(function ($, w, undefined) {
  if (w.footable === undefined || w.foobox === null)
    throw new Error(
      "Please check and make sure footable.js is included in the page and is loaded prior to this script."
    );

  var defaults = {
    striping: {
      enabled: true,
    },
    classes: {
      striping: {
        odd: "footable-odd",
        even: "footable-even",
      },
    },
  };

  function Striping() {
    var p = this;
    p.name = "Footable Striping";
    p.init = function (ft) {
      p.footable = ft;
      $(ft.table)
        .unbind("striping")
        .bind({
          "footable_initialized.striping footable_row_removed.striping footable_redrawn.striping footable_sorted.striping footable_filtered.striping":
            function () {
              if ($(this).data("striping") === false) return;

              p.setupStriping(ft);
            },
        });
    };

    p.setupStriping = function (ft) {
      var rowIndex = 0;
      $(ft.table)
        .find("> tbody > tr:not(.footable-row-detail)")
        .each(function () {
          var $row = $(this);

          //Clean off old classes
          $row
            .removeClass(ft.options.classes.striping.even)
            .removeClass(ft.options.classes.striping.odd);

          if (rowIndex % 2 === 0) {
            $row.addClass(ft.options.classes.striping.even);
          } else {
            $row.addClass(ft.options.classes.striping.odd);
          }

          rowIndex++;
        });
    };
  }

  w.footable.plugins.register(Striping, defaults);
})(jQuery, window);

(function ($, w, undefined) {
  if (w.footable === undefined || w.footable === null)
    throw new Error(
      "Please check and make sure footable.js is included in the page and is loaded prior to this script."
    );

  var defaults = {
    sort: true,
    sorters: {
      alpha: function (a, b) {
        if (typeof a === "string") {
          a = a.toLowerCase();
        }
        if (typeof b === "string") {
          b = b.toLowerCase();
        }
        if (a === b) return 0;
        if (a < b) return -1;
        return 1;
      },
      numeric: function (a, b) {
        return a - b;
      },
    },
    classes: {
      sort: {
        sortable: "footable-sortable",
        sorted: "footable-sorted",
        descending: "footable-sorted-desc",
        indicator: "footable-sort-indicator",
      },
    },
    events: {
      sort: {
        sorting: "footable_sorting",
        sorted: "footable_sorted",
      },
    },
  };

  function Sort() {
    var p = this;
    p.name = "Footable Sortable";
    p.init = function (ft) {
      p.footable = ft;
      if (ft.options.sort === true) {
        $(ft.table)
          .unbind(".sorting")
          .bind({
            "footable_initialized.sorting": function (e) {
              var $table = $(ft.table),
                $tbody = $table.find("> tbody"),
                cls = ft.options.classes.sort,
                column,
                $th;

              if ($table.data("sort") === false) return;

              $table
                .find(
                  "> thead > tr:last-child > th, > thead > tr:last-child > td"
                )
                .each(function (ec) {
                  var $th = $(this),
                    column = ft.columns[$th.index()];
                  if (
                    column.sort.ignore !== true &&
                    !$th.hasClass(cls.sortable)
                  ) {
                    $th.addClass(cls.sortable);
                    $("<span />").addClass(cls.indicator).appendTo($th);
                  }
                });

              $table
                .find(
                  "> thead > tr:last-child > th." +
                    cls.sortable +
                    ", > thead > tr:last-child > td." +
                    cls.sortable
                )
                .unbind("click.footable")
                .bind("click.footable", function (ec) {
                  ec.preventDefault();
                  $th = $(this);
                  var ascending = !$th.hasClass(cls.sorted);
                  p.doSort($th.index(), ascending);
                  return false;
                });

              var didSomeSorting = false;
              for (var c in ft.columns) {
                column = ft.columns[c];
                if (column.sort.initial) {
                  var ascending = column.sort.initial !== "descending";
                  p.doSort(column.index, ascending);
                  break;
                }
              }
              if (didSomeSorting) {
                ft.bindToggleSelectors();
              }
            },
            "footable_redrawn.sorting": function (e) {
              var $table = $(ft.table),
                cls = ft.options.classes.sort;
              if ($table.data("sorted") >= 0) {
                $table.find("> thead > tr:last-child > th").each(function (i) {
                  var $th = $(this);
                  if (
                    $th.hasClass(cls.sorted) ||
                    $th.hasClass(cls.descending)
                  ) {
                    p.doSort(i);
                    return;
                  }
                });
              }
            },
            "footable_column_data.sorting": function (e) {
              var $th = $(e.column.th);
              e.column.data.sort = e.column.data.sort || {};
              e.column.data.sort.initial = $th.data("sort-initial") || false;
              e.column.data.sort.ignore = $th.data("sort-ignore") || false;
              e.column.data.sort.selector = $th.data("sort-selector") || null;

              var match = $th.data("sort-match") || 0;
              if (match >= e.column.data.matches.length) match = 0;
              e.column.data.sort.match = e.column.data.matches[match];
            },
          })
          //save the sort object onto the table so we can access it later
          .data("footable-sort", p);
      }
    };

    p.doSort = function (columnIndex, ascending) {
      var ft = p.footable;
      if ($(ft.table).data("sort") === false) return;

      var $table = $(ft.table),
        $tbody = $table.find("> tbody"),
        column = ft.columns[columnIndex],
        $th = $table.find(
          "> thead > tr:last-child > th:eq(" + columnIndex + ")"
        ),
        cls = ft.options.classes.sort,
        evt = ft.options.events.sort;

      ascending =
        ascending === undefined
          ? $th.hasClass(cls.sorted)
          : ascending === "toggle"
          ? !$th.hasClass(cls.sorted)
          : ascending;

      if (column.sort.ignore === true) return true;

      //raise a pre-sorting event so that we can cancel the sorting if needed
      var event = ft.raise(evt.sorting, {
        column: column,
        direction: ascending ? "ASC" : "DESC",
      });
      if (event && event.result === false) return;

      $table.data("sorted", column.index);

      $table
        .find("> thead > tr:last-child > th, > thead > tr:last-child > td")
        .not($th)
        .removeClass(cls.sorted + " " + cls.descending);

      if (ascending === undefined) {
        ascending = $th.hasClass(cls.sorted);
      }

      if (ascending) {
        $th.removeClass(cls.descending).addClass(cls.sorted);
      } else {
        $th.removeClass(cls.sorted).addClass(cls.descending);
      }

      p.sort(ft, $tbody, column, ascending);

      ft.bindToggleSelectors();
      ft.raise(evt.sorted, {
        column: column,
        direction: ascending ? "ASC" : "DESC",
      });
    };

    p.rows = function (ft, tbody, column) {
      var rows = [];
      tbody
        .find("> tr")
        .each(function () {
          var $row = $(this),
            $next = null;
          if ($row.hasClass(ft.options.classes.detail)) return true;
          if ($row.next().hasClass(ft.options.classes.detail)) {
            $next = $row.next().get(0);
          }
          var row = { row: $row, detail: $next };
          if (column !== undefined) {
            row.value = ft.parse(this.cells[column.sort.match], column);
          }
          rows.push(row);
          return true;
        })
        .detach();
      return rows;
    };

    p.sort = function (ft, tbody, column, ascending) {
      var rows = p.rows(ft, tbody, column);
      var sorter = ft.options.sorters[column.type] || ft.options.sorters.alpha;
      rows.sort(function (a, b) {
        if (ascending) {
          return sorter(a.value, b.value);
        } else {
          return sorter(b.value, a.value);
        }
      });
      for (var j = 0; j < rows.length; j++) {
        tbody.append(rows[j].row);
        if (rows[j].detail !== null) {
          tbody.append(rows[j].detail);
        }
      }
    };
  }

  w.footable.plugins.register(Sort, defaults);
})(jQuery, window);

// (function ($, w, undefined) {
// 	if (w.footable === undefined || w.footable === null)
// 		throw new Error('Please check and make sure footable.js is included in the page and is loaded prior to this script.');

// 	var defaults = {
// 		paginate: true,
// 		pageSize: 10,
// 		pageNavigation: '.pagination',
// 		firstText: '&laquo;',
// 		previousText: '&lsaquo;',
// 		nextText: '&rsaquo;',
// 		lastText: '&raquo;',
// 		limitNavigation: 0,
// 		limitPreviousText: '...',
// 		limitNextText: '...'
// 	};

// 	function pageInfo(ft) {
// 		var $table = $(ft.table), data = $table.data();
// 		this.pageNavigation = data.pageNavigation || ft.options.pageNavigation;
// 		this.pageSize = data.pageSize || ft.options.pageSize;
// 		this.firstText = data.firstText || ft.options.firstText;
// 		this.previousText = data.previousText || ft.options.previousText;
// 		this.nextText = data.nextText || ft.options.nextText;
// 		this.lastText = data.lastText || ft.options.lastText;
// 		this.limitNavigation = parseInt(data.limitNavigation || ft.options.limitNavigation || defaults.limitNavigation, 10);
// 		this.limitPreviousText = data.limitPreviousText || ft.options.limitPreviousText;
// 		this.limitNextText = data.limitNextText || ft.options.limitNextText;
// 		this.limit = this.limitNavigation > 0;
// 		this.currentPage = data.currentPage || 0;
// 		this.pages = [];
// 		this.control = false;
// 	}

// 	function Paginate() {
// 		var p = this;
// 		p.name = 'Footable Paginate';

// 		p.init = function (ft) {
// 			if (ft.options.paginate === true) {
// 				if ($(ft.table).data('page') === false) return;
// 				p.footable = ft;
// 				$(ft.table)
// 					.unbind('.paging')
// 					.bind({
// 						'footable_initialized.paging footable_row_removed.paging footable_redrawn.paging footable_sorted.paging footable_filtered.paging': function () {
// 							p.setupPaging();
// 						}
// 					})
// 					//save the filter object onto the table so we can access it later
// 					.data('footable-paging', p);
// 			}
// 		};

// 		p.setupPaging = function () {
// 			var ft = p.footable,
// 				$tbody = $(ft.table).find('> tbody');

// 			ft.pageInfo = new pageInfo(ft);

// 			p.createPages(ft, $tbody);
// 			p.createNavigation(ft, $tbody);
// 			p.fillPage(ft, $tbody, ft.pageInfo.currentPage);
// 		};

// 		p.createPages = function (ft, tbody) {
// 			var pages = 1;
// 			var info = ft.pageInfo;
// 			var pageCount = pages * info.pageSize;
// 			var page = [];
// 			var lastPage = [];
// 			info.pages = [];
// 			var rows = tbody.find('> tr:not(.footable-filtered,.footable-row-detail)');
// 			rows.each(function (i, row) {
// 				page.push(row);
// 				if (i === pageCount - 1) {
// 					info.pages.push(page);
// 					pages++;
// 					pageCount = pages * info.pageSize;
// 					page = [];
// 				} else if (i >= rows.length - (rows.length % info.pageSize)) {
// 					lastPage.push(row);
// 				}
// 			});
// 			if (lastPage.length > 0) info.pages.push(lastPage);
// 			if (info.currentPage >= info.pages.length) info.currentPage = info.pages.length - 1;
// 			if (info.currentPage < 0) info.currentPage = 0;
// 			if (info.pages.length === 1) {
// 				//we only have a single page
// 				$(ft.table).addClass('no-paging');
// 			} else {
// 				$(ft.table).removeClass('no-paging');
// 			}
// 		};

// 		p.createNavigation = function (ft, tbody) {
// 			var $nav = $(ft.table).find(ft.pageInfo.pageNavigation);
// 			//if we cannot find the navigation control within the table, then try find it outside
// 			if ($nav.length === 0) {
// 				$nav = $(ft.pageInfo.pageNavigation);
// 				//if the navigation control is inside another table, then get out
// 				if ($nav.parents('table:first').length > 0 && $nav.parents('table:first') !== $(ft.table)) return;
// 				//if we found more than one navigation control, write error to console
// 				if ($nav.length > 1 && ft.options.debug === true) console.error('More than one pagination control was found!');
// 			}
// 			//if we still cannot find the control, then don't do anything
// 			if ($nav.length === 0) return;
// 			//if the nav is not a UL, then find or create a UL
// 			if (!$nav.is('ul')) {
// 				if ($nav.find('ul:first').length === 0) {
// 					$nav.append('<ul />');
// 				}
// 				$nav = $nav.find('ul');
// 			}
// 			$nav.find('li').remove();
// 			var info = ft.pageInfo;
// 			info.control = $nav;
// 			if (info.pages.length > 0) {
// 				$nav.append('<li class="footable-page-arrow"><a data-page="first" href="#first">' + ft.pageInfo.firstText + '</a>');
// 				$nav.append('<li class="footable-page-arrow"><a data-page="prev" href="#prev">' + ft.pageInfo.previousText + '</a></li>');
// 				if (info.limit){
// 					$nav.append('<li class="footable-page-arrow"><a data-page="limit-prev" href="#limit-prev">' + ft.pageInfo.limitPreviousText + '</a></li>');
// 				}
// 				if (!info.limit){
// 					$.each(info.pages, function (i, page) {
// 						if (page.length > 0) {
// 							$nav.append('<li class="footable-page"><a data-page="' + i + '" href="#">' + (i + 1) + '</a></li>');
// 						}
// 					});
// 				}
// 				if (info.limit){
// 					$nav.append('<li class="footable-page-arrow"><a data-page="limit-next" href="#limit-next">' + ft.pageInfo.limitNextText + '</a></li>');
// 					p.createLimited($nav, info, 0);
// 				}
// 				$nav.append('<li class="footable-page-arrow"><a data-page="next" href="#next">' + ft.pageInfo.nextText + '</a></li>');
// 				$nav.append('<li class="footable-page-arrow"><a data-page="last" href="#last">' + ft.pageInfo.lastText + '</a></li>');
// 			}
// 			$nav.off('click', 'a[data-page]').on('click', 'a[data-page]', function (e) {
// 				e.preventDefault();
// 				var page = $(this).data('page');
// 				var newPage = info.currentPage;
// 				if (page === 'first') {
// 					newPage = 0;
// 				} else if (page === 'prev') {
// 					if (newPage > 0) newPage--;
// 				} else if (page === 'next') {
// 					if (newPage < info.pages.length - 1) newPage++;
// 				} else if (page === 'last') {
// 					newPage = info.pages.length - 1;
// 				} else if (page === 'limit-prev') {
// 					newPage = -1;
// 					var first = $nav.find('.footable-page:first a').data('page');
// 					p.createLimited($nav, info, first - info.limitNavigation);
// 					p.setPagingClasses($nav, info.currentPage, info.pages.length);
// 				} else if (page === 'limit-next') {
// 					newPage = -1;
// 					var last = $nav.find('.footable-page:last a').data('page');
// 					p.createLimited($nav, info, last + 1);
// 					p.setPagingClasses($nav, info.currentPage, info.pages.length);
// 				} else {
// 					newPage = page;
// 				}
// 				if (newPage >= 0){
// 					if (info.limit && info.currentPage != newPage){
// 						var start = newPage;
// 						while (start % info.limitNavigation !== 0){ start -= 1; }
// 						p.createLimited($nav, info, start);
// 					}
// 					p.paginate(ft, newPage);
// 				}
// 			});
// 			p.setPagingClasses($nav, info.currentPage, info.pages.length);
// 		};

// 		p.createLimited = function(nav, info, start){
// 			start = start || 0;
// 			nav.find('li.footable-page').remove();
// 			var i, page,
// 				$prev = nav.find('li.footable-page-arrow > a[data-page="limit-prev"]').parent(),
// 				$next = nav.find('li.footable-page-arrow > a[data-page="limit-next"]').parent();
// 			for (i = info.pages.length - 1; i >=0 ; i--){
// 				page = info.pages[i];
// 				if (i >= start && i < start + info.limitNavigation && page.length > 0) {
// 					$prev.after('<li class="footable-page"><a data-page="' + i + '" href="#">' + (i + 1) + '</a></li>');
// 				}
// 			}
// 			if (start === 0){ $prev.hide(); }
// 			else { $prev.show(); }
// 			if (start + info.limitNavigation >= info.pages.length){ $next.hide(); }
// 			else { $next.show(); }
// 		};

// 		p.paginate = function (ft, newPage) {
// 			var info = ft.pageInfo;
// 			if (info.currentPage !== newPage) {
// 				var $tbody = $(ft.table).find('> tbody');

// 				//raise a pre-pagin event so that we can cancel the paging if needed
// 				var event = ft.raise('footable_paging', { page: newPage, size: info.pageSize });
// 				if (event && event.result === false) return;

// 				p.fillPage(ft, $tbody, newPage);
// 				info.control.find('li').removeClass('active disabled');
// 				p.setPagingClasses(info.control, info.currentPage, info.pages.length);
// 			}
// 		};

// 		p.setPagingClasses = function (nav, currentPage, pageCount) {
// 			nav.find('li.footable-page > a[data-page=' + currentPage + ']').parent().addClass('active');
// 			if (currentPage >= pageCount - 1) {
// 				nav.find('li.footable-page-arrow > a[data-page="next"]').parent().addClass('disabled');
// 				nav.find('li.footable-page-arrow > a[data-page="last"]').parent().addClass('disabled');
// 			}
// 			if (currentPage < 1) {
// 				nav.find('li.footable-page-arrow > a[data-page="first"]').parent().addClass('disabled');
// 				nav.find('li.footable-page-arrow > a[data-page="prev"]').parent().addClass('disabled');
// 			}
// 		};

// 		p.fillPage = function (ft, tbody, pageNumber) {
// 			ft.pageInfo.currentPage = pageNumber;
// 			$(ft.table).data('currentPage', pageNumber);
// 			tbody.find('> tr').hide();
// 			$(ft.pageInfo.pages[pageNumber]).each(function () {
// 				p.showRow(this, ft);
// 			});
// 			ft.raise('footable_page_filled');
// 		};

// 		p.showRow = function (row, ft) {
// 			var $row = $(row), $next = $row.next(), $table = $(ft.table);
// 			if ($table.hasClass('breakpoint') && $row.hasClass('footable-detail-show') && $next.hasClass('footable-row-detail')) {
// 				$row.add($next).show();
// 				ft.createOrUpdateDetailRow(row);
// 			}
// 			else $row.show();
// 		};
// 	}

// 	w.footable.plugins.register(Paginate, defaults);

// })(jQuery, window);

/**
 * Footable Memory
 *
 * Version 1.1.0
 *
 * Requires browser support for localStorage. Fallback to cookies using
 * jQuery Cookie (https://github.com/carhartl/jquery-cookie)
 *
 * Stores table state in a cookie and reloads state when page is refreshed.
 *
 * Supports common FooTable features:
 * - Pagination
 * - Sorting
 * - Filtering
 * - Expansion
 *
 * Written to be compatible with multiple FooTables per page and with
 * JavaScript libraries like AngularJS and Ember that use hash based URLs.
 *
 * Disabled by default, to enable add the following section to the footable
 * options:
 *
 *   $('#table').footable({
 *     memory: {
 *       enabled: true
 *     }
 *   });
 *
 * Based on FooTable Plugin Bookmarkable by Amy Farrell (https://github.com/akf)
 *
 * Created by Chris Laskey (https://github.com/chrislaskey)
 */

(function ($, w, undefined) {
  if (w.footable === undefined || w.foobox === null) {
    throw new Error(
      "Please check and make sure footable.js is included in the page and is loaded prior to this script."
    );
  }

  var defaults = {
    memory: {
      enabled: false,
    },
  };

  var storage;

  var storage_engines = {};

  storage_engines.local_storage = (function ($) {
    "use strict";

    var path_page = function () {
      return location.pathname;
    };

    var path_subpage = function () {
      return location.hash || "root";
    };

    var storage_key = function (index) {
      return path_page() + "/" + path_subpage() + "/index-" + index;
    };

    var get = function (index) {
      var key = storage_key(index),
        as_string = localStorage.getItem(key);

      return as_string ? JSON.parse(as_string) : {};
    };

    var set = function (index, item) {
      var key = storage_key(index),
        as_string = JSON.stringify(item);

      localStorage.setItem(key, as_string);
    };

    return {
      get: function (index) {
        return get(index);
      },
      set: function (index, item) {
        set(index, item);
      },
    };
  })($);

  storage_engines.cookie = (function ($) {
    "use strict";

    /**
     * Stores footable bookmarkable data in a cookie
     *
     * By default will store each page in its own cookie.
     * Supports multiple FooTables per page.
     * Supports JS frameworks that use hashmap URLs (AngularJS, Ember, etc).
     *
     * For example take an example application:
     *
     *     http://example.com/application-data (2 FooTables on this page)
     *     http://example.com/application-data/#/details (1 FooTable on this page)
     *     http://example.com/other-data (1 FooTable on this page)
     *
     * Would be stored like this:
     *
     *     cookie['/application-data'] = {
     *         '/': {
     *             1: {
     *                 key1: value1,
     *                 key2: value2
     *             },
     *             2: {
     *                 key1: value1,
     *                 key2: value2
     *             }
     *         },
     *         '#/details': {
     *             1: {
     *                 key1: value1,
     *                 key2: value2
     *             }
     *         }
     *     };
     *
     *     cookie['/other-data'] = {
     *         '/': {
     *             1: {
     *                 key1: value1,
     *                 key2: value2
     *             },
     *         }
     *     }
     *
     */

    if ($.cookie) {
      $.cookie.json = true;
    }

    var days_to_keep_data = 7;

    var path_page = function () {
      return location.pathname;
    };

    var path_subpage = function () {
      return location.hash || "/";
    };

    var get_data = function () {
      var page = path_page(),
        data = $.cookie(page);

      return data || {};
    };

    var get_table = function (index) {
      var subpage = path_subpage(),
        data = get_data();

      if (data[subpage] && data[subpage][index]) {
        return data[subpage][index];
      } else {
        return {};
      }
    };

    var set = function (index, item) {
      var page = path_page(),
        subpage = path_subpage(),
        data = get_data(),
        options;

      if (!data[subpage]) {
        data[subpage] = {};
      }

      data[subpage][index] = item;

      options = {
        path: page,
        expires: days_to_keep_data,
      };

      $.cookie(page, data, options);
    };

    return {
      get: function (index) {
        return get_table(index);
      },
      set: function (index, item) {
        set(index, item);
      },
    };
  })($);

  var set_storage_engine = (function () {
    var test = "footable-memory-plugin-storage-test";

    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      storage = storage_engines.local_storage;
    } catch (e) {
      try {
        $.cookie(test, test);
        storage = storage_engines.cookie;
      } catch (e) {
        throw new Error(
          "FooTable Memory requires either localStorage or cookie support via jQuery $.cookie plugin (https://github.com/carhartl/jquery-cookie)"
        );
      }
    }
  })($);

  var state = (function ($) {
    "use strict";

    /**
     * Gets and sets current table state
     */

    var vars = {};

    var get = {};

    var set = {};

    set.vars = function (ft) {
      vars.ft = ft;
      vars.table = $(ft.table);
    };

    get.descending = function () {
      var descending = false;
      $.each(vars.table.find("th"), function (index) {
        if ($(this).hasClass("footable-sorted-desc")) {
          descending = true;
        }
      });
      return descending;
    };

    get.expanded = function () {
      var indexes = [];
      $.each(vars.ft.table.rows, function (index, value) {
        if ($(this).hasClass("footable-detail-show")) {
          indexes.push(index);
        }
      });
      return indexes;
    };

    set.expanded = function (data) {
      if (data.expanded) {
        $.each(data.expanded, function (index, value) {
          // var row = $(vars.ft.table.rows[value]);
          // row.find('> td:first').trigger('footable_toggle_row');

          // Trying to execute the lines above, but the expanded row
          // shows raw AngularJS template (with {{ values }}) instead
          // of the fully rendered result.
          //
          // Best guess is some things happen after
          // 'footable_initialized' event and row expanding can not
          // occur until after those fire.
          //
          // A hack to get around this is to wait an interval before
          // executing the intended commands. Wrapped in an
          // immediately executing function to ensure ft is the
          // current value.

          (function (ft) {
            setTimeout(function () {
              var row = $(ft.table.rows[value]);
              row.find("> td:first").trigger("footable_toggle_row");
            }, 150);
          })(vars.ft);
        });
      }
    };

    get.filter = function () {
      return vars.table.data("filter")
        ? $(vars.table.data("filter")).val()
        : "";
    };

    set.filter = function (data) {
      if (data.filter) {
        $(vars.table.data("filter")).val(data.filter).trigger("keyup");
      }
    };

    get.page = function () {
      return vars.ft.pageInfo && vars.ft.pageInfo.currentPage !== undefined
        ? vars.ft.pageInfo.currentPage
        : 0;
    };

    set.page = function (data) {
      if (data.page) {
        vars.table.data("currentPage", data.page);
        // Delay triggering table until sort is updated, since both effect
        // pagination.
      }
    };

    get.shown = function () {
      return vars.table
        .find("tbody")
        .find("tr:not(.footable-row-detail)")
        .filter(":visible").length;
    };

    get.sorted = function () {
      if (vars.table.data("sorted") !== undefined) {
        return vars.table.data("sorted");
      } else {
        return -1;
      }
    };

    set.sorted = function (data) {
      if (data.sorted >= 0) {
        // vars.table.data('footable-sort').doSort(data.sorted, !data.descending);

        // Trying to execute the line above, but only sort icon on the
        // <th> element gets set. The rows themselves do not get sorted.
        //
        // Best guess is some things happen after 'footable_initialized' event
        // and sorting can not occur until after those fire.
        //
        // A hack to get around this is to wait an interval before executing
        // the intended commands. Wrapped in an immediately executing
        // function to ensure ft is the current value.

        (function (ft) {
          setTimeout(function () {
            $(ft.table)
              .data("footable-sort")
              .doSort(data.sorted, !data.descending);
          }, 150);
        })(vars.ft);
      } else {
        vars.table.trigger("footable_setup_paging");
      }
    };

    get.total = function () {
      return vars.table
        .find("tbody")
        .find("tr:not(.footable-row-detail, .footable-filtered)").length;
    };

    var get_state = function () {
      return {
        descending: get.descending(),
        expanded: get.expanded(),
        filter: get.filter(),
        page: get.page(),
        shown: get.shown(),
        sorted: get.sorted(),
        total: get.total(),
      };
    };

    var set_state = function (data) {
      set.filter(data);
      set.page(data);
      set.sorted(data);
      set.expanded(data);
    };

    return {
      get: function (ft) {
        set.vars(ft);
        return get_state();
      },
      set: function (ft, data) {
        set.vars(ft);
        return set_state(data);
      },
    };
  })($);

  var is_enabled = function (ft) {
    return ft.options.memory.enabled;
  };

  var update = function (ft, event) {
    var index = ft.id,
      data = state.get(ft);

    storage.set(index, data);
  };

  var load = function (ft) {
    var index = ft.id,
      data = storage.get(index);

    state.set(ft, data);
    ft.memory_plugin_loaded = true;
  };

  function Memory() {
    var p = this;
    p.name = "Footable Memory";
    p.init = function (ft) {
      if (is_enabled(ft)) {
        $(ft.table).bind({
          footable_initialized: function () {
            load(ft);
          },
          "footable_page_filled footable_redrawn footable_filtered footable_sorted footable_row_expanded footable_row_collapsed":
            function (e) {
              if (ft.memory_plugin_loaded) {
                update(ft, e);
              }
            },
        });
      }
    };
  }

  w.footable.plugins.register(Memory, defaults);
})(jQuery, window);

(function ($, w, undefined) {
  if (w.footable === undefined || w.foobox === null)
    throw new Error(
      "Please check and make sure footable.js is included in the page and is loaded prior to this script."
    );
  var defaults = {
    grid: {
      enabled: true,
      data: null,
      template: null, //row html template, use for make a row.
      cols: null, //column define
      items: null, //data items
      url: null, //get data from url
      ajax: null, //paramater for $.ajax
      activeClass: "active", //add to row selected
      multiSelect: false, //allow select multiple row
      showIndex: false, //show row index
      showCheckbox: false, //show checkbox for select
      showEmptyInfo: false, //when that is not data in table, show a info to notify user
      emptyInfo: '<p class="text-center text-warning">No Data</p>',
      pagination: {
        "page-size": 20,
        "pagination-class": "pagination pagination-centered",
      },
      indexFormatter: function (val, $td, index) {
        return index + 1;
      },
      checkboxFormatter: function (isTop) {
        return (
          '<input type="checkbox" class="' +
          (isTop ? "checkAll" : "check") +
          '">'
        );
      },
      events: {
        loaded: "footable_grid_loaded",
        created: "footable_grid_created",
        removed: "footable_grid_removed",
        updated: "footable_grid_updated",
      },
    },
  };

  function makeTh(col) {
    var $th = $("<th>" + col.title + "</th>");
    if ($.isPlainObject(col.data)) {
      $th.data(col.data);
    }
    if ($.isPlainObject(col.style)) {
      $th.css(col.style);
    }
    if (col.className) {
      $th.addClass(col.className);
    }
    return $th;
  }

  function initThead($table, options) {
    var $thead = $table.find("thead");
    if ($thead.size() === 0) {
      $thead = $("<thead>").appendTo($table);
    }
    var $row = $("<tr>").appendTo($thead);
    for (var i = 0, len = options.cols.length; i < len; i++) {
      $row.append(makeTh(options.cols[i]));
    }
  }

  function initTBody($table) {
    var $tbody = $table.find("tbody");
    if ($tbody.size() === 0) {
      $tbody = $("<tbody>").appendTo($table);
    }
  }

  function initPagination($table, cols, options) {
    if (options) {
      $table.attr("data-page-size", options["page-size"]);
      var $tfoot = $table.find("tfoot");
      if ($tfoot.size() === 0) {
        $tfoot = $('<tfoot class="hide-if-no-paging"></tfoot>').appendTo(
          $table
        );
      }
      $tfoot.append("<tr><td colspan=" + cols.length + "></td></tr>");
      var $pagination = $("<div>").appendTo($tfoot.find("tr:last-child td"));
      $pagination.addClass(options["pagination-class"]);
    }
  }

  function setToggleColumn(cols) {
    var toggleColumn = cols[0];
    for (var i = 0, len = cols.length; i < len; i++) {
      var col = cols[i];
      if (
        col.data &&
        (col.data.toggle === true || col.data.toggle === "true")
      ) {
        return;
      }
    }
    toggleColumn.data = $.extend(toggleColumn.data, {
      toggle: true,
    });
  }

  function makeEmptyInfo($table, cols, emptyInfo) {
    if ($table.find("tr.emptyInfo").size() === 0) {
      $table
        .find("tbody")
        .append(
          '<tr class="emptyInfo"><td colspan="' +
            cols.length +
            '">' +
            emptyInfo +
            "</td></tr>"
        );
    }
  }

  function updateRowIndex($tbody, $newRow, detailClass, offset) {
    //update rows index
    $tbody.find("tr:not(." + detailClass + ")").each(function () {
      var $row = $(this),
        index = $newRow.data("index"),
        oldIndex = parseInt($row.data("index"), 0),
        newIndex = oldIndex + offset;
      if (oldIndex >= index && this !== $newRow.get(0)) {
        $row.attr("data-index", newIndex).data("index", newIndex);
      }
    });
  }

  function Grid() {
    var grid = this;
    grid.name = "Footable Grid";
    grid.init = function (ft) {
      var toggleClass = ft.options.classes.toggle;
      var detailClass = ft.options.classes.detail;
      var options = ft.options.grid;
      if (!options.cols) return;
      grid.footable = ft;
      var $table = $(ft.table);
      $table.data("grid", grid);
      if ($.isPlainObject(options.data)) {
        $table.data(options.data);
      }
      grid._items = [];
      setToggleColumn(options.cols);
      if (options.showCheckbox) {
        options.multiSelect = true;
        options.cols.unshift({
          title: options.checkboxFormatter(true),
          name: "",
          data: {
            "sort-ignore": true,
          },
          formatter: options.checkboxFormatter,
        });
      }
      if (options.showIndex) {
        options.cols.unshift({
          title: "#",
          name: "index",
          data: {
            "sort-ignore": true,
          },
          formatter: options.indexFormatter,
        });
      }
      initThead($table, options);
      initTBody($table);
      initPagination($table, options.cols, options.pagination);
      $table
        .off(".grid")
        .on({
          "footable_initialized.grid": function (e) {
            if (options.url || options.ajax) {
              $.ajax(
                options.ajax || {
                  url: options.url,
                }
              ).then(
                function (resp) {
                  grid.newItem(resp);
                  ft.raise(options.events.loaded);
                },
                function (jqXHR) {
                  throw (
                    "load data from " +
                    (options.url || options.ajax.url) +
                    " fail"
                  );
                }
              );
            } else {
              grid.newItem(options.items || []);
              ft.raise(options.events.loaded);
            }
          },
          "footable_sorted.grid footable_grid_created.grid footable_grid_removed.grid":
            function (event) {
              if (options.showIndex && grid.getItem().length > 0) {
                $table
                  .find("tbody tr:not(." + detailClass + ")")
                  .each(function (index) {
                    var $td = $(this).find("td:first");
                    $td.html(options.indexFormatter(null, $td, index));
                  });
              }
            },
          "footable_redrawn.grid footable_row_removed.grid": function (event) {
            if (grid.getItem().length === 0 && options.showEmptyInfo) {
              makeEmptyInfo($table, options.cols, options.emptyInfo);
            }
          },
        })
        .on(
          {
            "click.grid": function (event) {
              if (
                $(event.target)
                  .closest("td")
                  .find(">." + toggleClass)
                  .size() > 0
              ) {
                return true;
              }
              var $tr = $(event.currentTarget);
              if ($tr.hasClass(detailClass)) {
                return true;
              }
              if (!options.multiSelect && !$tr.hasClass(options.activeClass)) {
                $table
                  .find("tbody tr." + options.activeClass)
                  .removeClass(options.activeClass);
              }
              $tr.toggleClass(options.activeClass);
              if (options.showCheckbox) {
                $tr
                  .find("input:checkbox.check")
                  .prop("checked", function (index, val) {
                    if (event.target === this) {
                      return val;
                    }
                    return !val;
                  });
              }
              ft.toggleDetail($tr);
            },
          },
          "tbody tr"
        )
        .on("click.grid", "thead input:checkbox.checkAll", function (event) {
          var checked = !!event.currentTarget.checked;
          if (checked) {
            $table.find("tbody tr").addClass(options.activeClass);
          } else {
            $table.find("tbody tr").removeClass(options.activeClass);
          }
          $table.find("tbody input:checkbox.check").prop("checked", checked);
        });
    };
    /**
     * get selected rows index;
     */
    grid.getSelected = function () {
      var options = grid.footable.options.grid,
        $selected = $(grid.footable.table).find(
          "tbody>tr." + options.activeClass
        );
      return $selected.map(function () {
        return $(this).data("index");
      });
    };
    /**
     * get row's data by index
     */
    grid.getItem = function (index) {
      if (index !== undefined) {
        if ($.isArray(index)) {
          return $.map(index, function (item) {
            return grid._items[item];
          });
        }
        return grid._items[index];
      }
      return grid._items;
    };

    function makeCell(col, value, index) {
      var $td = $("<td>");
      if (col.formatter) {
        $td.html(col.formatter(value, $td, index));
      } else {
        $td.html(value || "");
      }
      return $td;
    }
    grid._makeRow = function (item, index) {
      var options = grid.footable.options.grid;
      var $row;
      if ($.isFunction(options.template)) {
        $row = $(
          options.template(
            $.extend(
              {},
              {
                __index: index,
              },
              item
            )
          )
        );
      } else {
        $row = $("<tr>");
        for (var i = 0, len = options.cols.length; i < len; i++) {
          var col = options.cols[i];
          $row.append(makeCell(col, item[col.name] || "", index));
        }
      }
      $row.attr("data-index", index);
      return $row;
    };
    /**
     * create rows by js object
     */
    grid.newItem = function (item, index, wait) {
      var $tbody = $(grid.footable.table).find("tbody");
      var detailClass = grid.footable.options.classes.detail;
      $tbody.find("tr.emptyInfo").remove();
      if ($.isArray(item)) {
        for (var atom; (atom = item.pop()); ) {
          grid.newItem(atom, index, true);
        }
        grid.footable.redraw();
        grid.footable.raise(grid.footable.options.grid.events.created, {
          item: item,
          index: index,
        });
        return;
      }
      if (!$.isPlainObject(item)) {
        return;
      }
      var $tr,
        len = grid._items.length;
      if (index === undefined || index < 0 || index > len) {
        $tr = grid._makeRow(item, len++);
        grid._items.push(item);
        $tbody.append($tr);
      } else {
        $tr = grid._makeRow(item, index);
        if (index === 0) {
          grid._items.unshift(item);
          $tbody.prepend($tr);
        } else {
          var $before = $tbody.find("tr[data-index=" + (index - 1) + "]");
          grid._items.splice(index, 0, item);
          if ($before.data("detail_created") === true) {
            $before = $before.next();
          }
          $before.after($tr);
        }
        updateRowIndex($tbody, $tr, detailClass, 1);
      }
      if (!wait) {
        grid.footable.redraw();
        grid.footable.raise(grid.footable.options.grid.events.created, {
          item: item,
          index: index,
        });
      }
    };
    /**
     * update row by js object
     */
    grid.setItem = function (item, index) {
      if (!$.isPlainObject(item)) {
        return;
      }
      var $tbody = $(grid.footable.table).find("tbody"),
        $newTr = grid._makeRow(item, index);
      $.extend(grid._items[index], item);
      var $tr = $tbody.find("tr").eq(index);
      $tr.html($newTr.html());
      grid.footable.redraw();
      grid.footable.raise(grid.footable.options.grid.events.updated, {
        item: item,
        index: index,
      });
    };
    /**
     * remove rows by index
     */
    grid.removeItem = function (index) {
      var $tbody = $(grid.footable.table).find("tbody");
      var detailClass = grid.footable.options.classes.detail;
      var result = [];
      if ($.isArray(index)) {
        for (var i; (i = index.pop()); ) {
          result.push(grid.removeItem(i));
        }
        grid.footable.raise(grid.footable.options.grid.events.removed, {
          item: result,
          index: index,
        });
        return result;
      }
      if (index === undefined) {
        $tbody.find("tr").each(function () {
          result.push(grid._items.shift());
          grid.footable.removeRow(this);
        });
      } else {
        var $tr = $tbody.find("tr[data-index=" + index + "]");
        result = grid._items.splice(index, 1)[0];
        grid.footable.removeRow($tr);
        //update rows index
        updateRowIndex($tbody, $tr, detailClass, -1);
      }
      grid.footable.raise(grid.footable.options.grid.events.removed, {
        item: result,
        index: index,
      });
      return result;
    };
  }
  w.footable.plugins.register(Grid, defaults);
})(jQuery, window);

(function ($, w, undefined) {
  if (w.footable === undefined || w.footable === null)
    throw new Error(
      "Please check and make sure footable.js is included in the page and is loaded prior to this script."
    );

  var defaults = {
    filter: {
      enabled: true,
      input: ".footable-filter",
      timeout: 300,
      minimum: 2,
      disableEnter: false,
      filterFunction: function (index) {
        var $t = $(this),
          $table = $t.parents("table:first"),
          filter = $table.data("current-filter").toUpperCase(),
          text = $t.find("td").text();
        if (!$table.data("filter-text-only")) {
          $t.find("td[data-value]").each(function () {
            text += $(this).data("value");
          });
        }
        return text.toUpperCase().indexOf(filter) >= 0;
      },
    },
  };

  function Filter() {
    var p = this;
    p.name = "Footable Filter";
    p.init = function (ft) {
      p.footable = ft;
      if (ft.options.filter.enabled === true) {
        if ($(ft.table).data("filter") === false) return;
        ft.timers.register("filter");
        $(ft.table)
          .unbind(".filtering")
          .bind({
            "footable_initialized.filtering": function (e) {
              var $table = $(ft.table);
              var data = {
                input: $table.data("filter") || ft.options.filter.input,
                timeout:
                  $table.data("filter-timeout") || ft.options.filter.timeout,
                minimum:
                  $table.data("filter-minimum") || ft.options.filter.minimum,
                disableEnter:
                  $table.data("filter-disable-enter") ||
                  ft.options.filter.disableEnter,
              };
              if (data.disableEnter) {
                $(data.input).keypress(function (event) {
                  if (window.event) return window.event.keyCode !== 13;
                  else return event.which !== 13;
                });
              }
              $table.bind("footable_clear_filter", function () {
                $(data.input).val("");
                p.clearFilter();
              });
              $table.bind("footable_filter", function (event, args) {
                p.filter(args.filter);
              });
              $(data.input).keyup(function (eve) {
                ft.timers.filter.stop();
                if (eve.which === 27) {
                  $(data.input).val("");
                }
                ft.timers.filter.start(function () {
                  var val = $(data.input).val() || "";
                  p.filter(val);
                }, data.timeout);
              });
            },
            "footable_redrawn.filtering": function (e) {
              var $table = $(ft.table),
                filter = $table.data("filter-string");
              if (filter) {
                p.filter(filter);
              }
            },
          })
          //save the filter object onto the table so we can access it later
          .data("footable-filter", p);
      }
    };

    p.filter = function (filterString) {
      var ft = p.footable,
        $table = $(ft.table),
        minimum = $table.data("filter-minimum") || ft.options.filter.minimum,
        clear = !filterString;

      //raise a pre-filter event so that we can cancel the filtering if needed
      var event = ft.raise("footable_filtering", {
        filter: filterString,
        clear: clear,
      });
      if (event && event.result === false) return;
      if (event.filter && event.filter.length < minimum) {
        return; //if we do not have the minimum chars then do nothing
      }

      if (event.clear) {
        p.clearFilter();
      } else {
        var filters = event.filter.split(" ");

        $table.find("> tbody > tr").hide().addClass("footable-filtered");
        var rows = $table.find("> tbody > tr:not(.footable-row-detail)");
        $.each(filters, function (i, f) {
          if (f && f.length > 0) {
            $table.data("current-filter", f);
            rows = rows.filter(ft.options.filter.filterFunction);
          }
        });
        rows.each(function () {
          p.showRow(this, ft);
          $(this).removeClass("footable-filtered");
        });
        $table.data("filter-string", event.filter);
        ft.raise("footable_filtered", { filter: event.filter, clear: false });
      }
    };

    p.clearFilter = function () {
      var ft = p.footable,
        $table = $(ft.table);

      $table
        .find("> tbody > tr:not(.footable-row-detail)")
        .removeClass("footable-filtered")
        .each(function () {
          p.showRow(this, ft);
        });
      $table.removeData("filter-string");
      ft.raise("footable_filtered", { clear: true });
    };

    p.showRow = function (row, ft) {
      var $row = $(row),
        $next = $row.next(),
        $table = $(ft.table);
      if ($row.is(":visible")) return; //already visible - do nothing
      if (
        $table.hasClass("breakpoint") &&
        $row.hasClass("footable-detail-show") &&
        $next.hasClass("footable-row-detail")
      ) {
        $row.add($next).show();
        ft.createOrUpdateDetailRow(row);
      } else $row.show();
    };
  }

  w.footable.plugins.register(Filter, defaults);
})(jQuery, window);

/* xls.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* xls.js (C) 2013-present SheetJS -- http://sheetjs.com */
var XLS = {};
(function make_xls(XLS) {
  XLS.version = "0.7.6";
  var current_codepage = 1200,
    current_cptable;
  if (typeof module !== "undefined" && typeof require !== "undefined") {
    if (typeof cptable === "undefined") cptable = require("./dist/cpexcel");
    current_cptable = cptable[current_codepage];
  }
  function reset_cp() {
    set_cp(1200);
  }
  var set_cp = function (cp) {
    current_codepage = cp;
  };
  function char_codes(data) {
    var o = [];
    for (var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i);
    return o;
  }
  var debom = function (data) {
    var c1 = data.charCodeAt(0),
      c2 = data.charCodeAt(1);
    if (c1 == 255 && c2 == 254) return data.substr(2);
    if (c1 == 254 && c2 == 255) return data.substr(2);
    if (c1 == 65279) return data.substr(1);
    return data;
  };
  var _getchar = function _gc1(x) {
    return String.fromCharCode(x);
  };
  if (typeof cptable !== "undefined") {
    set_cp = function (cp) {
      current_codepage = cp;
      current_cptable = cptable[cp];
    };
    debom = function (data) {
      if (data.charCodeAt(0) === 255 && data.charCodeAt(1) === 254) {
        return cptable.utils.decode(1200, char_codes(data.substr(2)));
      }
      return data;
    };
    _getchar = function _gc2(x) {
      if (current_codepage === 1200) return String.fromCharCode(x);
      return cptable.utils.decode(current_codepage, [x & 255, x >> 8])[0];
    };
  }
  var Base64 = (function make_b64() {
    var map =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    return {
      decode: function b64_decode(input, utf8) {
        var o = "";
        var c1, c2, c3;
        var e1, e2, e3, e4;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        for (var i = 0; i < input.length; ) {
          e1 = map.indexOf(input.charAt(i++));
          e2 = map.indexOf(input.charAt(i++));
          e3 = map.indexOf(input.charAt(i++));
          e4 = map.indexOf(input.charAt(i++));
          c1 = (e1 << 2) | (e2 >> 4);
          c2 = ((e2 & 15) << 4) | (e3 >> 2);
          c3 = ((e3 & 3) << 6) | e4;
          o += String.fromCharCode(c1);
          if (e3 != 64) {
            o += String.fromCharCode(c2);
          }
          if (e4 != 64) {
            o += String.fromCharCode(c3);
          }
        }
        return o;
      },
    };
  })();
  var has_buf = typeof Buffer !== "undefined";
  function new_raw_buf(len) {
    return new (has_buf ? Buffer : Array)(len);
  }
  function s2a(s) {
    if (has_buf) return new Buffer(s, "binary");
    return s.split("").map(function (x) {
      return x.charCodeAt(0) & 255;
    });
  }
  var bconcat = function (bufs) {
    return [].concat.apply([], bufs);
  };
  var chr0 = /\u0000/g,
    chr1 = /[\u0001-\u0006]/;
  function read_double_le(b, idx) {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 127) << 4) + ((b[idx + 6] >>> 4) & 15);
    var m = b[idx + 6] & 15;
    for (var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
    if (e == 2047) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
      e -= 1023;
      m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
  }
  var __toBuffer, ___toBuffer;
  __toBuffer = ___toBuffer = function toBuffer_(bufs) {
    var x = [];
    for (var i = 0; i < bufs[0].length; ++i) {
      x.push.apply(x, bufs[0][i]);
    }
    return x;
  };
  var __utf16le, ___utf16le;
  __utf16le = ___utf16le = function utf16le_(b, s, e) {
    var ss = [];
    for (var i = s; i < e; i += 2)
      ss.push(String.fromCharCode(__readUInt16LE(b, i)));
    return ss.join("");
  };
  var __hexlify, ___hexlify;
  __hexlify = ___hexlify = function hexlify_(b, s, l) {
    return b
      .slice(s, s + l)
      .map(function (x) {
        return (x < 16 ? "0" : "") + x.toString(16);
      })
      .join("");
  };
  var __utf8, ___utf8;
  __utf8 = ___utf8 = function (b, s, e) {
    var ss = [];
    for (var i = s; i < e; i++) ss.push(String.fromCharCode(__readUInt8(b, i)));
    return ss.join("");
  };
  var __lpstr, ___lpstr;
  __lpstr = ___lpstr = function lpstr_(b, i) {
    var len = __readUInt32LE(b, i);
    return len > 0 ? __utf8(b, i + 4, i + 4 + len - 1) : "";
  };
  var __lpwstr, ___lpwstr;
  __lpwstr = ___lpwstr = function lpwstr_(b, i) {
    var len = 2 * __readUInt32LE(b, i);
    return len > 0 ? __utf8(b, i + 4, i + 4 + len - 1) : "";
  };
  var __double, ___double;
  __double = ___double = function (b, idx) {
    return read_double_le(b, idx);
  };
  if (typeof Buffer !== "undefined") {
    __utf16le = function utf16le_b(b, s, e) {
      if (!Buffer.isBuffer(b)) return ___utf16le(b, s, e);
      return b.toString("utf16le", s, e);
    };
    __hexlify = function (b, s, l) {
      return Buffer.isBuffer(b)
        ? b.toString("hex", s, s + l)
        : ___hexlify(b, s, l);
    };
    __lpstr = function lpstr_b(b, i) {
      if (!Buffer.isBuffer(b)) return ___lpstr(b, i);
      var len = b.readUInt32LE(i);
      return len > 0 ? b.toString("utf8", i + 4, i + 4 + len - 1) : "";
    };
    __lpwstr = function lpwstr_b(b, i) {
      if (!Buffer.isBuffer(b)) return ___lpwstr(b, i);
      var len = 2 * b.readUInt32LE(i);
      return b.toString("utf16le", i + 4, i + 4 + len - 1);
    };
    __utf8 = function utf8_b(b, s, e) {
      return b.toString("utf8", s, e);
    };
    __toBuffer = function (bufs) {
      return bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])
        ? Buffer.concat(bufs[0])
        : ___toBuffer(bufs);
    };
    bconcat = function (bufs) {
      return Buffer.isBuffer(bufs[0])
        ? Buffer.concat(bufs)
        : [].concat.apply([], bufs);
    };
    __double = function double_(b, i) {
      if (Buffer.isBuffer(b)) return b.readDoubleLE(i);
      return ___double(b, i);
    };
  }
  if (typeof cptable !== "undefined") {
    __utf16le = function (b, s, e) {
      return cptable.utils.decode(1200, b.slice(s, e));
    };
    __utf8 = function (b, s, e) {
      return cptable.utils.decode(65001, b.slice(s, e));
    };
    __lpstr = function (b, i) {
      var len = __readUInt32LE(b, i);
      return len > 0
        ? cptable.utils.decode(
            current_codepage,
            b.slice(i + 4, i + 4 + len - 1)
          )
        : "";
    };
    __lpwstr = function (b, i) {
      var len = 2 * __readUInt32LE(b, i);
      return len > 0
        ? cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1))
        : "";
    };
  }
  var __readUInt8 = function (b, idx) {
    return b[idx];
  };
  var __readUInt16LE = function (b, idx) {
    return b[idx + 1] * (1 << 8) + b[idx];
  };
  var __readInt16LE = function (b, idx) {
    var u = b[idx + 1] * (1 << 8) + b[idx];
    return u < 32768 ? u : (65535 - u + 1) * -1;
  };
  var __readUInt32LE = function (b, idx) {
    return (
      b[idx + 3] * (1 << 24) + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx]
    );
  };
  var __readInt32LE = function (b, idx) {
    return (b[idx + 3] << 24) | (b[idx + 2] << 16) | (b[idx + 1] << 8) | b[idx];
  };
  var ___unhexlify = function (s) {
    return s.match(/../g).map(function (x) {
      return parseInt(x, 16);
    });
  };
  var __unhexlify =
    typeof Buffer !== "undefined"
      ? function (s) {
          return Buffer.isBuffer(s) ? new Buffer(s, "hex") : ___unhexlify(s);
        }
      : ___unhexlify;
  function ReadShift(size, t) {
    var o = "",
      oI,
      oR,
      oo = [],
      w,
      vv,
      i,
      loc;
    switch (t) {
      case "utf8":
        o = __utf8(this, this.l, this.l + size);
        break;
      case "utf16le":
        size *= 2;
        o = __utf16le(this, this.l, this.l + size);
        break;
      case "lpstr":
        o = __lpstr(this, this.l);
        size = 5 + o.length;
        break;
      case "lpwstr":
        o = __lpwstr(this, this.l);
        size = 5 + o.length;
        if (o[o.length - 1] == "\0") size += 2;
        break;
      case "cstr":
        size = 0;
        o = "";
        while ((w = __readUInt8(this, this.l + size++)) !== 0)
          oo.push(_getchar(w));
        o = oo.join("");
        break;
      case "wstr":
        size = 0;
        o = "";
        while ((w = __readUInt16LE(this, this.l + size)) !== 0) {
          oo.push(_getchar(w));
          size += 2;
        }
        size += 2;
        o = oo.join("");
        break;
      case "dbcs-cont":
        o = "";
        loc = this.l;
        for (i = 0; i != size; ++i) {
          if (this.lens && this.lens.indexOf(loc) !== -1) {
            w = __readUInt8(this, loc);
            this.l = loc + 1;
            vv = ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
            return oo.join("") + vv;
          }
          oo.push(_getchar(__readUInt16LE(this, loc)));
          loc += 2;
        }
        o = oo.join("");
        size *= 2;
        break;
      case "sbcs-cont":
        o = "";
        loc = this.l;
        for (i = 0; i != size; ++i) {
          if (this.lens && this.lens.indexOf(loc) !== -1) {
            w = __readUInt8(this, loc);
            this.l = loc + 1;
            vv = ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
            return oo.join("") + vv;
          }
          oo.push(_getchar(__readUInt8(this, loc)));
          loc += 1;
        }
        o = oo.join("");
        break;
      default:
        switch (size) {
          case 1:
            oI = __readUInt8(this, this.l);
            this.l++;
            return oI;
          case 2:
            oI = (t === "i" ? __readInt16LE : __readUInt16LE)(this, this.l);
            this.l += 2;
            return oI;
          case 4:
            if (t === "i" || (this[this.l + 3] & 128) === 0) {
              oI = __readInt32LE(this, this.l);
              this.l += 4;
              return oI;
            } else {
              oR = __readUInt32LE(this, this.l);
              this.l += 4;
              return oR;
            }
            break;
          case 8:
            if (t === "f") {
              oR = __double(this, this.l);
              this.l += 8;
              return oR;
            }
          case 16:
            o = __hexlify(this, this.l, size);
            break;
        }
    }
    this.l += size;
    return o;
  }
  function CheckField(hexstr, fld) {
    var m = __hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw fld + "Expected " + hexstr + " saw " + m;
    this.l += hexstr.length >> 1;
  }
  function prep_blob(blob, pos) {
    blob.l = pos;
    blob.read_shift = ReadShift;
    blob.chk = CheckField;
  }
  var SSF = {};
  var make_ssf = function make_ssf(SSF) {
    SSF.version = "0.8.1";
    function _strrev(x) {
      var o = "",
        i = x.length - 1;
      while (i >= 0) o += x.charAt(i--);
      return o;
    }
    function fill(c, l) {
      var o = "";
      while (o.length < l) o += c;
      return o;
    }
    function pad0(v, d) {
      var t = "" + v;
      return t.length >= d ? t : fill("0", d - t.length) + t;
    }
    function pad_(v, d) {
      var t = "" + v;
      return t.length >= d ? t : fill(" ", d - t.length) + t;
    }
    function rpad_(v, d) {
      var t = "" + v;
      return t.length >= d ? t : t + fill(" ", d - t.length);
    }
    function pad0r1(v, d) {
      var t = "" + Math.round(v);
      return t.length >= d ? t : fill("0", d - t.length) + t;
    }
    function pad0r2(v, d) {
      var t = "" + v;
      return t.length >= d ? t : fill("0", d - t.length) + t;
    }
    var p2_32 = Math.pow(2, 32);
    function pad0r(v, d) {
      if (v > p2_32 || v < -p2_32) return pad0r1(v, d);
      var i = Math.round(v);
      return pad0r2(i, d);
    }
    function isgeneral(s, i) {
      return (
        s.length >= 7 + i &&
        (s.charCodeAt(i) | 32) === 103 &&
        (s.charCodeAt(i + 1) | 32) === 101 &&
        (s.charCodeAt(i + 2) | 32) === 110 &&
        (s.charCodeAt(i + 3) | 32) === 101 &&
        (s.charCodeAt(i + 4) | 32) === 114 &&
        (s.charCodeAt(i + 5) | 32) === 97 &&
        (s.charCodeAt(i + 6) | 32) === 108
      );
    }
    var opts_fmt = [
      ["date1904", 0],
      ["output", ""],
      ["WTF", false],
    ];
    function fixopts(o) {
      for (var y = 0; y != opts_fmt.length; ++y)
        if (o[opts_fmt[y][0]] === undefined) o[opts_fmt[y][0]] = opts_fmt[y][1];
    }
    SSF.opts = opts_fmt;
    var table_fmt = {
      0: "General",
      1: "0",
      2: "0.00",
      3: "#,##0",
      4: "#,##0.00",
      9: "0%",
      10: "0.00%",
      11: "0.00E+00",
      12: "# ?/?",
      13: "# ??/??",
      14: "m/d/yy",
      15: "d-mmm-yy",
      16: "d-mmm",
      17: "mmm-yy",
      18: "h:mm AM/PM",
      19: "h:mm:ss AM/PM",
      20: "h:mm",
      21: "h:mm:ss",
      22: "m/d/yy h:mm",
      37: "#,##0 ;(#,##0)",
      38: "#,##0 ;[Red](#,##0)",
      39: "#,##0.00;(#,##0.00)",
      40: "#,##0.00;[Red](#,##0.00)",
      45: "mm:ss",
      46: "[h]:mm:ss",
      47: "mmss.0",
      48: "##0.0E+0",
      49: "@",
      56: '"上午/下午 "hh"時"mm"分"ss"秒 "',
      65535: "General",
    };
    var days = [
      ["Sun", "Sunday"],
      ["Mon", "Monday"],
      ["Tue", "Tuesday"],
      ["Wed", "Wednesday"],
      ["Thu", "Thursday"],
      ["Fri", "Friday"],
      ["Sat", "Saturday"],
    ];
    var months = [
      ["J", "Jan", "January"],
      ["F", "Feb", "February"],
      ["M", "Mar", "March"],
      ["A", "Apr", "April"],
      ["M", "May", "May"],
      ["J", "Jun", "June"],
      ["J", "Jul", "July"],
      ["A", "Aug", "August"],
      ["S", "Sep", "September"],
      ["O", "Oct", "October"],
      ["N", "Nov", "November"],
      ["D", "Dec", "December"],
    ];
    function frac(x, D, mixed) {
      var sgn = x < 0 ? -1 : 1;
      var B = x * sgn;
      var P_2 = 0,
        P_1 = 1,
        P = 0;
      var Q_2 = 1,
        Q_1 = 0,
        Q = 0;
      var A = Math.floor(B);
      while (Q_1 < D) {
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 5e-10) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
      }
      if (Q > D) {
        Q = Q_1;
        P = P_1;
      }
      if (Q > D) {
        Q = Q_2;
        P = P_2;
      }
      if (!mixed) return [0, sgn * P, Q];
      if (Q === 0)
        throw (
          "Unexpected state: " +
          P +
          " " +
          P_1 +
          " " +
          P_2 +
          " " +
          Q +
          " " +
          Q_1 +
          " " +
          Q_2
        );
      var q = Math.floor((sgn * P) / Q);
      return [q, sgn * P - q * Q, Q];
    }
    function general_fmt_int(v, opts) {
      return "" + v;
    }
    SSF._general_int = general_fmt_int;
    var general_fmt_num = (function make_general_fmt_num() {
      var gnr1 = /\.(\d*[1-9])0+$/,
        gnr2 = /\.0*$/,
        gnr4 = /\.(\d*[1-9])0+/,
        gnr5 = /\.0*[Ee]/,
        gnr6 = /(E[+-])(\d)$/;
      function gfn2(v) {
        var w = v < 0 ? 12 : 11;
        var o = gfn5(v.toFixed(12));
        if (o.length <= w) return o;
        o = v.toPrecision(10);
        if (o.length <= w) return o;
        return v.toExponential(5);
      }
      function gfn3(v) {
        var o = v.toFixed(11).replace(gnr1, ".$1");
        if (o.length > (v < 0 ? 12 : 11)) o = v.toPrecision(6);
        return o;
      }
      function gfn4(o) {
        for (var i = 0; i != o.length; ++i)
          if ((o.charCodeAt(i) | 32) === 101)
            return o
              .replace(gnr4, ".$1")
              .replace(gnr5, "E")
              .replace("e", "E")
              .replace(gnr6, "$10$2");
        return o;
      }
      function gfn5(o) {
        return o.indexOf(".") > -1
          ? o.replace(gnr2, "").replace(gnr1, ".$1")
          : o;
      }
      return function general_fmt_num(v, opts) {
        var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E),
          o;
        if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
        else if (Math.abs(V) <= 9) o = gfn2(v);
        else if (V === 10) o = v.toFixed(10).substr(0, 12);
        else o = gfn3(v);
        return gfn5(gfn4(o));
      };
    })();
    SSF._general_num = general_fmt_num;
    function general_fmt(v, opts) {
      switch (typeof v) {
        case "string":
          return v;
        case "boolean":
          return v ? "TRUE" : "FALSE";
        case "number":
          return (v | 0) === v
            ? general_fmt_int(v, opts)
            : general_fmt_num(v, opts);
      }
      throw new Error("unsupported value in General format: " + v);
    }
    SSF._general = general_fmt;
    function fix_hijri(date, o) {
      return 0;
    }
    function parse_date_code(v, opts, b2) {
      if (v > 2958465 || v < 0) return null;
      var date = v | 0,
        time = Math.floor(86400 * (v - date)),
        dow = 0;
      var dout = [];
      var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0,
      };
      if (Math.abs(out.u) < 1e-6) out.u = 0;
      fixopts(opts != null ? opts : (opts = []));
      if (opts.date1904) date += 1462;
      if (out.u > 0.999) {
        out.u = 0;
        if (++time == 86400) {
          time = 0;
          ++date;
        }
      }
      if (date === 60) {
        dout = b2 ? [1317, 10, 29] : [1900, 2, 29];
        dow = 3;
      } else if (date === 0) {
        dout = b2 ? [1317, 8, 29] : [1900, 1, 0];
        dow = 6;
      } else {
        if (date > 60) --date;
        var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = fix_hijri(d, dout);
      }
      out.y = dout[0];
      out.m = dout[1];
      out.d = dout[2];
      out.S = time % 60;
      time = Math.floor(time / 60);
      out.M = time % 60;
      time = Math.floor(time / 60);
      out.H = time;
      out.q = dow;
      return out;
    }
    SSF.parse_date_code = parse_date_code;
    function write_date(type, fmt, val, ss0) {
      var o = "",
        ss = 0,
        tt = 0,
        y = val.y,
        out,
        outl = 0;
      switch (type) {
        case 98:
          y = val.y + 543;
        case 121:
          switch (fmt.length) {
            case 1:
            case 2:
              out = y % 100;
              outl = 2;
              break;
            default:
              out = y % 1e4;
              outl = 4;
              break;
          }
          break;
        case 109:
          switch (fmt.length) {
            case 1:
            case 2:
              out = val.m;
              outl = fmt.length;
              break;
            case 3:
              return months[val.m - 1][1];
            case 5:
              return months[val.m - 1][0];
            default:
              return months[val.m - 1][2];
          }
          break;
        case 100:
          switch (fmt.length) {
            case 1:
            case 2:
              out = val.d;
              outl = fmt.length;
              break;
            case 3:
              return days[val.q][0];
            default:
              return days[val.q][1];
          }
          break;
        case 104:
          switch (fmt.length) {
            case 1:
            case 2:
              out = 1 + ((val.H + 11) % 12);
              outl = fmt.length;
              break;
            default:
              throw "bad hour format: " + fmt;
          }
          break;
        case 72:
          switch (fmt.length) {
            case 1:
            case 2:
              out = val.H;
              outl = fmt.length;
              break;
            default:
              throw "bad hour format: " + fmt;
          }
          break;
        case 77:
          switch (fmt.length) {
            case 1:
            case 2:
              out = val.M;
              outl = fmt.length;
              break;
            default:
              throw "bad minute format: " + fmt;
          }
          break;
        case 115:
          if (val.u === 0)
            switch (fmt) {
              case "s":
              case "ss":
                return pad0(val.S, fmt.length);
              case ".0":
              case ".00":
              case ".000":
            }
          switch (fmt) {
            case "s":
            case "ss":
            case ".0":
            case ".00":
            case ".000":
              if (ss0 >= 2) tt = ss0 === 3 ? 1e3 : 100;
              else tt = ss0 === 1 ? 10 : 1;
              ss = Math.round(tt * (val.S + val.u));
              if (ss >= 60 * tt) ss = 0;
              if (fmt === "s") return ss === 0 ? "0" : "" + ss / tt;
              o = pad0(ss, 2 + ss0);
              if (fmt === "ss") return o.substr(0, 2);
              return "." + o.substr(2, fmt.length - 1);
            default:
              throw "bad second format: " + fmt;
          }
        case 90:
          switch (fmt) {
            case "[h]":
            case "[hh]":
              out = val.D * 24 + val.H;
              break;
            case "[m]":
            case "[mm]":
              out = (val.D * 24 + val.H) * 60 + val.M;
              break;
            case "[s]":
            case "[ss]":
              out =
                ((val.D * 24 + val.H) * 60 + val.M) * 60 +
                Math.round(val.S + val.u);
              break;
            default:
              throw "bad abstime format: " + fmt;
          }
          outl = fmt.length === 3 ? 1 : 2;
          break;
        case 101:
          out = y;
          outl = 1;
      }
      if (outl > 0) return pad0(out, outl);
      else return "";
    }
    function commaify(s) {
      if (s.length <= 3) return s;
      var j = s.length % 3,
        o = s.substr(0, j);
      for (; j != s.length; j += 3)
        o += (o.length > 0 ? "," : "") + s.substr(j, 3);
      return o;
    }
    var write_num = (function make_write_num() {
      var pct1 = /%/g;
      function write_num_pct(type, fmt, val) {
        var sfmt = fmt.replace(pct1, ""),
          mul = fmt.length - sfmt.length;
        return (
          write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + fill("%", mul)
        );
      }
      function write_num_cm(type, fmt, val) {
        var idx = fmt.length - 1;
        while (fmt.charCodeAt(idx - 1) === 44) --idx;
        return write_num(
          type,
          fmt.substr(0, idx),
          val / Math.pow(10, 3 * (fmt.length - idx))
        );
      }
      function write_num_exp(fmt, val) {
        var o;
        var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
        if (fmt.match(/^#+0.0E\+0$/)) {
          var period = fmt.indexOf(".");
          if (period === -1) period = fmt.indexOf("E");
          var ee = Math.floor(Math.log(Math.abs(val)) * Math.LOG10E) % period;
          if (ee < 0) ee += period;
          o = (val / Math.pow(10, ee)).toPrecision(
            idx + 1 + ((period + ee) % period)
          );
          if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(Math.abs(val)) * Math.LOG10E);
            if (o.indexOf(".") === -1)
              o = o[0] + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while (o.substr(0, 2) === "0.") {
              o = o[0] + o.substr(2, period) + "." + o.substr(2 + period);
              o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
          }
          o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function ($$, $1, $2, $3) {
            return (
              $1 +
              $2 +
              $3.substr(0, (period + ee) % period) +
              "." +
              $3.substr(ee) +
              "E"
            );
          });
        } else o = val.toExponential(idx);
        if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/))
          o = o.substr(0, o.length - 1) + "0" + o[o.length - 1];
        if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
        return o.replace("e", "E");
      }
      var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
      function write_num_f1(r, aval, sign) {
        var den = parseInt(r[4]),
          rr = Math.round(aval * den),
          base = Math.floor(rr / den);
        var myn = rr - base * den,
          myd = den;
        return (
          sign +
          (base === 0 ? "" : "" + base) +
          " " +
          (myn === 0
            ? fill(" ", r[1].length + 1 + r[4].length)
            : pad_(myn, r[1].length) +
              r[2] +
              "/" +
              r[3] +
              pad0(myd, r[4].length))
        );
      }
      function write_num_f2(r, aval, sign) {
        return (
          sign +
          (aval === 0 ? "" : "" + aval) +
          fill(" ", r[1].length + 2 + r[4].length)
        );
      }
      var dec1 = /^#*0*\.(0+)/;
      var closeparen = /\).*[0#]/;
      var phone = /\(###\) ###\\?-####/;
      function hashq(str) {
        var o = "",
          cc;
        for (var i = 0; i != str.length; ++i)
          switch ((cc = str.charCodeAt(i))) {
            case 35:
              break;
            case 63:
              o += " ";
              break;
            case 48:
              o += "0";
              break;
            default:
              o += String.fromCharCode(cc);
          }
        return o;
      }
      function rnd(val, d) {
        var dd = Math.pow(10, d);
        return "" + Math.round(val * dd) / dd;
      }
      function dec(val, d) {
        return Math.round((val - Math.floor(val)) * Math.pow(10, d));
      }
      function flr(val) {
        if (val < 2147483647 && val > -2147483648)
          return "" + (val >= 0 ? val | 0 : (val - 1) | 0);
        return "" + Math.floor(val);
      }
      function write_num_flt(type, fmt, val) {
        if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
          var ffmt = fmt
            .replace(/\( */, "")
            .replace(/ \)/, "")
            .replace(/\)/, "");
          if (val >= 0) return write_num_flt("n", ffmt, val);
          return "(" + write_num_flt("n", ffmt, -val) + ")";
        }
        if (fmt.charCodeAt(fmt.length - 1) === 44)
          return write_num_cm(type, fmt, val);
        if (fmt.indexOf("%") !== -1) return write_num_pct(type, fmt, val);
        if (fmt.indexOf("E") !== -1) return write_num_exp(fmt, val);
        if (fmt.charCodeAt(0) === 36)
          return (
            "$" + write_num_flt(type, fmt.substr(fmt[1] == " " ? 2 : 1), val)
          );
        var o, oo;
        var r,
          ri,
          ff,
          aval = Math.abs(val),
          sign = val < 0 ? "-" : "";
        if (fmt.match(/^00+$/)) return sign + pad0r(aval, fmt.length);
        if (fmt.match(/^[#?]+$/)) {
          o = pad0r(val, 0);
          if (o === "0") o = "";
          return o.length > fmt.length
            ? o
            : hashq(fmt.substr(0, fmt.length - o.length)) + o;
        }
        if ((r = fmt.match(frac1)) !== null) return write_num_f1(r, aval, sign);
        if (fmt.match(/^#+0+$/) !== null)
          return sign + pad0r(aval, fmt.length - fmt.indexOf("0"));
        if ((r = fmt.match(dec1)) !== null) {
          o = rnd(val, r[1].length)
            .replace(/^([^\.]+)$/, "$1." + r[1])
            .replace(/\.$/, "." + r[1])
            .replace(/\.(\d*)$/, function ($$, $1) {
              return "." + $1 + fill("0", r[1].length - $1.length);
            });
          return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
        }
        fmt = fmt.replace(/^#+([0.])/, "$1");
        if ((r = fmt.match(/^(0*)\.(#*)$/)) !== null) {
          return (
            sign +
            rnd(aval, r[2].length)
              .replace(/\.(\d*[1-9])0*$/, ".$1")
              .replace(/^(-?\d*)$/, "$1.")
              .replace(/^0\./, r[1].length ? "0." : ".")
          );
        }
        if ((r = fmt.match(/^#,##0(\.?)$/)) !== null)
          return sign + commaify(pad0r(aval, 0));
        if ((r = fmt.match(/^#,##0\.([#0]*0)$/)) !== null) {
          return val < 0
            ? "-" + write_num_flt(type, fmt, -val)
            : commaify("" + Math.floor(val)) +
                "." +
                pad0(dec(val, r[1].length), r[1].length);
        }
        if ((r = fmt.match(/^#,#*,#0/)) !== null)
          return write_num_flt(type, fmt.replace(/^#,#*,/, ""), val);
        if ((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) !== null) {
          o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g, ""), val));
          ri = 0;
          return _strrev(
            _strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function (x) {
              return ri < o.length ? o[ri++] : x === "0" ? "0" : "";
            })
          );
        }
        if (fmt.match(phone) !== null) {
          o = write_num_flt(type, "##########", val);
          return (
            "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6)
          );
        }
        var oa = "";
        if ((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
          ri = Math.min(r[4].length, 7);
          ff = frac(aval, Math.pow(10, ri) - 1, false);
          o = "" + sign;
          oa = write_num("n", r[1], ff[1]);
          if (oa[oa.length - 1] == " ") oa = oa.substr(0, oa.length - 1) + "0";
          o += oa + r[2] + "/" + r[3];
          oa = rpad_(ff[2], ri);
          if (oa.length < r[4].length)
            oa = hashq(r[4].substr(r[4].length - oa.length)) + oa;
          o += oa;
          return o;
        }
        if ((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
          ri = Math.min(Math.max(r[1].length, r[4].length), 7);
          ff = frac(aval, Math.pow(10, ri) - 1, true);
          return (
            sign +
            (ff[0] || (ff[1] ? "" : "0")) +
            " " +
            (ff[1]
              ? pad_(ff[1], ri) + r[2] + "/" + r[3] + rpad_(ff[2], ri)
              : fill(" ", 2 * ri + 1 + r[2].length + r[3].length))
          );
        }
        if ((r = fmt.match(/^[#0?]+$/)) !== null) {
          o = pad0r(val, 0);
          if (fmt.length <= o.length) return o;
          return hashq(fmt.substr(0, fmt.length - o.length)) + o;
        }
        if ((r = fmt.match(/^([#0?]+)\.([#0]+)$/)) !== null) {
          o =
            "" +
            val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
          ri = o.indexOf(".");
          var lres = fmt.indexOf(".") - ri,
            rres = fmt.length - o.length - lres;
          return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
        }
        if ((r = fmt.match(/^00,000\.([#0]*0)$/)) !== null) {
          ri = dec(val, r[1].length);
          return val < 0
            ? "-" + write_num_flt(type, fmt, -val)
            : commaify(flr(val))
                .replace(/^\d,\d{3}$/, "0$&")
                .replace(/^\d*$/, function ($$) {
                  return (
                    "00," + ($$.length < 3 ? pad0(0, 3 - $$.length) : "") + $$
                  );
                }) +
                "." +
                pad0(ri, r[1].length);
        }
        switch (fmt) {
          case "#,###":
            var x = commaify(pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
          default:
        }
        throw new Error("unsupported format |" + fmt + "|");
      }
      function write_num_cm2(type, fmt, val) {
        var idx = fmt.length - 1;
        while (fmt.charCodeAt(idx - 1) === 44) --idx;
        return write_num(
          type,
          fmt.substr(0, idx),
          val / Math.pow(10, 3 * (fmt.length - idx))
        );
      }
      function write_num_pct2(type, fmt, val) {
        var sfmt = fmt.replace(pct1, ""),
          mul = fmt.length - sfmt.length;
        return (
          write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + fill("%", mul)
        );
      }
      function write_num_exp2(fmt, val) {
        var o;
        var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
        if (fmt.match(/^#+0.0E\+0$/)) {
          var period = fmt.indexOf(".");
          if (period === -1) period = fmt.indexOf("E");
          var ee = Math.floor(Math.log(Math.abs(val)) * Math.LOG10E) % period;
          if (ee < 0) ee += period;
          o = (val / Math.pow(10, ee)).toPrecision(
            idx + 1 + ((period + ee) % period)
          );
          if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(Math.abs(val)) * Math.LOG10E);
            if (o.indexOf(".") === -1)
              o = o[0] + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
          }
          o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function ($$, $1, $2, $3) {
            return (
              $1 +
              $2 +
              $3.substr(0, (period + ee) % period) +
              "." +
              $3.substr(ee) +
              "E"
            );
          });
        } else o = val.toExponential(idx);
        if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/))
          o = o.substr(0, o.length - 1) + "0" + o[o.length - 1];
        if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
        return o.replace("e", "E");
      }
      function write_num_int(type, fmt, val) {
        if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
          var ffmt = fmt
            .replace(/\( */, "")
            .replace(/ \)/, "")
            .replace(/\)/, "");
          if (val >= 0) return write_num_int("n", ffmt, val);
          return "(" + write_num_int("n", ffmt, -val) + ")";
        }
        if (fmt.charCodeAt(fmt.length - 1) === 44)
          return write_num_cm2(type, fmt, val);
        if (fmt.indexOf("%") !== -1) return write_num_pct2(type, fmt, val);
        if (fmt.indexOf("E") !== -1) return write_num_exp2(fmt, val);
        if (fmt.charCodeAt(0) === 36)
          return (
            "$" + write_num_int(type, fmt.substr(fmt[1] == " " ? 2 : 1), val)
          );
        var o;
        var r,
          ri,
          ff,
          aval = Math.abs(val),
          sign = val < 0 ? "-" : "";
        if (fmt.match(/^00+$/)) return sign + pad0(aval, fmt.length);
        if (fmt.match(/^[#?]+$/)) {
          o = "" + val;
          if (val === 0) o = "";
          return o.length > fmt.length
            ? o
            : hashq(fmt.substr(0, fmt.length - o.length)) + o;
        }
        if ((r = fmt.match(frac1)) !== null) return write_num_f2(r, aval, sign);
        if (fmt.match(/^#+0+$/) !== null)
          return sign + pad0(aval, fmt.length - fmt.indexOf("0"));
        if ((r = fmt.match(dec1)) !== null) {
          o = ("" + val)
            .replace(/^([^\.]+)$/, "$1." + r[1])
            .replace(/\.$/, "." + r[1])
            .replace(/\.(\d*)$/, function ($$, $1) {
              return "." + $1 + fill("0", r[1].length - $1.length);
            });
          return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
        }
        fmt = fmt.replace(/^#+([0.])/, "$1");
        if ((r = fmt.match(/^(0*)\.(#*)$/)) !== null) {
          return (
            sign +
            ("" + aval)
              .replace(/\.(\d*[1-9])0*$/, ".$1")
              .replace(/^(-?\d*)$/, "$1.")
              .replace(/^0\./, r[1].length ? "0." : ".")
          );
        }
        if ((r = fmt.match(/^#,##0(\.?)$/)) !== null)
          return sign + commaify("" + aval);
        if ((r = fmt.match(/^#,##0\.([#0]*0)$/)) !== null) {
          return val < 0
            ? "-" + write_num_int(type, fmt, -val)
            : commaify("" + val) + "." + fill("0", r[1].length);
        }
        if ((r = fmt.match(/^#,#*,#0/)) !== null)
          return write_num_int(type, fmt.replace(/^#,#*,/, ""), val);
        if ((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) !== null) {
          o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g, ""), val));
          ri = 0;
          return _strrev(
            _strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function (x) {
              return ri < o.length ? o[ri++] : x === "0" ? "0" : "";
            })
          );
        }
        if (fmt.match(phone) !== null) {
          o = write_num_int(type, "##########", val);
          return (
            "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6)
          );
        }
        var oa = "";
        if ((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
          ri = Math.min(r[4].length, 7);
          ff = frac(aval, Math.pow(10, ri) - 1, false);
          o = "" + sign;
          oa = write_num("n", r[1], ff[1]);
          if (oa[oa.length - 1] == " ") oa = oa.substr(0, oa.length - 1) + "0";
          o += oa + r[2] + "/" + r[3];
          oa = rpad_(ff[2], ri);
          if (oa.length < r[4].length)
            oa = hashq(r[4].substr(r[4].length - oa.length)) + oa;
          o += oa;
          return o;
        }
        if ((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
          ri = Math.min(Math.max(r[1].length, r[4].length), 7);
          ff = frac(aval, Math.pow(10, ri) - 1, true);
          return (
            sign +
            (ff[0] || (ff[1] ? "" : "0")) +
            " " +
            (ff[1]
              ? pad_(ff[1], ri) + r[2] + "/" + r[3] + rpad_(ff[2], ri)
              : fill(" ", 2 * ri + 1 + r[2].length + r[3].length))
          );
        }
        if ((r = fmt.match(/^[#0?]+$/)) !== null) {
          o = "" + val;
          if (fmt.length <= o.length) return o;
          return hashq(fmt.substr(0, fmt.length - o.length)) + o;
        }
        if ((r = fmt.match(/^([#0]+)\.([#0]+)$/)) !== null) {
          o =
            "" +
            val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
          ri = o.indexOf(".");
          var lres = fmt.indexOf(".") - ri,
            rres = fmt.length - o.length - lres;
          return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
        }
        if ((r = fmt.match(/^00,000\.([#0]*0)$/)) !== null) {
          return val < 0
            ? "-" + write_num_int(type, fmt, -val)
            : commaify("" + val)
                .replace(/^\d,\d{3}$/, "0$&")
                .replace(/^\d*$/, function ($$) {
                  return (
                    "00," + ($$.length < 3 ? pad0(0, 3 - $$.length) : "") + $$
                  );
                }) +
                "." +
                pad0(0, r[1].length);
        }
        switch (fmt) {
          case "#,###":
            var x = commaify("" + aval);
            return x !== "0" ? sign + x : "";
          default:
        }
        throw new Error("unsupported format |" + fmt + "|");
      }
      return function write_num(type, fmt, val) {
        return (val | 0) === val
          ? write_num_int(type, fmt, val)
          : write_num_flt(type, fmt, val);
      };
    })();
    function split_fmt(fmt) {
      var out = [];
      var in_str = false,
        cc;
      for (var i = 0, j = 0; i < fmt.length; ++i)
        switch ((cc = fmt.charCodeAt(i))) {
          case 34:
            in_str = !in_str;
            break;
          case 95:
          case 42:
          case 92:
            ++i;
            break;
          case 59:
            out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
        }
      out[out.length] = fmt.substr(j);
      if (in_str === true)
        throw new Error("Format |" + fmt + "| unterminated string ");
      return out;
    }
    SSF._split = split_fmt;
    var abstime = /\[[HhMmSs]*\]/;
    function eval_fmt(fmt, v, opts, flen) {
      var out = [],
        o = "",
        i = 0,
        c = "",
        lst = "t",
        q,
        dt,
        j,
        cc;
      var hr = "H";
      while (i < fmt.length) {
        switch ((c = fmt[i])) {
          case "G":
            if (!isgeneral(fmt, i))
              throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = { t: "G", v: "General" };
            i += 7;
            break;
          case '"':
            for (o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length; )
              o += String.fromCharCode(cc);
            out[out.length] = { t: "t", v: o };
            ++i;
            break;
          case "\\":
            var w = fmt[++i],
              t = w === "(" || w === ")" ? w : "t";
            out[out.length] = { t: t, v: w };
            ++i;
            break;
          case "_":
            out[out.length] = { t: "t", v: " " };
            i += 2;
            break;
          case "@":
            out[out.length] = { t: "T", v: v };
            ++i;
            break;
          case "B":
          case "b":
            if (fmt[i + 1] === "1" || fmt[i + 1] === "2") {
              if (dt == null) {
                dt = parse_date_code(v, opts, fmt[i + 1] === "2");
                if (dt == null) return "";
              }
              out[out.length] = { t: "X", v: fmt.substr(i, 2) };
              lst = c;
              i += 2;
              break;
            }
          case "M":
          case "D":
          case "Y":
          case "H":
          case "S":
          case "E":
            c = c.toLowerCase();
          case "m":
          case "d":
          case "y":
          case "h":
          case "s":
          case "e":
          case "g":
            if (v < 0) return "";
            if (dt == null) {
              dt = parse_date_code(v, opts);
              if (dt == null) return "";
            }
            o = c;
            while (++i < fmt.length && fmt[i].toLowerCase() === c) o += c;
            if (c === "m" && lst.toLowerCase() === "h") c = "M";
            if (c === "h") c = hr;
            out[out.length] = { t: c, v: o };
            lst = c;
            break;
          case "A":
            q = { t: c, v: "A" };
            if (dt == null) dt = parse_date_code(v, opts);
            if (fmt.substr(i, 3) === "A/P") {
              if (dt != null) q.v = dt.H >= 12 ? "P" : "A";
              q.t = "T";
              hr = "h";
              i += 3;
            } else if (fmt.substr(i, 5) === "AM/PM") {
              if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
              q.t = "T";
              i += 5;
              hr = "h";
            } else {
              q.t = "t";
              ++i;
            }
            if (dt == null && q.t === "T") return "";
            out[out.length] = q;
            lst = c;
            break;
          case "[":
            o = c;
            while (fmt[i++] !== "]" && i < fmt.length) o += fmt[i];
            if (o.substr(-1) !== "]")
              throw 'unterminated "[" block: |' + o + "|";
            if (o.match(abstime)) {
              if (dt == null) {
                dt = parse_date_code(v, opts);
                if (dt == null) return "";
              }
              out[out.length] = { t: "Z", v: o.toLowerCase() };
            } else {
              o = "";
            }
            break;
          case ".":
            if (dt != null) {
              o = c;
              while ((c = fmt[++i]) === "0") o += c;
              out[out.length] = { t: "s", v: o };
              break;
            }
          case "0":
          case "#":
            o = c;
            while (
              "0#?.,E+-%".indexOf((c = fmt[++i])) > -1 ||
              (c == "\\" && fmt[i + 1] == "-" && "0#".indexOf(fmt[i + 2]) > -1)
            )
              o += c;
            out[out.length] = { t: "n", v: o };
            break;
          case "?":
            o = c;
            while (fmt[++i] === c) o += c;
            q = { t: c, v: o };
            out[out.length] = q;
            lst = c;
            break;
          case "*":
            ++i;
            if (fmt[i] == " " || fmt[i] == "*") ++i;
            break;
          case "(":
          case ")":
            out[out.length] = { t: flen === 1 ? "t" : c, v: c };
            ++i;
            break;
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            o = c;
            while ("0123456789".indexOf(fmt[++i]) > -1) o += fmt[i];
            out[out.length] = { t: "D", v: o };
            break;
          case " ":
            out[out.length] = { t: c, v: c };
            ++i;
            break;
          default:
            if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxz".indexOf(c) === -1)
              throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = { t: "t", v: c };
            ++i;
            break;
        }
      }
      var bt = 0,
        ss0 = 0,
        ssm;
      for (i = out.length - 1, lst = "t"; i >= 0; --i) {
        switch (out[i].t) {
          case "h":
          case "H":
            out[i].t = hr;
            lst = "h";
            if (bt < 1) bt = 1;
            break;
          case "s":
            if ((ssm = out[i].v.match(/\.0+$/)))
              ss0 = Math.max(ss0, ssm[0].length - 1);
            if (bt < 3) bt = 3;
          case "d":
          case "y":
          case "M":
          case "e":
            lst = out[i].t;
            break;
          case "m":
            if (lst === "s") {
              out[i].t = "M";
              if (bt < 2) bt = 2;
            }
            break;
          case "X":
            if (out[i].v === "B2");
            break;
          case "Z":
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
        }
      }
      switch (bt) {
        case 0:
          break;
        case 1:
          if (dt.u >= 0.5) {
            dt.u = 0;
            ++dt.S;
          }
          if (dt.S >= 60) {
            dt.S = 0;
            ++dt.M;
          }
          if (dt.M >= 60) {
            dt.M = 0;
            ++dt.H;
          }
          break;
        case 2:
          if (dt.u >= 0.5) {
            dt.u = 0;
            ++dt.S;
          }
          if (dt.S >= 60) {
            dt.S = 0;
            ++dt.M;
          }
          break;
      }
      var nstr = "",
        jj;
      for (i = 0; i < out.length; ++i) {
        switch (out[i].t) {
          case "t":
          case "T":
          case " ":
          case "D":
            break;
          case "X":
            out[i] = undefined;
            break;
          case "d":
          case "m":
          case "y":
          case "h":
          case "H":
          case "M":
          case "s":
          case "e":
          case "b":
          case "Z":
            out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = "t";
            break;
          case "n":
          case "(":
          case "?":
            jj = i + 1;
            while (
              out[jj] != null &&
              ((c = out[jj].t) === "?" ||
                c === "D" ||
                ((c === " " || c === "t") &&
                  out[jj + 1] != null &&
                  (out[jj + 1].t === "?" ||
                    (out[jj + 1].t === "t" && out[jj + 1].v === "/"))) ||
                (out[i].t === "(" && (c === " " || c === "n" || c === ")")) ||
                (c === "t" &&
                  (out[jj].v === "/" ||
                    "$€".indexOf(out[jj].v) > -1 ||
                    (out[jj].v === " " &&
                      out[jj + 1] != null &&
                      out[jj + 1].t == "?"))))
            ) {
              out[i].v += out[jj].v;
              out[jj] = undefined;
              ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
          case "G":
            out[i].t = "t";
            out[i].v = general_fmt(v, opts);
            break;
        }
      }
      var vv = "",
        myv,
        ostr;
      if (nstr.length > 0) {
        myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
        ostr = write_num(nstr.charCodeAt(0) === 40 ? "(" : "n", nstr, myv);
        jj = ostr.length - 1;
        var decpt = out.length;
        for (i = 0; i < out.length; ++i)
          if (out[i] != null && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
          }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
          for (i = out.length - 1; i >= 0; --i) {
            if (out[i] == null || "n?(".indexOf(out[i].t) === -1) continue;
            if (jj >= out[i].v.length - 1) {
              jj -= out[i].v.length;
              out[i].v = ostr.substr(jj + 1, out[i].v.length);
            } else if (jj < 0) out[i].v = "";
            else {
              out[i].v = ostr.substr(0, jj + 1);
              jj = -1;
            }
            out[i].t = "t";
            lasti = i;
          }
          if (jj >= 0 && lasti < out.length)
            out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
          jj = ostr.indexOf(".") - 1;
          for (i = decpt; i >= 0; --i) {
            if (out[i] == null || "n?(".indexOf(out[i].t) === -1) continue;
            j =
              out[i].v.indexOf(".") > -1 && i === decpt
                ? out[i].v.indexOf(".") - 1
                : out[i].v.length - 1;
            vv = out[i].v.substr(j + 1);
            for (; j >= 0; --j) {
              if (jj >= 0 && (out[i].v[j] === "0" || out[i].v[j] === "#"))
                vv = ostr[jj--] + vv;
            }
            out[i].v = vv;
            out[i].t = "t";
            lasti = i;
          }
          if (jj >= 0 && lasti < out.length)
            out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
          jj = ostr.indexOf(".") + 1;
          for (i = decpt; i < out.length; ++i) {
            if (
              out[i] == null ||
              ("n?(".indexOf(out[i].t) === -1 && i !== decpt)
            )
              continue;
            j =
              out[i].v.indexOf(".") > -1 && i === decpt
                ? out[i].v.indexOf(".") + 1
                : 0;
            vv = out[i].v.substr(0, j);
            for (; j < out[i].v.length; ++j) {
              if (jj < ostr.length) vv += ostr[jj++];
            }
            out[i].v = vv;
            out[i].t = "t";
            lasti = i;
          }
        }
      }
      for (i = 0; i < out.length; ++i)
        if (out[i] != null && "n(?".indexOf(out[i].t) > -1) {
          myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
          out[i].v = write_num(out[i].t, out[i].v, myv);
          out[i].t = "t";
        }
      var retval = "";
      for (i = 0; i !== out.length; ++i) if (out[i] != null) retval += out[i].v;
      return retval;
    }
    SSF._eval = eval_fmt;
    var cfregex = /\[[=<>]/;
    var cfregex2 = /\[([=<>]*)(-?\d+\.?\d*)\]/;
    function chkcond(v, rr) {
      if (rr == null) return false;
      var thresh = parseFloat(rr[2]);
      switch (rr[1]) {
        case "=":
          if (v == thresh) return true;
          break;
        case ">":
          if (v > thresh) return true;
          break;
        case "<":
          if (v < thresh) return true;
          break;
        case "<>":
          if (v != thresh) return true;
          break;
        case ">=":
          if (v >= thresh) return true;
          break;
        case "<=":
          if (v <= thresh) return true;
          break;
      }
      return false;
    }
    function choose_fmt(f, v) {
      var fmt = split_fmt(f);
      var l = fmt.length,
        lat = fmt[l - 1].indexOf("@");
      if (l < 4 && lat > -1) --l;
      if (fmt.length > 4) throw "cannot find right format for |" + fmt + "|";
      if (typeof v !== "number")
        return [4, fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"];
      switch (fmt.length) {
        case 1:
          fmt =
            lat > -1
              ? ["General", "General", "General", fmt[0]]
              : [fmt[0], fmt[0], fmt[0], "@"];
          break;
        case 2:
          fmt =
            lat > -1
              ? [fmt[0], fmt[0], fmt[0], fmt[1]]
              : [fmt[0], fmt[1], fmt[0], "@"];
          break;
        case 3:
          fmt =
            lat > -1
              ? [fmt[0], fmt[1], fmt[0], fmt[2]]
              : [fmt[0], fmt[1], fmt[2], "@"];
          break;
        case 4:
          break;
      }
      var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
      if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1)
        return [l, ff];
      if (fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
        var m1 = fmt[0].match(cfregex2);
        var m2 = fmt[1].match(cfregex2);
        return chkcond(v, m1)
          ? [l, fmt[0]]
          : chkcond(v, m2)
          ? [l, fmt[1]]
          : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
      }
      return [l, ff];
    }
    function format(fmt, v, o) {
      fixopts(o != null ? o : (o = []));
      var sfmt = "";
      switch (typeof fmt) {
        case "string":
          sfmt = fmt;
          break;
        case "number":
          sfmt = (o.table != null ? o.table : table_fmt)[fmt];
          break;
      }
      if (isgeneral(sfmt, 0)) return general_fmt(v, o);
      var f = choose_fmt(sfmt, v);
      if (isgeneral(f[1])) return general_fmt(v, o);
      if (v === true) v = "TRUE";
      else if (v === false) v = "FALSE";
      else if (v === "" || v == null) return "";
      return eval_fmt(f[1], v, o, f[0]);
    }
    SSF._table = table_fmt;
    SSF.load = function load_entry(fmt, idx) {
      table_fmt[idx] = fmt;
    };
    SSF.format = format;
    SSF.get_table = function get_table() {
      return table_fmt;
    };
    SSF.load_table = function load_table(tbl) {
      for (var i = 0; i != 392; ++i)
        if (tbl[i] !== undefined) SSF.load(tbl[i], i);
    };
  };
  make_ssf(SSF);
  function parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4),
      dwHighDateTime = blob.read_shift(4);
    return new Date(
      ((dwHighDateTime / 1e7) * Math.pow(2, 32) +
        dwLowDateTime / 1e7 -
        11644473600) *
        1e3
    )
      .toISOString()
      .replace(/\.000/, "");
  }
  function parse_lpstr(blob, type, pad) {
    var str = blob.read_shift(0, "lpstr");
    if (pad) blob.l += (4 - ((str.length + 1) & 3)) & 3;
    return str;
  }
  function parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, "lpwstr");
    if (pad) blob.l += (4 - ((str.length + 1) & 3)) & 3;
    return str;
  }
  function parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 31) return parse_lpwstr(blob);
    return parse_lpstr(blob, stringType, pad);
  }
  function parse_VtString(blob, t, pad) {
    return parse_VtStringBase(blob, t, pad === false ? 0 : 4);
  }
  function parse_VtUnalignedString(blob, t) {
    if (!t) throw new Error("dafuq?");
    return parse_VtStringBase(blob, t, 0);
  }
  function parse_VtVecUnalignedLpstrValue(blob) {
    var length = blob.read_shift(4);
    var ret = [];
    for (var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, "lpstr");
    return ret;
  }
  function parse_VtVecUnalignedLpstr(blob) {
    return parse_VtVecUnalignedLpstrValue(blob);
  }
  function parse_VtHeadingPair(blob) {
    var headingString = parse_TypedPropertyValue(blob, VT_USTR);
    var headerParts = parse_TypedPropertyValue(blob, VT_I4);
    return [headingString, headerParts];
  }
  function parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for (var i = 0; i != cElements / 2; ++i)
      out.push(parse_VtHeadingPair(blob));
    return out;
  }
  function parse_VtVecHeadingPair(blob) {
    return parse_VtVecHeadingPairValue(blob);
  }
  function parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict = {};
    for (var j = 0; j != cnt; ++j) {
      var pid = blob.read_shift(4);
      var len = blob.read_shift(4);
      dict[pid] = blob
        .read_shift(len, CodePage === 1200 ? "utf16le" : "utf8")
        .replace(chr0, "")
        .replace(chr1, "!");
    }
    if (blob.l & 3) blob.l = (blob.l >> (2 + 1)) << 2;
    return dict;
  }
  function parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    if ((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
    return bytes;
  }
  function parse_ClipboardData(blob) {
    var o = {};
    o.Size = blob.read_shift(4);
    blob.l += o.Size;
    return o;
  }
  function parse_VtVector(blob, cb) {}
  function parse_TypedPropertyValue(blob, type, _opts) {
    var t = blob.read_shift(2),
      ret,
      opts = _opts || {};
    blob.l += 2;
    if (type !== VT_VARIANT)
      if (t !== type && VT_CUSTOM.indexOf(type) === -1)
        throw new Error("Expected type " + type + " saw " + t);
    switch (type === VT_VARIANT ? t : type) {
      case 2:
        ret = blob.read_shift(2, "i");
        if (!opts.raw) blob.l += 2;
        return ret;
      case 3:
        ret = blob.read_shift(4, "i");
        return ret;
      case 11:
        return blob.read_shift(4) !== 0;
      case 19:
        ret = blob.read_shift(4);
        return ret;
      case 30:
        return parse_lpstr(blob, t, 4).replace(chr0, "");
      case 31:
        return parse_lpwstr(blob);
      case 64:
        return parse_FILETIME(blob);
      case 65:
        return parse_BLOB(blob);
      case 71:
        return parse_ClipboardData(blob);
      case 80:
        return parse_VtString(blob, t, !opts.raw && 4).replace(chr0, "");
      case 81:
        return parse_VtUnalignedString(blob, t, 4).replace(chr0, "");
      case 4108:
        return parse_VtVecHeadingPair(blob);
      case 4126:
        return parse_VtVecUnalignedLpstr(blob);
      default:
        throw new Error(
          "TypedPropertyValue unrecognized type " + type + " " + t
        );
    }
  }
  function parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [],
      i = 0;
    var CodePage = 0;
    var Dictionary = -1,
      DictObj = {};
    for (i = 0; i != NumProps; ++i) {
      var PropID = blob.read_shift(4);
      var Offset = blob.read_shift(4);
      Props[i] = [PropID, Offset + start_addr];
    }
    var PropH = {};
    for (i = 0; i != NumProps; ++i) {
      if (blob.l !== Props[i][1]) {
        var fail = true;
        if (i > 0 && PIDSI)
          switch (PIDSI[Props[i - 1][0]].t) {
            case 2:
              if (blob.l + 2 === Props[i][1]) {
                blob.l += 2;
                fail = false;
              }
              break;
            case 80:
              if (blob.l <= Props[i][1]) {
                blob.l = Props[i][1];
                fail = false;
              }
              break;
            case 4108:
              if (blob.l <= Props[i][1]) {
                blob.l = Props[i][1];
                fail = false;
              }
              break;
          }
        if (!PIDSI && blob.l <= Props[i][1]) {
          fail = false;
          blob.l = Props[i][1];
        }
        if (fail)
          throw new Error(
            "Read Error: Expected address " +
              Props[i][1] +
              " at " +
              blob.l +
              " :" +
              i
          );
      }
      if (PIDSI) {
        var piddsi = PIDSI[Props[i][0]];
        PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {
          raw: true,
        });
        if (piddsi.p === "version")
          PropH[piddsi.n] =
            String(PropH[piddsi.n] >> 16) +
            "." +
            String(PropH[piddsi.n] & 65535);
        if (piddsi.n == "CodePage")
          switch (PropH[piddsi.n]) {
            case 0:
              PropH[piddsi.n] = 1252;
            case 1e4:
            case 1252:
            case 874:
            case 1250:
            case 1251:
            case 1253:
            case 1254:
            case 1255:
            case 1256:
            case 1257:
            case 1258:
            case 932:
            case 936:
            case 949:
            case 950:
            case 1200:
            case 1201:
            case 65e3:
            case -536:
            case 65001:
            case -535:
              set_cp((CodePage = PropH[piddsi.n]));
              break;
            default:
              throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
          }
      } else {
        if (Props[i][0] === 1) {
          CodePage = PropH.CodePage = parse_TypedPropertyValue(blob, VT_I2);
          set_cp(CodePage);
          if (Dictionary !== -1) {
            var oldpos = blob.l;
            blob.l = Props[Dictionary][1];
            DictObj = parse_dictionary(blob, CodePage);
            blob.l = oldpos;
          }
        } else if (Props[i][0] === 0) {
          if (CodePage === 0) {
            Dictionary = i;
            blob.l = Props[i + 1][1];
            continue;
          }
          DictObj = parse_dictionary(blob, CodePage);
        } else {
          var name = DictObj[Props[i][0]];
          var val;
          switch (blob[blob.l]) {
            case 65:
              blob.l += 4;
              val = parse_BLOB(blob);
              break;
            case 30:
              blob.l += 4;
              val = parse_VtString(blob, blob[blob.l - 4]);
              break;
            case 31:
              blob.l += 4;
              val = parse_VtString(blob, blob[blob.l - 4]);
              break;
            case 3:
              blob.l += 4;
              val = blob.read_shift(4, "i");
              break;
            case 19:
              blob.l += 4;
              val = blob.read_shift(4);
              break;
            case 5:
              blob.l += 4;
              val = blob.read_shift(8, "f");
              break;
            case 11:
              blob.l += 4;
              val = parsebool(blob, 4);
              break;
            case 64:
              blob.l += 4;
              val = new Date(parse_FILETIME(blob));
              break;
            default:
              throw new Error("unparsed value: " + blob[blob.l]);
          }
          PropH[name] = val;
        }
      }
    }
    blob.l = start_addr + size;
    return PropH;
  }
  function parse_PropertySetStream(file, PIDSI) {
    var blob = file.content;
    prep_blob(blob, 0);
    var NumSets,
      FMTID0,
      FMTID1,
      Offset0,
      Offset1 = 0;
    blob.chk("feff", "Byte Order: ");
    var vers = blob.read_shift(2);
    var SystemIdentifier = blob.read_shift(4);
    blob.chk(CFB.utils.consts.HEADER_CLSID, "CLSID: ");
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw "Unrecognized #Sets: " + NumSets;
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw "Length mismatch";
    else if (NumSets === 2) {
      FMTID1 = blob.read_shift(16);
      Offset1 = blob.read_shift(4);
    }
    var PSet0 = parse_PropertySet(blob, PIDSI);
    var rval = { SystemIdentifier: SystemIdentifier };
    for (var y in PSet0) rval[y] = PSet0[y];
    rval.FMTID = FMTID0;
    if (NumSets === 1) return rval;
    if (blob.l !== Offset1)
      throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
      PSet1 = parse_PropertySet(blob, null);
    } catch (e) {}
    for (y in PSet1) rval[y] = PSet1[y];
    rval.FMTID = [FMTID0, FMTID1];
    return rval;
  }
  var DO_NOT_EXPORT_CFB = true;
  var CFB = (function _CFB() {
    var exports = {};
    exports.version = "0.11.0";
    function parse(file) {
      var mver = 3;
      var ssz = 512;
      var nmfs = 0;
      var ndfs = 0;
      var dir_start = 0;
      var minifat_start = 0;
      var difat_start = 0;
      var fat_addrs = [];
      var blob = file.slice(0, 512);
      prep_blob(blob, 0);
      var mv = check_get_mver(blob);
      mver = mv[0];
      switch (mver) {
        case 3:
          ssz = 512;
          break;
        case 4:
          ssz = 4096;
          break;
        default:
          throw "Major Version: Expected 3 or 4 saw " + mver;
      }
      if (ssz !== 512) {
        blob = file.slice(0, ssz);
        prep_blob(blob, 28);
      }
      var header = file.slice(0, ssz);
      check_shifts(blob, mver);
      var nds = blob.read_shift(4, "i");
      if (mver === 3 && nds !== 0)
        throw "# Directory Sectors: Expected 0 saw " + nds;
      blob.l += 4;
      dir_start = blob.read_shift(4, "i");
      blob.l += 4;
      blob.chk("00100000", "Mini Stream Cutoff Size: ");
      minifat_start = blob.read_shift(4, "i");
      nmfs = blob.read_shift(4, "i");
      difat_start = blob.read_shift(4, "i");
      ndfs = blob.read_shift(4, "i");
      for (var q, j = 0; j < 109; ++j) {
        q = blob.read_shift(4, "i");
        if (q < 0) break;
        fat_addrs[j] = q;
      }
      var sectors = sectorify(file, ssz);
      sleuth_fat(difat_start, ndfs, sectors, ssz, fat_addrs);
      var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);
      sector_list[dir_start].name = "!Directory";
      if (nmfs > 0 && minifat_start !== ENDOFCHAIN)
        sector_list[minifat_start].name = "!MiniFAT";
      sector_list[fat_addrs[0]].name = "!FAT";
      sector_list.fat_addrs = fat_addrs;
      sector_list.ssz = ssz;
      var files = {},
        Paths = [],
        FileIndex = [],
        FullPaths = [],
        FullPathDir = {};
      read_directory(
        dir_start,
        sector_list,
        sectors,
        Paths,
        nmfs,
        files,
        FileIndex
      );
      build_full_paths(FileIndex, FullPathDir, FullPaths, Paths);
      var root_name = Paths.shift();
      Paths.root = root_name;
      var find_path = make_find_path(
        FullPaths,
        Paths,
        FileIndex,
        files,
        root_name
      );
      return {
        raw: { header: header, sectors: sectors },
        FileIndex: FileIndex,
        FullPaths: FullPaths,
        FullPathDir: FullPathDir,
        find: find_path,
      };
    }
    function check_get_mver(blob) {
      blob.chk(HEADER_SIGNATURE, "Header Signature: ");
      blob.chk(HEADER_CLSID, "CLSID: ");
      var mver = blob.read_shift(2, "u");
      return [blob.read_shift(2, "u"), mver];
    }
    function check_shifts(blob, mver) {
      var shift = 9;
      blob.chk("feff", "Byte Order: ");
      switch ((shift = blob.read_shift(2))) {
        case 9:
          if (mver !== 3) throw "MajorVersion/SectorShift Mismatch";
          break;
        case 12:
          if (mver !== 4) throw "MajorVersion/SectorShift Mismatch";
          break;
        default:
          throw "Sector Shift: Expected 9 or 12 saw " + shift;
      }
      blob.chk("0600", "Mini Sector Shift: ");
      blob.chk("000000000000", "Reserved: ");
    }
    function sectorify(file, ssz) {
      var nsectors = Math.ceil(file.length / ssz) - 1;
      var sectors = new Array(nsectors);
      for (var i = 1; i < nsectors; ++i)
        sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
      sectors[nsectors - 1] = file.slice(nsectors * ssz);
      return sectors;
    }
    function build_full_paths(FI, FPD, FP, Paths) {
      var i = 0,
        L = 0,
        R = 0,
        C = 0,
        j = 0,
        pl = Paths.length;
      var dad = new Array(pl),
        q = new Array(pl);
      for (; i < pl; ++i) {
        dad[i] = q[i] = i;
        FP[i] = Paths[i];
      }
      for (; j < q.length; ++j) {
        i = q[j];
        L = FI[i].L;
        R = FI[i].R;
        C = FI[i].C;
        if (dad[i] === i) {
          if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
          if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
        }
        if (C !== -1) dad[C] = i;
        if (L !== -1) {
          dad[L] = dad[i];
          q.push(L);
        }
        if (R !== -1) {
          dad[R] = dad[i];
          q.push(R);
        }
      }
      for (i = 1; i !== pl; ++i)
        if (dad[i] === i) {
          if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
          else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
      for (i = 1; i < pl; ++i) {
        if (FI[i].type === 0) continue;
        j = dad[i];
        if (j === 0) FP[i] = FP[0] + "/" + FP[i];
        else
          while (j !== 0) {
            FP[i] = FP[j] + "/" + FP[i];
            j = dad[j];
          }
        dad[i] = 0;
      }
      FP[0] += "/";
      for (i = 1; i < pl; ++i) {
        if (FI[i].type !== 2) FP[i] += "/";
        FPD[FP[i]] = FI[i];
      }
    }
    function make_find_path(FullPaths, Paths, FileIndex, files, root_name) {
      var UCFullPaths = new Array(FullPaths.length);
      var UCPaths = new Array(Paths.length),
        i;
      for (i = 0; i < FullPaths.length; ++i)
        UCFullPaths[i] = FullPaths[i]
          .toUpperCase()
          .replace(chr0, "")
          .replace(chr1, "!");
      for (i = 0; i < Paths.length; ++i)
        UCPaths[i] = Paths[i]
          .toUpperCase()
          .replace(chr0, "")
          .replace(chr1, "!");
      return function find_path(path) {
        var k;
        if (path.charCodeAt(0) === 47) {
          k = true;
          path = root_name + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath = path.toUpperCase().replace(chr0, "").replace(chr1, "!");
        var w =
          k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w === -1) return null;
        return k === true ? FileIndex[w] : files[Paths[w]];
      };
    }
    function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
      var q;
      if (idx === ENDOFCHAIN) {
        if (cnt !== 0) throw "DIFAT chain shorter than expected";
      } else if (idx !== -1) {
        var sector = sectors[idx],
          m = (ssz >>> 2) - 1;
        if (!sector) return;
        for (var i = 0; i < m; ++i) {
          if ((q = __readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
          fat_addrs.push(q);
        }
        sleuth_fat(
          __readInt32LE(sector, ssz - 4),
          cnt - 1,
          sectors,
          ssz,
          fat_addrs
        );
      }
    }
    function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
      var sl = sectors.length;
      var buf, buf_chain;
      if (!chkd) chkd = new Array(sl);
      var modulus = ssz - 1,
        j,
        jj;
      buf = [];
      buf_chain = [];
      for (j = start; j >= 0; ) {
        chkd[j] = true;
        buf[buf.length] = j;
        buf_chain.push(sectors[j]);
        var addr = fat_addrs[Math.floor((j * 4) / ssz)];
        jj = (j * 4) & modulus;
        if (ssz < 4 + jj) throw "FAT boundary crossed: " + j + " 4 " + ssz;
        if (!sectors[addr]) break;
        j = __readInt32LE(sectors[addr], jj);
      }
      return { nodes: buf, data: __toBuffer([buf_chain]) };
    }
    function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
      var sl = sectors.length,
        sector_list = new Array(sl);
      var chkd = new Array(sl),
        buf,
        buf_chain;
      var modulus = ssz - 1,
        i,
        j,
        k,
        jj;
      for (i = 0; i < sl; ++i) {
        buf = [];
        k = i + dir_start;
        if (k >= sl) k -= sl;
        if (chkd[k] === true) continue;
        buf_chain = [];
        for (j = k; j >= 0; ) {
          chkd[j] = true;
          buf[buf.length] = j;
          buf_chain.push(sectors[j]);
          var addr = fat_addrs[Math.floor((j * 4) / ssz)];
          jj = (j * 4) & modulus;
          if (ssz < 4 + jj) throw "FAT boundary crossed: " + j + " 4 " + ssz;
          if (!sectors[addr]) break;
          j = __readInt32LE(sectors[addr], jj);
        }
        sector_list[k] = { nodes: buf, data: __toBuffer([buf_chain]) };
      }
      return sector_list;
    }
    function read_directory(
      dir_start,
      sector_list,
      sectors,
      Paths,
      nmfs,
      files,
      FileIndex
    ) {
      var blob;
      var minifat_store = 0,
        pl = Paths.length ? 2 : 0;
      var sector = sector_list[dir_start].data;
      var i = 0,
        namelen = 0,
        name,
        o,
        ctime,
        mtime;
      for (; i < sector.length; i += 128) {
        blob = sector.slice(i, i + 128);
        prep_blob(blob, 64);
        namelen = blob.read_shift(2);
        if (namelen === 0) continue;
        name = __utf16le(blob, 0, namelen - pl);
        Paths.push(name);
        o = {
          name: name,
          type: blob.read_shift(1),
          color: blob.read_shift(1),
          L: blob.read_shift(4, "i"),
          R: blob.read_shift(4, "i"),
          C: blob.read_shift(4, "i"),
          clsid: blob.read_shift(16),
          state: blob.read_shift(4, "i"),
        };
        ctime =
          blob.read_shift(2) +
          blob.read_shift(2) +
          blob.read_shift(2) +
          blob.read_shift(2);
        if (ctime !== 0) {
          o.ctime = ctime;
          o.ct = read_date(blob, blob.l - 8);
        }
        mtime =
          blob.read_shift(2) +
          blob.read_shift(2) +
          blob.read_shift(2) +
          blob.read_shift(2);
        if (mtime !== 0) {
          o.mtime = mtime;
          o.mt = read_date(blob, blob.l - 8);
        }
        o.start = blob.read_shift(4, "i");
        o.size = blob.read_shift(4, "i");
        if (o.type === 5) {
          minifat_store = o.start;
          if (nmfs > 0 && minifat_store !== ENDOFCHAIN)
            sector_list[minifat_store].name = "!StreamData";
        } else if (o.size >= 4096) {
          o.storage = "fat";
          if (sector_list[o.start] === undefined)
            sector_list[o.start] = get_sector_list(
              sectors,
              o.start,
              sector_list.fat_addrs,
              sector_list.ssz
            );
          sector_list[o.start].name = o.name;
          o.content = sector_list[o.start].data.slice(0, o.size);
          prep_blob(o.content, 0);
        } else {
          o.storage = "minifat";
          if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN) {
            o.content = sector_list[minifat_store].data.slice(
              o.start * MSSZ,
              o.start * MSSZ + o.size
            );
            prep_blob(o.content, 0);
          }
        }
        files[name] = o;
        FileIndex.push(o);
      }
    }
    function read_date(blob, offset) {
      return new Date(
        ((__readUInt32LE(blob, offset + 4) / 1e7) * Math.pow(2, 32) +
          __readUInt32LE(blob, offset) / 1e7 -
          11644473600) *
          1e3
      );
    }
    var fs;
    function readFileSync(filename, options) {
      if (fs === undefined) fs = require("fs");
      return parse(fs.readFileSync(filename), options);
    }
    function readSync(blob, options) {
      switch (
        options !== undefined && options.type !== undefined
          ? options.type
          : "base64"
      ) {
        case "file":
          return readFileSync(blob, options);
        case "base64":
          return parse(s2a(Base64.decode(blob)), options);
        case "binary":
          return parse(s2a(blob), options);
      }
      return parse(blob);
    }
    var MSSZ = 64;
    var ENDOFCHAIN = -2;
    var HEADER_SIGNATURE = "d0cf11e0a1b11ae1";
    var HEADER_CLSID = "00000000000000000000000000000000";
    var consts = {
      MAXREGSECT: -6,
      DIFSECT: -4,
      FATSECT: -3,
      ENDOFCHAIN: ENDOFCHAIN,
      FREESECT: -1,
      HEADER_SIGNATURE: HEADER_SIGNATURE,
      HEADER_MINOR_VERSION: "3e00",
      MAXREGSID: -6,
      NOSTREAM: -1,
      HEADER_CLSID: HEADER_CLSID,
      EntryTypes: [
        "unknown",
        "storage",
        "stream",
        "lockbytes",
        "property",
        "root",
      ],
    };
    exports.read = readSync;
    exports.parse = parse;
    exports.utils = {
      ReadShift: ReadShift,
      CheckField: CheckField,
      prep_blob: prep_blob,
      bconcat: bconcat,
      consts: consts,
    };
    return exports;
  })();
  if (
    typeof require !== "undefined" &&
    typeof module !== "undefined" &&
    typeof DO_NOT_EXPORT_CFB === "undefined"
  ) {
    module.exports = CFB;
  }
  function dup(o) {
    if (typeof JSON != "undefined") return JSON.parse(JSON.stringify(o));
    if (typeof o != "object" || !o) return o;
    var out = {};
    for (var k in o) if (o.hasOwnProperty(k)) out[k] = dup(o[k]);
    return out;
  }
  function fill(c, l) {
    var o = "";
    while (o.length < l) o += c;
    return o;
  }
  function parsenoop(blob, length) {
    blob.read_shift(length);
    return;
  }
  function parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
  }
  function parslurp(blob, length, cb) {
    var arr = [],
      target = blob.l + length;
    while (blob.l < target) arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
  }
  function parslurp2(blob, length, cb) {
    var arr = [],
      target = blob.l + length,
      len = blob.read_shift(2);
    while (len-- !== 0) arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
  }
  function parsebool(blob, length) {
    return blob.read_shift(length) === 1;
  }
  function parseuint16(blob) {
    return blob.read_shift(2, "u");
  }
  function parseuint16a(blob, length) {
    return parslurp(blob, length, parseuint16);
  }
  var parse_Boolean = parsebool;
  function parse_Bes(blob) {
    var v = blob.read_shift(1),
      t = blob.read_shift(1);
    return t === 1 ? v : v === 1;
  }
  function parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(1);
    var width = 1,
      encoding = "sbcs-cont";
    var cp = current_codepage;
    if (opts && opts.biff >= 8) current_codepage = 1200;
    if (!opts || opts.biff == 8) {
      var fHighByte = blob.read_shift(1);
      if (fHighByte) {
        width = 2;
        encoding = "dbcs-cont";
      }
    }
    var o = cch ? blob.read_shift(cch, encoding) : "";
    current_codepage = cp;
    return o;
  }
  function parse_XLUnicodeRichExtendedString(blob) {
    var cp = current_codepage;
    current_codepage = 1200;
    var cch = blob.read_shift(2),
      flags = blob.read_shift(1);
    var fHighByte = flags & 1,
      fExtSt = flags & 4,
      fRichSt = flags & 8;
    var width = 1 + (flags & 1);
    var cRun = 0,
      cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = flags & 1 ? "dbcs-cont" : "sbcs-cont";
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun;
    if (fExtSt) blob.l += cbExtRst;
    z.t = msg;
    if (!fRichSt) {
      z.raw = "<t>" + z.t + "</t>";
      z.r = z.t;
    }
    current_codepage = cp;
    return z;
  }
  function parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
      if (opts.biff >= 2 && opts.biff <= 5)
        return blob.read_shift(cch, "sbcs-cont");
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) {
      retval = blob.read_shift(cch, "sbcs-cont");
    } else {
      retval = blob.read_shift(cch, "dbcs-cont");
    }
    return retval;
  }
  function parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
      blob.l++;
      return "";
    }
    return parse_XLUnicodeStringNoCch(blob, cch, opts);
  }
  function parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
      blob.l++;
      return "";
    }
    return blob.read_shift(cch, "sbcs-cont");
  }
  function parse_Xnum(blob) {
    return blob.read_shift(8, "f");
  }
  var parse_ControlInfo = parsenoop;
  var parse_URLMoniker = function (blob, length) {
    var len = blob.read_shift(4),
      start = blob.l;
    var extra = false;
    if (len > 24) {
      blob.l += len - 24;
      if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763")
        extra = true;
      blob.l = start;
    }
    var url = blob
      .read_shift((extra ? len - 24 : len) >> 1, "utf16le")
      .replace(chr0, "");
    if (extra) blob.l += 24;
    return url;
  };
  var parse_FileMoniker = function (blob, length) {
    var cAnti = blob.read_shift(2);
    var ansiLength = blob.read_shift(4);
    var ansiPath = blob.read_shift(ansiLength, "cstr");
    var endServer = blob.read_shift(2);
    var versionNumber = blob.read_shift(2);
    var cbUnicodePathSize = blob.read_shift(4);
    if (cbUnicodePathSize === 0) return ansiPath.replace(/\\/g, "/");
    var cbUnicodePathBytes = blob.read_shift(4);
    var usKeyValue = blob.read_shift(2);
    var unicodePath = blob
      .read_shift(cbUnicodePathBytes >> 1, "utf16le")
      .replace(chr0, "");
    return unicodePath;
  };
  var parse_HyperlinkMoniker = function (blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch (clsid) {
      case "e0c9ea79f9bace118c8200aa004ba90b":
        return parse_URLMoniker(blob, length);
      case "0303000000000000c000000000000046":
        return parse_FileMoniker(blob, length);
      default:
        throw "unsupported moniker " + clsid;
    }
  };
  var parse_HyperlinkString = function (blob, length) {
    var len = blob.read_shift(4);
    var o = blob.read_shift(len, "utf16le").replace(chr0, "");
    return o;
  };
  var parse_Hyperlink = function (blob, length) {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName,
      targetFrameName,
      moniker,
      oleMoniker,
      location,
      guid,
      fileTime;
    if (flags & 16) displayName = parse_HyperlinkString(blob, end - blob.l);
    if (flags & 128)
      targetFrameName = parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 257) === 257)
      moniker = parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 257) === 1)
      oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 8) location = parse_HyperlinkString(blob, end - blob.l);
    if (flags & 32) guid = blob.read_shift(16);
    if (flags & 64) fileTime = parse_FILETIME(blob, 8);
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker;
    if (location) target += "#" + location;
    return { Target: target };
  };
  function parse_LongRGBA(blob, length) {
    var r = blob.read_shift(1),
      g = blob.read_shift(1),
      b = blob.read_shift(1),
      a = blob.read_shift(1);
    return [r, g, b, a];
  }
  function parse_LongRGB(blob, length) {
    var x = parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
  }
  function shift_cell(cell, tgt) {
    var out = dup(cell);
    if (tgt.s) {
      if (out.cRel) out.c += tgt.s.c;
      if (out.rRel) out.r += tgt.s.r;
    } else {
      out.c += tgt.c;
      out.r += tgt.r;
    }
    while (out.c >= 256) out.c -= 256;
    while (out.r >= 65536) out.r -= 65536;
    return out;
  }
  function shift_range(cell, range) {
    cell.s = shift_cell(cell.s, range.s);
    cell.e = shift_cell(cell.e, range.s);
    return cell;
  }
  function encode_cell_xls(c) {
    var s = encode_cell(c);
    if (c.cRel === 0) s = fix_col(s);
    if (c.rRel === 0) s = fix_row(s);
    return s;
  }
  function encode_range_xls(r) {
    return encode_cell_xls(r.s) + ":" + encode_cell_xls(r.e);
  }
  function parse_RkNumber(data) {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1,
      fInt = b[0] & 2;
    data.l += 4;
    b[0] &= 252;
    var RK =
      fInt === 0
        ? __double([0, 0, 0, 0, b[0], b[1], b[2], b[3]], 0)
        : __readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
  }
  var BErr = {
    0: "#NULL!",
    7: "#DIV/0!",
    15: "#VALUE!",
    23: "#REF!",
    29: "#NAME?",
    36: "#NUM!",
    42: "#N/A",
    43: "#GETTING_DATA",
    255: "#WTF?",
  };
  var RBErr = evert(BErr);
  {
    var VT_EMPTY = 0;
    var VT_NULL = 1;
    var VT_I2 = 2;
    var VT_I4 = 3;
    var VT_R4 = 4;
    var VT_R8 = 5;
    var VT_CY = 6;
    var VT_DATE = 7;
    var VT_BSTR = 8;
    var VT_ERROR = 10;
    var VT_BOOL = 11;
    var VT_VARIANT = 12;
    var VT_DECIMAL = 14;
    var VT_I1 = 16;
    var VT_UI1 = 17;
    var VT_UI2 = 18;
    var VT_UI4 = 19;
    var VT_I8 = 20;
    var VT_UI8 = 21;
    var VT_INT = 22;
    var VT_UINT = 23;
    var VT_LPSTR = 30;
    var VT_LPWSTR = 31;
    var VT_FILETIME = 64;
    var VT_BLOB = 65;
    var VT_STREAM = 66;
    var VT_STORAGE = 67;
    var VT_STREAMED_Object = 68;
    var VT_STORED_Object = 69;
    var VT_BLOB_Object = 70;
    var VT_CF = 71;
    var VT_CLSID = 72;
    var VT_VERSIONED_STREAM = 73;
    var VT_VECTOR = 4096;
    var VT_ARRAY = 8192;
    var VT_STRING = 80;
    var VT_USTR = 81;
    var VT_CUSTOM = [VT_STRING, VT_USTR];
  }
  var DocSummaryPIDDSI = {
    1: { n: "CodePage", t: VT_I2 },
    2: { n: "Category", t: VT_STRING },
    3: { n: "PresentationFormat", t: VT_STRING },
    4: { n: "ByteCount", t: VT_I4 },
    5: { n: "LineCount", t: VT_I4 },
    6: { n: "ParagraphCount", t: VT_I4 },
    7: { n: "SlideCount", t: VT_I4 },
    8: { n: "NoteCount", t: VT_I4 },
    9: { n: "HiddenCount", t: VT_I4 },
    10: { n: "MultimediaClipCount", t: VT_I4 },
    11: { n: "Scale", t: VT_BOOL },
    12: { n: "HeadingPair", t: VT_VECTOR | VT_VARIANT },
    13: { n: "DocParts", t: VT_VECTOR | VT_LPSTR },
    14: { n: "Manager", t: VT_STRING },
    15: { n: "Company", t: VT_STRING },
    16: { n: "LinksDirty", t: VT_BOOL },
    17: { n: "CharacterCount", t: VT_I4 },
    19: { n: "SharedDoc", t: VT_BOOL },
    22: { n: "HLinksChanged", t: VT_BOOL },
    23: { n: "AppVersion", t: VT_I4, p: "version" },
    26: { n: "ContentType", t: VT_STRING },
    27: { n: "ContentStatus", t: VT_STRING },
    28: { n: "Language", t: VT_STRING },
    29: { n: "Version", t: VT_STRING },
    255: {},
  };
  var SummaryPIDSI = {
    1: { n: "CodePage", t: VT_I2 },
    2: { n: "Title", t: VT_STRING },
    3: { n: "Subject", t: VT_STRING },
    4: { n: "Author", t: VT_STRING },
    5: { n: "Keywords", t: VT_STRING },
    6: { n: "Comments", t: VT_STRING },
    7: { n: "Template", t: VT_STRING },
    8: { n: "LastAuthor", t: VT_STRING },
    9: { n: "RevNumber", t: VT_STRING },
    10: { n: "EditTime", t: VT_FILETIME },
    11: { n: "LastPrinted", t: VT_FILETIME },
    12: { n: "CreatedDate", t: VT_FILETIME },
    13: { n: "ModifiedDate", t: VT_FILETIME },
    14: { n: "PageCount", t: VT_I4 },
    15: { n: "WordCount", t: VT_I4 },
    16: { n: "CharCount", t: VT_I4 },
    17: { n: "Thumbnail", t: VT_CF },
    18: { n: "ApplicationName", t: VT_LPSTR },
    19: { n: "DocumentSecurity", t: VT_I4 },
    255: {},
  };
  var SpecialProperties = {
    2147483648: { n: "Locale", t: VT_UI4 },
    2147483651: { n: "Behavior", t: VT_UI4 },
    1768515945: {},
  };
  (function () {
    for (var y in SpecialProperties)
      if (SpecialProperties.hasOwnProperty(y))
        DocSummaryPIDDSI[y] = SummaryPIDSI[y] = SpecialProperties[y];
  })();
  var FillPattern = [
    null,
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625",
  ];
  function rgbify(arr) {
    return arr.map(function (x) {
      return [(x >> 16) & 255, (x >> 8) & 255, x & 255];
    });
  }
  var Icv = rgbify([
    0, 16777215, 16711680, 65280, 255, 16776960, 16711935, 65535, 0, 16777215,
    16711680, 65280, 255, 16776960, 16711935, 65535, 8388608, 32768, 128,
    8421376, 8388736, 32896, 12632256, 8421504, 10066431, 10040166, 16777164,
    13434879, 6684774, 16744576, 26316, 13421823, 128, 16711935, 16776960,
    65535, 8388736, 8388608, 32896, 255, 52479, 13434879, 13434828, 16777113,
    10079487, 16751052, 13408767, 16764057, 3368703, 3394764, 10079232,
    16763904, 16750848, 16737792, 6710937, 9868950, 13158, 3381606, 13056,
    3355392, 10040064, 10040166, 3355545, 3355443, 16777215, 0,
  ]);
  function isval(x) {
    return x !== undefined && x !== null;
  }
  function keys(o) {
    return Object.keys(o);
  }
  function evert(obj, arr) {
    var o = {};
    var K = keys(obj);
    for (var i = 0; i < K.length; ++i) {
      var k = K[i];
      if (!arr) o[obj[k]] = k;
      else (o[obj[k]] = o[obj[k]] || []).push(k);
    }
    return o;
  }
  function rgb2Hex(rgb) {
    for (var i = 0, o = 1; i != 3; ++i)
      o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().substr(1);
  }
  function parse_Cell(blob, length) {
    var rw = blob.read_shift(2);
    var col = blob.read_shift(2);
    var ixfe = blob.read_shift(2);
    return { r: rw, c: col, ixfe: ixfe };
  }
  function parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 8;
    return { type: rt, flags: flags };
  }
  function parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts);
  }
  var HIDEOBJENUM = ["SHOWALL", "SHOWPLACEHOLDER", "HIDEALL"];
  var parse_HideObjEnum = parseuint16;
  function parse_XTI(blob, length) {
    var iSupBook = blob.read_shift(2),
      itabFirst = blob.read_shift(2, "i"),
      itabLast = blob.read_shift(2, "i");
    return [iSupBook, itabFirst, itabLast];
  }
  function parse_RkRec(blob, length) {
    var ixfe = blob.read_shift(2);
    var RK = parse_RkNumber(blob);
    return [ixfe, RK];
  }
  function parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw "Malformed AddinUdf: padding = " + l + " != " + cb;
    blob.l += cb;
    return udfName;
  }
  function parse_Ref8U(blob, length) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return { s: { c: colFirst, r: rwFirst }, e: { c: colLast, r: rwLast } };
  }
  function parse_RefU(blob, length) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return { s: { c: colFirst, r: rwFirst }, e: { c: colLast, r: rwLast } };
  }
  var parse_Ref = parse_RefU;
  function parse_FtCmo(blob, length) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [id, ot, flags];
  }
  function parse_FtNts(blob, length) {
    var out = {};
    blob.l += 4;
    blob.l += 16;
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
  }
  function parse_FtCf(blob, length) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
  }
  var FtTab = {
    21: parse_FtCmo,
    19: parsenoop,
    18: function (blob, length) {
      blob.l += 12;
    },
    17: function (blob, length) {
      blob.l += 8;
    },
    16: parsenoop,
    15: parsenoop,
    13: parse_FtNts,
    12: function (blob, length) {
      blob.l += 24;
    },
    11: function (blob, length) {
      blob.l += 10;
    },
    10: function (blob, length) {
      blob.l += 16;
    },
    9: parsenoop,
    8: function (blob, length) {
      blob.l += 6;
    },
    7: parse_FtCf,
    6: function (blob, length) {
      blob.l += 6;
    },
    4: parsenoop,
    0: function (blob, length) {
      blob.l += 4;
    },
  };
  function parse_FtArray(blob, length, ot) {
    var s = blob.l;
    var fts = [];
    while (blob.l < s + length) {
      var ft = blob.read_shift(2);
      blob.l -= 2;
      try {
        fts.push(FtTab[ft](blob, s + length - blob.l));
      } catch (e) {
        blob.l = s + length;
        return fts;
      }
    }
    if (blob.l != s + length) blob.l = s + length;
    return fts;
  }
  var parse_FontIndex = parseuint16;
  function parse_BOF(blob, length) {
    var o = {};
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    switch (o.BIFFVer) {
      case 1536:
      case 1280:
      case 2:
      case 7:
        break;
      default:
        if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
  }
  function parse_InterfaceHdr(blob, length) {
    if (length === 0) return 1200;
    var q;
    if ((q = blob.read_shift(2)) !== 1200) throw "InterfaceHdr codePage " + q;
    return 1200;
  }
  function parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
      blob.l += length;
      return "";
    }
    var l = blob.l;
    var UserName = parse_XLUnicodeString(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
  }
  function parse_BoundSheet8(blob, length, opts) {
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 3;
    var dt = blob.read_shift(1);
    switch (dt) {
      case 0:
        dt = "Worksheet";
        break;
      case 1:
        dt = "Macrosheet";
        break;
      case 2:
        dt = "Chartsheet";
        break;
      case 6:
        dt = "VBAModule";
        break;
    }
    var name = parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return { pos: pos, hs: hidden, dt: dt, name: name };
  }
  function parse_SST(blob, length) {
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs = [];
    for (var i = 0; i != ucnt; ++i) {
      strs.push(parse_XLUnicodeRichExtendedString(blob));
    }
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
  }
  function parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
  }
  function parse_Row(blob, length) {
    var rw = blob.read_shift(2),
      col = blob.read_shift(2),
      Col = blob.read_shift(2),
      rht = blob.read_shift(2);
    blob.read_shift(4);
    var flags = blob.read_shift(1);
    blob.read_shift(1);
    blob.read_shift(2);
    return { r: rw, c: col, cnt: Col - col };
  }
  function parse_ForceFullCalculation(blob, length) {
    var header = parse_frtHeader(blob);
    if (header.type != 2211) throw "Invalid Future Record " + header.type;
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0;
  }
  var parse_CompressPictures = parsenoop2;
  function parse_RecalcId(blob, length) {
    blob.read_shift(2);
    return blob.read_shift(4);
  }
  function parse_DefaultRowHeight(blob, length) {
    var f = length == 4 ? blob.read_shift(2) : 0,
      miyRw;
    miyRw = blob.read_shift(2);
    var fl = {
      Unsynced: f & 1,
      DyZero: (f & 2) >> 1,
      ExAsc: (f & 4) >> 2,
      ExDsc: (f & 8) >> 3,
    };
    return [fl, miyRw];
  }
  function parse_Window1(blob, length) {
    var xWn = blob.read_shift(2),
      yWn = blob.read_shift(2),
      dxWn = blob.read_shift(2),
      dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2),
      iTabCur = blob.read_shift(2),
      iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2),
      wTabRatio = blob.read_shift(2);
    return {
      Pos: [xWn, yWn],
      Dim: [dxWn, dyWn],
      Flags: flags,
      CurTab: iTabCur,
      FirstTab: iTabFirst,
      Selected: ctabSel,
      TabRatio: wTabRatio,
    };
  }
  function parse_Font(blob, length, opts) {
    blob.l += 14;
    var name = parse_ShortXLUnicodeString(blob, 0, opts);
    return name;
  }
  function parse_LabelSst(blob, length) {
    var cell = parse_Cell(blob);
    cell.isst = blob.read_shift(4);
    return cell;
  }
  function parse_Label(blob, length, opts) {
    var target = blob.l + length;
    var cell = parse_Cell(blob, 6);
    if (opts.biff == 2) blob.l++;
    var str = parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
  }
  function parse_Format(blob, length, opts) {
    var ifmt = blob.read_shift(2);
    var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
    return [ifmt, fmtstr];
  }
  var parse_BIFF2Format = parse_XLUnicodeString2;
  function parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w),
      R = blob.read_shift(w),
      c = blob.read_shift(2),
      C = blob.read_shift(2);
    blob.l = end;
    return { s: { r: r, c: c }, e: { r: R, c: C } };
  }
  function parse_RK(blob, length) {
    var rw = blob.read_shift(2),
      col = blob.read_shift(2);
    var rkrec = parse_RkRec(blob);
    return { r: rw, c: col, ixfe: rkrec[0], rknum: rkrec[1] };
  }
  function parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2),
      col = blob.read_shift(2);
    var rkrecs = [];
    while (blob.l < target) rkrecs.push(parse_RkRec(blob));
    if (blob.l !== target) throw "MulRK read error";
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw "MulRK length mismatch";
    return { r: rw, c: col, C: lastcol, rkrec: rkrecs };
  }
  function parse_CellStyleXF(blob, length, style) {
    var o = {};
    var a = blob.read_shift(4),
      b = blob.read_shift(4);
    var c = blob.read_shift(4),
      d = blob.read_shift(2);
    o.patternType = FillPattern[c >> 26];
    o.icvFore = d & 127;
    o.icvBack = (d >> 7) & 127;
    return o;
  }
  function parse_CellXF(blob, length) {
    return parse_CellStyleXF(blob, length, 0);
  }
  function parse_StyleXF(blob, length) {
    return parse_CellStyleXF(blob, length, 1);
  }
  function parse_XF(blob, length) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.ifmt = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = (o.flags >> 2) & 1;
    length -= 6;
    o.data = parse_CellStyleXF(blob, length, o.fStyle);
    return o;
  }
  function parse_Guts(blob, length) {
    blob.l += 4;
    var out = [blob.read_shift(2), blob.read_shift(2)];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw "Bad Gutters: " + out.join("|");
    return out;
  }
  function parse_BoolErr(blob, length, opts) {
    var cell = parse_Cell(blob, 6);
    if (opts.biff == 2) ++blob.l;
    var val = parse_Bes(blob, 2);
    cell.val = val;
    cell.t = val === true || val === false ? "b" : "e";
    return cell;
  }
  function parse_Number(blob, length) {
    var cell = parse_Cell(blob, 6);
    var xnum = parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
  }
  var parse_XLHeaderFooter = parse_OptXLUnicodeString;
  function parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    var virtPath;
    if (cch >= 1 && cch <= 255)
      virtPath = parse_XLUnicodeStringNoCch(blob, cch);
    var rgst = blob.read_shift(end - blob.l);
    opts.sbcch = cch;
    return [cch, ctab, virtPath, rgst];
  }
  function parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
      fBuiltIn: flags & 1,
      fWantAdvise: (flags >>> 1) & 1,
      fWantPict: (flags >>> 2) & 1,
      fOle: (flags >>> 3) & 1,
      fOleLink: (flags >>> 4) & 1,
      cf: (flags >>> 5) & 1023,
      fIcon: (flags >>> 15) & 1,
    };
    if (opts.sbcch === 14849) body = parse_AddinUdf(blob, length - 2, opts);
    o.body = body || blob.read_shift(length - 2);
    return o;
  }
  function parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (!opts || opts.biff >= 5) {
      blob.l += 2;
      var itab = blob.read_shift(2);
      blob.l += 4;
    }
    var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    var rgce =
      target == blob.l || cce == 0
        ? []
        : parse_NameParsedFormula(blob, npflen, opts, cce);
    return { chKey: chKey, Name: name, rgce: rgce };
  }
  function parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return parse_ShortXLUnicodeString(blob, length, opts);
    var o = parslurp2(blob, length, parse_XTI);
    var oo = [];
    if (opts.sbcch === 1025) {
      for (var i = 0; i != o.length; ++i) oo.push(opts.snames[o[i][1]]);
      return oo;
    } else return o;
  }
  function parse_ShrFmla(blob, length, opts) {
    var ref = parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [parse_SharedParsedFormula(blob, length, opts), cUse];
  }
  function parse_Array(blob, length, opts) {
    var ref = parse_Ref(blob, 6);
    switch (opts.biff) {
      case 2:
        blob.l++;
        length -= 7;
        break;
      case 3:
      case 4:
        blob.l += 2;
        length -= 8;
        break;
      default:
        blob.l += 6;
        length -= 12;
    }
    return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
  }
  function parse_MTRSettings(blob, length) {
    var fMTREnabled = blob.read_shift(4) !== 0;
    var fUserSetThreadCount = blob.read_shift(4) !== 0;
    var cUserThreadCount = blob.read_shift(4);
    return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
  }
  function parse_NoteSh(blob, length, opts) {
    if (opts.biff < 8) return;
    var row = blob.read_shift(2),
      col = blob.read_shift(2);
    var flags = blob.read_shift(2),
      idObj = blob.read_shift(2);
    var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
    if (opts.biff < 8) blob.read_shift(1);
    return [{ r: row, c: col }, stAuthor, idObj, flags];
  }
  function parse_Note(blob, length, opts) {
    return parse_NoteSh(blob, length, opts);
  }
  function parse_MergeCells(blob, length) {
    var merges = [];
    var cmcs = blob.read_shift(2);
    while (cmcs--) merges.push(parse_Ref8U(blob, length));
    return merges;
  }
  function parse_Obj(blob, length) {
    var cmo = parse_FtCmo(blob, 22);
    var fts = parse_FtArray(blob, length - 22, cmo[1]);
    return { cmo: cmo, ft: fts };
  }
  function parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
      blob.l += 4;
      var ot = (opts.lastobj || { cmo: [0, 0] }).cmo[1];
      var controlInfo;
      if ([0, 5, 7, 11, 12, 14].indexOf(ot) == -1) blob.l += 6;
      else controlInfo = parse_ControlInfo(blob, 6, opts);
      var cchText = blob.read_shift(2);
      var cbRuns = blob.read_shift(2);
      var ifntEmpty = parse_FontIndex(blob, 2);
      var len = blob.read_shift(2);
      blob.l += len;
      for (var i = 1; i < blob.lens.length - 1; ++i) {
        if (blob.l - s != blob.lens[i]) throw "TxO: bad continue record";
        var hdr = blob[blob.l];
        var t = parse_XLUnicodeStringNoCch(
          blob,
          blob.lens[i + 1] - blob.lens[i] - 1
        );
        texts += t;
        if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
      }
      if (texts.length !== cchText && texts.length !== cchText * 2) {
        throw "cchText: " + cchText + " != " + texts.length;
      }
      blob.l = s + length;
      return { t: texts };
    } catch (e) {
      blob.l = s + length;
      return { t: texts };
    }
  }
  var parse_HLink = function (blob, length) {
    var ref = parse_Ref8U(blob, 8);
    blob.l += 16;
    var hlink = parse_Hyperlink(blob, length - 24);
    return [ref, hlink];
  };
  var parse_HLinkTooltip = function (blob, length) {
    var end = blob.l + length;
    blob.read_shift(2);
    var ref = parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, "dbcs-cont");
    wzTooltip = wzTooltip.replace(chr0, "");
    return [ref, wzTooltip];
  };
  function parse_Country(blob, length) {
    var o = [],
      d;
    d = blob.read_shift(2);
    o[0] = CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = CountryEnum[d] || d;
    return o;
  }
  function parse_ClrtClient(blob, length) {
    var ccv = blob.read_shift(2);
    var o = [];
    while (ccv-- > 0) o.push(parse_LongRGB(blob, 8));
    return o;
  }
  function parse_Palette(blob, length) {
    var ccv = blob.read_shift(2);
    var o = [];
    while (ccv-- > 0) o.push(parse_LongRGB(blob, 8));
    return o;
  }
  function parse_XFCRC(blob, length) {
    blob.l += 2;
    var o = { cxfs: 0, crc: 0 };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
  }
  var parse_Style = parsenoop;
  var parse_StyleExt = parsenoop;
  var parse_ColInfo = parsenoop;
  var parse_Window2 = parsenoop;
  var parse_Backup = parsebool;
  var parse_Blank = parse_Cell;
  var parse_BottomMargin = parse_Xnum;
  var parse_BuiltInFnGroupCount = parseuint16;
  var parse_CalcCount = parseuint16;
  var parse_CalcDelta = parse_Xnum;
  var parse_CalcIter = parsebool;
  var parse_CalcMode = parseuint16;
  var parse_CalcPrecision = parsebool;
  var parse_CalcRefMode = parsenoop2;
  var parse_CalcSaveRecalc = parsebool;
  var parse_CodePage = parseuint16;
  var parse_Compat12 = parsebool;
  var parse_Date1904 = parsebool;
  var parse_DefColWidth = parseuint16;
  var parse_DSF = parsenoop2;
  var parse_EntExU2 = parsenoop2;
  var parse_EOF = parsenoop2;
  var parse_Excel9File = parsenoop2;
  var parse_FeatHdr = parsenoop2;
  var parse_FontX = parseuint16;
  var parse_Footer = parse_XLHeaderFooter;
  var parse_GridSet = parseuint16;
  var parse_HCenter = parsebool;
  var parse_Header = parse_XLHeaderFooter;
  var parse_HideObj = parse_HideObjEnum;
  var parse_InterfaceEnd = parsenoop2;
  var parse_LeftMargin = parse_Xnum;
  var parse_Mms = parsenoop2;
  var parse_ObjProtect = parsebool;
  var parse_Password = parseuint16;
  var parse_PrintGrid = parsebool;
  var parse_PrintRowCol = parsebool;
  var parse_PrintSize = parseuint16;
  var parse_Prot4Rev = parsebool;
  var parse_Prot4RevPass = parseuint16;
  var parse_Protect = parsebool;
  var parse_RefreshAll = parsebool;
  var parse_RightMargin = parse_Xnum;
  var parse_RRTabId = parseuint16a;
  var parse_ScenarioProtect = parsebool;
  var parse_Scl = parseuint16a;
  var parse_String = parse_XLUnicodeString;
  var parse_SxBool = parsebool;
  var parse_TopMargin = parse_Xnum;
  var parse_UsesELFs = parsebool;
  var parse_VCenter = parsebool;
  var parse_WinProtect = parsebool;
  var parse_WriteProtect = parsenoop;
  var parse_VerticalPageBreaks = parsenoop;
  var parse_HorizontalPageBreaks = parsenoop;
  var parse_Selection = parsenoop;
  var parse_Continue = parsenoop;
  var parse_Pane = parsenoop;
  var parse_Pls = parsenoop;
  var parse_DCon = parsenoop;
  var parse_DConRef = parsenoop;
  var parse_DConName = parsenoop;
  var parse_XCT = parsenoop;
  var parse_CRN = parsenoop;
  var parse_FileSharing = parsenoop;
  var parse_Uncalced = parsenoop;
  var parse_Template = parsenoop;
  var parse_Intl = parsenoop;
  var parse_WsBool = parsenoop;
  var parse_Sort = parsenoop;
  var parse_Sync = parsenoop;
  var parse_LPr = parsenoop;
  var parse_DxGCol = parsenoop;
  var parse_FnGroupName = parsenoop;
  var parse_FilterMode = parsenoop;
  var parse_AutoFilterInfo = parsenoop;
  var parse_AutoFilter = parsenoop;
  var parse_Setup = parsenoop;
  var parse_ScenMan = parsenoop;
  var parse_SCENARIO = parsenoop;
  var parse_SxView = parsenoop;
  var parse_Sxvd = parsenoop;
  var parse_SXVI = parsenoop;
  var parse_SxIvd = parsenoop;
  var parse_SXLI = parsenoop;
  var parse_SXPI = parsenoop;
  var parse_DocRoute = parsenoop;
  var parse_RecipName = parsenoop;
  var parse_MulBlank = parsenoop;
  var parse_SXDI = parsenoop;
  var parse_SXDB = parsenoop;
  var parse_SXFDB = parsenoop;
  var parse_SXDBB = parsenoop;
  var parse_SXNum = parsenoop;
  var parse_SxErr = parsenoop;
  var parse_SXInt = parsenoop;
  var parse_SXString = parsenoop;
  var parse_SXDtr = parsenoop;
  var parse_SxNil = parsenoop;
  var parse_SXTbl = parsenoop;
  var parse_SXTBRGIITM = parsenoop;
  var parse_SxTbpg = parsenoop;
  var parse_ObProj = parsenoop;
  var parse_SXStreamID = parsenoop;
  var parse_DBCell = parsenoop;
  var parse_SXRng = parsenoop;
  var parse_SxIsxoper = parsenoop;
  var parse_BookBool = parsenoop;
  var parse_DbOrParamQry = parsenoop;
  var parse_OleObjectSize = parsenoop;
  var parse_SXVS = parsenoop;
  var parse_BkHim = parsenoop;
  var parse_MsoDrawingGroup = parsenoop;
  var parse_MsoDrawing = parsenoop;
  var parse_MsoDrawingSelection = parsenoop;
  var parse_PhoneticInfo = parsenoop;
  var parse_SxRule = parsenoop;
  var parse_SXEx = parsenoop;
  var parse_SxFilt = parsenoop;
  var parse_SxDXF = parsenoop;
  var parse_SxItm = parsenoop;
  var parse_SxName = parsenoop;
  var parse_SxSelect = parsenoop;
  var parse_SXPair = parsenoop;
  var parse_SxFmla = parsenoop;
  var parse_SxFormat = parsenoop;
  var parse_SXVDEx = parsenoop;
  var parse_SXFormula = parsenoop;
  var parse_SXDBEx = parsenoop;
  var parse_RRDInsDel = parsenoop;
  var parse_RRDHead = parsenoop;
  var parse_RRDChgCell = parsenoop;
  var parse_RRDRenSheet = parsenoop;
  var parse_RRSort = parsenoop;
  var parse_RRDMove = parsenoop;
  var parse_RRFormat = parsenoop;
  var parse_RRAutoFmt = parsenoop;
  var parse_RRInsertSh = parsenoop;
  var parse_RRDMoveBegin = parsenoop;
  var parse_RRDMoveEnd = parsenoop;
  var parse_RRDInsDelBegin = parsenoop;
  var parse_RRDInsDelEnd = parsenoop;
  var parse_RRDConflict = parsenoop;
  var parse_RRDDefName = parsenoop;
  var parse_RRDRstEtxp = parsenoop;
  var parse_LRng = parsenoop;
  var parse_CUsr = parsenoop;
  var parse_CbUsr = parsenoop;
  var parse_UsrInfo = parsenoop;
  var parse_UsrExcl = parsenoop;
  var parse_FileLock = parsenoop;
  var parse_RRDInfo = parsenoop;
  var parse_BCUsrs = parsenoop;
  var parse_UsrChk = parsenoop;
  var parse_UserBView = parsenoop;
  var parse_UserSViewBegin = parsenoop;
  var parse_UserSViewEnd = parsenoop;
  var parse_RRDUserView = parsenoop;
  var parse_Qsi = parsenoop;
  var parse_CondFmt = parsenoop;
  var parse_CF = parsenoop;
  var parse_DVal = parsenoop;
  var parse_DConBin = parsenoop;
  var parse_Lel = parsenoop;
  var parse_CodeName = parse_XLUnicodeString;
  var parse_SXFDBType = parsenoop;
  var parse_ObNoMacros = parsenoop;
  var parse_Dv = parsenoop;
  var parse_Index = parsenoop;
  var parse_Table = parsenoop;
  var parse_BigName = parsenoop;
  var parse_ContinueBigName = parsenoop;
  var parse_WebPub = parsenoop;
  var parse_QsiSXTag = parsenoop;
  var parse_DBQueryExt = parsenoop;
  var parse_ExtString = parsenoop;
  var parse_TxtQry = parsenoop;
  var parse_Qsir = parsenoop;
  var parse_Qsif = parsenoop;
  var parse_RRDTQSIF = parsenoop;
  var parse_OleDbConn = parsenoop;
  var parse_WOpt = parsenoop;
  var parse_SXViewEx = parsenoop;
  var parse_SXTH = parsenoop;
  var parse_SXPIEx = parsenoop;
  var parse_SXVDTEx = parsenoop;
  var parse_SXViewEx9 = parsenoop;
  var parse_ContinueFrt = parsenoop;
  var parse_RealTimeData = parsenoop;
  var parse_ChartFrtInfo = parsenoop;
  var parse_FrtWrapper = parsenoop;
  var parse_StartBlock = parsenoop;
  var parse_EndBlock = parsenoop;
  var parse_StartObject = parsenoop;
  var parse_EndObject = parsenoop;
  var parse_CatLab = parsenoop;
  var parse_YMult = parsenoop;
  var parse_SXViewLink = parsenoop;
  var parse_PivotChartBits = parsenoop;
  var parse_FrtFontList = parsenoop;
  var parse_SheetExt = parsenoop;
  var parse_BookExt = parsenoop;
  var parse_SXAddl = parsenoop;
  var parse_CrErr = parsenoop;
  var parse_HFPicture = parsenoop;
  var parse_Feat = parsenoop;
  var parse_DataLabExt = parsenoop;
  var parse_DataLabExtContents = parsenoop;
  var parse_CellWatch = parsenoop;
  var parse_FeatHdr11 = parsenoop;
  var parse_Feature11 = parsenoop;
  var parse_DropDownObjIds = parsenoop;
  var parse_ContinueFrt11 = parsenoop;
  var parse_DConn = parsenoop;
  var parse_List12 = parsenoop;
  var parse_Feature12 = parsenoop;
  var parse_CondFmt12 = parsenoop;
  var parse_CF12 = parsenoop;
  var parse_CFEx = parsenoop;
  var parse_AutoFilter12 = parsenoop;
  var parse_ContinueFrt12 = parsenoop;
  var parse_MDTInfo = parsenoop;
  var parse_MDXStr = parsenoop;
  var parse_MDXTuple = parsenoop;
  var parse_MDXSet = parsenoop;
  var parse_MDXProp = parsenoop;
  var parse_MDXKPI = parsenoop;
  var parse_MDB = parsenoop;
  var parse_PLV = parsenoop;
  var parse_DXF = parsenoop;
  var parse_TableStyles = parsenoop;
  var parse_TableStyle = parsenoop;
  var parse_TableStyleElement = parsenoop;
  var parse_NamePublish = parsenoop;
  var parse_NameCmt = parsenoop;
  var parse_SortData = parsenoop;
  var parse_GUIDTypeLib = parsenoop;
  var parse_FnGrp12 = parsenoop;
  var parse_NameFnGrp12 = parsenoop;
  var parse_HeaderFooter = parsenoop;
  var parse_CrtLayout12 = parsenoop;
  var parse_CrtMlFrt = parsenoop;
  var parse_CrtMlFrtContinue = parsenoop;
  var parse_ShapePropsStream = parsenoop;
  var parse_TextPropsStream = parsenoop;
  var parse_RichTextStream = parsenoop;
  var parse_CrtLayout12A = parsenoop;
  var parse_Units = parsenoop;
  var parse_Chart = parsenoop;
  var parse_Series = parsenoop;
  var parse_DataFormat = parsenoop;
  var parse_LineFormat = parsenoop;
  var parse_MarkerFormat = parsenoop;
  var parse_AreaFormat = parsenoop;
  var parse_PieFormat = parsenoop;
  var parse_AttachedLabel = parsenoop;
  var parse_SeriesText = parsenoop;
  var parse_ChartFormat = parsenoop;
  var parse_Legend = parsenoop;
  var parse_SeriesList = parsenoop;
  var parse_Bar = parsenoop;
  var parse_Line = parsenoop;
  var parse_Pie = parsenoop;
  var parse_Area = parsenoop;
  var parse_Scatter = parsenoop;
  var parse_CrtLine = parsenoop;
  var parse_Axis = parsenoop;
  var parse_Tick = parsenoop;
  var parse_ValueRange = parsenoop;
  var parse_CatSerRange = parsenoop;
  var parse_AxisLine = parsenoop;
  var parse_CrtLink = parsenoop;
  var parse_DefaultText = parsenoop;
  var parse_Text = parsenoop;
  var parse_ObjectLink = parsenoop;
  var parse_Frame = parsenoop;
  var parse_Begin = parsenoop;
  var parse_End = parsenoop;
  var parse_PlotArea = parsenoop;
  var parse_Chart3d = parsenoop;
  var parse_PicF = parsenoop;
  var parse_DropBar = parsenoop;
  var parse_Radar = parsenoop;
  var parse_Surf = parsenoop;
  var parse_RadarArea = parsenoop;
  var parse_AxisParent = parsenoop;
  var parse_LegendException = parsenoop;
  var parse_ShtProps = parsenoop;
  var parse_SerToCrt = parsenoop;
  var parse_AxesUsed = parsenoop;
  var parse_SBaseRef = parsenoop;
  var parse_SerParent = parsenoop;
  var parse_SerAuxTrend = parsenoop;
  var parse_IFmtRecord = parsenoop;
  var parse_Pos = parsenoop;
  var parse_AlRuns = parsenoop;
  var parse_BRAI = parsenoop;
  var parse_SerAuxErrBar = parsenoop;
  var parse_SerFmt = parsenoop;
  var parse_Chart3DBarShape = parsenoop;
  var parse_Fbi = parsenoop;
  var parse_BopPop = parsenoop;
  var parse_AxcExt = parsenoop;
  var parse_Dat = parsenoop;
  var parse_PlotGrowth = parsenoop;
  var parse_SIIndex = parsenoop;
  var parse_GelFrame = parsenoop;
  var parse_BopPopCustom = parsenoop;
  var parse_Fbi2 = parsenoop;
  function parse_BIFF5String(blob) {
    var len = blob.read_shift(1);
    return blob.read_shift(len, "sbcs-cont");
  }
  function parse_BIFF2STR(blob, length, opts) {
    var cell = parse_Cell(blob, 6);
    ++blob.l;
    var str = parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = "str";
    cell.val = str;
    return cell;
  }
  function parse_BIFF2NUM(blob, length, opts) {
    var cell = parse_Cell(blob, 6);
    ++blob.l;
    var num = parse_Xnum(blob, 8);
    cell.t = "n";
    cell.val = num;
    return cell;
  }
  function parse_BIFF2INT(blob, length) {
    var cell = parse_Cell(blob, 6);
    ++blob.l;
    var num = blob.read_shift(2);
    cell.t = "n";
    cell.val = num;
    return cell;
  }
  function parse_BIFF2STRING(blob, length) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
      blob.l++;
      return "";
    }
    return blob.read_shift(cch, "sbcs-cont");
  }
  function parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6;
    blob.l += 2;
    blob.l += 1;
    blob.l += 3;
    blob.l += 1;
    blob.l += length - 9;
  }
  function parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = parse_Cell(blob, 6);
    var cch = blob.read_shift(2);
    var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = "str";
    cell.val = str;
    return cell;
  }
  var _chr = function (c) {
    return String.fromCharCode(c);
  };
  var attregexg = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
  var attregex = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
  function parsexmltag(tag, skip_root) {
    var words = tag.split(/\s+/);
    var z = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match(attregexg),
      y,
      j,
      w,
      i;
    if (m)
      for (i = 0; i != m.length; ++i) {
        y = m[i].match(attregex);
        if ((j = y[1].indexOf(":")) === -1)
          z[y[1]] = y[2].substr(1, y[2].length - 2);
        else {
          if (y[1].substr(0, 6) === "xmlns:") w = "xmlns" + y[1].substr(6);
          else w = y[1].substr(j + 1);
          z[w] = y[2].substr(1, y[2].length - 2);
        }
      }
    return z;
  }
  function parsexmltagobj(tag) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match(attregexg),
      y,
      j,
      w,
      i;
    if (m)
      for (i = 0; i != m.length; ++i) {
        y = m[i].match(attregex);
        if ((j = y[1].indexOf(":")) === -1)
          z[y[1]] = y[2].substr(1, y[2].length - 2);
        else {
          if (y[1].substr(0, 6) === "xmlns:") w = "xmlns" + y[1].substr(6);
          else w = y[1].substr(j + 1);
          z[w] = y[2].substr(1, y[2].length - 2);
        }
      }
    return z;
  }
  var encodings = {
    "&quot;": '"',
    "&apos;": "'",
    "&gt;": ">",
    "&lt;": "<",
    "&amp;": "&",
  };
  var rencoding = evert(encodings);
  var rencstr = "&<>'\"".split("");
  var XML_HEADER =
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
  var OFFCRYPTO = {};
  var make_offcrypto = function (O, _crypto) {
    var crypto;
    if (typeof _crypto !== "undefined") crypto = _crypto;
    else if (typeof require !== "undefined") {
      try {
        crypto = require("cry" + "pto");
      } catch (e) {
        crypto = null;
      }
    }
    O.rc4 = function (key, data) {
      var S = new Array(256);
      var c = 0,
        i = 0,
        j = 0,
        t = 0;
      for (i = 0; i != 256; ++i) S[i] = i;
      for (i = 0; i != 256; ++i) {
        j = (j + S[i] + key[i % key.length].charCodeAt(0)) & 255;
        t = S[i];
        S[i] = S[j];
        S[j] = t;
      }
      i = j = 0;
      out = Buffer(data.length);
      for (c = 0; c != data.length; ++c) {
        i = (i + 1) & 255;
        j = (j + S[i]) % 256;
        t = S[i];
        S[i] = S[j];
        S[j] = t;
        out[c] = data[c] ^ S[(S[i] + S[j]) & 255];
      }
      return out;
    };
    O.md5 = function (hex) {
      if (!crypto) throw new Error("Unsupported crypto");
      return crypto.createHash("md5").update(hex).digest("hex");
    };
  };
  make_offcrypto(OFFCRYPTO, typeof crypto !== "undefined" ? crypto : undefined);
  function _JS2ANSI(str) {
    if (typeof cptable !== "undefined") return cptable.utils.encode(1252, str);
    var o = [],
      oo = str.split("");
    for (var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
    return o;
  }
  function parse_Version(blob, length) {
    var o = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    return o;
  }
  function parse_EncryptionHeader(blob, length) {
    var o = {};
    o.Flags = blob.read_shift(4);
    var tmp = blob.read_shift(4);
    if (tmp !== 0) throw "Unrecognized SizeExtra: " + tmp;
    o.AlgID = blob.read_shift(4);
    switch (o.AlgID) {
      case 0:
      case 26625:
      case 26126:
      case 26127:
      case 26128:
        break;
      default:
        throw "Unrecognized encryption algorithm: " + o.AlgID;
    }
    parsenoop(blob, length - 12);
    return o;
  }
  function parse_EncryptionVerifier(blob, length) {
    return parsenoop(blob, length);
  }
  function parse_RC4CryptoHeader(blob, length) {
    var o = {};
    var vers = (o.EncryptionVersionInfo = parse_Version(blob, 4));
    length -= 4;
    if (vers.Minor != 2) throw "unrecognized minor version code: " + vers.Minor;
    if (vers.Major > 4 || vers.Major < 2)
      throw "unrecognized major version code: " + vers.Major;
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
    return o;
  }
  function parse_RC4Header(blob, length) {
    var o = {};
    var vers = (o.EncryptionVersionInfo = parse_Version(blob, 4));
    length -= 4;
    if (vers.Major != 1 || vers.Minor != 1)
      throw "unrecognized version code " + vers.Major + " : " + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
  }
  function crypto_CreatePasswordVerifier_Method1(Password) {
    var Verifier = 0,
      PasswordArray;
    var PasswordDecoded = _JS2ANSI(Password);
    var len = PasswordDecoded.length + 1,
      i,
      PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for (i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i - 1];
    for (i = len - 1; i >= 0; --i) {
      PasswordByte = PasswordArray[i];
      Intermediate1 = (Verifier & 16384) === 0 ? 0 : 1;
      Intermediate2 = (Verifier << 1) & 32767;
      Intermediate3 = Intermediate1 | Intermediate2;
      Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 52811;
  }
  var crypto_CreateXorArray_Method1 = (function () {
    var PadArray = [
      187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0,
    ];
    var InitialCode = [
      57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287,
      34041, 10252, 43370, 20163,
    ];
    var XorMatrix = [
      44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933,
      60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248,
      885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614,
      21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210,
      60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898,
      15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812,
      17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557,
      1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128,
      28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883,
      1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628,
    ];
    var Ror = function (Byte) {
      return ((Byte / 2) | (Byte * 128)) & 255;
    };
    var XorRor = function (byte1, byte2) {
      return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function (Password) {
      var XorKey = InitialCode[Password.length - 1];
      var CurrentElement = 104;
      for (var i = Password.length - 1; i >= 0; --i) {
        var Char = Password[i];
        for (var j = 0; j != 7; ++j) {
          if (Char & 64) XorKey ^= XorMatrix[CurrentElement];
          Char *= 2;
          --CurrentElement;
        }
      }
      return XorKey;
    };
    return function (password) {
      var Password = _JS2ANSI(password);
      var XorKey = CreateXorKey_Method1(Password);
      var Index = Password.length;
      var ObfuscationArray = new_raw_buf(16);
      for (var i = 0; i != 16; ++i) ObfuscationArray[i] = 0;
      var Temp, PasswordLastChar, PadIndex;
      if ((Index & 1) === 1) {
        Temp = XorKey >> 8;
        ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
        --Index;
        Temp = XorKey & 255;
        PasswordLastChar = Password[Password.length - 1];
        ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
      }
      while (Index > 0) {
        --Index;
        Temp = XorKey >> 8;
        ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        --Index;
        Temp = XorKey & 255;
        ObfuscationArray[Index] = XorRor(Password[Index], Temp);
      }
      Index = 15;
      PadIndex = 15 - Password.length;
      while (PadIndex > 0) {
        Temp = XorKey >> 8;
        ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
        --Index;
        --PadIndex;
        Temp = XorKey & 255;
        ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        --Index;
        --PadIndex;
      }
      return ObfuscationArray;
    };
  })();
  var crypto_DecryptData_Method1 = function (
    password,
    Data,
    XorArrayIndex,
    XorArray,
    O
  ) {
    if (!O) O = Data;
    if (!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for (Index = 0; Index != Data.length; ++Index) {
      Value = Data[Index];
      Value ^= XorArray[XorArrayIndex];
      Value = ((Value >> 5) | (Value << 3)) & 255;
      O[Index] = Value;
      ++XorArrayIndex;
    }
    return [O, XorArrayIndex, XorArray];
  };
  var crypto_MakeXorDecryptor = function (password) {
    var XorArrayIndex = 0,
      XorArray = crypto_CreateXorArray_Method1(password);
    return function (Data) {
      var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
      XorArrayIndex = O[1];
      return O[0];
    };
  };
  function parse_XORObfuscation(blob, length, opts, out) {
    var o = { key: parseuint16(blob), verificationBytes: parseuint16(blob) };
    if (opts.password)
      o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu_decrypt = crypto_MakeXorDecryptor(opts.password);
    return o;
  }
  function parse_FilePassHeader(blob, length, oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = parse_RC4Header(blob, length);
    else o.Data = parse_RC4CryptoHeader(blob, length);
    return o;
  }
  function parse_FilePass(blob, length, opts) {
    var o = { Type: blob.read_shift(2) };
    if (o.Type) parse_FilePassHeader(blob, length - 2, o);
    else parse_XORObfuscation(blob, length - 2, opts, o);
    return o;
  }
  function parseread(l) {
    return function (blob, length) {
      blob.l += l;
      return;
    };
  }
  function parseread1(blob, length) {
    blob.l += 1;
    return;
  }
  function parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [c & 16383, (c >> 14) & 1, (c >> 15) & 1];
  }
  function parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
      if (opts.biff >= 2 && opts.biff <= 5)
        return parse_RgceArea_BIFF2(blob, length, opts);
    }
    var r = blob.read_shift(w),
      R = blob.read_shift(w);
    var c = parse_ColRelU(blob, 2);
    var C = parse_ColRelU(blob, 2);
    return {
      s: { r: r, c: c[0], cRel: c[1], rRel: c[2] },
      e: { r: R, c: C[0], cRel: C[1], rRel: C[2] },
    };
  }
  function parse_RgceArea_BIFF2(blob, length, opts) {
    var r = parse_ColRelU(blob, 2),
      R = parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
      s: { r: r[0], c: c, cRel: r[1], rRel: r[2] },
      e: { r: R[0], c: C, cRel: R[1], rRel: R[2] },
    };
  }
  function parse_RgceAreaRel(blob, length) {
    var r = blob.read_shift(2),
      R = blob.read_shift(2);
    var c = parse_ColRelU(blob, 2);
    var C = parse_ColRelU(blob, 2);
    return {
      s: { r: r, c: c[0], cRel: c[1], rRel: c[2] },
      e: { r: R, c: C[0], cRel: C[1], rRel: C[2] },
    };
  }
  function parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5)
      return parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(2);
    var c = parse_ColRelU(blob, 2);
    return { r: r, c: c[0], cRel: c[1], rRel: c[2] };
  }
  function parse_RgceLoc_BIFF2(blob, length, opts) {
    var r = parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return { r: r[0], c: c, cRel: r[1], rRel: r[2] };
  }
  function parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5)
      return parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 32768) >> 15,
      rRel = (cl & 16384) >> 14;
    cl &= 16383;
    if (rRel == 1) while (r > 524287) r -= 1048576;
    if (cRel == 1) while (cl > 8191) cl = cl - 16384;
    return { r: r, c: cl, cRel: cRel, rRel: rRel };
  }
  function parse_RgceLocRel_BIFF2(blob, length) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 32768) >> 15,
      cRel = (rl & 16384) >> 14;
    rl &= 16383;
    if (rRel == 1 && rl >= 8192) rl = rl - 16384;
    if (cRel == 1 && c >= 128) c = c - 256;
    return { r: rl, c: c, cRel: cRel, rRel: rRel };
  }
  function parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 96) >> 5;
    var area = parse_RgceArea(
      blob,
      opts.biff >= 2 && opts.biff <= 5 ? 6 : 8,
      opts
    );
    return [type, area];
  }
  function parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 96) >> 5;
    var ixti = blob.read_shift(2, "i");
    var w = 8;
    if (opts)
      switch (opts.biff) {
        case 5:
          blob.l += 12;
          w = 6;
          break;
      }
    var area = parse_RgceArea(blob, w, opts);
    return [type, ixti, area];
  }
  function parse_PtgAreaErr(blob, length) {
    var type = (blob[blob.l++] & 96) >> 5;
    blob.l += 8;
    return [type];
  }
  function parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 96) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts)
      switch (opts.biff) {
        case 5:
          blob.l += 12;
          w = 6;
          break;
      }
    blob.l += w;
    return [type, ixti];
  }
  function parse_PtgAreaN(blob, length) {
    var type = (blob[blob.l++] & 96) >> 5;
    var area = parse_RgceAreaRel(blob, 8);
    return [type, area];
  }
  function parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 96) >> 5;
    blob.l += opts.biff == 2 ? 6 : 7;
    return [type];
  }
  function parse_PtgAttrBaxcel(blob, length) {
    var bitSemi = blob[blob.l + 1] & 1;
    var bitBaxcel = 1;
    blob.l += 4;
    return [bitSemi, bitBaxcel];
  }
  function parse_PtgAttrChoose(blob, length, opts) {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o = [];
    for (var i = 0; i <= offset; ++i)
      o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
  }
  function parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 255 ? 1 : 0;
    blob.l += 2;
    return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
  }
  function parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 255 ? 1 : 0;
    blob.l += 2;
    return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
  }
  function parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 255 ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [bitSemi];
  }
  function parse_PtgAttrSpaceType(blob, length) {
    var type = blob.read_shift(1),
      cch = blob.read_shift(1);
    return [type, cch];
  }
  function parse_PtgAttrSpace(blob, length) {
    blob.read_shift(2);
    return parse_PtgAttrSpaceType(blob, 2);
  }
  function parse_PtgAttrSpaceSemi(blob, length) {
    blob.read_shift(2);
    return parse_PtgAttrSpaceType(blob, 2);
  }
  function parse_PtgRef(blob, length, opts) {
    var ptg = blob[blob.l] & 31;
    var type = (blob[blob.l] & 96) >> 5;
    blob.l += 1;
    var loc = parse_RgceLoc(blob, 4, opts);
    return [type, loc];
  }
  function parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 96) >> 5;
    blob.l += 1;
    var loc = parse_RgceLocRel(blob, 4, opts);
    return [type, loc];
  }
  function parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 96) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2);
    var loc = parse_RgceLoc(blob, 0, opts);
    return [type, ixti, loc];
  }
  function parse_PtgFunc(blob, length, opts) {
    var ptg = blob[blob.l] & 31;
    var type = (blob[blob.l] & 96) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [FtabArgc[iftab], Ftab[iftab], type];
  }
  function parse_PtgFuncVar(blob, length, opts) {
    blob.l++;
    var cparams = blob.read_shift(1),
      tab = opts && opts.biff <= 3 ? [0, blob.read_shift(1)] : parsetab(blob);
    return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
  }
  function parsetab(blob, length) {
    return [blob[blob.l + 1] >> 7, blob.read_shift(2) & 32767];
  }
  function parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
  }
  var parse_PtgConcat = parseread1;
  function parse_PtgExp(blob, length, opts) {
    blob.l++;
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [row, col];
  }
  function parse_PtgErr(blob, length) {
    blob.l++;
    return BErr[blob.read_shift(1)];
  }
  function parse_PtgInt(blob, length) {
    blob.l++;
    return blob.read_shift(2);
  }
  function parse_PtgBool(blob, length) {
    blob.l++;
    return blob.read_shift(1) !== 0;
  }
  function parse_PtgNum(blob, length) {
    blob.l++;
    return parse_Xnum(blob, 8);
  }
  function parse_PtgStr(blob, length, opts) {
    blob.l++;
    return parse_ShortXLUnicodeString(blob, length - 1, opts);
  }
  function parse_SerAr(blob, biff) {
    var val = [blob.read_shift(1)];
    switch (val[0]) {
      case 4:
        val[1] = parsebool(blob, 1) ? "TRUE" : "FALSE";
        blob.l += 7;
        break;
      case 16:
        val[1] = BErr[blob[blob.l]];
        blob.l += 8;
        break;
      case 0:
        blob.l += 8;
        break;
      case 1:
        val[1] = parse_Xnum(blob, 8);
        break;
      case 2:
        val[1] = parse_XLUnicodeString2(blob, 0, {
          biff: biff > 0 && biff < 8 ? 2 : biff,
        });
        break;
    }
    return val;
  }
  function parse_PtgExtraMem(blob, cce) {
    var count = blob.read_shift(2);
    var out = [];
    for (var i = 0; i != count; ++i) out.push(parse_Ref8U(blob, 8));
    return out;
  }
  function parse_PtgExtraArray(blob, length, opts) {
    var cols = 1 + blob.read_shift(1);
    var rows = 1 + blob.read_shift(2);
    if (opts.biff >= 2 && opts.biff < 8) {
      --rows;
      if (--cols == 0) cols = 256;
    }
    for (var i = 0, o = []; i != rows && (o[i] = []); ++i)
      for (var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
    return o;
  }
  function parse_PtgName(blob, length, opts) {
    var type = (blob.read_shift(1) >>> 5) & 3;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch (opts.biff) {
      case 2:
        blob.l += 5;
        break;
      case 3:
      case 4:
        blob.l += 8;
        break;
      case 5:
        blob.l += 12;
        break;
    }
    return [type, 0, nameindex];
  }
  function parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
    var type = (blob.read_shift(1) >>> 5) & 3;
    var ixti = blob.read_shift(2);
    var nameindex = blob.read_shift(4);
    return [type, ixti, nameindex];
  }
  function parse_PtgNameX_BIFF5(blob, length, opts) {
    var type = (blob.read_shift(1) >>> 5) & 3;
    var ixti = blob.read_shift(2, "i");
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [type, ixti, nameindex];
  }
  function parse_PtgMemArea(blob, length, opts) {
    var type = (blob.read_shift(1) >>> 5) & 3;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [type, cce];
  }
  function parse_PtgMemFunc(blob, length, opts) {
    var type = (blob.read_shift(1) >>> 5) & 3;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [type, cce];
  }
  function parse_PtgRefErr(blob, length, opts) {
    var type = (blob.read_shift(1) >>> 5) & 3;
    blob.l += 4;
    return [type];
  }
  var parse_PtgAdd = parseread1;
  var parse_PtgDiv = parseread1;
  var parse_PtgEq = parseread1;
  var parse_PtgGe = parseread1;
  var parse_PtgGt = parseread1;
  var parse_PtgIsect = parseread1;
  var parse_PtgLe = parseread1;
  var parse_PtgLt = parseread1;
  var parse_PtgMissArg = parseread1;
  var parse_PtgMul = parseread1;
  var parse_PtgNe = parseread1;
  var parse_PtgParen = parseread1;
  var parse_PtgPercent = parseread1;
  var parse_PtgPower = parseread1;
  var parse_PtgRange = parseread1;
  var parse_PtgSub = parseread1;
  var parse_PtgUminus = parseread1;
  var parse_PtgUnion = parseread1;
  var parse_PtgUplus = parseread1;
  var parse_PtgMemErr = parsenoop;
  var parse_PtgMemNoMem = parsenoop;
  var parse_PtgRefErr3d = parsenoop;
  var parse_PtgTbl = parsenoop;
  var PtgTypes = {
    1: { n: "PtgExp", f: parse_PtgExp },
    2: { n: "PtgTbl", f: parse_PtgTbl },
    3: { n: "PtgAdd", f: parse_PtgAdd },
    4: { n: "PtgSub", f: parse_PtgSub },
    5: { n: "PtgMul", f: parse_PtgMul },
    6: { n: "PtgDiv", f: parse_PtgDiv },
    7: { n: "PtgPower", f: parse_PtgPower },
    8: { n: "PtgConcat", f: parse_PtgConcat },
    9: { n: "PtgLt", f: parse_PtgLt },
    10: { n: "PtgLe", f: parse_PtgLe },
    11: { n: "PtgEq", f: parse_PtgEq },
    12: { n: "PtgGe", f: parse_PtgGe },
    13: { n: "PtgGt", f: parse_PtgGt },
    14: { n: "PtgNe", f: parse_PtgNe },
    15: { n: "PtgIsect", f: parse_PtgIsect },
    16: { n: "PtgUnion", f: parse_PtgUnion },
    17: { n: "PtgRange", f: parse_PtgRange },
    18: { n: "PtgUplus", f: parse_PtgUplus },
    19: { n: "PtgUminus", f: parse_PtgUminus },
    20: { n: "PtgPercent", f: parse_PtgPercent },
    21: { n: "PtgParen", f: parse_PtgParen },
    22: { n: "PtgMissArg", f: parse_PtgMissArg },
    23: { n: "PtgStr", f: parse_PtgStr },
    28: { n: "PtgErr", f: parse_PtgErr },
    29: { n: "PtgBool", f: parse_PtgBool },
    30: { n: "PtgInt", f: parse_PtgInt },
    31: { n: "PtgNum", f: parse_PtgNum },
    32: { n: "PtgArray", f: parse_PtgArray },
    33: { n: "PtgFunc", f: parse_PtgFunc },
    34: { n: "PtgFuncVar", f: parse_PtgFuncVar },
    35: { n: "PtgName", f: parse_PtgName },
    36: { n: "PtgRef", f: parse_PtgRef },
    37: { n: "PtgArea", f: parse_PtgArea },
    38: { n: "PtgMemArea", f: parse_PtgMemArea },
    39: { n: "PtgMemErr", f: parse_PtgMemErr },
    40: { n: "PtgMemNoMem", f: parse_PtgMemNoMem },
    41: { n: "PtgMemFunc", f: parse_PtgMemFunc },
    42: { n: "PtgRefErr", f: parse_PtgRefErr },
    43: { n: "PtgAreaErr", f: parse_PtgAreaErr },
    44: { n: "PtgRefN", f: parse_PtgRefN },
    45: { n: "PtgAreaN", f: parse_PtgAreaN },
    57: { n: "PtgNameX", f: parse_PtgNameX },
    58: { n: "PtgRef3d", f: parse_PtgRef3d },
    59: { n: "PtgArea3d", f: parse_PtgArea3d },
    60: { n: "PtgRefErr3d", f: parse_PtgRefErr3d },
    61: { n: "PtgAreaErr3d", f: parse_PtgAreaErr3d },
    255: {},
  };
  var PtgDupes = {
    64: 32,
    96: 32,
    65: 33,
    97: 33,
    66: 34,
    98: 34,
    67: 35,
    99: 35,
    68: 36,
    100: 36,
    69: 37,
    101: 37,
    70: 38,
    102: 38,
    71: 39,
    103: 39,
    72: 40,
    104: 40,
    73: 41,
    105: 41,
    74: 42,
    106: 42,
    75: 43,
    107: 43,
    76: 44,
    108: 44,
    77: 45,
    109: 45,
    89: 57,
    121: 57,
    90: 58,
    122: 58,
    91: 59,
    123: 59,
    92: 60,
    124: 60,
    93: 61,
    125: 61,
  };
  (function () {
    for (var y in PtgDupes) PtgTypes[y] = PtgTypes[PtgDupes[y]];
  })();
  var Ptg18 = {};
  var Ptg19 = {
    1: { n: "PtgAttrSemi", f: parse_PtgAttrSemi },
    2: { n: "PtgAttrIf", f: parse_PtgAttrIf },
    4: { n: "PtgAttrChoose", f: parse_PtgAttrChoose },
    8: { n: "PtgAttrGoto", f: parse_PtgAttrGoto },
    16: { n: "PtgAttrSum", f: parse_PtgAttrSum },
    32: { n: "PtgAttrBaxcel", f: parse_PtgAttrBaxcel },
    64: { n: "PtgAttrSpace", f: parse_PtgAttrSpace },
    65: { n: "PtgAttrSpaceSemi", f: parse_PtgAttrSpaceSemi },
    255: {},
  };
  var rc_to_a1 = (function () {
    var rcregex = /(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g;
    var rcbase;
    function rcfunc($$, $1, $2, $3, $4, $5) {
      var R = $3.length > 0 ? parseInt($3, 10) | 0 : 0,
        C = $5.length > 0 ? parseInt($5, 10) | 0 : 0;
      if (C < 0 && $4.length === 0) C = 0;
      var cRel = false,
        rRel = false;
      if ($4.length > 0 || $5.length == 0) cRel = true;
      if (cRel) C += rcbase.c;
      else --C;
      if ($2.length > 0 || $3.length == 0) rRel = true;
      if (rRel) R += rcbase.r;
      else --R;
      return (
        $1 +
        (cRel ? "" : "$") +
        encode_col(C) +
        (rRel ? "" : "$") +
        encode_row(R)
      );
    }
    return function rc_to_a1(fstr, base) {
      rcbase = base;
      return fstr.replace(rcregex, rcfunc);
    };
  })();
  function parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = parse_Cell(blob, 6);
    if (opts.biff == 2) ++blob.l;
    var val = parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
      blob.read_shift(1);
      if (opts.biff >= 5) {
        var chn = blob.read_shift(4);
      }
    }
    var cbf = parse_CellParsedFormula(blob, end - blob.l, opts);
    return {
      cell: cell,
      val: val[0],
      formula: cbf,
      shared: (flags >> 3) & 1,
      tt: val[1],
    };
  }
  function parse_FormulaValue(blob) {
    var b;
    if (__readUInt16LE(blob, blob.l + 6) !== 65535)
      return [parse_Xnum(blob), "n"];
    switch (blob[blob.l]) {
      case 0:
        blob.l += 8;
        return ["String", "s"];
      case 1:
        b = blob[blob.l + 2] === 1;
        blob.l += 8;
        return [b, "b"];
      case 2:
        b = blob[blob.l + 2];
        blob.l += 8;
        return [b, "e"];
      case 3:
        blob.l += 8;
        return ["", "s"];
    }
    return [];
  }
  function parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for (var i = 0; i !== rgce.length; ++i) {
      switch (rgce[i][0]) {
        case "PtgArray":
          rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
          o.push(rgce[i][1]);
          break;
        case "PtgMemArea":
          rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1]);
          o.push(rgce[i][2]);
          break;
        default:
          break;
      }
    }
    length = target - blob.l;
    if (length !== 0) o.push(parsenoop(blob, length));
    return o;
  }
  function parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l)
      rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [rgce, rgcb];
  }
  function parse_CellParsedFormula(blob, length, opts) {
    var target = blob.l + length,
      len = opts.biff == 2 ? 1 : 2;
    var rgcb,
      cce = blob.read_shift(len);
    if (cce == 65535) return [[], parsenoop(blob, length - 2)];
    var rgce = parse_Rgce(blob, cce, opts);
    if (length !== cce + len)
      rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
    return [rgce, rgcb];
  }
  function parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb,
      cce = blob.read_shift(2);
    var rgce = parse_Rgce(blob, cce, opts);
    if (cce == 65535) return [[], parsenoop(blob, length - 2)];
    if (length !== cce + 2)
      rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [rgce, rgcb];
  }
  function parse_ArrayParsedFormula(blob, length, opts, ref) {
    var target = blob.l + length,
      len = opts.biff == 2 ? 1 : 2;
    var rgcb,
      cce = blob.read_shift(len);
    if (cce == 65535) return [[], parsenoop(blob, length - 2)];
    var rgce = parse_Rgce(blob, cce, opts);
    if (length !== cce + len)
      rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [rgce, rgcb];
  }
  function parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R,
      id,
      ptgs = [];
    while (target != blob.l) {
      length = target - blob.l;
      id = blob[blob.l];
      R = PtgTypes[id];
      if (id === 24 || id === 25) {
        id = blob[blob.l + 1];
        R = (id === 24 ? Ptg18 : Ptg19)[id];
      }
      if (!R || !R.f) {
        ptgs.push(parsenoop(blob, length));
      } else {
        ptgs.push([R.n, R.f(blob, length, opts)]);
      }
    }
    return ptgs;
  }
  function stringify_array(f) {
    var o = [];
    for (var i = 0; i < f.length; ++i) {
      var x = f[i],
        r = [];
      for (var j = 0; j < x.length; ++j) {
        var y = x[j];
        if (y)
          switch (y[0]) {
            case 2:
              r.push('"' + y[1].replace(/"/g, '""') + '"');
              break;
            default:
              r.push(y[1]);
          }
        else r.push("");
      }
      o.push(r.join(","));
    }
    return o.join(";");
  }
  var PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-",
  };
  function stringify_formula(formula, range, cell, supbooks, opts) {
    var _range = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    var stack = [],
      e1,
      e2,
      type,
      c,
      ixti,
      nameidx,
      r,
      sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1,
      sp = "";
    for (var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
      var f = formula[0][ff];
      switch (f[0]) {
        case "PtgUminus":
          stack.push("-" + stack.pop());
          break;
        case "PtgUplus":
          stack.push("+" + stack.pop());
          break;
        case "PtgPercent":
          stack.push(stack.pop() + "%");
          break;
        case "PtgAdd":
        case "PtgConcat":
        case "PtgDiv":
        case "PtgEq":
        case "PtgGe":
        case "PtgGt":
        case "PtgLe":
        case "PtgLt":
        case "PtgMul":
        case "PtgNe":
        case "PtgPower":
        case "PtgSub":
          e1 = stack.pop();
          e2 = stack.pop();
          if (last_sp >= 0) {
            switch (formula[0][last_sp][1][0]) {
              case 0:
                sp = fill(" ", formula[0][last_sp][1][1]);
                break;
              case 1:
                sp = fill("\r", formula[0][last_sp][1][1]);
                break;
              default:
                sp = "";
                if (opts.WTF)
                  throw new Error(
                    "Unexpected PtgSpace type " + formula[0][last_sp][1][0]
                  );
            }
            e2 = e2 + sp;
            last_sp = -1;
          }
          stack.push(e2 + PtgBinOp[f[0]] + e1);
          break;
        case "PtgIsect":
          e1 = stack.pop();
          e2 = stack.pop();
          stack.push(e2 + " " + e1);
          break;
        case "PtgUnion":
          e1 = stack.pop();
          e2 = stack.pop();
          stack.push(e2 + "," + e1);
          break;
        case "PtgRange":
          e1 = stack.pop();
          e2 = stack.pop();
          stack.push(e2 + ":" + e1);
          break;
        case "PtgAttrChoose":
          break;
        case "PtgAttrGoto":
          break;
        case "PtgAttrIf":
          break;
        case "PtgRef":
          type = f[1][0];
          c = shift_cell(f[1][1], _range, opts);
          stack.push(encode_cell_xls(c));
          break;
        case "PtgRefN":
          type = f[1][0];
          c = shift_cell(f[1][1], cell, opts);
          stack.push(encode_cell_xls(c));
          break;
        case "PtgRef3d":
          type = f[1][0];
          ixti = f[1][1];
          c = shift_cell(f[1][2], _range, opts);
          sname =
            supbooks && supbooks[1] ? supbooks[1][ixti + 1] : "**MISSING**";
          stack.push(sname + "!" + encode_cell(c));
          break;
        case "PtgFunc":
        case "PtgFuncVar":
          var argc = f[1][0],
            func = f[1][1];
          if (!argc) argc = 0;
          var args = argc == 0 ? [] : stack.slice(-argc);
          stack.length -= argc;
          if (func === "User") func = args.shift();
          stack.push(func + "(" + args.join(",") + ")");
          break;
        case "PtgBool":
          stack.push(f[1] ? "TRUE" : "FALSE");
          break;
        case "PtgInt":
          stack.push(f[1]);
          break;
        case "PtgNum":
          stack.push(String(f[1]));
          break;
        case "PtgStr":
          stack.push('"' + f[1] + '"');
          break;
        case "PtgErr":
          stack.push(f[1]);
          break;
        case "PtgArea":
          type = f[1][0];
          r = shift_range(f[1][1], _range);
          stack.push(encode_range_xls(r));
          break;
        case "PtgArea3d":
          type = f[1][0];
          ixti = f[1][1];
          r = f[1][2];
          sname =
            supbooks && supbooks[1] ? supbooks[1][ixti + 1] : "**MISSING**";
          stack.push(sname + "!" + encode_range(r));
          break;
        case "PtgAttrSum":
          stack.push("SUM(" + stack.pop() + ")");
          break;
        case "PtgAttrSemi":
          break;
        case "PtgName":
          nameidx = f[1][2];
          var lbl = supbooks[0][nameidx];
          var name = lbl ? lbl.Name : "**MISSING**" + nameidx;
          if (name in XLSXFutureFunctions) name = XLSXFutureFunctions[name];
          stack.push(name);
          break;
        case "PtgNameX":
          var bookidx = f[1][1];
          nameidx = f[1][2];
          var externbook;
          if (opts.biff == 5) {
            if (bookidx < 0) bookidx = -bookidx;
            if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
          } else {
            if (supbooks[bookidx + 1])
              externbook = supbooks[bookidx + 1][nameidx];
            else if (supbooks[bookidx - 1])
              externbook = supbooks[bookidx - 1][nameidx];
          }
          if (!externbook) externbook = { body: "??NAMEX??" };
          stack.push(externbook.body);
          break;
        case "PtgParen":
          var lp = "(",
            rp = ")";
          if (last_sp >= 0) {
            sp = "";
            switch (formula[0][last_sp][1][0]) {
              case 2:
                lp = fill(" ", formula[0][last_sp][1][1]) + lp;
                break;
              case 3:
                lp = fill("\r", formula[0][last_sp][1][1]) + lp;
                break;
              case 4:
                rp = fill(" ", formula[0][last_sp][1][1]) + lp;
                break;
              case 5:
                rp = fill("\r", formula[0][last_sp][1][1]) + lp;
                break;
              default:
                if (opts.WTF)
                  throw new Error(
                    "Unexpected PtgSpace type " + formula[0][last_sp][1][0]
                  );
            }
            last_sp = -1;
          }
          stack.push(lp + stack.pop() + rp);
          break;
        case "PtgRefErr":
          stack.push("#REF!");
          break;
        case "PtgExp":
          c = { c: f[1][1], r: f[1][0] };
          var q = { c: cell.c, r: cell.r };
          if (supbooks.sharedf[encode_cell(c)]) {
            var parsedf = supbooks.sharedf[encode_cell(c)];
            stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
          } else {
            var fnd = false;
            for (e1 = 0; e1 != supbooks.arrayf.length; ++e1) {
              e2 = supbooks.arrayf[e1];
              if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
              if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
              stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
              fnd = true;
              break;
            }
            if (!fnd) stack.push(f[1]);
          }
          break;
        case "PtgArray":
          stack.push("{" + stringify_array(f[1]) + "}");
          break;
        case "PtgMemArea":
          break;
        case "PtgAttrSpace":
        case "PtgAttrSpaceSemi":
          last_sp = ff;
          break;
        case "PtgTbl":
          break;
        case "PtgMemErr":
          break;
        case "PtgMissArg":
          stack.push("");
          break;
        case "PtgAreaErr":
          break;
        case "PtgAreaN":
          stack.push("");
          break;
        case "PtgRefErr3d":
          break;
        case "PtgMemFunc":
          break;
        default:
          throw "Unrecognized Formula Token: " + f;
      }
      var PtgNonDisp = ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"];
      if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
        f = formula[0][last_sp];
        switch (f[1][0]) {
          case 0:
            sp = fill(" ", f[1][1]);
            break;
          case 1:
            sp = fill("\r", f[1][1]);
            break;
          default:
            sp = "";
            if (opts.WTF)
              throw new Error("Unexpected PtgSpace type " + f[1][0]);
        }
        stack.push(sp + stack.pop());
        last_sp = -1;
      }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    return stack[0];
  }
  var PtgDataType = { 1: "REFERENCE", 2: "VALUE", 3: "ARRAY" };
  var Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS",
  };
  var Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS",
  };
  var FtabArgc = {
    2: 1,
    3: 1,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    90: 1,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    416: 1,
    449: 2,
    450: 2,
    65535: 0,
  };
  var XLSXFutureFunctions = {
    "_xlfn.ACOT": "ACOT",
    "_xlfn.ACOTH": "ACOTH",
    "_xlfn.AGGREGATE": "AGGREGATE",
    "_xlfn.ARABIC": "ARABIC",
    "_xlfn.AVERAGEIF": "AVERAGEIF",
    "_xlfn.AVERAGEIFS": "AVERAGEIFS",
    "_xlfn.BASE": "BASE",
    "_xlfn.BETA.DIST": "BETA.DIST",
    "_xlfn.BETA.INV": "BETA.INV",
    "_xlfn.BINOM.DIST": "BINOM.DIST",
    "_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
    "_xlfn.BINOM.INV": "BINOM.INV",
    "_xlfn.BITAND": "BITAND",
    "_xlfn.BITLSHIFT": "BITLSHIFT",
    "_xlfn.BITOR": "BITOR",
    "_xlfn.BITRSHIFT": "BITRSHIFT",
    "_xlfn.BITXOR": "BITXOR",
    "_xlfn.CEILING.MATH": "CEILING.MATH",
    "_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
    "_xlfn.CHISQ.DIST": "CHISQ.DIST",
    "_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
    "_xlfn.CHISQ.INV": "CHISQ.INV",
    "_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
    "_xlfn.CHISQ.TEST": "CHISQ.TEST",
    "_xlfn.COMBINA": "COMBINA",
    "_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
    "_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
    "_xlfn.COT": "COT",
    "_xlfn.COTH": "COTH",
    "_xlfn.COUNTIFS": "COUNTIFS",
    "_xlfn.COVARIANCE.P": "COVARIANCE.P",
    "_xlfn.COVARIANCE.S": "COVARIANCE.S",
    "_xlfn.CSC": "CSC",
    "_xlfn.CSCH": "CSCH",
    "_xlfn.DAYS": "DAYS",
    "_xlfn.DECIMAL": "DECIMAL",
    "_xlfn.ECMA.CEILING": "ECMA.CEILING",
    "_xlfn.ERF.PRECISE": "ERF.PRECISE",
    "_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
    "_xlfn.EXPON.DIST": "EXPON.DIST",
    "_xlfn.F.DIST": "F.DIST",
    "_xlfn.F.DIST.RT": "F.DIST.RT",
    "_xlfn.F.INV": "F.INV",
    "_xlfn.F.INV.RT": "F.INV.RT",
    "_xlfn.F.TEST": "F.TEST",
    "_xlfn.FILTERXML": "FILTERXML",
    "_xlfn.FLOOR.MATH": "FLOOR.MATH",
    "_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
    "_xlfn.FORMULATEXT": "FORMULATEXT",
    "_xlfn.GAMMA": "GAMMA",
    "_xlfn.GAMMA.DIST": "GAMMA.DIST",
    "_xlfn.GAMMA.INV": "GAMMA.INV",
    "_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
    "_xlfn.GAUSS": "GAUSS",
    "_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
    "_xlfn.IFNA": "IFNA",
    "_xlfn.IFERROR": "IFERROR",
    "_xlfn.IMCOSH": "IMCOSH",
    "_xlfn.IMCOT": "IMCOT",
    "_xlfn.IMCSC": "IMCSC",
    "_xlfn.IMCSCH": "IMCSCH",
    "_xlfn.IMSEC": "IMSEC",
    "_xlfn.IMSECH": "IMSECH",
    "_xlfn.IMSINH": "IMSINH",
    "_xlfn.IMTAN": "IMTAN",
    "_xlfn.ISFORMULA": "ISFORMULA",
    "_xlfn.ISO.CEILING": "ISO.CEILING",
    "_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
    "_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
    "_xlfn.LOGNORM.INV": "LOGNORM.INV",
    "_xlfn.MODE.MULT": "MODE.MULT",
    "_xlfn.MODE.SNGL": "MODE.SNGL",
    "_xlfn.MUNIT": "MUNIT",
    "_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
    "_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
    "_xlfn.NIGBINOM": "NIGBINOM",
    "_xlfn.NORM.DIST": "NORM.DIST",
    "_xlfn.NORM.INV": "NORM.INV",
    "_xlfn.NORM.S.DIST": "NORM.S.DIST",
    "_xlfn.NORM.S.INV": "NORM.S.INV",
    "_xlfn.NUMBERVALUE": "NUMBERVALUE",
    "_xlfn.PDURATION": "PDURATION",
    "_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
    "_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
    "_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
    "_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
    "_xlfn.PERMUTATIONA": "PERMUTATIONA",
    "_xlfn.PHI": "PHI",
    "_xlfn.POISSON.DIST": "POISSON.DIST",
    "_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
    "_xlfn.QUARTILE.INC": "QUARTILE.INC",
    "_xlfn.QUERYSTRING": "QUERYSTRING",
    "_xlfn.RANK.AVG": "RANK.AVG",
    "_xlfn.RANK.EQ": "RANK.EQ",
    "_xlfn.RRI": "RRI",
    "_xlfn.SEC": "SEC",
    "_xlfn.SECH": "SECH",
    "_xlfn.SHEET": "SHEET",
    "_xlfn.SHEETS": "SHEETS",
    "_xlfn.SKEW.P": "SKEW.P",
    "_xlfn.STDEV.P": "STDEV.P",
    "_xlfn.STDEV.S": "STDEV.S",
    "_xlfn.SUMIFS": "SUMIFS",
    "_xlfn.T.DIST": "T.DIST",
    "_xlfn.T.DIST.2T": "T.DIST.2T",
    "_xlfn.T.DIST.RT": "T.DIST.RT",
    "_xlfn.T.INV": "T.INV",
    "_xlfn.T.INV.2T": "T.INV.2T",
    "_xlfn.T.TEST": "T.TEST",
    "_xlfn.UNICHAR": "UNICHAR",
    "_xlfn.UNICODE": "UNICODE",
    "_xlfn.VAR.P": "VAR.P",
    "_xlfn.VAR.S": "VAR.S",
    "_xlfn.WEBSERVICE": "WEBSERVICE",
    "_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
    "_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
    "_xlfn.XOR": "XOR",
    "_xlfn.Z.TEST": "Z.TEST",
  };
  function parse_Theme(blob, length) {
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    blob.l += length - 4;
  }
  function parse_ColorTheme(blob, length) {
    return blob.read_shift(4);
  }
  function parse_FullColorExt(blob, length) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch (o.xclrType) {
      case 0:
        blob.l += 4;
        break;
      case 1:
        o.xclrValue = parse_IcvXF(blob, 4);
        break;
      case 2:
        o.xclrValue = parse_LongRGBA(blob, 4);
        break;
      case 3:
        o.xclrValue = parse_ColorTheme(blob, 4);
        break;
      case 4:
        blob.l += 4;
        break;
    }
    blob.l += 8;
    return o;
  }
  function parse_IcvXF(blob, length) {
    return parsenoop(blob, length);
  }
  function parse_XFExtGradient(blob, length) {
    return parsenoop(blob, length);
  }
  function parse_ExtProp(blob, length) {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2);
    var o = [extType];
    switch (extType) {
      case 4:
      case 5:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
      case 13:
        o[1] = parse_FullColorExt(blob, cb);
        break;
      case 6:
        o[1] = parse_XFExtGradient(blob, cb);
        break;
      case 14:
      case 15:
        o[1] = blob.read_shift(cb === 5 ? 1 : 2);
        break;
      default:
        throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
  }
  function parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext = [];
    while (cexts-- > 0) ext.push(parse_ExtProp(blob, end - blob.l));
    return { ixfe: ixfe, ext: ext };
  }
  function update_xfext(xf, xfext) {
    xfext.forEach(function (xfe) {
      switch (xfe[0]) {
        case 4:
          break;
        case 5:
          break;
        case 7:
        case 8:
        case 9:
        case 10:
          break;
        case 13:
          break;
        case 14:
          break;
        default:
          throw "bafuq" + xfe[0].toString(16);
      }
    });
  }
  var RecordEnum = {
    3: { n: "BIFF2NUM", f: parse_BIFF2NUM },
    4: { n: "BIFF2STR", f: parse_BIFF2STR },
    6: { n: "Formula", f: parse_Formula },
    9: { n: "BOF", f: parse_BOF },
    10: { n: "EOF", f: parse_EOF },
    12: { n: "CalcCount", f: parse_CalcCount },
    13: { n: "CalcMode", f: parse_CalcMode },
    14: { n: "CalcPrecision", f: parse_CalcPrecision },
    15: { n: "CalcRefMode", f: parse_CalcRefMode },
    16: { n: "CalcDelta", f: parse_CalcDelta },
    17: { n: "CalcIter", f: parse_CalcIter },
    18: { n: "Protect", f: parse_Protect },
    19: { n: "Password", f: parse_Password },
    20: { n: "Header", f: parse_Header },
    21: { n: "Footer", f: parse_Footer },
    23: { n: "ExternSheet", f: parse_ExternSheet },
    24: { n: "Lbl", f: parse_Lbl },
    25: { n: "WinProtect", f: parse_WinProtect },
    26: { n: "VerticalPageBreaks", f: parse_VerticalPageBreaks },
    27: { n: "HorizontalPageBreaks", f: parse_HorizontalPageBreaks },
    28: { n: "Note", f: parse_Note },
    29: { n: "Selection", f: parse_Selection },
    34: { n: "Date1904", f: parse_Date1904 },
    35: { n: "ExternName", f: parse_ExternName },
    38: { n: "LeftMargin", f: parse_LeftMargin },
    39: { n: "RightMargin", f: parse_RightMargin },
    40: { n: "TopMargin", f: parse_TopMargin },
    41: { n: "BottomMargin", f: parse_BottomMargin },
    42: { n: "PrintRowCol", f: parse_PrintRowCol },
    43: { n: "PrintGrid", f: parse_PrintGrid },
    47: { n: "FilePass", f: parse_FilePass },
    49: { n: "Font", f: parse_Font },
    51: { n: "PrintSize", f: parse_PrintSize },
    60: { n: "Continue", f: parse_Continue },
    61: { n: "Window1", f: parse_Window1 },
    64: { n: "Backup", f: parse_Backup },
    65: { n: "Pane", f: parse_Pane },
    66: { n: "CodePage", f: parse_CodePage },
    77: { n: "Pls", f: parse_Pls },
    80: { n: "DCon", f: parse_DCon },
    81: { n: "DConRef", f: parse_DConRef },
    82: { n: "DConName", f: parse_DConName },
    85: { n: "DefColWidth", f: parse_DefColWidth },
    89: { n: "XCT", f: parse_XCT },
    90: { n: "CRN", f: parse_CRN },
    91: { n: "FileSharing", f: parse_FileSharing },
    92: { n: "WriteAccess", f: parse_WriteAccess },
    93: { n: "Obj", f: parse_Obj },
    94: { n: "Uncalced", f: parse_Uncalced },
    95: { n: "CalcSaveRecalc", f: parse_CalcSaveRecalc },
    96: { n: "Template", f: parse_Template },
    97: { n: "Intl", f: parse_Intl },
    99: { n: "ObjProtect", f: parse_ObjProtect },
    125: { n: "ColInfo", f: parse_ColInfo },
    128: { n: "Guts", f: parse_Guts },
    129: { n: "WsBool", f: parse_WsBool },
    130: { n: "GridSet", f: parse_GridSet },
    131: { n: "HCenter", f: parse_HCenter },
    132: { n: "VCenter", f: parse_VCenter },
    133: { n: "BoundSheet8", f: parse_BoundSheet8 },
    134: { n: "WriteProtect", f: parse_WriteProtect },
    140: { n: "Country", f: parse_Country },
    141: { n: "HideObj", f: parse_HideObj },
    144: { n: "Sort", f: parse_Sort },
    146: { n: "Palette", f: parse_Palette },
    151: { n: "Sync", f: parse_Sync },
    152: { n: "LPr", f: parse_LPr },
    153: { n: "DxGCol", f: parse_DxGCol },
    154: { n: "FnGroupName", f: parse_FnGroupName },
    155: { n: "FilterMode", f: parse_FilterMode },
    156: { n: "BuiltInFnGroupCount", f: parse_BuiltInFnGroupCount },
    157: { n: "AutoFilterInfo", f: parse_AutoFilterInfo },
    158: { n: "AutoFilter", f: parse_AutoFilter },
    160: { n: "Scl", f: parse_Scl },
    161: { n: "Setup", f: parse_Setup },
    174: { n: "ScenMan", f: parse_ScenMan },
    175: { n: "SCENARIO", f: parse_SCENARIO },
    176: { n: "SxView", f: parse_SxView },
    177: { n: "Sxvd", f: parse_Sxvd },
    178: { n: "SXVI", f: parse_SXVI },
    180: { n: "SxIvd", f: parse_SxIvd },
    181: { n: "SXLI", f: parse_SXLI },
    182: { n: "SXPI", f: parse_SXPI },
    184: { n: "DocRoute", f: parse_DocRoute },
    185: { n: "RecipName", f: parse_RecipName },
    189: { n: "MulRk", f: parse_MulRk },
    190: { n: "MulBlank", f: parse_MulBlank },
    193: { n: "Mms", f: parse_Mms },
    197: { n: "SXDI", f: parse_SXDI },
    198: { n: "SXDB", f: parse_SXDB },
    199: { n: "SXFDB", f: parse_SXFDB },
    200: { n: "SXDBB", f: parse_SXDBB },
    201: { n: "SXNum", f: parse_SXNum },
    202: { n: "SxBool", f: parse_SxBool },
    203: { n: "SxErr", f: parse_SxErr },
    204: { n: "SXInt", f: parse_SXInt },
    205: { n: "SXString", f: parse_SXString },
    206: { n: "SXDtr", f: parse_SXDtr },
    207: { n: "SxNil", f: parse_SxNil },
    208: { n: "SXTbl", f: parse_SXTbl },
    209: { n: "SXTBRGIITM", f: parse_SXTBRGIITM },
    210: { n: "SxTbpg", f: parse_SxTbpg },
    211: { n: "ObProj", f: parse_ObProj },
    213: { n: "SXStreamID", f: parse_SXStreamID },
    215: { n: "DBCell", f: parse_DBCell },
    216: { n: "SXRng", f: parse_SXRng },
    217: { n: "SxIsxoper", f: parse_SxIsxoper },
    218: { n: "BookBool", f: parse_BookBool },
    220: { n: "DbOrParamQry", f: parse_DbOrParamQry },
    221: { n: "ScenarioProtect", f: parse_ScenarioProtect },
    222: { n: "OleObjectSize", f: parse_OleObjectSize },
    224: { n: "XF", f: parse_XF },
    225: { n: "InterfaceHdr", f: parse_InterfaceHdr },
    226: { n: "InterfaceEnd", f: parse_InterfaceEnd },
    227: { n: "SXVS", f: parse_SXVS },
    229: { n: "MergeCells", f: parse_MergeCells },
    233: { n: "BkHim", f: parse_BkHim },
    235: { n: "MsoDrawingGroup", f: parse_MsoDrawingGroup },
    236: { n: "MsoDrawing", f: parse_MsoDrawing },
    237: { n: "MsoDrawingSelection", f: parse_MsoDrawingSelection },
    239: { n: "PhoneticInfo", f: parse_PhoneticInfo },
    240: { n: "SxRule", f: parse_SxRule },
    241: { n: "SXEx", f: parse_SXEx },
    242: { n: "SxFilt", f: parse_SxFilt },
    244: { n: "SxDXF", f: parse_SxDXF },
    245: { n: "SxItm", f: parse_SxItm },
    246: { n: "SxName", f: parse_SxName },
    247: { n: "SxSelect", f: parse_SxSelect },
    248: { n: "SXPair", f: parse_SXPair },
    249: { n: "SxFmla", f: parse_SxFmla },
    251: { n: "SxFormat", f: parse_SxFormat },
    252: { n: "SST", f: parse_SST },
    253: { n: "LabelSst", f: parse_LabelSst },
    255: { n: "ExtSST", f: parse_ExtSST },
    256: { n: "SXVDEx", f: parse_SXVDEx },
    259: { n: "SXFormula", f: parse_SXFormula },
    290: { n: "SXDBEx", f: parse_SXDBEx },
    311: { n: "RRDInsDel", f: parse_RRDInsDel },
    312: { n: "RRDHead", f: parse_RRDHead },
    315: { n: "RRDChgCell", f: parse_RRDChgCell },
    317: { n: "RRTabId", f: parse_RRTabId },
    318: { n: "RRDRenSheet", f: parse_RRDRenSheet },
    319: { n: "RRSort", f: parse_RRSort },
    320: { n: "RRDMove", f: parse_RRDMove },
    330: { n: "RRFormat", f: parse_RRFormat },
    331: { n: "RRAutoFmt", f: parse_RRAutoFmt },
    333: { n: "RRInsertSh", f: parse_RRInsertSh },
    334: { n: "RRDMoveBegin", f: parse_RRDMoveBegin },
    335: { n: "RRDMoveEnd", f: parse_RRDMoveEnd },
    336: { n: "RRDInsDelBegin", f: parse_RRDInsDelBegin },
    337: { n: "RRDInsDelEnd", f: parse_RRDInsDelEnd },
    338: { n: "RRDConflict", f: parse_RRDConflict },
    339: { n: "RRDDefName", f: parse_RRDDefName },
    340: { n: "RRDRstEtxp", f: parse_RRDRstEtxp },
    351: { n: "LRng", f: parse_LRng },
    352: { n: "UsesELFs", f: parse_UsesELFs },
    353: { n: "DSF", f: parse_DSF },
    401: { n: "CUsr", f: parse_CUsr },
    402: { n: "CbUsr", f: parse_CbUsr },
    403: { n: "UsrInfo", f: parse_UsrInfo },
    404: { n: "UsrExcl", f: parse_UsrExcl },
    405: { n: "FileLock", f: parse_FileLock },
    406: { n: "RRDInfo", f: parse_RRDInfo },
    407: { n: "BCUsrs", f: parse_BCUsrs },
    408: { n: "UsrChk", f: parse_UsrChk },
    425: { n: "UserBView", f: parse_UserBView },
    426: { n: "UserSViewBegin", f: parse_UserSViewBegin },
    427: { n: "UserSViewEnd", f: parse_UserSViewEnd },
    428: { n: "RRDUserView", f: parse_RRDUserView },
    429: { n: "Qsi", f: parse_Qsi },
    430: { n: "SupBook", f: parse_SupBook },
    431: { n: "Prot4Rev", f: parse_Prot4Rev },
    432: { n: "CondFmt", f: parse_CondFmt },
    433: { n: "CF", f: parse_CF },
    434: { n: "DVal", f: parse_DVal },
    437: { n: "DConBin", f: parse_DConBin },
    438: { n: "TxO", f: parse_TxO },
    439: { n: "RefreshAll", f: parse_RefreshAll },
    440: { n: "HLink", f: parse_HLink },
    441: { n: "Lel", f: parse_Lel },
    442: { n: "CodeName", f: parse_CodeName },
    443: { n: "SXFDBType", f: parse_SXFDBType },
    444: { n: "Prot4RevPass", f: parse_Prot4RevPass },
    445: { n: "ObNoMacros", f: parse_ObNoMacros },
    446: { n: "Dv", f: parse_Dv },
    448: { n: "Excel9File", f: parse_Excel9File },
    449: { n: "RecalcId", f: parse_RecalcId, r: 2 },
    450: { n: "EntExU2", f: parse_EntExU2 },
    512: { n: "Dimensions", f: parse_Dimensions },
    513: { n: "Blank", f: parse_Blank },
    515: { n: "Number", f: parse_Number },
    516: { n: "Label", f: parse_Label },
    517: { n: "BoolErr", f: parse_BoolErr },
    518: { n: "Formula", f: parse_Formula },
    519: { n: "String", f: parse_String },
    520: { n: "Row", f: parse_Row },
    523: { n: "Index", f: parse_Index },
    545: { n: "Array", f: parse_Array },
    549: { n: "DefaultRowHeight", f: parse_DefaultRowHeight },
    566: { n: "Table", f: parse_Table },
    574: { n: "Window2", f: parse_Window2 },
    638: { n: "RK", f: parse_RK },
    659: { n: "Style", f: parse_Style },
    1030: { n: "Formula", f: parse_Formula },
    1048: { n: "BigName", f: parse_BigName },
    1054: { n: "Format", f: parse_Format },
    1084: { n: "ContinueBigName", f: parse_ContinueBigName },
    1212: { n: "ShrFmla", f: parse_ShrFmla },
    2048: { n: "HLinkTooltip", f: parse_HLinkTooltip },
    2049: { n: "WebPub", f: parse_WebPub },
    2050: { n: "QsiSXTag", f: parse_QsiSXTag },
    2051: { n: "DBQueryExt", f: parse_DBQueryExt },
    2052: { n: "ExtString", f: parse_ExtString },
    2053: { n: "TxtQry", f: parse_TxtQry },
    2054: { n: "Qsir", f: parse_Qsir },
    2055: { n: "Qsif", f: parse_Qsif },
    2056: { n: "RRDTQSIF", f: parse_RRDTQSIF },
    2057: { n: "BOF", f: parse_BOF },
    2058: { n: "OleDbConn", f: parse_OleDbConn },
    2059: { n: "WOpt", f: parse_WOpt },
    2060: { n: "SXViewEx", f: parse_SXViewEx },
    2061: { n: "SXTH", f: parse_SXTH },
    2062: { n: "SXPIEx", f: parse_SXPIEx },
    2063: { n: "SXVDTEx", f: parse_SXVDTEx },
    2064: { n: "SXViewEx9", f: parse_SXViewEx9 },
    2066: { n: "ContinueFrt", f: parse_ContinueFrt },
    2067: { n: "RealTimeData", f: parse_RealTimeData },
    2128: { n: "ChartFrtInfo", f: parse_ChartFrtInfo },
    2129: { n: "FrtWrapper", f: parse_FrtWrapper },
    2130: { n: "StartBlock", f: parse_StartBlock },
    2131: { n: "EndBlock", f: parse_EndBlock },
    2132: { n: "StartObject", f: parse_StartObject },
    2133: { n: "EndObject", f: parse_EndObject },
    2134: { n: "CatLab", f: parse_CatLab },
    2135: { n: "YMult", f: parse_YMult },
    2136: { n: "SXViewLink", f: parse_SXViewLink },
    2137: { n: "PivotChartBits", f: parse_PivotChartBits },
    2138: { n: "FrtFontList", f: parse_FrtFontList },
    2146: { n: "SheetExt", f: parse_SheetExt },
    2147: { n: "BookExt", f: parse_BookExt, r: 12 },
    2148: { n: "SXAddl", f: parse_SXAddl },
    2149: { n: "CrErr", f: parse_CrErr },
    2150: { n: "HFPicture", f: parse_HFPicture },
    2151: { n: "FeatHdr", f: parse_FeatHdr },
    2152: { n: "Feat", f: parse_Feat },
    2154: { n: "DataLabExt", f: parse_DataLabExt },
    2155: { n: "DataLabExtContents", f: parse_DataLabExtContents },
    2156: { n: "CellWatch", f: parse_CellWatch },
    2161: { n: "FeatHdr11", f: parse_FeatHdr11 },
    2162: { n: "Feature11", f: parse_Feature11 },
    2164: { n: "DropDownObjIds", f: parse_DropDownObjIds },
    2165: { n: "ContinueFrt11", f: parse_ContinueFrt11 },
    2166: { n: "DConn", f: parse_DConn },
    2167: { n: "List12", f: parse_List12 },
    2168: { n: "Feature12", f: parse_Feature12 },
    2169: { n: "CondFmt12", f: parse_CondFmt12 },
    2170: { n: "CF12", f: parse_CF12 },
    2171: { n: "CFEx", f: parse_CFEx },
    2172: { n: "XFCRC", f: parse_XFCRC, r: 12 },
    2173: { n: "XFExt", f: parse_XFExt, r: 12 },
    2174: { n: "AutoFilter12", f: parse_AutoFilter12 },
    2175: { n: "ContinueFrt12", f: parse_ContinueFrt12 },
    2180: { n: "MDTInfo", f: parse_MDTInfo },
    2181: { n: "MDXStr", f: parse_MDXStr },
    2182: { n: "MDXTuple", f: parse_MDXTuple },
    2183: { n: "MDXSet", f: parse_MDXSet },
    2184: { n: "MDXProp", f: parse_MDXProp },
    2185: { n: "MDXKPI", f: parse_MDXKPI },
    2186: { n: "MDB", f: parse_MDB },
    2187: { n: "PLV", f: parse_PLV },
    2188: { n: "Compat12", f: parse_Compat12, r: 12 },
    2189: { n: "DXF", f: parse_DXF },
    2190: { n: "TableStyles", f: parse_TableStyles, r: 12 },
    2191: { n: "TableStyle", f: parse_TableStyle },
    2192: { n: "TableStyleElement", f: parse_TableStyleElement },
    2194: { n: "StyleExt", f: parse_StyleExt },
    2195: { n: "NamePublish", f: parse_NamePublish },
    2196: { n: "NameCmt", f: parse_NameCmt },
    2197: { n: "SortData", f: parse_SortData },
    2198: { n: "Theme", f: parse_Theme, r: 12 },
    2199: { n: "GUIDTypeLib", f: parse_GUIDTypeLib },
    2200: { n: "FnGrp12", f: parse_FnGrp12 },
    2201: { n: "NameFnGrp12", f: parse_NameFnGrp12 },
    2202: { n: "MTRSettings", f: parse_MTRSettings, r: 12 },
    2203: { n: "CompressPictures", f: parse_CompressPictures },
    2204: { n: "HeaderFooter", f: parse_HeaderFooter },
    2205: { n: "CrtLayout12", f: parse_CrtLayout12 },
    2206: { n: "CrtMlFrt", f: parse_CrtMlFrt },
    2207: { n: "CrtMlFrtContinue", f: parse_CrtMlFrtContinue },
    2211: { n: "ForceFullCalculation", f: parse_ForceFullCalculation },
    2212: { n: "ShapePropsStream", f: parse_ShapePropsStream },
    2213: { n: "TextPropsStream", f: parse_TextPropsStream },
    2214: { n: "RichTextStream", f: parse_RichTextStream },
    2215: { n: "CrtLayout12A", f: parse_CrtLayout12A },
    4097: { n: "Units", f: parse_Units },
    4098: { n: "Chart", f: parse_Chart },
    4099: { n: "Series", f: parse_Series },
    4102: { n: "DataFormat", f: parse_DataFormat },
    4103: { n: "LineFormat", f: parse_LineFormat },
    4105: { n: "MarkerFormat", f: parse_MarkerFormat },
    4106: { n: "AreaFormat", f: parse_AreaFormat },
    4107: { n: "PieFormat", f: parse_PieFormat },
    4108: { n: "AttachedLabel", f: parse_AttachedLabel },
    4109: { n: "SeriesText", f: parse_SeriesText },
    4116: { n: "ChartFormat", f: parse_ChartFormat },
    4117: { n: "Legend", f: parse_Legend },
    4118: { n: "SeriesList", f: parse_SeriesList },
    4119: { n: "Bar", f: parse_Bar },
    4120: { n: "Line", f: parse_Line },
    4121: { n: "Pie", f: parse_Pie },
    4122: { n: "Area", f: parse_Area },
    4123: { n: "Scatter", f: parse_Scatter },
    4124: { n: "CrtLine", f: parse_CrtLine },
    4125: { n: "Axis", f: parse_Axis },
    4126: { n: "Tick", f: parse_Tick },
    4127: { n: "ValueRange", f: parse_ValueRange },
    4128: { n: "CatSerRange", f: parse_CatSerRange },
    4129: { n: "AxisLine", f: parse_AxisLine },
    4130: { n: "CrtLink", f: parse_CrtLink },
    4132: { n: "DefaultText", f: parse_DefaultText },
    4133: { n: "Text", f: parse_Text },
    4134: { n: "FontX", f: parse_FontX },
    4135: { n: "ObjectLink", f: parse_ObjectLink },
    4146: { n: "Frame", f: parse_Frame },
    4147: { n: "Begin", f: parse_Begin },
    4148: { n: "End", f: parse_End },
    4149: { n: "PlotArea", f: parse_PlotArea },
    4154: { n: "Chart3d", f: parse_Chart3d },
    4156: { n: "PicF", f: parse_PicF },
    4157: { n: "DropBar", f: parse_DropBar },
    4158: { n: "Radar", f: parse_Radar },
    4159: { n: "Surf", f: parse_Surf },
    4160: { n: "RadarArea", f: parse_RadarArea },
    4161: { n: "AxisParent", f: parse_AxisParent },
    4163: { n: "LegendException", f: parse_LegendException },
    4164: { n: "ShtProps", f: parse_ShtProps },
    4165: { n: "SerToCrt", f: parse_SerToCrt },
    4166: { n: "AxesUsed", f: parse_AxesUsed },
    4168: { n: "SBaseRef", f: parse_SBaseRef },
    4170: { n: "SerParent", f: parse_SerParent },
    4171: { n: "SerAuxTrend", f: parse_SerAuxTrend },
    4174: { n: "IFmtRecord", f: parse_IFmtRecord },
    4175: { n: "Pos", f: parse_Pos },
    4176: { n: "AlRuns", f: parse_AlRuns },
    4177: { n: "BRAI", f: parse_BRAI },
    4187: { n: "SerAuxErrBar", f: parse_SerAuxErrBar },
    4188: { n: "ClrtClient", f: parse_ClrtClient },
    4189: { n: "SerFmt", f: parse_SerFmt },
    4191: { n: "Chart3DBarShape", f: parse_Chart3DBarShape },
    4192: { n: "Fbi", f: parse_Fbi },
    4193: { n: "BopPop", f: parse_BopPop },
    4194: { n: "AxcExt", f: parse_AxcExt },
    4195: { n: "Dat", f: parse_Dat },
    4196: { n: "PlotGrowth", f: parse_PlotGrowth },
    4197: { n: "SIIndex", f: parse_SIIndex },
    4198: { n: "GelFrame", f: parse_GelFrame },
    4199: { n: "BopPopCustom", f: parse_BopPopCustom },
    4200: { n: "Fbi2", f: parse_Fbi2 },
    0: { n: "Dimensions", f: parse_Dimensions },
    2: { n: "BIFF2INT", f: parse_BIFF2INT },
    5: { n: "BoolErr", f: parse_BoolErr },
    7: { n: "String", f: parse_BIFF2STRING },
    8: { n: "BIFF2ROW", f: parsenoop },
    11: { n: "Index", f: parse_Index },
    30: { n: "BIFF2FORMAT", f: parse_BIFF2Format },
    31: { n: "BIFF2FMTCNT", f: parsenoop },
    22: { n: "ExternCount", f: parsenoop },
    33: { n: "Array", f: parse_Array },
    37: { n: "DefaultRowHeight", f: parse_DefaultRowHeight },
    50: { n: "BIFF2FONTXTRA", f: parse_BIFF2FONTXTRA },
    62: { n: "BIFF2WINDOW2", f: parsenoop },
    69: { n: "BIFF2FONTCLR", f: parsenoop },
    86: { n: "BIFF4FMTCNT", f: parsenoop },
    126: { n: "RK", f: parsenoop },
    127: { n: "ImData", f: parsenoop },
    135: { n: "Addin", f: parsenoop },
    136: { n: "Edg", f: parsenoop },
    137: { n: "Pub", f: parsenoop },
    145: { n: "Sub", f: parsenoop },
    148: { n: "LHRecord", f: parsenoop },
    149: { n: "LHNGraph", f: parsenoop },
    150: { n: "Sound", f: parsenoop },
    169: { n: "CoordList", f: parsenoop },
    171: { n: "GCW", f: parsenoop },
    188: { n: "ShrFmla", f: parsenoop },
    194: { n: "AddMenu", f: parsenoop },
    195: { n: "DelMenu", f: parsenoop },
    214: { n: "RString", f: parse_RString },
    223: { n: "UDDesc", f: parsenoop },
    234: { n: "TabIdConf", f: parsenoop },
    354: { n: "XL5Modify", f: parsenoop },
    421: { n: "FileSharing2", f: parsenoop },
    521: { n: "BOF", f: parse_BOF },
    536: { n: "Lbl", f: parse_Lbl },
    547: { n: "ExternName", f: parse_ExternName },
    561: { n: "Font", f: parsenoop },
    1033: { n: "BOF", f: parse_BOF },
    2157: { n: "FeatInfo", f: parsenoop },
    2163: { n: "FeatInfo11", f: parsenoop },
    2177: { n: "SXAddl12", f: parsenoop },
    2240: { n: "AutoWebPub", f: parsenoop },
    2241: { n: "ListObj", f: parsenoop },
    2242: { n: "ListField", f: parsenoop },
    2243: { n: "ListDV", f: parsenoop },
    2244: { n: "ListCondFmt", f: parsenoop },
    2245: { n: "ListCF", f: parsenoop },
    2246: { n: "FMQry", f: parsenoop },
    2247: { n: "FMSQry", f: parsenoop },
    2248: { n: "PLV", f: parsenoop },
    2249: { n: "LnExt", f: parsenoop },
    2250: { n: "MkrExt", f: parsenoop },
    2251: { n: "CrtCoopt", f: parsenoop },
    67: { n: "BIFF2XF", f: parsenoop },
    579: { n: "BIFF3XF", f: parsenoop },
    1091: { n: "BIFF4XF", f: parsenoop },
    29282: {},
  };
  var CountryEnum = {
    1: "US",
    2: "CA",
    3: "",
    7: "RU",
    20: "EG",
    30: "GR",
    31: "NL",
    32: "BE",
    33: "FR",
    34: "ES",
    36: "HU",
    39: "IT",
    41: "CH",
    43: "AT",
    44: "GB",
    45: "DK",
    46: "SE",
    47: "NO",
    48: "PL",
    49: "DE",
    52: "MX",
    55: "BR",
    61: "AU",
    64: "NZ",
    66: "TH",
    81: "JP",
    82: "KR",
    84: "VN",
    86: "CN",
    90: "TR",
    105: "JS",
    213: "DZ",
    216: "MA",
    218: "LY",
    351: "PT",
    354: "IS",
    358: "FI",
    420: "CZ",
    886: "TW",
    961: "LB",
    962: "JO",
    963: "SY",
    964: "IQ",
    965: "KW",
    966: "SA",
    971: "AE",
    972: "IL",
    974: "QA",
    981: "IR",
    65535: "US",
  };
  function fix_opts_func(defaults) {
    return function fix_opts(opts) {
      for (var i = 0; i != defaults.length; ++i) {
        var d = defaults[i];
        if (opts[d[0]] === undefined) opts[d[0]] = d[1];
        if (d[2] === "n") opts[d[0]] = Number(opts[d[0]]);
      }
    };
  }
  var fix_read_opts = fix_opts_func([
    ["cellNF", false],
    ["cellFormula", true],
    ["cellStyles", false],
    ["sheetRows", 0, "n"],
    ["bookSheets", false],
    ["bookProps", false],
    ["bookFiles", false],
    ["password", ""],
    ["WTF", false],
  ]);
  function parse_compobj(obj) {
    var v = {};
    var o = obj.content;
    var l = 28,
      m;
    m = __lpstr(o, l);
    l += 4 + __readUInt32LE(o, l);
    v.UserType = m;
    m = __readUInt32LE(o, l);
    l += 4;
    switch (m) {
      case 0:
        break;
      case 4294967295:
      case 4294967294:
        l += 4;
        break;
      default:
        if (m > 400)
          throw new Error("Unsupported Clipboard: " + m.toString(16));
        l += m;
    }
    m = __lpstr(o, l);
    l += m.length === 0 ? 0 : 5 + m.length;
    v.Reserved1 = m;
    if ((m = __readUInt32LE(o, l)) !== 1907550708) return v;
    throw new Error("Unsupported Unicode Extension");
  }
  function slurp(R, blob, length, opts) {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu_decrypt)
      switch (R.n) {
        case "BOF":
        case "FilePass":
        case "FileLock":
        case "InterfaceHdr":
        case "RRDInfo":
        case "RRDHead":
        case "UsrExcl":
          break;
        default:
          if (d.length === 0) break;
          opts.enc.insitu_decrypt(d);
      }
    bufs.push(d);
    blob.l += l;
    var next = RecordEnum[__readUInt16LE(blob, blob.l)];
    while (next != null && next.n === "Continue") {
      l = __readUInt16LE(blob, blob.l + 2);
      bufs.push(blob.slice(blob.l + 4, blob.l + 4 + l));
      blob.l += 4 + l;
      next = RecordEnum[__readUInt16LE(blob, blob.l)];
    }
    var b = bconcat(bufs);
    prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for (var j = 0; j < bufs.length; ++j) {
      b.lens.push(ll);
      ll += bufs[j].length;
    }
    return R.f(b, b.length, opts);
  }
  function safe_format_xf(p, opts, date1904) {
    if (p.t === "e") {
      p.w = p.w || BErr[p.v];
    }
    if (!p.XF) return;
    try {
      var fmtid = p.XF.ifmt || 0;
      if (p.t === "e");
      else if (fmtid === 0) {
        if (p.t === "n") {
          if ((p.v | 0) === p.v) p.w = SSF._general_int(p.v);
          else p.w = SSF._general_num(p.v);
        } else p.w = SSF._general(p.v);
      } else p.w = SSF.format(fmtid, p.v, { date1904: date1904 || false });
      if (opts.cellNF) p.z = SSF._table[fmtid];
    } catch (e) {
      if (opts.WTF) throw e;
    }
  }
  function make_cell(val, ixfe, t) {
    return { v: val, ixfe: ixfe, t: t };
  }
  function parse_workbook(blob, options) {
    var wb = { opts: {} };
    var Sheets = {};
    var out = {};
    var Directory = {};
    var found_sheet = false;
    var range = {};
    var last_formula = null;
    var sst = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell, cc, cmnt, rng, rngC, rngR;
    var shared_formulae = {};
    var array_formulae = [];
    var temp_val;
    var country;
    var cell_valid = true;
    var XFs = [];
    var palette = [];
    var get_rgb = function getrgb(icv) {
      if (icv < 8) return Icv[icv];
      if (icv < 64) return palette[icv - 8] || Icv[icv];
      return Icv[icv];
    };
    var process_cell_style = function pcs(cell, line) {
      var xfd = line.XF.data;
      if (!xfd || !xfd.patternType) return;
      line.s = {};
      line.s.patternType = xfd.patternType;
      var t;
      if ((t = rgb2Hex(get_rgb(xfd.icvFore)))) {
        line.s.fgColor = { rgb: t };
      }
      if ((t = rgb2Hex(get_rgb(xfd.icvBack)))) {
        line.s.bgColor = { rgb: t };
      }
    };
    var addcell = function addcell(cell, line, options) {
      if (!cell_valid) return;
      if (options.cellStyles && line.XF && line.XF.data)
        process_cell_style(cell, line);
      lastcell = cell;
      last_cell = encode_cell(cell);
      if (range.s) {
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
      }
      if (range.e) {
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
      }
      if (options.sheetRows && lastcell.r >= options.sheetRows)
        cell_valid = false;
      else out[last_cell] = line;
    };
    var opts = {
      enc: false,
      sbcch: 0,
      snames: [],
      sharedf: shared_formulae,
      arrayf: array_formulae,
      rrtabid: [],
      lastuser: "",
      biff: 8,
      codepage: 0,
      winlocked: 0,
      wtf: false,
    };
    if (options.password) opts.password = options.password;
    var mergecells = [];
    var objects = [];
    var supbooks = [[]];
    var sbc = 0,
      sbci = 0,
      sbcli = 0;
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    var last_Rn = "";
    var file_depth = 0;
    var BIFF2Fmt = 0;
    opts.codepage = 1200;
    set_cp(1200);
    while (blob.l < blob.length - 1) {
      var s = blob.l;
      var RecordType = blob.read_shift(2);
      if (RecordType === 0 && last_Rn === "EOF") break;
      var length = blob.l === blob.length ? 0 : blob.read_shift(2),
        y;
      var R = RecordEnum[RecordType];
      if (R && R.f) {
        if (options.bookSheets) {
          if (last_Rn === "BoundSheet8" && R.n !== "BoundSheet8") break;
        }
        last_Rn = R.n;
        if (R.r === 2 || R.r == 12) {
          var rt = blob.read_shift(2);
          length -= 2;
          if (!opts.enc && rt !== RecordType) throw "rt mismatch";
          if (R.r == 12) {
            blob.l += 10;
            length -= 10;
          }
        }
        var val;
        if (R.n === "EOF") val = R.f(blob, length, opts);
        else val = slurp(R, blob, length, opts);
        var Rn = R.n;
        switch (Rn) {
          case "Date1904":
            wb.opts.Date1904 = val;
            break;
          case "WriteProtect":
            wb.opts.WriteProtect = true;
            break;
          case "FilePass":
            if (!opts.enc) blob.l = 0;
            opts.enc = val;
            if (opts.WTF) console.error(val);
            if (!options.password)
              throw new Error("File is password-protected");
            if (val.Type !== 0)
              throw new Error("Encryption scheme unsupported");
            if (!val.valid) throw new Error("Password is incorrect");
            break;
          case "WriteAccess":
            opts.lastuser = val;
            break;
          case "FileSharing":
            break;
          case "CodePage":
            if (val === 21010) val = 1200;
            else if (val === 32769) val = 1252;
            opts.codepage = val;
            set_cp(val);
            break;
          case "RRTabId":
            opts.rrtabid = val;
            break;
          case "WinProtect":
            opts.winlocked = val;
            break;
          case "Template":
            break;
          case "RefreshAll":
            wb.opts.RefreshAll = val;
            break;
          case "BookBool":
            break;
          case "UsesELFs":
            break;
          case "MTRSettings":
            {
              if (val[0] && val[1]) throw "Unsupported threads: " + val;
            }
            break;
          case "CalcCount":
            wb.opts.CalcCount = val;
            break;
          case "CalcDelta":
            wb.opts.CalcDelta = val;
            break;
          case "CalcIter":
            wb.opts.CalcIter = val;
            break;
          case "CalcMode":
            wb.opts.CalcMode = val;
            break;
          case "CalcPrecision":
            wb.opts.CalcPrecision = val;
            break;
          case "CalcSaveRecalc":
            wb.opts.CalcSaveRecalc = val;
            break;
          case "CalcRefMode":
            opts.CalcRefMode = val;
            break;
          case "Uncalced":
            break;
          case "ForceFullCalculation":
            wb.opts.FullCalc = val;
            break;
          case "WsBool":
            break;
          case "XF":
            XFs.push(val);
            break;
          case "ExtSST":
            break;
          case "BookExt":
            break;
          case "RichTextStream":
            break;
          case "BkHim":
            break;
          case "SupBook":
            supbooks[++sbc] = [val];
            sbci = 0;
            break;
          case "ExternName":
            supbooks[sbc][++sbci] = val;
            break;
          case "Index":
            break;
          case "Lbl":
            supbooks[0][++sbcli] = val;
            break;
          case "ExternSheet":
            supbooks[sbc] = supbooks[sbc].concat(val);
            sbci += val.length;
            break;
          case "Protect":
            out["!protect"] = val;
            break;
          case "Password":
            if (val !== 0 && opts.WTF)
              console.error("Password verifier: " + val);
            break;
          case "Prot4Rev":
          case "Prot4RevPass":
            break;
          case "BoundSheet8":
            {
              Directory[val.pos] = val;
              opts.snames.push(val.name);
            }
            break;
          case "EOF":
            {
              if (--file_depth) break;
              if (range.e) {
                out["!range"] = range;
                if (range.e.r > 0 && range.e.c > 0) {
                  range.e.r--;
                  range.e.c--;
                  out["!ref"] = encode_range(range);
                  range.e.r++;
                  range.e.c++;
                }
                if (mergecells.length > 0) out["!merges"] = mergecells;
                if (objects.length > 0) out["!objects"] = objects;
              }
              if (cur_sheet === "") Preamble = out;
              else Sheets[cur_sheet] = out;
              out = {};
            }
            break;
          case "BOF":
            {
              if (opts.biff !== 8) {
              } else if (val.BIFFVer === 1280) opts.biff = 5;
              else if (val.BIFFVer === 2) opts.biff = 2;
              else if (val.BIFFVer === 7) opts.biff = 2;
              else if (RecordType === 9) opts.biff = 2;
              else if (RecordType === 521) opts.biff = 3;
              else if (RecordType === 1033) opts.biff = 4;
              if (file_depth++) break;
              cell_valid = true;
              out = {};
              if (opts.biff < 5) {
                if (cur_sheet === "") cur_sheet = "Sheet1";
                range = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
                var fakebs8 = { pos: blob.l - length, name: cur_sheet };
                Directory[fakebs8.pos] = fakebs8;
                opts.snames.push(cur_sheet);
              } else cur_sheet = (Directory[s] || { name: "" }).name;
              mergecells = [];
              objects = [];
            }
            break;
          case "Number":
          case "BIFF2NUM":
          case "BIFF2INT":
            {
              temp_val = {
                ixfe: val.ixfe,
                XF: XFs[val.ixfe],
                v: val.val,
                t: "n",
              };
              safe_format_xf(temp_val, options, wb.opts.Date1904);
              addcell({ c: val.c, r: val.r }, temp_val, options);
            }
            break;
          case "BoolErr":
            {
              temp_val = {
                ixfe: val.ixfe,
                XF: XFs[val.ixfe],
                v: val.val,
                t: val.t,
              };
              safe_format_xf(temp_val, options, wb.opts.Date1904);
              addcell({ c: val.c, r: val.r }, temp_val, options);
            }
            break;
          case "RK":
            {
              temp_val = {
                ixfe: val.ixfe,
                XF: XFs[val.ixfe],
                v: val.rknum,
                t: "n",
              };
              safe_format_xf(temp_val, options, wb.opts.Date1904);
              addcell({ c: val.c, r: val.r }, temp_val, options);
            }
            break;
          case "MulRk":
            {
              for (var j = val.c; j <= val.C; ++j) {
                var ixfe = val.rkrec[j - val.c][0];
                temp_val = {
                  ixfe: ixfe,
                  XF: XFs[ixfe],
                  v: val.rkrec[j - val.c][1],
                  t: "n",
                };
                safe_format_xf(temp_val, options, wb.opts.Date1904);
                addcell({ c: j, r: val.r }, temp_val, options);
              }
            }
            break;
          case "Formula":
            {
              switch (val.val) {
                case "String":
                  last_formula = val;
                  break;
                case "Array Formula":
                  throw "Array Formula unsupported";
                default:
                  temp_val = { v: val.val, ixfe: val.cell.ixfe, t: val.tt };
                  temp_val.XF = XFs[temp_val.ixfe];
                  if (options.cellFormula) {
                    var _f = val.formula;
                    if (_f && _f[0] && _f[0][0] && _f[0][0][0] == "PtgExp") {
                      var _fr = _f[0][0][1][0],
                        _fc = _f[0][0][1][1];
                      var _fe = encode_cell({ r: _fr, c: _fc });
                      if (shared_formulae[_fe])
                        temp_val.f = stringify_formula(
                          val.formula,
                          range,
                          val.cell,
                          supbooks,
                          opts
                        );
                      else temp_val.F = (out[_fe] || {}).F;
                    } else
                      temp_val.f = stringify_formula(
                        val.formula,
                        range,
                        val.cell,
                        supbooks,
                        opts
                      );
                  }
                  safe_format_xf(temp_val, options, wb.opts.Date1904);
                  addcell(val.cell, temp_val, options);
                  last_formula = val;
              }
            }
            break;
          case "String":
            {
              if (last_formula) {
                last_formula.val = val;
                temp_val = {
                  v: last_formula.val,
                  ixfe: last_formula.cell.ixfe,
                  t: "s",
                };
                temp_val.XF = XFs[temp_val.ixfe];
                if (options.cellFormula)
                  temp_val.f = stringify_formula(
                    last_formula.formula,
                    range,
                    last_formula.cell,
                    supbooks,
                    opts
                  );
                safe_format_xf(temp_val, options, wb.opts.Date1904);
                addcell(last_formula.cell, temp_val, options);
                last_formula = null;
              }
            }
            break;
          case "Array":
            {
              array_formulae.push(val);
              if (options.cellFormula && out[last_cell]) {
                out[last_cell].f = stringify_formula(
                  last_formula.formula,
                  range,
                  last_formula.cell,
                  supbooks,
                  opts
                );
                out[last_cell].F = encode_range(val[0]);
              }
            }
            break;
          case "ShrFmla":
            {
              if (!cell_valid) break;
              if (!options.cellFormula) break;
              if (last_cell) {
                shared_formulae[encode_cell(last_formula.cell)] = val[0];
                (out[encode_cell(last_formula.cell)] || {}).f =
                  stringify_formula(val[0], range, lastcell, supbooks, opts);
              }
            }
            break;
          case "LabelSst":
            temp_val = make_cell(sst[val.isst].t, val.ixfe, "s");
            temp_val.XF = XFs[temp_val.ixfe];
            safe_format_xf(temp_val, options, wb.opts.Date1904);
            addcell({ c: val.c, r: val.r }, temp_val, options);
            break;
          case "RString":
          case "Label":
          case "BIFF2STR":
            temp_val = make_cell(val.val, val.ixfe, "s");
            temp_val.XF = XFs[temp_val.ixfe];
            safe_format_xf(temp_val, options, wb.opts.Date1904);
            addcell({ c: val.c, r: val.r }, temp_val, options);
            break;
          case "Dimensions":
            {
              if (file_depth === 1) range = val;
            }
            break;
          case "SST":
            {
              sst = val;
            }
            break;
          case "Format":
            {
              SSF.load(val[1], val[0]);
            }
            break;
          case "BIFF2FORMAT":
            {
              SSF.load(val, BIFF2Fmt++);
            }
            break;
          case "MergeCells":
            mergecells = mergecells.concat(val);
            break;
          case "Obj":
            objects[val.cmo[0]] = opts.lastobj = val;
            break;
          case "TxO":
            opts.lastobj.TxO = val;
            break;
          case "HLink":
            {
              for (rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
                for (rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC)
                  if (out[encode_cell({ c: rngC, r: rngR })])
                    out[encode_cell({ c: rngC, r: rngR })].l = val[1];
            }
            break;
          case "HLinkTooltip":
            {
              for (rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
                for (rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC)
                  if (out[encode_cell({ c: rngC, r: rngR })])
                    out[encode_cell({ c: rngC, r: rngR })].l.tooltip = val[1];
            }
            break;
          case "Note":
            {
              if (opts.biff <= 5 && opts.biff >= 2) break;
              cc = out[encode_cell(val[0])];
              var noteobj = objects[val[2]];
              if (!cc) break;
              if (!cc.c) cc.c = [];
              cmnt = { a: val[1], t: noteobj.TxO.t };
              cc.c.push(cmnt);
            }
            break;
          default:
            switch (R.n) {
              case "ClrtClient":
                break;
              case "XFExt":
                update_xfext(XFs[val.ixfe], val.ext);
                break;
              case "NameCmt":
                break;
              case "Header":
                break;
              case "Footer":
                break;
              case "HCenter":
                break;
              case "VCenter":
                break;
              case "Pls":
                break;
              case "Setup":
                break;
              case "DefColWidth":
                break;
              case "GCW":
                break;
              case "LHRecord":
                break;
              case "ColInfo":
                break;
              case "Row":
                break;
              case "DBCell":
                break;
              case "MulBlank":
                break;
              case "EntExU2":
                break;
              case "SxView":
                break;
              case "Sxvd":
                break;
              case "SXVI":
                break;
              case "SXVDEx":
                break;
              case "SxIvd":
                break;
              case "SXDI":
                break;
              case "SXLI":
                break;
              case "SXEx":
                break;
              case "QsiSXTag":
                break;
              case "Selection":
                break;
              case "Feat":
                break;
              case "FeatHdr":
              case "FeatHdr11":
                break;
              case "Feature11":
              case "Feature12":
              case "List12":
                break;
              case "Blank":
                break;
              case "Country":
                country = val;
                break;
              case "RecalcId":
                break;
              case "DefaultRowHeight":
              case "DxGCol":
                break;
              case "Fbi":
              case "Fbi2":
              case "GelFrame":
                break;
              case "Font":
                break;
              case "XFCRC":
                break;
              case "Style":
                break;
              case "StyleExt":
                break;
              case "Palette":
                palette = val;
                break;
              case "Theme":
                break;
              case "ScenarioProtect":
                break;
              case "ObjProtect":
                break;
              case "CondFmt12":
                break;
              case "Table":
                break;
              case "TableStyles":
                break;
              case "TableStyle":
                break;
              case "TableStyleElement":
                break;
              case "SXStreamID":
                break;
              case "SXVS":
                break;
              case "DConRef":
                break;
              case "SXAddl":
                break;
              case "DConBin":
                break;
              case "DConName":
                break;
              case "SXPI":
                break;
              case "SxFormat":
                break;
              case "SxSelect":
                break;
              case "SxRule":
                break;
              case "SxFilt":
                break;
              case "SxItm":
                break;
              case "SxDXF":
                break;
              case "ScenMan":
                break;
              case "DCon":
                break;
              case "CellWatch":
                break;
              case "PrintRowCol":
                break;
              case "PrintGrid":
                break;
              case "PrintSize":
                break;
              case "XCT":
                break;
              case "CRN":
                break;
              case "Scl":
                {
                }
                break;
              case "SheetExt":
                {
                }
                break;
              case "SheetExtOptional":
                {
                }
                break;
              case "ObNoMacros":
                {
                }
                break;
              case "ObProj":
                {
                }
                break;
              case "CodeName":
                {
                }
                break;
              case "GUIDTypeLib":
                {
                }
                break;
              case "WOpt":
                break;
              case "PhoneticInfo":
                break;
              case "OleObjectSize":
                break;
              case "DXF":
              case "DXFN":
              case "DXFN12":
              case "DXFN12List":
              case "DXFN12NoCB":
                break;
              case "Dv":
              case "DVal":
                break;
              case "BRAI":
              case "Series":
              case "SeriesText":
                break;
              case "DConn":
                break;
              case "DbOrParamQry":
                break;
              case "DBQueryExt":
                break;
              case "IFmtRecord":
                break;
              case "CondFmt":
              case "CF":
              case "CF12":
              case "CFEx":
                break;
              case "Excel9File":
                break;
              case "Units":
                break;
              case "InterfaceHdr":
              case "Mms":
              case "InterfaceEnd":
              case "DSF":
              case "BuiltInFnGroupCount":
              case "Window1":
              case "Window2":
              case "HideObj":
              case "GridSet":
              case "Guts":
              case "UserBView":
              case "UserSViewBegin":
              case "UserSViewEnd":
              case "Pane":
                break;
              default:
                switch (R.n) {
                  case "Dat":
                  case "Begin":
                  case "End":
                  case "StartBlock":
                  case "EndBlock":
                  case "Frame":
                  case "Area":
                  case "Axis":
                  case "AxisLine":
                  case "Tick":
                    break;
                  case "AxesUsed":
                  case "CrtLayout12":
                  case "CrtLayout12A":
                  case "CrtLink":
                  case "CrtLine":
                  case "CrtMlFrt":
                  case "CrtMlFrtContinue":
                    break;
                  case "LineFormat":
                  case "AreaFormat":
                  case "Chart":
                  case "Chart3d":
                  case "Chart3DBarShape":
                  case "ChartFormat":
                  case "ChartFrtInfo":
                    break;
                  case "PlotArea":
                  case "PlotGrowth":
                    break;
                  case "SeriesList":
                  case "SerParent":
                  case "SerAuxTrend":
                    break;
                  case "DataFormat":
                  case "SerToCrt":
                  case "FontX":
                    break;
                  case "CatSerRange":
                  case "AxcExt":
                  case "SerFmt":
                    break;
                  case "ShtProps":
                    break;
                  case "DefaultText":
                  case "Text":
                  case "CatLab":
                    break;
                  case "DataLabExtContents":
                    break;
                  case "Legend":
                  case "LegendException":
                    break;
                  case "Pie":
                  case "Scatter":
                    break;
                  case "PieFormat":
                  case "MarkerFormat":
                    break;
                  case "StartObject":
                  case "EndObject":
                    break;
                  case "AlRuns":
                  case "ObjectLink":
                    break;
                  case "SIIndex":
                    break;
                  case "AttachedLabel":
                  case "YMult":
                    break;
                  case "Line":
                  case "Bar":
                    break;
                  case "Surf":
                    break;
                  case "AxisParent":
                    break;
                  case "Pos":
                    break;
                  case "ValueRange":
                    break;
                  case "SXViewEx9":
                    break;
                  case "SXViewLink":
                    break;
                  case "PivotChartBits":
                    break;
                  case "SBaseRef":
                    break;
                  case "TextPropsStream":
                    break;
                  case "LnExt":
                    break;
                  case "MkrExt":
                    break;
                  case "CrtCoopt":
                    break;
                  case "Qsi":
                  case "Qsif":
                  case "Qsir":
                  case "QsiSXTag":
                    break;
                  case "TxtQry":
                    break;
                  case "FilterMode":
                    break;
                  case "AutoFilter":
                  case "AutoFilterInfo":
                    break;
                  case "AutoFilter12":
                    break;
                  case "DropDownObjIds":
                    break;
                  case "Sort":
                    break;
                  case "SortData":
                    break;
                  case "ShapePropsStream":
                    break;
                  case "MsoDrawing":
                  case "MsoDrawingGroup":
                  case "MsoDrawingSelection":
                    break;
                  case "ImData":
                    break;
                  case "WebPub":
                  case "AutoWebPub":
                  case "RightMargin":
                  case "LeftMargin":
                  case "TopMargin":
                  case "BottomMargin":
                  case "HeaderFooter":
                  case "HFPicture":
                  case "PLV":
                  case "HorizontalPageBreaks":
                  case "VerticalPageBreaks":
                  case "Backup":
                  case "CompressPictures":
                  case "Compat12":
                    break;
                  case "Continue":
                  case "ContinueFrt12":
                    break;
                  case "FrtFontList":
                  case "FrtWrapper":
                    break;
                  default:
                    switch (R.n) {
                      case "ExternCount":
                        break;
                      case "TabIdConf":
                      case "Radar":
                      case "RadarArea":
                      case "DropBar":
                      case "Intl":
                      case "CoordList":
                      case "SerAuxErrBar":
                        break;
                      case "BIFF2FONTCLR":
                      case "BIFF2FMTCNT":
                      case "BIFF2FONTXTRA":
                        break;
                      case "BIFF2XF":
                      case "BIFF3XF":
                      case "BIFF4XF":
                        break;
                      case "BIFF4FMTCNT":
                      case "BIFF2ROW":
                      case "BIFF2WINDOW2":
                        break;
                      case "SCENARIO":
                      case "DConBin":
                      case "PicF":
                      case "DataLabExt":
                      case "Lel":
                      case "BopPop":
                      case "BopPopCustom":
                      case "RealTimeData":
                      case "Name":
                        break;
                      default:
                        if (options.WTF) throw "Unrecognized Record " + R.n;
                    }
                }
            }
        }
      } else blob.l += length;
    }
    var sheetnamesraw = Object.keys(Directory)
      .sort(function (a, b) {
        return Number(a) - Number(b);
      })
      .map(function (x) {
        return Directory[x].name;
      });
    var sheetnames = sheetnamesraw.slice();
    wb.Directory = sheetnamesraw;
    wb.SheetNames = sheetnamesraw;
    if (!options.bookSheets) wb.Sheets = Sheets;
    wb.Preamble = Preamble;
    wb.Strings = sst;
    wb.SSF = SSF.get_table();
    if (opts.enc) wb.Encryption = opts.enc;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    return wb;
  }
  function parse_xlscfb(cfb, options) {
    if (!options) options = {};
    fix_read_opts(options);
    reset_cp();
    var CompObj, Summary, Workbook;
    if (cfb.FullPaths) {
      CompObj = cfb.find("!CompObj");
      Summary = cfb.find("!SummaryInformation");
      Workbook = cfb.find("/Workbook");
    } else {
      prep_blob(cfb, 0);
      Workbook = { content: cfb };
    }
    if (!Workbook) Workbook = cfb.find("/Book");
    var CompObjP, SummaryP, WorkbookP;
    if (CompObj) CompObjP = parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {};
    else {
      if (Workbook)
        WorkbookP = parse_workbook(Workbook.content, options, !!Workbook.find);
      else throw new Error("Cannot find Workbook stream");
    }
    if (cfb.FullPaths) parse_props(cfb);
    var props = {};
    for (var y in cfb.Summary) props[y] = cfb.Summary[y];
    for (y in cfb.DocSummary) props[y] = cfb.DocSummary[y];
    WorkbookP.Props = WorkbookP.Custprops = props;
    if (options.bookFiles) WorkbookP.cfb = cfb;
    WorkbookP.CompObjP = CompObjP;
    return WorkbookP;
  }
  function parse_props(cfb) {
    var DSI = cfb.find("!DocumentSummaryInformation");
    if (DSI)
      try {
        cfb.DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI);
      } catch (e) {}
    var SI = cfb.find("!SummaryInformation");
    if (SI)
      try {
        cfb.Summary = parse_PropertySetStream(SI, SummaryPIDSI);
      } catch (e) {}
  }
  var encregex = /&[a-z]*;/g,
    coderegex = /_x([0-9a-fA-F]+)_/g;
  function coderepl(m, c) {
    return _chr(parseInt(c, 16));
  }
  function encrepl($$) {
    return encodings[$$];
  }
  function unescapexml(s) {
    if (s.indexOf("&") > -1) s = s.replace(encregex, encrepl);
    return s.indexOf("_") === -1 ? s : s.replace(coderegex, coderepl);
  }
  function parsexmlbool(value, tag) {
    switch (value) {
      case "1":
      case "true":
      case "TRUE":
        return true;
      default:
        return false;
    }
  }
  function matchtag(f, g) {
    return new RegExp(
      "<" + f + '(?: xml:space="preserve")?>([^☃]*)</' + f + ">",
      (g || "") + "m"
    );
  }
  var entregex = /&#(\d+);/g;
  function entrepl($$, $1) {
    return String.fromCharCode(parseInt($1, 10));
  }
  function fixstr(str) {
    return str.replace(entregex, entrepl);
  }
  var XLMLFormatMap = {
    "General Number": "General",
    "General Date": SSF._table[22],
    "Long Date": "dddd, mmmm dd, yyyy",
    "Medium Date": SSF._table[15],
    "Short Date": SSF._table[14],
    "Long Time": SSF._table[19],
    "Medium Time": SSF._table[18],
    "Short Time": SSF._table[20],
    Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    Fixed: SSF._table[2],
    Standard: SSF._table[4],
    Percent: SSF._table[10],
    Scientific: SSF._table[11],
    "Yes/No": '"Yes";"Yes";"No";@',
    "True/False": '"True";"True";"False";@',
    "On/Off": '"Yes";"Yes";"No";@',
  };
  var PatternTypeMap = {
    None: "none",
    Solid: "solid",
    Gray50: "mediumGray",
    Gray75: "darkGray",
    Gray25: "lightGray",
    HorzStripe: "darkHorizontal",
    VertStripe: "darkVertical",
    ReverseDiagStripe: "darkDown",
    DiagStripe: "darkUp",
    DiagCross: "darkGrid",
    ThickDiagCross: "darkTrellis",
    ThinHorzStripe: "lightHorizontal",
    ThinVertStripe: "lightVertical",
    ThinReverseDiagStripe: "lightDown",
    ThinHorzCross: "lightGrid",
  };
  function xlml_set_prop(Props, tag, val) {
    switch (tag) {
      case "Description":
        tag = "Comments";
        break;
    }
    Props[tag] = val;
  }
  function xlml_format(format, value) {
    var fmt = XLMLFormatMap[format] || unescapexml(format);
    if (fmt === "General") return SSF._general(value);
    return SSF.format(fmt, value);
  }
  function xlml_set_custprop(Custprops, Rn, cp, val) {
    switch ((cp[0].match(/dt:dt="([\w.]+)"/) || ["", ""])[1]) {
      case "boolean":
        val = parsexmlbool(val);
        break;
      case "i2":
      case "int":
        val = parseInt(val, 10);
        break;
      case "r4":
      case "float":
        val = parseFloat(val);
        break;
      case "date":
      case "dateTime.tz":
        val = new Date(val);
        break;
      case "i8":
      case "string":
      case "fixed":
      case "uuid":
      case "bin.base64":
        break;
      default:
        throw "bad custprop:" + cp[0];
    }
    Custprops[unescapexml(Rn[3])] = val;
  }
  function safe_format_xlml(cell, nf, o) {
    try {
      if (cell.t === "e") {
        cell.w = cell.w || BErr[cell.v];
      } else if (nf === "General") {
        if (cell.t === "n") {
          if ((cell.v | 0) === cell.v) cell.w = SSF._general_int(cell.v);
          else cell.w = SSF._general_num(cell.v);
        } else cell.w = SSF._general(cell.v);
      } else cell.w = xlml_format(nf || "General", cell.v);
      if (o.cellNF) cell.z = XLMLFormatMap[nf] || nf || "General";
    } catch (e) {
      if (o.WTF) throw e;
    }
  }
  function process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
      if (stag.Interior) {
        var I = stag.Interior;
        if (I.Pattern) I.patternType = PatternTypeMap[I.Pattern] || I.Pattern;
      }
    }
    styles[stag.ID] = stag;
  }
  function parse_xlml_data(
    xml,
    ss,
    data,
    cell,
    base,
    styles,
    csty,
    row,
    arrayf,
    o
  ) {
    var nf = "General",
      sid = cell.StyleID,
      S = {};
    o = o || {};
    var interiors = [];
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while (styles[sid] !== undefined) {
      if (styles[sid].nf) nf = styles[sid].nf;
      if (styles[sid].Interior) interiors.push(styles[sid].Interior);
      if (!styles[sid].Parent) break;
      sid = styles[sid].Parent;
    }
    switch (data.Type) {
      case "Boolean":
        cell.t = "b";
        cell.v = parsexmlbool(xml);
        break;
      case "String":
        cell.t = "s";
        cell.r = fixstr(unescapexml(xml));
        cell.v = xml.indexOf("<") > -1 ? unescapexml(ss) : cell.r;
        break;
      case "DateTime":
        cell.v =
          (Date.parse(xml) - new Date(Date.UTC(1899, 11, 30))) /
          (24 * 60 * 60 * 1e3);
        if (cell.v !== cell.v) cell.v = unescapexml(xml);
        else if (cell.v >= 1 && cell.v < 60) cell.v = cell.v - 1;
        if (!nf || nf == "General") nf = "yyyy-mm-dd";
      case "Number":
        if (cell.v === undefined) cell.v = +xml;
        if (!cell.t) cell.t = "n";
        break;
      case "Error":
        cell.t = "e";
        cell.v = RBErr[xml];
        cell.w = xml;
        break;
      default:
        cell.t = "s";
        cell.v = fixstr(ss);
        break;
    }
    safe_format_xlml(cell, nf, o);
    if (o.cellFormula != null) {
      if (cell.Formula) {
        var fstr = unescapexml(cell.Formula);
        if (fstr.charCodeAt(0) == 61) fstr = fstr.substr(1);
        cell.f = rc_to_a1(fstr, base);
        cell.Formula = undefined;
        if (cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
        else if (cell.ArrayRange) {
          cell.F = rc_to_a1(cell.ArrayRange, base);
          arrayf.push([safe_decode_range(cell.F), cell.F]);
        }
      } else {
        for (i = 0; i < arrayf.length; ++i)
          if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
            if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
              cell.F = arrayf[i][1];
      }
    }
    if (o.cellStyles) {
      interiors.forEach(function (x) {
        if (!S.patternType && x.patternType) S.patternType = x.patternType;
      });
      cell.s = S;
    }
    cell.ixfe = cell.StyleID !== undefined ? cell.StyleID : "Default";
  }
  function xlml_clean_comment(comment) {
    comment.t = comment.v;
    comment.v = comment.w = comment.ixfe = undefined;
  }
  function xlml_normalize(d) {
    if (has_buf && Buffer.isBuffer(d)) return d.toString("utf8");
    if (typeof d === "string") return d;
    throw new Error("Bad input format: expected Buffer or string");
  }
  var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/gm;
  function parse_xlml_xml(d, opts) {
    var str = debom(xlml_normalize(d));
    var Rn;
    var state = [],
      tmp;
    var sheets = {},
      sheetnames = [],
      cursheet = {},
      sheetname = "";
    var table = {},
      cell = {},
      row = {};
    var dtag = parsexmltag('<Data ss:Type="String">'),
      didx = 0;
    var c = 0,
      r = 0;
    var refguess = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
    var styles = {},
      stag = {};
    var ss = "",
      fidx = 0;
    var mergecells = [];
    var Props = {},
      Custprops = {},
      pidx = 0,
      cp = {};
    var comments = [],
      comment = {};
    var cstys = [],
      csty;
    var arrayf = [];
    xlmlregex.lastIndex = 0;
    while ((Rn = xlmlregex.exec(str)))
      switch (Rn[3]) {
        case "Data":
          if (state[state.length - 1][1]) break;
          if (Rn[1] === "/")
            parse_xlml_data(
              str.slice(didx, Rn.index),
              ss,
              dtag,
              state[state.length - 1][0] == "Comment" ? comment : cell,
              { c: c, r: r },
              styles,
              cstys[c],
              row,
              arrayf,
              opts
            );
          else {
            ss = "";
            dtag = parsexmltag(Rn[0]);
            didx = Rn.index + Rn[0].length;
          }
          break;
        case "Cell":
          if (Rn[1] === "/") {
            if (comments.length > 0) cell.c = comments;
            if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined)
              cursheet[encode_col(c) + encode_row(r)] = cell;
            if (cell.HRef) {
              cell.l = { Target: cell.HRef, tooltip: cell.HRefScreenTip };
              cell.HRef = cell.HRefScreenTip = undefined;
            }
            if (cell.MergeAcross || cell.MergeDown) {
              var cc = c + (parseInt(cell.MergeAcross, 10) | 0);
              var rr = r + (parseInt(cell.MergeDown, 10) | 0);
              mergecells.push({ s: { c: c, r: r }, e: { c: cc, r: rr } });
            }
            ++c;
            if (cell.MergeAcross) c += +cell.MergeAcross;
          } else {
            cell = parsexmltagobj(Rn[0]);
            if (cell.Index) c = +cell.Index - 1;
            if (c < refguess.s.c) refguess.s.c = c;
            if (c > refguess.e.c) refguess.e.c = c;
            if (Rn[0].slice(-2) === "/>") ++c;
            comments = [];
          }
          break;
        case "Row":
          if (Rn[1] === "/" || Rn[0].slice(-2) === "/>") {
            if (r < refguess.s.r) refguess.s.r = r;
            if (r > refguess.e.r) refguess.e.r = r;
            if (Rn[0].slice(-2) === "/>") {
              row = parsexmltag(Rn[0]);
              if (row.Index) r = +row.Index - 1;
            }
            c = 0;
            ++r;
          } else {
            row = parsexmltag(Rn[0]);
            if (row.Index) r = +row.Index - 1;
          }
          break;
        case "Worksheet":
          if (Rn[1] === "/") {
            if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            sheetnames.push(sheetname);
            if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c)
              cursheet["!ref"] = encode_range(refguess);
            if (mergecells.length) cursheet["!merges"] = mergecells;
            sheets[sheetname] = cursheet;
          } else {
            refguess = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
            r = c = 0;
            state.push([Rn[3], false]);
            tmp = parsexmltag(Rn[0]);
            sheetname = tmp.Name;
            cursheet = {};
            mergecells = [];
          }
          break;
        case "Table":
          if (Rn[1] === "/") {
            if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
          } else if (Rn[0].slice(-2) == "/>") break;
          else {
            table = parsexmltag(Rn[0]);
            state.push([Rn[3], false]);
            cstys = [];
          }
          break;
        case "Style":
          if (Rn[1] === "/") process_style_xlml(styles, stag, opts);
          else stag = parsexmltag(Rn[0]);
          break;
        case "NumberFormat":
          stag.nf = parsexmltag(Rn[0]).Format || "General";
          break;
        case "Column":
          if (state[state.length - 1][0] !== "Table") break;
          csty = parsexmltag(Rn[0]);
          cstys[csty.Index - 1 || cstys.length] = csty;
          for (var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = csty;
          break;
        case "NamedRange":
          break;
        case "NamedCell":
          break;
        case "B":
          break;
        case "I":
          break;
        case "U":
          break;
        case "S":
          break;
        case "Sub":
          break;
        case "Sup":
          break;
        case "Span":
          break;
        case "Border":
          break;
        case "Alignment":
          break;
        case "Borders":
          break;
        case "Font":
          if (Rn[0].slice(-2) === "/>") break;
          else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
          else fidx = Rn.index + Rn[0].length;
          break;
        case "Interior":
          if (!opts.cellStyles) break;
          stag.Interior = parsexmltag(Rn[0]);
          break;
        case "Protection":
          break;
        case "Author":
        case "Title":
        case "Description":
        case "Created":
        case "Keywords":
        case "Subject":
        case "Category":
        case "Company":
        case "LastAuthor":
        case "LastSaved":
        case "LastPrinted":
        case "Version":
        case "Revision":
        case "TotalTime":
        case "HyperlinkBase":
        case "Manager":
          if (Rn[0].slice(-2) === "/>") break;
          else if (Rn[1] === "/")
            xlml_set_prop(Props, Rn[3], str.slice(pidx, Rn.index));
          else pidx = Rn.index + Rn[0].length;
          break;
        case "Paragraphs":
          break;
        case "Styles":
        case "Workbook":
          if (Rn[1] === "/") {
            if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
          } else state.push([Rn[3], false]);
          break;
        case "Comment":
          if (Rn[1] === "/") {
            if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            xlml_clean_comment(comment);
            comments.push(comment);
          } else {
            state.push([Rn[3], false]);
            tmp = parsexmltag(Rn[0]);
            comment = { a: tmp.Author };
          }
          break;
        case "Name":
          break;
        case "ComponentOptions":
        case "DocumentProperties":
        case "CustomDocumentProperties":
        case "OfficeDocumentSettings":
        case "PivotTable":
        case "PivotCache":
        case "Names":
        case "MapInfo":
        case "PageBreaks":
        case "QueryTable":
        case "DataValidation":
        case "AutoFilter":
        case "Sorting":
        case "Schema":
        case "data":
        case "ConditionalFormatting":
        case "SmartTagType":
        case "SmartTags":
        case "ExcelWorkbook":
        case "WorkbookOptions":
        case "WorksheetOptions":
          if (Rn[1] === "/") {
            if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
          } else if (Rn[0].charAt(Rn[0].length - 2) !== "/")
            state.push([Rn[3], true]);
          break;
        default:
          if (state.length == 0 && Rn[3] == "document")
            throw new Error("Unsupported FODS format");
          if (state.length == 0 && Rn[3] == "UOF")
            throw new Error("Unsupported UOS format");
          var seen = true;
          switch (state[state.length - 1][0]) {
            case "OfficeDocumentSettings":
              switch (Rn[3]) {
                case "AllowPNG":
                  break;
                case "RemovePersonalInformation":
                  break;
                case "DownloadComponents":
                  break;
                case "LocationOfComponents":
                  break;
                case "Colors":
                  break;
                case "Color":
                  break;
                case "Index":
                  break;
                case "RGB":
                  break;
                case "PixelsPerInch":
                  break;
                case "TargetScreenSize":
                  break;
                case "ReadOnlyRecommended":
                  break;
                default:
                  seen = false;
              }
              break;
            case "ComponentOptions":
              switch (Rn[3]) {
                case "Toolbar":
                  break;
                case "HideOfficeLogo":
                  break;
                case "SpreadsheetAutoFit":
                  break;
                case "Label":
                  break;
                case "Caption":
                  break;
                case "MaxHeight":
                  break;
                case "MaxWidth":
                  break;
                case "NextSheetNumber":
                  break;
                default:
                  seen = false;
              }
              break;
            case "ExcelWorkbook":
              switch (Rn[3]) {
                case "WindowHeight":
                  break;
                case "WindowWidth":
                  break;
                case "WindowTopX":
                  break;
                case "WindowTopY":
                  break;
                case "TabRatio":
                  break;
                case "ProtectStructure":
                  break;
                case "ProtectWindows":
                  break;
                case "ActiveSheet":
                  break;
                case "DisplayInkNotes":
                  break;
                case "FirstVisibleSheet":
                  break;
                case "SupBook":
                  break;
                case "SheetName":
                  break;
                case "SheetIndex":
                  break;
                case "SheetIndexFirst":
                  break;
                case "SheetIndexLast":
                  break;
                case "Dll":
                  break;
                case "AcceptLabelsInFormulas":
                  break;
                case "DoNotSaveLinkValues":
                  break;
                case "Date1904":
                  break;
                case "Iteration":
                  break;
                case "MaxIterations":
                  break;
                case "MaxChange":
                  break;
                case "Path":
                  break;
                case "Xct":
                  break;
                case "Count":
                  break;
                case "SelectedSheets":
                  break;
                case "Calculation":
                  break;
                case "Uncalced":
                  break;
                case "StartupPrompt":
                  break;
                case "Crn":
                  break;
                case "ExternName":
                  break;
                case "Formula":
                  break;
                case "ColFirst":
                  break;
                case "ColLast":
                  break;
                case "WantAdvise":
                  break;
                case "Boolean":
                  break;
                case "Error":
                  break;
                case "Text":
                  break;
                case "OLE":
                  break;
                case "NoAutoRecover":
                  break;
                case "PublishObjects":
                  break;
                case "DoNotCalculateBeforeSave":
                  break;
                case "Number":
                  break;
                case "RefModeR1C1":
                  break;
                case "EmbedSaveSmartTags":
                  break;
                default:
                  seen = false;
              }
              break;
            case "WorkbookOptions":
              switch (Rn[3]) {
                case "OWCVersion":
                  break;
                case "Height":
                  break;
                case "Width":
                  break;
                default:
                  seen = false;
              }
              break;
            case "WorksheetOptions":
              switch (Rn[3]) {
                case "Unsynced":
                  break;
                case "Visible":
                  break;
                case "Print":
                  break;
                case "Panes":
                  break;
                case "Scale":
                  break;
                case "Pane":
                  break;
                case "Number":
                  break;
                case "Layout":
                  break;
                case "Header":
                  break;
                case "Footer":
                  break;
                case "PageSetup":
                  break;
                case "PageMargins":
                  break;
                case "Selected":
                  break;
                case "ProtectObjects":
                  break;
                case "EnableSelection":
                  break;
                case "ProtectScenarios":
                  break;
                case "ValidPrinterInfo":
                  break;
                case "HorizontalResolution":
                  break;
                case "VerticalResolution":
                  break;
                case "NumberofCopies":
                  break;
                case "ActiveRow":
                  break;
                case "ActiveCol":
                  break;
                case "ActivePane":
                  break;
                case "TopRowVisible":
                  break;
                case "TopRowBottomPane":
                  break;
                case "LeftColumnVisible":
                  break;
                case "LeftColumnRightPane":
                  break;
                case "FitToPage":
                  break;
                case "RangeSelection":
                  break;
                case "PaperSizeIndex":
                  break;
                case "PageLayoutZoom":
                  break;
                case "PageBreakZoom":
                  break;
                case "FilterOn":
                  break;
                case "DoNotDisplayGridlines":
                  break;
                case "SplitHorizontal":
                  break;
                case "SplitVertical":
                  break;
                case "FreezePanes":
                  break;
                case "FrozenNoSplit":
                  break;
                case "FitWidth":
                  break;
                case "FitHeight":
                  break;
                case "CommentsLayout":
                  break;
                case "Zoom":
                  break;
                case "LeftToRight":
                  break;
                case "Gridlines":
                  break;
                case "AllowSort":
                  break;
                case "AllowFilter":
                  break;
                case "AllowInsertRows":
                  break;
                case "AllowDeleteRows":
                  break;
                case "AllowInsertCols":
                  break;
                case "AllowDeleteCols":
                  break;
                case "AllowInsertHyperlinks":
                  break;
                case "AllowFormatCells":
                  break;
                case "AllowSizeCols":
                  break;
                case "AllowSizeRows":
                  break;
                case "NoSummaryRowsBelowDetail":
                  break;
                case "TabColorIndex":
                  break;
                case "DoNotDisplayHeadings":
                  break;
                case "ShowPageLayoutZoom":
                  break;
                case "NoSummaryColumnsRightDetail":
                  break;
                case "BlackAndWhite":
                  break;
                case "DoNotDisplayZeros":
                  break;
                case "DisplayPageBreak":
                  break;
                case "RowColHeadings":
                  break;
                case "DoNotDisplayOutline":
                  break;
                case "NoOrientation":
                  break;
                case "AllowUsePivotTables":
                  break;
                case "ZeroHeight":
                  break;
                case "ViewableRange":
                  break;
                case "Selection":
                  break;
                case "ProtectContents":
                  break;
                default:
                  seen = false;
              }
              break;
            case "PivotTable":
            case "PivotCache":
              switch (Rn[3]) {
                case "ImmediateItemsOnDrop":
                  break;
                case "ShowPageMultipleItemLabel":
                  break;
                case "CompactRowIndent":
                  break;
                case "Location":
                  break;
                case "PivotField":
                  break;
                case "Orientation":
                  break;
                case "LayoutForm":
                  break;
                case "LayoutSubtotalLocation":
                  break;
                case "LayoutCompactRow":
                  break;
                case "Position":
                  break;
                case "PivotItem":
                  break;
                case "DataType":
                  break;
                case "DataField":
                  break;
                case "SourceName":
                  break;
                case "ParentField":
                  break;
                case "PTLineItems":
                  break;
                case "PTLineItem":
                  break;
                case "CountOfSameItems":
                  break;
                case "Item":
                  break;
                case "ItemType":
                  break;
                case "PTSource":
                  break;
                case "CacheIndex":
                  break;
                case "ConsolidationReference":
                  break;
                case "FileName":
                  break;
                case "Reference":
                  break;
                case "NoColumnGrand":
                  break;
                case "NoRowGrand":
                  break;
                case "BlankLineAfterItems":
                  break;
                case "Hidden":
                  break;
                case "Subtotal":
                  break;
                case "BaseField":
                  break;
                case "MapChildItems":
                  break;
                case "Function":
                  break;
                case "RefreshOnFileOpen":
                  break;
                case "PrintSetTitles":
                  break;
                case "MergeLabels":
                  break;
                case "DefaultVersion":
                  break;
                case "RefreshName":
                  break;
                case "RefreshDate":
                  break;
                case "RefreshDateCopy":
                  break;
                case "VersionLastRefresh":
                  break;
                case "VersionLastUpdate":
                  break;
                case "VersionUpdateableMin":
                  break;
                case "VersionRefreshableMin":
                  break;
                case "Calculation":
                  break;
                default:
                  seen = false;
              }
              break;
            case "PageBreaks":
              switch (Rn[3]) {
                case "ColBreaks":
                  break;
                case "ColBreak":
                  break;
                case "RowBreaks":
                  break;
                case "RowBreak":
                  break;
                case "ColStart":
                  break;
                case "ColEnd":
                  break;
                case "RowEnd":
                  break;
                default:
                  seen = false;
              }
              break;
            case "AutoFilter":
              switch (Rn[3]) {
                case "AutoFilterColumn":
                  break;
                case "AutoFilterCondition":
                  break;
                case "AutoFilterAnd":
                  break;
                case "AutoFilterOr":
                  break;
                default:
                  seen = false;
              }
              break;
            case "QueryTable":
              switch (Rn[3]) {
                case "Id":
                  break;
                case "AutoFormatFont":
                  break;
                case "AutoFormatPattern":
                  break;
                case "QuerySource":
                  break;
                case "QueryType":
                  break;
                case "EnableRedirections":
                  break;
                case "RefreshedInXl9":
                  break;
                case "URLString":
                  break;
                case "HTMLTables":
                  break;
                case "Connection":
                  break;
                case "CommandText":
                  break;
                case "RefreshInfo":
                  break;
                case "NoTitles":
                  break;
                case "NextId":
                  break;
                case "ColumnInfo":
                  break;
                case "OverwriteCells":
                  break;
                case "DoNotPromptForFile":
                  break;
                case "TextWizardSettings":
                  break;
                case "Source":
                  break;
                case "Number":
                  break;
                case "Decimal":
                  break;
                case "ThousandSeparator":
                  break;
                case "TrailingMinusNumbers":
                  break;
                case "FormatSettings":
                  break;
                case "FieldType":
                  break;
                case "Delimiters":
                  break;
                case "Tab":
                  break;
                case "Comma":
                  break;
                case "AutoFormatName":
                  break;
                case "VersionLastEdit":
                  break;
                case "VersionLastRefresh":
                  break;
                default:
                  seen = false;
              }
              break;
            case "Sorting":
            case "ConditionalFormatting":
            case "DataValidation":
              switch (Rn[3]) {
                case "Range":
                  break;
                case "Type":
                  break;
                case "Min":
                  break;
                case "Max":
                  break;
                case "Sort":
                  break;
                case "Descending":
                  break;
                case "Order":
                  break;
                case "CaseSensitive":
                  break;
                case "Value":
                  break;
                case "ErrorStyle":
                  break;
                case "ErrorMessage":
                  break;
                case "ErrorTitle":
                  break;
                case "CellRangeList":
                  break;
                case "InputMessage":
                  break;
                case "InputTitle":
                  break;
                case "ComboHide":
                  break;
                case "InputHide":
                  break;
                case "Condition":
                  break;
                case "Qualifier":
                  break;
                case "UseBlank":
                  break;
                case "Value1":
                  break;
                case "Value2":
                  break;
                case "Format":
                  break;
                default:
                  seen = false;
              }
              break;
            case "MapInfo":
            case "Schema":
            case "data":
              switch (Rn[3]) {
                case "Map":
                  break;
                case "Entry":
                  break;
                case "Range":
                  break;
                case "XPath":
                  break;
                case "Field":
                  break;
                case "XSDType":
                  break;
                case "FilterOn":
                  break;
                case "Aggregate":
                  break;
                case "ElementType":
                  break;
                case "AttributeType":
                  break;
                case "schema":
                case "element":
                case "complexType":
                case "datatype":
                case "all":
                case "attribute":
                case "extends":
                  break;
                case "row":
                  break;
                default:
                  seen = false;
              }
              break;
            case "SmartTags":
              break;
            default:
              seen = false;
              break;
          }
          if (seen) break;
          if (!state[state.length - 1][1])
            throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
          if (state[state.length - 1][0] === "CustomDocumentProperties") {
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/")
              xlml_set_custprop(Custprops, Rn, cp, str.slice(pidx, Rn.index));
            else {
              cp = Rn;
              pidx = Rn.index + Rn[0].length;
            }
            break;
          }
          if (opts.WTF)
            throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
      }
    var out = {};
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.SSF = SSF.get_table();
    out.Props = Props;
    out.Custprops = Custprops;
    return out;
  }
  function parse_xlml(data, opts) {
    fix_read_opts((opts = opts || {}));
    switch (opts.type || "base64") {
      case "base64":
        return parse_xlml_xml(Base64.decode(data), opts);
      case "binary":
      case "buffer":
      case "file":
        return parse_xlml_xml(data, opts);
      case "array":
        return parse_xlml_xml(data.map(_chr).join(""), opts);
    }
  }
  function write_xlml(wb, opts) {
    var o = [XML_HEADER];
    return o.join("");
  }
  var fs;
  if (typeof exports !== "undefined") {
    if (typeof module !== "undefined" && module.exports) {
      fs = require("fs");
    }
  }
  function firstbyte(f, o) {
    switch ((o || {}).type || "base64") {
      case "buffer":
        return f[0];
      case "base64":
        return Base64.decode(f.substr(0, 12)).charCodeAt(0);
      case "binary":
        return f.charCodeAt(0);
      case "array":
        return f[0];
      default:
        throw new Error("Unrecognized type " + o.type);
    }
  }
  function xlsread(f, o) {
    var n = 0;
    if (!o) o = {};
    if (!o.type) o.type = has_buf && Buffer.isBuffer(f) ? "buffer" : "base64";
    switch ((n = firstbyte(f, o))) {
      case 208:
        return parse_xlscfb(CFB.read(f, o), o);
      case 9:
        return parse_xlscfb(s2a(o.type === "base64" ? Base64.decode(f) : f), o);
      case 60:
        return parse_xlml(f, o);
      case 239:
        return parse_xlml(f, o);
      default:
        throw new Error("Unsupported file " + n);
    }
  }
  var readFile = function (f, o) {
    var d = fs.readFileSync(f);
    if (!o) o = {};
    switch (firstbyte(d, { type: "buffer" })) {
      case 208:
        return parse_xlscfb(CFB.read(d, { type: "buffer" }), o);
      case 9:
        return parse_xlscfb(d, o);
      case 60:
        return parse_xlml(d, ((o.type = "buffer"), o));
      case 239:
        return parse_xlml(d, ((o.type = "buffer"), o));
      default:
        throw "Unsupported file";
    }
  };
  function writeSync(wb, opts) {
    var o = opts || {};
    switch (o.bookType) {
      case "xml":
        return write_xlml(wb, o);
      default:
        throw "unsupported output format " + o.bookType;
    }
  }
  function writeFileSync(wb, filename, opts) {
    var o = opts | {};
    o.type = "file";
    o.file = filename;
    switch (o.file.substr(-4).toLowerCase()) {
      case ".xls":
        o.bookType = "xls";
        break;
      case ".xml":
        o.bookType = "xml";
        break;
    }
    return writeSync(wb, o);
  }
  function decode_row(rowstr) {
    return parseInt(unfix_row(rowstr), 10) - 1;
  }
  function encode_row(row) {
    return "" + (row + 1);
  }
  function fix_row(cstr) {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
  }
  function unfix_row(cstr) {
    return cstr.replace(/\$(\d+)$/, "$1");
  }
  function decode_col(colstr) {
    var c = unfix_col(colstr),
      d = 0,
      i = 0;
    for (; i !== c.length; ++i) d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
  }
  function encode_col(col) {
    var s = "";
    for (++col; col; col = Math.floor((col - 1) / 26))
      s = String.fromCharCode(((col - 1) % 26) + 65) + s;
    return s;
  }
  function fix_col(cstr) {
    return cstr.replace(/^([A-Z])/, "$$$1");
  }
  function unfix_col(cstr) {
    return cstr.replace(/^\$([A-Z])/, "$1");
  }
  function split_cell(cstr) {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
  }
  function decode_cell(cstr) {
    var splt = split_cell(cstr);
    return { c: decode_col(splt[0]), r: decode_row(splt[1]) };
  }
  function encode_cell(cell) {
    return encode_col(cell.c) + encode_row(cell.r);
  }
  function fix_cell(cstr) {
    return fix_col(fix_row(cstr));
  }
  function unfix_cell(cstr) {
    return unfix_col(unfix_row(cstr));
  }
  function decode_range(range) {
    var x = range.split(":").map(decode_cell);
    return { s: x[0], e: x[x.length - 1] };
  }
  function encode_range(cs, ce) {
    if (ce === undefined || typeof ce === "number")
      return encode_range(cs.s, cs.e);
    if (typeof cs !== "string") cs = encode_cell(cs);
    if (typeof ce !== "string") ce = encode_cell(ce);
    return cs == ce ? cs : cs + ":" + ce;
  }
  function safe_decode_range(range) {
    var o = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    var idx = 0,
      i = 0,
      cc = 0;
    var len = range.length;
    for (idx = 0; i < len; ++i) {
      if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
      idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for (idx = 0; i < len; ++i) {
      if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
      idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || range.charCodeAt(++i) === 58) {
      o.e.c = o.s.c;
      o.e.r = o.s.r;
      return o;
    }
    for (idx = 0; i != len; ++i) {
      if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
      idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for (idx = 0; i != len; ++i) {
      if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
      idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
  }
  function safe_format_cell(cell, v) {
    if (cell.z !== undefined)
      try {
        return (cell.w = SSF.format(cell.z, v));
      } catch (e) {}
    if (!cell.XF) return v;
    try {
      return (cell.w = SSF.format(cell.XF.ifmt || 0, v));
    } catch (e) {
      return "" + v;
    }
  }
  function format_cell(cell, v) {
    if (cell == null || cell.t == null) return "";
    if (cell.w !== undefined) return cell.w;
    if (v === undefined) return safe_format_cell(cell, cell.v);
    return safe_format_cell(cell, v);
  }
  function sheet_to_json(sheet, opts) {
    var val,
      row,
      range,
      header = 0,
      offset = 1,
      r,
      hdr = [],
      isempty,
      R,
      C,
      v;
    var o = opts != null ? opts : {};
    var raw = o.raw;
    if (sheet == null || sheet["!ref"] == null) return [];
    range = o.range !== undefined ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch (typeof range) {
      case "string":
        r = safe_decode_range(range);
        break;
      case "number":
        r = safe_decode_range(sheet["!ref"]);
        r.s.r = range;
        break;
      default:
        r = range;
    }
    if (header > 0) offset = 0;
    var rr = encode_row(r.s.r);
    var cols = new Array(r.e.c - r.s.c + 1);
    var out = new Array(r.e.r - r.s.r - offset + 1);
    var outi = 0;
    for (C = r.s.c; C <= r.e.c; ++C) {
      cols[C] = encode_col(C);
      val = sheet[cols[C] + rr];
      switch (header) {
        case 1:
          hdr[C] = C;
          break;
        case 2:
          hdr[C] = cols[C];
          break;
        case 3:
          hdr[C] = o.header[C - r.s.c];
          break;
        default:
          if (val === undefined) continue;
          hdr[C] = format_cell(val);
      }
    }
    for (R = r.s.r + offset; R <= r.e.r; ++R) {
      rr = encode_row(R);
      isempty = true;
      if (header === 1) row = [];
      else {
        row = {};
        if (Object.defineProperty)
          Object.defineProperty(row, "__rowNum__", {
            value: R,
            enumerable: false,
          });
        else row.__rowNum__ = R;
      }
      for (C = r.s.c; C <= r.e.c; ++C) {
        val = sheet[cols[C] + rr];
        if (val === undefined || val.t === undefined) continue;
        v = val.v;
        switch (val.t) {
          case "e":
            continue;
          case "s":
            break;
          case "b":
          case "n":
            break;
          default:
            throw "unrecognized type " + val.t;
        }
        if (v !== undefined) {
          row[hdr[C]] = raw ? v : format_cell(val, v);
          isempty = false;
        }
      }
      if (isempty === false || header === 1) out[outi++] = row;
    }
    out.length = outi;
    return out;
  }
  function sheet_to_row_object_array(sheet, opts) {
    return sheet_to_json(sheet, opts != null ? opts : {});
  }
  function sheet_to_csv(sheet, opts) {
    var out = "",
      txt = "",
      qreg = /"/g;
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",",
      fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n",
      rs = RS.charCodeAt(0);
    var row = "",
      rr = "",
      cols = [];
    var i = 0,
      cc = 0,
      val;
    var R = 0,
      C = 0;
    for (C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
    for (R = r.s.r; R <= r.e.r; ++R) {
      row = "";
      rr = encode_row(R);
      for (C = r.s.c; C <= r.e.c; ++C) {
        val = sheet[cols[C] + rr];
        txt = val !== undefined ? "" + format_cell(val) : "";
        for (i = 0, cc = 0; i !== txt.length; ++i)
          if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34) {
            txt = '"' + txt.replace(qreg, '""') + '"';
            break;
          }
        row += (C === r.s.c ? "" : FS) + txt;
      }
      out += row + RS;
    }
    return out;
  }
  var make_csv = sheet_to_csv;
  function sheet_to_formulae(sheet) {
    var y = "",
      x,
      val = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = safe_decode_range(sheet["!ref"]),
      rr = "",
      cols = [],
      C;
    var cmds = new Array((r.e.r - r.s.r + 1) * (r.e.c - r.s.c + 1));
    var i = 0;
    for (C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
    for (var R = r.s.r; R <= r.e.r; ++R) {
      rr = encode_row(R);
      for (C = r.s.c; C <= r.e.c; ++C) {
        y = cols[C] + rr;
        x = sheet[y];
        val = "";
        if (x === undefined) continue;
        else if (x.F != null) {
          y = x.F;
          if (!x.f) continue;
          val = x.f;
          if (y.indexOf(":") == -1) y = y + ":" + y;
        }
        if (x.f != null) val = x.f;
        else if (x.t == "n" && x.v != null) val = "" + x.v;
        else if (x.t == "b") val = x.v ? "TRUE" : "FALSE";
        else if (x.w !== undefined) val = "'" + x.w;
        else if (x.v === undefined) continue;
        else if (x.t == "s") val = "'" + x.v;
        else val = "" + x.v;
        cmds[i++] = y + "=" + val;
      }
    }
    cmds.length = i;
    return cmds;
  }
  var utils = {
    encode_col: encode_col,
    encode_row: encode_row,
    encode_cell: encode_cell,
    encode_range: encode_range,
    decode_col: decode_col,
    decode_row: decode_row,
    split_cell: split_cell,
    decode_cell: decode_cell,
    decode_range: decode_range,
    format_cell: format_cell,
    get_formulae: sheet_to_formulae,
    make_csv: sheet_to_csv,
    make_json: sheet_to_json,
    make_formulae: sheet_to_formulae,
    sheet_to_csv: sheet_to_csv,
    sheet_to_json: sheet_to_json,
    sheet_to_formulae: sheet_to_formulae,
    sheet_to_row_object_array: sheet_to_row_object_array,
  };
  XLS.parse_xlscfb = parse_xlscfb;
  XLS.read = xlsread;
  XLS.readFile = readFile;
  XLS.readSync = xlsread;
  XLS.readFileSync = readFile;
  XLS.utils = utils;
  XLS.CFB = CFB;
  XLS.SSF = SSF;
})(typeof exports !== "undefined" ? exports : XLS);

/**
 * Spanish translation for bootstrap-datepicker
 * Bruno Bonamin <bruno.bonamin@gmail.com>
 */
(function ($) {
  $.fn.datepicker.dates["es"] = {
    days: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
    daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
    months: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    monthsShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    today: "Hoy",
    monthsTitle: "Meses",
    clear: "Borrar",
    weekStart: 1,
    format: "dd/mm/yyyy",
  };
})(jQuery);

/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if ("undefined" == typeof jQuery)
  throw new Error("Bootstrap's JavaScript requires jQuery");
+(function (a) {
  "use strict";
  var b = a.fn.jquery.split(" ")[0].split(".");
  if (
    (b[0] < 2 && b[1] < 9) ||
    (1 == b[0] && 9 == b[1] && b[2] < 1) ||
    b[0] > 3
  )
    throw new Error(
      "Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4"
    );
})(jQuery),
  +(function (a) {
    "use strict";
    function b() {
      var a = document.createElement("bootstrap"),
        b = {
          WebkitTransition: "webkitTransitionEnd",
          MozTransition: "transitionend",
          OTransition: "oTransitionEnd otransitionend",
          transition: "transitionend",
        };
      for (var c in b) if (void 0 !== a.style[c]) return { end: b[c] };
      return !1;
    }
    (a.fn.emulateTransitionEnd = function (b) {
      var c = !1,
        d = this;
      a(this).one("bsTransitionEnd", function () {
        c = !0;
      });
      var e = function () {
        c || a(d).trigger(a.support.transition.end);
      };
      return setTimeout(e, b), this;
    }),
      a(function () {
        (a.support.transition = b()),
          a.support.transition &&
            (a.event.special.bsTransitionEnd = {
              bindType: a.support.transition.end,
              delegateType: a.support.transition.end,
              handle: function (b) {
                if (a(b.target).is(this))
                  return b.handleObj.handler.apply(this, arguments);
              },
            });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var c = a(this),
          e = c.data("bs.alert");
        e || c.data("bs.alert", (e = new d(this))),
          "string" == typeof b && e[b].call(c);
      });
    }
    var c = '[data-dismiss="alert"]',
      d = function (b) {
        a(b).on("click", c, this.close);
      };
    (d.VERSION = "3.3.7"),
      (d.TRANSITION_DURATION = 150),
      (d.prototype.close = function (b) {
        function c() {
          g.detach().trigger("closed.bs.alert").remove();
        }
        var e = a(this),
          f = e.attr("data-target");
        f || ((f = e.attr("href")), (f = f && f.replace(/.*(?=#[^\s]*$)/, "")));
        var g = a("#" === f ? [] : f);
        b && b.preventDefault(),
          g.length || (g = e.closest(".alert")),
          g.trigger((b = a.Event("close.bs.alert"))),
          b.isDefaultPrevented() ||
            (g.removeClass("in"),
            a.support.transition && g.hasClass("fade")
              ? g
                  .one("bsTransitionEnd", c)
                  .emulateTransitionEnd(d.TRANSITION_DURATION)
              : c());
      });
    var e = a.fn.alert;
    (a.fn.alert = b),
      (a.fn.alert.Constructor = d),
      (a.fn.alert.noConflict = function () {
        return (a.fn.alert = e), this;
      }),
      a(document).on("click.bs.alert.data-api", c, d.prototype.close);
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.button"),
          f = "object" == typeof b && b;
        e || d.data("bs.button", (e = new c(this, f))),
          "toggle" == b ? e.toggle() : b && e.setState(b);
      });
    }
    var c = function (b, d) {
      (this.$element = a(b)),
        (this.options = a.extend({}, c.DEFAULTS, d)),
        (this.isLoading = !1);
    };
    (c.VERSION = "3.3.7"),
      (c.DEFAULTS = { loadingText: "loading..." }),
      (c.prototype.setState = function (b) {
        var c = "disabled",
          d = this.$element,
          e = d.is("input") ? "val" : "html",
          f = d.data();
        (b += "Text"),
          null == f.resetText && d.data("resetText", d[e]()),
          setTimeout(
            a.proxy(function () {
              d[e](null == f[b] ? this.options[b] : f[b]),
                "loadingText" == b
                  ? ((this.isLoading = !0),
                    d.addClass(c).attr(c, c).prop(c, !0))
                  : this.isLoading &&
                    ((this.isLoading = !1),
                    d.removeClass(c).removeAttr(c).prop(c, !1));
            }, this),
            0
          );
      }),
      (c.prototype.toggle = function () {
        var a = !0,
          b = this.$element.closest('[data-toggle="buttons"]');
        if (b.length) {
          var c = this.$element.find("input");
          "radio" == c.prop("type")
            ? (c.prop("checked") && (a = !1),
              b.find(".active").removeClass("active"),
              this.$element.addClass("active"))
            : "checkbox" == c.prop("type") &&
              (c.prop("checked") !== this.$element.hasClass("active") &&
                (a = !1),
              this.$element.toggleClass("active")),
            c.prop("checked", this.$element.hasClass("active")),
            a && c.trigger("change");
        } else
          this.$element.attr("aria-pressed", !this.$element.hasClass("active")),
            this.$element.toggleClass("active");
      });
    var d = a.fn.button;
    (a.fn.button = b),
      (a.fn.button.Constructor = c),
      (a.fn.button.noConflict = function () {
        return (a.fn.button = d), this;
      }),
      a(document)
        .on(
          "click.bs.button.data-api",
          '[data-toggle^="button"]',
          function (c) {
            var d = a(c.target).closest(".btn");
            b.call(d, "toggle"),
              a(c.target).is('input[type="radio"], input[type="checkbox"]') ||
                (c.preventDefault(),
                d.is("input,button")
                  ? d.trigger("focus")
                  : d
                      .find("input:visible,button:visible")
                      .first()
                      .trigger("focus"));
          }
        )
        .on(
          "focus.bs.button.data-api blur.bs.button.data-api",
          '[data-toggle^="button"]',
          function (b) {
            a(b.target)
              .closest(".btn")
              .toggleClass("focus", /^focus(in)?$/.test(b.type));
          }
        );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.carousel"),
          f = a.extend({}, c.DEFAULTS, d.data(), "object" == typeof b && b),
          g = "string" == typeof b ? b : f.slide;
        e || d.data("bs.carousel", (e = new c(this, f))),
          "number" == typeof b
            ? e.to(b)
            : g
            ? e[g]()
            : f.interval && e.pause().cycle();
      });
    }
    var c = function (b, c) {
      (this.$element = a(b)),
        (this.$indicators = this.$element.find(".carousel-indicators")),
        (this.options = c),
        (this.paused = null),
        (this.sliding = null),
        (this.interval = null),
        (this.$active = null),
        (this.$items = null),
        this.options.keyboard &&
          this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)),
        "hover" == this.options.pause &&
          !("ontouchstart" in document.documentElement) &&
          this.$element
            .on("mouseenter.bs.carousel", a.proxy(this.pause, this))
            .on("mouseleave.bs.carousel", a.proxy(this.cycle, this));
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 600),
      (c.DEFAULTS = { interval: 5e3, pause: "hover", wrap: !0, keyboard: !0 }),
      (c.prototype.keydown = function (a) {
        if (!/input|textarea/i.test(a.target.tagName)) {
          switch (a.which) {
            case 37:
              this.prev();
              break;
            case 39:
              this.next();
              break;
            default:
              return;
          }
          a.preventDefault();
        }
      }),
      (c.prototype.cycle = function (b) {
        return (
          b || (this.paused = !1),
          this.interval && clearInterval(this.interval),
          this.options.interval &&
            !this.paused &&
            (this.interval = setInterval(
              a.proxy(this.next, this),
              this.options.interval
            )),
          this
        );
      }),
      (c.prototype.getItemIndex = function (a) {
        return (
          (this.$items = a.parent().children(".item")),
          this.$items.index(a || this.$active)
        );
      }),
      (c.prototype.getItemForDirection = function (a, b) {
        var c = this.getItemIndex(b),
          d =
            ("prev" == a && 0 === c) ||
            ("next" == a && c == this.$items.length - 1);
        if (d && !this.options.wrap) return b;
        var e = "prev" == a ? -1 : 1,
          f = (c + e) % this.$items.length;
        return this.$items.eq(f);
      }),
      (c.prototype.to = function (a) {
        var b = this,
          c = this.getItemIndex(
            (this.$active = this.$element.find(".item.active"))
          );
        if (!(a > this.$items.length - 1 || a < 0))
          return this.sliding
            ? this.$element.one("slid.bs.carousel", function () {
                b.to(a);
              })
            : c == a
            ? this.pause().cycle()
            : this.slide(a > c ? "next" : "prev", this.$items.eq(a));
      }),
      (c.prototype.pause = function (b) {
        return (
          b || (this.paused = !0),
          this.$element.find(".next, .prev").length &&
            a.support.transition &&
            (this.$element.trigger(a.support.transition.end), this.cycle(!0)),
          (this.interval = clearInterval(this.interval)),
          this
        );
      }),
      (c.prototype.next = function () {
        if (!this.sliding) return this.slide("next");
      }),
      (c.prototype.prev = function () {
        if (!this.sliding) return this.slide("prev");
      }),
      (c.prototype.slide = function (b, d) {
        var e = this.$element.find(".item.active"),
          f = d || this.getItemForDirection(b, e),
          g = this.interval,
          h = "next" == b ? "left" : "right",
          i = this;
        if (f.hasClass("active")) return (this.sliding = !1);
        var j = f[0],
          k = a.Event("slide.bs.carousel", { relatedTarget: j, direction: h });
        if ((this.$element.trigger(k), !k.isDefaultPrevented())) {
          if (
            ((this.sliding = !0), g && this.pause(), this.$indicators.length)
          ) {
            this.$indicators.find(".active").removeClass("active");
            var l = a(this.$indicators.children()[this.getItemIndex(f)]);
            l && l.addClass("active");
          }
          var m = a.Event("slid.bs.carousel", {
            relatedTarget: j,
            direction: h,
          });
          return (
            a.support.transition && this.$element.hasClass("slide")
              ? (f.addClass(b),
                f[0].offsetWidth,
                e.addClass(h),
                f.addClass(h),
                e
                  .one("bsTransitionEnd", function () {
                    f.removeClass([b, h].join(" ")).addClass("active"),
                      e.removeClass(["active", h].join(" ")),
                      (i.sliding = !1),
                      setTimeout(function () {
                        i.$element.trigger(m);
                      }, 0);
                  })
                  .emulateTransitionEnd(c.TRANSITION_DURATION))
              : (e.removeClass("active"),
                f.addClass("active"),
                (this.sliding = !1),
                this.$element.trigger(m)),
            g && this.cycle(),
            this
          );
        }
      });
    var d = a.fn.carousel;
    (a.fn.carousel = b),
      (a.fn.carousel.Constructor = c),
      (a.fn.carousel.noConflict = function () {
        return (a.fn.carousel = d), this;
      });
    var e = function (c) {
      var d,
        e = a(this),
        f = a(
          e.attr("data-target") ||
            ((d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, ""))
        );
      if (f.hasClass("carousel")) {
        var g = a.extend({}, f.data(), e.data()),
          h = e.attr("data-slide-to");
        h && (g.interval = !1),
          b.call(f, g),
          h && f.data("bs.carousel").to(h),
          c.preventDefault();
      }
    };
    a(document)
      .on("click.bs.carousel.data-api", "[data-slide]", e)
      .on("click.bs.carousel.data-api", "[data-slide-to]", e),
      a(window).on("load", function () {
        a('[data-ride="carousel"]').each(function () {
          var c = a(this);
          b.call(c, c.data());
        });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      var c,
        d =
          b.attr("data-target") ||
          ((c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, ""));
      return a(d);
    }
    function c(b) {
      return this.each(function () {
        var c = a(this),
          e = c.data("bs.collapse"),
          f = a.extend({}, d.DEFAULTS, c.data(), "object" == typeof b && b);
        !e && f.toggle && /show|hide/.test(b) && (f.toggle = !1),
          e || c.data("bs.collapse", (e = new d(this, f))),
          "string" == typeof b && e[b]();
      });
    }
    var d = function (b, c) {
      (this.$element = a(b)),
        (this.options = a.extend({}, d.DEFAULTS, c)),
        (this.$trigger = a(
          '[data-toggle="collapse"][href="#' +
            b.id +
            '"],[data-toggle="collapse"][data-target="#' +
            b.id +
            '"]'
        )),
        (this.transitioning = null),
        this.options.parent
          ? (this.$parent = this.getParent())
          : this.addAriaAndCollapsedClass(this.$element, this.$trigger),
        this.options.toggle && this.toggle();
    };
    (d.VERSION = "3.3.7"),
      (d.TRANSITION_DURATION = 350),
      (d.DEFAULTS = { toggle: !0 }),
      (d.prototype.dimension = function () {
        var a = this.$element.hasClass("width");
        return a ? "width" : "height";
      }),
      (d.prototype.show = function () {
        if (!this.transitioning && !this.$element.hasClass("in")) {
          var b,
            e =
              this.$parent &&
              this.$parent.children(".panel").children(".in, .collapsing");
          if (
            !(
              e &&
              e.length &&
              ((b = e.data("bs.collapse")), b && b.transitioning)
            )
          ) {
            var f = a.Event("show.bs.collapse");
            if ((this.$element.trigger(f), !f.isDefaultPrevented())) {
              e &&
                e.length &&
                (c.call(e, "hide"), b || e.data("bs.collapse", null));
              var g = this.dimension();
              this.$element
                .removeClass("collapse")
                .addClass("collapsing")
                [g](0)
                .attr("aria-expanded", !0),
                this.$trigger
                  .removeClass("collapsed")
                  .attr("aria-expanded", !0),
                (this.transitioning = 1);
              var h = function () {
                this.$element
                  .removeClass("collapsing")
                  .addClass("collapse in")
                  [g](""),
                  (this.transitioning = 0),
                  this.$element.trigger("shown.bs.collapse");
              };
              if (!a.support.transition) return h.call(this);
              var i = a.camelCase(["scroll", g].join("-"));
              this.$element
                .one("bsTransitionEnd", a.proxy(h, this))
                .emulateTransitionEnd(d.TRANSITION_DURATION)
                [g](this.$element[0][i]);
            }
          }
        }
      }),
      (d.prototype.hide = function () {
        if (!this.transitioning && this.$element.hasClass("in")) {
          var b = a.Event("hide.bs.collapse");
          if ((this.$element.trigger(b), !b.isDefaultPrevented())) {
            var c = this.dimension();
            this.$element[c](this.$element[c]())[0].offsetHeight,
              this.$element
                .addClass("collapsing")
                .removeClass("collapse in")
                .attr("aria-expanded", !1),
              this.$trigger.addClass("collapsed").attr("aria-expanded", !1),
              (this.transitioning = 1);
            var e = function () {
              (this.transitioning = 0),
                this.$element
                  .removeClass("collapsing")
                  .addClass("collapse")
                  .trigger("hidden.bs.collapse");
            };
            return a.support.transition
              ? void this.$element[c](0)
                  .one("bsTransitionEnd", a.proxy(e, this))
                  .emulateTransitionEnd(d.TRANSITION_DURATION)
              : e.call(this);
          }
        }
      }),
      (d.prototype.toggle = function () {
        this[this.$element.hasClass("in") ? "hide" : "show"]();
      }),
      (d.prototype.getParent = function () {
        return a(this.options.parent)
          .find(
            '[data-toggle="collapse"][data-parent="' +
              this.options.parent +
              '"]'
          )
          .each(
            a.proxy(function (c, d) {
              var e = a(d);
              this.addAriaAndCollapsedClass(b(e), e);
            }, this)
          )
          .end();
      }),
      (d.prototype.addAriaAndCollapsedClass = function (a, b) {
        var c = a.hasClass("in");
        a.attr("aria-expanded", c),
          b.toggleClass("collapsed", !c).attr("aria-expanded", c);
      });
    var e = a.fn.collapse;
    (a.fn.collapse = c),
      (a.fn.collapse.Constructor = d),
      (a.fn.collapse.noConflict = function () {
        return (a.fn.collapse = e), this;
      }),
      a(document).on(
        "click.bs.collapse.data-api",
        '[data-toggle="collapse"]',
        function (d) {
          var e = a(this);
          e.attr("data-target") || d.preventDefault();
          var f = b(e),
            g = f.data("bs.collapse"),
            h = g ? "toggle" : e.data();
          c.call(f, h);
        }
      );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      var c = b.attr("data-target");
      c ||
        ((c = b.attr("href")),
        (c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, "")));
      var d = c && a(c);
      return d && d.length ? d : b.parent();
    }
    function c(c) {
      (c && 3 === c.which) ||
        (a(e).remove(),
        a(f).each(function () {
          var d = a(this),
            e = b(d),
            f = { relatedTarget: this };
          e.hasClass("open") &&
            ((c &&
              "click" == c.type &&
              /input|textarea/i.test(c.target.tagName) &&
              a.contains(e[0], c.target)) ||
              (e.trigger((c = a.Event("hide.bs.dropdown", f))),
              c.isDefaultPrevented() ||
                (d.attr("aria-expanded", "false"),
                e
                  .removeClass("open")
                  .trigger(a.Event("hidden.bs.dropdown", f)))));
        }));
    }
    function d(b) {
      return this.each(function () {
        var c = a(this),
          d = c.data("bs.dropdown");
        d || c.data("bs.dropdown", (d = new g(this))),
          "string" == typeof b && d[b].call(c);
      });
    }
    var e = ".dropdown-backdrop",
      f = '[data-toggle="dropdown"]',
      g = function (b) {
        a(b).on("click.bs.dropdown", this.toggle);
      };
    (g.VERSION = "3.3.7"),
      (g.prototype.toggle = function (d) {
        var e = a(this);
        if (!e.is(".disabled, :disabled")) {
          var f = b(e),
            g = f.hasClass("open");
          if ((c(), !g)) {
            "ontouchstart" in document.documentElement &&
              !f.closest(".navbar-nav").length &&
              a(document.createElement("div"))
                .addClass("dropdown-backdrop")
                .insertAfter(a(this))
                .on("click", c);
            var h = { relatedTarget: this };
            if (
              (f.trigger((d = a.Event("show.bs.dropdown", h))),
              d.isDefaultPrevented())
            )
              return;
            e.trigger("focus").attr("aria-expanded", "true"),
              f.toggleClass("open").trigger(a.Event("shown.bs.dropdown", h));
          }
          return !1;
        }
      }),
      (g.prototype.keydown = function (c) {
        if (
          /(38|40|27|32)/.test(c.which) &&
          !/input|textarea/i.test(c.target.tagName)
        ) {
          var d = a(this);
          if (
            (c.preventDefault(),
            c.stopPropagation(),
            !d.is(".disabled, :disabled"))
          ) {
            var e = b(d),
              g = e.hasClass("open");
            if ((!g && 27 != c.which) || (g && 27 == c.which))
              return (
                27 == c.which && e.find(f).trigger("focus"), d.trigger("click")
              );
            var h = " li:not(.disabled):visible a",
              i = e.find(".dropdown-menu" + h);
            if (i.length) {
              var j = i.index(c.target);
              38 == c.which && j > 0 && j--,
                40 == c.which && j < i.length - 1 && j++,
                ~j || (j = 0),
                i.eq(j).trigger("focus");
            }
          }
        }
      });
    var h = a.fn.dropdown;
    (a.fn.dropdown = d),
      (a.fn.dropdown.Constructor = g),
      (a.fn.dropdown.noConflict = function () {
        return (a.fn.dropdown = h), this;
      }),
      a(document)
        .on("click.bs.dropdown.data-api", c)
        .on("click.bs.dropdown.data-api", ".dropdown form", function (a) {
          a.stopPropagation();
        })
        .on("click.bs.dropdown.data-api", f, g.prototype.toggle)
        .on("keydown.bs.dropdown.data-api", f, g.prototype.keydown)
        .on(
          "keydown.bs.dropdown.data-api",
          ".dropdown-menu",
          g.prototype.keydown
        );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b, d) {
      return this.each(function () {
        var e = a(this),
          f = e.data("bs.modal"),
          g = a.extend({}, c.DEFAULTS, e.data(), "object" == typeof b && b);
        f || e.data("bs.modal", (f = new c(this, g))),
          "string" == typeof b ? f[b](d) : g.show && f.show(d);
      });
    }
    var c = function (b, c) {
      (this.options = c),
        (this.$body = a(document.body)),
        (this.$element = a(b)),
        (this.$dialog = this.$element.find(".modal-dialog")),
        (this.$backdrop = null),
        (this.isShown = null),
        (this.originalBodyPad = null),
        (this.scrollbarWidth = 0),
        (this.ignoreBackdropClick = !1),
        this.options.remote &&
          this.$element.find(".modal-content").load(
            this.options.remote,
            a.proxy(function () {
              this.$element.trigger("loaded.bs.modal");
            }, this)
          );
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 300),
      (c.BACKDROP_TRANSITION_DURATION = 150),
      (c.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }),
      (c.prototype.toggle = function (a) {
        return this.isShown ? this.hide() : this.show(a);
      }),
      (c.prototype.show = function (b) {
        var d = this,
          e = a.Event("show.bs.modal", { relatedTarget: b });
        this.$element.trigger(e),
          this.isShown ||
            e.isDefaultPrevented() ||
            ((this.isShown = !0),
            this.checkScrollbar(),
            this.setScrollbar(),
            this.$body.addClass("modal-open"),
            this.escape(),
            this.resize(),
            this.$element.on(
              "click.dismiss.bs.modal",
              '[data-dismiss="modal"]',
              a.proxy(this.hide, this)
            ),
            this.$dialog.on("mousedown.dismiss.bs.modal", function () {
              d.$element.one("mouseup.dismiss.bs.modal", function (b) {
                a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0);
              });
            }),
            this.backdrop(function () {
              var e = a.support.transition && d.$element.hasClass("fade");
              d.$element.parent().length || d.$element.appendTo(d.$body),
                d.$element.show().scrollTop(0),
                d.adjustDialog(),
                e && d.$element[0].offsetWidth,
                d.$element.addClass("in"),
                d.enforceFocus();
              var f = a.Event("shown.bs.modal", { relatedTarget: b });
              e
                ? d.$dialog
                    .one("bsTransitionEnd", function () {
                      d.$element.trigger("focus").trigger(f);
                    })
                    .emulateTransitionEnd(c.TRANSITION_DURATION)
                : d.$element.trigger("focus").trigger(f);
            }));
      }),
      (c.prototype.hide = function (b) {
        b && b.preventDefault(),
          (b = a.Event("hide.bs.modal")),
          this.$element.trigger(b),
          this.isShown &&
            !b.isDefaultPrevented() &&
            ((this.isShown = !1),
            this.escape(),
            this.resize(),
            a(document).off("focusin.bs.modal"),
            this.$element
              .removeClass("in")
              .off("click.dismiss.bs.modal")
              .off("mouseup.dismiss.bs.modal"),
            this.$dialog.off("mousedown.dismiss.bs.modal"),
            a.support.transition && this.$element.hasClass("fade")
              ? this.$element
                  .one("bsTransitionEnd", a.proxy(this.hideModal, this))
                  .emulateTransitionEnd(c.TRANSITION_DURATION)
              : this.hideModal());
      }),
      (c.prototype.enforceFocus = function () {
        a(document)
          .off("focusin.bs.modal")
          .on(
            "focusin.bs.modal",
            a.proxy(function (a) {
              document === a.target ||
                this.$element[0] === a.target ||
                this.$element.has(a.target).length ||
                this.$element.trigger("focus");
            }, this)
          );
      }),
      (c.prototype.escape = function () {
        this.isShown && this.options.keyboard
          ? this.$element.on(
              "keydown.dismiss.bs.modal",
              a.proxy(function (a) {
                27 == a.which && this.hide();
              }, this)
            )
          : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
      }),
      (c.prototype.resize = function () {
        this.isShown
          ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this))
          : a(window).off("resize.bs.modal");
      }),
      (c.prototype.hideModal = function () {
        var a = this;
        this.$element.hide(),
          this.backdrop(function () {
            a.$body.removeClass("modal-open"),
              a.resetAdjustments(),
              a.resetScrollbar(),
              a.$element.trigger("hidden.bs.modal");
          });
      }),
      (c.prototype.removeBackdrop = function () {
        this.$backdrop && this.$backdrop.remove(), (this.$backdrop = null);
      }),
      (c.prototype.backdrop = function (b) {
        var d = this,
          e = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
          var f = a.support.transition && e;
          if (
            ((this.$backdrop = a(document.createElement("div"))
              .addClass("modal-backdrop " + e)
              .appendTo(this.$body)),
            this.$element.on(
              "click.dismiss.bs.modal",
              a.proxy(function (a) {
                return this.ignoreBackdropClick
                  ? void (this.ignoreBackdropClick = !1)
                  : void (
                      a.target === a.currentTarget &&
                      ("static" == this.options.backdrop
                        ? this.$element[0].focus()
                        : this.hide())
                    );
              }, this)
            ),
            f && this.$backdrop[0].offsetWidth,
            this.$backdrop.addClass("in"),
            !b)
          )
            return;
          f
            ? this.$backdrop
                .one("bsTransitionEnd", b)
                .emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION)
            : b();
        } else if (!this.isShown && this.$backdrop) {
          this.$backdrop.removeClass("in");
          var g = function () {
            d.removeBackdrop(), b && b();
          };
          a.support.transition && this.$element.hasClass("fade")
            ? this.$backdrop
                .one("bsTransitionEnd", g)
                .emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION)
            : g();
        } else b && b();
      }),
      (c.prototype.handleUpdate = function () {
        this.adjustDialog();
      }),
      (c.prototype.adjustDialog = function () {
        var a =
          this.$element[0].scrollHeight > document.documentElement.clientHeight;
        this.$element.css({
          paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "",
          paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : "",
        });
      }),
      (c.prototype.resetAdjustments = function () {
        this.$element.css({ paddingLeft: "", paddingRight: "" });
      }),
      (c.prototype.checkScrollbar = function () {
        var a = window.innerWidth;
        if (!a) {
          var b = document.documentElement.getBoundingClientRect();
          a = b.right - Math.abs(b.left);
        }
        (this.bodyIsOverflowing = document.body.clientWidth < a),
          (this.scrollbarWidth = this.measureScrollbar());
      }),
      (c.prototype.setScrollbar = function () {
        var a = parseInt(this.$body.css("padding-right") || 0, 10);
        (this.originalBodyPad = document.body.style.paddingRight || ""),
          this.bodyIsOverflowing &&
            this.$body.css("padding-right", a + this.scrollbarWidth);
      }),
      (c.prototype.resetScrollbar = function () {
        this.$body.css("padding-right", this.originalBodyPad);
      }),
      (c.prototype.measureScrollbar = function () {
        var a = document.createElement("div");
        (a.className = "modal-scrollbar-measure"), this.$body.append(a);
        var b = a.offsetWidth - a.clientWidth;
        return this.$body[0].removeChild(a), b;
      });
    var d = a.fn.modal;
    (a.fn.modal = b),
      (a.fn.modal.Constructor = c),
      (a.fn.modal.noConflict = function () {
        return (a.fn.modal = d), this;
      }),
      a(document).on(
        "click.bs.modal.data-api",
        '[data-toggle="modal"]',
        function (c) {
          var d = a(this),
            e = d.attr("href"),
            f = a(
              d.attr("data-target") || (e && e.replace(/.*(?=#[^\s]+$)/, ""))
            ),
            g = f.data("bs.modal")
              ? "toggle"
              : a.extend({ remote: !/#/.test(e) && e }, f.data(), d.data());
          d.is("a") && c.preventDefault(),
            f.one("show.bs.modal", function (a) {
              a.isDefaultPrevented() ||
                f.one("hidden.bs.modal", function () {
                  d.is(":visible") && d.trigger("focus");
                });
            }),
            b.call(f, g, this);
        }
      );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.tooltip"),
          f = "object" == typeof b && b;
        (!e && /destroy|hide/.test(b)) ||
          (e || d.data("bs.tooltip", (e = new c(this, f))),
          "string" == typeof b && e[b]());
      });
    }
    var c = function (a, b) {
      (this.type = null),
        (this.options = null),
        (this.enabled = null),
        (this.timeout = null),
        (this.hoverState = null),
        (this.$element = null),
        (this.inState = null),
        this.init("tooltip", a, b);
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 150),
      (c.DEFAULTS = {
        animation: !0,
        placement: "top",
        selector: !1,
        template:
          '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        container: !1,
        viewport: { selector: "body", padding: 0 },
      }),
      (c.prototype.init = function (b, c, d) {
        if (
          ((this.enabled = !0),
          (this.type = b),
          (this.$element = a(c)),
          (this.options = this.getOptions(d)),
          (this.$viewport =
            this.options.viewport &&
            a(
              a.isFunction(this.options.viewport)
                ? this.options.viewport.call(this, this.$element)
                : this.options.viewport.selector || this.options.viewport
            )),
          (this.inState = { click: !1, hover: !1, focus: !1 }),
          this.$element[0] instanceof document.constructor &&
            !this.options.selector)
        )
          throw new Error(
            "`selector` option must be specified when initializing " +
              this.type +
              " on the window.document object!"
          );
        for (var e = this.options.trigger.split(" "), f = e.length; f--; ) {
          var g = e[f];
          if ("click" == g)
            this.$element.on(
              "click." + this.type,
              this.options.selector,
              a.proxy(this.toggle, this)
            );
          else if ("manual" != g) {
            var h = "hover" == g ? "mouseenter" : "focusin",
              i = "hover" == g ? "mouseleave" : "focusout";
            this.$element.on(
              h + "." + this.type,
              this.options.selector,
              a.proxy(this.enter, this)
            ),
              this.$element.on(
                i + "." + this.type,
                this.options.selector,
                a.proxy(this.leave, this)
              );
          }
        }
        this.options.selector
          ? (this._options = a.extend({}, this.options, {
              trigger: "manual",
              selector: "",
            }))
          : this.fixTitle();
      }),
      (c.prototype.getDefaults = function () {
        return c.DEFAULTS;
      }),
      (c.prototype.getOptions = function (b) {
        return (
          (b = a.extend({}, this.getDefaults(), this.$element.data(), b)),
          b.delay &&
            "number" == typeof b.delay &&
            (b.delay = { show: b.delay, hide: b.delay }),
          b
        );
      }),
      (c.prototype.getDelegateOptions = function () {
        var b = {},
          c = this.getDefaults();
        return (
          this._options &&
            a.each(this._options, function (a, d) {
              c[a] != d && (b[a] = d);
            }),
          b
        );
      }),
      (c.prototype.enter = function (b) {
        var c =
          b instanceof this.constructor
            ? b
            : a(b.currentTarget).data("bs." + this.type);
        return (
          c ||
            ((c = new this.constructor(
              b.currentTarget,
              this.getDelegateOptions()
            )),
            a(b.currentTarget).data("bs." + this.type, c)),
          b instanceof a.Event &&
            (c.inState["focusin" == b.type ? "focus" : "hover"] = !0),
          c.tip().hasClass("in") || "in" == c.hoverState
            ? void (c.hoverState = "in")
            : (clearTimeout(c.timeout),
              (c.hoverState = "in"),
              c.options.delay && c.options.delay.show
                ? void (c.timeout = setTimeout(function () {
                    "in" == c.hoverState && c.show();
                  }, c.options.delay.show))
                : c.show())
        );
      }),
      (c.prototype.isInStateTrue = function () {
        for (var a in this.inState) if (this.inState[a]) return !0;
        return !1;
      }),
      (c.prototype.leave = function (b) {
        var c =
          b instanceof this.constructor
            ? b
            : a(b.currentTarget).data("bs." + this.type);
        if (
          (c ||
            ((c = new this.constructor(
              b.currentTarget,
              this.getDelegateOptions()
            )),
            a(b.currentTarget).data("bs." + this.type, c)),
          b instanceof a.Event &&
            (c.inState["focusout" == b.type ? "focus" : "hover"] = !1),
          !c.isInStateTrue())
        )
          return (
            clearTimeout(c.timeout),
            (c.hoverState = "out"),
            c.options.delay && c.options.delay.hide
              ? void (c.timeout = setTimeout(function () {
                  "out" == c.hoverState && c.hide();
                }, c.options.delay.hide))
              : c.hide()
          );
      }),
      (c.prototype.show = function () {
        var b = a.Event("show.bs." + this.type);
        if (this.hasContent() && this.enabled) {
          this.$element.trigger(b);
          var d = a.contains(
            this.$element[0].ownerDocument.documentElement,
            this.$element[0]
          );
          if (b.isDefaultPrevented() || !d) return;
          var e = this,
            f = this.tip(),
            g = this.getUID(this.type);
          this.setContent(),
            f.attr("id", g),
            this.$element.attr("aria-describedby", g),
            this.options.animation && f.addClass("fade");
          var h =
              "function" == typeof this.options.placement
                ? this.options.placement.call(this, f[0], this.$element[0])
                : this.options.placement,
            i = /\s?auto?\s?/i,
            j = i.test(h);
          j && (h = h.replace(i, "") || "top"),
            f
              .detach()
              .css({ top: 0, left: 0, display: "block" })
              .addClass(h)
              .data("bs." + this.type, this),
            this.options.container
              ? f.appendTo(this.options.container)
              : f.insertAfter(this.$element),
            this.$element.trigger("inserted.bs." + this.type);
          var k = this.getPosition(),
            l = f[0].offsetWidth,
            m = f[0].offsetHeight;
          if (j) {
            var n = h,
              o = this.getPosition(this.$viewport);
            (h =
              "bottom" == h && k.bottom + m > o.bottom
                ? "top"
                : "top" == h && k.top - m < o.top
                ? "bottom"
                : "right" == h && k.right + l > o.width
                ? "left"
                : "left" == h && k.left - l < o.left
                ? "right"
                : h),
              f.removeClass(n).addClass(h);
          }
          var p = this.getCalculatedOffset(h, k, l, m);
          this.applyPlacement(p, h);
          var q = function () {
            var a = e.hoverState;
            e.$element.trigger("shown.bs." + e.type),
              (e.hoverState = null),
              "out" == a && e.leave(e);
          };
          a.support.transition && this.$tip.hasClass("fade")
            ? f
                .one("bsTransitionEnd", q)
                .emulateTransitionEnd(c.TRANSITION_DURATION)
            : q();
        }
      }),
      (c.prototype.applyPlacement = function (b, c) {
        var d = this.tip(),
          e = d[0].offsetWidth,
          f = d[0].offsetHeight,
          g = parseInt(d.css("margin-top"), 10),
          h = parseInt(d.css("margin-left"), 10);
        isNaN(g) && (g = 0),
          isNaN(h) && (h = 0),
          (b.top += g),
          (b.left += h),
          a.offset.setOffset(
            d[0],
            a.extend(
              {
                using: function (a) {
                  d.css({ top: Math.round(a.top), left: Math.round(a.left) });
                },
              },
              b
            ),
            0
          ),
          d.addClass("in");
        var i = d[0].offsetWidth,
          j = d[0].offsetHeight;
        "top" == c && j != f && (b.top = b.top + f - j);
        var k = this.getViewportAdjustedDelta(c, b, i, j);
        k.left ? (b.left += k.left) : (b.top += k.top);
        var l = /top|bottom/.test(c),
          m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
          n = l ? "offsetWidth" : "offsetHeight";
        d.offset(b), this.replaceArrow(m, d[0][n], l);
      }),
      (c.prototype.replaceArrow = function (a, b, c) {
        this.arrow()
          .css(c ? "left" : "top", 50 * (1 - a / b) + "%")
          .css(c ? "top" : "left", "");
      }),
      (c.prototype.setContent = function () {
        var a = this.tip(),
          b = this.getTitle();
        a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b),
          a.removeClass("fade in top bottom left right");
      }),
      (c.prototype.hide = function (b) {
        function d() {
          "in" != e.hoverState && f.detach(),
            e.$element &&
              e.$element
                .removeAttr("aria-describedby")
                .trigger("hidden.bs." + e.type),
            b && b();
        }
        var e = this,
          f = a(this.$tip),
          g = a.Event("hide.bs." + this.type);
        if ((this.$element.trigger(g), !g.isDefaultPrevented()))
          return (
            f.removeClass("in"),
            a.support.transition && f.hasClass("fade")
              ? f
                  .one("bsTransitionEnd", d)
                  .emulateTransitionEnd(c.TRANSITION_DURATION)
              : d(),
            (this.hoverState = null),
            this
          );
      }),
      (c.prototype.fixTitle = function () {
        var a = this.$element;
        (a.attr("title") || "string" != typeof a.attr("data-original-title")) &&
          a
            .attr("data-original-title", a.attr("title") || "")
            .attr("title", "");
      }),
      (c.prototype.hasContent = function () {
        return this.getTitle();
      }),
      (c.prototype.getPosition = function (b) {
        b = b || this.$element;
        var c = b[0],
          d = "BODY" == c.tagName,
          e = c.getBoundingClientRect();
        null == e.width &&
          (e = a.extend({}, e, {
            width: e.right - e.left,
            height: e.bottom - e.top,
          }));
        var f = window.SVGElement && c instanceof window.SVGElement,
          g = d ? { top: 0, left: 0 } : f ? null : b.offset(),
          h = {
            scroll: d
              ? document.documentElement.scrollTop || document.body.scrollTop
              : b.scrollTop(),
          },
          i = d
            ? { width: a(window).width(), height: a(window).height() }
            : null;
        return a.extend({}, e, h, i, g);
      }),
      (c.prototype.getCalculatedOffset = function (a, b, c, d) {
        return "bottom" == a
          ? { top: b.top + b.height, left: b.left + b.width / 2 - c / 2 }
          : "top" == a
          ? { top: b.top - d, left: b.left + b.width / 2 - c / 2 }
          : "left" == a
          ? { top: b.top + b.height / 2 - d / 2, left: b.left - c }
          : { top: b.top + b.height / 2 - d / 2, left: b.left + b.width };
      }),
      (c.prototype.getViewportAdjustedDelta = function (a, b, c, d) {
        var e = { top: 0, left: 0 };
        if (!this.$viewport) return e;
        var f = (this.options.viewport && this.options.viewport.padding) || 0,
          g = this.getPosition(this.$viewport);
        if (/right|left/.test(a)) {
          var h = b.top - f - g.scroll,
            i = b.top + f - g.scroll + d;
          h < g.top
            ? (e.top = g.top - h)
            : i > g.top + g.height && (e.top = g.top + g.height - i);
        } else {
          var j = b.left - f,
            k = b.left + f + c;
          j < g.left
            ? (e.left = g.left - j)
            : k > g.right && (e.left = g.left + g.width - k);
        }
        return e;
      }),
      (c.prototype.getTitle = function () {
        var a,
          b = this.$element,
          c = this.options;
        return (a =
          b.attr("data-original-title") ||
          ("function" == typeof c.title ? c.title.call(b[0]) : c.title));
      }),
      (c.prototype.getUID = function (a) {
        do a += ~~(1e6 * Math.random());
        while (document.getElementById(a));
        return a;
      }),
      (c.prototype.tip = function () {
        if (
          !this.$tip &&
          ((this.$tip = a(this.options.template)), 1 != this.$tip.length)
        )
          throw new Error(
            this.type +
              " `template` option must consist of exactly 1 top-level element!"
          );
        return this.$tip;
      }),
      (c.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow"));
      }),
      (c.prototype.enable = function () {
        this.enabled = !0;
      }),
      (c.prototype.disable = function () {
        this.enabled = !1;
      }),
      (c.prototype.toggleEnabled = function () {
        this.enabled = !this.enabled;
      }),
      (c.prototype.toggle = function (b) {
        var c = this;
        b &&
          ((c = a(b.currentTarget).data("bs." + this.type)),
          c ||
            ((c = new this.constructor(
              b.currentTarget,
              this.getDelegateOptions()
            )),
            a(b.currentTarget).data("bs." + this.type, c))),
          b
            ? ((c.inState.click = !c.inState.click),
              c.isInStateTrue() ? c.enter(c) : c.leave(c))
            : c.tip().hasClass("in")
            ? c.leave(c)
            : c.enter(c);
      }),
      (c.prototype.destroy = function () {
        var a = this;
        clearTimeout(this.timeout),
          this.hide(function () {
            a.$element.off("." + a.type).removeData("bs." + a.type),
              a.$tip && a.$tip.detach(),
              (a.$tip = null),
              (a.$arrow = null),
              (a.$viewport = null),
              (a.$element = null);
          });
      });
    var d = a.fn.tooltip;
    (a.fn.tooltip = b),
      (a.fn.tooltip.Constructor = c),
      (a.fn.tooltip.noConflict = function () {
        return (a.fn.tooltip = d), this;
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.popover"),
          f = "object" == typeof b && b;
        (!e && /destroy|hide/.test(b)) ||
          (e || d.data("bs.popover", (e = new c(this, f))),
          "string" == typeof b && e[b]());
      });
    }
    var c = function (a, b) {
      this.init("popover", a, b);
    };
    if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");
    (c.VERSION = "3.3.7"),
      (c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, {
        placement: "right",
        trigger: "click",
        content: "",
        template:
          '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
      })),
      (c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype)),
      (c.prototype.constructor = c),
      (c.prototype.getDefaults = function () {
        return c.DEFAULTS;
      }),
      (c.prototype.setContent = function () {
        var a = this.tip(),
          b = this.getTitle(),
          c = this.getContent();
        a.find(".popover-title")[this.options.html ? "html" : "text"](b),
          a
            .find(".popover-content")
            .children()
            .detach()
            .end()
            [
              this.options.html
                ? "string" == typeof c
                  ? "html"
                  : "append"
                : "text"
            ](c),
          a.removeClass("fade top bottom left right in"),
          a.find(".popover-title").html() || a.find(".popover-title").hide();
      }),
      (c.prototype.hasContent = function () {
        return this.getTitle() || this.getContent();
      }),
      (c.prototype.getContent = function () {
        var a = this.$element,
          b = this.options;
        return (
          a.attr("data-content") ||
          ("function" == typeof b.content ? b.content.call(a[0]) : b.content)
        );
      }),
      (c.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find(".arrow"));
      });
    var d = a.fn.popover;
    (a.fn.popover = b),
      (a.fn.popover.Constructor = c),
      (a.fn.popover.noConflict = function () {
        return (a.fn.popover = d), this;
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(c, d) {
      (this.$body = a(document.body)),
        (this.$scrollElement = a(a(c).is(document.body) ? window : c)),
        (this.options = a.extend({}, b.DEFAULTS, d)),
        (this.selector = (this.options.target || "") + " .nav li > a"),
        (this.offsets = []),
        (this.targets = []),
        (this.activeTarget = null),
        (this.scrollHeight = 0),
        this.$scrollElement.on(
          "scroll.bs.scrollspy",
          a.proxy(this.process, this)
        ),
        this.refresh(),
        this.process();
    }
    function c(c) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.scrollspy"),
          f = "object" == typeof c && c;
        e || d.data("bs.scrollspy", (e = new b(this, f))),
          "string" == typeof c && e[c]();
      });
    }
    (b.VERSION = "3.3.7"),
      (b.DEFAULTS = { offset: 10 }),
      (b.prototype.getScrollHeight = function () {
        return (
          this.$scrollElement[0].scrollHeight ||
          Math.max(
            this.$body[0].scrollHeight,
            document.documentElement.scrollHeight
          )
        );
      }),
      (b.prototype.refresh = function () {
        var b = this,
          c = "offset",
          d = 0;
        (this.offsets = []),
          (this.targets = []),
          (this.scrollHeight = this.getScrollHeight()),
          a.isWindow(this.$scrollElement[0]) ||
            ((c = "position"), (d = this.$scrollElement.scrollTop())),
          this.$body
            .find(this.selector)
            .map(function () {
              var b = a(this),
                e = b.data("target") || b.attr("href"),
                f = /^#./.test(e) && a(e);
              return (
                (f && f.length && f.is(":visible") && [[f[c]().top + d, e]]) ||
                null
              );
            })
            .sort(function (a, b) {
              return a[0] - b[0];
            })
            .each(function () {
              b.offsets.push(this[0]), b.targets.push(this[1]);
            });
      }),
      (b.prototype.process = function () {
        var a,
          b = this.$scrollElement.scrollTop() + this.options.offset,
          c = this.getScrollHeight(),
          d = this.options.offset + c - this.$scrollElement.height(),
          e = this.offsets,
          f = this.targets,
          g = this.activeTarget;
        if ((this.scrollHeight != c && this.refresh(), b >= d))
          return g != (a = f[f.length - 1]) && this.activate(a);
        if (g && b < e[0]) return (this.activeTarget = null), this.clear();
        for (a = e.length; a--; )
          g != f[a] &&
            b >= e[a] &&
            (void 0 === e[a + 1] || b < e[a + 1]) &&
            this.activate(f[a]);
      }),
      (b.prototype.activate = function (b) {
        (this.activeTarget = b), this.clear();
        var c =
            this.selector +
            '[data-target="' +
            b +
            '"],' +
            this.selector +
            '[href="' +
            b +
            '"]',
          d = a(c).parents("li").addClass("active");
        d.parent(".dropdown-menu").length &&
          (d = d.closest("li.dropdown").addClass("active")),
          d.trigger("activate.bs.scrollspy");
      }),
      (b.prototype.clear = function () {
        a(this.selector)
          .parentsUntil(this.options.target, ".active")
          .removeClass("active");
      });
    var d = a.fn.scrollspy;
    (a.fn.scrollspy = c),
      (a.fn.scrollspy.Constructor = b),
      (a.fn.scrollspy.noConflict = function () {
        return (a.fn.scrollspy = d), this;
      }),
      a(window).on("load.bs.scrollspy.data-api", function () {
        a('[data-spy="scroll"]').each(function () {
          var b = a(this);
          c.call(b, b.data());
        });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.tab");
        e || d.data("bs.tab", (e = new c(this))),
          "string" == typeof b && e[b]();
      });
    }
    var c = function (b) {
      this.element = a(b);
    };
    (c.VERSION = "3.3.7"),
      (c.TRANSITION_DURATION = 150),
      (c.prototype.show = function () {
        var b = this.element,
          c = b.closest("ul:not(.dropdown-menu)"),
          d = b.data("target");
        if (
          (d ||
            ((d = b.attr("href")), (d = d && d.replace(/.*(?=#[^\s]*$)/, ""))),
          !b.parent("li").hasClass("active"))
        ) {
          var e = c.find(".active:last a"),
            f = a.Event("hide.bs.tab", { relatedTarget: b[0] }),
            g = a.Event("show.bs.tab", { relatedTarget: e[0] });
          if (
            (e.trigger(f),
            b.trigger(g),
            !g.isDefaultPrevented() && !f.isDefaultPrevented())
          ) {
            var h = a(d);
            this.activate(b.closest("li"), c),
              this.activate(h, h.parent(), function () {
                e.trigger({ type: "hidden.bs.tab", relatedTarget: b[0] }),
                  b.trigger({ type: "shown.bs.tab", relatedTarget: e[0] });
              });
          }
        }
      }),
      (c.prototype.activate = function (b, d, e) {
        function f() {
          g
            .removeClass("active")
            .find("> .dropdown-menu > .active")
            .removeClass("active")
            .end()
            .find('[data-toggle="tab"]')
            .attr("aria-expanded", !1),
            b
              .addClass("active")
              .find('[data-toggle="tab"]')
              .attr("aria-expanded", !0),
            h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"),
            b.parent(".dropdown-menu").length &&
              b
                .closest("li.dropdown")
                .addClass("active")
                .end()
                .find('[data-toggle="tab"]')
                .attr("aria-expanded", !0),
            e && e();
        }
        var g = d.find("> .active"),
          h =
            e &&
            a.support.transition &&
            ((g.length && g.hasClass("fade")) || !!d.find("> .fade").length);
        g.length && h
          ? g
              .one("bsTransitionEnd", f)
              .emulateTransitionEnd(c.TRANSITION_DURATION)
          : f(),
          g.removeClass("in");
      });
    var d = a.fn.tab;
    (a.fn.tab = b),
      (a.fn.tab.Constructor = c),
      (a.fn.tab.noConflict = function () {
        return (a.fn.tab = d), this;
      });
    var e = function (c) {
      c.preventDefault(), b.call(a(this), "show");
    };
    a(document)
      .on("click.bs.tab.data-api", '[data-toggle="tab"]', e)
      .on("click.bs.tab.data-api", '[data-toggle="pill"]', e);
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.affix"),
          f = "object" == typeof b && b;
        e || d.data("bs.affix", (e = new c(this, f))),
          "string" == typeof b && e[b]();
      });
    }
    var c = function (b, d) {
      (this.options = a.extend({}, c.DEFAULTS, d)),
        (this.$target = a(this.options.target)
          .on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this))
          .on(
            "click.bs.affix.data-api",
            a.proxy(this.checkPositionWithEventLoop, this)
          )),
        (this.$element = a(b)),
        (this.affixed = null),
        (this.unpin = null),
        (this.pinnedOffset = null),
        this.checkPosition();
    };
    (c.VERSION = "3.3.7"),
      (c.RESET = "affix affix-top affix-bottom"),
      (c.DEFAULTS = { offset: 0, target: window }),
      (c.prototype.getState = function (a, b, c, d) {
        var e = this.$target.scrollTop(),
          f = this.$element.offset(),
          g = this.$target.height();
        if (null != c && "top" == this.affixed) return e < c && "top";
        if ("bottom" == this.affixed)
          return null != c
            ? !(e + this.unpin <= f.top) && "bottom"
            : !(e + g <= a - d) && "bottom";
        var h = null == this.affixed,
          i = h ? e : f.top,
          j = h ? g : b;
        return null != c && e <= c
          ? "top"
          : null != d && i + j >= a - d && "bottom";
      }),
      (c.prototype.getPinnedOffset = function () {
        if (this.pinnedOffset) return this.pinnedOffset;
        this.$element.removeClass(c.RESET).addClass("affix");
        var a = this.$target.scrollTop(),
          b = this.$element.offset();
        return (this.pinnedOffset = b.top - a);
      }),
      (c.prototype.checkPositionWithEventLoop = function () {
        setTimeout(a.proxy(this.checkPosition, this), 1);
      }),
      (c.prototype.checkPosition = function () {
        if (this.$element.is(":visible")) {
          var b = this.$element.height(),
            d = this.options.offset,
            e = d.top,
            f = d.bottom,
            g = Math.max(a(document).height(), a(document.body).height());
          "object" != typeof d && (f = e = d),
            "function" == typeof e && (e = d.top(this.$element)),
            "function" == typeof f && (f = d.bottom(this.$element));
          var h = this.getState(g, b, e, f);
          if (this.affixed != h) {
            null != this.unpin && this.$element.css("top", "");
            var i = "affix" + (h ? "-" + h : ""),
              j = a.Event(i + ".bs.affix");
            if ((this.$element.trigger(j), j.isDefaultPrevented())) return;
            (this.affixed = h),
              (this.unpin = "bottom" == h ? this.getPinnedOffset() : null),
              this.$element
                .removeClass(c.RESET)
                .addClass(i)
                .trigger(i.replace("affix", "affixed") + ".bs.affix");
          }
          "bottom" == h && this.$element.offset({ top: g - b - f });
        }
      });
    var d = a.fn.affix;
    (a.fn.affix = b),
      (a.fn.affix.Constructor = c),
      (a.fn.affix.noConflict = function () {
        return (a.fn.affix = d), this;
      }),
      a(window).on("load", function () {
        a('[data-spy="affix"]').each(function () {
          var c = a(this),
            d = c.data();
          (d.offset = d.offset || {}),
            null != d.offsetBottom && (d.offset.bottom = d.offsetBottom),
            null != d.offsetTop && (d.offset.top = d.offsetTop),
            b.call(c, d);
        });
      });
  })(jQuery);

/* xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
(function (e) {
  if ("object" == typeof exports && "undefined" != typeof module)
    module.exports = e();
  else if ("function" == typeof define && define.amd) {
    JSZip = e();
    define([], e);
  } else {
    var r;
    "undefined" != typeof window
      ? (r = window)
      : "undefined" != typeof global
      ? (r = global)
      : "undefined" != typeof $ && $.global
      ? (r = $.global)
      : "undefined" != typeof self && (r = self),
      (r.JSZip = e());
  }
})(function () {
  var e, r, t;
  return (function a(e, r, t) {
    function n(s, f) {
      if (!r[s]) {
        if (!e[s]) {
          var o = typeof require == "function" && require;
          if (!f && o) return o(s, !0);
          if (i) return i(s, !0);
          throw new Error("Cannot find module '" + s + "'");
        }
        var l = (r[s] = { exports: {} });
        e[s][0].call(
          l.exports,
          function (r) {
            var t = e[s][1][r];
            return n(t ? t : r);
          },
          l,
          l.exports,
          a,
          e,
          r,
          t
        );
      }
      return r[s].exports;
    }
    var i = typeof require == "function" && require;
    for (var s = 0; s < t.length; s++) n(t[s]);
    return n;
  })(
    {
      1: [
        function (e, r, t) {
          "use strict";
          var a =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          t.encode = function (e, r) {
            var t = "";
            var n, i, s, f, o, l, c;
            var h = 0;
            while (h < e.length) {
              n = e.charCodeAt(h++);
              i = e.charCodeAt(h++);
              s = e.charCodeAt(h++);
              f = n >> 2;
              o = ((n & 3) << 4) | (i >> 4);
              l = ((i & 15) << 2) | (s >> 6);
              c = s & 63;
              if (isNaN(i)) {
                l = c = 64;
              } else if (isNaN(s)) {
                c = 64;
              }
              t = t + a.charAt(f) + a.charAt(o) + a.charAt(l) + a.charAt(c);
            }
            return t;
          };
          t.decode = function (e, r) {
            var t = "";
            var n, i, s;
            var f, o, l, c;
            var h = 0;
            e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
            while (h < e.length) {
              f = a.indexOf(e.charAt(h++));
              o = a.indexOf(e.charAt(h++));
              l = a.indexOf(e.charAt(h++));
              c = a.indexOf(e.charAt(h++));
              n = (f << 2) | (o >> 4);
              i = ((o & 15) << 4) | (l >> 2);
              s = ((l & 3) << 6) | c;
              t = t + String.fromCharCode(n);
              if (l != 64) {
                t = t + String.fromCharCode(i);
              }
              if (c != 64) {
                t = t + String.fromCharCode(s);
              }
            }
            return t;
          };
        },
        {},
      ],
      2: [
        function (e, r, t) {
          "use strict";
          function a() {
            this.compressedSize = 0;
            this.uncompressedSize = 0;
            this.crc32 = 0;
            this.compressionMethod = null;
            this.compressedContent = null;
          }
          a.prototype = {
            getContent: function () {
              return null;
            },
            getCompressedContent: function () {
              return null;
            },
          };
          r.exports = a;
        },
        {},
      ],
      3: [
        function (e, r, t) {
          "use strict";
          t.STORE = {
            magic: "\0\0",
            compress: function (e) {
              return e;
            },
            uncompress: function (e) {
              return e;
            },
            compressInputType: null,
            uncompressInputType: null,
          };
          t.DEFLATE = e("./flate");
        },
        { "./flate": 8 },
      ],
      4: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          var n = [
            0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615,
            3915621685, 2657392035, 249268274, 2044508324, 3772115230,
            2547177864, 162941995, 2125561021, 3887607047, 2428444049,
            498536548, 1789927666, 4089016648, 2227061214, 450548861,
            1843258603, 4107580753, 2211677639, 325883990, 1684777152,
            4251122042, 2321926636, 335633487, 1661365465, 4195302755,
            2366115317, 997073096, 1281953886, 3579855332, 2724688242,
            1006888145, 1258607687, 3524101629, 2768942443, 901097722,
            1119000684, 3686517206, 2898065728, 853044451, 1172266101,
            3705015759, 2882616665, 651767980, 1373503546, 3369554304,
            3218104598, 565507253, 1454621731, 3485111705, 3099436303,
            671266974, 1594198024, 3322730930, 2970347812, 795835527,
            1483230225, 3244367275, 3060149565, 1994146192, 31158534,
            2563907772, 4023717930, 1907459465, 112637215, 2680153253,
            3904427059, 2013776290, 251722036, 2517215374, 3775830040,
            2137656763, 141376813, 2439277719, 3865271297, 1802195444,
            476864866, 2238001368, 4066508878, 1812370925, 453092731,
            2181625025, 4111451223, 1706088902, 314042704, 2344532202,
            4240017532, 1658658271, 366619977, 2362670323, 4224994405,
            1303535960, 984961486, 2747007092, 3569037538, 1256170817,
            1037604311, 2765210733, 3554079995, 1131014506, 879679996,
            2909243462, 3663771856, 1141124467, 855842277, 2852801631,
            3708648649, 1342533948, 654459306, 3188396048, 3373015174,
            1466479909, 544179635, 3110523913, 3462522015, 1591671054,
            702138776, 2966460450, 3352799412, 1504918807, 783551873,
            3082640443, 3233442989, 3988292384, 2596254646, 62317068,
            1957810842, 3939845945, 2647816111, 81470997, 1943803523,
            3814918930, 2489596804, 225274430, 2053790376, 3826175755,
            2466906013, 167816743, 2097651377, 4027552580, 2265490386,
            503444072, 1762050814, 4150417245, 2154129355, 426522225,
            1852507879, 4275313526, 2312317920, 282753626, 1742555852,
            4189708143, 2394877945, 397917763, 1622183637, 3604390888,
            2714866558, 953729732, 1340076626, 3518719985, 2797360999,
            1068828381, 1219638859, 3624741850, 2936675148, 906185462,
            1090812512, 3747672003, 2825379669, 829329135, 1181335161,
            3412177804, 3160834842, 628085408, 1382605366, 3423369109,
            3138078467, 570562233, 1426400815, 3317316542, 2998733608,
            733239954, 1555261956, 3268935591, 3050360625, 752459403,
            1541320221, 2607071920, 3965973030, 1969922972, 40735498,
            2617837225, 3943577151, 1913087877, 83908371, 2512341634,
            3803740692, 2075208622, 213261112, 2463272603, 3855990285,
            2094854071, 198958881, 2262029012, 4057260610, 1759359992,
            534414190, 2176718541, 4139329115, 1873836001, 414664567,
            2282248934, 4279200368, 1711684554, 285281116, 2405801727,
            4167216745, 1634467795, 376229701, 2685067896, 3608007406,
            1308918612, 956543938, 2808555105, 3495958263, 1231636301,
            1047427035, 2932959818, 3654703836, 1088359270, 936918e3,
            2847714899, 3736837829, 1202900863, 817233897, 3183342108,
            3401237130, 1404277552, 615818150, 3134207493, 3453421203,
            1423857449, 601450431, 3009837614, 3294710456, 1567103746,
            711928724, 3020668471, 3272380065, 1510334235, 755167117,
          ];
          r.exports = function i(e, r) {
            if (typeof e === "undefined" || !e.length) {
              return 0;
            }
            var t = a.getTypeOf(e) !== "string";
            if (typeof r == "undefined") {
              r = 0;
            }
            var i = 0;
            var s = 0;
            var f = 0;
            r = r ^ -1;
            for (var o = 0, l = e.length; o < l; o++) {
              f = t ? e[o] : e.charCodeAt(o);
              s = (r ^ f) & 255;
              i = n[s];
              r = (r >>> 8) ^ i;
            }
            return r ^ -1;
          };
        },
        { "./utils": 21 },
      ],
      5: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          function n(e) {
            this.data = null;
            this.length = 0;
            this.index = 0;
          }
          n.prototype = {
            checkOffset: function (e) {
              this.checkIndex(this.index + e);
            },
            checkIndex: function (e) {
              if (this.length < e || e < 0) {
                throw new Error(
                  "End of data reached (data length = " +
                    this.length +
                    ", asked index = " +
                    e +
                    "). Corrupted zip ?"
                );
              }
            },
            setIndex: function (e) {
              this.checkIndex(e);
              this.index = e;
            },
            skip: function (e) {
              this.setIndex(this.index + e);
            },
            byteAt: function (e) {},
            readInt: function (e) {
              var r = 0,
                t;
              this.checkOffset(e);
              for (t = this.index + e - 1; t >= this.index; t--) {
                r = (r << 8) + this.byteAt(t);
              }
              this.index += e;
              return r;
            },
            readString: function (e) {
              return a.transformTo("string", this.readData(e));
            },
            readData: function (e) {},
            lastIndexOfSignature: function (e) {},
            readDate: function () {
              var e = this.readInt(4);
              return new Date(
                ((e >> 25) & 127) + 1980,
                ((e >> 21) & 15) - 1,
                (e >> 16) & 31,
                (e >> 11) & 31,
                (e >> 5) & 63,
                (e & 31) << 1
              );
            },
          };
          r.exports = n;
        },
        { "./utils": 21 },
      ],
      6: [
        function (e, r, t) {
          "use strict";
          t.base64 = false;
          t.binary = false;
          t.dir = false;
          t.createFolders = false;
          t.date = null;
          t.compression = null;
          t.comment = null;
        },
        {},
      ],
      7: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          t.string2binary = function (e) {
            return a.string2binary(e);
          };
          t.string2Uint8Array = function (e) {
            return a.transformTo("uint8array", e);
          };
          t.uint8Array2String = function (e) {
            return a.transformTo("string", e);
          };
          t.string2Blob = function (e) {
            var r = a.transformTo("arraybuffer", e);
            return a.arrayBuffer2Blob(r);
          };
          t.arrayBuffer2Blob = function (e) {
            return a.arrayBuffer2Blob(e);
          };
          t.transformTo = function (e, r) {
            return a.transformTo(e, r);
          };
          t.getTypeOf = function (e) {
            return a.getTypeOf(e);
          };
          t.checkSupport = function (e) {
            return a.checkSupport(e);
          };
          t.MAX_VALUE_16BITS = a.MAX_VALUE_16BITS;
          t.MAX_VALUE_32BITS = a.MAX_VALUE_32BITS;
          t.pretty = function (e) {
            return a.pretty(e);
          };
          t.findCompression = function (e) {
            return a.findCompression(e);
          };
          t.isRegExp = function (e) {
            return a.isRegExp(e);
          };
        },
        { "./utils": 21 },
      ],
      8: [
        function (e, r, t) {
          "use strict";
          var a =
            typeof Uint8Array !== "undefined" &&
            typeof Uint16Array !== "undefined" &&
            typeof Uint32Array !== "undefined";
          var n = e("pako");
          t.uncompressInputType = a ? "uint8array" : "array";
          t.compressInputType = a ? "uint8array" : "array";
          t.magic = "\b\0";
          t.compress = function (e) {
            return n.deflateRaw(e);
          };
          t.uncompress = function (e) {
            return n.inflateRaw(e);
          };
        },
        { pako: 24 },
      ],
      9: [
        function (e, r, t) {
          "use strict";
          var a = e("./base64");
          function n(e, r) {
            if (!(this instanceof n)) return new n(e, r);
            this.files = {};
            this.comment = null;
            this.root = "";
            if (e) {
              this.load(e, r);
            }
            this.clone = function () {
              var e = new n();
              for (var r in this) {
                if (typeof this[r] !== "function") {
                  e[r] = this[r];
                }
              }
              return e;
            };
          }
          n.prototype = e("./object");
          n.prototype.load = e("./load");
          n.support = e("./support");
          n.defaults = e("./defaults");
          n.utils = e("./deprecatedPublicUtils");
          n.base64 = {
            encode: function (e) {
              return a.encode(e);
            },
            decode: function (e) {
              return a.decode(e);
            },
          };
          n.compressions = e("./compressions");
          r.exports = n;
        },
        {
          "./base64": 1,
          "./compressions": 3,
          "./defaults": 6,
          "./deprecatedPublicUtils": 7,
          "./load": 10,
          "./object": 13,
          "./support": 17,
        },
      ],
      10: [
        function (e, r, t) {
          "use strict";
          var a = e("./base64");
          var n = e("./zipEntries");
          r.exports = function (e, r) {
            var t, i, s, f;
            r = r || {};
            if (r.base64) {
              e = a.decode(e);
            }
            i = new n(e, r);
            t = i.files;
            for (s = 0; s < t.length; s++) {
              f = t[s];
              this.file(f.fileName, f.decompressed, {
                binary: true,
                optimizedBinaryString: true,
                date: f.date,
                dir: f.dir,
                comment: f.fileComment.length ? f.fileComment : null,
                createFolders: r.createFolders,
              });
            }
            if (i.zipComment.length) {
              this.comment = i.zipComment;
            }
            return this;
          };
        },
        { "./base64": 1, "./zipEntries": 22 },
      ],
      11: [
        function (e, r, t) {
          (function (e) {
            "use strict";
            r.exports = function (r, t) {
              return new e(r, t);
            };
            r.exports.test = function (r) {
              return e.isBuffer(r);
            };
          }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
        },
        {},
      ],
      12: [
        function (e, r, t) {
          "use strict";
          var a = e("./uint8ArrayReader");
          function n(e) {
            this.data = e;
            this.length = this.data.length;
            this.index = 0;
          }
          n.prototype = new a();
          n.prototype.readData = function (e) {
            this.checkOffset(e);
            var r = this.data.slice(this.index, this.index + e);
            this.index += e;
            return r;
          };
          r.exports = n;
        },
        { "./uint8ArrayReader": 18 },
      ],
      13: [
        function (e, r, t) {
          "use strict";
          var a = e("./support");
          var n = e("./utils");
          var i = e("./crc32");
          var s = e("./signature");
          var f = e("./defaults");
          var o = e("./base64");
          var l = e("./compressions");
          var c = e("./compressedObject");
          var h = e("./nodeBuffer");
          var u = e("./utf8");
          var d = e("./stringWriter");
          var v = e("./uint8ArrayWriter");
          var p = function (e) {
            if (e._data instanceof c) {
              e._data = e._data.getContent();
              e.options.binary = true;
              e.options.base64 = false;
              if (n.getTypeOf(e._data) === "uint8array") {
                var r = e._data;
                e._data = new Uint8Array(r.length);
                if (r.length !== 0) {
                  e._data.set(r, 0);
                }
              }
            }
            return e._data;
          };
          var g = function (e) {
            var r = p(e),
              t = n.getTypeOf(r);
            if (t === "string") {
              if (!e.options.binary) {
                if (a.nodebuffer) {
                  return h(r, "utf-8");
                }
              }
              return e.asBinary();
            }
            return r;
          };
          var b = function (e) {
            var r = p(this);
            if (r === null || typeof r === "undefined") {
              return "";
            }
            if (this.options.base64) {
              r = o.decode(r);
            }
            if (e && this.options.binary) {
              r = T.utf8decode(r);
            } else {
              r = n.transformTo("string", r);
            }
            if (!e && !this.options.binary) {
              r = n.transformTo("string", T.utf8encode(r));
            }
            return r;
          };
          var m = function (e, r, t) {
            this.name = e;
            this.dir = t.dir;
            this.date = t.date;
            this.comment = t.comment;
            this._data = r;
            this.options = t;
            this._initialMetadata = { dir: t.dir, date: t.date };
          };
          m.prototype = {
            asText: function () {
              return b.call(this, true);
            },
            asBinary: function () {
              return b.call(this, false);
            },
            asNodeBuffer: function () {
              var e = g(this);
              return n.transformTo("nodebuffer", e);
            },
            asUint8Array: function () {
              var e = g(this);
              return n.transformTo("uint8array", e);
            },
            asArrayBuffer: function () {
              return this.asUint8Array().buffer;
            },
          };
          var C = function (e, r) {
            var t = "",
              a;
            for (a = 0; a < r; a++) {
              t += String.fromCharCode(e & 255);
              e = e >>> 8;
            }
            return t;
          };
          var E = function () {
            var e = {},
              r,
              t;
            for (r = 0; r < arguments.length; r++) {
              for (t in arguments[r]) {
                if (
                  arguments[r].hasOwnProperty(t) &&
                  typeof e[t] === "undefined"
                ) {
                  e[t] = arguments[r][t];
                }
              }
            }
            return e;
          };
          var k = function (e) {
            e = e || {};
            if (
              e.base64 === true &&
              (e.binary === null || e.binary === undefined)
            ) {
              e.binary = true;
            }
            e = E(e, f);
            e.date = e.date || new Date();
            if (e.compression !== null)
              e.compression = e.compression.toUpperCase();
            return e;
          };
          var S = function (e, r, t) {
            var a = n.getTypeOf(r),
              i;
            t = k(t);
            if (t.createFolders && (i = w(e))) {
              A.call(this, i, true);
            }
            if (t.dir || r === null || typeof r === "undefined") {
              t.base64 = false;
              t.binary = false;
              r = null;
            } else if (a === "string") {
              if (t.binary && !t.base64) {
                if (t.optimizedBinaryString !== true) {
                  r = n.string2binary(r);
                }
              }
            } else {
              t.base64 = false;
              t.binary = true;
              if (!a && !(r instanceof c)) {
                throw new Error(
                  "The data of '" + e + "' is in an unsupported format !"
                );
              }
              if (a === "arraybuffer") {
                r = n.transformTo("uint8array", r);
              }
            }
            var s = new m(e, r, t);
            this.files[e] = s;
            return s;
          };
          var w = function (e) {
            if (e.slice(-1) == "/") {
              e = e.substring(0, e.length - 1);
            }
            var r = e.lastIndexOf("/");
            return r > 0 ? e.substring(0, r) : "";
          };
          var A = function (e, r) {
            if (e.slice(-1) != "/") {
              e += "/";
            }
            r = typeof r !== "undefined" ? r : false;
            if (!this.files[e]) {
              S.call(this, e, null, { dir: true, createFolders: r });
            }
            return this.files[e];
          };
          var B = function (e, r) {
            var t = new c(),
              a;
            if (e._data instanceof c) {
              t.uncompressedSize = e._data.uncompressedSize;
              t.crc32 = e._data.crc32;
              if (t.uncompressedSize === 0 || e.dir) {
                r = l["STORE"];
                t.compressedContent = "";
                t.crc32 = 0;
              } else if (e._data.compressionMethod === r.magic) {
                t.compressedContent = e._data.getCompressedContent();
              } else {
                a = e._data.getContent();
                t.compressedContent = r.compress(
                  n.transformTo(r.compressInputType, a)
                );
              }
            } else {
              a = g(e);
              if (!a || a.length === 0 || e.dir) {
                r = l["STORE"];
                a = "";
              }
              t.uncompressedSize = a.length;
              t.crc32 = i(a);
              t.compressedContent = r.compress(
                n.transformTo(r.compressInputType, a)
              );
            }
            t.compressedSize = t.compressedContent.length;
            t.compressionMethod = r.magic;
            return t;
          };
          var _ = function (e, r, t, a) {
            var f = t.compressedContent,
              o = n.transformTo("string", u.utf8encode(r.name)),
              l = r.comment || "",
              c = n.transformTo("string", u.utf8encode(l)),
              h = o.length !== r.name.length,
              d = c.length !== l.length,
              v = r.options,
              p,
              g,
              b = "",
              m = "",
              E = "",
              k,
              S;
            if (r._initialMetadata.dir !== r.dir) {
              k = r.dir;
            } else {
              k = v.dir;
            }
            if (r._initialMetadata.date !== r.date) {
              S = r.date;
            } else {
              S = v.date;
            }
            p = S.getHours();
            p = p << 6;
            p = p | S.getMinutes();
            p = p << 5;
            p = p | (S.getSeconds() / 2);
            g = S.getFullYear() - 1980;
            g = g << 4;
            g = g | (S.getMonth() + 1);
            g = g << 5;
            g = g | S.getDate();
            if (h) {
              m = C(1, 1) + C(i(o), 4) + o;
              b += "up" + C(m.length, 2) + m;
            }
            if (d) {
              E = C(1, 1) + C(this.crc32(c), 4) + c;
              b += "uc" + C(E.length, 2) + E;
            }
            var w = "";
            w += "\n\0";
            w += h || d ? "\0\b" : "\0\0";
            w += t.compressionMethod;
            w += C(p, 2);
            w += C(g, 2);
            w += C(t.crc32, 4);
            w += C(t.compressedSize, 4);
            w += C(t.uncompressedSize, 4);
            w += C(o.length, 2);
            w += C(b.length, 2);
            var A = s.LOCAL_FILE_HEADER + w + o + b;
            var B =
              s.CENTRAL_FILE_HEADER +
              "\0" +
              w +
              C(c.length, 2) +
              "\0\0" +
              "\0\0" +
              (k === true ? "\0\0\0" : "\0\0\0\0") +
              C(a, 4) +
              o +
              b +
              c;
            return { fileRecord: A, dirRecord: B, compressedObject: t };
          };
          var T = {
            load: function (e, r) {
              throw new Error(
                "Load method is not defined. Is the file jszip-load.js included ?"
              );
            },
            filter: function (e) {
              var r = [],
                t,
                a,
                n,
                i;
              for (t in this.files) {
                if (!this.files.hasOwnProperty(t)) {
                  continue;
                }
                n = this.files[t];
                i = new m(n.name, n._data, E(n.options));
                a = t.slice(this.root.length, t.length);
                if (t.slice(0, this.root.length) === this.root && e(a, i)) {
                  r.push(i);
                }
              }
              return r;
            },
            file: function (e, r, t) {
              if (arguments.length === 1) {
                if (n.isRegExp(e)) {
                  var a = e;
                  return this.filter(function (e, r) {
                    return !r.dir && a.test(e);
                  });
                } else {
                  return (
                    this.filter(function (r, t) {
                      return !t.dir && r === e;
                    })[0] || null
                  );
                }
              } else {
                e = this.root + e;
                S.call(this, e, r, t);
              }
              return this;
            },
            folder: function (e) {
              if (!e) {
                return this;
              }
              if (n.isRegExp(e)) {
                return this.filter(function (r, t) {
                  return t.dir && e.test(r);
                });
              }
              var r = this.root + e;
              var t = A.call(this, r);
              var a = this.clone();
              a.root = t.name;
              return a;
            },
            remove: function (e) {
              e = this.root + e;
              var r = this.files[e];
              if (!r) {
                if (e.slice(-1) != "/") {
                  e += "/";
                }
                r = this.files[e];
              }
              if (r && !r.dir) {
                delete this.files[e];
              } else {
                var t = this.filter(function (r, t) {
                  return t.name.slice(0, e.length) === e;
                });
                for (var a = 0; a < t.length; a++) {
                  delete this.files[t[a].name];
                }
              }
              return this;
            },
            generate: function (e) {
              e = E(e || {}, {
                base64: true,
                compression: "STORE",
                type: "base64",
                comment: null,
              });
              n.checkSupport(e.type);
              var r = [],
                t = 0,
                a = 0,
                i,
                f,
                c = n.transformTo(
                  "string",
                  this.utf8encode(e.comment || this.comment || "")
                );
              for (var h in this.files) {
                if (!this.files.hasOwnProperty(h)) {
                  continue;
                }
                var u = this.files[h];
                var p = u.options.compression || e.compression.toUpperCase();
                var g = l[p];
                if (!g) {
                  throw new Error(p + " is not a valid compression method !");
                }
                var b = B.call(this, u, g);
                var m = _.call(this, h, u, b, t);
                t += m.fileRecord.length + b.compressedSize;
                a += m.dirRecord.length;
                r.push(m);
              }
              var k = "";
              k =
                s.CENTRAL_DIRECTORY_END +
                "\0\0" +
                "\0\0" +
                C(r.length, 2) +
                C(r.length, 2) +
                C(a, 4) +
                C(t, 4) +
                C(c.length, 2) +
                c;
              var S = e.type.toLowerCase();
              if (
                S === "uint8array" ||
                S === "arraybuffer" ||
                S === "blob" ||
                S === "nodebuffer"
              ) {
                i = new v(t + a + k.length);
              } else {
                i = new d(t + a + k.length);
              }
              for (f = 0; f < r.length; f++) {
                i.append(r[f].fileRecord);
                i.append(r[f].compressedObject.compressedContent);
              }
              for (f = 0; f < r.length; f++) {
                i.append(r[f].dirRecord);
              }
              i.append(k);
              var w = i.finalize();
              switch (e.type.toLowerCase()) {
                case "uint8array":
                case "arraybuffer":
                case "nodebuffer":
                  return n.transformTo(e.type.toLowerCase(), w);
                case "blob":
                  return n.arrayBuffer2Blob(n.transformTo("arraybuffer", w));
                case "base64":
                  return e.base64 ? o.encode(w) : w;
                default:
                  return w;
              }
            },
            crc32: function (e, r) {
              return i(e, r);
            },
            utf8encode: function (e) {
              return n.transformTo("string", u.utf8encode(e));
            },
            utf8decode: function (e) {
              return u.utf8decode(e);
            },
          };
          r.exports = T;
        },
        {
          "./base64": 1,
          "./compressedObject": 2,
          "./compressions": 3,
          "./crc32": 4,
          "./defaults": 6,
          "./nodeBuffer": 11,
          "./signature": 14,
          "./stringWriter": 16,
          "./support": 17,
          "./uint8ArrayWriter": 19,
          "./utf8": 20,
          "./utils": 21,
        },
      ],
      14: [
        function (e, r, t) {
          "use strict";
          t.LOCAL_FILE_HEADER = "PK";
          t.CENTRAL_FILE_HEADER = "PK";
          t.CENTRAL_DIRECTORY_END = "PK";
          t.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK";
          t.ZIP64_CENTRAL_DIRECTORY_END = "PK";
          t.DATA_DESCRIPTOR = "PK\b";
        },
        {},
      ],
      15: [
        function (e, r, t) {
          "use strict";
          var a = e("./dataReader");
          var n = e("./utils");
          function i(e, r) {
            this.data = e;
            if (!r) {
              this.data = n.string2binary(this.data);
            }
            this.length = this.data.length;
            this.index = 0;
          }
          i.prototype = new a();
          i.prototype.byteAt = function (e) {
            return this.data.charCodeAt(e);
          };
          i.prototype.lastIndexOfSignature = function (e) {
            return this.data.lastIndexOf(e);
          };
          i.prototype.readData = function (e) {
            this.checkOffset(e);
            var r = this.data.slice(this.index, this.index + e);
            this.index += e;
            return r;
          };
          r.exports = i;
        },
        { "./dataReader": 5, "./utils": 21 },
      ],
      16: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          var n = function () {
            this.data = [];
          };
          n.prototype = {
            append: function (e) {
              e = a.transformTo("string", e);
              this.data.push(e);
            },
            finalize: function () {
              return this.data.join("");
            },
          };
          r.exports = n;
        },
        { "./utils": 21 },
      ],
      17: [
        function (e, r, t) {
          (function (e) {
            "use strict";
            t.base64 = true;
            t.array = true;
            t.string = true;
            t.arraybuffer =
              typeof ArrayBuffer !== "undefined" &&
              typeof Uint8Array !== "undefined";
            t.nodebuffer = typeof e !== "undefined";
            t.uint8array = typeof Uint8Array !== "undefined";
            if (typeof ArrayBuffer === "undefined") {
              t.blob = false;
            } else {
              var r = new ArrayBuffer(0);
              try {
                t.blob = new Blob([r], { type: "application/zip" }).size === 0;
              } catch (a) {
                try {
                  var n =
                    window.BlobBuilder ||
                    window.WebKitBlobBuilder ||
                    window.MozBlobBuilder ||
                    window.MSBlobBuilder;
                  var i = new n();
                  i.append(r);
                  t.blob = i.getBlob("application/zip").size === 0;
                } catch (a) {
                  t.blob = false;
                }
              }
            }
          }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
        },
        {},
      ],
      18: [
        function (e, r, t) {
          "use strict";
          var a = e("./dataReader");
          function n(e) {
            if (e) {
              this.data = e;
              this.length = this.data.length;
              this.index = 0;
            }
          }
          n.prototype = new a();
          n.prototype.byteAt = function (e) {
            return this.data[e];
          };
          n.prototype.lastIndexOfSignature = function (e) {
            var r = e.charCodeAt(0),
              t = e.charCodeAt(1),
              a = e.charCodeAt(2),
              n = e.charCodeAt(3);
            for (var i = this.length - 4; i >= 0; --i) {
              if (
                this.data[i] === r &&
                this.data[i + 1] === t &&
                this.data[i + 2] === a &&
                this.data[i + 3] === n
              ) {
                return i;
              }
            }
            return -1;
          };
          n.prototype.readData = function (e) {
            this.checkOffset(e);
            if (e === 0) {
              return new Uint8Array(0);
            }
            var r = this.data.subarray(this.index, this.index + e);
            this.index += e;
            return r;
          };
          r.exports = n;
        },
        { "./dataReader": 5 },
      ],
      19: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          var n = function (e) {
            this.data = new Uint8Array(e);
            this.index = 0;
          };
          n.prototype = {
            append: function (e) {
              if (e.length !== 0) {
                e = a.transformTo("uint8array", e);
                this.data.set(e, this.index);
                this.index += e.length;
              }
            },
            finalize: function () {
              return this.data;
            },
          };
          r.exports = n;
        },
        { "./utils": 21 },
      ],
      20: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          var n = e("./support");
          var i = e("./nodeBuffer");
          var s = new Array(256);
          for (var f = 0; f < 256; f++) {
            s[f] =
              f >= 252
                ? 6
                : f >= 248
                ? 5
                : f >= 240
                ? 4
                : f >= 224
                ? 3
                : f >= 192
                ? 2
                : 1;
          }
          s[254] = s[254] = 1;
          var o = function (e) {
            var r,
              t,
              a,
              i,
              s,
              f = e.length,
              o = 0;
            for (i = 0; i < f; i++) {
              t = e.charCodeAt(i);
              if ((t & 64512) === 55296 && i + 1 < f) {
                a = e.charCodeAt(i + 1);
                if ((a & 64512) === 56320) {
                  t = 65536 + ((t - 55296) << 10) + (a - 56320);
                  i++;
                }
              }
              o += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
            }
            if (n.uint8array) {
              r = new Uint8Array(o);
            } else {
              r = new Array(o);
            }
            for (s = 0, i = 0; s < o; i++) {
              t = e.charCodeAt(i);
              if ((t & 64512) === 55296 && i + 1 < f) {
                a = e.charCodeAt(i + 1);
                if ((a & 64512) === 56320) {
                  t = 65536 + ((t - 55296) << 10) + (a - 56320);
                  i++;
                }
              }
              if (t < 128) {
                r[s++] = t;
              } else if (t < 2048) {
                r[s++] = 192 | (t >>> 6);
                r[s++] = 128 | (t & 63);
              } else if (t < 65536) {
                r[s++] = 224 | (t >>> 12);
                r[s++] = 128 | ((t >>> 6) & 63);
                r[s++] = 128 | (t & 63);
              } else {
                r[s++] = 240 | (t >>> 18);
                r[s++] = 128 | ((t >>> 12) & 63);
                r[s++] = 128 | ((t >>> 6) & 63);
                r[s++] = 128 | (t & 63);
              }
            }
            return r;
          };
          var l = function (e, r) {
            var t;
            r = r || e.length;
            if (r > e.length) {
              r = e.length;
            }
            t = r - 1;
            while (t >= 0 && (e[t] & 192) === 128) {
              t--;
            }
            if (t < 0) {
              return r;
            }
            if (t === 0) {
              return r;
            }
            return t + s[e[t]] > r ? t : r;
          };
          var c = function (e) {
            var r, t, n, i, f;
            var o = e.length;
            var l = new Array(o * 2);
            for (n = 0, t = 0; t < o; ) {
              i = e[t++];
              if (i < 128) {
                l[n++] = i;
                continue;
              }
              f = s[i];
              if (f > 4) {
                l[n++] = 65533;
                t += f - 1;
                continue;
              }
              i &= f === 2 ? 31 : f === 3 ? 15 : 7;
              while (f > 1 && t < o) {
                i = (i << 6) | (e[t++] & 63);
                f--;
              }
              if (f > 1) {
                l[n++] = 65533;
                continue;
              }
              if (i < 65536) {
                l[n++] = i;
              } else {
                i -= 65536;
                l[n++] = 55296 | ((i >> 10) & 1023);
                l[n++] = 56320 | (i & 1023);
              }
            }
            if (l.length !== n) {
              if (l.subarray) {
                l = l.subarray(0, n);
              } else {
                l.length = n;
              }
            }
            return a.applyFromCharCode(l);
          };
          t.utf8encode = function h(e) {
            if (n.nodebuffer) {
              return i(e, "utf-8");
            }
            return o(e);
          };
          t.utf8decode = function u(e) {
            if (n.nodebuffer) {
              return a.transformTo("nodebuffer", e).toString("utf-8");
            }
            e = a.transformTo(n.uint8array ? "uint8array" : "array", e);
            var r = [],
              t = 0,
              i = e.length,
              s = 65536;
            while (t < i) {
              var f = l(e, Math.min(t + s, i));
              if (n.uint8array) {
                r.push(c(e.subarray(t, f)));
              } else {
                r.push(c(e.slice(t, f)));
              }
              t = f;
            }
            return r.join("");
          };
        },
        { "./nodeBuffer": 11, "./support": 17, "./utils": 21 },
      ],
      21: [
        function (e, r, t) {
          "use strict";
          var a = e("./support");
          var n = e("./compressions");
          var i = e("./nodeBuffer");
          t.string2binary = function (e) {
            var r = "";
            for (var t = 0; t < e.length; t++) {
              r += String.fromCharCode(e.charCodeAt(t) & 255);
            }
            return r;
          };
          t.arrayBuffer2Blob = function (e) {
            t.checkSupport("blob");
            try {
              return new Blob([e], { type: "application/zip" });
            } catch (r) {
              try {
                var a =
                  window.BlobBuilder ||
                  window.WebKitBlobBuilder ||
                  window.MozBlobBuilder ||
                  window.MSBlobBuilder;
                var n = new a();
                n.append(e);
                return n.getBlob("application/zip");
              } catch (r) {
                throw new Error("Bug : can't construct the Blob.");
              }
            }
          };
          function s(e) {
            return e;
          }
          function f(e, r) {
            for (var t = 0; t < e.length; ++t) {
              r[t] = e.charCodeAt(t) & 255;
            }
            return r;
          }
          function o(e) {
            var r = 65536;
            var a = [],
              n = e.length,
              s = t.getTypeOf(e),
              f = 0,
              o = true;
            try {
              switch (s) {
                case "uint8array":
                  String.fromCharCode.apply(null, new Uint8Array(0));
                  break;
                case "nodebuffer":
                  String.fromCharCode.apply(null, i(0));
                  break;
              }
            } catch (l) {
              o = false;
            }
            if (!o) {
              var c = "";
              for (var h = 0; h < e.length; h++) {
                c += String.fromCharCode(e[h]);
              }
              return c;
            }
            while (f < n && r > 1) {
              try {
                if (s === "array" || s === "nodebuffer") {
                  a.push(
                    String.fromCharCode.apply(
                      null,
                      e.slice(f, Math.min(f + r, n))
                    )
                  );
                } else {
                  a.push(
                    String.fromCharCode.apply(
                      null,
                      e.subarray(f, Math.min(f + r, n))
                    )
                  );
                }
                f += r;
              } catch (l) {
                r = Math.floor(r / 2);
              }
            }
            return a.join("");
          }
          t.applyFromCharCode = o;
          function l(e, r) {
            for (var t = 0; t < e.length; t++) {
              r[t] = e[t];
            }
            return r;
          }
          var c = {};
          c["string"] = {
            string: s,
            array: function (e) {
              return f(e, new Array(e.length));
            },
            arraybuffer: function (e) {
              return c["string"]["uint8array"](e).buffer;
            },
            uint8array: function (e) {
              return f(e, new Uint8Array(e.length));
            },
            nodebuffer: function (e) {
              return f(e, i(e.length));
            },
          };
          c["array"] = {
            string: o,
            array: s,
            arraybuffer: function (e) {
              return new Uint8Array(e).buffer;
            },
            uint8array: function (e) {
              return new Uint8Array(e);
            },
            nodebuffer: function (e) {
              return i(e);
            },
          };
          c["arraybuffer"] = {
            string: function (e) {
              return o(new Uint8Array(e));
            },
            array: function (e) {
              return l(new Uint8Array(e), new Array(e.byteLength));
            },
            arraybuffer: s,
            uint8array: function (e) {
              return new Uint8Array(e);
            },
            nodebuffer: function (e) {
              return i(new Uint8Array(e));
            },
          };
          c["uint8array"] = {
            string: o,
            array: function (e) {
              return l(e, new Array(e.length));
            },
            arraybuffer: function (e) {
              return e.buffer;
            },
            uint8array: s,
            nodebuffer: function (e) {
              return i(e);
            },
          };
          c["nodebuffer"] = {
            string: o,
            array: function (e) {
              return l(e, new Array(e.length));
            },
            arraybuffer: function (e) {
              return c["nodebuffer"]["uint8array"](e).buffer;
            },
            uint8array: function (e) {
              return l(e, new Uint8Array(e.length));
            },
            nodebuffer: s,
          };
          t.transformTo = function (e, r) {
            if (!r) {
              r = "";
            }
            if (!e) {
              return r;
            }
            t.checkSupport(e);
            var a = t.getTypeOf(r);
            var n = c[a][e](r);
            return n;
          };
          t.getTypeOf = function (e) {
            if (typeof e === "string") {
              return "string";
            }
            if (Object.prototype.toString.call(e) === "[object Array]") {
              return "array";
            }
            if (a.nodebuffer && i.test(e)) {
              return "nodebuffer";
            }
            if (a.uint8array && e instanceof Uint8Array) {
              return "uint8array";
            }
            if (a.arraybuffer && e instanceof ArrayBuffer) {
              return "arraybuffer";
            }
          };
          t.checkSupport = function (e) {
            var r = a[e.toLowerCase()];
            if (!r) {
              throw new Error(e + " is not supported by this browser");
            }
          };
          t.MAX_VALUE_16BITS = 65535;
          t.MAX_VALUE_32BITS = -1;
          t.pretty = function (e) {
            var r = "",
              t,
              a;
            for (a = 0; a < (e || "").length; a++) {
              t = e.charCodeAt(a);
              r += "\\x" + (t < 16 ? "0" : "") + t.toString(16).toUpperCase();
            }
            return r;
          };
          t.findCompression = function (e) {
            for (var r in n) {
              if (!n.hasOwnProperty(r)) {
                continue;
              }
              if (n[r].magic === e) {
                return n[r];
              }
            }
            return null;
          };
          t.isRegExp = function (e) {
            return Object.prototype.toString.call(e) === "[object RegExp]";
          };
        },
        { "./compressions": 3, "./nodeBuffer": 11, "./support": 17 },
      ],
      22: [
        function (e, r, t) {
          "use strict";
          var a = e("./stringReader");
          var n = e("./nodeBufferReader");
          var i = e("./uint8ArrayReader");
          var s = e("./utils");
          var f = e("./signature");
          var o = e("./zipEntry");
          var l = e("./support");
          var c = e("./object");
          function h(e, r) {
            this.files = [];
            this.loadOptions = r;
            if (e) {
              this.load(e);
            }
          }
          h.prototype = {
            checkSignature: function (e) {
              var r = this.reader.readString(4);
              if (r !== e) {
                throw new Error(
                  "Corrupted zip or bug : unexpected signature " +
                    "(" +
                    s.pretty(r) +
                    ", expected " +
                    s.pretty(e) +
                    ")"
                );
              }
            },
            readBlockEndOfCentral: function () {
              this.diskNumber = this.reader.readInt(2);
              this.diskWithCentralDirStart = this.reader.readInt(2);
              this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
              this.centralDirRecords = this.reader.readInt(2);
              this.centralDirSize = this.reader.readInt(4);
              this.centralDirOffset = this.reader.readInt(4);
              this.zipCommentLength = this.reader.readInt(2);
              this.zipComment = this.reader.readString(this.zipCommentLength);
              this.zipComment = c.utf8decode(this.zipComment);
            },
            readBlockZip64EndOfCentral: function () {
              this.zip64EndOfCentralSize = this.reader.readInt(8);
              this.versionMadeBy = this.reader.readString(2);
              this.versionNeeded = this.reader.readInt(2);
              this.diskNumber = this.reader.readInt(4);
              this.diskWithCentralDirStart = this.reader.readInt(4);
              this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
              this.centralDirRecords = this.reader.readInt(8);
              this.centralDirSize = this.reader.readInt(8);
              this.centralDirOffset = this.reader.readInt(8);
              this.zip64ExtensibleData = {};
              var e = this.zip64EndOfCentralSize - 44,
                r = 0,
                t,
                a,
                n;
              while (r < e) {
                t = this.reader.readInt(2);
                a = this.reader.readInt(4);
                n = this.reader.readString(a);
                this.zip64ExtensibleData[t] = { id: t, length: a, value: n };
              }
            },
            readBlockZip64EndOfCentralLocator: function () {
              this.diskWithZip64CentralDirStart = this.reader.readInt(4);
              this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
              this.disksCount = this.reader.readInt(4);
              if (this.disksCount > 1) {
                throw new Error("Multi-volumes zip are not supported");
              }
            },
            readLocalFiles: function () {
              var e, r;
              for (e = 0; e < this.files.length; e++) {
                r = this.files[e];
                this.reader.setIndex(r.localHeaderOffset);
                this.checkSignature(f.LOCAL_FILE_HEADER);
                r.readLocalPart(this.reader);
                r.handleUTF8();
              }
            },
            readCentralDir: function () {
              var e;
              this.reader.setIndex(this.centralDirOffset);
              while (this.reader.readString(4) === f.CENTRAL_FILE_HEADER) {
                e = new o({ zip64: this.zip64 }, this.loadOptions);
                e.readCentralPart(this.reader);
                this.files.push(e);
              }
            },
            readEndOfCentral: function () {
              var e = this.reader.lastIndexOfSignature(f.CENTRAL_DIRECTORY_END);
              if (e === -1) {
                throw new Error(
                  "Corrupted zip : can't find end of central directory"
                );
              }
              this.reader.setIndex(e);
              this.checkSignature(f.CENTRAL_DIRECTORY_END);
              this.readBlockEndOfCentral();
              if (
                this.diskNumber === s.MAX_VALUE_16BITS ||
                this.diskWithCentralDirStart === s.MAX_VALUE_16BITS ||
                this.centralDirRecordsOnThisDisk === s.MAX_VALUE_16BITS ||
                this.centralDirRecords === s.MAX_VALUE_16BITS ||
                this.centralDirSize === s.MAX_VALUE_32BITS ||
                this.centralDirOffset === s.MAX_VALUE_32BITS
              ) {
                this.zip64 = true;
                e = this.reader.lastIndexOfSignature(
                  f.ZIP64_CENTRAL_DIRECTORY_LOCATOR
                );
                if (e === -1) {
                  throw new Error(
                    "Corrupted zip : can't find the ZIP64 end of central directory locator"
                  );
                }
                this.reader.setIndex(e);
                this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
                this.readBlockZip64EndOfCentralLocator();
                this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
                this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_END);
                this.readBlockZip64EndOfCentral();
              }
            },
            prepareReader: function (e) {
              var r = s.getTypeOf(e);
              if (r === "string" && !l.uint8array) {
                this.reader = new a(e, this.loadOptions.optimizedBinaryString);
              } else if (r === "nodebuffer") {
                this.reader = new n(e);
              } else {
                this.reader = new i(s.transformTo("uint8array", e));
              }
            },
            load: function (e) {
              this.prepareReader(e);
              this.readEndOfCentral();
              this.readCentralDir();
              this.readLocalFiles();
            },
          };
          r.exports = h;
        },
        {
          "./nodeBufferReader": 12,
          "./object": 13,
          "./signature": 14,
          "./stringReader": 15,
          "./support": 17,
          "./uint8ArrayReader": 18,
          "./utils": 21,
          "./zipEntry": 23,
        },
      ],
      23: [
        function (e, r, t) {
          "use strict";
          var a = e("./stringReader");
          var n = e("./utils");
          var i = e("./compressedObject");
          var s = e("./object");
          function f(e, r) {
            this.options = e;
            this.loadOptions = r;
          }
          f.prototype = {
            isEncrypted: function () {
              return (this.bitFlag & 1) === 1;
            },
            useUTF8: function () {
              return (this.bitFlag & 2048) === 2048;
            },
            prepareCompressedContent: function (e, r, t) {
              return function () {
                var a = e.index;
                e.setIndex(r);
                var n = e.readData(t);
                e.setIndex(a);
                return n;
              };
            },
            prepareContent: function (e, r, t, a, i) {
              return function () {
                var e = n.transformTo(
                  a.uncompressInputType,
                  this.getCompressedContent()
                );
                var r = a.uncompress(e);
                if (r.length !== i) {
                  throw new Error("Bug : uncompressed data size mismatch");
                }
                return r;
              };
            },
            readLocalPart: function (e) {
              var r, t;
              e.skip(22);
              this.fileNameLength = e.readInt(2);
              t = e.readInt(2);
              this.fileName = e.readString(this.fileNameLength);
              e.skip(t);
              if (this.compressedSize == -1 || this.uncompressedSize == -1) {
                throw new Error(
                  "Bug or corrupted zip : didn't get enough informations from the central directory " +
                    "(compressedSize == -1 || uncompressedSize == -1)"
                );
              }
              r = n.findCompression(this.compressionMethod);
              if (r === null) {
                throw new Error(
                  "Corrupted zip : compression " +
                    n.pretty(this.compressionMethod) +
                    " unknown (inner file : " +
                    this.fileName +
                    ")"
                );
              }
              this.decompressed = new i();
              this.decompressed.compressedSize = this.compressedSize;
              this.decompressed.uncompressedSize = this.uncompressedSize;
              this.decompressed.crc32 = this.crc32;
              this.decompressed.compressionMethod = this.compressionMethod;
              this.decompressed.getCompressedContent =
                this.prepareCompressedContent(
                  e,
                  e.index,
                  this.compressedSize,
                  r
                );
              this.decompressed.getContent = this.prepareContent(
                e,
                e.index,
                this.compressedSize,
                r,
                this.uncompressedSize
              );
              if (this.loadOptions.checkCRC32) {
                this.decompressed = n.transformTo(
                  "string",
                  this.decompressed.getContent()
                );
                if (s.crc32(this.decompressed) !== this.crc32) {
                  throw new Error("Corrupted zip : CRC32 mismatch");
                }
              }
            },
            readCentralPart: function (e) {
              this.versionMadeBy = e.readString(2);
              this.versionNeeded = e.readInt(2);
              this.bitFlag = e.readInt(2);
              this.compressionMethod = e.readString(2);
              this.date = e.readDate();
              this.crc32 = e.readInt(4);
              this.compressedSize = e.readInt(4);
              this.uncompressedSize = e.readInt(4);
              this.fileNameLength = e.readInt(2);
              this.extraFieldsLength = e.readInt(2);
              this.fileCommentLength = e.readInt(2);
              this.diskNumberStart = e.readInt(2);
              this.internalFileAttributes = e.readInt(2);
              this.externalFileAttributes = e.readInt(4);
              this.localHeaderOffset = e.readInt(4);
              if (this.isEncrypted()) {
                throw new Error("Encrypted zip are not supported");
              }
              this.fileName = e.readString(this.fileNameLength);
              this.readExtraFields(e);
              this.parseZIP64ExtraField(e);
              this.fileComment = e.readString(this.fileCommentLength);
              this.dir = this.externalFileAttributes & 16 ? true : false;
            },
            parseZIP64ExtraField: function (e) {
              if (!this.extraFields[1]) {
                return;
              }
              var r = new a(this.extraFields[1].value);
              if (this.uncompressedSize === n.MAX_VALUE_32BITS) {
                this.uncompressedSize = r.readInt(8);
              }
              if (this.compressedSize === n.MAX_VALUE_32BITS) {
                this.compressedSize = r.readInt(8);
              }
              if (this.localHeaderOffset === n.MAX_VALUE_32BITS) {
                this.localHeaderOffset = r.readInt(8);
              }
              if (this.diskNumberStart === n.MAX_VALUE_32BITS) {
                this.diskNumberStart = r.readInt(4);
              }
            },
            readExtraFields: function (e) {
              var r = e.index,
                t,
                a,
                n;
              this.extraFields = this.extraFields || {};
              while (e.index < r + this.extraFieldsLength) {
                t = e.readInt(2);
                a = e.readInt(2);
                n = e.readString(a);
                this.extraFields[t] = { id: t, length: a, value: n };
              }
            },
            handleUTF8: function () {
              if (this.useUTF8()) {
                this.fileName = s.utf8decode(this.fileName);
                this.fileComment = s.utf8decode(this.fileComment);
              } else {
                var e = this.findExtraFieldUnicodePath();
                if (e !== null) {
                  this.fileName = e;
                }
                var r = this.findExtraFieldUnicodeComment();
                if (r !== null) {
                  this.fileComment = r;
                }
              }
            },
            findExtraFieldUnicodePath: function () {
              var e = this.extraFields[28789];
              if (e) {
                var r = new a(e.value);
                if (r.readInt(1) !== 1) {
                  return null;
                }
                if (s.crc32(this.fileName) !== r.readInt(4)) {
                  return null;
                }
                return s.utf8decode(r.readString(e.length - 5));
              }
              return null;
            },
            findExtraFieldUnicodeComment: function () {
              var e = this.extraFields[25461];
              if (e) {
                var r = new a(e.value);
                if (r.readInt(1) !== 1) {
                  return null;
                }
                if (s.crc32(this.fileComment) !== r.readInt(4)) {
                  return null;
                }
                return s.utf8decode(r.readString(e.length - 5));
              }
              return null;
            },
          };
          r.exports = f;
        },
        {
          "./compressedObject": 2,
          "./object": 13,
          "./stringReader": 15,
          "./utils": 21,
        },
      ],
      24: [
        function (e, r, t) {
          "use strict";
          var a = e("./lib/utils/common").assign;
          var n = e("./lib/deflate");
          var i = e("./lib/inflate");
          var s = e("./lib/zlib/constants");
          var f = {};
          a(f, n, i, s);
          r.exports = f;
        },
        {
          "./lib/deflate": 25,
          "./lib/inflate": 26,
          "./lib/utils/common": 27,
          "./lib/zlib/constants": 30,
        },
      ],
      25: [
        function (e, r, t) {
          "use strict";
          var a = e("./zlib/deflate.js");
          var n = e("./utils/common");
          var i = e("./utils/strings");
          var s = e("./zlib/messages");
          var f = e("./zlib/zstream");
          var o = 0;
          var l = 4;
          var c = 0;
          var h = 1;
          var u = -1;
          var d = 0;
          var v = 8;
          var p = function (e) {
            this.options = n.assign(
              {
                level: u,
                method: v,
                chunkSize: 16384,
                windowBits: 15,
                memLevel: 8,
                strategy: d,
                to: "",
              },
              e || {}
            );
            var r = this.options;
            if (r.raw && r.windowBits > 0) {
              r.windowBits = -r.windowBits;
            } else if (r.gzip && r.windowBits > 0 && r.windowBits < 16) {
              r.windowBits += 16;
            }
            this.err = 0;
            this.msg = "";
            this.ended = false;
            this.chunks = [];
            this.strm = new f();
            this.strm.avail_out = 0;
            var t = a.deflateInit2(
              this.strm,
              r.level,
              r.method,
              r.windowBits,
              r.memLevel,
              r.strategy
            );
            if (t !== c) {
              throw new Error(s[t]);
            }
            if (r.header) {
              a.deflateSetHeader(this.strm, r.header);
            }
          };
          p.prototype.push = function (e, r) {
            var t = this.strm;
            var s = this.options.chunkSize;
            var f, u;
            if (this.ended) {
              return false;
            }
            u = r === ~~r ? r : r === true ? l : o;
            if (typeof e === "string") {
              t.input = i.string2buf(e);
            } else {
              t.input = e;
            }
            t.next_in = 0;
            t.avail_in = t.input.length;
            do {
              if (t.avail_out === 0) {
                t.output = new n.Buf8(s);
                t.next_out = 0;
                t.avail_out = s;
              }
              f = a.deflate(t, u);
              if (f !== h && f !== c) {
                this.onEnd(f);
                this.ended = true;
                return false;
              }
              if (t.avail_out === 0 || (t.avail_in === 0 && u === l)) {
                if (this.options.to === "string") {
                  this.onData(
                    i.buf2binstring(n.shrinkBuf(t.output, t.next_out))
                  );
                } else {
                  this.onData(n.shrinkBuf(t.output, t.next_out));
                }
              }
            } while ((t.avail_in > 0 || t.avail_out === 0) && f !== h);
            if (u === l) {
              f = a.deflateEnd(this.strm);
              this.onEnd(f);
              this.ended = true;
              return f === c;
            }
            return true;
          };
          p.prototype.onData = function (e) {
            this.chunks.push(e);
          };
          p.prototype.onEnd = function (e) {
            if (e === c) {
              if (this.options.to === "string") {
                this.result = this.chunks.join("");
              } else {
                this.result = n.flattenChunks(this.chunks);
              }
            }
            this.chunks = [];
            this.err = e;
            this.msg = this.strm.msg;
          };
          function g(e, r) {
            var t = new p(r);
            t.push(e, true);
            if (t.err) {
              throw t.msg;
            }
            return t.result;
          }
          function b(e, r) {
            r = r || {};
            r.raw = true;
            return g(e, r);
          }
          function m(e, r) {
            r = r || {};
            r.gzip = true;
            return g(e, r);
          }
          t.Deflate = p;
          t.deflate = g;
          t.deflateRaw = b;
          t.gzip = m;
        },
        {
          "./utils/common": 27,
          "./utils/strings": 28,
          "./zlib/deflate.js": 32,
          "./zlib/messages": 37,
          "./zlib/zstream": 39,
        },
      ],
      26: [
        function (e, r, t) {
          "use strict";
          var a = e("./zlib/inflate.js");
          var n = e("./utils/common");
          var i = e("./utils/strings");
          var s = e("./zlib/constants");
          var f = e("./zlib/messages");
          var o = e("./zlib/zstream");
          var l = e("./zlib/gzheader");
          var c = function (e) {
            this.options = n.assign(
              { chunkSize: 16384, windowBits: 0, to: "" },
              e || {}
            );
            var r = this.options;
            if (r.raw && r.windowBits >= 0 && r.windowBits < 16) {
              r.windowBits = -r.windowBits;
              if (r.windowBits === 0) {
                r.windowBits = -15;
              }
            }
            if (
              r.windowBits >= 0 &&
              r.windowBits < 16 &&
              !(e && e.windowBits)
            ) {
              r.windowBits += 32;
            }
            if (r.windowBits > 15 && r.windowBits < 48) {
              if ((r.windowBits & 15) === 0) {
                r.windowBits |= 15;
              }
            }
            this.err = 0;
            this.msg = "";
            this.ended = false;
            this.chunks = [];
            this.strm = new o();
            this.strm.avail_out = 0;
            var t = a.inflateInit2(this.strm, r.windowBits);
            if (t !== s.Z_OK) {
              throw new Error(f[t]);
            }
            this.header = new l();
            a.inflateGetHeader(this.strm, this.header);
          };
          c.prototype.push = function (e, r) {
            var t = this.strm;
            var f = this.options.chunkSize;
            var o, l;
            var c, h, u;
            if (this.ended) {
              return false;
            }
            l = r === ~~r ? r : r === true ? s.Z_FINISH : s.Z_NO_FLUSH;
            if (typeof e === "string") {
              t.input = i.binstring2buf(e);
            } else {
              t.input = e;
            }
            t.next_in = 0;
            t.avail_in = t.input.length;
            do {
              if (t.avail_out === 0) {
                t.output = new n.Buf8(f);
                t.next_out = 0;
                t.avail_out = f;
              }
              o = a.inflate(t, s.Z_NO_FLUSH);
              if (o !== s.Z_STREAM_END && o !== s.Z_OK) {
                this.onEnd(o);
                this.ended = true;
                return false;
              }
              if (t.next_out) {
                if (
                  t.avail_out === 0 ||
                  o === s.Z_STREAM_END ||
                  (t.avail_in === 0 && l === s.Z_FINISH)
                ) {
                  if (this.options.to === "string") {
                    c = i.utf8border(t.output, t.next_out);
                    h = t.next_out - c;
                    u = i.buf2string(t.output, c);
                    t.next_out = h;
                    t.avail_out = f - h;
                    if (h) {
                      n.arraySet(t.output, t.output, c, h, 0);
                    }
                    this.onData(u);
                  } else {
                    this.onData(n.shrinkBuf(t.output, t.next_out));
                  }
                }
              }
            } while (t.avail_in > 0 && o !== s.Z_STREAM_END);
            if (o === s.Z_STREAM_END) {
              l = s.Z_FINISH;
            }
            if (l === s.Z_FINISH) {
              o = a.inflateEnd(this.strm);
              this.onEnd(o);
              this.ended = true;
              return o === s.Z_OK;
            }
            return true;
          };
          c.prototype.onData = function (e) {
            this.chunks.push(e);
          };
          c.prototype.onEnd = function (e) {
            if (e === s.Z_OK) {
              if (this.options.to === "string") {
                this.result = this.chunks.join("");
              } else {
                this.result = n.flattenChunks(this.chunks);
              }
            }
            this.chunks = [];
            this.err = e;
            this.msg = this.strm.msg;
          };
          function h(e, r) {
            var t = new c(r);
            t.push(e, true);
            if (t.err) {
              throw t.msg;
            }
            return t.result;
          }
          function u(e, r) {
            r = r || {};
            r.raw = true;
            return h(e, r);
          }
          t.Inflate = c;
          t.inflate = h;
          t.inflateRaw = u;
          t.ungzip = h;
        },
        {
          "./utils/common": 27,
          "./utils/strings": 28,
          "./zlib/constants": 30,
          "./zlib/gzheader": 33,
          "./zlib/inflate.js": 35,
          "./zlib/messages": 37,
          "./zlib/zstream": 39,
        },
      ],
      27: [
        function (e, r, t) {
          "use strict";
          var a =
            typeof Uint8Array !== "undefined" &&
            typeof Uint16Array !== "undefined" &&
            typeof Int32Array !== "undefined";
          t.assign = function (e) {
            var r = Array.prototype.slice.call(arguments, 1);
            while (r.length) {
              var t = r.shift();
              if (!t) {
                continue;
              }
              if (typeof t !== "object") {
                throw new TypeError(t + "must be non-object");
              }
              for (var a in t) {
                if (t.hasOwnProperty(a)) {
                  e[a] = t[a];
                }
              }
            }
            return e;
          };
          t.shrinkBuf = function (e, r) {
            if (e.length === r) {
              return e;
            }
            if (e.subarray) {
              return e.subarray(0, r);
            }
            e.length = r;
            return e;
          };
          var n = {
            arraySet: function (e, r, t, a, n) {
              if (r.subarray && e.subarray) {
                e.set(r.subarray(t, t + a), n);
                return;
              }
              for (var i = 0; i < a; i++) {
                e[n + i] = r[t + i];
              }
            },
            flattenChunks: function (e) {
              var r, t, a, n, i, s;
              a = 0;
              for (r = 0, t = e.length; r < t; r++) {
                a += e[r].length;
              }
              s = new Uint8Array(a);
              n = 0;
              for (r = 0, t = e.length; r < t; r++) {
                i = e[r];
                s.set(i, n);
                n += i.length;
              }
              return s;
            },
          };
          var i = {
            arraySet: function (e, r, t, a, n) {
              for (var i = 0; i < a; i++) {
                e[n + i] = r[t + i];
              }
            },
            flattenChunks: function (e) {
              return [].concat.apply([], e);
            },
          };
          t.setTyped = function (e) {
            if (e) {
              t.Buf8 = Uint8Array;
              t.Buf16 = Uint16Array;
              t.Buf32 = Int32Array;
              t.assign(t, n);
            } else {
              t.Buf8 = Array;
              t.Buf16 = Array;
              t.Buf32 = Array;
              t.assign(t, i);
            }
          };
          t.setTyped(a);
        },
        {},
      ],
      28: [
        function (e, r, t) {
          "use strict";
          var a = e("./common");
          var n = true;
          var i = true;
          try {
            String.fromCharCode.apply(null, [0]);
          } catch (s) {
            n = false;
          }
          try {
            String.fromCharCode.apply(null, new Uint8Array(1));
          } catch (s) {
            i = false;
          }
          var f = new a.Buf8(256);
          for (var o = 0; o < 256; o++) {
            f[o] =
              o >= 252
                ? 6
                : o >= 248
                ? 5
                : o >= 240
                ? 4
                : o >= 224
                ? 3
                : o >= 192
                ? 2
                : 1;
          }
          f[254] = f[254] = 1;
          t.string2buf = function (e) {
            var r,
              t,
              n,
              i,
              s,
              f = e.length,
              o = 0;
            for (i = 0; i < f; i++) {
              t = e.charCodeAt(i);
              if ((t & 64512) === 55296 && i + 1 < f) {
                n = e.charCodeAt(i + 1);
                if ((n & 64512) === 56320) {
                  t = 65536 + ((t - 55296) << 10) + (n - 56320);
                  i++;
                }
              }
              o += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
            }
            r = new a.Buf8(o);
            for (s = 0, i = 0; s < o; i++) {
              t = e.charCodeAt(i);
              if ((t & 64512) === 55296 && i + 1 < f) {
                n = e.charCodeAt(i + 1);
                if ((n & 64512) === 56320) {
                  t = 65536 + ((t - 55296) << 10) + (n - 56320);
                  i++;
                }
              }
              if (t < 128) {
                r[s++] = t;
              } else if (t < 2048) {
                r[s++] = 192 | (t >>> 6);
                r[s++] = 128 | (t & 63);
              } else if (t < 65536) {
                r[s++] = 224 | (t >>> 12);
                r[s++] = 128 | ((t >>> 6) & 63);
                r[s++] = 128 | (t & 63);
              } else {
                r[s++] = 240 | (t >>> 18);
                r[s++] = 128 | ((t >>> 12) & 63);
                r[s++] = 128 | ((t >>> 6) & 63);
                r[s++] = 128 | (t & 63);
              }
            }
            return r;
          };
          function l(e, r) {
            if (r < 65537) {
              if ((e.subarray && i) || (!e.subarray && n)) {
                return String.fromCharCode.apply(null, a.shrinkBuf(e, r));
              }
            }
            var t = "";
            for (var s = 0; s < r; s++) {
              t += String.fromCharCode(e[s]);
            }
            return t;
          }
          t.buf2binstring = function (e) {
            return l(e, e.length);
          };
          t.binstring2buf = function (e) {
            var r = new a.Buf8(e.length);
            for (var t = 0, n = r.length; t < n; t++) {
              r[t] = e.charCodeAt(t);
            }
            return r;
          };
          t.buf2string = function (e, r) {
            var t, a, n, i;
            var s = r || e.length;
            var o = new Array(s * 2);
            for (a = 0, t = 0; t < s; ) {
              n = e[t++];
              if (n < 128) {
                o[a++] = n;
                continue;
              }
              i = f[n];
              if (i > 4) {
                o[a++] = 65533;
                t += i - 1;
                continue;
              }
              n &= i === 2 ? 31 : i === 3 ? 15 : 7;
              while (i > 1 && t < s) {
                n = (n << 6) | (e[t++] & 63);
                i--;
              }
              if (i > 1) {
                o[a++] = 65533;
                continue;
              }
              if (n < 65536) {
                o[a++] = n;
              } else {
                n -= 65536;
                o[a++] = 55296 | ((n >> 10) & 1023);
                o[a++] = 56320 | (n & 1023);
              }
            }
            return l(o, a);
          };
          t.utf8border = function (e, r) {
            var t;
            r = r || e.length;
            if (r > e.length) {
              r = e.length;
            }
            t = r - 1;
            while (t >= 0 && (e[t] & 192) === 128) {
              t--;
            }
            if (t < 0) {
              return r;
            }
            if (t === 0) {
              return r;
            }
            return t + f[e[t]] > r ? t : r;
          };
        },
        { "./common": 27 },
      ],
      29: [
        function (e, r, t) {
          "use strict";
          function a(e, r, t, a) {
            var n = (e & 65535) | 0,
              i = ((e >>> 16) & 65535) | 0,
              s = 0;
            while (t !== 0) {
              s = t > 2e3 ? 2e3 : t;
              t -= s;
              do {
                n = (n + r[a++]) | 0;
                i = (i + n) | 0;
              } while (--s);
              n %= 65521;
              i %= 65521;
            }
            return n | (i << 16) | 0;
          }
          r.exports = a;
        },
        {},
      ],
      30: [
        function (e, r, t) {
          r.exports = {
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_BUF_ERROR: -5,
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            Z_BINARY: 0,
            Z_TEXT: 1,
            Z_UNKNOWN: 2,
            Z_DEFLATED: 8,
          };
        },
        {},
      ],
      31: [
        function (e, r, t) {
          "use strict";
          function a() {
            var e,
              r = [];
            for (var t = 0; t < 256; t++) {
              e = t;
              for (var a = 0; a < 8; a++) {
                e = e & 1 ? 3988292384 ^ (e >>> 1) : e >>> 1;
              }
              r[t] = e;
            }
            return r;
          }
          var n = a();
          function i(e, r, t, a) {
            var i = n,
              s = a + t;
            e = e ^ -1;
            for (var f = a; f < s; f++) {
              e = (e >>> 8) ^ i[(e ^ r[f]) & 255];
            }
            return e ^ -1;
          }
          r.exports = i;
        },
        {},
      ],
      32: [
        function (e, r, t) {
          "use strict";
          var a = e("../utils/common");
          var n = e("./trees");
          var i = e("./adler32");
          var s = e("./crc32");
          var f = e("./messages");
          var o = 0;
          var l = 1;
          var c = 3;
          var h = 4;
          var u = 5;
          var d = 0;
          var v = 1;
          var p = -2;
          var g = -3;
          var b = -5;
          var m = -1;
          var C = 1;
          var E = 2;
          var k = 3;
          var S = 4;
          var w = 0;
          var A = 2;
          var B = 8;
          var _ = 9;
          var T = 15;
          var x = 8;
          var I = 29;
          var y = 256;
          var R = y + 1 + I;
          var D = 30;
          var O = 19;
          var F = 2 * R + 1;
          var P = 15;
          var N = 3;
          var L = 258;
          var M = L + N + 1;
          var U = 32;
          var H = 42;
          var W = 69;
          var V = 73;
          var z = 91;
          var X = 103;
          var G = 113;
          var j = 666;
          var K = 1;
          var Y = 2;
          var $ = 3;
          var Z = 4;
          var Q = 3;
          function J(e, r) {
            e.msg = f[r];
            return r;
          }
          function q(e) {
            return (e << 1) - (e > 4 ? 9 : 0);
          }
          function ee(e) {
            var r = e.length;
            while (--r >= 0) {
              e[r] = 0;
            }
          }
          function re(e) {
            var r = e.state;
            var t = r.pending;
            if (t > e.avail_out) {
              t = e.avail_out;
            }
            if (t === 0) {
              return;
            }
            a.arraySet(e.output, r.pending_buf, r.pending_out, t, e.next_out);
            e.next_out += t;
            r.pending_out += t;
            e.total_out += t;
            e.avail_out -= t;
            r.pending -= t;
            if (r.pending === 0) {
              r.pending_out = 0;
            }
          }
          function te(e, r) {
            n._tr_flush_block(
              e,
              e.block_start >= 0 ? e.block_start : -1,
              e.strstart - e.block_start,
              r
            );
            e.block_start = e.strstart;
            re(e.strm);
          }
          function ae(e, r) {
            e.pending_buf[e.pending++] = r;
          }
          function ne(e, r) {
            e.pending_buf[e.pending++] = (r >>> 8) & 255;
            e.pending_buf[e.pending++] = r & 255;
          }
          function ie(e, r, t, n) {
            var f = e.avail_in;
            if (f > n) {
              f = n;
            }
            if (f === 0) {
              return 0;
            }
            e.avail_in -= f;
            a.arraySet(r, e.input, e.next_in, f, t);
            if (e.state.wrap === 1) {
              e.adler = i(e.adler, r, f, t);
            } else if (e.state.wrap === 2) {
              e.adler = s(e.adler, r, f, t);
            }
            e.next_in += f;
            e.total_in += f;
            return f;
          }
          function se(e, r) {
            var t = e.max_chain_length;
            var a = e.strstart;
            var n;
            var i;
            var s = e.prev_length;
            var f = e.nice_match;
            var o = e.strstart > e.w_size - M ? e.strstart - (e.w_size - M) : 0;
            var l = e.window;
            var c = e.w_mask;
            var h = e.prev;
            var u = e.strstart + L;
            var d = l[a + s - 1];
            var v = l[a + s];
            if (e.prev_length >= e.good_match) {
              t >>= 2;
            }
            if (f > e.lookahead) {
              f = e.lookahead;
            }
            do {
              n = r;
              if (
                l[n + s] !== v ||
                l[n + s - 1] !== d ||
                l[n] !== l[a] ||
                l[++n] !== l[a + 1]
              ) {
                continue;
              }
              a += 2;
              n++;
              do {} while (
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                a < u
              );
              i = L - (u - a);
              a = u - L;
              if (i > s) {
                e.match_start = r;
                s = i;
                if (i >= f) {
                  break;
                }
                d = l[a + s - 1];
                v = l[a + s];
              }
            } while ((r = h[r & c]) > o && --t !== 0);
            if (s <= e.lookahead) {
              return s;
            }
            return e.lookahead;
          }
          function fe(e) {
            var r = e.w_size;
            var t, n, i, s, f;
            do {
              s = e.window_size - e.lookahead - e.strstart;
              if (e.strstart >= r + (r - M)) {
                a.arraySet(e.window, e.window, r, r, 0);
                e.match_start -= r;
                e.strstart -= r;
                e.block_start -= r;
                n = e.hash_size;
                t = n;
                do {
                  i = e.head[--t];
                  e.head[t] = i >= r ? i - r : 0;
                } while (--n);
                n = r;
                t = n;
                do {
                  i = e.prev[--t];
                  e.prev[t] = i >= r ? i - r : 0;
                } while (--n);
                s += r;
              }
              if (e.strm.avail_in === 0) {
                break;
              }
              n = ie(e.strm, e.window, e.strstart + e.lookahead, s);
              e.lookahead += n;
              if (e.lookahead + e.insert >= N) {
                f = e.strstart - e.insert;
                e.ins_h = e.window[f];
                e.ins_h =
                  ((e.ins_h << e.hash_shift) ^ e.window[f + 1]) & e.hash_mask;
                while (e.insert) {
                  e.ins_h =
                    ((e.ins_h << e.hash_shift) ^ e.window[f + N - 1]) &
                    e.hash_mask;
                  e.prev[f & e.w_mask] = e.head[e.ins_h];
                  e.head[e.ins_h] = f;
                  f++;
                  e.insert--;
                  if (e.lookahead + e.insert < N) {
                    break;
                  }
                }
              }
            } while (e.lookahead < M && e.strm.avail_in !== 0);
          }
          function oe(e, r) {
            var t = 65535;
            if (t > e.pending_buf_size - 5) {
              t = e.pending_buf_size - 5;
            }
            for (;;) {
              if (e.lookahead <= 1) {
                fe(e);
                if (e.lookahead === 0 && r === o) {
                  return K;
                }
                if (e.lookahead === 0) {
                  break;
                }
              }
              e.strstart += e.lookahead;
              e.lookahead = 0;
              var a = e.block_start + t;
              if (e.strstart === 0 || e.strstart >= a) {
                e.lookahead = e.strstart - a;
                e.strstart = a;
                te(e, false);
                if (e.strm.avail_out === 0) {
                  return K;
                }
              }
              if (e.strstart - e.block_start >= e.w_size - M) {
                te(e, false);
                if (e.strm.avail_out === 0) {
                  return K;
                }
              }
            }
            e.insert = 0;
            if (r === h) {
              te(e, true);
              if (e.strm.avail_out === 0) {
                return $;
              }
              return Z;
            }
            if (e.strstart > e.block_start) {
              te(e, false);
              if (e.strm.avail_out === 0) {
                return K;
              }
            }
            return K;
          }
          function le(e, r) {
            var t;
            var a;
            for (;;) {
              if (e.lookahead < M) {
                fe(e);
                if (e.lookahead < M && r === o) {
                  return K;
                }
                if (e.lookahead === 0) {
                  break;
                }
              }
              t = 0;
              if (e.lookahead >= N) {
                e.ins_h =
                  ((e.ins_h << e.hash_shift) ^ e.window[e.strstart + N - 1]) &
                  e.hash_mask;
                t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h];
                e.head[e.ins_h] = e.strstart;
              }
              if (t !== 0 && e.strstart - t <= e.w_size - M) {
                e.match_length = se(e, t);
              }
              if (e.match_length >= N) {
                a = n._tr_tally(
                  e,
                  e.strstart - e.match_start,
                  e.match_length - N
                );
                e.lookahead -= e.match_length;
                if (e.match_length <= e.max_lazy_match && e.lookahead >= N) {
                  e.match_length--;
                  do {
                    e.strstart++;
                    e.ins_h =
                      ((e.ins_h << e.hash_shift) ^
                        e.window[e.strstart + N - 1]) &
                      e.hash_mask;
                    t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h];
                    e.head[e.ins_h] = e.strstart;
                  } while (--e.match_length !== 0);
                  e.strstart++;
                } else {
                  e.strstart += e.match_length;
                  e.match_length = 0;
                  e.ins_h = e.window[e.strstart];
                  e.ins_h =
                    ((e.ins_h << e.hash_shift) ^ e.window[e.strstart + 1]) &
                    e.hash_mask;
                }
              } else {
                a = n._tr_tally(e, 0, e.window[e.strstart]);
                e.lookahead--;
                e.strstart++;
              }
              if (a) {
                te(e, false);
                if (e.strm.avail_out === 0) {
                  return K;
                }
              }
            }
            e.insert = e.strstart < N - 1 ? e.strstart : N - 1;
            if (r === h) {
              te(e, true);
              if (e.strm.avail_out === 0) {
                return $;
              }
              return Z;
            }
            if (e.last_lit) {
              te(e, false);
              if (e.strm.avail_out === 0) {
                return K;
              }
            }
            return Y;
          }
          function ce(e, r) {
            var t;
            var a;
            var i;
            for (;;) {
              if (e.lookahead < M) {
                fe(e);
                if (e.lookahead < M && r === o) {
                  return K;
                }
                if (e.lookahead === 0) {
                  break;
                }
              }
              t = 0;
              if (e.lookahead >= N) {
                e.ins_h =
                  ((e.ins_h << e.hash_shift) ^ e.window[e.strstart + N - 1]) &
                  e.hash_mask;
                t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h];
                e.head[e.ins_h] = e.strstart;
              }
              e.prev_length = e.match_length;
              e.prev_match = e.match_start;
              e.match_length = N - 1;
              if (
                t !== 0 &&
                e.prev_length < e.max_lazy_match &&
                e.strstart - t <= e.w_size - M
              ) {
                e.match_length = se(e, t);
                if (
                  e.match_length <= 5 &&
                  (e.strategy === C ||
                    (e.match_length === N && e.strstart - e.match_start > 4096))
                ) {
                  e.match_length = N - 1;
                }
              }
              if (e.prev_length >= N && e.match_length <= e.prev_length) {
                i = e.strstart + e.lookahead - N;
                a = n._tr_tally(
                  e,
                  e.strstart - 1 - e.prev_match,
                  e.prev_length - N
                );
                e.lookahead -= e.prev_length - 1;
                e.prev_length -= 2;
                do {
                  if (++e.strstart <= i) {
                    e.ins_h =
                      ((e.ins_h << e.hash_shift) ^
                        e.window[e.strstart + N - 1]) &
                      e.hash_mask;
                    t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h];
                    e.head[e.ins_h] = e.strstart;
                  }
                } while (--e.prev_length !== 0);
                e.match_available = 0;
                e.match_length = N - 1;
                e.strstart++;
                if (a) {
                  te(e, false);
                  if (e.strm.avail_out === 0) {
                    return K;
                  }
                }
              } else if (e.match_available) {
                a = n._tr_tally(e, 0, e.window[e.strstart - 1]);
                if (a) {
                  te(e, false);
                }
                e.strstart++;
                e.lookahead--;
                if (e.strm.avail_out === 0) {
                  return K;
                }
              } else {
                e.match_available = 1;
                e.strstart++;
                e.lookahead--;
              }
            }
            if (e.match_available) {
              a = n._tr_tally(e, 0, e.window[e.strstart - 1]);
              e.match_available = 0;
            }
            e.insert = e.strstart < N - 1 ? e.strstart : N - 1;
            if (r === h) {
              te(e, true);
              if (e.strm.avail_out === 0) {
                return $;
              }
              return Z;
            }
            if (e.last_lit) {
              te(e, false);
              if (e.strm.avail_out === 0) {
                return K;
              }
            }
            return Y;
          }
          function he(e, r) {
            var t;
            var a;
            var i, s;
            var f = e.window;
            for (;;) {
              if (e.lookahead <= L) {
                fe(e);
                if (e.lookahead <= L && r === o) {
                  return K;
                }
                if (e.lookahead === 0) {
                  break;
                }
              }
              e.match_length = 0;
              if (e.lookahead >= N && e.strstart > 0) {
                i = e.strstart - 1;
                a = f[i];
                if (a === f[++i] && a === f[++i] && a === f[++i]) {
                  s = e.strstart + L;
                  do {} while (
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    i < s
                  );
                  e.match_length = L - (s - i);
                  if (e.match_length > e.lookahead) {
                    e.match_length = e.lookahead;
                  }
                }
              }
              if (e.match_length >= N) {
                t = n._tr_tally(e, 1, e.match_length - N);
                e.lookahead -= e.match_length;
                e.strstart += e.match_length;
                e.match_length = 0;
              } else {
                t = n._tr_tally(e, 0, e.window[e.strstart]);
                e.lookahead--;
                e.strstart++;
              }
              if (t) {
                te(e, false);
                if (e.strm.avail_out === 0) {
                  return K;
                }
              }
            }
            e.insert = 0;
            if (r === h) {
              te(e, true);
              if (e.strm.avail_out === 0) {
                return $;
              }
              return Z;
            }
            if (e.last_lit) {
              te(e, false);
              if (e.strm.avail_out === 0) {
                return K;
              }
            }
            return Y;
          }
          function ue(e, r) {
            var t;
            for (;;) {
              if (e.lookahead === 0) {
                fe(e);
                if (e.lookahead === 0) {
                  if (r === o) {
                    return K;
                  }
                  break;
                }
              }
              e.match_length = 0;
              t = n._tr_tally(e, 0, e.window[e.strstart]);
              e.lookahead--;
              e.strstart++;
              if (t) {
                te(e, false);
                if (e.strm.avail_out === 0) {
                  return K;
                }
              }
            }
            e.insert = 0;
            if (r === h) {
              te(e, true);
              if (e.strm.avail_out === 0) {
                return $;
              }
              return Z;
            }
            if (e.last_lit) {
              te(e, false);
              if (e.strm.avail_out === 0) {
                return K;
              }
            }
            return Y;
          }
          var de = function (e, r, t, a, n) {
            this.good_length = e;
            this.max_lazy = r;
            this.nice_length = t;
            this.max_chain = a;
            this.func = n;
          };
          var ve;
          ve = [
            new de(0, 0, 0, 0, oe),
            new de(4, 4, 8, 4, le),
            new de(4, 5, 16, 8, le),
            new de(4, 6, 32, 32, le),
            new de(4, 4, 16, 16, ce),
            new de(8, 16, 32, 32, ce),
            new de(8, 16, 128, 128, ce),
            new de(8, 32, 128, 256, ce),
            new de(32, 128, 258, 1024, ce),
            new de(32, 258, 258, 4096, ce),
          ];
          function pe(e) {
            e.window_size = 2 * e.w_size;
            ee(e.head);
            e.max_lazy_match = ve[e.level].max_lazy;
            e.good_match = ve[e.level].good_length;
            e.nice_match = ve[e.level].nice_length;
            e.max_chain_length = ve[e.level].max_chain;
            e.strstart = 0;
            e.block_start = 0;
            e.lookahead = 0;
            e.insert = 0;
            e.match_length = e.prev_length = N - 1;
            e.match_available = 0;
            e.ins_h = 0;
          }
          function ge() {
            this.strm = null;
            this.status = 0;
            this.pending_buf = null;
            this.pending_buf_size = 0;
            this.pending_out = 0;
            this.pending = 0;
            this.wrap = 0;
            this.gzhead = null;
            this.gzindex = 0;
            this.method = B;
            this.last_flush = -1;
            this.w_size = 0;
            this.w_bits = 0;
            this.w_mask = 0;
            this.window = null;
            this.window_size = 0;
            this.prev = null;
            this.head = null;
            this.ins_h = 0;
            this.hash_size = 0;
            this.hash_bits = 0;
            this.hash_mask = 0;
            this.hash_shift = 0;
            this.block_start = 0;
            this.match_length = 0;
            this.prev_match = 0;
            this.match_available = 0;
            this.strstart = 0;
            this.match_start = 0;
            this.lookahead = 0;
            this.prev_length = 0;
            this.max_chain_length = 0;
            this.max_lazy_match = 0;
            this.level = 0;
            this.strategy = 0;
            this.good_match = 0;
            this.nice_match = 0;
            this.dyn_ltree = new a.Buf16(F * 2);
            this.dyn_dtree = new a.Buf16((2 * D + 1) * 2);
            this.bl_tree = new a.Buf16((2 * O + 1) * 2);
            ee(this.dyn_ltree);
            ee(this.dyn_dtree);
            ee(this.bl_tree);
            this.l_desc = null;
            this.d_desc = null;
            this.bl_desc = null;
            this.bl_count = new a.Buf16(P + 1);
            this.heap = new a.Buf16(2 * R + 1);
            ee(this.heap);
            this.heap_len = 0;
            this.heap_max = 0;
            this.depth = new a.Buf16(2 * R + 1);
            ee(this.depth);
            this.l_buf = 0;
            this.lit_bufsize = 0;
            this.last_lit = 0;
            this.d_buf = 0;
            this.opt_len = 0;
            this.static_len = 0;
            this.matches = 0;
            this.insert = 0;
            this.bi_buf = 0;
            this.bi_valid = 0;
          }
          function be(e) {
            var r;
            if (!e || !e.state) {
              return J(e, p);
            }
            e.total_in = e.total_out = 0;
            e.data_type = A;
            r = e.state;
            r.pending = 0;
            r.pending_out = 0;
            if (r.wrap < 0) {
              r.wrap = -r.wrap;
            }
            r.status = r.wrap ? H : G;
            e.adler = r.wrap === 2 ? 0 : 1;
            r.last_flush = o;
            n._tr_init(r);
            return d;
          }
          function me(e) {
            var r = be(e);
            if (r === d) {
              pe(e.state);
            }
            return r;
          }
          function Ce(e, r) {
            if (!e || !e.state) {
              return p;
            }
            if (e.state.wrap !== 2) {
              return p;
            }
            e.state.gzhead = r;
            return d;
          }
          function Ee(e, r, t, n, i, s) {
            if (!e) {
              return p;
            }
            var f = 1;
            if (r === m) {
              r = 6;
            }
            if (n < 0) {
              f = 0;
              n = -n;
            } else if (n > 15) {
              f = 2;
              n -= 16;
            }
            if (
              i < 1 ||
              i > _ ||
              t !== B ||
              n < 8 ||
              n > 15 ||
              r < 0 ||
              r > 9 ||
              s < 0 ||
              s > S
            ) {
              return J(e, p);
            }
            if (n === 8) {
              n = 9;
            }
            var o = new ge();
            e.state = o;
            o.strm = e;
            o.wrap = f;
            o.gzhead = null;
            o.w_bits = n;
            o.w_size = 1 << o.w_bits;
            o.w_mask = o.w_size - 1;
            o.hash_bits = i + 7;
            o.hash_size = 1 << o.hash_bits;
            o.hash_mask = o.hash_size - 1;
            o.hash_shift = ~~((o.hash_bits + N - 1) / N);
            o.window = new a.Buf8(o.w_size * 2);
            o.head = new a.Buf16(o.hash_size);
            o.prev = new a.Buf16(o.w_size);
            o.lit_bufsize = 1 << (i + 6);
            o.pending_buf_size = o.lit_bufsize * 4;
            o.pending_buf = new a.Buf8(o.pending_buf_size);
            o.d_buf = o.lit_bufsize >> 1;
            o.l_buf = (1 + 2) * o.lit_bufsize;
            o.level = r;
            o.strategy = s;
            o.method = t;
            return me(e);
          }
          function ke(e, r) {
            return Ee(e, r, B, T, x, w);
          }
          function Se(e, r) {
            var t, a;
            var i, f;
            if (!e || !e.state || r > u || r < 0) {
              return e ? J(e, p) : p;
            }
            a = e.state;
            if (
              !e.output ||
              (!e.input && e.avail_in !== 0) ||
              (a.status === j && r !== h)
            ) {
              return J(e, e.avail_out === 0 ? b : p);
            }
            a.strm = e;
            t = a.last_flush;
            a.last_flush = r;
            if (a.status === H) {
              if (a.wrap === 2) {
                e.adler = 0;
                ae(a, 31);
                ae(a, 139);
                ae(a, 8);
                if (!a.gzhead) {
                  ae(a, 0);
                  ae(a, 0);
                  ae(a, 0);
                  ae(a, 0);
                  ae(a, 0);
                  ae(
                    a,
                    a.level === 9 ? 2 : a.strategy >= E || a.level < 2 ? 4 : 0
                  );
                  ae(a, Q);
                  a.status = G;
                } else {
                  ae(
                    a,
                    (a.gzhead.text ? 1 : 0) +
                      (a.gzhead.hcrc ? 2 : 0) +
                      (!a.gzhead.extra ? 0 : 4) +
                      (!a.gzhead.name ? 0 : 8) +
                      (!a.gzhead.comment ? 0 : 16)
                  );
                  ae(a, a.gzhead.time & 255);
                  ae(a, (a.gzhead.time >> 8) & 255);
                  ae(a, (a.gzhead.time >> 16) & 255);
                  ae(a, (a.gzhead.time >> 24) & 255);
                  ae(
                    a,
                    a.level === 9 ? 2 : a.strategy >= E || a.level < 2 ? 4 : 0
                  );
                  ae(a, a.gzhead.os & 255);
                  if (a.gzhead.extra && a.gzhead.extra.length) {
                    ae(a, a.gzhead.extra.length & 255);
                    ae(a, (a.gzhead.extra.length >> 8) & 255);
                  }
                  if (a.gzhead.hcrc) {
                    e.adler = s(e.adler, a.pending_buf, a.pending, 0);
                  }
                  a.gzindex = 0;
                  a.status = W;
                }
              } else {
                var g = (B + ((a.w_bits - 8) << 4)) << 8;
                var m = -1;
                if (a.strategy >= E || a.level < 2) {
                  m = 0;
                } else if (a.level < 6) {
                  m = 1;
                } else if (a.level === 6) {
                  m = 2;
                } else {
                  m = 3;
                }
                g |= m << 6;
                if (a.strstart !== 0) {
                  g |= U;
                }
                g += 31 - (g % 31);
                a.status = G;
                ne(a, g);
                if (a.strstart !== 0) {
                  ne(a, e.adler >>> 16);
                  ne(a, e.adler & 65535);
                }
                e.adler = 1;
              }
            }
            if (a.status === W) {
              if (a.gzhead.extra) {
                i = a.pending;
                while (a.gzindex < (a.gzhead.extra.length & 65535)) {
                  if (a.pending === a.pending_buf_size) {
                    if (a.gzhead.hcrc && a.pending > i) {
                      e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                    }
                    re(e);
                    i = a.pending;
                    if (a.pending === a.pending_buf_size) {
                      break;
                    }
                  }
                  ae(a, a.gzhead.extra[a.gzindex] & 255);
                  a.gzindex++;
                }
                if (a.gzhead.hcrc && a.pending > i) {
                  e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                }
                if (a.gzindex === a.gzhead.extra.length) {
                  a.gzindex = 0;
                  a.status = V;
                }
              } else {
                a.status = V;
              }
            }
            if (a.status === V) {
              if (a.gzhead.name) {
                i = a.pending;
                do {
                  if (a.pending === a.pending_buf_size) {
                    if (a.gzhead.hcrc && a.pending > i) {
                      e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                    }
                    re(e);
                    i = a.pending;
                    if (a.pending === a.pending_buf_size) {
                      f = 1;
                      break;
                    }
                  }
                  if (a.gzindex < a.gzhead.name.length) {
                    f = a.gzhead.name.charCodeAt(a.gzindex++) & 255;
                  } else {
                    f = 0;
                  }
                  ae(a, f);
                } while (f !== 0);
                if (a.gzhead.hcrc && a.pending > i) {
                  e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                }
                if (f === 0) {
                  a.gzindex = 0;
                  a.status = z;
                }
              } else {
                a.status = z;
              }
            }
            if (a.status === z) {
              if (a.gzhead.comment) {
                i = a.pending;
                do {
                  if (a.pending === a.pending_buf_size) {
                    if (a.gzhead.hcrc && a.pending > i) {
                      e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                    }
                    re(e);
                    i = a.pending;
                    if (a.pending === a.pending_buf_size) {
                      f = 1;
                      break;
                    }
                  }
                  if (a.gzindex < a.gzhead.comment.length) {
                    f = a.gzhead.comment.charCodeAt(a.gzindex++) & 255;
                  } else {
                    f = 0;
                  }
                  ae(a, f);
                } while (f !== 0);
                if (a.gzhead.hcrc && a.pending > i) {
                  e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                }
                if (f === 0) {
                  a.status = X;
                }
              } else {
                a.status = X;
              }
            }
            if (a.status === X) {
              if (a.gzhead.hcrc) {
                if (a.pending + 2 > a.pending_buf_size) {
                  re(e);
                }
                if (a.pending + 2 <= a.pending_buf_size) {
                  ae(a, e.adler & 255);
                  ae(a, (e.adler >> 8) & 255);
                  e.adler = 0;
                  a.status = G;
                }
              } else {
                a.status = G;
              }
            }
            if (a.pending !== 0) {
              re(e);
              if (e.avail_out === 0) {
                a.last_flush = -1;
                return d;
              }
            } else if (e.avail_in === 0 && q(r) <= q(t) && r !== h) {
              return J(e, b);
            }
            if (a.status === j && e.avail_in !== 0) {
              return J(e, b);
            }
            if (
              e.avail_in !== 0 ||
              a.lookahead !== 0 ||
              (r !== o && a.status !== j)
            ) {
              var C =
                a.strategy === E
                  ? ue(a, r)
                  : a.strategy === k
                  ? he(a, r)
                  : ve[a.level].func(a, r);
              if (C === $ || C === Z) {
                a.status = j;
              }
              if (C === K || C === $) {
                if (e.avail_out === 0) {
                  a.last_flush = -1;
                }
                return d;
              }
              if (C === Y) {
                if (r === l) {
                  n._tr_align(a);
                } else if (r !== u) {
                  n._tr_stored_block(a, 0, 0, false);
                  if (r === c) {
                    ee(a.head);
                    if (a.lookahead === 0) {
                      a.strstart = 0;
                      a.block_start = 0;
                      a.insert = 0;
                    }
                  }
                }
                re(e);
                if (e.avail_out === 0) {
                  a.last_flush = -1;
                  return d;
                }
              }
            }
            if (r !== h) {
              return d;
            }
            if (a.wrap <= 0) {
              return v;
            }
            if (a.wrap === 2) {
              ae(a, e.adler & 255);
              ae(a, (e.adler >> 8) & 255);
              ae(a, (e.adler >> 16) & 255);
              ae(a, (e.adler >> 24) & 255);
              ae(a, e.total_in & 255);
              ae(a, (e.total_in >> 8) & 255);
              ae(a, (e.total_in >> 16) & 255);
              ae(a, (e.total_in >> 24) & 255);
            } else {
              ne(a, e.adler >>> 16);
              ne(a, e.adler & 65535);
            }
            re(e);
            if (a.wrap > 0) {
              a.wrap = -a.wrap;
            }
            return a.pending !== 0 ? d : v;
          }
          function we(e) {
            var r;
            if (!e || !e.state) {
              return p;
            }
            r = e.state.status;
            if (
              r !== H &&
              r !== W &&
              r !== V &&
              r !== z &&
              r !== X &&
              r !== G &&
              r !== j
            ) {
              return J(e, p);
            }
            e.state = null;
            return r === G ? J(e, g) : d;
          }
          t.deflateInit = ke;
          t.deflateInit2 = Ee;
          t.deflateReset = me;
          t.deflateResetKeep = be;
          t.deflateSetHeader = Ce;
          t.deflate = Se;
          t.deflateEnd = we;
          t.deflateInfo = "pako deflate (from Nodeca project)";
        },
        {
          "../utils/common": 27,
          "./adler32": 29,
          "./crc32": 31,
          "./messages": 37,
          "./trees": 38,
        },
      ],
      33: [
        function (e, r, t) {
          "use strict";
          function a() {
            this.text = 0;
            this.time = 0;
            this.xflags = 0;
            this.os = 0;
            this.extra = null;
            this.extra_len = 0;
            this.name = "";
            this.comment = "";
            this.hcrc = 0;
            this.done = false;
          }
          r.exports = a;
        },
        {},
      ],
      34: [
        function (e, r, t) {
          "use strict";
          var a = 30;
          var n = 12;
          r.exports = function i(e, r) {
            var t;
            var i;
            var s;
            var f;
            var o;
            var l;
            var c;
            var h;
            var u;
            var d;
            var v;
            var p;
            var g;
            var b;
            var m;
            var C;
            var E;
            var k;
            var S;
            var w;
            var A;
            var B;
            var _;
            var T, x;
            t = e.state;
            i = e.next_in;
            T = e.input;
            s = i + (e.avail_in - 5);
            f = e.next_out;
            x = e.output;
            o = f - (r - e.avail_out);
            l = f + (e.avail_out - 257);
            c = t.dmax;
            h = t.wsize;
            u = t.whave;
            d = t.wnext;
            v = t.window;
            p = t.hold;
            g = t.bits;
            b = t.lencode;
            m = t.distcode;
            C = (1 << t.lenbits) - 1;
            E = (1 << t.distbits) - 1;
            e: do {
              if (g < 15) {
                p += T[i++] << g;
                g += 8;
                p += T[i++] << g;
                g += 8;
              }
              k = b[p & C];
              r: for (;;) {
                S = k >>> 24;
                p >>>= S;
                g -= S;
                S = (k >>> 16) & 255;
                if (S === 0) {
                  x[f++] = k & 65535;
                } else if (S & 16) {
                  w = k & 65535;
                  S &= 15;
                  if (S) {
                    if (g < S) {
                      p += T[i++] << g;
                      g += 8;
                    }
                    w += p & ((1 << S) - 1);
                    p >>>= S;
                    g -= S;
                  }
                  if (g < 15) {
                    p += T[i++] << g;
                    g += 8;
                    p += T[i++] << g;
                    g += 8;
                  }
                  k = m[p & E];
                  t: for (;;) {
                    S = k >>> 24;
                    p >>>= S;
                    g -= S;
                    S = (k >>> 16) & 255;
                    if (S & 16) {
                      A = k & 65535;
                      S &= 15;
                      if (g < S) {
                        p += T[i++] << g;
                        g += 8;
                        if (g < S) {
                          p += T[i++] << g;
                          g += 8;
                        }
                      }
                      A += p & ((1 << S) - 1);
                      if (A > c) {
                        e.msg = "invalid distance too far back";
                        t.mode = a;
                        break e;
                      }
                      p >>>= S;
                      g -= S;
                      S = f - o;
                      if (A > S) {
                        S = A - S;
                        if (S > u) {
                          if (t.sane) {
                            e.msg = "invalid distance too far back";
                            t.mode = a;
                            break e;
                          }
                        }
                        B = 0;
                        _ = v;
                        if (d === 0) {
                          B += h - S;
                          if (S < w) {
                            w -= S;
                            do {
                              x[f++] = v[B++];
                            } while (--S);
                            B = f - A;
                            _ = x;
                          }
                        } else if (d < S) {
                          B += h + d - S;
                          S -= d;
                          if (S < w) {
                            w -= S;
                            do {
                              x[f++] = v[B++];
                            } while (--S);
                            B = 0;
                            if (d < w) {
                              S = d;
                              w -= S;
                              do {
                                x[f++] = v[B++];
                              } while (--S);
                              B = f - A;
                              _ = x;
                            }
                          }
                        } else {
                          B += d - S;
                          if (S < w) {
                            w -= S;
                            do {
                              x[f++] = v[B++];
                            } while (--S);
                            B = f - A;
                            _ = x;
                          }
                        }
                        while (w > 2) {
                          x[f++] = _[B++];
                          x[f++] = _[B++];
                          x[f++] = _[B++];
                          w -= 3;
                        }
                        if (w) {
                          x[f++] = _[B++];
                          if (w > 1) {
                            x[f++] = _[B++];
                          }
                        }
                      } else {
                        B = f - A;
                        do {
                          x[f++] = x[B++];
                          x[f++] = x[B++];
                          x[f++] = x[B++];
                          w -= 3;
                        } while (w > 2);
                        if (w) {
                          x[f++] = x[B++];
                          if (w > 1) {
                            x[f++] = x[B++];
                          }
                        }
                      }
                    } else if ((S & 64) === 0) {
                      k = m[(k & 65535) + (p & ((1 << S) - 1))];
                      continue t;
                    } else {
                      e.msg = "invalid distance code";
                      t.mode = a;
                      break e;
                    }
                    break;
                  }
                } else if ((S & 64) === 0) {
                  k = b[(k & 65535) + (p & ((1 << S) - 1))];
                  continue r;
                } else if (S & 32) {
                  t.mode = n;
                  break e;
                } else {
                  e.msg = "invalid literal/length code";
                  t.mode = a;
                  break e;
                }
                break;
              }
            } while (i < s && f < l);
            w = g >> 3;
            i -= w;
            g -= w << 3;
            p &= (1 << g) - 1;
            e.next_in = i;
            e.next_out = f;
            e.avail_in = i < s ? 5 + (s - i) : 5 - (i - s);
            e.avail_out = f < l ? 257 + (l - f) : 257 - (f - l);
            t.hold = p;
            t.bits = g;
            return;
          };
        },
        {},
      ],
      35: [
        function (e, r, t) {
          "use strict";
          var a = e("../utils/common");
          var n = e("./adler32");
          var i = e("./crc32");
          var s = e("./inffast");
          var f = e("./inftrees");
          var o = 0;
          var l = 1;
          var c = 2;
          var h = 4;
          var u = 5;
          var d = 6;
          var v = 0;
          var p = 1;
          var g = 2;
          var b = -2;
          var m = -3;
          var C = -4;
          var E = -5;
          var k = 8;
          var S = 1;
          var w = 2;
          var A = 3;
          var B = 4;
          var _ = 5;
          var T = 6;
          var x = 7;
          var I = 8;
          var y = 9;
          var R = 10;
          var D = 11;
          var O = 12;
          var F = 13;
          var P = 14;
          var N = 15;
          var L = 16;
          var M = 17;
          var U = 18;
          var H = 19;
          var W = 20;
          var V = 21;
          var z = 22;
          var X = 23;
          var G = 24;
          var j = 25;
          var K = 26;
          var Y = 27;
          var $ = 28;
          var Z = 29;
          var Q = 30;
          var J = 31;
          var q = 32;
          var ee = 852;
          var re = 592;
          var te = 15;
          var ae = te;
          function ne(e) {
            return (
              ((e >>> 24) & 255) +
              ((e >>> 8) & 65280) +
              ((e & 65280) << 8) +
              ((e & 255) << 24)
            );
          }
          function ie() {
            this.mode = 0;
            this.last = false;
            this.wrap = 0;
            this.havedict = false;
            this.flags = 0;
            this.dmax = 0;
            this.check = 0;
            this.total = 0;
            this.head = null;
            this.wbits = 0;
            this.wsize = 0;
            this.whave = 0;
            this.wnext = 0;
            this.window = null;
            this.hold = 0;
            this.bits = 0;
            this.length = 0;
            this.offset = 0;
            this.extra = 0;
            this.lencode = null;
            this.distcode = null;
            this.lenbits = 0;
            this.distbits = 0;
            this.ncode = 0;
            this.nlen = 0;
            this.ndist = 0;
            this.have = 0;
            this.next = null;
            this.lens = new a.Buf16(320);
            this.work = new a.Buf16(288);
            this.lendyn = null;
            this.distdyn = null;
            this.sane = 0;
            this.back = 0;
            this.was = 0;
          }
          function se(e) {
            var r;
            if (!e || !e.state) {
              return b;
            }
            r = e.state;
            e.total_in = e.total_out = r.total = 0;
            e.msg = "";
            if (r.wrap) {
              e.adler = r.wrap & 1;
            }
            r.mode = S;
            r.last = 0;
            r.havedict = 0;
            r.dmax = 32768;
            r.head = null;
            r.hold = 0;
            r.bits = 0;
            r.lencode = r.lendyn = new a.Buf32(ee);
            r.distcode = r.distdyn = new a.Buf32(re);
            r.sane = 1;
            r.back = -1;
            return v;
          }
          function fe(e) {
            var r;
            if (!e || !e.state) {
              return b;
            }
            r = e.state;
            r.wsize = 0;
            r.whave = 0;
            r.wnext = 0;
            return se(e);
          }
          function oe(e, r) {
            var t;
            var a;
            if (!e || !e.state) {
              return b;
            }
            a = e.state;
            if (r < 0) {
              t = 0;
              r = -r;
            } else {
              t = (r >> 4) + 1;
              if (r < 48) {
                r &= 15;
              }
            }
            if (r && (r < 8 || r > 15)) {
              return b;
            }
            if (a.window !== null && a.wbits !== r) {
              a.window = null;
            }
            a.wrap = t;
            a.wbits = r;
            return fe(e);
          }
          function le(e, r) {
            var t;
            var a;
            if (!e) {
              return b;
            }
            a = new ie();
            e.state = a;
            a.window = null;
            t = oe(e, r);
            if (t !== v) {
              e.state = null;
            }
            return t;
          }
          function ce(e) {
            return le(e, ae);
          }
          var he = true;
          var ue, de;
          function ve(e) {
            if (he) {
              var r;
              ue = new a.Buf32(512);
              de = new a.Buf32(32);
              r = 0;
              while (r < 144) {
                e.lens[r++] = 8;
              }
              while (r < 256) {
                e.lens[r++] = 9;
              }
              while (r < 280) {
                e.lens[r++] = 7;
              }
              while (r < 288) {
                e.lens[r++] = 8;
              }
              f(l, e.lens, 0, 288, ue, 0, e.work, { bits: 9 });
              r = 0;
              while (r < 32) {
                e.lens[r++] = 5;
              }
              f(c, e.lens, 0, 32, de, 0, e.work, { bits: 5 });
              he = false;
            }
            e.lencode = ue;
            e.lenbits = 9;
            e.distcode = de;
            e.distbits = 5;
          }
          function pe(e, r, t, n) {
            var i;
            var s = e.state;
            if (s.window === null) {
              s.wsize = 1 << s.wbits;
              s.wnext = 0;
              s.whave = 0;
              s.window = new a.Buf8(s.wsize);
            }
            if (n >= s.wsize) {
              a.arraySet(s.window, r, t - s.wsize, s.wsize, 0);
              s.wnext = 0;
              s.whave = s.wsize;
            } else {
              i = s.wsize - s.wnext;
              if (i > n) {
                i = n;
              }
              a.arraySet(s.window, r, t - n, i, s.wnext);
              n -= i;
              if (n) {
                a.arraySet(s.window, r, t - n, n, 0);
                s.wnext = n;
                s.whave = s.wsize;
              } else {
                s.wnext += i;
                if (s.wnext === s.wsize) {
                  s.wnext = 0;
                }
                if (s.whave < s.wsize) {
                  s.whave += i;
                }
              }
            }
            return 0;
          }
          function ge(e, r) {
            var t;
            var ee, re;
            var te;
            var ae;
            var ie, se;
            var fe;
            var oe;
            var le, ce;
            var he;
            var ue;
            var de;
            var ge = 0;
            var be, me, Ce;
            var Ee, ke, Se;
            var we;
            var Ae;
            var Be = new a.Buf8(4);
            var _e;
            var Te;
            var xe = [
              16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15,
            ];
            if (!e || !e.state || !e.output || (!e.input && e.avail_in !== 0)) {
              return b;
            }
            t = e.state;
            if (t.mode === O) {
              t.mode = F;
            }
            ae = e.next_out;
            re = e.output;
            se = e.avail_out;
            te = e.next_in;
            ee = e.input;
            ie = e.avail_in;
            fe = t.hold;
            oe = t.bits;
            le = ie;
            ce = se;
            Ae = v;
            e: for (;;) {
              switch (t.mode) {
                case S:
                  if (t.wrap === 0) {
                    t.mode = F;
                    break;
                  }
                  while (oe < 16) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if (t.wrap & 2 && fe === 35615) {
                    t.check = 0;
                    Be[0] = fe & 255;
                    Be[1] = (fe >>> 8) & 255;
                    t.check = i(t.check, Be, 2, 0);
                    fe = 0;
                    oe = 0;
                    t.mode = w;
                    break;
                  }
                  t.flags = 0;
                  if (t.head) {
                    t.head.done = false;
                  }
                  if (!(t.wrap & 1) || (((fe & 255) << 8) + (fe >> 8)) % 31) {
                    e.msg = "incorrect header check";
                    t.mode = Q;
                    break;
                  }
                  if ((fe & 15) !== k) {
                    e.msg = "unknown compression method";
                    t.mode = Q;
                    break;
                  }
                  fe >>>= 4;
                  oe -= 4;
                  we = (fe & 15) + 8;
                  if (t.wbits === 0) {
                    t.wbits = we;
                  } else if (we > t.wbits) {
                    e.msg = "invalid window size";
                    t.mode = Q;
                    break;
                  }
                  t.dmax = 1 << we;
                  e.adler = t.check = 1;
                  t.mode = fe & 512 ? R : O;
                  fe = 0;
                  oe = 0;
                  break;
                case w:
                  while (oe < 16) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  t.flags = fe;
                  if ((t.flags & 255) !== k) {
                    e.msg = "unknown compression method";
                    t.mode = Q;
                    break;
                  }
                  if (t.flags & 57344) {
                    e.msg = "unknown header flags set";
                    t.mode = Q;
                    break;
                  }
                  if (t.head) {
                    t.head.text = (fe >> 8) & 1;
                  }
                  if (t.flags & 512) {
                    Be[0] = fe & 255;
                    Be[1] = (fe >>> 8) & 255;
                    t.check = i(t.check, Be, 2, 0);
                  }
                  fe = 0;
                  oe = 0;
                  t.mode = A;
                case A:
                  while (oe < 32) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if (t.head) {
                    t.head.time = fe;
                  }
                  if (t.flags & 512) {
                    Be[0] = fe & 255;
                    Be[1] = (fe >>> 8) & 255;
                    Be[2] = (fe >>> 16) & 255;
                    Be[3] = (fe >>> 24) & 255;
                    t.check = i(t.check, Be, 4, 0);
                  }
                  fe = 0;
                  oe = 0;
                  t.mode = B;
                case B:
                  while (oe < 16) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if (t.head) {
                    t.head.xflags = fe & 255;
                    t.head.os = fe >> 8;
                  }
                  if (t.flags & 512) {
                    Be[0] = fe & 255;
                    Be[1] = (fe >>> 8) & 255;
                    t.check = i(t.check, Be, 2, 0);
                  }
                  fe = 0;
                  oe = 0;
                  t.mode = _;
                case _:
                  if (t.flags & 1024) {
                    while (oe < 16) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    t.length = fe;
                    if (t.head) {
                      t.head.extra_len = fe;
                    }
                    if (t.flags & 512) {
                      Be[0] = fe & 255;
                      Be[1] = (fe >>> 8) & 255;
                      t.check = i(t.check, Be, 2, 0);
                    }
                    fe = 0;
                    oe = 0;
                  } else if (t.head) {
                    t.head.extra = null;
                  }
                  t.mode = T;
                case T:
                  if (t.flags & 1024) {
                    he = t.length;
                    if (he > ie) {
                      he = ie;
                    }
                    if (he) {
                      if (t.head) {
                        we = t.head.extra_len - t.length;
                        if (!t.head.extra) {
                          t.head.extra = new Array(t.head.extra_len);
                        }
                        a.arraySet(t.head.extra, ee, te, he, we);
                      }
                      if (t.flags & 512) {
                        t.check = i(t.check, ee, he, te);
                      }
                      ie -= he;
                      te += he;
                      t.length -= he;
                    }
                    if (t.length) {
                      break e;
                    }
                  }
                  t.length = 0;
                  t.mode = x;
                case x:
                  if (t.flags & 2048) {
                    if (ie === 0) {
                      break e;
                    }
                    he = 0;
                    do {
                      we = ee[te + he++];
                      if (t.head && we && t.length < 65536) {
                        t.head.name += String.fromCharCode(we);
                      }
                    } while (we && he < ie);
                    if (t.flags & 512) {
                      t.check = i(t.check, ee, he, te);
                    }
                    ie -= he;
                    te += he;
                    if (we) {
                      break e;
                    }
                  } else if (t.head) {
                    t.head.name = null;
                  }
                  t.length = 0;
                  t.mode = I;
                case I:
                  if (t.flags & 4096) {
                    if (ie === 0) {
                      break e;
                    }
                    he = 0;
                    do {
                      we = ee[te + he++];
                      if (t.head && we && t.length < 65536) {
                        t.head.comment += String.fromCharCode(we);
                      }
                    } while (we && he < ie);
                    if (t.flags & 512) {
                      t.check = i(t.check, ee, he, te);
                    }
                    ie -= he;
                    te += he;
                    if (we) {
                      break e;
                    }
                  } else if (t.head) {
                    t.head.comment = null;
                  }
                  t.mode = y;
                case y:
                  if (t.flags & 512) {
                    while (oe < 16) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    if (fe !== (t.check & 65535)) {
                      e.msg = "header crc mismatch";
                      t.mode = Q;
                      break;
                    }
                    fe = 0;
                    oe = 0;
                  }
                  if (t.head) {
                    t.head.hcrc = (t.flags >> 9) & 1;
                    t.head.done = true;
                  }
                  e.adler = t.check = 0;
                  t.mode = O;
                  break;
                case R:
                  while (oe < 32) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  e.adler = t.check = ne(fe);
                  fe = 0;
                  oe = 0;
                  t.mode = D;
                case D:
                  if (t.havedict === 0) {
                    e.next_out = ae;
                    e.avail_out = se;
                    e.next_in = te;
                    e.avail_in = ie;
                    t.hold = fe;
                    t.bits = oe;
                    return g;
                  }
                  e.adler = t.check = 1;
                  t.mode = O;
                case O:
                  if (r === u || r === d) {
                    break e;
                  }
                case F:
                  if (t.last) {
                    fe >>>= oe & 7;
                    oe -= oe & 7;
                    t.mode = Y;
                    break;
                  }
                  while (oe < 3) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  t.last = fe & 1;
                  fe >>>= 1;
                  oe -= 1;
                  switch (fe & 3) {
                    case 0:
                      t.mode = P;
                      break;
                    case 1:
                      ve(t);
                      t.mode = W;
                      if (r === d) {
                        fe >>>= 2;
                        oe -= 2;
                        break e;
                      }
                      break;
                    case 2:
                      t.mode = M;
                      break;
                    case 3:
                      e.msg = "invalid block type";
                      t.mode = Q;
                  }
                  fe >>>= 2;
                  oe -= 2;
                  break;
                case P:
                  fe >>>= oe & 7;
                  oe -= oe & 7;
                  while (oe < 32) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if ((fe & 65535) !== ((fe >>> 16) ^ 65535)) {
                    e.msg = "invalid stored block lengths";
                    t.mode = Q;
                    break;
                  }
                  t.length = fe & 65535;
                  fe = 0;
                  oe = 0;
                  t.mode = N;
                  if (r === d) {
                    break e;
                  }
                case N:
                  t.mode = L;
                case L:
                  he = t.length;
                  if (he) {
                    if (he > ie) {
                      he = ie;
                    }
                    if (he > se) {
                      he = se;
                    }
                    if (he === 0) {
                      break e;
                    }
                    a.arraySet(re, ee, te, he, ae);
                    ie -= he;
                    te += he;
                    se -= he;
                    ae += he;
                    t.length -= he;
                    break;
                  }
                  t.mode = O;
                  break;
                case M:
                  while (oe < 14) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  t.nlen = (fe & 31) + 257;
                  fe >>>= 5;
                  oe -= 5;
                  t.ndist = (fe & 31) + 1;
                  fe >>>= 5;
                  oe -= 5;
                  t.ncode = (fe & 15) + 4;
                  fe >>>= 4;
                  oe -= 4;
                  if (t.nlen > 286 || t.ndist > 30) {
                    e.msg = "too many length or distance symbols";
                    t.mode = Q;
                    break;
                  }
                  t.have = 0;
                  t.mode = U;
                case U:
                  while (t.have < t.ncode) {
                    while (oe < 3) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    t.lens[xe[t.have++]] = fe & 7;
                    fe >>>= 3;
                    oe -= 3;
                  }
                  while (t.have < 19) {
                    t.lens[xe[t.have++]] = 0;
                  }
                  t.lencode = t.lendyn;
                  t.lenbits = 7;
                  _e = { bits: t.lenbits };
                  Ae = f(o, t.lens, 0, 19, t.lencode, 0, t.work, _e);
                  t.lenbits = _e.bits;
                  if (Ae) {
                    e.msg = "invalid code lengths set";
                    t.mode = Q;
                    break;
                  }
                  t.have = 0;
                  t.mode = H;
                case H:
                  while (t.have < t.nlen + t.ndist) {
                    for (;;) {
                      ge = t.lencode[fe & ((1 << t.lenbits) - 1)];
                      be = ge >>> 24;
                      me = (ge >>> 16) & 255;
                      Ce = ge & 65535;
                      if (be <= oe) {
                        break;
                      }
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    if (Ce < 16) {
                      fe >>>= be;
                      oe -= be;
                      t.lens[t.have++] = Ce;
                    } else {
                      if (Ce === 16) {
                        Te = be + 2;
                        while (oe < Te) {
                          if (ie === 0) {
                            break e;
                          }
                          ie--;
                          fe += ee[te++] << oe;
                          oe += 8;
                        }
                        fe >>>= be;
                        oe -= be;
                        if (t.have === 0) {
                          e.msg = "invalid bit length repeat";
                          t.mode = Q;
                          break;
                        }
                        we = t.lens[t.have - 1];
                        he = 3 + (fe & 3);
                        fe >>>= 2;
                        oe -= 2;
                      } else if (Ce === 17) {
                        Te = be + 3;
                        while (oe < Te) {
                          if (ie === 0) {
                            break e;
                          }
                          ie--;
                          fe += ee[te++] << oe;
                          oe += 8;
                        }
                        fe >>>= be;
                        oe -= be;
                        we = 0;
                        he = 3 + (fe & 7);
                        fe >>>= 3;
                        oe -= 3;
                      } else {
                        Te = be + 7;
                        while (oe < Te) {
                          if (ie === 0) {
                            break e;
                          }
                          ie--;
                          fe += ee[te++] << oe;
                          oe += 8;
                        }
                        fe >>>= be;
                        oe -= be;
                        we = 0;
                        he = 11 + (fe & 127);
                        fe >>>= 7;
                        oe -= 7;
                      }
                      if (t.have + he > t.nlen + t.ndist) {
                        e.msg = "invalid bit length repeat";
                        t.mode = Q;
                        break;
                      }
                      while (he--) {
                        t.lens[t.have++] = we;
                      }
                    }
                  }
                  if (t.mode === Q) {
                    break;
                  }
                  if (t.lens[256] === 0) {
                    e.msg = "invalid code -- missing end-of-block";
                    t.mode = Q;
                    break;
                  }
                  t.lenbits = 9;
                  _e = { bits: t.lenbits };
                  Ae = f(l, t.lens, 0, t.nlen, t.lencode, 0, t.work, _e);
                  t.lenbits = _e.bits;
                  if (Ae) {
                    e.msg = "invalid literal/lengths set";
                    t.mode = Q;
                    break;
                  }
                  t.distbits = 6;
                  t.distcode = t.distdyn;
                  _e = { bits: t.distbits };
                  Ae = f(c, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, _e);
                  t.distbits = _e.bits;
                  if (Ae) {
                    e.msg = "invalid distances set";
                    t.mode = Q;
                    break;
                  }
                  t.mode = W;
                  if (r === d) {
                    break e;
                  }
                case W:
                  t.mode = V;
                case V:
                  if (ie >= 6 && se >= 258) {
                    e.next_out = ae;
                    e.avail_out = se;
                    e.next_in = te;
                    e.avail_in = ie;
                    t.hold = fe;
                    t.bits = oe;
                    s(e, ce);
                    ae = e.next_out;
                    re = e.output;
                    se = e.avail_out;
                    te = e.next_in;
                    ee = e.input;
                    ie = e.avail_in;
                    fe = t.hold;
                    oe = t.bits;
                    if (t.mode === O) {
                      t.back = -1;
                    }
                    break;
                  }
                  t.back = 0;
                  for (;;) {
                    ge = t.lencode[fe & ((1 << t.lenbits) - 1)];
                    be = ge >>> 24;
                    me = (ge >>> 16) & 255;
                    Ce = ge & 65535;
                    if (be <= oe) {
                      break;
                    }
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if (me && (me & 240) === 0) {
                    Ee = be;
                    ke = me;
                    Se = Ce;
                    for (;;) {
                      ge =
                        t.lencode[Se + ((fe & ((1 << (Ee + ke)) - 1)) >> Ee)];
                      be = ge >>> 24;
                      me = (ge >>> 16) & 255;
                      Ce = ge & 65535;
                      if (Ee + be <= oe) {
                        break;
                      }
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    fe >>>= Ee;
                    oe -= Ee;
                    t.back += Ee;
                  }
                  fe >>>= be;
                  oe -= be;
                  t.back += be;
                  t.length = Ce;
                  if (me === 0) {
                    t.mode = K;
                    break;
                  }
                  if (me & 32) {
                    t.back = -1;
                    t.mode = O;
                    break;
                  }
                  if (me & 64) {
                    e.msg = "invalid literal/length code";
                    t.mode = Q;
                    break;
                  }
                  t.extra = me & 15;
                  t.mode = z;
                case z:
                  if (t.extra) {
                    Te = t.extra;
                    while (oe < Te) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    t.length += fe & ((1 << t.extra) - 1);
                    fe >>>= t.extra;
                    oe -= t.extra;
                    t.back += t.extra;
                  }
                  t.was = t.length;
                  t.mode = X;
                case X:
                  for (;;) {
                    ge = t.distcode[fe & ((1 << t.distbits) - 1)];
                    be = ge >>> 24;
                    me = (ge >>> 16) & 255;
                    Ce = ge & 65535;
                    if (be <= oe) {
                      break;
                    }
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if ((me & 240) === 0) {
                    Ee = be;
                    ke = me;
                    Se = Ce;
                    for (;;) {
                      ge =
                        t.distcode[Se + ((fe & ((1 << (Ee + ke)) - 1)) >> Ee)];
                      be = ge >>> 24;
                      me = (ge >>> 16) & 255;
                      Ce = ge & 65535;
                      if (Ee + be <= oe) {
                        break;
                      }
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    fe >>>= Ee;
                    oe -= Ee;
                    t.back += Ee;
                  }
                  fe >>>= be;
                  oe -= be;
                  t.back += be;
                  if (me & 64) {
                    e.msg = "invalid distance code";
                    t.mode = Q;
                    break;
                  }
                  t.offset = Ce;
                  t.extra = me & 15;
                  t.mode = G;
                case G:
                  if (t.extra) {
                    Te = t.extra;
                    while (oe < Te) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    t.offset += fe & ((1 << t.extra) - 1);
                    fe >>>= t.extra;
                    oe -= t.extra;
                    t.back += t.extra;
                  }
                  if (t.offset > t.dmax) {
                    e.msg = "invalid distance too far back";
                    t.mode = Q;
                    break;
                  }
                  t.mode = j;
                case j:
                  if (se === 0) {
                    break e;
                  }
                  he = ce - se;
                  if (t.offset > he) {
                    he = t.offset - he;
                    if (he > t.whave) {
                      if (t.sane) {
                        e.msg = "invalid distance too far back";
                        t.mode = Q;
                        break;
                      }
                    }
                    if (he > t.wnext) {
                      he -= t.wnext;
                      ue = t.wsize - he;
                    } else {
                      ue = t.wnext - he;
                    }
                    if (he > t.length) {
                      he = t.length;
                    }
                    de = t.window;
                  } else {
                    de = re;
                    ue = ae - t.offset;
                    he = t.length;
                  }
                  if (he > se) {
                    he = se;
                  }
                  se -= he;
                  t.length -= he;
                  do {
                    re[ae++] = de[ue++];
                  } while (--he);
                  if (t.length === 0) {
                    t.mode = V;
                  }
                  break;
                case K:
                  if (se === 0) {
                    break e;
                  }
                  re[ae++] = t.length;
                  se--;
                  t.mode = V;
                  break;
                case Y:
                  if (t.wrap) {
                    while (oe < 32) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe |= ee[te++] << oe;
                      oe += 8;
                    }
                    ce -= se;
                    e.total_out += ce;
                    t.total += ce;
                    if (ce) {
                      e.adler = t.check = t.flags
                        ? i(t.check, re, ce, ae - ce)
                        : n(t.check, re, ce, ae - ce);
                    }
                    ce = se;
                    if ((t.flags ? fe : ne(fe)) !== t.check) {
                      e.msg = "incorrect data check";
                      t.mode = Q;
                      break;
                    }
                    fe = 0;
                    oe = 0;
                  }
                  t.mode = $;
                case $:
                  if (t.wrap && t.flags) {
                    while (oe < 32) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    if (fe !== (t.total & 4294967295)) {
                      e.msg = "incorrect length check";
                      t.mode = Q;
                      break;
                    }
                    fe = 0;
                    oe = 0;
                  }
                  t.mode = Z;
                case Z:
                  Ae = p;
                  break e;
                case Q:
                  Ae = m;
                  break e;
                case J:
                  return C;
                case q:
                default:
                  return b;
              }
            }
            e.next_out = ae;
            e.avail_out = se;
            e.next_in = te;
            e.avail_in = ie;
            t.hold = fe;
            t.bits = oe;
            if (
              t.wsize ||
              (ce !== e.avail_out && t.mode < Q && (t.mode < Y || r !== h))
            ) {
              if (pe(e, e.output, e.next_out, ce - e.avail_out)) {
                t.mode = J;
                return C;
              }
            }
            le -= e.avail_in;
            ce -= e.avail_out;
            e.total_in += le;
            e.total_out += ce;
            t.total += ce;
            if (t.wrap && ce) {
              e.adler = t.check = t.flags
                ? i(t.check, re, ce, e.next_out - ce)
                : n(t.check, re, ce, e.next_out - ce);
            }
            e.data_type =
              t.bits +
              (t.last ? 64 : 0) +
              (t.mode === O ? 128 : 0) +
              (t.mode === W || t.mode === N ? 256 : 0);
            if (((le === 0 && ce === 0) || r === h) && Ae === v) {
              Ae = E;
            }
            return Ae;
          }
          function be(e) {
            if (!e || !e.state) {
              return b;
            }
            var r = e.state;
            if (r.window) {
              r.window = null;
            }
            e.state = null;
            return v;
          }
          function me(e, r) {
            var t;
            if (!e || !e.state) {
              return b;
            }
            t = e.state;
            if ((t.wrap & 2) === 0) {
              return b;
            }
            t.head = r;
            r.done = false;
            return v;
          }
          t.inflateReset = fe;
          t.inflateReset2 = oe;
          t.inflateResetKeep = se;
          t.inflateInit = ce;
          t.inflateInit2 = le;
          t.inflate = ge;
          t.inflateEnd = be;
          t.inflateGetHeader = me;
          t.inflateInfo = "pako inflate (from Nodeca project)";
        },
        {
          "../utils/common": 27,
          "./adler32": 29,
          "./crc32": 31,
          "./inffast": 34,
          "./inftrees": 36,
        },
      ],
      36: [
        function (e, r, t) {
          "use strict";
          var a = e("../utils/common");
          var n = 15;
          var i = 852;
          var s = 592;
          var f = 0;
          var o = 1;
          var l = 2;
          var c = [
            3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51,
            59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0,
          ];
          var h = [
            16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19,
            19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78,
          ];
          var u = [
            1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385,
            513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385,
            24577, 0, 0,
          ];
          var d = [
            16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23,
            23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64,
          ];
          r.exports = function v(e, r, t, p, g, b, m, C) {
            var E = C.bits;
            var k = 0;
            var S = 0;
            var w = 0,
              A = 0;
            var B = 0;
            var _ = 0;
            var T = 0;
            var x = 0;
            var I = 0;
            var y = 0;
            var R;
            var D;
            var O;
            var F;
            var P;
            var N = null;
            var L = 0;
            var M;
            var U = new a.Buf16(n + 1);
            var H = new a.Buf16(n + 1);
            var W = null;
            var V = 0;
            var z, X, G;
            for (k = 0; k <= n; k++) {
              U[k] = 0;
            }
            for (S = 0; S < p; S++) {
              U[r[t + S]]++;
            }
            B = E;
            for (A = n; A >= 1; A--) {
              if (U[A] !== 0) {
                break;
              }
            }
            if (B > A) {
              B = A;
            }
            if (A === 0) {
              g[b++] = (1 << 24) | (64 << 16) | 0;
              g[b++] = (1 << 24) | (64 << 16) | 0;
              C.bits = 1;
              return 0;
            }
            for (w = 1; w < A; w++) {
              if (U[w] !== 0) {
                break;
              }
            }
            if (B < w) {
              B = w;
            }
            x = 1;
            for (k = 1; k <= n; k++) {
              x <<= 1;
              x -= U[k];
              if (x < 0) {
                return -1;
              }
            }
            if (x > 0 && (e === f || A !== 1)) {
              return -1;
            }
            H[1] = 0;
            for (k = 1; k < n; k++) {
              H[k + 1] = H[k] + U[k];
            }
            for (S = 0; S < p; S++) {
              if (r[t + S] !== 0) {
                m[H[r[t + S]]++] = S;
              }
            }
            if (e === f) {
              N = W = m;
              M = 19;
            } else if (e === o) {
              N = c;
              L -= 257;
              W = h;
              V -= 257;
              M = 256;
            } else {
              N = u;
              W = d;
              M = -1;
            }
            y = 0;
            S = 0;
            k = w;
            P = b;
            _ = B;
            T = 0;
            O = -1;
            I = 1 << B;
            F = I - 1;
            if ((e === o && I > i) || (e === l && I > s)) {
              return 1;
            }
            var j = 0;
            for (;;) {
              j++;
              z = k - T;
              if (m[S] < M) {
                X = 0;
                G = m[S];
              } else if (m[S] > M) {
                X = W[V + m[S]];
                G = N[L + m[S]];
              } else {
                X = 32 + 64;
                G = 0;
              }
              R = 1 << (k - T);
              D = 1 << _;
              w = D;
              do {
                D -= R;
                g[P + (y >> T) + D] = (z << 24) | (X << 16) | G | 0;
              } while (D !== 0);
              R = 1 << (k - 1);
              while (y & R) {
                R >>= 1;
              }
              if (R !== 0) {
                y &= R - 1;
                y += R;
              } else {
                y = 0;
              }
              S++;
              if (--U[k] === 0) {
                if (k === A) {
                  break;
                }
                k = r[t + m[S]];
              }
              if (k > B && (y & F) !== O) {
                if (T === 0) {
                  T = B;
                }
                P += w;
                _ = k - T;
                x = 1 << _;
                while (_ + T < A) {
                  x -= U[_ + T];
                  if (x <= 0) {
                    break;
                  }
                  _++;
                  x <<= 1;
                }
                I += 1 << _;
                if ((e === o && I > i) || (e === l && I > s)) {
                  return 1;
                }
                O = y & F;
                g[O] = (B << 24) | (_ << 16) | (P - b) | 0;
              }
            }
            if (y !== 0) {
              g[P + y] = ((k - T) << 24) | (64 << 16) | 0;
            }
            C.bits = B;
            return 0;
          };
        },
        { "../utils/common": 27 },
      ],
      37: [
        function (e, r, t) {
          "use strict";
          r.exports = {
            2: "need dictionary",
            1: "stream end",
            0: "",
            "-1": "file error",
            "-2": "stream error",
            "-3": "data error",
            "-4": "insufficient memory",
            "-5": "buffer error",
            "-6": "incompatible version",
          };
        },
        {},
      ],
      38: [
        function (e, r, t) {
          "use strict";
          var a = e("../utils/common");
          var n = 4;
          var i = 0;
          var s = 1;
          var f = 2;
          function o(e) {
            var r = e.length;
            while (--r >= 0) {
              e[r] = 0;
            }
          }
          var l = 0;
          var c = 1;
          var h = 2;
          var u = 3;
          var d = 258;
          var v = 29;
          var p = 256;
          var g = p + 1 + v;
          var b = 30;
          var m = 19;
          var C = 2 * g + 1;
          var E = 15;
          var k = 16;
          var S = 7;
          var w = 256;
          var A = 16;
          var B = 17;
          var _ = 18;
          var T = [
            0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4,
            4, 5, 5, 5, 5, 0,
          ];
          var x = [
            0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9,
            10, 10, 11, 11, 12, 12, 13, 13,
          ];
          var I = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7];
          var y = [
            16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15,
          ];
          var R = 512;
          var D = new Array((g + 2) * 2);
          o(D);
          var O = new Array(b * 2);
          o(O);
          var F = new Array(R);
          o(F);
          var P = new Array(d - u + 1);
          o(P);
          var N = new Array(v);
          o(N);
          var L = new Array(b);
          o(L);
          var M = function (e, r, t, a, n) {
            this.static_tree = e;
            this.extra_bits = r;
            this.extra_base = t;
            this.elems = a;
            this.max_length = n;
            this.has_stree = e && e.length;
          };
          var U;
          var H;
          var W;
          var V = function (e, r) {
            this.dyn_tree = e;
            this.max_code = 0;
            this.stat_desc = r;
          };
          function z(e) {
            return e < 256 ? F[e] : F[256 + (e >>> 7)];
          }
          function X(e, r) {
            e.pending_buf[e.pending++] = r & 255;
            e.pending_buf[e.pending++] = (r >>> 8) & 255;
          }
          function G(e, r, t) {
            if (e.bi_valid > k - t) {
              e.bi_buf |= (r << e.bi_valid) & 65535;
              X(e, e.bi_buf);
              e.bi_buf = r >> (k - e.bi_valid);
              e.bi_valid += t - k;
            } else {
              e.bi_buf |= (r << e.bi_valid) & 65535;
              e.bi_valid += t;
            }
          }
          function j(e, r, t) {
            G(e, t[r * 2], t[r * 2 + 1]);
          }
          function K(e, r) {
            var t = 0;
            do {
              t |= e & 1;
              e >>>= 1;
              t <<= 1;
            } while (--r > 0);
            return t >>> 1;
          }
          function Y(e) {
            if (e.bi_valid === 16) {
              X(e, e.bi_buf);
              e.bi_buf = 0;
              e.bi_valid = 0;
            } else if (e.bi_valid >= 8) {
              e.pending_buf[e.pending++] = e.bi_buf & 255;
              e.bi_buf >>= 8;
              e.bi_valid -= 8;
            }
          }
          function $(e, r) {
            var t = r.dyn_tree;
            var a = r.max_code;
            var n = r.stat_desc.static_tree;
            var i = r.stat_desc.has_stree;
            var s = r.stat_desc.extra_bits;
            var f = r.stat_desc.extra_base;
            var o = r.stat_desc.max_length;
            var l;
            var c, h;
            var u;
            var d;
            var v;
            var p = 0;
            for (u = 0; u <= E; u++) {
              e.bl_count[u] = 0;
            }
            t[e.heap[e.heap_max] * 2 + 1] = 0;
            for (l = e.heap_max + 1; l < C; l++) {
              c = e.heap[l];
              u = t[t[c * 2 + 1] * 2 + 1] + 1;
              if (u > o) {
                u = o;
                p++;
              }
              t[c * 2 + 1] = u;
              if (c > a) {
                continue;
              }
              e.bl_count[u]++;
              d = 0;
              if (c >= f) {
                d = s[c - f];
              }
              v = t[c * 2];
              e.opt_len += v * (u + d);
              if (i) {
                e.static_len += v * (n[c * 2 + 1] + d);
              }
            }
            if (p === 0) {
              return;
            }
            do {
              u = o - 1;
              while (e.bl_count[u] === 0) {
                u--;
              }
              e.bl_count[u]--;
              e.bl_count[u + 1] += 2;
              e.bl_count[o]--;
              p -= 2;
            } while (p > 0);
            for (u = o; u !== 0; u--) {
              c = e.bl_count[u];
              while (c !== 0) {
                h = e.heap[--l];
                if (h > a) {
                  continue;
                }
                if (t[h * 2 + 1] !== u) {
                  e.opt_len += (u - t[h * 2 + 1]) * t[h * 2];
                  t[h * 2 + 1] = u;
                }
                c--;
              }
            }
          }
          function Z(e, r, t) {
            var a = new Array(E + 1);
            var n = 0;
            var i;
            var s;
            for (i = 1; i <= E; i++) {
              a[i] = n = (n + t[i - 1]) << 1;
            }
            for (s = 0; s <= r; s++) {
              var f = e[s * 2 + 1];
              if (f === 0) {
                continue;
              }
              e[s * 2] = K(a[f]++, f);
            }
          }
          function Q() {
            var e;
            var r;
            var t;
            var a;
            var n;
            var i = new Array(E + 1);
            t = 0;
            for (a = 0; a < v - 1; a++) {
              N[a] = t;
              for (e = 0; e < 1 << T[a]; e++) {
                P[t++] = a;
              }
            }
            P[t - 1] = a;
            n = 0;
            for (a = 0; a < 16; a++) {
              L[a] = n;
              for (e = 0; e < 1 << x[a]; e++) {
                F[n++] = a;
              }
            }
            n >>= 7;
            for (; a < b; a++) {
              L[a] = n << 7;
              for (e = 0; e < 1 << (x[a] - 7); e++) {
                F[256 + n++] = a;
              }
            }
            for (r = 0; r <= E; r++) {
              i[r] = 0;
            }
            e = 0;
            while (e <= 143) {
              D[e * 2 + 1] = 8;
              e++;
              i[8]++;
            }
            while (e <= 255) {
              D[e * 2 + 1] = 9;
              e++;
              i[9]++;
            }
            while (e <= 279) {
              D[e * 2 + 1] = 7;
              e++;
              i[7]++;
            }
            while (e <= 287) {
              D[e * 2 + 1] = 8;
              e++;
              i[8]++;
            }
            Z(D, g + 1, i);
            for (e = 0; e < b; e++) {
              O[e * 2 + 1] = 5;
              O[e * 2] = K(e, 5);
            }
            U = new M(D, T, p + 1, g, E);
            H = new M(O, x, 0, b, E);
            W = new M(new Array(0), I, 0, m, S);
          }
          function J(e) {
            var r;
            for (r = 0; r < g; r++) {
              e.dyn_ltree[r * 2] = 0;
            }
            for (r = 0; r < b; r++) {
              e.dyn_dtree[r * 2] = 0;
            }
            for (r = 0; r < m; r++) {
              e.bl_tree[r * 2] = 0;
            }
            e.dyn_ltree[w * 2] = 1;
            e.opt_len = e.static_len = 0;
            e.last_lit = e.matches = 0;
          }
          function q(e) {
            if (e.bi_valid > 8) {
              X(e, e.bi_buf);
            } else if (e.bi_valid > 0) {
              e.pending_buf[e.pending++] = e.bi_buf;
            }
            e.bi_buf = 0;
            e.bi_valid = 0;
          }
          function ee(e, r, t, n) {
            q(e);
            if (n) {
              X(e, t);
              X(e, ~t);
            }
            a.arraySet(e.pending_buf, e.window, r, t, e.pending);
            e.pending += t;
          }
          function re(e, r, t, a) {
            var n = r * 2;
            var i = t * 2;
            return e[n] < e[i] || (e[n] === e[i] && a[r] <= a[t]);
          }
          function te(e, r, t) {
            var a = e.heap[t];
            var n = t << 1;
            while (n <= e.heap_len) {
              if (n < e.heap_len && re(r, e.heap[n + 1], e.heap[n], e.depth)) {
                n++;
              }
              if (re(r, a, e.heap[n], e.depth)) {
                break;
              }
              e.heap[t] = e.heap[n];
              t = n;
              n <<= 1;
            }
            e.heap[t] = a;
          }
          function ae(e, r, t) {
            var a;
            var n;
            var i = 0;
            var s;
            var f;
            if (e.last_lit !== 0) {
              do {
                a =
                  (e.pending_buf[e.d_buf + i * 2] << 8) |
                  e.pending_buf[e.d_buf + i * 2 + 1];
                n = e.pending_buf[e.l_buf + i];
                i++;
                if (a === 0) {
                  j(e, n, r);
                } else {
                  s = P[n];
                  j(e, s + p + 1, r);
                  f = T[s];
                  if (f !== 0) {
                    n -= N[s];
                    G(e, n, f);
                  }
                  a--;
                  s = z(a);
                  j(e, s, t);
                  f = x[s];
                  if (f !== 0) {
                    a -= L[s];
                    G(e, a, f);
                  }
                }
              } while (i < e.last_lit);
            }
            j(e, w, r);
          }
          function ne(e, r) {
            var t = r.dyn_tree;
            var a = r.stat_desc.static_tree;
            var n = r.stat_desc.has_stree;
            var i = r.stat_desc.elems;
            var s, f;
            var o = -1;
            var l;
            e.heap_len = 0;
            e.heap_max = C;
            for (s = 0; s < i; s++) {
              if (t[s * 2] !== 0) {
                e.heap[++e.heap_len] = o = s;
                e.depth[s] = 0;
              } else {
                t[s * 2 + 1] = 0;
              }
            }
            while (e.heap_len < 2) {
              l = e.heap[++e.heap_len] = o < 2 ? ++o : 0;
              t[l * 2] = 1;
              e.depth[l] = 0;
              e.opt_len--;
              if (n) {
                e.static_len -= a[l * 2 + 1];
              }
            }
            r.max_code = o;
            for (s = e.heap_len >> 1; s >= 1; s--) {
              te(e, t, s);
            }
            l = i;
            do {
              s = e.heap[1];
              e.heap[1] = e.heap[e.heap_len--];
              te(e, t, 1);
              f = e.heap[1];
              e.heap[--e.heap_max] = s;
              e.heap[--e.heap_max] = f;
              t[l * 2] = t[s * 2] + t[f * 2];
              e.depth[l] =
                (e.depth[s] >= e.depth[f] ? e.depth[s] : e.depth[f]) + 1;
              t[s * 2 + 1] = t[f * 2 + 1] = l;
              e.heap[1] = l++;
              te(e, t, 1);
            } while (e.heap_len >= 2);
            e.heap[--e.heap_max] = e.heap[1];
            $(e, r);
            Z(t, o, e.bl_count);
          }
          function ie(e, r, t) {
            var a;
            var n = -1;
            var i;
            var s = r[0 * 2 + 1];
            var f = 0;
            var o = 7;
            var l = 4;
            if (s === 0) {
              o = 138;
              l = 3;
            }
            r[(t + 1) * 2 + 1] = 65535;
            for (a = 0; a <= t; a++) {
              i = s;
              s = r[(a + 1) * 2 + 1];
              if (++f < o && i === s) {
                continue;
              } else if (f < l) {
                e.bl_tree[i * 2] += f;
              } else if (i !== 0) {
                if (i !== n) {
                  e.bl_tree[i * 2]++;
                }
                e.bl_tree[A * 2]++;
              } else if (f <= 10) {
                e.bl_tree[B * 2]++;
              } else {
                e.bl_tree[_ * 2]++;
              }
              f = 0;
              n = i;
              if (s === 0) {
                o = 138;
                l = 3;
              } else if (i === s) {
                o = 6;
                l = 3;
              } else {
                o = 7;
                l = 4;
              }
            }
          }
          function se(e, r, t) {
            var a;
            var n = -1;
            var i;
            var s = r[0 * 2 + 1];
            var f = 0;
            var o = 7;
            var l = 4;
            if (s === 0) {
              o = 138;
              l = 3;
            }
            for (a = 0; a <= t; a++) {
              i = s;
              s = r[(a + 1) * 2 + 1];
              if (++f < o && i === s) {
                continue;
              } else if (f < l) {
                do {
                  j(e, i, e.bl_tree);
                } while (--f !== 0);
              } else if (i !== 0) {
                if (i !== n) {
                  j(e, i, e.bl_tree);
                  f--;
                }
                j(e, A, e.bl_tree);
                G(e, f - 3, 2);
              } else if (f <= 10) {
                j(e, B, e.bl_tree);
                G(e, f - 3, 3);
              } else {
                j(e, _, e.bl_tree);
                G(e, f - 11, 7);
              }
              f = 0;
              n = i;
              if (s === 0) {
                o = 138;
                l = 3;
              } else if (i === s) {
                o = 6;
                l = 3;
              } else {
                o = 7;
                l = 4;
              }
            }
          }
          function fe(e) {
            var r;
            ie(e, e.dyn_ltree, e.l_desc.max_code);
            ie(e, e.dyn_dtree, e.d_desc.max_code);
            ne(e, e.bl_desc);
            for (r = m - 1; r >= 3; r--) {
              if (e.bl_tree[y[r] * 2 + 1] !== 0) {
                break;
              }
            }
            e.opt_len += 3 * (r + 1) + 5 + 5 + 4;
            return r;
          }
          function oe(e, r, t, a) {
            var n;
            G(e, r - 257, 5);
            G(e, t - 1, 5);
            G(e, a - 4, 4);
            for (n = 0; n < a; n++) {
              G(e, e.bl_tree[y[n] * 2 + 1], 3);
            }
            se(e, e.dyn_ltree, r - 1);
            se(e, e.dyn_dtree, t - 1);
          }
          function le(e) {
            var r = 4093624447;
            var t;
            for (t = 0; t <= 31; t++, r >>>= 1) {
              if (r & 1 && e.dyn_ltree[t * 2] !== 0) {
                return i;
              }
            }
            if (
              e.dyn_ltree[9 * 2] !== 0 ||
              e.dyn_ltree[10 * 2] !== 0 ||
              e.dyn_ltree[13 * 2] !== 0
            ) {
              return s;
            }
            for (t = 32; t < p; t++) {
              if (e.dyn_ltree[t * 2] !== 0) {
                return s;
              }
            }
            return i;
          }
          var ce = false;
          function he(e) {
            if (!ce) {
              Q();
              ce = true;
            }
            e.l_desc = new V(e.dyn_ltree, U);
            e.d_desc = new V(e.dyn_dtree, H);
            e.bl_desc = new V(e.bl_tree, W);
            e.bi_buf = 0;
            e.bi_valid = 0;
            J(e);
          }
          function ue(e, r, t, a) {
            G(e, (l << 1) + (a ? 1 : 0), 3);
            ee(e, r, t, true);
          }
          function de(e) {
            G(e, c << 1, 3);
            j(e, w, D);
            Y(e);
          }
          function ve(e, r, t, a) {
            var i, s;
            var o = 0;
            if (e.level > 0) {
              if (e.strm.data_type === f) {
                e.strm.data_type = le(e);
              }
              ne(e, e.l_desc);
              ne(e, e.d_desc);
              o = fe(e);
              i = (e.opt_len + 3 + 7) >>> 3;
              s = (e.static_len + 3 + 7) >>> 3;
              if (s <= i) {
                i = s;
              }
            } else {
              i = s = t + 5;
            }
            if (t + 4 <= i && r !== -1) {
              ue(e, r, t, a);
            } else if (e.strategy === n || s === i) {
              G(e, (c << 1) + (a ? 1 : 0), 3);
              ae(e, D, O);
            } else {
              G(e, (h << 1) + (a ? 1 : 0), 3);
              oe(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, o + 1);
              ae(e, e.dyn_ltree, e.dyn_dtree);
            }
            J(e);
            if (a) {
              q(e);
            }
          }
          function pe(e, r, t) {
            e.pending_buf[e.d_buf + e.last_lit * 2] = (r >>> 8) & 255;
            e.pending_buf[e.d_buf + e.last_lit * 2 + 1] = r & 255;
            e.pending_buf[e.l_buf + e.last_lit] = t & 255;
            e.last_lit++;
            if (r === 0) {
              e.dyn_ltree[t * 2]++;
            } else {
              e.matches++;
              r--;
              e.dyn_ltree[(P[t] + p + 1) * 2]++;
              e.dyn_dtree[z(r) * 2]++;
            }
            return e.last_lit === e.lit_bufsize - 1;
          }
          t._tr_init = he;
          t._tr_stored_block = ue;
          t._tr_flush_block = ve;
          t._tr_tally = pe;
          t._tr_align = de;
        },
        { "../utils/common": 27 },
      ],
      39: [
        function (e, r, t) {
          "use strict";
          function a() {
            this.input = null;
            this.next_in = 0;
            this.avail_in = 0;
            this.total_in = 0;
            this.output = null;
            this.next_out = 0;
            this.avail_out = 0;
            this.total_out = 0;
            this.msg = "";
            this.state = null;
            this.data_type = 2;
            this.adler = 0;
          }
          r.exports = a;
        },
        {},
      ],
    },
    {},
    [9]
  )(9);
});
var cptable = { version: "1.10.0" };
cptable[437] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[620] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[737] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[850] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[852] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[857] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[861] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[865] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[866] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[874] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[895] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[932] = (function () {
  var e = [],
    r = {},
    t = [],
    a;
  t[0] =
    "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split(
      ""
    );
  for (a = 0; a != t[0].length; ++a)
    if (t[0][a].charCodeAt(0) !== 65533) {
      r[t[0][a]] = 0 + a;
      e[0 + a] = t[0][a];
    }
  t[129] =
    "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split(
      ""
    );
  for (a = 0; a != t[129].length; ++a)
    if (t[129][a].charCodeAt(0) !== 65533) {
      r[t[129][a]] = 33024 + a;
      e[33024 + a] = t[129][a];
    }
  t[130] =
    "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split(
      ""
    );
  for (a = 0; a != t[130].length; ++a)
    if (t[130][a].charCodeAt(0) !== 65533) {
      r[t[130][a]] = 33280 + a;
      e[33280 + a] = t[130][a];
    }
  t[131] =
    "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split(
      ""
    );
  for (a = 0; a != t[131].length; ++a)
    if (t[131][a].charCodeAt(0) !== 65533) {
      r[t[131][a]] = 33536 + a;
      e[33536 + a] = t[131][a];
    }
  t[132] =
    "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[132].length; ++a)
    if (t[132][a].charCodeAt(0) !== 65533) {
      r[t[132][a]] = 33792 + a;
      e[33792 + a] = t[132][a];
    }
  t[135] =
    "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[135].length; ++a)
    if (t[135][a].charCodeAt(0) !== 65533) {
      r[t[135][a]] = 34560 + a;
      e[34560 + a] = t[135][a];
    }
  t[136] =
    "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split(
      ""
    );
  for (a = 0; a != t[136].length; ++a)
    if (t[136][a].charCodeAt(0) !== 65533) {
      r[t[136][a]] = 34816 + a;
      e[34816 + a] = t[136][a];
    }
  t[137] =
    "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split(
      ""
    );
  for (a = 0; a != t[137].length; ++a)
    if (t[137][a].charCodeAt(0) !== 65533) {
      r[t[137][a]] = 35072 + a;
      e[35072 + a] = t[137][a];
    }
  t[138] =
    "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split(
      ""
    );
  for (a = 0; a != t[138].length; ++a)
    if (t[138][a].charCodeAt(0) !== 65533) {
      r[t[138][a]] = 35328 + a;
      e[35328 + a] = t[138][a];
    }
  t[139] =
    "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split(
      ""
    );
  for (a = 0; a != t[139].length; ++a)
    if (t[139][a].charCodeAt(0) !== 65533) {
      r[t[139][a]] = 35584 + a;
      e[35584 + a] = t[139][a];
    }
  t[140] =
    "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split(
      ""
    );
  for (a = 0; a != t[140].length; ++a)
    if (t[140][a].charCodeAt(0) !== 65533) {
      r[t[140][a]] = 35840 + a;
      e[35840 + a] = t[140][a];
    }
  t[141] =
    "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split(
      ""
    );
  for (a = 0; a != t[141].length; ++a)
    if (t[141][a].charCodeAt(0) !== 65533) {
      r[t[141][a]] = 36096 + a;
      e[36096 + a] = t[141][a];
    }
  t[142] =
    "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split(
      ""
    );
  for (a = 0; a != t[142].length; ++a)
    if (t[142][a].charCodeAt(0) !== 65533) {
      r[t[142][a]] = 36352 + a;
      e[36352 + a] = t[142][a];
    }
  t[143] =
    "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split(
      ""
    );
  for (a = 0; a != t[143].length; ++a)
    if (t[143][a].charCodeAt(0) !== 65533) {
      r[t[143][a]] = 36608 + a;
      e[36608 + a] = t[143][a];
    }
  t[144] =
    "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split(
      ""
    );
  for (a = 0; a != t[144].length; ++a)
    if (t[144][a].charCodeAt(0) !== 65533) {
      r[t[144][a]] = 36864 + a;
      e[36864 + a] = t[144][a];
    }
  t[145] =
    "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split(
      ""
    );
  for (a = 0; a != t[145].length; ++a)
    if (t[145][a].charCodeAt(0) !== 65533) {
      r[t[145][a]] = 37120 + a;
      e[37120 + a] = t[145][a];
    }
  t[146] =
    "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split(
      ""
    );
  for (a = 0; a != t[146].length; ++a)
    if (t[146][a].charCodeAt(0) !== 65533) {
      r[t[146][a]] = 37376 + a;
      e[37376 + a] = t[146][a];
    }
  t[147] =
    "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split(
      ""
    );
  for (a = 0; a != t[147].length; ++a)
    if (t[147][a].charCodeAt(0) !== 65533) {
      r[t[147][a]] = 37632 + a;
      e[37632 + a] = t[147][a];
    }
  t[148] =
    "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split(
      ""
    );
  for (a = 0; a != t[148].length; ++a)
    if (t[148][a].charCodeAt(0) !== 65533) {
      r[t[148][a]] = 37888 + a;
      e[37888 + a] = t[148][a];
    }
  t[149] =
    "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split(
      ""
    );
  for (a = 0; a != t[149].length; ++a)
    if (t[149][a].charCodeAt(0) !== 65533) {
      r[t[149][a]] = 38144 + a;
      e[38144 + a] = t[149][a];
    }
  t[150] =
    "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split(
      ""
    );
  for (a = 0; a != t[150].length; ++a)
    if (t[150][a].charCodeAt(0) !== 65533) {
      r[t[150][a]] = 38400 + a;
      e[38400 + a] = t[150][a];
    }
  t[151] =
    "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split(
      ""
    );
  for (a = 0; a != t[151].length; ++a)
    if (t[151][a].charCodeAt(0) !== 65533) {
      r[t[151][a]] = 38656 + a;
      e[38656 + a] = t[151][a];
    }
  t[152] =
    "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split(
      ""
    );
  for (a = 0; a != t[152].length; ++a)
    if (t[152][a].charCodeAt(0) !== 65533) {
      r[t[152][a]] = 38912 + a;
      e[38912 + a] = t[152][a];
    }
  t[153] =
    "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split(
      ""
    );
  for (a = 0; a != t[153].length; ++a)
    if (t[153][a].charCodeAt(0) !== 65533) {
      r[t[153][a]] = 39168 + a;
      e[39168 + a] = t[153][a];
    }
  t[154] =
    "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split(
      ""
    );
  for (a = 0; a != t[154].length; ++a)
    if (t[154][a].charCodeAt(0) !== 65533) {
      r[t[154][a]] = 39424 + a;
      e[39424 + a] = t[154][a];
    }
  t[155] =
    "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split(
      ""
    );
  for (a = 0; a != t[155].length; ++a)
    if (t[155][a].charCodeAt(0) !== 65533) {
      r[t[155][a]] = 39680 + a;
      e[39680 + a] = t[155][a];
    }
  t[156] =
    "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split(
      ""
    );
  for (a = 0; a != t[156].length; ++a)
    if (t[156][a].charCodeAt(0) !== 65533) {
      r[t[156][a]] = 39936 + a;
      e[39936 + a] = t[156][a];
    }
  t[157] =
    "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split(
      ""
    );
  for (a = 0; a != t[157].length; ++a)
    if (t[157][a].charCodeAt(0) !== 65533) {
      r[t[157][a]] = 40192 + a;
      e[40192 + a] = t[157][a];
    }
  t[158] =
    "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split(
      ""
    );
  for (a = 0; a != t[158].length; ++a)
    if (t[158][a].charCodeAt(0) !== 65533) {
      r[t[158][a]] = 40448 + a;
      e[40448 + a] = t[158][a];
    }
  t[159] =
    "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split(
      ""
    );
  for (a = 0; a != t[159].length; ++a)
    if (t[159][a].charCodeAt(0) !== 65533) {
      r[t[159][a]] = 40704 + a;
      e[40704 + a] = t[159][a];
    }
  t[224] =
    "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split(
      ""
    );
  for (a = 0; a != t[224].length; ++a)
    if (t[224][a].charCodeAt(0) !== 65533) {
      r[t[224][a]] = 57344 + a;
      e[57344 + a] = t[224][a];
    }
  t[225] =
    "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split(
      ""
    );
  for (a = 0; a != t[225].length; ++a)
    if (t[225][a].charCodeAt(0) !== 65533) {
      r[t[225][a]] = 57600 + a;
      e[57600 + a] = t[225][a];
    }
  t[226] =
    "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split(
      ""
    );
  for (a = 0; a != t[226].length; ++a)
    if (t[226][a].charCodeAt(0) !== 65533) {
      r[t[226][a]] = 57856 + a;
      e[57856 + a] = t[226][a];
    }
  t[227] =
    "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split(
      ""
    );
  for (a = 0; a != t[227].length; ++a)
    if (t[227][a].charCodeAt(0) !== 65533) {
      r[t[227][a]] = 58112 + a;
      e[58112 + a] = t[227][a];
    }
  t[228] =
    "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split(
      ""
    );
  for (a = 0; a != t[228].length; ++a)
    if (t[228][a].charCodeAt(0) !== 65533) {
      r[t[228][a]] = 58368 + a;
      e[58368 + a] = t[228][a];
    }
  t[229] =
    "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split(
      ""
    );
  for (a = 0; a != t[229].length; ++a)
    if (t[229][a].charCodeAt(0) !== 65533) {
      r[t[229][a]] = 58624 + a;
      e[58624 + a] = t[229][a];
    }
  t[230] =
    "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split(
      ""
    );
  for (a = 0; a != t[230].length; ++a)
    if (t[230][a].charCodeAt(0) !== 65533) {
      r[t[230][a]] = 58880 + a;
      e[58880 + a] = t[230][a];
    }
  t[231] =
    "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split(
      ""
    );
  for (a = 0; a != t[231].length; ++a)
    if (t[231][a].charCodeAt(0) !== 65533) {
      r[t[231][a]] = 59136 + a;
      e[59136 + a] = t[231][a];
    }
  t[232] =
    "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split(
      ""
    );
  for (a = 0; a != t[232].length; ++a)
    if (t[232][a].charCodeAt(0) !== 65533) {
      r[t[232][a]] = 59392 + a;
      e[59392 + a] = t[232][a];
    }
  t[233] =
    "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split(
      ""
    );
  for (a = 0; a != t[233].length; ++a)
    if (t[233][a].charCodeAt(0) !== 65533) {
      r[t[233][a]] = 59648 + a;
      e[59648 + a] = t[233][a];
    }
  t[234] =
    "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[234].length; ++a)
    if (t[234][a].charCodeAt(0) !== 65533) {
      r[t[234][a]] = 59904 + a;
      e[59904 + a] = t[234][a];
    }
  t[237] =
    "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split(
      ""
    );
  for (a = 0; a != t[237].length; ++a)
    if (t[237][a].charCodeAt(0) !== 65533) {
      r[t[237][a]] = 60672 + a;
      e[60672 + a] = t[237][a];
    }
  t[238] =
    "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split(
      ""
    );
  for (a = 0; a != t[238].length; ++a)
    if (t[238][a].charCodeAt(0) !== 65533) {
      r[t[238][a]] = 60928 + a;
      e[60928 + a] = t[238][a];
    }
  t[250] =
    "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split(
      ""
    );
  for (a = 0; a != t[250].length; ++a)
    if (t[250][a].charCodeAt(0) !== 65533) {
      r[t[250][a]] = 64e3 + a;
      e[64e3 + a] = t[250][a];
    }
  t[251] =
    "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split(
      ""
    );
  for (a = 0; a != t[251].length; ++a)
    if (t[251][a].charCodeAt(0) !== 65533) {
      r[t[251][a]] = 64256 + a;
      e[64256 + a] = t[251][a];
    }
  t[252] =
    "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[252].length; ++a)
    if (t[252][a].charCodeAt(0) !== 65533) {
      r[t[252][a]] = 64512 + a;
      e[64512 + a] = t[252][a];
    }
  return { enc: r, dec: e };
})();
cptable[936] = (function () {
  var e = [],
    r = {},
    t = [],
    a;
  t[0] =
    "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[0].length; ++a)
    if (t[0][a].charCodeAt(0) !== 65533) {
      r[t[0][a]] = 0 + a;
      e[0 + a] = t[0][a];
    }
  t[129] =
    "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split(
      ""
    );
  for (a = 0; a != t[129].length; ++a)
    if (t[129][a].charCodeAt(0) !== 65533) {
      r[t[129][a]] = 33024 + a;
      e[33024 + a] = t[129][a];
    }
  t[130] =
    "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split(
      ""
    );
  for (a = 0; a != t[130].length; ++a)
    if (t[130][a].charCodeAt(0) !== 65533) {
      r[t[130][a]] = 33280 + a;
      e[33280 + a] = t[130][a];
    }
  t[131] =
    "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split(
      ""
    );
  for (a = 0; a != t[131].length; ++a)
    if (t[131][a].charCodeAt(0) !== 65533) {
      r[t[131][a]] = 33536 + a;
      e[33536 + a] = t[131][a];
    }
  t[132] =
    "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split(
      ""
    );
  for (a = 0; a != t[132].length; ++a)
    if (t[132][a].charCodeAt(0) !== 65533) {
      r[t[132][a]] = 33792 + a;
      e[33792 + a] = t[132][a];
    }
  t[133] =
    "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split(
      ""
    );
  for (a = 0; a != t[133].length; ++a)
    if (t[133][a].charCodeAt(0) !== 65533) {
      r[t[133][a]] = 34048 + a;
      e[34048 + a] = t[133][a];
    }
  t[134] =
    "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split(
      ""
    );
  for (a = 0; a != t[134].length; ++a)
    if (t[134][a].charCodeAt(0) !== 65533) {
      r[t[134][a]] = 34304 + a;
      e[34304 + a] = t[134][a];
    }
  t[135] =
    "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split(
      ""
    );
  for (a = 0; a != t[135].length; ++a)
    if (t[135][a].charCodeAt(0) !== 65533) {
      r[t[135][a]] = 34560 + a;
      e[34560 + a] = t[135][a];
    }
  t[136] =
    "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split(
      ""
    );
  for (a = 0; a != t[136].length; ++a)
    if (t[136][a].charCodeAt(0) !== 65533) {
      r[t[136][a]] = 34816 + a;
      e[34816 + a] = t[136][a];
    }
  t[137] =
    "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split(
      ""
    );
  for (a = 0; a != t[137].length; ++a)
    if (t[137][a].charCodeAt(0) !== 65533) {
      r[t[137][a]] = 35072 + a;
      e[35072 + a] = t[137][a];
    }
  t[138] =
    "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split(
      ""
    );
  for (a = 0; a != t[138].length; ++a)
    if (t[138][a].charCodeAt(0) !== 65533) {
      r[t[138][a]] = 35328 + a;
      e[35328 + a] = t[138][a];
    }
  t[139] =
    "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split(
      ""
    );
  for (a = 0; a != t[139].length; ++a)
    if (t[139][a].charCodeAt(0) !== 65533) {
      r[t[139][a]] = 35584 + a;
      e[35584 + a] = t[139][a];
    }
  t[140] =
    "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split(
      ""
    );
  for (a = 0; a != t[140].length; ++a)
    if (t[140][a].charCodeAt(0) !== 65533) {
      r[t[140][a]] = 35840 + a;
      e[35840 + a] = t[140][a];
    }
  t[141] =
    "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split(
      ""
    );
  for (a = 0; a != t[141].length; ++a)
    if (t[141][a].charCodeAt(0) !== 65533) {
      r[t[141][a]] = 36096 + a;
      e[36096 + a] = t[141][a];
    }
  t[142] =
    "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split(
      ""
    );
  for (a = 0; a != t[142].length; ++a)
    if (t[142][a].charCodeAt(0) !== 65533) {
      r[t[142][a]] = 36352 + a;
      e[36352 + a] = t[142][a];
    }
  t[143] =
    "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split(
      ""
    );
  for (a = 0; a != t[143].length; ++a)
    if (t[143][a].charCodeAt(0) !== 65533) {
      r[t[143][a]] = 36608 + a;
      e[36608 + a] = t[143][a];
    }
  t[144] =
    "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split(
      ""
    );
  for (a = 0; a != t[144].length; ++a)
    if (t[144][a].charCodeAt(0) !== 65533) {
      r[t[144][a]] = 36864 + a;
      e[36864 + a] = t[144][a];
    }
  t[145] =
    "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split(
      ""
    );
  for (a = 0; a != t[145].length; ++a)
    if (t[145][a].charCodeAt(0) !== 65533) {
      r[t[145][a]] = 37120 + a;
      e[37120 + a] = t[145][a];
    }
  t[146] =
    "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split(
      ""
    );
  for (a = 0; a != t[146].length; ++a)
    if (t[146][a].charCodeAt(0) !== 65533) {
      r[t[146][a]] = 37376 + a;
      e[37376 + a] = t[146][a];
    }
  t[147] =
    "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split(
      ""
    );
  for (a = 0; a != t[147].length; ++a)
    if (t[147][a].charCodeAt(0) !== 65533) {
      r[t[147][a]] = 37632 + a;
      e[37632 + a] = t[147][a];
    }
  t[148] =
    "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split(
      ""
    );
  for (a = 0; a != t[148].length; ++a)
    if (t[148][a].charCodeAt(0) !== 65533) {
      r[t[148][a]] = 37888 + a;
      e[37888 + a] = t[148][a];
    }
  t[149] =
    "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split(
      ""
    );
  for (a = 0; a != t[149].length; ++a)
    if (t[149][a].charCodeAt(0) !== 65533) {
      r[t[149][a]] = 38144 + a;
      e[38144 + a] = t[149][a];
    }
  t[150] =
    "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split(
      ""
    );
  for (a = 0; a != t[150].length; ++a)
    if (t[150][a].charCodeAt(0) !== 65533) {
      r[t[150][a]] = 38400 + a;
      e[38400 + a] = t[150][a];
    }
  t[151] =
    "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split(
      ""
    );
  for (a = 0; a != t[151].length; ++a)
    if (t[151][a].charCodeAt(0) !== 65533) {
      r[t[151][a]] = 38656 + a;
      e[38656 + a] = t[151][a];
    }
  t[152] =
    "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split(
      ""
    );
  for (a = 0; a != t[152].length; ++a)
    if (t[152][a].charCodeAt(0) !== 65533) {
      r[t[152][a]] = 38912 + a;
      e[38912 + a] = t[152][a];
    }
  t[153] =
    "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split(
      ""
    );
  for (a = 0; a != t[153].length; ++a)
    if (t[153][a].charCodeAt(0) !== 65533) {
      r[t[153][a]] = 39168 + a;
      e[39168 + a] = t[153][a];
    }
  t[154] =
    "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split(
      ""
    );
  for (a = 0; a != t[154].length; ++a)
    if (t[154][a].charCodeAt(0) !== 65533) {
      r[t[154][a]] = 39424 + a;
      e[39424 + a] = t[154][a];
    }
  t[155] =
    "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split(
      ""
    );
  for (a = 0; a != t[155].length; ++a)
    if (t[155][a].charCodeAt(0) !== 65533) {
      r[t[155][a]] = 39680 + a;
      e[39680 + a] = t[155][a];
    }
  t[156] =
    "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split(
      ""
    );
  for (a = 0; a != t[156].length; ++a)
    if (t[156][a].charCodeAt(0) !== 65533) {
      r[t[156][a]] = 39936 + a;
      e[39936 + a] = t[156][a];
    }
  t[157] =
    "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split(
      ""
    );
  for (a = 0; a != t[157].length; ++a)
    if (t[157][a].charCodeAt(0) !== 65533) {
      r[t[157][a]] = 40192 + a;
      e[40192 + a] = t[157][a];
    }
  t[158] =
    "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split(
      ""
    );
  for (a = 0; a != t[158].length; ++a)
    if (t[158][a].charCodeAt(0) !== 65533) {
      r[t[158][a]] = 40448 + a;
      e[40448 + a] = t[158][a];
    }
  t[159] =
    "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split(
      ""
    );
  for (a = 0; a != t[159].length; ++a)
    if (t[159][a].charCodeAt(0) !== 65533) {
      r[t[159][a]] = 40704 + a;
      e[40704 + a] = t[159][a];
    }
  t[160] =
    "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split(
      ""
    );
  for (a = 0; a != t[160].length; ++a)
    if (t[160][a].charCodeAt(0) !== 65533) {
      r[t[160][a]] = 40960 + a;
      e[40960 + a] = t[160][a];
    }
  t[161] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split(
      ""
    );
  for (a = 0; a != t[161].length; ++a)
    if (t[161][a].charCodeAt(0) !== 65533) {
      r[t[161][a]] = 41216 + a;
      e[41216 + a] = t[161][a];
    }
  t[162] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split(
      ""
    );
  for (a = 0; a != t[162].length; ++a)
    if (t[162][a].charCodeAt(0) !== 65533) {
      r[t[162][a]] = 41472 + a;
      e[41472 + a] = t[162][a];
    }
  t[163] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split(
      ""
    );
  for (a = 0; a != t[163].length; ++a)
    if (t[163][a].charCodeAt(0) !== 65533) {
      r[t[163][a]] = 41728 + a;
      e[41728 + a] = t[163][a];
    }
  t[164] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split(
      ""
    );
  for (a = 0; a != t[164].length; ++a)
    if (t[164][a].charCodeAt(0) !== 65533) {
      r[t[164][a]] = 41984 + a;
      e[41984 + a] = t[164][a];
    }
  t[165] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split(
      ""
    );
  for (a = 0; a != t[165].length; ++a)
    if (t[165][a].charCodeAt(0) !== 65533) {
      r[t[165][a]] = 42240 + a;
      e[42240 + a] = t[165][a];
    }
  t[166] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split(
      ""
    );
  for (a = 0; a != t[166].length; ++a)
    if (t[166][a].charCodeAt(0) !== 65533) {
      r[t[166][a]] = 42496 + a;
      e[42496 + a] = t[166][a];
    }
  t[167] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split(
      ""
    );
  for (a = 0; a != t[167].length; ++a)
    if (t[167][a].charCodeAt(0) !== 65533) {
      r[t[167][a]] = 42752 + a;
      e[42752 + a] = t[167][a];
    }
  t[168] =
    "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split(
      ""
    );
  for (a = 0; a != t[168].length; ++a)
    if (t[168][a].charCodeAt(0) !== 65533) {
      r[t[168][a]] = 43008 + a;
      e[43008 + a] = t[168][a];
    }
  t[169] =
    "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split(
      ""
    );
  for (a = 0; a != t[169].length; ++a)
    if (t[169][a].charCodeAt(0) !== 65533) {
      r[t[169][a]] = 43264 + a;
      e[43264 + a] = t[169][a];
    }
  t[170] =
    "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[170].length; ++a)
    if (t[170][a].charCodeAt(0) !== 65533) {
      r[t[170][a]] = 43520 + a;
      e[43520 + a] = t[170][a];
    }
  t[171] =
    "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[171].length; ++a)
    if (t[171][a].charCodeAt(0) !== 65533) {
      r[t[171][a]] = 43776 + a;
      e[43776 + a] = t[171][a];
    }
  t[172] =
    "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[172].length; ++a)
    if (t[172][a].charCodeAt(0) !== 65533) {
      r[t[172][a]] = 44032 + a;
      e[44032 + a] = t[172][a];
    }
  t[173] =
    "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[173].length; ++a)
    if (t[173][a].charCodeAt(0) !== 65533) {
      r[t[173][a]] = 44288 + a;
      e[44288 + a] = t[173][a];
    }
  t[174] =
    "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[174].length; ++a)
    if (t[174][a].charCodeAt(0) !== 65533) {
      r[t[174][a]] = 44544 + a;
      e[44544 + a] = t[174][a];
    }
  t[175] =
    "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[175].length; ++a)
    if (t[175][a].charCodeAt(0) !== 65533) {
      r[t[175][a]] = 44800 + a;
      e[44800 + a] = t[175][a];
    }
  t[176] =
    "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split(
      ""
    );
  for (a = 0; a != t[176].length; ++a)
    if (t[176][a].charCodeAt(0) !== 65533) {
      r[t[176][a]] = 45056 + a;
      e[45056 + a] = t[176][a];
    }
  t[177] =
    "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split(
      ""
    );
  for (a = 0; a != t[177].length; ++a)
    if (t[177][a].charCodeAt(0) !== 65533) {
      r[t[177][a]] = 45312 + a;
      e[45312 + a] = t[177][a];
    }
  t[178] =
    "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split(
      ""
    );
  for (a = 0; a != t[178].length; ++a)
    if (t[178][a].charCodeAt(0) !== 65533) {
      r[t[178][a]] = 45568 + a;
      e[45568 + a] = t[178][a];
    }
  t[179] =
    "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split(
      ""
    );
  for (a = 0; a != t[179].length; ++a)
    if (t[179][a].charCodeAt(0) !== 65533) {
      r[t[179][a]] = 45824 + a;
      e[45824 + a] = t[179][a];
    }
  t[180] =
    "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split(
      ""
    );
  for (a = 0; a != t[180].length; ++a)
    if (t[180][a].charCodeAt(0) !== 65533) {
      r[t[180][a]] = 46080 + a;
      e[46080 + a] = t[180][a];
    }
  t[181] =
    "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split(
      ""
    );
  for (a = 0; a != t[181].length; ++a)
    if (t[181][a].charCodeAt(0) !== 65533) {
      r[t[181][a]] = 46336 + a;
      e[46336 + a] = t[181][a];
    }
  t[182] =
    "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split(
      ""
    );
  for (a = 0; a != t[182].length; ++a)
    if (t[182][a].charCodeAt(0) !== 65533) {
      r[t[182][a]] = 46592 + a;
      e[46592 + a] = t[182][a];
    }
  t[183] =
    "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split(
      ""
    );
  for (a = 0; a != t[183].length; ++a)
    if (t[183][a].charCodeAt(0) !== 65533) {
      r[t[183][a]] = 46848 + a;
      e[46848 + a] = t[183][a];
    }
  t[184] =
    "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split(
      ""
    );
  for (a = 0; a != t[184].length; ++a)
    if (t[184][a].charCodeAt(0) !== 65533) {
      r[t[184][a]] = 47104 + a;
      e[47104 + a] = t[184][a];
    }
  t[185] =
    "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split(
      ""
    );
  for (a = 0; a != t[185].length; ++a)
    if (t[185][a].charCodeAt(0) !== 65533) {
      r[t[185][a]] = 47360 + a;
      e[47360 + a] = t[185][a];
    }
  t[186] =
    "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split(
      ""
    );
  for (a = 0; a != t[186].length; ++a)
    if (t[186][a].charCodeAt(0) !== 65533) {
      r[t[186][a]] = 47616 + a;
      e[47616 + a] = t[186][a];
    }
  t[187] =
    "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split(
      ""
    );
  for (a = 0; a != t[187].length; ++a)
    if (t[187][a].charCodeAt(0) !== 65533) {
      r[t[187][a]] = 47872 + a;
      e[47872 + a] = t[187][a];
    }
  t[188] =
    "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split(
      ""
    );
  for (a = 0; a != t[188].length; ++a)
    if (t[188][a].charCodeAt(0) !== 65533) {
      r[t[188][a]] = 48128 + a;
      e[48128 + a] = t[188][a];
    }
  t[189] =
    "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split(
      ""
    );
  for (a = 0; a != t[189].length; ++a)
    if (t[189][a].charCodeAt(0) !== 65533) {
      r[t[189][a]] = 48384 + a;
      e[48384 + a] = t[189][a];
    }
  t[190] =
    "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split(
      ""
    );
  for (a = 0; a != t[190].length; ++a)
    if (t[190][a].charCodeAt(0) !== 65533) {
      r[t[190][a]] = 48640 + a;
      e[48640 + a] = t[190][a];
    }
  t[191] =
    "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split(
      ""
    );
  for (a = 0; a != t[191].length; ++a)
    if (t[191][a].charCodeAt(0) !== 65533) {
      r[t[191][a]] = 48896 + a;
      e[48896 + a] = t[191][a];
    }
  t[192] =
    "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split(
      ""
    );
  for (a = 0; a != t[192].length; ++a)
    if (t[192][a].charCodeAt(0) !== 65533) {
      r[t[192][a]] = 49152 + a;
      e[49152 + a] = t[192][a];
    }
  t[193] =
    "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split(
      ""
    );
  for (a = 0; a != t[193].length; ++a)
    if (t[193][a].charCodeAt(0) !== 65533) {
      r[t[193][a]] = 49408 + a;
      e[49408 + a] = t[193][a];
    }
  t[194] =
    "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split(
      ""
    );
  for (a = 0; a != t[194].length; ++a)
    if (t[194][a].charCodeAt(0) !== 65533) {
      r[t[194][a]] = 49664 + a;
      e[49664 + a] = t[194][a];
    }
  t[195] =
    "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split(
      ""
    );
  for (a = 0; a != t[195].length; ++a)
    if (t[195][a].charCodeAt(0) !== 65533) {
      r[t[195][a]] = 49920 + a;
      e[49920 + a] = t[195][a];
    }
  t[196] =
    "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split(
      ""
    );
  for (a = 0; a != t[196].length; ++a)
    if (t[196][a].charCodeAt(0) !== 65533) {
      r[t[196][a]] = 50176 + a;
      e[50176 + a] = t[196][a];
    }
  t[197] =
    "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split(
      ""
    );
  for (a = 0; a != t[197].length; ++a)
    if (t[197][a].charCodeAt(0) !== 65533) {
      r[t[197][a]] = 50432 + a;
      e[50432 + a] = t[197][a];
    }
  t[198] =
    "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split(
      ""
    );
  for (a = 0; a != t[198].length; ++a)
    if (t[198][a].charCodeAt(0) !== 65533) {
      r[t[198][a]] = 50688 + a;
      e[50688 + a] = t[198][a];
    }
  t[199] =
    "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split(
      ""
    );
  for (a = 0; a != t[199].length; ++a)
    if (t[199][a].charCodeAt(0) !== 65533) {
      r[t[199][a]] = 50944 + a;
      e[50944 + a] = t[199][a];
    }
  t[200] =
    "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split(
      ""
    );
  for (a = 0; a != t[200].length; ++a)
    if (t[200][a].charCodeAt(0) !== 65533) {
      r[t[200][a]] = 51200 + a;
      e[51200 + a] = t[200][a];
    }
  t[201] =
    "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split(
      ""
    );
  for (a = 0; a != t[201].length; ++a)
    if (t[201][a].charCodeAt(0) !== 65533) {
      r[t[201][a]] = 51456 + a;
      e[51456 + a] = t[201][a];
    }
  t[202] =
    "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split(
      ""
    );
  for (a = 0; a != t[202].length; ++a)
    if (t[202][a].charCodeAt(0) !== 65533) {
      r[t[202][a]] = 51712 + a;
      e[51712 + a] = t[202][a];
    }
  t[203] =
    "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split(
      ""
    );
  for (a = 0; a != t[203].length; ++a)
    if (t[203][a].charCodeAt(0) !== 65533) {
      r[t[203][a]] = 51968 + a;
      e[51968 + a] = t[203][a];
    }
  t[204] =
    "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split(
      ""
    );
  for (a = 0; a != t[204].length; ++a)
    if (t[204][a].charCodeAt(0) !== 65533) {
      r[t[204][a]] = 52224 + a;
      e[52224 + a] = t[204][a];
    }
  t[205] =
    "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split(
      ""
    );
  for (a = 0; a != t[205].length; ++a)
    if (t[205][a].charCodeAt(0) !== 65533) {
      r[t[205][a]] = 52480 + a;
      e[52480 + a] = t[205][a];
    }
  t[206] =
    "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split(
      ""
    );
  for (a = 0; a != t[206].length; ++a)
    if (t[206][a].charCodeAt(0) !== 65533) {
      r[t[206][a]] = 52736 + a;
      e[52736 + a] = t[206][a];
    }
  t[207] =
    "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split(
      ""
    );
  for (a = 0; a != t[207].length; ++a)
    if (t[207][a].charCodeAt(0) !== 65533) {
      r[t[207][a]] = 52992 + a;
      e[52992 + a] = t[207][a];
    }
  t[208] =
    "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split(
      ""
    );
  for (a = 0; a != t[208].length; ++a)
    if (t[208][a].charCodeAt(0) !== 65533) {
      r[t[208][a]] = 53248 + a;
      e[53248 + a] = t[208][a];
    }
  t[209] =
    "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split(
      ""
    );
  for (a = 0; a != t[209].length; ++a)
    if (t[209][a].charCodeAt(0) !== 65533) {
      r[t[209][a]] = 53504 + a;
      e[53504 + a] = t[209][a];
    }
  t[210] =
    "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split(
      ""
    );
  for (a = 0; a != t[210].length; ++a)
    if (t[210][a].charCodeAt(0) !== 65533) {
      r[t[210][a]] = 53760 + a;
      e[53760 + a] = t[210][a];
    }
  t[211] =
    "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split(
      ""
    );
  for (a = 0; a != t[211].length; ++a)
    if (t[211][a].charCodeAt(0) !== 65533) {
      r[t[211][a]] = 54016 + a;
      e[54016 + a] = t[211][a];
    }
  t[212] =
    "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split(
      ""
    );
  for (a = 0; a != t[212].length; ++a)
    if (t[212][a].charCodeAt(0) !== 65533) {
      r[t[212][a]] = 54272 + a;
      e[54272 + a] = t[212][a];
    }
  t[213] =
    "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split(
      ""
    );
  for (a = 0; a != t[213].length; ++a)
    if (t[213][a].charCodeAt(0) !== 65533) {
      r[t[213][a]] = 54528 + a;
      e[54528 + a] = t[213][a];
    }
  t[214] =
    "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split(
      ""
    );
  for (a = 0; a != t[214].length; ++a)
    if (t[214][a].charCodeAt(0) !== 65533) {
      r[t[214][a]] = 54784 + a;
      e[54784 + a] = t[214][a];
    }
  t[215] =
    "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split(
      ""
    );
  for (a = 0; a != t[215].length; ++a)
    if (t[215][a].charCodeAt(0) !== 65533) {
      r[t[215][a]] = 55040 + a;
      e[55040 + a] = t[215][a];
    }
  t[216] =
    "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split(
      ""
    );
  for (a = 0; a != t[216].length; ++a)
    if (t[216][a].charCodeAt(0) !== 65533) {
      r[t[216][a]] = 55296 + a;
      e[55296 + a] = t[216][a];
    }
  t[217] =
    "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split(
      ""
    );
  for (a = 0; a != t[217].length; ++a)
    if (t[217][a].charCodeAt(0) !== 65533) {
      r[t[217][a]] = 55552 + a;
      e[55552 + a] = t[217][a];
    }
  t[218] =
    "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split(
      ""
    );
  for (a = 0; a != t[218].length; ++a)
    if (t[218][a].charCodeAt(0) !== 65533) {
      r[t[218][a]] = 55808 + a;
      e[55808 + a] = t[218][a];
    }
  t[219] =
    "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split(
      ""
    );
  for (a = 0; a != t[219].length; ++a)
    if (t[219][a].charCodeAt(0) !== 65533) {
      r[t[219][a]] = 56064 + a;
      e[56064 + a] = t[219][a];
    }
  t[220] =
    "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split(
      ""
    );
  for (a = 0; a != t[220].length; ++a)
    if (t[220][a].charCodeAt(0) !== 65533) {
      r[t[220][a]] = 56320 + a;
      e[56320 + a] = t[220][a];
    }
  t[221] =
    "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split(
      ""
    );
  for (a = 0; a != t[221].length; ++a)
    if (t[221][a].charCodeAt(0) !== 65533) {
      r[t[221][a]] = 56576 + a;
      e[56576 + a] = t[221][a];
    }
  t[222] =
    "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split(
      ""
    );
  for (a = 0; a != t[222].length; ++a)
    if (t[222][a].charCodeAt(0) !== 65533) {
      r[t[222][a]] = 56832 + a;
      e[56832 + a] = t[222][a];
    }
  t[223] =
    "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split(
      ""
    );
  for (a = 0; a != t[223].length; ++a)
    if (t[223][a].charCodeAt(0) !== 65533) {
      r[t[223][a]] = 57088 + a;
      e[57088 + a] = t[223][a];
    }
  t[224] =
    "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split(
      ""
    );
  for (a = 0; a != t[224].length; ++a)
    if (t[224][a].charCodeAt(0) !== 65533) {
      r[t[224][a]] = 57344 + a;
      e[57344 + a] = t[224][a];
    }
  t[225] =
    "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split(
      ""
    );
  for (a = 0; a != t[225].length; ++a)
    if (t[225][a].charCodeAt(0) !== 65533) {
      r[t[225][a]] = 57600 + a;
      e[57600 + a] = t[225][a];
    }
  t[226] =
    "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split(
      ""
    );
  for (a = 0; a != t[226].length; ++a)
    if (t[226][a].charCodeAt(0) !== 65533) {
      r[t[226][a]] = 57856 + a;
      e[57856 + a] = t[226][a];
    }
  t[227] =
    "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split(
      ""
    );
  for (a = 0; a != t[227].length; ++a)
    if (t[227][a].charCodeAt(0) !== 65533) {
      r[t[227][a]] = 58112 + a;
      e[58112 + a] = t[227][a];
    }
  t[228] =
    "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split(
      ""
    );
  for (a = 0; a != t[228].length; ++a)
    if (t[228][a].charCodeAt(0) !== 65533) {
      r[t[228][a]] = 58368 + a;
      e[58368 + a] = t[228][a];
    }
  t[229] =
    "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split(
      ""
    );
  for (a = 0; a != t[229].length; ++a)
    if (t[229][a].charCodeAt(0) !== 65533) {
      r[t[229][a]] = 58624 + a;
      e[58624 + a] = t[229][a];
    }
  t[230] =
    "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split(
      ""
    );
  for (a = 0; a != t[230].length; ++a)
    if (t[230][a].charCodeAt(0) !== 65533) {
      r[t[230][a]] = 58880 + a;
      e[58880 + a] = t[230][a];
    }
  t[231] =
    "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split(
      ""
    );
  for (a = 0; a != t[231].length; ++a)
    if (t[231][a].charCodeAt(0) !== 65533) {
      r[t[231][a]] = 59136 + a;
      e[59136 + a] = t[231][a];
    }
  t[232] =
    "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split(
      ""
    );
  for (a = 0; a != t[232].length; ++a)
    if (t[232][a].charCodeAt(0) !== 65533) {
      r[t[232][a]] = 59392 + a;
      e[59392 + a] = t[232][a];
    }
  t[233] =
    "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split(
      ""
    );
  for (a = 0; a != t[233].length; ++a)
    if (t[233][a].charCodeAt(0) !== 65533) {
      r[t[233][a]] = 59648 + a;
      e[59648 + a] = t[233][a];
    }
  t[234] =
    "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split(
      ""
    );
  for (a = 0; a != t[234].length; ++a)
    if (t[234][a].charCodeAt(0) !== 65533) {
      r[t[234][a]] = 59904 + a;
      e[59904 + a] = t[234][a];
    }
  t[235] =
    "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split(
      ""
    );
  for (a = 0; a != t[235].length; ++a)
    if (t[235][a].charCodeAt(0) !== 65533) {
      r[t[235][a]] = 60160 + a;
      e[60160 + a] = t[235][a];
    }
  t[236] =
    "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split(
      ""
    );
  for (a = 0; a != t[236].length; ++a)
    if (t[236][a].charCodeAt(0) !== 65533) {
      r[t[236][a]] = 60416 + a;
      e[60416 + a] = t[236][a];
    }
  t[237] =
    "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split(
      ""
    );
  for (a = 0; a != t[237].length; ++a)
    if (t[237][a].charCodeAt(0) !== 65533) {
      r[t[237][a]] = 60672 + a;
      e[60672 + a] = t[237][a];
    }
  t[238] =
    "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split(
      ""
    );
  for (a = 0; a != t[238].length; ++a)
    if (t[238][a].charCodeAt(0) !== 65533) {
      r[t[238][a]] = 60928 + a;
      e[60928 + a] = t[238][a];
    }
  t[239] =
    "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split(
      ""
    );
  for (a = 0; a != t[239].length; ++a)
    if (t[239][a].charCodeAt(0) !== 65533) {
      r[t[239][a]] = 61184 + a;
      e[61184 + a] = t[239][a];
    }
  t[240] =
    "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split(
      ""
    );
  for (a = 0; a != t[240].length; ++a)
    if (t[240][a].charCodeAt(0) !== 65533) {
      r[t[240][a]] = 61440 + a;
      e[61440 + a] = t[240][a];
    }
  t[241] =
    "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split(
      ""
    );
  for (a = 0; a != t[241].length; ++a)
    if (t[241][a].charCodeAt(0) !== 65533) {
      r[t[241][a]] = 61696 + a;
      e[61696 + a] = t[241][a];
    }
  t[242] =
    "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split(
      ""
    );
  for (a = 0; a != t[242].length; ++a)
    if (t[242][a].charCodeAt(0) !== 65533) {
      r[t[242][a]] = 61952 + a;
      e[61952 + a] = t[242][a];
    }
  t[243] =
    "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split(
      ""
    );
  for (a = 0; a != t[243].length; ++a)
    if (t[243][a].charCodeAt(0) !== 65533) {
      r[t[243][a]] = 62208 + a;
      e[62208 + a] = t[243][a];
    }
  t[244] =
    "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split(
      ""
    );
  for (a = 0; a != t[244].length; ++a)
    if (t[244][a].charCodeAt(0) !== 65533) {
      r[t[244][a]] = 62464 + a;
      e[62464 + a] = t[244][a];
    }
  t[245] =
    "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split(
      ""
    );
  for (a = 0; a != t[245].length; ++a)
    if (t[245][a].charCodeAt(0) !== 65533) {
      r[t[245][a]] = 62720 + a;
      e[62720 + a] = t[245][a];
    }
  t[246] =
    "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split(
      ""
    );
  for (a = 0; a != t[246].length; ++a)
    if (t[246][a].charCodeAt(0) !== 65533) {
      r[t[246][a]] = 62976 + a;
      e[62976 + a] = t[246][a];
    }
  t[247] =
    "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split(
      ""
    );
  for (a = 0; a != t[247].length; ++a)
    if (t[247][a].charCodeAt(0) !== 65533) {
      r[t[247][a]] = 63232 + a;
      e[63232 + a] = t[247][a];
    }
  t[248] =
    "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[248].length; ++a)
    if (t[248][a].charCodeAt(0) !== 65533) {
      r[t[248][a]] = 63488 + a;
      e[63488 + a] = t[248][a];
    }
  t[249] =
    "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[249].length; ++a)
    if (t[249][a].charCodeAt(0) !== 65533) {
      r[t[249][a]] = 63744 + a;
      e[63744 + a] = t[249][a];
    }
  t[250] =
    "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[250].length; ++a)
    if (t[250][a].charCodeAt(0) !== 65533) {
      r[t[250][a]] = 64e3 + a;
      e[64e3 + a] = t[250][a];
    }
  t[251] =
    "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[251].length; ++a)
    if (t[251][a].charCodeAt(0) !== 65533) {
      r[t[251][a]] = 64256 + a;
      e[64256 + a] = t[251][a];
    }
  t[252] =
    "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[252].length; ++a)
    if (t[252][a].charCodeAt(0) !== 65533) {
      r[t[252][a]] = 64512 + a;
      e[64512 + a] = t[252][a];
    }
  t[253] =
    "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[253].length; ++a)
    if (t[253][a].charCodeAt(0) !== 65533) {
      r[t[253][a]] = 64768 + a;
      e[64768 + a] = t[253][a];
    }
  t[254] =
    "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[254].length; ++a)
    if (t[254][a].charCodeAt(0) !== 65533) {
      r[t[254][a]] = 65024 + a;
      e[65024 + a] = t[254][a];
    }
  return { enc: r, dec: e };
})();
cptable[949] = (function () {
  var e = [],
    r = {},
    t = [],
    a;
  t[0] =
    "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[0].length; ++a)
    if (t[0][a].charCodeAt(0) !== 65533) {
      r[t[0][a]] = 0 + a;
      e[0 + a] = t[0][a];
    }
  t[129] =
    "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split(
      ""
    );
  for (a = 0; a != t[129].length; ++a)
    if (t[129][a].charCodeAt(0) !== 65533) {
      r[t[129][a]] = 33024 + a;
      e[33024 + a] = t[129][a];
    }
  t[130] =
    "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split(
      ""
    );
  for (a = 0; a != t[130].length; ++a)
    if (t[130][a].charCodeAt(0) !== 65533) {
      r[t[130][a]] = 33280 + a;
      e[33280 + a] = t[130][a];
    }
  t[131] =
    "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split(
      ""
    );
  for (a = 0; a != t[131].length; ++a)
    if (t[131][a].charCodeAt(0) !== 65533) {
      r[t[131][a]] = 33536 + a;
      e[33536 + a] = t[131][a];
    }
  t[132] =
    "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split(
      ""
    );
  for (a = 0; a != t[132].length; ++a)
    if (t[132][a].charCodeAt(0) !== 65533) {
      r[t[132][a]] = 33792 + a;
      e[33792 + a] = t[132][a];
    }
  t[133] =
    "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split(
      ""
    );
  for (a = 0; a != t[133].length; ++a)
    if (t[133][a].charCodeAt(0) !== 65533) {
      r[t[133][a]] = 34048 + a;
      e[34048 + a] = t[133][a];
    }
  t[134] =
    "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split(
      ""
    );
  for (a = 0; a != t[134].length; ++a)
    if (t[134][a].charCodeAt(0) !== 65533) {
      r[t[134][a]] = 34304 + a;
      e[34304 + a] = t[134][a];
    }
  t[135] =
    "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split(
      ""
    );
  for (a = 0; a != t[135].length; ++a)
    if (t[135][a].charCodeAt(0) !== 65533) {
      r[t[135][a]] = 34560 + a;
      e[34560 + a] = t[135][a];
    }
  t[136] =
    "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split(
      ""
    );
  for (a = 0; a != t[136].length; ++a)
    if (t[136][a].charCodeAt(0) !== 65533) {
      r[t[136][a]] = 34816 + a;
      e[34816 + a] = t[136][a];
    }
  t[137] =
    "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split(
      ""
    );
  for (a = 0; a != t[137].length; ++a)
    if (t[137][a].charCodeAt(0) !== 65533) {
      r[t[137][a]] = 35072 + a;
      e[35072 + a] = t[137][a];
    }
  t[138] =
    "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split(
      ""
    );
  for (a = 0; a != t[138].length; ++a)
    if (t[138][a].charCodeAt(0) !== 65533) {
      r[t[138][a]] = 35328 + a;
      e[35328 + a] = t[138][a];
    }
  t[139] =
    "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split(
      ""
    );
  for (a = 0; a != t[139].length; ++a)
    if (t[139][a].charCodeAt(0) !== 65533) {
      r[t[139][a]] = 35584 + a;
      e[35584 + a] = t[139][a];
    }
  t[140] =
    "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split(
      ""
    );
  for (a = 0; a != t[140].length; ++a)
    if (t[140][a].charCodeAt(0) !== 65533) {
      r[t[140][a]] = 35840 + a;
      e[35840 + a] = t[140][a];
    }
  t[141] =
    "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split(
      ""
    );
  for (a = 0; a != t[141].length; ++a)
    if (t[141][a].charCodeAt(0) !== 65533) {
      r[t[141][a]] = 36096 + a;
      e[36096 + a] = t[141][a];
    }
  t[142] =
    "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split(
      ""
    );
  for (a = 0; a != t[142].length; ++a)
    if (t[142][a].charCodeAt(0) !== 65533) {
      r[t[142][a]] = 36352 + a;
      e[36352 + a] = t[142][a];
    }
  t[143] =
    "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split(
      ""
    );
  for (a = 0; a != t[143].length; ++a)
    if (t[143][a].charCodeAt(0) !== 65533) {
      r[t[143][a]] = 36608 + a;
      e[36608 + a] = t[143][a];
    }
  t[144] =
    "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split(
      ""
    );
  for (a = 0; a != t[144].length; ++a)
    if (t[144][a].charCodeAt(0) !== 65533) {
      r[t[144][a]] = 36864 + a;
      e[36864 + a] = t[144][a];
    }
  t[145] =
    "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split(
      ""
    );
  for (a = 0; a != t[145].length; ++a)
    if (t[145][a].charCodeAt(0) !== 65533) {
      r[t[145][a]] = 37120 + a;
      e[37120 + a] = t[145][a];
    }
  t[146] =
    "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split(
      ""
    );
  for (a = 0; a != t[146].length; ++a)
    if (t[146][a].charCodeAt(0) !== 65533) {
      r[t[146][a]] = 37376 + a;
      e[37376 + a] = t[146][a];
    }
  t[147] =
    "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split(
      ""
    );
  for (a = 0; a != t[147].length; ++a)
    if (t[147][a].charCodeAt(0) !== 65533) {
      r[t[147][a]] = 37632 + a;
      e[37632 + a] = t[147][a];
    }
  t[148] =
    "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split(
      ""
    );
  for (a = 0; a != t[148].length; ++a)
    if (t[148][a].charCodeAt(0) !== 65533) {
      r[t[148][a]] = 37888 + a;
      e[37888 + a] = t[148][a];
    }
  t[149] =
    "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split(
      ""
    );
  for (a = 0; a != t[149].length; ++a)
    if (t[149][a].charCodeAt(0) !== 65533) {
      r[t[149][a]] = 38144 + a;
      e[38144 + a] = t[149][a];
    }
  t[150] =
    "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split(
      ""
    );
  for (a = 0; a != t[150].length; ++a)
    if (t[150][a].charCodeAt(0) !== 65533) {
      r[t[150][a]] = 38400 + a;
      e[38400 + a] = t[150][a];
    }
  t[151] =
    "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split(
      ""
    );
  for (a = 0; a != t[151].length; ++a)
    if (t[151][a].charCodeAt(0) !== 65533) {
      r[t[151][a]] = 38656 + a;
      e[38656 + a] = t[151][a];
    }
  t[152] =
    "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split(
      ""
    );
  for (a = 0; a != t[152].length; ++a)
    if (t[152][a].charCodeAt(0) !== 65533) {
      r[t[152][a]] = 38912 + a;
      e[38912 + a] = t[152][a];
    }
  t[153] =
    "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split(
      ""
    );
  for (a = 0; a != t[153].length; ++a)
    if (t[153][a].charCodeAt(0) !== 65533) {
      r[t[153][a]] = 39168 + a;
      e[39168 + a] = t[153][a];
    }
  t[154] =
    "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split(
      ""
    );
  for (a = 0; a != t[154].length; ++a)
    if (t[154][a].charCodeAt(0) !== 65533) {
      r[t[154][a]] = 39424 + a;
      e[39424 + a] = t[154][a];
    }
  t[155] =
    "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split(
      ""
    );
  for (a = 0; a != t[155].length; ++a)
    if (t[155][a].charCodeAt(0) !== 65533) {
      r[t[155][a]] = 39680 + a;
      e[39680 + a] = t[155][a];
    }
  t[156] =
    "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split(
      ""
    );
  for (a = 0; a != t[156].length; ++a)
    if (t[156][a].charCodeAt(0) !== 65533) {
      r[t[156][a]] = 39936 + a;
      e[39936 + a] = t[156][a];
    }
  t[157] =
    "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split(
      ""
    );
  for (a = 0; a != t[157].length; ++a)
    if (t[157][a].charCodeAt(0) !== 65533) {
      r[t[157][a]] = 40192 + a;
      e[40192 + a] = t[157][a];
    }
  t[158] =
    "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split(
      ""
    );
  for (a = 0; a != t[158].length; ++a)
    if (t[158][a].charCodeAt(0) !== 65533) {
      r[t[158][a]] = 40448 + a;
      e[40448 + a] = t[158][a];
    }
  t[159] =
    "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split(
      ""
    );
  for (a = 0; a != t[159].length; ++a)
    if (t[159][a].charCodeAt(0) !== 65533) {
      r[t[159][a]] = 40704 + a;
      e[40704 + a] = t[159][a];
    }
  t[160] =
    "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split(
      ""
    );
  for (a = 0; a != t[160].length; ++a)
    if (t[160][a].charCodeAt(0) !== 65533) {
      r[t[160][a]] = 40960 + a;
      e[40960 + a] = t[160][a];
    }
  t[161] =
    "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split(
      ""
    );
  for (a = 0; a != t[161].length; ++a)
    if (t[161][a].charCodeAt(0) !== 65533) {
      r[t[161][a]] = 41216 + a;
      e[41216 + a] = t[161][a];
    }
  t[162] =
    "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split(
      ""
    );
  for (a = 0; a != t[162].length; ++a)
    if (t[162][a].charCodeAt(0) !== 65533) {
      r[t[162][a]] = 41472 + a;
      e[41472 + a] = t[162][a];
    }
  t[163] =
    "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split(
      ""
    );
  for (a = 0; a != t[163].length; ++a)
    if (t[163][a].charCodeAt(0) !== 65533) {
      r[t[163][a]] = 41728 + a;
      e[41728 + a] = t[163][a];
    }
  t[164] =
    "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split(
      ""
    );
  for (a = 0; a != t[164].length; ++a)
    if (t[164][a].charCodeAt(0) !== 65533) {
      r[t[164][a]] = 41984 + a;
      e[41984 + a] = t[164][a];
    }
  t[165] =
    "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split(
      ""
    );
  for (a = 0; a != t[165].length; ++a)
    if (t[165][a].charCodeAt(0) !== 65533) {
      r[t[165][a]] = 42240 + a;
      e[42240 + a] = t[165][a];
    }
  t[166] =
    "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split(
      ""
    );
  for (a = 0; a != t[166].length; ++a)
    if (t[166][a].charCodeAt(0) !== 65533) {
      r[t[166][a]] = 42496 + a;
      e[42496 + a] = t[166][a];
    }
  t[167] =
    "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split(
      ""
    );
  for (a = 0; a != t[167].length; ++a)
    if (t[167][a].charCodeAt(0) !== 65533) {
      r[t[167][a]] = 42752 + a;
      e[42752 + a] = t[167][a];
    }
  t[168] =
    "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split(
      ""
    );
  for (a = 0; a != t[168].length; ++a)
    if (t[168][a].charCodeAt(0) !== 65533) {
      r[t[168][a]] = 43008 + a;
      e[43008 + a] = t[168][a];
    }
  t[169] =
    "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split(
      ""
    );
  for (a = 0; a != t[169].length; ++a)
    if (t[169][a].charCodeAt(0) !== 65533) {
      r[t[169][a]] = 43264 + a;
      e[43264 + a] = t[169][a];
    }
  t[170] =
    "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split(
      ""
    );
  for (a = 0; a != t[170].length; ++a)
    if (t[170][a].charCodeAt(0) !== 65533) {
      r[t[170][a]] = 43520 + a;
      e[43520 + a] = t[170][a];
    }
  t[171] =
    "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split(
      ""
    );
  for (a = 0; a != t[171].length; ++a)
    if (t[171][a].charCodeAt(0) !== 65533) {
      r[t[171][a]] = 43776 + a;
      e[43776 + a] = t[171][a];
    }
  t[172] =
    "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split(
      ""
    );
  for (a = 0; a != t[172].length; ++a)
    if (t[172][a].charCodeAt(0) !== 65533) {
      r[t[172][a]] = 44032 + a;
      e[44032 + a] = t[172][a];
    }
  t[173] =
    "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[173].length; ++a)
    if (t[173][a].charCodeAt(0) !== 65533) {
      r[t[173][a]] = 44288 + a;
      e[44288 + a] = t[173][a];
    }
  t[174] =
    "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[174].length; ++a)
    if (t[174][a].charCodeAt(0) !== 65533) {
      r[t[174][a]] = 44544 + a;
      e[44544 + a] = t[174][a];
    }
  t[175] =
    "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[175].length; ++a)
    if (t[175][a].charCodeAt(0) !== 65533) {
      r[t[175][a]] = 44800 + a;
      e[44800 + a] = t[175][a];
    }
  t[176] =
    "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split(
      ""
    );
  for (a = 0; a != t[176].length; ++a)
    if (t[176][a].charCodeAt(0) !== 65533) {
      r[t[176][a]] = 45056 + a;
      e[45056 + a] = t[176][a];
    }
  t[177] =
    "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split(
      ""
    );
  for (a = 0; a != t[177].length; ++a)
    if (t[177][a].charCodeAt(0) !== 65533) {
      r[t[177][a]] = 45312 + a;
      e[45312 + a] = t[177][a];
    }
  t[178] =
    "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split(
      ""
    );
  for (a = 0; a != t[178].length; ++a)
    if (t[178][a].charCodeAt(0) !== 65533) {
      r[t[178][a]] = 45568 + a;
      e[45568 + a] = t[178][a];
    }
  t[179] =
    "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split(
      ""
    );
  for (a = 0; a != t[179].length; ++a)
    if (t[179][a].charCodeAt(0) !== 65533) {
      r[t[179][a]] = 45824 + a;
      e[45824 + a] = t[179][a];
    }
  t[180] =
    "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split(
      ""
    );
  for (a = 0; a != t[180].length; ++a)
    if (t[180][a].charCodeAt(0) !== 65533) {
      r[t[180][a]] = 46080 + a;
      e[46080 + a] = t[180][a];
    }
  t[181] =
    "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split(
      ""
    );
  for (a = 0; a != t[181].length; ++a)
    if (t[181][a].charCodeAt(0) !== 65533) {
      r[t[181][a]] = 46336 + a;
      e[46336 + a] = t[181][a];
    }
  t[182] =
    "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split(
      ""
    );
  for (a = 0; a != t[182].length; ++a)
    if (t[182][a].charCodeAt(0) !== 65533) {
      r[t[182][a]] = 46592 + a;
      e[46592 + a] = t[182][a];
    }
  t[183] =
    "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split(
      ""
    );
  for (a = 0; a != t[183].length; ++a)
    if (t[183][a].charCodeAt(0) !== 65533) {
      r[t[183][a]] = 46848 + a;
      e[46848 + a] = t[183][a];
    }
  t[184] =
    "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split(
      ""
    );
  for (a = 0; a != t[184].length; ++a)
    if (t[184][a].charCodeAt(0) !== 65533) {
      r[t[184][a]] = 47104 + a;
      e[47104 + a] = t[184][a];
    }
  t[185] =
    "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split(
      ""
    );
  for (a = 0; a != t[185].length; ++a)
    if (t[185][a].charCodeAt(0) !== 65533) {
      r[t[185][a]] = 47360 + a;
      e[47360 + a] = t[185][a];
    }
  t[186] =
    "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split(
      ""
    );
  for (a = 0; a != t[186].length; ++a)
    if (t[186][a].charCodeAt(0) !== 65533) {
      r[t[186][a]] = 47616 + a;
      e[47616 + a] = t[186][a];
    }
  t[187] =
    "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split(
      ""
    );
  for (a = 0; a != t[187].length; ++a)
    if (t[187][a].charCodeAt(0) !== 65533) {
      r[t[187][a]] = 47872 + a;
      e[47872 + a] = t[187][a];
    }
  t[188] =
    "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split(
      ""
    );
  for (a = 0; a != t[188].length; ++a)
    if (t[188][a].charCodeAt(0) !== 65533) {
      r[t[188][a]] = 48128 + a;
      e[48128 + a] = t[188][a];
    }
  t[189] =
    "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split(
      ""
    );
  for (a = 0; a != t[189].length; ++a)
    if (t[189][a].charCodeAt(0) !== 65533) {
      r[t[189][a]] = 48384 + a;
      e[48384 + a] = t[189][a];
    }
  t[190] =
    "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split(
      ""
    );
  for (a = 0; a != t[190].length; ++a)
    if (t[190][a].charCodeAt(0) !== 65533) {
      r[t[190][a]] = 48640 + a;
      e[48640 + a] = t[190][a];
    }
  t[191] =
    "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split(
      ""
    );
  for (a = 0; a != t[191].length; ++a)
    if (t[191][a].charCodeAt(0) !== 65533) {
      r[t[191][a]] = 48896 + a;
      e[48896 + a] = t[191][a];
    }
  t[192] =
    "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split(
      ""
    );
  for (a = 0; a != t[192].length; ++a)
    if (t[192][a].charCodeAt(0) !== 65533) {
      r[t[192][a]] = 49152 + a;
      e[49152 + a] = t[192][a];
    }
  t[193] =
    "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split(
      ""
    );
  for (a = 0; a != t[193].length; ++a)
    if (t[193][a].charCodeAt(0) !== 65533) {
      r[t[193][a]] = 49408 + a;
      e[49408 + a] = t[193][a];
    }
  t[194] =
    "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split(
      ""
    );
  for (a = 0; a != t[194].length; ++a)
    if (t[194][a].charCodeAt(0) !== 65533) {
      r[t[194][a]] = 49664 + a;
      e[49664 + a] = t[194][a];
    }
  t[195] =
    "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split(
      ""
    );
  for (a = 0; a != t[195].length; ++a)
    if (t[195][a].charCodeAt(0) !== 65533) {
      r[t[195][a]] = 49920 + a;
      e[49920 + a] = t[195][a];
    }
  t[196] =
    "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split(
      ""
    );
  for (a = 0; a != t[196].length; ++a)
    if (t[196][a].charCodeAt(0) !== 65533) {
      r[t[196][a]] = 50176 + a;
      e[50176 + a] = t[196][a];
    }
  t[197] =
    "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split(
      ""
    );
  for (a = 0; a != t[197].length; ++a)
    if (t[197][a].charCodeAt(0) !== 65533) {
      r[t[197][a]] = 50432 + a;
      e[50432 + a] = t[197][a];
    }
  t[198] =
    "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split(
      ""
    );
  for (a = 0; a != t[198].length; ++a)
    if (t[198][a].charCodeAt(0) !== 65533) {
      r[t[198][a]] = 50688 + a;
      e[50688 + a] = t[198][a];
    }
  t[199] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split(
      ""
    );
  for (a = 0; a != t[199].length; ++a)
    if (t[199][a].charCodeAt(0) !== 65533) {
      r[t[199][a]] = 50944 + a;
      e[50944 + a] = t[199][a];
    }
  t[200] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split(
      ""
    );
  for (a = 0; a != t[200].length; ++a)
    if (t[200][a].charCodeAt(0) !== 65533) {
      r[t[200][a]] = 51200 + a;
      e[51200 + a] = t[200][a];
    }
  t[202] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split(
      ""
    );
  for (a = 0; a != t[202].length; ++a)
    if (t[202][a].charCodeAt(0) !== 65533) {
      r[t[202][a]] = 51712 + a;
      e[51712 + a] = t[202][a];
    }
  t[203] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split(
      ""
    );
  for (a = 0; a != t[203].length; ++a)
    if (t[203][a].charCodeAt(0) !== 65533) {
      r[t[203][a]] = 51968 + a;
      e[51968 + a] = t[203][a];
    }
  t[204] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split(
      ""
    );
  for (a = 0; a != t[204].length; ++a)
    if (t[204][a].charCodeAt(0) !== 65533) {
      r[t[204][a]] = 52224 + a;
      e[52224 + a] = t[204][a];
    }
  t[205] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split(
      ""
    );
  for (a = 0; a != t[205].length; ++a)
    if (t[205][a].charCodeAt(0) !== 65533) {
      r[t[205][a]] = 52480 + a;
      e[52480 + a] = t[205][a];
    }
  t[206] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split(
      ""
    );
  for (a = 0; a != t[206].length; ++a)
    if (t[206][a].charCodeAt(0) !== 65533) {
      r[t[206][a]] = 52736 + a;
      e[52736 + a] = t[206][a];
    }
  t[207] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split(
      ""
    );
  for (a = 0; a != t[207].length; ++a)
    if (t[207][a].charCodeAt(0) !== 65533) {
      r[t[207][a]] = 52992 + a;
      e[52992 + a] = t[207][a];
    }
  t[208] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split(
      ""
    );
  for (a = 0; a != t[208].length; ++a)
    if (t[208][a].charCodeAt(0) !== 65533) {
      r[t[208][a]] = 53248 + a;
      e[53248 + a] = t[208][a];
    }
  t[209] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split(
      ""
    );
  for (a = 0; a != t[209].length; ++a)
    if (t[209][a].charCodeAt(0) !== 65533) {
      r[t[209][a]] = 53504 + a;
      e[53504 + a] = t[209][a];
    }
  t[210] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split(
      ""
    );
  for (a = 0; a != t[210].length; ++a)
    if (t[210][a].charCodeAt(0) !== 65533) {
      r[t[210][a]] = 53760 + a;
      e[53760 + a] = t[210][a];
    }
  t[211] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split(
      ""
    );
  for (a = 0; a != t[211].length; ++a)
    if (t[211][a].charCodeAt(0) !== 65533) {
      r[t[211][a]] = 54016 + a;
      e[54016 + a] = t[211][a];
    }
  t[212] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split(
      ""
    );
  for (a = 0; a != t[212].length; ++a)
    if (t[212][a].charCodeAt(0) !== 65533) {
      r[t[212][a]] = 54272 + a;
      e[54272 + a] = t[212][a];
    }
  t[213] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split(
      ""
    );
  for (a = 0; a != t[213].length; ++a)
    if (t[213][a].charCodeAt(0) !== 65533) {
      r[t[213][a]] = 54528 + a;
      e[54528 + a] = t[213][a];
    }
  t[214] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split(
      ""
    );
  for (a = 0; a != t[214].length; ++a)
    if (t[214][a].charCodeAt(0) !== 65533) {
      r[t[214][a]] = 54784 + a;
      e[54784 + a] = t[214][a];
    }
  t[215] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split(
      ""
    );
  for (a = 0; a != t[215].length; ++a)
    if (t[215][a].charCodeAt(0) !== 65533) {
      r[t[215][a]] = 55040 + a;
      e[55040 + a] = t[215][a];
    }
  t[216] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split(
      ""
    );
  for (a = 0; a != t[216].length; ++a)
    if (t[216][a].charCodeAt(0) !== 65533) {
      r[t[216][a]] = 55296 + a;
      e[55296 + a] = t[216][a];
    }
  t[217] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split(
      ""
    );
  for (a = 0; a != t[217].length; ++a)
    if (t[217][a].charCodeAt(0) !== 65533) {
      r[t[217][a]] = 55552 + a;
      e[55552 + a] = t[217][a];
    }
  t[218] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split(
      ""
    );
  for (a = 0; a != t[218].length; ++a)
    if (t[218][a].charCodeAt(0) !== 65533) {
      r[t[218][a]] = 55808 + a;
      e[55808 + a] = t[218][a];
    }
  t[219] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split(
      ""
    );
  for (a = 0; a != t[219].length; ++a)
    if (t[219][a].charCodeAt(0) !== 65533) {
      r[t[219][a]] = 56064 + a;
      e[56064 + a] = t[219][a];
    }
  t[220] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split(
      ""
    );
  for (a = 0; a != t[220].length; ++a)
    if (t[220][a].charCodeAt(0) !== 65533) {
      r[t[220][a]] = 56320 + a;
      e[56320 + a] = t[220][a];
    }
  t[221] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split(
      ""
    );
  for (a = 0; a != t[221].length; ++a)
    if (t[221][a].charCodeAt(0) !== 65533) {
      r[t[221][a]] = 56576 + a;
      e[56576 + a] = t[221][a];
    }
  t[222] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split(
      ""
    );
  for (a = 0; a != t[222].length; ++a)
    if (t[222][a].charCodeAt(0) !== 65533) {
      r[t[222][a]] = 56832 + a;
      e[56832 + a] = t[222][a];
    }
  t[223] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split(
      ""
    );
  for (a = 0; a != t[223].length; ++a)
    if (t[223][a].charCodeAt(0) !== 65533) {
      r[t[223][a]] = 57088 + a;
      e[57088 + a] = t[223][a];
    }
  t[224] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split(
      ""
    );
  for (a = 0; a != t[224].length; ++a)
    if (t[224][a].charCodeAt(0) !== 65533) {
      r[t[224][a]] = 57344 + a;
      e[57344 + a] = t[224][a];
    }
  t[225] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split(
      ""
    );
  for (a = 0; a != t[225].length; ++a)
    if (t[225][a].charCodeAt(0) !== 65533) {
      r[t[225][a]] = 57600 + a;
      e[57600 + a] = t[225][a];
    }
  t[226] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split(
      ""
    );
  for (a = 0; a != t[226].length; ++a)
    if (t[226][a].charCodeAt(0) !== 65533) {
      r[t[226][a]] = 57856 + a;
      e[57856 + a] = t[226][a];
    }
  t[227] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split(
      ""
    );
  for (a = 0; a != t[227].length; ++a)
    if (t[227][a].charCodeAt(0) !== 65533) {
      r[t[227][a]] = 58112 + a;
      e[58112 + a] = t[227][a];
    }
  t[228] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split(
      ""
    );
  for (a = 0; a != t[228].length; ++a)
    if (t[228][a].charCodeAt(0) !== 65533) {
      r[t[228][a]] = 58368 + a;
      e[58368 + a] = t[228][a];
    }
  t[229] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split(
      ""
    );
  for (a = 0; a != t[229].length; ++a)
    if (t[229][a].charCodeAt(0) !== 65533) {
      r[t[229][a]] = 58624 + a;
      e[58624 + a] = t[229][a];
    }
  t[230] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split(
      ""
    );
  for (a = 0; a != t[230].length; ++a)
    if (t[230][a].charCodeAt(0) !== 65533) {
      r[t[230][a]] = 58880 + a;
      e[58880 + a] = t[230][a];
    }
  t[231] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split(
      ""
    );
  for (a = 0; a != t[231].length; ++a)
    if (t[231][a].charCodeAt(0) !== 65533) {
      r[t[231][a]] = 59136 + a;
      e[59136 + a] = t[231][a];
    }
  t[232] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split(
      ""
    );
  for (a = 0; a != t[232].length; ++a)
    if (t[232][a].charCodeAt(0) !== 65533) {
      r[t[232][a]] = 59392 + a;
      e[59392 + a] = t[232][a];
    }
  t[233] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split(
      ""
    );
  for (a = 0; a != t[233].length; ++a)
    if (t[233][a].charCodeAt(0) !== 65533) {
      r[t[233][a]] = 59648 + a;
      e[59648 + a] = t[233][a];
    }
  t[234] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split(
      ""
    );
  for (a = 0; a != t[234].length; ++a)
    if (t[234][a].charCodeAt(0) !== 65533) {
      r[t[234][a]] = 59904 + a;
      e[59904 + a] = t[234][a];
    }
  t[235] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split(
      ""
    );
  for (a = 0; a != t[235].length; ++a)
    if (t[235][a].charCodeAt(0) !== 65533) {
      r[t[235][a]] = 60160 + a;
      e[60160 + a] = t[235][a];
    }
  t[236] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split(
      ""
    );
  for (a = 0; a != t[236].length; ++a)
    if (t[236][a].charCodeAt(0) !== 65533) {
      r[t[236][a]] = 60416 + a;
      e[60416 + a] = t[236][a];
    }
  t[237] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split(
      ""
    );
  for (a = 0; a != t[237].length; ++a)
    if (t[237][a].charCodeAt(0) !== 65533) {
      r[t[237][a]] = 60672 + a;
      e[60672 + a] = t[237][a];
    }
  t[238] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split(
      ""
    );
  for (a = 0; a != t[238].length; ++a)
    if (t[238][a].charCodeAt(0) !== 65533) {
      r[t[238][a]] = 60928 + a;
      e[60928 + a] = t[238][a];
    }
  t[239] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split(
      ""
    );
  for (a = 0; a != t[239].length; ++a)
    if (t[239][a].charCodeAt(0) !== 65533) {
      r[t[239][a]] = 61184 + a;
      e[61184 + a] = t[239][a];
    }
  t[240] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split(
      ""
    );
  for (a = 0; a != t[240].length; ++a)
    if (t[240][a].charCodeAt(0) !== 65533) {
      r[t[240][a]] = 61440 + a;
      e[61440 + a] = t[240][a];
    }
  t[241] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split(
      ""
    );
  for (a = 0; a != t[241].length; ++a)
    if (t[241][a].charCodeAt(0) !== 65533) {
      r[t[241][a]] = 61696 + a;
      e[61696 + a] = t[241][a];
    }
  t[242] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split(
      ""
    );
  for (a = 0; a != t[242].length; ++a)
    if (t[242][a].charCodeAt(0) !== 65533) {
      r[t[242][a]] = 61952 + a;
      e[61952 + a] = t[242][a];
    }
  t[243] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split(
      ""
    );
  for (a = 0; a != t[243].length; ++a)
    if (t[243][a].charCodeAt(0) !== 65533) {
      r[t[243][a]] = 62208 + a;
      e[62208 + a] = t[243][a];
    }
  t[244] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split(
      ""
    );
  for (a = 0; a != t[244].length; ++a)
    if (t[244][a].charCodeAt(0) !== 65533) {
      r[t[244][a]] = 62464 + a;
      e[62464 + a] = t[244][a];
    }
  t[245] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split(
      ""
    );
  for (a = 0; a != t[245].length; ++a)
    if (t[245][a].charCodeAt(0) !== 65533) {
      r[t[245][a]] = 62720 + a;
      e[62720 + a] = t[245][a];
    }
  t[246] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split(
      ""
    );
  for (a = 0; a != t[246].length; ++a)
    if (t[246][a].charCodeAt(0) !== 65533) {
      r[t[246][a]] = 62976 + a;
      e[62976 + a] = t[246][a];
    }
  t[247] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split(
      ""
    );
  for (a = 0; a != t[247].length; ++a)
    if (t[247][a].charCodeAt(0) !== 65533) {
      r[t[247][a]] = 63232 + a;
      e[63232 + a] = t[247][a];
    }
  t[248] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split(
      ""
    );
  for (a = 0; a != t[248].length; ++a)
    if (t[248][a].charCodeAt(0) !== 65533) {
      r[t[248][a]] = 63488 + a;
      e[63488 + a] = t[248][a];
    }
  t[249] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split(
      ""
    );
  for (a = 0; a != t[249].length; ++a)
    if (t[249][a].charCodeAt(0) !== 65533) {
      r[t[249][a]] = 63744 + a;
      e[63744 + a] = t[249][a];
    }
  t[250] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split(
      ""
    );
  for (a = 0; a != t[250].length; ++a)
    if (t[250][a].charCodeAt(0) !== 65533) {
      r[t[250][a]] = 64e3 + a;
      e[64e3 + a] = t[250][a];
    }
  t[251] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split(
      ""
    );
  for (a = 0; a != t[251].length; ++a)
    if (t[251][a].charCodeAt(0) !== 65533) {
      r[t[251][a]] = 64256 + a;
      e[64256 + a] = t[251][a];
    }
  t[252] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split(
      ""
    );
  for (a = 0; a != t[252].length; ++a)
    if (t[252][a].charCodeAt(0) !== 65533) {
      r[t[252][a]] = 64512 + a;
      e[64512 + a] = t[252][a];
    }
  t[253] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split(
      ""
    );
  for (a = 0; a != t[253].length; ++a)
    if (t[253][a].charCodeAt(0) !== 65533) {
      r[t[253][a]] = 64768 + a;
      e[64768 + a] = t[253][a];
    }
  return { enc: r, dec: e };
})();
cptable[950] = (function () {
  var e = [],
    r = {},
    t = [],
    a;
  t[0] =
    "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[0].length; ++a)
    if (t[0][a].charCodeAt(0) !== 65533) {
      r[t[0][a]] = 0 + a;
      e[0 + a] = t[0][a];
    }
  t[161] =
    "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split(
      ""
    );
  for (a = 0; a != t[161].length; ++a)
    if (t[161][a].charCodeAt(0) !== 65533) {
      r[t[161][a]] = 41216 + a;
      e[41216 + a] = t[161][a];
    }
  t[162] =
    "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split(
      ""
    );
  for (a = 0; a != t[162].length; ++a)
    if (t[162][a].charCodeAt(0) !== 65533) {
      r[t[162][a]] = 41472 + a;
      e[41472 + a] = t[162][a];
    }
  t[163] =
    "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split(
      ""
    );
  for (a = 0; a != t[163].length; ++a)
    if (t[163][a].charCodeAt(0) !== 65533) {
      r[t[163][a]] = 41728 + a;
      e[41728 + a] = t[163][a];
    }
  t[164] =
    "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split(
      ""
    );
  for (a = 0; a != t[164].length; ++a)
    if (t[164][a].charCodeAt(0) !== 65533) {
      r[t[164][a]] = 41984 + a;
      e[41984 + a] = t[164][a];
    }
  t[165] =
    "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split(
      ""
    );
  for (a = 0; a != t[165].length; ++a)
    if (t[165][a].charCodeAt(0) !== 65533) {
      r[t[165][a]] = 42240 + a;
      e[42240 + a] = t[165][a];
    }
  t[166] =
    "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split(
      ""
    );
  for (a = 0; a != t[166].length; ++a)
    if (t[166][a].charCodeAt(0) !== 65533) {
      r[t[166][a]] = 42496 + a;
      e[42496 + a] = t[166][a];
    }
  t[167] =
    "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split(
      ""
    );
  for (a = 0; a != t[167].length; ++a)
    if (t[167][a].charCodeAt(0) !== 65533) {
      r[t[167][a]] = 42752 + a;
      e[42752 + a] = t[167][a];
    }
  t[168] =
    "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split(
      ""
    );
  for (a = 0; a != t[168].length; ++a)
    if (t[168][a].charCodeAt(0) !== 65533) {
      r[t[168][a]] = 43008 + a;
      e[43008 + a] = t[168][a];
    }
  t[169] =
    "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split(
      ""
    );
  for (a = 0; a != t[169].length; ++a)
    if (t[169][a].charCodeAt(0) !== 65533) {
      r[t[169][a]] = 43264 + a;
      e[43264 + a] = t[169][a];
    }
  t[170] =
    "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split(
      ""
    );
  for (a = 0; a != t[170].length; ++a)
    if (t[170][a].charCodeAt(0) !== 65533) {
      r[t[170][a]] = 43520 + a;
      e[43520 + a] = t[170][a];
    }
  t[171] =
    "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split(
      ""
    );
  for (a = 0; a != t[171].length; ++a)
    if (t[171][a].charCodeAt(0) !== 65533) {
      r[t[171][a]] = 43776 + a;
      e[43776 + a] = t[171][a];
    }
  t[172] =
    "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split(
      ""
    );
  for (a = 0; a != t[172].length; ++a)
    if (t[172][a].charCodeAt(0) !== 65533) {
      r[t[172][a]] = 44032 + a;
      e[44032 + a] = t[172][a];
    }
  t[173] =
    "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split(
      ""
    );
  for (a = 0; a != t[173].length; ++a)
    if (t[173][a].charCodeAt(0) !== 65533) {
      r[t[173][a]] = 44288 + a;
      e[44288 + a] = t[173][a];
    }
  t[174] =
    "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split(
      ""
    );
  for (a = 0; a != t[174].length; ++a)
    if (t[174][a].charCodeAt(0) !== 65533) {
      r[t[174][a]] = 44544 + a;
      e[44544 + a] = t[174][a];
    }
  t[175] =
    "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split(
      ""
    );
  for (a = 0; a != t[175].length; ++a)
    if (t[175][a].charCodeAt(0) !== 65533) {
      r[t[175][a]] = 44800 + a;
      e[44800 + a] = t[175][a];
    }
  t[176] =
    "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split(
      ""
    );
  for (a = 0; a != t[176].length; ++a)
    if (t[176][a].charCodeAt(0) !== 65533) {
      r[t[176][a]] = 45056 + a;
      e[45056 + a] = t[176][a];
    }
  t[177] =
    "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split(
      ""
    );
  for (a = 0; a != t[177].length; ++a)
    if (t[177][a].charCodeAt(0) !== 65533) {
      r[t[177][a]] = 45312 + a;
      e[45312 + a] = t[177][a];
    }
  t[178] =
    "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split(
      ""
    );
  for (a = 0; a != t[178].length; ++a)
    if (t[178][a].charCodeAt(0) !== 65533) {
      r[t[178][a]] = 45568 + a;
      e[45568 + a] = t[178][a];
    }
  t[179] =
    "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split(
      ""
    );
  for (a = 0; a != t[179].length; ++a)
    if (t[179][a].charCodeAt(0) !== 65533) {
      r[t[179][a]] = 45824 + a;
      e[45824 + a] = t[179][a];
    }
  t[180] =
    "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split(
      ""
    );
  for (a = 0; a != t[180].length; ++a)
    if (t[180][a].charCodeAt(0) !== 65533) {
      r[t[180][a]] = 46080 + a;
      e[46080 + a] = t[180][a];
    }
  t[181] =
    "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split(
      ""
    );
  for (a = 0; a != t[181].length; ++a)
    if (t[181][a].charCodeAt(0) !== 65533) {
      r[t[181][a]] = 46336 + a;
      e[46336 + a] = t[181][a];
    }
  t[182] =
    "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split(
      ""
    );
  for (a = 0; a != t[182].length; ++a)
    if (t[182][a].charCodeAt(0) !== 65533) {
      r[t[182][a]] = 46592 + a;
      e[46592 + a] = t[182][a];
    }
  t[183] =
    "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split(
      ""
    );
  for (a = 0; a != t[183].length; ++a)
    if (t[183][a].charCodeAt(0) !== 65533) {
      r[t[183][a]] = 46848 + a;
      e[46848 + a] = t[183][a];
    }
  t[184] =
    "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split(
      ""
    );
  for (a = 0; a != t[184].length; ++a)
    if (t[184][a].charCodeAt(0) !== 65533) {
      r[t[184][a]] = 47104 + a;
      e[47104 + a] = t[184][a];
    }
  t[185] =
    "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split(
      ""
    );
  for (a = 0; a != t[185].length; ++a)
    if (t[185][a].charCodeAt(0) !== 65533) {
      r[t[185][a]] = 47360 + a;
      e[47360 + a] = t[185][a];
    }
  t[186] =
    "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split(
      ""
    );
  for (a = 0; a != t[186].length; ++a)
    if (t[186][a].charCodeAt(0) !== 65533) {
      r[t[186][a]] = 47616 + a;
      e[47616 + a] = t[186][a];
    }
  t[187] =
    "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split(
      ""
    );
  for (a = 0; a != t[187].length; ++a)
    if (t[187][a].charCodeAt(0) !== 65533) {
      r[t[187][a]] = 47872 + a;
      e[47872 + a] = t[187][a];
    }
  t[188] =
    "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split(
      ""
    );
  for (a = 0; a != t[188].length; ++a)
    if (t[188][a].charCodeAt(0) !== 65533) {
      r[t[188][a]] = 48128 + a;
      e[48128 + a] = t[188][a];
    }
  t[189] =
    "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split(
      ""
    );
  for (a = 0; a != t[189].length; ++a)
    if (t[189][a].charCodeAt(0) !== 65533) {
      r[t[189][a]] = 48384 + a;
      e[48384 + a] = t[189][a];
    }
  t[190] =
    "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split(
      ""
    );
  for (a = 0; a != t[190].length; ++a)
    if (t[190][a].charCodeAt(0) !== 65533) {
      r[t[190][a]] = 48640 + a;
      e[48640 + a] = t[190][a];
    }
  t[191] =
    "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split(
      ""
    );
  for (a = 0; a != t[191].length; ++a)
    if (t[191][a].charCodeAt(0) !== 65533) {
      r[t[191][a]] = 48896 + a;
      e[48896 + a] = t[191][a];
    }
  t[192] =
    "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split(
      ""
    );
  for (a = 0; a != t[192].length; ++a)
    if (t[192][a].charCodeAt(0) !== 65533) {
      r[t[192][a]] = 49152 + a;
      e[49152 + a] = t[192][a];
    }
  t[193] =
    "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split(
      ""
    );
  for (a = 0; a != t[193].length; ++a)
    if (t[193][a].charCodeAt(0) !== 65533) {
      r[t[193][a]] = 49408 + a;
      e[49408 + a] = t[193][a];
    }
  t[194] =
    "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split(
      ""
    );
  for (a = 0; a != t[194].length; ++a)
    if (t[194][a].charCodeAt(0) !== 65533) {
      r[t[194][a]] = 49664 + a;
      e[49664 + a] = t[194][a];
    }
  t[195] =
    "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split(
      ""
    );
  for (a = 0; a != t[195].length; ++a)
    if (t[195][a].charCodeAt(0) !== 65533) {
      r[t[195][a]] = 49920 + a;
      e[49920 + a] = t[195][a];
    }
  t[196] =
    "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split(
      ""
    );
  for (a = 0; a != t[196].length; ++a)
    if (t[196][a].charCodeAt(0) !== 65533) {
      r[t[196][a]] = 50176 + a;
      e[50176 + a] = t[196][a];
    }
  t[197] =
    "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split(
      ""
    );
  for (a = 0; a != t[197].length; ++a)
    if (t[197][a].charCodeAt(0) !== 65533) {
      r[t[197][a]] = 50432 + a;
      e[50432 + a] = t[197][a];
    }
  t[198] =
    "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[198].length; ++a)
    if (t[198][a].charCodeAt(0) !== 65533) {
      r[t[198][a]] = 50688 + a;
      e[50688 + a] = t[198][a];
    }
  t[201] =
    "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split(
      ""
    );
  for (a = 0; a != t[201].length; ++a)
    if (t[201][a].charCodeAt(0) !== 65533) {
      r[t[201][a]] = 51456 + a;
      e[51456 + a] = t[201][a];
    }
  t[202] =
    "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split(
      ""
    );
  for (a = 0; a != t[202].length; ++a)
    if (t[202][a].charCodeAt(0) !== 65533) {
      r[t[202][a]] = 51712 + a;
      e[51712 + a] = t[202][a];
    }
  t[203] =
    "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split(
      ""
    );
  for (a = 0; a != t[203].length; ++a)
    if (t[203][a].charCodeAt(0) !== 65533) {
      r[t[203][a]] = 51968 + a;
      e[51968 + a] = t[203][a];
    }
  t[204] =
    "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split(
      ""
    );
  for (a = 0; a != t[204].length; ++a)
    if (t[204][a].charCodeAt(0) !== 65533) {
      r[t[204][a]] = 52224 + a;
      e[52224 + a] = t[204][a];
    }
  t[205] =
    "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split(
      ""
    );
  for (a = 0; a != t[205].length; ++a)
    if (t[205][a].charCodeAt(0) !== 65533) {
      r[t[205][a]] = 52480 + a;
      e[52480 + a] = t[205][a];
    }
  t[206] =
    "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split(
      ""
    );
  for (a = 0; a != t[206].length; ++a)
    if (t[206][a].charCodeAt(0) !== 65533) {
      r[t[206][a]] = 52736 + a;
      e[52736 + a] = t[206][a];
    }
  t[207] =
    "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split(
      ""
    );
  for (a = 0; a != t[207].length; ++a)
    if (t[207][a].charCodeAt(0) !== 65533) {
      r[t[207][a]] = 52992 + a;
      e[52992 + a] = t[207][a];
    }
  t[208] =
    "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split(
      ""
    );
  for (a = 0; a != t[208].length; ++a)
    if (t[208][a].charCodeAt(0) !== 65533) {
      r[t[208][a]] = 53248 + a;
      e[53248 + a] = t[208][a];
    }
  t[209] =
    "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split(
      ""
    );
  for (a = 0; a != t[209].length; ++a)
    if (t[209][a].charCodeAt(0) !== 65533) {
      r[t[209][a]] = 53504 + a;
      e[53504 + a] = t[209][a];
    }
  t[210] =
    "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split(
      ""
    );
  for (a = 0; a != t[210].length; ++a)
    if (t[210][a].charCodeAt(0) !== 65533) {
      r[t[210][a]] = 53760 + a;
      e[53760 + a] = t[210][a];
    }
  t[211] =
    "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split(
      ""
    );
  for (a = 0; a != t[211].length; ++a)
    if (t[211][a].charCodeAt(0) !== 65533) {
      r[t[211][a]] = 54016 + a;
      e[54016 + a] = t[211][a];
    }
  t[212] =
    "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split(
      ""
    );
  for (a = 0; a != t[212].length; ++a)
    if (t[212][a].charCodeAt(0) !== 65533) {
      r[t[212][a]] = 54272 + a;
      e[54272 + a] = t[212][a];
    }
  t[213] =
    "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split(
      ""
    );
  for (a = 0; a != t[213].length; ++a)
    if (t[213][a].charCodeAt(0) !== 65533) {
      r[t[213][a]] = 54528 + a;
      e[54528 + a] = t[213][a];
    }
  t[214] =
    "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split(
      ""
    );
  for (a = 0; a != t[214].length; ++a)
    if (t[214][a].charCodeAt(0) !== 65533) {
      r[t[214][a]] = 54784 + a;
      e[54784 + a] = t[214][a];
    }
  t[215] =
    "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split(
      ""
    );
  for (a = 0; a != t[215].length; ++a)
    if (t[215][a].charCodeAt(0) !== 65533) {
      r[t[215][a]] = 55040 + a;
      e[55040 + a] = t[215][a];
    }
  t[216] =
    "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split(
      ""
    );
  for (a = 0; a != t[216].length; ++a)
    if (t[216][a].charCodeAt(0) !== 65533) {
      r[t[216][a]] = 55296 + a;
      e[55296 + a] = t[216][a];
    }
  t[217] =
    "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split(
      ""
    );
  for (a = 0; a != t[217].length; ++a)
    if (t[217][a].charCodeAt(0) !== 65533) {
      r[t[217][a]] = 55552 + a;
      e[55552 + a] = t[217][a];
    }
  t[218] =
    "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split(
      ""
    );
  for (a = 0; a != t[218].length; ++a)
    if (t[218][a].charCodeAt(0) !== 65533) {
      r[t[218][a]] = 55808 + a;
      e[55808 + a] = t[218][a];
    }
  t[219] =
    "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split(
      ""
    );
  for (a = 0; a != t[219].length; ++a)
    if (t[219][a].charCodeAt(0) !== 65533) {
      r[t[219][a]] = 56064 + a;
      e[56064 + a] = t[219][a];
    }
  t[220] =
    "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split(
      ""
    );
  for (a = 0; a != t[220].length; ++a)
    if (t[220][a].charCodeAt(0) !== 65533) {
      r[t[220][a]] = 56320 + a;
      e[56320 + a] = t[220][a];
    }
  t[221] =
    "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split(
      ""
    );
  for (a = 0; a != t[221].length; ++a)
    if (t[221][a].charCodeAt(0) !== 65533) {
      r[t[221][a]] = 56576 + a;
      e[56576 + a] = t[221][a];
    }
  t[222] =
    "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split(
      ""
    );
  for (a = 0; a != t[222].length; ++a)
    if (t[222][a].charCodeAt(0) !== 65533) {
      r[t[222][a]] = 56832 + a;
      e[56832 + a] = t[222][a];
    }
  t[223] =
    "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split(
      ""
    );
  for (a = 0; a != t[223].length; ++a)
    if (t[223][a].charCodeAt(0) !== 65533) {
      r[t[223][a]] = 57088 + a;
      e[57088 + a] = t[223][a];
    }
  t[224] =
    "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split(
      ""
    );
  for (a = 0; a != t[224].length; ++a)
    if (t[224][a].charCodeAt(0) !== 65533) {
      r[t[224][a]] = 57344 + a;
      e[57344 + a] = t[224][a];
    }
  t[225] =
    "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split(
      ""
    );
  for (a = 0; a != t[225].length; ++a)
    if (t[225][a].charCodeAt(0) !== 65533) {
      r[t[225][a]] = 57600 + a;
      e[57600 + a] = t[225][a];
    }
  t[226] =
    "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split(
      ""
    );
  for (a = 0; a != t[226].length; ++a)
    if (t[226][a].charCodeAt(0) !== 65533) {
      r[t[226][a]] = 57856 + a;
      e[57856 + a] = t[226][a];
    }
  t[227] =
    "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split(
      ""
    );
  for (a = 0; a != t[227].length; ++a)
    if (t[227][a].charCodeAt(0) !== 65533) {
      r[t[227][a]] = 58112 + a;
      e[58112 + a] = t[227][a];
    }
  t[228] =
    "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split(
      ""
    );
  for (a = 0; a != t[228].length; ++a)
    if (t[228][a].charCodeAt(0) !== 65533) {
      r[t[228][a]] = 58368 + a;
      e[58368 + a] = t[228][a];
    }
  t[229] =
    "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split(
      ""
    );
  for (a = 0; a != t[229].length; ++a)
    if (t[229][a].charCodeAt(0) !== 65533) {
      r[t[229][a]] = 58624 + a;
      e[58624 + a] = t[229][a];
    }
  t[230] =
    "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split(
      ""
    );
  for (a = 0; a != t[230].length; ++a)
    if (t[230][a].charCodeAt(0) !== 65533) {
      r[t[230][a]] = 58880 + a;
      e[58880 + a] = t[230][a];
    }
  t[231] =
    "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split(
      ""
    );
  for (a = 0; a != t[231].length; ++a)
    if (t[231][a].charCodeAt(0) !== 65533) {
      r[t[231][a]] = 59136 + a;
      e[59136 + a] = t[231][a];
    }
  t[232] =
    "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split(
      ""
    );
  for (a = 0; a != t[232].length; ++a)
    if (t[232][a].charCodeAt(0) !== 65533) {
      r[t[232][a]] = 59392 + a;
      e[59392 + a] = t[232][a];
    }
  t[233] =
    "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split(
      ""
    );
  for (a = 0; a != t[233].length; ++a)
    if (t[233][a].charCodeAt(0) !== 65533) {
      r[t[233][a]] = 59648 + a;
      e[59648 + a] = t[233][a];
    }
  t[234] =
    "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split(
      ""
    );
  for (a = 0; a != t[234].length; ++a)
    if (t[234][a].charCodeAt(0) !== 65533) {
      r[t[234][a]] = 59904 + a;
      e[59904 + a] = t[234][a];
    }
  t[235] =
    "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split(
      ""
    );
  for (a = 0; a != t[235].length; ++a)
    if (t[235][a].charCodeAt(0) !== 65533) {
      r[t[235][a]] = 60160 + a;
      e[60160 + a] = t[235][a];
    }
  t[236] =
    "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split(
      ""
    );
  for (a = 0; a != t[236].length; ++a)
    if (t[236][a].charCodeAt(0) !== 65533) {
      r[t[236][a]] = 60416 + a;
      e[60416 + a] = t[236][a];
    }
  t[237] =
    "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split(
      ""
    );
  for (a = 0; a != t[237].length; ++a)
    if (t[237][a].charCodeAt(0) !== 65533) {
      r[t[237][a]] = 60672 + a;
      e[60672 + a] = t[237][a];
    }
  t[238] =
    "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split(
      ""
    );
  for (a = 0; a != t[238].length; ++a)
    if (t[238][a].charCodeAt(0) !== 65533) {
      r[t[238][a]] = 60928 + a;
      e[60928 + a] = t[238][a];
    }
  t[239] =
    "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split(
      ""
    );
  for (a = 0; a != t[239].length; ++a)
    if (t[239][a].charCodeAt(0) !== 65533) {
      r[t[239][a]] = 61184 + a;
      e[61184 + a] = t[239][a];
    }
  t[240] =
    "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split(
      ""
    );
  for (a = 0; a != t[240].length; ++a)
    if (t[240][a].charCodeAt(0) !== 65533) {
      r[t[240][a]] = 61440 + a;
      e[61440 + a] = t[240][a];
    }
  t[241] =
    "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split(
      ""
    );
  for (a = 0; a != t[241].length; ++a)
    if (t[241][a].charCodeAt(0) !== 65533) {
      r[t[241][a]] = 61696 + a;
      e[61696 + a] = t[241][a];
    }
  t[242] =
    "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split(
      ""
    );
  for (a = 0; a != t[242].length; ++a)
    if (t[242][a].charCodeAt(0) !== 65533) {
      r[t[242][a]] = 61952 + a;
      e[61952 + a] = t[242][a];
    }
  t[243] =
    "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split(
      ""
    );
  for (a = 0; a != t[243].length; ++a)
    if (t[243][a].charCodeAt(0) !== 65533) {
      r[t[243][a]] = 62208 + a;
      e[62208 + a] = t[243][a];
    }
  t[244] =
    "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split(
      ""
    );
  for (a = 0; a != t[244].length; ++a)
    if (t[244][a].charCodeAt(0) !== 65533) {
      r[t[244][a]] = 62464 + a;
      e[62464 + a] = t[244][a];
    }
  t[245] =
    "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split(
      ""
    );
  for (a = 0; a != t[245].length; ++a)
    if (t[245][a].charCodeAt(0) !== 65533) {
      r[t[245][a]] = 62720 + a;
      e[62720 + a] = t[245][a];
    }
  t[246] =
    "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split(
      ""
    );
  for (a = 0; a != t[246].length; ++a)
    if (t[246][a].charCodeAt(0) !== 65533) {
      r[t[246][a]] = 62976 + a;
      e[62976 + a] = t[246][a];
    }
  t[247] =
    "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split(
      ""
    );
  for (a = 0; a != t[247].length; ++a)
    if (t[247][a].charCodeAt(0) !== 65533) {
      r[t[247][a]] = 63232 + a;
      e[63232 + a] = t[247][a];
    }
  t[248] =
    "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split(
      ""
    );
  for (a = 0; a != t[248].length; ++a)
    if (t[248][a].charCodeAt(0) !== 65533) {
      r[t[248][a]] = 63488 + a;
      e[63488 + a] = t[248][a];
    }
  t[249] =
    "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split(
      ""
    );
  for (a = 0; a != t[249].length; ++a)
    if (t[249][a].charCodeAt(0) !== 65533) {
      r[t[249][a]] = 63744 + a;
      e[63744 + a] = t[249][a];
    }
  return { enc: r, dec: e };
})();
cptable[1250] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[1251] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[1252] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[1253] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[1254] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[1255] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[1256] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[1257] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[1258] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[1e4] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[10006] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[10007] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[10008] = (function () {
  var e = [],
    r = {},
    t = [],
    a;
  t[0] =
    "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split(
      ""
    );
  for (a = 0; a != t[0].length; ++a)
    if (t[0][a].charCodeAt(0) !== 65533) {
      r[t[0][a]] = 0 + a;
      e[0 + a] = t[0][a];
    }
  t[161] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split(
      ""
    );
  for (a = 0; a != t[161].length; ++a)
    if (t[161][a].charCodeAt(0) !== 65533) {
      r[t[161][a]] = 41216 + a;
      e[41216 + a] = t[161][a];
    }
  t[162] =
    "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split(
      ""
    );
  for (a = 0; a != t[162].length; ++a)
    if (t[162][a].charCodeAt(0) !== 65533) {
      r[t[162][a]] = 41472 + a;
      e[41472 + a] = t[162][a];
    }
  t[163] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split(
      ""
    );
  for (a = 0; a != t[163].length; ++a)
    if (t[163][a].charCodeAt(0) !== 65533) {
      r[t[163][a]] = 41728 + a;
      e[41728 + a] = t[163][a];
    }
  t[164] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split(
      ""
    );
  for (a = 0; a != t[164].length; ++a)
    if (t[164][a].charCodeAt(0) !== 65533) {
      r[t[164][a]] = 41984 + a;
      e[41984 + a] = t[164][a];
    }
  t[165] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split(
      ""
    );
  for (a = 0; a != t[165].length; ++a)
    if (t[165][a].charCodeAt(0) !== 65533) {
      r[t[165][a]] = 42240 + a;
      e[42240 + a] = t[165][a];
    }
  t[166] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split(
      ""
    );
  for (a = 0; a != t[166].length; ++a)
    if (t[166][a].charCodeAt(0) !== 65533) {
      r[t[166][a]] = 42496 + a;
      e[42496 + a] = t[166][a];
    }
  t[167] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split(
      ""
    );
  for (a = 0; a != t[167].length; ++a)
    if (t[167][a].charCodeAt(0) !== 65533) {
      r[t[167][a]] = 42752 + a;
      e[42752 + a] = t[167][a];
    }
  t[168] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split(
      ""
    );
  for (a = 0; a != t[168].length; ++a)
    if (t[168][a].charCodeAt(0) !== 65533) {
      r[t[168][a]] = 43008 + a;
      e[43008 + a] = t[168][a];
    }
  t[169] =
    "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split(
      ""
    );
  for (a = 0; a != t[169].length; ++a)
    if (t[169][a].charCodeAt(0) !== 65533) {
      r[t[169][a]] = 43264 + a;
      e[43264 + a] = t[169][a];
    }
  t[176] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split(
      ""
    );
  for (a = 0; a != t[176].length; ++a)
    if (t[176][a].charCodeAt(0) !== 65533) {
      r[t[176][a]] = 45056 + a;
      e[45056 + a] = t[176][a];
    }
  t[177] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split(
      ""
    );
  for (a = 0; a != t[177].length; ++a)
    if (t[177][a].charCodeAt(0) !== 65533) {
      r[t[177][a]] = 45312 + a;
      e[45312 + a] = t[177][a];
    }
  t[178] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split(
      ""
    );
  for (a = 0; a != t[178].length; ++a)
    if (t[178][a].charCodeAt(0) !== 65533) {
      r[t[178][a]] = 45568 + a;
      e[45568 + a] = t[178][a];
    }
  t[179] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split(
      ""
    );
  for (a = 0; a != t[179].length; ++a)
    if (t[179][a].charCodeAt(0) !== 65533) {
      r[t[179][a]] = 45824 + a;
      e[45824 + a] = t[179][a];
    }
  t[180] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split(
      ""
    );
  for (a = 0; a != t[180].length; ++a)
    if (t[180][a].charCodeAt(0) !== 65533) {
      r[t[180][a]] = 46080 + a;
      e[46080 + a] = t[180][a];
    }
  t[181] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split(
      ""
    );
  for (a = 0; a != t[181].length; ++a)
    if (t[181][a].charCodeAt(0) !== 65533) {
      r[t[181][a]] = 46336 + a;
      e[46336 + a] = t[181][a];
    }
  t[182] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split(
      ""
    );
  for (a = 0; a != t[182].length; ++a)
    if (t[182][a].charCodeAt(0) !== 65533) {
      r[t[182][a]] = 46592 + a;
      e[46592 + a] = t[182][a];
    }
  t[183] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split(
      ""
    );
  for (a = 0; a != t[183].length; ++a)
    if (t[183][a].charCodeAt(0) !== 65533) {
      r[t[183][a]] = 46848 + a;
      e[46848 + a] = t[183][a];
    }
  t[184] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split(
      ""
    );
  for (a = 0; a != t[184].length; ++a)
    if (t[184][a].charCodeAt(0) !== 65533) {
      r[t[184][a]] = 47104 + a;
      e[47104 + a] = t[184][a];
    }
  t[185] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split(
      ""
    );
  for (a = 0; a != t[185].length; ++a)
    if (t[185][a].charCodeAt(0) !== 65533) {
      r[t[185][a]] = 47360 + a;
      e[47360 + a] = t[185][a];
    }
  t[186] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split(
      ""
    );
  for (a = 0; a != t[186].length; ++a)
    if (t[186][a].charCodeAt(0) !== 65533) {
      r[t[186][a]] = 47616 + a;
      e[47616 + a] = t[186][a];
    }
  t[187] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split(
      ""
    );
  for (a = 0; a != t[187].length; ++a)
    if (t[187][a].charCodeAt(0) !== 65533) {
      r[t[187][a]] = 47872 + a;
      e[47872 + a] = t[187][a];
    }
  t[188] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split(
      ""
    );
  for (a = 0; a != t[188].length; ++a)
    if (t[188][a].charCodeAt(0) !== 65533) {
      r[t[188][a]] = 48128 + a;
      e[48128 + a] = t[188][a];
    }
  t[189] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split(
      ""
    );
  for (a = 0; a != t[189].length; ++a)
    if (t[189][a].charCodeAt(0) !== 65533) {
      r[t[189][a]] = 48384 + a;
      e[48384 + a] = t[189][a];
    }
  t[190] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split(
      ""
    );
  for (a = 0; a != t[190].length; ++a)
    if (t[190][a].charCodeAt(0) !== 65533) {
      r[t[190][a]] = 48640 + a;
      e[48640 + a] = t[190][a];
    }
  t[191] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split(
      ""
    );
  for (a = 0; a != t[191].length; ++a)
    if (t[191][a].charCodeAt(0) !== 65533) {
      r[t[191][a]] = 48896 + a;
      e[48896 + a] = t[191][a];
    }
  t[192] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split(
      ""
    );
  for (a = 0; a != t[192].length; ++a)
    if (t[192][a].charCodeAt(0) !== 65533) {
      r[t[192][a]] = 49152 + a;
      e[49152 + a] = t[192][a];
    }
  t[193] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split(
      ""
    );
  for (a = 0; a != t[193].length; ++a)
    if (t[193][a].charCodeAt(0) !== 65533) {
      r[t[193][a]] = 49408 + a;
      e[49408 + a] = t[193][a];
    }
  t[194] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split(
      ""
    );
  for (a = 0; a != t[194].length; ++a)
    if (t[194][a].charCodeAt(0) !== 65533) {
      r[t[194][a]] = 49664 + a;
      e[49664 + a] = t[194][a];
    }
  t[195] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split(
      ""
    );
  for (a = 0; a != t[195].length; ++a)
    if (t[195][a].charCodeAt(0) !== 65533) {
      r[t[195][a]] = 49920 + a;
      e[49920 + a] = t[195][a];
    }
  t[196] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split(
      ""
    );
  for (a = 0; a != t[196].length; ++a)
    if (t[196][a].charCodeAt(0) !== 65533) {
      r[t[196][a]] = 50176 + a;
      e[50176 + a] = t[196][a];
    }
  t[197] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split(
      ""
    );
  for (a = 0; a != t[197].length; ++a)
    if (t[197][a].charCodeAt(0) !== 65533) {
      r[t[197][a]] = 50432 + a;
      e[50432 + a] = t[197][a];
    }
  t[198] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split(
      ""
    );
  for (a = 0; a != t[198].length; ++a)
    if (t[198][a].charCodeAt(0) !== 65533) {
      r[t[198][a]] = 50688 + a;
      e[50688 + a] = t[198][a];
    }
  t[199] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split(
      ""
    );
  for (a = 0; a != t[199].length; ++a)
    if (t[199][a].charCodeAt(0) !== 65533) {
      r[t[199][a]] = 50944 + a;
      e[50944 + a] = t[199][a];
    }
  t[200] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split(
      ""
    );
  for (a = 0; a != t[200].length; ++a)
    if (t[200][a].charCodeAt(0) !== 65533) {
      r[t[200][a]] = 51200 + a;
      e[51200 + a] = t[200][a];
    }
  t[201] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split(
      ""
    );
  for (a = 0; a != t[201].length; ++a)
    if (t[201][a].charCodeAt(0) !== 65533) {
      r[t[201][a]] = 51456 + a;
      e[51456 + a] = t[201][a];
    }
  t[202] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split(
      ""
    );
  for (a = 0; a != t[202].length; ++a)
    if (t[202][a].charCodeAt(0) !== 65533) {
      r[t[202][a]] = 51712 + a;
      e[51712 + a] = t[202][a];
    }
  t[203] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split(
      ""
    );
  for (a = 0; a != t[203].length; ++a)
    if (t[203][a].charCodeAt(0) !== 65533) {
      r[t[203][a]] = 51968 + a;
      e[51968 + a] = t[203][a];
    }
  t[204] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split(
      ""
    );
  for (a = 0; a != t[204].length; ++a)
    if (t[204][a].charCodeAt(0) !== 65533) {
      r[t[204][a]] = 52224 + a;
      e[52224 + a] = t[204][a];
    }
  t[205] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split(
      ""
    );
  for (a = 0; a != t[205].length; ++a)
    if (t[205][a].charCodeAt(0) !== 65533) {
      r[t[205][a]] = 52480 + a;
      e[52480 + a] = t[205][a];
    }
  t[206] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split(
      ""
    );
  for (a = 0; a != t[206].length; ++a)
    if (t[206][a].charCodeAt(0) !== 65533) {
      r[t[206][a]] = 52736 + a;
      e[52736 + a] = t[206][a];
    }
  t[207] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split(
      ""
    );
  for (a = 0; a != t[207].length; ++a)
    if (t[207][a].charCodeAt(0) !== 65533) {
      r[t[207][a]] = 52992 + a;
      e[52992 + a] = t[207][a];
    }
  t[208] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split(
      ""
    );
  for (a = 0; a != t[208].length; ++a)
    if (t[208][a].charCodeAt(0) !== 65533) {
      r[t[208][a]] = 53248 + a;
      e[53248 + a] = t[208][a];
    }
  t[209] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split(
      ""
    );
  for (a = 0; a != t[209].length; ++a)
    if (t[209][a].charCodeAt(0) !== 65533) {
      r[t[209][a]] = 53504 + a;
      e[53504 + a] = t[209][a];
    }
  t[210] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split(
      ""
    );
  for (a = 0; a != t[210].length; ++a)
    if (t[210][a].charCodeAt(0) !== 65533) {
      r[t[210][a]] = 53760 + a;
      e[53760 + a] = t[210][a];
    }
  t[211] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split(
      ""
    );
  for (a = 0; a != t[211].length; ++a)
    if (t[211][a].charCodeAt(0) !== 65533) {
      r[t[211][a]] = 54016 + a;
      e[54016 + a] = t[211][a];
    }
  t[212] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split(
      ""
    );
  for (a = 0; a != t[212].length; ++a)
    if (t[212][a].charCodeAt(0) !== 65533) {
      r[t[212][a]] = 54272 + a;
      e[54272 + a] = t[212][a];
    }
  t[213] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split(
      ""
    );
  for (a = 0; a != t[213].length; ++a)
    if (t[213][a].charCodeAt(0) !== 65533) {
      r[t[213][a]] = 54528 + a;
      e[54528 + a] = t[213][a];
    }
  t[214] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split(
      ""
    );
  for (a = 0; a != t[214].length; ++a)
    if (t[214][a].charCodeAt(0) !== 65533) {
      r[t[214][a]] = 54784 + a;
      e[54784 + a] = t[214][a];
    }
  t[215] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split(
      ""
    );
  for (a = 0; a != t[215].length; ++a)
    if (t[215][a].charCodeAt(0) !== 65533) {
      r[t[215][a]] = 55040 + a;
      e[55040 + a] = t[215][a];
    }
  t[216] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split(
      ""
    );
  for (a = 0; a != t[216].length; ++a)
    if (t[216][a].charCodeAt(0) !== 65533) {
      r[t[216][a]] = 55296 + a;
      e[55296 + a] = t[216][a];
    }
  t[217] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split(
      ""
    );
  for (a = 0; a != t[217].length; ++a)
    if (t[217][a].charCodeAt(0) !== 65533) {
      r[t[217][a]] = 55552 + a;
      e[55552 + a] = t[217][a];
    }
  t[218] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split(
      ""
    );
  for (a = 0; a != t[218].length; ++a)
    if (t[218][a].charCodeAt(0) !== 65533) {
      r[t[218][a]] = 55808 + a;
      e[55808 + a] = t[218][a];
    }
  t[219] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split(
      ""
    );
  for (a = 0; a != t[219].length; ++a)
    if (t[219][a].charCodeAt(0) !== 65533) {
      r[t[219][a]] = 56064 + a;
      e[56064 + a] = t[219][a];
    }
  t[220] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split(
      ""
    );
  for (a = 0; a != t[220].length; ++a)
    if (t[220][a].charCodeAt(0) !== 65533) {
      r[t[220][a]] = 56320 + a;
      e[56320 + a] = t[220][a];
    }
  t[221] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split(
      ""
    );
  for (a = 0; a != t[221].length; ++a)
    if (t[221][a].charCodeAt(0) !== 65533) {
      r[t[221][a]] = 56576 + a;
      e[56576 + a] = t[221][a];
    }
  t[222] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split(
      ""
    );
  for (a = 0; a != t[222].length; ++a)
    if (t[222][a].charCodeAt(0) !== 65533) {
      r[t[222][a]] = 56832 + a;
      e[56832 + a] = t[222][a];
    }
  t[223] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split(
      ""
    );
  for (a = 0; a != t[223].length; ++a)
    if (t[223][a].charCodeAt(0) !== 65533) {
      r[t[223][a]] = 57088 + a;
      e[57088 + a] = t[223][a];
    }
  t[224] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split(
      ""
    );
  for (a = 0; a != t[224].length; ++a)
    if (t[224][a].charCodeAt(0) !== 65533) {
      r[t[224][a]] = 57344 + a;
      e[57344 + a] = t[224][a];
    }
  t[225] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split(
      ""
    );
  for (a = 0; a != t[225].length; ++a)
    if (t[225][a].charCodeAt(0) !== 65533) {
      r[t[225][a]] = 57600 + a;
      e[57600 + a] = t[225][a];
    }
  t[226] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split(
      ""
    );
  for (a = 0; a != t[226].length; ++a)
    if (t[226][a].charCodeAt(0) !== 65533) {
      r[t[226][a]] = 57856 + a;
      e[57856 + a] = t[226][a];
    }
  t[227] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split(
      ""
    );
  for (a = 0; a != t[227].length; ++a)
    if (t[227][a].charCodeAt(0) !== 65533) {
      r[t[227][a]] = 58112 + a;
      e[58112 + a] = t[227][a];
    }
  t[228] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split(
      ""
    );
  for (a = 0; a != t[228].length; ++a)
    if (t[228][a].charCodeAt(0) !== 65533) {
      r[t[228][a]] = 58368 + a;
      e[58368 + a] = t[228][a];
    }
  t[229] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split(
      ""
    );
  for (a = 0; a != t[229].length; ++a)
    if (t[229][a].charCodeAt(0) !== 65533) {
      r[t[229][a]] = 58624 + a;
      e[58624 + a] = t[229][a];
    }
  t[230] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split(
      ""
    );
  for (a = 0; a != t[230].length; ++a)
    if (t[230][a].charCodeAt(0) !== 65533) {
      r[t[230][a]] = 58880 + a;
      e[58880 + a] = t[230][a];
    }
  t[231] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split(
      ""
    );
  for (a = 0; a != t[231].length; ++a)
    if (t[231][a].charCodeAt(0) !== 65533) {
      r[t[231][a]] = 59136 + a;
      e[59136 + a] = t[231][a];
    }
  t[232] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split(
      ""
    );
  for (a = 0; a != t[232].length; ++a)
    if (t[232][a].charCodeAt(0) !== 65533) {
      r[t[232][a]] = 59392 + a;
      e[59392 + a] = t[232][a];
    }
  t[233] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split(
      ""
    );
  for (a = 0; a != t[233].length; ++a)
    if (t[233][a].charCodeAt(0) !== 65533) {
      r[t[233][a]] = 59648 + a;
      e[59648 + a] = t[233][a];
    }
  t[234] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split(
      ""
    );
  for (a = 0; a != t[234].length; ++a)
    if (t[234][a].charCodeAt(0) !== 65533) {
      r[t[234][a]] = 59904 + a;
      e[59904 + a] = t[234][a];
    }
  t[235] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split(
      ""
    );
  for (a = 0; a != t[235].length; ++a)
    if (t[235][a].charCodeAt(0) !== 65533) {
      r[t[235][a]] = 60160 + a;
      e[60160 + a] = t[235][a];
    }
  t[236] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split(
      ""
    );
  for (a = 0; a != t[236].length; ++a)
    if (t[236][a].charCodeAt(0) !== 65533) {
      r[t[236][a]] = 60416 + a;
      e[60416 + a] = t[236][a];
    }
  t[237] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split(
      ""
    );
  for (a = 0; a != t[237].length; ++a)
    if (t[237][a].charCodeAt(0) !== 65533) {
      r[t[237][a]] = 60672 + a;
      e[60672 + a] = t[237][a];
    }
  t[238] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split(
      ""
    );
  for (a = 0; a != t[238].length; ++a)
    if (t[238][a].charCodeAt(0) !== 65533) {
      r[t[238][a]] = 60928 + a;
      e[60928 + a] = t[238][a];
    }
  t[239] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split(
      ""
    );
  for (a = 0; a != t[239].length; ++a)
    if (t[239][a].charCodeAt(0) !== 65533) {
      r[t[239][a]] = 61184 + a;
      e[61184 + a] = t[239][a];
    }
  t[240] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split(
      ""
    );
  for (a = 0; a != t[240].length; ++a)
    if (t[240][a].charCodeAt(0) !== 65533) {
      r[t[240][a]] = 61440 + a;
      e[61440 + a] = t[240][a];
    }
  t[241] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split(
      ""
    );
  for (a = 0; a != t[241].length; ++a)
    if (t[241][a].charCodeAt(0) !== 65533) {
      r[t[241][a]] = 61696 + a;
      e[61696 + a] = t[241][a];
    }
  t[242] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split(
      ""
    );
  for (a = 0; a != t[242].length; ++a)
    if (t[242][a].charCodeAt(0) !== 65533) {
      r[t[242][a]] = 61952 + a;
      e[61952 + a] = t[242][a];
    }
  t[243] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split(
      ""
    );
  for (a = 0; a != t[243].length; ++a)
    if (t[243][a].charCodeAt(0) !== 65533) {
      r[t[243][a]] = 62208 + a;
      e[62208 + a] = t[243][a];
    }
  t[244] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split(
      ""
    );
  for (a = 0; a != t[244].length; ++a)
    if (t[244][a].charCodeAt(0) !== 65533) {
      r[t[244][a]] = 62464 + a;
      e[62464 + a] = t[244][a];
    }
  t[245] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split(
      ""
    );
  for (a = 0; a != t[245].length; ++a)
    if (t[245][a].charCodeAt(0) !== 65533) {
      r[t[245][a]] = 62720 + a;
      e[62720 + a] = t[245][a];
    }
  t[246] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split(
      ""
    );
  for (a = 0; a != t[246].length; ++a)
    if (t[246][a].charCodeAt(0) !== 65533) {
      r[t[246][a]] = 62976 + a;
      e[62976 + a] = t[246][a];
    }
  t[247] =
    "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split(
      ""
    );
  for (a = 0; a != t[247].length; ++a)
    if (t[247][a].charCodeAt(0) !== 65533) {
      r[t[247][a]] = 63232 + a;
      e[63232 + a] = t[247][a];
    }
  return { enc: r, dec: e };
})();
cptable[10029] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[10079] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
cptable[10081] = (function () {
  var e =
      "\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ",
    r = [],
    t = {};
  for (var a = 0; a != e.length; ++a) {
    if (e.charCodeAt(a) !== 65533) t[e.charAt(a)] = a;
    r[a] = e.charAt(a);
  }
  return { enc: t, dec: r };
})();
if (typeof module !== "undefined" && module.exports) module.exports = cptable;
(function (e, r) {
  "use strict";
  if (typeof cptable === "undefined") {
    if (typeof require !== "undefined") {
      var t = cptable;
      if (typeof module !== "undefined" && module.exports)
        module.exports = r(t);
      else e.cptable = r(t);
    } else throw new Error("cptable not found");
  } else cptable = r(cptable);
})(this, function (e) {
  "use strict";
  var r = {
    1200: "utf16le",
    1201: "utf16be",
    12000: "utf32le",
    12001: "utf32be",
    16969: "utf64le",
    20127: "ascii",
    65000: "utf7",
    65001: "utf8",
  };
  var t = [874, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1e4];
  var a = [932, 936, 949, 950];
  var n = [65001];
  var i = {};
  var s = {};
  var f = {};
  var o = {};
  var l = function R(e) {
    return String.fromCharCode(e);
  };
  var c = function D(e) {
    return e.charCodeAt(0);
  };
  var h = typeof Buffer !== "undefined";
  if (h) {
    var u = 1024,
      d = new Buffer(u);
    var v = function O(e) {
      var r = new Buffer(65536);
      for (var t = 0; t < 65536; ++t) r[t] = 0;
      var a = Object.keys(e),
        n = a.length;
      for (var i = 0, s = a[i]; i < n; ++i) {
        if (!(s = a[i])) continue;
        r[s.charCodeAt(0)] = e[s];
      }
      return r;
    };
    var p = function F(r) {
      var t = v(e[r].enc);
      return function a(e, r) {
        var a = e.length;
        var n,
          i = 0,
          s = 0,
          f = 0,
          o = 0;
        if (typeof e === "string") {
          n = new Buffer(a);
          for (i = 0; i < a; ++i) n[i] = t[e.charCodeAt(i)];
        } else if (Buffer.isBuffer(e)) {
          n = new Buffer(2 * a);
          s = 0;
          for (i = 0; i < a; ++i) {
            f = e[i];
            if (f < 128) n[s++] = t[f];
            else if (f < 224) {
              n[s++] = t[((f & 31) << 6) + (e[i + 1] & 63)];
              ++i;
            } else if (f < 240) {
              n[s++] =
                t[((f & 15) << 12) + ((e[i + 1] & 63) << 6) + (e[i + 2] & 63)];
              i += 2;
            } else {
              o =
                ((f & 7) << 18) +
                ((e[i + 1] & 63) << 12) +
                ((e[i + 2] & 63) << 6) +
                (e[i + 3] & 63);
              i += 3;
              if (o < 65536) n[s++] = t[o];
              else {
                o -= 65536;
                n[s++] = t[55296 + ((o >> 10) & 1023)];
                n[s++] = t[56320 + (o & 1023)];
              }
            }
          }
          n = n.slice(0, s);
        } else {
          n = new Buffer(a);
          for (i = 0; i < a; ++i) n[i] = t[e[i].charCodeAt(0)];
        }
        if (!r || r === "buf") return n;
        if (r !== "arr") return n.toString("binary");
        return [].slice.call(n);
      };
    };
    var g = function P(r) {
      var t = e[r].dec;
      var a = new Buffer(131072),
        n = 0,
        i = "";
      for (n = 0; n < t.length; ++n) {
        if (!(i = t[n])) continue;
        var s = i.charCodeAt(0);
        a[2 * n] = s & 255;
        a[2 * n + 1] = s >> 8;
      }
      return function f(e) {
        var r = e.length,
          t = 0,
          n = 0;
        if (2 * r > u) {
          u = 2 * r;
          d = new Buffer(u);
        }
        if (Buffer.isBuffer(e)) {
          for (t = 0; t < r; t++) {
            n = 2 * e[t];
            d[2 * t] = a[n];
            d[2 * t + 1] = a[n + 1];
          }
        } else if (typeof e === "string") {
          for (t = 0; t < r; t++) {
            n = 2 * e.charCodeAt(t);
            d[2 * t] = a[n];
            d[2 * t + 1] = a[n + 1];
          }
        } else {
          for (t = 0; t < r; t++) {
            n = 2 * e[t];
            d[2 * t] = a[n];
            d[2 * t + 1] = a[n + 1];
          }
        }
        return d.slice(0, 2 * r).toString("ucs2");
      };
    };
    var b = function N(r) {
      var t = e[r].enc;
      var a = new Buffer(131072);
      for (var n = 0; n < 131072; ++n) a[n] = 0;
      var i = Object.keys(t);
      for (var s = 0, f = i[s]; s < i.length; ++s) {
        if (!(f = i[s])) continue;
        var o = f.charCodeAt(0);
        a[2 * o] = t[f] & 255;
        a[2 * o + 1] = t[f] >> 8;
      }
      return function l(e, r) {
        var t = e.length,
          n = new Buffer(2 * t),
          i = 0,
          s = 0,
          f = 0,
          o = 0,
          l = 0;
        if (typeof e === "string") {
          for (i = o = 0; i < t; ++i) {
            s = e.charCodeAt(i) * 2;
            n[o++] = a[s + 1] || a[s];
            if (a[s + 1] > 0) n[o++] = a[s];
          }
          n = n.slice(0, o);
        } else if (Buffer.isBuffer(e)) {
          for (i = o = 0; i < t; ++i) {
            l = e[i];
            if (l < 128) s = l;
            else if (l < 224) {
              s = ((l & 31) << 6) + (e[i + 1] & 63);
              ++i;
            } else if (l < 240) {
              s = ((l & 15) << 12) + ((e[i + 1] & 63) << 6) + (e[i + 2] & 63);
              i += 2;
            } else {
              s =
                ((l & 7) << 18) +
                ((e[i + 1] & 63) << 12) +
                ((e[i + 2] & 63) << 6) +
                (e[i + 3] & 63);
              i += 3;
            }
            if (s < 65536) {
              s *= 2;
              n[o++] = a[s + 1] || a[s];
              if (a[s + 1] > 0) n[o++] = a[s];
            } else {
              f = s - 65536;
              s = 2 * (55296 + ((f >> 10) & 1023));
              n[o++] = a[s + 1] || a[s];
              if (a[s + 1] > 0) n[o++] = a[s];
              s = 2 * (56320 + (f & 1023));
              n[o++] = a[s + 1] || a[s];
              if (a[s + 1] > 0) n[o++] = a[s];
            }
          }
          n = n.slice(0, o);
        } else {
          for (i = o = 0; i < t; i++) {
            s = e[i].charCodeAt(0) * 2;
            n[o++] = a[s + 1] || a[s];
            if (a[s + 1] > 0) n[o++] = a[s];
          }
        }
        if (!r || r === "buf") return n;
        if (r !== "arr") return n.toString("binary");
        return [].slice.call(n);
      };
    };
    var m = function L(r) {
      var t = e[r].dec;
      var a = new Buffer(131072),
        n = 0,
        i,
        s = 0,
        f = 0,
        o = 0;
      for (o = 0; o < 65536; ++o) {
        a[2 * o] = 255;
        a[2 * o + 1] = 253;
      }
      for (n = 0; n < t.length; ++n) {
        if (!(i = t[n])) continue;
        s = i.charCodeAt(0);
        f = 2 * n;
        a[f] = s & 255;
        a[f + 1] = s >> 8;
      }
      return function l(e) {
        var r = e.length,
          t = new Buffer(2 * r),
          n = 0,
          i = 0,
          s = 0;
        if (Buffer.isBuffer(e)) {
          for (n = 0; n < r; n++) {
            i = 2 * e[n];
            if (a[i] === 255 && a[i + 1] === 253) {
              i = 2 * ((e[n] << 8) + e[n + 1]);
              ++n;
            }
            t[s++] = a[i];
            t[s++] = a[i + 1];
          }
        } else if (typeof e === "string") {
          for (n = 0; n < r; n++) {
            i = 2 * e.charCodeAt(n);
            if (a[i] === 255 && a[i + 1] === 253) {
              i = 2 * ((e.charCodeAt(n) << 8) + e.charCodeAt(n + 1));
              ++n;
            }
            t[s++] = a[i];
            t[s++] = a[i + 1];
          }
        } else {
          for (n = 0; n < r; n++) {
            i = 2 * e[n];
            if (a[i] === 255 && a[i + 1] === 253) {
              i = 2 * ((e[n] << 8) + e[n + 1]);
              ++n;
            }
            t[s++] = a[i];
            t[s++] = a[i + 1];
          }
        }
        return t.slice(0, s).toString("ucs2");
      };
    };
    i[65001] = function M(e) {
      if (typeof e === "string") return M(e.split("").map(c));
      var r = e.length,
        t = 0,
        a = 0;
      if (4 * r > u) {
        u = 4 * r;
        d = new Buffer(u);
      }
      var n = 0;
      if (r >= 3 && e[0] == 239) if (e[1] == 187 && e[2] == 191) n = 3;
      for (var i = 1, s = 0, f = 0; n < r; n += i) {
        i = 1;
        f = e[n];
        if (f < 128) t = f;
        else if (f < 224) {
          t = (f & 31) * 64 + (e[n + 1] & 63);
          i = 2;
        } else if (f < 240) {
          t = ((f & 15) << 12) + (e[n + 1] & 63) * 64 + (e[n + 2] & 63);
          i = 3;
        } else {
          t =
            (f & 7) * 262144 +
            ((e[n + 1] & 63) << 12) +
            (e[n + 2] & 63) * 64 +
            (e[n + 3] & 63);
          i = 4;
        }
        if (t < 65536) {
          d[s++] = t & 255;
          d[s++] = t >> 8;
        } else {
          t -= 65536;
          a = 55296 + ((t >> 10) & 1023);
          t = 56320 + (t & 1023);
          d[s++] = a & 255;
          d[s++] = a >>> 8;
          d[s++] = t & 255;
          d[s++] = (t >>> 8) & 255;
        }
      }
      return d.slice(0, s).toString("ucs2");
    };
    s[65001] = function U(e, r) {
      if (h && Buffer.isBuffer(e)) {
        if (!r || r === "buf") return e;
        if (r !== "arr") return e.toString("binary");
        return [].slice.call(e);
      }
      var t = e.length,
        a = 0,
        n = 0,
        i = 0;
      var s = typeof e === "string";
      if (4 * t > u) {
        u = 4 * t;
        d = new Buffer(u);
      }
      for (var f = 0; f < t; ++f) {
        a = s ? e.charCodeAt(f) : e[f].charCodeAt(0);
        if (a <= 127) d[i++] = a;
        else if (a <= 2047) {
          d[i++] = 192 + (a >> 6);
          d[i++] = 128 + (a & 63);
        } else if (a >= 55296 && a <= 57343) {
          a -= 55296;
          ++f;
          n = (s ? e.charCodeAt(f) : e[f].charCodeAt(0)) - 56320 + (a << 10);
          d[i++] = 240 + ((n >>> 18) & 7);
          d[i++] = 144 + ((n >>> 12) & 63);
          d[i++] = 128 + ((n >>> 6) & 63);
          d[i++] = 128 + (n & 63);
        } else {
          d[i++] = 224 + (a >> 12);
          d[i++] = 128 + ((a >> 6) & 63);
          d[i++] = 128 + (a & 63);
        }
      }
      if (!r || r === "buf") return d.slice(0, i);
      if (r !== "arr") return d.slice(0, i).toString("binary");
      return [].slice.call(d, 0, i);
    };
  }
  var C = function H() {
    if (h) {
      if (f[t[0]]) return;
      var r = 0,
        l = 0;
      for (r = 0; r < t.length; ++r) {
        l = t[r];
        if (e[l]) {
          f[l] = g(l);
          o[l] = p(l);
        }
      }
      for (r = 0; r < a.length; ++r) {
        l = a[r];
        if (e[l]) {
          f[l] = m(l);
          o[l] = b(l);
        }
      }
      for (r = 0; r < n.length; ++r) {
        l = n[r];
        if (i[l]) f[l] = i[l];
        if (s[l]) o[l] = s[l];
      }
    }
  };
  var E = function (e, r) {
    return "";
  };
  var k = function W(e) {
    delete f[e];
    delete o[e];
  };
  var S = function V() {
    if (h) {
      if (!f[t[0]]) return;
      t.forEach(k);
      a.forEach(k);
      n.forEach(k);
    }
    _ = E;
    T = 0;
  };
  var w = { encache: C, decache: S, sbcs: t, dbcs: a };
  C();
  var A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var B =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
  var _ = E,
    T = 0;
  var x = function z(t, a, n) {
    if (t === T && _) {
      return _(a, n);
    }
    if (o[t]) {
      _ = o[(T = t)];
      return _(a, n);
    }
    if (h && Buffer.isBuffer(a)) a = a.toString("utf8");
    var i = a.length;
    var s = h ? new Buffer(4 * i) : [],
      f = 0,
      c = 0,
      u = 0,
      d = 0;
    var v = e[t],
      p,
      g = "";
    var b = typeof a === "string";
    if (v && (p = v.enc))
      for (c = 0; c < i; ++c, ++u) {
        f = p[b ? a.charAt(c) : a[c]];
        if (f > 255) {
          s[u] = f >> 8;
          s[++u] = f & 255;
        } else s[u] = f & 255;
      }
    else if ((g = r[t]))
      switch (g) {
        case "utf8":
          if (h && b) {
            s = new Buffer(a, g);
            u = s.length;
            break;
          }
          for (c = 0; c < i; ++c, ++u) {
            f = b ? a.charCodeAt(c) : a[c].charCodeAt(0);
            if (f <= 127) s[u] = f;
            else if (f <= 2047) {
              s[u] = 192 + (f >> 6);
              s[++u] = 128 + (f & 63);
            } else if (f >= 55296 && f <= 57343) {
              f -= 55296;
              d =
                (b ? a.charCodeAt(++c) : a[++c].charCodeAt(0)) -
                56320 +
                (f << 10);
              s[u] = 240 + ((d >>> 18) & 7);
              s[++u] = 144 + ((d >>> 12) & 63);
              s[++u] = 128 + ((d >>> 6) & 63);
              s[++u] = 128 + (d & 63);
            } else {
              s[u] = 224 + (f >> 12);
              s[++u] = 128 + ((f >> 6) & 63);
              s[++u] = 128 + (f & 63);
            }
          }
          break;
        case "ascii":
          if (h && typeof a === "string") {
            s = new Buffer(a, g);
            u = s.length;
            break;
          }
          for (c = 0; c < i; ++c, ++u) {
            f = b ? a.charCodeAt(c) : a[c].charCodeAt(0);
            if (f <= 127) s[u] = f;
            else throw new Error("bad ascii " + f);
          }
          break;
        case "utf16le":
          if (h && typeof a === "string") {
            s = new Buffer(a, g);
            u = s.length;
            break;
          }
          for (c = 0; c < i; ++c) {
            f = b ? a.charCodeAt(c) : a[c].charCodeAt(0);
            s[u++] = f & 255;
            s[u++] = f >> 8;
          }
          break;
        case "utf16be":
          for (c = 0; c < i; ++c) {
            f = b ? a.charCodeAt(c) : a[c].charCodeAt(0);
            s[u++] = f >> 8;
            s[u++] = f & 255;
          }
          break;
        case "utf32le":
          for (c = 0; c < i; ++c) {
            f = b ? a.charCodeAt(c) : a[c].charCodeAt(0);
            if (f >= 55296 && f <= 57343)
              f = 65536 + ((f - 55296) << 10) + (a[++c].charCodeAt(0) - 56320);
            s[u++] = f & 255;
            f >>= 8;
            s[u++] = f & 255;
            f >>= 8;
            s[u++] = f & 255;
            f >>= 8;
            s[u++] = f & 255;
          }
          break;
        case "utf32be":
          for (c = 0; c < i; ++c) {
            f = b ? a.charCodeAt(c) : a[c].charCodeAt(0);
            if (f >= 55296 && f <= 57343)
              f = 65536 + ((f - 55296) << 10) + (a[++c].charCodeAt(0) - 56320);
            s[u + 3] = f & 255;
            f >>= 8;
            s[u + 2] = f & 255;
            f >>= 8;
            s[u + 1] = f & 255;
            f >>= 8;
            s[u] = f & 255;
            u += 4;
          }
          break;
        case "utf7":
          for (c = 0; c < i; c++) {
            var m = b ? a.charAt(c) : a[c].charAt(0);
            if (m === "+") {
              s[u++] = 43;
              s[u++] = 45;
              continue;
            }
            if (B.indexOf(m) > -1) {
              s[u++] = m.charCodeAt(0);
              continue;
            }
            var C = z(1201, m);
            s[u++] = 43;
            s[u++] = A.charCodeAt(C[0] >> 2);
            s[u++] = A.charCodeAt(((C[0] & 3) << 4) + ((C[1] || 0) >> 4));
            s[u++] = A.charCodeAt(((C[1] & 15) << 2) + ((C[2] || 0) >> 6));
            s[u++] = 45;
          }
          break;
        default:
          throw new Error("Unsupported magic: " + t + " " + r[t]);
      }
    else throw new Error("Unrecognized CP: " + t);
    s = s.slice(0, u);
    if (!h) return n == "str" ? s.map(l).join("") : s;
    if (!n || n === "buf") return s;
    if (n !== "arr") return s.toString("binary");
    return [].slice.call(s);
  };
  var I = function X(t, a) {
    var n;
    if ((n = f[t])) return n(a);
    if (typeof a === "string") return X(t, a.split("").map(c));
    var i = a.length,
      s = new Array(i),
      o = "",
      l = 0,
      u = 0,
      d = 1,
      v = 0,
      p = 0;
    var g = e[t],
      b,
      m = "";
    if (g && (b = g.dec)) {
      for (u = 0; u < i; u += d) {
        d = 2;
        o = b[(a[u] << 8) + a[u + 1]];
        if (!o) {
          d = 1;
          o = b[a[u]];
        }
        if (!o)
          throw new Error(
            "Unrecognized code: " +
              a[u] +
              " " +
              a[u + d - 1] +
              " " +
              u +
              " " +
              d +
              " " +
              b[a[u]]
          );
        s[v++] = o;
      }
    } else if ((m = r[t]))
      switch (m) {
        case "utf8":
          if (i >= 3 && a[0] == 239) if (a[1] == 187 && a[2] == 191) u = 3;
          for (; u < i; u += d) {
            d = 1;
            if (a[u] < 128) l = a[u];
            else if (a[u] < 224) {
              l = (a[u] & 31) * 64 + (a[u + 1] & 63);
              d = 2;
            } else if (a[u] < 240) {
              l = ((a[u] & 15) << 12) + (a[u + 1] & 63) * 64 + (a[u + 2] & 63);
              d = 3;
            } else {
              l =
                (a[u] & 7) * 262144 +
                ((a[u + 1] & 63) << 12) +
                (a[u + 2] & 63) * 64 +
                (a[u + 3] & 63);
              d = 4;
            }
            if (l < 65536) {
              s[v++] = String.fromCharCode(l);
            } else {
              l -= 65536;
              p = 55296 + ((l >> 10) & 1023);
              l = 56320 + (l & 1023);
              s[v++] = String.fromCharCode(p);
              s[v++] = String.fromCharCode(l);
            }
          }
          break;
        case "ascii":
          if (h && Buffer.isBuffer(a)) return a.toString(m);
          for (u = 0; u < i; u++) s[u] = String.fromCharCode(a[u]);
          v = i;
          break;
        case "utf16le":
          if (i >= 2 && a[0] == 255) if (a[1] == 254) u = 2;
          if (h && Buffer.isBuffer(a)) return a.toString(m);
          d = 2;
          for (; u + 1 < i; u += d) {
            s[v++] = String.fromCharCode((a[u + 1] << 8) + a[u]);
          }
          break;
        case "utf16be":
          if (i >= 2 && a[0] == 254) if (a[1] == 255) u = 2;
          d = 2;
          for (; u + 1 < i; u += d) {
            s[v++] = String.fromCharCode((a[u] << 8) + a[u + 1]);
          }
          break;
        case "utf32le":
          if (i >= 4 && a[0] == 255)
            if (a[1] == 254 && a[2] === 0 && a[3] === 0) u = 4;
          d = 4;
          for (; u < i; u += d) {
            l = (a[u + 3] << 24) + (a[u + 2] << 16) + (a[u + 1] << 8) + a[u];
            if (l > 65535) {
              l -= 65536;
              s[v++] = String.fromCharCode(55296 + ((l >> 10) & 1023));
              s[v++] = String.fromCharCode(56320 + (l & 1023));
            } else s[v++] = String.fromCharCode(l);
          }
          break;
        case "utf32be":
          if (i >= 4 && a[3] == 255)
            if (a[2] == 254 && a[1] === 0 && a[0] === 0) u = 4;
          d = 4;
          for (; u < i; u += d) {
            l = (a[u] << 24) + (a[u + 1] << 16) + (a[u + 2] << 8) + a[u + 3];
            if (l > 65535) {
              l -= 65536;
              s[v++] = String.fromCharCode(55296 + ((l >> 10) & 1023));
              s[v++] = String.fromCharCode(56320 + (l & 1023));
            } else s[v++] = String.fromCharCode(l);
          }
          break;
        case "utf7":
          if (i >= 4 && a[0] == 43 && a[1] == 47 && a[2] == 118) {
            if (i >= 5 && a[3] == 56 && a[4] == 45) u = 5;
            else if (a[3] == 56 || a[3] == 57 || a[3] == 43 || a[3] == 47)
              u = 4;
          }
          for (; u < i; u += d) {
            if (a[u] !== 43) {
              d = 1;
              s[v++] = String.fromCharCode(a[u]);
              continue;
            }
            d = 1;
            if (a[u + 1] === 45) {
              d = 2;
              s[v++] = "+";
              continue;
            }
            while (String.fromCharCode(a[u + d]).match(/[A-Za-z0-9+\/]/)) d++;
            var C = 0;
            if (a[u + d] === 45) {
              ++d;
              C = 1;
            }
            var E = [];
            var k = "";
            var S = 0,
              w = 0,
              B = 0;
            var _ = 0,
              T = 0,
              x = 0,
              I = 0;
            for (var y = 1; y < d - C; ) {
              _ = A.indexOf(String.fromCharCode(a[u + y++]));
              T = A.indexOf(String.fromCharCode(a[u + y++]));
              S = (_ << 2) | (T >> 4);
              E.push(S);
              x = A.indexOf(String.fromCharCode(a[u + y++]));
              if (x === -1) break;
              w = ((T & 15) << 4) | (x >> 2);
              E.push(w);
              I = A.indexOf(String.fromCharCode(a[u + y++]));
              if (I === -1) break;
              B = ((x & 3) << 6) | I;
              if (I < 64) E.push(B);
            }
            k = X(1201, E);
            for (y = 0; y < k.length; ++y) s[v++] = k.charAt(y);
          }
          break;
        default:
          throw new Error("Unsupported magic: " + t + " " + r[t]);
      }
    else throw new Error("Unrecognized CP: " + t);
    return s.slice(0, v).join("");
  };
  var y = function G(t) {
    return !!(e[t] || r[t]);
  };
  e.utils = { decode: I, encode: x, hascp: y, magic: r, cache: w };
  return e;
});
var XLSX = {};
(function e(r) {
  r.version = "0.11.0";
  var t = 1200;
  if (typeof module !== "undefined" && typeof require !== "undefined") {
    if (typeof cptable === "undefined") global.cptable = null;
  }
  function a() {
    n(1200);
  }
  var n = function (e) {
    t = e;
  };
  function i(e) {
    var r = [];
    for (var t = 0, a = e.length; t < a; ++t) r[t] = e.charCodeAt(t);
    return r;
  }
  function s(e) {
    var r = [];
    for (var t = 0; t < e.length >> 1; ++t)
      r[t] = String.fromCharCode(
        e.charCodeAt(2 * t) + (e.charCodeAt(2 * t + 1) << 8)
      );
    return r.join("");
  }
  function f(e) {
    var r = [];
    for (var t = 0; t < e.length >> 1; ++t)
      r[t] = String.fromCharCode(
        e.charCodeAt(2 * t + 1) + (e.charCodeAt(2 * t) << 8)
      );
    return r.join("");
  }
  var o = function (e) {
    var r = e.charCodeAt(0),
      t = e.charCodeAt(1);
    if (r == 255 && t == 254) return s(e.substr(2));
    if (r == 254 && t == 255) return f(e.substr(2));
    if (r == 65279) return e.substr(1);
    return e;
  };
  var l = function _E(e) {
    return String.fromCharCode(e);
  };
  if (typeof cptable !== "undefined") {
    n = function (e) {
      t = e;
    };
    o = function (e) {
      if (e.charCodeAt(0) === 255 && e.charCodeAt(1) === 254) {
        return cptable.utils.decode(1200, i(e.substr(2)));
      }
      return e;
    };
    l = function TE(e) {
      if (t === 1200) return String.fromCharCode(e);
      return cptable.utils.decode(t, [e & 255, e >> 8])[0];
    };
  }
  var c = null;
  var h = true;
  var u = (function xE() {
    var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    return {
      encode: function (r) {
        var t = "";
        var a, n, i, s, f, o, l;
        for (var c = 0; c < r.length; ) {
          a = r.charCodeAt(c++);
          n = r.charCodeAt(c++);
          i = r.charCodeAt(c++);
          s = a >> 2;
          f = ((a & 3) << 4) | (n >> 4);
          o = ((n & 15) << 2) | (i >> 6);
          l = i & 63;
          if (isNaN(n)) {
            o = l = 64;
          } else if (isNaN(i)) {
            l = 64;
          }
          t += e.charAt(s) + e.charAt(f) + e.charAt(o) + e.charAt(l);
        }
        return t;
      },
      decode: function r(t) {
        var a = "";
        var n, i, s;
        var f, o, l, c;
        t = t.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        for (var h = 0; h < t.length; ) {
          f = e.indexOf(t.charAt(h++));
          o = e.indexOf(t.charAt(h++));
          l = e.indexOf(t.charAt(h++));
          c = e.indexOf(t.charAt(h++));
          n = (f << 2) | (o >> 4);
          i = ((o & 15) << 4) | (l >> 2);
          s = ((l & 3) << 6) | c;
          a += String.fromCharCode(n);
          if (l != 64) {
            a += String.fromCharCode(i);
          }
          if (c != 64) {
            a += String.fromCharCode(s);
          }
        }
        return a;
      },
    };
  })();
  var d =
    typeof Buffer !== "undefined" &&
    typeof process !== "undefined" &&
    typeof process.versions !== "undefined" &&
    process.versions.node;
  function v(e) {
    return new (d ? Buffer : Array)(e);
  }
  function p(e) {
    if (d) return new Buffer(e, "binary");
    return e.split("").map(function (e) {
      return e.charCodeAt(0) & 255;
    });
  }
  var g = function (e) {
    return [].concat.apply([], e);
  };
  var b = /\u0000/g,
    m = /[\u0001-\u0006]/;
  var C = {};
  var E = function IE(e) {
    e.version = "0.10.0";
    function r(e) {
      var r = "",
        t = e.length - 1;
      while (t >= 0) r += e.charAt(t--);
      return r;
    }
    function t(e, r) {
      var t = "";
      while (t.length < r) t += e;
      return t;
    }
    function a(e, r) {
      var a = "" + e;
      return a.length >= r ? a : t("0", r - a.length) + a;
    }
    function n(e, r) {
      var a = "" + e;
      return a.length >= r ? a : t(" ", r - a.length) + a;
    }
    function i(e, r) {
      var a = "" + e;
      return a.length >= r ? a : a + t(" ", r - a.length);
    }
    function s(e, r) {
      var a = "" + Math.round(e);
      return a.length >= r ? a : t("0", r - a.length) + a;
    }
    function f(e, r) {
      var a = "" + e;
      return a.length >= r ? a : t("0", r - a.length) + a;
    }
    var o = Math.pow(2, 32);
    function l(e, r) {
      if (e > o || e < -o) return s(e, r);
      var t = Math.round(e);
      return f(t, r);
    }
    function c(e, r) {
      r = r || 0;
      return (
        e.length >= 7 + r &&
        (e.charCodeAt(r) | 32) === 103 &&
        (e.charCodeAt(r + 1) | 32) === 101 &&
        (e.charCodeAt(r + 2) | 32) === 110 &&
        (e.charCodeAt(r + 3) | 32) === 101 &&
        (e.charCodeAt(r + 4) | 32) === 114 &&
        (e.charCodeAt(r + 5) | 32) === 97 &&
        (e.charCodeAt(r + 6) | 32) === 108
      );
    }
    var h = [
      ["Sun", "Sunday"],
      ["Mon", "Monday"],
      ["Tue", "Tuesday"],
      ["Wed", "Wednesday"],
      ["Thu", "Thursday"],
      ["Fri", "Friday"],
      ["Sat", "Saturday"],
    ];
    var u = [
      ["J", "Jan", "January"],
      ["F", "Feb", "February"],
      ["M", "Mar", "March"],
      ["A", "Apr", "April"],
      ["M", "May", "May"],
      ["J", "Jun", "June"],
      ["J", "Jul", "July"],
      ["A", "Aug", "August"],
      ["S", "Sep", "September"],
      ["O", "Oct", "October"],
      ["N", "Nov", "November"],
      ["D", "Dec", "December"],
    ];
    function d(e) {
      e[0] = "General";
      e[1] = "0";
      e[2] = "0.00";
      e[3] = "#,##0";
      e[4] = "#,##0.00";
      e[9] = "0%";
      e[10] = "0.00%";
      e[11] = "0.00E+00";
      e[12] = "# ?/?";
      e[13] = "# ??/??";
      e[14] = "m/d/yy";
      e[15] = "d-mmm-yy";
      e[16] = "d-mmm";
      e[17] = "mmm-yy";
      e[18] = "h:mm AM/PM";
      e[19] = "h:mm:ss AM/PM";
      e[20] = "h:mm";
      e[21] = "h:mm:ss";
      e[22] = "m/d/yy h:mm";
      e[37] = "#,##0 ;(#,##0)";
      e[38] = "#,##0 ;[Red](#,##0)";
      e[39] = "#,##0.00;(#,##0.00)";
      e[40] = "#,##0.00;[Red](#,##0.00)";
      e[45] = "mm:ss";
      e[46] = "[h]:mm:ss";
      e[47] = "mmss.0";
      e[48] = "##0.0E+0";
      e[49] = "@";
      e[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "';
      e[65535] = "General";
    }
    var v = {};
    d(v);
    function p(e, r, t) {
      var a = e < 0 ? -1 : 1;
      var n = e * a;
      var i = 0,
        s = 1,
        f = 0;
      var o = 1,
        l = 0,
        c = 0;
      var h = Math.floor(n);
      while (l < r) {
        h = Math.floor(n);
        f = h * s + i;
        c = h * l + o;
        if (n - h < 5e-8) break;
        n = 1 / (n - h);
        i = s;
        s = f;
        o = l;
        l = c;
      }
      if (c > r) {
        if (l > r) {
          c = o;
          f = i;
        } else {
          c = l;
          f = s;
        }
      }
      if (!t) return [0, a * f, c];
      var u = Math.floor((a * f) / c);
      return [u, a * f - u * c, c];
    }
    function g(e, r, t) {
      if (e > 2958465 || e < 0) return null;
      var a = e | 0,
        n = Math.floor(86400 * (e - a)),
        i = 0;
      var s = [];
      var f = {
        D: a,
        T: n,
        u: 86400 * (e - a) - n,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0,
      };
      if (Math.abs(f.u) < 1e-6) f.u = 0;
      if (r && r.date1904) a += 1462;
      if (f.u > 0.9999) {
        f.u = 0;
        if (++n == 86400) {
          f.T = n = 0;
          ++a;
          ++f.D;
        }
      }
      if (a === 60) {
        s = t ? [1317, 10, 29] : [1900, 2, 29];
        i = 3;
      } else if (a === 0) {
        s = t ? [1317, 8, 29] : [1900, 1, 0];
        i = 6;
      } else {
        if (a > 60) --a;
        var o = new Date(1900, 0, 1);
        o.setDate(o.getDate() + a - 1);
        s = [o.getFullYear(), o.getMonth() + 1, o.getDate()];
        i = o.getDay();
        if (a < 60) i = (i + 6) % 7;
        if (t) i = A(o, s);
      }
      f.y = s[0];
      f.m = s[1];
      f.d = s[2];
      f.S = n % 60;
      n = Math.floor(n / 60);
      f.M = n % 60;
      n = Math.floor(n / 60);
      f.H = n;
      f.q = i;
      return f;
    }
    e.parse_date_code = g;
    var b = new Date(1899, 11, 31, 0, 0, 0);
    var m = b.getTime();
    var C = new Date(1900, 2, 1, 0, 0, 0);
    function E(e, r) {
      var t = e.getTime();
      if (r) t -= 1461 * 24 * 60 * 60 * 1e3;
      else if (e >= C) t += 24 * 60 * 60 * 1e3;
      return (
        (t - (m + (e.getTimezoneOffset() - b.getTimezoneOffset()) * 6e4)) /
        (24 * 60 * 60 * 1e3)
      );
    }
    function k(e) {
      return e.toString(10);
    }
    e._general_int = k;
    var S = (function M() {
      var e = /\.(\d*[1-9])0+$/,
        r = /\.0*$/,
        t = /\.(\d*[1-9])0+/,
        a = /\.0*[Ee]/,
        n = /(E[+-])(\d)$/;
      function i(e) {
        var r = e < 0 ? 12 : 11;
        var t = o(e.toFixed(12));
        if (t.length <= r) return t;
        t = e.toPrecision(10);
        if (t.length <= r) return t;
        return e.toExponential(5);
      }
      function s(r) {
        var t = r.toFixed(11).replace(e, ".$1");
        if (t.length > (r < 0 ? 12 : 11)) t = r.toPrecision(6);
        return t;
      }
      function f(e) {
        for (var r = 0; r != e.length; ++r)
          if ((e.charCodeAt(r) | 32) === 101)
            return e
              .replace(t, ".$1")
              .replace(a, "E")
              .replace("e", "E")
              .replace(n, "$10$2");
        return e;
      }
      function o(t) {
        return t.indexOf(".") > -1 ? t.replace(r, "").replace(e, ".$1") : t;
      }
      return function l(e) {
        var r = Math.floor(Math.log(Math.abs(e)) * Math.LOG10E),
          t;
        if (r >= -4 && r <= -1) t = e.toPrecision(10 + r);
        else if (Math.abs(r) <= 9) t = i(e);
        else if (r === 10) t = e.toFixed(10).substr(0, 12);
        else t = s(e);
        return o(f(t));
      };
    })();
    e._general_num = S;
    function w(e, r) {
      switch (typeof e) {
        case "string":
          return e;
        case "boolean":
          return e ? "TRUE" : "FALSE";
        case "number":
          return (e | 0) === e ? k(e) : S(e);
        case "undefined":
          return "";
        case "object":
          if (e == null) return "";
          if (e instanceof Date) return N(14, E(e, r && r.date1904), r);
      }
      throw new Error("unsupported value in General format: " + e);
    }
    e._general = w;
    function A() {
      return 0;
    }
    function B(e, r, t, n) {
      var i = "",
        s = 0,
        f = 0,
        o = t.y,
        l,
        c = 0;
      switch (e) {
        case 98:
          o = t.y + 543;
        case 121:
          switch (r.length) {
            case 1:
            case 2:
              l = o % 100;
              c = 2;
              break;
            default:
              l = o % 1e4;
              c = 4;
              break;
          }
          break;
        case 109:
          switch (r.length) {
            case 1:
            case 2:
              l = t.m;
              c = r.length;
              break;
            case 3:
              return u[t.m - 1][1];
            case 5:
              return u[t.m - 1][0];
            default:
              return u[t.m - 1][2];
          }
          break;
        case 100:
          switch (r.length) {
            case 1:
            case 2:
              l = t.d;
              c = r.length;
              break;
            case 3:
              return h[t.q][0];
            default:
              return h[t.q][1];
          }
          break;
        case 104:
          switch (r.length) {
            case 1:
            case 2:
              l = 1 + ((t.H + 11) % 12);
              c = r.length;
              break;
            default:
              throw "bad hour format: " + r;
          }
          break;
        case 72:
          switch (r.length) {
            case 1:
            case 2:
              l = t.H;
              c = r.length;
              break;
            default:
              throw "bad hour format: " + r;
          }
          break;
        case 77:
          switch (r.length) {
            case 1:
            case 2:
              l = t.M;
              c = r.length;
              break;
            default:
              throw "bad minute format: " + r;
          }
          break;
        case 115:
          if (r != "s" && r != "ss" && r != ".0" && r != ".00" && r != ".000")
            throw "bad second format: " + r;
          if (t.u === 0 && (r == "s" || r == "ss")) return a(t.S, r.length);
          if (n >= 2) f = n === 3 ? 1e3 : 100;
          else f = n === 1 ? 10 : 1;
          s = Math.round(f * (t.S + t.u));
          if (s >= 60 * f) s = 0;
          if (r === "s") return s === 0 ? "0" : "" + s / f;
          i = a(s, 2 + n);
          if (r === "ss") return i.substr(0, 2);
          return "." + i.substr(2, r.length - 1);
        case 90:
          switch (r) {
            case "[h]":
            case "[hh]":
              l = t.D * 24 + t.H;
              break;
            case "[m]":
            case "[mm]":
              l = (t.D * 24 + t.H) * 60 + t.M;
              break;
            case "[s]":
            case "[ss]":
              l = ((t.D * 24 + t.H) * 60 + t.M) * 60 + Math.round(t.S + t.u);
              break;
            default:
              throw "bad abstime format: " + r;
          }
          c = r.length === 3 ? 1 : 2;
          break;
        case 101:
          l = o;
          c = 1;
      }
      if (c > 0) return a(l, c);
      else return "";
    }
    function _(e) {
      var r = 3;
      if (e.length <= r) return e;
      var t = e.length % r,
        a = e.substr(0, t);
      for (; t != e.length; t += r)
        a += (a.length > 0 ? "," : "") + e.substr(t, r);
      return a;
    }
    var T = (function U() {
      var e = /%/g;
      function s(r, a, n) {
        var i = a.replace(e, ""),
          s = a.length - i.length;
        return T(r, i, n * Math.pow(10, 2 * s)) + t("%", s);
      }
      function f(e, r, t) {
        var a = r.length - 1;
        while (r.charCodeAt(a - 1) === 44) --a;
        return T(e, r.substr(0, a), t / Math.pow(10, 3 * (r.length - a)));
      }
      function o(e, r) {
        var t;
        var a = e.indexOf("E") - e.indexOf(".") - 1;
        if (e.match(/^#+0.0E\+0$/)) {
          if (r == 0) return "0.0E+0";
          else if (r < 0) return "-" + o(e, -r);
          var n = e.indexOf(".");
          if (n === -1) n = e.indexOf("E");
          var i = Math.floor(Math.log(r) * Math.LOG10E) % n;
          if (i < 0) i += n;
          t = (r / Math.pow(10, i)).toPrecision(a + 1 + ((n + i) % n));
          if (t.indexOf("e") === -1) {
            var s = Math.floor(Math.log(r) * Math.LOG10E);
            if (t.indexOf(".") === -1)
              t = t.charAt(0) + "." + t.substr(1) + "E+" + (s - t.length + i);
            else t += "E+" + (s - i);
            while (t.substr(0, 2) === "0.") {
              t = t.charAt(0) + t.substr(2, n) + "." + t.substr(2 + n);
              t = t.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            t = t.replace(/\+-/, "-");
          }
          t = t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function (e, r, t, a) {
            return r + t + a.substr(0, (n + i) % n) + "." + a.substr(i) + "E";
          });
        } else t = r.toExponential(a);
        if (e.match(/E\+00$/) && t.match(/e[+-]\d$/))
          t = t.substr(0, t.length - 1) + "0" + t.charAt(t.length - 1);
        if (e.match(/E\-/) && t.match(/e\+/)) t = t.replace(/e\+/, "e");
        return t.replace("e", "E");
      }
      var c = /# (\?+)( ?)\/( ?)(\d+)/;
      function h(e, r, i) {
        var s = parseInt(e[4], 10),
          f = Math.round(r * s),
          o = Math.floor(f / s);
        var l = f - o * s,
          c = s;
        return (
          i +
          (o === 0 ? "" : "" + o) +
          " " +
          (l === 0
            ? t(" ", e[1].length + 1 + e[4].length)
            : n(l, e[1].length) + e[2] + "/" + e[3] + a(c, e[4].length))
        );
      }
      function u(e, r, a) {
        return (
          a + (r === 0 ? "" : "" + r) + t(" ", e[1].length + 2 + e[4].length)
        );
      }
      var d = /^#*0*\.([0#]+)/;
      var v = /\).*[0#]/;
      var g = /\(###\) ###\\?-####/;
      function b(e) {
        var r = "",
          t;
        for (var a = 0; a != e.length; ++a)
          switch ((t = e.charCodeAt(a))) {
            case 35:
              break;
            case 63:
              r += " ";
              break;
            case 48:
              r += "0";
              break;
            default:
              r += String.fromCharCode(t);
          }
        return r;
      }
      function m(e, r) {
        var t = Math.pow(10, r);
        return "" + Math.round(e * t) / t;
      }
      function C(e, r) {
        if (
          r < ("" + Math.round((e - Math.floor(e)) * Math.pow(10, r))).length
        ) {
          return 0;
        }
        return Math.round((e - Math.floor(e)) * Math.pow(10, r));
      }
      function E(e, r) {
        if (
          r < ("" + Math.round((e - Math.floor(e)) * Math.pow(10, r))).length
        ) {
          return 1;
        }
        return 0;
      }
      function k(e) {
        if (e < 2147483647 && e > -2147483648)
          return "" + (e >= 0 ? e | 0 : (e - 1) | 0);
        return "" + Math.floor(e);
      }
      function S(e, u, w) {
        if (e.charCodeAt(0) === 40 && !u.match(v)) {
          var A = u.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
          if (w >= 0) return S("n", A, w);
          return "(" + S("n", A, -w) + ")";
        }
        if (u.charCodeAt(u.length - 1) === 44) return f(e, u, w);
        if (u.indexOf("%") !== -1) return s(e, u, w);
        if (u.indexOf("E") !== -1) return o(u, w);
        if (u.charCodeAt(0) === 36)
          return "$" + S(e, u.substr(u.charAt(1) == " " ? 2 : 1), w);
        var B;
        var x,
          I,
          y,
          R = Math.abs(w),
          D = w < 0 ? "-" : "";
        if (u.match(/^00+$/)) return D + l(R, u.length);
        if (u.match(/^[#?]+$/)) {
          B = l(w, 0);
          if (B === "0") B = "";
          return B.length > u.length
            ? B
            : b(u.substr(0, u.length - B.length)) + B;
        }
        if ((x = u.match(c))) return h(x, R, D);
        if (u.match(/^#+0+$/)) return D + l(R, u.length - u.indexOf("0"));
        if ((x = u.match(d))) {
          B = m(w, x[1].length)
            .replace(/^([^\.]+)$/, "$1." + b(x[1]))
            .replace(/\.$/, "." + b(x[1]))
            .replace(/\.(\d*)$/, function (e, r) {
              return "." + r + t("0", b(x[1]).length - r.length);
            });
          return u.indexOf("0.") !== -1 ? B : B.replace(/^0\./, ".");
        }
        u = u.replace(/^#+([0.])/, "$1");
        if ((x = u.match(/^(0*)\.(#*)$/))) {
          return (
            D +
            m(R, x[2].length)
              .replace(/\.(\d*[1-9])0*$/, ".$1")
              .replace(/^(-?\d*)$/, "$1.")
              .replace(/^0\./, x[1].length ? "0." : ".")
          );
        }
        if ((x = u.match(/^#{1,3},##0(\.?)$/))) return D + _(l(R, 0));
        if ((x = u.match(/^#,##0\.([#0]*0)$/))) {
          return w < 0
            ? "-" + S(e, u, -w)
            : _("" + (Math.floor(w) + E(w, x[1].length))) +
                "." +
                a(C(w, x[1].length), x[1].length);
        }
        if ((x = u.match(/^#,#*,#0/))) return S(e, u.replace(/^#,#*,/, ""), w);
        if ((x = u.match(/^([0#]+)(\\?-([0#]+))+$/))) {
          B = r(S(e, u.replace(/[\\-]/g, ""), w));
          I = 0;
          return r(
            r(u.replace(/\\/g, "")).replace(/[0#]/g, function (e) {
              return I < B.length ? B.charAt(I++) : e === "0" ? "0" : "";
            })
          );
        }
        if (u.match(g)) {
          B = S(e, "##########", w);
          return (
            "(" + B.substr(0, 3) + ") " + B.substr(3, 3) + "-" + B.substr(6)
          );
        }
        var O = "";
        if ((x = u.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
          I = Math.min(x[4].length, 7);
          y = p(R, Math.pow(10, I) - 1, false);
          B = "" + D;
          O = T("n", x[1], y[1]);
          if (O.charAt(O.length - 1) == " ")
            O = O.substr(0, O.length - 1) + "0";
          B += O + x[2] + "/" + x[3];
          O = i(y[2], I);
          if (O.length < x[4].length)
            O = b(x[4].substr(x[4].length - O.length)) + O;
          B += O;
          return B;
        }
        if ((x = u.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
          I = Math.min(Math.max(x[1].length, x[4].length), 7);
          y = p(R, Math.pow(10, I) - 1, true);
          return (
            D +
            (y[0] || (y[1] ? "" : "0")) +
            " " +
            (y[1]
              ? n(y[1], I) + x[2] + "/" + x[3] + i(y[2], I)
              : t(" ", 2 * I + 1 + x[2].length + x[3].length))
          );
        }
        if ((x = u.match(/^[#0?]+$/))) {
          B = l(w, 0);
          if (u.length <= B.length) return B;
          return b(u.substr(0, u.length - B.length)) + B;
        }
        if ((x = u.match(/^([#0?]+)\.([#0]+)$/))) {
          B =
            "" +
            w.toFixed(Math.min(x[2].length, 10)).replace(/([^0])0+$/, "$1");
          I = B.indexOf(".");
          var F = u.indexOf(".") - I,
            P = u.length - B.length - F;
          return b(u.substr(0, F) + B + u.substr(u.length - P));
        }
        if ((x = u.match(/^00,000\.([#0]*0)$/))) {
          I = C(w, x[1].length);
          return w < 0
            ? "-" + S(e, u, -w)
            : _(k(w))
                .replace(/^\d,\d{3}$/, "0$&")
                .replace(/^\d*$/, function (e) {
                  return "00," + (e.length < 3 ? a(0, 3 - e.length) : "") + e;
                }) +
                "." +
                a(I, x[1].length);
        }
        switch (u) {
          case "###,##0.00":
            return S(e, "#,##0.00", w);
          case "###,###":
          case "##,###":
          case "#,###":
            var N = _(l(R, 0));
            return N !== "0" ? D + N : "";
          case "###,###.00":
            return S(e, "###,##0.00", w).replace(/^0\./, ".");
          case "#,###.00":
            return S(e, "#,##0.00", w).replace(/^0\./, ".");
          default:
        }
        throw new Error("unsupported format |" + u + "|");
      }
      function w(e, r, t) {
        var a = r.length - 1;
        while (r.charCodeAt(a - 1) === 44) --a;
        return T(e, r.substr(0, a), t / Math.pow(10, 3 * (r.length - a)));
      }
      function A(r, a, n) {
        var i = a.replace(e, ""),
          s = a.length - i.length;
        return T(r, i, n * Math.pow(10, 2 * s)) + t("%", s);
      }
      function B(e, r) {
        var t;
        var a = e.indexOf("E") - e.indexOf(".") - 1;
        if (e.match(/^#+0.0E\+0$/)) {
          if (r == 0) return "0.0E+0";
          else if (r < 0) return "-" + B(e, -r);
          var n = e.indexOf(".");
          if (n === -1) n = e.indexOf("E");
          var i = Math.floor(Math.log(r) * Math.LOG10E) % n;
          if (i < 0) i += n;
          t = (r / Math.pow(10, i)).toPrecision(a + 1 + ((n + i) % n));
          if (!t.match(/[Ee]/)) {
            var s = Math.floor(Math.log(r) * Math.LOG10E);
            if (t.indexOf(".") === -1)
              t = t.charAt(0) + "." + t.substr(1) + "E+" + (s - t.length + i);
            else t += "E+" + (s - i);
            t = t.replace(/\+-/, "-");
          }
          t = t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function (e, r, t, a) {
            return r + t + a.substr(0, (n + i) % n) + "." + a.substr(i) + "E";
          });
        } else t = r.toExponential(a);
        if (e.match(/E\+00$/) && t.match(/e[+-]\d$/))
          t = t.substr(0, t.length - 1) + "0" + t.charAt(t.length - 1);
        if (e.match(/E\-/) && t.match(/e\+/)) t = t.replace(/e\+/, "e");
        return t.replace("e", "E");
      }
      function x(e, s, f) {
        if (e.charCodeAt(0) === 40 && !s.match(v)) {
          var o = s.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
          if (f >= 0) return x("n", o, f);
          return "(" + x("n", o, -f) + ")";
        }
        if (s.charCodeAt(s.length - 1) === 44) return w(e, s, f);
        if (s.indexOf("%") !== -1) return A(e, s, f);
        if (s.indexOf("E") !== -1) return B(s, f);
        if (s.charCodeAt(0) === 36)
          return "$" + x(e, s.substr(s.charAt(1) == " " ? 2 : 1), f);
        var l;
        var h,
          m,
          C,
          E = Math.abs(f),
          k = f < 0 ? "-" : "";
        if (s.match(/^00+$/)) return k + a(E, s.length);
        if (s.match(/^[#?]+$/)) {
          l = "" + f;
          if (f === 0) l = "";
          return l.length > s.length
            ? l
            : b(s.substr(0, s.length - l.length)) + l;
        }
        if ((h = s.match(c))) return u(h, E, k);
        if (s.match(/^#+0+$/)) return k + a(E, s.length - s.indexOf("0"));
        if ((h = s.match(d))) {
          l = ("" + f)
            .replace(/^([^\.]+)$/, "$1." + b(h[1]))
            .replace(/\.$/, "." + b(h[1]));
          l = l.replace(/\.(\d*)$/, function (e, r) {
            return "." + r + t("0", b(h[1]).length - r.length);
          });
          return s.indexOf("0.") !== -1 ? l : l.replace(/^0\./, ".");
        }
        s = s.replace(/^#+([0.])/, "$1");
        if ((h = s.match(/^(0*)\.(#*)$/))) {
          return (
            k +
            ("" + E)
              .replace(/\.(\d*[1-9])0*$/, ".$1")
              .replace(/^(-?\d*)$/, "$1.")
              .replace(/^0\./, h[1].length ? "0." : ".")
          );
        }
        if ((h = s.match(/^#{1,3},##0(\.?)$/))) return k + _("" + E);
        if ((h = s.match(/^#,##0\.([#0]*0)$/))) {
          return f < 0
            ? "-" + x(e, s, -f)
            : _("" + f) + "." + t("0", h[1].length);
        }
        if ((h = s.match(/^#,#*,#0/))) return x(e, s.replace(/^#,#*,/, ""), f);
        if ((h = s.match(/^([0#]+)(\\?-([0#]+))+$/))) {
          l = r(x(e, s.replace(/[\\-]/g, ""), f));
          m = 0;
          return r(
            r(s.replace(/\\/g, "")).replace(/[0#]/g, function (e) {
              return m < l.length ? l.charAt(m++) : e === "0" ? "0" : "";
            })
          );
        }
        if (s.match(g)) {
          l = x(e, "##########", f);
          return (
            "(" + l.substr(0, 3) + ") " + l.substr(3, 3) + "-" + l.substr(6)
          );
        }
        var S = "";
        if ((h = s.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
          m = Math.min(h[4].length, 7);
          C = p(E, Math.pow(10, m) - 1, false);
          l = "" + k;
          S = T("n", h[1], C[1]);
          if (S.charAt(S.length - 1) == " ")
            S = S.substr(0, S.length - 1) + "0";
          l += S + h[2] + "/" + h[3];
          S = i(C[2], m);
          if (S.length < h[4].length)
            S = b(h[4].substr(h[4].length - S.length)) + S;
          l += S;
          return l;
        }
        if ((h = s.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
          m = Math.min(Math.max(h[1].length, h[4].length), 7);
          C = p(E, Math.pow(10, m) - 1, true);
          return (
            k +
            (C[0] || (C[1] ? "" : "0")) +
            " " +
            (C[1]
              ? n(C[1], m) + h[2] + "/" + h[3] + i(C[2], m)
              : t(" ", 2 * m + 1 + h[2].length + h[3].length))
          );
        }
        if ((h = s.match(/^[#0?]+$/))) {
          l = "" + f;
          if (s.length <= l.length) return l;
          return b(s.substr(0, s.length - l.length)) + l;
        }
        if ((h = s.match(/^([#0]+)\.([#0]+)$/))) {
          l =
            "" +
            f.toFixed(Math.min(h[2].length, 10)).replace(/([^0])0+$/, "$1");
          m = l.indexOf(".");
          var I = s.indexOf(".") - m,
            y = s.length - l.length - I;
          return b(s.substr(0, I) + l + s.substr(s.length - y));
        }
        if ((h = s.match(/^00,000\.([#0]*0)$/))) {
          return f < 0
            ? "-" + x(e, s, -f)
            : _("" + f)
                .replace(/^\d,\d{3}$/, "0$&")
                .replace(/^\d*$/, function (e) {
                  return "00," + (e.length < 3 ? a(0, 3 - e.length) : "") + e;
                }) +
                "." +
                a(0, h[1].length);
        }
        switch (s) {
          case "###,###":
          case "##,###":
          case "#,###":
            var R = _("" + E);
            return R !== "0" ? k + R : "";
          default:
            if (s.match(/\.[0#?]*$/))
              return (
                x(e, s.slice(0, s.lastIndexOf(".")), f) +
                b(s.slice(s.lastIndexOf(".")))
              );
        }
        throw new Error("unsupported format |" + s + "|");
      }
      return function I(e, r, t) {
        return (t | 0) === t ? x(e, r, t) : S(e, r, t);
      };
    })();
    function x(e) {
      var r = [];
      var t = false;
      for (var a = 0, n = 0; a < e.length; ++a)
        switch (e.charCodeAt(a)) {
          case 34:
            t = !t;
            break;
          case 95:
          case 42:
          case 92:
            ++a;
            break;
          case 59:
            r[r.length] = e.substr(n, a - n);
            n = a + 1;
        }
      r[r.length] = e.substr(n);
      if (t === true)
        throw new Error("Format |" + e + "| unterminated string ");
      return r;
    }
    e._split = x;
    var I = /\[[HhMmSs]*\]/;
    function y(e) {
      var r = 0,
        t = "",
        a = "";
      while (r < e.length) {
        switch ((t = e.charAt(r))) {
          case "G":
            if (c(e, r)) r += 6;
            r++;
            break;
          case '"':
            for (; e.charCodeAt(++r) !== 34 && r < e.length; ) ++r;
            ++r;
            break;
          case "\\":
            r += 2;
            break;
          case "_":
            r += 2;
            break;
          case "@":
            ++r;
            break;
          case "B":
          case "b":
            if (e.charAt(r + 1) === "1" || e.charAt(r + 1) === "2") return true;
          case "M":
          case "D":
          case "Y":
          case "H":
          case "S":
          case "E":
          case "m":
          case "d":
          case "y":
          case "h":
          case "s":
          case "e":
          case "g":
            return true;
          case "A":
          case "a":
            if (e.substr(r, 3).toUpperCase() === "A/P") return true;
            if (e.substr(r, 5).toUpperCase() === "AM/PM") return true;
            ++r;
            break;
          case "[":
            a = t;
            while (e.charAt(r++) !== "]" && r < e.length) a += e.charAt(r);
            if (a.match(I)) return true;
            break;
          case ".":
          case "0":
          case "#":
            while (
              r < e.length &&
              ("0#?.,E+-%".indexOf((t = e.charAt(++r))) > -1 ||
                (t == "\\" &&
                  e.charAt(r + 1) == "-" &&
                  "0#".indexOf(e.charAt(r + 2)) > -1))
            ) {}
            break;
          case "?":
            while (e.charAt(++r) === t) {}
            break;
          case "*":
            ++r;
            if (e.charAt(r) == " " || e.charAt(r) == "*") ++r;
            break;
          case "(":
          case ")":
            ++r;
            break;
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            while (r < e.length && "0123456789".indexOf(e.charAt(++r)) > -1) {}
            break;
          case " ":
            ++r;
            break;
          default:
            ++r;
            break;
        }
      }
      return false;
    }
    e.is_date = y;
    function R(e, r, t, a) {
      var n = [],
        i = "",
        s = 0,
        f = "",
        o = "t",
        l,
        h,
        u;
      var d = "H";
      while (s < e.length) {
        switch ((f = e.charAt(s))) {
          case "G":
            if (!c(e, s))
              throw new Error("unrecognized character " + f + " in " + e);
            n[n.length] = { t: "G", v: "General" };
            s += 7;
            break;
          case '"':
            for (i = ""; (u = e.charCodeAt(++s)) !== 34 && s < e.length; )
              i += String.fromCharCode(u);
            n[n.length] = { t: "t", v: i };
            ++s;
            break;
          case "\\":
            var v = e.charAt(++s),
              p = v === "(" || v === ")" ? v : "t";
            n[n.length] = { t: p, v: v };
            ++s;
            break;
          case "_":
            n[n.length] = { t: "t", v: " " };
            s += 2;
            break;
          case "@":
            n[n.length] = { t: "T", v: r };
            ++s;
            break;
          case "B":
          case "b":
            if (e.charAt(s + 1) === "1" || e.charAt(s + 1) === "2") {
              if (l == null) {
                l = g(r, t, e.charAt(s + 1) === "2");
                if (l == null) return "";
              }
              n[n.length] = { t: "X", v: e.substr(s, 2) };
              o = f;
              s += 2;
              break;
            }
          case "M":
          case "D":
          case "Y":
          case "H":
          case "S":
          case "E":
            f = f.toLowerCase();
          case "m":
          case "d":
          case "y":
          case "h":
          case "s":
          case "e":
          case "g":
            if (r < 0) return "";
            if (l == null) {
              l = g(r, t);
              if (l == null) return "";
            }
            i = f;
            while (++s < e.length && e.charAt(s).toLowerCase() === f) i += f;
            if (f === "m" && o.toLowerCase() === "h") f = "M";
            if (f === "h") f = d;
            n[n.length] = { t: f, v: i };
            o = f;
            break;
          case "A":
          case "a":
            var b = { t: f, v: f };
            if (l == null) l = g(r, t);
            if (e.substr(s, 3).toUpperCase() === "A/P") {
              if (l != null) b.v = l.H >= 12 ? "P" : "A";
              b.t = "T";
              d = "h";
              s += 3;
            } else if (e.substr(s, 5).toUpperCase() === "AM/PM") {
              if (l != null) b.v = l.H >= 12 ? "PM" : "AM";
              b.t = "T";
              s += 5;
              d = "h";
            } else {
              b.t = "t";
              ++s;
            }
            if (l == null && b.t === "T") return "";
            n[n.length] = b;
            o = f;
            break;
          case "[":
            i = f;
            while (e.charAt(s++) !== "]" && s < e.length) i += e.charAt(s);
            if (i.slice(-1) !== "]")
              throw 'unterminated "[" block: |' + i + "|";
            if (i.match(I)) {
              if (l == null) {
                l = g(r, t);
                if (l == null) return "";
              }
              n[n.length] = { t: "Z", v: i.toLowerCase() };
              o = i.charAt(1);
            } else if (i.indexOf("$") > -1) {
              i = (i.match(/\$([^-\[\]]*)/) || [])[1] || "$";
              if (!y(e)) n[n.length] = { t: "t", v: i };
            }
            break;
          case ".":
            if (l != null) {
              i = f;
              while (++s < e.length && (f = e.charAt(s)) === "0") i += f;
              n[n.length] = { t: "s", v: i };
              break;
            }
          case "0":
          case "#":
            i = f;
            while (
              (++s < e.length && "0#?.,E+-%".indexOf((f = e.charAt(s))) > -1) ||
              (f == "\\" &&
                e.charAt(s + 1) == "-" &&
                s < e.length - 2 &&
                "0#".indexOf(e.charAt(s + 2)) > -1)
            )
              i += f;
            n[n.length] = { t: "n", v: i };
            break;
          case "?":
            i = f;
            while (e.charAt(++s) === f) i += f;
            n[n.length] = { t: f, v: i };
            o = f;
            break;
          case "*":
            ++s;
            if (e.charAt(s) == " " || e.charAt(s) == "*") ++s;
            break;
          case "(":
          case ")":
            n[n.length] = { t: a === 1 ? "t" : f, v: f };
            ++s;
            break;
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            i = f;
            while (s < e.length && "0123456789".indexOf(e.charAt(++s)) > -1)
              i += e.charAt(s);
            n[n.length] = { t: "D", v: i };
            break;
          case " ":
            n[n.length] = { t: f, v: f };
            ++s;
            break;
          default:
            if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(f) === -1)
              throw new Error("unrecognized character " + f + " in " + e);
            n[n.length] = { t: "t", v: f };
            ++s;
            break;
        }
      }
      var m = 0,
        C = 0,
        E;
      for (s = n.length - 1, o = "t"; s >= 0; --s) {
        switch (n[s].t) {
          case "h":
          case "H":
            n[s].t = d;
            o = "h";
            if (m < 1) m = 1;
            break;
          case "s":
            if ((E = n[s].v.match(/\.0+$/))) C = Math.max(C, E[0].length - 1);
            if (m < 3) m = 3;
          case "d":
          case "y":
          case "M":
          case "e":
            o = n[s].t;
            break;
          case "m":
            if (o === "s") {
              n[s].t = "M";
              if (m < 2) m = 2;
            }
            break;
          case "X":
            break;
          case "Z":
            if (m < 1 && n[s].v.match(/[Hh]/)) m = 1;
            if (m < 2 && n[s].v.match(/[Mm]/)) m = 2;
            if (m < 3 && n[s].v.match(/[Ss]/)) m = 3;
        }
      }
      switch (m) {
        case 0:
          break;
        case 1:
          if (l.u >= 0.5) {
            l.u = 0;
            ++l.S;
          }
          if (l.S >= 60) {
            l.S = 0;
            ++l.M;
          }
          if (l.M >= 60) {
            l.M = 0;
            ++l.H;
          }
          break;
        case 2:
          if (l.u >= 0.5) {
            l.u = 0;
            ++l.S;
          }
          if (l.S >= 60) {
            l.S = 0;
            ++l.M;
          }
          break;
      }
      var k = "",
        S;
      for (s = 0; s < n.length; ++s) {
        switch (n[s].t) {
          case "t":
          case "T":
          case " ":
          case "D":
            break;
          case "X":
            n[s].v = "";
            n[s].t = ";";
            break;
          case "d":
          case "m":
          case "y":
          case "h":
          case "H":
          case "M":
          case "s":
          case "e":
          case "b":
          case "Z":
            n[s].v = B(n[s].t.charCodeAt(0), n[s].v, l, C);
            n[s].t = "t";
            break;
          case "n":
          case "(":
          case "?":
            S = s + 1;
            while (
              n[S] != null &&
              ((f = n[S].t) === "?" ||
                f === "D" ||
                ((f === " " || f === "t") &&
                  n[S + 1] != null &&
                  (n[S + 1].t === "?" ||
                    (n[S + 1].t === "t" && n[S + 1].v === "/"))) ||
                (n[s].t === "(" && (f === " " || f === "n" || f === ")")) ||
                (f === "t" &&
                  (n[S].v === "/" ||
                    (n[S].v === " " && n[S + 1] != null && n[S + 1].t == "?"))))
            ) {
              n[s].v += n[S].v;
              n[S] = { v: "", t: ";" };
              ++S;
            }
            k += n[s].v;
            s = S - 1;
            break;
          case "G":
            n[s].t = "t";
            n[s].v = w(r, t);
            break;
        }
      }
      var A = "",
        _,
        x;
      if (k.length > 0) {
        if (k.charCodeAt(0) == 40) {
          _ = r < 0 && k.charCodeAt(0) === 45 ? -r : r;
          x = T("(", k, _);
        } else {
          _ = r < 0 && a > 1 ? -r : r;
          x = T("n", k, _);
          if (_ < 0 && n[0] && n[0].t == "t") {
            x = x.substr(1);
            n[0].v = "-" + n[0].v;
          }
        }
        S = x.length - 1;
        var R = n.length;
        for (s = 0; s < n.length; ++s)
          if (n[s] != null && n[s].t != "t" && n[s].v.indexOf(".") > -1) {
            R = s;
            break;
          }
        var D = n.length;
        if (R === n.length && x.indexOf("E") === -1) {
          for (s = n.length - 1; s >= 0; --s) {
            if (n[s] == null || "n?(".indexOf(n[s].t) === -1) continue;
            if (S >= n[s].v.length - 1) {
              S -= n[s].v.length;
              n[s].v = x.substr(S + 1, n[s].v.length);
            } else if (S < 0) n[s].v = "";
            else {
              n[s].v = x.substr(0, S + 1);
              S = -1;
            }
            n[s].t = "t";
            D = s;
          }
          if (S >= 0 && D < n.length) n[D].v = x.substr(0, S + 1) + n[D].v;
        } else if (R !== n.length && x.indexOf("E") === -1) {
          S = x.indexOf(".") - 1;
          for (s = R; s >= 0; --s) {
            if (n[s] == null || "n?(".indexOf(n[s].t) === -1) continue;
            h =
              n[s].v.indexOf(".") > -1 && s === R
                ? n[s].v.indexOf(".") - 1
                : n[s].v.length - 1;
            A = n[s].v.substr(h + 1);
            for (; h >= 0; --h) {
              if (
                S >= 0 &&
                (n[s].v.charAt(h) === "0" || n[s].v.charAt(h) === "#")
              )
                A = x.charAt(S--) + A;
            }
            n[s].v = A;
            n[s].t = "t";
            D = s;
          }
          if (S >= 0 && D < n.length) n[D].v = x.substr(0, S + 1) + n[D].v;
          S = x.indexOf(".") + 1;
          for (s = R; s < n.length; ++s) {
            if (n[s] == null || ("n?(".indexOf(n[s].t) === -1 && s !== R))
              continue;
            h =
              n[s].v.indexOf(".") > -1 && s === R ? n[s].v.indexOf(".") + 1 : 0;
            A = n[s].v.substr(0, h);
            for (; h < n[s].v.length; ++h) {
              if (S < x.length) A += x.charAt(S++);
            }
            n[s].v = A;
            n[s].t = "t";
            D = s;
          }
        }
      }
      for (s = 0; s < n.length; ++s)
        if (n[s] != null && "n(?".indexOf(n[s].t) > -1) {
          _ = a > 1 && r < 0 && s > 0 && n[s - 1].v === "-" ? -r : r;
          n[s].v = T(n[s].t, n[s].v, _);
          n[s].t = "t";
        }
      var O = "";
      for (s = 0; s !== n.length; ++s) if (n[s] != null) O += n[s].v;
      return O;
    }
    e._eval = R;
    var D = /\[[=<>]/;
    var O = /\[([=<>]*)(-?\d+\.?\d*)\]/;
    function F(e, r) {
      if (r == null) return false;
      var t = parseFloat(r[2]);
      switch (r[1]) {
        case "=":
          if (e == t) return true;
          break;
        case ">":
          if (e > t) return true;
          break;
        case "<":
          if (e < t) return true;
          break;
        case "<>":
          if (e != t) return true;
          break;
        case ">=":
          if (e >= t) return true;
          break;
        case "<=":
          if (e <= t) return true;
          break;
      }
      return false;
    }
    function P(e, r) {
      var t = x(e);
      var a = t.length,
        n = t[a - 1].indexOf("@");
      if (a < 4 && n > -1) --a;
      if (t.length > 4)
        throw new Error("cannot find right format for |" + t.join("|") + "|");
      if (typeof r !== "number")
        return [4, t.length === 4 || n > -1 ? t[t.length - 1] : "@"];
      switch (t.length) {
        case 1:
          t =
            n > -1
              ? ["General", "General", "General", t[0]]
              : [t[0], t[0], t[0], "@"];
          break;
        case 2:
          t = n > -1 ? [t[0], t[0], t[0], t[1]] : [t[0], t[1], t[0], "@"];
          break;
        case 3:
          t = n > -1 ? [t[0], t[1], t[0], t[2]] : [t[0], t[1], t[2], "@"];
          break;
        case 4:
          break;
      }
      var i = r > 0 ? t[0] : r < 0 ? t[1] : t[2];
      if (t[0].indexOf("[") === -1 && t[1].indexOf("[") === -1) return [a, i];
      if (t[0].match(D) != null || t[1].match(D) != null) {
        var s = t[0].match(O);
        var f = t[1].match(O);
        return F(r, s)
          ? [a, t[0]]
          : F(r, f)
          ? [a, t[1]]
          : [a, t[s != null && f != null ? 2 : 1]];
      }
      return [a, i];
    }
    function N(e, r, t) {
      if (t == null) t = {};
      var a = "";
      switch (typeof e) {
        case "string":
          if (e == "m/d/yy" && t.dateNF) a = t.dateNF;
          else a = e;
          break;
        case "number":
          if (e == 14 && t.dateNF) a = t.dateNF;
          else a = (t.table != null ? t.table : v)[e];
          break;
      }
      if (c(a, 0)) return w(r, t);
      if (r instanceof Date) r = E(r, t.date1904);
      var n = P(a, r);
      if (c(n[1])) return w(r, t);
      if (r === true) r = "TRUE";
      else if (r === false) r = "FALSE";
      else if (r === "" || r == null) return "";
      return R(n[1], r, t, n[0]);
    }
    function L(e, r) {
      if (typeof r != "number") {
        r = +r || -1;
        for (var t = 0; t < 392; ++t) {
          if (v[t] == undefined) {
            if (r < 0) r = t;
            continue;
          }
          if (v[t] == e) {
            r = t;
            break;
          }
        }
        if (r < 0) r = 391;
      }
      v[r] = e;
      return r;
    }
    e.load = L;
    e._table = v;
    e.get_table = function H() {
      return v;
    };
    e.load_table = function W(e) {
      for (var r = 0; r != 392; ++r) if (e[r] !== undefined) L(e[r], r);
    };
    e.init_table = d;
    e.format = N;
  };
  E(C);
  var k = {
    "General Number": "General",
    "General Date": C._table[22],
    "Long Date": "dddd, mmmm dd, yyyy",
    "Medium Date": C._table[15],
    "Short Date": C._table[14],
    "Long Time": C._table[19],
    "Medium Time": C._table[18],
    "Short Time": C._table[20],
    Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    Fixed: C._table[2],
    Standard: C._table[4],
    Percent: C._table[10],
    Scientific: C._table[11],
    "Yes/No": '"Yes";"Yes";"No";@',
    "True/False": '"True";"True";"False";@',
    "On/Off": '"Yes";"Yes";"No";@',
  };
  var S = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
  function w(e) {
    var r = typeof e == "number" ? C._table[e] : e;
    r = r.replace(S, "(\\d+)");
    return new RegExp("^" + r + "$");
  }
  function A(e, r, t) {
    var a = -1,
      n = -1,
      i = -1,
      s = -1,
      f = -1,
      o = -1;
    (r.match(S) || []).forEach(function (e, r) {
      var l = parseInt(t[r + 1], 10);
      switch (e.toLowerCase().charAt(0)) {
        case "y":
          a = l;
          break;
        case "d":
          i = l;
          break;
        case "h":
          s = l;
          break;
        case "s":
          o = l;
          break;
        case "m":
          if (s >= 0) f = l;
          else n = l;
          break;
      }
    });
    if (o >= 0 && f == -1 && n >= 0) {
      f = n;
      n = -1;
    }
    var l =
      ("" + (a >= 0 ? a : new Date().getFullYear())).slice(-4) +
      "-" +
      ("00" + (n >= 1 ? n : 1)).slice(-2) +
      "-" +
      ("00" + (i >= 1 ? i : 1)).slice(-2);
    if (l.length == 7) l = "0" + l;
    if (l.length == 8) l = "20" + l;
    var c =
      ("00" + (s >= 0 ? s : 0)).slice(-2) +
      ":" +
      ("00" + (f >= 0 ? f : 0)).slice(-2) +
      ":" +
      ("00" + (o >= 0 ? o : 0)).slice(-2);
    if (s == -1 && f == -1 && o == -1) return l;
    if (a == -1 && n == -1 && i == -1) return c;
    return l + "T" + c;
  }
  var B = true;
  var _ = (function yE() {
    var e = {};
    e.version = "0.12.0";
    function r(e, r) {
      var o = 3;
      var h = 512;
      var u = 0;
      var d = 0;
      var v = 0;
      var p = 0;
      var g = 0;
      var b = [];
      var m = e.slice(0, 512);
      mr(m, 0);
      var C = t(m);
      o = C[0];
      switch (o) {
        case 3:
          h = 512;
          break;
        case 4:
          h = 4096;
          break;
        default:
          throw new Error("Major Version: Expected 3 or 4 saw " + o);
      }
      if (h !== 512) {
        m = e.slice(0, h);
        mr(m, 28);
      }
      var E = e.slice(0, h);
      a(m, o);
      var S = m.read_shift(4, "i");
      if (o === 3 && S !== 0)
        throw new Error("# Directory Sectors: Expected 0 saw " + S);
      m.l += 4;
      v = m.read_shift(4, "i");
      m.l += 4;
      m.chk("00100000", "Mini Stream Cutoff Size: ");
      p = m.read_shift(4, "i");
      u = m.read_shift(4, "i");
      g = m.read_shift(4, "i");
      d = m.read_shift(4, "i");
      for (var w = -1, A = 0; A < 109; ++A) {
        w = m.read_shift(4, "i");
        if (w < 0) break;
        b[A] = w;
      }
      var B = n(e, h);
      f(g, d, B, h, b);
      var _ = l(B, v, b, h);
      _[v].name = "!Directory";
      if (u > 0 && p !== k) _[p].name = "!MiniFAT";
      _[b[0]].name = "!FAT";
      _.fat_addrs = b;
      _.ssz = h;
      var T = {},
        x = [],
        I = [],
        y = [],
        R = {};
      c(v, _, B, x, u, T, I);
      i(I, R, y, x);
      var D = x.shift();
      var O = s(y, x, I, T, D);
      return {
        raw: { header: E, sectors: B },
        FileIndex: I,
        FullPaths: y,
        FullPathDir: R,
        find: O,
      };
    }
    function t(e) {
      e.chk(S, "Header Signature: ");
      e.chk(w, "CLSID: ");
      var r = e.read_shift(2, "u");
      return [e.read_shift(2, "u"), r];
    }
    function a(e, r) {
      var t = 9;
      e.l += 2;
      switch ((t = e.read_shift(2))) {
        case 9:
          if (r != 3) throw new Error("Sector Shift: Expected 9 saw " + t);
          break;
        case 12:
          if (r != 4) throw new Error("Sector Shift: Expected 12 saw " + t);
          break;
        default:
          throw new Error("Sector Shift: Expected 9 or 12 saw " + t);
      }
      e.chk("0600", "Mini Sector Shift: ");
      e.chk("000000000000", "Reserved: ");
    }
    function n(e, r) {
      var t = Math.ceil(e.length / r) - 1;
      var a = [];
      for (var n = 1; n < t; ++n) a[n - 1] = e.slice(n * r, (n + 1) * r);
      a[t - 1] = e.slice(t * r);
      return a;
    }
    function i(e, r, t, a) {
      var n = 0,
        i = 0,
        s = 0,
        f = 0,
        o = 0,
        l = a.length;
      var c = [],
        h = [];
      for (; n < l; ++n) {
        c[n] = h[n] = n;
        t[n] = a[n];
      }
      for (; o < h.length; ++o) {
        n = h[o];
        i = e[n].L;
        s = e[n].R;
        f = e[n].C;
        if (c[n] === n) {
          if (i !== -1 && c[i] !== i) c[n] = c[i];
          if (s !== -1 && c[s] !== s) c[n] = c[s];
        }
        if (f !== -1) c[f] = n;
        if (i !== -1) {
          c[i] = c[n];
          h.push(i);
        }
        if (s !== -1) {
          c[s] = c[n];
          h.push(s);
        }
      }
      for (n = 1; n !== l; ++n)
        if (c[n] === n) {
          if (s !== -1 && c[s] !== s) c[n] = c[s];
          else if (i !== -1 && c[i] !== i) c[n] = c[i];
        }
      for (n = 1; n < l; ++n) {
        if (e[n].type === 0) continue;
        o = c[n];
        if (o === 0) t[n] = t[0] + "/" + t[n];
        else
          while (o !== 0) {
            t[n] = t[o] + "/" + t[n];
            o = c[o];
          }
        c[n] = 0;
      }
      t[0] += "/";
      for (n = 1; n < l; ++n) {
        if (e[n].type !== 2) t[n] += "/";
        r[t[n]] = e[n];
      }
    }
    function s(e, r, t, a, n) {
      var i = [];
      var s = [],
        f = 0;
      for (f = 0; f < e.length; ++f)
        i[f] = e[f].toUpperCase().replace(b, "").replace(m, "!");
      for (f = 0; f < r.length; ++f)
        s[f] = r[f].toUpperCase().replace(b, "").replace(m, "!");
      return function o(e) {
        var f = false;
        if (e.charCodeAt(0) === 47) {
          f = true;
          e = n + e;
        } else f = e.indexOf("/") !== -1;
        var o = e.toUpperCase().replace(b, "").replace(m, "!");
        var l = f === true ? i.indexOf(o) : s.indexOf(o);
        if (l === -1) return null;
        return f === true ? t[l] : a[r[l]];
      };
    }
    function f(e, r, t, a, n) {
      var i = k;
      if (e === k) {
        if (r !== 0) throw new Error("DIFAT chain shorter than expected");
      } else if (e !== -1) {
        var s = t[e],
          o = (a >>> 2) - 1;
        if (!s) return;
        for (var l = 0; l < o; ++l) {
          if ((i = lr(s, l * 4)) === k) break;
          n.push(i);
        }
        f(lr(s, a - 4), r - 1, t, a, n);
      }
    }
    function o(e, r, t, a, n) {
      var i = e.length;
      var s = [],
        f = [];
      if (!n) n = [];
      var o = a - 1,
        l = 0,
        c = 0;
      for (l = r; l >= 0; ) {
        n[l] = true;
        s[s.length] = l;
        f.push(e[l]);
        var h = t[Math.floor((l * 4) / a)];
        c = (l * 4) & o;
        if (a < 4 + c)
          throw new Error("FAT boundary crossed: " + l + " 4 " + a);
        if (!e[h]) break;
        l = lr(e[h], c);
      }
      return { nodes: s, data: He([f]) };
    }
    function l(e, r, t, a) {
      var n = e.length,
        i = [];
      var s = [],
        f = [],
        o = [];
      var l = a - 1,
        c = 0,
        h = 0,
        u = 0,
        d = 0;
      for (c = 0; c < n; ++c) {
        f = [];
        u = c + r;
        if (u >= n) u -= n;
        if (s[u]) continue;
        o = [];
        for (h = u; h >= 0; ) {
          s[h] = true;
          f[f.length] = h;
          o.push(e[h]);
          var v = t[Math.floor((h * 4) / a)];
          d = (h * 4) & l;
          if (a < 4 + d)
            throw new Error("FAT boundary crossed: " + h + " 4 " + a);
          if (!e[v]) break;
          h = lr(e[v], d);
        }
        i[u] = { nodes: f, data: He([o]) };
      }
      return i;
    }
    function c(e, r, t, a, n, i, s) {
      var f = 0,
        l = a.length ? 2 : 0;
      var c = r[e].data;
      var u = 0,
        d = 0,
        v;
      for (; u < c.length; u += 128) {
        var p = c.slice(u, u + 128);
        mr(p, 64);
        d = p.read_shift(2);
        if (d === 0) continue;
        v = Ve(p, 0, d - l);
        a.push(v);
        var g = {
          name: v,
          type: p.read_shift(1),
          color: p.read_shift(1),
          L: p.read_shift(4, "i"),
          R: p.read_shift(4, "i"),
          C: p.read_shift(4, "i"),
          clsid: p.read_shift(16),
          state: p.read_shift(4, "i"),
          start: 0,
          size: 0,
        };
        var b =
          p.read_shift(2) + p.read_shift(2) + p.read_shift(2) + p.read_shift(2);
        if (b !== 0) g.ct = h(p, p.l - 8);
        var m =
          p.read_shift(2) + p.read_shift(2) + p.read_shift(2) + p.read_shift(2);
        if (m !== 0) g.mt = h(p, p.l - 8);
        g.start = p.read_shift(4, "i");
        g.size = p.read_shift(4, "i");
        if (g.type === 5) {
          f = g.start;
          if (n > 0 && f !== k) r[f].name = "!StreamData";
        } else if (g.size >= 4096) {
          g.storage = "fat";
          if (r[g.start] === undefined)
            r[g.start] = o(t, g.start, r.fat_addrs, r.ssz);
          r[g.start].name = g.name;
          g.content = r[g.start].data.slice(0, g.size);
          mr(g.content, 0);
        } else {
          g.storage = "minifat";
          if (f !== k && g.start !== k) {
            g.content = r[f].data.slice(g.start * E, g.start * E + g.size);
            mr(g.content, 0);
          }
        }
        i[v] = g;
        s.push(g);
      }
    }
    function h(e, r) {
      return new Date(
        ((or(e, r + 4) / 1e7) * Math.pow(2, 32) +
          or(e, r) / 1e7 -
          11644473600) *
          1e3
      );
    }
    var d;
    function v(e, t) {
      if (d == null) d = null;
      return r(d.readFileSync(e), t);
    }
    function C(e, t) {
      switch ((t && t.type) || "base64") {
        case "file":
          return v(e, t);
        case "base64":
          return r(p(u.decode(e)), t);
        case "binary":
          return r(p(e), t);
      }
      return r(e, t);
    }
    var E = 64;
    var k = -2;
    var S = "d0cf11e0a1b11ae1";
    var w = "00000000000000000000000000000000";
    var A = {
      MAXREGSECT: -6,
      DIFSECT: -4,
      FATSECT: -3,
      ENDOFCHAIN: k,
      FREESECT: -1,
      HEADER_SIGNATURE: S,
      HEADER_MINOR_VERSION: "3e00",
      MAXREGSID: -6,
      NOSTREAM: -1,
      HEADER_CLSID: w,
      EntryTypes: [
        "unknown",
        "storage",
        "stream",
        "lockbytes",
        "property",
        "root",
      ],
    };
    e.read = C;
    e.parse = r;
    e.utils = {
      ReadShift: ur,
      CheckField: br,
      prep_blob: mr,
      bconcat: g,
      consts: A,
    };
    return e;
  })();
  if (
    typeof require !== "undefined" &&
    typeof module !== "undefined" &&
    typeof B === "undefined"
  ) {
    module.exports = _;
  }
  function T(e) {
    return e !== undefined && e !== null;
  }
  function x(e) {
    return Object.keys(e);
  }
  function I(e, r) {
    var t = [],
      a = x(e);
    for (var n = 0; n !== a.length; ++n) t[e[a[n]][r]] = a[n];
    return t;
  }
  function y(e) {
    var r = [],
      t = x(e);
    for (var a = 0; a !== t.length; ++a) r[e[t[a]]] = t[a];
    return r;
  }
  function R(e) {
    var r = [],
      t = x(e);
    for (var a = 0; a !== t.length; ++a) r[e[t[a]]] = parseInt(t[a], 10);
    return r;
  }
  function D(e) {
    var r = [],
      t = x(e);
    for (var a = 0; a !== t.length; ++a) {
      if (r[e[t[a]]] == null) r[e[t[a]]] = [];
      r[e[t[a]]].push(t[a]);
    }
    return r;
  }
  var O = new Date(1899, 11, 30, 0, 0, 0);
  var F =
    O.getTime() +
    (new Date().getTimezoneOffset() - O.getTimezoneOffset()) * 6e4;
  function P(e, r) {
    var t = e.getTime();
    if (r) t += 1462 * 24 * 60 * 60 * 1e3;
    return (t - F) / (24 * 60 * 60 * 1e3);
  }
  function N(e) {
    var r = new Date();
    r.setTime(e * 24 * 60 * 60 * 1e3 + F);
    return r;
  }
  function L(e) {
    var r = 0,
      t = 0,
      a = false;
    var n = e.match(
      /P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/
    );
    if (!n) throw new Error("|" + e + "| is not an ISO8601 Duration");
    for (var i = 1; i != n.length; ++i) {
      if (!n[i]) continue;
      t = 1;
      if (i > 3) a = true;
      switch (n[i].substr(n[i].length - 1)) {
        case "Y":
          throw new Error(
            "Unsupported ISO Duration Field: " + n[i].substr(n[i].length - 1)
          );
        case "D":
          t *= 24;
        case "H":
          t *= 60;
        case "M":
          if (!a) throw new Error("Unsupported ISO Duration Field: M");
          else t *= 60;
        case "S":
          break;
      }
      r += t * parseInt(n[i], 10);
    }
    return r;
  }
  var M = new Date("2017-02-19T19:06:09.000Z");
  if (isNaN(M.getFullYear())) M = new Date("2/19/17");
  var U = M.getFullYear() == 2017;
  function H(e, r) {
    var t = new Date(e);
    if (U) {
      if (r > 0) t.setTime(t.getTime() + t.getTimezoneOffset() * 60 * 1e3);
      else if (r < 0) t.setTime(t.getTime() - t.getTimezoneOffset() * 60 * 1e3);
      return t;
    }
    if (e instanceof Date) return e;
    if (M.getFullYear() == 1917 && !isNaN(t.getFullYear())) {
      var a = t.getFullYear();
      if (e.indexOf("" + a) > -1) return t;
      t.setFullYear(t.getFullYear() + 100);
      return t;
    }
    var n = e.match(/\d+/g) || ["2017", "2", "19", "0", "0", "0"];
    return new Date(
      +n[0],
      +n[1] - 1,
      +n[2],
      +n[3] || 0,
      +n[4] || 0,
      +n[5] || 0
    );
  }
  function W(e) {
    var r = "";
    for (var t = 0; t != e.length; ++t) r += String.fromCharCode(e[t]);
    return r;
  }
  function V(e) {
    var r = [];
    for (var t = 0; t != e.length; ++t) r.push(e.charCodeAt(t));
    return r;
  }
  function z(e) {
    if (typeof JSON != "undefined" && !Array.isArray(e))
      return JSON.parse(JSON.stringify(e));
    if (typeof e != "object" || e == null) return e;
    var r = {};
    for (var t in e) if (e.hasOwnProperty(t)) r[t] = z(e[t]);
    return r;
  }
  function X(e, r) {
    var t = "";
    while (t.length < r) t += e;
    return t;
  }
  function G(e) {
    var r = new Date(e),
      t = new Date(NaN);
    var a = r.getYear(),
      n = r.getMonth(),
      i = r.getDate();
    if (isNaN(i)) return t;
    if (a < 0 || a > 8099) return t;
    if ((n > 0 || i > 1) && a != 101) return r;
    if (
      e.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)
    )
      return r;
    if (!e.match(/[a-zA-Z]/)) return r;
    return t;
  }
  function j(e) {
    if (!e) return null;
    if (e.data) return o(e.data);
    if (e.asNodeBuffer && d) return o(e.asNodeBuffer().toString("binary"));
    if (e.asBinary) return o(e.asBinary());
    if (e._data && e._data.getContent)
      return o(W(Array.prototype.slice.call(e._data.getContent(), 0)));
    return null;
  }
  function K(e) {
    if (!e) return null;
    if (e.data) return i(e.data);
    if (e.asNodeBuffer && d) return e.asNodeBuffer();
    if (e._data && e._data.getContent) {
      var r = e._data.getContent();
      if (typeof r == "string") return V(r);
      return Array.prototype.slice.call(r);
    }
    return null;
  }
  function Y(e) {
    return e && e.name.slice(-4) === ".bin" ? K(e) : j(e);
  }
  function $(e, r) {
    var t = x(e.files);
    var a = r.toLowerCase(),
      n = a.replace(/\//g, "\\");
    for (var i = 0; i < t.length; ++i) {
      var s = t[i].toLowerCase();
      if (a == s || n == s) return e.files[t[i]];
    }
    return null;
  }
  function Z(e, r) {
    var t = $(e, r);
    if (t == null) throw new Error("Cannot find file " + r + " in zip");
    return t;
  }
  function Q(e, r, t) {
    if (!t) return Y(Z(e, r));
    if (!r) return null;
    try {
      return Q(e, r);
    } catch (a) {
      return null;
    }
  }
  function J(e, r, t) {
    if (!t) return j(Z(e, r));
    if (!r) return null;
    try {
      return J(e, r);
    } catch (a) {
      return null;
    }
  }
  var q, ee;
  if (typeof JSZip !== "undefined") ee = JSZip;
  if (typeof exports !== "undefined") {
    if (typeof module !== "undefined" && module.exports) {
      if (typeof ee === "undefined") ee = null;
      q = null;
    }
  }
  function re(e, r) {
    var t = r.split("/");
    if (r.slice(-1) != "/") t.pop();
    var a = e.split("/");
    while (a.length !== 0) {
      var n = a.shift();
      if (n === "..") t.pop();
      else if (n !== ".") t.push(n);
    }
    return t.join("/");
  }
  var te = /([^"\s?>\/]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
  var ae = /<[^>]*>/g;
  var ne = /<\w*:/,
    ie = /<(\/?)\w+:/;
  function se(e, r) {
    var t = {};
    var a = 0,
      n = 0;
    for (; a !== e.length; ++a)
      if ((n = e.charCodeAt(a)) === 32 || n === 10 || n === 13) break;
    if (!r) t[0] = e.substr(0, a);
    if (a === e.length) return t;
    var i = e.match(te),
      s = 0,
      f = "",
      o = 0,
      l = "",
      c = "",
      h = 1;
    if (i)
      for (o = 0; o != i.length; ++o) {
        c = i[o];
        for (n = 0; n != c.length; ++n) if (c.charCodeAt(n) === 61) break;
        l = c.substr(0, n);
        h = (a = c.charCodeAt(n + 1)) == 34 || a == 39 ? 1 : 0;
        f = c.substring(n + 1 + h, c.length - h);
        for (s = 0; s != l.length; ++s) if (l.charCodeAt(s) === 58) break;
        if (s === l.length) {
          if (l.indexOf("_") > 0) l = l.substr(0, l.indexOf("_"));
          t[l] = f;
        } else {
          var u =
            (s === 5 && l.substr(0, 5) === "xmlns" ? "xmlns" : "") +
            l.substr(s + 1);
          if (t[u] && l.substr(s - 3, 3) == "ext") continue;
          t[u] = f;
        }
      }
    return t;
  }
  function fe(e) {
    return e.replace(ie, "<$1");
  }
  var oe = {
    "&quot;": '"',
    "&apos;": "'",
    "&gt;": ">",
    "&lt;": "<",
    "&amp;": "&",
  };
  var le = y(oe);
  var ce = (function () {
    var e = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/g,
      r = /_x([\da-fA-F]{4})_/g;
    return function t(a) {
      var n = a + "";
      return n
        .replace(e, function (e, r) {
          return (
            oe[e] ||
            String.fromCharCode(parseInt(r, e.indexOf("x") > -1 ? 16 : 10)) ||
            e
          );
        })
        .replace(r, function (e, r) {
          return String.fromCharCode(parseInt(r, 16));
        });
    };
  })();
  var he = /[&<>'"]/g,
    ue = /[\u0000-\u0008\u000b-\u001f]/g;
  function de(e, r) {
    var t = e + "";
    return t
      .replace(he, function (e) {
        return le[e];
      })
      .replace(ue, function (e) {
        return "_x" + ("000" + e.charCodeAt(0).toString(16)).slice(-4) + "_";
      });
  }
  function ve(e) {
    return de(e).replace(/ /g, "_x0020_");
  }
  var pe = /[\u0000-\u001f]/g;
  function ge(e) {
    var r = e + "";
    return r
      .replace(he, function (e) {
        return le[e];
      })
      .replace(pe, function (e) {
        return "&#x" + ("000" + e.charCodeAt(0).toString(16)).slice(-4) + ";";
      });
  }
  var be = (function () {
    var e = /&#(\d+);/g;
    function r(e, r) {
      return String.fromCharCode(parseInt(r, 10));
    }
    return function t(a) {
      return a.replace(e, r);
    };
  })();
  var me = (function () {
    return function e(r) {
      return r.replace(/(\r\n|[\r\n])/g, "&#10;");
    };
  })();
  function Ce(e, r) {
    switch (e) {
      case 1:
      case true:
      case "1":
      case "true":
      case "TRUE":
        return true;
      default:
        return false;
    }
  }
  var Ee = function RE(e) {
    var r = "",
      t = 0,
      a = 0,
      n = 0,
      i = 0,
      s = 0,
      f = 0;
    while (t < e.length) {
      a = e.charCodeAt(t++);
      if (a < 128) {
        r += String.fromCharCode(a);
        continue;
      }
      n = e.charCodeAt(t++);
      if (a > 191 && a < 224) {
        s = (a & 31) << 6;
        s |= n & 63;
        r += String.fromCharCode(s);
        continue;
      }
      i = e.charCodeAt(t++);
      if (a < 240) {
        r += String.fromCharCode(((a & 15) << 12) | ((n & 63) << 6) | (i & 63));
        continue;
      }
      s = e.charCodeAt(t++);
      f =
        (((a & 7) << 18) | ((n & 63) << 12) | ((i & 63) << 6) | (s & 63)) -
        65536;
      r += String.fromCharCode(55296 + ((f >>> 10) & 1023));
      r += String.fromCharCode(56320 + (f & 1023));
    }
    return r;
  };
  if (d) {
    var ke = function DE(e) {
      var r = new Buffer(2 * e.length),
        t,
        a,
        n = 1,
        i = 0,
        s = 0,
        f;
      for (a = 0; a < e.length; a += n) {
        n = 1;
        if ((f = e.charCodeAt(a)) < 128) t = f;
        else if (f < 224) {
          t = (f & 31) * 64 + (e.charCodeAt(a + 1) & 63);
          n = 2;
        } else if (f < 240) {
          t =
            (f & 15) * 4096 +
            (e.charCodeAt(a + 1) & 63) * 64 +
            (e.charCodeAt(a + 2) & 63);
          n = 3;
        } else {
          n = 4;
          t =
            (f & 7) * 262144 +
            (e.charCodeAt(a + 1) & 63) * 4096 +
            (e.charCodeAt(a + 2) & 63) * 64 +
            (e.charCodeAt(a + 3) & 63);
          t -= 65536;
          s = 55296 + ((t >>> 10) & 1023);
          t = 56320 + (t & 1023);
        }
        if (s !== 0) {
          r[i++] = s & 255;
          r[i++] = s >>> 8;
          s = 0;
        }
        r[i++] = t % 256;
        r[i++] = t >>> 8;
      }
      return r.slice(0, i).toString("ucs2");
    };
    var Se = "foo bar bazâð£";
    if (Ee(Se) == ke(Se)) Ee = ke;
    var we = function OE(e) {
      return Buffer(e, "binary").toString("utf8");
    };
    if (Ee(Se) == we(Se)) Ee = we;
  }
  var Ae = (function () {
    var e = {};
    return function r(t, a) {
      var n = t + "|" + (a || "");
      if (e[n]) return e[n];
      return (e[n] = new RegExp(
        "<(?:\\w+:)?" +
          t +
          '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' +
          t +
          ">",
        a || ""
      ));
    };
  })();
  var Be = (function () {
    var e = {};
    return function r(t) {
      if (e[t] !== undefined) return e[t];
      return (e[t] = new RegExp(
        "<(?:vt:)?" + t + ">([\\s\\S]*?)</(?:vt:)?" + t + ">",
        "g"
      ));
    };
  })();
  var _e = /<\/?(?:vt:)?variant>/g,
    Te = /<(?:vt:)([^>]*)>([\s\S]*)</;
  function xe(e) {
    var r = se(e);
    var t = e.match(Be(r.baseType)) || [];
    if (t.length != r.size)
      throw new Error("unexpected vector length " + t.length + " != " + r.size);
    var a = [];
    t.forEach(function (e) {
      var r = e.replace(_e, "").match(Te);
      a.push({ v: Ee(r[2]), t: r[1] });
    });
    return a;
  }
  var Ie = /(^\s|\s$|\n)/;
  function ye(e, r) {
    return (
      "<" +
      e +
      (r.match(Ie) ? ' xml:space="preserve"' : "") +
      ">" +
      r +
      "</" +
      e +
      ">"
    );
  }
  function Re(e) {
    return x(e)
      .map(function (r) {
        return " " + r + '="' + e[r] + '"';
      })
      .join("");
  }
  function De(e, r, t) {
    return (
      "<" +
      e +
      (T(t) ? Re(t) : "") +
      (T(r)
        ? (r.match(Ie) ? ' xml:space="preserve"' : "") + ">" + r + "</" + e
        : "/") +
      ">"
    );
  }
  function Oe(e, r) {
    try {
      return e.toISOString().replace(/\.\d*/, "");
    } catch (t) {
      if (r) throw t;
    }
    return "";
  }
  function Fe(e) {
    switch (typeof e) {
      case "string":
        return De("vt:lpwstr", e);
      case "number":
        return De((e | 0) == e ? "vt:i4" : "vt:r8", String(e));
      case "boolean":
        return De("vt:bool", e ? "true" : "false");
    }
    if (e instanceof Date) return De("vt:filetime", Oe(e));
    throw new Error("Unable to serialize " + e);
  }
  var Pe = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
  var Ne = {
    dc: "http://purl.org/dc/elements/1.1/",
    dcterms: "http://purl.org/dc/terms/",
    dcmitype: "http://purl.org/dc/dcmitype/",
    mx: "http://schemas.microsoft.com/office/mac/excel/2008/main",
    r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
    sjs: "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
    vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
    xsi: "http://www.w3.org/2001/XMLSchema-instance",
    xsd: "http://www.w3.org/2001/XMLSchema",
  };
  Ne.main = [
    "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
    "http://purl.oclc.org/ooxml/spreadsheetml/main",
    "http://schemas.microsoft.com/office/excel/2006/main",
    "http://schemas.microsoft.com/office/excel/2006/2",
  ];
  var Le = {
    o: "urn:schemas-microsoft-com:office:office",
    x: "urn:schemas-microsoft-com:office:excel",
    ss: "urn:schemas-microsoft-com:office:spreadsheet",
    dt: "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
    mv: "http://macVmlSchemaUri",
    v: "urn:schemas-microsoft-com:vml",
    html: "http://www.w3.org/TR/REC-html40",
  };
  function Me(e, r) {
    var t = 1 - 2 * (e[r + 7] >>> 7);
    var a = ((e[r + 7] & 127) << 4) + ((e[r + 6] >>> 4) & 15);
    var n = e[r + 6] & 15;
    for (var i = 5; i >= 0; --i) n = n * 256 + e[r + i];
    if (a == 2047) return n == 0 ? t * Infinity : NaN;
    if (a == 0) a = -1022;
    else {
      a -= 1023;
      n += Math.pow(2, 52);
    }
    return t * Math.pow(2, a - 52) * n;
  }
  function Ue(e, r, t) {
    var a = (r < 0 || 1 / r == -Infinity ? 1 : 0) << 7,
      n = 0,
      i = 0;
    var s = a ? -r : r;
    if (!isFinite(s)) {
      n = 2047;
      i = isNaN(r) ? 26985 : 0;
    } else {
      n = Math.floor(Math.log(s) * Math.LOG2E);
      i = r * Math.pow(2, 52 - n);
      if (n <= -1023 && (!isFinite(i) || i < Math.pow(2, 52))) {
        n = -1022;
      } else {
        i -= Math.pow(2, 52);
        n += 1023;
      }
    }
    for (var f = 0; f <= 5; ++f, i /= 256) e[t + f] = i & 255;
    e[t + 6] = ((n & 15) << 4) | (i & 15);
    e[t + 7] = (n >> 4) | a;
  }
  var He, We;
  He = We = function FE(e) {
    var r = [];
    for (var t = 0; t < e[0].length; ++t) {
      r.push.apply(r, e[0][t]);
    }
    return r;
  };
  var Ve, ze;
  Ve = ze = function PE(e, r, t) {
    var a = [];
    for (var n = r; n < t; n += 2) a.push(String.fromCharCode(sr(e, n)));
    return a.join("");
  };
  var Xe, Ge;
  Xe = Ge = function NE(e, r, t) {
    return e
      .slice(r, r + t)
      .map(function (e) {
        return (e < 16 ? "0" : "") + e.toString(16);
      })
      .join("");
  };
  var je, Ke;
  je = Ke = function (e, r, t) {
    var a = [];
    for (var n = r; n < t; n++) a.push(String.fromCharCode(ir(e, n)));
    return a.join("");
  };
  var Ye, $e;
  Ye = $e = function LE(e, r) {
    var t = or(e, r);
    return t > 0 ? je(e, r + 4, r + 4 + t - 1) : "";
  };
  var Ze, Qe;
  Ze = Qe = function ME(e, r) {
    var t = 2 * or(e, r);
    return t > 0 ? je(e, r + 4, r + 4 + t - 1) : "";
  };
  var Je, qe;
  Je = qe = function UE(e, r) {
    var t = or(e, r);
    return t > 0 ? Ve(e, r + 4, r + 4 + t) : "";
  };
  var er, rr;
  er = rr = function HE(e, r) {
    var t = or(e, r);
    return t > 0 ? je(e, r + 4, r + 4 + t) : "";
  };
  var tr, ar;
  tr = ar = function (e, r) {
    return Me(e, r);
  };
  var nr = function WE(e) {
    return Array.isArray(e);
  };
  if (d) {
    Ve = function VE(e, r, t) {
      if (!Buffer.isBuffer(e)) return ze(e, r, t);
      return e.toString("utf16le", r, t);
    };
    Xe = function (e, r, t) {
      return Buffer.isBuffer(e) ? e.toString("hex", r, r + t) : Ge(e, r, t);
    };
    Ye = function zE(e, r) {
      if (!Buffer.isBuffer(e)) return $e(e, r);
      var t = e.readUInt32LE(r);
      return t > 0 ? e.toString("utf8", r + 4, r + 4 + t - 1) : "";
    };
    Ze = function XE(e, r) {
      if (!Buffer.isBuffer(e)) return Qe(e, r);
      var t = 2 * e.readUInt32LE(r);
      return e.toString("utf16le", r + 4, r + 4 + t - 1);
    };
    Je = function GE(e, r) {
      if (!Buffer.isBuffer(e)) return qe(e, r);
      var t = e.readUInt32LE(r);
      return e.toString("utf16le", r + 4, r + 4 + t);
    };
    er = function jE(e, r) {
      if (!Buffer.isBuffer(e)) return rr(e, r);
      var t = e.readUInt32LE(r);
      return e.toString("utf8", r + 4, r + 4 + t);
    };
    je = function KE(e, r, t) {
      return e.toString("utf8", r, t);
    };
    He = function (e) {
      return e[0].length > 0 && Buffer.isBuffer(e[0][0])
        ? Buffer.concat(e[0])
        : We(e);
    };
    g = function (e) {
      return Buffer.isBuffer(e[0]) ? Buffer.concat(e) : [].concat.apply([], e);
    };
    tr = function YE(e, r) {
      if (Buffer.isBuffer(e)) return e.readDoubleLE(r);
      return ar(e, r);
    };
    nr = function $E(e) {
      return Buffer.isBuffer(e) || Array.isArray(e);
    };
  }
  if (typeof cptable !== "undefined") {
    Ve = function (e, r, t) {
      return cptable.utils.decode(1200, e.slice(r, t));
    };
    je = function (e, r, t) {
      return cptable.utils.decode(65001, e.slice(r, t));
    };
    Ye = function (e, r) {
      var a = or(e, r);
      return a > 0
        ? cptable.utils.decode(t, e.slice(r + 4, r + 4 + a - 1))
        : "";
    };
    Ze = function (e, r) {
      var t = 2 * or(e, r);
      return t > 0
        ? cptable.utils.decode(1200, e.slice(r + 4, r + 4 + t - 1))
        : "";
    };
    Je = function (e, r) {
      var t = or(e, r);
      return t > 0 ? cptable.utils.decode(1200, e.slice(r + 4, r + 4 + t)) : "";
    };
    er = function (e, r) {
      var t = or(e, r);
      return t > 0
        ? cptable.utils.decode(65001, e.slice(r + 4, r + 4 + t))
        : "";
    };
  }
  var ir = function (e, r) {
    return e[r];
  };
  var sr = function (e, r) {
    return e[r + 1] * (1 << 8) + e[r];
  };
  var fr = function (e, r) {
    var t = e[r + 1] * (1 << 8) + e[r];
    return t < 32768 ? t : (65535 - t + 1) * -1;
  };
  var or = function (e, r) {
    return e[r + 3] * (1 << 24) + (e[r + 2] << 16) + (e[r + 1] << 8) + e[r];
  };
  var lr = function (e, r) {
    return (e[r + 3] << 24) | (e[r + 2] << 16) | (e[r + 1] << 8) | e[r];
  };
  var cr = function (e) {
    return e.match(/../g).map(function (e) {
      return parseInt(e, 16);
    });
  };
  var hr =
    typeof Buffer !== "undefined"
      ? function (e) {
          return Buffer.isBuffer(e) ? new Buffer(e, "hex") : cr(e);
        }
      : cr;
  function ur(e, r) {
    var a = "",
      n,
      i,
      s = [],
      f,
      o,
      c,
      h;
    switch (r) {
      case "dbcs":
        h = this.l;
        if (d && Buffer.isBuffer(this))
          a = this.slice(this.l, this.l + 2 * e).toString("utf16le");
        else
          for (c = 0; c != e; ++c) {
            a += String.fromCharCode(sr(this, h));
            h += 2;
          }
        e *= 2;
        break;
      case "utf8":
        a = je(this, this.l, this.l + e);
        break;
      case "utf16le":
        e *= 2;
        a = Ve(this, this.l, this.l + e);
        break;
      case "wstr":
        if (typeof cptable !== "undefined")
          a = cptable.utils.decode(t, this.slice(this.l, this.l + 2 * e));
        else return ur.call(this, e, "dbcs");
        e = 2 * e;
        break;
      case "lpstr":
        a = Ye(this, this.l);
        e = 5 + a.length;
        break;
      case "lpwstr":
        a = Ze(this, this.l);
        e = 5 + a.length;
        if (a[a.length - 1] == "\0") e += 2;
        break;
      case "lpp4":
        e = 4 + or(this, this.l);
        a = Je(this, this.l);
        if (e & 2) e += 2;
        break;
      case "8lpp4":
        e = 4 + or(this, this.l);
        a = er(this, this.l);
        if (e & 3) e += 4 - (e & 3);
        break;
      case "cstr":
        e = 0;
        a = "";
        while ((f = ir(this, this.l + e++)) !== 0) s.push(l(f));
        a = s.join("");
        break;
      case "_wstr":
        e = 0;
        a = "";
        while ((f = sr(this, this.l + e)) !== 0) {
          s.push(l(f));
          e += 2;
        }
        e += 2;
        a = s.join("");
        break;
      case "dbcs-cont":
        a = "";
        h = this.l;
        for (c = 0; c != e; ++c) {
          if (this.lens && this.lens.indexOf(h) !== -1) {
            f = ir(this, h);
            this.l = h + 1;
            o = ur.call(this, e - c, f ? "dbcs-cont" : "sbcs-cont");
            return s.join("") + o;
          }
          s.push(l(sr(this, h)));
          h += 2;
        }
        a = s.join("");
        e *= 2;
        break;
      case "sbcs-cont":
        a = "";
        h = this.l;
        for (c = 0; c != e; ++c) {
          if (this.lens && this.lens.indexOf(h) !== -1) {
            f = ir(this, h);
            this.l = h + 1;
            o = ur.call(this, e - c, f ? "dbcs-cont" : "sbcs-cont");
            return s.join("") + o;
          }
          s.push(l(ir(this, h)));
          h += 1;
        }
        a = s.join("");
        break;
      default:
        switch (e) {
          case 1:
            n = ir(this, this.l);
            this.l++;
            return n;
          case 2:
            n = (r === "i" ? fr : sr)(this, this.l);
            this.l += 2;
            return n;
          case 4:
            if (r === "i" || (this[this.l + 3] & 128) === 0) {
              n = lr(this, this.l);
              this.l += 4;
              return n;
            } else {
              i = or(this, this.l);
              this.l += 4;
            }
            return i;
          case 8:
            if (r === "f") {
              i = tr(this, this.l);
              this.l += 8;
              return i;
            }
          case 16:
            a = Xe(this, this.l, e);
            break;
        }
    }
    this.l += e;
    return a;
  }
  var dr = function (e, r, t) {
    e[t] = r & 255;
    e[t + 1] = (r >>> 8) & 255;
  };
  var vr = function (e, r, t) {
    e[t] = r & 255;
    e[t + 1] = (r >>> 8) & 255;
    e[t + 2] = (r >>> 16) & 255;
    e[t + 3] = (r >>> 24) & 255;
  };
  var pr = function (e, r, t) {
    e[t] = r & 255;
    e[t + 1] = (r >> 8) & 255;
    e[t + 2] = (r >> 16) & 255;
    e[t + 3] = (r >> 24) & 255;
  };
  function gr(e, r, t) {
    var a = 0,
      n = 0;
    if (t === "dbcs") {
      for (n = 0; n != r.length; ++n) dr(this, r.charCodeAt(n), this.l + 2 * n);
      a = 2 * r.length;
    } else if (t === "sbcs") {
      for (n = 0; n != r.length; ++n) this[this.l + n] = r.charCodeAt(n) & 255;
      a = r.length;
    } else
      switch (e) {
        case 1:
          a = 1;
          this[this.l] = r & 255;
          break;
        case 2:
          a = 2;
          this[this.l] = r & 255;
          r >>>= 8;
          this[this.l + 1] = r & 255;
          break;
        case 3:
          a = 3;
          this[this.l] = r & 255;
          r >>>= 8;
          this[this.l + 1] = r & 255;
          r >>>= 8;
          this[this.l + 2] = r & 255;
          break;
        case 4:
          a = 4;
          vr(this, r, this.l);
          break;
        case 8:
          a = 8;
          if (t === "f") {
            Ue(this, r, this.l);
            break;
          }
        case 16:
          break;
        case -4:
          a = 4;
          pr(this, r, this.l);
          break;
      }
    this.l += a;
    return this;
  }
  function br(e, r) {
    var t = Xe(this, this.l, e.length >> 1);
    if (t !== e) throw r + "Expected " + e + " saw " + t;
    this.l += e.length >> 1;
  }
  function mr(e, r) {
    e.l = r;
    e.read_shift = ur;
    e.chk = br;
    e.write_shift = gr;
  }
  function Cr(e, r) {
    e.l += r;
  }
  function Er(e, r) {
    if (typeof console != "undefined") console.log(e.slice(e.l, e.l + r));
    e.l += r;
  }
  function kr(e, r) {
    e.l += r;
  }
  function Sr(e) {
    var r = v(e);
    mr(r, 0);
    return r;
  }
  function wr(e, r, t) {
    if (!e) return;
    var a, n, i;
    mr(e, e.l || 0);
    var s = e.length,
      f = 0,
      o = 0;
    while (e.l < s) {
      f = e.read_shift(1);
      if (f & 128) f = (f & 127) + ((e.read_shift(1) & 127) << 7);
      var l = bC[f] || bC[65535];
      a = e.read_shift(1);
      i = a & 127;
      for (n = 1; n < 4 && a & 128; ++n)
        i += ((a = e.read_shift(1)) & 127) << (7 * n);
      o = e.l + i;
      var c = l.f(e, i, t);
      e.l = o;
      if (r(c, l.n, f)) return;
    }
  }
  function Ar() {
    var e = [],
      r = 2048;
    var t = function o(e) {
      var r = Sr(e);
      mr(r, 0);
      return r;
    };
    var a = t(r);
    var n = function l() {
      if (!a) return;
      if (a.length > a.l) a = a.slice(0, a.l);
      if (a.length > 0) e.push(a);
      a = null;
    };
    var i = function c(e) {
      if (a && e < a.length - a.l) return a;
      n();
      return (a = t(Math.max(e + 1, r)));
    };
    var s = function h() {
      n();
      return He([e]);
    };
    var f = function u(e) {
      n();
      a = e;
      i(r);
    };
    return { next: i, push: f, end: s, _bufs: e };
  }
  function Br(e, r, t, a) {
    var n = Number(mC[r]),
      i;
    if (isNaN(n)) return;
    if (!a) a = bC[n].p || (t || []).length || 0;
    i = 1 + (n >= 128 ? 1 : 0) + 1 + a;
    if (a >= 128) ++i;
    if (a >= 16384) ++i;
    if (a >= 2097152) ++i;
    var s = e.next(i);
    if (n <= 127) s.write_shift(1, n);
    else {
      s.write_shift(1, (n & 127) + 128);
      s.write_shift(1, n >> 7);
    }
    for (var f = 0; f != 4; ++f) {
      if (a >= 128) {
        s.write_shift(1, (a & 127) + 128);
        a >>= 7;
      } else {
        s.write_shift(1, a);
        break;
      }
    }
    if (a > 0 && nr(t)) e.push(t);
  }
  function _r(e, r, t) {
    var a = z(e);
    if (r.s) {
      if (a.cRel) a.c += r.s.c;
      if (a.rRel) a.r += r.s.r;
    } else {
      a.c += r.c;
      a.r += r.r;
    }
    if (!t || t.biff < 12) {
      while (a.c >= 256) a.c -= 256;
      while (a.r >= 65536) a.r -= 65536;
    }
    return a;
  }
  function Tr(e, r, t) {
    var a = z(e);
    a.s = _r(a.s, r.s, t);
    a.e = _r(a.e, r.s, t);
    return a;
  }
  function xr(e) {
    var r = Vr(e);
    if (e.cRel === 0) r = Mr(r);
    if (e.rRel === 0) r = Fr(r);
    return r;
  }
  function Ir(e, r) {
    if (e.s.r == 0 && !e.s.rRel) {
      if (e.e.r == (r.biff >= 12 ? 1048575 : 65535) && !e.e.rRel) {
        return (
          (e.s.cRel ? "" : "$") +
          Lr(e.s.c) +
          ":" +
          (e.e.cRel ? "" : "$") +
          Lr(e.e.c)
        );
      }
    }
    if (e.s.c == 0 && !e.s.cRel) {
      if (e.e.c == (r.biff >= 12 ? 65535 : 255) && !e.e.cRel) {
        return (
          (e.s.rRel ? "" : "$") +
          Or(e.s.r) +
          ":" +
          (e.e.rRel ? "" : "$") +
          Or(e.e.r)
        );
      }
    }
    return xr(e.s) + ":" + xr(e.e);
  }
  var yr = {};
  var Rr = function (e, r) {
    var t;
    if (typeof r !== "undefined") t = r;
    else if (typeof require !== "undefined") {
      try {
        t = null;
      } catch (a) {
        t = null;
      }
    }
    e.rc4 = function (e, r) {
      var t = new Array(256);
      var a = 0,
        n = 0,
        i = 0,
        s = 0;
      for (n = 0; n != 256; ++n) t[n] = n;
      for (n = 0; n != 256; ++n) {
        i = (i + t[n] + e[n % e.length].charCodeAt(0)) & 255;
        s = t[n];
        t[n] = t[i];
        t[i] = s;
      }
      n = i = 0;
      var f = Buffer(r.length);
      for (a = 0; a != r.length; ++a) {
        n = (n + 1) & 255;
        i = (i + t[n]) % 256;
        s = t[n];
        t[n] = t[i];
        t[i] = s;
        f[a] = r[a] ^ t[(t[n] + t[i]) & 255];
      }
      return f;
    };
    e.md5 = function (e) {
      if (!t) throw new Error("Unsupported crypto");
      return t.createHash("md5").update(e).digest("hex");
    };
  };
  Rr(yr, typeof crypto !== "undefined" ? crypto : undefined);
  function Dr(e) {
    return parseInt(Pr(e), 10) - 1;
  }
  function Or(e) {
    return "" + (e + 1);
  }
  function Fr(e) {
    return e.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
  }
  function Pr(e) {
    return e.replace(/\$(\d+)$/, "$1");
  }
  function Nr(e) {
    var r = Ur(e),
      t = 0,
      a = 0;
    for (; a !== r.length; ++a) t = 26 * t + r.charCodeAt(a) - 64;
    return t - 1;
  }
  function Lr(e) {
    var r = "";
    for (++e; e; e = Math.floor((e - 1) / 26))
      r = String.fromCharCode(((e - 1) % 26) + 65) + r;
    return r;
  }
  function Mr(e) {
    return e.replace(/^([A-Z])/, "$$$1");
  }
  function Ur(e) {
    return e.replace(/^\$([A-Z])/, "$1");
  }
  function Hr(e) {
    return e.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
  }
  function Wr(e) {
    var r = Hr(e);
    return { c: Nr(r[0]), r: Dr(r[1]) };
  }
  function Vr(e) {
    return Lr(e.c) + Or(e.r);
  }
  function zr(e) {
    return Mr(Fr(e));
  }
  function Xr(e) {
    return Ur(Pr(e));
  }
  function Gr(e) {
    var r = e.split(":").map(Wr);
    return { s: r[0], e: r[r.length - 1] };
  }
  function jr(e, r) {
    if (typeof r === "undefined" || typeof r === "number") {
      return jr(e.s, e.e);
    }
    if (typeof e !== "string") e = Vr(e);
    if (typeof r !== "string") r = Vr(r);
    return e == r ? e : e + ":" + r;
  }
  function Kr(e) {
    var r = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    var t = 0,
      a = 0,
      n = 0;
    var i = e.length;
    for (t = 0; a < i; ++a) {
      if ((n = e.charCodeAt(a) - 64) < 1 || n > 26) break;
      t = 26 * t + n;
    }
    r.s.c = --t;
    for (t = 0; a < i; ++a) {
      if ((n = e.charCodeAt(a) - 48) < 0 || n > 9) break;
      t = 10 * t + n;
    }
    r.s.r = --t;
    if (a === i || e.charCodeAt(++a) === 58) {
      r.e.c = r.s.c;
      r.e.r = r.s.r;
      return r;
    }
    for (t = 0; a != i; ++a) {
      if ((n = e.charCodeAt(a) - 64) < 1 || n > 26) break;
      t = 26 * t + n;
    }
    r.e.c = --t;
    for (t = 0; a != i; ++a) {
      if ((n = e.charCodeAt(a) - 48) < 0 || n > 9) break;
      t = 10 * t + n;
    }
    r.e.r = --t;
    return r;
  }
  function Yr(e, r) {
    var t = e.t == "d" && r instanceof Date;
    if (e.z != null)
      try {
        return (e.w = C.format(e.z, t ? P(r) : r));
      } catch (a) {}
    try {
      return (e.w = C.format(
        (e.XF || {}).numFmtId || (t ? 14 : 0),
        t ? P(r) : r
      ));
    } catch (a) {
      return "" + r;
    }
  }
  function $r(e, r, t) {
    if (e == null || e.t == null || e.t == "z") return "";
    if (e.w !== undefined) return e.w;
    if (e.t == "d" && !e.z && t && t.dateNF) e.z = t.dateNF;
    if (r == undefined) return Yr(e, e.v);
    return Yr(e, r);
  }
  function Zr(e, r) {
    var t = r && r.sheet ? r.sheet : "Sheet1";
    var a = {};
    a[t] = e;
    return { SheetNames: [t], Sheets: a };
  }
  function Qr(e, r) {
    var t = r || {};
    if (c != null && t.dense == null) t.dense = c;
    var a = t.dense ? [] : {};
    var n = { s: { c: 1e7, r: 1e7 }, e: { c: 0, r: 0 } };
    for (var i = 0; i != e.length; ++i) {
      for (var s = 0; s != e[i].length; ++s) {
        if (typeof e[i][s] === "undefined") continue;
        var f = { v: e[i][s] };
        if (Array.isArray(f.v)) {
          f.f = e[i][s][1];
          f.v = f.v[0];
        }
        if (n.s.r > i) n.s.r = i;
        if (n.s.c > s) n.s.c = s;
        if (n.e.r < i) n.e.r = i;
        if (n.e.c < s) n.e.c = s;
        if (f.v === null) {
          if (f.f) f.t = "n";
          else if (!t.cellStubs) continue;
          else f.t = "z";
        } else if (typeof f.v === "number") f.t = "n";
        else if (typeof f.v === "boolean") f.t = "b";
        else if (f.v instanceof Date) {
          f.z = t.dateNF || C._table[14];
          if (t.cellDates) {
            f.t = "d";
            f.w = C.format(f.z, P(f.v));
          } else {
            f.t = "n";
            f.v = P(f.v);
            f.w = C.format(f.z, f.v);
          }
        } else f.t = "s";
        if (t.dense) {
          if (!a[i]) a[i] = [];
          a[i][s] = f;
        } else {
          var o = Vr({ c: s, r: i });
          a[o] = f;
        }
      }
    }
    if (n.s.c < 1e7) a["!ref"] = jr(n);
    return a;
  }
  function Jr(e, r) {
    if (!r) r = Sr(4);
    r.write_shift(4, e);
    return r;
  }
  function qr(e) {
    var r = e.read_shift(4);
    return r === 0 ? "" : e.read_shift(r, "dbcs");
  }
  function et(e, r) {
    var t = false;
    if (r == null) {
      t = true;
      r = Sr(4 + 2 * e.length);
    }
    r.write_shift(4, e.length);
    if (e.length > 0) r.write_shift(0, e, "dbcs");
    return t ? r.slice(0, r.l) : r;
  }
  function rt(e, r) {
    return { ich: e.read_shift(2), ifnt: e.read_shift(2) };
  }
  function tt(e, r) {
    if (!r) r = Sr(4);
    r.write_shift(2, e.ich || 0);
    r.write_shift(2, e.ifnt || 0);
    return r;
  }
  function at(e, r) {
    var t = e.l;
    var a = e.read_shift(1);
    var n = qr(e);
    var i = [];
    var s = { t: n, h: n };
    if ((a & 1) !== 0) {
      var f = e.read_shift(4);
      for (var o = 0; o != f; ++o) i.push(rt(e));
      s.r = i;
    } else s.r = [{ ich: 0, ifnt: 0 }];
    e.l = t + r;
    return s;
  }
  function nt(e, r) {
    var t = false;
    if (r == null) {
      t = true;
      r = Sr(15 + 4 * e.t.length);
    }
    r.write_shift(1, 0);
    et(e.t, r);
    return t ? r.slice(0, r.l) : r;
  }
  var it = at;
  function st(e, r) {
    var t = false;
    if (r == null) {
      t = true;
      r = Sr(23 + 4 * e.t.length);
    }
    r.write_shift(1, 1);
    et(e.t, r);
    r.write_shift(4, 1);
    tt({ ich: 0, ifnt: 0 }, r);
    return t ? r.slice(0, r.l) : r;
  }
  function ft(e) {
    var r = e.read_shift(4);
    var t = e.read_shift(2);
    t += e.read_shift(1) << 16;
    var a = e.read_shift(1);
    return { c: r, iStyleRef: t };
  }
  function ot(e, r) {
    if (r == null) r = Sr(8);
    r.write_shift(-4, e.c);
    r.write_shift(3, e.iStyleRef || e.s);
    r.write_shift(1, 0);
    return r;
  }
  var lt = qr;
  var ct = et;
  function ht(e) {
    var r = e.read_shift(4);
    return r === 0 || r === 4294967295 ? "" : e.read_shift(r, "dbcs");
  }
  function ut(e, r) {
    var t = false;
    if (r == null) {
      t = true;
      r = Sr(127);
    }
    r.write_shift(4, e.length > 0 ? e.length : 4294967295);
    if (e.length > 0) r.write_shift(0, e, "dbcs");
    return t ? r.slice(0, r.l) : r;
  }
  var dt = qr;
  var vt = et;
  var pt = ht;
  var gt = ut;
  function bt(e) {
    var r = e.slice(e.l, e.l + 4);
    var t = r[0] & 1,
      a = r[0] & 2;
    e.l += 4;
    r[0] &= 252;
    var n =
      a === 0 ? tr([0, 0, 0, 0, r[0], r[1], r[2], r[3]], 0) : lr(r, 0) >> 2;
    return t ? n / 100 : n;
  }
  function mt(e, r) {
    if (r == null) r = Sr(4);
    var t = 0,
      a = 0,
      n = e * 100;
    if (e == (e | 0) && e >= -(1 << 29) && e < 1 << 29) {
      a = 1;
    } else if (n == (n | 0) && n >= -(1 << 29) && n < 1 << 29) {
      a = 1;
      t = 1;
    }
    if (a) r.write_shift(-4, ((t ? n : e) << 2) + (t + 2));
    else throw new Error("unsupported RkNumber " + e);
  }
  function Ct(e) {
    var r = { s: {}, e: {} };
    r.s.r = e.read_shift(4);
    r.e.r = e.read_shift(4);
    r.s.c = e.read_shift(4);
    r.e.c = e.read_shift(4);
    return r;
  }
  function Et(e, r) {
    if (!r) r = Sr(16);
    r.write_shift(4, e.s.r);
    r.write_shift(4, e.e.r);
    r.write_shift(4, e.s.c);
    r.write_shift(4, e.e.c);
    return r;
  }
  var kt = Ct;
  var St = Et;
  function wt(e, r) {
    return e.read_shift(8, "f");
  }
  function At(e, r) {
    return (r || Sr(8)).write_shift(8, e, "f");
  }
  var Bt = {
    0: "#NULL!",
    7: "#DIV/0!",
    15: "#VALUE!",
    23: "#REF!",
    29: "#NAME?",
    36: "#NUM!",
    42: "#N/A",
    43: "#GETTING_DATA",
    255: "#WTF?",
  };
  var _t = R(Bt);
  function Tt(e, r) {
    var t = {};
    var a = e.read_shift(1);
    var n = a & 1;
    var i = a >>> 1;
    var s = e.read_shift(1);
    var f = e.read_shift(2, "i");
    var o = e.read_shift(1);
    var l = e.read_shift(1);
    var c = e.read_shift(1);
    var h = e.read_shift(1);
    switch (i) {
      case 0:
        t.auto = 1;
        break;
      case 1:
        t.index = s;
        var u = Zt[s];
        if (u) t.rgb = Au(u);
        break;
      case 2:
        t.rgb = Au([o, l, c]);
        break;
      case 3:
        t.theme = s;
        break;
    }
    if (f != 0) t.tint = f > 0 ? f / 32767 : f / 32768;
    return t;
  }
  function xt(e, r) {
    if (!r) r = Sr(8);
    if (!e || e.auto) {
      r.write_shift(4, 0);
      r.write_shift(4, 0);
      return r;
    }
    if (e.index) {
      r.write_shift(1, 2);
      r.write_shift(1, e.index);
    } else if (e.theme) {
      r.write_shift(1, 6);
      r.write_shift(1, e.theme);
    } else {
      r.write_shift(1, 5);
      r.write_shift(1, 0);
    }
    var t = e.tint || 0;
    if (t > 0) t *= 32767;
    else if (t < 0) t *= 32768;
    r.write_shift(2, t);
    if (!e.rgb) {
      r.write_shift(2, 0);
      r.write_shift(1, 0);
      r.write_shift(1, 0);
    } else {
      var a = e.rgb || "FFFFFF";
      r.write_shift(1, parseInt(a.substr(0, 2), 16));
      r.write_shift(1, parseInt(a.substr(2, 2), 16));
      r.write_shift(1, parseInt(a.substr(4, 2), 16));
      r.write_shift(1, 255);
    }
    return r;
  }
  function It(e, r, t) {
    var a = e.read_shift(1);
    e.l++;
    var n = {
      fItalic: a & 2,
      fStrikeout: a & 8,
      fOutline: a & 16,
      fShadow: a & 32,
      fCondense: a & 64,
      fExtend: a & 128,
    };
    return n;
  }
  function yt(e, r) {
    if (!r) r = Sr(2);
    var t =
      (e.italic ? 2 : 0) |
      (e.strike ? 8 : 0) |
      (e.outline ? 16 : 0) |
      (e.shadow ? 32 : 0) |
      (e.condense ? 64 : 0) |
      (e.extend ? 128 : 0);
    r.write_shift(1, t);
    r.write_shift(1, 0);
    return r;
  }
  {
    var Rt = 2;
    var Dt = 3;
    var Ot = 11;
    var Ft = 12;
    var Pt = 19;
    var Nt = 21;
    var Lt = 30;
    var Mt = 64;
    var Ut = 71;
    var Ht = 4096;
    var Wt = 80;
    var Vt = 81;
    var zt = [Wt, Vt];
  }
  var Xt = {
    1: { n: "CodePage", t: Rt },
    2: { n: "Category", t: Wt },
    3: { n: "PresentationFormat", t: Wt },
    4: { n: "ByteCount", t: Dt },
    5: { n: "LineCount", t: Dt },
    6: { n: "ParagraphCount", t: Dt },
    7: { n: "SlideCount", t: Dt },
    8: { n: "NoteCount", t: Dt },
    9: { n: "HiddenCount", t: Dt },
    10: { n: "MultimediaClipCount", t: Dt },
    11: { n: "Scale", t: Ot },
    12: { n: "HeadingPair", t: Ht | Ft },
    13: { n: "DocParts", t: Ht | Lt },
    14: { n: "Manager", t: Wt },
    15: { n: "Company", t: Wt },
    16: { n: "LinksDirty", t: Ot },
    17: { n: "CharacterCount", t: Dt },
    19: { n: "SharedDoc", t: Ot },
    22: { n: "HLinksChanged", t: Ot },
    23: { n: "AppVersion", t: Dt, p: "version" },
    26: { n: "ContentType", t: Wt },
    27: { n: "ContentStatus", t: Wt },
    28: { n: "Language", t: Wt },
    29: { n: "Version", t: Wt },
    255: {},
  };
  var Gt = {
    1: { n: "CodePage", t: Rt },
    2: { n: "Title", t: Wt },
    3: { n: "Subject", t: Wt },
    4: { n: "Author", t: Wt },
    5: { n: "Keywords", t: Wt },
    6: { n: "Comments", t: Wt },
    7: { n: "Template", t: Wt },
    8: { n: "LastAuthor", t: Wt },
    9: { n: "RevNumber", t: Wt },
    10: { n: "EditTime", t: Mt },
    11: { n: "LastPrinted", t: Mt },
    12: { n: "CreatedDate", t: Mt },
    13: { n: "ModifiedDate", t: Mt },
    14: { n: "PageCount", t: Dt },
    15: { n: "WordCount", t: Dt },
    16: { n: "CharCount", t: Dt },
    17: { n: "Thumbnail", t: Ut },
    18: { n: "ApplicationName", t: Lt },
    19: { n: "DocumentSecurity", t: Dt },
    255: {},
  };
  var jt = {
    2147483648: { n: "Locale", t: Pt },
    2147483651: { n: "Behavior", t: Pt },
    1919054434: {},
  };
  (function () {
    for (var e in jt) if (jt.hasOwnProperty(e)) Xt[e] = Gt[e] = jt[e];
  })();
  var Kt = {
    1: "US",
    2: "CA",
    3: "",
    7: "RU",
    20: "EG",
    30: "GR",
    31: "NL",
    32: "BE",
    33: "FR",
    34: "ES",
    36: "HU",
    39: "IT",
    41: "CH",
    43: "AT",
    44: "GB",
    45: "DK",
    46: "SE",
    47: "NO",
    48: "PL",
    49: "DE",
    52: "MX",
    55: "BR",
    61: "AU",
    64: "NZ",
    66: "TH",
    81: "JP",
    82: "KR",
    84: "VN",
    86: "CN",
    90: "TR",
    105: "JS",
    213: "DZ",
    216: "MA",
    218: "LY",
    351: "PT",
    354: "IS",
    358: "FI",
    420: "CZ",
    886: "TW",
    961: "LB",
    962: "JO",
    963: "SY",
    964: "IQ",
    965: "KW",
    966: "SA",
    971: "AE",
    972: "IL",
    974: "QA",
    981: "IR",
    65535: "US",
  };
  var Yt = [
    null,
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625",
  ];
  function $t(e) {
    return e.map(function (e) {
      return [(e >> 16) & 255, (e >> 8) & 255, e & 255];
    });
  }
  var Zt = $t([
    0, 16777215, 16711680, 65280, 255, 16776960, 16711935, 65535, 0, 16777215,
    16711680, 65280, 255, 16776960, 16711935, 65535, 8388608, 32768, 128,
    8421376, 8388736, 32896, 12632256, 8421504, 10066431, 10040166, 16777164,
    13434879, 6684774, 16744576, 26316, 13421823, 128, 16711935, 16776960,
    65535, 8388736, 8388608, 32896, 255, 52479, 13434879, 13434828, 16777113,
    10079487, 16751052, 13408767, 16764057, 3368703, 3394764, 10079232,
    16763904, 16750848, 16737792, 6710937, 9868950, 13158, 3381606, 13056,
    3355392, 10040064, 10040166, 3355545, 3355443, 16777215, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  var Qt = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":
      "workbooks",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml":
      "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml":
      "extprops",
    "application/vnd.openxmlformats-officedocument.customXmlProperties+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":
      "TODO",
    "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":
      "TODO",
    "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    "application/vnd.ms-office.chartstyle+xml": "TODO",
    "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":
      "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":
      "TODO",
    "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    "application/vnd.ms-excel.attachedToolbars": "TODO",
    "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":
      "TODO",
    "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":
      "links",
    "application/vnd.ms-excel.sheetMetadata": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":
      "TODO",
    "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":
      "TODO",
    "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":
      "TODO",
    "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":
      "TODO",
    "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":
      "TODO",
    "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    "application/vnd.ms-excel.wsSortMap": "TODO",
    "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    "application/vnd.ms-excel.Timeline+xml": "TODO",
    "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "vba",
    "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":
      "TODO",
    "application/vnd.ms-excel.controlproperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    "application/vnd.ms-excel.Survey+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    "image/png": "TODO",
    sheet: "js",
  };
  var Jt = (function () {
    var e = {
      workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml",
      },
      strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings",
      },
      comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments",
      },
      sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet",
      },
      charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet",
      },
      dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet",
      },
      macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet",
      },
      styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles",
      },
    };
    x(e).forEach(function (r) {
      if (!e[r].xlsm) e[r].xlsm = e[r].xlsx;
    });
    x(e).forEach(function (r) {
      x(e[r]).forEach(function (t) {
        Qt[e[r][t]] = r;
      });
    });
    return e;
  })();
  var qt = D(Qt);
  Ne.CT = "http://schemas.openxmlformats.org/package/2006/content-types";
  function ea() {
    return {
      workbooks: [],
      sheets: [],
      charts: [],
      dialogs: [],
      macros: [],
      rels: [],
      strs: [],
      comments: [],
      links: [],
      coreprops: [],
      extprops: [],
      custprops: [],
      themes: [],
      styles: [],
      calcchains: [],
      vba: [],
      drawings: [],
      TODO: [],
      xmlns: "",
    };
  }
  function ra(e, r) {
    var t = ea();
    if (!e || !e.match) return t;
    var a = {};
    (e.match(ae) || []).forEach(function (e) {
      var r = se(e);
      switch (r[0].replace(ne, "<")) {
        case "<?xml":
          break;
        case "<Types":
          t.xmlns = r["xmlns" + (r[0].match(/<(\w+):/) || ["", ""])[1]];
          break;
        case "<Default":
          a[r.Extension] = r.ContentType;
          break;
        case "<Override":
          if (t[Qt[r.ContentType]] !== undefined)
            t[Qt[r.ContentType]].push(r.PartName);
          break;
      }
    });
    if (t.xmlns !== Ne.CT) throw new Error("Unknown Namespace: " + t.xmlns);
    t.calcchain = t.calcchains.length > 0 ? t.calcchains[0] : "";
    t.sst = t.strs.length > 0 ? t.strs[0] : "";
    t.style = t.styles.length > 0 ? t.styles[0] : "";
    t.defaults = a;
    delete t.calcchains;
    return t;
  }
  var ta = De("Types", null, {
    xmlns: Ne.CT,
    "xmlns:xsd": Ne.xsd,
    "xmlns:xsi": Ne.xsi,
  });
  var aa = [
    ["xml", "application/xml"],
    ["bin", "application/vnd.ms-excel.sheet.binary.macroEnabled.main"],
    ["vml", "application/vnd.openxmlformats-officedocument.vmlDrawing"],
    ["bmp", "image/bmp"],
    ["png", "image/png"],
    ["gif", "image/gif"],
    ["emf", "image/x-emf"],
    ["wmf", "image/x-wmf"],
    ["jpg", "image/jpeg"],
    ["jpeg", "image/jpeg"],
    ["tif", "image/tiff"],
    ["tiff", "image/tiff"],
    ["pdf", "application/pdf"],
    ["rels", qt.rels[0]],
  ].map(function (e) {
    return De("Default", null, { Extension: e[0], ContentType: e[1] });
  });
  function na(e, r) {
    var t = [],
      a;
    t[t.length] = Pe;
    t[t.length] = ta;
    t = t.concat(aa);
    var n = function (n) {
      if (e[n] && e[n].length > 0) {
        a = e[n][0];
        t[t.length] = De("Override", null, {
          PartName: (a[0] == "/" ? "" : "/") + a,
          ContentType: Jt[n][r.bookType || "xlsx"],
        });
      }
    };
    var i = function (a) {
      (e[a] || []).forEach(function (e) {
        t[t.length] = De("Override", null, {
          PartName: (e[0] == "/" ? "" : "/") + e,
          ContentType: Jt[a][r.bookType || "xlsx"],
        });
      });
    };
    var s = function (r) {
      (e[r] || []).forEach(function (e) {
        t[t.length] = De("Override", null, {
          PartName: (e[0] == "/" ? "" : "/") + e,
          ContentType: qt[r][0],
        });
      });
    };
    n("workbooks");
    i("sheets");
    i("charts");
    s("themes");
    ["strs", "styles"].forEach(n);
    ["coreprops", "extprops", "custprops"].forEach(s);
    s("vba");
    s("comments");
    s("drawings");
    if (t.length > 2) {
      t[t.length] = "</Types>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  var ia = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET:
      "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK:
      "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject",
  };
  function sa(e) {
    var r = e.lastIndexOf("/");
    return e.substr(0, r + 1) + "_rels/" + e.substr(r + 1) + ".rels";
  }
  function fa(e, r) {
    if (!e) return e;
    if (r.charAt(0) !== "/") {
      r = "/" + r;
    }
    var t = {};
    var a = {};
    (e.match(ae) || []).forEach(function (e) {
      var n = se(e);
      if (n[0] === "<Relationship") {
        var i = {};
        i.Type = n.Type;
        i.Target = n.Target;
        i.Id = n.Id;
        i.TargetMode = n.TargetMode;
        var s = n.TargetMode === "External" ? n.Target : re(n.Target, r);
        t[s] = i;
        a[n.Id] = i;
      }
    });
    t["!id"] = a;
    return t;
  }
  Ne.RELS = "http://schemas.openxmlformats.org/package/2006/relationships";
  var oa = De("Relationships", null, { xmlns: Ne.RELS });
  function la(e) {
    var r = [Pe, oa];
    x(e["!id"]).forEach(function (t) {
      r[r.length] = De("Relationship", null, e["!id"][t]);
    });
    if (r.length > 2) {
      r[r.length] = "</Relationships>";
      r[1] = r[1].replace("/>", ">");
    }
    return r.join("");
  }
  function ca(e, r, t, a, n) {
    if (!n) n = {};
    if (!e["!id"]) e["!id"] = {};
    if (r < 0) for (r = 1; e["!id"]["rId" + r]; ++r) {}
    n.Id = "rId" + r;
    n.Type = a;
    n.Target = t;
    if (n.Type == ia.HLINK) n.TargetMode = "External";
    if (e["!id"][n.Id]) throw new Error("Cannot rewrite rId " + r);
    e["!id"][n.Id] = n;
    e[("/" + n.Target).replace("//", "/")] = n;
    return r;
  }
  var ha = "application/vnd.oasis.opendocument.spreadsheet";
  function ua(e, r) {
    var t = Zm(e);
    var a;
    var n;
    while ((a = Qm.exec(t)))
      switch (a[3]) {
        case "manifest":
          break;
        case "file-entry":
          n = se(a[0], false);
          if (n.path == "/" && n.type !== ha)
            throw new Error("This OpenDocument is not a spreadsheet");
          break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
          throw new Error("Unsupported ODS Encryption");
        default:
          if (r && r.WTF) throw a;
      }
  }
  function da(e, r) {
    var t = [Pe];
    t.push(
      '<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n'
    );
    t.push(
      '  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n'
    );
    for (var a = 0; a < e.length; ++a)
      t.push(
        '  <manifest:file-entry manifest:full-path="' +
          e[a][0] +
          '" manifest:media-type="' +
          e[a][1] +
          '"/>\n'
      );
    t.push("</manifest:manifest>");
    return t.join("");
  }
  function va(e, r, t) {
    return [
      '  <rdf:Description rdf:about="' + e + '">\n',
      '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' +
        (t || "odf") +
        "#" +
        r +
        '"/>\n',
      "  </rdf:Description>\n",
    ].join("");
  }
  function pa(e, r) {
    return [
      '  <rdf:Description rdf:about="' + e + '">\n',
      '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' +
        r +
        '"/>\n',
      "  </rdf:Description>\n",
    ].join("");
  }
  function ga(e, r) {
    var t = [Pe];
    t.push(
      '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n'
    );
    for (var a = 0; a != e.length; ++a) {
      t.push(va(e[a][0], e[a][1]));
      t.push(pa("", e[a][0]));
    }
    t.push(va("", "Document", "pkg"));
    t.push("</rdf:RDF>");
    return t.join("");
  }
  var ba = (function () {
    var e =
      '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' +
      "JS " +
      r.version +
      "</meta:generator></office:meta></office:document-meta>";
    return function t(r, a) {
      return e;
    };
  })();
  var ma = [
    ["cp:category", "Category"],
    ["cp:contentStatus", "ContentStatus"],
    ["cp:keywords", "Keywords"],
    ["cp:lastModifiedBy", "LastAuthor"],
    ["cp:lastPrinted", "LastPrinted"],
    ["cp:revision", "RevNumber"],
    ["cp:version", "Version"],
    ["dc:creator", "Author"],
    ["dc:description", "Comments"],
    ["dc:identifier", "Identifier"],
    ["dc:language", "Language"],
    ["dc:subject", "Subject"],
    ["dc:title", "Title"],
    ["dcterms:created", "CreatedDate", "date"],
    ["dcterms:modified", "ModifiedDate", "date"],
  ];
  Ne.CORE_PROPS =
    "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
  ia.CORE_PROPS =
    "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties";
  var Ca = (function () {
    var e = new Array(ma.length);
    for (var r = 0; r < ma.length; ++r) {
      var t = ma[r];
      var a =
        "(?:" +
        t[0].substr(0, t[0].indexOf(":")) +
        ":)" +
        t[0].substr(t[0].indexOf(":") + 1);
      e[r] = new RegExp("<" + a + "[^>]*>([\\s\\S]*?)</" + a + ">");
    }
    return e;
  })();
  function Ea(e) {
    var r = {};
    for (var t = 0; t < ma.length; ++t) {
      var a = ma[t],
        n = e.match(Ca[t]);
      if (n != null && n.length > 0) r[a[1]] = n[1];
      if (a[2] === "date" && r[a[1]]) r[a[1]] = H(r[a[1]]);
    }
    return r;
  }
  var ka = De("cp:coreProperties", null, {
    "xmlns:cp": Ne.CORE_PROPS,
    "xmlns:dc": Ne.dc,
    "xmlns:dcterms": Ne.dcterms,
    "xmlns:dcmitype": Ne.dcmitype,
    "xmlns:xsi": Ne.xsi,
  });
  function Sa(e, r, t, a, n) {
    if (n[e] != null || r == null || r === "") return;
    n[e] = r;
    a[a.length] = t ? De(e, r, t) : ye(e, r);
  }
  function wa(e, r) {
    var t = r || {};
    var a = [Pe, ka],
      n = {};
    if (!e && !t.Props) return a.join("");
    if (e) {
      if (e.CreatedDate != null)
        Sa(
          "dcterms:created",
          typeof e.CreatedDate === "string"
            ? e.CreatedDate
            : Oe(e.CreatedDate, t.WTF),
          { "xsi:type": "dcterms:W3CDTF" },
          a,
          n
        );
      if (e.ModifiedDate != null)
        Sa(
          "dcterms:modified",
          typeof e.ModifiedDate === "string"
            ? e.ModifiedDate
            : Oe(e.ModifiedDate, t.WTF),
          { "xsi:type": "dcterms:W3CDTF" },
          a,
          n
        );
    }
    for (var i = 0; i != ma.length; ++i) {
      var s = ma[i];
      var f =
        t.Props && t.Props[s[1]] != null ? t.Props[s[1]] : e ? e[s[1]] : null;
      if (f === true) f = "1";
      else if (f === false) f = "0";
      else if (typeof f == "number") f = String(f);
      if (f != null) Sa(s[0], f, null, a, n);
    }
    if (a.length > 2) {
      a[a.length] = "</cp:coreProperties>";
      a[1] = a[1].replace("/>", ">");
    }
    return a.join("");
  }
  var Aa = [
    ["Application", "Application", "string"],
    ["AppVersion", "AppVersion", "string"],
    ["Company", "Company", "string"],
    ["DocSecurity", "DocSecurity", "string"],
    ["Manager", "Manager", "string"],
    ["HyperlinksChanged", "HyperlinksChanged", "bool"],
    ["SharedDoc", "SharedDoc", "bool"],
    ["LinksUpToDate", "LinksUpToDate", "bool"],
    ["ScaleCrop", "ScaleCrop", "bool"],
    ["HeadingPairs", "HeadingPairs", "raw"],
    ["TitlesOfParts", "TitlesOfParts", "raw"],
  ];
  Ne.EXT_PROPS =
    "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
  ia.EXT_PROPS =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties";
  function Ba(e, r) {
    var t = {};
    if (!r) r = {};
    Aa.forEach(function (a) {
      switch (a[2]) {
        case "string":
          r[a[1]] = (e.match(Ae(a[0])) || [])[1];
          break;
        case "bool":
          r[a[1]] = (e.match(Ae(a[0])) || [])[1] === "true";
          break;
        case "raw":
          var n = e.match(
            new RegExp("<" + a[0] + "[^>]*>([\\s\\S]*?)</" + a[0] + ">")
          );
          if (n && n.length > 0) t[a[1]] = n[1];
          break;
      }
    });
    if (t.HeadingPairs && t.TitlesOfParts) {
      var a = xe(t.HeadingPairs);
      var n = xe(t.TitlesOfParts).map(function (e) {
        return e.v;
      });
      var i = 0,
        s = 0;
      for (var f = 0; f !== a.length; f += 2) {
        s = +a[f + 1].v;
        switch (a[f].v) {
          case "Worksheets":
          case "工作表":
          case "Листы":
          case "أوراق العمل":
          case "ワークシート":
          case "גליונות עבודה":
          case "Arbeitsblätter":
          case "Çalışma Sayfaları":
          case "Feuilles de calcul":
          case "Fogli di lavoro":
          case "Folhas de cálculo":
          case "Planilhas":
          case "Regneark":
          case "Werkbladen":
            r.Worksheets = s;
            r.SheetNames = n.slice(i, i + s);
            break;
          case "Named Ranges":
          case "名前付き一覧":
          case "Benannte Bereiche":
          case "Navngivne områder":
            r.NamedRanges = s;
            r.DefinedNames = n.slice(i, i + s);
            break;
          case "Charts":
          case "Diagramme":
            r.Chartsheets = s;
            r.ChartNames = n.slice(i, i + s);
            break;
        }
        i += s;
      }
    }
    return r;
  }
  var _a = De("Properties", null, { xmlns: Ne.EXT_PROPS, "xmlns:vt": Ne.vt });
  function Ta(e, r) {
    var t = [],
      a = {},
      n = De;
    if (!e) e = {};
    e.Application = "SheetJS";
    t[t.length] = Pe;
    t[t.length] = _a;
    Aa.forEach(function (r) {
      if (e[r[1]] === undefined) return;
      var a;
      switch (r[2]) {
        case "string":
          a = String(e[r[1]]);
          break;
        case "bool":
          a = e[r[1]] ? "true" : "false";
          break;
      }
      if (a !== undefined) t[t.length] = n(r[0], a);
    });
    t[t.length] = n(
      "HeadingPairs",
      n(
        "vt:vector",
        n("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") +
          n("vt:variant", n("vt:i4", String(e.Worksheets))),
        { size: 2, baseType: "variant" }
      )
    );
    t[t.length] = n(
      "TitlesOfParts",
      n(
        "vt:vector",
        e.SheetNames.map(function (e) {
          return "<vt:lpstr>" + de(e) + "</vt:lpstr>";
        }).join(""),
        { size: e.Worksheets, baseType: "lpstr" }
      )
    );
    if (t.length > 2) {
      t[t.length] = "</Properties>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  Ne.CUST_PROPS =
    "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";
  ia.CUST_PROPS =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties";
  var xa = /<[^>]+>[^<]*/g;
  function Ia(e, r) {
    var t = {},
      a = "";
    var n = e.match(xa);
    if (n)
      for (var i = 0; i != n.length; ++i) {
        var s = n[i],
          f = se(s);
        switch (f[0]) {
          case "<?xml":
            break;
          case "<Properties":
            break;
          case "<property":
            a = f.name;
            break;
          case "</property>":
            a = null;
            break;
          default:
            if (s.indexOf("<vt:") === 0) {
              var o = s.split(">");
              var l = o[0].substring(4),
                c = o[1];
              switch (l) {
                case "lpstr":
                case "bstr":
                case "lpwstr":
                  t[a] = ce(c);
                  break;
                case "bool":
                  t[a] = Ce(c, "<vt:bool>");
                  break;
                case "i1":
                case "i2":
                case "i4":
                case "i8":
                case "int":
                case "uint":
                  t[a] = parseInt(c, 10);
                  break;
                case "r4":
                case "r8":
                case "decimal":
                  t[a] = parseFloat(c);
                  break;
                case "filetime":
                case "date":
                  t[a] = H(c);
                  break;
                case "cy":
                case "error":
                  t[a] = ce(c);
                  break;
                default:
                  if (l.slice(-1) == "/") break;
                  if (r.WTF && typeof console !== "undefined")
                    console.warn("Unexpected", s, l, o);
              }
            } else if (s.substr(0, 2) === "</") {
            } else if (r.WTF) throw new Error(s);
        }
      }
    return t;
  }
  var ya = De("Properties", null, { xmlns: Ne.CUST_PROPS, "xmlns:vt": Ne.vt });
  function Ra(e, r) {
    var t = [Pe, ya];
    if (!e) return t.join("");
    var a = 1;
    x(e).forEach(function n(r) {
      ++a;
      t[t.length] = De("property", Fe(e[r]), {
        fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
        pid: a,
        name: r,
      });
    });
    if (t.length > 2) {
      t[t.length] = "</Properties>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  var Da = {
    Title: "Title",
    Subject: "Subject",
    Author: "Author",
    Keywords: "Keywords",
    Comments: "Description",
    LastAuthor: "LastAuthor",
    RevNumber: "Revision",
    Application: "AppName",
    LastPrinted: "LastPrinted",
    CreatedDate: "Created",
    ModifiedDate: "LastSaved",
    Category: "Category",
    Manager: "Manager",
    Company: "Company",
    AppVersion: "Version",
    ContentStatus: "ContentStatus",
    Identifier: "Identifier",
    Language: "Language",
  };
  var Oa = y(Da);
  function Fa(e, r, t) {
    r = Oa[r] || r;
    e[r] = t;
  }
  function Pa(e, r) {
    var t = [];
    x(Da)
      .map(function (e) {
        for (var r = 0; r < ma.length; ++r) if (ma[r][1] == e) return ma[r];
        for (r = 0; r < Aa.length; ++r) if (Aa[r][1] == e) return Aa[r];
        throw e;
      })
      .forEach(function (a) {
        if (e[a[1]] == null) return;
        var n = r && r.Props && r.Props[a[1]] != null ? r.Props[a[1]] : e[a[1]];
        switch (a[2]) {
          case "date":
            n = new Date(n).toISOString().replace(/\.\d*Z/, "Z");
            break;
        }
        if (typeof n == "number") n = String(n);
        else if (n === true || n === false) {
          n = n ? "1" : "0";
        } else if (n instanceof Date)
          n = new Date(n).toISOString().replace(/\.\d*Z/, "");
        t.push(ye(Da[a[1]] || a[1], n));
      });
    return De("DocumentProperties", t.join(""), { xmlns: Le.o });
  }
  function Na(e, r, t) {
    var a = ["Worksheets", "SheetNames"];
    var n = "CustomDocumentProperties";
    var i = [];
    if (e)
      x(e).forEach(function (r) {
        if (!e.hasOwnProperty(r)) return;
        for (var t = 0; t < ma.length; ++t) if (r == ma[t][1]) return;
        for (t = 0; t < Aa.length; ++t) if (r == Aa[t][1]) return;
        for (t = 0; t < a.length; ++t) if (r == a[t]) return;
        var n = e[r];
        var s = "string";
        if (typeof n == "number") {
          s = "float";
          n = String(n);
        } else if (n === true || n === false) {
          s = "boolean";
          n = n ? "1" : "0";
        } else n = String(n);
        i.push(De(ve(r), n, { "dt:dt": s }));
      });
    if (r)
      x(r).forEach(function (e) {
        if (!r.hasOwnProperty(e)) return;
        var t = r[e];
        var a = "string";
        if (typeof t == "number") {
          a = "float";
          t = String(t);
        } else if (t === true || t === false) {
          a = "boolean";
          t = t ? "1" : "0";
        } else if (t instanceof Date) {
          a = "dateTime.tz";
          t = t.toISOString();
        } else t = String(t);
        i.push(De(ve(e), t, { "dt:dt": a }));
      });
    return "<" + n + ' xmlns="' + Le.o + '">' + i.join("") + "</" + n + ">";
  }
  function La(e) {
    var r = e.read_shift(4),
      t = e.read_shift(4);
    return new Date(((t / 1e7) * Math.pow(2, 32) + r / 1e7 - 11644473600) * 1e3)
      .toISOString()
      .replace(/\.000/, "");
  }
  function Ma(e, r, t) {
    var a = e.read_shift(0, "lpstr");
    if (t) e.l += (4 - ((a.length + 1) & 3)) & 3;
    return a;
  }
  function Ua(e, r, t) {
    var a = e.read_shift(0, "lpwstr");
    if (t) e.l += (4 - ((a.length + 1) & 3)) & 3;
    return a;
  }
  function Ha(e, r, t) {
    if (r === 31) return Ua(e);
    return Ma(e, r, t);
  }
  function Wa(e, r, t) {
    return Ha(e, r, t === false ? 0 : 4);
  }
  function Va(e, r) {
    if (!r) throw new Error("dafuq?");
    return Ha(e, r, 0);
  }
  function za(e) {
    var r = e.read_shift(4);
    var t = [];
    for (var a = 0; a != r; ++a) t[a] = e.read_shift(0, "lpstr");
    return t;
  }
  function Xa(e) {
    return za(e);
  }
  function Ga(e) {
    var r = Ja(e, Vt);
    var t = Ja(e, Dt);
    return [r, t];
  }
  function ja(e) {
    var r = e.read_shift(4);
    var t = [];
    for (var a = 0; a != r / 2; ++a) t.push(Ga(e));
    return t;
  }
  function Ka(e) {
    return ja(e);
  }
  function Ya(e, r) {
    var t = e.read_shift(4);
    var a = {};
    for (var n = 0; n != t; ++n) {
      var i = e.read_shift(4);
      var s = e.read_shift(4);
      a[i] = e
        .read_shift(s, r === 1200 ? "utf16le" : "utf8")
        .replace(b, "")
        .replace(m, "!");
    }
    if (e.l & 3) e.l = (e.l >> (2 + 1)) << 2;
    return a;
  }
  function $a(e) {
    var r = e.read_shift(4);
    var t = e.slice(e.l, e.l + r);
    if ((r & 3) > 0) e.l += (4 - (r & 3)) & 3;
    return t;
  }
  function Za(e) {
    var r = {};
    r.Size = e.read_shift(4);
    e.l += r.Size;
    return r;
  }
  function Qa(e, r) {}
  function Ja(e, r, t) {
    var a = e.read_shift(2),
      n,
      i = t || {};
    e.l += 2;
    if (r !== Ft)
      if (a !== r && zt.indexOf(r) === -1)
        throw new Error("Expected type " + r + " saw " + a);
    switch (r === Ft ? a : r) {
      case 2:
        n = e.read_shift(2, "i");
        if (!i.raw) e.l += 2;
        return n;
      case 3:
        n = e.read_shift(4, "i");
        return n;
      case 11:
        return e.read_shift(4) !== 0;
      case 19:
        n = e.read_shift(4);
        return n;
      case 30:
        return Ma(e, a, 4).replace(b, "");
      case 31:
        return Ua(e);
      case 64:
        return La(e);
      case 65:
        return $a(e);
      case 71:
        return Za(e);
      case 80:
        return Wa(e, a, !i.raw && 4).replace(b, "");
      case 81:
        return Va(e, a).replace(b, "");
      case 4108:
        return Ka(e);
      case 4126:
        return Xa(e);
      default:
        throw new Error("TypedPropertyValue unrecognized type " + r + " " + a);
    }
  }
  function qa(e, r) {
    var t = e.l;
    var a = e.read_shift(4);
    var i = e.read_shift(4);
    var s = [],
      f = 0;
    var o = 0;
    var l = -1,
      c = {};
    for (f = 0; f != i; ++f) {
      var h = e.read_shift(4);
      var u = e.read_shift(4);
      s[f] = [h, u + t];
    }
    var d = {};
    for (f = 0; f != i; ++f) {
      if (e.l !== s[f][1]) {
        var v = true;
        if (f > 0 && r)
          switch (r[s[f - 1][0]].t) {
            case 2:
              if (e.l + 2 === s[f][1]) {
                e.l += 2;
                v = false;
              }
              break;
            case 80:
              if (e.l <= s[f][1]) {
                e.l = s[f][1];
                v = false;
              }
              break;
            case 4108:
              if (e.l <= s[f][1]) {
                e.l = s[f][1];
                v = false;
              }
              break;
          }
        if (!r && e.l <= s[f][1]) {
          v = false;
          e.l = s[f][1];
        }
        if (v)
          throw new Error(
            "Read Error: Expected address " + s[f][1] + " at " + e.l + " :" + f
          );
      }
      if (r) {
        var p = r[s[f][0]];
        d[p.n] = Ja(e, p.t, { raw: true });
        if (p.p === "version")
          d[p.n] = String(d[p.n] >> 16) + "." + String(d[p.n] & 65535);
        if (p.n == "CodePage")
          switch (d[p.n]) {
            case 0:
              d[p.n] = 1252;
            case 874:
            case 932:
            case 936:
            case 949:
            case 950:
            case 1250:
            case 1251:
            case 1253:
            case 1254:
            case 1255:
            case 1256:
            case 1257:
            case 1258:
            case 1e4:
            case 1200:
            case 1201:
            case 1252:
            case 65e3:
            case -536:
            case 65001:
            case -535:
              n((o = d[p.n]));
              break;
            default:
              throw new Error("Unsupported CodePage: " + d[p.n]);
          }
      } else {
        if (s[f][0] === 1) {
          o = d.CodePage = Ja(e, Rt);
          n(o);
          if (l !== -1) {
            var g = e.l;
            e.l = s[l][1];
            c = Ya(e, o);
            e.l = g;
          }
        } else if (s[f][0] === 0) {
          if (o === 0) {
            l = f;
            e.l = s[f + 1][1];
            continue;
          }
          c = Ya(e, o);
        } else {
          var b = c[s[f][0]];
          var m;
          switch (e[e.l]) {
            case 65:
              e.l += 4;
              m = $a(e);
              break;
            case 30:
              e.l += 4;
              m = Wa(e, e[e.l - 4]);
              break;
            case 31:
              e.l += 4;
              m = Wa(e, e[e.l - 4]);
              break;
            case 3:
              e.l += 4;
              m = e.read_shift(4, "i");
              break;
            case 19:
              e.l += 4;
              m = e.read_shift(4);
              break;
            case 5:
              e.l += 4;
              m = e.read_shift(8, "f");
              break;
            case 11:
              e.l += 4;
              m = an(e, 4);
              break;
            case 64:
              e.l += 4;
              m = H(La(e));
              break;
            default:
              throw new Error("unparsed value: " + e[e.l]);
          }
          d[b] = m;
        }
      }
    }
    e.l = t + a;
    return d;
  }
  function en(e, r) {
    var t = e.content;
    mr(t, 0);
    var a,
      n,
      i,
      s,
      f = 0;
    t.chk("feff", "Byte Order: ");
    var o = t.read_shift(2);
    var l = t.read_shift(4);
    t.chk(_.utils.consts.HEADER_CLSID, "CLSID: ");
    a = t.read_shift(4);
    if (a !== 1 && a !== 2) throw new Error("Unrecognized #Sets: " + a);
    n = t.read_shift(16);
    s = t.read_shift(4);
    if (a === 1 && s !== t.l)
      throw new Error("Length mismatch: " + s + " !== " + t.l);
    else if (a === 2) {
      i = t.read_shift(16);
      f = t.read_shift(4);
    }
    var c = qa(t, r);
    var h = { SystemIdentifier: l };
    for (var u in c) h[u] = c[u];
    h.FMTID = n;
    if (a === 1) return h;
    if (t.l !== f) throw new Error("Length mismatch 2: " + t.l + " !== " + f);
    var d;
    try {
      d = qa(t, null);
    } catch (v) {}
    for (u in d) h[u] = d[u];
    h.FMTID = [n, i];
    return h;
  }
  function rn(e, r) {
    e.read_shift(r);
    return null;
  }
  function tn(e, r, t) {
    var a = [],
      n = e.l + r;
    while (e.l < n) a.push(t(e, n - e.l));
    if (n !== e.l) throw new Error("Slurp error");
    return a;
  }
  function an(e, r) {
    return e.read_shift(r) === 1;
  }
  function nn(e) {
    return e.read_shift(2, "u");
  }
  function sn(e, r) {
    return tn(e, r, nn);
  }
  var fn = an;
  function on(e) {
    var r = e.read_shift(1),
      t = e.read_shift(1);
    return t === 1 ? r : r === 1;
  }
  function ln(e, r, a) {
    var n = e.read_shift(a && a.biff >= 12 ? 2 : 1);
    var i = 1,
      s = "sbcs-cont";
    var f = t;
    if (a && a.biff >= 8) t = 1200;
    if (!a || a.biff == 8) {
      var o = e.read_shift(1);
      if (o) {
        i = 2;
        s = "dbcs-cont";
      }
    } else if (a.biff == 12) {
      i = 2;
      s = "wstr";
    }
    var l = n ? e.read_shift(n, s) : "";
    t = f;
    return l;
  }
  function cn(e) {
    var r = t;
    t = 1200;
    var a = e.read_shift(2),
      n = e.read_shift(1);
    var i = n & 1,
      s = n & 4,
      f = n & 8;
    var o = 1 + (n & 1);
    var l = 0,
      c;
    var h = {};
    if (f) l = e.read_shift(2);
    if (s) c = e.read_shift(4);
    var u = n & 1 ? "dbcs-cont" : "sbcs-cont";
    var d = a === 0 ? "" : e.read_shift(a, u);
    if (f) e.l += 4 * l;
    if (s) e.l += c;
    h.t = d;
    if (!f) {
      h.raw = "<t>" + h.t + "</t>";
      h.r = h.t;
    }
    t = r;
    return h;
  }
  function hn(e, r, t) {
    var a;
    if (t) {
      if (t.biff >= 2 && t.biff <= 5) return e.read_shift(r, "sbcs-cont");
      if (t.biff >= 12) return e.read_shift(r, "dbcs-cont");
    }
    var n = e.read_shift(1);
    if (n === 0) {
      a = e.read_shift(r, "sbcs-cont");
    } else {
      a = e.read_shift(r, "dbcs-cont");
    }
    return a;
  }
  function un(e, r, t) {
    var a = e.read_shift(t && t.biff == 2 ? 1 : 2);
    if (a === 0) {
      e.l++;
      return "";
    }
    return hn(e, a, t);
  }
  function dn(e, r, t) {
    if (t.biff > 5) return un(e, r, t);
    var a = e.read_shift(1);
    if (a === 0) {
      e.l++;
      return "";
    }
    return e.read_shift(a, "sbcs-cont");
  }
  function vn(e, r, t) {
    var a = e.read_shift(1);
    e.l++;
    var n = e.read_shift(2);
    e.l += 2;
    return [a, n];
  }
  var pn = function (e) {
    var r = e.read_shift(4),
      t = e.l;
    var a = false;
    if (r > 24) {
      e.l += r - 24;
      if (e.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") a = true;
      e.l = t;
    }
    var n = e.read_shift((a ? r - 24 : r) >> 1, "utf16le").replace(b, "");
    if (a) e.l += 24;
    return n;
  };
  var gn = function (e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(4);
    var n = e.read_shift(a, "cstr");
    var i = e.read_shift(2);
    var s = e.read_shift(2);
    var f = e.read_shift(4);
    if (f === 0) return n.replace(/\\/g, "/");
    var o = e.read_shift(4);
    var l = e.read_shift(2);
    var c = e.read_shift(o >> 1, "utf16le").replace(b, "");
    return c;
  };
  var bn = function (e, r) {
    var t = e.read_shift(16);
    r -= 16;
    switch (t) {
      case "e0c9ea79f9bace118c8200aa004ba90b":
        return pn(e, r);
      case "0303000000000000c000000000000046":
        return gn(e, r);
      default:
        throw new Error("Unsupported Moniker " + t);
    }
  };
  var mn = function (e, r) {
    var t = e.read_shift(4);
    var a = e.read_shift(t, "utf16le").replace(b, "");
    return a;
  };
  var Cn = function (e, r) {
    var t = e.l + r;
    var a = e.read_shift(4);
    if (a !== 2) throw new Error("Unrecognized streamVersion: " + a);
    var n = e.read_shift(2);
    e.l += 2;
    var i, s, f, o, l, c, h;
    if (n & 16) i = mn(e, t - e.l);
    if (n & 128) s = mn(e, t - e.l);
    if ((n & 257) === 257) f = mn(e, t - e.l);
    if ((n & 257) === 1) o = bn(e, t - e.l);
    if (n & 8) l = mn(e, t - e.l);
    if (n & 32) c = e.read_shift(16);
    if (n & 64) h = La(e);
    e.l = t;
    var u = s || f || o;
    if (l) u += "#" + l;
    return { Target: u };
  };
  function En(e, r) {
    var t = e.read_shift(1),
      a = e.read_shift(1),
      n = e.read_shift(1),
      i = e.read_shift(1);
    return [t, a, n, i];
  }
  function kn(e, r) {
    var t = En(e, r);
    t[3] = 0;
    return t;
  }
  function Sn(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    var n = e.read_shift(2);
    return { r: t, c: a, ixfe: n };
  }
  function wn(e) {
    var r = e.read_shift(2);
    var t = e.read_shift(2);
    e.l += 8;
    return { type: r, flags: t };
  }
  function An(e, r, t) {
    return r === 0 ? "" : dn(e, r, t);
  }
  var Bn = nn;
  function _n(e, r, t) {
    var a = t.biff > 8 ? 4 : 2;
    var n = e.read_shift(a),
      i = e.read_shift(a, "i"),
      s = e.read_shift(a, "i");
    return [n, i, s];
  }
  function Tn(e, r) {
    var t = e.read_shift(2);
    var a = bt(e);
    return [t, a];
  }
  function xn(e, r, t) {
    e.l += 4;
    r -= 4;
    var a = e.l + r;
    var n = ln(e, r, t);
    var i = e.read_shift(2);
    a -= e.l;
    if (i !== a)
      throw new Error("Malformed AddinUdf: padding = " + a + " != " + i);
    e.l += i;
    return n;
  }
  function In(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    var n = e.read_shift(2);
    var i = e.read_shift(2);
    return { s: { c: n, r: t }, e: { c: i, r: a } };
  }
  function yn(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    var n = e.read_shift(1);
    var i = e.read_shift(1);
    return { s: { c: n, r: t }, e: { c: i, r: a } };
  }
  var Rn = yn;
  function Dn(e, r) {
    e.l += 4;
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    var n = e.read_shift(2);
    e.l += 12;
    return [a, t, n];
  }
  function On(e, r) {
    var t = {};
    e.l += 4;
    e.l += 16;
    t.fSharedNote = e.read_shift(2);
    e.l += 4;
    return t;
  }
  function Fn(e, r) {
    var t = {};
    e.l += 4;
    e.cf = e.read_shift(2);
    return t;
  }
  function Pn(e, r) {
    e.l += 2;
    e.l += e.read_shift(2);
  }
  var Nn = {
    0: Pn,
    4: Pn,
    5: Pn,
    6: Pn,
    7: Fn,
    8: Pn,
    9: Pn,
    10: Pn,
    11: Pn,
    12: Pn,
    13: On,
    14: Pn,
    15: Pn,
    16: Pn,
    17: Pn,
    18: Pn,
    19: Pn,
    20: Pn,
    21: Dn,
  };
  function Ln(e, r, t) {
    var a = e.l + r;
    var n = [];
    while (e.l < a) {
      var i = e.read_shift(2);
      e.l -= 2;
      try {
        n.push(Nn[i](e, a - e.l));
      } catch (s) {
        e.l = a;
        return n;
      }
    }
    if (e.l != a) e.l = a;
    return n;
  }
  var Mn = nn;
  function Un(e, r) {
    var t = { BIFFVer: 0, dt: 0 };
    t.BIFFVer = e.read_shift(2);
    r -= 2;
    if (r >= 2) {
      t.dt = e.read_shift(2);
      e.l -= 2;
    }
    switch (t.BIFFVer) {
      case 1536:
      case 1280:
      case 2:
      case 7:
        break;
      default:
        if (r > 6) throw new Error("Unexpected BIFF Ver " + t.BIFFVer);
    }
    e.read_shift(r);
    return t;
  }
  function Hn(e, r) {
    if (r === 0) return 1200;
    var t;
    if ((t = e.read_shift(2)) !== 1200) {
    }
    return 1200;
  }
  function Wn(e, r, t) {
    if (t.enc) {
      e.l += r;
      return "";
    }
    var a = e.l;
    var n = un(e, 0, t);
    e.read_shift(r + a - e.l);
    return n;
  }
  function Vn(e, r, t) {
    var a = e.read_shift(4);
    var n = e.read_shift(1) & 3;
    var i = e.read_shift(1);
    switch (i) {
      case 0:
        i = "Worksheet";
        break;
      case 1:
        i = "Macrosheet";
        break;
      case 2:
        i = "Chartsheet";
        break;
      case 6:
        i = "VBAModule";
        break;
    }
    var s = ln(e, 0, t);
    if (s.length === 0) s = "Sheet1";
    return { pos: a, hs: n, dt: i, name: s };
  }
  function zn(e, r) {
    var t = e.l + r;
    var a = e.read_shift(4);
    var n = e.read_shift(4);
    var i = [];
    for (var s = 0; s != n && e.l < t; ++s) {
      i.push(cn(e));
    }
    i.Count = a;
    i.Unique = n;
    return i;
  }
  function Xn(e, r) {
    var t = {};
    t.dsst = e.read_shift(2);
    e.l += r - 2;
    return t;
  }
  function Gn(e, r) {
    var t = {};
    t.r = e.read_shift(2);
    t.c = e.read_shift(2);
    t.cnt = e.read_shift(2) - t.c;
    var a = e.read_shift(2);
    e.l += 4;
    var n = e.read_shift(1);
    e.l += 3;
    if (n & 7) t.level = n & 7;
    if (n & 32) t.hidden = true;
    if (n & 64) t.hpt = a / 20;
    return t;
  }
  function jn(e, r) {
    var t = wn(e);
    if (t.type != 2211) throw new Error("Invalid Future Record " + t.type);
    var a = e.read_shift(4);
    return a !== 0;
  }
  var Kn = rn;
  function Yn(e, r) {
    e.read_shift(2);
    return e.read_shift(4);
  }
  function $n(e, r, t) {
    var a = 0;
    if (!(t && t.biff == 2)) {
      a = e.read_shift(2);
    }
    var n = e.read_shift(2);
    if (t && t.biff == 2) {
      a = 1 - (n >> 15);
      n &= 32767;
    }
    var i = {
      Unsynced: a & 1,
      DyZero: (a & 2) >> 1,
      ExAsc: (a & 4) >> 2,
      ExDsc: (a & 8) >> 3,
    };
    return [i, n];
  }
  function Zn(e, r) {
    var t = e.read_shift(2),
      a = e.read_shift(2),
      n = e.read_shift(2),
      i = e.read_shift(2);
    var s = e.read_shift(2),
      f = e.read_shift(2),
      o = e.read_shift(2);
    var l = e.read_shift(2),
      c = e.read_shift(2);
    return {
      Pos: [t, a],
      Dim: [n, i],
      Flags: s,
      CurTab: f,
      FirstTab: o,
      Selected: l,
      TabRatio: c,
    };
  }
  function Qn(e, r, t) {
    var a = { dyHeight: e.read_shift(2), fl: e.read_shift(2) };
    switch ((t && t.biff) || 8) {
      case 2:
        break;
      case 3:
      case 4:
        e.l += 2;
        break;
      default:
        e.l += 10;
        break;
    }
    a.name = ln(e, 0, t);
    return a;
  }
  function Jn(e, r) {
    var t = Sn(e);
    t.isst = e.read_shift(4);
    return t;
  }
  function qn(e, r, t) {
    var a = e.l + r;
    var n = Sn(e, 6);
    if (t.biff == 2) e.l++;
    var i = un(e, a - e.l, t);
    n.val = i;
    return n;
  }
  function ei(e, r, t) {
    var a = e.read_shift(2);
    var n = dn(e, 0, t);
    return [a, n];
  }
  var ri = dn;
  function ti(e, r, t) {
    var a = e.l + r;
    var n = t.biff == 8 || !t.biff ? 4 : 2;
    var i = e.read_shift(n),
      s = e.read_shift(n);
    var f = e.read_shift(2),
      o = e.read_shift(2);
    e.l = a;
    return { s: { r: i, c: f }, e: { r: s, c: o } };
  }
  function ai(e, r) {
    var t = e.read_shift(2),
      a = e.read_shift(2);
    var n = Tn(e);
    return { r: t, c: a, ixfe: n[0], rknum: n[1] };
  }
  function ni(e, r) {
    var t = e.l + r - 2;
    var a = e.read_shift(2),
      n = e.read_shift(2);
    var i = [];
    while (e.l < t) i.push(Tn(e));
    if (e.l !== t) throw new Error("MulRK read error");
    var s = e.read_shift(2);
    if (i.length != s - n + 1) throw new Error("MulRK length mismatch");
    return { r: a, c: n, C: s, rkrec: i };
  }
  function ii(e, r) {
    var t = e.l + r - 2;
    var a = e.read_shift(2),
      n = e.read_shift(2);
    var i = [];
    while (e.l < t) i.push(e.read_shift(2));
    if (e.l !== t) throw new Error("MulBlank read error");
    var s = e.read_shift(2);
    if (i.length != s - n + 1) throw new Error("MulBlank length mismatch");
    return { r: a, c: n, C: s, ixfe: i };
  }
  function si(e, r, t, a) {
    var n = {};
    var i = e.read_shift(4),
      s = e.read_shift(4);
    var f = e.read_shift(4),
      o = e.read_shift(2);
    n.patternType = Yt[f >> 26];
    if (!a.cellStyles) return n;
    n.alc = i & 7;
    n.fWrap = (i >> 3) & 1;
    n.alcV = (i >> 4) & 7;
    n.fJustLast = (i >> 7) & 1;
    n.trot = (i >> 8) & 255;
    n.cIndent = (i >> 16) & 15;
    n.fShrinkToFit = (i >> 20) & 1;
    n.iReadOrder = (i >> 22) & 2;
    n.fAtrNum = (i >> 26) & 1;
    n.fAtrFnt = (i >> 27) & 1;
    n.fAtrAlc = (i >> 28) & 1;
    n.fAtrBdr = (i >> 29) & 1;
    n.fAtrPat = (i >> 30) & 1;
    n.fAtrProt = (i >> 31) & 1;
    n.dgLeft = s & 15;
    n.dgRight = (s >> 4) & 15;
    n.dgTop = (s >> 8) & 15;
    n.dgBottom = (s >> 12) & 15;
    n.icvLeft = (s >> 16) & 127;
    n.icvRight = (s >> 23) & 127;
    n.grbitDiag = (s >> 30) & 3;
    n.icvTop = f & 127;
    n.icvBottom = (f >> 7) & 127;
    n.icvDiag = (f >> 14) & 127;
    n.dgDiag = (f >> 21) & 15;
    n.icvFore = o & 127;
    n.icvBack = (o >> 7) & 127;
    n.fsxButton = (o >> 14) & 1;
    return n;
  }
  function fi(e, r, t) {
    return si(e, r, 0, t);
  }
  function oi(e, r, t) {
    return si(e, r, 1, t);
  }
  function li(e, r, t) {
    var a = {};
    a.ifnt = e.read_shift(2);
    a.numFmtId = e.read_shift(2);
    a.flags = e.read_shift(2);
    a.fStyle = (a.flags >> 2) & 1;
    r -= 6;
    a.data = si(e, r, a.fStyle, t);
    return a;
  }
  function ci(e, r) {
    e.l += 4;
    var t = [e.read_shift(2), e.read_shift(2)];
    if (t[0] !== 0) t[0]--;
    if (t[1] !== 0) t[1]--;
    if (t[0] > 7 || t[1] > 7) throw new Error("Bad Gutters: " + t.join("|"));
    return t;
  }
  function hi(e, r, t) {
    var a = Sn(e, 6);
    if (t.biff == 2) ++e.l;
    var n = on(e, 2);
    a.val = n;
    a.t = n === true || n === false ? "b" : "e";
    return a;
  }
  function ui(e, r) {
    var t = Sn(e, 6);
    var a = wt(e, 8);
    t.val = a;
    return t;
  }
  var di = An;
  function vi(e, r, t) {
    var a = e.l + r;
    var n = e.read_shift(2);
    var i = e.read_shift(2);
    t.sbcch = i;
    if (i == 1025 || i == 14849) return [i, n];
    if (i < 1 || i > 255) throw new Error("Unexpected SupBook type: " + i);
    var s = hn(e, i);
    var f = [];
    while (a > e.l) f.push(un(e));
    return [i, n, s, f];
  }
  function pi(e, r, t) {
    var a = e.read_shift(2);
    var n;
    var i = {
      fBuiltIn: a & 1,
      fWantAdvise: (a >>> 1) & 1,
      fWantPict: (a >>> 2) & 1,
      fOle: (a >>> 3) & 1,
      fOleLink: (a >>> 4) & 1,
      cf: (a >>> 5) & 1023,
      fIcon: (a >>> 15) & 1,
    };
    if (t.sbcch === 14849) n = xn(e, r - 2, t);
    i.body = n || e.read_shift(r - 2);
    if (typeof n === "string") i.Name = n;
    return i;
  }
  var gi = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase",
  ];
  function bi(e, r, t) {
    var a = e.l + r;
    var n = e.read_shift(2);
    var i = e.read_shift(1);
    var s = e.read_shift(1);
    var f = e.read_shift(t && t.biff == 2 ? 1 : 2);
    var o = 0;
    if (!t || t.biff >= 5) {
      e.l += 2;
      o = e.read_shift(2);
      e.l += 4;
    }
    var l = hn(e, s, t);
    if (n & 32) l = gi[l.charCodeAt(0)];
    var c = a - e.l;
    if (t && t.biff == 2) --c;
    var h = a == e.l || f == 0 ? [] : Gp(e, c, t, f);
    return { chKey: i, Name: l, itab: o, rgce: h };
  }
  function mi(e, r, t) {
    if (t.biff < 8) return Ci(e, r, t);
    var a = [],
      n = e.l + r,
      i = e.read_shift(t.biff > 8 ? 4 : 2);
    while (i-- !== 0) a.push(_n(e, t.biff > 8 ? 12 : 6, t));
    var s = [];
    return a;
  }
  function Ci(e, r, t) {
    if (e[e.l + 1] == 3) e[e.l]++;
    var a = ln(e, r, t);
    return a.charCodeAt(0) == 3 ? a.slice(1) : a;
  }
  var Ei = nn;
  function ki(e, r, t) {
    if (t.biff < 8) {
      e.l += r;
      return;
    }
    var a = e.read_shift(2);
    var n = e.read_shift(2);
    var i = hn(e, a, t);
    var s = hn(e, n, t);
    return [i, s];
  }
  function Si(e, r, t) {
    var a = yn(e, 6);
    e.l++;
    var n = e.read_shift(1);
    r -= 8;
    return [Kp(e, r, t), n];
  }
  function wi(e, r, t) {
    var a = Rn(e, 6);
    switch (t.biff) {
      case 2:
        e.l++;
        r -= 7;
        break;
      case 3:
      case 4:
        e.l += 2;
        r -= 8;
        break;
      default:
        e.l += 6;
        r -= 12;
    }
    return [a, Yp(e, r, t, a)];
  }
  function Ai(e, r) {
    var t = e.read_shift(4) !== 0;
    var a = e.read_shift(4) !== 0;
    var n = e.read_shift(4);
    return [t, a, n];
  }
  function Bi(e, r, t) {
    if (t.biff < 8) return;
    var a = e.read_shift(2),
      n = e.read_shift(2);
    var i = e.read_shift(2),
      s = e.read_shift(2);
    var f = dn(e, 0, t);
    if (t.biff < 8) e.read_shift(1);
    return [{ r: a, c: n }, f, s, i];
  }
  function _i(e, r, t) {
    return Bi(e, r, t);
  }
  function Ti(e, r) {
    var t = [];
    var a = e.read_shift(2);
    while (a--) t.push(In(e, r));
    return t;
  }
  function xi(e, r, t) {
    if (t && t.biff < 8) return yi(e, r, t);
    var a = Dn(e, 22);
    var n = Ln(e, r - 22, a[1]);
    return { cmo: a, ft: n };
  }
  var Ii = [];
  Ii[8] = function (e, r, t) {
    var a = e.l + r;
    e.l += 10;
    var n = e.read_shift(2);
    e.l += 4;
    var i = e.read_shift(2);
    e.l += 2;
    var s = e.read_shift(2);
    e.l += 4;
    var f = e.read_shift(1);
    e.l += f;
    e.l = a;
    return { fmt: n };
  };
  function yi(e, r, t) {
    var a = e.read_shift(4);
    var n = e.read_shift(2);
    var i = e.read_shift(2);
    var s = e.read_shift(2);
    var f = e.read_shift(2);
    var o = e.read_shift(2);
    var l = e.read_shift(2);
    var c = e.read_shift(2);
    var h = e.read_shift(2);
    var u = e.read_shift(2);
    var d = e.read_shift(2);
    var v = e.read_shift(2);
    var p = e.read_shift(2);
    e.l += 6;
    r -= 36;
    var g = [];
    g.push((Ii[n] || Cr)(e, r, t));
    return { cmo: [i, n, s], ft: g };
  }
  function Ri(e, r, t) {
    var a = e.l;
    var n = "";
    try {
      e.l += 4;
      var i = (t.lastobj || { cmo: [0, 0] }).cmo[1];
      var s;
      if ([0, 5, 7, 11, 12, 14].indexOf(i) == -1) e.l += 6;
      else s = vn(e, 6, t);
      var f = e.read_shift(2);
      var o = e.read_shift(2);
      var l = Mn(e, 2);
      var c = e.read_shift(2);
      e.l += c;
      for (var h = 1; h < e.lens.length - 1; ++h) {
        if (e.l - a != e.lens[h]) throw new Error("TxO: bad continue record");
        var u = e[e.l];
        var d = hn(e, e.lens[h + 1] - e.lens[h] - 1);
        n += d;
        if (n.length >= (u ? f : 2 * f)) break;
      }
      if (n.length !== f && n.length !== f * 2) {
        throw new Error("cchText: " + f + " != " + n.length);
      }
      e.l = a + r;
      return { t: n };
    } catch (v) {
      e.l = a + r;
      return { t: n };
    }
  }
  var Di = function (e, r) {
    var t = In(e, 8);
    e.l += 16;
    var a = Cn(e, r - 24);
    return [t, a];
  };
  var Oi = function (e, r) {
    var t = e.l + r;
    e.read_shift(2);
    var a = In(e, 8);
    var n = e.read_shift((r - 10) / 2, "dbcs-cont");
    n = n.replace(b, "");
    return [a, n];
  };
  function Fi(e, r) {
    var t = [],
      a;
    a = e.read_shift(2);
    t[0] = Kt[a] || a;
    a = e.read_shift(2);
    t[1] = Kt[a] || a;
    return t;
  }
  function Pi(e, r) {
    var t = e.read_shift(2);
    var a = [];
    while (t-- > 0) a.push(kn(e, 8));
    return a;
  }
  function Ni(e, r) {
    var t = e.read_shift(2);
    var a = [];
    while (t-- > 0) a.push(kn(e, 8));
    return a;
  }
  function Li(e, r) {
    e.l += 2;
    var t = { cxfs: 0, crc: 0 };
    t.cxfs = e.read_shift(2);
    t.crc = e.read_shift(4);
    return t;
  }
  function Mi(e, r, t) {
    if (!t.cellStyles) return Cr(e, r);
    var a = t && t.biff >= 12 ? 4 : 2;
    var n = e.read_shift(a);
    var i = e.read_shift(a);
    var s = e.read_shift(a);
    var f = e.read_shift(a);
    var o = e.read_shift(2);
    if (a == 2) e.l += 2;
    return { s: n, e: i, w: s, ixfe: f, flags: o };
  }
  function Ui(e, r, t) {
    var a = {};
    e.l += 16;
    a.header = wt(e, 8);
    a.footer = wt(e, 8);
    e.l += 2;
    return a;
  }
  function Hi(e, r, t) {
    var a = { area: false };
    if (t.biff != 5) {
      e.l += r;
      return a;
    }
    var n = e.read_shift(1);
    e.l += 3;
    if (n & 16) a.area = true;
    return a;
  }
  var Wi = Cr;
  var Vi = Cr;
  var zi = Cr;
  var Xi = an;
  var Gi = Sn;
  var ji = wt;
  var Ki = nn;
  var Yi = nn;
  var $i = wt;
  var Zi = an;
  var Qi = nn;
  var Ji = an;
  var qi = rn;
  var es = an;
  var rs = nn;
  var ts = an;
  var as = an;
  var ns = nn;
  var is = rn;
  var ss = rn;
  var fs = rn;
  var os = rn;
  var ls = rn;
  var cs = nn;
  var hs = di;
  var us = nn;
  var ds = an;
  var vs = di;
  var ps = Bn;
  var gs = rn;
  var bs = wt;
  var ms = rn;
  var Cs = an;
  var Es = nn;
  var ks = an;
  var Ss = an;
  var ws = nn;
  var As = an;
  var Bs = nn;
  var _s = an;
  var Ts = an;
  var xs = wt;
  var Is = sn;
  var ys = an;
  var Rs = sn;
  var Ds = un;
  var Os = an;
  var Fs = wt;
  var Ps = an;
  var Ns = an;
  var Ls = an;
  var Ms = Cr;
  var Us = Cr;
  var Hs = Cr;
  var Ws = Cr;
  var Vs = Cr;
  var zs = Cr;
  var Xs = Cr;
  var Gs = Cr;
  var js = Cr;
  var Ks = Cr;
  var Ys = Cr;
  var $s = Cr;
  var Zs = Cr;
  var Qs = Cr;
  var Js = Cr;
  var qs = Cr;
  var ef = Cr;
  var rf = Cr;
  var tf = Cr;
  var af = Cr;
  var nf = Cr;
  var sf = Cr;
  var ff = Cr;
  var of = Cr;
  var lf = Cr;
  var cf = Cr;
  var hf = Cr;
  var uf = Cr;
  var df = Cr;
  var vf = Cr;
  var pf = Cr;
  var gf = Cr;
  var bf = Cr;
  var mf = Cr;
  var Cf = Cr;
  var Ef = Cr;
  var kf = Cr;
  var Sf = Cr;
  var wf = Cr;
  var Af = Cr;
  var Bf = Cr;
  var _f = Cr;
  var Tf = Cr;
  var xf = Cr;
  var If = Cr;
  var yf = Cr;
  var Rf = Cr;
  var Df = Cr;
  var Of = Cr;
  var Ff = Cr;
  var Pf = Cr;
  var Nf = Cr;
  var Lf = Cr;
  var Mf = Cr;
  var Uf = Cr;
  var Hf = Cr;
  var Wf = Cr;
  var Vf = Cr;
  var zf = Cr;
  var Xf = Cr;
  var Gf = Cr;
  var jf = Cr;
  var Kf = Cr;
  var Yf = Cr;
  var $f = Cr;
  var Zf = Cr;
  var Qf = Cr;
  var Jf = Cr;
  var qf = Cr;
  var eo = Cr;
  var ro = Cr;
  var to = Cr;
  var ao = Cr;
  var no = Cr;
  var io = Cr;
  var so = Cr;
  var fo = Cr;
  var oo = Cr;
  var lo = Cr;
  var co = Cr;
  var ho = Cr;
  var uo = Cr;
  var vo = Cr;
  var po = Cr;
  var go = Cr;
  var bo = Cr;
  var mo = Cr;
  var Co = Cr;
  var Eo = Cr;
  var ko = Cr;
  var So = Cr;
  var wo = Cr;
  var Ao = Cr;
  var Bo = Cr;
  var _o = Cr;
  var To = Cr;
  var xo = Cr;
  var Io = Cr;
  var yo = Cr;
  var Ro = Cr;
  var Do = Cr;
  var Oo = Cr;
  var Fo = Cr;
  var Po = Cr;
  var No = Cr;
  var Lo = Cr;
  var Mo = Cr;
  var Uo = Cr;
  var Ho = Cr;
  var Wo = Cr;
  var Vo = un;
  var zo = Cr;
  var Xo = Cr;
  var Go = Cr;
  var jo = Cr;
  var Ko = Cr;
  var Yo = Cr;
  var $o = Cr;
  var Zo = Cr;
  var Qo = Cr;
  var Jo = Cr;
  var qo = Cr;
  var el = Cr;
  var rl = Cr;
  var tl = Cr;
  var al = Cr;
  var nl = Cr;
  var il = Cr;
  var sl = Cr;
  var fl = Cr;
  var ol = Cr;
  var ll = Cr;
  var cl = Cr;
  var hl = Cr;
  var ul = Cr;
  var dl = Cr;
  var vl = Cr;
  var pl = Cr;
  var gl = Cr;
  var bl = Cr;
  var ml = Cr;
  var Cl = Cr;
  var El = Cr;
  var kl = Cr;
  var Sl = Cr;
  var wl = Cr;
  var Al = Cr;
  var Bl = Cr;
  var _l = Cr;
  var Tl = Cr;
  var xl = Cr;
  var Il = Cr;
  var yl = Cr;
  var Rl = Cr;
  var Dl = Cr;
  var Ol = Cr;
  var Fl = Cr;
  var Pl = Cr;
  var Nl = Cr;
  var Ll = Cr;
  var Ml = Cr;
  var Ul = Cr;
  var Hl = Cr;
  var Wl = Cr;
  var Vl = Cr;
  var zl = Cr;
  var Xl = Cr;
  var Gl = Cr;
  var jl = Cr;
  var Kl = Cr;
  var Yl = Cr;
  var $l = Cr;
  var Zl = Cr;
  var Ql = Cr;
  var Jl = Cr;
  var ql = Cr;
  var ec = Cr;
  var rc = Cr;
  var tc = Cr;
  var ac = Cr;
  var nc = Cr;
  var ic = Cr;
  var sc = Cr;
  var fc = Cr;
  var oc = Cr;
  var lc = Cr;
  var cc = Cr;
  var hc = Cr;
  var uc = Cr;
  var dc = Cr;
  var vc = Cr;
  var pc = Cr;
  var gc = Cr;
  var bc = Cr;
  var mc = Cr;
  var Cc = Cr;
  var Ec = Cr;
  var kc = Cr;
  var Sc = Cr;
  var wc = Cr;
  var Ac = Cr;
  var Bc = Cr;
  var _c = Cr;
  var Tc = Cr;
  var xc = Cr;
  var Ic = Cr;
  var yc = Cr;
  var Rc = Cr;
  var Dc = Cr;
  var Oc = Cr;
  var Fc = Cr;
  var Pc = Cr;
  var Nc = Cr;
  var Lc = Cr;
  var Mc = Cr;
  var Uc = Cr;
  var Hc = Cr;
  var Wc = Cr;
  var Vc = Cr;
  var zc = Cr;
  var Xc = Cr;
  var Gc = Cr;
  var jc = Cr;
  var Kc = Cr;
  var Yc = Cr;
  var $c = Cr;
  var Zc = Cr;
  var Qc = Cr;
  var Jc = Cr;
  var qc = Cr;
  var eh = Cr;
  var rh = Cr;
  var th = Cr;
  var ah = Cr;
  var nh = Cr;
  var ih = Cr;
  var sh = Cr;
  var fh = Cr;
  var oh = Cr;
  var lh = Cr;
  var ch = Cr;
  var hh = Cr;
  var uh = Cr;
  var dh = Cr;
  var vh = Cr;
  var ph = Cr;
  var gh = Cr;
  var bh = Cr;
  var mh = Cr;
  var Ch = Cr;
  var Eh = Cr;
  var kh = Cr;
  var Sh = Cr;
  function wh(e, r, t) {
    var a = e.l + r;
    var n = e.read_shift(2);
    var i = e.read_shift(2);
    var s = e.read_shift(4);
    var f = { fmt: n, env: i, len: s, data: e.slice(e.l, e.l + s) };
    e.l += s;
    return f;
  }
  function Ah(e) {
    var r = e.read_shift(1);
    return e.read_shift(r, "sbcs-cont");
  }
  function Bh(e, r, t) {
    var a = Sn(e, 6);
    ++e.l;
    var n = dn(e, r - 7, t);
    a.t = "str";
    a.val = n;
    return a;
  }
  function _h(e, r, t) {
    var a = Sn(e, 6);
    ++e.l;
    var n = wt(e, 8);
    a.t = "n";
    a.val = n;
    return a;
  }
  function Th(e, r) {
    var t = Sn(e, 6);
    ++e.l;
    var a = e.read_shift(2);
    t.t = "n";
    t.val = a;
    return t;
  }
  function xh(e, r) {
    var t = e.read_shift(1);
    if (t === 0) {
      e.l++;
      return "";
    }
    return e.read_shift(t, "sbcs-cont");
  }
  function Ih(e, r) {
    e.l += 6;
    e.l += 2;
    e.l += 1;
    e.l += 3;
    e.l += 1;
    e.l += r - 13;
  }
  function yh(e, r, t) {
    var a = e.l + r;
    var n = Sn(e, 6);
    var i = e.read_shift(2);
    var s = hn(e, i, t);
    e.l = a;
    n.t = "str";
    n.val = s;
    return n;
  }
  var Rh = (function () {
    var e = {
      1: 437,
      2: 850,
      3: 1252,
      4: 1e4,
      100: 852,
      101: 866,
      102: 865,
      103: 861,
      104: 895,
      105: 620,
      106: 737,
      107: 857,
      120: 950,
      121: 949,
      122: 936,
      123: 932,
      124: 874,
      125: 1255,
      126: 1256,
      150: 10007,
      151: 10029,
      152: 10006,
      200: 1250,
      201: 1251,
      202: 1254,
      203: 1253,
      0: 20127,
      8: 865,
      9: 437,
      10: 850,
      11: 437,
      13: 437,
      14: 850,
      15: 437,
      16: 850,
      17: 437,
      18: 850,
      19: 932,
      20: 850,
      21: 437,
      22: 850,
      23: 865,
      24: 437,
      25: 437,
      26: 850,
      27: 437,
      28: 863,
      29: 850,
      31: 852,
      34: 852,
      35: 852,
      36: 860,
      37: 850,
      38: 866,
      55: 850,
      64: 852,
      77: 936,
      78: 949,
      79: 950,
      80: 874,
      87: 1252,
      88: 1252,
      89: 1252,
      255: 16969,
    };
    function r(r, t) {
      var a = [];
      var n = v(1);
      switch (t.type) {
        case "base64":
          n = p(u.decode(r));
          break;
        case "binary":
          n = p(r);
          break;
        case "buffer":
        case "array":
          n = r;
          break;
      }
      mr(n, 0);
      var i = n.read_shift(1);
      var s = false;
      var f = false;
      switch (i) {
        case 2:
        case 3:
          break;
        case 48:
          f = true;
          s = true;
          break;
        case 49:
          f = true;
          break;
        case 131:
          s = true;
          break;
        case 139:
          s = true;
          break;
        case 245:
          s = true;
          break;
        default:
          throw new Error("DBF Unsupported Version: " + i.toString(16));
      }
      var o = new Date(),
        l = 0,
        c = 0;
      if (i == 2) l = n.read_shift(2);
      o = new Date(
        n.read_shift(1) + 1900,
        n.read_shift(1) - 1,
        n.read_shift(1)
      );
      if (i != 2) l = n.read_shift(4);
      if (i != 2) c = n.read_shift(2);
      var h = n.read_shift(2);
      var d = 0,
        g = 1252;
      if (i != 2) {
        n.l += 16;
        d = n.read_shift(1);
        if (n[n.l] !== 0) g = e[n[n.l]];
        n.l += 1;
        n.l += 2;
      }
      var b = [],
        m = {};
      var C = c - 10 - (f ? 264 : 0);
      while (i == 2 ? n.l < n.length && n[n.l] != 13 : n.l < C) {
        m = {};
        m.name = cptable.utils
          .decode(g, n.slice(n.l, n.l + 10))
          .replace(/[\u0000\r\n].*$/g, "");
        n.l += 11;
        m.type = String.fromCharCode(n.read_shift(1));
        if (i != 2) m.offset = n.read_shift(4);
        m.len = n.read_shift(1);
        if (i == 2) m.offset = n.read_shift(2);
        m.dec = n.read_shift(1);
        if (m.name.length) b.push(m);
        if (i != 2) n.l += 14;
        switch (m.type) {
          case "C":
            break;
          case "D":
            break;
          case "F":
            break;
          case "I":
            break;
          case "L":
            break;
          case "M":
            break;
          case "N":
            break;
          case "T":
            break;
          case "Y":
            break;
          case "0":
            break;
          case "+":
            break;
          case "@":
            break;
          default:
            throw new Error("Unknown Field Type: " + m.type);
        }
      }
      if (n[n.l] !== 13) n.l = c - 1;
      else if (i == 2) n.l = 521;
      if (i != 2) {
        if (n.read_shift(1) !== 13)
          throw new Error("DBF Terminator not found " + n.l + " " + n[n.l]);
        n.l = c;
      }
      var E = 0,
        k = 0;
      a[0] = [];
      for (k = 0; k != b.length; ++k) a[0][k] = b[k].name;
      while (l-- > 0) {
        if (n[n.l] === 42) {
          n.l += h;
          continue;
        }
        ++n.l;
        a[++E] = [];
        k = 0;
        for (k = 0; k != b.length; ++k) {
          var S = n.slice(n.l, n.l + b[k].len);
          n.l += b[k].len;
          mr(S, 0);
          var w = cptable.utils.decode(g, S);
          switch (b[k].type) {
            case "C":
              a[E][k] = cptable.utils.decode(g, S);
              a[E][k] = a[E][k].trim();
              break;
            case "D":
              if (w.length === 8)
                a[E][k] = new Date(
                  +w.substr(0, 4),
                  +w.substr(4, 2) - 1,
                  +w.substr(6, 2)
                );
              else a[E][k] = w;
              break;
            case "F":
              a[E][k] = parseFloat(w.trim());
              break;
            case "I":
              a[E][k] = S.read_shift(4, "i");
              break;
            case "L":
              switch (w.toUpperCase()) {
                case "Y":
                case "T":
                  a[E][k] = true;
                  break;
                case "N":
                case "F":
                  a[E][k] = false;
                  break;
                case " ":
                case "?":
                  a[E][k] = false;
                  break;
                default:
                  throw new Error("DBF Unrecognized L:|" + w + "|");
              }
              break;
            case "M":
              if (!s)
                throw new Error(
                  "DBF Unexpected MEMO for type " + i.toString(16)
                );
              a[E][k] = "##MEMO##" + S.read_shift(4);
              break;
            case "N":
              a[E][k] = +w.replace(/\u0000/g, "").trim();
              break;
            case "T":
              var A = S.read_shift(4),
                B = S.read_shift(4);
              throw new Error(A + " | " + B);
            case "Y":
              a[E][k] = S.read(4, "i") / 1e4;
              break;
            case "0":
              if (b[k].name === "_NullFlags") break;
            default:
              throw new Error("DBF Unsupported data type " + b[k].type);
          }
        }
      }
      if (i != 2)
        if (n.l < n.length && n[n.l++] != 26)
          throw new Error(
            "DBF EOF Marker missing " +
              (n.l - 1) +
              " of " +
              n.length +
              " " +
              n[n.l - 1].toString(16)
          );
      return a;
    }
    function t(e, t) {
      var a = t || {};
      if (!a.dateNF) a.dateNF = "yyyymmdd";
      return Qr(r(e, a), a);
    }
    function a(e, r) {
      try {
        return Zr(t(e, r), r);
      } catch (a) {
        if (r && r.WTF) throw a;
      }
      return { SheetNames: [], Sheets: {} };
    }
    return { to_workbook: a, to_sheet: t };
  })();
  var Dh = (function () {
    function e(e, t) {
      switch (t.type) {
        case "base64":
          return r(u.decode(e), t);
        case "binary":
          return r(e, t);
        case "buffer":
          return r(e.toString("binary"), t);
        case "array":
          return r(W(e), t);
      }
      throw new Error("Unrecognized type " + t.type);
    }
    function r(e, r) {
      var t = e.split(/[\n\r]+/),
        a = -1,
        n = -1,
        i = 0,
        s = 0,
        f = [];
      var o = [];
      var l = null;
      var c = {},
        h = [],
        u = [],
        d = [];
      var v = 0,
        p;
      for (; i !== t.length; ++i) {
        v = 0;
        var g = t[i].trim();
        var b = g
          .replace(/;;/g, "")
          .split(";")
          .map(function (e) {
            return e.replace(/\u0001/g, ";");
          });
        var m = b[0],
          E;
        if (g.length > 0)
          switch (m) {
            case "ID":
              break;
            case "E":
              break;
            case "B":
              break;
            case "O":
              break;
            case "P":
              if (b[1].charAt(0) == "P")
                o.push(g.substr(3).replace(/;;/g, ";"));
              break;
            case "C":
              for (s = 1; s < b.length; ++s)
                switch (b[s].charAt(0)) {
                  case "X":
                    n = parseInt(b[s].substr(1)) - 1;
                    break;
                  case "Y":
                    a = parseInt(b[s].substr(1)) - 1;
                    n = 0;
                    for (p = f.length; p <= a; ++p) f[p] = [];
                    break;
                  case "K":
                    E = b[s].substr(1);
                    if (E.charAt(0) === '"') E = E.substr(1, E.length - 2);
                    else if (E === "TRUE") E = true;
                    else if (E === "FALSE") E = false;
                    else if (+E === +E) {
                      E = +E;
                      if (l !== null && C.is_date(l)) E = N(E);
                    } else if (!isNaN(G(E).getDate())) {
                      E = H(E);
                    }
                    f[a][n] = E;
                    l = null;
                    break;
                  case "E":
                    var k = gv(b[s].substr(1), { r: a, c: n });
                    f[a][n] = [f[a][n], k];
                    break;
                  default:
                    if (r && r.WTF) throw new Error("SYLK bad record " + g);
                }
              break;
            case "F":
              var S = 0;
              for (s = 1; s < b.length; ++s)
                switch (b[s].charAt(0)) {
                  case "X":
                    n = parseInt(b[s].substr(1)) - 1;
                    ++S;
                    break;
                  case "Y":
                    a = parseInt(b[s].substr(1)) - 1;
                    for (p = f.length; p <= a; ++p) f[p] = [];
                    break;
                  case "M":
                    v = parseInt(b[s].substr(1)) / 20;
                    break;
                  case "F":
                    break;
                  case "P":
                    l = o[parseInt(b[s].substr(1))];
                    break;
                  case "S":
                    break;
                  case "D":
                    break;
                  case "N":
                    break;
                  case "W":
                    d = b[s].substr(1).split(" ");
                    for (p = parseInt(d[0], 10); p <= parseInt(d[1], 10); ++p) {
                      v = parseInt(d[2], 10);
                      u[p - 1] = v == 0 ? { hidden: true } : { wch: v };
                      Hu(u[p - 1]);
                    }
                    break;
                  case "C":
                    n = parseInt(b[s].substr(1)) - 1;
                    if (!u[n]) u[n] = {};
                    break;
                  case "R":
                    a = parseInt(b[s].substr(1)) - 1;
                    if (!h[a]) h[a] = {};
                    if (v > 0) {
                      h[a].hpt = v;
                      h[a].hpx = Xu(v);
                    } else if (v == 0) h[a].hidden = true;
                    break;
                  default:
                    if (r && r.WTF) throw new Error("SYLK bad record " + g);
                }
              if (S < 1) l = null;
              break;
            default:
              if (r && r.WTF) throw new Error("SYLK bad record " + g);
          }
      }
      if (h.length > 0) c["!rows"] = h;
      if (u.length > 0) c["!cols"] = u;
      return [f, c];
    }
    function t(r, t) {
      var a = e(r, t);
      var n = a[0],
        i = a[1];
      var s = Qr(n, t);
      x(i).forEach(function (e) {
        s[e] = i[e];
      });
      return s;
    }
    function a(e, r) {
      return Zr(t(e, r), r);
    }
    function n(e, r, t, a, n) {
      var i = "C;Y" + (t + 1) + ";X" + (a + 1) + ";K";
      switch (e.t) {
        case "n":
          i += e.v || 0;
          if (e.f && !e.F) i += ";E" + mv(e.f, { r: t, c: a });
          break;
        case "b":
          i += e.v ? "TRUE" : "FALSE";
          break;
        case "e":
          i += e.w || e.v;
          break;
        case "d":
          i += '"' + (e.w || e.v) + '"';
          break;
        case "s":
          i += '"' + e.v.replace(/"/g, "") + '"';
          break;
      }
      return i;
    }
    function i(e, r) {
      r.forEach(function (r, t) {
        var a = "F;W" + (t + 1) + " " + (t + 1) + " ";
        if (r.hidden) a += "0";
        else {
          if (typeof r.width == "number") r.wpx = Du(r.width);
          if (typeof r.wpx == "number") r.wch = Ou(r.wpx);
          if (typeof r.wch == "number") a += Math.round(r.wch);
        }
        if (a.charAt(a.length - 1) != " ") e.push(a);
      });
    }
    function s(e, r) {
      r.forEach(function (r, t) {
        var a = "F;";
        if (r.hidden) a += "M0;";
        else if (r.hpt) a += "M" + 20 * r.hpt + ";";
        else if (r.hpx) a += "M" + 20 * zu(r.hpx) + ";";
        if (a.length > 2) e.push(a + "R" + (t + 1));
      });
    }
    function f(e, r) {
      var t = ["ID;PWXL;N;E"],
        a = [];
      var f = Gr(e["!ref"]),
        o;
      var l = Array.isArray(e);
      var c = "\r\n";
      t.push("P;PGeneral");
      t.push("F;P0;DG0G8;M255");
      if (e["!cols"]) i(t, e["!cols"]);
      if (e["!rows"]) s(t, e["!rows"]);
      t.push(
        "B;Y" +
          (f.e.r - f.s.r + 1) +
          ";X" +
          (f.e.c - f.s.c + 1) +
          ";D" +
          [f.s.c, f.s.r, f.e.c, f.e.r].join(" ")
      );
      for (var h = f.s.r; h <= f.e.r; ++h) {
        for (var u = f.s.c; u <= f.e.c; ++u) {
          var d = Vr({ r: h, c: u });
          o = l ? (e[h] || [])[u] : e[d];
          if (!o || (o.v == null && (!o.f || o.F))) continue;
          a.push(n(o, e, h, u, r));
        }
      }
      return t.join(c) + c + a.join(c) + c + "E" + c;
    }
    return { to_workbook: a, to_sheet: t, from_sheet: f };
  })();
  var Oh = (function () {
    function e(e, t) {
      switch (t.type) {
        case "base64":
          return r(u.decode(e), t);
        case "binary":
          return r(e, t);
        case "buffer":
          return r(e.toString("binary"), t);
        case "array":
          return r(W(e), t);
      }
      throw new Error("Unrecognized type " + t.type);
    }
    function r(e, r) {
      var t = e.split("\n"),
        a = -1,
        n = -1,
        i = 0,
        s = [];
      for (; i !== t.length; ++i) {
        if (t[i].trim() === "BOT") {
          s[++a] = [];
          n = 0;
          continue;
        }
        if (a < 0) continue;
        var f = t[i].trim().split(",");
        var o = f[0],
          l = f[1];
        ++i;
        var c = t[i].trim();
        switch (+o) {
          case -1:
            if (c === "BOT") {
              s[++a] = [];
              n = 0;
              continue;
            } else if (c !== "EOD")
              throw new Error("Unrecognized DIF special command " + c);
            break;
          case 0:
            if (c === "TRUE") s[a][n] = true;
            else if (c === "FALSE") s[a][n] = false;
            else if (+l == +l) s[a][n] = +l;
            else if (!isNaN(G(l).getDate())) s[a][n] = H(l);
            else s[a][n] = l;
            ++n;
            break;
          case 1:
            c = c.substr(1, c.length - 2);
            s[a][n++] = c !== "" ? c : null;
            break;
        }
        if (c === "EOD") break;
      }
      return s;
    }
    function t(r, t) {
      return Qr(e(r, t), t);
    }
    function a(e, r) {
      return Zr(t(e, r), r);
    }
    var n = (function () {
      var e = function t(e, r, a, n, i) {
        e.push(r);
        e.push(a + "," + n);
        e.push('"' + i.replace(/"/g, '""') + '"');
      };
      var r = function a(e, r, t, n) {
        e.push(r + "," + t);
        e.push(r == 1 ? '"' + n.replace(/"/g, '""') + '"' : n);
      };
      return function n(t, a) {
        var n = [];
        var i = Gr(t["!ref"]),
          s;
        var f = Array.isArray(t);
        e(n, "TABLE", 0, 1, "sheetjs");
        e(n, "VECTORS", 0, i.e.r - i.s.r + 1, "");
        e(n, "TUPLES", 0, i.e.c - i.s.c + 1, "");
        e(n, "DATA", 0, 0, "");
        for (var o = i.s.r; o <= i.e.r; ++o) {
          r(n, -1, 0, "BOT");
          for (var l = i.s.c; l <= i.e.c; ++l) {
            var c = Vr({ r: o, c: l });
            s = f ? (t[o] || [])[l] : t[c];
            if (!s) {
              r(n, 1, 0, "");
              continue;
            }
            switch (s.t) {
              case "n":
                var u = h ? s.w : s.v;
                if (!u && s.v != null) u = s.v;
                if (u == null) {
                  if (h && s.f && !s.F) r(n, 1, 0, "=" + s.f);
                  else r(n, 1, 0, "");
                } else r(n, 0, u, "V");
                break;
              case "b":
                r(n, 0, s.v ? 1 : 0, s.v ? "TRUE" : "FALSE");
                break;
              case "s":
                r(n, 1, 0, !h || isNaN(s.v) ? s.v : '="' + s.v + '"');
                break;
              case "d":
                if (!s.w) s.w = C.format(s.z || C._table[14], P(H(s.v)));
                if (h) r(n, 0, s.w, "V");
                else r(n, 1, 0, s.w);
                break;
              default:
                r(n, 1, 0, "");
            }
          }
        }
        r(n, -1, 0, "EOD");
        var d = "\r\n";
        var v = n.join(d);
        return v;
      };
    })();
    return { to_workbook: a, to_sheet: t, from_sheet: n };
  })();
  var Fh = (function () {
    function e(e, r, t, a, n) {
      if (n.raw) r[t][a] = e;
      else if (e === "TRUE") r[t][a] = true;
      else if (e === "FALSE") r[t][a] = false;
      else if (e === "") {
      } else if (+e == +e) r[t][a] = +e;
      else if (!isNaN(G(e).getDate())) r[t][a] = H(e);
      else r[t][a] = e;
    }
    function r(r, t) {
      var a = t || {};
      var n = [];
      if (!r || r.length === 0) return n;
      var i = r.split(/[\r\n]/);
      var s = i.length - 1;
      while (s >= 0 && i[s].length === 0) --s;
      var f = 10,
        o = 0;
      var l = 0;
      for (; l <= s; ++l) {
        o = i[l].indexOf(" ");
        if (o == -1) o = i[l].length;
        else o++;
        f = Math.max(f, o);
      }
      for (l = 0; l <= s; ++l) {
        n[l] = [];
        var c = 0;
        e(i[l].slice(0, f).trim(), n, l, c, a);
        for (c = 1; c <= (i[l].length - f) / 10 + 1; ++c)
          e(i[l].slice(f + (c - 1) * 10, f + c * 10).trim(), n, l, c, a);
      }
      return n;
    }
    function t(e, r) {
      var t = r || {};
      var a = "";
      if (c != null && t.dense == null) t.dense = c;
      var n = t.dense ? [] : {};
      var i = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
      if (e.substr(0, 4) == "sep=" && e.charCodeAt(5) == 10) {
        a = e.charAt(4);
        e = e.substr(6);
      } else if (e.substr(0, 1024).indexOf("\t") == -1) a = ",";
      else a = "\t";
      var s = 0,
        f = 0,
        o = 0;
      var l = 0,
        h = 0,
        u = a.charCodeAt(0),
        d = false,
        v = 0;
      e = e.replace(/\r\n/gm, "\n");
      var p = t.dateNF != null ? w(t.dateNF) : null;
      function g() {
        var r = e.slice(l, h);
        var a = {};
        if (t.raw) {
          a.t = "s";
          a.v = r;
        } else if (r.charCodeAt(0) == 61) {
          a.t = "n";
          a.f = r.substr(1);
        } else if (r == "TRUE") {
          a.t = "b";
          a.v = true;
        } else if (r == "FALSE") {
          a.t = "b";
          a.v = false;
        } else if (!isNaN((o = +r))) {
          a.t = "n";
          a.w = r;
          a.v = o;
        } else if (!isNaN(G(r).getDate()) || (p && r.match(p))) {
          a.z = t.dateNF || C._table[14];
          var c = 0;
          if (p && r.match(p)) {
            r = A(r, t.dateNF, r.match(p) || []);
            c = 1;
          }
          if (t.cellDates) {
            a.t = "d";
            a.v = H(r, c);
          } else {
            a.t = "n";
            a.v = P(H(r, c));
          }
          a.w = C.format(a.z, a.v instanceof Date ? P(a.v) : a.v);
        } else {
          a.t = "s";
          if (r.charAt(0) == '"' && r.charAt(r.length - 1) == '"')
            r = r.slice(1, -1).replace(/""/g, '"');
          a.v = r;
        }
        if (t.dense) {
          if (!n[s]) n[s] = [];
          n[s][f] = a;
        } else n[Vr({ c: f, r: s })] = a;
        l = h + 1;
        if (i.e.c < f) i.e.c = f;
        if (i.e.r < s) i.e.r = s;
        if (v == u) ++f;
        else {
          f = 0;
          ++s;
        }
      }
      for (; h < e.length; ++h)
        switch ((v = e.charCodeAt(h))) {
          case 34:
            d = !d;
            break;
          case u:
          case 10:
          case 13:
            if (!d) g();
            break;
          default:
            break;
        }
      if (h - l > 0) g();
      n["!ref"] = jr(i);
      return n;
    }
    function a(e, a) {
      if (e.substr(0, 4) == "sep=") return t(e, a);
      if (e.indexOf("\t") >= 0 || e.indexOf(",") >= 0) return t(e, a);
      return Qr(r(e, a), a);
    }
    function n(e, r) {
      var t = "",
        n = tE(e, r);
      switch (r.type) {
        case "base64":
          t = u.decode(e);
          break;
        case "binary":
          t = e;
          break;
        case "buffer":
          t = e.toString("binary");
          break;
        case "array":
          t = W(e);
          break;
        default:
          throw new Error("Unrecognized type " + r.type);
      }
      if (n[0] == 239 && n[1] == 187 && n[2] == 191) t = Ee(t);
      return a(t, r);
    }
    function i(e, r) {
      return Zr(n(e, r), r);
    }
    function s(e, r) {
      var t = [];
      var a = Gr(e["!ref"]),
        n;
      var i = Array.isArray(e);
      for (var s = a.s.r; s <= a.e.r; ++s) {
        var f = [];
        for (var o = a.s.c; o <= a.e.c; ++o) {
          var l = Vr({ r: s, c: o });
          n = i ? (e[s] || [])[o] : e[l];
          if (!n || n.v == null) {
            f.push("          ");
            continue;
          }
          var c = (n.w || ($r(n), n.w) || "").substr(0, 10);
          while (c.length < 10) c += " ";
          f.push(c + (o == 0 ? " " : ""));
        }
        t.push(f.join(""));
      }
      return t.join("\n");
    }
    return { to_workbook: i, to_sheet: n, from_sheet: s };
  })();
  function Ph(e, r) {
    var t = r || {},
      a = !!t.WTF;
    t.WTF = true;
    try {
      var n = Dh.to_workbook(e, t);
      t.WTF = a;
      return n;
    } catch (i) {
      t.WTF = a;
      if (!i.message.match(/SYLK bad record ID/) && a) throw i;
      return Fh.to_workbook(e, r);
    }
  }
  var Nh = (function () {
    function e(e, r, t) {
      if (!e) return;
      mr(e, e.l || 0);
      var a = t.Enum || k;
      while (e.l < e.length) {
        var n = e.read_shift(2);
        var i = a[n] || a[255];
        var s = e.read_shift(2);
        var f = e.l + s;
        var o = i.f(e, s, t);
        e.l = f;
        if (r(o, i.n, n)) return;
      }
    }
    function r(e, r) {
      switch (r.type) {
        case "base64":
          return t(p(u.decode(e)), r);
        case "binary":
          return t(p(e), r);
        case "buffer":
        case "array":
          return t(e, r);
      }
      throw "Unsupported type " + r.type;
    }
    function t(r, t) {
      if (!r) return r;
      var a = t || {};
      if (c != null && a.dense == null) a.dense = c;
      var n = a.dense ? [] : {},
        i = "Sheet1",
        s = 0;
      var f = {},
        o = [i];
      var l = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
      if (r[2] == 2) a.Enum = k;
      else if (r[2] == 26) a.Enum = S;
      else if (r[2] == 14) {
        a.Enum = S;
        a.qpro = true;
        r.l = 0;
      } else throw new Error("Unrecognized LOTUS BOF " + r[2]);
      e(
        r,
        function (e, t, c) {
          if (r[2] == 2)
            switch (c) {
              case 0:
                a.vers = e;
                if (e >= 4096) a.qpro = true;
                break;
              case 6:
                l = e;
                break;
              case 15:
                if (!a.qpro) e[1].v = e[1].v.substr(1);
              case 13:
              case 14:
              case 16:
              case 51:
                if (
                  c == 14 &&
                  (e[2] & 112) == 112 &&
                  (e[2] & 15) > 1 &&
                  (e[2] & 15) < 15
                ) {
                  e[1].z = a.dateNF || C._table[14];
                  if (a.cellDates) {
                    e[1].t = "d";
                    e[1].v = N(e[1].v);
                  }
                }
                if (a.dense) {
                  if (!n[e[0].r]) n[e[0].r] = [];
                  n[e[0].r][e[0].c] = e[1];
                } else n[Vr(e[0])] = e[1];
                break;
            }
          else
            switch (c) {
              case 22:
                e[1].v = e[1].v.substr(1);
              case 23:
              case 24:
              case 25:
              case 37:
              case 39:
              case 40:
                if (e[3] > s) {
                  n["!ref"] = jr(l);
                  f[i] = n;
                  n = a.dense ? [] : {};
                  l = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
                  s = e[3];
                  i = "Sheet" + (s + 1);
                  o.push(i);
                }
                n[Vr(e[0])] = e[1];
                if (l.e.c < e[0].c) l.e.c = e[0].c;
                if (l.e.r < e[0].r) l.e.r = e[0].r;
                break;
              default:
                break;
            }
        },
        a
      );
      n["!ref"] = jr(l);
      f[i] = n;
      return { SheetNames: o, Sheets: f };
    }
    function a(e, r) {
      var t = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
      t.s.c = e.read_shift(2);
      t.s.r = e.read_shift(2);
      t.e.c = e.read_shift(2);
      t.e.r = e.read_shift(2);
      if (t.s.c == 65535) t.s.c = t.e.c = t.s.r = t.e.r = 0;
      return t;
    }
    function n(e, r, t) {
      var a = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
      if (t.qpro && t.vers != 20768) {
        a[0].c = e.read_shift(1);
        e.l++;
        a[0].r = e.read_shift(2);
        e.l += 2;
      } else {
        a[2] = e.read_shift(1);
        a[0].c = e.read_shift(2);
        a[0].r = e.read_shift(2);
      }
      return a;
    }
    function i(e, r, t) {
      var a = e.l + r;
      var i = n(e, r, t);
      i[1].t = "s";
      if (t.vers == 20768) {
        e.l++;
        var s = e.read_shift(1);
        i[1].v = e.read_shift(s, "utf8");
        return i;
      }
      if (t.qpro) e.l++;
      i[1].v = e.read_shift(a - e.l, "cstr");
      return i;
    }
    function s(e, r, t) {
      var a = n(e, r, t);
      a[1].v = e.read_shift(2, "i");
      return a;
    }
    function f(e, r, t) {
      var a = n(e, r, t);
      a[1].v = e.read_shift(8, "f");
      return a;
    }
    function o(e, r, t) {
      var a = e.l + r;
      var i = n(e, r, t);
      i[1].v = e.read_shift(8, "f");
      if (t.qpro) e.l = a;
      else {
        var s = e.read_shift(2);
        e.l += s;
      }
      return i;
    }
    function l(e, r) {
      var t = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
      t[0].r = e.read_shift(2);
      t[3] = e[e.l++];
      t[0].c = e[e.l++];
      return t;
    }
    function h(e, r) {
      var t = l(e, r);
      t[1].t = "s";
      t[1].v = e.read_shift(r - 4, "cstr");
      return t;
    }
    function d(e, r) {
      var t = l(e, r);
      t[1].v = e.read_shift(2);
      var a = t[1].v >> 1;
      if (t[1].v & 1) {
        switch (a & 7) {
          case 1:
            a = (a >> 3) * 500;
            break;
          case 2:
            a = (a >> 3) / 20;
            break;
          case 4:
            a = (a >> 3) / 2e3;
            break;
          case 6:
            a = (a >> 3) / 16;
            break;
          case 7:
            a = (a >> 3) / 64;
            break;
          default:
            throw "unknown NUMBER_18 encoding " + (a & 7);
        }
      }
      t[1].v = a;
      return t;
    }
    function v(e, r) {
      var t = l(e, r);
      var a = e.read_shift(4);
      var n = e.read_shift(4);
      var i = e.read_shift(2);
      if (i == 65535) {
        t[1].v = 0;
        return t;
      }
      var s = i & 32768;
      i = (i & 32767) - 16446;
      t[1].v =
        (i > 0 ? n << i : n >>> -i) +
        (i > -32 ? a << (i + 32) : a >>> -(i + 32));
      return t;
    }
    function g(e, r) {
      var t = v(e, 14);
      e.l += r - 14;
      return t;
    }
    function b(e, r) {
      var t = l(e, r);
      var a = e.read_shift(4);
      t[1].v = a >> 6;
      return t;
    }
    function m(e, r) {
      var t = l(e, r);
      var a = e.read_shift(8, "f");
      t[1].v = a;
      return t;
    }
    function E(e, r) {
      var t = m(e, 14);
      e.l += r - 10;
      return t;
    }
    var k = {
      0: { n: "BOF", f: nn },
      1: { n: "EOF", f: Cr },
      2: { n: "CALCMODE", f: Cr },
      3: { n: "CALCORDER", f: Cr },
      4: { n: "SPLIT", f: Cr },
      5: { n: "SYNC", f: Cr },
      6: { n: "RANGE", f: a },
      7: { n: "WINDOW1", f: Cr },
      8: { n: "COLW1", f: Cr },
      9: { n: "WINTWO", f: Cr },
      10: { n: "COLW2", f: Cr },
      11: { n: "NAME", f: Cr },
      12: { n: "BLANK", f: Cr },
      13: { n: "INTEGER", f: s },
      14: { n: "NUMBER", f: f },
      15: { n: "LABEL", f: i },
      16: { n: "FORMULA", f: o },
      24: { n: "TABLE", f: Cr },
      25: { n: "ORANGE", f: Cr },
      26: { n: "PRANGE", f: Cr },
      27: { n: "SRANGE", f: Cr },
      28: { n: "FRANGE", f: Cr },
      29: { n: "KRANGE1", f: Cr },
      32: { n: "HRANGE", f: Cr },
      35: { n: "KRANGE2", f: Cr },
      36: { n: "PROTEC", f: Cr },
      37: { n: "FOOTER", f: Cr },
      38: { n: "HEADER", f: Cr },
      39: { n: "SETUP", f: Cr },
      40: { n: "MARGINS", f: Cr },
      41: { n: "LABELFMT", f: Cr },
      42: { n: "TITLES", f: Cr },
      43: { n: "SHEETJS", f: Cr },
      45: { n: "GRAPH", f: Cr },
      46: { n: "NGRAPH", f: Cr },
      47: { n: "CALCCOUNT", f: Cr },
      48: { n: "UNFORMATTED", f: Cr },
      49: { n: "CURSORW12", f: Cr },
      50: { n: "WINDOW", f: Cr },
      51: { n: "STRING", f: i },
      55: { n: "PASSWORD", f: Cr },
      56: { n: "LOCKED", f: Cr },
      60: { n: "QUERY", f: Cr },
      61: { n: "QUERYNAME", f: Cr },
      62: { n: "PRINT", f: Cr },
      63: { n: "PRINTNAME", f: Cr },
      64: { n: "GRAPH2", f: Cr },
      65: { n: "GRAPHNAME", f: Cr },
      66: { n: "ZOOM", f: Cr },
      67: { n: "SYMSPLIT", f: Cr },
      68: { n: "NSROWS", f: Cr },
      69: { n: "NSCOLS", f: Cr },
      70: { n: "RULER", f: Cr },
      71: { n: "NNAME", f: Cr },
      72: { n: "ACOMM", f: Cr },
      73: { n: "AMACRO", f: Cr },
      74: { n: "PARSE", f: Cr },
      255: { n: "", f: Cr },
    };
    var S = {
      0: { n: "BOF", f: Cr },
      1: { n: "EOF", f: Cr },
      3: { n: "??", f: Cr },
      4: { n: "??", f: Cr },
      5: { n: "??", f: Cr },
      6: { n: "??", f: Cr },
      7: { n: "??", f: Cr },
      9: { n: "??", f: Cr },
      10: { n: "??", f: Cr },
      11: { n: "??", f: Cr },
      12: { n: "??", f: Cr },
      14: { n: "??", f: Cr },
      15: { n: "??", f: Cr },
      16: { n: "??", f: Cr },
      17: { n: "??", f: Cr },
      18: { n: "??", f: Cr },
      19: { n: "??", f: Cr },
      21: { n: "??", f: Cr },
      22: { n: "LABEL16", f: h },
      23: { n: "NUMBER17", f: v },
      24: { n: "NUMBER18", f: d },
      25: { n: "FORMULA19", f: g },
      26: { n: "??", f: Cr },
      27: { n: "??", f: Cr },
      28: { n: "??", f: Cr },
      29: { n: "??", f: Cr },
      30: { n: "??", f: Cr },
      31: { n: "??", f: Cr },
      33: { n: "??", f: Cr },
      37: { n: "NUMBER25", f: b },
      39: { n: "NUMBER27", f: m },
      40: { n: "FORMULA28", f: E },
      255: { n: "", f: Cr },
    };
    return { to_workbook: r };
  })();
  var Lh = {
    0: 1252,
    1: 65001,
    2: 65001,
    77: 1e4,
    128: 932,
    129: 949,
    130: 1361,
    134: 936,
    136: 950,
    161: 1253,
    162: 1254,
    163: 1258,
    177: 1255,
    178: 1256,
    186: 1257,
    204: 1251,
    222: 874,
    238: 1250,
    255: 1252,
    69: 6969,
  };
  var Mh = (function ZE() {
    var e = Ae("t"),
      r = Ae("rPr"),
      t = /<(?:\w+:)?r>/g,
      a = /<\/(?:\w+:)?r>/,
      n = /\r\n/g;
    var i = function f(e, r, t) {
      var a = {},
        n = 65001,
        i = "";
      var s = e.match(ae),
        f = 0;
      if (s)
        for (; f != s.length; ++f) {
          var o = se(s[f]);
          switch (o[0].replace(/\w*:/g, "")) {
            case "<condense":
              break;
            case "<extend":
              break;
            case "<shadow":
              if (!o.val) break;
            case "<shadow>":
            case "<shadow/>":
              a.shadow = 1;
              break;
            case "</shadow>":
              break;
            case "<charset":
              if (o.val == "1") break;
              n = Lh[parseInt(o.val, 10)];
              break;
            case "<outline":
              if (!o.val) break;
            case "<outline>":
            case "<outline/>":
              a.outline = 1;
              break;
            case "</outline>":
              break;
            case "<rFont":
              a.name = o.val;
              break;
            case "<sz":
              a.sz = o.val;
              break;
            case "<strike":
              if (!o.val) break;
            case "<strike>":
            case "<strike/>":
              a.strike = 1;
              break;
            case "</strike>":
              break;
            case "<u":
              if (!o.val) break;
              switch (o.val) {
                case "double":
                  a.uval = "double";
                  break;
                case "singleAccounting":
                  a.uval = "single-accounting";
                  break;
                case "doubleAccounting":
                  a.uval = "double-accounting";
                  break;
              }
            case "<u>":
            case "<u/>":
              a.u = 1;
              break;
            case "</u>":
              break;
            case "<b":
              if (o.val == "0") break;
            case "<b>":
            case "<b/>":
              a.b = 1;
              break;
            case "</b>":
              break;
            case "<i":
              if (o.val == "0") break;
            case "<i>":
            case "<i/>":
              a.i = 1;
              break;
            case "</i>":
              break;
            case "<color":
              if (o.rgb) a.color = o.rgb.substr(2, 6);
              break;
            case "<family":
              a.family = o.val;
              break;
            case "<vertAlign":
              i = o.val;
              break;
            case "<scheme":
              break;
            default:
              if (o[0].charCodeAt(1) !== 47)
                throw "Unrecognized rich format " + o[0];
          }
        }
      var l = [];
      if (a.u) l.push("text-decoration: underline;");
      if (a.uval) l.push("text-underline-style:" + a.uval + ";");
      if (a.sz) l.push("font-size:" + a.sz + ";");
      if (a.outline) l.push("text-effect: outline;");
      if (a.shadow) l.push("text-shadow: auto;");
      r.push('<span style="' + l.join("") + '">');
      if (a.b) {
        r.push("<b>");
        t.push("</b>");
      }
      if (a.i) {
        r.push("<i>");
        t.push("</i>");
      }
      if (a.strike) {
        r.push("<s>");
        t.push("</s>");
      }
      if (i == "superscript") i = "sup";
      else if (i == "subscript") i = "sub";
      if (i != "") {
        r.push("<" + i + ">");
        t.push("</" + i + ">");
      }
      t.push("</span>");
      return n;
    };
    function s(t) {
      var a = [[], "", []];
      var s = t.match(e),
        f = 65001;
      if (!T(s)) return "";
      a[1] = s[1];
      var o = t.match(r);
      if (T(o)) f = i(o[1], a[0], a[2]);
      return a[0].join("") + a[1].replace(n, "<br/>") + a[2].join("");
    }
    return function o(e) {
      return e.replace(t, "").split(a).map(s).join("");
    };
  })();
  var Uh = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,
    Hh = /<(?:\w+:)?r>/;
  var Wh = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
  function Vh(e, r) {
    var t = r ? r.cellHTML : true;
    var a = {};
    if (!e) return null;
    var n;
    if (e.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
      a.t = Ee(ce(e.substr(e.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0]));
      a.r = Ee(e);
      if (t) a.h = ge(a.t);
    } else if ((n = e.match(Hh))) {
      a.r = Ee(e);
      a.t = Ee(
        ce((e.replace(Wh, "").match(Uh) || []).join("").replace(ae, ""))
      );
      if (t) a.h = Mh(a.r);
    }
    return a;
  }
  var zh = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
  var Xh = /<(?:\w+:)?(?:si|sstItem)>/g;
  var Gh = /<\/(?:\w+:)?(?:si|sstItem)>/;
  function jh(e, r) {
    var t = [],
      a = "";
    if (!e) return t;
    var n = e.match(zh);
    if (T(n)) {
      a = n[2].replace(Xh, "").split(Gh);
      for (var i = 0; i != a.length; ++i) {
        var s = Vh(a[i].trim(), r);
        if (s != null) t[t.length] = s;
      }
      n = se(n[1]);
      t.Count = n.count;
      t.Unique = n.uniqueCount;
    }
    return t;
  }
  ia.SST =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
  var Kh = /^\s|\s$|[\t\n\r]/;
  function Yh(e, r) {
    if (!r.bookSST) return "";
    var t = [Pe];
    t[t.length] = De("sst", null, {
      xmlns: Ne.main[0],
      count: e.Count,
      uniqueCount: e.Unique,
    });
    for (var a = 0; a != e.length; ++a) {
      if (e[a] == null) continue;
      var n = e[a];
      var i = "<si>";
      if (n.r) i += n.r;
      else {
        i += "<t";
        if (!n.t) n.t = "";
        if (n.t.match(Kh)) i += ' xml:space="preserve"';
        i += ">" + de(n.t) + "</t>";
      }
      i += "</si>";
      t[t.length] = i;
    }
    if (t.length > 2) {
      t[t.length] = "</sst>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  function $h(e, r) {
    return [e.read_shift(4), e.read_shift(4)];
  }
  function Zh(e, r) {
    var t = [];
    var a = false;
    wr(e, function n(e, i, s) {
      switch (s) {
        case 159:
          t.Count = e[0];
          t.Unique = e[1];
          break;
        case 19:
          t.push(e);
          break;
        case 160:
          return true;
        case 35:
          a = true;
          break;
        case 36:
          a = false;
          break;
        default:
          if (i.indexOf("Begin") > 0) {
          } else if (i.indexOf("End") > 0) {
          }
          if (!a || r.WTF) throw new Error("Unexpected record " + s + " " + i);
      }
    });
    return t;
  }
  function Qh(e, r) {
    if (!r) r = Sr(8);
    r.write_shift(4, e.Count);
    r.write_shift(4, e.Unique);
    return r;
  }
  var Jh = nt;
  function qh(e, r) {
    var t = Ar();
    Br(t, "BrtBeginSst", Qh(e));
    for (var a = 0; a < e.length; ++a) Br(t, "BrtSSTItem", Jh(e[a]));
    Br(t, "BrtEndSst");
    return t.end();
  }
  function eu(e) {
    if (typeof cptable !== "undefined") return cptable.utils.encode(1252, e);
    var r = [],
      t = e.split("");
    for (var a = 0; a < t.length; ++a) r[a] = t[a].charCodeAt(0);
    return r;
  }
  function ru(e, r) {
    var t = {};
    t.Major = e.read_shift(2);
    t.Minor = e.read_shift(2);
    if (r >= 4) e.l += r - 4;
    return t;
  }
  function tu(e, r) {
    var t = {};
    t.id = e.read_shift(0, "lpp4");
    t.R = ru(e, 4);
    t.U = ru(e, 4);
    t.W = ru(e, 4);
    return t;
  }
  function au(e) {
    var r = e.read_shift(4);
    var t = e.l + r - 4;
    var a = {};
    var n = e.read_shift(4);
    var i = [];
    while (n-- > 0) {
      var s = {};
      s.t = e.read_shift(4);
      s.v = e.read_shift(0, "lpp4");
      i.push(s);
    }
    a.name = e.read_shift(0, "lpp4");
    a.comps = i;
    return a;
  }
  function nu(e, r) {
    var t = [];
    e.l += 4;
    var a = e.read_shift(4);
    while (a-- > 0) t.push(au(e));
    return t;
  }
  function iu(e, r) {
    var t = [];
    e.l += 4;
    var a = e.read_shift(4);
    while (a-- > 0) t.push(e.read_shift(0, "lpp4"));
    return t;
  }
  function su(e, r) {
    var t = {};
    var a = e.read_shift(4);
    var n = e.l + a - 4;
    e.l += 4;
    t.id = e.read_shift(0, "lpp4");
    t.name = e.read_shift(0, "lpp4");
    t.R = ru(e, 4);
    t.U = ru(e, 4);
    t.W = ru(e, 4);
    return t;
  }
  function fu(e, r) {
    var t = su(e);
    t.ename = e.read_shift(0, "8lpp4");
    t.blksz = e.read_shift(4);
    t.cmode = e.read_shift(4);
    if (e.read_shift(4) != 4) throw new Error("Bad !Primary record");
    return t;
  }
  function ou(e, r) {
    var t = e.l + r;
    var a = {};
    a.Flags = e.read_shift(4) & 63;
    e.l += 4;
    a.AlgID = e.read_shift(4);
    var n = false;
    switch (a.AlgID) {
      case 26126:
      case 26127:
      case 26128:
        n = a.Flags == 36;
        break;
      case 26625:
        n = a.Flags == 4;
        break;
      case 0:
        n = a.Flags == 16 || a.Flags == 4 || a.Flags == 36;
        break;
      default:
        throw "Unrecognized encryption algorithm: " + a.AlgID;
    }
    if (!n) throw new Error("Encryption Flags/AlgID mismatch");
    a.AlgIDHash = e.read_shift(4);
    a.KeySize = e.read_shift(4);
    a.ProviderType = e.read_shift(4);
    e.l += 8;
    a.CSPName = e.read_shift((t - e.l) >> 1, "utf16le").slice(0, -1);
    e.l = t;
    return a;
  }
  function lu(e, r) {
    var t = {};
    e.l += 4;
    t.Salt = e.slice(e.l, e.l + 16);
    e.l += 16;
    t.Verifier = e.slice(e.l, e.l + 16);
    e.l += 16;
    var a = e.read_shift(4);
    t.VerifierHash = e.slice(e.l, e.l + a);
    e.l += a;
    return t;
  }
  function cu(e, r) {
    var t = ru(e);
    switch (t.Minor) {
      case 2:
        return hu(e, t);
      case 3:
        return uu(e, t);
      case 4:
        return du(e, t);
    }
    throw new Error("ECMA-376 Encryped file unrecognized Version: " + t.Minor);
  }
  function hu(e, r) {
    var t = e.read_shift(4);
    if ((t & 63) != 36) throw new Error("EncryptionInfo mismatch");
    var a = e.read_shift(4);
    var n = e.l + a;
    var i = ou(e, a);
    var s = lu(e, e.length - e.l);
    return { t: "Std", h: i, v: s };
  }
  function uu(e, r) {
    throw new Error("File is password-protected: ECMA-376 Extensible");
  }
  function du(e, r) {
    throw new Error("File is password-protected: ECMA-376 Agile");
  }
  function vu(e, r) {
    var t = {};
    var a = (t.EncryptionVersionInfo = ru(e, 4));
    r -= 4;
    if (a.Minor != 2)
      throw new Error("unrecognized minor version code: " + a.Minor);
    if (a.Major > 4 || a.Major < 2)
      throw new Error("unrecognized major version code: " + a.Major);
    t.Flags = e.read_shift(4);
    r -= 4;
    var n = e.read_shift(4);
    r -= 4;
    t.EncryptionHeader = ou(e, n);
    r -= n;
    t.EncryptionVerifier = lu(e, r);
    return t;
  }
  function pu(e, r) {
    var t = {};
    var a = (t.EncryptionVersionInfo = ru(e, 4));
    r -= 4;
    if (a.Major != 1 || a.Minor != 1)
      throw "unrecognized version code " + a.Major + " : " + a.Minor;
    t.Salt = e.read_shift(16);
    t.EncryptedVerifier = e.read_shift(16);
    t.EncryptedVerifierHash = e.read_shift(16);
    return t;
  }
  function gu(e) {
    var r = 0,
      t;
    var a = eu(e);
    var n = a.length + 1,
      i,
      s;
    var f, o, l;
    t = v(n);
    t[0] = a.length;
    for (i = 1; i != n; ++i) t[i] = a[i - 1];
    for (i = n - 1; i >= 0; --i) {
      s = t[i];
      f = (r & 16384) === 0 ? 0 : 1;
      o = (r << 1) & 32767;
      l = f | o;
      r = l ^ s;
    }
    return r ^ 52811;
  }
  var bu = (function () {
    var e = [187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0];
    var r = [
      57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287,
      34041, 10252, 43370, 20163,
    ];
    var t = [
      44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933,
      60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248,
      885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614,
      21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210,
      60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898,
      15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812,
      17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557,
      1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128,
      28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883,
      1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628,
    ];
    var a = function (e) {
      return ((e / 2) | (e * 128)) & 255;
    };
    var n = function (e, r) {
      return a(e ^ r);
    };
    var i = function (e) {
      var a = r[e.length - 1];
      var n = 104;
      for (var i = e.length - 1; i >= 0; --i) {
        var s = e[i];
        for (var f = 0; f != 7; ++f) {
          if (s & 64) a ^= t[n];
          s *= 2;
          --n;
        }
      }
      return a;
    };
    return function (r) {
      var t = eu(r);
      var a = i(t);
      var s = t.length;
      var f = v(16);
      for (var o = 0; o != 16; ++o) f[o] = 0;
      var l, c, h;
      if ((s & 1) === 1) {
        l = a >> 8;
        f[s] = n(e[0], l);
        --s;
        l = a & 255;
        c = t[t.length - 1];
        f[s] = n(c, l);
      }
      while (s > 0) {
        --s;
        l = a >> 8;
        f[s] = n(t[s], l);
        --s;
        l = a & 255;
        f[s] = n(t[s], l);
      }
      s = 15;
      h = 15 - t.length;
      while (h > 0) {
        l = a >> 8;
        f[s] = n(e[h], l);
        --s;
        --h;
        l = a & 255;
        f[s] = n(t[s], l);
        --s;
        --h;
      }
      return f;
    };
  })();
  var mu = function (e, r, t, a, n) {
    if (!n) n = r;
    if (!a) a = bu(e);
    var i, s;
    for (i = 0; i != r.length; ++i) {
      s = r[i];
      s ^= a[t];
      s = ((s >> 5) | (s << 3)) & 255;
      n[i] = s;
      ++t;
    }
    return [n, t, a];
  };
  var Cu = function (e) {
    var r = 0,
      t = bu(e);
    return function (e) {
      var a = mu("", e, r, t);
      r = a[1];
      return a[0];
    };
  };
  function Eu(e, r, t, a) {
    var n = { key: nn(e), verificationBytes: nn(e) };
    if (t.password) n.verifier = gu(t.password);
    a.valid = n.verificationBytes === n.verifier;
    if (a.valid) a.insitu_decrypt = Cu(t.password);
    return n;
  }
  function ku(e, r, t) {
    var a = t || {};
    a.Info = e.read_shift(2);
    e.l -= 2;
    if (a.Info === 1) a.Data = pu(e, r);
    else a.Data = vu(e, r);
    return a;
  }
  function Su(e, r, t) {
    var a = { Type: t.biff >= 8 ? e.read_shift(2) : 0 };
    if (a.Type) ku(e, r - 2, a);
    else Eu(e, r - 2, t, a);
    return a;
  }
  function wu(e) {
    var r = e.substr(e[0] === "#" ? 1 : 0, 6);
    return [
      parseInt(r.substr(0, 2), 16),
      parseInt(r.substr(2, 2), 16),
      parseInt(r.substr(4, 2), 16),
    ];
  }
  function Au(e) {
    for (var r = 0, t = 1; r != 3; ++r)
      t = t * 256 + (e[r] > 255 ? 255 : e[r] < 0 ? 0 : e[r]);
    return t.toString(16).toUpperCase().substr(1);
  }
  function Bu(e) {
    var r = e[0] / 255,
      t = e[1] / 255,
      a = e[2] / 255;
    var n = Math.max(r, t, a),
      i = Math.min(r, t, a),
      s = n - i;
    if (s === 0) return [0, 0, r];
    var f = 0,
      o = 0,
      l = n + i;
    o = s / (l > 1 ? 2 - l : l);
    switch (n) {
      case r:
        f = ((t - a) / s + 6) % 6;
        break;
      case t:
        f = (a - r) / s + 2;
        break;
      case a:
        f = (r - t) / s + 4;
        break;
    }
    return [f / 6, o, l / 2];
  }
  function _u(e) {
    var r = e[0],
      t = e[1],
      a = e[2];
    var n = t * 2 * (a < 0.5 ? a : 1 - a),
      i = a - n / 2;
    var s = [i, i, i],
      f = 6 * r;
    var o;
    if (t !== 0)
      switch (f | 0) {
        case 0:
        case 6:
          o = n * f;
          s[0] += n;
          s[1] += o;
          break;
        case 1:
          o = n * (2 - f);
          s[0] += o;
          s[1] += n;
          break;
        case 2:
          o = n * (f - 2);
          s[1] += n;
          s[2] += o;
          break;
        case 3:
          o = n * (4 - f);
          s[1] += o;
          s[2] += n;
          break;
        case 4:
          o = n * (f - 4);
          s[2] += n;
          s[0] += o;
          break;
        case 5:
          o = n * (6 - f);
          s[2] += o;
          s[0] += n;
          break;
      }
    for (var l = 0; l != 3; ++l) s[l] = Math.round(s[l] * 255);
    return s;
  }
  function Tu(e, r) {
    if (r === 0) return e;
    var t = Bu(wu(e));
    if (r < 0) t[2] = t[2] * (1 + r);
    else t[2] = 1 - (1 - t[2]) * (1 - r);
    return Au(_u(t));
  }
  var xu = 6,
    Iu = 15,
    yu = 1,
    Ru = xu;
  function Du(e) {
    return Math.floor((e + Math.round(128 / Ru) / 256) * Ru);
  }
  function Ou(e) {
    return Math.floor(((e - 5) / Ru) * 100 + 0.5) / 100;
  }
  function Fu(e) {
    return Math.round(((e * Ru + 5) / Ru) * 256) / 256;
  }
  function Pu(e) {
    return (((e - 5) / Ru) * 100 + 0.5) / 100;
  }
  function Nu(e) {
    return (((e * Ru + 5) / Ru) * 256) / 256;
  }
  function Lu(e) {
    return Fu(Ou(Du(e)));
  }
  function Mu(e) {
    var r = Math.abs(e - Lu(e)),
      t = Ru;
    if (r > 0.005)
      for (Ru = yu; Ru < Iu; ++Ru)
        if (Math.abs(e - Lu(e)) <= r) {
          r = Math.abs(e - Lu(e));
          t = Ru;
        }
    Ru = t;
  }
  function Uu(e) {
    var r = Infinity,
      t = 0,
      a = yu;
    for (Ru = yu; Ru < Iu; ++Ru) {
      t = Nu(Pu(e)) * 256;
      t = t % 1;
      if (t > 0.5) t--;
      if (Math.abs(t) < r) {
        r = Math.abs(t);
        a = Ru;
      }
    }
    Ru = a;
  }
  function Hu(e) {
    if (e.width) {
      e.wpx = Du(e.width);
      e.wch = Ou(e.wpx);
      e.MDW = Ru;
    } else if (e.wpx) {
      e.wch = Ou(e.wpx);
      e.width = Fu(e.wch);
      e.MDW = Ru;
    } else if (typeof e.wch == "number") {
      e.width = Fu(e.wch);
      e.wpx = Du(e.width);
      e.MDW = Ru;
    }
    if (e.customWidth) delete e.customWidth;
  }
  var Wu = 96,
    Vu = Wu;
  function zu(e) {
    return (e * 96) / Vu;
  }
  function Xu(e) {
    return (e * Vu) / 96;
  }
  var Gu = {
    None: "none",
    Solid: "solid",
    Gray50: "mediumGray",
    Gray75: "darkGray",
    Gray25: "lightGray",
    HorzStripe: "darkHorizontal",
    VertStripe: "darkVertical",
    ReverseDiagStripe: "darkDown",
    DiagStripe: "darkUp",
    DiagCross: "darkGrid",
    ThickDiagCross: "darkTrellis",
    ThinHorzStripe: "lightHorizontal",
    ThinVertStripe: "lightVertical",
    ThinReverseDiagStripe: "lightDown",
    ThinHorzCross: "lightGrid",
  };
  function ju(e, r, t, a) {
    r.Borders = [];
    var n = {},
      i = {};
    e[0].match(ae).forEach(function (e) {
      var t = se(e);
      switch (t[0]) {
        case "<borders":
        case "<borders>":
        case "</borders>":
          break;
        case "<border":
        case "<border>":
        case "<border/>":
          n = {};
          if (t.diagonalUp) {
            n.diagonalUp = t.diagonalUp;
          }
          if (t.diagonalDown) {
            n.diagonalDown = t.diagonalDown;
          }
          r.Borders.push(n);
          break;
        case "</border>":
          break;
        case "<left/>":
          break;
        case "<left":
        case "<left>":
          break;
        case "</left>":
          break;
        case "<right/>":
          break;
        case "<right":
        case "<right>":
          break;
        case "</right>":
          break;
        case "<top/>":
          break;
        case "<top":
        case "<top>":
          break;
        case "</top>":
          break;
        case "<bottom/>":
          break;
        case "<bottom":
        case "<bottom>":
          break;
        case "</bottom>":
          break;
        case "<diagonal":
        case "<diagonal>":
        case "<diagonal/>":
          break;
        case "</diagonal>":
          break;
        case "<horizontal":
        case "<horizontal>":
        case "<horizontal/>":
          break;
        case "</horizontal>":
          break;
        case "<vertical":
        case "<vertical>":
        case "<vertical/>":
          break;
        case "</vertical>":
          break;
        case "<start":
        case "<start>":
        case "<start/>":
          break;
        case "</start>":
          break;
        case "<end":
        case "<end>":
        case "<end/>":
          break;
        case "</end>":
          break;
        case "<color":
        case "<color>":
          break;
        case "<color/>":
        case "</color>":
          break;
        default:
          if (a && a.WTF)
            throw new Error("unrecognized " + t[0] + " in borders");
      }
    });
  }
  function Ku(e, r, t, a) {
    r.Fills = [];
    var n = {};
    e[0].match(ae).forEach(function (e) {
      var t = se(e);
      switch (t[0]) {
        case "<fills":
        case "<fills>":
        case "</fills>":
          break;
        case "<fill>":
        case "<fill":
          break;
        case "</fill>":
          r.Fills.push(n);
          n = {};
          break;
        case "<gradientFill>":
          break;
        case "<gradientFill":
        case "</gradientFill>":
          r.Fills.push(n);
          n = {};
          break;
        case "<patternFill":
        case "<patternFill>":
          if (t.patternType) n.patternType = t.patternType;
          break;
        case "<patternFill/>":
        case "</patternFill>":
          break;
        case "<bgColor":
          if (!n.bgColor) n.bgColor = {};
          if (t.indexed) n.bgColor.indexed = parseInt(t.indexed, 10);
          if (t.theme) n.bgColor.theme = parseInt(t.theme, 10);
          if (t.tint) n.bgColor.tint = parseFloat(t.tint);
          if (t.rgb) n.bgColor.rgb = t.rgb.slice(-6);
          break;
        case "<bgColor/>":
        case "</bgColor>":
          break;
        case "<fgColor":
          if (!n.fgColor) n.fgColor = {};
          if (t.theme) n.fgColor.theme = parseInt(t.theme, 10);
          if (t.tint) n.fgColor.tint = parseFloat(t.tint);
          if (t.rgb) n.fgColor.rgb = t.rgb.slice(-6);
          break;
        case "<fgColor/>":
        case "</fgColor>":
          break;
        case "<stop":
        case "<stop/>":
          break;
        case "</stop>":
          break;
        case "<color":
        case "<color/>":
          break;
        case "</color>":
          break;
        default:
          if (a && a.WTF) throw new Error("unrecognized " + t[0] + " in fills");
      }
    });
  }
  function Yu(e, r, t, a) {
    r.Fonts = [];
    var n = {};
    e[0].match(ae).forEach(function (e) {
      var i = se(e);
      switch (i[0]) {
        case "<fonts":
        case "<fonts>":
        case "</fonts>":
          break;
        case "<font":
        case "<font>":
          break;
        case "</font>":
        case "<font/>":
          r.Fonts.push(n);
          n = {};
          break;
        case "<name":
          if (i.val) n.name = i.val;
          break;
        case "<name/>":
        case "</name>":
          break;
        case "<b":
          n.bold = i.val ? Ce(i.val) : 1;
          break;
        case "<b/>":
          n.bold = 1;
          break;
        case "<i":
          n.italic = i.val ? Ce(i.val) : 1;
          break;
        case "<i/>":
          n.italic = 1;
          break;
        case "<u":
          switch (i.val) {
            case "none":
              n.underline = 0;
              break;
            case "single":
              n.underline = 1;
              break;
            case "double":
              n.underline = 2;
              break;
            case "singleAccounting":
              n.underline = 33;
              break;
            case "doubleAccounting":
              n.underline = 34;
              break;
          }
          break;
        case "<u/>":
          n.underline = 1;
          break;
        case "<strike":
          n.strike = i.val ? Ce(i.val) : 1;
          break;
        case "<strike/>":
          n.strike = 1;
          break;
        case "<outline":
          n.outline = i.val ? Ce(i.val) : 1;
          break;
        case "<outline/>":
          n.outline = 1;
          break;
        case "<shadow":
          n.shadow = i.val ? Ce(i.val) : 1;
          break;
        case "<shadow/>":
          n.shadow = 1;
          break;
        case "<condense":
          n.condense = i.val ? Ce(i.val) : 1;
          break;
        case "<condense/>":
          n.condense = 1;
          break;
        case "<extend":
          n.extend = i.val ? Ce(i.val) : 1;
          break;
        case "<extend/>":
          n.extend = 1;
          break;
        case "<sz":
          if (i.val) n.sz = +i.val;
          break;
        case "<sz/>":
        case "</sz>":
          break;
        case "<vertAlign":
          if (i.val) n.vertAlign = i.val;
          break;
        case "<vertAlign/>":
        case "</vertAlign>":
          break;
        case "<family":
          if (i.val) n.family = parseInt(i.val, 10);
          break;
        case "<family/>":
        case "</family>":
          break;
        case "<scheme":
          if (i.val) n.scheme = i.val;
          break;
        case "<scheme/>":
        case "</scheme>":
          break;
        case "<charset":
          if (i.val == "1") break;
          i.codepage = Lh[parseInt(i.val, 10)];
          break;
        case "<color":
          if (!n.color) n.color = {};
          if (i.auto) n.color.auto = Ce(i.auto);
          if (i.rgb) n.color.rgb = i.rgb.slice(-6);
          else if (i.indexed) {
            n.color.index = parseInt(i.indexed, 10);
            var s = Zt[n.color.index];
            if (n.color.index == 81) s = Zt[1];
            if (!s) throw new Error(e);
            n.color.rgb =
              s[0].toString(16) + s[1].toString(16) + s[2].toString(16);
          } else if (i.theme) {
            n.color.theme = parseInt(i.theme, 10);
            if (i.tint) n.color.tint = parseFloat(i.tint);
            if (i.theme && t.themeElements && t.themeElements.clrScheme) {
              n.color.rgb = Tu(
                t.themeElements.clrScheme[n.color.theme].rgb,
                n.color.tint || 0
              );
            }
          }
          break;
        case "<color/>":
        case "</color>":
          break;
        default:
          if (a && a.WTF) throw new Error("unrecognized " + i[0] + " in fonts");
      }
    });
  }
  function $u(e, r, t) {
    r.NumberFmt = [];
    var a = x(C._table);
    for (var n = 0; n < a.length; ++n) r.NumberFmt[a[n]] = C._table[a[n]];
    var i = e[0].match(ae);
    if (!i) return;
    for (n = 0; n < i.length; ++n) {
      var s = se(i[n]);
      switch (s[0]) {
        case "<numFmts":
        case "</numFmts>":
        case "<numFmts/>":
        case "<numFmts>":
          break;
        case "<numFmt":
          {
            var f = ce(Ee(s.formatCode)),
              o = parseInt(s.numFmtId, 10);
            r.NumberFmt[o] = f;
            if (o > 0) {
              if (o > 392) {
                for (o = 392; o > 60; --o) if (r.NumberFmt[o] == null) break;
                r.NumberFmt[o] = f;
              }
              C.load(f, o);
            }
          }
          break;
        case "</numFmt>":
          break;
        default:
          if (t.WTF) throw new Error("unrecognized " + s[0] + " in numFmts");
      }
    }
  }
  function Zu(e, r) {
    var t = ["<numFmts>"];
    [
      [5, 8],
      [23, 26],
      [41, 44],
      [50, 392],
    ].forEach(function (r) {
      for (var a = r[0]; a <= r[1]; ++a)
        if (e[a] != null)
          t[t.length] = De("numFmt", null, {
            numFmtId: a,
            formatCode: de(e[a]),
          });
    });
    if (t.length === 1) return "";
    t[t.length] = "</numFmts>";
    t[0] = De("numFmts", null, { count: t.length - 2 }).replace("/>", ">");
    return t.join("");
  }
  var Qu = ["numFmtId", "fillId", "fontId", "borderId", "xfId"];
  var Ju = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix",
  ];
  function qu(e, r, t) {
    r.CellXf = [];
    var a;
    e[0].match(ae).forEach(function (e) {
      var n = se(e),
        i = 0;
      switch (n[0]) {
        case "<cellXfs":
        case "<cellXfs>":
        case "<cellXfs/>":
        case "</cellXfs>":
          break;
        case "<xf":
        case "<xf/>":
          a = n;
          delete a[0];
          for (i = 0; i < Qu.length; ++i)
            if (a[Qu[i]]) a[Qu[i]] = parseInt(a[Qu[i]], 10);
          for (i = 0; i < Ju.length; ++i)
            if (a[Ju[i]]) a[Ju[i]] = Ce(a[Ju[i]], "");
          if (a.numFmtId > 392) {
            for (i = 392; i > 60; --i)
              if (r.NumberFmt[a.numFmtId] == r.NumberFmt[i]) {
                a.numFmtId = i;
                break;
              }
          }
          r.CellXf.push(a);
          break;
        case "</xf>":
          break;
        case "<alignment":
        case "<alignment/>":
          var s = {};
          if (n.vertical) s.vertical = n.vertical;
          if (n.horizontal) s.horizontal = n.horizontal;
          if (n.textRotation != null) s.textRotation = n.textRotation;
          if (n.indent) s.indent = n.indent;
          if (n.wrapText) s.wrapText = n.wrapText;
          a.alignment = s;
          break;
        case "</alignment>":
          break;
        case "<protection":
        case "</protection>":
        case "<protection/>":
          break;
        case "<extLst":
        case "</extLst>":
          break;
        case "<ext":
          break;
        default:
          if (t.WTF) throw new Error("unrecognized " + n[0] + " in cellXfs");
      }
    });
  }
  function ed(e) {
    var r = [];
    r[r.length] = De("cellXfs", null);
    e.forEach(function (e) {
      r[r.length] = De("xf", null, e);
    });
    r[r.length] = "</cellXfs>";
    if (r.length === 2) return "";
    r[0] = De("cellXfs", null, { count: r.length - 2 }).replace("/>", ">");
    return r.join("");
  }
  var rd = (function QE() {
    var e = /<numFmts([^>]*)>[\S\s]*?<\/numFmts>/;
    var r = /<cellXfs([^>]*)>[\S\s]*?<\/cellXfs>/;
    var t = /<fills([^>]*)>[\S\s]*?<\/fills>/;
    var a = /<fonts([^>]*)>[\S\s]*?<\/fonts>/;
    var n = /<borders([^>]*)>[\S\s]*?<\/borders>/;
    return function i(s, f, o) {
      var l = {};
      if (!s) return l;
      s = s
        .replace(/<!--([\s\S]*?)-->/gm, "")
        .replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
      var c;
      if ((c = s.match(e))) $u(c, l, o);
      if ((c = s.match(a))) Yu(c, l, f, o);
      if ((c = s.match(t))) Ku(c, l, f, o);
      if ((c = s.match(n))) ju(c, l, f, o);
      if ((c = s.match(r))) qu(c, l, o);
      return l;
    };
  })();
  var td = De("styleSheet", null, { xmlns: Ne.main[0], "xmlns:vt": Ne.vt });
  ia.STY =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";
  function ad(e, r) {
    var t = [Pe, td],
      a;
    if (e.SSF && (a = Zu(e.SSF)) != null) t[t.length] = a;
    t[t.length] =
      '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    t[t.length] =
      '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    t[t.length] =
      '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    t[t.length] =
      '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if ((a = ed(r.cellXfs))) t[t.length] = a;
    t[t.length] =
      '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    t[t.length] = '<dxfs count="0"/>';
    t[t.length] =
      '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (t.length > 2) {
      t[t.length] = "</styleSheet>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  function nd(e, r) {
    var t = e.read_shift(2);
    var a = qr(e, r - 2);
    return [t, a];
  }
  function id(e, r, t) {
    if (!t) t = Sr(6 + 4 * r.length);
    t.write_shift(2, e);
    et(r, t);
    return t.length > t.l ? t.slice(0, t.l) : t;
  }
  function sd(e, r, t) {
    var a = {};
    a.sz = e.read_shift(2) / 20;
    var n = It(e, 2, t);
    if (n.fCondense) a.condense = 1;
    if (n.fExtend) a.extend = 1;
    if (n.fShadow) a.shadow = 1;
    if (n.fOutline) a.outline = 1;
    if (n.fStrikeout) a.strike = 1;
    if (n.fItalic) a.italic = 1;
    var i = e.read_shift(2);
    if (i === 700) a.bold = 1;
    switch (e.read_shift(2)) {
      case 1:
        a.vertAlign = "superscript";
        break;
      case 2:
        a.vertAlign = "subscript";
        break;
    }
    var s = e.read_shift(1);
    if (s != 0) a.underline = s;
    var f = e.read_shift(1);
    if (f > 0) a.family = f;
    var o = e.read_shift(1);
    if (o > 0) a.charset = o;
    e.l++;
    a.color = Tt(e, 8);
    switch (e.read_shift(1)) {
      case 1:
        a.scheme = "major";
        break;
      case 2:
        a.scheme = "minor";
        break;
    }
    a.name = qr(e, r - 21);
    return a;
  }
  function fd(e, r) {
    if (!r) r = Sr(25 + 4 * 32);
    r.write_shift(2, e.sz * 20);
    yt(e, r);
    r.write_shift(2, e.bold ? 700 : 400);
    var t = 0;
    if (e.vertAlign == "superscript") t = 1;
    else if (e.vertAlign == "subscript") t = 2;
    r.write_shift(2, t);
    r.write_shift(1, e.underline || 0);
    r.write_shift(1, e.family || 0);
    r.write_shift(1, e.charset || 0);
    r.write_shift(1, 0);
    xt(e.color, r);
    var a = 0;
    if (e.scheme == "major") a = 1;
    if (e.scheme == "minor") a = 2;
    r.write_shift(1, a);
    et(e.name, r);
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  var od = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625",
  ];
  var ld = y(od);
  function cd(e, r) {
    if (!r) r = Sr(4 * 3 + 8 * 7 + 16 * 1);
    var t = ld[e.patternType];
    if (t == null) t = 40;
    r.write_shift(4, t);
    var a = 0;
    if (t != 40) {
      xt({ auto: 1 }, r);
      xt({ auto: 1 }, r);
      for (; a < 12; ++a) r.write_shift(4, 0);
    } else {
      for (; a < 4; ++a) r.write_shift(4, 0);
      for (; a < 12; ++a) r.write_shift(4, 0);
    }
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  function hd(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    Cr(e, r - 4);
    return { ixfe: t, numFmtId: a };
  }
  function ud(e, r, t) {
    if (!t) t = Sr(16);
    t.write_shift(2, r || 0);
    t.write_shift(2, e.numFmtId || 0);
    t.write_shift(2, 0);
    t.write_shift(2, 0);
    t.write_shift(2, 0);
    t.write_shift(1, 0);
    t.write_shift(1, 0);
    t.write_shift(1, 0);
    t.write_shift(1, 0);
    t.write_shift(1, 0);
    t.write_shift(1, 0);
    return t;
  }
  function dd(e, r) {
    if (!r) r = Sr(10);
    r.write_shift(1, 0);
    r.write_shift(1, 0);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    return r;
  }
  function vd(e, r) {
    if (!r) r = Sr(51);
    r.write_shift(1, 0);
    dd(null, r);
    dd(null, r);
    dd(null, r);
    dd(null, r);
    dd(null, r);
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  function pd(e, r) {
    if (!r) r = Sr(12 + 4 * 10);
    r.write_shift(4, e.xfId);
    r.write_shift(2, 1);
    r.write_shift(1, +e.builtinId);
    r.write_shift(1, 0);
    ut(e.name || "", r);
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  function gd(e, r, t) {
    var a = Sr(4 + 256 * 2 * 4);
    a.write_shift(4, e);
    ut(r, a);
    ut(t, a);
    return a.length > a.l ? a.slice(0, a.l) : a;
  }
  function bd(e, r, t) {
    var a = {};
    a.NumberFmt = [];
    for (var n in C._table) a.NumberFmt[n] = C._table[n];
    a.CellXf = [];
    a.Fonts = [];
    var i = [];
    var s = false;
    wr(e, function f(e, n, o) {
      switch (o) {
        case 44:
          a.NumberFmt[e[0]] = e[1];
          C.load(e[1], e[0]);
          break;
        case 43:
          a.Fonts.push(e);
          if (
            e.color.theme != null &&
            r &&
            r.themeElements &&
            r.themeElements.clrScheme
          ) {
            e.color.rgb = Tu(
              r.themeElements.clrScheme[e.color.theme].rgb,
              e.color.tint || 0
            );
          }
          break;
        case 1025:
          break;
        case 45:
          break;
        case 46:
          break;
        case 47:
          if (i[i.length - 1] == "BrtBeginCellXFs") {
            a.CellXf.push(e);
          }
          break;
        case 48:
        case 507:
        case 572:
        case 475:
          break;
        case 1171:
        case 2102:
        case 1130:
        case 512:
        case 2095:
          break;
        case 35:
          s = true;
          break;
        case 36:
          s = false;
          break;
        case 37:
          i.push(n);
          break;
        case 38:
          i.pop();
          break;
        default:
          if ((n || "").indexOf("Begin") > 0) i.push(n);
          else if ((n || "").indexOf("End") > 0) i.pop();
          else if (!s || t.WTF)
            throw new Error("Unexpected record " + o + " " + n);
      }
    });
    return a;
  }
  function md(e, r) {
    if (!r) return;
    var t = 0;
    [
      [5, 8],
      [23, 26],
      [41, 44],
      [50, 392],
    ].forEach(function (e) {
      for (var a = e[0]; a <= e[1]; ++a) if (r[a] != null) ++t;
    });
    if (t == 0) return;
    Br(e, "BrtBeginFmts", Jr(t));
    [
      [5, 8],
      [23, 26],
      [41, 44],
      [50, 392],
    ].forEach(function (t) {
      for (var a = t[0]; a <= t[1]; ++a)
        if (r[a] != null) Br(e, "BrtFmt", id(a, r[a]));
    });
    Br(e, "BrtEndFmts");
  }
  function Cd(e, r) {
    var t = 1;
    if (t == 0) return;
    Br(e, "BrtBeginFonts", Jr(t));
    Br(
      e,
      "BrtFont",
      fd({
        sz: 12,
        color: { theme: 1 },
        name: "Calibri",
        family: 2,
        scheme: "minor",
      })
    );
    Br(e, "BrtEndFonts");
  }
  function Ed(e, r) {
    var t = 2;
    if (t == 0) return;
    Br(e, "BrtBeginFills", Jr(t));
    Br(e, "BrtFill", cd({ patternType: "none" }));
    Br(e, "BrtFill", cd({ patternType: "gray125" }));
    Br(e, "BrtEndFills");
  }
  function kd(e, r) {
    var t = 1;
    if (t == 0) return;
    Br(e, "BrtBeginBorders", Jr(t));
    Br(e, "BrtBorder", vd({}));
    Br(e, "BrtEndBorders");
  }
  function Sd(e, r) {
    var t = 1;
    Br(e, "BrtBeginCellStyleXFs", Jr(t));
    Br(
      e,
      "BrtXF",
      ud({ numFmtId: 0, fontId: 0, fillId: 0, borderId: 0 }, 65535)
    );
    Br(e, "BrtEndCellStyleXFs");
  }
  function wd(e, r) {
    Br(e, "BrtBeginCellXFs", Jr(r.length));
    r.forEach(function (r) {
      Br(e, "BrtXF", ud(r, 0));
    });
    Br(e, "BrtEndCellXFs");
  }
  function Ad(e, r) {
    var t = 1;
    Br(e, "BrtBeginStyles", Jr(1));
    Br(e, "BrtStyle", pd({ xfId: 0, builtinId: 0, name: "Normal" }));
    Br(e, "BrtEndStyles");
  }
  function Bd(e, r) {
    var t = 0;
    Br(e, "BrtBeginDXFs", Jr(t));
    Br(e, "BrtEndDXFs");
  }
  function _d(e, r) {
    var t = 0;
    Br(
      e,
      "BrtBeginTableStyles",
      gd(t, "TableStyleMedium9", "PivotStyleMedium4")
    );
    Br(e, "BrtEndTableStyles");
  }
  function Td(e, r) {
    return;
  }
  function xd(e, r) {
    var t = Ar();
    Br(t, "BrtBeginStyleSheet");
    md(t, e.SSF);
    Cd(t, e);
    Ed(t, e);
    kd(t, e);
    Sd(t, e);
    wd(t, r.cellXfs);
    Ad(t, e);
    Bd(t, e);
    _d(t, e);
    Td(t, e);
    Br(t, "BrtEndStyleSheet");
    return t.end();
  }
  ia.THEME =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";
  function Id(e, r, t) {
    r.themeElements.clrScheme = [];
    var a = {};
    (e[0].match(ae) || []).forEach(function (e) {
      var n = se(e);
      switch (n[0]) {
        case "<a:clrScheme":
        case "</a:clrScheme>":
          break;
        case "<a:srgbClr":
          a.rgb = n.val;
          break;
        case "<a:sysClr":
          a.rgb = n.lastClr;
          break;
        case "<a:dk1>":
        case "</a:dk1>":
        case "<a:lt1>":
        case "</a:lt1>":
        case "<a:dk2>":
        case "</a:dk2>":
        case "<a:lt2>":
        case "</a:lt2>":
        case "<a:accent1>":
        case "</a:accent1>":
        case "<a:accent2>":
        case "</a:accent2>":
        case "<a:accent3>":
        case "</a:accent3>":
        case "<a:accent4>":
        case "</a:accent4>":
        case "<a:accent5>":
        case "</a:accent5>":
        case "<a:accent6>":
        case "</a:accent6>":
        case "<a:hlink>":
        case "</a:hlink>":
        case "<a:folHlink>":
        case "</a:folHlink>":
          if (n[0].charAt(1) === "/") {
            r.themeElements.clrScheme.push(a);
            a = {};
          } else {
            a.name = n[0].substring(3, n[0].length - 1);
          }
          break;
        default:
          if (t && t.WTF)
            throw new Error("Unrecognized " + n[0] + " in clrScheme");
      }
    });
  }
  function yd(e, r, t) {}
  function Rd(e, r, t) {}
  var Dd = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
  var Od = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
  var Fd = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
  function Pd(e, r, t) {
    r.themeElements = {};
    var a;
    [
      ["clrScheme", Dd, Id],
      ["fontScheme", Od, yd],
      ["fmtScheme", Fd, Rd],
    ].forEach(function (n) {
      if (!(a = e.match(n[1])))
        throw new Error(n[0] + " not found in themeElements");
      n[2](a, r, t);
    });
  }
  var Nd = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
  function Ld(e, r) {
    if (!e || e.length === 0) return Ld(Md());
    var t;
    var a = {};
    if (!(t = e.match(Nd))) throw new Error("themeElements not found in theme");
    Pd(t[0], a, r);
    return a;
  }
  function Md(e, r) {
    if (r && r.themeXLSX) return r.themeXLSX;
    var t = [Pe];
    t[t.length] =
      '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    t[t.length] = "<a:themeElements>";
    t[t.length] = '<a:clrScheme name="Office">';
    t[t.length] =
      '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    t[t.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    t[t.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    t[t.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    t[t.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    t[t.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    t[t.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    t[t.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    t[t.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    t[t.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    t[t.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    t[t.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    t[t.length] = "</a:clrScheme>";
    t[t.length] = '<a:fontScheme name="Office">';
    t[t.length] = "<a:majorFont>";
    t[t.length] = '<a:latin typeface="Cambria"/>';
    t[t.length] = '<a:ea typeface=""/>';
    t[t.length] = '<a:cs typeface=""/>';
    t[t.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
    t[t.length] = '<a:font script="Hang" typeface="맑은 고딕"/>';
    t[t.length] = '<a:font script="Hans" typeface="宋体"/>';
    t[t.length] = '<a:font script="Hant" typeface="新細明體"/>';
    t[t.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    t[t.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    t[t.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    t[t.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    t[t.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    t[t.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    t[t.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    t[t.length] = '<a:font script="Knda" typeface="Tunga"/>';
    t[t.length] = '<a:font script="Guru" typeface="Raavi"/>';
    t[t.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    t[t.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    t[t.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    t[t.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    t[t.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    t[t.length] = '<a:font script="Deva" typeface="Mangal"/>';
    t[t.length] = '<a:font script="Telu" typeface="Gautami"/>';
    t[t.length] = '<a:font script="Taml" typeface="Latha"/>';
    t[t.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    t[t.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    t[t.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    t[t.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    t[t.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    t[t.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    t[t.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    t[t.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    t[t.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    t[t.length] = "</a:majorFont>";
    t[t.length] = "<a:minorFont>";
    t[t.length] = '<a:latin typeface="Calibri"/>';
    t[t.length] = '<a:ea typeface=""/>';
    t[t.length] = '<a:cs typeface=""/>';
    t[t.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
    t[t.length] = '<a:font script="Hang" typeface="맑은 고딕"/>';
    t[t.length] = '<a:font script="Hans" typeface="宋体"/>';
    t[t.length] = '<a:font script="Hant" typeface="新細明體"/>';
    t[t.length] = '<a:font script="Arab" typeface="Arial"/>';
    t[t.length] = '<a:font script="Hebr" typeface="Arial"/>';
    t[t.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    t[t.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    t[t.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    t[t.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    t[t.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    t[t.length] = '<a:font script="Knda" typeface="Tunga"/>';
    t[t.length] = '<a:font script="Guru" typeface="Raavi"/>';
    t[t.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    t[t.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    t[t.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    t[t.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    t[t.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    t[t.length] = '<a:font script="Deva" typeface="Mangal"/>';
    t[t.length] = '<a:font script="Telu" typeface="Gautami"/>';
    t[t.length] = '<a:font script="Taml" typeface="Latha"/>';
    t[t.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    t[t.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    t[t.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    t[t.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    t[t.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    t[t.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    t[t.length] = '<a:font script="Viet" typeface="Arial"/>';
    t[t.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    t[t.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    t[t.length] = "</a:minorFont>";
    t[t.length] = "</a:fontScheme>";
    t[t.length] = '<a:fmtScheme name="Office">';
    t[t.length] = "<a:fillStyleLst>";
    t[t.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    t[t.length] = '<a:gradFill rotWithShape="1">';
    t[t.length] = "<a:gsLst>";
    t[t.length] =
      '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    t[t.length] = "</a:gsLst>";
    t[t.length] = '<a:lin ang="16200000" scaled="1"/>';
    t[t.length] = "</a:gradFill>";
    t[t.length] = '<a:gradFill rotWithShape="1">';
    t[t.length] = "<a:gsLst>";
    t[t.length] =
      '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    t[t.length] = "</a:gsLst>";
    t[t.length] = '<a:lin ang="16200000" scaled="0"/>';
    t[t.length] = "</a:gradFill>";
    t[t.length] = "</a:fillStyleLst>";
    t[t.length] = "<a:lnStyleLst>";
    t[t.length] =
      '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    t[t.length] =
      '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    t[t.length] =
      '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    t[t.length] = "</a:lnStyleLst>";
    t[t.length] = "<a:effectStyleLst>";
    t[t.length] = "<a:effectStyle>";
    t[t.length] = "<a:effectLst>";
    t[t.length] =
      '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    t[t.length] = "</a:effectLst>";
    t[t.length] = "</a:effectStyle>";
    t[t.length] = "<a:effectStyle>";
    t[t.length] = "<a:effectLst>";
    t[t.length] =
      '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    t[t.length] = "</a:effectLst>";
    t[t.length] = "</a:effectStyle>";
    t[t.length] = "<a:effectStyle>";
    t[t.length] = "<a:effectLst>";
    t[t.length] =
      '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    t[t.length] = "</a:effectLst>";
    t[t.length] =
      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    t[t.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    t[t.length] = "</a:effectStyle>";
    t[t.length] = "</a:effectStyleLst>";
    t[t.length] = "<a:bgFillStyleLst>";
    t[t.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    t[t.length] = '<a:gradFill rotWithShape="1">';
    t[t.length] = "<a:gsLst>";
    t[t.length] =
      '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    t[t.length] = "</a:gsLst>";
    t[t.length] =
      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    t[t.length] = "</a:gradFill>";
    t[t.length] = '<a:gradFill rotWithShape="1">';
    t[t.length] = "<a:gsLst>";
    t[t.length] =
      '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    t[t.length] = "</a:gsLst>";
    t[t.length] =
      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    t[t.length] = "</a:gradFill>";
    t[t.length] = "</a:bgFillStyleLst>";
    t[t.length] = "</a:fmtScheme>";
    t[t.length] = "</a:themeElements>";
    t[t.length] = "<a:objectDefaults>";
    t[t.length] = "<a:spDef>";
    t[t.length] =
      '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    t[t.length] = "</a:spDef>";
    t[t.length] = "<a:lnDef>";
    t[t.length] =
      '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    t[t.length] = "</a:lnDef>";
    t[t.length] = "</a:objectDefaults>";
    t[t.length] = "<a:extraClrSchemeLst/>";
    t[t.length] = "</a:theme>";
    return t.join("");
  }
  function Ud(e, r, t) {
    var a = e.read_shift(4);
    if (a === 124226) return;
    e.l += r - 4;
  }
  function Hd(e, r) {
    return e.read_shift(4);
  }
  function Wd(e, r) {
    var t = {};
    t.xclrType = e.read_shift(2);
    t.nTintShade = e.read_shift(2);
    switch (t.xclrType) {
      case 0:
        e.l += 4;
        break;
      case 1:
        t.xclrValue = Vd(e, 4);
        break;
      case 2:
        t.xclrValue = En(e, 4);
        break;
      case 3:
        t.xclrValue = Hd(e, 4);
        break;
      case 4:
        e.l += 4;
        break;
    }
    e.l += 8;
    return t;
  }
  function Vd(e, r) {
    return Cr(e, r);
  }
  function zd(e, r) {
    return Cr(e, r);
  }
  function Xd(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    var n = [t];
    switch (t) {
      case 4:
      case 5:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
      case 13:
        n[1] = Wd(e, a);
        break;
      case 6:
        n[1] = zd(e, a);
        break;
      case 14:
      case 15:
        n[1] = e.read_shift(a === 5 ? 1 : 2);
        break;
      default:
        throw new Error("Unrecognized ExtProp type: " + t + " " + a);
    }
    return n;
  }
  function Gd(e, r) {
    var t = e.l + r;
    e.l += 2;
    var a = e.read_shift(2);
    e.l += 2;
    var n = e.read_shift(2);
    var i = [];
    while (n-- > 0) i.push(Xd(e, t - e.l));
    return { ixfe: a, ext: i };
  }
  function jd(e, r) {
    r.forEach(function (e) {
      switch (e[0]) {
        case 4:
          break;
        case 5:
          break;
        case 6:
          break;
        case 7:
          break;
        case 8:
          break;
        case 9:
          break;
        case 10:
          break;
        case 11:
          break;
        case 13:
          break;
        case 14:
          break;
        case 15:
          break;
      }
    });
  }
  function Kd(e, r) {
    var t = [];
    if (!e) return t;
    var a = 0,
      n = 1;
    (e.match(ae) || []).forEach(function (e) {
      var r = se(e);
      switch (r[0]) {
        case "<?xml":
          break;
        case "<calcChain":
        case "<calcChain>":
        case "</calcChain>":
          break;
        case "<c":
          delete r[0];
          if (r.i) n = r.i;
          else r.i = n;
          t.push(r);
          break;
      }
    });
    return t;
  }
  function Yd(e, r) {}
  function $d(e, r) {
    var t = {};
    t.i = e.read_shift(4);
    var a = {};
    a.r = e.read_shift(4);
    a.c = e.read_shift(4);
    t.r = Vr(a);
    var n = e.read_shift(1);
    if (n & 2) t.l = "1";
    if (n & 8) t.a = "1";
    return t;
  }
  function Zd(e, r) {
    var t = [];
    var a = false;
    wr(e, function n(e, i, s) {
      switch (s) {
        case 63:
          t.push(e);
          break;
        default:
          if ((i || "").indexOf("Begin") > 0) {
          } else if ((i || "").indexOf("End") > 0) {
          } else if (!a || r.WTF)
            throw new Error("Unexpected record " + s + " " + i);
      }
    });
    return t;
  }
  function Qd(e, r) {}
  ia.IMG =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
  ia.DRAW =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";
  function Jd(e, r) {
    if (!e) return "??";
    var t = (e.match(/<c:chart [^>]*r:id="([^"]*)"/) || ["", ""])[1];
    return r["!id"][t].Target;
  }
  var qd = 1024;
  function ev(e, r) {
    var t = [21600, 21600];
    var a = ["m0,0l0", t[1], t[0], t[1], t[0], "0xe"].join(",");
    var n = [
      De("xml", null, {
        "xmlns:v": Le.v,
        "xmlns:o": Le.o,
        "xmlns:x": Le.x,
        "xmlns:mv": Le.mv,
      }).replace(/\/>/, ">"),
      De("o:shapelayout", De("o:idmap", null, { "v:ext": "edit", data: e }), {
        "v:ext": "edit",
      }),
      De(
        "v:shapetype",
        [
          De("v:stroke", null, { joinstyle: "miter" }),
          De("v:path", null, { gradientshapeok: "t", "o:connecttype": "rect" }),
        ].join(""),
        { id: "_x0000_t202", "o:spt": 202, coordsize: t.join(","), path: a }
      ),
    ];
    while (qd < e * 1e3) qd += 1e3;
    r.map(function (e) {
      return Wr(e[0]);
    }).forEach(function (e, r) {
      n = n.concat([
        "<v:shape" +
          Re({
            id: "_x0000_s" + ++qd,
            type: "#_x0000_t202",
            style:
              "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10;visibility:hidden",
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1",
          }) +
          ">",
        De(
          "v:fill",
          De("o:fill", null, { type: "gradientUnscaled", "v:ext": "view" }),
          { color2: "#BEFF82", angle: "-180", type: "gradient" }
        ),
        De("v:shadow", null, { on: "t", obscured: "t" }),
        De("v:path", null, { "o:connecttype": "none" }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        "<x:MoveWithCells/>",
        "<x:SizeWithCells/>",
        ye("x:Anchor", [e.c, 0, e.r, 0, e.c + 3, 100, e.r + 5, 100].join(",")),
        ye("x:AutoFill", "False"),
        ye("x:Row", String(e.r)),
        ye("x:Column", String(e.c)),
        "<x:Visible/>",
        "</x:ClientData>",
        "</v:shape>",
      ]);
    });
    n.push("</xml>");
    return n.join("");
  }
  ia.CMNT =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";
  function rv(e, r, t, a, n) {
    for (var i = 0; i != r.length; ++i) {
      var s = r[i];
      var f = Rm(Q(e, s.replace(/^\//, ""), true), s, n);
      if (!f || !f.length) continue;
      var o = x(t);
      for (var l = 0; l != o.length; ++l) {
        var c = o[l];
        var h = a[c];
        if (h) {
          var u = h[s];
          if (u) tv(c, t[c], f);
        }
      }
    }
  }
  function tv(e, r, t) {
    var a = Array.isArray(r);
    var n, i;
    t.forEach(function (e) {
      if (a) {
        i = Wr(e.ref);
        if (!r[i.r]) r[i.r] = [];
        n = r[i.r][i.c];
      } else n = r[e.ref];
      if (!n) {
        n = {};
        if (a) r[i.r][i.c] = n;
        else r[e.ref] = n;
        var t = Kr(r["!ref"] || "BDWGO1000001:A1");
        var s = Wr(e.ref);
        if (t.s.r > s.r) t.s.r = s.r;
        if (t.e.r < s.r) t.e.r = s.r;
        if (t.s.c > s.c) t.s.c = s.c;
        if (t.e.c < s.c) t.e.c = s.c;
        var f = jr(t);
        if (f !== r["!ref"]) r["!ref"] = f;
      }
      if (!n.c) n.c = [];
      var o = { a: e.author, t: e.t, r: e.r };
      if (e.h) o.h = e.h;
      n.c.push(o);
    });
  }
  function av(e, r) {
    if (e.match(/<(?:\w+:)?comments *\/>/)) return [];
    var t = [];
    var a = [];
    var n = e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
    if (n && n[1])
      n[1].split(/<\/\w*:?author>/).forEach(function (e) {
        if (e === "" || e.trim() === "") return;
        var r = e.match(/<(?:\w+:)?author[^>]*>(.*)/);
        if (r) t.push(r[1]);
      });
    var i = e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
    if (i && i[1])
      i[1].split(/<\/\w*:?comment>/).forEach(function (e, n) {
        if (e === "" || e.trim() === "") return;
        var i = e.match(/<(?:\w+:)?comment[^>]*>/);
        if (!i) return;
        var s = se(i[0]);
        var f = {
          author: s.authorId && t[s.authorId] ? t[s.authorId] : "sheetjsghost",
          ref: s.ref,
          guid: s.guid,
        };
        var o = Wr(s.ref);
        if (r.sheetRows && r.sheetRows <= o.r) return;
        var l = e.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
        var c = (!!l && !!l[1] && Vh(l[1])) || { r: "", t: "", h: "" };
        f.r = c.r;
        if (c.r == "<t></t>") c.t = c.h = "";
        f.t = c.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (r.cellHTML) f.h = c.h;
        a.push(f);
      });
    return a;
  }
  var nv = De("comments", null, { xmlns: Ne.main[0] });
  function iv(e, r) {
    var t = [Pe, nv];
    var a = [];
    t.push("<authors>");
    e.map(function (e) {
      return e[1];
    }).forEach(function (e) {
      e.map(function (e) {
        return de(e.a);
      }).forEach(function (e) {
        if (a.indexOf(e) > -1) return;
        a.push(e);
        t.push("<author>" + e + "</author>");
      });
    });
    t.push("</authors>");
    t.push("<commentList>");
    e.forEach(function (e) {
      e[1].forEach(function (r) {
        t.push(
          '<comment ref="' +
            e[0] +
            '" authorId="' +
            a.indexOf(de(r.a)) +
            '"><text>'
        );
        t.push(ye("t", r.t == null ? "" : r.t));
        t.push("</text></comment>");
      });
    });
    t.push("</commentList>");
    if (t.length > 2) {
      t[t.length] = "</comments>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  function sv(e, r) {
    var t = {};
    t.iauthor = e.read_shift(4);
    var a = kt(e, 16);
    t.rfx = a.s;
    t.ref = Vr(a.s);
    e.l += 16;
    return t;
  }
  function fv(e, r) {
    if (r == null) r = Sr(36);
    r.write_shift(4, e[1].iauthor);
    St(e[0], r);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    return r;
  }
  var ov = qr;
  function lv(e) {
    return et(e.substr(0, 54));
  }
  function cv(e, r) {
    var t = [];
    var a = [];
    var n = {};
    var i = false;
    wr(e, function s(e, f, o) {
      switch (o) {
        case 632:
          a.push(e);
          break;
        case 635:
          n = e;
          break;
        case 637:
          n.t = e.t;
          n.h = e.h;
          n.r = e.r;
          break;
        case 636:
          n.author = a[n.iauthor];
          delete n.iauthor;
          if (r.sheetRows && r.sheetRows <= n.rfx.r) break;
          if (!n.t) n.t = "";
          delete n.rfx;
          t.push(n);
          break;
        case 35:
          i = true;
          break;
        case 36:
          i = false;
          break;
        case 37:
          break;
        case 38:
          break;
        default:
          if ((f || "").indexOf("Begin") > 0) {
          } else if ((f || "").indexOf("End") > 0) {
          } else if (!i || r.WTF)
            throw new Error("Unexpected record " + o + " " + f);
      }
    });
    return t;
  }
  function hv(e, r) {
    var t = Ar();
    var a = [];
    Br(t, "BrtBeginComments");
    {
      Br(t, "BrtBeginCommentAuthors");
      e.forEach(function (e) {
        e[1].forEach(function (e) {
          if (a.indexOf(e.a) > -1) return;
          a.push(e.a.substr(0, 54));
          Br(t, "BrtCommentAuthor", lv(e.a));
        });
      });
      Br(t, "BrtEndCommentAuthors");
    }
    {
      Br(t, "BrtBeginCommentList");
      e.forEach(function (e) {
        e[1].forEach(function (r) {
          r.iauthor = a.indexOf(r.a);
          var n = { s: Wr(e[0]), e: Wr(e[0]) };
          Br(t, "BrtBeginComment", fv([n, r]));
          if (r.t && r.t.length > 0) Br(t, "BrtCommentText", st(r));
          Br(t, "BrtEndComment");
          delete r.iauthor;
        });
      });
      Br(t, "BrtEndCommentList");
    }
    Br(t, "BrtEndComments");
    return t.end();
  }
  ia.DS =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";
  ia.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";
  function uv(e, r, t, a, n, i) {
    return { "!type": "dialog" };
  }
  function dv(e, r, t, a, n, i) {
    return { "!type": "dialog" };
  }
  function vv(e, r, t, a, n, i) {
    return { "!type": "macro" };
  }
  function pv(e, r, t, a, n, i) {
    return { "!type": "macro" };
  }
  var gv = (function () {
    var e = /(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g;
    var r = { r: 0, c: 0 };
    function t(e, t, a, n, i, s) {
      var f = n.length > 0 ? parseInt(n, 10) | 0 : 0,
        o = s.length > 0 ? parseInt(s, 10) | 0 : 0;
      if (o < 0 && i.length === 0) o = 0;
      var l = false,
        c = false;
      if (i.length > 0 || s.length == 0) l = true;
      if (l) o += r.c;
      else --o;
      if (a.length > 0 || n.length == 0) c = true;
      if (c) f += r.r;
      else --f;
      return t + (l ? "" : "$") + Lr(o) + (c ? "" : "$") + Or(f);
    }
    return function a(n, i) {
      r = i;
      return n.replace(e, t);
    };
  })();
  var bv =
    /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.\(A-Za-z0-9])/g;
  var mv = (function () {
    return function e(r, t) {
      return r.replace(bv, function (e, r, a, n, i, s, f, o) {
        var l = Nr(n) - t.c;
        var c = Dr(s) - t.r;
        return (
          r +
          "R" +
          (c == 0 ? "" : "[" + c + "]") +
          "C" +
          (l == 0 ? "" : "[" + l + "]")
        );
      });
    };
  })();
  function Cv(e, r) {
    return e.replace(bv, function (e, t, a, n, i, s, f, o) {
      return (
        t +
        (a == "$" ? a + n : Lr(Nr(n) + r.c)) +
        (i == "$" ? i + s : Or(Dr(s) + r.r))
      );
    });
  }
  function Ev(e, r, t) {
    var a = Gr(r),
      n = a.s,
      i = Wr(t);
    var s = { r: i.r - n.r, c: i.c - n.c };
    return Cv(e, s);
  }
  function kv(e) {
    return function (r, t) {
      r.l += e;
      return;
    };
  }
  function Sv(e) {
    e.l += 1;
    return;
  }
  function wv(e, r) {
    var t = e.read_shift(r == 1 ? 1 : 2);
    return [t & 16383, (t >> 14) & 1, (t >> 15) & 1];
  }
  function Av(e, r, t) {
    var a = 2;
    if (t) {
      if (t.biff >= 2 && t.biff <= 5) return Bv(e, r, t);
      else if (t.biff == 12) a = 4;
    }
    var n = e.read_shift(a),
      i = e.read_shift(a);
    var s = wv(e, 2);
    var f = wv(e, 2);
    return {
      s: { r: n, c: s[0], cRel: s[1], rRel: s[2] },
      e: { r: i, c: f[0], cRel: f[1], rRel: f[2] },
    };
  }
  function Bv(e) {
    var r = wv(e, 2),
      t = wv(e, 2);
    var a = e.read_shift(1);
    var n = e.read_shift(1);
    return {
      s: { r: r[0], c: a, cRel: r[1], rRel: r[2] },
      e: { r: t[0], c: n, cRel: t[1], rRel: t[2] },
    };
  }
  function _v(e, r) {
    var t = e.read_shift(r == 12 ? 4 : 2),
      a = e.read_shift(r == 12 ? 4 : 2);
    var n = wv(e, 2);
    var i = wv(e, 2);
    return {
      s: { r: t, c: n[0], cRel: n[1], rRel: n[2] },
      e: { r: a, c: i[0], cRel: i[1], rRel: i[2] },
    };
  }
  function Tv(e, r, t) {
    if (t && t.biff >= 2 && t.biff <= 5) return xv(e, r, t);
    var a = e.read_shift(t && t.biff == 12 ? 4 : 2);
    var n = wv(e, 2);
    return { r: a, c: n[0], cRel: n[1], rRel: n[2] };
  }
  function xv(e, r, t) {
    var a = wv(e, 2);
    var n = e.read_shift(1);
    return { r: a[0], c: n, cRel: a[1], rRel: a[2] };
  }
  function Iv(e, r, t) {
    var a = t && t.biff ? t.biff : 8;
    if (a >= 2 && a <= 5) return yv(e, r, t);
    var n = e.read_shift(a >= 12 ? 4 : 2);
    var i = e.read_shift(2);
    var s = (i & 32768) >> 15,
      f = (i & 16384) >> 14;
    i &= 16383;
    if (f == 1) while (n > 524287) n -= 1048576;
    if (s == 1) while (i > 8191) i = i - 16384;
    return { r: n, c: i, cRel: s, rRel: f };
  }
  function yv(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(1);
    var n = (t & 32768) >> 15,
      i = (t & 16384) >> 14;
    t &= 16383;
    if (n == 1 && t >= 8192) t = t - 16384;
    if (i == 1 && a >= 128) a = a - 256;
    return { r: t, c: a, cRel: i, rRel: n };
  }
  function Rv(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    var n = Av(e, t.biff >= 2 && t.biff <= 5 ? 6 : 8, t);
    return [a, n];
  }
  function Dv(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    var n = e.read_shift(2, "i");
    var i = 8;
    if (t)
      switch (t.biff) {
        case 5:
          e.l += 12;
          i = 6;
          break;
        case 12:
          i = 12;
          break;
      }
    var s = Av(e, i, t);
    return [a, n, s];
  }
  function Ov(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    e.l += t && t.biff > 8 ? 12 : 8;
    return [a];
  }
  function Fv(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    var n = e.read_shift(2);
    var i = 8;
    if (t)
      switch (t.biff) {
        case 5:
          e.l += 12;
          i = 6;
          break;
        case 12:
          i = 12;
          break;
      }
    e.l += i;
    return [a, n];
  }
  function Pv(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    var n = _v(e, t && t.biff > 8 ? 12 : 8, t);
    return [a, n];
  }
  function Nv(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    e.l += t.biff == 2 ? 6 : t.biff == 12 ? 14 : 7;
    return [a];
  }
  function Lv(e, r) {
    var t = e[e.l + 1] & 1;
    var a = 1;
    e.l += 4;
    return [t, a];
  }
  function Mv(e, r, t) {
    e.l += 2;
    var a = e.read_shift(t && t.biff == 2 ? 1 : 2);
    var n = [];
    for (var i = 0; i <= a; ++i) n.push(e.read_shift(t && t.biff == 2 ? 1 : 2));
    return n;
  }
  function Uv(e, r, t) {
    var a = e[e.l + 1] & 255 ? 1 : 0;
    e.l += 2;
    return [a, e.read_shift(t && t.biff == 2 ? 1 : 2)];
  }
  function Hv(e, r, t) {
    var a = e[e.l + 1] & 255 ? 1 : 0;
    e.l += 2;
    return [a, e.read_shift(t && t.biff == 2 ? 1 : 2)];
  }
  function Wv(e, r) {
    var t = e[e.l + 1] & 255 ? 1 : 0;
    e.l += 2;
    return [t, e.read_shift(2)];
  }
  function Vv(e, r, t) {
    var a = e[e.l + 1] & 255 ? 1 : 0;
    e.l += t && t.biff == 2 ? 3 : 4;
    return [a];
  }
  function zv(e, r) {
    var t = e.read_shift(1),
      a = e.read_shift(1);
    return [t, a];
  }
  function Xv(e, r) {
    e.read_shift(2);
    return zv(e, 2);
  }
  function Gv(e, r) {
    e.read_shift(2);
    return zv(e, 2);
  }
  function jv(e, r, t) {
    var a = e[e.l] & 31;
    var n = (e[e.l] & 96) >> 5;
    e.l += 1;
    var i = Tv(e, 0, t);
    return [n, i];
  }
  function Kv(e, r, t) {
    var a = (e[e.l] & 96) >> 5;
    e.l += 1;
    var n = Iv(e, 0, t);
    return [a, n];
  }
  function Yv(e, r, t) {
    var a = (e[e.l] & 96) >> 5;
    e.l += 1;
    var n = e.read_shift(2);
    var i = Tv(e, 0, t);
    return [a, n, i];
  }
  function $v(e, r, t) {
    var a = e[e.l] & 31;
    var n = (e[e.l] & 96) >> 5;
    e.l += 1;
    var i = e.read_shift(t && t.biff <= 3 ? 1 : 2);
    return [og[i], fg[i], n];
  }
  function Zv(e, r, t) {
    e.l++;
    var a = e.read_shift(1),
      n = t && t.biff <= 3 ? [0, e.read_shift(1)] : Qv(e);
    return [a, (n[0] === 0 ? fg : sg)[n[1]]];
  }
  function Qv(e, r) {
    return [e[e.l + 1] >> 7, e.read_shift(2) & 32767];
  }
  function Jv(e, r, t) {
    e.l += t && t.biff == 2 ? 3 : 4;
    return;
  }
  var qv = Sv;
  function ep(e, r, t) {
    e.l++;
    if (t && t.biff == 12) return [e.read_shift(4, "i"), 0];
    var a = e.read_shift(2);
    var n = e.read_shift(t && t.biff == 2 ? 1 : 2);
    return [a, n];
  }
  function rp(e, r) {
    e.l++;
    return Bt[e.read_shift(1)];
  }
  function tp(e, r) {
    e.l++;
    return e.read_shift(2);
  }
  function ap(e, r) {
    e.l++;
    return e.read_shift(1) !== 0;
  }
  function np(e, r) {
    e.l++;
    return wt(e, 8);
  }
  function ip(e, r, t) {
    e.l++;
    return ln(e, r - 1, t);
  }
  function sp(e, r) {
    var t = [e.read_shift(1)];
    if (r == 12)
      switch (t[0]) {
        case 2:
          t[0] = 4;
          break;
        case 4:
          t[0] = 16;
          break;
        case 0:
          t[0] = 1;
          break;
        case 1:
          t[0] = 2;
          break;
      }
    switch (t[0]) {
      case 4:
        t[1] = an(e, 1) ? "TRUE" : "FALSE";
        e.l += 7;
        break;
      case 16:
        t[1] = Bt[e[e.l]];
        e.l += 8;
        break;
      case 0:
        e.l += 8;
        break;
      case 1:
        t[1] = wt(e, 8);
        break;
      case 2:
        t[1] = dn(e, 0, { biff: r > 0 && r < 8 ? 2 : r });
        break;
    }
    return t;
  }
  function fp(e, r) {
    var t = e.read_shift(2);
    var a = [];
    for (var n = 0; n != t; ++n) a.push(In(e, 8));
    return a;
  }
  function op(e, r, t) {
    var a = 0,
      n = 0;
    if (t.biff == 12) {
      a = e.read_shift(4);
      n = e.read_shift(4);
    } else {
      n = 1 + e.read_shift(1);
      a = 1 + e.read_shift(2);
    }
    if (t.biff >= 2 && t.biff < 8) {
      --a;
      if (--n == 0) n = 256;
    }
    for (var i = 0, s = []; i != a && (s[i] = []); ++i)
      for (var f = 0; f != n; ++f) s[i][f] = sp(e, t.biff);
    return s;
  }
  function lp(e, r, t) {
    var a = (e.read_shift(1) >>> 5) & 3;
    var n = !t || t.biff >= 8 ? 4 : 2;
    var i = e.read_shift(n);
    switch (t.biff) {
      case 2:
        e.l += 5;
        break;
      case 3:
      case 4:
        e.l += 8;
        break;
      case 5:
        e.l += 12;
        break;
    }
    return [a, 0, i];
  }
  function cp(e, r, t) {
    if (t.biff == 5) return hp(e, r, t);
    var a = (e.read_shift(1) >>> 5) & 3;
    var n = e.read_shift(2);
    var i = e.read_shift(4);
    return [a, n, i];
  }
  function hp(e, r, t) {
    var a = (e.read_shift(1) >>> 5) & 3;
    var n = e.read_shift(2, "i");
    e.l += 8;
    var i = e.read_shift(2);
    e.l += 12;
    return [a, n, i];
  }
  function up(e, r, t) {
    var a = (e.read_shift(1) >>> 5) & 3;
    e.l += t && t.biff == 2 ? 3 : 4;
    var n = e.read_shift(t && t.biff == 2 ? 1 : 2);
    return [a, n];
  }
  function dp(e, r, t) {
    var a = (e.read_shift(1) >>> 5) & 3;
    var n = e.read_shift(t && t.biff == 2 ? 1 : 2);
    return [a, n];
  }
  function vp(e, r, t) {
    var a = (e.read_shift(1) >>> 5) & 3;
    e.l += 4;
    if (t.biff == 12) e.l += 2;
    return [a];
  }
  function pp(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    var n = e.read_shift(2);
    var i = 4;
    if (t)
      switch (t.biff) {
        case 5:
          throw new Error("PtgRefErr3d -- 5");
        case 12:
          i = 6;
          break;
      }
    e.l += i;
    return [a, n];
  }
  var gp = Sv;
  var bp = Sv;
  var mp = Sv;
  var Cp = Sv;
  var Ep = Sv;
  var kp = Sv;
  var Sp = Sv;
  var wp = Sv;
  var Ap = Sv;
  var Bp = Sv;
  var _p = Sv;
  var Tp = Sv;
  var xp = Sv;
  var Ip = Sv;
  var yp = Sv;
  var Rp = Sv;
  var Dp = Sv;
  var Op = Sv;
  var Fp = Sv;
  var Pp = Cr;
  var Np = Cr;
  var Lp = Cr;
  var Mp = {
    1: { n: "PtgExp", f: ep },
    2: { n: "PtgTbl", f: Lp },
    3: { n: "PtgAdd", f: gp },
    4: { n: "PtgSub", f: Rp },
    5: { n: "PtgMul", f: Bp },
    6: { n: "PtgDiv", f: bp },
    7: { n: "PtgPower", f: Ip },
    8: { n: "PtgConcat", f: qv },
    9: { n: "PtgLt", f: wp },
    10: { n: "PtgLe", f: Sp },
    11: { n: "PtgEq", f: mp },
    12: { n: "PtgGe", f: Cp },
    13: { n: "PtgGt", f: Ep },
    14: { n: "PtgNe", f: _p },
    15: { n: "PtgIsect", f: kp },
    16: { n: "PtgUnion", f: Op },
    17: { n: "PtgRange", f: yp },
    18: { n: "PtgUplus", f: Fp },
    19: { n: "PtgUminus", f: Dp },
    20: { n: "PtgPercent", f: xp },
    21: { n: "PtgParen", f: Tp },
    22: { n: "PtgMissArg", f: Ap },
    23: { n: "PtgStr", f: ip },
    28: { n: "PtgErr", f: rp },
    29: { n: "PtgBool", f: ap },
    30: { n: "PtgInt", f: tp },
    31: { n: "PtgNum", f: np },
    32: { n: "PtgArray", f: Nv },
    33: { n: "PtgFunc", f: $v },
    34: { n: "PtgFuncVar", f: Zv },
    35: { n: "PtgName", f: lp },
    36: { n: "PtgRef", f: jv },
    37: { n: "PtgArea", f: Rv },
    38: { n: "PtgMemArea", f: up },
    39: { n: "PtgMemErr", f: Pp },
    40: { n: "PtgMemNoMem", f: Np },
    41: { n: "PtgMemFunc", f: dp },
    42: { n: "PtgRefErr", f: vp },
    43: { n: "PtgAreaErr", f: Ov },
    44: { n: "PtgRefN", f: Kv },
    45: { n: "PtgAreaN", f: Pv },
    57: { n: "PtgNameX", f: cp },
    58: { n: "PtgRef3d", f: Yv },
    59: { n: "PtgArea3d", f: Dv },
    60: { n: "PtgRefErr3d", f: pp },
    61: { n: "PtgAreaErr3d", f: Fv },
    255: {},
  };
  var Up = {
    64: 32,
    96: 32,
    65: 33,
    97: 33,
    66: 34,
    98: 34,
    67: 35,
    99: 35,
    68: 36,
    100: 36,
    69: 37,
    101: 37,
    70: 38,
    102: 38,
    71: 39,
    103: 39,
    72: 40,
    104: 40,
    73: 41,
    105: 41,
    74: 42,
    106: 42,
    75: 43,
    107: 43,
    76: 44,
    108: 44,
    77: 45,
    109: 45,
    89: 57,
    121: 57,
    90: 58,
    122: 58,
    91: 59,
    123: 59,
    92: 60,
    124: 60,
    93: 61,
    125: 61,
  };
  (function () {
    for (var e in Up) Mp[e] = Mp[Up[e]];
  })();
  var Hp = {};
  var Wp = {
    1: { n: "PtgAttrSemi", f: Vv },
    2: { n: "PtgAttrIf", f: Hv },
    4: { n: "PtgAttrChoose", f: Mv },
    8: { n: "PtgAttrGoto", f: Uv },
    16: { n: "PtgAttrSum", f: Jv },
    32: { n: "PtgAttrBaxcel", f: Lv },
    64: { n: "PtgAttrSpace", f: Xv },
    65: { n: "PtgAttrSpaceSemi", f: Gv },
    128: { n: "PtgAttrIfError", f: Wv },
    255: {},
  };
  function Vp(e, r, t) {
    var a = e.l + r;
    var n = Sn(e, 6);
    if (t.biff == 2) ++e.l;
    var i = zp(e, 8);
    var s = e.read_shift(1);
    if (t.biff != 2) {
      e.read_shift(1);
      if (t.biff >= 5) {
        var f = e.read_shift(4);
      }
    }
    var o = jp(e, a - e.l, t);
    return { cell: n, val: i[0], formula: o, shared: (s >> 3) & 1, tt: i[1] };
  }
  function zp(e) {
    var r;
    if (sr(e, e.l + 6) !== 65535) return [wt(e), "n"];
    switch (e[e.l]) {
      case 0:
        e.l += 8;
        return ["String", "s"];
      case 1:
        r = e[e.l + 2] === 1;
        e.l += 8;
        return [r, "b"];
      case 2:
        r = e[e.l + 2];
        e.l += 8;
        return [r, "e"];
      case 3:
        e.l += 8;
        return ["", "s"];
    }
    return [];
  }
  function Xp(e, r, t, a) {
    if (a.biff < 8) return Cr(e, r);
    var n = e.l + r;
    var i = [];
    for (var s = 0; s !== t.length; ++s) {
      switch (t[s][0]) {
        case "PtgArray":
          t[s][1] = op(e, 0, a);
          i.push(t[s][1]);
          break;
        case "PtgMemArea":
          t[s][2] = fp(e, t[s][1]);
          i.push(t[s][2]);
          break;
        case "PtgExp":
          if (a && a.biff == 12) {
            t[s][1][1] = e.read_shift(4);
            i.push(t[s][1]);
          }
          break;
        default:
          break;
      }
    }
    r = n - e.l;
    if (r !== 0) i.push(Cr(e, r));
    return i;
  }
  function Gp(e, r, t, a) {
    var n = e.l + r;
    var i = $p(e, a, t);
    var s;
    if (n !== e.l) s = Xp(e, n - e.l, i, t);
    return [i, s];
  }
  function jp(e, r, t) {
    var a = e.l + r,
      n = t.biff == 2 ? 1 : 2;
    var i,
      s = e.read_shift(n);
    if (s == 65535) return [[], Cr(e, r - 2)];
    var f = $p(e, s, t);
    if (r !== s + n) i = Xp(e, r - s - n, f, t);
    return [f, i];
  }
  function Kp(e, r, t) {
    var a = e.l + r;
    var n,
      i = e.read_shift(2);
    var s = $p(e, i, t);
    if (i == 65535) return [[], Cr(e, r - 2)];
    if (r !== i + 2) n = Xp(e, a - i - 2, s, t);
    return [s, n];
  }
  function Yp(e, r, t, a) {
    var n = e.l + r,
      i = t.biff == 2 ? 1 : 2;
    var s,
      f = e.read_shift(i);
    if (f == 65535) return [[], Cr(e, r - 2)];
    var o = $p(e, f, t);
    if (r !== f + i) s = Xp(e, r - f - i, o, t);
    return [o, s];
  }
  function $p(e, r, t) {
    var a = e.l + r;
    var n,
      i,
      s = [];
    while (a != e.l) {
      r = a - e.l;
      i = e[e.l];
      n = Mp[i];
      if (i === 24 || i === 25) {
        i = e[e.l + 1];
        n = (i === 24 ? Hp : Wp)[i];
      }
      if (!n || !n.f) {
        Cr(e, r);
      } else {
        s.push([n.n, n.f(e, r, t)]);
      }
    }
    return s;
  }
  function Zp(e) {
    var r = [];
    for (var t = 0; t < e.length; ++t) {
      var a = e[t],
        n = [];
      for (var i = 0; i < a.length; ++i) {
        var s = a[i];
        if (s)
          switch (s[0]) {
            case 2:
              n.push('"' + s[1].replace(/"/g, '""') + '"');
              break;
            default:
              n.push(s[1]);
          }
        else n.push("");
      }
      r.push(n.join(","));
    }
    return r.join(";");
  }
  var Qp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-",
  };
  function Jp(e, r, t) {
    return e.SheetNames[r];
  }
  function qp(e, r, t, a, n) {
    var i = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    var s = [],
      f,
      o,
      l,
      c,
      h = 0,
      u = 0,
      d,
      v = "";
    if (!e[0] || !e[0][0]) return "";
    var p = -1,
      g = "";
    for (var b = 0, m = e[0].length; b < m; ++b) {
      var C = e[0][b];
      switch (C[0]) {
        case "PtgUminus":
          s.push("-" + s.pop());
          break;
        case "PtgUplus":
          s.push("+" + s.pop());
          break;
        case "PtgPercent":
          s.push(s.pop() + "%");
          break;
        case "PtgAdd":
        case "PtgConcat":
        case "PtgDiv":
        case "PtgEq":
        case "PtgGe":
        case "PtgGt":
        case "PtgLe":
        case "PtgLt":
        case "PtgMul":
        case "PtgNe":
        case "PtgPower":
        case "PtgSub":
          f = s.pop();
          o = s.pop();
          if (p >= 0) {
            switch (e[0][p][1][0]) {
              case 0:
                g = X(" ", e[0][p][1][1]);
                break;
              case 1:
                g = X("\r", e[0][p][1][1]);
                break;
              default:
                g = "";
                if (n.WTF)
                  throw new Error(
                    "Unexpected PtgAttrSpaceType " + e[0][p][1][0]
                  );
            }
            o = o + g;
            p = -1;
          }
          s.push(o + Qp[C[0]] + f);
          break;
        case "PtgIsect":
          f = s.pop();
          o = s.pop();
          s.push(o + " " + f);
          break;
        case "PtgUnion":
          f = s.pop();
          o = s.pop();
          s.push(o + "," + f);
          break;
        case "PtgRange":
          f = s.pop();
          o = s.pop();
          s.push(o + ":" + f);
          break;
        case "PtgAttrChoose":
          break;
        case "PtgAttrGoto":
          break;
        case "PtgAttrIf":
          break;
        case "PtgAttrIfError":
          break;
        case "PtgRef":
          l = C[1][0];
          c = _r(C[1][1], i, n);
          s.push(xr(c));
          break;
        case "PtgRefN":
          l = C[1][0];
          c = t ? _r(C[1][1], t, n) : C[1][1];
          s.push(xr(c));
          break;
        case "PtgRef3d":
          l = C[1][0];
          h = C[1][1];
          c = _r(C[1][2], i, n);
          v = Jp(a, h, n);
          var E = v;
          s.push(v + "!" + xr(c));
          break;
        case "PtgFunc":
        case "PtgFuncVar":
          var k = C[1][0],
            S = C[1][1];
          if (!k) k = 0;
          var w = k == 0 ? [] : s.slice(-k);
          s.length -= k;
          if (S === "User") S = w.shift();
          s.push(S + "(" + w.join(",") + ")");
          break;
        case "PtgBool":
          s.push(C[1] ? "TRUE" : "FALSE");
          break;
        case "PtgInt":
          s.push(C[1]);
          break;
        case "PtgNum":
          s.push(String(C[1]));
          break;
        case "PtgStr":
          s.push('"' + C[1] + '"');
          break;
        case "PtgErr":
          s.push(C[1]);
          break;
        case "PtgAreaN":
          l = C[1][0];
          d = Tr(C[1][1], i, n);
          s.push(Ir(d, n));
          break;
        case "PtgArea":
          l = C[1][0];
          d = Tr(C[1][1], i, n);
          s.push(Ir(d, n));
          break;
        case "PtgArea3d":
          l = C[1][0];
          h = C[1][1];
          d = C[1][2];
          v = a && a[1] ? a[1][h + 1] : "**MISSING**";
          s.push(v + "!" + jr(d));
          break;
        case "PtgAttrSum":
          s.push("SUM(" + s.pop() + ")");
          break;
        case "PtgAttrSemi":
          break;
        case "PtgName":
          u = C[1][2];
          var A = (a.names || [])[u - 1] || (a[0] || [])[u];
          var B = A ? A.Name : "SH33TJSERR7" + String(u);
          if (B in lg) B = lg[B];
          s.push(B);
          break;
        case "PtgNameX":
          var _ = C[1][1];
          u = C[1][2];
          var T;
          if (n.biff <= 5) {
            if (_ < 0) _ = -_;
            if (a[_]) T = a[_][u];
          } else {
            var x = a.SheetNames[_];
            var I = "";
            if (((a[_] || [])[0] || [])[0] == 14849) {
            } else if (((a[_] || [])[0] || [])[0] == 1025) {
              if (a[_][u] && a[_][u].itab > 0) {
                I = a.SheetNames[a[_][u].itab - 1] + "!";
              }
            } else I = a.SheetNames[u - 1] + "!";
            if (a[_] && a[_][u]) I += a[_][u].Name;
            else if (a[0] && a[0][u]) I += a[0][u].Name;
            else I += "SH33TJSERRX";
            s.push(I);
            break;
          }
          if (!T) T = { Name: "SH33TJSERRY" };
          s.push(T.Name);
          break;
        case "PtgParen":
          var y = "(",
            R = ")";
          if (p >= 0) {
            g = "";
            switch (e[0][p][1][0]) {
              case 2:
                y = X(" ", e[0][p][1][1]) + y;
                break;
              case 3:
                y = X("\r", e[0][p][1][1]) + y;
                break;
              case 4:
                R = X(" ", e[0][p][1][1]) + R;
                break;
              case 5:
                R = X("\r", e[0][p][1][1]) + R;
                break;
              default:
                if (n.WTF)
                  throw new Error(
                    "Unexpected PtgAttrSpaceType " + e[0][p][1][0]
                  );
            }
            p = -1;
          }
          s.push(y + s.pop() + R);
          break;
        case "PtgRefErr":
          s.push("#REF!");
          break;
        case "PtgRefErr3d":
          s.push("#REF!");
          break;
        case "PtgExp":
          c = { c: C[1][1], r: C[1][0] };
          var D = { c: t.c, r: t.r };
          if (a.sharedf[Vr(c)]) {
            var O = a.sharedf[Vr(c)];
            s.push(qp(O, i, D, a, n));
          } else {
            var F = false;
            for (f = 0; f != a.arrayf.length; ++f) {
              o = a.arrayf[f];
              if (c.c < o[0].s.c || c.c > o[0].e.c) continue;
              if (c.r < o[0].s.r || c.r > o[0].e.r) continue;
              s.push(qp(o[1], i, D, a, n));
              F = true;
              break;
            }
            if (!F) s.push(C[1]);
          }
          break;
        case "PtgArray":
          s.push("{" + Zp(C[1]) + "}");
          break;
        case "PtgMemArea":
          break;
        case "PtgAttrSpace":
        case "PtgAttrSpaceSemi":
          p = b;
          break;
        case "PtgTbl":
          break;
        case "PtgMemErr":
          break;
        case "PtgMissArg":
          s.push("");
          break;
        case "PtgAreaErr":
          s.push("#REF!");
          break;
        case "PtgAreaErr3d":
          s.push("#REF!");
          break;
        case "PtgMemFunc":
          break;
        default:
          throw new Error("Unrecognized Formula Token: " + String(C));
      }
      var P = ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"];
      if (p >= 0 && P.indexOf(e[0][b][0]) == -1) {
        C = e[0][p];
        var N = true;
        switch (C[1][0]) {
          case 4:
            N = false;
          case 0:
            g = X(" ", C[1][1]);
            break;
          case 5:
            N = false;
          case 1:
            g = X("\r", C[1][1]);
            break;
          default:
            g = "";
            if (n.WTF)
              throw new Error("Unexpected PtgAttrSpaceType " + C[1][0]);
        }
        s.push((N ? g : "") + s.pop() + (N ? "" : g));
        p = -1;
      }
    }
    if (s.length > 1 && n.WTF) throw new Error("bad formula stack");
    return s[0];
  }
  function eg(e, r, t) {
    var a = e.l + r;
    var n = e.read_shift(4);
    var i = $p(e, n, t);
    var s = e.read_shift(4);
    var f = s > 0 ? Xp(e, s, i, t) : null;
    return [i, f];
  }
  var rg = eg;
  var tg = eg;
  var ag = eg;
  var ng = eg;
  var ig = { 1: "REFERENCE", 2: "VALUE", 3: "ARRAY" };
  var sg = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS",
  };
  var fg = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS",
  };
  var og = {
    2: 1,
    3: 1,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    90: 1,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0,
  };
  var lg = {
    "_xlfn.ACOT": "ACOT",
    "_xlfn.ACOTH": "ACOTH",
    "_xlfn.AGGREGATE": "AGGREGATE",
    "_xlfn.ARABIC": "ARABIC",
    "_xlfn.AVERAGEIF": "AVERAGEIF",
    "_xlfn.AVERAGEIFS": "AVERAGEIFS",
    "_xlfn.BASE": "BASE",
    "_xlfn.BETA.DIST": "BETA.DIST",
    "_xlfn.BETA.INV": "BETA.INV",
    "_xlfn.BINOM.DIST": "BINOM.DIST",
    "_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
    "_xlfn.BINOM.INV": "BINOM.INV",
    "_xlfn.BITAND": "BITAND",
    "_xlfn.BITLSHIFT": "BITLSHIFT",
    "_xlfn.BITOR": "BITOR",
    "_xlfn.BITRSHIFT": "BITRSHIFT",
    "_xlfn.BITXOR": "BITXOR",
    "_xlfn.CEILING.MATH": "CEILING.MATH",
    "_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
    "_xlfn.CHISQ.DIST": "CHISQ.DIST",
    "_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
    "_xlfn.CHISQ.INV": "CHISQ.INV",
    "_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
    "_xlfn.CHISQ.TEST": "CHISQ.TEST",
    "_xlfn.COMBINA": "COMBINA",
    "_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
    "_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
    "_xlfn.COT": "COT",
    "_xlfn.COTH": "COTH",
    "_xlfn.COUNTIFS": "COUNTIFS",
    "_xlfn.COVARIANCE.P": "COVARIANCE.P",
    "_xlfn.COVARIANCE.S": "COVARIANCE.S",
    "_xlfn.CSC": "CSC",
    "_xlfn.CSCH": "CSCH",
    "_xlfn.DAYS": "DAYS",
    "_xlfn.DECIMAL": "DECIMAL",
    "_xlfn.ECMA.CEILING": "ECMA.CEILING",
    "_xlfn.ERF.PRECISE": "ERF.PRECISE",
    "_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
    "_xlfn.EXPON.DIST": "EXPON.DIST",
    "_xlfn.F.DIST": "F.DIST",
    "_xlfn.F.DIST.RT": "F.DIST.RT",
    "_xlfn.F.INV": "F.INV",
    "_xlfn.F.INV.RT": "F.INV.RT",
    "_xlfn.F.TEST": "F.TEST",
    "_xlfn.FILTERXML": "FILTERXML",
    "_xlfn.FLOOR.MATH": "FLOOR.MATH",
    "_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
    "_xlfn.FORMULATEXT": "FORMULATEXT",
    "_xlfn.GAMMA": "GAMMA",
    "_xlfn.GAMMA.DIST": "GAMMA.DIST",
    "_xlfn.GAMMA.INV": "GAMMA.INV",
    "_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
    "_xlfn.GAUSS": "GAUSS",
    "_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
    "_xlfn.IFNA": "IFNA",
    "_xlfn.IFERROR": "IFERROR",
    "_xlfn.IMCOSH": "IMCOSH",
    "_xlfn.IMCOT": "IMCOT",
    "_xlfn.IMCSC": "IMCSC",
    "_xlfn.IMCSCH": "IMCSCH",
    "_xlfn.IMSEC": "IMSEC",
    "_xlfn.IMSECH": "IMSECH",
    "_xlfn.IMSINH": "IMSINH",
    "_xlfn.IMTAN": "IMTAN",
    "_xlfn.ISFORMULA": "ISFORMULA",
    "_xlfn.ISO.CEILING": "ISO.CEILING",
    "_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
    "_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
    "_xlfn.LOGNORM.INV": "LOGNORM.INV",
    "_xlfn.MODE.MULT": "MODE.MULT",
    "_xlfn.MODE.SNGL": "MODE.SNGL",
    "_xlfn.MUNIT": "MUNIT",
    "_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
    "_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
    "_xlfn.NIGBINOM": "NIGBINOM",
    "_xlfn.NORM.DIST": "NORM.DIST",
    "_xlfn.NORM.INV": "NORM.INV",
    "_xlfn.NORM.S.DIST": "NORM.S.DIST",
    "_xlfn.NORM.S.INV": "NORM.S.INV",
    "_xlfn.NUMBERVALUE": "NUMBERVALUE",
    "_xlfn.PDURATION": "PDURATION",
    "_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
    "_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
    "_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
    "_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
    "_xlfn.PERMUTATIONA": "PERMUTATIONA",
    "_xlfn.PHI": "PHI",
    "_xlfn.POISSON.DIST": "POISSON.DIST",
    "_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
    "_xlfn.QUARTILE.INC": "QUARTILE.INC",
    "_xlfn.QUERYSTRING": "QUERYSTRING",
    "_xlfn.RANK.AVG": "RANK.AVG",
    "_xlfn.RANK.EQ": "RANK.EQ",
    "_xlfn.RRI": "RRI",
    "_xlfn.SEC": "SEC",
    "_xlfn.SECH": "SECH",
    "_xlfn.SHEET": "SHEET",
    "_xlfn.SHEETS": "SHEETS",
    "_xlfn.SKEW.P": "SKEW.P",
    "_xlfn.STDEV.P": "STDEV.P",
    "_xlfn.STDEV.S": "STDEV.S",
    "_xlfn.SUMIFS": "SUMIFS",
    "_xlfn.T.DIST": "T.DIST",
    "_xlfn.T.DIST.2T": "T.DIST.2T",
    "_xlfn.T.DIST.RT": "T.DIST.RT",
    "_xlfn.T.INV": "T.INV",
    "_xlfn.T.INV.2T": "T.INV.2T",
    "_xlfn.T.TEST": "T.TEST",
    "_xlfn.UNICHAR": "UNICHAR",
    "_xlfn.UNICODE": "UNICODE",
    "_xlfn.VAR.P": "VAR.P",
    "_xlfn.VAR.S": "VAR.S",
    "_xlfn.WEBSERVICE": "WEBSERVICE",
    "_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
    "_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
    "_xlfn.XOR": "XOR",
    "_xlfn.Z.TEST": "Z.TEST",
  };
  function cg(e) {
    if (e.substr(0, 3) == "of:") e = e.substr(3);
    if (e.charCodeAt(0) == 61) {
      e = e.substr(1);
      if (e.charCodeAt(0) == 61) e = e.substr(1);
    }
    e = e.replace(/COM\.MICROSOFT\./g, "");
    e = e.replace(
      /\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g,
      function (e, r) {
        return r.replace(/\./g, "");
      }
    );
    e = e.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return e.replace(/[;~]/g, ",").replace(/\|/g, ";");
  }
  function hg(e) {
    var r = "of:=" + e.replace(bv, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    return r.replace(/;/g, "|").replace(/,/g, ";");
  }
  function ug(e) {
    var r = e.split(":");
    var t = r[0].split(".")[0];
    return [t, r[0].split(".")[1] + ":" + r[1].split(".")[1]];
  }
  var dg = {};
  var vg = {};
  ia.WS = [
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
    "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet",
  ];
  function pg(e, r) {
    for (var t = 0, a = e.length; t < a; ++t)
      if (e[t].t === r) {
        e.Count++;
        return t;
      }
    e[a] = { t: r };
    e.Count++;
    e.Unique++;
    return a;
  }
  function gg(e, r) {
    var t = { min: e + 1, max: e + 1 };
    var a = -1;
    if (r.MDW) Ru = r.MDW;
    if (r.width != null) t.customWidth = 1;
    else if (r.wpx != null) a = Ou(r.wpx);
    else if (r.wch != null) a = r.wch;
    if (a > -1) {
      t.width = Fu(a);
      t.customWidth = 1;
    } else if (r.width != null) t.width = r.width;
    if (r.hidden) t.hidden = true;
    return t;
  }
  function bg(e, r) {
    if (!e) return;
    var t = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
    if (r == "xlml") t = [1, 1, 1, 1, 0.5, 0.5];
    if (e.left == null) e.left = t[0];
    if (e.right == null) e.right = t[1];
    if (e.top == null) e.top = t[2];
    if (e.bottom == null) e.bottom = t[3];
    if (e.header == null) e.header = t[4];
    if (e.footer == null) e.footer = t[5];
  }
  function mg(e, r, t) {
    var a = t.revssf[r.z != null ? r.z : "General"];
    var n = 60,
      i = e.length;
    if (a == null && t.ssf) {
      for (; n < 392; ++n)
        if (t.ssf[n] == null) {
          C.load(r.z, n);
          t.ssf[n] = r.z;
          t.revssf[r.z] = a = n;
          break;
        }
    }
    for (n = 0; n != i; ++n) if (e[n].numFmtId === a) return n;
    e[i] = {
      numFmtId: a,
      fontId: 0,
      fillId: 0,
      borderId: 0,
      xfId: 0,
      applyNumberFormat: 1,
    };
    return i;
  }
  function Cg(e, r, t, a, n, i) {
    if (e.t === "z") return;
    if (e.t === "d" && typeof e.v === "string") e.v = H(e.v);
    try {
      if (a.cellNF) e.z = C._table[r];
    } catch (s) {
      if (a.WTF) throw s;
    }
    if (!a || a.cellText !== false)
      try {
        if (e.t === "e") e.w = e.w || Bt[e.v];
        else if (r === 0) {
          if (e.t === "n") {
            if ((e.v | 0) === e.v) e.w = C._general_int(e.v);
            else e.w = C._general_num(e.v);
          } else if (e.t === "d") {
            var f = P(e.v);
            if ((f | 0) === f) e.w = C._general_int(f);
            else e.w = C._general_num(f);
          } else if (e.v === undefined) return "";
          else e.w = C._general(e.v, vg);
        } else if (e.t === "d") e.w = C.format(r, P(e.v), vg);
        else e.w = C.format(r, e.v, vg);
      } catch (s) {
        if (a.WTF) throw s;
      }
    if (t)
      try {
        e.s = i.Fills[t];
        if (e.s.fgColor && e.s.fgColor.theme && !e.s.fgColor.rgb) {
          e.s.fgColor.rgb = Tu(
            n.themeElements.clrScheme[e.s.fgColor.theme].rgb,
            e.s.fgColor.tint || 0
          );
          if (a.WTF)
            e.s.fgColor.raw_rgb =
              n.themeElements.clrScheme[e.s.fgColor.theme].rgb;
        }
        if (e.s.bgColor && e.s.bgColor.theme) {
          e.s.bgColor.rgb = Tu(
            n.themeElements.clrScheme[e.s.bgColor.theme].rgb,
            e.s.bgColor.tint || 0
          );
          if (a.WTF)
            e.s.bgColor.raw_rgb =
              n.themeElements.clrScheme[e.s.bgColor.theme].rgb;
        }
      } catch (s) {
        if (a.WTF) throw s;
      }
  }
  function Eg(e, r) {
    var t = Kr(r);
    if (t.s.r <= t.e.r && t.s.c <= t.e.c && t.s.r >= 0 && t.s.c >= 0)
      e["!ref"] = jr(t);
  }
  var kg = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
  var Sg = /<(?:\w+:)?sheetData>([\s\S]*)<\/(?:\w+:)?sheetData>/;
  var wg = /<(?:\w:)?hyperlink [^>]*>/gm;
  var Ag = /"(\w*:\w*)"/;
  var Bg = /<(?:\w:)?col[^>]*[\/]?>/g;
  var _g = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
  var Tg = /<(?:\w:)?pageMargins[^>]*\/>/g;
  function xg(e, r, t, a, n, i) {
    if (!e) return e;
    if (c != null && r.dense == null) r.dense = c;
    var s = r.dense ? [] : {};
    var f = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
    var o = "",
      l = "";
    var h = e.match(Sg);
    if (h) {
      o = e.substr(0, h.index);
      l = e.substr(h.index + h[0].length);
    } else o = l = e;
    var u = (o.match(/<(?:\w*:)?dimension/) || { index: -1 }).index;
    if (u > 0) {
      var d = o.substr(u, 50).match(Ag);
      if (d) Eg(s, d[1]);
    }
    var v = [];
    if (r.cellStyles) {
      var p = o.match(Bg);
      if (p) Fg(v, p);
    }
    if (h) Hg(h[1], s, r, f, n, i);
    var g = l.match(_g);
    if (g) s["!autofilter"] = Ng(g[0]);
    var b = [];
    var m = l.match(kg);
    if (m)
      for (u = 0; u != m.length; ++u)
        b[u] = Kr(m[u].substr(m[u].indexOf('"') + 1));
    var C = l.match(wg);
    if (C) Rg(s, C, t);
    var E = l.match(Tg);
    if (E) s["!margins"] = Dg(se(E[0]));
    if (!s["!ref"] && f.e.c >= f.s.c && f.e.r >= f.s.r) s["!ref"] = jr(f);
    if (r.sheetRows > 0 && s["!ref"]) {
      var k = Kr(s["!ref"]);
      if (r.sheetRows < +k.e.r) {
        k.e.r = r.sheetRows - 1;
        if (k.e.r > f.e.r) k.e.r = f.e.r;
        if (k.e.r < k.s.r) k.s.r = k.e.r;
        if (k.e.c > f.e.c) k.e.c = f.e.c;
        if (k.e.c < k.s.c) k.s.c = k.e.c;
        s["!fullref"] = s["!ref"];
        s["!ref"] = jr(k);
      }
    }
    if (v.length > 0) s["!cols"] = v;
    if (b.length > 0) s["!merges"] = b;
    return s;
  }
  function Ig(e) {
    if (e.length == 0) return "";
    var r = '<mergeCells count="' + e.length + '">';
    for (var t = 0; t != e.length; ++t)
      r += '<mergeCell ref="' + jr(e[t]) + '"/>';
    return r + "</mergeCells>";
  }
  function yg(e) {
    var r = { sheet: 1 };
    var t = [
      "objects",
      "scenarios",
      "selectLockedCells",
      "selectUnlockedCells",
    ];
    var a = [
      "formatColumns",
      "formatRows",
      "formatCells",
      "insertColumns",
      "insertRows",
      "insertHyperlinks",
      "deleteColumns",
      "deleteRows",
      "sort",
      "autoFilter",
      "pivotTables",
    ];
    t.forEach(function (t) {
      if (e[t] != null && e[t]) r[t] = "1";
    });
    a.forEach(function (t) {
      if (e[t] != null && !e[t]) r[t] = "0";
    });
    if (e.password) r.password = gu(e.password).toString(16).toUpperCase();
    return De("sheetProtection", null, r);
  }
  function Rg(e, r, t) {
    var a = Array.isArray(e);
    for (var n = 0; n != r.length; ++n) {
      var i = se(Ee(r[n]), true);
      if (!i.ref) return;
      var s = t ? t["!id"][i.id] : null;
      if (s) {
        i.Target = s.Target;
        if (i.location) i.Target += "#" + i.location;
        i.Rel = s;
      } else {
        i.Target = i.location;
        s = { Target: i.location, TargetMode: "Internal" };
        i.Rel = s;
      }
      if (i.tooltip) {
        i.Tooltip = i.tooltip;
        delete i.tooltip;
      }
      var f = Kr(i.ref);
      for (var o = f.s.r; o <= f.e.r; ++o)
        for (var l = f.s.c; l <= f.e.c; ++l) {
          var c = Vr({ c: l, r: o });
          if (a) {
            if (!e[o]) e[o] = [];
            if (!e[o][l]) e[o][l] = { t: "z", v: undefined };
            e[o][l].l = i;
          } else {
            if (!e[c]) e[c] = { t: "z", v: undefined };
            e[c].l = i;
          }
        }
    }
  }
  function Dg(e) {
    var r = {};
    ["left", "right", "top", "bottom", "header", "footer"].forEach(function (
      t
    ) {
      if (e[t]) r[t] = parseFloat(e[t]);
    });
    return r;
  }
  function Og(e) {
    bg(e);
    return De("pageMargins", null, e);
  }
  function Fg(e, r) {
    var t = false;
    for (var a = 0; a != r.length; ++a) {
      var n = se(r[a], true);
      if (n.hidden) n.hidden = Ce(n.hidden);
      var i = parseInt(n.min, 10) - 1,
        s = parseInt(n.max, 10) - 1;
      delete n.min;
      delete n.max;
      n.width = +n.width;
      if (!t && n.width) {
        t = true;
        Mu(n.width);
      }
      Hu(n);
      while (i <= s) e[i++] = z(n);
    }
  }
  function Pg(e, r) {
    var t = ["<cols>"],
      a,
      n;
    for (var i = 0; i != r.length; ++i) {
      if (!(a = r[i])) continue;
      t[t.length] = De("col", null, gg(i, a));
    }
    t[t.length] = "</cols>";
    return t.join("");
  }
  function Ng(e) {
    var r = { ref: (e.match(/ref="([^"]*)"/) || [])[1] };
    return r;
  }
  function Lg(e) {
    return De("autoFilter", null, { ref: e.ref });
  }
  function Mg(e, r, t, a) {
    return De("sheetViews", De("sheetView", null, { workbookViewId: "0" }), {});
  }
  function Ug(e, r, t, a, n, i) {
    if ((e.v === undefined && e.f === undefined) || e.t === "z") return "";
    var s = "";
    var f = e.t,
      o = e.v;
    switch (e.t) {
      case "b":
        s = e.v ? "1" : "0";
        break;
      case "n":
        s = "" + e.v;
        break;
      case "e":
        s = Bt[e.v];
        break;
      case "d":
        if (a.cellDates) s = H(e.v, -1).toISOString();
        else {
          e.t = "n";
          s = "" + (e.v = P(H(e.v)));
        }
        if (typeof e.z === "undefined") e.z = C._table[14];
        break;
      default:
        s = e.v;
        break;
    }
    var l = ye("v", de(s)),
      c = { r: r };
    var h = mg(a.cellXfs, e, a);
    if (h !== 0) c.s = h;
    switch (e.t) {
      case "n":
        break;
      case "d":
        c.t = "d";
        break;
      case "b":
        c.t = "b";
        break;
      case "e":
        c.t = "e";
        break;
      default:
        if (e.v == null) {
          delete e.t;
          break;
        }
        if (a.bookSST) {
          l = ye("v", "" + pg(a.Strings, e.v));
          c.t = "s";
          break;
        }
        c.t = "str";
        break;
    }
    if (e.t != f) {
      e.t = f;
      e.v = o;
    }
    if (e.f) {
      var u =
        e.F && e.F.substr(0, r.length) == r ? { t: "array", ref: e.F } : null;
      l = De("f", de(e.f), u) + (e.v != null ? l : "");
    }
    if (e.l) t["!links"].push([r, e.l]);
    if (e.c) t["!comments"].push([r, e.c]);
    return De("c", l, c);
  }
  var Hg = (function JE() {
    var e = /<(?:\w+:)?c[ >]/,
      r = /<\/(?:\w+:)?row>/;
    var t = /r=["']([^"']*)["']/,
      a = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
    var n = /ref=["']([^"']*)["']/;
    var i = Ae("v"),
      s = Ae("f");
    return function f(o, l, c, h, u, d) {
      var v = 0,
        p = "",
        g = [],
        b = [],
        m = 0,
        E = 0,
        k = 0,
        S = "",
        w;
      var A,
        B = 0,
        _ = 0;
      var T, x;
      var I = 0,
        y = 0;
      var R = Array.isArray(d.CellXf),
        D;
      var O = [];
      var F = [];
      var L = Array.isArray(l);
      var M = [],
        U = {},
        W = false;
      for (var V = o.split(r), z = 0, X = V.length; z != X; ++z) {
        p = V[z].trim();
        var G = p.length;
        if (G === 0) continue;
        for (v = 0; v < G; ++v) if (p.charCodeAt(v) === 62) break;
        ++v;
        A = se(p.substr(0, v), true);
        B = A.r != null ? parseInt(A.r, 10) : B + 1;
        _ = -1;
        if (c.sheetRows && c.sheetRows < B) continue;
        if (h.s.r > B - 1) h.s.r = B - 1;
        if (h.e.r < B - 1) h.e.r = B - 1;
        if (c && c.cellStyles) {
          U = {};
          W = false;
          if (A.ht) {
            W = true;
            U.hpt = parseFloat(A.ht);
            U.hpx = Xu(U.hpt);
          }
          if (A.hidden == "1") {
            W = true;
            U.hidden = true;
          }
          if (A.outlineLevel != null) {
            W = true;
            U.level = +A.outlineLevel;
          }
          if (W) M[B - 1] = U;
        }
        g = p.substr(v).split(e);
        for (v = 0; v != g.length; ++v) {
          p = g[v].trim();
          if (p.length === 0) continue;
          b = p.match(t);
          m = v;
          E = 0;
          k = 0;
          p = "<c " + (p.substr(0, 1) == "<" ? ">" : "") + p;
          if (b != null && b.length === 2) {
            m = 0;
            S = b[1];
            for (E = 0; E != S.length; ++E) {
              if ((k = S.charCodeAt(E) - 64) < 1 || k > 26) break;
              m = 26 * m + k;
            }
            --m;
            _ = m;
          } else ++_;
          for (E = 0; E != p.length; ++E) if (p.charCodeAt(E) === 62) break;
          ++E;
          A = se(p.substr(0, E), true);
          if (!A.r) A.r = Vr({ r: B - 1, c: _ });
          S = p.substr(E);
          w = { t: "" };
          if ((b = S.match(i)) != null && b[1] !== "") w.v = ce(b[1]);
          if (c.cellFormula) {
            if ((b = S.match(s)) != null && b[1] !== "") {
              w.f = ce(Ee(b[1])).replace(/_xlfn\./, "");
              if (b[0].indexOf('t="array"') > -1) {
                w.F = (S.match(n) || [])[1];
                if (w.F.indexOf(":") > -1) O.push([Kr(w.F), w.F]);
              } else if (b[0].indexOf('t="shared"') > -1) {
                x = se(b[0]);
                F[parseInt(x.si, 10)] = [x, ce(Ee(b[1]))];
              }
            } else if ((b = S.match(/<f[^>]*\/>/))) {
              x = se(b[0]);
              if (F[x.si]) w.f = Ev(F[x.si][1], F[x.si][0].ref, A.r);
            }
            var j = Wr(A.r);
            for (E = 0; E < O.length; ++E)
              if (j.r >= O[E][0].s.r && j.r <= O[E][0].e.r)
                if (j.c >= O[E][0].s.c && j.c <= O[E][0].e.c) w.F = O[E][1];
          }
          if (A.t == null && w.v === undefined) {
            if (w.f || w.F) {
              w.v = 0;
              w.t = "n";
            } else if (!c.sheetStubs) continue;
            else w.t = "z";
          } else w.t = A.t || "n";
          if (h.s.c > m) h.s.c = m;
          if (h.e.c < m) h.e.c = m;
          switch (w.t) {
            case "n":
              w.v = parseFloat(w.v);
              break;
            case "s":
              if (typeof w.v == "undefined") {
                if (!c.sheetStubs) continue;
                w.t = "z";
              } else {
                T = dg[parseInt(w.v, 10)];
                w.v = T.t;
                w.r = T.r;
                if (c.cellHTML) w.h = T.h;
              }
              break;
            case "str":
              w.t = "s";
              w.v = w.v != null ? Ee(w.v) : "";
              if (c.cellHTML) w.h = ge(w.v);
              break;
            case "inlineStr":
              b = S.match(a);
              w.t = "s";
              if (b != null && (T = Vh(b[1]))) w.v = T.t;
              else w.v = "";
              break;
            case "b":
              w.v = Ce(w.v);
              break;
            case "d":
              if (c.cellDates) w.v = H(w.v, 1);
              else {
                w.v = P(H(w.v, 1));
                w.t = "n";
              }
              break;
            case "e":
              if (!c || c.cellText !== false) w.w = w.v;
              w.v = _t[w.v];
              break;
          }
          I = y = 0;
          if (R && A.s !== undefined) {
            D = d.CellXf[A.s];
            if (D != null) {
              if (D.numFmtId != null) I = D.numFmtId;
              if (c.cellStyles) {
                if (D.fillId != null) y = D.fillId;
              }
            }
          }
          Cg(w, I, y, c, u, d);
          if (c.cellDates && R && w.t == "n" && C.is_date(C._table[I])) {
            w.t = "d";
            w.v = N(w.v);
          }
          if (L) {
            var K = Wr(A.r);
            if (!l[K.r]) l[K.r] = [];
            l[K.r][K.c] = w;
          } else l[A.r] = w;
        }
      }
      if (M.length > 0) l["!rows"] = M;
    };
  })();
  function Wg(e, r, t, a, n) {
    var i = [],
      s = [],
      f = Kr(e["!ref"]),
      o,
      l,
      c = "",
      h = [],
      u = 0,
      d = 0,
      v = e["!rows"];
    var p = Array.isArray(e);
    for (d = f.s.c; d <= f.e.c; ++d) h[d] = Lr(d);
    for (u = f.s.r; u <= f.e.r; ++u) {
      s = [];
      c = Or(u);
      for (d = f.s.c; d <= f.e.c; ++d) {
        l = h[d] + c;
        var g = p ? (e[u] || [])[d] : e[l];
        if (g === undefined) continue;
        if ((o = Ug(g, l, e, r, t, a)) != null) s.push(o);
      }
      if (s.length > 0 || (v && v[u])) {
        var b = { r: c };
        if (v && v[u]) {
          var m = v[u];
          if (m.hidden) b.hidden = 1;
          var C = -1;
          if (m.hpx) C = zu(m.hpx);
          else if (m.hpt) C = m.hpt;
          if (C > -1) {
            b.ht = C;
            b.customHeight = 1;
          }
          if (m.level) {
            b.outlineLevel = m.level;
          }
        }
        i[i.length] = De("row", s.join(""), b);
      }
    }
    if (v)
      for (; u < v.length; ++u) {
        if (v && v[u]) {
          b = { r: u + 1 };
          m = v[u];
          if (m.hidden) b.hidden = 1;
          C = -1;
          if (m.hpx) C = zu(m.hpx);
          else if (m.hpt) C = m.hpt;
          if (C > -1) {
            b.ht = C;
            b.customHeight = 1;
          }
          if (m.level) {
            b.outlineLevel = m.level;
          }
          i[i.length] = De("row", "", b);
        }
      }
    return i.join("");
  }
  var Vg = De("worksheet", null, { xmlns: Ne.main[0], "xmlns:r": Ne.r });
  function zg(e, r, t, a) {
    var n = [Pe, Vg];
    var i = t.SheetNames[e],
      s = 0,
      f = "";
    var o = t.Sheets[i];
    if (o == null) o = {};
    var l = o["!ref"];
    if (l == null) l = "A1";
    if (!a) a = {};
    o["!comments"] = [];
    o["!drawing"] = [];
    n[n.length] = De("sheetPr", null, { codeName: de(t.SheetNames[e]) });
    n[n.length] = De("dimension", null, { ref: l });
    n[n.length] = Mg(o, r, e, t);
    if (r.sheetFormat)
      n[n.length] = De("sheetFormatPr", null, {
        defaultRowHeight: r.sheetFormat.defaultRowHeight || "16",
        baseColWidth: r.sheetFormat.baseColWidth || "10",
        outlineLevelRow: r.sheetFormat.outlineLevelRow || "7",
      });
    if (o["!cols"] != null && o["!cols"].length > 0)
      n[n.length] = Pg(o, o["!cols"]);
    n[(s = n.length)] = "<sheetData/>";
    o["!links"] = [];
    if (o["!ref"] != null) {
      f = Wg(o, r, e, t, a);
      if (f.length > 0) n[n.length] = f;
    }
    if (n.length > s + 1) {
      n[n.length] = "</sheetData>";
      n[s] = n[s].replace("/>", ">");
    }
    if (o["!protect"] != null) n[n.length] = yg(o["!protect"]);
    if (o["!autofilter"] != null) n[n.length] = Lg(o["!autofilter"]);
    if (o["!merges"] != null && o["!merges"].length > 0)
      n[n.length] = Ig(o["!merges"]);
    var c = -1,
      h,
      u = -1;
    if (o["!links"].length > 0) {
      n[n.length] = "<hyperlinks>";
      o["!links"].forEach(function (e) {
        if (!e[1].Target) return;
        u = ca(a, -1, de(e[1].Target).replace(/#.*$/, ""), ia.HLINK);
        h = { ref: e[0], "r:id": "rId" + u };
        if ((c = e[1].Target.indexOf("#")) > -1)
          h.location = de(e[1].Target.substr(c + 1));
        if (e[1].Tooltip) h.tooltip = de(e[1].Tooltip);
        n[n.length] = De("hyperlink", null, h);
      });
      n[n.length] = "</hyperlinks>";
    }
    delete o["!links"];
    if (o["!margins"] != null) n[n.length] = Og(o["!margins"]);
    var d = n.length;
    n[n.length] = "";
    if (o["!drawing"].length > 0) {
      u = ca(a, -1, "../drawings/drawing" + (e + 1) + ".xml", ia.DRAW);
      n[n.length] = De("drawing", null, { "r:id": "rId" + u });
    } else delete o["!drawing"];
    if (o["!comments"].length > 0) {
      u = ca(a, -1, "../drawings/vmlDrawing" + (e + 1) + ".vml", ia.VML);
      n[n.length] = De("legacyDrawing", null, { "r:id": "rId" + u });
      o["!legacy"] = u;
    }
    if (n.length > 2) {
      n[n.length] = "</worksheet>";
      n[1] = n[1].replace("/>", ">");
    }
    return n.join("");
  }
  function Xg(e, r) {
    var t = {};
    var a = e.l + r;
    t.r = e.read_shift(4);
    e.l += 4;
    var n = e.read_shift(2);
    e.l += 1;
    var i = e.read_shift(1);
    e.l = a;
    if (i & 7) t.level = i & 7;
    if (i & 16) t.hidden = true;
    if (i & 32) t.hpt = n / 20;
    return t;
  }
  function Gg(e, r, t) {
    var a = Sr(17 + 8 * 16);
    var n = (t["!rows"] || [])[e] || {};
    a.write_shift(4, e);
    a.write_shift(4, 0);
    var i = 320;
    if (n.hpx) i = zu(n.hpx) * 20;
    else if (n.hpt) i = n.hpt * 20;
    a.write_shift(2, i);
    a.write_shift(1, 0);
    var s = 0;
    if (n.level) s |= n.level;
    if (n.hidden) s |= 16;
    if (n.hpx || n.hpt) s |= 32;
    a.write_shift(1, s);
    a.write_shift(1, 0);
    var f = 0,
      o = a.l;
    a.l += 4;
    var l = { r: e, c: 0 };
    for (var c = 0; c < 16; ++c) {
      if (r.s.c > (c + 1) << 10 || r.e.c < c << 10) continue;
      var h = -1,
        u = -1;
      for (var d = c << 10; d < (c + 1) << 10; ++d) {
        l.c = d;
        var v = Array.isArray(t) ? (t[l.r] || [])[l.c] : t[Vr(l)];
        if (v) {
          if (h < 0) h = d;
          u = d;
        }
      }
      if (h < 0) continue;
      ++f;
      a.write_shift(4, h);
      a.write_shift(4, u);
    }
    var p = a.l;
    a.l = o;
    a.write_shift(4, f);
    a.l = p;
    return a.length > a.l ? a.slice(0, a.l) : a;
  }
  function jg(e, r, t, a) {
    var n = Gg(a, t, r);
    if (n.length > 17 || (r["!rows"] || [])[a]) Br(e, "BrtRowHdr", n);
  }
  var Kg = kt;
  var Yg = St;
  function $g(e, r) {}
  function Zg(e, r) {
    var t = {};
    e.l += 19;
    t.name = lt(e, r - 19);
    return t;
  }
  function Qg(e, r) {
    if (r == null) r = Sr(84 + 4 * e.length);
    for (var t = 0; t < 3; ++t) r.write_shift(1, 0);
    xt({ auto: 1 }, r);
    r.write_shift(-4, -1);
    r.write_shift(-4, -1);
    ct(e, r);
    return r.slice(0, r.l);
  }
  function Jg(e, r) {
    var t = ft(e);
    return [t];
  }
  function qg(e, r, t) {
    if (t == null) t = Sr(8);
    return ot(r, t);
  }
  function eb(e, r) {
    var t = ft(e);
    var a = e.read_shift(1);
    return [t, a, "b"];
  }
  function rb(e, r, t) {
    if (t == null) t = Sr(9);
    ot(r, t);
    t.write_shift(1, e.v ? 1 : 0);
    return t;
  }
  function tb(e, r) {
    var t = ft(e);
    var a = e.read_shift(1);
    return [t, a, "e"];
  }
  function ab(e, r) {
    var t = ft(e);
    var a = e.read_shift(4);
    return [t, a, "s"];
  }
  function nb(e, r, t) {
    if (t == null) t = Sr(12);
    ot(r, t);
    t.write_shift(4, r.v);
    return t;
  }
  function ib(e, r) {
    var t = ft(e);
    var a = wt(e);
    return [t, a, "n"];
  }
  function sb(e, r, t) {
    if (t == null) t = Sr(16);
    ot(r, t);
    At(e.v, t);
    return t;
  }
  function fb(e, r) {
    var t = ft(e);
    var a = bt(e);
    return [t, a, "n"];
  }
  function ob(e, r, t) {
    if (t == null) t = Sr(12);
    ot(r, t);
    mt(e.v, t);
    return t;
  }
  function lb(e, r) {
    var t = ft(e);
    var a = qr(e);
    return [t, a, "str"];
  }
  function cb(e, r, t) {
    if (t == null) t = Sr(12 + 4 * e.v.length);
    ot(r, t);
    et(e.v, t);
    return t.length > t.l ? t.slice(0, t.l) : t;
  }
  function hb(e, r, t) {
    var a = e.l + r;
    var n = ft(e);
    n.r = t["!row"];
    var i = e.read_shift(1);
    var s = [n, i, "b"];
    if (t.cellFormula) {
      e.l += 2;
      var f = tg(e, a - e.l, t);
      s[3] = qp(f, null, n, t.supbooks, t);
    } else e.l = a;
    return s;
  }
  function ub(e, r, t) {
    var a = e.l + r;
    var n = ft(e);
    n.r = t["!row"];
    var i = e.read_shift(1);
    var s = [n, i, "e"];
    if (t.cellFormula) {
      e.l += 2;
      var f = tg(e, a - e.l, t);
      s[3] = qp(f, null, n, t.supbooks, t);
    } else e.l = a;
    return s;
  }
  function db(e, r, t) {
    var a = e.l + r;
    var n = ft(e);
    n.r = t["!row"];
    var i = wt(e);
    var s = [n, i, "n"];
    if (t.cellFormula) {
      e.l += 2;
      var f = tg(e, a - e.l, t);
      s[3] = qp(f, null, n, t.supbooks, t);
    } else e.l = a;
    return s;
  }
  function vb(e, r, t) {
    var a = e.l + r;
    var n = ft(e);
    n.r = t["!row"];
    var i = qr(e);
    var s = [n, i, "str"];
    if (t.cellFormula) {
      e.l += 2;
      var f = tg(e, a - e.l, t);
      s[3] = qp(f, null, n, t.supbooks, t);
    } else e.l = a;
    return s;
  }
  var pb = kt;
  var gb = St;
  function bb(e, r) {
    if (r == null) r = Sr(4);
    r.write_shift(4, e);
    return r;
  }
  function mb(e, r, t) {
    var a = e.l + r;
    var n = kt(e, 16);
    var i = ht(e);
    var s = qr(e);
    var f = qr(e);
    var o = qr(e);
    e.l = a;
    return { rfx: n, relId: i, loc: s, Tooltip: f, display: o };
  }
  function Cb(e, r, t) {
    if (t == null) t = Sr(50 + 4 * e[1].Target.length);
    St({ s: Wr(e[0]), e: Wr(e[0]) }, t);
    gt("rId" + r, t);
    var a = e[1].Target.indexOf("#");
    var n = a == -1 ? "" : e[1].Target.substr(a + 1);
    et(n || "", t);
    et(e[1].Tooltip || "", t);
    et("", t);
    return t.slice(0, t.l);
  }
  function Eb(e, r, t) {
    var a = e.l + r;
    var n = Ct(e, 16);
    var i = e.read_shift(1);
    var s = [n];
    s[2] = i;
    if (t.cellFormula) {
      var f = rg(e, a - e.l, t);
      s[1] = f;
    } else e.l = a;
    return s;
  }
  function kb(e, r, t) {
    var a = e.l + r;
    var n = kt(e, 16);
    var i = [n];
    if (t.cellFormula) {
      var s = ng(e, a - e.l, t);
      i[1] = s;
      e.l = a;
    } else e.l = a;
    return i;
  }
  function Sb(e, r, t) {
    if (t == null) t = Sr(18);
    var a = gg(e, r);
    t.write_shift(-4, e);
    t.write_shift(-4, e);
    t.write_shift(4, (a.width || 10) * 256);
    t.write_shift(4, 0);
    var n = 0;
    if (r.hidden) n |= 1;
    if (typeof a.width == "number") n |= 2;
    t.write_shift(1, n);
    t.write_shift(1, 0);
    return t;
  }
  function wb(e, r, t) {
    return {
      left: wt(e, 8),
      right: wt(e, 8),
      top: wt(e, 8),
      bottom: wt(e, 8),
      header: wt(e, 8),
      footer: wt(e, 8),
    };
  }
  function Ab(e, r) {
    if (r == null) r = Sr(6 * 8);
    bg(e);
    At(e.left, r);
    At(e.right, r);
    At(e.top, r);
    At(e.bottom, r);
    At(e.header, r);
    At(e.footer, r);
    return r;
  }
  function Bb(e, r) {
    if (r == null) r = Sr(30);
    r.write_shift(2, 924);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    r.write_shift(1, 0);
    r.write_shift(1, 0);
    r.write_shift(2, 0);
    r.write_shift(2, 100);
    r.write_shift(2, 0);
    r.write_shift(2, 0);
    r.write_shift(2, 0);
    r.write_shift(4, 0);
    return r;
  }
  function _b(e, r) {
    if (r == null) r = Sr(16 * 4 + 2);
    r.write_shift(2, e.password ? gu(e.password) : 0);
    r.write_shift(4, 1);
    [
      ["objects", false],
      ["scenarios", false],
      ["formatCells", true],
      ["formatColumns", true],
      ["formatRows", true],
      ["insertColumns", true],
      ["insertRows", true],
      ["insertHyperlinks", true],
      ["deleteColumns", true],
      ["deleteRows", true],
      ["selectLockedCells", false],
      ["sort", true],
      ["autoFilter", true],
      ["pivotTables", true],
      ["selectUnlockedCells", false],
    ].forEach(function (t) {
      if (t[1]) r.write_shift(4, e[t[0]] != null && !e[t[0]] ? 1 : 0);
      else r.write_shift(4, e[t[0]] != null && e[t[0]] ? 0 : 1);
    });
    return r;
  }
  function Tb(e, r, t, a, n, i) {
    if (!e) return e;
    var s = r || {};
    if (!t) t = { "!id": {} };
    if (c != null && s.dense == null) s.dense = c;
    var f = s.dense ? [] : {};
    var o;
    var l = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
    var h = false,
      u = false;
    var d, v, p, g, b, m, E, k, S;
    var w = [];
    s.biff = 12;
    s["!row"] = 0;
    var A = 0,
      B = false;
    var _ = [];
    var T = {};
    var x = [[]];
    x.sharedf = T;
    x.arrayf = _;
    x.SheetNames =
      a.SheetNames ||
      a.Sheets.map(function (e) {
        return e.name;
      });
    s.supbooks = x;
    for (var I = 0; I < a.Names.length; ++I) x[0][I + 1] = a.Names[I];
    var y = [],
      R = [];
    var D = 0,
      O = 0;
    var F = false;
    wr(
      e,
      function N(e, r, a) {
        if (u) return;
        switch (a) {
          case 148:
            o = e;
            break;
          case 0:
            d = e;
            if (s.sheetRows && s.sheetRows <= d.r) u = true;
            k = Or((g = d.r));
            s["!row"] = d.r;
            if (e.hidden || e.hpt || e.level != null) {
              if (e.hpt) e.hpx = Xu(e.hpt);
              R[e.r] = e;
            }
            break;
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
            v = { t: e[2] };
            switch (e[2]) {
              case "n":
                v.v = e[1];
                break;
              case "s":
                E = dg[e[1]];
                v.v = E.t;
                v.r = E.r;
                break;
              case "b":
                v.v = e[1] ? true : false;
                break;
              case "e":
                v.v = e[1];
                if (s.cellText !== false) v.w = Bt[v.v];
                break;
              case "str":
                v.t = "s";
                v.v = Ee(e[1]);
                break;
            }
            if ((p = i.CellXf[e[0].iStyleRef]))
              Cg(v, p.numFmtId, null, s, n, i);
            b = e[0].c;
            if (s.dense) {
              if (!f[g]) f[g] = [];
              f[g][b] = v;
            } else f[Lr(b) + k] = v;
            if (s.cellFormula) {
              B = false;
              for (A = 0; A < _.length; ++A) {
                var c = _[A];
                if (d.r >= c[0].s.r && d.r <= c[0].e.r)
                  if (b >= c[0].s.c && b <= c[0].e.c) {
                    v.F = jr(c[0]);
                    B = true;
                  }
              }
              if (!B && e.length > 3) v.f = e[3];
            }
            if (l.s.r > d.r) l.s.r = d.r;
            if (l.s.c > b) l.s.c = b;
            if (l.e.r < d.r) l.e.r = d.r;
            if (l.e.c < b) l.e.c = b;
            if (
              s.cellDates &&
              p &&
              v.t == "n" &&
              C.is_date(C._table[p.numFmtId])
            ) {
              var I = C.parse_date_code(v.v);
              if (I) {
                v.t = "d";
                v.v = new Date(I.y, I.m - 1, I.d, I.H, I.M, I.S, I.u);
              }
            }
            break;
          case 1:
            if (!s.sheetStubs || h) break;
            v = { t: "z", v: undefined };
            b = e[0].c;
            if (s.dense) {
              if (!f[g]) f[g] = [];
              f[g][b] = v;
            } else f[Lr(b) + k] = v;
            if (l.s.r > d.r) l.s.r = d.r;
            if (l.s.c > b) l.s.c = b;
            if (l.e.r < d.r) l.e.r = d.r;
            if (l.e.c < b) l.e.c = b;
            break;
          case 176:
            w.push(e);
            break;
          case 494:
            var D = t["!id"][e.relId];
            if (D) {
              e.Target = D.Target;
              if (e.loc) e.Target += "#" + e.loc;
              e.Rel = D;
            }
            for (g = e.rfx.s.r; g <= e.rfx.e.r; ++g)
              for (b = e.rfx.s.c; b <= e.rfx.e.c; ++b) {
                if (s.dense) {
                  if (!f[g]) f[g] = [];
                  if (!f[g][b]) f[g][b] = { t: "z", v: undefined };
                  f[g][b].l = e;
                } else {
                  m = Vr({ c: b, r: g });
                  if (!f[m]) f[m] = { t: "z", v: undefined };
                  f[m].l = e;
                }
              }
            break;
          case 426:
            if (!s.cellFormula) break;
            _.push(e);
            S = s.dense ? f[g][b] : f[Lr(b) + k];
            S.f = qp(e[1], l, { r: d.r, c: b }, x, s);
            S.F = jr(e[0]);
            break;
          case 427:
            if (!s.cellFormula) break;
            T[Vr(e[0].s)] = e[1];
            S = s.dense ? f[g][b] : f[Lr(b) + k];
            S.f = qp(e[1], l, { r: d.r, c: b }, x, s);
            break;
          case 60:
            if (!s.cellStyles) break;
            while (e.e >= e.s) {
              y[e.e--] = { width: e.w / 256, hidden: !!(e.flags & 1) };
              if (!F) {
                F = true;
                Mu(e.w / 256);
              }
              Hu(y[e.e + 1]);
            }
            break;
          case 161:
            f["!autofilter"] = { ref: jr(e) };
            break;
          case 476:
            f["!margins"] = e;
            break;
          case 485:
          case 175:
          case 644:
          case 625:
          case 562:
          case 396:
          case 1112:
          case 1146:
          case 471:
          case 1050:
          case 649:
          case 1105:
          case 49:
          case 589:
          case 607:
          case 564:
          case 1055:
          case 168:
          case 174:
          case 1180:
          case 499:
          case 64:
          case 1053:
          case 550:
          case 171:
          case 167:
          case 1177:
          case 169:
          case 1181:
          case 551:
          case 552:
          case 661:
          case 639:
          case 478:
          case 151:
          case 537:
          case 477:
          case 536:
          case 1103:
          case 680:
          case 1104:
          case 1024:
          case 152:
          case 663:
          case 535:
          case 678:
          case 504:
          case 1043:
          case 428:
          case 170:
          case 50:
          case 2070:
          case 1045:
          case 147:
            break;
          case 35:
            h = true;
            break;
          case 36:
            h = false;
            break;
          case 37:
            break;
          case 38:
            break;
          default:
            if ((r || "").indexOf("Begin") > 0) {
            } else if ((r || "").indexOf("End") > 0) {
            } else if (!h || s.WTF)
              throw new Error("Unexpected record " + a + " " + r);
        }
      },
      s
    );
    delete s.supbooks;
    delete s["!row"];
    if (
      !f["!ref"] &&
      (l.s.r < 2e6 || (o && (o.e.r > 0 || o.e.c > 0 || o.s.r > 0 || o.s.c > 0)))
    )
      f["!ref"] = jr(o || l);
    if (s.sheetRows && f["!ref"]) {
      var P = Kr(f["!ref"]);
      if (s.sheetRows < +P.e.r) {
        P.e.r = s.sheetRows - 1;
        if (P.e.r > l.e.r) P.e.r = l.e.r;
        if (P.e.r < P.s.r) P.s.r = P.e.r;
        if (P.e.c > l.e.c) P.e.c = l.e.c;
        if (P.e.c < P.s.c) P.s.c = P.e.c;
        f["!fullref"] = f["!ref"];
        f["!ref"] = jr(P);
      }
    }
    if (w.length > 0) f["!merges"] = w;
    if (y.length > 0) f["!cols"] = y;
    if (R.length > 0) f["!rows"] = R;
    return f;
  }
  function xb(e, r, t, a, n, i) {
    if (r.v === undefined) return "";
    var s = "";
    var f = null;
    switch (r.t) {
      case "b":
        s = r.v ? "1" : "0";
        break;
      case "d":
        r.z = r.z || C._table[14];
        f = r.v;
        r.v = P(r.v);
        r.t = "n";
        break;
      case "n":
      case "e":
        s = "" + r.v;
        break;
      default:
        s = r.v;
        break;
    }
    var o = { r: t, c: a };
    o.s = mg(n.cellXfs, r, n);
    if (r.l) i["!links"].push([Vr(o), r.l]);
    if (r.c) i["!comments"].push([Vr(o), r.c]);
    switch (r.t) {
      case "s":
      case "str":
        if (n.bookSST) {
          s = pg(n.Strings, r.v);
          o.t = "s";
          o.v = s;
          Br(e, "BrtCellIsst", nb(r, o));
        } else {
          o.t = "str";
          Br(e, "BrtCellSt", cb(r, o));
        }
        return;
      case "n":
        if (r.v == (r.v | 0) && r.v > -1e3 && r.v < 1e3)
          Br(e, "BrtCellRk", ob(r, o));
        else Br(e, "BrtCellReal", sb(r, o));
        if (f) {
          r.t = "d";
          r.v = f;
        }
        return;
      case "b":
        o.t = "b";
        Br(e, "BrtCellBool", rb(r, o));
        return;
      case "e":
        o.t = "e";
        break;
    }
    Br(e, "BrtCellBlank", qg(r, o));
  }
  function Ib(e, r, t, a, n) {
    var i = Kr(r["!ref"] || "A1"),
      s,
      f = "",
      o = [];
    Br(e, "BrtBeginSheetData");
    var l = Array.isArray(r);
    var c = i.e.r;
    if (r["!rows"]) c = Math.max(i.e.r, r["!rows"].length - 1);
    for (var h = i.s.r; h <= c; ++h) {
      f = Or(h);
      jg(e, r, i, h);
      if (h <= i.e.r)
        for (var u = i.s.c; u <= i.e.c; ++u) {
          if (h === i.s.r) o[u] = Lr(u);
          s = o[u] + f;
          var d = l ? (r[h] || [])[u] : r[s];
          if (!d) continue;
          xb(e, d, h, u, a, r);
        }
    }
    Br(e, "BrtEndSheetData");
  }
  function yb(e, r) {
    if (!r || !r["!merges"]) return;
    Br(e, "BrtBeginMergeCells", bb(r["!merges"].length));
    r["!merges"].forEach(function (r) {
      Br(e, "BrtMergeCell", gb(r));
    });
    Br(e, "BrtEndMergeCells");
  }
  function Rb(e, r, t, a, n) {
    if (!r || !r["!cols"]) return;
    Br(e, "BrtBeginColInfos");
    r["!cols"].forEach(function (r, t) {
      if (r) Br(e, "BrtColInfo", Sb(t, r));
    });
    Br(e, "BrtEndColInfos");
  }
  function Db(e, r, t) {
    r["!links"].forEach(function (r) {
      if (!r[1].Target) return;
      var a = ca(t, -1, r[1].Target.replace(/#.*$/, ""), ia.HLINK);
      Br(e, "BrtHLink", Cb(r, a));
    });
    delete r["!links"];
  }
  function Ob(e, r, t, a) {
    if (r["!comments"].length > 0) {
      var n = ca(a, -1, "../drawings/vmlDrawing" + (t + 1) + ".vml", ia.VML);
      Br(e, "BrtLegacyDrawing", gt("rId" + n));
      r["!legacy"] = n;
    }
  }
  function Fb(e, r) {
    if (!r["!autofilter"]) return;
    Br(e, "BrtBeginAFilter", St(Gr(r["!autofilter"].ref)));
    Br(e, "BrtEndAFilter");
  }
  function Pb(e, r) {
    Br(e, "BrtBeginWsViews");
    {
      Br(e, "BrtBeginWsView", Bb(r));
      Br(e, "BrtEndWsView");
    }
    Br(e, "BrtEndWsViews");
  }
  function Nb(e, r) {}
  function Lb(e, r) {
    if (!r["!protect"]) return;
    Br(e, "BrtSheetProtection", _b(r["!protect"]));
  }
  function Mb(e, r, t, a) {
    var n = Ar();
    var i = t.SheetNames[e],
      s = t.Sheets[i] || {};
    var f = Kr(s["!ref"] || "A1");
    s["!links"] = [];
    s["!comments"] = [];
    Br(n, "BrtBeginSheet");
    Br(n, "BrtWsProp", Qg(i));
    Br(n, "BrtWsDim", Yg(f));
    Pb(n, s);
    Nb(n, s);
    Rb(n, s, e, r, t);
    Ib(n, s, e, r, t);
    Lb(n, s);
    Fb(n, s);
    yb(n, s);
    Db(n, s, a);
    if (s["!margins"]) Br(n, "BrtMargins", Ab(s["!margins"]));
    Ob(n, s, e, a);
    Br(n, "BrtEndSheet");
    return n.end();
  }
  function Ub(e) {
    var r = [];
    (e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm) || []).forEach(function (e) {
      var t = e.match(/<c:pt idx="(.*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
      if (!t) return;
      r[+t[1]] = +t[2];
    });
    var t = ce(
      (e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [
        "",
        "General",
      ])[1]
    );
    return [r, t];
  }
  function Hb(e, r, t, a, n, i) {
    var s = i || { "!type": "chart" };
    if (!e) return i;
    var f = 0,
      o = 0,
      l = "A";
    var c = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
    (e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function (
      e
    ) {
      var r = Ub(e);
      c.s.r = c.s.c = 0;
      c.e.c = f;
      l = Lr(f);
      r[0].forEach(function (e, t) {
        s[l + Or(t)] = { t: "n", v: e, z: r[1] };
        o = t;
      });
      if (c.e.r < o) c.e.r = o;
      ++f;
    });
    if (f > 0) s["!ref"] = jr(c);
    return s;
  }
  ia.CS =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";
  var Wb = De("chartsheet", null, { xmlns: Ne.main[0], "xmlns:r": Ne.r });
  function Vb(e, r, t, a, n, i) {
    if (!e) return e;
    if (!t) t = { "!id": {} };
    var s = { "!type": "chart", "!chart": null, "!rel": "" };
    var f;
    if ((f = e.match(/drawing r:id="(.*?)"/))) s["!rel"] = f[1];
    if (t["!id"][s["!rel"]]) s["!chart"] = t["!id"][s["!rel"]];
    return s;
  }
  function zb(e, r, t, a) {
    var n = [Pe, Wb];
    n[n.length] = De("drawing", null, { "r:id": "rId1" });
    ca(a, -1, "../drawings/drawing" + (e + 1) + ".xml", ia.DRAW);
    if (n.length > 2) {
      n[n.length] = "</chartsheet>";
      n[1] = n[1].replace("/>", ">");
    }
    return n.join("");
  }
  function Xb(e, r, t, a, n, i) {
    if (!e) return e;
    if (!t) t = { "!id": {} };
    var s = { "!type": "chart", "!chart": null, "!rel": "" };
    var f = [];
    var o = false;
    wr(
      e,
      function l(e, t, a) {
        switch (a) {
          case 550:
            s["!rel"] = e;
            break;
          case 562:
          case 652:
          case 651:
          case 669:
          case 679:
          case 551:
          case 552:
          case 476:
            break;
          case 35:
            o = true;
            break;
          case 36:
            o = false;
            break;
          case 37:
            f.push(t);
            break;
          case 38:
            f.pop();
            break;
          default:
            if ((t || "").indexOf("Begin") > 0) f.push(t);
            else if ((t || "").indexOf("End") > 0) f.pop();
            else if (!o || r.WTF)
              throw new Error("Unexpected record " + a + " " + t);
        }
      },
      r
    );
    if (t["!id"][s["!rel"]]) s["!chart"] = t["!id"][s["!rel"]];
    return s;
  }
  function Gb(e, r, t, a) {
    var n = Ar();
    Br(n, "BrtBeginSheet");
    Br(n, "BrtEndSheet");
    return n.end();
  }
  var jb = [
    ["allowRefreshQuery", false, "bool"],
    ["autoCompressPictures", true, "bool"],
    ["backupFile", false, "bool"],
    ["checkCompatibility", false, "bool"],
    ["codeName", ""],
    ["date1904", false, "bool"],
    ["defaultThemeVersion", 0, "int"],
    ["filterPrivacy", false, "bool"],
    ["hidePivotFieldList", false, "bool"],
    ["promptedSolutions", false, "bool"],
    ["publishItems", false, "bool"],
    ["refreshAllConnections", false, "bool"],
    ["saveExternalLinkValues", true, "bool"],
    ["showBorderUnselectedTables", true, "bool"],
    ["showInkAnnotation", true, "bool"],
    ["showObjects", "all"],
    ["showPivotChartFilter", false, "bool"],
    ["updateLinks", "userSet"],
  ];
  var Kb = [
    ["activeTab", 0, "int"],
    ["autoFilterDateGrouping", true, "bool"],
    ["firstSheet", 0, "int"],
    ["minimized", false, "bool"],
    ["showHorizontalScroll", true, "bool"],
    ["showSheetTabs", true, "bool"],
    ["showVerticalScroll", true, "bool"],
    ["tabRatio", 600, "int"],
    ["visibility", "visible"],
  ];
  var Yb = [];
  var $b = [
    ["calcCompleted", "true"],
    ["calcMode", "auto"],
    ["calcOnSave", "true"],
    ["concurrentCalc", "true"],
    ["fullCalcOnLoad", "false"],
    ["fullPrecision", "true"],
    ["iterate", "false"],
    ["iterateCount", "100"],
    ["iterateDelta", "0.001"],
    ["refMode", "A1"],
  ];
  var Zb = [
    ["autoUpdate", "false"],
    ["changesSavedWin", "false"],
    ["includeHiddenRowCol", "true"],
    ["includePrintSettings", "true"],
    ["maximized", "false"],
    ["minimized", "false"],
    ["onlySync", "false"],
    ["personalView", "false"],
    ["showComments", "commIndicator"],
    ["showFormulaBar", "true"],
    ["showHorizontalScroll", "true"],
    ["showObjects", "all"],
    ["showSheetTabs", "true"],
    ["showStatusbar", "true"],
    ["showVerticalScroll", "true"],
    ["tabRatio", "600"],
    ["xWindow", "0"],
    ["yWindow", "0"],
  ];
  function Qb(e, r) {
    for (var t = 0; t != e.length; ++t) {
      var a = e[t];
      for (var n = 0; n != r.length; ++n) {
        var i = r[n];
        if (a[i[0]] == null) a[i[0]] = i[1];
        else
          switch (i[2]) {
            case "bool":
              if (typeof a[i[0]] == "string") a[i[0]] = Ce(a[i[0]], i[0]);
              break;
            case "int":
              if (typeof a[i[0]] == "string") a[i[0]] = parseInt(a[i[0]], 10);
              break;
          }
      }
    }
  }
  function Jb(e, r) {
    for (var t = 0; t != r.length; ++t) {
      var a = r[t];
      if (e[a[0]] == null) e[a[0]] = a[1];
      else
        switch (a[2]) {
          case "bool":
            if (typeof e[a[0]] == "string") e[a[0]] = Ce(e[a[0]], a[0]);
            break;
          case "int":
            if (typeof e[a[0]] == "string") e[a[0]] = parseInt(e[a[0]], 10);
            break;
        }
    }
  }
  function qb(e) {
    Jb(e.WBProps, jb);
    Jb(e.CalcPr, $b);
    Qb(e.WBView, Kb);
    Qb(e.Sheets, Yb);
    vg.date1904 = Ce(e.WBProps.date1904, "date1904");
  }
  function em(e) {
    if (!e.Workbook) return "false";
    if (!e.Workbook.WBProps) return "false";
    return Ce(e.Workbook.WBProps.date1904) ? "true" : "false";
  }
  var rm = "][*?/\\".split("");
  function tm(e, r) {
    if (e.length > 31) {
      if (r) return false;
      throw new Error("Sheet names cannot exceed 31 chars");
    }
    var t = true;
    rm.forEach(function (a) {
      if (e.indexOf(a) == -1) return;
      if (!r) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
      t = false;
    });
    return t;
  }
  function am(e) {
    e.forEach(function (r, t) {
      tm(r);
      for (var a = 0; a < t; ++a)
        if (r == e[a]) throw new Error("Duplicate Sheet Name: " + r);
    });
  }
  function nm(e) {
    if (!e || !e.SheetNames || !e.Sheets) throw new Error("Invalid Workbook");
    am(e.SheetNames);
  }
  var im = /<\w+:workbook/;
  function sm(e, r) {
    if (!e) throw new Error("Could not find file");
    var t = {
      AppVersion: {},
      WBProps: {},
      WBView: [],
      Sheets: [],
      CalcPr: {},
      Names: [],
      xmlns: "",
    };
    var a = false,
      n = "xmlns";
    var i = {},
      s = 0;
    e.replace(ae, function f(o, l) {
      var c = se(o);
      switch (fe(c[0])) {
        case "<?xml":
          break;
        case "<workbook":
          if (o.match(im)) n = "xmlns" + o.match(/<(\w+):/)[1];
          t.xmlns = c[n];
          break;
        case "</workbook>":
          break;
        case "<fileVersion":
          delete c[0];
          t.AppVersion = c;
          break;
        case "<fileVersion/>":
        case "</fileVersion>":
          break;
        case "<fileSharing":
        case "<fileSharing/>":
          break;
        case "<workbookPr":
        case "<workbookPr/>":
          jb.forEach(function (e) {
            if (c[e[0]] == null) return;
            switch (e[2]) {
              case "bool":
                t.WBProps[e[0]] = Ce(c[e[0]], e[0]);
                break;
              case "int":
                t.WBProps[e[0]] = parseInt(c[e[0]], 10);
                break;
              default:
                t.WBProps[e[0]] = c[e[0]];
            }
          });
          break;
        case "</workbookPr>":
          break;
        case "<workbookProtection":
          break;
        case "<workbookProtection/>":
          break;
        case "<bookViews":
        case "<bookViews>":
        case "</bookViews>":
          break;
        case "<workbookView":
          delete c[0];
          t.WBView.push(c);
          break;
        case "</workbookView>":
          break;
        case "<sheets":
        case "<sheets>":
        case "</sheets>":
          break;
        case "<sheet":
          switch (c.state) {
            case "hidden":
              c.Hidden = 1;
              break;
            case "veryHidden":
              c.Hidden = 2;
              break;
            default:
              c.Hidden = 0;
          }
          delete c.state;
          c.name = ce(Ee(c.name));
          delete c[0];
          t.Sheets.push(c);
          break;
        case "</sheet>":
          break;
        case "<functionGroups":
        case "<functionGroups/>":
          break;
        case "<functionGroup":
          break;
        case "<externalReferences":
        case "</externalReferences>":
        case "<externalReferences>":
          break;
        case "<externalReference":
          break;
        case "<definedNames/>":
          break;
        case "<definedNames>":
        case "<definedNames":
          a = true;
          break;
        case "</definedNames>":
          a = false;
          break;
        case "<definedName":
          {
            i = {};
            i.Name = c.name;
            if (c.comment) i.Comment = c.comment;
            if (c.localSheetId) i.Sheet = +c.localSheetId;
            s = l + o.length;
          }
          break;
        case "</definedName>":
          {
            i.Ref = e.slice(s, l);
            t.Names.push(i);
          }
          break;
        case "<definedName/>":
          break;
        case "<calcPr":
          delete c[0];
          t.CalcPr = c;
          break;
        case "<calcPr/>":
          delete c[0];
          t.CalcPr = c;
          break;
        case "</calcPr>":
          break;
        case "<oleSize":
          break;
        case "<customWorkbookViews>":
        case "</customWorkbookViews>":
        case "<customWorkbookViews":
          break;
        case "<customWorkbookView":
        case "</customWorkbookView>":
          break;
        case "<pivotCaches>":
        case "</pivotCaches>":
        case "<pivotCaches":
          break;
        case "<pivotCache":
          break;
        case "<smartTagPr":
        case "<smartTagPr/>":
          break;
        case "<smartTagTypes":
        case "<smartTagTypes>":
        case "</smartTagTypes>":
          break;
        case "<smartTagType":
          break;
        case "<webPublishing":
        case "<webPublishing/>":
          break;
        case "<fileRecoveryPr":
        case "<fileRecoveryPr/>":
          break;
        case "<webPublishObjects>":
        case "<webPublishObjects":
        case "</webPublishObjects>":
          break;
        case "<webPublishObject":
          break;
        case "<extLst":
        case "<extLst>":
        case "</extLst>":
        case "<extLst/>":
          break;
        case "<ext":
          a = true;
          break;
        case "</ext>":
          a = false;
          break;
        case "<ArchID":
          break;
        case "<AlternateContent":
          a = true;
          break;
        case "</AlternateContent>":
          a = false;
          break;
        case "<revisionPtr":
          break;
        default:
          if (!a && r.WTF)
            throw new Error("unrecognized " + c[0] + " in workbook");
      }
      return o;
    });
    if (Ne.main.indexOf(t.xmlns) === -1)
      throw new Error("Unknown Namespace: " + t.xmlns);
    qb(t);
    return t;
  }
  var fm = De("workbook", null, { xmlns: Ne.main[0], "xmlns:r": Ne.r });
  function om(e, r) {
    var t = [Pe];
    t[t.length] = fm;
    var a = e.Workbook && (e.Workbook.Names || []).length > 0;
    var n = { codeName: "ThisWorkbook" };
    if (e.Workbook && e.Workbook.WBProps) {
      if (e.Workbook.WBProps.codeName) n.codeName = e.Workbook.WBProps.codeName;
      jb.forEach(function (r) {
        if (e.Workbook.WBProps[r[0]] == null) return;
        if (e.Workbook.WBProps[r[0]] == r[1]) return;
        n[r[0]] = e.Workbook.WBProps[r[0]];
      });
    }
    t[t.length] = De("workbookPr", null, n);
    t[t.length] = "<sheets>";
    var i = (e.Workbook && e.Workbook.Sheets) || [];
    for (var s = 0; s != e.SheetNames.length; ++s) {
      var f = { name: de(e.SheetNames[s].substr(0, 31)) };
      f.sheetId = "" + (s + 1);
      f["r:id"] = "rId" + (s + 1);
      if (i[s])
        switch (i[s].Hidden) {
          case 1:
            f.state = "hidden";
            break;
          case 2:
            f.state = "veryHidden";
            break;
        }
      t[t.length] = De("sheet", null, f);
    }
    t[t.length] = "</sheets>";
    if (a) {
      t[t.length] = "<definedNames>";
      if (e.Workbook && e.Workbook.Names)
        e.Workbook.Names.forEach(function (e) {
          var r = { name: e.Name };
          if (e.Comment) r.comment = e.Comment;
          if (e.Sheet != null) r.localSheetId = "" + e.Sheet;
          if (!e.Ref) return;
          t[t.length] = De("definedName", String(e.Ref), r);
        });
      t[t.length] = "</definedNames>";
    }
    if (t.length > 2) {
      t[t.length] = "</workbook>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  function lm(e, r) {
    var t = {};
    t.Hidden = e.read_shift(4);
    t.iTabID = e.read_shift(4);
    t.strRelID = pt(e, r - 8);
    t.name = qr(e);
    return t;
  }
  function cm(e, r) {
    if (!r) r = Sr(127);
    r.write_shift(4, e.Hidden);
    r.write_shift(4, e.iTabID);
    gt(e.strRelID, r);
    et(e.name.substr(0, 31), r);
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  function hm(e, r) {
    var t = {};
    var a = e.read_shift(4);
    t.defaultThemeVersion = e.read_shift(4);
    var n = r > 8 ? qr(e) : "";
    if (n.length > 0) t.codeName = n;
    t.autoCompressPictures = !!(a & 65536);
    t.backupFile = !!(a & 64);
    t.checkCompatibility = !!(a & 4096);
    t.date1904 = !!(a & 1);
    t.filterPrivacy = !!(a & 8);
    t.hidePivotFieldList = !!(a & 1024);
    t.promptedSolutions = !!(a & 16);
    t.publishItems = !!(a & 2048);
    t.refreshAllConnections = !!(a & 262144);
    t.saveExternalLinkValues = !!(a & 128);
    t.showBorderUnselectedTables = !!(a & 4);
    t.showInkAnnotation = !!(a & 32);
    t.showObjects = ["all", "placeholders", "none"][(a >> 13) & 3];
    t.showPivotChartFilter = !!(a & 32768);
    t.updateLinks = ["userSet", "never", "always"][(a >> 8) & 3];
    return t;
  }
  function um(e, r) {
    if (!r) r = Sr(72);
    var t = 0;
    if (e) {
      if (e.filterPrivacy) t |= 8;
    }
    r.write_shift(4, t);
    r.write_shift(4, 0);
    ct("ThisWorkbook", r);
    return r.slice(0, r.l);
  }
  function dm(e, r) {
    var t = {};
    e.read_shift(4);
    t.ArchID = e.read_shift(4);
    e.l += r - 8;
    return t;
  }
  function vm(e, r, t) {
    var a = e.l + r;
    var n = e.read_shift(4);
    var i = e.read_shift(1);
    var s = e.read_shift(4);
    var f = dt(e);
    var o = ag(e, 0, t);
    var l = ht(e);
    e.l = a;
    var c = { Name: f, Ptg: o, Comment: l };
    if (s < 268435455) c.Sheet = s;
    return c;
  }
  function pm(e, r) {
    var t = {
      AppVersion: {},
      WBProps: {},
      WBView: [],
      Sheets: [],
      CalcPr: {},
      xmlns: "",
    };
    var a = false,
      n;
    if (!r) r = {};
    r.biff = 12;
    var i = [];
    var s = [];
    s.SheetNames = [];
    wr(
      e,
      function f(e, n, o) {
        switch (o) {
          case 156:
            s.SheetNames.push(e.name);
            t.Sheets.push(e);
            break;
          case 153:
            t.WBProps = e;
            break;
          case 39:
            e.Ref = qp(e.Ptg, null, null, s, r);
            delete e.Ptg;
            i.push(e);
            break;
          case 1036:
            break;
          case 357:
          case 358:
          case 355:
          case 667:
          case 362:
          case 361:
            break;
          case 2071:
          case 534:
          case 677:
          case 158:
          case 157:
          case 610:
          case 2050:
          case 155:
          case 548:
          case 676:
          case 128:
          case 665:
          case 2128:
          case 2125:
          case 549:
          case 2053:
          case 596:
          case 2076:
          case 2075:
          case 2082:
          case 397:
          case 154:
          case 1117:
          case 553:
          case 2091:
            break;
          case 35:
            a = true;
            break;
          case 36:
            a = false;
            break;
          case 37:
            break;
          case 38:
            break;
          case 16:
            break;
          default:
            if ((n || "").indexOf("Begin") > 0) {
            } else if ((n || "").indexOf("End") > 0) {
            } else if (!a || r.WTF)
              throw new Error("Unexpected record " + o + " " + n);
        }
      },
      r
    );
    qb(t);
    t.Names = i;
    return t;
  }
  function gm(e, r, t) {
    Br(e, "BrtBeginBundleShs");
    for (var a = 0; a != r.SheetNames.length; ++a) {
      var n =
        (r.Workbook &&
          r.Workbook.Sheets &&
          r.Workbook.Sheets[a] &&
          r.Workbook.Sheets[a].Hidden) ||
        0;
      var i = {
        Hidden: n,
        iTabID: a + 1,
        strRelID: "rId" + (a + 1),
        name: r.SheetNames[a],
      };
      Br(e, "BrtBundleSh", cm(i));
    }
    Br(e, "BrtEndBundleShs");
  }
  function bm(e, t) {
    if (!t) t = Sr(127);
    for (var a = 0; a != 4; ++a) t.write_shift(4, 0);
    et("SheetJS", t);
    et(r.version, t);
    et(r.version, t);
    et("7262", t);
    t.length = t.l;
    return t.length > t.l ? t.slice(0, t.l) : t;
  }
  function mm(e, r) {
    if (!r) r = Sr(29);
    r.write_shift(-4, 0);
    r.write_shift(-4, 460);
    r.write_shift(4, 28800);
    r.write_shift(4, 17600);
    r.write_shift(4, 500);
    r.write_shift(4, e);
    r.write_shift(4, e);
    var t = 120;
    r.write_shift(1, t);
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  function Cm(e, r, t) {
    if (!r.Workbook || !r.Workbook.Sheets) return;
    var a = r.Workbook.Sheets;
    var n = 0,
      i = -1,
      s = -1;
    for (; n < a.length; ++n) {
      if (!a[n] || (!a[n].Hidden && i == -1)) i = n;
      else if (a[n].Hidden == 1 && s == -1) s = n;
    }
    if (s > i) return;
    Br(e, "BrtBeginBookViews");
    Br(e, "BrtBookView", mm(i));
    Br(e, "BrtEndBookViews");
  }
  function Em(e, r) {
    if (!r) r = Sr(26);
    r.write_shift(4, 0);
    r.write_shift(4, 1);
    r.write_shift(4, 0);
    At(0, r);
    r.write_shift(-4, 1023);
    r.write_shift(1, 51);
    r.write_shift(1, 0);
    return r;
  }
  function km(e, r) {
    if (!r) r = Sr(1);
    r.write_shift(1, 0);
    return r;
  }
  function Sm(e, r) {
    var t = Ar();
    Br(t, "BrtBeginBook");
    Br(t, "BrtFileVersion", bm());
    Br(t, "BrtWbProp", um((e.Workbook && e.Workbook.WBProps) || null));
    Cm(t, e, r);
    gm(t, e, r);
    Br(t, "BrtEndBook");
    return t.end();
  }
  function wm(e, r, t) {
    if (r.slice(-4) === ".bin") return pm(e, t);
    return sm(e, t);
  }
  function Am(e, r, t, a, n, i, s) {
    if (r.slice(-4) === ".bin") return Tb(e, t, a, n, i, s);
    return xg(e, t, a, n, i, s);
  }
  function Bm(e, r, t, a, n, i, s) {
    if (r.slice(-4) === ".bin") return Xb(e, t, a, n, i, s);
    return Vb(e, t, a, n, i, s);
  }
  function _m(e, r, t, a, n, i, s) {
    if (r.slice(-4) === ".bin") return vv(e, t, a, n, i, s);
    return pv(e, t, a, n, i, s);
  }
  function Tm(e, r, t, a, n, i, s) {
    if (r.slice(-4) === ".bin") return uv(e, t, a, n, i, s);
    return dv(e, t, a, n, i, s);
  }
  function xm(e, r, t, a) {
    if (r.slice(-4) === ".bin") return bd(e, t, a);
    return rd(e, t, a);
  }
  function Im(e, r, t) {
    return Ld(e, t);
  }
  function ym(e, r, t) {
    if (r.slice(-4) === ".bin") return Zh(e, t);
    return jh(e, t);
  }
  function Rm(e, r, t) {
    if (r.slice(-4) === ".bin") return cv(e, t);
    return av(e, t);
  }
  function Dm(e, r, t) {
    if (r.slice(-4) === ".bin") return Zd(e, t);
    return Kd(e, t);
  }
  function Om(e, r, t) {
    return (r.slice(-4) === ".bin" ? Sm : om)(e, t);
  }
  function Fm(e, r, t, a, n) {
    return (r.slice(-4) === ".bin" ? Mb : zg)(e, t, a, n);
  }
  function Pm(e, r, t, a, n) {
    return (r.slice(-4) === ".bin" ? Gb : zb)(e, t, a, n);
  }
  function Nm(e, r, t) {
    return (r.slice(-4) === ".bin" ? xd : ad)(e, t);
  }
  function Lm(e, r, t) {
    return (r.slice(-4) === ".bin" ? qh : Yh)(e, t);
  }
  function Mm(e, r, t) {
    return (r.slice(-4) === ".bin" ? hv : iv)(e, t);
  }
  var Um = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
  var Hm = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
  var Wm = function (e) {
    return String.fromCharCode(e);
  };
  function Vm(e, r) {
    var t = e.split(/\s+/);
    var a = [];
    if (!r) a[0] = t[0];
    if (t.length === 1) return a;
    var n = e.match(Um),
      i,
      s,
      f,
      o;
    if (n)
      for (o = 0; o != n.length; ++o) {
        i = n[o].match(Hm);
        if ((s = i[1].indexOf(":")) === -1)
          a[i[1]] = i[2].substr(1, i[2].length - 2);
        else {
          if (i[1].substr(0, 6) === "xmlns:") f = "xmlns" + i[1].substr(6);
          else f = i[1].substr(s + 1);
          a[f] = i[2].substr(1, i[2].length - 2);
        }
      }
    return a;
  }
  function zm(e) {
    var r = e.split(/\s+/);
    var t = {};
    if (r.length === 1) return t;
    var a = e.match(Um),
      n,
      i,
      s,
      f;
    if (a)
      for (f = 0; f != a.length; ++f) {
        n = a[f].match(Hm);
        if ((i = n[1].indexOf(":")) === -1)
          t[n[1]] = n[2].substr(1, n[2].length - 2);
        else {
          if (n[1].substr(0, 6) === "xmlns:") s = "xmlns" + n[1].substr(6);
          else s = n[1].substr(i + 1);
          t[s] = n[2].substr(1, n[2].length - 2);
        }
      }
    return t;
  }
  function Xm(e, r) {
    var t = k[e] || ce(e);
    if (t === "General") return C._general(r);
    return C.format(t, r);
  }
  function Gm(e, r, t, a) {
    var n = a;
    switch ((t[0].match(/dt:dt="([\w.]+)"/) || ["", ""])[1]) {
      case "boolean":
        n = Ce(a);
        break;
      case "i2":
      case "int":
        n = parseInt(a, 10);
        break;
      case "r4":
      case "float":
        n = parseFloat(a);
        break;
      case "date":
      case "dateTime.tz":
        n = H(a);
        break;
      case "i8":
      case "string":
      case "fixed":
      case "uuid":
      case "bin.base64":
        break;
      default:
        throw new Error("bad custprop:" + t[0]);
    }
    e[ce(r[3])] = n;
  }
  function jm(e, r, t) {
    if (e.t === "z") return;
    if (!t || t.cellText !== false)
      try {
        if (e.t === "e") {
          e.w = e.w || Bt[e.v];
        } else if (r === "General") {
          if (e.t === "n") {
            if ((e.v | 0) === e.v) e.w = C._general_int(e.v);
            else e.w = C._general_num(e.v);
          } else e.w = C._general(e.v);
        } else e.w = Xm(r || "General", e.v);
      } catch (a) {
        if (t.WTF) throw a;
      }
    try {
      var n = k[r] || r || "General";
      if (t.cellNF) e.z = n;
      if (t.cellDates && e.t == "n" && C.is_date(n)) {
        var i = C.parse_date_code(e.v);
        if (i) {
          e.t = "d";
          e.v = new Date(i.y, i.m - 1, i.d, i.H, i.M, i.S, i.u);
        }
      }
    } catch (a) {
      if (t.WTF) throw a;
    }
  }
  function Km(e, r, t) {
    if (t.cellStyles) {
      if (r.Interior) {
        var a = r.Interior;
        if (a.Pattern) a.patternType = Gu[a.Pattern] || a.Pattern;
      }
    }
    e[r.ID] = r;
  }
  function Ym(e, r, t, a, n, i, s, f, o, l) {
    var c = "General",
      h = a.StyleID,
      u = {};
    l = l || {};
    var d = [];
    var v = 0;
    if (h === undefined && f) h = f.StyleID;
    if (h === undefined && s) h = s.StyleID;
    while (i[h] !== undefined) {
      if (i[h].nf) c = i[h].nf;
      if (i[h].Interior) d.push(i[h].Interior);
      if (!i[h].Parent) break;
      h = i[h].Parent;
    }
    switch (t.Type) {
      case "Boolean":
        a.t = "b";
        a.v = Ce(e);
        break;
      case "String":
        a.t = "s";
        a.r = be(ce(e));
        a.v = e.indexOf("<") > -1 ? ce(r) : a.r;
        break;
      case "DateTime":
        if (e.slice(-1) != "Z") e += "Z";
        a.v = (H(e) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1e3);
        if (a.v !== a.v) a.v = ce(e);
        else if (a.v < 60) a.v = a.v - 1;
        if (!c || c == "General") c = "yyyy-mm-dd";
      case "Number":
        if (a.v === undefined) a.v = +e;
        if (!a.t) a.t = "n";
        break;
      case "Error":
        a.t = "e";
        a.v = _t[e];
        if (l.cellText !== false) a.w = e;
        break;
      default:
        a.t = "s";
        a.v = be(r || e);
        break;
    }
    jm(a, c, l);
    if (l.cellFormula !== false) {
      if (a.Formula) {
        var p = ce(a.Formula);
        if (p.charCodeAt(0) == 61) p = p.substr(1);
        a.f = gv(p, n);
        delete a.Formula;
        if (a.ArrayRange == "RC") a.F = gv("RC:RC", n);
        else if (a.ArrayRange) {
          a.F = gv(a.ArrayRange, n);
          o.push([Kr(a.F), a.F]);
        }
      } else {
        for (v = 0; v < o.length; ++v)
          if (n.r >= o[v][0].s.r && n.r <= o[v][0].e.r)
            if (n.c >= o[v][0].s.c && n.c <= o[v][0].e.c) a.F = o[v][1];
      }
    }
    if (l.cellStyles) {
      d.forEach(function (e) {
        if (!u.patternType && e.patternType) u.patternType = e.patternType;
      });
      a.s = u;
    }
    a.ixfe = a.StyleID !== undefined ? a.StyleID : "Default";
  }
  function $m(e) {
    e.t = e.v || "";
    e.t = e.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    e.v = e.w = e.ixfe = undefined;
  }
  function Zm(e) {
    if (d && Buffer.isBuffer(e)) return e.toString("utf8");
    if (typeof e === "string") return e;
    throw new Error("Bad input format: expected Buffer or string");
  }
  var Qm = /<(\/?)([^\s?>!\/:]*:|)([^\s?>]*[^\s?>\/])[^>]*>/gm;
  function Jm(e, r) {
    var t = r || {};
    E(C);
    var a = o(Zm(e));
    if (t && t.type == "binary" && typeof cptable !== "undefined")
      a = cptable.utils.decode(65001, i(a));
    var n = a.slice(0, 1024).toLowerCase(),
      s = false;
    if (n.indexOf("<?xml") == -1)
      ["html", "table", "head", "meta", "script", "style", "div"].forEach(
        function (e) {
          if (n.indexOf("<" + e) >= 0) s = true;
        }
      );
    if (s) return yC.to_workbook(a, t);
    var f;
    var l = [],
      h;
    if (c != null && t.dense == null) t.dense = c;
    var u = {},
      d = [],
      v = t.dense ? [] : {},
      p = "";
    var g = {},
      b = {},
      m = {};
    var S = Vm('<Data ss:Type="String">'),
      w = 0;
    var A = 0,
      B = 0;
    var _ = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
    var T = {},
      x = {};
    var I = "",
      y = 0;
    var R = [];
    var D = {},
      O = {},
      F = 0,
      P = {};
    var N = [],
      L = {};
    var M = [],
      U,
      H = false;
    var W = [];
    var V = [],
      X = {};
    var G = { Sheets: [], WBProps: { date1904: false } },
      j = {};
    Qm.lastIndex = 0;
    a = a.replace(/<!--([\s\S]*?)-->/gm, "");
    while ((f = Qm.exec(a)))
      switch (f[3]) {
        case "Data":
          if (l[l.length - 1][1]) break;
          if (f[1] === "/")
            Ym(
              a.slice(w, f.index),
              I,
              S,
              l[l.length - 1][0] == "Comment" ? L : b,
              { c: A, r: B },
              T,
              M[A],
              m,
              W,
              t
            );
          else {
            I = "";
            S = Vm(f[0]);
            w = f.index + f[0].length;
          }
          break;
        case "Cell":
          if (f[1] === "/") {
            if (N.length > 0) b.c = N;
            if ((!t.sheetRows || t.sheetRows > B) && b.v !== undefined) {
              if (t.dense) {
                if (!v[B]) v[B] = [];
                v[B][A] = b;
              } else v[Lr(A) + Or(B)] = b;
            }
            if (b.HRef) {
              b.l = { Target: b.HRef, Tooltip: b.HRefScreenTip };
              delete b.HRef;
              delete b.HRefScreenTip;
            }
            if (b.MergeAcross || b.MergeDown) {
              var K = A + (parseInt(b.MergeAcross, 10) | 0);
              var Y = B + (parseInt(b.MergeDown, 10) | 0);
              R.push({ s: { c: A, r: B }, e: { c: K, r: Y } });
            }
            if (!t.sheetStubs) {
              if (b.MergeAcross) A = K + 1;
              else ++A;
            } else if (b.MergeAcross || b.MergeDown) {
              for (var $ = A; $ <= K; ++$) {
                for (var Z = B; Z <= Y; ++Z) {
                  if ($ > A || Z > B) {
                    if (t.dense) {
                      if (!v[Z]) v[Z] = [];
                      v[Z][$] = { t: "z" };
                    } else v[Lr($) + Or(Z)] = { t: "z" };
                  }
                }
              }
              A = K + 1;
            } else ++A;
          } else {
            b = zm(f[0]);
            if (b.Index) A = +b.Index - 1;
            if (A < _.s.c) _.s.c = A;
            if (A > _.e.c) _.e.c = A;
            if (f[0].slice(-2) === "/>") ++A;
            N = [];
          }
          break;
        case "Row":
          if (f[1] === "/" || f[0].slice(-2) === "/>") {
            if (B < _.s.r) _.s.r = B;
            if (B > _.e.r) _.e.r = B;
            if (f[0].slice(-2) === "/>") {
              m = Vm(f[0]);
              if (m.Index) B = +m.Index - 1;
            }
            A = 0;
            ++B;
          } else {
            m = Vm(f[0]);
            if (m.Index) B = +m.Index - 1;
            X = {};
            if (m.AutoFitHeight == "0" || m.Height) {
              X.hpx = parseInt(m.Height, 10);
              X.hpt = zu(X.hpx);
              V[B] = X;
            }
            if (m.Hidden == "1") {
              X.hidden = true;
              V[B] = X;
            }
          }
          break;
        case "Worksheet":
          if (f[1] === "/") {
            if ((h = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + h.join("|"));
            d.push(p);
            if (_.s.r <= _.e.r && _.s.c <= _.e.c) v["!ref"] = jr(_);
            if (R.length) v["!merges"] = R;
            if (M.length > 0) v["!cols"] = M;
            if (V.length > 0) v["!rows"] = V;
            u[p] = v;
          } else {
            _ = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
            B = A = 0;
            l.push([f[3], false]);
            h = Vm(f[0]);
            p = ce(h.Name);
            v = t.dense ? [] : {};
            R = [];
            W = [];
            V = [];
            j = { name: p, Hidden: 0 };
            G.Sheets.push(j);
          }
          break;
        case "Table":
          if (f[1] === "/") {
            if ((h = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + h.join("|"));
          } else if (f[0].slice(-2) == "/>") break;
          else {
            g = Vm(f[0]);
            l.push([f[3], false]);
            M = [];
            H = false;
          }
          break;
        case "Style":
          if (f[1] === "/") Km(T, x, t);
          else x = Vm(f[0]);
          break;
        case "NumberFormat":
          x.nf = ce(Vm(f[0]).Format || "General");
          if (k[x.nf]) x.nf = k[x.nf];
          for (var Q = 0; Q != 392; ++Q) if (C._table[Q] == x.nf) break;
          if (Q == 392)
            for (Q = 57; Q != 392; ++Q)
              if (C._table[Q] == null) {
                C.load(x.nf, Q);
                break;
              }
          break;
        case "Column":
          if (l[l.length - 1][0] !== "Table") break;
          U = Vm(f[0]);
          if (U.Hidden) {
            U.hidden = true;
            delete U.Hidden;
          }
          if (U.Width) U.wpx = parseInt(U.Width, 10);
          if (!H && U.wpx > 10) {
            H = true;
            Ru = xu;
            for (var J = 0; J < M.length; ++J) if (M[J]) Hu(M[J]);
          }
          if (H) Hu(U);
          M[U.Index - 1 || M.length] = U;
          for (var q = 0; q < +U.Span; ++q) M[M.length] = z(U);
          break;
        case "NamedRange":
          if (!G.Names) G.Names = [];
          var ee = se(f[0]);
          var re = { Name: ee.Name, Ref: gv(ee.RefersTo.substr(1)) };
          if (G.Sheets.length > 0) re.Sheet = G.Sheets.length - 1;
          G.Names.push(re);
          break;
        case "NamedCell":
          break;
        case "B":
          break;
        case "I":
          break;
        case "U":
          break;
        case "S":
          break;
        case "Sub":
          break;
        case "Sup":
          break;
        case "Span":
          break;
        case "Border":
          break;
        case "Alignment":
          break;
        case "Borders":
          break;
        case "Font":
          if (f[0].slice(-2) === "/>") break;
          else if (f[1] === "/") I += a.slice(y, f.index);
          else y = f.index + f[0].length;
          break;
        case "Interior":
          if (!t.cellStyles) break;
          x.Interior = Vm(f[0]);
          break;
        case "Protection":
          break;
        case "Author":
        case "Title":
        case "Description":
        case "Created":
        case "Keywords":
        case "Subject":
        case "Category":
        case "Company":
        case "LastAuthor":
        case "LastSaved":
        case "LastPrinted":
        case "Version":
        case "Revision":
        case "TotalTime":
        case "HyperlinkBase":
        case "Manager":
        case "ContentStatus":
        case "Identifier":
        case "Language":
          if (f[0].slice(-2) === "/>") break;
          else if (f[1] === "/") Fa(D, f[3], a.slice(F, f.index));
          else F = f.index + f[0].length;
          break;
        case "Paragraphs":
          break;
        case "Styles":
        case "Workbook":
          if (f[1] === "/") {
            if ((h = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + h.join("|"));
          } else l.push([f[3], false]);
          break;
        case "Comment":
          if (f[1] === "/") {
            if ((h = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + h.join("|"));
            $m(L);
            N.push(L);
          } else {
            l.push([f[3], false]);
            h = Vm(f[0]);
            L = { a: h.Author };
          }
          break;
        case "AutoFilter":
          if (f[1] === "/") {
            if ((h = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + h.join("|"));
          } else if (f[0].charAt(f[0].length - 2) !== "/") {
            var te = Vm(f[0]);
            v["!autofilter"] = { ref: gv(te.Range).replace(/\$/g, "") };
            l.push([f[3], true]);
          }
          break;
        case "Name":
          break;
        case "ComponentOptions":
        case "DocumentProperties":
        case "CustomDocumentProperties":
        case "OfficeDocumentSettings":
        case "PivotTable":
        case "PivotCache":
        case "Names":
        case "MapInfo":
        case "PageBreaks":
        case "QueryTable":
        case "DataValidation":
        case "Sorting":
        case "Schema":
        case "data":
        case "ConditionalFormatting":
        case "SmartTagType":
        case "SmartTags":
        case "ExcelWorkbook":
        case "WorkbookOptions":
        case "WorksheetOptions":
          if (f[1] === "/") {
            if ((h = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + h.join("|"));
          } else if (f[0].charAt(f[0].length - 2) !== "/") l.push([f[3], true]);
          break;
        default:
          if (l.length == 0 && f[3] == "document") return PC(a, t);
          if (l.length == 0 && f[3] == "UOF") return PC(a, t);
          var ae = true;
          switch (l[l.length - 1][0]) {
            case "OfficeDocumentSettings":
              switch (f[3]) {
                case "AllowPNG":
                  break;
                case "RemovePersonalInformation":
                  break;
                case "DownloadComponents":
                  break;
                case "LocationOfComponents":
                  break;
                case "Colors":
                  break;
                case "Color":
                  break;
                case "Index":
                  break;
                case "RGB":
                  break;
                case "PixelsPerInch":
                  break;
                case "TargetScreenSize":
                  break;
                case "ReadOnlyRecommended":
                  break;
                default:
                  ae = false;
              }
              break;
            case "ComponentOptions":
              switch (f[3]) {
                case "Toolbar":
                  break;
                case "HideOfficeLogo":
                  break;
                case "SpreadsheetAutoFit":
                  break;
                case "Label":
                  break;
                case "Caption":
                  break;
                case "MaxHeight":
                  break;
                case "MaxWidth":
                  break;
                case "NextSheetNumber":
                  break;
                default:
                  ae = false;
              }
              break;
            case "ExcelWorkbook":
              switch (f[3]) {
                case "Date1904":
                  G.WBProps.date1904 = true;
                  break;
                case "WindowHeight":
                  break;
                case "WindowWidth":
                  break;
                case "WindowTopX":
                  break;
                case "WindowTopY":
                  break;
                case "TabRatio":
                  break;
                case "ProtectStructure":
                  break;
                case "ProtectWindows":
                  break;
                case "ActiveSheet":
                  break;
                case "DisplayInkNotes":
                  break;
                case "FirstVisibleSheet":
                  break;
                case "SupBook":
                  break;
                case "SheetName":
                  break;
                case "SheetIndex":
                  break;
                case "SheetIndexFirst":
                  break;
                case "SheetIndexLast":
                  break;
                case "Dll":
                  break;
                case "AcceptLabelsInFormulas":
                  break;
                case "DoNotSaveLinkValues":
                  break;
                case "Iteration":
                  break;
                case "MaxIterations":
                  break;
                case "MaxChange":
                  break;
                case "Path":
                  break;
                case "Xct":
                  break;
                case "Count":
                  break;
                case "SelectedSheets":
                  break;
                case "Calculation":
                  break;
                case "Uncalced":
                  break;
                case "StartupPrompt":
                  break;
                case "Crn":
                  break;
                case "ExternName":
                  break;
                case "Formula":
                  break;
                case "ColFirst":
                  break;
                case "ColLast":
                  break;
                case "WantAdvise":
                  break;
                case "Boolean":
                  break;
                case "Error":
                  break;
                case "Text":
                  break;
                case "OLE":
                  break;
                case "NoAutoRecover":
                  break;
                case "PublishObjects":
                  break;
                case "DoNotCalculateBeforeSave":
                  break;
                case "Number":
                  break;
                case "RefModeR1C1":
                  break;
                case "EmbedSaveSmartTags":
                  break;
                default:
                  ae = false;
              }
              break;
            case "WorkbookOptions":
              switch (f[3]) {
                case "OWCVersion":
                  break;
                case "Height":
                  break;
                case "Width":
                  break;
                default:
                  ae = false;
              }
              break;
            case "WorksheetOptions":
              switch (f[3]) {
                case "Visible":
                  if (f[0].slice(-2) === "/>") {
                  } else if (f[1] === "/")
                    switch (a.slice(F, f.index)) {
                      case "SheetHidden":
                        j.Hidden = 1;
                        break;
                      case "SheetVeryHidden":
                        j.Hidden = 2;
                        break;
                    }
                  else F = f.index + f[0].length;
                  break;
                case "Header":
                  if (!v["!margins"]) bg((v["!margins"] = {}), "xlml");
                  v["!margins"].header = se(f[0]).Margin;
                  break;
                case "Footer":
                  if (!v["!margins"]) bg((v["!margins"] = {}), "xlml");
                  v["!margins"].footer = se(f[0]).Margin;
                  break;
                case "PageMargins":
                  var ne = se(f[0]);
                  if (!v["!margins"]) bg((v["!margins"] = {}), "xlml");
                  if (ne.Top) v["!margins"].top = ne.Top;
                  if (ne.Left) v["!margins"].left = ne.Left;
                  if (ne.Right) v["!margins"].right = ne.Right;
                  if (ne.Bottom) v["!margins"].bottom = ne.Bottom;
                  break;
                case "Unsynced":
                  break;
                case "Print":
                  break;
                case "Panes":
                  break;
                case "Scale":
                  break;
                case "Pane":
                  break;
                case "Number":
                  break;
                case "Layout":
                  break;
                case "PageSetup":
                  break;
                case "Selected":
                  break;
                case "ProtectObjects":
                  break;
                case "EnableSelection":
                  break;
                case "ProtectScenarios":
                  break;
                case "ValidPrinterInfo":
                  break;
                case "HorizontalResolution":
                  break;
                case "VerticalResolution":
                  break;
                case "NumberofCopies":
                  break;
                case "ActiveRow":
                  break;
                case "ActiveCol":
                  break;
                case "ActivePane":
                  break;
                case "TopRowVisible":
                  break;
                case "TopRowBottomPane":
                  break;
                case "LeftColumnVisible":
                  break;
                case "LeftColumnRightPane":
                  break;
                case "FitToPage":
                  break;
                case "RangeSelection":
                  break;
                case "PaperSizeIndex":
                  break;
                case "PageLayoutZoom":
                  break;
                case "PageBreakZoom":
                  break;
                case "FilterOn":
                  break;
                case "DoNotDisplayGridlines":
                  break;
                case "SplitHorizontal":
                  break;
                case "SplitVertical":
                  break;
                case "FreezePanes":
                  break;
                case "FrozenNoSplit":
                  break;
                case "FitWidth":
                  break;
                case "FitHeight":
                  break;
                case "CommentsLayout":
                  break;
                case "Zoom":
                  break;
                case "LeftToRight":
                  break;
                case "Gridlines":
                  break;
                case "AllowSort":
                  break;
                case "AllowFilter":
                  break;
                case "AllowInsertRows":
                  break;
                case "AllowDeleteRows":
                  break;
                case "AllowInsertCols":
                  break;
                case "AllowDeleteCols":
                  break;
                case "AllowInsertHyperlinks":
                  break;
                case "AllowFormatCells":
                  break;
                case "AllowSizeCols":
                  break;
                case "AllowSizeRows":
                  break;
                case "NoSummaryRowsBelowDetail":
                  break;
                case "TabColorIndex":
                  break;
                case "DoNotDisplayHeadings":
                  break;
                case "ShowPageLayoutZoom":
                  break;
                case "NoSummaryColumnsRightDetail":
                  break;
                case "BlackAndWhite":
                  break;
                case "DoNotDisplayZeros":
                  break;
                case "DisplayPageBreak":
                  break;
                case "RowColHeadings":
                  break;
                case "DoNotDisplayOutline":
                  break;
                case "NoOrientation":
                  break;
                case "AllowUsePivotTables":
                  break;
                case "ZeroHeight":
                  break;
                case "ViewableRange":
                  break;
                case "Selection":
                  break;
                case "ProtectContents":
                  break;
                default:
                  ae = false;
              }
              break;
            case "PivotTable":
            case "PivotCache":
              switch (f[3]) {
                case "ImmediateItemsOnDrop":
                  break;
                case "ShowPageMultipleItemLabel":
                  break;
                case "CompactRowIndent":
                  break;
                case "Location":
                  break;
                case "PivotField":
                  break;
                case "Orientation":
                  break;
                case "LayoutForm":
                  break;
                case "LayoutSubtotalLocation":
                  break;
                case "LayoutCompactRow":
                  break;
                case "Position":
                  break;
                case "PivotItem":
                  break;
                case "DataType":
                  break;
                case "DataField":
                  break;
                case "SourceName":
                  break;
                case "ParentField":
                  break;
                case "PTLineItems":
                  break;
                case "PTLineItem":
                  break;
                case "CountOfSameItems":
                  break;
                case "Item":
                  break;
                case "ItemType":
                  break;
                case "PTSource":
                  break;
                case "CacheIndex":
                  break;
                case "ConsolidationReference":
                  break;
                case "FileName":
                  break;
                case "Reference":
                  break;
                case "NoColumnGrand":
                  break;
                case "NoRowGrand":
                  break;
                case "BlankLineAfterItems":
                  break;
                case "Hidden":
                  break;
                case "Subtotal":
                  break;
                case "BaseField":
                  break;
                case "MapChildItems":
                  break;
                case "Function":
                  break;
                case "RefreshOnFileOpen":
                  break;
                case "PrintSetTitles":
                  break;
                case "MergeLabels":
                  break;
                case "DefaultVersion":
                  break;
                case "RefreshName":
                  break;
                case "RefreshDate":
                  break;
                case "RefreshDateCopy":
                  break;
                case "VersionLastRefresh":
                  break;
                case "VersionLastUpdate":
                  break;
                case "VersionUpdateableMin":
                  break;
                case "VersionRefreshableMin":
                  break;
                case "Calculation":
                  break;
                default:
                  ae = false;
              }
              break;
            case "PageBreaks":
              switch (f[3]) {
                case "ColBreaks":
                  break;
                case "ColBreak":
                  break;
                case "RowBreaks":
                  break;
                case "RowBreak":
                  break;
                case "ColStart":
                  break;
                case "ColEnd":
                  break;
                case "RowEnd":
                  break;
                default:
                  ae = false;
              }
              break;
            case "AutoFilter":
              switch (f[3]) {
                case "AutoFilterColumn":
                  break;
                case "AutoFilterCondition":
                  break;
                case "AutoFilterAnd":
                  break;
                case "AutoFilterOr":
                  break;
                default:
                  ae = false;
              }
              break;
            case "QueryTable":
              switch (f[3]) {
                case "Id":
                  break;
                case "AutoFormatFont":
                  break;
                case "AutoFormatPattern":
                  break;
                case "QuerySource":
                  break;
                case "QueryType":
                  break;
                case "EnableRedirections":
                  break;
                case "RefreshedInXl9":
                  break;
                case "URLString":
                  break;
                case "HTMLTables":
                  break;
                case "Connection":
                  break;
                case "CommandText":
                  break;
                case "RefreshInfo":
                  break;
                case "NoTitles":
                  break;
                case "NextId":
                  break;
                case "ColumnInfo":
                  break;
                case "OverwriteCells":
                  break;
                case "DoNotPromptForFile":
                  break;
                case "TextWizardSettings":
                  break;
                case "Source":
                  break;
                case "Number":
                  break;
                case "Decimal":
                  break;
                case "ThousandSeparator":
                  break;
                case "TrailingMinusNumbers":
                  break;
                case "FormatSettings":
                  break;
                case "FieldType":
                  break;
                case "Delimiters":
                  break;
                case "Tab":
                  break;
                case "Comma":
                  break;
                case "AutoFormatName":
                  break;
                case "VersionLastEdit":
                  break;
                case "VersionLastRefresh":
                  break;
                default:
                  ae = false;
              }
              break;
            case "Sorting":
            case "ConditionalFormatting":
            case "DataValidation":
              switch (f[3]) {
                case "Range":
                  break;
                case "Type":
                  break;
                case "Min":
                  break;
                case "Max":
                  break;
                case "Sort":
                  break;
                case "Descending":
                  break;
                case "Order":
                  break;
                case "CaseSensitive":
                  break;
                case "Value":
                  break;
                case "ErrorStyle":
                  break;
                case "ErrorMessage":
                  break;
                case "ErrorTitle":
                  break;
                case "CellRangeList":
                  break;
                case "InputMessage":
                  break;
                case "InputTitle":
                  break;
                case "ComboHide":
                  break;
                case "InputHide":
                  break;
                case "Condition":
                  break;
                case "Qualifier":
                  break;
                case "UseBlank":
                  break;
                case "Value1":
                  break;
                case "Value2":
                  break;
                case "Format":
                  break;
                default:
                  ae = false;
              }
              break;
            case "MapInfo":
            case "Schema":
            case "data":
              switch (f[3]) {
                case "Map":
                  break;
                case "Entry":
                  break;
                case "Range":
                  break;
                case "XPath":
                  break;
                case "Field":
                  break;
                case "XSDType":
                  break;
                case "FilterOn":
                  break;
                case "Aggregate":
                  break;
                case "ElementType":
                  break;
                case "AttributeType":
                  break;
                case "schema":
                case "element":
                case "complexType":
                case "datatype":
                case "all":
                case "attribute":
                case "extends":
                  break;
                case "row":
                  break;
                default:
                  ae = false;
              }
              break;
            case "SmartTags":
              break;
            default:
              ae = false;
              break;
          }
          if (ae) break;
          if (!l[l.length - 1][1])
            throw "Unrecognized tag: " + f[3] + "|" + l.join("|");
          if (l[l.length - 1][0] === "CustomDocumentProperties") {
            if (f[0].slice(-2) === "/>") break;
            else if (f[1] === "/") Gm(O, f, P, a.slice(F, f.index));
            else {
              P = f;
              F = f.index + f[0].length;
            }
            break;
          }
          if (t.WTF) throw "Unrecognized tag: " + f[3] + "|" + l.join("|");
      }
    var ie = {};
    if (!t.bookSheets && !t.bookProps) ie.Sheets = u;
    ie.SheetNames = d;
    ie.Workbook = G;
    ie.SSF = C.get_table();
    ie.Props = D;
    ie.Custprops = O;
    return ie;
  }
  function qm(e, r) {
    KC((r = r || {}));
    switch (r.type || "base64") {
      case "base64":
        return Jm(u.decode(e), r);
      case "binary":
      case "buffer":
      case "file":
        return Jm(e, r);
      case "array":
        return Jm(e.map(Wm).join(""), r);
    }
  }
  function eC(e, r) {
    var t = [];
    if (e.Props) t.push(Pa(e.Props, r));
    if (e.Custprops) t.push(Na(e.Props, e.Custprops, r));
    return t.join("");
  }
  function rC(e, r) {
    return "";
  }
  function tC(e, r) {
    return "";
  }
  function aC(e, r, t, a) {
    if (!e) return "";
    var n = [];
    if (e["!margins"]) {
      n.push("<PageSetup>");
      if (e["!margins"].header)
        n.push(De("Header", null, { "x:Margin": e["!margins"].header }));
      if (e["!margins"].footer)
        n.push(De("Footer", null, { "x:Margin": e["!margins"].footer }));
      n.push(
        De("PageMargins", null, {
          "x:Bottom": e["!margins"].bottom || "0.75",
          "x:Left": e["!margins"].left || "0.7",
          "x:Right": e["!margins"].right || "0.7",
          "x:Top": e["!margins"].top || "0.75",
        })
      );
      n.push("</PageSetup>");
    }
    if (a && a.Workbook && a.Workbook.Sheets && a.Workbook.Sheets[t]) {
      if (a.Workbook.Sheets[t].Hidden)
        n.push(
          De(
            "Visible",
            a.Workbook.Sheets[t].Hidden == 1
              ? "SheetHidden"
              : "SheetVeryHidden",
            {}
          )
        );
      else {
        for (var i = 0; i < t; ++i)
          if (a.Workbook.Sheets[i] && !a.Workbook.Sheets[i].Hidden) break;
        if (i == t) n.push("<Selected/>");
      }
    }
    if (e["!protect"]) {
      n.push(ye("ProtectContents", "True"));
      if (e["!protect"].objects) n.push(ye("ProtectObjects", "True"));
      if (e["!protect"].scenarios) n.push(ye("ProtectScenarios", "True"));
      if (
        e["!protect"].selectLockedCells != null &&
        !e["!protect"].selectLockedCells
      )
        n.push(ye("EnableSelection", "NoSelection"));
      else if (
        e["!protect"].selectUnlockedCells != null &&
        !e["!protect"].selectUnlockedCells
      )
        n.push(ye("EnableSelection", "UnlockedCells"));
      [
        ["formatColumns", "AllowFormatCells"],
        ["formatRows", "AllowSizeCols"],
        ["formatCells", "AllowSizeRows"],
        ["insertColumns", "AllowInsertCols"],
        ["insertRows", "AllowInsertRows"],
        ["insertHyperlinks", "AllowInsertHyperlinks"],
        ["deleteColumns", "AllowDeleteCols"],
        ["deleteRows", "AllowDeleteRows"],
        ["sort", "AllowSort"],
        ["autoFilter", "AllowFilter"],
        ["pivotTables", "AllowUsePivotTables"],
      ].forEach(function (r) {
        if (e["!protect"][r[0]]) n.push("<" + r[1] + "/>");
      });
    }
    if (n.length == 0) return "";
    return De("WorksheetOptions", n.join(""), { xmlns: Le.x });
  }
  function nC(e) {
    return e
      .map(function (e) {
        var r = me(e.t || "");
        var t = De("ss:Data", r, { xmlns: "http://www.w3.org/TR/REC-html40" });
        return De("Comment", t, { "ss:Author": e.a });
      })
      .join("");
  }
  function iC(e, r, t, a, n, i, s) {
    if (!e || (e.v == undefined && e.f == undefined)) return "<Cell></Cell>";
    var f = {};
    if (e.f) f["ss:Formula"] = "=" + de(mv(e.f, s));
    if (e.F && e.F.substr(0, r.length) == r) {
      var o = Wr(e.F.substr(r.length + 1));
      f["ss:ArrayRange"] =
        "RC:R" +
        (o.r == s.r ? "" : "[" + (o.r - s.r) + "]") +
        "C" +
        (o.c == s.c ? "" : "[" + (o.c - s.c) + "]");
    }
    if (e.l && e.l.Target) {
      f["ss:HRef"] = de(e.l.Target);
      if (e.l.Tooltip) f["x:HRefScreenTip"] = de(e.l.Tooltip);
    }
    if (t["!merges"]) {
      var l = t["!merges"];
      for (var c = 0; c != l.length; ++c) {
        if (l[c].s.c != s.c || l[c].s.r != s.r) continue;
        if (l[c].e.c > l[c].s.c) f["ss:MergeAcross"] = l[c].e.c - l[c].s.c;
        if (l[c].e.r > l[c].s.r) f["ss:MergeDown"] = l[c].e.r - l[c].s.r;
      }
    }
    var h = "",
      u = "";
    switch (e.t) {
      case "z":
        return "";
      case "n":
        h = "Number";
        u = String(e.v);
        break;
      case "b":
        h = "Boolean";
        u = e.v ? "1" : "0";
        break;
      case "e":
        h = "Error";
        u = Bt[e.v];
        break;
      case "d":
        h = "DateTime";
        u = new Date(e.v).toISOString();
        break;
      case "s":
        h = "String";
        u = de(e.v || "");
        break;
    }
    var d = e.v != null ? u : "";
    if (
      a &&
      a.type == "binary" &&
      typeof cptable !== "undefined" &&
      e.t == "s"
    ) {
      d = cptable.utils.encode(65001, d);
      var v = "";
      for (var p = 0; p < d.length; ++p) v += String.fromCharCode(d[p]);
      d = v;
    }
    var g = '<Data ss:Type="' + h + '">' + d + "</Data>";
    if ((e.c || []).length > 0) g += nC(e.c);
    return De("Cell", g, f);
  }
  function sC(e, r) {
    var t = '<Row ss:Index="' + (e + 1) + '"';
    if (r) {
      if (r.hpt && !r.hpx) r.hpx = Xu(r.hpt);
      if (r.hpx) t += ' ss:AutoFitHeight="0" ss:Height="' + r.hpx + '"';
      if (r.hidden) t += ' ss:Hidden="1"';
    }
    return t + ">";
  }
  function fC(e, r, t, a) {
    if (!e["!ref"]) return "";
    var n = Kr(e["!ref"]);
    var i = e["!merges"] || [],
      s = 0;
    var f = [];
    if (e["!cols"])
      e["!cols"].forEach(function (e, r) {
        Hu(e);
        var t = !!e.width;
        var a = gg(r, e);
        var n = { "ss:Index": r + 1 };
        if (t) n["ss:Width"] = Du(a.width);
        if (e.hidden) n["ss:Hidden"] = "1";
        f.push(De("Column", null, n));
      });
    var o = Array.isArray(e);
    for (var l = n.s.r; l <= n.e.r; ++l) {
      var c = [sC(l, (e["!rows"] || [])[l])];
      for (var h = n.s.c; h <= n.e.c; ++h) {
        var u = false;
        for (s = 0; s != i.length; ++s) {
          if (i[s].s.c > h) continue;
          if (i[s].s.r > l) continue;
          if (i[s].e.c < h) continue;
          if (i[s].e.r < l) continue;
          if (i[s].s.c != h || i[s].s.r != l) u = true;
          break;
        }
        if (u) continue;
        var d = { r: l, c: h };
        var v = Vr(d),
          p = o ? (e[l] || [])[h] : e[v];
        c.push(iC(p, v, e, r, t, a, d));
      }
      c.push("</Row>");
      if (c.length > 2) f.push(c.join(""));
    }
    return f.join("");
  }
  function oC(e, r, t) {
    var a = [];
    var n = t.SheetNames[e];
    var i = t.Sheets[n];
    var s = i ? fC(i, r, e, t) : "";
    if (s.length > 0) a.push("<Table>" + s + "</Table>");
    a.push(aC(i, r, e, t));
    return a.join("");
  }
  function lC(e, r) {
    var t = [];
    t.push(eC(e, r));
    t.push(rC(e, r));
    t.push(tC(e, r));
    for (var a = 0; a < e.SheetNames.length; ++a)
      t.push(De("Worksheet", oC(a, r, e), { "ss:Name": de(e.SheetNames[a]) }));
    return (
      Pe +
      De("Workbook", t.join(""), {
        xmlns: Le.ss,
        "xmlns:o": Le.o,
        "xmlns:x": Le.x,
        "xmlns:ss": Le.ss,
        "xmlns:dt": Le.dt,
        "xmlns:html": Le.html,
      })
    );
  }
  function cC(e) {
    var r = {};
    var t = e.content;
    var a = 28,
      n;
    n = Ye(t, a);
    a += 4 + or(t, a);
    r.UserType = n;
    n = or(t, a);
    a += 4;
    switch (n) {
      case 0:
        break;
      case 4294967295:
      case 4294967294:
        a += 4;
        break;
      default:
        if (n > 400)
          throw new Error("Unsupported Clipboard: " + n.toString(16));
        a += n;
    }
    n = Ye(t, a);
    a += n.length === 0 ? 0 : 5 + n.length;
    r.Reserved1 = n;
    if ((n = or(t, a)) !== 1907550708) return r;
    throw new Error("Unsupported Unicode Extension");
  }
  function hC(e, r, t, a) {
    var n = t;
    var i = [];
    var s = r.slice(r.l, r.l + n);
    if (a && a.enc && a.enc.insitu_decrypt)
      switch (e.n) {
        case "BOF":
        case "FilePass":
        case "FileLock":
        case "InterfaceHdr":
        case "RRDInfo":
        case "RRDHead":
        case "UsrExcl":
          break;
        default:
          if (s.length === 0) break;
          a.enc.insitu_decrypt(s);
      }
    i.push(s);
    r.l += n;
    var f = CC[sr(r, r.l)];
    var o = 0;
    while (f != null && f.n.slice(0, 8) === "Continue") {
      n = sr(r, r.l + 2);
      o = r.l + 4;
      if (f.n == "ContinueFrt") o += 4;
      else if (f.n.slice(0, 11) == "ContinueFrt") o += 12;
      i.push(r.slice(o, r.l + 4 + n));
      r.l += 4 + n;
      f = CC[sr(r, r.l)];
    }
    var l = g(i);
    mr(l, 0);
    var c = 0;
    l.lens = [];
    for (var h = 0; h < i.length; ++h) {
      l.lens.push(c);
      c += i[h].length;
    }
    return e.f(l, l.length, a);
  }
  function uC(e, r, t) {
    if (e.t === "z") return;
    if (!e.XF) return;
    var a = 0;
    try {
      a = e.z || e.XF.numFmtId || 0;
      if (r.cellNF) e.z = C._table[a];
    } catch (n) {
      if (r.WTF) throw n;
    }
    if (!r || r.cellText !== false)
      try {
        if (e.t === "e") {
          e.w = e.w || Bt[e.v];
        } else if (a === 0 || a == "General") {
          if (e.t === "n") {
            if ((e.v | 0) === e.v) e.w = C._general_int(e.v);
            else e.w = C._general_num(e.v);
          } else e.w = C._general(e.v);
        } else e.w = C.format(a, e.v, { date1904: !!t });
        if (
          r.cellDates &&
          a &&
          e.t == "n" &&
          C.is_date(C._table[a] || String(a))
        ) {
          var i = C.parse_date_code(e.v);
          if (i) {
            e.t = "d";
            e.v = new Date(i.y, i.m - 1, i.d, i.H, i.M, i.S, i.u);
          }
        }
      } catch (n) {
        if (r.WTF) throw n;
      }
  }
  function dC(e, r, t) {
    return { v: e, ixfe: r, t: t };
  }
  function vC(e, r) {
    var t = { opts: {} };
    var a = {};
    if (c != null && r.dense == null) r.dense = c;
    var i = r.dense ? [] : {};
    var s = {};
    var f = false;
    var o = {};
    var l = null;
    var h = [];
    var u = "";
    var d = {};
    var v,
      p = "",
      g,
      b,
      m,
      E,
      k;
    var S = {};
    var w = [];
    var A;
    var B;
    var _ = true;
    var T = [];
    var x = [];
    var I = { Sheets: [], WBProps: { date1904: false } },
      y = {};
    var R = function me(e) {
      if (e < 8) return Zt[e];
      if (e < 64) return x[e - 8] || Zt[e];
      return Zt[e];
    };
    var D = function Ce(e, r, t) {
      var a = r.XF.data;
      if (!a || !a.patternType || !t || !t.cellStyles) return;
      r.s = {};
      r.s.patternType = a.patternType;
      var n;
      if ((n = Au(R(a.icvFore)))) {
        r.s.fgColor = { rgb: n };
      }
      if ((n = Au(R(a.icvBack)))) {
        r.s.bgColor = { rgb: n };
      }
    };
    var O = function Ee(e, r, t) {
      if (X > 1) return;
      if (!_) return;
      if (t.cellStyles && r.XF && r.XF.data) D(e, r, t);
      v = e;
      p = Vr(e);
      if (o.s) {
        if (e.r < o.s.r) o.s.r = e.r;
        if (e.c < o.s.c) o.s.c = e.c;
      }
      if (o.e) {
        if (e.r + 1 > o.e.r) o.e.r = e.r + 1;
        if (e.c + 1 > o.e.c) o.e.c = e.c + 1;
      }
      if (t.cellFormula && r.f) {
        for (var a = 0; a < w.length; ++a) {
          if (w[a][0].s.c > e.c) continue;
          if (w[a][0].s.r > e.r) continue;
          if (w[a][0].e.c < e.c) continue;
          if (w[a][0].e.r < e.r) continue;
          r.F = jr(w[a][0]);
          if (w[a][0].s.c != e.c) delete r.f;
          if (w[a][0].s.r != e.r) delete r.f;
          if (r.f) r.f = "" + qp(w[a][1], o, e, V, F);
          break;
        }
      }
      if (t.sheetRows && v.r >= t.sheetRows) _ = false;
      else {
        if (t.dense) {
          if (!i[e.r]) i[e.r] = [];
          i[e.r][e.c] = r;
        } else i[p] = r;
      }
    };
    var F = {
      enc: false,
      sbcch: 0,
      snames: [],
      sharedf: S,
      arrayf: w,
      rrtabid: [],
      lastuser: "",
      biff: 8,
      codepage: 0,
      winlocked: 0,
      cellStyles: !!r && !!r.cellStyles,
      WTF: !!r && !!r.wtf,
    };
    if (r.password) F.password = r.password;
    var P = [];
    var N = [];
    var L = [],
      M = [];
    var U = 0,
      H = 0;
    var W = false;
    var V = [];
    V.SheetNames = F.snames;
    V.sharedf = F.sharedf;
    V.arrayf = F.arrayf;
    V.names = [];
    V.XTI = [];
    var z = "";
    var X = 0;
    var G = 0;
    var j = [];
    var K = [];
    var Y;
    F.codepage = 1200;
    n(1200);
    while (e.l < e.length - 1) {
      var $ = e.l;
      var Z = e.read_shift(2);
      if (Z === 0 && z === "EOF") break;
      var Q = e.l === e.length ? 0 : e.read_shift(2),
        J;
      var q = CC[Z];
      if (q && q.f) {
        if (r.bookSheets) {
          if (z === "BoundSheet8" && q.n !== "BoundSheet8") break;
        }
        z = q.n;
        if (q.r === 2 || q.r == 12) {
          var ee = e.read_shift(2);
          Q -= 2;
          if (!F.enc && ee !== Z)
            throw new Error("rt mismatch: " + ee + "!=" + Z);
          if (q.r == 12) {
            e.l += 10;
            Q -= 10;
          }
        }
        var re;
        if (q.n === "EOF") re = q.f(e, Q, F);
        else re = hC(q, e, Q, F);
        var te = q.n;
        switch (te) {
          case "Date1904":
            t.opts.Date1904 = I.WBProps.date1904 = re;
            break;
          case "WriteProtect":
            t.opts.WriteProtect = true;
            break;
          case "FilePass":
            if (!F.enc) e.l = 0;
            F.enc = re;
            if (F.WTF) console.error(re);
            if (!r.password) throw new Error("File is password-protected");
            if (re.valid == null)
              throw new Error("Encryption scheme unsupported");
            if (!re.valid) throw new Error("Password is incorrect");
            break;
          case "WriteAccess":
            F.lastuser = re;
            break;
          case "FileSharing":
            break;
          case "CodePage":
            if (re === 21010) re = 1200;
            else if (re === 32769) re = 1252;
            F.codepage = re;
            n(re);
            break;
          case "RRTabId":
            F.rrtabid = re;
            break;
          case "WinProtect":
            F.winlocked = re;
            break;
          case "Template":
            break;
          case "RefreshAll":
            t.opts.RefreshAll = re;
            break;
          case "BookBool":
            break;
          case "UsesELFs":
            break;
          case "MTRSettings":
            break;
          case "CalcCount":
            t.opts.CalcCount = re;
            break;
          case "CalcDelta":
            t.opts.CalcDelta = re;
            break;
          case "CalcIter":
            t.opts.CalcIter = re;
            break;
          case "CalcMode":
            t.opts.CalcMode = re;
            break;
          case "CalcPrecision":
            t.opts.CalcPrecision = re;
            break;
          case "CalcSaveRecalc":
            t.opts.CalcSaveRecalc = re;
            break;
          case "CalcRefMode":
            F.CalcRefMode = re;
            break;
          case "Uncalced":
            break;
          case "ForceFullCalculation":
            t.opts.FullCalc = re;
            break;
          case "WsBool":
            break;
          case "XF":
            T.push(re);
            break;
          case "ExtSST":
            break;
          case "BookExt":
            break;
          case "RichTextStream":
            break;
          case "BkHim":
            break;
          case "SupBook":
            V.push([re]);
            V[V.length - 1].XTI = [];
            break;
          case "ExternName":
            V[V.length - 1].push(re);
            break;
          case "Index":
            break;
          case "Lbl":
            Y = { Name: re.Name, Ref: qp(re.rgce, o, null, V, F) };
            if (re.itab > 0) Y.Sheet = re.itab - 1;
            V.names.push(Y);
            if (!V[0]) V[0] = [];
            V[V.length - 1].push(re);
            if (re.Name == "_xlnm._FilterDatabase" && re.itab > 0)
              if (
                re.rgce &&
                re.rgce[0] &&
                re.rgce[0][0] &&
                re.rgce[0][0][0] == "PtgArea3d"
              )
                K[re.itab - 1] = { ref: jr(re.rgce[0][0][1][2]) };
            break;
          case "ExternCount":
            F.ExternCount = re;
            break;
          case "ExternSheet":
            if (V.length == 0) {
              V[0] = [];
              V[0].XTI = [];
            }
            V[V.length - 1].XTI = V[V.length - 1].XTI.concat(re);
            V.XTI = V.XTI.concat(re);
            break;
          case "NameCmt":
            if (F.biff < 8) break;
            if (Y != null) Y.Comment = re[1];
            break;
          case "Protect":
            i["!protect"] = re;
            break;
          case "Password":
            if (re !== 0 && F.WTF) console.error("Password verifier: " + re);
            break;
          case "Prot4Rev":
          case "Prot4RevPass":
            break;
          case "BoundSheet8":
            {
              s[re.pos] = re;
              F.snames.push(re.name);
            }
            break;
          case "EOF":
            {
              if (--X) break;
              if (o.e) {
                if (o.e.r > 0 && o.e.c > 0) {
                  o.e.r--;
                  o.e.c--;
                  i["!ref"] = jr(o);
                  o.e.r++;
                  o.e.c++;
                }
                if (P.length > 0) i["!merges"] = P;
                if (N.length > 0) i["!objects"] = N;
                if (L.length > 0) i["!cols"] = L;
                if (M.length > 0) i["!rows"] = M;
                I.Sheets.push(y);
              }
              if (u === "") d = i;
              else a[u] = i;
              i = r.dense ? [] : {};
            }
            break;
          case "BOF":
            {
              if (F.biff !== 8) {
              } else if (Z === 9) F.biff = 2;
              else if (Z === 521) F.biff = 3;
              else if (Z === 1033) F.biff = 4;
              else if (re.BIFFVer === 1280) F.biff = 5;
              else if (re.BIFFVer === 1536) F.biff = 8;
              else if (re.BIFFVer === 2) F.biff = 2;
              else if (re.BIFFVer === 7) F.biff = 2;
              if (X++) break;
              _ = true;
              i = r.dense ? [] : {};
              if (F.biff < 5) {
                if (u === "") u = "Sheet1";
                o = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
                var ae = { pos: e.l - Q, name: u };
                s[ae.pos] = ae;
                F.snames.push(u);
              } else u = (s[$] || { name: "" }).name;
              if (re.dt == 32) i["!type"] = "chart";
              P = [];
              N = [];
              w = [];
              F.arrayf = w;
              L = [];
              M = [];
              U = H = 0;
              W = false;
              y = { Hidden: (s[$] || { hs: 0 }).hs, name: u };
            }
            break;
          case "Number":
          case "BIFF2NUM":
          case "BIFF2INT":
            {
              if (i["!type"] == "chart")
                if (
                  r.dense ? (i[re.r] || [])[re.c] : i[Vr({ c: re.c, r: re.r })]
                )
                  ++re.c;
              A = { ixfe: re.ixfe, XF: T[re.ixfe] || {}, v: re.val, t: "n" };
              if (G > 0) A.z = j[(A.ixfe >> 8) & 31];
              uC(A, r, t.opts.Date1904);
              O({ c: re.c, r: re.r }, A, r);
            }
            break;
          case "BoolErr":
            {
              A = { ixfe: re.ixfe, XF: T[re.ixfe], v: re.val, t: re.t };
              if (G > 0) A.z = j[(A.ixfe >> 8) & 31];
              uC(A, r, t.opts.Date1904);
              O({ c: re.c, r: re.r }, A, r);
            }
            break;
          case "RK":
            {
              A = { ixfe: re.ixfe, XF: T[re.ixfe], v: re.rknum, t: "n" };
              if (G > 0) A.z = j[(A.ixfe >> 8) & 31];
              uC(A, r, t.opts.Date1904);
              O({ c: re.c, r: re.r }, A, r);
            }
            break;
          case "MulRk":
            {
              for (var ne = re.c; ne <= re.C; ++ne) {
                var ie = re.rkrec[ne - re.c][0];
                A = { ixfe: ie, XF: T[ie], v: re.rkrec[ne - re.c][1], t: "n" };
                if (G > 0) A.z = j[(A.ixfe >> 8) & 31];
                uC(A, r, t.opts.Date1904);
                O({ c: ne, r: re.r }, A, r);
              }
            }
            break;
          case "Formula":
            {
              if (re.val == "String") {
                l = re;
                break;
              }
              A = dC(re.val, re.cell.ixfe, re.tt);
              A.XF = T[A.ixfe];
              if (r.cellFormula) {
                var se = re.formula;
                if (se && se[0] && se[0][0] && se[0][0][0] == "PtgExp") {
                  var fe = se[0][0][1][0],
                    oe = se[0][0][1][1];
                  var le = Vr({ r: fe, c: oe });
                  if (S[le]) A.f = "" + qp(re.formula, o, re.cell, V, F);
                  else A.F = ((r.dense ? (i[fe] || [])[oe] : i[le]) || {}).F;
                } else A.f = "" + qp(re.formula, o, re.cell, V, F);
              }
              if (G > 0) A.z = j[(A.ixfe >> 8) & 31];
              uC(A, r, t.opts.Date1904);
              O(re.cell, A, r);
              l = re;
            }
            break;
          case "String":
            {
              if (l) {
                l.val = re;
                A = dC(re, l.cell.ixfe, "s");
                A.XF = T[A.ixfe];
                if (r.cellFormula) {
                  A.f = "" + qp(l.formula, o, l.cell, V, F);
                }
                if (G > 0) A.z = j[(A.ixfe >> 8) & 31];
                uC(A, r, t.opts.Date1904);
                O(l.cell, A, r);
                l = null;
              } else throw new Error("String record expects Formula");
            }
            break;
          case "Array":
            {
              w.push(re);
              var ce = Vr(re[0].s);
              g = r.dense ? (i[re[0].s.r] || [])[re[0].s.c] : i[ce];
              if (r.cellFormula && g) {
                if (!l) break;
                if (!ce || !g) break;
                g.f = "" + qp(re[1], o, re[0], V, F);
                g.F = jr(re[0]);
              }
            }
            break;
          case "ShrFmla":
            {
              if (!_) break;
              if (!r.cellFormula) break;
              if (p) {
                if (!l) break;
                S[Vr(l.cell)] = re[0];
                g = r.dense ? (i[l.cell.r] || [])[l.cell.c] : i[Vr(l.cell)];
                (g || {}).f = "" + qp(re[0], o, v, V, F);
              }
            }
            break;
          case "LabelSst":
            A = dC(h[re.isst].t, re.ixfe, "s");
            A.XF = T[A.ixfe];
            if (G > 0) A.z = j[(A.ixfe >> 8) & 31];
            uC(A, r, t.opts.Date1904);
            O({ c: re.c, r: re.r }, A, r);
            break;
          case "Blank":
            if (r.sheetStubs) {
              A = { ixfe: re.ixfe, XF: T[re.ixfe], t: "z" };
              if (G > 0) A.z = j[(A.ixfe >> 8) & 31];
              uC(A, r, t.opts.Date1904);
              O({ c: re.c, r: re.r }, A, r);
            }
            break;
          case "MulBlank":
            if (r.sheetStubs) {
              for (var he = re.c; he <= re.C; ++he) {
                var ue = re.ixfe[he - re.c];
                A = { ixfe: ue, XF: T[ue], t: "z" };
                if (G > 0) A.z = j[(A.ixfe >> 8) & 31];
                uC(A, r, t.opts.Date1904);
                O({ c: he, r: re.r }, A, r);
              }
            }
            break;
          case "RString":
          case "Label":
          case "BIFF2STR":
            A = dC(re.val, re.ixfe, "s");
            A.XF = T[A.ixfe];
            if (G > 0) A.z = j[(A.ixfe >> 8) & 31];
            uC(A, r, t.opts.Date1904);
            O({ c: re.c, r: re.r }, A, r);
            break;
          case "Dimensions":
            {
              if (X === 1) o = re;
            }
            break;
          case "SST":
            {
              h = re;
            }
            break;
          case "Format":
            {
              C.load(re[1], re[0]);
            }
            break;
          case "BIFF2FORMAT":
            {
              j[G++] = re;
              for (var de = 0; de < G + 163; ++de)
                if (C._table[de] == re) break;
              if (de >= 163) C.load(re, G + 163);
            }
            break;
          case "MergeCells":
            P = P.concat(re);
            break;
          case "Obj":
            N[re.cmo[0]] = F.lastobj = re;
            break;
          case "TxO":
            F.lastobj.TxO = re;
            break;
          case "ImData":
            F.lastobj.ImData = re;
            break;
          case "HLink":
            {
              for (k = re[0].s.r; k <= re[0].e.r; ++k)
                for (E = re[0].s.c; E <= re[0].e.c; ++E) {
                  g = r.dense ? (i[k] || [])[E] : i[Vr({ c: E, r: k })];
                  if (g) g.l = re[1];
                }
            }
            break;
          case "HLinkTooltip":
            {
              for (k = re[0].s.r; k <= re[0].e.r; ++k)
                for (E = re[0].s.c; E <= re[0].e.c; ++E) {
                  g = r.dense ? (i[k] || [])[E] : i[Vr({ c: E, r: k })];
                  if (g) g.l.Tooltip = re[1];
                }
            }
            break;
          case "Note":
            {
              if (F.biff <= 5 && F.biff >= 2) break;
              g = r.dense ? (i[re[0].r] || [])[re[0].c] : i[Vr(re[0])];
              var ve = N[re[2]];
              if (!g) break;
              if (!g.c) g.c = [];
              b = { a: re[1], t: ve.TxO.t };
              g.c.push(b);
            }
            break;
          default:
            switch (q.n) {
              case "ClrtClient":
                break;
              case "XFExt":
                jd(T[re.ixfe], re.ext);
                break;
              case "DefColWidth":
                U = re;
                break;
              case "DefaultRowHeight":
                H = re[1];
                break;
              case "ColInfo":
                {
                  if (!F.cellStyles) break;
                  while (re.e >= re.s) {
                    L[re.e--] = { width: re.w / 256 };
                    if (!W) {
                      W = true;
                      Mu(re.w / 256);
                    }
                    Hu(L[re.e + 1]);
                  }
                }
                break;
              case "Row":
                {
                  var pe = {};
                  if (re.level != null) {
                    M[re.r] = pe;
                    pe.level = re.level;
                  }
                  if (re.hidden) {
                    M[re.r] = pe;
                    pe.hidden = true;
                  }
                  if (re.hpt) {
                    M[re.r] = pe;
                    pe.hpt = re.hpt;
                    pe.hpx = Xu(re.hpt);
                  }
                }
                break;
              case "LeftMargin":
              case "RightMargin":
              case "TopMargin":
              case "BottomMargin":
                if (!i["!margins"]) bg((i["!margins"] = {}));
                i["!margins"][te.slice(0, -6).toLowerCase()] = re;
                break;
              case "Setup":
                if (!i["!margins"]) bg((i["!margins"] = {}));
                i["!margins"].header = re.header;
                i["!margins"].footer = re.footer;
                break;
              case "Header":
                break;
              case "Footer":
                break;
              case "HCenter":
                break;
              case "VCenter":
                break;
              case "Pls":
                break;
              case "GCW":
                break;
              case "LHRecord":
                break;
              case "DBCell":
                break;
              case "EntExU2":
                break;
              case "SxView":
                break;
              case "Sxvd":
                break;
              case "SXVI":
                break;
              case "SXVDEx":
                break;
              case "SxIvd":
                break;
              case "SXString":
                break;
              case "Sync":
                break;
              case "Addin":
                break;
              case "SXDI":
                break;
              case "SXLI":
                break;
              case "SXEx":
                break;
              case "QsiSXTag":
                break;
              case "Selection":
                break;
              case "Feat":
                break;
              case "FeatHdr":
              case "FeatHdr11":
                break;
              case "Feature11":
              case "Feature12":
              case "List12":
                break;
              case "Country":
                B = re;
                break;
              case "RecalcId":
                break;
              case "DxGCol":
                break;
              case "Fbi":
              case "Fbi2":
              case "GelFrame":
                break;
              case "Font":
                break;
              case "XFCRC":
                break;
              case "Style":
                break;
              case "StyleExt":
                break;
              case "Palette":
                x = re;
                break;
              case "Theme":
                break;
              case "ScenarioProtect":
                break;
              case "ObjProtect":
                break;
              case "CondFmt12":
                break;
              case "Table":
                break;
              case "TableStyles":
                break;
              case "TableStyle":
                break;
              case "TableStyleElement":
                break;
              case "SXStreamID":
                break;
              case "SXVS":
                break;
              case "DConRef":
                break;
              case "SXAddl":
                break;
              case "DConBin":
                break;
              case "DConName":
                break;
              case "SXPI":
                break;
              case "SxFormat":
                break;
              case "SxSelect":
                break;
              case "SxRule":
                break;
              case "SxFilt":
                break;
              case "SxItm":
                break;
              case "SxDXF":
                break;
              case "ScenMan":
                break;
              case "DCon":
                break;
              case "CellWatch":
                break;
              case "PrintRowCol":
                break;
              case "PrintGrid":
                break;
              case "PrintSize":
                break;
              case "XCT":
                break;
              case "CRN":
                break;
              case "Scl":
                {
                }
                break;
              case "SheetExt":
                {
                }
                break;
              case "SheetExtOptional":
                {
                }
                break;
              case "ObNoMacros":
                {
                }
                break;
              case "ObProj":
                {
                }
                break;
              case "CodeName":
                {
                }
                break;
              case "GUIDTypeLib":
                {
                }
                break;
              case "WOpt":
                break;
              case "PhoneticInfo":
                break;
              case "OleObjectSize":
                break;
              case "DXF":
              case "DXFN":
              case "DXFN12":
              case "DXFN12List":
              case "DXFN12NoCB":
                break;
              case "Dv":
              case "DVal":
                break;
              case "BRAI":
              case "Series":
              case "SeriesText":
                break;
              case "DConn":
                break;
              case "DbOrParamQry":
                break;
              case "DBQueryExt":
                break;
              case "OleDbConn":
                break;
              case "ExtString":
                break;
              case "IFmtRecord":
                break;
              case "CondFmt":
              case "CF":
              case "CF12":
              case "CFEx":
                break;
              case "Excel9File":
                break;
              case "Units":
                break;
              case "InterfaceHdr":
              case "Mms":
              case "InterfaceEnd":
              case "DSF":
              case "BuiltInFnGroupCount":
                break;
              case "Window1":
              case "Window2":
              case "HideObj":
              case "GridSet":
              case "Guts":
              case "UserBView":
              case "UserSViewBegin":
              case "UserSViewEnd":
              case "Pane":
                break;
              default:
                switch (q.n) {
                  case "Dat":
                  case "Begin":
                  case "End":
                  case "StartBlock":
                  case "EndBlock":
                  case "Frame":
                  case "Area":
                  case "Axis":
                  case "AxisLine":
                  case "Tick":
                    break;
                  case "AxesUsed":
                  case "CrtLayout12":
                  case "CrtLayout12A":
                  case "CrtLink":
                  case "CrtLine":
                  case "CrtMlFrt":
                  case "CrtMlFrtContinue":
                    break;
                  case "LineFormat":
                  case "AreaFormat":
                  case "Chart":
                  case "Chart3d":
                  case "Chart3DBarShape":
                  case "ChartFormat":
                  case "ChartFrtInfo":
                    break;
                  case "PlotArea":
                  case "PlotGrowth":
                    break;
                  case "SeriesList":
                  case "SerParent":
                  case "SerAuxTrend":
                    break;
                  case "DataFormat":
                  case "SerToCrt":
                  case "FontX":
                    break;
                  case "CatSerRange":
                  case "AxcExt":
                  case "SerFmt":
                    break;
                  case "ShtProps":
                    break;
                  case "DefaultText":
                  case "Text":
                  case "CatLab":
                    break;
                  case "DataLabExtContents":
                    break;
                  case "Legend":
                  case "LegendException":
                    break;
                  case "Pie":
                  case "Scatter":
                    break;
                  case "PieFormat":
                  case "MarkerFormat":
                    break;
                  case "StartObject":
                  case "EndObject":
                    break;
                  case "AlRuns":
                  case "ObjectLink":
                    break;
                  case "SIIndex":
                    break;
                  case "AttachedLabel":
                  case "YMult":
                    break;
                  case "Line":
                  case "Bar":
                    break;
                  case "Surf":
                    break;
                  case "AxisParent":
                    break;
                  case "Pos":
                    break;
                  case "ValueRange":
                    break;
                  case "SXViewEx9":
                    break;
                  case "SXViewLink":
                    break;
                  case "PivotChartBits":
                    break;
                  case "SBaseRef":
                    break;
                  case "TextPropsStream":
                    break;
                  case "LnExt":
                    break;
                  case "MkrExt":
                    break;
                  case "CrtCoopt":
                    break;
                  case "Qsi":
                  case "Qsif":
                  case "Qsir":
                  case "QsiSXTag":
                    break;
                  case "TxtQry":
                    break;
                  case "FilterMode":
                    break;
                  case "AutoFilter":
                  case "AutoFilterInfo":
                    break;
                  case "AutoFilter12":
                    break;
                  case "DropDownObjIds":
                    break;
                  case "Sort":
                    break;
                  case "SortData":
                    break;
                  case "ShapePropsStream":
                    break;
                  case "MsoDrawing":
                  case "MsoDrawingGroup":
                  case "MsoDrawingSelection":
                    break;
                  case "WebPub":
                  case "AutoWebPub":
                    break;
                  case "HeaderFooter":
                  case "HFPicture":
                  case "PLV":
                  case "HorizontalPageBreaks":
                  case "VerticalPageBreaks":
                    break;
                  case "Backup":
                  case "CompressPictures":
                  case "Compat12":
                    break;
                  case "Continue":
                  case "ContinueFrt12":
                    break;
                  case "FrtFontList":
                  case "FrtWrapper":
                    break;
                  default:
                    switch (q.n) {
                      case "TabIdConf":
                      case "Radar":
                      case "RadarArea":
                      case "DropBar":
                      case "Intl":
                      case "CoordList":
                      case "SerAuxErrBar":
                        break;
                      case "BIFF2FONTCLR":
                      case "BIFF2FMTCNT":
                      case "BIFF2FONTXTRA":
                        break;
                      case "BIFF2XF":
                      case "BIFF3XF":
                      case "BIFF4XF":
                        break;
                      case "BIFF4FMTCNT":
                      case "BIFF2ROW":
                      case "BIFF2WINDOW2":
                        break;
                      case "SCENARIO":
                      case "DConBin":
                      case "PicF":
                      case "DataLabExt":
                      case "Lel":
                      case "BopPop":
                      case "BopPopCustom":
                      case "RealTimeData":
                      case "Name":
                        break;
                      case "LHNGraph":
                      case "FnGroupName":
                      case "AddMenu":
                      case "LPr":
                        break;
                      case "ListObj":
                      case "ListField":
                        break;
                      case "RRSort":
                        break;
                      case "BigName":
                        break;
                      default:
                        if (r.WTF) throw "Unrecognized Record " + q.n;
                    }
                }
            }
        }
      } else e.l += Q;
    }
    var ge = Object.keys(s)
      .sort(function (e, r) {
        return Number(e) - Number(r);
      })
      .map(function (e) {
        return s[e].name;
      });
    var be = ge.slice();
    t.Directory = ge;
    t.SheetNames = ge;
    if (!r.bookSheets) t.Sheets = a;
    if (t.Sheets)
      K.forEach(function (e, r) {
        t.Sheets[t.SheetNames[r]]["!autofilter"] = e;
      });
    t.Preamble = d;
    t.Strings = h;
    t.SSF = C.get_table();
    if (F.enc) t.Encryption = F.enc;
    t.Metadata = {};
    if (B !== undefined) t.Metadata.Country = B;
    if (V.names.length > 0) I.Names = V.names;
    t.Workbook = I;
    return t;
  }
  function pC(e) {
    var r = e.find("!DocumentSummaryInformation");
    if (r)
      try {
        e.DocSummary = en(r, Xt);
      } catch (t) {}
    var a = e.find("!SummaryInformation");
    if (a)
      try {
        e.Summary = en(a, Gt);
      } catch (t) {}
  }
  function gC(e, r) {
    if (!r) r = {};
    KC(r);
    a();
    var t, n, i;
    if (e.FullPaths) {
      t = e.find("!CompObj");
      n = e.find("!SummaryInformation");
      i = e.find("/Workbook");
    } else {
      mr(e, 0);
      i = { content: e };
    }
    if (!i) i = e.find("/Book");
    var s, f, o;
    if (t) s = cC(t);
    if (r.bookProps && !r.bookSheets) o = {};
    else {
      if (i) o = vC(i.content, r);
      else if (e.find("PerfectOffice_MAIN"))
        o = Nh.to_workbook(e.find("PerfectOffice_MAIN").content, r);
      else if (e.find("NativeContent_MAIN"))
        o = Nh.to_workbook(e.find("NativeContent_MAIN").content, r);
      else throw new Error("Cannot find Workbook stream");
    }
    if (e.FullPaths) pC(e);
    var l = {};
    for (var c in e.Summary) l[c] = e.Summary[c];
    for (c in e.DocSummary) l[c] = e.DocSummary[c];
    o.Props = o.Custprops = l;
    if (r.bookFiles) o.cfb = e;
    return o;
  }
  var bC = {
    0: { n: "BrtRowHdr", f: Xg },
    1: { n: "BrtCellBlank", f: Jg },
    2: { n: "BrtCellRk", f: fb },
    3: { n: "BrtCellError", f: tb },
    4: { n: "BrtCellBool", f: eb },
    5: { n: "BrtCellReal", f: ib },
    6: { n: "BrtCellSt", f: lb },
    7: { n: "BrtCellIsst", f: ab },
    8: { n: "BrtFmlaString", f: vb },
    9: { n: "BrtFmlaNum", f: db },
    10: { n: "BrtFmlaBool", f: hb },
    11: { n: "BrtFmlaError", f: ub },
    16: { n: "BrtFRTArchID$", f: dm },
    19: { n: "BrtSSTItem", f: at },
    20: { n: "BrtPCDIMissing", f: Cr },
    21: { n: "BrtPCDINumber", f: Cr },
    22: { n: "BrtPCDIBoolean", f: Cr },
    23: { n: "BrtPCDIError", f: Cr },
    24: { n: "BrtPCDIString", f: Cr },
    25: { n: "BrtPCDIDatetime", f: Cr },
    26: { n: "BrtPCDIIndex", f: Cr },
    27: { n: "BrtPCDIAMissing", f: Cr },
    28: { n: "BrtPCDIANumber", f: Cr },
    29: { n: "BrtPCDIABoolean", f: Cr },
    30: { n: "BrtPCDIAError", f: Cr },
    31: { n: "BrtPCDIAString", f: Cr },
    32: { n: "BrtPCDIADatetime", f: Cr },
    33: { n: "BrtPCRRecord", f: Cr },
    34: { n: "BrtPCRRecordDt", f: Cr },
    35: { n: "BrtFRTBegin", f: Cr },
    36: { n: "BrtFRTEnd", f: Cr },
    37: { n: "BrtACBegin", f: Cr },
    38: { n: "BrtACEnd", f: Cr },
    39: { n: "BrtName", f: vm },
    40: { n: "BrtIndexRowBlock", f: Cr },
    42: { n: "BrtIndexBlock", f: Cr },
    43: { n: "BrtFont", f: sd },
    44: { n: "BrtFmt", f: nd },
    45: { n: "BrtFill", f: Cr },
    46: { n: "BrtBorder", f: Cr },
    47: { n: "BrtXF", f: hd },
    48: { n: "BrtStyle", f: Cr },
    49: { n: "BrtCellMeta", f: Cr },
    50: { n: "BrtValueMeta", f: Cr },
    51: { n: "BrtMdb", f: Cr },
    52: { n: "BrtBeginFmd", f: Cr },
    53: { n: "BrtEndFmd", f: Cr },
    54: { n: "BrtBeginMdx", f: Cr },
    55: { n: "BrtEndMdx", f: Cr },
    56: { n: "BrtBeginMdxTuple", f: Cr },
    57: { n: "BrtEndMdxTuple", f: Cr },
    58: { n: "BrtMdxMbrIstr", f: Cr },
    59: { n: "BrtStr", f: Cr },
    60: { n: "BrtColInfo", f: Mi },
    62: { n: "BrtCellRString", f: Cr },
    63: { n: "BrtCalcChainItem$", f: $d },
    64: { n: "BrtDVal", f: Cr },
    65: { n: "BrtSxvcellNum", f: Cr },
    66: { n: "BrtSxvcellStr", f: Cr },
    67: { n: "BrtSxvcellBool", f: Cr },
    68: { n: "BrtSxvcellErr", f: Cr },
    69: { n: "BrtSxvcellDate", f: Cr },
    70: { n: "BrtSxvcellNil", f: Cr },
    128: { n: "BrtFileVersion", f: Cr },
    129: { n: "BrtBeginSheet", f: Cr },
    130: { n: "BrtEndSheet", f: Cr },
    131: { n: "BrtBeginBook", f: Cr, p: 0 },
    132: { n: "BrtEndBook", f: Cr },
    133: { n: "BrtBeginWsViews", f: Cr },
    134: { n: "BrtEndWsViews", f: Cr },
    135: { n: "BrtBeginBookViews", f: Cr },
    136: { n: "BrtEndBookViews", f: Cr },
    137: { n: "BrtBeginWsView", f: Cr },
    138: { n: "BrtEndWsView", f: Cr },
    139: { n: "BrtBeginCsViews", f: Cr },
    140: { n: "BrtEndCsViews", f: Cr },
    141: { n: "BrtBeginCsView", f: Cr },
    142: { n: "BrtEndCsView", f: Cr },
    143: { n: "BrtBeginBundleShs", f: Cr },
    144: { n: "BrtEndBundleShs", f: Cr },
    145: { n: "BrtBeginSheetData", f: Cr },
    146: { n: "BrtEndSheetData", f: Cr },
    147: { n: "BrtWsProp", f: Zg },
    148: { n: "BrtWsDim", f: Kg, p: 16 },
    151: { n: "BrtPane", f: Cr },
    152: { n: "BrtSel", f: Cr },
    153: { n: "BrtWbProp", f: hm },
    154: { n: "BrtWbFactoid", f: Cr },
    155: { n: "BrtFileRecover", f: Cr },
    156: { n: "BrtBundleSh", f: lm },
    157: { n: "BrtCalcProp", f: Cr },
    158: { n: "BrtBookView", f: Cr },
    159: { n: "BrtBeginSst", f: $h },
    160: { n: "BrtEndSst", f: Cr },
    161: { n: "BrtBeginAFilter", f: kt },
    162: { n: "BrtEndAFilter", f: Cr },
    163: { n: "BrtBeginFilterColumn", f: Cr },
    164: { n: "BrtEndFilterColumn", f: Cr },
    165: { n: "BrtBeginFilters", f: Cr },
    166: { n: "BrtEndFilters", f: Cr },
    167: { n: "BrtFilter", f: Cr },
    168: { n: "BrtColorFilter", f: Cr },
    169: { n: "BrtIconFilter", f: Cr },
    170: { n: "BrtTop10Filter", f: Cr },
    171: { n: "BrtDynamicFilter", f: Cr },
    172: { n: "BrtBeginCustomFilters", f: Cr },
    173: { n: "BrtEndCustomFilters", f: Cr },
    174: { n: "BrtCustomFilter", f: Cr },
    175: { n: "BrtAFilterDateGroupItem", f: Cr },
    176: { n: "BrtMergeCell", f: pb },
    177: { n: "BrtBeginMergeCells", f: Cr },
    178: { n: "BrtEndMergeCells", f: Cr },
    179: { n: "BrtBeginPivotCacheDef", f: Cr },
    180: { n: "BrtEndPivotCacheDef", f: Cr },
    181: { n: "BrtBeginPCDFields", f: Cr },
    182: { n: "BrtEndPCDFields", f: Cr },
    183: { n: "BrtBeginPCDField", f: Cr },
    184: { n: "BrtEndPCDField", f: Cr },
    185: { n: "BrtBeginPCDSource", f: Cr },
    186: { n: "BrtEndPCDSource", f: Cr },
    187: { n: "BrtBeginPCDSRange", f: Cr },
    188: { n: "BrtEndPCDSRange", f: Cr },
    189: { n: "BrtBeginPCDFAtbl", f: Cr },
    190: { n: "BrtEndPCDFAtbl", f: Cr },
    191: { n: "BrtBeginPCDIRun", f: Cr },
    192: { n: "BrtEndPCDIRun", f: Cr },
    193: { n: "BrtBeginPivotCacheRecords", f: Cr },
    194: { n: "BrtEndPivotCacheRecords", f: Cr },
    195: { n: "BrtBeginPCDHierarchies", f: Cr },
    196: { n: "BrtEndPCDHierarchies", f: Cr },
    197: { n: "BrtBeginPCDHierarchy", f: Cr },
    198: { n: "BrtEndPCDHierarchy", f: Cr },
    199: { n: "BrtBeginPCDHFieldsUsage", f: Cr },
    200: { n: "BrtEndPCDHFieldsUsage", f: Cr },
    201: { n: "BrtBeginExtConnection", f: Cr },
    202: { n: "BrtEndExtConnection", f: Cr },
    203: { n: "BrtBeginECDbProps", f: Cr },
    204: { n: "BrtEndECDbProps", f: Cr },
    205: { n: "BrtBeginECOlapProps", f: Cr },
    206: { n: "BrtEndECOlapProps", f: Cr },
    207: { n: "BrtBeginPCDSConsol", f: Cr },
    208: { n: "BrtEndPCDSConsol", f: Cr },
    209: { n: "BrtBeginPCDSCPages", f: Cr },
    210: { n: "BrtEndPCDSCPages", f: Cr },
    211: { n: "BrtBeginPCDSCPage", f: Cr },
    212: { n: "BrtEndPCDSCPage", f: Cr },
    213: { n: "BrtBeginPCDSCPItem", f: Cr },
    214: { n: "BrtEndPCDSCPItem", f: Cr },
    215: { n: "BrtBeginPCDSCSets", f: Cr },
    216: { n: "BrtEndPCDSCSets", f: Cr },
    217: { n: "BrtBeginPCDSCSet", f: Cr },
    218: { n: "BrtEndPCDSCSet", f: Cr },
    219: { n: "BrtBeginPCDFGroup", f: Cr },
    220: { n: "BrtEndPCDFGroup", f: Cr },
    221: { n: "BrtBeginPCDFGItems", f: Cr },
    222: { n: "BrtEndPCDFGItems", f: Cr },
    223: { n: "BrtBeginPCDFGRange", f: Cr },
    224: { n: "BrtEndPCDFGRange", f: Cr },
    225: { n: "BrtBeginPCDFGDiscrete", f: Cr },
    226: { n: "BrtEndPCDFGDiscrete", f: Cr },
    227: { n: "BrtBeginPCDSDTupleCache", f: Cr },
    228: { n: "BrtEndPCDSDTupleCache", f: Cr },
    229: { n: "BrtBeginPCDSDTCEntries", f: Cr },
    230: { n: "BrtEndPCDSDTCEntries", f: Cr },
    231: { n: "BrtBeginPCDSDTCEMembers", f: Cr },
    232: { n: "BrtEndPCDSDTCEMembers", f: Cr },
    233: { n: "BrtBeginPCDSDTCEMember", f: Cr },
    234: { n: "BrtEndPCDSDTCEMember", f: Cr },
    235: { n: "BrtBeginPCDSDTCQueries", f: Cr },
    236: { n: "BrtEndPCDSDTCQueries", f: Cr },
    237: { n: "BrtBeginPCDSDTCQuery", f: Cr },
    238: { n: "BrtEndPCDSDTCQuery", f: Cr },
    239: { n: "BrtBeginPCDSDTCSets", f: Cr },
    240: { n: "BrtEndPCDSDTCSets", f: Cr },
    241: { n: "BrtBeginPCDSDTCSet", f: Cr },
    242: { n: "BrtEndPCDSDTCSet", f: Cr },
    243: { n: "BrtBeginPCDCalcItems", f: Cr },
    244: { n: "BrtEndPCDCalcItems", f: Cr },
    245: { n: "BrtBeginPCDCalcItem", f: Cr },
    246: { n: "BrtEndPCDCalcItem", f: Cr },
    247: { n: "BrtBeginPRule", f: Cr },
    248: { n: "BrtEndPRule", f: Cr },
    249: { n: "BrtBeginPRFilters", f: Cr },
    250: { n: "BrtEndPRFilters", f: Cr },
    251: { n: "BrtBeginPRFilter", f: Cr },
    252: { n: "BrtEndPRFilter", f: Cr },
    253: { n: "BrtBeginPNames", f: Cr },
    254: { n: "BrtEndPNames", f: Cr },
    255: { n: "BrtBeginPName", f: Cr },
    256: { n: "BrtEndPName", f: Cr },
    257: { n: "BrtBeginPNPairs", f: Cr },
    258: { n: "BrtEndPNPairs", f: Cr },
    259: { n: "BrtBeginPNPair", f: Cr },
    260: { n: "BrtEndPNPair", f: Cr },
    261: { n: "BrtBeginECWebProps", f: Cr },
    262: { n: "BrtEndECWebProps", f: Cr },
    263: { n: "BrtBeginEcWpTables", f: Cr },
    264: { n: "BrtEndECWPTables", f: Cr },
    265: { n: "BrtBeginECParams", f: Cr },
    266: { n: "BrtEndECParams", f: Cr },
    267: { n: "BrtBeginECParam", f: Cr },
    268: { n: "BrtEndECParam", f: Cr },
    269: { n: "BrtBeginPCDKPIs", f: Cr },
    270: { n: "BrtEndPCDKPIs", f: Cr },
    271: { n: "BrtBeginPCDKPI", f: Cr },
    272: { n: "BrtEndPCDKPI", f: Cr },
    273: { n: "BrtBeginDims", f: Cr },
    274: { n: "BrtEndDims", f: Cr },
    275: { n: "BrtBeginDim", f: Cr },
    276: { n: "BrtEndDim", f: Cr },
    277: { n: "BrtIndexPartEnd", f: Cr },
    278: { n: "BrtBeginStyleSheet", f: Cr },
    279: { n: "BrtEndStyleSheet", f: Cr },
    280: { n: "BrtBeginSXView", f: Cr },
    281: { n: "BrtEndSXVI", f: Cr },
    282: { n: "BrtBeginSXVI", f: Cr },
    283: { n: "BrtBeginSXVIs", f: Cr },
    284: { n: "BrtEndSXVIs", f: Cr },
    285: { n: "BrtBeginSXVD", f: Cr },
    286: { n: "BrtEndSXVD", f: Cr },
    287: { n: "BrtBeginSXVDs", f: Cr },
    288: { n: "BrtEndSXVDs", f: Cr },
    289: { n: "BrtBeginSXPI", f: Cr },
    290: { n: "BrtEndSXPI", f: Cr },
    291: { n: "BrtBeginSXPIs", f: Cr },
    292: { n: "BrtEndSXPIs", f: Cr },
    293: { n: "BrtBeginSXDI", f: Cr },
    294: { n: "BrtEndSXDI", f: Cr },
    295: { n: "BrtBeginSXDIs", f: Cr },
    296: { n: "BrtEndSXDIs", f: Cr },
    297: { n: "BrtBeginSXLI", f: Cr },
    298: { n: "BrtEndSXLI", f: Cr },
    299: { n: "BrtBeginSXLIRws", f: Cr },
    300: { n: "BrtEndSXLIRws", f: Cr },
    301: { n: "BrtBeginSXLICols", f: Cr },
    302: { n: "BrtEndSXLICols", f: Cr },
    303: { n: "BrtBeginSXFormat", f: Cr },
    304: { n: "BrtEndSXFormat", f: Cr },
    305: { n: "BrtBeginSXFormats", f: Cr },
    306: { n: "BrtEndSxFormats", f: Cr },
    307: { n: "BrtBeginSxSelect", f: Cr },
    308: { n: "BrtEndSxSelect", f: Cr },
    309: { n: "BrtBeginISXVDRws", f: Cr },
    310: { n: "BrtEndISXVDRws", f: Cr },
    311: { n: "BrtBeginISXVDCols", f: Cr },
    312: { n: "BrtEndISXVDCols", f: Cr },
    313: { n: "BrtEndSXLocation", f: Cr },
    314: { n: "BrtBeginSXLocation", f: Cr },
    315: { n: "BrtEndSXView", f: Cr },
    316: { n: "BrtBeginSXTHs", f: Cr },
    317: { n: "BrtEndSXTHs", f: Cr },
    318: { n: "BrtBeginSXTH", f: Cr },
    319: { n: "BrtEndSXTH", f: Cr },
    320: { n: "BrtBeginISXTHRws", f: Cr },
    321: { n: "BrtEndISXTHRws", f: Cr },
    322: { n: "BrtBeginISXTHCols", f: Cr },
    323: { n: "BrtEndISXTHCols", f: Cr },
    324: { n: "BrtBeginSXTDMPS", f: Cr },
    325: { n: "BrtEndSXTDMPs", f: Cr },
    326: { n: "BrtBeginSXTDMP", f: Cr },
    327: { n: "BrtEndSXTDMP", f: Cr },
    328: { n: "BrtBeginSXTHItems", f: Cr },
    329: { n: "BrtEndSXTHItems", f: Cr },
    330: { n: "BrtBeginSXTHItem", f: Cr },
    331: { n: "BrtEndSXTHItem", f: Cr },
    332: { n: "BrtBeginMetadata", f: Cr },
    333: { n: "BrtEndMetadata", f: Cr },
    334: { n: "BrtBeginEsmdtinfo", f: Cr },
    335: { n: "BrtMdtinfo", f: Cr },
    336: { n: "BrtEndEsmdtinfo", f: Cr },
    337: { n: "BrtBeginEsmdb", f: Cr },
    338: { n: "BrtEndEsmdb", f: Cr },
    339: { n: "BrtBeginEsfmd", f: Cr },
    340: { n: "BrtEndEsfmd", f: Cr },
    341: { n: "BrtBeginSingleCells", f: Cr },
    342: { n: "BrtEndSingleCells", f: Cr },
    343: { n: "BrtBeginList", f: Cr },
    344: { n: "BrtEndList", f: Cr },
    345: { n: "BrtBeginListCols", f: Cr },
    346: { n: "BrtEndListCols", f: Cr },
    347: { n: "BrtBeginListCol", f: Cr },
    348: { n: "BrtEndListCol", f: Cr },
    349: { n: "BrtBeginListXmlCPr", f: Cr },
    350: { n: "BrtEndListXmlCPr", f: Cr },
    351: { n: "BrtListCCFmla", f: Cr },
    352: { n: "BrtListTrFmla", f: Cr },
    353: { n: "BrtBeginExternals", f: Cr },
    354: { n: "BrtEndExternals", f: Cr },
    355: { n: "BrtSupBookSrc", f: pt },
    357: { n: "BrtSupSelf", f: Cr },
    358: { n: "BrtSupSame", f: Cr },
    359: { n: "BrtSupTabs", f: Cr },
    360: { n: "BrtBeginSupBook", f: Cr },
    361: { n: "BrtPlaceholderName", f: Cr },
    362: { n: "BrtExternSheet", f: mi },
    363: { n: "BrtExternTableStart", f: Cr },
    364: { n: "BrtExternTableEnd", f: Cr },
    366: { n: "BrtExternRowHdr", f: Cr },
    367: { n: "BrtExternCellBlank", f: Cr },
    368: { n: "BrtExternCellReal", f: Cr },
    369: { n: "BrtExternCellBool", f: Cr },
    370: { n: "BrtExternCellError", f: Cr },
    371: { n: "BrtExternCellString", f: Cr },
    372: { n: "BrtBeginEsmdx", f: Cr },
    373: { n: "BrtEndEsmdx", f: Cr },
    374: { n: "BrtBeginMdxSet", f: Cr },
    375: { n: "BrtEndMdxSet", f: Cr },
    376: { n: "BrtBeginMdxMbrProp", f: Cr },
    377: { n: "BrtEndMdxMbrProp", f: Cr },
    378: { n: "BrtBeginMdxKPI", f: Cr },
    379: { n: "BrtEndMdxKPI", f: Cr },
    380: { n: "BrtBeginEsstr", f: Cr },
    381: { n: "BrtEndEsstr", f: Cr },
    382: { n: "BrtBeginPRFItem", f: Cr },
    383: { n: "BrtEndPRFItem", f: Cr },
    384: { n: "BrtBeginPivotCacheIDs", f: Cr },
    385: { n: "BrtEndPivotCacheIDs", f: Cr },
    386: { n: "BrtBeginPivotCacheID", f: Cr },
    387: { n: "BrtEndPivotCacheID", f: Cr },
    388: { n: "BrtBeginISXVIs", f: Cr },
    389: { n: "BrtEndISXVIs", f: Cr },
    390: { n: "BrtBeginColInfos", f: Cr },
    391: { n: "BrtEndColInfos", f: Cr },
    392: { n: "BrtBeginRwBrk", f: Cr },
    393: { n: "BrtEndRwBrk", f: Cr },
    394: { n: "BrtBeginColBrk", f: Cr },
    395: { n: "BrtEndColBrk", f: Cr },
    396: { n: "BrtBrk", f: Cr },
    397: { n: "BrtUserBookView", f: Cr },
    398: { n: "BrtInfo", f: Cr },
    399: { n: "BrtCUsr", f: Cr },
    400: { n: "BrtUsr", f: Cr },
    401: { n: "BrtBeginUsers", f: Cr },
    403: { n: "BrtEOF", f: Cr },
    404: { n: "BrtUCR", f: Cr },
    405: { n: "BrtRRInsDel", f: Cr },
    406: { n: "BrtRREndInsDel", f: Cr },
    407: { n: "BrtRRMove", f: Cr },
    408: { n: "BrtRREndMove", f: Cr },
    409: { n: "BrtRRChgCell", f: Cr },
    410: { n: "BrtRREndChgCell", f: Cr },
    411: { n: "BrtRRHeader", f: Cr },
    412: { n: "BrtRRUserView", f: Cr },
    413: { n: "BrtRRRenSheet", f: Cr },
    414: { n: "BrtRRInsertSh", f: Cr },
    415: { n: "BrtRRDefName", f: Cr },
    416: { n: "BrtRRNote", f: Cr },
    417: { n: "BrtRRConflict", f: Cr },
    418: { n: "BrtRRTQSIF", f: Cr },
    419: { n: "BrtRRFormat", f: Cr },
    420: { n: "BrtRREndFormat", f: Cr },
    421: { n: "BrtRRAutoFmt", f: Cr },
    422: { n: "BrtBeginUserShViews", f: Cr },
    423: { n: "BrtBeginUserShView", f: Cr },
    424: { n: "BrtEndUserShView", f: Cr },
    425: { n: "BrtEndUserShViews", f: Cr },
    426: { n: "BrtArrFmla", f: Eb },
    427: { n: "BrtShrFmla", f: kb },
    428: { n: "BrtTable", f: Cr },
    429: { n: "BrtBeginExtConnections", f: Cr },
    430: { n: "BrtEndExtConnections", f: Cr },
    431: { n: "BrtBeginPCDCalcMems", f: Cr },
    432: { n: "BrtEndPCDCalcMems", f: Cr },
    433: { n: "BrtBeginPCDCalcMem", f: Cr },
    434: { n: "BrtEndPCDCalcMem", f: Cr },
    435: { n: "BrtBeginPCDHGLevels", f: Cr },
    436: { n: "BrtEndPCDHGLevels", f: Cr },
    437: { n: "BrtBeginPCDHGLevel", f: Cr },
    438: { n: "BrtEndPCDHGLevel", f: Cr },
    439: { n: "BrtBeginPCDHGLGroups", f: Cr },
    440: { n: "BrtEndPCDHGLGroups", f: Cr },
    441: { n: "BrtBeginPCDHGLGroup", f: Cr },
    442: { n: "BrtEndPCDHGLGroup", f: Cr },
    443: { n: "BrtBeginPCDHGLGMembers", f: Cr },
    444: { n: "BrtEndPCDHGLGMembers", f: Cr },
    445: { n: "BrtBeginPCDHGLGMember", f: Cr },
    446: { n: "BrtEndPCDHGLGMember", f: Cr },
    447: { n: "BrtBeginQSI", f: Cr },
    448: { n: "BrtEndQSI", f: Cr },
    449: { n: "BrtBeginQSIR", f: Cr },
    450: { n: "BrtEndQSIR", f: Cr },
    451: { n: "BrtBeginDeletedNames", f: Cr },
    452: { n: "BrtEndDeletedNames", f: Cr },
    453: { n: "BrtBeginDeletedName", f: Cr },
    454: { n: "BrtEndDeletedName", f: Cr },
    455: { n: "BrtBeginQSIFs", f: Cr },
    456: { n: "BrtEndQSIFs", f: Cr },
    457: { n: "BrtBeginQSIF", f: Cr },
    458: { n: "BrtEndQSIF", f: Cr },
    459: { n: "BrtBeginAutoSortScope", f: Cr },
    460: { n: "BrtEndAutoSortScope", f: Cr },
    461: { n: "BrtBeginConditionalFormatting", f: Cr },
    462: { n: "BrtEndConditionalFormatting", f: Cr },
    463: { n: "BrtBeginCFRule", f: Cr },
    464: { n: "BrtEndCFRule", f: Cr },
    465: { n: "BrtBeginIconSet", f: Cr },
    466: { n: "BrtEndIconSet", f: Cr },
    467: { n: "BrtBeginDatabar", f: Cr },
    468: { n: "BrtEndDatabar", f: Cr },
    469: { n: "BrtBeginColorScale", f: Cr },
    470: { n: "BrtEndColorScale", f: Cr },
    471: { n: "BrtCFVO", f: Cr },
    472: { n: "BrtExternValueMeta", f: Cr },
    473: { n: "BrtBeginColorPalette", f: Cr },
    474: { n: "BrtEndColorPalette", f: Cr },
    475: { n: "BrtIndexedColor", f: Cr },
    476: { n: "BrtMargins", f: wb },
    477: { n: "BrtPrintOptions", f: Cr },
    478: { n: "BrtPageSetup", f: Cr },
    479: { n: "BrtBeginHeaderFooter", f: Cr },
    480: { n: "BrtEndHeaderFooter", f: Cr },
    481: { n: "BrtBeginSXCrtFormat", f: Cr },
    482: { n: "BrtEndSXCrtFormat", f: Cr },
    483: { n: "BrtBeginSXCrtFormats", f: Cr },
    484: { n: "BrtEndSXCrtFormats", f: Cr },
    485: { n: "BrtWsFmtInfo", f: $g },
    486: { n: "BrtBeginMgs", f: Cr },
    487: { n: "BrtEndMGs", f: Cr },
    488: { n: "BrtBeginMGMaps", f: Cr },
    489: { n: "BrtEndMGMaps", f: Cr },
    490: { n: "BrtBeginMG", f: Cr },
    491: { n: "BrtEndMG", f: Cr },
    492: { n: "BrtBeginMap", f: Cr },
    493: { n: "BrtEndMap", f: Cr },
    494: { n: "BrtHLink", f: mb },
    495: { n: "BrtBeginDCon", f: Cr },
    496: { n: "BrtEndDCon", f: Cr },
    497: { n: "BrtBeginDRefs", f: Cr },
    498: { n: "BrtEndDRefs", f: Cr },
    499: { n: "BrtDRef", f: Cr },
    500: { n: "BrtBeginScenMan", f: Cr },
    501: { n: "BrtEndScenMan", f: Cr },
    502: { n: "BrtBeginSct", f: Cr },
    503: { n: "BrtEndSct", f: Cr },
    504: { n: "BrtSlc", f: Cr },
    505: { n: "BrtBeginDXFs", f: Cr },
    506: { n: "BrtEndDXFs", f: Cr },
    507: { n: "BrtDXF", f: Cr },
    508: { n: "BrtBeginTableStyles", f: Cr },
    509: { n: "BrtEndTableStyles", f: Cr },
    510: { n: "BrtBeginTableStyle", f: Cr },
    511: { n: "BrtEndTableStyle", f: Cr },
    512: { n: "BrtTableStyleElement", f: Cr },
    513: { n: "BrtTableStyleClient", f: Cr },
    514: { n: "BrtBeginVolDeps", f: Cr },
    515: { n: "BrtEndVolDeps", f: Cr },
    516: { n: "BrtBeginVolType", f: Cr },
    517: { n: "BrtEndVolType", f: Cr },
    518: { n: "BrtBeginVolMain", f: Cr },
    519: { n: "BrtEndVolMain", f: Cr },
    520: { n: "BrtBeginVolTopic", f: Cr },
    521: { n: "BrtEndVolTopic", f: Cr },
    522: { n: "BrtVolSubtopic", f: Cr },
    523: { n: "BrtVolRef", f: Cr },
    524: { n: "BrtVolNum", f: Cr },
    525: { n: "BrtVolErr", f: Cr },
    526: { n: "BrtVolStr", f: Cr },
    527: { n: "BrtVolBool", f: Cr },
    528: { n: "BrtBeginCalcChain$", f: Cr },
    529: { n: "BrtEndCalcChain$", f: Cr },
    530: { n: "BrtBeginSortState", f: Cr },
    531: { n: "BrtEndSortState", f: Cr },
    532: { n: "BrtBeginSortCond", f: Cr },
    533: { n: "BrtEndSortCond", f: Cr },
    534: { n: "BrtBookProtection", f: Cr },
    535: { n: "BrtSheetProtection", f: Cr },
    536: { n: "BrtRangeProtection", f: Cr },
    537: { n: "BrtPhoneticInfo", f: Cr },
    538: { n: "BrtBeginECTxtWiz", f: Cr },
    539: { n: "BrtEndECTxtWiz", f: Cr },
    540: { n: "BrtBeginECTWFldInfoLst", f: Cr },
    541: { n: "BrtEndECTWFldInfoLst", f: Cr },
    542: { n: "BrtBeginECTwFldInfo", f: Cr },
    548: { n: "BrtFileSharing", f: Cr },
    549: { n: "BrtOleSize", f: Cr },
    550: { n: "BrtDrawing", f: pt },
    551: { n: "BrtLegacyDrawing", f: Cr },
    552: { n: "BrtLegacyDrawingHF", f: Cr },
    553: { n: "BrtWebOpt", f: Cr },
    554: { n: "BrtBeginWebPubItems", f: Cr },
    555: { n: "BrtEndWebPubItems", f: Cr },
    556: { n: "BrtBeginWebPubItem", f: Cr },
    557: { n: "BrtEndWebPubItem", f: Cr },
    558: { n: "BrtBeginSXCondFmt", f: Cr },
    559: { n: "BrtEndSXCondFmt", f: Cr },
    560: { n: "BrtBeginSXCondFmts", f: Cr },
    561: { n: "BrtEndSXCondFmts", f: Cr },
    562: { n: "BrtBkHim", f: Cr },
    564: { n: "BrtColor", f: Cr },
    565: { n: "BrtBeginIndexedColors", f: Cr },
    566: { n: "BrtEndIndexedColors", f: Cr },
    569: { n: "BrtBeginMRUColors", f: Cr },
    570: { n: "BrtEndMRUColors", f: Cr },
    572: { n: "BrtMRUColor", f: Cr },
    573: { n: "BrtBeginDVals", f: Cr },
    574: { n: "BrtEndDVals", f: Cr },
    577: { n: "BrtSupNameStart", f: Cr },
    578: { n: "BrtSupNameValueStart", f: Cr },
    579: { n: "BrtSupNameValueEnd", f: Cr },
    580: { n: "BrtSupNameNum", f: Cr },
    581: { n: "BrtSupNameErr", f: Cr },
    582: { n: "BrtSupNameSt", f: Cr },
    583: { n: "BrtSupNameNil", f: Cr },
    584: { n: "BrtSupNameBool", f: Cr },
    585: { n: "BrtSupNameFmla", f: Cr },
    586: { n: "BrtSupNameBits", f: Cr },
    587: { n: "BrtSupNameEnd", f: Cr },
    588: { n: "BrtEndSupBook", f: Cr },
    589: { n: "BrtCellSmartTagProperty", f: Cr },
    590: { n: "BrtBeginCellSmartTag", f: Cr },
    591: { n: "BrtEndCellSmartTag", f: Cr },
    592: { n: "BrtBeginCellSmartTags", f: Cr },
    593: { n: "BrtEndCellSmartTags", f: Cr },
    594: { n: "BrtBeginSmartTags", f: Cr },
    595: { n: "BrtEndSmartTags", f: Cr },
    596: { n: "BrtSmartTagType", f: Cr },
    597: { n: "BrtBeginSmartTagTypes", f: Cr },
    598: { n: "BrtEndSmartTagTypes", f: Cr },
    599: { n: "BrtBeginSXFilters", f: Cr },
    600: { n: "BrtEndSXFilters", f: Cr },
    601: { n: "BrtBeginSXFILTER", f: Cr },
    602: { n: "BrtEndSXFilter", f: Cr },
    603: { n: "BrtBeginFills", f: Cr },
    604: { n: "BrtEndFills", f: Cr },
    605: { n: "BrtBeginCellWatches", f: Cr },
    606: { n: "BrtEndCellWatches", f: Cr },
    607: { n: "BrtCellWatch", f: Cr },
    608: { n: "BrtBeginCRErrs", f: Cr },
    609: { n: "BrtEndCRErrs", f: Cr },
    610: { n: "BrtCrashRecErr", f: Cr },
    611: { n: "BrtBeginFonts", f: Cr },
    612: { n: "BrtEndFonts", f: Cr },
    613: { n: "BrtBeginBorders", f: Cr },
    614: { n: "BrtEndBorders", f: Cr },
    615: { n: "BrtBeginFmts", f: Cr },
    616: { n: "BrtEndFmts", f: Cr },
    617: { n: "BrtBeginCellXFs", f: Cr },
    618: { n: "BrtEndCellXFs", f: Cr },
    619: { n: "BrtBeginStyles", f: Cr },
    620: { n: "BrtEndStyles", f: Cr },
    625: { n: "BrtBigName", f: Cr },
    626: { n: "BrtBeginCellStyleXFs", f: Cr },
    627: { n: "BrtEndCellStyleXFs", f: Cr },
    628: { n: "BrtBeginComments", f: Cr },
    629: { n: "BrtEndComments", f: Cr },
    630: { n: "BrtBeginCommentAuthors", f: Cr },
    631: { n: "BrtEndCommentAuthors", f: Cr },
    632: { n: "BrtCommentAuthor", f: ov },
    633: { n: "BrtBeginCommentList", f: Cr },
    634: { n: "BrtEndCommentList", f: Cr },
    635: { n: "BrtBeginComment", f: sv },
    636: { n: "BrtEndComment", f: Cr },
    637: { n: "BrtCommentText", f: it },
    638: { n: "BrtBeginOleObjects", f: Cr },
    639: { n: "BrtOleObject", f: Cr },
    640: { n: "BrtEndOleObjects", f: Cr },
    641: { n: "BrtBeginSxrules", f: Cr },
    642: { n: "BrtEndSxRules", f: Cr },
    643: { n: "BrtBeginActiveXControls", f: Cr },
    644: { n: "BrtActiveX", f: Cr },
    645: { n: "BrtEndActiveXControls", f: Cr },
    646: { n: "BrtBeginPCDSDTCEMembersSortBy", f: Cr },
    648: { n: "BrtBeginCellIgnoreECs", f: Cr },
    649: { n: "BrtCellIgnoreEC", f: Cr },
    650: { n: "BrtEndCellIgnoreECs", f: Cr },
    651: { n: "BrtCsProp", f: Cr },
    652: { n: "BrtCsPageSetup", f: Cr },
    653: { n: "BrtBeginUserCsViews", f: Cr },
    654: { n: "BrtEndUserCsViews", f: Cr },
    655: { n: "BrtBeginUserCsView", f: Cr },
    656: { n: "BrtEndUserCsView", f: Cr },
    657: { n: "BrtBeginPcdSFCIEntries", f: Cr },
    658: { n: "BrtEndPCDSFCIEntries", f: Cr },
    659: { n: "BrtPCDSFCIEntry", f: Cr },
    660: { n: "BrtBeginListParts", f: Cr },
    661: { n: "BrtListPart", f: Cr },
    662: { n: "BrtEndListParts", f: Cr },
    663: { n: "BrtSheetCalcProp", f: Cr },
    664: { n: "BrtBeginFnGroup", f: Cr },
    665: { n: "BrtFnGroup", f: Cr },
    666: { n: "BrtEndFnGroup", f: Cr },
    667: { n: "BrtSupAddin", f: Cr },
    668: { n: "BrtSXTDMPOrder", f: Cr },
    669: { n: "BrtCsProtection", f: Cr },
    671: { n: "BrtBeginWsSortMap", f: Cr },
    672: { n: "BrtEndWsSortMap", f: Cr },
    673: { n: "BrtBeginRRSort", f: Cr },
    674: { n: "BrtEndRRSort", f: Cr },
    675: { n: "BrtRRSortItem", f: Cr },
    676: { n: "BrtFileSharingIso", f: Cr },
    677: { n: "BrtBookProtectionIso", f: Cr },
    678: { n: "BrtSheetProtectionIso", f: Cr },
    679: { n: "BrtCsProtectionIso", f: Cr },
    680: { n: "BrtRangeProtectionIso", f: Cr },
    1024: { n: "BrtRwDescent", f: Cr },
    1025: { n: "BrtKnownFonts", f: Cr },
    1026: { n: "BrtBeginSXTupleSet", f: Cr },
    1027: { n: "BrtEndSXTupleSet", f: Cr },
    1028: { n: "BrtBeginSXTupleSetHeader", f: Cr },
    1029: { n: "BrtEndSXTupleSetHeader", f: Cr },
    1030: { n: "BrtSXTupleSetHeaderItem", f: Cr },
    1031: { n: "BrtBeginSXTupleSetData", f: Cr },
    1032: { n: "BrtEndSXTupleSetData", f: Cr },
    1033: { n: "BrtBeginSXTupleSetRow", f: Cr },
    1034: { n: "BrtEndSXTupleSetRow", f: Cr },
    1035: { n: "BrtSXTupleSetRowItem", f: Cr },
    1036: { n: "BrtNameExt", f: Cr },
    1037: { n: "BrtPCDH14", f: Cr },
    1038: { n: "BrtBeginPCDCalcMem14", f: Cr },
    1039: { n: "BrtEndPCDCalcMem14", f: Cr },
    1040: { n: "BrtSXTH14", f: Cr },
    1041: { n: "BrtBeginSparklineGroup", f: Cr },
    1042: { n: "BrtEndSparklineGroup", f: Cr },
    1043: { n: "BrtSparkline", f: Cr },
    1044: { n: "BrtSXDI14", f: Cr },
    1045: { n: "BrtWsFmtInfoEx14", f: Cr },
    1046: { n: "BrtBeginConditionalFormatting14", f: Cr },
    1047: { n: "BrtEndConditionalFormatting14", f: Cr },
    1048: { n: "BrtBeginCFRule14", f: Cr },
    1049: { n: "BrtEndCFRule14", f: Cr },
    1050: { n: "BrtCFVO14", f: Cr },
    1051: { n: "BrtBeginDatabar14", f: Cr },
    1052: { n: "BrtBeginIconSet14", f: Cr },
    1053: { n: "BrtDVal14", f: Cr },
    1054: { n: "BrtBeginDVals14", f: Cr },
    1055: { n: "BrtColor14", f: Cr },
    1056: { n: "BrtBeginSparklines", f: Cr },
    1057: { n: "BrtEndSparklines", f: Cr },
    1058: { n: "BrtBeginSparklineGroups", f: Cr },
    1059: { n: "BrtEndSparklineGroups", f: Cr },
    1061: { n: "BrtSXVD14", f: Cr },
    1062: { n: "BrtBeginSxview14", f: Cr },
    1063: { n: "BrtEndSxview14", f: Cr },
    1066: { n: "BrtBeginPCD14", f: Cr },
    1067: { n: "BrtEndPCD14", f: Cr },
    1068: { n: "BrtBeginExtConn14", f: Cr },
    1069: { n: "BrtEndExtConn14", f: Cr },
    1070: { n: "BrtBeginSlicerCacheIDs", f: Cr },
    1071: { n: "BrtEndSlicerCacheIDs", f: Cr },
    1072: { n: "BrtBeginSlicerCacheID", f: Cr },
    1073: { n: "BrtEndSlicerCacheID", f: Cr },
    1075: { n: "BrtBeginSlicerCache", f: Cr },
    1076: { n: "BrtEndSlicerCache", f: Cr },
    1077: { n: "BrtBeginSlicerCacheDef", f: Cr },
    1078: { n: "BrtEndSlicerCacheDef", f: Cr },
    1079: { n: "BrtBeginSlicersEx", f: Cr },
    1080: { n: "BrtEndSlicersEx", f: Cr },
    1081: { n: "BrtBeginSlicerEx", f: Cr },
    1082: { n: "BrtEndSlicerEx", f: Cr },
    1083: { n: "BrtBeginSlicer", f: Cr },
    1084: { n: "BrtEndSlicer", f: Cr },
    1085: { n: "BrtSlicerCachePivotTables", f: Cr },
    1086: { n: "BrtBeginSlicerCacheOlapImpl", f: Cr },
    1087: { n: "BrtEndSlicerCacheOlapImpl", f: Cr },
    1088: { n: "BrtBeginSlicerCacheLevelsData", f: Cr },
    1089: { n: "BrtEndSlicerCacheLevelsData", f: Cr },
    1090: { n: "BrtBeginSlicerCacheLevelData", f: Cr },
    1091: { n: "BrtEndSlicerCacheLevelData", f: Cr },
    1092: { n: "BrtBeginSlicerCacheSiRanges", f: Cr },
    1093: { n: "BrtEndSlicerCacheSiRanges", f: Cr },
    1094: { n: "BrtBeginSlicerCacheSiRange", f: Cr },
    1095: { n: "BrtEndSlicerCacheSiRange", f: Cr },
    1096: { n: "BrtSlicerCacheOlapItem", f: Cr },
    1097: { n: "BrtBeginSlicerCacheSelections", f: Cr },
    1098: { n: "BrtSlicerCacheSelection", f: Cr },
    1099: { n: "BrtEndSlicerCacheSelections", f: Cr },
    1100: { n: "BrtBeginSlicerCacheNative", f: Cr },
    1101: { n: "BrtEndSlicerCacheNative", f: Cr },
    1102: { n: "BrtSlicerCacheNativeItem", f: Cr },
    1103: { n: "BrtRangeProtection14", f: Cr },
    1104: { n: "BrtRangeProtectionIso14", f: Cr },
    1105: { n: "BrtCellIgnoreEC14", f: Cr },
    1111: { n: "BrtList14", f: Cr },
    1112: { n: "BrtCFIcon", f: Cr },
    1113: { n: "BrtBeginSlicerCachesPivotCacheIDs", f: Cr },
    1114: { n: "BrtEndSlicerCachesPivotCacheIDs", f: Cr },
    1115: { n: "BrtBeginSlicers", f: Cr },
    1116: { n: "BrtEndSlicers", f: Cr },
    1117: { n: "BrtWbProp14", f: Cr },
    1118: { n: "BrtBeginSXEdit", f: Cr },
    1119: { n: "BrtEndSXEdit", f: Cr },
    1120: { n: "BrtBeginSXEdits", f: Cr },
    1121: { n: "BrtEndSXEdits", f: Cr },
    1122: { n: "BrtBeginSXChange", f: Cr },
    1123: { n: "BrtEndSXChange", f: Cr },
    1124: { n: "BrtBeginSXChanges", f: Cr },
    1125: { n: "BrtEndSXChanges", f: Cr },
    1126: { n: "BrtSXTupleItems", f: Cr },
    1128: { n: "BrtBeginSlicerStyle", f: Cr },
    1129: { n: "BrtEndSlicerStyle", f: Cr },
    1130: { n: "BrtSlicerStyleElement", f: Cr },
    1131: { n: "BrtBeginStyleSheetExt14", f: Cr },
    1132: { n: "BrtEndStyleSheetExt14", f: Cr },
    1133: { n: "BrtBeginSlicerCachesPivotCacheID", f: Cr },
    1134: { n: "BrtEndSlicerCachesPivotCacheID", f: Cr },
    1135: { n: "BrtBeginConditionalFormattings", f: Cr },
    1136: { n: "BrtEndConditionalFormattings", f: Cr },
    1137: { n: "BrtBeginPCDCalcMemExt", f: Cr },
    1138: { n: "BrtEndPCDCalcMemExt", f: Cr },
    1139: { n: "BrtBeginPCDCalcMemsExt", f: Cr },
    1140: { n: "BrtEndPCDCalcMemsExt", f: Cr },
    1141: { n: "BrtPCDField14", f: Cr },
    1142: { n: "BrtBeginSlicerStyles", f: Cr },
    1143: { n: "BrtEndSlicerStyles", f: Cr },
    1144: { n: "BrtBeginSlicerStyleElements", f: Cr },
    1145: { n: "BrtEndSlicerStyleElements", f: Cr },
    1146: { n: "BrtCFRuleExt", f: Cr },
    1147: { n: "BrtBeginSXCondFmt14", f: Cr },
    1148: { n: "BrtEndSXCondFmt14", f: Cr },
    1149: { n: "BrtBeginSXCondFmts14", f: Cr },
    1150: { n: "BrtEndSXCondFmts14", f: Cr },
    1152: { n: "BrtBeginSortCond14", f: Cr },
    1153: { n: "BrtEndSortCond14", f: Cr },
    1154: { n: "BrtEndDVals14", f: Cr },
    1155: { n: "BrtEndIconSet14", f: Cr },
    1156: { n: "BrtEndDatabar14", f: Cr },
    1157: { n: "BrtBeginColorScale14", f: Cr },
    1158: { n: "BrtEndColorScale14", f: Cr },
    1159: { n: "BrtBeginSxrules14", f: Cr },
    1160: { n: "BrtEndSxrules14", f: Cr },
    1161: { n: "BrtBeginPRule14", f: Cr },
    1162: { n: "BrtEndPRule14", f: Cr },
    1163: { n: "BrtBeginPRFilters14", f: Cr },
    1164: { n: "BrtEndPRFilters14", f: Cr },
    1165: { n: "BrtBeginPRFilter14", f: Cr },
    1166: { n: "BrtEndPRFilter14", f: Cr },
    1167: { n: "BrtBeginPRFItem14", f: Cr },
    1168: { n: "BrtEndPRFItem14", f: Cr },
    1169: { n: "BrtBeginCellIgnoreECs14", f: Cr },
    1170: { n: "BrtEndCellIgnoreECs14", f: Cr },
    1171: { n: "BrtDxf14", f: Cr },
    1172: { n: "BrtBeginDxF14s", f: Cr },
    1173: { n: "BrtEndDxf14s", f: Cr },
    1177: { n: "BrtFilter14", f: Cr },
    1178: { n: "BrtBeginCustomFilters14", f: Cr },
    1180: { n: "BrtCustomFilter14", f: Cr },
    1181: { n: "BrtIconFilter14", f: Cr },
    1182: { n: "BrtPivotCacheConnectionName", f: Cr },
    2048: { n: "BrtBeginDecoupledPivotCacheIDs", f: Cr },
    2049: { n: "BrtEndDecoupledPivotCacheIDs", f: Cr },
    2050: { n: "BrtDecoupledPivotCacheID", f: Cr },
    2051: { n: "BrtBeginPivotTableRefs", f: Cr },
    2052: { n: "BrtEndPivotTableRefs", f: Cr },
    2053: { n: "BrtPivotTableRef", f: Cr },
    2054: { n: "BrtSlicerCacheBookPivotTables", f: Cr },
    2055: { n: "BrtBeginSxvcells", f: Cr },
    2056: { n: "BrtEndSxvcells", f: Cr },
    2057: { n: "BrtBeginSxRow", f: Cr },
    2058: { n: "BrtEndSxRow", f: Cr },
    2060: { n: "BrtPcdCalcMem15", f: Cr },
    2067: { n: "BrtQsi15", f: Cr },
    2068: { n: "BrtBeginWebExtensions", f: Cr },
    2069: { n: "BrtEndWebExtensions", f: Cr },
    2070: { n: "BrtWebExtension", f: Cr },
    2071: { n: "BrtAbsPath15", f: Cr },
    2072: { n: "BrtBeginPivotTableUISettings", f: Cr },
    2073: { n: "BrtEndPivotTableUISettings", f: Cr },
    2075: { n: "BrtTableSlicerCacheIDs", f: Cr },
    2076: { n: "BrtTableSlicerCacheID", f: Cr },
    2077: { n: "BrtBeginTableSlicerCache", f: Cr },
    2078: { n: "BrtEndTableSlicerCache", f: Cr },
    2079: { n: "BrtSxFilter15", f: Cr },
    2080: { n: "BrtBeginTimelineCachePivotCacheIDs", f: Cr },
    2081: { n: "BrtEndTimelineCachePivotCacheIDs", f: Cr },
    2082: { n: "BrtTimelineCachePivotCacheID", f: Cr },
    2083: { n: "BrtBeginTimelineCacheIDs", f: Cr },
    2084: { n: "BrtEndTimelineCacheIDs", f: Cr },
    2085: { n: "BrtBeginTimelineCacheID", f: Cr },
    2086: { n: "BrtEndTimelineCacheID", f: Cr },
    2087: { n: "BrtBeginTimelinesEx", f: Cr },
    2088: { n: "BrtEndTimelinesEx", f: Cr },
    2089: { n: "BrtBeginTimelineEx", f: Cr },
    2090: { n: "BrtEndTimelineEx", f: Cr },
    2091: { n: "BrtWorkBookPr15", f: Cr },
    2092: { n: "BrtPCDH15", f: Cr },
    2093: { n: "BrtBeginTimelineStyle", f: Cr },
    2094: { n: "BrtEndTimelineStyle", f: Cr },
    2095: { n: "BrtTimelineStyleElement", f: Cr },
    2096: { n: "BrtBeginTimelineStylesheetExt15", f: Cr },
    2097: { n: "BrtEndTimelineStylesheetExt15", f: Cr },
    2098: { n: "BrtBeginTimelineStyles", f: Cr },
    2099: { n: "BrtEndTimelineStyles", f: Cr },
    2100: {
      n: "BrtBeginTimelineStyleElements",
      f: Cr,
    },
    2101: { n: "BrtEndTimelineStyleElements", f: Cr },
    2102: { n: "BrtDxf15", f: Cr },
    2103: { n: "BrtBeginDxfs15", f: Cr },
    2104: { n: "brtEndDxfs15", f: Cr },
    2105: { n: "BrtSlicerCacheHideItemsWithNoData", f: Cr },
    2106: { n: "BrtBeginItemUniqueNames", f: Cr },
    2107: { n: "BrtEndItemUniqueNames", f: Cr },
    2108: { n: "BrtItemUniqueName", f: Cr },
    2109: { n: "BrtBeginExtConn15", f: Cr },
    2110: { n: "BrtEndExtConn15", f: Cr },
    2111: { n: "BrtBeginOledbPr15", f: Cr },
    2112: { n: "BrtEndOledbPr15", f: Cr },
    2113: { n: "BrtBeginDataFeedPr15", f: Cr },
    2114: { n: "BrtEndDataFeedPr15", f: Cr },
    2115: { n: "BrtTextPr15", f: Cr },
    2116: { n: "BrtRangePr15", f: Cr },
    2117: { n: "BrtDbCommand15", f: Cr },
    2118: { n: "BrtBeginDbTables15", f: Cr },
    2119: { n: "BrtEndDbTables15", f: Cr },
    2120: { n: "BrtDbTable15", f: Cr },
    2121: { n: "BrtBeginDataModel", f: Cr },
    2122: { n: "BrtEndDataModel", f: Cr },
    2123: { n: "BrtBeginModelTables", f: Cr },
    2124: { n: "BrtEndModelTables", f: Cr },
    2125: { n: "BrtModelTable", f: Cr },
    2126: { n: "BrtBeginModelRelationships", f: Cr },
    2127: { n: "BrtEndModelRelationships", f: Cr },
    2128: { n: "BrtModelRelationship", f: Cr },
    2129: { n: "BrtBeginECTxtWiz15", f: Cr },
    2130: { n: "BrtEndECTxtWiz15", f: Cr },
    2131: { n: "BrtBeginECTWFldInfoLst15", f: Cr },
    2132: { n: "BrtEndECTWFldInfoLst15", f: Cr },
    2133: { n: "BrtBeginECTWFldInfo15", f: Cr },
    2134: { n: "BrtFieldListActiveItem", f: Cr },
    2135: { n: "BrtPivotCacheIdVersion", f: Cr },
    2136: { n: "BrtSXDI15", f: Cr },
    65535: { n: "", f: Cr },
  };
  var mC = I(bC, "n");
  var CC = {
    3: { n: "BIFF2NUM", f: _h },
    4: { n: "BIFF2STR", f: Bh },
    6: { n: "Formula", f: Vp },
    9: { n: "BOF", f: Un },
    10: { n: "EOF", f: fs },
    12: { n: "CalcCount", f: Yi },
    13: { n: "CalcMode", f: Qi },
    14: { n: "CalcPrecision", f: Ji },
    15: { n: "CalcRefMode", f: qi },
    16: { n: "CalcDelta", f: $i },
    17: { n: "CalcIter", f: Zi },
    18: { n: "Protect", f: _s },
    19: { n: "Password", f: Es },
    20: { n: "Header", f: vs },
    21: { n: "Footer", f: hs },
    23: { n: "ExternSheet", f: mi },
    24: { n: "Lbl", f: bi },
    25: { n: "WinProtect", f: Ls },
    26: { n: "VerticalPageBreaks", f: Us },
    27: { n: "HorizontalPageBreaks", f: Hs },
    28: { n: "Note", f: _i },
    29: { n: "Selection", f: Ws },
    34: { n: "Date1904", f: as },
    35: { n: "ExternName", f: pi },
    38: { n: "LeftMargin", f: bs },
    39: { n: "RightMargin", f: xs },
    40: { n: "TopMargin", f: Fs },
    41: { n: "BottomMargin", f: ji },
    42: { n: "PrintRowCol", f: Ss },
    43: { n: "PrintGrid", f: ks },
    47: { n: "FilePass", f: Su },
    49: { n: "Font", f: Qn },
    51: { n: "PrintSize", f: ws },
    60: { n: "Continue", f: Vs },
    61: { n: "Window1", f: Zn },
    64: { n: "Backup", f: Xi },
    65: { n: "Pane", f: zs },
    66: { n: "CodePage", f: rs },
    77: { n: "Pls", f: Xs },
    80: { n: "DCon", f: Gs },
    81: { n: "DConRef", f: js },
    82: { n: "DConName", f: Ks },
    85: { n: "DefColWidth", f: ns },
    89: { n: "XCT", f: Ys },
    90: { n: "CRN", f: $s },
    91: { n: "FileSharing", f: Zs },
    92: { n: "WriteAccess", f: Wn },
    93: { n: "Obj", f: xi },
    94: { n: "Uncalced", f: Qs },
    95: { n: "CalcSaveRecalc", f: es },
    96: { n: "Template", f: Js },
    97: { n: "Intl", f: qs },
    99: { n: "ObjProtect", f: Cs },
    125: { n: "ColInfo", f: Mi },
    128: { n: "Guts", f: ci },
    129: { n: "WsBool", f: ef },
    130: { n: "GridSet", f: us },
    131: { n: "HCenter", f: ds },
    132: { n: "VCenter", f: Ns },
    133: { n: "BoundSheet8", f: Vn },
    134: { n: "WriteProtect", f: Ms },
    140: { n: "Country", f: Fi },
    141: { n: "HideObj", f: ps },
    144: { n: "Sort", f: rf },
    146: { n: "Palette", f: Ni },
    151: { n: "Sync", f: tf },
    152: { n: "LPr", f: af },
    153: { n: "DxGCol", f: nf },
    154: { n: "FnGroupName", f: sf },
    155: { n: "FilterMode", f: ff },
    156: { n: "BuiltInFnGroupCount", f: Ki },
    157: { n: "AutoFilterInfo", f: of },
    158: { n: "AutoFilter", f: lf },
    160: { n: "Scl", f: Rs },
    161: { n: "Setup", f: Ui },
    174: { n: "ScenMan", f: cf },
    175: { n: "SCENARIO", f: hf },
    176: { n: "SxView", f: uf },
    177: { n: "Sxvd", f: df },
    178: { n: "SXVI", f: vf },
    180: { n: "SxIvd", f: pf },
    181: { n: "SXLI", f: gf },
    182: { n: "SXPI", f: bf },
    184: { n: "DocRoute", f: mf },
    185: { n: "RecipName", f: Cf },
    189: { n: "MulRk", f: ni },
    190: { n: "MulBlank", f: ii },
    193: { n: "Mms", f: ms },
    197: { n: "SXDI", f: Ef },
    198: { n: "SXDB", f: kf },
    199: { n: "SXFDB", f: Sf },
    200: { n: "SXDBB", f: wf },
    201: { n: "SXNum", f: Af },
    202: { n: "SxBool", f: Os },
    203: { n: "SxErr", f: Bf },
    204: { n: "SXInt", f: _f },
    205: { n: "SXString", f: Tf },
    206: { n: "SXDtr", f: xf },
    207: { n: "SxNil", f: If },
    208: { n: "SXTbl", f: yf },
    209: { n: "SXTBRGIITM", f: Rf },
    210: { n: "SxTbpg", f: Df },
    211: { n: "ObProj", f: Of },
    213: { n: "SXStreamID", f: Ff },
    215: { n: "DBCell", f: Pf },
    216: { n: "SXRng", f: Nf },
    217: { n: "SxIsxoper", f: Lf },
    218: { n: "BookBool", f: Mf },
    220: { n: "DbOrParamQry", f: Uf },
    221: { n: "ScenarioProtect", f: ys },
    222: { n: "OleObjectSize", f: Hf },
    224: { n: "XF", f: li },
    225: { n: "InterfaceHdr", f: Hn },
    226: { n: "InterfaceEnd", f: gs },
    227: { n: "SXVS", f: Wf },
    229: { n: "MergeCells", f: Ti },
    233: { n: "BkHim", f: Vf },
    235: { n: "MsoDrawingGroup", f: zf },
    236: { n: "MsoDrawing", f: Xf },
    237: { n: "MsoDrawingSelection", f: Gf },
    239: { n: "PhoneticInfo", f: jf },
    240: { n: "SxRule", f: Kf },
    241: { n: "SXEx", f: Yf },
    242: { n: "SxFilt", f: $f },
    244: { n: "SxDXF", f: Zf },
    245: { n: "SxItm", f: Qf },
    246: { n: "SxName", f: Jf },
    247: { n: "SxSelect", f: qf },
    248: { n: "SXPair", f: eo },
    249: { n: "SxFmla", f: ro },
    251: { n: "SxFormat", f: to },
    252: { n: "SST", f: zn },
    253: { n: "LabelSst", f: Jn },
    255: { n: "ExtSST", f: Xn },
    256: { n: "SXVDEx", f: ao },
    259: { n: "SXFormula", f: no },
    290: { n: "SXDBEx", f: io },
    311: { n: "RRDInsDel", f: so },
    312: { n: "RRDHead", f: fo },
    315: { n: "RRDChgCell", f: oo },
    317: { n: "RRTabId", f: Is },
    318: { n: "RRDRenSheet", f: lo },
    319: { n: "RRSort", f: co },
    320: { n: "RRDMove", f: ho },
    330: { n: "RRFormat", f: uo },
    331: { n: "RRAutoFmt", f: vo },
    333: { n: "RRInsertSh", f: po },
    334: { n: "RRDMoveBegin", f: go },
    335: { n: "RRDMoveEnd", f: bo },
    336: { n: "RRDInsDelBegin", f: mo },
    337: { n: "RRDInsDelEnd", f: Co },
    338: { n: "RRDConflict", f: Eo },
    339: { n: "RRDDefName", f: ko },
    340: { n: "RRDRstEtxp", f: So },
    351: { n: "LRng", f: wo },
    352: { n: "UsesELFs", f: Ps },
    353: { n: "DSF", f: is },
    401: { n: "CUsr", f: Ao },
    402: { n: "CbUsr", f: Bo },
    403: { n: "UsrInfo", f: _o },
    404: { n: "UsrExcl", f: To },
    405: { n: "FileLock", f: xo },
    406: { n: "RRDInfo", f: Io },
    407: { n: "BCUsrs", f: yo },
    408: { n: "UsrChk", f: Ro },
    425: { n: "UserBView", f: Do },
    426: { n: "UserSViewBegin", f: Oo },
    427: { n: "UserSViewEnd", f: Fo },
    428: { n: "RRDUserView", f: Po },
    429: { n: "Qsi", f: No },
    430: { n: "SupBook", f: vi },
    431: { n: "Prot4Rev", f: As },
    432: { n: "CondFmt", f: Lo },
    433: { n: "CF", f: Mo },
    434: { n: "DVal", f: Uo },
    437: { n: "DConBin", f: Ho },
    438: { n: "TxO", f: Ri },
    439: { n: "RefreshAll", f: Ts },
    440: { n: "HLink", f: Di },
    441: { n: "Lel", f: Wo },
    442: { n: "CodeName", f: Vo },
    443: { n: "SXFDBType", f: zo },
    444: { n: "Prot4RevPass", f: Bs },
    445: { n: "ObNoMacros", f: Xo },
    446: { n: "Dv", f: Go },
    448: { n: "Excel9File", f: os },
    449: { n: "RecalcId", f: Yn, r: 2 },
    450: { n: "EntExU2", f: ss },
    512: { n: "Dimensions", f: ti },
    513: { n: "Blank", f: Gi },
    515: { n: "Number", f: ui },
    516: { n: "Label", f: qn },
    517: { n: "BoolErr", f: hi },
    518: { n: "Formula", f: Vp },
    519: { n: "String", f: Ds },
    520: { n: "Row", f: Gn },
    523: { n: "Index", f: jo },
    545: { n: "Array", f: wi },
    549: { n: "DefaultRowHeight", f: $n },
    566: { n: "Table", f: Ko },
    574: { n: "Window2", f: zi },
    638: { n: "RK", f: ai },
    659: { n: "Style", f: Wi },
    1030: { n: "Formula", f: Vp },
    1048: { n: "BigName", f: Yo },
    1054: { n: "Format", f: ei },
    1084: { n: "ContinueBigName", f: $o },
    1212: { n: "ShrFmla", f: Si },
    2048: { n: "HLinkTooltip", f: Oi },
    2049: { n: "WebPub", f: Zo },
    2050: { n: "QsiSXTag", f: Qo },
    2051: { n: "DBQueryExt", f: Jo },
    2052: { n: "ExtString", f: qo },
    2053: { n: "TxtQry", f: el },
    2054: { n: "Qsir", f: rl },
    2055: { n: "Qsif", f: tl },
    2056: { n: "RRDTQSIF", f: al },
    2057: { n: "BOF", f: Un },
    2058: { n: "OleDbConn", f: nl },
    2059: { n: "WOpt", f: il },
    2060: { n: "SXViewEx", f: sl },
    2061: { n: "SXTH", f: fl },
    2062: { n: "SXPIEx", f: ol },
    2063: { n: "SXVDTEx", f: ll },
    2064: { n: "SXViewEx9", f: cl },
    2066: { n: "ContinueFrt", f: hl },
    2067: { n: "RealTimeData", f: ul },
    2128: { n: "ChartFrtInfo", f: dl },
    2129: { n: "FrtWrapper", f: vl },
    2130: { n: "StartBlock", f: pl },
    2131: { n: "EndBlock", f: gl },
    2132: { n: "StartObject", f: bl },
    2133: { n: "EndObject", f: ml },
    2134: { n: "CatLab", f: Cl },
    2135: { n: "YMult", f: El },
    2136: { n: "SXViewLink", f: kl },
    2137: { n: "PivotChartBits", f: Sl },
    2138: { n: "FrtFontList", f: wl },
    2146: { n: "SheetExt", f: Al },
    2147: { n: "BookExt", f: Bl, r: 12 },
    2148: { n: "SXAddl", f: _l },
    2149: { n: "CrErr", f: Tl },
    2150: { n: "HFPicture", f: xl },
    2151: { n: "FeatHdr", f: ls },
    2152: { n: "Feat", f: Il },
    2154: { n: "DataLabExt", f: yl },
    2155: { n: "DataLabExtContents", f: Rl },
    2156: { n: "CellWatch", f: Dl },
    2161: { n: "FeatHdr11", f: Ol },
    2162: { n: "Feature11", f: Fl },
    2164: { n: "DropDownObjIds", f: Pl },
    2165: { n: "ContinueFrt11", f: Nl },
    2166: { n: "DConn", f: Ll },
    2167: { n: "List12", f: Ml },
    2168: { n: "Feature12", f: Ul },
    2169: { n: "CondFmt12", f: Hl },
    2170: { n: "CF12", f: Wl },
    2171: { n: "CFEx", f: Vl },
    2172: { n: "XFCRC", f: Li, r: 12 },
    2173: { n: "XFExt", f: Gd, r: 12 },
    2174: { n: "AutoFilter12", f: zl },
    2175: { n: "ContinueFrt12", f: Xl },
    2180: { n: "MDTInfo", f: Gl },
    2181: { n: "MDXStr", f: jl },
    2182: { n: "MDXTuple", f: Kl },
    2183: { n: "MDXSet", f: Yl },
    2184: { n: "MDXProp", f: $l },
    2185: { n: "MDXKPI", f: Zl },
    2186: { n: "MDB", f: Ql },
    2187: { n: "PLV", f: Jl },
    2188: { n: "Compat12", f: ts, r: 12 },
    2189: { n: "DXF", f: ql },
    2190: { n: "TableStyles", f: ec, r: 12 },
    2191: { n: "TableStyle", f: rc },
    2192: { n: "TableStyleElement", f: tc },
    2194: { n: "StyleExt", f: Vi },
    2195: { n: "NamePublish", f: ac },
    2196: { n: "NameCmt", f: ki, r: 12 },
    2197: { n: "SortData", f: nc },
    2198: { n: "Theme", f: Ud, r: 12 },
    2199: { n: "GUIDTypeLib", f: ic },
    2200: { n: "FnGrp12", f: sc },
    2201: { n: "NameFnGrp12", f: fc },
    2202: { n: "MTRSettings", f: Ai, r: 12 },
    2203: { n: "CompressPictures", f: Kn },
    2204: { n: "HeaderFooter", f: oc },
    2205: { n: "CrtLayout12", f: lc },
    2206: { n: "CrtMlFrt", f: cc },
    2207: { n: "CrtMlFrtContinue", f: hc },
    2211: { n: "ForceFullCalculation", f: jn },
    2212: { n: "ShapePropsStream", f: uc },
    2213: { n: "TextPropsStream", f: dc },
    2214: { n: "RichTextStream", f: vc },
    2215: { n: "CrtLayout12A", f: pc },
    4097: { n: "Units", f: gc },
    4098: { n: "Chart", f: bc },
    4099: { n: "Series", f: mc },
    4102: { n: "DataFormat", f: Cc },
    4103: { n: "LineFormat", f: Ec },
    4105: { n: "MarkerFormat", f: kc },
    4106: { n: "AreaFormat", f: Sc },
    4107: { n: "PieFormat", f: wc },
    4108: { n: "AttachedLabel", f: Ac },
    4109: { n: "SeriesText", f: Bc },
    4116: { n: "ChartFormat", f: _c },
    4117: { n: "Legend", f: Tc },
    4118: { n: "SeriesList", f: xc },
    4119: { n: "Bar", f: Ic },
    4120: { n: "Line", f: yc },
    4121: { n: "Pie", f: Rc },
    4122: { n: "Area", f: Dc },
    4123: { n: "Scatter", f: Oc },
    4124: { n: "CrtLine", f: Fc },
    4125: { n: "Axis", f: Pc },
    4126: { n: "Tick", f: Nc },
    4127: { n: "ValueRange", f: Lc },
    4128: { n: "CatSerRange", f: Mc },
    4129: { n: "AxisLine", f: Uc },
    4130: { n: "CrtLink", f: Hc },
    4132: { n: "DefaultText", f: Wc },
    4133: { n: "Text", f: Vc },
    4134: { n: "FontX", f: cs },
    4135: { n: "ObjectLink", f: zc },
    4146: { n: "Frame", f: Xc },
    4147: { n: "Begin", f: Gc },
    4148: { n: "End", f: jc },
    4149: { n: "PlotArea", f: Kc },
    4154: { n: "Chart3d", f: Yc },
    4156: { n: "PicF", f: $c },
    4157: { n: "DropBar", f: Zc },
    4158: { n: "Radar", f: Qc },
    4159: { n: "Surf", f: Jc },
    4160: { n: "RadarArea", f: qc },
    4161: { n: "AxisParent", f: eh },
    4163: { n: "LegendException", f: rh },
    4164: { n: "ShtProps", f: Hi },
    4165: { n: "SerToCrt", f: th },
    4166: { n: "AxesUsed", f: ah },
    4168: { n: "SBaseRef", f: nh },
    4170: { n: "SerParent", f: ih },
    4171: { n: "SerAuxTrend", f: sh },
    4174: { n: "IFmtRecord", f: fh },
    4175: { n: "Pos", f: oh },
    4176: { n: "AlRuns", f: lh },
    4177: { n: "BRAI", f: ch },
    4187: { n: "SerAuxErrBar", f: hh },
    4188: { n: "ClrtClient", f: Pi },
    4189: { n: "SerFmt", f: uh },
    4191: { n: "Chart3DBarShape", f: dh },
    4192: { n: "Fbi", f: vh },
    4193: { n: "BopPop", f: ph },
    4194: { n: "AxcExt", f: gh },
    4195: { n: "Dat", f: bh },
    4196: { n: "PlotGrowth", f: mh },
    4197: { n: "SIIndex", f: Ch },
    4198: { n: "GelFrame", f: Eh },
    4199: { n: "BopPopCustom", f: kh },
    4200: { n: "Fbi2", f: Sh },
    0: { n: "Dimensions", f: ti },
    2: { n: "BIFF2INT", f: Th },
    5: { n: "BoolErr", f: hi },
    7: { n: "String", f: xh },
    8: { n: "BIFF2ROW", f: Cr },
    11: { n: "Index", f: jo },
    22: { n: "ExternCount", f: Ei },
    30: { n: "BIFF2FORMAT", f: ri },
    31: { n: "BIFF2FMTCNT", f: Cr },
    32: { n: "BIFF2COLINFO", f: Cr },
    33: { n: "Array", f: wi },
    37: { n: "DefaultRowHeight", f: $n },
    50: { n: "BIFF2FONTXTRA", f: Ih },
    62: { n: "BIFF2WINDOW2", f: Cr },
    69: { n: "BIFF2FONTCLR", f: Cr },
    86: { n: "BIFF4FMTCNT", f: Cr },
    126: { n: "RK", f: Cr },
    127: { n: "ImData", f: wh },
    135: { n: "Addin", f: Cr },
    136: { n: "Edg", f: Cr },
    137: { n: "Pub", f: Cr },
    145: { n: "Sub", f: Cr },
    148: { n: "LHRecord", f: Cr },
    149: { n: "LHNGraph", f: Cr },
    150: { n: "Sound", f: Cr },
    169: { n: "CoordList", f: Cr },
    171: { n: "GCW", f: Cr },
    188: { n: "ShrFmla", f: Cr },
    194: { n: "AddMenu", f: Cr },
    195: { n: "DelMenu", f: Cr },
    214: { n: "RString", f: yh },
    223: { n: "UDDesc", f: Cr },
    234: { n: "TabIdConf", f: Cr },
    354: { n: "XL5Modify", f: Cr },
    421: { n: "FileSharing2", f: Cr },
    521: { n: "BOF", f: Un },
    536: { n: "Lbl", f: bi },
    547: { n: "ExternName", f: pi },
    561: { n: "Font", f: Cr },
    1033: { n: "BOF", f: Un },
    2157: { n: "FeatInfo", f: Cr },
    2163: { n: "FeatInfo11", f: Cr },
    2177: { n: "SXAddl12", f: Cr },
    2240: { n: "AutoWebPub", f: Cr },
    2241: { n: "ListObj", f: Cr },
    2242: { n: "ListField", f: Cr },
    2243: { n: "ListDV", f: Cr },
    2244: { n: "ListCondFmt", f: Cr },
    2245: { n: "ListCF", f: Cr },
    2246: { n: "FMQry", f: Cr },
    2247: { n: "FMSQry", f: Cr },
    2248: { n: "PLV", f: Cr },
    2249: { n: "LnExt", f: Cr },
    2250: { n: "MkrExt", f: Cr },
    2251: { n: "CrtCoopt", f: Cr },
    67: { n: "BIFF2XF", f: Cr },
    579: { n: "BIFF3XF", f: Cr },
    1091: { n: "BIFF4XF", f: Cr },
    29282: {},
  };
  function EC(e, r, t, a) {
    var n = a || (t || []).length;
    var i = e.next(4 + n);
    i.write_shift(2, r);
    i.write_shift(2, n);
    if (n > 0 && nr(t)) e.push(t);
  }
  function kC(e, r) {
    if (r.bookType != "biff2") throw "unsupported BIFF version";
    var t = Sr(4);
    t.write_shift(2, 2);
    t.write_shift(2, 16);
    return t;
  }
  function SC(e, r, t) {
    if (!e) e = Sr(7);
    e.write_shift(2, r);
    e.write_shift(2, t);
    e.write_shift(1, 0);
    e.write_shift(1, 0);
    e.write_shift(1, 0);
    return e;
  }
  function wC(e, r, t) {
    var a = Sr(9);
    SC(a, e, r);
    a.write_shift(2, t);
    return a;
  }
  function AC(e, r, t) {
    var a = Sr(15);
    SC(a, e, r);
    a.write_shift(8, t, "f");
    return a;
  }
  function BC(e, r, t, a) {
    var n = Sr(9);
    SC(n, e, r);
    if (a == "e") {
      n.write_shift(1, t);
      n.write_shift(1, 1);
    } else {
      n.write_shift(1, t ? 1 : 0);
      n.write_shift(1, 0);
    }
    return n;
  }
  function _C(e, r, t) {
    var a = Sr(8 + 2 * t.length);
    SC(a, e, r);
    a.write_shift(1, t.length);
    a.write_shift(t.length, t, "sbcs");
    return a.l < a.length ? a.slice(0, a.l) : a;
  }
  function TC(e, r, t, a, n) {
    if (r.v != null)
      switch (r.t) {
        case "d":
        case "n":
          var i = r.t == "d" ? P(r.v) : r.v;
          if (i == (i | 0) && i >= 0 && i < 65536) EC(e, 2, wC(t, a, i));
          else EC(e, 3, AC(t, a, i));
          return;
        case "b":
        case "e":
          EC(e, 5, BC(t, a, r.v, r.t));
          return;
        case "s":
        case "str":
          EC(e, 4, _C(t, a, r.v));
          return;
      }
    EC(e, 1, SC(null, t, a));
  }
  function xC(e, r, t, a, n) {
    var i = Array.isArray(r);
    var s = Kr(r["!ref"] || "A1"),
      f,
      o = "",
      l = [];
    for (var c = s.s.r; c <= s.e.r; ++c) {
      o = Or(c);
      for (var h = s.s.c; h <= s.e.c; ++h) {
        if (c === s.s.r) l[h] = Lr(h);
        f = l[h] + o;
        var u = i ? (r[c] || [])[h] : r[f];
        if (!u) continue;
        TC(e, u, c, h, a);
      }
    }
  }
  function IC(e, r) {
    var t = r || {};
    if (c != null && t.dense == null) t.dense = c;
    var a = Ar();
    var n = 0;
    for (var i = 0; i < e.SheetNames.length; ++i)
      if (e.SheetNames[i] == t.sheet) n = i;
    if (n == 0 && !!t.sheet && e.SheetNames[0] != t.sheet)
      throw new Error("Sheet not found: " + t.sheet);
    EC(a, 9, kC(e, t));
    xC(a, e.Sheets[e.SheetNames[n]], n, t, e);
    EC(a, 10);
    return a.end();
  }
  var yC = (function () {
    function e(e, r) {
      var t = r || {};
      if (c != null && t.dense == null) t.dense = c;
      var a = t.dense ? [] : {};
      var n = e.match(/<table/i);
      if (!n) throw new Error("Invalid HTML: could not find <table>");
      var i = e.match(/<\/table/i);
      var s = n.index,
        f = (i && i.index) || e.length;
      var o = e.slice(s, f).split(/(:?<tr[^>]*>)/i);
      var l = -1,
        h = 0,
        u = 0,
        d = 0;
      var v = { s: { r: 1e7, c: 1e7 }, e: { r: 0, c: 0 } };
      var p = [],
        g = 0;
      for (s = 0; s < o.length; ++s) {
        var b = o[s].trim();
        var m = b.substr(0, 3).toLowerCase();
        if (m == "<tr") {
          ++l;
          h = 0;
          continue;
        }
        if (m != "<td") continue;
        var C = b.split(/<\/td>/i);
        for (f = 0; f < C.length; ++f) {
          var E = C[f].trim();
          if (E.substr(0, 3).toLowerCase() != "<td") continue;
          var k = E,
            S = 0;
          while (k.charAt(0) == "<" && (S = k.indexOf(">")) > -1)
            k = k.slice(S + 1);
          while (k.indexOf(">") > -1) k = k.slice(0, k.lastIndexOf("<"));
          var w = se(E.slice(0, E.indexOf(">")));
          d = w.colspan ? +w.colspan : 1;
          if ((u = +w.rowspan) > 0 || d > 1)
            p.push({
              s: { r: l, c: h },
              e: { r: l + (u || 1) - 1, c: h + d - 1 },
            });
          if (!k.length) {
            h += d;
            continue;
          }
          k = ce(k).replace(/[\r\n]/g, "");
          if (v.s.r > l) v.s.r = l;
          if (v.e.r < l) v.e.r = l;
          if (v.s.c > h) v.s.c = h;
          if (v.e.c < h) v.e.c = h;
          if (t.dense) {
            if (!a[l]) a[l] = [];
            if (Number(k) == Number(k)) a[l][h] = { t: "n", v: +k };
            else a[l][h] = { t: "s", v: k };
          } else {
            var A = Vr({ r: l, c: h });
            if (Number(k) == Number(k)) a[A] = { t: "n", v: +k };
            else a[A] = { t: "s", v: k };
          }
          h += d;
        }
      }
      a["!ref"] = jr(v);
      return a;
    }
    function r(r, t) {
      return Zr(e(r, t), t);
    }
    function t(e, r, t, a) {
      var n = e["!merges"] || [];
      var i = [];
      var s = "<td" + (a.editable ? ' contenteditable="true"' : "") + "></td>";
      for (var f = r.s.c; f <= r.e.c; ++f) {
        var o = 0,
          l = 0;
        for (var c = 0; c < n.length; ++c) {
          if (n[c].s.r > t || n[c].s.c > f) continue;
          if (n[c].e.r < t || n[c].e.c < f) continue;
          if (n[c].s.r < t || n[c].s.c < f) {
            o = -1;
            break;
          }
          o = n[c].e.r - n[c].s.r + 1;
          l = n[c].e.c - n[c].s.c + 1;
          break;
        }
        if (o < 0) continue;
        var h = Vr({ r: t, c: f });
        var u = a.dense ? (e[t] || [])[f] : e[h];
        if (!u || u.v == null) {
          i.push(s);
          continue;
        }
        var d = u.h || de(u.w || ($r(u), u.w) || "");
        var v = {};
        if (o > 1) v.rowspan = o;
        if (l > 1) v.colspan = l;
        if (a.editable) v.contenteditable = "true";
        v.id = "sjs-" + h;
        i.push(De("td", d, v));
      }
      var p = "<tr>";
      return p + i.join("") + "</tr>";
    }
    function a(e, r, t) {
      var a = [];
      return a.join("") + "<table>";
    }
    var n =
      '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
    var i = "</body></html>";
    function s(e, r, s) {
      var f = r || {};
      var o = f.header != null ? f.header : n;
      var l = f.footer != null ? f.footer : i;
      var c = [o];
      var h = Gr(e["!ref"]);
      f.dense = Array.isArray(e);
      c.push(a(e, h, f));
      for (var u = h.s.r; u <= h.e.r; ++u) c.push(t(e, h, u, f));
      c.push("</table>" + l);
      return c.join("");
    }
    return {
      to_workbook: r,
      to_sheet: e,
      _row: t,
      BEGIN: n,
      END: i,
      _preamble: a,
      from_sheet: s,
    };
  })();
  function RC(e, r) {
    var t = r || {};
    if (c != null) t.dense = c;
    var a = t.dense ? [] : {};
    var n = e.getElementsByTagName("tr");
    var i = { s: { r: 0, c: 0 }, e: { r: n.length - 1, c: 0 } };
    var s = [],
      f = 0;
    var o = 0,
      l = 0,
      h = 0,
      u = 0,
      d = 0;
    for (; o < n.length; ++o) {
      var v = n[o];
      var p = v.children;
      for (l = h = 0; l < p.length; ++l) {
        var g = p[l],
          b = p[l].innerText || p[l].textContent;
        for (f = 0; f < s.length; ++f) {
          var m = s[f];
          if (m.s.c == h && m.s.r <= o && o <= m.e.r) {
            h = m.e.c + 1;
            f = -1;
          }
        }
        d = +g.getAttribute("colspan") || 1;
        if ((u = +g.getAttribute("rowspan")) > 0 || d > 1)
          s.push({
            s: { r: o, c: h },
            e: { r: o + (u || 1) - 1, c: h + d - 1 },
          });
        var E = { t: "s", v: b };
        if (b != null && b.length) {
          if (!isNaN(Number(b))) E = { t: "n", v: Number(b) };
          else if (!isNaN(G(b).getDate())) {
            E = { t: "d", v: H(b) };
            if (!t.cellDates) E = { t: "n", v: P(E.v) };
            E.z = t.dateNF || C._table[14];
          }
        }
        if (t.dense) {
          if (!a[o]) a[o] = [];
          a[o][h] = E;
        } else a[Vr({ c: h, r: o })] = E;
        if (i.e.c < h) i.e.c = h;
        h += d;
      }
    }
    a["!merges"] = s;
    a["!ref"] = jr(i);
    return a;
  }
  function DC(e, r) {
    return Zr(RC(e, r), r);
  }
  var OC = (function () {
    var e = function (e, r) {
      return ce(e.replace(/<text:s\/>/g, " ").replace(/<[^>]*>/g, ""));
    };
    var r = {
      day: ["d", "dd"],
      month: ["m", "mm"],
      year: ["y", "yy"],
      hours: ["h", "hh"],
      minutes: ["m", "mm"],
      seconds: ["s", "ss"],
      "am-pm": ["A/P", "AM/PM"],
      "day-of-week": ["ddd", "dddd"],
    };
    return function t(a, n) {
      var i = n || {};
      if (c != null && i.dense == null) i.dense = c;
      var s = Zm(a);
      var f = [],
        o;
      var l;
      var h = { name: "" },
        u = "",
        d = 0;
      var v;
      var p;
      var g = {},
        b = [];
      var m = i.dense ? [] : {};
      var C, E;
      var k = { value: "" };
      var S = "",
        w = 0,
        A;
      var B = -1,
        _ = -1,
        T = { s: { r: 1e6, c: 1e7 }, e: { r: 0, c: 0 } };
      var x = {};
      var I = [],
        y = {},
        R = 0,
        D = 0;
      var O = [];
      var F = [],
        N = {};
      var M = "",
        U = 0;
      var W = 1,
        V = false;
      var X = 0;
      Qm.lastIndex = 0;
      s = s
        .replace(/<!--([\s\S]*?)-->/gm, "")
        .replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
      while ((C = Qm.exec(s)))
        switch ((C[3] = C[3].replace(/_.*$/, ""))) {
          case "table":
          case "工作表":
            if (C[1] === "/") {
              if (T.e.c >= T.s.c && T.e.r >= T.s.r) m["!ref"] = jr(T);
              if (I.length) m["!merges"] = I;
              v.name = Ee(v["名称"] || v.name);
              b.push(v.name);
              g[v.name] = m;
            } else if (C[0].charAt(C[0].length - 2) !== "/") {
              v = se(C[0], false);
              B = _ = -1;
              T.s.r = T.s.c = 1e7;
              T.e.r = T.e.c = 0;
              m = i.dense ? [] : {};
              I = [];
            }
            break;
          case "table-row":
          case "行":
            if (C[1] === "/") break;
            p = se(C[0], false);
            if (p["行号"]) B = p["行号"] - 1;
            else ++B;
            _ = -1;
            break;
          case "covered-table-cell":
            ++_;
            if (i.sheetStubs) {
              if (i.dense) {
                if (!m[B]) m[B] = [];
                m[B][_] = { t: "z" };
              } else m[Vr({ r: B, c: _ })] = { t: "z" };
            }
            break;
          case "table-cell":
          case "数据":
            if (C[0].charAt(C[0].length - 2) === "/") {
              k = se(C[0], false);
              if (k["number-columns-repeated"])
                _ += parseInt(k["number-columns-repeated"], 10);
              else ++_;
            } else if (C[1] !== "/") {
              ++_;
              W = 1;
              if (_ > T.e.c) T.e.c = _;
              if (B > T.e.r) T.e.r = B;
              if (_ < T.s.c) T.s.c = _;
              if (B < T.s.r) T.s.r = B;
              k = se(C[0], false);
              F = [];
              N = {};
              E = { t: k["数据类型"] || k["value-type"], v: null };
              if (i.cellFormula) {
                if (k.formula) k.formula = ce(k.formula);
                if (
                  k["number-matrix-columns-spanned"] &&
                  k["number-matrix-rows-spanned"]
                ) {
                  R = parseInt(k["number-matrix-rows-spanned"], 10) || 0;
                  D = parseInt(k["number-matrix-columns-spanned"], 10) || 0;
                  y = { s: { r: B, c: _ }, e: { r: B + R - 1, c: _ + D - 1 } };
                  E.F = jr(y);
                  O.push([y, E.F]);
                }
                if (k.formula) E.f = cg(k.formula);
                else
                  for (X = 0; X < O.length; ++X)
                    if (B >= O[X][0].s.r && B <= O[X][0].e.r)
                      if (_ >= O[X][0].s.c && _ <= O[X][0].e.c) E.F = O[X][1];
              }
              if (k["number-columns-spanned"] || k["number-rows-spanned"]) {
                R = parseInt(k["number-rows-spanned"], 10) || 0;
                D = parseInt(k["number-columns-spanned"], 10) || 0;
                y = { s: { r: B, c: _ }, e: { r: B + R - 1, c: _ + D - 1 } };
                I.push(y);
              }
              if (k["number-columns-repeated"])
                W = parseInt(k["number-columns-repeated"], 10);
              switch (E.t) {
                case "boolean":
                  E.t = "b";
                  E.v = Ce(k["boolean-value"]);
                  break;
                case "float":
                  E.t = "n";
                  E.v = parseFloat(k.value);
                  break;
                case "percentage":
                  E.t = "n";
                  E.v = parseFloat(k.value);
                  break;
                case "currency":
                  E.t = "n";
                  E.v = parseFloat(k.value);
                  break;
                case "date":
                  E.t = "d";
                  E.v = H(k["date-value"]);
                  if (!i.cellDates) {
                    E.t = "n";
                    E.v = P(E.v);
                  }
                  E.z = "m/d/yy";
                  break;
                case "time":
                  E.t = "n";
                  E.v = L(k["time-value"]) / 86400;
                  break;
                case "number":
                  E.t = "n";
                  E.v = parseFloat(k["数据数值"]);
                  break;
                default:
                  if (E.t === "string" || E.t === "text" || !E.t) {
                    E.t = "s";
                    if (k["string-value"] != null) S = ce(k["string-value"]);
                  } else throw new Error("Unsupported value type " + E.t);
              }
            } else {
              V = false;
              if (E.t === "s") {
                E.v = S || "";
                V = w == 0;
              }
              if (F.length > 0) {
                E.c = F;
                F = [];
              }
              if (S && i.cellText !== false) E.w = S;
              if (!V || i.sheetStubs) {
                if (!(i.sheetRows && i.sheetRows < B)) {
                  if (i.dense) {
                    if (!m[B]) m[B] = [];
                    m[B][_] = E;
                    while (--W > 0) m[B][++_] = z(E);
                  } else {
                    m[Vr({ r: B, c: _ })] = E;
                    while (--W > 0) m[Vr({ r: B, c: ++_ })] = z(E);
                  }
                  if (T.e.c <= _) T.e.c = _;
                }
              } else {
                _ += W;
                W = 0;
              }
              E = {};
              S = "";
            }
            break;
          case "document":
          case "document-content":
          case "电子表格文档":
          case "spreadsheet":
          case "主体":
          case "scripts":
          case "styles":
          case "font-face-decls":
            if (C[1] === "/") {
              if ((o = f.pop())[0] !== C[3]) throw "Bad state: " + o;
            } else if (C[0].charAt(C[0].length - 2) !== "/")
              f.push([C[3], true]);
            break;
          case "annotation":
            if (C[1] === "/") {
              if ((o = f.pop())[0] !== C[3]) throw "Bad state: " + o;
              N.t = S;
              N.a = M;
              F.push(N);
            } else if (C[0].charAt(C[0].length - 2) !== "/") {
              f.push([C[3], false]);
            }
            M = "";
            U = 0;
            S = "";
            w = 0;
            break;
          case "creator":
            if (C[1] === "/") {
              M = s.slice(U, C.index);
            } else U = C.index + C[0].length;
            break;
          case "meta":
          case "元数据":
          case "settings":
          case "config-item-set":
          case "config-item-map-indexed":
          case "config-item-map-entry":
          case "config-item-map-named":
          case "shapes":
          case "frame":
          case "text-box":
          case "image":
          case "data-pilot-tables":
          case "list-style":
          case "form":
          case "dde-links":
          case "event-listeners":
            if (C[1] === "/") {
              if ((o = f.pop())[0] !== C[3]) throw "Bad state: " + o;
            } else if (C[0].charAt(C[0].length - 2) !== "/")
              f.push([C[3], false]);
            S = "";
            w = 0;
            break;
          case "scientific-number":
            break;
          case "currency-symbol":
            break;
          case "currency-style":
            break;
          case "number-style":
          case "percentage-style":
          case "date-style":
          case "time-style":
            if (C[1] === "/") {
              x[h.name] = u;
              if ((o = f.pop())[0] !== C[3]) throw "Bad state: " + o;
            } else if (C[0].charAt(C[0].length - 2) !== "/") {
              u = "";
              h = se(C[0], false);
              f.push([C[3], true]);
            }
            break;
          case "script":
            break;
          case "libraries":
            break;
          case "automatic-styles":
            break;
          case "master-styles":
            break;
          case "default-style":
          case "page-layout":
            break;
          case "style":
            break;
          case "map":
            break;
          case "font-face":
            break;
          case "paragraph-properties":
            break;
          case "table-properties":
            break;
          case "table-column-properties":
            break;
          case "table-row-properties":
            break;
          case "table-cell-properties":
            break;
          case "number":
            switch (f[f.length - 1][0]) {
              case "time-style":
              case "date-style":
                l = se(C[0], false);
                u += r[C[3]][l.style === "long" ? 1 : 0];
                break;
            }
            break;
          case "fraction":
            break;
          case "day":
          case "month":
          case "year":
          case "era":
          case "day-of-week":
          case "week-of-year":
          case "quarter":
          case "hours":
          case "minutes":
          case "seconds":
          case "am-pm":
            switch (f[f.length - 1][0]) {
              case "time-style":
              case "date-style":
                l = se(C[0], false);
                u += r[C[3]][l.style === "long" ? 1 : 0];
                break;
            }
            break;
          case "boolean-style":
            break;
          case "boolean":
            break;
          case "text-style":
            break;
          case "text":
            if (C[0].slice(-2) === "/>") break;
            else if (C[1] === "/")
              switch (f[f.length - 1][0]) {
                case "number-style":
                case "date-style":
                case "time-style":
                  u += s.slice(d, C.index);
                  break;
              }
            else d = C.index + C[0].length;
            break;
          case "text-content":
            break;
          case "text-properties":
            break;
          case "body":
          case "电子表格":
            break;
          case "forms":
            break;
          case "table-column":
            break;
          case "table-header-rows":
            break;
          case "table-row-group":
            break;
          case "table-column-group":
            break;
          case "table-header-columns":
            break;
          case "null-date":
            break;
          case "graphic-properties":
            break;
          case "calculation-settings":
            break;
          case "named-expressions":
            break;
          case "named-range":
            break;
          case "label-range":
            break;
          case "label-ranges":
            break;
          case "named-expression":
            break;
          case "sort":
            break;
          case "sort-by":
            break;
          case "sort-groups":
            break;
          case "tab":
            break;
          case "line-break":
            break;
          case "span":
            break;
          case "p":
          case "文本串":
            if (C[1] === "/")
              S = (S.length > 0 ? S + "\n" : "") + e(s.slice(w, C.index), A);
            else {
              A = se(C[0], false);
              w = C.index + C[0].length;
            }
            break;
          case "database-range":
            if (C[1] === "/") break;
            try {
              var G = ug(se(C[0])["target-range-address"]);
              g[G[0]]["!autofilter"] = { ref: G[1] };
            } catch (j) {}
            break;
          case "s":
            break;
          case "date":
            break;
          case "object":
            break;
          case "title":
          case "标题":
            break;
          case "desc":
            break;
          case "table-source":
            break;
          case "scenario":
            break;
          case "iteration":
            break;
          case "content-validations":
            break;
          case "content-validation":
            break;
          case "help-message":
            break;
          case "error-message":
            break;
          case "database-ranges":
            break;
          case "filter":
            break;
          case "filter-and":
            break;
          case "filter-or":
            break;
          case "filter-condition":
            break;
          case "list-level-style-bullet":
            break;
          case "list-level-style-number":
            break;
          case "list-level-properties":
            break;
          case "sender-firstname":
          case "sender-lastname":
          case "sender-initials":
          case "sender-title":
          case "sender-position":
          case "sender-email":
          case "sender-phone-private":
          case "sender-fax":
          case "sender-company":
          case "sender-phone-work":
          case "sender-street":
          case "sender-city":
          case "sender-postal-code":
          case "sender-country":
          case "sender-state-or-province":
          case "author-name":
          case "author-initials":
          case "chapter":
          case "file-name":
          case "template-name":
          case "sheet-name":
            break;
          case "event-listener":
            break;
          case "initial-creator":
          case "creation-date":
          case "generator":
          case "document-statistic":
          case "user-defined":
            break;
          case "config-item":
            break;
          case "page-number":
            break;
          case "page-count":
            break;
          case "time":
            break;
          case "cell-range-source":
            break;
          case "detective":
            break;
          case "operation":
            break;
          case "highlighted-range":
            break;
          case "data-pilot-table":
          case "source-cell-range":
          case "source-service":
          case "data-pilot-field":
          case "data-pilot-level":
          case "data-pilot-subtotals":
          case "data-pilot-subtotal":
          case "data-pilot-members":
          case "data-pilot-member":
          case "data-pilot-display-info":
          case "data-pilot-sort-info":
          case "data-pilot-layout-info":
          case "data-pilot-field-reference":
          case "data-pilot-groups":
          case "data-pilot-group":
          case "data-pilot-group-member":
            break;
          case "rect":
            break;
          case "dde-connection-decls":
          case "dde-connection-decl":
          case "dde-link":
          case "dde-source":
            break;
          case "properties":
            break;
          case "property":
            break;
          case "a":
            break;
          case "table-protection":
            break;
          case "data-pilot-grand-total":
            break;
          case "office-document-common-attrs":
            break;
          default:
            if (C[2] === "dc:") break;
            if (C[2] === "draw:") break;
            if (C[2] === "style:") break;
            if (C[2] === "form:") break;
            if (C[2] === "calcext:") break;
            if (C[2] === "loext:") break;
            if (C[2] === "uof:") break;
            if (C[2] === "表:") break;
            if (C[2] === "字:") break;
            if (i.WTF) throw new Error(C);
        }
      var K = { Sheets: g, SheetNames: b };
      return K;
    };
  })();
  function FC(e, r) {
    r = r || {};
    var t = !!$(e, "objectdata");
    if (t) var a = ua(Q(e, "META-INF/manifest.xml"), r);
    var n = J(e, "content.xml");
    if (!n)
      throw new Error(
        "Missing content.xml in " + (t ? "ODS" : "UOF") + " file"
      );
    return OC(t ? n : Ee(n), r);
  }
  function PC(e, r) {
    return OC(e, r);
  }
  var NC = (function () {
    var e =
      '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-styles xmlns:table="urn:oasis:names:tc:opendocument:xmlns:table:1.0" xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:text="urn:oasis:names:tc:opendocument:xmlns:text:1.0" xmlns:style="urn:oasis:names:tc:opendocument:xmlns:style:1.0" xmlns:draw="urn:oasis:names:tc:opendocument:xmlns:drawing:1.0" xmlns:fo="urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:number="urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0" xmlns:svg="urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0" xmlns:of="urn:oasis:names:tc:opendocument:xmlns:of:1.2" office:version="1.2"></office:document-styles>';
    return function r(t, a) {
      return e;
    };
  })();
  var LC = (function () {
    var e = "          <table:table-cell />\n";
    var r = "          <table:covered-table-cell/>\n";
    var t = function (t, a, n, i) {
      var s = [];
      s.push('      <table:table table:name="' + de(a.SheetNames[n]) + '">\n');
      var f = 0,
        o = 0,
        l = Gr(t["!ref"]);
      var c = t["!merges"] || [],
        h = 0;
      var u = Array.isArray(t);
      for (f = 0; f < l.s.r; ++f)
        s.push("        <table:table-row></table:table-row>\n");
      for (; f <= l.e.r; ++f) {
        s.push("        <table:table-row>\n");
        for (o = 0; o < l.s.c; ++o) s.push(e);
        for (; o <= l.e.c; ++o) {
          var d = false,
            v = {},
            p = "";
          for (h = 0; h != c.length; ++h) {
            if (c[h].s.c > o) continue;
            if (c[h].s.r > f) continue;
            if (c[h].e.c < o) continue;
            if (c[h].e.r < f) continue;
            if (c[h].s.c != o || c[h].s.r != f) d = true;
            v["table:number-columns-spanned"] = c[h].e.c - c[h].s.c + 1;
            v["table:number-rows-spanned"] = c[h].e.r - c[h].s.r + 1;
            break;
          }
          if (d) {
            s.push(r);
            continue;
          }
          var g = Vr({ r: f, c: o }),
            b = u ? (t[f] || [])[o] : t[g];
          if (b && b.f) {
            v["table:formula"] = de(hg(b.f));
            if (b.F) {
              if (b.F.substr(0, g.length) == g) {
                var m = Gr(b.F);
                v["table:number-matrix-columns-spanned"] = m.e.c - m.s.c + 1;
                v["table:number-matrix-rows-spanned"] = m.e.r - m.s.r + 1;
              }
            }
          }
          if (!b) {
            s.push(e);
            continue;
          }
          switch (b.t) {
            case "b":
              p = b.v ? "TRUE" : "FALSE";
              v["office:value-type"] = "boolean";
              v["office:boolean-value"] = b.v ? "true" : "false";
              break;
            case "n":
              p = b.w || String(b.v || 0);
              v["office:value-type"] = "float";
              v["office:value"] = b.v || 0;
              break;
            case "s":
            case "str":
              p = de(b.v);
              v["office:value-type"] = "string";
              break;
            case "d":
              p = b.w || H(b.v).toISOString();
              v["office:value-type"] = "date";
              v["office:date-value"] = H(b.v).toISOString();
              v["table:style-name"] = "ce1";
              break;
            default:
              s.push(e);
              continue;
          }
          s.push(
            "          " + De("table:table-cell", De("text:p", p, {}), v) + "\n"
          );
        }
        s.push("        </table:table-row>\n");
      }
      s.push("      </table:table>\n");
      return s.join("");
    };
    var a = function (e) {
      e.push(" <office:automatic-styles>\n");
      e.push(
        '  <number:date-style style:name="N37" number:automatic-order="true">\n'
      );
      e.push('   <number:month number:style="long"/>\n');
      e.push("   <number:text>/</number:text>\n");
      e.push('   <number:day number:style="long"/>\n');
      e.push("   <number:text>/</number:text>\n");
      e.push("   <number:year/>\n");
      e.push("  </number:date-style>\n");
      e.push(
        '  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n'
      );
      e.push(" </office:automatic-styles>\n");
    };
    return function n(e, r) {
      var n = [Pe];
      var i = Re({
        "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        "xmlns:fo":
          "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xmlns:dc": "http://purl.org/dc/elements/1.1/",
        "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
        "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        "xmlns:presentation":
          "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
        "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
        "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
        "xmlns:math": "http://www.w3.org/1998/Math/MathML",
        "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
        "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
        "xmlns:ooo": "http://openoffice.org/2004/office",
        "xmlns:ooow": "http://openoffice.org/2004/writer",
        "xmlns:oooc": "http://openoffice.org/2004/calc",
        "xmlns:dom": "http://www.w3.org/2001/xml-events",
        "xmlns:xforms": "http://www.w3.org/2002/xforms",
        "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
        "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
        "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
        "xmlns:rpt": "http://openoffice.org/2005/report",
        "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
        "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
        "xmlns:tableooo": "http://openoffice.org/2009/table",
        "xmlns:drawooo": "http://openoffice.org/2010/draw",
        "xmlns:calcext":
          "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
        "xmlns:loext":
          "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
        "xmlns:field":
          "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
        "xmlns:formx":
          "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
        "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
        "office:version": "1.2",
      });
      var s = Re({
        "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
        "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet",
      });
      if (r.bookType == "fods") n.push("<office:document" + i + s + ">\n");
      else n.push("<office:document-content" + i + ">\n");
      a(n);
      n.push("  <office:body>\n");
      n.push("    <office:spreadsheet>\n");
      for (var f = 0; f != e.SheetNames.length; ++f)
        n.push(t(e.Sheets[e.SheetNames[f]], e, f, r));
      n.push("    </office:spreadsheet>\n");
      n.push("  </office:body>\n");
      if (r.bookType == "fods") n.push("</office:document>");
      else n.push("</office:document-content>");
      return n.join("");
    };
  })();
  function MC(e, r) {
    if (r.bookType == "fods") return LC(e, r);
    var t = new ee();
    var a = "";
    var n = [];
    var i = [];
    a = "mimetype";
    t.file(a, "application/vnd.oasis.opendocument.spreadsheet");
    a = "content.xml";
    t.file(a, LC(e, r));
    n.push([a, "text/xml"]);
    i.push([a, "ContentFile"]);
    a = "styles.xml";
    t.file(a, NC(e, r));
    n.push([a, "text/xml"]);
    i.push([a, "StylesFile"]);
    a = "manifest.rdf";
    t.file(a, ga(i, r));
    n.push([a, "application/rdf+xml"]);
    a = "meta.xml";
    t.file(a, ba(e, r));
    n.push([a, "text/xml"]);
    i.push([a, "MetadataFile"]);
    a = "META-INF/manifest.xml";
    t.file(a, da(n, r));
    return t;
  }
  function UC(e) {
    return function r(t, a) {
      var n = 0;
      for (var i = 0; i < t.SheetNames.length; ++i)
        if (t.SheetNames[i] == a.sheet) n = i;
      if (n == 0 && !!a.sheet && t.SheetNames[0] != a.sheet)
        throw new Error("Sheet not found: " + a.sheet);
      return e.from_sheet(t.Sheets[t.SheetNames[n]], a, t);
    };
  }
  var HC = UC(yC);
  var WC = UC({ from_sheet: kE });
  var VC = UC(Dh);
  var zC = UC(Oh);
  var XC = UC(Fh);
  var GC = UC({ from_sheet: SE });
  function jC(e) {
    return function r(t) {
      for (var a = 0; a != e.length; ++a) {
        var n = e[a];
        if (t[n[0]] === undefined) t[n[0]] = n[1];
        if (n[2] === "n") t[n[0]] = Number(t[n[0]]);
      }
    };
  }
  var KC = jC([
    ["cellNF", false],
    ["cellHTML", true],
    ["cellFormula", true],
    ["cellStyles", false],
    ["cellText", true],
    ["cellDates", false],
    ["sheetStubs", false],
    ["sheetRows", 0, "n"],
    ["bookDeps", false],
    ["bookSheets", false],
    ["bookProps", false],
    ["bookFiles", false],
    ["bookVBA", false],
    ["password", ""],
    ["WTF", false],
  ]);
  var YC = jC([
    ["cellDates", false],
    ["bookSST", false],
    ["bookType", "xlsx"],
    ["compression", false],
    ["WTF", false],
  ]);
  function $C(e) {
    if (ia.WS.indexOf(e) > -1) return "sheet";
    if (ia.CS && e == ia.CS) return "chart";
    if (ia.DS && e == ia.DS) return "dialog";
    if (ia.MS && e == ia.MS) return "macro";
    if (!e || !e.length) return "sheet";
    return e;
  }
  function ZC(e, r) {
    if (!e) return 0;
    try {
      e = r.map(function a(r) {
        if (!r.id) r.id = r.strRelID;
        return [r.name, e["!id"][r.id].Target, $C(e["!id"][r.id].Type)];
      });
    } catch (t) {
      return null;
    }
    return !e || e.length === 0 ? null : e;
  }
  function QC(e, r, t, a, n, i, s, f, o, l, c) {
    try {
      n[a] = fa(J(e, t, true), r);
      var h = Q(e, r);
      switch (s) {
        case "sheet":
          i[a] = Am(h, r, f, n[a], o, l, c);
          break;
        case "chart":
          var u = Bm(h, r, f, n[a], o, l, c);
          i[a] = u;
          if (!u || !u["!chart"]) break;
          var d = re(u["!chart"].Target, r);
          var v = sa(d);
          var p = Jd(J(e, d, true), fa(J(e, v, true), d));
          var g = re(p, d);
          var b = sa(g);
          u = Hb(J(e, g, true), g, f, fa(J(e, b, true), g), o, u);
          break;
        case "macro":
          i[a] = _m(h, r, f, n[a], o, l, c);
          break;
        case "dialog":
          i[a] = Tm(h, r, f, n[a], o, l, c);
          break;
      }
    } catch (m) {
      if (f.WTF) throw m;
    }
  }
  var JC = function qE(e) {
    return e.slice(-1) != "/";
  };
  function qC(e, r) {
    E(C);
    r = r || {};
    KC(r);
    a();
    if ($(e, "META-INF/manifest.xml")) return FC(e, r);
    if ($(e, "objectdata.xml")) return FC(e, r);
    var t = x(e.files).filter(JC).sort();
    var i = ra(J(e, "[Content_Types].xml"), r);
    var s = false;
    var f, o;
    if (i.workbooks.length === 0) {
      o = "xl/workbook.xml";
      if (Q(e, o, true)) i.workbooks.push(o);
    }
    if (i.workbooks.length === 0) {
      o = "xl/workbook.bin";
      if (!Q(e, o, true)) throw new Error("Could not find workbook");
      i.workbooks.push(o);
      s = true;
    }
    if (i.workbooks[0].slice(-3) == "bin") s = true;
    if (s) n(1200);
    var l = {};
    var c = {};
    if (!r.bookSheets && !r.bookProps) {
      dg = [];
      if (i.sst) dg = ym(Q(e, i.sst.replace(/^\//, "")), i.sst, r);
      if (r.cellStyles && i.themes.length)
        l = Im(
          J(e, i.themes[0].replace(/^\//, ""), true) || "",
          i.themes[0],
          r
        );
      if (i.style) c = xm(Q(e, i.style.replace(/^\//, "")), i.style, l, r);
    }
    var h = wm(Q(e, i.workbooks[0].replace(/^\//, "")), i.workbooks[0], r);
    var u = {},
      d = "";
    if (i.coreprops.length !== 0) {
      d = J(e, i.coreprops[0].replace(/^\//, ""), true);
      if (d) u = Ea(d);
      if (i.extprops.length !== 0) {
        d = J(e, i.extprops[0].replace(/^\//, ""), true);
        if (d) Ba(d, u);
      }
    }
    var v = {};
    if (!r.bookSheets || r.bookProps) {
      if (i.custprops.length !== 0) {
        d = J(e, i.custprops[0].replace(/^\//, ""), true);
        if (d) v = Ia(d, r);
      }
    }
    var p = {};
    if (r.bookSheets || r.bookProps) {
      if (h.Sheets)
        f = h.Sheets.map(function R(e) {
          return e.name;
        });
      else if (u.Worksheets && u.SheetNames.length > 0) f = u.SheetNames;
      if (r.bookProps) {
        p.Props = u;
        p.Custprops = v;
      }
      if (r.bookSheets && typeof f !== "undefined") p.SheetNames = f;
      if (r.bookSheets ? p.SheetNames : r.bookProps) return p;
    }
    f = {};
    var g = {};
    if (r.bookDeps && i.calcchain)
      g = Dm(Q(e, i.calcchain.replace(/^\//, "")), i.calcchain, r);
    var b = 0;
    var m = {};
    var k, S;
    {
      var w = h.Sheets;
      u.Worksheets = w.length;
      u.SheetNames = [];
      for (var A = 0; A != w.length; ++A) {
        u.SheetNames[A] = w[A].name;
      }
    }
    var B = s ? "bin" : "xml";
    var _ = "xl/_rels/workbook." + B + ".rels";
    var T = fa(J(e, _, true), _);
    if (T) T = ZC(T, h.Sheets);
    var I = Q(e, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    for (b = 0; b != u.Worksheets; ++b) {
      var y = "sheet";
      if (T && T[b]) {
        k = "xl/" + T[b][1].replace(/[\/]?xl\//, "");
        y = T[b][2];
      } else {
        k = "xl/worksheets/sheet" + (b + 1 - I) + "." + B;
        k = k.replace(/sheet0\./, "sheet.");
      }
      S = k.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
      QC(e, k, S, u.SheetNames[b], m, f, y, r, h, l, c);
    }
    if (i.comments) rv(e, i.comments, f, m, r);
    p = {
      Directory: i,
      Workbook: h,
      Props: u,
      Custprops: v,
      Deps: g,
      Sheets: f,
      SheetNames: u.SheetNames,
      Strings: dg,
      Styles: c,
      Themes: l,
      SSF: C.get_table(),
    };
    if (r.bookFiles) {
      p.keys = t;
      p.files = e.files;
    }
    if (r.bookVBA) {
      if (i.vba.length > 0) p.vbaraw = Q(e, i.vba[0].replace(/^\//, ""), true);
      else if (
        i.defaults &&
        i.defaults.bin === "application/vnd.ms-office.vbaProject"
      )
        p.vbaraw = Q(e, "xl/vbaProject.bin", true);
    }
    return p;
  }
  function eE(e, r) {
    var t = "Version";
    var a = e.find(t);
    if (!a || !a.content)
      throw new Error("ECMA-376 Encrypted file missing " + t);
    var n = tu(a.content);
    t = "DataSpaceMap";
    a = e.find(t);
    if (!a || !a.content)
      throw new Error("ECMA-376 Encrypted file missing " + t);
    var i = nu(a.content);
    if (
      i.length != 1 ||
      i[0].comps.length != 1 ||
      i[0].comps[0].t != 0 ||
      i[0].name != "StrongEncryptionDataSpace" ||
      i[0].comps[0].v != "EncryptedPackage"
    )
      throw new Error("ECMA-376 Encrypted file bad " + t);
    t = "StrongEncryptionDataSpace";
    a = e.find(t);
    if (!a || !a.content)
      throw new Error("ECMA-376 Encrypted file missing " + t);
    var s = iu(a.content);
    if (s.length != 1 || s[0] != "StrongEncryptionTransform")
      throw new Error("ECMA-376 Encrypted file bad " + t);
    t = "!Primary";
    a = e.find(t);
    if (!a || !a.content)
      throw new Error("ECMA-376 Encrypted file missing " + t);
    var f = fu(a.content);
    t = "EncryptionInfo";
    a = e.find(t);
    if (!a || !a.content)
      throw new Error("ECMA-376 Encrypted file missing " + t);
    var o = cu(a.content);
    throw new Error("File is password-protected");
  }
  function rE(e, r) {
    qd = 1024;
    if (r.bookType == "ods") return MC(e, r);
    if (e && !e.SSF) {
      e.SSF = C.get_table();
    }
    if (e && e.SSF) {
      E(C);
      C.load_table(e.SSF);
      r.revssf = R(e.SSF);
      r.revssf[e.SSF[65535]] = 0;
      r.ssf = e.SSF;
    }
    r.rels = {};
    r.wbrels = {};
    r.Strings = [];
    r.Strings.Count = 0;
    r.Strings.Unique = 0;
    var t = r.bookType == "xlsb" ? "bin" : "xml";
    var a = r.bookType == "xlsb" || r.bookType == "xlsm";
    var n = ea();
    YC((r = r || {}));
    var i = new ee();
    var s = "",
      f = 0;
    r.cellXfs = [];
    mg(r.cellXfs, {}, { revssf: { General: 0 } });
    if (!e.Props) e.Props = {};
    s = "docProps/core.xml";
    i.file(s, wa(e.Props, r));
    n.coreprops.push(s);
    ca(r.rels, 2, s, ia.CORE_PROPS);
    s = "docProps/app.xml";
    if (e.Props && e.Props.SheetNames) {
    } else if (!e.Workbook || !e.Workbook.Sheets)
      e.Props.SheetNames = e.SheetNames;
    else
      e.Props.SheetNames = e.SheetNames.map(function (r, t) {
        return [(e.Workbook.Sheets[t] || {}).Hidden != 2, r];
      })
        .filter(function (e) {
          return e[0];
        })
        .map(function (e) {
          return e[1];
        });
    e.Props.Worksheets = e.Props.SheetNames.length;
    i.file(s, Ta(e.Props, r));
    n.extprops.push(s);
    ca(r.rels, 3, s, ia.EXT_PROPS);
    if (e.Custprops !== e.Props && x(e.Custprops || {}).length > 0) {
      s = "docProps/custom.xml";
      i.file(s, Ra(e.Custprops, r));
      n.custprops.push(s);
      ca(r.rels, 4, s, ia.CUST_PROPS);
    }
    s = "xl/workbook." + t;
    i.file(s, Om(e, s, r));
    n.workbooks.push(s);
    ca(r.rels, 1, s, ia.WB);
    for (f = 1; f <= e.SheetNames.length; ++f) {
      var o = { "!id": {} };
      var l = e.Sheets[e.SheetNames[f - 1]];
      var c = (l || {})["!type"] || "sheet";
      switch (c) {
        case "chart":
        default:
          s = "xl/worksheets/sheet" + f + "." + t;
          i.file(s, Fm(f - 1, s, r, e, o));
          n.sheets.push(s);
          ca(r.wbrels, -1, "worksheets/sheet" + f + "." + t, ia.WS[0]);
      }
      if (l) {
        var h = l["!comments"];
        if (h && h.length > 0) {
          var u = "xl/comments" + f + "." + t;
          i.file(u, Mm(h, u, r));
          n.comments.push(u);
          ca(o, -1, "../comments" + f + "." + t, ia.CMNT);
        }
        if (l["!legacy"]) {
          i.file("xl/drawings/vmlDrawing" + f + ".vml", ev(f, l["!comments"]));
        }
        delete l["!comments"];
        delete l["!legacy"];
      }
      if (o["!id"].rId1) i.file(sa(s), la(o));
    }
    if (r.Strings != null && r.Strings.length > 0) {
      s = "xl/sharedStrings." + t;
      i.file(s, Lm(r.Strings, s, r));
      n.strs.push(s);
      ca(r.wbrels, -1, "sharedStrings." + t, ia.SST);
    }
    s = "xl/theme/theme1.xml";
    i.file(s, Md(e.Themes, r));
    n.themes.push(s);
    ca(r.wbrels, -1, "theme/theme1.xml", ia.THEME);
    s = "xl/styles." + t;
    i.file(s, Nm(e, s, r));
    n.styles.push(s);
    ca(r.wbrels, -1, "styles." + t, ia.STY);
    if (e.vbaraw && a) {
      s = "xl/vbaProject.bin";
      i.file(s, e.vbaraw);
      n.vba.push(s);
      ca(r.wbrels, -1, "vbaProject.bin", ia.VBA);
    }
    i.file("[Content_Types].xml", na(n, r));
    i.file("_rels/.rels", la(r.rels));
    i.file("xl/_rels/workbook." + t + ".rels", la(r.wbrels));
    delete r.revssf;
    delete r.ssf;
    return i;
  }
  function tE(e, r) {
    var t = "";
    switch ((r || {}).type || "base64") {
      case "buffer":
        return [e[0], e[1], e[2], e[3]];
      case "base64":
        t = u.decode(e.substr(0, 24));
        break;
      case "binary":
        t = e;
        break;
      case "array":
        return [e[0], e[1], e[2], e[3]];
      default:
        throw new Error("Unrecognized type " + ((r && r.type) || "undefined"));
    }
    return [t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2), t.charCodeAt(3)];
  }
  function aE(e, r) {
    if (e.find("EncryptedPackage")) return eE(e, r);
    return gC(e, r);
  }
  function nE(e, r) {
    var t,
      a = e;
    var n = r || {};
    if (!n.type) n.type = d && Buffer.isBuffer(e) ? "buffer" : "base64";
    switch (n.type) {
      case "base64":
        t = new ee(a, { base64: true });
        break;
      case "binary":
      case "array":
        t = new ee(a, { base64: false });
        break;
      case "buffer":
        t = new ee(a);
        break;
      default:
        throw new Error("Unrecognized type " + n.type);
    }
    return qC(t, n);
  }
  function iE(e, r) {
    var t = 0;
    e: while (t < e.length)
      switch (e.charCodeAt(t)) {
        case 10:
        case 13:
        case 32:
          ++t;
          break;
        case 60:
          return qm(e.slice(t), r);
        default:
          break e;
      }
    return Fh.to_workbook(e, r);
  }
  function sE(e, r) {
    var t = "",
      a = tE(e, r);
    switch (r.type) {
      case "base64":
        t = u.decode(e);
        break;
      case "binary":
        t = e;
        break;
      case "buffer":
        t = e.toString("binary");
        break;
      case "array":
        t = W(e);
        break;
      default:
        throw new Error("Unrecognized type " + r.type);
    }
    if (a[0] == 239 && a[1] == 187 && a[2] == 191) t = Ee(t);
    return iE(t, r);
  }
  function fE(e, r) {
    var t = e;
    if (r.type == "base64") t = u.decode(t);
    t = cptable.utils.decode(1200, t.slice(2), "str");
    r.type = "binary";
    return iE(t, r);
  }
  function oE(e, r) {
    var t,
      a = e,
      n = [0];
    var i = r || {};
    vg = {};
    if (i.dateNF) vg.dateNF = i.dateNF;
    if (!i.type) i.type = d && Buffer.isBuffer(e) ? "buffer" : "base64";
    if (i.type == "file") {
      i.type = "buffer";
      a = q.readFileSync(e);
    }
    switch ((n = tE(a, i))[0]) {
      case 208:
        return aE(_.read(a, i), i);
      case 9:
        return gC(p(i.type === "base64" ? u.decode(a) : a), i);
      case 60:
        return qm(a, i);
      case 73:
        if (n[1] == 68) return Ph(a, i);
        break;
      case 84:
        if (n[1] == 65 && n[2] == 66 && n[3] == 76) return Oh.to_workbook(a, i);
        break;
      case 80:
        if (n[1] == 75 && n[2] < 32 && n[3] < 32) return nE(a, i);
        break;
      case 239:
        return n[3] == 60 ? qm(a, i) : Fh.to_workbook(a, i);
      case 255:
        if (n[1] == 254) {
          return fE(a, i);
        }
        break;
      case 0:
        if (n[1] == 0 && n[2] >= 2 && n[3] == 0) return Nh.to_workbook(a, i);
        break;
      case 3:
      case 131:
      case 139:
        return Rh.to_workbook(a, i);
      case 123:
        if (n[1] == 92 && n[2] == 114 && n[3] == 116)
          throw new Error("Unsupported RTF");
        break;
      case 10:
      case 13:
      case 32:
        return sE(a, i);
    }
    if (n[2] <= 12 && n[3] <= 31) return Rh.to_workbook(a, i);
    if (32 > n[0] || n[0] > 127)
      throw new Error("Unsupported file " + n.join("|"));
    return Fh.to_workbook(a, i);
  }
  function lE(e, r) {
    var t = r || {};
    t.type = "file";
    return oE(e, t);
  }
  function cE(e, r) {
    var t = r || {};
    var a = rE(e, t);
    var n = {};
    if (t.compression) n.compression = "DEFLATE";
    switch (t.type) {
      case "base64":
        n.type = "base64";
        break;
      case "binary":
        n.type = "string";
        break;
      case "buffer":
      case "file":
        n.type = "nodebuffer";
        break;
      default:
        throw new Error("Unrecognized type " + t.type);
    }
    if (t.type === "file") return q.writeFileSync(t.file, a.generate(n));
    return a.generate(n);
  }
  function hE(e, r) {
    switch (r.type) {
      case "base64":
        return u.encode(e);
      case "binary":
        return e;
      case "file":
        return q.writeFileSync(r.file, e, "binary");
      case "buffer": {
        if (d) return new Buffer(e, "binary");
        else
          return e.split("").map(function (e) {
            return e.charCodeAt(0);
          });
      }
    }
    throw new Error("Unrecognized type " + r.type);
  }
  function uE(e, r) {
    switch (r.type) {
      case "base64":
        return u.encode(e);
      case "binary":
        return e;
      case "file":
        return q.writeFileSync(r.file, e, "utf8");
      case "buffer": {
        if (d) return new Buffer(e, "utf8");
        else
          return e.split("").map(function (e) {
            return e.charCodeAt(0);
          });
      }
    }
    throw new Error("Unrecognized type " + r.type);
  }
  function dE(e, r) {
    switch (r.type) {
      case "base64":
      case "binary":
        var t = "";
        for (var a = 0; a < e.length; ++a) t += String.fromCharCode(e[a]);
        return r.type == "base64" ? u.encode(t) : t;
      case "file":
        return q.writeFileSync(r.file, e);
      case "buffer":
        return e;
      default:
        throw new Error("Unrecognized type " + r.type);
    }
  }
  function vE(e, r) {
    nm(e);
    var t = r || {};
    switch (t.bookType || "xlsb") {
      case "xml":
      case "xlml":
        return uE(lC(e, t), t);
      case "slk":
      case "sylk":
        return uE(VC(e, t), t);
      case "html":
        return uE(HC(e, t), t);
      case "txt":
        return hE(GC(e, t), t);
      case "csv":
        return uE(WC(e, t), t);
      case "dif":
        return uE(zC(e, t), t);
      case "prn":
        return uE(XC(e, t), t);
      case "fods":
        return uE(MC(e, t), t);
      case "biff2":
        return dE(IC(e, t), t);
      case "xlsx":
      case "xlsm":
      case "xlsb":
      case "ods":
        return cE(e, t);
      default:
        throw new Error("Unrecognized bookType |" + t.bookType + "|");
    }
  }
  function pE(e) {
    if (!e.bookType)
      switch (e.file.slice(e.file.lastIndexOf(".")).toLowerCase()) {
        case ".xlsx":
          e.bookType = "xlsx";
          break;
        case ".xlsm":
          e.bookType = "xlsm";
          break;
        case ".xlsb":
          e.bookType = "xlsb";
          break;
        case ".fods":
          e.bookType = "fods";
          break;
        case ".xlml":
          e.bookType = "xlml";
          break;
        case ".sylk":
          e.bookType = "sylk";
          break;
        case ".html":
          e.bookType = "html";
          break;
        case ".xls":
          e.bookType = "biff2";
          break;
        case ".xml":
          e.bookType = "xml";
          break;
        case ".ods":
          e.bookType = "ods";
          break;
        case ".csv":
          e.bookType = "csv";
          break;
        case ".txt":
          e.bookType = "txt";
          break;
        case ".dif":
          e.bookType = "dif";
          break;
        case ".prn":
          e.bookType = "prn";
          break;
        case ".slk":
          e.bookType = "sylk";
          break;
        case ".htm":
          e.bookType = "html";
          break;
      }
  }
  function gE(e, r, t) {
    var a = t || {};
    a.type = "file";
    a.file = r;
    pE(a);
    return vE(e, a);
  }
  function bE(e, r, t, a) {
    var n = t || {};
    n.type = "file";
    n.file = e;
    pE(n);
    n.type = "buffer";
    var i = a;
    if (!(i instanceof Function)) i = t;
    return q.writeFile(e, vE(r, n), i);
  }
  function mE(e, r) {
    if (e == null || e["!ref"] == null) return [];
    var t = { t: "n", v: 0 },
      a = 0,
      n = 1,
      i = [],
      s = true,
      f = 0,
      o = "";
    var l = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
    var c = r != null ? r : {};
    var h = c.raw;
    var u = c.defval;
    var d = c.range != null ? c.range : e["!ref"];
    if (c.header === 1) a = 1;
    else if (c.header === "A") a = 2;
    else if (Array.isArray(c.header)) a = 3;
    switch (typeof d) {
      case "string":
        l = Kr(d);
        break;
      case "number":
        l = Kr(e["!ref"]);
        l.s.r = d;
        break;
      default:
        l = d;
    }
    if (a > 0) n = 0;
    var v = Or(l.s.r);
    var p = new Array(l.e.c - l.s.c + 1);
    var g = new Array(l.e.r - l.s.r - n + 1);
    var b = 0,
      m = 0;
    var C = Array.isArray(e);
    var E = l.s.r,
      k = 0,
      S = 0;
    if (C && !e[E]) e[E] = [];
    for (k = l.s.c; k <= l.e.c; ++k) {
      p[k] = Lr(k);
      t = C ? e[E][k] : e[p[k] + v];
      switch (a) {
        case 1:
          i[k] = k - l.s.c;
          break;
        case 2:
          i[k] = p[k];
          break;
        case 3:
          i[k] = c.header[k - l.s.c];
          break;
        default:
          if (t == null) continue;
          o = f = $r(t, null, c);
          m = 0;
          for (S = 0; S < i.length; ++S) if (i[S] == o) o = f + "_" + ++m;
          i[k] = o;
      }
    }
    var w = a === 1 ? [] : {};
    for (E = l.s.r + n; E <= l.e.r; ++E) {
      v = Or(E);
      s = true;
      if (a === 1) w = [];
      else {
        w = {};
        if (Object.defineProperty)
          try {
            Object.defineProperty(w, "__rowNum__", {
              value: E,
              enumerable: false,
            });
          } catch (A) {
            w.__rowNum__ = E;
          }
        else w.__rowNum__ = E;
      }
      if (!C || e[E])
        for (k = l.s.c; k <= l.e.c; ++k) {
          t = C ? e[E][k] : e[p[k] + v];
          if (t === undefined || t.t === undefined) {
            if (u === undefined) continue;
            if (i[k] != null) {
              w[i[k]] = u;
              s = false;
            }
            continue;
          }
          f = t.v;
          switch (t.t) {
            case "z":
              if (f == null) break;
              continue;
            case "e":
              continue;
            case "s":
            case "d":
            case "b":
            case "n":
              break;
            default:
              throw new Error("unrecognized type " + t.t);
          }
          if (i[k] != null) {
            if (f == null) {
              if (u !== undefined) w[i[k]] = u;
              else if (h && f === null) w[i[k]] = null;
              else continue;
            } else {
              w[i[k]] = h ? f : $r(t, f, c);
            }
            s = false;
          }
        }
      if (s === false || (a === 1 ? c.blankrows !== false : !!c.blankrows))
        g[b++] = w;
    }
    g.length = b;
    return g;
  }
  var CE = /"/g;
  function EE(e, r, t, a, n, i, s, f) {
    var o = true;
    var l = "",
      c = "",
      h = Or(t);
    for (var u = r.s.c; u <= r.e.c; ++u) {
      var d = f.dense ? (e[t] || [])[u] : e[a[u] + h];
      if (d == null) c = "";
      else if (d.v != null) {
        o = false;
        c = "" + $r(d, null, f);
        for (var v = 0, p = 0; v !== c.length; ++v)
          if ((p = c.charCodeAt(v)) === n || p === i || p === 34) {
            c = '"' + c.replace(CE, '""') + '"';
            break;
          }
        if (c == "ID") c = '"ID"';
      } else if (d.f != null && !d.F) {
        o = false;
        c = "=" + d.f;
        if (c.indexOf(",") >= 0) c = '"' + c.replace(CE, '""') + '"';
      } else c = "";
      l += (u === r.s.c ? "" : s) + c;
    }
    if (f.blankrows === false && o) return null;
    return l;
  }
  function kE(e, r) {
    var t = [];
    var a = r == null ? {} : r;
    if (e == null || e["!ref"] == null) return "";
    var n = Kr(e["!ref"]);
    var i = a.FS !== undefined ? a.FS : ",",
      s = i.charCodeAt(0);
    var f = a.RS !== undefined ? a.RS : "\n",
      o = f.charCodeAt(0);
    var l = new RegExp((i == "|" ? "\\|" : i) + "+$");
    var c = "",
      h = [];
    a.dense = Array.isArray(e);
    for (var u = n.s.c; u <= n.e.c; ++u) h[u] = Lr(u);
    for (var d = n.s.r; d <= n.e.r; ++d) {
      c = EE(e, n, d, h, s, o, i, a);
      if (c == null) {
        continue;
      }
      if (a.strip) c = c.replace(l, "");
      t.push(c + f);
    }
    delete a.dense;
    return t.join("");
  }
  function SE(e, r) {
    if (!r) r = {};
    r.FS = "\t";
    r.RS = "\n";
    var t = kE(e, r);
    if (typeof cptable == "undefined") return t;
    var a = cptable.utils.encode(1200, t);
    return "ÿþ" + a;
  }
  function wE(e) {
    var r = "",
      t,
      a = "";
    if (e == null || e["!ref"] == null) return [];
    var n = Kr(e["!ref"]),
      i = "",
      s = [],
      f;
    var o = [];
    var l = Array.isArray(e);
    for (f = n.s.c; f <= n.e.c; ++f) s[f] = Lr(f);
    for (var c = n.s.r; c <= n.e.r; ++c) {
      i = Or(c);
      for (f = n.s.c; f <= n.e.c; ++f) {
        r = s[f] + i;
        t = l ? (e[c] || [])[f] : e[r];
        a = "";
        if (t === undefined) continue;
        else if (t.F != null) {
          r = t.F;
          if (!t.f) continue;
          a = t.f;
          if (r.indexOf(":") == -1) r = r + ":" + r;
        }
        if (t.f != null) a = t.f;
        else if (t.t == "z") continue;
        else if (t.t == "n" && t.v != null) a = "" + t.v;
        else if (t.t == "b") a = t.v ? "TRUE" : "FALSE";
        else if (t.w !== undefined) a = "'" + t.w;
        else if (t.v === undefined) continue;
        else if (t.t == "s") a = "'" + t.v;
        else a = "" + t.v;
        o[o.length] = r + "=" + a;
      }
    }
    return o;
  }
  function AE(e, r) {
    var t = r || {};
    var a = {};
    var n;
    var i = { s: { c: 0, r: 0 }, e: { c: 0, r: e.length } };
    var s = t.header || [],
      f = 0;
    for (var o = 0; o != e.length; ++o) {
      Object.keys(e[o])
        .filter(function (r) {
          return e[o].hasOwnProperty(r);
        })
        .forEach(function (r) {
          if ((f = s.indexOf(r)) == -1) s[(f = s.length)] = r;
          var i = e[o][r];
          var l = "z";
          var c = "";
          if (typeof i == "number") l = "n";
          else if (typeof i == "boolean") l = "b";
          else if (typeof i == "string") l = "s";
          else if (i instanceof Date) {
            l = "d";
            if (!t.cellDates) {
              l = "n";
              i = P(i);
            }
            c = t.dateNF || C._table[14];
          }
          a[Vr({ c: f, r: o + 1 })] = n = { t: l, v: i };
          if (c) n.z = c;
        });
    }
    i.e.c = s.length - 1;
    for (f = 0; f < s.length; ++f) a[Lr(f) + "1"] = { t: "s", v: s[f] };
    a["!ref"] = jr(i);
    return a;
  }
  var BE = {
    encode_col: Lr,
    encode_row: Or,
    encode_cell: Vr,
    encode_range: jr,
    decode_col: Nr,
    decode_row: Dr,
    split_cell: Hr,
    decode_cell: Wr,
    decode_range: Gr,
    format_cell: $r,
    get_formulae: wE,
    make_csv: kE,
    make_json: mE,
    make_formulae: wE,
    aoa_to_sheet: Qr,
    json_to_sheet: AE,
    table_to_sheet: RC,
    table_to_book: DC,
    sheet_to_csv: kE,
    sheet_to_json: mE,
    sheet_to_html: yC.from_sheet,
    sheet_to_formulae: wE,
    sheet_to_row_object_array: mE,
  };
  (function (e) {
    e.consts = e.consts || {};
    function r(r) {
      r.forEach(function (r) {
        e.consts[r[0]] = r[1];
      });
    }
    function t(e, r, t) {
      return e[r] != null ? e[r] : (e[r] = t);
    }
    function a(e, r, t) {
      if (typeof r == "string") return e[r] || (e[r] = { t: "z" });
      if (typeof r != "number") return a(e, Vr(r));
      return a(e, Vr({ r: r, c: t || 0 }));
    }
    function n(e, r) {
      if (typeof r == "number") {
        if (r >= 0 && e.SheetNames.length > r) return r;
        throw new Error("Cannot find sheet # " + r);
      } else if (typeof r == "string") {
        var t = e.SheetNames.indexOf(r);
        if (t > -1) return t;
        throw new Error("Cannot find sheet name |" + r + "|");
      } else throw new Error("Cannot find sheet |" + r + "|");
    }
    e.book_new = function () {
      return { SheetNames: [], Sheets: {} };
    };
    e.book_append_sheet = function (e, r, t) {
      if (!t)
        for (var a = 1; a <= 65535; ++a)
          if (e.SheetNames.indexOf((t = "Sheet" + a)) == -1) break;
      if (!t) throw new Error("Too many worksheets");
      tm(t);
      if (e.SheetNames.indexOf(t) >= 0)
        throw new Error("Worksheet with name |" + t + "| already exists!");
      e.SheetNames.push(t);
      e.Sheets[t] = r;
    };
    e.book_set_sheet_visibility = function (e, r, a) {
      t(e, "Workbook", {});
      t(e.Workbook, "Sheets", []);
      var i = n(e, r);
      t(e.Workbook.Sheets, i, {});
      switch (a) {
        case 0:
        case 1:
        case 2:
          break;
        default:
          throw new Error("Bad sheet visibility setting " + a);
      }
      e.Workbook.Sheets[i].Hidden = a;
    };
    r([
      ["SHEET_VISIBLE", 0],
      ["SHEET_HIDDEN", 1],
      ["SHEET_VERY_HIDDEN", 2],
    ]);
    e.cell_set_number_format = function (e, r) {
      e.z = r;
      return e;
    };
    e.cell_set_hyperlink = function (e, r, t) {
      if (!r) {
        delete e.l;
      } else {
        e.l = { Target: r };
        if (t) e.l.Tooltip = t;
      }
      return e;
    };
    e.cell_add_comment = function (e, r, t) {
      if (!e.c) e.c = [];
      e.c.push({ t: r, a: t || "SheetJS" });
    };
    e.sheet_set_array_formula = function (e, r, t) {
      var n = typeof r != "string" ? r : Kr(r);
      var i = typeof r == "string" ? r : jr(r);
      for (var s = n.s.r; s <= n.e.r; ++s)
        for (var f = n.s.c; f <= n.e.c; ++f) {
          var o = a(e, s, f);
          o.t = "n";
          o.F = i;
          delete o.v;
          if (s == n.s.r && f == n.s.c) o.f = t;
        }
      return e;
    };
    return e;
  })(BE);
  if (d && typeof require != "undefined")
    (function () {
      var e = {}.Readable;
      var t = function (r, t) {
        var a = e();
        var n = "";
        var i = t == null ? {} : t;
        if (r == null || r["!ref"] == null) {
          a.push(null);
          return a;
        }
        var s = Kr(r["!ref"]);
        var f = i.FS !== undefined ? i.FS : ",",
          o = f.charCodeAt(0);
        var l = i.RS !== undefined ? i.RS : "\n",
          c = l.charCodeAt(0);
        var h = new RegExp((f == "|" ? "\\|" : f) + "+$");
        var u = "",
          d = [];
        i.dense = Array.isArray(r);
        for (var v = s.s.c; v <= s.e.c; ++v) d[v] = Lr(v);
        var p = s.s.r;
        a._read = function () {
          if (p > s.e.r) return a.push(null);
          while (p <= s.e.r) {
            u = EE(r, s, p, d, o, c, f, i);
            ++p;
            if (u != null) {
              if (i.strip) u = u.replace(h, "");
              a.push(u + l);
              break;
            }
          }
        };
        return a;
      };
      var a = function (r, t) {
        var a = e();
        var n = t || {};
        var i = n.header != null ? n.header : yC.BEGIN;
        var s = n.footer != null ? n.footer : yC.END;
        a.push(i);
        var f = Gr(r["!ref"]);
        n.dense = Array.isArray(r);
        a.push(yC._preamble(r, f, n));
        var o = f.s.r;
        var l = false;
        a._read = function () {
          if (o > f.e.r) {
            if (!l) {
              l = true;
              a.push("</table>" + s);
            }
            return a.push(null);
          }
          while (o <= f.e.r) {
            a.push(yC._row(r, f, o, n));
            ++o;
            break;
          }
        };
        return a;
      };
      r.stream = { to_html: a, to_csv: t };
    })();
  r.parse_xlscfb = gC;
  r.parse_ods = FC;
  r.parse_fods = PC;
  r.write_ods = MC;
  r.parse_zip = qC;
  r.read = oE;
  r.readFile = lE;
  r.readFileSync = lE;
  r.write = vE;
  r.writeFile = gE;
  r.writeFileSync = gE;
  r.writeFileAsync = bE;
  r.utils = BE;
  r.SSF = C;
})(typeof exports !== "undefined" ? exports : XLSX);
var XLS = XLSX;
var ODS = XLSX;

/* xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
(function (e) {
  if ("object" == typeof exports && "undefined" != typeof module)
    module.exports = e();
  else if ("function" == typeof define && define.amd) {
    JSZip = e();
    define([], e);
  } else {
    var r;
    "undefined" != typeof window
      ? (r = window)
      : "undefined" != typeof global
      ? (r = global)
      : "undefined" != typeof $ && $.global
      ? (r = $.global)
      : "undefined" != typeof self && (r = self),
      (r.JSZip = e());
  }
})(function () {
  var e, r, t;
  return (function a(e, r, t) {
    function n(s, f) {
      if (!r[s]) {
        if (!e[s]) {
          var o = typeof require == "function" && require;
          if (!f && o) return o(s, !0);
          if (i) return i(s, !0);
          throw new Error("Cannot find module '" + s + "'");
        }
        var l = (r[s] = { exports: {} });
        e[s][0].call(
          l.exports,
          function (r) {
            var t = e[s][1][r];
            return n(t ? t : r);
          },
          l,
          l.exports,
          a,
          e,
          r,
          t
        );
      }
      return r[s].exports;
    }
    var i = typeof require == "function" && require;
    for (var s = 0; s < t.length; s++) n(t[s]);
    return n;
  })(
    {
      1: [
        function (e, r, t) {
          "use strict";
          var a =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          t.encode = function (e, r) {
            var t = "";
            var n, i, s, f, o, l, c;
            var u = 0;
            while (u < e.length) {
              n = e.charCodeAt(u++);
              i = e.charCodeAt(u++);
              s = e.charCodeAt(u++);
              f = n >> 2;
              o = ((n & 3) << 4) | (i >> 4);
              l = ((i & 15) << 2) | (s >> 6);
              c = s & 63;
              if (isNaN(i)) {
                l = c = 64;
              } else if (isNaN(s)) {
                c = 64;
              }
              t = t + a.charAt(f) + a.charAt(o) + a.charAt(l) + a.charAt(c);
            }
            return t;
          };
          t.decode = function (e, r) {
            var t = "";
            var n, i, s;
            var f, o, l, c;
            var u = 0;
            e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
            while (u < e.length) {
              f = a.indexOf(e.charAt(u++));
              o = a.indexOf(e.charAt(u++));
              l = a.indexOf(e.charAt(u++));
              c = a.indexOf(e.charAt(u++));
              n = (f << 2) | (o >> 4);
              i = ((o & 15) << 4) | (l >> 2);
              s = ((l & 3) << 6) | c;
              t = t + String.fromCharCode(n);
              if (l != 64) {
                t = t + String.fromCharCode(i);
              }
              if (c != 64) {
                t = t + String.fromCharCode(s);
              }
            }
            return t;
          };
        },
        {},
      ],
      2: [
        function (e, r, t) {
          "use strict";
          function a() {
            this.compressedSize = 0;
            this.uncompressedSize = 0;
            this.crc32 = 0;
            this.compressionMethod = null;
            this.compressedContent = null;
          }
          a.prototype = {
            getContent: function () {
              return null;
            },
            getCompressedContent: function () {
              return null;
            },
          };
          r.exports = a;
        },
        {},
      ],
      3: [
        function (e, r, t) {
          "use strict";
          t.STORE = {
            magic: "\0\0",
            compress: function (e) {
              return e;
            },
            uncompress: function (e) {
              return e;
            },
            compressInputType: null,
            uncompressInputType: null,
          };
          t.DEFLATE = e("./flate");
        },
        { "./flate": 8 },
      ],
      4: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          var n = [
            0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615,
            3915621685, 2657392035, 249268274, 2044508324, 3772115230,
            2547177864, 162941995, 2125561021, 3887607047, 2428444049,
            498536548, 1789927666, 4089016648, 2227061214, 450548861,
            1843258603, 4107580753, 2211677639, 325883990, 1684777152,
            4251122042, 2321926636, 335633487, 1661365465, 4195302755,
            2366115317, 997073096, 1281953886, 3579855332, 2724688242,
            1006888145, 1258607687, 3524101629, 2768942443, 901097722,
            1119000684, 3686517206, 2898065728, 853044451, 1172266101,
            3705015759, 2882616665, 651767980, 1373503546, 3369554304,
            3218104598, 565507253, 1454621731, 3485111705, 3099436303,
            671266974, 1594198024, 3322730930, 2970347812, 795835527,
            1483230225, 3244367275, 3060149565, 1994146192, 31158534,
            2563907772, 4023717930, 1907459465, 112637215, 2680153253,
            3904427059, 2013776290, 251722036, 2517215374, 3775830040,
            2137656763, 141376813, 2439277719, 3865271297, 1802195444,
            476864866, 2238001368, 4066508878, 1812370925, 453092731,
            2181625025, 4111451223, 1706088902, 314042704, 2344532202,
            4240017532, 1658658271, 366619977, 2362670323, 4224994405,
            1303535960, 984961486, 2747007092, 3569037538, 1256170817,
            1037604311, 2765210733, 3554079995, 1131014506, 879679996,
            2909243462, 3663771856, 1141124467, 855842277, 2852801631,
            3708648649, 1342533948, 654459306, 3188396048, 3373015174,
            1466479909, 544179635, 3110523913, 3462522015, 1591671054,
            702138776, 2966460450, 3352799412, 1504918807, 783551873,
            3082640443, 3233442989, 3988292384, 2596254646, 62317068,
            1957810842, 3939845945, 2647816111, 81470997, 1943803523,
            3814918930, 2489596804, 225274430, 2053790376, 3826175755,
            2466906013, 167816743, 2097651377, 4027552580, 2265490386,
            503444072, 1762050814, 4150417245, 2154129355, 426522225,
            1852507879, 4275313526, 2312317920, 282753626, 1742555852,
            4189708143, 2394877945, 397917763, 1622183637, 3604390888,
            2714866558, 953729732, 1340076626, 3518719985, 2797360999,
            1068828381, 1219638859, 3624741850, 2936675148, 906185462,
            1090812512, 3747672003, 2825379669, 829329135, 1181335161,
            3412177804, 3160834842, 628085408, 1382605366, 3423369109,
            3138078467, 570562233, 1426400815, 3317316542, 2998733608,
            733239954, 1555261956, 3268935591, 3050360625, 752459403,
            1541320221, 2607071920, 3965973030, 1969922972, 40735498,
            2617837225, 3943577151, 1913087877, 83908371, 2512341634,
            3803740692, 2075208622, 213261112, 2463272603, 3855990285,
            2094854071, 198958881, 2262029012, 4057260610, 1759359992,
            534414190, 2176718541, 4139329115, 1873836001, 414664567,
            2282248934, 4279200368, 1711684554, 285281116, 2405801727,
            4167216745, 1634467795, 376229701, 2685067896, 3608007406,
            1308918612, 956543938, 2808555105, 3495958263, 1231636301,
            1047427035, 2932959818, 3654703836, 1088359270, 936918e3,
            2847714899, 3736837829, 1202900863, 817233897, 3183342108,
            3401237130, 1404277552, 615818150, 3134207493, 3453421203,
            1423857449, 601450431, 3009837614, 3294710456, 1567103746,
            711928724, 3020668471, 3272380065, 1510334235, 755167117,
          ];
          r.exports = function i(e, r) {
            if (typeof e === "undefined" || !e.length) {
              return 0;
            }
            var t = a.getTypeOf(e) !== "string";
            if (typeof r == "undefined") {
              r = 0;
            }
            var i = 0;
            var s = 0;
            var f = 0;
            r = r ^ -1;
            for (var o = 0, l = e.length; o < l; o++) {
              f = t ? e[o] : e.charCodeAt(o);
              s = (r ^ f) & 255;
              i = n[s];
              r = (r >>> 8) ^ i;
            }
            return r ^ -1;
          };
        },
        { "./utils": 21 },
      ],
      5: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          function n(e) {
            this.data = null;
            this.length = 0;
            this.index = 0;
          }
          n.prototype = {
            checkOffset: function (e) {
              this.checkIndex(this.index + e);
            },
            checkIndex: function (e) {
              if (this.length < e || e < 0) {
                throw new Error(
                  "End of data reached (data length = " +
                    this.length +
                    ", asked index = " +
                    e +
                    "). Corrupted zip ?"
                );
              }
            },
            setIndex: function (e) {
              this.checkIndex(e);
              this.index = e;
            },
            skip: function (e) {
              this.setIndex(this.index + e);
            },
            byteAt: function (e) {},
            readInt: function (e) {
              var r = 0,
                t;
              this.checkOffset(e);
              for (t = this.index + e - 1; t >= this.index; t--) {
                r = (r << 8) + this.byteAt(t);
              }
              this.index += e;
              return r;
            },
            readString: function (e) {
              return a.transformTo("string", this.readData(e));
            },
            readData: function (e) {},
            lastIndexOfSignature: function (e) {},
            readDate: function () {
              var e = this.readInt(4);
              return new Date(
                ((e >> 25) & 127) + 1980,
                ((e >> 21) & 15) - 1,
                (e >> 16) & 31,
                (e >> 11) & 31,
                (e >> 5) & 63,
                (e & 31) << 1
              );
            },
          };
          r.exports = n;
        },
        { "./utils": 21 },
      ],
      6: [
        function (e, r, t) {
          "use strict";
          t.base64 = false;
          t.binary = false;
          t.dir = false;
          t.createFolders = false;
          t.date = null;
          t.compression = null;
          t.comment = null;
        },
        {},
      ],
      7: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          t.string2binary = function (e) {
            return a.string2binary(e);
          };
          t.string2Uint8Array = function (e) {
            return a.transformTo("uint8array", e);
          };
          t.uint8Array2String = function (e) {
            return a.transformTo("string", e);
          };
          t.string2Blob = function (e) {
            var r = a.transformTo("arraybuffer", e);
            return a.arrayBuffer2Blob(r);
          };
          t.arrayBuffer2Blob = function (e) {
            return a.arrayBuffer2Blob(e);
          };
          t.transformTo = function (e, r) {
            return a.transformTo(e, r);
          };
          t.getTypeOf = function (e) {
            return a.getTypeOf(e);
          };
          t.checkSupport = function (e) {
            return a.checkSupport(e);
          };
          t.MAX_VALUE_16BITS = a.MAX_VALUE_16BITS;
          t.MAX_VALUE_32BITS = a.MAX_VALUE_32BITS;
          t.pretty = function (e) {
            return a.pretty(e);
          };
          t.findCompression = function (e) {
            return a.findCompression(e);
          };
          t.isRegExp = function (e) {
            return a.isRegExp(e);
          };
        },
        { "./utils": 21 },
      ],
      8: [
        function (e, r, t) {
          "use strict";
          var a =
            typeof Uint8Array !== "undefined" &&
            typeof Uint16Array !== "undefined" &&
            typeof Uint32Array !== "undefined";
          var n = e("pako");
          t.uncompressInputType = a ? "uint8array" : "array";
          t.compressInputType = a ? "uint8array" : "array";
          t.magic = "\b\0";
          t.compress = function (e) {
            return n.deflateRaw(e);
          };
          t.uncompress = function (e) {
            return n.inflateRaw(e);
          };
        },
        { pako: 24 },
      ],
      9: [
        function (e, r, t) {
          "use strict";
          var a = e("./base64");
          function n(e, r) {
            if (!(this instanceof n)) return new n(e, r);
            this.files = {};
            this.comment = null;
            this.root = "";
            if (e) {
              this.load(e, r);
            }
            this.clone = function () {
              var e = new n();
              for (var r in this) {
                if (typeof this[r] !== "function") {
                  e[r] = this[r];
                }
              }
              return e;
            };
          }
          n.prototype = e("./object");
          n.prototype.load = e("./load");
          n.support = e("./support");
          n.defaults = e("./defaults");
          n.utils = e("./deprecatedPublicUtils");
          n.base64 = {
            encode: function (e) {
              return a.encode(e);
            },
            decode: function (e) {
              return a.decode(e);
            },
          };
          n.compressions = e("./compressions");
          r.exports = n;
        },
        {
          "./base64": 1,
          "./compressions": 3,
          "./defaults": 6,
          "./deprecatedPublicUtils": 7,
          "./load": 10,
          "./object": 13,
          "./support": 17,
        },
      ],
      10: [
        function (e, r, t) {
          "use strict";
          var a = e("./base64");
          var n = e("./zipEntries");
          r.exports = function (e, r) {
            var t, i, s, f;
            r = r || {};
            if (r.base64) {
              e = a.decode(e);
            }
            i = new n(e, r);
            t = i.files;
            for (s = 0; s < t.length; s++) {
              f = t[s];
              this.file(f.fileName, f.decompressed, {
                binary: true,
                optimizedBinaryString: true,
                date: f.date,
                dir: f.dir,
                comment: f.fileComment.length ? f.fileComment : null,
                createFolders: r.createFolders,
              });
            }
            if (i.zipComment.length) {
              this.comment = i.zipComment;
            }
            return this;
          };
        },
        { "./base64": 1, "./zipEntries": 22 },
      ],
      11: [
        function (e, r, t) {
          (function (e) {
            "use strict";
            r.exports = function (r, t) {
              return new e(r, t);
            };
            r.exports.test = function (r) {
              return e.isBuffer(r);
            };
          }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
        },
        {},
      ],
      12: [
        function (e, r, t) {
          "use strict";
          var a = e("./uint8ArrayReader");
          function n(e) {
            this.data = e;
            this.length = this.data.length;
            this.index = 0;
          }
          n.prototype = new a();
          n.prototype.readData = function (e) {
            this.checkOffset(e);
            var r = this.data.slice(this.index, this.index + e);
            this.index += e;
            return r;
          };
          r.exports = n;
        },
        { "./uint8ArrayReader": 18 },
      ],
      13: [
        function (e, r, t) {
          "use strict";
          var a = e("./support");
          var n = e("./utils");
          var i = e("./crc32");
          var s = e("./signature");
          var f = e("./defaults");
          var o = e("./base64");
          var l = e("./compressions");
          var c = e("./compressedObject");
          var u = e("./nodeBuffer");
          var h = e("./utf8");
          var d = e("./stringWriter");
          var v = e("./uint8ArrayWriter");
          var p = function (e) {
            if (e._data instanceof c) {
              e._data = e._data.getContent();
              e.options.binary = true;
              e.options.base64 = false;
              if (n.getTypeOf(e._data) === "uint8array") {
                var r = e._data;
                e._data = new Uint8Array(r.length);
                if (r.length !== 0) {
                  e._data.set(r, 0);
                }
              }
            }
            return e._data;
          };
          var m = function (e) {
            var r = p(e),
              t = n.getTypeOf(r);
            if (t === "string") {
              if (!e.options.binary) {
                if (a.nodebuffer) {
                  return u(r, "utf-8");
                }
              }
              return e.asBinary();
            }
            return r;
          };
          var b = function (e) {
            var r = p(this);
            if (r === null || typeof r === "undefined") {
              return "";
            }
            if (this.options.base64) {
              r = o.decode(r);
            }
            if (e && this.options.binary) {
              r = x.utf8decode(r);
            } else {
              r = n.transformTo("string", r);
            }
            if (!e && !this.options.binary) {
              r = n.transformTo("string", x.utf8encode(r));
            }
            return r;
          };
          var g = function (e, r, t) {
            this.name = e;
            this.dir = t.dir;
            this.date = t.date;
            this.comment = t.comment;
            this._data = r;
            this.options = t;
            this._initialMetadata = { dir: t.dir, date: t.date };
          };
          g.prototype = {
            asText: function () {
              return b.call(this, true);
            },
            asBinary: function () {
              return b.call(this, false);
            },
            asNodeBuffer: function () {
              var e = m(this);
              return n.transformTo("nodebuffer", e);
            },
            asUint8Array: function () {
              var e = m(this);
              return n.transformTo("uint8array", e);
            },
            asArrayBuffer: function () {
              return this.asUint8Array().buffer;
            },
          };
          var E = function (e, r) {
            var t = "",
              a;
            for (a = 0; a < r; a++) {
              t += String.fromCharCode(e & 255);
              e = e >>> 8;
            }
            return t;
          };
          var k = function () {
            var e = {},
              r,
              t;
            for (r = 0; r < arguments.length; r++) {
              for (t in arguments[r]) {
                if (
                  arguments[r].hasOwnProperty(t) &&
                  typeof e[t] === "undefined"
                ) {
                  e[t] = arguments[r][t];
                }
              }
            }
            return e;
          };
          var S = function (e) {
            e = e || {};
            if (
              e.base64 === true &&
              (e.binary === null || e.binary === undefined)
            ) {
              e.binary = true;
            }
            e = k(e, f);
            e.date = e.date || new Date();
            if (e.compression !== null)
              e.compression = e.compression.toUpperCase();
            return e;
          };
          var w = function (e, r, t) {
            var a = n.getTypeOf(r),
              i;
            t = S(t);
            if (t.createFolders && (i = B(e))) {
              C.call(this, i, true);
            }
            if (t.dir || r === null || typeof r === "undefined") {
              t.base64 = false;
              t.binary = false;
              r = null;
            } else if (a === "string") {
              if (t.binary && !t.base64) {
                if (t.optimizedBinaryString !== true) {
                  r = n.string2binary(r);
                }
              }
            } else {
              t.base64 = false;
              t.binary = true;
              if (!a && !(r instanceof c)) {
                throw new Error(
                  "The data of '" + e + "' is in an unsupported format !"
                );
              }
              if (a === "arraybuffer") {
                r = n.transformTo("uint8array", r);
              }
            }
            var s = new g(e, r, t);
            this.files[e] = s;
            return s;
          };
          var B = function (e) {
            if (e.slice(-1) == "/") {
              e = e.substring(0, e.length - 1);
            }
            var r = e.lastIndexOf("/");
            return r > 0 ? e.substring(0, r) : "";
          };
          var C = function (e, r) {
            if (e.slice(-1) != "/") {
              e += "/";
            }
            r = typeof r !== "undefined" ? r : false;
            if (!this.files[e]) {
              w.call(this, e, null, { dir: true, createFolders: r });
            }
            return this.files[e];
          };
          var _ = function (e, r) {
            var t = new c(),
              a;
            if (e._data instanceof c) {
              t.uncompressedSize = e._data.uncompressedSize;
              t.crc32 = e._data.crc32;
              if (t.uncompressedSize === 0 || e.dir) {
                r = l["STORE"];
                t.compressedContent = "";
                t.crc32 = 0;
              } else if (e._data.compressionMethod === r.magic) {
                t.compressedContent = e._data.getCompressedContent();
              } else {
                a = e._data.getContent();
                t.compressedContent = r.compress(
                  n.transformTo(r.compressInputType, a)
                );
              }
            } else {
              a = m(e);
              if (!a || a.length === 0 || e.dir) {
                r = l["STORE"];
                a = "";
              }
              t.uncompressedSize = a.length;
              t.crc32 = i(a);
              t.compressedContent = r.compress(
                n.transformTo(r.compressInputType, a)
              );
            }
            t.compressedSize = t.compressedContent.length;
            t.compressionMethod = r.magic;
            return t;
          };
          var T = function (e, r, t, a) {
            var f = t.compressedContent,
              o = n.transformTo("string", h.utf8encode(r.name)),
              l = r.comment || "",
              c = n.transformTo("string", h.utf8encode(l)),
              u = o.length !== r.name.length,
              d = c.length !== l.length,
              v = r.options,
              p,
              m,
              b = "",
              g = "",
              k = "",
              S,
              w;
            if (r._initialMetadata.dir !== r.dir) {
              S = r.dir;
            } else {
              S = v.dir;
            }
            if (r._initialMetadata.date !== r.date) {
              w = r.date;
            } else {
              w = v.date;
            }
            p = w.getHours();
            p = p << 6;
            p = p | w.getMinutes();
            p = p << 5;
            p = p | (w.getSeconds() / 2);
            m = w.getFullYear() - 1980;
            m = m << 4;
            m = m | (w.getMonth() + 1);
            m = m << 5;
            m = m | w.getDate();
            if (u) {
              g = E(1, 1) + E(i(o), 4) + o;
              b += "up" + E(g.length, 2) + g;
            }
            if (d) {
              k = E(1, 1) + E(this.crc32(c), 4) + c;
              b += "uc" + E(k.length, 2) + k;
            }
            var B = "";
            B += "\n\0";
            B += u || d ? "\0\b" : "\0\0";
            B += t.compressionMethod;
            B += E(p, 2);
            B += E(m, 2);
            B += E(t.crc32, 4);
            B += E(t.compressedSize, 4);
            B += E(t.uncompressedSize, 4);
            B += E(o.length, 2);
            B += E(b.length, 2);
            var C = s.LOCAL_FILE_HEADER + B + o + b;
            var _ =
              s.CENTRAL_FILE_HEADER +
              "\0" +
              B +
              E(c.length, 2) +
              "\0\0" +
              "\0\0" +
              (S === true ? "\0\0\0" : "\0\0\0\0") +
              E(a, 4) +
              o +
              b +
              c;
            return { fileRecord: C, dirRecord: _, compressedObject: t };
          };
          var x = {
            load: function (e, r) {
              throw new Error(
                "Load method is not defined. Is the file jszip-load.js included ?"
              );
            },
            filter: function (e) {
              var r = [],
                t,
                a,
                n,
                i;
              for (t in this.files) {
                if (!this.files.hasOwnProperty(t)) {
                  continue;
                }
                n = this.files[t];
                i = new g(n.name, n._data, k(n.options));
                a = t.slice(this.root.length, t.length);
                if (t.slice(0, this.root.length) === this.root && e(a, i)) {
                  r.push(i);
                }
              }
              return r;
            },
            file: function (e, r, t) {
              if (arguments.length === 1) {
                if (n.isRegExp(e)) {
                  var a = e;
                  return this.filter(function (e, r) {
                    return !r.dir && a.test(e);
                  });
                } else {
                  return (
                    this.filter(function (r, t) {
                      return !t.dir && r === e;
                    })[0] || null
                  );
                }
              } else {
                e = this.root + e;
                w.call(this, e, r, t);
              }
              return this;
            },
            folder: function (e) {
              if (!e) {
                return this;
              }
              if (n.isRegExp(e)) {
                return this.filter(function (r, t) {
                  return t.dir && e.test(r);
                });
              }
              var r = this.root + e;
              var t = C.call(this, r);
              var a = this.clone();
              a.root = t.name;
              return a;
            },
            remove: function (e) {
              e = this.root + e;
              var r = this.files[e];
              if (!r) {
                if (e.slice(-1) != "/") {
                  e += "/";
                }
                r = this.files[e];
              }
              if (r && !r.dir) {
                delete this.files[e];
              } else {
                var t = this.filter(function (r, t) {
                  return t.name.slice(0, e.length) === e;
                });
                for (var a = 0; a < t.length; a++) {
                  delete this.files[t[a].name];
                }
              }
              return this;
            },
            generate: function (e) {
              e = k(e || {}, {
                base64: true,
                compression: "STORE",
                type: "base64",
                comment: null,
              });
              n.checkSupport(e.type);
              var r = [],
                t = 0,
                a = 0,
                i,
                f,
                c = n.transformTo(
                  "string",
                  this.utf8encode(e.comment || this.comment || "")
                );
              for (var u in this.files) {
                if (!this.files.hasOwnProperty(u)) {
                  continue;
                }
                var h = this.files[u];
                var p = h.options.compression || e.compression.toUpperCase();
                var m = l[p];
                if (!m) {
                  throw new Error(p + " is not a valid compression method !");
                }
                var b = _.call(this, h, m);
                var g = T.call(this, u, h, b, t);
                t += g.fileRecord.length + b.compressedSize;
                a += g.dirRecord.length;
                r.push(g);
              }
              var S = "";
              S =
                s.CENTRAL_DIRECTORY_END +
                "\0\0" +
                "\0\0" +
                E(r.length, 2) +
                E(r.length, 2) +
                E(a, 4) +
                E(t, 4) +
                E(c.length, 2) +
                c;
              var w = e.type.toLowerCase();
              if (
                w === "uint8array" ||
                w === "arraybuffer" ||
                w === "blob" ||
                w === "nodebuffer"
              ) {
                i = new v(t + a + S.length);
              } else {
                i = new d(t + a + S.length);
              }
              for (f = 0; f < r.length; f++) {
                i.append(r[f].fileRecord);
                i.append(r[f].compressedObject.compressedContent);
              }
              for (f = 0; f < r.length; f++) {
                i.append(r[f].dirRecord);
              }
              i.append(S);
              var B = i.finalize();
              switch (e.type.toLowerCase()) {
                case "uint8array":
                case "arraybuffer":
                case "nodebuffer":
                  return n.transformTo(e.type.toLowerCase(), B);
                case "blob":
                  return n.arrayBuffer2Blob(n.transformTo("arraybuffer", B));
                case "base64":
                  return e.base64 ? o.encode(B) : B;
                default:
                  return B;
              }
            },
            crc32: function (e, r) {
              return i(e, r);
            },
            utf8encode: function (e) {
              return n.transformTo("string", h.utf8encode(e));
            },
            utf8decode: function (e) {
              return h.utf8decode(e);
            },
          };
          r.exports = x;
        },
        {
          "./base64": 1,
          "./compressedObject": 2,
          "./compressions": 3,
          "./crc32": 4,
          "./defaults": 6,
          "./nodeBuffer": 11,
          "./signature": 14,
          "./stringWriter": 16,
          "./support": 17,
          "./uint8ArrayWriter": 19,
          "./utf8": 20,
          "./utils": 21,
        },
      ],
      14: [
        function (e, r, t) {
          "use strict";
          t.LOCAL_FILE_HEADER = "PK";
          t.CENTRAL_FILE_HEADER = "PK";
          t.CENTRAL_DIRECTORY_END = "PK";
          t.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK";
          t.ZIP64_CENTRAL_DIRECTORY_END = "PK";
          t.DATA_DESCRIPTOR = "PK\b";
        },
        {},
      ],
      15: [
        function (e, r, t) {
          "use strict";
          var a = e("./dataReader");
          var n = e("./utils");
          function i(e, r) {
            this.data = e;
            if (!r) {
              this.data = n.string2binary(this.data);
            }
            this.length = this.data.length;
            this.index = 0;
          }
          i.prototype = new a();
          i.prototype.byteAt = function (e) {
            return this.data.charCodeAt(e);
          };
          i.prototype.lastIndexOfSignature = function (e) {
            return this.data.lastIndexOf(e);
          };
          i.prototype.readData = function (e) {
            this.checkOffset(e);
            var r = this.data.slice(this.index, this.index + e);
            this.index += e;
            return r;
          };
          r.exports = i;
        },
        { "./dataReader": 5, "./utils": 21 },
      ],
      16: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          var n = function () {
            this.data = [];
          };
          n.prototype = {
            append: function (e) {
              e = a.transformTo("string", e);
              this.data.push(e);
            },
            finalize: function () {
              return this.data.join("");
            },
          };
          r.exports = n;
        },
        { "./utils": 21 },
      ],
      17: [
        function (e, r, t) {
          (function (e) {
            "use strict";
            t.base64 = true;
            t.array = true;
            t.string = true;
            t.arraybuffer =
              typeof ArrayBuffer !== "undefined" &&
              typeof Uint8Array !== "undefined";
            t.nodebuffer = typeof e !== "undefined";
            t.uint8array = typeof Uint8Array !== "undefined";
            if (typeof ArrayBuffer === "undefined") {
              t.blob = false;
            } else {
              var r = new ArrayBuffer(0);
              try {
                t.blob = new Blob([r], { type: "application/zip" }).size === 0;
              } catch (a) {
                try {
                  var n =
                    window.BlobBuilder ||
                    window.WebKitBlobBuilder ||
                    window.MozBlobBuilder ||
                    window.MSBlobBuilder;
                  var i = new n();
                  i.append(r);
                  t.blob = i.getBlob("application/zip").size === 0;
                } catch (a) {
                  t.blob = false;
                }
              }
            }
          }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
        },
        {},
      ],
      18: [
        function (e, r, t) {
          "use strict";
          var a = e("./dataReader");
          function n(e) {
            if (e) {
              this.data = e;
              this.length = this.data.length;
              this.index = 0;
            }
          }
          n.prototype = new a();
          n.prototype.byteAt = function (e) {
            return this.data[e];
          };
          n.prototype.lastIndexOfSignature = function (e) {
            var r = e.charCodeAt(0),
              t = e.charCodeAt(1),
              a = e.charCodeAt(2),
              n = e.charCodeAt(3);
            for (var i = this.length - 4; i >= 0; --i) {
              if (
                this.data[i] === r &&
                this.data[i + 1] === t &&
                this.data[i + 2] === a &&
                this.data[i + 3] === n
              ) {
                return i;
              }
            }
            return -1;
          };
          n.prototype.readData = function (e) {
            this.checkOffset(e);
            if (e === 0) {
              return new Uint8Array(0);
            }
            var r = this.data.subarray(this.index, this.index + e);
            this.index += e;
            return r;
          };
          r.exports = n;
        },
        { "./dataReader": 5 },
      ],
      19: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          var n = function (e) {
            this.data = new Uint8Array(e);
            this.index = 0;
          };
          n.prototype = {
            append: function (e) {
              if (e.length !== 0) {
                e = a.transformTo("uint8array", e);
                this.data.set(e, this.index);
                this.index += e.length;
              }
            },
            finalize: function () {
              return this.data;
            },
          };
          r.exports = n;
        },
        { "./utils": 21 },
      ],
      20: [
        function (e, r, t) {
          "use strict";
          var a = e("./utils");
          var n = e("./support");
          var i = e("./nodeBuffer");
          var s = new Array(256);
          for (var f = 0; f < 256; f++) {
            s[f] =
              f >= 252
                ? 6
                : f >= 248
                ? 5
                : f >= 240
                ? 4
                : f >= 224
                ? 3
                : f >= 192
                ? 2
                : 1;
          }
          s[254] = s[254] = 1;
          var o = function (e) {
            var r,
              t,
              a,
              i,
              s,
              f = e.length,
              o = 0;
            for (i = 0; i < f; i++) {
              t = e.charCodeAt(i);
              if ((t & 64512) === 55296 && i + 1 < f) {
                a = e.charCodeAt(i + 1);
                if ((a & 64512) === 56320) {
                  t = 65536 + ((t - 55296) << 10) + (a - 56320);
                  i++;
                }
              }
              o += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
            }
            if (n.uint8array) {
              r = new Uint8Array(o);
            } else {
              r = new Array(o);
            }
            for (s = 0, i = 0; s < o; i++) {
              t = e.charCodeAt(i);
              if ((t & 64512) === 55296 && i + 1 < f) {
                a = e.charCodeAt(i + 1);
                if ((a & 64512) === 56320) {
                  t = 65536 + ((t - 55296) << 10) + (a - 56320);
                  i++;
                }
              }
              if (t < 128) {
                r[s++] = t;
              } else if (t < 2048) {
                r[s++] = 192 | (t >>> 6);
                r[s++] = 128 | (t & 63);
              } else if (t < 65536) {
                r[s++] = 224 | (t >>> 12);
                r[s++] = 128 | ((t >>> 6) & 63);
                r[s++] = 128 | (t & 63);
              } else {
                r[s++] = 240 | (t >>> 18);
                r[s++] = 128 | ((t >>> 12) & 63);
                r[s++] = 128 | ((t >>> 6) & 63);
                r[s++] = 128 | (t & 63);
              }
            }
            return r;
          };
          var l = function (e, r) {
            var t;
            r = r || e.length;
            if (r > e.length) {
              r = e.length;
            }
            t = r - 1;
            while (t >= 0 && (e[t] & 192) === 128) {
              t--;
            }
            if (t < 0) {
              return r;
            }
            if (t === 0) {
              return r;
            }
            return t + s[e[t]] > r ? t : r;
          };
          var c = function (e) {
            var r, t, n, i, f;
            var o = e.length;
            var l = new Array(o * 2);
            for (n = 0, t = 0; t < o; ) {
              i = e[t++];
              if (i < 128) {
                l[n++] = i;
                continue;
              }
              f = s[i];
              if (f > 4) {
                l[n++] = 65533;
                t += f - 1;
                continue;
              }
              i &= f === 2 ? 31 : f === 3 ? 15 : 7;
              while (f > 1 && t < o) {
                i = (i << 6) | (e[t++] & 63);
                f--;
              }
              if (f > 1) {
                l[n++] = 65533;
                continue;
              }
              if (i < 65536) {
                l[n++] = i;
              } else {
                i -= 65536;
                l[n++] = 55296 | ((i >> 10) & 1023);
                l[n++] = 56320 | (i & 1023);
              }
            }
            if (l.length !== n) {
              if (l.subarray) {
                l = l.subarray(0, n);
              } else {
                l.length = n;
              }
            }
            return a.applyFromCharCode(l);
          };
          t.utf8encode = function u(e) {
            if (n.nodebuffer) {
              return i(e, "utf-8");
            }
            return o(e);
          };
          t.utf8decode = function h(e) {
            if (n.nodebuffer) {
              return a.transformTo("nodebuffer", e).toString("utf-8");
            }
            e = a.transformTo(n.uint8array ? "uint8array" : "array", e);
            var r = [],
              t = 0,
              i = e.length,
              s = 65536;
            while (t < i) {
              var f = l(e, Math.min(t + s, i));
              if (n.uint8array) {
                r.push(c(e.subarray(t, f)));
              } else {
                r.push(c(e.slice(t, f)));
              }
              t = f;
            }
            return r.join("");
          };
        },
        { "./nodeBuffer": 11, "./support": 17, "./utils": 21 },
      ],
      21: [
        function (e, r, t) {
          "use strict";
          var a = e("./support");
          var n = e("./compressions");
          var i = e("./nodeBuffer");
          t.string2binary = function (e) {
            var r = "";
            for (var t = 0; t < e.length; t++) {
              r += String.fromCharCode(e.charCodeAt(t) & 255);
            }
            return r;
          };
          t.arrayBuffer2Blob = function (e) {
            t.checkSupport("blob");
            try {
              return new Blob([e], { type: "application/zip" });
            } catch (r) {
              try {
                var a =
                  window.BlobBuilder ||
                  window.WebKitBlobBuilder ||
                  window.MozBlobBuilder ||
                  window.MSBlobBuilder;
                var n = new a();
                n.append(e);
                return n.getBlob("application/zip");
              } catch (r) {
                throw new Error("Bug : can't construct the Blob.");
              }
            }
          };
          function s(e) {
            return e;
          }
          function f(e, r) {
            for (var t = 0; t < e.length; ++t) {
              r[t] = e.charCodeAt(t) & 255;
            }
            return r;
          }
          function o(e) {
            var r = 65536;
            var a = [],
              n = e.length,
              s = t.getTypeOf(e),
              f = 0,
              o = true;
            try {
              switch (s) {
                case "uint8array":
                  String.fromCharCode.apply(null, new Uint8Array(0));
                  break;
                case "nodebuffer":
                  String.fromCharCode.apply(null, i(0));
                  break;
              }
            } catch (l) {
              o = false;
            }
            if (!o) {
              var c = "";
              for (var u = 0; u < e.length; u++) {
                c += String.fromCharCode(e[u]);
              }
              return c;
            }
            while (f < n && r > 1) {
              try {
                if (s === "array" || s === "nodebuffer") {
                  a.push(
                    String.fromCharCode.apply(
                      null,
                      e.slice(f, Math.min(f + r, n))
                    )
                  );
                } else {
                  a.push(
                    String.fromCharCode.apply(
                      null,
                      e.subarray(f, Math.min(f + r, n))
                    )
                  );
                }
                f += r;
              } catch (l) {
                r = Math.floor(r / 2);
              }
            }
            return a.join("");
          }
          t.applyFromCharCode = o;
          function l(e, r) {
            for (var t = 0; t < e.length; t++) {
              r[t] = e[t];
            }
            return r;
          }
          var c = {};
          c["string"] = {
            string: s,
            array: function (e) {
              return f(e, new Array(e.length));
            },
            arraybuffer: function (e) {
              return c["string"]["uint8array"](e).buffer;
            },
            uint8array: function (e) {
              return f(e, new Uint8Array(e.length));
            },
            nodebuffer: function (e) {
              return f(e, i(e.length));
            },
          };
          c["array"] = {
            string: o,
            array: s,
            arraybuffer: function (e) {
              return new Uint8Array(e).buffer;
            },
            uint8array: function (e) {
              return new Uint8Array(e);
            },
            nodebuffer: function (e) {
              return i(e);
            },
          };
          c["arraybuffer"] = {
            string: function (e) {
              return o(new Uint8Array(e));
            },
            array: function (e) {
              return l(new Uint8Array(e), new Array(e.byteLength));
            },
            arraybuffer: s,
            uint8array: function (e) {
              return new Uint8Array(e);
            },
            nodebuffer: function (e) {
              return i(new Uint8Array(e));
            },
          };
          c["uint8array"] = {
            string: o,
            array: function (e) {
              return l(e, new Array(e.length));
            },
            arraybuffer: function (e) {
              return e.buffer;
            },
            uint8array: s,
            nodebuffer: function (e) {
              return i(e);
            },
          };
          c["nodebuffer"] = {
            string: o,
            array: function (e) {
              return l(e, new Array(e.length));
            },
            arraybuffer: function (e) {
              return c["nodebuffer"]["uint8array"](e).buffer;
            },
            uint8array: function (e) {
              return l(e, new Uint8Array(e.length));
            },
            nodebuffer: s,
          };
          t.transformTo = function (e, r) {
            if (!r) {
              r = "";
            }
            if (!e) {
              return r;
            }
            t.checkSupport(e);
            var a = t.getTypeOf(r);
            var n = c[a][e](r);
            return n;
          };
          t.getTypeOf = function (e) {
            if (typeof e === "string") {
              return "string";
            }
            if (Object.prototype.toString.call(e) === "[object Array]") {
              return "array";
            }
            if (a.nodebuffer && i.test(e)) {
              return "nodebuffer";
            }
            if (a.uint8array && e instanceof Uint8Array) {
              return "uint8array";
            }
            if (a.arraybuffer && e instanceof ArrayBuffer) {
              return "arraybuffer";
            }
          };
          t.checkSupport = function (e) {
            var r = a[e.toLowerCase()];
            if (!r) {
              throw new Error(e + " is not supported by this browser");
            }
          };
          t.MAX_VALUE_16BITS = 65535;
          t.MAX_VALUE_32BITS = -1;
          t.pretty = function (e) {
            var r = "",
              t,
              a;
            for (a = 0; a < (e || "").length; a++) {
              t = e.charCodeAt(a);
              r += "\\x" + (t < 16 ? "0" : "") + t.toString(16).toUpperCase();
            }
            return r;
          };
          t.findCompression = function (e) {
            for (var r in n) {
              if (!n.hasOwnProperty(r)) {
                continue;
              }
              if (n[r].magic === e) {
                return n[r];
              }
            }
            return null;
          };
          t.isRegExp = function (e) {
            return Object.prototype.toString.call(e) === "[object RegExp]";
          };
        },
        { "./compressions": 3, "./nodeBuffer": 11, "./support": 17 },
      ],
      22: [
        function (e, r, t) {
          "use strict";
          var a = e("./stringReader");
          var n = e("./nodeBufferReader");
          var i = e("./uint8ArrayReader");
          var s = e("./utils");
          var f = e("./signature");
          var o = e("./zipEntry");
          var l = e("./support");
          var c = e("./object");
          function u(e, r) {
            this.files = [];
            this.loadOptions = r;
            if (e) {
              this.load(e);
            }
          }
          u.prototype = {
            checkSignature: function (e) {
              var r = this.reader.readString(4);
              if (r !== e) {
                throw new Error(
                  "Corrupted zip or bug : unexpected signature " +
                    "(" +
                    s.pretty(r) +
                    ", expected " +
                    s.pretty(e) +
                    ")"
                );
              }
            },
            readBlockEndOfCentral: function () {
              this.diskNumber = this.reader.readInt(2);
              this.diskWithCentralDirStart = this.reader.readInt(2);
              this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
              this.centralDirRecords = this.reader.readInt(2);
              this.centralDirSize = this.reader.readInt(4);
              this.centralDirOffset = this.reader.readInt(4);
              this.zipCommentLength = this.reader.readInt(2);
              this.zipComment = this.reader.readString(this.zipCommentLength);
              this.zipComment = c.utf8decode(this.zipComment);
            },
            readBlockZip64EndOfCentral: function () {
              this.zip64EndOfCentralSize = this.reader.readInt(8);
              this.versionMadeBy = this.reader.readString(2);
              this.versionNeeded = this.reader.readInt(2);
              this.diskNumber = this.reader.readInt(4);
              this.diskWithCentralDirStart = this.reader.readInt(4);
              this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
              this.centralDirRecords = this.reader.readInt(8);
              this.centralDirSize = this.reader.readInt(8);
              this.centralDirOffset = this.reader.readInt(8);
              this.zip64ExtensibleData = {};
              var e = this.zip64EndOfCentralSize - 44,
                r = 0,
                t,
                a,
                n;
              while (r < e) {
                t = this.reader.readInt(2);
                a = this.reader.readInt(4);
                n = this.reader.readString(a);
                this.zip64ExtensibleData[t] = { id: t, length: a, value: n };
              }
            },
            readBlockZip64EndOfCentralLocator: function () {
              this.diskWithZip64CentralDirStart = this.reader.readInt(4);
              this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
              this.disksCount = this.reader.readInt(4);
              if (this.disksCount > 1) {
                throw new Error("Multi-volumes zip are not supported");
              }
            },
            readLocalFiles: function () {
              var e, r;
              for (e = 0; e < this.files.length; e++) {
                r = this.files[e];
                this.reader.setIndex(r.localHeaderOffset);
                this.checkSignature(f.LOCAL_FILE_HEADER);
                r.readLocalPart(this.reader);
                r.handleUTF8();
              }
            },
            readCentralDir: function () {
              var e;
              this.reader.setIndex(this.centralDirOffset);
              while (this.reader.readString(4) === f.CENTRAL_FILE_HEADER) {
                e = new o({ zip64: this.zip64 }, this.loadOptions);
                e.readCentralPart(this.reader);
                this.files.push(e);
              }
            },
            readEndOfCentral: function () {
              var e = this.reader.lastIndexOfSignature(f.CENTRAL_DIRECTORY_END);
              if (e === -1) {
                throw new Error(
                  "Corrupted zip : can't find end of central directory"
                );
              }
              this.reader.setIndex(e);
              this.checkSignature(f.CENTRAL_DIRECTORY_END);
              this.readBlockEndOfCentral();
              if (
                this.diskNumber === s.MAX_VALUE_16BITS ||
                this.diskWithCentralDirStart === s.MAX_VALUE_16BITS ||
                this.centralDirRecordsOnThisDisk === s.MAX_VALUE_16BITS ||
                this.centralDirRecords === s.MAX_VALUE_16BITS ||
                this.centralDirSize === s.MAX_VALUE_32BITS ||
                this.centralDirOffset === s.MAX_VALUE_32BITS
              ) {
                this.zip64 = true;
                e = this.reader.lastIndexOfSignature(
                  f.ZIP64_CENTRAL_DIRECTORY_LOCATOR
                );
                if (e === -1) {
                  throw new Error(
                    "Corrupted zip : can't find the ZIP64 end of central directory locator"
                  );
                }
                this.reader.setIndex(e);
                this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
                this.readBlockZip64EndOfCentralLocator();
                this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
                this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_END);
                this.readBlockZip64EndOfCentral();
              }
            },
            prepareReader: function (e) {
              var r = s.getTypeOf(e);
              if (r === "string" && !l.uint8array) {
                this.reader = new a(e, this.loadOptions.optimizedBinaryString);
              } else if (r === "nodebuffer") {
                this.reader = new n(e);
              } else {
                this.reader = new i(s.transformTo("uint8array", e));
              }
            },
            load: function (e) {
              this.prepareReader(e);
              this.readEndOfCentral();
              this.readCentralDir();
              this.readLocalFiles();
            },
          };
          r.exports = u;
        },
        {
          "./nodeBufferReader": 12,
          "./object": 13,
          "./signature": 14,
          "./stringReader": 15,
          "./support": 17,
          "./uint8ArrayReader": 18,
          "./utils": 21,
          "./zipEntry": 23,
        },
      ],
      23: [
        function (e, r, t) {
          "use strict";
          var a = e("./stringReader");
          var n = e("./utils");
          var i = e("./compressedObject");
          var s = e("./object");
          function f(e, r) {
            this.options = e;
            this.loadOptions = r;
          }
          f.prototype = {
            isEncrypted: function () {
              return (this.bitFlag & 1) === 1;
            },
            useUTF8: function () {
              return (this.bitFlag & 2048) === 2048;
            },
            prepareCompressedContent: function (e, r, t) {
              return function () {
                var a = e.index;
                e.setIndex(r);
                var n = e.readData(t);
                e.setIndex(a);
                return n;
              };
            },
            prepareContent: function (e, r, t, a, i) {
              return function () {
                var e = n.transformTo(
                  a.uncompressInputType,
                  this.getCompressedContent()
                );
                var r = a.uncompress(e);
                if (r.length !== i) {
                  throw new Error("Bug : uncompressed data size mismatch");
                }
                return r;
              };
            },
            readLocalPart: function (e) {
              var r, t;
              e.skip(22);
              this.fileNameLength = e.readInt(2);
              t = e.readInt(2);
              this.fileName = e.readString(this.fileNameLength);
              e.skip(t);
              if (this.compressedSize == -1 || this.uncompressedSize == -1) {
                throw new Error(
                  "Bug or corrupted zip : didn't get enough informations from the central directory " +
                    "(compressedSize == -1 || uncompressedSize == -1)"
                );
              }
              r = n.findCompression(this.compressionMethod);
              if (r === null) {
                throw new Error(
                  "Corrupted zip : compression " +
                    n.pretty(this.compressionMethod) +
                    " unknown (inner file : " +
                    this.fileName +
                    ")"
                );
              }
              this.decompressed = new i();
              this.decompressed.compressedSize = this.compressedSize;
              this.decompressed.uncompressedSize = this.uncompressedSize;
              this.decompressed.crc32 = this.crc32;
              this.decompressed.compressionMethod = this.compressionMethod;
              this.decompressed.getCompressedContent =
                this.prepareCompressedContent(
                  e,
                  e.index,
                  this.compressedSize,
                  r
                );
              this.decompressed.getContent = this.prepareContent(
                e,
                e.index,
                this.compressedSize,
                r,
                this.uncompressedSize
              );
              if (this.loadOptions.checkCRC32) {
                this.decompressed = n.transformTo(
                  "string",
                  this.decompressed.getContent()
                );
                if (s.crc32(this.decompressed) !== this.crc32) {
                  throw new Error("Corrupted zip : CRC32 mismatch");
                }
              }
            },
            readCentralPart: function (e) {
              this.versionMadeBy = e.readString(2);
              this.versionNeeded = e.readInt(2);
              this.bitFlag = e.readInt(2);
              this.compressionMethod = e.readString(2);
              this.date = e.readDate();
              this.crc32 = e.readInt(4);
              this.compressedSize = e.readInt(4);
              this.uncompressedSize = e.readInt(4);
              this.fileNameLength = e.readInt(2);
              this.extraFieldsLength = e.readInt(2);
              this.fileCommentLength = e.readInt(2);
              this.diskNumberStart = e.readInt(2);
              this.internalFileAttributes = e.readInt(2);
              this.externalFileAttributes = e.readInt(4);
              this.localHeaderOffset = e.readInt(4);
              if (this.isEncrypted()) {
                throw new Error("Encrypted zip are not supported");
              }
              this.fileName = e.readString(this.fileNameLength);
              this.readExtraFields(e);
              this.parseZIP64ExtraField(e);
              this.fileComment = e.readString(this.fileCommentLength);
              this.dir = this.externalFileAttributes & 16 ? true : false;
            },
            parseZIP64ExtraField: function (e) {
              if (!this.extraFields[1]) {
                return;
              }
              var r = new a(this.extraFields[1].value);
              if (this.uncompressedSize === n.MAX_VALUE_32BITS) {
                this.uncompressedSize = r.readInt(8);
              }
              if (this.compressedSize === n.MAX_VALUE_32BITS) {
                this.compressedSize = r.readInt(8);
              }
              if (this.localHeaderOffset === n.MAX_VALUE_32BITS) {
                this.localHeaderOffset = r.readInt(8);
              }
              if (this.diskNumberStart === n.MAX_VALUE_32BITS) {
                this.diskNumberStart = r.readInt(4);
              }
            },
            readExtraFields: function (e) {
              var r = e.index,
                t,
                a,
                n;
              this.extraFields = this.extraFields || {};
              while (e.index < r + this.extraFieldsLength) {
                t = e.readInt(2);
                a = e.readInt(2);
                n = e.readString(a);
                this.extraFields[t] = { id: t, length: a, value: n };
              }
            },
            handleUTF8: function () {
              if (this.useUTF8()) {
                this.fileName = s.utf8decode(this.fileName);
                this.fileComment = s.utf8decode(this.fileComment);
              } else {
                var e = this.findExtraFieldUnicodePath();
                if (e !== null) {
                  this.fileName = e;
                }
                var r = this.findExtraFieldUnicodeComment();
                if (r !== null) {
                  this.fileComment = r;
                }
              }
            },
            findExtraFieldUnicodePath: function () {
              var e = this.extraFields[28789];
              if (e) {
                var r = new a(e.value);
                if (r.readInt(1) !== 1) {
                  return null;
                }
                if (s.crc32(this.fileName) !== r.readInt(4)) {
                  return null;
                }
                return s.utf8decode(r.readString(e.length - 5));
              }
              return null;
            },
            findExtraFieldUnicodeComment: function () {
              var e = this.extraFields[25461];
              if (e) {
                var r = new a(e.value);
                if (r.readInt(1) !== 1) {
                  return null;
                }
                if (s.crc32(this.fileComment) !== r.readInt(4)) {
                  return null;
                }
                return s.utf8decode(r.readString(e.length - 5));
              }
              return null;
            },
          };
          r.exports = f;
        },
        {
          "./compressedObject": 2,
          "./object": 13,
          "./stringReader": 15,
          "./utils": 21,
        },
      ],
      24: [
        function (e, r, t) {
          "use strict";
          var a = e("./lib/utils/common").assign;
          var n = e("./lib/deflate");
          var i = e("./lib/inflate");
          var s = e("./lib/zlib/constants");
          var f = {};
          a(f, n, i, s);
          r.exports = f;
        },
        {
          "./lib/deflate": 25,
          "./lib/inflate": 26,
          "./lib/utils/common": 27,
          "./lib/zlib/constants": 30,
        },
      ],
      25: [
        function (e, r, t) {
          "use strict";
          var a = e("./zlib/deflate.js");
          var n = e("./utils/common");
          var i = e("./utils/strings");
          var s = e("./zlib/messages");
          var f = e("./zlib/zstream");
          var o = 0;
          var l = 4;
          var c = 0;
          var u = 1;
          var h = -1;
          var d = 0;
          var v = 8;
          var p = function (e) {
            this.options = n.assign(
              {
                level: h,
                method: v,
                chunkSize: 16384,
                windowBits: 15,
                memLevel: 8,
                strategy: d,
                to: "",
              },
              e || {}
            );
            var r = this.options;
            if (r.raw && r.windowBits > 0) {
              r.windowBits = -r.windowBits;
            } else if (r.gzip && r.windowBits > 0 && r.windowBits < 16) {
              r.windowBits += 16;
            }
            this.err = 0;
            this.msg = "";
            this.ended = false;
            this.chunks = [];
            this.strm = new f();
            this.strm.avail_out = 0;
            var t = a.deflateInit2(
              this.strm,
              r.level,
              r.method,
              r.windowBits,
              r.memLevel,
              r.strategy
            );
            if (t !== c) {
              throw new Error(s[t]);
            }
            if (r.header) {
              a.deflateSetHeader(this.strm, r.header);
            }
          };
          p.prototype.push = function (e, r) {
            var t = this.strm;
            var s = this.options.chunkSize;
            var f, h;
            if (this.ended) {
              return false;
            }
            h = r === ~~r ? r : r === true ? l : o;
            if (typeof e === "string") {
              t.input = i.string2buf(e);
            } else {
              t.input = e;
            }
            t.next_in = 0;
            t.avail_in = t.input.length;
            do {
              if (t.avail_out === 0) {
                t.output = new n.Buf8(s);
                t.next_out = 0;
                t.avail_out = s;
              }
              f = a.deflate(t, h);
              if (f !== u && f !== c) {
                this.onEnd(f);
                this.ended = true;
                return false;
              }
              if (t.avail_out === 0 || (t.avail_in === 0 && h === l)) {
                if (this.options.to === "string") {
                  this.onData(
                    i.buf2binstring(n.shrinkBuf(t.output, t.next_out))
                  );
                } else {
                  this.onData(n.shrinkBuf(t.output, t.next_out));
                }
              }
            } while ((t.avail_in > 0 || t.avail_out === 0) && f !== u);
            if (h === l) {
              f = a.deflateEnd(this.strm);
              this.onEnd(f);
              this.ended = true;
              return f === c;
            }
            return true;
          };
          p.prototype.onData = function (e) {
            this.chunks.push(e);
          };
          p.prototype.onEnd = function (e) {
            if (e === c) {
              if (this.options.to === "string") {
                this.result = this.chunks.join("");
              } else {
                this.result = n.flattenChunks(this.chunks);
              }
            }
            this.chunks = [];
            this.err = e;
            this.msg = this.strm.msg;
          };
          function m(e, r) {
            var t = new p(r);
            t.push(e, true);
            if (t.err) {
              throw t.msg;
            }
            return t.result;
          }
          function b(e, r) {
            r = r || {};
            r.raw = true;
            return m(e, r);
          }
          function g(e, r) {
            r = r || {};
            r.gzip = true;
            return m(e, r);
          }
          t.Deflate = p;
          t.deflate = m;
          t.deflateRaw = b;
          t.gzip = g;
        },
        {
          "./utils/common": 27,
          "./utils/strings": 28,
          "./zlib/deflate.js": 32,
          "./zlib/messages": 37,
          "./zlib/zstream": 39,
        },
      ],
      26: [
        function (e, r, t) {
          "use strict";
          var a = e("./zlib/inflate.js");
          var n = e("./utils/common");
          var i = e("./utils/strings");
          var s = e("./zlib/constants");
          var f = e("./zlib/messages");
          var o = e("./zlib/zstream");
          var l = e("./zlib/gzheader");
          var c = function (e) {
            this.options = n.assign(
              { chunkSize: 16384, windowBits: 0, to: "" },
              e || {}
            );
            var r = this.options;
            if (r.raw && r.windowBits >= 0 && r.windowBits < 16) {
              r.windowBits = -r.windowBits;
              if (r.windowBits === 0) {
                r.windowBits = -15;
              }
            }
            if (
              r.windowBits >= 0 &&
              r.windowBits < 16 &&
              !(e && e.windowBits)
            ) {
              r.windowBits += 32;
            }
            if (r.windowBits > 15 && r.windowBits < 48) {
              if ((r.windowBits & 15) === 0) {
                r.windowBits |= 15;
              }
            }
            this.err = 0;
            this.msg = "";
            this.ended = false;
            this.chunks = [];
            this.strm = new o();
            this.strm.avail_out = 0;
            var t = a.inflateInit2(this.strm, r.windowBits);
            if (t !== s.Z_OK) {
              throw new Error(f[t]);
            }
            this.header = new l();
            a.inflateGetHeader(this.strm, this.header);
          };
          c.prototype.push = function (e, r) {
            var t = this.strm;
            var f = this.options.chunkSize;
            var o, l;
            var c, u, h;
            if (this.ended) {
              return false;
            }
            l = r === ~~r ? r : r === true ? s.Z_FINISH : s.Z_NO_FLUSH;
            if (typeof e === "string") {
              t.input = i.binstring2buf(e);
            } else {
              t.input = e;
            }
            t.next_in = 0;
            t.avail_in = t.input.length;
            do {
              if (t.avail_out === 0) {
                t.output = new n.Buf8(f);
                t.next_out = 0;
                t.avail_out = f;
              }
              o = a.inflate(t, s.Z_NO_FLUSH);
              if (o !== s.Z_STREAM_END && o !== s.Z_OK) {
                this.onEnd(o);
                this.ended = true;
                return false;
              }
              if (t.next_out) {
                if (
                  t.avail_out === 0 ||
                  o === s.Z_STREAM_END ||
                  (t.avail_in === 0 && l === s.Z_FINISH)
                ) {
                  if (this.options.to === "string") {
                    c = i.utf8border(t.output, t.next_out);
                    u = t.next_out - c;
                    h = i.buf2string(t.output, c);
                    t.next_out = u;
                    t.avail_out = f - u;
                    if (u) {
                      n.arraySet(t.output, t.output, c, u, 0);
                    }
                    this.onData(h);
                  } else {
                    this.onData(n.shrinkBuf(t.output, t.next_out));
                  }
                }
              }
            } while (t.avail_in > 0 && o !== s.Z_STREAM_END);
            if (o === s.Z_STREAM_END) {
              l = s.Z_FINISH;
            }
            if (l === s.Z_FINISH) {
              o = a.inflateEnd(this.strm);
              this.onEnd(o);
              this.ended = true;
              return o === s.Z_OK;
            }
            return true;
          };
          c.prototype.onData = function (e) {
            this.chunks.push(e);
          };
          c.prototype.onEnd = function (e) {
            if (e === s.Z_OK) {
              if (this.options.to === "string") {
                this.result = this.chunks.join("");
              } else {
                this.result = n.flattenChunks(this.chunks);
              }
            }
            this.chunks = [];
            this.err = e;
            this.msg = this.strm.msg;
          };
          function u(e, r) {
            var t = new c(r);
            t.push(e, true);
            if (t.err) {
              throw t.msg;
            }
            return t.result;
          }
          function h(e, r) {
            r = r || {};
            r.raw = true;
            return u(e, r);
          }
          t.Inflate = c;
          t.inflate = u;
          t.inflateRaw = h;
          t.ungzip = u;
        },
        {
          "./utils/common": 27,
          "./utils/strings": 28,
          "./zlib/constants": 30,
          "./zlib/gzheader": 33,
          "./zlib/inflate.js": 35,
          "./zlib/messages": 37,
          "./zlib/zstream": 39,
        },
      ],
      27: [
        function (e, r, t) {
          "use strict";
          var a =
            typeof Uint8Array !== "undefined" &&
            typeof Uint16Array !== "undefined" &&
            typeof Int32Array !== "undefined";
          t.assign = function (e) {
            var r = Array.prototype.slice.call(arguments, 1);
            while (r.length) {
              var t = r.shift();
              if (!t) {
                continue;
              }
              if (typeof t !== "object") {
                throw new TypeError(t + "must be non-object");
              }
              for (var a in t) {
                if (t.hasOwnProperty(a)) {
                  e[a] = t[a];
                }
              }
            }
            return e;
          };
          t.shrinkBuf = function (e, r) {
            if (e.length === r) {
              return e;
            }
            if (e.subarray) {
              return e.subarray(0, r);
            }
            e.length = r;
            return e;
          };
          var n = {
            arraySet: function (e, r, t, a, n) {
              if (r.subarray && e.subarray) {
                e.set(r.subarray(t, t + a), n);
                return;
              }
              for (var i = 0; i < a; i++) {
                e[n + i] = r[t + i];
              }
            },
            flattenChunks: function (e) {
              var r, t, a, n, i, s;
              a = 0;
              for (r = 0, t = e.length; r < t; r++) {
                a += e[r].length;
              }
              s = new Uint8Array(a);
              n = 0;
              for (r = 0, t = e.length; r < t; r++) {
                i = e[r];
                s.set(i, n);
                n += i.length;
              }
              return s;
            },
          };
          var i = {
            arraySet: function (e, r, t, a, n) {
              for (var i = 0; i < a; i++) {
                e[n + i] = r[t + i];
              }
            },
            flattenChunks: function (e) {
              return [].concat.apply([], e);
            },
          };
          t.setTyped = function (e) {
            if (e) {
              t.Buf8 = Uint8Array;
              t.Buf16 = Uint16Array;
              t.Buf32 = Int32Array;
              t.assign(t, n);
            } else {
              t.Buf8 = Array;
              t.Buf16 = Array;
              t.Buf32 = Array;
              t.assign(t, i);
            }
          };
          t.setTyped(a);
        },
        {},
      ],
      28: [
        function (e, r, t) {
          "use strict";
          var a = e("./common");
          var n = true;
          var i = true;
          try {
            String.fromCharCode.apply(null, [0]);
          } catch (s) {
            n = false;
          }
          try {
            String.fromCharCode.apply(null, new Uint8Array(1));
          } catch (s) {
            i = false;
          }
          var f = new a.Buf8(256);
          for (var o = 0; o < 256; o++) {
            f[o] =
              o >= 252
                ? 6
                : o >= 248
                ? 5
                : o >= 240
                ? 4
                : o >= 224
                ? 3
                : o >= 192
                ? 2
                : 1;
          }
          f[254] = f[254] = 1;
          t.string2buf = function (e) {
            var r,
              t,
              n,
              i,
              s,
              f = e.length,
              o = 0;
            for (i = 0; i < f; i++) {
              t = e.charCodeAt(i);
              if ((t & 64512) === 55296 && i + 1 < f) {
                n = e.charCodeAt(i + 1);
                if ((n & 64512) === 56320) {
                  t = 65536 + ((t - 55296) << 10) + (n - 56320);
                  i++;
                }
              }
              o += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
            }
            r = new a.Buf8(o);
            for (s = 0, i = 0; s < o; i++) {
              t = e.charCodeAt(i);
              if ((t & 64512) === 55296 && i + 1 < f) {
                n = e.charCodeAt(i + 1);
                if ((n & 64512) === 56320) {
                  t = 65536 + ((t - 55296) << 10) + (n - 56320);
                  i++;
                }
              }
              if (t < 128) {
                r[s++] = t;
              } else if (t < 2048) {
                r[s++] = 192 | (t >>> 6);
                r[s++] = 128 | (t & 63);
              } else if (t < 65536) {
                r[s++] = 224 | (t >>> 12);
                r[s++] = 128 | ((t >>> 6) & 63);
                r[s++] = 128 | (t & 63);
              } else {
                r[s++] = 240 | (t >>> 18);
                r[s++] = 128 | ((t >>> 12) & 63);
                r[s++] = 128 | ((t >>> 6) & 63);
                r[s++] = 128 | (t & 63);
              }
            }
            return r;
          };
          function l(e, r) {
            if (r < 65537) {
              if ((e.subarray && i) || (!e.subarray && n)) {
                return String.fromCharCode.apply(null, a.shrinkBuf(e, r));
              }
            }
            var t = "";
            for (var s = 0; s < r; s++) {
              t += String.fromCharCode(e[s]);
            }
            return t;
          }
          t.buf2binstring = function (e) {
            return l(e, e.length);
          };
          t.binstring2buf = function (e) {
            var r = new a.Buf8(e.length);
            for (var t = 0, n = r.length; t < n; t++) {
              r[t] = e.charCodeAt(t);
            }
            return r;
          };
          t.buf2string = function (e, r) {
            var t, a, n, i;
            var s = r || e.length;
            var o = new Array(s * 2);
            for (a = 0, t = 0; t < s; ) {
              n = e[t++];
              if (n < 128) {
                o[a++] = n;
                continue;
              }
              i = f[n];
              if (i > 4) {
                o[a++] = 65533;
                t += i - 1;
                continue;
              }
              n &= i === 2 ? 31 : i === 3 ? 15 : 7;
              while (i > 1 && t < s) {
                n = (n << 6) | (e[t++] & 63);
                i--;
              }
              if (i > 1) {
                o[a++] = 65533;
                continue;
              }
              if (n < 65536) {
                o[a++] = n;
              } else {
                n -= 65536;
                o[a++] = 55296 | ((n >> 10) & 1023);
                o[a++] = 56320 | (n & 1023);
              }
            }
            return l(o, a);
          };
          t.utf8border = function (e, r) {
            var t;
            r = r || e.length;
            if (r > e.length) {
              r = e.length;
            }
            t = r - 1;
            while (t >= 0 && (e[t] & 192) === 128) {
              t--;
            }
            if (t < 0) {
              return r;
            }
            if (t === 0) {
              return r;
            }
            return t + f[e[t]] > r ? t : r;
          };
        },
        { "./common": 27 },
      ],
      29: [
        function (e, r, t) {
          "use strict";
          function a(e, r, t, a) {
            var n = (e & 65535) | 0,
              i = ((e >>> 16) & 65535) | 0,
              s = 0;
            while (t !== 0) {
              s = t > 2e3 ? 2e3 : t;
              t -= s;
              do {
                n = (n + r[a++]) | 0;
                i = (i + n) | 0;
              } while (--s);
              n %= 65521;
              i %= 65521;
            }
            return n | (i << 16) | 0;
          }
          r.exports = a;
        },
        {},
      ],
      30: [
        function (e, r, t) {
          r.exports = {
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_BUF_ERROR: -5,
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            Z_BINARY: 0,
            Z_TEXT: 1,
            Z_UNKNOWN: 2,
            Z_DEFLATED: 8,
          };
        },
        {},
      ],
      31: [
        function (e, r, t) {
          "use strict";
          function a() {
            var e,
              r = [];
            for (var t = 0; t < 256; t++) {
              e = t;
              for (var a = 0; a < 8; a++) {
                e = e & 1 ? 3988292384 ^ (e >>> 1) : e >>> 1;
              }
              r[t] = e;
            }
            return r;
          }
          var n = a();
          function i(e, r, t, a) {
            var i = n,
              s = a + t;
            e = e ^ -1;
            for (var f = a; f < s; f++) {
              e = (e >>> 8) ^ i[(e ^ r[f]) & 255];
            }
            return e ^ -1;
          }
          r.exports = i;
        },
        {},
      ],
      32: [
        function (e, r, t) {
          "use strict";
          var a = e("../utils/common");
          var n = e("./trees");
          var i = e("./adler32");
          var s = e("./crc32");
          var f = e("./messages");
          var o = 0;
          var l = 1;
          var c = 3;
          var u = 4;
          var h = 5;
          var d = 0;
          var v = 1;
          var p = -2;
          var m = -3;
          var b = -5;
          var g = -1;
          var E = 1;
          var k = 2;
          var S = 3;
          var w = 4;
          var B = 0;
          var C = 2;
          var _ = 8;
          var T = 9;
          var x = 15;
          var I = 8;
          var A = 29;
          var y = 256;
          var R = y + 1 + A;
          var D = 30;
          var O = 19;
          var F = 2 * R + 1;
          var P = 15;
          var N = 3;
          var L = 258;
          var M = L + N + 1;
          var U = 32;
          var H = 42;
          var W = 69;
          var V = 73;
          var z = 91;
          var X = 103;
          var G = 113;
          var j = 666;
          var K = 1;
          var Y = 2;
          var $ = 3;
          var Z = 4;
          var Q = 3;
          function J(e, r) {
            e.msg = f[r];
            return r;
          }
          function q(e) {
            return (e << 1) - (e > 4 ? 9 : 0);
          }
          function ee(e) {
            var r = e.length;
            while (--r >= 0) {
              e[r] = 0;
            }
          }
          function re(e) {
            var r = e.state;
            var t = r.pending;
            if (t > e.avail_out) {
              t = e.avail_out;
            }
            if (t === 0) {
              return;
            }
            a.arraySet(e.output, r.pending_buf, r.pending_out, t, e.next_out);
            e.next_out += t;
            r.pending_out += t;
            e.total_out += t;
            e.avail_out -= t;
            r.pending -= t;
            if (r.pending === 0) {
              r.pending_out = 0;
            }
          }
          function te(e, r) {
            n._tr_flush_block(
              e,
              e.block_start >= 0 ? e.block_start : -1,
              e.strstart - e.block_start,
              r
            );
            e.block_start = e.strstart;
            re(e.strm);
          }
          function ae(e, r) {
            e.pending_buf[e.pending++] = r;
          }
          function ne(e, r) {
            e.pending_buf[e.pending++] = (r >>> 8) & 255;
            e.pending_buf[e.pending++] = r & 255;
          }
          function ie(e, r, t, n) {
            var f = e.avail_in;
            if (f > n) {
              f = n;
            }
            if (f === 0) {
              return 0;
            }
            e.avail_in -= f;
            a.arraySet(r, e.input, e.next_in, f, t);
            if (e.state.wrap === 1) {
              e.adler = i(e.adler, r, f, t);
            } else if (e.state.wrap === 2) {
              e.adler = s(e.adler, r, f, t);
            }
            e.next_in += f;
            e.total_in += f;
            return f;
          }
          function se(e, r) {
            var t = e.max_chain_length;
            var a = e.strstart;
            var n;
            var i;
            var s = e.prev_length;
            var f = e.nice_match;
            var o = e.strstart > e.w_size - M ? e.strstart - (e.w_size - M) : 0;
            var l = e.window;
            var c = e.w_mask;
            var u = e.prev;
            var h = e.strstart + L;
            var d = l[a + s - 1];
            var v = l[a + s];
            if (e.prev_length >= e.good_match) {
              t >>= 2;
            }
            if (f > e.lookahead) {
              f = e.lookahead;
            }
            do {
              n = r;
              if (
                l[n + s] !== v ||
                l[n + s - 1] !== d ||
                l[n] !== l[a] ||
                l[++n] !== l[a + 1]
              ) {
                continue;
              }
              a += 2;
              n++;
              do {} while (
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                l[++a] === l[++n] &&
                a < h
              );
              i = L - (h - a);
              a = h - L;
              if (i > s) {
                e.match_start = r;
                s = i;
                if (i >= f) {
                  break;
                }
                d = l[a + s - 1];
                v = l[a + s];
              }
            } while ((r = u[r & c]) > o && --t !== 0);
            if (s <= e.lookahead) {
              return s;
            }
            return e.lookahead;
          }
          function fe(e) {
            var r = e.w_size;
            var t, n, i, s, f;
            do {
              s = e.window_size - e.lookahead - e.strstart;
              if (e.strstart >= r + (r - M)) {
                a.arraySet(e.window, e.window, r, r, 0);
                e.match_start -= r;
                e.strstart -= r;
                e.block_start -= r;
                n = e.hash_size;
                t = n;
                do {
                  i = e.head[--t];
                  e.head[t] = i >= r ? i - r : 0;
                } while (--n);
                n = r;
                t = n;
                do {
                  i = e.prev[--t];
                  e.prev[t] = i >= r ? i - r : 0;
                } while (--n);
                s += r;
              }
              if (e.strm.avail_in === 0) {
                break;
              }
              n = ie(e.strm, e.window, e.strstart + e.lookahead, s);
              e.lookahead += n;
              if (e.lookahead + e.insert >= N) {
                f = e.strstart - e.insert;
                e.ins_h = e.window[f];
                e.ins_h =
                  ((e.ins_h << e.hash_shift) ^ e.window[f + 1]) & e.hash_mask;
                while (e.insert) {
                  e.ins_h =
                    ((e.ins_h << e.hash_shift) ^ e.window[f + N - 1]) &
                    e.hash_mask;
                  e.prev[f & e.w_mask] = e.head[e.ins_h];
                  e.head[e.ins_h] = f;
                  f++;
                  e.insert--;
                  if (e.lookahead + e.insert < N) {
                    break;
                  }
                }
              }
            } while (e.lookahead < M && e.strm.avail_in !== 0);
          }
          function oe(e, r) {
            var t = 65535;
            if (t > e.pending_buf_size - 5) {
              t = e.pending_buf_size - 5;
            }
            for (;;) {
              if (e.lookahead <= 1) {
                fe(e);
                if (e.lookahead === 0 && r === o) {
                  return K;
                }
                if (e.lookahead === 0) {
                  break;
                }
              }
              e.strstart += e.lookahead;
              e.lookahead = 0;
              var a = e.block_start + t;
              if (e.strstart === 0 || e.strstart >= a) {
                e.lookahead = e.strstart - a;
                e.strstart = a;
                te(e, false);
                if (e.strm.avail_out === 0) {
                  return K;
                }
              }
              if (e.strstart - e.block_start >= e.w_size - M) {
                te(e, false);
                if (e.strm.avail_out === 0) {
                  return K;
                }
              }
            }
            e.insert = 0;
            if (r === u) {
              te(e, true);
              if (e.strm.avail_out === 0) {
                return $;
              }
              return Z;
            }
            if (e.strstart > e.block_start) {
              te(e, false);
              if (e.strm.avail_out === 0) {
                return K;
              }
            }
            return K;
          }
          function le(e, r) {
            var t;
            var a;
            for (;;) {
              if (e.lookahead < M) {
                fe(e);
                if (e.lookahead < M && r === o) {
                  return K;
                }
                if (e.lookahead === 0) {
                  break;
                }
              }
              t = 0;
              if (e.lookahead >= N) {
                e.ins_h =
                  ((e.ins_h << e.hash_shift) ^ e.window[e.strstart + N - 1]) &
                  e.hash_mask;
                t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h];
                e.head[e.ins_h] = e.strstart;
              }
              if (t !== 0 && e.strstart - t <= e.w_size - M) {
                e.match_length = se(e, t);
              }
              if (e.match_length >= N) {
                a = n._tr_tally(
                  e,
                  e.strstart - e.match_start,
                  e.match_length - N
                );
                e.lookahead -= e.match_length;
                if (e.match_length <= e.max_lazy_match && e.lookahead >= N) {
                  e.match_length--;
                  do {
                    e.strstart++;
                    e.ins_h =
                      ((e.ins_h << e.hash_shift) ^
                        e.window[e.strstart + N - 1]) &
                      e.hash_mask;
                    t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h];
                    e.head[e.ins_h] = e.strstart;
                  } while (--e.match_length !== 0);
                  e.strstart++;
                } else {
                  e.strstart += e.match_length;
                  e.match_length = 0;
                  e.ins_h = e.window[e.strstart];
                  e.ins_h =
                    ((e.ins_h << e.hash_shift) ^ e.window[e.strstart + 1]) &
                    e.hash_mask;
                }
              } else {
                a = n._tr_tally(e, 0, e.window[e.strstart]);
                e.lookahead--;
                e.strstart++;
              }
              if (a) {
                te(e, false);
                if (e.strm.avail_out === 0) {
                  return K;
                }
              }
            }
            e.insert = e.strstart < N - 1 ? e.strstart : N - 1;
            if (r === u) {
              te(e, true);
              if (e.strm.avail_out === 0) {
                return $;
              }
              return Z;
            }
            if (e.last_lit) {
              te(e, false);
              if (e.strm.avail_out === 0) {
                return K;
              }
            }
            return Y;
          }
          function ce(e, r) {
            var t;
            var a;
            var i;
            for (;;) {
              if (e.lookahead < M) {
                fe(e);
                if (e.lookahead < M && r === o) {
                  return K;
                }
                if (e.lookahead === 0) {
                  break;
                }
              }
              t = 0;
              if (e.lookahead >= N) {
                e.ins_h =
                  ((e.ins_h << e.hash_shift) ^ e.window[e.strstart + N - 1]) &
                  e.hash_mask;
                t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h];
                e.head[e.ins_h] = e.strstart;
              }
              e.prev_length = e.match_length;
              e.prev_match = e.match_start;
              e.match_length = N - 1;
              if (
                t !== 0 &&
                e.prev_length < e.max_lazy_match &&
                e.strstart - t <= e.w_size - M
              ) {
                e.match_length = se(e, t);
                if (
                  e.match_length <= 5 &&
                  (e.strategy === E ||
                    (e.match_length === N && e.strstart - e.match_start > 4096))
                ) {
                  e.match_length = N - 1;
                }
              }
              if (e.prev_length >= N && e.match_length <= e.prev_length) {
                i = e.strstart + e.lookahead - N;
                a = n._tr_tally(
                  e,
                  e.strstart - 1 - e.prev_match,
                  e.prev_length - N
                );
                e.lookahead -= e.prev_length - 1;
                e.prev_length -= 2;
                do {
                  if (++e.strstart <= i) {
                    e.ins_h =
                      ((e.ins_h << e.hash_shift) ^
                        e.window[e.strstart + N - 1]) &
                      e.hash_mask;
                    t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h];
                    e.head[e.ins_h] = e.strstart;
                  }
                } while (--e.prev_length !== 0);
                e.match_available = 0;
                e.match_length = N - 1;
                e.strstart++;
                if (a) {
                  te(e, false);
                  if (e.strm.avail_out === 0) {
                    return K;
                  }
                }
              } else if (e.match_available) {
                a = n._tr_tally(e, 0, e.window[e.strstart - 1]);
                if (a) {
                  te(e, false);
                }
                e.strstart++;
                e.lookahead--;
                if (e.strm.avail_out === 0) {
                  return K;
                }
              } else {
                e.match_available = 1;
                e.strstart++;
                e.lookahead--;
              }
            }
            if (e.match_available) {
              a = n._tr_tally(e, 0, e.window[e.strstart - 1]);
              e.match_available = 0;
            }
            e.insert = e.strstart < N - 1 ? e.strstart : N - 1;
            if (r === u) {
              te(e, true);
              if (e.strm.avail_out === 0) {
                return $;
              }
              return Z;
            }
            if (e.last_lit) {
              te(e, false);
              if (e.strm.avail_out === 0) {
                return K;
              }
            }
            return Y;
          }
          function ue(e, r) {
            var t;
            var a;
            var i, s;
            var f = e.window;
            for (;;) {
              if (e.lookahead <= L) {
                fe(e);
                if (e.lookahead <= L && r === o) {
                  return K;
                }
                if (e.lookahead === 0) {
                  break;
                }
              }
              e.match_length = 0;
              if (e.lookahead >= N && e.strstart > 0) {
                i = e.strstart - 1;
                a = f[i];
                if (a === f[++i] && a === f[++i] && a === f[++i]) {
                  s = e.strstart + L;
                  do {} while (
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    a === f[++i] &&
                    i < s
                  );
                  e.match_length = L - (s - i);
                  if (e.match_length > e.lookahead) {
                    e.match_length = e.lookahead;
                  }
                }
              }
              if (e.match_length >= N) {
                t = n._tr_tally(e, 1, e.match_length - N);
                e.lookahead -= e.match_length;
                e.strstart += e.match_length;
                e.match_length = 0;
              } else {
                t = n._tr_tally(e, 0, e.window[e.strstart]);
                e.lookahead--;
                e.strstart++;
              }
              if (t) {
                te(e, false);
                if (e.strm.avail_out === 0) {
                  return K;
                }
              }
            }
            e.insert = 0;
            if (r === u) {
              te(e, true);
              if (e.strm.avail_out === 0) {
                return $;
              }
              return Z;
            }
            if (e.last_lit) {
              te(e, false);
              if (e.strm.avail_out === 0) {
                return K;
              }
            }
            return Y;
          }
          function he(e, r) {
            var t;
            for (;;) {
              if (e.lookahead === 0) {
                fe(e);
                if (e.lookahead === 0) {
                  if (r === o) {
                    return K;
                  }
                  break;
                }
              }
              e.match_length = 0;
              t = n._tr_tally(e, 0, e.window[e.strstart]);
              e.lookahead--;
              e.strstart++;
              if (t) {
                te(e, false);
                if (e.strm.avail_out === 0) {
                  return K;
                }
              }
            }
            e.insert = 0;
            if (r === u) {
              te(e, true);
              if (e.strm.avail_out === 0) {
                return $;
              }
              return Z;
            }
            if (e.last_lit) {
              te(e, false);
              if (e.strm.avail_out === 0) {
                return K;
              }
            }
            return Y;
          }
          var de = function (e, r, t, a, n) {
            this.good_length = e;
            this.max_lazy = r;
            this.nice_length = t;
            this.max_chain = a;
            this.func = n;
          };
          var ve;
          ve = [
            new de(0, 0, 0, 0, oe),
            new de(4, 4, 8, 4, le),
            new de(4, 5, 16, 8, le),
            new de(4, 6, 32, 32, le),
            new de(4, 4, 16, 16, ce),
            new de(8, 16, 32, 32, ce),
            new de(8, 16, 128, 128, ce),
            new de(8, 32, 128, 256, ce),
            new de(32, 128, 258, 1024, ce),
            new de(32, 258, 258, 4096, ce),
          ];
          function pe(e) {
            e.window_size = 2 * e.w_size;
            ee(e.head);
            e.max_lazy_match = ve[e.level].max_lazy;
            e.good_match = ve[e.level].good_length;
            e.nice_match = ve[e.level].nice_length;
            e.max_chain_length = ve[e.level].max_chain;
            e.strstart = 0;
            e.block_start = 0;
            e.lookahead = 0;
            e.insert = 0;
            e.match_length = e.prev_length = N - 1;
            e.match_available = 0;
            e.ins_h = 0;
          }
          function me() {
            this.strm = null;
            this.status = 0;
            this.pending_buf = null;
            this.pending_buf_size = 0;
            this.pending_out = 0;
            this.pending = 0;
            this.wrap = 0;
            this.gzhead = null;
            this.gzindex = 0;
            this.method = _;
            this.last_flush = -1;
            this.w_size = 0;
            this.w_bits = 0;
            this.w_mask = 0;
            this.window = null;
            this.window_size = 0;
            this.prev = null;
            this.head = null;
            this.ins_h = 0;
            this.hash_size = 0;
            this.hash_bits = 0;
            this.hash_mask = 0;
            this.hash_shift = 0;
            this.block_start = 0;
            this.match_length = 0;
            this.prev_match = 0;
            this.match_available = 0;
            this.strstart = 0;
            this.match_start = 0;
            this.lookahead = 0;
            this.prev_length = 0;
            this.max_chain_length = 0;
            this.max_lazy_match = 0;
            this.level = 0;
            this.strategy = 0;
            this.good_match = 0;
            this.nice_match = 0;
            this.dyn_ltree = new a.Buf16(F * 2);
            this.dyn_dtree = new a.Buf16((2 * D + 1) * 2);
            this.bl_tree = new a.Buf16((2 * O + 1) * 2);
            ee(this.dyn_ltree);
            ee(this.dyn_dtree);
            ee(this.bl_tree);
            this.l_desc = null;
            this.d_desc = null;
            this.bl_desc = null;
            this.bl_count = new a.Buf16(P + 1);
            this.heap = new a.Buf16(2 * R + 1);
            ee(this.heap);
            this.heap_len = 0;
            this.heap_max = 0;
            this.depth = new a.Buf16(2 * R + 1);
            ee(this.depth);
            this.l_buf = 0;
            this.lit_bufsize = 0;
            this.last_lit = 0;
            this.d_buf = 0;
            this.opt_len = 0;
            this.static_len = 0;
            this.matches = 0;
            this.insert = 0;
            this.bi_buf = 0;
            this.bi_valid = 0;
          }
          function be(e) {
            var r;
            if (!e || !e.state) {
              return J(e, p);
            }
            e.total_in = e.total_out = 0;
            e.data_type = C;
            r = e.state;
            r.pending = 0;
            r.pending_out = 0;
            if (r.wrap < 0) {
              r.wrap = -r.wrap;
            }
            r.status = r.wrap ? H : G;
            e.adler = r.wrap === 2 ? 0 : 1;
            r.last_flush = o;
            n._tr_init(r);
            return d;
          }
          function ge(e) {
            var r = be(e);
            if (r === d) {
              pe(e.state);
            }
            return r;
          }
          function Ee(e, r) {
            if (!e || !e.state) {
              return p;
            }
            if (e.state.wrap !== 2) {
              return p;
            }
            e.state.gzhead = r;
            return d;
          }
          function ke(e, r, t, n, i, s) {
            if (!e) {
              return p;
            }
            var f = 1;
            if (r === g) {
              r = 6;
            }
            if (n < 0) {
              f = 0;
              n = -n;
            } else if (n > 15) {
              f = 2;
              n -= 16;
            }
            if (
              i < 1 ||
              i > T ||
              t !== _ ||
              n < 8 ||
              n > 15 ||
              r < 0 ||
              r > 9 ||
              s < 0 ||
              s > w
            ) {
              return J(e, p);
            }
            if (n === 8) {
              n = 9;
            }
            var o = new me();
            e.state = o;
            o.strm = e;
            o.wrap = f;
            o.gzhead = null;
            o.w_bits = n;
            o.w_size = 1 << o.w_bits;
            o.w_mask = o.w_size - 1;
            o.hash_bits = i + 7;
            o.hash_size = 1 << o.hash_bits;
            o.hash_mask = o.hash_size - 1;
            o.hash_shift = ~~((o.hash_bits + N - 1) / N);
            o.window = new a.Buf8(o.w_size * 2);
            o.head = new a.Buf16(o.hash_size);
            o.prev = new a.Buf16(o.w_size);
            o.lit_bufsize = 1 << (i + 6);
            o.pending_buf_size = o.lit_bufsize * 4;
            o.pending_buf = new a.Buf8(o.pending_buf_size);
            o.d_buf = o.lit_bufsize >> 1;
            o.l_buf = (1 + 2) * o.lit_bufsize;
            o.level = r;
            o.strategy = s;
            o.method = t;
            return ge(e);
          }
          function Se(e, r) {
            return ke(e, r, _, x, I, B);
          }
          function we(e, r) {
            var t, a;
            var i, f;
            if (!e || !e.state || r > h || r < 0) {
              return e ? J(e, p) : p;
            }
            a = e.state;
            if (
              !e.output ||
              (!e.input && e.avail_in !== 0) ||
              (a.status === j && r !== u)
            ) {
              return J(e, e.avail_out === 0 ? b : p);
            }
            a.strm = e;
            t = a.last_flush;
            a.last_flush = r;
            if (a.status === H) {
              if (a.wrap === 2) {
                e.adler = 0;
                ae(a, 31);
                ae(a, 139);
                ae(a, 8);
                if (!a.gzhead) {
                  ae(a, 0);
                  ae(a, 0);
                  ae(a, 0);
                  ae(a, 0);
                  ae(a, 0);
                  ae(
                    a,
                    a.level === 9 ? 2 : a.strategy >= k || a.level < 2 ? 4 : 0
                  );
                  ae(a, Q);
                  a.status = G;
                } else {
                  ae(
                    a,
                    (a.gzhead.text ? 1 : 0) +
                      (a.gzhead.hcrc ? 2 : 0) +
                      (!a.gzhead.extra ? 0 : 4) +
                      (!a.gzhead.name ? 0 : 8) +
                      (!a.gzhead.comment ? 0 : 16)
                  );
                  ae(a, a.gzhead.time & 255);
                  ae(a, (a.gzhead.time >> 8) & 255);
                  ae(a, (a.gzhead.time >> 16) & 255);
                  ae(a, (a.gzhead.time >> 24) & 255);
                  ae(
                    a,
                    a.level === 9 ? 2 : a.strategy >= k || a.level < 2 ? 4 : 0
                  );
                  ae(a, a.gzhead.os & 255);
                  if (a.gzhead.extra && a.gzhead.extra.length) {
                    ae(a, a.gzhead.extra.length & 255);
                    ae(a, (a.gzhead.extra.length >> 8) & 255);
                  }
                  if (a.gzhead.hcrc) {
                    e.adler = s(e.adler, a.pending_buf, a.pending, 0);
                  }
                  a.gzindex = 0;
                  a.status = W;
                }
              } else {
                var m = (_ + ((a.w_bits - 8) << 4)) << 8;
                var g = -1;
                if (a.strategy >= k || a.level < 2) {
                  g = 0;
                } else if (a.level < 6) {
                  g = 1;
                } else if (a.level === 6) {
                  g = 2;
                } else {
                  g = 3;
                }
                m |= g << 6;
                if (a.strstart !== 0) {
                  m |= U;
                }
                m += 31 - (m % 31);
                a.status = G;
                ne(a, m);
                if (a.strstart !== 0) {
                  ne(a, e.adler >>> 16);
                  ne(a, e.adler & 65535);
                }
                e.adler = 1;
              }
            }
            if (a.status === W) {
              if (a.gzhead.extra) {
                i = a.pending;
                while (a.gzindex < (a.gzhead.extra.length & 65535)) {
                  if (a.pending === a.pending_buf_size) {
                    if (a.gzhead.hcrc && a.pending > i) {
                      e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                    }
                    re(e);
                    i = a.pending;
                    if (a.pending === a.pending_buf_size) {
                      break;
                    }
                  }
                  ae(a, a.gzhead.extra[a.gzindex] & 255);
                  a.gzindex++;
                }
                if (a.gzhead.hcrc && a.pending > i) {
                  e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                }
                if (a.gzindex === a.gzhead.extra.length) {
                  a.gzindex = 0;
                  a.status = V;
                }
              } else {
                a.status = V;
              }
            }
            if (a.status === V) {
              if (a.gzhead.name) {
                i = a.pending;
                do {
                  if (a.pending === a.pending_buf_size) {
                    if (a.gzhead.hcrc && a.pending > i) {
                      e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                    }
                    re(e);
                    i = a.pending;
                    if (a.pending === a.pending_buf_size) {
                      f = 1;
                      break;
                    }
                  }
                  if (a.gzindex < a.gzhead.name.length) {
                    f = a.gzhead.name.charCodeAt(a.gzindex++) & 255;
                  } else {
                    f = 0;
                  }
                  ae(a, f);
                } while (f !== 0);
                if (a.gzhead.hcrc && a.pending > i) {
                  e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                }
                if (f === 0) {
                  a.gzindex = 0;
                  a.status = z;
                }
              } else {
                a.status = z;
              }
            }
            if (a.status === z) {
              if (a.gzhead.comment) {
                i = a.pending;
                do {
                  if (a.pending === a.pending_buf_size) {
                    if (a.gzhead.hcrc && a.pending > i) {
                      e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                    }
                    re(e);
                    i = a.pending;
                    if (a.pending === a.pending_buf_size) {
                      f = 1;
                      break;
                    }
                  }
                  if (a.gzindex < a.gzhead.comment.length) {
                    f = a.gzhead.comment.charCodeAt(a.gzindex++) & 255;
                  } else {
                    f = 0;
                  }
                  ae(a, f);
                } while (f !== 0);
                if (a.gzhead.hcrc && a.pending > i) {
                  e.adler = s(e.adler, a.pending_buf, a.pending - i, i);
                }
                if (f === 0) {
                  a.status = X;
                }
              } else {
                a.status = X;
              }
            }
            if (a.status === X) {
              if (a.gzhead.hcrc) {
                if (a.pending + 2 > a.pending_buf_size) {
                  re(e);
                }
                if (a.pending + 2 <= a.pending_buf_size) {
                  ae(a, e.adler & 255);
                  ae(a, (e.adler >> 8) & 255);
                  e.adler = 0;
                  a.status = G;
                }
              } else {
                a.status = G;
              }
            }
            if (a.pending !== 0) {
              re(e);
              if (e.avail_out === 0) {
                a.last_flush = -1;
                return d;
              }
            } else if (e.avail_in === 0 && q(r) <= q(t) && r !== u) {
              return J(e, b);
            }
            if (a.status === j && e.avail_in !== 0) {
              return J(e, b);
            }
            if (
              e.avail_in !== 0 ||
              a.lookahead !== 0 ||
              (r !== o && a.status !== j)
            ) {
              var E =
                a.strategy === k
                  ? he(a, r)
                  : a.strategy === S
                  ? ue(a, r)
                  : ve[a.level].func(a, r);
              if (E === $ || E === Z) {
                a.status = j;
              }
              if (E === K || E === $) {
                if (e.avail_out === 0) {
                  a.last_flush = -1;
                }
                return d;
              }
              if (E === Y) {
                if (r === l) {
                  n._tr_align(a);
                } else if (r !== h) {
                  n._tr_stored_block(a, 0, 0, false);
                  if (r === c) {
                    ee(a.head);
                    if (a.lookahead === 0) {
                      a.strstart = 0;
                      a.block_start = 0;
                      a.insert = 0;
                    }
                  }
                }
                re(e);
                if (e.avail_out === 0) {
                  a.last_flush = -1;
                  return d;
                }
              }
            }
            if (r !== u) {
              return d;
            }
            if (a.wrap <= 0) {
              return v;
            }
            if (a.wrap === 2) {
              ae(a, e.adler & 255);
              ae(a, (e.adler >> 8) & 255);
              ae(a, (e.adler >> 16) & 255);
              ae(a, (e.adler >> 24) & 255);
              ae(a, e.total_in & 255);
              ae(a, (e.total_in >> 8) & 255);
              ae(a, (e.total_in >> 16) & 255);
              ae(a, (e.total_in >> 24) & 255);
            } else {
              ne(a, e.adler >>> 16);
              ne(a, e.adler & 65535);
            }
            re(e);
            if (a.wrap > 0) {
              a.wrap = -a.wrap;
            }
            return a.pending !== 0 ? d : v;
          }
          function Be(e) {
            var r;
            if (!e || !e.state) {
              return p;
            }
            r = e.state.status;
            if (
              r !== H &&
              r !== W &&
              r !== V &&
              r !== z &&
              r !== X &&
              r !== G &&
              r !== j
            ) {
              return J(e, p);
            }
            e.state = null;
            return r === G ? J(e, m) : d;
          }
          t.deflateInit = Se;
          t.deflateInit2 = ke;
          t.deflateReset = ge;
          t.deflateResetKeep = be;
          t.deflateSetHeader = Ee;
          t.deflate = we;
          t.deflateEnd = Be;
          t.deflateInfo = "pako deflate (from Nodeca project)";
        },
        {
          "../utils/common": 27,
          "./adler32": 29,
          "./crc32": 31,
          "./messages": 37,
          "./trees": 38,
        },
      ],
      33: [
        function (e, r, t) {
          "use strict";
          function a() {
            this.text = 0;
            this.time = 0;
            this.xflags = 0;
            this.os = 0;
            this.extra = null;
            this.extra_len = 0;
            this.name = "";
            this.comment = "";
            this.hcrc = 0;
            this.done = false;
          }
          r.exports = a;
        },
        {},
      ],
      34: [
        function (e, r, t) {
          "use strict";
          var a = 30;
          var n = 12;
          r.exports = function i(e, r) {
            var t;
            var i;
            var s;
            var f;
            var o;
            var l;
            var c;
            var u;
            var h;
            var d;
            var v;
            var p;
            var m;
            var b;
            var g;
            var E;
            var k;
            var S;
            var w;
            var B;
            var C;
            var _;
            var T;
            var x, I;
            t = e.state;
            i = e.next_in;
            x = e.input;
            s = i + (e.avail_in - 5);
            f = e.next_out;
            I = e.output;
            o = f - (r - e.avail_out);
            l = f + (e.avail_out - 257);
            c = t.dmax;
            u = t.wsize;
            h = t.whave;
            d = t.wnext;
            v = t.window;
            p = t.hold;
            m = t.bits;
            b = t.lencode;
            g = t.distcode;
            E = (1 << t.lenbits) - 1;
            k = (1 << t.distbits) - 1;
            e: do {
              if (m < 15) {
                p += x[i++] << m;
                m += 8;
                p += x[i++] << m;
                m += 8;
              }
              S = b[p & E];
              r: for (;;) {
                w = S >>> 24;
                p >>>= w;
                m -= w;
                w = (S >>> 16) & 255;
                if (w === 0) {
                  I[f++] = S & 65535;
                } else if (w & 16) {
                  B = S & 65535;
                  w &= 15;
                  if (w) {
                    if (m < w) {
                      p += x[i++] << m;
                      m += 8;
                    }
                    B += p & ((1 << w) - 1);
                    p >>>= w;
                    m -= w;
                  }
                  if (m < 15) {
                    p += x[i++] << m;
                    m += 8;
                    p += x[i++] << m;
                    m += 8;
                  }
                  S = g[p & k];
                  t: for (;;) {
                    w = S >>> 24;
                    p >>>= w;
                    m -= w;
                    w = (S >>> 16) & 255;
                    if (w & 16) {
                      C = S & 65535;
                      w &= 15;
                      if (m < w) {
                        p += x[i++] << m;
                        m += 8;
                        if (m < w) {
                          p += x[i++] << m;
                          m += 8;
                        }
                      }
                      C += p & ((1 << w) - 1);
                      if (C > c) {
                        e.msg = "invalid distance too far back";
                        t.mode = a;
                        break e;
                      }
                      p >>>= w;
                      m -= w;
                      w = f - o;
                      if (C > w) {
                        w = C - w;
                        if (w > h) {
                          if (t.sane) {
                            e.msg = "invalid distance too far back";
                            t.mode = a;
                            break e;
                          }
                        }
                        _ = 0;
                        T = v;
                        if (d === 0) {
                          _ += u - w;
                          if (w < B) {
                            B -= w;
                            do {
                              I[f++] = v[_++];
                            } while (--w);
                            _ = f - C;
                            T = I;
                          }
                        } else if (d < w) {
                          _ += u + d - w;
                          w -= d;
                          if (w < B) {
                            B -= w;
                            do {
                              I[f++] = v[_++];
                            } while (--w);
                            _ = 0;
                            if (d < B) {
                              w = d;
                              B -= w;
                              do {
                                I[f++] = v[_++];
                              } while (--w);
                              _ = f - C;
                              T = I;
                            }
                          }
                        } else {
                          _ += d - w;
                          if (w < B) {
                            B -= w;
                            do {
                              I[f++] = v[_++];
                            } while (--w);
                            _ = f - C;
                            T = I;
                          }
                        }
                        while (B > 2) {
                          I[f++] = T[_++];
                          I[f++] = T[_++];
                          I[f++] = T[_++];
                          B -= 3;
                        }
                        if (B) {
                          I[f++] = T[_++];
                          if (B > 1) {
                            I[f++] = T[_++];
                          }
                        }
                      } else {
                        _ = f - C;
                        do {
                          I[f++] = I[_++];
                          I[f++] = I[_++];
                          I[f++] = I[_++];
                          B -= 3;
                        } while (B > 2);
                        if (B) {
                          I[f++] = I[_++];
                          if (B > 1) {
                            I[f++] = I[_++];
                          }
                        }
                      }
                    } else if ((w & 64) === 0) {
                      S = g[(S & 65535) + (p & ((1 << w) - 1))];
                      continue t;
                    } else {
                      e.msg = "invalid distance code";
                      t.mode = a;
                      break e;
                    }
                    break;
                  }
                } else if ((w & 64) === 0) {
                  S = b[(S & 65535) + (p & ((1 << w) - 1))];
                  continue r;
                } else if (w & 32) {
                  t.mode = n;
                  break e;
                } else {
                  e.msg = "invalid literal/length code";
                  t.mode = a;
                  break e;
                }
                break;
              }
            } while (i < s && f < l);
            B = m >> 3;
            i -= B;
            m -= B << 3;
            p &= (1 << m) - 1;
            e.next_in = i;
            e.next_out = f;
            e.avail_in = i < s ? 5 + (s - i) : 5 - (i - s);
            e.avail_out = f < l ? 257 + (l - f) : 257 - (f - l);
            t.hold = p;
            t.bits = m;
            return;
          };
        },
        {},
      ],
      35: [
        function (e, r, t) {
          "use strict";
          var a = e("../utils/common");
          var n = e("./adler32");
          var i = e("./crc32");
          var s = e("./inffast");
          var f = e("./inftrees");
          var o = 0;
          var l = 1;
          var c = 2;
          var u = 4;
          var h = 5;
          var d = 6;
          var v = 0;
          var p = 1;
          var m = 2;
          var b = -2;
          var g = -3;
          var E = -4;
          var k = -5;
          var S = 8;
          var w = 1;
          var B = 2;
          var C = 3;
          var _ = 4;
          var T = 5;
          var x = 6;
          var I = 7;
          var A = 8;
          var y = 9;
          var R = 10;
          var D = 11;
          var O = 12;
          var F = 13;
          var P = 14;
          var N = 15;
          var L = 16;
          var M = 17;
          var U = 18;
          var H = 19;
          var W = 20;
          var V = 21;
          var z = 22;
          var X = 23;
          var G = 24;
          var j = 25;
          var K = 26;
          var Y = 27;
          var $ = 28;
          var Z = 29;
          var Q = 30;
          var J = 31;
          var q = 32;
          var ee = 852;
          var re = 592;
          var te = 15;
          var ae = te;
          function ne(e) {
            return (
              ((e >>> 24) & 255) +
              ((e >>> 8) & 65280) +
              ((e & 65280) << 8) +
              ((e & 255) << 24)
            );
          }
          function ie() {
            this.mode = 0;
            this.last = false;
            this.wrap = 0;
            this.havedict = false;
            this.flags = 0;
            this.dmax = 0;
            this.check = 0;
            this.total = 0;
            this.head = null;
            this.wbits = 0;
            this.wsize = 0;
            this.whave = 0;
            this.wnext = 0;
            this.window = null;
            this.hold = 0;
            this.bits = 0;
            this.length = 0;
            this.offset = 0;
            this.extra = 0;
            this.lencode = null;
            this.distcode = null;
            this.lenbits = 0;
            this.distbits = 0;
            this.ncode = 0;
            this.nlen = 0;
            this.ndist = 0;
            this.have = 0;
            this.next = null;
            this.lens = new a.Buf16(320);
            this.work = new a.Buf16(288);
            this.lendyn = null;
            this.distdyn = null;
            this.sane = 0;
            this.back = 0;
            this.was = 0;
          }
          function se(e) {
            var r;
            if (!e || !e.state) {
              return b;
            }
            r = e.state;
            e.total_in = e.total_out = r.total = 0;
            e.msg = "";
            if (r.wrap) {
              e.adler = r.wrap & 1;
            }
            r.mode = w;
            r.last = 0;
            r.havedict = 0;
            r.dmax = 32768;
            r.head = null;
            r.hold = 0;
            r.bits = 0;
            r.lencode = r.lendyn = new a.Buf32(ee);
            r.distcode = r.distdyn = new a.Buf32(re);
            r.sane = 1;
            r.back = -1;
            return v;
          }
          function fe(e) {
            var r;
            if (!e || !e.state) {
              return b;
            }
            r = e.state;
            r.wsize = 0;
            r.whave = 0;
            r.wnext = 0;
            return se(e);
          }
          function oe(e, r) {
            var t;
            var a;
            if (!e || !e.state) {
              return b;
            }
            a = e.state;
            if (r < 0) {
              t = 0;
              r = -r;
            } else {
              t = (r >> 4) + 1;
              if (r < 48) {
                r &= 15;
              }
            }
            if (r && (r < 8 || r > 15)) {
              return b;
            }
            if (a.window !== null && a.wbits !== r) {
              a.window = null;
            }
            a.wrap = t;
            a.wbits = r;
            return fe(e);
          }
          function le(e, r) {
            var t;
            var a;
            if (!e) {
              return b;
            }
            a = new ie();
            e.state = a;
            a.window = null;
            t = oe(e, r);
            if (t !== v) {
              e.state = null;
            }
            return t;
          }
          function ce(e) {
            return le(e, ae);
          }
          var ue = true;
          var he, de;
          function ve(e) {
            if (ue) {
              var r;
              he = new a.Buf32(512);
              de = new a.Buf32(32);
              r = 0;
              while (r < 144) {
                e.lens[r++] = 8;
              }
              while (r < 256) {
                e.lens[r++] = 9;
              }
              while (r < 280) {
                e.lens[r++] = 7;
              }
              while (r < 288) {
                e.lens[r++] = 8;
              }
              f(l, e.lens, 0, 288, he, 0, e.work, { bits: 9 });
              r = 0;
              while (r < 32) {
                e.lens[r++] = 5;
              }
              f(c, e.lens, 0, 32, de, 0, e.work, { bits: 5 });
              ue = false;
            }
            e.lencode = he;
            e.lenbits = 9;
            e.distcode = de;
            e.distbits = 5;
          }
          function pe(e, r, t, n) {
            var i;
            var s = e.state;
            if (s.window === null) {
              s.wsize = 1 << s.wbits;
              s.wnext = 0;
              s.whave = 0;
              s.window = new a.Buf8(s.wsize);
            }
            if (n >= s.wsize) {
              a.arraySet(s.window, r, t - s.wsize, s.wsize, 0);
              s.wnext = 0;
              s.whave = s.wsize;
            } else {
              i = s.wsize - s.wnext;
              if (i > n) {
                i = n;
              }
              a.arraySet(s.window, r, t - n, i, s.wnext);
              n -= i;
              if (n) {
                a.arraySet(s.window, r, t - n, n, 0);
                s.wnext = n;
                s.whave = s.wsize;
              } else {
                s.wnext += i;
                if (s.wnext === s.wsize) {
                  s.wnext = 0;
                }
                if (s.whave < s.wsize) {
                  s.whave += i;
                }
              }
            }
            return 0;
          }
          function me(e, r) {
            var t;
            var ee, re;
            var te;
            var ae;
            var ie, se;
            var fe;
            var oe;
            var le, ce;
            var ue;
            var he;
            var de;
            var me = 0;
            var be, ge, Ee;
            var ke, Se, we;
            var Be;
            var Ce;
            var _e = new a.Buf8(4);
            var Te;
            var xe;
            var Ie = [
              16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15,
            ];
            if (!e || !e.state || !e.output || (!e.input && e.avail_in !== 0)) {
              return b;
            }
            t = e.state;
            if (t.mode === O) {
              t.mode = F;
            }
            ae = e.next_out;
            re = e.output;
            se = e.avail_out;
            te = e.next_in;
            ee = e.input;
            ie = e.avail_in;
            fe = t.hold;
            oe = t.bits;
            le = ie;
            ce = se;
            Ce = v;
            e: for (;;) {
              switch (t.mode) {
                case w:
                  if (t.wrap === 0) {
                    t.mode = F;
                    break;
                  }
                  while (oe < 16) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if (t.wrap & 2 && fe === 35615) {
                    t.check = 0;
                    _e[0] = fe & 255;
                    _e[1] = (fe >>> 8) & 255;
                    t.check = i(t.check, _e, 2, 0);
                    fe = 0;
                    oe = 0;
                    t.mode = B;
                    break;
                  }
                  t.flags = 0;
                  if (t.head) {
                    t.head.done = false;
                  }
                  if (!(t.wrap & 1) || (((fe & 255) << 8) + (fe >> 8)) % 31) {
                    e.msg = "incorrect header check";
                    t.mode = Q;
                    break;
                  }
                  if ((fe & 15) !== S) {
                    e.msg = "unknown compression method";
                    t.mode = Q;
                    break;
                  }
                  fe >>>= 4;
                  oe -= 4;
                  Be = (fe & 15) + 8;
                  if (t.wbits === 0) {
                    t.wbits = Be;
                  } else if (Be > t.wbits) {
                    e.msg = "invalid window size";
                    t.mode = Q;
                    break;
                  }
                  t.dmax = 1 << Be;
                  e.adler = t.check = 1;
                  t.mode = fe & 512 ? R : O;
                  fe = 0;
                  oe = 0;
                  break;
                case B:
                  while (oe < 16) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  t.flags = fe;
                  if ((t.flags & 255) !== S) {
                    e.msg = "unknown compression method";
                    t.mode = Q;
                    break;
                  }
                  if (t.flags & 57344) {
                    e.msg = "unknown header flags set";
                    t.mode = Q;
                    break;
                  }
                  if (t.head) {
                    t.head.text = (fe >> 8) & 1;
                  }
                  if (t.flags & 512) {
                    _e[0] = fe & 255;
                    _e[1] = (fe >>> 8) & 255;
                    t.check = i(t.check, _e, 2, 0);
                  }
                  fe = 0;
                  oe = 0;
                  t.mode = C;
                case C:
                  while (oe < 32) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if (t.head) {
                    t.head.time = fe;
                  }
                  if (t.flags & 512) {
                    _e[0] = fe & 255;
                    _e[1] = (fe >>> 8) & 255;
                    _e[2] = (fe >>> 16) & 255;
                    _e[3] = (fe >>> 24) & 255;
                    t.check = i(t.check, _e, 4, 0);
                  }
                  fe = 0;
                  oe = 0;
                  t.mode = _;
                case _:
                  while (oe < 16) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if (t.head) {
                    t.head.xflags = fe & 255;
                    t.head.os = fe >> 8;
                  }
                  if (t.flags & 512) {
                    _e[0] = fe & 255;
                    _e[1] = (fe >>> 8) & 255;
                    t.check = i(t.check, _e, 2, 0);
                  }
                  fe = 0;
                  oe = 0;
                  t.mode = T;
                case T:
                  if (t.flags & 1024) {
                    while (oe < 16) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    t.length = fe;
                    if (t.head) {
                      t.head.extra_len = fe;
                    }
                    if (t.flags & 512) {
                      _e[0] = fe & 255;
                      _e[1] = (fe >>> 8) & 255;
                      t.check = i(t.check, _e, 2, 0);
                    }
                    fe = 0;
                    oe = 0;
                  } else if (t.head) {
                    t.head.extra = null;
                  }
                  t.mode = x;
                case x:
                  if (t.flags & 1024) {
                    ue = t.length;
                    if (ue > ie) {
                      ue = ie;
                    }
                    if (ue) {
                      if (t.head) {
                        Be = t.head.extra_len - t.length;
                        if (!t.head.extra) {
                          t.head.extra = new Array(t.head.extra_len);
                        }
                        a.arraySet(t.head.extra, ee, te, ue, Be);
                      }
                      if (t.flags & 512) {
                        t.check = i(t.check, ee, ue, te);
                      }
                      ie -= ue;
                      te += ue;
                      t.length -= ue;
                    }
                    if (t.length) {
                      break e;
                    }
                  }
                  t.length = 0;
                  t.mode = I;
                case I:
                  if (t.flags & 2048) {
                    if (ie === 0) {
                      break e;
                    }
                    ue = 0;
                    do {
                      Be = ee[te + ue++];
                      if (t.head && Be && t.length < 65536) {
                        t.head.name += String.fromCharCode(Be);
                      }
                    } while (Be && ue < ie);
                    if (t.flags & 512) {
                      t.check = i(t.check, ee, ue, te);
                    }
                    ie -= ue;
                    te += ue;
                    if (Be) {
                      break e;
                    }
                  } else if (t.head) {
                    t.head.name = null;
                  }
                  t.length = 0;
                  t.mode = A;
                case A:
                  if (t.flags & 4096) {
                    if (ie === 0) {
                      break e;
                    }
                    ue = 0;
                    do {
                      Be = ee[te + ue++];
                      if (t.head && Be && t.length < 65536) {
                        t.head.comment += String.fromCharCode(Be);
                      }
                    } while (Be && ue < ie);
                    if (t.flags & 512) {
                      t.check = i(t.check, ee, ue, te);
                    }
                    ie -= ue;
                    te += ue;
                    if (Be) {
                      break e;
                    }
                  } else if (t.head) {
                    t.head.comment = null;
                  }
                  t.mode = y;
                case y:
                  if (t.flags & 512) {
                    while (oe < 16) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    if (fe !== (t.check & 65535)) {
                      e.msg = "header crc mismatch";
                      t.mode = Q;
                      break;
                    }
                    fe = 0;
                    oe = 0;
                  }
                  if (t.head) {
                    t.head.hcrc = (t.flags >> 9) & 1;
                    t.head.done = true;
                  }
                  e.adler = t.check = 0;
                  t.mode = O;
                  break;
                case R:
                  while (oe < 32) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  e.adler = t.check = ne(fe);
                  fe = 0;
                  oe = 0;
                  t.mode = D;
                case D:
                  if (t.havedict === 0) {
                    e.next_out = ae;
                    e.avail_out = se;
                    e.next_in = te;
                    e.avail_in = ie;
                    t.hold = fe;
                    t.bits = oe;
                    return m;
                  }
                  e.adler = t.check = 1;
                  t.mode = O;
                case O:
                  if (r === h || r === d) {
                    break e;
                  }
                case F:
                  if (t.last) {
                    fe >>>= oe & 7;
                    oe -= oe & 7;
                    t.mode = Y;
                    break;
                  }
                  while (oe < 3) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  t.last = fe & 1;
                  fe >>>= 1;
                  oe -= 1;
                  switch (fe & 3) {
                    case 0:
                      t.mode = P;
                      break;
                    case 1:
                      ve(t);
                      t.mode = W;
                      if (r === d) {
                        fe >>>= 2;
                        oe -= 2;
                        break e;
                      }
                      break;
                    case 2:
                      t.mode = M;
                      break;
                    case 3:
                      e.msg = "invalid block type";
                      t.mode = Q;
                  }
                  fe >>>= 2;
                  oe -= 2;
                  break;
                case P:
                  fe >>>= oe & 7;
                  oe -= oe & 7;
                  while (oe < 32) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if ((fe & 65535) !== ((fe >>> 16) ^ 65535)) {
                    e.msg = "invalid stored block lengths";
                    t.mode = Q;
                    break;
                  }
                  t.length = fe & 65535;
                  fe = 0;
                  oe = 0;
                  t.mode = N;
                  if (r === d) {
                    break e;
                  }
                case N:
                  t.mode = L;
                case L:
                  ue = t.length;
                  if (ue) {
                    if (ue > ie) {
                      ue = ie;
                    }
                    if (ue > se) {
                      ue = se;
                    }
                    if (ue === 0) {
                      break e;
                    }
                    a.arraySet(re, ee, te, ue, ae);
                    ie -= ue;
                    te += ue;
                    se -= ue;
                    ae += ue;
                    t.length -= ue;
                    break;
                  }
                  t.mode = O;
                  break;
                case M:
                  while (oe < 14) {
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  t.nlen = (fe & 31) + 257;
                  fe >>>= 5;
                  oe -= 5;
                  t.ndist = (fe & 31) + 1;
                  fe >>>= 5;
                  oe -= 5;
                  t.ncode = (fe & 15) + 4;
                  fe >>>= 4;
                  oe -= 4;
                  if (t.nlen > 286 || t.ndist > 30) {
                    e.msg = "too many length or distance symbols";
                    t.mode = Q;
                    break;
                  }
                  t.have = 0;
                  t.mode = U;
                case U:
                  while (t.have < t.ncode) {
                    while (oe < 3) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    t.lens[Ie[t.have++]] = fe & 7;
                    fe >>>= 3;
                    oe -= 3;
                  }
                  while (t.have < 19) {
                    t.lens[Ie[t.have++]] = 0;
                  }
                  t.lencode = t.lendyn;
                  t.lenbits = 7;
                  Te = { bits: t.lenbits };
                  Ce = f(o, t.lens, 0, 19, t.lencode, 0, t.work, Te);
                  t.lenbits = Te.bits;
                  if (Ce) {
                    e.msg = "invalid code lengths set";
                    t.mode = Q;
                    break;
                  }
                  t.have = 0;
                  t.mode = H;
                case H:
                  while (t.have < t.nlen + t.ndist) {
                    for (;;) {
                      me = t.lencode[fe & ((1 << t.lenbits) - 1)];
                      be = me >>> 24;
                      ge = (me >>> 16) & 255;
                      Ee = me & 65535;
                      if (be <= oe) {
                        break;
                      }
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    if (Ee < 16) {
                      fe >>>= be;
                      oe -= be;
                      t.lens[t.have++] = Ee;
                    } else {
                      if (Ee === 16) {
                        xe = be + 2;
                        while (oe < xe) {
                          if (ie === 0) {
                            break e;
                          }
                          ie--;
                          fe += ee[te++] << oe;
                          oe += 8;
                        }
                        fe >>>= be;
                        oe -= be;
                        if (t.have === 0) {
                          e.msg = "invalid bit length repeat";
                          t.mode = Q;
                          break;
                        }
                        Be = t.lens[t.have - 1];
                        ue = 3 + (fe & 3);
                        fe >>>= 2;
                        oe -= 2;
                      } else if (Ee === 17) {
                        xe = be + 3;
                        while (oe < xe) {
                          if (ie === 0) {
                            break e;
                          }
                          ie--;
                          fe += ee[te++] << oe;
                          oe += 8;
                        }
                        fe >>>= be;
                        oe -= be;
                        Be = 0;
                        ue = 3 + (fe & 7);
                        fe >>>= 3;
                        oe -= 3;
                      } else {
                        xe = be + 7;
                        while (oe < xe) {
                          if (ie === 0) {
                            break e;
                          }
                          ie--;
                          fe += ee[te++] << oe;
                          oe += 8;
                        }
                        fe >>>= be;
                        oe -= be;
                        Be = 0;
                        ue = 11 + (fe & 127);
                        fe >>>= 7;
                        oe -= 7;
                      }
                      if (t.have + ue > t.nlen + t.ndist) {
                        e.msg = "invalid bit length repeat";
                        t.mode = Q;
                        break;
                      }
                      while (ue--) {
                        t.lens[t.have++] = Be;
                      }
                    }
                  }
                  if (t.mode === Q) {
                    break;
                  }
                  if (t.lens[256] === 0) {
                    e.msg = "invalid code -- missing end-of-block";
                    t.mode = Q;
                    break;
                  }
                  t.lenbits = 9;
                  Te = { bits: t.lenbits };
                  Ce = f(l, t.lens, 0, t.nlen, t.lencode, 0, t.work, Te);
                  t.lenbits = Te.bits;
                  if (Ce) {
                    e.msg = "invalid literal/lengths set";
                    t.mode = Q;
                    break;
                  }
                  t.distbits = 6;
                  t.distcode = t.distdyn;
                  Te = { bits: t.distbits };
                  Ce = f(c, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, Te);
                  t.distbits = Te.bits;
                  if (Ce) {
                    e.msg = "invalid distances set";
                    t.mode = Q;
                    break;
                  }
                  t.mode = W;
                  if (r === d) {
                    break e;
                  }
                case W:
                  t.mode = V;
                case V:
                  if (ie >= 6 && se >= 258) {
                    e.next_out = ae;
                    e.avail_out = se;
                    e.next_in = te;
                    e.avail_in = ie;
                    t.hold = fe;
                    t.bits = oe;
                    s(e, ce);
                    ae = e.next_out;
                    re = e.output;
                    se = e.avail_out;
                    te = e.next_in;
                    ee = e.input;
                    ie = e.avail_in;
                    fe = t.hold;
                    oe = t.bits;
                    if (t.mode === O) {
                      t.back = -1;
                    }
                    break;
                  }
                  t.back = 0;
                  for (;;) {
                    me = t.lencode[fe & ((1 << t.lenbits) - 1)];
                    be = me >>> 24;
                    ge = (me >>> 16) & 255;
                    Ee = me & 65535;
                    if (be <= oe) {
                      break;
                    }
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if (ge && (ge & 240) === 0) {
                    ke = be;
                    Se = ge;
                    we = Ee;
                    for (;;) {
                      me =
                        t.lencode[we + ((fe & ((1 << (ke + Se)) - 1)) >> ke)];
                      be = me >>> 24;
                      ge = (me >>> 16) & 255;
                      Ee = me & 65535;
                      if (ke + be <= oe) {
                        break;
                      }
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    fe >>>= ke;
                    oe -= ke;
                    t.back += ke;
                  }
                  fe >>>= be;
                  oe -= be;
                  t.back += be;
                  t.length = Ee;
                  if (ge === 0) {
                    t.mode = K;
                    break;
                  }
                  if (ge & 32) {
                    t.back = -1;
                    t.mode = O;
                    break;
                  }
                  if (ge & 64) {
                    e.msg = "invalid literal/length code";
                    t.mode = Q;
                    break;
                  }
                  t.extra = ge & 15;
                  t.mode = z;
                case z:
                  if (t.extra) {
                    xe = t.extra;
                    while (oe < xe) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    t.length += fe & ((1 << t.extra) - 1);
                    fe >>>= t.extra;
                    oe -= t.extra;
                    t.back += t.extra;
                  }
                  t.was = t.length;
                  t.mode = X;
                case X:
                  for (;;) {
                    me = t.distcode[fe & ((1 << t.distbits) - 1)];
                    be = me >>> 24;
                    ge = (me >>> 16) & 255;
                    Ee = me & 65535;
                    if (be <= oe) {
                      break;
                    }
                    if (ie === 0) {
                      break e;
                    }
                    ie--;
                    fe += ee[te++] << oe;
                    oe += 8;
                  }
                  if ((ge & 240) === 0) {
                    ke = be;
                    Se = ge;
                    we = Ee;
                    for (;;) {
                      me =
                        t.distcode[we + ((fe & ((1 << (ke + Se)) - 1)) >> ke)];
                      be = me >>> 24;
                      ge = (me >>> 16) & 255;
                      Ee = me & 65535;
                      if (ke + be <= oe) {
                        break;
                      }
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    fe >>>= ke;
                    oe -= ke;
                    t.back += ke;
                  }
                  fe >>>= be;
                  oe -= be;
                  t.back += be;
                  if (ge & 64) {
                    e.msg = "invalid distance code";
                    t.mode = Q;
                    break;
                  }
                  t.offset = Ee;
                  t.extra = ge & 15;
                  t.mode = G;
                case G:
                  if (t.extra) {
                    xe = t.extra;
                    while (oe < xe) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    t.offset += fe & ((1 << t.extra) - 1);
                    fe >>>= t.extra;
                    oe -= t.extra;
                    t.back += t.extra;
                  }
                  if (t.offset > t.dmax) {
                    e.msg = "invalid distance too far back";
                    t.mode = Q;
                    break;
                  }
                  t.mode = j;
                case j:
                  if (se === 0) {
                    break e;
                  }
                  ue = ce - se;
                  if (t.offset > ue) {
                    ue = t.offset - ue;
                    if (ue > t.whave) {
                      if (t.sane) {
                        e.msg = "invalid distance too far back";
                        t.mode = Q;
                        break;
                      }
                    }
                    if (ue > t.wnext) {
                      ue -= t.wnext;
                      he = t.wsize - ue;
                    } else {
                      he = t.wnext - ue;
                    }
                    if (ue > t.length) {
                      ue = t.length;
                    }
                    de = t.window;
                  } else {
                    de = re;
                    he = ae - t.offset;
                    ue = t.length;
                  }
                  if (ue > se) {
                    ue = se;
                  }
                  se -= ue;
                  t.length -= ue;
                  do {
                    re[ae++] = de[he++];
                  } while (--ue);
                  if (t.length === 0) {
                    t.mode = V;
                  }
                  break;
                case K:
                  if (se === 0) {
                    break e;
                  }
                  re[ae++] = t.length;
                  se--;
                  t.mode = V;
                  break;
                case Y:
                  if (t.wrap) {
                    while (oe < 32) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe |= ee[te++] << oe;
                      oe += 8;
                    }
                    ce -= se;
                    e.total_out += ce;
                    t.total += ce;
                    if (ce) {
                      e.adler = t.check = t.flags
                        ? i(t.check, re, ce, ae - ce)
                        : n(t.check, re, ce, ae - ce);
                    }
                    ce = se;
                    if ((t.flags ? fe : ne(fe)) !== t.check) {
                      e.msg = "incorrect data check";
                      t.mode = Q;
                      break;
                    }
                    fe = 0;
                    oe = 0;
                  }
                  t.mode = $;
                case $:
                  if (t.wrap && t.flags) {
                    while (oe < 32) {
                      if (ie === 0) {
                        break e;
                      }
                      ie--;
                      fe += ee[te++] << oe;
                      oe += 8;
                    }
                    if (fe !== (t.total & 4294967295)) {
                      e.msg = "incorrect length check";
                      t.mode = Q;
                      break;
                    }
                    fe = 0;
                    oe = 0;
                  }
                  t.mode = Z;
                case Z:
                  Ce = p;
                  break e;
                case Q:
                  Ce = g;
                  break e;
                case J:
                  return E;
                case q:
                default:
                  return b;
              }
            }
            e.next_out = ae;
            e.avail_out = se;
            e.next_in = te;
            e.avail_in = ie;
            t.hold = fe;
            t.bits = oe;
            if (
              t.wsize ||
              (ce !== e.avail_out && t.mode < Q && (t.mode < Y || r !== u))
            ) {
              if (pe(e, e.output, e.next_out, ce - e.avail_out)) {
                t.mode = J;
                return E;
              }
            }
            le -= e.avail_in;
            ce -= e.avail_out;
            e.total_in += le;
            e.total_out += ce;
            t.total += ce;
            if (t.wrap && ce) {
              e.adler = t.check = t.flags
                ? i(t.check, re, ce, e.next_out - ce)
                : n(t.check, re, ce, e.next_out - ce);
            }
            e.data_type =
              t.bits +
              (t.last ? 64 : 0) +
              (t.mode === O ? 128 : 0) +
              (t.mode === W || t.mode === N ? 256 : 0);
            if (((le === 0 && ce === 0) || r === u) && Ce === v) {
              Ce = k;
            }
            return Ce;
          }
          function be(e) {
            if (!e || !e.state) {
              return b;
            }
            var r = e.state;
            if (r.window) {
              r.window = null;
            }
            e.state = null;
            return v;
          }
          function ge(e, r) {
            var t;
            if (!e || !e.state) {
              return b;
            }
            t = e.state;
            if ((t.wrap & 2) === 0) {
              return b;
            }
            t.head = r;
            r.done = false;
            return v;
          }
          t.inflateReset = fe;
          t.inflateReset2 = oe;
          t.inflateResetKeep = se;
          t.inflateInit = ce;
          t.inflateInit2 = le;
          t.inflate = me;
          t.inflateEnd = be;
          t.inflateGetHeader = ge;
          t.inflateInfo = "pako inflate (from Nodeca project)";
        },
        {
          "../utils/common": 27,
          "./adler32": 29,
          "./crc32": 31,
          "./inffast": 34,
          "./inftrees": 36,
        },
      ],
      36: [
        function (e, r, t) {
          "use strict";
          var a = e("../utils/common");
          var n = 15;
          var i = 852;
          var s = 592;
          var f = 0;
          var o = 1;
          var l = 2;
          var c = [
            3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51,
            59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0,
          ];
          var u = [
            16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19,
            19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78,
          ];
          var h = [
            1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385,
            513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385,
            24577, 0, 0,
          ];
          var d = [
            16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23,
            23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64,
          ];
          r.exports = function v(e, r, t, p, m, b, g, E) {
            var k = E.bits;
            var S = 0;
            var w = 0;
            var B = 0,
              C = 0;
            var _ = 0;
            var T = 0;
            var x = 0;
            var I = 0;
            var A = 0;
            var y = 0;
            var R;
            var D;
            var O;
            var F;
            var P;
            var N = null;
            var L = 0;
            var M;
            var U = new a.Buf16(n + 1);
            var H = new a.Buf16(n + 1);
            var W = null;
            var V = 0;
            var z, X, G;
            for (S = 0; S <= n; S++) {
              U[S] = 0;
            }
            for (w = 0; w < p; w++) {
              U[r[t + w]]++;
            }
            _ = k;
            for (C = n; C >= 1; C--) {
              if (U[C] !== 0) {
                break;
              }
            }
            if (_ > C) {
              _ = C;
            }
            if (C === 0) {
              m[b++] = (1 << 24) | (64 << 16) | 0;
              m[b++] = (1 << 24) | (64 << 16) | 0;
              E.bits = 1;
              return 0;
            }
            for (B = 1; B < C; B++) {
              if (U[B] !== 0) {
                break;
              }
            }
            if (_ < B) {
              _ = B;
            }
            I = 1;
            for (S = 1; S <= n; S++) {
              I <<= 1;
              I -= U[S];
              if (I < 0) {
                return -1;
              }
            }
            if (I > 0 && (e === f || C !== 1)) {
              return -1;
            }
            H[1] = 0;
            for (S = 1; S < n; S++) {
              H[S + 1] = H[S] + U[S];
            }
            for (w = 0; w < p; w++) {
              if (r[t + w] !== 0) {
                g[H[r[t + w]]++] = w;
              }
            }
            if (e === f) {
              N = W = g;
              M = 19;
            } else if (e === o) {
              N = c;
              L -= 257;
              W = u;
              V -= 257;
              M = 256;
            } else {
              N = h;
              W = d;
              M = -1;
            }
            y = 0;
            w = 0;
            S = B;
            P = b;
            T = _;
            x = 0;
            O = -1;
            A = 1 << _;
            F = A - 1;
            if ((e === o && A > i) || (e === l && A > s)) {
              return 1;
            }
            var j = 0;
            for (;;) {
              j++;
              z = S - x;
              if (g[w] < M) {
                X = 0;
                G = g[w];
              } else if (g[w] > M) {
                X = W[V + g[w]];
                G = N[L + g[w]];
              } else {
                X = 32 + 64;
                G = 0;
              }
              R = 1 << (S - x);
              D = 1 << T;
              B = D;
              do {
                D -= R;
                m[P + (y >> x) + D] = (z << 24) | (X << 16) | G | 0;
              } while (D !== 0);
              R = 1 << (S - 1);
              while (y & R) {
                R >>= 1;
              }
              if (R !== 0) {
                y &= R - 1;
                y += R;
              } else {
                y = 0;
              }
              w++;
              if (--U[S] === 0) {
                if (S === C) {
                  break;
                }
                S = r[t + g[w]];
              }
              if (S > _ && (y & F) !== O) {
                if (x === 0) {
                  x = _;
                }
                P += B;
                T = S - x;
                I = 1 << T;
                while (T + x < C) {
                  I -= U[T + x];
                  if (I <= 0) {
                    break;
                  }
                  T++;
                  I <<= 1;
                }
                A += 1 << T;
                if ((e === o && A > i) || (e === l && A > s)) {
                  return 1;
                }
                O = y & F;
                m[O] = (_ << 24) | (T << 16) | (P - b) | 0;
              }
            }
            if (y !== 0) {
              m[P + y] = ((S - x) << 24) | (64 << 16) | 0;
            }
            E.bits = _;
            return 0;
          };
        },
        { "../utils/common": 27 },
      ],
      37: [
        function (e, r, t) {
          "use strict";
          r.exports = {
            2: "need dictionary",
            1: "stream end",
            0: "",
            "-1": "file error",
            "-2": "stream error",
            "-3": "data error",
            "-4": "insufficient memory",
            "-5": "buffer error",
            "-6": "incompatible version",
          };
        },
        {},
      ],
      38: [
        function (e, r, t) {
          "use strict";
          var a = e("../utils/common");
          var n = 4;
          var i = 0;
          var s = 1;
          var f = 2;
          function o(e) {
            var r = e.length;
            while (--r >= 0) {
              e[r] = 0;
            }
          }
          var l = 0;
          var c = 1;
          var u = 2;
          var h = 3;
          var d = 258;
          var v = 29;
          var p = 256;
          var m = p + 1 + v;
          var b = 30;
          var g = 19;
          var E = 2 * m + 1;
          var k = 15;
          var S = 16;
          var w = 7;
          var B = 256;
          var C = 16;
          var _ = 17;
          var T = 18;
          var x = [
            0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4,
            4, 5, 5, 5, 5, 0,
          ];
          var I = [
            0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9,
            10, 10, 11, 11, 12, 12, 13, 13,
          ];
          var A = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7];
          var y = [
            16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15,
          ];
          var R = 512;
          var D = new Array((m + 2) * 2);
          o(D);
          var O = new Array(b * 2);
          o(O);
          var F = new Array(R);
          o(F);
          var P = new Array(d - h + 1);
          o(P);
          var N = new Array(v);
          o(N);
          var L = new Array(b);
          o(L);
          var M = function (e, r, t, a, n) {
            this.static_tree = e;
            this.extra_bits = r;
            this.extra_base = t;
            this.elems = a;
            this.max_length = n;
            this.has_stree = e && e.length;
          };
          var U;
          var H;
          var W;
          var V = function (e, r) {
            this.dyn_tree = e;
            this.max_code = 0;
            this.stat_desc = r;
          };
          function z(e) {
            return e < 256 ? F[e] : F[256 + (e >>> 7)];
          }
          function X(e, r) {
            e.pending_buf[e.pending++] = r & 255;
            e.pending_buf[e.pending++] = (r >>> 8) & 255;
          }
          function G(e, r, t) {
            if (e.bi_valid > S - t) {
              e.bi_buf |= (r << e.bi_valid) & 65535;
              X(e, e.bi_buf);
              e.bi_buf = r >> (S - e.bi_valid);
              e.bi_valid += t - S;
            } else {
              e.bi_buf |= (r << e.bi_valid) & 65535;
              e.bi_valid += t;
            }
          }
          function j(e, r, t) {
            G(e, t[r * 2], t[r * 2 + 1]);
          }
          function K(e, r) {
            var t = 0;
            do {
              t |= e & 1;
              e >>>= 1;
              t <<= 1;
            } while (--r > 0);
            return t >>> 1;
          }
          function Y(e) {
            if (e.bi_valid === 16) {
              X(e, e.bi_buf);
              e.bi_buf = 0;
              e.bi_valid = 0;
            } else if (e.bi_valid >= 8) {
              e.pending_buf[e.pending++] = e.bi_buf & 255;
              e.bi_buf >>= 8;
              e.bi_valid -= 8;
            }
          }
          function $(e, r) {
            var t = r.dyn_tree;
            var a = r.max_code;
            var n = r.stat_desc.static_tree;
            var i = r.stat_desc.has_stree;
            var s = r.stat_desc.extra_bits;
            var f = r.stat_desc.extra_base;
            var o = r.stat_desc.max_length;
            var l;
            var c, u;
            var h;
            var d;
            var v;
            var p = 0;
            for (h = 0; h <= k; h++) {
              e.bl_count[h] = 0;
            }
            t[e.heap[e.heap_max] * 2 + 1] = 0;
            for (l = e.heap_max + 1; l < E; l++) {
              c = e.heap[l];
              h = t[t[c * 2 + 1] * 2 + 1] + 1;
              if (h > o) {
                h = o;
                p++;
              }
              t[c * 2 + 1] = h;
              if (c > a) {
                continue;
              }
              e.bl_count[h]++;
              d = 0;
              if (c >= f) {
                d = s[c - f];
              }
              v = t[c * 2];
              e.opt_len += v * (h + d);
              if (i) {
                e.static_len += v * (n[c * 2 + 1] + d);
              }
            }
            if (p === 0) {
              return;
            }
            do {
              h = o - 1;
              while (e.bl_count[h] === 0) {
                h--;
              }
              e.bl_count[h]--;
              e.bl_count[h + 1] += 2;
              e.bl_count[o]--;
              p -= 2;
            } while (p > 0);
            for (h = o; h !== 0; h--) {
              c = e.bl_count[h];
              while (c !== 0) {
                u = e.heap[--l];
                if (u > a) {
                  continue;
                }
                if (t[u * 2 + 1] !== h) {
                  e.opt_len += (h - t[u * 2 + 1]) * t[u * 2];
                  t[u * 2 + 1] = h;
                }
                c--;
              }
            }
          }
          function Z(e, r, t) {
            var a = new Array(k + 1);
            var n = 0;
            var i;
            var s;
            for (i = 1; i <= k; i++) {
              a[i] = n = (n + t[i - 1]) << 1;
            }
            for (s = 0; s <= r; s++) {
              var f = e[s * 2 + 1];
              if (f === 0) {
                continue;
              }
              e[s * 2] = K(a[f]++, f);
            }
          }
          function Q() {
            var e;
            var r;
            var t;
            var a;
            var n;
            var i = new Array(k + 1);
            t = 0;
            for (a = 0; a < v - 1; a++) {
              N[a] = t;
              for (e = 0; e < 1 << x[a]; e++) {
                P[t++] = a;
              }
            }
            P[t - 1] = a;
            n = 0;
            for (a = 0; a < 16; a++) {
              L[a] = n;
              for (e = 0; e < 1 << I[a]; e++) {
                F[n++] = a;
              }
            }
            n >>= 7;
            for (; a < b; a++) {
              L[a] = n << 7;
              for (e = 0; e < 1 << (I[a] - 7); e++) {
                F[256 + n++] = a;
              }
            }
            for (r = 0; r <= k; r++) {
              i[r] = 0;
            }
            e = 0;
            while (e <= 143) {
              D[e * 2 + 1] = 8;
              e++;
              i[8]++;
            }
            while (e <= 255) {
              D[e * 2 + 1] = 9;
              e++;
              i[9]++;
            }
            while (e <= 279) {
              D[e * 2 + 1] = 7;
              e++;
              i[7]++;
            }
            while (e <= 287) {
              D[e * 2 + 1] = 8;
              e++;
              i[8]++;
            }
            Z(D, m + 1, i);
            for (e = 0; e < b; e++) {
              O[e * 2 + 1] = 5;
              O[e * 2] = K(e, 5);
            }
            U = new M(D, x, p + 1, m, k);
            H = new M(O, I, 0, b, k);
            W = new M(new Array(0), A, 0, g, w);
          }
          function J(e) {
            var r;
            for (r = 0; r < m; r++) {
              e.dyn_ltree[r * 2] = 0;
            }
            for (r = 0; r < b; r++) {
              e.dyn_dtree[r * 2] = 0;
            }
            for (r = 0; r < g; r++) {
              e.bl_tree[r * 2] = 0;
            }
            e.dyn_ltree[B * 2] = 1;
            e.opt_len = e.static_len = 0;
            e.last_lit = e.matches = 0;
          }
          function q(e) {
            if (e.bi_valid > 8) {
              X(e, e.bi_buf);
            } else if (e.bi_valid > 0) {
              e.pending_buf[e.pending++] = e.bi_buf;
            }
            e.bi_buf = 0;
            e.bi_valid = 0;
          }
          function ee(e, r, t, n) {
            q(e);
            if (n) {
              X(e, t);
              X(e, ~t);
            }
            a.arraySet(e.pending_buf, e.window, r, t, e.pending);
            e.pending += t;
          }
          function re(e, r, t, a) {
            var n = r * 2;
            var i = t * 2;
            return e[n] < e[i] || (e[n] === e[i] && a[r] <= a[t]);
          }
          function te(e, r, t) {
            var a = e.heap[t];
            var n = t << 1;
            while (n <= e.heap_len) {
              if (n < e.heap_len && re(r, e.heap[n + 1], e.heap[n], e.depth)) {
                n++;
              }
              if (re(r, a, e.heap[n], e.depth)) {
                break;
              }
              e.heap[t] = e.heap[n];
              t = n;
              n <<= 1;
            }
            e.heap[t] = a;
          }
          function ae(e, r, t) {
            var a;
            var n;
            var i = 0;
            var s;
            var f;
            if (e.last_lit !== 0) {
              do {
                a =
                  (e.pending_buf[e.d_buf + i * 2] << 8) |
                  e.pending_buf[e.d_buf + i * 2 + 1];
                n = e.pending_buf[e.l_buf + i];
                i++;
                if (a === 0) {
                  j(e, n, r);
                } else {
                  s = P[n];
                  j(e, s + p + 1, r);
                  f = x[s];
                  if (f !== 0) {
                    n -= N[s];
                    G(e, n, f);
                  }
                  a--;
                  s = z(a);
                  j(e, s, t);
                  f = I[s];
                  if (f !== 0) {
                    a -= L[s];
                    G(e, a, f);
                  }
                }
              } while (i < e.last_lit);
            }
            j(e, B, r);
          }
          function ne(e, r) {
            var t = r.dyn_tree;
            var a = r.stat_desc.static_tree;
            var n = r.stat_desc.has_stree;
            var i = r.stat_desc.elems;
            var s, f;
            var o = -1;
            var l;
            e.heap_len = 0;
            e.heap_max = E;
            for (s = 0; s < i; s++) {
              if (t[s * 2] !== 0) {
                e.heap[++e.heap_len] = o = s;
                e.depth[s] = 0;
              } else {
                t[s * 2 + 1] = 0;
              }
            }
            while (e.heap_len < 2) {
              l = e.heap[++e.heap_len] = o < 2 ? ++o : 0;
              t[l * 2] = 1;
              e.depth[l] = 0;
              e.opt_len--;
              if (n) {
                e.static_len -= a[l * 2 + 1];
              }
            }
            r.max_code = o;
            for (s = e.heap_len >> 1; s >= 1; s--) {
              te(e, t, s);
            }
            l = i;
            do {
              s = e.heap[1];
              e.heap[1] = e.heap[e.heap_len--];
              te(e, t, 1);
              f = e.heap[1];
              e.heap[--e.heap_max] = s;
              e.heap[--e.heap_max] = f;
              t[l * 2] = t[s * 2] + t[f * 2];
              e.depth[l] =
                (e.depth[s] >= e.depth[f] ? e.depth[s] : e.depth[f]) + 1;
              t[s * 2 + 1] = t[f * 2 + 1] = l;
              e.heap[1] = l++;
              te(e, t, 1);
            } while (e.heap_len >= 2);
            e.heap[--e.heap_max] = e.heap[1];
            $(e, r);
            Z(t, o, e.bl_count);
          }
          function ie(e, r, t) {
            var a;
            var n = -1;
            var i;
            var s = r[0 * 2 + 1];
            var f = 0;
            var o = 7;
            var l = 4;
            if (s === 0) {
              o = 138;
              l = 3;
            }
            r[(t + 1) * 2 + 1] = 65535;
            for (a = 0; a <= t; a++) {
              i = s;
              s = r[(a + 1) * 2 + 1];
              if (++f < o && i === s) {
                continue;
              } else if (f < l) {
                e.bl_tree[i * 2] += f;
              } else if (i !== 0) {
                if (i !== n) {
                  e.bl_tree[i * 2]++;
                }
                e.bl_tree[C * 2]++;
              } else if (f <= 10) {
                e.bl_tree[_ * 2]++;
              } else {
                e.bl_tree[T * 2]++;
              }
              f = 0;
              n = i;
              if (s === 0) {
                o = 138;
                l = 3;
              } else if (i === s) {
                o = 6;
                l = 3;
              } else {
                o = 7;
                l = 4;
              }
            }
          }
          function se(e, r, t) {
            var a;
            var n = -1;
            var i;
            var s = r[0 * 2 + 1];
            var f = 0;
            var o = 7;
            var l = 4;
            if (s === 0) {
              o = 138;
              l = 3;
            }
            for (a = 0; a <= t; a++) {
              i = s;
              s = r[(a + 1) * 2 + 1];
              if (++f < o && i === s) {
                continue;
              } else if (f < l) {
                do {
                  j(e, i, e.bl_tree);
                } while (--f !== 0);
              } else if (i !== 0) {
                if (i !== n) {
                  j(e, i, e.bl_tree);
                  f--;
                }
                j(e, C, e.bl_tree);
                G(e, f - 3, 2);
              } else if (f <= 10) {
                j(e, _, e.bl_tree);
                G(e, f - 3, 3);
              } else {
                j(e, T, e.bl_tree);
                G(e, f - 11, 7);
              }
              f = 0;
              n = i;
              if (s === 0) {
                o = 138;
                l = 3;
              } else if (i === s) {
                o = 6;
                l = 3;
              } else {
                o = 7;
                l = 4;
              }
            }
          }
          function fe(e) {
            var r;
            ie(e, e.dyn_ltree, e.l_desc.max_code);
            ie(e, e.dyn_dtree, e.d_desc.max_code);
            ne(e, e.bl_desc);
            for (r = g - 1; r >= 3; r--) {
              if (e.bl_tree[y[r] * 2 + 1] !== 0) {
                break;
              }
            }
            e.opt_len += 3 * (r + 1) + 5 + 5 + 4;
            return r;
          }
          function oe(e, r, t, a) {
            var n;
            G(e, r - 257, 5);
            G(e, t - 1, 5);
            G(e, a - 4, 4);
            for (n = 0; n < a; n++) {
              G(e, e.bl_tree[y[n] * 2 + 1], 3);
            }
            se(e, e.dyn_ltree, r - 1);
            se(e, e.dyn_dtree, t - 1);
          }
          function le(e) {
            var r = 4093624447;
            var t;
            for (t = 0; t <= 31; t++, r >>>= 1) {
              if (r & 1 && e.dyn_ltree[t * 2] !== 0) {
                return i;
              }
            }
            if (
              e.dyn_ltree[9 * 2] !== 0 ||
              e.dyn_ltree[10 * 2] !== 0 ||
              e.dyn_ltree[13 * 2] !== 0
            ) {
              return s;
            }
            for (t = 32; t < p; t++) {
              if (e.dyn_ltree[t * 2] !== 0) {
                return s;
              }
            }
            return i;
          }
          var ce = false;
          function ue(e) {
            if (!ce) {
              Q();
              ce = true;
            }
            e.l_desc = new V(e.dyn_ltree, U);
            e.d_desc = new V(e.dyn_dtree, H);
            e.bl_desc = new V(e.bl_tree, W);
            e.bi_buf = 0;
            e.bi_valid = 0;
            J(e);
          }
          function he(e, r, t, a) {
            G(e, (l << 1) + (a ? 1 : 0), 3);
            ee(e, r, t, true);
          }
          function de(e) {
            G(e, c << 1, 3);
            j(e, B, D);
            Y(e);
          }
          function ve(e, r, t, a) {
            var i, s;
            var o = 0;
            if (e.level > 0) {
              if (e.strm.data_type === f) {
                e.strm.data_type = le(e);
              }
              ne(e, e.l_desc);
              ne(e, e.d_desc);
              o = fe(e);
              i = (e.opt_len + 3 + 7) >>> 3;
              s = (e.static_len + 3 + 7) >>> 3;
              if (s <= i) {
                i = s;
              }
            } else {
              i = s = t + 5;
            }
            if (t + 4 <= i && r !== -1) {
              he(e, r, t, a);
            } else if (e.strategy === n || s === i) {
              G(e, (c << 1) + (a ? 1 : 0), 3);
              ae(e, D, O);
            } else {
              G(e, (u << 1) + (a ? 1 : 0), 3);
              oe(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, o + 1);
              ae(e, e.dyn_ltree, e.dyn_dtree);
            }
            J(e);
            if (a) {
              q(e);
            }
          }
          function pe(e, r, t) {
            e.pending_buf[e.d_buf + e.last_lit * 2] = (r >>> 8) & 255;
            e.pending_buf[e.d_buf + e.last_lit * 2 + 1] = r & 255;
            e.pending_buf[e.l_buf + e.last_lit] = t & 255;
            e.last_lit++;
            if (r === 0) {
              e.dyn_ltree[t * 2]++;
            } else {
              e.matches++;
              r--;
              e.dyn_ltree[(P[t] + p + 1) * 2]++;
              e.dyn_dtree[z(r) * 2]++;
            }
            return e.last_lit === e.lit_bufsize - 1;
          }
          t._tr_init = ue;
          t._tr_stored_block = he;
          t._tr_flush_block = ve;
          t._tr_tally = pe;
          t._tr_align = de;
        },
        { "../utils/common": 27 },
      ],
      39: [
        function (e, r, t) {
          "use strict";
          function a() {
            this.input = null;
            this.next_in = 0;
            this.avail_in = 0;
            this.total_in = 0;
            this.output = null;
            this.next_out = 0;
            this.avail_out = 0;
            this.total_out = 0;
            this.msg = "";
            this.state = null;
            this.data_type = 2;
            this.adler = 0;
          }
          r.exports = a;
        },
        {},
      ],
    },
    {},
    [9]
  )(9);
});
var XLSX = {};
(function e(r) {
  r.version = "0.11.0";
  var t = 1200;
  if (typeof module !== "undefined" && typeof require !== "undefined") {
    if (typeof cptable === "undefined") global.cptable = null;
  }
  function a() {
    n(1200);
  }
  var n = function (e) {
    t = e;
  };
  function i(e) {
    var r = [];
    for (var t = 0, a = e.length; t < a; ++t) r[t] = e.charCodeAt(t);
    return r;
  }
  function s(e) {
    var r = [];
    for (var t = 0; t < e.length >> 1; ++t)
      r[t] = String.fromCharCode(
        e.charCodeAt(2 * t) + (e.charCodeAt(2 * t + 1) << 8)
      );
    return r.join("");
  }
  function f(e) {
    var r = [];
    for (var t = 0; t < e.length >> 1; ++t)
      r[t] = String.fromCharCode(
        e.charCodeAt(2 * t + 1) + (e.charCodeAt(2 * t) << 8)
      );
    return r.join("");
  }
  var o = function (e) {
    var r = e.charCodeAt(0),
      t = e.charCodeAt(1);
    if (r == 255 && t == 254) return s(e.substr(2));
    if (r == 254 && t == 255) return f(e.substr(2));
    if (r == 65279) return e.substr(1);
    return e;
  };
  var l = function Tk(e) {
    return String.fromCharCode(e);
  };
  if (typeof cptable !== "undefined") {
    n = function (e) {
      t = e;
    };
    o = function (e) {
      if (e.charCodeAt(0) === 255 && e.charCodeAt(1) === 254) {
        return cptable.utils.decode(1200, i(e.substr(2)));
      }
      return e;
    };
    l = function xk(e) {
      if (t === 1200) return String.fromCharCode(e);
      return cptable.utils.decode(t, [e & 255, e >> 8])[0];
    };
  }
  var c = null;
  var u = true;
  var h = (function Ik() {
    var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    return {
      encode: function (r) {
        var t = "";
        var a, n, i, s, f, o, l;
        for (var c = 0; c < r.length; ) {
          a = r.charCodeAt(c++);
          n = r.charCodeAt(c++);
          i = r.charCodeAt(c++);
          s = a >> 2;
          f = ((a & 3) << 4) | (n >> 4);
          o = ((n & 15) << 2) | (i >> 6);
          l = i & 63;
          if (isNaN(n)) {
            o = l = 64;
          } else if (isNaN(i)) {
            l = 64;
          }
          t += e.charAt(s) + e.charAt(f) + e.charAt(o) + e.charAt(l);
        }
        return t;
      },
      decode: function r(t) {
        var a = "";
        var n, i, s;
        var f, o, l, c;
        t = t.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        for (var u = 0; u < t.length; ) {
          f = e.indexOf(t.charAt(u++));
          o = e.indexOf(t.charAt(u++));
          l = e.indexOf(t.charAt(u++));
          c = e.indexOf(t.charAt(u++));
          n = (f << 2) | (o >> 4);
          i = ((o & 15) << 4) | (l >> 2);
          s = ((l & 3) << 6) | c;
          a += String.fromCharCode(n);
          if (l != 64) {
            a += String.fromCharCode(i);
          }
          if (c != 64) {
            a += String.fromCharCode(s);
          }
        }
        return a;
      },
    };
  })();
  var d =
    typeof Buffer !== "undefined" &&
    typeof process !== "undefined" &&
    typeof process.versions !== "undefined" &&
    process.versions.node;
  function v(e) {
    return new (d ? Buffer : Array)(e);
  }
  function p(e) {
    if (d) return new Buffer(e, "binary");
    return e.split("").map(function (e) {
      return e.charCodeAt(0) & 255;
    });
  }
  var m = function (e) {
    return [].concat.apply([], e);
  };
  var b = /\u0000/g,
    g = /[\u0001-\u0006]/;
  var E = {};
  var k = function Ak(e) {
    e.version = "0.10.0";
    function r(e) {
      var r = "",
        t = e.length - 1;
      while (t >= 0) r += e.charAt(t--);
      return r;
    }
    function t(e, r) {
      var t = "";
      while (t.length < r) t += e;
      return t;
    }
    function a(e, r) {
      var a = "" + e;
      return a.length >= r ? a : t("0", r - a.length) + a;
    }
    function n(e, r) {
      var a = "" + e;
      return a.length >= r ? a : t(" ", r - a.length) + a;
    }
    function i(e, r) {
      var a = "" + e;
      return a.length >= r ? a : a + t(" ", r - a.length);
    }
    function s(e, r) {
      var a = "" + Math.round(e);
      return a.length >= r ? a : t("0", r - a.length) + a;
    }
    function f(e, r) {
      var a = "" + e;
      return a.length >= r ? a : t("0", r - a.length) + a;
    }
    var o = Math.pow(2, 32);
    function l(e, r) {
      if (e > o || e < -o) return s(e, r);
      var t = Math.round(e);
      return f(t, r);
    }
    function c(e, r) {
      r = r || 0;
      return (
        e.length >= 7 + r &&
        (e.charCodeAt(r) | 32) === 103 &&
        (e.charCodeAt(r + 1) | 32) === 101 &&
        (e.charCodeAt(r + 2) | 32) === 110 &&
        (e.charCodeAt(r + 3) | 32) === 101 &&
        (e.charCodeAt(r + 4) | 32) === 114 &&
        (e.charCodeAt(r + 5) | 32) === 97 &&
        (e.charCodeAt(r + 6) | 32) === 108
      );
    }
    var u = [
      ["Sun", "Sunday"],
      ["Mon", "Monday"],
      ["Tue", "Tuesday"],
      ["Wed", "Wednesday"],
      ["Thu", "Thursday"],
      ["Fri", "Friday"],
      ["Sat", "Saturday"],
    ];
    var h = [
      ["J", "Jan", "January"],
      ["F", "Feb", "February"],
      ["M", "Mar", "March"],
      ["A", "Apr", "April"],
      ["M", "May", "May"],
      ["J", "Jun", "June"],
      ["J", "Jul", "July"],
      ["A", "Aug", "August"],
      ["S", "Sep", "September"],
      ["O", "Oct", "October"],
      ["N", "Nov", "November"],
      ["D", "Dec", "December"],
    ];
    function d(e) {
      e[0] = "General";
      e[1] = "0";
      e[2] = "0.00";
      e[3] = "#,##0";
      e[4] = "#,##0.00";
      e[9] = "0%";
      e[10] = "0.00%";
      e[11] = "0.00E+00";
      e[12] = "# ?/?";
      e[13] = "# ??/??";
      e[14] = "m/d/yy";
      e[15] = "d-mmm-yy";
      e[16] = "d-mmm";
      e[17] = "mmm-yy";
      e[18] = "h:mm AM/PM";
      e[19] = "h:mm:ss AM/PM";
      e[20] = "h:mm";
      e[21] = "h:mm:ss";
      e[22] = "m/d/yy h:mm";
      e[37] = "#,##0 ;(#,##0)";
      e[38] = "#,##0 ;[Red](#,##0)";
      e[39] = "#,##0.00;(#,##0.00)";
      e[40] = "#,##0.00;[Red](#,##0.00)";
      e[45] = "mm:ss";
      e[46] = "[h]:mm:ss";
      e[47] = "mmss.0";
      e[48] = "##0.0E+0";
      e[49] = "@";
      e[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "';
      e[65535] = "General";
    }
    var v = {};
    d(v);
    function p(e, r, t) {
      var a = e < 0 ? -1 : 1;
      var n = e * a;
      var i = 0,
        s = 1,
        f = 0;
      var o = 1,
        l = 0,
        c = 0;
      var u = Math.floor(n);
      while (l < r) {
        u = Math.floor(n);
        f = u * s + i;
        c = u * l + o;
        if (n - u < 5e-8) break;
        n = 1 / (n - u);
        i = s;
        s = f;
        o = l;
        l = c;
      }
      if (c > r) {
        if (l > r) {
          c = o;
          f = i;
        } else {
          c = l;
          f = s;
        }
      }
      if (!t) return [0, a * f, c];
      var h = Math.floor((a * f) / c);
      return [h, a * f - h * c, c];
    }
    function m(e, r, t) {
      if (e > 2958465 || e < 0) return null;
      var a = e | 0,
        n = Math.floor(86400 * (e - a)),
        i = 0;
      var s = [];
      var f = {
        D: a,
        T: n,
        u: 86400 * (e - a) - n,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0,
      };
      if (Math.abs(f.u) < 1e-6) f.u = 0;
      if (r && r.date1904) a += 1462;
      if (f.u > 0.9999) {
        f.u = 0;
        if (++n == 86400) {
          f.T = n = 0;
          ++a;
          ++f.D;
        }
      }
      if (a === 60) {
        s = t ? [1317, 10, 29] : [1900, 2, 29];
        i = 3;
      } else if (a === 0) {
        s = t ? [1317, 8, 29] : [1900, 1, 0];
        i = 6;
      } else {
        if (a > 60) --a;
        var o = new Date(1900, 0, 1);
        o.setDate(o.getDate() + a - 1);
        s = [o.getFullYear(), o.getMonth() + 1, o.getDate()];
        i = o.getDay();
        if (a < 60) i = (i + 6) % 7;
        if (t) i = C(o, s);
      }
      f.y = s[0];
      f.m = s[1];
      f.d = s[2];
      f.S = n % 60;
      n = Math.floor(n / 60);
      f.M = n % 60;
      n = Math.floor(n / 60);
      f.H = n;
      f.q = i;
      return f;
    }
    e.parse_date_code = m;
    var b = new Date(1899, 11, 31, 0, 0, 0);
    var g = b.getTime();
    var E = new Date(1900, 2, 1, 0, 0, 0);
    function k(e, r) {
      var t = e.getTime();
      if (r) t -= 1461 * 24 * 60 * 60 * 1e3;
      else if (e >= E) t += 24 * 60 * 60 * 1e3;
      return (
        (t - (g + (e.getTimezoneOffset() - b.getTimezoneOffset()) * 6e4)) /
        (24 * 60 * 60 * 1e3)
      );
    }
    function S(e) {
      return e.toString(10);
    }
    e._general_int = S;
    var w = (function M() {
      var e = /\.(\d*[1-9])0+$/,
        r = /\.0*$/,
        t = /\.(\d*[1-9])0+/,
        a = /\.0*[Ee]/,
        n = /(E[+-])(\d)$/;
      function i(e) {
        var r = e < 0 ? 12 : 11;
        var t = o(e.toFixed(12));
        if (t.length <= r) return t;
        t = e.toPrecision(10);
        if (t.length <= r) return t;
        return e.toExponential(5);
      }
      function s(r) {
        var t = r.toFixed(11).replace(e, ".$1");
        if (t.length > (r < 0 ? 12 : 11)) t = r.toPrecision(6);
        return t;
      }
      function f(e) {
        for (var r = 0; r != e.length; ++r)
          if ((e.charCodeAt(r) | 32) === 101)
            return e
              .replace(t, ".$1")
              .replace(a, "E")
              .replace("e", "E")
              .replace(n, "$10$2");
        return e;
      }
      function o(t) {
        return t.indexOf(".") > -1 ? t.replace(r, "").replace(e, ".$1") : t;
      }
      return function l(e) {
        var r = Math.floor(Math.log(Math.abs(e)) * Math.LOG10E),
          t;
        if (r >= -4 && r <= -1) t = e.toPrecision(10 + r);
        else if (Math.abs(r) <= 9) t = i(e);
        else if (r === 10) t = e.toFixed(10).substr(0, 12);
        else t = s(e);
        return o(f(t));
      };
    })();
    e._general_num = w;
    function B(e, r) {
      switch (typeof e) {
        case "string":
          return e;
        case "boolean":
          return e ? "TRUE" : "FALSE";
        case "number":
          return (e | 0) === e ? S(e) : w(e);
        case "undefined":
          return "";
        case "object":
          if (e == null) return "";
          if (e instanceof Date) return N(14, k(e, r && r.date1904), r);
      }
      throw new Error("unsupported value in General format: " + e);
    }
    e._general = B;
    function C() {
      return 0;
    }
    function _(e, r, t, n) {
      var i = "",
        s = 0,
        f = 0,
        o = t.y,
        l,
        c = 0;
      switch (e) {
        case 98:
          o = t.y + 543;
        case 121:
          switch (r.length) {
            case 1:
            case 2:
              l = o % 100;
              c = 2;
              break;
            default:
              l = o % 1e4;
              c = 4;
              break;
          }
          break;
        case 109:
          switch (r.length) {
            case 1:
            case 2:
              l = t.m;
              c = r.length;
              break;
            case 3:
              return h[t.m - 1][1];
            case 5:
              return h[t.m - 1][0];
            default:
              return h[t.m - 1][2];
          }
          break;
        case 100:
          switch (r.length) {
            case 1:
            case 2:
              l = t.d;
              c = r.length;
              break;
            case 3:
              return u[t.q][0];
            default:
              return u[t.q][1];
          }
          break;
        case 104:
          switch (r.length) {
            case 1:
            case 2:
              l = 1 + ((t.H + 11) % 12);
              c = r.length;
              break;
            default:
              throw "bad hour format: " + r;
          }
          break;
        case 72:
          switch (r.length) {
            case 1:
            case 2:
              l = t.H;
              c = r.length;
              break;
            default:
              throw "bad hour format: " + r;
          }
          break;
        case 77:
          switch (r.length) {
            case 1:
            case 2:
              l = t.M;
              c = r.length;
              break;
            default:
              throw "bad minute format: " + r;
          }
          break;
        case 115:
          if (r != "s" && r != "ss" && r != ".0" && r != ".00" && r != ".000")
            throw "bad second format: " + r;
          if (t.u === 0 && (r == "s" || r == "ss")) return a(t.S, r.length);
          if (n >= 2) f = n === 3 ? 1e3 : 100;
          else f = n === 1 ? 10 : 1;
          s = Math.round(f * (t.S + t.u));
          if (s >= 60 * f) s = 0;
          if (r === "s") return s === 0 ? "0" : "" + s / f;
          i = a(s, 2 + n);
          if (r === "ss") return i.substr(0, 2);
          return "." + i.substr(2, r.length - 1);
        case 90:
          switch (r) {
            case "[h]":
            case "[hh]":
              l = t.D * 24 + t.H;
              break;
            case "[m]":
            case "[mm]":
              l = (t.D * 24 + t.H) * 60 + t.M;
              break;
            case "[s]":
            case "[ss]":
              l = ((t.D * 24 + t.H) * 60 + t.M) * 60 + Math.round(t.S + t.u);
              break;
            default:
              throw "bad abstime format: " + r;
          }
          c = r.length === 3 ? 1 : 2;
          break;
        case 101:
          l = o;
          c = 1;
      }
      if (c > 0) return a(l, c);
      else return "";
    }
    function T(e) {
      var r = 3;
      if (e.length <= r) return e;
      var t = e.length % r,
        a = e.substr(0, t);
      for (; t != e.length; t += r)
        a += (a.length > 0 ? "," : "") + e.substr(t, r);
      return a;
    }
    var x = (function U() {
      var e = /%/g;
      function s(r, a, n) {
        var i = a.replace(e, ""),
          s = a.length - i.length;
        return x(r, i, n * Math.pow(10, 2 * s)) + t("%", s);
      }
      function f(e, r, t) {
        var a = r.length - 1;
        while (r.charCodeAt(a - 1) === 44) --a;
        return x(e, r.substr(0, a), t / Math.pow(10, 3 * (r.length - a)));
      }
      function o(e, r) {
        var t;
        var a = e.indexOf("E") - e.indexOf(".") - 1;
        if (e.match(/^#+0.0E\+0$/)) {
          if (r == 0) return "0.0E+0";
          else if (r < 0) return "-" + o(e, -r);
          var n = e.indexOf(".");
          if (n === -1) n = e.indexOf("E");
          var i = Math.floor(Math.log(r) * Math.LOG10E) % n;
          if (i < 0) i += n;
          t = (r / Math.pow(10, i)).toPrecision(a + 1 + ((n + i) % n));
          if (t.indexOf("e") === -1) {
            var s = Math.floor(Math.log(r) * Math.LOG10E);
            if (t.indexOf(".") === -1)
              t = t.charAt(0) + "." + t.substr(1) + "E+" + (s - t.length + i);
            else t += "E+" + (s - i);
            while (t.substr(0, 2) === "0.") {
              t = t.charAt(0) + t.substr(2, n) + "." + t.substr(2 + n);
              t = t.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            t = t.replace(/\+-/, "-");
          }
          t = t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function (e, r, t, a) {
            return r + t + a.substr(0, (n + i) % n) + "." + a.substr(i) + "E";
          });
        } else t = r.toExponential(a);
        if (e.match(/E\+00$/) && t.match(/e[+-]\d$/))
          t = t.substr(0, t.length - 1) + "0" + t.charAt(t.length - 1);
        if (e.match(/E\-/) && t.match(/e\+/)) t = t.replace(/e\+/, "e");
        return t.replace("e", "E");
      }
      var c = /# (\?+)( ?)\/( ?)(\d+)/;
      function u(e, r, i) {
        var s = parseInt(e[4], 10),
          f = Math.round(r * s),
          o = Math.floor(f / s);
        var l = f - o * s,
          c = s;
        return (
          i +
          (o === 0 ? "" : "" + o) +
          " " +
          (l === 0
            ? t(" ", e[1].length + 1 + e[4].length)
            : n(l, e[1].length) + e[2] + "/" + e[3] + a(c, e[4].length))
        );
      }
      function h(e, r, a) {
        return (
          a + (r === 0 ? "" : "" + r) + t(" ", e[1].length + 2 + e[4].length)
        );
      }
      var d = /^#*0*\.([0#]+)/;
      var v = /\).*[0#]/;
      var m = /\(###\) ###\\?-####/;
      function b(e) {
        var r = "",
          t;
        for (var a = 0; a != e.length; ++a)
          switch ((t = e.charCodeAt(a))) {
            case 35:
              break;
            case 63:
              r += " ";
              break;
            case 48:
              r += "0";
              break;
            default:
              r += String.fromCharCode(t);
          }
        return r;
      }
      function g(e, r) {
        var t = Math.pow(10, r);
        return "" + Math.round(e * t) / t;
      }
      function E(e, r) {
        if (
          r < ("" + Math.round((e - Math.floor(e)) * Math.pow(10, r))).length
        ) {
          return 0;
        }
        return Math.round((e - Math.floor(e)) * Math.pow(10, r));
      }
      function k(e, r) {
        if (
          r < ("" + Math.round((e - Math.floor(e)) * Math.pow(10, r))).length
        ) {
          return 1;
        }
        return 0;
      }
      function S(e) {
        if (e < 2147483647 && e > -2147483648)
          return "" + (e >= 0 ? e | 0 : (e - 1) | 0);
        return "" + Math.floor(e);
      }
      function w(e, h, B) {
        if (e.charCodeAt(0) === 40 && !h.match(v)) {
          var C = h.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
          if (B >= 0) return w("n", C, B);
          return "(" + w("n", C, -B) + ")";
        }
        if (h.charCodeAt(h.length - 1) === 44) return f(e, h, B);
        if (h.indexOf("%") !== -1) return s(e, h, B);
        if (h.indexOf("E") !== -1) return o(h, B);
        if (h.charCodeAt(0) === 36)
          return "$" + w(e, h.substr(h.charAt(1) == " " ? 2 : 1), B);
        var _;
        var I,
          A,
          y,
          R = Math.abs(B),
          D = B < 0 ? "-" : "";
        if (h.match(/^00+$/)) return D + l(R, h.length);
        if (h.match(/^[#?]+$/)) {
          _ = l(B, 0);
          if (_ === "0") _ = "";
          return _.length > h.length
            ? _
            : b(h.substr(0, h.length - _.length)) + _;
        }
        if ((I = h.match(c))) return u(I, R, D);
        if (h.match(/^#+0+$/)) return D + l(R, h.length - h.indexOf("0"));
        if ((I = h.match(d))) {
          _ = g(B, I[1].length)
            .replace(/^([^\.]+)$/, "$1." + b(I[1]))
            .replace(/\.$/, "." + b(I[1]))
            .replace(/\.(\d*)$/, function (e, r) {
              return "." + r + t("0", b(I[1]).length - r.length);
            });
          return h.indexOf("0.") !== -1 ? _ : _.replace(/^0\./, ".");
        }
        h = h.replace(/^#+([0.])/, "$1");
        if ((I = h.match(/^(0*)\.(#*)$/))) {
          return (
            D +
            g(R, I[2].length)
              .replace(/\.(\d*[1-9])0*$/, ".$1")
              .replace(/^(-?\d*)$/, "$1.")
              .replace(/^0\./, I[1].length ? "0." : ".")
          );
        }
        if ((I = h.match(/^#{1,3},##0(\.?)$/))) return D + T(l(R, 0));
        if ((I = h.match(/^#,##0\.([#0]*0)$/))) {
          return B < 0
            ? "-" + w(e, h, -B)
            : T("" + (Math.floor(B) + k(B, I[1].length))) +
                "." +
                a(E(B, I[1].length), I[1].length);
        }
        if ((I = h.match(/^#,#*,#0/))) return w(e, h.replace(/^#,#*,/, ""), B);
        if ((I = h.match(/^([0#]+)(\\?-([0#]+))+$/))) {
          _ = r(w(e, h.replace(/[\\-]/g, ""), B));
          A = 0;
          return r(
            r(h.replace(/\\/g, "")).replace(/[0#]/g, function (e) {
              return A < _.length ? _.charAt(A++) : e === "0" ? "0" : "";
            })
          );
        }
        if (h.match(m)) {
          _ = w(e, "##########", B);
          return (
            "(" + _.substr(0, 3) + ") " + _.substr(3, 3) + "-" + _.substr(6)
          );
        }
        var O = "";
        if ((I = h.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
          A = Math.min(I[4].length, 7);
          y = p(R, Math.pow(10, A) - 1, false);
          _ = "" + D;
          O = x("n", I[1], y[1]);
          if (O.charAt(O.length - 1) == " ")
            O = O.substr(0, O.length - 1) + "0";
          _ += O + I[2] + "/" + I[3];
          O = i(y[2], A);
          if (O.length < I[4].length)
            O = b(I[4].substr(I[4].length - O.length)) + O;
          _ += O;
          return _;
        }
        if ((I = h.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
          A = Math.min(Math.max(I[1].length, I[4].length), 7);
          y = p(R, Math.pow(10, A) - 1, true);
          return (
            D +
            (y[0] || (y[1] ? "" : "0")) +
            " " +
            (y[1]
              ? n(y[1], A) + I[2] + "/" + I[3] + i(y[2], A)
              : t(" ", 2 * A + 1 + I[2].length + I[3].length))
          );
        }
        if ((I = h.match(/^[#0?]+$/))) {
          _ = l(B, 0);
          if (h.length <= _.length) return _;
          return b(h.substr(0, h.length - _.length)) + _;
        }
        if ((I = h.match(/^([#0?]+)\.([#0]+)$/))) {
          _ =
            "" +
            B.toFixed(Math.min(I[2].length, 10)).replace(/([^0])0+$/, "$1");
          A = _.indexOf(".");
          var F = h.indexOf(".") - A,
            P = h.length - _.length - F;
          return b(h.substr(0, F) + _ + h.substr(h.length - P));
        }
        if ((I = h.match(/^00,000\.([#0]*0)$/))) {
          A = E(B, I[1].length);
          return B < 0
            ? "-" + w(e, h, -B)
            : T(S(B))
                .replace(/^\d,\d{3}$/, "0$&")
                .replace(/^\d*$/, function (e) {
                  return "00," + (e.length < 3 ? a(0, 3 - e.length) : "") + e;
                }) +
                "." +
                a(A, I[1].length);
        }
        switch (h) {
          case "###,##0.00":
            return w(e, "#,##0.00", B);
          case "###,###":
          case "##,###":
          case "#,###":
            var N = T(l(R, 0));
            return N !== "0" ? D + N : "";
          case "###,###.00":
            return w(e, "###,##0.00", B).replace(/^0\./, ".");
          case "#,###.00":
            return w(e, "#,##0.00", B).replace(/^0\./, ".");
          default:
        }
        throw new Error("unsupported format |" + h + "|");
      }
      function B(e, r, t) {
        var a = r.length - 1;
        while (r.charCodeAt(a - 1) === 44) --a;
        return x(e, r.substr(0, a), t / Math.pow(10, 3 * (r.length - a)));
      }
      function C(r, a, n) {
        var i = a.replace(e, ""),
          s = a.length - i.length;
        return x(r, i, n * Math.pow(10, 2 * s)) + t("%", s);
      }
      function _(e, r) {
        var t;
        var a = e.indexOf("E") - e.indexOf(".") - 1;
        if (e.match(/^#+0.0E\+0$/)) {
          if (r == 0) return "0.0E+0";
          else if (r < 0) return "-" + _(e, -r);
          var n = e.indexOf(".");
          if (n === -1) n = e.indexOf("E");
          var i = Math.floor(Math.log(r) * Math.LOG10E) % n;
          if (i < 0) i += n;
          t = (r / Math.pow(10, i)).toPrecision(a + 1 + ((n + i) % n));
          if (!t.match(/[Ee]/)) {
            var s = Math.floor(Math.log(r) * Math.LOG10E);
            if (t.indexOf(".") === -1)
              t = t.charAt(0) + "." + t.substr(1) + "E+" + (s - t.length + i);
            else t += "E+" + (s - i);
            t = t.replace(/\+-/, "-");
          }
          t = t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function (e, r, t, a) {
            return r + t + a.substr(0, (n + i) % n) + "." + a.substr(i) + "E";
          });
        } else t = r.toExponential(a);
        if (e.match(/E\+00$/) && t.match(/e[+-]\d$/))
          t = t.substr(0, t.length - 1) + "0" + t.charAt(t.length - 1);
        if (e.match(/E\-/) && t.match(/e\+/)) t = t.replace(/e\+/, "e");
        return t.replace("e", "E");
      }
      function I(e, s, f) {
        if (e.charCodeAt(0) === 40 && !s.match(v)) {
          var o = s.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
          if (f >= 0) return I("n", o, f);
          return "(" + I("n", o, -f) + ")";
        }
        if (s.charCodeAt(s.length - 1) === 44) return B(e, s, f);
        if (s.indexOf("%") !== -1) return C(e, s, f);
        if (s.indexOf("E") !== -1) return _(s, f);
        if (s.charCodeAt(0) === 36)
          return "$" + I(e, s.substr(s.charAt(1) == " " ? 2 : 1), f);
        var l;
        var u,
          g,
          E,
          k = Math.abs(f),
          S = f < 0 ? "-" : "";
        if (s.match(/^00+$/)) return S + a(k, s.length);
        if (s.match(/^[#?]+$/)) {
          l = "" + f;
          if (f === 0) l = "";
          return l.length > s.length
            ? l
            : b(s.substr(0, s.length - l.length)) + l;
        }
        if ((u = s.match(c))) return h(u, k, S);
        if (s.match(/^#+0+$/)) return S + a(k, s.length - s.indexOf("0"));
        if ((u = s.match(d))) {
          l = ("" + f)
            .replace(/^([^\.]+)$/, "$1." + b(u[1]))
            .replace(/\.$/, "." + b(u[1]));
          l = l.replace(/\.(\d*)$/, function (e, r) {
            return "." + r + t("0", b(u[1]).length - r.length);
          });
          return s.indexOf("0.") !== -1 ? l : l.replace(/^0\./, ".");
        }
        s = s.replace(/^#+([0.])/, "$1");
        if ((u = s.match(/^(0*)\.(#*)$/))) {
          return (
            S +
            ("" + k)
              .replace(/\.(\d*[1-9])0*$/, ".$1")
              .replace(/^(-?\d*)$/, "$1.")
              .replace(/^0\./, u[1].length ? "0." : ".")
          );
        }
        if ((u = s.match(/^#{1,3},##0(\.?)$/))) return S + T("" + k);
        if ((u = s.match(/^#,##0\.([#0]*0)$/))) {
          return f < 0
            ? "-" + I(e, s, -f)
            : T("" + f) + "." + t("0", u[1].length);
        }
        if ((u = s.match(/^#,#*,#0/))) return I(e, s.replace(/^#,#*,/, ""), f);
        if ((u = s.match(/^([0#]+)(\\?-([0#]+))+$/))) {
          l = r(I(e, s.replace(/[\\-]/g, ""), f));
          g = 0;
          return r(
            r(s.replace(/\\/g, "")).replace(/[0#]/g, function (e) {
              return g < l.length ? l.charAt(g++) : e === "0" ? "0" : "";
            })
          );
        }
        if (s.match(m)) {
          l = I(e, "##########", f);
          return (
            "(" + l.substr(0, 3) + ") " + l.substr(3, 3) + "-" + l.substr(6)
          );
        }
        var w = "";
        if ((u = s.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
          g = Math.min(u[4].length, 7);
          E = p(k, Math.pow(10, g) - 1, false);
          l = "" + S;
          w = x("n", u[1], E[1]);
          if (w.charAt(w.length - 1) == " ")
            w = w.substr(0, w.length - 1) + "0";
          l += w + u[2] + "/" + u[3];
          w = i(E[2], g);
          if (w.length < u[4].length)
            w = b(u[4].substr(u[4].length - w.length)) + w;
          l += w;
          return l;
        }
        if ((u = s.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
          g = Math.min(Math.max(u[1].length, u[4].length), 7);
          E = p(k, Math.pow(10, g) - 1, true);
          return (
            S +
            (E[0] || (E[1] ? "" : "0")) +
            " " +
            (E[1]
              ? n(E[1], g) + u[2] + "/" + u[3] + i(E[2], g)
              : t(" ", 2 * g + 1 + u[2].length + u[3].length))
          );
        }
        if ((u = s.match(/^[#0?]+$/))) {
          l = "" + f;
          if (s.length <= l.length) return l;
          return b(s.substr(0, s.length - l.length)) + l;
        }
        if ((u = s.match(/^([#0]+)\.([#0]+)$/))) {
          l =
            "" +
            f.toFixed(Math.min(u[2].length, 10)).replace(/([^0])0+$/, "$1");
          g = l.indexOf(".");
          var A = s.indexOf(".") - g,
            y = s.length - l.length - A;
          return b(s.substr(0, A) + l + s.substr(s.length - y));
        }
        if ((u = s.match(/^00,000\.([#0]*0)$/))) {
          return f < 0
            ? "-" + I(e, s, -f)
            : T("" + f)
                .replace(/^\d,\d{3}$/, "0$&")
                .replace(/^\d*$/, function (e) {
                  return "00," + (e.length < 3 ? a(0, 3 - e.length) : "") + e;
                }) +
                "." +
                a(0, u[1].length);
        }
        switch (s) {
          case "###,###":
          case "##,###":
          case "#,###":
            var R = T("" + k);
            return R !== "0" ? S + R : "";
          default:
            if (s.match(/\.[0#?]*$/))
              return (
                I(e, s.slice(0, s.lastIndexOf(".")), f) +
                b(s.slice(s.lastIndexOf(".")))
              );
        }
        throw new Error("unsupported format |" + s + "|");
      }
      return function A(e, r, t) {
        return (t | 0) === t ? I(e, r, t) : w(e, r, t);
      };
    })();
    function I(e) {
      var r = [];
      var t = false;
      for (var a = 0, n = 0; a < e.length; ++a)
        switch (e.charCodeAt(a)) {
          case 34:
            t = !t;
            break;
          case 95:
          case 42:
          case 92:
            ++a;
            break;
          case 59:
            r[r.length] = e.substr(n, a - n);
            n = a + 1;
        }
      r[r.length] = e.substr(n);
      if (t === true)
        throw new Error("Format |" + e + "| unterminated string ");
      return r;
    }
    e._split = I;
    var A = /\[[HhMmSs]*\]/;
    function y(e) {
      var r = 0,
        t = "",
        a = "";
      while (r < e.length) {
        switch ((t = e.charAt(r))) {
          case "G":
            if (c(e, r)) r += 6;
            r++;
            break;
          case '"':
            for (; e.charCodeAt(++r) !== 34 && r < e.length; ) ++r;
            ++r;
            break;
          case "\\":
            r += 2;
            break;
          case "_":
            r += 2;
            break;
          case "@":
            ++r;
            break;
          case "B":
          case "b":
            if (e.charAt(r + 1) === "1" || e.charAt(r + 1) === "2") return true;
          case "M":
          case "D":
          case "Y":
          case "H":
          case "S":
          case "E":
          case "m":
          case "d":
          case "y":
          case "h":
          case "s":
          case "e":
          case "g":
            return true;
          case "A":
          case "a":
            if (e.substr(r, 3).toUpperCase() === "A/P") return true;
            if (e.substr(r, 5).toUpperCase() === "AM/PM") return true;
            ++r;
            break;
          case "[":
            a = t;
            while (e.charAt(r++) !== "]" && r < e.length) a += e.charAt(r);
            if (a.match(A)) return true;
            break;
          case ".":
          case "0":
          case "#":
            while (
              r < e.length &&
              ("0#?.,E+-%".indexOf((t = e.charAt(++r))) > -1 ||
                (t == "\\" &&
                  e.charAt(r + 1) == "-" &&
                  "0#".indexOf(e.charAt(r + 2)) > -1))
            ) {}
            break;
          case "?":
            while (e.charAt(++r) === t) {}
            break;
          case "*":
            ++r;
            if (e.charAt(r) == " " || e.charAt(r) == "*") ++r;
            break;
          case "(":
          case ")":
            ++r;
            break;
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            while (r < e.length && "0123456789".indexOf(e.charAt(++r)) > -1) {}
            break;
          case " ":
            ++r;
            break;
          default:
            ++r;
            break;
        }
      }
      return false;
    }
    e.is_date = y;
    function R(e, r, t, a) {
      var n = [],
        i = "",
        s = 0,
        f = "",
        o = "t",
        l,
        u,
        h;
      var d = "H";
      while (s < e.length) {
        switch ((f = e.charAt(s))) {
          case "G":
            if (!c(e, s))
              throw new Error("unrecognized character " + f + " in " + e);
            n[n.length] = { t: "G", v: "General" };
            s += 7;
            break;
          case '"':
            for (i = ""; (h = e.charCodeAt(++s)) !== 34 && s < e.length; )
              i += String.fromCharCode(h);
            n[n.length] = { t: "t", v: i };
            ++s;
            break;
          case "\\":
            var v = e.charAt(++s),
              p = v === "(" || v === ")" ? v : "t";
            n[n.length] = { t: p, v: v };
            ++s;
            break;
          case "_":
            n[n.length] = { t: "t", v: " " };
            s += 2;
            break;
          case "@":
            n[n.length] = { t: "T", v: r };
            ++s;
            break;
          case "B":
          case "b":
            if (e.charAt(s + 1) === "1" || e.charAt(s + 1) === "2") {
              if (l == null) {
                l = m(r, t, e.charAt(s + 1) === "2");
                if (l == null) return "";
              }
              n[n.length] = { t: "X", v: e.substr(s, 2) };
              o = f;
              s += 2;
              break;
            }
          case "M":
          case "D":
          case "Y":
          case "H":
          case "S":
          case "E":
            f = f.toLowerCase();
          case "m":
          case "d":
          case "y":
          case "h":
          case "s":
          case "e":
          case "g":
            if (r < 0) return "";
            if (l == null) {
              l = m(r, t);
              if (l == null) return "";
            }
            i = f;
            while (++s < e.length && e.charAt(s).toLowerCase() === f) i += f;
            if (f === "m" && o.toLowerCase() === "h") f = "M";
            if (f === "h") f = d;
            n[n.length] = { t: f, v: i };
            o = f;
            break;
          case "A":
          case "a":
            var b = { t: f, v: f };
            if (l == null) l = m(r, t);
            if (e.substr(s, 3).toUpperCase() === "A/P") {
              if (l != null) b.v = l.H >= 12 ? "P" : "A";
              b.t = "T";
              d = "h";
              s += 3;
            } else if (e.substr(s, 5).toUpperCase() === "AM/PM") {
              if (l != null) b.v = l.H >= 12 ? "PM" : "AM";
              b.t = "T";
              s += 5;
              d = "h";
            } else {
              b.t = "t";
              ++s;
            }
            if (l == null && b.t === "T") return "";
            n[n.length] = b;
            o = f;
            break;
          case "[":
            i = f;
            while (e.charAt(s++) !== "]" && s < e.length) i += e.charAt(s);
            if (i.slice(-1) !== "]")
              throw 'unterminated "[" block: |' + i + "|";
            if (i.match(A)) {
              if (l == null) {
                l = m(r, t);
                if (l == null) return "";
              }
              n[n.length] = { t: "Z", v: i.toLowerCase() };
              o = i.charAt(1);
            } else if (i.indexOf("$") > -1) {
              i = (i.match(/\$([^-\[\]]*)/) || [])[1] || "$";
              if (!y(e)) n[n.length] = { t: "t", v: i };
            }
            break;
          case ".":
            if (l != null) {
              i = f;
              while (++s < e.length && (f = e.charAt(s)) === "0") i += f;
              n[n.length] = { t: "s", v: i };
              break;
            }
          case "0":
          case "#":
            i = f;
            while (
              (++s < e.length && "0#?.,E+-%".indexOf((f = e.charAt(s))) > -1) ||
              (f == "\\" &&
                e.charAt(s + 1) == "-" &&
                s < e.length - 2 &&
                "0#".indexOf(e.charAt(s + 2)) > -1)
            )
              i += f;
            n[n.length] = { t: "n", v: i };
            break;
          case "?":
            i = f;
            while (e.charAt(++s) === f) i += f;
            n[n.length] = { t: f, v: i };
            o = f;
            break;
          case "*":
            ++s;
            if (e.charAt(s) == " " || e.charAt(s) == "*") ++s;
            break;
          case "(":
          case ")":
            n[n.length] = { t: a === 1 ? "t" : f, v: f };
            ++s;
            break;
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            i = f;
            while (s < e.length && "0123456789".indexOf(e.charAt(++s)) > -1)
              i += e.charAt(s);
            n[n.length] = { t: "D", v: i };
            break;
          case " ":
            n[n.length] = { t: f, v: f };
            ++s;
            break;
          default:
            if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(f) === -1)
              throw new Error("unrecognized character " + f + " in " + e);
            n[n.length] = { t: "t", v: f };
            ++s;
            break;
        }
      }
      var g = 0,
        E = 0,
        k;
      for (s = n.length - 1, o = "t"; s >= 0; --s) {
        switch (n[s].t) {
          case "h":
          case "H":
            n[s].t = d;
            o = "h";
            if (g < 1) g = 1;
            break;
          case "s":
            if ((k = n[s].v.match(/\.0+$/))) E = Math.max(E, k[0].length - 1);
            if (g < 3) g = 3;
          case "d":
          case "y":
          case "M":
          case "e":
            o = n[s].t;
            break;
          case "m":
            if (o === "s") {
              n[s].t = "M";
              if (g < 2) g = 2;
            }
            break;
          case "X":
            break;
          case "Z":
            if (g < 1 && n[s].v.match(/[Hh]/)) g = 1;
            if (g < 2 && n[s].v.match(/[Mm]/)) g = 2;
            if (g < 3 && n[s].v.match(/[Ss]/)) g = 3;
        }
      }
      switch (g) {
        case 0:
          break;
        case 1:
          if (l.u >= 0.5) {
            l.u = 0;
            ++l.S;
          }
          if (l.S >= 60) {
            l.S = 0;
            ++l.M;
          }
          if (l.M >= 60) {
            l.M = 0;
            ++l.H;
          }
          break;
        case 2:
          if (l.u >= 0.5) {
            l.u = 0;
            ++l.S;
          }
          if (l.S >= 60) {
            l.S = 0;
            ++l.M;
          }
          break;
      }
      var S = "",
        w;
      for (s = 0; s < n.length; ++s) {
        switch (n[s].t) {
          case "t":
          case "T":
          case " ":
          case "D":
            break;
          case "X":
            n[s].v = "";
            n[s].t = ";";
            break;
          case "d":
          case "m":
          case "y":
          case "h":
          case "H":
          case "M":
          case "s":
          case "e":
          case "b":
          case "Z":
            n[s].v = _(n[s].t.charCodeAt(0), n[s].v, l, E);
            n[s].t = "t";
            break;
          case "n":
          case "(":
          case "?":
            w = s + 1;
            while (
              n[w] != null &&
              ((f = n[w].t) === "?" ||
                f === "D" ||
                ((f === " " || f === "t") &&
                  n[w + 1] != null &&
                  (n[w + 1].t === "?" ||
                    (n[w + 1].t === "t" && n[w + 1].v === "/"))) ||
                (n[s].t === "(" && (f === " " || f === "n" || f === ")")) ||
                (f === "t" &&
                  (n[w].v === "/" ||
                    (n[w].v === " " && n[w + 1] != null && n[w + 1].t == "?"))))
            ) {
              n[s].v += n[w].v;
              n[w] = { v: "", t: ";" };
              ++w;
            }
            S += n[s].v;
            s = w - 1;
            break;
          case "G":
            n[s].t = "t";
            n[s].v = B(r, t);
            break;
        }
      }
      var C = "",
        T,
        I;
      if (S.length > 0) {
        if (S.charCodeAt(0) == 40) {
          T = r < 0 && S.charCodeAt(0) === 45 ? -r : r;
          I = x("(", S, T);
        } else {
          T = r < 0 && a > 1 ? -r : r;
          I = x("n", S, T);
          if (T < 0 && n[0] && n[0].t == "t") {
            I = I.substr(1);
            n[0].v = "-" + n[0].v;
          }
        }
        w = I.length - 1;
        var R = n.length;
        for (s = 0; s < n.length; ++s)
          if (n[s] != null && n[s].t != "t" && n[s].v.indexOf(".") > -1) {
            R = s;
            break;
          }
        var D = n.length;
        if (R === n.length && I.indexOf("E") === -1) {
          for (s = n.length - 1; s >= 0; --s) {
            if (n[s] == null || "n?(".indexOf(n[s].t) === -1) continue;
            if (w >= n[s].v.length - 1) {
              w -= n[s].v.length;
              n[s].v = I.substr(w + 1, n[s].v.length);
            } else if (w < 0) n[s].v = "";
            else {
              n[s].v = I.substr(0, w + 1);
              w = -1;
            }
            n[s].t = "t";
            D = s;
          }
          if (w >= 0 && D < n.length) n[D].v = I.substr(0, w + 1) + n[D].v;
        } else if (R !== n.length && I.indexOf("E") === -1) {
          w = I.indexOf(".") - 1;
          for (s = R; s >= 0; --s) {
            if (n[s] == null || "n?(".indexOf(n[s].t) === -1) continue;
            u =
              n[s].v.indexOf(".") > -1 && s === R
                ? n[s].v.indexOf(".") - 1
                : n[s].v.length - 1;
            C = n[s].v.substr(u + 1);
            for (; u >= 0; --u) {
              if (
                w >= 0 &&
                (n[s].v.charAt(u) === "0" || n[s].v.charAt(u) === "#")
              )
                C = I.charAt(w--) + C;
            }
            n[s].v = C;
            n[s].t = "t";
            D = s;
          }
          if (w >= 0 && D < n.length) n[D].v = I.substr(0, w + 1) + n[D].v;
          w = I.indexOf(".") + 1;
          for (s = R; s < n.length; ++s) {
            if (n[s] == null || ("n?(".indexOf(n[s].t) === -1 && s !== R))
              continue;
            u =
              n[s].v.indexOf(".") > -1 && s === R ? n[s].v.indexOf(".") + 1 : 0;
            C = n[s].v.substr(0, u);
            for (; u < n[s].v.length; ++u) {
              if (w < I.length) C += I.charAt(w++);
            }
            n[s].v = C;
            n[s].t = "t";
            D = s;
          }
        }
      }
      for (s = 0; s < n.length; ++s)
        if (n[s] != null && "n(?".indexOf(n[s].t) > -1) {
          T = a > 1 && r < 0 && s > 0 && n[s - 1].v === "-" ? -r : r;
          n[s].v = x(n[s].t, n[s].v, T);
          n[s].t = "t";
        }
      var O = "";
      for (s = 0; s !== n.length; ++s) if (n[s] != null) O += n[s].v;
      return O;
    }
    e._eval = R;
    var D = /\[[=<>]/;
    var O = /\[([=<>]*)(-?\d+\.?\d*)\]/;
    function F(e, r) {
      if (r == null) return false;
      var t = parseFloat(r[2]);
      switch (r[1]) {
        case "=":
          if (e == t) return true;
          break;
        case ">":
          if (e > t) return true;
          break;
        case "<":
          if (e < t) return true;
          break;
        case "<>":
          if (e != t) return true;
          break;
        case ">=":
          if (e >= t) return true;
          break;
        case "<=":
          if (e <= t) return true;
          break;
      }
      return false;
    }
    function P(e, r) {
      var t = I(e);
      var a = t.length,
        n = t[a - 1].indexOf("@");
      if (a < 4 && n > -1) --a;
      if (t.length > 4)
        throw new Error("cannot find right format for |" + t.join("|") + "|");
      if (typeof r !== "number")
        return [4, t.length === 4 || n > -1 ? t[t.length - 1] : "@"];
      switch (t.length) {
        case 1:
          t =
            n > -1
              ? ["General", "General", "General", t[0]]
              : [t[0], t[0], t[0], "@"];
          break;
        case 2:
          t = n > -1 ? [t[0], t[0], t[0], t[1]] : [t[0], t[1], t[0], "@"];
          break;
        case 3:
          t = n > -1 ? [t[0], t[1], t[0], t[2]] : [t[0], t[1], t[2], "@"];
          break;
        case 4:
          break;
      }
      var i = r > 0 ? t[0] : r < 0 ? t[1] : t[2];
      if (t[0].indexOf("[") === -1 && t[1].indexOf("[") === -1) return [a, i];
      if (t[0].match(D) != null || t[1].match(D) != null) {
        var s = t[0].match(O);
        var f = t[1].match(O);
        return F(r, s)
          ? [a, t[0]]
          : F(r, f)
          ? [a, t[1]]
          : [a, t[s != null && f != null ? 2 : 1]];
      }
      return [a, i];
    }
    function N(e, r, t) {
      if (t == null) t = {};
      var a = "";
      switch (typeof e) {
        case "string":
          if (e == "m/d/yy" && t.dateNF) a = t.dateNF;
          else a = e;
          break;
        case "number":
          if (e == 14 && t.dateNF) a = t.dateNF;
          else a = (t.table != null ? t.table : v)[e];
          break;
      }
      if (c(a, 0)) return B(r, t);
      if (r instanceof Date) r = k(r, t.date1904);
      var n = P(a, r);
      if (c(n[1])) return B(r, t);
      if (r === true) r = "TRUE";
      else if (r === false) r = "FALSE";
      else if (r === "" || r == null) return "";
      return R(n[1], r, t, n[0]);
    }
    function L(e, r) {
      if (typeof r != "number") {
        r = +r || -1;
        for (var t = 0; t < 392; ++t) {
          if (v[t] == undefined) {
            if (r < 0) r = t;
            continue;
          }
          if (v[t] == e) {
            r = t;
            break;
          }
        }
        if (r < 0) r = 391;
      }
      v[r] = e;
      return r;
    }
    e.load = L;
    e._table = v;
    e.get_table = function H() {
      return v;
    };
    e.load_table = function W(e) {
      for (var r = 0; r != 392; ++r) if (e[r] !== undefined) L(e[r], r);
    };
    e.init_table = d;
    e.format = N;
  };
  k(E);
  var S = {
    "General Number": "General",
    "General Date": E._table[22],
    "Long Date": "dddd, mmmm dd, yyyy",
    "Medium Date": E._table[15],
    "Short Date": E._table[14],
    "Long Time": E._table[19],
    "Medium Time": E._table[18],
    "Short Time": E._table[20],
    Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    Fixed: E._table[2],
    Standard: E._table[4],
    Percent: E._table[10],
    Scientific: E._table[11],
    "Yes/No": '"Yes";"Yes";"No";@',
    "True/False": '"True";"True";"False";@',
    "On/Off": '"Yes";"Yes";"No";@',
  };
  var w = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
  function B(e) {
    var r = typeof e == "number" ? E._table[e] : e;
    r = r.replace(w, "(\\d+)");
    return new RegExp("^" + r + "$");
  }
  function C(e, r, t) {
    var a = -1,
      n = -1,
      i = -1,
      s = -1,
      f = -1,
      o = -1;
    (r.match(w) || []).forEach(function (e, r) {
      var l = parseInt(t[r + 1], 10);
      switch (e.toLowerCase().charAt(0)) {
        case "y":
          a = l;
          break;
        case "d":
          i = l;
          break;
        case "h":
          s = l;
          break;
        case "s":
          o = l;
          break;
        case "m":
          if (s >= 0) f = l;
          else n = l;
          break;
      }
    });
    if (o >= 0 && f == -1 && n >= 0) {
      f = n;
      n = -1;
    }
    var l =
      ("" + (a >= 0 ? a : new Date().getFullYear())).slice(-4) +
      "-" +
      ("00" + (n >= 1 ? n : 1)).slice(-2) +
      "-" +
      ("00" + (i >= 1 ? i : 1)).slice(-2);
    if (l.length == 7) l = "0" + l;
    if (l.length == 8) l = "20" + l;
    var c =
      ("00" + (s >= 0 ? s : 0)).slice(-2) +
      ":" +
      ("00" + (f >= 0 ? f : 0)).slice(-2) +
      ":" +
      ("00" + (o >= 0 ? o : 0)).slice(-2);
    if (s == -1 && f == -1 && o == -1) return l;
    if (a == -1 && n == -1 && i == -1) return c;
    return l + "T" + c;
  }
  var _ = true;
  var T = (function yk() {
    var e = {};
    e.version = "0.12.0";
    function r(e, r) {
      var o = 3;
      var u = 512;
      var h = 0;
      var d = 0;
      var v = 0;
      var p = 0;
      var m = 0;
      var b = [];
      var g = e.slice(0, 512);
      gr(g, 0);
      var E = t(g);
      o = E[0];
      switch (o) {
        case 3:
          u = 512;
          break;
        case 4:
          u = 4096;
          break;
        default:
          throw new Error("Major Version: Expected 3 or 4 saw " + o);
      }
      if (u !== 512) {
        g = e.slice(0, u);
        gr(g, 28);
      }
      var k = e.slice(0, u);
      a(g, o);
      var w = g.read_shift(4, "i");
      if (o === 3 && w !== 0)
        throw new Error("# Directory Sectors: Expected 0 saw " + w);
      g.l += 4;
      v = g.read_shift(4, "i");
      g.l += 4;
      g.chk("00100000", "Mini Stream Cutoff Size: ");
      p = g.read_shift(4, "i");
      h = g.read_shift(4, "i");
      m = g.read_shift(4, "i");
      d = g.read_shift(4, "i");
      for (var B = -1, C = 0; C < 109; ++C) {
        B = g.read_shift(4, "i");
        if (B < 0) break;
        b[C] = B;
      }
      var _ = n(e, u);
      f(m, d, _, u, b);
      var T = l(_, v, b, u);
      T[v].name = "!Directory";
      if (h > 0 && p !== S) T[p].name = "!MiniFAT";
      T[b[0]].name = "!FAT";
      T.fat_addrs = b;
      T.ssz = u;
      var x = {},
        I = [],
        A = [],
        y = [],
        R = {};
      c(v, T, _, I, h, x, A);
      i(A, R, y, I);
      var D = I.shift();
      var O = s(y, I, A, x, D);
      return {
        raw: { header: k, sectors: _ },
        FileIndex: A,
        FullPaths: y,
        FullPathDir: R,
        find: O,
      };
    }
    function t(e) {
      e.chk(w, "Header Signature: ");
      e.chk(B, "CLSID: ");
      var r = e.read_shift(2, "u");
      return [e.read_shift(2, "u"), r];
    }
    function a(e, r) {
      var t = 9;
      e.l += 2;
      switch ((t = e.read_shift(2))) {
        case 9:
          if (r != 3) throw new Error("Sector Shift: Expected 9 saw " + t);
          break;
        case 12:
          if (r != 4) throw new Error("Sector Shift: Expected 12 saw " + t);
          break;
        default:
          throw new Error("Sector Shift: Expected 9 or 12 saw " + t);
      }
      e.chk("0600", "Mini Sector Shift: ");
      e.chk("000000000000", "Reserved: ");
    }
    function n(e, r) {
      var t = Math.ceil(e.length / r) - 1;
      var a = [];
      for (var n = 1; n < t; ++n) a[n - 1] = e.slice(n * r, (n + 1) * r);
      a[t - 1] = e.slice(t * r);
      return a;
    }
    function i(e, r, t, a) {
      var n = 0,
        i = 0,
        s = 0,
        f = 0,
        o = 0,
        l = a.length;
      var c = [],
        u = [];
      for (; n < l; ++n) {
        c[n] = u[n] = n;
        t[n] = a[n];
      }
      for (; o < u.length; ++o) {
        n = u[o];
        i = e[n].L;
        s = e[n].R;
        f = e[n].C;
        if (c[n] === n) {
          if (i !== -1 && c[i] !== i) c[n] = c[i];
          if (s !== -1 && c[s] !== s) c[n] = c[s];
        }
        if (f !== -1) c[f] = n;
        if (i !== -1) {
          c[i] = c[n];
          u.push(i);
        }
        if (s !== -1) {
          c[s] = c[n];
          u.push(s);
        }
      }
      for (n = 1; n !== l; ++n)
        if (c[n] === n) {
          if (s !== -1 && c[s] !== s) c[n] = c[s];
          else if (i !== -1 && c[i] !== i) c[n] = c[i];
        }
      for (n = 1; n < l; ++n) {
        if (e[n].type === 0) continue;
        o = c[n];
        if (o === 0) t[n] = t[0] + "/" + t[n];
        else
          while (o !== 0) {
            t[n] = t[o] + "/" + t[n];
            o = c[o];
          }
        c[n] = 0;
      }
      t[0] += "/";
      for (n = 1; n < l; ++n) {
        if (e[n].type !== 2) t[n] += "/";
        r[t[n]] = e[n];
      }
    }
    function s(e, r, t, a, n) {
      var i = [];
      var s = [],
        f = 0;
      for (f = 0; f < e.length; ++f)
        i[f] = e[f].toUpperCase().replace(b, "").replace(g, "!");
      for (f = 0; f < r.length; ++f)
        s[f] = r[f].toUpperCase().replace(b, "").replace(g, "!");
      return function o(e) {
        var f = false;
        if (e.charCodeAt(0) === 47) {
          f = true;
          e = n + e;
        } else f = e.indexOf("/") !== -1;
        var o = e.toUpperCase().replace(b, "").replace(g, "!");
        var l = f === true ? i.indexOf(o) : s.indexOf(o);
        if (l === -1) return null;
        return f === true ? t[l] : a[r[l]];
      };
    }
    function f(e, r, t, a, n) {
      var i = S;
      if (e === S) {
        if (r !== 0) throw new Error("DIFAT chain shorter than expected");
      } else if (e !== -1) {
        var s = t[e],
          o = (a >>> 2) - 1;
        if (!s) return;
        for (var l = 0; l < o; ++l) {
          if ((i = lr(s, l * 4)) === S) break;
          n.push(i);
        }
        f(lr(s, a - 4), r - 1, t, a, n);
      }
    }
    function o(e, r, t, a, n) {
      var i = e.length;
      var s = [],
        f = [];
      if (!n) n = [];
      var o = a - 1,
        l = 0,
        c = 0;
      for (l = r; l >= 0; ) {
        n[l] = true;
        s[s.length] = l;
        f.push(e[l]);
        var u = t[Math.floor((l * 4) / a)];
        c = (l * 4) & o;
        if (a < 4 + c)
          throw new Error("FAT boundary crossed: " + l + " 4 " + a);
        if (!e[u]) break;
        l = lr(e[u], c);
      }
      return { nodes: s, data: He([f]) };
    }
    function l(e, r, t, a) {
      var n = e.length,
        i = [];
      var s = [],
        f = [],
        o = [];
      var l = a - 1,
        c = 0,
        u = 0,
        h = 0,
        d = 0;
      for (c = 0; c < n; ++c) {
        f = [];
        h = c + r;
        if (h >= n) h -= n;
        if (s[h]) continue;
        o = [];
        for (u = h; u >= 0; ) {
          s[u] = true;
          f[f.length] = u;
          o.push(e[u]);
          var v = t[Math.floor((u * 4) / a)];
          d = (u * 4) & l;
          if (a < 4 + d)
            throw new Error("FAT boundary crossed: " + u + " 4 " + a);
          if (!e[v]) break;
          u = lr(e[v], d);
        }
        i[h] = { nodes: f, data: He([o]) };
      }
      return i;
    }
    function c(e, r, t, a, n, i, s) {
      var f = 0,
        l = a.length ? 2 : 0;
      var c = r[e].data;
      var h = 0,
        d = 0,
        v;
      for (; h < c.length; h += 128) {
        var p = c.slice(h, h + 128);
        gr(p, 64);
        d = p.read_shift(2);
        if (d === 0) continue;
        v = Ve(p, 0, d - l);
        a.push(v);
        var m = {
          name: v,
          type: p.read_shift(1),
          color: p.read_shift(1),
          L: p.read_shift(4, "i"),
          R: p.read_shift(4, "i"),
          C: p.read_shift(4, "i"),
          clsid: p.read_shift(16),
          state: p.read_shift(4, "i"),
          start: 0,
          size: 0,
        };
        var b =
          p.read_shift(2) + p.read_shift(2) + p.read_shift(2) + p.read_shift(2);
        if (b !== 0) m.ct = u(p, p.l - 8);
        var g =
          p.read_shift(2) + p.read_shift(2) + p.read_shift(2) + p.read_shift(2);
        if (g !== 0) m.mt = u(p, p.l - 8);
        m.start = p.read_shift(4, "i");
        m.size = p.read_shift(4, "i");
        if (m.type === 5) {
          f = m.start;
          if (n > 0 && f !== S) r[f].name = "!StreamData";
        } else if (m.size >= 4096) {
          m.storage = "fat";
          if (r[m.start] === undefined)
            r[m.start] = o(t, m.start, r.fat_addrs, r.ssz);
          r[m.start].name = m.name;
          m.content = r[m.start].data.slice(0, m.size);
          gr(m.content, 0);
        } else {
          m.storage = "minifat";
          if (f !== S && m.start !== S) {
            m.content = r[f].data.slice(m.start * k, m.start * k + m.size);
            gr(m.content, 0);
          }
        }
        i[v] = m;
        s.push(m);
      }
    }
    function u(e, r) {
      return new Date(
        ((or(e, r + 4) / 1e7) * Math.pow(2, 32) +
          or(e, r) / 1e7 -
          11644473600) *
          1e3
      );
    }
    var d;
    function v(e, t) {
      if (d == null) d = null;
      return r(d.readFileSync(e), t);
    }
    function E(e, t) {
      switch ((t && t.type) || "base64") {
        case "file":
          return v(e, t);
        case "base64":
          return r(p(h.decode(e)), t);
        case "binary":
          return r(p(e), t);
      }
      return r(e, t);
    }
    var k = 64;
    var S = -2;
    var w = "d0cf11e0a1b11ae1";
    var B = "00000000000000000000000000000000";
    var C = {
      MAXREGSECT: -6,
      DIFSECT: -4,
      FATSECT: -3,
      ENDOFCHAIN: S,
      FREESECT: -1,
      HEADER_SIGNATURE: w,
      HEADER_MINOR_VERSION: "3e00",
      MAXREGSID: -6,
      NOSTREAM: -1,
      HEADER_CLSID: B,
      EntryTypes: [
        "unknown",
        "storage",
        "stream",
        "lockbytes",
        "property",
        "root",
      ],
    };
    e.read = E;
    e.parse = r;
    e.utils = {
      ReadShift: hr,
      CheckField: br,
      prep_blob: gr,
      bconcat: m,
      consts: C,
    };
    return e;
  })();
  if (
    typeof require !== "undefined" &&
    typeof module !== "undefined" &&
    typeof _ === "undefined"
  ) {
    module.exports = T;
  }
  function x(e) {
    return e !== undefined && e !== null;
  }
  function I(e) {
    return Object.keys(e);
  }
  function A(e, r) {
    var t = [],
      a = I(e);
    for (var n = 0; n !== a.length; ++n) t[e[a[n]][r]] = a[n];
    return t;
  }
  function y(e) {
    var r = [],
      t = I(e);
    for (var a = 0; a !== t.length; ++a) r[e[t[a]]] = t[a];
    return r;
  }
  function R(e) {
    var r = [],
      t = I(e);
    for (var a = 0; a !== t.length; ++a) r[e[t[a]]] = parseInt(t[a], 10);
    return r;
  }
  function D(e) {
    var r = [],
      t = I(e);
    for (var a = 0; a !== t.length; ++a) {
      if (r[e[t[a]]] == null) r[e[t[a]]] = [];
      r[e[t[a]]].push(t[a]);
    }
    return r;
  }
  var O = new Date(1899, 11, 30, 0, 0, 0);
  var F =
    O.getTime() +
    (new Date().getTimezoneOffset() - O.getTimezoneOffset()) * 6e4;
  function P(e, r) {
    var t = e.getTime();
    if (r) t += 1462 * 24 * 60 * 60 * 1e3;
    return (t - F) / (24 * 60 * 60 * 1e3);
  }
  function N(e) {
    var r = new Date();
    r.setTime(e * 24 * 60 * 60 * 1e3 + F);
    return r;
  }
  function L(e) {
    var r = 0,
      t = 0,
      a = false;
    var n = e.match(
      /P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/
    );
    if (!n) throw new Error("|" + e + "| is not an ISO8601 Duration");
    for (var i = 1; i != n.length; ++i) {
      if (!n[i]) continue;
      t = 1;
      if (i > 3) a = true;
      switch (n[i].substr(n[i].length - 1)) {
        case "Y":
          throw new Error(
            "Unsupported ISO Duration Field: " + n[i].substr(n[i].length - 1)
          );
        case "D":
          t *= 24;
        case "H":
          t *= 60;
        case "M":
          if (!a) throw new Error("Unsupported ISO Duration Field: M");
          else t *= 60;
        case "S":
          break;
      }
      r += t * parseInt(n[i], 10);
    }
    return r;
  }
  var M = new Date("2017-02-19T19:06:09.000Z");
  if (isNaN(M.getFullYear())) M = new Date("2/19/17");
  var U = M.getFullYear() == 2017;
  function H(e, r) {
    var t = new Date(e);
    if (U) {
      if (r > 0) t.setTime(t.getTime() + t.getTimezoneOffset() * 60 * 1e3);
      else if (r < 0) t.setTime(t.getTime() - t.getTimezoneOffset() * 60 * 1e3);
      return t;
    }
    if (e instanceof Date) return e;
    if (M.getFullYear() == 1917 && !isNaN(t.getFullYear())) {
      var a = t.getFullYear();
      if (e.indexOf("" + a) > -1) return t;
      t.setFullYear(t.getFullYear() + 100);
      return t;
    }
    var n = e.match(/\d+/g) || ["2017", "2", "19", "0", "0", "0"];
    return new Date(
      +n[0],
      +n[1] - 1,
      +n[2],
      +n[3] || 0,
      +n[4] || 0,
      +n[5] || 0
    );
  }
  function W(e) {
    var r = "";
    for (var t = 0; t != e.length; ++t) r += String.fromCharCode(e[t]);
    return r;
  }
  function V(e) {
    var r = [];
    for (var t = 0; t != e.length; ++t) r.push(e.charCodeAt(t));
    return r;
  }
  function z(e) {
    if (typeof JSON != "undefined" && !Array.isArray(e))
      return JSON.parse(JSON.stringify(e));
    if (typeof e != "object" || e == null) return e;
    var r = {};
    for (var t in e) if (e.hasOwnProperty(t)) r[t] = z(e[t]);
    return r;
  }
  function X(e, r) {
    var t = "";
    while (t.length < r) t += e;
    return t;
  }
  function G(e) {
    var r = new Date(e),
      t = new Date(NaN);
    var a = r.getYear(),
      n = r.getMonth(),
      i = r.getDate();
    if (isNaN(i)) return t;
    if (a < 0 || a > 8099) return t;
    if ((n > 0 || i > 1) && a != 101) return r;
    if (
      e.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)
    )
      return r;
    if (!e.match(/[a-zA-Z]/)) return r;
    return t;
  }
  function j(e) {
    if (!e) return null;
    if (e.data) return o(e.data);
    if (e.asNodeBuffer && d) return o(e.asNodeBuffer().toString("binary"));
    if (e.asBinary) return o(e.asBinary());
    if (e._data && e._data.getContent)
      return o(W(Array.prototype.slice.call(e._data.getContent(), 0)));
    return null;
  }
  function K(e) {
    if (!e) return null;
    if (e.data) return i(e.data);
    if (e.asNodeBuffer && d) return e.asNodeBuffer();
    if (e._data && e._data.getContent) {
      var r = e._data.getContent();
      if (typeof r == "string") return V(r);
      return Array.prototype.slice.call(r);
    }
    return null;
  }
  function Y(e) {
    return e && e.name.slice(-4) === ".bin" ? K(e) : j(e);
  }
  function $(e, r) {
    var t = I(e.files);
    var a = r.toLowerCase(),
      n = a.replace(/\//g, "\\");
    for (var i = 0; i < t.length; ++i) {
      var s = t[i].toLowerCase();
      if (a == s || n == s) return e.files[t[i]];
    }
    return null;
  }
  function Z(e, r) {
    var t = $(e, r);
    if (t == null) throw new Error("Cannot find file " + r + " in zip");
    return t;
  }
  function Q(e, r, t) {
    if (!t) return Y(Z(e, r));
    if (!r) return null;
    try {
      return Q(e, r);
    } catch (a) {
      return null;
    }
  }
  function J(e, r, t) {
    if (!t) return j(Z(e, r));
    if (!r) return null;
    try {
      return J(e, r);
    } catch (a) {
      return null;
    }
  }
  var q, ee;
  if (typeof JSZip !== "undefined") ee = JSZip;
  if (typeof exports !== "undefined") {
    if (typeof module !== "undefined" && module.exports) {
      if (typeof ee === "undefined") ee = null;
      q = null;
    }
  }
  function re(e, r) {
    var t = r.split("/");
    if (r.slice(-1) != "/") t.pop();
    var a = e.split("/");
    while (a.length !== 0) {
      var n = a.shift();
      if (n === "..") t.pop();
      else if (n !== ".") t.push(n);
    }
    return t.join("/");
  }
  var te = /([^"\s?>\/]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
  var ae = /<[^>]*>/g;
  var ne = /<\w*:/,
    ie = /<(\/?)\w+:/;
  function se(e, r) {
    var t = {};
    var a = 0,
      n = 0;
    for (; a !== e.length; ++a)
      if ((n = e.charCodeAt(a)) === 32 || n === 10 || n === 13) break;
    if (!r) t[0] = e.substr(0, a);
    if (a === e.length) return t;
    var i = e.match(te),
      s = 0,
      f = "",
      o = 0,
      l = "",
      c = "",
      u = 1;
    if (i)
      for (o = 0; o != i.length; ++o) {
        c = i[o];
        for (n = 0; n != c.length; ++n) if (c.charCodeAt(n) === 61) break;
        l = c.substr(0, n);
        u = (a = c.charCodeAt(n + 1)) == 34 || a == 39 ? 1 : 0;
        f = c.substring(n + 1 + u, c.length - u);
        for (s = 0; s != l.length; ++s) if (l.charCodeAt(s) === 58) break;
        if (s === l.length) {
          if (l.indexOf("_") > 0) l = l.substr(0, l.indexOf("_"));
          t[l] = f;
        } else {
          var h =
            (s === 5 && l.substr(0, 5) === "xmlns" ? "xmlns" : "") +
            l.substr(s + 1);
          if (t[h] && l.substr(s - 3, 3) == "ext") continue;
          t[h] = f;
        }
      }
    return t;
  }
  function fe(e) {
    return e.replace(ie, "<$1");
  }
  var oe = {
    "&quot;": '"',
    "&apos;": "'",
    "&gt;": ">",
    "&lt;": "<",
    "&amp;": "&",
  };
  var le = y(oe);
  var ce = (function () {
    var e = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/g,
      r = /_x([\da-fA-F]{4})_/g;
    return function t(a) {
      var n = a + "";
      return n
        .replace(e, function (e, r) {
          return (
            oe[e] ||
            String.fromCharCode(parseInt(r, e.indexOf("x") > -1 ? 16 : 10)) ||
            e
          );
        })
        .replace(r, function (e, r) {
          return String.fromCharCode(parseInt(r, 16));
        });
    };
  })();
  var ue = /[&<>'"]/g,
    he = /[\u0000-\u0008\u000b-\u001f]/g;
  function de(e, r) {
    var t = e + "";
    return t
      .replace(ue, function (e) {
        return le[e];
      })
      .replace(he, function (e) {
        return "_x" + ("000" + e.charCodeAt(0).toString(16)).slice(-4) + "_";
      });
  }
  function ve(e) {
    return de(e).replace(/ /g, "_x0020_");
  }
  var pe = /[\u0000-\u001f]/g;
  function me(e) {
    var r = e + "";
    return r
      .replace(ue, function (e) {
        return le[e];
      })
      .replace(pe, function (e) {
        return "&#x" + ("000" + e.charCodeAt(0).toString(16)).slice(-4) + ";";
      });
  }
  var be = (function () {
    var e = /&#(\d+);/g;
    function r(e, r) {
      return String.fromCharCode(parseInt(r, 10));
    }
    return function t(a) {
      return a.replace(e, r);
    };
  })();
  var ge = (function () {
    return function e(r) {
      return r.replace(/(\r\n|[\r\n])/g, "&#10;");
    };
  })();
  function Ee(e, r) {
    switch (e) {
      case 1:
      case true:
      case "1":
      case "true":
      case "TRUE":
        return true;
      default:
        return false;
    }
  }
  var ke = function Rk(e) {
    var r = "",
      t = 0,
      a = 0,
      n = 0,
      i = 0,
      s = 0,
      f = 0;
    while (t < e.length) {
      a = e.charCodeAt(t++);
      if (a < 128) {
        r += String.fromCharCode(a);
        continue;
      }
      n = e.charCodeAt(t++);
      if (a > 191 && a < 224) {
        s = (a & 31) << 6;
        s |= n & 63;
        r += String.fromCharCode(s);
        continue;
      }
      i = e.charCodeAt(t++);
      if (a < 240) {
        r += String.fromCharCode(((a & 15) << 12) | ((n & 63) << 6) | (i & 63));
        continue;
      }
      s = e.charCodeAt(t++);
      f =
        (((a & 7) << 18) | ((n & 63) << 12) | ((i & 63) << 6) | (s & 63)) -
        65536;
      r += String.fromCharCode(55296 + ((f >>> 10) & 1023));
      r += String.fromCharCode(56320 + (f & 1023));
    }
    return r;
  };
  if (d) {
    var Se = function Dk(e) {
      var r = new Buffer(2 * e.length),
        t,
        a,
        n = 1,
        i = 0,
        s = 0,
        f;
      for (a = 0; a < e.length; a += n) {
        n = 1;
        if ((f = e.charCodeAt(a)) < 128) t = f;
        else if (f < 224) {
          t = (f & 31) * 64 + (e.charCodeAt(a + 1) & 63);
          n = 2;
        } else if (f < 240) {
          t =
            (f & 15) * 4096 +
            (e.charCodeAt(a + 1) & 63) * 64 +
            (e.charCodeAt(a + 2) & 63);
          n = 3;
        } else {
          n = 4;
          t =
            (f & 7) * 262144 +
            (e.charCodeAt(a + 1) & 63) * 4096 +
            (e.charCodeAt(a + 2) & 63) * 64 +
            (e.charCodeAt(a + 3) & 63);
          t -= 65536;
          s = 55296 + ((t >>> 10) & 1023);
          t = 56320 + (t & 1023);
        }
        if (s !== 0) {
          r[i++] = s & 255;
          r[i++] = s >>> 8;
          s = 0;
        }
        r[i++] = t % 256;
        r[i++] = t >>> 8;
      }
      return r.slice(0, i).toString("ucs2");
    };
    var we = "foo bar bazâð£";
    if (ke(we) == Se(we)) ke = Se;
    var Be = function Ok(e) {
      return Buffer(e, "binary").toString("utf8");
    };
    if (ke(we) == Be(we)) ke = Be;
  }
  var Ce = (function () {
    var e = {};
    return function r(t, a) {
      var n = t + "|" + (a || "");
      if (e[n]) return e[n];
      return (e[n] = new RegExp(
        "<(?:\\w+:)?" +
          t +
          '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' +
          t +
          ">",
        a || ""
      ));
    };
  })();
  var _e = (function () {
    var e = {};
    return function r(t) {
      if (e[t] !== undefined) return e[t];
      return (e[t] = new RegExp(
        "<(?:vt:)?" + t + ">([\\s\\S]*?)</(?:vt:)?" + t + ">",
        "g"
      ));
    };
  })();
  var Te = /<\/?(?:vt:)?variant>/g,
    xe = /<(?:vt:)([^>]*)>([\s\S]*)</;
  function Ie(e) {
    var r = se(e);
    var t = e.match(_e(r.baseType)) || [];
    if (t.length != r.size)
      throw new Error("unexpected vector length " + t.length + " != " + r.size);
    var a = [];
    t.forEach(function (e) {
      var r = e.replace(Te, "").match(xe);
      a.push({ v: ke(r[2]), t: r[1] });
    });
    return a;
  }
  var Ae = /(^\s|\s$|\n)/;
  function ye(e, r) {
    return (
      "<" +
      e +
      (r.match(Ae) ? ' xml:space="preserve"' : "") +
      ">" +
      r +
      "</" +
      e +
      ">"
    );
  }
  function Re(e) {
    return I(e)
      .map(function (r) {
        return " " + r + '="' + e[r] + '"';
      })
      .join("");
  }
  function De(e, r, t) {
    return (
      "<" +
      e +
      (x(t) ? Re(t) : "") +
      (x(r)
        ? (r.match(Ae) ? ' xml:space="preserve"' : "") + ">" + r + "</" + e
        : "/") +
      ">"
    );
  }
  function Oe(e, r) {
    try {
      return e.toISOString().replace(/\.\d*/, "");
    } catch (t) {
      if (r) throw t;
    }
    return "";
  }
  function Fe(e) {
    switch (typeof e) {
      case "string":
        return De("vt:lpwstr", e);
      case "number":
        return De((e | 0) == e ? "vt:i4" : "vt:r8", String(e));
      case "boolean":
        return De("vt:bool", e ? "true" : "false");
    }
    if (e instanceof Date) return De("vt:filetime", Oe(e));
    throw new Error("Unable to serialize " + e);
  }
  var Pe = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
  var Ne = {
    dc: "http://purl.org/dc/elements/1.1/",
    dcterms: "http://purl.org/dc/terms/",
    dcmitype: "http://purl.org/dc/dcmitype/",
    mx: "http://schemas.microsoft.com/office/mac/excel/2008/main",
    r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
    sjs: "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
    vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
    xsi: "http://www.w3.org/2001/XMLSchema-instance",
    xsd: "http://www.w3.org/2001/XMLSchema",
  };
  Ne.main = [
    "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
    "http://purl.oclc.org/ooxml/spreadsheetml/main",
    "http://schemas.microsoft.com/office/excel/2006/main",
    "http://schemas.microsoft.com/office/excel/2006/2",
  ];
  var Le = {
    o: "urn:schemas-microsoft-com:office:office",
    x: "urn:schemas-microsoft-com:office:excel",
    ss: "urn:schemas-microsoft-com:office:spreadsheet",
    dt: "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
    mv: "http://macVmlSchemaUri",
    v: "urn:schemas-microsoft-com:vml",
    html: "http://www.w3.org/TR/REC-html40",
  };
  function Me(e, r) {
    var t = 1 - 2 * (e[r + 7] >>> 7);
    var a = ((e[r + 7] & 127) << 4) + ((e[r + 6] >>> 4) & 15);
    var n = e[r + 6] & 15;
    for (var i = 5; i >= 0; --i) n = n * 256 + e[r + i];
    if (a == 2047) return n == 0 ? t * Infinity : NaN;
    if (a == 0) a = -1022;
    else {
      a -= 1023;
      n += Math.pow(2, 52);
    }
    return t * Math.pow(2, a - 52) * n;
  }
  function Ue(e, r, t) {
    var a = (r < 0 || 1 / r == -Infinity ? 1 : 0) << 7,
      n = 0,
      i = 0;
    var s = a ? -r : r;
    if (!isFinite(s)) {
      n = 2047;
      i = isNaN(r) ? 26985 : 0;
    } else {
      n = Math.floor(Math.log(s) * Math.LOG2E);
      i = r * Math.pow(2, 52 - n);
      if (n <= -1023 && (!isFinite(i) || i < Math.pow(2, 52))) {
        n = -1022;
      } else {
        i -= Math.pow(2, 52);
        n += 1023;
      }
    }
    for (var f = 0; f <= 5; ++f, i /= 256) e[t + f] = i & 255;
    e[t + 6] = ((n & 15) << 4) | (i & 15);
    e[t + 7] = (n >> 4) | a;
  }
  var He, We;
  He = We = function Fk(e) {
    var r = [];
    for (var t = 0; t < e[0].length; ++t) {
      r.push.apply(r, e[0][t]);
    }
    return r;
  };
  var Ve, ze;
  Ve = ze = function Pk(e, r, t) {
    var a = [];
    for (var n = r; n < t; n += 2) a.push(String.fromCharCode(sr(e, n)));
    return a.join("");
  };
  var Xe, Ge;
  Xe = Ge = function Nk(e, r, t) {
    return e
      .slice(r, r + t)
      .map(function (e) {
        return (e < 16 ? "0" : "") + e.toString(16);
      })
      .join("");
  };
  var je, Ke;
  je = Ke = function (e, r, t) {
    var a = [];
    for (var n = r; n < t; n++) a.push(String.fromCharCode(ir(e, n)));
    return a.join("");
  };
  var Ye, $e;
  Ye = $e = function Lk(e, r) {
    var t = or(e, r);
    return t > 0 ? je(e, r + 4, r + 4 + t - 1) : "";
  };
  var Ze, Qe;
  Ze = Qe = function Mk(e, r) {
    var t = 2 * or(e, r);
    return t > 0 ? je(e, r + 4, r + 4 + t - 1) : "";
  };
  var Je, qe;
  Je = qe = function Uk(e, r) {
    var t = or(e, r);
    return t > 0 ? Ve(e, r + 4, r + 4 + t) : "";
  };
  var er, rr;
  er = rr = function Hk(e, r) {
    var t = or(e, r);
    return t > 0 ? je(e, r + 4, r + 4 + t) : "";
  };
  var tr, ar;
  tr = ar = function (e, r) {
    return Me(e, r);
  };
  var nr = function Wk(e) {
    return Array.isArray(e);
  };
  if (d) {
    Ve = function Vk(e, r, t) {
      if (!Buffer.isBuffer(e)) return ze(e, r, t);
      return e.toString("utf16le", r, t);
    };
    Xe = function (e, r, t) {
      return Buffer.isBuffer(e) ? e.toString("hex", r, r + t) : Ge(e, r, t);
    };
    Ye = function zk(e, r) {
      if (!Buffer.isBuffer(e)) return $e(e, r);
      var t = e.readUInt32LE(r);
      return t > 0 ? e.toString("utf8", r + 4, r + 4 + t - 1) : "";
    };
    Ze = function Xk(e, r) {
      if (!Buffer.isBuffer(e)) return Qe(e, r);
      var t = 2 * e.readUInt32LE(r);
      return e.toString("utf16le", r + 4, r + 4 + t - 1);
    };
    Je = function Gk(e, r) {
      if (!Buffer.isBuffer(e)) return qe(e, r);
      var t = e.readUInt32LE(r);
      return e.toString("utf16le", r + 4, r + 4 + t);
    };
    er = function jk(e, r) {
      if (!Buffer.isBuffer(e)) return rr(e, r);
      var t = e.readUInt32LE(r);
      return e.toString("utf8", r + 4, r + 4 + t);
    };
    je = function Kk(e, r, t) {
      return e.toString("utf8", r, t);
    };
    He = function (e) {
      return e[0].length > 0 && Buffer.isBuffer(e[0][0])
        ? Buffer.concat(e[0])
        : We(e);
    };
    m = function (e) {
      return Buffer.isBuffer(e[0]) ? Buffer.concat(e) : [].concat.apply([], e);
    };
    tr = function Yk(e, r) {
      if (Buffer.isBuffer(e)) return e.readDoubleLE(r);
      return ar(e, r);
    };
    nr = function $k(e) {
      return Buffer.isBuffer(e) || Array.isArray(e);
    };
  }
  if (typeof cptable !== "undefined") {
    Ve = function (e, r, t) {
      return cptable.utils.decode(1200, e.slice(r, t));
    };
    je = function (e, r, t) {
      return cptable.utils.decode(65001, e.slice(r, t));
    };
    Ye = function (e, r) {
      var a = or(e, r);
      return a > 0
        ? cptable.utils.decode(t, e.slice(r + 4, r + 4 + a - 1))
        : "";
    };
    Ze = function (e, r) {
      var t = 2 * or(e, r);
      return t > 0
        ? cptable.utils.decode(1200, e.slice(r + 4, r + 4 + t - 1))
        : "";
    };
    Je = function (e, r) {
      var t = or(e, r);
      return t > 0 ? cptable.utils.decode(1200, e.slice(r + 4, r + 4 + t)) : "";
    };
    er = function (e, r) {
      var t = or(e, r);
      return t > 0
        ? cptable.utils.decode(65001, e.slice(r + 4, r + 4 + t))
        : "";
    };
  }
  var ir = function (e, r) {
    return e[r];
  };
  var sr = function (e, r) {
    return e[r + 1] * (1 << 8) + e[r];
  };
  var fr = function (e, r) {
    var t = e[r + 1] * (1 << 8) + e[r];
    return t < 32768 ? t : (65535 - t + 1) * -1;
  };
  var or = function (e, r) {
    return e[r + 3] * (1 << 24) + (e[r + 2] << 16) + (e[r + 1] << 8) + e[r];
  };
  var lr = function (e, r) {
    return (e[r + 3] << 24) | (e[r + 2] << 16) | (e[r + 1] << 8) | e[r];
  };
  var cr = function (e) {
    return e.match(/../g).map(function (e) {
      return parseInt(e, 16);
    });
  };
  var ur =
    typeof Buffer !== "undefined"
      ? function (e) {
          return Buffer.isBuffer(e) ? new Buffer(e, "hex") : cr(e);
        }
      : cr;
  function hr(e, r) {
    var a = "",
      n,
      i,
      s = [],
      f,
      o,
      c,
      u;
    switch (r) {
      case "dbcs":
        u = this.l;
        if (d && Buffer.isBuffer(this))
          a = this.slice(this.l, this.l + 2 * e).toString("utf16le");
        else
          for (c = 0; c != e; ++c) {
            a += String.fromCharCode(sr(this, u));
            u += 2;
          }
        e *= 2;
        break;
      case "utf8":
        a = je(this, this.l, this.l + e);
        break;
      case "utf16le":
        e *= 2;
        a = Ve(this, this.l, this.l + e);
        break;
      case "wstr":
        if (typeof cptable !== "undefined")
          a = cptable.utils.decode(t, this.slice(this.l, this.l + 2 * e));
        else return hr.call(this, e, "dbcs");
        e = 2 * e;
        break;
      case "lpstr":
        a = Ye(this, this.l);
        e = 5 + a.length;
        break;
      case "lpwstr":
        a = Ze(this, this.l);
        e = 5 + a.length;
        if (a[a.length - 1] == "\0") e += 2;
        break;
      case "lpp4":
        e = 4 + or(this, this.l);
        a = Je(this, this.l);
        if (e & 2) e += 2;
        break;
      case "8lpp4":
        e = 4 + or(this, this.l);
        a = er(this, this.l);
        if (e & 3) e += 4 - (e & 3);
        break;
      case "cstr":
        e = 0;
        a = "";
        while ((f = ir(this, this.l + e++)) !== 0) s.push(l(f));
        a = s.join("");
        break;
      case "_wstr":
        e = 0;
        a = "";
        while ((f = sr(this, this.l + e)) !== 0) {
          s.push(l(f));
          e += 2;
        }
        e += 2;
        a = s.join("");
        break;
      case "dbcs-cont":
        a = "";
        u = this.l;
        for (c = 0; c != e; ++c) {
          if (this.lens && this.lens.indexOf(u) !== -1) {
            f = ir(this, u);
            this.l = u + 1;
            o = hr.call(this, e - c, f ? "dbcs-cont" : "sbcs-cont");
            return s.join("") + o;
          }
          s.push(l(sr(this, u)));
          u += 2;
        }
        a = s.join("");
        e *= 2;
        break;
      case "sbcs-cont":
        a = "";
        u = this.l;
        for (c = 0; c != e; ++c) {
          if (this.lens && this.lens.indexOf(u) !== -1) {
            f = ir(this, u);
            this.l = u + 1;
            o = hr.call(this, e - c, f ? "dbcs-cont" : "sbcs-cont");
            return s.join("") + o;
          }
          s.push(l(ir(this, u)));
          u += 1;
        }
        a = s.join("");
        break;
      default:
        switch (e) {
          case 1:
            n = ir(this, this.l);
            this.l++;
            return n;
          case 2:
            n = (r === "i" ? fr : sr)(this, this.l);
            this.l += 2;
            return n;
          case 4:
            if (r === "i" || (this[this.l + 3] & 128) === 0) {
              n = lr(this, this.l);
              this.l += 4;
              return n;
            } else {
              i = or(this, this.l);
              this.l += 4;
            }
            return i;
          case 8:
            if (r === "f") {
              i = tr(this, this.l);
              this.l += 8;
              return i;
            }
          case 16:
            a = Xe(this, this.l, e);
            break;
        }
    }
    this.l += e;
    return a;
  }
  var dr = function (e, r, t) {
    e[t] = r & 255;
    e[t + 1] = (r >>> 8) & 255;
  };
  var vr = function (e, r, t) {
    e[t] = r & 255;
    e[t + 1] = (r >>> 8) & 255;
    e[t + 2] = (r >>> 16) & 255;
    e[t + 3] = (r >>> 24) & 255;
  };
  var pr = function (e, r, t) {
    e[t] = r & 255;
    e[t + 1] = (r >> 8) & 255;
    e[t + 2] = (r >> 16) & 255;
    e[t + 3] = (r >> 24) & 255;
  };
  function mr(e, r, t) {
    var a = 0,
      n = 0;
    if (t === "dbcs") {
      for (n = 0; n != r.length; ++n) dr(this, r.charCodeAt(n), this.l + 2 * n);
      a = 2 * r.length;
    } else if (t === "sbcs") {
      for (n = 0; n != r.length; ++n) this[this.l + n] = r.charCodeAt(n) & 255;
      a = r.length;
    } else
      switch (e) {
        case 1:
          a = 1;
          this[this.l] = r & 255;
          break;
        case 2:
          a = 2;
          this[this.l] = r & 255;
          r >>>= 8;
          this[this.l + 1] = r & 255;
          break;
        case 3:
          a = 3;
          this[this.l] = r & 255;
          r >>>= 8;
          this[this.l + 1] = r & 255;
          r >>>= 8;
          this[this.l + 2] = r & 255;
          break;
        case 4:
          a = 4;
          vr(this, r, this.l);
          break;
        case 8:
          a = 8;
          if (t === "f") {
            Ue(this, r, this.l);
            break;
          }
        case 16:
          break;
        case -4:
          a = 4;
          pr(this, r, this.l);
          break;
      }
    this.l += a;
    return this;
  }
  function br(e, r) {
    var t = Xe(this, this.l, e.length >> 1);
    if (t !== e) throw r + "Expected " + e + " saw " + t;
    this.l += e.length >> 1;
  }
  function gr(e, r) {
    e.l = r;
    e.read_shift = hr;
    e.chk = br;
    e.write_shift = mr;
  }
  function Er(e, r) {
    e.l += r;
  }
  function kr(e, r) {
    if (typeof console != "undefined") console.log(e.slice(e.l, e.l + r));
    e.l += r;
  }
  function Sr(e, r) {
    e.l += r;
  }
  function wr(e) {
    var r = v(e);
    gr(r, 0);
    return r;
  }
  function Br(e, r, t) {
    if (!e) return;
    var a, n, i;
    gr(e, e.l || 0);
    var s = e.length,
      f = 0,
      o = 0;
    while (e.l < s) {
      f = e.read_shift(1);
      if (f & 128) f = (f & 127) + ((e.read_shift(1) & 127) << 7);
      var l = bE[f] || bE[65535];
      a = e.read_shift(1);
      i = a & 127;
      for (n = 1; n < 4 && a & 128; ++n)
        i += ((a = e.read_shift(1)) & 127) << (7 * n);
      o = e.l + i;
      var c = l.f(e, i, t);
      e.l = o;
      if (r(c, l.n, f)) return;
    }
  }
  function Cr() {
    var e = [],
      r = 2048;
    var t = function o(e) {
      var r = wr(e);
      gr(r, 0);
      return r;
    };
    var a = t(r);
    var n = function l() {
      if (!a) return;
      if (a.length > a.l) a = a.slice(0, a.l);
      if (a.length > 0) e.push(a);
      a = null;
    };
    var i = function c(e) {
      if (a && e < a.length - a.l) return a;
      n();
      return (a = t(Math.max(e + 1, r)));
    };
    var s = function u() {
      n();
      return He([e]);
    };
    var f = function h(e) {
      n();
      a = e;
      i(r);
    };
    return { next: i, push: f, end: s, _bufs: e };
  }
  function _r(e, r, t, a) {
    var n = Number(gE[r]),
      i;
    if (isNaN(n)) return;
    if (!a) a = bE[n].p || (t || []).length || 0;
    i = 1 + (n >= 128 ? 1 : 0) + 1 + a;
    if (a >= 128) ++i;
    if (a >= 16384) ++i;
    if (a >= 2097152) ++i;
    var s = e.next(i);
    if (n <= 127) s.write_shift(1, n);
    else {
      s.write_shift(1, (n & 127) + 128);
      s.write_shift(1, n >> 7);
    }
    for (var f = 0; f != 4; ++f) {
      if (a >= 128) {
        s.write_shift(1, (a & 127) + 128);
        a >>= 7;
      } else {
        s.write_shift(1, a);
        break;
      }
    }
    if (a > 0 && nr(t)) e.push(t);
  }
  function Tr(e, r, t) {
    var a = z(e);
    if (r.s) {
      if (a.cRel) a.c += r.s.c;
      if (a.rRel) a.r += r.s.r;
    } else {
      a.c += r.c;
      a.r += r.r;
    }
    if (!t || t.biff < 12) {
      while (a.c >= 256) a.c -= 256;
      while (a.r >= 65536) a.r -= 65536;
    }
    return a;
  }
  function xr(e, r, t) {
    var a = z(e);
    a.s = Tr(a.s, r.s, t);
    a.e = Tr(a.e, r.s, t);
    return a;
  }
  function Ir(e) {
    var r = Vr(e);
    if (e.cRel === 0) r = Mr(r);
    if (e.rRel === 0) r = Fr(r);
    return r;
  }
  function Ar(e, r) {
    if (e.s.r == 0 && !e.s.rRel) {
      if (e.e.r == (r.biff >= 12 ? 1048575 : 65535) && !e.e.rRel) {
        return (
          (e.s.cRel ? "" : "$") +
          Lr(e.s.c) +
          ":" +
          (e.e.cRel ? "" : "$") +
          Lr(e.e.c)
        );
      }
    }
    if (e.s.c == 0 && !e.s.cRel) {
      if (e.e.c == (r.biff >= 12 ? 65535 : 255) && !e.e.cRel) {
        return (
          (e.s.rRel ? "" : "$") +
          Or(e.s.r) +
          ":" +
          (e.e.rRel ? "" : "$") +
          Or(e.e.r)
        );
      }
    }
    return Ir(e.s) + ":" + Ir(e.e);
  }
  var yr = {};
  var Rr = function (e, r) {
    var t;
    if (typeof r !== "undefined") t = r;
    else if (typeof require !== "undefined") {
      try {
        t = null;
      } catch (a) {
        t = null;
      }
    }
    e.rc4 = function (e, r) {
      var t = new Array(256);
      var a = 0,
        n = 0,
        i = 0,
        s = 0;
      for (n = 0; n != 256; ++n) t[n] = n;
      for (n = 0; n != 256; ++n) {
        i = (i + t[n] + e[n % e.length].charCodeAt(0)) & 255;
        s = t[n];
        t[n] = t[i];
        t[i] = s;
      }
      n = i = 0;
      var f = Buffer(r.length);
      for (a = 0; a != r.length; ++a) {
        n = (n + 1) & 255;
        i = (i + t[n]) % 256;
        s = t[n];
        t[n] = t[i];
        t[i] = s;
        f[a] = r[a] ^ t[(t[n] + t[i]) & 255];
      }
      return f;
    };
    e.md5 = function (e) {
      if (!t) throw new Error("Unsupported crypto");
      return t.createHash("md5").update(e).digest("hex");
    };
  };
  Rr(yr, typeof crypto !== "undefined" ? crypto : undefined);
  function Dr(e) {
    return parseInt(Pr(e), 10) - 1;
  }
  function Or(e) {
    return "" + (e + 1);
  }
  function Fr(e) {
    return e.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
  }
  function Pr(e) {
    return e.replace(/\$(\d+)$/, "$1");
  }
  function Nr(e) {
    var r = Ur(e),
      t = 0,
      a = 0;
    for (; a !== r.length; ++a) t = 26 * t + r.charCodeAt(a) - 64;
    return t - 1;
  }
  function Lr(e) {
    var r = "";
    for (++e; e; e = Math.floor((e - 1) / 26))
      r = String.fromCharCode(((e - 1) % 26) + 65) + r;
    return r;
  }
  function Mr(e) {
    return e.replace(/^([A-Z])/, "$$$1");
  }
  function Ur(e) {
    return e.replace(/^\$([A-Z])/, "$1");
  }
  function Hr(e) {
    return e.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
  }
  function Wr(e) {
    var r = Hr(e);
    return { c: Nr(r[0]), r: Dr(r[1]) };
  }
  function Vr(e) {
    return Lr(e.c) + Or(e.r);
  }
  function zr(e) {
    return Mr(Fr(e));
  }
  function Xr(e) {
    return Ur(Pr(e));
  }
  function Gr(e) {
    var r = e.split(":").map(Wr);
    return { s: r[0], e: r[r.length - 1] };
  }
  function jr(e, r) {
    if (typeof r === "undefined" || typeof r === "number") {
      return jr(e.s, e.e);
    }
    if (typeof e !== "string") e = Vr(e);
    if (typeof r !== "string") r = Vr(r);
    return e == r ? e : e + ":" + r;
  }
  function Kr(e) {
    var r = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    var t = 0,
      a = 0,
      n = 0;
    var i = e.length;
    for (t = 0; a < i; ++a) {
      if ((n = e.charCodeAt(a) - 64) < 1 || n > 26) break;
      t = 26 * t + n;
    }
    r.s.c = --t;
    for (t = 0; a < i; ++a) {
      if ((n = e.charCodeAt(a) - 48) < 0 || n > 9) break;
      t = 10 * t + n;
    }
    r.s.r = --t;
    if (a === i || e.charCodeAt(++a) === 58) {
      r.e.c = r.s.c;
      r.e.r = r.s.r;
      return r;
    }
    for (t = 0; a != i; ++a) {
      if ((n = e.charCodeAt(a) - 64) < 1 || n > 26) break;
      t = 26 * t + n;
    }
    r.e.c = --t;
    for (t = 0; a != i; ++a) {
      if ((n = e.charCodeAt(a) - 48) < 0 || n > 9) break;
      t = 10 * t + n;
    }
    r.e.r = --t;
    return r;
  }
  function Yr(e, r) {
    var t = e.t == "d" && r instanceof Date;
    if (e.z != null)
      try {
        return (e.w = E.format(e.z, t ? P(r) : r));
      } catch (a) {}
    try {
      return (e.w = E.format(
        (e.XF || {}).numFmtId || (t ? 14 : 0),
        t ? P(r) : r
      ));
    } catch (a) {
      return "" + r;
    }
  }
  function $r(e, r, t) {
    if (e == null || e.t == null || e.t == "z") return "";
    if (e.w !== undefined) return e.w;
    if (e.t == "d" && !e.z && t && t.dateNF) e.z = t.dateNF;
    if (r == undefined) return Yr(e, e.v);
    return Yr(e, r);
  }
  function Zr(e, r) {
    var t = r && r.sheet ? r.sheet : "Sheet1";
    var a = {};
    a[t] = e;
    return { SheetNames: [t], Sheets: a };
  }
  function Qr(e, r) {
    var t = r || {};
    if (c != null && t.dense == null) t.dense = c;
    var a = t.dense ? [] : {};
    var n = { s: { c: 1e7, r: 1e7 }, e: { c: 0, r: 0 } };
    for (var i = 0; i != e.length; ++i) {
      for (var s = 0; s != e[i].length; ++s) {
        if (typeof e[i][s] === "undefined") continue;
        var f = { v: e[i][s] };
        if (Array.isArray(f.v)) {
          f.f = e[i][s][1];
          f.v = f.v[0];
        }
        if (n.s.r > i) n.s.r = i;
        if (n.s.c > s) n.s.c = s;
        if (n.e.r < i) n.e.r = i;
        if (n.e.c < s) n.e.c = s;
        if (f.v === null) {
          if (f.f) f.t = "n";
          else if (!t.cellStubs) continue;
          else f.t = "z";
        } else if (typeof f.v === "number") f.t = "n";
        else if (typeof f.v === "boolean") f.t = "b";
        else if (f.v instanceof Date) {
          f.z = t.dateNF || E._table[14];
          if (t.cellDates) {
            f.t = "d";
            f.w = E.format(f.z, P(f.v));
          } else {
            f.t = "n";
            f.v = P(f.v);
            f.w = E.format(f.z, f.v);
          }
        } else f.t = "s";
        if (t.dense) {
          if (!a[i]) a[i] = [];
          a[i][s] = f;
        } else {
          var o = Vr({ c: s, r: i });
          a[o] = f;
        }
      }
    }
    if (n.s.c < 1e7) a["!ref"] = jr(n);
    return a;
  }
  function Jr(e, r) {
    if (!r) r = wr(4);
    r.write_shift(4, e);
    return r;
  }
  function qr(e) {
    var r = e.read_shift(4);
    return r === 0 ? "" : e.read_shift(r, "dbcs");
  }
  function et(e, r) {
    var t = false;
    if (r == null) {
      t = true;
      r = wr(4 + 2 * e.length);
    }
    r.write_shift(4, e.length);
    if (e.length > 0) r.write_shift(0, e, "dbcs");
    return t ? r.slice(0, r.l) : r;
  }
  function rt(e, r) {
    return { ich: e.read_shift(2), ifnt: e.read_shift(2) };
  }
  function tt(e, r) {
    if (!r) r = wr(4);
    r.write_shift(2, e.ich || 0);
    r.write_shift(2, e.ifnt || 0);
    return r;
  }
  function at(e, r) {
    var t = e.l;
    var a = e.read_shift(1);
    var n = qr(e);
    var i = [];
    var s = { t: n, h: n };
    if ((a & 1) !== 0) {
      var f = e.read_shift(4);
      for (var o = 0; o != f; ++o) i.push(rt(e));
      s.r = i;
    } else s.r = [{ ich: 0, ifnt: 0 }];
    e.l = t + r;
    return s;
  }
  function nt(e, r) {
    var t = false;
    if (r == null) {
      t = true;
      r = wr(15 + 4 * e.t.length);
    }
    r.write_shift(1, 0);
    et(e.t, r);
    return t ? r.slice(0, r.l) : r;
  }
  var it = at;
  function st(e, r) {
    var t = false;
    if (r == null) {
      t = true;
      r = wr(23 + 4 * e.t.length);
    }
    r.write_shift(1, 1);
    et(e.t, r);
    r.write_shift(4, 1);
    tt({ ich: 0, ifnt: 0 }, r);
    return t ? r.slice(0, r.l) : r;
  }
  function ft(e) {
    var r = e.read_shift(4);
    var t = e.read_shift(2);
    t += e.read_shift(1) << 16;
    var a = e.read_shift(1);
    return { c: r, iStyleRef: t };
  }
  function ot(e, r) {
    if (r == null) r = wr(8);
    r.write_shift(-4, e.c);
    r.write_shift(3, e.iStyleRef || e.s);
    r.write_shift(1, 0);
    return r;
  }
  var lt = qr;
  var ct = et;
  function ut(e) {
    var r = e.read_shift(4);
    return r === 0 || r === 4294967295 ? "" : e.read_shift(r, "dbcs");
  }
  function ht(e, r) {
    var t = false;
    if (r == null) {
      t = true;
      r = wr(127);
    }
    r.write_shift(4, e.length > 0 ? e.length : 4294967295);
    if (e.length > 0) r.write_shift(0, e, "dbcs");
    return t ? r.slice(0, r.l) : r;
  }
  var dt = qr;
  var vt = et;
  var pt = ut;
  var mt = ht;
  function bt(e) {
    var r = e.slice(e.l, e.l + 4);
    var t = r[0] & 1,
      a = r[0] & 2;
    e.l += 4;
    r[0] &= 252;
    var n =
      a === 0 ? tr([0, 0, 0, 0, r[0], r[1], r[2], r[3]], 0) : lr(r, 0) >> 2;
    return t ? n / 100 : n;
  }
  function gt(e, r) {
    if (r == null) r = wr(4);
    var t = 0,
      a = 0,
      n = e * 100;
    if (e == (e | 0) && e >= -(1 << 29) && e < 1 << 29) {
      a = 1;
    } else if (n == (n | 0) && n >= -(1 << 29) && n < 1 << 29) {
      a = 1;
      t = 1;
    }
    if (a) r.write_shift(-4, ((t ? n : e) << 2) + (t + 2));
    else throw new Error("unsupported RkNumber " + e);
  }
  function Et(e) {
    var r = { s: {}, e: {} };
    r.s.r = e.read_shift(4);
    r.e.r = e.read_shift(4);
    r.s.c = e.read_shift(4);
    r.e.c = e.read_shift(4);
    return r;
  }
  function kt(e, r) {
    if (!r) r = wr(16);
    r.write_shift(4, e.s.r);
    r.write_shift(4, e.e.r);
    r.write_shift(4, e.s.c);
    r.write_shift(4, e.e.c);
    return r;
  }
  var St = Et;
  var wt = kt;
  function Bt(e, r) {
    return e.read_shift(8, "f");
  }
  function Ct(e, r) {
    return (r || wr(8)).write_shift(8, e, "f");
  }
  var _t = {
    0: "#NULL!",
    7: "#DIV/0!",
    15: "#VALUE!",
    23: "#REF!",
    29: "#NAME?",
    36: "#NUM!",
    42: "#N/A",
    43: "#GETTING_DATA",
    255: "#WTF?",
  };
  var Tt = R(_t);
  function xt(e, r) {
    var t = {};
    var a = e.read_shift(1);
    var n = a & 1;
    var i = a >>> 1;
    var s = e.read_shift(1);
    var f = e.read_shift(2, "i");
    var o = e.read_shift(1);
    var l = e.read_shift(1);
    var c = e.read_shift(1);
    var u = e.read_shift(1);
    switch (i) {
      case 0:
        t.auto = 1;
        break;
      case 1:
        t.index = s;
        var h = Zt[s];
        if (h) t.rgb = Ch(h);
        break;
      case 2:
        t.rgb = Ch([o, l, c]);
        break;
      case 3:
        t.theme = s;
        break;
    }
    if (f != 0) t.tint = f > 0 ? f / 32767 : f / 32768;
    return t;
  }
  function It(e, r) {
    if (!r) r = wr(8);
    if (!e || e.auto) {
      r.write_shift(4, 0);
      r.write_shift(4, 0);
      return r;
    }
    if (e.index) {
      r.write_shift(1, 2);
      r.write_shift(1, e.index);
    } else if (e.theme) {
      r.write_shift(1, 6);
      r.write_shift(1, e.theme);
    } else {
      r.write_shift(1, 5);
      r.write_shift(1, 0);
    }
    var t = e.tint || 0;
    if (t > 0) t *= 32767;
    else if (t < 0) t *= 32768;
    r.write_shift(2, t);
    if (!e.rgb) {
      r.write_shift(2, 0);
      r.write_shift(1, 0);
      r.write_shift(1, 0);
    } else {
      var a = e.rgb || "FFFFFF";
      r.write_shift(1, parseInt(a.substr(0, 2), 16));
      r.write_shift(1, parseInt(a.substr(2, 2), 16));
      r.write_shift(1, parseInt(a.substr(4, 2), 16));
      r.write_shift(1, 255);
    }
    return r;
  }
  function At(e, r, t) {
    var a = e.read_shift(1);
    e.l++;
    var n = {
      fItalic: a & 2,
      fStrikeout: a & 8,
      fOutline: a & 16,
      fShadow: a & 32,
      fCondense: a & 64,
      fExtend: a & 128,
    };
    return n;
  }
  function yt(e, r) {
    if (!r) r = wr(2);
    var t =
      (e.italic ? 2 : 0) |
      (e.strike ? 8 : 0) |
      (e.outline ? 16 : 0) |
      (e.shadow ? 32 : 0) |
      (e.condense ? 64 : 0) |
      (e.extend ? 128 : 0);
    r.write_shift(1, t);
    r.write_shift(1, 0);
    return r;
  }
  {
    var Rt = 2;
    var Dt = 3;
    var Ot = 11;
    var Ft = 12;
    var Pt = 19;
    var Nt = 21;
    var Lt = 30;
    var Mt = 64;
    var Ut = 71;
    var Ht = 4096;
    var Wt = 80;
    var Vt = 81;
    var zt = [Wt, Vt];
  }
  var Xt = {
    1: { n: "CodePage", t: Rt },
    2: { n: "Category", t: Wt },
    3: { n: "PresentationFormat", t: Wt },
    4: { n: "ByteCount", t: Dt },
    5: { n: "LineCount", t: Dt },
    6: { n: "ParagraphCount", t: Dt },
    7: { n: "SlideCount", t: Dt },
    8: { n: "NoteCount", t: Dt },
    9: { n: "HiddenCount", t: Dt },
    10: { n: "MultimediaClipCount", t: Dt },
    11: { n: "Scale", t: Ot },
    12: { n: "HeadingPair", t: Ht | Ft },
    13: { n: "DocParts", t: Ht | Lt },
    14: { n: "Manager", t: Wt },
    15: { n: "Company", t: Wt },
    16: { n: "LinksDirty", t: Ot },
    17: { n: "CharacterCount", t: Dt },
    19: { n: "SharedDoc", t: Ot },
    22: { n: "HLinksChanged", t: Ot },
    23: { n: "AppVersion", t: Dt, p: "version" },
    26: { n: "ContentType", t: Wt },
    27: { n: "ContentStatus", t: Wt },
    28: { n: "Language", t: Wt },
    29: { n: "Version", t: Wt },
    255: {},
  };
  var Gt = {
    1: { n: "CodePage", t: Rt },
    2: { n: "Title", t: Wt },
    3: { n: "Subject", t: Wt },
    4: { n: "Author", t: Wt },
    5: { n: "Keywords", t: Wt },
    6: { n: "Comments", t: Wt },
    7: { n: "Template", t: Wt },
    8: { n: "LastAuthor", t: Wt },
    9: { n: "RevNumber", t: Wt },
    10: { n: "EditTime", t: Mt },
    11: { n: "LastPrinted", t: Mt },
    12: { n: "CreatedDate", t: Mt },
    13: { n: "ModifiedDate", t: Mt },
    14: { n: "PageCount", t: Dt },
    15: { n: "WordCount", t: Dt },
    16: { n: "CharCount", t: Dt },
    17: { n: "Thumbnail", t: Ut },
    18: { n: "ApplicationName", t: Lt },
    19: { n: "DocumentSecurity", t: Dt },
    255: {},
  };
  var jt = {
    2147483648: { n: "Locale", t: Pt },
    2147483651: { n: "Behavior", t: Pt },
    1919054434: {},
  };
  (function () {
    for (var e in jt) if (jt.hasOwnProperty(e)) Xt[e] = Gt[e] = jt[e];
  })();
  var Kt = {
    1: "US",
    2: "CA",
    3: "",
    7: "RU",
    20: "EG",
    30: "GR",
    31: "NL",
    32: "BE",
    33: "FR",
    34: "ES",
    36: "HU",
    39: "IT",
    41: "CH",
    43: "AT",
    44: "GB",
    45: "DK",
    46: "SE",
    47: "NO",
    48: "PL",
    49: "DE",
    52: "MX",
    55: "BR",
    61: "AU",
    64: "NZ",
    66: "TH",
    81: "JP",
    82: "KR",
    84: "VN",
    86: "CN",
    90: "TR",
    105: "JS",
    213: "DZ",
    216: "MA",
    218: "LY",
    351: "PT",
    354: "IS",
    358: "FI",
    420: "CZ",
    886: "TW",
    961: "LB",
    962: "JO",
    963: "SY",
    964: "IQ",
    965: "KW",
    966: "SA",
    971: "AE",
    972: "IL",
    974: "QA",
    981: "IR",
    65535: "US",
  };
  var Yt = [
    null,
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625",
  ];
  function $t(e) {
    return e.map(function (e) {
      return [(e >> 16) & 255, (e >> 8) & 255, e & 255];
    });
  }
  var Zt = $t([
    0, 16777215, 16711680, 65280, 255, 16776960, 16711935, 65535, 0, 16777215,
    16711680, 65280, 255, 16776960, 16711935, 65535, 8388608, 32768, 128,
    8421376, 8388736, 32896, 12632256, 8421504, 10066431, 10040166, 16777164,
    13434879, 6684774, 16744576, 26316, 13421823, 128, 16711935, 16776960,
    65535, 8388736, 8388608, 32896, 255, 52479, 13434879, 13434828, 16777113,
    10079487, 16751052, 13408767, 16764057, 3368703, 3394764, 10079232,
    16763904, 16750848, 16737792, 6710937, 9868950, 13158, 3381606, 13056,
    3355392, 10040064, 10040166, 3355545, 3355443, 16777215, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  var Qt = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":
      "workbooks",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml":
      "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml":
      "extprops",
    "application/vnd.openxmlformats-officedocument.customXmlProperties+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":
      "TODO",
    "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":
      "TODO",
    "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    "application/vnd.ms-office.chartstyle+xml": "TODO",
    "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":
      "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":
      "TODO",
    "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    "application/vnd.ms-excel.attachedToolbars": "TODO",
    "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":
      "TODO",
    "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":
      "links",
    "application/vnd.ms-excel.sheetMetadata": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":
      "TODO",
    "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":
      "TODO",
    "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":
      "TODO",
    "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":
      "TODO",
    "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":
      "TODO",
    "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    "application/vnd.ms-excel.wsSortMap": "TODO",
    "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    "application/vnd.ms-excel.Timeline+xml": "TODO",
    "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "vba",
    "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":
      "TODO",
    "application/vnd.ms-excel.controlproperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    "application/vnd.ms-excel.Survey+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":
      "TODO",
    "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    "image/png": "TODO",
    sheet: "js",
  };
  var Jt = (function () {
    var e = {
      workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml",
      },
      strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings",
      },
      comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments",
      },
      sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet",
      },
      charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet",
      },
      dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet",
      },
      macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet",
      },
      styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles",
      },
    };
    I(e).forEach(function (r) {
      if (!e[r].xlsm) e[r].xlsm = e[r].xlsx;
    });
    I(e).forEach(function (r) {
      I(e[r]).forEach(function (t) {
        Qt[e[r][t]] = r;
      });
    });
    return e;
  })();
  var qt = D(Qt);
  Ne.CT = "http://schemas.openxmlformats.org/package/2006/content-types";
  function ea() {
    return {
      workbooks: [],
      sheets: [],
      charts: [],
      dialogs: [],
      macros: [],
      rels: [],
      strs: [],
      comments: [],
      links: [],
      coreprops: [],
      extprops: [],
      custprops: [],
      themes: [],
      styles: [],
      calcchains: [],
      vba: [],
      drawings: [],
      TODO: [],
      xmlns: "",
    };
  }
  function ra(e, r) {
    var t = ea();
    if (!e || !e.match) return t;
    var a = {};
    (e.match(ae) || []).forEach(function (e) {
      var r = se(e);
      switch (r[0].replace(ne, "<")) {
        case "<?xml":
          break;
        case "<Types":
          t.xmlns = r["xmlns" + (r[0].match(/<(\w+):/) || ["", ""])[1]];
          break;
        case "<Default":
          a[r.Extension] = r.ContentType;
          break;
        case "<Override":
          if (t[Qt[r.ContentType]] !== undefined)
            t[Qt[r.ContentType]].push(r.PartName);
          break;
      }
    });
    if (t.xmlns !== Ne.CT) throw new Error("Unknown Namespace: " + t.xmlns);
    t.calcchain = t.calcchains.length > 0 ? t.calcchains[0] : "";
    t.sst = t.strs.length > 0 ? t.strs[0] : "";
    t.style = t.styles.length > 0 ? t.styles[0] : "";
    t.defaults = a;
    delete t.calcchains;
    return t;
  }
  var ta = De("Types", null, {
    xmlns: Ne.CT,
    "xmlns:xsd": Ne.xsd,
    "xmlns:xsi": Ne.xsi,
  });
  var aa = [
    ["xml", "application/xml"],
    ["bin", "application/vnd.ms-excel.sheet.binary.macroEnabled.main"],
    ["vml", "application/vnd.openxmlformats-officedocument.vmlDrawing"],
    ["bmp", "image/bmp"],
    ["png", "image/png"],
    ["gif", "image/gif"],
    ["emf", "image/x-emf"],
    ["wmf", "image/x-wmf"],
    ["jpg", "image/jpeg"],
    ["jpeg", "image/jpeg"],
    ["tif", "image/tiff"],
    ["tiff", "image/tiff"],
    ["pdf", "application/pdf"],
    ["rels", qt.rels[0]],
  ].map(function (e) {
    return De("Default", null, { Extension: e[0], ContentType: e[1] });
  });
  function na(e, r) {
    var t = [],
      a;
    t[t.length] = Pe;
    t[t.length] = ta;
    t = t.concat(aa);
    var n = function (n) {
      if (e[n] && e[n].length > 0) {
        a = e[n][0];
        t[t.length] = De("Override", null, {
          PartName: (a[0] == "/" ? "" : "/") + a,
          ContentType: Jt[n][r.bookType || "xlsx"],
        });
      }
    };
    var i = function (a) {
      (e[a] || []).forEach(function (e) {
        t[t.length] = De("Override", null, {
          PartName: (e[0] == "/" ? "" : "/") + e,
          ContentType: Jt[a][r.bookType || "xlsx"],
        });
      });
    };
    var s = function (r) {
      (e[r] || []).forEach(function (e) {
        t[t.length] = De("Override", null, {
          PartName: (e[0] == "/" ? "" : "/") + e,
          ContentType: qt[r][0],
        });
      });
    };
    n("workbooks");
    i("sheets");
    i("charts");
    s("themes");
    ["strs", "styles"].forEach(n);
    ["coreprops", "extprops", "custprops"].forEach(s);
    s("vba");
    s("comments");
    s("drawings");
    if (t.length > 2) {
      t[t.length] = "</Types>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  var ia = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET:
      "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK:
      "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject",
  };
  function sa(e) {
    var r = e.lastIndexOf("/");
    return e.substr(0, r + 1) + "_rels/" + e.substr(r + 1) + ".rels";
  }
  function fa(e, r) {
    if (!e) return e;
    if (r.charAt(0) !== "/") {
      r = "/" + r;
    }
    var t = {};
    var a = {};
    (e.match(ae) || []).forEach(function (e) {
      var n = se(e);
      if (n[0] === "<Relationship") {
        var i = {};
        i.Type = n.Type;
        i.Target = n.Target;
        i.Id = n.Id;
        i.TargetMode = n.TargetMode;
        var s = n.TargetMode === "External" ? n.Target : re(n.Target, r);
        t[s] = i;
        a[n.Id] = i;
      }
    });
    t["!id"] = a;
    return t;
  }
  Ne.RELS = "http://schemas.openxmlformats.org/package/2006/relationships";
  var oa = De("Relationships", null, { xmlns: Ne.RELS });
  function la(e) {
    var r = [Pe, oa];
    I(e["!id"]).forEach(function (t) {
      r[r.length] = De("Relationship", null, e["!id"][t]);
    });
    if (r.length > 2) {
      r[r.length] = "</Relationships>";
      r[1] = r[1].replace("/>", ">");
    }
    return r.join("");
  }
  function ca(e, r, t, a, n) {
    if (!n) n = {};
    if (!e["!id"]) e["!id"] = {};
    if (r < 0) for (r = 1; e["!id"]["rId" + r]; ++r) {}
    n.Id = "rId" + r;
    n.Type = a;
    n.Target = t;
    if (n.Type == ia.HLINK) n.TargetMode = "External";
    if (e["!id"][n.Id]) throw new Error("Cannot rewrite rId " + r);
    e["!id"][n.Id] = n;
    e[("/" + n.Target).replace("//", "/")] = n;
    return r;
  }
  var ua = "application/vnd.oasis.opendocument.spreadsheet";
  function ha(e, r) {
    var t = Zg(e);
    var a;
    var n;
    while ((a = Qg.exec(t)))
      switch (a[3]) {
        case "manifest":
          break;
        case "file-entry":
          n = se(a[0], false);
          if (n.path == "/" && n.type !== ua)
            throw new Error("This OpenDocument is not a spreadsheet");
          break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
          throw new Error("Unsupported ODS Encryption");
        default:
          if (r && r.WTF) throw a;
      }
  }
  function da(e, r) {
    var t = [Pe];
    t.push(
      '<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n'
    );
    t.push(
      '  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n'
    );
    for (var a = 0; a < e.length; ++a)
      t.push(
        '  <manifest:file-entry manifest:full-path="' +
          e[a][0] +
          '" manifest:media-type="' +
          e[a][1] +
          '"/>\n'
      );
    t.push("</manifest:manifest>");
    return t.join("");
  }
  function va(e, r, t) {
    return [
      '  <rdf:Description rdf:about="' + e + '">\n',
      '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' +
        (t || "odf") +
        "#" +
        r +
        '"/>\n',
      "  </rdf:Description>\n",
    ].join("");
  }
  function pa(e, r) {
    return [
      '  <rdf:Description rdf:about="' + e + '">\n',
      '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' +
        r +
        '"/>\n',
      "  </rdf:Description>\n",
    ].join("");
  }
  function ma(e, r) {
    var t = [Pe];
    t.push(
      '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n'
    );
    for (var a = 0; a != e.length; ++a) {
      t.push(va(e[a][0], e[a][1]));
      t.push(pa("", e[a][0]));
    }
    t.push(va("", "Document", "pkg"));
    t.push("</rdf:RDF>");
    return t.join("");
  }
  var ba = (function () {
    var e =
      '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' +
      "JS " +
      r.version +
      "</meta:generator></office:meta></office:document-meta>";
    return function t(r, a) {
      return e;
    };
  })();
  var ga = [
    ["cp:category", "Category"],
    ["cp:contentStatus", "ContentStatus"],
    ["cp:keywords", "Keywords"],
    ["cp:lastModifiedBy", "LastAuthor"],
    ["cp:lastPrinted", "LastPrinted"],
    ["cp:revision", "RevNumber"],
    ["cp:version", "Version"],
    ["dc:creator", "Author"],
    ["dc:description", "Comments"],
    ["dc:identifier", "Identifier"],
    ["dc:language", "Language"],
    ["dc:subject", "Subject"],
    ["dc:title", "Title"],
    ["dcterms:created", "CreatedDate", "date"],
    ["dcterms:modified", "ModifiedDate", "date"],
  ];
  Ne.CORE_PROPS =
    "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
  ia.CORE_PROPS =
    "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties";
  var Ea = (function () {
    var e = new Array(ga.length);
    for (var r = 0; r < ga.length; ++r) {
      var t = ga[r];
      var a =
        "(?:" +
        t[0].substr(0, t[0].indexOf(":")) +
        ":)" +
        t[0].substr(t[0].indexOf(":") + 1);
      e[r] = new RegExp("<" + a + "[^>]*>([\\s\\S]*?)</" + a + ">");
    }
    return e;
  })();
  function ka(e) {
    var r = {};
    for (var t = 0; t < ga.length; ++t) {
      var a = ga[t],
        n = e.match(Ea[t]);
      if (n != null && n.length > 0) r[a[1]] = n[1];
      if (a[2] === "date" && r[a[1]]) r[a[1]] = H(r[a[1]]);
    }
    return r;
  }
  var Sa = De("cp:coreProperties", null, {
    "xmlns:cp": Ne.CORE_PROPS,
    "xmlns:dc": Ne.dc,
    "xmlns:dcterms": Ne.dcterms,
    "xmlns:dcmitype": Ne.dcmitype,
    "xmlns:xsi": Ne.xsi,
  });
  function wa(e, r, t, a, n) {
    if (n[e] != null || r == null || r === "") return;
    n[e] = r;
    a[a.length] = t ? De(e, r, t) : ye(e, r);
  }
  function Ba(e, r) {
    var t = r || {};
    var a = [Pe, Sa],
      n = {};
    if (!e && !t.Props) return a.join("");
    if (e) {
      if (e.CreatedDate != null)
        wa(
          "dcterms:created",
          typeof e.CreatedDate === "string"
            ? e.CreatedDate
            : Oe(e.CreatedDate, t.WTF),
          { "xsi:type": "dcterms:W3CDTF" },
          a,
          n
        );
      if (e.ModifiedDate != null)
        wa(
          "dcterms:modified",
          typeof e.ModifiedDate === "string"
            ? e.ModifiedDate
            : Oe(e.ModifiedDate, t.WTF),
          { "xsi:type": "dcterms:W3CDTF" },
          a,
          n
        );
    }
    for (var i = 0; i != ga.length; ++i) {
      var s = ga[i];
      var f =
        t.Props && t.Props[s[1]] != null ? t.Props[s[1]] : e ? e[s[1]] : null;
      if (f === true) f = "1";
      else if (f === false) f = "0";
      else if (typeof f == "number") f = String(f);
      if (f != null) wa(s[0], f, null, a, n);
    }
    if (a.length > 2) {
      a[a.length] = "</cp:coreProperties>";
      a[1] = a[1].replace("/>", ">");
    }
    return a.join("");
  }
  var Ca = [
    ["Application", "Application", "string"],
    ["AppVersion", "AppVersion", "string"],
    ["Company", "Company", "string"],
    ["DocSecurity", "DocSecurity", "string"],
    ["Manager", "Manager", "string"],
    ["HyperlinksChanged", "HyperlinksChanged", "bool"],
    ["SharedDoc", "SharedDoc", "bool"],
    ["LinksUpToDate", "LinksUpToDate", "bool"],
    ["ScaleCrop", "ScaleCrop", "bool"],
    ["HeadingPairs", "HeadingPairs", "raw"],
    ["TitlesOfParts", "TitlesOfParts", "raw"],
  ];
  Ne.EXT_PROPS =
    "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
  ia.EXT_PROPS =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties";
  function _a(e, r) {
    var t = {};
    if (!r) r = {};
    Ca.forEach(function (a) {
      switch (a[2]) {
        case "string":
          r[a[1]] = (e.match(Ce(a[0])) || [])[1];
          break;
        case "bool":
          r[a[1]] = (e.match(Ce(a[0])) || [])[1] === "true";
          break;
        case "raw":
          var n = e.match(
            new RegExp("<" + a[0] + "[^>]*>([\\s\\S]*?)</" + a[0] + ">")
          );
          if (n && n.length > 0) t[a[1]] = n[1];
          break;
      }
    });
    if (t.HeadingPairs && t.TitlesOfParts) {
      var a = Ie(t.HeadingPairs);
      var n = Ie(t.TitlesOfParts).map(function (e) {
        return e.v;
      });
      var i = 0,
        s = 0;
      for (var f = 0; f !== a.length; f += 2) {
        s = +a[f + 1].v;
        switch (a[f].v) {
          case "Worksheets":
          case "工作表":
          case "Листы":
          case "أوراق العمل":
          case "ワークシート":
          case "גליונות עבודה":
          case "Arbeitsblätter":
          case "Çalışma Sayfaları":
          case "Feuilles de calcul":
          case "Fogli di lavoro":
          case "Folhas de cálculo":
          case "Planilhas":
          case "Regneark":
          case "Werkbladen":
            r.Worksheets = s;
            r.SheetNames = n.slice(i, i + s);
            break;
          case "Named Ranges":
          case "名前付き一覧":
          case "Benannte Bereiche":
          case "Navngivne områder":
            r.NamedRanges = s;
            r.DefinedNames = n.slice(i, i + s);
            break;
          case "Charts":
          case "Diagramme":
            r.Chartsheets = s;
            r.ChartNames = n.slice(i, i + s);
            break;
        }
        i += s;
      }
    }
    return r;
  }
  var Ta = De("Properties", null, { xmlns: Ne.EXT_PROPS, "xmlns:vt": Ne.vt });
  function xa(e, r) {
    var t = [],
      a = {},
      n = De;
    if (!e) e = {};
    e.Application = "SheetJS";
    t[t.length] = Pe;
    t[t.length] = Ta;
    Ca.forEach(function (r) {
      if (e[r[1]] === undefined) return;
      var a;
      switch (r[2]) {
        case "string":
          a = String(e[r[1]]);
          break;
        case "bool":
          a = e[r[1]] ? "true" : "false";
          break;
      }
      if (a !== undefined) t[t.length] = n(r[0], a);
    });
    t[t.length] = n(
      "HeadingPairs",
      n(
        "vt:vector",
        n("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") +
          n("vt:variant", n("vt:i4", String(e.Worksheets))),
        { size: 2, baseType: "variant" }
      )
    );
    t[t.length] = n(
      "TitlesOfParts",
      n(
        "vt:vector",
        e.SheetNames.map(function (e) {
          return "<vt:lpstr>" + de(e) + "</vt:lpstr>";
        }).join(""),
        { size: e.Worksheets, baseType: "lpstr" }
      )
    );
    if (t.length > 2) {
      t[t.length] = "</Properties>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  Ne.CUST_PROPS =
    "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";
  ia.CUST_PROPS =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties";
  var Ia = /<[^>]+>[^<]*/g;
  function Aa(e, r) {
    var t = {},
      a = "";
    var n = e.match(Ia);
    if (n)
      for (var i = 0; i != n.length; ++i) {
        var s = n[i],
          f = se(s);
        switch (f[0]) {
          case "<?xml":
            break;
          case "<Properties":
            break;
          case "<property":
            a = f.name;
            break;
          case "</property>":
            a = null;
            break;
          default:
            if (s.indexOf("<vt:") === 0) {
              var o = s.split(">");
              var l = o[0].substring(4),
                c = o[1];
              switch (l) {
                case "lpstr":
                case "bstr":
                case "lpwstr":
                  t[a] = ce(c);
                  break;
                case "bool":
                  t[a] = Ee(c, "<vt:bool>");
                  break;
                case "i1":
                case "i2":
                case "i4":
                case "i8":
                case "int":
                case "uint":
                  t[a] = parseInt(c, 10);
                  break;
                case "r4":
                case "r8":
                case "decimal":
                  t[a] = parseFloat(c);
                  break;
                case "filetime":
                case "date":
                  t[a] = H(c);
                  break;
                case "cy":
                case "error":
                  t[a] = ce(c);
                  break;
                default:
                  if (l.slice(-1) == "/") break;
                  if (r.WTF && typeof console !== "undefined")
                    console.warn("Unexpected", s, l, o);
              }
            } else if (s.substr(0, 2) === "</") {
            } else if (r.WTF) throw new Error(s);
        }
      }
    return t;
  }
  var ya = De("Properties", null, { xmlns: Ne.CUST_PROPS, "xmlns:vt": Ne.vt });
  function Ra(e, r) {
    var t = [Pe, ya];
    if (!e) return t.join("");
    var a = 1;
    I(e).forEach(function n(r) {
      ++a;
      t[t.length] = De("property", Fe(e[r]), {
        fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
        pid: a,
        name: r,
      });
    });
    if (t.length > 2) {
      t[t.length] = "</Properties>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  var Da = {
    Title: "Title",
    Subject: "Subject",
    Author: "Author",
    Keywords: "Keywords",
    Comments: "Description",
    LastAuthor: "LastAuthor",
    RevNumber: "Revision",
    Application: "AppName",
    LastPrinted: "LastPrinted",
    CreatedDate: "Created",
    ModifiedDate: "LastSaved",
    Category: "Category",
    Manager: "Manager",
    Company: "Company",
    AppVersion: "Version",
    ContentStatus: "ContentStatus",
    Identifier: "Identifier",
    Language: "Language",
  };
  var Oa = y(Da);
  function Fa(e, r, t) {
    r = Oa[r] || r;
    e[r] = t;
  }
  function Pa(e, r) {
    var t = [];
    I(Da)
      .map(function (e) {
        for (var r = 0; r < ga.length; ++r) if (ga[r][1] == e) return ga[r];
        for (r = 0; r < Ca.length; ++r) if (Ca[r][1] == e) return Ca[r];
        throw e;
      })
      .forEach(function (a) {
        if (e[a[1]] == null) return;
        var n = r && r.Props && r.Props[a[1]] != null ? r.Props[a[1]] : e[a[1]];
        switch (a[2]) {
          case "date":
            n = new Date(n).toISOString().replace(/\.\d*Z/, "Z");
            break;
        }
        if (typeof n == "number") n = String(n);
        else if (n === true || n === false) {
          n = n ? "1" : "0";
        } else if (n instanceof Date)
          n = new Date(n).toISOString().replace(/\.\d*Z/, "");
        t.push(ye(Da[a[1]] || a[1], n));
      });
    return De("DocumentProperties", t.join(""), { xmlns: Le.o });
  }
  function Na(e, r, t) {
    var a = ["Worksheets", "SheetNames"];
    var n = "CustomDocumentProperties";
    var i = [];
    if (e)
      I(e).forEach(function (r) {
        if (!e.hasOwnProperty(r)) return;
        for (var t = 0; t < ga.length; ++t) if (r == ga[t][1]) return;
        for (t = 0; t < Ca.length; ++t) if (r == Ca[t][1]) return;
        for (t = 0; t < a.length; ++t) if (r == a[t]) return;
        var n = e[r];
        var s = "string";
        if (typeof n == "number") {
          s = "float";
          n = String(n);
        } else if (n === true || n === false) {
          s = "boolean";
          n = n ? "1" : "0";
        } else n = String(n);
        i.push(De(ve(r), n, { "dt:dt": s }));
      });
    if (r)
      I(r).forEach(function (e) {
        if (!r.hasOwnProperty(e)) return;
        var t = r[e];
        var a = "string";
        if (typeof t == "number") {
          a = "float";
          t = String(t);
        } else if (t === true || t === false) {
          a = "boolean";
          t = t ? "1" : "0";
        } else if (t instanceof Date) {
          a = "dateTime.tz";
          t = t.toISOString();
        } else t = String(t);
        i.push(De(ve(e), t, { "dt:dt": a }));
      });
    return "<" + n + ' xmlns="' + Le.o + '">' + i.join("") + "</" + n + ">";
  }
  function La(e) {
    var r = e.read_shift(4),
      t = e.read_shift(4);
    return new Date(((t / 1e7) * Math.pow(2, 32) + r / 1e7 - 11644473600) * 1e3)
      .toISOString()
      .replace(/\.000/, "");
  }
  function Ma(e, r, t) {
    var a = e.read_shift(0, "lpstr");
    if (t) e.l += (4 - ((a.length + 1) & 3)) & 3;
    return a;
  }
  function Ua(e, r, t) {
    var a = e.read_shift(0, "lpwstr");
    if (t) e.l += (4 - ((a.length + 1) & 3)) & 3;
    return a;
  }
  function Ha(e, r, t) {
    if (r === 31) return Ua(e);
    return Ma(e, r, t);
  }
  function Wa(e, r, t) {
    return Ha(e, r, t === false ? 0 : 4);
  }
  function Va(e, r) {
    if (!r) throw new Error("dafuq?");
    return Ha(e, r, 0);
  }
  function za(e) {
    var r = e.read_shift(4);
    var t = [];
    for (var a = 0; a != r; ++a) t[a] = e.read_shift(0, "lpstr");
    return t;
  }
  function Xa(e) {
    return za(e);
  }
  function Ga(e) {
    var r = Ja(e, Vt);
    var t = Ja(e, Dt);
    return [r, t];
  }
  function ja(e) {
    var r = e.read_shift(4);
    var t = [];
    for (var a = 0; a != r / 2; ++a) t.push(Ga(e));
    return t;
  }
  function Ka(e) {
    return ja(e);
  }
  function Ya(e, r) {
    var t = e.read_shift(4);
    var a = {};
    for (var n = 0; n != t; ++n) {
      var i = e.read_shift(4);
      var s = e.read_shift(4);
      a[i] = e
        .read_shift(s, r === 1200 ? "utf16le" : "utf8")
        .replace(b, "")
        .replace(g, "!");
    }
    if (e.l & 3) e.l = (e.l >> (2 + 1)) << 2;
    return a;
  }
  function $a(e) {
    var r = e.read_shift(4);
    var t = e.slice(e.l, e.l + r);
    if ((r & 3) > 0) e.l += (4 - (r & 3)) & 3;
    return t;
  }
  function Za(e) {
    var r = {};
    r.Size = e.read_shift(4);
    e.l += r.Size;
    return r;
  }
  function Qa(e, r) {}
  function Ja(e, r, t) {
    var a = e.read_shift(2),
      n,
      i = t || {};
    e.l += 2;
    if (r !== Ft)
      if (a !== r && zt.indexOf(r) === -1)
        throw new Error("Expected type " + r + " saw " + a);
    switch (r === Ft ? a : r) {
      case 2:
        n = e.read_shift(2, "i");
        if (!i.raw) e.l += 2;
        return n;
      case 3:
        n = e.read_shift(4, "i");
        return n;
      case 11:
        return e.read_shift(4) !== 0;
      case 19:
        n = e.read_shift(4);
        return n;
      case 30:
        return Ma(e, a, 4).replace(b, "");
      case 31:
        return Ua(e);
      case 64:
        return La(e);
      case 65:
        return $a(e);
      case 71:
        return Za(e);
      case 80:
        return Wa(e, a, !i.raw && 4).replace(b, "");
      case 81:
        return Va(e, a).replace(b, "");
      case 4108:
        return Ka(e);
      case 4126:
        return Xa(e);
      default:
        throw new Error("TypedPropertyValue unrecognized type " + r + " " + a);
    }
  }
  function qa(e, r) {
    var t = e.l;
    var a = e.read_shift(4);
    var i = e.read_shift(4);
    var s = [],
      f = 0;
    var o = 0;
    var l = -1,
      c = {};
    for (f = 0; f != i; ++f) {
      var u = e.read_shift(4);
      var h = e.read_shift(4);
      s[f] = [u, h + t];
    }
    var d = {};
    for (f = 0; f != i; ++f) {
      if (e.l !== s[f][1]) {
        var v = true;
        if (f > 0 && r)
          switch (r[s[f - 1][0]].t) {
            case 2:
              if (e.l + 2 === s[f][1]) {
                e.l += 2;
                v = false;
              }
              break;
            case 80:
              if (e.l <= s[f][1]) {
                e.l = s[f][1];
                v = false;
              }
              break;
            case 4108:
              if (e.l <= s[f][1]) {
                e.l = s[f][1];
                v = false;
              }
              break;
          }
        if (!r && e.l <= s[f][1]) {
          v = false;
          e.l = s[f][1];
        }
        if (v)
          throw new Error(
            "Read Error: Expected address " + s[f][1] + " at " + e.l + " :" + f
          );
      }
      if (r) {
        var p = r[s[f][0]];
        d[p.n] = Ja(e, p.t, { raw: true });
        if (p.p === "version")
          d[p.n] = String(d[p.n] >> 16) + "." + String(d[p.n] & 65535);
        if (p.n == "CodePage")
          switch (d[p.n]) {
            case 0:
              d[p.n] = 1252;
            case 874:
            case 932:
            case 936:
            case 949:
            case 950:
            case 1250:
            case 1251:
            case 1253:
            case 1254:
            case 1255:
            case 1256:
            case 1257:
            case 1258:
            case 1e4:
            case 1200:
            case 1201:
            case 1252:
            case 65e3:
            case -536:
            case 65001:
            case -535:
              n((o = d[p.n]));
              break;
            default:
              throw new Error("Unsupported CodePage: " + d[p.n]);
          }
      } else {
        if (s[f][0] === 1) {
          o = d.CodePage = Ja(e, Rt);
          n(o);
          if (l !== -1) {
            var m = e.l;
            e.l = s[l][1];
            c = Ya(e, o);
            e.l = m;
          }
        } else if (s[f][0] === 0) {
          if (o === 0) {
            l = f;
            e.l = s[f + 1][1];
            continue;
          }
          c = Ya(e, o);
        } else {
          var b = c[s[f][0]];
          var g;
          switch (e[e.l]) {
            case 65:
              e.l += 4;
              g = $a(e);
              break;
            case 30:
              e.l += 4;
              g = Wa(e, e[e.l - 4]);
              break;
            case 31:
              e.l += 4;
              g = Wa(e, e[e.l - 4]);
              break;
            case 3:
              e.l += 4;
              g = e.read_shift(4, "i");
              break;
            case 19:
              e.l += 4;
              g = e.read_shift(4);
              break;
            case 5:
              e.l += 4;
              g = e.read_shift(8, "f");
              break;
            case 11:
              e.l += 4;
              g = an(e, 4);
              break;
            case 64:
              e.l += 4;
              g = H(La(e));
              break;
            default:
              throw new Error("unparsed value: " + e[e.l]);
          }
          d[b] = g;
        }
      }
    }
    e.l = t + a;
    return d;
  }
  function en(e, r) {
    var t = e.content;
    gr(t, 0);
    var a,
      n,
      i,
      s,
      f = 0;
    t.chk("feff", "Byte Order: ");
    var o = t.read_shift(2);
    var l = t.read_shift(4);
    t.chk(T.utils.consts.HEADER_CLSID, "CLSID: ");
    a = t.read_shift(4);
    if (a !== 1 && a !== 2) throw new Error("Unrecognized #Sets: " + a);
    n = t.read_shift(16);
    s = t.read_shift(4);
    if (a === 1 && s !== t.l)
      throw new Error("Length mismatch: " + s + " !== " + t.l);
    else if (a === 2) {
      i = t.read_shift(16);
      f = t.read_shift(4);
    }
    var c = qa(t, r);
    var u = { SystemIdentifier: l };
    for (var h in c) u[h] = c[h];
    u.FMTID = n;
    if (a === 1) return u;
    if (t.l !== f) throw new Error("Length mismatch 2: " + t.l + " !== " + f);
    var d;
    try {
      d = qa(t, null);
    } catch (v) {}
    for (h in d) u[h] = d[h];
    u.FMTID = [n, i];
    return u;
  }
  function rn(e, r) {
    e.read_shift(r);
    return null;
  }
  function tn(e, r, t) {
    var a = [],
      n = e.l + r;
    while (e.l < n) a.push(t(e, n - e.l));
    if (n !== e.l) throw new Error("Slurp error");
    return a;
  }
  function an(e, r) {
    return e.read_shift(r) === 1;
  }
  function nn(e) {
    return e.read_shift(2, "u");
  }
  function sn(e, r) {
    return tn(e, r, nn);
  }
  var fn = an;
  function on(e) {
    var r = e.read_shift(1),
      t = e.read_shift(1);
    return t === 1 ? r : r === 1;
  }
  function ln(e, r, a) {
    var n = e.read_shift(a && a.biff >= 12 ? 2 : 1);
    var i = 1,
      s = "sbcs-cont";
    var f = t;
    if (a && a.biff >= 8) t = 1200;
    if (!a || a.biff == 8) {
      var o = e.read_shift(1);
      if (o) {
        i = 2;
        s = "dbcs-cont";
      }
    } else if (a.biff == 12) {
      i = 2;
      s = "wstr";
    }
    var l = n ? e.read_shift(n, s) : "";
    t = f;
    return l;
  }
  function cn(e) {
    var r = t;
    t = 1200;
    var a = e.read_shift(2),
      n = e.read_shift(1);
    var i = n & 1,
      s = n & 4,
      f = n & 8;
    var o = 1 + (n & 1);
    var l = 0,
      c;
    var u = {};
    if (f) l = e.read_shift(2);
    if (s) c = e.read_shift(4);
    var h = n & 1 ? "dbcs-cont" : "sbcs-cont";
    var d = a === 0 ? "" : e.read_shift(a, h);
    if (f) e.l += 4 * l;
    if (s) e.l += c;
    u.t = d;
    if (!f) {
      u.raw = "<t>" + u.t + "</t>";
      u.r = u.t;
    }
    t = r;
    return u;
  }
  function un(e, r, t) {
    var a;
    if (t) {
      if (t.biff >= 2 && t.biff <= 5) return e.read_shift(r, "sbcs-cont");
      if (t.biff >= 12) return e.read_shift(r, "dbcs-cont");
    }
    var n = e.read_shift(1);
    if (n === 0) {
      a = e.read_shift(r, "sbcs-cont");
    } else {
      a = e.read_shift(r, "dbcs-cont");
    }
    return a;
  }
  function hn(e, r, t) {
    var a = e.read_shift(t && t.biff == 2 ? 1 : 2);
    if (a === 0) {
      e.l++;
      return "";
    }
    return un(e, a, t);
  }
  function dn(e, r, t) {
    if (t.biff > 5) return hn(e, r, t);
    var a = e.read_shift(1);
    if (a === 0) {
      e.l++;
      return "";
    }
    return e.read_shift(a, "sbcs-cont");
  }
  function vn(e, r, t) {
    var a = e.read_shift(1);
    e.l++;
    var n = e.read_shift(2);
    e.l += 2;
    return [a, n];
  }
  var pn = function (e) {
    var r = e.read_shift(4),
      t = e.l;
    var a = false;
    if (r > 24) {
      e.l += r - 24;
      if (e.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") a = true;
      e.l = t;
    }
    var n = e.read_shift((a ? r - 24 : r) >> 1, "utf16le").replace(b, "");
    if (a) e.l += 24;
    return n;
  };
  var mn = function (e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(4);
    var n = e.read_shift(a, "cstr");
    var i = e.read_shift(2);
    var s = e.read_shift(2);
    var f = e.read_shift(4);
    if (f === 0) return n.replace(/\\/g, "/");
    var o = e.read_shift(4);
    var l = e.read_shift(2);
    var c = e.read_shift(o >> 1, "utf16le").replace(b, "");
    return c;
  };
  var bn = function (e, r) {
    var t = e.read_shift(16);
    r -= 16;
    switch (t) {
      case "e0c9ea79f9bace118c8200aa004ba90b":
        return pn(e, r);
      case "0303000000000000c000000000000046":
        return mn(e, r);
      default:
        throw new Error("Unsupported Moniker " + t);
    }
  };
  var gn = function (e, r) {
    var t = e.read_shift(4);
    var a = e.read_shift(t, "utf16le").replace(b, "");
    return a;
  };
  var En = function (e, r) {
    var t = e.l + r;
    var a = e.read_shift(4);
    if (a !== 2) throw new Error("Unrecognized streamVersion: " + a);
    var n = e.read_shift(2);
    e.l += 2;
    var i, s, f, o, l, c, u;
    if (n & 16) i = gn(e, t - e.l);
    if (n & 128) s = gn(e, t - e.l);
    if ((n & 257) === 257) f = gn(e, t - e.l);
    if ((n & 257) === 1) o = bn(e, t - e.l);
    if (n & 8) l = gn(e, t - e.l);
    if (n & 32) c = e.read_shift(16);
    if (n & 64) u = La(e);
    e.l = t;
    var h = s || f || o;
    if (l) h += "#" + l;
    return { Target: h };
  };
  function kn(e, r) {
    var t = e.read_shift(1),
      a = e.read_shift(1),
      n = e.read_shift(1),
      i = e.read_shift(1);
    return [t, a, n, i];
  }
  function Sn(e, r) {
    var t = kn(e, r);
    t[3] = 0;
    return t;
  }
  function wn(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    var n = e.read_shift(2);
    return { r: t, c: a, ixfe: n };
  }
  function Bn(e) {
    var r = e.read_shift(2);
    var t = e.read_shift(2);
    e.l += 8;
    return { type: r, flags: t };
  }
  function Cn(e, r, t) {
    return r === 0 ? "" : dn(e, r, t);
  }
  var _n = nn;
  function Tn(e, r, t) {
    var a = t.biff > 8 ? 4 : 2;
    var n = e.read_shift(a),
      i = e.read_shift(a, "i"),
      s = e.read_shift(a, "i");
    return [n, i, s];
  }
  function xn(e, r) {
    var t = e.read_shift(2);
    var a = bt(e);
    return [t, a];
  }
  function In(e, r, t) {
    e.l += 4;
    r -= 4;
    var a = e.l + r;
    var n = ln(e, r, t);
    var i = e.read_shift(2);
    a -= e.l;
    if (i !== a)
      throw new Error("Malformed AddinUdf: padding = " + a + " != " + i);
    e.l += i;
    return n;
  }
  function An(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    var n = e.read_shift(2);
    var i = e.read_shift(2);
    return { s: { c: n, r: t }, e: { c: i, r: a } };
  }
  function yn(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    var n = e.read_shift(1);
    var i = e.read_shift(1);
    return { s: { c: n, r: t }, e: { c: i, r: a } };
  }
  var Rn = yn;
  function Dn(e, r) {
    e.l += 4;
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    var n = e.read_shift(2);
    e.l += 12;
    return [a, t, n];
  }
  function On(e, r) {
    var t = {};
    e.l += 4;
    e.l += 16;
    t.fSharedNote = e.read_shift(2);
    e.l += 4;
    return t;
  }
  function Fn(e, r) {
    var t = {};
    e.l += 4;
    e.cf = e.read_shift(2);
    return t;
  }
  function Pn(e, r) {
    e.l += 2;
    e.l += e.read_shift(2);
  }
  var Nn = {
    0: Pn,
    4: Pn,
    5: Pn,
    6: Pn,
    7: Fn,
    8: Pn,
    9: Pn,
    10: Pn,
    11: Pn,
    12: Pn,
    13: On,
    14: Pn,
    15: Pn,
    16: Pn,
    17: Pn,
    18: Pn,
    19: Pn,
    20: Pn,
    21: Dn,
  };
  function Ln(e, r, t) {
    var a = e.l + r;
    var n = [];
    while (e.l < a) {
      var i = e.read_shift(2);
      e.l -= 2;
      try {
        n.push(Nn[i](e, a - e.l));
      } catch (s) {
        e.l = a;
        return n;
      }
    }
    if (e.l != a) e.l = a;
    return n;
  }
  var Mn = nn;
  function Un(e, r) {
    var t = { BIFFVer: 0, dt: 0 };
    t.BIFFVer = e.read_shift(2);
    r -= 2;
    if (r >= 2) {
      t.dt = e.read_shift(2);
      e.l -= 2;
    }
    switch (t.BIFFVer) {
      case 1536:
      case 1280:
      case 2:
      case 7:
        break;
      default:
        if (r > 6) throw new Error("Unexpected BIFF Ver " + t.BIFFVer);
    }
    e.read_shift(r);
    return t;
  }
  function Hn(e, r) {
    if (r === 0) return 1200;
    var t;
    if ((t = e.read_shift(2)) !== 1200) {
    }
    return 1200;
  }
  function Wn(e, r, t) {
    if (t.enc) {
      e.l += r;
      return "";
    }
    var a = e.l;
    var n = hn(e, 0, t);
    e.read_shift(r + a - e.l);
    return n;
  }
  function Vn(e, r, t) {
    var a = e.read_shift(4);
    var n = e.read_shift(1) & 3;
    var i = e.read_shift(1);
    switch (i) {
      case 0:
        i = "Worksheet";
        break;
      case 1:
        i = "Macrosheet";
        break;
      case 2:
        i = "Chartsheet";
        break;
      case 6:
        i = "VBAModule";
        break;
    }
    var s = ln(e, 0, t);
    if (s.length === 0) s = "Sheet1";
    return { pos: a, hs: n, dt: i, name: s };
  }
  function zn(e, r) {
    var t = e.l + r;
    var a = e.read_shift(4);
    var n = e.read_shift(4);
    var i = [];
    for (var s = 0; s != n && e.l < t; ++s) {
      i.push(cn(e));
    }
    i.Count = a;
    i.Unique = n;
    return i;
  }
  function Xn(e, r) {
    var t = {};
    t.dsst = e.read_shift(2);
    e.l += r - 2;
    return t;
  }
  function Gn(e, r) {
    var t = {};
    t.r = e.read_shift(2);
    t.c = e.read_shift(2);
    t.cnt = e.read_shift(2) - t.c;
    var a = e.read_shift(2);
    e.l += 4;
    var n = e.read_shift(1);
    e.l += 3;
    if (n & 7) t.level = n & 7;
    if (n & 32) t.hidden = true;
    if (n & 64) t.hpt = a / 20;
    return t;
  }
  function jn(e, r) {
    var t = Bn(e);
    if (t.type != 2211) throw new Error("Invalid Future Record " + t.type);
    var a = e.read_shift(4);
    return a !== 0;
  }
  var Kn = rn;
  function Yn(e, r) {
    e.read_shift(2);
    return e.read_shift(4);
  }
  function $n(e, r, t) {
    var a = 0;
    if (!(t && t.biff == 2)) {
      a = e.read_shift(2);
    }
    var n = e.read_shift(2);
    if (t && t.biff == 2) {
      a = 1 - (n >> 15);
      n &= 32767;
    }
    var i = {
      Unsynced: a & 1,
      DyZero: (a & 2) >> 1,
      ExAsc: (a & 4) >> 2,
      ExDsc: (a & 8) >> 3,
    };
    return [i, n];
  }
  function Zn(e, r) {
    var t = e.read_shift(2),
      a = e.read_shift(2),
      n = e.read_shift(2),
      i = e.read_shift(2);
    var s = e.read_shift(2),
      f = e.read_shift(2),
      o = e.read_shift(2);
    var l = e.read_shift(2),
      c = e.read_shift(2);
    return {
      Pos: [t, a],
      Dim: [n, i],
      Flags: s,
      CurTab: f,
      FirstTab: o,
      Selected: l,
      TabRatio: c,
    };
  }
  function Qn(e, r, t) {
    var a = { dyHeight: e.read_shift(2), fl: e.read_shift(2) };
    switch ((t && t.biff) || 8) {
      case 2:
        break;
      case 3:
      case 4:
        e.l += 2;
        break;
      default:
        e.l += 10;
        break;
    }
    a.name = ln(e, 0, t);
    return a;
  }
  function Jn(e, r) {
    var t = wn(e);
    t.isst = e.read_shift(4);
    return t;
  }
  function qn(e, r, t) {
    var a = e.l + r;
    var n = wn(e, 6);
    if (t.biff == 2) e.l++;
    var i = hn(e, a - e.l, t);
    n.val = i;
    return n;
  }
  function ei(e, r, t) {
    var a = e.read_shift(2);
    var n = dn(e, 0, t);
    return [a, n];
  }
  var ri = dn;
  function ti(e, r, t) {
    var a = e.l + r;
    var n = t.biff == 8 || !t.biff ? 4 : 2;
    var i = e.read_shift(n),
      s = e.read_shift(n);
    var f = e.read_shift(2),
      o = e.read_shift(2);
    e.l = a;
    return { s: { r: i, c: f }, e: { r: s, c: o } };
  }
  function ai(e, r) {
    var t = e.read_shift(2),
      a = e.read_shift(2);
    var n = xn(e);
    return { r: t, c: a, ixfe: n[0], rknum: n[1] };
  }
  function ni(e, r) {
    var t = e.l + r - 2;
    var a = e.read_shift(2),
      n = e.read_shift(2);
    var i = [];
    while (e.l < t) i.push(xn(e));
    if (e.l !== t) throw new Error("MulRK read error");
    var s = e.read_shift(2);
    if (i.length != s - n + 1) throw new Error("MulRK length mismatch");
    return { r: a, c: n, C: s, rkrec: i };
  }
  function ii(e, r) {
    var t = e.l + r - 2;
    var a = e.read_shift(2),
      n = e.read_shift(2);
    var i = [];
    while (e.l < t) i.push(e.read_shift(2));
    if (e.l !== t) throw new Error("MulBlank read error");
    var s = e.read_shift(2);
    if (i.length != s - n + 1) throw new Error("MulBlank length mismatch");
    return { r: a, c: n, C: s, ixfe: i };
  }
  function si(e, r, t, a) {
    var n = {};
    var i = e.read_shift(4),
      s = e.read_shift(4);
    var f = e.read_shift(4),
      o = e.read_shift(2);
    n.patternType = Yt[f >> 26];
    if (!a.cellStyles) return n;
    n.alc = i & 7;
    n.fWrap = (i >> 3) & 1;
    n.alcV = (i >> 4) & 7;
    n.fJustLast = (i >> 7) & 1;
    n.trot = (i >> 8) & 255;
    n.cIndent = (i >> 16) & 15;
    n.fShrinkToFit = (i >> 20) & 1;
    n.iReadOrder = (i >> 22) & 2;
    n.fAtrNum = (i >> 26) & 1;
    n.fAtrFnt = (i >> 27) & 1;
    n.fAtrAlc = (i >> 28) & 1;
    n.fAtrBdr = (i >> 29) & 1;
    n.fAtrPat = (i >> 30) & 1;
    n.fAtrProt = (i >> 31) & 1;
    n.dgLeft = s & 15;
    n.dgRight = (s >> 4) & 15;
    n.dgTop = (s >> 8) & 15;
    n.dgBottom = (s >> 12) & 15;
    n.icvLeft = (s >> 16) & 127;
    n.icvRight = (s >> 23) & 127;
    n.grbitDiag = (s >> 30) & 3;
    n.icvTop = f & 127;
    n.icvBottom = (f >> 7) & 127;
    n.icvDiag = (f >> 14) & 127;
    n.dgDiag = (f >> 21) & 15;
    n.icvFore = o & 127;
    n.icvBack = (o >> 7) & 127;
    n.fsxButton = (o >> 14) & 1;
    return n;
  }
  function fi(e, r, t) {
    return si(e, r, 0, t);
  }
  function oi(e, r, t) {
    return si(e, r, 1, t);
  }
  function li(e, r, t) {
    var a = {};
    a.ifnt = e.read_shift(2);
    a.numFmtId = e.read_shift(2);
    a.flags = e.read_shift(2);
    a.fStyle = (a.flags >> 2) & 1;
    r -= 6;
    a.data = si(e, r, a.fStyle, t);
    return a;
  }
  function ci(e, r) {
    e.l += 4;
    var t = [e.read_shift(2), e.read_shift(2)];
    if (t[0] !== 0) t[0]--;
    if (t[1] !== 0) t[1]--;
    if (t[0] > 7 || t[1] > 7) throw new Error("Bad Gutters: " + t.join("|"));
    return t;
  }
  function ui(e, r, t) {
    var a = wn(e, 6);
    if (t.biff == 2) ++e.l;
    var n = on(e, 2);
    a.val = n;
    a.t = n === true || n === false ? "b" : "e";
    return a;
  }
  function hi(e, r) {
    var t = wn(e, 6);
    var a = Bt(e, 8);
    t.val = a;
    return t;
  }
  var di = Cn;
  function vi(e, r, t) {
    var a = e.l + r;
    var n = e.read_shift(2);
    var i = e.read_shift(2);
    t.sbcch = i;
    if (i == 1025 || i == 14849) return [i, n];
    if (i < 1 || i > 255) throw new Error("Unexpected SupBook type: " + i);
    var s = un(e, i);
    var f = [];
    while (a > e.l) f.push(hn(e));
    return [i, n, s, f];
  }
  function pi(e, r, t) {
    var a = e.read_shift(2);
    var n;
    var i = {
      fBuiltIn: a & 1,
      fWantAdvise: (a >>> 1) & 1,
      fWantPict: (a >>> 2) & 1,
      fOle: (a >>> 3) & 1,
      fOleLink: (a >>> 4) & 1,
      cf: (a >>> 5) & 1023,
      fIcon: (a >>> 15) & 1,
    };
    if (t.sbcch === 14849) n = In(e, r - 2, t);
    i.body = n || e.read_shift(r - 2);
    if (typeof n === "string") i.Name = n;
    return i;
  }
  var mi = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase",
  ];
  function bi(e, r, t) {
    var a = e.l + r;
    var n = e.read_shift(2);
    var i = e.read_shift(1);
    var s = e.read_shift(1);
    var f = e.read_shift(t && t.biff == 2 ? 1 : 2);
    var o = 0;
    if (!t || t.biff >= 5) {
      e.l += 2;
      o = e.read_shift(2);
      e.l += 4;
    }
    var l = un(e, s, t);
    if (n & 32) l = mi[l.charCodeAt(0)];
    var c = a - e.l;
    if (t && t.biff == 2) --c;
    var u = a == e.l || f == 0 ? [] : Gp(e, c, t, f);
    return { chKey: i, Name: l, itab: o, rgce: u };
  }
  function gi(e, r, t) {
    if (t.biff < 8) return Ei(e, r, t);
    var a = [],
      n = e.l + r,
      i = e.read_shift(t.biff > 8 ? 4 : 2);
    while (i-- !== 0) a.push(Tn(e, t.biff > 8 ? 12 : 6, t));
    var s = [];
    return a;
  }
  function Ei(e, r, t) {
    if (e[e.l + 1] == 3) e[e.l]++;
    var a = ln(e, r, t);
    return a.charCodeAt(0) == 3 ? a.slice(1) : a;
  }
  var ki = nn;
  function Si(e, r, t) {
    if (t.biff < 8) {
      e.l += r;
      return;
    }
    var a = e.read_shift(2);
    var n = e.read_shift(2);
    var i = un(e, a, t);
    var s = un(e, n, t);
    return [i, s];
  }
  function wi(e, r, t) {
    var a = yn(e, 6);
    e.l++;
    var n = e.read_shift(1);
    r -= 8;
    return [Kp(e, r, t), n];
  }
  function Bi(e, r, t) {
    var a = Rn(e, 6);
    switch (t.biff) {
      case 2:
        e.l++;
        r -= 7;
        break;
      case 3:
      case 4:
        e.l += 2;
        r -= 8;
        break;
      default:
        e.l += 6;
        r -= 12;
    }
    return [a, Yp(e, r, t, a)];
  }
  function Ci(e, r) {
    var t = e.read_shift(4) !== 0;
    var a = e.read_shift(4) !== 0;
    var n = e.read_shift(4);
    return [t, a, n];
  }
  function _i(e, r, t) {
    if (t.biff < 8) return;
    var a = e.read_shift(2),
      n = e.read_shift(2);
    var i = e.read_shift(2),
      s = e.read_shift(2);
    var f = dn(e, 0, t);
    if (t.biff < 8) e.read_shift(1);
    return [{ r: a, c: n }, f, s, i];
  }
  function Ti(e, r, t) {
    return _i(e, r, t);
  }
  function xi(e, r) {
    var t = [];
    var a = e.read_shift(2);
    while (a--) t.push(An(e, r));
    return t;
  }
  function Ii(e, r, t) {
    if (t && t.biff < 8) return yi(e, r, t);
    var a = Dn(e, 22);
    var n = Ln(e, r - 22, a[1]);
    return { cmo: a, ft: n };
  }
  var Ai = [];
  Ai[8] = function (e, r, t) {
    var a = e.l + r;
    e.l += 10;
    var n = e.read_shift(2);
    e.l += 4;
    var i = e.read_shift(2);
    e.l += 2;
    var s = e.read_shift(2);
    e.l += 4;
    var f = e.read_shift(1);
    e.l += f;
    e.l = a;
    return { fmt: n };
  };
  function yi(e, r, t) {
    var a = e.read_shift(4);
    var n = e.read_shift(2);
    var i = e.read_shift(2);
    var s = e.read_shift(2);
    var f = e.read_shift(2);
    var o = e.read_shift(2);
    var l = e.read_shift(2);
    var c = e.read_shift(2);
    var u = e.read_shift(2);
    var h = e.read_shift(2);
    var d = e.read_shift(2);
    var v = e.read_shift(2);
    var p = e.read_shift(2);
    e.l += 6;
    r -= 36;
    var m = [];
    m.push((Ai[n] || Er)(e, r, t));
    return { cmo: [i, n, s], ft: m };
  }
  function Ri(e, r, t) {
    var a = e.l;
    var n = "";
    try {
      e.l += 4;
      var i = (t.lastobj || { cmo: [0, 0] }).cmo[1];
      var s;
      if ([0, 5, 7, 11, 12, 14].indexOf(i) == -1) e.l += 6;
      else s = vn(e, 6, t);
      var f = e.read_shift(2);
      var o = e.read_shift(2);
      var l = Mn(e, 2);
      var c = e.read_shift(2);
      e.l += c;
      for (var u = 1; u < e.lens.length - 1; ++u) {
        if (e.l - a != e.lens[u]) throw new Error("TxO: bad continue record");
        var h = e[e.l];
        var d = un(e, e.lens[u + 1] - e.lens[u] - 1);
        n += d;
        if (n.length >= (h ? f : 2 * f)) break;
      }
      if (n.length !== f && n.length !== f * 2) {
        throw new Error("cchText: " + f + " != " + n.length);
      }
      e.l = a + r;
      return { t: n };
    } catch (v) {
      e.l = a + r;
      return { t: n };
    }
  }
  var Di = function (e, r) {
    var t = An(e, 8);
    e.l += 16;
    var a = En(e, r - 24);
    return [t, a];
  };
  var Oi = function (e, r) {
    var t = e.l + r;
    e.read_shift(2);
    var a = An(e, 8);
    var n = e.read_shift((r - 10) / 2, "dbcs-cont");
    n = n.replace(b, "");
    return [a, n];
  };
  function Fi(e, r) {
    var t = [],
      a;
    a = e.read_shift(2);
    t[0] = Kt[a] || a;
    a = e.read_shift(2);
    t[1] = Kt[a] || a;
    return t;
  }
  function Pi(e, r) {
    var t = e.read_shift(2);
    var a = [];
    while (t-- > 0) a.push(Sn(e, 8));
    return a;
  }
  function Ni(e, r) {
    var t = e.read_shift(2);
    var a = [];
    while (t-- > 0) a.push(Sn(e, 8));
    return a;
  }
  function Li(e, r) {
    e.l += 2;
    var t = { cxfs: 0, crc: 0 };
    t.cxfs = e.read_shift(2);
    t.crc = e.read_shift(4);
    return t;
  }
  function Mi(e, r, t) {
    if (!t.cellStyles) return Er(e, r);
    var a = t && t.biff >= 12 ? 4 : 2;
    var n = e.read_shift(a);
    var i = e.read_shift(a);
    var s = e.read_shift(a);
    var f = e.read_shift(a);
    var o = e.read_shift(2);
    if (a == 2) e.l += 2;
    return { s: n, e: i, w: s, ixfe: f, flags: o };
  }
  function Ui(e, r, t) {
    var a = {};
    e.l += 16;
    a.header = Bt(e, 8);
    a.footer = Bt(e, 8);
    e.l += 2;
    return a;
  }
  function Hi(e, r, t) {
    var a = { area: false };
    if (t.biff != 5) {
      e.l += r;
      return a;
    }
    var n = e.read_shift(1);
    e.l += 3;
    if (n & 16) a.area = true;
    return a;
  }
  var Wi = Er;
  var Vi = Er;
  var zi = Er;
  var Xi = an;
  var Gi = wn;
  var ji = Bt;
  var Ki = nn;
  var Yi = nn;
  var $i = Bt;
  var Zi = an;
  var Qi = nn;
  var Ji = an;
  var qi = rn;
  var es = an;
  var rs = nn;
  var ts = an;
  var as = an;
  var ns = nn;
  var is = rn;
  var ss = rn;
  var fs = rn;
  var os = rn;
  var ls = rn;
  var cs = nn;
  var us = di;
  var hs = nn;
  var ds = an;
  var vs = di;
  var ps = _n;
  var ms = rn;
  var bs = Bt;
  var gs = rn;
  var Es = an;
  var ks = nn;
  var Ss = an;
  var ws = an;
  var Bs = nn;
  var Cs = an;
  var _s = nn;
  var Ts = an;
  var xs = an;
  var Is = Bt;
  var As = sn;
  var ys = an;
  var Rs = sn;
  var Ds = hn;
  var Os = an;
  var Fs = Bt;
  var Ps = an;
  var Ns = an;
  var Ls = an;
  var Ms = Er;
  var Us = Er;
  var Hs = Er;
  var Ws = Er;
  var Vs = Er;
  var zs = Er;
  var Xs = Er;
  var Gs = Er;
  var js = Er;
  var Ks = Er;
  var Ys = Er;
  var $s = Er;
  var Zs = Er;
  var Qs = Er;
  var Js = Er;
  var qs = Er;
  var ef = Er;
  var rf = Er;
  var tf = Er;
  var af = Er;
  var nf = Er;
  var sf = Er;
  var ff = Er;
  var of = Er;
  var lf = Er;
  var cf = Er;
  var uf = Er;
  var hf = Er;
  var df = Er;
  var vf = Er;
  var pf = Er;
  var mf = Er;
  var bf = Er;
  var gf = Er;
  var Ef = Er;
  var kf = Er;
  var Sf = Er;
  var wf = Er;
  var Bf = Er;
  var Cf = Er;
  var _f = Er;
  var Tf = Er;
  var xf = Er;
  var If = Er;
  var Af = Er;
  var yf = Er;
  var Rf = Er;
  var Df = Er;
  var Of = Er;
  var Ff = Er;
  var Pf = Er;
  var Nf = Er;
  var Lf = Er;
  var Mf = Er;
  var Uf = Er;
  var Hf = Er;
  var Wf = Er;
  var Vf = Er;
  var zf = Er;
  var Xf = Er;
  var Gf = Er;
  var jf = Er;
  var Kf = Er;
  var Yf = Er;
  var $f = Er;
  var Zf = Er;
  var Qf = Er;
  var Jf = Er;
  var qf = Er;
  var eo = Er;
  var ro = Er;
  var to = Er;
  var ao = Er;
  var no = Er;
  var io = Er;
  var so = Er;
  var fo = Er;
  var oo = Er;
  var lo = Er;
  var co = Er;
  var uo = Er;
  var ho = Er;
  var vo = Er;
  var po = Er;
  var mo = Er;
  var bo = Er;
  var go = Er;
  var Eo = Er;
  var ko = Er;
  var So = Er;
  var wo = Er;
  var Bo = Er;
  var Co = Er;
  var _o = Er;
  var To = Er;
  var xo = Er;
  var Io = Er;
  var Ao = Er;
  var yo = Er;
  var Ro = Er;
  var Do = Er;
  var Oo = Er;
  var Fo = Er;
  var Po = Er;
  var No = Er;
  var Lo = Er;
  var Mo = Er;
  var Uo = Er;
  var Ho = Er;
  var Wo = Er;
  var Vo = hn;
  var zo = Er;
  var Xo = Er;
  var Go = Er;
  var jo = Er;
  var Ko = Er;
  var Yo = Er;
  var $o = Er;
  var Zo = Er;
  var Qo = Er;
  var Jo = Er;
  var qo = Er;
  var el = Er;
  var rl = Er;
  var tl = Er;
  var al = Er;
  var nl = Er;
  var il = Er;
  var sl = Er;
  var fl = Er;
  var ol = Er;
  var ll = Er;
  var cl = Er;
  var ul = Er;
  var hl = Er;
  var dl = Er;
  var vl = Er;
  var pl = Er;
  var ml = Er;
  var bl = Er;
  var gl = Er;
  var El = Er;
  var kl = Er;
  var Sl = Er;
  var wl = Er;
  var Bl = Er;
  var Cl = Er;
  var _l = Er;
  var Tl = Er;
  var xl = Er;
  var Il = Er;
  var Al = Er;
  var yl = Er;
  var Rl = Er;
  var Dl = Er;
  var Ol = Er;
  var Fl = Er;
  var Pl = Er;
  var Nl = Er;
  var Ll = Er;
  var Ml = Er;
  var Ul = Er;
  var Hl = Er;
  var Wl = Er;
  var Vl = Er;
  var zl = Er;
  var Xl = Er;
  var Gl = Er;
  var jl = Er;
  var Kl = Er;
  var Yl = Er;
  var $l = Er;
  var Zl = Er;
  var Ql = Er;
  var Jl = Er;
  var ql = Er;
  var ec = Er;
  var rc = Er;
  var tc = Er;
  var ac = Er;
  var nc = Er;
  var ic = Er;
  var sc = Er;
  var fc = Er;
  var oc = Er;
  var lc = Er;
  var cc = Er;
  var uc = Er;
  var hc = Er;
  var dc = Er;
  var vc = Er;
  var pc = Er;
  var mc = Er;
  var bc = Er;
  var gc = Er;
  var Ec = Er;
  var kc = Er;
  var Sc = Er;
  var wc = Er;
  var Bc = Er;
  var Cc = Er;
  var _c = Er;
  var Tc = Er;
  var xc = Er;
  var Ic = Er;
  var Ac = Er;
  var yc = Er;
  var Rc = Er;
  var Dc = Er;
  var Oc = Er;
  var Fc = Er;
  var Pc = Er;
  var Nc = Er;
  var Lc = Er;
  var Mc = Er;
  var Uc = Er;
  var Hc = Er;
  var Wc = Er;
  var Vc = Er;
  var zc = Er;
  var Xc = Er;
  var Gc = Er;
  var jc = Er;
  var Kc = Er;
  var Yc = Er;
  var $c = Er;
  var Zc = Er;
  var Qc = Er;
  var Jc = Er;
  var qc = Er;
  var eu = Er;
  var ru = Er;
  var tu = Er;
  var au = Er;
  var nu = Er;
  var iu = Er;
  var su = Er;
  var fu = Er;
  var ou = Er;
  var lu = Er;
  var cu = Er;
  var uu = Er;
  var hu = Er;
  var du = Er;
  var vu = Er;
  var pu = Er;
  var mu = Er;
  var bu = Er;
  var gu = Er;
  var Eu = Er;
  var ku = Er;
  var Su = Er;
  var wu = Er;
  function Bu(e, r, t) {
    var a = e.l + r;
    var n = e.read_shift(2);
    var i = e.read_shift(2);
    var s = e.read_shift(4);
    var f = { fmt: n, env: i, len: s, data: e.slice(e.l, e.l + s) };
    e.l += s;
    return f;
  }
  function Cu(e) {
    var r = e.read_shift(1);
    return e.read_shift(r, "sbcs-cont");
  }
  function _u(e, r, t) {
    var a = wn(e, 6);
    ++e.l;
    var n = dn(e, r - 7, t);
    a.t = "str";
    a.val = n;
    return a;
  }
  function Tu(e, r, t) {
    var a = wn(e, 6);
    ++e.l;
    var n = Bt(e, 8);
    a.t = "n";
    a.val = n;
    return a;
  }
  function xu(e, r) {
    var t = wn(e, 6);
    ++e.l;
    var a = e.read_shift(2);
    t.t = "n";
    t.val = a;
    return t;
  }
  function Iu(e, r) {
    var t = e.read_shift(1);
    if (t === 0) {
      e.l++;
      return "";
    }
    return e.read_shift(t, "sbcs-cont");
  }
  function Au(e, r) {
    e.l += 6;
    e.l += 2;
    e.l += 1;
    e.l += 3;
    e.l += 1;
    e.l += r - 13;
  }
  function yu(e, r, t) {
    var a = e.l + r;
    var n = wn(e, 6);
    var i = e.read_shift(2);
    var s = un(e, i, t);
    e.l = a;
    n.t = "str";
    n.val = s;
    return n;
  }
  var Ru = (function () {
    var e = {
      1: 437,
      2: 850,
      3: 1252,
      4: 1e4,
      100: 852,
      101: 866,
      102: 865,
      103: 861,
      104: 895,
      105: 620,
      106: 737,
      107: 857,
      120: 950,
      121: 949,
      122: 936,
      123: 932,
      124: 874,
      125: 1255,
      126: 1256,
      150: 10007,
      151: 10029,
      152: 10006,
      200: 1250,
      201: 1251,
      202: 1254,
      203: 1253,
      0: 20127,
      8: 865,
      9: 437,
      10: 850,
      11: 437,
      13: 437,
      14: 850,
      15: 437,
      16: 850,
      17: 437,
      18: 850,
      19: 932,
      20: 850,
      21: 437,
      22: 850,
      23: 865,
      24: 437,
      25: 437,
      26: 850,
      27: 437,
      28: 863,
      29: 850,
      31: 852,
      34: 852,
      35: 852,
      36: 860,
      37: 850,
      38: 866,
      55: 850,
      64: 852,
      77: 936,
      78: 949,
      79: 950,
      80: 874,
      87: 1252,
      88: 1252,
      89: 1252,
      255: 16969,
    };
    function r(r, t) {
      var a = [];
      var n = v(1);
      switch (t.type) {
        case "base64":
          n = p(h.decode(r));
          break;
        case "binary":
          n = p(r);
          break;
        case "buffer":
        case "array":
          n = r;
          break;
      }
      gr(n, 0);
      var i = n.read_shift(1);
      var s = false;
      var f = false;
      switch (i) {
        case 2:
        case 3:
          break;
        case 48:
          f = true;
          s = true;
          break;
        case 49:
          f = true;
          break;
        case 131:
          s = true;
          break;
        case 139:
          s = true;
          break;
        case 245:
          s = true;
          break;
        default:
          throw new Error("DBF Unsupported Version: " + i.toString(16));
      }
      var o = new Date(),
        l = 0,
        c = 0;
      if (i == 2) l = n.read_shift(2);
      o = new Date(
        n.read_shift(1) + 1900,
        n.read_shift(1) - 1,
        n.read_shift(1)
      );
      if (i != 2) l = n.read_shift(4);
      if (i != 2) c = n.read_shift(2);
      var u = n.read_shift(2);
      var d = 0,
        m = 1252;
      if (i != 2) {
        n.l += 16;
        d = n.read_shift(1);
        if (n[n.l] !== 0) m = e[n[n.l]];
        n.l += 1;
        n.l += 2;
      }
      var b = [],
        g = {};
      var E = c - 10 - (f ? 264 : 0);
      while (i == 2 ? n.l < n.length && n[n.l] != 13 : n.l < E) {
        g = {};
        g.name = cptable.utils
          .decode(m, n.slice(n.l, n.l + 10))
          .replace(/[\u0000\r\n].*$/g, "");
        n.l += 11;
        g.type = String.fromCharCode(n.read_shift(1));
        if (i != 2) g.offset = n.read_shift(4);
        g.len = n.read_shift(1);
        if (i == 2) g.offset = n.read_shift(2);
        g.dec = n.read_shift(1);
        if (g.name.length) b.push(g);
        if (i != 2) n.l += 14;
        switch (g.type) {
          case "C":
            break;
          case "D":
            break;
          case "F":
            break;
          case "I":
            break;
          case "L":
            break;
          case "M":
            break;
          case "N":
            break;
          case "T":
            break;
          case "Y":
            break;
          case "0":
            break;
          case "+":
            break;
          case "@":
            break;
          default:
            throw new Error("Unknown Field Type: " + g.type);
        }
      }
      if (n[n.l] !== 13) n.l = c - 1;
      else if (i == 2) n.l = 521;
      if (i != 2) {
        if (n.read_shift(1) !== 13)
          throw new Error("DBF Terminator not found " + n.l + " " + n[n.l]);
        n.l = c;
      }
      var k = 0,
        S = 0;
      a[0] = [];
      for (S = 0; S != b.length; ++S) a[0][S] = b[S].name;
      while (l-- > 0) {
        if (n[n.l] === 42) {
          n.l += u;
          continue;
        }
        ++n.l;
        a[++k] = [];
        S = 0;
        for (S = 0; S != b.length; ++S) {
          var w = n.slice(n.l, n.l + b[S].len);
          n.l += b[S].len;
          gr(w, 0);
          var B = cptable.utils.decode(m, w);
          switch (b[S].type) {
            case "C":
              a[k][S] = cptable.utils.decode(m, w);
              a[k][S] = a[k][S].trim();
              break;
            case "D":
              if (B.length === 8)
                a[k][S] = new Date(
                  +B.substr(0, 4),
                  +B.substr(4, 2) - 1,
                  +B.substr(6, 2)
                );
              else a[k][S] = B;
              break;
            case "F":
              a[k][S] = parseFloat(B.trim());
              break;
            case "I":
              a[k][S] = w.read_shift(4, "i");
              break;
            case "L":
              switch (B.toUpperCase()) {
                case "Y":
                case "T":
                  a[k][S] = true;
                  break;
                case "N":
                case "F":
                  a[k][S] = false;
                  break;
                case " ":
                case "?":
                  a[k][S] = false;
                  break;
                default:
                  throw new Error("DBF Unrecognized L:|" + B + "|");
              }
              break;
            case "M":
              if (!s)
                throw new Error(
                  "DBF Unexpected MEMO for type " + i.toString(16)
                );
              a[k][S] = "##MEMO##" + w.read_shift(4);
              break;
            case "N":
              a[k][S] = +B.replace(/\u0000/g, "").trim();
              break;
            case "T":
              var C = w.read_shift(4),
                _ = w.read_shift(4);
              throw new Error(C + " | " + _);
            case "Y":
              a[k][S] = w.read(4, "i") / 1e4;
              break;
            case "0":
              if (b[S].name === "_NullFlags") break;
            default:
              throw new Error("DBF Unsupported data type " + b[S].type);
          }
        }
      }
      if (i != 2)
        if (n.l < n.length && n[n.l++] != 26)
          throw new Error(
            "DBF EOF Marker missing " +
              (n.l - 1) +
              " of " +
              n.length +
              " " +
              n[n.l - 1].toString(16)
          );
      return a;
    }
    function t(e, t) {
      var a = t || {};
      if (!a.dateNF) a.dateNF = "yyyymmdd";
      return Qr(r(e, a), a);
    }
    function a(e, r) {
      try {
        return Zr(t(e, r), r);
      } catch (a) {
        if (r && r.WTF) throw a;
      }
      return { SheetNames: [], Sheets: {} };
    }
    return { to_workbook: a, to_sheet: t };
  })();
  var Du = (function () {
    function e(e, t) {
      switch (t.type) {
        case "base64":
          return r(h.decode(e), t);
        case "binary":
          return r(e, t);
        case "buffer":
          return r(e.toString("binary"), t);
        case "array":
          return r(W(e), t);
      }
      throw new Error("Unrecognized type " + t.type);
    }
    function r(e, r) {
      var t = e.split(/[\n\r]+/),
        a = -1,
        n = -1,
        i = 0,
        s = 0,
        f = [];
      var o = [];
      var l = null;
      var c = {},
        u = [],
        h = [],
        d = [];
      var v = 0,
        p;
      for (; i !== t.length; ++i) {
        v = 0;
        var m = t[i].trim();
        var b = m
          .replace(/;;/g, "")
          .split(";")
          .map(function (e) {
            return e.replace(/\u0001/g, ";");
          });
        var g = b[0],
          k;
        if (m.length > 0)
          switch (g) {
            case "ID":
              break;
            case "E":
              break;
            case "B":
              break;
            case "O":
              break;
            case "P":
              if (b[1].charAt(0) == "P")
                o.push(m.substr(3).replace(/;;/g, ";"));
              break;
            case "C":
              for (s = 1; s < b.length; ++s)
                switch (b[s].charAt(0)) {
                  case "X":
                    n = parseInt(b[s].substr(1)) - 1;
                    break;
                  case "Y":
                    a = parseInt(b[s].substr(1)) - 1;
                    n = 0;
                    for (p = f.length; p <= a; ++p) f[p] = [];
                    break;
                  case "K":
                    k = b[s].substr(1);
                    if (k.charAt(0) === '"') k = k.substr(1, k.length - 2);
                    else if (k === "TRUE") k = true;
                    else if (k === "FALSE") k = false;
                    else if (+k === +k) {
                      k = +k;
                      if (l !== null && E.is_date(l)) k = N(k);
                    } else if (!isNaN(G(k).getDate())) {
                      k = H(k);
                    }
                    f[a][n] = k;
                    l = null;
                    break;
                  case "E":
                    var S = mv(b[s].substr(1), { r: a, c: n });
                    f[a][n] = [f[a][n], S];
                    break;
                  default:
                    if (r && r.WTF) throw new Error("SYLK bad record " + m);
                }
              break;
            case "F":
              var w = 0;
              for (s = 1; s < b.length; ++s)
                switch (b[s].charAt(0)) {
                  case "X":
                    n = parseInt(b[s].substr(1)) - 1;
                    ++w;
                    break;
                  case "Y":
                    a = parseInt(b[s].substr(1)) - 1;
                    for (p = f.length; p <= a; ++p) f[p] = [];
                    break;
                  case "M":
                    v = parseInt(b[s].substr(1)) / 20;
                    break;
                  case "F":
                    break;
                  case "P":
                    l = o[parseInt(b[s].substr(1))];
                    break;
                  case "S":
                    break;
                  case "D":
                    break;
                  case "N":
                    break;
                  case "W":
                    d = b[s].substr(1).split(" ");
                    for (p = parseInt(d[0], 10); p <= parseInt(d[1], 10); ++p) {
                      v = parseInt(d[2], 10);
                      h[p - 1] = v == 0 ? { hidden: true } : { wch: v };
                      Hh(h[p - 1]);
                    }
                    break;
                  case "C":
                    n = parseInt(b[s].substr(1)) - 1;
                    if (!h[n]) h[n] = {};
                    break;
                  case "R":
                    a = parseInt(b[s].substr(1)) - 1;
                    if (!u[a]) u[a] = {};
                    if (v > 0) {
                      u[a].hpt = v;
                      u[a].hpx = Xh(v);
                    } else if (v == 0) u[a].hidden = true;
                    break;
                  default:
                    if (r && r.WTF) throw new Error("SYLK bad record " + m);
                }
              if (w < 1) l = null;
              break;
            default:
              if (r && r.WTF) throw new Error("SYLK bad record " + m);
          }
      }
      if (u.length > 0) c["!rows"] = u;
      if (h.length > 0) c["!cols"] = h;
      return [f, c];
    }
    function t(r, t) {
      var a = e(r, t);
      var n = a[0],
        i = a[1];
      var s = Qr(n, t);
      I(i).forEach(function (e) {
        s[e] = i[e];
      });
      return s;
    }
    function a(e, r) {
      return Zr(t(e, r), r);
    }
    function n(e, r, t, a, n) {
      var i = "C;Y" + (t + 1) + ";X" + (a + 1) + ";K";
      switch (e.t) {
        case "n":
          i += e.v || 0;
          if (e.f && !e.F) i += ";E" + gv(e.f, { r: t, c: a });
          break;
        case "b":
          i += e.v ? "TRUE" : "FALSE";
          break;
        case "e":
          i += e.w || e.v;
          break;
        case "d":
          i += '"' + (e.w || e.v) + '"';
          break;
        case "s":
          i += '"' + e.v.replace(/"/g, "") + '"';
          break;
      }
      return i;
    }
    function i(e, r) {
      r.forEach(function (r, t) {
        var a = "F;W" + (t + 1) + " " + (t + 1) + " ";
        if (r.hidden) a += "0";
        else {
          if (typeof r.width == "number") r.wpx = Dh(r.width);
          if (typeof r.wpx == "number") r.wch = Oh(r.wpx);
          if (typeof r.wch == "number") a += Math.round(r.wch);
        }
        if (a.charAt(a.length - 1) != " ") e.push(a);
      });
    }
    function s(e, r) {
      r.forEach(function (r, t) {
        var a = "F;";
        if (r.hidden) a += "M0;";
        else if (r.hpt) a += "M" + 20 * r.hpt + ";";
        else if (r.hpx) a += "M" + 20 * zh(r.hpx) + ";";
        if (a.length > 2) e.push(a + "R" + (t + 1));
      });
    }
    function f(e, r) {
      var t = ["ID;PWXL;N;E"],
        a = [];
      var f = Gr(e["!ref"]),
        o;
      var l = Array.isArray(e);
      var c = "\r\n";
      t.push("P;PGeneral");
      t.push("F;P0;DG0G8;M255");
      if (e["!cols"]) i(t, e["!cols"]);
      if (e["!rows"]) s(t, e["!rows"]);
      t.push(
        "B;Y" +
          (f.e.r - f.s.r + 1) +
          ";X" +
          (f.e.c - f.s.c + 1) +
          ";D" +
          [f.s.c, f.s.r, f.e.c, f.e.r].join(" ")
      );
      for (var u = f.s.r; u <= f.e.r; ++u) {
        for (var h = f.s.c; h <= f.e.c; ++h) {
          var d = Vr({ r: u, c: h });
          o = l ? (e[u] || [])[h] : e[d];
          if (!o || (o.v == null && (!o.f || o.F))) continue;
          a.push(n(o, e, u, h, r));
        }
      }
      return t.join(c) + c + a.join(c) + c + "E" + c;
    }
    return { to_workbook: a, to_sheet: t, from_sheet: f };
  })();
  var Ou = (function () {
    function e(e, t) {
      switch (t.type) {
        case "base64":
          return r(h.decode(e), t);
        case "binary":
          return r(e, t);
        case "buffer":
          return r(e.toString("binary"), t);
        case "array":
          return r(W(e), t);
      }
      throw new Error("Unrecognized type " + t.type);
    }
    function r(e, r) {
      var t = e.split("\n"),
        a = -1,
        n = -1,
        i = 0,
        s = [];
      for (; i !== t.length; ++i) {
        if (t[i].trim() === "BOT") {
          s[++a] = [];
          n = 0;
          continue;
        }
        if (a < 0) continue;
        var f = t[i].trim().split(",");
        var o = f[0],
          l = f[1];
        ++i;
        var c = t[i].trim();
        switch (+o) {
          case -1:
            if (c === "BOT") {
              s[++a] = [];
              n = 0;
              continue;
            } else if (c !== "EOD")
              throw new Error("Unrecognized DIF special command " + c);
            break;
          case 0:
            if (c === "TRUE") s[a][n] = true;
            else if (c === "FALSE") s[a][n] = false;
            else if (+l == +l) s[a][n] = +l;
            else if (!isNaN(G(l).getDate())) s[a][n] = H(l);
            else s[a][n] = l;
            ++n;
            break;
          case 1:
            c = c.substr(1, c.length - 2);
            s[a][n++] = c !== "" ? c : null;
            break;
        }
        if (c === "EOD") break;
      }
      return s;
    }
    function t(r, t) {
      return Qr(e(r, t), t);
    }
    function a(e, r) {
      return Zr(t(e, r), r);
    }
    var n = (function () {
      var e = function t(e, r, a, n, i) {
        e.push(r);
        e.push(a + "," + n);
        e.push('"' + i.replace(/"/g, '""') + '"');
      };
      var r = function a(e, r, t, n) {
        e.push(r + "," + t);
        e.push(r == 1 ? '"' + n.replace(/"/g, '""') + '"' : n);
      };
      return function n(t, a) {
        var n = [];
        var i = Gr(t["!ref"]),
          s;
        var f = Array.isArray(t);
        e(n, "TABLE", 0, 1, "sheetjs");
        e(n, "VECTORS", 0, i.e.r - i.s.r + 1, "");
        e(n, "TUPLES", 0, i.e.c - i.s.c + 1, "");
        e(n, "DATA", 0, 0, "");
        for (var o = i.s.r; o <= i.e.r; ++o) {
          r(n, -1, 0, "BOT");
          for (var l = i.s.c; l <= i.e.c; ++l) {
            var c = Vr({ r: o, c: l });
            s = f ? (t[o] || [])[l] : t[c];
            if (!s) {
              r(n, 1, 0, "");
              continue;
            }
            switch (s.t) {
              case "n":
                var h = u ? s.w : s.v;
                if (!h && s.v != null) h = s.v;
                if (h == null) {
                  if (u && s.f && !s.F) r(n, 1, 0, "=" + s.f);
                  else r(n, 1, 0, "");
                } else r(n, 0, h, "V");
                break;
              case "b":
                r(n, 0, s.v ? 1 : 0, s.v ? "TRUE" : "FALSE");
                break;
              case "s":
                r(n, 1, 0, !u || isNaN(s.v) ? s.v : '="' + s.v + '"');
                break;
              case "d":
                if (!s.w) s.w = E.format(s.z || E._table[14], P(H(s.v)));
                if (u) r(n, 0, s.w, "V");
                else r(n, 1, 0, s.w);
                break;
              default:
                r(n, 1, 0, "");
            }
          }
        }
        r(n, -1, 0, "EOD");
        var d = "\r\n";
        var v = n.join(d);
        return v;
      };
    })();
    return { to_workbook: a, to_sheet: t, from_sheet: n };
  })();
  var Fu = (function () {
    function e(e, r, t, a, n) {
      if (n.raw) r[t][a] = e;
      else if (e === "TRUE") r[t][a] = true;
      else if (e === "FALSE") r[t][a] = false;
      else if (e === "") {
      } else if (+e == +e) r[t][a] = +e;
      else if (!isNaN(G(e).getDate())) r[t][a] = H(e);
      else r[t][a] = e;
    }
    function r(r, t) {
      var a = t || {};
      var n = [];
      if (!r || r.length === 0) return n;
      var i = r.split(/[\r\n]/);
      var s = i.length - 1;
      while (s >= 0 && i[s].length === 0) --s;
      var f = 10,
        o = 0;
      var l = 0;
      for (; l <= s; ++l) {
        o = i[l].indexOf(" ");
        if (o == -1) o = i[l].length;
        else o++;
        f = Math.max(f, o);
      }
      for (l = 0; l <= s; ++l) {
        n[l] = [];
        var c = 0;
        e(i[l].slice(0, f).trim(), n, l, c, a);
        for (c = 1; c <= (i[l].length - f) / 10 + 1; ++c)
          e(i[l].slice(f + (c - 1) * 10, f + c * 10).trim(), n, l, c, a);
      }
      return n;
    }
    function t(e, r) {
      var t = r || {};
      var a = "";
      if (c != null && t.dense == null) t.dense = c;
      var n = t.dense ? [] : {};
      var i = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
      if (e.substr(0, 4) == "sep=" && e.charCodeAt(5) == 10) {
        a = e.charAt(4);
        e = e.substr(6);
      } else if (e.substr(0, 1024).indexOf("\t") == -1) a = ",";
      else a = "\t";
      var s = 0,
        f = 0,
        o = 0;
      var l = 0,
        u = 0,
        h = a.charCodeAt(0),
        d = false,
        v = 0;
      e = e.replace(/\r\n/gm, "\n");
      var p = t.dateNF != null ? B(t.dateNF) : null;
      function m() {
        var r = e.slice(l, u);
        var a = {};
        if (t.raw) {
          a.t = "s";
          a.v = r;
        } else if (r.charCodeAt(0) == 61) {
          a.t = "n";
          a.f = r.substr(1);
        } else if (r == "TRUE") {
          a.t = "b";
          a.v = true;
        } else if (r == "FALSE") {
          a.t = "b";
          a.v = false;
        } else if (!isNaN((o = +r))) {
          a.t = "n";
          a.w = r;
          a.v = o;
        } else if (!isNaN(G(r).getDate()) || (p && r.match(p))) {
          a.z = t.dateNF || E._table[14];
          var c = 0;
          if (p && r.match(p)) {
            r = C(r, t.dateNF, r.match(p) || []);
            c = 1;
          }
          if (t.cellDates) {
            a.t = "d";
            a.v = H(r, c);
          } else {
            a.t = "n";
            a.v = P(H(r, c));
          }
          a.w = E.format(a.z, a.v instanceof Date ? P(a.v) : a.v);
        } else {
          a.t = "s";
          if (r.charAt(0) == '"' && r.charAt(r.length - 1) == '"')
            r = r.slice(1, -1).replace(/""/g, '"');
          a.v = r;
        }
        if (t.dense) {
          if (!n[s]) n[s] = [];
          n[s][f] = a;
        } else n[Vr({ c: f, r: s })] = a;
        l = u + 1;
        if (i.e.c < f) i.e.c = f;
        if (i.e.r < s) i.e.r = s;
        if (v == h) ++f;
        else {
          f = 0;
          ++s;
        }
      }
      for (; u < e.length; ++u)
        switch ((v = e.charCodeAt(u))) {
          case 34:
            d = !d;
            break;
          case h:
          case 10:
          case 13:
            if (!d) m();
            break;
          default:
            break;
        }
      if (u - l > 0) m();
      n["!ref"] = jr(i);
      return n;
    }
    function a(e, a) {
      if (e.substr(0, 4) == "sep=") return t(e, a);
      if (e.indexOf("\t") >= 0 || e.indexOf(",") >= 0) return t(e, a);
      return Qr(r(e, a), a);
    }
    function n(e, r) {
      var t = "",
        n = tk(e, r);
      switch (r.type) {
        case "base64":
          t = h.decode(e);
          break;
        case "binary":
          t = e;
          break;
        case "buffer":
          t = e.toString("binary");
          break;
        case "array":
          t = W(e);
          break;
        default:
          throw new Error("Unrecognized type " + r.type);
      }
      if (n[0] == 239 && n[1] == 187 && n[2] == 191) t = ke(t);
      return a(t, r);
    }
    function i(e, r) {
      return Zr(n(e, r), r);
    }
    function s(e, r) {
      var t = [];
      var a = Gr(e["!ref"]),
        n;
      var i = Array.isArray(e);
      for (var s = a.s.r; s <= a.e.r; ++s) {
        var f = [];
        for (var o = a.s.c; o <= a.e.c; ++o) {
          var l = Vr({ r: s, c: o });
          n = i ? (e[s] || [])[o] : e[l];
          if (!n || n.v == null) {
            f.push("          ");
            continue;
          }
          var c = (n.w || ($r(n), n.w) || "").substr(0, 10);
          while (c.length < 10) c += " ";
          f.push(c + (o == 0 ? " " : ""));
        }
        t.push(f.join(""));
      }
      return t.join("\n");
    }
    return { to_workbook: i, to_sheet: n, from_sheet: s };
  })();
  function Pu(e, r) {
    var t = r || {},
      a = !!t.WTF;
    t.WTF = true;
    try {
      var n = Du.to_workbook(e, t);
      t.WTF = a;
      return n;
    } catch (i) {
      t.WTF = a;
      if (!i.message.match(/SYLK bad record ID/) && a) throw i;
      return Fu.to_workbook(e, r);
    }
  }
  var Nu = (function () {
    function e(e, r, t) {
      if (!e) return;
      gr(e, e.l || 0);
      var a = t.Enum || S;
      while (e.l < e.length) {
        var n = e.read_shift(2);
        var i = a[n] || a[255];
        var s = e.read_shift(2);
        var f = e.l + s;
        var o = i.f(e, s, t);
        e.l = f;
        if (r(o, i.n, n)) return;
      }
    }
    function r(e, r) {
      switch (r.type) {
        case "base64":
          return t(p(h.decode(e)), r);
        case "binary":
          return t(p(e), r);
        case "buffer":
        case "array":
          return t(e, r);
      }
      throw "Unsupported type " + r.type;
    }
    function t(r, t) {
      if (!r) return r;
      var a = t || {};
      if (c != null && a.dense == null) a.dense = c;
      var n = a.dense ? [] : {},
        i = "Sheet1",
        s = 0;
      var f = {},
        o = [i];
      var l = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
      if (r[2] == 2) a.Enum = S;
      else if (r[2] == 26) a.Enum = w;
      else if (r[2] == 14) {
        a.Enum = w;
        a.qpro = true;
        r.l = 0;
      } else throw new Error("Unrecognized LOTUS BOF " + r[2]);
      e(
        r,
        function (e, t, c) {
          if (r[2] == 2)
            switch (c) {
              case 0:
                a.vers = e;
                if (e >= 4096) a.qpro = true;
                break;
              case 6:
                l = e;
                break;
              case 15:
                if (!a.qpro) e[1].v = e[1].v.substr(1);
              case 13:
              case 14:
              case 16:
              case 51:
                if (
                  c == 14 &&
                  (e[2] & 112) == 112 &&
                  (e[2] & 15) > 1 &&
                  (e[2] & 15) < 15
                ) {
                  e[1].z = a.dateNF || E._table[14];
                  if (a.cellDates) {
                    e[1].t = "d";
                    e[1].v = N(e[1].v);
                  }
                }
                if (a.dense) {
                  if (!n[e[0].r]) n[e[0].r] = [];
                  n[e[0].r][e[0].c] = e[1];
                } else n[Vr(e[0])] = e[1];
                break;
            }
          else
            switch (c) {
              case 22:
                e[1].v = e[1].v.substr(1);
              case 23:
              case 24:
              case 25:
              case 37:
              case 39:
              case 40:
                if (e[3] > s) {
                  n["!ref"] = jr(l);
                  f[i] = n;
                  n = a.dense ? [] : {};
                  l = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
                  s = e[3];
                  i = "Sheet" + (s + 1);
                  o.push(i);
                }
                n[Vr(e[0])] = e[1];
                if (l.e.c < e[0].c) l.e.c = e[0].c;
                if (l.e.r < e[0].r) l.e.r = e[0].r;
                break;
              default:
                break;
            }
        },
        a
      );
      n["!ref"] = jr(l);
      f[i] = n;
      return { SheetNames: o, Sheets: f };
    }
    function a(e, r) {
      var t = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
      t.s.c = e.read_shift(2);
      t.s.r = e.read_shift(2);
      t.e.c = e.read_shift(2);
      t.e.r = e.read_shift(2);
      if (t.s.c == 65535) t.s.c = t.e.c = t.s.r = t.e.r = 0;
      return t;
    }
    function n(e, r, t) {
      var a = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
      if (t.qpro && t.vers != 20768) {
        a[0].c = e.read_shift(1);
        e.l++;
        a[0].r = e.read_shift(2);
        e.l += 2;
      } else {
        a[2] = e.read_shift(1);
        a[0].c = e.read_shift(2);
        a[0].r = e.read_shift(2);
      }
      return a;
    }
    function i(e, r, t) {
      var a = e.l + r;
      var i = n(e, r, t);
      i[1].t = "s";
      if (t.vers == 20768) {
        e.l++;
        var s = e.read_shift(1);
        i[1].v = e.read_shift(s, "utf8");
        return i;
      }
      if (t.qpro) e.l++;
      i[1].v = e.read_shift(a - e.l, "cstr");
      return i;
    }
    function s(e, r, t) {
      var a = n(e, r, t);
      a[1].v = e.read_shift(2, "i");
      return a;
    }
    function f(e, r, t) {
      var a = n(e, r, t);
      a[1].v = e.read_shift(8, "f");
      return a;
    }
    function o(e, r, t) {
      var a = e.l + r;
      var i = n(e, r, t);
      i[1].v = e.read_shift(8, "f");
      if (t.qpro) e.l = a;
      else {
        var s = e.read_shift(2);
        e.l += s;
      }
      return i;
    }
    function l(e, r) {
      var t = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
      t[0].r = e.read_shift(2);
      t[3] = e[e.l++];
      t[0].c = e[e.l++];
      return t;
    }
    function u(e, r) {
      var t = l(e, r);
      t[1].t = "s";
      t[1].v = e.read_shift(r - 4, "cstr");
      return t;
    }
    function d(e, r) {
      var t = l(e, r);
      t[1].v = e.read_shift(2);
      var a = t[1].v >> 1;
      if (t[1].v & 1) {
        switch (a & 7) {
          case 1:
            a = (a >> 3) * 500;
            break;
          case 2:
            a = (a >> 3) / 20;
            break;
          case 4:
            a = (a >> 3) / 2e3;
            break;
          case 6:
            a = (a >> 3) / 16;
            break;
          case 7:
            a = (a >> 3) / 64;
            break;
          default:
            throw "unknown NUMBER_18 encoding " + (a & 7);
        }
      }
      t[1].v = a;
      return t;
    }
    function v(e, r) {
      var t = l(e, r);
      var a = e.read_shift(4);
      var n = e.read_shift(4);
      var i = e.read_shift(2);
      if (i == 65535) {
        t[1].v = 0;
        return t;
      }
      var s = i & 32768;
      i = (i & 32767) - 16446;
      t[1].v =
        (i > 0 ? n << i : n >>> -i) +
        (i > -32 ? a << (i + 32) : a >>> -(i + 32));
      return t;
    }
    function m(e, r) {
      var t = v(e, 14);
      e.l += r - 14;
      return t;
    }
    function b(e, r) {
      var t = l(e, r);
      var a = e.read_shift(4);
      t[1].v = a >> 6;
      return t;
    }
    function g(e, r) {
      var t = l(e, r);
      var a = e.read_shift(8, "f");
      t[1].v = a;
      return t;
    }
    function k(e, r) {
      var t = g(e, 14);
      e.l += r - 10;
      return t;
    }
    var S = {
      0: { n: "BOF", f: nn },
      1: { n: "EOF", f: Er },
      2: { n: "CALCMODE", f: Er },
      3: { n: "CALCORDER", f: Er },
      4: { n: "SPLIT", f: Er },
      5: { n: "SYNC", f: Er },
      6: { n: "RANGE", f: a },
      7: { n: "WINDOW1", f: Er },
      8: { n: "COLW1", f: Er },
      9: { n: "WINTWO", f: Er },
      10: { n: "COLW2", f: Er },
      11: { n: "NAME", f: Er },
      12: { n: "BLANK", f: Er },
      13: { n: "INTEGER", f: s },
      14: { n: "NUMBER", f: f },
      15: { n: "LABEL", f: i },
      16: { n: "FORMULA", f: o },
      24: { n: "TABLE", f: Er },
      25: { n: "ORANGE", f: Er },
      26: { n: "PRANGE", f: Er },
      27: { n: "SRANGE", f: Er },
      28: { n: "FRANGE", f: Er },
      29: { n: "KRANGE1", f: Er },
      32: { n: "HRANGE", f: Er },
      35: { n: "KRANGE2", f: Er },
      36: { n: "PROTEC", f: Er },
      37: { n: "FOOTER", f: Er },
      38: { n: "HEADER", f: Er },
      39: { n: "SETUP", f: Er },
      40: { n: "MARGINS", f: Er },
      41: { n: "LABELFMT", f: Er },
      42: { n: "TITLES", f: Er },
      43: { n: "SHEETJS", f: Er },
      45: { n: "GRAPH", f: Er },
      46: { n: "NGRAPH", f: Er },
      47: { n: "CALCCOUNT", f: Er },
      48: { n: "UNFORMATTED", f: Er },
      49: { n: "CURSORW12", f: Er },
      50: { n: "WINDOW", f: Er },
      51: { n: "STRING", f: i },
      55: { n: "PASSWORD", f: Er },
      56: { n: "LOCKED", f: Er },
      60: { n: "QUERY", f: Er },
      61: { n: "QUERYNAME", f: Er },
      62: { n: "PRINT", f: Er },
      63: { n: "PRINTNAME", f: Er },
      64: { n: "GRAPH2", f: Er },
      65: { n: "GRAPHNAME", f: Er },
      66: { n: "ZOOM", f: Er },
      67: { n: "SYMSPLIT", f: Er },
      68: { n: "NSROWS", f: Er },
      69: { n: "NSCOLS", f: Er },
      70: { n: "RULER", f: Er },
      71: { n: "NNAME", f: Er },
      72: { n: "ACOMM", f: Er },
      73: { n: "AMACRO", f: Er },
      74: { n: "PARSE", f: Er },
      255: { n: "", f: Er },
    };
    var w = {
      0: { n: "BOF", f: Er },
      1: { n: "EOF", f: Er },
      3: { n: "??", f: Er },
      4: { n: "??", f: Er },
      5: { n: "??", f: Er },
      6: { n: "??", f: Er },
      7: { n: "??", f: Er },
      9: { n: "??", f: Er },
      10: { n: "??", f: Er },
      11: { n: "??", f: Er },
      12: { n: "??", f: Er },
      14: { n: "??", f: Er },
      15: { n: "??", f: Er },
      16: { n: "??", f: Er },
      17: { n: "??", f: Er },
      18: { n: "??", f: Er },
      19: { n: "??", f: Er },
      21: { n: "??", f: Er },
      22: { n: "LABEL16", f: u },
      23: { n: "NUMBER17", f: v },
      24: { n: "NUMBER18", f: d },
      25: { n: "FORMULA19", f: m },
      26: { n: "??", f: Er },
      27: { n: "??", f: Er },
      28: { n: "??", f: Er },
      29: { n: "??", f: Er },
      30: { n: "??", f: Er },
      31: { n: "??", f: Er },
      33: { n: "??", f: Er },
      37: { n: "NUMBER25", f: b },
      39: { n: "NUMBER27", f: g },
      40: { n: "FORMULA28", f: k },
      255: { n: "", f: Er },
    };
    return { to_workbook: r };
  })();
  var Lu = {
    0: 1252,
    1: 65001,
    2: 65001,
    77: 1e4,
    128: 932,
    129: 949,
    130: 1361,
    134: 936,
    136: 950,
    161: 1253,
    162: 1254,
    163: 1258,
    177: 1255,
    178: 1256,
    186: 1257,
    204: 1251,
    222: 874,
    238: 1250,
    255: 1252,
    69: 6969,
  };
  var Mu = (function Zk() {
    var e = Ce("t"),
      r = Ce("rPr"),
      t = /<(?:\w+:)?r>/g,
      a = /<\/(?:\w+:)?r>/,
      n = /\r\n/g;
    var i = function f(e, r, t) {
      var a = {},
        n = 65001,
        i = "";
      var s = e.match(ae),
        f = 0;
      if (s)
        for (; f != s.length; ++f) {
          var o = se(s[f]);
          switch (o[0].replace(/\w*:/g, "")) {
            case "<condense":
              break;
            case "<extend":
              break;
            case "<shadow":
              if (!o.val) break;
            case "<shadow>":
            case "<shadow/>":
              a.shadow = 1;
              break;
            case "</shadow>":
              break;
            case "<charset":
              if (o.val == "1") break;
              n = Lu[parseInt(o.val, 10)];
              break;
            case "<outline":
              if (!o.val) break;
            case "<outline>":
            case "<outline/>":
              a.outline = 1;
              break;
            case "</outline>":
              break;
            case "<rFont":
              a.name = o.val;
              break;
            case "<sz":
              a.sz = o.val;
              break;
            case "<strike":
              if (!o.val) break;
            case "<strike>":
            case "<strike/>":
              a.strike = 1;
              break;
            case "</strike>":
              break;
            case "<u":
              if (!o.val) break;
              switch (o.val) {
                case "double":
                  a.uval = "double";
                  break;
                case "singleAccounting":
                  a.uval = "single-accounting";
                  break;
                case "doubleAccounting":
                  a.uval = "double-accounting";
                  break;
              }
            case "<u>":
            case "<u/>":
              a.u = 1;
              break;
            case "</u>":
              break;
            case "<b":
              if (o.val == "0") break;
            case "<b>":
            case "<b/>":
              a.b = 1;
              break;
            case "</b>":
              break;
            case "<i":
              if (o.val == "0") break;
            case "<i>":
            case "<i/>":
              a.i = 1;
              break;
            case "</i>":
              break;
            case "<color":
              if (o.rgb) a.color = o.rgb.substr(2, 6);
              break;
            case "<family":
              a.family = o.val;
              break;
            case "<vertAlign":
              i = o.val;
              break;
            case "<scheme":
              break;
            default:
              if (o[0].charCodeAt(1) !== 47)
                throw "Unrecognized rich format " + o[0];
          }
        }
      var l = [];
      if (a.u) l.push("text-decoration: underline;");
      if (a.uval) l.push("text-underline-style:" + a.uval + ";");
      if (a.sz) l.push("font-size:" + a.sz + ";");
      if (a.outline) l.push("text-effect: outline;");
      if (a.shadow) l.push("text-shadow: auto;");
      r.push('<span style="' + l.join("") + '">');
      if (a.b) {
        r.push("<b>");
        t.push("</b>");
      }
      if (a.i) {
        r.push("<i>");
        t.push("</i>");
      }
      if (a.strike) {
        r.push("<s>");
        t.push("</s>");
      }
      if (i == "superscript") i = "sup";
      else if (i == "subscript") i = "sub";
      if (i != "") {
        r.push("<" + i + ">");
        t.push("</" + i + ">");
      }
      t.push("</span>");
      return n;
    };
    function s(t) {
      var a = [[], "", []];
      var s = t.match(e),
        f = 65001;
      if (!x(s)) return "";
      a[1] = s[1];
      var o = t.match(r);
      if (x(o)) f = i(o[1], a[0], a[2]);
      return a[0].join("") + a[1].replace(n, "<br/>") + a[2].join("");
    }
    return function o(e) {
      return e.replace(t, "").split(a).map(s).join("");
    };
  })();
  var Uu = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,
    Hu = /<(?:\w+:)?r>/;
  var Wu = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
  function Vu(e, r) {
    var t = r ? r.cellHTML : true;
    var a = {};
    if (!e) return null;
    var n;
    if (e.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
      a.t = ke(ce(e.substr(e.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0]));
      a.r = ke(e);
      if (t) a.h = me(a.t);
    } else if ((n = e.match(Hu))) {
      a.r = ke(e);
      a.t = ke(
        ce((e.replace(Wu, "").match(Uu) || []).join("").replace(ae, ""))
      );
      if (t) a.h = Mu(a.r);
    }
    return a;
  }
  var zu = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
  var Xu = /<(?:\w+:)?(?:si|sstItem)>/g;
  var Gu = /<\/(?:\w+:)?(?:si|sstItem)>/;
  function ju(e, r) {
    var t = [],
      a = "";
    if (!e) return t;
    var n = e.match(zu);
    if (x(n)) {
      a = n[2].replace(Xu, "").split(Gu);
      for (var i = 0; i != a.length; ++i) {
        var s = Vu(a[i].trim(), r);
        if (s != null) t[t.length] = s;
      }
      n = se(n[1]);
      t.Count = n.count;
      t.Unique = n.uniqueCount;
    }
    return t;
  }
  ia.SST =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
  var Ku = /^\s|\s$|[\t\n\r]/;
  function Yu(e, r) {
    if (!r.bookSST) return "";
    var t = [Pe];
    t[t.length] = De("sst", null, {
      xmlns: Ne.main[0],
      count: e.Count,
      uniqueCount: e.Unique,
    });
    for (var a = 0; a != e.length; ++a) {
      if (e[a] == null) continue;
      var n = e[a];
      var i = "<si>";
      if (n.r) i += n.r;
      else {
        i += "<t";
        if (!n.t) n.t = "";
        if (n.t.match(Ku)) i += ' xml:space="preserve"';
        i += ">" + de(n.t) + "</t>";
      }
      i += "</si>";
      t[t.length] = i;
    }
    if (t.length > 2) {
      t[t.length] = "</sst>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  function $u(e, r) {
    return [e.read_shift(4), e.read_shift(4)];
  }
  function Zu(e, r) {
    var t = [];
    var a = false;
    Br(e, function n(e, i, s) {
      switch (s) {
        case 159:
          t.Count = e[0];
          t.Unique = e[1];
          break;
        case 19:
          t.push(e);
          break;
        case 160:
          return true;
        case 35:
          a = true;
          break;
        case 36:
          a = false;
          break;
        default:
          if (i.indexOf("Begin") > 0) {
          } else if (i.indexOf("End") > 0) {
          }
          if (!a || r.WTF) throw new Error("Unexpected record " + s + " " + i);
      }
    });
    return t;
  }
  function Qu(e, r) {
    if (!r) r = wr(8);
    r.write_shift(4, e.Count);
    r.write_shift(4, e.Unique);
    return r;
  }
  var Ju = nt;
  function qu(e, r) {
    var t = Cr();
    _r(t, "BrtBeginSst", Qu(e));
    for (var a = 0; a < e.length; ++a) _r(t, "BrtSSTItem", Ju(e[a]));
    _r(t, "BrtEndSst");
    return t.end();
  }
  function eh(e) {
    if (typeof cptable !== "undefined") return cptable.utils.encode(1252, e);
    var r = [],
      t = e.split("");
    for (var a = 0; a < t.length; ++a) r[a] = t[a].charCodeAt(0);
    return r;
  }
  function rh(e, r) {
    var t = {};
    t.Major = e.read_shift(2);
    t.Minor = e.read_shift(2);
    if (r >= 4) e.l += r - 4;
    return t;
  }
  function th(e, r) {
    var t = {};
    t.id = e.read_shift(0, "lpp4");
    t.R = rh(e, 4);
    t.U = rh(e, 4);
    t.W = rh(e, 4);
    return t;
  }
  function ah(e) {
    var r = e.read_shift(4);
    var t = e.l + r - 4;
    var a = {};
    var n = e.read_shift(4);
    var i = [];
    while (n-- > 0) {
      var s = {};
      s.t = e.read_shift(4);
      s.v = e.read_shift(0, "lpp4");
      i.push(s);
    }
    a.name = e.read_shift(0, "lpp4");
    a.comps = i;
    return a;
  }
  function nh(e, r) {
    var t = [];
    e.l += 4;
    var a = e.read_shift(4);
    while (a-- > 0) t.push(ah(e));
    return t;
  }
  function ih(e, r) {
    var t = [];
    e.l += 4;
    var a = e.read_shift(4);
    while (a-- > 0) t.push(e.read_shift(0, "lpp4"));
    return t;
  }
  function sh(e, r) {
    var t = {};
    var a = e.read_shift(4);
    var n = e.l + a - 4;
    e.l += 4;
    t.id = e.read_shift(0, "lpp4");
    t.name = e.read_shift(0, "lpp4");
    t.R = rh(e, 4);
    t.U = rh(e, 4);
    t.W = rh(e, 4);
    return t;
  }
  function fh(e, r) {
    var t = sh(e);
    t.ename = e.read_shift(0, "8lpp4");
    t.blksz = e.read_shift(4);
    t.cmode = e.read_shift(4);
    if (e.read_shift(4) != 4) throw new Error("Bad !Primary record");
    return t;
  }
  function oh(e, r) {
    var t = e.l + r;
    var a = {};
    a.Flags = e.read_shift(4) & 63;
    e.l += 4;
    a.AlgID = e.read_shift(4);
    var n = false;
    switch (a.AlgID) {
      case 26126:
      case 26127:
      case 26128:
        n = a.Flags == 36;
        break;
      case 26625:
        n = a.Flags == 4;
        break;
      case 0:
        n = a.Flags == 16 || a.Flags == 4 || a.Flags == 36;
        break;
      default:
        throw "Unrecognized encryption algorithm: " + a.AlgID;
    }
    if (!n) throw new Error("Encryption Flags/AlgID mismatch");
    a.AlgIDHash = e.read_shift(4);
    a.KeySize = e.read_shift(4);
    a.ProviderType = e.read_shift(4);
    e.l += 8;
    a.CSPName = e.read_shift((t - e.l) >> 1, "utf16le").slice(0, -1);
    e.l = t;
    return a;
  }
  function lh(e, r) {
    var t = {};
    e.l += 4;
    t.Salt = e.slice(e.l, e.l + 16);
    e.l += 16;
    t.Verifier = e.slice(e.l, e.l + 16);
    e.l += 16;
    var a = e.read_shift(4);
    t.VerifierHash = e.slice(e.l, e.l + a);
    e.l += a;
    return t;
  }
  function ch(e, r) {
    var t = rh(e);
    switch (t.Minor) {
      case 2:
        return uh(e, t);
      case 3:
        return hh(e, t);
      case 4:
        return dh(e, t);
    }
    throw new Error("ECMA-376 Encryped file unrecognized Version: " + t.Minor);
  }
  function uh(e, r) {
    var t = e.read_shift(4);
    if ((t & 63) != 36) throw new Error("EncryptionInfo mismatch");
    var a = e.read_shift(4);
    var n = e.l + a;
    var i = oh(e, a);
    var s = lh(e, e.length - e.l);
    return { t: "Std", h: i, v: s };
  }
  function hh(e, r) {
    throw new Error("File is password-protected: ECMA-376 Extensible");
  }
  function dh(e, r) {
    throw new Error("File is password-protected: ECMA-376 Agile");
  }
  function vh(e, r) {
    var t = {};
    var a = (t.EncryptionVersionInfo = rh(e, 4));
    r -= 4;
    if (a.Minor != 2)
      throw new Error("unrecognized minor version code: " + a.Minor);
    if (a.Major > 4 || a.Major < 2)
      throw new Error("unrecognized major version code: " + a.Major);
    t.Flags = e.read_shift(4);
    r -= 4;
    var n = e.read_shift(4);
    r -= 4;
    t.EncryptionHeader = oh(e, n);
    r -= n;
    t.EncryptionVerifier = lh(e, r);
    return t;
  }
  function ph(e, r) {
    var t = {};
    var a = (t.EncryptionVersionInfo = rh(e, 4));
    r -= 4;
    if (a.Major != 1 || a.Minor != 1)
      throw "unrecognized version code " + a.Major + " : " + a.Minor;
    t.Salt = e.read_shift(16);
    t.EncryptedVerifier = e.read_shift(16);
    t.EncryptedVerifierHash = e.read_shift(16);
    return t;
  }
  function mh(e) {
    var r = 0,
      t;
    var a = eh(e);
    var n = a.length + 1,
      i,
      s;
    var f, o, l;
    t = v(n);
    t[0] = a.length;
    for (i = 1; i != n; ++i) t[i] = a[i - 1];
    for (i = n - 1; i >= 0; --i) {
      s = t[i];
      f = (r & 16384) === 0 ? 0 : 1;
      o = (r << 1) & 32767;
      l = f | o;
      r = l ^ s;
    }
    return r ^ 52811;
  }
  var bh = (function () {
    var e = [187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0];
    var r = [
      57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287,
      34041, 10252, 43370, 20163,
    ];
    var t = [
      44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933,
      60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248,
      885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614,
      21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210,
      60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898,
      15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812,
      17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557,
      1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128,
      28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883,
      1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628,
    ];
    var a = function (e) {
      return ((e / 2) | (e * 128)) & 255;
    };
    var n = function (e, r) {
      return a(e ^ r);
    };
    var i = function (e) {
      var a = r[e.length - 1];
      var n = 104;
      for (var i = e.length - 1; i >= 0; --i) {
        var s = e[i];
        for (var f = 0; f != 7; ++f) {
          if (s & 64) a ^= t[n];
          s *= 2;
          --n;
        }
      }
      return a;
    };
    return function (r) {
      var t = eh(r);
      var a = i(t);
      var s = t.length;
      var f = v(16);
      for (var o = 0; o != 16; ++o) f[o] = 0;
      var l, c, u;
      if ((s & 1) === 1) {
        l = a >> 8;
        f[s] = n(e[0], l);
        --s;
        l = a & 255;
        c = t[t.length - 1];
        f[s] = n(c, l);
      }
      while (s > 0) {
        --s;
        l = a >> 8;
        f[s] = n(t[s], l);
        --s;
        l = a & 255;
        f[s] = n(t[s], l);
      }
      s = 15;
      u = 15 - t.length;
      while (u > 0) {
        l = a >> 8;
        f[s] = n(e[u], l);
        --s;
        --u;
        l = a & 255;
        f[s] = n(t[s], l);
        --s;
        --u;
      }
      return f;
    };
  })();
  var gh = function (e, r, t, a, n) {
    if (!n) n = r;
    if (!a) a = bh(e);
    var i, s;
    for (i = 0; i != r.length; ++i) {
      s = r[i];
      s ^= a[t];
      s = ((s >> 5) | (s << 3)) & 255;
      n[i] = s;
      ++t;
    }
    return [n, t, a];
  };
  var Eh = function (e) {
    var r = 0,
      t = bh(e);
    return function (e) {
      var a = gh("", e, r, t);
      r = a[1];
      return a[0];
    };
  };
  function kh(e, r, t, a) {
    var n = { key: nn(e), verificationBytes: nn(e) };
    if (t.password) n.verifier = mh(t.password);
    a.valid = n.verificationBytes === n.verifier;
    if (a.valid) a.insitu_decrypt = Eh(t.password);
    return n;
  }
  function Sh(e, r, t) {
    var a = t || {};
    a.Info = e.read_shift(2);
    e.l -= 2;
    if (a.Info === 1) a.Data = ph(e, r);
    else a.Data = vh(e, r);
    return a;
  }
  function wh(e, r, t) {
    var a = { Type: t.biff >= 8 ? e.read_shift(2) : 0 };
    if (a.Type) Sh(e, r - 2, a);
    else kh(e, r - 2, t, a);
    return a;
  }
  function Bh(e) {
    var r = e.substr(e[0] === "#" ? 1 : 0, 6);
    return [
      parseInt(r.substr(0, 2), 16),
      parseInt(r.substr(2, 2), 16),
      parseInt(r.substr(4, 2), 16),
    ];
  }
  function Ch(e) {
    for (var r = 0, t = 1; r != 3; ++r)
      t = t * 256 + (e[r] > 255 ? 255 : e[r] < 0 ? 0 : e[r]);
    return t.toString(16).toUpperCase().substr(1);
  }
  function _h(e) {
    var r = e[0] / 255,
      t = e[1] / 255,
      a = e[2] / 255;
    var n = Math.max(r, t, a),
      i = Math.min(r, t, a),
      s = n - i;
    if (s === 0) return [0, 0, r];
    var f = 0,
      o = 0,
      l = n + i;
    o = s / (l > 1 ? 2 - l : l);
    switch (n) {
      case r:
        f = ((t - a) / s + 6) % 6;
        break;
      case t:
        f = (a - r) / s + 2;
        break;
      case a:
        f = (r - t) / s + 4;
        break;
    }
    return [f / 6, o, l / 2];
  }
  function Th(e) {
    var r = e[0],
      t = e[1],
      a = e[2];
    var n = t * 2 * (a < 0.5 ? a : 1 - a),
      i = a - n / 2;
    var s = [i, i, i],
      f = 6 * r;
    var o;
    if (t !== 0)
      switch (f | 0) {
        case 0:
        case 6:
          o = n * f;
          s[0] += n;
          s[1] += o;
          break;
        case 1:
          o = n * (2 - f);
          s[0] += o;
          s[1] += n;
          break;
        case 2:
          o = n * (f - 2);
          s[1] += n;
          s[2] += o;
          break;
        case 3:
          o = n * (4 - f);
          s[1] += o;
          s[2] += n;
          break;
        case 4:
          o = n * (f - 4);
          s[2] += n;
          s[0] += o;
          break;
        case 5:
          o = n * (6 - f);
          s[2] += o;
          s[0] += n;
          break;
      }
    for (var l = 0; l != 3; ++l) s[l] = Math.round(s[l] * 255);
    return s;
  }
  function xh(e, r) {
    if (r === 0) return e;
    var t = _h(Bh(e));
    if (r < 0) t[2] = t[2] * (1 + r);
    else t[2] = 1 - (1 - t[2]) * (1 - r);
    return Ch(Th(t));
  }
  var Ih = 6,
    Ah = 15,
    yh = 1,
    Rh = Ih;
  function Dh(e) {
    return Math.floor((e + Math.round(128 / Rh) / 256) * Rh);
  }
  function Oh(e) {
    return Math.floor(((e - 5) / Rh) * 100 + 0.5) / 100;
  }
  function Fh(e) {
    return Math.round(((e * Rh + 5) / Rh) * 256) / 256;
  }
  function Ph(e) {
    return (((e - 5) / Rh) * 100 + 0.5) / 100;
  }
  function Nh(e) {
    return (((e * Rh + 5) / Rh) * 256) / 256;
  }
  function Lh(e) {
    return Fh(Oh(Dh(e)));
  }
  function Mh(e) {
    var r = Math.abs(e - Lh(e)),
      t = Rh;
    if (r > 0.005)
      for (Rh = yh; Rh < Ah; ++Rh)
        if (Math.abs(e - Lh(e)) <= r) {
          r = Math.abs(e - Lh(e));
          t = Rh;
        }
    Rh = t;
  }
  function Uh(e) {
    var r = Infinity,
      t = 0,
      a = yh;
    for (Rh = yh; Rh < Ah; ++Rh) {
      t = Nh(Ph(e)) * 256;
      t = t % 1;
      if (t > 0.5) t--;
      if (Math.abs(t) < r) {
        r = Math.abs(t);
        a = Rh;
      }
    }
    Rh = a;
  }
  function Hh(e) {
    if (e.width) {
      e.wpx = Dh(e.width);
      e.wch = Oh(e.wpx);
      e.MDW = Rh;
    } else if (e.wpx) {
      e.wch = Oh(e.wpx);
      e.width = Fh(e.wch);
      e.MDW = Rh;
    } else if (typeof e.wch == "number") {
      e.width = Fh(e.wch);
      e.wpx = Dh(e.width);
      e.MDW = Rh;
    }
    if (e.customWidth) delete e.customWidth;
  }
  var Wh = 96,
    Vh = Wh;
  function zh(e) {
    return (e * 96) / Vh;
  }
  function Xh(e) {
    return (e * Vh) / 96;
  }
  var Gh = {
    None: "none",
    Solid: "solid",
    Gray50: "mediumGray",
    Gray75: "darkGray",
    Gray25: "lightGray",
    HorzStripe: "darkHorizontal",
    VertStripe: "darkVertical",
    ReverseDiagStripe: "darkDown",
    DiagStripe: "darkUp",
    DiagCross: "darkGrid",
    ThickDiagCross: "darkTrellis",
    ThinHorzStripe: "lightHorizontal",
    ThinVertStripe: "lightVertical",
    ThinReverseDiagStripe: "lightDown",
    ThinHorzCross: "lightGrid",
  };
  function jh(e, r, t, a) {
    r.Borders = [];
    var n = {},
      i = {};
    e[0].match(ae).forEach(function (e) {
      var t = se(e);
      switch (t[0]) {
        case "<borders":
        case "<borders>":
        case "</borders>":
          break;
        case "<border":
        case "<border>":
        case "<border/>":
          n = {};
          if (t.diagonalUp) {
            n.diagonalUp = t.diagonalUp;
          }
          if (t.diagonalDown) {
            n.diagonalDown = t.diagonalDown;
          }
          r.Borders.push(n);
          break;
        case "</border>":
          break;
        case "<left/>":
          break;
        case "<left":
        case "<left>":
          break;
        case "</left>":
          break;
        case "<right/>":
          break;
        case "<right":
        case "<right>":
          break;
        case "</right>":
          break;
        case "<top/>":
          break;
        case "<top":
        case "<top>":
          break;
        case "</top>":
          break;
        case "<bottom/>":
          break;
        case "<bottom":
        case "<bottom>":
          break;
        case "</bottom>":
          break;
        case "<diagonal":
        case "<diagonal>":
        case "<diagonal/>":
          break;
        case "</diagonal>":
          break;
        case "<horizontal":
        case "<horizontal>":
        case "<horizontal/>":
          break;
        case "</horizontal>":
          break;
        case "<vertical":
        case "<vertical>":
        case "<vertical/>":
          break;
        case "</vertical>":
          break;
        case "<start":
        case "<start>":
        case "<start/>":
          break;
        case "</start>":
          break;
        case "<end":
        case "<end>":
        case "<end/>":
          break;
        case "</end>":
          break;
        case "<color":
        case "<color>":
          break;
        case "<color/>":
        case "</color>":
          break;
        default:
          if (a && a.WTF)
            throw new Error("unrecognized " + t[0] + " in borders");
      }
    });
  }
  function Kh(e, r, t, a) {
    r.Fills = [];
    var n = {};
    e[0].match(ae).forEach(function (e) {
      var t = se(e);
      switch (t[0]) {
        case "<fills":
        case "<fills>":
        case "</fills>":
          break;
        case "<fill>":
        case "<fill":
          break;
        case "</fill>":
          r.Fills.push(n);
          n = {};
          break;
        case "<gradientFill>":
          break;
        case "<gradientFill":
        case "</gradientFill>":
          r.Fills.push(n);
          n = {};
          break;
        case "<patternFill":
        case "<patternFill>":
          if (t.patternType) n.patternType = t.patternType;
          break;
        case "<patternFill/>":
        case "</patternFill>":
          break;
        case "<bgColor":
          if (!n.bgColor) n.bgColor = {};
          if (t.indexed) n.bgColor.indexed = parseInt(t.indexed, 10);
          if (t.theme) n.bgColor.theme = parseInt(t.theme, 10);
          if (t.tint) n.bgColor.tint = parseFloat(t.tint);
          if (t.rgb) n.bgColor.rgb = t.rgb.slice(-6);
          break;
        case "<bgColor/>":
        case "</bgColor>":
          break;
        case "<fgColor":
          if (!n.fgColor) n.fgColor = {};
          if (t.theme) n.fgColor.theme = parseInt(t.theme, 10);
          if (t.tint) n.fgColor.tint = parseFloat(t.tint);
          if (t.rgb) n.fgColor.rgb = t.rgb.slice(-6);
          break;
        case "<fgColor/>":
        case "</fgColor>":
          break;
        case "<stop":
        case "<stop/>":
          break;
        case "</stop>":
          break;
        case "<color":
        case "<color/>":
          break;
        case "</color>":
          break;
        default:
          if (a && a.WTF) throw new Error("unrecognized " + t[0] + " in fills");
      }
    });
  }
  function Yh(e, r, t, a) {
    r.Fonts = [];
    var n = {};
    e[0].match(ae).forEach(function (e) {
      var i = se(e);
      switch (i[0]) {
        case "<fonts":
        case "<fonts>":
        case "</fonts>":
          break;
        case "<font":
        case "<font>":
          break;
        case "</font>":
        case "<font/>":
          r.Fonts.push(n);
          n = {};
          break;
        case "<name":
          if (i.val) n.name = i.val;
          break;
        case "<name/>":
        case "</name>":
          break;
        case "<b":
          n.bold = i.val ? Ee(i.val) : 1;
          break;
        case "<b/>":
          n.bold = 1;
          break;
        case "<i":
          n.italic = i.val ? Ee(i.val) : 1;
          break;
        case "<i/>":
          n.italic = 1;
          break;
        case "<u":
          switch (i.val) {
            case "none":
              n.underline = 0;
              break;
            case "single":
              n.underline = 1;
              break;
            case "double":
              n.underline = 2;
              break;
            case "singleAccounting":
              n.underline = 33;
              break;
            case "doubleAccounting":
              n.underline = 34;
              break;
          }
          break;
        case "<u/>":
          n.underline = 1;
          break;
        case "<strike":
          n.strike = i.val ? Ee(i.val) : 1;
          break;
        case "<strike/>":
          n.strike = 1;
          break;
        case "<outline":
          n.outline = i.val ? Ee(i.val) : 1;
          break;
        case "<outline/>":
          n.outline = 1;
          break;
        case "<shadow":
          n.shadow = i.val ? Ee(i.val) : 1;
          break;
        case "<shadow/>":
          n.shadow = 1;
          break;
        case "<condense":
          n.condense = i.val ? Ee(i.val) : 1;
          break;
        case "<condense/>":
          n.condense = 1;
          break;
        case "<extend":
          n.extend = i.val ? Ee(i.val) : 1;
          break;
        case "<extend/>":
          n.extend = 1;
          break;
        case "<sz":
          if (i.val) n.sz = +i.val;
          break;
        case "<sz/>":
        case "</sz>":
          break;
        case "<vertAlign":
          if (i.val) n.vertAlign = i.val;
          break;
        case "<vertAlign/>":
        case "</vertAlign>":
          break;
        case "<family":
          if (i.val) n.family = parseInt(i.val, 10);
          break;
        case "<family/>":
        case "</family>":
          break;
        case "<scheme":
          if (i.val) n.scheme = i.val;
          break;
        case "<scheme/>":
        case "</scheme>":
          break;
        case "<charset":
          if (i.val == "1") break;
          i.codepage = Lu[parseInt(i.val, 10)];
          break;
        case "<color":
          if (!n.color) n.color = {};
          if (i.auto) n.color.auto = Ee(i.auto);
          if (i.rgb) n.color.rgb = i.rgb.slice(-6);
          else if (i.indexed) {
            n.color.index = parseInt(i.indexed, 10);
            var s = Zt[n.color.index];
            if (n.color.index == 81) s = Zt[1];
            if (!s) throw new Error(e);
            n.color.rgb =
              s[0].toString(16) + s[1].toString(16) + s[2].toString(16);
          } else if (i.theme) {
            n.color.theme = parseInt(i.theme, 10);
            if (i.tint) n.color.tint = parseFloat(i.tint);
            if (i.theme && t.themeElements && t.themeElements.clrScheme) {
              n.color.rgb = xh(
                t.themeElements.clrScheme[n.color.theme].rgb,
                n.color.tint || 0
              );
            }
          }
          break;
        case "<color/>":
        case "</color>":
          break;
        default:
          if (a && a.WTF) throw new Error("unrecognized " + i[0] + " in fonts");
      }
    });
  }
  function $h(e, r, t) {
    r.NumberFmt = [];
    var a = I(E._table);
    for (var n = 0; n < a.length; ++n) r.NumberFmt[a[n]] = E._table[a[n]];
    var i = e[0].match(ae);
    if (!i) return;
    for (n = 0; n < i.length; ++n) {
      var s = se(i[n]);
      switch (s[0]) {
        case "<numFmts":
        case "</numFmts>":
        case "<numFmts/>":
        case "<numFmts>":
          break;
        case "<numFmt":
          {
            var f = ce(ke(s.formatCode)),
              o = parseInt(s.numFmtId, 10);
            r.NumberFmt[o] = f;
            if (o > 0) {
              if (o > 392) {
                for (o = 392; o > 60; --o) if (r.NumberFmt[o] == null) break;
                r.NumberFmt[o] = f;
              }
              E.load(f, o);
            }
          }
          break;
        case "</numFmt>":
          break;
        default:
          if (t.WTF) throw new Error("unrecognized " + s[0] + " in numFmts");
      }
    }
  }
  function Zh(e, r) {
    var t = ["<numFmts>"];
    [
      [5, 8],
      [23, 26],
      [41, 44],
      [50, 392],
    ].forEach(function (r) {
      for (var a = r[0]; a <= r[1]; ++a)
        if (e[a] != null)
          t[t.length] = De("numFmt", null, {
            numFmtId: a,
            formatCode: de(e[a]),
          });
    });
    if (t.length === 1) return "";
    t[t.length] = "</numFmts>";
    t[0] = De("numFmts", null, { count: t.length - 2 }).replace("/>", ">");
    return t.join("");
  }
  var Qh = ["numFmtId", "fillId", "fontId", "borderId", "xfId"];
  var Jh = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix",
  ];
  function qh(e, r, t) {
    r.CellXf = [];
    var a;
    e[0].match(ae).forEach(function (e) {
      var n = se(e),
        i = 0;
      switch (n[0]) {
        case "<cellXfs":
        case "<cellXfs>":
        case "<cellXfs/>":
        case "</cellXfs>":
          break;
        case "<xf":
        case "<xf/>":
          a = n;
          delete a[0];
          for (i = 0; i < Qh.length; ++i)
            if (a[Qh[i]]) a[Qh[i]] = parseInt(a[Qh[i]], 10);
          for (i = 0; i < Jh.length; ++i)
            if (a[Jh[i]]) a[Jh[i]] = Ee(a[Jh[i]], "");
          if (a.numFmtId > 392) {
            for (i = 392; i > 60; --i)
              if (r.NumberFmt[a.numFmtId] == r.NumberFmt[i]) {
                a.numFmtId = i;
                break;
              }
          }
          r.CellXf.push(a);
          break;
        case "</xf>":
          break;
        case "<alignment":
        case "<alignment/>":
          var s = {};
          if (n.vertical) s.vertical = n.vertical;
          if (n.horizontal) s.horizontal = n.horizontal;
          if (n.textRotation != null) s.textRotation = n.textRotation;
          if (n.indent) s.indent = n.indent;
          if (n.wrapText) s.wrapText = n.wrapText;
          a.alignment = s;
          break;
        case "</alignment>":
          break;
        case "<protection":
        case "</protection>":
        case "<protection/>":
          break;
        case "<extLst":
        case "</extLst>":
          break;
        case "<ext":
          break;
        default:
          if (t.WTF) throw new Error("unrecognized " + n[0] + " in cellXfs");
      }
    });
  }
  function ed(e) {
    var r = [];
    r[r.length] = De("cellXfs", null);
    e.forEach(function (e) {
      r[r.length] = De("xf", null, e);
    });
    r[r.length] = "</cellXfs>";
    if (r.length === 2) return "";
    r[0] = De("cellXfs", null, { count: r.length - 2 }).replace("/>", ">");
    return r.join("");
  }
  var rd = (function Qk() {
    var e = /<numFmts([^>]*)>[\S\s]*?<\/numFmts>/;
    var r = /<cellXfs([^>]*)>[\S\s]*?<\/cellXfs>/;
    var t = /<fills([^>]*)>[\S\s]*?<\/fills>/;
    var a = /<fonts([^>]*)>[\S\s]*?<\/fonts>/;
    var n = /<borders([^>]*)>[\S\s]*?<\/borders>/;
    return function i(s, f, o) {
      var l = {};
      if (!s) return l;
      s = s
        .replace(/<!--([\s\S]*?)-->/gm, "")
        .replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
      var c;
      if ((c = s.match(e))) $h(c, l, o);
      if ((c = s.match(a))) Yh(c, l, f, o);
      if ((c = s.match(t))) Kh(c, l, f, o);
      if ((c = s.match(n))) jh(c, l, f, o);
      if ((c = s.match(r))) qh(c, l, o);
      return l;
    };
  })();
  var td = De("styleSheet", null, { xmlns: Ne.main[0], "xmlns:vt": Ne.vt });
  ia.STY =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";
  function ad(e, r) {
    var t = [Pe, td],
      a;
    if (e.SSF && (a = Zh(e.SSF)) != null) t[t.length] = a;
    t[t.length] =
      '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    t[t.length] =
      '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    t[t.length] =
      '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    t[t.length] =
      '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if ((a = ed(r.cellXfs))) t[t.length] = a;
    t[t.length] =
      '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    t[t.length] = '<dxfs count="0"/>';
    t[t.length] =
      '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (t.length > 2) {
      t[t.length] = "</styleSheet>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  function nd(e, r) {
    var t = e.read_shift(2);
    var a = qr(e, r - 2);
    return [t, a];
  }
  function id(e, r, t) {
    if (!t) t = wr(6 + 4 * r.length);
    t.write_shift(2, e);
    et(r, t);
    return t.length > t.l ? t.slice(0, t.l) : t;
  }
  function sd(e, r, t) {
    var a = {};
    a.sz = e.read_shift(2) / 20;
    var n = At(e, 2, t);
    if (n.fCondense) a.condense = 1;
    if (n.fExtend) a.extend = 1;
    if (n.fShadow) a.shadow = 1;
    if (n.fOutline) a.outline = 1;
    if (n.fStrikeout) a.strike = 1;
    if (n.fItalic) a.italic = 1;
    var i = e.read_shift(2);
    if (i === 700) a.bold = 1;
    switch (e.read_shift(2)) {
      case 1:
        a.vertAlign = "superscript";
        break;
      case 2:
        a.vertAlign = "subscript";
        break;
    }
    var s = e.read_shift(1);
    if (s != 0) a.underline = s;
    var f = e.read_shift(1);
    if (f > 0) a.family = f;
    var o = e.read_shift(1);
    if (o > 0) a.charset = o;
    e.l++;
    a.color = xt(e, 8);
    switch (e.read_shift(1)) {
      case 1:
        a.scheme = "major";
        break;
      case 2:
        a.scheme = "minor";
        break;
    }
    a.name = qr(e, r - 21);
    return a;
  }
  function fd(e, r) {
    if (!r) r = wr(25 + 4 * 32);
    r.write_shift(2, e.sz * 20);
    yt(e, r);
    r.write_shift(2, e.bold ? 700 : 400);
    var t = 0;
    if (e.vertAlign == "superscript") t = 1;
    else if (e.vertAlign == "subscript") t = 2;
    r.write_shift(2, t);
    r.write_shift(1, e.underline || 0);
    r.write_shift(1, e.family || 0);
    r.write_shift(1, e.charset || 0);
    r.write_shift(1, 0);
    It(e.color, r);
    var a = 0;
    if (e.scheme == "major") a = 1;
    if (e.scheme == "minor") a = 2;
    r.write_shift(1, a);
    et(e.name, r);
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  var od = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625",
  ];
  var ld = y(od);
  function cd(e, r) {
    if (!r) r = wr(4 * 3 + 8 * 7 + 16 * 1);
    var t = ld[e.patternType];
    if (t == null) t = 40;
    r.write_shift(4, t);
    var a = 0;
    if (t != 40) {
      It({ auto: 1 }, r);
      It({ auto: 1 }, r);
      for (; a < 12; ++a) r.write_shift(4, 0);
    } else {
      for (; a < 4; ++a) r.write_shift(4, 0);
      for (; a < 12; ++a) r.write_shift(4, 0);
    }
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  function ud(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    Er(e, r - 4);
    return { ixfe: t, numFmtId: a };
  }
  function hd(e, r, t) {
    if (!t) t = wr(16);
    t.write_shift(2, r || 0);
    t.write_shift(2, e.numFmtId || 0);
    t.write_shift(2, 0);
    t.write_shift(2, 0);
    t.write_shift(2, 0);
    t.write_shift(1, 0);
    t.write_shift(1, 0);
    t.write_shift(1, 0);
    t.write_shift(1, 0);
    t.write_shift(1, 0);
    t.write_shift(1, 0);
    return t;
  }
  function dd(e, r) {
    if (!r) r = wr(10);
    r.write_shift(1, 0);
    r.write_shift(1, 0);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    return r;
  }
  function vd(e, r) {
    if (!r) r = wr(51);
    r.write_shift(1, 0);
    dd(null, r);
    dd(null, r);
    dd(null, r);
    dd(null, r);
    dd(null, r);
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  function pd(e, r) {
    if (!r) r = wr(12 + 4 * 10);
    r.write_shift(4, e.xfId);
    r.write_shift(2, 1);
    r.write_shift(1, +e.builtinId);
    r.write_shift(1, 0);
    ht(e.name || "", r);
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  function md(e, r, t) {
    var a = wr(4 + 256 * 2 * 4);
    a.write_shift(4, e);
    ht(r, a);
    ht(t, a);
    return a.length > a.l ? a.slice(0, a.l) : a;
  }
  function bd(e, r, t) {
    var a = {};
    a.NumberFmt = [];
    for (var n in E._table) a.NumberFmt[n] = E._table[n];
    a.CellXf = [];
    a.Fonts = [];
    var i = [];
    var s = false;
    Br(e, function f(e, n, o) {
      switch (o) {
        case 44:
          a.NumberFmt[e[0]] = e[1];
          E.load(e[1], e[0]);
          break;
        case 43:
          a.Fonts.push(e);
          if (
            e.color.theme != null &&
            r &&
            r.themeElements &&
            r.themeElements.clrScheme
          ) {
            e.color.rgb = xh(
              r.themeElements.clrScheme[e.color.theme].rgb,
              e.color.tint || 0
            );
          }
          break;
        case 1025:
          break;
        case 45:
          break;
        case 46:
          break;
        case 47:
          if (i[i.length - 1] == "BrtBeginCellXFs") {
            a.CellXf.push(e);
          }
          break;
        case 48:
        case 507:
        case 572:
        case 475:
          break;
        case 1171:
        case 2102:
        case 1130:
        case 512:
        case 2095:
          break;
        case 35:
          s = true;
          break;
        case 36:
          s = false;
          break;
        case 37:
          i.push(n);
          break;
        case 38:
          i.pop();
          break;
        default:
          if ((n || "").indexOf("Begin") > 0) i.push(n);
          else if ((n || "").indexOf("End") > 0) i.pop();
          else if (!s || t.WTF)
            throw new Error("Unexpected record " + o + " " + n);
      }
    });
    return a;
  }
  function gd(e, r) {
    if (!r) return;
    var t = 0;
    [
      [5, 8],
      [23, 26],
      [41, 44],
      [50, 392],
    ].forEach(function (e) {
      for (var a = e[0]; a <= e[1]; ++a) if (r[a] != null) ++t;
    });
    if (t == 0) return;
    _r(e, "BrtBeginFmts", Jr(t));
    [
      [5, 8],
      [23, 26],
      [41, 44],
      [50, 392],
    ].forEach(function (t) {
      for (var a = t[0]; a <= t[1]; ++a)
        if (r[a] != null) _r(e, "BrtFmt", id(a, r[a]));
    });
    _r(e, "BrtEndFmts");
  }
  function Ed(e, r) {
    var t = 1;
    if (t == 0) return;
    _r(e, "BrtBeginFonts", Jr(t));
    _r(
      e,
      "BrtFont",
      fd({
        sz: 12,
        color: { theme: 1 },
        name: "Calibri",
        family: 2,
        scheme: "minor",
      })
    );
    _r(e, "BrtEndFonts");
  }
  function kd(e, r) {
    var t = 2;
    if (t == 0) return;
    _r(e, "BrtBeginFills", Jr(t));
    _r(e, "BrtFill", cd({ patternType: "none" }));
    _r(e, "BrtFill", cd({ patternType: "gray125" }));
    _r(e, "BrtEndFills");
  }
  function Sd(e, r) {
    var t = 1;
    if (t == 0) return;
    _r(e, "BrtBeginBorders", Jr(t));
    _r(e, "BrtBorder", vd({}));
    _r(e, "BrtEndBorders");
  }
  function wd(e, r) {
    var t = 1;
    _r(e, "BrtBeginCellStyleXFs", Jr(t));
    _r(
      e,
      "BrtXF",
      hd({ numFmtId: 0, fontId: 0, fillId: 0, borderId: 0 }, 65535)
    );
    _r(e, "BrtEndCellStyleXFs");
  }
  function Bd(e, r) {
    _r(e, "BrtBeginCellXFs", Jr(r.length));
    r.forEach(function (r) {
      _r(e, "BrtXF", hd(r, 0));
    });
    _r(e, "BrtEndCellXFs");
  }
  function Cd(e, r) {
    var t = 1;
    _r(e, "BrtBeginStyles", Jr(1));
    _r(e, "BrtStyle", pd({ xfId: 0, builtinId: 0, name: "Normal" }));
    _r(e, "BrtEndStyles");
  }
  function _d(e, r) {
    var t = 0;
    _r(e, "BrtBeginDXFs", Jr(t));
    _r(e, "BrtEndDXFs");
  }
  function Td(e, r) {
    var t = 0;
    _r(
      e,
      "BrtBeginTableStyles",
      md(t, "TableStyleMedium9", "PivotStyleMedium4")
    );
    _r(e, "BrtEndTableStyles");
  }
  function xd(e, r) {
    return;
  }
  function Id(e, r) {
    var t = Cr();
    _r(t, "BrtBeginStyleSheet");
    gd(t, e.SSF);
    Ed(t, e);
    kd(t, e);
    Sd(t, e);
    wd(t, e);
    Bd(t, r.cellXfs);
    Cd(t, e);
    _d(t, e);
    Td(t, e);
    xd(t, e);
    _r(t, "BrtEndStyleSheet");
    return t.end();
  }
  ia.THEME =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";
  function Ad(e, r, t) {
    r.themeElements.clrScheme = [];
    var a = {};
    (e[0].match(ae) || []).forEach(function (e) {
      var n = se(e);
      switch (n[0]) {
        case "<a:clrScheme":
        case "</a:clrScheme>":
          break;
        case "<a:srgbClr":
          a.rgb = n.val;
          break;
        case "<a:sysClr":
          a.rgb = n.lastClr;
          break;
        case "<a:dk1>":
        case "</a:dk1>":
        case "<a:lt1>":
        case "</a:lt1>":
        case "<a:dk2>":
        case "</a:dk2>":
        case "<a:lt2>":
        case "</a:lt2>":
        case "<a:accent1>":
        case "</a:accent1>":
        case "<a:accent2>":
        case "</a:accent2>":
        case "<a:accent3>":
        case "</a:accent3>":
        case "<a:accent4>":
        case "</a:accent4>":
        case "<a:accent5>":
        case "</a:accent5>":
        case "<a:accent6>":
        case "</a:accent6>":
        case "<a:hlink>":
        case "</a:hlink>":
        case "<a:folHlink>":
        case "</a:folHlink>":
          if (n[0].charAt(1) === "/") {
            r.themeElements.clrScheme.push(a);
            a = {};
          } else {
            a.name = n[0].substring(3, n[0].length - 1);
          }
          break;
        default:
          if (t && t.WTF)
            throw new Error("Unrecognized " + n[0] + " in clrScheme");
      }
    });
  }
  function yd(e, r, t) {}
  function Rd(e, r, t) {}
  var Dd = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
  var Od = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
  var Fd = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
  function Pd(e, r, t) {
    r.themeElements = {};
    var a;
    [
      ["clrScheme", Dd, Ad],
      ["fontScheme", Od, yd],
      ["fmtScheme", Fd, Rd],
    ].forEach(function (n) {
      if (!(a = e.match(n[1])))
        throw new Error(n[0] + " not found in themeElements");
      n[2](a, r, t);
    });
  }
  var Nd = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
  function Ld(e, r) {
    if (!e || e.length === 0) return Ld(Md());
    var t;
    var a = {};
    if (!(t = e.match(Nd))) throw new Error("themeElements not found in theme");
    Pd(t[0], a, r);
    return a;
  }
  function Md(e, r) {
    if (r && r.themeXLSX) return r.themeXLSX;
    var t = [Pe];
    t[t.length] =
      '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    t[t.length] = "<a:themeElements>";
    t[t.length] = '<a:clrScheme name="Office">';
    t[t.length] =
      '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    t[t.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    t[t.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    t[t.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    t[t.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    t[t.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    t[t.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    t[t.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    t[t.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    t[t.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    t[t.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    t[t.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    t[t.length] = "</a:clrScheme>";
    t[t.length] = '<a:fontScheme name="Office">';
    t[t.length] = "<a:majorFont>";
    t[t.length] = '<a:latin typeface="Cambria"/>';
    t[t.length] = '<a:ea typeface=""/>';
    t[t.length] = '<a:cs typeface=""/>';
    t[t.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
    t[t.length] = '<a:font script="Hang" typeface="맑은 고딕"/>';
    t[t.length] = '<a:font script="Hans" typeface="宋体"/>';
    t[t.length] = '<a:font script="Hant" typeface="新細明體"/>';
    t[t.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    t[t.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    t[t.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    t[t.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    t[t.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    t[t.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    t[t.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    t[t.length] = '<a:font script="Knda" typeface="Tunga"/>';
    t[t.length] = '<a:font script="Guru" typeface="Raavi"/>';
    t[t.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    t[t.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    t[t.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    t[t.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    t[t.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    t[t.length] = '<a:font script="Deva" typeface="Mangal"/>';
    t[t.length] = '<a:font script="Telu" typeface="Gautami"/>';
    t[t.length] = '<a:font script="Taml" typeface="Latha"/>';
    t[t.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    t[t.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    t[t.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    t[t.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    t[t.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    t[t.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    t[t.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    t[t.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    t[t.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    t[t.length] = "</a:majorFont>";
    t[t.length] = "<a:minorFont>";
    t[t.length] = '<a:latin typeface="Calibri"/>';
    t[t.length] = '<a:ea typeface=""/>';
    t[t.length] = '<a:cs typeface=""/>';
    t[t.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
    t[t.length] = '<a:font script="Hang" typeface="맑은 고딕"/>';
    t[t.length] = '<a:font script="Hans" typeface="宋体"/>';
    t[t.length] = '<a:font script="Hant" typeface="新細明體"/>';
    t[t.length] = '<a:font script="Arab" typeface="Arial"/>';
    t[t.length] = '<a:font script="Hebr" typeface="Arial"/>';
    t[t.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    t[t.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    t[t.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    t[t.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    t[t.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    t[t.length] = '<a:font script="Knda" typeface="Tunga"/>';
    t[t.length] = '<a:font script="Guru" typeface="Raavi"/>';
    t[t.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    t[t.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    t[t.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    t[t.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    t[t.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    t[t.length] = '<a:font script="Deva" typeface="Mangal"/>';
    t[t.length] = '<a:font script="Telu" typeface="Gautami"/>';
    t[t.length] = '<a:font script="Taml" typeface="Latha"/>';
    t[t.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    t[t.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    t[t.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    t[t.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    t[t.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    t[t.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    t[t.length] = '<a:font script="Viet" typeface="Arial"/>';
    t[t.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    t[t.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    t[t.length] = "</a:minorFont>";
    t[t.length] = "</a:fontScheme>";
    t[t.length] = '<a:fmtScheme name="Office">';
    t[t.length] = "<a:fillStyleLst>";
    t[t.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    t[t.length] = '<a:gradFill rotWithShape="1">';
    t[t.length] = "<a:gsLst>";
    t[t.length] =
      '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    t[t.length] = "</a:gsLst>";
    t[t.length] = '<a:lin ang="16200000" scaled="1"/>';
    t[t.length] = "</a:gradFill>";
    t[t.length] = '<a:gradFill rotWithShape="1">';
    t[t.length] = "<a:gsLst>";
    t[t.length] =
      '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    t[t.length] = "</a:gsLst>";
    t[t.length] = '<a:lin ang="16200000" scaled="0"/>';
    t[t.length] = "</a:gradFill>";
    t[t.length] = "</a:fillStyleLst>";
    t[t.length] = "<a:lnStyleLst>";
    t[t.length] =
      '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    t[t.length] =
      '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    t[t.length] =
      '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    t[t.length] = "</a:lnStyleLst>";
    t[t.length] = "<a:effectStyleLst>";
    t[t.length] = "<a:effectStyle>";
    t[t.length] = "<a:effectLst>";
    t[t.length] =
      '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    t[t.length] = "</a:effectLst>";
    t[t.length] = "</a:effectStyle>";
    t[t.length] = "<a:effectStyle>";
    t[t.length] = "<a:effectLst>";
    t[t.length] =
      '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    t[t.length] = "</a:effectLst>";
    t[t.length] = "</a:effectStyle>";
    t[t.length] = "<a:effectStyle>";
    t[t.length] = "<a:effectLst>";
    t[t.length] =
      '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    t[t.length] = "</a:effectLst>";
    t[t.length] =
      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    t[t.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    t[t.length] = "</a:effectStyle>";
    t[t.length] = "</a:effectStyleLst>";
    t[t.length] = "<a:bgFillStyleLst>";
    t[t.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    t[t.length] = '<a:gradFill rotWithShape="1">';
    t[t.length] = "<a:gsLst>";
    t[t.length] =
      '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    t[t.length] = "</a:gsLst>";
    t[t.length] =
      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    t[t.length] = "</a:gradFill>";
    t[t.length] = '<a:gradFill rotWithShape="1">';
    t[t.length] = "<a:gsLst>";
    t[t.length] =
      '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    t[t.length] =
      '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    t[t.length] = "</a:gsLst>";
    t[t.length] =
      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    t[t.length] = "</a:gradFill>";
    t[t.length] = "</a:bgFillStyleLst>";
    t[t.length] = "</a:fmtScheme>";
    t[t.length] = "</a:themeElements>";
    t[t.length] = "<a:objectDefaults>";
    t[t.length] = "<a:spDef>";
    t[t.length] =
      '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    t[t.length] = "</a:spDef>";
    t[t.length] = "<a:lnDef>";
    t[t.length] =
      '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    t[t.length] = "</a:lnDef>";
    t[t.length] = "</a:objectDefaults>";
    t[t.length] = "<a:extraClrSchemeLst/>";
    t[t.length] = "</a:theme>";
    return t.join("");
  }
  function Ud(e, r, t) {
    var a = e.read_shift(4);
    if (a === 124226) return;
    e.l += r - 4;
  }
  function Hd(e, r) {
    return e.read_shift(4);
  }
  function Wd(e, r) {
    var t = {};
    t.xclrType = e.read_shift(2);
    t.nTintShade = e.read_shift(2);
    switch (t.xclrType) {
      case 0:
        e.l += 4;
        break;
      case 1:
        t.xclrValue = Vd(e, 4);
        break;
      case 2:
        t.xclrValue = kn(e, 4);
        break;
      case 3:
        t.xclrValue = Hd(e, 4);
        break;
      case 4:
        e.l += 4;
        break;
    }
    e.l += 8;
    return t;
  }
  function Vd(e, r) {
    return Er(e, r);
  }
  function zd(e, r) {
    return Er(e, r);
  }
  function Xd(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(2);
    var n = [t];
    switch (t) {
      case 4:
      case 5:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
      case 13:
        n[1] = Wd(e, a);
        break;
      case 6:
        n[1] = zd(e, a);
        break;
      case 14:
      case 15:
        n[1] = e.read_shift(a === 5 ? 1 : 2);
        break;
      default:
        throw new Error("Unrecognized ExtProp type: " + t + " " + a);
    }
    return n;
  }
  function Gd(e, r) {
    var t = e.l + r;
    e.l += 2;
    var a = e.read_shift(2);
    e.l += 2;
    var n = e.read_shift(2);
    var i = [];
    while (n-- > 0) i.push(Xd(e, t - e.l));
    return { ixfe: a, ext: i };
  }
  function jd(e, r) {
    r.forEach(function (e) {
      switch (e[0]) {
        case 4:
          break;
        case 5:
          break;
        case 6:
          break;
        case 7:
          break;
        case 8:
          break;
        case 9:
          break;
        case 10:
          break;
        case 11:
          break;
        case 13:
          break;
        case 14:
          break;
        case 15:
          break;
      }
    });
  }
  function Kd(e, r) {
    var t = [];
    if (!e) return t;
    var a = 0,
      n = 1;
    (e.match(ae) || []).forEach(function (e) {
      var r = se(e);
      switch (r[0]) {
        case "<?xml":
          break;
        case "<calcChain":
        case "<calcChain>":
        case "</calcChain>":
          break;
        case "<c":
          delete r[0];
          if (r.i) n = r.i;
          else r.i = n;
          t.push(r);
          break;
      }
    });
    return t;
  }
  function Yd(e, r) {}
  function $d(e, r) {
    var t = {};
    t.i = e.read_shift(4);
    var a = {};
    a.r = e.read_shift(4);
    a.c = e.read_shift(4);
    t.r = Vr(a);
    var n = e.read_shift(1);
    if (n & 2) t.l = "1";
    if (n & 8) t.a = "1";
    return t;
  }
  function Zd(e, r) {
    var t = [];
    var a = false;
    Br(e, function n(e, i, s) {
      switch (s) {
        case 63:
          t.push(e);
          break;
        default:
          if ((i || "").indexOf("Begin") > 0) {
          } else if ((i || "").indexOf("End") > 0) {
          } else if (!a || r.WTF)
            throw new Error("Unexpected record " + s + " " + i);
      }
    });
    return t;
  }
  function Qd(e, r) {}
  ia.IMG =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
  ia.DRAW =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";
  function Jd(e, r) {
    if (!e) return "??";
    var t = (e.match(/<c:chart [^>]*r:id="([^"]*)"/) || ["", ""])[1];
    return r["!id"][t].Target;
  }
  var qd = 1024;
  function ev(e, r) {
    var t = [21600, 21600];
    var a = ["m0,0l0", t[1], t[0], t[1], t[0], "0xe"].join(",");
    var n = [
      De("xml", null, {
        "xmlns:v": Le.v,
        "xmlns:o": Le.o,
        "xmlns:x": Le.x,
        "xmlns:mv": Le.mv,
      }).replace(/\/>/, ">"),
      De("o:shapelayout", De("o:idmap", null, { "v:ext": "edit", data: e }), {
        "v:ext": "edit",
      }),
      De(
        "v:shapetype",
        [
          De("v:stroke", null, { joinstyle: "miter" }),
          De("v:path", null, { gradientshapeok: "t", "o:connecttype": "rect" }),
        ].join(""),
        { id: "_x0000_t202", "o:spt": 202, coordsize: t.join(","), path: a }
      ),
    ];
    while (qd < e * 1e3) qd += 1e3;
    r.map(function (e) {
      return Wr(e[0]);
    }).forEach(function (e, r) {
      n = n.concat([
        "<v:shape" +
          Re({
            id: "_x0000_s" + ++qd,
            type: "#_x0000_t202",
            style:
              "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10;visibility:hidden",
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1",
          }) +
          ">",
        De(
          "v:fill",
          De("o:fill", null, { type: "gradientUnscaled", "v:ext": "view" }),
          { color2: "#BEFF82", angle: "-180", type: "gradient" }
        ),
        De("v:shadow", null, { on: "t", obscured: "t" }),
        De("v:path", null, { "o:connecttype": "none" }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        "<x:MoveWithCells/>",
        "<x:SizeWithCells/>",
        ye("x:Anchor", [e.c, 0, e.r, 0, e.c + 3, 100, e.r + 5, 100].join(",")),
        ye("x:AutoFill", "False"),
        ye("x:Row", String(e.r)),
        ye("x:Column", String(e.c)),
        "<x:Visible/>",
        "</x:ClientData>",
        "</v:shape>",
      ]);
    });
    n.push("</xml>");
    return n.join("");
  }
  ia.CMNT =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";
  function rv(e, r, t, a, n) {
    for (var i = 0; i != r.length; ++i) {
      var s = r[i];
      var f = Rg(Q(e, s.replace(/^\//, ""), true), s, n);
      if (!f || !f.length) continue;
      var o = I(t);
      for (var l = 0; l != o.length; ++l) {
        var c = o[l];
        var u = a[c];
        if (u) {
          var h = u[s];
          if (h) tv(c, t[c], f);
        }
      }
    }
  }
  function tv(e, r, t) {
    var a = Array.isArray(r);
    var n, i;
    t.forEach(function (e) {
      if (a) {
        i = Wr(e.ref);
        if (!r[i.r]) r[i.r] = [];
        n = r[i.r][i.c];
      } else n = r[e.ref];
      if (!n) {
        n = {};
        if (a) r[i.r][i.c] = n;
        else r[e.ref] = n;
        var t = Kr(r["!ref"] || "BDWGO1000001:A1");
        var s = Wr(e.ref);
        if (t.s.r > s.r) t.s.r = s.r;
        if (t.e.r < s.r) t.e.r = s.r;
        if (t.s.c > s.c) t.s.c = s.c;
        if (t.e.c < s.c) t.e.c = s.c;
        var f = jr(t);
        if (f !== r["!ref"]) r["!ref"] = f;
      }
      if (!n.c) n.c = [];
      var o = { a: e.author, t: e.t, r: e.r };
      if (e.h) o.h = e.h;
      n.c.push(o);
    });
  }
  function av(e, r) {
    if (e.match(/<(?:\w+:)?comments *\/>/)) return [];
    var t = [];
    var a = [];
    var n = e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
    if (n && n[1])
      n[1].split(/<\/\w*:?author>/).forEach(function (e) {
        if (e === "" || e.trim() === "") return;
        var r = e.match(/<(?:\w+:)?author[^>]*>(.*)/);
        if (r) t.push(r[1]);
      });
    var i = e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
    if (i && i[1])
      i[1].split(/<\/\w*:?comment>/).forEach(function (e, n) {
        if (e === "" || e.trim() === "") return;
        var i = e.match(/<(?:\w+:)?comment[^>]*>/);
        if (!i) return;
        var s = se(i[0]);
        var f = {
          author: s.authorId && t[s.authorId] ? t[s.authorId] : "sheetjsghost",
          ref: s.ref,
          guid: s.guid,
        };
        var o = Wr(s.ref);
        if (r.sheetRows && r.sheetRows <= o.r) return;
        var l = e.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
        var c = (!!l && !!l[1] && Vu(l[1])) || { r: "", t: "", h: "" };
        f.r = c.r;
        if (c.r == "<t></t>") c.t = c.h = "";
        f.t = c.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (r.cellHTML) f.h = c.h;
        a.push(f);
      });
    return a;
  }
  var nv = De("comments", null, { xmlns: Ne.main[0] });
  function iv(e, r) {
    var t = [Pe, nv];
    var a = [];
    t.push("<authors>");
    e.map(function (e) {
      return e[1];
    }).forEach(function (e) {
      e.map(function (e) {
        return de(e.a);
      }).forEach(function (e) {
        if (a.indexOf(e) > -1) return;
        a.push(e);
        t.push("<author>" + e + "</author>");
      });
    });
    t.push("</authors>");
    t.push("<commentList>");
    e.forEach(function (e) {
      e[1].forEach(function (r) {
        t.push(
          '<comment ref="' +
            e[0] +
            '" authorId="' +
            a.indexOf(de(r.a)) +
            '"><text>'
        );
        t.push(ye("t", r.t == null ? "" : r.t));
        t.push("</text></comment>");
      });
    });
    t.push("</commentList>");
    if (t.length > 2) {
      t[t.length] = "</comments>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  function sv(e, r) {
    var t = {};
    t.iauthor = e.read_shift(4);
    var a = St(e, 16);
    t.rfx = a.s;
    t.ref = Vr(a.s);
    e.l += 16;
    return t;
  }
  function fv(e, r) {
    if (r == null) r = wr(36);
    r.write_shift(4, e[1].iauthor);
    wt(e[0], r);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    return r;
  }
  var ov = qr;
  function lv(e) {
    return et(e.substr(0, 54));
  }
  function cv(e, r) {
    var t = [];
    var a = [];
    var n = {};
    var i = false;
    Br(e, function s(e, f, o) {
      switch (o) {
        case 632:
          a.push(e);
          break;
        case 635:
          n = e;
          break;
        case 637:
          n.t = e.t;
          n.h = e.h;
          n.r = e.r;
          break;
        case 636:
          n.author = a[n.iauthor];
          delete n.iauthor;
          if (r.sheetRows && r.sheetRows <= n.rfx.r) break;
          if (!n.t) n.t = "";
          delete n.rfx;
          t.push(n);
          break;
        case 35:
          i = true;
          break;
        case 36:
          i = false;
          break;
        case 37:
          break;
        case 38:
          break;
        default:
          if ((f || "").indexOf("Begin") > 0) {
          } else if ((f || "").indexOf("End") > 0) {
          } else if (!i || r.WTF)
            throw new Error("Unexpected record " + o + " " + f);
      }
    });
    return t;
  }
  function uv(e, r) {
    var t = Cr();
    var a = [];
    _r(t, "BrtBeginComments");
    {
      _r(t, "BrtBeginCommentAuthors");
      e.forEach(function (e) {
        e[1].forEach(function (e) {
          if (a.indexOf(e.a) > -1) return;
          a.push(e.a.substr(0, 54));
          _r(t, "BrtCommentAuthor", lv(e.a));
        });
      });
      _r(t, "BrtEndCommentAuthors");
    }
    {
      _r(t, "BrtBeginCommentList");
      e.forEach(function (e) {
        e[1].forEach(function (r) {
          r.iauthor = a.indexOf(r.a);
          var n = { s: Wr(e[0]), e: Wr(e[0]) };
          _r(t, "BrtBeginComment", fv([n, r]));
          if (r.t && r.t.length > 0) _r(t, "BrtCommentText", st(r));
          _r(t, "BrtEndComment");
          delete r.iauthor;
        });
      });
      _r(t, "BrtEndCommentList");
    }
    _r(t, "BrtEndComments");
    return t.end();
  }
  ia.DS =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";
  ia.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";
  function hv(e, r, t, a, n, i) {
    return { "!type": "dialog" };
  }
  function dv(e, r, t, a, n, i) {
    return { "!type": "dialog" };
  }
  function vv(e, r, t, a, n, i) {
    return { "!type": "macro" };
  }
  function pv(e, r, t, a, n, i) {
    return { "!type": "macro" };
  }
  var mv = (function () {
    var e = /(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g;
    var r = { r: 0, c: 0 };
    function t(e, t, a, n, i, s) {
      var f = n.length > 0 ? parseInt(n, 10) | 0 : 0,
        o = s.length > 0 ? parseInt(s, 10) | 0 : 0;
      if (o < 0 && i.length === 0) o = 0;
      var l = false,
        c = false;
      if (i.length > 0 || s.length == 0) l = true;
      if (l) o += r.c;
      else --o;
      if (a.length > 0 || n.length == 0) c = true;
      if (c) f += r.r;
      else --f;
      return t + (l ? "" : "$") + Lr(o) + (c ? "" : "$") + Or(f);
    }
    return function a(n, i) {
      r = i;
      return n.replace(e, t);
    };
  })();
  var bv =
    /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.\(A-Za-z0-9])/g;
  var gv = (function () {
    return function e(r, t) {
      return r.replace(bv, function (e, r, a, n, i, s, f, o) {
        var l = Nr(n) - t.c;
        var c = Dr(s) - t.r;
        return (
          r +
          "R" +
          (c == 0 ? "" : "[" + c + "]") +
          "C" +
          (l == 0 ? "" : "[" + l + "]")
        );
      });
    };
  })();
  function Ev(e, r) {
    return e.replace(bv, function (e, t, a, n, i, s, f, o) {
      return (
        t +
        (a == "$" ? a + n : Lr(Nr(n) + r.c)) +
        (i == "$" ? i + s : Or(Dr(s) + r.r))
      );
    });
  }
  function kv(e, r, t) {
    var a = Gr(r),
      n = a.s,
      i = Wr(t);
    var s = { r: i.r - n.r, c: i.c - n.c };
    return Ev(e, s);
  }
  function Sv(e) {
    return function (r, t) {
      r.l += e;
      return;
    };
  }
  function wv(e) {
    e.l += 1;
    return;
  }
  function Bv(e, r) {
    var t = e.read_shift(r == 1 ? 1 : 2);
    return [t & 16383, (t >> 14) & 1, (t >> 15) & 1];
  }
  function Cv(e, r, t) {
    var a = 2;
    if (t) {
      if (t.biff >= 2 && t.biff <= 5) return _v(e, r, t);
      else if (t.biff == 12) a = 4;
    }
    var n = e.read_shift(a),
      i = e.read_shift(a);
    var s = Bv(e, 2);
    var f = Bv(e, 2);
    return {
      s: { r: n, c: s[0], cRel: s[1], rRel: s[2] },
      e: { r: i, c: f[0], cRel: f[1], rRel: f[2] },
    };
  }
  function _v(e) {
    var r = Bv(e, 2),
      t = Bv(e, 2);
    var a = e.read_shift(1);
    var n = e.read_shift(1);
    return {
      s: { r: r[0], c: a, cRel: r[1], rRel: r[2] },
      e: { r: t[0], c: n, cRel: t[1], rRel: t[2] },
    };
  }
  function Tv(e, r) {
    var t = e.read_shift(r == 12 ? 4 : 2),
      a = e.read_shift(r == 12 ? 4 : 2);
    var n = Bv(e, 2);
    var i = Bv(e, 2);
    return {
      s: { r: t, c: n[0], cRel: n[1], rRel: n[2] },
      e: { r: a, c: i[0], cRel: i[1], rRel: i[2] },
    };
  }
  function xv(e, r, t) {
    if (t && t.biff >= 2 && t.biff <= 5) return Iv(e, r, t);
    var a = e.read_shift(t && t.biff == 12 ? 4 : 2);
    var n = Bv(e, 2);
    return { r: a, c: n[0], cRel: n[1], rRel: n[2] };
  }
  function Iv(e, r, t) {
    var a = Bv(e, 2);
    var n = e.read_shift(1);
    return { r: a[0], c: n, cRel: a[1], rRel: a[2] };
  }
  function Av(e, r, t) {
    var a = t && t.biff ? t.biff : 8;
    if (a >= 2 && a <= 5) return yv(e, r, t);
    var n = e.read_shift(a >= 12 ? 4 : 2);
    var i = e.read_shift(2);
    var s = (i & 32768) >> 15,
      f = (i & 16384) >> 14;
    i &= 16383;
    if (f == 1) while (n > 524287) n -= 1048576;
    if (s == 1) while (i > 8191) i = i - 16384;
    return { r: n, c: i, cRel: s, rRel: f };
  }
  function yv(e, r) {
    var t = e.read_shift(2);
    var a = e.read_shift(1);
    var n = (t & 32768) >> 15,
      i = (t & 16384) >> 14;
    t &= 16383;
    if (n == 1 && t >= 8192) t = t - 16384;
    if (i == 1 && a >= 128) a = a - 256;
    return { r: t, c: a, cRel: i, rRel: n };
  }
  function Rv(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    var n = Cv(e, t.biff >= 2 && t.biff <= 5 ? 6 : 8, t);
    return [a, n];
  }
  function Dv(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    var n = e.read_shift(2, "i");
    var i = 8;
    if (t)
      switch (t.biff) {
        case 5:
          e.l += 12;
          i = 6;
          break;
        case 12:
          i = 12;
          break;
      }
    var s = Cv(e, i, t);
    return [a, n, s];
  }
  function Ov(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    e.l += t && t.biff > 8 ? 12 : 8;
    return [a];
  }
  function Fv(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    var n = e.read_shift(2);
    var i = 8;
    if (t)
      switch (t.biff) {
        case 5:
          e.l += 12;
          i = 6;
          break;
        case 12:
          i = 12;
          break;
      }
    e.l += i;
    return [a, n];
  }
  function Pv(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    var n = Tv(e, t && t.biff > 8 ? 12 : 8, t);
    return [a, n];
  }
  function Nv(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    e.l += t.biff == 2 ? 6 : t.biff == 12 ? 14 : 7;
    return [a];
  }
  function Lv(e, r) {
    var t = e[e.l + 1] & 1;
    var a = 1;
    e.l += 4;
    return [t, a];
  }
  function Mv(e, r, t) {
    e.l += 2;
    var a = e.read_shift(t && t.biff == 2 ? 1 : 2);
    var n = [];
    for (var i = 0; i <= a; ++i) n.push(e.read_shift(t && t.biff == 2 ? 1 : 2));
    return n;
  }
  function Uv(e, r, t) {
    var a = e[e.l + 1] & 255 ? 1 : 0;
    e.l += 2;
    return [a, e.read_shift(t && t.biff == 2 ? 1 : 2)];
  }
  function Hv(e, r, t) {
    var a = e[e.l + 1] & 255 ? 1 : 0;
    e.l += 2;
    return [a, e.read_shift(t && t.biff == 2 ? 1 : 2)];
  }
  function Wv(e, r) {
    var t = e[e.l + 1] & 255 ? 1 : 0;
    e.l += 2;
    return [t, e.read_shift(2)];
  }
  function Vv(e, r, t) {
    var a = e[e.l + 1] & 255 ? 1 : 0;
    e.l += t && t.biff == 2 ? 3 : 4;
    return [a];
  }
  function zv(e, r) {
    var t = e.read_shift(1),
      a = e.read_shift(1);
    return [t, a];
  }
  function Xv(e, r) {
    e.read_shift(2);
    return zv(e, 2);
  }
  function Gv(e, r) {
    e.read_shift(2);
    return zv(e, 2);
  }
  function jv(e, r, t) {
    var a = e[e.l] & 31;
    var n = (e[e.l] & 96) >> 5;
    e.l += 1;
    var i = xv(e, 0, t);
    return [n, i];
  }
  function Kv(e, r, t) {
    var a = (e[e.l] & 96) >> 5;
    e.l += 1;
    var n = Av(e, 0, t);
    return [a, n];
  }
  function Yv(e, r, t) {
    var a = (e[e.l] & 96) >> 5;
    e.l += 1;
    var n = e.read_shift(2);
    var i = xv(e, 0, t);
    return [a, n, i];
  }
  function $v(e, r, t) {
    var a = e[e.l] & 31;
    var n = (e[e.l] & 96) >> 5;
    e.l += 1;
    var i = e.read_shift(t && t.biff <= 3 ? 1 : 2);
    return [om[i], fm[i], n];
  }
  function Zv(e, r, t) {
    e.l++;
    var a = e.read_shift(1),
      n = t && t.biff <= 3 ? [0, e.read_shift(1)] : Qv(e);
    return [a, (n[0] === 0 ? fm : sm)[n[1]]];
  }
  function Qv(e, r) {
    return [e[e.l + 1] >> 7, e.read_shift(2) & 32767];
  }
  function Jv(e, r, t) {
    e.l += t && t.biff == 2 ? 3 : 4;
    return;
  }
  var qv = wv;
  function ep(e, r, t) {
    e.l++;
    if (t && t.biff == 12) return [e.read_shift(4, "i"), 0];
    var a = e.read_shift(2);
    var n = e.read_shift(t && t.biff == 2 ? 1 : 2);
    return [a, n];
  }
  function rp(e, r) {
    e.l++;
    return _t[e.read_shift(1)];
  }
  function tp(e, r) {
    e.l++;
    return e.read_shift(2);
  }
  function ap(e, r) {
    e.l++;
    return e.read_shift(1) !== 0;
  }
  function np(e, r) {
    e.l++;
    return Bt(e, 8);
  }
  function ip(e, r, t) {
    e.l++;
    return ln(e, r - 1, t);
  }
  function sp(e, r) {
    var t = [e.read_shift(1)];
    if (r == 12)
      switch (t[0]) {
        case 2:
          t[0] = 4;
          break;
        case 4:
          t[0] = 16;
          break;
        case 0:
          t[0] = 1;
          break;
        case 1:
          t[0] = 2;
          break;
      }
    switch (t[0]) {
      case 4:
        t[1] = an(e, 1) ? "TRUE" : "FALSE";
        e.l += 7;
        break;
      case 16:
        t[1] = _t[e[e.l]];
        e.l += 8;
        break;
      case 0:
        e.l += 8;
        break;
      case 1:
        t[1] = Bt(e, 8);
        break;
      case 2:
        t[1] = dn(e, 0, { biff: r > 0 && r < 8 ? 2 : r });
        break;
    }
    return t;
  }
  function fp(e, r) {
    var t = e.read_shift(2);
    var a = [];
    for (var n = 0; n != t; ++n) a.push(An(e, 8));
    return a;
  }
  function op(e, r, t) {
    var a = 0,
      n = 0;
    if (t.biff == 12) {
      a = e.read_shift(4);
      n = e.read_shift(4);
    } else {
      n = 1 + e.read_shift(1);
      a = 1 + e.read_shift(2);
    }
    if (t.biff >= 2 && t.biff < 8) {
      --a;
      if (--n == 0) n = 256;
    }
    for (var i = 0, s = []; i != a && (s[i] = []); ++i)
      for (var f = 0; f != n; ++f) s[i][f] = sp(e, t.biff);
    return s;
  }
  function lp(e, r, t) {
    var a = (e.read_shift(1) >>> 5) & 3;
    var n = !t || t.biff >= 8 ? 4 : 2;
    var i = e.read_shift(n);
    switch (t.biff) {
      case 2:
        e.l += 5;
        break;
      case 3:
      case 4:
        e.l += 8;
        break;
      case 5:
        e.l += 12;
        break;
    }
    return [a, 0, i];
  }
  function cp(e, r, t) {
    if (t.biff == 5) return up(e, r, t);
    var a = (e.read_shift(1) >>> 5) & 3;
    var n = e.read_shift(2);
    var i = e.read_shift(4);
    return [a, n, i];
  }
  function up(e, r, t) {
    var a = (e.read_shift(1) >>> 5) & 3;
    var n = e.read_shift(2, "i");
    e.l += 8;
    var i = e.read_shift(2);
    e.l += 12;
    return [a, n, i];
  }
  function hp(e, r, t) {
    var a = (e.read_shift(1) >>> 5) & 3;
    e.l += t && t.biff == 2 ? 3 : 4;
    var n = e.read_shift(t && t.biff == 2 ? 1 : 2);
    return [a, n];
  }
  function dp(e, r, t) {
    var a = (e.read_shift(1) >>> 5) & 3;
    var n = e.read_shift(t && t.biff == 2 ? 1 : 2);
    return [a, n];
  }
  function vp(e, r, t) {
    var a = (e.read_shift(1) >>> 5) & 3;
    e.l += 4;
    if (t.biff == 12) e.l += 2;
    return [a];
  }
  function pp(e, r, t) {
    var a = (e[e.l++] & 96) >> 5;
    var n = e.read_shift(2);
    var i = 4;
    if (t)
      switch (t.biff) {
        case 5:
          throw new Error("PtgRefErr3d -- 5");
        case 12:
          i = 6;
          break;
      }
    e.l += i;
    return [a, n];
  }
  var mp = wv;
  var bp = wv;
  var gp = wv;
  var Ep = wv;
  var kp = wv;
  var Sp = wv;
  var wp = wv;
  var Bp = wv;
  var Cp = wv;
  var _p = wv;
  var Tp = wv;
  var xp = wv;
  var Ip = wv;
  var Ap = wv;
  var yp = wv;
  var Rp = wv;
  var Dp = wv;
  var Op = wv;
  var Fp = wv;
  var Pp = Er;
  var Np = Er;
  var Lp = Er;
  var Mp = {
    1: { n: "PtgExp", f: ep },
    2: { n: "PtgTbl", f: Lp },
    3: { n: "PtgAdd", f: mp },
    4: { n: "PtgSub", f: Rp },
    5: { n: "PtgMul", f: _p },
    6: { n: "PtgDiv", f: bp },
    7: { n: "PtgPower", f: Ap },
    8: { n: "PtgConcat", f: qv },
    9: { n: "PtgLt", f: Bp },
    10: { n: "PtgLe", f: wp },
    11: { n: "PtgEq", f: gp },
    12: { n: "PtgGe", f: Ep },
    13: { n: "PtgGt", f: kp },
    14: { n: "PtgNe", f: Tp },
    15: { n: "PtgIsect", f: Sp },
    16: { n: "PtgUnion", f: Op },
    17: { n: "PtgRange", f: yp },
    18: { n: "PtgUplus", f: Fp },
    19: { n: "PtgUminus", f: Dp },
    20: { n: "PtgPercent", f: Ip },
    21: { n: "PtgParen", f: xp },
    22: { n: "PtgMissArg", f: Cp },
    23: { n: "PtgStr", f: ip },
    28: { n: "PtgErr", f: rp },
    29: { n: "PtgBool", f: ap },
    30: { n: "PtgInt", f: tp },
    31: { n: "PtgNum", f: np },
    32: { n: "PtgArray", f: Nv },
    33: { n: "PtgFunc", f: $v },
    34: { n: "PtgFuncVar", f: Zv },
    35: { n: "PtgName", f: lp },
    36: { n: "PtgRef", f: jv },
    37: { n: "PtgArea", f: Rv },
    38: { n: "PtgMemArea", f: hp },
    39: { n: "PtgMemErr", f: Pp },
    40: { n: "PtgMemNoMem", f: Np },
    41: { n: "PtgMemFunc", f: dp },
    42: { n: "PtgRefErr", f: vp },
    43: { n: "PtgAreaErr", f: Ov },
    44: { n: "PtgRefN", f: Kv },
    45: { n: "PtgAreaN", f: Pv },
    57: { n: "PtgNameX", f: cp },
    58: { n: "PtgRef3d", f: Yv },
    59: { n: "PtgArea3d", f: Dv },
    60: { n: "PtgRefErr3d", f: pp },
    61: { n: "PtgAreaErr3d", f: Fv },
    255: {},
  };
  var Up = {
    64: 32,
    96: 32,
    65: 33,
    97: 33,
    66: 34,
    98: 34,
    67: 35,
    99: 35,
    68: 36,
    100: 36,
    69: 37,
    101: 37,
    70: 38,
    102: 38,
    71: 39,
    103: 39,
    72: 40,
    104: 40,
    73: 41,
    105: 41,
    74: 42,
    106: 42,
    75: 43,
    107: 43,
    76: 44,
    108: 44,
    77: 45,
    109: 45,
    89: 57,
    121: 57,
    90: 58,
    122: 58,
    91: 59,
    123: 59,
    92: 60,
    124: 60,
    93: 61,
    125: 61,
  };
  (function () {
    for (var e in Up) Mp[e] = Mp[Up[e]];
  })();
  var Hp = {};
  var Wp = {
    1: { n: "PtgAttrSemi", f: Vv },
    2: { n: "PtgAttrIf", f: Hv },
    4: { n: "PtgAttrChoose", f: Mv },
    8: { n: "PtgAttrGoto", f: Uv },
    16: { n: "PtgAttrSum", f: Jv },
    32: { n: "PtgAttrBaxcel", f: Lv },
    64: { n: "PtgAttrSpace", f: Xv },
    65: { n: "PtgAttrSpaceSemi", f: Gv },
    128: { n: "PtgAttrIfError", f: Wv },
    255: {},
  };
  function Vp(e, r, t) {
    var a = e.l + r;
    var n = wn(e, 6);
    if (t.biff == 2) ++e.l;
    var i = zp(e, 8);
    var s = e.read_shift(1);
    if (t.biff != 2) {
      e.read_shift(1);
      if (t.biff >= 5) {
        var f = e.read_shift(4);
      }
    }
    var o = jp(e, a - e.l, t);
    return { cell: n, val: i[0], formula: o, shared: (s >> 3) & 1, tt: i[1] };
  }
  function zp(e) {
    var r;
    if (sr(e, e.l + 6) !== 65535) return [Bt(e), "n"];
    switch (e[e.l]) {
      case 0:
        e.l += 8;
        return ["String", "s"];
      case 1:
        r = e[e.l + 2] === 1;
        e.l += 8;
        return [r, "b"];
      case 2:
        r = e[e.l + 2];
        e.l += 8;
        return [r, "e"];
      case 3:
        e.l += 8;
        return ["", "s"];
    }
    return [];
  }
  function Xp(e, r, t, a) {
    if (a.biff < 8) return Er(e, r);
    var n = e.l + r;
    var i = [];
    for (var s = 0; s !== t.length; ++s) {
      switch (t[s][0]) {
        case "PtgArray":
          t[s][1] = op(e, 0, a);
          i.push(t[s][1]);
          break;
        case "PtgMemArea":
          t[s][2] = fp(e, t[s][1]);
          i.push(t[s][2]);
          break;
        case "PtgExp":
          if (a && a.biff == 12) {
            t[s][1][1] = e.read_shift(4);
            i.push(t[s][1]);
          }
          break;
        default:
          break;
      }
    }
    r = n - e.l;
    if (r !== 0) i.push(Er(e, r));
    return i;
  }
  function Gp(e, r, t, a) {
    var n = e.l + r;
    var i = $p(e, a, t);
    var s;
    if (n !== e.l) s = Xp(e, n - e.l, i, t);
    return [i, s];
  }
  function jp(e, r, t) {
    var a = e.l + r,
      n = t.biff == 2 ? 1 : 2;
    var i,
      s = e.read_shift(n);
    if (s == 65535) return [[], Er(e, r - 2)];
    var f = $p(e, s, t);
    if (r !== s + n) i = Xp(e, r - s - n, f, t);
    return [f, i];
  }
  function Kp(e, r, t) {
    var a = e.l + r;
    var n,
      i = e.read_shift(2);
    var s = $p(e, i, t);
    if (i == 65535) return [[], Er(e, r - 2)];
    if (r !== i + 2) n = Xp(e, a - i - 2, s, t);
    return [s, n];
  }
  function Yp(e, r, t, a) {
    var n = e.l + r,
      i = t.biff == 2 ? 1 : 2;
    var s,
      f = e.read_shift(i);
    if (f == 65535) return [[], Er(e, r - 2)];
    var o = $p(e, f, t);
    if (r !== f + i) s = Xp(e, r - f - i, o, t);
    return [o, s];
  }
  function $p(e, r, t) {
    var a = e.l + r;
    var n,
      i,
      s = [];
    while (a != e.l) {
      r = a - e.l;
      i = e[e.l];
      n = Mp[i];
      if (i === 24 || i === 25) {
        i = e[e.l + 1];
        n = (i === 24 ? Hp : Wp)[i];
      }
      if (!n || !n.f) {
        Er(e, r);
      } else {
        s.push([n.n, n.f(e, r, t)]);
      }
    }
    return s;
  }
  function Zp(e) {
    var r = [];
    for (var t = 0; t < e.length; ++t) {
      var a = e[t],
        n = [];
      for (var i = 0; i < a.length; ++i) {
        var s = a[i];
        if (s)
          switch (s[0]) {
            case 2:
              n.push('"' + s[1].replace(/"/g, '""') + '"');
              break;
            default:
              n.push(s[1]);
          }
        else n.push("");
      }
      r.push(n.join(","));
    }
    return r.join(";");
  }
  var Qp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-",
  };
  function Jp(e, r, t) {
    return e.SheetNames[r];
  }
  function qp(e, r, t, a, n) {
    var i = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    var s = [],
      f,
      o,
      l,
      c,
      u = 0,
      h = 0,
      d,
      v = "";
    if (!e[0] || !e[0][0]) return "";
    var p = -1,
      m = "";
    for (var b = 0, g = e[0].length; b < g; ++b) {
      var E = e[0][b];
      switch (E[0]) {
        case "PtgUminus":
          s.push("-" + s.pop());
          break;
        case "PtgUplus":
          s.push("+" + s.pop());
          break;
        case "PtgPercent":
          s.push(s.pop() + "%");
          break;
        case "PtgAdd":
        case "PtgConcat":
        case "PtgDiv":
        case "PtgEq":
        case "PtgGe":
        case "PtgGt":
        case "PtgLe":
        case "PtgLt":
        case "PtgMul":
        case "PtgNe":
        case "PtgPower":
        case "PtgSub":
          f = s.pop();
          o = s.pop();
          if (p >= 0) {
            switch (e[0][p][1][0]) {
              case 0:
                m = X(" ", e[0][p][1][1]);
                break;
              case 1:
                m = X("\r", e[0][p][1][1]);
                break;
              default:
                m = "";
                if (n.WTF)
                  throw new Error(
                    "Unexpected PtgAttrSpaceType " + e[0][p][1][0]
                  );
            }
            o = o + m;
            p = -1;
          }
          s.push(o + Qp[E[0]] + f);
          break;
        case "PtgIsect":
          f = s.pop();
          o = s.pop();
          s.push(o + " " + f);
          break;
        case "PtgUnion":
          f = s.pop();
          o = s.pop();
          s.push(o + "," + f);
          break;
        case "PtgRange":
          f = s.pop();
          o = s.pop();
          s.push(o + ":" + f);
          break;
        case "PtgAttrChoose":
          break;
        case "PtgAttrGoto":
          break;
        case "PtgAttrIf":
          break;
        case "PtgAttrIfError":
          break;
        case "PtgRef":
          l = E[1][0];
          c = Tr(E[1][1], i, n);
          s.push(Ir(c));
          break;
        case "PtgRefN":
          l = E[1][0];
          c = t ? Tr(E[1][1], t, n) : E[1][1];
          s.push(Ir(c));
          break;
        case "PtgRef3d":
          l = E[1][0];
          u = E[1][1];
          c = Tr(E[1][2], i, n);
          v = Jp(a, u, n);
          var k = v;
          s.push(v + "!" + Ir(c));
          break;
        case "PtgFunc":
        case "PtgFuncVar":
          var S = E[1][0],
            w = E[1][1];
          if (!S) S = 0;
          var B = S == 0 ? [] : s.slice(-S);
          s.length -= S;
          if (w === "User") w = B.shift();
          s.push(w + "(" + B.join(",") + ")");
          break;
        case "PtgBool":
          s.push(E[1] ? "TRUE" : "FALSE");
          break;
        case "PtgInt":
          s.push(E[1]);
          break;
        case "PtgNum":
          s.push(String(E[1]));
          break;
        case "PtgStr":
          s.push('"' + E[1] + '"');
          break;
        case "PtgErr":
          s.push(E[1]);
          break;
        case "PtgAreaN":
          l = E[1][0];
          d = xr(E[1][1], i, n);
          s.push(Ar(d, n));
          break;
        case "PtgArea":
          l = E[1][0];
          d = xr(E[1][1], i, n);
          s.push(Ar(d, n));
          break;
        case "PtgArea3d":
          l = E[1][0];
          u = E[1][1];
          d = E[1][2];
          v = a && a[1] ? a[1][u + 1] : "**MISSING**";
          s.push(v + "!" + jr(d));
          break;
        case "PtgAttrSum":
          s.push("SUM(" + s.pop() + ")");
          break;
        case "PtgAttrSemi":
          break;
        case "PtgName":
          h = E[1][2];
          var C = (a.names || [])[h - 1] || (a[0] || [])[h];
          var _ = C ? C.Name : "SH33TJSERR7" + String(h);
          if (_ in lm) _ = lm[_];
          s.push(_);
          break;
        case "PtgNameX":
          var T = E[1][1];
          h = E[1][2];
          var x;
          if (n.biff <= 5) {
            if (T < 0) T = -T;
            if (a[T]) x = a[T][h];
          } else {
            var I = a.SheetNames[T];
            var A = "";
            if (((a[T] || [])[0] || [])[0] == 14849) {
            } else if (((a[T] || [])[0] || [])[0] == 1025) {
              if (a[T][h] && a[T][h].itab > 0) {
                A = a.SheetNames[a[T][h].itab - 1] + "!";
              }
            } else A = a.SheetNames[h - 1] + "!";
            if (a[T] && a[T][h]) A += a[T][h].Name;
            else if (a[0] && a[0][h]) A += a[0][h].Name;
            else A += "SH33TJSERRX";
            s.push(A);
            break;
          }
          if (!x) x = { Name: "SH33TJSERRY" };
          s.push(x.Name);
          break;
        case "PtgParen":
          var y = "(",
            R = ")";
          if (p >= 0) {
            m = "";
            switch (e[0][p][1][0]) {
              case 2:
                y = X(" ", e[0][p][1][1]) + y;
                break;
              case 3:
                y = X("\r", e[0][p][1][1]) + y;
                break;
              case 4:
                R = X(" ", e[0][p][1][1]) + R;
                break;
              case 5:
                R = X("\r", e[0][p][1][1]) + R;
                break;
              default:
                if (n.WTF)
                  throw new Error(
                    "Unexpected PtgAttrSpaceType " + e[0][p][1][0]
                  );
            }
            p = -1;
          }
          s.push(y + s.pop() + R);
          break;
        case "PtgRefErr":
          s.push("#REF!");
          break;
        case "PtgRefErr3d":
          s.push("#REF!");
          break;
        case "PtgExp":
          c = { c: E[1][1], r: E[1][0] };
          var D = { c: t.c, r: t.r };
          if (a.sharedf[Vr(c)]) {
            var O = a.sharedf[Vr(c)];
            s.push(qp(O, i, D, a, n));
          } else {
            var F = false;
            for (f = 0; f != a.arrayf.length; ++f) {
              o = a.arrayf[f];
              if (c.c < o[0].s.c || c.c > o[0].e.c) continue;
              if (c.r < o[0].s.r || c.r > o[0].e.r) continue;
              s.push(qp(o[1], i, D, a, n));
              F = true;
              break;
            }
            if (!F) s.push(E[1]);
          }
          break;
        case "PtgArray":
          s.push("{" + Zp(E[1]) + "}");
          break;
        case "PtgMemArea":
          break;
        case "PtgAttrSpace":
        case "PtgAttrSpaceSemi":
          p = b;
          break;
        case "PtgTbl":
          break;
        case "PtgMemErr":
          break;
        case "PtgMissArg":
          s.push("");
          break;
        case "PtgAreaErr":
          s.push("#REF!");
          break;
        case "PtgAreaErr3d":
          s.push("#REF!");
          break;
        case "PtgMemFunc":
          break;
        default:
          throw new Error("Unrecognized Formula Token: " + String(E));
      }
      var P = ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"];
      if (p >= 0 && P.indexOf(e[0][b][0]) == -1) {
        E = e[0][p];
        var N = true;
        switch (E[1][0]) {
          case 4:
            N = false;
          case 0:
            m = X(" ", E[1][1]);
            break;
          case 5:
            N = false;
          case 1:
            m = X("\r", E[1][1]);
            break;
          default:
            m = "";
            if (n.WTF)
              throw new Error("Unexpected PtgAttrSpaceType " + E[1][0]);
        }
        s.push((N ? m : "") + s.pop() + (N ? "" : m));
        p = -1;
      }
    }
    if (s.length > 1 && n.WTF) throw new Error("bad formula stack");
    return s[0];
  }
  function em(e, r, t) {
    var a = e.l + r;
    var n = e.read_shift(4);
    var i = $p(e, n, t);
    var s = e.read_shift(4);
    var f = s > 0 ? Xp(e, s, i, t) : null;
    return [i, f];
  }
  var rm = em;
  var tm = em;
  var am = em;
  var nm = em;
  var im = { 1: "REFERENCE", 2: "VALUE", 3: "ARRAY" };
  var sm = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS",
  };
  var fm = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS",
  };
  var om = {
    2: 1,
    3: 1,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    90: 1,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0,
  };
  var lm = {
    "_xlfn.ACOT": "ACOT",
    "_xlfn.ACOTH": "ACOTH",
    "_xlfn.AGGREGATE": "AGGREGATE",
    "_xlfn.ARABIC": "ARABIC",
    "_xlfn.AVERAGEIF": "AVERAGEIF",
    "_xlfn.AVERAGEIFS": "AVERAGEIFS",
    "_xlfn.BASE": "BASE",
    "_xlfn.BETA.DIST": "BETA.DIST",
    "_xlfn.BETA.INV": "BETA.INV",
    "_xlfn.BINOM.DIST": "BINOM.DIST",
    "_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
    "_xlfn.BINOM.INV": "BINOM.INV",
    "_xlfn.BITAND": "BITAND",
    "_xlfn.BITLSHIFT": "BITLSHIFT",
    "_xlfn.BITOR": "BITOR",
    "_xlfn.BITRSHIFT": "BITRSHIFT",
    "_xlfn.BITXOR": "BITXOR",
    "_xlfn.CEILING.MATH": "CEILING.MATH",
    "_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
    "_xlfn.CHISQ.DIST": "CHISQ.DIST",
    "_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
    "_xlfn.CHISQ.INV": "CHISQ.INV",
    "_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
    "_xlfn.CHISQ.TEST": "CHISQ.TEST",
    "_xlfn.COMBINA": "COMBINA",
    "_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
    "_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
    "_xlfn.COT": "COT",
    "_xlfn.COTH": "COTH",
    "_xlfn.COUNTIFS": "COUNTIFS",
    "_xlfn.COVARIANCE.P": "COVARIANCE.P",
    "_xlfn.COVARIANCE.S": "COVARIANCE.S",
    "_xlfn.CSC": "CSC",
    "_xlfn.CSCH": "CSCH",
    "_xlfn.DAYS": "DAYS",
    "_xlfn.DECIMAL": "DECIMAL",
    "_xlfn.ECMA.CEILING": "ECMA.CEILING",
    "_xlfn.ERF.PRECISE": "ERF.PRECISE",
    "_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
    "_xlfn.EXPON.DIST": "EXPON.DIST",
    "_xlfn.F.DIST": "F.DIST",
    "_xlfn.F.DIST.RT": "F.DIST.RT",
    "_xlfn.F.INV": "F.INV",
    "_xlfn.F.INV.RT": "F.INV.RT",
    "_xlfn.F.TEST": "F.TEST",
    "_xlfn.FILTERXML": "FILTERXML",
    "_xlfn.FLOOR.MATH": "FLOOR.MATH",
    "_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
    "_xlfn.FORMULATEXT": "FORMULATEXT",
    "_xlfn.GAMMA": "GAMMA",
    "_xlfn.GAMMA.DIST": "GAMMA.DIST",
    "_xlfn.GAMMA.INV": "GAMMA.INV",
    "_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
    "_xlfn.GAUSS": "GAUSS",
    "_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
    "_xlfn.IFNA": "IFNA",
    "_xlfn.IFERROR": "IFERROR",
    "_xlfn.IMCOSH": "IMCOSH",
    "_xlfn.IMCOT": "IMCOT",
    "_xlfn.IMCSC": "IMCSC",
    "_xlfn.IMCSCH": "IMCSCH",
    "_xlfn.IMSEC": "IMSEC",
    "_xlfn.IMSECH": "IMSECH",
    "_xlfn.IMSINH": "IMSINH",
    "_xlfn.IMTAN": "IMTAN",
    "_xlfn.ISFORMULA": "ISFORMULA",
    "_xlfn.ISO.CEILING": "ISO.CEILING",
    "_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
    "_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
    "_xlfn.LOGNORM.INV": "LOGNORM.INV",
    "_xlfn.MODE.MULT": "MODE.MULT",
    "_xlfn.MODE.SNGL": "MODE.SNGL",
    "_xlfn.MUNIT": "MUNIT",
    "_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
    "_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
    "_xlfn.NIGBINOM": "NIGBINOM",
    "_xlfn.NORM.DIST": "NORM.DIST",
    "_xlfn.NORM.INV": "NORM.INV",
    "_xlfn.NORM.S.DIST": "NORM.S.DIST",
    "_xlfn.NORM.S.INV": "NORM.S.INV",
    "_xlfn.NUMBERVALUE": "NUMBERVALUE",
    "_xlfn.PDURATION": "PDURATION",
    "_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
    "_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
    "_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
    "_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
    "_xlfn.PERMUTATIONA": "PERMUTATIONA",
    "_xlfn.PHI": "PHI",
    "_xlfn.POISSON.DIST": "POISSON.DIST",
    "_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
    "_xlfn.QUARTILE.INC": "QUARTILE.INC",
    "_xlfn.QUERYSTRING": "QUERYSTRING",
    "_xlfn.RANK.AVG": "RANK.AVG",
    "_xlfn.RANK.EQ": "RANK.EQ",
    "_xlfn.RRI": "RRI",
    "_xlfn.SEC": "SEC",
    "_xlfn.SECH": "SECH",
    "_xlfn.SHEET": "SHEET",
    "_xlfn.SHEETS": "SHEETS",
    "_xlfn.SKEW.P": "SKEW.P",
    "_xlfn.STDEV.P": "STDEV.P",
    "_xlfn.STDEV.S": "STDEV.S",
    "_xlfn.SUMIFS": "SUMIFS",
    "_xlfn.T.DIST": "T.DIST",
    "_xlfn.T.DIST.2T": "T.DIST.2T",
    "_xlfn.T.DIST.RT": "T.DIST.RT",
    "_xlfn.T.INV": "T.INV",
    "_xlfn.T.INV.2T": "T.INV.2T",
    "_xlfn.T.TEST": "T.TEST",
    "_xlfn.UNICHAR": "UNICHAR",
    "_xlfn.UNICODE": "UNICODE",
    "_xlfn.VAR.P": "VAR.P",
    "_xlfn.VAR.S": "VAR.S",
    "_xlfn.WEBSERVICE": "WEBSERVICE",
    "_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
    "_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
    "_xlfn.XOR": "XOR",
    "_xlfn.Z.TEST": "Z.TEST",
  };
  function cm(e) {
    if (e.substr(0, 3) == "of:") e = e.substr(3);
    if (e.charCodeAt(0) == 61) {
      e = e.substr(1);
      if (e.charCodeAt(0) == 61) e = e.substr(1);
    }
    e = e.replace(/COM\.MICROSOFT\./g, "");
    e = e.replace(
      /\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g,
      function (e, r) {
        return r.replace(/\./g, "");
      }
    );
    e = e.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return e.replace(/[;~]/g, ",").replace(/\|/g, ";");
  }
  function um(e) {
    var r = "of:=" + e.replace(bv, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    return r.replace(/;/g, "|").replace(/,/g, ";");
  }
  function hm(e) {
    var r = e.split(":");
    var t = r[0].split(".")[0];
    return [t, r[0].split(".")[1] + ":" + r[1].split(".")[1]];
  }
  var dm = {};
  var vm = {};
  ia.WS = [
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
    "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet",
  ];
  function pm(e, r) {
    for (var t = 0, a = e.length; t < a; ++t)
      if (e[t].t === r) {
        e.Count++;
        return t;
      }
    e[a] = { t: r };
    e.Count++;
    e.Unique++;
    return a;
  }
  function mm(e, r) {
    var t = { min: e + 1, max: e + 1 };
    var a = -1;
    if (r.MDW) Rh = r.MDW;
    if (r.width != null) t.customWidth = 1;
    else if (r.wpx != null) a = Oh(r.wpx);
    else if (r.wch != null) a = r.wch;
    if (a > -1) {
      t.width = Fh(a);
      t.customWidth = 1;
    } else if (r.width != null) t.width = r.width;
    if (r.hidden) t.hidden = true;
    return t;
  }
  function bm(e, r) {
    if (!e) return;
    var t = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
    if (r == "xlml") t = [1, 1, 1, 1, 0.5, 0.5];
    if (e.left == null) e.left = t[0];
    if (e.right == null) e.right = t[1];
    if (e.top == null) e.top = t[2];
    if (e.bottom == null) e.bottom = t[3];
    if (e.header == null) e.header = t[4];
    if (e.footer == null) e.footer = t[5];
  }
  function gm(e, r, t) {
    var a = t.revssf[r.z != null ? r.z : "General"];
    var n = 60,
      i = e.length;
    if (a == null && t.ssf) {
      for (; n < 392; ++n)
        if (t.ssf[n] == null) {
          E.load(r.z, n);
          t.ssf[n] = r.z;
          t.revssf[r.z] = a = n;
          break;
        }
    }
    for (n = 0; n != i; ++n) if (e[n].numFmtId === a) return n;
    e[i] = {
      numFmtId: a,
      fontId: 0,
      fillId: 0,
      borderId: 0,
      xfId: 0,
      applyNumberFormat: 1,
    };
    return i;
  }
  function Em(e, r, t, a, n, i) {
    if (e.t === "z") return;
    if (e.t === "d" && typeof e.v === "string") e.v = H(e.v);
    try {
      if (a.cellNF) e.z = E._table[r];
    } catch (s) {
      if (a.WTF) throw s;
    }
    if (!a || a.cellText !== false)
      try {
        if (e.t === "e") e.w = e.w || _t[e.v];
        else if (r === 0) {
          if (e.t === "n") {
            if ((e.v | 0) === e.v) e.w = E._general_int(e.v);
            else e.w = E._general_num(e.v);
          } else if (e.t === "d") {
            var f = P(e.v);
            if ((f | 0) === f) e.w = E._general_int(f);
            else e.w = E._general_num(f);
          } else if (e.v === undefined) return "";
          else e.w = E._general(e.v, vm);
        } else if (e.t === "d") e.w = E.format(r, P(e.v), vm);
        else e.w = E.format(r, e.v, vm);
      } catch (s) {
        if (a.WTF) throw s;
      }
    if (t)
      try {
        e.s = i.Fills[t];
        if (e.s.fgColor && e.s.fgColor.theme && !e.s.fgColor.rgb) {
          e.s.fgColor.rgb = xh(
            n.themeElements.clrScheme[e.s.fgColor.theme].rgb,
            e.s.fgColor.tint || 0
          );
          if (a.WTF)
            e.s.fgColor.raw_rgb =
              n.themeElements.clrScheme[e.s.fgColor.theme].rgb;
        }
        if (e.s.bgColor && e.s.bgColor.theme) {
          e.s.bgColor.rgb = xh(
            n.themeElements.clrScheme[e.s.bgColor.theme].rgb,
            e.s.bgColor.tint || 0
          );
          if (a.WTF)
            e.s.bgColor.raw_rgb =
              n.themeElements.clrScheme[e.s.bgColor.theme].rgb;
        }
      } catch (s) {
        if (a.WTF) throw s;
      }
  }
  function km(e, r) {
    var t = Kr(r);
    if (t.s.r <= t.e.r && t.s.c <= t.e.c && t.s.r >= 0 && t.s.c >= 0)
      e["!ref"] = jr(t);
  }
  var Sm = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
  var wm = /<(?:\w+:)?sheetData>([\s\S]*)<\/(?:\w+:)?sheetData>/;
  var Bm = /<(?:\w:)?hyperlink [^>]*>/gm;
  var Cm = /"(\w*:\w*)"/;
  var _m = /<(?:\w:)?col[^>]*[\/]?>/g;
  var Tm = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
  var xm = /<(?:\w:)?pageMargins[^>]*\/>/g;
  function Im(e, r, t, a, n, i) {
    if (!e) return e;
    if (c != null && r.dense == null) r.dense = c;
    var s = r.dense ? [] : {};
    var f = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
    var o = "",
      l = "";
    var u = e.match(wm);
    if (u) {
      o = e.substr(0, u.index);
      l = e.substr(u.index + u[0].length);
    } else o = l = e;
    var h = (o.match(/<(?:\w*:)?dimension/) || { index: -1 }).index;
    if (h > 0) {
      var d = o.substr(h, 50).match(Cm);
      if (d) km(s, d[1]);
    }
    var v = [];
    if (r.cellStyles) {
      var p = o.match(_m);
      if (p) Fm(v, p);
    }
    if (u) Hm(u[1], s, r, f, n, i);
    var m = l.match(Tm);
    if (m) s["!autofilter"] = Nm(m[0]);
    var b = [];
    var g = l.match(Sm);
    if (g)
      for (h = 0; h != g.length; ++h)
        b[h] = Kr(g[h].substr(g[h].indexOf('"') + 1));
    var E = l.match(Bm);
    if (E) Rm(s, E, t);
    var k = l.match(xm);
    if (k) s["!margins"] = Dm(se(k[0]));
    if (!s["!ref"] && f.e.c >= f.s.c && f.e.r >= f.s.r) s["!ref"] = jr(f);
    if (r.sheetRows > 0 && s["!ref"]) {
      var S = Kr(s["!ref"]);
      if (r.sheetRows < +S.e.r) {
        S.e.r = r.sheetRows - 1;
        if (S.e.r > f.e.r) S.e.r = f.e.r;
        if (S.e.r < S.s.r) S.s.r = S.e.r;
        if (S.e.c > f.e.c) S.e.c = f.e.c;
        if (S.e.c < S.s.c) S.s.c = S.e.c;
        s["!fullref"] = s["!ref"];
        s["!ref"] = jr(S);
      }
    }
    if (v.length > 0) s["!cols"] = v;
    if (b.length > 0) s["!merges"] = b;
    return s;
  }
  function Am(e) {
    if (e.length == 0) return "";
    var r = '<mergeCells count="' + e.length + '">';
    for (var t = 0; t != e.length; ++t)
      r += '<mergeCell ref="' + jr(e[t]) + '"/>';
    return r + "</mergeCells>";
  }
  function ym(e) {
    var r = { sheet: 1 };
    var t = [
      "objects",
      "scenarios",
      "selectLockedCells",
      "selectUnlockedCells",
    ];
    var a = [
      "formatColumns",
      "formatRows",
      "formatCells",
      "insertColumns",
      "insertRows",
      "insertHyperlinks",
      "deleteColumns",
      "deleteRows",
      "sort",
      "autoFilter",
      "pivotTables",
    ];
    t.forEach(function (t) {
      if (e[t] != null && e[t]) r[t] = "1";
    });
    a.forEach(function (t) {
      if (e[t] != null && !e[t]) r[t] = "0";
    });
    if (e.password) r.password = mh(e.password).toString(16).toUpperCase();
    return De("sheetProtection", null, r);
  }
  function Rm(e, r, t) {
    var a = Array.isArray(e);
    for (var n = 0; n != r.length; ++n) {
      var i = se(ke(r[n]), true);
      if (!i.ref) return;
      var s = t ? t["!id"][i.id] : null;
      if (s) {
        i.Target = s.Target;
        if (i.location) i.Target += "#" + i.location;
        i.Rel = s;
      } else {
        i.Target = i.location;
        s = { Target: i.location, TargetMode: "Internal" };
        i.Rel = s;
      }
      if (i.tooltip) {
        i.Tooltip = i.tooltip;
        delete i.tooltip;
      }
      var f = Kr(i.ref);
      for (var o = f.s.r; o <= f.e.r; ++o)
        for (var l = f.s.c; l <= f.e.c; ++l) {
          var c = Vr({ c: l, r: o });
          if (a) {
            if (!e[o]) e[o] = [];
            if (!e[o][l]) e[o][l] = { t: "z", v: undefined };
            e[o][l].l = i;
          } else {
            if (!e[c]) e[c] = { t: "z", v: undefined };
            e[c].l = i;
          }
        }
    }
  }
  function Dm(e) {
    var r = {};
    ["left", "right", "top", "bottom", "header", "footer"].forEach(function (
      t
    ) {
      if (e[t]) r[t] = parseFloat(e[t]);
    });
    return r;
  }
  function Om(e) {
    bm(e);
    return De("pageMargins", null, e);
  }
  function Fm(e, r) {
    var t = false;
    for (var a = 0; a != r.length; ++a) {
      var n = se(r[a], true);
      if (n.hidden) n.hidden = Ee(n.hidden);
      var i = parseInt(n.min, 10) - 1,
        s = parseInt(n.max, 10) - 1;
      delete n.min;
      delete n.max;
      n.width = +n.width;
      if (!t && n.width) {
        t = true;
        Mh(n.width);
      }
      Hh(n);
      while (i <= s) e[i++] = z(n);
    }
  }
  function Pm(e, r) {
    var t = ["<cols>"],
      a,
      n;
    for (var i = 0; i != r.length; ++i) {
      if (!(a = r[i])) continue;
      t[t.length] = De("col", null, mm(i, a));
    }
    t[t.length] = "</cols>";
    return t.join("");
  }
  function Nm(e) {
    var r = { ref: (e.match(/ref="([^"]*)"/) || [])[1] };
    return r;
  }
  function Lm(e) {
    return De("autoFilter", null, { ref: e.ref });
  }
  function Mm(e, r, t, a) {
    return De("sheetViews", De("sheetView", null, { workbookViewId: "0" }), {});
  }
  function Um(e, r, t, a, n, i) {
    if ((e.v === undefined && e.f === undefined) || e.t === "z") return "";
    var s = "";
    var f = e.t,
      o = e.v;
    switch (e.t) {
      case "b":
        s = e.v ? "1" : "0";
        break;
      case "n":
        s = "" + e.v;
        break;
      case "e":
        s = _t[e.v];
        break;
      case "d":
        if (a.cellDates) s = H(e.v, -1).toISOString();
        else {
          e.t = "n";
          s = "" + (e.v = P(H(e.v)));
        }
        if (typeof e.z === "undefined") e.z = E._table[14];
        break;
      default:
        s = e.v;
        break;
    }
    var l = ye("v", de(s)),
      c = { r: r };
    var u = gm(a.cellXfs, e, a);
    if (u !== 0) c.s = u;
    switch (e.t) {
      case "n":
        break;
      case "d":
        c.t = "d";
        break;
      case "b":
        c.t = "b";
        break;
      case "e":
        c.t = "e";
        break;
      default:
        if (e.v == null) {
          delete e.t;
          break;
        }
        if (a.bookSST) {
          l = ye("v", "" + pm(a.Strings, e.v));
          c.t = "s";
          break;
        }
        c.t = "str";
        break;
    }
    if (e.t != f) {
      e.t = f;
      e.v = o;
    }
    if (e.f) {
      var h =
        e.F && e.F.substr(0, r.length) == r ? { t: "array", ref: e.F } : null;
      l = De("f", de(e.f), h) + (e.v != null ? l : "");
    }
    if (e.l) t["!links"].push([r, e.l]);
    if (e.c) t["!comments"].push([r, e.c]);
    return De("c", l, c);
  }
  var Hm = (function Jk() {
    var e = /<(?:\w+:)?c[ >]/,
      r = /<\/(?:\w+:)?row>/;
    var t = /r=["']([^"']*)["']/,
      a = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
    var n = /ref=["']([^"']*)["']/;
    var i = Ce("v"),
      s = Ce("f");
    return function f(o, l, c, u, h, d) {
      var v = 0,
        p = "",
        m = [],
        b = [],
        g = 0,
        k = 0,
        S = 0,
        w = "",
        B;
      var C,
        _ = 0,
        T = 0;
      var x, I;
      var A = 0,
        y = 0;
      var R = Array.isArray(d.CellXf),
        D;
      var O = [];
      var F = [];
      var L = Array.isArray(l);
      var M = [],
        U = {},
        W = false;
      for (var V = o.split(r), z = 0, X = V.length; z != X; ++z) {
        p = V[z].trim();
        var G = p.length;
        if (G === 0) continue;
        for (v = 0; v < G; ++v) if (p.charCodeAt(v) === 62) break;
        ++v;
        C = se(p.substr(0, v), true);
        _ = C.r != null ? parseInt(C.r, 10) : _ + 1;
        T = -1;
        if (c.sheetRows && c.sheetRows < _) continue;
        if (u.s.r > _ - 1) u.s.r = _ - 1;
        if (u.e.r < _ - 1) u.e.r = _ - 1;
        if (c && c.cellStyles) {
          U = {};
          W = false;
          if (C.ht) {
            W = true;
            U.hpt = parseFloat(C.ht);
            U.hpx = Xh(U.hpt);
          }
          if (C.hidden == "1") {
            W = true;
            U.hidden = true;
          }
          if (C.outlineLevel != null) {
            W = true;
            U.level = +C.outlineLevel;
          }
          if (W) M[_ - 1] = U;
        }
        m = p.substr(v).split(e);
        for (v = 0; v != m.length; ++v) {
          p = m[v].trim();
          if (p.length === 0) continue;
          b = p.match(t);
          g = v;
          k = 0;
          S = 0;
          p = "<c " + (p.substr(0, 1) == "<" ? ">" : "") + p;
          if (b != null && b.length === 2) {
            g = 0;
            w = b[1];
            for (k = 0; k != w.length; ++k) {
              if ((S = w.charCodeAt(k) - 64) < 1 || S > 26) break;
              g = 26 * g + S;
            }
            --g;
            T = g;
          } else ++T;
          for (k = 0; k != p.length; ++k) if (p.charCodeAt(k) === 62) break;
          ++k;
          C = se(p.substr(0, k), true);
          if (!C.r) C.r = Vr({ r: _ - 1, c: T });
          w = p.substr(k);
          B = { t: "" };
          if ((b = w.match(i)) != null && b[1] !== "") B.v = ce(b[1]);
          if (c.cellFormula) {
            if ((b = w.match(s)) != null && b[1] !== "") {
              B.f = ce(ke(b[1])).replace(/_xlfn\./, "");
              if (b[0].indexOf('t="array"') > -1) {
                B.F = (w.match(n) || [])[1];
                if (B.F.indexOf(":") > -1) O.push([Kr(B.F), B.F]);
              } else if (b[0].indexOf('t="shared"') > -1) {
                I = se(b[0]);
                F[parseInt(I.si, 10)] = [I, ce(ke(b[1]))];
              }
            } else if ((b = w.match(/<f[^>]*\/>/))) {
              I = se(b[0]);
              if (F[I.si]) B.f = kv(F[I.si][1], F[I.si][0].ref, C.r);
            }
            var j = Wr(C.r);
            for (k = 0; k < O.length; ++k)
              if (j.r >= O[k][0].s.r && j.r <= O[k][0].e.r)
                if (j.c >= O[k][0].s.c && j.c <= O[k][0].e.c) B.F = O[k][1];
          }
          if (C.t == null && B.v === undefined) {
            if (B.f || B.F) {
              B.v = 0;
              B.t = "n";
            } else if (!c.sheetStubs) continue;
            else B.t = "z";
          } else B.t = C.t || "n";
          if (u.s.c > g) u.s.c = g;
          if (u.e.c < g) u.e.c = g;
          switch (B.t) {
            case "n":
              B.v = parseFloat(B.v);
              break;
            case "s":
              if (typeof B.v == "undefined") {
                if (!c.sheetStubs) continue;
                B.t = "z";
              } else {
                x = dm[parseInt(B.v, 10)];
                B.v = x.t;
                B.r = x.r;
                if (c.cellHTML) B.h = x.h;
              }
              break;
            case "str":
              B.t = "s";
              B.v = B.v != null ? ke(B.v) : "";
              if (c.cellHTML) B.h = me(B.v);
              break;
            case "inlineStr":
              b = w.match(a);
              B.t = "s";
              if (b != null && (x = Vu(b[1]))) B.v = x.t;
              else B.v = "";
              break;
            case "b":
              B.v = Ee(B.v);
              break;
            case "d":
              if (c.cellDates) B.v = H(B.v, 1);
              else {
                B.v = P(H(B.v, 1));
                B.t = "n";
              }
              break;
            case "e":
              if (!c || c.cellText !== false) B.w = B.v;
              B.v = Tt[B.v];
              break;
          }
          A = y = 0;
          if (R && C.s !== undefined) {
            D = d.CellXf[C.s];
            if (D != null) {
              if (D.numFmtId != null) A = D.numFmtId;
              if (c.cellStyles) {
                if (D.fillId != null) y = D.fillId;
              }
            }
          }
          Em(B, A, y, c, h, d);
          if (c.cellDates && R && B.t == "n" && E.is_date(E._table[A])) {
            B.t = "d";
            B.v = N(B.v);
          }
          if (L) {
            var K = Wr(C.r);
            if (!l[K.r]) l[K.r] = [];
            l[K.r][K.c] = B;
          } else l[C.r] = B;
        }
      }
      if (M.length > 0) l["!rows"] = M;
    };
  })();
  function Wm(e, r, t, a, n) {
    var i = [],
      s = [],
      f = Kr(e["!ref"]),
      o,
      l,
      c = "",
      u = [],
      h = 0,
      d = 0,
      v = e["!rows"];
    var p = Array.isArray(e);
    for (d = f.s.c; d <= f.e.c; ++d) u[d] = Lr(d);
    for (h = f.s.r; h <= f.e.r; ++h) {
      s = [];
      c = Or(h);
      for (d = f.s.c; d <= f.e.c; ++d) {
        l = u[d] + c;
        var m = p ? (e[h] || [])[d] : e[l];
        if (m === undefined) continue;
        if ((o = Um(m, l, e, r, t, a)) != null) s.push(o);
      }
      if (s.length > 0 || (v && v[h])) {
        var b = { r: c };
        if (v && v[h]) {
          var g = v[h];
          if (g.hidden) b.hidden = 1;
          var E = -1;
          if (g.hpx) E = zh(g.hpx);
          else if (g.hpt) E = g.hpt;
          if (E > -1) {
            b.ht = E;
            b.customHeight = 1;
          }
          if (g.level) {
            b.outlineLevel = g.level;
          }
        }
        i[i.length] = De("row", s.join(""), b);
      }
    }
    if (v)
      for (; h < v.length; ++h) {
        if (v && v[h]) {
          b = { r: h + 1 };
          g = v[h];
          if (g.hidden) b.hidden = 1;
          E = -1;
          if (g.hpx) E = zh(g.hpx);
          else if (g.hpt) E = g.hpt;
          if (E > -1) {
            b.ht = E;
            b.customHeight = 1;
          }
          if (g.level) {
            b.outlineLevel = g.level;
          }
          i[i.length] = De("row", "", b);
        }
      }
    return i.join("");
  }
  var Vm = De("worksheet", null, { xmlns: Ne.main[0], "xmlns:r": Ne.r });
  function zm(e, r, t, a) {
    var n = [Pe, Vm];
    var i = t.SheetNames[e],
      s = 0,
      f = "";
    var o = t.Sheets[i];
    if (o == null) o = {};
    var l = o["!ref"];
    if (l == null) l = "A1";
    if (!a) a = {};
    o["!comments"] = [];
    o["!drawing"] = [];
    n[n.length] = De("sheetPr", null, { codeName: de(t.SheetNames[e]) });
    n[n.length] = De("dimension", null, { ref: l });
    n[n.length] = Mm(o, r, e, t);
    if (r.sheetFormat)
      n[n.length] = De("sheetFormatPr", null, {
        defaultRowHeight: r.sheetFormat.defaultRowHeight || "16",
        baseColWidth: r.sheetFormat.baseColWidth || "10",
        outlineLevelRow: r.sheetFormat.outlineLevelRow || "7",
      });
    if (o["!cols"] != null && o["!cols"].length > 0)
      n[n.length] = Pm(o, o["!cols"]);
    n[(s = n.length)] = "<sheetData/>";
    o["!links"] = [];
    if (o["!ref"] != null) {
      f = Wm(o, r, e, t, a);
      if (f.length > 0) n[n.length] = f;
    }
    if (n.length > s + 1) {
      n[n.length] = "</sheetData>";
      n[s] = n[s].replace("/>", ">");
    }
    if (o["!protect"] != null) n[n.length] = ym(o["!protect"]);
    if (o["!autofilter"] != null) n[n.length] = Lm(o["!autofilter"]);
    if (o["!merges"] != null && o["!merges"].length > 0)
      n[n.length] = Am(o["!merges"]);
    var c = -1,
      u,
      h = -1;
    if (o["!links"].length > 0) {
      n[n.length] = "<hyperlinks>";
      o["!links"].forEach(function (e) {
        if (!e[1].Target) return;
        h = ca(a, -1, de(e[1].Target).replace(/#.*$/, ""), ia.HLINK);
        u = { ref: e[0], "r:id": "rId" + h };
        if ((c = e[1].Target.indexOf("#")) > -1)
          u.location = de(e[1].Target.substr(c + 1));
        if (e[1].Tooltip) u.tooltip = de(e[1].Tooltip);
        n[n.length] = De("hyperlink", null, u);
      });
      n[n.length] = "</hyperlinks>";
    }
    delete o["!links"];
    if (o["!margins"] != null) n[n.length] = Om(o["!margins"]);
    var d = n.length;
    n[n.length] = "";
    if (o["!drawing"].length > 0) {
      h = ca(a, -1, "../drawings/drawing" + (e + 1) + ".xml", ia.DRAW);
      n[n.length] = De("drawing", null, { "r:id": "rId" + h });
    } else delete o["!drawing"];
    if (o["!comments"].length > 0) {
      h = ca(a, -1, "../drawings/vmlDrawing" + (e + 1) + ".vml", ia.VML);
      n[n.length] = De("legacyDrawing", null, { "r:id": "rId" + h });
      o["!legacy"] = h;
    }
    if (n.length > 2) {
      n[n.length] = "</worksheet>";
      n[1] = n[1].replace("/>", ">");
    }
    return n.join("");
  }
  function Xm(e, r) {
    var t = {};
    var a = e.l + r;
    t.r = e.read_shift(4);
    e.l += 4;
    var n = e.read_shift(2);
    e.l += 1;
    var i = e.read_shift(1);
    e.l = a;
    if (i & 7) t.level = i & 7;
    if (i & 16) t.hidden = true;
    if (i & 32) t.hpt = n / 20;
    return t;
  }
  function Gm(e, r, t) {
    var a = wr(17 + 8 * 16);
    var n = (t["!rows"] || [])[e] || {};
    a.write_shift(4, e);
    a.write_shift(4, 0);
    var i = 320;
    if (n.hpx) i = zh(n.hpx) * 20;
    else if (n.hpt) i = n.hpt * 20;
    a.write_shift(2, i);
    a.write_shift(1, 0);
    var s = 0;
    if (n.level) s |= n.level;
    if (n.hidden) s |= 16;
    if (n.hpx || n.hpt) s |= 32;
    a.write_shift(1, s);
    a.write_shift(1, 0);
    var f = 0,
      o = a.l;
    a.l += 4;
    var l = { r: e, c: 0 };
    for (var c = 0; c < 16; ++c) {
      if (r.s.c > (c + 1) << 10 || r.e.c < c << 10) continue;
      var u = -1,
        h = -1;
      for (var d = c << 10; d < (c + 1) << 10; ++d) {
        l.c = d;
        var v = Array.isArray(t) ? (t[l.r] || [])[l.c] : t[Vr(l)];
        if (v) {
          if (u < 0) u = d;
          h = d;
        }
      }
      if (u < 0) continue;
      ++f;
      a.write_shift(4, u);
      a.write_shift(4, h);
    }
    var p = a.l;
    a.l = o;
    a.write_shift(4, f);
    a.l = p;
    return a.length > a.l ? a.slice(0, a.l) : a;
  }
  function jm(e, r, t, a) {
    var n = Gm(a, t, r);
    if (n.length > 17 || (r["!rows"] || [])[a]) _r(e, "BrtRowHdr", n);
  }
  var Km = St;
  var Ym = wt;
  function $m(e, r) {}
  function Zm(e, r) {
    var t = {};
    e.l += 19;
    t.name = lt(e, r - 19);
    return t;
  }
  function Qm(e, r) {
    if (r == null) r = wr(84 + 4 * e.length);
    for (var t = 0; t < 3; ++t) r.write_shift(1, 0);
    It({ auto: 1 }, r);
    r.write_shift(-4, -1);
    r.write_shift(-4, -1);
    ct(e, r);
    return r.slice(0, r.l);
  }
  function Jm(e, r) {
    var t = ft(e);
    return [t];
  }
  function qm(e, r, t) {
    if (t == null) t = wr(8);
    return ot(r, t);
  }
  function eb(e, r) {
    var t = ft(e);
    var a = e.read_shift(1);
    return [t, a, "b"];
  }
  function rb(e, r, t) {
    if (t == null) t = wr(9);
    ot(r, t);
    t.write_shift(1, e.v ? 1 : 0);
    return t;
  }
  function tb(e, r) {
    var t = ft(e);
    var a = e.read_shift(1);
    return [t, a, "e"];
  }
  function ab(e, r) {
    var t = ft(e);
    var a = e.read_shift(4);
    return [t, a, "s"];
  }
  function nb(e, r, t) {
    if (t == null) t = wr(12);
    ot(r, t);
    t.write_shift(4, r.v);
    return t;
  }
  function ib(e, r) {
    var t = ft(e);
    var a = Bt(e);
    return [t, a, "n"];
  }
  function sb(e, r, t) {
    if (t == null) t = wr(16);
    ot(r, t);
    Ct(e.v, t);
    return t;
  }
  function fb(e, r) {
    var t = ft(e);
    var a = bt(e);
    return [t, a, "n"];
  }
  function ob(e, r, t) {
    if (t == null) t = wr(12);
    ot(r, t);
    gt(e.v, t);
    return t;
  }
  function lb(e, r) {
    var t = ft(e);
    var a = qr(e);
    return [t, a, "str"];
  }
  function cb(e, r, t) {
    if (t == null) t = wr(12 + 4 * e.v.length);
    ot(r, t);
    et(e.v, t);
    return t.length > t.l ? t.slice(0, t.l) : t;
  }
  function ub(e, r, t) {
    var a = e.l + r;
    var n = ft(e);
    n.r = t["!row"];
    var i = e.read_shift(1);
    var s = [n, i, "b"];
    if (t.cellFormula) {
      e.l += 2;
      var f = tm(e, a - e.l, t);
      s[3] = qp(f, null, n, t.supbooks, t);
    } else e.l = a;
    return s;
  }
  function hb(e, r, t) {
    var a = e.l + r;
    var n = ft(e);
    n.r = t["!row"];
    var i = e.read_shift(1);
    var s = [n, i, "e"];
    if (t.cellFormula) {
      e.l += 2;
      var f = tm(e, a - e.l, t);
      s[3] = qp(f, null, n, t.supbooks, t);
    } else e.l = a;
    return s;
  }
  function db(e, r, t) {
    var a = e.l + r;
    var n = ft(e);
    n.r = t["!row"];
    var i = Bt(e);
    var s = [n, i, "n"];
    if (t.cellFormula) {
      e.l += 2;
      var f = tm(e, a - e.l, t);
      s[3] = qp(f, null, n, t.supbooks, t);
    } else e.l = a;
    return s;
  }
  function vb(e, r, t) {
    var a = e.l + r;
    var n = ft(e);
    n.r = t["!row"];
    var i = qr(e);
    var s = [n, i, "str"];
    if (t.cellFormula) {
      e.l += 2;
      var f = tm(e, a - e.l, t);
      s[3] = qp(f, null, n, t.supbooks, t);
    } else e.l = a;
    return s;
  }
  var pb = St;
  var mb = wt;
  function bb(e, r) {
    if (r == null) r = wr(4);
    r.write_shift(4, e);
    return r;
  }
  function gb(e, r, t) {
    var a = e.l + r;
    var n = St(e, 16);
    var i = ut(e);
    var s = qr(e);
    var f = qr(e);
    var o = qr(e);
    e.l = a;
    return { rfx: n, relId: i, loc: s, Tooltip: f, display: o };
  }
  function Eb(e, r, t) {
    if (t == null) t = wr(50 + 4 * e[1].Target.length);
    wt({ s: Wr(e[0]), e: Wr(e[0]) }, t);
    mt("rId" + r, t);
    var a = e[1].Target.indexOf("#");
    var n = a == -1 ? "" : e[1].Target.substr(a + 1);
    et(n || "", t);
    et(e[1].Tooltip || "", t);
    et("", t);
    return t.slice(0, t.l);
  }
  function kb(e, r, t) {
    var a = e.l + r;
    var n = Et(e, 16);
    var i = e.read_shift(1);
    var s = [n];
    s[2] = i;
    if (t.cellFormula) {
      var f = rm(e, a - e.l, t);
      s[1] = f;
    } else e.l = a;
    return s;
  }
  function Sb(e, r, t) {
    var a = e.l + r;
    var n = St(e, 16);
    var i = [n];
    if (t.cellFormula) {
      var s = nm(e, a - e.l, t);
      i[1] = s;
      e.l = a;
    } else e.l = a;
    return i;
  }
  function wb(e, r, t) {
    if (t == null) t = wr(18);
    var a = mm(e, r);
    t.write_shift(-4, e);
    t.write_shift(-4, e);
    t.write_shift(4, (a.width || 10) * 256);
    t.write_shift(4, 0);
    var n = 0;
    if (r.hidden) n |= 1;
    if (typeof a.width == "number") n |= 2;
    t.write_shift(1, n);
    t.write_shift(1, 0);
    return t;
  }
  function Bb(e, r, t) {
    return {
      left: Bt(e, 8),
      right: Bt(e, 8),
      top: Bt(e, 8),
      bottom: Bt(e, 8),
      header: Bt(e, 8),
      footer: Bt(e, 8),
    };
  }
  function Cb(e, r) {
    if (r == null) r = wr(6 * 8);
    bm(e);
    Ct(e.left, r);
    Ct(e.right, r);
    Ct(e.top, r);
    Ct(e.bottom, r);
    Ct(e.header, r);
    Ct(e.footer, r);
    return r;
  }
  function _b(e, r) {
    if (r == null) r = wr(30);
    r.write_shift(2, 924);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    r.write_shift(4, 0);
    r.write_shift(1, 0);
    r.write_shift(1, 0);
    r.write_shift(2, 0);
    r.write_shift(2, 100);
    r.write_shift(2, 0);
    r.write_shift(2, 0);
    r.write_shift(2, 0);
    r.write_shift(4, 0);
    return r;
  }
  function Tb(e, r) {
    if (r == null) r = wr(16 * 4 + 2);
    r.write_shift(2, e.password ? mh(e.password) : 0);
    r.write_shift(4, 1);
    [
      ["objects", false],
      ["scenarios", false],
      ["formatCells", true],
      ["formatColumns", true],
      ["formatRows", true],
      ["insertColumns", true],
      ["insertRows", true],
      ["insertHyperlinks", true],
      ["deleteColumns", true],
      ["deleteRows", true],
      ["selectLockedCells", false],
      ["sort", true],
      ["autoFilter", true],
      ["pivotTables", true],
      ["selectUnlockedCells", false],
    ].forEach(function (t) {
      if (t[1]) r.write_shift(4, e[t[0]] != null && !e[t[0]] ? 1 : 0);
      else r.write_shift(4, e[t[0]] != null && e[t[0]] ? 0 : 1);
    });
    return r;
  }
  function xb(e, r, t, a, n, i) {
    if (!e) return e;
    var s = r || {};
    if (!t) t = { "!id": {} };
    if (c != null && s.dense == null) s.dense = c;
    var f = s.dense ? [] : {};
    var o;
    var l = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
    var u = false,
      h = false;
    var d, v, p, m, b, g, k, S, w;
    var B = [];
    s.biff = 12;
    s["!row"] = 0;
    var C = 0,
      _ = false;
    var T = [];
    var x = {};
    var I = [[]];
    I.sharedf = x;
    I.arrayf = T;
    I.SheetNames =
      a.SheetNames ||
      a.Sheets.map(function (e) {
        return e.name;
      });
    s.supbooks = I;
    for (var A = 0; A < a.Names.length; ++A) I[0][A + 1] = a.Names[A];
    var y = [],
      R = [];
    var D = 0,
      O = 0;
    var F = false;
    Br(
      e,
      function N(e, r, a) {
        if (h) return;
        switch (a) {
          case 148:
            o = e;
            break;
          case 0:
            d = e;
            if (s.sheetRows && s.sheetRows <= d.r) h = true;
            S = Or((m = d.r));
            s["!row"] = d.r;
            if (e.hidden || e.hpt || e.level != null) {
              if (e.hpt) e.hpx = Xh(e.hpt);
              R[e.r] = e;
            }
            break;
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
            v = { t: e[2] };
            switch (e[2]) {
              case "n":
                v.v = e[1];
                break;
              case "s":
                k = dm[e[1]];
                v.v = k.t;
                v.r = k.r;
                break;
              case "b":
                v.v = e[1] ? true : false;
                break;
              case "e":
                v.v = e[1];
                if (s.cellText !== false) v.w = _t[v.v];
                break;
              case "str":
                v.t = "s";
                v.v = ke(e[1]);
                break;
            }
            if ((p = i.CellXf[e[0].iStyleRef]))
              Em(v, p.numFmtId, null, s, n, i);
            b = e[0].c;
            if (s.dense) {
              if (!f[m]) f[m] = [];
              f[m][b] = v;
            } else f[Lr(b) + S] = v;
            if (s.cellFormula) {
              _ = false;
              for (C = 0; C < T.length; ++C) {
                var c = T[C];
                if (d.r >= c[0].s.r && d.r <= c[0].e.r)
                  if (b >= c[0].s.c && b <= c[0].e.c) {
                    v.F = jr(c[0]);
                    _ = true;
                  }
              }
              if (!_ && e.length > 3) v.f = e[3];
            }
            if (l.s.r > d.r) l.s.r = d.r;
            if (l.s.c > b) l.s.c = b;
            if (l.e.r < d.r) l.e.r = d.r;
            if (l.e.c < b) l.e.c = b;
            if (
              s.cellDates &&
              p &&
              v.t == "n" &&
              E.is_date(E._table[p.numFmtId])
            ) {
              var A = E.parse_date_code(v.v);
              if (A) {
                v.t = "d";
                v.v = new Date(A.y, A.m - 1, A.d, A.H, A.M, A.S, A.u);
              }
            }
            break;
          case 1:
            if (!s.sheetStubs || u) break;
            v = { t: "z", v: undefined };
            b = e[0].c;
            if (s.dense) {
              if (!f[m]) f[m] = [];
              f[m][b] = v;
            } else f[Lr(b) + S] = v;
            if (l.s.r > d.r) l.s.r = d.r;
            if (l.s.c > b) l.s.c = b;
            if (l.e.r < d.r) l.e.r = d.r;
            if (l.e.c < b) l.e.c = b;
            break;
          case 176:
            B.push(e);
            break;
          case 494:
            var D = t["!id"][e.relId];
            if (D) {
              e.Target = D.Target;
              if (e.loc) e.Target += "#" + e.loc;
              e.Rel = D;
            }
            for (m = e.rfx.s.r; m <= e.rfx.e.r; ++m)
              for (b = e.rfx.s.c; b <= e.rfx.e.c; ++b) {
                if (s.dense) {
                  if (!f[m]) f[m] = [];
                  if (!f[m][b]) f[m][b] = { t: "z", v: undefined };
                  f[m][b].l = e;
                } else {
                  g = Vr({ c: b, r: m });
                  if (!f[g]) f[g] = { t: "z", v: undefined };
                  f[g].l = e;
                }
              }
            break;
          case 426:
            if (!s.cellFormula) break;
            T.push(e);
            w = s.dense ? f[m][b] : f[Lr(b) + S];
            w.f = qp(e[1], l, { r: d.r, c: b }, I, s);
            w.F = jr(e[0]);
            break;
          case 427:
            if (!s.cellFormula) break;
            x[Vr(e[0].s)] = e[1];
            w = s.dense ? f[m][b] : f[Lr(b) + S];
            w.f = qp(e[1], l, { r: d.r, c: b }, I, s);
            break;
          case 60:
            if (!s.cellStyles) break;
            while (e.e >= e.s) {
              y[e.e--] = { width: e.w / 256, hidden: !!(e.flags & 1) };
              if (!F) {
                F = true;
                Mh(e.w / 256);
              }
              Hh(y[e.e + 1]);
            }
            break;
          case 161:
            f["!autofilter"] = { ref: jr(e) };
            break;
          case 476:
            f["!margins"] = e;
            break;
          case 485:
          case 175:
          case 644:
          case 625:
          case 562:
          case 396:
          case 1112:
          case 1146:
          case 471:
          case 1050:
          case 649:
          case 1105:
          case 49:
          case 589:
          case 607:
          case 564:
          case 1055:
          case 168:
          case 174:
          case 1180:
          case 499:
          case 64:
          case 1053:
          case 550:
          case 171:
          case 167:
          case 1177:
          case 169:
          case 1181:
          case 551:
          case 552:
          case 661:
          case 639:
          case 478:
          case 151:
          case 537:
          case 477:
          case 536:
          case 1103:
          case 680:
          case 1104:
          case 1024:
          case 152:
          case 663:
          case 535:
          case 678:
          case 504:
          case 1043:
          case 428:
          case 170:
          case 50:
          case 2070:
          case 1045:
          case 147:
            break;
          case 35:
            u = true;
            break;
          case 36:
            u = false;
            break;
          case 37:
            break;
          case 38:
            break;
          default:
            if ((r || "").indexOf("Begin") > 0) {
            } else if ((r || "").indexOf("End") > 0) {
            } else if (!u || s.WTF)
              throw new Error("Unexpected record " + a + " " + r);
        }
      },
      s
    );
    delete s.supbooks;
    delete s["!row"];
    if (
      !f["!ref"] &&
      (l.s.r < 2e6 || (o && (o.e.r > 0 || o.e.c > 0 || o.s.r > 0 || o.s.c > 0)))
    )
      f["!ref"] = jr(o || l);
    if (s.sheetRows && f["!ref"]) {
      var P = Kr(f["!ref"]);
      if (s.sheetRows < +P.e.r) {
        P.e.r = s.sheetRows - 1;
        if (P.e.r > l.e.r) P.e.r = l.e.r;
        if (P.e.r < P.s.r) P.s.r = P.e.r;
        if (P.e.c > l.e.c) P.e.c = l.e.c;
        if (P.e.c < P.s.c) P.s.c = P.e.c;
        f["!fullref"] = f["!ref"];
        f["!ref"] = jr(P);
      }
    }
    if (B.length > 0) f["!merges"] = B;
    if (y.length > 0) f["!cols"] = y;
    if (R.length > 0) f["!rows"] = R;
    return f;
  }
  function Ib(e, r, t, a, n, i) {
    if (r.v === undefined) return "";
    var s = "";
    var f = null;
    switch (r.t) {
      case "b":
        s = r.v ? "1" : "0";
        break;
      case "d":
        r.z = r.z || E._table[14];
        f = r.v;
        r.v = P(r.v);
        r.t = "n";
        break;
      case "n":
      case "e":
        s = "" + r.v;
        break;
      default:
        s = r.v;
        break;
    }
    var o = { r: t, c: a };
    o.s = gm(n.cellXfs, r, n);
    if (r.l) i["!links"].push([Vr(o), r.l]);
    if (r.c) i["!comments"].push([Vr(o), r.c]);
    switch (r.t) {
      case "s":
      case "str":
        if (n.bookSST) {
          s = pm(n.Strings, r.v);
          o.t = "s";
          o.v = s;
          _r(e, "BrtCellIsst", nb(r, o));
        } else {
          o.t = "str";
          _r(e, "BrtCellSt", cb(r, o));
        }
        return;
      case "n":
        if (r.v == (r.v | 0) && r.v > -1e3 && r.v < 1e3)
          _r(e, "BrtCellRk", ob(r, o));
        else _r(e, "BrtCellReal", sb(r, o));
        if (f) {
          r.t = "d";
          r.v = f;
        }
        return;
      case "b":
        o.t = "b";
        _r(e, "BrtCellBool", rb(r, o));
        return;
      case "e":
        o.t = "e";
        break;
    }
    _r(e, "BrtCellBlank", qm(r, o));
  }
  function Ab(e, r, t, a, n) {
    var i = Kr(r["!ref"] || "A1"),
      s,
      f = "",
      o = [];
    _r(e, "BrtBeginSheetData");
    var l = Array.isArray(r);
    var c = i.e.r;
    if (r["!rows"]) c = Math.max(i.e.r, r["!rows"].length - 1);
    for (var u = i.s.r; u <= c; ++u) {
      f = Or(u);
      jm(e, r, i, u);
      if (u <= i.e.r)
        for (var h = i.s.c; h <= i.e.c; ++h) {
          if (u === i.s.r) o[h] = Lr(h);
          s = o[h] + f;
          var d = l ? (r[u] || [])[h] : r[s];
          if (!d) continue;
          Ib(e, d, u, h, a, r);
        }
    }
    _r(e, "BrtEndSheetData");
  }
  function yb(e, r) {
    if (!r || !r["!merges"]) return;
    _r(e, "BrtBeginMergeCells", bb(r["!merges"].length));
    r["!merges"].forEach(function (r) {
      _r(e, "BrtMergeCell", mb(r));
    });
    _r(e, "BrtEndMergeCells");
  }
  function Rb(e, r, t, a, n) {
    if (!r || !r["!cols"]) return;
    _r(e, "BrtBeginColInfos");
    r["!cols"].forEach(function (r, t) {
      if (r) _r(e, "BrtColInfo", wb(t, r));
    });
    _r(e, "BrtEndColInfos");
  }
  function Db(e, r, t) {
    r["!links"].forEach(function (r) {
      if (!r[1].Target) return;
      var a = ca(t, -1, r[1].Target.replace(/#.*$/, ""), ia.HLINK);
      _r(e, "BrtHLink", Eb(r, a));
    });
    delete r["!links"];
  }
  function Ob(e, r, t, a) {
    if (r["!comments"].length > 0) {
      var n = ca(a, -1, "../drawings/vmlDrawing" + (t + 1) + ".vml", ia.VML);
      _r(e, "BrtLegacyDrawing", mt("rId" + n));
      r["!legacy"] = n;
    }
  }
  function Fb(e, r) {
    if (!r["!autofilter"]) return;
    _r(e, "BrtBeginAFilter", wt(Gr(r["!autofilter"].ref)));
    _r(e, "BrtEndAFilter");
  }
  function Pb(e, r) {
    _r(e, "BrtBeginWsViews");
    {
      _r(e, "BrtBeginWsView", _b(r));
      _r(e, "BrtEndWsView");
    }
    _r(e, "BrtEndWsViews");
  }
  function Nb(e, r) {}
  function Lb(e, r) {
    if (!r["!protect"]) return;
    _r(e, "BrtSheetProtection", Tb(r["!protect"]));
  }
  function Mb(e, r, t, a) {
    var n = Cr();
    var i = t.SheetNames[e],
      s = t.Sheets[i] || {};
    var f = Kr(s["!ref"] || "A1");
    s["!links"] = [];
    s["!comments"] = [];
    _r(n, "BrtBeginSheet");
    _r(n, "BrtWsProp", Qm(i));
    _r(n, "BrtWsDim", Ym(f));
    Pb(n, s);
    Nb(n, s);
    Rb(n, s, e, r, t);
    Ab(n, s, e, r, t);
    Lb(n, s);
    Fb(n, s);
    yb(n, s);
    Db(n, s, a);
    if (s["!margins"]) _r(n, "BrtMargins", Cb(s["!margins"]));
    Ob(n, s, e, a);
    _r(n, "BrtEndSheet");
    return n.end();
  }
  function Ub(e) {
    var r = [];
    (e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm) || []).forEach(function (e) {
      var t = e.match(/<c:pt idx="(.*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
      if (!t) return;
      r[+t[1]] = +t[2];
    });
    var t = ce(
      (e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [
        "",
        "General",
      ])[1]
    );
    return [r, t];
  }
  function Hb(e, r, t, a, n, i) {
    var s = i || { "!type": "chart" };
    if (!e) return i;
    var f = 0,
      o = 0,
      l = "A";
    var c = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
    (e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function (
      e
    ) {
      var r = Ub(e);
      c.s.r = c.s.c = 0;
      c.e.c = f;
      l = Lr(f);
      r[0].forEach(function (e, t) {
        s[l + Or(t)] = { t: "n", v: e, z: r[1] };
        o = t;
      });
      if (c.e.r < o) c.e.r = o;
      ++f;
    });
    if (f > 0) s["!ref"] = jr(c);
    return s;
  }
  ia.CS =
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";
  var Wb = De("chartsheet", null, { xmlns: Ne.main[0], "xmlns:r": Ne.r });
  function Vb(e, r, t, a, n, i) {
    if (!e) return e;
    if (!t) t = { "!id": {} };
    var s = { "!type": "chart", "!chart": null, "!rel": "" };
    var f;
    if ((f = e.match(/drawing r:id="(.*?)"/))) s["!rel"] = f[1];
    if (t["!id"][s["!rel"]]) s["!chart"] = t["!id"][s["!rel"]];
    return s;
  }
  function zb(e, r, t, a) {
    var n = [Pe, Wb];
    n[n.length] = De("drawing", null, { "r:id": "rId1" });
    ca(a, -1, "../drawings/drawing" + (e + 1) + ".xml", ia.DRAW);
    if (n.length > 2) {
      n[n.length] = "</chartsheet>";
      n[1] = n[1].replace("/>", ">");
    }
    return n.join("");
  }
  function Xb(e, r, t, a, n, i) {
    if (!e) return e;
    if (!t) t = { "!id": {} };
    var s = { "!type": "chart", "!chart": null, "!rel": "" };
    var f = [];
    var o = false;
    Br(
      e,
      function l(e, t, a) {
        switch (a) {
          case 550:
            s["!rel"] = e;
            break;
          case 562:
          case 652:
          case 651:
          case 669:
          case 679:
          case 551:
          case 552:
          case 476:
            break;
          case 35:
            o = true;
            break;
          case 36:
            o = false;
            break;
          case 37:
            f.push(t);
            break;
          case 38:
            f.pop();
            break;
          default:
            if ((t || "").indexOf("Begin") > 0) f.push(t);
            else if ((t || "").indexOf("End") > 0) f.pop();
            else if (!o || r.WTF)
              throw new Error("Unexpected record " + a + " " + t);
        }
      },
      r
    );
    if (t["!id"][s["!rel"]]) s["!chart"] = t["!id"][s["!rel"]];
    return s;
  }
  function Gb(e, r, t, a) {
    var n = Cr();
    _r(n, "BrtBeginSheet");
    _r(n, "BrtEndSheet");
    return n.end();
  }
  var jb = [
    ["allowRefreshQuery", false, "bool"],
    ["autoCompressPictures", true, "bool"],
    ["backupFile", false, "bool"],
    ["checkCompatibility", false, "bool"],
    ["codeName", ""],
    ["date1904", false, "bool"],
    ["defaultThemeVersion", 0, "int"],
    ["filterPrivacy", false, "bool"],
    ["hidePivotFieldList", false, "bool"],
    ["promptedSolutions", false, "bool"],
    ["publishItems", false, "bool"],
    ["refreshAllConnections", false, "bool"],
    ["saveExternalLinkValues", true, "bool"],
    ["showBorderUnselectedTables", true, "bool"],
    ["showInkAnnotation", true, "bool"],
    ["showObjects", "all"],
    ["showPivotChartFilter", false, "bool"],
    ["updateLinks", "userSet"],
  ];
  var Kb = [
    ["activeTab", 0, "int"],
    ["autoFilterDateGrouping", true, "bool"],
    ["firstSheet", 0, "int"],
    ["minimized", false, "bool"],
    ["showHorizontalScroll", true, "bool"],
    ["showSheetTabs", true, "bool"],
    ["showVerticalScroll", true, "bool"],
    ["tabRatio", 600, "int"],
    ["visibility", "visible"],
  ];
  var Yb = [];
  var $b = [
    ["calcCompleted", "true"],
    ["calcMode", "auto"],
    ["calcOnSave", "true"],
    ["concurrentCalc", "true"],
    ["fullCalcOnLoad", "false"],
    ["fullPrecision", "true"],
    ["iterate", "false"],
    ["iterateCount", "100"],
    ["iterateDelta", "0.001"],
    ["refMode", "A1"],
  ];
  var Zb = [
    ["autoUpdate", "false"],
    ["changesSavedWin", "false"],
    ["includeHiddenRowCol", "true"],
    ["includePrintSettings", "true"],
    ["maximized", "false"],
    ["minimized", "false"],
    ["onlySync", "false"],
    ["personalView", "false"],
    ["showComments", "commIndicator"],
    ["showFormulaBar", "true"],
    ["showHorizontalScroll", "true"],
    ["showObjects", "all"],
    ["showSheetTabs", "true"],
    ["showStatusbar", "true"],
    ["showVerticalScroll", "true"],
    ["tabRatio", "600"],
    ["xWindow", "0"],
    ["yWindow", "0"],
  ];
  function Qb(e, r) {
    for (var t = 0; t != e.length; ++t) {
      var a = e[t];
      for (var n = 0; n != r.length; ++n) {
        var i = r[n];
        if (a[i[0]] == null) a[i[0]] = i[1];
        else
          switch (i[2]) {
            case "bool":
              if (typeof a[i[0]] == "string") a[i[0]] = Ee(a[i[0]], i[0]);
              break;
            case "int":
              if (typeof a[i[0]] == "string") a[i[0]] = parseInt(a[i[0]], 10);
              break;
          }
      }
    }
  }
  function Jb(e, r) {
    for (var t = 0; t != r.length; ++t) {
      var a = r[t];
      if (e[a[0]] == null) e[a[0]] = a[1];
      else
        switch (a[2]) {
          case "bool":
            if (typeof e[a[0]] == "string") e[a[0]] = Ee(e[a[0]], a[0]);
            break;
          case "int":
            if (typeof e[a[0]] == "string") e[a[0]] = parseInt(e[a[0]], 10);
            break;
        }
    }
  }
  function qb(e) {
    Jb(e.WBProps, jb);
    Jb(e.CalcPr, $b);
    Qb(e.WBView, Kb);
    Qb(e.Sheets, Yb);
    vm.date1904 = Ee(e.WBProps.date1904, "date1904");
  }
  function eg(e) {
    if (!e.Workbook) return "false";
    if (!e.Workbook.WBProps) return "false";
    return Ee(e.Workbook.WBProps.date1904) ? "true" : "false";
  }
  var rg = "][*?/\\".split("");
  function tg(e, r) {
    if (e.length > 31) {
      if (r) return false;
      throw new Error("Sheet names cannot exceed 31 chars");
    }
    var t = true;
    rg.forEach(function (a) {
      if (e.indexOf(a) == -1) return;
      if (!r) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
      t = false;
    });
    return t;
  }
  function ag(e) {
    e.forEach(function (r, t) {
      tg(r);
      for (var a = 0; a < t; ++a)
        if (r == e[a]) throw new Error("Duplicate Sheet Name: " + r);
    });
  }
  function ng(e) {
    if (!e || !e.SheetNames || !e.Sheets) throw new Error("Invalid Workbook");
    ag(e.SheetNames);
  }
  var ig = /<\w+:workbook/;
  function sg(e, r) {
    if (!e) throw new Error("Could not find file");
    var t = {
      AppVersion: {},
      WBProps: {},
      WBView: [],
      Sheets: [],
      CalcPr: {},
      Names: [],
      xmlns: "",
    };
    var a = false,
      n = "xmlns";
    var i = {},
      s = 0;
    e.replace(ae, function f(o, l) {
      var c = se(o);
      switch (fe(c[0])) {
        case "<?xml":
          break;
        case "<workbook":
          if (o.match(ig)) n = "xmlns" + o.match(/<(\w+):/)[1];
          t.xmlns = c[n];
          break;
        case "</workbook>":
          break;
        case "<fileVersion":
          delete c[0];
          t.AppVersion = c;
          break;
        case "<fileVersion/>":
        case "</fileVersion>":
          break;
        case "<fileSharing":
        case "<fileSharing/>":
          break;
        case "<workbookPr":
        case "<workbookPr/>":
          jb.forEach(function (e) {
            if (c[e[0]] == null) return;
            switch (e[2]) {
              case "bool":
                t.WBProps[e[0]] = Ee(c[e[0]], e[0]);
                break;
              case "int":
                t.WBProps[e[0]] = parseInt(c[e[0]], 10);
                break;
              default:
                t.WBProps[e[0]] = c[e[0]];
            }
          });
          break;
        case "</workbookPr>":
          break;
        case "<workbookProtection":
          break;
        case "<workbookProtection/>":
          break;
        case "<bookViews":
        case "<bookViews>":
        case "</bookViews>":
          break;
        case "<workbookView":
          delete c[0];
          t.WBView.push(c);
          break;
        case "</workbookView>":
          break;
        case "<sheets":
        case "<sheets>":
        case "</sheets>":
          break;
        case "<sheet":
          switch (c.state) {
            case "hidden":
              c.Hidden = 1;
              break;
            case "veryHidden":
              c.Hidden = 2;
              break;
            default:
              c.Hidden = 0;
          }
          delete c.state;
          c.name = ce(ke(c.name));
          delete c[0];
          t.Sheets.push(c);
          break;
        case "</sheet>":
          break;
        case "<functionGroups":
        case "<functionGroups/>":
          break;
        case "<functionGroup":
          break;
        case "<externalReferences":
        case "</externalReferences>":
        case "<externalReferences>":
          break;
        case "<externalReference":
          break;
        case "<definedNames/>":
          break;
        case "<definedNames>":
        case "<definedNames":
          a = true;
          break;
        case "</definedNames>":
          a = false;
          break;
        case "<definedName":
          {
            i = {};
            i.Name = c.name;
            if (c.comment) i.Comment = c.comment;
            if (c.localSheetId) i.Sheet = +c.localSheetId;
            s = l + o.length;
          }
          break;
        case "</definedName>":
          {
            i.Ref = e.slice(s, l);
            t.Names.push(i);
          }
          break;
        case "<definedName/>":
          break;
        case "<calcPr":
          delete c[0];
          t.CalcPr = c;
          break;
        case "<calcPr/>":
          delete c[0];
          t.CalcPr = c;
          break;
        case "</calcPr>":
          break;
        case "<oleSize":
          break;
        case "<customWorkbookViews>":
        case "</customWorkbookViews>":
        case "<customWorkbookViews":
          break;
        case "<customWorkbookView":
        case "</customWorkbookView>":
          break;
        case "<pivotCaches>":
        case "</pivotCaches>":
        case "<pivotCaches":
          break;
        case "<pivotCache":
          break;
        case "<smartTagPr":
        case "<smartTagPr/>":
          break;
        case "<smartTagTypes":
        case "<smartTagTypes>":
        case "</smartTagTypes>":
          break;
        case "<smartTagType":
          break;
        case "<webPublishing":
        case "<webPublishing/>":
          break;
        case "<fileRecoveryPr":
        case "<fileRecoveryPr/>":
          break;
        case "<webPublishObjects>":
        case "<webPublishObjects":
        case "</webPublishObjects>":
          break;
        case "<webPublishObject":
          break;
        case "<extLst":
        case "<extLst>":
        case "</extLst>":
        case "<extLst/>":
          break;
        case "<ext":
          a = true;
          break;
        case "</ext>":
          a = false;
          break;
        case "<ArchID":
          break;
        case "<AlternateContent":
          a = true;
          break;
        case "</AlternateContent>":
          a = false;
          break;
        case "<revisionPtr":
          break;
        default:
          if (!a && r.WTF)
            throw new Error("unrecognized " + c[0] + " in workbook");
      }
      return o;
    });
    if (Ne.main.indexOf(t.xmlns) === -1)
      throw new Error("Unknown Namespace: " + t.xmlns);
    qb(t);
    return t;
  }
  var fg = De("workbook", null, { xmlns: Ne.main[0], "xmlns:r": Ne.r });
  function og(e, r) {
    var t = [Pe];
    t[t.length] = fg;
    var a = e.Workbook && (e.Workbook.Names || []).length > 0;
    var n = { codeName: "ThisWorkbook" };
    if (e.Workbook && e.Workbook.WBProps) {
      if (e.Workbook.WBProps.codeName) n.codeName = e.Workbook.WBProps.codeName;
      jb.forEach(function (r) {
        if (e.Workbook.WBProps[r[0]] == null) return;
        if (e.Workbook.WBProps[r[0]] == r[1]) return;
        n[r[0]] = e.Workbook.WBProps[r[0]];
      });
    }
    t[t.length] = De("workbookPr", null, n);
    t[t.length] = "<sheets>";
    var i = (e.Workbook && e.Workbook.Sheets) || [];
    for (var s = 0; s != e.SheetNames.length; ++s) {
      var f = { name: de(e.SheetNames[s].substr(0, 31)) };
      f.sheetId = "" + (s + 1);
      f["r:id"] = "rId" + (s + 1);
      if (i[s])
        switch (i[s].Hidden) {
          case 1:
            f.state = "hidden";
            break;
          case 2:
            f.state = "veryHidden";
            break;
        }
      t[t.length] = De("sheet", null, f);
    }
    t[t.length] = "</sheets>";
    if (a) {
      t[t.length] = "<definedNames>";
      if (e.Workbook && e.Workbook.Names)
        e.Workbook.Names.forEach(function (e) {
          var r = { name: e.Name };
          if (e.Comment) r.comment = e.Comment;
          if (e.Sheet != null) r.localSheetId = "" + e.Sheet;
          if (!e.Ref) return;
          t[t.length] = De("definedName", String(e.Ref), r);
        });
      t[t.length] = "</definedNames>";
    }
    if (t.length > 2) {
      t[t.length] = "</workbook>";
      t[1] = t[1].replace("/>", ">");
    }
    return t.join("");
  }
  function lg(e, r) {
    var t = {};
    t.Hidden = e.read_shift(4);
    t.iTabID = e.read_shift(4);
    t.strRelID = pt(e, r - 8);
    t.name = qr(e);
    return t;
  }
  function cg(e, r) {
    if (!r) r = wr(127);
    r.write_shift(4, e.Hidden);
    r.write_shift(4, e.iTabID);
    mt(e.strRelID, r);
    et(e.name.substr(0, 31), r);
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  function ug(e, r) {
    var t = {};
    var a = e.read_shift(4);
    t.defaultThemeVersion = e.read_shift(4);
    var n = r > 8 ? qr(e) : "";
    if (n.length > 0) t.codeName = n;
    t.autoCompressPictures = !!(a & 65536);
    t.backupFile = !!(a & 64);
    t.checkCompatibility = !!(a & 4096);
    t.date1904 = !!(a & 1);
    t.filterPrivacy = !!(a & 8);
    t.hidePivotFieldList = !!(a & 1024);
    t.promptedSolutions = !!(a & 16);
    t.publishItems = !!(a & 2048);
    t.refreshAllConnections = !!(a & 262144);
    t.saveExternalLinkValues = !!(a & 128);
    t.showBorderUnselectedTables = !!(a & 4);
    t.showInkAnnotation = !!(a & 32);
    t.showObjects = ["all", "placeholders", "none"][(a >> 13) & 3];
    t.showPivotChartFilter = !!(a & 32768);
    t.updateLinks = ["userSet", "never", "always"][(a >> 8) & 3];
    return t;
  }
  function hg(e, r) {
    if (!r) r = wr(72);
    var t = 0;
    if (e) {
      if (e.filterPrivacy) t |= 8;
    }
    r.write_shift(4, t);
    r.write_shift(4, 0);
    ct("ThisWorkbook", r);
    return r.slice(0, r.l);
  }
  function dg(e, r) {
    var t = {};
    e.read_shift(4);
    t.ArchID = e.read_shift(4);
    e.l += r - 8;
    return t;
  }
  function vg(e, r, t) {
    var a = e.l + r;
    var n = e.read_shift(4);
    var i = e.read_shift(1);
    var s = e.read_shift(4);
    var f = dt(e);
    var o = am(e, 0, t);
    var l = ut(e);
    e.l = a;
    var c = { Name: f, Ptg: o, Comment: l };
    if (s < 268435455) c.Sheet = s;
    return c;
  }
  function pg(e, r) {
    var t = {
      AppVersion: {},
      WBProps: {},
      WBView: [],
      Sheets: [],
      CalcPr: {},
      xmlns: "",
    };
    var a = false,
      n;
    if (!r) r = {};
    r.biff = 12;
    var i = [];
    var s = [];
    s.SheetNames = [];
    Br(
      e,
      function f(e, n, o) {
        switch (o) {
          case 156:
            s.SheetNames.push(e.name);
            t.Sheets.push(e);
            break;
          case 153:
            t.WBProps = e;
            break;
          case 39:
            e.Ref = qp(e.Ptg, null, null, s, r);
            delete e.Ptg;
            i.push(e);
            break;
          case 1036:
            break;
          case 357:
          case 358:
          case 355:
          case 667:
          case 362:
          case 361:
            break;
          case 2071:
          case 534:
          case 677:
          case 158:
          case 157:
          case 610:
          case 2050:
          case 155:
          case 548:
          case 676:
          case 128:
          case 665:
          case 2128:
          case 2125:
          case 549:
          case 2053:
          case 596:
          case 2076:
          case 2075:
          case 2082:
          case 397:
          case 154:
          case 1117:
          case 553:
          case 2091:
            break;
          case 35:
            a = true;
            break;
          case 36:
            a = false;
            break;
          case 37:
            break;
          case 38:
            break;
          case 16:
            break;
          default:
            if ((n || "").indexOf("Begin") > 0) {
            } else if ((n || "").indexOf("End") > 0) {
            } else if (!a || r.WTF)
              throw new Error("Unexpected record " + o + " " + n);
        }
      },
      r
    );
    qb(t);
    t.Names = i;
    return t;
  }
  function mg(e, r, t) {
    _r(e, "BrtBeginBundleShs");
    for (var a = 0; a != r.SheetNames.length; ++a) {
      var n =
        (r.Workbook &&
          r.Workbook.Sheets &&
          r.Workbook.Sheets[a] &&
          r.Workbook.Sheets[a].Hidden) ||
        0;
      var i = {
        Hidden: n,
        iTabID: a + 1,
        strRelID: "rId" + (a + 1),
        name: r.SheetNames[a],
      };
      _r(e, "BrtBundleSh", cg(i));
    }
    _r(e, "BrtEndBundleShs");
  }
  function bg(e, t) {
    if (!t) t = wr(127);
    for (var a = 0; a != 4; ++a) t.write_shift(4, 0);
    et("SheetJS", t);
    et(r.version, t);
    et(r.version, t);
    et("7262", t);
    t.length = t.l;
    return t.length > t.l ? t.slice(0, t.l) : t;
  }
  function gg(e, r) {
    if (!r) r = wr(29);
    r.write_shift(-4, 0);
    r.write_shift(-4, 460);
    r.write_shift(4, 28800);
    r.write_shift(4, 17600);
    r.write_shift(4, 500);
    r.write_shift(4, e);
    r.write_shift(4, e);
    var t = 120;
    r.write_shift(1, t);
    return r.length > r.l ? r.slice(0, r.l) : r;
  }
  function Eg(e, r, t) {
    if (!r.Workbook || !r.Workbook.Sheets) return;
    var a = r.Workbook.Sheets;
    var n = 0,
      i = -1,
      s = -1;
    for (; n < a.length; ++n) {
      if (!a[n] || (!a[n].Hidden && i == -1)) i = n;
      else if (a[n].Hidden == 1 && s == -1) s = n;
    }
    if (s > i) return;
    _r(e, "BrtBeginBookViews");
    _r(e, "BrtBookView", gg(i));
    _r(e, "BrtEndBookViews");
  }
  function kg(e, r) {
    if (!r) r = wr(26);
    r.write_shift(4, 0);
    r.write_shift(4, 1);
    r.write_shift(4, 0);
    Ct(0, r);
    r.write_shift(-4, 1023);
    r.write_shift(1, 51);
    r.write_shift(1, 0);
    return r;
  }
  function Sg(e, r) {
    if (!r) r = wr(1);
    r.write_shift(1, 0);
    return r;
  }
  function wg(e, r) {
    var t = Cr();
    _r(t, "BrtBeginBook");
    _r(t, "BrtFileVersion", bg());
    _r(t, "BrtWbProp", hg((e.Workbook && e.Workbook.WBProps) || null));
    Eg(t, e, r);
    mg(t, e, r);
    _r(t, "BrtEndBook");
    return t.end();
  }
  function Bg(e, r, t) {
    if (r.slice(-4) === ".bin") return pg(e, t);
    return sg(e, t);
  }
  function Cg(e, r, t, a, n, i, s) {
    if (r.slice(-4) === ".bin") return xb(e, t, a, n, i, s);
    return Im(e, t, a, n, i, s);
  }
  function _g(e, r, t, a, n, i, s) {
    if (r.slice(-4) === ".bin") return Xb(e, t, a, n, i, s);
    return Vb(e, t, a, n, i, s);
  }
  function Tg(e, r, t, a, n, i, s) {
    if (r.slice(-4) === ".bin") return vv(e, t, a, n, i, s);
    return pv(e, t, a, n, i, s);
  }
  function xg(e, r, t, a, n, i, s) {
    if (r.slice(-4) === ".bin") return hv(e, t, a, n, i, s);
    return dv(e, t, a, n, i, s);
  }
  function Ig(e, r, t, a) {
    if (r.slice(-4) === ".bin") return bd(e, t, a);
    return rd(e, t, a);
  }
  function Ag(e, r, t) {
    return Ld(e, t);
  }
  function yg(e, r, t) {
    if (r.slice(-4) === ".bin") return Zu(e, t);
    return ju(e, t);
  }
  function Rg(e, r, t) {
    if (r.slice(-4) === ".bin") return cv(e, t);
    return av(e, t);
  }
  function Dg(e, r, t) {
    if (r.slice(-4) === ".bin") return Zd(e, t);
    return Kd(e, t);
  }
  function Og(e, r, t) {
    return (r.slice(-4) === ".bin" ? wg : og)(e, t);
  }
  function Fg(e, r, t, a, n) {
    return (r.slice(-4) === ".bin" ? Mb : zm)(e, t, a, n);
  }
  function Pg(e, r, t, a, n) {
    return (r.slice(-4) === ".bin" ? Gb : zb)(e, t, a, n);
  }
  function Ng(e, r, t) {
    return (r.slice(-4) === ".bin" ? Id : ad)(e, t);
  }
  function Lg(e, r, t) {
    return (r.slice(-4) === ".bin" ? qu : Yu)(e, t);
  }
  function Mg(e, r, t) {
    return (r.slice(-4) === ".bin" ? uv : iv)(e, t);
  }
  var Ug = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
  var Hg = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
  var Wg = function (e) {
    return String.fromCharCode(e);
  };
  function Vg(e, r) {
    var t = e.split(/\s+/);
    var a = [];
    if (!r) a[0] = t[0];
    if (t.length === 1) return a;
    var n = e.match(Ug),
      i,
      s,
      f,
      o;
    if (n)
      for (o = 0; o != n.length; ++o) {
        i = n[o].match(Hg);
        if ((s = i[1].indexOf(":")) === -1)
          a[i[1]] = i[2].substr(1, i[2].length - 2);
        else {
          if (i[1].substr(0, 6) === "xmlns:") f = "xmlns" + i[1].substr(6);
          else f = i[1].substr(s + 1);
          a[f] = i[2].substr(1, i[2].length - 2);
        }
      }
    return a;
  }
  function zg(e) {
    var r = e.split(/\s+/);
    var t = {};
    if (r.length === 1) return t;
    var a = e.match(Ug),
      n,
      i,
      s,
      f;
    if (a)
      for (f = 0; f != a.length; ++f) {
        n = a[f].match(Hg);
        if ((i = n[1].indexOf(":")) === -1)
          t[n[1]] = n[2].substr(1, n[2].length - 2);
        else {
          if (n[1].substr(0, 6) === "xmlns:") s = "xmlns" + n[1].substr(6);
          else s = n[1].substr(i + 1);
          t[s] = n[2].substr(1, n[2].length - 2);
        }
      }
    return t;
  }
  function Xg(e, r) {
    var t = S[e] || ce(e);
    if (t === "General") return E._general(r);
    return E.format(t, r);
  }
  function Gg(e, r, t, a) {
    var n = a;
    switch ((t[0].match(/dt:dt="([\w.]+)"/) || ["", ""])[1]) {
      case "boolean":
        n = Ee(a);
        break;
      case "i2":
      case "int":
        n = parseInt(a, 10);
        break;
      case "r4":
      case "float":
        n = parseFloat(a);
        break;
      case "date":
      case "dateTime.tz":
        n = H(a);
        break;
      case "i8":
      case "string":
      case "fixed":
      case "uuid":
      case "bin.base64":
        break;
      default:
        throw new Error("bad custprop:" + t[0]);
    }
    e[ce(r[3])] = n;
  }
  function jg(e, r, t) {
    if (e.t === "z") return;
    if (!t || t.cellText !== false)
      try {
        if (e.t === "e") {
          e.w = e.w || _t[e.v];
        } else if (r === "General") {
          if (e.t === "n") {
            if ((e.v | 0) === e.v) e.w = E._general_int(e.v);
            else e.w = E._general_num(e.v);
          } else e.w = E._general(e.v);
        } else e.w = Xg(r || "General", e.v);
      } catch (a) {
        if (t.WTF) throw a;
      }
    try {
      var n = S[r] || r || "General";
      if (t.cellNF) e.z = n;
      if (t.cellDates && e.t == "n" && E.is_date(n)) {
        var i = E.parse_date_code(e.v);
        if (i) {
          e.t = "d";
          e.v = new Date(i.y, i.m - 1, i.d, i.H, i.M, i.S, i.u);
        }
      }
    } catch (a) {
      if (t.WTF) throw a;
    }
  }
  function Kg(e, r, t) {
    if (t.cellStyles) {
      if (r.Interior) {
        var a = r.Interior;
        if (a.Pattern) a.patternType = Gh[a.Pattern] || a.Pattern;
      }
    }
    e[r.ID] = r;
  }
  function Yg(e, r, t, a, n, i, s, f, o, l) {
    var c = "General",
      u = a.StyleID,
      h = {};
    l = l || {};
    var d = [];
    var v = 0;
    if (u === undefined && f) u = f.StyleID;
    if (u === undefined && s) u = s.StyleID;
    while (i[u] !== undefined) {
      if (i[u].nf) c = i[u].nf;
      if (i[u].Interior) d.push(i[u].Interior);
      if (!i[u].Parent) break;
      u = i[u].Parent;
    }
    switch (t.Type) {
      case "Boolean":
        a.t = "b";
        a.v = Ee(e);
        break;
      case "String":
        a.t = "s";
        a.r = be(ce(e));
        a.v = e.indexOf("<") > -1 ? ce(r) : a.r;
        break;
      case "DateTime":
        if (e.slice(-1) != "Z") e += "Z";
        a.v = (H(e) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1e3);
        if (a.v !== a.v) a.v = ce(e);
        else if (a.v < 60) a.v = a.v - 1;
        if (!c || c == "General") c = "yyyy-mm-dd";
      case "Number":
        if (a.v === undefined) a.v = +e;
        if (!a.t) a.t = "n";
        break;
      case "Error":
        a.t = "e";
        a.v = Tt[e];
        if (l.cellText !== false) a.w = e;
        break;
      default:
        a.t = "s";
        a.v = be(r || e);
        break;
    }
    jg(a, c, l);
    if (l.cellFormula !== false) {
      if (a.Formula) {
        var p = ce(a.Formula);
        if (p.charCodeAt(0) == 61) p = p.substr(1);
        a.f = mv(p, n);
        delete a.Formula;
        if (a.ArrayRange == "RC") a.F = mv("RC:RC", n);
        else if (a.ArrayRange) {
          a.F = mv(a.ArrayRange, n);
          o.push([Kr(a.F), a.F]);
        }
      } else {
        for (v = 0; v < o.length; ++v)
          if (n.r >= o[v][0].s.r && n.r <= o[v][0].e.r)
            if (n.c >= o[v][0].s.c && n.c <= o[v][0].e.c) a.F = o[v][1];
      }
    }
    if (l.cellStyles) {
      d.forEach(function (e) {
        if (!h.patternType && e.patternType) h.patternType = e.patternType;
      });
      a.s = h;
    }
    a.ixfe = a.StyleID !== undefined ? a.StyleID : "Default";
  }
  function $g(e) {
    e.t = e.v || "";
    e.t = e.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    e.v = e.w = e.ixfe = undefined;
  }
  function Zg(e) {
    if (d && Buffer.isBuffer(e)) return e.toString("utf8");
    if (typeof e === "string") return e;
    throw new Error("Bad input format: expected Buffer or string");
  }
  var Qg = /<(\/?)([^\s?>!\/:]*:|)([^\s?>]*[^\s?>\/])[^>]*>/gm;
  function Jg(e, r) {
    var t = r || {};
    k(E);
    var a = o(Zg(e));
    if (t && t.type == "binary" && typeof cptable !== "undefined")
      a = cptable.utils.decode(65001, i(a));
    var n = a.slice(0, 1024).toLowerCase(),
      s = false;
    if (n.indexOf("<?xml") == -1)
      ["html", "table", "head", "meta", "script", "style", "div"].forEach(
        function (e) {
          if (n.indexOf("<" + e) >= 0) s = true;
        }
      );
    if (s) return yE.to_workbook(a, t);
    var f;
    var l = [],
      u;
    if (c != null && t.dense == null) t.dense = c;
    var h = {},
      d = [],
      v = t.dense ? [] : {},
      p = "";
    var m = {},
      b = {},
      g = {};
    var w = Vg('<Data ss:Type="String">'),
      B = 0;
    var C = 0,
      _ = 0;
    var T = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
    var x = {},
      I = {};
    var A = "",
      y = 0;
    var R = [];
    var D = {},
      O = {},
      F = 0,
      P = {};
    var N = [],
      L = {};
    var M = [],
      U,
      H = false;
    var W = [];
    var V = [],
      X = {};
    var G = { Sheets: [], WBProps: { date1904: false } },
      j = {};
    Qg.lastIndex = 0;
    a = a.replace(/<!--([\s\S]*?)-->/gm, "");
    while ((f = Qg.exec(a)))
      switch (f[3]) {
        case "Data":
          if (l[l.length - 1][1]) break;
          if (f[1] === "/")
            Yg(
              a.slice(B, f.index),
              A,
              w,
              l[l.length - 1][0] == "Comment" ? L : b,
              { c: C, r: _ },
              x,
              M[C],
              g,
              W,
              t
            );
          else {
            A = "";
            w = Vg(f[0]);
            B = f.index + f[0].length;
          }
          break;
        case "Cell":
          if (f[1] === "/") {
            if (N.length > 0) b.c = N;
            if ((!t.sheetRows || t.sheetRows > _) && b.v !== undefined) {
              if (t.dense) {
                if (!v[_]) v[_] = [];
                v[_][C] = b;
              } else v[Lr(C) + Or(_)] = b;
            }
            if (b.HRef) {
              b.l = { Target: b.HRef, Tooltip: b.HRefScreenTip };
              delete b.HRef;
              delete b.HRefScreenTip;
            }
            if (b.MergeAcross || b.MergeDown) {
              var K = C + (parseInt(b.MergeAcross, 10) | 0);
              var Y = _ + (parseInt(b.MergeDown, 10) | 0);
              R.push({ s: { c: C, r: _ }, e: { c: K, r: Y } });
            }
            if (!t.sheetStubs) {
              if (b.MergeAcross) C = K + 1;
              else ++C;
            } else if (b.MergeAcross || b.MergeDown) {
              for (var $ = C; $ <= K; ++$) {
                for (var Z = _; Z <= Y; ++Z) {
                  if ($ > C || Z > _) {
                    if (t.dense) {
                      if (!v[Z]) v[Z] = [];
                      v[Z][$] = { t: "z" };
                    } else v[Lr($) + Or(Z)] = { t: "z" };
                  }
                }
              }
              C = K + 1;
            } else ++C;
          } else {
            b = zg(f[0]);
            if (b.Index) C = +b.Index - 1;
            if (C < T.s.c) T.s.c = C;
            if (C > T.e.c) T.e.c = C;
            if (f[0].slice(-2) === "/>") ++C;
            N = [];
          }
          break;
        case "Row":
          if (f[1] === "/" || f[0].slice(-2) === "/>") {
            if (_ < T.s.r) T.s.r = _;
            if (_ > T.e.r) T.e.r = _;
            if (f[0].slice(-2) === "/>") {
              g = Vg(f[0]);
              if (g.Index) _ = +g.Index - 1;
            }
            C = 0;
            ++_;
          } else {
            g = Vg(f[0]);
            if (g.Index) _ = +g.Index - 1;
            X = {};
            if (g.AutoFitHeight == "0" || g.Height) {
              X.hpx = parseInt(g.Height, 10);
              X.hpt = zh(X.hpx);
              V[_] = X;
            }
            if (g.Hidden == "1") {
              X.hidden = true;
              V[_] = X;
            }
          }
          break;
        case "Worksheet":
          if (f[1] === "/") {
            if ((u = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + u.join("|"));
            d.push(p);
            if (T.s.r <= T.e.r && T.s.c <= T.e.c) v["!ref"] = jr(T);
            if (R.length) v["!merges"] = R;
            if (M.length > 0) v["!cols"] = M;
            if (V.length > 0) v["!rows"] = V;
            h[p] = v;
          } else {
            T = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
            _ = C = 0;
            l.push([f[3], false]);
            u = Vg(f[0]);
            p = ce(u.Name);
            v = t.dense ? [] : {};
            R = [];
            W = [];
            V = [];
            j = { name: p, Hidden: 0 };
            G.Sheets.push(j);
          }
          break;
        case "Table":
          if (f[1] === "/") {
            if ((u = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + u.join("|"));
          } else if (f[0].slice(-2) == "/>") break;
          else {
            m = Vg(f[0]);
            l.push([f[3], false]);
            M = [];
            H = false;
          }
          break;
        case "Style":
          if (f[1] === "/") Kg(x, I, t);
          else I = Vg(f[0]);
          break;
        case "NumberFormat":
          I.nf = ce(Vg(f[0]).Format || "General");
          if (S[I.nf]) I.nf = S[I.nf];
          for (var Q = 0; Q != 392; ++Q) if (E._table[Q] == I.nf) break;
          if (Q == 392)
            for (Q = 57; Q != 392; ++Q)
              if (E._table[Q] == null) {
                E.load(I.nf, Q);
                break;
              }
          break;
        case "Column":
          if (l[l.length - 1][0] !== "Table") break;
          U = Vg(f[0]);
          if (U.Hidden) {
            U.hidden = true;
            delete U.Hidden;
          }
          if (U.Width) U.wpx = parseInt(U.Width, 10);
          if (!H && U.wpx > 10) {
            H = true;
            Rh = Ih;
            for (var J = 0; J < M.length; ++J) if (M[J]) Hh(M[J]);
          }
          if (H) Hh(U);
          M[U.Index - 1 || M.length] = U;
          for (var q = 0; q < +U.Span; ++q) M[M.length] = z(U);
          break;
        case "NamedRange":
          if (!G.Names) G.Names = [];
          var ee = se(f[0]);
          var re = { Name: ee.Name, Ref: mv(ee.RefersTo.substr(1)) };
          if (G.Sheets.length > 0) re.Sheet = G.Sheets.length - 1;
          G.Names.push(re);
          break;
        case "NamedCell":
          break;
        case "B":
          break;
        case "I":
          break;
        case "U":
          break;
        case "S":
          break;
        case "Sub":
          break;
        case "Sup":
          break;
        case "Span":
          break;
        case "Border":
          break;
        case "Alignment":
          break;
        case "Borders":
          break;
        case "Font":
          if (f[0].slice(-2) === "/>") break;
          else if (f[1] === "/") A += a.slice(y, f.index);
          else y = f.index + f[0].length;
          break;
        case "Interior":
          if (!t.cellStyles) break;
          I.Interior = Vg(f[0]);
          break;
        case "Protection":
          break;
        case "Author":
        case "Title":
        case "Description":
        case "Created":
        case "Keywords":
        case "Subject":
        case "Category":
        case "Company":
        case "LastAuthor":
        case "LastSaved":
        case "LastPrinted":
        case "Version":
        case "Revision":
        case "TotalTime":
        case "HyperlinkBase":
        case "Manager":
        case "ContentStatus":
        case "Identifier":
        case "Language":
          if (f[0].slice(-2) === "/>") break;
          else if (f[1] === "/") Fa(D, f[3], a.slice(F, f.index));
          else F = f.index + f[0].length;
          break;
        case "Paragraphs":
          break;
        case "Styles":
        case "Workbook":
          if (f[1] === "/") {
            if ((u = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + u.join("|"));
          } else l.push([f[3], false]);
          break;
        case "Comment":
          if (f[1] === "/") {
            if ((u = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + u.join("|"));
            $g(L);
            N.push(L);
          } else {
            l.push([f[3], false]);
            u = Vg(f[0]);
            L = { a: u.Author };
          }
          break;
        case "AutoFilter":
          if (f[1] === "/") {
            if ((u = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + u.join("|"));
          } else if (f[0].charAt(f[0].length - 2) !== "/") {
            var te = Vg(f[0]);
            v["!autofilter"] = { ref: mv(te.Range).replace(/\$/g, "") };
            l.push([f[3], true]);
          }
          break;
        case "Name":
          break;
        case "ComponentOptions":
        case "DocumentProperties":
        case "CustomDocumentProperties":
        case "OfficeDocumentSettings":
        case "PivotTable":
        case "PivotCache":
        case "Names":
        case "MapInfo":
        case "PageBreaks":
        case "QueryTable":
        case "DataValidation":
        case "Sorting":
        case "Schema":
        case "data":
        case "ConditionalFormatting":
        case "SmartTagType":
        case "SmartTags":
        case "ExcelWorkbook":
        case "WorkbookOptions":
        case "WorksheetOptions":
          if (f[1] === "/") {
            if ((u = l.pop())[0] !== f[3])
              throw new Error("Bad state: " + u.join("|"));
          } else if (f[0].charAt(f[0].length - 2) !== "/") l.push([f[3], true]);
          break;
        default:
          if (l.length == 0 && f[3] == "document") return PE(a, t);
          if (l.length == 0 && f[3] == "UOF") return PE(a, t);
          var ae = true;
          switch (l[l.length - 1][0]) {
            case "OfficeDocumentSettings":
              switch (f[3]) {
                case "AllowPNG":
                  break;
                case "RemovePersonalInformation":
                  break;
                case "DownloadComponents":
                  break;
                case "LocationOfComponents":
                  break;
                case "Colors":
                  break;
                case "Color":
                  break;
                case "Index":
                  break;
                case "RGB":
                  break;
                case "PixelsPerInch":
                  break;
                case "TargetScreenSize":
                  break;
                case "ReadOnlyRecommended":
                  break;
                default:
                  ae = false;
              }
              break;
            case "ComponentOptions":
              switch (f[3]) {
                case "Toolbar":
                  break;
                case "HideOfficeLogo":
                  break;
                case "SpreadsheetAutoFit":
                  break;
                case "Label":
                  break;
                case "Caption":
                  break;
                case "MaxHeight":
                  break;
                case "MaxWidth":
                  break;
                case "NextSheetNumber":
                  break;
                default:
                  ae = false;
              }
              break;
            case "ExcelWorkbook":
              switch (f[3]) {
                case "Date1904":
                  G.WBProps.date1904 = true;
                  break;
                case "WindowHeight":
                  break;
                case "WindowWidth":
                  break;
                case "WindowTopX":
                  break;
                case "WindowTopY":
                  break;
                case "TabRatio":
                  break;
                case "ProtectStructure":
                  break;
                case "ProtectWindows":
                  break;
                case "ActiveSheet":
                  break;
                case "DisplayInkNotes":
                  break;
                case "FirstVisibleSheet":
                  break;
                case "SupBook":
                  break;
                case "SheetName":
                  break;
                case "SheetIndex":
                  break;
                case "SheetIndexFirst":
                  break;
                case "SheetIndexLast":
                  break;
                case "Dll":
                  break;
                case "AcceptLabelsInFormulas":
                  break;
                case "DoNotSaveLinkValues":
                  break;
                case "Iteration":
                  break;
                case "MaxIterations":
                  break;
                case "MaxChange":
                  break;
                case "Path":
                  break;
                case "Xct":
                  break;
                case "Count":
                  break;
                case "SelectedSheets":
                  break;
                case "Calculation":
                  break;
                case "Uncalced":
                  break;
                case "StartupPrompt":
                  break;
                case "Crn":
                  break;
                case "ExternName":
                  break;
                case "Formula":
                  break;
                case "ColFirst":
                  break;
                case "ColLast":
                  break;
                case "WantAdvise":
                  break;
                case "Boolean":
                  break;
                case "Error":
                  break;
                case "Text":
                  break;
                case "OLE":
                  break;
                case "NoAutoRecover":
                  break;
                case "PublishObjects":
                  break;
                case "DoNotCalculateBeforeSave":
                  break;
                case "Number":
                  break;
                case "RefModeR1C1":
                  break;
                case "EmbedSaveSmartTags":
                  break;
                default:
                  ae = false;
              }
              break;
            case "WorkbookOptions":
              switch (f[3]) {
                case "OWCVersion":
                  break;
                case "Height":
                  break;
                case "Width":
                  break;
                default:
                  ae = false;
              }
              break;
            case "WorksheetOptions":
              switch (f[3]) {
                case "Visible":
                  if (f[0].slice(-2) === "/>") {
                  } else if (f[1] === "/")
                    switch (a.slice(F, f.index)) {
                      case "SheetHidden":
                        j.Hidden = 1;
                        break;
                      case "SheetVeryHidden":
                        j.Hidden = 2;
                        break;
                    }
                  else F = f.index + f[0].length;
                  break;
                case "Header":
                  if (!v["!margins"]) bm((v["!margins"] = {}), "xlml");
                  v["!margins"].header = se(f[0]).Margin;
                  break;
                case "Footer":
                  if (!v["!margins"]) bm((v["!margins"] = {}), "xlml");
                  v["!margins"].footer = se(f[0]).Margin;
                  break;
                case "PageMargins":
                  var ne = se(f[0]);
                  if (!v["!margins"]) bm((v["!margins"] = {}), "xlml");
                  if (ne.Top) v["!margins"].top = ne.Top;
                  if (ne.Left) v["!margins"].left = ne.Left;
                  if (ne.Right) v["!margins"].right = ne.Right;
                  if (ne.Bottom) v["!margins"].bottom = ne.Bottom;
                  break;
                case "Unsynced":
                  break;
                case "Print":
                  break;
                case "Panes":
                  break;
                case "Scale":
                  break;
                case "Pane":
                  break;
                case "Number":
                  break;
                case "Layout":
                  break;
                case "PageSetup":
                  break;
                case "Selected":
                  break;
                case "ProtectObjects":
                  break;
                case "EnableSelection":
                  break;
                case "ProtectScenarios":
                  break;
                case "ValidPrinterInfo":
                  break;
                case "HorizontalResolution":
                  break;
                case "VerticalResolution":
                  break;
                case "NumberofCopies":
                  break;
                case "ActiveRow":
                  break;
                case "ActiveCol":
                  break;
                case "ActivePane":
                  break;
                case "TopRowVisible":
                  break;
                case "TopRowBottomPane":
                  break;
                case "LeftColumnVisible":
                  break;
                case "LeftColumnRightPane":
                  break;
                case "FitToPage":
                  break;
                case "RangeSelection":
                  break;
                case "PaperSizeIndex":
                  break;
                case "PageLayoutZoom":
                  break;
                case "PageBreakZoom":
                  break;
                case "FilterOn":
                  break;
                case "DoNotDisplayGridlines":
                  break;
                case "SplitHorizontal":
                  break;
                case "SplitVertical":
                  break;
                case "FreezePanes":
                  break;
                case "FrozenNoSplit":
                  break;
                case "FitWidth":
                  break;
                case "FitHeight":
                  break;
                case "CommentsLayout":
                  break;
                case "Zoom":
                  break;
                case "LeftToRight":
                  break;
                case "Gridlines":
                  break;
                case "AllowSort":
                  break;
                case "AllowFilter":
                  break;
                case "AllowInsertRows":
                  break;
                case "AllowDeleteRows":
                  break;
                case "AllowInsertCols":
                  break;
                case "AllowDeleteCols":
                  break;
                case "AllowInsertHyperlinks":
                  break;
                case "AllowFormatCells":
                  break;
                case "AllowSizeCols":
                  break;
                case "AllowSizeRows":
                  break;
                case "NoSummaryRowsBelowDetail":
                  break;
                case "TabColorIndex":
                  break;
                case "DoNotDisplayHeadings":
                  break;
                case "ShowPageLayoutZoom":
                  break;
                case "NoSummaryColumnsRightDetail":
                  break;
                case "BlackAndWhite":
                  break;
                case "DoNotDisplayZeros":
                  break;
                case "DisplayPageBreak":
                  break;
                case "RowColHeadings":
                  break;
                case "DoNotDisplayOutline":
                  break;
                case "NoOrientation":
                  break;
                case "AllowUsePivotTables":
                  break;
                case "ZeroHeight":
                  break;
                case "ViewableRange":
                  break;
                case "Selection":
                  break;
                case "ProtectContents":
                  break;
                default:
                  ae = false;
              }
              break;
            case "PivotTable":
            case "PivotCache":
              switch (f[3]) {
                case "ImmediateItemsOnDrop":
                  break;
                case "ShowPageMultipleItemLabel":
                  break;
                case "CompactRowIndent":
                  break;
                case "Location":
                  break;
                case "PivotField":
                  break;
                case "Orientation":
                  break;
                case "LayoutForm":
                  break;
                case "LayoutSubtotalLocation":
                  break;
                case "LayoutCompactRow":
                  break;
                case "Position":
                  break;
                case "PivotItem":
                  break;
                case "DataType":
                  break;
                case "DataField":
                  break;
                case "SourceName":
                  break;
                case "ParentField":
                  break;
                case "PTLineItems":
                  break;
                case "PTLineItem":
                  break;
                case "CountOfSameItems":
                  break;
                case "Item":
                  break;
                case "ItemType":
                  break;
                case "PTSource":
                  break;
                case "CacheIndex":
                  break;
                case "ConsolidationReference":
                  break;
                case "FileName":
                  break;
                case "Reference":
                  break;
                case "NoColumnGrand":
                  break;
                case "NoRowGrand":
                  break;
                case "BlankLineAfterItems":
                  break;
                case "Hidden":
                  break;
                case "Subtotal":
                  break;
                case "BaseField":
                  break;
                case "MapChildItems":
                  break;
                case "Function":
                  break;
                case "RefreshOnFileOpen":
                  break;
                case "PrintSetTitles":
                  break;
                case "MergeLabels":
                  break;
                case "DefaultVersion":
                  break;
                case "RefreshName":
                  break;
                case "RefreshDate":
                  break;
                case "RefreshDateCopy":
                  break;
                case "VersionLastRefresh":
                  break;
                case "VersionLastUpdate":
                  break;
                case "VersionUpdateableMin":
                  break;
                case "VersionRefreshableMin":
                  break;
                case "Calculation":
                  break;
                default:
                  ae = false;
              }
              break;
            case "PageBreaks":
              switch (f[3]) {
                case "ColBreaks":
                  break;
                case "ColBreak":
                  break;
                case "RowBreaks":
                  break;
                case "RowBreak":
                  break;
                case "ColStart":
                  break;
                case "ColEnd":
                  break;
                case "RowEnd":
                  break;
                default:
                  ae = false;
              }
              break;
            case "AutoFilter":
              switch (f[3]) {
                case "AutoFilterColumn":
                  break;
                case "AutoFilterCondition":
                  break;
                case "AutoFilterAnd":
                  break;
                case "AutoFilterOr":
                  break;
                default:
                  ae = false;
              }
              break;
            case "QueryTable":
              switch (f[3]) {
                case "Id":
                  break;
                case "AutoFormatFont":
                  break;
                case "AutoFormatPattern":
                  break;
                case "QuerySource":
                  break;
                case "QueryType":
                  break;
                case "EnableRedirections":
                  break;
                case "RefreshedInXl9":
                  break;
                case "URLString":
                  break;
                case "HTMLTables":
                  break;
                case "Connection":
                  break;
                case "CommandText":
                  break;
                case "RefreshInfo":
                  break;
                case "NoTitles":
                  break;
                case "NextId":
                  break;
                case "ColumnInfo":
                  break;
                case "OverwriteCells":
                  break;
                case "DoNotPromptForFile":
                  break;
                case "TextWizardSettings":
                  break;
                case "Source":
                  break;
                case "Number":
                  break;
                case "Decimal":
                  break;
                case "ThousandSeparator":
                  break;
                case "TrailingMinusNumbers":
                  break;
                case "FormatSettings":
                  break;
                case "FieldType":
                  break;
                case "Delimiters":
                  break;
                case "Tab":
                  break;
                case "Comma":
                  break;
                case "AutoFormatName":
                  break;
                case "VersionLastEdit":
                  break;
                case "VersionLastRefresh":
                  break;
                default:
                  ae = false;
              }
              break;
            case "Sorting":
            case "ConditionalFormatting":
            case "DataValidation":
              switch (f[3]) {
                case "Range":
                  break;
                case "Type":
                  break;
                case "Min":
                  break;
                case "Max":
                  break;
                case "Sort":
                  break;
                case "Descending":
                  break;
                case "Order":
                  break;
                case "CaseSensitive":
                  break;
                case "Value":
                  break;
                case "ErrorStyle":
                  break;
                case "ErrorMessage":
                  break;
                case "ErrorTitle":
                  break;
                case "CellRangeList":
                  break;
                case "InputMessage":
                  break;
                case "InputTitle":
                  break;
                case "ComboHide":
                  break;
                case "InputHide":
                  break;
                case "Condition":
                  break;
                case "Qualifier":
                  break;
                case "UseBlank":
                  break;
                case "Value1":
                  break;
                case "Value2":
                  break;
                case "Format":
                  break;
                default:
                  ae = false;
              }
              break;
            case "MapInfo":
            case "Schema":
            case "data":
              switch (f[3]) {
                case "Map":
                  break;
                case "Entry":
                  break;
                case "Range":
                  break;
                case "XPath":
                  break;
                case "Field":
                  break;
                case "XSDType":
                  break;
                case "FilterOn":
                  break;
                case "Aggregate":
                  break;
                case "ElementType":
                  break;
                case "AttributeType":
                  break;
                case "schema":
                case "element":
                case "complexType":
                case "datatype":
                case "all":
                case "attribute":
                case "extends":
                  break;
                case "row":
                  break;
                default:
                  ae = false;
              }
              break;
            case "SmartTags":
              break;
            default:
              ae = false;
              break;
          }
          if (ae) break;
          if (!l[l.length - 1][1])
            throw "Unrecognized tag: " + f[3] + "|" + l.join("|");
          if (l[l.length - 1][0] === "CustomDocumentProperties") {
            if (f[0].slice(-2) === "/>") break;
            else if (f[1] === "/") Gg(O, f, P, a.slice(F, f.index));
            else {
              P = f;
              F = f.index + f[0].length;
            }
            break;
          }
          if (t.WTF) throw "Unrecognized tag: " + f[3] + "|" + l.join("|");
      }
    var ie = {};
    if (!t.bookSheets && !t.bookProps) ie.Sheets = h;
    ie.SheetNames = d;
    ie.Workbook = G;
    ie.SSF = E.get_table();
    ie.Props = D;
    ie.Custprops = O;
    return ie;
  }
  function qg(e, r) {
    KE((r = r || {}));
    switch (r.type || "base64") {
      case "base64":
        return Jg(h.decode(e), r);
      case "binary":
      case "buffer":
      case "file":
        return Jg(e, r);
      case "array":
        return Jg(e.map(Wg).join(""), r);
    }
  }
  function eE(e, r) {
    var t = [];
    if (e.Props) t.push(Pa(e.Props, r));
    if (e.Custprops) t.push(Na(e.Props, e.Custprops, r));
    return t.join("");
  }
  function rE(e, r) {
    return "";
  }
  function tE(e, r) {
    return "";
  }
  function aE(e, r, t, a) {
    if (!e) return "";
    var n = [];
    if (e["!margins"]) {
      n.push("<PageSetup>");
      if (e["!margins"].header)
        n.push(De("Header", null, { "x:Margin": e["!margins"].header }));
      if (e["!margins"].footer)
        n.push(De("Footer", null, { "x:Margin": e["!margins"].footer }));
      n.push(
        De("PageMargins", null, {
          "x:Bottom": e["!margins"].bottom || "0.75",
          "x:Left": e["!margins"].left || "0.7",
          "x:Right": e["!margins"].right || "0.7",
          "x:Top": e["!margins"].top || "0.75",
        })
      );
      n.push("</PageSetup>");
    }
    if (a && a.Workbook && a.Workbook.Sheets && a.Workbook.Sheets[t]) {
      if (a.Workbook.Sheets[t].Hidden)
        n.push(
          De(
            "Visible",
            a.Workbook.Sheets[t].Hidden == 1
              ? "SheetHidden"
              : "SheetVeryHidden",
            {}
          )
        );
      else {
        for (var i = 0; i < t; ++i)
          if (a.Workbook.Sheets[i] && !a.Workbook.Sheets[i].Hidden) break;
        if (i == t) n.push("<Selected/>");
      }
    }
    if (e["!protect"]) {
      n.push(ye("ProtectContents", "True"));
      if (e["!protect"].objects) n.push(ye("ProtectObjects", "True"));
      if (e["!protect"].scenarios) n.push(ye("ProtectScenarios", "True"));
      if (
        e["!protect"].selectLockedCells != null &&
        !e["!protect"].selectLockedCells
      )
        n.push(ye("EnableSelection", "NoSelection"));
      else if (
        e["!protect"].selectUnlockedCells != null &&
        !e["!protect"].selectUnlockedCells
      )
        n.push(ye("EnableSelection", "UnlockedCells"));
      [
        ["formatColumns", "AllowFormatCells"],
        ["formatRows", "AllowSizeCols"],
        ["formatCells", "AllowSizeRows"],
        ["insertColumns", "AllowInsertCols"],
        ["insertRows", "AllowInsertRows"],
        ["insertHyperlinks", "AllowInsertHyperlinks"],
        ["deleteColumns", "AllowDeleteCols"],
        ["deleteRows", "AllowDeleteRows"],
        ["sort", "AllowSort"],
        ["autoFilter", "AllowFilter"],
        ["pivotTables", "AllowUsePivotTables"],
      ].forEach(function (r) {
        if (e["!protect"][r[0]]) n.push("<" + r[1] + "/>");
      });
    }
    if (n.length == 0) return "";
    return De("WorksheetOptions", n.join(""), { xmlns: Le.x });
  }
  function nE(e) {
    return e
      .map(function (e) {
        var r = ge(e.t || "");
        var t = De("ss:Data", r, { xmlns: "http://www.w3.org/TR/REC-html40" });
        return De("Comment", t, { "ss:Author": e.a });
      })
      .join("");
  }
  function iE(e, r, t, a, n, i, s) {
    if (!e || (e.v == undefined && e.f == undefined)) return "<Cell></Cell>";
    var f = {};
    if (e.f) f["ss:Formula"] = "=" + de(gv(e.f, s));
    if (e.F && e.F.substr(0, r.length) == r) {
      var o = Wr(e.F.substr(r.length + 1));
      f["ss:ArrayRange"] =
        "RC:R" +
        (o.r == s.r ? "" : "[" + (o.r - s.r) + "]") +
        "C" +
        (o.c == s.c ? "" : "[" + (o.c - s.c) + "]");
    }
    if (e.l && e.l.Target) {
      f["ss:HRef"] = de(e.l.Target);
      if (e.l.Tooltip) f["x:HRefScreenTip"] = de(e.l.Tooltip);
    }
    if (t["!merges"]) {
      var l = t["!merges"];
      for (var c = 0; c != l.length; ++c) {
        if (l[c].s.c != s.c || l[c].s.r != s.r) continue;
        if (l[c].e.c > l[c].s.c) f["ss:MergeAcross"] = l[c].e.c - l[c].s.c;
        if (l[c].e.r > l[c].s.r) f["ss:MergeDown"] = l[c].e.r - l[c].s.r;
      }
    }
    var u = "",
      h = "";
    switch (e.t) {
      case "z":
        return "";
      case "n":
        u = "Number";
        h = String(e.v);
        break;
      case "b":
        u = "Boolean";
        h = e.v ? "1" : "0";
        break;
      case "e":
        u = "Error";
        h = _t[e.v];
        break;
      case "d":
        u = "DateTime";
        h = new Date(e.v).toISOString();
        break;
      case "s":
        u = "String";
        h = de(e.v || "");
        break;
    }
    var d = e.v != null ? h : "";
    if (
      a &&
      a.type == "binary" &&
      typeof cptable !== "undefined" &&
      e.t == "s"
    ) {
      d = cptable.utils.encode(65001, d);
      var v = "";
      for (var p = 0; p < d.length; ++p) v += String.fromCharCode(d[p]);
      d = v;
    }
    var m = '<Data ss:Type="' + u + '">' + d + "</Data>";
    if ((e.c || []).length > 0) m += nE(e.c);
    return De("Cell", m, f);
  }
  function sE(e, r) {
    var t = '<Row ss:Index="' + (e + 1) + '"';
    if (r) {
      if (r.hpt && !r.hpx) r.hpx = Xh(r.hpt);
      if (r.hpx) t += ' ss:AutoFitHeight="0" ss:Height="' + r.hpx + '"';
      if (r.hidden) t += ' ss:Hidden="1"';
    }
    return t + ">";
  }
  function fE(e, r, t, a) {
    if (!e["!ref"]) return "";
    var n = Kr(e["!ref"]);
    var i = e["!merges"] || [],
      s = 0;
    var f = [];
    if (e["!cols"])
      e["!cols"].forEach(function (e, r) {
        Hh(e);
        var t = !!e.width;
        var a = mm(r, e);
        var n = { "ss:Index": r + 1 };
        if (t) n["ss:Width"] = Dh(a.width);
        if (e.hidden) n["ss:Hidden"] = "1";
        f.push(De("Column", null, n));
      });
    var o = Array.isArray(e);
    for (var l = n.s.r; l <= n.e.r; ++l) {
      var c = [sE(l, (e["!rows"] || [])[l])];
      for (var u = n.s.c; u <= n.e.c; ++u) {
        var h = false;
        for (s = 0; s != i.length; ++s) {
          if (i[s].s.c > u) continue;
          if (i[s].s.r > l) continue;
          if (i[s].e.c < u) continue;
          if (i[s].e.r < l) continue;
          if (i[s].s.c != u || i[s].s.r != l) h = true;
          break;
        }
        if (h) continue;
        var d = { r: l, c: u };
        var v = Vr(d),
          p = o ? (e[l] || [])[u] : e[v];
        c.push(iE(p, v, e, r, t, a, d));
      }
      c.push("</Row>");
      if (c.length > 2) f.push(c.join(""));
    }
    return f.join("");
  }
  function oE(e, r, t) {
    var a = [];
    var n = t.SheetNames[e];
    var i = t.Sheets[n];
    var s = i ? fE(i, r, e, t) : "";
    if (s.length > 0) a.push("<Table>" + s + "</Table>");
    a.push(aE(i, r, e, t));
    return a.join("");
  }
  function lE(e, r) {
    var t = [];
    t.push(eE(e, r));
    t.push(rE(e, r));
    t.push(tE(e, r));
    for (var a = 0; a < e.SheetNames.length; ++a)
      t.push(De("Worksheet", oE(a, r, e), { "ss:Name": de(e.SheetNames[a]) }));
    return (
      Pe +
      De("Workbook", t.join(""), {
        xmlns: Le.ss,
        "xmlns:o": Le.o,
        "xmlns:x": Le.x,
        "xmlns:ss": Le.ss,
        "xmlns:dt": Le.dt,
        "xmlns:html": Le.html,
      })
    );
  }
  function cE(e) {
    var r = {};
    var t = e.content;
    var a = 28,
      n;
    n = Ye(t, a);
    a += 4 + or(t, a);
    r.UserType = n;
    n = or(t, a);
    a += 4;
    switch (n) {
      case 0:
        break;
      case 4294967295:
      case 4294967294:
        a += 4;
        break;
      default:
        if (n > 400)
          throw new Error("Unsupported Clipboard: " + n.toString(16));
        a += n;
    }
    n = Ye(t, a);
    a += n.length === 0 ? 0 : 5 + n.length;
    r.Reserved1 = n;
    if ((n = or(t, a)) !== 1907550708) return r;
    throw new Error("Unsupported Unicode Extension");
  }
  function uE(e, r, t, a) {
    var n = t;
    var i = [];
    var s = r.slice(r.l, r.l + n);
    if (a && a.enc && a.enc.insitu_decrypt)
      switch (e.n) {
        case "BOF":
        case "FilePass":
        case "FileLock":
        case "InterfaceHdr":
        case "RRDInfo":
        case "RRDHead":
        case "UsrExcl":
          break;
        default:
          if (s.length === 0) break;
          a.enc.insitu_decrypt(s);
      }
    i.push(s);
    r.l += n;
    var f = EE[sr(r, r.l)];
    var o = 0;
    while (f != null && f.n.slice(0, 8) === "Continue") {
      n = sr(r, r.l + 2);
      o = r.l + 4;
      if (f.n == "ContinueFrt") o += 4;
      else if (f.n.slice(0, 11) == "ContinueFrt") o += 12;
      i.push(r.slice(o, r.l + 4 + n));
      r.l += 4 + n;
      f = EE[sr(r, r.l)];
    }
    var l = m(i);
    gr(l, 0);
    var c = 0;
    l.lens = [];
    for (var u = 0; u < i.length; ++u) {
      l.lens.push(c);
      c += i[u].length;
    }
    return e.f(l, l.length, a);
  }
  function hE(e, r, t) {
    if (e.t === "z") return;
    if (!e.XF) return;
    var a = 0;
    try {
      a = e.z || e.XF.numFmtId || 0;
      if (r.cellNF) e.z = E._table[a];
    } catch (n) {
      if (r.WTF) throw n;
    }
    if (!r || r.cellText !== false)
      try {
        if (e.t === "e") {
          e.w = e.w || _t[e.v];
        } else if (a === 0 || a == "General") {
          if (e.t === "n") {
            if ((e.v | 0) === e.v) e.w = E._general_int(e.v);
            else e.w = E._general_num(e.v);
          } else e.w = E._general(e.v);
        } else e.w = E.format(a, e.v, { date1904: !!t });
        if (
          r.cellDates &&
          a &&
          e.t == "n" &&
          E.is_date(E._table[a] || String(a))
        ) {
          var i = E.parse_date_code(e.v);
          if (i) {
            e.t = "d";
            e.v = new Date(i.y, i.m - 1, i.d, i.H, i.M, i.S, i.u);
          }
        }
      } catch (n) {
        if (r.WTF) throw n;
      }
  }
  function dE(e, r, t) {
    return { v: e, ixfe: r, t: t };
  }
  function vE(e, r) {
    var t = { opts: {} };
    var a = {};
    if (c != null && r.dense == null) r.dense = c;
    var i = r.dense ? [] : {};
    var s = {};
    var f = false;
    var o = {};
    var l = null;
    var u = [];
    var h = "";
    var d = {};
    var v,
      p = "",
      m,
      b,
      g,
      k,
      S;
    var w = {};
    var B = [];
    var C;
    var _;
    var T = true;
    var x = [];
    var I = [];
    var A = { Sheets: [], WBProps: { date1904: false } },
      y = {};
    var R = function ge(e) {
      if (e < 8) return Zt[e];
      if (e < 64) return I[e - 8] || Zt[e];
      return Zt[e];
    };
    var D = function Ee(e, r, t) {
      var a = r.XF.data;
      if (!a || !a.patternType || !t || !t.cellStyles) return;
      r.s = {};
      r.s.patternType = a.patternType;
      var n;
      if ((n = Ch(R(a.icvFore)))) {
        r.s.fgColor = { rgb: n };
      }
      if ((n = Ch(R(a.icvBack)))) {
        r.s.bgColor = { rgb: n };
      }
    };
    var O = function ke(e, r, t) {
      if (X > 1) return;
      if (!T) return;
      if (t.cellStyles && r.XF && r.XF.data) D(e, r, t);
      v = e;
      p = Vr(e);
      if (o.s) {
        if (e.r < o.s.r) o.s.r = e.r;
        if (e.c < o.s.c) o.s.c = e.c;
      }
      if (o.e) {
        if (e.r + 1 > o.e.r) o.e.r = e.r + 1;
        if (e.c + 1 > o.e.c) o.e.c = e.c + 1;
      }
      if (t.cellFormula && r.f) {
        for (var a = 0; a < B.length; ++a) {
          if (B[a][0].s.c > e.c) continue;
          if (B[a][0].s.r > e.r) continue;
          if (B[a][0].e.c < e.c) continue;
          if (B[a][0].e.r < e.r) continue;
          r.F = jr(B[a][0]);
          if (B[a][0].s.c != e.c) delete r.f;
          if (B[a][0].s.r != e.r) delete r.f;
          if (r.f) r.f = "" + qp(B[a][1], o, e, V, F);
          break;
        }
      }
      if (t.sheetRows && v.r >= t.sheetRows) T = false;
      else {
        if (t.dense) {
          if (!i[e.r]) i[e.r] = [];
          i[e.r][e.c] = r;
        } else i[p] = r;
      }
    };
    var F = {
      enc: false,
      sbcch: 0,
      snames: [],
      sharedf: w,
      arrayf: B,
      rrtabid: [],
      lastuser: "",
      biff: 8,
      codepage: 0,
      winlocked: 0,
      cellStyles: !!r && !!r.cellStyles,
      WTF: !!r && !!r.wtf,
    };
    if (r.password) F.password = r.password;
    var P = [];
    var N = [];
    var L = [],
      M = [];
    var U = 0,
      H = 0;
    var W = false;
    var V = [];
    V.SheetNames = F.snames;
    V.sharedf = F.sharedf;
    V.arrayf = F.arrayf;
    V.names = [];
    V.XTI = [];
    var z = "";
    var X = 0;
    var G = 0;
    var j = [];
    var K = [];
    var Y;
    F.codepage = 1200;
    n(1200);
    while (e.l < e.length - 1) {
      var $ = e.l;
      var Z = e.read_shift(2);
      if (Z === 0 && z === "EOF") break;
      var Q = e.l === e.length ? 0 : e.read_shift(2),
        J;
      var q = EE[Z];
      if (q && q.f) {
        if (r.bookSheets) {
          if (z === "BoundSheet8" && q.n !== "BoundSheet8") break;
        }
        z = q.n;
        if (q.r === 2 || q.r == 12) {
          var ee = e.read_shift(2);
          Q -= 2;
          if (!F.enc && ee !== Z)
            throw new Error("rt mismatch: " + ee + "!=" + Z);
          if (q.r == 12) {
            e.l += 10;
            Q -= 10;
          }
        }
        var re;
        if (q.n === "EOF") re = q.f(e, Q, F);
        else re = uE(q, e, Q, F);
        var te = q.n;
        switch (te) {
          case "Date1904":
            t.opts.Date1904 = A.WBProps.date1904 = re;
            break;
          case "WriteProtect":
            t.opts.WriteProtect = true;
            break;
          case "FilePass":
            if (!F.enc) e.l = 0;
            F.enc = re;
            if (F.WTF) console.error(re);
            if (!r.password) throw new Error("File is password-protected");
            if (re.valid == null)
              throw new Error("Encryption scheme unsupported");
            if (!re.valid) throw new Error("Password is incorrect");
            break;
          case "WriteAccess":
            F.lastuser = re;
            break;
          case "FileSharing":
            break;
          case "CodePage":
            if (re === 21010) re = 1200;
            else if (re === 32769) re = 1252;
            F.codepage = re;
            n(re);
            break;
          case "RRTabId":
            F.rrtabid = re;
            break;
          case "WinProtect":
            F.winlocked = re;
            break;
          case "Template":
            break;
          case "RefreshAll":
            t.opts.RefreshAll = re;
            break;
          case "BookBool":
            break;
          case "UsesELFs":
            break;
          case "MTRSettings":
            break;
          case "CalcCount":
            t.opts.CalcCount = re;
            break;
          case "CalcDelta":
            t.opts.CalcDelta = re;
            break;
          case "CalcIter":
            t.opts.CalcIter = re;
            break;
          case "CalcMode":
            t.opts.CalcMode = re;
            break;
          case "CalcPrecision":
            t.opts.CalcPrecision = re;
            break;
          case "CalcSaveRecalc":
            t.opts.CalcSaveRecalc = re;
            break;
          case "CalcRefMode":
            F.CalcRefMode = re;
            break;
          case "Uncalced":
            break;
          case "ForceFullCalculation":
            t.opts.FullCalc = re;
            break;
          case "WsBool":
            break;
          case "XF":
            x.push(re);
            break;
          case "ExtSST":
            break;
          case "BookExt":
            break;
          case "RichTextStream":
            break;
          case "BkHim":
            break;
          case "SupBook":
            V.push([re]);
            V[V.length - 1].XTI = [];
            break;
          case "ExternName":
            V[V.length - 1].push(re);
            break;
          case "Index":
            break;
          case "Lbl":
            Y = { Name: re.Name, Ref: qp(re.rgce, o, null, V, F) };
            if (re.itab > 0) Y.Sheet = re.itab - 1;
            V.names.push(Y);
            if (!V[0]) V[0] = [];
            V[V.length - 1].push(re);
            if (re.Name == "_xlnm._FilterDatabase" && re.itab > 0)
              if (
                re.rgce &&
                re.rgce[0] &&
                re.rgce[0][0] &&
                re.rgce[0][0][0] == "PtgArea3d"
              )
                K[re.itab - 1] = { ref: jr(re.rgce[0][0][1][2]) };
            break;
          case "ExternCount":
            F.ExternCount = re;
            break;
          case "ExternSheet":
            if (V.length == 0) {
              V[0] = [];
              V[0].XTI = [];
            }
            V[V.length - 1].XTI = V[V.length - 1].XTI.concat(re);
            V.XTI = V.XTI.concat(re);
            break;
          case "NameCmt":
            if (F.biff < 8) break;
            if (Y != null) Y.Comment = re[1];
            break;
          case "Protect":
            i["!protect"] = re;
            break;
          case "Password":
            if (re !== 0 && F.WTF) console.error("Password verifier: " + re);
            break;
          case "Prot4Rev":
          case "Prot4RevPass":
            break;
          case "BoundSheet8":
            {
              s[re.pos] = re;
              F.snames.push(re.name);
            }
            break;
          case "EOF":
            {
              if (--X) break;
              if (o.e) {
                if (o.e.r > 0 && o.e.c > 0) {
                  o.e.r--;
                  o.e.c--;
                  i["!ref"] = jr(o);
                  o.e.r++;
                  o.e.c++;
                }
                if (P.length > 0) i["!merges"] = P;
                if (N.length > 0) i["!objects"] = N;
                if (L.length > 0) i["!cols"] = L;
                if (M.length > 0) i["!rows"] = M;
                A.Sheets.push(y);
              }
              if (h === "") d = i;
              else a[h] = i;
              i = r.dense ? [] : {};
            }
            break;
          case "BOF":
            {
              if (F.biff !== 8) {
              } else if (Z === 9) F.biff = 2;
              else if (Z === 521) F.biff = 3;
              else if (Z === 1033) F.biff = 4;
              else if (re.BIFFVer === 1280) F.biff = 5;
              else if (re.BIFFVer === 1536) F.biff = 8;
              else if (re.BIFFVer === 2) F.biff = 2;
              else if (re.BIFFVer === 7) F.biff = 2;
              if (X++) break;
              T = true;
              i = r.dense ? [] : {};
              if (F.biff < 5) {
                if (h === "") h = "Sheet1";
                o = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
                var ae = { pos: e.l - Q, name: h };
                s[ae.pos] = ae;
                F.snames.push(h);
              } else h = (s[$] || { name: "" }).name;
              if (re.dt == 32) i["!type"] = "chart";
              P = [];
              N = [];
              B = [];
              F.arrayf = B;
              L = [];
              M = [];
              U = H = 0;
              W = false;
              y = { Hidden: (s[$] || { hs: 0 }).hs, name: h };
            }
            break;
          case "Number":
          case "BIFF2NUM":
          case "BIFF2INT":
            {
              if (i["!type"] == "chart")
                if (
                  r.dense ? (i[re.r] || [])[re.c] : i[Vr({ c: re.c, r: re.r })]
                )
                  ++re.c;
              C = { ixfe: re.ixfe, XF: x[re.ixfe] || {}, v: re.val, t: "n" };
              if (G > 0) C.z = j[(C.ixfe >> 8) & 31];
              hE(C, r, t.opts.Date1904);
              O({ c: re.c, r: re.r }, C, r);
            }
            break;
          case "BoolErr":
            {
              C = { ixfe: re.ixfe, XF: x[re.ixfe], v: re.val, t: re.t };
              if (G > 0) C.z = j[(C.ixfe >> 8) & 31];
              hE(C, r, t.opts.Date1904);
              O({ c: re.c, r: re.r }, C, r);
            }
            break;
          case "RK":
            {
              C = { ixfe: re.ixfe, XF: x[re.ixfe], v: re.rknum, t: "n" };
              if (G > 0) C.z = j[(C.ixfe >> 8) & 31];
              hE(C, r, t.opts.Date1904);
              O({ c: re.c, r: re.r }, C, r);
            }
            break;
          case "MulRk":
            {
              for (var ne = re.c; ne <= re.C; ++ne) {
                var ie = re.rkrec[ne - re.c][0];
                C = { ixfe: ie, XF: x[ie], v: re.rkrec[ne - re.c][1], t: "n" };
                if (G > 0) C.z = j[(C.ixfe >> 8) & 31];
                hE(C, r, t.opts.Date1904);
                O({ c: ne, r: re.r }, C, r);
              }
            }
            break;
          case "Formula":
            {
              if (re.val == "String") {
                l = re;
                break;
              }
              C = dE(re.val, re.cell.ixfe, re.tt);
              C.XF = x[C.ixfe];
              if (r.cellFormula) {
                var se = re.formula;
                if (se && se[0] && se[0][0] && se[0][0][0] == "PtgExp") {
                  var fe = se[0][0][1][0],
                    oe = se[0][0][1][1];
                  var le = Vr({ r: fe, c: oe });
                  if (w[le]) C.f = "" + qp(re.formula, o, re.cell, V, F);
                  else C.F = ((r.dense ? (i[fe] || [])[oe] : i[le]) || {}).F;
                } else C.f = "" + qp(re.formula, o, re.cell, V, F);
              }
              if (G > 0) C.z = j[(C.ixfe >> 8) & 31];
              hE(C, r, t.opts.Date1904);
              O(re.cell, C, r);
              l = re;
            }
            break;
          case "String":
            {
              if (l) {
                l.val = re;
                C = dE(re, l.cell.ixfe, "s");
                C.XF = x[C.ixfe];
                if (r.cellFormula) {
                  C.f = "" + qp(l.formula, o, l.cell, V, F);
                }
                if (G > 0) C.z = j[(C.ixfe >> 8) & 31];
                hE(C, r, t.opts.Date1904);
                O(l.cell, C, r);
                l = null;
              } else throw new Error("String record expects Formula");
            }
            break;
          case "Array":
            {
              B.push(re);
              var ce = Vr(re[0].s);
              m = r.dense ? (i[re[0].s.r] || [])[re[0].s.c] : i[ce];
              if (r.cellFormula && m) {
                if (!l) break;
                if (!ce || !m) break;
                m.f = "" + qp(re[1], o, re[0], V, F);
                m.F = jr(re[0]);
              }
            }
            break;
          case "ShrFmla":
            {
              if (!T) break;
              if (!r.cellFormula) break;
              if (p) {
                if (!l) break;
                w[Vr(l.cell)] = re[0];
                m = r.dense ? (i[l.cell.r] || [])[l.cell.c] : i[Vr(l.cell)];
                (m || {}).f = "" + qp(re[0], o, v, V, F);
              }
            }
            break;
          case "LabelSst":
            C = dE(u[re.isst].t, re.ixfe, "s");
            C.XF = x[C.ixfe];
            if (G > 0) C.z = j[(C.ixfe >> 8) & 31];
            hE(C, r, t.opts.Date1904);
            O({ c: re.c, r: re.r }, C, r);
            break;
          case "Blank":
            if (r.sheetStubs) {
              C = { ixfe: re.ixfe, XF: x[re.ixfe], t: "z" };
              if (G > 0) C.z = j[(C.ixfe >> 8) & 31];
              hE(C, r, t.opts.Date1904);
              O({ c: re.c, r: re.r }, C, r);
            }
            break;
          case "MulBlank":
            if (r.sheetStubs) {
              for (var ue = re.c; ue <= re.C; ++ue) {
                var he = re.ixfe[ue - re.c];
                C = { ixfe: he, XF: x[he], t: "z" };
                if (G > 0) C.z = j[(C.ixfe >> 8) & 31];
                hE(C, r, t.opts.Date1904);
                O({ c: ue, r: re.r }, C, r);
              }
            }
            break;
          case "RString":
          case "Label":
          case "BIFF2STR":
            C = dE(re.val, re.ixfe, "s");
            C.XF = x[C.ixfe];
            if (G > 0) C.z = j[(C.ixfe >> 8) & 31];
            hE(C, r, t.opts.Date1904);
            O({ c: re.c, r: re.r }, C, r);
            break;
          case "Dimensions":
            {
              if (X === 1) o = re;
            }
            break;
          case "SST":
            {
              u = re;
            }
            break;
          case "Format":
            {
              E.load(re[1], re[0]);
            }
            break;
          case "BIFF2FORMAT":
            {
              j[G++] = re;
              for (var de = 0; de < G + 163; ++de)
                if (E._table[de] == re) break;
              if (de >= 163) E.load(re, G + 163);
            }
            break;
          case "MergeCells":
            P = P.concat(re);
            break;
          case "Obj":
            N[re.cmo[0]] = F.lastobj = re;
            break;
          case "TxO":
            F.lastobj.TxO = re;
            break;
          case "ImData":
            F.lastobj.ImData = re;
            break;
          case "HLink":
            {
              for (S = re[0].s.r; S <= re[0].e.r; ++S)
                for (k = re[0].s.c; k <= re[0].e.c; ++k) {
                  m = r.dense ? (i[S] || [])[k] : i[Vr({ c: k, r: S })];
                  if (m) m.l = re[1];
                }
            }
            break;
          case "HLinkTooltip":
            {
              for (S = re[0].s.r; S <= re[0].e.r; ++S)
                for (k = re[0].s.c; k <= re[0].e.c; ++k) {
                  m = r.dense ? (i[S] || [])[k] : i[Vr({ c: k, r: S })];
                  if (m) m.l.Tooltip = re[1];
                }
            }
            break;
          case "Note":
            {
              if (F.biff <= 5 && F.biff >= 2) break;
              m = r.dense ? (i[re[0].r] || [])[re[0].c] : i[Vr(re[0])];
              var ve = N[re[2]];
              if (!m) break;
              if (!m.c) m.c = [];
              b = { a: re[1], t: ve.TxO.t };
              m.c.push(b);
            }
            break;
          default:
            switch (q.n) {
              case "ClrtClient":
                break;
              case "XFExt":
                jd(x[re.ixfe], re.ext);
                break;
              case "DefColWidth":
                U = re;
                break;
              case "DefaultRowHeight":
                H = re[1];
                break;
              case "ColInfo":
                {
                  if (!F.cellStyles) break;
                  while (re.e >= re.s) {
                    L[re.e--] = { width: re.w / 256 };
                    if (!W) {
                      W = true;
                      Mh(re.w / 256);
                    }
                    Hh(L[re.e + 1]);
                  }
                }
                break;
              case "Row":
                {
                  var pe = {};
                  if (re.level != null) {
                    M[re.r] = pe;
                    pe.level = re.level;
                  }
                  if (re.hidden) {
                    M[re.r] = pe;
                    pe.hidden = true;
                  }
                  if (re.hpt) {
                    M[re.r] = pe;
                    pe.hpt = re.hpt;
                    pe.hpx = Xh(re.hpt);
                  }
                }
                break;
              case "LeftMargin":
              case "RightMargin":
              case "TopMargin":
              case "BottomMargin":
                if (!i["!margins"]) bm((i["!margins"] = {}));
                i["!margins"][te.slice(0, -6).toLowerCase()] = re;
                break;
              case "Setup":
                if (!i["!margins"]) bm((i["!margins"] = {}));
                i["!margins"].header = re.header;
                i["!margins"].footer = re.footer;
                break;
              case "Header":
                break;
              case "Footer":
                break;
              case "HCenter":
                break;
              case "VCenter":
                break;
              case "Pls":
                break;
              case "GCW":
                break;
              case "LHRecord":
                break;
              case "DBCell":
                break;
              case "EntExU2":
                break;
              case "SxView":
                break;
              case "Sxvd":
                break;
              case "SXVI":
                break;
              case "SXVDEx":
                break;
              case "SxIvd":
                break;
              case "SXString":
                break;
              case "Sync":
                break;
              case "Addin":
                break;
              case "SXDI":
                break;
              case "SXLI":
                break;
              case "SXEx":
                break;
              case "QsiSXTag":
                break;
              case "Selection":
                break;
              case "Feat":
                break;
              case "FeatHdr":
              case "FeatHdr11":
                break;
              case "Feature11":
              case "Feature12":
              case "List12":
                break;
              case "Country":
                _ = re;
                break;
              case "RecalcId":
                break;
              case "DxGCol":
                break;
              case "Fbi":
              case "Fbi2":
              case "GelFrame":
                break;
              case "Font":
                break;
              case "XFCRC":
                break;
              case "Style":
                break;
              case "StyleExt":
                break;
              case "Palette":
                I = re;
                break;
              case "Theme":
                break;
              case "ScenarioProtect":
                break;
              case "ObjProtect":
                break;
              case "CondFmt12":
                break;
              case "Table":
                break;
              case "TableStyles":
                break;
              case "TableStyle":
                break;
              case "TableStyleElement":
                break;
              case "SXStreamID":
                break;
              case "SXVS":
                break;
              case "DConRef":
                break;
              case "SXAddl":
                break;
              case "DConBin":
                break;
              case "DConName":
                break;
              case "SXPI":
                break;
              case "SxFormat":
                break;
              case "SxSelect":
                break;
              case "SxRule":
                break;
              case "SxFilt":
                break;
              case "SxItm":
                break;
              case "SxDXF":
                break;
              case "ScenMan":
                break;
              case "DCon":
                break;
              case "CellWatch":
                break;
              case "PrintRowCol":
                break;
              case "PrintGrid":
                break;
              case "PrintSize":
                break;
              case "XCT":
                break;
              case "CRN":
                break;
              case "Scl":
                {
                }
                break;
              case "SheetExt":
                {
                }
                break;
              case "SheetExtOptional":
                {
                }
                break;
              case "ObNoMacros":
                {
                }
                break;
              case "ObProj":
                {
                }
                break;
              case "CodeName":
                {
                }
                break;
              case "GUIDTypeLib":
                {
                }
                break;
              case "WOpt":
                break;
              case "PhoneticInfo":
                break;
              case "OleObjectSize":
                break;
              case "DXF":
              case "DXFN":
              case "DXFN12":
              case "DXFN12List":
              case "DXFN12NoCB":
                break;
              case "Dv":
              case "DVal":
                break;
              case "BRAI":
              case "Series":
              case "SeriesText":
                break;
              case "DConn":
                break;
              case "DbOrParamQry":
                break;
              case "DBQueryExt":
                break;
              case "OleDbConn":
                break;
              case "ExtString":
                break;
              case "IFmtRecord":
                break;
              case "CondFmt":
              case "CF":
              case "CF12":
              case "CFEx":
                break;
              case "Excel9File":
                break;
              case "Units":
                break;
              case "InterfaceHdr":
              case "Mms":
              case "InterfaceEnd":
              case "DSF":
              case "BuiltInFnGroupCount":
                break;
              case "Window1":
              case "Window2":
              case "HideObj":
              case "GridSet":
              case "Guts":
              case "UserBView":
              case "UserSViewBegin":
              case "UserSViewEnd":
              case "Pane":
                break;
              default:
                switch (q.n) {
                  case "Dat":
                  case "Begin":
                  case "End":
                  case "StartBlock":
                  case "EndBlock":
                  case "Frame":
                  case "Area":
                  case "Axis":
                  case "AxisLine":
                  case "Tick":
                    break;
                  case "AxesUsed":
                  case "CrtLayout12":
                  case "CrtLayout12A":
                  case "CrtLink":
                  case "CrtLine":
                  case "CrtMlFrt":
                  case "CrtMlFrtContinue":
                    break;
                  case "LineFormat":
                  case "AreaFormat":
                  case "Chart":
                  case "Chart3d":
                  case "Chart3DBarShape":
                  case "ChartFormat":
                  case "ChartFrtInfo":
                    break;
                  case "PlotArea":
                  case "PlotGrowth":
                    break;
                  case "SeriesList":
                  case "SerParent":
                  case "SerAuxTrend":
                    break;
                  case "DataFormat":
                  case "SerToCrt":
                  case "FontX":
                    break;
                  case "CatSerRange":
                  case "AxcExt":
                  case "SerFmt":
                    break;
                  case "ShtProps":
                    break;
                  case "DefaultText":
                  case "Text":
                  case "CatLab":
                    break;
                  case "DataLabExtContents":
                    break;
                  case "Legend":
                  case "LegendException":
                    break;
                  case "Pie":
                  case "Scatter":
                    break;
                  case "PieFormat":
                  case "MarkerFormat":
                    break;
                  case "StartObject":
                  case "EndObject":
                    break;
                  case "AlRuns":
                  case "ObjectLink":
                    break;
                  case "SIIndex":
                    break;
                  case "AttachedLabel":
                  case "YMult":
                    break;
                  case "Line":
                  case "Bar":
                    break;
                  case "Surf":
                    break;
                  case "AxisParent":
                    break;
                  case "Pos":
                    break;
                  case "ValueRange":
                    break;
                  case "SXViewEx9":
                    break;
                  case "SXViewLink":
                    break;
                  case "PivotChartBits":
                    break;
                  case "SBaseRef":
                    break;
                  case "TextPropsStream":
                    break;
                  case "LnExt":
                    break;
                  case "MkrExt":
                    break;
                  case "CrtCoopt":
                    break;
                  case "Qsi":
                  case "Qsif":
                  case "Qsir":
                  case "QsiSXTag":
                    break;
                  case "TxtQry":
                    break;
                  case "FilterMode":
                    break;
                  case "AutoFilter":
                  case "AutoFilterInfo":
                    break;
                  case "AutoFilter12":
                    break;
                  case "DropDownObjIds":
                    break;
                  case "Sort":
                    break;
                  case "SortData":
                    break;
                  case "ShapePropsStream":
                    break;
                  case "MsoDrawing":
                  case "MsoDrawingGroup":
                  case "MsoDrawingSelection":
                    break;
                  case "WebPub":
                  case "AutoWebPub":
                    break;
                  case "HeaderFooter":
                  case "HFPicture":
                  case "PLV":
                  case "HorizontalPageBreaks":
                  case "VerticalPageBreaks":
                    break;
                  case "Backup":
                  case "CompressPictures":
                  case "Compat12":
                    break;
                  case "Continue":
                  case "ContinueFrt12":
                    break;
                  case "FrtFontList":
                  case "FrtWrapper":
                    break;
                  default:
                    switch (q.n) {
                      case "TabIdConf":
                      case "Radar":
                      case "RadarArea":
                      case "DropBar":
                      case "Intl":
                      case "CoordList":
                      case "SerAuxErrBar":
                        break;
                      case "BIFF2FONTCLR":
                      case "BIFF2FMTCNT":
                      case "BIFF2FONTXTRA":
                        break;
                      case "BIFF2XF":
                      case "BIFF3XF":
                      case "BIFF4XF":
                        break;
                      case "BIFF4FMTCNT":
                      case "BIFF2ROW":
                      case "BIFF2WINDOW2":
                        break;
                      case "SCENARIO":
                      case "DConBin":
                      case "PicF":
                      case "DataLabExt":
                      case "Lel":
                      case "BopPop":
                      case "BopPopCustom":
                      case "RealTimeData":
                      case "Name":
                        break;
                      case "LHNGraph":
                      case "FnGroupName":
                      case "AddMenu":
                      case "LPr":
                        break;
                      case "ListObj":
                      case "ListField":
                        break;
                      case "RRSort":
                        break;
                      case "BigName":
                        break;
                      default:
                        if (r.WTF) throw "Unrecognized Record " + q.n;
                    }
                }
            }
        }
      } else e.l += Q;
    }
    var me = Object.keys(s)
      .sort(function (e, r) {
        return Number(e) - Number(r);
      })
      .map(function (e) {
        return s[e].name;
      });
    var be = me.slice();
    t.Directory = me;
    t.SheetNames = me;
    if (!r.bookSheets) t.Sheets = a;
    if (t.Sheets)
      K.forEach(function (e, r) {
        t.Sheets[t.SheetNames[r]]["!autofilter"] = e;
      });
    t.Preamble = d;
    t.Strings = u;
    t.SSF = E.get_table();
    if (F.enc) t.Encryption = F.enc;
    t.Metadata = {};
    if (_ !== undefined) t.Metadata.Country = _;
    if (V.names.length > 0) A.Names = V.names;
    t.Workbook = A;
    return t;
  }
  function pE(e) {
    var r = e.find("!DocumentSummaryInformation");
    if (r)
      try {
        e.DocSummary = en(r, Xt);
      } catch (t) {}
    var a = e.find("!SummaryInformation");
    if (a)
      try {
        e.Summary = en(a, Gt);
      } catch (t) {}
  }
  function mE(e, r) {
    if (!r) r = {};
    KE(r);
    a();
    var t, n, i;
    if (e.FullPaths) {
      t = e.find("!CompObj");
      n = e.find("!SummaryInformation");
      i = e.find("/Workbook");
    } else {
      gr(e, 0);
      i = { content: e };
    }
    if (!i) i = e.find("/Book");
    var s, f, o;
    if (t) s = cE(t);
    if (r.bookProps && !r.bookSheets) o = {};
    else {
      if (i) o = vE(i.content, r);
      else if (e.find("PerfectOffice_MAIN"))
        o = Nu.to_workbook(e.find("PerfectOffice_MAIN").content, r);
      else if (e.find("NativeContent_MAIN"))
        o = Nu.to_workbook(e.find("NativeContent_MAIN").content, r);
      else throw new Error("Cannot find Workbook stream");
    }
    if (e.FullPaths) pE(e);
    var l = {};
    for (var c in e.Summary) l[c] = e.Summary[c];
    for (c in e.DocSummary) l[c] = e.DocSummary[c];
    o.Props = o.Custprops = l;
    if (r.bookFiles) o.cfb = e;
    return o;
  }
  var bE = {
    0: { n: "BrtRowHdr", f: Xm },
    1: { n: "BrtCellBlank", f: Jm },
    2: { n: "BrtCellRk", f: fb },
    3: { n: "BrtCellError", f: tb },
    4: { n: "BrtCellBool", f: eb },
    5: { n: "BrtCellReal", f: ib },
    6: { n: "BrtCellSt", f: lb },
    7: { n: "BrtCellIsst", f: ab },
    8: { n: "BrtFmlaString", f: vb },
    9: { n: "BrtFmlaNum", f: db },
    10: { n: "BrtFmlaBool", f: ub },
    11: { n: "BrtFmlaError", f: hb },
    16: { n: "BrtFRTArchID$", f: dg },
    19: { n: "BrtSSTItem", f: at },
    20: { n: "BrtPCDIMissing", f: Er },
    21: { n: "BrtPCDINumber", f: Er },
    22: { n: "BrtPCDIBoolean", f: Er },
    23: { n: "BrtPCDIError", f: Er },
    24: { n: "BrtPCDIString", f: Er },
    25: { n: "BrtPCDIDatetime", f: Er },
    26: { n: "BrtPCDIIndex", f: Er },
    27: { n: "BrtPCDIAMissing", f: Er },
    28: { n: "BrtPCDIANumber", f: Er },
    29: { n: "BrtPCDIABoolean", f: Er },
    30: { n: "BrtPCDIAError", f: Er },
    31: { n: "BrtPCDIAString", f: Er },
    32: { n: "BrtPCDIADatetime", f: Er },
    33: { n: "BrtPCRRecord", f: Er },
    34: { n: "BrtPCRRecordDt", f: Er },
    35: { n: "BrtFRTBegin", f: Er },
    36: { n: "BrtFRTEnd", f: Er },
    37: { n: "BrtACBegin", f: Er },
    38: { n: "BrtACEnd", f: Er },
    39: { n: "BrtName", f: vg },
    40: { n: "BrtIndexRowBlock", f: Er },
    42: { n: "BrtIndexBlock", f: Er },
    43: { n: "BrtFont", f: sd },
    44: { n: "BrtFmt", f: nd },
    45: { n: "BrtFill", f: Er },
    46: { n: "BrtBorder", f: Er },
    47: { n: "BrtXF", f: ud },
    48: { n: "BrtStyle", f: Er },
    49: { n: "BrtCellMeta", f: Er },
    50: { n: "BrtValueMeta", f: Er },
    51: { n: "BrtMdb", f: Er },
    52: { n: "BrtBeginFmd", f: Er },
    53: { n: "BrtEndFmd", f: Er },
    54: { n: "BrtBeginMdx", f: Er },
    55: { n: "BrtEndMdx", f: Er },
    56: { n: "BrtBeginMdxTuple", f: Er },
    57: { n: "BrtEndMdxTuple", f: Er },
    58: { n: "BrtMdxMbrIstr", f: Er },
    59: { n: "BrtStr", f: Er },
    60: { n: "BrtColInfo", f: Mi },
    62: { n: "BrtCellRString", f: Er },
    63: { n: "BrtCalcChainItem$", f: $d },
    64: { n: "BrtDVal", f: Er },
    65: { n: "BrtSxvcellNum", f: Er },
    66: { n: "BrtSxvcellStr", f: Er },
    67: { n: "BrtSxvcellBool", f: Er },
    68: { n: "BrtSxvcellErr", f: Er },
    69: { n: "BrtSxvcellDate", f: Er },
    70: { n: "BrtSxvcellNil", f: Er },
    128: { n: "BrtFileVersion", f: Er },
    129: { n: "BrtBeginSheet", f: Er },
    130: { n: "BrtEndSheet", f: Er },
    131: { n: "BrtBeginBook", f: Er, p: 0 },
    132: { n: "BrtEndBook", f: Er },
    133: { n: "BrtBeginWsViews", f: Er },
    134: { n: "BrtEndWsViews", f: Er },
    135: { n: "BrtBeginBookViews", f: Er },
    136: { n: "BrtEndBookViews", f: Er },
    137: { n: "BrtBeginWsView", f: Er },
    138: { n: "BrtEndWsView", f: Er },
    139: { n: "BrtBeginCsViews", f: Er },
    140: { n: "BrtEndCsViews", f: Er },
    141: { n: "BrtBeginCsView", f: Er },
    142: { n: "BrtEndCsView", f: Er },
    143: { n: "BrtBeginBundleShs", f: Er },
    144: { n: "BrtEndBundleShs", f: Er },
    145: { n: "BrtBeginSheetData", f: Er },
    146: { n: "BrtEndSheetData", f: Er },
    147: { n: "BrtWsProp", f: Zm },
    148: { n: "BrtWsDim", f: Km, p: 16 },
    151: { n: "BrtPane", f: Er },
    152: { n: "BrtSel", f: Er },
    153: { n: "BrtWbProp", f: ug },
    154: { n: "BrtWbFactoid", f: Er },
    155: { n: "BrtFileRecover", f: Er },
    156: { n: "BrtBundleSh", f: lg },
    157: { n: "BrtCalcProp", f: Er },
    158: { n: "BrtBookView", f: Er },
    159: { n: "BrtBeginSst", f: $u },
    160: { n: "BrtEndSst", f: Er },
    161: { n: "BrtBeginAFilter", f: St },
    162: { n: "BrtEndAFilter", f: Er },
    163: { n: "BrtBeginFilterColumn", f: Er },
    164: { n: "BrtEndFilterColumn", f: Er },
    165: { n: "BrtBeginFilters", f: Er },
    166: { n: "BrtEndFilters", f: Er },
    167: { n: "BrtFilter", f: Er },
    168: { n: "BrtColorFilter", f: Er },
    169: { n: "BrtIconFilter", f: Er },
    170: { n: "BrtTop10Filter", f: Er },
    171: { n: "BrtDynamicFilter", f: Er },
    172: { n: "BrtBeginCustomFilters", f: Er },
    173: { n: "BrtEndCustomFilters", f: Er },
    174: { n: "BrtCustomFilter", f: Er },
    175: { n: "BrtAFilterDateGroupItem", f: Er },
    176: { n: "BrtMergeCell", f: pb },
    177: { n: "BrtBeginMergeCells", f: Er },
    178: { n: "BrtEndMergeCells", f: Er },
    179: { n: "BrtBeginPivotCacheDef", f: Er },
    180: { n: "BrtEndPivotCacheDef", f: Er },
    181: { n: "BrtBeginPCDFields", f: Er },
    182: { n: "BrtEndPCDFields", f: Er },
    183: { n: "BrtBeginPCDField", f: Er },
    184: { n: "BrtEndPCDField", f: Er },
    185: { n: "BrtBeginPCDSource", f: Er },
    186: { n: "BrtEndPCDSource", f: Er },
    187: { n: "BrtBeginPCDSRange", f: Er },
    188: { n: "BrtEndPCDSRange", f: Er },
    189: { n: "BrtBeginPCDFAtbl", f: Er },
    190: { n: "BrtEndPCDFAtbl", f: Er },
    191: { n: "BrtBeginPCDIRun", f: Er },
    192: { n: "BrtEndPCDIRun", f: Er },
    193: { n: "BrtBeginPivotCacheRecords", f: Er },
    194: { n: "BrtEndPivotCacheRecords", f: Er },
    195: { n: "BrtBeginPCDHierarchies", f: Er },
    196: { n: "BrtEndPCDHierarchies", f: Er },
    197: { n: "BrtBeginPCDHierarchy", f: Er },
    198: { n: "BrtEndPCDHierarchy", f: Er },
    199: { n: "BrtBeginPCDHFieldsUsage", f: Er },
    200: { n: "BrtEndPCDHFieldsUsage", f: Er },
    201: { n: "BrtBeginExtConnection", f: Er },
    202: { n: "BrtEndExtConnection", f: Er },
    203: { n: "BrtBeginECDbProps", f: Er },
    204: { n: "BrtEndECDbProps", f: Er },
    205: { n: "BrtBeginECOlapProps", f: Er },
    206: { n: "BrtEndECOlapProps", f: Er },
    207: { n: "BrtBeginPCDSConsol", f: Er },
    208: { n: "BrtEndPCDSConsol", f: Er },
    209: { n: "BrtBeginPCDSCPages", f: Er },
    210: { n: "BrtEndPCDSCPages", f: Er },
    211: { n: "BrtBeginPCDSCPage", f: Er },
    212: { n: "BrtEndPCDSCPage", f: Er },
    213: { n: "BrtBeginPCDSCPItem", f: Er },
    214: { n: "BrtEndPCDSCPItem", f: Er },
    215: { n: "BrtBeginPCDSCSets", f: Er },
    216: { n: "BrtEndPCDSCSets", f: Er },
    217: { n: "BrtBeginPCDSCSet", f: Er },
    218: { n: "BrtEndPCDSCSet", f: Er },
    219: { n: "BrtBeginPCDFGroup", f: Er },
    220: { n: "BrtEndPCDFGroup", f: Er },
    221: { n: "BrtBeginPCDFGItems", f: Er },
    222: { n: "BrtEndPCDFGItems", f: Er },
    223: { n: "BrtBeginPCDFGRange", f: Er },
    224: { n: "BrtEndPCDFGRange", f: Er },
    225: { n: "BrtBeginPCDFGDiscrete", f: Er },
    226: { n: "BrtEndPCDFGDiscrete", f: Er },
    227: { n: "BrtBeginPCDSDTupleCache", f: Er },
    228: { n: "BrtEndPCDSDTupleCache", f: Er },
    229: { n: "BrtBeginPCDSDTCEntries", f: Er },
    230: { n: "BrtEndPCDSDTCEntries", f: Er },
    231: { n: "BrtBeginPCDSDTCEMembers", f: Er },
    232: { n: "BrtEndPCDSDTCEMembers", f: Er },
    233: { n: "BrtBeginPCDSDTCEMember", f: Er },
    234: { n: "BrtEndPCDSDTCEMember", f: Er },
    235: { n: "BrtBeginPCDSDTCQueries", f: Er },
    236: { n: "BrtEndPCDSDTCQueries", f: Er },
    237: { n: "BrtBeginPCDSDTCQuery", f: Er },
    238: { n: "BrtEndPCDSDTCQuery", f: Er },
    239: { n: "BrtBeginPCDSDTCSets", f: Er },
    240: { n: "BrtEndPCDSDTCSets", f: Er },
    241: { n: "BrtBeginPCDSDTCSet", f: Er },
    242: { n: "BrtEndPCDSDTCSet", f: Er },
    243: { n: "BrtBeginPCDCalcItems", f: Er },
    244: { n: "BrtEndPCDCalcItems", f: Er },
    245: { n: "BrtBeginPCDCalcItem", f: Er },
    246: { n: "BrtEndPCDCalcItem", f: Er },
    247: { n: "BrtBeginPRule", f: Er },
    248: { n: "BrtEndPRule", f: Er },
    249: { n: "BrtBeginPRFilters", f: Er },
    250: { n: "BrtEndPRFilters", f: Er },
    251: { n: "BrtBeginPRFilter", f: Er },
    252: { n: "BrtEndPRFilter", f: Er },
    253: { n: "BrtBeginPNames", f: Er },
    254: { n: "BrtEndPNames", f: Er },
    255: { n: "BrtBeginPName", f: Er },
    256: { n: "BrtEndPName", f: Er },
    257: { n: "BrtBeginPNPairs", f: Er },
    258: { n: "BrtEndPNPairs", f: Er },
    259: { n: "BrtBeginPNPair", f: Er },
    260: { n: "BrtEndPNPair", f: Er },
    261: { n: "BrtBeginECWebProps", f: Er },
    262: { n: "BrtEndECWebProps", f: Er },
    263: { n: "BrtBeginEcWpTables", f: Er },
    264: { n: "BrtEndECWPTables", f: Er },
    265: { n: "BrtBeginECParams", f: Er },
    266: { n: "BrtEndECParams", f: Er },
    267: { n: "BrtBeginECParam", f: Er },
    268: { n: "BrtEndECParam", f: Er },
    269: { n: "BrtBeginPCDKPIs", f: Er },
    270: { n: "BrtEndPCDKPIs", f: Er },
    271: { n: "BrtBeginPCDKPI", f: Er },
    272: { n: "BrtEndPCDKPI", f: Er },
    273: { n: "BrtBeginDims", f: Er },
    274: { n: "BrtEndDims", f: Er },
    275: { n: "BrtBeginDim", f: Er },
    276: { n: "BrtEndDim", f: Er },
    277: { n: "BrtIndexPartEnd", f: Er },
    278: { n: "BrtBeginStyleSheet", f: Er },
    279: { n: "BrtEndStyleSheet", f: Er },
    280: { n: "BrtBeginSXView", f: Er },
    281: { n: "BrtEndSXVI", f: Er },
    282: { n: "BrtBeginSXVI", f: Er },
    283: { n: "BrtBeginSXVIs", f: Er },
    284: { n: "BrtEndSXVIs", f: Er },
    285: { n: "BrtBeginSXVD", f: Er },
    286: { n: "BrtEndSXVD", f: Er },
    287: { n: "BrtBeginSXVDs", f: Er },
    288: { n: "BrtEndSXVDs", f: Er },
    289: { n: "BrtBeginSXPI", f: Er },
    290: { n: "BrtEndSXPI", f: Er },
    291: { n: "BrtBeginSXPIs", f: Er },
    292: { n: "BrtEndSXPIs", f: Er },
    293: { n: "BrtBeginSXDI", f: Er },
    294: { n: "BrtEndSXDI", f: Er },
    295: { n: "BrtBeginSXDIs", f: Er },
    296: { n: "BrtEndSXDIs", f: Er },
    297: { n: "BrtBeginSXLI", f: Er },
    298: { n: "BrtEndSXLI", f: Er },
    299: { n: "BrtBeginSXLIRws", f: Er },
    300: { n: "BrtEndSXLIRws", f: Er },
    301: { n: "BrtBeginSXLICols", f: Er },
    302: { n: "BrtEndSXLICols", f: Er },
    303: { n: "BrtBeginSXFormat", f: Er },
    304: { n: "BrtEndSXFormat", f: Er },
    305: { n: "BrtBeginSXFormats", f: Er },
    306: { n: "BrtEndSxFormats", f: Er },
    307: { n: "BrtBeginSxSelect", f: Er },
    308: { n: "BrtEndSxSelect", f: Er },
    309: { n: "BrtBeginISXVDRws", f: Er },
    310: { n: "BrtEndISXVDRws", f: Er },
    311: { n: "BrtBeginISXVDCols", f: Er },
    312: { n: "BrtEndISXVDCols", f: Er },
    313: { n: "BrtEndSXLocation", f: Er },
    314: { n: "BrtBeginSXLocation", f: Er },
    315: { n: "BrtEndSXView", f: Er },
    316: { n: "BrtBeginSXTHs", f: Er },
    317: { n: "BrtEndSXTHs", f: Er },
    318: { n: "BrtBeginSXTH", f: Er },
    319: { n: "BrtEndSXTH", f: Er },
    320: { n: "BrtBeginISXTHRws", f: Er },
    321: { n: "BrtEndISXTHRws", f: Er },
    322: { n: "BrtBeginISXTHCols", f: Er },
    323: { n: "BrtEndISXTHCols", f: Er },
    324: { n: "BrtBeginSXTDMPS", f: Er },
    325: { n: "BrtEndSXTDMPs", f: Er },
    326: { n: "BrtBeginSXTDMP", f: Er },
    327: { n: "BrtEndSXTDMP", f: Er },
    328: { n: "BrtBeginSXTHItems", f: Er },
    329: { n: "BrtEndSXTHItems", f: Er },
    330: { n: "BrtBeginSXTHItem", f: Er },
    331: { n: "BrtEndSXTHItem", f: Er },
    332: { n: "BrtBeginMetadata", f: Er },
    333: { n: "BrtEndMetadata", f: Er },
    334: { n: "BrtBeginEsmdtinfo", f: Er },
    335: { n: "BrtMdtinfo", f: Er },
    336: { n: "BrtEndEsmdtinfo", f: Er },
    337: { n: "BrtBeginEsmdb", f: Er },
    338: { n: "BrtEndEsmdb", f: Er },
    339: { n: "BrtBeginEsfmd", f: Er },
    340: { n: "BrtEndEsfmd", f: Er },
    341: { n: "BrtBeginSingleCells", f: Er },
    342: { n: "BrtEndSingleCells", f: Er },
    343: { n: "BrtBeginList", f: Er },
    344: { n: "BrtEndList", f: Er },
    345: { n: "BrtBeginListCols", f: Er },
    346: { n: "BrtEndListCols", f: Er },
    347: { n: "BrtBeginListCol", f: Er },
    348: { n: "BrtEndListCol", f: Er },
    349: { n: "BrtBeginListXmlCPr", f: Er },
    350: { n: "BrtEndListXmlCPr", f: Er },
    351: { n: "BrtListCCFmla", f: Er },
    352: { n: "BrtListTrFmla", f: Er },
    353: { n: "BrtBeginExternals", f: Er },
    354: { n: "BrtEndExternals", f: Er },
    355: { n: "BrtSupBookSrc", f: pt },
    357: { n: "BrtSupSelf", f: Er },
    358: { n: "BrtSupSame", f: Er },
    359: { n: "BrtSupTabs", f: Er },
    360: { n: "BrtBeginSupBook", f: Er },
    361: { n: "BrtPlaceholderName", f: Er },
    362: { n: "BrtExternSheet", f: gi },
    363: { n: "BrtExternTableStart", f: Er },
    364: { n: "BrtExternTableEnd", f: Er },
    366: { n: "BrtExternRowHdr", f: Er },
    367: { n: "BrtExternCellBlank", f: Er },
    368: { n: "BrtExternCellReal", f: Er },
    369: { n: "BrtExternCellBool", f: Er },
    370: { n: "BrtExternCellError", f: Er },
    371: { n: "BrtExternCellString", f: Er },
    372: { n: "BrtBeginEsmdx", f: Er },
    373: { n: "BrtEndEsmdx", f: Er },
    374: { n: "BrtBeginMdxSet", f: Er },
    375: { n: "BrtEndMdxSet", f: Er },
    376: { n: "BrtBeginMdxMbrProp", f: Er },
    377: { n: "BrtEndMdxMbrProp", f: Er },
    378: { n: "BrtBeginMdxKPI", f: Er },
    379: { n: "BrtEndMdxKPI", f: Er },
    380: { n: "BrtBeginEsstr", f: Er },
    381: { n: "BrtEndEsstr", f: Er },
    382: { n: "BrtBeginPRFItem", f: Er },
    383: { n: "BrtEndPRFItem", f: Er },
    384: { n: "BrtBeginPivotCacheIDs", f: Er },
    385: { n: "BrtEndPivotCacheIDs", f: Er },
    386: { n: "BrtBeginPivotCacheID", f: Er },
    387: { n: "BrtEndPivotCacheID", f: Er },
    388: { n: "BrtBeginISXVIs", f: Er },
    389: { n: "BrtEndISXVIs", f: Er },
    390: { n: "BrtBeginColInfos", f: Er },
    391: { n: "BrtEndColInfos", f: Er },
    392: { n: "BrtBeginRwBrk", f: Er },
    393: { n: "BrtEndRwBrk", f: Er },
    394: { n: "BrtBeginColBrk", f: Er },
    395: { n: "BrtEndColBrk", f: Er },
    396: { n: "BrtBrk", f: Er },
    397: { n: "BrtUserBookView", f: Er },
    398: { n: "BrtInfo", f: Er },
    399: { n: "BrtCUsr", f: Er },
    400: { n: "BrtUsr", f: Er },
    401: { n: "BrtBeginUsers", f: Er },
    403: { n: "BrtEOF", f: Er },
    404: { n: "BrtUCR", f: Er },
    405: { n: "BrtRRInsDel", f: Er },
    406: { n: "BrtRREndInsDel", f: Er },
    407: { n: "BrtRRMove", f: Er },
    408: { n: "BrtRREndMove", f: Er },
    409: { n: "BrtRRChgCell", f: Er },
    410: { n: "BrtRREndChgCell", f: Er },
    411: { n: "BrtRRHeader", f: Er },
    412: { n: "BrtRRUserView", f: Er },
    413: { n: "BrtRRRenSheet", f: Er },
    414: { n: "BrtRRInsertSh", f: Er },
    415: { n: "BrtRRDefName", f: Er },
    416: { n: "BrtRRNote", f: Er },
    417: { n: "BrtRRConflict", f: Er },
    418: { n: "BrtRRTQSIF", f: Er },
    419: { n: "BrtRRFormat", f: Er },
    420: { n: "BrtRREndFormat", f: Er },
    421: { n: "BrtRRAutoFmt", f: Er },
    422: { n: "BrtBeginUserShViews", f: Er },
    423: { n: "BrtBeginUserShView", f: Er },
    424: { n: "BrtEndUserShView", f: Er },
    425: { n: "BrtEndUserShViews", f: Er },
    426: { n: "BrtArrFmla", f: kb },
    427: { n: "BrtShrFmla", f: Sb },
    428: { n: "BrtTable", f: Er },
    429: { n: "BrtBeginExtConnections", f: Er },
    430: { n: "BrtEndExtConnections", f: Er },
    431: { n: "BrtBeginPCDCalcMems", f: Er },
    432: { n: "BrtEndPCDCalcMems", f: Er },
    433: { n: "BrtBeginPCDCalcMem", f: Er },
    434: { n: "BrtEndPCDCalcMem", f: Er },
    435: { n: "BrtBeginPCDHGLevels", f: Er },
    436: { n: "BrtEndPCDHGLevels", f: Er },
    437: { n: "BrtBeginPCDHGLevel", f: Er },
    438: { n: "BrtEndPCDHGLevel", f: Er },
    439: { n: "BrtBeginPCDHGLGroups", f: Er },
    440: { n: "BrtEndPCDHGLGroups", f: Er },
    441: { n: "BrtBeginPCDHGLGroup", f: Er },
    442: { n: "BrtEndPCDHGLGroup", f: Er },
    443: { n: "BrtBeginPCDHGLGMembers", f: Er },
    444: { n: "BrtEndPCDHGLGMembers", f: Er },
    445: { n: "BrtBeginPCDHGLGMember", f: Er },
    446: { n: "BrtEndPCDHGLGMember", f: Er },
    447: { n: "BrtBeginQSI", f: Er },
    448: { n: "BrtEndQSI", f: Er },
    449: { n: "BrtBeginQSIR", f: Er },
    450: { n: "BrtEndQSIR", f: Er },
    451: { n: "BrtBeginDeletedNames", f: Er },
    452: { n: "BrtEndDeletedNames", f: Er },
    453: { n: "BrtBeginDeletedName", f: Er },
    454: { n: "BrtEndDeletedName", f: Er },
    455: { n: "BrtBeginQSIFs", f: Er },
    456: { n: "BrtEndQSIFs", f: Er },
    457: { n: "BrtBeginQSIF", f: Er },
    458: { n: "BrtEndQSIF", f: Er },
    459: { n: "BrtBeginAutoSortScope", f: Er },
    460: { n: "BrtEndAutoSortScope", f: Er },
    461: { n: "BrtBeginConditionalFormatting", f: Er },
    462: { n: "BrtEndConditionalFormatting", f: Er },
    463: { n: "BrtBeginCFRule", f: Er },
    464: { n: "BrtEndCFRule", f: Er },
    465: { n: "BrtBeginIconSet", f: Er },
    466: { n: "BrtEndIconSet", f: Er },
    467: { n: "BrtBeginDatabar", f: Er },
    468: { n: "BrtEndDatabar", f: Er },
    469: { n: "BrtBeginColorScale", f: Er },
    470: { n: "BrtEndColorScale", f: Er },
    471: { n: "BrtCFVO", f: Er },
    472: { n: "BrtExternValueMeta", f: Er },
    473: { n: "BrtBeginColorPalette", f: Er },
    474: { n: "BrtEndColorPalette", f: Er },
    475: { n: "BrtIndexedColor", f: Er },
    476: { n: "BrtMargins", f: Bb },
    477: { n: "BrtPrintOptions", f: Er },
    478: { n: "BrtPageSetup", f: Er },
    479: { n: "BrtBeginHeaderFooter", f: Er },
    480: { n: "BrtEndHeaderFooter", f: Er },
    481: { n: "BrtBeginSXCrtFormat", f: Er },
    482: { n: "BrtEndSXCrtFormat", f: Er },
    483: { n: "BrtBeginSXCrtFormats", f: Er },
    484: { n: "BrtEndSXCrtFormats", f: Er },
    485: { n: "BrtWsFmtInfo", f: $m },
    486: { n: "BrtBeginMgs", f: Er },
    487: { n: "BrtEndMGs", f: Er },
    488: { n: "BrtBeginMGMaps", f: Er },
    489: { n: "BrtEndMGMaps", f: Er },
    490: { n: "BrtBeginMG", f: Er },
    491: { n: "BrtEndMG", f: Er },
    492: { n: "BrtBeginMap", f: Er },
    493: { n: "BrtEndMap", f: Er },
    494: { n: "BrtHLink", f: gb },
    495: { n: "BrtBeginDCon", f: Er },
    496: { n: "BrtEndDCon", f: Er },
    497: { n: "BrtBeginDRefs", f: Er },
    498: { n: "BrtEndDRefs", f: Er },
    499: { n: "BrtDRef", f: Er },
    500: { n: "BrtBeginScenMan", f: Er },
    501: { n: "BrtEndScenMan", f: Er },
    502: { n: "BrtBeginSct", f: Er },
    503: { n: "BrtEndSct", f: Er },
    504: { n: "BrtSlc", f: Er },
    505: { n: "BrtBeginDXFs", f: Er },
    506: { n: "BrtEndDXFs", f: Er },
    507: { n: "BrtDXF", f: Er },
    508: { n: "BrtBeginTableStyles", f: Er },
    509: { n: "BrtEndTableStyles", f: Er },
    510: { n: "BrtBeginTableStyle", f: Er },
    511: { n: "BrtEndTableStyle", f: Er },
    512: { n: "BrtTableStyleElement", f: Er },
    513: { n: "BrtTableStyleClient", f: Er },
    514: { n: "BrtBeginVolDeps", f: Er },
    515: { n: "BrtEndVolDeps", f: Er },
    516: { n: "BrtBeginVolType", f: Er },
    517: { n: "BrtEndVolType", f: Er },
    518: { n: "BrtBeginVolMain", f: Er },
    519: { n: "BrtEndVolMain", f: Er },
    520: { n: "BrtBeginVolTopic", f: Er },
    521: { n: "BrtEndVolTopic", f: Er },
    522: { n: "BrtVolSubtopic", f: Er },
    523: { n: "BrtVolRef", f: Er },
    524: { n: "BrtVolNum", f: Er },
    525: { n: "BrtVolErr", f: Er },
    526: { n: "BrtVolStr", f: Er },
    527: { n: "BrtVolBool", f: Er },
    528: { n: "BrtBeginCalcChain$", f: Er },
    529: { n: "BrtEndCalcChain$", f: Er },
    530: { n: "BrtBeginSortState", f: Er },
    531: { n: "BrtEndSortState", f: Er },
    532: { n: "BrtBeginSortCond", f: Er },
    533: { n: "BrtEndSortCond", f: Er },
    534: { n: "BrtBookProtection", f: Er },
    535: { n: "BrtSheetProtection", f: Er },
    536: { n: "BrtRangeProtection", f: Er },
    537: { n: "BrtPhoneticInfo", f: Er },
    538: { n: "BrtBeginECTxtWiz", f: Er },
    539: { n: "BrtEndECTxtWiz", f: Er },
    540: { n: "BrtBeginECTWFldInfoLst", f: Er },
    541: { n: "BrtEndECTWFldInfoLst", f: Er },
    542: { n: "BrtBeginECTwFldInfo", f: Er },
    548: { n: "BrtFileSharing", f: Er },
    549: { n: "BrtOleSize", f: Er },
    550: { n: "BrtDrawing", f: pt },
    551: { n: "BrtLegacyDrawing", f: Er },
    552: { n: "BrtLegacyDrawingHF", f: Er },
    553: { n: "BrtWebOpt", f: Er },
    554: { n: "BrtBeginWebPubItems", f: Er },
    555: { n: "BrtEndWebPubItems", f: Er },
    556: { n: "BrtBeginWebPubItem", f: Er },
    557: { n: "BrtEndWebPubItem", f: Er },
    558: { n: "BrtBeginSXCondFmt", f: Er },
    559: { n: "BrtEndSXCondFmt", f: Er },
    560: { n: "BrtBeginSXCondFmts", f: Er },
    561: { n: "BrtEndSXCondFmts", f: Er },
    562: { n: "BrtBkHim", f: Er },
    564: { n: "BrtColor", f: Er },
    565: { n: "BrtBeginIndexedColors", f: Er },
    566: { n: "BrtEndIndexedColors", f: Er },
    569: { n: "BrtBeginMRUColors", f: Er },
    570: { n: "BrtEndMRUColors", f: Er },
    572: { n: "BrtMRUColor", f: Er },
    573: { n: "BrtBeginDVals", f: Er },
    574: { n: "BrtEndDVals", f: Er },
    577: { n: "BrtSupNameStart", f: Er },
    578: { n: "BrtSupNameValueStart", f: Er },
    579: { n: "BrtSupNameValueEnd", f: Er },
    580: { n: "BrtSupNameNum", f: Er },
    581: { n: "BrtSupNameErr", f: Er },
    582: { n: "BrtSupNameSt", f: Er },
    583: { n: "BrtSupNameNil", f: Er },
    584: { n: "BrtSupNameBool", f: Er },
    585: { n: "BrtSupNameFmla", f: Er },
    586: { n: "BrtSupNameBits", f: Er },
    587: { n: "BrtSupNameEnd", f: Er },
    588: { n: "BrtEndSupBook", f: Er },
    589: { n: "BrtCellSmartTagProperty", f: Er },
    590: { n: "BrtBeginCellSmartTag", f: Er },
    591: { n: "BrtEndCellSmartTag", f: Er },
    592: { n: "BrtBeginCellSmartTags", f: Er },
    593: { n: "BrtEndCellSmartTags", f: Er },
    594: { n: "BrtBeginSmartTags", f: Er },
    595: { n: "BrtEndSmartTags", f: Er },
    596: { n: "BrtSmartTagType", f: Er },
    597: { n: "BrtBeginSmartTagTypes", f: Er },
    598: { n: "BrtEndSmartTagTypes", f: Er },
    599: { n: "BrtBeginSXFilters", f: Er },
    600: { n: "BrtEndSXFilters", f: Er },
    601: { n: "BrtBeginSXFILTER", f: Er },
    602: { n: "BrtEndSXFilter", f: Er },
    603: { n: "BrtBeginFills", f: Er },
    604: { n: "BrtEndFills", f: Er },
    605: { n: "BrtBeginCellWatches", f: Er },
    606: { n: "BrtEndCellWatches", f: Er },
    607: { n: "BrtCellWatch", f: Er },
    608: { n: "BrtBeginCRErrs", f: Er },
    609: { n: "BrtEndCRErrs", f: Er },
    610: { n: "BrtCrashRecErr", f: Er },
    611: { n: "BrtBeginFonts", f: Er },
    612: { n: "BrtEndFonts", f: Er },
    613: { n: "BrtBeginBorders", f: Er },
    614: { n: "BrtEndBorders", f: Er },
    615: { n: "BrtBeginFmts", f: Er },
    616: { n: "BrtEndFmts", f: Er },
    617: { n: "BrtBeginCellXFs", f: Er },
    618: { n: "BrtEndCellXFs", f: Er },
    619: { n: "BrtBeginStyles", f: Er },
    620: { n: "BrtEndStyles", f: Er },
    625: { n: "BrtBigName", f: Er },
    626: { n: "BrtBeginCellStyleXFs", f: Er },
    627: { n: "BrtEndCellStyleXFs", f: Er },
    628: { n: "BrtBeginComments", f: Er },
    629: { n: "BrtEndComments", f: Er },
    630: { n: "BrtBeginCommentAuthors", f: Er },
    631: { n: "BrtEndCommentAuthors", f: Er },
    632: { n: "BrtCommentAuthor", f: ov },
    633: { n: "BrtBeginCommentList", f: Er },
    634: { n: "BrtEndCommentList", f: Er },
    635: { n: "BrtBeginComment", f: sv },
    636: { n: "BrtEndComment", f: Er },
    637: { n: "BrtCommentText", f: it },
    638: { n: "BrtBeginOleObjects", f: Er },
    639: { n: "BrtOleObject", f: Er },
    640: { n: "BrtEndOleObjects", f: Er },
    641: { n: "BrtBeginSxrules", f: Er },
    642: { n: "BrtEndSxRules", f: Er },
    643: { n: "BrtBeginActiveXControls", f: Er },
    644: { n: "BrtActiveX", f: Er },
    645: { n: "BrtEndActiveXControls", f: Er },
    646: { n: "BrtBeginPCDSDTCEMembersSortBy", f: Er },
    648: { n: "BrtBeginCellIgnoreECs", f: Er },
    649: { n: "BrtCellIgnoreEC", f: Er },
    650: { n: "BrtEndCellIgnoreECs", f: Er },
    651: { n: "BrtCsProp", f: Er },
    652: { n: "BrtCsPageSetup", f: Er },
    653: { n: "BrtBeginUserCsViews", f: Er },
    654: { n: "BrtEndUserCsViews", f: Er },
    655: { n: "BrtBeginUserCsView", f: Er },
    656: { n: "BrtEndUserCsView", f: Er },
    657: { n: "BrtBeginPcdSFCIEntries", f: Er },
    658: { n: "BrtEndPCDSFCIEntries", f: Er },
    659: { n: "BrtPCDSFCIEntry", f: Er },
    660: { n: "BrtBeginListParts", f: Er },
    661: { n: "BrtListPart", f: Er },
    662: { n: "BrtEndListParts", f: Er },
    663: { n: "BrtSheetCalcProp", f: Er },
    664: { n: "BrtBeginFnGroup", f: Er },
    665: { n: "BrtFnGroup", f: Er },
    666: { n: "BrtEndFnGroup", f: Er },
    667: { n: "BrtSupAddin", f: Er },
    668: { n: "BrtSXTDMPOrder", f: Er },
    669: { n: "BrtCsProtection", f: Er },
    671: { n: "BrtBeginWsSortMap", f: Er },
    672: { n: "BrtEndWsSortMap", f: Er },
    673: { n: "BrtBeginRRSort", f: Er },
    674: { n: "BrtEndRRSort", f: Er },
    675: { n: "BrtRRSortItem", f: Er },
    676: { n: "BrtFileSharingIso", f: Er },
    677: { n: "BrtBookProtectionIso", f: Er },
    678: { n: "BrtSheetProtectionIso", f: Er },
    679: { n: "BrtCsProtectionIso", f: Er },
    680: { n: "BrtRangeProtectionIso", f: Er },
    1024: { n: "BrtRwDescent", f: Er },
    1025: { n: "BrtKnownFonts", f: Er },
    1026: { n: "BrtBeginSXTupleSet", f: Er },
    1027: { n: "BrtEndSXTupleSet", f: Er },
    1028: { n: "BrtBeginSXTupleSetHeader", f: Er },
    1029: { n: "BrtEndSXTupleSetHeader", f: Er },
    1030: { n: "BrtSXTupleSetHeaderItem", f: Er },
    1031: { n: "BrtBeginSXTupleSetData", f: Er },
    1032: { n: "BrtEndSXTupleSetData", f: Er },
    1033: { n: "BrtBeginSXTupleSetRow", f: Er },
    1034: { n: "BrtEndSXTupleSetRow", f: Er },
    1035: { n: "BrtSXTupleSetRowItem", f: Er },
    1036: { n: "BrtNameExt", f: Er },
    1037: { n: "BrtPCDH14", f: Er },
    1038: { n: "BrtBeginPCDCalcMem14", f: Er },
    1039: { n: "BrtEndPCDCalcMem14", f: Er },
    1040: { n: "BrtSXTH14", f: Er },
    1041: { n: "BrtBeginSparklineGroup", f: Er },
    1042: { n: "BrtEndSparklineGroup", f: Er },
    1043: { n: "BrtSparkline", f: Er },
    1044: { n: "BrtSXDI14", f: Er },
    1045: { n: "BrtWsFmtInfoEx14", f: Er },
    1046: { n: "BrtBeginConditionalFormatting14", f: Er },
    1047: { n: "BrtEndConditionalFormatting14", f: Er },
    1048: { n: "BrtBeginCFRule14", f: Er },
    1049: { n: "BrtEndCFRule14", f: Er },
    1050: { n: "BrtCFVO14", f: Er },
    1051: { n: "BrtBeginDatabar14", f: Er },
    1052: { n: "BrtBeginIconSet14", f: Er },
    1053: { n: "BrtDVal14", f: Er },
    1054: { n: "BrtBeginDVals14", f: Er },
    1055: { n: "BrtColor14", f: Er },
    1056: { n: "BrtBeginSparklines", f: Er },
    1057: { n: "BrtEndSparklines", f: Er },
    1058: { n: "BrtBeginSparklineGroups", f: Er },
    1059: { n: "BrtEndSparklineGroups", f: Er },
    1061: { n: "BrtSXVD14", f: Er },
    1062: { n: "BrtBeginSxview14", f: Er },
    1063: { n: "BrtEndSxview14", f: Er },
    1066: { n: "BrtBeginPCD14", f: Er },
    1067: { n: "BrtEndPCD14", f: Er },
    1068: { n: "BrtBeginExtConn14", f: Er },
    1069: { n: "BrtEndExtConn14", f: Er },
    1070: { n: "BrtBeginSlicerCacheIDs", f: Er },
    1071: { n: "BrtEndSlicerCacheIDs", f: Er },
    1072: { n: "BrtBeginSlicerCacheID", f: Er },
    1073: { n: "BrtEndSlicerCacheID", f: Er },
    1075: { n: "BrtBeginSlicerCache", f: Er },
    1076: { n: "BrtEndSlicerCache", f: Er },
    1077: { n: "BrtBeginSlicerCacheDef", f: Er },
    1078: { n: "BrtEndSlicerCacheDef", f: Er },
    1079: { n: "BrtBeginSlicersEx", f: Er },
    1080: { n: "BrtEndSlicersEx", f: Er },
    1081: { n: "BrtBeginSlicerEx", f: Er },
    1082: { n: "BrtEndSlicerEx", f: Er },
    1083: { n: "BrtBeginSlicer", f: Er },
    1084: { n: "BrtEndSlicer", f: Er },
    1085: { n: "BrtSlicerCachePivotTables", f: Er },
    1086: { n: "BrtBeginSlicerCacheOlapImpl", f: Er },
    1087: { n: "BrtEndSlicerCacheOlapImpl", f: Er },
    1088: { n: "BrtBeginSlicerCacheLevelsData", f: Er },
    1089: { n: "BrtEndSlicerCacheLevelsData", f: Er },
    1090: { n: "BrtBeginSlicerCacheLevelData", f: Er },
    1091: { n: "BrtEndSlicerCacheLevelData", f: Er },
    1092: { n: "BrtBeginSlicerCacheSiRanges", f: Er },
    1093: { n: "BrtEndSlicerCacheSiRanges", f: Er },
    1094: { n: "BrtBeginSlicerCacheSiRange", f: Er },
    1095: { n: "BrtEndSlicerCacheSiRange", f: Er },
    1096: { n: "BrtSlicerCacheOlapItem", f: Er },
    1097: { n: "BrtBeginSlicerCacheSelections", f: Er },
    1098: { n: "BrtSlicerCacheSelection", f: Er },
    1099: { n: "BrtEndSlicerCacheSelections", f: Er },
    1100: { n: "BrtBeginSlicerCacheNative", f: Er },
    1101: { n: "BrtEndSlicerCacheNative", f: Er },
    1102: { n: "BrtSlicerCacheNativeItem", f: Er },
    1103: { n: "BrtRangeProtection14", f: Er },
    1104: { n: "BrtRangeProtectionIso14", f: Er },
    1105: { n: "BrtCellIgnoreEC14", f: Er },
    1111: { n: "BrtList14", f: Er },
    1112: { n: "BrtCFIcon", f: Er },
    1113: { n: "BrtBeginSlicerCachesPivotCacheIDs", f: Er },
    1114: { n: "BrtEndSlicerCachesPivotCacheIDs", f: Er },
    1115: { n: "BrtBeginSlicers", f: Er },
    1116: { n: "BrtEndSlicers", f: Er },
    1117: { n: "BrtWbProp14", f: Er },
    1118: { n: "BrtBeginSXEdit", f: Er },
    1119: { n: "BrtEndSXEdit", f: Er },
    1120: { n: "BrtBeginSXEdits", f: Er },
    1121: { n: "BrtEndSXEdits", f: Er },
    1122: { n: "BrtBeginSXChange", f: Er },
    1123: { n: "BrtEndSXChange", f: Er },
    1124: { n: "BrtBeginSXChanges", f: Er },
    1125: { n: "BrtEndSXChanges", f: Er },
    1126: { n: "BrtSXTupleItems", f: Er },
    1128: { n: "BrtBeginSlicerStyle", f: Er },
    1129: { n: "BrtEndSlicerStyle", f: Er },
    1130: { n: "BrtSlicerStyleElement", f: Er },
    1131: { n: "BrtBeginStyleSheetExt14", f: Er },
    1132: { n: "BrtEndStyleSheetExt14", f: Er },
    1133: { n: "BrtBeginSlicerCachesPivotCacheID", f: Er },
    1134: { n: "BrtEndSlicerCachesPivotCacheID", f: Er },
    1135: { n: "BrtBeginConditionalFormattings", f: Er },
    1136: { n: "BrtEndConditionalFormattings", f: Er },
    1137: { n: "BrtBeginPCDCalcMemExt", f: Er },
    1138: { n: "BrtEndPCDCalcMemExt", f: Er },
    1139: { n: "BrtBeginPCDCalcMemsExt", f: Er },
    1140: { n: "BrtEndPCDCalcMemsExt", f: Er },
    1141: { n: "BrtPCDField14", f: Er },
    1142: { n: "BrtBeginSlicerStyles", f: Er },
    1143: { n: "BrtEndSlicerStyles", f: Er },
    1144: { n: "BrtBeginSlicerStyleElements", f: Er },
    1145: { n: "BrtEndSlicerStyleElements", f: Er },
    1146: { n: "BrtCFRuleExt", f: Er },
    1147: { n: "BrtBeginSXCondFmt14", f: Er },
    1148: { n: "BrtEndSXCondFmt14", f: Er },
    1149: { n: "BrtBeginSXCondFmts14", f: Er },
    1150: { n: "BrtEndSXCondFmts14", f: Er },
    1152: { n: "BrtBeginSortCond14", f: Er },
    1153: { n: "BrtEndSortCond14", f: Er },
    1154: { n: "BrtEndDVals14", f: Er },
    1155: { n: "BrtEndIconSet14", f: Er },
    1156: { n: "BrtEndDatabar14", f: Er },
    1157: { n: "BrtBeginColorScale14", f: Er },
    1158: { n: "BrtEndColorScale14", f: Er },
    1159: { n: "BrtBeginSxrules14", f: Er },
    1160: { n: "BrtEndSxrules14", f: Er },
    1161: { n: "BrtBeginPRule14", f: Er },
    1162: { n: "BrtEndPRule14", f: Er },
    1163: { n: "BrtBeginPRFilters14", f: Er },
    1164: { n: "BrtEndPRFilters14", f: Er },
    1165: { n: "BrtBeginPRFilter14", f: Er },
    1166: { n: "BrtEndPRFilter14", f: Er },
    1167: { n: "BrtBeginPRFItem14", f: Er },
    1168: { n: "BrtEndPRFItem14", f: Er },
    1169: { n: "BrtBeginCellIgnoreECs14", f: Er },
    1170: { n: "BrtEndCellIgnoreECs14", f: Er },
    1171: { n: "BrtDxf14", f: Er },
    1172: { n: "BrtBeginDxF14s", f: Er },
    1173: { n: "BrtEndDxf14s", f: Er },
    1177: { n: "BrtFilter14", f: Er },
    1178: { n: "BrtBeginCustomFilters14", f: Er },
    1180: { n: "BrtCustomFilter14", f: Er },
    1181: { n: "BrtIconFilter14", f: Er },
    1182: { n: "BrtPivotCacheConnectionName", f: Er },
    2048: { n: "BrtBeginDecoupledPivotCacheIDs", f: Er },
    2049: { n: "BrtEndDecoupledPivotCacheIDs", f: Er },
    2050: { n: "BrtDecoupledPivotCacheID", f: Er },
    2051: { n: "BrtBeginPivotTableRefs", f: Er },
    2052: { n: "BrtEndPivotTableRefs", f: Er },
    2053: { n: "BrtPivotTableRef", f: Er },
    2054: { n: "BrtSlicerCacheBookPivotTables", f: Er },
    2055: { n: "BrtBeginSxvcells", f: Er },
    2056: { n: "BrtEndSxvcells", f: Er },
    2057: { n: "BrtBeginSxRow", f: Er },
    2058: { n: "BrtEndSxRow", f: Er },
    2060: { n: "BrtPcdCalcMem15", f: Er },
    2067: { n: "BrtQsi15", f: Er },
    2068: { n: "BrtBeginWebExtensions", f: Er },
    2069: { n: "BrtEndWebExtensions", f: Er },
    2070: { n: "BrtWebExtension", f: Er },
    2071: { n: "BrtAbsPath15", f: Er },
    2072: { n: "BrtBeginPivotTableUISettings", f: Er },
    2073: { n: "BrtEndPivotTableUISettings", f: Er },
    2075: { n: "BrtTableSlicerCacheIDs", f: Er },
    2076: { n: "BrtTableSlicerCacheID", f: Er },
    2077: { n: "BrtBeginTableSlicerCache", f: Er },
    2078: { n: "BrtEndTableSlicerCache", f: Er },
    2079: { n: "BrtSxFilter15", f: Er },
    2080: { n: "BrtBeginTimelineCachePivotCacheIDs", f: Er },
    2081: { n: "BrtEndTimelineCachePivotCacheIDs", f: Er },
    2082: { n: "BrtTimelineCachePivotCacheID", f: Er },
    2083: { n: "BrtBeginTimelineCacheIDs", f: Er },
    2084: { n: "BrtEndTimelineCacheIDs", f: Er },
    2085: { n: "BrtBeginTimelineCacheID", f: Er },
    2086: { n: "BrtEndTimelineCacheID", f: Er },
    2087: { n: "BrtBeginTimelinesEx", f: Er },
    2088: { n: "BrtEndTimelinesEx", f: Er },
    2089: { n: "BrtBeginTimelineEx", f: Er },
    2090: { n: "BrtEndTimelineEx", f: Er },
    2091: { n: "BrtWorkBookPr15", f: Er },
    2092: { n: "BrtPCDH15", f: Er },
    2093: { n: "BrtBeginTimelineStyle", f: Er },
    2094: { n: "BrtEndTimelineStyle", f: Er },
    2095: { n: "BrtTimelineStyleElement", f: Er },
    2096: { n: "BrtBeginTimelineStylesheetExt15", f: Er },
    2097: { n: "BrtEndTimelineStylesheetExt15", f: Er },
    2098: { n: "BrtBeginTimelineStyles", f: Er },
    2099: { n: "BrtEndTimelineStyles", f: Er },
    2100: { n: "BrtBeginTimelineStyleElements", f: Er },
    2101: { n: "BrtEndTimelineStyleElements", f: Er },
    2102: { n: "BrtDxf15", f: Er },
    2103: { n: "BrtBeginDxfs15", f: Er },
    2104: { n: "brtEndDxfs15", f: Er },
    2105: { n: "BrtSlicerCacheHideItemsWithNoData", f: Er },
    2106: { n: "BrtBeginItemUniqueNames", f: Er },
    2107: { n: "BrtEndItemUniqueNames", f: Er },
    2108: { n: "BrtItemUniqueName", f: Er },
    2109: { n: "BrtBeginExtConn15", f: Er },
    2110: { n: "BrtEndExtConn15", f: Er },
    2111: { n: "BrtBeginOledbPr15", f: Er },
    2112: { n: "BrtEndOledbPr15", f: Er },
    2113: { n: "BrtBeginDataFeedPr15", f: Er },
    2114: { n: "BrtEndDataFeedPr15", f: Er },
    2115: { n: "BrtTextPr15", f: Er },
    2116: { n: "BrtRangePr15", f: Er },
    2117: { n: "BrtDbCommand15", f: Er },
    2118: { n: "BrtBeginDbTables15", f: Er },
    2119: { n: "BrtEndDbTables15", f: Er },
    2120: { n: "BrtDbTable15", f: Er },
    2121: { n: "BrtBeginDataModel", f: Er },
    2122: { n: "BrtEndDataModel", f: Er },
    2123: { n: "BrtBeginModelTables", f: Er },
    2124: { n: "BrtEndModelTables", f: Er },
    2125: { n: "BrtModelTable", f: Er },
    2126: { n: "BrtBeginModelRelationships", f: Er },
    2127: { n: "BrtEndModelRelationships", f: Er },
    2128: { n: "BrtModelRelationship", f: Er },
    2129: { n: "BrtBeginECTxtWiz15", f: Er },
    2130: { n: "BrtEndECTxtWiz15", f: Er },
    2131: { n: "BrtBeginECTWFldInfoLst15", f: Er },
    2132: { n: "BrtEndECTWFldInfoLst15", f: Er },
    2133: { n: "BrtBeginECTWFldInfo15", f: Er },
    2134: { n: "BrtFieldListActiveItem", f: Er },
    2135: { n: "BrtPivotCacheIdVersion", f: Er },
    2136: { n: "BrtSXDI15", f: Er },
    65535: { n: "", f: Er },
  };
  var gE = A(bE, "n");
  var EE = {
    3: { n: "BIFF2NUM", f: Tu },
    4: { n: "BIFF2STR", f: _u },
    6: { n: "Formula", f: Vp },
    9: { n: "BOF", f: Un },
    10: { n: "EOF", f: fs },
    12: { n: "CalcCount", f: Yi },
    13: { n: "CalcMode", f: Qi },
    14: { n: "CalcPrecision", f: Ji },
    15: { n: "CalcRefMode", f: qi },
    16: { n: "CalcDelta", f: $i },
    17: { n: "CalcIter", f: Zi },
    18: { n: "Protect", f: Ts },
    19: { n: "Password", f: ks },
    20: { n: "Header", f: vs },
    21: { n: "Footer", f: us },
    23: { n: "ExternSheet", f: gi },
    24: { n: "Lbl", f: bi },
    25: { n: "WinProtect", f: Ls },
    26: { n: "VerticalPageBreaks", f: Us },
    27: { n: "HorizontalPageBreaks", f: Hs },
    28: { n: "Note", f: Ti },
    29: { n: "Selection", f: Ws },
    34: { n: "Date1904", f: as },
    35: { n: "ExternName", f: pi },
    38: { n: "LeftMargin", f: bs },
    39: { n: "RightMargin", f: Is },
    40: { n: "TopMargin", f: Fs },
    41: { n: "BottomMargin", f: ji },
    42: { n: "PrintRowCol", f: ws },
    43: { n: "PrintGrid", f: Ss },
    47: { n: "FilePass", f: wh },
    49: { n: "Font", f: Qn },
    51: { n: "PrintSize", f: Bs },
    60: { n: "Continue", f: Vs },
    61: { n: "Window1", f: Zn },
    64: { n: "Backup", f: Xi },
    65: { n: "Pane", f: zs },
    66: { n: "CodePage", f: rs },
    77: { n: "Pls", f: Xs },
    80: { n: "DCon", f: Gs },
    81: { n: "DConRef", f: js },
    82: { n: "DConName", f: Ks },
    85: { n: "DefColWidth", f: ns },
    89: { n: "XCT", f: Ys },
    90: { n: "CRN", f: $s },
    91: { n: "FileSharing", f: Zs },
    92: { n: "WriteAccess", f: Wn },
    93: { n: "Obj", f: Ii },
    94: { n: "Uncalced", f: Qs },
    95: { n: "CalcSaveRecalc", f: es },
    96: { n: "Template", f: Js },
    97: { n: "Intl", f: qs },
    99: { n: "ObjProtect", f: Es },
    125: { n: "ColInfo", f: Mi },
    128: { n: "Guts", f: ci },
    129: { n: "WsBool", f: ef },
    130: { n: "GridSet", f: hs },
    131: { n: "HCenter", f: ds },
    132: { n: "VCenter", f: Ns },
    133: { n: "BoundSheet8", f: Vn },
    134: { n: "WriteProtect", f: Ms },
    140: { n: "Country", f: Fi },
    141: { n: "HideObj", f: ps },
    144: { n: "Sort", f: rf },
    146: { n: "Palette", f: Ni },
    151: { n: "Sync", f: tf },
    152: { n: "LPr", f: af },
    153: { n: "DxGCol", f: nf },
    154: { n: "FnGroupName", f: sf },
    155: { n: "FilterMode", f: ff },
    156: { n: "BuiltInFnGroupCount", f: Ki },
    157: { n: "AutoFilterInfo", f: of },
    158: { n: "AutoFilter", f: lf },
    160: { n: "Scl", f: Rs },
    161: { n: "Setup", f: Ui },
    174: { n: "ScenMan", f: cf },
    175: { n: "SCENARIO", f: uf },
    176: { n: "SxView", f: hf },
    177: { n: "Sxvd", f: df },
    178: { n: "SXVI", f: vf },
    180: { n: "SxIvd", f: pf },
    181: { n: "SXLI", f: mf },
    182: { n: "SXPI", f: bf },
    184: { n: "DocRoute", f: gf },
    185: { n: "RecipName", f: Ef },
    189: { n: "MulRk", f: ni },
    190: { n: "MulBlank", f: ii },
    193: { n: "Mms", f: gs },
    197: { n: "SXDI", f: kf },
    198: { n: "SXDB", f: Sf },
    199: { n: "SXFDB", f: wf },
    200: { n: "SXDBB", f: Bf },
    201: { n: "SXNum", f: Cf },
    202: { n: "SxBool", f: Os },
    203: { n: "SxErr", f: _f },
    204: { n: "SXInt", f: Tf },
    205: { n: "SXString", f: xf },
    206: { n: "SXDtr", f: If },
    207: { n: "SxNil", f: Af },
    208: { n: "SXTbl", f: yf },
    209: { n: "SXTBRGIITM", f: Rf },
    210: { n: "SxTbpg", f: Df },
    211: { n: "ObProj", f: Of },
    213: { n: "SXStreamID", f: Ff },
    215: { n: "DBCell", f: Pf },
    216: { n: "SXRng", f: Nf },
    217: { n: "SxIsxoper", f: Lf },
    218: { n: "BookBool", f: Mf },
    220: { n: "DbOrParamQry", f: Uf },
    221: { n: "ScenarioProtect", f: ys },
    222: { n: "OleObjectSize", f: Hf },
    224: { n: "XF", f: li },
    225: { n: "InterfaceHdr", f: Hn },
    226: { n: "InterfaceEnd", f: ms },
    227: { n: "SXVS", f: Wf },
    229: { n: "MergeCells", f: xi },
    233: { n: "BkHim", f: Vf },
    235: { n: "MsoDrawingGroup", f: zf },
    236: { n: "MsoDrawing", f: Xf },
    237: { n: "MsoDrawingSelection", f: Gf },
    239: { n: "PhoneticInfo", f: jf },
    240: { n: "SxRule", f: Kf },
    241: { n: "SXEx", f: Yf },
    242: { n: "SxFilt", f: $f },
    244: { n: "SxDXF", f: Zf },
    245: { n: "SxItm", f: Qf },
    246: { n: "SxName", f: Jf },
    247: { n: "SxSelect", f: qf },
    248: { n: "SXPair", f: eo },
    249: { n: "SxFmla", f: ro },
    251: { n: "SxFormat", f: to },
    252: { n: "SST", f: zn },
    253: { n: "LabelSst", f: Jn },
    255: { n: "ExtSST", f: Xn },
    256: { n: "SXVDEx", f: ao },
    259: { n: "SXFormula", f: no },
    290: { n: "SXDBEx", f: io },
    311: { n: "RRDInsDel", f: so },
    312: { n: "RRDHead", f: fo },
    315: { n: "RRDChgCell", f: oo },
    317: { n: "RRTabId", f: As },
    318: { n: "RRDRenSheet", f: lo },
    319: { n: "RRSort", f: co },
    320: { n: "RRDMove", f: uo },
    330: { n: "RRFormat", f: ho },
    331: { n: "RRAutoFmt", f: vo },
    333: { n: "RRInsertSh", f: po },
    334: { n: "RRDMoveBegin", f: mo },
    335: { n: "RRDMoveEnd", f: bo },
    336: { n: "RRDInsDelBegin", f: go },
    337: { n: "RRDInsDelEnd", f: Eo },
    338: { n: "RRDConflict", f: ko },
    339: { n: "RRDDefName", f: So },
    340: { n: "RRDRstEtxp", f: wo },
    351: { n: "LRng", f: Bo },
    352: { n: "UsesELFs", f: Ps },
    353: { n: "DSF", f: is },
    401: { n: "CUsr", f: Co },
    402: { n: "CbUsr", f: _o },
    403: { n: "UsrInfo", f: To },
    404: { n: "UsrExcl", f: xo },
    405: { n: "FileLock", f: Io },
    406: { n: "RRDInfo", f: Ao },
    407: { n: "BCUsrs", f: yo },
    408: { n: "UsrChk", f: Ro },
    425: { n: "UserBView", f: Do },
    426: { n: "UserSViewBegin", f: Oo },
    427: { n: "UserSViewEnd", f: Fo },
    428: { n: "RRDUserView", f: Po },
    429: { n: "Qsi", f: No },
    430: { n: "SupBook", f: vi },
    431: { n: "Prot4Rev", f: Cs },
    432: { n: "CondFmt", f: Lo },
    433: { n: "CF", f: Mo },
    434: { n: "DVal", f: Uo },
    437: { n: "DConBin", f: Ho },
    438: { n: "TxO", f: Ri },
    439: { n: "RefreshAll", f: xs },
    440: { n: "HLink", f: Di },
    441: { n: "Lel", f: Wo },
    442: { n: "CodeName", f: Vo },
    443: { n: "SXFDBType", f: zo },
    444: { n: "Prot4RevPass", f: _s },
    445: { n: "ObNoMacros", f: Xo },
    446: { n: "Dv", f: Go },
    448: { n: "Excel9File", f: os },
    449: { n: "RecalcId", f: Yn, r: 2 },
    450: { n: "EntExU2", f: ss },
    512: { n: "Dimensions", f: ti },
    513: { n: "Blank", f: Gi },
    515: { n: "Number", f: hi },
    516: { n: "Label", f: qn },
    517: { n: "BoolErr", f: ui },
    518: { n: "Formula", f: Vp },
    519: { n: "String", f: Ds },
    520: { n: "Row", f: Gn },
    523: { n: "Index", f: jo },
    545: { n: "Array", f: Bi },
    549: { n: "DefaultRowHeight", f: $n },
    566: { n: "Table", f: Ko },
    574: { n: "Window2", f: zi },
    638: { n: "RK", f: ai },
    659: { n: "Style", f: Wi },
    1030: { n: "Formula", f: Vp },
    1048: { n: "BigName", f: Yo },
    1054: { n: "Format", f: ei },
    1084: { n: "ContinueBigName", f: $o },
    1212: { n: "ShrFmla", f: wi },
    2048: { n: "HLinkTooltip", f: Oi },
    2049: { n: "WebPub", f: Zo },
    2050: { n: "QsiSXTag", f: Qo },
    2051: { n: "DBQueryExt", f: Jo },
    2052: { n: "ExtString", f: qo },
    2053: { n: "TxtQry", f: el },
    2054: { n: "Qsir", f: rl },
    2055: { n: "Qsif", f: tl },
    2056: { n: "RRDTQSIF", f: al },
    2057: { n: "BOF", f: Un },
    2058: { n: "OleDbConn", f: nl },
    2059: { n: "WOpt", f: il },
    2060: { n: "SXViewEx", f: sl },
    2061: { n: "SXTH", f: fl },
    2062: { n: "SXPIEx", f: ol },
    2063: { n: "SXVDTEx", f: ll },
    2064: { n: "SXViewEx9", f: cl },
    2066: { n: "ContinueFrt", f: ul },
    2067: { n: "RealTimeData", f: hl },
    2128: { n: "ChartFrtInfo", f: dl },
    2129: { n: "FrtWrapper", f: vl },
    2130: { n: "StartBlock", f: pl },
    2131: { n: "EndBlock", f: ml },
    2132: { n: "StartObject", f: bl },
    2133: { n: "EndObject", f: gl },
    2134: { n: "CatLab", f: El },
    2135: { n: "YMult", f: kl },
    2136: { n: "SXViewLink", f: Sl },
    2137: { n: "PivotChartBits", f: wl },
    2138: { n: "FrtFontList", f: Bl },
    2146: { n: "SheetExt", f: Cl },
    2147: { n: "BookExt", f: _l, r: 12 },
    2148: { n: "SXAddl", f: Tl },
    2149: { n: "CrErr", f: xl },
    2150: { n: "HFPicture", f: Il },
    2151: { n: "FeatHdr", f: ls },
    2152: { n: "Feat", f: Al },
    2154: { n: "DataLabExt", f: yl },
    2155: { n: "DataLabExtContents", f: Rl },
    2156: { n: "CellWatch", f: Dl },
    2161: { n: "FeatHdr11", f: Ol },
    2162: { n: "Feature11", f: Fl },
    2164: { n: "DropDownObjIds", f: Pl },
    2165: { n: "ContinueFrt11", f: Nl },
    2166: { n: "DConn", f: Ll },
    2167: { n: "List12", f: Ml },
    2168: { n: "Feature12", f: Ul },
    2169: { n: "CondFmt12", f: Hl },
    2170: { n: "CF12", f: Wl },
    2171: { n: "CFEx", f: Vl },
    2172: { n: "XFCRC", f: Li, r: 12 },
    2173: { n: "XFExt", f: Gd, r: 12 },
    2174: { n: "AutoFilter12", f: zl },
    2175: { n: "ContinueFrt12", f: Xl },
    2180: { n: "MDTInfo", f: Gl },
    2181: { n: "MDXStr", f: jl },
    2182: { n: "MDXTuple", f: Kl },
    2183: { n: "MDXSet", f: Yl },
    2184: { n: "MDXProp", f: $l },
    2185: { n: "MDXKPI", f: Zl },
    2186: { n: "MDB", f: Ql },
    2187: { n: "PLV", f: Jl },
    2188: { n: "Compat12", f: ts, r: 12 },
    2189: { n: "DXF", f: ql },
    2190: { n: "TableStyles", f: ec, r: 12 },
    2191: { n: "TableStyle", f: rc },
    2192: { n: "TableStyleElement", f: tc },
    2194: { n: "StyleExt", f: Vi },
    2195: { n: "NamePublish", f: ac },
    2196: { n: "NameCmt", f: Si, r: 12 },
    2197: { n: "SortData", f: nc },
    2198: { n: "Theme", f: Ud, r: 12 },
    2199: { n: "GUIDTypeLib", f: ic },
    2200: { n: "FnGrp12", f: sc },
    2201: { n: "NameFnGrp12", f: fc },
    2202: { n: "MTRSettings", f: Ci, r: 12 },
    2203: { n: "CompressPictures", f: Kn },
    2204: { n: "HeaderFooter", f: oc },
    2205: { n: "CrtLayout12", f: lc },
    2206: { n: "CrtMlFrt", f: cc },
    2207: { n: "CrtMlFrtContinue", f: uc },
    2211: { n: "ForceFullCalculation", f: jn },
    2212: { n: "ShapePropsStream", f: hc },
    2213: { n: "TextPropsStream", f: dc },
    2214: { n: "RichTextStream", f: vc },
    2215: { n: "CrtLayout12A", f: pc },
    4097: { n: "Units", f: mc },
    4098: { n: "Chart", f: bc },
    4099: { n: "Series", f: gc },
    4102: { n: "DataFormat", f: Ec },
    4103: { n: "LineFormat", f: kc },
    4105: { n: "MarkerFormat", f: Sc },
    4106: { n: "AreaFormat", f: wc },
    4107: { n: "PieFormat", f: Bc },
    4108: { n: "AttachedLabel", f: Cc },
    4109: { n: "SeriesText", f: _c },
    4116: { n: "ChartFormat", f: Tc },
    4117: { n: "Legend", f: xc },
    4118: { n: "SeriesList", f: Ic },
    4119: { n: "Bar", f: Ac },
    4120: { n: "Line", f: yc },
    4121: { n: "Pie", f: Rc },
    4122: { n: "Area", f: Dc },
    4123: { n: "Scatter", f: Oc },
    4124: { n: "CrtLine", f: Fc },
    4125: { n: "Axis", f: Pc },
    4126: { n: "Tick", f: Nc },
    4127: { n: "ValueRange", f: Lc },
    4128: { n: "CatSerRange", f: Mc },
    4129: { n: "AxisLine", f: Uc },
    4130: { n: "CrtLink", f: Hc },
    4132: { n: "DefaultText", f: Wc },
    4133: { n: "Text", f: Vc },
    4134: { n: "FontX", f: cs },
    4135: { n: "ObjectLink", f: zc },
    4146: { n: "Frame", f: Xc },
    4147: { n: "Begin", f: Gc },
    4148: { n: "End", f: jc },
    4149: { n: "PlotArea", f: Kc },
    4154: { n: "Chart3d", f: Yc },
    4156: { n: "PicF", f: $c },
    4157: { n: "DropBar", f: Zc },
    4158: { n: "Radar", f: Qc },
    4159: { n: "Surf", f: Jc },
    4160: { n: "RadarArea", f: qc },
    4161: { n: "AxisParent", f: eu },
    4163: { n: "LegendException", f: ru },
    4164: { n: "ShtProps", f: Hi },
    4165: { n: "SerToCrt", f: tu },
    4166: { n: "AxesUsed", f: au },
    4168: { n: "SBaseRef", f: nu },
    4170: { n: "SerParent", f: iu },
    4171: { n: "SerAuxTrend", f: su },
    4174: { n: "IFmtRecord", f: fu },
    4175: { n: "Pos", f: ou },
    4176: { n: "AlRuns", f: lu },
    4177: { n: "BRAI", f: cu },
    4187: { n: "SerAuxErrBar", f: uu },
    4188: { n: "ClrtClient", f: Pi },
    4189: { n: "SerFmt", f: hu },
    4191: { n: "Chart3DBarShape", f: du },
    4192: { n: "Fbi", f: vu },
    4193: { n: "BopPop", f: pu },
    4194: { n: "AxcExt", f: mu },
    4195: { n: "Dat", f: bu },
    4196: { n: "PlotGrowth", f: gu },
    4197: { n: "SIIndex", f: Eu },
    4198: { n: "GelFrame", f: ku },
    4199: { n: "BopPopCustom", f: Su },
    4200: { n: "Fbi2", f: wu },
    0: { n: "Dimensions", f: ti },
    2: { n: "BIFF2INT", f: xu },
    5: { n: "BoolErr", f: ui },
    7: { n: "String", f: Iu },
    8: { n: "BIFF2ROW", f: Er },
    11: { n: "Index", f: jo },
    22: { n: "ExternCount", f: ki },
    30: { n: "BIFF2FORMAT", f: ri },
    31: { n: "BIFF2FMTCNT", f: Er },
    32: { n: "BIFF2COLINFO", f: Er },
    33: { n: "Array", f: Bi },
    37: { n: "DefaultRowHeight", f: $n },
    50: { n: "BIFF2FONTXTRA", f: Au },
    62: { n: "BIFF2WINDOW2", f: Er },
    69: { n: "BIFF2FONTCLR", f: Er },
    86: { n: "BIFF4FMTCNT", f: Er },
    126: { n: "RK", f: Er },
    127: { n: "ImData", f: Bu },
    135: { n: "Addin", f: Er },
    136: { n: "Edg", f: Er },
    137: { n: "Pub", f: Er },
    145: { n: "Sub", f: Er },
    148: { n: "LHRecord", f: Er },
    149: { n: "LHNGraph", f: Er },
    150: { n: "Sound", f: Er },
    169: { n: "CoordList", f: Er },
    171: { n: "GCW", f: Er },
    188: { n: "ShrFmla", f: Er },
    194: { n: "AddMenu", f: Er },
    195: { n: "DelMenu", f: Er },
    214: { n: "RString", f: yu },
    223: { n: "UDDesc", f: Er },
    234: { n: "TabIdConf", f: Er },
    354: { n: "XL5Modify", f: Er },
    421: { n: "FileSharing2", f: Er },
    521: { n: "BOF", f: Un },
    536: { n: "Lbl", f: bi },
    547: { n: "ExternName", f: pi },
    561: { n: "Font", f: Er },
    1033: { n: "BOF", f: Un },
    2157: { n: "FeatInfo", f: Er },
    2163: { n: "FeatInfo11", f: Er },
    2177: { n: "SXAddl12", f: Er },
    2240: { n: "AutoWebPub", f: Er },
    2241: { n: "ListObj", f: Er },
    2242: { n: "ListField", f: Er },
    2243: { n: "ListDV", f: Er },
    2244: { n: "ListCondFmt", f: Er },
    2245: { n: "ListCF", f: Er },
    2246: { n: "FMQry", f: Er },
    2247: { n: "FMSQry", f: Er },
    2248: { n: "PLV", f: Er },
    2249: { n: "LnExt", f: Er },
    2250: { n: "MkrExt", f: Er },
    2251: { n: "CrtCoopt", f: Er },
    67: { n: "BIFF2XF", f: Er },
    579: { n: "BIFF3XF", f: Er },
    1091: { n: "BIFF4XF", f: Er },
    29282: {},
  };
  function kE(e, r, t, a) {
    var n = a || (t || []).length;
    var i = e.next(4 + n);
    i.write_shift(2, r);
    i.write_shift(2, n);
    if (n > 0 && nr(t)) e.push(t);
  }
  function SE(e, r) {
    if (r.bookType != "biff2") throw "unsupported BIFF version";
    var t = wr(4);
    t.write_shift(2, 2);
    t.write_shift(2, 16);
    return t;
  }
  function wE(e, r, t) {
    if (!e) e = wr(7);
    e.write_shift(2, r);
    e.write_shift(2, t);
    e.write_shift(1, 0);
    e.write_shift(1, 0);
    e.write_shift(1, 0);
    return e;
  }
  function BE(e, r, t) {
    var a = wr(9);
    wE(a, e, r);
    a.write_shift(2, t);
    return a;
  }
  function CE(e, r, t) {
    var a = wr(15);
    wE(a, e, r);
    a.write_shift(8, t, "f");
    return a;
  }
  function _E(e, r, t, a) {
    var n = wr(9);
    wE(n, e, r);
    if (a == "e") {
      n.write_shift(1, t);
      n.write_shift(1, 1);
    } else {
      n.write_shift(1, t ? 1 : 0);
      n.write_shift(1, 0);
    }
    return n;
  }
  function TE(e, r, t) {
    var a = wr(8 + 2 * t.length);
    wE(a, e, r);
    a.write_shift(1, t.length);
    a.write_shift(t.length, t, "sbcs");
    return a.l < a.length ? a.slice(0, a.l) : a;
  }
  function xE(e, r, t, a, n) {
    if (r.v != null)
      switch (r.t) {
        case "d":
        case "n":
          var i = r.t == "d" ? P(r.v) : r.v;
          if (i == (i | 0) && i >= 0 && i < 65536) kE(e, 2, BE(t, a, i));
          else kE(e, 3, CE(t, a, i));
          return;
        case "b":
        case "e":
          kE(e, 5, _E(t, a, r.v, r.t));
          return;
        case "s":
        case "str":
          kE(e, 4, TE(t, a, r.v));
          return;
      }
    kE(e, 1, wE(null, t, a));
  }
  function IE(e, r, t, a, n) {
    var i = Array.isArray(r);
    var s = Kr(r["!ref"] || "A1"),
      f,
      o = "",
      l = [];
    for (var c = s.s.r; c <= s.e.r; ++c) {
      o = Or(c);
      for (var u = s.s.c; u <= s.e.c; ++u) {
        if (c === s.s.r) l[u] = Lr(u);
        f = l[u] + o;
        var h = i ? (r[c] || [])[u] : r[f];
        if (!h) continue;
        xE(e, h, c, u, a);
      }
    }
  }
  function AE(e, r) {
    var t = r || {};
    if (c != null && t.dense == null) t.dense = c;
    var a = Cr();
    var n = 0;
    for (var i = 0; i < e.SheetNames.length; ++i)
      if (e.SheetNames[i] == t.sheet) n = i;
    if (n == 0 && !!t.sheet && e.SheetNames[0] != t.sheet)
      throw new Error("Sheet not found: " + t.sheet);
    kE(a, 9, SE(e, t));
    IE(a, e.Sheets[e.SheetNames[n]], n, t, e);
    kE(a, 10);
    return a.end();
  }
  var yE = (function () {
    function e(e, r) {
      var t = r || {};
      if (c != null && t.dense == null) t.dense = c;
      var a = t.dense ? [] : {};
      var n = e.match(/<table/i);
      if (!n) throw new Error("Invalid HTML: could not find <table>");
      var i = e.match(/<\/table/i);
      var s = n.index,
        f = (i && i.index) || e.length;
      var o = e.slice(s, f).split(/(:?<tr[^>]*>)/i);
      var l = -1,
        u = 0,
        h = 0,
        d = 0;
      var v = { s: { r: 1e7, c: 1e7 }, e: { r: 0, c: 0 } };
      var p = [],
        m = 0;
      for (s = 0; s < o.length; ++s) {
        var b = o[s].trim();
        var g = b.substr(0, 3).toLowerCase();
        if (g == "<tr") {
          ++l;
          u = 0;
          continue;
        }
        if (g != "<td") continue;
        var E = b.split(/<\/td>/i);
        for (f = 0; f < E.length; ++f) {
          var k = E[f].trim();
          if (k.substr(0, 3).toLowerCase() != "<td") continue;
          var S = k,
            w = 0;
          while (S.charAt(0) == "<" && (w = S.indexOf(">")) > -1)
            S = S.slice(w + 1);
          while (S.indexOf(">") > -1) S = S.slice(0, S.lastIndexOf("<"));
          var B = se(k.slice(0, k.indexOf(">")));
          d = B.colspan ? +B.colspan : 1;
          if ((h = +B.rowspan) > 0 || d > 1)
            p.push({
              s: { r: l, c: u },
              e: { r: l + (h || 1) - 1, c: u + d - 1 },
            });
          if (!S.length) {
            u += d;
            continue;
          }
          S = ce(S).replace(/[\r\n]/g, "");
          if (v.s.r > l) v.s.r = l;
          if (v.e.r < l) v.e.r = l;
          if (v.s.c > u) v.s.c = u;
          if (v.e.c < u) v.e.c = u;
          if (t.dense) {
            if (!a[l]) a[l] = [];
            if (Number(S) == Number(S)) a[l][u] = { t: "n", v: +S };
            else a[l][u] = { t: "s", v: S };
          } else {
            var C = Vr({ r: l, c: u });
            if (Number(S) == Number(S)) a[C] = { t: "n", v: +S };
            else a[C] = { t: "s", v: S };
          }
          u += d;
        }
      }
      a["!ref"] = jr(v);
      return a;
    }
    function r(r, t) {
      return Zr(e(r, t), t);
    }
    function t(e, r, t, a) {
      var n = e["!merges"] || [];
      var i = [];
      var s = "<td" + (a.editable ? ' contenteditable="true"' : "") + "></td>";
      for (var f = r.s.c; f <= r.e.c; ++f) {
        var o = 0,
          l = 0;
        for (var c = 0; c < n.length; ++c) {
          if (n[c].s.r > t || n[c].s.c > f) continue;
          if (n[c].e.r < t || n[c].e.c < f) continue;
          if (n[c].s.r < t || n[c].s.c < f) {
            o = -1;
            break;
          }
          o = n[c].e.r - n[c].s.r + 1;
          l = n[c].e.c - n[c].s.c + 1;
          break;
        }
        if (o < 0) continue;
        var u = Vr({ r: t, c: f });
        var h = a.dense ? (e[t] || [])[f] : e[u];
        if (!h || h.v == null) {
          i.push(s);
          continue;
        }
        var d = h.h || de(h.w || ($r(h), h.w) || "");
        var v = {};
        if (o > 1) v.rowspan = o;
        if (l > 1) v.colspan = l;
        if (a.editable) v.contenteditable = "true";
        v.id = "sjs-" + u;
        i.push(De("td", d, v));
      }
      var p = "<tr>";
      return p + i.join("") + "</tr>";
    }
    function a(e, r, t) {
      var a = [];
      return a.join("") + "<table>";
    }
    var n =
      '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
    var i = "</body></html>";
    function s(e, r, s) {
      var f = r || {};
      var o = f.header != null ? f.header : n;
      var l = f.footer != null ? f.footer : i;
      var c = [o];
      var u = Gr(e["!ref"]);
      f.dense = Array.isArray(e);
      c.push(a(e, u, f));
      for (var h = u.s.r; h <= u.e.r; ++h) c.push(t(e, u, h, f));
      c.push("</table>" + l);
      return c.join("");
    }
    return {
      to_workbook: r,
      to_sheet: e,
      _row: t,
      BEGIN: n,
      END: i,
      _preamble: a,
      from_sheet: s,
    };
  })();
  function RE(e, r) {
    var t = r || {};
    if (c != null) t.dense = c;
    var a = t.dense ? [] : {};
    var n = e.getElementsByTagName("tr");
    var i = { s: { r: 0, c: 0 }, e: { r: n.length - 1, c: 0 } };
    var s = [],
      f = 0;
    var o = 0,
      l = 0,
      u = 0,
      h = 0,
      d = 0;
    for (; o < n.length; ++o) {
      var v = n[o];
      var p = v.children;
      for (l = u = 0; l < p.length; ++l) {
        var m = p[l],
          b = p[l].innerText || p[l].textContent;
        for (f = 0; f < s.length; ++f) {
          var g = s[f];
          if (g.s.c == u && g.s.r <= o && o <= g.e.r) {
            u = g.e.c + 1;
            f = -1;
          }
        }
        d = +m.getAttribute("colspan") || 1;
        if ((h = +m.getAttribute("rowspan")) > 0 || d > 1)
          s.push({
            s: { r: o, c: u },
            e: { r: o + (h || 1) - 1, c: u + d - 1 },
          });
        var k = { t: "s", v: b };
        if (b != null && b.length) {
          if (!isNaN(Number(b))) k = { t: "n", v: Number(b) };
          else if (!isNaN(G(b).getDate())) {
            k = { t: "d", v: H(b) };
            if (!t.cellDates) k = { t: "n", v: P(k.v) };
            k.z = t.dateNF || E._table[14];
          }
        }
        if (t.dense) {
          if (!a[o]) a[o] = [];
          a[o][u] = k;
        } else a[Vr({ c: u, r: o })] = k;
        if (i.e.c < u) i.e.c = u;
        u += d;
      }
    }
    a["!merges"] = s;
    a["!ref"] = jr(i);
    return a;
  }
  function DE(e, r) {
    return Zr(RE(e, r), r);
  }
  var OE = (function () {
    var e = function (e, r) {
      return ce(e.replace(/<text:s\/>/g, " ").replace(/<[^>]*>/g, ""));
    };
    var r = {
      day: ["d", "dd"],
      month: ["m", "mm"],
      year: ["y", "yy"],
      hours: ["h", "hh"],
      minutes: ["m", "mm"],
      seconds: ["s", "ss"],
      "am-pm": ["A/P", "AM/PM"],
      "day-of-week": ["ddd", "dddd"],
    };
    return function t(a, n) {
      var i = n || {};
      if (c != null && i.dense == null) i.dense = c;
      var s = Zg(a);
      var f = [],
        o;
      var l;
      var u = { name: "" },
        h = "",
        d = 0;
      var v;
      var p;
      var m = {},
        b = [];
      var g = i.dense ? [] : {};
      var E, k;
      var S = { value: "" };
      var w = "",
        B = 0,
        C;
      var _ = -1,
        T = -1,
        x = { s: { r: 1e6, c: 1e7 }, e: { r: 0, c: 0 } };
      var I = {};
      var A = [],
        y = {},
        R = 0,
        D = 0;
      var O = [];
      var F = [],
        N = {};
      var M = "",
        U = 0;
      var W = 1,
        V = false;
      var X = 0;
      Qg.lastIndex = 0;
      s = s
        .replace(/<!--([\s\S]*?)-->/gm, "")
        .replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
      while ((E = Qg.exec(s)))
        switch ((E[3] = E[3].replace(/_.*$/, ""))) {
          case "table":
          case "工作表":
            if (E[1] === "/") {
              if (x.e.c >= x.s.c && x.e.r >= x.s.r) g["!ref"] = jr(x);
              if (A.length) g["!merges"] = A;
              v.name = ke(v["名称"] || v.name);
              b.push(v.name);
              m[v.name] = g;
            } else if (E[0].charAt(E[0].length - 2) !== "/") {
              v = se(E[0], false);
              _ = T = -1;
              x.s.r = x.s.c = 1e7;
              x.e.r = x.e.c = 0;
              g = i.dense ? [] : {};
              A = [];
            }
            break;
          case "table-row":
          case "行":
            if (E[1] === "/") break;
            p = se(E[0], false);
            if (p["行号"]) _ = p["行号"] - 1;
            else ++_;
            T = -1;
            break;
          case "covered-table-cell":
            ++T;
            if (i.sheetStubs) {
              if (i.dense) {
                if (!g[_]) g[_] = [];
                g[_][T] = { t: "z" };
              } else g[Vr({ r: _, c: T })] = { t: "z" };
            }
            break;
          case "table-cell":
          case "数据":
            if (E[0].charAt(E[0].length - 2) === "/") {
              S = se(E[0], false);
              if (S["number-columns-repeated"])
                T += parseInt(S["number-columns-repeated"], 10);
              else ++T;
            } else if (E[1] !== "/") {
              ++T;
              W = 1;
              if (T > x.e.c) x.e.c = T;
              if (_ > x.e.r) x.e.r = _;
              if (T < x.s.c) x.s.c = T;
              if (_ < x.s.r) x.s.r = _;
              S = se(E[0], false);
              F = [];
              N = {};
              k = { t: S["数据类型"] || S["value-type"], v: null };
              if (i.cellFormula) {
                if (S.formula) S.formula = ce(S.formula);
                if (
                  S["number-matrix-columns-spanned"] &&
                  S["number-matrix-rows-spanned"]
                ) {
                  R = parseInt(S["number-matrix-rows-spanned"], 10) || 0;
                  D = parseInt(S["number-matrix-columns-spanned"], 10) || 0;
                  y = { s: { r: _, c: T }, e: { r: _ + R - 1, c: T + D - 1 } };
                  k.F = jr(y);
                  O.push([y, k.F]);
                }
                if (S.formula) k.f = cm(S.formula);
                else
                  for (X = 0; X < O.length; ++X)
                    if (_ >= O[X][0].s.r && _ <= O[X][0].e.r)
                      if (T >= O[X][0].s.c && T <= O[X][0].e.c) k.F = O[X][1];
              }
              if (S["number-columns-spanned"] || S["number-rows-spanned"]) {
                R = parseInt(S["number-rows-spanned"], 10) || 0;
                D = parseInt(S["number-columns-spanned"], 10) || 0;
                y = { s: { r: _, c: T }, e: { r: _ + R - 1, c: T + D - 1 } };
                A.push(y);
              }
              if (S["number-columns-repeated"])
                W = parseInt(S["number-columns-repeated"], 10);
              switch (k.t) {
                case "boolean":
                  k.t = "b";
                  k.v = Ee(S["boolean-value"]);
                  break;
                case "float":
                  k.t = "n";
                  k.v = parseFloat(S.value);
                  break;
                case "percentage":
                  k.t = "n";
                  k.v = parseFloat(S.value);
                  break;
                case "currency":
                  k.t = "n";
                  k.v = parseFloat(S.value);
                  break;
                case "date":
                  k.t = "d";
                  k.v = H(S["date-value"]);
                  if (!i.cellDates) {
                    k.t = "n";
                    k.v = P(k.v);
                  }
                  k.z = "m/d/yy";
                  break;
                case "time":
                  k.t = "n";
                  k.v = L(S["time-value"]) / 86400;
                  break;
                case "number":
                  k.t = "n";
                  k.v = parseFloat(S["数据数值"]);
                  break;
                default:
                  if (k.t === "string" || k.t === "text" || !k.t) {
                    k.t = "s";
                    if (S["string-value"] != null) w = ce(S["string-value"]);
                  } else throw new Error("Unsupported value type " + k.t);
              }
            } else {
              V = false;
              if (k.t === "s") {
                k.v = w || "";
                V = B == 0;
              }
              if (F.length > 0) {
                k.c = F;
                F = [];
              }
              if (w && i.cellText !== false) k.w = w;
              if (!V || i.sheetStubs) {
                if (!(i.sheetRows && i.sheetRows < _)) {
                  if (i.dense) {
                    if (!g[_]) g[_] = [];
                    g[_][T] = k;
                    while (--W > 0) g[_][++T] = z(k);
                  } else {
                    g[Vr({ r: _, c: T })] = k;
                    while (--W > 0) g[Vr({ r: _, c: ++T })] = z(k);
                  }
                  if (x.e.c <= T) x.e.c = T;
                }
              } else {
                T += W;
                W = 0;
              }
              k = {};
              w = "";
            }
            break;
          case "document":
          case "document-content":
          case "电子表格文档":
          case "spreadsheet":
          case "主体":
          case "scripts":
          case "styles":
          case "font-face-decls":
            if (E[1] === "/") {
              if ((o = f.pop())[0] !== E[3]) throw "Bad state: " + o;
            } else if (E[0].charAt(E[0].length - 2) !== "/")
              f.push([E[3], true]);
            break;
          case "annotation":
            if (E[1] === "/") {
              if ((o = f.pop())[0] !== E[3]) throw "Bad state: " + o;
              N.t = w;
              N.a = M;
              F.push(N);
            } else if (E[0].charAt(E[0].length - 2) !== "/") {
              f.push([E[3], false]);
            }
            M = "";
            U = 0;
            w = "";
            B = 0;
            break;
          case "creator":
            if (E[1] === "/") {
              M = s.slice(U, E.index);
            } else U = E.index + E[0].length;
            break;
          case "meta":
          case "元数据":
          case "settings":
          case "config-item-set":
          case "config-item-map-indexed":
          case "config-item-map-entry":
          case "config-item-map-named":
          case "shapes":
          case "frame":
          case "text-box":
          case "image":
          case "data-pilot-tables":
          case "list-style":
          case "form":
          case "dde-links":
          case "event-listeners":
            if (E[1] === "/") {
              if ((o = f.pop())[0] !== E[3]) throw "Bad state: " + o;
            } else if (E[0].charAt(E[0].length - 2) !== "/")
              f.push([E[3], false]);
            w = "";
            B = 0;
            break;
          case "scientific-number":
            break;
          case "currency-symbol":
            break;
          case "currency-style":
            break;
          case "number-style":
          case "percentage-style":
          case "date-style":
          case "time-style":
            if (E[1] === "/") {
              I[u.name] = h;
              if ((o = f.pop())[0] !== E[3]) throw "Bad state: " + o;
            } else if (E[0].charAt(E[0].length - 2) !== "/") {
              h = "";
              u = se(E[0], false);
              f.push([E[3], true]);
            }
            break;
          case "script":
            break;
          case "libraries":
            break;
          case "automatic-styles":
            break;
          case "master-styles":
            break;
          case "default-style":
          case "page-layout":
            break;
          case "style":
            break;
          case "map":
            break;
          case "font-face":
            break;
          case "paragraph-properties":
            break;
          case "table-properties":
            break;
          case "table-column-properties":
            break;
          case "table-row-properties":
            break;
          case "table-cell-properties":
            break;
          case "number":
            switch (f[f.length - 1][0]) {
              case "time-style":
              case "date-style":
                l = se(E[0], false);
                h += r[E[3]][l.style === "long" ? 1 : 0];
                break;
            }
            break;
          case "fraction":
            break;
          case "day":
          case "month":
          case "year":
          case "era":
          case "day-of-week":
          case "week-of-year":
          case "quarter":
          case "hours":
          case "minutes":
          case "seconds":
          case "am-pm":
            switch (f[f.length - 1][0]) {
              case "time-style":
              case "date-style":
                l = se(E[0], false);
                h += r[E[3]][l.style === "long" ? 1 : 0];
                break;
            }
            break;
          case "boolean-style":
            break;
          case "boolean":
            break;
          case "text-style":
            break;
          case "text":
            if (E[0].slice(-2) === "/>") break;
            else if (E[1] === "/")
              switch (f[f.length - 1][0]) {
                case "number-style":
                case "date-style":
                case "time-style":
                  h += s.slice(d, E.index);
                  break;
              }
            else d = E.index + E[0].length;
            break;
          case "text-content":
            break;
          case "text-properties":
            break;
          case "body":
          case "电子表格":
            break;
          case "forms":
            break;
          case "table-column":
            break;
          case "table-header-rows":
            break;
          case "table-row-group":
            break;
          case "table-column-group":
            break;
          case "table-header-columns":
            break;
          case "null-date":
            break;
          case "graphic-properties":
            break;
          case "calculation-settings":
            break;
          case "named-expressions":
            break;
          case "named-range":
            break;
          case "label-range":
            break;
          case "label-ranges":
            break;
          case "named-expression":
            break;
          case "sort":
            break;
          case "sort-by":
            break;
          case "sort-groups":
            break;
          case "tab":
            break;
          case "line-break":
            break;
          case "span":
            break;
          case "p":
          case "文本串":
            if (E[1] === "/")
              w = (w.length > 0 ? w + "\n" : "") + e(s.slice(B, E.index), C);
            else {
              C = se(E[0], false);
              B = E.index + E[0].length;
            }
            break;
          case "database-range":
            if (E[1] === "/") break;
            try {
              var G = hm(se(E[0])["target-range-address"]);
              m[G[0]]["!autofilter"] = { ref: G[1] };
            } catch (j) {}
            break;
          case "s":
            break;
          case "date":
            break;
          case "object":
            break;
          case "title":
          case "标题":
            break;
          case "desc":
            break;
          case "table-source":
            break;
          case "scenario":
            break;
          case "iteration":
            break;
          case "content-validations":
            break;
          case "content-validation":
            break;
          case "help-message":
            break;
          case "error-message":
            break;
          case "database-ranges":
            break;
          case "filter":
            break;
          case "filter-and":
            break;
          case "filter-or":
            break;
          case "filter-condition":
            break;
          case "list-level-style-bullet":
            break;
          case "list-level-style-number":
            break;
          case "list-level-properties":
            break;
          case "sender-firstname":
          case "sender-lastname":
          case "sender-initials":
          case "sender-title":
          case "sender-position":
          case "sender-email":
          case "sender-phone-private":
          case "sender-fax":
          case "sender-company":
          case "sender-phone-work":
          case "sender-street":
          case "sender-city":
          case "sender-postal-code":
          case "sender-country":
          case "sender-state-or-province":
          case "author-name":
          case "author-initials":
          case "chapter":
          case "file-name":
          case "template-name":
          case "sheet-name":
            break;
          case "event-listener":
            break;
          case "initial-creator":
          case "creation-date":
          case "generator":
          case "document-statistic":
          case "user-defined":
            break;
          case "config-item":
            break;
          case "page-number":
            break;
          case "page-count":
            break;
          case "time":
            break;
          case "cell-range-source":
            break;
          case "detective":
            break;
          case "operation":
            break;
          case "highlighted-range":
            break;
          case "data-pilot-table":
          case "source-cell-range":
          case "source-service":
          case "data-pilot-field":
          case "data-pilot-level":
          case "data-pilot-subtotals":
          case "data-pilot-subtotal":
          case "data-pilot-members":
          case "data-pilot-member":
          case "data-pilot-display-info":
          case "data-pilot-sort-info":
          case "data-pilot-layout-info":
          case "data-pilot-field-reference":
          case "data-pilot-groups":
          case "data-pilot-group":
          case "data-pilot-group-member":
            break;
          case "rect":
            break;
          case "dde-connection-decls":
          case "dde-connection-decl":
          case "dde-link":
          case "dde-source":
            break;
          case "properties":
            break;
          case "property":
            break;
          case "a":
            break;
          case "table-protection":
            break;
          case "data-pilot-grand-total":
            break;
          case "office-document-common-attrs":
            break;
          default:
            if (E[2] === "dc:") break;
            if (E[2] === "draw:") break;
            if (E[2] === "style:") break;
            if (E[2] === "form:") break;
            if (E[2] === "calcext:") break;
            if (E[2] === "loext:") break;
            if (E[2] === "uof:") break;
            if (E[2] === "表:") break;
            if (E[2] === "字:") break;
            if (i.WTF) throw new Error(E);
        }
      var K = { Sheets: m, SheetNames: b };
      return K;
    };
  })();
  function FE(e, r) {
    r = r || {};
    var t = !!$(e, "objectdata");
    if (t) var a = ha(Q(e, "META-INF/manifest.xml"), r);
    var n = J(e, "content.xml");
    if (!n)
      throw new Error(
        "Missing content.xml in " + (t ? "ODS" : "UOF") + " file"
      );
    return OE(t ? n : ke(n), r);
  }
  function PE(e, r) {
    return OE(e, r);
  }
  var NE = (function () {
    var e =
      '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-styles xmlns:table="urn:oasis:names:tc:opendocument:xmlns:table:1.0" xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:text="urn:oasis:names:tc:opendocument:xmlns:text:1.0" xmlns:style="urn:oasis:names:tc:opendocument:xmlns:style:1.0" xmlns:draw="urn:oasis:names:tc:opendocument:xmlns:drawing:1.0" xmlns:fo="urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:number="urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0" xmlns:svg="urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0" xmlns:of="urn:oasis:names:tc:opendocument:xmlns:of:1.2" office:version="1.2"></office:document-styles>';
    return function r(t, a) {
      return e;
    };
  })();
  var LE = (function () {
    var e = "          <table:table-cell />\n";
    var r = "          <table:covered-table-cell/>\n";
    var t = function (t, a, n, i) {
      var s = [];
      s.push('      <table:table table:name="' + de(a.SheetNames[n]) + '">\n');
      var f = 0,
        o = 0,
        l = Gr(t["!ref"]);
      var c = t["!merges"] || [],
        u = 0;
      var h = Array.isArray(t);
      for (f = 0; f < l.s.r; ++f)
        s.push("        <table:table-row></table:table-row>\n");
      for (; f <= l.e.r; ++f) {
        s.push("        <table:table-row>\n");
        for (o = 0; o < l.s.c; ++o) s.push(e);
        for (; o <= l.e.c; ++o) {
          var d = false,
            v = {},
            p = "";
          for (u = 0; u != c.length; ++u) {
            if (c[u].s.c > o) continue;
            if (c[u].s.r > f) continue;
            if (c[u].e.c < o) continue;
            if (c[u].e.r < f) continue;
            if (c[u].s.c != o || c[u].s.r != f) d = true;
            v["table:number-columns-spanned"] = c[u].e.c - c[u].s.c + 1;
            v["table:number-rows-spanned"] = c[u].e.r - c[u].s.r + 1;
            break;
          }
          if (d) {
            s.push(r);
            continue;
          }
          var m = Vr({ r: f, c: o }),
            b = h ? (t[f] || [])[o] : t[m];
          if (b && b.f) {
            v["table:formula"] = de(um(b.f));
            if (b.F) {
              if (b.F.substr(0, m.length) == m) {
                var g = Gr(b.F);
                v["table:number-matrix-columns-spanned"] = g.e.c - g.s.c + 1;
                v["table:number-matrix-rows-spanned"] = g.e.r - g.s.r + 1;
              }
            }
          }
          if (!b) {
            s.push(e);
            continue;
          }
          switch (b.t) {
            case "b":
              p = b.v ? "TRUE" : "FALSE";
              v["office:value-type"] = "boolean";
              v["office:boolean-value"] = b.v ? "true" : "false";
              break;
            case "n":
              p = b.w || String(b.v || 0);
              v["office:value-type"] = "float";
              v["office:value"] = b.v || 0;
              break;
            case "s":
            case "str":
              p = de(b.v);
              v["office:value-type"] = "string";
              break;
            case "d":
              p = b.w || H(b.v).toISOString();
              v["office:value-type"] = "date";
              v["office:date-value"] = H(b.v).toISOString();
              v["table:style-name"] = "ce1";
              break;
            default:
              s.push(e);
              continue;
          }
          s.push(
            "          " + De("table:table-cell", De("text:p", p, {}), v) + "\n"
          );
        }
        s.push("        </table:table-row>\n");
      }
      s.push("      </table:table>\n");
      return s.join("");
    };
    var a = function (e) {
      e.push(" <office:automatic-styles>\n");
      e.push(
        '  <number:date-style style:name="N37" number:automatic-order="true">\n'
      );
      e.push('   <number:month number:style="long"/>\n');
      e.push("   <number:text>/</number:text>\n");
      e.push('   <number:day number:style="long"/>\n');
      e.push("   <number:text>/</number:text>\n");
      e.push("   <number:year/>\n");
      e.push("  </number:date-style>\n");
      e.push(
        '  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n'
      );
      e.push(" </office:automatic-styles>\n");
    };
    return function n(e, r) {
      var n = [Pe];
      var i = Re({
        "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        "xmlns:fo":
          "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xmlns:dc": "http://purl.org/dc/elements/1.1/",
        "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
        "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        "xmlns:presentation":
          "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
        "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
        "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
        "xmlns:math": "http://www.w3.org/1998/Math/MathML",
        "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
        "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
        "xmlns:ooo": "http://openoffice.org/2004/office",
        "xmlns:ooow": "http://openoffice.org/2004/writer",
        "xmlns:oooc": "http://openoffice.org/2004/calc",
        "xmlns:dom": "http://www.w3.org/2001/xml-events",
        "xmlns:xforms": "http://www.w3.org/2002/xforms",
        "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
        "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
        "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
        "xmlns:rpt": "http://openoffice.org/2005/report",
        "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
        "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
        "xmlns:tableooo": "http://openoffice.org/2009/table",
        "xmlns:drawooo": "http://openoffice.org/2010/draw",
        "xmlns:calcext":
          "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
        "xmlns:loext":
          "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
        "xmlns:field":
          "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
        "xmlns:formx":
          "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
        "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
        "office:version": "1.2",
      });
      var s = Re({
        "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
        "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet",
      });
      if (r.bookType == "fods") n.push("<office:document" + i + s + ">\n");
      else n.push("<office:document-content" + i + ">\n");
      a(n);
      n.push("  <office:body>\n");
      n.push("    <office:spreadsheet>\n");
      for (var f = 0; f != e.SheetNames.length; ++f)
        n.push(t(e.Sheets[e.SheetNames[f]], e, f, r));
      n.push("    </office:spreadsheet>\n");
      n.push("  </office:body>\n");
      if (r.bookType == "fods") n.push("</office:document>");
      else n.push("</office:document-content>");
      return n.join("");
    };
  })();
  function ME(e, r) {
    if (r.bookType == "fods") return LE(e, r);
    var t = new ee();
    var a = "";
    var n = [];
    var i = [];
    a = "mimetype";
    t.file(a, "application/vnd.oasis.opendocument.spreadsheet");
    a = "content.xml";
    t.file(a, LE(e, r));
    n.push([a, "text/xml"]);
    i.push([a, "ContentFile"]);
    a = "styles.xml";
    t.file(a, NE(e, r));
    n.push([a, "text/xml"]);
    i.push([a, "StylesFile"]);
    a = "manifest.rdf";
    t.file(a, ma(i, r));
    n.push([a, "application/rdf+xml"]);
    a = "meta.xml";
    t.file(a, ba(e, r));
    n.push([a, "text/xml"]);
    i.push([a, "MetadataFile"]);
    a = "META-INF/manifest.xml";
    t.file(a, da(n, r));
    return t;
  }
  function UE(e) {
    return function r(t, a) {
      var n = 0;
      for (var i = 0; i < t.SheetNames.length; ++i)
        if (t.SheetNames[i] == a.sheet) n = i;
      if (n == 0 && !!a.sheet && t.SheetNames[0] != a.sheet)
        throw new Error("Sheet not found: " + a.sheet);
      return e.from_sheet(t.Sheets[t.SheetNames[n]], a, t);
    };
  }
  var HE = UE(yE);
  var WE = UE({ from_sheet: Sk });
  var VE = UE(Du);
  var zE = UE(Ou);
  var XE = UE(Fu);
  var GE = UE({ from_sheet: wk });
  function jE(e) {
    return function r(t) {
      for (var a = 0; a != e.length; ++a) {
        var n = e[a];
        if (t[n[0]] === undefined) t[n[0]] = n[1];
        if (n[2] === "n") t[n[0]] = Number(t[n[0]]);
      }
    };
  }
  var KE = jE([
    ["cellNF", false],
    ["cellHTML", true],
    ["cellFormula", true],
    ["cellStyles", false],
    ["cellText", true],
    ["cellDates", false],
    ["sheetStubs", false],
    ["sheetRows", 0, "n"],
    ["bookDeps", false],
    ["bookSheets", false],
    ["bookProps", false],
    ["bookFiles", false],
    ["bookVBA", false],
    ["password", ""],
    ["WTF", false],
  ]);
  var YE = jE([
    ["cellDates", false],
    ["bookSST", false],
    ["bookType", "xlsx"],
    ["compression", false],
    ["WTF", false],
  ]);
  function $E(e) {
    if (ia.WS.indexOf(e) > -1) return "sheet";
    if (ia.CS && e == ia.CS) return "chart";
    if (ia.DS && e == ia.DS) return "dialog";
    if (ia.MS && e == ia.MS) return "macro";
    if (!e || !e.length) return "sheet";
    return e;
  }
  function ZE(e, r) {
    if (!e) return 0;
    try {
      e = r.map(function a(r) {
        if (!r.id) r.id = r.strRelID;
        return [r.name, e["!id"][r.id].Target, $E(e["!id"][r.id].Type)];
      });
    } catch (t) {
      return null;
    }
    return !e || e.length === 0 ? null : e;
  }
  function QE(e, r, t, a, n, i, s, f, o, l, c) {
    try {
      n[a] = fa(J(e, t, true), r);
      var u = Q(e, r);
      switch (s) {
        case "sheet":
          i[a] = Cg(u, r, f, n[a], o, l, c);
          break;
        case "chart":
          var h = _g(u, r, f, n[a], o, l, c);
          i[a] = h;
          if (!h || !h["!chart"]) break;
          var d = re(h["!chart"].Target, r);
          var v = sa(d);
          var p = Jd(J(e, d, true), fa(J(e, v, true), d));
          var m = re(p, d);
          var b = sa(m);
          h = Hb(J(e, m, true), m, f, fa(J(e, b, true), m), o, h);
          break;
        case "macro":
          i[a] = Tg(u, r, f, n[a], o, l, c);
          break;
        case "dialog":
          i[a] = xg(u, r, f, n[a], o, l, c);
          break;
      }
    } catch (g) {
      if (f.WTF) throw g;
    }
  }
  var JE = function qk(e) {
    return e.slice(-1) != "/";
  };
  function qE(e, r) {
    k(E);
    r = r || {};
    KE(r);
    a();
    if ($(e, "META-INF/manifest.xml")) return FE(e, r);
    if ($(e, "objectdata.xml")) return FE(e, r);
    var t = I(e.files).filter(JE).sort();
    var i = ra(J(e, "[Content_Types].xml"), r);
    var s = false;
    var f, o;
    if (i.workbooks.length === 0) {
      o = "xl/workbook.xml";
      if (Q(e, o, true)) i.workbooks.push(o);
    }
    if (i.workbooks.length === 0) {
      o = "xl/workbook.bin";
      if (!Q(e, o, true)) throw new Error("Could not find workbook");
      i.workbooks.push(o);
      s = true;
    }
    if (i.workbooks[0].slice(-3) == "bin") s = true;
    if (s) n(1200);
    var l = {};
    var c = {};
    if (!r.bookSheets && !r.bookProps) {
      dm = [];
      if (i.sst) dm = yg(Q(e, i.sst.replace(/^\//, "")), i.sst, r);
      if (r.cellStyles && i.themes.length)
        l = Ag(
          J(e, i.themes[0].replace(/^\//, ""), true) || "",
          i.themes[0],
          r
        );
      if (i.style) c = Ig(Q(e, i.style.replace(/^\//, "")), i.style, l, r);
    }
    var u = Bg(Q(e, i.workbooks[0].replace(/^\//, "")), i.workbooks[0], r);
    var h = {},
      d = "";
    if (i.coreprops.length !== 0) {
      d = J(e, i.coreprops[0].replace(/^\//, ""), true);
      if (d) h = ka(d);
      if (i.extprops.length !== 0) {
        d = J(e, i.extprops[0].replace(/^\//, ""), true);
        if (d) _a(d, h);
      }
    }
    var v = {};
    if (!r.bookSheets || r.bookProps) {
      if (i.custprops.length !== 0) {
        d = J(e, i.custprops[0].replace(/^\//, ""), true);
        if (d) v = Aa(d, r);
      }
    }
    var p = {};
    if (r.bookSheets || r.bookProps) {
      if (u.Sheets)
        f = u.Sheets.map(function R(e) {
          return e.name;
        });
      else if (h.Worksheets && h.SheetNames.length > 0) f = h.SheetNames;
      if (r.bookProps) {
        p.Props = h;
        p.Custprops = v;
      }
      if (r.bookSheets && typeof f !== "undefined") p.SheetNames = f;
      if (r.bookSheets ? p.SheetNames : r.bookProps) return p;
    }
    f = {};
    var m = {};
    if (r.bookDeps && i.calcchain)
      m = Dg(Q(e, i.calcchain.replace(/^\//, "")), i.calcchain, r);
    var b = 0;
    var g = {};
    var S, w;
    {
      var B = u.Sheets;
      h.Worksheets = B.length;
      h.SheetNames = [];
      for (var C = 0; C != B.length; ++C) {
        h.SheetNames[C] = B[C].name;
      }
    }
    var _ = s ? "bin" : "xml";
    var T = "xl/_rels/workbook." + _ + ".rels";
    var x = fa(J(e, T, true), T);
    if (x) x = ZE(x, u.Sheets);
    var A = Q(e, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    for (b = 0; b != h.Worksheets; ++b) {
      var y = "sheet";
      if (x && x[b]) {
        S = "xl/" + x[b][1].replace(/[\/]?xl\//, "");
        y = x[b][2];
      } else {
        S = "xl/worksheets/sheet" + (b + 1 - A) + "." + _;
        S = S.replace(/sheet0\./, "sheet.");
      }
      w = S.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
      QE(e, S, w, h.SheetNames[b], g, f, y, r, u, l, c);
    }
    if (i.comments) rv(e, i.comments, f, g, r);
    p = {
      Directory: i,
      Workbook: u,
      Props: h,
      Custprops: v,
      Deps: m,
      Sheets: f,
      SheetNames: h.SheetNames,
      Strings: dm,
      Styles: c,
      Themes: l,
      SSF: E.get_table(),
    };
    if (r.bookFiles) {
      p.keys = t;
      p.files = e.files;
    }
    if (r.bookVBA) {
      if (i.vba.length > 0) p.vbaraw = Q(e, i.vba[0].replace(/^\//, ""), true);
      else if (
        i.defaults &&
        i.defaults.bin === "application/vnd.ms-office.vbaProject"
      )
        p.vbaraw = Q(e, "xl/vbaProject.bin", true);
    }
    return p;
  }
  function ek(e, r) {
    var t = "Version";
    var a = e.find(t);
    if (!a || !a.content)
      throw new Error("ECMA-376 Encrypted file missing " + t);
    var n = th(a.content);
    t = "DataSpaceMap";
    a = e.find(t);
    if (!a || !a.content)
      throw new Error("ECMA-376 Encrypted file missing " + t);
    var i = nh(a.content);
    if (
      i.length != 1 ||
      i[0].comps.length != 1 ||
      i[0].comps[0].t != 0 ||
      i[0].name != "StrongEncryptionDataSpace" ||
      i[0].comps[0].v != "EncryptedPackage"
    )
      throw new Error("ECMA-376 Encrypted file bad " + t);
    t = "StrongEncryptionDataSpace";
    a = e.find(t);
    if (!a || !a.content)
      throw new Error("ECMA-376 Encrypted file missing " + t);
    var s = ih(a.content);
    if (s.length != 1 || s[0] != "StrongEncryptionTransform")
      throw new Error("ECMA-376 Encrypted file bad " + t);
    t = "!Primary";
    a = e.find(t);
    if (!a || !a.content)
      throw new Error("ECMA-376 Encrypted file missing " + t);
    var f = fh(a.content);
    t = "EncryptionInfo";
    a = e.find(t);
    if (!a || !a.content)
      throw new Error("ECMA-376 Encrypted file missing " + t);
    var o = ch(a.content);
    throw new Error("File is password-protected");
  }
  function rk(e, r) {
    qd = 1024;
    if (r.bookType == "ods") return ME(e, r);
    if (e && !e.SSF) {
      e.SSF = E.get_table();
    }
    if (e && e.SSF) {
      k(E);
      E.load_table(e.SSF);
      r.revssf = R(e.SSF);
      r.revssf[e.SSF[65535]] = 0;
      r.ssf = e.SSF;
    }
    r.rels = {};
    r.wbrels = {};
    r.Strings = [];
    r.Strings.Count = 0;
    r.Strings.Unique = 0;
    var t = r.bookType == "xlsb" ? "bin" : "xml";
    var a = r.bookType == "xlsb" || r.bookType == "xlsm";
    var n = ea();
    YE((r = r || {}));
    var i = new ee();
    var s = "",
      f = 0;
    r.cellXfs = [];
    gm(r.cellXfs, {}, { revssf: { General: 0 } });
    if (!e.Props) e.Props = {};
    s = "docProps/core.xml";
    i.file(s, Ba(e.Props, r));
    n.coreprops.push(s);
    ca(r.rels, 2, s, ia.CORE_PROPS);
    s = "docProps/app.xml";
    if (e.Props && e.Props.SheetNames) {
    } else if (!e.Workbook || !e.Workbook.Sheets)
      e.Props.SheetNames = e.SheetNames;
    else
      e.Props.SheetNames = e.SheetNames.map(function (r, t) {
        return [(e.Workbook.Sheets[t] || {}).Hidden != 2, r];
      })
        .filter(function (e) {
          return e[0];
        })
        .map(function (e) {
          return e[1];
        });
    e.Props.Worksheets = e.Props.SheetNames.length;
    i.file(s, xa(e.Props, r));
    n.extprops.push(s);
    ca(r.rels, 3, s, ia.EXT_PROPS);
    if (e.Custprops !== e.Props && I(e.Custprops || {}).length > 0) {
      s = "docProps/custom.xml";
      i.file(s, Ra(e.Custprops, r));
      n.custprops.push(s);
      ca(r.rels, 4, s, ia.CUST_PROPS);
    }
    s = "xl/workbook." + t;
    i.file(s, Og(e, s, r));
    n.workbooks.push(s);
    ca(r.rels, 1, s, ia.WB);
    for (f = 1; f <= e.SheetNames.length; ++f) {
      var o = { "!id": {} };
      var l = e.Sheets[e.SheetNames[f - 1]];
      var c = (l || {})["!type"] || "sheet";
      switch (c) {
        case "chart":
        default:
          s = "xl/worksheets/sheet" + f + "." + t;
          i.file(s, Fg(f - 1, s, r, e, o));
          n.sheets.push(s);
          ca(r.wbrels, -1, "worksheets/sheet" + f + "." + t, ia.WS[0]);
      }
      if (l) {
        var u = l["!comments"];
        if (u && u.length > 0) {
          var h = "xl/comments" + f + "." + t;
          i.file(h, Mg(u, h, r));
          n.comments.push(h);
          ca(o, -1, "../comments" + f + "." + t, ia.CMNT);
        }
        if (l["!legacy"]) {
          i.file("xl/drawings/vmlDrawing" + f + ".vml", ev(f, l["!comments"]));
        }
        delete l["!comments"];
        delete l["!legacy"];
      }
      if (o["!id"].rId1) i.file(sa(s), la(o));
    }
    if (r.Strings != null && r.Strings.length > 0) {
      s = "xl/sharedStrings." + t;
      i.file(s, Lg(r.Strings, s, r));
      n.strs.push(s);
      ca(r.wbrels, -1, "sharedStrings." + t, ia.SST);
    }
    s = "xl/theme/theme1.xml";
    i.file(s, Md(e.Themes, r));
    n.themes.push(s);
    ca(r.wbrels, -1, "theme/theme1.xml", ia.THEME);
    s = "xl/styles." + t;
    i.file(s, Ng(e, s, r));
    n.styles.push(s);
    ca(r.wbrels, -1, "styles." + t, ia.STY);
    if (e.vbaraw && a) {
      s = "xl/vbaProject.bin";
      i.file(s, e.vbaraw);
      n.vba.push(s);
      ca(r.wbrels, -1, "vbaProject.bin", ia.VBA);
    }
    i.file("[Content_Types].xml", na(n, r));
    i.file("_rels/.rels", la(r.rels));
    i.file("xl/_rels/workbook." + t + ".rels", la(r.wbrels));
    delete r.revssf;
    delete r.ssf;
    return i;
  }
  function tk(e, r) {
    var t = "";
    switch ((r || {}).type || "base64") {
      case "buffer":
        return [e[0], e[1], e[2], e[3]];
      case "base64":
        t = h.decode(e.substr(0, 24));
        break;
      case "binary":
        t = e;
        break;
      case "array":
        return [e[0], e[1], e[2], e[3]];
      default:
        throw new Error("Unrecognized type " + ((r && r.type) || "undefined"));
    }
    return [t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2), t.charCodeAt(3)];
  }
  function ak(e, r) {
    if (e.find("EncryptedPackage")) return ek(e, r);
    return mE(e, r);
  }
  function nk(e, r) {
    var t,
      a = e;
    var n = r || {};
    if (!n.type) n.type = d && Buffer.isBuffer(e) ? "buffer" : "base64";
    switch (n.type) {
      case "base64":
        t = new ee(a, { base64: true });
        break;
      case "binary":
      case "array":
        t = new ee(a, { base64: false });
        break;
      case "buffer":
        t = new ee(a);
        break;
      default:
        throw new Error("Unrecognized type " + n.type);
    }
    return qE(t, n);
  }
  function ik(e, r) {
    var t = 0;
    e: while (t < e.length)
      switch (e.charCodeAt(t)) {
        case 10:
        case 13:
        case 32:
          ++t;
          break;
        case 60:
          return qg(e.slice(t), r);
        default:
          break e;
      }
    return Fu.to_workbook(e, r);
  }
  function sk(e, r) {
    var t = "",
      a = tk(e, r);
    switch (r.type) {
      case "base64":
        t = h.decode(e);
        break;
      case "binary":
        t = e;
        break;
      case "buffer":
        t = e.toString("binary");
        break;
      case "array":
        t = W(e);
        break;
      default:
        throw new Error("Unrecognized type " + r.type);
    }
    if (a[0] == 239 && a[1] == 187 && a[2] == 191) t = ke(t);
    return ik(t, r);
  }
  function fk(e, r) {
    var t = e;
    if (r.type == "base64") t = h.decode(t);
    t = cptable.utils.decode(1200, t.slice(2), "str");
    r.type = "binary";
    return ik(t, r);
  }
  function ok(e, r) {
    var t,
      a = e,
      n = [0];
    var i = r || {};
    vm = {};
    if (i.dateNF) vm.dateNF = i.dateNF;
    if (!i.type) i.type = d && Buffer.isBuffer(e) ? "buffer" : "base64";
    if (i.type == "file") {
      i.type = "buffer";
      a = q.readFileSync(e);
    }
    switch ((n = tk(a, i))[0]) {
      case 208:
        return ak(T.read(a, i), i);
      case 9:
        return mE(p(i.type === "base64" ? h.decode(a) : a), i);
      case 60:
        return qg(a, i);
      case 73:
        if (n[1] == 68) return Pu(a, i);
        break;
      case 84:
        if (n[1] == 65 && n[2] == 66 && n[3] == 76) return Ou.to_workbook(a, i);
        break;
      case 80:
        if (n[1] == 75 && n[2] < 32 && n[3] < 32) return nk(a, i);
        break;
      case 239:
        return n[3] == 60 ? qg(a, i) : Fu.to_workbook(a, i);
      case 255:
        if (n[1] == 254) {
          return fk(a, i);
        }
        break;
      case 0:
        if (n[1] == 0 && n[2] >= 2 && n[3] == 0) return Nu.to_workbook(a, i);
        break;
      case 3:
      case 131:
      case 139:
        return Ru.to_workbook(a, i);
      case 123:
        if (n[1] == 92 && n[2] == 114 && n[3] == 116)
          throw new Error("Unsupported RTF");
        break;
      case 10:
      case 13:
      case 32:
        return sk(a, i);
    }
    if (n[2] <= 12 && n[3] <= 31) return Ru.to_workbook(a, i);
    if (32 > n[0] || n[0] > 127)
      throw new Error("Unsupported file " + n.join("|"));
    return Fu.to_workbook(a, i);
  }
  function lk(e, r) {
    var t = r || {};
    t.type = "file";
    return ok(e, t);
  }
  function ck(e, r) {
    var t = r || {};
    var a = rk(e, t);
    var n = {};
    if (t.compression) n.compression = "DEFLATE";
    switch (t.type) {
      case "base64":
        n.type = "base64";
        break;
      case "binary":
        n.type = "string";
        break;
      case "buffer":
      case "file":
        n.type = "nodebuffer";
        break;
      default:
        throw new Error("Unrecognized type " + t.type);
    }
    if (t.type === "file") return q.writeFileSync(t.file, a.generate(n));
    return a.generate(n);
  }
  function uk(e, r) {
    switch (r.type) {
      case "base64":
        return h.encode(e);
      case "binary":
        return e;
      case "file":
        return q.writeFileSync(r.file, e, "binary");
      case "buffer": {
        if (d) return new Buffer(e, "binary");
        else
          return e.split("").map(function (e) {
            return e.charCodeAt(0);
          });
      }
    }
    throw new Error("Unrecognized type " + r.type);
  }
  function hk(e, r) {
    switch (r.type) {
      case "base64":
        return h.encode(e);
      case "binary":
        return e;
      case "file":
        return q.writeFileSync(r.file, e, "utf8");
      case "buffer": {
        if (d) return new Buffer(e, "utf8");
        else
          return e.split("").map(function (e) {
            return e.charCodeAt(0);
          });
      }
    }
    throw new Error("Unrecognized type " + r.type);
  }
  function dk(e, r) {
    switch (r.type) {
      case "base64":
      case "binary":
        var t = "";
        for (var a = 0; a < e.length; ++a) t += String.fromCharCode(e[a]);
        return r.type == "base64" ? h.encode(t) : t;
      case "file":
        return q.writeFileSync(r.file, e);
      case "buffer":
        return e;
      default:
        throw new Error("Unrecognized type " + r.type);
    }
  }
  function vk(e, r) {
    ng(e);
    var t = r || {};
    switch (t.bookType || "xlsb") {
      case "xml":
      case "xlml":
        return hk(lE(e, t), t);
      case "slk":
      case "sylk":
        return hk(VE(e, t), t);
      case "html":
        return hk(HE(e, t), t);
      case "txt":
        return uk(GE(e, t), t);
      case "csv":
        return hk(WE(e, t), t);
      case "dif":
        return hk(zE(e, t), t);
      case "prn":
        return hk(XE(e, t), t);
      case "fods":
        return hk(ME(e, t), t);
      case "biff2":
        return dk(AE(e, t), t);
      case "xlsx":
      case "xlsm":
      case "xlsb":
      case "ods":
        return ck(e, t);
      default:
        throw new Error("Unrecognized bookType |" + t.bookType + "|");
    }
  }
  function pk(e) {
    if (!e.bookType)
      switch (e.file.slice(e.file.lastIndexOf(".")).toLowerCase()) {
        case ".xlsx":
          e.bookType = "xlsx";
          break;
        case ".xlsm":
          e.bookType = "xlsm";
          break;
        case ".xlsb":
          e.bookType = "xlsb";
          break;
        case ".fods":
          e.bookType = "fods";
          break;
        case ".xlml":
          e.bookType = "xlml";
          break;
        case ".sylk":
          e.bookType = "sylk";
          break;
        case ".html":
          e.bookType = "html";
          break;
        case ".xls":
          e.bookType = "biff2";
          break;
        case ".xml":
          e.bookType = "xml";
          break;
        case ".ods":
          e.bookType = "ods";
          break;
        case ".csv":
          e.bookType = "csv";
          break;
        case ".txt":
          e.bookType = "txt";
          break;
        case ".dif":
          e.bookType = "dif";
          break;
        case ".prn":
          e.bookType = "prn";
          break;
        case ".slk":
          e.bookType = "sylk";
          break;
        case ".htm":
          e.bookType = "html";
          break;
      }
  }
  function mk(e, r, t) {
    var a = t || {};
    a.type = "file";
    a.file = r;
    pk(a);
    return vk(e, a);
  }
  function bk(e, r, t, a) {
    var n = t || {};
    n.type = "file";
    n.file = e;
    pk(n);
    n.type = "buffer";
    var i = a;
    if (!(i instanceof Function)) i = t;
    return q.writeFile(e, vk(r, n), i);
  }
  function gk(e, r) {
    if (e == null || e["!ref"] == null) return [];
    var t = { t: "n", v: 0 },
      a = 0,
      n = 1,
      i = [],
      s = true,
      f = 0,
      o = "";
    var l = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
    var c = r != null ? r : {};
    var u = c.raw;
    var h = c.defval;
    var d = c.range != null ? c.range : e["!ref"];
    if (c.header === 1) a = 1;
    else if (c.header === "A") a = 2;
    else if (Array.isArray(c.header)) a = 3;
    switch (typeof d) {
      case "string":
        l = Kr(d);
        break;
      case "number":
        l = Kr(e["!ref"]);
        l.s.r = d;
        break;
      default:
        l = d;
    }
    if (a > 0) n = 0;
    var v = Or(l.s.r);
    var p = new Array(l.e.c - l.s.c + 1);
    var m = new Array(l.e.r - l.s.r - n + 1);
    var b = 0,
      g = 0;
    var E = Array.isArray(e);
    var k = l.s.r,
      S = 0,
      w = 0;
    if (E && !e[k]) e[k] = [];
    for (S = l.s.c; S <= l.e.c; ++S) {
      p[S] = Lr(S);
      t = E ? e[k][S] : e[p[S] + v];
      switch (a) {
        case 1:
          i[S] = S - l.s.c;
          break;
        case 2:
          i[S] = p[S];
          break;
        case 3:
          i[S] = c.header[S - l.s.c];
          break;
        default:
          if (t == null) continue;
          o = f = $r(t, null, c);
          g = 0;
          for (w = 0; w < i.length; ++w) if (i[w] == o) o = f + "_" + ++g;
          i[S] = o;
      }
    }
    var B = a === 1 ? [] : {};
    for (k = l.s.r + n; k <= l.e.r; ++k) {
      v = Or(k);
      s = true;
      if (a === 1) B = [];
      else {
        B = {};
        if (Object.defineProperty)
          try {
            Object.defineProperty(B, "__rowNum__", {
              value: k,
              enumerable: false,
            });
          } catch (C) {
            B.__rowNum__ = k;
          }
        else B.__rowNum__ = k;
      }
      if (!E || e[k])
        for (S = l.s.c; S <= l.e.c; ++S) {
          t = E ? e[k][S] : e[p[S] + v];
          if (t === undefined || t.t === undefined) {
            if (h === undefined) continue;
            if (i[S] != null) {
              B[i[S]] = h;
              s = false;
            }
            continue;
          }
          f = t.v;
          switch (t.t) {
            case "z":
              if (f == null) break;
              continue;
            case "e":
              continue;
            case "s":
            case "d":
            case "b":
            case "n":
              break;
            default:
              throw new Error("unrecognized type " + t.t);
          }
          if (i[S] != null) {
            if (f == null) {
              if (h !== undefined) B[i[S]] = h;
              else if (u && f === null) B[i[S]] = null;
              else continue;
            } else {
              B[i[S]] = u ? f : $r(t, f, c);
            }
            s = false;
          }
        }
      if (s === false || (a === 1 ? c.blankrows !== false : !!c.blankrows))
        m[b++] = B;
    }
    m.length = b;
    return m;
  }
  var Ek = /"/g;
  function kk(e, r, t, a, n, i, s, f) {
    var o = true;
    var l = "",
      c = "",
      u = Or(t);
    for (var h = r.s.c; h <= r.e.c; ++h) {
      var d = f.dense ? (e[t] || [])[h] : e[a[h] + u];
      if (d == null) c = "";
      else if (d.v != null) {
        o = false;
        c = "" + $r(d, null, f);
        for (var v = 0, p = 0; v !== c.length; ++v)
          if ((p = c.charCodeAt(v)) === n || p === i || p === 34) {
            c = '"' + c.replace(Ek, '""') + '"';
            break;
          }
        if (c == "ID") c = '"ID"';
      } else if (d.f != null && !d.F) {
        o = false;
        c = "=" + d.f;
        if (c.indexOf(",") >= 0) c = '"' + c.replace(Ek, '""') + '"';
      } else c = "";
      l += (h === r.s.c ? "" : s) + c;
    }
    if (f.blankrows === false && o) return null;
    return l;
  }
  function Sk(e, r) {
    var t = [];
    var a = r == null ? {} : r;
    if (e == null || e["!ref"] == null) return "";
    var n = Kr(e["!ref"]);
    var i = a.FS !== undefined ? a.FS : ",",
      s = i.charCodeAt(0);
    var f = a.RS !== undefined ? a.RS : "\n",
      o = f.charCodeAt(0);
    var l = new RegExp((i == "|" ? "\\|" : i) + "+$");
    var c = "",
      u = [];
    a.dense = Array.isArray(e);
    for (var h = n.s.c; h <= n.e.c; ++h) u[h] = Lr(h);
    for (var d = n.s.r; d <= n.e.r; ++d) {
      c = kk(e, n, d, u, s, o, i, a);
      if (c == null) {
        continue;
      }
      if (a.strip) c = c.replace(l, "");
      t.push(c + f);
    }
    delete a.dense;
    return t.join("");
  }
  function wk(e, r) {
    if (!r) r = {};
    r.FS = "\t";
    r.RS = "\n";
    var t = Sk(e, r);
    if (typeof cptable == "undefined") return t;
    var a = cptable.utils.encode(1200, t);
    return "ÿþ" + a;
  }
  function Bk(e) {
    var r = "",
      t,
      a = "";
    if (e == null || e["!ref"] == null) return [];
    var n = Kr(e["!ref"]),
      i = "",
      s = [],
      f;
    var o = [];
    var l = Array.isArray(e);
    for (f = n.s.c; f <= n.e.c; ++f) s[f] = Lr(f);
    for (var c = n.s.r; c <= n.e.r; ++c) {
      i = Or(c);
      for (f = n.s.c; f <= n.e.c; ++f) {
        r = s[f] + i;
        t = l ? (e[c] || [])[f] : e[r];
        a = "";
        if (t === undefined) continue;
        else if (t.F != null) {
          r = t.F;
          if (!t.f) continue;
          a = t.f;
          if (r.indexOf(":") == -1) r = r + ":" + r;
        }
        if (t.f != null) a = t.f;
        else if (t.t == "z") continue;
        else if (t.t == "n" && t.v != null) a = "" + t.v;
        else if (t.t == "b") a = t.v ? "TRUE" : "FALSE";
        else if (t.w !== undefined) a = "'" + t.w;
        else if (t.v === undefined) continue;
        else if (t.t == "s") a = "'" + t.v;
        else a = "" + t.v;
        o[o.length] = r + "=" + a;
      }
    }
    return o;
  }
  function Ck(e, r) {
    var t = r || {};
    var a = {};
    var n;
    var i = { s: { c: 0, r: 0 }, e: { c: 0, r: e.length } };
    var s = t.header || [],
      f = 0;
    for (var o = 0; o != e.length; ++o) {
      Object.keys(e[o])
        .filter(function (r) {
          return e[o].hasOwnProperty(r);
        })
        .forEach(function (r) {
          if ((f = s.indexOf(r)) == -1) s[(f = s.length)] = r;
          var i = e[o][r];
          var l = "z";
          var c = "";
          if (typeof i == "number") l = "n";
          else if (typeof i == "boolean") l = "b";
          else if (typeof i == "string") l = "s";
          else if (i instanceof Date) {
            l = "d";
            if (!t.cellDates) {
              l = "n";
              i = P(i);
            }
            c = t.dateNF || E._table[14];
          }
          a[Vr({ c: f, r: o + 1 })] = n = { t: l, v: i };
          if (c) n.z = c;
        });
    }
    i.e.c = s.length - 1;
    for (f = 0; f < s.length; ++f) a[Lr(f) + "1"] = { t: "s", v: s[f] };
    a["!ref"] = jr(i);
    return a;
  }
  var _k = {
    encode_col: Lr,
    encode_row: Or,
    encode_cell: Vr,
    encode_range: jr,
    decode_col: Nr,
    decode_row: Dr,
    split_cell: Hr,
    decode_cell: Wr,
    decode_range: Gr,
    format_cell: $r,
    get_formulae: Bk,
    make_csv: Sk,
    make_json: gk,
    make_formulae: Bk,
    aoa_to_sheet: Qr,
    json_to_sheet: Ck,
    table_to_sheet: RE,
    table_to_book: DE,
    sheet_to_csv: Sk,
    sheet_to_json: gk,
    sheet_to_html: yE.from_sheet,
    sheet_to_formulae: Bk,
    sheet_to_row_object_array: gk,
  };
  (function (e) {
    e.consts = e.consts || {};
    function r(r) {
      r.forEach(function (r) {
        e.consts[r[0]] = r[1];
      });
    }
    function t(e, r, t) {
      return e[r] != null ? e[r] : (e[r] = t);
    }
    function a(e, r, t) {
      if (typeof r == "string") return e[r] || (e[r] = { t: "z" });
      if (typeof r != "number") return a(e, Vr(r));
      return a(e, Vr({ r: r, c: t || 0 }));
    }
    function n(e, r) {
      if (typeof r == "number") {
        if (r >= 0 && e.SheetNames.length > r) return r;
        throw new Error("Cannot find sheet # " + r);
      } else if (typeof r == "string") {
        var t = e.SheetNames.indexOf(r);
        if (t > -1) return t;
        throw new Error("Cannot find sheet name |" + r + "|");
      } else throw new Error("Cannot find sheet |" + r + "|");
    }
    e.book_new = function () {
      return { SheetNames: [], Sheets: {} };
    };
    e.book_append_sheet = function (e, r, t) {
      if (!t)
        for (var a = 1; a <= 65535; ++a)
          if (e.SheetNames.indexOf((t = "Sheet" + a)) == -1) break;
      if (!t) throw new Error("Too many worksheets");
      tg(t);
      if (e.SheetNames.indexOf(t) >= 0)
        throw new Error("Worksheet with name |" + t + "| already exists!");
      e.SheetNames.push(t);
      e.Sheets[t] = r;
    };
    e.book_set_sheet_visibility = function (e, r, a) {
      t(e, "Workbook", {});
      t(e.Workbook, "Sheets", []);
      var i = n(e, r);
      t(e.Workbook.Sheets, i, {});
      switch (a) {
        case 0:
        case 1:
        case 2:
          break;
        default:
          throw new Error("Bad sheet visibility setting " + a);
      }
      e.Workbook.Sheets[i].Hidden = a;
    };
    r([
      ["SHEET_VISIBLE", 0],
      ["SHEET_HIDDEN", 1],
      ["SHEET_VERY_HIDDEN", 2],
    ]);
    e.cell_set_number_format = function (e, r) {
      e.z = r;
      return e;
    };
    e.cell_set_hyperlink = function (e, r, t) {
      if (!r) {
        delete e.l;
      } else {
        e.l = { Target: r };
        if (t) e.l.Tooltip = t;
      }
      return e;
    };
    e.cell_add_comment = function (e, r, t) {
      if (!e.c) e.c = [];
      e.c.push({ t: r, a: t || "SheetJS" });
    };
    e.sheet_set_array_formula = function (e, r, t) {
      var n = typeof r != "string" ? r : Kr(r);
      var i = typeof r == "string" ? r : jr(r);
      for (var s = n.s.r; s <= n.e.r; ++s)
        for (var f = n.s.c; f <= n.e.c; ++f) {
          var o = a(e, s, f);
          o.t = "n";
          o.F = i;
          delete o.v;
          if (s == n.s.r && f == n.s.c) o.f = t;
        }
      return e;
    };
    return e;
  })(_k);
  if (d && typeof require != "undefined")
    (function () {
      var e = {}.Readable;
      var t = function (r, t) {
        var a = e();
        var n = "";
        var i = t == null ? {} : t;
        if (r == null || r["!ref"] == null) {
          a.push(null);
          return a;
        }
        var s = Kr(r["!ref"]);
        var f = i.FS !== undefined ? i.FS : ",",
          o = f.charCodeAt(0);
        var l = i.RS !== undefined ? i.RS : "\n",
          c = l.charCodeAt(0);
        var u = new RegExp((f == "|" ? "\\|" : f) + "+$");
        var h = "",
          d = [];
        i.dense = Array.isArray(r);
        for (var v = s.s.c; v <= s.e.c; ++v) d[v] = Lr(v);
        var p = s.s.r;
        a._read = function () {
          if (p > s.e.r) return a.push(null);
          while (p <= s.e.r) {
            h = kk(r, s, p, d, o, c, f, i);
            ++p;
            if (h != null) {
              if (i.strip) h = h.replace(u, "");
              a.push(h + l);
              break;
            }
          }
        };
        return a;
      };
      var a = function (r, t) {
        var a = e();
        var n = t || {};
        var i = n.header != null ? n.header : yE.BEGIN;
        var s = n.footer != null ? n.footer : yE.END;
        a.push(i);
        var f = Gr(r["!ref"]);
        n.dense = Array.isArray(r);
        a.push(yE._preamble(r, f, n));
        var o = f.s.r;
        var l = false;
        a._read = function () {
          if (o > f.e.r) {
            if (!l) {
              l = true;
              a.push("</table>" + s);
            }
            return a.push(null);
          }
          while (o <= f.e.r) {
            a.push(yE._row(r, f, o, n));
            ++o;
            break;
          }
        };
        return a;
      };
      r.stream = { to_html: a, to_csv: t };
    })();
  r.parse_xlscfb = mE;
  r.parse_ods = FE;
  r.parse_fods = PE;
  r.write_ods = ME;
  r.parse_zip = qE;
  r.read = ok;
  r.readFile = lk;
  r.readFileSync = lk;
  r.write = vk;
  r.writeFile = mk;
  r.writeFileSync = mk;
  r.writeFileAsync = bk;
  r.utils = _k;
  r.SSF = E;
})(typeof exports !== "undefined" ? exports : XLSX);
var XLS = XLSX;
var ODS = XLSX;

/* xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
function SheetJSExportService(uiGridExporterService) {
  function exportSheetJS(gridApi, wopts) {
    var columns = uiGridExporterService.getColumnHeaders(gridApi.grid, "all");
    var data = uiGridExporterService.getData(gridApi.grid, "all", "all");

    var fileName = gridApi.grid.options.filename || "SheetJS";
    fileName += wopts.bookType ? "." + wopts.bookType : ".xlsx";

    var sheetName = gridApi.grid.options.sheetname || "Sheet1";

    var wb = XLSX.utils.book_new(),
      ws = uigrid_to_sheet(data, columns);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    var wbout = XLSX.write(wb, wopts);
    saveAs(
      new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      fileName
    );
  }

  var service = {};
  service.exportXLSB = function exportXLSB(gridApi) {
    return exportSheetJS(gridApi, {
      bookType: "xlsb",
      bookSST: true,
      type: "binary",
    });
  };
  service.exportXLSX = function exportXLSX(gridApi) {
    return exportSheetJS(gridApi, {
      bookType: "xlsx",
      bookSST: true,
      type: "binary",
    });
  };

  return service;

  /* utilities */
  function uigrid_to_sheet(data, columns) {
    var o = [],
      oo = [],
      i = 0,
      j = 0;

    /* column headers */
    for (j = 0; j < columns.length; ++j) oo.push(get_value(columns[j]));
    o.push(oo);

    /* table data */
    for (i = 0; i < data.length; ++i) {
      oo = [];
      for (j = 0; j < data[i].length; ++j) oo.push(get_value(data[i][j]));
      o.push(oo);
    }
    /* aoa_to_sheet converts an array of arrays into a worksheet object */
    return XLSX.utils.aoa_to_sheet(o);
  }

  function get_value(col) {
    if (!col) return col;
    if (col.value) return col.value;
    if (col.displayName) return col.displayName;
    if (col.name) return col.name;
    return null;
  }

  function s2ab(s) {
    if (typeof ArrayBuffer !== "undefined") {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    } else {
      var buf = new Array(s.length);
      for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
  }
}

var SheetJSImportDirective = function () {
  return {
    scope: { opts: "=" },
    link: function ($scope, $elm, $attrs) {
      $elm.on("change", function (changeEvent) {
        var reader = new FileReader();

        reader.onload = function (e) {
          /* read workbook */
          var bstr = e.target.result;
          var wb = XLSX.read(bstr, { type: "binary" });

          /* grab first sheet */
          var wsname = wb.SheetNames[0];
          var ws = wb.Sheets[wsname];

          /* grab first row and generate column headers */
          var aoa = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false });
          var cols = [];
          for (var i = 0; i < aoa[0].length; ++i)
            cols[i] = { field: aoa[0][i] };

          /* generate rest of the data */
          var data = [];
          for (var r = 1; r < aoa.length; ++r) {
            data[r - 1] = {};
            for (i = 0; i < aoa[r].length; ++i) {
              if (aoa[r][i] == null) continue;
              data[r - 1][aoa[0][i]] = aoa[r][i];
            }
          }

          /* update scope */
          $scope.$apply(function () {
            $scope.opts.columnDefs = cols;
            $scope.opts.data = data;
          });
        };

        reader.readAsBinaryString(changeEvent.target.files[0]);
      });
    },
  };
};

$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
  options.async = true;
});
(function () {
  "use strict";

  function purgeInvalidNgStorageEntries(storage, label) {
    if (!storage || typeof storage.length !== "number") {
      return;
    }

    var keys = [];
    for (var idx = 0; idx < storage.length; idx++) {
      try {
        var key = storage.key(idx);
        if (key && key.indexOf("ngStorage-") === 0) {
          keys.push(key);
        }
      } catch (error) {
        console.warn(
          "[ngStorage][scan] No se pudo leer la llave en",
          label,
          error
        );
      }
    }

    keys.forEach(function (key) {
      try {
        var rawValue = storage.getItem(key);
        if (rawValue === null || rawValue === undefined || rawValue === "") {
          storage.removeItem(key);
          return;
        }

        // ngStorage guarda JSON.stringify(valor). Si la cadena no es JSON válido,
        // JSON.parse lanzará excepción y eliminamos la entrada dañada.
        JSON.parse(rawValue);
      } catch (error) {
        console.warn(
          "[ngStorage] Eliminando entrada corrupta",
          key,
          "desde",
          label,
          error
        );
        try {
          storage.removeItem(key);
        } catch (removeError) {
          console.warn(
            "[ngStorage] No se pudo eliminar la entrada corrupta",
            key,
            removeError
          );
        }
      }
    });
  }

  var hasWindowObject = typeof window !== "undefined";
  if (hasWindowObject) {
    try {
      purgeInvalidNgStorageEntries(window.localStorage, "localStorage");
    } catch (error) {
      console.warn("[ngStorage] No se pudo depurar localStorage", error);
    }

    try {
      purgeInvalidNgStorageEntries(window.sessionStorage, "sessionStorage");
    } catch (error) {
      console.warn("[ngStorage] No se pudo depurar sessionStorage", error);
    }
  }

  angular.module("naif.base64", []).directive("baseSixtyFourInput", [
    "$window",
    "$q",
    function ($window, $q) {
      return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ngModel) {
          var isMultiple = attrs.hasOwnProperty("multiple");

          if (!$window.FileReader) {
            ngModel.$setValidity("base64", false);
            return;
          }

          ngModel.$render = function () {
            if (!ngModel.$viewValue) {
              element.val(null);
            }
          };

          element.on("change", function (event) {
            var files =
              event.target && event.target.files ? event.target.files : null;

            if (!files || !files.length) {
              scope.$applyAsync(function () {
                var emptyValue = isMultiple ? [] : null;
                ngModel.$setViewValue(emptyValue);
                if (attrs.required) {
                  ngModel.$setValidity("required", false);
                }
              });
              element.val(null);
              return;
            }

            var readPromises = [];

            angular.forEach(files, function (file) {
              readPromises.push(readFile(file));
            });

            $q.all(readPromises)
              .then(
                function (results) {
                  scope.$applyAsync(function () {
                    ngModel.$setValidity("base64", true);
                    var viewValue = isMultiple ? results : results[0];
                    ngModel.$setViewValue(viewValue);

                    if (attrs.required) {
                      var hasValue = isMultiple
                        ? !!(viewValue && viewValue.length)
                        : !!viewValue;
                      ngModel.$setValidity("required", hasValue);
                    }

                    if (attrs.onChange) {
                      scope.$eval(attrs.onChange, {
                        $files: results,
                        $event: event,
                      });
                    }
                  });
                },
                function () {
                  scope.$applyAsync(function () {
                    ngModel.$setValidity("base64", false);
                    var emptyValue = isMultiple ? [] : null;
                    ngModel.$setViewValue(emptyValue);
                    if (attrs.required) {
                      ngModel.$setValidity("required", false);
                    }
                  });
                }
              )
              .finally(function () {
                element.val(null);
              });
          });

          scope.$on("$destroy", function () {
            element.off("change");
          });

          function readFile(file) {
            var deferred = $q.defer();

            try {
              var reader = new $window.FileReader();

              reader.onload = function (loadEvent) {
                var result = loadEvent.target.result || "";
                var commaIndex = result.indexOf(",");

                if (commaIndex >= 0) {
                  result = result.substring(commaIndex + 1);
                }

                deferred.resolve({
                  filename: file.name,
                  filetype: file.type,
                  filesize: file.size,
                  base64: result,
                  file: file,
                });
              };

              reader.onerror = function (error) {
                deferred.reject(error);
              };

              reader.readAsDataURL(file);
            } catch (error) {
              deferred.reject(error);
            }

            return deferred.promise;
          }
        },
      };
    },
  ]);

  var app = angular
    .module("inspinia", [
      "ngAnimate",
      "ngCookies",
      "ngTouch",
      "ngSanitize",
      "ngResource",
      "ngMessages",
      "ngAria",
      "ui.router",
      "ui.bootstrap",
      "oc.lazyLoad",
      "datatables",
      "ngStorage",
      "config",
      "chart.js",
      "ui.select",
      "bcherny/formatAsCurrency",
      "naif.base64",
      "datePicker",
      "toaster",
      "angularFileUpload",
      "ui.footable",
      "ngIdle",
      "Dragtable",
      "textAngular",
      "ngTagsInput",
      "mwl.calendar",
      "firebase",
      // 'ngRaven',
    ])
    .directive("onFinishRender", function ($timeout) {
      return {
        restrict: "A",
        transclude: false,
        link: function (scope, element, attr) {
          if (scope.$last === true) {
            $timeout(function () {
              scope.$emit("ngRepeatFinished");
            });
          }
        },
      };
    });

  app.constant("project", {
    NAME: "Beneficios",
    VERSION: "v0.5.0",
  });

  app.run(function (DTDefaultOptions) {
    DTDefaultOptions.setLanguageSource(
      "https://cdn.datatables.net/plug-ins/1.10.10/i18n/Spanish.json"
    );
  });

  // --- PATCH: helper de desencriptado seguro (evita reventar en blanco)
  window.safeDecrypt = function (label, blob) {
    try {
      if (typeof blob !== "string" || blob.length < 10 || blob[0] !== "{")
        return null;
      var txt = sjcl.decrypt(label, blob);
      // puede ser JSON o string; tratamos de parsear
      try {
        return JSON.parse(txt);
      } catch (_) {
        return txt;
      }
    } catch (e) {
      return null;
    }
  };

  app.run(function (
    $localStorage,
    $location,
    $sessionStorage,
    $rootScope,
    toaster,
    MESSAGES,
    $window,
    Idle,
    $state,
    $uibModal,
    $compile,
    dataFactory,
    PersistenceFactory,
    navigationService
  ) {
    function normalizeTokenCandidate(candidate) {
      if (!candidate) {
        return null;
      }
      if (angular.isObject(candidate)) {
        try {
          candidate = JSON.stringify(candidate);
        } catch (_) {
          candidate = null;
        }
      }
      if (typeof candidate !== "string") {
        return null;
      }
      var trimmed = candidate.trim();
      if (!trimmed || trimmed === "null" || trimmed === "undefined") {
        return null;
      }
      return trimmed;
    }

    function isEncryptedToken(token) {
      return angular.isString(token) && token.charAt(0) === "{";
    }

    function tokenLooksUsable(token) {
      var normalized = normalizeTokenCandidate(token);
      if (!normalized) {
        return false;
      }
      if (isEncryptedToken(normalized)) {
        try {
          return !!sjcl.decrypt("Token", normalized);
        } catch (error) {
          return false;
        }
      }
      return true;
    }

    function readStoredTokenCandidate() {
      return (
        normalizeTokenCandidate($sessionStorage.token) ||
        normalizeTokenCandidate($localStorage.token) ||
        normalizeTokenCandidate($localStorage.authToken)
      );
    }

    function hasUsableSession() {
      return tokenLooksUsable(readStoredTokenCandidate());
    }

    function resetStoredSession() {
      delete $sessionStorage.token;
      delete $sessionStorage.user;
      delete $sessionStorage.permisos;
      delete $sessionStorage.infoUser;
      delete $sessionStorage.actualPage;
      delete $localStorage.token;
      delete $localStorage.user;
      delete $localStorage.permisos;
      delete $localStorage.infoUser;
      delete $localStorage.authToken;
      if (!$localStorage.token) {
        delete $localStorage.actualPage;
      }
    }

    function stubAnonymousUser() {
      try {
        $sessionStorage.user = sjcl.encrypt("User", "{}");
      } catch (error) {
        $sessionStorage.user = "{}";
      }
    }

    var forcingLoginRedirect = false;

    function forceLoginRedirect(options) {
      options = options || {};
      var loginPath = "/login/auth";

      if (forcingLoginRedirect && options.force !== true) {
        if ($location.path() !== loginPath) {
          $location.path(loginPath).replace();
        }
        if ($window.location.hash !== "#" + loginPath) {
          $window.location.hash = "#" + loginPath;
        }
        return;
      }

      function navigateToLogin() {
        if ($location.path() !== loginPath) {
          $location.path(loginPath).replace();
        }
        if (!$state.current || $state.current.name !== "login.login") {
          try {
            $state.go(
              "login.login",
              {},
              { reload: true, inherit: false, notify: true }
            );
          } catch (error) {
            console.warn(
              "No fue posible redirigir mediante $state, usando hash directo",
              error
            );
          }
        }
        if ($window.location.hash !== "#" + loginPath) {
          $window.location.hash = "#" + loginPath;
        }
      }

      forcingLoginRedirect = true;

      if (options.clear !== false) {
        resetStoredSession();
      }

      if (options.stubUser !== false) {
        stubAnonymousUser();
      }

      if ($rootScope.$$phase) {
        navigateToLogin();
      } else {
        $rootScope.$evalAsync(navigateToLogin);
      }

      Idle.unwatch();
    }

    var sessionBridge = $window.saamSessionControl || {};
    sessionBridge.resetStoredSession = resetStoredSession;
    sessionBridge.forceLoginRedirect = forceLoginRedirect;
    sessionBridge.stubAnonymousUser = stubAnonymousUser;
    sessionBridge.markLoginRestored = function () {
      forcingLoginRedirect = false;
    };
    sessionBridge.hasUsableSession = hasUsableSession;

    $window.saamSessionControl = sessionBridge;

    /* === PATCH: seed & migrate token entre pestañas === */
    if (!$localStorage.token && $localStorage.authToken) {
      try {
        $localStorage.token = sjcl.encrypt(
          "Token",
          JSON.stringify($localStorage.authToken)
        );
      } catch (e) {
        $localStorage.token = $localStorage.authToken;
      } // fallback plano
    }
    var storedTokenCandidate = readStoredTokenCandidate();

    var hasSession = tokenLooksUsable(storedTokenCandidate);

    if (hasSession && storedTokenCandidate) {
      if (!$sessionStorage.token) {
        $sessionStorage.token = storedTokenCandidate;
      }
      if (!$localStorage.token) {
        $localStorage.token = storedTokenCandidate;
      }
    } else if (!hasSession) {
      resetStoredSession();
    }

    if (hasSession) {
      if (!$sessionStorage.user && $localStorage.user) {
        $sessionStorage.user = $localStorage.user;
      }
      if (!$sessionStorage.permisos && $localStorage.permisos) {
        $sessionStorage.permisos = $localStorage.permisos;
      }
      if (!$sessionStorage.infoUser && $localStorage.infoUser) {
        $sessionStorage.infoUser = $localStorage.infoUser;
      }
    }

    // 3) (opcional) LOGS de verificación
    console.log(
      "> seed session.token?",
      !!$sessionStorage.token,
      "local.token?",
      !!$localStorage.token,
      "legacy authToken?",
      !!$localStorage.authToken,
      "session válido?",
      hasSession
    );

    try {
      $(".datepicker-me input").datepicker();
      $.fn.datepicker.defaults.format = "dd/mm/yyyy";
      $.fn.datepicker.defaults.startView = 0;
      $.fn.datepicker.defaults.autoclose = true;
      $.fn.datepicker.defaults.language = "es";
    } catch (e) {}

    try {
      if ($location.$$search) {
        var parameter = $location.$$search;
        if (parameter.tipo) {
          if (parameter.tipo == 1) {
            $localStorage.url_operation = "/operacion.semanal";
          }
        }
      }
    } catch (error) {
      console.log("Login normal", error);
    }
    $rootScope.$watch(
      function () {
        return location.hash;
      },
      function (value) {
        function __tokenFromStorage__() {
          var enc = readStoredTokenCandidate();

          if (!enc) {
            return null;
          }
          if (isEncryptedToken(enc)) {
            try {
              return JSON.parse(sjcl.decrypt("Token", enc));
            } catch (_) {
              return null;
            }
          }
          return enc;
        }

        var hasLiveToken = !!__tokenFromStorage__();

        if (
          hasLiveToken &&
          $location.path() !== "/block-page" &&
          $location.path() !== "/login/auth"
        ) {
          $sessionStorage.actualPage = $location.path();
          $localStorage.actualPage = $sessionStorage.actualPage; // <-- NUEVO (compartido entre pestañas)
        }

        if (value !== "#/login/auth" && value !== "" && hasLiveToken) {
          dataFactory.get("schedule/");
        }

        if (value !== "/login/auth") {
          $(document).ready(function () {
            $(document).on("focus", ":input", function () {
              $(this).attr("autocomplete", "off");
            });
            $(".js-example-basic-multiple").select2();
            $(window).scrollTop(0);
            if (
              !$localStorage.email_config &&
              value !== "#/login/auth" &&
              (value.length > 0 || value !== "")
            ) {
              dataFactory.get("orginfo/").then(function success(response) {
                if (response.data) {
                  if (response.data.results) {
                    if (response.data.results.length) {
                      $localStorage.email_config = response.data.results[0];
                    }
                  }
                }
              });
            }
            if ($sessionStorage && $sessionStorage.user) {
              var usr = window.safeDecrypt("User", $sessionStorage.user);
              // if(usr.urlname == "ts"){
              //   main.org_pruebas = true;
              // } else {
              //   main.org_pruebas = false;
              // }
            }
          });

          // ACTUAL -------------------------------------------------------------
          $(document).on("keyup", "input[type=text]", function (e) {
            // console.log('input text ---',$('input[type=text]'));
            $("input[type=text]").attr("style", "text-transform: uppercase");
            var exp = /\d\s\W/;
            if (
              $(this).val != exp &&
              e.keyCode != 37 &&
              e.keyCode != 38 &&
              e.keyCode != 39 &&
              e.keyCode != 40
            ) {
              $(this).val(function (_, val) {
                // console.log('val', val);
                return val.toUpperCase();
              });
            }
          });
        }
        //-- Stop PersistenceFactory in the change--//
        // if(PersistenceFactory.interval != ""){
        //   console.log('Apps - PersistenceFactory.interval: '+PersistenceFactory.interval)
        //   // clearInterval(PersistenceFactory.interval);
        //   PersistenceFactory.interval = '';
        //   PersistenceFactory.count = 0;
        // }
      }
    );
    // ----validación correo

    // ----validación correo
    //Modificado new tab buscador
    // [SYNC] Acepta token de session o de localStorage
    console.log("sesion", $sessionStorage);
    console.log("localStorage", $localStorage);
    var rawHash = $window.location.hash || "";
    var hasExplicitRoute =
      rawHash.length > 1 && rawHash !== "#/" && rawHash !== "#";
    var potentialToken = readStoredTokenCandidate();
    var hasLiveToken = tokenLooksUsable(potentialToken);
    // Sembrar última ruta desde localStorage si la pestaña no la tiene y no se solicitó una ruta específica
    if (
      hasLiveToken &&
      !hasExplicitRoute &&
      !$sessionStorage.actualPage &&
      $localStorage.actualPage &&
      $localStorage.actualPage !== "/block-page" &&
      $localStorage.actualPage !== "/login/auth"
    ) {
      $sessionStorage.actualPage = $localStorage.actualPage;
    }

    if (hasSession) {
      // calcula último destino válido
      var last = $sessionStorage.actualPage;
      var isValidLast =
        last && last !== "/block-page" && last !== "/login/auth";
      var target = isValidLast ? last : "/index/main";
      // console.log('[redirect]', { last: $sessionStorage.actualPage, target, current: $location.path() });

      if (!hasExplicitRoute) {
        // evita redirecciones dobles
        if ($location.path() !== target) {
          $location.path(target);
        }
      }

      // (opcional) tu uppercase
      jQuery("input")
        .off("keyup.saamUpper")
        .on("keyup.saamUpper", function () {
          $(this).val($(this).val().toUpperCase());
        });
    } else {
      console.log("Sin sesión activa, redirigiendo a login");
      forceLoginRedirect();
    }

    // Detecta si hay o no internet
    $rootScope.online = navigator.onLine;
    $window.addEventListener(
      "offline",
      function () {
        toaster.pop({
          type: "error",
          title: MESSAGES.ERROR.ERRORINTERNETCONNECTION,
          timeout: 0,
        });
        //toaster.error(MESSAGES.ERROR.ERRORINTERNETCONNECTION)
        $rootScope.$apply(function () {
          $rootScope.online = false;
        });
      },
      false
    );

    function ejecutar() {
      alert("-e-ee", $location);
      $location.replace();
      alert("-e-ee", $location);
    }

    $window.addEventListener(
      "online",
      function () {
        toaster.clear();
        toaster.success(MESSAGES.INFO.SUCCESSINTERNETCONNECTION);
        $rootScope.$apply(function () {
          $rootScope.online = true;
        });
      },
      false
    );

    // Idle timer
    // console.log('test', $location.path());
    if (!hasSession || $location.path() == "/login/auth") {
      Idle.unwatch();
    } else {
      Idle.watch();
    }

    function closeModals() {
      if ($rootScope.warning) {
        $rootScope.warning.close();
        $rootScope.warning = null;
      }
    }

    $rootScope.$on("IdleStart", function () {
      closeModals();

      $rootScope.warning = $uibModal.open({
        //jshint ignore:line
        templateUrl: "templates/modal-warning-lock.html",
        windowClass: "modal-danger",
      });

      //toaster.warning('Tu sesión expirará en 5 segundos.');
    });
    // [SYNC] Escucha inicios/cierres de sesión desde otras pestañas

    $window.addEventListener("storage", function (e) {
      if (e.key !== "saam_auth_event") return;

      if (!e.newValue) {
        return;
      }

      var payload;
      try {
        payload = JSON.parse(e.newValue);
      } catch (_) {
        payload = null;
      }

      if (payload && payload.type === "logout") {
        resetStoredSession();
        $rootScope.$applyAsync(function () {
          forceLoginRedirect({ clear: false });
        });

        return;
      }

      if (payload && payload.type === "login") {
        var incomingToken = normalizeTokenCandidate(payload.token);
        if (tokenLooksUsable(incomingToken)) {
          if (incomingToken) {
            $localStorage.token = incomingToken;
            $sessionStorage.token = incomingToken;
          }
          if (payload.user) {
            $localStorage.user = payload.user;
            $sessionStorage.user = payload.user;
          }
          if (payload.permisos) {
            $localStorage.permisos = payload.permisos;
            $sessionStorage.permisos = payload.permisos;
          }
          if (payload.infoUser) {
            $localStorage.infoUser = payload.infoUser;
            $sessionStorage.infoUser = payload.infoUser;
          }
          forcingLoginRedirect = false;

          $rootScope.$applyAsync();
        } else {
          resetStoredSession();
          $rootScope.$applyAsync(function () {
            forceLoginRedirect({ clear: false });
          });
        }

        return;
      }

      if (e.newValue === "logout") {
        resetStoredSession();
        $rootScope.$applyAsync(function () {
          forceLoginRedirect({ clear: false });
        });

        return;
      }

      if (e.newValue.indexOf("login:") === 0) {
        var enc = normalizeTokenCandidate(e.newValue.slice("login:".length));
        if (tokenLooksUsable(enc)) {
          $localStorage.token = enc;
          $sessionStorage.token = enc;
          $rootScope.$applyAsync();
        }
      }
    });

    $rootScope.$on("IdleEnd", function () {
      closeModals();
      //console.log('end');
    });

    $rootScope.$on("IdleTimeout", function () {
      closeModals();
      $state.go("block");
    });

    // ---- Idle timer end
  });

  // app.run(function(VersionService){})
  // ❌ NO hagas esto si solo quieres en login
  // app.run(function(VersionService){ VersionService.start(60000); });

  app.factory(
    "httpRequestInterceptor",
    function (
      $localStorage,
      $location,
      $q,
      $sessionStorage,
      url,
      SweetAlert,
      URLS_CONFIG,
      $window
    ) {
      function tokenFromStorage() {
        var enc =
          $sessionStorage.token ||
          $localStorage.token ||
          $localStorage.authToken;
        if (!enc) return null;
        try {
          // token cifrado con SJCL
          var decrypted = sjcl.decrypt("Token", enc);
          return JSON.parse(decrypted); // devuelve el JWT (string)
        } catch (e) {
          return enc; // token plano (legacy)
        }
      }

      function normalizeTokenValue(candidate) {
        if (!candidate) {
          return null;
        }

        if (typeof candidate === "string") {
          return candidate;
        }

        if (angular.isObject(candidate)) {
          if (candidate.token) {
            return candidate.token;
          }

          if (candidate.access || candidate.access_token) {
            return candidate.access || candidate.access_token;
          }
        }

        try {
          return candidate.toString();
        } catch (_) {
          return null;
        }
      }

      function describeTokenForLog(candidate) {
        var normalized = normalizeTokenValue(candidate);

        if (!normalized) {
          return {
            tokenPresent: false,
            tokenLength: 0,
            tokenSuffix: null,
          };
        }

        var suffixLength = normalized.length > 8 ? 8 : normalized.length;

        return {
          tokenPresent: true,
          tokenLength: normalized.length,
          tokenSuffix: normalized.slice(normalized.length - suffixLength),
        };
      }

      function logRequestDecision(context, details) {
        // try {
        //   console.log('[SAAM][httpRequestInterceptor] ' + context, details || {});
        // } catch (_) {
        //   // Evitamos romper el flujo si el log falla.
        // }
      }

      return {
        request: request,
        responseError: responseError,
      };

      function request(config) {
        if (!config.url) {
          config.url = "#";
        }

        var config_url = config.url;
        var normalizedConfigUrl = "";
        try {
          normalizedConfigUrl = config_url.toString().toLowerCase();
        } catch (_) {
          normalizedConfigUrl = "";
        }

        var bootstrapAuthFragments = [
          "/api-token-auth-saam/",
          "/api-token-refresh-saam/",
          "/api-token-verify-saam/",
          "/api-token-auth/",
        ];

        var isBootstrapAuthRequest = bootstrapAuthFragments.some(function (
          fragment
        ) {
          return normalizedConfigUrl.indexOf(fragment) !== -1;
        });

        if (isBootstrapAuthRequest) {
          logRequestDecision("bootstrap auth request", {
            url: config.url,
          });
          config.headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
          };
          if (config.headers.Authorization) {
            delete config.headers.Authorization;
          }
          if (config.headers.authorization) {
            delete config.headers.authorization;
          }
          return config;
        }

        var skipAuthFragments = ["/get-image-or/"];

        var shouldSkipAuth = skipAuthFragments.some(function (fragment) {
          return normalizedConfigUrl.indexOf(fragment) !== -1;
        });
        if (shouldSkipAuth) {
          logRequestDecision("skip auth for endpoint", {
            url: config.url,
          });
          config.headers = config.headers || {};
          config.headers["Content-Type"] = "application/json";
          config.headers["Accept"] = "application/json";

          if (config.headers.Authorization) {
            delete config.headers.Authorization;
          }
          if (config.headers.authorization) {
            delete config.headers.authorization;
          }

          return config;
        }

        if (config.url.endsWith("us-login")) {
          config.headers = {
            "Content-Type": "application/json",
            //'Accept': 'application/x-www-form-urlencoded'
          };
          var jwt = tokenFromStorage();
          var normalizedJwt = normalizeTokenValue(jwt);
          if (normalizedJwt && !config.url.includes("get-user-picture")) {
            config.headers.Authorization = "Bearer " + normalizedJwt;
            var tokenLog = describeTokenForLog(normalizedJwt);
            tokenLog.url = config.url;
            logRequestDecision("attached Authorization (us-login)", tokenLog);
          } else {
            logRequestDecision("Authorization omitido (us-login)", {
              url: config.url,
              reason: normalizedJwt ? "endpoint excluido" : "sin token",
            });
          }

          return config;
        } else {
          if (config_url.indexOf("org") == -1) {
            if (!config.url.endsWith("html")) {
              if (config.url.endsWith("&")) {
                if ($sessionStorage && $sessionStorage.user) {
                  var usr = window.safeDecrypt("User", $sessionStorage.user);
                  if (usr && usr.urlname) {
                    config.url =
                      config.url +
                      (config.url.indexOf("?") > -1 ? "&" : "?") +
                      "org=" +
                      usr.urlname;
                  }
                }
              } else if (config.url.endsWith("%")) {
                config.url = config.url.replace("%", "");
              } else if (!config.url.endsWith("token-auth/")) {
                try {
                  if ($sessionStorage && $sessionStorage.user) {
                    var usr = window.safeDecrypt("User", $sessionStorage.user);
                    config.url = config.url + "?org=" + usr.urlname;
                  }
                } catch (error) {
                  console.log("-error-token-auth/-", error);
                }
              }
            } else {
              config.headers = {
                "Content-Type": "application/json",
                Accept: "application/json",
              };
            }

            config.headers = {
              "Content-Type": "application/json",
              Accept: "application/json",
            };

            var jwt = tokenFromStorage();
            var normalizedJwt = normalizeTokenValue(jwt);
            if (normalizedJwt && !config.url.includes("get-user-picture")) {
              config.headers.Authorization = "Bearer " + normalizedJwt;
              var tokenLog = describeTokenForLog(normalizedJwt);
              tokenLog.url = config.url;
              logRequestDecision("attached Authorization (sin org)", tokenLog);
            } else {
              logRequestDecision("Authorization omitido (sin org)", {
                url: config.url,
                reason: normalizedJwt ? "endpoint excluido" : "sin token",
              });
            }
            // https://miurabox.atlassian.net/browse/DES-859
            if (
              config.data &&
              Object.prototype.toString.call(config.data) ===
                "[object FormData]"
            ) {
              delete config.headers["Content-Type"];
              config.transformRequest = angular.identity;
            }
            // https://miurabox.atlassian.net/browse/DES-859
            return config;
          } else {
            config.headers = {
              "Content-Type": "application/json",
              Accept: "application/json",
            };
            if ($sessionStorage && $sessionStorage.user) {
              var usr = window.safeDecrypt("User", $sessionStorage.user);
            }
            // ----------
            // if ($sessionStorage.user){
            //   var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
            //   var usr = JSON.parse(decryptedUser);
            // }
            // --------
            // ------ADD--- Excepción si existe org= no add config.url = config.url + '?org=' + usr.urlname; ----------
            var no_org = true;
            var exist_org_url = config_url.indexOf("org=") > -1;
            var exist_info = config_url.indexOf("orginfo") > -1;
            var exist_p = config_url.indexOf("?") > -1;
            if (exist_org_url == true) {
              config.url = config_url;
              no_org = false;
              var jwt = tokenFromStorage();
              var normalizedJwt = normalizeTokenValue(jwt);
              if (normalizedJwt && !config.url.includes("get-user-picture")) {
                config.headers.Authorization = "Bearer " + normalizedJwt;
                var tokenLog = describeTokenForLog(normalizedJwt);
                tokenLog.url = config.url;
                logRequestDecision(
                  "attached Authorization (org en url)",
                  tokenLog
                );
              } else {
                logRequestDecision("Authorization omitido (org en url)", {
                  url: config.url,
                  reason: normalizedJwt ? "endpoint excluido" : "sin token",
                });
              }
            } else if (no_org == false || exist_info == true) {
              if (exist_p == true) {
                config.url = config.url + "&org=" + usr.urlname;
              } else {
                config.url = config.url + "?org=" + usr.urlname;
              }
              var jwt = tokenFromStorage();
              var normalizedJwt = normalizeTokenValue(jwt);
              if (normalizedJwt && !config.url.includes("get-user-picture")) {
                config.headers.Authorization = "Bearer " + normalizedJwt;
                var tokenLog = describeTokenForLog(normalizedJwt);
                tokenLog.url = config.url;
                logRequestDecision(
                  "attached Authorization (org agregado)",
                  tokenLog
                );
              } else {
                logRequestDecision("Authorization omitido (org agregado)", {
                  url: config.url,
                  reason: normalizedJwt ? "endpoint excluido" : "sin token",
                });
              }
            }
            // ----------- Excepción si existe org= no add config.url = config.url + '?org=' + usr.urlname; x------------
            // ----------------Original----------------------
            // config.url = config.url + '?org=' + usr.urlname;
            // if ($sessionStorage.token !== undefined) {
            //   var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
            //   var token = JSON.parse(decryptedToken);
            //   config.headers.Authorization = 'Token ' + token;
            // }
            // ----------------Original x----------------------
            return config;
          }
        }
      }

      function responseError(response) {
        if (response.status === 403) {
          //SweetAlert.swal("El usuario no tiene permiso para realizar esta acción", "", "error");
        }
        if (shouldForceLogout(response)) {
          try {
            $window.localStorage.setItem(
              "saam_auth_event",
              JSON.stringify({ type: "logout", timestamp: Date.now() })
            );
          } catch (error) {
            console.warn(
              "No se pudo notificar el cierre de sesión forzado",
              error
            );
          }
          delete $localStorage.authToken;

          if (
            $window.saamSessionControl &&
            angular.isFunction($window.saamSessionControl.forceLoginRedirect)
          ) {
            $window.saamSessionControl.forceLoginRedirect();
          } else {
            delete $sessionStorage.token;
            delete $sessionStorage.user;
            delete $sessionStorage.permisos;
            delete $sessionStorage.infoUser;
            delete $sessionStorage.actualPage;
            delete $localStorage.token;
            delete $localStorage.user;
            delete $localStorage.permisos;
            delete $localStorage.infoUser;
            delete $localStorage.authToken;
            delete $localStorage.actualPage;
            $location.path("/login/auth");
          }
          return $q.reject(response);
        }
        if (
          response.status === 401 &&
          $window.saamSessionControl &&
          angular.isFunction($window.saamSessionControl.hasUsableSession) &&
          !$window.saamSessionControl.hasUsableSession()
        ) {
          try {
            console.log(
              "[SAAM] responseError -> 401 fallback sin sesión usable",
              {
                status: response.status,
                url:
                  response.config && response.config.url
                    ? response.config.url
                    : null,
              }
            );
          } catch (_) {
            // ignoramos errores de logging
          }
          if (
            $window.saamSessionControl &&
            angular.isFunction($window.saamSessionControl.forceLoginRedirect)
          ) {
            $window.saamSessionControl.forceLoginRedirect();
          } else {
            delete $sessionStorage.token;
            delete $sessionStorage.user;
            delete $sessionStorage.permisos;
            delete $sessionStorage.infoUser;
            delete $sessionStorage.actualPage;
            delete $localStorage.token;
            delete $localStorage.user;
            delete $localStorage.permisos;
            delete $localStorage.infoUser;
            delete $localStorage.authToken;
            delete $localStorage.actualPage;
            $location.path("/login/auth");
          }
          return $q.reject(response);
        }
        return $q.reject(response);
      }

      function shouldForceLogout(response) {
        if (!response || (response.status !== 401 && response.status !== 403)) {
          return false;
        }

        var requestUrl = "";
        if (response.config && response.config.url) {
          try {
            requestUrl = response.config.url.toString();
          } catch (_) {
            requestUrl = "";
          }
        }

        var normalizedRequestUrl = "";
        var hadAuthHeader = false;
        var requestBearerToken = null;
        var storedTokenValue = null;

        function normalizeTokenString(candidate) {
          if (!candidate) {
            return "";
          }

          if (angular.isObject(candidate)) {
            if (candidate.token) {
              try {
                return candidate.token.toString();
              } catch (_) {
                return "";
              }
            }

            try {
              return JSON.stringify(candidate);
            } catch (_) {
              return "";
            }
          }

          try {
            return candidate.toString();
          } catch (_) {
            return "";
          }
        }

        try {
          var storedTokenCandidate = tokenFromStorage();
          var normalizedStoredToken =
            normalizeTokenString(storedTokenCandidate);

          if (
            normalizedStoredToken &&
            typeof normalizedStoredToken === "string"
          ) {
            normalizedStoredToken = normalizedStoredToken.trim();

            if (
              normalizedStoredToken.charAt(0) === '"' &&
              normalizedStoredToken.charAt(normalizedStoredToken.length - 1) ===
                '"'
            ) {
              normalizedStoredToken = normalizedStoredToken.slice(1, -1);
            }

            var lowerStored = normalizedStoredToken.toLowerCase();
            if (lowerStored.indexOf("bearer ") === 0) {
              normalizedStoredToken = normalizedStoredToken
                .slice("bearer ".length)
                .trim();
            } else if (lowerStored.indexOf("token ") === 0) {
              normalizedStoredToken = normalizedStoredToken
                .slice("token ".length)
                .trim();
            }

            if (normalizedStoredToken) {
              storedTokenValue = normalizedStoredToken;
            }
          }
        } catch (_) {
          storedTokenValue = null;
        }

        try {
          var headerSource = response.config && response.config.headers;

          if (angular.isFunction(headerSource)) {
            try {
              headerSource = headerSource(response.config);
            } catch (_) {
              headerSource = headerSource();
            }
          }

          if (headerSource && typeof headerSource === "object") {
            Object.keys(headerSource).some(function (headerKey) {
              if (!headerKey) {
                return false;
              }

              var normalizedKey;

              try {
                normalizedKey = headerKey.toString().toLowerCase();
              } catch (_) {
                normalizedKey = headerKey;
              }

              if (
                normalizedKey === "authorization" &&
                headerSource[headerKey]
              ) {
                hadAuthHeader = true;

                try {
                  var rawHeader = headerSource[headerKey].toString().trim();
                  var lowerHeader = rawHeader.toLowerCase();

                  if (lowerHeader.indexOf("bearer ") === 0) {
                    requestBearerToken = rawHeader
                      .slice("bearer ".length)
                      .trim();
                  } else if (lowerHeader.indexOf("token ") === 0) {
                    requestBearerToken = rawHeader
                      .slice("token ".length)
                      .trim();
                  }
                } catch (_) {
                  requestBearerToken = null;
                }

                return true;
              }

              return false;
            });
          }
        } catch (_) {
          hadAuthHeader = false;
          requestBearerToken = null;
        }

        if (
          requestBearerToken &&
          storedTokenValue &&
          requestBearerToken !== storedTokenValue
        ) {
          try {
            console.log(
              "[SAAM] shouldForceLogout -> skipped (auth header desincronizado)",
              {
                status: response.status,
                url: requestUrl || null,
                headerTokenLength: requestBearerToken
                  ? requestBearerToken.length
                  : 0,
                storedTokenLength: storedTokenValue
                  ? storedTokenValue.length
                  : 0,
                headerTokenSuffix: requestBearerToken
                  ? requestBearerToken.slice(-6)
                  : null,
                storedTokenSuffix: storedTokenValue
                  ? storedTokenValue.slice(-6)
                  : null,
              }
            );
          } catch (_) {
            // ignoramos errores de logging para no afectar el flujo principal
          }

          return false;
        }

        if (requestUrl) {
          try {
            normalizedRequestUrl = requestUrl.toLowerCase();
          } catch (_) {
            normalizedRequestUrl = "";
          }

          if (normalizedRequestUrl) {
            var alwaysIgnoreFragments = ["/get-image-or/"];

            var matchesAlwaysIgnored = alwaysIgnoreFragments.some(function (
              fragment
            ) {
              return normalizedRequestUrl.indexOf(fragment) !== -1;
            });

            if (matchesAlwaysIgnored) {
              try {
                console.log(
                  "[SAAM] shouldForceLogout -> skipped (get-image-or endpoint)",
                  {
                    status: response.status,
                    url: requestUrl || null,
                  }
                );
              } catch (_) {
                // Evitamos romper el flujo si el log falla.
              }
              return false;
            }

            var ignoreFragmentsAnyStatus = [
              "/notifications-count",
              "/notifications-test",
              "/mis-registros-automaticos",
              "/get-carousel-from-cas/",
              "/get-birthdays/",
              "/schedule",
              "/filtros-subramos-dash/",
              "/get_user_by_username/",
              "/count-receipts",
              "/v1/configurations/states/",
            ];

            var matchesAnyStatusIgnored = ignoreFragmentsAnyStatus.some(
              function (fragment) {
                return normalizedRequestUrl.indexOf(fragment) !== -1;
              }
            );

            if (matchesAnyStatusIgnored) {
              var hasStoredToken = !!(
                ($sessionStorage && $sessionStorage.token) ||
                ($localStorage &&
                  ($localStorage.token || $localStorage.authToken))
              );
              var isCarouselEndpoint =
                normalizedRequestUrl.indexOf("/get-carousel-from-cas/") !== -1;

              if (response.status === 403 && !isCarouselEndpoint) {
                try {
                  console.log(
                    "[SAAM] shouldForceLogout -> skipped (known endpoint 403)",
                    {
                      status: response.status,
                      url: requestUrl || null,
                      hadAuthHeader: hadAuthHeader,
                      hasStoredToken: hasStoredToken,
                    }
                  );
                } catch (_) {
                  // Ignoramos fallos de logging para no romper el flujo.
                }
                return false;
              }

              if (response.status === 403 && isCarouselEndpoint) {
                try {
                  console.log(
                    "[SAAM] shouldForceLogout -> skipped (carousel endpoint 403)",
                    {
                      status: response.status,
                      url: requestUrl || null,
                      hadAuthHeader: hadAuthHeader,
                      hasStoredToken: hasStoredToken,
                    }
                  );
                } catch (_) {
                  // Ignoramos fallos de logging para no romper el flujo.
                }
                return false;
              }

              if (
                response.status === 401 &&
                (hadAuthHeader || hasStoredToken)
              ) {
                // Se intentó autenticar la petición; continuar evaluando el cierre de sesión forzado.
              } else {
                try {
                  console.log(
                    "[SAAM] shouldForceLogout -> skipped (known endpoint sin credenciales activas)",
                    {
                      status: response.status,
                      url: requestUrl || null,
                      hadAuthHeader: hadAuthHeader,
                      hasStoredToken: hasStoredToken,
                    }
                  );
                } catch (_) {
                  // Evitamos romper el flujo si el log falla.
                }
                return false;
              }
            }

            if (response.status === 403) {
              var ignoreFragmentsWithOrgValidation = [
                "/orginfo/",
                "/get-carousel-from-cas/",
              ];

              var matchesConditionalIgnored =
                ignoreFragmentsWithOrgValidation.some(function (fragment) {
                  return normalizedRequestUrl.indexOf(fragment) !== -1;
                });

              if (matchesConditionalIgnored) {
                var orgParamMatch =
                  normalizedRequestUrl.match(/[?&]org=([^&#]*)/);
                var orgParamValue =
                  orgParamMatch && orgParamMatch[1]
                    ? decodeURIComponent(orgParamMatch[1])
                    : "";

                if (
                  !orgParamValue ||
                  orgParamValue === "undefined" ||
                  orgParamValue === "null"
                ) {
                  try {
                    console.log(
                      "[SAAM] shouldForceLogout -> skipped (invalid org parameter)",
                      {
                        status: response.status,
                        url: requestUrl || null,
                        org: orgParamValue || null,
                      }
                    );
                  } catch (_) {
                    // Evitamos romper el flujo si el log falla.
                  }
                  return false;
                }
              }
            }
          }
        }

        var data = response.data || {};
        var detailMessage = "";
        var errorCode = "";

        if (angular.isObject(data) && data.detail) {
          detailMessage = data.detail;
        } else if (angular.isString(data)) {
          detailMessage = data;
        }

        if (angular.isObject(data) && data.code) {
          errorCode = data.code;
        }

        var normalizedMessage = "";
        if (detailMessage) {
          try {
            normalizedMessage = detailMessage.toString().toLowerCase();
          } catch (_) {
            normalizedMessage = "";
          }
        }

        var normalizedCode = "";
        if (errorCode) {
          try {
            normalizedCode = errorCode.toString().toLowerCase();
          } catch (_) {
            normalizedCode = "";
          }
        }

        var logoutReason = "";
        var tokenErrorCodes = [
          "token_not_valid",
          "token_invalid",
          "token_expired",
        ];
        if (normalizedCode && tokenErrorCodes.indexOf(normalizedCode) !== -1) {
          logoutReason =
            "response.code indica token inválido o expirado (" +
            normalizedCode +
            ")";
        }

        if (!logoutReason && normalizedMessage) {
          var missingCredentialsFragments = [
            "credenciales de autenticaci",
            "authentication credentials were not provided",
          ];

          var mentionsMissingCredentials = missingCredentialsFragments.some(
            function (fragment) {
              return normalizedMessage.indexOf(fragment) !== -1;
            }
          );

          if (mentionsMissingCredentials) {
            logoutReason =
              "El detalle indica que faltan credenciales de autenticación";
          }
        }

        if (!logoutReason && normalizedMessage) {
          var mentionsToken = normalizedMessage.indexOf("token") !== -1;

          if (mentionsToken) {
            var tokenInvalidFragments = ["expir", "inval", "invál", "vencid"];
            var matchesInvalid = tokenInvalidFragments.some(function (
              fragment
            ) {
              return normalizedMessage.indexOf(fragment) !== -1;
            });

            if (matchesInvalid) {
              logoutReason =
                "El detalle menciona que el token está expirado o es inválido";
            }
          }
        }

        if (!logoutReason && response.status === 401) {
          if (
            $window.saamSessionControl &&
            angular.isFunction($window.saamSessionControl.hasUsableSession)
          ) {
            if (!$window.saamSessionControl.hasUsableSession()) {
              logoutReason =
                "saamSessionControl.hasUsableSession() devolvió false tras un 401";
            }
          } else {
            var storedCandidate =
              $sessionStorage.token ||
              $localStorage.token ||
              $localStorage.authToken;
            if (!storedCandidate) {
              logoutReason = "No existe token almacenado tras recibir un 401";
            } else {
              if (angular.isObject(storedCandidate)) {
                try {
                  storedCandidate = JSON.stringify(storedCandidate);
                } catch (_) {
                  storedCandidate = "";
                }
              }

              if (typeof storedCandidate !== "string") {
                storedCandidate = "";
              }

              var trimmedCandidate = storedCandidate.trim();
              if (
                !trimmedCandidate ||
                trimmedCandidate === "null" ||
                trimmedCandidate === "undefined"
              ) {
                logoutReason =
                  "El token almacenado está vacío o es inválido tras un 401";
              }
            }
          }
        }

        if (!logoutReason && response.status === 401) {
          logoutReason = "Se recibió un 401 sin más contexto";
        }

        if (logoutReason) {
          try {
            console.log("[SAAM] shouldForceLogout -> true", {
              status: response.status,
              url: requestUrl || null,
              reason: logoutReason,
              code: errorCode || null,
              detail: detailMessage || null,
            });
          } catch (logError) {
            // Evitamos romper el flujo si el log falla.
          }
          return true;
        }

        return false;
      }
    }
  );
  // Configuración de Idle
  // $(window).load(function() {
  // $('.js-example-basic-multiple').select2();
  // });
  // angular.element(document).ready(function(){
  //   $('.js-example-basic-multiple').select2();
  // });
  app.config(function (IdleProvider, KeepaliveProvider) {
    IdleProvider.idle(1800); // tiempo para que se valide la notificación warning
    IdleProvider.timeout(60); // despues de notificación, tiempo para reactivar la sesión (segundos)
    KeepaliveProvider.interval(10);
  });
  app.config(function ($httpProvider) {
    $httpProvider.interceptors.push("httpRequestInterceptor");
    $httpProvider.defaults.headers.patch = {
      "Content-Type": "application/json",
    };
    // $httpProvider.defaults.headers.post = {};
  });
  app.config(function (uiSelectConfig) {
    uiSelectConfig.theme = "bootstrap";
    uiSelectConfig.resetSearchInput = true;
    uiSelectConfig.appendToBody = true;
  });

  // app.run(function($rootScope, $localStorage, $state, $stateParams, appStates,$location, url) {
  //     $rootScope.$on("$locationChangeSuccess", function(event, next, current) {
  //       if($location.$$path == '/login/auth'){
  //         $location.$$path = url.IP + appStates.states[appStates.states.length-1].route;
  //       }
  //       setTimeout( function () {
  //         var paramApp = appStates.states[$localStorage.tab_index] ? appStates.states[$localStorage.tab_index].params : '';
  //         var state = appStates.estados($state.current.name, $location.$$absUrl, paramApp);
  //         if (state){
  //           appStates.states[$localStorage.tab_index] = state;
  //           $localStorage.tab_states = appStates.states;
  //         }else{
  //           $localStorage.tab_states = [];
  //         }
  //       }, 500);
  //     });
  // });

  app.run(function (
    $rootScope,
    $localStorage,
    $state,
    $stateParams,
    appStates,
    $location,
    url
  ) {
    $rootScope.$on("$locationChangeSuccess", function (event, next, current) {
      if ($localStorage.infoUser && $location.$$path == "/login/auth") {
        $location.$$path =
          url.IP + appStates.states[appStates.states.length - 1].route;
      }
      setTimeout(function () {
        var paramApp = appStates.states[$localStorage.tab_index]
          ? appStates.states[$localStorage.tab_index].params
          : "";
        var state = appStates.estados(
          $state.current.name,
          $location.$$absUrl,
          paramApp
        );
        if (state) {
          appStates.states[$localStorage.tab_index] = state;
          $localStorage.tab_states = appStates.states;

          /* Saving the last state visited in the local storage. */
          // $localStorage['last_state_visited'] = appStates.getActualTab();
        }
      }, 500);
    });
  });
  app.run(function ($rootScope, NotificationService) {
    NotificationService.getNotifications();
  });
  app.config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state("testing", {
        abstract: true,
        url: "/testing",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("testing.testing", {
        url: "/",
        templateUrl: "app/testing/testing.html",
        controller: "TestingCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Testing" },
      })
      .state("login", {
        abstract: true,
        url: "/login",
        templateUrl: "app/login/login.html",
      })
      .state("login.login", {
        url: "/auth",
        templateUrl: "app/login/login.auth.html",
        controller: "LoginCtrl",
        controllerAs: "vm",
      })
      .state("inicio", {
        abstract: true,
        url: "/inicio",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("inicio.inicio", {
        url: "/",
        templateUrl: "app/inicio/inicio.html",
        controller: "InicioCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Inicio" },
      })
      .state("index", {
        abstract: true,
        url: "/index",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("index.main", {
        url: "/main",
        views: {
          "": {
            templateUrl: "app/main/main.html",
          },
          "cobranza@index.main": {
            templateUrl: "app/charts/cobranzas.chart.html",
            controller: "CobranzaChartCtrl",
          },
          "renovaciones@index.main": {
            templateUrl: "app/charts/renovaciones.chart.html",
            controller: "RenovacionChartCtrl",
          },
          "endosos@index.main": {
            templateUrl: "app/charts/endosos.chart.html",
            controller: "EndosoChartCtrl",
          },
          "buttons@index.main": {
            templateUrl: "app/modals/modal.ot-creator.html",
            controller: "ButtonsCtrl",
          },
        },
      })
      .state("index.minor", {
        url: "/minor",
        templateUrl: "app/minor/minor.html",
        data: { pageTitle: "Example view" },
      })
      .state("block", {
        url: "/block-page",
        templateUrl: "app/block-page/block-page.html",
        controller: "BlockCtrl",
        data: { pageTitle: "BlockPage" },
      })
      .state("contratantes", {
        abstract: true,
        url: "/contratantes",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("contratantes.main", {
        url: "/list",
        templateUrl: "app/contratantes/contratantes.list.html",
        data: { pageTitle: "Contratantes" },
        controller: "ContratantesCtrl",
        controllerAs: "vm",
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
        },
      })
      .state("contratantes.create", {
        url: "/crear",
        templateUrl: "app/contratantes/contratantes.html",
        data: { pageTitle: "Contratantes" },
        controller: "ContratantesCtrl",
        controllerAs: "vm",
      })
      .state("contratantes.list", {
        url: "/lista",
        templateUrl: "app/contratantes/contratantes.list.html",
        data: { pageTitle: "ContratantesList" },
        controller: "ContratantesCtrl",
        controllerAs: "vm",
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
        },
      })
      .state("contratantes.info", {
        url: "/:type/:contratanteId/",
        templateUrl: "app/contratantes/contratantes.info.html",
        data: { pageTitle: "Contratantes" },
        controller: "ContratantesEditCtrl",
        controllerAs: "vm",
      })
      .state("contratantes.edit", {
        url: "/:type/editar/:contratanteId/",
        templateUrl: "app/contratantes/contratantes.edit.html",
        data: { pageTitle: "Contratantes" },
        controller: "ContratantesEditCtrl",
        controllerAs: "vm",
      })
      .state("ibis", {
        abstract: true,
        url: "/ibis",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("sucursal", {
        abstract: true,
        url: "/Sucursales",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("ibis.usuarios", {
        url: "/usuarios",
        templateUrl: "app/ibis/ibis.principal.html",
        data: { pageTitle: "IBIS" },
        controller: "IBISController",
        controllerAs: "vm",
      })
      .state("ibis.formatos", {
        url: "/formatos",
        templateUrl: "app/ibis/ibis.formatos.html",
        data: { pageTitle: "IBIS" },
        controller: "IBISController",
        controllerAs: "vm",
      })
      .state("ibis.formatosPlantillasWhatsappSiniestros", {
        url: "/formatos/plantillas-siniestros-whatsapp",
        templateUrl: "app/ibis/ibis.formatos.whatsapp-siniestros.html",
        controller: "IbisFormatosPlantillasSiniestrosCtrl",
        controllerAs: "vm",
        data: {
          pageTitle: "Plantillas para Compartir Siniestros por WhatsApp Web",
        },
      })
      .state("ibis.directorio", {
        url: "/directorio",
        templateUrl: "app/ibis/ibis.directorio.html",
        data: { pageTitle: "IBIS" },
        controller: "IBISController",
        controllerAs: "vm",
      })
      .state("ibis.red", {
        url: "/red",
        templateUrl: "app/ibis/ibis.red.html",
        data: { pageTitle: "IBIS" },
        controller: "IBISController",
        controllerAs: "vm",
      })
      .state("filtro", {
        abstract: true,
        url: "/filtros",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("filtro.filtro", {
        url: "/asignar",
        templateUrl: "app/filtros/filtro.html",
        controller: "filterController",
        controllerAs: "vm",
      })
      .state("filtro.shared", {
        url: "/ccompartir",
        templateUrl: "app/filtros/filtro.compartir.html",
        controller: "filterSharedController",
        controllerAs: "vm",
      })
      .state("filtro.lista", {
        url: "/lista",
        templateUrl: "app/filtros/filtro.lista.html",
        controller: "filterListController",
        controllerAs: "vm",
      })
      .state("reportes", {
        abstract: true,
        url: "/reportes",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("reportes.cobranza", {
        url: "/cobranza",
        templateUrl: "app/reportes/reporte.cobranza.html",
        data: { pageTitle: "Reporte Cobranza" },
        controller: "ReporteCobrazaController",
        controllerAs: "vm",
      })
      .state("reportes.cobranzafianzas", {
        url: "/cobranzafianzas",
        templateUrl: "app/reportes/reporte.cobranzafianzas.html",
        data: { pageTitle: "Reporte Cobranza Fianzas" },
        controller: "ReporteCobrazaFianzasController",
        controllerAs: "vm",
      })
      .state("reportes.auditoria", {
        url: "/auditoria",
        templateUrl: "app/reportes/reporte.auditoria.html",
        data: { pageTitle: "Reporte Auditoria" },
        controller: "ReporteAuditoriaController",
        controllerAs: "vm",
      })
      .state("task", {
        abstract: true,
        url: "/tareas",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("task.task", {
        url: "/",
        templateUrl: "app/tasks/task.html",
        data: { pageTitle: "Tareas" },
        controller: "TareasCtrl",
        params: { id_task: 0, main_comming: false },
        controllerAs: "vm",
      })
      .state("task.admin", {
        url: "/administrador",
        templateUrl: "app/tasks/task.admin.html",
        data: { pageTitle: "Tareas" },
        controller: "TareasAdminCtrl",
        controllerAs: "vm",
      })
      .state("reportes.renovaciones", {
        url: "/renovaciones",
        templateUrl: "app/reportes/reporte.renovaciones.html",
        data: { pageTitle: "Reporte Renovaciones" },
        controller: "ReporteRenovacionesController",
        controllerAs: "vm",
      })
      .state("reportes.endosos", {
        url: "/endosos",
        templateUrl: "app/reportes/reporte.endosos.html",
        data: { pageTitle: "Reporte Endosos" },
        controller: "ReporteEndososController",
        controllerAs: "vm",
      })
      .state("reportes.polizas", {
        url: "/polizas",
        templateUrl: "app/reportes/reporte.polizas.html",
        data: { pageTitle: "Reporte Pólizas" },
        controller: "ReportePolizasController",
        controllerAs: "vm",
      })
      .state("reportes.polizas_contributorias", {
        url: "/polizascontributorias",
        templateUrl: "app/reportes/reporte.polizascontributorias.html",
        data: { pageTitle: "Reporte Pólizas Contributorias" },
        controller: "ReportePolizasContributoriasController",
        controllerAs: "vm",
      })
      .state("reportes.siniestros", {
        url: "/siniestros",
        templateUrl: "app/reportes/reporte.siniestros.html",
        data: { pageTitle: "Reporte Siniestros" },
        controller: "ReporteSiniestrosController",
        controllerAs: "vm",
      })
      .state("reportes.fianzas", {
        url: "/fianzas",
        templateUrl: "app/reportes/reporte.fianzas.html",
        data: { pageTitle: "Reporte Fianzas" },
        controller: "ReporteFianzasController",
        controllerAs: "vm",
      })
      .state("reportes.fianzas_ben", {
        url: "/fianzas/beneficiarios",
        templateUrl: "app/reportes/reporte.fianzasben.html",
        data: { pageTitle: "Reporte Fianzas Beneficiarios" },
        controller: "ReporteFianzasBenController",
        controllerAs: "vm",
      })
      .state("reportes.log", {
        url: "/log",
        templateUrl: "app/reportes/reporte.log.html",
        data: { pageTitle: "Reporte Log" },
        controller: "ReporteLogController",
        controllerAs: "vm",
      })
      .state("reportes.cumple", {
        url: "/cumple",
        templateUrl: "app/reportes/reporte.cumple.html",
        data: { pageTitle: "Reporte Cumpleaños de la Semana" },
        controller: "ReporteCumpleaniosController",
        controllerAs: "vm",
      })
      .state("reportes.task", {
        url: "/tareas",
        templateUrl: "app/reportes/reporte.task.html",
        data: { pageTitle: "Reporte Tareas" },
        controller: "ReporteTaskController",
        controllerAs: "vm",
      })
      .state("reportes.certificates", {
        url: "/certificados",
        templateUrl: "app/reportes/reporte.certificados.html",
        data: { pageTitle: "Reporte Certificados" },
        controller: "ReporteCertificadosController",
        controllerAs: "vm",
      })
      .state("reportes.edoclientes", {
        url: "/edoclientes",
        templateUrl: "app/reportes/reporte.edoclientes.html",
        data: { pageTitle: "Reporte Edo. de Clientes" },
        controller: "ReporteEdoClientesController",
        controllerAs: "vm",
      })
      .state("reportes.ventacruzada", {
        url: "/venta-cruzada",
        templateUrl: "app/reportes/reporte.ventacruzada.html",
        data: { pageTitle: "Reporte Venta Cruzada" },
        controller: "VentaCruzadaController",
        controllerAs: "vm",
      })
      .state("reportes.cobranza_liq", {
        url: "/cobranzaLiquidaciones",
        templateUrl: "app/reportes/reporte.cobranza_liq.html",
        data: { pageTitle: "Reporte Cobranza Liquidaciones" },
        controller: "ReporteCobrazaLiqController",
        controllerAs: "vm",
      })
      .state("reportes.cobranza_subsec", {
        url: "/cobranzaSubsecuentes",
        templateUrl: "app/reportes/reporte.cobranzas_subsec.html",
        data: { pageTitle: "Reporte recibos subsecuentes" },
        controller: "ReporteCobranzaSubsecController",
        controllerAs: "vm",
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          valueReceipt: function () {
            return {};
          },
        },
      })
      .state("reportes.cobranzapendiente", {
        url: "/cobranzapendiente",
        templateUrl: "app/reportes/reporte.cobranzapendiente.html",
        data: { pageTitle: "Reporte Cobranza Pendiente" },
        controller: "ReporteCobranzaPendienteController",
        controllerAs: "vm",
      })
      .state("reportes.cotizaciones", {
        url: "/cotizaciones",
        templateUrl: "app/reportes/reporte.cotizaciones.html",
        data: { pageTitle: "Reporte Cotizaciones" },
        controller: "ReporteCotizacionesController",
        controllerAs: "vm",
      })
      .state("reportes.renovacionespendientes", {
        url: "/renovacionesPendientes",
        templateUrl: "app/reportes/reporte.renovacionespendientes.html",
        data: { pageTitle: "Reporte Renovaciones Pendientes" },
        controller: "ReporteRenovacionesPendientesController",
        controllerAs: "vm",
      })

      .state("reportes.polizasTitularesConyuges", {
        url: "/polizasTitularesConyuges",
        templateUrl: "app/reportes/reporte.polizasGastosMedicos.html",
        data: { pageTitle: "Reporte Titulares y Cónyuges" },
        controller: "ReportePolizasGastosMedicosController",
        controllerAs: "vm",
      })

      .state("reportes.otsendosos", {
        url: "/OtsEndosos",
        templateUrl: "app/reportes/reporte.otsendosos.html",
        data: { pageTitle: "Reporte OTs/Endosos" },
        controller: "ReporteOTEndosoController",
        controllerAs: "vm",
      })
      .state("agenda", {
        abstract: true,
        url: "/agenda",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("agenda.agenda", {
        url: "/",
        templateUrl: "app/agenda/agenda.html",
        data: { pageTitle: "Agenda" },
        controller: "AgendaCtrl",
        controllerAs: "vm",
      })
      .state("cotizacion", {
        abstract: true,
        url: "/cotizacion",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("cotizacion.cotizacion", {
        url: "/",
        templateUrl: "app/cotizacion/cotizacion.html",
        params: {
          myContractor: "some default",
        },
        data: { pageTitle: "Cotizacion" },
        controller: "cotizacionController",
        controllerAs: "vm",
      })
      .state("cotizacion.info", {
        url: "/:polizaId",
        templateUrl: "app/cotizacion/cotizacion.html",
        data: { pageTitle: "Cotizacion Información" },
        controller: "cotizacionController",
        controllerAs: "vm",
      })
      .state("operacion", {
        abstract: true,
        url: "/operacion",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("operacion.semanal", {
        url: "/",
        templateUrl: "app/operacion/reporte.operacion.html",
        data: { pageTitle: "Repporte Operación" },
        controller: "ReporteOperacionController",
        controllerAs: "vm",
      })
      .state("reportes.conservacion", {
        url: "/conservacion",
        templateUrl: "app/reportes/estadistica/reporte.conservacion.html",
        data: { pageTitle: "Reporte conservación" },
        controller: "ReporteEstConservacionController",
        controllerAs: "vm",
      })
      .state("notificaciones", {
        abstract: true,
        url: "/notificaciones",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("notificaciones.main", {
        url: "/",
        templateUrl: "app/notificaciones/notificaciones.html",
        data: { pageTitle: "Notificaciones" },
        controller: "notificacionesCtrl",
        controllerAs: "vm",
      })
      .state("notificaciones.listado", {
        url: "/listado",
        templateUrl: "app/notificaciones/notificaciones.listado.html",
        data: { pageTitle: "Notificaciones" },
        controller: "notificacionListadoCtrl",
        controllerAs: "vm",
      })
      .state("mensajeria", {
        abstract: true,
        url: "/mensajeria",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("mensajeria.principal", {
        url: "/",
        templateUrl: "app/mensajeria/mensajeria.html",
        data: { pageTitle: "Mensajeria" },
        controller: "MensajeriaCtrl",
        controllerAs: "vm",
      })
      .state("kbi", {
        abstract: true,
        url: "/kbi",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("kbi.principal", {
        url: "/",
        templateUrl: "app/kbi/kbi.html",
        controller: "kbicontrolCtrl",
        controllerAs: "vm",
        data: { pageTitle: "KBI" },
      })
      .state("sucursal.config", {
        url: "/sucursales",
        templateUrl: "app/sucursales/sucursal.html",
        data: { pageTitle: "Sucursales" },
        controller: "ScrslController",
        controllerAs: "vm",
      })
      .state("colectividades", {
        abstract: true,
        url: "/colectividades",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("colectividades.plantillas", {
        url: "plantillas-certificados",
        templateUrl: "app/colectivos/certificados.plantillas.html",
        controller: "CertificadosPlantillasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "colectivosPlantillas" },
      })
      .state("colectividades.main", {
        url: "/",
        templateUrl: "app/colectivos/colectivos.html",
        data: { pageTitle: "Colectividades" },
        controller: "ColectivosCtrl",
        controllerAs: "order",
        params: {
          myInsurance: "some default",
        },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
        },
      })
      .state("colectividades.table", {
        url: "/colectividades-tabla",
        templateUrl: "app/colectividades/colectividades.table.html",
        data: { pageTitle: "ListColectividades" },
        controller: "ColectividadesTableCtrl",
        // controllerAs: 'order',
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
        },
      })
      .state("colectividades.info", {
        url: "/:polizaId",
        templateUrl: "app/colectivos/colectivos.info.html",
        controller: "ColectivosInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Colectividades" },
      })
      .state("colectividades.masivos", {
        url: "/subir-archivos/masivos",
        templateUrl: "app/colectividades/colectividades.subir-masivos.html",
        data: { pageTitle: "SubirMasivos" },
        controller: "SubirMasivosCtrl",
        controllerAs: "foo",
      })
      .state("colectividades.edit", {
        url: "/editar/:polizaId",
        templateUrl: "app/colectivos/colectivos.edit.html",
        controller: "ColectivosEditCtrl",
        controllerAs: "order",
        data: { pageTitle: "EditColectividades" },
      })
      .state("colectividades.convertirPoliza", {
        url: "/:polizaId/:status/convertir",
        templateUrl: "app/colectividades/colectividades.edit.html",
        controller: "ColectividadesEditCtrl",
        data: { pageTitle: "ColectividadesToPoliza" },
      })
      .state("colectividades.renewal", {
        url: "/renovaciones/:polizaId/",
        templateUrl: "app/colectivos/colectivos.renewal.html",
        controller: "ColectivosRenewalCtrl",
        controllerAs: "order",
        data: { pageTitle: "RenewalColectividades" },
      })
      .state("flotillas", {
        abstract: true,
        url: "/flotillas",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("flotillas.flotillas", {
        url: "/",
        templateUrl: "app/flotillas/flotillas.html",
        controller: "FlotillasCtrl",
        controllerAs: "order",
        params: {
          dataContractor: "some default",
          message: "some default",
        },
        data: { pageTitle: "Flotillas" },
      })
      .state("flotillas.info", {
        url: "/:polizaId",
        templateUrl: "app/flotillas/flotillas.info.html",
        controller: "FlotillasInfoCtrl",
        controllerAs: "order",
        params: {
          dataContractor: "some default",
          message: "some default",
        },
        data: { pageTitle: "FlotillasInfo" },
      })
      .state("flotillas.edit", {
        url: "/editar/:polizaId",
        templateUrl: "app/flotillas/flotillas.edit.html",
        controller: "FlotillasEditCtrl",
        controllerAs: "order",
        data: { pageTitle: "FlotillasEdit" },
      })
      .state("flotillas.renewal", {
        url: "/renewal/:polizaId",
        templateUrl: "app/flotillas/flotillas.renewal.html",
        controller: "FlotillasRenewalCtrl",
        controllerAs: "order",
        data: { pageTitle: "FlotillasRenewal" },
      })
      .state("grupos", {
        abstract: true,
        url: "/grupos",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("grupos.grupos", {
        url: "/",
        templateUrl: "app/grupos/grupos.html",
        controller: "GrupoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Grupos" },
      })
      .state("grupos.edit", {
        url: "/editar/:grupoId",
        templateUrl: "app/grupos/grupos.edit.html",
        controller: "GrupoEditCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Grupos" },
      })
      .state("grupos.info", {
        url: "/informacion/:grupoId",
        templateUrl: "app/grupos/grupos.info.html",
        controller: "GrupoInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Grupos" },
      })
      .state("clasificacion", {
        abstract: true,
        url: "/clasificacion",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("clasificacion.clasificacion", {
        url: "/",
        templateUrl: "app/clasificacion/clasificacion.html",
        controller: "clasificacionController",
        controllerAs: "vm",
        data: { pageTitle: "Clasificacion" },
      })
      .state("celulacontractor", {
        abstract: true,
        url: "/celulacontractor",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("celulacontractor.celulacontractor", {
        url: "/",
        templateUrl: "app/contratantes/celulacontractor.html",
        controller: "celulacontractorController",
        controllerAs: "vm",
        data: { pageTitle: "Célula de Contratante" },
      })
      .state("aseguradoras", {
        abstract: true,
        url: "/aseguradoras",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("aseguradoras.aseguradoras", {
        url: "/",
        templateUrl: "app/aseguradoras/aseguradoras.html",
        controller: "AseguradorasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Aseguradoras" },
      })
      .state("aseguradoras.edit", {
        url: "/:aseguradoraId",
        templateUrl: "app/aseguradoras/aseguradoras.edit.html",
        controller: "AseguradorasEditCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Aseguradoras" },
      })
      .state("aseguradoras.info", {
        url: "/info/:aseguradoraId",
        templateUrl: "app/aseguradoras/aseguradoras.info.html",
        controller: "AseguradorasInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Aseguradoras" },
      })
      .state("aseguradoras.ramos", {
        url: "/:aseguradoraId/ramos",
        templateUrl: "app/aseguradoras/aseguradoras.config.html",
        controller: "AseguradorasConfigCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Aseguradoras" },
      })
      .state("aseguradoras.subramos", {
        url: "/:aseguradoraId/ramos/:ramosId/subramos",
        templateUrl: "app/aseguradoras/aseguradoras.subramos.html",
        controller: "AseguradorasSubramoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Aseguradoras" },
      })
      .state("fianzas", {
        abstract: true,
        url: "/fianzas",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("reclamacion", {
        abstract: true,
        url: "/fianzas/reclamaciones",
        templateUrl: "app/components/common/content.html",
      })
      .state("fianzas.fianzas", {
        url: "/",
        templateUrl: "app/fianzas/fianzas.html",
        controller: "FianzasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "fianzas" },
        // params: {
        //   myInsurance: 'some default'
        // }
        params: {
          myInsurance: "some default",
        },
        //data: { pageTitle: 'Fianzas' },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
        },
      })
      .state("fianzas.reclist", {
        url: "/reclamaciones/list",
        templateUrl: "app/fianzas/reclamaciones.list.html",
        controller: "FianzasReclamacionesListCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Fianzas" },
      })
      .state("fianzas.reclinf", {
        url: "/reclamaciones/info/:claimId",
        templateUrl: "app/fianzas/reclamaciones.info.html",
        controller: "FianzasReclamacionesInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Fianzas" },
      })
      .state("fianzas.colectividades", {
        url: "/colectividades",
        templateUrl: "app/fianzaGpo/fianza.gpo.ordenes.html",
        controller: "FianzasColectividadesCtrl",
        controllerAs: "order",
        data: { pageTitle: "Fianzas" },
        params: {
          myInsurance: "some default",
        },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
        },
      })
      .state("fianzas.edit", {
        url: "/colectividades/editar/:polizaId",
        templateUrl: "app/fianzaGpo/fianza.gpo.edit.html",
        controller: "FianzasColectividadesEditCtrl",
        controllerAs: "order",
        params: {
          myInsurance: "some default",
          message: "some default",
        },
        data: { pageTitle: "Fianzas" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          myInsurance: function () {
            return null;
          },
          container: function () {
            return [];
          },
        },
      })
      .state("reclamacion.edit", {
        url: "/:reclId/editar",
        templateUrl: "app/fianzas/fianzas.reclamaciones.html",
        controller: "ReclamacionEditCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Edición de Reclamación" },
      })
      .state("fianzas.renewal", {
        url: "/colectividades/:polizaId/renovar",
        templateUrl: "app/fianzaGpo/fianza.gpo.renewal.html",
        controller: "FianzasColectividadesRenewalCtrl",
        controllerAs: "order",
        params: {
          myInsurance: "some default",
          message: "some default",
        },
        data: { pageTitle: "Fianzas" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          myInsurance: function () {
            return null;
          },
          container: function () {
            return [];
          },
        },
      })
      .state("fianzas.reissue", {
        url: "/colectividades/:polizaId/reexpedir",
        templateUrl: "app/fianzaGpo/fianza.gpo.renewal.html",
        controller: "FianzasColectividadesRenewalCtrl",
        controllerAs: "order",
        params: {
          myInsurance: "some default",
          message: "some default",
        },
        data: { pageTitle: "Fianzas" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          myInsurance: function () {
            return null;
          },
          container: function () {
            return [];
          },
        },
      })
      .state("fianzas.details", {
        url: "/colectividades/:polizaId",
        templateUrl: "app/fianzaGpo/fianza.gpo.info.html",
        controller: "FianzasInfoColectividadesCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Fianzas" },
      })
      .state("fianzas.reclamaciones", {
        url: "/reclamaciones",
        templateUrl: "app/fianzas/fianzas.reclamaciones.html",
        controller: "FianzasReclamacionesCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Fianzas" },
      })
      .state("fianzas.list", {
        url: "/list",
        templateUrl: "app/fianzas/fianzas.list.html",
        controller: "FianzasListCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Fianzas" },
      })
      .state("fianzas.info", {
        url: "/informacion/:polizaId",
        templateUrl: "app/fianzas/fianzas.info.html",
        controller: "FianzasInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Fianzas" },
      })
      .state("fianzas.pprovlist", {
        url: "/programa/list",
        templateUrl: "app/fianzas/programa.list.html",
        controller: "FianzasProgramaListCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Programa de Proveedores" },
      })
      .state("fianzas.pprovnew", {
        url: "/programa/new",
        templateUrl: "app/fianzas/programa.new.html",
        controller: "FianzasProgramaNewCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Programa de Proveedores - Nuevo" },
      })

      .state("fianzas.pprovinfo", {
        url: "/programa/:type/:contratanteId",
        templateUrl: "app/fianzas/pproveedor.info.html",
        data: { pageTitle: "Programa de Proveedores" },
        controller: "ContratantesPPEditCtrl",
        controllerAs: "vm",
      })
      .state("fianzas.pprovedit", {
        url: "/programa/:type/:contratanteId",
        templateUrl: "app/fianzas/pproveedor.edit.html",
        data: { pageTitle: "Contratantes Programa de Proveedores" },
        controller: "ContratantesPPEditCtrl",
        controllerAs: "vm",
      })

      .state("fianzas.editar", {
        url: "/editar/:polizaId",
        templateUrl: "app/fianzas/fianzas.edit.html",
        controller: "FianzasEditCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "some default",
          message: "some default",
        },
        data: { pageTitle: "Polizas" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          myInsurance: function () {
            return null;
          },
          container: function () {
            return [];
          },
        },
      })
      .state("fianzas.renovar", {
        url: "/:polizaId/:renovacion/renovacion",
        templateUrl: "app/fianzas/fianzas.edit.html",
        controller: "FianzasEditCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "some default",
          renovacion: "",
          message: "some default",
        },
        data: { pageTitle: "Fianzas" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          myInsurance: function () {
            return null;
          },
          container: function () {
            return [];
          },
        },
      })
      .state("fianzas.reexpedir", {
        url: "/:polizaId/:reexpedir/reexpedicion",
        templateUrl: "app/fianzas/fianzas.edit.html",
        controller: "FianzasEditCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "some default",
          message: "some default",
        },
        data: { pageTitle: "Fianzas" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          myInsurance: function () {
            return null;
          },
          container: function () {
            return [];
          },
        },
      })
      .state("grupinglevel", {
        abstract: true,
        url: "/agrupacion",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("grupinglevel.grupinglevel", {
        url: "/",
        templateUrl: "app/agrupaciones/agrupacion.html",
        controller: "groupingLevelCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Agrupaciones" },
        params: {
          myInsurance: "some default",
        },
      })
      .state("adjuntosinternos", {
        abstract: true,
        url: "/carpetas",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("adjuntosinternos.list", {
        url: "/content",
        templateUrl: "app/carpetas/carpetas.html",
        controller: "CarpetasAdjuntosCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Carpetas" },
      })
      .state("bibliotecas", {
        abstract: true,
        url: "/bibliotecas",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("bibliotecas.bibliotecas", {
        url: "/",
        templateUrl: "app/bibliotecas/bibliotecas.html",
        controller: "BibliotecasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Bibliotecas" },
        params: {
          myInsurance: "some default",
        },
      })
      .state("bibliotecas.edit", {
        url: "/edit",
        templateUrl: "app/bibliotecas/bibliotecas.edit.html",
        controller: "BibliotecasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Bibliotecas" },
        params: {
          myInsurance: "some default",
        },
      })
      .state("bibliotecas.list", {
        url: "/list",
        templateUrl: "app/bibliotecas/cartas.list.html",
        controller: "CartasListCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Cartas" },
      })
      .state("bibliotecas.layouts", {
        url: "/layouts",
        templateUrl: "app/bibliotecas/layouts.html",
        controller: "CartasListCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Layouts" },
      })
      .state("bibliotecas.editables", {
        url: "/editables",
        templateUrl: "app/bibliotecas/editables.html",
        controller: "EditablesCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Layouts" },
      })
      .state("buscador", {
        abstract: true,
        url: "/buscador",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("buscador.buscador", {
        url: "/:cadena",
        templateUrl: "app/buscador/buscador.template.html",
        controller: "BuscadorCtrl",
        data: { pageTitle: "Buscador" },
      })
      .state("buscador.modal", {
        url: "/modal/:cadena",
        templateUrl: "app/buscador/buscador.modal.html",
        controller: "BuscadorCtrl",
        data: { pageTitle: "Buscador" },
      })
      .state("comisiones", {
        abstract: true,
        url: "/comisiones",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("comisiones.comisiones", {
        url: "/",
        templateUrl: "app/comisiones/comisiones.html",
        controller: "ComisionesCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Comisiones" },
      })
      .state("comisiones.conciliarid", {
        url: "/conciliarid",
        templateUrl: "app/comisiones/conciliarid.html",
        controller: "ConciliarMasivoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Conciliar Masivo ID" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          valueReceipt: function () {
            return {};
          },
        },
      })
      .state("agentes", {
        abstract: true,
        url: "/agentes",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("agentes.administration", {
        url: "/administracion",
        templateUrl: "app/agentes/pago.administrador.html",
        controller: "PagoAgentesAdminController",
        controllerAs: "vm",
        data: { pageTitle: "Pago a Agentes" },
      })
      .state("agentes.estadoscuenta", {
        url: "/estadoscuenta",
        templateUrl: "app/agentes/pago.estadoscuenta.html",
        controller: "PagoAgentesEstadosCuentaController",
        controllerAs: "vm",
        data: { pageTitle: "Estados Cuenta" },
      })
      .state("agentes.agentes", {
        url: "/",
        templateUrl: "app/agentes/pago.agentes.html",
        controller: "PagoAgentesController",
        controllerAs: "vm",
        data: { pageTitle: "Pago a Agentes" },
      })
      .state("agentes.receipts", {
        url: "/:folioId",
        templateUrl: "app/agentes/pago.recibos.html",
        controller: "PagoAgentesDetalleController",
        controllerAs: "vm",
        data: { pageTitle: "Pago a Agentes" },
      })
      .state("comisiones.consulta", {
        url: "/consulta",
        templateUrl: "app/comisiones/comisiones.consulta.html",
        controller: "ComisionesConsultaCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Comisiones" },
      })
      .state("multicotizador", {
        abstract: true,
        url: "/multicotizador",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("multicotizador.multicotizador", {
        url: "/",
        templateUrl: "app/multicotizador/multicotizador.html",
        controller: "MulticotizadorCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "some default",
        },
        data: { pageTitle: "Multicotizador" },
      })
      .state("multicotizador.emision", {
        url: "/emision",
        templateUrl: "app/multicotizador/multicotizador.emision.html",
        controller: "MulticotizadorEmisionCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "some default",
          contractor: "some default",
          quoteInfo: "some default",
        },
        data: { pageTitle: "Multicotizador" },
      })
      .state("multicotizador.administrador", {
        url: "/administrador",
        templateUrl: "app/multicotizador/admin/admin.html",
        controller: "MulticotizadorAdminCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Administrador de cotizaciones" },
      })
      .state("multicotizador.configurador", {
        url: "/configurador",
        templateUrl: "app/multicotizador/configurador/configurador.html",
        controller: "ConfiguradorCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "some default",
        },
        data: { pageTitle: "Configurador" },
      })
      .state("config", {
        abstract: true,
        url: "/config",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("config.lectura_documentos", {
        url: "/lectura-documentos",
        templateUrl: "app/lectura_documentos/lectura_documentos.html",
        data: { pageTitle: "Lectura de documentos" },
        controller: "LecturaDocumentosController",
        controllerAs: "vm",
      })
      .state("config.edit_lectura_documentos", {
        url: "/lectura-documentos/:id",
        templateUrl: "app/lectura_documentos/lectura_documentos.edit.html",
        data: { pageTitle: "Lectura de documentos" },
        controller: "LecturaDocumentosEditController",
        controllerAs: "vm",
      })
      .state("config.configCampos", {
        url: "/configuracionfiltros",
        templateUrl: "app/configuracion/configuracion.html",
        data: { pageTitle: "Configuracion Filtros" },
        controller: "ConfiguracionFiltrosController",
        controllerAs: "vm",
      })
      .state("cedula", {
        abstract: true,
        url: "/cedula",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("cedula.cedula", {
        url: "/",
        templateUrl: "app/cedula/cedula.html",
        data: { pageTitle: "Cédula" },
        controller: "CedulaController",
        controllerAs: "vm",
      })
      .state("help", {
        abstract: true,
        url: "/help",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("help.manual", {
        url: "/",
        templateUrl: "app/help/help.html",
        controller: "HelpCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Ayuda" },
      })
      .state("help.policy", {
        url: "/",
        templateUrl: "app/help/help.policy.html",
        controller: "HelpCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Ayuda" },
      })
      .state("paquetes", {
        abstract: true,
        url: "/paquetes",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("campaign", {
        abstract: true,
        url: "/campaigns",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("campaign.list", {
        url: "/list",
        templateUrl: "app/campaigns/campaigns.list.html",
        controller: "CampaignListCtrl",
        controllerAs: "vm",
        data: { pageTitle: "campaigns" },
      })
      .state("campaign.create", {
        url: "/create",
        templateUrl: "app/campaigns/campaigns.html",
        controller: "CampaignCtrl",
        controllerAs: "vm",
        data: { pageTitle: "campaigns" },
      })
      .state("campaign.edit", {
        url: "/:campaignId/edit",
        templateUrl: "app/campaigns/campaigns.edit.html",
        controller: "CampaignEditCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Campañas" },
      })
      .state("paquetes.paquetes", {
        url: "/",
        templateUrl: "app/paquetes/paquetes.html",
        controller: "PaquetesCtrl",
        controllerAs: "vm",
        data: { pageTitle: "paquetes" },
      })
      .state("paquetes.edit", {
        url: "/:paqueteId/coberturas",
        templateUrl: "app/paquetes/paquetes.edit.html",
        controller: "PaquetesEditCtrl",
        controllerAs: "vm",
        data: { pageTitle: "paquetes" },
      })
      .state("polizas", {
        abstract: true,
        url: "/polizas",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("polizas.table", {
        url: "/datos",
        templateUrl: "app/polizas/polizas.table.html",
        controller: "PolizasTableCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Tabla de Polizas" },
      })
      .state("polizas.create", {
        url: "/crear",
        templateUrl: "app/ordenes/ordenes.html",
        // templateUrl: 'app/modals/modal.ot-creator.html',
        controller: "OrderCtrl",
        controllerAs: "order",
        params: {
          myInsurance: "some default",
        },
        data: { pageTitle: "Polizas" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
        },
      })
      .state("polizas.info", {
        url: "/:polizaId",
        templateUrl: "app/polizas/polizas.info.html",
        controller: "PolizasInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Polizas" },
      })
      .state("polizas.editar", {
        url: "/:polizaId/editar",
        templateUrl: "app/polizas/polizas.edit.html",
        controller: "OrderEditCtrl",
        controllerAs: "order",
        params: {
          myInsurance: "some default",
          message: "some default",
        },
        data: { pageTitle: "Polizas" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          myInsurance: function () {
            return null;
          },
          container: function () {
            return [];
          },
        },
      })
      .state("polizas.plantillas", {
        url: "plantillas",
        templateUrl: "app/polizas/polizas.plantillas.html",
        controller: "PolizasPlantillasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "polizasPlantillas" },
      })
      //.state('polizas.recibos', {
      //url: '/:polizaId/recibos/:receiptId',
      //templateUrl: 'app/polizas/receipts/receipts.html',
      //controller: 'ReceiptsCtrl',
      //controllerAs: 'vm',
      //data: { pageTitle: 'Recibos' }
      //})
      .state("cobranzas", {
        abstract: true,
        url: "/cobranzas",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      // .state('cobranzas.recibospendientes', {
      //   url: '/',
      //   templateUrl: 'app/modals/modal.receipts.html',
      //   controller: 'CobranzasModal',
      //   controllerAs: 'vm',
      //   data: { pageTitle: 'Pagar recibos' },
      //   resolve: {
      //     $uibModalInstance: function () {
      //       return null;
      //     }
      //   }
      // })
      .state("cobranzas.recibospendientes", {
        url: "/recibosPendientes",
        templateUrl: "app/modals/modal.receipts.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "RecibosPendientes" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          valueReceipt: function () {
            return {};
          },
        },
      })
      .state("cobranzas.cobranzas", {
        url: "/",
        templateUrl: "app/cobranzas/cobranzas.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Cobranzas" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          valueReceipt: function () {
            return {};
          },
        },
      })
      .state("cobranzas.plantillas", {
        url: "/plantillas",
        templateUrl: "app/cobranzas/cobranzas.plantillas.html",
        controller: "CobranzasPlantillasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "CobranzasPlantillas" },
      })
      .state("cobranzas.plantillassms", {
        url: "/plantillasms",
        templateUrl: "app/cobranzas/cobranzas.plantillassms.html",
        controller: "CobranzasPlantillasSmsCtrl",
        controllerAs: "vm",
        data: { pageTitle: "CobranzasPlantillasSms" },
      })
      .state("cobranzas.plantillaswhatsapp", {
        url: "/plantillaswhatsappweb",
        templateUrl: "app/cobranzas/cobranzas.plantillaswhatsapp.html",
        controller: "CobranzasPlantillasWhatsappCtrl",
        controllerAs: "vm",
        data: { pageTitle: "CobranzasPlantillasWhatsapp" },
      })
      .state("cobranzas.folios", {
        url: "/folios",
        templateUrl: "app/cobranzas/cobranzas.folios.html",
        controller: "CobranzasFoliosCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Folios Pago/Liquidación" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          valueReceipt: function () {
            return {};
          },
        },
      })
      .state("cobranzas.bonos", {
        url: "/bonos",
        templateUrl: "app/cobranzas/cobranzas.bonos.html",
        controller: "CobranzasBonosCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Bonos" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          valueReceipt: function () {
            return {};
          },
        },
      })
      .state("cobranzas.cobranzasmasivo", {
        url: "/masivo/",
        templateUrl: "app/cobranzas/cobranzasmasivo.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "CobranzasMasivo" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          valueReceipt: function () {
            return {};
          },
        },
      })
      .state("cobranzas.repositorio", {
        url: "/repositorio/",
        templateUrl: "app/repositorio/repositorio.html",
        controller: "RepositorioCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Repositorio" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
          valueReceipt: function () {
            return {};
          },
        },
      })
      .state("coberturas", {
        abstract: true,
        url: "/coberturas",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("coberturas.coberturas", {
        url: "/",
        templateUrl: "app/coberturas/coberturas.html",
        controller: "CoberturasCtrl",
        controllerAs: "vm",
      })
      .state("renovaciones", {
        abstract: true,
        url: "/renovaciones",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("renovaciones.renovaciones", {
        url: "/",
        templateUrl: "app/renovaciones/renovaciones.html",
        controller: "RenovacionesCtrl",
        controllerAs: "vm",
        // params: ['myInsurance','container'],
        data: { pageTitle: "Renovaciones" },
      })
      .state("renovaciones.polizas", {
        url: "/renovacion-poliza/:polizaId",
        templateUrl: "app/renovaciones/renovaciones.modalNew.html",
        controller: "RenovacionesModalCtrl",
        controllerAs: "order",
        params: {
          myInsurance: "some default",
          container: "some default",
        },
        data: { pageTitle: "Renovaciones" },
      })
      .state("siniestros", {
        abstract: true,
        url: "/siniestros",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("siniestros.plantillas", {
        url: "plantillas",
        templateUrl: "app/siniestros/siniestros.plantillas.html",
        controller: "SiniestrosPlantillasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros Plantillas" },
      })
      .state("siniestros.lista", {
        url: "/lista",
        templateUrl: "app/siniestros/new_siniestros.table.html",
        controller: "NewSiniestrosTableCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros" },
      })
      .state("siniestros.accidentes", {
        url: "/accidentes",
        templateUrl: "app/siniestros/new_siniestros_accidentes.html",
        controller: "SiniestrosAccidentesCreateCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "myInsurance",
        },
        data: { pageTitle: "Siniestros" },
      })
      .state("siniestros.create_accidentes", {
        url: "/accidentes-enfermedades/",
        templateUrl: "app/siniestros/siniestros.accidentes.html",
        // templateUrl: 'app/modals/modal.ot-creator.html',
        controller: "SiniestrosCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "myInsurance",
        },
        data: { pageTitle: "Siniestros - Accidentes" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
        },
      })
      .state("siniestros.damage", {
        url: "/damages",
        templateUrl: "app/siniestros/siniestros.damage.html",
        controller: "SiniestrosCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros" },
      })
      .state("siniestros.vida", {
        url: "/vida",
        templateUrl: "app/siniestros/siniestros.vida.html",
        controller: "SiniestrosVidaCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros" },
      })
      .state("siniestros.create_vida", {
        url: "/vida/",
        templateUrl: "app/siniestros/siniestros.vida.html",
        // templateUrl: 'app/modals/modal.ot-creator.html',
        controller: "SiniestrosVidaCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "myInsurance",
        },
        data: { pageTitle: "Siniestros - Vida" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
        },
      })
      .state("siniestros.info", {
        url: "/gmm/info/:siniestroId",
        templateUrl: "app/siniestros/new_siniestros_accidentes.info.html",
        controller: "SiniestrosAccidentesInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros" },
      })
      .state("siniestros.edit", {
        url: "/gmm/edit/:siniestroId",
        templateUrl: "app/siniestros/new_siniestros_accidentes.edit.html",
        controller: "SiniestrosAccidentesEditCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros" },
      })
      .state("siniestros.accidentesInfo", {
        url: "/accidentes/info/:siniestroId",
        templateUrl: "app/siniestros/siniestros.accidentes.html",
        controller: "SiniestrosCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros" },
      })
      .state("siniestros.vida_info", {
        url: "/vida/:siniestroId",
        templateUrl: "app/siniestros/siniestro.vida.info.html",
        controller: "siniestrosVidaInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros" },
      })
      .state("siniestros.autos", {
        url: "/autos",
        templateUrl: "app/siniestros/siniestros.autos.html",
        controller: "SiniestrosAutosCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros" },
      })
      .state("siniestros.danios", {
        url: "/danios",
        templateUrl: "app/siniestros/siniestros.danios.html",
        controller: "SiniestrosDaniosCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros" },
      })
      .state("siniestros.create_autos", {
        url: "/autos/",
        templateUrl: "app/siniestros/siniestros.autos.html",
        // templateUrl: 'app/modals/modal.ot-creator.html',
        controller: "SiniestrosAutosCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "myInsurance",
        },
        data: { pageTitle: "Siniestros - Autos" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
        },
      })
      .state("siniestros.create_danios", {
        url: "/danios/",
        templateUrl: "app/siniestros/siniestros.danios.html",
        // templateUrl: 'app/modals/modal.ot-creator.html',
        controller: "SiniestrosDaniosCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "myInsurance",
        },
        data: { pageTitle: "Siniestros - Daños" },
        resolve: {
          $uibModalInstance: function () {
            return null;
          },
        },
      })
      .state("siniestros.auto_info", {
        url: "/autos/:siniestroId",
        templateUrl: "app/siniestros/siniestro.auto.info.html",
        controller: "siniestrosAutosInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros" },
      })
      .state("siniestros.danio_info", {
        url: "/danios/:siniestroId",
        templateUrl: "app/siniestros/siniestro.danio.info.html",
        controller: "siniestrosDanioInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Siniestros" },
      })
      /*Inicia nuevo endosos*/
      .state("endorsement", {
        abstract: true,
        url: "/endosos",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("endorsement.endorsement", {
        url: "/",
        templateUrl: "app/endosoFull/endoso.full.html",
        controller: "EndosoFullController",
        controllerAs: "order",
        params: {
          myInsurance: "some default",
          contractor: "some default",
        },
        data: { pageTitle: "Endosos" },
      })
      .state("endorsement.lista", {
        url: "/listado",
        templateUrl: "app/endoso/endosos.table.html",
        controller: "EndososTableCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Endosos" },
      })
      .state("endorsement.collectivity", {
        url: "/grupo",
        templateUrl: "app/endosoFull/endoso.gpo.html",
        controller: "EndosoGpoController",
        controllerAs: "order",
        data: { pageTitle: "Endosos" },
        params: {
          myInsurance: "some default",
          contractor: "some default",
        },
      })
      .state("endorsement.info", {
        url: "/informacion/:endosoId",
        templateUrl: "app/endosoFull/endoso.full.information.html",
        controller: "EndosoFullInfoController",
        controllerAs: "order",
        data: { pageTitle: "Endosos" },
      })
      .state("endorsement.details", {
        url: "/info/:endosoId",
        templateUrl: "app/endoso/endosos.fianza.info.html",
        controller: "EndososFianzaInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Endosos" },
      })
      .state("endorsement.edit", {
        url: "/edit/:endosoId",
        templateUrl: "app/endosoFull/endoso.full.edit.html",
        controller: "EndosoFullEditCtrl",
        controllerAs: "order",
        data: { pageTitle: "Endosos" },
      })
      .state("endorsement.collective", {
        url: "/fianzacolectiva",
        templateUrl: "app/endoso/endosos.fianzaGpo.html",
        controller: "EndososSuretyCollectiveCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "some default",
          contractor: "some default",
        },
        data: { pageTitle: "Endosos" },
      })
      .state("endorsement.update", {
        url: "/editar/:endosoId",
        templateUrl: "app/endoso/endosos.fianzaGpo.edit.html",
        controller: "EndososSuretyEditCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Endosos" },
      })
      .state("endorsement.fianza", {
        url: "/fianza/:fianzaId",
        templateUrl: "app/endoso/endosos.fianza.html",
        controller: "EndososSuretyCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "some default",
          contractor: "some default",
        },
        data: { pageTitle: "Endosos" },
      })
      /*Termina nuevo endosos*/
      .state("endosos", {
        abstract: true,
        url: "/endosos",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("endosos.endosos", {
        url: "/",
        templateUrl: "app/endosos/endosos.html",
        controller: "EndososCtrl",
        controllerAs: "vm",
        params: {
          myInsurance: "some default",
          contractor: "some default",
        },
        data: { pageTitle: "Endosos" },
      })
      .state("endosos.available", {
        url: "/datos",
        templateUrl: "app/endosos/endosos.table.html",
        controller: "EndososTableCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Endosos" },
      })
      .state("endosos.pendingDataMassive", {
        url: "/pendientes/masivos/:polizaId/:endorsementType/:endorsementId/",
        templateUrl: "app/endosos/endosos.pendingInfoMassive.html",
        controller: "EndososPendingMassiveCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Endosos" },
      })
      .state("endosos.pending", {
        url: "/pendientes",
        templateUrl: "app/endosos/endosos.pending.html",
        controller: "EndososPendingCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Endosos" },
      })
      .state("endosos.pendingData", {
        url: "/pendientes/:endorsementId/:endorsementType",
        templateUrl: "app/endosos/endosos.pendingInformation.html",
        controller: "EndososPendingInfoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Endosos" },
      })
      .state("endosos.information", {
        url: "/informaciones/:endorsementId",
        templateUrl: "app/endosos/endosos.information.html",
        controller: "EndososInformationCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Endosos" },
      })
      .state("endosos.plantillas", {
        url: "/plantillas",
        templateUrl: "app/endosos/endosos.plantillas.html",
        controller: "EndososPlantillasCtrl",
        controllerAs: "vm",
        data: { pageTitle: "EndososPlantillas" },
      })
      .state("emails", {
        abstract: true,
        url: "/emails",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("emails.smtp", {
        url: "/smtp",
        templateUrl: "app/emails/smtp.config.html",
        data: { pageTitle: "SMTP" },
        controller: "SmtpConfigController",
        controllerAs: "vm",
      })
      .state("emails.whatsapp", {
        url: "/Whatsapp",
        templateUrl: "app/emails/whatsapp.config.html",
        data: { pageTitle: "Whatsapp" },
        controller: "WhatsappConfigController",
        controllerAs: "vm",
      })
      .state("emails.config", {
        url: "/config",
        templateUrl: "app/emails/emails.config.html",
        controller: "EmailConfigController",
        controllerAs: "vm",
        data: { pageTitle: "Correos" },
      })
      .state("carga", {
        abstract: true,
        url: "/carga",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("carga.contractor", {
        url: "/contratantes",
        templateUrl: "app/carga/carga.contratante.html",
        controller: "cargaContractorCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Cargas" },
      })
      .state("carga.poliza", {
        url: "/poliza",
        templateUrl: "app/carga/carga.poliza.html",
        controller: "cargaPolizaCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Cargas" },
      })
      .state("carga.norenovacion", {
        url: "/norenovacion",
        templateUrl: "app/carga/carga.norenovacion.html",
        controller: "cargaNoRenovacionCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Cargas" },
      })
      .state("carga.pgrupo", {
        url: "/polizagrupo",
        templateUrl: "app/carga/carga.polizaGpo.html",
        controller: "cargaPolizaGrupoCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Cargas" },
      })
      .state("carga.certificado", {
        url: "/certificados",
        templateUrl: "app/carga/carga.certificados.html",
        controller: "cargaCertificadosCtrl",
        controllerAs: "order",
        data: { pageTitle: "Cargas" },
      })
      .state("carga.flotilla", {
        url: "/flotilla",
        templateUrl: "app/carga/carga.flotilla.html",
        controller: "cargaFlotillaCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Cargas" },
      })
      .state("carga.recibos", {
        url: "/recibos",
        templateUrl: "app/carga/carga.recibos.html",
        controller: "cargaRecibosCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Cargas" },
      })
      .state("carga.catalogo", {
        url: "/catalogo",
        templateUrl: "app/carga/carga.catalogo.html",
        controller: "cargaCatalogoCtrl",
        controllerAs: "order",
        data: { pageTitle: "Cargas" },
      })
      .state("carga.cancelacion", {
        url: "/cancelacion",
        templateUrl: "app/carga/carga.cancelacion.html",
        controller: "cargaCancelacionPolizaCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Cargas" },
      })
      .state("carga.infocontributoria", {
        url: "/informacioncontributoria",
        templateUrl: "app/carga/carga.info_contributoria.html",
        controller: "cargaPGInfoContributoriaCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Carga Informacion Contributoria" },
      })
      .state("recordatorios", {
        abstract: true,
        url: "/recordatorios",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("recordatorios.table", {
        url: "/",
        templateUrl:
          "app/recordatorios/table/recordatorios.table.component.html",
        data: { pageTitle: "Recordatorios" },
        controller: "RecordatoriosTableCtrl",
        controllerAs: "vm",
      })
      .state("recordatorios.automaticos", {
        url: "/automaticos",
        templateUrl: "app/recordatorios/automaticos/automaticos.component.html",
        data: { pageTitle: "Recordatorios" },
        controller: "RecordatoriosAutomaticosCtrl",
        controllerAs: "vm",
      })
      .state("recordatorios.automaticos_detalle", {
        url: "/automaticos-detalle/:id",
        templateUrl:
          "app/recordatorios/automaticos/automaticos.detail.component.html",
        data: { pageTitle: "Recordatorios" },
        controller: "RecordatoriosAutomaticosDetalleCtrl",
        controllerAs: "vm",
      })
      .state("recordatorios.libres_detalle", {
        url: "/libres-detalle/:id",
        templateUrl: "app/recordatorios/libres/libres.detail.component.html",
        data: { pageTitle: "Recordatorios" },
        controller: "RecordatoriosLibresDetalleCtrl",
        controllerAs: "vm",
      })
      .state("recordatorios.desde_registros_detalle", {
        url: "/desde-registros-detalle/:id",
        templateUrl:
          "app/recordatorios/desde-registro/desde_registro.detail.component.html",
        data: { pageTitle: "Recordatorios" },
        controller: "RecordatoriosDesdeRegistroDetalleCtrl",
        controllerAs: "vm",
      })
      .state("recordatorios.automaticos_show", {
        url: "/automaticos-show/:id",
        templateUrl:
          "app/recordatorios/automaticos/automaticos.show.component.html",
        data: { pageTitle: "Recordatorios" },
        controller: "RecordatoriosAutomaticosShowCtrl",
        controllerAs: "vm",
      })
      .state("recordatorios.libres_show", {
        url: "/libres-show/:id",
        templateUrl: "app/recordatorios/libres/libres.show.component.html",
        data: { pageTitle: "Recordatorios" },
        controller: "RecordatoriosLibresShowCtrl",
        controllerAs: "vm",
      })
      .state("recordatorios.desde_registro_show", {
        url: "/desde-registros-show/:id",
        templateUrl:
          "app/recordatorios/desde-registro/desde_registro.show.component.html",
        data: { pageTitle: "Recordatorios" },
        controller: "RecordatoriosDesdeRegistroShowCtrl",
        controllerAs: "vm",
      })
      .state("recordatorios.libres", {
        url: "/libres",
        templateUrl: "app/recordatorios/libres/libres.component.html",
        data: { pageTitle: "Recordatorios" },
        controller: "RecordatoriosLibresCtrl",
        controllerAs: "vm",
      })
      .state("recordatorios.desde_registros", {
        url: "/desde-registros",
        templateUrl:
          "app/recordatorios/desde-registro/desde_registro.component.html",
        data: { pageTitle: "Recordatorios" },
        controller: "RecordatoriosDesdeRegistrosCtrl",
        controllerAs: "vm",
      })
      .state("reportes.adjuntos", {
        url: "/reporteadjuntos",
        templateUrl: "app/reportes/reporte.adjuntos.html",
        data: { pageTitle: "Reporte Adjuntos" },
        controller: "ReporteAdjuntosController",
        controllerAs: "vm",
      })
      .state("reportes.asegurados", {
        url: "/asegurados",
        templateUrl: "app/reportes/reporte.asegurados.html",
        data: { pageTitle: "Reporte Asegurados" },
        controller: "ReporteAseguradosController",
        controllerAs: "vm",
      })
      .state("compartir", {
        abstract: true,
        url: "/compartir",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("compartir.create", {
        url: "/:shareId",
        templateUrl: "app/compartirapp/compartir.html",
        controller: "CompartirAppCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Compartir a la App" },
      })
      .state("conexion", {
        abstract: true,
        url: "/conexionagentes",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("conexion.agentes", {
        url: "/:shareId",
        templateUrl: "app/conexion_agentes/conexion_agentes.html",
        controller: "ConexionAgentesCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Conexión Agentes" },
      })
      .state("tablero", {
        abstract: true,
        url: "/TableroOTs",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("tablero.init", {
        url: "/:tabOts",
        templateUrl: "app/tablero/tablero.config.html",
        controller: "TableroOtsCtrl",
        controllerAs: "vm",
        data: { pageTitle: "Tablero OTs" },
      })
      .state("medicoscelulas", {
        abstract: true,
        url: "/medicoscelulas",
        templateUrl: "app/components/common/content.html",
        controller: "TabsCtrl",
      })
      .state("medicoscelulas.configuracion", {
        url: "/medicos",
        templateUrl: "app/medicoscelulas/configuracion.html",
        data: { pageTitle: "Médicos" },
        controller: "MedicosCelulasConfiguracionCtrl",
        controllerAs: "vm",
      });
    $urlRouterProvider.otherwise("/login/auth");
  });
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .service("siniestroWhatsappService", siniestroWhatsappService)
    .controller("SiniestroWhatsappModalCtrl", siniestroWhatsappModalCtrl);

  siniestroWhatsappService.$inject = ["$uibModal"];

  function siniestroWhatsappService($uibModal) {
    this.open = function (data) {
      return $uibModal.open({
        templateUrl: "app/siniestros/whatsapp_siniestro.html",
        controller: "SiniestroWhatsappModalCtrl",
        controllerAs: "whatsappModal",
        size: "lg",
        resolve: {
          siniestro: function () {
            return data && data.siniestro ? data.siniestro : null;
          },
          poliza: function () {
            return data && data.poliza ? data.poliza : null;
          },
          info: function () {
            return data && data.info ? data.info : {};
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };
  }

  siniestroWhatsappModalCtrl.$inject = [
    "$uibModalInstance",
    "$scope",
    "$http",
    "url",
    "whatsappWebHelper",
    "SweetAlert",
    "$sce",
    "dataFactory",
    "siniestro",
    "poliza",
    "info",
  ];

  function siniestroWhatsappModalCtrl(
    $uibModalInstance,
    $scope,
    $http,
    url,
    whatsappWebHelper,
    SweetAlert,
    $sce,
    dataFactory,
    siniestro,
    poliza,
    info
  ) {
    $scope.phone =
      (info &&
        (info.contratante_phone_number ||
          (info.contratante && info.contratante.phone_number))) ||
      "";
    $scope.message = "";
    $scope.appendPreview = true;
    $scope.previewRawHtml = "";
    $scope.previewHtml = "";
    $scope.previewLoading = false;
    $scope.sendLoading = false;
    $scope.templatesList = [];
    $scope.selectedTemplate = null;
    $scope.previewPlain = "";
    $scope.siniestroDetails = [];
    $scope.poliza = poliza;
    $scope.siniestro = siniestro;

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };

    $scope.applyTemplate = function (template) {
      $scope.selectedTemplate = template;
      if (template) {
        var templateText =
          template.text || template.mensaje || template.bottom_text || "";
        $scope.message = whatsappWebHelper.normalizeLineBreaks(
          whatsappWebHelper.extractPreviewText(templateText)
        );
      }
    };

    function parsePreviewDetails(rawHtml) {
      try {
        var wrapper = document.createElement("div");
        wrapper.innerHTML = rawHtml || "";
        var lis = wrapper.querySelectorAll("ul li");
        var details = [];
        angular.forEach(lis, function (item) {
          var text = (item.textContent || item.innerText || "").trim();
          if (text) {
            details.push(text.replace(/\s+/g, " "));
          }
        });
        return details;
      } catch (err) {
        return [];
      }
    }

    function detailsFromShare(data) {
      if (!data) {
        return [];
      }
      var fields = [
        { label: "Contratante", key: "contratante" },
        { label: "Número de Siniestro", key: "numero_siniestro" },
        { label: "Tipo de Siniestro", key: "tipo_siniestro" },
        { label: "Número de Póliza", key: "poliza_number" },
        { label: "Subramo", key: "subramo" },
        { label: "Aseguradora", key: "aseguradora" },
        { label: "Estatus del Siniestro", key: "siniestro_estatus" },
        { label: "Asegurado del Siniestro", key: "asegurado" },
      ];
      var details = [];
      angular.forEach(fields, function (field) {
        if (data[field.key]) {
          details.push(field.label + ": " + data[field.key]);
        }
      });
      return details;
    }

    function loadPreview() {
      $scope.previewLoading = true;
      $http
        .get(
          url.IP +
            "share-siniestro-whatsapp/" +
            (siniestro && siniestro.id ? siniestro.id : info.id)
        )
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.body) {
              $scope.previewRawHtml = response.data.body || "";
              $scope.previewHtml = $sce.trustAsHtml($scope.previewRawHtml);
              $scope.previewPlain = whatsappWebHelper.extractPreviewText(
                $scope.previewRawHtml
              );
              $scope.siniestroDetails = parsePreviewDetails(
                $scope.previewRawHtml
              );
            } else {
              $scope.previewRawHtml = detailsFromShare(response.data)
                .map(function (item) {
                  return "<div>" + item + "</div>";
                })
                .join("");
              $scope.previewHtml = $sce.trustAsHtml($scope.previewRawHtml);
              var formatted = detailsFromShare(response.data);
              $scope.previewPlain = formatted.join("\n");
              $scope.siniestroDetails = formatted;
            }
            if (!$scope.phone && response.data.telefono) {
              $scope.phone = response.data.telefono;
            }
          }
        })
        .catch(function (error) {
          console.error("error - catch", error);
        })
        .finally(function () {
          $scope.previewLoading = false;
        });
    }

    function loadTemplates() {
      dataFactory
        .get("whatsappwebtemplate-unpag/", { type_message: 3 })
        .then(function success(response) {
          var payload = response.data || [];
          if (payload.results && Array.isArray(payload.results)) {
            $scope.templatesList = payload.results;
          } else if (Array.isArray(payload)) {
            $scope.templatesList = payload;
          } else {
            $scope.templatesList = [];
          }
        })
        .catch(function (error) {
          console.error("error cargando plantillas siniestro", error);
        });
    }

    $scope.sendWhatsApp = function () {
      if ($scope.sendLoading) {
        return;
      }
      $scope.sendLoading = true;
      var finalMessage = whatsappWebHelper.composeMessage(
        $scope.message,
        $scope.appendPreview ? $scope.previewRawHtml : "",
        true
      );
      if (!finalMessage || !finalMessage.trim()) {
        SweetAlert.swal("Error", "No hay mensaje para enviar.", "error");
        $scope.sendLoading = false;
        return;
      }

      var whatsappUrl = whatsappWebHelper.buildWhatsAppUrl(
        $scope.phone,
        finalMessage
      );
      if (!whatsappUrl) {
        SweetAlert.swal("Error", "Ingrese un teléfono válido.", "error");
        $scope.sendLoading = false;
        return;
      }

      try {
        window.open(whatsappUrl, "_blank");
        $scope.cancel();
      } catch (err) {
        console.error("Error al abrir WhatsApp Web:", err);
        SweetAlert.swal("Error", "No se pudo abrir WhatsApp Web.", "error");
      } finally {
        $scope.sendLoading = false;
      }
    };

    loadTemplates();
    loadPreview();
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "ReporteEstConservacionController",
      ReporteEstConservacionController
    );

  ReporteEstConservacionController.$inject = [
    "datesFactory",
    "MESSAGES",
    "$http",
    "url",
    "$scope",
    "$parse",
    "$sessionStorage",
    "$uibModal",
    "SweetAlert",
    "$localStorage",
  ];

  function ReporteEstConservacionController(
    datesFactory,
    MESSAGES,
    $http,
    url,
    $scope,
    $parse,
    $sessionStorage,
    $uibModal,
    SweetAlert,
    $localStorage
  ) {
    var vm = this;
    var app = angular.module("inspinia");
    app.controller(
      "ReporteEstConservacionController",
      ReporteEstConservacionController
    );
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    vm.users = [];
    vm.group_by = [
      {
        id: 1,
        name: "Clave Agente",
      },
      {
        id: 2,
        name: "Aseguradora",
      },
      {
        id: 3,
        name: "Contratante",
      },
      {
        id: 4,
        name: "Ramo",
      },
      {
        id: 5,
        name: "Subramo",
      },
      // {
      //   id: 6,
      //   name: 'Moneda'
      // },
      // {
      //   id: 7,
      //   name: 'Sucursal'
      // }
    ];
    vm.form = {
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      since2: convertDate(new Date()),
      until2: convertDate(new Date()),
      selectTipo: 1,
    };
    vm.estatus = [
      {
        id: 1,
        name: "Vigente",
      },
      {
        id: 2,
        name: "Renovada",
      },
      {
        id: 3,
        name: "Vencida",
      },
      {
        id: 4,
        name: "Cancelada",
      },
      {
        id: 5,
        name: "Por iniciar",
      },
      {
        id: 6,
        name: "No renovada",
      },
    ];
    $scope.parameters = "Estatus: -Todos.";
    vm.formatearNumero = formatearNumero;
    $scope.procComparar = false;
    $scope.makeComparationFin = false;
    activate();
    // Start functionality
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    function activate() {
      $scope.by = "-Por Clave de Agente-";
      $scope.parPer = "-Fecha de Vigencia-";
      $scope.parEst = [];
      $scope.parEst.push("Estatus -Todos.");
      vm.form.group_by = {
        id: 1,
        name: "Clave Agente",
      };
      vm.form.polizas = true;
      vm.form.recibos = false;
      vm.form.fianzas = false;
      $scope.period_select = 1;
      vm.form.selectTipo = 1;
      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });

      vm.form.groupBy =
        $localStorage.saved_filters_reporte_estadistico &&
        $localStorage.saved_filters_reporte_estadistico["group_by"]
          ? $localStorage.saved_filters_reporte_estadistico["group_by"]
          : 1;
      vm.form.selectTipo =
        $localStorage.saved_filters_reporte_estadistico &&
        $localStorage.saved_filters_reporte_estadistico["selectTipo"]
          ? $localStorage.saved_filters_reporte_estadistico["selectTipo"]
          : 1;
      $scope.period_select =
        $localStorage.saved_filters_reporte_estadistico &&
        $localStorage.saved_filters_reporte_estadistico["period_select"]
          ? $localStorage.saved_filters_reporte_estadistico["period_select"]
          : 1;
    }

    $(".js-example-basic-multiple").select2();
    $scope.changeGroupBy = function (by) {
      $scope.by = "-Por Clave de Agente-";
      if (by.id == 1) {
        $scope.by = "-Por Clave de Agente-";
      } else if (by.id == 2) {
        $scope.by = "-Por Aseguradora-";
      } else if (by.id == 3) {
        $scope.by = "-Por Contratante-";
      } else if (by.id == 4) {
        $scope.by = "-Por Ramo-";
      } else if (by.id == 5) {
        $scope.by = "-Por Subramo-";
      } else {
        $scope.by = "-Por Clave de Agente-";
      }
      $scope.parameters = $scope.parameters + " por: " + $scope.by;
    };
    $scope.addEndososF = function (endo, pr) {
      if ($scope.period_select == 3) {
        if (vm.form.addEndosos == true) {
          vm.form.addEndosos = false;
        }
      }
    };
    $scope.selctPeriodo = function (pr) {
      if ($scope.period_select == 3) {
        vm.form.addEndosos = false;
        vm.form.polizas = false;
        vm.form.fianzas = false;
        vm.form.addEndosos = false;
        vm.form.recibos = true;
        vm.form.selectTipo = 2;
        $scope.parPer = "-Fecha de Pago-";
      } else if (pr == 1) {
        $scope.parPer = "-Fecha de Vigencia-";
      } else if (pr == 2) {
        $scope.parPer = "-Fecha de Emisión (Creación)-";
      } else if (pr == 3) {
        $scope.parPer = "-Fecha de Pago-";
      } else {
        $scope.parPer = "-Fecha de Vigencia-";
      }
    };
    $scope.selectPor = function (pr) {
      if (!vm.form.selectTipo && !vm.form.selectTipo & !vm.form.selectTipo) {
        vm.form.selectTipo = 1;
      }
      if (vm.form.selectTipo == 1) {
        vm.form.polizas = true;
        vm.form.recibos = false;
        vm.form.fianzas = false;
        vm.form.addEndosos = false;
        $scope.parPor = "-Pólizas-";
      } else if (vm.form.selectTipo == 2) {
        vm.form.recibos = true;
        vm.form.fianzas = false;
        vm.form.addEndosos = false;
        vm.form.polizas = false;
        $scope.parPor = "-Recibos-";
      } else if (vm.form.selectTipo == 3) {
        vm.form.fianzas = true;
        vm.form.addEndosos = false;
        vm.form.polizas = false;
        vm.form.recibos = false;
        $scope.parPor = "-Fianzas-";
      } else if (vm.form.selectTipo == 4) {
        vm.form.addEndosos = true;
        vm.form.polizas = false;
        vm.form.recibos = false;
        vm.form.fianzas = false;
        $scope.parPor = "-Endosos-";
      }
      if ($scope.period_select == 3) {
        vm.form.addEndosos = false;
        vm.form.polizas = false;
        vm.form.fianzas = false;
        vm.form.recibos = true;
        $scope.parPor = "-Recibos-";
        vm.form.selectTipo = 2;
      }
    };
    $scope.makeComparation = function (pr) {
      $scope.procComparar = true;
    };
    // $scope.options = {
    //     legend: {
    //         display: true,
    //         position: "bottom"
    //     },
    //     tooltipEvents: [],
    //     showTooltips: true,
    //     tooltipCaretSize: 0,
    //     onAnimationComplete: function () {
    //         this.showTooltip(this.segments, true);
    //     }
    // };
    $scope.makeComparationFinal = function (pr) {
      var l3 = Ladda.create(document.querySelector(".ladda-button3"));
      l3.start();
      $scope.labels = [];
      $scope.data = [];
      $scope.makeComparationFin = true;
      $scope.procComparar = true;
      $scope.stadistics = [];
      $scope.presentarPor3 = [];
      $scope.filters3 = {
        status: vm.estatusSelected ? vm.estatusSelected : 0,
        since2: vm.form.since2 ? vm.form.since2 : "",
        until2: vm.form.until2 ? vm.form.until2 : "",
        since: vm.form.since ? vm.form.since : "",
        until: vm.form.until ? vm.form.until : "",
        model: vm.form.model ? vm.form.model.id : 0,
        groupBy: vm.form.group_by ? vm.form.group_by.id : 0,
        polizasAdd: vm.form.polizas ? vm.form.polizas : false,
        recibosAdd: vm.form.recibos ? vm.form.recibos : false,
        fianzasAdd: vm.form.fianzas ? vm.form.fianzas : false,
        endososAdd: vm.form.addEndosos ? vm.form.addEndosos : false,
        period: $scope.period_select ? $scope.period_select : 1,
      };
      $scope.filters3.since2 = $scope.filters3.since2 + " " + "00:00:00";
      $scope.filters3.until2 = $scope.filters3.until2 + " " + "23:59:59";
      $scope.filters3.since = $scope.filters3.since + " " + "00:00:00";
      $scope.filters3.until = $scope.filters3.until + " " + "23:59:59";
      $http({
        method: "POST",
        url: url.IP + "reporte-stadistics3/",
        data: $scope.filters3,
      }).then(
        function success(response) {
          $scope.colours = [
            "#F1E223",
            "#00b8ff",
            "#708090",
            "#23a91c",
            "#006666",
            "#aec5a9",
            "#afe4d6",
            "#dbac98",
            "#00b159",
            "#f37735",
            "#ffc425",
            "  #00b159",
            "#F9D62E",
            "#e2f4c7",
          ];
          if ($scope.filters3.groupBy != 0) {
            l3.stop();
            $scope.labels = [];
            $scope.data = [];
            $scope.dataT = [];
            $scope.dataC = [];
            $scope.labels2 = [];
            $scope.data2 = [];
            $scope.dataT2 = [];
            $scope.dataC2 = [];
            $scope.labelsF = [];
            $scope.dataF = [];
            $scope.dataTF = [];
            $scope.dataCF = [];
            $scope.labels2F = [];
            $scope.data2F = [];
            $scope.dataT2F = [];
            $scope.dataC2F = [];
            $scope.presentarPor3 = [];
            $scope.presentarPor3 = response.data.results;
            $scope.presentarPor3.percentages.forEach(function (xc, idx) {
              $scope.labels = $scope.presentarPor3.percentages;
            });
            $scope.presentarPor3.percentagesN.forEach(function (xc, idx) {
              $scope.presentarPor3.percentagesN[idx] = parseFloat(
                $scope.presentarPor3.percentagesN[idx]
              ).toFixed(2);
              $scope.data = $scope.presentarPor3.percentagesN;
            });

            $scope.presentarPor3.percentagesT.forEach(function (xc, idx) {
              $scope.presentarPor3.percentagesT[idx] = parseFloat(
                $scope.presentarPor3.percentagesT[idx]
              ).toFixed(2);
              $scope.dataT = $scope.presentarPor3.percentagesT;
            });
            $scope.presentarPor3.percentagesC.forEach(function (xCc, idxC) {
              $scope.presentarPor3.percentagesC[idxC] = parseFloat(
                $scope.presentarPor3.percentagesC[idxC]
              ).toFixed(2);
              $scope.dataC = $scope.presentarPor3.percentagesC;
            });
            // Periodo 2
            $scope.presentarPor3 = response.data.results;
            $scope.presentarPor3.percentages2.forEach(function (xc, idx) {
              $scope.labels2 = $scope.presentarPor3.percentages2;
            });
            $scope.presentarPor3.percentagesN2.forEach(function (xc, idx) {
              $scope.presentarPor3.percentagesN2[idx] = parseFloat(
                $scope.presentarPor3.percentagesN2[idx]
              ).toFixed(2);
              $scope.data2 = $scope.presentarPor3.percentagesN2;
            });
            $scope.presentarPor3.percentagesT2.forEach(function (xc, idx) {
              $scope.presentarPor3.percentagesT2[idx] = parseFloat(
                $scope.presentarPor3.percentagesT2[idx]
              ).toFixed(2);
              $scope.dataT2 = $scope.presentarPor3.percentagesT2;
            });
            $scope.presentarPor3.percentagesC2.forEach(function (xCc, idxC) {
              $scope.presentarPor3.percentagesC2[idxC] = parseFloat(
                $scope.presentarPor3.percentagesC2[idxC]
              ).toFixed(2);
              $scope.dataC2 = $scope.presentarPor3.percentagesC2;
            });
            // Recibos por Póliza/Fianza Contratante
            if (
              (vm.form.recibos && vm.form.group_by.id == 3) ||
              (vm.form.addEndosos && vm.form.group_by.id == 3)
            ) {
              $scope.presentarPor3 = response.data.results;
              $scope.presentarPor3.percentagesF.forEach(function (xc, idx) {
                $scope.labelsF = $scope.presentarPor3.percentagesF;
              });
              $scope.presentarPor3.percentagesNF.forEach(function (xc, idx) {
                $scope.presentarPor3.percentagesNF[idx] = parseFloat(
                  $scope.presentarPor3.percentagesNF[idx]
                ).toFixed(2);
                $scope.dataF = $scope.presentarPor3.percentagesNF;
              });
              $scope.presentarPor3.percentagesTF.forEach(function (xc, idx) {
                $scope.presentarPor3.percentagesTF[idx] = parseFloat(
                  $scope.presentarPor3.percentagesTF[idx]
                ).toFixed(2);
                $scope.dataTF = $scope.presentarPor3.percentagesTF;
              });
              $scope.presentarPor3.percentagesCF.forEach(function (xCc, idxC) {
                $scope.presentarPor3.percentagesCF[idxC] = parseFloat(
                  $scope.presentarPor3.percentagesCF[idxC]
                ).toFixed(2);
                $scope.dataCF = $scope.presentarPor3.percentagesCF;
              });
              // Periodo 2
              $scope.presentarPor3 = response.data.results;
              $scope.presentarPor3.percentages2F.forEach(function (xc, idx) {
                $scope.labels2F = $scope.presentarPor3.percentages2F;
              });
              $scope.presentarPor3.percentagesN2F.forEach(function (xc, idx) {
                $scope.presentarPor3.percentagesN2F[idx] = parseFloat(
                  $scope.presentarPor3.percentagesN2F[idx]
                ).toFixed(2);
                $scope.data2F = $scope.presentarPor3.percentagesN2F;
              });
              $scope.presentarPor3.percentagesT2F.forEach(function (xc, idx) {
                $scope.presentarPor3.percentagesT2F[idx] = parseFloat(
                  $scope.presentarPor3.percentagesT2F[idx]
                ).toFixed(2);
                $scope.dataT2F = $scope.presentarPor3.percentagesT2F;
              });
              $scope.presentarPor3.percentagesC2F.forEach(function (xCc, idxC) {
                $scope.presentarPor3.percentagesC2F[idxC] = parseFloat(
                  $scope.presentarPor3.percentagesC2F[idxC]
                ).toFixed(2);
                $scope.dataC2F = $scope.presentarPor3.percentagesC2F;
              });
            }
          } else {
            l3.stop();
          }
        },
        function error(err) {
          console.log("error", err);
          l3.stop();
        }
      );
    };
    // Get stadistics 1
    $scope.getStadistics = function (page, otro) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.stadistics = [];
      $scope.presentarPor = [];
      $scope.filters = {
        status: vm.estatusSelected ? vm.estatusSelected : 0,
        since: vm.form.since ? vm.form.since : "",
        until: vm.form.until ? vm.form.until : "",
        model: vm.form.model ? vm.form.model.id : 0,
        groupBy: vm.form.group_by ? vm.form.group_by.id : 0,
        polizasAdd: vm.form.polizas ? vm.form.polizas : false,
        recibosAdd: vm.form.recibos ? vm.form.recibos : false,
        fianzasAdd: vm.form.fianzas ? vm.form.fianzas : false,
        endososAdd: vm.form.addEndosos ? vm.form.addEndosos : false,
        period: $scope.period_select ? $scope.period_select : 1,
        page: page ? page : 1,
      };
      $scope.filters.since = $scope.filters.since + " " + "00:00:00";
      $scope.filters.until = $scope.filters.until + " " + "23:59:59";
      $http({
        method: "POST",
        url: url.IP + "reporte-stadistics/",
        data: $scope.filters,
      }).then(
        function success(response) {
          if ($scope.filters.groupBy != 0) {
            $scope.presentarPor = response.data.results;
            l.stop();
          } else {
            l.stop();
          }
        },
        function error(err) {
          console.log("error", err);
          l.stop();
        }
      );

      $localStorage.saved_filters_reporte_estadistico = angular.copy(
        $scope.filters
      );
      $localStorage.saved_filters_reporte_estadistico["group_by"] =
        vm.form.group_by;
      $localStorage.saved_filters_reporte_estadistico["selectTipo"] =
        vm.form.selectTipo;
      $localStorage.saved_filters_reporte_estadistico["period_select"] =
        $scope.period_select;
    };
    // Get stadistics 2
    $scope.getStadistics2 = function (page, otro) {
      var l2 = Ladda.create(document.querySelector(".ladda-button2"));
      l2.start();
      $scope.stadistics2 = [];
      $scope.presentarPor2 = [];
      $scope.filters2 = {
        status: vm.estatusSelected ? vm.estatusSelected : 0,
        since2: vm.form.since2 ? vm.form.since2 : "",
        until2: vm.form.until2 ? vm.form.until2 : "",
        model: vm.form.model ? vm.form.model.id : 0,
        groupBy: vm.form.group_by ? vm.form.group_by.id : 0,
        polizasAdd: vm.form.polizas ? vm.form.polizas : false,
        recibosAdd: vm.form.recibos ? vm.form.recibos : false,
        fianzasAdd: vm.form.fianzas ? vm.form.fianzas : false,
        endososAdd: vm.form.addEndosos ? vm.form.addEndosos : false,
        period: $scope.period_select ? $scope.period_select : 1,
        page: page ? page : 1,
      };
      $scope.filters2.since2 = $scope.filters2.since2 + " " + "00:00:00";
      $scope.filters2.until2 = $scope.filters2.until2 + " " + "23:59:59";
      $http({
        method: "POST",
        url: url.IP + "reporte-stadistics2/",
        data: $scope.filters2,
      }).then(
        function success(response) {
          if ($scope.filters2.groupBy != 0) {
            l2.stop();
            $scope.recContratantes = [];
            $scope.endoContratantes = [];
            $scope.recSucursal = [];
            $scope.endoSucursal = [];
            $scope.recMoneda = [];
            $scope.endoMoneda = [];
            $scope.presentarPor2 = response.data.results;
          } else {
            l2.stop();
          }
        },
        function error(err) {
          console.log("error", err);
          l2.stop();
        }
      );
    };
    $scope.getExcelData = function (param) {
      var l4 = Ladda.create(document.querySelector(".ladda-buttonE"));
      l4.start();
      $scope.filtros = {
        status: vm.estatusSelected ? vm.estatusSelected : 0,
        since2: vm.form.since2 ? vm.form.since2 : "",
        until2: vm.form.until2 ? vm.form.until2 : "",
        since: vm.form.since ? vm.form.since : "",
        until: vm.form.until ? vm.form.until : "",
        model: vm.form.model ? vm.form.model.id : 0,
        groupBy: vm.form.group_by ? vm.form.group_by.id : 0,
        polizasAdd: vm.form.polizas ? vm.form.polizas : false,
        recibosAdd: vm.form.recibos ? vm.form.recibos : false,
        fianzasAdd: vm.form.fianzas ? vm.form.fianzas : false,
        endososAdd: vm.form.addEndosos ? vm.form.addEndosos : false,
        period: $scope.period_select ? $scope.period_select : 1,
      };
      $scope.filtros.since2 = $scope.filtros.since2 + " " + "00:00:00";
      $scope.filtros.until2 = $scope.filtros.until2 + " " + "23:59:59";
      $scope.filtros.since = $scope.filtros.since + " " + "00:00:00";
      $scope.filtros.until = $scope.filtros.until + " " + "23:59:59";
      if (param == 1) {
        $scope.excel_stadistics = "service_reporte-stadistics1-excel";
        $http({
          method: "POST",
          url: url.IP + $scope.excel_stadistics,
          data: $scope.filtros,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(
          function (data, status, headers, config) {
            if (data.status == 200) {
              l4.stop();
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Estadística_1.xls");
            } else {
              SweetAlert.swal(
                "Error",
                "Ha ocurrido un error al descargar el reporte",
                "error"
              );
              l4.stop();
            }
          },
          function error(err) {
            console.log("error", err);
            l4.stop();
          }
        );
      }
    };
    // Estatus
    $scope.selectStatus = function (x, y) {
      vm.estatusSelected = [];
      $scope.parEst = [];
      if (x.length == 0) {
        $scope.parEst.push("Estatus -Todos.");
      }
      x.forEach(function (r) {
        if (r.id == 1) {
          $scope.parEst.push("Estatus -Vigente-");
        } else if (r.id == 2) {
          $scope.parEst.push("Estatus -Renovada-");
        } else if (r.id == 3) {
          $scope.parEst.push("Estatus -Vencida-");
        } else if (r.id == 4) {
          $scope.parEst.push("Estatus -Cancelada-");
        } else {
          $scope.parEst.push("Estatus -Todos.");
        }
        vm.estatusSelected.push(parseInt(r.id));
      });
    };
    // Change User
    $scope.selectUser = function (x, y) {
      vm.users_selected = [];
      x.forEach(function (r) {
        vm.users_selected.push(parseInt(r.id));
      });
    };
    // FormatNumber
    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }
    // Download report to excel
    $scope.export = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "md",
            resolve: {
              filters: function () {
                return $scope.filters;
              },
              from: function () {
                return null;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var lx = Ladda.create(document.querySelector(".ladda-button_excel"));
        lx.start();
        $scope.filters.orden = $scope.columnArray;
        $scope.filters.export_type = 2;
        if (param == 1) {
          $http({
            method: "POST",
            // url: url.IP +'reporte-log-excel' ,
            url: url.IP + "service_reporte-logReport-excel",
            data: $scope.filters,
            headers: {
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "arraybuffer",
          }).then(function (data, status, headers, config) {
            if (data.status == 200) {
              lx.stop();
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte Transacciones.xls");
            } else {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.ERRORDOWNLOADREP,
                "error"
              );
              lx.stop();
            }
          });
        }
      }
    };
    // Format Dates DD/MM/YYYY
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    // -----------PAGINACIÓN
    function PaginationResults(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        $scope.getStadistics(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("RecordatoriosTableCtrl", RecordatoriosTableCtrl);

  RecordatoriosTableCtrl.$inject = [
    "providerService",
    "$state",
    "appStates",
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
    "$rootScope",
  ];

  function RecordatoriosTableCtrl(
    providerService,
    $state,
    appStates,
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory,
    $rootScope
  ) {
    var vm = this;
    vm.recordatorios = [];
    vm.cargarRegistros = cargarRegistros;
    activate();

    function cargarRegistros(param, page) {
      $http
        .get(url.IP + "recordatorios/mis-registros-automaticos", {
          params: { param: param, page: page ? page : 1 },
        })
        .then(
          function (response) {
            vm.recordatorios = response.data.data;
            $scope.params = { param: param, page: page ? page : 1 };
            if (param == "pasadosvistos") {
              vm.recordatorios = response.data.results;
              $scope.recordatorios_config = {
                count: response.data.count,
                previous: url.IP + "recordatorios/mis-registros-automaticos",
                next: url.IP + "recordatorios/mis-registros-automaticos",
              };
              $scope.show_pag_misrecsi = true;
              testPagination("vm.recordatorios", "recordatorios_config");
            }
          },
          function (error) {}
        )
        .catch(function (error) {});
    }

    function activate() {
      $scope.showMisrecordatorios = true;
      cargarRegistros("hoy");
    }
    $scope.show_section = function (value) {
      switch (value) {
        case 1:
          $scope.showMisrecordatorios = true;
          $scope.showMisrecordatoriosNo = false;
          $scope.showMisrecordatoriosSi = false;
          break;
        case 2:
          $scope.showMisrecordatorios = false;
          $scope.showMisrecordatoriosNo = true;
          $scope.showMisrecordatoriosSi = false;
          break;
        case 3:
          $scope.showMisrecordatorios = false;
          $scope.showMisrecordatoriosNo = false;
          $scope.showMisrecordatoriosSi = true;
          break;
        default:
          $scope.showMisrecordatorios = true;
          $scope.showMisrecordatoriosNo = false;
          $scope.showMisrecordatoriosSi = false;
      }
    };

    $scope.showReminderAll = function () {
      var lenrecs = vm.recordatorios.length;
      var conteo = 0;
      vm.recordatorios.forEach(function (item, index) {
        // $scope.showReminder(item,index)
        $http.patch(item.url, { seen: true }).then(function (res) {
          conteo = conteo + 1;
        });
      });
      if (lenrecs == conteo) {
        cargarRegistros("pasados");
      }
    };

    $scope.showReminder = function (recordatorio, index) {
      $http.patch(recordatorio.url, { seen: true }).then(function () {
        vm.recordatorios[index]["seen"] = true;
        $rootScope.recordatorioscount = $rootScope.recordatorioscount - 1;
      });
      if (recordatorio.record_model == 1) {
        var template_url = "app/recordatorios/polizas.modal.html";
      } else if (recordatorio.record_model == 13) {
        var template_url = "app/recordatorios/fianzas.modal.html";
      } else if (recordatorio.record_model == 4) {
        var template_url = "app/recordatorios/recibos.modal.html";
      } else if (recordatorio.record_model == 10) {
        var template_url = "app/recordatorios/endosos.modal.html";
      } else if (recordatorio.record_model == 5) {
        var template_url = "app/recordatorios/siniestros.modal.html";
      } else if (recordatorio.record_model == 25) {
        var template_url = "app/recordatorios/certificado.modal.html";
      } else if (recordatorio.record_model == 22) {
        var template_url = "app/recordatorios/tareas.modal.html";
      } else if (recordatorio.record_model == 2) {
        var template_url = "app/recordatorios/contratante.modal.html";
      } else {
        var template_url = "app/recordatorios/polizas.modal.html";
      }

      if (recordatorio.instancia.tipo == "Libre") {
        template_url = "app/recordatorios/libres.modal.html";
      }
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: template_url,
        controller: ShowPolizaCtrl,
        size: "lg",
        resolve: {
          recordatorio: function () {
            return recordatorio;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    function ShowPolizaCtrl(
      $scope,
      $uibModalInstance,
      recordatorio,
      $sessionStorage,
      dataFactory
    ) {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.user = usr;
      $scope.recordatorio = recordatorio;
      $scope.poliza = {};
      $scope.siniestro = {};
      $scope.endorsement = {};

      $scope.tipo_title = {
        1: "Accidente",
        2: "Enfermedad",
        3: "Parto",
      };

      $scope.pago_title = {
        1: "Reembolso",
        2: "Programacion",
        3: "Pago Directo",
        4: "Aclaración",
      };

      $scope.status = {
        2: "En Trámite",
        3: "Completada/Procedente",
        4: "Cancelada",
        5: "Rechazada/ No Procedente",
        6: "En espera/ Solicitud de Información",
        7: "Reproceso",
        8: "Inconformidad",
      };

      if (recordatorio.instancia.tipo != "Libre") {
        var idp = "";
        if ($scope.recordatorio.instancia.poliza_id) {
          var idp = $scope.recordatorio.instancia.poliza_id;
        } else if ($scope.recordatorio.record_id) {
          var idp = $scope.recordatorio.record_id;
        }
        if (idp && recordatorio.record_model != 2) {
          dataFactory.get("leer-polizas-edit/" + idp).then(function (response) {
            $scope.poliza = response.data;
            $http.get($scope.poliza.contractor).then(function (contractor) {
              $scope.poliza["contractor"] = contractor.data;
              if (
                recordatorio.record_model == 4 &&
                recordatorio.instancia.receipt_type == 2
              ) {
                dataFactory
                  .get(
                    "endorsement-info/" + recordatorio.instancia.endoso_id + "/"
                  )
                  .then(function success(response) {
                    $scope.endorsement = response.data;
                  });
              }
              if (contractor.data.address_contractor) {
                $scope.poliza["contractor"]["address"] =
                  contractor.data.address_contractor[0];
              }
            });

            $http.get($scope.poliza.owner).then(function (owner) {
              $scope.poliza["owner"] = owner.data;
            });

            providerService
              .getProviderById($scope.poliza.aseguradora)
              .then(function (aseguradora) {
                $scope.poliza["aseguradora"] = aseguradora.data;
              });
          });
        }
        if (recordatorio.record_model == 10) {
          dataFactory
            .get("endorsement-info/" + recordatorio.record_id + "/")
            .then(function success(response) {
              $scope.endorsement = response.data;
            });
        }
        if (recordatorio.record_model == 2) {
          dataFactory
            .get("contractor/" + recordatorio.record_id + "/")
            .then(function success(response) {
              $scope.contratante = response.data;
            });
        }

        if (recordatorio.record_model == 5) {
          dataFactory
            .get("siniester_get_by_id/" + recordatorio.record_id)
            .then(function (response) {
              $scope.siniestro = response.data;
            });
        }
      }
      // Menú rapido
      // $scope.getPDF = getPDF;

      $scope.gotoTarea = function (tarea) {
        if (tarea || (recordatorio && recordatorio.record_id)) {
          var params = { id_task: recordatorio.record_id, main_comming: true };
          $scope.open_in_same_tab_natural("Tareas", "task.task", params);
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
      $scope.open_in_same_tab_natural = function (
        name,
        route,
        params,
        identifier
      ) {
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
        }

        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
        $localStorage.tab_states = appStates.states;
        $localStorage.tab_index = $localStorage.tab_states.length - 1;
        $state.go($scope.route_for_new_tab, params);
      };

      function checkType(type) {
        //jshint ignore:line
        return type === 1 ? "fisicas" : "morales";
      }
      $scope.goToContractor = function (recordatorio) {
        // $scope.open_in_same_tab_natural('Información Contratante', 'contratantes.info',{endosoId: recordatorio.record_id}, recordatorio.record_id , null);
        $scope.open_in_same_tab_natural(
          "Información Contratante",
          "contratantes.info",
          {
            type: checkType($scope.contratante.type_person),
            contratanteId: $scope.contratante.id,
          },
          $scope.contratante.id,
          $scope.contratante.type_person
        );
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
      $scope.goToEndoso = function (recordatorio) {
        $scope.open_in_same_tab_natural(
          "Información Endoso",
          "endorsement.info",
          { endosoId: recordatorio.record_id },
          recordatorio.record_id,
          null
        );

        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.goToSiniestro = function (siniestro) {
        if (siniestro.siniestro.tipo_siniestro_general == 3) {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.auto_info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.auto_info', {siniestroId: siniestro.siniestro.id});
        } else if (siniestro.siniestro.tipo_siniestro_general == 1) {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.vida_info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.vida_info', {siniestroId: siniestro.siniestro.id});
        } else if (siniestro.siniestro.tipo_siniestro_general == 2) {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.info', {siniestroId: siniestro.siniestro.id});
        } else {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.danio_info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.danio_info', {siniestroId: siniestro.siniestro.id});
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.goToPolicy = function (poliza) {
        console.log(poliza);
        if (poliza.document_type == 1) {
          $scope.open_in_same_tab_natural(
            "Pólizas",
            "polizas.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('polizas.info', {polizaId: poliza.id});
        } else if (poliza.document_type == 3) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('colectividades.info', {polizaId: poliza.id});
        } else if (poliza.document_type == 4) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.caratula },
            poliza.caratula
          );
          // $state.go('colectividades.info', {polizaId: poliza.caratula});
        } else if (poliza.document_type == 6) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.caratula },
            poliza.caratula
          );
          // $state.go('colectividades.info', {polizaId: poliza.caratula})
        } else if (poliza.document_type == 7) {
          $scope.open_in_same_tab_natural(
            "Fianzas",
            "fianzas.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('fianzas.info', {polizaId: poliza.id})
        } else if (poliza.document_type == 8) {
          $scope.open_in_same_tab_natural(
            "Fianzas",
            "fianzas.details",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('fianzas.details',{polizaId: poliza.id})
        } else if (poliza.document_type == 12) {
          $scope.open_in_same_tab_natural(
            "Flotillas",
            "flotillas.info",
            { polizaId: parseInt(poliza.caratula) },
            poliza.id
          );
          // $state.go('flotillas.info',{polizaId: parseInt(poliza.caratula)})
        } else if (poliza.document_type == 11) {
          $scope.open_in_same_tab_natural(
            "Flotillas",
            "flotillas.info",
            { polizaId: parseInt(poliza.caratula) },
            poliza.id
          );
          // $state.go('flotillas.info',{polizaId: parseInt(poliza.id)})
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.goToReceipt = function (recordatorio, poliza) {
        if (recordatorio.instancia.receipt_type == 1) {
          $scope.open_in_same_tab_natural(
            "Pólizas",
            "polizas.info",
            { polizaId: recordatorio.instancia.poliza_id },
            recordatorio.instancia.poliza_id
          );
        } else if (recordatorio.instancia.receipt_type == 2) {
          $scope.open_in_same_tab_natural(
            "Endosos",
            "endorsement.info",
            { endosoId: recordatorio.instancia.endoso_id },
            recordatorio.instancia.endoso_id
          );
        } else if (recordatorio.instancia.receipt_type == 3) {
          $scope.open_in_same_tab_natural(
            "Endosos",
            "endorsement.info",
            { endosoId: recordatorio.instancia.endoso_id },
            recordatorio.instancia.endoso_id
          );
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.forma_pago = function (parValue) {
        switch (parValue) {
          case 1:
            return "Mensual";
            break;
          case 2:
            return "Bimestral";
            break;
          case 3:
            return "Trimestral";
            break;
          case 5:
            return "Contado";
            break;
          case 6:
            return "Semestral";
            break;
          case 12:
            return "Anual";
            break;
          case 24:
            return "Quincenal";
            break;
          default:
            return "No especificada";
        }
      };

      $scope.status = function (parValue) {
        switch (parValue) {
          case 1:
            return "En trámite";
            break;
          case 2:
            return "OT Cancelada";
            break;
          case 4:
            return "Precancelada";
            break;
          case 10:
            return "Por iniciar";
            break;
          case 11:
            return "Cancelada";
            break;
          case 12:
            return "Renovada";
            break;
          case 13:
            return "Vencida";
            break;
          case 14:
            return "Vigente";
            break;
          case 15:
            return "No renovada";
            break;
          default:
            return "Pendiente";
        }
      };
      $scope.statusEndoso = function (parValue) {
        switch (parValue) {
          case 1:
            return "Pendiente";
            break;
          case 2:
            return "Registrado";
            break;
          case 3:
            return "Rechazado";
            break;
          case 4:
            return "Cancelado";
            break;
          case 5:
            return "En trámite";
            break;
          default:
            return "Pendiente";
        }
      };
      $scope.dismis = function (receipt) {
        $uibModalInstance.dismiss("cancel");
        changeStatusModal(receipt, $scope.myPolicy);
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        $scope.params.page = parPage;
        dataFactory
          .get("recordatorios/mis-registros-automaticos", $scope.params)
          .then(function success(response) {
            vm.recordatorios = response.data.results;

            $scope.recordatorios_config = {
              count: response.data.count,
              previous: url.IP + "recordatorios/mis-registros-automaticos",
              next: url.IP + "recordatorios/mis-registros-automaticos",
            };
            $scope.show_pag_recatm = true;
            testPagination("vm.recordatorios", "recordatorios_config");
          });
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("RecordatoriosLibresShowCtrl", RecordatoriosLibresShowCtrl);

  RecordatoriosLibresShowCtrl.$inject = [
    "providerService",
    "$state",
    "appStates",
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
  ];

  function RecordatoriosLibresShowCtrl(
    providerService,
    $state,
    appStates,
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory
  ) {
    var vm = this;
    $scope.action = "";
    $scope.recordatorio_id = 0;
    $scope.loader = false;
    $scope.form = {
      nombre: "",
      providers: [],
      subramos: [],
      descr: "",
      fecha_vencimiento_polizas: 0,
      fecha_inicio_vigencia_recibos: 0,
      fecha_vencimiento_recibos: 0,
      fecha_promesa_pago_recibos: 0,
      fecha_compromiso_siniestros: 0,
    };

    vm.cargarRegistros = cargarRegistros;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.users = [];
    vm.users_selected = [];
    $scope.select_created_by = [];

    $scope.opciones = [0, -1, -2, -3, 1, 2];

    activate();
    // Start functionality
    function activate() {
      $(".js-example-basic-multiple").select2();
      $scope.recordatorio_id = $stateParams.id;
      if (parseInt($scope.recordatorio_id)) {
        $scope.loader = true;
        $http
          .get(url.IP + "recordatorios/libres/" + $scope.recordatorio_id)
          .then(function (response) {
            $scope.form = response.data;
          });
        vm.cargarRegistros();
      } else {
      }
      $scope.action = !parseInt($scope.recordatorio_id)
        ? "Nuevo"
        : "Información";
    }

    $scope.cancel = function () {
      $scope.open_in_same_tab(
        "Recordatorios",
        "recordatorios.libres",
        {},
        null,
        null
      );
    };

    function cargarRegistros() {
      $http
        .get(url.IP + "recordatorios/registros-automaticos", {
          params: { recordatorio_id: $scope.recordatorio_id },
        })
        .then(
          function (response) {
            console.log(response);
            vm.recordatorios = response.data;
            $scope.loader = false;
          },
          function (error) {
            $scope.loader = false;
          }
        )
        .catch(function (error) {
          $scope.loader = false;
        });
    }

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    $scope.showReminder = function (recordatorio, index) {
      $http.patch(recordatorio.url, { seen: true }).then(function () {
        vm.recordatorios[index]["seen"] = true;
      });

      var template_url = "app/recordatorios/libres.modal.html";

      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: template_url,
        controller: ShowPolizaCtrl,
        size: "lg",
        resolve: {
          recordatorio: function () {
            return recordatorio;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    function ShowPolizaCtrl(
      $scope,
      $uibModalInstance,
      recordatorio,
      $sessionStorage,
      dataFactory
    ) {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.user = usr;
      $scope.recordatorio = recordatorio;

      $scope.dismis = function (receipt) {
        $uibModalInstance.dismiss("cancel");
        changeStatusModal(receipt, $scope.myPolicy);
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "RecordatoriosLibresDetalleCtrl",
      RecordatoriosLibresDetalleCtrl
    );

  RecordatoriosLibresDetalleCtrl.$inject = [
    "providerService",
    "$state",
    "appStates",
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
  ];

  function RecordatoriosLibresDetalleCtrl(
    providerService,
    $state,
    appStates,
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory
  ) {
    var vm = this;
    $scope.action = "";
    $scope.recordatorio_id = 0;
    $scope.form = {
      nombre: "",
      descr: "",
      fecha_programada: datesFactory.convertDate(new Date()),
      hora_programada: new Date(),
    };

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.users = [];
    vm.users_selected = [];
    $scope.select_created_by = [];

    activate();
    // Start functionality
    function activate() {
      $scope.recordatorio_id = $stateParams.id;
      console.log("recordatorio_id", $scope.recordatorio_id);
      if (parseInt($scope.recordatorio_id)) {
        $http
          .get(url.IP + "recordatorios/libres/" + $scope.recordatorio_id)
          .then(function (response) {
            $scope.form = response.data;
            $scope.form.fecha_programada = datesFactory.convertDate(
              $scope.form.fecha_programada
            );
            $scope.form.hora_programada = new Date().setHours(
              $scope.form["hora_programada"].split(":")[0],
              $scope.form["hora_programada"].split(":")[1],
              0
            );
          });
      } else {
      }
      $scope.action = !parseInt($scope.recordatorio_id)
        ? "Nuevo"
        : "Información";
    }

    $scope.cancel = function () {
      $scope.open_in_same_tab(
        "Recordatorios",
        "recordatorios.libres",
        {},
        null,
        null
      );
    };

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };
    $scope.timeDate = function (hr) {
      if (hr == null || hr == undefined) {
        $scope.form.hora_programada = new Date().getTime();
      }
    };
    $scope.save = function () {
      var time = angular.copy(new Date($scope.form.hora_programada));
      time = time.toLocaleTimeString("es-MX");

      var fecha_programada = new Date($scope.form.hora_programada);
      fecha_programada.setDate(
        datesFactory.toDate($scope.form.fecha_programada).getDate()
      );
      fecha_programada.setMonth(
        datesFactory.toDate($scope.form.fecha_programada).getMonth()
      );
      fecha_programada.setFullYear(
        datesFactory.toDate($scope.form.fecha_programada).getFullYear()
      );
      var payload = angular.copy($scope.form);
      // payload['fecha_programada'] = fecha_programada
      payload["fecha_programada"] = datesFactory.toDate(
        $scope.form.fecha_programada
      );
      payload["hora_programada"] = time;
      if ($scope.form.url) {
        $http
          .patch(payload.url, payload)
          .then(
            function () {
              toaster.success("Recordatorio actualizado exitosamente");
              setTimeout(function () {
                $scope.open_in_same_tab(
                  "Recordatorios",
                  "recordatorios.libres",
                  {},
                  null,
                  null
                );
              }, 1000);
            },
            function (error) {
              console.error(error);
              toaster.error("Ha ocurrido un error");
            }
          )
          .catch(function (error) {
            console.error(error);
            toaster.error("Ha ocurrido un error");
          });
      } else {
        $http
          .post(url.IP + "recordatorios/libres/", payload)
          .then(
            function () {
              toaster.success("Recordatorio creado exitosamente");
              setTimeout(function () {
                $scope.open_in_same_tab(
                  "Recordatorios",
                  "recordatorios.libres",
                  {},
                  null,
                  null
                );
              }, 1000);
            },
            function (error) {
              console.error(error);
              toaster.error("Ha ocurrido un error");
            }
          )
          .catch(function (error) {
            console.error(error);
            toaster.error("Ha ocurrido un error");
          });
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("RecordatoriosLibresCtrl", RecordatoriosLibresCtrl);

  RecordatoriosLibresCtrl.$inject = [
    "$state",
    "appStates",
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
  ];

  function RecordatoriosLibresCtrl(
    $state,
    appStates,
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory
  ) {
    var vm = this;
    vm.recordatorios = [];

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.users = [];
    vm.users_selected = [];
    $scope.select_created_by = [];
    $scope.show_pag_recfree = false;

    activate(1);
    // Start functionality
    function activate(page) {
      $(".js-example-basic-multiple").select2();
      $scope.params = {
        page: page ? page : 1,
      };
      $http
        .get(url.IP + "recordatorios/libres", $scope.params)
        .then(function (response) {
          vm.recordatorios = response.data.results;
          $scope.recordatorios_config = {
            count: response.data.count,
            previous: url.IP + "recordatorios/libres",
            next: url.IP + "recordatorios/libres",
          };
          $scope.show_pag_recfree = true;
          testPagination("vm.recordatorios", "recordatorios_config");
        });
    }

    $scope.crear_recordatorio = function () {
      $scope.open_in_same_tab(
        "Recordatorios",
        "recordatorios.libres_detalle",
        { id: 0 },
        0,
        null
      );
    };

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    $scope.save = function () {
      console.log($scope.select_created_by);
      var toSave = $scope.select_created_by.map(function (item) {
        return item.id;
      });
      $http.post(url.IP + "group-manager/", toSave).then(function () {
        vm.users_selected = $scope.select_created_by;
      });
    };

    $scope.editReminder = function (recordatorio) {
      $scope.open_in_same_tab(
        "Información Recordatorio",
        "recordatorios.libres_detalle",
        { id: recordatorio.id },
        recordatorio.id,
        null
      );
    };

    $scope.deleteReminder = function (recordatorio, index) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este recordatorio",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(recordatorio.url).then(function (response) {
              vm.recordatorios.splice(index, 1);
              toaster.success("Recordatorio eliminado exitosamente");
            });
          }
        }
      );
    };

    $scope.showReminder = function (recordatorio, index) {
      $scope.open_in_same_tab(
        "Información Recordatorio",
        "recordatorios.libres_show",
        { id: recordatorio.id },
        recordatorio.id,
        null
      );
    };
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        $scope.params.page = parPage;

        dataFactory
          .get("recordatorios/libres", $scope.params)
          .then(function success(response) {
            vm.recordatorios = response.data.results;

            $scope.recordatorios_config = {
              count: response.data.count,
              previous: url.IP + "recordatorios/libres",
              next: url.IP + "recordatorios/libres",
            };
            $scope.show_pag_task = true;
            testPagination("vm.recordatorios", "recordatorios_config");

            vm.recordatorios.forEach(function (child) {
              if (!$localStorage[child.owner.username]) {
                $http({
                  method: "GET",
                  url: url.IP_CAS + "get-user-picture/" + child.owner.username,
                })
                  .then(function (request) {
                    if (request.status === 200) {
                      child.image = request.data.url;
                      $localStorage[child.owner.username] = request.data.url;
                    }
                  })
                  .catch(function (e) {
                    console.log("e", e);
                  });
              } else {
                child.image = $localStorage[child.owner.username];
              }
            });
          });
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("RecordatorioRegistroCtrl", RecordatorioRegistroCtrl);

  RecordatorioRegistroCtrl.$inject = [
    "$state",
    "parent",
    "statusReceiptsFactory",
    "$uibModalInstance",
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
    "poliza",
    "tipoRegistro",
  ];

  function RecordatorioRegistroCtrl(
    $state,
    parent,
    statusReceiptsFactory,
    $uibModalInstance,
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory,
    poliza,
    tipoRegistro
  ) {
    var vm = this;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.users = [];
    vm.users_selected = [];
    $scope.select_created_by = [];
    $scope.poliza = poliza;
    $scope.parent = parent;
    console.log("--s registro", poliza, tipoRegistro);
    $scope.tipoRegistro = tipoRegistro;
    $scope.form = {
      nombre_rec: "",
      descr: "",
      fecha_programada: datesFactory.convertDate(new Date()),
      hora_programada: new Date(),
    };
    activate();
    // Start functionality
    function activate() {
      $(".js-example-basic-multiple").select2();
      if (tipoRegistro == 1) {
        $scope.tipo = "Póliza";
      } else if (tipoRegistro == 4) {
        $scope.tipo = "Recibo";
      } else if (tipoRegistro == 2) {
        $scope.tipo = "Contratante";
      } else if (tipoRegistro == 13) {
        $scope.tipo = "Fianza";
      } else if (tipoRegistro == 10) {
        $scope.tipo = "Endoso";
      } else if (tipoRegistro == 25) {
        $scope.tipo = "Certificado";
      } else if (tipoRegistro == 5) {
        $scope.tipo = "Siniestro";
      } else if (tipoRegistro == 22) {
        $scope.tipo = "Tareas";
      }
      $http.get(url.IP + "group-manager/").then(function (response) {
        $http.get(url.IP + "usuarios/").then(function (user) {
          user.data.results.forEach(function (usr) {
            response["data"].forEach(function (item) {
              if (item.user == usr.id) {
                vm.users_selected.push(usr);
                $scope.select_created_by.push(usr);
              }
            });
            if (usr.user_info.is_active) {
              vm.users.push(usr);
            }
          });
        });
      });
    }
    $scope.timeDate = function (hr) {
      if (hr == null || hr == undefined) {
        $scope.form.hora_programada = new Date().getTime();
      }
    };

    $scope.save = function () {
      var time = angular.copy(new Date($scope.form.hora_programada));
      time = time.toLocaleTimeString("es-MX");
      var fecha_programada = new Date($scope.form.hora_programada);
      fecha_programada.setDate(
        datesFactory.toDate($scope.form.fecha_programada).getDate()
      );
      fecha_programada.setMonth(
        datesFactory.toDate($scope.form.fecha_programada).getMonth()
      );
      fecha_programada.setFullYear(
        datesFactory.toDate($scope.form.fecha_programada).getFullYear()
      );
      //
      var fecha_programada = new Date($scope.form.hora_programada);
      fecha_programada.setDate(
        datesFactory.toDate($scope.form.fecha_programada).getDate()
      );
      fecha_programada.setMonth(
        datesFactory.toDate($scope.form.fecha_programada).getMonth()
      );
      fecha_programada.setFullYear(
        datesFactory.toDate($scope.form.fecha_programada).getFullYear()
      );
      var payload = angular.copy($scope.form);
      //
      var recordatorioI = {};
      // recordatorioI['fecha_programada'] = fecha_programada;
      recordatorioI["fecha_programada"] = datesFactory.toDate(
        $scope.form.fecha_programada
      );
      recordatorioI["hora_programada"] = time;
      recordatorioI["nombre"] = $scope.form.nombre_rec;
      recordatorioI["descr"] = $scope.form.descr;
      recordatorioI["registro_id"] = poliza.id;
      recordatorioI["modelo"] = tipoRegistro;
      $http
        .post(url.IP + "recordatorios/desde-registros/", recordatorioI)
        .then(
          function (response) {
            if (response.data) {
              toaster.success("Recordatorio creado exitosamente");
              $state.reload();
              $scope.cancel();
            }
          },
          function (error) {
            console.error(error);
            toaster.error("Ha ocurrido un error");
          }
        )
        .catch(function (error) {
          console.error(error);
          toaster.error("Ha ocurrido un error");
        });
    };

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };
    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "Pendiente";
      }
    };
    $scope.checkStatusReceipts = function (parStatus) {
      $scope.statusReceipt = statusReceiptsFactory.receipts(parStatus.status);
      if (
        $scope.poliza_multianual &&
        $scope.statusReceipt == "Pendiente de pago" &&
        parStatus.prima_neta == 0
      ) {
        $scope.statusReceipt = "Pendiente de actualizar";
      }
      return $scope.statusReceipt;
    };
    $scope.cancel = function (pay) {
      $uibModalInstance.dismiss("cancel");
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "RecordatoriosDesdeRegistroShowCtrl",
      RecordatoriosDesdeRegistroShowCtrl
    );

  RecordatoriosDesdeRegistroShowCtrl.$inject = [
    "providerService",
    "$state",
    "appStates",
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
  ];

  function RecordatoriosDesdeRegistroShowCtrl(
    providerService,
    $state,
    appStates,
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory
  ) {
    var vm = this;
    $scope.action = "";
    $scope.recordatorio_id = 0;
    $scope.loader = false;
    $scope.form = {
      nombre: "",
      providers: [],
      subramos: [],
      descr: "",
      fecha_vencimiento_polizas: 0,
      fecha_inicio_vigencia_recibos: 0,
      fecha_vencimiento_recibos: 0,
      fecha_promesa_pago_recibos: 0,
      fecha_compromiso_siniestros: 0,
    };

    vm.cargarRegistros = cargarRegistros;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.users = [];
    vm.users_selected = [];
    $scope.select_created_by = [];

    $scope.opciones = [0, -1, -2, -3, 1, 2];

    activate();
    // Start functionality
    function activate() {
      $(".js-example-basic-multiple").select2();
      $scope.recordatorio_id = $stateParams.id;
      if (parseInt($scope.recordatorio_id)) {
        $scope.loader = true;
        $http
          .get(
            url.IP + "recordatorios/desde-registros/" + $scope.recordatorio_id
          )
          .then(function (response) {
            $scope.form = response.data;
          });
        vm.cargarRegistros();
      } else {
      }
      $scope.action = !parseInt($scope.recordatorio_id)
        ? "Nuevo"
        : "Información";
    }

    $scope.cancel = function () {
      $scope.open_in_same_tab(
        "Recordatorios",
        "recordatorios.desde_registros",
        {},
        null,
        null
      );
    };

    function cargarRegistros() {
      $http
        .get(url.IP + "recordatorios/registros-automaticos", {
          params: { recordatorio_id: $scope.recordatorio_id },
        })
        .then(
          function (response) {
            console.log(response);
            vm.recordatorios = response.data;
            $scope.loader = false;
          },
          function (error) {
            $scope.loader = false;
          }
        )
        .catch(function (error) {
          $scope.loader = false;
        });
    }

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    $scope.showReminder = function (recordatorio, index) {
      $http.patch(recordatorio.url, { seen: true }).then(function () {
        vm.recordatorios[index]["seen"] = true;
      });
      if (recordatorio.record_model == 1) {
        var template_url = "app/recordatorios/polizas.modal.html";
      } else if (recordatorio.record_model == 4) {
        var template_url = "app/recordatorios/recibos.modal.html";
      } else if (recordatorio.record_model == 10) {
        var template_url = "app/recordatorios/endosos.modal.html";
      } else if (recordatorio.record_model == 5) {
        var template_url = "app/recordatorios/siniestros.modal.html";
      } else if (recordatorio.record_model == 2) {
        var template_url = "app/recordatorios/libres.modal.html";
      } else if (recordatorio.record_model == 13) {
        var template_url = "app/recordatorios/fianzas.modal.html";
      } else if (recordatorio.record_model == 22) {
        var template_url = "app/recordatorios/tareas.modal.html";
      } else {
        var template_url = "app/recordatorios/polizas.modal.html";
      }
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: template_url,
        controller: ShowPolizaCtrl,
        size: "lg",
        resolve: {
          recordatorio: function () {
            return recordatorio;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    function ShowPolizaCtrl(
      $scope,
      $uibModalInstance,
      recordatorio,
      $sessionStorage,
      dataFactory
    ) {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.user = usr;
      $scope.recordatorio = recordatorio;
      $scope.poliza = {};
      $scope.siniestro = {};
      $scope.endorsement = {};

      $scope.tipo_title = {
        1: "Accidente",
        2: "Enfermedad",
        3: "Parto",
      };

      $scope.pago_title = {
        1: "Reembolso",
        2: "Programacion",
        3: "Pago Directo",
        4: "Aclaración",
      };

      $scope.status = {
        2: "En Trámite",
        3: "Completada/Procedente",
        4: "Cancelada",
        5: "Rechazada/ No Procedente",
        6: "En espera/ Solicitud de Información",
        7: "Reproceso",
        8: "Inconformidad",
      };

      if (recordatorio.record_model != 2) {
        dataFactory
          .get("leer-polizas-edit/" + $scope.recordatorio.instancia.poliza_id)
          .then(function (response) {
            $scope.poliza = response.data;
            $http.get($scope.poliza.contractor).then(function (contractor) {
              $scope.poliza["contractor"] = contractor.data;

              if (contractor.data.address_contractor) {
                $scope.poliza["contractor"]["address"] =
                  contractor.data.address_contractor[0];
              }
            });

            $http.get($scope.poliza.owner).then(function (owner) {
              $scope.poliza["owner"] = owner.data;
            });

            providerService
              .getProviderById($scope.poliza.aseguradora)
              .then(function (aseguradora) {
                $scope.poliza["aseguradora"] = aseguradora.data;
              });
          });
      }
      if (recordatorio.record_model == 4) {
        if (recordatorio.instancia) {
          if (recordatorio.instancia.endoso_id) {
            dataFactory
              .get("endorsement-info/" + recordatorio.instancia.endoso_id + "/")
              .then(function success(response) {
                $scope.endorsement = response.data;
              });
          }
        }
      }
      if (recordatorio.record_model == 10) {
        dataFactory
          .get("endorsement-info/" + recordatorio.record_id + "/")
          .then(function success(response) {
            $scope.endorsement = response.data;
          });
      }

      if (recordatorio.record_model == 5) {
        dataFactory
          .get("siniester_get_by_id/" + recordatorio.record_id)
          .then(function (response) {
            $scope.siniestro = response.data;
          });
      }
      if (recordatorio.record_model == 22) {
        dataFactory
          .get("ticket/" + recordatorio.record_id)
          .then(function (response) {
            $scope.tarea = response.data;
          });
      }

      // Menú rapido
      // $scope.getPDF = getPDF;

      $scope.open_in_same_tab_natural = function (
        name,
        route,
        params,
        identifier
      ) {
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
        }

        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
        $localStorage.tab_states = appStates.states;
        $localStorage.tab_index = $localStorage.tab_states.length - 1;
        $state.go($scope.route_for_new_tab, params);
      };

      $scope.goToEndoso = function (recordatorio) {
        if (
          recordatorio.instancia.document_type_poliza == 7 ||
          recordatorio.instancia.document_type_poliza == 8 ||
          recordatorio.instancia.document_type_poliza == 9 ||
          recordatorio.instancia.document_type_poliza == 10
        ) {
          $scope.open_in_same_tab_natural(
            "Información Endoso",
            "endorsement.details",
            { endosoId: recordatorio.record_id },
            recordatorio.record_id,
            null
          );
        } else {
          $scope.open_in_same_tab_natural(
            "Información Endoso",
            "endorsement.info",
            { endosoId: recordatorio.record_id },
            recordatorio.record_id,
            null
          );
        }

        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.goToContratante = function (recordatorio) {
        console.log(recordatorio);
        if (parseInt(recordatorio.instancia.document_type_poliza) == 1) {
          $scope.open_in_same_tab_natural(
            "Información Contratante",
            "contratantes.info",
            { type: "fisicas", contratanteId: recordatorio.record_id },
            recordatorio.record_id,
            null
          );
        } else {
          $scope.open_in_same_tab_natural(
            "Información Contratante",
            "contratantes.info",
            { type: "morales", contratanteId: recordatorio.record_id },
            recordatorio.record_id,
            null
          );
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.goToSiniestro = function (siniestro) {
        if (siniestro.siniestro.tipo_siniestro_general == 3) {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.auto_info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.auto_info', {siniestroId: siniestro.siniestro.id});
        } else if (siniestro.siniestro.tipo_siniestro_general == 1) {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.vida_info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.vida_info', {siniestroId: siniestro.siniestro.id});
        } else if (siniestro.siniestro.tipo_siniestro_general == 2) {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.info', {siniestroId: siniestro.siniestro.id});
        } else {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.danio_info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.danio_info', {siniestroId: siniestro.siniestro.id});
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.goToPolicy = function (poliza) {
        if (poliza.document_type == 1) {
          $scope.open_in_same_tab_natural(
            "Pólizas",
            "polizas.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('polizas.info', {polizaId: poliza.id});
        } else if (poliza.document_type == 3) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('colectividades.info', {polizaId: poliza.id});
        } else if (poliza.document_type == 4) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.caratula },
            poliza.caratula
          );
          // $state.go('colectividades.info', {polizaId: poliza.caratula});
        } else if (poliza.document_type == 6) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.caratula },
            poliza.caratula
          );
          // $state.go('colectividades.info', {polizaId: poliza.caratula})
        } else if (poliza.document_type == 7) {
          $scope.open_in_same_tab_natural(
            "Fianzas",
            "fianzas.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('fianzas.info', {polizaId: poliza.id})
        } else if (poliza.document_type == 8) {
          $scope.open_in_same_tab_natural(
            "Fianzas",
            "fianzas.details",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('fianzas.details',{polizaId: poliza.id})
        } else if (poliza.document_type == 12) {
          $scope.open_in_same_tab_natural(
            "Flotillas",
            "flotillas.info",
            { polizaId: parseInt(poliza.caratula) },
            poliza.id
          );
          // $state.go('flotillas.info',{polizaId: parseInt(poliza.caratula)})
        } else if (poliza.document_type == 11) {
          $scope.open_in_same_tab_natural(
            "Flotillas",
            "flotillas.info",
            { polizaId: parseInt(poliza.caratula) },
            poliza.id
          );
          // $state.go('flotillas.info',{polizaId: parseInt(poliza.id)})
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
      $scope.gotoTarea = function (tarea) {
        if (tarea) {
          var params = { id_task: tarea.id, main_comming: true };
          $scope.open_in_same_tab_natural("Tareas", "task.task", params);
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
      $scope.goToReceipt = function (recordatorio, poliza) {
        if (recordatorio.instancia.receipt_type == 1) {
          $scope.open_in_same_tab_natural(
            "Pólizas",
            "polizas.info",
            { polizaId: recordatorio.instancia.poliza_id },
            recordatorio.instancia.poliza_id
          );
        } else if (recordatorio.instancia.receipt_type == 2) {
          $scope.open_in_same_tab_natural(
            "Endosos",
            "endorsement.info",
            { endosoId: recordatorio.instancia.endoso_id },
            recordatorio.instancia.endoso_id
          );
        } else if (recordatorio.instancia.receipt_type == 3) {
          $scope.open_in_same_tab_natural(
            "Endosos",
            "endorsement.info",
            { endosoId: recordatorio.instancia.endoso_id },
            recordatorio.instancia.endoso_id
          );
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.forma_pago = function (parValue) {
        switch (parValue) {
          case 1:
            return "Mensual";
            break;
          case 2:
            return "Bimestral";
            break;
          case 3:
            return "Trimestral";
            break;
          case 5:
            return "Contado";
            break;
          case 6:
            return "Semestral";
            break;
          case 12:
            return "Anual";
            break;
          case 24:
            return "Quincenal";
            break;
          default:
            return "No especificada";
        }
      };

      $scope.status = function (parValue) {
        switch (parValue) {
          case 1:
            return "En trámite";
            break;
          case 2:
            return "OT Cancelada";
            break;
          case 4:
            return "Precancelada";
            break;
          case 10:
            return "Por iniciar";
            break;
          case 11:
            return "Cancelada";
            break;
          case 12:
            return "Renovada";
            break;
          case 13:
            return "Vencida";
            break;
          case 14:
            return "Vigente";
            break;
          case 15:
            return "No renovada";
            break;
          default:
            return "Pendiente";
        }
      };

      $scope.dismis = function (receipt) {
        $uibModalInstance.dismiss("cancel");
        changeStatusModal(receipt, $scope.myPolicy);
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "RecordatoriosDesdeRegistroDetalleCtrl",
      RecordatoriosDesdeRegistroDetalleCtrl
    );

  RecordatoriosDesdeRegistroDetalleCtrl.$inject = [
    "providerService",
    "$state",
    "appStates",
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
  ];

  function RecordatoriosDesdeRegistroDetalleCtrl(
    providerService,
    $state,
    appStates,
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory
  ) {
    var vm = this;
    $scope.action = "";
    $scope.recordatorio_id = 0;
    $scope.form = {
      nombre: "",
      descr: "",
      fecha_programada: datesFactory.convertDate(new Date()),
      hora_programada: new Date(),
    };

    $scope.registro_seleccionado = {
      id: 0,
      modelo: 0,
    };

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.users = [];
    vm.users_selected = [];
    $scope.select_created_by = [];

    $scope.policyLay = [];

    $scope.$watch("searchPolicy.value", function (newValue, oldValue) {
      if (
        $scope.searchPolicy &&
        $scope.searchPolicy.value &&
        $scope.searchPolicy.value.poliza_number
      ) {
        $scope.policyLay.id = $scope.searchPolicy.value.id;
        $scope.policyLay.selected = false;
        $scope.policyLay.poliza_number =
          $scope.searchPolicy.value.poliza_number;
        $scope.policyLay.start = datesFactory.convertDate(
          $scope.searchPolicy.value.start_of_validity
        );
        $scope.policyLay.end = datesFactory.convertDate(
          $scope.searchPolicy.value.end_of_validity
        );
        $scope.policyLay.recibos = $scope.searchPolicy.value.recibos_poliza;
        if ($scope.policyLay.recibos && $scope.policyLay.recibos.length > 0) {
          $scope.policyLay.recibos = $scope.policyLay.recibos.map(function (
            item
          ) {
            item["selected"] = false;
            return item;
          });
        }
        $scope.policyLay.endosos = $scope.searchPolicy.value.endosos_poliza;
        if ($scope.policyLay.endosos && $scope.policyLay.endosos.length > 0) {
          $scope.policyLay.endosos = $scope.policyLay.endosos.map(function (
            item
          ) {
            item["selected"] = false;
            return item;
          });
        }
        $scope.policyLay.siniestros =
          $scope.searchPolicy.value.siniestros_poliza;
        if (
          $scope.policyLay.siniestros &&
          $scope.policyLay.siniestros.length > 0
        ) {
          $scope.policyLay.siniestros = $scope.policyLay.siniestros.map(
            function (item) {
              item["selected"] = false;
              return item;
            }
          );
        }
        toaster.success(
          "Seleccione un registro al que se le creará el recordatorio (Póliza, recibo, endoso, siniestro, etc.)"
        );
      }
    });

    $scope.caratuleLay = [];
    $scope.$watch("searchCaratule.value", function (newValue, oldValue) {
      if (
        $scope.searchCaratule &&
        $scope.searchCaratule.value &&
        $scope.searchCaratule.value.poliza_number
      ) {
        $scope.caratuleLay.id = $scope.searchCaratule.value.id;
        $scope.caratuleLay.selected = false;
        $scope.caratuleLay.poliza_number =
          $scope.searchCaratule.value.poliza_number;
        $scope.caratuleLay.start = datesFactory.convertDate(
          $scope.searchCaratule.value.start_of_validity
        );
        $scope.caratuleLay.end = datesFactory.convertDate(
          $scope.searchCaratule.value.end_of_validity
        );
        $scope.caratuleLay.receipts_by =
          $scope.searchCaratule.value.receipts_by;
        $scope.getPolicy($scope.caratuleLay.id);
      }
    });

    $scope.getPolicy = function (param) {
      $http
        .post(url.IP + "get_caratula_complete/", { caratula: param })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.caratuleLay.recibos =
              response.data.data.caratula.recibos_poliza;
            if (
              $scope.caratuleLay.recibos &&
              $scope.caratuleLay.recibos.length > 0
            ) {
              $scope.caratuleLay.recibos = $scope.caratuleLay.recibos.map(
                function (item) {
                  item["selected"] = false;
                  return item;
                }
              );
            }
            $scope.subgrupoLayout = response.data.data.childs;
            $scope.paqueteGLayout = response.data.data.paquetes;
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORSEARCHPOLICY, "error");
          }
        })
        .catch(function (e) {
          // console.log('e', e);
        });
    };

    // ((1, u'Pólizas'),
    //   (2, u'Contratantes'),
    //   (4, u'Recibos'),
    //   (5, u'Siniestros'),
    //   (6, u'Renovaciones'),
    //   (7, u'Recibos-Comisiones'),
    //   (8, u'Grupos'),
    //   (9, u'Paquetes'),
    //   (10, u'Endosos'),
    //   (11, u'Aseguradoras'),
    //   (12, u'Estados de Cuenta'),
    //   (13, u'Fianzas'),
    //   (14, u'Afianzadoras'),
    //   (15, u'Comentarios'),
    //   (16, u'Logs') ,
    //   (17, u'Cartas'),
    //   (18, u'Colectividades'),
    //   (19, u'Graphs'),
    //   (20, u'Notes'),
    //   (21, u'Fianzas Reclamaciones'),
    //   (22, u'Tasks'),
    //   (23, u'Tasks Completados'),
    //   (24, u'Events'),
    //   (25, u'Certificado'),
    //   (26, u'Reportes'),
    //   (27, u'NotificaciónApp'),
    //   (28, u'Flotillas'),
    //   (29, u'Plantilla Correo'),
    //   (30, u'Comentarios'),
    //   (31, u'Recordatorios'),
    //   )

    $scope.selectRecibo = function (index) {
      disableAll();
      if ($scope.policyLay.recibos[index].selected) {
        $scope.policyLay.recibos[index]["selected"] = false;
      } else {
        $scope.policyLay.recibos[index]["selected"] = true;
        $scope.registro_seleccionado = {
          id: $scope.policyLay.recibos[index].id,
          modelo: 4,
        };
      }
    };

    $scope.selectReciboCaratula = function (index) {
      disableAll();
      if ($scope.caratuleLay.recibos[index].selected) {
        $scope.caratuleLay.recibos[index]["selected"] = false;
      } else {
        $scope.caratuleLay.recibos[index]["selected"] = true;
        $scope.registro_seleccionado = {
          id: $scope.caratuleLay.recibos[index].id,
          modelo: 4,
        };
      }
    };

    $scope.selectEndoso = function (index) {
      disableAll();
      if ($scope.policyLay.endosos[index].selected) {
        $scope.policyLay.endosos[index]["selected"] = false;
      } else {
        $scope.policyLay.endosos[index]["selected"] = true;
        $scope.registro_seleccionado = {
          id: $scope.policyLay.endosos[index].id,
          modelo: 10,
        };
      }
    };

    $scope.selectSiniestro = function (index) {
      disableAll();
      if ($scope.policyLay.siniestros[index].selected) {
        $scope.policyLay.siniestros[index]["selected"] = false;
      } else {
        $scope.policyLay.siniestros[index]["selected"] = true;
        $scope.registro_seleccionado = {
          id: $scope.policyLay.siniestros[index].id,
          modelo: 5,
        };
      }
    };

    function disableAll() {
      $scope.policyLay.selected = false;
      $scope.caratuleLay.selected = false;

      if ($scope.policyLay.recibos && $scope.policyLay.recibos.length > 0) {
        $scope.policyLay.recibos = $scope.policyLay.recibos.map(function (
          item
        ) {
          item["selected"] = false;
          return item;
        });
      }
      if ($scope.caratuleLay.recibos && $scope.caratuleLay.recibos.length > 0) {
        $scope.caratuleLay.recibos = $scope.caratuleLay.recibos.map(function (
          item
        ) {
          item["selected"] = false;
          return item;
        });
      }
      if ($scope.policyLay.endosos && $scope.policyLay.endosos.length > 0) {
        $scope.policyLay.endosos = $scope.policyLay.endosos.map(function (
          item
        ) {
          item["selected"] = false;
          return item;
        });
      }
      if (
        $scope.policyLay.siniestros &&
        $scope.policyLay.siniestros.length > 0
      ) {
        $scope.policyLay.siniestros = $scope.policyLay.siniestros.map(function (
          item
        ) {
          item["selected"] = false;
          return item;
        });
      }
    }

    $scope.selectPolicy = function () {
      disableAll();
      if ($scope.policyLay.selected) {
        $scope.policyLay.selected = false;
      } else {
        $scope.policyLay.selected = true;
        $scope.registro_seleccionado = {
          id: $scope.policyLay.id,
          modelo: 1,
        };
      }
    };

    $scope.selectCaratula = function () {
      disableAll();
      if ($scope.caratuleLay.selected) {
        $scope.caratuleLay.selected = false;
      } else {
        $scope.caratuleLay.selected = true;
        $scope.registro_seleccionado = {
          id: $scope.caratuleLay.id,
          modelo: 1,
        };
      }
      console.log($scope.caratuleLay.selected);
    };

    activate();
    // Start functionality
    function activate() {
      $scope.recordatorio_id = $stateParams.id;
      console.log("recordatorio_id", $scope.recordatorio_id);
      if (parseInt($scope.recordatorio_id)) {
        $http
          .get(
            url.IP + "recordatorios/desde-registros/" + $scope.recordatorio_id
          )
          .then(function (response) {
            $scope.form = response.data;
            $scope.form.fecha_programada = datesFactory.convertDate(
              $scope.form.fecha_programada
            );
            $scope.form.hora_programada = new Date().setHours(
              $scope.form["hora_programada"].split(":")[0],
              $scope.form["hora_programada"].split(":")[1],
              0
            );

            $http
              .get(url.IP + "recordatorios/registros-automaticos", {
                params: { recordatorio_id: $scope.recordatorio_id },
              })
              .then(
                function (response) {
                  console.log("response", response);
                  $scope.form["registro"] = response.data[0];
                  $scope.loader = false;
                },
                function (error) {
                  $scope.loader = false;
                }
              )
              .catch(function (error) {
                $scope.loader = false;
              });
          });
      }
      $scope.action = !parseInt($scope.recordatorio_id)
        ? "Nuevo"
        : "Información";
    }

    $scope.cancel = function () {
      $scope.open_in_same_tab(
        "Recordatorios",
        "recordatorios.desde_registros",
        {},
        null,
        null
      );
    };

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    $scope.matchesCaratules = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          dataFactory
            .post("get-endorsements-collect/", {
              word: parWord.val,
              mode: "caratula",
            })
            .then(
              function success(request) {
                var results = [];
                results = _.map(request.data, function (item) {
                  var label =
                    item.poliza_number +
                    " - " +
                    item.contractor +
                    " - " +
                    datesFactory.convertDate(item.start_of_validity) +
                    " - " +
                    datesFactory.convertDate(item.end_of_validity);
                  return {
                    label: label,
                    value: item,
                    id: item.id,
                  };
                });
                $scope.caratules_data = results;
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };

    $scope.matchesPolicies = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          dataFactory
            .post("get-endorsements-policies/", { word: parWord.val })
            .then(
              function success(request) {
                var results = [];
                results = _.map(request.data, function (item) {
                  var label =
                    item.poliza_number +
                    " - " +
                    item.contractor +
                    " - " +
                    datesFactory.convertDate(item.start_of_validity) +
                    " - " +
                    datesFactory.convertDate(item.end_of_validity);
                  return {
                    label: label,
                    value: item,
                    id: item.id,
                  };
                });
                $scope.policies_data = results;
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };
    $scope.timeDate = function (hr) {
      if (hr == null || hr == undefined) {
        $scope.form.hora_programada = new Date().getTime();
      }
    };

    $scope.save = function () {
      if ($scope.form.nombre == "") {
        SweetAlert.swal(
          "El campo 'Resumen' no puede estar en blanco",
          "",
          "error"
        );
        return;
      }
      if ($scope.form.descr == "") {
        SweetAlert.swal(
          "El campo 'Descripción' no puede estar en blanco",
          "",
          "error"
        );
        return;
      }

      var time = angular.copy(new Date($scope.form.hora_programada));
      time = time.toLocaleTimeString("es-MX");

      // var fecha_programada = new Date($scope.form.hora_programada);
      // fecha_programada.setDate(datesFactory.toDate($scope.form.fecha_programada).getDate());
      // fecha_programada.setMonth(datesFactory.toDate($scope.form.fecha_programada).getMonth());
      // fecha_programada.setFullYear(datesFactory.toDate($scope.form.fecha_programada).getFullYear());
      // var payload = angular.copy($scope.form);
      // payload['fecha_programada'] = fecha_programada;
      var fecha_programada = new Date($scope.form.hora_programada);
      fecha_programada.setDate(
        datesFactory.toDate($scope.form.fecha_programada).getDate()
      );
      fecha_programada.setMonth(
        datesFactory.toDate($scope.form.fecha_programada).getMonth()
      );
      fecha_programada.setFullYear(
        datesFactory.toDate($scope.form.fecha_programada).getFullYear()
      );
      var payload = angular.copy($scope.form);
      // payload['fecha_programada'] = fecha_programada
      payload["fecha_programada"] = datesFactory.toDate(
        $scope.form.fecha_programada
      );
      payload["hora_programada"] = time;

      if ($scope.form.url) {
        $http
          .patch(payload.url, payload)
          .then(
            function () {
              toaster.success("Recordatorio actualizado exitosamente");
              setTimeout(function () {
                $scope.open_in_same_tab(
                  "Recordatorios",
                  "recordatorios.desde_registros",
                  {},
                  null,
                  null
                );
              }, 1000);
            },
            function (error) {
              console.error(error);
              toaster.error("Ha ocurrido un error");
            }
          )
          .catch(function (error) {
            console.error(error);
            toaster.error("Ha ocurrido un error");
          });
      } else {
        if (
          $scope.registro_seleccionado &&
          $scope.registro_seleccionado.id == 0
        ) {
          SweetAlert.swal("Debe seleccionar un registro válido", "", "error");
          return;
        }

        payload["registro_id"] = $scope.registro_seleccionado.id;
        payload["modelo"] = $scope.registro_seleccionado.modelo;

        $http
          .post(url.IP + "recordatorios/desde-registros/", payload)
          .then(
            function () {
              toaster.success("Recordatorio creado exitosamente");
              setTimeout(function () {
                $scope.open_in_same_tab(
                  "Recordatorios",
                  "recordatorios.desde_registros",
                  {},
                  null,
                  null
                );
              }, 1000);
            },
            function (error) {
              console.error(error);
              toaster.error("Ha ocurrido un error");
            }
          )
          .catch(function (error) {
            console.error(error);
            toaster.error("Ha ocurrido un error");
          });
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "RecordatoriosDesdeRegistrosCtrl",
      RecordatoriosDesdeRegistrosCtrl
    );

  RecordatoriosDesdeRegistrosCtrl.$inject = [
    "$state",
    "appStates",
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
  ];

  function RecordatoriosDesdeRegistrosCtrl(
    $state,
    appStates,
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory
  ) {
    var vm = this;
    vm.recordatorios = [];

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.users = [];
    vm.users_selected = [];
    $scope.select_created_by = [];
    $scope.show_pag_recfree = false;

    activate(1);
    // Start functionality
    function activate(page) {
      $(".js-example-basic-multiple").select2();
      $scope.params = {
        page: page ? page : 1,
      };
      $http
        .get(url.IP + "recordatorios/desde-registros", $scope.params)
        .then(function (response) {
          vm.recordatorios = response.data.results;
          $scope.recordatorios_config = {
            count: response.data.count,
            previous: url.IP + "recordatorios/desde-registros",
            next: url.IP + "recordatorios/desde-registros",
          };
          $scope.show_pag_recfree = true;
          testPagination("vm.recordatorios", "recordatorios_config");
        });
    }
    $scope.crear_recordatorio = function () {
      $scope.open_in_same_tab(
        "Recordatorios",
        "recordatorios.desde_registros_detalle",
        { id: 0 },
        0,
        null
      );
    };

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    $scope.save = function () {
      console.log($scope.select_created_by);
      var toSave = $scope.select_created_by.map(function (item) {
        return item.id;
      });
      $http.post(url.IP + "group-manager/", toSave).then(function () {
        vm.users_selected = $scope.select_created_by;
      });
    };

    $scope.editReminder = function (recordatorio) {
      $scope.open_in_same_tab(
        "Información Recordatorio",
        "recordatorios.desde_registros_detalle",
        { id: recordatorio.id },
        recordatorio.id,
        null
      );
    };

    $scope.deleteReminder = function (recordatorio, index) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este recordatorio",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(recordatorio.url).then(function (response) {
              vm.recordatorios.splice(index, 1);
              toaster.success("Recordatorio eliminado exitosamente");
            });
          }
        }
      );
    };

    $scope.showReminder = function (recordatorio, index) {
      $scope.open_in_same_tab(
        "Información Recordatorio",
        "recordatorios.desde_registro_show",
        { id: recordatorio.id },
        recordatorio.id,
        null
      );
    };
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        $scope.params.page = parPage;

        dataFactory
          .get("recordatorios/desde-registros", $scope.params)
          .then(function success(response) {
            vm.recordatorios = response.data.results;

            $scope.recordatorios_config = {
              count: response.data.count,
              previous: url.IP + "recordatorios/desde-registros",
              next: url.IP + "recordatorios/desde-registros",
            };
            $scope.show_pag_task = true;
            testPagination("vm.recordatorios", "recordatorios_config");

            vm.recordatorios.forEach(function (child) {
              if (!$localStorage[child.owner.username]) {
                $http({
                  method: "GET",
                  url: url.IP_CAS + "get-user-picture/" + child.owner.username,
                })
                  .then(function (request) {
                    if (request.status === 200) {
                      child.image = request.data.url;
                      $localStorage[child.owner.username] = request.data.url;
                    }
                  })
                  .catch(function (e) {
                    console.log("e", e);
                  });
              } else {
                child.image = $localStorage[child.owner.username];
              }
            });
          });
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "RecordatoriosAutomaticosShowCtrl",
      RecordatoriosAutomaticosShowCtrl
    );

  RecordatoriosAutomaticosShowCtrl.$inject = [
    "providerService",
    "$state",
    "appStates",
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
  ];

  function RecordatoriosAutomaticosShowCtrl(
    providerService,
    $state,
    appStates,
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory
  ) {
    var vm = this;
    $scope.action = "";
    $scope.recordatorio_id = 0;
    $scope.loader = false;
    $scope.form = {
      nombre: "",
      providers: [],
      subramos: [],
      descr: "",
      fecha_vencimiento_polizas: 0,
      fecha_inicio_vigencia_recibos: 0,
      fecha_vencimiento_recibos: 0,
      fecha_promesa_pago_recibos: 0,
      fecha_compromiso_siniestros: 0,
    };

    vm.cargarRegistros = cargarRegistros;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.users = [];
    vm.users_selected = [];
    $scope.select_created_by = [];

    $scope.opciones = [0, -1, -2, -3, 1, 2];

    activate();
    // Start functionality
    function activate() {
      $(".js-example-basic-multiple").select2();
      $scope.recordatorio_id = $stateParams.id;
      if (parseInt($scope.recordatorio_id)) {
        $scope.loader = true;
        $http
          .get(url.IP + "recordatorios/automaticos/" + $scope.recordatorio_id)
          .then(function (response) {
            $scope.form = response.data;
            getSubramos();
            getProviders();
          });
        vm.cargarRegistros();
      } else {
        getSubramos();
        getProviders();
      }
      $scope.action = !parseInt($scope.recordatorio_id)
        ? "Nuevo"
        : "Información";
    }

    $scope.cancel = function () {
      $scope.open_in_same_tab(
        "Recordatorios",
        "recordatorios.automaticos",
        {},
        null,
        null
      );
    };

    function cargarRegistros() {
      $http
        .get(url.IP + "recordatorios/registros-automaticos", {
          params: { recordatorio_id: $scope.recordatorio_id },
        })
        .then(
          function (response) {
            $scope.loader = false;
            console.log(response);
            vm.recordatorios = response.data;
            $scope.loader = false;
          },
          function (error) {
            $scope.loader = false;
          }
        )
        .catch(function (error) {
          $scope.loader = false;
        });
    }

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        $scope.providers = data.data;
        $scope.form.providers = $scope.form.aseguradoras_recordatorio.map(
          function (item) {
            var aux_item = item;
            $scope.providers.forEach(function (aseguradora) {
              if (aseguradora.alias == item.aseguradora) {
                aux_item = {
                  alias: aseguradora.alias,
                  compania: aseguradora.compania,
                  id: aseguradora.id,
                  org_name: aseguradora.org_name,
                  provider_type: aseguradora.provider_type,
                  rfc: aseguradora.rfc,
                  url: aseguradora.url,
                };
              }
            });
            return aux_item;
          }
        );
      });
    }

    function getSubramos() {
      $scope.subramos_selected = [];
      $scope.subramos_toselected = [
        {
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          subramo_code: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
      $scope.form.subramos = $scope.form.subramos_recordatorio.map(function (
        item
      ) {
        var aux_item = item;
        $scope.subramos_toselected.forEach(function (subramo) {
          if (subramo.subramo_code == item.subramo) {
            aux_item = {
              subramo_code: subramo.subramo_code,
              subramo_name: subramo.subramo_name,
            };
          }
        });
        return aux_item;
      });
    }

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    $scope.showReminder = function (recordatorio, index) {
      $http.patch(recordatorio.url, { seen: true }).then(function () {
        vm.recordatorios[index]["seen"] = true;
      });
      if (recordatorio.recordatorio.tipo_instancia == 1) {
        var template_url = "app/recordatorios/polizas.modal.html";
      } else if (
        recordatorio.recordatorio.tipo_instancia == 2 ||
        recordatorio.recordatorio.tipo_instancia == 3 ||
        recordatorio.recordatorio.tipo_instancia == 4
      ) {
        var template_url = "app/recordatorios/recibos.modal.html";
      } else if (recordatorio.recordatorio.tipo_instancia == 5) {
        var template_url = "app/recordatorios/siniestros.modal.html";
      }
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: template_url,
        controller: ShowPolizaCtrl,
        size: "lg",
        resolve: {
          recordatorio: function () {
            return recordatorio;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    function ShowPolizaCtrl(
      $scope,
      $uibModalInstance,
      recordatorio,
      $sessionStorage,
      dataFactory
    ) {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.user = usr;
      $scope.recordatorio = recordatorio;
      $scope.poliza = {};
      $scope.siniestro = {};
      $scope.endorsement = {};

      $scope.tipo_title = {
        1: "Accidente",
        2: "Enfermedad",
        3: "Parto",
      };

      $scope.pago_title = {
        1: "Reembolso",
        2: "Programacion",
        3: "Pago Directo",
        4: "Aclaración",
      };

      $scope.status = {
        2: "En Trámite",
        3: "Completada/Procedente",
        4: "Cancelada",
        5: "Rechazada/ No Procedente",
        6: "En espera/ Solicitud de Información",
        7: "Reproceso",
        8: "Inconformidad",
      };

      if (recordatorio.recordatorio.tipo_instancia == 1) {
        dataFactory
          .get("leer-polizas-edit/" + $scope.recordatorio.record_id)
          .then(function (response) {
            $scope.poliza = response.data;
            $http.get($scope.poliza.contractor).then(function (contractor) {
              $scope.poliza["contractor"] = contractor.data;

              if (contractor.data.address_contractor) {
                $scope.poliza["contractor"]["address"] =
                  contractor.data.address_contractor[0];
              }
            });

            $http.get($scope.poliza.owner).then(function (owner) {
              $scope.poliza["owner"] = owner.data;
            });

            providerService
              .getProviderById($scope.poliza.aseguradora)
              .then(function (aseguradora) {
                $scope.poliza["aseguradora"] = aseguradora.data;
              });
          });
      } else if (
        recordatorio.recordatorio.tipo_instancia == 2 ||
        recordatorio.recordatorio.tipo_instancia == 3 ||
        recordatorio.recordatorio.tipo_instancia == 4
      ) {
        dataFactory
          .get("leer-polizas-edit/" + $scope.recordatorio.instancia.poliza_id)
          .then(function (response) {
            $scope.poliza = response.data;
            $http.get($scope.poliza.contractor).then(function (contractor) {
              $scope.poliza["contractor"] = contractor.data;

              if (contractor.data.address_contractor) {
                $scope.poliza["contractor"]["address"] =
                  contractor.data.address_contractor[0];
              }
            });

            $http.get($scope.poliza.owner).then(function (owner) {
              $scope.poliza["owner"] = owner.data;
            });

            providerService
              .getProviderById($scope.poliza.aseguradora)
              .then(function (aseguradora) {
                $scope.poliza["aseguradora"] = aseguradora.data;
              });
          });
        if (recordatorio.instancia.receipt_type == 2) {
          dataFactory
            .get("endorsement-info/" + recordatorio.instancia.endoso_id + "/")
            .then(function success(response) {
              $scope.endorsement = response.data;
            });
        }
      } else if (recordatorio.recordatorio.tipo_instancia == 5) {
        dataFactory
          .get("leer-polizas-edit/" + $scope.recordatorio.instancia.poliza_id)
          .then(function (response) {
            $scope.poliza = response.data;
            $http.get($scope.poliza.contractor).then(function (contractor) {
              $scope.poliza["contractor"] = contractor.data;

              if (contractor.data.address_contractor) {
                $scope.poliza["contractor"]["address"] =
                  contractor.data.address_contractor[0];
              }
            });

            $http.get($scope.poliza.owner).then(function (owner) {
              $scope.poliza["owner"] = owner.data;
            });

            providerService
              .getProviderById($scope.poliza.aseguradora)
              .then(function (aseguradora) {
                $scope.poliza["aseguradora"] = aseguradora.data;
              });
          });
        dataFactory
          .get("siniester_get_by_id/" + recordatorio.instancia.siniestro_id)
          .then(function (response) {
            $scope.siniestro = response.data;
          });
      }

      // Menú rapido
      // $scope.getPDF = getPDF;

      $scope.open_in_same_tab_natural = function (
        name,
        route,
        params,
        identifier
      ) {
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
        }

        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
        $localStorage.tab_states = appStates.states;
        $localStorage.tab_index = $localStorage.tab_states.length - 1;
        $state.go($scope.route_for_new_tab, params);
      };

      $scope.goToSiniestro = function (siniestro) {
        if (siniestro.siniestro.tipo_siniestro_general == 3) {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.auto_info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.auto_info', {siniestroId: siniestro.siniestro.id});
        } else if (siniestro.siniestro.tipo_siniestro_general == 1) {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.vida_info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.vida_info', {siniestroId: siniestro.siniestro.id});
        } else if (siniestro.siniestro.tipo_siniestro_general == 2) {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.info', {siniestroId: siniestro.siniestro.id});
        } else {
          $scope.open_in_same_tab_natural(
            "Información Sinestro",
            "siniestros.danio_info",
            { siniestroId: siniestro.siniestro.id },
            siniestro.siniestro.id,
            null
          );
          // $state.go('siniestros.danio_info', {siniestroId: siniestro.siniestro.id});
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.goToPolicy = function (poliza) {
        console.log(poliza);
        if (poliza.document_type == 1) {
          $scope.open_in_same_tab_natural(
            "Pólizas",
            "polizas.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('polizas.info', {polizaId: poliza.id});
        } else if (poliza.document_type == 3) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('colectividades.info', {polizaId: poliza.id});
        } else if (poliza.document_type == 4) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.caratula },
            poliza.caratula
          );
          // $state.go('colectividades.info', {polizaId: poliza.caratula});
        } else if (poliza.document_type == 6) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.caratula },
            poliza.caratula
          );
          // $state.go('colectividades.info', {polizaId: poliza.caratula})
        } else if (poliza.document_type == 7) {
          $scope.open_in_same_tab_natural(
            "Fianzas",
            "fianzas.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('fianzas.info', {polizaId: poliza.id})
        } else if (poliza.document_type == 8) {
          $scope.open_in_same_tab_natural(
            "Fianzas",
            "fianzas.details",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('fianzas.details',{polizaId: poliza.id})
        } else if (poliza.document_type == 12) {
          $scope.open_in_same_tab_natural(
            "Flotillas",
            "flotillas.info",
            { polizaId: parseInt(poliza.caratula) },
            poliza.id
          );
          // $state.go('flotillas.info',{polizaId: parseInt(poliza.caratula)})
        } else if (poliza.document_type == 11) {
          $scope.open_in_same_tab_natural(
            "Flotillas",
            "flotillas.info",
            { polizaId: parseInt(poliza.caratula) },
            poliza.id
          );
          // $state.go('flotillas.info',{polizaId: parseInt(poliza.id)})
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.goToReceipt = function (recordatorio, poliza) {
        if (recordatorio.instancia.receipt_type == 1) {
          $scope.open_in_same_tab_natural(
            "Pólizas",
            "polizas.info",
            { polizaId: recordatorio.instancia.poliza_id },
            recordatorio.instancia.poliza_id
          );
        } else if (recordatorio.instancia.receipt_type == 2) {
          $scope.open_in_same_tab_natural(
            "Endosos",
            "endorsement.info",
            { endosoId: recordatorio.instancia.endoso_id },
            recordatorio.instancia.endoso_id
          );
        } else if (recordatorio.instancia.receipt_type == 3) {
          $scope.open_in_same_tab_natural(
            "Endosos",
            "endorsement.info",
            { endosoId: recordatorio.instancia.endoso_id },
            recordatorio.instancia.endoso_id
          );
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.forma_pago = function (parValue) {
        switch (parValue) {
          case 1:
            return "Mensual";
            break;
          case 2:
            return "Bimestral";
            break;
          case 3:
            return "Trimestral";
            break;
          case 5:
            return "Contado";
            break;
          case 6:
            return "Semestral";
            break;
          case 12:
            return "Anual";
            break;
          case 24:
            return "Quincenal";
            break;
          default:
            return "No especificada";
        }
      };

      $scope.status = function (parValue) {
        switch (parValue) {
          case 1:
            return "En trámite";
            break;
          case 2:
            return "OT Cancelada";
            break;
          case 4:
            return "Precancelada";
            break;
          case 10:
            return "Por iniciar";
            break;
          case 11:
            return "Cancelada";
            break;
          case 12:
            return "Renovada";
            break;
          case 13:
            return "Vencida";
            break;
          case 14:
            return "Vigente";
            break;
          case 15:
            return "No renovada";
            break;
          default:
            return "Pendiente";
        }
      };

      $scope.statusEndoso = function (parValue) {
        switch (parValue) {
          case 1:
            return "Pendiente";
            break;
          case 2:
            return "Registrado";
            break;
          case 3:
            return "Rechazado";
            break;
          case 4:
            return "Cancelado";
            break;
          case 5:
            return "En trámite";
            break;
          default:
            return "Pendiente";
        }
      };
      $scope.dismis = function (receipt) {
        $uibModalInstance.dismiss("cancel");
        changeStatusModal(receipt, $scope.myPolicy);
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    $scope.save = function () {
      if ($scope.form.url) {
        $http
          .patch($scope.form.url, $scope.form)
          .then(
            function () {
              toaster.success("Recordatorio actualizado exitosamente");
            },
            function (error) {
              console.error(error);
              toaster.error("Ha ocurrido un error");
            }
          )
          .catch(function (error) {
            console.error(error);
            toaster.error("Ha ocurrido un error");
          });
      } else {
        $http
          .post(url.IP + "recordatorios/automaticos/", $scope.form)
          .then(
            function () {
              toaster.success("Recordatorio creado exitosamente");
              $scope.open_in_same_tab(
                "Recordatorios",
                "recordatorios.automaticos",
                {},
                null,
                null
              );
            },
            function (error) {
              console.error(error);
              toaster.error("Ha ocurrido un error");
            }
          )
          .catch(function (error) {
            console.error(error);
            toaster.error("Ha ocurrido un error");
          });
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "RecordatoriosAutomaticosDetalleCtrl",
      RecordatoriosAutomaticosDetalleCtrl
    );

  RecordatoriosAutomaticosDetalleCtrl.$inject = [
    "providerService",
    "$state",
    "appStates",
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
  ];

  function RecordatoriosAutomaticosDetalleCtrl(
    providerService,
    $state,
    appStates,
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory
  ) {
    var vm = this;
    $scope.action = "";
    $scope.recordatorio_id = 0;
    $scope.form = {
      nombre: "",
      providers: [],
      subramos: [],
      descr: "",
      tipo_instancia: 1,
      dias_configuracion: 0,
    };

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.users = [];
    vm.users_selected = [];
    $scope.select_created_by = [];

    $scope.opciones = [
      0, -1, -2, -3, -4, -5, -6, -7, -8, -9, -10, -11, -12, -13, -14, -15, -16,
      -16, -17, 1, 2,
    ];

    $scope.opciones_tipo_instancia = [
      {
        descr: "Fecha de vencimiento de polizas (sin renovar)",
        value: 1,
      },
      {
        descr: "Fecha de inicio de vigencia de recibos (pendientes de pago)",
        value: 2,
      },
      {
        descr: "Fecha de vencimiento de recibos (pendientes de pago)",
        value: 3,
      },
      {
        descr: "Fecha de promesa de pago de recibos (pendientes de pago)",
        value: 4,
      },
      {
        descr: "Fecha de compromiso de siniestros",
        value: 5,
      },
    ];

    activate();
    // Start functionality
    function activate() {
      $(".js-example-basic-multiple").select2();
      $scope.recordatorio_id = $stateParams.id;
      console.log("recordatorio_id", $scope.recordatorio_id);
      if (parseInt($scope.recordatorio_id)) {
        $http
          .get(url.IP + "recordatorios/automaticos/" + $scope.recordatorio_id)
          .then(function (response) {
            $scope.form = response.data;
            $scope.opciones_tipo_instancia.forEach(function (item) {
              if (item.value == $scope.form.tipo_instancia) {
                $scope.form.tipo_instancia = item;
              }
            });
            getSubramos();
            getProviders();
          });
      } else {
        $scope.opciones_tipo_instancia.forEach(function (item) {
          if (item.value == $scope.form.tipo_instancia) {
            $scope.form.tipo_instancia = item;
          }
        });
        getSubramos();
        getProviders();
      }
      $scope.action = !parseInt($scope.recordatorio_id)
        ? "Nuevo"
        : "Información";
    }

    $scope.cancel = function () {
      $scope.open_in_same_tab(
        "Recordatorios",
        "recordatorios.automaticos",
        {},
        null,
        null
      );
    };

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        $scope.providers = data.data;
        if (parseInt($scope.recordatorio_id)) {
          $scope.form.providers = $scope.form.aseguradoras_recordatorio.map(
            function (item) {
              var aux_item = item;
              $scope.providers.forEach(function (aseguradora) {
                if (aseguradora.alias == item.aseguradora) {
                  aux_item = {
                    alias: aseguradora.alias,
                    compania: aseguradora.compania,
                    id: aseguradora.id,
                    org_name: aseguradora.org_name,
                    provider_type: aseguradora.provider_type,
                    rfc: aseguradora.rfc,
                    url: aseguradora.url,
                  };
                }
              });
              return aux_item;
            }
          );
        }
      });
    }

    function getSubramos() {
      $scope.subramos_selected = [];
      $scope.subramos_toselected = [
        {
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          subramo_code: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
      if (parseInt($scope.recordatorio_id)) {
        $scope.form.subramos = $scope.form.subramos_recordatorio.map(function (
          item
        ) {
          var aux_item = item;
          $scope.subramos_toselected.forEach(function (subramo) {
            if (subramo.subramo_code == item.subramo) {
              aux_item = {
                subramo_code: subramo.subramo_code,
                subramo_name: subramo.subramo_name,
              };
            }
          });
          return aux_item;
        });
      }
    }

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    $scope.save = function () {
      if ($scope.form.url) {
        var payload = angular.copy($scope.form);
        payload.tipo_instancia =
          payload.tipo_instancia && payload.tipo_instancia.value
            ? payload.tipo_instancia.value
            : 0;
        $http
          .patch(payload.url, payload)
          .then(
            function () {
              toaster.success("Recordatorio actualizado exitosamente");
              setTimeout(function () {
                $scope.open_in_same_tab(
                  "Recordatorios",
                  "recordatorios.automaticos",
                  {},
                  null,
                  null
                );
              }, 1000);
            },
            function (error) {
              console.error(error);
              toaster.error("Ha ocurrido un error");
            }
          )
          .catch(function (error) {
            console.error(error);
            toaster.error("Ha ocurrido un error");
          });
      } else {
        var payload = angular.copy($scope.form);
        payload.tipo_instancia =
          payload.tipo_instancia && payload.tipo_instancia.value
            ? payload.tipo_instancia.value
            : 0;

        $http
          .post(url.IP + "recordatorios/automaticos/", payload)
          .then(
            function () {
              toaster.success("Recordatorio creado exitosamente");
              setTimeout(function () {
                $scope.open_in_same_tab(
                  "Recordatorios",
                  "recordatorios.automaticos",
                  {},
                  null,
                  null
                );
              }, 1000);
            },
            function (error) {
              console.error(error);
              toaster.error("Ha ocurrido un error");
            }
          )
          .catch(function (error) {
            console.error(error);
            toaster.error("Ha ocurrido un error");
          });
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("RecordatoriosAutomaticosCtrl", RecordatoriosAutomaticosCtrl);

  RecordatoriosAutomaticosCtrl.$inject = [
    "$state",
    "appStates",
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
  ];

  function RecordatoriosAutomaticosCtrl(
    $state,
    appStates,
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory
  ) {
    var vm = this;
    vm.recordatorios = [];

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.users = [];
    vm.users_selected = [];
    $scope.select_created_by = [];
    $scope.show_pag_recatm = false;
    activate(1);
    // Start functionality
    function activate(page) {
      $(".js-example-basic-multiple").select2();
      $scope.params = {
        page: page ? page : 1,
      };
      $http
        .get(url.IP + "recordatorios/automaticos", $scope.params)
        .then(function (response) {
          vm.recordatorios = response.data.results;
          $scope.recordatorios_config = {
            count: response.data.count,
            previous: url.IP + "recordatorios/automaticos",
            next: url.IP + "recordatorios/automaticos",
          };
          $scope.show_pag_recatm = true;
          testPagination("vm.recordatorios", "recordatorios_config");

          console.log("response", response);
        });
    }

    $scope.crear_recordatorio = function () {
      $scope.open_in_same_tab(
        "Recordatorios",
        "recordatorios.automaticos_detalle",
        { id: 0 },
        0,
        null
      );
    };

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    $scope.save = function () {
      console.log($scope.select_created_by);
      var toSave = $scope.select_created_by.map(function (item) {
        return item.id;
      });
      $http.post(url.IP + "group-manager/", toSave).then(function () {
        vm.users_selected = $scope.select_created_by;
      });
    };

    $scope.editReminder = function (recordatorio) {
      $scope.open_in_same_tab(
        "Información Recordatorio",
        "recordatorios.automaticos_detalle",
        { id: recordatorio.id },
        recordatorio.id,
        null
      );
    };

    $scope.deleteReminder = function (recordatorio, index) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este recordatorio",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(recordatorio.url).then(function (response) {
              vm.recordatorios.splice(index, 1);
              toaster.success("Recordatorio eliminado exitosamente");
            });
          }
        }
      );
    };

    $scope.showReminder = function (recordatorio, index) {
      $scope.open_in_same_tab(
        "Información Recordatorio",
        "recordatorios.automaticos_show",
        { id: recordatorio.id },
        recordatorio.id,
        null
      );
    };

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        $scope.params.page = parPage;

        dataFactory
          .get("recordatorios/automaticos", $scope.params)
          .then(function success(response) {
            vm.recordatorios = response.data.results;

            $scope.recordatorios_config = {
              count: response.data.count,
              previous: url.IP + "recordatorios/automaticos",
              next: url.IP + "recordatorios/automaticos",
            };
            $scope.show_pag_task = true;
            testPagination("vm.recordatorios", "recordatorios_config");

            vm.recordatorios.forEach(function (child) {
              if (!$localStorage[child.owner.username]) {
                $http({
                  method: "GET",
                  url: url.IP_CAS + "get-user-picture/" + child.owner.username,
                })
                  .then(function (request) {
                    if (request.status === 200) {
                      child.image = request.data.url;
                      $localStorage[child.owner.username] = request.data.url;
                    }
                  })
                  .catch(function (e) {
                    console.log("e", e);
                  });
              } else {
                child.image = $localStorage[child.owner.username];
              }
            });
          });
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

// (function() {
//     'use strict';
//     /* jshint devel: true */

//     angular.module('inspinia')
//         .controller('ReceiptsCtrl', ReceiptsCtrl);

//     ReceiptsCtrl.$inject = ['insuranceService', 'receiptService', 'statusReceipt', 'helpers', 'toaster', 'FileUploader', 'url',
//         '$stateParams', '$scope', '$localStorage', '$uibModal', '$timeout', '$q', '$sessionStorage','MESSAGES'];

//     function ReceiptsCtrl(insuranceService, receiptService, statusReceipt, helpers, toaster, FileUploader, url,
//         $stateParams, $scope, $localStorage, $uibModal, $timeout, $q, $sessionStorage, MESSAGES) {

//         var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
//         var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
//         var usr = JSON.parse(decryptedUser);
//         var token = JSON.parse(decryptedToken);

//         var vm = this;
//         vm.pageTitle = 'Pólizas';

//         // variables
//         vm.receipts = [];
//         vm.receipt = {};
//         vm.canEditReceipt = true;
//         vm.canEditReceiptStatus = true;
//         vm.statusReceipt = statusReceipt;

//         vm.receiptBackup = {};
//         vm.user = usr;

//         // functions
//         vm.editReceipt = editReceipt;
//         vm.changeReceiptStatus = changeReceiptStatus;
//         vm.editReceiptStatus = editReceiptStatus;
//         vm.uploadFiles = uploadFiles;

//         vm.cancelEditReceipt = cancelEditReceipt;
//         vm.applyEditReceipt = applyEditReceipt;

//         /** Uploader files */
//         $scope.userInfo = { id: 0 };
//         var uploader = $scope.uploader = new FileUploader({
//             headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json' },
//         });

//         uploader.filters.push({
//             name: 'customFilter',
//             fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
//                 return this.queue.length < 20;
//             }
//         });

//         // ALERTA SUCCES UPLOADFILES
//         uploader.onSuccessItem = function(fileItem, response, status, headers) {
//           toaster.success(MESSAGES.OK.UPLOADFILES);
//         };

//         // ALERTA ERROR UPLOADFILES
//         uploader.onErrorItem = function(fileItem, response, status, headers) {
//           toaster.error(MESSAGES.ERROR.ERRORONUPLOADFILES);
//         };

//         uploader.onAfterAddingFile = function(fileItem) {
//             fileItem.formData.push({
//                 arch: fileItem._file
//             })
//         }

//         uploader.onBeforeUploadItem = function(item) {
//             item.url = $scope.userInfo.url;
//             item.formData[0].nombre = item.file.name;
//             item.alias = '';
//             item.formData[0].owner = $scope.userInfo.id;
//         };

//         activate();

//         function activate() {
//             insuranceService.getInsuranceRead($stateParams)
//                 .then(function(data) {
//                   vm.poliza_number = data.poliza_number;
//                   vm.poliza_id = data.id;
//                     data.recibos_poliza.forEach(function(elem) {
//                         receiptService.getReceiptsByUriService(elem)
//                             .then(function(res) {
//                                 vm.receipts.push(res);
//                                 if (parseInt($stateParams.receiptId) === res.recibo_numero) {
//                                     vm.receipt = res;
//                                 }
//                             });
//                     });
//                 });
//             getFiles();
//         }

//         function getFiles() {
//             return receiptService.getFiles(receiptService.getReceiptID())
//                 .then(function(data) {
//                     vm.files = data;
//                     return vm.files;
//                 });
//         }

//         function changeReceiptStatus() {
//             // Refresh actual state
//             // TODO change only receipt
//             vm.receipt.status = vm.status.value;
//             if (!helpers.isTheReceiptCanceled(vm.receipt.status)) {

//             } else {
//                 receiptService.cancelReceiptsFrom(vm.receipt)
//                     .then(function(res) {
//                     });
//             }

//             // receiptService.updateReceiptService(vm.receipt)
//             //     .then(function(res){
//             //         if (res.status === 200){
//             //             toaster.success('Se ha guardado su cambio');
//             //         } else {
//             //             toaster.warning('Ha ocurrido un error');
//             //         }
//             //     });
//             vm.canEditReceiptStatus = true;
//         }

//         function editReceipt() {
//             vm.canEditReceipt = !vm.canEditReceipt;
//             vm.receiptBackup = angular.copy(vm.receipt);
//         }

//         function cancelEditReceipt() {
//             vm.canEditReceipt = !vm.canEditReceipt;
//             vm.receipt = vm.receiptBackup;
//         }

//         function applyEditReceipt() {
//             receiptService.patchReceipt(vm.receipt.url, vm.receipt)
//                 .then(function(res) {
//                     toaster.success('Recibo actualizado');
//                     vm.canEditReceipt = !vm.canEditReceipt;
//                 });
//         }

//         function editReceiptStatus(receipt) {
//             //vm.canEditReceiptStatus = !vm.canEditReceiptStatus;
//             var modalInstance = $uibModal.open({ //jshint ignore:line
//                 templateUrl: 'app/cobranzas/cobranzas.modal.html',
//                 controller: 'CobranzasModal',
//                 size: 'lg',
//                 ////windowClass: 'animated fadeIn',
//                 resolve: {
//                     receipt: function() {
//                         return angular.copy(receipt.id);
//                     },
//                     from: function(){
//                       return null;
//                     } ,bono: function(){
//                       return null;
//                     }
//                 }
//             });
//             modalInstance.result.then(function() {
//                 activate();
//             });
//         }

//         function uploadFiles() {

//             $scope.userInfo = {
//                 id: vm.receipt.id
//             };

//             $scope.userInfo.url = $scope.uploader.url = url.IP + 'recibos/' + vm.receipt.id + '/archivos/';
//             $q.when()
//                 .then(function() {
//                     var defer = $q.defer();
//                     defer.resolve($scope.uploader.uploadAll());
//                     return defer.promise;
//                 })
//                 .then(function() {
//                     toaster.success('Se han subido sus archivos correctamente');
//                     $timeout(function() {
//                         getFiles().then(function(res) {
//                             vm.files = res;
//                         });
//                     }, 100);
//                 });
//         }
//     }
// })();

"use strict";

angular
  .module("inspinia")
  .controller("RenewalPolicyModalCtrl", RenewalPolicyModalCtrl);

RenewalPolicyModalCtrl.$inject = [
  "$scope",
  "$uibModalInstance",
  "$filter",
  "providerService",
  "toaster",
  "newOT",
  "payform",
];

function RenewalPolicyModalCtrl(
  $scope,
  $uibModalInstance,
  $filter,
  providerService,
  toaster,
  newOT,
  payform
) {
  var vm = $scope;

  // Variables
  vm.showOne = true;
  vm.combos = {
    providers: [],
    payform: payform,
    ramos: [],
    subramos: [],
    packages: [],
  };

  // Functions
  vm.cancel = cancel;
  vm.renewal = newOT;

  // changeListener
  vm.changeProvider = changeProvider;
  vm.changeRamo = changeRamo;
  vm.changeSubramo = changeSubramo;
  vm.changePackage = changePackage;
  // TODO la fecha de vigencia se corre un año

  activate();
  //
  function activate() {
    //     var data = {};
    //     data.polizaId = main.insurance.id;
    //     insuranceService.getInsuranceRead(data)
    //         .then(function(data){
    //             $scope.form = data;
    //         });
    //
    providerService.getProviders().then(function (data) {
      vm.combos.providers = data;
      vm.combos.providers.forEach(function (elem, index) {
        if (elem.compania === vm.renewal.aseguradora) {
          vm.renewal.aseguradora = vm.combos.providers[index];
          vm.combos.ramos = vm.renewal.aseguradora.ramo_provider;
          vm.combos.ramos.forEach(function (elem, index) {
            if (elem.ramo_name === vm.renewal.ramo) {
              vm.renewal.ramo = vm.combos.ramos[index];
              vm.combos.subramos = vm.renewal.ramo.subramo_ramo;
              vm.combos.subramos.forEach(function (elem, index) {
                if (elem.subramo_name === vm.renewal.subramo) {
                  vm.renewal.subramo = vm.combos.subramos[index];
                  vm.combos.packages = vm.renewal.subramo.package_subramo;
                  vm.combos.packages.forEach(function (elem, index) {
                    if (elem.package_name === vm.renewal.paquete) {
                      vm.renewal.paquete = vm.combos.packages[index];
                      // TODO traer coberturas
                    }
                  });
                }
              });
            }
          });
        }
      });
      return data;
    });

    vm.combos.payform.forEach(function (elem, index) {
      if (elem.label === vm.renewal.forma_de_pago) {
        vm.renewal.payment = payform[index];
      }
    });

    vm.renewal.start_of_validity = moment(vm.renewal.start_of_validity)
      .add(1, "years")
      .format();
    vm.renewal.end_of_validity = moment(vm.renewal.end_of_validity)
      .add(1, "years")
      .format();
    //
    //     var otherData = {};
    //     otherData.polizaId = data.polizaId.replace('leer-', '');
    //
    //     insuranceService.getInsurance(otherData)
    //         .then(function(insuranceData){
    //             var prov = {};
    //             prov.provider = insuranceData.aseguradora;
    //             providerService.getProvider(prov)
    //                 .then(function(data){
    //                     $scope.ramos = data.ramo_provider;
    //                     return insuranceData;
    //                 }).then(function(insurance){
    //                     ramoService.getRamo(insurance)
    //                         .then(function(ramoData){
    //                               $scope.subramos = ramoData.subramo_ramo;
    //                               ramoService.getSubramo(insurance)
    //                                   .then(function(subramoData){
    //                                       $scope.paquetes = subramoData.package_subramo;
    //                                   });
    //                         });
    //                 });
    //         });
  }

  function cancel() {
    if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
  }

  // changeListener
  function changeProvider(provider) {
    vm.combos.ramos = provider.ramo_provider;
    vm.combos.subramos = [];
    vm.combos.packages = [];
  }

  function changeRamo(ramo) {
    vm.combos.subramos = ramo.subramo_ramo;
    vm.combos.packages = [];
  }

  function changeSubramo(subramo) {
    vm.combos.paquetes = subramo.package_subramo;
  }

  function changePackage(pack) {}
}

// RenewalPolicyModal
// function PolicyModal($scope, $uibModalInstance, toaster, $filter) {
//     $scope.datas = 10;
//     $scope.form = {};
//
//     $scope.providers = [];
//     $scope.ramos = [];
//     $scope.subramos = [];
//     $scope.paquetes = [];
//
//     $scope.saveOT = saveOT;
//
//     $scope.status = status;
//     $scope.payform = payform;
//
//     $scope.show = {
//         receipt: false
//         // ot: false
//     };
//
//     $scope.changeProvider = changeProvider;
//     $scope.changeRamos = changeRamos;
//     $scope.changeSubramos = changeSubramos;
//
//     $scope.openModal = openReceiptModal;
//     $scope.saveInsurance = saveInsurance;
//
//
//     function changeProvider(changeProv){
//         $scope.ramos = changeProv.ramo_provider;
//     }
//
//     function changeRamos(changeRamo){
//         $scope.subramos = changeRamo.subramo_ramo;
//     }
//
//     function changeSubramos(changeSubramo){
//         $scope.paquetes = changeSubramo.package_subramo;
//     }
//
//     var myForm = {};
//     var parentScope = $scope;
//
//     function openReceiptModal(){
//         myForm = $scope.form;
//         var modalInstance = $uibModal.open({ //jshint ignore:line
//             templateUrl: 'app/polizas/recibos.modal.html',
//             controller: ReceiptModalCtrl,
//             size: 'lg',
//             ////windowClass: 'animated fadeIn',
//             resolve: {
//                 form: function(){
//                   return $scope.form;
//                 }
//             }
//         });
//     }
//
//     function getInsurances(){
//         insuranceService.getandReadInsurances()
//             .then(function(data){
//                 main.insurances = data;
//             });
//     }
//
//     function saveInsurance() {
//         $scope.form.status = 4;
//
//         insuranceService.updateInsurance($scope.form)
//             .then(function(){
//                 getInsurances();
//                 $scope.receipts.forEach(function(elem, index){
//                         var receipt = {
//                             'poliza': $scope.form.url,
//                             'recibo_numero': index+1,
//                             'prima_neta': elem.prima.toString(),
//                             'rpf': elem.rpf.toString(),
//                             'derecho': elem.derecho.toString(),
//                             'iva': elem.iva,
//                             'sub_total': elem.subTotal.toString(),
//                             'prima_total': elem.total.toString(),
//                             'status': 4,
//                             'fecha_inicio': $filter('date')(elem.startDate, 'yyyy-MM-dd'),
//                             'fecha_fin':  $filter('date')(elem.endingDate, 'yyyy-MM-dd'),
//                             'description': null
//                         };
//                     receiptService.createReceiptService(receipt);
//                 });
//                 toaster.success('Se ha creado una poliza');
//             });
//     }
//
//     function saveOT(){
//         var save = $scope.form;
//         save.aseguradora = $scope.form.aseguradora.url;
//         save.ramo = $scope.form.ramo.url;
//         save.subramo = $scope.form.subramo.url;
//         save.paquete = $scope.form.paquete.url;
//         if ($scope.form.forma_de_pago.value){
//           save.forma_de_pago = $scope.form.forma_de_pago.value;
//         }
//         save.status = 1;
//         insuranceService.updateInsurance(save)
//             .then(function(){
//                 toaster.success('Su Ot ha sido guardada');
//                 getInsurances();
//                 $uibModalInstance.dismiss('cancel');
//             });
//     }
//
//     function activate(){
//         var data = {};
//         data.polizaId = main.insurance.id;
//         insuranceService.getInsuranceRead(data)
//             .then(function(data){
//                 $scope.form = data;
//             });
//
//         providerService.getProviders()
//           .then(function(data){
//               $scope.providers = data;
//               return data;
//           });
//
//         var otherData = {};
//         otherData.polizaId = data.polizaId.replace('leer-', '');
//
//         insuranceService.getInsurance(otherData)
//             .then(function(insuranceData){
//                 var prov = {};
//                 prov.provider = insuranceData.aseguradora;
//                 providerService.getProvider(prov)
//                     .then(function(data){
//                         $scope.ramos = data.ramo_provider;
//                         return insuranceData;
//                     }).then(function(insurance){
//                         ramoService.getRamo(insurance)
//                             .then(function(ramoData){
//                                   $scope.subramos = ramoData.subramo_ramo;
//                                   ramoService.getSubramo(insurance)
//                                       .then(function(subramoData){
//                                           $scope.paquetes = subramoData.package_subramo;
//                                       });
//                             });
//                     });
//             });
//     }
//
//     activate();
//
//     $scope.ok = function () {
//     };
//
//     $scope.close = function () {
//         $uibModalInstance.dismiss('cancel');
//     };
//
//     ///////////////// Create receipt modal
//     function ReceiptModalCtrl($scope, $uibModalInstance){
//         $scope.amountReceipts = 0;
//         $scope.poliza = {
//             primaNeta: 538.10,
//             iva: 16,
//             rpf: 45.20,
//             derecho: 300,
//             subTotal: 0,
//             primaTotal: 0
//         };
//
//         $scope.calculate = function(){
//             if(!parentScope.form.forma_de_pago){
//                 toaster.info(MESSAGES.ERROR.SELPAY);
//             } else {
//                 $scope.receipts = [];
//                 $scope.showReceipts = true;
//                 var amountReceipts = $scope.amountReceipts = 12 / parentScope.form.forma_de_pago.value;
//                 //Calculate poliza results
//                 $scope.poliza.subTotal = getSubtotal($scope.poliza);
//                 $scope.poliza.primaTotal = getTotal($scope.poliza);
//                 var arrayLen = $scope.getNumber(amountReceipts);
//
//                 var obj = {
//                     prima: $scope.poliza.primaNeta / amountReceipts,
//                     rpf: $scope.poliza.rpf / amountReceipts,
//                     derecho: $scope.poliza.derecho / amountReceipts,
//                     iva: $scope.poliza.iva,
//                     subTotal: $scope.poliza.subTotal / amountReceipts,
//                     primaTotal: $scope.poliza.primaTotal / amountReceipts,
//                 };
//
//                 var initDate = parentScope.form.start_of_validity;
//                 var endDate = parentScope.form.end_of_validity;
//                 for (var i = 0; i < arrayLen.length; i++) {
//                     // Check options
//                     if ($scope.configDerecho){
//                         if (i === 0) {obj.derecho = $scope.poliza.derecho;}
//                         else {obj.derecho = 0;}
//                     }
//
//                     if ($scope.configRPF){
//                         if (i === 0) {obj.rpf = $scope.poliza.rpf;}
//                         else {obj.rpf = 0;}
//                     }
//                     endDate = moment(new Date(moment(initDate).add(parentScope.form.forma_de_pago.value, 'months').calendar())).format();
//
//                     var subTotal = obj.prima + obj.rpf + obj.derecho;
//                     var receipt = {
//                         'prima': parseFloat((obj.prima).toFixed(2)),
//                         'rpf': parseFloat((obj.rpf).toFixed(2)),
//                         'derecho': parseFloat((obj.derecho).toFixed(2)),
//                         'iva': 16,
//                         'subTotal':parseFloat((subTotal).toFixed(2)),
//                         'total': parseFloat((subTotal * 1.16).toFixed(2)),
//                         'startDate': initDate,
//                         'endingDate':  endDate
//                     };
//
//                     initDate = endDate;
//
//                     $scope.receipts.push(angular.copy(receipt));
//                     parentScope.receipts = $scope.receipts;
//                 }
//             }
//
//         };
//
//         $scope.ok = function () {
//             parentScope.show = {
//                 receipt: true,
//                 // ot: true
//             };
//             $uibModalInstance.dismiss('cancel');
//
//         };
//
//         $scope.cancel = function () {
//             $uibModalInstance.dismiss('cancel');
//         };
//
//         $scope.getNumber = function(num){
//             return new Array(num);
//         };
//
//         function getSubtotal(poliza){
//             var sum = poliza.primaNeta + poliza.rpf + poliza.derecho;
//             return Number((sum).toFixed(2));
//         }
//
//         function getTotal(poliza){
//             return poliza.subTotal * 1.16;
//         }
//     }
//     ///////////////// Create receipt modal
//
//
//   /////// PolicyModal
//   }

(function () {
  "use strict";

  angular.module("inspinia").factory("formService", formService);

  formService.$inject = ["$http", "generalService", "helpers", "datesFactory"];

  function formService($http, generalService, helpers, datesFactory) {
    var service = {
      createForm: createForm,
      getPersonalInfoByUri: getPersonalInfoByUri,
      deleteFormByUri: deleteFormByUri,
      createAccidentsDisease: createAccidentsDisease,
    };

    return service;

    function createForm(object) {
      // code required, insurance required
      var dfd = $.Deferred();
      var code = parseInt(object.code);
      var insurance = object.insurance;

      var responseFromThis = {};
      var done = 0;
      var toBeDone = 0;

      if (code == 1 || code == 30) {
        // personal: Object, relationships: [], smoker: boolean requied
        var personal = object.personal;
        var beneficiaries = object.relationships;
        var smoker = object.smoker;
        var asegs = object.personal_life_policy;
        responseFromThis = {
          personalInfo: null,
          lifeForm: null,
          beneficiaries: [],
          personal_life_policy: [],
        };
        // console.log('---------',personal,beneficiaries,smoker,asegs,object)
        if (asegs) {
          asegs.forEach(function (element, index) {
            element.policy = insurance.url;
            if (element.birthdate && element.birthdate.length == 10) {
              element.birthdate = element.birthdate
                ? datesFactory.toDate(element.birthdate)
                : null;
            }
            if (element.antiguedad && element.antiguedad.length == 10) {
              element.antiguedad = element.antiguedad
                ? datesFactory.toDate(element.antiguedad)
                : null;
            }
            element.full_name =
              element.first_name +
              " " +
              element.last_name +
              " " +
              element.second_last_name;
            element.smoker = element.smoker ? element.smoker : false;
            if (index == 0) {
              if (personal) {
                if (personal.birthdate && personal.birthdate.length == 10) {
                  personal.birthdate = personal.birthdate
                    ? datesFactory.toDate(personal.birthdate)
                    : null;
                }
                if (personal.antiguedad && personal.antiguedad.length == 10) {
                  personal.antiguedad = personal.antiguedad
                    ? datesFactory.toDate(personal.antiguedad)
                    : null;
                }
              }
              toBeDone = 2 + beneficiaries.length;
              generalService
                .createPersonalInformation(element)
                .then(function (personalInfo) {
                  if (checkRes(personalInfo)) {
                    return;
                  }

                  responseFromThis.personalInfo = personalInfo.data;

                  var model = {
                    sub_branch: insurance.subramo.url
                      ? insurance.subramo.url
                      : insurance.subramo,
                    policy: insurance.url,
                    personal: personalInfo.data.url,
                    smoker: smoker ? smoker : false,
                  };
                  generalService.lifeForm(model).then(function (lifeFormData) {
                    if (checkRes(lifeFormData)) {
                      return;
                    }
                    responseFromThis.lifeForm = lifeFormData.data;
                    aThingIsDone();
                    beneficiaries.forEach(function (elementb, index) {
                      elementb.life = lifeFormData.data.url;
                      if (elementb.birthdate.length == 10) {
                        elementb.birthdate = elementb.birthdate
                          ? datesFactory.toDate(elementb.birthdate)
                          : null;
                      }
                      if (elementb.antiguedad.length == 10) {
                        elementb.antiguedad = elementb.antiguedad
                          ? datesFactory.toDate(elementb.antiguedad)
                          : null;
                      }
                      elementb.full_name =
                        elementb.first_name +
                        " " +
                        elementb.last_name +
                        " " +
                        elementb.second_last_name;
                      generalService
                        .createBeneficiaries(elementb)
                        .then(function (beneficiarie) {
                          responseFromThis.beneficiaries.push(beneficiarie);
                          aThingIsDone();
                        });
                    });
                    aThingIsDone();
                  });

                  aThingIsDone();
                })
                .catch(function (error) {
                  dfd.reject(error);
                });
            } else {
              generalService
                .createPersonalInformation(element)
                .then(function (as) {
                  responseFromThis.personal_life_policy.push(as);
                  // console.log('mas de uno personal-',element,as,responseFromThis)
                });
            }
            aThingIsDone();
          });
        }
        toBeDone = 2 + beneficiaries.length;
      } else if (code === 2 || code === 3 || code === 4) {
        // personal: obj relationships: [] , coinsurance: string required
        //personal: Object
        //  first_name:       string
        //  last_name:        string
        //  second_last_name: string
        //  birthdate:        Date
        //  sex:              string F M

        //relationship: Object
        //  birthdate:        Date
        //  first_name:       string
        //  last_name:        string
        //  relationships:    Object
        //    option:           string
        //    relationship:     string
        //  second_last_name: string
        //  sex:              string
        var type = helpers.diseaseType(code);

        var personal = object.personal;
        var coinsurance = object.coinsurance;
        var relationships = object.relationships;
        personal.birthdate = personal.birthdate
          ? datesFactory.toDate(personal.birthdate)
          : null;
        personal.antiguedad = personal.antiguedad
          ? datesFactory.toDate(personal.antiguedad)
          : null;

        responseFromThis = {
          personalInfo: null,
          diseaseForm: null,
          relationships: [],
        };

        toBeDone = 2 + relationships.length;

        generalService
          .createPersonalInformation(personal)
          .then(function (personalInfo) {
            if (checkRes(personalInfo)) {
              return;
            }

            responseFromThis.personalInfo = personalInfo.data;

            var model = {
              sub_branch: insurance.subramo.url
                ? insurance.subramo.url
                : insurance.subramo,
              policy: insurance.url,
              personal: personalInfo.data.url,
              disease_type: type,
              coinsurance: coinsurance ? coinsurance : "",
            };
            generalService.diseaseForm(model).then(function (diseaseData) {
              if (checkRes(diseaseData)) {
                return;
              }
              responseFromThis.diseaseForm = diseaseData.data;

              var ulr = diseaseData.data.url;

              relationships.forEach(function (relationship) {
                // delete .toISOString().split("T")[0]
                relationship.birthdate = relationship.birthdate
                  ? datesFactory.toDate(relationship.birthdate)
                  : null;
                relationship.antiguedad = relationship.antiguedad
                  ? datesFactory.toDate(relationship.antiguedad)
                  : null;
                relationship.accident = diseaseData.data.url;
                relationship.relationship =
                  relationship.relationship.relationship;
                relationship.sex = relationship.sex.value;

                generalService
                  .createRelationship(relationship)
                  .then(function (relationshipData) {
                    responseFromThis.relationships.push(relationship);
                    aThingIsDone();
                  });
              });
              aThingIsDone();
            });
            aThingIsDone();
          })
          .catch(function (error) {
            dfd.reject(error);
          });
      } else if (
        code === 5 ||
        code === 6 ||
        code === 7 ||
        code === 8 ||
        code === 10 ||
        code === 11 ||
        code === 12 ||
        code === 13 ||
        code === 14 ||
        code === 31
      ) {
        toBeDone++;
        generalService.damageForm(object.form).then(function (dam) {
          aThingIsDone();
        });
      } else if (code === 9) {
        toBeDone++;
        generalService.automobileForm(object.form).then(function (aut) {
          aThingIsDone();
        });
      }
      function convertDate(inputFormat) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
        return date;
      }
      function checkRes(result) {
        if (result.status < 200 || result.status >= 300) {
          dfd.reject(result);
          return true;
        }
        return false;
      }

      function aThingIsDone() {
        done++;
        if (done >= toBeDone) {
          dfd.resolve(responseFromThis);
        }
      }

      return dfd.promise();
    }

    function getPersonalInfoByUri(uri) {
      return $http.get(uri);
    }

    function deleteFormByUri(uri) {
      return $http.delete(uri);
    }
    // Accident Disease
    function createAccidentsDisease(object) {
      // code required, insurance required
      var dfd = $.Deferred();
      var code = parseInt(object.code);
      var insurance = object.insurance;

      var responseFromThis = {};
      var done = 0;
      var toBeDone = 0;

      if (code === 2 || code === 3 || code === 4) {
        // personal: obj relationships: [] , coinsurance: string required
        var type = helpers.diseaseType(code);

        var personal = object.personal;
        var coinsurance = object.coinsurance;
        var relationships = object.relationships;
        // personal.birthdate = personal.birthdate ? datesFactory.toDate(personal.birthdate) : null;
        // personal.antiguedad = personal.antiguedad ? datesFactory.toDate(personal.antiguedad) : null;

        responseFromThis = {
          personalInfo: null,
          diseaseForm: null,
          relationships: [],
        };

        toBeDone = 2 + relationships.length;

        generalService
          .createPersonalInformation(personal)
          .then(function (personalInfo) {
            if (checkRes(personalInfo)) {
              return;
            }

            responseFromThis.personalInfo = personalInfo.data;

            var model = {
              sub_branch: insurance.subramo.url
                ? insurance.subramo.url
                : insurance.subramo,
              policy: insurance.url,
              personal: personalInfo.data.url,
              disease_type: type,
              coinsurance: coinsurance ? coinsurance : "",
            };
            generalService.diseaseForm(model).then(function (diseaseData) {
              if (checkRes(diseaseData)) {
                return;
              }
              responseFromThis.diseaseForm = diseaseData.data;

              var ulr = diseaseData.data.url;

              relationships.forEach(function (relationship) {
                // delete .toISOString().split("T")[0]
                relationship.accident = diseaseData.data.url;

                generalService
                  .createRelationship(relationship)
                  .then(function (relationshipData) {
                    responseFromThis.relationships.push(relationship);
                    aThingIsDone();
                  });
              });
              aThingIsDone();
            });
            aThingIsDone();
          })
          .catch(function (error) {
            dfd.reject(error);
          });
      }
      function convertDate(inputFormat) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
        return date;
      }
      function checkRes(result) {
        if (result.status < 200 || result.status >= 300) {
          dfd.reject(result);
          return true;
        }
        return false;
      }

      function aThingIsDone() {
        done++;
        if (done >= toBeDone) {
          dfd.resolve(responseFromThis);
        }
      }

      return dfd.promise();
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ConfiguradorCtrl", ConfiguradorCtrl)
    .controller("DescuentoController", DescuentoController)
    .controller("CredencialController", CredencialController);

  ConfiguradorCtrl.$inject = [
    "$scope",
    "$http",
    "SweetAlert",
    "$sessionStorage",
    "toaster",
    "datesFactory",
    "$uibModal",
    "$window",
    "$sce",
    "$parse",
    "$localStorage",
  ];
  DescuentoController.$inject = [
    "$scope",
    "$uibModalInstance",
    "descuentoData",
    "$http",
    "SweetAlert",
  ];
  CredencialController.$inject = [
    "$scope",
    "$uibModalInstance",
    "credencialData",
    "$http",
    "SweetAlert",
  ];

  function ConfiguradorCtrl(
    $scope,
    $http,
    SweetAlert,
    $sessionStorage,
    toaster,
    datesFactory,
    $uibModal,
    $window,
    $sce,
    $parse,
    $localStorage
  ) {
    $scope.aseguradoras = [];
    $scope.empresas = [];
    $scope.urlApi = "https://apigatewaymc.multicotizador.com/";
    $scope.urlApiHDI = "https://hdi-api.multicotizador.com/";
    $scope.selectedEmpresa = "";
    $scope.owner = "";
    $scope.aseguradora = "";
    $scope.selectedCoberturas = [];
    $scope.sumaAsegurada = {};
    $scope.coberturasPorPaquete = {};
    $scope.deducibleGNP = {};
    $scope.descuentos = [];
    $scope.credenciales = [];

    /* -----------------------------------------------------------
     * 1)  Detectar la organización del usuario (sessionStorage)
     * ----------------------------------------------------------- */
    var user = $sessionStorage.infoUser || {}; // ← con ngStorage ya es objeto
    var org = user.org || {}; // puede venir vacío
    $scope.owner = org.name || null; // ← será "pruebas", "gpi", etc.
    $scope.orgId = org.id || null; // por si necesitas el id
    if ($scope.owner == "gpi") {
      $scope.owner = "AndreaZamora";
    }

    $scope.COBERTURAS_QUALITAS = {
      1: "Daños Materiales",
      2: "DM Sólo pérdida total",
      3: "Robo Total",
      4: "Responsabilidad Civil",
      5: "Gastos Médicos",
      6: "Muerte del Conductor X Accidente",
      7: "Gastos Legales",
      8: "Equipo Especial [descripción del equipo | suma asegurada]",
      9: "Adaptaciones Daños Materiales [descripción de la adaptación | suma asegurada]",
      10: "Adaptaciones Robo Total [descripción de la adaptación | suma asegurada]",
      11: "Extensión de RC",
      12: "Exención de Deducible Daños Materiales",
      13: "RC Pasajero",
      14: "Asistencia Vial",
      17: "Gastos de Transporte/Gastos X Perdida de Uso X Pérdidas Totales",
      22: "RC Legal Ocupantes",
      26: "Cancelación de deducible por vuelco o colisión",
      28: "Gastos X Perdida de Uso X Perdidas Parciales",
      31: "Daños por la carga. Tipo Carga [A o B o C] | [Descrip de la Carga] | [Num Remolques]",
      40: "Exención de Deducible Robo Total",
      34: "RC en el Extranjero",
      47: "RC Complementaria Personas",
    };

    $scope.COBERTURAS_HDI = {
      249: "Asistencia en viajes",
      239: "Gastos medicos ocupantes (Limite unico combinado)",
      253: "Responsabilidad Civil",
      242: "Asistencia Juridica",
      233: "Danos materiales",
      235: "Accidentes Automovilisticos al conductor",
      266: "Responsabilidad USA y Canada",
      236: "Robo Total",
      366: "Responsabilidad civil exceso por muerte",
    };
    $scope.COBERTURAS_CHUBB = {
      1: "Daños materiales",
      2: "Robo total",
      3: "Responsabilidad civil por daños a terceros",
      4: "Gastos Médicos Ocupantes",
      6: "Muerte del conductor por accidente",
      7: "Responsabilidad civil carga A",
      8: "Adaptaciones y conversiones",
      9: "Equipo especial",
      11: "Responsabilidad civil carga B",
      12: "Responsabilidad civil carga C / Ecológica",
      14: "Responsabilidad civil primer remolque",
      15: "Responsabilidad civil segundo remolque",
      20: "Cobertura por diferencial (CODIF)",
      21: "Cláusula de extensión de cobertura limitada (CEL)",
      22: "Robo parcial (Parte por parte)",
      25: "Cláusula de aumento porcentual (CAP Daños materiales)",
      33: "Auto protegido EMME",
      41: "Extensión de cobertura de responsabilidad civil",
      42: "Asistencia legal IKE",
      43: "Responsabilidad civil equipo especial",
      44: "Responsabilidad civil adaptaciones y conversiones",
      45: "Cláusula de aumento porcentual (CAP Robo total)",
      46: "Auto relevo pérdida total",
      47: "Responsabilidad civil por daños a ocupantes",
      49: "Accidentes automovilísticos al conductor",
      78: "Asistencia legal PROVIAL",
      79: "Auto protegido EMERMEX",
      84: "Auto relevo integral",
      110: "Responsabilidad civil familiar",
      114: "Gestoría vial",
      115: "Maniobras de carga y descarga",
      117: "Auto relevo premium",
      118: "Auto relevo pérdida total premium",
      120: "Seguro de llantas y rines",
      393: "Auto relevo plus",
      394: "Auto relevo plus premium",
      467: "Asistencia legal AUSA",
      468: "Asistencia legal OESA",
      469: "Asistencia legal Logistics",
      470: "Asistencia legal y vial IKE",
      471: "Cerocible pérdida total daños",
      472: "Cerocible",
      473: "Responsabilidad civil por fallecimiento",
      486: "Responsabilidad civil por fallecimiento plus",
      524: "Gastos de transporte por pérdida total",
      549: "Reparación en agencia",
      552: "Responsabilidad civil en USA y Canadá",
      561: "Responsabilidad civil personas",
      702: "Cerocible pérdida total robo",
      703: "Auto protegido SIAM",
      726: "Responsabilidad civil viajero",
      732: "Accidentes personales",
      800: "Responsabilidad civil bienes",
      801: "Asistencia legal plus PROVIAL",
      856: "Asistencia en viaje CDS",
      858: "Asistencia legal CDS",
      859: "Asistencia legal y vial CDS",
      862: "Auto protegido CDS",
      863: "Auto relevo pérdida total CDS",
      864: "Auto relevo plus CDS",
      865: "Auto relevo pérdida total premium CDS",
      866: "Auto relevo plus premium CDS",
      974: "Pérdida o robo de llaves",
      975: "Robo de contenidos personales",
      976: "Responsabilidad civil en exceso",
    };
    $scope.COBERTURAS_ANA = {
      2: "Daños Materiales",
      4: "Robo Total",
      6: "Gastos Médicos",
      7: "Defensa Jurídica",
      8: "NPD x PT x DM",
      9: "Auto Sustituto",
      10: "ANA Asistencia",
      12: "Extensión de Coberturas",
      13: "Muerte Accidental",
      18: "ANA Rent",
      23: "RC Ocupantes",
      24: "NPD x PP x DM",
      25: "RC Bienes",
      26: "RC Personas",
      27: "RC USA",
      28: "Segullantas",
      29: "Extensión Autorent",
      33: "Robo Parcial",
      34: "RC Catastrófica",
      35: "Desbielamiento",
      37: "Grúa",
      38: "Devolución de Prima y Deducible",
      39: "Reparación en Taller",
      40: "Multas y Corralones",
    };
    $scope.COBERTURAS_PS = {
      DM: "Daños materiales",
      RT: "Robo Total",
      RCTP: "Responsabilidad Civil Terceros en sus Personas",
      RCTB: "Responsabilidad Civil Terceros en sus Bienes",
      RCTBP: "Responsabilidad Civil Terceros en sus Bienes y Personas",
      GMO: "Gastos Médicos Ocupantes",
      DJUR: "Defensa Jurídica",
      RCV: "Responsabilidad Civil Viajero",
      EE: "Equipo Especial",
      GMC: "Gastos Médicos al Conductor",
      GMF: "Gastos Médicos a Familiares del Conductor",
      NPD: "No pago de deducible por pérdida total en daños materiales",
      ASVI: "Asistencia Vial",
      SPT: "Sólo Pérdida Total",
      UGF: "Últimos Gastos",
      AS: "Automóvil Sustituto",
      ExtRCP: "Extensión de RC a Terceros en sus Personas",
      ExtRCB: "Extensión de RC a Terceros en sus Bienes",
      EXTRCTBP: "Extensión de RC a Terceros en sus Bienes y Personas",
      RCCP: "Daños por la Carga a Terceros en sus Personas",
      RCCB: "Daños por la Carga a Terceros en sus Bienes",
      RCCTB: "Daños por la Carga a Terceros en sus Bienes y Personas",
      PC: "Pérdida de cuenta",
      EXTRTV: "Extensión de Gastos Médicos por robo con violencia",
      "AD&CON": "Adaptaciones y conversiones",
      RED: "RED",
      GV: "GV",
      RCUSA: "RCUSA",
      EXCRCP: "EXCRCP",
      AAC: "AAC",
    };

    $scope.COBERTURAS_GNP = {
      "0000000893": {
        id: "0000000893",
        nombre: "Accidentes Automovilisticos al conductor",
        sumaAsegurada: 100000,
        suma_asegurada: [20000, 50000, 100000, 150000, 200000, 250000, 300000],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000000894": {
        id: "0000000894",
        nombre: "Adaptaciones, conversiones y Equipo especial",
        sumaAsegurada: "Amparada",
        suma_asegurada: [],
        deducible: 25,
        opcionesDeducible: [25],
      },
      "0000001414": {
        id: "0000001414",
        nombre: "Auto Sustituto",
        sumaAsegurada: 10,
        suma_asegurada: [10, 15, 20, 30],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000001415": {
        id: "0000001415",
        nombre: "Auto Sustituto Plus",
        sumaAsegurada: 10,
        suma_asegurada: [10, 15, 20, 30],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000001348": {
        id: "0000001348",
        nombre: "Ayuda para Pérdidas Totales",
        sumaAsegurada: 7500,
        suma_asegurada: [7500, 15000],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000001268": {
        id: "0000001268",
        nombre: "Club GNP",
        sumaAsegurada: "Amparada",
        suma_asegurada: [],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000000891": {
        id: "0000000891",
        nombre: "Cristales",
        sumaAsegurada: "Amparada",
        suma_asegurada: [],
        deducible: 20,
        opcionesDeducible: [20],
      },
      "0000001289": {
        id: "0000001289",
        nombre: "Daños Materiales Pérdida Parcial",
        sumaAsegurada: "N/A",
        suma_asegurada: [],
        deducible: 3,
        opcionesDeducible: [3, 5, 10],
      },
      "0000001288": {
        id: "0000001288",
        nombre: "Daños Materiales Pérdida Total",
        sumaAsegurada: "N/A",
        suma_asegurada: [],
        deducible: 0,
        opcionesDeducible: [0, 3, 5, 10],
      },
      "0000000904": {
        id: "0000000904",
        nombre: "Extensión de Responsabilidad Civil",
        sumaAsegurada: 1000000,
        suma_asegurada: [
          1000000, 1500000, 2000000, 2500000, 3000000, 3500000, 4000000,
          4500000, 5000000,
        ],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000000906": {
        id: "0000000906",
        nombre: "Gastos Médicos Ocupantes",
        sumaAsegurada: 200000,
        suma_asegurada: [
          100000, 120000, 150000, 200000, 300000, 400000, 500000, 600000,
          700000, 800000, 900000, 1000000,
        ],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000000909": {
        id: "0000000909",
        nombre: "Protección Auxiliar",
        sumaAsegurada: "Amparada",
        suma_asegurada: [],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000001285": {
        id: "0000001285",
        nombre: "Protección legal",
        sumaAsegurada: 1000000,
        suma_asegurada: [
          1000000, 1500000, 2000000, 2500000, 3000000, 3500000, 4000000,
          4500000, 5000000,
        ],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000001453": {
        id: "0000001453",
        nombre: "Responsabilidad Civil Ocupantes",
        sumaAsegurada: 1000000,
        suma_asegurada: [
          1000000, 1500000, 2000000, 2500000, 3000000, 3500000, 4000000,
          4500000, 5000000,
        ],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000001273": {
        id: "0000001273",
        nombre: "Responsabilidad Civil por Daños a Terceros",
        sumaAsegurada: 1000000,
        suma_asegurada: [
          1000000, 1500000, 2000000, 2500000, 3000000, 3500000, 4000000,
          4500000, 5000000,
        ],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000001452": {
        id: "0000001452",
        nombre: "Responsabilidad Civil Fallecimiento",
        sumaAsegurada: 500000,
        suma_asegurada: [
          500000, 1000000, 1500000, 2000000, 2500000, 3000000, 5000000,
        ],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000000916": {
        id: "0000000916",
        nombre: "Robo total",
        sumaAsegurada: "N/A",
        suma_asegurada: [],
        deducible: 0,
        opcionesDeducible: [0, 3, 5, 10, 20],
      },
      "0000001470": {
        id: "0000001470",
        nombre: "Ayuda Llantas/Rines",
        sumaAsegurada: 25000,
        suma_asegurada: [25000],
        deducible: 25,
        opcionesDeducible: [25],
      },
      "0000001471": {
        id: "0000001471",
        nombre: "Llaves de repuesto",
        sumaAsegurada: 5000,
        suma_asegurada: [5000],
        deducible: 20,
        opcionesDeducible: [20],
      },

      "0000001473": {
        id: "0000001473",
        nombre: "Siempre en Agencia",
        sumaAsegurada: "Amparada",
        suma_asegurada: [],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000001461": {
        id: "0000001461",
        nombre: "Robo Parcial",
        sumaAsegurada: "Amparada",
        suma_asegurada: [],
        deducible: 10,
        opcionesDeducible: [10, 25],
      },
      "0000001472": {
        id: "0000001472",
        nombre: "Robo Parcial Plus",
        sumaAsegurada: "Amparada",
        suma_asegurada: [],
        deducible: 10,
        opcionesDeducible: [10, 25],
      },
      "0000001564": {
        id: "0000001564",
        nombre: "Conductor Protegido",
        sumaAsegurada: "Amparada",
        suma_asegurada: [],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000001465": {
        id: "0000001465",
        nombre: "Garantia Autos Financiamiento",
        sumaAsegurada: "Amparada",
        suma_asegurada: [],
        deducible: 0,
        opcionesDeducible: [],
      },
      "0000001567": {
        id: "0000001567",
        nombre: "Asistencia Vial Moto",
        sumaAsegurada: "Amparada",
        suma_asegurada: [],
        deducible: 0,
        opcionesDeducible: [],
      },
    };
    $scope.onSumaAseguradaChangeGNP = function (event, key) {
      var selectedCobertura = $scope.selectedCoberturas.find(function (
        cobertura
      ) {
        return cobertura.id === key;
      });

      if (selectedCobertura) {
        selectedCobertura.sumaAsegurada = event;
      }
    };

    $scope.getCoberturasActuales = function () {
      switch ($scope.aseguradora) {
        case "qualitas":
          $scope.coberturasActuales = $scope.COBERTURAS_QUALITAS;
          break;
        case "gnp":
          $scope.coberturasActuales = $scope.COBERTURAS_GNP;
          break;
        case "chubb":
          $scope.coberturasActuales = $scope.COBERTURAS_CHUBB;
          break;
        case "ana":
          $scope.coberturasActuales = $scope.COBERTURAS_ANA;
          break;
        case "hdi":
          $scope.coberturasActuales = $scope.COBERTURAS_HDI;
          break;
        case "ps":
          $scope.coberturasActuales = $scope.COBERTURAS_PS;
          break;
        default:
          $scope.coberturasActuales = [];
      }
      return $scope.coberturasActuales;
    };
    $scope.getKeys = function (obj) {
      if (!obj || typeof obj !== "object") {
        return [];
      }
      return Object.keys(obj);
    };

    $scope.generarXML = function (cobertura) {
      if ($scope.aseguradora === "qualitas" && cobertura.noCobertura == 47) {
        return (
          '<Coberturas NoCobertura="' +
          cobertura.noCobertura +
          '">' +
          "<SumaAsegurada>" +
          cobertura.sumaAsegurada +
          "</SumaAsegurada>" +
          "<TipoSuma>14</TipoSuma>" +
          "<Deducible>" +
          cobertura.deducible +
          "</Deducible>" +
          "<Prima>0.0</Prima>" +
          "</Coberturas>"
        );
      } else if ($scope.aseguradora === "qualitas") {
        return (
          '<Coberturas NoCobertura="' +
          cobertura.noCobertura +
          '">' +
          "<SumaAsegurada>" +
          cobertura.sumaAsegurada +
          "</SumaAsegurada>" +
          "<TipoSuma>0</TipoSuma>" +
          "<Deducible>" +
          cobertura.deducible +
          "</Deducible>" +
          "<Prima>0.0</Prima>" +
          "</Coberturas>"
        );
      }

      if ($scope.aseguradora === "ps") {
        var XML = "";
        for (var key in $scope.selectedCoberturas) {
          if (
            $scope.selectedCoberturas.hasOwnProperty(key) &&
            key.indexOf("_") === -1
          ) {
            var id = $scope.selectedCoberturas[key];
            var deducible = $scope.selectedCoberturas[key + "_deducible"] || 0;
            var sumaAsegurada =
              $scope.selectedCoberturas[key + "_sumaAsegurada"] || 0;

            XML +=
              "<coberturas>" +
              "<id>" +
              id +
              "</id>" +
              "<suma_asegurada>" +
              sumaAsegurada +
              "</suma_asegurada>" +
              "<deducible>" +
              deducible +
              "</deducible>" +
              "</coberturas>";
          }
        }
        return XML;
      }

      if ($scope.aseguradora === "chubb") {
        var deducibleDividido =
          (cobertura.deducible != null ? cobertura.deducible : "") / 100;
        return (
          "<COB>" +
          "<COBID>" +
          cobertura.noCobertura +
          "</COBID>" +
          "<SUMAASEG>" +
          cobertura.sumaAsegurada +
          "</SUMAASEG>" +
          "<DADIC>" +
          (cobertura.deducibleAdicional != null
            ? cobertura.deducibleAdicional
            : "") +
          "</DADIC>" +
          "<DPCT>" +
          (deducibleDividido != null ? deducibleDividido : "") +
          "</DPCT>" +
          "</COB>"
        );
      }

      if ($scope.aseguradora === "gnp") {
        return (
          "<COBERTURA>" +
          "<CVE_COBERTURA>" +
          cobertura.id +
          "</CVE_COBERTURA>" +
          "<DEDUCIBLE>" +
          (cobertura.deducible || "") +
          "</DEDUCIBLE>" +
          "<NOMBRE>" +
          (cobertura.nombre ? cobertura.nombre.toUpperCase() : "") +
          "</NOMBRE>" +
          "<SUMA_ASEGURADA>" +
          (cobertura.sumaAsegurada || "") +
          "</SUMA_ASEGURADA>" +
          "</COBERTURA>"
        );
      }

      if ($scope.aseguradora === "ana") {
        if (cobertura.cobID == "10") {
          return (
            '<cobertura id="' +
            cobertura.cobID +
            '" ' +
            'desc="' +
            (cobertura.desc || "") +
            '" ' +
            'sa="' +
            (cobertura.sumaAsegurada || "") +
            '" ' +
            'tipo="B" ' +
            'ded="' +
            (cobertura.deducible || "") +
            '" ' +
            'pma="' +
            (cobertura.pma || "") +
            '"/>'
          );
        } else {
          return (
            '<cobertura id="' +
            cobertura.cobID +
            '" ' +
            'desc="' +
            (cobertura.desc || "") +
            '" ' +
            'sa="' +
            (cobertura.sumaAsegurada || "") +
            '" ' +
            'tipo="' +
            (cobertura.tipo || "") +
            '" ' +
            'ded="' +
            (cobertura.deducible || "") +
            '" ' +
            'pma="' +
            (cobertura.pma || "") +
            '"/>'
          );
        }
      }

      if ($scope.aseguradora === "hdi") {
        return (
          "{" +
          '"Regla": ' +
          cobertura.regla +
          "," +
          '"Clave": ' +
          cobertura.cobID +
          "," +
          '"Descripcion": "' +
          cobertura.nombre +
          '",' +
          '"SumaAsegurada": ' +
          (cobertura.sumaAsegurada || 0) +
          "," +
          '"Deducible": ' +
          (cobertura.deducible || 0) +
          "," +
          '"ProveedorAsistencia": ' +
          cobertura.proveedorAsistencia +
          "," +
          '"PrimaNeta": ' +
          cobertura.primaNeta +
          "," +
          '"Calculada": "' +
          cobertura.calculada +
          '"' +
          "}"
        );
      }

      return "";
    };

    $scope.onSumaAseguradaInput = function (event, key) {
      var inputElement = event.target;
      var rawValue = inputElement.value.replace(/,/g, "");
      var numericValue = parseFloat(rawValue) || 0;

      $scope.selectedCoberturas[key + "_sumaAsegurada"] = numericValue;

      var cobertura;

      if ($scope.aseguradora === "ana" || $scope.aseguradora === "hdi") {
        cobertura = $scope.coberturas.find(function (c) {
          return c.cobID === parseInt(key);
        });

        if (cobertura) {
          cobertura.sumaAsegurada = numericValue;
          cobertura.data = $scope.generarXML(cobertura);
        } else {
          console.warn("No se encontró la cobertura con el id: " + key);
        }
      } else if ($scope.aseguradora === "chubb") {
        cobertura = $scope.coberturas.find(function (c) {
          return c.noCobertura === parseInt(key);
        });

        if (cobertura) {
          cobertura.sumaAsegurada = numericValue;
          cobertura.data = $scope.generarXML(cobertura);
        } else {
          console.warn("No se encontró la cobertura con el id: " + key);
        }
      } else if ($scope.aseguradora === "qualitas") {
        cobertura = $scope.coberturas.find(function (c) {
          return c.noCobertura === parseInt(key);
        });

        if (cobertura) {
          cobertura.sumaAsegurada = numericValue;
          cobertura.data = $scope.generarXML(cobertura);
        } else {
          console.warn("No se encontró la cobertura con el id: " + key);
        }
      } else if ($scope.aseguradora === "gnp") {
        cobertura = $scope.coberturasFiltradas.find(function (c) {
          return c.id === key;
        });

        if (cobertura) {
          cobertura.sumaAsegurada = numericValue;
          cobertura.data = $scope.generarXML(cobertura);
        } else {
          console.warn("No se encontró la cobertura con el id: " + key);
        }
      } else if ($scope.aseguradora === "ps") {
        cobertura = $scope.coberturasPS.find(function (c) {
          return c.id === key;
        });

        if (cobertura) {
          cobertura.sumaAsegurada = numericValue;
          cobertura.data = $scope.generarXML(cobertura);
          $scope.XML = cobertura.data;
        } else {
          console.warn("No se encontró la cobertura con el id: " + key);
        }
      }
    };

    $scope.formatVisualSumaAsegurada = function (value) {
      if (value == null || value === 0 || value === undefined) return "";
      return parseFloat(value).toLocaleString("en-US");
    };

    $scope.crearCobertura = function (key, _id) {
      var deducible = $scope.selectedCoberturas[key + "_deducible"] || 0;
      var sumaAsegurada =
        $scope.selectedCoberturas[key + "_sumaAsegurada"] || 0;
      var id = $scope.selectedCoberturas[key + "_id"] || null;

      if ($scope.aseguradora === "qualitas") {
        var seleccion = {
          noCobertura: parseInt(key),
          sumaAsegurada: sumaAsegurada,
          deducible: deducible,
          id: $scope.COBERTURAS_QUALITAS[_id] || null,
          nombre: _id || "",
          data: "",
          paquete: $scope.paquete || "Amplia",
          owner: $scope.owner,
        };
        seleccion.data = $scope.generarXML(seleccion);
        var coberturaExistente = $scope.coberturas.find(function (c) {
          return c.noCobertura === parseInt(key);
        });
        if (!coberturaExistente) {
          $scope.coberturas.push(seleccion);
        } else {
          angular.extend(coberturaExistente, seleccion);
        }
      }

      if ($scope.aseguradora === "chubb") {
        var seleccion = {
          noCobertura: parseInt(key),
          sumaAsegurada: sumaAsegurada,
          deducible: deducible,
          id: $scope.COBERTURAS_CHUBB[_id] || null,
          nombre: _id || "",
          data: "",
          paquete: $scope.paquete,
          owner: $scope.owner,
        };
        seleccion.data = $scope.generarXML(seleccion);
        var coberturaExistente = $scope.coberturas.find(function (c) {
          return c.noCobertura === parseInt(key);
        });
        if (!coberturaExistente) {
          $scope.coberturas.push(seleccion);
        } else {
          angular.extend(coberturaExistente, seleccion);
        }
      }

      if ($scope.aseguradora === "ana") {
        var seleccion = {
          cobID: parseInt(key),
          sumaAsegurada: sumaAsegurada,
          deducible: deducible,
          id: $scope.COBERTURAS_ANA[_id] || null,
          nombre: _id || "",
          data: "",
          paquete: $scope.paquete,
          owner: $scope.owner,
        };
        seleccion.data = $scope.generarXML(seleccion);
        var coberturaExistente = $scope.coberturas.find(function (c) {
          return c.noCobertura === parseInt(key);
        });
        if (!coberturaExistente) {
          $scope.coberturas.push(seleccion);
        } else {
          angular.extend(coberturaExistente, seleccion);
        }
      }

      if ($scope.aseguradora === "hdi") {
      }
    };
    $scope.onCheckboxChange = function (key, id) {
      var isChecked = $scope.selectedCoberturas[key];
      if (isChecked) {
        $scope.selectedCoberturas[key + "_id"] = id;
      } else {
        delete $scope.selectedCoberturas[key + "_id"];
      }
    };

    $scope.onCheckboxChangeQualitas = function (key, _id) {
      var isChecked = $scope.selectedCoberturas[key];

      if (isChecked) {
        $scope.crearCobertura(key, _id); // Asegúrate de tener este método disponible en tu controlador
      } else {
        if ($scope.aseguradora === "hdi") {
        }

        if ($scope.aseguradora === "qualitas") {
          // var cobertura = $scope.coberturas.find(c => c.noCobertura === parseInt(key));
          var cobertura = null;
          for (var i = 0; i < $scope.coberturas.length; i++) {
            if ($scope.coberturas[i].noCobertura === parseInt(key)) {
              cobertura = $scope.coberturas[i];
              break;
            }
          }

          if (cobertura && cobertura.id) {
            var payload = {
              id: cobertura.id,
            };

            $http
              .delete(
                $scope.urlApi + "cotizar/coberturas/" + $scope.aseguradora,
                payload
              )
              .then(function (response) {
                SweetAlert.swal("Listo", "Cambios guardados", "success");
              })
              .catch(function (error) {
                // console.error('Error al actualizar aseguradoras:', error);
                SweetAlert.swal("Ocurrio un error", error, "error");
              });
          } else {
            // $scope.coberturas = $scope.coberturas.filter(c => c.noCobertura !== parseInt(key));
          }
        }

        if ($scope.aseguradora === "chubb" || $scope.aseguradora === "ana") {
          // var cobertura = $scope.coberturas.find(c => parseInt(c.cobID) === parseInt(key));
          var cobertura = null;
          for (var i = 0; i < $scope.coberturas.length; i++) {
            if (parseInt($scope.coberturas[i].cobID) === parseInt(key)) {
              cobertura = $scope.coberturas[i];
              break; // Opcional, si solo esperas una coincidencia
            }
          }

          if (cobertura && cobertura.id) {
            var payload = {
              id: cobertura.id,
            };

            $http
              .delete(
                $scope.urlApi + "cotizar/coberturas/" + $scope.aseguradora,
                { params: payload }
              )
              .then(function (response) {
                // Puedes mostrar una notificación de éxito aquí
              })
              .catch(function (error) {
                console.error("Error al actualizar aseguradoras:", error);
                // Puedes manejar el error y mostrar una notificación al usuario
              });
          } else {
            // $scope.coberturas = $scope.coberturas.filter(c =>
            //   c.cobID !== parseInt(key) || c.paquete !== $scope.paquete
            // );
          }
        }
      }
    };

    $scope.onTipoChange = function (option) {
      if ($scope.aseguradora === "hdi" || $scope.aseguradora === "ps") {
        $scope.selectedCoberturas = {};

        switch (option) {
          case "Amplia":
            $scope.paquete = "Amplia";
            break;
          case "Limitada":
            $scope.paquete = "Limitada";
            break;
          case "RC":
            $scope.paquete = "RC";
            break;
          default:
            $scope.paquete = "";
        }

        if ($scope.aseguradora === "hdi") {
          formatoService
            .getCoberturasHDI($scope.owner, $scope.paquete)
            .then(function (response) {
              $scope.coberturas = response.data; // Si `response` contiene un objeto con `data`
              $scope.procesarCoberturas();

              var paquetesUnicos = new Set();
              var coberturasPorPaquete = {};

              $scope.coberturas.forEach(function (cobertura) {
                var cobID = cobertura.cobID;
                var paquete = cobertura.paquete;

                if (paquete) {
                  paquetesUnicos.add(paquete);
                  if (!coberturasPorPaquete[paquete]) {
                    coberturasPorPaquete[paquete] = [];
                  }
                  coberturasPorPaquete[paquete].push(cobertura);
                }

                $scope.selectedCoberturas[cobID] = true;
                $scope.selectedCoberturas[cobID + "_clave"] = cobID;
                $scope.selectedCoberturas[cobID + "_regla"] = cobertura.regla;
                $scope.selectedCoberturas[cobID + "_descripcion"] =
                  cobertura.nombre;
                $scope.selectedCoberturas[cobID + "_sumaAsegurada"] =
                  cobertura.sumaAsegurada;
                $scope.selectedCoberturas[cobID + "_id"] = cobertura.id;
                $scope.selectedCoberturas[cobID + "_deducible"] =
                  cobertura.deducible;
                $scope.selectedCoberturas[cobID + "_tipoCobertura"] =
                  cobertura.tipoCobertura;
              });

              $scope.paquetesUnicos = Array.from(paquetesUnicos);
              $scope.selectedCoberturas["coberturasPorPaquete"] =
                coberturasPorPaquete;
              $scope.coberturasPorPaquete = coberturasPorPaquete;
            });
        }
      }
    };
    $scope.isCoberturaSeleccionada = function (id) {
      return $scope.selectedCoberturas.some(function (cobertura) {
        return cobertura.id === id;
      });
    };

    $scope.getDeducibleGNP = function (id) {
      var cobertura = null;

      for (var i = 0; i < $scope.selectedCoberturas.length; i++) {
        if ($scope.selectedCoberturas[i].id === id) {
          cobertura = $scope.selectedCoberturas[i];
          break;
        }
      }

      return cobertura ? cobertura.deducible : null;
    };

    // Función para manejar el cambio del checkbox
    $scope.onCheckboxChangeGNP = function (key, cobertura, event) {
      $scope.sumaAsegurada = $scope.sumaAsegurada || {};
      $scope.deducibleGNP = $scope.deducibleGNP || {};

      if ($scope.aseguradora === "gnp") {
        if (event) {
          $scope.selectedCoberturas.push({
            id: key,
            nombre: cobertura.nombre,
            sumaAsegurada: cobertura.sumaAsegurada,
            deducible: cobertura.deducible,
          });

          $scope.sumaAsegurada[key] = cobertura.sumaAsegurada;
          $scope.deducibleGNP[key] = cobertura.deducible;
        } else {
          $scope.selectedCoberturas = $scope.selectedCoberturas.filter(
            function (c) {
              return c.id !== key;
            }
          );
          delete $scope.sumaAsegurada[key];
          delete $scope.deducibleGNP[key];
        }
      }
    };

    $scope.tipoOpciones = ["Amplia", "RC", "Limitada"];
    $scope.getAseguradoras = function () {
      $http
        .get($scope.urlApi + "core/aseguradora-saam")
        .then(function (response) {
          $scope.aseguradoras = response.data.results || [];
          $scope.inicializarCheckboxes();
        })
        .catch(function (error) {
          console.error("Error al obtener aseguradoras:", error);
        });
    };

    $scope.onTipoChange = function (option) {
      if ($scope.aseguradora === "hdi" || $scope.aseguradora === "ps") {
        $scope.selectedCoberturas = {};

        switch (option) {
          case "Amplia":
            $scope.paquete = "Amplia";
            break;
          case "Limitada":
            $scope.paquete = "Limitada";
            break;
          case "RC":
            $scope.paquete = "RC";
            break;
          default:
            $scope.paquete = "";
        }

        if ($scope.aseguradora === "hdi") {
          $http({
            method: "GET",
            url: $scope.urlApiHDI + "coberturas",
            params: {
              owner: $scope.owner,
              paquete: $scope.paquete,
            },
          }).then(
            function (response) {
              $scope.coberturas = response.data;
              $scope.procesarCoberturas();
              // Procesar coberturas
              var paquetesUnicos = new Set();
              var coberturasPorPaquete = {};

              $scope.coberturas.forEach(function (cobertura) {
                var cobID = cobertura.cobID;
                var paquete = cobertura.paquete;

                if (paquete) {
                  paquetesUnicos.add(paquete);
                  if (!coberturasPorPaquete[paquete]) {
                    coberturasPorPaquete[paquete] = [];
                  }
                  coberturasPorPaquete[paquete].push(cobertura);
                }

                $scope.selectedCoberturas[cobID] = true;
                $scope.selectedCoberturas[cobID + "_clave"] = cobID;
                $scope.selectedCoberturas[cobID + "_regla"] = cobertura.regla;
                $scope.selectedCoberturas[cobID + "_descripcion"] =
                  cobertura.nombre;
                $scope.selectedCoberturas[cobID + "_sumaAsegurada"] =
                  cobertura.sumaAsegurada;
                $scope.selectedCoberturas[cobID + "_id"] = cobertura.id;
                $scope.selectedCoberturas[cobID + "_deducible"] =
                  cobertura.deducible;
                $scope.selectedCoberturas[cobID + "_tipoCobertura"] =
                  cobertura.tipoCobertura;
              });

              $scope.paquetesUnicos = Array.from(paquetesUnicos);
              $scope.selectedCoberturas["coberturasPorPaquete"] =
                coberturasPorPaquete;
              $scope.coberturasPorPaquete = coberturasPorPaquete;
            },
            function (error) {
              console.error("Error al obtener coberturas:", error);
            }
          );
        }
      }
    };

    $scope.getEmpresas = function () {
      $http
        .get($scope.urlApi + "core/empresa-saam", {
          params: { name: $scope.owner }, // <-- 1) FILTRO en servidor
        })
        .then(function (res) {
          $scope.empresas = res.data || [];

          // Si el backend no filtra, filtra tú:
          if ($scope.empresas.length > 1) {
            $scope.empresas = $scope.empresas.filter(function (e) {
              return e.nombre === $scope.owner;
            });
          }
          // Preselecciona para que los <select> queden bloqueados
          if ($scope.empresas.length) {
            $scope.selectedEmpresa = $scope.empresas[0].id;
            $scope.changeEmpresa($scope.empresas[0].id);
          }
        });
    };

    $scope.inicializarCheckboxes = function () {
      $scope.aseguradorasSeleccionadas = {};
      $scope.aseguradoras.forEach(function (aseguradora) {
        $scope.aseguradorasSeleccionadas[aseguradora.id] = false;
      });
    };

    // $scope.selectedEmpresa = null; // Valor inicial
    $scope.aseguradorasSeleccionadas = {}; // Objeto para seleccionadas

    // Inicializar todos los checkboxes
    $scope.inicializarCheckboxes();
    $scope.changeEmpresaDescuento = function (seleccion) {
      $scope.selectedCoberturas = {};
      $scope.owner = seleccion;
      if ($scope.aseguradora && $scope.owner) {
        $scope.getCoberturasDescuento($scope.owner);
        $scope.descuento_seleccionado = {};
      }
    };
    $scope.changeAseguradoraDescuento = function (aseguradora) {
      $scope.selectedCoberturas = {};
      $scope.aseguradora = aseguradora;
      if ($scope.owner && $scope.aseguradora) {
        $scope.getCoberturasDescuento($scope.owner);
        $scope.cobertura_seleccionada = {};
      }
    };
    $scope.getCoberturasDescuento = function (owner) {
      $http({
        method: "GET",
        url: $scope.urlApi + "cotizar/descuentos-saam/" + $scope.aseguradora,
        params: {
          owner: owner,
        },
      })
        .then(function (response) {
          $scope.descuentos = response.data;
        })
        .catch(function (error) {
          $scope.descuentos = [];
        });
    };

    $scope.changeEmpresa = function (seleccion) {
      // Inicializar todos los checkboxes
      $scope.inicializarCheckboxes();

      if (!seleccion) {
        console.log("No se seleccionó ninguna empresa.");
        return;
      }

      // Buscar la empresa seleccionada por el ID
      var empresaSeleccionada = $scope.empresas.find(function (empresa) {
        return empresa.id == seleccion; // Asegurarse de comparar correctamente (usa == para tipo diferente)
      });

      if (empresaSeleccionada) {
        if (
          empresaSeleccionada.aseguradoras &&
          empresaSeleccionada.aseguradoras.length > 0
        ) {
          // Activar los checkboxes de aseguradoras asociadas
          angular.forEach(
            empresaSeleccionada.aseguradoras,
            function (aseguradoraId) {
              var aseguradora = $scope.aseguradoras.find(function (a) {
                return a.id == aseguradoraId; // Comparación flexible
              });

              if (aseguradora) {
                $scope.aseguradorasSeleccionadas[aseguradora.id] = true;
              }
            }
          );
        } else {
          console.log(
            "La empresa seleccionada no tiene aseguradoras asociadas."
          );
        }
      } else {
        console.log("No se encontró la empresa seleccionada.");
      }
    };
    $scope.changeAseguradora = function (aseguradora) {
      $scope.selectedCoberturas = {};
      $scope.aseguradora = aseguradora;
      $scope.paquete = "";
      // $scope.owner = '';

      $scope.getCoberturasActuales();
      if ($scope.owner && $scope.aseguradora) {
        $scope.getCoberturas($scope.owner);
        $scope.cobertura_seleccionada = {};
      }
    };
    $scope.changeNegocio = function (empresa) {
      $scope.selectedCoberturas = {};
      // $scope.owner = empresa;
      $scope.paquete = "";
      if ($scope.aseguradora !== "hdi" && $scope.owner) {
        $scope.getCoberturas($scope.owner);
        $scope.cobertura_seleccionada = {};
      }
    };
    $scope.obtenerCoberturaPorId = function (id) {
      switch (id) {
        case 1:
          return {
            nombre: "Gastos médicos ocupantes",
            insuredSum: 300000,
            deductible: 0,
          };
        case 2:
          return {
            nombre: "Gastos médicos ocupantes",
            insuredSum: 350000,
            deductible: 0,
          };
        case 3:
          return {
            nombre: "Gastos médicos ocupantes",
            insuredSum: 400000,
            deductible: 0,
          };
        case 4:
          return {
            nombre: "Gastos médicos ocupantes",
            insuredSum: 500000,
            deductible: 0,
          };
        case 5:
          return {
            nombre: "Responsabilidad Civil Personas",
            insuredSum: 1000000,
            deductible: null,
          };
        case 6:
          return {
            nombre: "Responsabilidad Civil Personas",
            insuredSum: 1500000,
            deductible: null,
          };
        case 7:
          return {
            nombre: "Responsabilidad Civil Personas",
            insuredSum: 2000000,
            deductible: null,
          };
        case 8:
          return {
            nombre: "Responsabilidad Civil Muerte",
            insuredSum: 500000,
            deductible: null,
          };
        case 9:
          return {
            nombre: "Responsabilidad Civil Muerte",
            insuredSum: 1000000,
            deductible: null,
          };
        case 10:
          return {
            nombre: "Responsabilidad Civil Muerte",
            insuredSum: 1500000,
            deductible: null,
          };
        case 11:
          return {
            nombre: "Responsabilidad Civil Bienes",
            insuredSum: 1000000,
            deductible: null,
          };
        case 12:
          return {
            nombre: "Responsabilidad Civil Bienes",
            insuredSum: 1500000,
            deductible: null,
          };
        case 13:
          return {
            nombre: "Responsabilidad Civil Bienes",
            insuredSum: 2000000,
            deductible: null,
          };
        case 17:
          return {
            nombre: "Daños materiales",
            insuredSum: null,
            deductible: 3,
            opcion_deducible_perdida_total: true,
          };
        case 18:
          return {
            nombre: "Daños materiales",
            insuredSum: null,
            deductible: 3,
            opcion_deducible_perdida_total: false,
          };
        case 19:
          return {
            nombre: "Daños materiales",
            insuredSum: null,
            deductible: 5,
            opcion_deducible_perdida_total: true,
          };
        case 20:
          return {
            nombre: "Daños materiales",
            insuredSum: null,
            deductible: 5,
            opcion_deducible_perdida_total: false,
          };
        case 21:
          return {
            nombre: "Daños materiales",
            insuredSum: null,
            deductible: 7,
            opcion_deducible_perdida_total: true,
          };
        case 22:
          return {
            nombre: "Daños materiales",
            insuredSum: null,
            deductible: 7,
            opcion_deducible_perdida_total: false,
          };
        case 23:
          return {
            nombre: "Robo total",
            insuredSum: null,
            deductible: 0,
          };
        case 24:
          return {
            nombre: "Robo total",
            insuredSum: null,
            deductible: 5,
          };
        case 25:
          return {
            nombre: "Robo total",
            insuredSum: null,
            deductible: 10,
          };
        case 26:
          return {
            nombre: "Robo total",
            insuredSum: null,
            deductible: 15,
          };
        case 27:
          return {
            nombre: "Robo parcial",
            insuredSum: null,
            deductible: 5,
          };
        case 28:
          return {
            nombre: "Robo parcial",
            insuredSum: null,
            deductible: 10,
          };
        case 29:
          return {
            nombre: "Robo parcial",
            insuredSum: null,
            deductible: 15,
          };
        case 30:
          return {
            nombre: "Accidentes al conductor",
            insuredSum: 50000,
            deductible: 0,
          };
        case 31:
          return {
            nombre: "Accidentes al conductor",
            insuredSum: 100000,
            deductible: 0,
          };
        case 32:
          return {
            nombre: "Accidentes al conductor",
            insuredSum: 150000,
            deductible: 0,
          };
        case 33:
          return {
            nombre: "Asistencia legal",
            insuredSum: "",
            deductible: 0,
          };
        case 34:
          return {
            nombre: "Asistencia vial y en viajes",
            insuredSum: "",
            deductible: 0,
          };
        case 35:
          return {
            nombre: "Lazy fee",
            insuredSum: "",
            deductible: 0,
          };
        default:
          return null;
      }
    };
    $scope.procesarCoberturas = function () {
      var parser = new DOMParser();

      $scope.coberturas = $scope.coberturas.reduce(function (
        resultado,
        cobertura
      ) {
        var cobID = null;
        var sumaAsegurada = null;
        var deducible = null;
        var deduciblePorcentaje = null;
        var deducibleAdicional = null;
        var tipoSuma = null;
        var prima = null;
        var noCobertura = null;
        var nombre = null;

        if ($scope.aseguradora === "qualitas") {
          var xmlDoc = parser.parseFromString(cobertura.data, "text/xml");
          sumaAsegurada = obtenerValorNodo(xmlDoc, "SumaAsegurada");
          tipoSuma = obtenerValorNodo(xmlDoc, "TipoSuma");
          deducible = obtenerValorNodo(xmlDoc, "Deducible");
          prima = obtenerValorNodo(xmlDoc, "Prima");
          var coberturas = xmlDoc.getElementsByTagName("Coberturas");
          var noCobertura =
            coberturas.length > 0
              ? coberturas[0].getAttribute("NoCobertura")
              : null;

          // Crear un nuevo objeto manualmente
          var nuevoObjeto = Object.assign({}, cobertura || {}, {
            cobID: cobID || null,
            sumaAsegurada:
              sumaAsegurada && !isNaN(sumaAsegurada)
                ? Number(sumaAsegurada)
                : null,
            deducible:
              deducible && !isNaN(deducible) ? Number(deducible) : null,
            tipoSuma: tipoSuma && !isNaN(tipoSuma) ? Number(tipoSuma) : null,
            prima: prima && !isNaN(prima) ? Number(prima) : null,
            noCobertura:
              noCobertura && !isNaN(noCobertura) ? Number(noCobertura) : null,
            nombre: nombre,
            deducibleAdicional: deducibleAdicional
              ? Number(deducibleAdicional)
              : null,
            deduciblePorcentaje: deduciblePorcentaje
              ? Number(deduciblePorcentaje)
              : null,
          });

          // Agregar el nuevo objeto al array resultado
          resultado.push(nuevoObjeto);
        } else if ($scope.aseguradora === "chubb") {
          var xmlDoc = parser.parseFromString(cobertura.data, "text/xml");
          cobID = obtenerValorNodo(xmlDoc, "COBID");
          sumaAsegurada = obtenerValorNodo(xmlDoc, "SUMAASEG");
          deducibleAdicional = obtenerValorNodo(xmlDoc, "DADIC");
          deduciblePorcentaje = obtenerValorNodo(xmlDoc, "DPCT");

          // Crear un nuevo objeto manualmente
          var nuevoObjeto = Object.assign({}, cobertura || {}, {
            cobID: cobID || null,
            sumaAsegurada: sumaAsegurada ? Number(sumaAsegurada) : null,
            deducibleAdicional: deducibleAdicional
              ? Number(deducibleAdicional)
              : null,
            deduciblePorcentaje: deduciblePorcentaje
              ? Number(deduciblePorcentaje)
              : null,
            tipoSuma: tipoSuma ? Number(tipoSuma) : null,
            deducible: deducible ? Number(deducible) : null,
            prima: prima ? Number(prima) : null,
            noCobertura: noCobertura ? Number(noCobertura) : null,
            nombre: nombre,
          });

          resultado.push(nuevoObjeto);
          // resultado.push({
          //     ...cobertura,
          //     cobID: cobID,
          //     sumaAsegurada: sumaAsegurada ? Number(sumaAsegurada) : null,
          //     deducibleAdicional: deducibleAdicional ? Number(deducibleAdicional) : null,
          //     deduciblePorcentaje: deduciblePorcentaje ? Number(deduciblePorcentaje) : null
          // });
        } else if ($scope.aseguradora === "ana") {
          var xmlDoc = parser.parseFromString(cobertura.data, "text/xml");
          var coberturaNode = xmlDoc.getElementsByTagName("cobertura")[0];
          if (coberturaNode) {
            cobID = coberturaNode.getAttribute("id");
            sumaAsegurada = coberturaNode.getAttribute("sa");
            deducible = coberturaNode.getAttribute("ded");
            nombre = coberturaNode.getAttribute("desc");
          }
          // Crear un nuevo objeto manualmente
          var nuevoObjeto = Object.assign({}, cobertura || {}, {
            cobID: cobID || null,
            sumaAsegurada: sumaAsegurada ? Number(sumaAsegurada) : null,
            deducible: deducible ? Number(deducible) : null,
            nombre: nombre,
            deducibleAdicional: deducibleAdicional
              ? Number(deducibleAdicional)
              : null,
            deduciblePorcentaje: deduciblePorcentaje
              ? Number(deduciblePorcentaje)
              : null,
            tipoSuma: tipoSuma ? Number(tipoSuma) : null,
            prima: prima ? Number(prima) : null,
            noCobertura: noCobertura ? Number(noCobertura) : null,
          });

          resultado.push(nuevoObjeto);
          // resultado.push({
          //     ...cobertura,
          //     cobID: cobID,
          //     sumaAsegurada: sumaAsegurada ? Number(sumaAsegurada) : null,
          //     deducible: deducible ? Number(deducible) : null,
          //     nombre: nombre
          // });
        } else if ($scope.aseguradora === "gnp") {
          var xmlDoc = parser.parseFromString(cobertura.data, "text/xml");
          var coberturaNodes = xmlDoc.getElementsByTagName("COBERTURA");
          var coberturas = xmlDoc.getElementsByTagName("Coberturas");
          var noCobertura =
            coberturas.length > 0
              ? coberturas[0].getAttribute("NoCobertura")
              : null;

          // Crear un nuevo objeto manualmente
          var nuevoObjeto = Object.assign({}, cobertura || {}, {
            cobID: cobID || null,
            sumaAsegurada:
              sumaAsegurada && !isNaN(sumaAsegurada)
                ? Number(sumaAsegurada)
                : null,
            deducible:
              deducible && !isNaN(deducible) ? Number(deducible) : null,
            tipoSuma: tipoSuma && !isNaN(tipoSuma) ? Number(tipoSuma) : null,
            prima: prima && !isNaN(prima) ? Number(prima) : null,
            noCobertura:
              noCobertura && !isNaN(noCobertura) ? Number(noCobertura) : null,
          });

          // Agregar el nuevo objeto al array resultado
          resultado.push(nuevoObjeto);
        } else if ($scope.aseguradora === "hdi") {
          var dataJSON = JSON.parse(cobertura.data);

          dataJSON.Cobertura.forEach(function (cob) {
            var nuevoObjeto = Object.assign({}, cobertura || {}, {
              cobID: cob.Clave || null,
              sumaAsegurada: Number(cob.SumaAsegurada || null),
              deducible: Number(cob.Deducible || null),
              prima: Number(cob.PrimaNeta || null),
              nombre: cob.Descripcion,
              paquete: cobertura["paquete"],
              id: cobertura["id"],
              tipoCobertura: cobertura["nombre"],
              regla: cob.Regla,
              proveedorAsistencia: cob.ProveedorAsistencia,
              primaNeta: cob.PrimaNeta,
              calculada: cob.Calculada,
            });

            resultado.push(nuevoObjeto);
            // resultado.push({
            //     ...cobertura,
            //     cobID: cob.Clave,
            //     sumaAsegurada: Number(cob.SumaAsegurada || null),
            //     deducible: Number(cob.Deducible || null),
            //     prima: Number(cob.PrimaNeta || null),
            //     nombre: cob.Descripcion,
            //     paquete: cobertura['paquete'],
            //     id: cobertura['id'],
            //     tipoCobertura: cobertura['nombre'],
            //     regla: cob.Regla,
            //     proveedorAsistencia: cob.ProveedorAsistencia,
            //     primaNeta: cob.PrimaNeta,
            //     calculada: cob.Calculada
            // });
          });
        } else if ($scope.aseguradora === "ps") {
          var xmlDoc = parser.parseFromString(cobertura.data, "text/xml");
          var coberturaNodes = xmlDoc.getElementsByTagName("coberturas");

          Array.from(coberturaNodes).forEach(function (node) {
            resultado.push({
              cobID:
                node.getElementsByTagName("id").length > 0
                  ? node.getElementsByTagName("id")[0].textContent
                  : "",
              sumaAsegurada:
                node.getElementsByTagName("suma_asegurada").length > 0
                  ? Number(
                      node.getElementsByTagName("suma_asegurada")[0].textContent
                    )
                  : 0,
              deducible:
                node.getElementsByTagName("deducible").length > 0
                  ? Number(
                      node.getElementsByTagName("deducible")[0].textContent
                    )
                  : 0,
            });
          });
        }

        return resultado;
      },
      []);
    };

    $scope.getCoberturas = function (owner) {
      $http({
        method: "GET",
        url: $scope.urlApi + "cotizar/coberturas/" + $scope.aseguradora,
        params: {
          owner: $scope.owner,
        },
      }).then(
        function (response) {
          if (response.data.length > 0) {
            $scope.id = response.data[0].id;
            $scope.nombre = response.data[0].nombre;
            // $scope.owner = response.data[0].owner;

            if ($scope.aseguradora === "tumomento") {
              $scope.paquetesUnicos = [];
              $scope.coberturas = response.data;

              angular.forEach($scope.coberturas, function (cobertura) {
                $scope.paquetesUnicos.push(cobertura.paquete);
              });
              $scope.paquete = "Amplia";
              if (typeof response.data[0].data === "string") {
                var dataString = response.data[0].data.replace(
                  /"\s*"/g,
                  '", "'
                );
                $scope.coberturas = JSON.parse(dataString).map(Number);
              } else if (Array.isArray(response.data[0].data)) {
                $scope.coberturas = response.data[0].data.map(Number);
              } else {
                $scope.coberturas = [];
              }

              var condiciones = [
                { key: "gastos_medicos_ocupantes", ids: [1, 2, 3, 4] },
                { key: "responsabilidad_civil_personas", ids: [5, 6, 7] },
                { key: "robo_total", ids: [23, 24, 25, 26] },
                { key: "robo_parcial", ids: [27, 28, 29] },
                { key: "asistencia_legal", ids: [33] },
                { key: "asistencia_vial", ids: [34] },
                { key: "lazy_fee", ids: [35] },
                { key: "responsabilidad_civil_muerte", ids: [8, 9, 10] },
                { key: "conductor", ids: [30, 31, 32] },
                { key: "responsabilidad_civil_bienes", ids: [11, 12, 13] },
              ];

              angular.forEach(condiciones, function (condicion) {
                if (
                  $scope.coberturas.some(function (id) {
                    return condicion.ids.includes(id);
                  })
                ) {
                  $scope.selectedCoberturas[condicion.key] = true;
                  $scope.coberturas[condicion.key] = condicion.key;
                  $scope.selectedCoberturas[condicion.key + "_id"] =
                    $scope.coberturas.find(function (id) {
                      return condicion.ids.includes(id);
                    });
                }
              });

              var danosMaterialesId = $scope.coberturas.find(function (id) {
                return [17, 18, 19, 20, 21, 22].includes(id);
              });
              if (danosMaterialesId) {
                var cobertura = $scope.obtenerCoberturaPorId(danosMaterialesId);
                $scope.selectedCoberturas["danos_materiales"] = true;
                $scope.selectedCoberturas["danos_materiales_deductible"] =
                  cobertura.deductible.toString();
                $scope.selectedCoberturas["danos_materiales_opcion"] =
                  cobertura.opcion_deducible_perdida_total.toString();
                $scope.selectedCoberturas["danos_materiales_id"] =
                  danosMaterialesId;
              }
            }

            var aseguradorasEspecificas = ["qualitas", "chubb", "ana"];
            if (aseguradorasEspecificas.includes($scope.aseguradora)) {
              $scope.coberturas = response.data;
              $scope.procesarCoberturas();

              var paquetesUnicos = {};
              $scope.coberturasPorPaquete = {};

              angular.forEach($scope.coberturas, function (cobertura) {
                var paquete = cobertura.paquete || "Paquete desconocido";
                var cobID = cobertura.cobID || cobertura.noCobertura;

                if (!paquetesUnicos[paquete]) {
                  paquetesUnicos[paquete] = true; // Usamos un objeto como reemplazo de Set.
                }

                if (!$scope.coberturasPorPaquete[paquete]) {
                  $scope.coberturasPorPaquete[paquete] = [];
                }
                $scope.coberturasPorPaquete[paquete].push(cobertura);

                $scope.selectedCoberturas[cobID] = true;
                $scope.selectedCoberturas[cobID + "_id"] = cobertura.id;
                $scope.selectedCoberturas[cobID + "_nombre"] = cobertura.nombre;
                $scope.selectedCoberturas[cobID + "_sumaAsegurada"] =
                  cobertura.sumaAsegurada;

                var deducible = cobertura.deduciblePorcentaje
                  ? cobertura.deduciblePorcentaje * 100
                  : cobertura.deducible || null;
                $scope.selectedCoberturas[cobID + "_deducible"] = deducible;
              });
              $scope.paquetesUnicos = Object.keys(paquetesUnicos);
              $scope.selectedCoberturas["coberturasPorPaquete"] =
                paquetesUnicos;
            }

            if ($scope.aseguradora === "gnp" || $scope.aseguradora === "ps") {
              $scope.paquetesUnicos = [];
              $scope.coberturas = response.data;
              angular.forEach($scope.coberturas, function (cobertura) {
                $scope.paquetesUnicos.push(cobertura.paquete);
              });
            }
          }
        },
        function (error) {
          $scope.coberturas = [];
        }
      );
    };

    // Función para obtener valores de un nodo XML
    function obtenerValorNodo(xmlDoc, tagName) {
      var node = xmlDoc.getElementsByTagName(tagName)[0];
      return node ? node.textContent : null;
    }
    $scope.parseXMLToCoberturas = function (xmlString) {
      var parser = new DOMParser();

      if ($scope.aseguradora === "gnp") {
        var xmlDoc = parser.parseFromString(xmlString, "application/xml");
        var coberturas = xmlDoc.getElementsByTagName("COBERTURA");
        var coberturaArray = [];

        angular.forEach(coberturas, function (cobertura) {
          var id = cobertura.getElementsByTagName("CVE_COBERTURA")[0]
            ? cobertura.getElementsByTagName("CVE_COBERTURA")[0].textContent
            : "";
          var nombre = cobertura.getElementsByTagName("NOMBRE")[0]
            ? cobertura.getElementsByTagName("NOMBRE")[0].textContent
            : "";
          var deducible = cobertura.getElementsByTagName("DEDUCIBLE")[0]
            ? cobertura.getElementsByTagName("DEDUCIBLE")[0].textContent
            : "";
          var sumaAsegurada = cobertura.getElementsByTagName(
            "SUMA_ASEGURADA"
          )[0]
            ? cobertura.getElementsByTagName("SUMA_ASEGURADA")[0].textContent
            : "";

          coberturaArray.push({
            id: id,
            nombre: nombre,
            deducible: parseInt(deducible) || 0,
            sumaAsegurada: parseInt(sumaAsegurada) || 0,
          });

          $scope.sumaAsegurada[id] = parseInt(sumaAsegurada) || 0;
          $scope.deducibleGNP[id] = parseInt(deducible) || 0;
        });

        return coberturaArray;
      }

      if ($scope.aseguradora === "ps") {
        var wrappedXMLString = "<root>" + xmlString + "</root>";
        var xmlDoc = parser.parseFromString(
          wrappedXMLString,
          "application/xml"
        );
        var coberturas = xmlDoc.getElementsByTagName("coberturas");
        var coberturaArray = [];

        if (coberturas.length === 0) {
          console.error(
            "No se encontraron coberturas en el XML para Primero Seguros"
          );
        }

        angular.forEach(coberturas, function (cobertura) {
          var id = cobertura.getElementsByTagName("id")[0]
            ? cobertura.getElementsByTagName("id")[0].textContent.trim()
            : "";
          var sumaAsegurada = cobertura.getElementsByTagName(
            "suma_asegurada"
          )[0]
            ? cobertura
                .getElementsByTagName("suma_asegurada")[0]
                .textContent.trim()
            : "0";
          var deducible = cobertura.getElementsByTagName("deducible")[0]
            ? cobertura.getElementsByTagName("deducible")[0].textContent.trim()
            : "0";

          coberturaArray.push({
            id: id,
            sumaAsegurada: parseInt(sumaAsegurada) || 0,
            deducible: parseInt(deducible) || 0,
          });

          $scope.sumaAsegurada[id] = parseInt(sumaAsegurada) || 0;
          $scope.deducibleGNP[id] = parseInt(deducible) || 0;
        });

        return coberturaArray;
      }

      return [];
    };

    $scope.changePaquete = function (paquete) {
      $scope.paquete = paquete;
      if ($scope.aseguradora === "chubb") {
        $scope.selectedCoberturas = {};
        $scope.coberturas = $scope.coberturasPorPaquete[$scope.paquete];
        if ($scope.coberturas) {
          $scope.coberturas.forEach(function (cobertura) {
            var cobID = cobertura.cobID;
            $scope.selectedCoberturas[cobID] = true;
            $scope.selectedCoberturas[cobID + "_id"] = cobertura.id;
            $scope.selectedCoberturas[cobID + "_nombre"] = cobertura.nombre;
            $scope.selectedCoberturas[cobID + "_sumaAsegurada"] =
              cobertura.sumaAsegurada;
            var deducible =
              (cobertura.deduciblePorcentaje || cobertura.deducibleAdicional) *
              100;
            $scope.selectedCoberturas[cobID + "_deducible"] = deducible;
          });
        } else {
          $scope.selectedCoberturas = {};
        }
      }

      if ($scope.aseguradora === "gnp") {
        var paqueteSeleccionado = $scope.paquete;
        var paqueteData = $scope.coberturas.find(function (cobertura) {
          return cobertura.paquete === paqueteSeleccionado;
        });
        if (paqueteData && paqueteData.data) {
          $scope.selectedCoberturas = $scope.parseXMLToCoberturas(
            paqueteData.data
          );
          $scope.id = paqueteData.id;
        } else {
          $scope.selectedCoberturas = [];
        }
      }

      if ($scope.aseguradora === "ps") {
        $scope.selectedCoberturas = [];
        var paqueteSeleccionado = $scope.paquete;
        var paqueteData = $scope.coberturas.find(function (cobertura) {
          return cobertura.paquete === paqueteSeleccionado;
        });
        if (paqueteData && paqueteData.data) {
          var data = "<coberturas>" + paqueteData.data;
          $scope.coberturasPS = $scope.parseXMLToCoberturas(data);
          $scope.id = paqueteData.id;
          if ($scope.coberturasPS) {
            $scope.coberturasPS.forEach(function (cobertura) {
              var cobID = cobertura.id;
              $scope.selectedCoberturas[cobID] = cobID;
              $scope.selectedCoberturas[cobID + "_id"] = cobertura.id;
              $scope.selectedCoberturas[cobID + "_nombre"] = cobertura.nombre;
              $scope.selectedCoberturas[cobID + "_sumaAsegurada"] =
                cobertura.sumaAsegurada;
              $scope.selectedCoberturas[cobID + "_deducible"] =
                cobertura.deducible;
            });
          } else {
            $scope.selectedCoberturas = {};
          }
        } else {
          $scope.selectedCoberturas = [];
        }
      }

      if ($scope.aseguradora === "tumomento") {
        $scope.selectedCoberturas = {};
        var paqueteFiltrado = $scope.coberturas.filter(function (cobertura) {
          return cobertura.paquete === $scope.paquete;
        });

        // $scope.id = paqueteFiltrado[0].id;
        var dataString = paqueteFiltrado[0]["data"].replace(/"\s*"/g, '", "');

        var coberturas = JSON.parse(dataString).map(function (numStr) {
          return Number(numStr);
        });

        if (
          coberturas.some(function (id) {
            return [1, 2, 3, 4].includes(id);
          })
        ) {
          $scope.selectedCoberturas["gastos_medicos_ocupantes"] = true;
          $scope.selectedCoberturas["gastos_medicos_ocupantes_id"] =
            coberturas.find(function (id) {
              return [1, 2, 3, 4].includes(id);
            });
        }
      }

      if ($scope.aseguradora === "ana") {
        $scope.selectedCoberturas = {};
        $scope.coberturas = $scope.coberturasPorPaquete[$scope.paquete];
        if ($scope.coberturas) {
          $scope.coberturas.forEach(function (cobertura) {
            var cobIDStr = cobertura.cobID;
            var cobID = parseInt(cobIDStr, 10); // El segundo parámetro (10) indica que el número es en base decimal

            $scope.selectedCoberturas[cobID] = true;
            $scope.selectedCoberturas[cobID + "_id"] = cobertura.id;
            $scope.selectedCoberturas[cobID + "_nombre"] = cobertura.nombre;
            $scope.selectedCoberturas[cobID + "_sumaAsegurada"] =
              cobertura.sumaAsegurada;
            $scope.selectedCoberturas[cobID + "_deducible"] =
              cobertura.deducible;
          });
        } else {
          $scope.selectedCoberturas = {};
        }
      }

      if ($scope.aseguradora === "qualitas") {
        $scope.selectedCoberturas = {};

        $scope.coberturas = $scope.coberturasPorPaquete[$scope.paquete];

        if ($scope.coberturas) {
          $scope.coberturas.forEach(function (cobertura) {
            var cobID = cobertura.noCobertura;
            $scope.selectedCoberturas[cobID] = true;
            $scope.selectedCoberturas[cobID + "_id"] = cobertura.id;
            $scope.selectedCoberturas[cobID + "_nombre"] = cobertura.nombre;
            $scope.selectedCoberturas[cobID + "_sumaAsegurada"] =
              cobertura.sumaAsegurada;
            $scope.selectedCoberturas[cobID + "_deducible"] =
              cobertura.deducible;
          });
        } else {
          $scope.selectedCoberturas = {};
        }
      }
    };
    $scope.guardarSeleccion = function (selectedEmpresa) {
      $scope.selectedEmpresa = selectedEmpresa;

      if ($scope.selectedEmpresa) {
        // Encontrar la empresa seleccionada
        var empresaSeleccionada = $scope.empresas.find(function (empresa) {
          return empresa.id === Number($scope.selectedEmpresa); // Conversión explícita
        });

        if (empresaSeleccionada) {
          var aseguradorasAEnviar = [];

          // Recorrer las aseguradoras seleccionadas
          angular.forEach(
            $scope.aseguradorasSeleccionadas,
            function (seleccionada, id) {
              if (seleccionada) {
                aseguradorasAEnviar.push(Number(id));
              }
            }
          );

          // Preparar el payload
          var payload = {
            aseguradoras: aseguradorasAEnviar,
          };

          $http
            .patch(
              $scope.urlApi +
                "/core/empresa-saam/" +
                empresaSeleccionada.id +
                "/",
              payload
            )
            .then(function (response) {
              SweetAlert.swal("Listo", "Cambios guardados", "success");
            })
            .catch(function (error) {
              // console.error('Error al actualizar aseguradoras:', error);
              SweetAlert.swal("Ocurrio un error", error, "error");
            });
        }
      }
    };
    $scope.onDeducibleChange = function (value, key) {
      var nuevoDeducible = Number(value);

      $scope.selectedCoberturas[key + "_deducible"] = nuevoDeducible;

      if ($scope.aseguradora === "qualitas") {
        var cobertura = null;
        for (var i = 0; i < $scope.coberturas.length; i++) {
          if ($scope.coberturas[i].noCobertura === parseInt(key)) {
            cobertura = $scope.coberturas[i];
            break;
          }
        }
        if (cobertura) {
          cobertura.deducible = nuevoDeducible;
          cobertura.data = $scope.generarXML(cobertura);
        }
      }

      if ($scope.aseguradora === "ana" || $scope.aseguradora === "hdi") {
        var cobertura = null;
        for (var i = 0; i < $scope.coberturas.length; i++) {
          if ($scope.coberturas[i].cobID === parseInt(key)) {
            cobertura = $scope.coberturas[i];
            break;
          }
        }
        if (cobertura) {
          cobertura.deducible = nuevoDeducible;
          cobertura.data = $scope.generarXML(cobertura);
        }
      }

      if ($scope.aseguradora === "ana") {
        var cobertura = null;
        for (var i = 0; i < $scope.coberturas.length; i++) {
          if ($scope.coberturas[i].noCobertura === parseInt(key)) {
            cobertura = $scope.coberturas[i];
            break;
          }
        }
        if (cobertura) {
          cobertura.deducible = nuevoDeducible;
          cobertura.data = $scope.generarXML(cobertura);
        }
      }

      if ($scope.aseguradora === "chubb") {
        var cobertura = null;
        for (var i = 0; i < $scope.coberturas.length; i++) {
          if ($scope.coberturas[i].noCobertura === parseInt(key)) {
            cobertura = $scope.coberturas[i];
            break;
          }
        }
        if (cobertura) {
          cobertura.deducible = nuevoDeducible;
          cobertura.data = $scope.generarXML(cobertura);
        }
      }

      if ($scope.aseguradora === "gnp") {
        var cobertura = null;
        for (var i = 0; i < $scope.coberturasFiltradas.length; i++) {
          if ($scope.coberturasFiltradas[i].id === key) {
            cobertura = $scope.coberturasFiltradas[i];
            break;
          }
        }
        if (cobertura) {
          cobertura.deducible = nuevoDeducible;
          cobertura.data = $scope.generarXML(cobertura);
        }
      }

      if ($scope.aseguradora === "ps") {
        var cobertura = null;
        for (var i = 0; i < $scope.coberturasPS.length; i++) {
          if ($scope.coberturasPS[i].id === key) {
            cobertura = $scope.coberturasPS[i];
            break;
          }
        }
        if (cobertura) {
          cobertura.deducible = nuevoDeducible;
          cobertura.data = $scope.generarXML(cobertura);
        }
      }
    };

    function actualizarDescuentos(nuevoDescuento) {
      var index = $scope.descuentos.findIndex(function (d) {
        return d.id === nuevoDescuento.id;
      });

      if (index !== -1) {
        // Si el descuento ya existe, actualízalo
        $scope.descuentos[index] = nuevoDescuento;
      } else {
        // Si no existe, agrégalo al array
        $scope.descuentos.push(nuevoDescuento);
      }
    }
    function safeNumber(val) {
      var n = Number(val);
      return isFinite(n) ? n : null;
    }

    $scope.guardarCobertura = function () {
      var url = $scope.urlApi + "cotizar/coberturas/" + $scope.aseguradora;
      if ($scope.aseguradora === "tumomento" && $scope.coberturas[0]) {
        var coberturasSeleccionadas = Object.keys($scope.selectedCoberturas)
          .filter(function (nombre) {
            return $scope.selectedCoberturas[nombre];
          })
          .map(function (nombre) {
            return $scope.selectedCoberturas[nombre + "_id"]
              ? $scope.selectedCoberturas[nombre + "_id"].toString()
              : undefined;
          })
          .filter(function (id) {
            return id !== undefined;
          });

        var dataStr = JSON.stringify(coberturasSeleccionadas);
        var coberturasObj = {
          data: dataStr,
          paquete: $scope.paquete,
          nombre: $scope.nombre,
          id: $scope.id,
          owner: $scope.owner,
        };

        $http
          .patch(url, coberturasObj)
          .success(function (response) {
            SweetAlert.swal(
              "Éxito",
              "Cobertura actualizada exitosamente.",
              "success"
            );
          })
          .error(function (response) {
            console.error("Error al actualizar la cobertura:", response);
            SweetAlert.swal(
              "Error",
              "No se pudo actualizar la cobertura.",
              "error"
            );
          });
      } else if ($scope.aseguradora === "tumomento") {
        var coberturasSeleccionadas = Object.keys($scope.selectedCoberturas)
          .filter(function (nombre) {
            return $scope.selectedCoberturas[nombre];
          })
          .map(function (nombre) {
            return $scope.selectedCoberturas[nombre + "_id"]
              ? $scope.selectedCoberturas[nombre + "_id"].toString()
              : undefined;
          })
          .filter(function (id) {
            return id !== undefined;
          });

        var dataStr = JSON.stringify(coberturasSeleccionadas);
        var coberturasObj = {
          data: dataStr,
          paquete: $scope.paquete,
          nombre: $scope.nombre,
          id: $scope.id,
          owner: $scope.owner,
        };

        $http
          .patch(url, coberturasObj)
          .success(function (response) {
            SweetAlert.swal(
              "Éxito",
              "Cobertura actualizada exitosamente.",
              "success"
            );
          })
          .error(function (response) {
            console.error("Error al actualizar la cobertura:", response);
            SweetAlert.swal(
              "Error",
              "No se pudo actualizar la cobertura.",
              "error"
            );
          });
      }

      if ($scope.aseguradora === "qualitas") {
        angular.forEach($scope.coberturas, function (cobertura) {
          if ($scope.selectedCoberturas[cobertura.id]) {
            cobertura.deducible =
              Number($scope.selectedCoberturas[cobertura.id + "_deducible"]) ||
              0;
            cobertura.sumaAsegurada =
              Number(
                $scope.selectedCoberturas[cobertura.id + "_sumaAsegurada"]
              ) || 0;
            cobertura.deduciblePorcentaje = "";
            cobertura.data =
              '<Coberturas NoCobertura="' +
              cobertura.id +
              '">' +
              "<SumaAsegurada>" +
              cobertura.sumaAsegurada +
              "</SumaAsegurada>" +
              "<TipoSuma>" +
              cobertura.tipoSuma +
              "</TipoSuma>" +
              "<Deducible>" +
              cobertura.deducible +
              "</Deducible>" +
              "<Prima>" +
              cobertura.prima +
              "</Prima>" +
              "  </Coberturas>";
          }
          if (cobertura.id) {
            //         // Si tiene ID, es una actualización (PATCH)

            $http
              .patch(url, cobertura)
              .success(function (response) {
                console.log("Cobertura actualizada exitosamente:", response);

                // SweetAlert.swal('Éxito', 'Cobertura actualizada exitosamente.', 'success');
              })
              .error(function (response) {
                console.error("Error al actualizar la cobertura:", response);
                // SweetAlert.swal('Error', 'No se pudo actualizar la cobertura.', 'error');
              });
          } else {
            //         // Si no tiene ID, es una creación (POST)
            $http
              .post(url, cobertura)
              .success(function (response) {
                console.log("Cobertura creada exitosamente:", response);
                actualizarDescuentos(response); // Función para actualizar el array de descuentos
                SweetAlert.swal(
                  "Éxito",
                  "Cobertura creada exitosamente.",
                  "success"
                );
              })
              .error(function (response) {
                console.error("Error al crear la cobertura:", response);
                SweetAlert.swal(
                  "Error",
                  "No se pudo crear la cobertura.",
                  "error"
                );
              });
          }
        });
      }

      if ($scope.aseguradora === "chubb" || $scope.aseguradora === "ana") {
        angular.forEach($scope.coberturas, function (cobertura) {
          cobertura.cobID = Number(cobertura.cobID);

          if ($scope.selectedCoberturas[cobertura.cobID]) {
            cobertura.deducible =
              $scope.selectedCoberturas[cobertura.cobID + "_deducible"];
            cobertura.deduciblePorcentaje =
              $scope.selectedCoberturas[cobertura.cobID + "_deducible"] / 100;
            cobertura.sumaAsegurada =
              $scope.selectedCoberturas[cobertura.cobID + "_sumaAsegurada"];
            var deducibleAdicional = safeNumber(cobertura.deducibleAdicional);
            var deduciblePorcentaje = safeNumber(cobertura.deduciblePorcentaje);
            if ($scope.aseguradora === "chubb") {
              cobertura.data =
                "   <COB>\n" +
                "      <COBID>" +
                cobertura.cobID +
                "</COBID>\n" +
                "      <SUMAASEG>" +
                cobertura.sumaAsegurada +
                "</SUMAASEG>\n" +
                "      <DADIC>" +
                (deducibleAdicional !== "" ? deducibleAdicional : "") +
                "</DADIC>\n" +
                "      <DPCT>" +
                (deduciblePorcentaje !== "" ? deduciblePorcentaje : "") +
                "</DPCT>\n" +
                "   </COB>";
            } else if ($scope.aseguradora === "ana") {
              if (cobertura.cobID == "10") {
                cobertura.data =
                  '<cobertura id="' +
                  cobertura.cobID +
                  '" ' +
                  'desc="" ' +
                  'sa="' +
                  (cobertura.sumaAsegurada || "") +
                  '" ' +
                  'tipo="B" ' +
                  'ded="' +
                  (cobertura.deducible || "") +
                  '" ' +
                  'pma="' +
                  (cobertura.pma || "") +
                  '"/>';
              } else {
                cobertura.data =
                  "<cobertura " +
                  'id="' +
                  cobertura.cobID +
                  '" ' +
                  'desc="" ' +
                  'sa="' +
                  (cobertura.sumaAsegurada || 0) +
                  '" ' +
                  'tipo="' +
                  (cobertura.tipoSuma || "") +
                  '" ' +
                  'ded="' +
                  (cobertura.deducible || "") +
                  '" ' +
                  'pma="' +
                  (cobertura.prima || "") +
                  '" ' +
                  "/>";
              }
            }
          }

          //  necesitamos sacar los nuevos valores

          if (cobertura.id) {
            // cobertura.sumaAsegurada =
            // Si tiene ID, es una actualización (PATCH)

            $http
              .patch(url, cobertura)
              .success(function (response) {
                console.log("Cobertura actualizada exitosamente:", response);

                SweetAlert.swal(
                  "Éxito",
                  "Cobertura actualizada exitosamente.",
                  "success"
                );
              })
              .error(function (response) {
                console.error("Error al actualizar la cobertura:", response);
                SweetAlert.swal(
                  "Error",
                  "No se pudo actualizar la cobertura.",
                  "error"
                );
              });
          } else {
            // Si no tiene ID, es una creación (POST)
            $http
              .post(url, cobertura)
              .success(function (response) {
                console.log("Cobertura creada exitosamente:", response);
                // actualizarDescuentos(response); // Función para actualizar el array de descuentos
                // SweetAlert.swal('Éxito', 'Cobertura creada exitosamente.', 'success');
              })
              .error(function (response) {
                console.error("Error al crear la cobertura:", response);
                // SweetAlert.swal('Error', 'No se pudo crear la cobertura.', 'error');
              });
          }
        });
      }

      if ($scope.aseguradora === "gnp") {
        var coberturasXML = "<COBERTURAS> \n";

        angular.forEach($scope.selectedCoberturas, function (cobertura) {
          var xmlCobertura =
            "<COBERTURA>" +
            "<CVE_COBERTURA>" +
            cobertura.id +
            "</CVE_COBERTURA>" +
            "<DEDUCIBLE>" +
            (cobertura.deducible || "") +
            "</DEDUCIBLE>" +
            "<NOMBRE>" +
            (cobertura.nombre || "").toUpperCase() +
            "</NOMBRE>" +
            "<SUMA_ASEGURADA>" +
            (cobertura.sumaAsegurada || "") +
            "</SUMA_ASEGURADA>" +
            "</COBERTURA>";
          coberturasXML += xmlCobertura;
        });

        coberturasXML += "\n </COBERTURAS>";
        var cobertura = {
          id: $scope.id,
          data: coberturasXML,
          nombre: $scope.paquete,
          owner: $scope.owner,
          paquete: $scope.paquete,
        };
        $http
          .patch(url, cobertura)
          .success(function (response) {
            console.log("Cobertura actualizada exitosamente:", response);

            SweetAlert.swal(
              "Éxito",
              "Cobertura actualizada exitosamente.",
              "success"
            );
          })
          .error(function (response) {
            console.error("Error al actualizar la cobertura:", response);
            SweetAlert.swal(
              "Error",
              "No se pudo actualizar la cobertura.",
              "error"
            );
          });
      }

      if ($scope.aseguradora === "hdi") {
        var coberturasAgrupadas = {};
        angular.forEach($scope.selectedCoberturas, function (value, key) {
          if (key.includes("_id")) {
            var id = value;
            var clave = $scope.selectedCoberturas[key.replace("_id", "_clave")];
            var regla = $scope.selectedCoberturas[key.replace("_id", "_regla")];
            var descripcion =
              $scope.selectedCoberturas[key.replace("_id", "_descripcion")];
            var sumaAsegurada =
              $scope.selectedCoberturas[key.replace("_id", "_sumaAsegurada")];
            var deducible =
              $scope.selectedCoberturas[key.replace("_id", "_deducible")] || 0;
            $scope.tipoCobertura =
              $scope.selectedCoberturas[key.replace("_id", "_tipoCobertura")];

            if (!coberturasAgrupadas[id]) {
              coberturasAgrupadas[id] = [];
            }

            coberturasAgrupadas[id].push({
              Regla: regla,
              Clave: clave,
              Descripcion: descripcion,
              SumaAsegurada: sumaAsegurada || 0,
              Deducible: deducible,
              ProveedorAsistencia: 0,
              PrimaNeta: 0,
              Calculada: "True",
            });
          }
        });

        var objetosAgrupados = Object.keys(coberturasAgrupadas).map(function (
          id
        ) {
          return {
            data: JSON.stringify(
              {
                Cobertura: coberturasAgrupadas[id],
              },
              null,
              3
            ),
            id: Number(id),
            nombre: $scope.tipoCobertura || "",
            owner: $scope.owner,
            paquete: $scope.paquete,
          };
        });

        angular.forEach(objetosAgrupados, function (cobertura) {
          if (cobertura.id) {
            // cobertura.sumaAsegurada =
            // Si tiene ID, es una actualización (PATCH)

            $http
              .patch(url, cobertura)
              .success(function (response) {
                console.log("Cobertura actualizada exitosamente:", response);

                SweetAlert.swal(
                  "Éxito",
                  "Cobertura actualizada exitosamente.",
                  "success"
                );
              })
              .error(function (response) {
                console.error("Error al actualizar la cobertura:", response);
                SweetAlert.swal(
                  "Error",
                  "No se pudo actualizar la cobertura.",
                  "error"
                );
              });
          } else {
            // Si no tiene ID, es una creación (POST)
            $http
              .post(url, cobertura)
              .success(function (response) {
                console.log("Cobertura creada exitosamente:", response);
                actualizarDescuentos(response); // Función para actualizar el array de descuentos
                SweetAlert.swal(
                  "Éxito",
                  "Cobertura creada exitosamente.",
                  "success"
                );
              })
              .error(function (response) {
                console.error("Error al crear la cobertura:", response);
                SweetAlert.swal(
                  "Error",
                  "No se pudo crear la cobertura.",
                  "error"
                );
              });
          }
        });
      }

      if ($scope.aseguradora === "ps") {
        var xmlString = "";
        for (var key in $scope.selectedCoberturas) {
          if (
            $scope.selectedCoberturas.hasOwnProperty(key) &&
            key.indexOf("_") === -1
          ) {
            var id = key;
            var deducible = $scope.selectedCoberturas[key + "_deducible"] || 0;
            var sumaAsegurada =
              $scope.selectedCoberturas[key + "_sumaAsegurada"] || 0;

            // Generar el nodo de cobertura para PS
            xmlString +=
              "<coberturas>" +
              "<id>" +
              id +
              "</id>" +
              "<suma_asegurada>" +
              sumaAsegurada +
              "</suma_asegurada>" +
              "<deducible>" +
              deducible +
              "</deducible>" +
              "</coberturas>";
          }
        }

        var resultado = xmlString.replace("<coberturas>", "");

        var cobertura = {
          id: $scope.id,
          data: resultado,
          nombre: $scope.paquete,
          owner: $scope.owner,
          paquete: $scope.paquete,
        };
        $http
          .patch(url, cobertura)
          .success(function (response) {
            console.log("Cobertura actualizada exitosamente:", response);

            SweetAlert.swal(
              "Éxito",
              "Cobertura actualizada exitosamente.",
              "success"
            );
          })
          .error(function (response) {
            console.error("Error al actualizar la cobertura:", response);
            SweetAlert.swal(
              "Error",
              "No se pudo actualizar la cobertura.",
              "error"
            );
          });
      }
      // $scope.paquete = '';

      // SweetAlert.swal('Éxito', 'Coberturas procesadas correctamente.', 'success');
    };

    $scope.getAseguradoras();
    $scope.getEmpresas();

    $scope.deleteCredencial = function (credencial, index) {
      SweetAlert.swal(
        {
          title: "¿Deseas eliminar esta credencial?",
          text: "Esta operación no podrá deshacerse",
          type: "warning", // En versiones antiguas, usa 'type' en lugar de 'icon'
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, borrar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .delete(
                $scope.urlApi +
                  "cotizar/credenciales-saam/" +
                  $scope.aseguradora,
                {
                  params: { id: credencial.id },
                }
              )
              .then(
                function success(response) {
                  $scope.credenciales.splice(index, 1);
                  SweetAlert.swal(
                    "Eliminado",
                    "La credencial ha sido eliminado correctamente.",
                    "success"
                  );
                },
                function error(response) {
                  // Manejo de errores si no se puede eliminar
                  console.error("Error al eliminar la credencial:", response);
                  SweetAlert.swal(
                    "Error",
                    "No se pudo eliminar la credencial.",
                    "error"
                  );
                }
              );

            $scope.credenciales.splice(index, 1);
            SweetAlert.swal(
              "Eliminado",
              "La credencial ha sido eliminado correctamente.",
              "success"
            );
          }
        }
      );
    };

    $scope.deleteCobertura = function (cobertura, index) {
      SweetAlert.swal(
        {
          title: "¿Deseas eliminar este descuento?",
          text: "Esta operación no podrá deshacerse",
          type: "warning", // En versiones antiguas, usa 'type' en lugar de 'icon'
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, borrar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .delete(
                $scope.urlApi + "cotizar/descuentos-saam/" + $scope.aseguradora,
                {
                  params: { id: cobertura.id },
                }
              )
              .then(
                function success(response) {
                  $scope.descuentos.splice(index, 1);
                  SweetAlert.swal(
                    "Eliminado",
                    "El descuento ha sido eliminado correctamente.",
                    "success"
                  );
                },
                function error(response) {
                  // Manejo de errores si no se puede eliminar
                  console.error("Error al eliminar el descuento:", response);
                  SweetAlert.swal(
                    "Error",
                    "No se pudo eliminar el descuento.",
                    "error"
                  );
                }
              );

            $scope.descuentos.splice(index, 1);
            SweetAlert.swal(
              "Eliminado",
              "El descuento ha sido eliminado correctamente.",
              "success"
            );
          }
        }
      );
    };

    $scope.modalCredencial = function (credencial) {
      if ($scope.aseguradora && $scope.owner) {
        var data = {
          aseguradora: $scope.aseguradora,
          empresa: $scope.owner,
          credencial: credencial,
        };

        var modalInstance = $uibModal.open({
          animation: true,
          size: "lg",
          templateUrl: "app/multicotizador/modals/credencial_form.html",
          controller: "CredencialController",
          resolve: {
            credencialData: function () {
              return data;
            },
          },
        });

        modalInstance.result.then(
          function (newCredencial) {
            if (newCredencial) {
              var index = $scope.credenciales.findIndex(function (desc) {
                return desc.id === newCredencial.id;
              });

              if (index !== -1) {
                $scope.credenciales[index] = newCredencial;
              } else {
                $scope.credenciales.push(newCredencial);
              }
            }
          },
          function () {
            console.log("Modal cerrado sin cambios.");
          }
        );
      } else {
        SweetAlert.swal(
          "Error",
          "Debes seleccionar una aseguradora y una empresa",
          "error"
        );
      }
    };

    $scope.modalDescuento = function (descuento) {
      if ($scope.aseguradora && $scope.owner) {
        var data = {
          aseguradora: $scope.aseguradora,
          empresa: $scope.owner,
          descuento: descuento,
        };

        var modalInstance = $uibModal.open({
          animation: true,
          size: "lg",
          templateUrl: "app/multicotizador/modals/descuento_form.html",
          controller: "DescuentoController",
          resolve: {
            descuentoData: function () {
              return data;
            },
          },
        });

        // Cuando el modal se cierra, recibir el nuevo descuento
        modalInstance.result.then(
          function (newDescuento) {
            if (newDescuento) {
              // Verificar si el descuento existe en el array y reemplazarlo
              var index = $scope.descuentos.findIndex(function (desc) {
                return desc.id === newDescuento.id; // Compara el ID de los descuentos
              });

              if (index !== -1) {
                // Si el descuento existe, lo actualiza
                $scope.descuentos[index] = newDescuento;
              } else {
                // Si no existe, lo agrega
                $scope.descuentos.push(newDescuento);
              }
            }
          },
          function () {
            console.log("Modal cerrado sin cambios.");
          }
        );
      } else {
        SweetAlert.swal(
          "Error",
          "Debes seleccionar una aseguradora y una empresa",
          "error"
        );
      }
    };

    $scope.changeAseguradoraCredencial = function (aseguradora) {
      $scope.aseguradora = aseguradora;
      $scope.credenciales = [];
      if ($scope.owner && $scope.aseguradora) {
        $scope.getCoberturasCredencial($scope.owner);
        $scope.credencial_seleccionada = {};
      }
    };
    $scope.getCoberturasCredencial = function (owner) {
      $http({
        method: "GET",
        url: $scope.urlApi + "cotizar/credenciales-saam/" + $scope.aseguradora,
        params: {
          owner: owner,
        },
      })
        .then(function (response) {
          $scope.credenciales = response.data;
        })
        .catch(function (error) {
          $scope.credenciales = [];
        });
    };
    $scope.changeEmpresaCredencial = function (seleccion) {
      $scope.credenciales = [];
      // $scope.owner = seleccion;
      if ($scope.aseguradora && $scope.owner) {
        $scope.getCoberturasCredencial($scope.owner);
        $scope.credencial_seleccionada = {};
      }
    };
  }
})();

function DescuentoController(
  $scope,
  $uibModalInstance,
  descuentoData,
  $http,
  SweetAlert,
  $sessionStorage
) {
  $scope.descuentosInfo = descuentoData;
  $scope.urlApi = "https://apigatewaymc.multicotizador.com/";
  // var user       = $sessionStorage.infoUser || {};        // ← con ngStorage ya es objeto
  // var org        = user.org        || {};             // puede venir vacío
  // $scope.owner   = org.name        || null;           // ← será "pruebas", "gpi", etc.
  // $scope.orgId   = org.id          || null;           // por si necesitas el id
  // if($scope.owner == "pruebas" || $scope.owner == "gpi"){
  //   $scope.owner = 'AndreaZamora';
  // }
  // $scope.ownerdesc  = $scope.owner;

  $scope.aseguradora = $scope.descuentosInfo.aseguradora;
  $scope.descuento_seleccionado = [];
  // Paso 1 – obtén el valor de forma segura
  var raw =
    $scope.descuentosInfo &&
    $scope.descuentosInfo.descuento &&
    $scope.descuentosInfo.descuento.descuento;

  // Paso 2 – valida y asigna
  $scope.descuento =
    raw !== undefined && !isNaN(raw)
      ? Number(raw) // convierte a número
      : 0; // valor por defecto

  if ($scope.descuentosInfo.descuento) {
    $scope.descuento_seleccionado = $scope.descuentosInfo.descuento;
  }
  $scope.guardarDescuento = function (descuento) {
    $scope.descuento = descuento;

    // if($scope.owner){
    if ($scope.descuento_seleccionado && $scope.descuento_seleccionado.id) {
      // Actualizar descuento existente
      $scope.descuento_seleccionado.owner = $scope.owner;
      $scope.descuento_seleccionado.aseguradora = $scope.aseguradora;

      var payload = {
        aseguradora: $scope.aseguradora,
        descuento: $scope.descuento,
        owner: $scope.descuentosInfo.empresa,
        id: $scope.descuento_seleccionado.id,
      };

      $http
        .patch(
          $scope.urlApi + "cotizar/descuentos-saam/" + $scope.aseguradora,
          payload
        )
        .then(
          function success(response) {
            $scope.descuentos = response.data;
            $uibModalInstance.close(response.data);
            SweetAlert.swal(
              "Éxito",
              "Cobertura creada exitosamente.",
              "success"
            );
          },
          function error(response) {
            console.error("Error al crear la cobertura:", response);
            SweetAlert.swal("Error", "No se pudo crear la cobertura.", "error");
          }
        );
    } else {
      // Crear nuevo descuento
      $scope.descuento_seleccionado.owner = $scope.owner;
      $scope.descuento_seleccionado.aseguradora = $scope.aseguradora;

      var payload = {
        aseguradora: $scope.aseguradora,
        descuento: $scope.descuento,
        owner: $scope.descuentosInfo.empresa,
      };

      $http
        .post(
          $scope.urlApi + "cotizar/descuentos-saam/" + $scope.aseguradora,
          payload
        )
        .then(
          function success(response) {
            console.log("Respuesta del servidor:", response.data);
            $scope.descuentos = response.data;
            $uibModalInstance.close(response.data);
            SweetAlert.swal(
              "Éxito",
              "Cobertura creada exitosamente.",
              "success"
            );
          },
          function error(response) {
            console.error("Error al crear la cobertura:", response);
            SweetAlert.swal("Error", "No se pudo crear la cobertura.", "error");
          }
        );
    }
    // }else{
    //   SweetAlert.swal('Error', 'No se pudo crear la cobertura, nno hay empresa seleccionada', 'error');
    // }
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss("cancel");
  };
}

function CredencialController(
  $scope,
  $uibModalInstance,
  credencialData,
  $http,
  SweetAlert,
  $sessionStorage
) {
  $scope.credencialesInfo = credencialData;
  // var user       = $sessionStorage.infoUser || {};        // ← con ngStorage ya es objeto
  // var org        = user.org        || {};             // puede venir vacío
  // $scope.owner   = org.name        || null;           // ← será "pruebas", "gpi", etc.
  // $scope.orgId   = org.id          || null;           // por si necesitas el id
  // if($scope.owner == "pruebas" || $scope.owner == "gpi"){
  //   $scope.owner = 'AndreaZamora';
  // }
  // $scope.ownerdesc  = $scope.owner;

  $scope.urlApi = "https://apigatewaymc.multicotizador.com/";
  $scope.owner = $scope.credencialesInfo.empresa || null;
  $scope.aseguradora = $scope.credencialesInfo.aseguradora || null;
  $scope.credencial_seleccionado = [];

  // Verificar si la propiedad credencial existe
  if ($scope.credencialesInfo.credencial) {
    $scope.credencial = $scope.credencialesInfo.credencial.data || null;
    $scope.credencial_seleccionado = $scope.credencialesInfo.credencial || [];
  } else {
    console.warn(
      "No se encontró la propiedad credencial en los datos recibidos"
    );
  }
  $scope.credencial_seleccionado = $scope.credencialesInfo.credencial || {};
  if ($scope.credencial_seleccionado.is_active === "true") {
    $scope.credencial_seleccionado.is_active = true;
  } else {
    $scope.credencial_seleccionado.is_active = false;
  }

  $scope.guardarCredencial = function (credencial) {
    $scope.credencial_seleccionado.owner = $scope.owner;

    // if($scope.credencial_seleccionado.id){

    if ($scope.credencial_seleccionado.is_active === true) {
      $scope.credencial_seleccionado.is_active = "true";
    } else {
      $scope.credencial_seleccionado.is_active = "false";
    }

    if ($scope.credencial_seleccionado && $scope.credencial_seleccionado.id) {
      // Llamada para actualizar credenciales
      var payload = {
        data: $scope.credencial_seleccionado.data,
        is_active: $scope.credencial_seleccionado.is_active,
        owner: $scope.owner,
        env: $scope.credencial_seleccionado.env.toLowerCase(),
        id: $scope.credencial_seleccionado.id,
      };
      $http
        .patch(
          $scope.urlApi + "cotizar/credenciales-saam/" + $scope.aseguradora,
          payload
        )
        .then(
          function success(response) {
            console.log("Respuesta del servidor:", response.data);
            $scope.credenciales = response.data;
            $uibModalInstance.close(response.data);
            SweetAlert.swal(
              "Éxito",
              "Credencial actualizada exitosamente.",
              "success"
            );
          },
          function error(response) {
            console.error("Error al actualizar la cobertura:", response);
            SweetAlert.swal(
              "Error",
              "No se pudo crear la credebcuak.",
              "error"
            );
          }
        );
    } else {
      var payload = {
        data: $scope.credencial_seleccionado.data,
        is_active: $scope.credencial_seleccionado.is_active,
        owner: $scope.owner,
        env: $scope.credencial_seleccionado.env.toLowerCase(),
      };
      // Llamada para crear nuevas credenciales
      $http
        .post(
          $scope.urlApi + "cotizar/credenciales-saam/" + $scope.aseguradora,
          payload
        )
        .then(
          function success(response) {
            console.log("Respuesta del servidor:", response.data);
            $scope.descuentos = response.data;
            $uibModalInstance.close(response.data);
            SweetAlert.swal(
              "Éxito",
              "Cobertura creada exitosamente.",
              "success"
            );
          },
          function error(response) {
            console.error("Error al crear la cobertura:", response);
            SweetAlert.swal("Error", "No se pudo crear la cobertura.", "error");
          }
        );
    }
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss("cancel");
  };
}

(function () {
  "use strict";
  /* jshint devel: true */

  angular
    .module("inspinia")
    .controller("MulticotizadorAdminCtrl", MulticotizadorAdminCtrl);

  MulticotizadorAdminCtrl.$inject = [
    "SweetAlert",
    "$scope",
    "$rootScope",
    "$http",
    "url",
    "$sessionStorage",
    "toaster",
    "datesFactory",
    "$uibModal",
    "$window",
    "dataFactory",
    "$sce",
    "$parse",
    "$localStorage",
    "$location",
  ];

  function MulticotizadorAdminCtrl(
    SweetAlert,
    $scope,
    $rootScope,
    $http,
    url,
    $sessionStorage,
    toaster,
    datesFactory,
    $uibModal,
    $window,
    dataFactory,
    $sce,
    $parse,
    $localStorage,
    $location
  ) {
    $scope.show_quote_selected = "";
    $scope.quotes = [];
    $scope.loader_data = true;
    $scope.pageStart = 1; // Inicio de la página
    $scope.pageEnd = 100; // Fin de la página
    $scope.total = 0; // Total de cotizaciones
    $scope.offset = 0; // Offset inicial
    $scope.status = [];
    $scope.pageStart = 1; // Inicio de la página
    $scope.pageEnd = 100; // Fin de la página
    $scope.total = 0; // Total de cotizaciones
    $scope.offset = 0; // Offset inicial
    $scope.urlApi = "https://apigatewaymc.multicotizador.com/";
    $scope.urlApi_corto = "api.multicotizador.com";
    $scope.urlApiTm = "ms.multicotizador.com";

    $scope.id_cotizacion = "";
    $scope.status = [
      { value: 0, name: "Pendiente" },
      { value: 1, name: "Abierta" },
      { value: 2, name: "Cerrada" },
      { value: 3, name: "Cancelada" },
      { value: 4, name: "Registrada" },
    ];
    $scope.selectedStatus = $scope.status[0];
    // ► End-points/constantes que usa la lógica de descargas
    $scope.URL_CHUBB = "https://avantthya-api.multicotizador.com/"; // base URL de Chubb
    $scope.urlGateway = "https://apigatewaymc.multicotizador.com"; // proxy usado en fetchBlob()

    // ► Variables operativas iniciales
    $scope.policy = ""; // aquí guardarás el número de póliza emitida
    $scope.quoteCreated = {}; // se llenará cuando emitas la póliza
    $scope.selected_quote = {}; // se setea antes de cualquier descarga
    $scope.Urllector = "https://lector-pdf.mbxservicios.com/"; // endpoint del micro-servicio lector
    $scope.policy = ""; // id póliza (se rellena al emitir)
    var orgName =
      $sessionStorage.user &&
      $sessionStorage.infoUser.org &&
      $sessionStorage.infoUser.org.name;
    $scope.org_name = orgName;
    if ($scope.org_name == "gpi") {
      $scope.empresa = "AndreaZamora";
    }
    $scope.origen = $scope.org_name;
    if ($scope.org_name == "gpi") {
      $scope.origen = "miurabox";
    }

    $scope.quoter = function (info) {
      // Contexto global
      $scope.show_quote_selected = info;

      $scope.id_cotizacion = info.id;
      $scope.quoteCreated = info;
      // Limpia el arreglo para evitar duplicados
      $scope.quotes = [];

      var insurers = [
        "ana",
        "chubb",
        "gnp",
        "hdi",
        "ps",
        "qualitas",
        "descr_tumomento",
      ];

      insurers.forEach(function (insurer) {
        var original = info[insurer]; // sub-objeto de la aseguradora
        if (!original || !original.coberturas) {
          return;
        }

        /* 1) Ajuste especial para ANA */
        if (
          insurer === "ana" &&
          info.forma_de_pago !== "C" &&
          angular.isArray(original.recibos)
        ) {
          original.recibos = original.recibos.map(function (r) {
            r.primatotal = r["@primatotal"];
            return r;
          });
        }

        /* 2) Crea UNA COPIA para no tocar el original */
        var quote = angular.copy(original);

        /* 3) Calcula y añade cotizacion_id */
        var rootId = info[insurer + "_id"]; // ej. 'hdi_id'
        quote.cotizacion_id =
          rootId ||
          quote.id_cotizacion ||
          (quote.raw_response && quote.raw_response.id);
        if (original.impresion) {
          $scope.quoteCreated.cotizacion_id = rootId;
        }
        /* 4) Empuja la copia enriquecida */
        $scope.quotes.push(quote);
      });

      /* 5) Actualiza el estatus seleccionado */
      $scope.selectedStatus = $scope.status[info.status];
    };

    $scope.changeStatus = function (estatus) {
      var payload = {
        status: estatus.value,
      };

      console.log("Estatus seleccionado:", estatus); // Usar el valor directamente.

      // Realiza la solicitud PATCH
      $http
        .patch(
          $scope.urlApi +
            "cotizar/cotizaciones-unit/" +
            $scope.id_cotizacion +
            "/",
          payload
        )
        .then(function (response) {
          console.log("Cotización guardada correctamente:", response.data);
          toaster.success("¡Cotización actualizada con éxito!");
        })
        .catch(function (error) {
          console.error("Error al guardar la cotización:", error);
          toaster.error("Error al actualizar la cotización.");
        });
    };
    $scope.getAllQuotes = function () {
      console.log("Realizando la solicitud GET para obtener cotizaciones");

      var url = $scope.urlApi + "cotizar/cotizaciones-saam/";

      $http({
        method: "GET",
        url: url,
        params: {
          origen: $scope.origen,
          limit: 100,
          offset: $scope.offset, // Usamos el offset dinámico
        },
      })
        .then(function success(response) {
          // Actualizar datos de cotizaciones
          $scope.quotes_data = response.data["results"];
          $scope.total = response.data["count"]; // Total de cotizaciones en el backend

          // Calcular el rango actual de cotizaciones
          $scope.pageStart = $scope.offset + 1;
          $scope.pageEnd = Math.min($scope.offset + 100, $scope.total);

          $scope.loader_data = false;
        })
        .catch(function error(e) {
          console.error("Error al obtener cotizaciones:", e);
        });
    };

    // Función para avanzar o retroceder en la paginación
    $scope.changePage = function (direction) {
      // Incrementar o decrementar el offset según la dirección
      $scope.offset = Math.max(0, $scope.offset + direction);
      $scope.getAllQuotes(); // Llamar de nuevo a la función de obtención
    };

    $scope.getAllQuotes();
    $scope.regresar = function () {
      $scope.show_quote_selected = "";
      $scope.quotes = [];
      $scope.id_cotizacion = "";
    };

    $scope.downloadPdfGeneric = function (
      url,
      empresa,
      cotizacion_id,
      linkPath
    ) {
      if (!cotizacion_id) {
        console.error("Error: cotizacion_id no está definido.");
        $scope.loader = false;
        return;
      }
      var params = {
        empresa: empresa,
        cotizacion_id: cotizacion_id,
      };
      if ($scope.selected_quote.aseguradora === "descr_tumomento") {
        $scope.selected_quote.aseguradora = "tumomento";
      }

      if (
        $scope.selected_quote.aseguradora === "hdi" ||
        $scope.selected_quote.aseguradora === "chubb" ||
        $scope.selected_quote.aseguradora === "tumomento"
      ) {
        // $http.get(url + 'imprimir', { params: params, responseType: 'arraybuffer' })
        $http
          .get(url + "imprimir", { params: params, responseType: "blob" })
          .then(function (response) {
            if ($scope.selected_quote.aseguradora == "hdi") {
              var file = new Blob([response.data], { type: "application/pdf" });
              var fileURL = URL.createObjectURL(file);
              window.open(fileURL);
              var downloadLink = document.createElement("a");
              downloadLink.href = fileURL;
              downloadLink.download = $scope.policy + ".pdf";
              downloadLink.click();
            } else if ($scope.selected_quote.aseguradora == "tumomento") {
              var file = new Blob([response.data], { type: "application/pdf" });
              var fileURL = URL.createObjectURL(file);

              var reader = new FileReader();
              reader.onload = function (e) {
                window.open(e.target.result);
              };

              reader.readAsDataURL(file);

              // Crear enlace de descarga
              var downloadLink = document.createElement("a");
              downloadLink.href = fileURL;
              downloadLink.download = $scope.policy + ".pdf";
              downloadLink.click();
            } else {
              var pdfUrl = response.data.PATHPDF;

              // Verifica si la URL está presente
              if (pdfUrl) {
                // Abre el archivo PDF en una nueva pestaña
                window.open(pdfUrl, "_blank");
              } else {
                console.error("No se ha proporcionado la URL del PDF.");
              }
            }
          })
          .then(function (blob) {
            $scope.filePdf = new File([blob], "documento.pdf", {
              type: "application/pdf",
            });
          })

          .catch(function (err) {
            console.error("Error al descargar PDF:", err);
            toastr.error(
              "Ocurrió un error al intentar descargar el PDF",
              "Error"
            );
          })
          .finally(function () {});
      } else if ($scope.selected_quote.aseguradora === "qualitas") {
        $http
          .post(url + "imprimir", params)
          .then(function (response) {
            var links = response.data.pdf;
            var linksArray = Object.values(links);

            // Reemplazo de find con un bucle for
            var link = null;
            for (var i = 0; i < linksArray.length; i++) {
              window.open(linksArray[i], "_blank");
              // if (linksArray[i].indexOf("http://qbcenter.qualitas.com.mx/poliza/p") === 0) {
              //     link = linksArray[i];
              //     break;
              // }
            }

            if (link) {
              // Abrir el enlace en una nueva pestaña
              // window.open(link, "_blank");
            } else {
              // Mostrar mensaje de error si no se encuentra el enlace
              toastr.error("Enlace del PDF no encontrado", "Error");
              console.error(
                "Error: No se encontró un enlace que cumpla con el criterio."
              );
            }
          })
          .catch(function (err) {
            console.error("Error al descargar PDF:", err);
            toastr.error(
              "Ocurrió un error al intentar descargar el PDF",
              "Error"
            );
          });
      } else {
        $http
          .get(url + "imprimir", { params: params })
          .then(function (response) {
            var link = linkPath.split(".").reduce(function (obj, key) {
              return obj && obj[key];
            }, response.data);

            if (link) {
              window.open(link, "_blank");
            } else {
              toastr.error("Enlace del PDF no encontrado", "Error");
              console.error("Error: No se encontró el enlace en la respuesta.");
            }
          })
          .catch(function (err) {
            console.error("Error al descargar PDF:", err);
            toastr.error(
              "Ocurrió un error al intentar descargar el PDF",
              "Error"
            );
          })
          .finally(function () {});
      }
    };
    function base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64); // Decodificar Base64 a una cadena binaria
      var length = binaryString.length;
      var bytes = new Uint8Array(length);

      // Convertir la cadena binaria en un Uint8Array
      for (var i = 0; i < length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer; // Retornar el ArrayBuffer
    }
    $scope.downloadPdfAna = function () {
      var cotizacionId =
        $scope.quoteCreated &&
        $scope.quoteCreated.issue &&
        $scope.quoteCreated.issue.cotizacion_id;

      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId, // Se pasa la variable cotizacionId
        "transacciones.transaccion.poliza.@link"
      );
    };
    $scope.downloadPdfQualitas = function (item) {
      var cotizacionId = item.raw_response.id;

      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId,
        "IM.PATHPDF"
      );
    };

    $scope.downloadPdfChubb = function () {
      var cotizacionId = $scope.selected_quote.raw_response.id;
      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId,
        "IM.PATHPDF"
      );
    };
    $scope.downloadPdfGnp = function () {
      var cotizacionId = $scope.selected_quote.raw_response.id;
      // var cotizacionId =27234;
      // $scope.urlDownload ='https://gnp-api.multicotizador.com/';

      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId,
        "RESULTADO.URL_DOCUMENTO"
      );
    };
    $scope.downloadPdfHdi = function () {
      var cotizacionId =
        $scope.quoteCreated && $scope.quoteCreated.cotizacion_id;
      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId,
        "",
        "blob"
      );
    };
    $scope.downloadPdfMomento = function () {
      var cotizacionId =
        $scope.quoteCreated &&
        $scope.quoteCreated &&
        $scope.quoteCreated.cotizacion_id;

      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId,
        "",
        "blob"
      );
    };
    $scope.downloadPdfPs = function (pdf) {
      $scope.loader = true;
      var linkSource = "data:application/pdf;base64," + pdf;
      var downloadLink = document.createElement("a");
      var fileName = $scope.policy + ".pdf";
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      $scope.loader = false;
    };
    $scope.downloadPdf = function (item) {
      $scope.selected_quote = item;
      var complementoUrl = "";

      switch (item["aseguradora"]) {
        case "ana":
          complementoUrl = "anaseguros";
          break;
        case "gnp":
          complementoUrl = "gnp";
          break;
        case "ps":
          complementoUrl = "ps";
          break;
        case "hdi":
          complementoUrl = "hdi";
          break;
        case "descr_tumomento":
          complementoUrl = "tumomento";
          break;
        case "qualitas":
          complementoUrl = "qualitas";
          break;
        case "chubb":
          complementoUrl = "avantthya";
          break;
        default:
          break;
      }

      var url2_ = {
        MC2: "https://" + complementoUrl + "-" + $scope.urlApi_corto + "/",
      };
      if (item["aseguradora"] == "tumomento") {
        var url2_ = {
          MC2: "https://" + complementoUrl + "-" + $scope.urlApiTm + "/",
        };
      }
      $scope.urlDownload = url2_.MC2;

      switch (item["aseguradora"]) {
        case "ana":
          $scope.downloadPdfAna(item);
          break;

        case "chubb":
          $scope.downloadPdfChubb(item);
          break;

        case "gnp":
          $scope.downloadPdfGnp(item);
          break;

        case "hdi":
          $scope.downloadPdfHdi(item);
          break;

        case "qualitas":
          $scope.downloadPdfQualitas(item);
          break;

        case "ps":
          // For Primero Seguros (PS)
          $scope.downloadPdfPs(item.impresion);
          break;
        case "descr_tumomento":
          // For Primero Seguros (PS)
          $scope.downloadPdfMomento(item.impresion);
          break;
        default:
          console.warn("Aseguradora no reconocida.");
          break;
      }
    };

    // helpers/url-factory.js -----------------------------
    function buildApiUrl(aseguradora, apiBase, apiTm, urlChubb) {
      var dominios = {
        ana: "https://anaseguros-" + apiBase + "/",
        gnp: "https://gnp-" + apiBase + "/",
        hdi: "https://hdi-" + apiBase + "/",
        tumomento: "https://tumomento-" + apiTm + "/",
        ps: "https://ps-" + apiBase + "/",
        qualitas: "https://qualitas-" + apiBase + "/",
      };
      return aseguradora === "chubb" ? urlChubb : dominios[aseguradora];
    }

    // helpers/pdf-link-parser.js -------------------------
    function extractPdfUrl(aseguradora, data) {
      switch (aseguradora) {
        case "chubb":
          return data && data.IM ? data.IM.PATHPDF : undefined;

        case "gnp":
          return data && data.RESULTADO
            ? data.RESULTADO.URL_DOCUMENTO
            : undefined;

        case "ana":
          return data &&
            data.transacciones &&
            data.transacciones.transaccion &&
            data.transacciones.transaccion.poliza
            ? data.transacciones.transaccion.poliza["@link"]
            : undefined;

        default:
          return undefined;
      }
    }

    // helpers/fetch-blob.js ------------------------------
    function fetchBlob(gateway, rawUrl, $http) {
      // 1) Construye la URL sin template-literals
      var proxied =
        gateway + "/cotizar/proxy?url=" + encodeURIComponent(rawUrl);

      // 2) Usa $http para que Angular maneje promesas y digest
      return $http({
        method: "GET",
        url: proxied,
        responseType: "blob", // devuelve Blob listo para File/URL.createObjectURL
      })
        .then(function (response) {
          return response.data; // el Blob
        })
        .catch(function (err) {
          // Normaliza mensaje
          var status = err.status || (err.response && err.response.status) || 0;
          throw new Error("HTTP " + status);
        });
    }

    /* --------------------------------------------------
     *  Función obtenerPoliza — compatible con ES5
     * -------------------------------------------------- */
    $scope.obtenerPoliza = function (accion, aseguradora, cotizacion_id) {
      /* 1) Datos base */
      var params = { empresa: $scope.empresa, cotizacion_id: cotizacion_id };
      var apiUrl = buildApiUrl(
        aseguradora,
        $scope.urlApi_corto, // "api.multicotizador.com"
        $scope.urlApiTm, // "ms.multicotizador.com"
        $scope.URL_CHUBB
      ); // fijo para Chubb

      $scope.loader = true;
      $scope.aseguradora = aseguradora;

      /* Helpers locales -------------------------------- */
      function endLoader() {
        $scope.loader = false;
        $scope.$applyAsync();
      }

      function onError(err) {
        console.error(err);
        toaster.pop(
          "error",
          "Error",
          (err && err.message) || "No se pudo descargar la póliza."
        );
        endLoader();
      }

      /* 2) Aseguradora PS (PDF viene embebido en base64) */
      if (aseguradora === "ps") {
        $scope.registrarPoliza();
        endLoader();
        return;
      }

      /* 3) Aseguradoras con GET que regresan link -------- */
      if (["chubb", "gnp", "ana"].indexOf(aseguradora) !== -1) {
        $http
          .get(apiUrl + "imprimir", { params: params })
          .then(function (response) {
            var pdfUrl = extractPdfUrl(aseguradora, response.data);
            if (!pdfUrl) {
              throw new Error("URL de PDF no encontrada.");
            }
            localStorage.setItem("url_impresion", pdfUrl);

            // fetchBlob ES5 (usa $http) — ya lo adaptaste antes
            return fetchBlob($scope.urlGateway, pdfUrl);
          })
          .then(function (blob) {
            $scope.filePdf = new File([blob], "poliza.pdf", {
              type: "application/pdf",
            });
            $scope.registrarPoliza();
          })
          .catch(onError)
          .finally(endLoader);

        return;
      }

      /* 4) Qualitas (POST + lista de links) -------------- */
      if (aseguradora === "qualitas") {
        $http
          .post(apiUrl + "imprimir", params)
          .then(function (response) {
            var links = response.data.pdf;

            // compatibilidad: si el backend regresa objeto ⇒ a arreglo
            if (!angular.isArray(links)) {
              links = [];
              for (var k in response.data.pdf) {
                links.push(response.data.pdf[k]);
              }
            }

            // busca el link que empiece con la ruta esperada
            var pdfUrl = null;
            for (var i = 0; i < links.length; i++) {
              if (
                links[i].indexOf("http://qbcenter.qualitas.com.mx/poliza/p") ===
                0
              ) {
                pdfUrl = links[i];
                break;
              }
            }
            if (!pdfUrl) {
              throw new Error("URL de PDF no encontrada.");
            }
            localStorage.setItem("url_impresion", pdfUrl);

            return fetchBlob($scope.urlGateway, pdfUrl);
          })
          .then(function (blob) {
            $scope.filePdf = new File([blob], "poliza.pdf", {
              type: "application/pdf",
            });
            $scope.registrarPoliza();
          })
          .catch(onError)
          .finally(endLoader);

        return;
      }

      /* 5) Tumomento / HDI (GET → binario directo) ------- */
      if (["tumomento", "hdi"].indexOf(aseguradora) !== -1) {
        $http
          .get(apiUrl + "imprimir", { params: params, responseType: "blob" })
          .then(function (response) {
            $scope.filePdf = new File([response.data], "poliza.pdf", {
              type: "application/pdf",
            });
            $scope.registrarPoliza();
          })
          .catch(onError)
          .finally(endLoader);

        return;
      }

      /* 6) Cualquier otro caso --------------------------- */
      onError(new Error("Aseguradora '" + aseguradora + "' no soportada."));
    };

    // Helper local para generar requestId únicos
    function generarRequestId() {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      var hex = Array.prototype.map
        .call(bytes, function (b) {
          return ("0" + b.toString(16)).slice(-2);
        })
        .join("");
      return [
        hex.substr(0, 8),
        hex.substr(8, 4),
        hex.substr(12, 4),
        hex.substr(16, 4),
        hex.substr(20),
      ].join("-");
    }

    /* ============================================================
     * 3)  FUNCIÓN registrarPoliza — SIN CAMBIOS EN LA LÓGICA
     * ============================================================ */
    $scope.registrarPoliza = function () {
      console.log("--", $scope.filePdf);

      if (!$scope.filePdf) {
        toaster.pop("error", "Error", "No se pudo obtener el archivo PDF.");
        return;
      }
      if ($scope.filePdf.type !== "application/pdf") {
        toaster.pop("error", "Error", "Solo se permiten archivos PDF.");
        return;
      }
      if ($scope.filePdf.size === 0) {
        console.error("El archivo descargado está vacío.");
        toaster.pop("error", "Error", "El archivo descargado está vacío.");
        return;
      }
      $scope.loader = true;

      var formData = new FormData();
      formData.append("archivo", $scope.filePdf);
      formData.append("insurance", $scope.aseguradora);
      formData.append("org", $scope.org_name || "pruebas");
      formData.append("nombre", $scope.filePdf.name);
      formData.append("requestId", generarRequestId());

      var xhr = new XMLHttpRequest();
      xhr.open("POST", $scope.Urllector + "upload-pdf", true);

      xhr.onload = function () {
        $scope.loader = false;
        if (xhr.status === 200) {
          // Cambiamos estatus a “registrada” (4)
          $scope.guardarCotizacion({ status: "4" }, $scope.id_cotizacion);
          localStorage.setItem("datos_pdf", xhr.response);
          localStorage.setItem("pdf_generado", 1);
          // $location.path('/polizas/crear');
        } else {
          console.error("Error al enviar el archivo:", xhr.statusText);
          toaster.pop("error", "Error", "No se pudo registrar la póliza.");
        }
        $scope.$applyAsync();
      };

      xhr.onerror = function () {
        $scope.loader = false;
        console.error("Error en la solicitud.");
        toaster.pop("error", "Error", "Error en la solicitud.");
        $scope.$applyAsync();
      };

      xhr.send(formData);
    };

    $scope.guardarCotizacion = function (payload, id_cotizacion) {
      console.log("Guardar cotizacion", payload, id_cotizacion);
      if (id_cotizacion) {
        return $http
          .patch(
            $scope.urlGateway +
              "/cotizar/cotizaciones-unit/" +
              id_cotizacion +
              "/",
            payload,
            { headers: $scope.headers }
          )
          .then(function (response) {
            // console.log(response);
            return response.data;
          })
          .catch(function (err) {
            console.error("Error al guardar la cotización:", err);
            throw err;
          });
      }
    };
    $scope.showCoverages = function (data) {
      var modalInstance = $uibModal.open({
        animation: true,
        size: "lg",
        templateUrl: "app/multicotizador/modals/multicotizador_coberturas.html",
        controller: "CoveragesModalController",
        resolve: {
          coveragesData: function () {
            return data;
          },
        },
      });
    };
  }
})();

(function () {
  angular.module("inspinia").controller("PayReceiptsCtrl", PayReceiptsCtrl);

  PayReceiptsCtrl.$inject = [
    "$scope",
    "$filter",
    "$uibModalInstance",
    "toaster",
    "receiptService",
    "DTOptionsBuilder",
    "DTColumnDefBuilder",
    "modalService",
  ];

  function PayReceiptsCtrl(
    $scope,
    $filter,
    $uibModalInstance,
    toaster,
    receiptService,
    DTOptionsBuilder,
    DTColumnDefBuilder,
    modalService
  ) {
    $scope.receipts = [];
    $scope.changeStatusModal = changeStatusModal;

    $scope.dtOyepptions = DTOptionsBuilder.newOptions()
      .withPaginationType("simple_numbers")
      .withDisplayLength(10)
      .withOption("responsive", true)
      .withLanguage({
        sSearch: "Buscador:",
        oPaginate: {
          sNext: "»",
          sPrevious: "«",
        },
      });
    $scope.dtColumnDefs = [
      DTColumnDefBuilder.newColumnDef(0),
      DTColumnDefBuilder.newColumnDef(1),
      DTColumnDefBuilder.newColumnDef(2),
    ];

    function activate() {
      getReceipts();
    }

    function getReceipts() {
      receiptService.getValidReceipts().then(function (data) {
        $scope.receipts = data;
      });
    }

    var myReceiptInfo = {};

    function changeStatusModal(data) {
      $scope.receipt = data;
      myReceiptInfo = data;

      if ($uibModalInstance) {
        $uibModalInstance.close(6);
      } else {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/cobranzas/cobranzas.modal.html",
          controller: "CobranzasModal",
          //windowClass: 'animated fadeIn'
        });
      }
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss("cancel");
    };

    activate();
  }
})();

(function () {
  angular.module("inspinia").controller("modalOverview", modalOverview);

  modalOverview.$inject = [
    "$scope",
    "$http",
    "$q",
    "helpers",
    "$uibModalInstance",
    "myInsurance",
    "insuranceData",
    "container",
    "toaster",
    "insuranceService",
    "MESSAGES",
    "pdfService",
    "SweetAlert",
    "$localStorage",
    "$sessionStorage",
    "$state",
    "url",
  ];

  function modalOverview(
    $scope,
    $http,
    $q,
    helpers,
    $uibModalInstance,
    myInsurance,
    insuranceData,
    container,
    toaster,
    insuranceService,
    MESSAGES,
    pdfService,
    SweetAlert,
    $localStorage,
    $sessionStorage,
    $state,
    url
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;

    vm.actions = {
      close: close,
      edit: edit,
      renew: renew,
      deleteIt: deleteIt,
      openPdf: openPdf,
      downloadPdf: downloadPdf,
    };

    vm.isPoliza = helpers.isPolicy(myInsurance);
    vm.user = usr;

    activate();

    function activate() {
      vm.myInsurance = myInsurance;

      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 1,
          id_model: vm.myInsurance.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.policy_id = vm.myInsurance.id;

      getContratante();
      $scope.coberturas = myInsurance.coverageInPolicy_policy;
      $scope.forma_pago = function (parValue) {
        switch (parValue) {
          case 1:
            return "Mensual";
            break;
          case 2:
            return "Bimestral";
            break;
          case 3:
            return "Trimestral";
            break;
          case 5:
            return "Contado";
            break;
          case 6:
            return "Semestral";
            break;
          case 12:
            return "Anual";
            break;
          case 24:
            return "Quincenal";
            break;
          default:
            return "No especificada";
        }
      };

      $scope.status = function (parValue) {
        switch (parValue) {
          case 1:
            return "En trámite";
            break;
          case 2:
            return "OT Cancelada";
            break;
          case 4:
            return "Precancelada";
            break;
          case 10:
            return "Por iniciar";
            break;
          case 11:
            return "Cancelada";
            break;
          case 12:
            return "Renovada";
            break;
          case 13:
            return "Vencida";
            break;
          case 14:
            return "Vigente";
            break;
          case 15:
            return "No renovada";
            break;
          default:
            return "Pendiente";
        }
      };
    }

    function close() {
      $uibModalInstance.dismiss("button close");
    }

    function getContratante() {
      if (vm.myInsurance.juridical) url = vm.myInsurance.juridical;
      else url = vm.myInsurance.natural;

      $scope.contratante = url;
      if ($scope.contratante.address_natural)
        $scope.addressContratante = $scope.contratante.address_natural[0];
      else $scope.addressContratante = $scope.contratante.address_juridical[0];
    }

    function edit() {
      if (usr.permiso.editar) {
        $uibModalInstance.close(2);

        if (myInsurance.document_type == 3) {
          $state.go("colectividades.edit", { polizaId: myInsurance.id });
        } else if (myInsurance.document_type == 1 && myInsurance.status == 1) {
          $state.go("polizas.editar", { polizaId: myInsurance.id });
        }
      } else {
        SweetAlert.swal(
          "Oops...",
          "No tienes permiso para editar registros",
          "error"
        );
      }
    }

    function renew() {
      if (!canRenew()) {
        return;
      }

      $uibModalInstance.close(3); // llama al pathfinder con index 3
    }

    function deleteIt() {
      //TODO consumir servicio de delete y entonces cerrar modal (borrar de container opcional)
      if (usr.permiso.eliminar) {
        insuranceService.deleteOT(myInsurance).then(function (res) {
          if (container) {
            container.splice(container.indexOf(myInsurance), 1);
            if (vm.isPoliza) {
              toaster.success(MESSAGES.OK.DELETEOT);
            } else {
              toaster.success(MESSAGES.OK.DELETEPOLICY);
            }
            $uibModalInstance.dismiss("deleted");
          }
        });
      } else {
        SweetAlert.swal(
          "Oops...",
          "No tienes permiso para eliminar registros",
          "error"
        );
      }
    }

    function canRenew() {
      if (
        insuranceData.status != 10 &&
        insuranceData.status != 13 &&
        insuranceData.status != 14
      ) {
        toaster.info("Sólo una póliza puede renovarse");
        return false;
      }

      return true;
    }

    function openPdf() {
      var wait = [];
      wait.push(insuranceService.getInsuranceData(insuranceData.myInsurance));
      $q.all(wait).then(function (response) {
        pdfService.getPdf({ insuranceData: response[0], open: true });
      });
    }

    function downloadPdf() {
      var wait = [];
      wait.push(insuranceService.getInsuranceData(insuranceData.myInsurance));
      $q.all(wait).then(function (response) {
        pdfService.getPdf({ insuranceData: response[0], open: false });
      });
    }
  }
})();

var app = angular.module("inspinia").directive("uppercaseOnly", [
  function () {
    return {
      restrict: "A",
      require: "ngModel",
      link: function (scope, element, attrs, ctrl) {
        element.on("keypress", function (e) {
          var char = e.char || String.fromCharCode(e.charCode);
          if (!/^[A-Z0-9]$/i.test(char)) {
            e.preventDefault();
            return false;
          }
        });

        function parser(value) {
          if (ctrl.$isEmpty(value)) {
            return value;
          }
          var formatedValue = value.toUpperCase();
          if (ctrl.$viewValue !== formatedValue) {
            ctrl.$setViewValue(formatedValue);
            ctrl.$render();
          }
          return formatedValue;
        }

        function formatter(value) {
          if (ctrl.$isEmpty(value)) {
            return value;
          }
          return value.toUpperCase();
        }

        ctrl.$formatters.push(formatter);
        ctrl.$parsers.push(parser);
      },
    };
  },
]);

var app = angular.module("inspinia").directive("tasks", [
  "$uibModal",
  function ($uibModal) {
    return {
      restrict: "EA",
      scope: {
        url: "@",
        typeaheadOnSelect: "=",
        click: "&",
        id: "@",
        required: "=",
        type: "=",
        associated: "=",
        receipt: "=",
        model: "=",
      },
      template:
        '<a class="btn btn-white btn-sm" title="Agregar tarea sobre este trámite" ng-click="$event.stopPropagation(); onClick()">' +
        '<img src="assets/images/icons/addtask.png" width="15px">' +
        "</a>",
      link: function (scope, element, $watch) {
        scope.data = assignTitle();
        scope.route = assignRoute();
        scope.modelo = assignModel();
        scope.id = scope.associated;

        function assignTitle() {
          switch (scope.type) {
            case 1:
              return "OT de póliza no. " + scope.model;
              break;
            case 2:
              return "OT de endoso no. " + scope.model;
              break;
            case 3:
              return "recibo no. " + scope.model;
              break;
            case 4:
              return "póliza no. " + scope.model;
              break;
            case 5:
              return "renovación de la póliza " + scope.model;
              break;
            case 6:
              return "siniestro no. " + scope.model;
              break;
            case 7:
              return "cliente " + scope.model;
              break;
            case 8:
              return "fianza no. " + scope.model;
              break;
            case 9:
              return "endoso no. " + scope.model;
              break;
          }
        }

        function assignRoute() {
          switch (scope.type) {
            case 1:
              return "OT | Póliza | " + scope.model + " | ";
              break;
            case 2:
              return "OT | Endoso | " + scope.model + " | ";
              break;
            case 3:
              return (
                "Recibo | " +
                scope.model.split(" ")[0] +
                " | Póliza | " +
                scope.model.split(" ")[4]
              );
              break;
            case 4:
              return "Póliza | " + scope.model + " | ";
              break;
            case 5:
              return "Renovación | Póliza | " + scope.model + " | ";
              break;
            case 6:
              return (
                "Siniestro | " +
                scope.model.split(" ")[0] +
                " | Póliza | " +
                scope.model.split(" ")[4]
              );
              break;
            case 7:
              return "Cliente | " + scope.model;
              break;
            case 8:
              return "Fianza | " + scope.model + " | ";
              break;
            case 9:
              return "Endoso | " + scope.model + " | ";
              break;
          }
        }

        function assignModel() {
          switch (scope.type) {
            case 1:
              return 1;
              break;
            case 2:
              return 2;
              break;
            case 3:
              return 4;
              break;
            case 4:
              return 4;
              break;
            case 5:
              return 5;
              break;
            case 6:
              return 6;
              break;
            case 7:
              return 7;
              break;
            case 8:
              return 8;
              break;
            case 9:
              return 9;
              break;
          }
        }

        scope.onClick = function () {
          var modalInstance = $uibModal.open({
            templateUrl: "app/tasks/task.modal.html",
            controller: "TareasModalCtrl",
            size: "lg",
            resolve: {
              task: function () {
                return null;
              },
              data: function () {
                return scope.data;
              },
              associated: function () {
                return scope.id;
              },
              receipt: function () {
                return scope.receipt;
              },
              route: function () {
                return scope.route;
              },
              modelo: function () {
                return scope.modelo;
              },
            },
          });
        };
      },
    };
  },
]);

var tabsModule = angular.module("inspinia");

tabsModule.directive("tabset", function (appStates, $state, $localStorage) {
  return {
    restrict: "E",
    transclude: true,
    scope: {},
    // template: '<div role="tabpanel"><ul class="nav nav-tabs" role="tablist"><li role="presentation"  ng-class="{"active":tab.active, "disabled":tab.disabled}" ng-repeat="tab in tabset.tabs"><a href=""role="tab"ng-click="tabset.select(tab)">{{tab.heading}}</a></li></ul><ng-transclude></ng-transclude></div>',
    templateUrl: "app/directivas/tabs/tabset.html",
    bindToController: true,
    controllerAs: "tabset",
    controller: function () {
      var self = this;
      self.tabs = [];
      self.select = function (selectedTab) {
        if (selectedTab.disabled) {
          return;
        }
        angular.forEach(self.tabs, function (tab) {
          if (tab.active && tab !== selectedTab) {
            tab.active = false;
          }
        });
        selectedTab.active = true;
        $state.go(selectedTab.route);
      };
      self.add_tab = function () {
        console.log("Add tab");
        appStates.states = appStates.states.map(function (item) {
          item.active = false;
          return item;
        });
        appStates.states.push({
          name: "Dashboard",
          heading: "Dashboard",
          route: "index.main",
          active: true,
          isVisible: true,
          href: $state.href("index.main"),
        });
        self.tabs = appStates.states;
        $localStorage.tab_states = appStates.states;
        $state.go(self.tabs[self.tabs.length - 1].route);
      };

      self.delete_tab = function (index) {
        console.log(self.tabs);
        console.log(self.tabs[index]);
        var actual_state = appStates.states.splice(index, 1);
        console.log("actual_state**", actual_state);

        self.tabs = appStates.states;

        // $localStorage.tab_states = appStates.states;
      };

      self.addTab = function addTab(tab) {
        self.tabs.push(tab);
        if (self.tabs.length === 1) {
          tab.active = true;
        }
      };
    },
  };
});

var tabsModule = angular.module("inspinia");

tabsModule.directive("tab", function () {
  return {
    restrict: "E",
    transclude: true,
    template: '<div role="tabpanel" ng-show="active" ng-transclude></div>',
    require: "^tabset",
    scope: {
      heading: "@",
    },
    link: function (scope, elem, attr, tabsetCtrl) {
      scope.active = false;
      scope.disabled = false;
      scope.route = "index.main";
      if (attr.disable) {
        attr.$observe("disable", function (value) {
          scope.disabled = value !== "false";
        });
      }
      tabsetCtrl.addTab(scope);
    },
  };
});

var phonenumberModule = angular.module("inspinia");

phonenumberModule
  .directive("phonenumberDirective", [
    "$filter",
    "$window",
    function ($filter, $window) {
      /*
		Use:
			<phonenumber-directive placeholder='prompt' model='someModel.phonenumber'></phonenumber-directive>
		Where:
			someModel.phonenumber: {String} value which to bind only the numeric characters [0-9] entered
				ie, if user enters 617-2223333, value of 6172223333 will be bound to model
			prompt: {String} text to keep in placeholder when no numeric input entered
		*/

      function link(scope, element, attributes) {
        // scope.inputValue is the value of input element used in template
        scope.inputValue = scope.phonenumberModel;

        scope.$watch("phonenumberModel", function (value, oldValue) {
          value = String(value);
          var number = value.replace(/[^0-9]+/g, "");
          scope.phonenumberModel = number;
          scope.inputValue = $filter("phonenumber")(number);
        });

        scope.$watch("inputValue", function (value, oldValue) {
          value = String(value);
          var number = value.replace(/[^0-9]+/g, "");
          scope.phonenumberModel = number;
          scope.inputValue = $filter("phonenumber")(number);
        });
        // }
      }

      return {
        link: link,
        restrict: "E",
        scope: {
          phonenumberPlaceholder: "=placeholder",
          phonenumberModel: "=model",
          disabledfield: "=",
          change: "&",
        },
        //templateUrl: '/static/phonenumberModule/template.html',
        template:
          '<input ng-model="inputValue" ng-change="change()" ng-disabled="disabledfield" type="tel" class="phonenumber form-control" maxlength="25" placeholder="{{phonenumberPlaceholder}}" title="Phonenumber (Format: (999) 9999-9999)">',
      };
    },
  ])

  .filter("phonenumber", function () {
    return function (number) {
      if (!number) {
        return "";
      }

      number = String(number);

      // Will return formattedNumber.
      // If phonenumber isn't longer than an area code, just show number
      var formattedNumber = number;

      // if the first character is '1', strip it out and add it back
      if (number[0] == "1") {
        var c = number[0] == "1" ? "1 " : "";
        number = number[0] == "1" ? number.slice(1) : number;
      } else if (number[0] == "0" && number[1] == "1") {
        var c = number[0] == "0" && number[1] == "1" ? "01 " : "";
        number =
          number[0] == "0" && number[1] == "1" ? number.slice(2) : number;
      } else var c = "";

      var area;
      var front;
      if (
        number.substring(0, 2) == 55 ||
        number.substring(0, 2) == 33 ||
        number.substring(0, 2) == 81
      ) {
        area = number.substring(0, 2);
        front = number.substring(2, 6);
      } else {
        area = number.substring(0, 3);
        front = number.substring(3, 6);
      }

      var end = number.substring(6, 10);
      var ext = number.substring(10, 15);

      // # (###) ###-#### as c (area) front-end
      //var area = number.substring(0,3);
      //var front = number.substring(3, 6);
      //var end = number.substring(6, 10);
      //var ext = number.substring(10, 15);

      if (front) {
        formattedNumber = c + "(" + area + ") " + front;
      }
      if (end) {
        formattedNumber += "-" + end;
      }
      if (ext) {
        formattedNumber += " ext. " + ext;
      }
      return formattedNumber;
    };
  });

var myApp = angular.module("inspinia");

myApp.directive("percentageField", [
  "$filter",
  function ($filter) {
    return {
      restrict: "A",
      require: "ngModel",
      scope: {
        // currencyIncludeDecimals: '&',
      },
      link: function (scope, element, attr, ngModel) {
        attr["percentageMaxValue"] = attr["percentageMaxValue"] || 100;
        attr["percentageMaxDecimals"] = attr["percentageMaxDecimals"] || 2;

        $(element).css({ "text-align": "right" });

        // function called when parsing the inputted url
        // this validation may not be rfc compliant, but is more
        // designed to catch common url input issues.
        function into(input) {
          var valid;

          if (input == "") {
            ngModel.$setValidity("valid", true);
            return "";
          }

          // if the user enters something that's not even remotely a number, reject it
          if (!input.match(/^\d+(\.\d+){0,1}%{0,1}$/gi)) {
            ngModel.$setValidity("valid", false);
            return "";
          }

          // strip everything but numbers from the input
          input = input.replace(/[^0-9\.]/gi, "");

          input = parseFloat(input);

          var power = Math.pow(10, attr["percentageMaxDecimals"]);

          input = Math.round(input * power) / power;

          if (input > attr["percentageMaxValue"])
            input = attr["percentageMaxValue"];

          // valid!
          ngModel.$setValidity("valid", true);

          return input;
        }

        ngModel.$parsers.push(into);

        function out(input) {
          if (ngModel.$valid && input !== undefined && input > "") {
            return input + "%";
          }

          return "";
        }

        ngModel.$formatters.push(out);

        $(element).bind("click", function () {
          //$( element ).val( ngModel.$modelValue );
          $(element).select();
        });

        $(element).bind("blur", function () {
          $(element).val(out(ngModel.$modelValue));
        });
      },
    };
  },
]);

myApp.controller("Ctrl2", [
  "$scope",
  function ($scope) {
    $scope.percent = 0.0;
    $scope.maxValue = 100;
    $scope.maxDecimals = 2;
    // $scope.dollarValue = '';
    $scope.currencyIncludeDecimals = true;
  },
]);

var app = angular
  .module("inspinia")
  .filter("slice", function () {
    return function (arr, start, end) {
      if (arr) {
        return arr.slice(start, end);
      }
    };
  })
  .directive("pagination", [
    "$http",
    "$parse",
    "$localStorage",
    function ($http, $parse, $localStorage) {
      return {
        // restrict: 'EA',
        scope: {
          model: "=",
          params: "=",
          config: "=",
          id: "@",
        },
        templateUrl: "app/directivas/pagination/pagination.html",
        link: function (scope, rootScope, attrs) {
          if (scope.config) {
            var pages = 1;
            pages = Math.ceil(scope.config.count / 10);
          }

          scope.totalPages = [];
          var count_items = 0;
          var count_pages = 0;

          var previous_array = [];
          var next_array = [];

          scope.start = 0;
          scope.end = 5;
          scope.actual_page = 1;
          scope.actual_page =
            scope.config && scope.config.current_page
              ? parseInt(scope.config.current_page, 10)
              : 1;
          scope.not_prev = true;
          for (var i = 0; i < pages; i++) {
            scope.totalPages.push(i + 1);
          }
          scope.$watch("config.page", function (newVal, oldVal) {
            if (!newVal) return;

            var page = parseInt(newVal, 10) || 1;

            // Si solo quieres marcar la página visualmente:
            // scope.actual_page = page;

            // Si además quieres que se haga el request de esa página,
            // llama a la propia lógica de la directiva:
            if (page !== scope.actual_page) {
              scope.selectPage(page);
            }
          });
          scope.previousPage = function () {
            if (scope.actual_page > 1) {
              scope.not_prev = false;

              if (scope.actual_page == scope.start) {
                scope.start = scope.start - 4;
                scope.end = scope.end - 4;

                scope.not_prev = false;
                scope.not_next = false;
              }

              scope.actual_page = scope.actual_page - 1;

              getProviders(scope.config.previous);
              scope.previousBlockPages(1);
            }
          };

          scope.nextPage = function () {
            if (scope.actual_page > 1) {
              scope.not_prev = false;
            }

            if (scope.actual_page == scope.totalPages.length - 1) {
              scope.not_next = true;
            }

            if (scope.actual_page < scope.totalPages.length) {
              if (scope.actual_page == scope.end) {
                scope.start = scope.start + 4;
                scope.end = scope.end + 5;
                if (scope.end == scope.totalPages.length) {
                  scope.not_next = true;
                }
              }
              scope.actual_page = scope.actual_page + 1;
              getProviders(scope.config.next);
              scope.nextBlockPages(2);
            } else if (scope.actual_page == scope.totalPages.length) {
              scope.not_next = true;
            }
          };

          scope.selectPage = function (parPage) {
            var config_ = "";
            config_ = angular.copy(scope.config);

            var url = "";
            if (scope.config.next || scope.config.previous) {
              if (scope.config.next) {
                var otherParameters = config_.next.substring(
                  config_.next.indexOf("&page=") + 6
                );

                // var test = otherParameters.substring(2, otherParameters.indexOf('&')+1000);
                // console.log('test', test);

                url = config_.next.substring(
                  0,
                  config_.next.indexOf("&page=") + 6
                );
                url += parPage.toString();

                if (config_.next.search("&") !== -1) {
                  var params = otherParameters.substring(
                    2,
                    otherParameters.indexOf("&") + 500
                  );

                  url += "&" + params;
                }

                // if(config_.next.search('&tipo=') !== -1) {
                //   var tipo = scope.config.next.substring(0, scope.config.next.indexOf("&tipo=") + 6);
                //   url += '&'+tipo.toString();
                // }
              } else {
                url = "";

                // var otherParameters = config_.previous.substring(config_.previous.indexOf("&page=") + 6);

                // if(config_.previous.search('&page=') !== -1) {
                //   url = config_.previous.substring(0, config_.previous.indexOf("&page=") + 6);
                //   url += parPage.toString();
                // } else {
                //   url = config_.previous
                // }

                // if(config_.previous.search('&') !== -1) {
                //   var params = otherParameters.substring(2, otherParameters.indexOf('&')+1000);
                // console.log('----------', params);
                // url += '&'+params;
                // }

                if (config_.previous.indexOf("&page=") > -1) {
                  var otherParameters = config_.previous.substring(
                    config_.previous.indexOf("&page=") + 6
                  );

                  // var test = otherParameters.substring(2, otherParameters.indexOf('&')+1000);
                  // console.log('test', test);

                  url = config_.previous.substring(
                    0,
                    config_.previous.indexOf("&page=") + 6
                  );
                  url += parPage.toString();

                  if (config_.previous.search("&") !== -1) {
                    var params = otherParameters.substring(
                      2,
                      otherParameters.indexOf("&") + 500
                    );

                    url += "&" + params;
                  }
                } else {
                  url = config_.previous + "&page=" + String(parPage);
                }

                // if(config_.previous.search('&tipo=') !== -1) {
                //   var tipo = scope.config.previous.substring(0, scope.config.next.indexOf("&tipo=") + 6);
                //   url += '&'+tipo.toString();
                // }else {
                //   url = scope.config.previous
                // }
              }
            }

            // url += '&status=1'

            getProviders(url);
            scope.actual_page = parPage;
            if (scope.actual_page > 1) {
              scope.not_prev = false;
            }
            if (scope.actual_page == scope.totalPages.length - 1) {
              scope.not_next = true;
            }
          };

          scope.lastPage = function () {
            // TODO: ultimo bloque
            if (scope.totalPages.length > 5) {
              scope.end = scope.totalPages.length;
              scope.start = scope.totalPages.length - 5;
            }
            scope.selectPage(scope.totalPages.length);

            scope.actual_page = scope.totalPages.length;
          };

          // console.log('id', scope.id);
          scope.previousBlockPages = function (param) {
            if (param) {
              if (scope.start < scope.actual_page) {
                scope.start = scope.start - 1;
                scope.end = scope.end - 1;
              }
            } else {
              scope.start = scope.start - 5;
              scope.end = scope.end - 5;

              if (scope.end < scope.totalPages.length) {
                scope.not_next = false;
              }
            }

            if (scope.end <= 5) {
              scope.start = 0;
              scope.end = 5;
              scope.show_prev_block = false;
            }
          };

          scope.nextBlockPages = function (param) {
            scope.show_prev_block = true;

            if (param) {
              if (scope.end > scope.actual_page) {
                scope.start = scope.start + 1;
                scope.end = scope.end + 1;
              }
            } else {
              if (scope.end < scope.totalPages.length) {
                scope.start = scope.start + 5;
                scope.end = scope.end + 5;

                if (scope.end == scope.totalPages.length) {
                  scope.not_next = true;
                }
              } else {
                scope.not_next = true;
              }
            }
          };

          function getProviders(parUrl) {
            $http
              .get(parUrl)
              .then(
                function success(request) {
                  if (request.data) {
                    // console.log('... params ....', scope.params);

                    // console.log('request - pagination', request,parUrl);
                    if (parUrl && parUrl.indexOf("/graficas-recibos") !== -1) {
                      var queryString = parUrl.split("?")[1] || "";
                      var params = {};
                      queryString.split("&").forEach(function (pair) {
                        if (!pair) return;
                        var parts = pair.split("=");
                        var key = decodeURIComponent(parts[0]);
                        var value = decodeURIComponent(parts[1] || "");
                        params[key] = value;
                      });
                      var page = params.page || "1";
                      $localStorage.graficas_recibos_page = page;
                      $localStorage.graficas_recibos_url = parUrl;
                    }
                    scope.model = [];
                    // scope.model = request.data.results;
                    // console.log('model', scope.model);

                    if (scope.params) {
                      scope.model = [];

                      scope.params.forEach(function (item) {
                        // console.log('item', item);
                        request.data.results.forEach(function (rec, rec_index) {
                          if (item.id == rec.id) {
                            request.data.results.splice(rec_index, 1);
                          }
                        });
                      });
                    }
                    scope.model = request.data.results;

                    var parsed = $parse(attrs.model);
                    parsed.assign(scope, []);
                    parsed.assign(scope, request.data.results);
                    // console.log('ssssssss',scope.$parent[attrs.model]);
                    if (scope.$parent[attrs.model]) {
                      scope.$parent[attrs.model] = request.data.results;
                    }
                    // console.log('scope', scope);

                    scope.config = {
                      count: request.data.count,
                      previous: request.data.previous,
                      next: request.data.next,
                    };
                  }
                },
                function error(error) {
                  console.log("error", error);
                }
              )
              .catch(function (e) {
                console.log("e", e);
              });
          }
        },
      };
    },
  ]);

var app = angular.module("inspinia").directive("ngEnter", function () {
  return function (scope, element, attrs) {
    element.bind("keypress", function (e) {
      if (e.charCode === 13 || e.keyCode === 13) {
        scope.$apply(attrs.ngEnter);
      }
    });
  };
});

var app = angular
  .module("inspinia")
  .directive("lowercase", [
    function () {
      return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ctrl) {
          element.on("keyup", function (e) {
            var char = e.char || String.fromCharCode(e.charCode);
            if (!/^[A-Z0-9]$/i.test(char)) {
              e.preventDefault();
              return false;
            }
          });

          function parser(value) {
            if (ctrl.$isEmpty(value)) {
              return value;
            }
            var formatedValue = value.toLowerCase();
            if (ctrl.$viewValue !== formatedValue) {
              ctrl.$setViewValue(formatedValue);
              ctrl.$render();
            }
            return formatedValue;
          }

          function formatter(value) {
            if (ctrl.$isEmpty(value)) {
              return value;
            }
            return value.toLowerCase();
          }

          ctrl.$formatters.push(formatter);
          ctrl.$parsers.push(parser);
        },
      };
    },
  ])
  .directive("transformInputs", function ($compile) {
    return {
      // restrict: 'AE',
      link: function (scope, elem, attrs) {
        // console.log('okokokokoko');
        console.log(elem.children("input"));
        elem.children("input").attr("uppercase");
        $compile(elem.contents())(scope);
      },
    };
  })
  .directive("uppercase", [
    function () {
      return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ctrl) {
          element.on("keyup", function (e) {
            var char = e.char || String.fromCharCode(e.charCode);
            if (!/^[A-Z0-9]$/i.test(char)) {
              e.preventDefault();
              return false;
            }
          });

          function parser(value) {
            if (ctrl.$isEmpty(value)) {
              return value;
            }
            var formatedValue = value.toUpperCase();
            if (ctrl.$viewValue !== formatedValue) {
              ctrl.$setViewValue(formatedValue);
              ctrl.$render();
            }
            return formatedValue;
          }

          function formatter(value) {
            if (ctrl.$isEmpty(value)) {
              return value;
            }

            return value.toUpperCase();
          }

          ctrl.$formatters.push(formatter);
          ctrl.$parsers.push(parser);
        },
      };
    },
  ]);

(function () {
  var myApp = angular
    .module("inspinia")
    .directive("phoneInput", function ($filter, $browser) {
      return {
        require: "ngModel",
        link: function ($scope, $element, $attrs, ngModelCtrl) {
          var listener = function () {
            var value = $element.val().replace(/[^0-9]/g, "");
            $element.val($filter("tel")(value, false));
          };

          // This runs when we update the text field
          ngModelCtrl.$parsers.push(function (viewValue) {
            return viewValue.replace(/[^0-9]/g, "").slice(0, 10);
          });

          // This runs when the model gets updated on the scope directly and keeps our view in sync
          ngModelCtrl.$render = function () {
            $element.val($filter("tel")(ngModelCtrl.$viewValue, false));
          };

          // console.log('lkasjdkl');

          $element.bind("change", listener);
          $element.bind("keydown", function (event) {
            var key = event.keyCode;
            // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
            // This lets us support copy and paste too
            if (
              key == 91 ||
              (15 < key && key < 19) ||
              (37 <= key && key <= 40)
            ) {
              return;
            }
            $browser.defer(listener); // Have to do this or changes don't get picked up properly
          });

          $element.bind("paste cut", function () {
            $browser.defer(listener);
          });
        },
      };
    })
    .filter("tel", function () {
      return function (tel) {
        console.log(tel);
        if (!tel) {
          return "";
        }

        var value = tel.toString().trim().replace(/^\+/, "");

        if (value.match(/[^0-9]/)) {
          return tel;
        }

        var country, city, number;

        switch (value.length) {
          case 1:
          case 2:
          case 3:
            city = value;
            break;

          default:
            city = value.slice(0, 3);
            number = value.slice(3);
        }

        if (number) {
          if (number.length > 3) {
            number = number.slice(0, 3) + "-" + number.slice(3, 7);
          } else {
            number = number;
          }

          return ("(" + city + ") " + number).trim();
        } else {
          return "(" + city;
        }
      };
    });
});

var app = angular.module("inspinia").directive("graphic", [
  "$http",
  "url",
  "exportFactory",
  "$localStorage",
  "$sessionStorage",
  function ($http, url, exportFactory, $localStorage, $sessionStorage) {
    return {
      restrict: "EA",
      scope: {
        model: "=",
        lc: "=",
        gsource: "=",
        gtype: "@",
        id: "@",
        greenClick: "&",
        yellowClick: "&",
        orangeClick: "&",
        redClick: "&",
        parentVm: "=?", // 👈 NUEVO
      },
      templateUrl: "app/directivas/graphic/graphic.html",
      link: function (scope, element, $watch) {
        // var greatGrandFather = scope.$parent.$parent.$parent.main;
        // Si me pasaron el padre explícito, úsalo
        var greatGrandFather = scope.parentVm;

        // Fallbacks por si todavía no actualizas todos los templates viejos
        if (!greatGrandFather) {
          greatGrandFather =
            (scope.$parent && scope.$parent.main) ||
            (scope.$parent &&
              scope.$parent.$parent &&
              scope.$parent.$parent.main) ||
            (scope.$parent &&
              scope.$parent.$parent &&
              scope.$parent.$parent.$parent &&
              scope.$parent.$parent.$parent.main);
        }

        if (!greatGrandFather) {
          console.warn(
            "graphic directive: no se pudo resolver main (parentVm/main)"
          );
          return;
        }
        var infoUser = $sessionStorage.infoUser;

        if (scope.gtype) {
          switch (scope.gtype) {
            case "ot":
              httpCall("chart-polizas/");
              break;
            case "receipts":
              httpCall("chart-recibos/");
              break;
            case "renewals":
              httpCall("chart-renovaciones/");
              break;
            case "sinister":
              httpCall("chart-siniestros/");
              break;
            default:
          }
        }
        // 👇 NUEVO: función global para recargar la gráfica de recibos
        if (scope.gtype === "receipts") {
          greatGrandFather.reloadReceiptsGraphic = function () {
            // 1) refrescar donut / resumen
            httpCall("chart-recibos/");

            // 2) refrescar el listado con el último filtro usado
            //    (color y orden guardados en localStorage por la propia directiva)
            var parType =
              $localStorage.type_rec || greatGrandFather.color || "green";
            var order = $localStorage.order_rec || 1;
            var asc = $localStorage.asc_rec || 1;
            console.log("función actualizar gráfica");
            scope.gtype = "receipts";
            scope.getItems(parType, order, asc);
          };
        }
        function httpCallEndo(parUrl, parType, titleID, title, order, asc) {
          greatGrandFather.showEndV = false;
          if (parType) {
            if (parType == "blue") {
              var par = { polizaId: 0 };
              scope.polizaId = par;
              scope.order = order;
              scope.asc = asc;
            } else {
              var par = { tipo: parType, order: order, asc: asc };
            }
          } else {
            var par = { tipo: null, order: order, asc: asc };
          }
          if (parUrl == "graficas-endosos/") {
            var met = "POST";
            var p = "data";
            var d = par;
            var u = {
              method: "POST",
              url: url.IP + "graficas-endosos/",
              data: par,
            };
          } else {
            var met = "GET";
            var p = "params";
            var d = par;
            var u = {
              method: "GET",
              url: url.IP + parUrl,
              params: par,
            };
          }
          // $http({
          //   method: 'GET',
          //   url: url.IP +parUrl,
          //   params: par
          // })
          $http(u).then(function success(response) {
            if (response.status === 200 || response.status === 201) {
              if (parType) {
                switch (scope.gtype) {
                  case "ot":
                    greatGrandFather.endo = [];
                    var today = new Date();
                    today = today.getTime();
                    response.data.results.forEach(function (item) {
                      var fechaInicio = new Date(item.created_at).getTime();
                      var diff = today - fechaInicio;
                      item.antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
                      greatGrandFather.endo.push(item);
                    });
                    greatGrandFather.policyTable = true;
                    greatGrandFather.coverageTable = false;
                    greatGrandFather.renewalTable = false;
                    greatGrandFather.sinisterTable = false;
                    greatGrandFather.titleID = titleID;
                    greatGrandFather.title = title;
                    greatGrandFather.vida_pagination = {
                      count: response.data.count,
                      next: response.data.next,
                      previous: response.data.previous,
                    };
                    greatGrandFather.show_paginationVida = true;
                    greatGrandFather.show_vida_pagination = true;
                }
              }
            }
          });
        }

        function httpCall(parUrl, parType, titleID, title, order, asc) {
          greatGrandFather.titleID = titleID;
          greatGrandFather.title = title;
          greatGrandFather.orden = order;
          greatGrandFather.asce = asc;
          greatGrandFather.show_paginationOt = false;
          greatGrandFather.show_ots_pagination = false;
          greatGrandFather.show_paginationReceipts = false;
          greatGrandFather.show_receipts_pagination = false;
          greatGrandFather.show_paginationRenewals = false;
          greatGrandFather.show_renovaciones_pagination = false;
          greatGrandFather.show_paginationRenewals = false;
          greatGrandFather.show_renovaciones_pagination = false;
          greatGrandFather.show_sinisters_pagination = false;

          if (parType) {
            if (parType == "blue") {
              var par = {
                polizaId: 0,
                order: order,
                asc: asc,
                vendedor: 0,
                type_contractor: 0,
                contratante: 0,
                grupo: 0,
              };
              scope.polizaId = par;
              scope.order = order;
              scope.asc = asc;
            } else {
              var par = { tipo: parType, order: order, asc: asc };
            }
          } else {
            var par = { tipo: null, order: order, asc: asc };
          }
          if (parUrl == "graficas-polizas/") {
            var met = "POST";
            var p = "data";
            var d = par;
            var u = {
              method: "POST",
              url: url.IP + "graficas-polizas/",
              data: par,
            };
          } else {
            var met = "GET";
            var p = "params";
            var d = par;
            var u = {
              method: "GET",
              url: url.IP + parUrl,
              params: par,
            };
          }
          // $http({
          //   method: met,
          //   url: url.IP +parUrl,
          //   p: par
          // })
          $http(u).then(
            function success(response) {
              if (response.status === 200 || response.status === 201) {
                if (parType) {
                  switch (scope.gtype) {
                    case "ot":
                      greatGrandFather.insurances = [];

                      var today = new Date();
                      today = today.getTime();
                      response.data.results.forEach(function (item) {
                        var fechaInicio = new Date(item.created_at).getTime();
                        var diff = today - fechaInicio;
                        item.antiguedad = parseInt(
                          diff / (1000 * 60 * 60 * 24)
                        );
                        greatGrandFather.insurances.push(item);
                      });
                      greatGrandFather.insurances.forEach(function (value) {
                        if (value.old_policies) {
                          value.old_policies.forEach(function (old) {
                            if (old) {
                              if (value.id == old.base_policy.id) {
                                if (value.renewed) {
                                  value.historic = " Renovada";
                                } else {
                                  value.historic = " por renovar";
                                }
                              } else if (value.id == old.new_policy.id) {
                                value.historic = "de Renovación";
                              } else {
                                value.historic = " nueva";
                              }
                            } else {
                              value.historic = " nueva";
                            }
                          });
                          if (value.historic) {
                          } else {
                            value.historic = " nueva";
                          }
                        }
                        // $http({
                        //   method: 'GET',
                        //   url: url.IP + 'historic-policies/',
                        //   params: {
                        //     actual_id: value.id
                        //   }
                        // }).then(function success(response) {
                        //   if(response.data.results.length){
                        //     response.data.results.forEach(function function_name(old) {
                        //       if(old.base_policy){
                        //         if(value.id == old.new_policy.id){
                        //           if (old.new_policy) {
                        //             value.historic ='de Renovación';
                        //           }
                        //         } else {
                        //             value.historic = ' nueva'
                        //         }
                        //       }else{
                        //         value = ''
                        //       }
                        //     })
                        //   }else{
                        //       value.historic = ' nueva'

                        //   }
                        // })
                      });
                      greatGrandFather.policyTable = true;
                      greatGrandFather.coverageTable = false;
                      greatGrandFather.coverageModal = false;
                      greatGrandFather.renewalTable = false;
                      greatGrandFather.sinisterTable = false;
                      greatGrandFather.titleID = titleID;
                      greatGrandFather.title = title;
                      greatGrandFather.ot_pagination = {
                        count: response.data.count,
                        next: response.data.next,
                        previous: response.data.previous,
                      };
                      // greatGrandFather.show_paginationOt = true;
                      // greatGrandFather.show_ots_pagination = true;
                      break;
                    case "receipts":
                      if (parUrl == "get-notas/") {
                        greatGrandFather.notascredito = response.data.results;
                        greatGrandFather.notas = true;
                        greatGrandFather.coverageTable = false;
                        greatGrandFather.coverageModal = false;
                        greatGrandFather.config_receipts = false;
                        greatGrandFather.show_paginationReceipts = false;
                        greatGrandFather.show_receipts_pagination = false;
                        greatGrandFather.config_notes = {
                          count: response.data.count,
                          next: response.data.next,
                          previous: response.data.previous,
                        };
                        greatGrandFather.show_paginationNote = true;
                        greatGrandFather.show_note_pagination = true;
                      } else {
                        if (
                          parUrl &&
                          parUrl.indexOf("/graficas-recibos") !== -1
                        ) {
                          var queryString = parUrl.split("?")[1] || "";
                          var params = {};
                          queryString.split("&").forEach(function (pair) {
                            if (!pair) return;
                            var parts = pair.split("=");
                            var key = decodeURIComponent(parts[0]);
                            var value = decodeURIComponent(parts[1] || "");
                            params[key] = value;
                          });
                          var page = params.page || "1";
                          $localStorage.graficas_recibos_page = page;
                          $localStorage.graficas_recibos_url = parUrl;
                        }
                        // if (!$localStorage.graficas_recibos_url) {
                        var queryString = parUrl.split("?")[1] || "";
                        var params = {};
                        queryString.split("&").forEach(function (pair) {
                          if (!pair) return;
                          var parts = pair.split("=");
                          var key = decodeURIComponent(parts[0]);
                          var value = decodeURIComponent(parts[1] || "");
                          params[key] = value;
                        });
                        var page = params.page || "1";
                        $localStorage.graficas_recibos_page = page;
                        $localStorage.graficas_recibos_url = parUrl;
                        // }
                        greatGrandFather.notas = false;
                        greatGrandFather.coverageTable = true;
                        greatGrandFather.receipts = response.data.results;

                        for (
                          var i = 0;
                          i < greatGrandFather.receipts.length;
                          i++
                        ) {
                          // greatGrandFather.receipts[i].receipt_type = greatGrandFather.receipts[i].receipt_type == 1 ? "Póliza" : "Endoso";
                          if (greatGrandFather.receipts[i].poliza) {
                            greatGrandFather.receipts[i].poliza.status =
                              greatGrandFather.receipts[i].poliza.status == 1
                                ? "En trámite"
                                : greatGrandFather.receipts[i].poliza.status ==
                                  2
                                ? "OT Cancelada"
                                : greatGrandFather.receipts[i].poliza.status ==
                                  10
                                ? "Por Iniciar"
                                : greatGrandFather.receipts[i].poliza.status ==
                                  11
                                ? "Cancelada"
                                : greatGrandFather.receipts[i].poliza.status ==
                                  12
                                ? "Renovada"
                                : greatGrandFather.receipts[i].poliza.status ==
                                  13
                                ? "Vencida"
                                : greatGrandFather.receipts[i].poliza.status ==
                                  14
                                ? "Vigente"
                                : "Vigente";
                          } else if (greatGrandFather.receipts[i].fianza) {
                            greatGrandFather.receipts[i].fianza.status =
                              greatGrandFather.receipts[i].fianza.status == 1
                                ? "En trámite"
                                : greatGrandFather.receipts[i].fianza.status ==
                                  2
                                ? "OT Cancelada"
                                : greatGrandFather.receipts[i].fianza.status ==
                                  10
                                ? "Por Iniciar"
                                : greatGrandFather.receipts[i].fianza.status ==
                                  11
                                ? "Cancelada"
                                : greatGrandFather.receipts[i].fianza.status ==
                                  12
                                ? "Anulada"
                                : greatGrandFather.receipts[i].fianza.status ==
                                  13
                                ? "Rechazada"
                                : greatGrandFather.receipts[i].fianza.status ==
                                  15
                                ? "Renovada"
                                : "Vigente";
                          }

                          if (greatGrandFather.receipts[i].status == 1) {
                            greatGrandFather.receipts[i].status = "Pagado";
                          } else if (greatGrandFather.receipts[i].status == 2) {
                            greatGrandFather.receipts[i].status = "Cancelado";
                          } else if (greatGrandFather.receipts[i].status == 3) {
                            greatGrandFather.receipts[i].status = "Prorrogado";
                          } else if (greatGrandFather.receipts[i].status == 4) {
                            greatGrandFather.receipts[i].status =
                              "Pendiente de pago";
                          } else if (greatGrandFather.receipts[i].status == 5) {
                            greatGrandFather.receipts[i].status = "Liquidado";
                          } else if (greatGrandFather.receipts[i].status == 6) {
                            greatGrandFather.receipts[i].status = "Conciliado";
                          } else if (greatGrandFather.receipts[i].status == 7) {
                            greatGrandFather.receipts[i].status = "Cerrado";
                          } else if (greatGrandFather.receipts[i].status == 0) {
                            greatGrandFather.receipts[i].status = "Desactivado";
                          } else {
                            greatGrandFather.receipts[i].status = "Sin estatus";
                          }

                          if (greatGrandFather.receipts[i].poliza) {
                            if (
                              greatGrandFather.receipts[i].poliza
                                .forma_de_pago == 1
                            ) {
                              greatGrandFather.receipts[
                                i
                              ].poliza.forma_de_pago = "Mensual";
                            } else if (
                              greatGrandFather.receipts[i].poliza
                                .forma_de_pago == 2
                            ) {
                              greatGrandFather.receipts[
                                i
                              ].poliza.forma_de_pago = "Bimestral";
                            } else if (
                              greatGrandFather.receipts[i].poliza
                                .forma_de_pago == 3
                            ) {
                              greatGrandFather.receipts[
                                i
                              ].poliza.forma_de_pago = "Trimestral";
                            } else if (
                              greatGrandFather.receipts[i].poliza
                                .forma_de_pago == 5
                            ) {
                              greatGrandFather.receipts[
                                i
                              ].poliza.forma_de_pago = "Contado";
                            } else if (
                              greatGrandFather.receipts[i].poliza
                                .forma_de_pago == 6
                            ) {
                              greatGrandFather.receipts[
                                i
                              ].poliza.forma_de_pago = "Semestral";
                            } else if (
                              greatGrandFather.receipts[i].poliza
                                .forma_de_pago == 12
                            ) {
                              greatGrandFather.receipts[
                                i
                              ].poliza.forma_de_pago = "Anual";
                            } else {
                              greatGrandFather.receipts[
                                i
                              ].poliza.forma_de_pago = "Sin estatus";
                            }
                          }
                        }
                        greatGrandFather.config_receipts = {
                          count: response.data.count,
                          next: response.data.next,
                          previous: response.data.previous,
                        };
                      }

                      greatGrandFather.policyTable = false;
                      greatGrandFather.renewalTable = false;
                      greatGrandFather.sinisterTable = false;
                      greatGrandFather.endorsementTable = false;

                      greatGrandFather.titleID = titleID;
                      greatGrandFather.title = title;

                      greatGrandFather.show_paginationReceipts = true;
                      greatGrandFather.show_receipts_pagination = true;
                      break;
                    case "renewals":
                      greatGrandFather.show_renewal = false;
                      greatGrandFather.policies = response.data.results;
                      // hacer el config y el show
                      // greatGrandFather == main
                      greatGrandFather.notas = false;
                      greatGrandFather.renewalTable = true;
                      greatGrandFather.policyTable = false;
                      greatGrandFather.coverageTable = false;
                      greatGrandFather.coverageModal = false;
                      greatGrandFather.sinisterTable = false;
                      greatGrandFather.endorsementTable = false;
                      greatGrandFather.config_renovaciones = {
                        count: response.data.count,
                        next: response.data.next,
                        previous: response.data.previous,
                      };
                      greatGrandFather.show_paginationRenewals = true;
                      greatGrandFather.show_renovaciones_pagination = true;
                      break;
                    case "sinister":
                      greatGrandFather.sinisters = response.data.results;
                      greatGrandFather.sinisterTable = true;
                      greatGrandFather.notas = false;
                      greatGrandFather.renewalTable = false;
                      greatGrandFather.policyTable = false;
                      greatGrandFather.coverageTable = false;
                      greatGrandFather.coverageModal = false;
                      greatGrandFather.endorsementTable = false;
                      greatGrandFather.titleID = titleID;
                      greatGrandFather.title = title;
                      greatGrandFather.config_sinisters = {
                        count: response.data.count,
                        next: response.data.next,
                        previous: response.data.previous,
                      };
                      greatGrandFather.show_sinisters_pagination = true;
                      break;
                    default:
                      console.log(
                        "vvvvvvvvvv",
                        $localStorage["graficas_recibos_url"]
                      );
                  }
                } else {
                  scope.data = response.data;
                }
                if (scope.gtype == "ot") {
                  var order = 1;
                  var asc = 1;
                  greatGrandFather.vida = false;
                  httpCallEndo(
                    "graficas-endosos/",
                    parType,
                    titleID,
                    title,
                    order,
                    asc
                  );
                }
              } else {
                console.log("Error en graphic", response.data);
              }
            },
            function error(response) {
              console.log("ERROR", response);
            }
          );
        }
        greatGrandFather.changePolicyDash = changePolicyDash;
        function changePolicyDash(par, asc) {
          greatGrandFather.ots = true;
          greatGrandFather.vida = false;
          greatGrandFather.gastos = false;
          greatGrandFather.d = false;
          switch (par) {
            case 1:
              scope.gtype = "ot";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.policy_type_asc = asc;
              greatGrandFather.policy_folio_asc = 0;
              greatGrandFather.policy_fint_asc = 0;
              greatGrandFather.policy_cont_asc = 0;
              greatGrandFather.policy_subr_asc = 0;
              greatGrandFather.policy_aseg_asc = 0;
              greatGrandFather.policy_fcre_asc = 0;
              break;
            case 2:
              scope.gtype = "ot";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.policy_folio_asc = asc;
              greatGrandFather.policy_type_asc = 0;
              greatGrandFather.policy_fint_asc = 0;
              greatGrandFather.policy_cont_asc = 0;
              greatGrandFather.policy_subr_asc = 0;
              greatGrandFather.policy_aseg_asc = 0;
              greatGrandFather.policy_fcre_asc = 0;
              break;
            case 3:
              scope.gtype = "ot";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.policy_fint_asc = asc;
              greatGrandFather.policy_type_asc = 0;
              greatGrandFather.policy_folio_asc = 0;
              greatGrandFather.policy_cont_asc = 0;
              greatGrandFather.policy_subr_asc = 0;
              greatGrandFather.policy_aseg_asc = 0;
              greatGrandFather.policy_fcre_asc = 0;
              break;
            case 4:
              scope.gtype = "ot";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.policy_cont_asc = asc;
              greatGrandFather.policy_folio_asc = 0;
              greatGrandFather.policy_type_asc = 0;
              greatGrandFather.policy_fint_asc = 0;
              greatGrandFather.policy_subr_asc = 0;
              greatGrandFather.policy_aseg_asc = 0;
              greatGrandFather.policy_fcre_asc = 0;
              break;
            case 5:
              scope.gtype = "ot";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.policy_subr_asc = asc;
              greatGrandFather.policy_type_asc = 0;
              greatGrandFather.policy_folio_asc = 0;
              greatGrandFather.policy_fint_asc = 0;
              greatGrandFather.policy_cont_asc = 0;
              greatGrandFather.policy_aseg_asc = 0;
              greatGrandFather.policy_fcre_asc = 0;
            case 6:
              scope.gtype = "ot";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.policy_aseg_asc = asc;
              greatGrandFather.policy_type_asc = 0;
              greatGrandFather.policy_folio_asc = 0;
              greatGrandFather.policy_fint_asc = 0;
              greatGrandFather.policy_cont_asc = 0;
              greatGrandFather.policy_subr_asc = 0;
              greatGrandFather.policy_fcre_asc = 0;
              break;
            case 7:
              scope.gtype = "ot";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.policy_type_asc = 0;
              greatGrandFather.policy_folio_asc = 0;
              greatGrandFather.policy_fint_asc = 0;
              greatGrandFather.policy_cont_asc = 0;
              greatGrandFather.policy_subr_asc = 0;
              greatGrandFather.policy_aseg_asc = 0;
              greatGrandFather.policy_fcre_asc = asc;
              break;
          }
        }
        greatGrandFather.showEndV = false;
        greatGrandFather.changeEndDashV = changeEndDashV;
        function changeEndDashV(par, asc) {
          greatGrandFather.vida = true;
          greatGrandFather.gastos = false;
          greatGrandFather.d = false;
          greatGrandFather.ots = false;
          switch (par) {
            case 1:
              scope.gtype = "ot";
              httpCallEndo(
                "graficas-endosos/",
                greatGrandFather.color,
                greatGrandFather.titleID,
                greatGrandFather.title,
                par,
                asc
              );
              greatGrandFather.vida_type_asc = asc;
              greatGrandFather.vida_cont_asc = 0;
              greatGrandFather.vida_nump_asc = 0;
              greatGrandFather.vida_aseg_asc = 0;
              greatGrandFather.vida_creac_asc = 0;
              break;
            case 2:
              scope.gtype = "ot";
              httpCallEndo(
                "graficas-endosos/",
                greatGrandFather.color,
                greatGrandFather.titleID,
                greatGrandFather.title,
                par,
                asc
              );
              greatGrandFather.vida_cont_asc = asc;
              greatGrandFather.vida_type_asc = 0;
              greatGrandFather.vida_nump_asc = 0;
              greatGrandFather.vida_aseg_asc = 0;
              greatGrandFather.vida_creac_asc = 0;
              break;
            case 3:
              scope.gtype = "ot";
              httpCallEndo(
                "graficas-endosos/",
                greatGrandFather.color,
                greatGrandFather.titleID,
                greatGrandFather.title,
                par,
                asc
              );
              greatGrandFather.vida_nump_asc = asc;
              greatGrandFather.vida_type_asc = 0;
              greatGrandFather.vida_cont_asc = 0;
              greatGrandFather.vida_aseg_asc = 0;
              greatGrandFather.vida_creac_asc = 0;
              break;
            case 4:
              scope.gtype = "ot";
              httpCallEndo(
                "graficas-endosos/",
                greatGrandFather.color,
                greatGrandFather.titleID,
                greatGrandFather.title,
                par,
                asc
              );
              greatGrandFather.vida_aseg_asc = asc;
              greatGrandFather.vida_cont_asc = 0;
              greatGrandFather.vida_type_asc = 0;
              greatGrandFather.vida_nump_asc = 0;
              greatGrandFather.vida_creac_asc = 0;
              break;
            case 5:
              scope.gtype = "ot";
              httpCallEndo(
                "graficas-endosos/",
                greatGrandFather.color,
                greatGrandFather.titleID,
                greatGrandFather.title,
                par,
                asc
              );
              greatGrandFather.vida_creac_asc = asc;
              greatGrandFather.vida_type_asc = 0;
              greatGrandFather.vida_cont_asc = 0;
              greatGrandFather.vida_nump_asc = 0;
              greatGrandFather.vida_aseg_asc = 0;
              break;
          }
        }

        greatGrandFather.changeReceipt = changeReceipt;
        greatGrandFather.show_cobranza = false;
        function changeReceipt(par, asc) {
          switch (par) {
            case 1:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.receipt_num_asc = asc;
              greatGrandFather.receipt_cont_asc = 0;
              greatGrandFather.receipt_nump_asc = 0;
              greatGrandFather.receipt_vig_asc = 0;
              greatGrandFather.receipt_subr_asc = 0;
              greatGrandFather.receipt_aseg_asc = 0;
              greatGrandFather.receipt_venc_asc = 0;
              greatGrandFather.receipt_pneta = 0;

              break;
            case 2:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.receipt_cont_asc = asc;
              greatGrandFather.receipt_num_asc = 0;
              greatGrandFather.receipt_nump_asc = 0;
              greatGrandFather.receipt_vig_asc = 0;
              greatGrandFather.receipt_subr_asc = 0;
              greatGrandFather.receipt_aseg_asc = 0;
              greatGrandFather.receipt_venc_asc = 0;
              greatGrandFather.receipt_pneta = 0;
              break;
            case 3:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.receipt_nump_asc = asc;
              greatGrandFather.receipt_num_asc = 0;
              greatGrandFather.receipt_cont_asc = 0;
              greatGrandFather.receipt_vig_asc = 0;
              greatGrandFather.receipt_subr_asc = 0;
              greatGrandFather.receipt_aseg_asc = 0;
              greatGrandFather.receipt_venc_asc = 0;
              greatGrandFather.receipt_pneta = 0;
              break;
            case 4:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.receipt_vig_asc = asc;
              greatGrandFather.receipt_cont_asc = 0;
              greatGrandFather.receipt_num_asc = 0;
              greatGrandFather.receipt_nump_asc = 0;
              greatGrandFather.receipt_subr_asc = 0;
              greatGrandFather.receipt_aseg_asc = 0;
              greatGrandFather.receipt_venc_asc = 0;
              greatGrandFather.receipt_pneta = 0;
              break;
            case 5:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.receipt_subr_asc = asc;
              greatGrandFather.receipt_num_asc = 0;
              greatGrandFather.receipt_cont_asc = 0;
              greatGrandFather.receipt_nump_asc = 0;
              greatGrandFather.receipt_vig_asc = 0;
              greatGrandFather.receipt_aseg_asc = 0;
              greatGrandFather.receipt_venc_asc = 0;
              greatGrandFather.receipt_pneta = 0;
              break;
            case 6:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.receipt_subr_asc = 0;
              greatGrandFather.receipt_num_asc = 0;
              greatGrandFather.receipt_cont_asc = 0;
              greatGrandFather.receipt_nump_asc = 0;
              greatGrandFather.receipt_vig_asc = 0;
              greatGrandFather.receipt_aseg_asc = asc;
              greatGrandFather.receipt_venc_asc = 0;
              greatGrandFather.receipt_pneta = 0;
              break;
            case 7:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.receipt_subr_asc = 0;
              greatGrandFather.receipt_num_asc = 0;
              greatGrandFather.receipt_cont_asc = 0;
              greatGrandFather.receipt_nump_asc = 0;
              greatGrandFather.receipt_vig_asc = 0;
              greatGrandFather.receipt_aseg_asc = 0;
              greatGrandFather.receipt_venc_asc = asc;
              greatGrandFather.receipt_pneta = 0;
              break;
            case 8:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.receipt_subr_asc = 0;
              greatGrandFather.receipt_num_asc = 0;
              greatGrandFather.receipt_cont_asc = 0;
              greatGrandFather.receipt_nump_asc = 0;
              greatGrandFather.receipt_vig_asc = 0;
              greatGrandFather.receipt_aseg_asc = 0;
              greatGrandFather.receipt_venc_asc = 0;
              greatGrandFather.receipt_pneta = asc;
              break;
          }
        }

        greatGrandFather.changeNCr = changeNCr;
        greatGrandFather.show_nota = false;
        function changeNCr(par, asc) {
          switch (par) {
            case 1:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.nota_cont_asc = asc;
              greatGrandFather.nota_folio_asc = 0;
              greatGrandFather.nota_numend_asc = 0;
              greatGrandFather.nota_numpol_asc = 0;
              greatGrandFather.nota_fecha_asc = 0;
              greatGrandFather.nota_ptotal_asc = 0;
              greatGrandFather.nota_pago_asc = 0;
              greatGrandFather.nota_moneda_asc = 0;
              break;
            case 2:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.nota_folio_asc = asc;
              greatGrandFather.nota_cont_asc = 0;
              greatGrandFather.nota_numend_asc = 0;
              greatGrandFather.nota_numpol_asc = 0;
              greatGrandFather.nota_fecha_asc = 0;
              greatGrandFather.nota_ptotal_asc = 0;
              greatGrandFather.nota_pago_asc = 0;
              greatGrandFather.nota_moneda_asc = 0;
              break;
            case 3:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.nota_numend_asc = asc;
              greatGrandFather.nota_cont_asc = 0;
              greatGrandFather.nota_folio_asc = 0;
              greatGrandFather.nota_numpol_asc = 0;
              greatGrandFather.nota_fecha_asc = 0;
              greatGrandFather.nota_ptotal_asc = 0;
              greatGrandFather.nota_pago_asc = 0;
              greatGrandFather.nota_moneda_asc = 0;
              break;
            case 4:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.nota_numpol_asc = asc;
              greatGrandFather.nota_folio_asc = 0;
              greatGrandFather.nota_cont_asc = 0;
              greatGrandFather.nota_numend_asc = 0;
              greatGrandFather.nota_fecha_asc = 0;
              greatGrandFather.nota_ptotal_asc = 0;
              greatGrandFather.nota_pago_asc = 0;
              greatGrandFather.nota_moneda_asc = 0;
              break;
            case 5:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.nota_fecha_asc = asc;
              greatGrandFather.nota_cont_asc = 0;
              greatGrandFather.nota_folio_asc = 0;
              greatGrandFather.nota_numend_asc = 0;
              greatGrandFather.nota_numpol_asc = 0;
              greatGrandFather.nota_ptotal_asc = 0;
              greatGrandFather.nota_pago_asc = 0;
              greatGrandFather.nota_moneda_asc = 0;
              break;
            case 6:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.nota_fecha_asc = 0;
              greatGrandFather.nota_cont_asc = 0;
              greatGrandFather.nota_folio_asc = 0;
              greatGrandFather.nota_numend_asc = 0;
              greatGrandFather.nota_numpol_asc = 0;
              greatGrandFather.nota_ptotal_asc = asc;
              greatGrandFather.nota_pago_asc = 0;
              greatGrandFather.nota_moneda_asc = 0;
              break;
            case 7:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.nota_fecha_asc = 0;
              greatGrandFather.nota_cont_asc = 0;
              greatGrandFather.nota_folio_asc = 0;
              greatGrandFather.nota_numend_asc = 0;
              greatGrandFather.nota_numpol_asc = 0;
              greatGrandFather.nota_ptotal_asc = 0;
              greatGrandFather.nota_pago_asc = asc;
              greatGrandFather.nota_moneda_asc = 0;
              break;
            case 8:
              scope.gtype = "receipts";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.nota_fecha_asc = 0;
              greatGrandFather.nota_cont_asc = 0;
              greatGrandFather.nota_folio_asc = 0;
              greatGrandFather.nota_numend_asc = 0;
              greatGrandFather.nota_numpol_asc = 0;
              greatGrandFather.nota_ptotal_asc = 0;
              greatGrandFather.nota_pago_asc = 0;
              greatGrandFather.nota_moneda_asc = asc;
              break;
          }
        }
        greatGrandFather.show_renewal = false;
        greatGrandFather.changeRen = changeRen;
        function changeRen(par, asc) {
          greatGrandFather.show_renewal = false;
          switch (par) {
            case 1:
              scope.gtype = "renewals";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.ren_nump_asc = asc;
              greatGrandFather.ren_cont_asc = 0;
              greatGrandFather.ren_subr_asc = 0;
              greatGrandFather.ren_aseg_asc = 0;
              greatGrandFather.ren_vig_asc = 0;
              break;
            case 2:
              scope.gtype = "renewals";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.ren_cont_asc = asc;
              greatGrandFather.ren_nump_asc = 0;
              greatGrandFather.ren_subr_asc = 0;
              greatGrandFather.ren_aseg_asc = 0;
              greatGrandFather.ren_vig_asc = 0;
              break;
            case 3:
              scope.gtype = "renewals";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.ren_subr_asc = asc;
              greatGrandFather.ren_nump_asc = 0;
              greatGrandFather.ren_cont_asc = 0;
              greatGrandFather.ren_aseg_asc = 0;
              greatGrandFather.ren_vig_asc = 0;
              break;
            case 4:
              scope.gtype = "renewals";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.ren_aseg_asc = asc;
              greatGrandFather.ren_cont_asc = 0;
              greatGrandFather.ren_nump_asc = 0;
              greatGrandFather.ren_subr_asc = 0;
              greatGrandFather.ren_vig_asc = 0;
              break;
            case 5:
              scope.gtype = "renewals";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.ren_vig_asc = asc;
              greatGrandFather.ren_nump_asc = 0;
              greatGrandFather.ren_cont_asc = 0;
              greatGrandFather.ren_subr_asc = 0;
              greatGrandFather.ren_aseg_asc = 0;
              break;
          }
        }
        greatGrandFather.show_sinister = false;
        greatGrandFather.changeSin = changeSin;
        function changeSin(par, asc) {
          greatGrandFather.show_sinister = false;
          switch (par) {
            case 1:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_afec_asc = asc;
              greatGrandFather.sin_cont_asc = 0;
              greatGrandFather.sin_aseg_asc = 0;
              greatGrandFather.sin_nump_asc = 0;
              greatGrandFather.sin_nums_asc = 0;
              greatGrandFather.sin_subr_asc = 0;
              greatGrandFather.sin_fecha_asc = 0;
              greatGrandFather.sin_status_asc = 0;
              greatGrandFather.sin_reclamado_asc = 0;
              greatGrandFather.sin_tipopad_asc = 0;
              greatGrandFather.sin_ingreso_asc = 0;
              greatGrandFather.sin_compromiso_asc = 0;
              break;
            case 2:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_cont_asc = asc;
              greatGrandFather.sin_afec_asc = 0;
              greatGrandFather.sin_aseg_asc = 0;
              greatGrandFather.sin_nump_asc = 0;
              greatGrandFather.sin_nums_asc = 0;
              greatGrandFather.sin_subr_asc = 0;
              greatGrandFather.sin_fecha_asc = 0;
              greatGrandFather.sin_status_asc = 0;
              greatGrandFather.sin_reclamado_asc = 0;
              greatGrandFather.sin_tipopad_asc = 0;
              greatGrandFather.sin_ingreso_asc = 0;
              greatGrandFather.sin_compromiso_asc = 0;
              break;
            case 3:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_aseg_asc = asc;
              greatGrandFather.sin_afec_asc = 0;
              greatGrandFather.sin_cont_asc = 0;
              greatGrandFather.sin_nump_asc = 0;
              greatGrandFather.sin_nums_asc = 0;
              greatGrandFather.sin_subr_asc = 0;
              greatGrandFather.sin_fecha_asc = 0;
              greatGrandFather.sin_status_asc = 0;
              greatGrandFather.sin_reclamado_asc = 0;
              greatGrandFather.sin_tipopad_asc = 0;
              greatGrandFather.sin_ingreso_asc = 0;
              greatGrandFather.sin_compromiso_asc = 0;
              break;
            case 4:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_nump_asc = asc;
              greatGrandFather.sin_cont_asc = 0;
              greatGrandFather.sin_afec_asc = 0;
              greatGrandFather.sin_aseg_asc = 0;
              greatGrandFather.sin_nums_asc = 0;
              greatGrandFather.sin_subr_asc = 0;
              greatGrandFather.sin_fecha_asc = 0;
              greatGrandFather.sin_status_asc = 0;
              greatGrandFather.sin_reclamado_asc = 0;
              greatGrandFather.sin_tipopad_asc = 0;
              greatGrandFather.sin_ingreso_asc = 0;
              greatGrandFather.sin_compromiso_asc = 0;
              break;
            case 5:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_nums_asc = asc;
              greatGrandFather.sin_afec_asc = 0;
              greatGrandFather.sin_cont_asc = 0;
              greatGrandFather.sin_aseg_asc = 0;
              greatGrandFather.sin_nump_asc = 0;
              greatGrandFather.sin_subr_asc = 0;
              greatGrandFather.sin_fecha_asc = 0;
              greatGrandFather.sin_status_asc = 0;
              greatGrandFather.sin_reclamado_asc = 0;
              greatGrandFather.sin_tipopad_asc = 0;
              greatGrandFather.sin_ingreso_asc = 0;
              greatGrandFather.sin_compromiso_asc = 0;
              break;
            case 6:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_nums_asc = 0;
              greatGrandFather.sin_afec_asc = 0;
              greatGrandFather.sin_cont_asc = 0;
              greatGrandFather.sin_aseg_asc = 0;
              greatGrandFather.sin_nump_asc = 0;
              greatGrandFather.sin_subr_asc = asc;
              greatGrandFather.sin_fecha_asc = 0;
              greatGrandFather.sin_status_asc = 0;
              greatGrandFather.sin_reclamado_asc = 0;
              greatGrandFather.sin_tipopad_asc = 0;
              greatGrandFather.sin_ingreso_asc = 0;
              greatGrandFather.sin_compromiso_asc = 0;
              break;
            case 7:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_nums_asc = 0;
              greatGrandFather.sin_afec_asc = 0;
              greatGrandFather.sin_cont_asc = 0;
              greatGrandFather.sin_aseg_asc = 0;
              greatGrandFather.sin_nump_asc = 0;
              greatGrandFather.sin_subr_asc = 0;
              greatGrandFather.sin_fecha_asc = asc;
              greatGrandFather.sin_status_asc = 0;
              greatGrandFather.sin_reclamado_asc = 0;
              greatGrandFather.sin_tipopad_asc = 0;
              greatGrandFather.sin_ingreso_asc = 0;
              greatGrandFather.sin_compromiso_asc = 0;
              break;
            case 9:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_nums_asc = 0;
              greatGrandFather.sin_afec_asc = 0;
              greatGrandFather.sin_cont_asc = 0;
              greatGrandFather.sin_aseg_asc = 0;
              greatGrandFather.sin_nump_asc = 0;
              greatGrandFather.sin_subr_asc = 0;
              greatGrandFather.sin_fecha_asc = 0;
              greatGrandFather.sin_status_asc = asc;
              greatGrandFather.sin_reclamado_asc = 0;
              greatGrandFather.sin_tipopad_asc = 0;
              greatGrandFather.sin_ingreso_asc = 0;
              greatGrandFather.sin_compromiso_asc = 0;
              break;
            case 10:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_nums_asc = 0;
              greatGrandFather.sin_afec_asc = 0;
              greatGrandFather.sin_cont_asc = 0;
              greatGrandFather.sin_aseg_asc = 0;
              greatGrandFather.sin_nump_asc = 0;
              greatGrandFather.sin_subr_asc = 0;
              greatGrandFather.sin_fecha_asc = 0;
              greatGrandFather.sin_status_asc = 0;
              greatGrandFather.sin_reclamado_asc = asc;
              greatGrandFather.sin_tipopad_asc = 0;
              greatGrandFather.sin_ingreso_asc = 0;
              greatGrandFather.sin_compromiso_asc = 0;
              break;
            case 11:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_nums_asc = 0;
              greatGrandFather.sin_afec_asc = 0;
              greatGrandFather.sin_cont_asc = 0;
              greatGrandFather.sin_aseg_asc = 0;
              greatGrandFather.sin_nump_asc = 0;
              greatGrandFather.sin_subr_asc = 0;
              greatGrandFather.sin_fecha_asc = 0;
              greatGrandFather.sin_status_asc = 0;
              greatGrandFather.sin_reclamado_asc = 0;
              greatGrandFather.sin_tipopad_asc = asc;
              greatGrandFather.sin_ingreso_asc = 0;
              greatGrandFather.sin_compromiso_asc = 0;
              break;
            case 12:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_nums_asc = 0;
              greatGrandFather.sin_afec_asc = 0;
              greatGrandFather.sin_cont_asc = 0;
              greatGrandFather.sin_aseg_asc = 0;
              greatGrandFather.sin_nump_asc = 0;
              greatGrandFather.sin_subr_asc = 0;
              greatGrandFather.sin_fecha_asc = 0;
              greatGrandFather.sin_status_asc = 0;
              greatGrandFather.sin_reclamado_asc = 0;
              greatGrandFather.sin_tipopad_asc = 0;
              greatGrandFather.sin_ingreso_asc = asc;
              greatGrandFather.sin_compromiso_asc = 0;
              break;
            case 13:
              scope.gtype = "sinister";
              scope.getItems(greatGrandFather.color, par, asc);
              greatGrandFather.sin_nums_asc = 0;
              greatGrandFather.sin_afec_asc = 0;
              greatGrandFather.sin_cont_asc = 0;
              greatGrandFather.sin_aseg_asc = 0;
              greatGrandFather.sin_nump_asc = 0;
              greatGrandFather.sin_subr_asc = 0;
              greatGrandFather.sin_fecha_asc = 0;
              greatGrandFather.sin_status_asc = 0;
              greatGrandFather.sin_reclamado_asc = 0;
              greatGrandFather.sin_tipopad_asc = 0;
              greatGrandFather.sin_ingreso_asc = 0;
              greatGrandFather.sin_compromiso_asc = asc;
              break;
          }
        }

        scope.getItems = function (parType, order, asc) {
          greatGrandFather.cadena = "";
          scope.lc = parType ? parType : "";
          greatGrandFather.last_color = scope.lc;
          var myDiv = $("html, body");
          var scrollto = myDiv.offset().top + myDiv.height() / 2;
          myDiv.animate({ scrollTop: scrollto });

          greatGrandFather.cadena = "";
          greatGrandFather.serie = "";

          greatGrandFather.btn_all = false;
          greatGrandFather.show_cobranza = false;
          greatGrandFather.show_renewal = false;
          greatGrandFather.show_sinister = false;
          greatGrandFather.color = parType;
          greatGrandFather.show_binnacle = false;
          greatGrandFather.show_binnacle_receipt = false;
          greatGrandFather.show_binnacle_renewal = false;

          switch (scope.gtype) {
            case "ot":
              greatGrandFather.autos = false;
              greatGrandFather.gastos = false;
              greatGrandFather.vida = false;
              greatGrandFather.d = false;
              if (parType == "green") {
                var titleID = 1;
                var title = "En tiempo";
              } else if (parType == "yellow") {
                var titleID = 2;
                var title = "Se acerca su vencimiento"; //"Fuera de tiempo"
              } else if (parType == "orange") {
                var titleID = 3;
                var title = "Con atraso importante";
              } else if (parType == "red") {
                var titleID = 4;
                var title = "Atención urgente";
              }
              httpCall(
                "graficas-polizas/",
                parType,
                titleID,
                title,
                order,
                asc
              );

              greatGrandFather.exportData = exportData;
              function exportData(param) {
                greatGrandFather.btn_all = false;
                if (param == 1) {
                  $http({
                    method: "GET",
                    url: url.IP + "excel-graficas-polizas/",
                    params: {
                      tipo: parType,
                      order: order,
                      asc: asc,
                    },
                    headers: {
                      "Content-Type":
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    },
                    responseType: "arraybuffer",
                  }).then(function success(data) {
                    if (data.status == 200) {
                      var blob = new Blob([data.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      saveAs(blob, "Reporte_Dash_OTs.xls");
                    } else {
                      SweetAlert.swal(
                        "Error",
                        "Ha ocurrido un error al descargar el reporte",
                        "error"
                      );
                    }
                  });
                } else if (param == 2) {
                  $http({
                    method: "GET",
                    url: url.IP + "excel-graficas-endosos/",
                    params: {
                      tipo: parType,
                      order: order,
                      asc: asc,
                    },
                    headers: {
                      "Content-Type":
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    },
                    responseType: "arraybuffer",
                  }).then(function success(data) {
                    if (data.status == 200) {
                      var blob = new Blob([data.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      saveAs(blob, "Reporte_Endosos_Dash.xls");
                    } else {
                      SweetAlert.swal(
                        "Error",
                        "Ha ocurrido un error al descargar el reporte",
                        "error"
                      );
                    }
                  });
                }
              }
              break;
            case "receipts":
              if (parType == "green") {
                var titleID = 1;
                var title = "En tiempo";
                httpCall(
                  "graficas-recibos/",
                  parType,
                  titleID,
                  title,
                  order,
                  asc
                );
              } else if (parType == "yellow") {
                var titleID = 2;
                var title = "Se acerca su vencimiento"; //"Fuera de tiempo"
                httpCall(
                  "graficas-recibos/",
                  parType,
                  titleID,
                  title,
                  order,
                  asc
                );
              } else if (parType == "orange") {
                var titleID = 3;
                var title = "Gestionar cobranza urgente";
                httpCall(
                  "graficas-recibos/",
                  parType,
                  titleID,
                  title,
                  order,
                  asc
                );
              } else if (parType == "red") {
                var titleID = 4;
                var title = "Recibos vencidos";
                httpCall(
                  "graficas-recibos/",
                  parType,
                  titleID,
                  title,
                  order,
                  asc
                );
              } else if (parType == "blue") {
                var titleID = 5;
                var title = "Notas de crédito";
                httpCall("get-notas/", parType, titleID, title, order, asc);
              }

              $localStorage.order_rec = order;
              $localStorage.asc_rec = asc;
              $localStorage.type_rec = parType;
              greatGrandFather.exportDataReceipts = exportDataReceipts;
              greatGrandFather.exportDataReceiptsAll = exportDataReceiptsAll;
              function exportDataReceiptsAll(param) {
                var lrc = Ladda.create(
                  document.querySelector(".ladda-button3")
                );
                lrc.start();
                parType = "all";
                if (greatGrandFather.cadena) {
                  var params = {
                    tipo: parType,
                    order: order,
                    asc: asc,
                    cadena: greatGrandFather.cadena,
                    serie: greatGrandFather.serie
                      ? greatGrandFather.serie
                      : null,
                  };
                } else {
                  var params = {
                    tipo: parType,
                    order: order,
                    asc: asc,
                    serie: greatGrandFather.serie
                      ? greatGrandFather.serie
                      : null,
                    cadena: greatGrandFather.cadena
                      ? greatGrandFather.cadena
                      : null,
                  };
                }
                greatGrandFather.show_cobranza = false;
                if (param == 2) {
                  var excel_receipt_all = "service_reporte-recibosDash-excel";
                  $http({
                    method: "GET",
                    url: url.IP + excel_receipt_all,
                    params: params,
                    headers: {
                      "Content-Type":
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    },
                    responseType: "arraybuffer",
                  }).then(function success(response) {
                    if (response.status === 200 || response.status === 201) {
                      lrc.stop();
                      var blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      saveAs(blob, "Reporte_Cobranza.xls");
                    } else {
                      lrc.stop();
                    }
                  });
                }
              }
              function exportDataReceipts(param) {
                var lrc = Ladda.create(
                  document.querySelector(".ladda-button3")
                );
                lrc.start();
                greatGrandFather.show_cobranza = false;
                if (greatGrandFather.cadena) {
                  var params = {
                    tipo: parType,
                    order: order,
                    asc: asc,
                    cadena: greatGrandFather.cadena,
                    serie: greatGrandFather.serie
                      ? greatGrandFather.serie
                      : null,
                  };
                } else {
                  var params = {
                    tipo: parType,
                    order: order,
                    asc: asc,
                    serie: greatGrandFather.serie
                      ? greatGrandFather.serie
                      : null,
                    cadena: greatGrandFather.cadena
                      ? greatGrandFather.cadena
                      : null,
                  };
                }
                if (param == 2) {
                  var excel_receipt = "service_reporte-recibosDash-excel";
                  $http({
                    method: "GET",
                    url: url.IP + excel_receipt,
                    params: params,
                    headers: {
                      "Content-Type":
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    },
                    responseType: "arraybuffer",
                  }).then(function success(response) {
                    if (response.status === 200 || response.status === 201) {
                      lrc.stop();
                      var blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      saveAs(blob, "Reporte_Cobranza.xls");
                    } else {
                      lrc.stop();
                    }
                  });
                }
                if (param == 5) {
                  $http({
                    method: "GET",
                    url: url.IP + "excel-graficas-notas/",
                    params: {
                      polizaId: scope.polizaId.polizaId,
                      order: order,
                      asc: asc,
                    },
                  }).then(function success(response) {
                    if (response.status === 200 || response.status === 201) {
                      exportFactory.excel(response.data, "Notas_Crédito");
                    }
                  });
                }
              }
              break;
            case "renewals":
              if (parType == "green") {
                var titleID = 1;
                var title = "En tiempo";
              } else if (parType == "yellow") {
                var titleID = 2;
                var title = "Se acerca su vencimiento"; //"Fuera de tiempo2"
              } else if (parType == "orange") {
                var titleID = 3;
                var title = "Con atraso importante";
              } else if (parType == "red") {
                var titleID = 4;
                var title = "Polizas vencidas";
              }
              httpCall(
                "graficas-renovaciones/",
                parType,
                titleID,
                title,
                order,
                asc
              );
              greatGrandFather.exportDataRenewal = exportDataRenewal;
              function exportDataRenewal(param) {
                var lr = Ladda.create(document.querySelector(".ladda-button2"));
                lr.start();
                if (greatGrandFather.cadena) {
                  var params = {
                    tipo: parType,
                    order: order,
                    asc: asc,
                    cadena: greatGrandFather.cadena,
                  };
                } else {
                  var params = {
                    tipo: parType,
                    order: order,
                    asc: asc,
                  };
                }
                if (param == 3) {
                  var excel_renewal = "service_reporte-renovacionesDash-excel";
                  $http({
                    method: "GET",
                    url: url.IP + excel_renewal,
                    params: params,
                    headers: {
                      "Content-Type":
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    },
                    responseType: "arraybuffer",
                  }).then(function success(data) {
                    if (data.status == 200) {
                      lr.stop();
                      var blob = new Blob([data.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      saveAs(blob, "Reporte_Renovaciones_Dash.xls");
                    } else {
                      lr.start();
                      SweetAlert.swal(
                        "Error",
                        "Ha ocurrido un error al descargar el reporte",
                        "error"
                      );
                    }
                  });
                }
              }
              break;
            case "sinister":
              if (parType == "green") {
                var titleID = 1;
                var title = "En tiempo";
              } else if (parType == "yellow") {
                var titleID = 2;
                var title = "Se acerca su vencimiento"; //"Fuera de tiempo3"
              } else if (parType == "orange") {
                var titleID = 3;
                var title = "Con atraso importante";
              } else if (parType == "red") {
                var titleID = 4;
                var title = "Atención urgente";
              }
              httpCall(
                "graficas-siniestros/",
                parType,
                titleID,
                title,
                order,
                asc
              );
              greatGrandFather.exportDataSinister = exportDataSinister;
              function exportDataSinister(param) {
                var l = Ladda.create(document.querySelector(".ladda-button"));
                l.start();
                if (greatGrandFather.cadena) {
                  var params = {
                    order: order,
                    asc: asc,
                    tipo: parType,
                    cadena: greatGrandFather.cadena,
                  };
                } else {
                  var params = {
                    order: order,
                    asc: asc,
                    tipo: parType,
                  };
                }
                if (param == 4) {
                  var excel_sinister = "service_reporte-siniestrosDash-excel";
                  $http({
                    method: "GET",
                    url: url.IP + excel_sinister,
                    params: params,
                    headers: {
                      "Content-Type":
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    },
                    responseType: "arraybuffer",
                  }).then(function success(data) {
                    if (data.status == 200) {
                      l.stop();
                      var blob = new Blob([data.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      saveAs(blob, "Reporte_Siniestros_Dash.xls");
                    } else {
                      l.stop();
                      SweetAlert.swal(
                        "Error",
                        "Ha ocurrido un error al descargar el reporte",
                        "error"
                      );
                    }
                  });
                } else {
                  l.stop();
                }
              }
            default:
          }
        };
      },
    };
  },
]);

var app = angular
  .module("inspinia")

  .directive("formatCurrency", [
    "$filter",
    function ($filter) {
      return {
        require: "?ngModel",
        link: function (scope, elem, attrs, ctrl) {
          if (!ctrl) return;

          ctrl.$formatters.unshift(function (a) {
            if (ctrl.$modelValue) {
              if (
                ctrl.$modelValue.toString().search(/[A-Za-z]/g) > -1 ||
                ctrl.$modelValue.search(/[0-9]%/g) > -1
              ) {
                return ctrl.$modelValue;
              } else {
                var x = $filter("currency")(ctrl.$modelValue);

                if (isNaN(ctrl.$modelValue)) {
                  return ctrl.$modelValue;
                } else {
                  return x;
                }
              }
            }
          });

          elem.bind("blur", function (event) {
            var num = elem.val();

            if (
              num.search(/[A-Za-z]/g) > -1 ||
              ctrl.$modelValue.search(/[0-9]%/g) > -1
            ) {
              elem.val(ctrl.$modelValue);
            } else {
              var plainNumber = elem.val().replace(/[^\d|\-+|\.+]/g, "");
              elem.val($filter("currency")(plainNumber));
            }
          });
        },
      };
    },
  ])

  .directive("currencyFormat", [
    "$filter",
    function ($filter) {
      return {
        require: "?ngModel",
        link: function (scope, elem, attrs, ctrl) {
          if (!ctrl) return;

          ctrl.$formatters.unshift(function (a) {
            if (ctrl.$modelValue) {
              if (
                ctrl.$modelValue.toString().search(/[A-Za-z]/g) > -1 ||
                ctrl.$modelValue.search(/[0-9]%/g) > -1
              ) {
                return ctrl.$modelValue;
              } else {
                var x = $filter("currency")(ctrl.$modelValue);

                if (isNaN(ctrl.$modelValue)) {
                  return ctrl.$modelValue;
                } else {
                  return x;
                }
              }
            }
          });

          elem.bind("keydown", function (event) {
            console.log("ok", elem.val());

            var num = elem.val();

            if (
              num.search(/[A-Za-z]/g) > -1 ||
              ctrl.$modelValue.search(/[0-9]%/g) > -1
            ) {
              elem.val(ctrl.$modelValue);
            } else {
              var plainNumber = elem.val().replace(/[^\d|\-+|\.+]/g, "");
              elem.val($filter("currency")(plainNumber));
            }
          });
        },
      };
    },
  ])
  .directive("formatReceipt", [
    "$filter",
    function ($filter) {
      return {
        require: "?ngModel",
        link: function (scope, elem, attrs, ctrl) {
          if (!ctrl) return;

          console.log("attrs", attrs);

          ctrl.$formatters.unshift(function (a) {
            // return $filter('currency')(ctrl.$modelValue);
            elem.val($filter("currency")(ctrl.$modelValue));
          });

          // console.log('ctrl', ctrl);
          $(elem).change(function (event) {
            console.log("oki");
            var plainNumber = elem.val().replace(/[^\d|\-+|\.+]/g, "");
            elem.val($filter("currency")(plainNumber));
          });

          // elem.bind('keydown keyup', function(event) {

          //     console.log('asdadfad------', elem.val());

          //     var plainNumber = elem.val().replace(/[^\d|\-+|\.+]/g, '');
          //     elem.val($filter('currency')(plainNumber));
          // });
        },
      };
    },
  ])

  .directive("format_currency_respaldo", [
    "$filter",
    function ($filter) {
      return {
        require: "?ngModel",
        link: function (scope, elem, attrs, ctrl) {
          if (!ctrl) return;

          ctrl.$formatters.unshift(function (a) {
            return $filter(attrs.format)(ctrl.$modelValue);
          });

          elem.bind("blur", function (event) {
            console.log("asdadfad------", elem.val());

            var plainNumber = elem.val().replace(/[^\d|\-+|\.+]/g, "");
            elem.val($filter(attrs.format)(plainNumber));
          });
        },
      };
    },
  ])

  .directive("inputCurrency", [
    function () {
      return {
        restrict: "EA",
        scope: {
          model: "=",
          ngdisabled: "=",
          ngHide: "=",
          change: "&",
          blur: "&",
        },
        template:
          '<input ng-hide = "ngHide" ng-blur="blur()" ng-disabled = "ngdisabled" class="form-control" ng-model="model"  ng-change="onChange(model)" type="text" ng-keypress="validateFloatKeyPress($event)">',
        link: function (scope, element, attrs) {
          scope.validateFloatKeyPress = function (evt) {
            if (!isIntegerChar()) {
              evt.preventDefault();
            }

            function isIntegerChar() {
              return /[0-9]|(\.)/.test(String.fromCharCode(evt.which));
            }

            var value = scope.model;

            scope.onChange = function (param) {
              scope.change();
            };

            if (value) {
              var v = value.toString();
              var charCode = evt.which ? evt.which : event.keyCode;
              var number = v.split(".");
              var caratPos = number[0].length;
              if (number[1]) {
                var dotPos = number[1].length;
              }

              // if( caratPos > dotPos && dotPos>-1 && (number[1].length > 1)){
              //   console.log('ok');
              //     evt.preventDefault();
              // }

              if (dotPos) {
                if (dotPos == 2) {
                  if (caratPos) {
                    evt.preventDefault();
                  } else {
                    // console.log('ok');
                  }
                }
              }
            }
          };
          // scope.calculateInputs = function(poliza){
          //   console.log('poliza',poliza)
          // }
        }, // termina link
      }; // termina return
    },
  ]);

var app = angular.module("inspinia").directive("fileread", [
  function () {
    return {
      require: "ngModel",
      scope: {
        fileread: "=",
        ngModel: "=",
      },
      link: function (scope, element, attributes, ngModel) {
        $(element).on("change", function (changeEvent) {
          var files = changeEvent.target.files;

          if (files.length) {
            var r = new FileReader();
            r.onload = function (e) {
              var data = e.target.result;
              var cfb = XLS.CFB.read(data, { type: "binary" });
              var wb = XLS.parse_xlscfb(cfb);
              // Loop Over Each Sheet
              var data = {};
              wb.SheetNames.forEach(function (sheetName) {
                // Obtain The Current Row As CSV
                // console.log('hoja', sheetName);
                var sCSV = XLS.utils.make_csv(wb.Sheets[sheetName]);
                var oJS = XLS.utils.sheet_to_row_object_array(
                  wb.Sheets[sheetName]
                );
                // console.log(oJS);
                data[sheetName] = oJS;
                // console.log(scope.model);
              });
              //TODO: retornar data
              // console.log('data', data);
              ngModel.$setViewValue(data);
              ngModel.$render();
            };
            r.readAsBinaryString(files[0]);
          }
        });
      },
    };
  },
]);

angular.module("inspinia").directive("excelExport", [
  function () {
    return {
      restrict: "A",
      scope: {
        filename: "@",
        data: "=exportData",
      },
      replace: true,
      template:
        '<button class="btn btn-primary btn-ef btn-ef-3 btn-ef-3c mb-10" ng-click="download()">Export to Excel <i class="fa fa-download"></i></button>',
      link: function (scope, element) {
        // scope.download = function() {

        // console.log('XLSX', XLSX);

        // var data = scope.data;

        var wb = XLSX.utils.json_to_sheet(scope.data);

        var workbook = {
          SheetNames: ["Plough &amp; Stars"],
          Sheets: {
            "Plough &amp; Stars": wb,
            "!ref": wb["!ref"],
          },
        };

        var wbout = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        function s2ab(s) {
          console.log("s", s.length);
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);

          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
          console.log("buf", buf);
          return buf;
        }

        saveAs(
          new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
          "Reporte_" + scope.filename + ".xlsx"
        );

        // };
      },
    };
  },
]);

/*
 *
 * https://github.com/fatlinesofcode/ngDraggable
 */
angular
  .module("ngDraggable", [])
  .service("ngDraggable", [
    function () {
      var scope = this;
      scope.inputEvent = function (event) {
        if (angular.isDefined(event.touches)) {
          return event.touches[0];
        }
        //Checking both is not redundent. If only check if touches isDefined, angularjs isDefnied will return error and stop the remaining scripty if event.originalEvent is not defined.
        else if (
          angular.isDefined(event.originalEvent) &&
          angular.isDefined(event.originalEvent.touches)
        ) {
          return event.originalEvent.touches[0];
        }
        return event;
      };
    },
  ])
  .directive("ngDrag", [
    "$rootScope",
    "$parse",
    "$document",
    "$window",
    "ngDraggable",
    function ($rootScope, $parse, $document, $window, ngDraggable) {
      return {
        restrict: "A",
        link: function (scope, element, attrs) {
          scope.value = attrs.ngDrag;
          var offset,
            _centerAnchor = false,
            _mx,
            _my,
            _tx,
            _ty,
            _mrx,
            _mry;
          var _hasTouch =
            "ontouchstart" in window ||
            (window.DocumentTouch && document instanceof DocumentTouch);
          var _pressEvents = "touchstart mousedown";
          var _moveEvents = "touchmove mousemove";
          var _releaseEvents = "touchend mouseup";
          var _dragHandle;

          // to identify the element in order to prevent getting superflous events when a single element has both drag and drop directives on it.
          var _myid = scope.$id;
          var _data = null;

          var _dragOffset = null;

          var _dragEnabled = false;

          var _pressTimer = null;

          var onDragSuccessCallback = $parse(attrs.ngDragSuccess) || null;
          var allowTransform = angular.isDefined(attrs.allowTransform)
            ? scope.$eval(attrs.allowTransform)
            : true;

          var getDragData = $parse(attrs.ngDragData);

          // deregistration function for mouse move events in $rootScope triggered by jqLite trigger handler
          var _deregisterRootMoveListener = angular.noop;

          var initialize = function () {
            element.attr("draggable", "false"); // prevent native drag
            // check to see if drag handle(s) was specified
            // if querySelectorAll is available, we use this instead of find
            // as JQLite find is limited to tagnames
            if (element[0].querySelectorAll) {
              var dragHandles = angular.element(
                element[0].querySelectorAll("[ng-drag-handle]")
              );
            } else {
              var dragHandles = element.find("[ng-drag-handle]");
            }
            if (dragHandles.length) {
              _dragHandle = dragHandles;
            }
            toggleListeners(true);
          };

          var toggleListeners = function (enable) {
            if (!enable) return;
            // add listeners.

            scope.$on("$destroy", onDestroy);
            scope.$watch(attrs.ngDrag, onEnableChange);
            scope.$watch(attrs.ngCenterAnchor, onCenterAnchor);
            // wire up touch events
            if (_dragHandle) {
              // handle(s) specified, use those to initiate drag
              _dragHandle.on(_pressEvents, onpress);
            } else {
              // no handle(s) specified, use the element as the handle
              element.on(_pressEvents, onpress);
            }
            if (!_hasTouch && element[0].nodeName.toLowerCase() == "img") {
              element.on("mousedown", function () {
                return false;
              }); // prevent native drag for images
            }
          };
          var onDestroy = function (enable) {
            toggleListeners(false);
          };
          var onEnableChange = function (newVal, oldVal) {
            _dragEnabled = newVal;
          };
          var onCenterAnchor = function (newVal, oldVal) {
            if (angular.isDefined(newVal)) _centerAnchor = newVal || "true";
          };

          var isClickableElement = function (evt) {
            return angular.isDefined(
              angular.element(evt.target).attr("ng-cancel-drag")
            );
          };
          /*
           * When the element is clicked start the drag behaviour
           * On touch devices as a small delay so as not to prevent native window scrolling
           */
          var onpress = function (evt) {
            if (!_dragEnabled) return;

            if (isClickableElement(evt)) {
              return;
            }

            if (evt.type == "mousedown" && evt.button != 0) {
              // Do not start dragging on right-click
              return;
            }

            if (_hasTouch) {
              cancelPress();
              _pressTimer = setTimeout(function () {
                cancelPress();
                onlongpress(evt);
              }, 100);
              $document.on(_moveEvents, cancelPress);
              $document.on(_releaseEvents, cancelPress);
            } else {
              onlongpress(evt);
            }
          };

          var cancelPress = function () {
            clearTimeout(_pressTimer);
            $document.off(_moveEvents, cancelPress);
            $document.off(_releaseEvents, cancelPress);
          };

          var onlongpress = function (evt) {
            if (!_dragEnabled) return;
            evt.preventDefault();

            offset = element[0].getBoundingClientRect();
            if (allowTransform) _dragOffset = offset;
            else {
              _dragOffset = {
                left: document.body.scrollLeft,
                top: document.body.scrollTop,
              };
            }

            element.centerX = element[0].offsetWidth / 2;
            element.centerY = element[0].offsetHeight / 2;

            _mx = ngDraggable.inputEvent(evt).pageX; //ngDraggable.getEventProp(evt, 'pageX');
            _my = ngDraggable.inputEvent(evt).pageY; //ngDraggable.getEventProp(evt, 'pageY');
            _mrx = _mx - offset.left;
            _mry = _my - offset.top;
            if (_centerAnchor) {
              _tx = _mx - element.centerX - $window.pageXOffset;
              _ty = _my - element.centerY - $window.pageYOffset;
            } else {
              _tx = _mx - _mrx - $window.pageXOffset;
              _ty = _my - _mry - $window.pageYOffset;
            }

            $document.on(_moveEvents, onmove);
            $document.on(_releaseEvents, onrelease);
            // This event is used to receive manually triggered mouse move events
            // jqLite unfortunately only supports triggerHandler(...)
            // See http://api.jquery.com/triggerHandler/
            // _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', onmove);
            _deregisterRootMoveListener = $rootScope.$on(
              "draggable:_triggerHandlerMove",
              function (event, origEvent) {
                onmove(origEvent);
              }
            );
          };

          var onmove = function (evt) {
            if (!_dragEnabled) return;
            evt.preventDefault();

            if (!element.hasClass("dragging")) {
              _data = getDragData(scope);
              element.addClass("dragging");
              $rootScope.$broadcast("draggable:start", {
                x: _mx,
                y: _my,
                tx: _tx,
                ty: _ty,
                event: evt,
                element: element,
                data: _data,
              });
            }

            _mx = ngDraggable.inputEvent(evt).pageX; //ngDraggable.getEventProp(evt, 'pageX');
            _my = ngDraggable.inputEvent(evt).pageY; //ngDraggable.getEventProp(evt, 'pageY');

            if (_centerAnchor) {
              _tx = _mx - element.centerX - _dragOffset.left;
              _ty = _my - element.centerY - _dragOffset.top;
            } else {
              _tx = _mx - _mrx - _dragOffset.left;
              _ty = _my - _mry - _dragOffset.top;
            }

            moveElement(_tx, _ty);

            $rootScope.$broadcast("draggable:move", {
              x: _mx,
              y: _my,
              tx: _tx,
              ty: _ty,
              event: evt,
              element: element,
              data: _data,
              uid: _myid,
            });
          };

          var onrelease = function (evt) {
            if (!_dragEnabled) return;
            evt.preventDefault();
            $rootScope.$broadcast("draggable:end", {
              x: _mx,
              y: _my,
              tx: _tx,
              ty: _ty,
              event: evt,
              element: element,
              data: _data,
              callback: onDragComplete,
              uid: _myid,
            });
            element.removeClass("dragging");
            element.parent().find(".drag-enter").removeClass("drag-enter");
            reset();
            $document.off(_moveEvents, onmove);
            $document.off(_releaseEvents, onrelease);
            _deregisterRootMoveListener();
          };

          var onDragComplete = function (evt) {
            if (!onDragSuccessCallback) return;

            scope.$apply(function () {
              onDragSuccessCallback(scope, { $data: _data, $event: evt });
            });
          };

          var reset = function () {
            if (allowTransform)
              element.css({
                transform: "",
                "z-index": "",
                "-webkit-transform": "",
                "-ms-transform": "",
              });
            else element.css({ position: "", top: "", left: "" });
          };

          var moveElement = function (x, y) {
            if (allowTransform) {
              element.css({
                transform:
                  "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, " +
                  x +
                  ", " +
                  y +
                  ", 0, 1)",
                "z-index": 99999,
                "-webkit-transform":
                  "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, " +
                  x +
                  ", " +
                  y +
                  ", 0, 1)",
                "-ms-transform": "matrix(1, 0, 0, 1, " + x + ", " + y + ")",
              });
            } else {
              element.css({ left: x + "px", top: y + "px", position: "fixed" });
            }
          };
          initialize();
        },
      };
    },
  ])

  .directive("ngDrop", [
    "$parse",
    "$timeout",
    "$window",
    "$document",
    "ngDraggable",
    function ($parse, $timeout, $window, $document, ngDraggable) {
      return {
        restrict: "A",
        link: function (scope, element, attrs) {
          scope.value = attrs.ngDrop;
          scope.isTouching = false;

          var _lastDropTouch = null;

          var _myid = scope.$id;

          var _dropEnabled = false;

          var onDropCallback = $parse(attrs.ngDropSuccess); // || function(){};

          var onDragStartCallback = $parse(attrs.ngDragStart);
          var onDragStopCallback = $parse(attrs.ngDragStop);
          var onDragMoveCallback = $parse(attrs.ngDragMove);

          var initialize = function () {
            toggleListeners(true);
          };

          var toggleListeners = function (enable) {
            // remove listeners

            if (!enable) return;
            // add listeners.
            scope.$watch(attrs.ngDrop, onEnableChange);
            scope.$on("$destroy", onDestroy);
            scope.$on("draggable:start", onDragStart);
            scope.$on("draggable:move", onDragMove);
            scope.$on("draggable:end", onDragEnd);
          };

          var onDestroy = function (enable) {
            toggleListeners(false);
          };
          var onEnableChange = function (newVal, oldVal) {
            _dropEnabled = newVal;
          };
          var onDragStart = function (evt, obj) {
            if (!_dropEnabled) return;
            isTouching(obj.x, obj.y, obj.element);

            if (attrs.ngDragStart) {
              $timeout(function () {
                onDragStartCallback(scope, { $data: obj.data, $event: obj });
              });
            }
          };
          var onDragMove = function (evt, obj) {
            if (!_dropEnabled) return;
            isTouching(obj.x, obj.y, obj.element);

            if (attrs.ngDragMove) {
              $timeout(function () {
                onDragMoveCallback(scope, { $data: obj.data, $event: obj });
              });
            }
          };

          var onDragEnd = function (evt, obj) {
            // don't listen to drop events if this is the element being dragged
            // only update the styles and return
            if (!_dropEnabled || _myid === obj.uid) {
              updateDragStyles(false, obj.element);
              return;
            }
            if (isTouching(obj.x, obj.y, obj.element)) {
              // call the ngDraggable ngDragSuccess element callback
              if (obj.callback) {
                obj.callback(obj);
              }

              if (attrs.ngDropSuccess) {
                $timeout(function () {
                  onDropCallback(scope, {
                    $data: obj.data,
                    $event: obj,
                    $target: scope.$eval(scope.value),
                  });
                });
              }
            }

            if (attrs.ngDragStop) {
              $timeout(function () {
                onDragStopCallback(scope, { $data: obj.data, $event: obj });
              });
            }

            updateDragStyles(false, obj.element);
          };

          var isTouching = function (mouseX, mouseY, dragElement) {
            var touching = hitTest(mouseX, mouseY);
            scope.isTouching = touching;
            if (touching) {
              _lastDropTouch = element;
            }
            updateDragStyles(touching, dragElement);
            return touching;
          };

          var updateDragStyles = function (touching, dragElement) {
            if (touching) {
              element.addClass("drag-enter");
              dragElement.addClass("drag-over");
            } else if (_lastDropTouch == element) {
              _lastDropTouch = null;
              element.removeClass("drag-enter");
              dragElement.removeClass("drag-over");
            }
          };

          var hitTest = function (x, y) {
            var bounds = element[0].getBoundingClientRect(); // ngDraggable.getPrivOffset(element);
            x -=
              $document[0].body.scrollLeft +
              $document[0].documentElement.scrollLeft;
            y -=
              $document[0].body.scrollTop +
              $document[0].documentElement.scrollTop;
            return (
              x >= bounds.left &&
              x <= bounds.right &&
              y <= bounds.bottom &&
              y >= bounds.top
            );
          };

          initialize();
        },
      };
    },
  ])
  .directive("ngDragClone", [
    "$parse",
    "$timeout",
    "ngDraggable",
    function ($parse, $timeout, ngDraggable) {
      return {
        restrict: "A",
        link: function (scope, element, attrs) {
          var img,
            _allowClone = true;
          var _dragOffset = null;
          scope.clonedData = {};
          var initialize = function () {
            img = element.find("img");
            element.attr("draggable", "false");
            img.attr("draggable", "false");
            reset();
            toggleListeners(true);
          };

          var toggleListeners = function (enable) {
            // remove listeners

            if (!enable) return;
            // add listeners.
            scope.$on("draggable:start", onDragStart);
            scope.$on("draggable:move", onDragMove);
            scope.$on("draggable:end", onDragEnd);
            preventContextMenu();
          };
          var preventContextMenu = function () {
            //  element.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
            img.off(
              "mousedown touchstart touchmove touchend touchcancel",
              absorbEvent_
            );
            //  element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
            img.on(
              "mousedown touchstart touchmove touchend touchcancel",
              absorbEvent_
            );
          };
          var onDragStart = function (evt, obj, elm) {
            _allowClone = true;
            if (angular.isDefined(obj.data.allowClone)) {
              _allowClone = obj.data.allowClone;
            }
            if (_allowClone) {
              scope.$apply(function () {
                scope.clonedData = obj.data;
              });
              element.css("width", obj.element[0].offsetWidth);
              element.css("height", obj.element[0].offsetHeight);

              moveElement(obj.tx, obj.ty);
            }

            _dragOffset = element[0].getBoundingClientRect(); //ngDraggable.getPrivOffset(element);
          };
          var onDragMove = function (evt, obj) {
            if (_allowClone) {
              _tx = obj.tx + _dragOffset.left;
              _ty = obj.ty + _dragOffset.top;

              moveElement(_tx, _ty);
            }
          };
          var onDragEnd = function (evt, obj) {
            //moveElement(obj.tx,obj.ty);
            if (_allowClone) {
              reset();
            }
          };

          var reset = function () {
            element.css({
              left: 0,
              top: 0,
              position: "fixed",
              "z-index": -1,
              visibility: "hidden",
            });
          };
          var moveElement = function (x, y) {
            element.css({
              transform:
                "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, " +
                x +
                ", " +
                y +
                ", 0, 1)",
              "z-index": 99999,
              visibility: "visible",
              "-webkit-transform":
                "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, " +
                x +
                ", " +
                y +
                ", 0, 1)",
              "-ms-transform": "matrix(1, 0, 0, 1, " + x + ", " + y + ")",
              //,margin: '0'  don't monkey with the margin,
            });
          };

          var absorbEvent_ = function (event) {
            var e = event; //.originalEvent;
            e.preventDefault && e.preventDefault();
            e.stopPropagation && e.stopPropagation();
            e.cancelBubble = true;
            e.returnValue = false;
            return false;
          };

          initialize();
        },
      };
    },
  ])
  .directive("ngPreventDrag", [
    "$parse",
    "$timeout",
    function ($parse, $timeout) {
      return {
        restrict: "A",
        link: function (scope, element, attrs) {
          var initialize = function () {
            element.attr("draggable", "false");
            toggleListeners(true);
          };

          var toggleListeners = function (enable) {
            // remove listeners

            if (!enable) return;
            // add listeners.
            element.on(
              "mousedown touchstart touchmove touchend touchcancel",
              absorbEvent_
            );
          };

          var absorbEvent_ = function (event) {
            var e = event.originalEvent;
            e.preventDefault && e.preventDefault();
            e.stopPropagation && e.stopPropagation();
            e.cancelBubble = true;
            e.returnValue = false;
            return false;
          };

          initialize();
        },
      };
    },
  ])
  .directive("ngCancelDrag", [
    function () {
      return {
        restrict: "A",
        link: function (scope, element, attrs) {
          element.find("*").attr("ng-cancel-drag", "ng-cancel-drag");
        },
      };
    },
  ])
  .directive("ngDragScroll", [
    "$window",
    "$interval",
    "$timeout",
    "$document",
    "$rootScope",
    function ($window, $interval, $timeout, $document, $rootScope) {
      return {
        restrict: "A",
        link: function (scope, element, attrs) {
          var intervalPromise = null;
          var lastMouseEvent = null;

          var config = {
            verticalScroll: attrs.verticalScroll || true,
            horizontalScroll: attrs.horizontalScroll || true,
            activationDistance: attrs.activationDistance || 75,
            scrollDistance: attrs.scrollDistance || 15,
          };

          var reqAnimFrame = (function () {
            return (
              window.requestAnimationFrame ||
              window.webkitRequestAnimationFrame ||
              window.mozRequestAnimationFrame ||
              window.oRequestAnimationFrame ||
              window.msRequestAnimationFrame ||
              function (
                /* function FrameRequestCallback */ callback,
                /* DOMElement Element */ element
              ) {
                window.setTimeout(callback, 1000 / 60);
              }
            );
          })();

          var animationIsOn = false;
          var createInterval = function () {
            animationIsOn = true;

            function nextFrame(callback) {
              var args = Array.prototype.slice.call(arguments);
              if (animationIsOn) {
                reqAnimFrame(function () {
                  $rootScope.$apply(function () {
                    callback.apply(null, args);
                    nextFrame(callback);
                  });
                });
              }
            }

            nextFrame(function () {
              if (!lastMouseEvent) return;

              var viewportWidth = Math.max(
                document.documentElement.clientWidth,
                window.innerWidth || 0
              );
              var viewportHeight = Math.max(
                document.documentElement.clientHeight,
                window.innerHeight || 0
              );

              var scrollX = 0;
              var scrollY = 0;

              if (config.horizontalScroll) {
                // If horizontal scrolling is active.
                if (lastMouseEvent.clientX < config.activationDistance) {
                  // If the mouse is on the left of the viewport within the activation distance.
                  scrollX = -config.scrollDistance;
                } else if (
                  lastMouseEvent.clientX >
                  viewportWidth - config.activationDistance
                ) {
                  // If the mouse is on the right of the viewport within the activation distance.
                  scrollX = config.scrollDistance;
                }
              }

              if (config.verticalScroll) {
                // If vertical scrolling is active.
                if (lastMouseEvent.clientY < config.activationDistance) {
                  // If the mouse is on the top of the viewport within the activation distance.
                  scrollY = -config.scrollDistance;
                } else if (
                  lastMouseEvent.clientY >
                  viewportHeight - config.activationDistance
                ) {
                  // If the mouse is on the bottom of the viewport within the activation distance.
                  scrollY = config.scrollDistance;
                }
              }

              if (scrollX !== 0 || scrollY !== 0) {
                // Record the current scroll position.
                var currentScrollLeft =
                  $window.pageXOffset ||
                  $document[0].documentElement.scrollLeft;
                var currentScrollTop =
                  $window.pageYOffset || $document[0].documentElement.scrollTop;

                // Remove the transformation from the element, scroll the window by the scroll distance
                // record how far we scrolled, then reapply the element transformation.
                var elementTransform = element.css("transform");
                element.css("transform", "initial");

                $window.scrollBy(scrollX, scrollY);

                var horizontalScrollAmount =
                  ($window.pageXOffset ||
                    $document[0].documentElement.scrollLeft) -
                  currentScrollLeft;
                var verticalScrollAmount =
                  ($window.pageYOffset ||
                    $document[0].documentElement.scrollTop) - currentScrollTop;

                element.css("transform", elementTransform);

                lastMouseEvent.pageX += horizontalScrollAmount;
                lastMouseEvent.pageY += verticalScrollAmount;

                $rootScope.$emit(
                  "draggable:_triggerHandlerMove",
                  lastMouseEvent
                );
              }
            });
          };

          var clearInterval = function () {
            animationIsOn = false;
          };

          scope.$on("draggable:start", function (event, obj) {
            // Ignore this event if it's not for this element.
            if (obj.element[0] !== element[0]) return;

            if (!animationIsOn) createInterval();
          });

          scope.$on("draggable:end", function (event, obj) {
            // Ignore this event if it's not for this element.
            if (obj.element[0] !== element[0]) return;

            if (animationIsOn) clearInterval();
          });

          scope.$on("draggable:move", function (event, obj) {
            // Ignore this event if it's not for this element.
            if (obj.element[0] !== element[0]) return;

            lastMouseEvent = obj.event;
          });
        },
      };
    },
  ]);

var app = angular.module("inspinia").directive("comments", [
  "$uibModal",
  "calendarConfig",
  "$location",
  "$http",
  "url",
  "$localStorage",
  "toaster",
  "dataFactory",
  "SweetAlert",
  "$rootScope",
  "$timeout",
  "NotificationService",
  "exportFactory",
  "$sessionStorage",
  function (
    $uibModal,
    calendarConfig,
    $location,
    $http,
    url,
    $localStorage,
    toaster,
    dataFactory,
    SweetAlert,
    $rootScope,
    $timeout,
    NotificationService,
    exportFactory,
    $sessionStorage
  ) {
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
    return {
      restrict: "EA",
      scope: {
        model: "=",
        datasource: "=",
        typemodel: "=",
        idmodel: "=",
        receiptmodel: "=",
        config: "=",
      },
      templateUrl: "app/directivas/comments/comments.template.html",
      link: function (scope, element, attrs) {
        scope.converter_task = false;
        scope.child_converter_task = false;
        scope.user_assigned = 0;
        scope.users = [];
        scope.mentionatedChild = [];
        scope.mentionated = [];
        scope.show_main = true;
        scope.show = false;
        scope.show_task = false;
        scope.yaguardado = false;
        scope.index = 0;
        scope.index2 = 0;

        var orgFromSession = "";
        var authToken = "";
        try {
          var user = $sessionStorage.user
            ? JSON.parse(sjcl.decrypt("User", $sessionStorage.user))
            : null;
          var token = $sessionStorage.token
            ? JSON.parse(sjcl.decrypt("Token", $sessionStorage.token))
            : "";
          if (user) {
            orgFromSession =
              user.org && user.org.urlname
                ? user.org.urlname
                : user.urlname || user.orgname || "";
          }
          authToken = token && token.token ? token.token : token;
        } catch (e) {
          console.warn("No se pudo descifrar user/token", e);
        }

        scope.commentsExportLoading = false;
        var currentPath = $location.path();
        scope.showExportButton =
          currentPath === "/tareas/" ||
          currentPath.indexOf("/index/main") === 0 ||
          !!scope.$eval(attrs.exportable);
        scope.exportComments = function () {
          if (
            !scope.typemodel ||
            !scope.idmodel ||
            scope.commentsExportLoading
          ) {
            return;
          }
          scope.commentsExportLoading = true;

          var resetLoading = function () {
            scope.commentsExportLoading = false;
            scope.$evalAsync(function () {});
          };

          var paramsObj = {
            model: scope.typemodel || scope.model,
            id_model: scope.idmodel,
          };
          if (orgFromSession) {
            paramsObj.org = orgFromSession;
          }
          toaster.info(
            "Generando...",
            "El archivo se está generando, espera un momento."
          );

          exportFactory
            .commentsExport({
              params: paramsObj,
              downloadName: "bitacora_tarea.xlsx",
            })
            .then(function () {
              SweetAlert.swal({
                title: "Listo",
                icon: "success",
                text: "La bitacora se descargo exitosamente",
                timer: 5000,
              });
            })
            .catch(function (error) {
              console.error("Error exportando comentarios", error);
              SweetAlert.swal(
                "Error",
                "No se pudo exportar los comentarios. Intenta nuevamente.",
                "error"
              );
            })
            .finally(function () {
              resetLoading();
            });
        };

        if ($location.path() == "/tareas/") {
          scope.show_main = false;
        }

        scope.saveReminder = function (item, index) {
          $http
            .post(url.IP + "save-reminder", {
              mid: item.id,
              reminder_date: new Date(
                item.event.startsAt.getTime() -
                  item.event.startsAt.getTimezoneOffset() * 60000
              ),
              has_reminder: true,
            })
            .then(function (response) {
              scope.datasource[index] = response.data;
            });
          item.isReminder = false;
        };

        scope.closeReminder = function (item) {
          item.isReminder = false;
        };
        //------------------------------------------prueba
        $http.get(url.IP + "usuarios/").then(function (user) {
          user.data.results.forEach(function (vn) {
            vn.first_name = vn.first_name.toUpperCase();
            vn.last_name = vn.last_name.toUpperCase();
            vn.name =
              vn.first_name.toUpperCase() + " " + vn.last_name.toUpperCase();
          });
          scope.users = user.data.results;
          scope.usersChild = user.data.results;
        });
        scope.checkForMention = function (event) {
          scope.showUserList = false;
          var input = event.target.value;
          var cursorPos = event.target.selectionStart;
          var textUpToCursor = input.slice(0, cursorPos);

          var mentionIndex = textUpToCursor.lastIndexOf("@");
          if (mentionIndex !== -1) {
            var query = textUpToCursor.slice(mentionIndex + 1);
            scope.filteredUsers = scope.users.filter(function (user) {
              return user.name.toLowerCase().includes(query.toLowerCase());
            });
            scope.showUserList = scope.filteredUsers.length > 0;
          } else {
            scope.showUserList = false;
          }
        };
        scope.mentionated = [];
        scope.addMention = function (user) {
          var input = scope.simple_comment;
          var cursorPos =
            document.getElementById("commentInput").selectionStart;
          var textUpToCursor = input.slice(0, cursorPos);
          var mentionIndex = textUpToCursor.lastIndexOf("@");
          scope.mentionated.push(user.url);
          scope.simple_comment =
            input.slice(0, mentionIndex + 1) +
            user.name +
            " " +
            input.slice(cursorPos);
          scope.showUserList = false;
        };

        scope.submitComment = function () {
          scope.comments.push(scope.simple_comment);
          scope.simple_comment = "";
        };
        // ----CHild
        scope.checkForMentionChild = function (event, child) {
          scope.showUserList = false;
          scope.showUserListChild = false;
          var input = event.target.value;
          var cursorPos = event.target.selectionStart;
          var textUpToCursor_c = input.slice(0, cursorPos);

          var mentionIndex_c = textUpToCursor_c.lastIndexOf("@");
          if (mentionIndex_c !== -1) {
            var query = textUpToCursor_c.slice(mentionIndex_c + 1);
            child.filteredUsersC = scope.usersChild.filter(function (user) {
              return user.name.toLowerCase().includes(query.toLowerCase());
            });
            scope.showUserListChild = child.filteredUsersC.length > 0;
          } else {
            scope.showUserListChild = false;
          }
        };

        scope.addMentionChild = function (user, child) {
          scope.child = child;
          var input = child.content;
          var cursorPos =
            document.getElementById("commentInputChild").selectionStart;
          var textUpToCursor = input.slice(0, cursorPos);
          var mentionIndex = textUpToCursor.lastIndexOf("@");
          scope.mentionated.push(user.url);
          scope.child.content =
            input.slice(0, mentionIndex + 1) + user.name + " ";
          scope.showUserListChild = false;
        };

        scope.submitCommentChild = function () {
          scope.comments.push(scope.child.content);
          scope.child.content = "";
        };
        // ******************************************************
        scope.toggle = function ($event, field, event) {
          $event.preventDefault();
          $event.stopPropagation();
          event[field] = !event[field];
        };

        scope.makeReminder = function (item) {
          if (!item.has_reminder) {
            item.event = {
              title: "",
              startsAt: new Date(),
              color: calendarConfig.colorTypes.warning,
              draggable: true,
              resizable: true,
            };
          } else {
            item.event = {
              title: "",
              startsAt: new Date(item.reminder_date),
              color: calendarConfig.colorTypes.warning,
              draggable: true,
              resizable: true,
            };
          }

          if (item.isReminder) {
            scope.isReminder = false;
          } else {
            item.isReminder = true;
          }
        };

        var users_array = [];
        scope.urls_array = [];

        scope.editTask = function (item, index) {
          console.log(item.comment_tasks[0]);
          var modalInstance = $uibModal.open({
            templateUrl: "app/tasks/task.modal.html",
            controller: "TareasModalCtrl",
            backdrop: false,
            size: "lg",
            resolve: {
              task: function () {
                return item.comment_tasks[0];
              },
              data: function () {
                return null;
              },
              associated: function () {
                return null;
              },
              receipt: function () {
                return null;
              },
              route: function () {
                return null;
              },
              modelo: function () {
                return null;
              },
            },
          });
          modalInstance.result.then(
            function (response) {
              console.log("modal closed", response);
              if (response) {
                scope.datasource[index].comment_tasks[0] = response.data;
              }
            },
            function () {
              //close callback
              console.info("modal closed");
            }
          );
        };

        scope.getPicture = function (parItem) {
          if (parItem.image) {
            parItem.image = parItem.image;
          } else {
            getUsers(parItem);
          }
        };

        scope.changeSelect = function (argument) {
          scope.user_assigned = argument;
        };

        function getUsers(param) {
          $http({
            method: "GET",
            url: url.IP_CAS + "get-user-picture/" + param.user,
          })
            .then(function success(request) {
              if (request.status === 200) {
                param.image = request.data.url;
                $localStorage.avatar = request.data.url;
              }
            })
            .catch(function (e) {
              console.info("e", e);
            });
        }

        scope.scrollDown = function () {
          var content_ = $("#binaclecontent")[0];
          $("#binaclecontent").scrollTop(content_.scrollHeight);
        };

        //console.log(scope.receiptmodel);
        //console.log('---------------------');

        scope.change_converter = function (flag) {
          if (flag) {
            // $http.get(url.IP + 'usuarios').then(function(data) {
            //   scope.users = data.data.results;
            // })
            dataFactory.get("usuarios/").then(function (data) {
              scope.users = data.data.results;
            });
          }
          scope.converter_task = flag;
          // }
          // else{
          //   scope.converter_task = true;
          // }
        };

        function assignModel(param) {
          switch (param) {
            case 1:
              return 1;
              break;
            case 10:
              return 2;
              break;
            case 10:
              return 2;
              break;
            case 4:
              return 3;
              break;
            case 6:
              return 5;
              break;
            case 5:
              return 6;
              break;
            case 2:
              return 7;
              break;
            case 13:
              return 8;
              break;
            case 18:
              return 18;
              break;
            case 28:
              return 28;
              break;
            case 30:
              return 30;
              break;
            default:
              return 1;
              break;
          }
        }

        // scope.saveComment = function () {
        //   scope.yaguardado=true;
        //   var l = Ladda.create( document.querySelector( '.ladda-button' ) );
        //   l.start();
        //   if(!scope.simple_comment || scope.simple_comment == ''){
        //     l.stop();
        //     scope.yaguardado=false;
        //     SweetAlert.swal("¡Error!", "Agrega un comentario.", "error");
        //     return;
        //   }
        //   if(scope.converter_task
        //     ){
        //     if(scope.user_assigned == 0){
        //       l.stop();
        //       scope.yaguardado=false;
        //       return;
        //     }
        //   }

        //   var data = {
        //     'model': scope.typemodel,
        //     'id_model': scope.idmodel,
        //     'content': scope.simple_comment,
        //     'parent': null,
        //     'create_task': scope.converter_task,
        //     'user_assigned': scope.user_assigned,
        //     'modelo_tareas': assignModel(scope.typemodel)
        //   };

        //   $http.post(url.IP+'comments/', data)
        //   .then(function(request) {
        //     l.stop();
        //     scope.yaguardado=false;
        //     scope.datasource.push(request.data);
        //     scope.simple_comment = '';
        //     scope.getNotifications();
        //     if(scope.typemodel == 4){
        //       var obj = {
        //         'track_bitacora': true
        //       }
        //       // cambiar url.IP por url del recibo
        //       $http.patch(scope.receiptmodel, obj);
        //     }

        //   })
        //   .catch(function(e) {
        //     console.log('e', e);
        //     l.stop();
        //     scope.yaguardado=false;
        //   });

        //   if(scope.typemodel == 22){
        //     var data = {
        //       id: scope.idmodel
        //     }
        //     $http.post(url.IP + 'complete-task/', data).then(function(response){
        //       console.log("216",response);
        //       var params = {
        //         'model': 22,
        //         'event': "POST",
        //         'associated_id': scope.idmodel,
        //         'identifier': "cerró la tarea."
        //       }
        //       l.stop();
        //       scope.yaguardado=false;
        //       dataFactory.post('send-log/', params).then(function success(response) {
        //         console.log("225", response);
        //       });
        //     });
        //     scope.yaguardado=false;
        //   }
        //   l.stop();
        // };
        scope.saveComment = function ($event) {
          // ✅ 1) si ya está guardando, no hagas nada
          if (scope.yaguardado) return;

          // ✅ 2) valida antes de prender "guardado"
          var comment = (scope.simple_comment || "").trim();
          if (!comment) {
            SweetAlert.swal("¡Error!", "Agrega un comentario.", "error");
            return;
          }

          if (scope.converter_task) {
            if (scope.user_assigned == 0) return;
          }

          // ✅ 3) prende lock y limpia input de inmediato (evita dobles + UX)
          scope.yaguardado = true;
          scope.simple_comment = "";

          // ✅ 4) Ladda sobre ESTE botón (no querySelector global)
          var btn =
            $event && $event.currentTarget ? $event.currentTarget : null;
          var l = btn ? Ladda.create(btn) : null;
          if (l) l.start();

          var data = {
            model: scope.typemodel,
            id_model: scope.idmodel,
            content: comment, // usamos el comentario guardado localmente
            parent: null,
            create_task: scope.converter_task,
            user_assigned: scope.user_assigned,
            modelo_tareas: assignModel(scope.typemodel),
          };

          $http
            .post(url.IP + "comments/", data)
            .then(function (resp) {
              scope.datasource.push(resp.data);
              scope.getNotifications();

              if (scope.typemodel == 4) {
                $http.patch(scope.receiptmodel, { track_bitacora: true });
              }

              // si typemodel 22, corre el flujo extra, pero sin duplicar saves
              if (scope.typemodel == 22) {
                return $http
                  .post(url.IP + "complete-task/", { id: scope.idmodel })
                  .then(function () {
                    var params = {
                      model: 22,
                      event: "POST",
                      associated_id: scope.idmodel,
                      identifier: "cerró la tarea.",
                    };
                    return dataFactory.post("send-log/", params);
                  });
              }
            })
            .catch(function (e) {
              console.log("e", e);
              // ✅ si falla, regresa el texto al input para que no lo pierda
              scope.simple_comment = comment;
              SweetAlert.swal(
                "¡Error!",
                "No se pudo enviar el comentario. Intenta de nuevo.",
                "error"
              );
            })
            .finally(function () {
              if (l) l.stop();
              scope.yaguardado = false;
            });
        };

        scope.getNotifications = function () {
          NotificationService.getNotifications().then(function () {
            $rootScope.$broadcast("MainCtrl:getNotifications");
          });
          // ------socket
          // $http({
          //   method: 'POST',
          //   url: url.IP +'notifications-test-task/',
          //   })
          // .then(function success(response) {
          //   if (response.status == 200){
          //     var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
          //     socket.emit('subscribe', response.data);
          //     // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
          //     // socket.on('result', function(url){
          //     socket.onmessage = function(e) {
          //         const data = JSON.parse(e.data);
          //         if (data.type === 'notification') {
          //             const notification = data.data;
          //             console.log('Received notification:', notification.message);
          //             // Update your notification count or list here
          //         }
          //     };
          //     // socket.on(response.data, function(url){
          //     //   var notificacion = {
          //     //     'title': 'Enviando notificación...',
          //     //     'description': url,
          //     //     'model': 26,
          //     //     'id_reference':0
          //     //   }
          //     //   socket.disconnect();
          //     // });
          //     console.log('Generando...', 'Bitácora');
          //     // socket.disconnect();

          //   } else {
          //     console.log('Aviso', 'Ha ocurrido un error, intente nuevamente');
          //   }
          // }).catch(function(error) {
          //   console.log('Aviso', 'Ha ocurrido un error, intente nuevamente');
          // })
          // -----------------
        };
        scope.saveChild = function (parChild, parItem) {
          // if(scope.child_converter_task){
          //   if(!scope.user_child_assigned){
          //     return;
          //   }
          // }

          var data = {
            model: scope.typemodel,
            id_model: scope.idmodel,
            content: parChild.content,
            parent: parItem.id,
            is_child: true,
            create_task: scope.child_converter_task,
            user_assigned: scope.user_child_assigned,
          };

          $http
            .post(url.IP + "comments/", data)
            .then(function (request) {
              if (request.status === 201) {
                parItem.comment_child.push(request.data);
                parChild.content = "";
                parChild.response = false;
                scope.getNotifications();
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
        };
        scope.show_mail = function (id) {
          //scope.show = true;
          $http
            .get(url.IP + "log-email/" + id + "/" + 1)
            .then(function (response) {
              if (response.status == 200) {
                var modalInstance = $uibModal.open({
                  //jshint ignore:line
                  templateUrl: "app/cobranzas/log.detail.email.html",
                  controller: "EmailDetailCtrl",
                  size: "lg",
                  windowClass: "modal-s",

                  resolve: {
                    mail: function () {
                      return response.data;
                    },
                  },
                  backdrop:
                    "static" /* this prevent user interaction with the background */,
                  keyboard: false,
                });
                modalInstance.result.then(function (receipt) {
                  vm.receipts.splice(index, 1);
                  activate();
                });
              }
            });
        };

        // Ver más
        scope.showMore = function () {
          $http
            .get(scope.config.next)
            .then(function (request) {
              if (request.status === 200) {
                scope.config.next = request.data.next;
                scope.config.count = request.data.count;
                scope.config.previous = request.data.previous;
                request.data.results.forEach(function (item) {
                  scope.datasource.unshift(item);
                });
              }
            })
            .catch(function (e) {
              console.log("error", e);
            });
        };
      }, // termina link
    }; // termina return
  },
]);

var app = angular.module("inspinia").directive("commentsMc", [
  "$http",
  "url",
  "$localStorage",
  function ($http, url, $localStorage) {
    return {
      restrict: "EA",
      scope: {
        quote: "=",
        datasource: "=",
        config: "=",
      },
      templateUrl: "app/directivas/comments/comments-mc.template.html",
      link: function (scope, element, attrs) {
        var users_array = [];
        scope.urls_array = [];

        scope.getPicture = function (parItem) {
          if ($localStorage[parItem.user]) {
            parItem.image = $localStorage[parItem.user];
          } else {
            getUsers(parItem);
          }
        };

        function getUsers(param) {
          console.log("param", param);

          $http({
            method: "GET",
            url: url.IP_CAS + "get-user-picture/" + param.user,
          })
            .then(function (request) {
              if (request.status === 200) {
                param.image = url.IP_CAS + request.data.url;
                $localStorage[param.user] = url.IP_CAS + request.data.url;
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
        }

        scope.scrollDown = function () {
          var content_ = $("#binaclecontent")[0];
          $("#binaclecontent").scrollTop(content_.scrollHeight);
        };

        scope.saveComment = function () {
          var data = {
            // 'model': scope.typemodel,
            // 'id_model': scope.idmodel,
            content: scope.simple_comment,
            parent: null,
            quote: scope.quote.id,
            isChild: false,
          };

          $http
            .post(url.MC + "quote-comment/", data)
            .then(function (request) {
              if (request.status === 201) {
                scope.datasource.push(request.data);
                scope.simple_comment = "";
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
        };

        scope.saveChild = function (parChild, parItem) {
          var data = {
            quote: scope.quote.id,
            content: parChild.content,
            parent: parItem.id,
            isChild: true,
          };

          $http
            .post(url.MC + "quote-comment/", data)
            .then(function (request) {
              if (request.status === 201) {
                parItem.comment_child.push(request.data);
                parChild.content = "";
                parChild.response = false;
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
        };

        // Ver más
        scope.showMore = function () {
          $http
            .get(scope.config.next)
            .then(function (request) {
              if (request.status === 200) {
                scope.config.next = request.data.next;
                scope.config.count = request.data.count;
                scope.config.previous = request.data.previous;
                request.data.results.forEach(function (item) {
                  scope.datasource.unshift(item);
                });
              }
            })
            .catch(function (e) {
              console.log("error", e);
            });
        };
      }, // termina link
    }; // termina return
  },
]);

var app = angular.module("inspinia").directive("receiptsIndividual", [
  "MESSAGES",
  "SweetAlert",
  "$location",
  "$sessionStorage",
  function (MESSAGES, SweetAlert, $location, $sessionStorage) {
    return {
      restrict: "EA",
      scope: {
        form: "=",
        tosave: "=",
        type: "=",
      },
      templateUrl: "app/directivas/calculateReceipts/receiptsIndividual.html",
      link: function (scope, element, $watch, attrs) {
        // Variables
        scope.comision_seleccion = "";
        scope.accesos = $sessionStorage.permisos;
        if (scope.accesos) {
          scope.accesos.forEach(function (perm) {
            if (perm.model_name == "Comisiones") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Comisiones") {
                  if (acc.checked == true) {
                    scope.permiso_comisiones = true;
                  } else {
                    scope.permiso_comisiones = false;
                  }
                }
              });
            }
            if (perm.model_name == "Cobranza") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Eliminar recibos") {
                  if (acc.checked == true) {
                    scope.permiso_delRecibo = true;
                  } else {
                    scope.permiso_delRecibo = false;
                  }
                }
              });
            }
            if (perm.model_name == "Pólizas") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Comisión no obligatoria") {
                  if (acc.checked == true) {
                    scope.permiso_comision_no_obligatoria = true;
                  } else {
                    scope.permiso_comision_no_obligatoria = false;
                  }
                }
              });
            }
          });
        }
        scope.datareceipt = {
          primaNeta: 0,
          descuento: null,
          rpf: 0,
          derecho: 0,
          subTotal: 0,
          iva: null,
          primaTotal: 0,
          comision: 0,
          aplicarDescuento: false,
          comision_derecho_percent: 0,
          comision_rpf_percent: 0,
        };

        scope.option_descuento = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_descuento = scope.option_descuento[0];

        scope.option_rpf = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_rpf = scope.option_rpf[0];

        scope.option_iva = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_iva = scope.option_iva[0];

        var agregar_comision = 0;

        var valor_primaNeta;
        var valor_descuento;
        var valor_rpf;
        var valor_derecho;
        var valor_iva;
        var valor_prima_descuento;
        var valor_comision;
        var valor_suma_comision;

        var copy_primaNeta = 0;
        var copy_rpf = 0;
        var copy_subTotal = 0;

        scope.newPrima = {};
        scope.todos_prima = [0];
        scope.todos_subtotal = [0];

        scope.mostrarPrimerRecibo = false;
        scope.mostrarTodosRecibo = false;
        scope.editar_recibos = false;

        scope.editar = false;
        scope.recalcular = true;

        scope.obj_rpf = null;
        scope.verComisiones = function () {
          var sin_comision = {
            comission: "0",
            comission_derecho: "0",
            comission_rpf: "0",
            derecho: "0",
            efective_date: "-",
            expire_date: null,
            nombre: "Sin Comisión",
            observations: "-",
            others: "0",
            others_derecho: "0",
            others_rpf: "0",
            periodo_inicial: 0,
            periodo_subsecuente: 0,
            ramo: "-",
            rpf_mensual: "0",
            rpf_bimestral: "0",
            rpf_trimestral: "0",
            rpf_trimestral: "0",
            rpf_anual: "0",
            subramo: "-",
            udi: "0",
            udi_derecho: "0",
            udi_rpf: "0",
          };

          // if(scope.form.comisiones){
          //   if(scope.form.subramo && agregar_comision == 0){
          //     scope.form.comisiones.push(sin_comision);
          //     agregar_comision++;
          //   }
          // }else{
          //   if(scope.form.subramo && agregar_comision == 0){
          //     scope.form.comisiones = [];
          //     scope.form.comisiones.push(sin_comision);
          //     agregar_comision++;
          //   }
          // }

          if (scope.form.comisiones) {
            scope.form.comisiones.forEach(function (item) {
              if (
                item.nombre == "Sin Comisión" &&
                item.efective_date == "-" &&
                item.observations == "-"
              ) {
                agregar_comision++;
              }
            });
            if (scope.form.subramo && agregar_comision == 0) {
              scope.form.comisiones.push(sin_comision);
              agregar_comision++;
            }
          } else {
            if (scope.form.subramo && agregar_comision == 0) {
              scope.form.comisiones = [];
              scope.form.comisiones.push(sin_comision);
              agregar_comision++;
            } else {
              if (scope.form.comisiones && scope.form.comisiones.length == 0) {
                scope.form.comisiones.push(sin_comision);
              } else {
                if (scope.form.comisiones) {
                  scope.form.comisiones.push(sin_comision);
                } else {
                  scope.form.comisiones = [];
                  scope.form.comisiones.push(sin_comision);
                }
              }
            }
          }
          if (
            scope &&
            scope.form &&
            scope.form.comisiones &&
            scope.form.comisiones.length == 0
          ) {
            scope.form.comisiones.push(sin_comision);
          }
          if (scope.form) {
            if (scope.form.comision_seleccion) {
              scope.comision_seleccion = scope.form.comision_seleccion;
            }
            if (scope.form.primaNeta) {
              scope.datareceipt.primaNeta = scope.form.primaNeta
                ? scope.form.primaNeta
                : 0;
            }
            if (scope.form.derecho) {
              scope.datareceipt.derecho = scope.form.derecho
                ? scope.form.derecho
                : 0;
            }
            if (scope.form.rpf) {
              scope.datareceipt.rpf = scope.form.rpf ? scope.form.rpf : 0;
            }
          }
          scope.calcularRpf();
        };

        // Asignar valores segun comision seleccionada
        scope.asignarValores = function (comission) {
          if (scope.form && scope.form.primaNeta) {
            if (scope.form.comision_seleccion) {
              scope.comision_seleccion = scope.form.comision_seleccion;
            }
            if (scope.form.primaNeta) {
              scope.datareceipt.primaNeta = scope.form.primaNeta
                ? scope.form.primaNeta
                : 0;
            }
            if (scope.form.primaTotal) {
              scope.datareceipt.primaTotal = scope.form.primaTotal
                ? scope.form.primaTotal
                : 0;
            }
            if (scope.form.derecho) {
              scope.datareceipt.derecho = scope.form.derecho
                ? scope.form.derecho
                : 0;
            }
            if (scope.form.rpf) {
              scope.datareceipt.rpf = scope.form.rpf ? scope.form.rpf : 0;
            }
          }
          scope.comission = comission;
          if (!scope.form.payment || scope.form.payment == "") {
            scope.comision_seleccion = "";
            SweetAlert.swal("¡Error!", MESSAGES.ERROR.SELPAY, "error");
            return;
          } else {
            if (!scope.editar) {
              scope.datareceipt.payment = scope.form.payment;
            } else {
              scope.numeroRecibos = scope.datareceipt.numeroRecibos;
              scope.recalcular = scope.tosave.recalcular;
            }

            scope.datareceipt.subramo = scope.form.subramo.subramo_name;
            if (scope.form.derecho && scope.form.from_pdf) {
              scope.datareceipt.derecho = parseFloat(scope.form.derecho);
              scope.datareceipt.rpf = parseFloat(scope.form.rpf);
            } else {
              scope.datareceipt.derecho = parseFloat(
                comission && comission.derecho ? comission.derecho : 0
              );
              scope.datareceipt.rpf = parseFloat(
                comission && comission.rpf ? comission.rpf : 0
              );
            }
            if (scope.form.rpf && scope.form.from_pdf) {
              scope.datareceipt.rpf = parseFloat(scope.form.rpf);
            } else {
              scope.datareceipt.rpf = parseFloat(
                comission && comission.rpf ? comission.rpf : 0
              );
            }
            if (scope.form.descuento && scope.form.from_pdf) {
              scope.datareceipt.descuento = parseFloat(scope.form.descuento);
            }
            scope.datareceipt.prima_comision = parseFloat(
              comission && comission.comission ? comission.comission : 0
            );
            scope.datareceipt.rpf_comision = parseFloat(
              comission && comission.comission_rpf ? comission.comission_rpf : 0
            );
            scope.datareceipt.derecho_comision = parseFloat(
              comission && comission.comission_derecho
                ? comission.comission_derecho
                : 0
            );
            scope.datareceipt.periodo_inicial = parseFloat(
              comission && comission.periodo_inicial
                ? comission.periodo_inicial
                : 0
            );
            scope.datareceipt.periodo_subsecuente = parseFloat(
              comission && comission.periodo_subsecuente
                ? comission.periodo_subsecuente
                : 0
            );

            scope.datareceipt.domiciliado = scope.form.domiciliado;
            scope.calcularTotales();
          }
        };

        scope.porcentageRpf = function () {
          if (!scope.editar) {
            scope.datareceipt.payment = scope.form.payment;
          } else {
            scope.datareceipt.payment = scope.form.payment.value;
          }

          switch (parseFloat(scope.datareceipt.payment)) {
            case 1:
              scope.datareceipt.percent_rpf =
                scope.comission && scope.comission.rpf_mensual
                  ? scope.comission.rpf_mensual
                  : 0;
              break;
            case 2:
              scope.datareceipt.percent_rpf =
                scope.comission && scope.comission.rpf_bimestral
                  ? scope.comission.rpf_bimestral
                  : 0;
              break;
            case 3:
              scope.datareceipt.percent_rpf =
                scope.comission && scope.comission.rpf_trimestral
                  ? scope.comission.rpf_trimestral
                  : 0;
              break;
            case 5:
              scope.datareceipt.percent_rpf =
                scope.comission && scope.comission.rpf_anual
                  ? scope.comission.rpf_anual
                  : 0;
              break;
            case 6:
              scope.datareceipt.percent_rpf =
                scope.comission && scope.comission.rpf_semestral
                  ? scope.comission.rpf_semestral
                  : 0;
              break;
            case 12:
              scope.datareceipt.percent_rpf =
                scope.comission && scope.comission.rpf_anual
                  ? scope.comission.rpf_anual
                  : 0;
              break;
            default:
              break;
          }
          if (scope.datareceipt.primaNeta == 0) {
            scope.datareceipt.primaTotal = 0;
          }
        };

        // Calcula pesos o porcetaje de descuento
        scope.calcularDescuento = function () {
          if (scope.tipo_descuento.value == 2) {
            if (scope.datareceipt.descuento != 0) {
              scope.descuentoPesos =
                (scope.datareceipt.primaNeta * scope.datareceipt.descuento) /
                100;
            } else {
              scope.descuentoPesos = 0;
            }
          } else {
            if (scope.datareceipt.descuento != 0) {
              scope.descuentoPorcentaje = (
                (scope.datareceipt.descuento * 100) /
                scope.datareceipt.primaNeta
              ).toFixed(2);
            } else {
              scope.descuentoPorcentaje = 0;
            }
          }
          if (scope.datareceipt.primaNeta == 0) {
            scope.datareceipt.primaTotal = 0;
          }
        };

        // Calcula pesos o porcetaje de rpf
        scope.calcularRpf = function () {
          if (valor_prima_descuento == undefined || !valor_prima_descuento) {
            valor_prima_descuento = scope.form.primaNeta;
          }
          if (scope.tipo_rpf.value == 2) {
            if (scope.datareceipt.rpf != 0) {
              scope.rpfPesos =
                (valor_prima_descuento * scope.datareceipt.rpf) / 100;
            } else {
              scope.rpfPesos = 0;
            }
          } else {
            if (scope.datareceipt.rpf != 0) {
              scope.rpfPorcentaje = (
                (scope.datareceipt.rpf * 100) /
                valor_prima_descuento
              ).toFixed(2);
            } else {
              scope.rpfPorcentaje = 0;
            }
          }
          if (
            scope.form.primaTotal &&
            scope.form.from_pdf &&
            parseFloat(scope.datareceipt.primaTotal) == 0.0
          ) {
            scope.datareceipt.primaTotal = scope.form.primaTotal;
            scope.datareceipt.subTotal = scope.form.subTotal;
          }
          if (scope.datareceipt.primaNeta == 0) {
            scope.datareceipt.primaTotal = 0;
          }
        };
        scope.validarPrimaNeta = function () {
          if (scope.datareceipt.primaNeta == 0) {
            scope.datareceipt.primaTotal = 0;
          }
        };
        // Calcula pesos o porcetaje de iva
        scope.calcularIva = function (ivaval) {
          if (scope.tipo_iva.value == 2) {
            if (scope.datareceipt.iva != 0) {
              scope.ivaPesos =
                (scope.datareceipt.subTotal * scope.datareceipt.iva) / 100;
            } else {
              scope.ivaPesos = 0;
            }
          } else {
            if (scope.datareceipt.iva != 0) {
              scope.ivaPorcentaje = (
                (scope.datareceipt.iva * 100) /
                scope.datareceipt.subTotal
              ).toFixed(2);
            } else {
              scope.ivaPorcentaje = 0;
            }
          }
          if (ivaval == 0) {
            scope.datareceipt.iva = parseFloat(ivaval.toFixed(2));
            valor_iva = ivaval;
            scope.ivaPorcentaje = 0;
            scope.ivaPesos = 0;
          }
          // if((scope.datareceipt.iva !=scope.form.iva && scope.form.from_pdf) && (!ivaval || ivaval==undefined) && parseFloat(scope.datareceipt.iva?scope.datareceipt.iva:0).toFixed(0)==0.00){
          if (
            (scope.datareceipt.iva != scope.form.iva &&
              scope.form.from_pdf &&
              (!ivaval || ivaval == undefined)) ||
            parseFloat(
              scope.datareceipt.iva ? scope.datareceipt.iva : 0
            ).toFixed(0) == 0.0
          ) {
            scope.datareceipt.iva = parseFloat(
              (scope.form.iva ? scope.form.iva : 0).toFixed(2)
            );
            // scope.calcularTotales();
          }
          if (scope.datareceipt.primaNeta == 0) {
            scope.datareceipt.primaTotal = 0;
          }
        };

        scope.fixDerecho = function () {
          try {
            scope.datareceipt.derecho = parseFloat(
              scope.datareceipt.derecho
            ).toFixed(2);
          } catch (err) {
            scope.datareceipt.derecho = 0.0;
          }
        };

        // Calcula totales de las primas
        scope.calcularTotales = function (tipodesc, ivaval) {
          if (scope.datareceipt.primaNeta == 0) {
            scope.datareceipt.primaTotal = 0;
          }
          if (tipodesc) {
            scope.tipo_descuento = tipodesc;
          }
          if (
            !scope.datareceipt.primaNeta ||
            scope.datareceipt.primaNeta == undefined
          ) {
            valor_primaNeta = 0;
          } else {
            valor_primaNeta = parseFloat(scope.datareceipt.primaNeta);
          }

          if (
            !scope.datareceipt.descuento ||
            scope.datareceipt.descuento == undefined
          ) {
            valor_descuento = 0;
          } else {
            if (scope.datareceipt.aplicarDescuento) {
              if (scope.tipo_descuento.value == 2) {
                if (scope.datareceipt.descuento > 100) {
                  SweetAlert.swal(
                    "Error",
                    "El descuento no puede ser mayor a 100%.",
                    "error"
                  );
                  scope.datareceipt.descuento = 0;
                  valor_descuento = 0;
                } else {
                  valor_descuento =
                    (scope.datareceipt.primaNeta *
                      scope.datareceipt.descuento) /
                    100;
                }
              } else {
                valor_descuento = scope.datareceipt.descuento;
              }
            } else {
              valor_descuento = scope.datareceipt.descuento;
            }
          }
          scope.calcularDescuento();

          valor_prima_descuento = valor_primaNeta - valor_descuento;
          scope.porcentageRpf();

          if (copy_primaNeta != scope.datareceipt.primaNeta) {
            if (scope.form.rpf && scope.form.from_pdf) {
              scope.datareceipt.rpf = parseFloat(scope.form.rpf);
            } else {
              scope.datareceipt.rpf = parseFloat(
                (
                  valor_prima_descuento *
                  (parseFloat(scope.datareceipt.percent_rpf) / 100)
                ).toFixed(2)
              );
            }
            copy_rpf = angular.copy(scope.datareceipt.rpf);
          } else {
            if (
              scope.datareceipt.aplicarDescuento &&
              copy_rpf == scope.datareceipt.rpf
            ) {
              if (scope.form.rpf && scope.form.from_pdf) {
                scope.datareceipt.rpf = parseFloat(scope.form.rpf);
              } else {
                scope.datareceipt.rpf = parseFloat(
                  (
                    valor_prima_descuento *
                    (parseFloat(scope.datareceipt.percent_rpf) / 100)
                  ).toFixed(2)
                );
              }
              copy_rpf = angular.copy(scope.datareceipt.rpf);
            }
          }

          if (!scope.datareceipt.rpf || scope.datareceipt.rpf == undefined) {
            copy_primaNeta = angular.copy(scope.datareceipt.primaNeta);
            valor_rpf = 0;
          } else {
            if (scope.tipo_rpf.value == 2) {
              if (scope.datareceipt.rpf > 100) {
                SweetAlert.swal(
                  "Error",
                  "El recargo por pago fraccionado no puede ser mayor a 100%.",
                  "error"
                );
                scope.datareceipt.rpf = 0;
                valor_rpf = 0;
              } else {
                valor_rpf =
                  (valor_prima_descuento * scope.datareceipt.rpf) / 100;
              }
            } else {
              copy_primaNeta = angular.copy(scope.datareceipt.primaNeta);
              valor_rpf = scope.datareceipt.rpf;
            }
          }
          scope.calcularRpf();

          if (
            !scope.datareceipt.derecho ||
            scope.datareceipt.derecho == undefined
          ) {
            valor_derecho = 0;
          } else {
            valor_derecho = parseFloat(scope.datareceipt.derecho);
          }

          scope.datareceipt.subTotal = parseFloat(
            (valor_prima_descuento + valor_rpf + valor_derecho).toFixed(2)
          );

          if (!scope.datareceipt.iva || scope.datareceipt.iva == undefined) {
            if (
              scope.datareceipt.subramo == "Vida" ||
              scope.datareceipt.subramo == "Funerarios"
            ) {
              copy_subTotal = angular.copy(scope.datareceipt.subTotal);
              scope.datareceipt.iva = 0;
              valor_iva = 0;
            } else {
              if (ivaval == 0) {
                scope.datareceipt.iva = parseFloat(ivaval.toFixed(2));
                valor_iva = ivaval;
              } else {
                scope.datareceipt.iva = parseFloat(
                  (scope.datareceipt.subTotal * 0.16).toFixed(2)
                );
                valor_iva = scope.datareceipt.iva;
              }
            }
          } else {
            if (scope.tipo_iva.value == 2) {
              if (scope.datareceipt.iva > 100) {
                SweetAlert.swal(
                  "Error",
                  "El iva no puede ser mayor a 100%.",
                  "error"
                );
                scope.datareceipt.iva = 0;
                valor_iva = 0;
              } else {
                valor_iva =
                  (scope.datareceipt.subTotal * scope.datareceipt.iva) / 100;
              }
            } else {
              if (copy_subTotal == scope.datareceipt.subTotal) {
                valor_iva = scope.datareceipt.iva;
              } else {
                copy_subTotal = angular.copy(scope.datareceipt.subTotal);
                scope.datareceipt.iva = parseFloat(
                  (scope.datareceipt.subTotal * 0.16).toFixed(2)
                );
                valor_iva = scope.datareceipt.iva;
              }
            }
          }
          scope.calcularIva(ivaval);
          scope.datareceipt.primaTotal = parseFloat(
            (scope.datareceipt.subTotal + valor_iva).toFixed(2)
          );
          if (
            scope.datareceipt.prima_comision <= 0 ||
            scope.datareceipt.prima_comision > 100 ||
            scope.datareceipt.prima_comision == null
          ) {
            scope.datareceipt.prima_comision = 0;
          }
          if (
            scope.datareceipt.rpf_comision <= 0 ||
            scope.datareceipt.rpf_comision > 100 ||
            scope.datareceipt.rpf_comision == null
          ) {
            scope.datareceipt.rpf_comision = 0;
          }
          if (
            scope.datareceipt.derecho_comision <= 0 ||
            scope.datareceipt.derecho_comision > 100 ||
            scope.datareceipt.derecho_comision == null
          ) {
            scope.datareceipt.derecho_comision = 0;
          }

          scope.valor_prima_comision =
            valor_prima_descuento * (scope.datareceipt.prima_comision / 100);
          scope.valor_rpf_comision =
            valor_rpf * (scope.datareceipt.rpf_comision / 100);
          scope.valor_derecho_comision =
            valor_derecho * (scope.datareceipt.derecho_comision / 100);

          valor_suma_comision = 0;
          scope.datareceipt.comision = 0;
          if (scope.valor_prima_comision != 0) {
            scope.datareceipt.comision = parseFloat(scope.valor_prima_comision);
            valor_suma_comision = valor_prima_descuento;
          }
          if (scope.valor_rpf_comision != 0) {
            scope.datareceipt.comision =
              scope.datareceipt.comision + parseFloat(scope.valor_rpf_comision);
            valor_suma_comision = valor_suma_comision + valor_rpf;
          }
          if (scope.valor_derecho_comision != 0) {
            scope.datareceipt.comision =
              scope.datareceipt.comision +
              parseFloat(scope.valor_derecho_comision);
            valor_suma_comision = valor_suma_comision + valor_derecho;
          }

          scope.datareceipt.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );

          scope.comisionPorcentaje = (
            (scope.datareceipt.comision * 100) /
            valor_suma_comision
          ).toFixed(4);

          if (scope.comisionPorcentaje == "NaN") {
            scope.comisionPorcentaje = 0;
          }

          scope.tosave.comision = scope.datareceipt.comision;
          scope.tosave.comision_percent = scope.comisionPorcentaje;
        };

        // Calcula el porcentaje de la comisión
        scope.calcularComision = function () {
          scope.comisionPorcentaje = (
            (scope.datareceipt.comision * 100) /
            scope.datareceipt.subTotal
          ).toFixed(4);
          scope.form.comision_percent = scope.comisionPorcentaje;
          scope.generarToSave();
        };
        // caluclar policy days duration
        scope.calcularDuracionPoliza = function () {
          // Asegúrate de que las fechas estén en formato DD/MM/YYYY
          if (scope.startDate && scope.endingDate) {
            // Parsear las fechas al formato ISO
            var partesInicio = scope.startDate.split("/");
            var partesFin = scope.endingDate.split("/");

            // Crear objetos Date (Año, Mes - 1, Día)
            var fechaInicio = new Date(
              partesInicio[2],
              partesInicio[1] - 1,
              partesInicio[0]
            );
            var fechaFin = new Date(
              partesFin[2],
              partesFin[1] - 1,
              partesFin[0]
            );

            // Calcular diferencia en milisegundos
            var diffMs = fechaFin - fechaInicio;

            // Convertir a días
            var diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

            // Asignar resultado
            scope.form.policy_days_duration = diffDays;
          } else {
            scope.form.policy_days_duration = scope.form.policy_days_duration;
          }
        };

        // Calcula el primer recibo
        scope.calcularPrimerRecibo = function () {
          try {
            if (
              !scope.datareceipt ||
              scope.datareceipt.policy_days_duration == null || // null/undefined
              isNaN(+scope.datareceipt.policy_days_duration) // NaN o texto no numérico
            ) {
              // --- helpers inline ---
              function parseDMY(str) {
                if (!str) return null;
                var m = /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/.exec(
                  str.trim()
                );
                if (!m) return null;
                var d = +m[1],
                  mo = +m[2] - 1,
                  y = +m[3];
                // usar UTC (mediodía) para evitar problemas de DST
                var dt = new Date(Date.UTC(y, mo, d, 12, 0, 0));
                return isNaN(dt.getTime()) ? null : dt;
              }
              function diffDaysUTC(a, b) {
                var s = Date.UTC(
                  a.getUTCFullYear(),
                  a.getUTCMonth(),
                  a.getUTCDate()
                );
                var e = Date.UTC(
                  b.getUTCFullYear(),
                  b.getUTCMonth(),
                  b.getUTCDate()
                );
                // fin EXCLUSIVO → 29/09/2025 a 29/09/2026 = 365
                return Math.max(0, Math.round((e - s) / 86400000));
                // si lo quieres INCLUSIVO agrega +1
              }

              var s = parseDMY(scope.datareceipt.startDate);
              var e = parseDMY(scope.datareceipt.endingDate);

              if (s && e) {
                scope.datareceipt.policy_days_duration = diffDaysUTC(s, e);
                // INCLUSIVO:
                // scope.datareceipt.policy_days_duration = diffDaysUTC(s, e) + 1;
              } else {
                console.log(
                  "error** no se pudieron parsear fechas",
                  scope.datareceipt
                );
                // if(scope.form.policy_days_duration){
                scope.startDate = scope.form.startDate;
                scope.endingDate = scope.form.endingDate;
                scope.calcularDuracionPoliza();
                // }
              }
            }
          } catch (u) {}
          if (!scope.permiso_comision_no_obligatoria) {
            if (
              scope.datareceipt.prima_comision == 0 ||
              scope.datareceipt.prima_comision == "0" ||
              scope.datareceipt.prima_comision == ""
            ) {
              SweetAlert.swal(
                "¡Error!",
                "La comisión de prima neta es obligatoria.",
                "error"
              );
              scope.form.canCreate = false;
              scope.mostrarPrimerRecibo = false;
              return;
            }
          }

          scope.form.canCreate = false;
          if (!scope.comision_seleccion) {
            SweetAlert.swal(
              "¡Error!",
              "Debe elegir un valor de comisión.",
              "error"
            );
            return;
          }
          scope.datareceipt.startDate = scope.form.startDate;
          scope.datareceipt.endingDate = scope.form.endingDate;

          if (!scope.editar) {
            scope.datareceipt.payment = scope.form.payment;
          } else {
            scope.datareceipt.payment = scope.form.payment.value;
          }
          // console.log('iiiiiiiiiiii',scope.datareceipt.derecho,scope.datareceipt)
          scope.datareceipt.policy_days_duration =
            scope.form.policy_days_duration;
          scope.datareceipt.primaNeta = parseFloat(scope.datareceipt.primaNeta);
          scope.datareceipt.derecho = parseFloat(scope.datareceipt.derecho);
          scope.datareceipt.subTotal = parseFloat(scope.datareceipt.subTotal);
          scope.datareceipt.comision = parseFloat(scope.datareceipt.comision);
          if (scope.recalcular) {
            switch (parseFloat(scope.datareceipt.payment)) {
              case 1:
                scope.numeroRecibos = 12;
                break;
              case 2:
                scope.numeroRecibos = 6;
                break;
              case 3:
                scope.numeroRecibos = 4;
                break;
              case 4:
                scope.numeroRecibos = 3;
                break;
              case 5:
                scope.numeroRecibos = 1; //contado
                break;
              case 6:
                scope.numeroRecibos = 2;
                break;
              case 12:
                scope.numeroRecibos = 1; //anual
                break;
              default:
                break;
            }
            // -------
            // ***********
            if (scope.datareceipt.policy_days_duration < 365) {
              scope.calcularRecibosCortos(1);
            } else if (
              scope.datareceipt.policy_days_duration == 365 ||
              scope.datareceipt.policy_days_duration == 366
            ) {
              scope.calcularRecibos(1);
            } else if (scope.datareceipt.policy_days_duration > 366) {
              scope.calcularRecibosMultianuales(1);
            }
            // console.log('days durat dirct',scope.datareceipt.policy_days_duration)
            SweetAlert.swal(
              "¡Atención!",
              "Introduce las primas para el primer recibo, después genera los recibos subsecuentes.",
              "warning"
            );
          } else {
            SweetAlert.swal(
              "¡Error se modificaron primas!",
              "Y existen recibos pagados, las primas de la póliza se podrán guardar pero cada recibo se deberá que modificar de manera manual desde la información.",
              "error"
            );
          }
        };

        // Recalcula el primer recibo
        scope.calcularTotalPrimerRecibo = function () {
          scope.form.canCreate = false;
          if (
            scope.todos_prima[0] == scope.datareceipt.receipts[0].prima_neta
          ) {
            scope.datareceipt.receipts[0].rpf =
              scope.datareceipt.receipts[0].rpf;
          } else {
            scope.todos_prima = [];
            scope.datareceipt.receipts.forEach(function (receipt) {
              scope.todos_prima.push(receipt.prima_neta);
            });
            if (scope.obj_rpf != null) {
              scope.datareceipt.receipts[0].rpf = scope.obj_rpf;
            } else {
              scope.datareceipt.receipts[0].rpf =
                scope.datareceipt.receipts[0].prima_neta *
                ((valor_rpf * 100) / scope.datareceipt.primaNeta / 100);
            }
          }

          if (scope.datareceipt.receipts[0].derecho == null) {
            scope.datareceipt.receipts[0].derecho = 0;
          }

          scope.datareceipt.receipts[0].sub_total =
            scope.datareceipt.receipts[0].prima_neta +
            scope.datareceipt.receipts[0].rpf +
            scope.datareceipt.receipts[0].derecho;

          if (
            scope.todos_subtotal[0] == scope.datareceipt.receipts[0].sub_total
          ) {
            scope.datareceipt.receipts[0].iva =
              scope.datareceipt.receipts[0].iva;
          } else {
            scope.todos_subtotal = [];
            scope.datareceipt.receipts.forEach(function (receipt) {
              scope.todos_subtotal.push(receipt.sub_total);
            });
            scope.datareceipt.receipts[0].iva =
              scope.datareceipt.receipts[0].sub_total *
              ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
          }
          scope.datareceipt.receipts[0].prima_total =
            scope.datareceipt.receipts[0].sub_total +
            scope.datareceipt.receipts[0].iva;

          var comision_primer_recibo_prima =
            scope.datareceipt.receipts[0].prima_neta *
            (scope.datareceipt.prima_comision / 100);
          var comision_primer_recibo_rpf =
            scope.datareceipt.receipts[0].rpf *
            (scope.datareceipt.rpf_comision / 100);
          var comision_primer_recibo_derecho =
            scope.datareceipt.receipts[0].derecho *
            (scope.datareceipt.derecho_comision / 100);

          scope.datareceipt.receipts[0].comision =
            comision_primer_recibo_prima +
            comision_primer_recibo_rpf +
            comision_primer_recibo_derecho;

          scope.datareceipt.receipts[0].prima_neta = parseFloat(
            scope.datareceipt.receipts[0].prima_neta.toFixed(2)
          );
          scope.datareceipt.receipts[0].rpf = parseFloat(
            scope.datareceipt.receipts[0].rpf.toFixed(2)
          );
          scope.datareceipt.receipts[0].derecho = parseFloat(
            scope.datareceipt.receipts[0].derecho.toFixed(2)
          );
          scope.datareceipt.receipts[0].sub_total = parseFloat(
            scope.datareceipt.receipts[0].sub_total.toFixed(2)
          );
          scope.datareceipt.receipts[0].iva = parseFloat(
            scope.datareceipt.receipts[0].iva.toFixed(2)
          );
          scope.datareceipt.receipts[0].prima_total = parseFloat(
            scope.datareceipt.receipts[0].prima_total.toFixed(2)
          );
          scope.datareceipt.receipts[0].comision = parseFloat(
            scope.datareceipt.receipts[0].comision.toFixed(2)
          );
        };
        // calcualr prima neta si meuve prima total
        scope.calcularNetaPrimerRecibo = function () {
          var recibo = scope.datareceipt.receipts[0];

          // Conversión segura a número
          var primaTotal = parseFloat(recibo.prima_total) || 0;
          var derecho = parseFloat(recibo.derecho) || 0;
          var rpf = parseFloat(recibo.rpf) || 0;

          // IVA dinámico (puede ser 0)
          var ivaRate = 0.16;
          if (
            scope.datareceipt &&
            scope.datareceipt.subramo &&
            (scope.datareceipt.subramo.subramo_code == 1 ||
              scope.datareceipt.subramo.subramo_code == 30 ||
              scope.datareceipt.subramo.subramo_name == "Vida" ||
              scope.datareceipt.subramo.subramo_name == "Funerarios" ||
              scope.datareceipt.subramo == "Vida" ||
              scope.datareceipt.subramo == "Funerarios")
          ) {
            ivaRate = 0;
          }

          // Base sin IVA
          var baseSinIva = primaTotal - derecho - rpf;

          // Calcular prima neta e IVA
          var primaNeta = ivaRate > 0 ? baseSinIva / (1 + ivaRate) : baseSinIva;
          var iva = ivaRate > 0 ? baseSinIva - primaNeta : 0;

          // Redondear a 2 decimales
          primaNeta = Math.round(primaNeta * 100) / 100;
          iva = Math.round(iva * 100) / 100;

          // Asignar valores finales al recibo
          recibo.prima_total = primaTotal;
          recibo.prima_neta = primaNeta;
          recibo.iva = iva;
        };
        // Calcula recibos subsecuentes con cambios en primer recibo
        scope.calcularSiguientesRecibos = function () {
          SweetAlert.swal(
            "¡Atención!",
            "Revise la información de primas y fechas de cada recibo ya que pueden no ser exactas",
            "warning"
          );
          scope.firstReceipt = angular.copy(scope.datareceipt.receipts[0]);

          if (
            scope.datareceipt.primaNeta >=
            scope.datareceipt.receipts[0].prima_neta
          ) {
            scope.newPrima.primaNeta =
              scope.datareceipt.primaNeta -
              scope.datareceipt.receipts[0].prima_neta;
          } else {
            SweetAlert.swal(
              "Error",
              "La prima neta del primer recibo es mayor a la prima neta de la póliza.",
              "error"
            );
            return;
          }
          if (valor_rpf > 1) {
            if (valor_rpf >= scope.datareceipt.receipts[0].rpf) {
              scope.newPrima.rpf =
                valor_rpf - scope.datareceipt.receipts[0].rpf;
            } else {
              SweetAlert.swal(
                "Error",
                "El RPF del primer recibo es mayor al RPF de la póliza.",
                "error"
              );
              return;
            }
          } else {
            if (valor_rpf >= scope.datareceipt.receipts[0].rpf) {
              scope.newPrima.rpf =
                valor_rpf - scope.datareceipt.receipts[0].rpf;
            } else {
              scope.newPrima.rpf =
                valor_rpf - scope.datareceipt.receipts[0].rpf;
            }
          }

          if (
            scope.datareceipt.derecho >= scope.datareceipt.receipts[0].derecho
          ) {
            scope.newPrima.derecho =
              scope.datareceipt.derecho - scope.datareceipt.receipts[0].derecho;
          } else {
            SweetAlert.swal(
              "Error",
              "El derecho del primer recibo es mayor al derecho de la póliza.",
              "error"
            );
            return;
          }

          if (
            scope.datareceipt.subTotal >=
            scope.datareceipt.receipts[0].sub_total
          ) {
            scope.newPrima.subTotal =
              scope.datareceipt.subTotal -
              scope.datareceipt.receipts[0].sub_total;
          } else {
            if (scope.datareceipt.primaNeta == 0) {
              scope.datareceipt.receipts[0].sub_total = 0;
              scope.datareceipt.subTotal = 0;
              scope.datareceipt.iva = 0;
              scope.datareceipt.primaTotal = 0;
            }
            scope.newPrima.subTotal = 0;
          }

          if (valor_iva >= scope.datareceipt.receipts[0].iva) {
            scope.newPrima.iva = valor_iva - scope.datareceipt.receipts[0].iva;
          } else {
            if (isNaN(valor_iva)) {
              valor_iva = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "El iva del primer recibo es mayor al iva de la póliza.",
                "error"
              );
              return;
            }
          }

          if (
            scope.datareceipt.primaTotal >=
            scope.datareceipt.receipts[0].prima_total
          ) {
            scope.newPrima.primaTotal =
              scope.datareceipt.primaTotal -
              scope.datareceipt.receipts[0].prima_total;
          } else {
            if (isNaN(scope.datareceipt.primaTotal)) {
              scope.newPrima.primaTotal = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "La prima total del primer recibo es mayor a la prima total de la póliza.",
                "error"
              );
              return;
            }
          }

          if (
            scope.datareceipt.comision >= scope.datareceipt.receipts[0].comision
          ) {
            scope.newPrima.comision =
              scope.datareceipt.comision -
              scope.datareceipt.receipts[0].comision;
          } else {
            scope.newPrima.comision = 0;
          }

          scope.form.canCreate = true;

          if (scope.datareceipt.policy_days_duration < 365) {
            scope.calcularRecibosCortos(2);
          } else if (
            scope.datareceipt.policy_days_duration == 365 ||
            scope.datareceipt.policy_days_duration == 366
          ) {
            scope.calcularRecibos(2);
          } else if (scope.datareceipt.policy_days_duration > 366) {
            scope.calcularRecibosMultianuales(2);
          }
        };

        // Calcula recibos de menos de un año de vigencia
        scope.calcularRecibosCortos = function (value) {
          scope.datareceipt.receipts = [];

          var recibos_fracionados =
            (scope.datareceipt.policy_days_duration * scope.numeroRecibos) /
            366;
          var arreglo_recibos = recibos_fracionados.toString().split(".");
          var recibos_completos = parseFloat(arreglo_recibos[0]);
          var recibos_incompletos = "0." + arreglo_recibos[1];
          recibos_incompletos = parseFloat(recibos_incompletos);

          if (recibos_incompletos < 0.05) {
            recibos_fracionados = angular.copy(recibos_completos);
            recibos_incompletos = 1;
            recibos_completos = recibos_completos - 1;
          }
          if (recibos_completos < 0) {
            recibos_completos = parseInt(recibos_completos) * -1;
          }
          if (value == 1) {
            scope.obj = {
              prima_neta:
                (recibos_incompletos * scope.datareceipt.primaNeta) /
                recibos_fracionados,
              rpf:
                (valor_rpf ? recibos_incompletos * valor_rpf : 0) /
                recibos_fracionados,
              derecho:
                (scope.datareceipt.derecho
                  ? recibos_incompletos * scope.datareceipt.derecho
                  : 0) / recibos_fracionados,
              subTotal:
                (recibos_incompletos * scope.datareceipt.subTotal) /
                recibos_fracionados,
              iva:
                (valor_iva ? recibos_incompletos * valor_iva : 0) /
                recibos_fracionados,
              primaTotal:
                (scope.datareceipt.primaTotal
                  ? recibos_incompletos * scope.datareceipt.primaTotal
                  : 0) / recibos_fracionados,
              comision:
                (scope.datareceipt.comision
                  ? recibos_incompletos * scope.datareceipt.comision
                  : 0) / recibos_fracionados,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (recibos_incompletos * valor_prima_descuento) /
                recibos_fracionados;
            }
            if (isFinite(scope.obj.prima_neta)) {
              console.log("is Finite", isFinite(scope.obj.prima_neta));
            } else {
              console.log(
                "no is Finite, is Infinity",
                isFinite(scope.obj.prima_neta)
              );
              scope.obj = {
                prima_neta:
                  (recibos_incompletos * scope.datareceipt.primaNeta) /
                  scope.numeroRecibos,
                rpf:
                  (valor_rpf ? recibos_incompletos * valor_rpf : 0) /
                  scope.numeroRecibos,
                derecho:
                  (scope.datareceipt.derecho
                    ? recibos_incompletos * scope.datareceipt.derecho
                    : 0) / scope.numeroRecibos,
                subTotal:
                  (recibos_incompletos * scope.datareceipt.subTotal) /
                  scope.numeroRecibos,
                iva:
                  (valor_iva ? recibos_incompletos * valor_iva : 0) /
                  scope.numeroRecibos,
                primaTotal:
                  (scope.datareceipt.primaTotal
                    ? recibos_incompletos * scope.datareceipt.primaTotal
                    : 0) / scope.numeroRecibos,
                comision:
                  (scope.datareceipt.comision
                    ? recibos_incompletos * scope.datareceipt.comision
                    : 0) / scope.numeroRecibos,
              };
            }
            scope.mostrarPrimerRecibo = true;
            scope.mostrarTodosRecibo = false;
          } else {
            scope.obj = {
              prima_neta: scope.newPrima.primaNeta / recibos_completos,
              rpf:
                (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                recibos_completos,
              derecho:
                (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                recibos_completos,
              subTotal: scope.newPrima.subTotal / recibos_completos,
              iva:
                (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                recibos_completos,
              primaTotal:
                (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                recibos_completos,
              comision:
                (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                recibos_completos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (scope.newPrima.primaNeta - valor_descuento) /
                recibos_completos;
            }

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;

            if (recibos_completos <= recibos_fracionados) {
              scope.numeroRecibos = recibos_completos + 1;
            }
          }

          for (var i = 0; i < scope.numeroRecibos; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                // if(scope.datareceipt.rpf){
                //   scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                // }else{
                //   scope.obj.rpf = 0;
                // }
                if (scope.tipo_rpf.value == 2) {
                  if (scope.datareceipt.rpf != 0) {
                    scope.rpfPesos =
                      (valor_prima_descuento * scope.datareceipt.rpf) / 100;
                    scope.obj.rpf = parseFloat(scope.rpfPesos);
                  } else {
                    scope.rpfPesos = 0;
                  }
                } else {
                  if (scope.datareceipt.rpf != 0) {
                    scope.rpfPorcentaje = (
                      (scope.datareceipt.rpf * 100) /
                      valor_prima_descuento
                    ).toFixed(2);
                    scope.obj.rpf = parseFloat(scope.rpfPorcentaje);
                  } else {
                    scope.rpfPorcentaje = 0;
                  }
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            var receipt = {
              recibo_numero: i + 1,
              prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
              rpf: parseFloat(scope.obj.rpf.toFixed(2)),
              derecho: parseFloat(scope.obj.derecho.toFixed(2)),
              iva: parseFloat(scope.obj.iva.toFixed(2)),
              sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
              prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
              comision: parseFloat(scope.obj.comision.toFixed(2)),
              receipt_type: 1,
              delivered: false,
              fecha_inicio: scope.obtenerVigenciaInicialCorta(
                i,
                recibos_completos
              ),
              fecha_fin: scope.obtenerVigenciaFinalCorta(recibos_completos),
            };
            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.fecha_inicio
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));

            if (
              scope.datareceipt.receipts &&
              scope.datareceipt.receipts.length == 1
            ) {
              scope.datareceipt.receipts[0]["fecha_inicio"] =
                scope.datareceipt.startDate;
            }

            recibos_completos--;
          }

          if (value == 2) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }

          scope.generarToSave(value);
        };

        // Calcula recibos de un año de vigencia
        scope.calcularRecibos = function (value) {
          scope.datareceipt.receipts = [];

          scope.numeroRecibosNuevos = scope.numeroRecibos - 1;
          if (scope.numeroRecibosNuevos < 1) {
            scope.numeroRecibosNuevos = 1;
          }

          if (value == 1) {
            scope.obj = {
              prima_neta: scope.datareceipt.primaNeta / scope.numeroRecibos,
              rpf: (valor_rpf ? valor_rpf : 0) / scope.numeroRecibos,
              derecho:
                (scope.datareceipt.derecho ? scope.datareceipt.derecho : 0) /
                scope.numeroRecibos,
              subTotal: scope.datareceipt.subTotal / scope.numeroRecibos,
              iva: (valor_iva ? valor_iva : 0) / scope.numeroRecibos,
              primaTotal:
                (scope.datareceipt.primaTotal
                  ? scope.datareceipt.primaTotal
                  : 0) / scope.numeroRecibos,
              comision:
                (scope.datareceipt.comision ? scope.datareceipt.comision : 0) /
                scope.numeroRecibos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                valor_prima_descuento / scope.numeroRecibos;
            }

            scope.mostrarPrimerRecibo = true;
            scope.mostrarTodosRecibo = false;
          } else {
            scope.obj = {
              prima_neta: scope.newPrima.primaNeta / scope.numeroRecibosNuevos,
              rpf:
                (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                scope.numeroRecibosNuevos,
              derecho:
                (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                scope.numeroRecibosNuevos,
              subTotal: scope.newPrima.subTotal / scope.numeroRecibosNuevos,
              iva:
                (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                scope.numeroRecibosNuevos,
              primaTotal:
                (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                scope.numeroRecibosNuevos,
              comision:
                (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                scope.numeroRecibosNuevos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (scope.newPrima.primaNeta - valor_descuento) /
                scope.numeroRecibosNuevos;
            }

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;
          }

          for (var i = 0; i < scope.numeroRecibos; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                // if(scope.datareceipt.rpf){
                //   scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                // }else{
                //   scope.obj.rpf = 0;
                // }
                if (scope.tipo_rpf.value == 2) {
                  if (scope.datareceipt.rpf != 0) {
                    scope.rpfPesos =
                      (valor_prima_descuento * scope.datareceipt.rpf) / 100;
                    scope.obj.rpf = parseFloat(scope.rpfPesos);
                  } else {
                    scope.obj.rpf = 0;
                  }
                } else {
                  if (scope.datareceipt.rpf != 0) {
                    scope.rpfPorcentaje = (
                      (scope.datareceipt.rpf * 100) /
                      valor_prima_descuento
                    ).toFixed(2);
                    scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                  } else {
                    scope.obj.rpf = 0;
                  }
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            var receipt = {
              recibo_numero: i + 1,
              prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
              rpf: parseFloat(scope.obj.rpf.toFixed(2)),
              derecho: parseFloat(scope.obj.derecho.toFixed(2)),
              iva: parseFloat(scope.obj.iva.toFixed(2)),
              sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
              prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
              comision: parseFloat(scope.obj.comision.toFixed(2)),
              receipt_type: 1,
              delivered: false,
              fecha_inicio: scope.obtenerVigenciaInicial(i),
              fecha_fin: scope.obtenerVigenciaFinal(i),
            };

            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.fecha_inicio
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));
          }

          if (value == 2) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }
          scope.generarToSave(value);
        };
        scope.limitDecimals = function () {
          if (
            scope.datareceipt.prima_comision !== null &&
            scope.datareceipt.prima_comision !== undefined
          ) {
            scope.datareceipt.prima_comision = parseFloat(
              scope.datareceipt.prima_comision.toFixed(4)
            );
          }
        };
        // Calcula recibos de mas de año de vigencia
        scope.calcularRecibosMultianuales = function (value) {
          scope.datareceipt.receipts = [];

          if (!scope.datareceipt.startDate) {
            scope.datareceipt.startDate = scope.form.startDate;
            scope.datareceipt.endingDate = scope.form.endingDate;
          }

          var date_initial = scope.datareceipt.startDate.split("/");
          var date_final = scope.datareceipt.endingDate.split("/");
          var anio_initial = parseInt(date_initial[2]);
          var anio_final = parseInt(date_final[2]);
          var total_anios = anio_final - anio_initial;

          if (scope.datareceipt.payment == 5) {
            total_anios = 1;
          }

          scope.numeroRecibosAnios = scope.numeroRecibos * total_anios;

          scope.numeroRecibosAniosNuevos = scope.numeroRecibosAnios - 1;
          if (scope.numeroRecibosAniosNuevos < 1) {
            scope.numeroRecibosAniosNuevos = 1;
          }

          if (value == 1) {
            scope.obj = {
              prima_neta:
                scope.datareceipt.primaNeta / scope.numeroRecibosAnios,
              rpf: (valor_rpf ? valor_rpf : 0) / scope.numeroRecibosAnios,
              derecho:
                (scope.datareceipt.derecho ? scope.datareceipt.derecho : 0) /
                scope.numeroRecibosAnios,
              subTotal: scope.datareceipt.subTotal / scope.numeroRecibosAnios,
              iva: (valor_iva ? valor_iva : 0) / scope.numeroRecibosAnios,
              primaTotal:
                (scope.datareceipt.primaTotal
                  ? scope.datareceipt.primaTotal
                  : 0) / scope.numeroRecibosAnios,
              comision:
                (scope.datareceipt.comision ? scope.datareceipt.comision : 0) /
                scope.numeroRecibosAnios,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                valor_prima_descuento / scope.numeroRecibosAnios;
            }

            scope.mostrarPrimerRecibo = true;
            scope.mostrarTodosRecibo = false;
          } else {
            scope.obj = {
              prima_neta:
                scope.newPrima.primaNeta / scope.numeroRecibosAniosNuevos,
              rpf:
                (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                scope.numeroRecibosAniosNuevos,
              derecho:
                (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                scope.numeroRecibosAniosNuevos,
              subTotal:
                scope.newPrima.subTotal / scope.numeroRecibosAniosNuevos,
              iva:
                (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                scope.numeroRecibosAniosNuevos,
              primaTotal:
                (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                scope.numeroRecibosAniosNuevos,
              comision:
                (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                scope.numeroRecibosAniosNuevos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (scope.newPrima.primaNeta - valor_descuento) /
                scope.numeroRecibosAniosNuevos;
            }

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;
          }

          var j = 0;
          var index_anual = 0;
          var numero_anio = 0;

          for (var i = 0; i < scope.numeroRecibosAnios; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                if (scope.datareceipt.rpf) {
                  scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                } else {
                  scope.obj.rpf = 0;
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            if (scope.datareceipt.fy) {
              if (i >= scope.numeroRecibos) {
                scope.obj = {
                  prima_neta: 0,
                  rpf: 0,
                  derecho: 0,
                  subTotal: 0,
                  iva: 0,
                  primaTotal: 0,
                  comision: 0,
                };
              }
            }

            if (j >= scope.numeroRecibos) {
              j = 1;
            } else {
              j++;
            }

            var receipt = {
              recibo_numero: j,
              prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
              rpf: parseFloat(scope.obj.rpf.toFixed(2)),
              derecho: parseFloat(scope.obj.derecho.toFixed(2)),
              iva: parseFloat(scope.obj.iva.toFixed(2)),
              sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
              prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
              comision: parseFloat(scope.obj.comision.toFixed(2)),
              receipt_type: 1,
              delivered: false,
              fecha_inicio: scope.obtenerVigenciaInicialMultianual(
                index_anual,
                numero_anio
              ),
              fecha_fin: scope.obtenerVigenciaFinalMultianual(
                index_anual,
                numero_anio
              ),
            };

            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.fecha_inicio
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));

            index_anual++;
            if (index_anual >= scope.numeroRecibos) {
              index_anual = 0;
              numero_anio++;
            }
          }

          if (value == 2) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }

          scope.generarToSave(value);
        };

        // Calcula las fechas de inicio de los recibos menores de un año de vigencia
        scope.obtenerVigenciaInicialCorta = function (index, value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var year_init_date = scope.datareceipt.startDate.split("/")[2];
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          mes = mes - (value + 1) * parseFloat(scope.datareceipt.payment);
          if (mes < 0) {
            mes = mes + 12;
            anio = anio - 1;
          } else if (mes == 0) {
            mes = 12;
            anio = anio - 1;
          }

          if (index == 0) {
            date_initial = scope.datareceipt.startDate.split("/");
            dia = parseInt(date_initial[0]);
            mes = parseInt(date_initial[1]);
          }

          if (dia == 31) {
            if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 30;
            } else if (mes == 2) {
              dia = 28;
            }
          }

          if (dia > 28 && mes == 2) {
            dia = 28;
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          return dia + "/" + mes + "/" + anio;
        };

        // Calcula las fechas de inicio de los recibos con un año de vigencia
        scope.obtenerVigenciaInicial = function (index) {
          var date_initial = scope.datareceipt.startDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          mes = mes + index * parseFloat(scope.datareceipt.payment);

          if (mes > 12) {
            mes = mes - 12;
            anio = anio + 1;
          }

          if (dia == 31) {
            if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 30;
            } else if (mes == 2) {
              dia = 28;
            }
          }

          if (dia > 28 && mes == 2) {
            dia = 28;
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          return dia + "/" + mes + "/" + anio;
        };

        // Calcula las fechas de inicio de los recibos con mayores de un año de vigencia
        scope.obtenerVigenciaInicialMultianual = function (value, number) {
          var date_initial = scope.datareceipt.startDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          mes = mes + value * parseFloat(scope.datareceipt.payment);

          if (mes > 12) {
            mes = mes - 12;
            anio = anio + 1;
          }

          if (dia == 31) {
            if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 30;
            } else if (mes == 2) {
              dia = 28;
            }
          }

          if (dia > 28 && mes == 2) {
            dia = 28;
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          anio = anio + number;

          return dia + "/" + mes + "/" + anio;
        };

        // Calcula las fechas de fin de los recibos menores de un año de vigencia
        scope.obtenerVigenciaFinalCorta = function (value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          if (parseFloat(scope.datareceipt.payment) == 5) {
            mes = mes - value * 12;
          } else {
            mes = mes - value * parseFloat(scope.datareceipt.payment);
          }

          if (mes < 0) {
            mes = mes + 12;
            anio = anio - 1;
          } else if (mes == 0) {
            mes = 12;
            anio = anio - 1;
          }

          if (dia == 31) {
            if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 30;
            } else if (mes == 2) {
              dia = 28;
            }
          }

          if (dia > 28 && mes == 2) {
            dia = 28;
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }
          if (
            parseFloat(scope.datareceipt.payment) == 5 &&
            parseFloat(scope.datareceipt.policy_days_duration) < 365
          ) {
            if (anio != parseInt(date_initial[2])) {
              anio = parseInt(date_initial[2]);
            }
          }
          var dateFin_ =
            date_initial[0] + "/" + date_initial[1] + "/" + date_initial[2];
          if (mes == date_initial[1] && anio == date_initial[2]) {
            dia = date_initial[0];
          }
          return dia + "/" + mes + "/" + anio;
        };

        // Calcula las fechas de fin de los recibos con un año de vigencia
        scope.obtenerVigenciaFinal = function (index) {
          var date_initial = scope.datareceipt.startDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          if (parseFloat(scope.datareceipt.payment) == 5) {
            mes = mes + (index + 1) * 12;
          } else {
            mes = mes + (index + 1) * parseFloat(scope.datareceipt.payment);
          }

          if (mes > 12) {
            mes = mes - 12;
            anio = anio + 1;
          }

          if (dia == 31) {
            if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 30;
            } else if (mes == 2) {
              dia = 28;
            }
          }

          if (dia > 28 && mes == 2) {
            dia = 28;
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }
          if (
            scope.datareceipt.payment == 12 ||
            scope.datareceipt.payment == "12" ||
            scope.datareceipt.payment == 5 ||
            scope.datareceipt.payment == "5"
          ) {
            return scope.datareceipt.endingDate;
          } else {
            return dia + "/" + mes + "/" + anio;
          }
        };

        // Calcula las fechas de fin de los recibos con mayores de un año de vigencia
        scope.obtenerVigenciaFinalMultianual = function (index, number) {
          var date_initial = scope.datareceipt.startDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          if (parseFloat(scope.datareceipt.payment) == 5) {
            mes = mes + (index + 1) * 12;
            var date_initial = scope.datareceipt.endingDate.split("/");
            anio = parseInt(date_initial[2]);
          } else {
            mes = mes + (index + 1) * parseFloat(scope.datareceipt.payment);
          }
          if (mes > 12) {
            mes = mes - 12;
            if (parseFloat(scope.datareceipt.payment) != 5) {
              anio = anio + 1;
            }
          }

          if (dia == 31) {
            if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 30;
            } else if (mes == 2) {
              dia = 28;
            }
          }

          if (dia > 28 && mes == 2) {
            dia = 28;
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          anio = anio + number;

          return dia + "/" + mes + "/" + anio;
        };

        // Calcula las fechas de vencimiento de los recibos
        scope.obtenerVencimiento = function (index, date) {
          var date_initial = date.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          if (index == 0) {
            dia = dia + scope.datareceipt.periodo_inicial;
          } else {
            dia = dia + scope.datareceipt.periodo_subsecuente;
          }

          if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
            if (dia > 30) {
              dia = dia - 30;
              mes = mes + 1;
              if (mes > 12) {
                mes = mes - 12;
                anio = anio + 1;
              }
            }
          } else if (mes == 2) {
            if (dia > 28) {
              dia = dia - 28;
              mes = mes + 1;
            }
          } else {
            if (dia > 31) {
              dia = dia - 31;
              mes = mes + 1;
              if (mes > 12) {
                mes = mes - 12;
                anio = anio + 1;
              }
            }
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          if (
            parseFloat(scope.datareceipt.payment) == 5 &&
            parseFloat(scope.datareceipt.policy_days_duration) < 365
          ) {
            var otro = scope.datareceipt.endingDate.split("/");
            if (
              anio != parseInt(date_initial[2]) &&
              scope.datareceipt.endingDate != date_initial
            ) {
              anio = parseInt(date_initial[2]);
            }
            if (anio < parseInt(scope.datareceipt.startDate.split("/")[2])) {
              anio = scope.datareceipt.startDate.split("/")[2];
            }
          }
          return dia + "/" + mes + "/" + anio;
        };

        // Recalcula un recibo
        scope.recalcularRecibo = function (index) {
          if (
            scope.todos_prima[index] ==
            scope.datareceipt.receipts[index].prima_neta
          ) {
            scope.datareceipt.receipts[index].rpf =
              scope.datareceipt.receipts[index].rpf;
          } else {
            scope.todos_prima[index] =
              scope.datareceipt.receipts[index].prima_neta;
            scope.datareceipt.receipts[index].rpf =
              scope.datareceipt.receipts[index].prima_neta *
              ((valor_rpf * 100) / scope.datareceipt.primaNeta / 100);
          }

          if (scope.datareceipt.receipts[index].derecho == null) {
            scope.datareceipt.receipts[index].derecho = 0;
          }

          scope.datareceipt.receipts[index].sub_total =
            scope.datareceipt.receipts[index].prima_neta +
            scope.datareceipt.receipts[index].rpf +
            scope.datareceipt.receipts[index].derecho;

          if (
            scope.todos_subtotal[index] ==
            scope.datareceipt.receipts[index].sub_total
          ) {
            scope.datareceipt.receipts[index].iva =
              scope.datareceipt.receipts[index].iva;
          } else {
            scope.todos_subtotal[index] =
              scope.datareceipt.receipts[index].sub_total;
            scope.datareceipt.receipts[index].iva =
              scope.datareceipt.receipts[index].sub_total *
              ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
          }
          scope.datareceipt.receipts[index].prima_total = parseFloat(
            scope.datareceipt.receipts[index].sub_total +
              scope.datareceipt.receipts[index].iva
          );

          var comision_prima =
            scope.datareceipt.receipts[index].prima_neta *
            (scope.datareceipt.prima_comision / 100);
          var comision_rpf =
            scope.datareceipt.receipts[index].rpf *
            (scope.datareceipt.rpf_comision / 100);
          var comision_derecho =
            scope.datareceipt.receipts[index].derecho *
            (scope.datareceipt.derecho_comision / 100);

          // scope.datareceipt.receipts[index].comision = comision_prima + comision_rpf + comision_derecho;

          // scope.datareceipt.receipts[index].prima_neta = parseFloat((scope.datareceipt.receipts[index].prima_neta).toFixed(2));
          // scope.datareceipt.receipts[index].rpf = parseFloat((scope.datareceipt.receipts[index].rpf).toFixed(2));
          // scope.datareceipt.receipts[index].derecho = parseFloat((scope.datareceipt.receipts[index].derecho).toFixed(2));
          // scope.datareceipt.receipts[index].sub_total = parseFloat((scope.datareceipt.receipts[index].sub_total).toFixed(2));
          // scope.datareceipt.receipts[index].iva = parseFloat((scope.datareceipt.receipts[index].iva).toFixed(2));
          // scope.datareceipt.receipts[index].prima_total = parseFloat((scope.datareceipt.receipts[index].prima_total).toFixed(2));
          // scope.datareceipt.receipts[index].comision = parseFloat((scope.datareceipt.receipts[index].comision).toFixed(2));
          // Calcular comisiones si existen componentes, sino 0
          scope.datareceipt.receipts[index].comision =
            (comision_prima || 0) +
            (comision_rpf || 0) +
            (comision_derecho || 0);
          // Aplicar ternario y formato:
          scope.datareceipt.receipts[index].prima_neta = scope.datareceipt
            .receipts[index].prima_neta
            ? parseFloat(
                scope.datareceipt.receipts[index].prima_neta.toFixed(2)
              )
            : 0;
          scope.datareceipt.receipts[index].rpf = scope.datareceipt.receipts[
            index
          ].rpf
            ? parseFloat(scope.datareceipt.receipts[index].rpf.toFixed(2))
            : 0;
          scope.datareceipt.receipts[index].derecho = scope.datareceipt
            .receipts[index].derecho
            ? parseFloat(scope.datareceipt.receipts[index].derecho.toFixed(2))
            : 0;
          scope.datareceipt.receipts[index].sub_total = scope.datareceipt
            .receipts[index].sub_total
            ? parseFloat(scope.datareceipt.receipts[index].sub_total.toFixed(2))
            : 0;
          scope.datareceipt.receipts[index].iva = scope.datareceipt.receipts[
            index
          ].iva
            ? parseFloat(scope.datareceipt.receipts[index].iva.toFixed(2))
            : 0;
          scope.datareceipt.receipts[index].prima_total = scope.datareceipt
            .receipts[index].prima_total
            ? parseFloat(
                scope.datareceipt.receipts[index].prima_total.toFixed(2)
              )
            : 0;
          scope.datareceipt.receipts[index].comision = scope.datareceipt
            .receipts[index].comision
            ? parseFloat(scope.datareceipt.receipts[index].comision.toFixed(2))
            : 0;
        };

        scope.recalcularTotal = function (index) {
          scope.datareceipt.receipts[index].prima_total = parseFloat(
            scope.datareceipt.receipts[index].prima_total.toFixed(2)
          );
        };

        // Racalcula la comision de un recibo
        scope.recalcularComision = function (index) {
          scope.datareceipt.receipts[index].comision = parseFloat(
            scope.datareceipt.receipts[index].comision.toFixed(2)
          );
          scope.datareceipt.comision = 0;
          scope.datareceipt.receipts.forEach(function (receipt) {
            scope.datareceipt.comision =
              scope.datareceipt.comision + parseFloat(receipt.comision);
          });

          scope.datareceipt.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );

          scope.calcularComision();
        };

        // Muestra la edición de los recibos
        scope.editarRecibos = function () {
          if (!scope.comision_seleccion) {
            SweetAlert.swal(
              "¡Error!",
              "Debe elegir un valor de comisión.",
              "error"
            );
            return;
          } else {
            scope.editar_recibos = true;
          }
        };

        scope.validarFechaInicio = function (receipt, index) {
          if (index > 0) {
            scope.datareceipt.receipts[index - 1].fecha_fin =
              receipt.fecha_inicio;
          }
        };

        scope.validarFechaFin = function (receipt, index) {
          if (scope.datareceipt.receipts.length - 1 > index) {
            scope.datareceipt.receipts[index + 1].fecha_inicio =
              receipt.fecha_fin;
          }
        };

        // Revisa que las fechas de los recibos no se salgan de la vigencia de la póliza
        scope.guardarRecibos = function () {
          var fechas_vacias = false;

          scope.datareceipt.receipts.forEach(function (item, index) {
            if (!item.fecha_inicio || !item.fecha_fin || !item.vencimiento) {
              SweetAlert.swal(
                "Error",
                "No se pueden quedar fechas vacías, revisa que los recibos tengan todas las fechas.",
                "error"
              );
              fechas_vacias = true;
              return;
            } else {
              if (
                process(item.fecha_inicio) <
                  process(scope.datareceipt.startDate) ||
                process(item.fecha_inicio) >
                  process(scope.datareceipt.endingDate) ||
                process(item.fecha_fin) <
                  process(scope.datareceipt.startDate) ||
                process(item.fecha_fin) > process(scope.datareceipt.endingDate)
              ) {
                SweetAlert.swal(
                  "Error",
                  "Las fechas del recibo " +
                    (index + 1) +
                    " se sale de la vigencia de la póliza.",
                  "error"
                );
                fechas_vacias = true;
                return;
              } else {
                // if(process(item.vencimiento) < process(item.fecha_inicio)){
                //   SweetAlert.swal('Error', 'La fecha de vencimiento del recibo ' + (index+1) + ' no puede ser menor a la de su inicio.', 'error');
                //   fechas_vacias = true;
                //   return;
                // }
              }
            }
          });

          function process(date) {
            var parts = date.split("/");
            var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
            return date.getTime();
          }

          var total_prima = 0;
          var total_rpf = 0;
          var total_derecho = 0;
          var total_iva = 0;
          var total_total = 0;

          for (var i = 0; i < scope.datareceipt.receipts.length; i++) {
            total_prima =
              total_prima + scope.datareceipt.receipts[i].prima_neta;
            total_rpf = total_rpf + scope.datareceipt.receipts[i].rpf;
            total_derecho =
              total_derecho + scope.datareceipt.receipts[i].derecho;
            total_iva = total_iva + scope.datareceipt.receipts[i].iva;
            total_total =
              total_total + scope.datareceipt.receipts[i].prima_total;
          }

          if (
            scope.datareceipt.primaNeta + 0.99 < total_prima ||
            scope.datareceipt.primaNeta - 0.99 > total_prima
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de las primas netas de todos los recibos no coincide con la prima neta de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            valor_rpf + 0.99 < total_rpf ||
            valor_rpf - 0.99 > total_rpf
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de los rpf de todos los recibos no coincide con el rpf de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            scope.datareceipt.derecho + 0.99 < total_derecho ||
            scope.datareceipt.derecho - 0.99 > total_derecho
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de los derechos de todos los recibos no coincide con el derecho de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            valor_iva + 0.99 < total_iva ||
            valor_iva - 0.99 > total_iva
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de los iva de todos los recibos no coincide con el iva de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            scope.datareceipt.primaTotal + 0.99 < total_total ||
            scope.datareceipt.primaTotal - 0.99 > total_total
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de las primas totales de todos los recibos no coincide con la prima total de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          }

          if (fechas_vacias) {
            scope.editar_recibos = true;
          } else {
            scope.editar_recibos = false;
          }
        };

        // Completa el json con la información de los recibos para enviarla a la póliza
        scope.generarToSave = function (value) {
          if (value == 1) {
            if (
              scope.datareceipt.aplicarRpf ||
              scope.datareceipt.aplicarDerecho
            ) {
              scope.todos_prima[0] == scope.datareceipt.receipts[0].prima_neta;
              scope.datareceipt.receipts[0].sub_total = parseFloat(
                scope.datareceipt.receipts[0].prima_neta +
                  scope.datareceipt.receipts[0].rpf +
                  scope.datareceipt.receipts[0].derecho
              );
              scope.todos_subtotal[0] ==
                scope.datareceipt.receipts[0].sub_total;
              scope.datareceipt.receipts[0].iva =
                scope.datareceipt.receipts[0].sub_total *
                ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
              scope.datareceipt.receipts[0].prima_total = parseFloat(
                scope.datareceipt.receipts[0].sub_total +
                  scope.datareceipt.receipts[0].iva
              );
              var comision_prima =
                scope.datareceipt.receipts[0].prima_neta *
                (scope.datareceipt.prima_comision / 100);
              var comision_rpf =
                scope.datareceipt.receipts[0].rpf *
                (scope.datareceipt.rpf_comision / 100);
              var comision_derecho =
                scope.datareceipt.receipts[0].derecho *
                (scope.datareceipt.derecho_comision / 100);
              scope.datareceipt.receipts[0].comision =
                comision_prima + comision_rpf + comision_derecho;
              if (scope.datareceipt.aplicarRpf) {
                scope.obj_rpf = scope.datareceipt.receipts[0].rpf;
              }
              scope.datareceipt.receipts[0].prima_neta = parseFloat(
                scope.datareceipt.receipts[0].prima_neta.toFixed(2)
              );
              scope.datareceipt.receipts[0].rpf = parseFloat(
                scope.datareceipt.receipts[0].rpf.toFixed(2)
              );
              scope.datareceipt.receipts[0].derecho = parseFloat(
                scope.datareceipt.receipts[0].derecho.toFixed(2)
              );
              scope.datareceipt.receipts[0].sub_total = parseFloat(
                scope.datareceipt.receipts[0].sub_total.toFixed(2)
              );
              scope.datareceipt.receipts[0].iva = parseFloat(
                scope.datareceipt.receipts[0].iva.toFixed(2)
              );
              scope.datareceipt.receipts[0].prima_total = parseFloat(
                scope.datareceipt.receipts[0].prima_total.toFixed(2)
              );
              scope.datareceipt.receipts[0].comision = parseFloat(
                scope.datareceipt.receipts[0].comision.toFixed(2)
              );
            }
          } else {
            scope.obj_rpf = null;
          }
          scope.tosave.p_neta = parseFloat(valor_primaNeta.toFixed(2));
          scope.tosave.descuento = parseFloat(valor_descuento.toFixed(2));
          scope.tosave.rpf = parseFloat(valor_rpf.toFixed(2));
          scope.tosave.derecho = parseFloat(valor_derecho);
          scope.tosave.sub_total = parseFloat(
            scope.datareceipt.subTotal.toFixed(2)
          );
          scope.tosave.iva = parseFloat(valor_iva.toFixed(2));
          scope.tosave.p_total = parseFloat(
            parseFloat(scope.datareceipt.primaTotal).toFixed(2)
          );
          scope.tosave.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );
          scope.tosave.comision_percent = scope.comisionPorcentaje;
          scope.tosave.prima_comision = scope.datareceipt.prima_comision;
          scope.tosave.poliza = {
            primaNeta: parseFloat(scope.datareceipt.primaNeta.toFixed(2)),
            descuento: parseFloat(valor_descuento.toFixed(2)),
            aplicarDescuento: scope.datareceipt.aplicarDescuento,
            rpf: parseFloat(valor_rpf.toFixed(2)),
            derecho: parseFloat(scope.datareceipt.derecho.toFixed(2)),
            iva: parseFloat(valor_iva.toFixed(2)),
            subTotal: parseFloat(scope.datareceipt.subTotal.toFixed(2)),
            primaTotal: parseFloat(
              parseFloat(scope.datareceipt.primaTotal).toFixed(2)
            ),
            comision_derecho_percent: parseFloat(
              scope.datareceipt.derecho_comision
            ),
            comision_rpf_percent: parseFloat(scope.datareceipt.rpf_comision),
          };
          scope.tosave.recibos_poliza = scope.datareceipt.receipts;
        };

        if (scope.tosave) {
          if (scope.tosave.receipts) {
            scope.datareceipt = scope.tosave.poliza;
            scope.datareceipt.receipts = scope.tosave.receipts;

            valor_iva = scope.datareceipt.iva;

            scope.editar = true;

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;

            if ($location.path().indexOf("convertir") != -1) {
              scope.mostrarTodosRecibo = false;
            } else {
              scope.mostrarTodosRecibo = true;
            }
          }
        }
      },
    };
  },
]);

var app = angular.module("inspinia").directive("receiptsEndoso", [
  "MESSAGES",
  "SweetAlert",
  "$location",
  "$sessionStorage",
  function (MESSAGES, SweetAlert, $location, $sessionStorage) {
    return {
      restrict: "EA",
      scope: {
        form: "=",
        tosave: "=",
        type: "=",
      },
      templateUrl: "app/directivas/calculateReceipts/receiptsEndoso.html",
      link: function (scope, element, $watch, attrs) {
        // Variables
        scope.comision_seleccion = "";
        scope.accesos = $sessionStorage.permisos;
        if (scope.accesos) {
          scope.accesos.forEach(function (perm) {
            if (perm.model_name == "Comisiones") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Comisiones") {
                  if (acc.checked == true) {
                    scope.permiso_comisiones = true;
                  } else {
                    scope.permiso_comisiones = false;
                  }
                }
              });
            }
            if (perm.model_name == "Cobranza") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Eliminar recibos") {
                  if (acc.checked == true) {
                    scope.permiso_delRecibo = true;
                  } else {
                    scope.permiso_delRecibo = false;
                  }
                }
              });
            }
            if (perm.model_name == "Pólizas") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Comisión no obligatoria") {
                  if (acc.checked == true) {
                    scope.permiso_comision_no_obligatoria = true;
                  } else {
                    scope.permiso_comision_no_obligatoria = false;
                  }
                }
              });
            }
          });
        }
        scope.datareceipt = {
          primaNeta: 0,
          descuento: null,
          rpf: 0,
          derecho: 0,
          subTotal: 0,
          iva: null,
          primaTotal: 0,
          comision: 0,
          aplicarDescuento: false,
        };

        scope.option_descuento = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_descuento = scope.option_descuento[0];

        scope.option_rpf = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_rpf = scope.option_rpf[0];

        scope.option_iva = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_iva = scope.option_iva[0];

        var agregar_comision = 0;
        var valor_primaNeta;
        var valor_descuento;
        var valor_rpf;
        var valor_derecho;
        var valor_iva;
        var valor_prima_descuento;
        var valor_comision;
        var valor_suma_comision;

        var copy_primaNeta = 0;
        var copy_rpf = 0;
        var copy_subTotal = 0;

        scope.newPrima = {};
        scope.todos_prima = [0];
        scope.todos_subtotal = [0];

        scope.mostrarPrimerRecibo = false;
        scope.mostrarTodosRecibo = false;
        scope.editar_recibos = false;

        scope.editar = false;
        scope.recalcular = true;

        scope.obj_rpf = null;

        scope.sobrePrimas = [
          { value: 1, name: "Prima Neta Pagada" },
          { value: 2, name: "Prima Neta Pactada" },
        ];

        scope.arreglo_escalones = [{ porcentaje: null, comision: 0 }];
        scope.suma_porcentaje = 0;
        scope.noteColor = { color: "#ff0000" };

        scope.verComisiones = function () {
          var sin_comision = {
            comission: "0",
            comission_derecho: "0",
            comission_rpf: "0",
            derecho: "0",
            efective_date: "-",
            expire_date: null,
            nombre: "Sin Comisión",
            observations: "-",
            others: "0",
            others_derecho: "0",
            others_rpf: "0",
            periodo_inicial: 0,
            periodo_subsecuente: 0,
            ramo: "-",
            rpf_mensual: "0",
            rpf_bimestral: "0",
            rpf_trimestral: "0",
            rpf_semestral: "0",
            rpf_anual: "0",
            subramo: "-",
            udi: "0",
            udi_derecho: "0",
            udi_rpf: "0",
          };

          if (scope.form.comisiones.length > 0) {
            scope.form.comisiones.forEach(function (item) {
              if (
                item.nombre == "Sin Comisión" &&
                item.efective_date == "-" &&
                item.observations == "-"
              ) {
                agregar_comision++;
              }
            });
            if (scope.form.subramo && agregar_comision == 0) {
              scope.form.comisiones.push(sin_comision);
              agregar_comision++;
            }
          } else {
            if (scope.form.subramo && agregar_comision == 0) {
              scope.form.comisiones = [];
              scope.form.comisiones.push(sin_comision);
              agregar_comision++;
            } else {
              if (scope.form.comisiones.length == 0) {
                scope.form.comisiones.push(sin_comision);
              }
            }
          }
        };

        // Asignar valores segun comision seleccionada
        scope.asignarValores = function (comission) {
          scope.comission = comission;
          if (!scope.form.payment || scope.form.payment == "") {
            scope.comision_seleccion = "";
            SweetAlert.swal("¡Error!", MESSAGES.ERROR.SELPAY, "error");
            return;
          } else {
            if (!scope.editar) {
              scope.datareceipt.payment = scope.form.payment;
            } else {
              scope.numeroRecibos = scope.datareceipt.numeroRecibos;
              scope.recalcular = scope.tosave.recalcular;
            }

            scope.datareceipt.subramo = scope.form.subramo;

            scope.datareceipt.derecho = parseFloat(comission.derecho);
            if (scope.form.comision_percent) {
              if (parseFloat(scope.form.comision_percent) == 0.0) {
                scope.datareceipt.prima_comision = parseFloat(
                  comission.comission
                );
              } else {
                scope.datareceipt.prima_comision = parseFloat(
                  scope.form.comision_percent
                );
              }
            }
            scope.datareceipt.rpf_comision = parseFloat(
              comission.comission_rpf
            );
            scope.datareceipt.derecho_comision = parseFloat(
              comission.comission_derecho
            );
            scope.datareceipt.periodo_inicial = parseFloat(
              comission.periodo_inicial
            );
            scope.datareceipt.periodo_subsecuente = parseFloat(
              comission.periodo_subsecuente
            );

            scope.datareceipt.domiciliado = scope.form.domiciliado;

            scope.calcularTotales();
          }
        };

        scope.porcentageRpf = function () {
          if (!scope.editar) {
            scope.datareceipt.payment = scope.form.payment;
          } else {
            scope.datareceipt.payment = scope.form.payment.value;
          }

          switch (parseFloat(scope.datareceipt.payment)) {
            case 1:
              scope.datareceipt.percent_rpf = scope.comission.rpf_mensual;
              break;
            case 2:
              scope.datareceipt.percent_rpf = scope.comission.rpf_bimestral;
              break;
            case 3:
              scope.datareceipt.percent_rpf = scope.comission.rpf_trimestral;
              break;
            case 5:
              scope.datareceipt.percent_rpf = scope.comission.rpf_anual;
              break;
            case 6:
              scope.datareceipt.percent_rpf = scope.comission.rpf_semestral;
              break;
            case 12:
              scope.datareceipt.percent_rpf = scope.comission.rpf_anual;
              break;
            default:
              scope.datareceipt.percent_rpf = 0;
              break;
          }
        };

        // Calcula pesos o porcentaje de descuento
        scope.calcularDescuento = function () {
          if (scope.tipo_descuento.value == 2) {
            if (scope.datareceipt.descuento != 0) {
              scope.descuentoPesos =
                (scope.datareceipt.primaNeta * scope.datareceipt.descuento) /
                100;
            } else {
              scope.descuentoPesos = 0;
            }
          } else {
            if (scope.datareceipt.descuento != 0) {
              scope.descuentoPorcentaje = (
                (scope.datareceipt.descuento * 100) /
                scope.datareceipt.primaNeta
              ).toFixed(2);
            } else {
              scope.descuentoPorcentaje = 0;
            }
          }
        };

        // Calcula pesos o porcentaje de rpf
        scope.calcularRpf = function () {
          if (scope.tipo_rpf.value == 2) {
            if (scope.datareceipt.rpf != 0) {
              scope.rpfPesos =
                (valor_prima_descuento * scope.datareceipt.rpf) / 100;
            } else {
              scope.rpfPesos = 0;
            }
          } else {
            if (scope.datareceipt.rpf != 0) {
              scope.rpfPorcentaje = (
                (scope.datareceipt.rpf * 100) /
                valor_prima_descuento
              ).toFixed(2);
            } else {
              scope.rpfPorcentaje = 0;
            }
          }
          console.log("oooo", scope.rpfPorcentaje);
          console.log("oorpfPesosoo", scope.rpfPesos);
        };

        // Calcula pesos o porcentaje de iva
        scope.calcularIva = function () {
          if (scope.tipo_iva.value == 2) {
            if (scope.datareceipt.iva != 0) {
              scope.ivaPesos =
                (scope.datareceipt.subTotal * scope.datareceipt.iva) / 100;
            } else {
              scope.ivaPesos = 0;
            }
          } else {
            if (scope.datareceipt.iva != 0) {
              scope.ivaPorcentaje = (
                (scope.datareceipt.iva * 100) /
                scope.datareceipt.subTotal
              ).toFixed(2);
            } else {
              scope.ivaPorcentaje = 0;
            }
          }
          if (scope.form.subramo.subramo_code == 1) {
            scope.ivaPorcentaje = 0;
            scope.ivaPesos = 0;
          }
        };

        // Calcula totales de las primas
        scope.calcularTotales = function () {
          if (
            scope.form.endorsement_type == "D" ||
            scope.form.type_endorsement == "D"
          ) {
            if (scope.datareceipt.primaNeta < 0) {
              scope.datareceipt.primaNeta =
                parseFloat(scope.datareceipt.primaNeta) * -1;
            }
            if (scope.tipo_descuento.value == 1) {
              if (scope.datareceipt.descuento < 0) {
                scope.datareceipt.descuento =
                  parseFloat(scope.datareceipt.descuento) * -1;
              }
            }
            if (scope.datareceipt.rpf < 0) {
              scope.datareceipt.rpf = parseFloat(scope.datareceipt.rpf) * -1;
            }
            if (scope.datareceipt.derecho < 0) {
              scope.datareceipt.derecho =
                parseFloat(scope.datareceipt.derecho) * -1;
            }
            if (scope.datareceipt.subTotal < 0) {
              scope.datareceipt.subTotal =
                parseFloat(scope.datareceipt.subTotal) * -1;
            }
            if (scope.datareceipt.iva < 0) {
              scope.datareceipt.iva = parseFloat(scope.datareceipt.iva) * -1;
            }
            if (scope.datareceipt.primaTotal < 0) {
              scope.datareceipt.primaTotal =
                parseFloat(scope.datareceipt.primaTotal) * -1;
            }
          }
          if (
            !scope.datareceipt.primaNeta ||
            scope.datareceipt.primaNeta == undefined
          ) {
            valor_primaNeta = 0;
          } else {
            valor_primaNeta = parseFloat(scope.datareceipt.primaNeta);
          }

          if (
            !scope.datareceipt.descuento ||
            scope.datareceipt.descuento == undefined
          ) {
            valor_descuento = 0;
          } else {
            if (scope.datareceipt.aplicarDescuento) {
              if (scope.tipo_descuento.value == 2) {
                if (scope.datareceipt.descuento > 100) {
                  SweetAlert.swal(
                    "Error",
                    "El descuento no puede ser mayor a 100%.",
                    "error"
                  );
                  scope.datareceipt.descuento = 0;
                  valor_descuento = 0;
                } else {
                  valor_descuento =
                    (scope.datareceipt.primaNeta *
                      scope.datareceipt.descuento) /
                    100;
                }
              } else {
                valor_descuento = scope.datareceipt.descuento;
              }
            } else {
              valor_descuento = 0;
            }
          }
          scope.calcularDescuento();

          valor_prima_descuento = valor_primaNeta - valor_descuento;
          scope.porcentageRpf();

          if (copy_primaNeta != scope.datareceipt.primaNeta) {
            scope.datareceipt.rpf = parseFloat(
              (
                valor_prima_descuento *
                (parseFloat(scope.datareceipt.percent_rpf) / 100)
              ).toFixed(2)
            );
            copy_rpf = angular.copy(scope.datareceipt.rpf);
          } else {
            if (
              scope.datareceipt.aplicarDescuento &&
              copy_rpf == scope.datareceipt.rpf
            ) {
              scope.datareceipt.rpf = parseFloat(
                (
                  valor_prima_descuento *
                  (parseFloat(scope.datareceipt.percent_rpf) / 100)
                ).toFixed(2)
              );
              copy_rpf = angular.copy(scope.datareceipt.rpf);
            }
          }

          if (!scope.datareceipt.rpf || scope.datareceipt.rpf == undefined) {
            copy_primaNeta = angular.copy(scope.datareceipt.primaNeta);
            valor_rpf = 0;
          } else {
            console.log("scope.tipo_rpf***********+", scope.tipo_rpf);
            if (scope.tipo_rpf.value == 2) {
              if (scope.datareceipt.rpf > 100) {
                SweetAlert.swal(
                  "Error",
                  "El recargo por pago fraccionado no puede ser mayor a 100%.",
                  "error"
                );
                scope.datareceipt.rpf = 0;
                valor_rpf = 0;
              } else {
                valor_rpf =
                  (valor_prima_descuento * scope.datareceipt.rpf) / 100;
              }
            } else {
              copy_primaNeta = angular.copy(scope.datareceipt.primaNeta);
              valor_rpf = scope.datareceipt.rpf;
            }
          }
          console.log("ooo", valor_rpf);
          scope.calcularRpf();

          if (
            !scope.datareceipt.derecho ||
            scope.datareceipt.derecho == undefined
          ) {
            valor_derecho = 0;
          } else {
            valor_derecho = parseFloat(scope.datareceipt.derecho);
          }

          scope.datareceipt.subTotal = parseFloat(
            (valor_prima_descuento + valor_rpf + valor_derecho).toFixed(2)
          );

          if (!scope.datareceipt.iva || scope.datareceipt.iva == undefined) {
            if (scope.datareceipt.subramo == "Vida") {
              copy_subTotal = angular.copy(scope.datareceipt.subTotal);
              scope.datareceipt.iva = 0;
              valor_iva = 0;
            } else if (scope.form.subramo.subramo_code == 1) {
              copy_subTotal = angular.copy(scope.datareceipt.subTotal);
              scope.datareceipt.iva = 0;
              valor_iva = 0;
            } else {
              scope.datareceipt.iva = parseFloat(
                (scope.datareceipt.subTotal * 0.16).toFixed(2)
              );
              valor_iva = scope.datareceipt.iva;
            }
          } else {
            if (scope.tipo_iva.value == 2) {
              if (scope.datareceipt.iva > 100) {
                SweetAlert.swal(
                  "Error",
                  "El iva no puede ser mayor a 100%.",
                  "error"
                );
                scope.datareceipt.iva = 0;
                valor_iva = 0;
              } else {
                valor_iva =
                  (scope.datareceipt.subTotal * scope.datareceipt.iva) / 100;
              }
            } else {
              if (copy_subTotal == scope.datareceipt.subTotal) {
                valor_iva = scope.datareceipt.iva;
              } else {
                copy_subTotal = angular.copy(scope.datareceipt.subTotal);
                scope.datareceipt.iva = parseFloat(
                  (scope.datareceipt.subTotal * 0.16).toFixed(2)
                );
                valor_iva = scope.datareceipt.iva;
              }
            }
          }
          scope.calcularIva();

          scope.datareceipt.primaTotal = parseFloat(
            (scope.datareceipt.subTotal + valor_iva).toFixed(2)
          );
          if (
            scope.datareceipt.prima_comision <= 0 ||
            scope.datareceipt.prima_comision > 100 ||
            scope.datareceipt.prima_comision == null
          ) {
            scope.datareceipt.prima_comision = 0;
          }
          if (
            scope.datareceipt.rpf_comision <= 0 ||
            scope.datareceipt.rpf_comision > 100 ||
            scope.datareceipt.rpf_comision == null
          ) {
            scope.datareceipt.rpf_comision = 0;
          }
          if (
            scope.datareceipt.derecho_comision <= 0 ||
            scope.datareceipt.derecho_comision > 100 ||
            scope.datareceipt.derecho_comision == null
          ) {
            scope.datareceipt.derecho_comision = 0;
          }

          scope.valor_prima_comision =
            valor_prima_descuento * (scope.datareceipt.prima_comision / 100);
          scope.valor_rpf_comision =
            valor_rpf * (scope.datareceipt.rpf_comision / 100);
          scope.valor_derecho_comision =
            valor_derecho * (scope.datareceipt.derecho_comision / 100);

          valor_suma_comision = 0;
          scope.datareceipt.comision = 0;
          if (scope.valor_prima_comision != 0) {
            scope.datareceipt.comision = parseFloat(scope.valor_prima_comision);
            valor_suma_comision = valor_prima_descuento;
          }
          if (scope.valor_rpf_comision != 0) {
            scope.datareceipt.comision =
              scope.datareceipt.comision + parseFloat(scope.valor_rpf_comision);
            valor_suma_comision = valor_suma_comision + valor_rpf;
          }
          if (scope.valor_derecho_comision != 0) {
            scope.datareceipt.comision =
              scope.datareceipt.comision +
              parseFloat(scope.valor_derecho_comision);
            valor_suma_comision = valor_suma_comision + valor_derecho;
          }

          scope.datareceipt.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );

          scope.comisionPorcentaje = (
            (scope.datareceipt.comision * 100) /
            valor_suma_comision
          ).toFixed(2);

          if (scope.comisionPorcentaje == "NaN") {
            scope.comisionPorcentaje = 0;
          }

          scope.tosave.comision = scope.datareceipt.comision;
          scope.tosave.comision_percent = scope.comisionPorcentaje;
          scope.tosave.p_neta = parseFloat(valor_primaNeta.toFixed(2));
          scope.tosave.descuento = parseFloat(valor_descuento.toFixed(2));
          scope.tosave.rpf = parseFloat(valor_rpf.toFixed(2));
          scope.tosave.aplicarRpf = scope.datareceipt.aplicarRpf;
          scope.tosave.derecho = parseFloat(valor_derecho);
          scope.tosave.aplicarDerecho = scope.datareceipt.aplicarDerecho;
          scope.tosave.sub_total = parseFloat(
            scope.datareceipt.subTotal.toFixed(2)
          );
          scope.tosave.iva = parseFloat(valor_iva.toFixed(2));
          scope.tosave.p_total = parseFloat(
            scope.datareceipt.primaTotal.toFixed(2)
          );
          scope.tosave.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );
          scope.tosave.comision_percent = scope.comisionPorcentaje;
          scope.tosave.poliza = {
            primaNeta: parseFloat(scope.datareceipt.primaNeta.toFixed(2)),
            descuento: parseFloat(valor_descuento.toFixed(2)),
            aplicarDescuento: scope.datareceipt.aplicarDescuento,
            rpf: parseFloat(valor_rpf.toFixed(2)),
            derecho: parseFloat(scope.datareceipt.derecho).toFixed(2),
            iva: parseFloat(valor_iva.toFixed(2)),
            subTotal: parseFloat(scope.datareceipt.subTotal.toFixed(2)),
            primaTotal: parseFloat(scope.datareceipt.primaTotal.toFixed(2)),
          };
        };

        // Calcula el porcentaje de la comisión
        scope.calcularComision = function () {
          scope.comisionPorcentaje = (
            (scope.datareceipt.comision * 100) /
            scope.datareceipt.subTotal
          ).toFixed(2);
          scope.form.comision_percent = scope.comisionPorcentaje;
          scope.generarToSave();
        };

        // Calcula el primer recibo
        scope.calcularPrimerRecibo = function () {
          if (!scope.permiso_comision_no_obligatoria) {
            if (
              scope.datareceipt.prima_comision == 0 ||
              scope.datareceipt.prima_comision == "0" ||
              scope.datareceipt.prima_comision == ""
            ) {
              SweetAlert.swal(
                "¡Error!",
                "La comisión de prima neta es obligatoria.",
                "error"
              );
              scope.mostrarPrimerRecibo = false;
              return;
            }
          }

          if (scope.form.concept) {
            if (scope.form.concept != 1) {
              if (
                scope.form.administration_type == "Autoadministrada" ||
                scope.form.administration_type == 2
              ) {
                if (scope.form.concept == 36) {
                  if (scope.form.generarRecibosExcepcional) {
                    scope.form.num_receipts = scope.form.num_receipts;
                  } else {
                    scope.form.num_receipts = 1;
                  }
                } else {
                  if (scope.form.generarRecibosExcepcional) {
                    scope.form.num_receipts = scope.form.num_receipts;
                  } else {
                    scope.form.num_receipts = 0;
                  }
                }
              } else if (!scope.form.num_receipts) {
                SweetAlert.swal(
                  "¡Error!",
                  "Debe elegir un número de recibos.",
                  "error"
                );
                return;
              }
            } else if (!scope.form.num_receipts) {
              SweetAlert.swal(
                "¡Error!",
                "Debe elegir un número de recibos.",
                "error"
              );
              return;
            }
          }
          // if(!scope.form.num_receipts){
          //   SweetAlert.swal("¡Error!", "Debe elegir un número de recibos.", "error");
          //   return;
          // }
          if (!scope.comision_seleccion && scope.type == 1) {
            SweetAlert.swal(
              "¡Error!",
              "Debe elegir un valor de comisión.",
              "error"
            );
            return;
          }
          scope.datareceipt.startDate = scope.form.startDate;
          scope.datareceipt.endingDate = scope.form.endingDate;

          if (!scope.editar) {
            scope.datareceipt.payment = scope.form.payment;
            scope.datareceipt.num_receipts = scope.form.num_receipts;
            scope.datareceipt.concept = scope.form.concept;
            scope.datareceipt.type_endorsement = scope.form.endorsement_type;
          } else {
            scope.datareceipt.payment = scope.form.payment.value;
            scope.datareceipt.num_receipts = scope.form.num_receipts;
            scope.datareceipt.type_endorsement = scope.form.endorsement_type;
          }

          if (scope.datareceipt.type_endorsement == "A") {
            scope.noteColor = { color: "inherit" };
          } else if (scope.datareceipt.type_endorsement == "D") {
            scope.noteColor = { color: "#ff0000" };
          }

          scope.datareceipt.policy_days_duration =
            scope.form.policy_days_duration;

          scope.datareceipt.primaNeta = parseFloat(scope.datareceipt.primaNeta);
          scope.datareceipt.derecho = parseFloat(scope.datareceipt.derecho);
          scope.datareceipt.subTotal = parseFloat(scope.datareceipt.subTotal);
          scope.datareceipt.comision = parseFloat(scope.datareceipt.comision);
          // console.log('ooooooo',scope.datareceipt)
          if (scope.recalcular) {
            switch (parseFloat(scope.datareceipt.payment)) {
              case 1:
                scope.numeroRecibos = 12;
                break;
              case 2:
                scope.numeroRecibos = 6;
                break;
              case 3:
                scope.numeroRecibos = 4;
                break;
              case 5:
                scope.numeroRecibos = 1; //contado
                break;
              case 6:
                scope.numeroRecibos = 2;
                break;
              case 7:
                scope.numeroRecibos = 52;
                break;
              case 14:
                scope.numeroRecibos = 26;
                break;
              case 24:
                scope.numeroRecibos = 24;
                break;
              case 12:
                scope.numeroRecibos = 1; //anual
                break;
              default:
                break;
            }

            if (
              scope.form &&
              scope.form.num_receipts &&
              scope.form.generarRecibosExcepcional &&
              scope.form.generarRecibosExcepcional == true
            ) {
              scope.numeroRecibos = scope.form.num_receipts;
            }
            scope.nuevoNumeroRecibos = angular.copy(scope.numeroRecibos);
            // al calcular primer recibo le asignaba todo el importe y los restantes en 0
            if (
              scope.form &&
              scope.form.num_receipts &&
              scope.datareceipt &&
              scope.datareceipt.num_receipts
            ) {
              if (scope.datareceipt.num_receipts === scope.form.num_receipts) {
                scope.nuevoNumeroRecibos = scope.datareceipt.num_receipts;
                scope.numeroRecibos = scope.datareceipt.num_receipts;
              }
            }
            // al calcular primer recibo le asignaba todo el importe y los restantes en 0 fin
            // if(scope.datareceipt.policy_days_duration < 365){
            //   scope.calcularRecibosCortos(1);
            // }else if(scope.datareceipt.policy_days_duration == 365 || scope.datareceipt.policy_days_duration == 366){
            //   scope.calcularRecibos(1);
            // }else if(scope.datareceipt.policy_days_duration > 366){
            //   scope.calcularRecibosMultianuales(1);
            // }
            if (
              scope.form &&
              scope.form.num_receipts &&
              scope.form.generarRecibosExcepcional &&
              scope.form.generarRecibosExcepcional == true
            ) {
              scope.nuevoNumeroRecibos = scope.form.num_receipts;
            }
            if (
              scope.datareceipt.payment == 7 ||
              scope.datareceipt.payment == 14
            ) {
              scope.calcularRecibosMes(1, scope.datareceipt.payment);
            } else if (scope.datareceipt.payment == 24) {
              scope.calcularRecibosQuincena(1);
            } else if (
              scope.datareceipt.payment == 1 ||
              scope.datareceipt.payment == 2 ||
              scope.datareceipt.payment == 3 ||
              scope.datareceipt.payment == 5 ||
              scope.datareceipt.payment == 6 ||
              scope.datareceipt.payment == 12
            ) {
              scope.calcularRecibosMes(1, scope.datareceipt.payment);
            }
            SweetAlert.swal(
              "¡Atención!",
              "Introduce las primas para el primer recibo, después genera los recibos subsecuentes.\n Las Fechas y Cantidades pueden no ser exactas",
              "warning"
            );
          } else {
            SweetAlert.swal(
              "¡Error se modificaron primas!",
              "Y existen recibos pagados, las primas de la póliza se podrán guardar pero cada recibo se deberá que modificar de manera manual desde la información.",
              "error"
            );
          }
        };

        // Recalcula el primer recibo
        scope.calcularTotalPrimerRecibo = function () {
          if (scope.datareceipt.type_endorsement == "A") {
            if (
              scope.datareceipt.receipts[0].prima_neta >
              scope.datareceipt.primaNeta
            ) {
              scope.datareceipt.receipts[0].prima_neta =
                scope.datareceipt.primaNeta;
              SweetAlert.swal(
                "Error",
                "La prima neta del recibo no puede ser mayor a la prima neta del endoso.",
                "error"
              );
              return;
            }
          } else if (scope.datareceipt.type_endorsement == "D") {
            if (scope.datareceipt.receipts[0].prima_neta > 0) {
              scope.datareceipt.receipts[0].prima_neta =
                scope.datareceipt.receipts[0].prima_neta * -1;
            }
            if (
              scope.datareceipt.receipts[0].prima_neta <
              scope.datareceipt.primaNeta * -1
            ) {
              scope.datareceipt.receipts[0].prima_neta =
                scope.datareceipt.primaNeta * -1;
              SweetAlert.swal(
                "Error",
                "La prima neta de la nota de crédito no puede ser mayor a la prima neta del endoso.",
                "error"
              );
              return;
            }
          }
          if (scope.datareceipt.type_endorsement == "A") {
            if (scope.datareceipt.receipts[0].rpf > scope.datareceipt.rpf) {
              scope.datareceipt.receipts[0].rpf = scope.datareceipt.rpf;
              SweetAlert.swal(
                "Error",
                "El rpf del recibo no puede ser mayor al rpf del endoso.",
                "error"
              );
              return;
            }
          } else if (scope.datareceipt.type_endorsement == "D") {
            if (scope.datareceipt.receipts[0].rpf > 0) {
              scope.datareceipt.receipts[0].rpf =
                scope.datareceipt.receipts[0].rpf * -1;
            }
            if (
              scope.datareceipt.receipts[0].rpf <
              scope.datareceipt.rpf * -1
            ) {
              scope.datareceipt.receipts[0].rpf = scope.datareceipt.rpf * -1;
              SweetAlert.swal(
                "Error",
                "El rpf de la nota de crédito no puede ser mayor al rpf del endoso.",
                "error"
              );
              return;
            }
          }
          if (scope.datareceipt.type_endorsement == "A") {
            if (
              scope.datareceipt.receipts[0].derecho > scope.datareceipt.derecho
            ) {
              scope.datareceipt.receipts[0].derecho = scope.datareceipt.derecho;
              SweetAlert.swal(
                "Error",
                "El rpf del recibo no puede ser mayor al rpf del endoso.",
                "error"
              );
              return;
            }
          } else if (scope.datareceipt.type_endorsement == "D") {
            if (scope.datareceipt.receipts[0].derecho > 0) {
              scope.datareceipt.receipts[0].derecho =
                scope.datareceipt.receipts[0].derecho * -1;
            }
            if (
              scope.datareceipt.receipts[0].derecho <
              scope.datareceipt.derecho * -1
            ) {
              scope.datareceipt.receipts[0].derecho =
                scope.datareceipt.derecho * -1;
              SweetAlert.swal(
                "Error",
                "El rpf de la nota de crédito no puede ser mayor al rpf del endoso.",
                "error"
              );
              return;
            }
          }
          if (scope.datareceipt.type_endorsement == "A") {
            if (scope.datareceipt.receipts[0].iva > scope.datareceipt.iva) {
              scope.datareceipt.receipts[0].iva = scope.datareceipt.iva;
              SweetAlert.swal(
                "Error",
                "El rpf del recibo no puede ser mayor al rpf del endoso.",
                "error"
              );
              return;
            }
          } else if (scope.datareceipt.type_endorsement == "D") {
            if (scope.datareceipt.receipts[0].iva > 0) {
              scope.datareceipt.receipts[0].iva =
                scope.datareceipt.receipts[0].iva * -1;
            }
            if (
              scope.datareceipt.receipts[0].iva <
              scope.datareceipt.iva * -1
            ) {
              scope.datareceipt.receipts[0].iva = scope.datareceipt.iva * -1;
              SweetAlert.swal(
                "Error",
                "El rpf de la nota de crédito no puede ser mayor al rpf del endoso.",
                "error"
              );
              return;
            }
          }
          if (scope.datareceipt.type_endorsement == "A") {
            if (
              scope.datareceipt.receipts[0].prima_total >
              scope.datareceipt.primaTotal
            ) {
              scope.datareceipt.receipts[0].prima_total =
                scope.datareceipt.primaTotal;
              SweetAlert.swal(
                "Error",
                "El rpf del recibo no puede ser mayor al rpf del endoso.",
                "error"
              );
              return;
            }
          } else if (scope.datareceipt.type_endorsement == "D") {
            if (scope.datareceipt.receipts[0].prima_total > 0) {
              scope.datareceipt.receipts[0].prima_total =
                scope.datareceipt.receipts[0].prima_total * -1;
            }
            if (
              scope.datareceipt.receipts[0].prima_total <
              scope.datareceipt.primaTotal * -1
            ) {
              scope.datareceipt.receipts[0].prima_total =
                scope.datareceipt.primaTotal * -1;
              SweetAlert.swal(
                "Error",
                "El rpf de la nota de crédito no puede ser mayor al rpf del endoso.",
                "error"
              );
              return;
            }
          }

          if (
            scope.todos_prima[0] == scope.datareceipt.receipts[0].prima_neta
          ) {
            scope.datareceipt.receipts[0].rpf =
              scope.datareceipt.receipts[0].rpf;
          } else {
            scope.todos_prima = [];
            scope.datareceipt.receipts.forEach(function (receipt) {
              scope.todos_prima.push(receipt.prima_neta);
            });
            if (scope.obj_rpf != null) {
              scope.datareceipt.receipts[0].rpf = scope.obj_rpf;
            } else {
              scope.datareceipt.receipts[0].rpf =
                scope.datareceipt.receipts[0].prima_neta *
                ((valor_rpf * 100) / scope.datareceipt.primaNeta / 100);
            }
          }

          if (scope.datareceipt.receipts[0].derecho == null) {
            scope.datareceipt.receipts[0].derecho = 0;
          }

          scope.datareceipt.receipts[0].sub_total =
            scope.datareceipt.receipts[0].prima_neta +
            scope.datareceipt.receipts[0].rpf +
            scope.datareceipt.receipts[0].derecho;

          if (
            scope.todos_subtotal[0] == scope.datareceipt.receipts[0].sub_total
          ) {
            scope.datareceipt.receipts[0].iva =
              scope.datareceipt.receipts[0].iva;
          } else {
            scope.todos_subtotal = [];
            scope.datareceipt.receipts.forEach(function (receipt) {
              scope.todos_subtotal.push(receipt.sub_total);
            });
            scope.datareceipt.receipts[0].iva =
              scope.datareceipt.receipts[0].sub_total *
              ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
          }
          scope.datareceipt.receipts[0].prima_total =
            scope.datareceipt.receipts[0].sub_total +
            scope.datareceipt.receipts[0].iva;

          var comision_primer_recibo_prima =
            scope.datareceipt.receipts[0].prima_neta *
            (scope.datareceipt.prima_comision / 100);
          var comision_primer_recibo_rpf = scope.datareceipt.receipts[0].rpf
            ? scope.datareceipt.receipts[0].rpf
            : 0 * (scope.datareceipt.rpf_comision / 100);
          var comision_primer_recibo_derecho = scope.datareceipt.receipts[0]
            .derecho
            ? scope.datareceipt.receipts[0].derecho
            : 0 * (scope.datareceipt.derecho_comision / 100);

          scope.datareceipt.receipts[0].comision =
            comision_primer_recibo_prima +
            comision_primer_recibo_rpf +
            comision_primer_recibo_derecho;

          scope.datareceipt.receipts[0].prima_neta = scope.datareceipt
            .receipts[0].prima_neta
            ? parseFloat(scope.datareceipt.receipts[0].prima_neta.toFixed(2))
            : 0;
          scope.datareceipt.receipts[0].rpf = scope.datareceipt.receipts[0].rpf
            ? parseFloat(scope.datareceipt.receipts[0].rpf.toFixed(2))
            : 0;
          scope.datareceipt.receipts[0].derecho = scope.datareceipt.receipts[0]
            .derecho
            ? parseFloat(scope.datareceipt.receipts[0].derecho.toFixed(2))
            : 0;
          scope.datareceipt.receipts[0].sub_total = scope.datareceipt
            .receipts[0].sub_total
            ? parseFloat(scope.datareceipt.receipts[0].sub_total.toFixed(2))
            : 0;
          scope.datareceipt.receipts[0].iva = scope.datareceipt.receipts[0].iva
            ? parseFloat(scope.datareceipt.receipts[0].iva.toFixed(2))
            : 0;
          scope.datareceipt.receipts[0].prima_total = scope.datareceipt
            .receipts[0].prima_total
            ? parseFloat(scope.datareceipt.receipts[0].prima_total.toFixed(2))
            : 0;
          scope.datareceipt.receipts[0].comision = scope.datareceipt.receipts[0]
            .comision
            ? parseFloat(scope.datareceipt.receipts[0].comision.toFixed(2))
            : 0;
        };
        // Recalcula el primer recibo

        scope.calcularNetaPrimerRecibo = function () {
          var recibo = scope.datareceipt.receipts[0];

          // Conversión segura a número
          var primaTotal = parseFloat(recibo.prima_total) || 0;
          var derecho = parseFloat(recibo.derecho) || 0;
          var rpf = parseFloat(recibo.rpf) || 0;

          // IVA dinámico (puede ser 0)
          var ivaRate = 0.16;
          // if ((scope.datareceipt && scope.datareceipt.subramo && scope.datareceipt.subramo.subramo_code == 1)) {
          if (
            scope.datareceipt &&
            scope.datareceipt.subramo &&
            (scope.datareceipt.subramo.subramo_code == 1 ||
              scope.datareceipt.subramo.subramo_code == 30 ||
              scope.datareceipt.subramo.subramo_name == "Vida" ||
              scope.datareceipt.subramo.subramo_name == "Funerarios" ||
              scope.datareceipt.subramo == "Vida" ||
              scope.datareceipt.subramo == "Funerarios")
          ) {
            ivaRate = 0;
          }

          // Base sin IVA
          var baseSinIva = primaTotal - derecho - rpf;

          // Calcular prima neta e IVA
          var primaNeta = ivaRate > 0 ? baseSinIva / (1 + ivaRate) : baseSinIva;
          var iva = ivaRate > 0 ? baseSinIva - primaNeta : 0;

          // Redondear a 2 decimales
          primaNeta = Math.round(primaNeta * 100) / 100;
          iva = Math.round(iva * 100) / 100;

          // Validaciones por tipo de endoso
          if (scope.datareceipt.type_endorsement == "A") {
            if (primaTotal > scope.datareceipt.primaTotal) {
              SweetAlert.swal(
                "Error",
                "La prima total del recibo no puede ser mayor a la prima total del endoso.",
                "error"
              );
              return;
            }
          } else if (scope.datareceipt.type_endorsement == "D") {
            if (primaTotal > 0) {
              primaTotal *= -1;
              primaNeta *= -1;
              iva *= -1;
            }
            if (primaTotal < scope.datareceipt.primaTotal * -1) {
              primaTotal = scope.datareceipt.primaTotal * -1;
              SweetAlert.swal(
                "Error",
                "La prima total de la nota de crédito no puede ser mayor a la prima total del endoso.",
                "error"
              );
              return;
            }
          }

          // Asignar valores finales al recibo
          recibo.prima_total = primaTotal;
          recibo.prima_neta = primaNeta;
          recibo.iva = iva;
        };

        // Calcula recibos subsecuentes con cambios en primer recibo
        scope.calcularSiguientesRecibos = function () {
          scope.firstReceipt = angular.copy(scope.datareceipt.receipts[0]);
          if (
            scope.datareceipt.primaNeta >=
            scope.datareceipt.receipts[0].prima_neta
          ) {
            if (scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.primaNeta =
                scope.datareceipt.primaNeta -
                scope.datareceipt.receipts[0].prima_neta;
            } else if (scope.datareceipt.type_endorsement == "D") {
              scope.newPrima.primaNeta =
                scope.datareceipt.primaNeta +
                scope.datareceipt.receipts[0].prima_neta;
            }
          } else {
            if (scope.type == 1) {
              scope.newPrima.primaNeta = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "La prima neta del primer recibo es mayor a la prima neta de la póliza.",
                "error"
              );
              return;
            }
          }
          if (valor_rpf >= scope.datareceipt.receipts[0].rpf) {
            if (scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.rpf =
                valor_rpf - scope.datareceipt.receipts[0].rpf;
            } else if (scope.datareceipt.type_endorsement == "D") {
              scope.newPrima.rpf =
                valor_rpf + scope.datareceipt.receipts[0].rpf;
            }
          } else {
            if (scope.type == 1) {
              scope.newPrima.rpf = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "El RPF del primer recibo es mayor al RPF de la póliza.",
                "error"
              );
              return;
            }
          }

          if (
            scope.datareceipt.derecho >= scope.datareceipt.receipts[0].derecho
          ) {
            if (scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.derecho =
                scope.datareceipt.derecho -
                scope.datareceipt.receipts[0].derecho;
            } else if (scope.datareceipt.type_endorsement == "D") {
              scope.newPrima.derecho =
                scope.datareceipt.derecho +
                scope.datareceipt.receipts[0].derecho;
            }
          } else {
            if (scope.type == 1) {
              scope.newPrima.derech = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "El derecho del primer recibo es mayor al derecho de la póliza.",
                "error"
              );
              return;
            }
          }

          if (
            scope.datareceipt.subTotal >=
            scope.datareceipt.receipts[0].sub_total
          ) {
            if (scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.subTotal =
                scope.datareceipt.subTotal -
                scope.datareceipt.receipts[0].sub_total;
            } else if (scope.datareceipt.type_endorsement == "D") {
              scope.newPrima.subTotal =
                scope.datareceipt.subTotal +
                scope.datareceipt.receipts[0].sub_total;
            }
          } else {
            scope.newPrima.subTotal = 0;
          }

          if (valor_iva >= scope.datareceipt.receipts[0].iva) {
            if (scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.iva =
                valor_iva - scope.datareceipt.receipts[0].iva;
            } else if (scope.datareceipt.type_endorsement == "D") {
              scope.newPrima.iva =
                valor_iva + scope.datareceipt.receipts[0].iva;
            }
          } else {
            if (scope.type == 1) {
              scope.newPrima.iva = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "El iva del primer recibo es mayor al iva de la póliza.",
                "error"
              );
              return;
            }
          }

          if (
            scope.datareceipt.primaTotal >=
            scope.datareceipt.receipts[0].prima_total
          ) {
            if (scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.primaTotal =
                scope.datareceipt.primaTotal -
                scope.datareceipt.receipts[0].prima_total;
            } else if (scope.datareceipt.type_endorsement == "D") {
              scope.newPrima.primaTotal =
                scope.datareceipt.primaTotal +
                scope.datareceipt.receipts[0].prima_total;
            }
          } else {
            if (scope.type == 1) {
              scope.newPrima.primaTotal = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "La prima total del primer recibo es mayor a la prima total de la póliza.",
                "error"
              );
              return;
            }
          }

          if (
            scope.datareceipt.comision >= scope.datareceipt.receipts[0].comision
          ) {
            if (scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.comision =
                scope.datareceipt.comision -
                scope.datareceipt.receipts[0].comision;
            } else if (scope.datareceipt.type_endorsement == "D") {
              scope.newPrima.comision =
                scope.datareceipt.comision +
                scope.datareceipt.receipts[0].comision;
            }
          } else {
            scope.newPrima.comision = 0;
          }

          if (
            scope.datareceipt.payment == 7 ||
            scope.datareceipt.payment == 14
          ) {
            scope.calcularRecibosMes(2, scope.datareceipt.payment);
          } else if (scope.datareceipt.payment == 24) {
            scope.calcularRecibosQuincena(2);
          } else if (
            scope.datareceipt.payment == 1 ||
            scope.datareceipt.payment == 2 ||
            scope.datareceipt.payment == 3 ||
            scope.datareceipt.payment == 5 ||
            scope.datareceipt.payment == 6 ||
            scope.datareceipt.payment == 12
          ) {
            scope.calcularRecibosMes(2, scope.datareceipt.payment);
          }

          // SweetAlert.swal('¡Atención!', 'Introduce las primas para el primer recibo, después genera los recibos subsecuentes.', 'warning');
        };

        // Valida que el porcentaje de siniestralidad no supere el 100%
        scope.validarPorcentaje = function () {
          if (scope.datareceipt.accident_rate < 0) {
            scope.datareceipt.accident_rate = 0;
          } else if (scope.datareceipt.accident_rate > 100) {
            scope.datareceipt.accident_rate = 100;
          } else {
            scope.datareceipt.accident_rate.toFixed(2);
          }
        };

        // Agregar nuevo escalon
        scope.agregarEscalon = function () {
          var data_step = {
            porcentaje: null,
            comision: 0,
          };
          scope.arreglo_escalones.push(data_step);
        };

        // Eliminar escalon
        scope.quitarEscalon = function (index) {
          scope.arreglo_escalones.splice(index, 1);
          scope.sumarPorcentajes();
        };

        // Verifica que todos los escalones sean 100%
        scope.sumarPorcentajes = function () {
          scope.suma_porcentaje = 0;
          scope.arreglo_escalones.forEach(function (item) {
            if (item.porcentaje == null) {
              item.porcentaje = 0;
            } else if (item.porcentaje < 0) {
              item.porcentaje = 0;
            } else if (item.porcentaje > 100) {
              item.porcentaje = 100;
            }
            scope.suma_porcentaje = scope.suma_porcentaje + item.porcentaje;
            if (scope.suma_porcentaje > 100) {
              SweetAlert.swal(
                "Error",
                "La sumatoria de todos los porcentajes de cada escalon no pueden superar el 100%, verifica los porcentajes.",
                "error"
              );
            }
          });
          scope.tosave.sumaPorcentaje = scope.suma_porcentaje;
        };

        // Calcula recibos por prima minima
        scope.calcularRecibosPrimaMinima = function () {
          if (!scope.comision_seleccion) {
            SweetAlert.swal(
              "¡Error!",
              "Debe elegir un valor de comisión.",
              "error"
            );
            return;
          }
          if (!scope.datareceipt.accident_rate) {
            SweetAlert.swal(
              "¡Error!",
              "Debe agregar un porcentaje de siniestralidad.",
              "error"
            );
            return;
          }
          if (scope.suma_porcentaje != 100) {
            SweetAlert.swal(
              "Error",
              "La sumatoria de todos los porcentajes de cada escalon no pueden ser diferente al 100%, verifica los porcentajes.",
              "error"
            );
            return;
          }
          scope.arreglo_escalones.forEach(function (item, index) {
            if (item.porcentaje == null || item.porcentaje <= 0) {
              scope.arreglo_escalones.splice(index, 1);
            }
          });
          scope.datareceipt.receipts = [];
          scope.datareceipt.startDate = scope.form.startDate;
          scope.datareceipt.endingDate = scope.form.endingDate;
          scope.recibos_totales = scope.arreglo_escalones.length;

          scope.arreglo_escalones.forEach(function (item, index) {
            var receipt = {
              recibo_numero: index + 1,
              prima_neta: 0,
              rpf: 0,
              derecho: 0,
              iva: 0,
              sub_total: 0,
              prima_total: 0,
              comision: 0,
              receipt_type: 1,
              delivered: false,
              fecha_inicio: scope.form.startDate,
              fecha_fin: scope.form.endingDate,
              vencimiento: scope.obtenerVencimiento(
                index,
                scope.form.startDate
              ),
            };
            receipt.prima_neta = parseFloat(
              ((scope.datareceipt.primaNeta * item.porcentaje) / 100).toFixed(2)
            );
            if (index == 0) {
              receipt.rpf = parseFloat(scope.datareceipt.rpf.toFixed(2));
              receipt.derecho = parseFloat(
                parseFloat(scope.datareceipt.derecho).toFixed(2)
              );
            } else {
              receipt.rpf = 0;
              receipt.derecho = 0;
            }
            receipt.sub_total = parseFloat(
              (
                parseFloat(receipt.prima_neta) +
                parseFloat(receipt.rpf) +
                parseFloat(receipt.derecho)
              ).toFixed(2)
            );
            receipt.iva = parseFloat(
              (
                (receipt.sub_total * parseFloat(scope.ivaPorcentaje)) /
                100
              ).toFixed(2)
            );
            receipt.prima_total = parseFloat(
              (parseFloat(receipt.sub_total) + parseFloat(receipt.iva)).toFixed(
                2
              )
            );
            receipt.comision = parseFloat(
              ((scope.datareceipt.comision * item.porcentaje) / 100).toFixed(2)
            );
            scope.datareceipt.receipts.push(angular.copy(receipt));
          });
          var receipt = {
            recibo_numero: 1,
            prima_neta: (
              scope.datareceipt.receipts[0].prima_neta -
              parseFloat(scope.datareceipt.primaNeta)
            ).toFixed(2),
            rpf: (
              scope.datareceipt.receipts[0].rpf -
              parseFloat(scope.datareceipt.rpf)
            ).toFixed(2),
            derecho: (
              scope.datareceipt.receipts[0].derecho -
              parseFloat(scope.datareceipt.derecho)
            ).toFixed(2),
            iva: (
              scope.datareceipt.receipts[0].iva -
              parseFloat(scope.datareceipt.iva)
            ).toFixed(2),
            sub_total: (
              scope.datareceipt.receipts[0].sub_total -
              parseFloat(scope.datareceipt.subTotal)
            ).toFixed(2),
            prima_total: (
              scope.datareceipt.receipts[0].prima_total -
              parseFloat(scope.datareceipt.primaTotal)
            ).toFixed(2),
            comision: (
              scope.datareceipt.receipts[0].comision -
              parseFloat(scope.datareceipt.comision)
            ).toFixed(2),
            receipt_type: 3,
            delivered: false,
            fecha_inicio: scope.form.startDate,
            fecha_fin: scope.form.endingDate,
            vencimiento: scope.obtenerVencimiento(1, scope.form.startDate),
          };
          scope.datareceipt.receipts.push(angular.copy(receipt));

          scope.mostrarPrimerRecibo = false;
          scope.mostrarTodosRecibo = true;
          scope.generarToSave();
        };

        // Calcula recibos semanal, catorcenal
        scope.calcularRecibosDia = function (value) {
          scope.datareceipt.receipts = [];

          var recibos_fracionados =
            (scope.datareceipt.policy_days_duration * scope.numeroRecibos) /
            365;
          var arreglo_recibos = recibos_fracionados.toString().split(".");
          var recibos_completos = parseFloat(arreglo_recibos[0]);
          var recibos_incompletos = "0." + arreglo_recibos[1];
          recibos_incompletos = parseFloat(recibos_incompletos);

          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          var date1 = new Date(mes + "/" + dia + "/" + (anio - 1));
          var date2 = new Date(mes + "/" + dia + "/" + anio);
          var timeDiff = Math.abs(date2.getTime() - date1.getTime());
          duration = Math.ceil(timeDiff / (1000 * 3600 * 24));

          var dias_bisiesto = scope.datareceipt.policy_days_duration % duration;
          var diferencia = Math.abs(date2.getTime() - date1.getTime());

          if (
            (scope.datareceipt.policy_days_duration - dias_bisiesto) %
              duration ==
              0 &&
            diferencia == 366
          ) {
            recibos_incompletos = recibos_incompletos + 1;
            recibos_completos = recibos_completos - 1;
          }

          if (scope.datareceipt.policy_days_duration > 366) {
            recibos_incompletos = recibos_incompletos + 1;
            recibos_completos = recibos_completos - 1;
            scope.nuevoNumeroRecibos = angular.copy(recibos_completos);
          }
          if (scope.datareceipt.num_receipts < scope.nuevoNumeroRecibos) {
            for (
              var j = scope.datareceipt.num_receipts;
              j <= scope.nuevoNumeroRecibos;
              j++
            ) {
              recibos_incompletos = recibos_incompletos + 1;
              recibos_completos = recibos_completos - 1;
            }
          }

          if (recibos_incompletos == 0) {
            recibos_incompletos = 1;
            recibos_completos = recibos_completos - 1;
          }

          scope.recibos_totales = 0;
          scope.recibos_totales = angular.copy(scope.datareceipt.num_receipts);
          // if(scope.datareceipt.payment == 5){
          //   recibos_fracionados = 1;
          //   recibos_completos = 1;
          //   recibos_incompletos = 1;
          //   scope.recibos_totales = 1;
          // }else{
          //   if(recibos_completos < recibos_fracionados){
          //     scope.recibos_totales = recibos_completos + 1;
          //   }else{
          //     scope.recibos_totales = recibos_completos;
          //   }
          // }
          if (scope.datareceipt.concept != 1) {
            recibos_completos =
              angular.copy(scope.datareceipt.num_receipts) - 1;
          }

          if (value == 1) {
            scope.obj = {
              prima_neta:
                (recibos_incompletos * scope.datareceipt.primaNeta) /
                recibos_fracionados,
              rpf:
                (valor_rpf ? recibos_incompletos * valor_rpf : 0) /
                recibos_fracionados,
              derecho:
                (scope.datareceipt.derecho
                  ? recibos_incompletos * scope.datareceipt.derecho
                  : 0) / recibos_fracionados,
              subTotal:
                (recibos_incompletos * scope.datareceipt.subTotal) /
                recibos_fracionados,
              iva:
                (valor_iva ? recibos_incompletos * valor_iva : 0) /
                recibos_fracionados,
              primaTotal:
                (scope.datareceipt.primaTotal
                  ? recibos_incompletos * scope.datareceipt.primaTotal
                  : 0) / recibos_fracionados,
              comision:
                (scope.datareceipt.comision
                  ? recibos_incompletos * scope.datareceipt.comision
                  : 0) / recibos_fracionados,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (recibos_incompletos * valor_prima_descuento) /
                recibos_fracionados;
            }

            scope.mostrarPrimerRecibo = true;
            scope.mostrarTodosRecibo = false;
          } else {
            scope.obj = {
              prima_neta: scope.newPrima.primaNeta / recibos_completos,
              rpf:
                (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                recibos_completos,
              derecho:
                (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                recibos_completos,
              subTotal: scope.newPrima.subTotal / recibos_completos,
              iva:
                (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                recibos_completos,
              primaTotal:
                (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                recibos_completos,
              comision:
                (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                recibos_completos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (scope.newPrima.primaNeta - valor_descuento) /
                recibos_completos;
            }

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;
          }

          scope.dias_resta = scope.recibos_totales * scope.datareceipt.payment;
          scope.dias_resta_fin =
            scope.recibos_totales * scope.datareceipt.payment -
            scope.datareceipt.payment;

          for (var i = 0; i < scope.recibos_totales; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                if (scope.datareceipt.rpf) {
                  scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                } else {
                  scope.obj.rpf = 0;
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            if (scope.datareceipt.type_endorsement == "A") {
              var receipt = {
                recibo_numero: i + 1,
                prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
                rpf: parseFloat(scope.obj.rpf.toFixed(2)),
                derecho: parseFloat(scope.obj.derecho.toFixed(2)),
                iva: parseFloat(scope.obj.iva.toFixed(2)),
                sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
                prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
                comision: parseFloat(scope.obj.comision.toFixed(2)),
                receipt_type: 2,
                delivered: false,
                startDate: scope.obtenerVigenciaInicialDia(
                  i,
                  recibos_completos
                ),
                endingDate: scope.obtenerVigenciaFinalDia(recibos_completos),
              };
            } else if (scope.datareceipt.type_endorsement == "D") {
              var receipt = {
                recibo_numero: i + 1,
                prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)) * -1,
                rpf: parseFloat(scope.obj.rpf.toFixed(2)) * -1,
                derecho: parseFloat(scope.obj.derecho.toFixed(2)) * -1,
                iva: parseFloat(scope.obj.iva.toFixed(2)) * -1,
                sub_total: parseFloat(scope.obj.subTotal.toFixed(2)) * -1,
                prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)) * -1,
                comision: parseFloat(scope.obj.comision.toFixed(2)) * -1,
                receipt_type: 3,
                delivered: false,
                startDate: scope.obtenerVigenciaInicialDia(
                  i,
                  recibos_completos
                ),
                endingDate: scope.obtenerVigenciaFinalDia(recibos_completos),
              };
            }

            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.startDate
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));

            scope.dias_resta = scope.dias_resta - scope.datareceipt.payment;
            scope.dias_resta_fin =
              scope.dias_resta_fin - scope.datareceipt.payment;
          }

          if (value == 2 && scope.type == 1) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }

          scope.generarToSave(value);
        };

        // Calcula recibos quincenal
        scope.calcularRecibosQuincena = function (value) {
          scope.datareceipt.receipts = [];

          if (scope.type == 1) {
            scope.numeroRecibosNuevos = scope.numeroRecibos - 1;
          } else {
            scope.numeroRecibosNuevos = scope.numeroRecibos;
          }
          if (scope.numeroRecibosNuevos < 1) {
            scope.numeroRecibosNuevos = 1;
          }

          if (value == 1) {
            scope.obj = {
              prima_neta: scope.datareceipt.primaNeta / scope.numeroRecibos,
              rpf: (valor_rpf ? valor_rpf : 0) / scope.numeroRecibos,
              derecho:
                (scope.datareceipt.derecho ? scope.datareceipt.derecho : 0) /
                scope.numeroRecibos,
              subTotal: scope.datareceipt.subTotal / scope.numeroRecibos,
              iva: (valor_iva ? valor_iva : 0) / scope.numeroRecibos,
              primaTotal:
                (scope.datareceipt.primaTotal
                  ? scope.datareceipt.primaTotal
                  : 0) / scope.numeroRecibos,
              comision:
                (scope.datareceipt.comision ? scope.datareceipt.comision : 0) /
                scope.numeroRecibos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                valor_prima_descuento / scope.numeroRecibos;
            }

            scope.mostrarPrimerRecibo = true;
            scope.mostrarTodosRecibo = false;
          } else {
            scope.obj = {
              prima_neta: scope.newPrima.primaNeta / scope.numeroRecibosNuevos,
              rpf:
                (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                scope.numeroRecibosNuevos,
              derecho:
                (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                scope.numeroRecibosNuevos,
              subTotal: scope.newPrima.subTotal / scope.numeroRecibosNuevos,
              iva:
                (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                scope.numeroRecibosNuevos,
              primaTotal:
                (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                scope.numeroRecibosNuevos,
              comision:
                (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                scope.numeroRecibosNuevos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (scope.newPrima.primaNeta - valor_descuento) /
                scope.numeroRecibosNuevos;
            }

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;
          }

          for (var i = 0; i < scope.numeroRecibos; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                if (scope.datareceipt.rpf) {
                  scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                } else {
                  scope.obj.rpf = 0;
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            var receipt = {
              recibo_numero: i + 1,
              prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
              rpf: parseFloat(scope.obj.rpf.toFixed(2)),
              derecho: parseFloat(scope.obj.derecho.toFixed(2)),
              iva: parseFloat(scope.obj.iva.toFixed(2)),
              sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
              prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
              comision: parseFloat(scope.obj.comision.toFixed(2)),
              receipt_type: 1,
              delivered: false,
              fecha_inicio: scope.obtenerVigenciaInicial(i),
              fecha_fin: scope.obtenerVigenciaFinal(i),
            };

            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.fecha_inicio
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));
          }

          if (value == 2 && scope.type == 1) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }
          scope.generarToSave(value);
        };

        // Calcula recibos mensual, bimestral, trimestral, semestral, anual, contado
        scope.calcularRecibosMes = function (value, payment_method) {
          // console.log(payment_method);
          scope.datareceipt.receipts = [];
          var recibos_fracionados =
            (scope.datareceipt.policy_days_duration * scope.numeroRecibos) /
            365;
          var arreglo_recibos = recibos_fracionados.toString().split(".");
          var recibos_completos = parseFloat(arreglo_recibos[0]);
          var recibos_incompletos = "0." + arreglo_recibos[1];
          recibos_incompletos = parseFloat(recibos_incompletos);

          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          var date1 = new Date(mes + "/" + dia + "/" + (anio - 1));
          var date2 = new Date(mes + "/" + dia + "/" + anio);
          var timeDiff = Math.abs(date2.getTime() - date1.getTime());
          var duration = Math.ceil(timeDiff / (1000 * 3600 * 24));

          var dias_bisiesto = scope.datareceipt.policy_days_duration % duration;
          var diferencia = Math.abs(date2.getTime() - date1.getTime());

          if (
            (scope.datareceipt.policy_days_duration - dias_bisiesto) %
              duration ==
              0 &&
            diferencia == 366
          ) {
            recibos_incompletos = recibos_incompletos + 1;
            recibos_completos = recibos_completos - 1;
          }

          if (scope.datareceipt.policy_days_duration > 366) {
            recibos_incompletos = recibos_incompletos + 1;
            recibos_completos = recibos_completos - 1;
            scope.nuevoNumeroRecibos = angular.copy(recibos_completos);
          }
          if (scope.datareceipt.num_receipts < scope.nuevoNumeroRecibos) {
            for (
              var j = scope.datareceipt.num_receipts;
              j <= scope.nuevoNumeroRecibos;
              j++
            ) {
              recibos_incompletos = recibos_incompletos + 1;
              recibos_completos = recibos_completos - 1;
            }
          }

          if (recibos_incompletos == 0) {
            recibos_incompletos = 1;
            recibos_completos = recibos_completos - 1;
          }

          scope.recibos_totales = 0;
          scope.recibos_totales = angular.copy(scope.datareceipt.num_receipts);
          // if(scope.datareceipt.payment == 5){
          //   recibos_fracionados = 1;
          //   recibos_completos = 1;
          //   recibos_incompletos = 1;
          //   scope.recibos_totales = 1;
          // }else{
          //   if(recibos_completos < recibos_fracionados){
          //     scope.recibos_totales = recibos_completos + 1;
          //   }else{
          //     scope.recibos_totales = recibos_completos;
          //   }
          // }
          if (scope.datareceipt.concept != 1) {
            recibos_completos =
              angular.copy(scope.datareceipt.num_receipts) - 1;
          }
          // if(scope.form.generarRecibosExcepcional && scope.form.generarRecibosExcepcional==true){
          //   recibos_completos=scope.form.num_receipts ? scope.form.num_receipts : recibos_completos;
          // }else{
          //   recibos_completos = angular.copy(scope.datareceipt.num_receipts) - 1;
          // }
          // console.log('valor_rpf*******+',valor_rpf,valor_derecho)
          if (scope.recibos_totales != 1) {
            if (value == 1) {
              scope.obj = {
                prima_neta: scope.datareceipt.primaNeta / recibos_fracionados,
                rpf: (valor_rpf ? valor_rpf : 0) / recibos_fracionados,
                derecho:
                  (scope.datareceipt.derecho ? scope.datareceipt.derecho : 0) /
                  recibos_fracionados,
                subTotal: scope.datareceipt.subTotal / recibos_fracionados,
                iva: (valor_iva ? valor_iva : 0) / recibos_fracionados,
                primaTotal:
                  (scope.datareceipt.primaTotal
                    ? scope.datareceipt.primaTotal
                    : 0) / recibos_fracionados,
                comision:
                  (scope.datareceipt.comision
                    ? scope.datareceipt.comision
                    : 0) / recibos_fracionados,
              };
              if (scope.datareceipt.aplicarDescuento) {
                scope.obj.prima_neta =
                  valor_prima_descuento / recibos_fracionados;
              }
              scope.mostrarPrimerRecibo = true;
              scope.mostrarTodosRecibo = false;

              if (scope.obj.prima_neta > scope.datareceipt.primaNeta) {
                scope.obj.prima_neta = scope.datareceipt.primaNeta;
              }
              if (scope.obj.rpf > scope.datareceipt.rpf) {
                scope.obj.rpf = scope.datareceipt.rpf;
              }
              if (scope.obj.derecho > scope.datareceipt.derecho) {
                scope.obj.derecho = scope.datareceipt.derecho;
              }
              if (scope.obj.sub_total > scope.datareceipt.subTotal) {
                scope.obj.sub_total = scope.datareceipt.subTotal;
              }
              if (scope.obj.iva > scope.datareceipt.iva) {
                scope.obj.iva = scope.datareceipt.iva;
              }
              if (scope.obj.primaTotal > scope.datareceipt.primaTotal) {
                scope.obj.primaTotal = scope.datareceipt.primaTotal;
              }
              if (scope.obj.comision > scope.datareceipt.comision) {
                scope.obj.comision = scope.datareceipt.comision;
              }
            } else {
              scope.obj = {
                prima_neta: scope.newPrima.primaNeta / recibos_completos,
                rpf:
                  (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                  recibos_completos,
                derecho:
                  (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                  recibos_completos,
                subTotal: scope.newPrima.subTotal / recibos_completos,
                iva:
                  (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                  recibos_completos,
                primaTotal:
                  (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                  recibos_completos,
                comision:
                  (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                  recibos_completos,
              };

              if (scope.datareceipt.aplicarDescuento) {
                scope.obj.prima_neta =
                  (scope.newPrima.primaNeta - valor_descuento) /
                  recibos_completos;
              }
              scope.mostrarPrimerRecibo = false;
              scope.mostrarTodosRecibo = true;
            }
          } else {
            if (value == 1) {
              scope.obj = {
                prima_neta: scope.datareceipt.primaNeta / scope.recibos_totales,
                rpf: (valor_rpf ? valor_rpf : 0) / scope.recibos_totales,
                derecho:
                  (scope.datareceipt.derecho ? scope.datareceipt.derecho : 0) /
                  scope.recibos_totales,
                subTotal: scope.datareceipt.subTotal / scope.recibos_totales,
                iva: (valor_iva ? valor_iva : 0) / scope.recibos_totales,
                primaTotal:
                  (scope.datareceipt.primaTotal
                    ? scope.datareceipt.primaTotal
                    : 0) / scope.recibos_totales,
                comision:
                  (scope.datareceipt.comision
                    ? scope.datareceipt.comision
                    : 0) / scope.recibos_totales,
              };
              if (scope.datareceipt.aplicarDescuento) {
                scope.obj.prima_neta =
                  valor_prima_descuento / scope.recibos_totales;
              }
              scope.mostrarPrimerRecibo = true;
              scope.mostrarTodosRecibo = false;
            } else {
              scope.obj = {
                prima_neta: scope.datareceipt.primaNeta / scope.recibos_totales,
                rpf: (valor_rpf ? valor_rpf : 0) / scope.recibos_totales,
                derecho:
                  (scope.datareceipt.derecho ? scope.datareceipt.derecho : 0) /
                  scope.recibos_totales,
                subTotal: scope.datareceipt.subTotal / scope.recibos_totales,
                iva: (valor_iva ? valor_iva : 0) / scope.recibos_totales,
                primaTotal:
                  (scope.datareceipt.primaTotal
                    ? scope.datareceipt.primaTotal
                    : 0) / scope.recibos_totales,
                comision:
                  (scope.datareceipt.comision
                    ? scope.datareceipt.comision
                    : 0) / scope.recibos_totales,
              };

              if (scope.datareceipt.aplicarDescuento) {
                scope.obj.prima_neta =
                  valor_prima_descuento / scope.recibos_totales;
              }
              scope.mostrarPrimerRecibo = false;
              scope.mostrarTodosRecibo = true;
            }
          }
          if (scope.datareceipt.concept == 1) {
            scope.meses_resta =
              scope.recibos_totales * scope.datareceipt.payment;
            scope.meses_resta_fin =
              scope.recibos_totales * scope.datareceipt.payment -
              scope.datareceipt.payment;
          } else {
            scope.meses_resta =
              scope.recibos_totales * scope.datareceipt.payment;
            scope.meses_resta_fin =
              scope.recibos_totales * scope.datareceipt.payment -
              scope.datareceipt.payment;
          }
          // console.log('oooooooooo',scope.obj,scope.form,scope.datareceipt,scope.recibos_totales)
          for (var i = 0; i < scope.recibos_totales; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                if (scope.datareceipt.rpf) {
                  scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                } else {
                  scope.obj.rpf = 0;
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            if (scope.datareceipt.type_endorsement == "A") {
              var receipt = {
                recibo_numero: i + 1,
                prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
                rpf: parseFloat(scope.obj.rpf.toFixed(2)),
                derecho: parseFloat(scope.obj.derecho.toFixed(2)),
                iva: parseFloat(scope.obj.iva.toFixed(2)),
                sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
                prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
                comision: parseFloat(scope.obj.comision.toFixed(2)),
                receipt_type: 2,
                delivered: false,
                fecha_inicio: scope.obtenerVigenciaInicialMes(
                  i,
                  scope.meses_resta
                ),
                fecha_fin: scope.obtenerVigenciaFinalMes(
                  i,
                  scope.meses_resta_fin
                ),
              };
            } else if (scope.datareceipt.type_endorsement == "D") {
              var receipt = {
                recibo_numero: i + 1,
                prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)) * -1,
                rpf: parseFloat(scope.obj.rpf.toFixed(2)) * -1,
                derecho: parseFloat(scope.obj.derecho.toFixed(2)) * -1,
                iva: parseFloat(scope.obj.iva.toFixed(2)) * -1,
                sub_total: parseFloat(scope.obj.subTotal.toFixed(2)) * -1,
                prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)) * -1,
                comision: parseFloat(scope.obj.comision.toFixed(2)) * -1,
                receipt_type: 3,
                delivered: false,
                fecha_inicio: scope.obtenerVigenciaInicialMes(
                  i,
                  scope.meses_resta
                ),
                fecha_fin: scope.obtenerVigenciaFinalMes(
                  i,
                  scope.meses_resta_fin
                ),
              };
            }
            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.fecha_inicio
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));

            if (scope.datareceipt.concept == 1) {
              scope.meses_resta = scope.meses_resta - scope.datareceipt.payment;
              scope.meses_resta_fin =
                scope.meses_resta_fin - scope.datareceipt.payment;
            } else {
              scope.meses_resta = scope.meses_resta - scope.datareceipt.payment;
              scope.meses_resta_fin =
                scope.meses_resta_fin - scope.datareceipt.payment;
            }
          }

          if (value == 2 && scope.type == 1) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }
          scope.generarToSave(value);
        };

        function convertDate(inputFormat) {
          function pad(s) {
            return s < 10 ? "0" + s : s;
          }
          var d = new Date(inputFormat);
          var date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
          return date;
        }

        // Calcula las fechas de inicio semanal, catorcenal
        scope.obtenerVigenciaInicialDia = function (index, value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);
          fecha.setDate(fecha.getDate() - value);

          if (index == 0) {
            return scope.datareceipt.startDate;
          } else {
            return convertDate(fecha);
          }
        };

        // Calcula las fechas de inicio quincena
        scope.obtenerVigenciaInicialQuincena = function (index, value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);
          console.log("mes", fecha.getMonth());
          fecha.setMonth(fecha.getMonth() - value);

          if (index == 0) {
            return scope.datareceipt.startDate;
          } else {
            return convertDate(fecha);
          }
        };

        // Calcula las fechas de inicio mensual, bimestral, trimestral, semestral, anual, contado
        scope.obtenerVigenciaInicialMes = function (index, value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);

          fecha.setMonth(fecha.getMonth() - value);

          // console.log('numeroRecibos ',scope.numeroRecibos);
          // console.log('value ',value);

          var total_index = scope.recibos_totales - scope.numeroRecibos - 1;

          // console.log('total_indez ',total_index);
          // console.log('index ',index);

          if (index == 0) {
            return scope.datareceipt.startDate;
          } else if (total_index >= index) {
            // console.log('recibos filtrados ', index, scope.datareceipt.startDate);
            return scope.datareceipt.startDate;
          } else {
            return convertDate(fecha);
          }
        };

        // Calcula las fechas de fin semanal, catorcenal
        scope.obtenerVigenciaFinalDia = function (value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);

          fecha.setDate(fecha.getDate() - value);

          return convertDate(fecha);
        };

        // Calcula las fechas de fin quincenal
        scope.obtenerVigenciaFinalQuincena = function (index) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);

          fecha.setDate(fecha.getDate() - value);

          return convertDate(fecha);
        };

        // Calcula las fechas de fin mensual, bimestral, trimestral, semestral, anual, contado
        scope.obtenerVigenciaFinalMes = function (index, value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);

          fecha.setMonth(fecha.getMonth() - value);

          var date_initial_endoso = scope.datareceipt.startDate.split("/");
          var fecha_inicio_endoso = new Date(
            parseInt(date_initial_endoso[1]) +
              "/" +
              parseInt(date_initial_endoso[0]) +
              "/" +
              parseInt(date_initial_endoso[2])
          );

          var total_index = scope.recibos_totales - scope.numeroRecibos - 1;

          if (total_index >= index) {
            return scope.datareceipt.startDate;
          } else if (fecha < fecha_inicio_endoso) {
            return scope.datareceipt.startDate;
          } else {
            return convertDate(fecha);
          }
        };

        // Calcula las fechas de vencimiento de los recibos
        scope.obtenerVencimiento = function (index, date) {
          var date_initial = date.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          if (index == 0) {
            dia = dia + scope.datareceipt.periodo_inicial;
          } else {
            dia = dia + scope.datareceipt.periodo_subsecuente;
          }

          if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
            if (dia > 30) {
              dia = dia - 30;
              mes = mes + 1;
              if (mes > 12) {
                mes = mes - 12;
                anio = anio + 1;
              }
            }
          } else if (mes == 2) {
            if (dia > 28) {
              dia = dia - 28;
              mes = mes + 1;
            }
          } else {
            if (dia > 31) {
              dia = dia - 31;
              mes = mes + 1;
              if (mes > 12) {
                mes = mes - 12;
                anio = anio + 1;
              }
            }
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          return dia + "/" + mes + "/" + anio;
        };

        // Recalcula un recibo
        scope.recalcularRecibo = function (index) {
          if (
            scope.todos_prima[index] ==
            scope.datareceipt.receipts[index].prima_neta
          ) {
            scope.datareceipt.receipts[index].rpf =
              scope.datareceipt.receipts[index].rpf;
          } else {
            scope.todos_prima[index] =
              scope.datareceipt.receipts[index].prima_neta;
            scope.datareceipt.receipts[index].rpf =
              scope.datareceipt.receipts[index].prima_neta *
              ((valor_rpf * 100) / scope.datareceipt.primaNeta / 100);
          }

          if (scope.datareceipt.receipts[index].derecho == null) {
            scope.datareceipt.receipts[index].derecho = 0;
          }

          scope.datareceipt.receipts[index].sub_total =
            scope.datareceipt.receipts[index].prima_neta +
            scope.datareceipt.receipts[index].rpf +
            scope.datareceipt.receipts[index].derecho;

          if (
            scope.todos_subtotal[index] ==
            scope.datareceipt.receipts[index].sub_total
          ) {
            scope.datareceipt.receipts[index].iva =
              scope.datareceipt.receipts[index].iva;
          } else {
            scope.todos_subtotal[index] =
              scope.datareceipt.receipts[index].sub_total;
            scope.datareceipt.receipts[index].iva =
              scope.datareceipt.receipts[index].sub_total *
              ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
          }
          scope.datareceipt.receipts[index].prima_total = parseFloat(
            scope.datareceipt.receipts[index].sub_total +
              scope.datareceipt.receipts[index].iva
          );

          var comision_prima =
            scope.datareceipt.receipts[index].prima_neta *
            (scope.datareceipt.prima_comision / 100);
          var comision_rpf =
            scope.datareceipt.receipts[index].rpf *
            (scope.datareceipt.rpf_comision / 100);
          var comision_derecho =
            scope.datareceipt.receipts[index].derecho *
            (scope.datareceipt.derecho_comision / 100);

          scope.datareceipt.receipts[index].comision =
            comision_prima + comision_rpf + comision_derecho;

          scope.datareceipt.receipts[index].prima_neta = scope.datareceipt
            .receipts[index].prima_neta
            ? parseFloat(
                scope.datareceipt.receipts[index].prima_neta.toFixed(2)
              )
            : 0;
          scope.datareceipt.receipts[index].rpf = scope.datareceipt.receipts[
            index
          ].rpf
            ? parseFloat(scope.datareceipt.receipts[index].rpf.toFixed(2))
            : 0;
          scope.datareceipt.receipts[index].derecho = scope.datareceipt
            .receipts[index].derecho
            ? parseFloat(scope.datareceipt.receipts[index].derecho.toFixed(2))
            : 0;
          scope.datareceipt.receipts[index].sub_total = scope.datareceipt
            .receipts[index].sub_total
            ? parseFloat(scope.datareceipt.receipts[index].sub_total.toFixed(2))
            : 0;
          scope.datareceipt.receipts[index].iva = scope.datareceipt.receipts[
            index
          ].iva
            ? parseFloat(scope.datareceipt.receipts[index].iva.toFixed(2))
            : 0;
          scope.datareceipt.receipts[index].prima_total = scope.datareceipt
            .receipts[index].prima_total
            ? parseFloat(
                scope.datareceipt.receipts[index].prima_total.toFixed(2)
              )
            : 0;
          scope.datareceipt.receipts[index].comision = scope.datareceipt
            .receipts[index].comision
            ? parseFloat(scope.datareceipt.receipts[index].comision.toFixed(2))
            : 0;

          var recibo_prima = 0;
          var recibo_rpf = 0;
          var recibo_derecho = 0;
          var recibo_iva = 0;
          var recibo_total = 0;

          for (var i = 0; i <= index; i++) {
            recibo_prima =
              recibo_prima + scope.datareceipt.receipts[i].prima_neta;
            recibo_rpf = recibo_rpf + scope.datareceipt.receipts[i].rpf;
            recibo_derecho =
              recibo_derecho + scope.datareceipt.receipts[i].derecho;
            recibo_iva = recibo_iva + scope.datareceipt.receipts[i].iva;
            recibo_total =
              recibo_total + scope.datareceipt.receipts[i].prima_total;
          }

          var numero_consecuentes =
            scope.datareceipt.receipts.length - (index + 1);
          for (var j = index + 1; j < scope.datareceipt.receipts.length; j++) {
            scope.datareceipt.receipts[j].prima_neta = parseFloat(
              (
                (scope.datareceipt.primaNeta - recibo_prima) /
                numero_consecuentes
              ).toFixed(2)
            );
            scope.datareceipt.receipts[j].rpf = parseFloat(
              (
                (scope.datareceipt.rpf - recibo_rpf) /
                numero_consecuentes
              ).toFixed(2)
            );
            scope.datareceipt.receipts[j].derecho = parseFloat(
              (
                (scope.datareceipt.derecho - recibo_derecho) /
                numero_consecuentes
              ).toFixed(2)
            );
            scope.datareceipt.receipts[j].iva = parseFloat(
              (
                (scope.datareceipt.iva - recibo_iva) /
                numero_consecuentes
              ).toFixed(2)
            );
            scope.datareceipt.receipts[j].prima_total = parseFloat(
              (
                (scope.datareceipt.primaTotal - recibo_total) /
                numero_consecuentes
              ).toFixed(2)
            );
          }
        };

        scope.recalcularTotal = function (index) {
          scope.datareceipt.receipts[index].prima_total = parseFloat(
            scope.datareceipt.receipts[index].prima_total.toFixed(2)
          );
        };

        // Racalcula la comision de un recibo
        scope.recalcularComision = function (index) {
          scope.datareceipt.receipts[index].comision = scope.datareceipt
            .receipts[index].comision
            ? parseFloat(scope.datareceipt.receipts[index].comision.toFixed(2))
            : 0;
          scope.datareceipt.comision = 0;
          scope.datareceipt.receipts.forEach(function (receipt) {
            scope.datareceipt.comision =
              scope.datareceipt.comision + parseFloat(receipt.comision);
          });

          scope.datareceipt.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );

          scope.calcularComision();
        };

        // Muestra la edición de los recibos
        scope.editarRecibos = function () {
          if (!scope.comision_seleccion && scope.type == 1) {
            SweetAlert.swal(
              "¡Error!",
              "Debe elegir un valor de comisión.",
              "error"
            );
            return;
          } else {
            scope.editar_recibos = true;
          }
        };

        scope.validarFechaInicio = function (receipt, index) {
          if (index > 0) {
            scope.datareceipt.receipts[index - 1].fecha_fin =
              receipt.fecha_inicio;
          }
        };

        scope.validarFechaFin = function (receipt, index) {
          if (scope.datareceipt.receipts.length - 1 > index) {
            scope.datareceipt.receipts[index + 1].fecha_inicio =
              receipt.fecha_fin;
          }
        };

        // Revisa que las fechas de los recibos no se salgan de la vigencia de la póliza
        scope.guardarRecibos = function () {
          var fechas_vacias = false;

          scope.datareceipt.receipts.forEach(function (item, index) {
            if (!item.fecha_inicio || !item.fecha_fin || !item.vencimiento) {
              SweetAlert.swal(
                "Error",
                "No se pueden quedar fechas vacías, revisa que los recibos tengan todas las fechas.",
                "error"
              );
              fechas_vacias = true;
              return;
            } else {
              if (
                process(item.fecha_inicio) <
                  process(scope.datareceipt.startDate) ||
                process(item.fecha_inicio) >
                  process(scope.datareceipt.endingDate) ||
                process(item.fecha_fin) <
                  process(scope.datareceipt.startDate) ||
                process(item.fecha_fin) > process(scope.datareceipt.endingDate)
              ) {
                SweetAlert.swal(
                  "Error",
                  "Las fechas del recibo " +
                    (index + 1) +
                    " se sale de la vigencia de la póliza.",
                  "error"
                );
                fechas_vacias = true;
                return;
              } else {
                // if(process(item.vencimiento) < process(item.fecha_inicio)){
                //   SweetAlert.swal('Error', 'La fecha de vencimiento del recibo ' + (index+1) + ' no puede ser menor a la de su inicio.', 'error');
                //   fechas_vacias = true;
                //   return;
                // }
              }
            }
          });

          function process(date) {
            var parts = date.split("/");
            var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
            return date.getTime();
          }

          var total_prima = 0;
          var total_rpf = 0;
          var total_derecho = 0;
          var total_iva = 0;
          var total_total = 0;

          try {
            if (scope.datareceipt.aplicarDescuento) {
              scope.datareceipt.primaNeta =
                scope.datareceipt.primaNeta - valor_descuento;
            }
          } catch (e) {}
          for (var i = 0; i < scope.datareceipt.receipts.length; i++) {
            total_prima =
              total_prima + scope.datareceipt.receipts[i].prima_neta;
            total_rpf = total_rpf + scope.datareceipt.receipts[i].rpf;
            total_derecho =
              total_derecho + scope.datareceipt.receipts[i].derecho;
            total_iva = total_iva + scope.datareceipt.receipts[i].iva;
            total_total =
              total_total + scope.datareceipt.receipts[i].prima_total;
          }

          if (
            scope.datareceipt.type_endorsement == "D" &&
            scope.datareceipt.concept != 1
          ) {
            total_prima = total_prima * -1;
            total_rpf = total_rpf * -1;
            total_derecho = total_derecho * -1;
            total_iva = total_iva * -1;
            total_total = total_total * -1;
          }
          if (
            scope.datareceipt.primaNeta + 0.99 < total_prima ||
            scope.datareceipt.primaNeta - 0.99 > total_prima
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de las primas netas de todos los recibos no coincide con la prima neta de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            valor_rpf + 0.99 < total_rpf ||
            valor_rpf - 0.99 > total_rpf
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de los rpf de todos los recibos no coincide con el rpf de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            scope.datareceipt.derecho + 0.99 < total_derecho ||
            scope.datareceipt.derecho - 0.99 > total_derecho
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de los derechos de todos los recibos no coincide con el derecho de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            valor_iva + 0.99 < total_iva ||
            valor_iva - 0.99 > total_iva
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de los iva de todos los recibos no coincide con el iva de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            scope.datareceipt.primaTotal + 0.99 < total_total ||
            scope.datareceipt.primaTotal - 0.99 > total_total
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de las primas totales de todos los recibos no coincide con la prima total de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          }

          if (fechas_vacias) {
            scope.editar_recibos = true;
          } else {
            scope.editar_recibos = false;
          }
        };

        scope.changePrimaTotal = function (prima) {
          scope.datareceipt.primaTotal = parseFloat(prima);
        };

        // Completa el json con la información de los recibos para enviarla a la póliza
        scope.generarToSave = function (value) {
          if (value == 1) {
            if (
              scope.datareceipt.aplicarRpf ||
              scope.datareceipt.aplicarDerecho
            ) {
              scope.todos_prima[0] == scope.datareceipt.receipts[0].prima_neta;
              scope.datareceipt.receipts[0].sub_total = parseFloat(
                scope.datareceipt.receipts[0].prima_neta +
                  scope.datareceipt.receipts[0].rpf +
                  scope.datareceipt.receipts[0].derecho
              );
              scope.todos_subtotal[0] ==
                scope.datareceipt.receipts[0].sub_total;
              scope.datareceipt.receipts[0].iva =
                scope.datareceipt.receipts[0].sub_total *
                ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
              scope.datareceipt.receipts[0].prima_total = parseFloat(
                scope.datareceipt.receipts[0].sub_total +
                  scope.datareceipt.receipts[0].iva
              );
              var comision_prima =
                scope.datareceipt.receipts[0].prima_neta *
                (scope.datareceipt.prima_comision / 100);
              var comision_rpf =
                scope.datareceipt.receipts[0].rpf *
                (scope.datareceipt.rpf_comision / 100);
              var comision_derecho =
                scope.datareceipt.receipts[0].derecho *
                (scope.datareceipt.derecho_comision / 100);
              scope.datareceipt.receipts[0].comision =
                comision_prima + comision_rpf + comision_derecho;
              if (scope.datareceipt.aplicarRpf) {
                scope.obj_rpf = scope.datareceipt.receipts[0].rpf;
              }
              scope.datareceipt.receipts[0].prima_neta = parseFloat(
                scope.datareceipt.receipts[0].prima_neta.toFixed(2)
              );
              scope.datareceipt.receipts[0].rpf = parseFloat(
                scope.datareceipt.receipts[0].rpf.toFixed(2)
              );
              scope.datareceipt.receipts[0].derecho = parseFloat(
                scope.datareceipt.receipts[0].derecho.toFixed(2)
              );
              scope.datareceipt.receipts[0].sub_total = parseFloat(
                scope.datareceipt.receipts[0].sub_total.toFixed(2)
              );
              scope.datareceipt.receipts[0].iva = parseFloat(
                scope.datareceipt.receipts[0].iva.toFixed(2)
              );
              scope.datareceipt.receipts[0].prima_total = parseFloat(
                scope.datareceipt.receipts[0].prima_total.toFixed(2)
              );
              scope.datareceipt.receipts[0].comision = parseFloat(
                scope.datareceipt.receipts[0].comision.toFixed(2)
              );
            }
          } else {
            scope.obj_rpf = null;
          }
          scope.tosave.accident_rate = scope.datareceipt.accident_rate;
          if (scope.type == 3) {
            scope.tosave.steps = scope.arreglo_escalones;
          } else {
            scope.tosave.steps = [];
          }
          scope.tosave.p_neta = parseFloat(valor_primaNeta.toFixed(2));
          scope.tosave.descuento = parseFloat(valor_descuento.toFixed(2));
          scope.tosave.rpf = parseFloat(valor_rpf.toFixed(2));
          scope.tosave.aplicarRpf = scope.datareceipt.aplicarRpf;
          scope.tosave.derecho = parseFloat(valor_derecho);
          scope.tosave.aplicarDerecho = scope.datareceipt.aplicarDerecho;
          scope.tosave.sub_total = parseFloat(
            scope.datareceipt.subTotal.toFixed(2)
          );
          scope.tosave.iva = parseFloat(valor_iva.toFixed(2));
          scope.tosave.p_total = parseFloat(
            scope.datareceipt.primaTotal.toFixed(2)
          );
          scope.tosave.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );
          scope.tosave.comision_percent = scope.comisionPorcentaje;
          scope.tosave.poliza = {
            primaNeta: parseFloat(scope.datareceipt.primaNeta.toFixed(2)),
            descuento: parseFloat(valor_descuento.toFixed(2)),
            aplicarDescuento: scope.datareceipt.aplicarDescuento,
            rpf: parseFloat(valor_rpf.toFixed(2)),
            derecho: parseFloat(scope.datareceipt.derecho).toFixed(2),
            iva: parseFloat(valor_iva.toFixed(2)),
            subTotal: parseFloat(scope.datareceipt.subTotal.toFixed(2)),
            primaTotal: parseFloat(scope.datareceipt.primaTotal.toFixed(2)),
          };
          scope.tosave.recibos_poliza = scope.datareceipt.receipts;
        };

        if (scope.tosave) {
          if (scope.tosave.receipts) {
            scope.datareceipt = scope.tosave.poliza;
            if (scope.type == 3) {
              scope.datareceipt.accident_rate = scope.tosave.accident_rate;
              scope.arreglo_escalones =
                scope.tosave.steps.length > 0
                  ? scope.tosave.steps
                  : [{ porcentaje: null, comision: 0 }];
              scope.sumarPorcentajes();
            }
            scope.datareceipt.receipts = scope.tosave.receipts;

            valor_iva = scope.datareceipt.iva;

            scope.editar = true;

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;

            if ($location.path().indexOf("convertir") != -1) {
              scope.mostrarTodosRecibo = false;
            } else {
              scope.mostrarTodosRecibo = true;
            }
          }
        }

        if (scope.type == 2) {
          scope.datareceipt = scope.tosave.poliza;
          valor_primaNeta = scope.tosave.poliza.primaNeta;
          valor_descuento = 0;
          valor_rpf = scope.tosave.poliza.rpf;
          valor_derecho = scope.tosave.poliza.derecho;
          valor_iva = scope.tosave.poliza.iva;

          scope.datareceipt.payment = scope.form.payment;
          scope.datareceipt.subramo = scope.form.subramo;
          scope.datareceipt.startDate = scope.form.startDate;
          scope.datareceipt.endingDate = scope.form.endingDate;
          scope.datareceipt.policy_days_duration =
            scope.form.policy_days_duration;

          scope.datareceipt.prima_comision = 0;
          scope.datareceipt.rpf_comision = 0;
          scope.datareceipt.derecho_comision = 0;
          scope.datareceipt.periodo_inicial = 0;
          scope.datareceipt.periodo_subsecuente = 0;
          scope.datareceipt.domiciliado = scope.form.domiciliado;

          switch (parseFloat(scope.datareceipt.payment)) {
            case 1:
              scope.numeroRecibos = 12;
              break;
            case 2:
              scope.numeroRecibos = 6;
              break;
            case 3:
              scope.numeroRecibos = 4;
              break;
            case 5:
              scope.numeroRecibos = 1; //contado
              break;
            case 6:
              scope.numeroRecibos = 2;
              break;
            case 12:
              scope.numeroRecibos = 1; //anual
              break;
            default:
              break;
          }
          console.log("scope.numeroRecibos", scope.numeroRecibos);
        }
      },
    };
  },
]);

var app = angular.module("inspinia").directive("receiptsEndorsement", [
  "MESSAGES",
  "SweetAlert",
  "$location",
  "$sessionStorage",
  function (MESSAGES, SweetAlert, $location, $sessionStorage) {
    return {
      restrict: "EA",
      scope: {
        form: "=",
        tosave: "=",
        type: "=",
      },
      templateUrl: "app/directivas/calculateReceipts/receiptsEndorsement.html",
      link: function (scope, element, $watch, attrs) {
        // Variables
        scope.comision_seleccion = "";
        scope.accesos = $sessionStorage.permisos;
        if (scope.accesos) {
          scope.accesos.forEach(function (perm) {
            if (perm.model_name == "Comisiones") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Comisiones") {
                  if (acc.checked == true) {
                    scope.permiso_comisiones = true;
                  } else {
                    scope.permiso_comisiones = false;
                  }
                }
              });
            }
            if (perm.model_name == "Cobranza") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Eliminar recibos") {
                  if (acc.checked == true) {
                    scope.permiso_delRecibo = true;
                  } else {
                    scope.permiso_delRecibo = false;
                  }
                }
              });
            }
            if (perm.model_name == "Pólizas") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Comisión no obligatoria") {
                  if (acc.checked == true) {
                    scope.permiso_comision_no_obligatoria = true;
                  } else {
                    scope.permiso_comision_no_obligatoria = false;
                  }
                }
              });
            }
          });
        }
        scope.datareceipt = {
          primaNeta: 0,
          rpf: 0,
          derecho: 0,
          subTotal: 0,
          iva: null,
          primaTotal: 0,
          comision: 0,
        };

        scope.option_descuento = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_descuento = scope.option_descuento[0];

        scope.option_rpf = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_rpf = scope.option_rpf[0];

        scope.option_iva = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_iva = scope.option_iva[0];

        var agregar_comision = 0;

        var valor_primaNeta;
        var valor_descuento;
        var valor_rpf;
        var valor_derecho;
        var valor_iva;
        var valor_prima_descuento;
        var valor_comision;
        var valor_suma_comision;

        var copy_primaNeta = 0;
        var copy_rpf = 0;
        var copy_subTotal = 0;

        scope.newPrima = {};
        scope.todos_prima = [0];
        scope.todos_subtotal = [0];

        scope.mostrarPrimerRecibo = false;
        scope.mostrarTodosRecibo = false;
        scope.editar_recibos = false;

        scope.editar = false;
        scope.recalcular = true;

        scope.obj_rpf = null;

        scope.obj_rpf = null;

        scope.verComisiones = function () {
          var sin_comision = {
            comission: "0",
            comission_derecho: "0",
            comission_rpf: "0",
            derecho: "0",
            efective_date: "Sin fecha",
            expire_date: null,
            nombre: "Sin comisión",
            observations: "-",
            others: "0",
            others_derecho: "0",
            others_rpf: "0",
            periodo_inicial: 0,
            periodo_subsecuente: 0,
            ramo: "-",
            rpf_mensual: "0",
            rpf_bimestral: "0",
            rpf_trimestral: "0",
            rpf_trimestral: "0",
            rpf_anual: "0",
            subramo: "-",
            udi: "0",
            udi_derecho: "0",
            udi_rpf: "0",
          };

          if (scope.form.comisiones) {
            if (scope.form.subramo && agregar_comision == 0) {
              scope.form.comisiones.push(sin_comision);
              agregar_comision++;
            }
          } else {
            if (scope.form.subramo && agregar_comision == 0) {
              scope.form.comisiones = [];
              scope.form.comisiones.push(sin_comision);
              agregar_comision++;
            }
          }
        };

        // Asignar valores segun comision seleccionada
        scope.asignarValores = function (comission) {
          scope.comission = comission;
          if (
            (!scope.form.num_receipts && scope.type == 2) ||
            (scope.form.num_receipts == "" && scope.type == 2)
          ) {
            scope.comision_seleccion = "";
            SweetAlert.swal(
              "¡Error!",
              "Selecciona  un número de recibos.",
              "error"
            );
            return;
          } else {
            if (!scope.editar) {
              if (scope.type == 1) {
                scope.datareceipt.num_receipts = 1;
                scope.datareceipt.payment = 12;
              } else {
                scope.datareceipt.num_receipts = scope.form.num_receipts;
                scope.datareceipt.payment = scope.form.payment;
              }
            } else {
              scope.numeroRecibos = scope.datareceipt.numeroRecibos;
              scope.recalcular = scope.tosave.recalcular;
            }

            scope.datareceipt.subramo = scope.form.subramo.subramo_name;

            scope.datareceipt.derecho = parseFloat(comission.derecho);
            scope.datareceipt.prima_comision = parseFloat(comission.comission);
            scope.datareceipt.rpf_comision = parseFloat(
              comission.comission_rpf
            );
            scope.datareceipt.derecho_comision = parseFloat(
              comission.comission_derecho
            );
            scope.datareceipt.periodo_inicial = parseFloat(
              comission.periodo_inicial
            );
            scope.datareceipt.periodo_subsecuente = parseFloat(
              comission.periodo_subsecuente
            );

            scope.calcularTotales();
          }
        };

        scope.porcentageRpf = function () {
          if (!scope.editar) {
            if (scope.type == 1) {
              scope.datareceipt.num_receipts = 1;
              scope.datareceipt.payment = 1;
            } else {
              scope.datareceipt.num_receipts = scope.form.num_receipts;
              scope.datareceipt.payment = scope.form.payment;
            }
          } else {
            scope.datareceipt.num_receipts = scope.form.num_receipts;
            scope.datareceipt.payment = scope.form.payment;
          }

          if (scope.type == 2) {
            scope.datareceipt.percent_rpf = 3.5;
          } else {
            scope.datareceipt.percent_rpf = 3.5;

            // switch(parseFloat(scope.datareceipt.payment)){
            //   case 1:
            //     scope.datareceipt.percent_rpf = scope.comission.rpf_mensual;
            //     break;
            //   case 2:
            //     scope.datareceipt.percent_rpf = scope.comission.rpf_bimestral;
            //     break;
            //   case 3:
            //     scope.datareceipt.percent_rpf = scope.comission.rpf_trimestral;
            //     break;
            //   case 5:
            //     scope.datareceipt.percent_rpf = scope.comission.rpf_anual;
            //     break;
            //   case 6:
            //     scope.datareceipt.percent_rpf = scope.comission.rpf_semestral;
            //     break;
            //   case 12:
            //     scope.datareceipt.percent_rpf = scope.comission.rpf_anual;
            //     break;
            //   default:
            //     break;
            // }
          }
        };

        // Calcula pesos o porcetaje de rpf
        scope.calcularRpf = function () {
          if (scope.tipo_rpf.value == 2) {
            if (scope.datareceipt.rpf != 0) {
              scope.rpfPesos =
                (valor_prima_descuento * scope.datareceipt.rpf) / 100;
            } else {
              scope.rpfPesos = 0;
            }
          } else {
            if (scope.datareceipt.rpf != 0) {
              scope.rpfPorcentaje = (
                (scope.datareceipt.rpf * 100) /
                valor_prima_descuento
              ).toFixed(2);
            } else {
              scope.rpfPorcentaje = 0;
            }
          }
        };

        // Calcula pesos o porcetaje de iva
        scope.calcularIva = function () {
          if (scope.tipo_iva.value == 2) {
            if (scope.datareceipt.iva != 0) {
              scope.ivaPesos =
                (scope.datareceipt.subTotal * scope.datareceipt.iva) / 100;
            } else {
              scope.ivaPesos = 0;
            }
          } else {
            if (scope.datareceipt.iva != 0) {
              scope.ivaPorcentaje = (
                (scope.datareceipt.iva * 100) /
                scope.datareceipt.subTotal
              ).toFixed(2);
            } else {
              scope.ivaPorcentaje = 0;
            }
          }
        };

        // Calcula totales de las primas
        scope.calcularTotales = function () {
          if (
            !scope.datareceipt.primaNeta ||
            scope.datareceipt.primaNeta == undefined
          ) {
            valor_primaNeta = 0;
          } else {
            valor_primaNeta = parseFloat(scope.datareceipt.primaNeta);
          }

          valor_prima_descuento = valor_primaNeta;
          scope.porcentageRpf();

          if (copy_primaNeta != scope.datareceipt.primaNeta) {
            scope.datareceipt.rpf = parseFloat(
              (
                valor_prima_descuento *
                (parseFloat(scope.datareceipt.percent_rpf) / 100)
              ).toFixed(2)
            );
            copy_rpf = angular.copy(scope.datareceipt.rpf);
          } else {
            if (
              scope.datareceipt.aplicarDescuento &&
              copy_rpf == scope.datareceipt.rpf
            ) {
              scope.datareceipt.rpf = parseFloat(
                (
                  valor_prima_descuento *
                  (parseFloat(scope.datareceipt.percent_rpf) / 100)
                ).toFixed(2)
              );
              copy_rpf = angular.copy(scope.datareceipt.rpf);
            }
          }

          if (!scope.datareceipt.rpf || scope.datareceipt.rpf == undefined) {
            copy_primaNeta = angular.copy(scope.datareceipt.primaNeta);
            valor_rpf = 0;
          } else {
            if (scope.tipo_rpf.value == 2) {
              if (scope.datareceipt.rpf > 100) {
                if (scope.type == 1) {
                  SweetAlert.swal(
                    "Error",
                    "El Derecho no puede ser mayor a 100%.",
                    "error"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "El recargo por pago fraccionado no puede ser mayor a 100%.",
                    "error"
                  );
                }
                scope.datareceipt.rpf = 0;
                valor_rpf = 0;
              } else {
                valor_rpf =
                  (valor_prima_descuento * scope.datareceipt.rpf) / 100;
              }
            } else {
              copy_primaNeta = angular.copy(scope.datareceipt.primaNeta);
              valor_rpf = scope.datareceipt.rpf;
            }
          }
          scope.calcularRpf();

          if (
            !scope.datareceipt.derecho ||
            scope.datareceipt.derecho == undefined
          ) {
            valor_derecho = 0;
          } else {
            valor_derecho = parseFloat(scope.datareceipt.derecho);
          }

          scope.datareceipt.subTotal = parseFloat(
            (valor_prima_descuento + valor_rpf + valor_derecho).toFixed(2)
          );

          if (!scope.datareceipt.iva || scope.datareceipt.iva == undefined) {
            scope.datareceipt.iva = parseFloat(
              (scope.datareceipt.subTotal * 0.16).toFixed(2)
            );
            valor_iva = scope.datareceipt.iva;
          } else {
            if (scope.tipo_iva.value == 2) {
              if (scope.datareceipt.iva > 100) {
                SweetAlert.swal(
                  "Error",
                  "El iva no puede ser mayor a 100%.",
                  "error"
                );
                scope.datareceipt.iva = 0;
                valor_iva = 0;
              } else {
                valor_iva =
                  (scope.datareceipt.subTotal * scope.datareceipt.iva) / 100;
              }
            } else {
              if (copy_subTotal == scope.datareceipt.subTotal) {
                valor_iva = scope.datareceipt.iva;
              } else {
                copy_subTotal = angular.copy(scope.datareceipt.subTotal);
                scope.datareceipt.iva = parseFloat(
                  (scope.datareceipt.subTotal * 0.16).toFixed(2)
                );
                valor_iva = scope.datareceipt.iva;
              }
            }
          }
          scope.calcularIva();

          scope.datareceipt.primaTotal = parseFloat(
            (scope.datareceipt.subTotal + valor_iva).toFixed(2)
          );
          // if(scope.datareceipt.prima_comision <= 0 || scope.datareceipt.prima_comision > 100 || scope.datareceipt.prima_comision == null){
          //   scope.datareceipt.prima_comision = 0;
          // }
          // if(scope.datareceipt.rpf_comision <= 0 || scope.datareceipt.rpf_comision > 100 || scope.datareceipt.rpf_comision == null){
          //   scope.datareceipt.rpf_comision = 0;
          // }
          // if(scope.datareceipt.derecho_comision <= 0 || scope.datareceipt.derecho_comision > 100 || scope.datareceipt.derecho_comision == null){
          //   scope.datareceipt.derecho_comision = 0;
          // }

          scope.valor_prima_comision =
            valor_prima_descuento * (scope.datareceipt.prima_comision / 100);
          scope.valor_rpf_comision =
            valor_rpf * (scope.datareceipt.rpf_comision / 100);
          scope.valor_derecho_comision =
            valor_derecho * (scope.datareceipt.derecho_comision / 100);

          valor_suma_comision = 0;
          scope.datareceipt.comision = 0;
          if (scope.valor_prima_comision != 0) {
            scope.datareceipt.comision = parseFloat(scope.valor_prima_comision);
            valor_suma_comision = valor_prima_descuento;
          }
          if (scope.valor_rpf_comision != 0) {
            scope.datareceipt.comision =
              scope.datareceipt.comision + parseFloat(scope.valor_rpf_comision);
            valor_suma_comision = valor_suma_comision + valor_rpf;
          }
          if (scope.valor_derecho_comision != 0) {
            scope.datareceipt.comision =
              scope.datareceipt.comision +
              parseFloat(scope.valor_derecho_comision);
            valor_suma_comision = valor_suma_comision + valor_derecho;
          }

          scope.datareceipt.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );

          scope.comisionPorcentaje = (
            (scope.datareceipt.comision * 100) /
            valor_suma_comision
          ).toFixed(2);

          if (scope.comisionPorcentaje == "NaN") {
            scope.comisionPorcentaje = 0;
          }

          scope.tosave.comision = scope.datareceipt.comision;
          scope.tosave.comision_percent = scope.comisionPorcentaje;
        };

        // Calcula el porcentaje de la comisión
        scope.calcularComision = function () {
          scope.comisionPorcentaje = (
            (scope.datareceipt.comision * 100) /
            scope.datareceipt.subTotal
          ).toFixed(2);
          scope.form.comision_percent = scope.comisionPorcentaje;
          scope.generarToSave();
        };

        // Calcula el primer recibo
        scope.calcularPrimerRecibo = function () {
          if (!scope.permiso_comision_no_obligatoria && !scope.form.is_fianza) {
            if (
              scope.datareceipt.prima_comision == 0 ||
              scope.datareceipt.prima_comision == "0" ||
              scope.datareceipt.prima_comision == ""
            ) {
              SweetAlert.swal(
                "¡Error!",
                "La comisión de prima neta es obligatoria.",
                "error"
              );
              scope.mostrarPrimerRecibo = false;
              return;
            }
          }

          if (!scope.comision_seleccion) {
            SweetAlert.swal(
              "¡Error!",
              "Debe elegir un valor de comisión.",
              "error"
            );
            return;
          }

          if (scope.type == 1) {
            scope.datareceipt.startDate = scope.form.startDate;
            scope.datareceipt.endingDate = scope.form.endingDate;
          } else {
            scope.datareceipt.startDate = scope.form.start_of_validity;
            scope.datareceipt.endingDate = scope.form.end_of_validity;
          }

          if (!scope.editar) {
            if (scope.type == 1) {
              scope.datareceipt.num_receipts = 1;
              scope.datareceipt.payment = 12;
            } else {
              scope.datareceipt.num_receipts = scope.form.num_receipts;
              scope.datareceipt.payment = scope.form.payment;
              scope.datareceipt.type_endorsement = scope.form.type_endorsement;
            }
          } else {
            if (scope.type == 1) {
              scope.datareceipt.num_receipts = 1;
              scope.datareceipt.payment = 12;
            } else {
              scope.datareceipt.num_receipts = scope.form.num_receipts;
              scope.datareceipt.payment = scope.form.payment;
              scope.datareceipt.type_endorsement = scope.form.endorsement_type;
            }
          }

          if (scope.type == 2 && scope.datareceipt.type_endorsement == "A") {
            scope.noteColor = { color: "inherit" };
          } else if (
            scope.type == 2 &&
            scope.datareceipt.type_endorsement == "D"
          ) {
            scope.noteColor = { color: "#ff0000" };
          }

          scope.datareceipt.policy_days_duration =
            scope.form.policy_days_duration;

          scope.datareceipt.primaNeta = parseFloat(scope.datareceipt.primaNeta);
          scope.datareceipt.derecho = parseFloat(scope.datareceipt.derecho);
          scope.datareceipt.subTotal = parseFloat(scope.datareceipt.subTotal);
          scope.datareceipt.comision = parseFloat(scope.datareceipt.comision);

          if (scope.recalcular) {
            switch (parseFloat(scope.datareceipt.payment)) {
              case 1:
                scope.numeroRecibos = 12;
                break;
              case 2:
                scope.numeroRecibos = 6;
                break;
              case 3:
                scope.numeroRecibos = 4;
                break;
              case 5:
                scope.numeroRecibos = 1; //contado
                break;
              case 6:
                scope.numeroRecibos = 2;
                break;
              case 12:
                scope.numeroRecibos = 1; //anual
                break;
              default:
                break;
            }

            if (scope.type == 1) {
              scope.calcularRecibos(1);
            } else {
              if (scope.datareceipt.policy_days_duration <= 366) {
                scope.calcularRecibosCortos(1);
              } else if (scope.datareceipt.policy_days_duration > 366) {
                scope.calcularRecibosCortos(1);
              }
            }
            if ((scope.type = 1)) {
              scope.calcularSiguientesRecibos();
            } else {
              SweetAlert.swal(
                "¡Atención!",
                "Introduce las primas para el primer recibo, después genera los recibos subsecuentes.",
                "warning"
              );
            }
          } else {
            SweetAlert.swal(
              "¡Error se modificaron primas!",
              "Y existen recibos pagados, las primas de la póliza se podrán guardar pero cada recibo se deberá que modificar de manera manual desde la información.",
              "error"
            );
          }
        };

        // Recalcula el primer recibo
        scope.calcularTotalPrimerRecibo = function () {
          if (
            scope.todos_prima[0] == scope.datareceipt.receipts[0].prima_neta
          ) {
            scope.datareceipt.receipts[0].rpf =
              scope.datareceipt.receipts[0].rpf;
          } else {
            scope.todos_prima = [];
            scope.datareceipt.receipts.forEach(function (receipt) {
              scope.todos_prima.push(receipt.prima_neta);
            });
            if (scope.obj_rpf != null) {
              scope.datareceipt.receipts[0].rpf = scope.obj_rpf;
            } else {
              scope.datareceipt.receipts[0].rpf =
                scope.datareceipt.receipts[0].prima_neta *
                ((valor_rpf * 100) / scope.datareceipt.primaNeta / 100);
            }
          }

          if (scope.datareceipt.receipts[0].derecho == null) {
            scope.datareceipt.receipts[0].derecho = 0;
          }

          scope.datareceipt.receipts[0].sub_total =
            scope.datareceipt.receipts[0].prima_neta +
            scope.datareceipt.receipts[0].rpf +
            scope.datareceipt.receipts[0].derecho;

          if (
            scope.todos_subtotal[0] == scope.datareceipt.receipts[0].sub_total
          ) {
            scope.datareceipt.receipts[0].iva =
              scope.datareceipt.receipts[0].iva;
          } else {
            scope.todos_subtotal = [];
            scope.datareceipt.receipts.forEach(function (receipt) {
              scope.todos_subtotal.push(receipt.sub_total);
            });
            scope.datareceipt.receipts[0].iva =
              scope.datareceipt.receipts[0].sub_total *
              ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
          }
          scope.datareceipt.receipts[0].prima_total =
            scope.datareceipt.receipts[0].sub_total +
            scope.datareceipt.receipts[0].iva;

          var comision_primer_recibo_prima =
            scope.datareceipt.receipts[0].prima_neta *
            (scope.datareceipt.prima_comision / 100);
          var comision_primer_recibo_rpf =
            scope.datareceipt.receipts[0].rpf *
            (scope.datareceipt.rpf_comision / 100);
          var comision_primer_recibo_derecho =
            scope.datareceipt.receipts[0].derecho *
            (scope.datareceipt.derecho_comision / 100);

          scope.datareceipt.receipts[0].comision =
            comision_primer_recibo_prima +
            comision_primer_recibo_rpf +
            comision_primer_recibo_derecho;

          scope.datareceipt.receipts[0].prima_neta = parseFloat(
            scope.datareceipt.receipts[0].prima_neta.toFixed(2)
          );
          scope.datareceipt.receipts[0].rpf = parseFloat(
            scope.datareceipt.receipts[0].rpf.toFixed(2)
          );
          scope.datareceipt.receipts[0].derecho = parseFloat(
            scope.datareceipt.receipts[0].derecho.toFixed(2)
          );
          scope.datareceipt.receipts[0].sub_total = parseFloat(
            scope.datareceipt.receipts[0].sub_total.toFixed(2)
          );
          scope.datareceipt.receipts[0].iva = parseFloat(
            scope.datareceipt.receipts[0].iva.toFixed(2)
          );
          scope.datareceipt.receipts[0].prima_total = parseFloat(
            scope.datareceipt.receipts[0].prima_total.toFixed(2)
          );
          scope.datareceipt.receipts[0].comision = parseFloat(
            scope.datareceipt.receipts[0].comision.toFixed(2)
          );
        };

        // Calcula recibos subsecuentes con cambios en primer recibo
        scope.calcularSiguientesRecibos = function () {
          scope.firstReceipt = angular.copy(scope.datareceipt.receipts[0]);

          if (
            scope.datareceipt.primaNeta >=
            scope.datareceipt.receipts[0].prima_neta
          ) {
            if (scope.type == 2 && scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.primaNeta =
                scope.datareceipt.primaNeta -
                scope.datareceipt.receipts[0].prima_neta;
            } else if (
              scope.type == 2 &&
              scope.datareceipt.type_endorsement == "D"
            ) {
              scope.newPrima.primaNeta =
                scope.datareceipt.primaNeta +
                scope.datareceipt.receipts[0].prima_neta;
            }
          } else {
            if (scope.type == 1) {
              scope.newPrima.primaNeta = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "La prima neta del primer recibo es mayor a la prima neta de la póliza.",
                "error"
              );
              return;
            }
          }

          if (valor_rpf >= scope.datareceipt.receipts[0].rpf) {
            if (scope.type == 2 && scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.rpf =
                valor_rpf - scope.datareceipt.receipts[0].rpf;
            } else if (
              scope.type == 2 &&
              scope.datareceipt.type_endorsement == "D"
            ) {
              scope.newPrima.rpf =
                valor_rpf + scope.datareceipt.receipts[0].rpf;
            }
          } else {
            if (scope.type == 1) {
              scope.newPrima.rpf = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "El RPF del primer recibo es mayor al RPF de la póliza.",
                "error"
              );
              return;
            }
          }

          if (
            scope.datareceipt.derecho >= scope.datareceipt.receipts[0].derecho
          ) {
            if (scope.type == 2 && scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.derecho =
                scope.datareceipt.derecho -
                scope.datareceipt.receipts[0].derecho;
            } else if (
              scope.type == 2 &&
              scope.datareceipt.type_endorsement == "D"
            ) {
              scope.newPrima.derecho =
                scope.datareceipt.derecho +
                scope.datareceipt.receipts[0].derecho;
            }
          } else {
            if (scope.type == 1) {
              scope.newPrima.derech = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "El derecho del primer recibo es mayor al derecho de la póliza.",
                "error"
              );
              return;
            }
          }

          if (
            scope.datareceipt.subTotal >=
            scope.datareceipt.receipts[0].sub_total
          ) {
            if (scope.type == 2 && scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.subTotal =
                scope.datareceipt.subTotal -
                scope.datareceipt.receipts[0].sub_total;
            } else if (
              scope.type == 2 &&
              scope.datareceipt.type_endorsement == "D"
            ) {
              scope.newPrima.subTotal =
                scope.datareceipt.subTotal +
                scope.datareceipt.receipts[0].sub_total;
            }
          } else {
            scope.newPrima.subTotal = 0;
          }

          if (valor_iva >= scope.datareceipt.receipts[0].iva) {
            if (scope.type == 2 && scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.iva =
                valor_iva - scope.datareceipt.receipts[0].iva;
            } else if (
              scope.type == 2 &&
              scope.datareceipt.type_endorsement == "D"
            ) {
              scope.newPrima.iva =
                valor_iva + scope.datareceipt.receipts[0].iva;
            }
          } else {
            if (scope.type == 1) {
              scope.newPrima.iva = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "El iva del primer recibo es mayor al iva de la póliza.",
                "error"
              );
              return;
            }
          }

          if (
            scope.datareceipt.primaTotal >=
            scope.datareceipt.receipts[0].prima_total
          ) {
            if (scope.type == 2 && scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.primaTotal =
                scope.datareceipt.primaTotal -
                scope.datareceipt.receipts[0].prima_total;
            } else if (
              scope.type == 2 &&
              scope.datareceipt.type_endorsement == "D"
            ) {
              scope.newPrima.primaTotal =
                scope.datareceipt.primaTotal +
                scope.datareceipt.receipts[0].prima_total;
            }
          } else {
            if (scope.type == 1) {
              scope.newPrima.primaTotal = 0;
            } else {
              SweetAlert.swal(
                "Error",
                "La prima total del primer recibo es mayor a la prima total de la póliza.",
                "error"
              );
              return;
            }
          }

          if (
            scope.datareceipt.comision >= scope.datareceipt.receipts[0].comision
          ) {
            if (scope.type == 2 && scope.datareceipt.type_endorsement == "A") {
              scope.newPrima.comision =
                scope.datareceipt.comision -
                scope.datareceipt.receipts[0].comision;
            } else if (
              scope.type == 2 &&
              scope.datareceipt.type_endorsement == "D"
            ) {
              scope.newPrima.comision =
                scope.datareceipt.comision +
                scope.datareceipt.receipts[0].comision;
            }
          } else {
            scope.newPrima.comision = 0;
          }

          if (scope.type == 1) {
            scope.calcularRecibos(2);
          } else {
            if (scope.datareceipt.policy_days_duration <= 366) {
              scope.calcularRecibosCortos(2);
            } else if (scope.datareceipt.policy_days_duration > 366) {
              scope.calcularRecibosCortos(2);
            }
          }
        };

        // Calcula recibos de menos de un año de vigencia
        scope.calcularRecibosCortos = function (value) {
          scope.datareceipt.receipts = [];

          scope.nuevoNumeroRecibos = angular.copy(scope.numeroRecibos);

          var recibos_fracionados =
            (scope.datareceipt.policy_days_duration * scope.numeroRecibos) /
            366;
          var arreglo_recibos = recibos_fracionados.toString().split(".");
          var recibos_completos = parseFloat(arreglo_recibos[0]);
          if (arreglo_recibos[1] == undefined) {
            arreglo_recibos[1] = 0;
          }
          var recibos_incompletos = "0." + arreglo_recibos[1];
          recibos_incompletos = parseFloat(recibos_incompletos);

          if (scope.datareceipt.policy_days_duration > 366) {
            scope.nuevoNumeroRecibos = angular.copy(recibos_completos);
          }

          if (scope.datareceipt.num_receipts < scope.nuevoNumeroRecibos) {
            if (recibos_completos <= recibos_fracionados) {
              scope.nuevoNumeroRecibos = recibos_completos + 1;
            }
            for (
              var j = scope.datareceipt.num_receipts;
              j < scope.nuevoNumeroRecibos;
              j++
            ) {
              recibos_incompletos = recibos_incompletos + 1;
              recibos_completos = recibos_completos - 1;
            }
          }

          if (recibos_incompletos == 0) {
            recibos_incompletos = 1;
            recibos_completos = recibos_completos - 1;
          }

          if (value == 1) {
            scope.obj = {
              prima_neta:
                (recibos_incompletos * scope.datareceipt.primaNeta) /
                recibos_fracionados,
              rpf:
                (valor_rpf ? recibos_incompletos * valor_rpf : 0) /
                recibos_fracionados,
              derecho:
                (scope.datareceipt.derecho
                  ? recibos_incompletos * scope.datareceipt.derecho
                  : 0) / recibos_fracionados,
              subTotal:
                (recibos_incompletos * scope.datareceipt.subTotal) /
                recibos_fracionados,
              iva:
                (valor_iva ? recibos_incompletos * valor_iva : 0) /
                recibos_fracionados,
              primaTotal:
                (scope.datareceipt.primaTotal
                  ? recibos_incompletos * scope.datareceipt.primaTotal
                  : 0) / recibos_fracionados,
              comision:
                (scope.datareceipt.comision
                  ? recibos_incompletos * scope.datareceipt.comision
                  : 0) / recibos_fracionados,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (recibos_incompletos * valor_prima_descuento) /
                recibos_fracionados;
            }

            scope.mostrarPrimerRecibo = true;
            scope.mostrarTodosRecibo = false;
          } else {
            scope.obj = {
              prima_neta: scope.newPrima.primaNeta / recibos_completos,
              rpf:
                (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                recibos_completos,
              derecho:
                (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                recibos_completos,
              subTotal: scope.newPrima.subTotal / recibos_completos,
              iva:
                (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                recibos_completos,
              primaTotal:
                (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                recibos_completos,
              comision:
                (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                recibos_completos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (scope.newPrima.primaNeta - valor_descuento) /
                recibos_completos;
            }

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;

            if (recibos_completos <= recibos_fracionados) {
              scope.numeroRecibos = recibos_completos + 1;
            }
          }

          for (var i = 0; i < scope.numeroRecibos; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                if (scope.datareceipt.rpf) {
                  scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                } else {
                  scope.obj.rpf = 0;
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            if (scope.type == 1) {
              var receipt = {
                recibo_numero: i + 1,
                prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
                rpf: parseFloat(scope.obj.rpf.toFixed(2)),
                derecho: parseFloat(scope.obj.derecho.toFixed(2)),
                iva: parseFloat(scope.obj.iva.toFixed(2)),
                sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
                prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
                comision: parseFloat(scope.obj.comision.toFixed(2)),
                receipt_type: 1,
                delivered: false,
                startDate: scope.obtenerVigenciaInicialCorta(
                  i,
                  recibos_completos
                ),
                endingDate: scope.obtenerVigenciaFinalCorta(recibos_completos),
              };
            } else if (
              scope.type == 2 &&
              scope.datareceipt.type_endorsement == "A"
            ) {
              var receipt = {
                recibo_numero: i + 1,
                prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
                rpf: parseFloat(scope.obj.rpf.toFixed(2)),
                derecho: parseFloat(scope.obj.derecho.toFixed(2)),
                iva: parseFloat(scope.obj.iva.toFixed(2)),
                sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
                prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
                comision: parseFloat(scope.obj.comision.toFixed(2)),
                receipt_type: 2,
                delivered: false,
                startDate: scope.obtenerVigenciaInicialCorta(
                  i,
                  recibos_completos
                ),
                endingDate: scope.obtenerVigenciaFinalCorta(recibos_completos),
              };
            } else if (
              scope.type == 2 &&
              scope.datareceipt.type_endorsement == "D"
            ) {
              var receipt = {
                recibo_numero: i + 1,
                prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)) * -1,
                rpf: parseFloat(scope.obj.rpf.toFixed(2)) * -1,
                derecho: parseFloat(scope.obj.derecho.toFixed(2)) * -1,
                iva: parseFloat(scope.obj.iva.toFixed(2)) * -1,
                sub_total: parseFloat(scope.obj.subTotal.toFixed(2)) * -1,
                prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)) * -1,
                comision: parseFloat(scope.obj.comision.toFixed(2)) * -1,
                receipt_type: 3,
                delivered: false,
                startDate: scope.obtenerVigenciaInicialCorta(
                  i,
                  recibos_completos
                ),
                endingDate: scope.obtenerVigenciaFinalCorta(recibos_completos),
              };
            }

            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.startDate
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));

            recibos_completos--;
          }

          if (value == 2) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }

          scope.generarToSave(value);
        };

        // Calcula recibos de un año de vigencia
        scope.calcularRecibos = function (value) {
          scope.datareceipt.receipts = [];

          scope.numeroRecibosNuevos = scope.numeroRecibos - 1;
          if (scope.numeroRecibosNuevos < 1) {
            scope.numeroRecibosNuevos = 1;
          }

          if (value == 1) {
            scope.obj = {
              prima_neta: scope.datareceipt.primaNeta / scope.numeroRecibos,
              rpf: (valor_rpf ? valor_rpf : 0) / scope.numeroRecibos,
              derecho:
                (scope.datareceipt.derecho ? scope.datareceipt.derecho : 0) /
                scope.numeroRecibos,
              subTotal: scope.datareceipt.subTotal / scope.numeroRecibos,
              iva: (valor_iva ? valor_iva : 0) / scope.numeroRecibos,
              primaTotal:
                (scope.datareceipt.primaTotal
                  ? scope.datareceipt.primaTotal
                  : 0) / scope.numeroRecibos,
              comision:
                (scope.datareceipt.comision ? scope.datareceipt.comision : 0) /
                scope.numeroRecibos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                valor_prima_descuento / scope.numeroRecibos;
            }

            scope.mostrarPrimerRecibo = true;
            scope.mostrarTodosRecibo = false;
          } else {
            scope.obj = {
              prima_neta: scope.newPrima.primaNeta / scope.numeroRecibosNuevos,
              rpf:
                (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                scope.numeroRecibosNuevos,
              derecho:
                (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                scope.numeroRecibosNuevos,
              subTotal: scope.newPrima.subTotal / scope.numeroRecibosNuevos,
              iva:
                (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                scope.numeroRecibosNuevos,
              primaTotal:
                (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                scope.numeroRecibosNuevos,
              comision:
                (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                scope.numeroRecibosNuevos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (scope.newPrima.primaNeta - valor_descuento) /
                scope.numeroRecibosNuevos;
            }

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;
          }

          for (var i = 0; i < scope.numeroRecibos; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                if (scope.datareceipt.rpf) {
                  scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                } else {
                  scope.obj.rpf = 0;
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            var receipt = {
              recibo_numero: i + 1,
              prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
              rpf: parseFloat(scope.obj.rpf.toFixed(2)),
              derecho: parseFloat(scope.obj.derecho.toFixed(2)),
              iva: parseFloat(scope.obj.iva.toFixed(2)),
              sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
              prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
              comision: parseFloat(scope.obj.comision.toFixed(2)),
              receipt_type: 1,
              delivered: false,
              startDate: scope.obtenerVigenciaInicial(i),
              endingDate: scope.obtenerVigenciaFinal(i),
            };

            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.startDate
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));
          }

          if (value == 2) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }
          scope.generarToSave(value);
        };

        // Calcula recibos de mas de año de vigencia
        scope.calcularRecibosMultianuales = function (value) {
          scope.datareceipt.receipts = [];

          if (!scope.datareceipt.startDate) {
            scope.datareceipt.startDate = scope.form.startDate;
            scope.datareceipt.endingDate = scope.form.endingDate;
          }

          var date_initial = scope.datareceipt.startDate.split("/");
          var date_final = scope.datareceipt.endingDate.split("/");
          var anio_initial = parseInt(date_initial[2]);
          var anio_final = parseInt(date_final[2]);
          var total_anios = anio_final - anio_initial;

          scope.numeroRecibosAnios = scope.numeroRecibos * total_anios;

          scope.numeroRecibosAniosNuevos = scope.numeroRecibosAnios - 1;
          if (scope.numeroRecibosAniosNuevos < 1) {
            scope.numeroRecibosAniosNuevos = 1;
          }

          if (value == 1) {
            scope.obj = {
              prima_neta:
                scope.datareceipt.primaNeta / scope.numeroRecibosAnios,
              rpf: (valor_rpf ? valor_rpf : 0) / scope.numeroRecibosAnios,
              derecho:
                (scope.datareceipt.derecho ? scope.datareceipt.derecho : 0) /
                scope.numeroRecibosAnios,
              subTotal: scope.datareceipt.subTotal / scope.numeroRecibosAnios,
              iva: (valor_iva ? valor_iva : 0) / scope.numeroRecibosAnios,
              primaTotal:
                (scope.datareceipt.primaTotal
                  ? scope.datareceipt.primaTotal
                  : 0) / scope.numeroRecibosAnios,
              comision:
                (scope.datareceipt.comision ? scope.datareceipt.comision : 0) /
                scope.numeroRecibosAnios,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                valor_prima_descuento / scope.numeroRecibosAnios;
            }

            scope.mostrarPrimerRecibo = true;
            scope.mostrarTodosRecibo = false;
          } else {
            scope.obj = {
              prima_neta:
                scope.newPrima.primaNeta / scope.numeroRecibosAniosNuevos,
              rpf:
                (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                scope.numeroRecibosAniosNuevos,
              derecho:
                (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                scope.numeroRecibosAniosNuevos,
              subTotal:
                scope.newPrima.subTotal / scope.numeroRecibosAniosNuevos,
              iva:
                (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                scope.numeroRecibosAniosNuevos,
              primaTotal:
                (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                scope.numeroRecibosAniosNuevos,
              comision:
                (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                scope.numeroRecibosAniosNuevos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (scope.newPrima.primaNeta - valor_descuento) /
                scope.numeroRecibosAniosNuevos;
            }

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;
          }

          var j = 0;
          var index_anual = 0;
          var numero_anio = 0;

          for (var i = 0; i < scope.numeroRecibosAnios; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                if (scope.datareceipt.rpf) {
                  scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                } else {
                  scope.obj.rpf = 0;
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            if (scope.datareceipt.fy) {
              if (i >= scope.numeroRecibos) {
                scope.obj = {
                  prima_neta: 0,
                  rpf: 0,
                  derecho: 0,
                  subTotal: 0,
                  iva: 0,
                  primaTotal: 0,
                  comision: 0,
                };
              }
            }

            if (j >= scope.numeroRecibos) {
              j = 1;
            } else {
              j++;
            }

            var receipt = {
              recibo_numero: j,
              prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
              rpf: parseFloat(scope.obj.rpf.toFixed(2)),
              derecho: parseFloat(scope.obj.derecho.toFixed(2)),
              iva: parseFloat(scope.obj.iva.toFixed(2)),
              sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
              prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
              comision: parseFloat(scope.obj.comision.toFixed(2)),
              receipt_type: 1,
              delivered: false,
              startDate: scope.obtenerVigenciaInicialMultianual(
                index_anual,
                numero_anio
              ),
              endingDate: scope.obtenerVigenciaFinalMultianual(
                index_anual,
                numero_anio
              ),
            };

            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.startDate
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));

            index_anual++;
            if (index_anual >= scope.numeroRecibos) {
              index_anual = 0;
              numero_anio++;
            }
          }

          if (value == 2) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }

          scope.generarToSave(value);
        };

        // Calcula las fechas de inicio de los recibos menores de un año de vigencia
        scope.obtenerVigenciaInicialCorta = function (index, value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          if (parseFloat(scope.datareceipt.payment) == 5) {
            var date_initial = scope.datareceipt.startDate.split("/");
            var anio = parseInt(date_initial[2]);
          }

          mes = mes - (value + 1) * parseFloat(scope.datareceipt.payment);

          if (mes < 0) {
            mes = mes + 12;
            anio = anio - 1;
          } else if (mes == 0) {
            mes = 12;
            anio = anio - 1;
          }

          if (index == 0) {
            date_initial = scope.datareceipt.startDate.split("/");
            dia = parseInt(date_initial[0]);
            mes = parseInt(date_initial[1]);
            anio = parseInt(date_initial[2]);
          }

          if (dia == 31) {
            if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 30;
            } else if (mes == 2) {
              dia = 28;
            }
          }

          if (dia > 28 && mes == 2) {
            dia = 28;
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          return dia + "/" + mes + "/" + anio;
        };

        // Calcula las fechas de inicio de los recibos con un año de vigencia
        scope.obtenerVigenciaInicial = function (index) {
          var date_initial = scope.datareceipt.startDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          mes = mes + index * parseFloat(scope.datareceipt.payment);

          if (mes > 12) {
            mes = mes - 12;
            anio = anio + 1;
          }

          if (dia == 31) {
            if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 30;
            } else if (mes == 2) {
              dia = 28;
            }
          }

          if (dia > 28 && mes == 2) {
            dia = 28;
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          return dia + "/" + mes + "/" + anio;
        };

        // Calcula las fechas de inicio de los recibos con mayores de un año de vigencia
        scope.obtenerVigenciaInicialMultianual = function (value, number) {
          var date_initial = scope.datareceipt.startDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          mes = mes + value * parseFloat(scope.datareceipt.payment);

          if (mes > 12) {
            mes = mes - 12;
            anio = anio + 1;
          }

          if (dia == 31) {
            if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 30;
            } else if (mes == 2) {
              dia = 28;
            }
          }

          if (dia > 28 && mes == 2) {
            dia = 28;
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          anio = anio + number;

          return dia + "/" + mes + "/" + anio;
        };

        // Calcula las fechas de fin de los recibos menores de un año de vigencia
        scope.obtenerVigenciaFinalCorta = function (value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          if (parseFloat(scope.datareceipt.payment) == 5) {
            mes = mes - value * 12;
          } else {
            mes = mes - value * parseFloat(scope.datareceipt.payment);
          }

          if (mes < 0) {
            mes = mes + 12;
            anio = anio - 1;
          } else if (mes == 0) {
            mes = 12;
            anio = anio - 1;
          }

          if (dia == 31) {
            if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 30;
            } else if (mes == 2) {
              dia = 28;
            }
          }

          if (dia > 28 && mes == 2) {
            dia = 28;
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }
          return dia + "/" + mes + "/" + anio;
        };

        // Calcula las fechas de fin de los recibos con un año de vigencia
        scope.obtenerVigenciaFinal = function (index) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          if (dia > 28 && mes == 2) {
            dia = 28;
          }
          if (scope.datareceipt.policy_days_duration <= 366) {
            dia = dia - 1;
          }
          if (dia == 0) {
            if (
              mes == 1 ||
              mes == 2 ||
              mes == 4 ||
              mes == 6 ||
              mes == 8 ||
              mes == 9 ||
              mes == 11
            ) {
              dia = 31;
            } else if (mes == 3) {
              dia = 28;
            } else if (mes == 5 || mes == 7 || mes == 10 || mes == 12) {
              dia = 30;
            }
            mes = mes - 1;
          }
          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }
          // if (mes == '00') {
          //   mes = 12
          // }
          if (mes < 0) {
            mes = mes + 12;
            anio = anio - 1;
          } else if (mes == 0) {
            mes = 12;
            anio = anio - 1;
          }
          // console.log('-d--',dia,mes,anio)
          return dia + "/" + mes + "/" + anio;
        };

        // Calcula las fechas de fin de los recibos con mayores de un año de vigencia
        scope.obtenerVigenciaFinalMultianual = function (index, number) {
          var date_initial = scope.datareceipt.startDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          if (parseFloat(scope.datareceipt.payment) == 5) {
            mes = mes + (index + 1) * 12;
          } else {
            mes = mes + (index + 1) * parseFloat(scope.datareceipt.payment);
          }

          if (mes > 12) {
            mes = mes - 12;
            anio = anio + 1;
          }

          if (dia == 31) {
            if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 30;
            } else if (mes == 2) {
              dia = 28;
            }
          }

          if (dia > 28 && mes == 2) {
            dia = 28;
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          anio = anio + number;

          return dia + "/" + mes + "/" + anio;
        };

        // Calcula las fechas de vencimiento de los recibos
        scope.obtenerVencimiento = function (index, date) {
          var date_initial = date.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          if (index == 0) {
            dia = dia + scope.datareceipt.periodo_inicial;
          } else {
            dia = dia + scope.datareceipt.periodo_subsecuente;
          }

          if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
            if (dia > 30) {
              dia = dia - 30;
              mes = mes + 1;
              if (mes > 12) {
                mes = mes - 12;
                anio = anio + 1;
              }
            }
          } else if (mes == 2) {
            if (dia > 28) {
              dia = dia - 28;
              mes = mes + 1;
            }
          } else {
            if (dia > 31) {
              dia = dia - 31;
              mes = mes + 1;
              if (mes > 12) {
                mes = mes - 12;
                anio = anio + 1;
              }
            }
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          return dia + "/" + mes + "/" + anio;
        };

        // Recalcula un recibo
        scope.recalcularRecibo = function (index) {
          if (
            scope.todos_prima[index] ==
            scope.datareceipt.receipts[index].prima_neta
          ) {
            scope.datareceipt.receipts[index].rpf =
              scope.datareceipt.receipts[index].rpf;
          } else {
            scope.todos_prima[index] =
              scope.datareceipt.receipts[index].prima_neta;
            scope.datareceipt.receipts[index].rpf =
              scope.datareceipt.receipts[index].prima_neta *
              ((valor_rpf * 100) / scope.datareceipt.primaNeta / 100);
          }

          if (scope.datareceipt.receipts[index].derecho == null) {
            scope.datareceipt.receipts[index].derecho = 0;
          }

          scope.datareceipt.receipts[index].sub_total =
            scope.datareceipt.receipts[index].prima_neta +
            scope.datareceipt.receipts[index].rpf +
            scope.datareceipt.receipts[index].derecho;

          if (
            scope.todos_subtotal[index] ==
            scope.datareceipt.receipts[index].sub_total
          ) {
            scope.datareceipt.receipts[index].iva =
              scope.datareceipt.receipts[index].iva;
          } else {
            scope.todos_subtotal[index] =
              scope.datareceipt.receipts[index].sub_total;
            scope.datareceipt.receipts[index].iva =
              scope.datareceipt.receipts[index].sub_total *
              ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
          }
          scope.datareceipt.receipts[index].prima_total = parseFloat(
            scope.datareceipt.receipts[index].sub_total +
              scope.datareceipt.receipts[index].iva
          );

          var comision_prima =
            scope.datareceipt.receipts[index].prima_neta *
            (scope.datareceipt.prima_comision / 100);
          var comision_rpf =
            scope.datareceipt.receipts[index].rpf *
            (scope.datareceipt.rpf_comision / 100);
          var comision_derecho =
            scope.datareceipt.receipts[index].derecho *
            (scope.datareceipt.derecho_comision / 100);

          scope.datareceipt.receipts[index].comision =
            comision_prima + comision_rpf + comision_derecho;

          scope.datareceipt.receipts[index].prima_neta = parseFloat(
            scope.datareceipt.receipts[index].prima_neta.toFixed(2)
          );
          scope.datareceipt.receipts[index].rpf = parseFloat(
            scope.datareceipt.receipts[index].rpf.toFixed(2)
          );
          scope.datareceipt.receipts[index].derecho = parseFloat(
            scope.datareceipt.receipts[index].derecho.toFixed(2)
          );
          scope.datareceipt.receipts[index].sub_total = parseFloat(
            scope.datareceipt.receipts[index].sub_total.toFixed(2)
          );
          scope.datareceipt.receipts[index].iva = parseFloat(
            scope.datareceipt.receipts[index].iva.toFixed(2)
          );
          scope.datareceipt.receipts[index].prima_total = parseFloat(
            scope.datareceipt.receipts[index].prima_total.toFixed(2)
          );
          scope.datareceipt.receipts[index].comision = parseFloat(
            scope.datareceipt.receipts[index].comision.toFixed(2)
          );
        };

        scope.recalcularTotal = function (index) {
          scope.datareceipt.receipts[index].prima_total = parseFloat(
            scope.datareceipt.receipts[index].prima_total.toFixed(2)
          );
        };

        // Racalcula la comision de un recibo
        scope.recalcularComision = function (index) {
          scope.datareceipt.receipts[index].comision = parseFloat(
            scope.datareceipt.receipts[index].comision.toFixed(2)
          );
          scope.datareceipt.comision = 0;
          scope.datareceipt.receipts.forEach(function (receipt) {
            scope.datareceipt.comision =
              scope.datareceipt.comision + parseFloat(receipt.comision);
          });

          scope.datareceipt.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );

          scope.calcularComision();
        };

        // Muestra la edición de los recibos
        scope.editarRecibos = function () {
          scope.editar_recibos = true;
        };

        scope.validarFechaInicio = function (receipt, index) {
          if (index > 0) {
            scope.datareceipt.receipts[index - 1].endingDate =
              receipt.startDate;
          }
        };

        scope.validarFechaFin = function (receipt, index) {
          if (scope.datareceipt.receipts.length - 1 > index) {
            scope.datareceipt.receipts[index + 1].startDate =
              receipt.endingDate;
          }
        };

        // Revisa que las fechas de los recibos no se salgan de la vigencia de la póliza
        scope.guardarRecibos = function () {
          var fechas_vacias = false;

          if (scope.type == 2) {
            scope.datareceipt.receipts.forEach(function (item, index) {
              if (!item.startDate || !item.endingDate || !item.vencimiento) {
                SweetAlert.swal(
                  "Error",
                  "No se pueden quedar fechas vacías, revisa que los recibos tengan todas las fechas.",
                  "error"
                );
                fechas_vacias = true;
                return;
              } else {
                if (
                  process(item.startDate) <
                    process(scope.datareceipt.startDate) ||
                  process(item.startDate) >
                    process(scope.datareceipt.endingDate) ||
                  process(item.endingDate) <
                    process(scope.datareceipt.startDate) ||
                  process(item.endingDate) >
                    process(scope.datareceipt.endingDate)
                ) {
                  //if(scope.type == 1){
                  //SweetAlert.swal('Error', 'Las fechas del recibo ' + (index+1) + ' se sale de la vigencia de la fianza.', 'error');
                  //}else{
                  //SweetAlert.swal('Error', 'Las fechas del recibo ' + (index+1) + ' se sale de la vigencia del endoso.', 'error');
                  //}
                  //fechas_vacias = true;
                  //return;
                } else {
                  // if(process(item.vencimiento) < process(item.startDate)){
                  //   SweetAlert.swal('Error', 'La fecha de vencimiento del recibo ' + (index+1) + ' no puede ser menor a la de su inicio.', 'error');
                  //   fechas_vacias = true;
                  //   return;
                  // }
                }
              }
            });
          }

          function process(date) {
            var parts = date.split("/");
            var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
            return date.getTime();
          }

          if (scope.type == 2) {
            var total_prima = 0;
            var total_rpf = 0;
            var total_derecho = 0;
            var total_iva = 0;
            var total_total = 0;

            for (var i = 0; i < scope.datareceipt.receipts.length; i++) {
              total_prima =
                total_prima + scope.datareceipt.receipts[i].prima_neta;
              total_rpf = total_rpf + scope.datareceipt.receipts[i].rpf;
              total_derecho =
                total_derecho + scope.datareceipt.receipts[i].derecho;
              total_iva = total_iva + scope.datareceipt.receipts[i].iva;
              total_total =
                total_total + scope.datareceipt.receipts[i].prima_total;
            }

            if (scope.type == 2 && scope.datareceipt.type_endorsement == "D") {
              total_prima = total_prima * -1;
              total_rpf = total_rpf * -1;
              total_derecho = total_derecho * -1;
              total_iva = total_iva * -1;
              total_total = total_total * -1;
            }

            if (
              scope.datareceipt.primaNeta + 0.99 < total_prima ||
              scope.datareceipt.primaNeta - 0.99 > total_prima
            ) {
              SweetAlert.swal(
                "Error",
                "La suma de las primas netas de todos los recibos no coincide con la prima neta de la póliza.",
                "error"
              );
              fechas_vacias = true;
              return;
            } else if (
              valor_rpf + 0.99 < total_rpf ||
              valor_rpf - 0.99 > total_rpf
            ) {
              SweetAlert.swal(
                "Error",
                "La suma de los rpf de todos los recibos no coincide con el rpf de la póliza.",
                "error"
              );
              fechas_vacias = true;
              return;
            } else if (
              scope.datareceipt.derecho + 0.99 < total_derecho ||
              scope.datareceipt.derecho - 0.99 > total_derecho
            ) {
              SweetAlert.swal(
                "Error",
                "La suma de los derechos de todos los recibos no coincide con el derecho de la póliza.",
                "error"
              );
              fechas_vacias = true;
              return;
            } else if (
              valor_iva + 0.99 < total_iva ||
              valor_iva - 0.99 > total_iva
            ) {
              SweetAlert.swal(
                "Error",
                "La suma de los iva de todos los recibos no coincide con el iva de la póliza.",
                "error"
              );
              fechas_vacias = true;
              return;
            } else if (
              scope.datareceipt.primaTotal + 0.99 < total_total ||
              scope.datareceipt.primaTotal - 0.99 > total_total
            ) {
              SweetAlert.swal(
                "Error",
                "La suma de las primas totales de todos los recibos no coincide con la prima total de la póliza.",
                "error"
              );
              fechas_vacias = true;
              return;
            }
          }

          if (fechas_vacias) {
            scope.editar_recibos = true;
          } else {
            scope.editar_recibos = false;
          }
        };

        // Completa el json con la información de los recibos para enviarla a la póliza
        scope.generarToSave = function (value) {
          if (value == 1) {
            if (
              scope.datareceipt.aplicarRpf ||
              scope.datareceipt.aplicarDerecho
            ) {
              scope.todos_prima[0] == scope.datareceipt.receipts[0].prima_neta;
              scope.datareceipt.receipts[0].sub_total = parseFloat(
                scope.datareceipt.receipts[0].prima_neta +
                  scope.datareceipt.receipts[0].rpf +
                  scope.datareceipt.receipts[0].derecho
              );
              scope.todos_subtotal[0] ==
                scope.datareceipt.receipts[0].sub_total;
              scope.datareceipt.receipts[0].iva =
                scope.datareceipt.receipts[0].sub_total *
                ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
              scope.datareceipt.receipts[0].prima_total = parseFloat(
                scope.datareceipt.receipts[0].sub_total +
                  scope.datareceipt.receipts[0].iva
              );
              var comision_prima =
                scope.datareceipt.receipts[0].prima_neta *
                (scope.datareceipt.prima_comision / 100);
              var comision_rpf =
                scope.datareceipt.receipts[0].rpf *
                (scope.datareceipt.rpf_comision / 100);
              var comision_derecho =
                scope.datareceipt.receipts[0].derecho *
                (scope.datareceipt.derecho_comision / 100);
              scope.datareceipt.receipts[0].comision =
                comision_prima + comision_rpf + comision_derecho;
              if (scope.datareceipt.aplicarRpf) {
                scope.obj_rpf = scope.datareceipt.receipts[0].rpf;
              }
              scope.datareceipt.receipts[0].prima_neta = parseFloat(
                scope.datareceipt.receipts[0].prima_neta.toFixed(2)
              );
              scope.datareceipt.receipts[0].rpf = parseFloat(
                scope.datareceipt.receipts[0].rpf.toFixed(2)
              );
              scope.datareceipt.receipts[0].derecho = parseFloat(
                scope.datareceipt.receipts[0].derecho.toFixed(2)
              );
              scope.datareceipt.receipts[0].sub_total = parseFloat(
                scope.datareceipt.receipts[0].sub_total.toFixed(2)
              );
              scope.datareceipt.receipts[0].iva = parseFloat(
                scope.datareceipt.receipts[0].iva.toFixed(2)
              );
              scope.datareceipt.receipts[0].prima_total = parseFloat(
                scope.datareceipt.receipts[0].prima_total.toFixed(2)
              );
              scope.datareceipt.receipts[0].comision = parseFloat(
                scope.datareceipt.receipts[0].comision.toFixed(2)
              );
            }
          } else {
            scope.obj_rpf = null;
          }
          scope.tosave.p_neta = parseFloat(valor_primaNeta.toFixed(2));
          scope.tosave.rpf = parseFloat(valor_rpf.toFixed(2));
          scope.tosave.derecho = parseFloat(valor_derecho.toFixed(2));
          scope.tosave.sub_total = parseFloat(
            scope.datareceipt.subTotal.toFixed(2)
          );
          scope.tosave.iva = parseFloat(valor_iva.toFixed(2));
          scope.tosave.p_total = parseFloat(
            scope.datareceipt.primaTotal.toFixed(2)
          );
          scope.tosave.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );
          scope.tosave.comision_percent = scope.comisionPorcentaje;
          scope.tosave.poliza = {
            primaNeta: parseFloat(scope.datareceipt.primaNeta.toFixed(2)),
            rpf: parseFloat(valor_rpf.toFixed(2)),
            derecho: parseFloat(scope.datareceipt.derecho.toFixed(2)),
            iva: parseFloat(valor_iva.toFixed(2)),
            subTotal: parseFloat(scope.datareceipt.subTotal.toFixed(2)),
            primaTotal: parseFloat(scope.datareceipt.primaTotal.toFixed(2)),
          };
          scope.tosave.recibos_poliza = scope.datareceipt.receipts;
        };

        if (scope.tosave) {
          if (scope.tosave.receipts) {
            scope.datareceipt = scope.tosave.poliza;
            scope.datareceipt.receipts = scope.tosave.receipts;

            valor_iva = scope.datareceipt.iva;

            scope.editar = true;

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;
          }
        }
      },
    };
  },
]);

var app = angular.module("inspinia").directive("receiptsColectivo", [
  "MESSAGES",
  "SweetAlert",
  "$location",
  "$sessionStorage",
  function (MESSAGES, SweetAlert, $location, $sessionStorage) {
    return {
      restrict: "EA",
      scope: {
        form: "=",
        tosave: "=",
        type: "=",
      },
      templateUrl: "app/directivas/calculateReceipts/receiptsColectivo.html",
      link: function (scope, element, $watch, attrs) {
        // Variables
        scope.comision_seleccion = "";
        scope.accesos = $sessionStorage.permisos;
        if (scope.accesos) {
          scope.accesos.forEach(function (perm) {
            if (perm.model_name == "Comisiones") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Comisiones") {
                  if (acc.checked == true) {
                    scope.permiso_comisiones = true;
                  } else {
                    scope.permiso_comisiones = false;
                  }
                }
              });
            }
            if (perm.model_name == "Cobranza") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Eliminar recibos") {
                  if (acc.checked == true) {
                    scope.permiso_delRecibo = true;
                  } else {
                    scope.permiso_delRecibo = false;
                  }
                }
              });
            }

            if (perm.model_name == "Pólizas") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Comisión no obligatoria") {
                  if (acc.checked == true) {
                    scope.permiso_comision_no_obligatoria = true;
                  } else {
                    scope.permiso_comision_no_obligatoria = false;
                  }
                }
              });
            }
          });
        }
        scope.datareceipt = {
          primaNeta: 0,
          descuento: null,
          rpf: 0,
          derecho: 0,
          subTotal: 0,
          iva: null,
          primaTotal: 0,
          comision: 0,
          aplicarDescuento: false,
          comision_percent: 0,
          comision_derecho_percent: 0,
          comision_rpf_percent: 0,
        };

        scope.option_descuento = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_descuento = scope.option_descuento[0];

        scope.option_rpf = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_rpf = scope.option_rpf[0];

        scope.option_iva = [
          { name: "$", value: 1 },
          { name: "%", value: 2 },
        ];
        scope.tipo_iva = scope.option_iva[0];

        var agregar_comision = 0;
        var valor_primaNeta;
        var valor_descuento;
        var valor_rpf;
        var valor_derecho;
        var valor_iva;
        var valor_prima_descuento;
        var valor_comision;
        var valor_suma_comision;

        var copy_primaNeta = 0;
        var copy_rpf = 0;
        var copy_subTotal = 0;

        scope.newPrima = {};
        scope.todos_prima = [0];
        scope.todos_subtotal = [0];

        scope.mostrarPrimerRecibo = false;
        scope.mostrarTodosRecibo = false;
        scope.editar_recibos = false;

        scope.editar = false;
        scope.recalcular = true;

        scope.obj_rpf = null;

        scope.sobrePrimas = [
          { value: 1, name: "Prima Neta Pagada" },
          { value: 2, name: "Prima Neta Pactada" },
        ];

        scope.arreglo_escalones = [{ porcentaje: null, comision: 0 }];
        scope.suma_porcentaje = 0;
        scope.noteColor = { color: "#ff0000" };

        scope.verComisiones = function () {
          var sin_comision = {
            comission: "0",
            comission_derecho: "0",
            comission_rpf: "0",
            derecho: "0",
            efective_date: "-",
            expire_date: null,
            nombre: "Sin Comisión",
            observations: "-",
            others: "0",
            others_derecho: "0",
            others_rpf: "0",
            periodo_inicial: 0,
            periodo_subsecuente: 0,
            ramo: "-",
            rpf_mensual: "0",
            rpf_bimestral: "0",
            rpf_trimestral: "0",
            rpf_semestral: "0",
            rpf_anual: "0",
            subramo: "-",
            udi: "0",
            udi_derecho: "0",
            udi_rpf: "0",
          };
          if (scope.form.comisiones && scope.form.comisiones.length > 0) {
            scope.form.comisiones.forEach(function (item) {
              if (
                item.nombre == "Sin Comisión" &&
                item.efective_date == "-" &&
                item.observations == "-"
              ) {
                agregar_comision++;
              }
            });
            if (scope.form.subramo && agregar_comision == 0) {
              scope.form.comisiones.push(sin_comision);
              agregar_comision++;
            }
          } else {
            if (scope.form.subramo && agregar_comision == 0) {
              scope.form.comisiones = [];
              scope.form.comisiones.push(sin_comision);
              agregar_comision++;
            } else {
              if (scope.form.comisiones.length == 0) {
                scope.form.comisiones.push(sin_comision);
              }
            }
          }
          if (scope.form) {
            if (scope.form.comision_seleccion) {
              scope.comision_seleccion = scope.form.comision_seleccion;
            }
            if (scope.form.primaNeta) {
              scope.datareceipt.primaNeta = scope.form.primaNeta
                ? scope.form.primaNeta
                : 0;
            }
            if (scope.form.derecho) {
              scope.datareceipt.derecho = scope.form.derecho
                ? scope.form.derecho
                : 0;
            }
            if (scope.form.rpf) {
              scope.datareceipt.rpf = scope.form.rpf ? scope.form.rpf : 0;
            }
          }
        };

        // Asignar valores segun comision seleccionada
        scope.asignarValores = function (comission) {
          if (scope.form && scope.form.primaNeta) {
            if (scope.form.comision_seleccion) {
              scope.comision_seleccion = scope.form.comision_seleccion;
            }
            if (scope.form.primaNeta) {
              scope.datareceipt.primaNeta = scope.form.primaNeta
                ? scope.form.primaNeta
                : 0;
            }
            if (scope.form.primaTotal) {
              scope.datareceipt.primaTotal = scope.form.primaTotal
                ? scope.form.primaTotal
                : 0;
            }
            if (scope.form.derecho) {
              scope.datareceipt.derecho = scope.form.derecho
                ? scope.form.derecho
                : 0;
            }
            if (scope.form.rpf) {
              scope.datareceipt.rpf = scope.form.rpf ? scope.form.rpf : 0;
            }
          }
          scope.comission = comission;
          if (!scope.form.payment || scope.form.payment == "") {
            scope.comision_seleccion = "";
            SweetAlert.swal("¡Error!", MESSAGES.ERROR.SELPAY, "error");
            return;
          } else {
            if (!scope.editar) {
              try {
                scope.datareceipt.payment = scope.form.payment;
              } catch (err) {
                scope.datareceipt = {};
                scope.datareceipt["payment"] = scope.form.payment;
              }
            } else {
              scope.numeroRecibos = scope.datareceipt.numeroRecibos;
              scope.recalcular = scope.tosave.recalcular;
            }
            scope.datareceipt.subramo = scope.form.subramo.subramo_name;
            if (scope.form.derecho && scope.form.from_pdf) {
              scope.datareceipt.derecho = parseFloat(scope.form.derecho);
              scope.datareceipt.rpf = parseFloat(scope.form.rpf);
            } else {
              scope.datareceipt.derecho = parseFloat(
                comission && comission.derecho ? comission.derecho : 0
              );
              scope.datareceipt.rpf = parseFloat(
                comission && comission.rpf ? comission.rpf : 0
              );
            }
            if (scope.form.rpf && scope.form.from_pdf) {
              scope.datareceipt.rpf = parseFloat(scope.form.rpf);
            } else {
              scope.datareceipt.rpf = parseFloat(
                comission && comission.rpf ? comission.rpf : 0
              );
            }
            if (scope.form.descuento && scope.form.from_pdf) {
              scope.datareceipt.descuento = parseFloat(scope.form.descuento);
            }
            if (scope.form.iva && scope.form.from_pdf) {
              scope.datareceipt.iva = parseFloat(scope.form.iva);
            }
            if (scope.form.descuento && scope.form.from_pdf) {
              scope.datareceipt.descuento = parseFloat(scope.form.descuento);
            }
            // scope.datareceipt.derecho = parseFloat(comission.derecho);
            scope.datareceipt.prima_comision = parseFloat(comission.comission);
            scope.datareceipt.rpf_comision = parseFloat(
              comission.comission_rpf
            );
            scope.datareceipt.derecho_comision = parseFloat(
              comission.comission_derecho
            );
            scope.datareceipt.periodo_inicial = parseFloat(
              comission.periodo_inicial
            );
            scope.datareceipt.periodo_subsecuente = parseFloat(
              comission.periodo_subsecuente
            );

            scope.datareceipt.domiciliado = scope.form.domiciliado;

            scope.calcularTotales();
          }
        };

        scope.porcentageRpf = function () {
          if (!scope.editar) {
            scope.datareceipt.payment = scope.form.payment;
          } else {
            scope.datareceipt.payment = scope.form.payment.value
              ? scope.form.payment.value
              : scope.form.payment;
          }

          switch (parseFloat(scope.datareceipt.payment)) {
            case 1:
              scope.datareceipt.percent_rpf = scope.comission.rpf_mensual;
              break;
            case 2:
              scope.datareceipt.percent_rpf = scope.comission.rpf_bimestral;
              break;
            case 3:
              scope.datareceipt.percent_rpf = scope.comission.rpf_trimestral;
              break;
            case 5:
              scope.datareceipt.percent_rpf = scope.comission.rpf_anual;
              break;
            case 6:
              scope.datareceipt.percent_rpf = scope.comission.rpf_semestral;
              break;
            case 12:
              scope.datareceipt.percent_rpf = scope.comission.rpf_anual;
              break;
            default:
              scope.datareceipt.percent_rpf = 0;
              break;
          }
        };

        // Calcula pesos o porcentaje de descuento
        scope.calcularDescuento = function () {
          if (scope.tipo_descuento.value == 2) {
            if (scope.datareceipt.descuento != 0) {
              scope.descuentoPesos =
                (scope.datareceipt.primaNeta * scope.datareceipt.descuento) /
                100;
            } else {
              scope.descuentoPesos = 0;
            }
          } else {
            if (scope.datareceipt.descuento != 0) {
              scope.descuentoPorcentaje = (
                (scope.datareceipt.descuento * 100) /
                scope.datareceipt.primaNeta
              ).toFixed(2);
            } else {
              scope.descuentoPorcentaje = 0;
            }
          }
        };

        // Calcula pesos o porcentaje de rpf
        scope.calcularRpf = function () {
          if (scope.tipo_rpf.value == 2) {
            if (scope.datareceipt.rpf != 0) {
              scope.rpfPesos =
                (valor_prima_descuento * scope.datareceipt.rpf) / 100;
            } else {
              scope.rpfPesos = 0;
            }
          } else {
            if (scope.datareceipt.rpf != 0) {
              scope.rpfPorcentaje = (
                (scope.datareceipt.rpf * 100) /
                valor_prima_descuento
              ).toFixed(2);
            } else {
              scope.rpfPorcentaje = 0;
            }
          }
          if (
            scope.form.primaTotal &&
            scope.form.from_pdf &&
            parseFloat(scope.datareceipt.primaTotal) == 0.0
          ) {
            scope.datareceipt.primaTotal = scope.form.primaTotal;
            scope.datareceipt.subTotal = scope.form.subTotal;
          }
        };

        // Calcula pesos o porcentaje de iva
        scope.calcularIva = function (ivaval) {
          if (scope.tipo_iva.value == 2) {
            if (scope.datareceipt.iva != 0) {
              scope.ivaPesos =
                (scope.datareceipt.subTotal * scope.datareceipt.iva) / 100;
            } else {
              scope.ivaPesos = 0;
            }
          } else {
            if (scope.datareceipt.iva != 0) {
              scope.ivaPorcentaje = (
                (scope.datareceipt.iva * 100) /
                scope.datareceipt.subTotal
              ).toFixed(2);
            } else {
              scope.ivaPorcentaje = 0;
            }
          }
          // if(scope.datareceipt.iva !=scope.form.iva && scope.form.from_pdf){
          // if((scope.datareceipt.iva !=scope.form.iva && scope.form.from_pdf) && parseFloat(scope.datareceipt.iva?scope.datareceipt.iva:0).toFixed(0)==0.00){
          //   scope.datareceipt.iva = parseFloat((scope.form.iva).toFixed(2));
          //   scope.calcularTotales();
          // }

          if (ivaval == 0) {
            scope.datareceipt.iva = parseFloat(ivaval.toFixed(2));
            valor_iva = ivaval;
            scope.ivaPorcentaje = 0;
            scope.ivaPesos = 0;
          }
          if (
            (scope.datareceipt.iva != scope.form.iva &&
              scope.form.from_pdf &&
              (!ivaval || ivaval == undefined)) ||
            parseFloat(
              scope.datareceipt.iva ? scope.datareceipt.iva : 0
            ).toFixed(0) == 0.0
          ) {
            // scope.datareceipt.iva = parseFloat((scope.form.iva).toFixed(2));
            var ivaRaw = scope.form && scope.form.iva;
            var ivaNum = parseFloat(ivaRaw);
            scope.datareceipt.iva = isNaN(ivaNum) ? 0 : +ivaNum.toFixed(2);
            // scope.calcularTotales();
          }
          if (scope.datareceipt.primaNeta == 0) {
            scope.datareceipt.primaTotal = 0;
          }
        };

        // Calcula totales de las primas
        scope.calcularTotales = function (tipodesc, ivaval) {
          if (tipodesc) {
            scope.tipo_descuento = tipodesc;
          }
          if (
            !scope.datareceipt.primaNeta ||
            scope.datareceipt.primaNeta == undefined
          ) {
            valor_primaNeta = 0;
          } else {
            valor_primaNeta = parseFloat(scope.datareceipt.primaNeta);
          }

          if (
            !scope.datareceipt.descuento ||
            scope.datareceipt.descuento == undefined
          ) {
            valor_descuento = 0;
          } else {
            if (scope.datareceipt.aplicarDescuento) {
              if (scope.tipo_descuento.value == 2) {
                if (scope.datareceipt.descuento > 100) {
                  SweetAlert.swal(
                    "Error",
                    "El descuento no puede ser mayor a 100%.",
                    "error"
                  );
                  scope.datareceipt.descuento = 0;
                  valor_descuento = 0;
                } else {
                  valor_descuento =
                    (scope.datareceipt.primaNeta *
                      scope.datareceipt.descuento) /
                    100;
                }
              } else {
                valor_descuento = scope.datareceipt.descuento;
              }
            } else {
              valor_descuento = scope.datareceipt.descuento
                ? scope.datareceipt.descuento
                : 0;
            }
          }
          scope.calcularDescuento();

          valor_prima_descuento = valor_primaNeta - valor_descuento;
          scope.porcentageRpf();
          if (copy_primaNeta != scope.datareceipt.primaNeta) {
            if (scope.form.rpf && scope.form.from_pdf) {
              scope.datareceipt.rpf = parseFloat(scope.form.rpf);
            } else {
              scope.datareceipt.rpf = parseFloat(
                (
                  valor_prima_descuento *
                  (parseFloat(scope.datareceipt.percent_rpf) / 100)
                ).toFixed(2)
              );
            }
            copy_rpf = angular.copy(scope.datareceipt.rpf);
          } else {
            if (
              scope.datareceipt.aplicarDescuento &&
              copy_rpf == scope.datareceipt.rpf
            ) {
              if (scope.form.rpf && scope.form.from_pdf) {
                scope.datareceipt.rpf = parseFloat(scope.form.rpf);
              } else {
                scope.datareceipt.rpf = parseFloat(
                  (
                    valor_prima_descuento *
                    (parseFloat(scope.datareceipt.percent_rpf) / 100)
                  ).toFixed(2)
                );
              }
              copy_rpf = angular.copy(scope.datareceipt.rpf);
            }
          }
          // if(copy_primaNeta != scope.datareceipt.primaNeta){
          //   scope.datareceipt.rpf = parseFloat((valor_prima_descuento * (parseFloat(scope.datareceipt.percent_rpf) / 100)).toFixed(2));
          //   copy_rpf = angular.copy(scope.datareceipt.rpf)
          // }else{
          //   if(scope.datareceipt.aplicarDescuento && copy_rpf == scope.datareceipt.rpf){
          //     scope.datareceipt.rpf = parseFloat((valor_prima_descuento * (parseFloat(scope.datareceipt.percent_rpf) / 100)).toFixed(2));
          //     copy_rpf = angular.copy(scope.datareceipt.rpf)
          //   }
          // }

          if (!scope.datareceipt.rpf || scope.datareceipt.rpf == undefined) {
            copy_primaNeta = angular.copy(scope.datareceipt.primaNeta);
            valor_rpf = 0;
          } else {
            if (scope.tipo_rpf.value == 2) {
              if (scope.datareceipt.rpf > 100) {
                SweetAlert.swal(
                  "Error",
                  "El recargo por pago fraccionado no puede ser mayor a 100%.",
                  "error"
                );
                scope.datareceipt.rpf = 0;
                valor_rpf = 0;
              } else {
                valor_rpf =
                  (valor_prima_descuento * scope.datareceipt.rpf) / 100;
              }
            } else {
              copy_primaNeta = angular.copy(scope.datareceipt.primaNeta);
              valor_rpf = scope.datareceipt.rpf;
            }
          }
          scope.calcularRpf();

          if (
            !scope.datareceipt.derecho ||
            scope.datareceipt.derecho == undefined
          ) {
            valor_derecho = 0;
          } else {
            valor_derecho = parseFloat(scope.datareceipt.derecho);
          }

          scope.datareceipt.subTotal = parseFloat(
            (valor_prima_descuento + valor_rpf + valor_derecho).toFixed(2)
          );

          if (!scope.datareceipt.iva || scope.datareceipt.iva == undefined) {
            if (
              scope.datareceipt.subramo == "Vida" ||
              scope.form.subramo == "Vida" ||
              scope.datareceipt.subramo == "Funerarios" ||
              scope.form.subramo == "Funerarios"
            ) {
              copy_subTotal = angular.copy(scope.datareceipt.subTotal);
              scope.datareceipt.iva = 0;
              valor_iva = 0;
            } else {
              // console.log('sssss',scope.datareceipt.iva,tipodesc,ivaval)
              if (ivaval == 0) {
                scope.datareceipt.iva = parseFloat(ivaval.toFixed(2));
                valor_iva = ivaval;
              } else {
                scope.datareceipt.iva = parseFloat(
                  (scope.datareceipt.subTotal * 0.16).toFixed(2)
                );
                valor_iva = scope.datareceipt.iva;
              }
            }
          } else {
            if (scope.tipo_iva.value == 2) {
              if (scope.datareceipt.iva > 100) {
                SweetAlert.swal(
                  "Error",
                  "El iva no puede ser mayor a 100%.",
                  "error"
                );
                scope.datareceipt.iva = 0;
                valor_iva = 0;
              } else {
                valor_iva =
                  (scope.datareceipt.subTotal * scope.datareceipt.iva) / 100;
              }
            } else {
              if (copy_subTotal == scope.datareceipt.subTotal) {
                valor_iva = scope.datareceipt.iva;
              } else {
                copy_subTotal = angular.copy(scope.datareceipt.subTotal);
                scope.datareceipt.iva = parseFloat(
                  (scope.datareceipt.subTotal * 0.16).toFixed(2)
                );
                valor_iva = scope.datareceipt.iva;
              }
            }
          }
          scope.calcularIva(ivaval);

          scope.datareceipt.primaTotal = parseFloat(
            (scope.datareceipt.subTotal + valor_iva).toFixed(2)
          );
          if (
            scope.datareceipt.prima_comision <= 0 ||
            scope.datareceipt.prima_comision > 100 ||
            scope.datareceipt.prima_comision == null
          ) {
            scope.datareceipt.prima_comision = 0;
          }
          if (
            scope.datareceipt.rpf_comision <= 0 ||
            scope.datareceipt.rpf_comision > 100 ||
            scope.datareceipt.rpf_comision == null
          ) {
            scope.datareceipt.rpf_comision = 0;
          }
          if (
            scope.datareceipt.derecho_comision <= 0 ||
            scope.datareceipt.derecho_comision > 100 ||
            scope.datareceipt.derecho_comision == null
          ) {
            scope.datareceipt.derecho_comision = 0;
          }

          scope.valor_prima_comision =
            valor_prima_descuento * (scope.datareceipt.prima_comision / 100);
          scope.valor_rpf_comision =
            valor_rpf * (scope.datareceipt.rpf_comision / 100);
          scope.valor_derecho_comision =
            valor_derecho * (scope.datareceipt.derecho_comision / 100);

          valor_suma_comision = 0;
          scope.datareceipt.comision = 0;
          if (scope.valor_prima_comision != 0) {
            scope.datareceipt.comision = parseFloat(scope.valor_prima_comision);
            valor_suma_comision = valor_prima_descuento;
          }
          if (scope.valor_rpf_comision != 0) {
            scope.datareceipt.comision =
              scope.datareceipt.comision + parseFloat(scope.valor_rpf_comision);
            valor_suma_comision = valor_suma_comision + valor_rpf;
          }
          if (scope.valor_derecho_comision != 0) {
            scope.datareceipt.comision =
              scope.datareceipt.comision +
              parseFloat(scope.valor_derecho_comision);
            valor_suma_comision = valor_suma_comision + valor_derecho;
          }

          scope.datareceipt.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );

          scope.comisionPorcentaje = (
            (scope.datareceipt.comision * 100) /
            valor_suma_comision
          ).toFixed(4);

          if (scope.comisionPorcentaje == "NaN") {
            scope.comisionPorcentaje = 0;
          }

          scope.tosave.comision = scope.datareceipt.comision;
          scope.tosave.comision_percent = scope.comisionPorcentaje;
        };

        // Calcula el porcentaje de la comisión
        scope.calcularComision = function () {
          scope.comisionPorcentaje = (
            (scope.datareceipt.comision * 100) /
            scope.datareceipt.subTotal
          ).toFixed(4);
          scope.form.comision_percent = scope.comisionPorcentaje;
          scope.generarToSave();
        };

        // Calcula el primer recibo
        scope.calcularPrimerRecibo = function () {
          scope.form.canCreate = false;

          if (!scope.permiso_comision_no_obligatoria) {
            if (
              scope.datareceipt.prima_comision == 0 ||
              scope.datareceipt.prima_comision == "0" ||
              scope.datareceipt.prima_comision == ""
            ) {
              SweetAlert.swal(
                "¡Error!",
                "La comisión de prima neta es obligatoria.",
                "error"
              );
              scope.form.canCreate = false;
              scope.mostrarPrimerRecibo = false;
              return;
            }
          }

          if (!scope.comision_seleccion && scope.type == 1) {
            SweetAlert.swal(
              "¡Error!",
              "Debe elegir un valor de comisión.",
              "error"
            );
            return;
          }
          scope.datareceipt.startDate = scope.form.startDate;
          scope.datareceipt.endingDate = scope.form.endingDate;

          if (!scope.editar) {
            scope.datareceipt.payment = scope.form.payment;
          } else {
            scope.datareceipt.payment = scope.form.payment.value
              ? scope.form.payment.value
              : scope.form.payment;
          }

          scope.datareceipt.policy_days_duration =
            scope.form.policy_days_duration;

          scope.datareceipt.primaNeta = parseFloat(scope.datareceipt.primaNeta);
          scope.datareceipt.derecho = parseFloat(scope.datareceipt.derecho);
          scope.datareceipt.subTotal = parseFloat(scope.datareceipt.subTotal);
          scope.datareceipt.comision = parseFloat(scope.datareceipt.comision);

          if (scope.recalcular) {
            switch (parseFloat(scope.datareceipt.payment)) {
              case 1:
                scope.numeroRecibos = 12;
                break;
              case 2:
                scope.numeroRecibos = 6;
                break;
              case 3:
                scope.numeroRecibos = 4;
                break;
              case 5:
                scope.numeroRecibos = 1; //contado
                break;
              case 6:
                scope.numeroRecibos = 2;
                break;
              case 7:
                scope.numeroRecibos = 52;
                break;
              case 14:
                scope.numeroRecibos = 26;
                break;
              case 15:
                scope.numeroRecibos = 24;
                break;
              case 24:
                scope.numeroRecibos = 24;
                break;
              case 12:
                scope.numeroRecibos = 1; //anual
                break;
              default:
                break;
            }
            // if(scope.datareceipt.policy_days_duration < 365){
            //   scope.calcularRecibosCortos(1);
            // }else if(scope.datareceipt.policy_days_duration == 365 || scope.datareceipt.policy_days_duration == 366){
            //   scope.calcularRecibos(1);
            // }else if(scope.datareceipt.policy_days_duration > 366){
            //   scope.calcularRecibosMultianuales(1);
            // }
            if (
              scope.datareceipt.payment == 7 ||
              scope.datareceipt.payment == 14 ||
              scope.datareceipt.payment == 15
            ) {
              scope.calcularRecibosDia(1);
            } else if (scope.datareceipt.payment == 24) {
              scope.calcularRecibosQuincena(1);
            } else if (
              scope.datareceipt.payment == 1 ||
              scope.datareceipt.payment == 2 ||
              scope.datareceipt.payment == 3 ||
              scope.datareceipt.payment == 5 ||
              scope.datareceipt.payment == 6 ||
              scope.datareceipt.payment == 12
            ) {
              scope.calcularRecibosMes(1);
            }

            SweetAlert.swal(
              "¡Atención!",
              "Introduce las primas para el primer recibo, después genera los recibos subsecuentes.",
              "warning"
            );
          } else {
            SweetAlert.swal(
              "¡Error se modificaron primas!",
              "Y existen recibos pagados, las primas de la póliza se podrán guardar pero cada recibo se deberá que modificar de manera manual desde la información.",
              "error"
            );
          }
        };

        // Recalcula el primer recibo
        scope.calcularTotalPrimerRecibo = function () {
          scope.form.canCreate = false;
          if (
            scope.todos_prima[0] == scope.datareceipt.receipts[0].prima_neta
          ) {
            scope.datareceipt.receipts[0].rpf =
              scope.datareceipt.receipts[0].rpf;
          } else {
            scope.todos_prima = [];
            scope.datareceipt.receipts.forEach(function (receipt) {
              scope.todos_prima.push(receipt.prima_neta);
            });
            if (scope.obj_rpf != null) {
              scope.datareceipt.receipts[0].rpf = scope.obj_rpf;
            } else {
              scope.datareceipt.receipts[0].rpf =
                scope.datareceipt.receipts[0].prima_neta *
                ((valor_rpf * 100) / scope.datareceipt.primaNeta / 100);
            }
          }

          if (scope.datareceipt.receipts[0].derecho == null) {
            scope.datareceipt.receipts[0].derecho = 0;
          }

          scope.datareceipt.receipts[0].sub_total =
            scope.datareceipt.receipts[0].prima_neta +
            scope.datareceipt.receipts[0].rpf +
            scope.datareceipt.receipts[0].derecho;

          if (
            scope.todos_subtotal[0] == scope.datareceipt.receipts[0].sub_total
          ) {
            scope.datareceipt.receipts[0].iva =
              scope.datareceipt.receipts[0].iva;
          } else {
            scope.todos_subtotal = [];
            scope.datareceipt.receipts.forEach(function (receipt) {
              scope.todos_subtotal.push(receipt.sub_total);
            });
            scope.datareceipt.receipts[0].iva =
              scope.datareceipt.receipts[0].sub_total *
              ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
          }
          scope.datareceipt.receipts[0].prima_total =
            scope.datareceipt.receipts[0].sub_total +
            scope.datareceipt.receipts[0].iva;

          var comision_primer_recibo_prima =
            scope.datareceipt.receipts[0].prima_neta *
            (scope.datareceipt.prima_comision / 100);
          var comision_primer_recibo_rpf =
            scope.datareceipt.receipts[0].rpf *
            (scope.datareceipt.rpf_comision / 100);
          var comision_primer_recibo_derecho =
            scope.datareceipt.receipts[0].derecho *
            (scope.datareceipt.derecho_comision / 100);

          scope.datareceipt.receipts[0].comision =
            comision_primer_recibo_prima +
            comision_primer_recibo_rpf +
            comision_primer_recibo_derecho;

          scope.datareceipt.receipts[0].prima_neta = parseFloat(
            scope.datareceipt.receipts[0].prima_neta.toFixed(2)
          );
          scope.datareceipt.receipts[0].rpf = parseFloat(
            scope.datareceipt.receipts[0].rpf.toFixed(2)
          );
          scope.datareceipt.receipts[0].derecho = parseFloat(
            scope.datareceipt.receipts[0].derecho.toFixed(2)
          );
          scope.datareceipt.receipts[0].sub_total = parseFloat(
            scope.datareceipt.receipts[0].sub_total.toFixed(2)
          );
          scope.datareceipt.receipts[0].iva = parseFloat(
            scope.datareceipt.receipts[0].iva.toFixed(2)
          );
          scope.datareceipt.receipts[0].prima_total = parseFloat(
            scope.datareceipt.receipts[0].prima_total.toFixed(2)
          );
          scope.datareceipt.receipts[0].comision = parseFloat(
            scope.datareceipt.receipts[0].comision.toFixed(2)
          );
        };

        // Calcula recibos subsecuentes con cambios en primer recibo
        scope.calcularSiguientesRecibos = function () {
          scope.firstReceipt = angular.copy(scope.datareceipt.receipts[0]);

          if (
            scope.datareceipt.primaNeta >=
            scope.datareceipt.receipts[0].prima_neta
          ) {
            scope.newPrima.primaNeta =
              scope.datareceipt.primaNeta -
              scope.datareceipt.receipts[0].prima_neta;
          } else {
            SweetAlert.swal(
              "Error",
              "La prima neta del primer recibo es mayor a la prima neta de la póliza.",
              "error"
            );
            return;
          }

          if (valor_rpf >= scope.datareceipt.receipts[0].rpf) {
            scope.newPrima.rpf = valor_rpf - scope.datareceipt.receipts[0].rpf;
          } else {
            SweetAlert.swal(
              "Error",
              "El RPF del primer recibo es mayor al RPF de la póliza.",
              "error"
            );
            return;
          }

          if (
            scope.datareceipt.derecho >= scope.datareceipt.receipts[0].derecho
          ) {
            scope.newPrima.derecho =
              scope.datareceipt.derecho - scope.datareceipt.receipts[0].derecho;
          } else {
            SweetAlert.swal(
              "Error",
              "El derecho del primer recibo es mayor al derecho de la póliza.",
              "error"
            );
            return;
          }

          if (
            scope.datareceipt.subTotal >=
            scope.datareceipt.receipts[0].sub_total
          ) {
            scope.newPrima.subTotal =
              scope.datareceipt.subTotal -
              scope.datareceipt.receipts[0].sub_total;
          } else {
            scope.newPrima.subTotal = 0;
          }

          if (valor_iva >= scope.datareceipt.receipts[0].iva) {
            scope.newPrima.iva = valor_iva - scope.datareceipt.receipts[0].iva;
          } else {
            SweetAlert.swal(
              "Error",
              "El iva del primer recibo es mayor al iva de la póliza.",
              "error"
            );
            return;
          }

          if (
            scope.datareceipt.primaTotal >=
            scope.datareceipt.receipts[0].prima_total
          ) {
            scope.newPrima.primaTotal =
              scope.datareceipt.primaTotal -
              scope.datareceipt.receipts[0].prima_total;
          } else {
            SweetAlert.swal(
              "Error",
              "La prima total del primer recibo es mayor a la prima total de la póliza.",
              "error"
            );
            return;
          }

          if (
            scope.datareceipt.comision >= scope.datareceipt.receipts[0].comision
          ) {
            scope.newPrima.comision =
              scope.datareceipt.comision -
              scope.datareceipt.receipts[0].comision;
          } else {
            scope.newPrima.comision = 0;
          }

          scope.form.canCreate = true;

          if (
            scope.datareceipt.payment == 7 ||
            scope.datareceipt.payment == 14 ||
            scope.datareceipt.payment == 15
          ) {
            scope.calcularRecibosDia(2);
          } else if (scope.datareceipt.payment == 24) {
            scope.calcularRecibosQuincena(2);
          } else if (
            scope.datareceipt.payment == 1 ||
            scope.datareceipt.payment == 2 ||
            scope.datareceipt.payment == 3 ||
            scope.datareceipt.payment == 5 ||
            scope.datareceipt.payment == 6 ||
            scope.datareceipt.payment == 12
          ) {
            scope.calcularRecibosMes(2);
          }
        };

        // Valida que el porcentaje de siniestralidad no supere el 100%
        scope.validarPorcentaje = function () {
          if (scope.datareceipt.accident_rate < 0) {
            scope.datareceipt.accident_rate = 0;
          } else if (scope.datareceipt.accident_rate > 100) {
            scope.datareceipt.accident_rate = 100;
          } else {
            scope.datareceipt.accident_rate.toFixed(2);
          }
        };

        // Agregar nuevo escalon
        scope.agregarEscalon = function () {
          var data_step = {
            porcentaje: null,
            comision: 0,
          };
          scope.arreglo_escalones.push(data_step);
        };

        // Eliminar escalon
        scope.quitarEscalon = function (index) {
          scope.arreglo_escalones.splice(index, 1);
          scope.sumarPorcentajes();
        };

        // Verifica que todos los escalones sean 100%
        scope.sumarPorcentajes = function () {
          scope.suma_porcentaje = 0;
          scope.arreglo_escalones.forEach(function (item) {
            if (item.porcentaje == null) {
              item.porcentaje = 0;
            } else if (item.porcentaje < 0) {
              item.porcentaje = 0;
            } else if (item.porcentaje > 100) {
              item.porcentaje = 100;
            }
            scope.suma_porcentaje = scope.suma_porcentaje + item.porcentaje;
            if (scope.suma_porcentaje > 100) {
              SweetAlert.swal(
                "Error",
                "La sumatoria de todos los porcentajes de cada escalon no pueden superar el 100%, verifica los porcentajes.",
                "error"
              );
            }
          });
          scope.tosave.sumaPorcentaje = scope.suma_porcentaje;
        };

        // Calcula recibos por prima minima
        scope.calcularRecibosPrimaMinima = function () {
          if (!scope.comision_seleccion) {
            SweetAlert.swal(
              "¡Error!",
              "Debe elegir un valor de comisión.",
              "error"
            );
            return;
          }
          if (!scope.datareceipt.accident_rate) {
            SweetAlert.swal(
              "¡Error!",
              "Debe agregar un porcentaje de siniestralidad.",
              "error"
            );
            return;
          }
          if (scope.suma_porcentaje != 100) {
            SweetAlert.swal(
              "Error",
              "La sumatoria de todos los porcentajes de cada escalon no pueden ser diferente al 100%, verifica los porcentajes.",
              "error"
            );
            return;
          }
          scope.arreglo_escalones.forEach(function (item, index) {
            if (item.porcentaje == null || item.porcentaje <= 0) {
              scope.arreglo_escalones.splice(index, 1);
            }
          });
          scope.datareceipt.receipts = [];
          scope.datareceipt.startDate = scope.form.startDate;
          scope.datareceipt.endingDate = scope.form.endingDate;
          scope.recibos_totales = scope.arreglo_escalones.length;

          scope.arreglo_escalones.forEach(function (item, index) {
            var receipt = {
              recibo_numero: index + 1,
              prima_neta: 0,
              rpf: 0,
              derecho: 0,
              iva: 0,
              sub_total: 0,
              prima_total: 0,
              comision: 0,
              receipt_type: 1,
              delivered: false,
              fecha_inicio: scope.form.startDate,
              fecha_fin: scope.form.endingDate,
              vencimiento: scope.obtenerVencimiento(
                index,
                scope.form.startDate
              ),
            };
            receipt.prima_neta = parseFloat(
              ((scope.datareceipt.primaNeta * item.porcentaje) / 100).toFixed(2)
            );
            if (index == 0) {
              receipt.rpf = parseFloat(scope.datareceipt.rpf.toFixed(2));
              receipt.derecho = parseFloat(
                parseFloat(scope.datareceipt.derecho).toFixed(2)
              );
            } else {
              receipt.rpf = 0;
              receipt.derecho = 0;
            }
            receipt.sub_total = parseFloat(
              (
                parseFloat(receipt.prima_neta) +
                parseFloat(receipt.rpf) +
                parseFloat(receipt.derecho)
              ).toFixed(2)
            );
            receipt.iva = parseFloat(
              (
                (receipt.sub_total * parseFloat(scope.ivaPorcentaje)) /
                100
              ).toFixed(2)
            );
            receipt.prima_total = parseFloat(
              (parseFloat(receipt.sub_total) + parseFloat(receipt.iva)).toFixed(
                2
              )
            );
            receipt.comision = parseFloat(
              ((scope.datareceipt.comision * item.porcentaje) / 100).toFixed(2)
            );
            scope.datareceipt.receipts.push(angular.copy(receipt));
          });
          var receipt = {
            recibo_numero: 1,
            prima_neta: (
              scope.datareceipt.receipts[0].prima_neta -
              parseFloat(scope.datareceipt.primaNeta)
            ).toFixed(2),
            rpf: (
              scope.datareceipt.receipts[0].rpf -
              parseFloat(scope.datareceipt.rpf)
            ).toFixed(2),
            derecho: (
              scope.datareceipt.receipts[0].derecho -
              parseFloat(scope.datareceipt.derecho)
            ).toFixed(2),
            iva: (
              scope.datareceipt.receipts[0].iva -
              parseFloat(scope.datareceipt.iva)
            ).toFixed(2),
            sub_total: (
              scope.datareceipt.receipts[0].sub_total -
              parseFloat(scope.datareceipt.subTotal)
            ).toFixed(2),
            prima_total: (
              scope.datareceipt.receipts[0].prima_total -
              parseFloat(scope.datareceipt.primaTotal)
            ).toFixed(2),
            comision: (
              scope.datareceipt.receipts[0].comision -
              parseFloat(scope.datareceipt.comision)
            ).toFixed(2),
            receipt_type: 3,
            delivered: false,
            fecha_inicio: scope.form.startDate,
            fecha_fin: scope.form.endingDate,
            vencimiento: scope.obtenerVencimiento(1, scope.form.startDate),
          };
          scope.datareceipt.receipts.push(angular.copy(receipt));

          scope.mostrarPrimerRecibo = false;
          scope.mostrarTodosRecibo = true;
          scope.form.canCreate = true;
          scope.generarToSave();
        };

        // Calcula recibos semanal, catorcenal
        scope.calcularRecibosDia = function (value) {
          scope.datareceipt.receipts = [];

          var recibos_fracionados =
            (scope.datareceipt.policy_days_duration * scope.numeroRecibos) /
            365;
          var arreglo_recibos = recibos_fracionados.toString().split(".");
          var recibos_completos = parseFloat(arreglo_recibos[0]);
          var recibos_incompletos = "0." + arreglo_recibos[1];
          recibos_incompletos = parseFloat(recibos_incompletos);

          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          var date1 = new Date(mes + "/" + dia + "/" + (anio - 1));
          var date2 = new Date(mes + "/" + dia + "/" + anio);
          var timeDiff = Math.abs(date2.getTime() - date1.getTime());
          scope.duration = Math.ceil(timeDiff / (1000 * 3600 * 24));

          var dias_bisiesto =
            scope.datareceipt.policy_days_duration % scope.duration;
          var diferencia = Math.abs(date2.getTime() - date1.getTime());

          if (
            (scope.datareceipt.policy_days_duration - dias_bisiesto) %
              scope.duration ==
              0 &&
            diferencia == 366
          ) {
            recibos_incompletos = recibos_incompletos + 1;
            recibos_completos = recibos_completos - 1;
          }

          if (recibos_incompletos == 0) {
            recibos_incompletos = 1;
            recibos_completos = recibos_completos - 1;
          }

          scope.recibos_totales = 0;
          if (recibos_completos <= recibos_fracionados) {
            scope.recibos_totales = recibos_completos + 1;
          }

          if (recibos_incompletos < 0.08) {
            recibos_fracionados = angular.copy(recibos_completos);
            recibos_incompletos = 1;
            recibos_completos = recibos_completos - 1;
          }

          if (value == 1) {
            scope.obj = {
              prima_neta:
                (recibos_incompletos * scope.datareceipt.primaNeta) /
                recibos_fracionados,
              rpf:
                (valor_rpf ? recibos_incompletos * valor_rpf : 0) /
                recibos_fracionados,
              derecho:
                (scope.datareceipt.derecho
                  ? recibos_incompletos * scope.datareceipt.derecho
                  : 0) / recibos_fracionados,
              subTotal:
                (recibos_incompletos * scope.datareceipt.subTotal) /
                recibos_fracionados,
              iva:
                (valor_iva ? recibos_incompletos * valor_iva : 0) /
                recibos_fracionados,
              primaTotal:
                (scope.datareceipt.primaTotal
                  ? recibos_incompletos * scope.datareceipt.primaTotal
                  : 0) / recibos_fracionados,
              comision:
                (scope.datareceipt.comision
                  ? recibos_incompletos * scope.datareceipt.comision
                  : 0) / recibos_fracionados,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (recibos_incompletos * valor_prima_descuento) /
                recibos_fracionados;
            }
            scope.mostrarPrimerRecibo = true;
            scope.mostrarTodosRecibo = false;
          } else {
            scope.obj = {
              prima_neta: scope.newPrima.primaNeta / recibos_completos,
              rpf:
                (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                recibos_completos,
              derecho:
                (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                recibos_completos,
              subTotal: scope.newPrima.subTotal / recibos_completos,
              iva:
                (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                recibos_completos,
              primaTotal:
                (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                recibos_completos,
              comision:
                (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                recibos_completos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (scope.newPrima.primaNeta - valor_descuento) /
                recibos_completos;
            }

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;
            scope.form.canCreate = true;
          }

          scope.dias_resta = scope.recibos_totales * scope.datareceipt.payment;
          scope.dias_resta_fin =
            scope.recibos_totales * scope.datareceipt.payment -
            scope.datareceipt.payment;

          for (var i = 0; i < scope.recibos_totales; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                // if(scope.datareceipt.rpf){
                //   scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                // }else{
                //   scope.obj.rpf = 0;
                // }
                if (scope.tipo_rpf.value == 2) {
                  if (scope.datareceipt.rpf != 0) {
                    scope.rpfPesos =
                      (valor_prima_descuento * scope.datareceipt.rpf) / 100;
                    scope.obj.rpf = parseFloat(scope.rpfPesos);
                  } else {
                    scope.obj.rpf = 0;
                  }
                } else {
                  if (scope.datareceipt.rpf != 0) {
                    scope.rpfPorcentaje = (
                      (scope.datareceipt.rpf * 100) /
                      valor_prima_descuento
                    ).toFixed(2);
                    scope.obj.rpf = parseFloat(scope.rpfPorcentaje);
                  } else {
                    scope.obj.rpf = 0;
                  }
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            var receipt = {
              recibo_numero: i + 1,
              prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
              rpf: parseFloat(scope.obj.rpf.toFixed(2)),
              derecho: parseFloat(scope.obj.derecho.toFixed(2)),
              iva: parseFloat(scope.obj.iva.toFixed(2)),
              sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
              prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
              comision: parseFloat(scope.obj.comision.toFixed(2)),
              receipt_type: 1,
              delivered: false,
              fecha_inicio: scope.obtenerVigenciaInicialDia(
                i,
                scope.dias_resta
              ),
              fecha_fin: scope.obtenerVigenciaFinalDia(scope.dias_resta_fin),
            };

            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.fecha_inicio
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));

            scope.dias_resta = scope.dias_resta - scope.datareceipt.payment;
            scope.dias_resta_fin =
              scope.dias_resta_fin - scope.datareceipt.payment;
          }

          if (
            (value == 2 && scope.type == 1) ||
            (value == 2 && scope.type == 2)
          ) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }

          scope.generarToSave(value);
        };

        // Calcula recibos quincenal
        scope.calcularRecibosQuincena = function (value) {
          console.log(scope.datareceipt);
          scope.datareceipt.receipts = [];

          if (scope.type == 1) {
            scope.numeroRecibosNuevos = scope.numeroRecibos - 1;
          } else {
            scope.numeroRecibosNuevos = scope.numeroRecibos;
          }
          if (scope.numeroRecibosNuevos < 1) {
            scope.numeroRecibosNuevos = 1;
          }

          if (value == 1) {
            scope.obj = {
              prima_neta: scope.datareceipt.primaNeta / scope.numeroRecibos,
              rpf: (valor_rpf ? valor_rpf : 0) / scope.numeroRecibos,
              derecho:
                (scope.datareceipt.derecho ? scope.datareceipt.derecho : 0) /
                scope.numeroRecibos,
              subTotal: scope.datareceipt.subTotal / scope.numeroRecibos,
              iva: (valor_iva ? valor_iva : 0) / scope.numeroRecibos,
              primaTotal:
                (scope.datareceipt.primaTotal
                  ? scope.datareceipt.primaTotal
                  : 0) / scope.numeroRecibos,
              comision:
                (scope.datareceipt.comision ? scope.datareceipt.comision : 0) /
                scope.numeroRecibos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                valor_prima_descuento / scope.numeroRecibos;
            }

            scope.mostrarPrimerRecibo = true;
            scope.mostrarTodosRecibo = false;
          } else {
            scope.obj = {
              prima_neta: scope.newPrima.primaNeta / scope.numeroRecibosNuevos,
              rpf:
                (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                scope.numeroRecibosNuevos,
              derecho:
                (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                scope.numeroRecibosNuevos,
              subTotal: scope.newPrima.subTotal / scope.numeroRecibosNuevos,
              iva:
                (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                scope.numeroRecibosNuevos,
              primaTotal:
                (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                scope.numeroRecibosNuevos,
              comision:
                (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                scope.numeroRecibosNuevos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (scope.newPrima.primaNeta - valor_descuento) /
                scope.numeroRecibosNuevos;
            }

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;
            scope.form.canCreate = true;
          }

          for (var i = 0; i < scope.numeroRecibos; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                if (scope.datareceipt.rpf) {
                  scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                } else {
                  scope.obj.rpf = 0;
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            var receipt = {
              recibo_numero: i + 1,
              prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
              rpf: parseFloat(scope.obj.rpf.toFixed(2)),
              derecho: parseFloat(scope.obj.derecho.toFixed(2)),
              iva: parseFloat(scope.obj.iva.toFixed(2)),
              sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
              prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
              comision: parseFloat(scope.obj.comision.toFixed(2)),
              receipt_type: 1,
              delivered: false,
              fecha_inicio: scope.obtenerVigenciaInicial(i),
              fecha_fin: scope.obtenerVigenciaFinal(i),
            };

            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.fecha_inicio
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));
          }

          if (value == 2 && scope.type == 1) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }
          scope.generarToSave(value);
        };

        // Calcula recibos mensual, bimestral, trimestral, semestral, anual, contado
        scope.calcularRecibosMes = function (value) {
          scope.datareceipt.receipts = [];

          var recibos_fracionados =
            (scope.datareceipt.policy_days_duration * scope.numeroRecibos) /
            365;
          var arreglo_recibos = recibos_fracionados.toString().split(".");
          var recibos_completos = parseFloat(arreglo_recibos[0]);
          var recibos_incompletos = "0." + arreglo_recibos[1];
          recibos_incompletos = parseFloat(recibos_incompletos);

          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          var date1 = new Date(mes + "/" + dia + "/" + (anio - 1));
          var date2 = new Date(mes + "/" + dia + "/" + anio);
          var timeDiff = Math.abs(date2.getTime() - date1.getTime());
          scope.duration = Math.ceil(timeDiff / (1000 * 3600 * 24));

          var dias_bisiesto =
            scope.datareceipt.policy_days_duration % scope.duration;
          var diferencia = Math.abs(date2.getTime() - date1.getTime());

          if (
            (scope.datareceipt.policy_days_duration - dias_bisiesto) %
              scope.duration ==
              0 &&
            diferencia == 366
          ) {
            recibos_incompletos = recibos_incompletos + 1;
            recibos_completos = recibos_completos - 1;
          }

          if (recibos_incompletos == 0) {
            recibos_incompletos = 1;
            recibos_completos = recibos_completos - 1;
          }

          scope.recibos_totales = 0;
          if (
            scope.datareceipt.payment == 5 ||
            scope.datareceipt.payment == 12
          ) {
            recibos_fracionados = 1;
            recibos_completos = 1;
            recibos_incompletos = 1;
            scope.recibos_totales = 1;
          } else {
            if (recibos_incompletos < 0.08) {
              recibos_fracionados = angular.copy(recibos_completos);
              recibos_incompletos = 1;
              recibos_completos = recibos_completos - 1;
            }

            if (recibos_completos < recibos_fracionados) {
              scope.recibos_totales = recibos_completos + 1;
            } else {
              scope.recibos_totales = recibos_completos;
            }
          }

          if (value == 1) {
            scope.obj = {
              prima_neta:
                (recibos_incompletos * scope.datareceipt.primaNeta) /
                recibos_fracionados,
              rpf:
                (valor_rpf ? recibos_incompletos * valor_rpf : 0) /
                recibos_fracionados,
              derecho:
                (scope.datareceipt.derecho
                  ? recibos_incompletos * scope.datareceipt.derecho
                  : 0) / recibos_fracionados,
              subTotal:
                (recibos_incompletos * scope.datareceipt.subTotal) /
                recibos_fracionados,
              iva:
                (valor_iva ? recibos_incompletos * valor_iva : 0) /
                recibos_fracionados,
              primaTotal:
                (scope.datareceipt.primaTotal
                  ? recibos_incompletos * scope.datareceipt.primaTotal
                  : 0) / recibos_fracionados,
              comision:
                (scope.datareceipt.comision
                  ? recibos_incompletos * scope.datareceipt.comision
                  : 0) / recibos_fracionados,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (recibos_incompletos * valor_prima_descuento) /
                recibos_fracionados;
            }

            scope.mostrarPrimerRecibo = true;
            scope.mostrarTodosRecibo = false;
          } else {
            scope.obj = {
              prima_neta: scope.newPrima.primaNeta / recibos_completos,
              rpf:
                (scope.newPrima.rpf ? scope.newPrima.rpf : 0) /
                recibos_completos,
              derecho:
                (scope.newPrima.derecho ? scope.newPrima.derecho : 0) /
                recibos_completos,
              subTotal: scope.newPrima.subTotal / recibos_completos,
              iva:
                (scope.newPrima.iva ? scope.newPrima.iva : 0) /
                recibos_completos,
              primaTotal:
                (scope.newPrima.primaTotal ? scope.newPrima.primaTotal : 0) /
                recibos_completos,
              comision:
                (scope.newPrima.comision ? scope.newPrima.comision : 0) /
                recibos_completos,
            };

            if (scope.datareceipt.aplicarDescuento) {
              scope.obj.prima_neta =
                (scope.newPrima.primaNeta - valor_descuento) /
                recibos_completos;
            }

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;
            scope.form.canCreate = true;
          }

          scope.meses_resta = scope.recibos_totales * scope.datareceipt.payment;
          scope.meses_resta_fin =
            scope.recibos_totales * scope.datareceipt.payment -
            scope.datareceipt.payment;

          for (var i = 0; i < scope.recibos_totales; i++) {
            if (scope.datareceipt.aplicarDerecho) {
              if (i === 0) {
                if (scope.datareceipt.derecho) {
                  scope.obj.derecho = parseFloat(scope.datareceipt.derecho);
                } else {
                  scope.obj.derecho = 0;
                }
              } else {
                scope.obj.derecho = 0;
              }
            }

            if (scope.datareceipt.aplicarRpf) {
              if (i === 0) {
                // if(scope.datareceipt.rpf){
                //   scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                // }else{
                //   scope.obj.rpf = 0;
                // }
                if (scope.tipo_rpf.value == 2) {
                  if (scope.datareceipt.rpf != 0) {
                    scope.rpfPesos =
                      (valor_prima_descuento * scope.datareceipt.rpf) / 100;
                    scope.obj.rpf = parseFloat(scope.rpfPesos);
                  } else {
                    scope.obj.rpf = 0;
                  }
                } else {
                  if (scope.datareceipt.rpf != 0) {
                    scope.rpfPorcentaje = (
                      (scope.datareceipt.rpf * 100) /
                      valor_prima_descuento
                    ).toFixed(2);
                    scope.obj.rpf = parseFloat(scope.datareceipt.rpf);
                  } else {
                    scope.obj.rpf = 0;
                  }
                }
              } else {
                scope.obj.rpf = 0;
              }
            }

            var receipt = {
              recibo_numero: i + 1,
              prima_neta: parseFloat(scope.obj.prima_neta.toFixed(2)),
              rpf: parseFloat(scope.obj.rpf.toFixed(2)),
              derecho: parseFloat(scope.obj.derecho.toFixed(2)),
              iva: parseFloat(scope.obj.iva.toFixed(2)),
              sub_total: parseFloat(scope.obj.subTotal.toFixed(2)),
              prima_total: parseFloat(scope.obj.primaTotal.toFixed(2)),
              comision: parseFloat(scope.obj.comision.toFixed(2)),
              receipt_type: 1,
              delivered: false,
              fecha_inicio: scope.obtenerVigenciaInicialMes(
                i,
                scope.meses_resta
              ),
              fecha_fin: scope.obtenerVigenciaFinalMes(scope.meses_resta_fin),
            };

            receipt.vencimiento = scope.obtenerVencimiento(
              i,
              receipt.fecha_inicio
            );

            scope.datareceipt.receipts.push(angular.copy(receipt));

            scope.meses_resta = scope.meses_resta - scope.datareceipt.payment;
            scope.meses_resta_fin =
              scope.meses_resta_fin - scope.datareceipt.payment;
          }

          if (
            (value == 2 && scope.type == 1) ||
            (value == 2 && scope.type == 2)
          ) {
            scope.datareceipt.receipts[0] = scope.firstReceipt;
          }

          scope.generarToSave(value);
        };

        function convertDate(inputFormat) {
          function pad(s) {
            return s < 10 ? "0" + s : s;
          }
          var d = new Date(inputFormat);
          var date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
          return date;
        }

        // Calcula las fechas de inicio semanal, catorcenal
        scope.obtenerVigenciaInicialDia = function (index, value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);
          fecha.setDate(fecha.getDate() - value);

          if (index == 0) {
            return scope.datareceipt.startDate;
          } else {
            return convertDate(fecha);
          }
        };

        // Calcula las fechas de inicio quincena
        scope.obtenerVigenciaInicialQuincena = function (index, value) {
          console.log(value);
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);
          console.log("mes", fecha.getMonth());
          fecha.setMonth(fecha.getMonth() - value);

          if (index == 0) {
            return scope.datareceipt.startDate;
          } else {
            return convertDate(fecha);
          }
        };

        // Calcula las fechas de inicio mensual, bimestral, trimestral, semestral, anual, contado
        scope.obtenerVigenciaInicialMes = function (index, value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);

          fecha.setMonth(fecha.getMonth() - value);

          if (index == 0) {
            return scope.datareceipt.startDate;
          } else {
            return convertDate(fecha);
          }
        };

        // Calcula las fechas de fin semanal, catorcenal
        scope.obtenerVigenciaFinalDia = function (value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);
          fecha.setDate(fecha.getDate() - value);

          return convertDate(fecha);
        };

        // Calcula las fechas de fin quincenal
        scope.obtenerVigenciaFinalQuincena = function (index) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);

          fecha.setDate(fecha.getDate() - value);

          return convertDate(fecha);
        };

        // Calcula las fechas de fin mensual, bimestral, trimestral, semestral, anual, contado
        scope.obtenerVigenciaFinalMes = function (value) {
          var date_initial = scope.datareceipt.endingDate.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);
          var fecha = new Date(mes + "/" + dia + "/" + anio);

          fecha.setMonth(fecha.getMonth() - value);

          return convertDate(fecha);
        };

        // Calcula las fechas de vencimiento de los recibos
        scope.obtenerVencimiento = function (index, date) {
          var date_initial = date.split("/");
          var dia = parseInt(date_initial[0]);
          var mes = parseInt(date_initial[1]);
          var anio = parseInt(date_initial[2]);

          if (index == 0) {
            dia = dia + scope.datareceipt.periodo_inicial;
          } else {
            dia = dia + scope.datareceipt.periodo_subsecuente;
          }

          if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
            if (dia > 30) {
              dia = dia - 30;
              mes = mes + 1;
              if (mes > 12) {
                mes = mes - 12;
                anio = anio + 1;
              }
            }
          } else if (mes == 2) {
            if (dia > 28) {
              dia = dia - 28;
              mes = mes + 1;
            }
          } else {
            if (dia > 31) {
              dia = dia - 31;
              mes = mes + 1;
              if (mes > 12) {
                mes = mes - 12;
                anio = anio + 1;
              }
            }
          }

          if (dia.toString().length == 1) {
            dia = "0" + dia;
          }

          if (mes.toString().length == 1) {
            mes = "0" + mes;
          }

          return dia + "/" + mes + "/" + anio;
        };

        // Recalcula un recibo
        scope.recalcularRecibo = function (index) {
          if (
            scope.todos_prima[index] ==
            scope.datareceipt.receipts[index].prima_neta
          ) {
            scope.datareceipt.receipts[index].rpf =
              scope.datareceipt.receipts[index].rpf;
          } else {
            scope.todos_prima[index] =
              scope.datareceipt.receipts[index].prima_neta;
            scope.datareceipt.receipts[index].rpf =
              scope.datareceipt.receipts[index].prima_neta *
              ((valor_rpf * 100) / scope.datareceipt.primaNeta / 100);
          }

          if (scope.datareceipt.receipts[index].derecho == null) {
            scope.datareceipt.receipts[index].derecho = 0;
          }

          scope.datareceipt.receipts[index].sub_total =
            scope.datareceipt.receipts[index].prima_neta +
            scope.datareceipt.receipts[index].rpf +
            scope.datareceipt.receipts[index].derecho;

          if (
            scope.todos_subtotal[index] ==
            scope.datareceipt.receipts[index].sub_total
          ) {
            scope.datareceipt.receipts[index].iva =
              scope.datareceipt.receipts[index].iva;
          } else {
            scope.todos_subtotal[index] =
              scope.datareceipt.receipts[index].sub_total;
            scope.datareceipt.receipts[index].iva =
              scope.datareceipt.receipts[index].sub_total *
              ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
          }
          scope.datareceipt.receipts[index].prima_total = parseFloat(
            scope.datareceipt.receipts[index].sub_total +
              scope.datareceipt.receipts[index].iva
          );

          var comision_prima =
            scope.datareceipt.receipts[index].prima_neta *
            (scope.datareceipt.prima_comision / 100);
          var comision_rpf =
            scope.datareceipt.receipts[index].rpf *
            (scope.datareceipt.rpf_comision / 100);
          var comision_derecho =
            scope.datareceipt.receipts[index].derecho *
            (scope.datareceipt.derecho_comision / 100);

          scope.datareceipt.receipts[index].comision =
            comision_prima + comision_rpf + comision_derecho;

          scope.datareceipt.receipts[index].prima_neta = parseFloat(
            scope.datareceipt.receipts[index].prima_neta.toFixed(2)
          );
          scope.datareceipt.receipts[index].rpf = parseFloat(
            scope.datareceipt.receipts[index].rpf.toFixed(2)
          );
          scope.datareceipt.receipts[index].derecho = parseFloat(
            scope.datareceipt.receipts[index].derecho.toFixed(2)
          );
          scope.datareceipt.receipts[index].sub_total = parseFloat(
            scope.datareceipt.receipts[index].sub_total.toFixed(2)
          );
          scope.datareceipt.receipts[index].iva = parseFloat(
            scope.datareceipt.receipts[index].iva.toFixed(2)
          );
          scope.datareceipt.receipts[index].prima_total = parseFloat(
            scope.datareceipt.receipts[index].prima_total.toFixed(2)
          );
          scope.datareceipt.receipts[index].comision = parseFloat(
            scope.datareceipt.receipts[index].comision.toFixed(2)
          );
        };

        scope.recalcularTotal = function (index) {
          scope.datareceipt.receipts[index].prima_total = parseFloat(
            scope.datareceipt.receipts[index].prima_total.toFixed(2)
          );
        };

        // Racalcula la comision de un recibo
        scope.recalcularComision = function (index) {
          scope.datareceipt.receipts[index].comision = parseFloat(
            scope.datareceipt.receipts[index].comision.toFixed(2)
          );
          scope.datareceipt.comision = 0;
          scope.datareceipt.receipts.forEach(function (receipt) {
            scope.datareceipt.comision =
              scope.datareceipt.comision + parseFloat(receipt.comision);
          });

          scope.datareceipt.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );

          scope.calcularComision();
        };

        // Muestra la edición de los recibos
        scope.editarRecibos = function () {
          if (!scope.comision_seleccion && scope.type == 1) {
            SweetAlert.swal(
              "¡Error!",
              "Debe elegir un valor de comisión.",
              "error"
            );
            return;
          } else {
            scope.editar_recibos = true;
          }
        };

        scope.validarFechaInicio = function (receipt, index) {
          if (index > 0) {
            scope.datareceipt.receipts[index - 1].fecha_fin =
              receipt.fecha_inicio;
          }
        };

        scope.validarFechaFin = function (receipt, index) {
          if (scope.datareceipt.receipts.length - 1 > index) {
            scope.datareceipt.receipts[index + 1].fecha_inicio =
              receipt.fecha_fin;
          }
        };

        // Revisa que las fechas de los recibos no se salgan de la vigencia de la póliza
        scope.guardarRecibos = function () {
          var fechas_vacias = false;

          scope.datareceipt.receipts.forEach(function (item, index) {
            if (!item.fecha_inicio || !item.fecha_fin || !item.vencimiento) {
              SweetAlert.swal(
                "Error",
                "No se pueden quedar fechas vacías, revisa que los recibos tengan todas las fechas.",
                "error"
              );
              fechas_vacias = true;
              return;
            } else {
              if (
                process(item.fecha_inicio) <
                  process(scope.datareceipt.startDate) ||
                process(item.fecha_inicio) >
                  process(scope.datareceipt.endingDate) ||
                process(item.fecha_fin) <
                  process(scope.datareceipt.startDate) ||
                process(item.fecha_fin) > process(scope.datareceipt.endingDate)
              ) {
                SweetAlert.swal(
                  "Error",
                  "Las fechas del recibo " +
                    (index + 1) +
                    " se sale de la vigencia de la póliza.",
                  "error"
                );
                fechas_vacias = true;
                return;
              } else {
                // if(process(item.vencimiento) < process(item.fecha_inicio)){
                //   SweetAlert.swal('Error', 'La fecha de vencimiento del recibo ' + (index+1) + ' no puede ser menor a la de su inicio.', 'error');
                //   fechas_vacias = true;
                //   return;
                // }
              }
            }
          });

          function process(date) {
            var parts = date.split("/");
            var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
            return date.getTime();
          }

          var total_prima = 0;
          var total_rpf = 0;
          var total_derecho = 0;
          var total_iva = 0;
          var total_total = 0;

          for (var i = 0; i < scope.datareceipt.receipts.length; i++) {
            total_prima =
              total_prima + scope.datareceipt.receipts[i].prima_neta;
            total_rpf = total_rpf + scope.datareceipt.receipts[i].rpf;
            total_derecho =
              total_derecho + scope.datareceipt.receipts[i].derecho;
            total_iva = total_iva + scope.datareceipt.receipts[i].iva;
            total_total =
              total_total + scope.datareceipt.receipts[i].prima_total;
          }

          if (
            scope.datareceipt.primaNeta + 0.99 < total_prima ||
            scope.datareceipt.primaNeta - 0.99 > total_prima
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de las primas netas de todos los recibos no coincide con la prima neta de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            valor_rpf + 0.99 < total_rpf ||
            valor_rpf - 0.99 > total_rpf
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de los rpf de todos los recibos no coincide con el rpf de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            scope.datareceipt.derecho + 0.99 < total_derecho ||
            scope.datareceipt.derecho - 0.99 > total_derecho
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de los derechos de todos los recibos no coincide con el derecho de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            valor_iva + 0.99 < total_iva ||
            valor_iva - 0.99 > total_iva
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de los iva de todos los recibos no coincide con el iva de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          } else if (
            scope.datareceipt.primaTotal + 0.99 < total_total ||
            scope.datareceipt.primaTotal - 0.99 > total_total
          ) {
            SweetAlert.swal(
              "Error",
              "La suma de las primas totales de todos los recibos no coincide con la prima total de la póliza.",
              "error"
            );
            fechas_vacias = true;
            return;
          }

          if (fechas_vacias) {
            scope.editar_recibos = true;
          } else {
            scope.editar_recibos = false;
          }
        };

        // Completa el json con la información de los recibos para enviarla a la póliza
        scope.generarToSave = function (value) {
          if (value == 1) {
            if (
              scope.datareceipt.aplicarRpf ||
              scope.datareceipt.aplicarDerecho
            ) {
              scope.todos_prima[0] == scope.datareceipt.receipts[0].prima_neta;
              scope.datareceipt.receipts[0].sub_total = parseFloat(
                scope.datareceipt.receipts[0].prima_neta +
                  scope.datareceipt.receipts[0].rpf +
                  scope.datareceipt.receipts[0].derecho
              );
              scope.todos_subtotal[0] ==
                scope.datareceipt.receipts[0].sub_total;
              scope.datareceipt.receipts[0].iva =
                scope.datareceipt.receipts[0].sub_total *
                ((valor_iva * 100) / scope.datareceipt.subTotal / 100);
              scope.datareceipt.receipts[0].prima_total = parseFloat(
                scope.datareceipt.receipts[0].sub_total +
                  scope.datareceipt.receipts[0].iva
              );
              if (scope.type != 2) {
                var comision_prima =
                  scope.datareceipt.receipts[0].prima_neta *
                  (scope.datareceipt.prima_comision / 100);
                var comision_rpf =
                  scope.datareceipt.receipts[0].rpf *
                  (scope.datareceipt.rpf_comision / 100);
                var comision_derecho =
                  scope.datareceipt.receipts[0].derecho *
                  (scope.datareceipt.derecho_comision / 100);
                scope.datareceipt.receipts[0].comision =
                  comision_prima + comision_rpf + comision_derecho;
              }
              if (scope.datareceipt.aplicarRpf) {
                scope.obj_rpf = scope.datareceipt.receipts[0].rpf;
              }
              scope.datareceipt.receipts[0].prima_neta = parseFloat(
                scope.datareceipt.receipts[0].prima_neta.toFixed(2)
              );
              scope.datareceipt.receipts[0].rpf = parseFloat(
                scope.datareceipt.receipts[0].rpf.toFixed(2)
              );
              scope.datareceipt.receipts[0].derecho = parseFloat(
                scope.datareceipt.receipts[0].derecho.toFixed(2)
              );
              scope.datareceipt.receipts[0].sub_total = parseFloat(
                scope.datareceipt.receipts[0].sub_total.toFixed(2)
              );
              scope.datareceipt.receipts[0].iva = parseFloat(
                scope.datareceipt.receipts[0].iva.toFixed(2)
              );
              scope.datareceipt.receipts[0].prima_total = parseFloat(
                scope.datareceipt.receipts[0].prima_total.toFixed(2)
              );
              scope.datareceipt.receipts[0].comision = parseFloat(
                scope.datareceipt.receipts[0].comision.toFixed(2)
              );
            }
          } else {
            scope.obj_rpf = null;
          }
          scope.tosave.accident_rate = scope.datareceipt.accident_rate;
          if (scope.type == 3) {
            scope.tosave.steps = scope.arreglo_escalones;
          } else {
            scope.tosave.steps = [];
          }
          scope.tosave.p_neta = parseFloat(valor_primaNeta.toFixed(2));
          scope.tosave.descuento = parseFloat(valor_descuento.toFixed(2));
          scope.tosave.rpf = parseFloat(valor_rpf.toFixed(2));
          scope.tosave.aplicarRpf = scope.datareceipt.aplicarRpf;
          scope.tosave.derecho = parseFloat(valor_derecho);
          scope.tosave.aplicarDerecho = scope.datareceipt.aplicarDerecho;
          scope.tosave.sub_total = parseFloat(
            scope.datareceipt.subTotal.toFixed(2)
          );
          scope.tosave.iva = parseFloat(valor_iva.toFixed(2));
          scope.tosave.p_total = parseFloat(
            scope.datareceipt.primaTotal.toFixed(2)
          );
          scope.tosave.comision = parseFloat(
            scope.datareceipt.comision.toFixed(2)
          );
          scope.tosave.comision_percent = scope.comisionPorcentaje;
          scope.tosave.prima_comision = scope.datareceipt.prima_comision;
          scope.tosave.poliza = {
            primaNeta: parseFloat(scope.datareceipt.primaNeta.toFixed(2)),
            descuento: parseFloat(valor_descuento.toFixed(2)),
            aplicarDescuento: scope.datareceipt.aplicarDescuento,
            rpf: parseFloat(valor_rpf.toFixed(2)),
            derecho: parseFloat(scope.datareceipt.derecho).toFixed(2),
            iva: parseFloat(valor_iva.toFixed(2)),
            subTotal: parseFloat(scope.datareceipt.subTotal.toFixed(2)),
            primaTotal: parseFloat(scope.datareceipt.primaTotal.toFixed(2)),
            comision_derecho_percent: parseFloat(
              scope.datareceipt.derecho_comision
            ),
            comision_rpf_percent: parseFloat(scope.datareceipt.rpf_comision),
          };
          scope.tosave.recibos_poliza = scope.datareceipt.receipts;
        };

        if (scope.tosave) {
          if (scope.tosave.receipts) {
            scope.datareceipt = scope.tosave.poliza;
            if (scope.type == 3) {
              scope.datareceipt.accident_rate = scope.tosave.accident_rate;
              scope.arreglo_escalones =
                scope.tosave.steps.length > 0
                  ? scope.tosave.steps
                  : [{ porcentaje: null, comision: 0 }];
              scope.sumarPorcentajes();
            }
            scope.datareceipt.receipts = scope.tosave.receipts;

            valor_iva = scope.datareceipt.iva;

            scope.editar = true;

            scope.mostrarPrimerRecibo = false;
            scope.mostrarTodosRecibo = true;
            scope.form.canCreate = true;

            if ($location.path().indexOf("convertir") != -1) {
              scope.mostrarTodosRecibo = false;
            } else {
              scope.mostrarTodosRecibo = true;
              scope.form.canCreate = true;
            }
          }
        }

        if (scope.type == 2) {
          scope.datareceipt = scope.tosave.poliza;
          valor_primaNeta = scope.tosave.poliza.primaNeta;
          valor_descuento = 0;
          valor_rpf = scope.tosave.poliza.rpf;
          valor_derecho = scope.tosave.poliza.derecho;
          valor_iva = scope.tosave.poliza.iva;

          scope.datareceipt.payment = scope.form.payment;
          scope.datareceipt.subramo = scope.form.subramo;
          scope.datareceipt.startDate = scope.form.startDate;
          scope.datareceipt.endingDate = scope.form.endingDate;
          scope.datareceipt.policy_days_duration =
            scope.form.policy_days_duration;

          scope.datareceipt.prima_comision = 0;
          scope.datareceipt.rpf_comision = 0;
          scope.datareceipt.derecho_comision = 0;
          scope.datareceipt.periodo_inicial = 0;
          scope.datareceipt.periodo_subsecuente = 0;
          scope.datareceipt.domiciliado = scope.form.domiciliado;

          switch (parseFloat(scope.datareceipt.payment)) {
            case 1:
              scope.numeroRecibos = 12;
              break;
            case 2:
              scope.numeroRecibos = 6;
              break;
            case 3:
              scope.numeroRecibos = 4;
              break;
            case 5:
              scope.numeroRecibos = 1; //contado
              break;
            case 6:
              scope.numeroRecibos = 2;
              break;
            case 12:
              scope.numeroRecibos = 1; //anual
              break;
            default:
              break;
          }
        }
      },
    };
  },
]);

var app = angular.module("inspinia").directive("endorsementReceipts", [
  "toaster",
  "MESSAGES",
  "helpers",
  "datesFactory",
  "$filter",
  "SweetAlert",
  "$location",
  "$sessionStorage",
  function (
    toaster,
    MESSAGES,
    helpers,
    datesFactory,
    $filter,
    SweetAlert,
    $location,
    $sessionStorage
  ) {
    return {
      restrict: "EA",
      scope: {
        model: "=",
        poliza: "=",
        form: "=",
        tosave: "=",
        policy: "=",
      },
      templateUrl:
        "app/directivas/calculateReceipts/endorsement.receipts.template.html",
      link: function (scope, element, $watch, attrs) {
        $(".datepicker-me input").datepicker();

        $.fn.datepicker.defaults.format = "dd/mm/yyyy";
        $.fn.datepicker.defaults.startView = 0;
        $.fn.datepicker.defaults.autoclose = true;
        $.fn.datepicker.defaults.language = "es";

        scope.endoso_date = angular.copy(scope.form);
        scope.accesos = $sessionStorage.permisos;
        if (scope.accesos) {
          scope.accesos.forEach(function (perm) {
            if (perm.model_name == "Comisiones") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Comisiones") {
                  if (acc.checked == true) {
                    scope.permiso_comisiones = true;
                  } else {
                    scope.permiso_comisiones = false;
                  }
                }
              });
            }
            if (perm.model_name == "Cobranza") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Eliminar recibos") {
                  if (acc.checked == true) {
                    scope.permiso_delRecibo = true;
                  } else {
                    scope.permiso_delRecibo = false;
                  }
                }
              });
            }
          });
        }
        // console.log('endoso_date', scope.endoso_date);
        // console.log('form', scope.form);
        if (scope.policy) {
          scope.policy_dates = {
            start: angular.copy(scope.policy.start_of_validity),
            end: angular.copy(scope.policy.end_of_validity),
          };
        } else if (scope.form) {
          scope.policy_dates = {
            start: angular.copy(scope.form.start_of_validity),
            end: angular.copy(scope.form.end_of_validity),
          };
        }

        if ($location.path().indexOf("edit") != -1) {
          scope.noRecalculateReceipts = true;
        } else {
          scope.noRecalculateReceipts = false;
        }

        scope.endoso = {};

        if (!scope.endoso) {
          scope.endoso = {};
        }

        if (scope.endoso.subTotal) {
          scope.endoso.subTotal = parseFloat(scope.endoso.subTotal).toFixed(2);
        }

        var form = angular.copy(scope.form);
        // console.log('______',form)
        if (scope.tosave.receipts) {
          scope.tosave.delete_receitps = [];
          if (scope.form.policy) {
            form.policy_starting_date = scope.form.policy.start_of_validity;
          } else if (scope.form.fianza) {
            form.policy_starting_date = scope.form.fianza.start_of_validity;
          }
          scope.endoso_date.start_of_validity = scope.form.start_of_validity;
          scope.receipts = scope.tosave.receipts;

          if (scope.receipts.length) {
            scope.receipts.forEach(function (item) {
              // console.log('item', item);
              item.startDate = datesFactory.convertDate(item.fecha_inicio);
              item.endingDate = datesFactory.convertDate(item.fecha_fin);
              item.vencimiento = datesFactory.convertDate(item.vencimiento);
              item.prima = item.prima_neta;
              item.total = item.prima_total;
            });
          }

          scope.showreceipts = true;
          if (scope.tosave.poliza) {
            scope.endoso = scope.tosave.poliza;
          }
        } else {
          scope.receipts = [];
          scope.showreceipts = false;
        }

        scope.back_up_poliza = angular.copy(scope.policy);

        // form.payment = scope.form.num_receipts;
        if (form.type == "INDIVIDUAL") {
          // if(scope.form.description.label == 'CAMBIO DE FORMA DE PAGO') {
          //   form.startDate = scope.policy.startDate;
          //   form.start_of_validity= scope.policy.start_of_validity;
          // } else {

          form.startDate = datesFactory.toDate(
            scope.endoso_date.start_of_validity
          );
          form.start_of_validity = datesFactory.toDate(
            scope.endoso_date.start_of_validity
          );
          // }

          form.endingDate = scope.policy.endingDate;
          form.end_of_validity = scope.policy.end_of_validity;
        } else {
          if (scope.policy) {
            form.startDate = scope.policy.startDate;
            form.start_of_validity = scope.policy.start_of_validity;
            form.endingDate = scope.policy.endingDate;
            form.end_of_validity = scope.policy.end_of_validity;
          } else if (scope.form) {
            form.startDate = scope.form.startDate;
            form.start_of_validity = scope.form.start_of_validity;
            form.endingDate = scope.form.endingDate;
            form.end_of_validity = scope.form.end_of_validity;
          }
        }

        if (!scope.endoso) {
          scope.endoso = {
            iva: 16,
            primaTotal: 0,
          };
        }

        var descuento_ = 0;
        var cantidad_desc = parseFloat(scope.endoso.primaNeta) * descuento_;
        scope.p_neta_desc =
          parseFloat(scope.endoso.primaNeta) - parseFloat(cantidad_desc);

        if (scope.endoso.primaNeta == 0) {
          scope.endoso.primaNeta = "";
        }

        if (scope.endoso.rpf == 0) {
          scope.endoso.rpf = "";
        }

        if (scope.endoso.derecho == 0) {
          scope.endoso.derecho = "";
        }

        scope.showIva = true;

        scope.delete_receipt = function (event, param, index) {
          if (scope.receipts.length > 1) {
            if (!scope.tosave.delete_receitps) {
              scope.tosave.delete_receitps = [];
            }
            scope.tosave.delete_receitps.push(param);
            scope.receipts.splice(index, 1);
          } else {
            SweetAlert.swal("Debe mantener por lo menos un recibo.");
          }
        };

        scope.add_receipt = function () {
          // console.log('add_receipt');
          var new_receipt = {
            recibo_numero: scope.receipts.length + 1,
            prima_neta: 0,
            prima: 0,
            rpf: 0,
            derecho: 0,
            iva: "",
            subTotal: 0,
            prima_total: "",
            total: "",
            comision: "",
            receipt_type: 2,
            fecha_inicio: "",
            vencimiento: "",
            startDate: "",
            endingDate: "",
            fecha_fin: "",
            delivered: false,
          };
          scope.receipts.push(new_receipt);
        };

        scope.editPTotal = function () {
          scope.edited_ptotal = true;
          scope.ptotal_edited = angular.copy(scope.endoso.primaTotal);
        };

        scope.calculateComision = function () {
          var prima_ = parseFloat(scope.endoso.primaNeta);
          var percent = parseFloat(form.comision_percent) / 100;
          scope.endoso.comision = (prima_ * percent).toFixed(2);
          scope.comision_desc = 0;
        };

        scope.deleteSpecialCharacters = function () {};

        scope.recalc_receipt = function (parReceipt, receipt_index) {
          // console.log('policy', scope.policy);

          var receipt_subtotal =
            parseFloat(parReceipt.prima) +
            parseFloat(parReceipt.rpf) +
            parseFloat(parReceipt.derecho);

          if (scope.policy.ramo.ramo_code == 1) {
            parReceipt.iva = parseFloat(0).toFixed(2);
            parReceipt.total = parseFloat(receipt_subtotal).toFixed(2);
          } else {
            parReceipt.iva = parseFloat(receipt_subtotal * 0.16).toFixed(2);
            parReceipt.total = parseFloat(receipt_subtotal * 1.16).toFixed(2);
          }

          // comision
          // if(scope.policy.comision_percent) {
          //   var percent__ = parseFloat(scope.policy.comision_percent);

          //   if(percent__ > 0) {

          //     var prima_rec = parseFloat(angular.copy(parReceipt.prima));
          //     var comision_impr = parseFloat(prima_rec) / parseFloat(percent__);

          //     parReceipt.comision = comision_impr.toFixed(2);
          //   } else {
          //     parReceipt.comision = 0.00;
          //   }
          // }
        };

        scope.validateFloatKeyPress = function (
          e,
          parReceipt,
          receipt_index,
          parType
        ) {
          // console.log('event', e.type);
          // enter
          if (e.keyCode == 13 || e.type == "click") {
            var rec_prima = parseFloat(parReceipt.prima);
            var rec_rpf = parseFloat(parReceipt.rpf);
            var rec_derecho = parseFloat(parReceipt.derecho);
            var rec_iva = parseFloat(parReceipt.iva);
            var rec_total = parseFloat(parReceipt.total);
            var rec_comision = parseFloat(parReceipt.comision);

            if (parReceipt.recibo_numero == 1) {
              scope.prima_restante =
                angular.copy(scope.prima_c_descuento) - rec_prima;
              if (scope.endoso.rpf > 0) {
                scope.rpf_restante = angular.copy(scope.endoso.rpf) - rec_rpf;
              } else {
                scope.rpf_restante = 0;
              }
              scope.derecho_restante =
                angular.copy(scope.endoso.derecho) - rec_derecho;

              scope.total_restante =
                angular.copy(parseFloat(scope.endoso.primaTotal)) - rec_total;
              // console.log('aaa', scope.form);

              // console.log('comision_importe', scope.comision_importe);
              if (scope.comision_importe > 0) {
                scope.comision_restante =
                  angular.copy(scope.comision_importe) - rec_comision;
              } else {
                scope.comision_restante = 0;
              }

              if (scope.endoso.iva) {
                scope.iva_restante = angular.copy(scope.endoso.iva) - rec_iva;
              } else {
                scope.iva_restante = 0;
              }
            }

            if (parReceipt.recibo_numero > 1) {
              if (!isNaN(rec_prima)) {
                scope.prima_restante = scope.prima_restante - rec_prima;
              }
              if (!isNaN(rec_rpf)) {
                scope.rpf_restante = scope.rpf_restante - rec_rpf;
              }
              if (!isNaN(rec_derecho)) {
                scope.derecho_restante = scope.derecho_restante - rec_derecho;
              }
              if (!isNaN(rec_iva)) {
                scope.iva_restante = scope.iva_restante - rec_iva;
              }
              if (!isNaN(rec_total)) {
                scope.total_restante = scope.total_restante - rec_total;
              }
              if (!isNaN(rec_comision)) {
                scope.comision_restante =
                  scope.comision_restante - rec_comision;
              }
            }

            var receipts_lenght = angular.copy(scope.receipts.length);

            scope.receipts.forEach(function (rec_item, rec_item_index) {
              var item__ = rec_item_index + 1;

              if (item__ <= parReceipt.recibo_numero) {
                receipts_lenght = receipts_lenght - 1;

                if (item__ == parReceipt.recibo_numero) {
                  var prima___ = scope.new_prima_restante
                    ? scope.new_prima_restante
                    : scope.prima_restante;
                  scope.prima_x_recibo = prima___ / receipts_lenght;

                  var rpf__ = scope.rpf_restante;
                  scope.rpf_x_recibo = rpf__ / receipts_lenght;

                  var derecho__ = scope.derecho_restante;
                  scope.derecho_x_recibo = derecho__ / receipts_lenght;

                  var iva__ = scope.iva_restante;
                  scope.iva_x_recibo = iva__ / receipts_lenght;

                  var total__ = scope.total_restante;
                  scope.total_x_recibo = total__ / receipts_lenght;

                  var comision__ = scope.comision_restante;
                  scope.comision_x_recibo = comision__ / receipts_lenght;
                }
              } else {
                if (parType == 1) {
                  rec_item.prima = angular
                    .copy(scope.prima_x_recibo)
                    .toFixed(2);
                  rec_item.prima_neta = angular
                    .copy(scope.prima_x_recibo)
                    .toFixed(2);
                  scope.recalc_receipt(rec_item, rec_item_index);

                  rec_item.total = angular
                    .copy(scope.total_x_recibo)
                    .toFixed(2);
                  // rec_item.comision = angular.copy(scope.comision_x_recibo).toFixed(2);
                }

                rec_item.rpf = angular.copy(scope.rpf_x_recibo).toFixed(2);
                rec_item.derecho = angular
                  .copy(scope.derecho_x_recibo)
                  .toFixed(2);
                rec_item.iva = angular.copy(scope.iva_x_recibo).toFixed(2);
                if (parType == 5) {
                  rec_item.total = angular
                    .copy(scope.total_x_recibo)
                    .toFixed(2);
                } else if (parType == 6) {
                  rec_item.comision = angular
                    .copy(scope.comision_x_recibo)
                    .toFixed(2);
                }
              }
            });
          }
        };

        scope.getValuesPoliza = function () {
          // console.log('polizaaaaaaaaaaa', scope.poliza_);

          var desc__ = angular.copy(
            parseFloat(scope.endoso.descuento ? scope.endoso.descuento : 0)
          );
          var prima_neta__ = angular.copy(parseFloat(scope.endoso.primaNeta));
          var desc_import__ = angular.copy(
            parseFloat(prima_neta__ / 100) * desc__
          );

          // var comision___ = scope.form.comision ? scope.form.comision.comission : 0;
          // if(comision___) {
          //   scope.comision_importe = angular.copy(parseFloat(prima_neta__ / parseInt(scope.form.comision.comission)));
          // } else {
          //   scope.comision_importe = 0;
          // }
          // console.log('poliza_',scope.poliza_);
          if (scope.poliza_) {
            if (scope.poliza_.comision_percent) {
              var importe_prop = parseFloat(prima_neta__) / 100;
              var importe =
                importe_prop * parseFloat(scope.poliza_.comision_percent);
              // console.log('importe', importe);
              scope.comision_importe = importe;
            } else {
              scope.comision_importe = 0;
            }
          }

          if (scope.endoso.aplicarDescuento) {
            scope.prima_c_descuento = angular.copy(
              prima_neta__ - desc_import__
            );
          } else {
            scope.prima_c_descuento = angular.copy(prima_neta__);
          }
          // console.log('aaa', scope.prima_c_descuento);
        };

        scope.calculateInputs = function (param) {
          // console.log('ok', scope.endoso);
          // scope.back_up_poliza = angular.copy(scope.poliza);

          if (!scope.endoso.primaNeta || scope.endoso.primaNeta == undefined) {
            var primaNeta_ = 0;
          } else {
            var primaNeta_ = parseFloat(scope.endoso.primaNeta);
          }

          if (!scope.endoso.descuento || scope.endoso.descuento == undefined) {
            var desceunto_importe = 0;
          } else {
            if (scope.endoso.aplicarDescuento) {
              var descuento_percent = parseInt(scope.endoso.descuento) / 100;
              var desceunto_importe = primaNeta_ * descuento_percent;
            } else {
              var desceunto_importe = 0;
            }
          }

          if (!scope.endoso.rpf || scope.endoso.rpf == undefined) {
            var rpf_ = 0;
          } else {
            var rpf_ = parseFloat(scope.endoso.rpf);
          }

          if (!scope.endoso.derecho || scope.endoso.derecho == undefined) {
            var derecho_ = 0;
          } else {
            var derecho_ = parseFloat(scope.endoso.derecho);
          }

          if (desceunto_importe == undefined) {
            desceunto_importe = 0;
          }

          var p_neta_descuento = primaNeta_ - desceunto_importe;

          // console.log('policy', scope.policy);
          // if(scope.policy.ramo.ramo_code == 1) {

          // }

          var subtotal_ = p_neta_descuento + rpf_ + derecho_;
          var iva_importe = subtotal_ * 0.16;

          var ramo_code = scope.policy.ramo.ramo_code;

          if (ramo_code == 1) {
            var primaTotal_ = subtotal_;
            scope.endoso.iva = 0;
          } else {
            var primaTotal_ = subtotal_ + iva_importe;
            scope.endoso.iva = iva_importe.toFixed(2);
          }

          scope.endoso.primaTotal = primaTotal_.toFixed(2);

          if (scope.endoso.subTotal == undefined) {
            scope.endoso.subTotal = subtotal_.toFixed(2);
          }

          if (isNaN(scope.endoso.subTotal)) {
            scope.endoso.subTotal = 0;
          } else {
            scope.endoso.subTotal = subtotal_.toFixed(2);
          }
        };

        if (scope.receipts) {
          scope.endoso.primaNeta = parseFloat(scope.endoso.primaNeta);
          scope.endoso.derecho = parseFloat(scope.endoso.derecho);
          // scope.endoso.derecho = parseFloat(scope.endoso.derecho);
          // scope.endoso.derecho = parseFloat(scope.endoso.derecho);

          scope.calculateInputs();
        }

        scope.showInput = false;

        scope.editTable = function (param) {
          scope.editedReceipts = true;
          if (scope.showInput == false) {
            scope.showInput = true;
          } else {
            scope.showInput = false;
          }

          if (param) {
            // var init_poliza = new Date(scope.form.start_of_validity);
            var init_poliza = new Date(form.policy_starting_date);
            var end_poliza = new Date(scope.form.end_of_validity);

            scope.receipts.forEach(function (obj, obj_index) {
              obj.fecha_inicio = obj.startDate;
              obj.fecha_fin = obj.endingDate;

              if (obj_index == 0) {
                var init_first_receipt = new Date(
                  datesFactory.toDate(obj.startDate)
                );

                // console.log('init_first_receipt', init_first_receipt);
                // console.log('init_poliza       ', init_poliza);
                var Hoy = new Date(init_poliza); //Fecha actual del sistema
                var Fecha1 = new Date(init_first_receipt);

                var AnyoFecha = Fecha1.getFullYear();
                var MesFecha = Fecha1.getMonth();
                var DiaFecha = Fecha1.getDate();

                var AnyoHoy = Hoy.getFullYear();
                var MesHoy = Hoy.getMonth();
                var DiaHoy = Hoy.getDate();

                if (AnyoFecha < AnyoHoy) {
                  // alert ("La fecha introducida es anterior a Hoy");
                } else {
                  if (AnyoFecha == AnyoHoy && MesFecha < MesHoy) {
                    // alert ("La fecha introducida es anterior a Hoy");
                  } else {
                    if (
                      AnyoFecha == AnyoHoy &&
                      MesFecha == MesHoy &&
                      DiaFecha < DiaHoy
                    ) {
                      // alert ("La fecha introducida es anterior a Hoy");
                      toaster.warning(
                        "La fecha de inicio del recibo es menor a la fecha de inicio de la póliza."
                      );
                      // obj.startDate = datesFactory.convertDate(scope.form.start_of_validity);
                      // obj.fecha_inicio = obj.startDate;
                      obj.startDate = datesFactory.convertDate(init_poliza);
                      obj.fecha_inicio = obj.startDate;
                    } else {
                      if (
                        AnyoFecha == AnyoHoy &&
                        MesFecha == MesHoy &&
                        DiaFecha == DiaHoy
                      ) {
                        // alert ("Has introducido la fecha de Hoy");
                      } else {
                        // alert ("La fecha introducida es posterior a Hoy");
                      }
                    }
                  }
                }

                // if(init_first_receipt.getTime() < init_poliza.getTime()) {

                //   toaster.warning('La fecha de inicio del recibo es menor a la fecha de inicio de la póliza.');
                //   // obj.startDate = datesFactory.convertDate(new Date());
                //   obj.startDate = datesFactory.convertDate(scope.form.start_of_validity);
                //   obj.fecha_inicio = obj.startDate;

                // }
              } else if (obj_index == scope.receipts.length - 1) {
                var end_last_receipt = new Date(
                  datesFactory.toDate(obj.endingDate)
                );

                if (end_last_receipt.getTime() > end_poliza.getTime()) {
                  toaster.warning(
                    "La fecha de fin del recibo es mayor a la fecha de fin de la póliza."
                  );
                  obj.endingDate = datesFactory.convertDate(end_poliza);
                  obj.fecha_fin = obj.endingDate;
                } else {
                  obj.fecha_fin = obj.endingDate;
                }
              }
            });

            var demo = angular.copy(scope.receipts);
            // console.log('receipts', scope.receipts);

            demo.forEach(function (obj) {
              // console.log('demo');

              obj.recibo_numero = obj.recibo_numero;
              obj.prima_neta = parseFloat(obj.prima).toFixed(2);
              obj.rpf = parseFloat(obj.rpf).toFixed(2);
              obj.derecho = parseFloat(obj.derecho).toFixed(2);
              obj.iva = parseFloat(obj.iva).toFixed(2);
              obj.subTotal = parseFloat(obj.subTotal).toFixed(2);
              obj.prima_total = parseFloat(obj.total).toFixed(2);
              obj.total = parseFloat(obj.total).toFixed(2);
              obj.receipt_type = scope.receipts[0].receipt_type;
              obj.comision = parseFloat(obj.comision).toFixed(2);
              obj.fecha_inicio = obj.startDate;
              obj.vencimiento = obj.vencimiento
                ? obj.vencimiento
                : obj.startDate;
              obj.startDate = obj.startDate;
              obj.endingDate = obj.endingDate;
              obj.fecha_fin = obj.endingDate;
            });

            scope.tosave.recibos_poliza = demo;
            scope.tosave.receipts = demo;
          } else {
            scope.getValuesPoliza();
          }
          scope.getValuesPoliza();
        };
        scope.editIva = function (param) {
          scope.endoso[param] = String(scope.endoso[param]).replace(
            /^[A-Za-z]+$/,
            ""
          );

          scope.edited_iva = true;
          if (scope.endoso.iva) {
            var iva_edited = scope.endoso.iva;
          } else {
            var iva_edited = 0;
          }
          scope.endoso.primaTotal = (
            parseFloat(scope.endoso.subTotal) + parseFloat(iva_edited)
          ).toFixed(2);
        };
        // calculate
        function getSubtotal(parPoliza) {
          var sum =
            parseFloat(parPoliza.primaNeta) +
            parseFloat(parPoliza.rpf) +
            parseFloat(parPoliza.derecho);

          return Number(sum.toFixed(2));
        }

        scope.formatNumber = function (valor) {
          // console.log('valor', valor);
          var nums = new Array();
          var simb = ",";

          if (!valor) {
            return;
          }
          // console.log(typeof(valor));
          if (typeof valor == "number") {
            return valor;
          } else {
            valor = valor.toString();
            nums = valor.split("");
            var long = nums.length - 1;
            var patron = 3;
            var prox = 2;
            var res = "";

            while (long > prox) {
              if (prox == 2) {
              } else {
                nums.splice(long - prox, 0, simb);
              }
              prox += patron;
            }
            nums.splice(0, 0);

            for (var i = 0; i <= nums.length - 1; i++) {
              res += nums[i];
            }

            return valor;
          }
        };

        function sumarDias(fecha, dias) {
          fecha.setDate(fecha.getDate() + dias);
          return fecha;
        }

        scope.$watch("form.num_receipts", function (new_value, old_value) {
          // console.log('new_value', new_value);
          form.num_receipts = new_value;
        });

        scope.checkVenDate = function (parReceipt) {
          var init_date_ = datesFactory.toDate(parReceipt.startDate);
          var ven_date_ = datesFactory.toDate(parReceipt.vencimiento);
          if (ven_date_.getTime() < init_date_.getTime()) {
            SweetAlert.swal(
              "La fecha de vencimiento no puede ser menor a la fecha de inicio del recibo."
            );
            parReceipt.vencimiento = "";
          }
        };

        scope.calculate = function (poliza) {
          scope.prima_restante = 0;
          scope.rpf_restante = 0;
          scope.derecho_restante = 0;
          scope.iva_restante = 0;
          scope.total_restante = 0;
          scope.comision_restante = 0;
          if (scope.form.description == "CAMBIO DE FORMA DE PAGO") {
            if (scope.form.num_receipts !== scope.policy.forma_de_pago) {
              scope.non_dates = true;
              SweetAlert.swal(
                "La cantidad de recibos que ha seleccionado no concuerda con la frecuencia de pago seleccionada, puede haber errores en los recibos generados."
              );
            } else {
              scope.non_dates = false;
            }
          } else {
            scope.non_dates = false;
          }

          if (scope.endoso.configDerecho || scope.endoso.configRPF) {
            // swal
            if (scope.edited_iva) {
              SweetAlert.swal(
                "Los resultados en los recibos pueden no ser exactos, favor de revisarlos manualmente."
              );
            }
          }
          scope.endoso.descuento = 0;

          var desc_importe = 0;

          poliza.prima = parseFloat(angular.copy(poliza.prima)) - desc_importe;
          poliza.rpf = poliza.rpf;
          poliza.derecho = poliza.derecho;
          scope.receipts = [];

          // console.log('adads', scope.poliz);
          var ramo_code = scope.policy.ramo.ramo_code;
          if (ramo_code == 1) {
            poliza.ivaStatus = false;
            scope.showIva = false;
            poliza.iva = 0.0;
            scope.endoso.iva = 0.0;
          } else {
            poliza.ivaStatus = true;
            scope.showIva = true;
          }

          if (form.receipts) {
            scope.tosave.delete_receitps = form.receipts;
            form.receipts = [];
            if (!form.num_receipts) {
              if (scope.form.forma_de_pago) {
                form.num_receipts = scope.form.forma_de_pago;
              } else {
                form.num_receipts = scope.policy.forma_de_pago;
              }
            }
          }

          // console.log('--------', form.num_receipts);

          if (form.num_receipts >= 7 && form.num_receipts <= 11) {
            var form_ = 1;
          } else {
            var form_ = form.num_receipts;
          }

          // var form_ = form.num_receipts;

          if (!poliza.derecho) {
            poliza.derecho = 0;
          }

          if (!poliza.rpf) {
            poliza.rpf = 0;
          }

          var descuento_ = 0;
          var cantidad_desc = parseFloat(poliza.primaNeta);

          scope.p_neta_desc = parseFloat(cantidad_desc);
          scope.subtotal_desc =
            parseFloat(scope.p_neta_desc) +
            parseFloat(poliza.rpf) +
            parseFloat(poliza.derecho);

          if (scope.edited_iva) {
            scope.iva_desc = scope.endoso.iva;
          } else {
            scope.iva_desc = parseFloat(scope.subtotal_desc) * 0.16;
          }

          if (scope.back_up_poliza.ramo.ramo_code == 1) {
            scope.p_total_desc = parseFloat(scope.subtotal_desc);
          } else {
            scope.p_total_desc =
              parseFloat(scope.subtotal_desc) + parseFloat(scope.iva_desc);
          }
          var prima_neta = parseFloat(poliza.primaNeta);
          var derecho = parseFloat(poliza.derecho);
          var rpf = parseFloat(poliza.rpf);

          scope.endoso.iva = parseFloat(scope.endoso.iva).toFixed(2);
          scope.endoso.primaTotal = (
            parseFloat(scope.endoso.subTotal) + parseFloat(scope.endoso.iva)
          ).toFixed(2);

          scope.tosave.p_neta = prima_neta;
          scope.tosave.derecho = derecho;
          scope.tosave.rpf = rpf;
          scope.tosave.descuento = poliza.descuento ? poliza.descuento : 0;
          scope.tosave.p_total = parseFloat(poliza.primaTotal);

          var IVA = 0;
          var TOTAL_IVA = 1;

          if (!scope.edited_iva) {
            var poliza_iva = scope.iva_desc;
          } else {
            var poliza_iva = parseFloat(scope.endoso.iva).toFixed(2);
          }

          scope.tosave.iva = parseFloat(poliza_iva).toFixed(2);

          poliza.iva = scope.tosave.iva;

          // console.log('---------------------');
          // console.log(form);
          if (form.num_receipts || form.endorsement_receipt) {
            if (!form.num_receipts && form.endorsement_receipt) {
              form.num_receipts = 5;
            }

            // TODO: checar esta función
            function getNumber(num) {
              var num2 = Math.ceil(num);
              return new Array(num2);
            }

            function getTotal(poliza) {
              if (scope.edited_ptotal) {
                var p_total = parseFloat(scope.ptotal_edited);
                scope.endoso.primaTotal = parseFloat(scope.ptotal_edited);
              } else {
                // poliza.primaTotal = getTotal(poliza).toFixed(2);
                var p_total = parseFloat(scope.p_total_desc);
              }

              // var p_total = parseFloat(scope.p_total_desc);
              scope.tosave.p_total = p_total.toFixed(2);
              return parseFloat(p_total);
            }

            function getPrimaTotalReceipt(parObj, parAmonunts) {
              var prima_neta_ = parseFloat(parObj.prima);
              var subtotal_ =
                parseFloat(prima_neta_) +
                parseFloat(parObj.rpf) +
                parseFloat(parObj.derecho);
              var iva_ = getIva(parObj, parAmonunts);

              if (scope.edited_ptotal) {
                var prima_total_ = parseFloat(parObj.primaTotal);
              } else {
                var prima_total_ = parseFloat(subtotal_ + parseFloat(iva_));
              }

              // var prima_total_ = parseFloat(subtotal_ + parseFloat(iva_));

              return prima_total_.toFixed(2);
            }

            function getIva(parValue, parAmonunts) {
              var prima_neta_ = parseFloat(parValue.prima);
              var subtotal_ =
                parseFloat(prima_neta_) +
                parseFloat(parValue.rpf) +
                parseFloat(parValue.derecho);

              if (scope.edited_iva) {
                var iva_ = parseFloat(scope.endoso.iva) / parAmonunts;
              } else {
                var iva_ = subtotal_ * 0.16;
              }

              if (ramo_code == 1) {
                var iva_ = 0.0;
              }

              return iva_.toFixed(2);
            }

            function comissionCalc(parPneta) {
              var p_neta_ = parPneta;
              // console.log('policy_comision', scope.policy.comision);

              scope.poliza_ = scope.policy;

              if (scope.policy.comision) {
                if (scope.policy.comision.comission) {
                  var comision_ =
                    parseFloat(scope.policy.comision.comission) / 100;
                } else if (scope.policy.comision_percent) {
                  var comision_ =
                    parseFloat(scope.policy.comision_percent) / 100;
                }

                if (scope.policy.ceder_comision) {
                  var comision_ =
                    parseFloat(scope.policy.comision_percent) / 100;
                }
              } else {
                if (scope.policy.comision_percent) {
                  var comision_ =
                    parseFloat(scope.policy.comision_percent) / 100;
                } else {
                  var comision_ = 0;
                }
              }

              var result = parseFloat(p_neta_ * comision_).toFixed(2);

              return result;
            }

            // console.log('-----------------', form);

            receipts = [];
            scope.showreceipts = true;
            if (form.startDate) {
              if (form.cambioPago) {
                // var initDate = new Date(form.start_of_validity);
                var initDate = new Date(form.policy_starting_date);
              } else {
                // var initDate = form.startDate;
                var initDate = new Date(form.policy_starting_date);
                // console.log('initDate', initDate);
              }
            } else {
              // var initDate = new Date(form.start_of_validity);
              var initDate = new Date(form.policy_starting_date);
            }

            if (form.endingDate) {
              var endDate = new Date(datesFactory.mesDiaAnio(form.endingDate));
            } else {
              var endDate = new Date(form.end_of_validity);
            }

            if (isNaN(initDate)) {
              // initDate = new Date(form.startDate);
              initDate = new Date(form.policy_starting_date);
            }

            if (isNaN(endDate)) {
              // console.log('++++++++ END DATE');
              endDate = new Date(form.endingDate);
            }

            var months = helpers.monthDiff(initDate, endDate);

            // Calculate diff between dates
            var dateDiff = moment(endDate).diff(moment(initDate), "days");

            var amountReceipts = months / form_;
            if (scope.form.tipo_endoso == 2 || scope.form.tipo_endoso == 1) {
              if (form_ == 6) {
                var amountReceipts = 2;
              } else if (form_ == 4) {
                var amountReceipts = 3;
              } else if (form_ == 3) {
                var amountReceipts = 4;
              } else if (form_ == 2) {
                var amountReceipts = 6;
              } else if (form_ == 1) {
                var amountReceipts = 12;
              }
            }
            // var amountReceipts = form.num_receipts;

            if (amountReceipts == 0) {
              amountReceipts = 1;
            }
            if (form_ == 0) {
              amountReceipts = 0;
            }
            //Calculate poliza results
            poliza.primaTotal = getTotal(poliza).toFixed(2);
            // console.log('-->',poliza.primaTotal);

            amountReceipts = Math.ceil(amountReceipts);

            scope.total_receipts = form.num_receipts;
            // console.log('num_receipts', form.num_receipts);
            if (form.num_receipts == 5) {
              amountReceipts = 1;
              initDate = new Date(
                datesFactory.toDate(datesFactory.convertDate(form.startDate))
              );
              endDate = new Date(datesFactory.toDate(form.end_of_validity));
            } else if (form.num_receipts.value == 5) {
              amountReceipts = 1;

              initDate = new Date(datesFactory.toDate(form.startDate));
              endDate = new Date(datesFactory.toDate(form.end_of_validity));
            }

            // if(form.num_receipts == 7 || form.num_receipts == 8 || form.num_receipts == 9 || form.num_receipts == 11) {
            //   // console.log('ok');
            //   amountReceipts = 7;

            //   // initDate = new Date(datesFactory.toDate(form.startDate));
            //   // endDate = new Date(datesFactory.toDate(form.end_of_validity));
            // } else if(form.num_receipts == 5.5) {
            //   amountReceipts = 12;
            // }
            switch (form.num_receipts) {
              case 5.5:
                amountReceipts = 5;
                break;
              case 7:
                amountReceipts = 7;
                break;
              case 8:
                amountReceipts = 8;
                break;
              case 9:
                amountReceipts = 9;
                break;
              case 10:
                amountReceipts = 10;
                break;
              case 11:
                amountReceipts = 11;
                break;
            }

            // var start_poliza = new Date(form.policy_starting_date);
            if (form.initDate == "Invalid Date") {
              var start_poliza = new Date(datesFactory.toDate(form.init_date));
            } else if (form.init_date) {
              // console.log();
              if (form.init_date.search("/") > -1) {
                var date = form.init_date.split("/");
                start_poliza = new Date(date[2], date[1] - 1, date[0]);
              } else {
                start_poliza = new Date(form.init_date);
              }

              // console.log('start_poliza_2', start_poliza);
            } else {
              var start_poliza = new Date(form.startDate);
              // console.log('start_poliza_3', start_poliza);
            }

            // console.log('start_poliza', start_poliza);

            initDate = start_poliza;

            // console.log('initDate', initDate);

            var prima_neta_total = 0;
            // console.log('amountReceipts', amountReceipts);
            var arrayLen = getNumber(amountReceipts);
            // console.log('arrayLen', arrayLen);
            // Logic from vm

            if (poliza.aplicarDescuento) {
              var percent_ = parseFloat(poliza.descuento) / 100;
              var importe_ = parseFloat(poliza.primaNeta) * percent_;
              var prima_ = parseFloat(poliza.primaNeta) - importe_;
            } else {
              var prima_ = parseFloat(poliza.primaNeta);
            }

            if (scope.edited_iva) {
              poliza.iva = scope.endoso.iva;
              poliza.primaTotal = scope.endoso.primaTotal;
            }

            var obj = {
              // prima: poliza.primaNeta / amountReceipts,
              prima: prima_ / amountReceipts,
              rpf: poliza.rpf / amountReceipts,
              derecho: poliza.derecho / amountReceipts,
              iva: poliza.iva,
              subTotal: poliza.subTotal / amountReceipts,
              primaTotal: poliza.primaTotal / amountReceipts,
            };

            var empty_receipts = 0;
            var empty_rec_array = [];

            for (var i = 0; i < arrayLen.length; i++) {
              if (scope.total_receipts > 5) {
                var x = i + 1;

                if (x > scope.total_receipts) {
                  break;
                }
              }
              // Check options
              if (poliza.configDerecho) {
                if (i === 0) {
                  if (poliza.derecho) {
                    obj.derecho = parseFloat(poliza.derecho);
                  } else {
                    obj.derecho = 0;
                  }
                } else {
                  obj.derecho = 0;
                }
              }

              if (poliza.configRPF) {
                if (i === 0) {
                  if (obj.rpf) {
                    obj.rpf = parseFloat(poliza.rpf);
                  } else {
                    obj.rpf = 0;
                  }
                } else {
                  obj.rpf = 0;
                }
              }

              // console.log('start_poliza', start_poliza);
              // console.log('form_', form_);
              // endDate = new Date(new Date(moment(start_poliza).add(form_, 'months')).setHours(11,59,59));

              // console.log('policy', scope.policy);
              // console.log(form);
              if (i == 0) {
                endDate = new Date(
                  new Date(
                    moment(form.policy_starting_date).add(form_, "months")
                  ).setHours(11, 59, 59)
                );
                // console.log('++++++++++++++ endDate', endDate);
              } else {
                endDate = new Date(
                  new Date(moment(initDate).add(form_, "months")).setHours(
                    11,
                    59,
                    59
                  )
                );
                // console.log('______________ endDate', endDate);
              }

              if (i == 0 && scope.policy.document_type == 7) {
                // console.log('form', form);
                if (form.end_date) {
                  // if(isNaN(new Date(form.end_date))){
                  //   endDate = form.end_date;
                  // } else {
                  //   endDate = new Date(form.end_date);
                  // }
                  // console.log('end_date', form.end_date);
                  endDate = new Date(datesFactory.toDate(form.end_date));
                  // console.log('asdasdf', endDate);
                } else if (form.end_of_validity) {
                  endDate = new Date(form.end_of_validity);
                }
              }

              // console.log('endingDate', endDate);
              // console.log('----------------------------');

              // var val_start_2 = new Date(datesFactory.toDate(scope.endoso_date.start_of_validity));
              // var val_end_2   = new Date(endDate);

              // console.log('val_start_2', val_start_2);
              // console.log('val_end_2', val_end_2);
              // console.log('initDate', initDate);

              var subTotal = obj.prima + obj.rpf + obj.derecho;

              prima_neta_total + parseFloat(obj.prima.toFixed(2));

              // console.log('policy', form);
              // console.log('initDate', initDate);

              var receipt = {
                recibo_numero: i + 1,
                prima_neta: parseFloat(obj.prima.toFixed(2)),
                prima: parseFloat(obj.prima.toFixed(2)),
                rpf: parseFloat(obj.rpf.toFixed(2)),
                derecho: parseFloat(obj.derecho.toFixed(2)),
                iva: getIva(obj, amountReceipts),
                subTotal: parseFloat(subTotal.toFixed(2)),
                prima_total: getPrimaTotalReceipt(obj, amountReceipts),
                total: getPrimaTotalReceipt(obj, amountReceipts),
                comision: comissionCalc(parseFloat(obj.prima.toFixed(2))),
                receipt_type: 2,
                delivered: false,
              };

              if (dateDiff === 364 || dateDiff === 365 || dateDiff === 366) {
                receipt.fecha_inicio = datesFactory.convertDate(initDate);
                receipt.vencimiento = datesFactory.convertDate(initDate)
                  ? datesFactory.convertDate(initDate)
                  : null;
                receipt.startDate = datesFactory.convertDate(initDate);
                receipt.endingDate = datesFactory.convertDate(endDate);
                receipt.fecha_fin = datesFactory.convertDate(new Date(endDate));
              } else {
                receipt.startDate = "";
                receipt.vencimiento = "";
                receipt.endingDate = "";
                receipt.fecha_inicio = "";
                receipt.fecha_fin = "";
              }

              if (form.num_receipts == 5 || scope.policy.document_type == 7) {
                receipt.fecha_inicio = form.startDate;
                receipt.startDate = form.startDate;
                receipt.endingDate = form.endingDate;
                receipt.fecha_fin = form.endingDate;
                receipt.vencimiento = form.startDate ? form.startDate : null;
              }

              // console.log(scope.endoso_date.start_of_validity);
              // console.log(endDate);
              // console.log('------------------------');
              // console.log('scope.endoso_date.start_of_validity', scope.endoso_date.start_of_validity);

              // var val_start = new Date(datesFactory.toDate(scope.endoso_date.start_of_validity));
              // console.log('initDate', form);
              if (form.init_date) {
                var val_start = new Date(datesFactory.toDate(form.init_date));
                // console.log('añlkdsjlkfjs');
              } else {
                // console.log('----------------');
                var val_start = new Date(form.startDate);
              }

              var val_policy_end = new Date(form.end_of_validity);

              // console.log('val_start', val_start);

              var val_end = new Date(endDate);

              // if (new Date().getTime() > endDate.getTime()) {
              if (val_start.getTime() > endDate.getTime()) {
                // console.log('---- FECHA FUERA DE RANGO ----');
                // empty_receipts = empty_receipts +1;
                // receipt.startDate = '';
                // receipt.vencimiento  = '';
                // receipt.endingDate = '';
                // receipt.fecha_inicio = '';
                // receipt.fecha_fin = '';
                // initDate = endDate;
                // empty_rec_array.push(receipt);
                // continue;

                receipt.startDate = "";
                receipt.fecha_inicio = "";
                receipt.endingDate = "";
                receipt.fecha_fin = "";
                receipt.vencimiento = "";

                // console.log('val_start', val_start);
                // initDate = new Date(val_start);

                // if(receipt.recibo_numero == 1) {

                //   receipt.fecha_inicio = datesFactory.convertDate(initDate);
                //   receipt.startDate = datesFactory.convertDate(initDate);
                // }

                // scope.new_amounts = angular.copy(amountReceipts) -1;
                // scope.new_prima = obj.prima / scope.new_amounts;
                // scope.new_derecho =  obj.derecho / scope.new_amounts;
                // scope.new_rpf =  obj.rpf / scope.new_amounts;
                // scope.new_iva =  obj.iva / scope.new_amounts;
                // scope.new_subTotal =  obj.subTotal / scope.new_amounts;
                // scope.new_primaTotal =  obj.primaTotal / scope.new_amounts;
                // scope.new_comision =  angular.copy(receipt.comision) / scope.new_amounts;
                // // continue;
                // console.log('--------------');
              } else {
                // console.log('*************');

                receipt.recibo_numero =
                  parseInt(receipt.recibo_numero) - empty_receipts;

                if (scope.new_prima) {
                  receipt.recibo_numero = receipt.recibo_numero - 1;
                  receipt.prima = receipt.prima + scope.new_prima;
                  receipt.prima_neta = receipt.prima + scope.new_prima;

                  receipt.derecho = receipt.derecho + scope.new_derecho;
                  receipt.rpf = receipt.rpf + scope.new_rpf;
                  receipt.iva = scope.new_iva;
                  receipt.subTotal = receipt.subTotal + scope.new_subTotal;
                  receipt.primaTotal =
                    parseFloat(receipt.prima_total) + scope.new_primaTotal;
                  receipt.total =
                    parseFloat(receipt.prima_total) + scope.new_primaTotal;
                  receipt.comision =
                    parseFloat(receipt.comision) + scope.new_comision;
                }

                // if(receipt.recibo_numero == 1) {

                // console.log('initDate', initDate);
                // console.log('endDate', endDate);
                if (initDate.getTime() < val_start.getTime()) {
                  initDate = val_start;
                  // console.log('============');
                }

                // console.log('val_start', val_start);
                // console.log('initDate', initDate);
                // console.log('endDate', endDate);
                // console.log('init_date', form.init_date);
                // console.log('endDate', form.end_of_validity);
                // console.log('.................................', new Date(datesFactory.toDate(new Date(form.end_of_validity))));
                // console.log('.................................');
                if (
                  val_start.getTime() > initDate &&
                  val_start.getTime() < endDate.getTime()
                ) {
                  if (form.type == "INDIVIDUAL") {
                    if (scope.form.description == "CAMBIO DE FORMA DE PAGO") {
                      receipt.startDate = datesFactory.convertDate(
                        scope.policy.start_of_validity
                      );
                      receipt.start_of_validity = datesFactory.convertDate(
                        scope.policy.start_of_validity
                      );
                    } else {
                      receipt.startDate = datesFactory.convertDate(
                        scope.endoso_date.start_of_validity
                      );
                      var start___ =
                        scope.endoso_date.start_of_validity.search("/");
                      if (start___ > -1) {
                        receipt.fecha_inicio =
                          scope.endoso_date.start_of_validity;
                        receipt.startDate = scope.endoso_date.start_of_validity;
                      } else {
                        receipt.fecha_inicio = datesFactory.convertDate(
                          scope.endoso_date.start_of_validity
                        );
                        receipt.startDate = datesFactory.convertDate(
                          scope.endoso_date.start_of_validity
                        );
                      }
                    }

                    receipt.endingDate = endDate;
                    receipt.end_of_validity = endDate;

                    var ven_date = datesFactory.convertDate(
                      sumarDias(datesFactory.toDate(receipt.fecha_inicio), 30)
                    );
                    receipt.vencimiento = ven_date;
                  } else {
                    console.log("bbb");

                    var date_init = angular.copy(
                      datesFactory.toDate(receipt.fecha_inicio)
                    );

                    if (new Date().getTime() > new Date(date_init).getTime()) {
                      receipt.fecha_inicio = datesFactory.convertDate(
                        new Date()
                      );
                      receipt.startDate = datesFactory.convertDate(new Date());
                      var ven_date = datesFactory.convertDate(
                        sumarDias(datesFactory.toDate(receipt.fecha_inicio), 30)
                      );
                      receipt.vencimiento = ven_date;
                    }
                  }

                  receipt.endingDate = datesFactory.convertDate(endDate);
                  receipt.end_of_validity = datesFactory.convertDate(endDate);

                  initDate = endDate;
                } else {
                  receipt.startDate = datesFactory.convertDate(initDate);
                  receipt.start_of_validity =
                    datesFactory.convertDate(initDate);
                  receipt.endingDate = datesFactory.convertDate(endDate);
                  receipt.end_of_validity = datesFactory.convertDate(endDate);
                  receipt.vencimiento = datesFactory.convertDate(initDate);

                  if (initDate.getTime() > val_policy_end.getTime()) {
                    receipt.start_of_validity = "";
                    receipt.startDate = "";
                    receipt.fecha_inicio = "";
                    receipt.vencimiento = "";
                  }

                  val_end.setHours(11, 59, 59);
                  val_policy_end.setHours(11, 59, 59);

                  if (val_end.getTime() > val_policy_end.getTime()) {
                    receipt.endingDate = "";
                    receipt.fecha_fin = "";
                    receipt.end_of_validity = "";
                    // receipt.vencimiento = '';

                    if (
                      scope.policy.document_type == 7 &&
                      arrayLen.length == 1
                    ) {
                      receipt.endingDate =
                        datesFactory.convertDate(val_policy_end);
                      receipt.fecha_fin =
                        datesFactory.convertDate(val_policy_end);
                      receipt.end_of_validity =
                        datesFactory.convertDate(val_policy_end);
                    }
                  }

                  initDate = endDate;
                }
              }

              if (scope.non_dates) {
                receipt.startDate = "";
                receipt.vencimiento = "";
                receipt.endingDate = "";
                receipt.fecha_inicio = "";
                receipt.fecha_fin = "";
              }

              initDate = endDate;

              scope.receipts.push(angular.copy(receipt));

              scope.tosave.endoso = scope.endoso;
              scope.tosave.recibos_poliza = scope.receipts;
              scope.tosave.receipts = scope.receipts;
            }

            // console.log('empty_receipts', empty_receipts);
            if (empty_receipts > 0) {
              // console.log('empty_rec_array',empty_rec_array);
              for (var j in empty_rec_array) {
                var item = empty_rec_array[j];

                item.recibo_numero =
                  parseInt(item.recibo_numero) + scope.receipts.length;

                scope.receipts.push(angular.copy(item));

                scope.tosave.endoso = scope.endoso;
                scope.tosave.recibos_poliza = scope.receipts;
                scope.tosave.receipts = scope.receipts;
              }

              SweetAlert.swal(
                "La cantidad de recibos no coinicide con la fecha de endoso."
              );
            }

            if (ramo_code == 1) {
              poliza.ivaStatus = false;
              scope.showIva = false;
              poliza.iva = 0.0;
              scope.endoso.iva = 0.0;

              primaTotalNum = poliza.subTotal;
              primaTotalNum = parseFloat(primaTotalNum).toFixed(2);
              scope.endoso.primaNeta = scope.formatNumber(poliza.primaNeta);
              scope.endoso.rpf = scope.formatNumber(poliza.rpf);
              scope.endoso.derecho = scope.formatNumber(poliza.derecho);
              subTotalNum = poliza.subTotal;
              subTotalNum = parseFloat(subTotalNum).toFixed(2);
              scope.endoso.subTotal = scope.formatNumber(subTotalNum);
              scope.endoso.iva = scope.formatNumber(poliza.iva);
              // scope.endoso.primaTotal = scope.formatNumber(primaTotalNum);

              //---------normal-------
            } else {
              poliza.ivaStatus = true;
              scope.showIva = true;
              scope.endoso.primaNeta = scope.formatNumber(poliza.primaNeta);
              scope.endoso.rpf = scope.formatNumber(poliza.rpf);
              scope.endoso.derecho = scope.formatNumber(poliza.derecho);
              subTotalNum = poliza.subTotal;
              subTotalNum = parseFloat(subTotalNum).toFixed(2);
              scope.endoso.subTotal = scope.formatNumber(subTotalNum);
              scope.endoso.iva = scope.formatNumber(poliza.iva);
              // primaTotalNum =  poliza.primaTotal;
              // primaTotalNum = parseFloat(primaTotalNum).toFixed(2);
              // scope.endoso.primaTotal = scope.formatNumber(primaTotalNum);
            }

            if (scope.receipts.length) {
              scope.datesN = false;
              scope.receipts.forEach(function (rec, e) {
                if (
                  rec.fecha_inicio == "Invalid Date" ||
                  rec.fecha_fin == "Invalid Date" ||
                  rec.fecha_inicio == "" ||
                  rec.fecha_fin == ""
                ) {
                  scope.datesN = true;
                }
              });
              if (scope.datesN) {
                toaster.warning(
                  "Agregar manualmente las fechas y, guarde cambios"
                );
                scope.editTable(true);
              }
              if (!scope.receipts[0].startDate) {
                scope.editTable(true);
                toaster.warning(
                  "Agregar manualmente las fechas y, guarde cambios"
                );
              }
            }
          }
        };
      },
    };
  },
]);

var app = angular.module("inspinia").directive("calculateReceipts", [
  "toaster",
  "MESSAGES",
  "helpers",
  "datesFactory",
  "$filter",
  "SweetAlert",
  "$sessionStorage",
  "$location",
  function (
    toaster,
    MESSAGES,
    helpers,
    datesFactory,
    $filter,
    SweetAlert,
    $sessionStorage,
    $location
  ) {
    return {
      restrict: "EA",
      scope: {
        model: "=",
        poliza: "=",
        form: "=",
        tosave: "=",
        type: "=",
      },
      templateUrl:
        "app/directivas/calculateReceipts/calculate.receipts.template.html",
      link: function (scope, element, $watch, attrs) {
        scope.active_calculate = true;

        scope.recibo_liquidado_conciliado = false;
        scope.accesos = $sessionStorage.permisos;
        if (scope.accesos) {
          scope.accesos.forEach(function (perm) {
            if (perm.model_name == "Comisiones") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Comisiones") {
                  if (acc.checked == true) {
                    scope.permiso_comisiones = true;
                  } else {
                    scope.permiso_comisiones = false;
                  }
                }
              });
            }
            if (perm.model_name == "Cobranza") {
              scope.acceso_dash = perm;
              scope.acceso_dash.permissions.forEach(function (acc) {
                if (acc.permission_name == "Eliminar recibos") {
                  if (acc.checked == true) {
                    scope.permiso_delRecibo = true;
                  } else {
                    scope.permiso_delRecibo = false;
                  }
                }
              });
            }
          });
        }
        // if ($location.path().indexOf('editar')) {
        if ($location.path().indexOf("editar") != -1) {
          try {
            if (
              scope.form.noRecalculateReceipts == false ||
              scope.form.noRecalculateReceipts == true
            ) {
              scope.noRecalculateReceipts = scope.form.noRecalculateReceipts;
            } else {
              scope.noRecalculateReceipts = true;
            }
          } catch (err) {
            scope.noRecalculateReceipts = true;
            console.log("error recalculate", err);
          }
        } else {
          scope.noRecalculateReceipts = false;
        }
        scope.checkValue = function (parIndex, $event, param, parType) {
          switch (parType) {
            case 1:
              scope.poliza[param] = String(scope.poliza[param]).replace(
                /[A-Za-z]/,
                ""
              );
              scope.poliza[param] = String(scope.poliza[param]).replace(
                /,/g,
                ""
              );
              break;

            case 2:
              scope.receipts[parIndex][param] = String(
                scope.receipts[parIndex][param]
              ).replace(/[A-Za-z]/, "");
              scope.receipts[parIndex][param] = String(
                scope.receipts[parIndex][param]
              ).replace(/,/, "");
              break;

            default:
              break;
          }
        };

        scope.calculateInputs = function (param) {
          // letras y caracteres especiales
          // var letters = /^[A-Za-z]+$/;

          scope.poliza[param] = String(scope.poliza[param]).replace(
            /[A-Za-z]/g,
            ""
          );
          scope.poliza[param] = String(scope.poliza[param]).replace(/,/g, "");
          // scope.poliza.primaNeta = String(scope.poliza.primaNeta).replace(/[A-Za-z]/g, '');

          if (scope.poliza.descuento) {
            if (parseFloat(scope.poliza.descuento) > 100) {
              // alert('El porcentaje no puede ser mayor a 100');
              scope.poliza.descuento = 100;
              SweetAlert.swal(
                "Error",
                "El descuento no pude ser mayor al 100%.",
                "error"
              );
              return;
            }
          }

          if (!scope.poliza.primaNeta || scope.poliza.primaNeta == undefined) {
            var primaNeta_ = 0;
          } else {
            var primaNeta_ = parseFloat(scope.poliza.primaNeta);
          }

          if (!scope.poliza.descuento || scope.poliza.descuento == undefined) {
            var desceunto_importe = 0;
          } else {
            if (scope.poliza.aplicarDescuento) {
              var descuento_percent = parseInt(scope.poliza.descuento) / 100;
              var desceunto_importe = primaNeta_ * descuento_percent;
            } else {
              var desceunto_importe = 0;
            }
          }

          if (!scope.poliza.rpf || scope.poliza.rpf == undefined) {
            var rpf_ = 0;
          } else {
            var rpf_ = parseFloat(scope.poliza.rpf);
          }

          if (!scope.poliza.derecho || scope.poliza.derecho == undefined) {
            var derecho_ = 0;
          } else {
            var derecho_ = parseFloat(scope.poliza.derecho);
          }

          if (desceunto_importe == undefined) {
            desceunto_importe = 0;
          }

          var p_neta_descuento = primaNeta_ - desceunto_importe;

          var subtotal_ = p_neta_descuento + rpf_ + derecho_;
          var iva_importe = subtotal_ * 0.16;
          var primaTotal_ = subtotal_ + iva_importe;

          var ramo_code = scope.form.ramo.ramo_code;

          scope.poliza.primaTotal = primaTotal_.toFixed(2);

          if (ramo_code == 1) {
            scope.poliza.iva = 0;
            // scope.poliza.primaTotal = parseFloat(scope.poliza.subTotal).toFixed(2);
            scope.poliza.primaTotal = subtotal_;
          } else {
            if (scope.edited_iva) {
              scope.poliza.iva = scope.poliza.iva;
              scope.poliza.primaTotal = (
                parseFloat(scope.poliza.subTotal) + parseFloat(scope.poliza.iva)
              ).toFixed(2);
            } else {
              scope.poliza.iva = iva_importe.toFixed(2);
            }
          }

          if (
            isNaN(scope.poliza.subTotal) &&
            scope.poliza.subTotal !== undefined
          ) {
            scope.poliza.subTotal = 0;
          } else {
            scope.poliza.subTotal = subtotal_.toFixed(2);
          }
        };

        if (!scope.poliza) {
          scope.poliza = {};
        }

        scope.checkReceipts = function (parReceipts) {
          parReceipts.forEach(function (item) {
            if (item.status) {
              if (item.status > 4) {
                scope.recibo_liquidado_conciliado = true;
              }
            }
          });
        };

        if (scope.tosave.receipts) {
          scope.receipts = scope.tosave.receipts;

          // checa si tiene startDate y endingDate, si no, se agrega
          scope.receipts.forEach(function (item) {
            // console.log('item', item);

            if (item.prima_neta) {
              item.prima = item.prima_neta;
            }

            if (item.prima_total) {
              item.total = item.prima_total;
            }

            if (!item.startDate) {
              if (item.fecha_inicio) {
                item.startDate = datesFactory.convertDate(item.fecha_inicio);
              }
            }

            if (!item.endingDate) {
              if (item.fecha_fin) {
                item.endingDate = datesFactory.convertDate(item.fecha_fin);
              }
            }

            item.vencimiento = datesFactory.convertDate(item.vencimiento);
          });

          scope.showreceipts = true;
          if (scope.tosave.poliza) {
            scope.poliza = scope.tosave.poliza;
          }

          if (scope.type == 2) {
            // console.log('????????????????');
            scope.receipts.forEach(function (receipt, index) {
              // console.log('receipt_'+index, receipt);
              receipt.initDate = datesFactory.convertDate(receipt.fecha_inicio);
              receipt.endingDate = datesFactory.convertDate(receipt.fecha_fin);
              if (receipt.status == 5 || receipt.status == 6) {
                scope.active_calculate = false;
              }
            });
          }
        } else {
          scope.receipts = [];
          scope.showreceipts = false;
        }

        // console.log('poliza', scope.poliza);
        if (scope.poliza.subTotal) {
          scope.poliza.subTotal = parseFloat(scope.poliza.subTotal).toFixed(2);
        } else {
          if (scope.poliza.primaNeta) {
            // console.log('ok');
            scope.calculateInputs(scope.poliza);
          }
        }

        if (!scope.form) {
          if (scope.tosave.form) {
            var form = scope.tosave.form;
            if (!form.payment) {
              if (form.forma_de_pago) {
                if (form.forma_de_pago.value) {
                  form.payment = form.forma_de_pago;
                } else {
                  form.payment = {
                    value: form.forma_de_pago,
                  };
                }
              }
            } else {
              if (!form.payment.value) {
                form.payment = {
                  value: form.payment,
                };
              }
            }
          }
        } else {
          var form = scope.form;
        }

        if (!scope.poliza) {
          scope.poliza = {
            iva: 16,
            primaTotal: 0,
          };
        }

        if (scope.poliza.descuento) {
          var descuento_ = parseFloat(scope.poliza.descuento) / 100;
        } else {
          var descuento_ = 0;
        }

        var cantidad_desc = parseFloat(scope.poliza.primaNeta) * descuento_;
        scope.p_neta_desc =
          parseFloat(scope.poliza.primaNeta) - parseFloat(cantidad_desc);

        scope.calculateComision = function () {
          var prima_ = parseFloat(scope.poliza.primaNeta);
          var percent = parseFloat(form.comision_percent) / 100;
          if (scope.poliza.descuento) {
            var descuento_ = parseFloat(scope.poliza.descuento) / 100;

            var cantidad_descuento = parseFloat(prima_ * descuento_);
            var prima_descuento = prima_ - cantidad_descuento;

            scope.poliza.comision = (prima_ * percent).toFixed(2);
            scope.comision_desc = (prima_descuento * percent).toFixed(2);
          } else {
            // TODO: comision neta
            scope.poliza.comision = (prima_ * percent).toFixed(2);
            scope.comision_desc = 0;
          }
          // } else {
          //   // scope.poliza.descuento = 0;
          // }
        };

        if (scope.poliza.primaNeta == 0) {
          scope.poliza.primaNeta = 0;
        }

        if (scope.poliza.rpf == 0) {
          scope.poliza.rpf = 0;
        }

        if (scope.poliza.derecho == 0) {
          scope.poliza.derecho = 0;
        }

        if (scope.poliza.descuento == 0) {
          scope.poliza.descuento = 0;
        }

        scope.activarPP = function (param) {
          // console.log('pp', param);
          if (param) {
            scope.poliza.pp_percent_comision = null;
          }
        };

        scope.changeIva = function (poliza) {
          if (poliza.ivaStatus == true) {
            scope.calculate(poliza);
            var primaNeta = poliza.primaNeta;

            var desc = parseFloat(scope.poliza.descuento) * 0.01;
            var primaNetaDesc = primaNeta - primaNeta * desc;
            scope.poliza.iva = parseFloat(primaNetaDesc) * 0.16;

            poliza.iva = parseFloat(primaNetaDesc) * 0.16;
            var subTotal = poliza.subTotal;

            poliza.primaTotal = parseFloat(subTotal) + parseFloat(poliza.iva);
            scope.poliza.primaTotal = poliza.primaTotal.toFixed(2);

            scope.poliza.iva = parseFloat(poliza.iva);
            scope.poliza.iva = poliza.iva.toFixed(2);

            scope.calculateInputs(poliza);
          }
          if (poliza.ivaStatus == false) {
            scope.calculate(poliza);

            var primaNeta = poliza.primaNeta;

            var desc = parseFloat(scope.poliza.descuento) * 0.01;
            var primaNetaDesc = primaNeta - primaNeta * desc;

            scope.poliza.iva = parseFloat(primaNetaDesc) * 0.16;
            //Las pólizas que no sean de IVA llevan obligatorio el IVA
            //si el checkbox se manipula se pone en false y se hace lo mismo que en true
            poliza.iva = parseFloat(primaNetaDesc) * 0.16;
            var subTotal = poliza.subTotal;

            poliza.primaTotal = parseFloat(subTotal) - parseFloat(poliza.iva);
            scope.poliza.primaTotal = poliza.primaTotal.toFixed(2);

            scope.poliza.iva = parseFloat(poliza.iva);
            scope.poliza.iva = poliza.iva.toFixed(2);
            scope.calculateInputs(poliza);
          }
        };

        scope.showIva = true;

        scope.activarDescuento = function (value) {
          scope.calculateInputs();
          scope.calculate(scope.poliza);
        };

        scope.firstYear = function (value) {
          if (scope.first_year) {
            scope.first_year = false;
          } else {
            scope.first_year = true;
          }
        };

        scope.editIva = function (param) {
          scope.poliza[param] = String(scope.poliza[param]).replace(
            /^[A-Za-z]+$/,
            ""
          );

          scope.edited_iva = true;
          if (scope.poliza.iva) {
            var iva_edited = scope.poliza.iva;
          } else {
            var iva_edited = 0;
          }
          scope.poliza.primaTotal = (
            parseFloat(scope.poliza.subTotal) + parseFloat(iva_edited)
          ).toFixed(2);
        };

        scope.editPTotal = function () {
          scope.edited_ptotal = true;
          scope.ptotal_edited = angular.copy(scope.poliza.primaTotal);
        };

        scope.formatNumber = function (valor) {
          var nums = new Array();
          var simb = ",";

          if (!valor) {
            return;
          }

          if (typeof valor == "number") {
            return valor;
          } else {
            valor = valor.toString();
            nums = valor.split("");
            var long = nums.length - 1;
            var patron = 3;
            var prox = 2;
            var res = "";

            while (long > prox) {
              if (prox == 2) {
              } else {
                nums.splice(long - prox, 0, simb);
              }
              prox += patron;
            }
            nums.splice(0, 0);

            for (var i = 0; i <= nums.length - 1; i++) {
              res += nums[i];
            }

            return valor;
          }
        };

        scope.showInput = false;
        scope.canDeleteReceipts = false;
        scope.editTable = function (param) {
          if (scope.form.policy_days_duration < 365) {
            if (scope.receipts.length > 1) {
              scope.canDeleteReceipts = true;
            } else {
              scope.canDeleteReceipts = false;
            }
          } else {
            scope.canDeleteReceipts = false;
          }
          scope.editedReceipts = true;
          if (scope.showInput == false) {
            scope.showInput = true;
          } else {
            scope.showInput = false;
          }

          if (param) {
            SweetAlert.swal(
              "¡Atención!",
              "Revise la información de primas y fechas de cada recibo ya que pueden no ser exactas",
              "warning"
            );
            // fechas
            scope.receipts.forEach(function (obj) {
              // validar fechas de cada recibo
              // Fechas de inicio
              var date_obj_inicio = new Date(
                datesFactory.mesDiaAnio(obj.startDate)
              );
              var date_form_inicio = new Date(
                datesFactory.mesDiaAnio(form.startDate)
              );

              // Fechas de fin

              if (date_obj_inicio < date_form_inicio) {
                toaster.warning(
                  "La fecha de inició del recibo es menor a la fecha de inicio de la póliza."
                );
                obj.startDate = "";
                obj.fecha_inicio = "";
              }

              // fin
              var date_obj_fin = new Date(
                datesFactory.mesDiaAnio(obj.endingDate)
              );
              var date_form_fin = new Date(
                datesFactory.mesDiaAnio(form.endingDate)
              );

              // Fechas de fin

              if (date_obj_fin > date_form_fin && scope.type != 2) {
                toaster.warning(
                  "La fecha de fin del recibo es mayor a la fecha de fin de la póliza."
                );
                obj.endingDate = "";
                obj.fecha_fin = "";
              }
            });

            var demo = angular.copy(scope.receipts);

            demo.forEach(function (obj) {
              obj.recibo_numero = obj.recibo_numero;
              obj.prima_neta = parseFloat(obj.prima).toFixed(2);
              obj.rpf = parseFloat(obj.rpf).toFixed(2);
              obj.derecho = parseFloat(obj.derecho).toFixed(2);
              obj.iva = parseFloat(obj.iva).toFixed(2);
              obj.subTotal = parseFloat(obj.subTotal).toFixed(2);
              obj.prima_total = parseFloat(obj.total).toFixed(2);
              obj.total = parseFloat(obj.total).toFixed(2);
              obj.receipt_type = 1;
              obj.comision = parseFloat(obj.comision).toFixed(2);
              obj.fecha_inicio = obj.startDate;
              obj.vencimiento = obj.vencimiento
                ? obj.vencimiento
                : obj.startDate;
              obj.startDate = obj.startDate;
              obj.endingDate = obj.endingDate;
              obj.fecha_fin = obj.endingDate;
              obj.is_cat = obj.is_cat;
            });

            scope.tosave.recibos_poliza = demo;
            scope.tosave.receipts = demo;
          } else {
            scope.getValuesPoliza();
          }
          scope.getValuesPoliza();
        };

        // calculate
        function getSubtotal(parPoliza) {
          var sum =
            parseFloat(parPoliza.primaNeta) +
            parseFloat(parPoliza.rpf) +
            parseFloat(parPoliza.derecho);

          return Number(sum.toFixed(2));
        }

        scope.recalc_receipt = function (parReceipt, receipt_index) {
          var receipt_subtotal =
            parseFloat(parReceipt.prima) +
            parseFloat(parReceipt.rpf) +
            parseFloat(parReceipt.derecho);

          if (scope.form.ramo.ramo_code == 1) {
            parReceipt.iva = parseFloat(0).toFixed(2);
            parReceipt.total = parseFloat(receipt_subtotal).toFixed(2);
          } else {
            parReceipt.iva = parseFloat(receipt_subtotal * 0.16).toFixed(2);
            parReceipt.total = parseFloat(receipt_subtotal * 1.16).toFixed(2);
          }
        };

        scope.validateFloatKeyPress = function (
          e,
          parReceipt,
          receipt_index,
          parType
        ) {
          // enter
          if (e.keyCode == 13) {
            var rec_prima = parseFloat(parReceipt.prima);
            var rec_rpf = parseFloat(parReceipt.rpf);
            var rec_derecho = parseFloat(parReceipt.derecho);
            var rec_iva = parseFloat(parReceipt.iva);
            var rec_total = parseFloat(parReceipt.total);
            var rec_comision = parseFloat(parReceipt.comision);

            if (parReceipt.recibo_numero == 1) {
              scope.prima_restante =
                angular.copy(scope.prima_c_descuento) - rec_prima;
              scope.rpf_restante = angular.copy(scope.poliza.rpf) - rec_rpf;
              scope.derecho_restante =
                angular.copy(scope.poliza.derecho) - rec_derecho;
              scope.iva_restante = angular.copy(scope.poliza.iva) - rec_iva;
              scope.total_restante =
                angular.copy(parseFloat(scope.poliza.primaTotal)) - rec_total;
              // console.log('comision_importe', scope.comision_importe);
              scope.comision_restante =
                angular.copy(scope.comision_importe) - rec_comision;
            }

            if (parReceipt.recibo_numero > 1) {
              if (!isNaN(rec_prima)) {
                scope.prima_restante = scope.prima_restante - rec_prima;
              }
              if (!isNaN(rec_rpf)) {
                scope.rpf_restante = scope.rpf_restante - rec_rpf;
              }
              if (!isNaN(rec_derecho)) {
                scope.derecho_restante = scope.derecho_restante - rec_derecho;
              }
              if (!isNaN(rec_iva)) {
                scope.iva_restante = scope.iva_restante - rec_iva;
              }
              if (!isNaN(rec_total)) {
                scope.total_restante = scope.total_restante - rec_total;
              }
              if (!isNaN(rec_comision)) {
                scope.comision_restante =
                  scope.comision_restante - rec_comision;
              }
            }

            var receipts_lenght = angular.copy(scope.receipts.length);

            scope.receipts.forEach(function (rec_item, rec_item_index) {
              var item__ = rec_item_index + 1;

              if (item__ <= parReceipt.recibo_numero) {
                receipts_lenght = receipts_lenght - 1;

                if (item__ == parReceipt.recibo_numero) {
                  var prima___ = scope.new_prima_restante
                    ? scope.new_prima_restante
                    : scope.prima_restante;
                  scope.prima_x_recibo = prima___ / receipts_lenght;

                  var rpf__ = scope.rpf_restante;
                  scope.rpf_x_recibo = rpf__ / receipts_lenght;

                  var derecho__ = scope.derecho_restante;
                  scope.derecho_x_recibo = derecho__ / receipts_lenght;

                  var iva__ = scope.iva_restante;
                  scope.iva_x_recibo = iva__ / receipts_lenght;

                  var total__ = scope.total_restante;
                  scope.total_x_recibo = total__ / receipts_lenght;

                  var comision__ = scope.comision_restante;
                  scope.comision_x_recibo = comision__ / receipts_lenght;
                }
              } else {
                if (parType == 1) {
                  rec_item.prima = angular
                    .copy(scope.prima_x_recibo)
                    .toFixed(2);
                  rec_item.prima_neta = angular
                    .copy(scope.prima_x_recibo)
                    .toFixed(2);
                  scope.recalc_receipt(rec_item, rec_item_index);
                }

                rec_item.rpf = angular.copy(scope.rpf_x_recibo).toFixed(2);
                rec_item.derecho = angular
                  .copy(scope.derecho_x_recibo)
                  .toFixed(2);
                rec_item.iva = angular.copy(scope.iva_x_recibo).toFixed(2);
                if (parType == 5) {
                  rec_item.total = angular
                    .copy(scope.total_x_recibo)
                    .toFixed(2);
                } else if (parType == 6) {
                  rec_item.comision = angular
                    .copy(scope.comision_x_recibo)
                    .toFixed(2);
                }
              }
            });
          }
        };

        scope.getValuesPoliza = function () {
          // console.log('poliza', scope.poliza);

          var desc__ = angular.copy(parseFloat(scope.poliza.descuento));
          var prima_neta__ = angular.copy(parseFloat(scope.poliza.primaNeta));
          var desc_import__ = angular.copy(
            parseFloat(prima_neta__ / 100) * desc__
          );

          if (scope.form.comision) {
            scope.comision_importe = angular.copy(
              parseFloat(prima_neta__ / parseInt(scope.form.comision.comission))
            );
            // console.log('comision_importe', comision_importe);
          } else if (scope.form.comision_percent) {
            scope.comision_importe = angular.copy(
              parseFloat(prima_neta__ / parseFloat(scope.form.comision_percent))
            );
          }

          if (scope.poliza.aplicarDescuento) {
            scope.prima_c_descuento = angular.copy(
              prima_neta__ - desc_import__
            );
          } else {
            scope.prima_c_descuento = angular.copy(prima_neta__);
          }
          // console.log('aaa', scope.prima_c_descuento);
        };

        // diferencia entre fechas
        function monthDiff(d1, d2) {
          var months;
          months = (d2.getFullYear() - d1.getFullYear()) * 12;
          months -= d1.getMonth() + 1;
          months += d2.getMonth();
          return months <= 0 ? 0 : months;
        }

        function editar_fecha(fecha, intervalo) {
          // var separador = separador || "-";
          var separador = "/";
          var arrayFecha = fecha.split(separador);
          var dia = arrayFecha[0];
          var mes = arrayFecha[1];
          var anio = arrayFecha[2];

          var fechaInicial = new Date(anio, mes - 1, dia);
          var fechaFinal = fechaInicial;
          // if(dma=="m" || dma=="M"){
          fechaFinal.setMonth(fechaInicial.getMonth() + parseInt(intervalo));
          // }else if(dma=="y" || dma=="Y"){
          //   fechaFinal.setFullYear(fechaInicial.getFullYear()+parseInt(intervalo));
          // }else if(dma=="d" || dma=="D"){
          //   fechaFinal.setDate(fechaInicial.getDate()+parseInt(intervalo));
          // }else{
          //   return fecha;
          // }
          dia = fechaFinal.getDate();
          mes = fechaFinal.getMonth() + 1;
          anio = fechaFinal.getFullYear();

          dia = dia.toString().length == 1 ? "0" + dia.toString() : dia;
          mes = mes.toString().length == 1 ? "0" + mes.toString() : mes;

          return dia + "/" + mes + "/" + anio;
        }

        scope.delete_receipt = function (event, param, index, m) {
          // if (scope.permiso_delRecibo) {
          if (scope.receipts.length > 1) {
            if (!scope.tosave.delete_receitps) {
              scope.tosave.delete_receitps = [];
            }
            scope.tosave.delete_receitps.push(param);
            if (param.poliza) {
              scope.recPoliza = param.poliza;
            } else {
              scope.recPoliza = "";
            }

            scope.receipts.splice(index, 1);
          } else {
            SweetAlert.swal("Debe mantener por lo menos un recibo.");
          }
          // }else{
          //   SweetAlert.swal('No tiene permiso de eliminar recibos');
          // }
        };

        scope.add_receipt = function () {
          var new_receipt = {
            recibo_numero: scope.receipts.length + 1,
            prima_neta: 0,
            prima: 0,
            rpf: 0,
            derecho: 0,
            iva: "",
            subTotal: 0,
            prima_total: "",
            total: "",
            comision: "",
            receipt_type: 2,
            fecha_inicio: "",
            vencimiento: "",
            startDate: "",
            endingDate: "",
            fecha_fin: "",
            delivered: false,
          };
          scope.receipts.push(new_receipt);
        };

        scope.pp_percent_comision = null;

        function swalReceipts() {
          // if (scope.permiso_delRecibo) {
          SweetAlert.swal(
            {
              title: "¿Está seguro?",
              text: "Al recalcular el recibo de la fianza, perderá su información de pago ¿Está de acuerdo?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Si, estoy seguro.",
              cancelButtonText: "Cancelar",
              closeOnConfirm: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                scope.continue_1 = true;
                scope.calculate(scope.poliza);
              } else {
                scope.continue_ = false;
              }
            }
          );
          // }else{
          //   SweetAlert.swal('No tiene permiso de eliminar recibos, por lo que no puede recalcularlos');
          // }
        }

        scope.calculate = function (poliza) {
          scope.tosave.delete_receitps = [];
          // console.log('form', scope.form);
          SweetAlert.swal(
            "¡Atención!",
            "Revise la información de primas y fechas de cada recibo ya que pueden no ser exactas",
            "warning"
          );
          if (!scope.form.payment && scope.type !== 2) {
            SweetAlert.swal(
              "¡Cuidado!",
              "No has seleccionado una frecuencia de pago",
              "error"
            );
            return;
          }

          scope.continue_ = true;
          // for de recibos de fianza
          if (scope.type == 2 && scope.receipts.length) {
            for (var i in scope.receipts) {
              var item = scope.receipts[i];
              if (item.status == 1 && item.receipt_type == 1) {
                if (scope.continue_ && scope.continue_1) {
                } else {
                  swalReceipts();
                  scope.continue_ = false;
                }
              }
            }

            if (!scope.continue_) {
              return;
            }
          }

          // console.log('Calculando.......');
          if (scope.poliza.fy) {
            scope.first_year = true;
          }

          if (!scope.form.comision_percent) {
            scope.form.comision_percent = 0;
          }

          if (form.ceder_porcentaje) {
            var porcentaje_cedido = scope.tosave.give_comision;
            var porcentaje_final = 100 - parseInt(porcentaje_cedido);
          }

          // REVISAR SI ES O NO MULTIANUAL
          if (form.startDate && form.endingDate) {
            var date_1 = form.startDate.split("/");
            var date_2 = form.endingDate.split("/");
          }

          var anio_inicio = parseInt(date_1[2]);
          var anio_fin = parseInt(date_2[2]);

          // años de vigencia póliza
          var anios_vigencia = anio_fin - anio_inicio;

          if (form.payment == "1") {
            var total_recibos = 12;
          } else if (form.payment == "2") {
            var total_recibos = 6;
          } else if (form.payment == "3") {
            var total_recibos = 4;
          } else if (form.payment == "6") {
            var total_recibos = 2;
          } else if (form.payment == "12") {
            var total_recibos = 1;
          } else if (form.payment == "5") {
            var total_recibos = 1;
          }

          if (anios_vigencia > 1) {
            var total_recibos = total_recibos * anios_vigencia;
          }

          if (scope.poliza.descuento) {
            if (parseFloat(scope.poliza.descuento) > 100) {
              scope.poliza.descuento = 100;
              SweetAlert.swal(
                "Error",
                "El descuento no pude ser mayor al 100%.",
                "error"
              );

              return;
            }
          }

          if (form.policy_days_duration < 365) {
            scope.poliza_menor_anio = true;
          } else {
            scope.poliza_menor_anio = false;
          }

          if (scope.poliza.configDerecho || scope.poliza.configRPF) {
            if (scope.edited_iva) {
              SweetAlert.swal(
                "Los resultados en los recibos pueden no ser exactos, favor de revisarlos manualmente."
              );
            }
          }

          if (!scope.poliza.descuento) {
            scope.poliza.descuento = 0;
          }
          scope.poliza.aplicarDescuento = poliza.aplicarDescuento;
          if (poliza.aplicarDescuento) {
            var desc_percent = parseFloat(scope.poliza.descuento) / 100;
            var desc_importe =
              parseFloat(angular.copy(scope.poliza.prima)) *
              parseFloat(desc_percent);
          } else {
            var desc_importe = 0;
          }

          if (isNaN(desc_importe)) {
            desc_importe = 0;
          }

          if (poliza.aplicarDescuento) {
            desc_importe = 0;
          }

          poliza.prima = parseFloat(angular.copy(poliza.prima)) - desc_importe;
          poliza.rpf = poliza.rpf;
          poliza.derecho = poliza.derecho;
          scope.receipts = [];

          var ramo_code = scope.form.ramo.ramo_code;
          if (ramo_code == 1) {
            poliza.ivaStatus = false;
            scope.showIva = false;
            poliza.iva = 0.0;
            scope.poliza.iva = 0.0;
          } else {
            poliza.ivaStatus = true;
            scope.showIva = true;
          }
          if (scope.type == 2) {
            var form_ = 5;
          } else {
            if (!form.payment.value) {
              if (form.payment) {
                var form_ = form.payment;
              }
            } else {
              var form_ = form.payment.value;
            }
          }

          if (!poliza.derecho) {
            poliza.derecho = 0;
          }

          if (!poliza.rpf) {
            poliza.rpf = 0;
          }

          if (poliza.descuento) {
            var descuento_ = parseFloat(poliza.descuento) / 100;
          } else {
            var descuento_ = 0;
          }

          if (poliza.aplicarDescuento) {
            var desc_percent = parseFloat(poliza.descuento) / 100;
            var desc_importe =
              parseFloat(angular.copy(poliza.primaNeta)) *
              parseFloat(desc_percent);
            var cantidad_desc = parseFloat(poliza.primaNeta) - desc_importe;
          } else {
            var cantidad_desc = parseFloat(poliza.primaNeta);
          }

          scope.p_neta_desc = parseFloat(cantidad_desc);
          scope.subtotal_desc =
            parseFloat(scope.p_neta_desc) +
            parseFloat(poliza.rpf) +
            parseFloat(poliza.derecho);

          if (scope.edited_iva) {
            scope.iva_desc = scope.poliza.iva;
          } else {
            scope.iva_desc = parseFloat(scope.subtotal_desc) * 0.16;
          }
          scope.p_total_desc =
            parseFloat(scope.subtotal_desc) + parseFloat(scope.iva_desc);
          var prima_neta = parseFloat(poliza.primaNeta);
          var derecho = parseFloat(poliza.derecho);
          var rpf = parseFloat(poliza.rpf);

          if (!scope.edited_iva) {
            scope.poliza.iva = parseFloat(scope.iva_desc).toFixed(2);
          } else {
            scope.poliza.iva = parseFloat(scope.poliza.iva).toFixed(2);

            if (scope.edited_ptotal) {
              scope.poliza.primaTotal = scope.ptotal_edited;
            } else {
              scope.poliza.primaTotal = (
                parseFloat(scope.poliza.subTotal) + parseFloat(scope.poliza.iva)
              ).toFixed(2);
            }
          }

          scope.tosave.p_neta = prima_neta;
          scope.tosave.derecho = derecho;
          scope.tosave.rpf = rpf;
          if (scope.tosave.give_comision) {
            scope.tosave.give_comision.descuento = poliza.descuento
              ? poliza.descuento
              : 0;
          }

          if (scope.form.comision_percent && scope.poliza.primaNeta) {
            // console.log('asdkfklsd');
            var primaNeta = parseFloat(scope.poliza.primaNeta);
            var comision = parseFloat(scope.form.comision_percent);

            comision = parseFloat(comision / 100);

            scope.tosave.comision_currency = parseFloat(
              prima_neta * comision
            ).toFixed(2);
            scope.tosave.comision_currency = parseFloat(
              scope.tosave.comision_currency
            );
          }

          var IVA = 0;
          var TOTAL_IVA = 1;

          if (!scope.edited_iva) {
            var poliza_iva = scope.iva_desc;
          } else {
            var poliza_iva = parseFloat(scope.poliza.iva).toFixed(2);
          }

          scope.tosave.iva = parseFloat(poliza_iva).toFixed(2);

          poliza.iva = scope.tosave.iva;

          if (!form.payment || scope.type == 2) {
            if (scope.type !== 2) {
              toaster.info(MESSAGES.ERROR.SELPAY);
            } else {
              form.payment = 5;
              function getNumber(num) {
                var num2 = Math.ceil(num);
                return new Array(num2);
              }

              function getTotal(poliza) {
                if (scope.edited_ptotal) {
                  var p_total = parseFloat(scope.ptotal_edited);
                  poliza.primaTotal = parseFloat(scope.ptotal_edited);
                } else {
                  var p_total = parseFloat(scope.p_total_desc);
                }

                scope.tosave.p_total = p_total.toFixed(2);
                return parseFloat(p_total);
              }

              function getPrimaTotalReceipt(parObj, parAmonunts) {
                var prima_neta_ = parseFloat(parObj.prima);
                var subtotal_ =
                  parseFloat(prima_neta_) +
                  parseFloat(parObj.rpf) +
                  parseFloat(parObj.derecho);
                var iva_ = getIva(parObj, parAmonunts);

                if (scope.edited_ptotal) {
                  var prima_total_ = parseFloat(parObj.primaTotal);
                } else {
                  var prima_total_ = parseFloat(subtotal_ + parseFloat(iva_));
                }

                return prima_total_.toFixed(2);
              }

              function getIva(parValue, parAmonunts) {
                var prima_neta_ = parseFloat(parValue.prima);
                var subtotal_ =
                  parseFloat(prima_neta_) +
                  parseFloat(parValue.rpf) +
                  parseFloat(parValue.derecho);

                if (scope.edited_iva) {
                  var iva_ = parseFloat(scope.poliza.iva) / parAmonunts;
                } else {
                  var iva_ = subtotal_ * 0.16;
                }

                if (ramo_code == 1) {
                  var iva_ = 0.0;
                }

                return iva_.toFixed(2);
              }

              function comissionCalc(parPneta) {
                var p_neta_ = parPneta;

                if (form.comision_percent) {
                  var comision_ = parseFloat(form.comision_percent) / 100;
                } else if (form.comision) {
                  if (form.comision.comission) {
                    var comision_ = parseFloat(form.comision.comission) / 100;
                  } else if (form.comision_percent) {
                    var comision_ = parseFloat(form.comision_percent) / 100;
                  }
                } else {
                  var comision_ = 0;
                }

                if (form.ceder_comision) {
                  var comision_ = parseFloat(form.comision_percent) / 100;
                  scope.tosave.comision_percent = form.comision_percent;
                  if (!scope.tosave.comision) {
                    scope.tosave.comision = comision_;
                  }
                  scope.tosave.udi = form.comision_percent;
                }

                if (comision_) {
                  var res_comision_pol = parseFloat(
                    p_neta_ * comision_
                  ).toFixed(2);

                  if (form.ceder_porcentaje) {
                    var comision_ceder =
                      (100 - parseFloat(scope.tosave.give_comision)) / 100;
                    var res_comision_cedida =
                      parseFloat(res_comision_pol) * comision_ceder;
                    var result = res_comision_cedida;
                  } else {
                    var result = res_comision_pol;
                  }
                } else {
                  var result = poliza.comision;
                }

                scope.poliza.comision_insurance = parseFloat(result).toFixed(2);

                if (scope.type == 2) {
                  if (scope.poliza.pp) {
                    var pp_percent = parseFloat(
                      scope.poliza.pp_percent_comision
                    );
                    var new_comision = pp_percent / 100;
                    var fianzas_result = parseFloat(result * new_comision);

                    return fianzas_result.toFixed(2);
                  } else {
                    return result;
                  }
                } else {
                  return result;
                }
              }

              receipts = [];
              scope.showreceipts = true;
              if (form.startDate) {
                if (form.cambioPago) {
                  var initDate = new Date(form.start_of_validity);
                } else {
                  var initDate = new Date(
                    datesFactory.mesDiaAnio(form.startDate)
                  );
                }
              } else {
                var initDate = new Date(form.start_of_validity);
              }
              if (isNaN(initDate)) {
                initDate = new Date(form.startDate);
              }

              poliza.primaTotal = getTotal(poliza).toFixed(2);

              amountReceipts = Math.ceil(amountReceipts);

              if (form.payment == 5) {
                amountReceipts = 1;
                initDate = new Date(datesFactory.toDate(form.startDate));
                endDate = angular.copy(initDate);
                endDate = new Date(endDate.setYear(endDate.getFullYear() + 1));
              }

              var prima_neta_total = 0;
              var arrayLen = getNumber(amountReceipts);

              if (poliza.aplicarDescuento) {
                var percent_ = parseFloat(poliza.descuento) / 100;
                var importe_ = parseFloat(poliza.primaNeta) * percent_;
                var prima_ = parseFloat(poliza.primaNeta) - importe_;
              } else {
                var prima_ = parseFloat(poliza.primaNeta);
              }

              if (scope.edited_iva) {
                poliza.iva = scope.poliza.iva;
                poliza.primaTotal = scope.poliza.primaTotal;
              }
              var obj = {
                prima: prima_ / amountReceipts,
                rpf: poliza.rpf / amountReceipts,
                derecho: poliza.derecho / amountReceipts,
                iva: poliza.iva,
                subTotal: poliza.subTotal / amountReceipts,
                primaTotal: poliza.primaTotal / amountReceipts,
              };

              for (var i = 0; i < arrayLen.length; i++) {
                // Check options
                if (poliza.configDerecho) {
                  if (i === 0) {
                    if (poliza.derecho) {
                      obj.derecho = parseFloat(poliza.derecho);
                    } else {
                      obj.derecho = 0;
                    }
                  } else {
                    obj.derecho = 0;
                  }
                }

                if (poliza.configRPF) {
                  if (i === 0) {
                    if (poliza.rpf) {
                      obj.rpf = parseFloat(poliza.rpf);
                    } else {
                      obj.rpf = 0;
                    }
                  } else {
                    obj.rpf = 0;
                  }
                }

                var date_policy = new Date(datesFactory.toDate(form.startDate));
                var day_policy = date_policy.getDate();

                var date_receipt = new Date(initDate);
                var day_ = date_receipt.getDate();
                var month_ = date_receipt.getMonth() + 1;
                var year_ = date_receipt.getFullYear();

                function sumarDias(fecha, dias) {
                  fecha.setDate(fecha.getDate() + dias);
                  return fecha;
                }

                function sumMonths(parDate, parNum) {
                  var new_value = sumarDias(parDate, 1);
                  var new_month = parDate.setMonth(
                    new_value.getMonth() + parNum
                  );
                  var ok_value = sumarDias(new Date(new_month), -1);

                  return ok_value;
                }

                if (scope.type == 1) {
                  if (day_ !== day_policy) {
                    endDate = new Date(
                      new Date(year_, month_, day_policy)
                    ).setHours(11, 59, 59);
                  } else {
                    endDate = new Date(
                      new Date(moment(initDate).add(form_, "months")).setHours(
                        11,
                        59,
                        59
                      )
                    );
                  }
                }

                var subTotal = obj.prima + obj.rpf + obj.derecho;

                prima_neta_total + parseFloat(obj.prima.toFixed(2));

                var receipt = {
                  recibo_numero: i + 1,
                  prima_neta: parseFloat(obj.prima.toFixed(2)),
                  prima: parseFloat(obj.prima.toFixed(2)),
                  rpf: parseFloat(obj.rpf.toFixed(2)),
                  derecho: parseFloat(obj.derecho.toFixed(2)),
                  iva: getIva(obj, amountReceipts),
                  subTotal: parseFloat(subTotal.toFixed(2)),
                  prima_total: getPrimaTotalReceipt(obj, amountReceipts),
                  total: getPrimaTotalReceipt(obj, amountReceipts),
                  receipt_type: 1,
                  comision: parseFloat(
                    comissionCalc(parseFloat(obj.prima.toFixed(2)))
                  ),
                  delivered: false,
                };

                if (scope.form.domiciliado == "true") {
                  receipt.is_cat = true;
                }
                receipt.fecha_inicio = datesFactory.convertDate(initDate);
                receipt.vencimiento = datesFactory.convertDate(initDate)
                  ? datesFactory.convertDate(initDate)
                  : null;

                receipt.startDate = datesFactory.convertDate(initDate);
                receipt.endingDate = datesFactory.convertDate(endDate);
                receipt.fecha_fin = datesFactory.convertDate(endDate);

                initDate = new Date(endDate);

                scope.receipts.push(angular.copy(receipt));

                scope.tosave.poliza = scope.poliza;
                scope.tosave.recibos_poliza = scope.receipts;
                scope.tosave.receipts = scope.receipts;
              }

              if (ramo_code == 1) {
                poliza.ivaStatus = false;
                scope.showIva = false;
                poliza.iva = 0.0;
                scope.poliza.iva = 0.0;
                primaTotalNum = poliza.subTotal;
                primaTotalNum = parseFloat(primaTotalNum).toFixed(2);
                scope.poliza.primaNeta = scope.formatNumber(poliza.primaNeta);
                scope.poliza.rpf = scope.formatNumber(poliza.rpf);
                scope.poliza.derecho = scope.formatNumber(poliza.derecho);
                subTotalNum = poliza.subTotal;
                subTotalNum = parseFloat(subTotalNum).toFixed(2);
                scope.poliza.subTotal = scope.formatNumber(subTotalNum);
                scope.poliza.iva = scope.formatNumber(poliza.iva);

                if (scope.edited_ptotal) {
                  scope.poliza.primaTotal = scope.ptotal_edited;
                } else {
                  scope.poliza.primaTotal = scope.formatNumber(primaTotalNum);
                }

                //---------normal-------
              } else {
                poliza.ivaStatus = true;
                scope.showIva = true;
                scope.poliza.primaNeta = scope.formatNumber(poliza.primaNeta);
                scope.poliza.rpf = scope.formatNumber(poliza.rpf);
                scope.poliza.derecho = scope.formatNumber(poliza.derecho);
                subTotalNum = poliza.subTotal;
                subTotalNum = parseFloat(subTotalNum).toFixed(2);
                scope.poliza.subTotal = scope.formatNumber(subTotalNum);
                scope.poliza.iva = scope.formatNumber(poliza.iva);
                primaTotalNum = poliza.primaTotal;
                primaTotalNum = parseFloat(primaTotalNum).toFixed(2);
                if (scope.edited_ptotal) {
                  scope.poliza.primaTotal = scope.ptotal_edited;
                } else {
                  scope.poliza.primaTotal = scope.formatNumber(primaTotalNum);
                }
              }

              if (!scope.receipts[0].startDate) {
                toaster.warning("Agregar manualmente las fechas.");
              }
            }
          } else {
            function getNumber(num) {
              var num2 = Math.ceil(num);
              return new Array(num2);
            }

            function getTotal(poliza) {
              if (scope.edited_ptotal) {
                var p_total = parseFloat(scope.ptotal_edited);
                poliza.primaTotal = parseFloat(scope.ptotal_edited);
              } else {
                var p_total = parseFloat(scope.p_total_desc);
              }

              scope.tosave.p_total = p_total.toFixed(2);
              return parseFloat(p_total);
            }

            function getPrimaTotalReceipt(parObj, parAmonunts) {
              var prima_neta_ = parseFloat(parObj.prima);
              var subtotal_ =
                parseFloat(prima_neta_) +
                parseFloat(parObj.rpf) +
                parseFloat(parObj.derecho);
              var iva_ = getIva(parObj, parAmonunts);

              if (scope.edited_ptotal) {
                var prima_total_ = parseFloat(parObj.primaTotal);
              } else {
                var prima_total_ = parseFloat(subtotal_ + parseFloat(iva_));
              }

              return prima_total_.toFixed(2);
            }

            function getIva(parValue, parAmonunts) {
              var prima_neta_ = parseFloat(parValue.prima);
              var subtotal_ =
                parseFloat(prima_neta_) +
                parseFloat(parValue.rpf) +
                parseFloat(parValue.derecho);

              if (scope.edited_iva) {
                var iva_ = parseFloat(scope.poliza.iva) / parAmonunts;
              } else {
                var iva_ = subtotal_ * 0.16;
              }

              if (ramo_code == 1) {
                var iva_ = 0.0;
              }

              return iva_.toFixed(2);
            }

            function comissionCalc(parPneta) {
              scope.accesos = $sessionStorage.permisos;
              if (scope.accesos) {
                scope.accesos.forEach(function (perm) {
                  if (perm.model_name == "Comisiones") {
                    scope.acceso_dash = perm;
                    scope.acceso_dash.permissions.forEach(function (acc) {
                      if (acc.permission_name == "Comisiones") {
                        if (acc.checked == true) {
                          scope.permiso_comisiones = true;
                        } else {
                          scope.permiso_comisiones = false;
                        }
                      }
                    });
                  }
                });
              }
              var p_neta_ = parPneta;

              if (scope.tosave.comision) {
                // var comision_ = scope.tosave.comision;
              } else {
                var comision_ = parseFloat(form.comision_percent) / 100;

                if (form.comision_percent) {
                  var comision_ = parseFloat(form.comision_percent) / 100;
                } else if (form.comision) {
                  if (form.comision.comission) {
                    var comision_ = parseFloat(form.comision.comission) / 100;
                  } else if (form.comision_percent) {
                    var comision_ = parseFloat(form.comision_percent) / 100;
                  }
                } else {
                  var comision_ = 0;
                }
              }

              if (form.ceder_comision) {
                scope.tosave.comision_percent = form.comision_percent;
                var comision_ = parseFloat(form.comision_percent) / 100;
                scope.tosave.comision = comision_;

                scope.tosave.udi = form.comision_percent;
              }

              if (comision_ || comision_ == 0) {
                var res_comision_pol = parseFloat(p_neta_ * comision_).toFixed(
                  2
                );

                if (form.ceder_porcentaje) {
                  var comision_ceder =
                    (100 - parseFloat(scope.tosave.give_comision)) / 100;
                  var res_comision_cedida =
                    parseFloat(res_comision_pol) * comision_ceder;
                  var result = res_comision_cedida;
                } else {
                  var result = res_comision_pol;
                }
              } else {
                var result = poliza.comision;
              }

              scope.poliza.comision_insurance = parseFloat(result).toFixed(2);

              if (scope.type == 2) {
                // result es el 100%
                if (scope.poliza.pp) {
                  // scope.poliza.pp_percent_comision
                  var pp_percent = parseFloat(scope.poliza.pp_percent_comision);
                  var new_comision = pp_percent / 100;
                  var fianzas_result = parseFloat(result * new_comision);

                  return fianzas_result.toFixed(2);
                } else {
                  return result;
                }
              } else {
                return parseFloat(result).toFixed(2);
              }
            }

            // Termina calcComission

            receipts = [];
            scope.showreceipts = true;
            if (form.startDate) {
              if (form.cambioPago) {
                var initDate = new Date(form.start_of_validity);
              } else {
                var initDate = new Date(
                  datesFactory.mesDiaAnio(form.startDate)
                );
              }
            } else {
              var initDate = new Date(form.start_of_validity);
            }
            if (form.endingDate) {
              var endDate = new Date(datesFactory.mesDiaAnio(form.endingDate));
            } else {
              var endDate = new Date(form.end_of_validity);
            }

            if (isNaN(initDate)) {
              initDate = new Date(form.startDate);
            }

            if (isNaN(endDate)) {
              endDate = new Date(form.endingDate);
            }

            var months = helpers.monthDiff(initDate, endDate);

            // Calculate diff between dates
            var dateDiff = moment(endDate).diff(moment(initDate), "days");
            var amountReceipts = months / form_;

            /* Solución a recibos en el mismo mes*/
            if (amountReceipts == 0) {
              amountReceipts = 1;
            }

            poliza.primaTotal = getTotal(poliza).toFixed(2);

            amountReceipts = Math.ceil(amountReceipts);

            if (form.payment == 5) {
              amountReceipts = 1;

              initDate = new Date(datesFactory.toDate(form.startDate));
              endDate = new Date(datesFactory.toDate(form.endingDate));
            } else if (form.payment.value == 5) {
              amountReceipts = 1;

              initDate = new Date(datesFactory.toDate(form.startDate));
              endDate = new Date(datesFactory.toDate(form.endingDate));
            }

            // console.log('initDate', initDate);

            var prima_neta_total = 0;
            var arrayLen = getNumber(amountReceipts);
            // Logic from vm

            if (poliza.aplicarDescuento) {
              var percent_ = parseFloat(poliza.descuento) / 100;
              var importe_ = parseFloat(poliza.primaNeta) * percent_;
              var prima_ = parseFloat(poliza.primaNeta) - importe_;
            } else {
              var prima_ = parseFloat(poliza.primaNeta);
            }

            if (scope.edited_iva) {
              poliza.iva = scope.poliza.iva;
              poliza.primaTotal = scope.poliza.primaTotal;
            }

            function amountFirstReceipt(parAmount) {
              if (parAmount) {
                var value_ = parseFloat(parAmount);
                return value_;
              } else {
                return 0;
              }
            }

            var obj = {
              // prima: poliza.primaNeta / amountReceipts,
              prima: prima_ / amountReceipts,
              rpf: poliza.rpf / amountReceipts,
              derecho: poliza.derecho / amountReceipts,
              iva: poliza.iva,
              subTotal: poliza.subTotal / amountReceipts,
              primaTotal: poliza.primaTotal / amountReceipts,
            };

            function pad(d) {
              return d < 10 ? "0" + d.toString() : d.toString();
            }

            for (var i = 0; i < arrayLen.length; i++) {
              var start_date = form.startDate.split("/");
              var year_initDate = new Date(initDate).getFullYear();
              var month_initDate = pad(new Date(initDate).getMonth() + 1);
              var day_initDate = pad(new Date(initDate).getDate());
              var date_init =
                day_initDate + "/" + month_initDate + "/" + year_initDate;
              var date_end =
                start_date[0] +
                "/" +
                start_date[1] +
                "/" +
                String(parseInt(start_date[2]) + 1);

              // console.log('first_year', scope.first_year);
              if (scope.first_year) {
                // console.log('first_year');
                if (anios_vigencia > 1) {
                  if (date_init == date_end) {
                    break;
                  }
                }
              }

              if (poliza.configDerecho) {
                if (scope.poliza_menor_anio) {
                  if (i == arrayLen.length - 1) {
                    obj.derecho = amountFirstReceipt(poliza.derecho);
                  } else {
                    obj.derecho = 0;
                  }
                } else {
                  if (i == 0) {
                    obj.derecho = amountFirstReceipt(poliza.derecho);
                  } else {
                    obj.derecho = 0;
                  }
                }
              }

              if (poliza.configRPF) {
                if (scope.poliza_menor_anio) {
                  if (i == arrayLen.length - 1) {
                    obj.rpf = amountFirstReceipt(poliza.rpf);
                  } else {
                    obj.rpf = 0;
                  }
                } else {
                  if (i == 0) {
                    obj.rpf = amountFirstReceipt(poliza.rpf);
                  } else {
                    obj.rpf = 0;
                  }
                }
              }

              var date_policy = new Date(datesFactory.toDate(form.startDate));
              var day_policy = date_policy.getDate();

              var date_receipt = new Date(initDate);
              var day_ = date_receipt.getDate();
              var month_ = date_receipt.getMonth() + 1;
              var year_ = date_receipt.getFullYear();

              function sumarDias(fecha, dias) {
                fecha.setDate(fecha.getDate() + dias);
                return fecha;
              }

              function sumMonths(parDate, parNum) {
                var new_value = sumarDias(parDate, 1);
                var new_month = parDate.setMonth(new_value.getMonth() + parNum);
                var ok_value = sumarDias(new Date(new_month), -1);

                return ok_value;
              }

              if (day_ !== day_policy) {
                var date_1 = new Date(year_, month_, day_policy);
                var date_2 = new Date(
                  year_,
                  date_receipt.getMonth() + form_,
                  0
                );

                if (
                  day_policy == 31 ||
                  day_policy == 30 ||
                  day_policy == 28 ||
                  day_policy == 29
                ) {
                  var day__ = 0;
                  var month___ = date_receipt.getMonth() + parseInt(form_) + 1;
                  if (day_policy == 30) {
                    day__ = 30;
                    month___ = date_receipt.getMonth() + parseInt(form_);
                  } else if (day_policy == 28) {
                    day__ = 28;
                    month___ = date_receipt.getMonth() + parseInt(form_);
                  } else if (day_policy == 29) {
                    day__ = 29;
                    month___ = date_receipt.getMonth() + parseInt(form_);
                  }

                  endDate = new Date(new Date(year_, month___, day__)).setHours(
                    11,
                    59,
                    59
                  );
                } else {
                  endDate = new Date(
                    new Date(year_, month_, day_policy)
                  ).setHours(11, 59, 59);
                }
              } else {
                endDate = new Date(
                  new Date(moment(initDate).add(form_, "months")).setHours(
                    11,
                    59,
                    59
                  )
                );
              }

              var subTotal = obj.prima + obj.rpf + obj.derecho;

              prima_neta_total + parseFloat(obj.prima.toFixed(2));

              if (scope.poliza_menor_anio) {
                var receipt = {
                  recibo_numero: arrayLen.length - i,
                  prima_neta: parseFloat(obj.prima.toFixed(2)),
                  prima: parseFloat(obj.prima.toFixed(2)),
                  rpf: parseFloat(obj.rpf.toFixed(2)),
                  derecho: parseFloat(obj.derecho.toFixed(2)),
                  iva: getIva(obj, amountReceipts),
                  subTotal: parseFloat(subTotal.toFixed(2)),
                  prima_total: getPrimaTotalReceipt(obj, amountReceipts),
                  total: getPrimaTotalReceipt(obj, amountReceipts),
                  receipt_type: 1,
                  comision: parseFloat(
                    comissionCalc(parseFloat(obj.prima.toFixed(2)))
                  ),
                  delivered: false,
                };

                if (scope.domiciliado == "true") {
                  receipt.is_cat = true;
                }

                var pay_form_ = String(form.payment);

                if (pay_form_ !== "5" || pay_form_ !== "12") {
                  if (i == 0) {
                    endDate = form.endingDate;
                    initDate = editar_fecha(form.endingDate, -form_);
                  } else {
                    endDate = initDate;
                    initDate = editar_fecha(endDate, -form_);
                    if (i + 1 == arrayLen.length) {
                      initDate = form.startDate;
                    }
                  }
                }

                var init__ = datesFactory.toDate(initDate);
                var init_policy__ = datesFactory.toDate(form.startDate);

                if (pay_form_ !== "5" || pay_form_ !== "12") {
                  if (init__.getTime() < init_policy__.getTime()) {
                    initDate = form.startDate;
                  } else if (arrayLen.length == 1) {
                    initDate = form.startDate;
                  }
                } else {
                  initDate = form.startDate;
                }

                if (receipt.recibo_numero == 1) {
                  var vencimiento = sumarDias(
                    angular.copy(datesFactory.toDate(initDate)),
                    30
                  );
                  var vencimiento_date = datesFactory.convertDate(vencimiento);
                } else {
                  var vencimiento_date = initDate;
                }

                receipt.startDate = initDate;
                receipt.endingDate = endDate;
                receipt.vencimiento = vencimiento_date;

                scope.receipts.unshift(receipt);
                endDate = receipt.startDate;
              } else {
                var receipt = {
                  recibo_numero: i + 1,
                  prima_neta: parseFloat(obj.prima.toFixed(2)),
                  prima: parseFloat(obj.prima.toFixed(2)),
                  rpf: parseFloat(obj.rpf.toFixed(2)),
                  derecho: parseFloat(obj.derecho.toFixed(2)),
                  iva: getIva(obj, amountReceipts),
                  subTotal: parseFloat(subTotal.toFixed(2)),
                  prima_total: getPrimaTotalReceipt(obj, amountReceipts),
                  total: getPrimaTotalReceipt(obj, amountReceipts),
                  receipt_type: 1,
                  comision: comissionCalc(parseFloat(obj.prima.toFixed(2))),
                  delivered: false,
                };
                if (scope.form.domiciliado == "true") {
                  receipt.is_cat = true;
                }

                if (receipt.recibo_numero == 1) {
                  var vencimiento_date = sumarDias(angular.copy(initDate), 30);
                }

                receipt.fecha_inicio = datesFactory.convertDate(initDate);

                if (receipt.recibo_numero == 1) {
                  receipt.vencimiento = datesFactory.convertDate(
                    vencimiento_date
                  )
                    ? datesFactory.convertDate(vencimiento_date)
                    : null;
                } else {
                  receipt.vencimiento = datesFactory.convertDate(initDate)
                    ? datesFactory.convertDate(initDate)
                    : null;
                }

                receipt.startDate = datesFactory.convertDate(initDate);
                receipt.endingDate = datesFactory.convertDate(endDate);
                receipt.fecha_fin = datesFactory.convertDate(endDate);

                if (form.payment == 5 || form.payment.value == 5) {
                  receipt.fecha_inicio = form.startDate;
                  receipt.startDate = form.startDate;
                  receipt.endingDate = form.endingDate;
                  receipt.fecha_fin = form.endingDate;
                  receipt.vencimiento = receipt.vencimiento
                    ? receipt.vencimiento
                    : form.startDate;
                }

                initDate = new Date(endDate);

                scope.receipts.push(angular.copy(receipt));
              }

              scope.tosave.poliza = scope.poliza;
              scope.tosave.recibos_poliza = scope.receipts;
              scope.tosave.receipts = scope.receipts;
            }

            var date = form.endingDate.split("/");
            var date2 = form.startDate.split("/");

            if (anios_vigencia >= 1) {
              var original_endYear = parseInt(date[2]) + (anios_vigencia - 1);
              var original_endDate =
                date[0] + "/" + date[1] + "/" + String(original_endYear);
            }

            if (form.ceder_porcentaje) {
              var percent_comision = porcentaje_final / 100;
              poliza.comision = parseFloat(poliza.comision) * percent_comision;
            } else if (form.comision) {
              if (form.comision.comission) {
                var percent_comision =
                  parseFloat(form.comision.comission) / 100;
                poliza.comision =
                  parseFloat(scope.poliza.primaNeta) * percent_comision;
              } else {
                poliza.comision = 0;
              }
            } else {
              poliza.comision = 0;
            }

            poliza.comision = poliza.comision.toFixed(2);

            if (ramo_code == 1) {
              poliza.ivaStatus = false;
              scope.showIva = false;
              poliza.iva = 0.0;
              scope.poliza.iva = 0.0;
              primaTotalNum = poliza.subTotal;
              primaTotalNum = parseFloat(primaTotalNum).toFixed(2);
              scope.poliza.primaNeta = scope.formatNumber(poliza.primaNeta);
              scope.poliza.rpf = scope.formatNumber(poliza.rpf);
              scope.poliza.derecho = scope.formatNumber(poliza.derecho);
              subTotalNum = poliza.subTotal;
              subTotalNum = parseFloat(subTotalNum).toFixed(2);
              scope.poliza.subTotal = scope.formatNumber(subTotalNum);
              scope.poliza.iva = scope.formatNumber(poliza.iva);
              scope.poliza.primaTotal = scope.formatNumber(primaTotalNum);

              //---------normal-------
            } else {
              poliza.ivaStatus = true;
              scope.showIva = true;
              scope.poliza.primaNeta = scope.formatNumber(poliza.primaNeta);
              scope.poliza.rpf = scope.formatNumber(poliza.rpf);
              scope.poliza.derecho = scope.formatNumber(poliza.derecho);
              subTotalNum = poliza.subTotal;
              subTotalNum = parseFloat(subTotalNum).toFixed(2);
              scope.poliza.subTotal = scope.formatNumber(subTotalNum);
              scope.poliza.iva = scope.formatNumber(poliza.iva);
              primaTotalNum = poliza.primaTotal;
              primaTotalNum = parseFloat(primaTotalNum).toFixed(2);
              scope.poliza.primaTotal = scope.formatNumber(primaTotalNum);
            }

            if (!scope.receipts[0].startDate) {
              toaster.warning("Agregar manualmente las fechas.");
            }

            if (scope.form.ramo.ramo_code == 1) {
              scope.tosave.iva = 0;
              scope.tosave.p_total = scope.poliza.primaTotal;
            }
          }
        };
      },
    };
  },
]);

var app = angular
  .module("inspinia")
  .directive("autocomplete", [
    function () {
      return {
        restrict: "EA",
        scope: {
          model: "=",
          datasource: "=",
          url: "@",
          typeaheadOnSelect: "=",
          change: "&",
          id: "@",
          required: "=",
        },
        // template: '<div class="autocomplete-container" focusout="hideMenu()">' +
        //             '<input id="id"  class="form-control col-sm-12" ng-change="onChange()" ng-model="model.val" type="text" ng-required="required">' +
        //             '<ul ng-if="showData" ng-hide="!datasource.length" class="ul-content">' +
        //               '<li ng-repeat="item in datasource" class="item-list" ng-mousedown="select_item(item)" >' +
        //                 '<a class="list-item-text"> {{ item.label }} </a>' +
        //               '</li>' +
        //           '  </ul>' +
        //           '</div>',
        // template: '<div class="autocomplete-container" focusout="hideMenu()">' +
        //             '<input id="id"  class="form-control col-sm-12" ng-change="onChange()" ng-model="model.val" type="text" ng-required="required">' +
        //             '<ul ng-if="showData" ng-hide="!datasource.length" class="ul-content">' +
        //               '<li ng-repeat="item in datasource" class="item-list" ng-mousedown="select_item(item)" >' +
        //                 '<a class="list-item-text" style="background:{{}}"> {{ item.label }} </a>' +
        //               '</li>' +
        //           '  </ul>' +
        //           '</div>',
        template:
          '<div class="autocomplete-container" ng-focusout="hideMenu()">' +
          '<input id="{{uniqueId}}" class="form-control col-sm-12" ' +
          'ng-change="onChange()" ' +
          'ng-model="model.val" ' +
          'type="text" ' +
          'ng-required="required">' +
          '<ul ng-if="showData" ng-hide="!datasource.length" class="ul-content">' +
          '<li ng-repeat="item in datasource" class="item-list" ng-mousedown="select_item(item)">' +
          '<a class="list-item-text">{{ item.label }}</a>' +
          "</li>" +
          "</ul>" +
          "</div>",
        link: function (scope, element, $watch) {
          var count = 0;
          scope.uniqueId =
            "autocomplete-" + Math.random().toString(36).substr(2, 9);

          $("#id").keydown(function () {
            if (scope.datasource) {
              if (event.keyCode == 40) {
                //abajo
                if (count < scope.datasource.length) {
                  console.log(scope.datasource[count]);
                  var bgc = { background: "#1b84c7" };
                  count += 1;
                }
              } else if (event.keyCode == 38) {
                //arriba
                if (count > 1) {
                  count -= 1;
                  console.log(scope.datasource[count - 1]);
                }
              } else if (event.keyCode == 9) {
                scope.model.id = scope.datasource[count - 1].id;
                scope.model.val = scope.datasource[count - 1].label;
                scope.model.value = scope.datasource[count - 1].value;
                scope.showData = false;
              }
            }
          });

          scope.onChange = function () {
            scope.change();
            scope.showData = true;
          };

          scope.hideMenu = function () {
            scope.showData = false;
          };

          scope.select_item = function (parItem) {
            if (parItem) {
              scope.showData = false;
              scope.model.val = parItem.label;
              scope.model.value = parItem.value;
              if (parItem.id) {
                scope.model.id = parItem.id;
              }
              if (parItem.document_type) {
                scope.model.document_type = parItem.document_type;
              }
              if (parItem.type) {
                scope.model.type = parItem.type;
              }
              if (parItem.url) {
                scope.model.url = parItem.url;
              }
              if (parItem.subgrupos) {
                scope.model.subgrupos = parItem.subgrupos;
              }
              scope.datasource.length = 0;
            } else {
              scope.showData = false;
            }
          };
        },
      };
    },
  ])
  .directive("focusout", [
    "$parse",
    function ($parse) {
      return {
        compile: function ($element, attr) {
          var fn = $parse(attr.focusout);
          return function handler(scope, element) {
            element.on("focusout", function (event) {
              scope.$apply(function () {
                fn(scope, { $event: event });
              });
            });
          };
        },
      };
    },
  ]);

var app = angular.module("inspinia");

app._areas = {};
app.areaid = -1;
app.directive("ngAreas", [
  "$parse",
  function ($parse, $scope) {
    return {
      restrict: "A",

      link: function ($scope, $element, $attrs) {
        var imageSelectAreas = function () {};
        var mainImageSelectAreas = new imageSelectAreas();
        var allow =
          typeof $attrs.ngAreasAllow === "undefined"
            ? {}
            : eval("(" + $attrs.ngAreasAllow + ")");
        var getParameters = function () {
          $scope.ngAreas_areas = $scope.$eval($attrs.ngAreas);
          return {
            width:
              typeof $attrs.ngAreasWidth === "undefined"
                ? 800
                : $attrs.ngAreasWidth,
            areas:
              typeof $attrs.ngAreas === "undefined" ? [] : $scope.ngAreas_areas,
            onLoaded:
              typeof $attrs.ngAreasOnLoad === "undefined"
                ? null
                : $scope.$eval($attrs.ngAreasOnLoad),
            onAdd:
              typeof $attrs.ngAreasOnAdd === "undefined"
                ? null
                : $scope.$eval($attrs.ngAreasOnAdd),
            onDelete:
              typeof $attrs.ngAreasOnRemove === "undefined"
                ? null
                : $scope.$eval($attrs.ngAreasOnRemove),
            onChanged:
              typeof $attrs.ngAreasOnChange === "undefined"
                ? null
                : $scope.$eval($attrs.ngAreasOnChange),
            allowEdit: typeof allow.edit === "undefined" ? true : allow.edit,
            allowMove: typeof allow.move === "undefined" ? true : allow.move,
            allowResize:
              typeof allow.resize === "undefined" ? true : allow.resize,
            allowSelect:
              typeof allow.select === "undefined" ? true : allow.select,
            allowDelete:
              typeof allow.remove === "undefined" ? true : allow.remove,
            allowNudge: typeof allow.nudge === "undefined" ? true : allow.nudge,
          };
        };
        var destroy = function () {
          console.log("ngAreas:destroy");
          mainImageSelectAreas.destroy();
        };

        var reload = function () {
          console.log("ngAreas:reload");
          mainImageSelectAreas.init($element, getParameters());
          console.log("global Areas: " + JSON.stringify(app._areas));
        };

        var renameByAreaId = function (event, args) {
          var areaid = args.areaid;
          var name = args.name;
          mainImageSelectAreas.renameArea(areaid, name);
          $(".name-area-id-" + areaid).html(name);
        };

        $scope.$on("ngAreas:reload", reload);

        $scope.$on("ngAreas:reset", function (event) {
          mainImageSelectAreas.reset();
        });

        $scope.$on("ngAreas:destroy", destroy);

        $scope.$on("ngAreas:renameByAreaId", renameByAreaId);

        $element.css("display", "none");
        $element.bind("load", function () {
          mainImageSelectAreas.init($element, getParameters());
          $element.css("display", "block");
        });

        $element.bind("error", function () {
          $.error("Method " + customOptions + " on load error");
        });

        $scope.imageArea = function (parent, areaid) {
          if (!$scope.name_for_new_tag) return;
          var options = parent.options,
            $image = parent.$image,
            $trigger = parent.$trigger,
            $outline,
            $selection,
            $resizeHandlers = {},
            $btDelete,
            resizeHorizontally = true,
            resizeVertically = true,
            selectionOffset = [0, 0],
            selectionOrigin = [0, 0],
            area = $.extend(
              {
                areaid: areaid,
                x: 0,
                y: 0,
                z: 0,
                height: 0,
                width: 0,
                name: $scope.name_for_new_tag,
                cssClass: "class_blue",
              },
              typeof $attrs.ngAreasExtendData === "undefined"
                ? {}
                : $scope.$eval($attrs.ngAreasExtendData)
            ),
            blur = function () {
              area.z = 0;
              refresh("blur");
            },
            focus = function () {
              parent.blurAll();
              area.z = 100;
              refresh();
            },
            getData = function () {
              return area;
            },
            fireEvent = function (event) {
              $image.trigger(event, [parent.removeRatio(area), parent.areas()]);
            },
            cancelEvent = function (e) {
              var event = e || window.event || {};
              event.cancelBubble = true;
              event.returnValue = false;
              event.stopPropagation && event.stopPropagation(); // jshint ignore: line
              event.preventDefault && event.preventDefault(); // jshint ignore: line
            },
            off = function () {
              $.each(arguments, function (key, val) {
                on(val);
              });
            },
            on = function (type, handler) {
              var browserEvent, mobileEvent;
              switch (type) {
                case "start":
                  browserEvent = "mousedown";
                  mobileEvent = "touchstart";
                  break;
                case "move":
                  browserEvent = "mousemove";
                  mobileEvent = "touchmove";
                  break;
                case "stop":
                  browserEvent = "mouseup";
                  mobileEvent = "touchend";
                  break;
                default:
                  return;
              }
              if (handler && jQuery.isFunction(handler)) {
                $(window.document)
                  .on(browserEvent, handler)
                  .on(mobileEvent, handler);
              } else {
                $(window.document).off(browserEvent).off(mobileEvent);
              }
            },
            updateSelection = function () {
              // Update the outline layer
              $outline.addClass(area.cssClass);
              $outline.css({
                cursor: "default",
                width: area.width,
                height: area.height,
                left: area.x - 3,
                top: area.y - 3,
              });

              // Update the selection layer
              $selection.addClass(area.cssClass);

              $selection.css({
                backgroundPosition: -area.x - 1 + "px " + (-area.y - 1) + "px",
                cursor: options.allowMove ? "move" : "default",
                width: area.width - 2 > 0 ? area.width - 2 : 0,
                height: area.height - 2 > 0 ? area.height - 2 : 0,
                left: area.x - 2,
                top: area.y - 2,
                "z-index": area.z + 2,
              });
              $name = $($selection)
                .empty()
                .append(
                  $(
                    '<div><span class="select-area-field-label ' +
                      area.cssClass +
                      " border-thin name-area-id-" +
                      area.areaid +
                      '">' +
                      area.name +
                      "</span></div>"
                  )
                );
            },
            updateResizeHandlers = function (show) {
              if (!options.allowResize) {
                return;
              }
              if (show) {
                $.each($resizeHandlers, function (name, $handler) {
                  var top,
                    left,
                    semiwidth = Math.round($handler.width() / 2),
                    semiheight = Math.round($handler.height() / 2),
                    vertical = name[0],
                    horizontal = name[name.length - 1];

                  if (vertical === "n") {
                    // ====== North* ======
                    top = -semiheight - 10;
                  } else if (vertical === "s") {
                    // ====== South* ======
                    top = area.height - semiheight - 1;
                  } else {
                    // === East & West ===
                    top = Math.round(area.height / 2) - semiheight - 1;
                  }

                  if (horizontal === "e") {
                    // ====== *East ======
                    left = area.width - semiwidth - 1;
                  } else if (horizontal === "w") {
                    // ====== *West ======
                    left = -semiwidth - (semiwidth > 20 ? 10 : 5);
                  } else {
                    // == North & South ==
                    left = Math.round(area.width / 2) - semiwidth - 1;
                  }

                  $handler.css({
                    display: "block",
                    left: area.x + left,
                    top: area.y + top,
                    "z-index": area.z + 1,
                  });
                });
              } else {
                $(".select-areas-resize-handler").each(function () {
                  $(this).css({ display: "none" });
                });
              }
            },
            updateBtDelete = function (visible) {
              if ($btDelete) {
                $btDelete.css({
                  display: visible ? "block" : "none",
                  left: area.x + area.width + 1,
                  top: area.y - $btDelete.outerHeight() - 1,
                  "z-index": area.z + 1,
                });
              }
            },
            updateCursor = function (cursorType) {
              $outline.css({
                cursor: cursorType,
              });

              $selection.css({
                cursor: cursorType,
              });
            },
            refresh = function (sender) {
              switch (sender) {
                case "startSelection":
                  parent._refresh();
                  updateSelection();
                  updateResizeHandlers();
                  updateBtDelete(true);
                  break;

                case "pickSelection":
                case "pickResizeHandler":
                  updateResizeHandlers();
                  break;

                case "resizeSelection":
                  updateSelection();
                  updateResizeHandlers();
                  updateCursor("crosshair");
                  updateBtDelete(true);
                  break;

                case "moveSelection":
                  updateSelection();
                  updateResizeHandlers();
                  updateCursor("move");
                  updateBtDelete(true);
                  break;

                case "blur":
                  updateSelection();
                  updateResizeHandlers();
                  updateBtDelete();
                  break;

                //case "releaseSelection":
                default:
                  updateSelection();
                  updateResizeHandlers(true);
                  updateBtDelete(true);
              }
            },
            startSelection = function (event) {
              cancelEvent(event);

              // Reset the selection size
              area.width = options.minSize[0];
              area.height = options.minSize[1];
              focus();
              on("move", resizeSelection);
              on("stop", releaseSelection);

              // Get the selection origin
              selectionOrigin = getMousePosition(event);
              if (selectionOrigin[0] + area.width > $image.width()) {
                selectionOrigin[0] = $image.width() - area.width;
              }
              if (selectionOrigin[1] + area.height > $image.height()) {
                selectionOrigin[1] = $image.height() - area.height;
              }
              // And set its position
              area.x = selectionOrigin[0];
              area.y = selectionOrigin[1];
              area.newBox = true;

              refresh("startSelection");
            },
            pickSelection = function (event) {
              cancelEvent(event);
              focus();
              on("move", moveSelection);
              on("stop", releaseSelection);

              var mousePosition = getMousePosition(event);

              // Get the selection offset relative to the mouse position
              selectionOffset[0] = mousePosition[0] - area.x;
              selectionOffset[1] = mousePosition[1] - area.y;

              refresh("pickSelection");
            },
            pickResizeHandler = function (event) {
              cancelEvent(event);
              focus();

              var card = event.target.className.split(" ")[2];
              if (card[card.length - 1] === "w") {
                selectionOrigin[0] += area.width;
                area.x = selectionOrigin[0] - area.width;
              }
              if (card[0] === "n") {
                selectionOrigin[1] += area.height;
                area.y = selectionOrigin[1] - area.height;
              }
              if (card === "n" || card === "s") {
                resizeHorizontally = false;
              } else if (card === "e" || card === "w") {
                resizeVertically = false;
              }

              on("move", resizeSelection);
              on("stop", releaseSelection);

              refresh("pickResizeHandler");
            },
            resizeSelection = function (event) {
              cancelEvent(event);
              focus();

              var mousePosition = getMousePosition(event);

              // Get the selection size
              var height = mousePosition[1] - selectionOrigin[1],
                width = mousePosition[0] - selectionOrigin[0];

              // If the selection size is smaller than the minimum size set it to minimum size
              if (Math.abs(width) < options.minSize[0]) {
                width = width >= 0 ? options.minSize[0] : -options.minSize[0];
              }
              if (Math.abs(height) < options.minSize[1]) {
                height = height >= 0 ? options.minSize[1] : -options.minSize[1];
              }
              // Test if the selection size exceeds the image bounds
              if (
                selectionOrigin[0] + width < 0 ||
                selectionOrigin[0] + width > $image.width()
              ) {
                width = -width;
              }
              if (
                selectionOrigin[1] + height < 0 ||
                selectionOrigin[1] + height > $image.height()
              ) {
                height = -height;
              }
              // Test if the selection size is bigger than the maximum size (ignored if minSize > maxSize)
              if (
                options.maxSize[0] > options.minSize[0] &&
                options.maxSize[1] > options.minSize[1]
              ) {
                if (Math.abs(width) > options.maxSize[0]) {
                  width = width >= 0 ? options.maxSize[0] : -options.maxSize[0];
                }

                if (Math.abs(height) > options.maxSize[1]) {
                  height =
                    height >= 0 ? options.maxSize[1] : -options.maxSize[1];
                }
              }

              // Set the selection size
              if (resizeHorizontally) {
                area.width = width;
              }
              if (resizeVertically) {
                area.height = height;
              }

              if (area.width < 0) {
                area.width = Math.abs(area.width);
                area.x = selectionOrigin[0] - area.width;
              } else {
                area.x = selectionOrigin[0];
              }
              if (area.height < 0) {
                area.height = Math.abs(area.height);
                area.y = selectionOrigin[1] - area.height;
              } else {
                area.y = selectionOrigin[1];
              }

              fireEvent("changing");
              refresh("resizeSelection");
            },
            moveSelection = function (event) {
              cancelEvent(event);
              if (!options.allowMove) {
                return;
              }
              focus();

              var mousePosition = getMousePosition(event);
              moveTo({
                x: mousePosition[0] - selectionOffset[0],
                y: mousePosition[1] - selectionOffset[1],
              });

              fireEvent("changing");
            },
            moveTo = function (point) {
              // Set the selection position on the x-axis relative to the bounds
              // of the image
              if (point.x > 0) {
                if (point.x + area.width < $image.width()) {
                  area.x = point.x;
                } else {
                  area.x = $image.width() - area.width;
                }
              } else {
                area.x = 0;
              }
              // Set the selection position on the y-axis relative to the bounds
              // of the image
              if (point.y > 0) {
                if (point.y + area.height < $image.height()) {
                  area.y = point.y;
                } else {
                  area.y = $image.height() - area.height;
                }
              } else {
                area.y = 0;
              }
              refresh("moveSelection");
            },
            releaseSelection = function (event) {
              cancelEvent(event);
              off("move", "stop");

              // Update the selection origin
              selectionOrigin[0] = area.x;
              selectionOrigin[1] = area.y;

              // Reset the resize constraints
              resizeHorizontally = true;
              resizeVertically = true;

              if (typeof area.id === "undefined" && area.newBox) {
                area.newBox = false;
                delete area.newBox;
                fireEvent("onAdd");
              } else {
                fireEvent("changed");
              }

              refresh("releaseSelection");
            },
            deleteSelection = function (event) {
              cancelEvent(event);
              $selection.remove();
              $outline.remove();
              $.each($resizeHandlers, function (card, $handler) {
                $handler.remove();
              });
              $btDelete.remove();
              parent._remove(areaid);
              fireEvent("onDelete");
              fireEvent("changed");
            },
            getElementOffset = function (object) {
              var offset = $(object).offset();

              return [offset.left, offset.top];
            },
            getMousePosition = function (event) {
              var imageOffset = getElementOffset($image);

              if (!event.pageX) {
                if (event.originalEvent) {
                  event = event.originalEvent;
                }

                if (event.changedTouches) {
                  event = event.changedTouches[0];
                }

                if (event.touches) {
                  event = event.touches[0];
                }
              }
              var x = event.pageX - imageOffset[0],
                y = event.pageY - imageOffset[1];

              x = x < 0 ? 0 : x > $image.width() ? $image.width() : x;
              y = y < 0 ? 0 : y > $image.height() ? $image.height() : y;

              return [x, y];
            };

          // Initialize an outline layer and place it above the trigger layer
          $outline = $('<div class="ngAreas-element select-areas-outline" />')
            .css({
              opacity: options.outlineOpacity,
              position: "absolute",
            })
            .insertAfter($trigger);

          // Initialize a selection layer and place it above the outline layer
          $selection = $('<div class="ngAreas-element  border-medium" />')
            .addClass("select-areas-background-area")
            .css({
              background: "#fff url(" + $image.attr("src") + ") no-repeat",
              backgroundSize: $image.width() + "px",
              position: "absolute",
            })
            .insertAfter($outline);

          // Initialize all handlers
          if (options.allowResize) {
            $.each(
              ["nw", "n", "ne", "e", "se", "s", "sw", "w"],
              function (key, card) {
                $resizeHandlers[card] = $(
                  '<div class="ngAreas-element select-areas-resize-handler ' +
                    card +
                    '"/>'
                )
                  .css({
                    opacity: 0.5,
                    position: "absolute",
                    cursor: card + "-resize",
                  })
                  .insertAfter($selection)
                  .mousedown(pickResizeHandler)
                  .bind("touchstart", pickResizeHandler);
              }
            );
          }
          // initialize delete button
          if (options.allowDelete) {
            var bindToDelete = function ($obj) {
              $obj
                .click(deleteSelection)
                .bind("touchstart", deleteSelection)
                .bind("tap", deleteSelection);
              return $obj;
            };
            $btDelete = bindToDelete(
              $('<div class="ngAreas-element delete-area" />')
            )
              .append(
                bindToDelete(
                  $('<div class="ngAreas-element select-areas-delete-area" />')
                )
              )
              .insertAfter($selection);
          }

          if (options.allowMove) {
            $selection
              .mousedown(pickSelection)
              .bind("touchstart", pickSelection);
          }

          focus();

          return {
            getData: getData,
            startSelection: startSelection,
            deleteSelection: deleteSelection,
            options: options,
            blur: blur,
            focus: focus,
            nudge: function (point) {
              point.x = area.x;
              point.y = area.y;
              if (point.d) {
                point.y = area.y + point.d;
              }
              if (point.u) {
                point.y = area.y - point.u;
              }
              if (point.l) {
                point.x = area.x - point.l;
              }
              if (point.r) {
                point.x = area.x + point.r;
              }
              moveTo(point);
              fireEvent("changing");
            },
            set: function (dimensions, silent) {
              area = $.extend(area, dimensions);
              selectionOrigin[0] = area.x;
              selectionOrigin[1] = area.y;
              if (!silent) {
                fireEvent("loaded");
              }
            },
            contains: function (point) {
              return (
                point.x >= area.x &&
                point.x <= area.x + area.width &&
                point.y >= area.y &&
                point.y <= area.y + area.height
              );
            },
          };
        };

        imageSelectAreas.prototype.init = function (object, customOptions) {
          var that = this,
            defaultOptions = {
              allowEdit: true,
              allowMove: true,
              allowResize: true,
              allowSelect: true,
              allowDelete: true,
              allowNudge: true,
              ratio: 1,
              minSize: [0, 0],
              maxSize: [0, 0],
              width: 0,
              maxAreas: 0,
              outlineOpacity: 0.5,
              overlayOpacity: 0.5,
              areas: [],
              onLoaded: null,
              onChanging: null,
              onChanged: null,
              onAdd: null,
              onDelete: null,
            };
          this.options = $.extend(defaultOptions, customOptions);

          if (!this.options.allowEdit) {
            this.options.allowSelect =
              this.options.allowMove =
              this.options.allowResize =
              this.options.allowDelete =
                false;
          }

          this._areas = app._areas;

          // Initialize the image layer
          this.$image = $(object);

          if (
            this.options.width &&
            this.$image.width() &&
            this.options.width !== this.$image.width()
          ) {
            this.options.ratio =
              this.options.width / this.$image[0].naturalWidth;
            this.$image.width(this.options.width);
          }

          if (this.options.onChanging) {
            this.$image.on("changing", this.options.onChanging);
          }
          if (this.options.onChanged) {
            this.$image.on("changed", this.options.onChanged);
          }
          if (this.options.onAdd) {
            this.$image.on("onAdd", this.options.onAdd);
          }
          if (this.options.onDelete) {
            this.$image.on("onDelete", this.options.onDelete);
          }

          if (this.options.onLoaded) {
            this.$image.on("loaded", this.options.onLoaded);
          }

          // Initialize an image holder
          this.$holder = $('<div class="ngAreas-element ngAreas-holder"/>').css(
            {
              position: "relative",
              width: this.$image.width(),
              height: this.$image.height(),
            }
          );

          // Wrap the holder around the image
          this.$image.wrap(this.$holder).css({
            position: "absolute",
          });

          // Initialize an overlay layer and place it above the image
          this.$overlay = $(
            '<div class="ngAreas-element select-areas-overlay" />'
          )
            .css({
              opacity: this.options.overlayOpacity,
              position: "absolute",
              width: this.$image.width(),
              height: this.$image.height(),
            })
            .insertAfter(this.$image);

          // Initialize a trigger layer and place it above the overlay layer
          this.$trigger = $('<div class="ngAreas-element" />')
            .css({
              backgroundColor: "#000000",
              opacity: 0,
              position: "absolute",
              width: this.$image.width(),
              height: this.$image.height(),
            })
            .insertAfter(this.$overlay);
          var that = this;
          $.each(this.options.areas, function (key, area) {
            that._add(that.applyRatio(area), false);
          });

          this.blurAll();
          this._refresh();

          if (this.options.allowSelect) {
            // Bind an event handler to the "mousedown" event of the trigger layer
            this.$trigger
              .mousedown($.proxy(this.newArea, this))
              .on("touchstart", $.proxy(this.newArea, this));
          }
          if (this.options.allowNudge) {
            $("html").keydown(function (e) {
              // move selection with arrow keys
              var codes = {
                  37: "l",
                  38: "u",
                  39: "r",
                  40: "d",
                },
                direction = codes[e.which],
                selectedArea;

              if (direction) {
                that._eachArea(function (area) {
                  if (area.getData().z === 100) {
                    selectedArea = area;
                    return false;
                  }
                });
                if (selectedArea) {
                  var move = {};
                  move[direction] = 1;
                  selectedArea.nudge(move);
                }
              }
            });
          }
        };

        imageSelectAreas.prototype.applyRatio = function (area) {
          var that = this;
          var apply = function (val) {
            return Math.round(val * that.options.ratio);
          };

          var tmp = $.extend({}, area);
          tmp.x = apply(tmp.x);
          tmp.y = apply(tmp.y);
          tmp.width = apply(tmp.width);
          tmp.height = apply(tmp.height);

          return tmp;
        };

        imageSelectAreas.prototype.removeRatio = function (area) {
          var that = this;
          var removeIt = function (val) {
            return Math.round(val / that.options.ratio);
          };

          var tmp = $.extend({}, area);
          tmp.x = removeIt(tmp.x);
          tmp.y = removeIt(tmp.y);
          tmp.width = removeIt(tmp.width);
          tmp.height = removeIt(tmp.height);

          return tmp;
        };

        imageSelectAreas.prototype._refresh = function () {
          var nbAreas = this.areas().length;
          this.$overlay.css({
            display: nbAreas ? "block" : "none",
          });
          if (nbAreas) {
            this.$image.addClass("blurred");
          } else {
            this.$image.removeClass("blurred");
          }
          this.$trigger.css({
            cursor: this.options.allowSelect ? "crosshair" : "default",
          });
        };

        imageSelectAreas.prototype._eachArea = function (cb) {
          $.each(this._areas, function (areaid, area) {
            if (area) {
              return cb(area, areaid);
            }
          });
        };

        imageSelectAreas.prototype._remove = function (areaid) {
          delete this._areas[areaid];
          this._refresh();
        };

        imageSelectAreas.prototype.remove = function (areaid) {
          if (this._areas[areaid]) {
            this._areas[areaid].deleteSelection();
          }
        };

        imageSelectAreas.prototype.newArea = function (event) {
          if (!$scope.name_for_new_tag) return;
          var areaid = -1;
          this.blurAll();
          if (
            this.options.maxAreas &&
            this.options.maxAreas <= this.areas().length
          ) {
            return areaid;
          }
          this._eachArea(function (area, index) {
            areaid = Math.max(areaid, parseInt(index, 10));
          });
          app.areaid += 1;
          areaid = app.areaid;
          this._areas[areaid] = $scope.imageArea(this, areaid);
          if (event) {
            this._areas[areaid].startSelection(event);
          }
          return areaid;
        };

        imageSelectAreas.prototype.set = function (areaid, options, silent) {
          if (this._areas[areaid]) {
            options.areaid = areaid;
            this._areas[areaid].set(options, silent);
            this._areas[areaid].focus();
          }
        };

        imageSelectAreas.prototype._add = function (options, silent) {
          var areaid = this.newArea();
          this.set(areaid, options, silent);
        };

        imageSelectAreas.prototype.add = function (options) {
          var that = this;
          this.blurAll();
          if ($.isArray(options)) {
            $.each(options, function (key, val) {
              that._add(val);
            });
          } else {
            this._add(options);
          }
          this._refresh();
          if (
            !this.options.allowSelect &&
            !this.options.allowMove &&
            !this.options.allowResize &&
            !this.options.allowDelete
          ) {
            this.blurAll();
          }
        };

        imageSelectAreas.prototype.reset = function () {
          console.log("to reset");
          var that = this;
          this._eachArea(function (area, areaid) {
            delete that._areas[areaid];
          });
          this._refresh();
        };

        imageSelectAreas.prototype.destroy = function (element) {
          this.reset();
          $(".ngAreas-holder").find("img").unwrap();
          $(".ngAreas-element").remove();
          this.$overlay.remove();
          this.$trigger.remove();
          this.$image.removeData("mainImageSelectAreas");
        };

        imageSelectAreas.prototype.areas = function () {
          var ret = [];
          var that = this;
          var areas = this.relativeAreas();
          for (var i = 0; i < areas.length; i++) {
            ret[i] = $.extend({}, areas[i]);
            ret[i] = that.removeRatio(ret[i]);
          }

          return ret;
        };

        imageSelectAreas.prototype.relativeAreas = function () {
          var ret = [];
          this._eachArea(function (area) {
            ret.push(area.getData());
          });
          return ret;
        };

        imageSelectAreas.prototype.renameArea = function (areaid, name) {
          this._eachArea(function (area) {
            if (area.getData().areaid === areaid) {
              area.getData().name = name;
            }
          });
        };
        imageSelectAreas.prototype.blurAll = function () {
          this._eachArea(function (area) {
            area.blur();
          });
        };

        imageSelectAreas.prototype.contains = function (point) {
          var res = false;
          this._eachArea(function (area) {
            if (area.contains(point)) {
              res = true;
              return false;
            }
          });
          return res;
        };

        var execCommand = function (currentObject, command) {
          if (imageSelectAreas.prototype[command]) {
            // Method call
            var ret = imageSelectAreas.prototype[command].apply(
              $scope.selectAreas(currentObject),
              Array.prototype.slice.call(arguments, 1)
            );
            return typeof ret === "undefined" ? this : ret;
          } else {
            console.error("error command " + command + " not found!");
          }
        };
      },
    };
  },
]);

/* global angular */
(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ColectividadesTableCtrl", ColectividadesTableCtrl);

  ColectividadesTableCtrl.$inject = [
    "$scope",
    "$rootScope",
    "insuranceService",
    "$state",
    "url",
    "$http",
    "$parse",
  ];

  function ColectividadesTableCtrl(
    $scope,
    $rootScope,
    insuranceService,
    $state,
    url,
    $http,
    $parse
  ) {
    $scope.covers = [];
    $scope.renewalColect == false;

    $scope.coverSelected = function (parItem) {
      $state.go("colectividades.info", { polizaId: parItem.id });
    };

    $http({
      method: "GET",
      url: url.IP + "get-certificados/",
    })
      .then(
        function success(request) {
          if (request.status === 200) {
            $scope.covers = request.data.results;
            $scope.covers_config = {
              count: request.data.count,
              next: request.data.next,
              previous: request.data.previous,
            };
            $scope.show_pagination = true;

            $scope.testPagination("covers", "covers_config");
          }
        },
        function error(error) {}
      )
      .catch(function (e) {
        console.log(e);
      });

    $scope.returnToColectiv = function (param) {
      if (param) {
        $scope.show_binnacle = false;
      } else {
        $scope.show_binnacle = false;
      }
    };
    $scope.show_binnacle = false;
    //-----------------------------------------------------------comments
    $scope.showBinnacle = function (param) {
      $scope.show_binnacle = true;
      $scope.item_id = param.id;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 1,
          id_model: param.id,
        },
      })
        .then(function (request) {
          // console.log('requestkñlñkñl', request);
          $scope.comments_data = request.data.results;
          $scope.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };
    //-------------------------------------------------------------comments

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      // console.log('pages', pages);

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
          } else {
            if (config_.previous.search("&page=") !== -1) {
              var url = config_.previous.substring(
                0,
                config_.previous.indexOf("&page=") + 6
              );
              url += parPage.toString();
            } else {
              var url = config_.previous;
            }
          }
        }

        // url += '&status=1'
        getProviders(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      // console.log('id', $scope.id);
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getProviders(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("SubirMasivosCtrl", SubirMasivosCtrl);

  SubirMasivosCtrl.$inject = [
    "$q",
    "url",
    "FileUploader",
    "$localStorage",
    "emailService",
    "dataFactory",
    "toaster",
    "$sessionStorage",
    "$http",
    "$rootScope",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
  ];

  function SubirMasivosCtrl(
    $q,
    url,
    FileUploader,
    $localStorage,
    emailService,
    dataFactory,
    toaster,
    $sessionStorage,
    $http,
    $rootScope,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal
  ) {
    var foo = this;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    $scope.showCertificates = true;
    $scope.showPolicies = true;
    $scope.gralFiles = false;
    $scope.gralFilesReceipts = false;

    foo.elementos = [];
    foo.elementos_incompletos = [];
    foo.file_loaded = false;
    foo.archivos_encontrados = 0;
    foo.loader = false;
    foo.boton_guardar = true;
    foo.boton_por_id_habilitado = true;

    $scope.selGralFilesReceipts = function (argument) {
      $scope.gralFilesReceipts = argument;
    };

    $scope.selGralFiles = function (argument) {
      $scope.gralFiles = argument;
    };

    $scope.selectExcel = function (parData) {
      $scope.showCertificates = true;
      $scope.showPolicies = false;
      foo.file_loaded = false;
      foo.loader = true;
      foo.elementos = parData["Hoja1"];
      foo.elementos.map(function (item) {
        item["id"] = 0;
        item["file"] = null;
        item["cert"] = null;
        return item;
      });
      $http
        .post(url.IP + "get-certificate/", { elementos: foo.elementos })
        .then(function (response) {
          if (response.data && response.data["elementos"]) {
            foo.elementos = response.data["elementos"];
            foo.elementos_by_id = response.data["elementos"];
          }
          foo.loader = false;
          foo.file_loaded = true;
        })
        .catch(function (err) {
          toaster.error("Ocurrio un error, intentelo nuevamente");
          foo.loader = false;
        });
      foo.archivos_encontrados = 0;

      // foo.loader = false;
      SweetAlert.swal(
        "Ojo",
        "En caso de cargar achivos individuales asegurese de que la columna del nombre del archivo coincida 100% con el nombre del archivo, de otro modo no se cargará",
        "warning"
      );
    };

    $scope.selectExcelPolicyById = function (parData) {
      // $scope.showCertificates = false;
      // $scope.showPolicies = true;
      foo.archivos_encontrados_by_id = 0;
      foo.file_loaded_by_id = false;
      foo.loader_by_id = true;
      foo.elementos_by_id = parData["Hoja1"];
      foo.elementos_by_id.map(function (item) {
        item["id"] = 0;
        item["file"] = null;
        item["file_id"] = null;
        item["isUploading"] = false;
        item["isUploaded"] = false;
        item["isError"] = false;
        return item;
      });
      $http
        .post(url.IP + "get-certificate-by-id/", {
          elementos: foo.elementos_by_id,
        })
        .then(function (response) {
          if (response.data && response.data["elementos"]) {
            foo.elementos_by_id = response.data["elementos"];
          }
          foo.loader_by_id = false;
          foo.file_loaded_by_id = true;
          foo.boton_por_id_habilitado = true;
        })
        .catch(function (err) {
          toaster.error("Ocurrio un error, intentelo nuevamente");
          foo.loader_by_id = false;
        });
      foo.archivos_encontrados = 0;

      // foo.loader = false;
      SweetAlert.swal(
        "Ojo",
        "Asegurese de que la columna del nombre del archivo coincida 100% con el nombre del archivo, de otro modo no se cargará",
        "warning"
      );
    };

    $scope.selectExcelPolizaIndById = function (parData) {
      // $scope.showCertificates = false;
      // $scope.showPolicies = true;
      foo.archivos_encontrados_by_id = 0;
      foo.file_polizas_loaded_by_id = false;
      foo.loader_by_id = true;
      foo.elementos_polizas_by_id = parData["Hoja1"];
      foo.elementos_polizas_by_id.map(function (item) {
        item["id"] = 0;
        item["file"] = null;
        item["file_id"] = null;
        item["isUploading"] = false;
        item["isUploaded"] = false;
        item["isError"] = false;
        return item;
      });
      $http
        .post(url.IP + "get-certificate-by-id/", {
          elementos: foo.elementos_polizas_by_id,
        })
        .then(function (response) {
          if (response.data && response.data["elementos"]) {
            foo.elementos_polizas_by_id = response.data["elementos"];
          }
          foo.loader_by_id = false;
          foo.file_polizas_loaded_by_id = true;
          foo.boton_por_id_habilitado = true;
        })
        .catch(function (err) {
          toaster.error("Ocurrio un error, intentelo nuevamente");
          foo.loader_by_id = false;
        });
      foo.archivos_encontrados = 0;

      // foo.loader = false;
      SweetAlert.swal(
        "Ojo",
        "Asegurese de que la columna del nombre del archivo coincida 100% con el nombre del archivo, de otro modo no se cargará",
        "warning"
      );
    };

    $scope.selectExcelReceiptById = function (parData) {
      // $scope.showCertificates = false;
      // $scope.showPolicies = true;
      foo.archivos_encontrados_by_id = 0;
      foo.file_receipts_loaded_by_id = false;
      foo.loader_by_id = true;
      foo.elementos_receipt_by_id = parData["Hoja1"];
      foo.elementos_receipt_by_id.map(function (item) {
        item["id"] = 0;
        item["file"] = null;
        item["file_id"] = null;
        item["isUploading"] = false;
        item["isUploaded"] = false;
        item["isError"] = false;
        return item;
      });
      $http
        .post(url.IP + "get-receipts-by-id/", {
          elementos: foo.elementos_receipt_by_id,
        })
        .then(function (response) {
          if (response.data && response.data["elementos"]) {
            foo.elementos_receipt_by_id = response.data["elementos"];
          }
          foo.loader_by_id = false;
          foo.file_receipts_loaded_by_id = true;
          foo.boton_por_id_habilitado = true;
        })
        .catch(function (err) {
          toaster.error("Ocurrio un error, intentelo nuevamente");
          foo.loader_by_id = false;
        });
      foo.archivos_encontrados = 0;

      // foo.loader = false;
      SweetAlert.swal(
        "Ojo",
        "Asegurese de que la columna del nombre del archivo coincida 100% con el nombre del archivo, de otro modo no se cargará",
        "warning"
      );
    };

    $scope.selectExcelContractortById = function (parData) {
      // $scope.showCertificates = false;
      // $scope.showPolicies = true;
      foo.archivos_encontrados_by_id = 0;
      foo.file_contractors_loaded_by_id = false;
      foo.loader_by_id = true;
      foo.elementos_contractor_by_id = parData["Hoja1"];
      foo.elementos_contractor_by_id.map(function (item) {
        item["id"] = 0;
        item["file"] = null;
        item["file_id"] = null;
        item["isUploading"] = false;
        item["isUploaded"] = false;
        item["isError"] = false;
        return item;
      });
      $http
        .post(url.IP + "get-contractors-by-id/", {
          elementos: foo.elementos_contractor_by_id,
        })
        .then(function (response) {
          if (response.data && response.data["elementos"]) {
            foo.elementos_contractor_by_id = response.data["elementos"];
          }
          foo.loader_by_id = false;
          foo.file_contractors_loaded_by_id = true;
          foo.boton_por_id_habilitado = true;
        })
        .catch(function (err) {
          toaster.error("Ocurrio un error, intentelo nuevamente");
          foo.loader_by_id = false;
        });
      foo.archivos_encontrados = 0;

      // foo.loader = false;
      SweetAlert.swal(
        "Ojo",
        "Asegurese de que la columna del nombre del archivo coincida 100% con el nombre del archivo, de otro modo no se cargará",
        "warning"
      );
    };

    $scope.selectExcelPolicy = function (parData) {
      $scope.showCertificates = false;
      $scope.showPolicies = true;
      foo.file_loaded = false;
      foo.loader = true;
      foo.elementos = parData["Hoja1"];
      foo.elementos.map(function (item) {
        item["id"] = 0;
        item["file"] = null;
        item["cert"] = null;
        item["polizacaratula"] = null;
        return item;
      });
      $http
        .post(url.IP + "get-polizacaratula_files/", {
          elementos: foo.elementos,
        })
        .then(function (response) {
          if (response.data && response.data["elementos"]) {
            foo.elementos = response.data["elementos"];
          }
          foo.loader = false;
          foo.file_loaded = true;
        })
        .catch(function (err) {
          toaster.error("Ocurrio un error, intentelo nuevamente");
          foo.loader = false;
        });
      foo.archivos_encontrados = 0;

      // foo.loader = false;
      SweetAlert.swal(
        "Ojo",
        "Asegurese de que la columna del nombre del archivo coincida 100% con el nombre del archivo, de otro modo no se cargará",
        "warning"
      );
    };

    function enviarFilePolizas() {
      // toaster.success('Simulacion de envio');
      foo.boton_por_id_habilitado = false;

      foo.elementos_polizas_by_id.forEach(function (item, index) {
        if ((item["cert"] || item["polizacaratula"]) && item["file"]) {
          uploader.queue.push(item["file"]);
          uploader.uploadItem(item["file"]);
        }
      });
    }

    function enviarFileCerts() {
      // toaster.success('Simulacion de envio');
      foo.boton_por_id_habilitado = false;

      foo.elementos_by_id.forEach(function (item, index) {
        if ((item["cert"] || item["polizacaratula"]) && item["file"]) {
          uploader.queue.push(item["file"]);
          uploader.uploadItem(item["file"]);
        }
      });
    }

    function enviarFileReceipts() {
      foo.boton_por_id_habilitado = false;
      if ($scope.gralFilesReceipts) {
        foo.loader = true;
        foo.elementos_receipt_by_id.forEach(function (item, index) {
          var _url = url.IP + "recibos/" + item["recibo"] + "/archivos/";
          var settings = {
            async: true,
            crossDomain: true,
            url: _url,
            method: "POST",
            beforeSend: function (request) {
              // request.setRequestHeader("Authorization", 'Token ' + token); },
              request.setRequestHeader("Authorization", "Bearer " + token);
            },
            processData: false,
            contentType: false,
            mimeType: "multipart/form-data",
            data: formdata,
          };
          $.ajax(settings)
            .done(function (response) {
              try {
                response = JSON.parse(response);
                foo.elementos_receipt_by_id[index]["recibo"] = response["id"];
                foo.elementos_receipt_by_id[index]["isUploaded"] = true;
                foo.elementos_receipt_by_id[index]["isError"] = false;
              } catch (err) {
                foo.loader = false;
              }
              toaster.success(MESSAGES.OK.UPLOADFILES);
              foo.loader = false;
            })
            .error(function (response) {
              toaster.error("Ocurrio un error al cargar un archivo");
              foo.loader = false;
            });
        });
      } else {
        foo.elementos_receipt_by_id.forEach(function (item, index) {
          if (item["recibo"] && item["file"]) {
            uploader.queue.push(item["file"]);
            uploader.uploadItem(item["file"]);
          }
        });
      }
    }

    function enviarFileContractors() {
      foo.boton_por_id_habilitado = false;

      foo.elementos_contractor_by_id.forEach(function (item, index) {
        if (item["contratante"] && item["file"]) {
          uploader.queue.push(item["file"]);
          uploader.uploadItem(item["file"]);
        }
      });
    }

    function enviar() {
      // toaster.success('Simulacion de envio');
      foo.boton_guardar = false;
      // foo.loader = true;

      if ($scope.gralFiles) {
        foo.loader = true;
        foo.elementos.forEach(function (item, index) {
          var _url = url.IP + "polizas/" + item["cert"] + "/archivos/";
          var settings = {
            async: true,
            crossDomain: true,
            url: _url,
            method: "POST",
            beforeSend: function (request) {
              // request.setRequestHeader("Authorization", 'Token ' + token); },
              request.setRequestHeader("Authorization", "Bearer " + token);
            },
            processData: false,
            contentType: false,
            mimeType: "multipart/form-data",
            data: formdata,
          };
          $.ajax(settings)
            .done(function (response) {
              console.log("response", response);
              try {
                response = JSON.parse(response);
                foo.elementos[index]["id"] = response["id"];
              } catch (err) {
                console.log("response", response);
                foo.loader = false;
              }
              toaster.success(MESSAGES.OK.UPLOADFILES);
              foo.loader = false;
            })
            .error(function (response) {
              toaster.error("Ocurrio un error al cargar un archivo");
              foo.loader = false;
            });
        });
      } else {
        foo.elementos.forEach(function (item) {
          if ((item["cert"] || item["polizacaratula"]) && item["file"]) {
            uploader.queue.push(item["file"]);
            item["id"] = 1;
          }
        });
        $q.all(uploadFiles())
          .then(function () {
            foo.elementos_incompletos = angular.copy(
              foo.elementos.filter(function (item) {
                if ((item["cert"] || item["polizacaratula"]) && item["file"])
                  return false;
                else return true;
              })
            );
            foo.elementos = angular.copy(
              foo.elementos.filter(function (item) {
                if ((item["cert"] || item["polizacaratula"]) && item["file"])
                  return true;
                else return false;
              })
            );
            // foo.loader = false;
          })
          .catch(function (err) {
            toaster.error("Ocurrio un error");
          });
      }
    }

    $scope.saveFilesCerts = function () {
      var flag_certs = true;
      var flag_files = true;
      var text_var = "";
      foo.elementos_by_id.some(function (item) {
        if (item.cert) {
          flag_certs = false;
        }
        if (item.file) {
          flag_files = false;
        }
      });

      if (!flag_certs || !flag_files) {
        text_var =
          "Se cargará el archivo seleccionado a todos los certificados encontrados, Por favor, no recargue pantalla, ni apague su dispositivo.";
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: text_var,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "¡Si, Cargar!",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              enviarFileCerts();
            }
          }
        );
      }
    };

    $scope.saveFilesPolizas = function () {
      var flag_certs = true;
      var flag_files = true;
      var text_var = "";
      foo.elementos_polizas_by_id.some(function (item) {
        if (item.cert) {
          flag_certs = false;
        }
        if (item.file) {
          flag_files = false;
        }
      });

      if (!flag_certs || !flag_files) {
        text_var =
          "Se cargará el archivo seleccionado a todos los certificados encontrados, Por favor, no recargue pantalla, ni apague su dispositivo.";

        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: text_var,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "¡Si, Cargar!",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              enviarFilePolizas();
            }
          }
        );
      }
    };

    $scope.saveFilesReceipts = function () {
      var flag_receipts = true;
      var flag_files = true;
      var text_var = "";
      foo.elementos_receipt_by_id.some(function (item) {
        if (item.recibo) {
          flag_receipts = false;
        }
        if (item.file) {
          flag_files = false;
        }
      });

      if (!flag_receipts || !flag_files) {
        text_var =
          "Se cargará el archivo seleccionado a todos los recibos encontrados, Por favor, no recargue pantalla, ni apague su dispositivo.";

        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: text_var,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "¡Si, Cargar!",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              enviarFileReceipts();
            }
          }
        );
      }
    };

    $scope.saveFilesContractors = function () {
      var flag_receipts = true;
      var flag_files = true;
      var text_var = "";
      foo.elementos_contractor_by_id.some(function (item) {
        if (item.contratante) {
          flag_receipts = false;
        }
        if (item.file) {
          flag_files = false;
        }
      });

      if (!flag_receipts || !flag_files) {
        text_var =
          "Se cargará el archivo seleccionado a todos los contratantes encontrados, Por favor, no recargue pantalla, ni apague su dispositivo.";

        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: text_var,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "¡Si, Cargar!",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              enviarFileContractors();
            }
          }
        );
      }
    };

    $scope.saveFiles = function () {
      var flag_certs = true;
      var flag_files = true;
      var text_var = "";
      foo.elementos.some(function (item) {
        if (item.cert) {
          flag_certs = false;
        }
        if (item.file) {
          flag_files = false;
        }
      });

      if (!flag_certs || !flag_files) {
        if ($scope.gralFiles) {
          text_var =
            "Se cargará el archivo seleccionado a todos los certificados encontrados.";
        } else {
          text_var =
            "No todos los certificados o archivos se encontraron, solo se cargarán los archivos encontrados en los certificados encontrados";
        }

        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: text_var,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "¡Si, Cargar!",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              enviar();
            }
          }
        );
      }
    };

    $scope.saveFilesPolicy = function () {
      var flag_certs = true;
      var flag_files = true;
      foo.elementos.some(function (item) {
        if (item.cert) {
          flag_certs = false;
        }
        if (item.file) {
          flag_files = false;
        }
      });

      if (!flag_certs || !flag_files) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "No todos los certificados o archivos se encontraron, solo se cargarán los archivos encontrados en los certificados encontrados",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "¡Si, Cargar!",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              enviar();
            }
          }
        );
      }
    };

    // Upload files
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    uploader.filters.push({
      name: "customFilter",
      fn: function (item /*{File|FileLikeObject}*/, options) {
        //jshint ignore:line
        return this.queue.length < 2000000;
      },
    });

    function removeExtension(filename) {
      return filename.replace(/\.[^\/.]+$/, "");
    }

    // ALERTA SUCCES UPLOADFILES
    $scope.totalFiles = 0;
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      // $scope.showFiles($scope.num_section, $scope.element.id, $scope.element);
      $scope.totalFiles = $scope.totalFiles + 1;
      if (
        foo.elementos_by_id &&
        foo.elementos_by_id.length == $scope.totalFiles
      ) {
        toaster.success(MESSAGES.OK.UPLOADFILES);
      } else {
        toaster.success(MESSAGES.OK.UPLOADFILEONE);
      }
      if (foo.elementos_by_id && foo.elementos_by_id.length) {
        foo.elementos_by_id = foo.elementos_by_id.map(function (item) {
          if (
            item["NOMBRE DEL ARCHIVO PDF (CERTIFICADO INDIVIDUAL)"] ==
              removeExtension(fileItem.file.name) ||
            item["NOMBRE DEL ADJUNTO PDF (CERTIFICADO INDIVIDUAL)"] ==
              removeExtension(fileItem.file.name)
          ) {
            item["isUploaded"] = fileItem.isUploaded;
            item["isError"] = fileItem.isError;
          }
          return item;
        });
      }

      if (foo.elementos_polizas_by_id && foo.elementos_polizas_by_id.length) {
        foo.elementos_polizas_by_id = foo.elementos_polizas_by_id.map(function (
          item
        ) {
          if (
            item["NOMBRE DEL ARCHIVO PDF"] ==
            removeExtension(fileItem.file.name)
          ) {
            item["isUploaded"] = fileItem.isUploaded;
            item["isError"] = fileItem.isError;
          }
          return item;
        });
      }

      if (foo.elementos_receipt_by_id && foo.elementos_receipt_by_id.length) {
        foo.elementos_receipt_by_id = foo.elementos_receipt_by_id.map(function (
          item
        ) {
          if (
            item["NOMBRE DEL ARCHIVO PDF"] ==
            removeExtension(fileItem.file.name)
          ) {
            item["isUploaded"] = fileItem.isUploaded;
            item["isError"] = fileItem.isError;
          }
          return item;
        });
      }

      if (
        foo.elementos_contractor_by_id &&
        foo.elementos_contractor_by_id.length
      ) {
        foo.elementos_contractor_by_id = foo.elementos_contractor_by_id.map(
          function (item) {
            if (
              item["NOMBRE DEL ARCHIVO PDF"] ==
              removeExtension(fileItem.file.name)
            ) {
              item["isUploaded"] = fileItem.isUploaded;
              item["isError"] = fileItem.isError;
            }
            return item;
          }
        );
      }

      // uploader.clearQueue();
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      // SweetAlert.swal("ERROR",MESSAGES.ERROR.ERRORONUPLOADFILES ,"error");
      if (foo.elementos_by_id && foo.elementos_by_id.length) {
        foo.elementos_by_id = foo.elementos_by_id.map(function (item) {
          if (
            item["NOMBRE DEL ARCHIVO PDF (CERTIFICADO INDIVIDUAL)"] ==
              removeExtension(fileItem.file.name) ||
            item["NOMBRE DEL ADJUNTO PDF (CERTIFICADO INDIVIDUAL)"] ==
              removeExtension(fileItem.file.name)
          ) {
            item["isUploaded"] = false;
            item["isError"] = fileItem.isError;
          }
          return item;
        });
      }

      if (foo.elementos_polizas_by_id && foo.elementos_polizas_by_id.length) {
        foo.elementos_polizas_by_id = foo.elementos_polizas_by_id.map(function (
          item
        ) {
          if (
            item["NOMBRE DEL ARCHIVO PDF"] ==
            removeExtension(fileItem.file.name)
          ) {
            item["isUploaded"] = false;
            item["isError"] = fileItem.isError;
          }
          return item;
        });
      }

      if (foo.elementos_receipt_by_id && foo.elementos_receipt_by_id.length) {
        foo.elementos_receipt_by_id = foo.elementos_receipt_by_id.map(function (
          item
        ) {
          if (
            item["NOMBRE DEL ARCHIVO PDF"] ==
            removeExtension(fileItem.file.name)
          ) {
            item["isUploaded"] = false;
            item["isError"] = fileItem.isError;
          }
          return item;
        });
      }

      if (
        foo.elementos_contractor_by_id &&
        foo.elementos_contractor_by_id.length
      ) {
        foo.elementos_contractor_by_id = foo.elementos_contractor_by_id.map(
          function (item) {
            if (
              item["NOMBRE DEL ARCHIVO PDF"] ==
              removeExtension(fileItem.file.name)
            ) {
              item["isUploaded"] = false;
              item["isError"] = fileItem.isError;
            }
            return item;
          }
        );
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      $scope.totalFiles = $scope.uploader.queue.length;
      // console.log('fileItem',fileItem);
      var copied_file;
      if (
        foo.elementos_contractor_by_id &&
        foo.elementos_contractor_by_id.length
      ) {
        fileItem.formData.push({
          arch: fileItem._file,
          name: fileItem.file.name,
        });
      } else {
        fileItem.formData.push({
          arch: fileItem._file,
          nombre: fileItem.file.name,
        });
      }
      fileItem.removeAfterUpload = true;
      var filename = "";

      foo.elementos.map(function (item) {
        uploader.queue.forEach(function (file, index) {
          if ($scope.gralFilesReceipts) {
            copied_file = angular.copy(file);
            copied_file["url"] =
              url.IP + "recibos/" + item["recibo"] + "/archivos/";
            item["file"] = copied_file;
            foo.archivos_encontrados++;
          }
          if ($scope.gralFiles) {
            copied_file = angular.copy(file);
            copied_file["url"] =
              url.IP + "polizas/" + item["cert"] + "/archivos/";
            item["file"] = copied_file;
            foo.archivos_encontrados++;
          } else {
            filename = file["file"]["name"]
              .replace(".pdf", "")
              .replace(".PDF", "")
              .replace(".Pdf", "");
            if (
              filename ==
                item["NOMBRE DEL ARCHIVO PDF (CERTIFICADO INDIVIDUAL)"] ||
              filename ==
                item["NOMBRE DEL ADJUNTO PDF (CERTIFICADO INDIVIDUAL)"]
            ) {
              if (item["polizacaratula"]) {
                file["url"] =
                  url.IP + "polizas/" + item["polizacaratula"] + "/archivos/";
              } else {
                file["url"] = url.IP + "polizas/" + item["cert"] + "/archivos/";
              }
              item["file"] = file;
              foo.archivos_encontrados++;
              uploader.queue.splice(index, 1);
            }
          }
        });
        return item;
      });

      if (foo.elementos_by_id && foo.elementos_by_id.length) {
        foo.elementos_by_id.map(function (item) {
          uploader.queue.forEach(function (file, index) {
            filename = file["file"]["name"]
              .replace(".pdf", "")
              .replace(".PDF", "")
              .replace(".Pdf", "");
            if (
              filename ==
                item["NOMBRE DEL ARCHIVO PDF (CERTIFICADO INDIVIDUAL)"] ||
              filename ==
                item["NOMBRE DEL ADJUNTO PDF (CERTIFICADO INDIVIDUAL)"]
            ) {
              if (item["polizacaratula"]) {
                file["url"] =
                  url.IP + "polizas/" + item["polizacaratula"] + "/archivos/";
              } else {
                file["url"] = url.IP + "polizas/" + item["cert"] + "/archivos/";
              }
              item["file"] = file;
              foo.archivos_encontrados_by_id++;
              uploader.queue.splice(index, 1);
            }
          });
          return item;
        });
      }

      if (foo.elementos_polizas_by_id && foo.elementos_polizas_by_id.length) {
        foo.elementos_polizas_by_id.map(function (item) {
          uploader.queue.forEach(function (file, index) {
            filename = file["file"]["name"]
              .replace(".pdf", "")
              .replace(".PDF", "")
              .replace(".Pdf", "");
            if (filename == item["NOMBRE DEL ARCHIVO PDF"]) {
              file["url"] = url.IP + "polizas/" + item["cert"] + "/archivos/";
              item["file"] = file;
              foo.archivos_encontrados_by_id++;
              uploader.queue.splice(index, 1);
            }
          });
          return item;
        });
      }

      if (foo.elementos_receipt_by_id && foo.elementos_receipt_by_id.length) {
        foo.elementos_receipt_by_id.map(function (item) {
          uploader.queue.forEach(function (file, index) {
            filename = removeExtension(file["file"]["name"]);
            if (filename == item["NOMBRE DEL ARCHIVO PDF"]) {
              file["url"] = url.IP + "recibos/" + item["recibo"] + "/archivos/";
              item["file"] = file;
              item["owner"] = item["recibo"];
              foo.archivos_encontrados_by_id++;
              uploader.queue.splice(index, 1);
            }
          });
          return item;
        });
      }

      if (
        foo.elementos_contractor_by_id &&
        foo.elementos_contractor_by_id.length
      ) {
        foo.elementos_contractor_by_id.map(function (item) {
          uploader.queue.forEach(function (file, index) {
            filename = removeExtension(file["file"]["name"]);
            if (filename == item["NOMBRE DEL ARCHIVO PDF"]) {
              file["url"] =
                url.IP + "contractors/" + item["contratante"] + "/archivos/";
              item["file"] = file;
              foo.archivos_encontrados_by_id++;
              uploader.queue.splice(index, 1);
            }
          });
          return item;
        });
      }

      uploader.queue = [];
    };

    uploader.onBeforeUploadItem = function (item) {};

    function uploadFiles() {
      $scope.uploader.uploadAll();
    }

    var formdata = new FormData();

    $scope.addFileReceipts = function (key, files) {
      foo.loader = true;
      formdata.append(key, files[0]);
      formdata.append("nombre", files[0].name);
      foo.elementos_receipt_by_id.map(function (item) {
        item["file"] = "Cargado...";
        return item;
      });
      foo.loader = false;
    };
    $scope.addFile = function (key, files) {
      foo.loader = true;
      formdata.append(key, files[0]);
      formdata.append("nombre", files[0].name);
      foo.elementos.map(function (item) {
        item["file"] = "Cargado...";
        return item;
      });
      foo.loader = false;
    };
  }
})();

/* global angular */
(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ColectividadesRenewalCtrl", ColectividadesRenewalCtrl);

  ColectividadesRenewalCtrl.$inject = [
    "dataFactory",
    "SweetAlert",
    "providerService",
    "$scope",
    "$controller",
    "formatValues",
    "$http",
    "url",
    "$stateParams",
    "payform",
    "$sessionStorage",
    "$rootScope",
    "toaster",
    "MESSAGES",
    "helpers",
    "datesFactory",
    "FileUploader",
    "$timeout",
    "$parse",
    "$state",
    "packageService",
    "coverageService",
    "insuranceService",
    "$localStorage",
    "$uibModal",
  ];

  function ColectividadesRenewalCtrl(
    dataFactory,
    SweetAlert,
    providerService,
    $scope,
    $controller,
    formatValues,
    $http,
    url,
    $stateParams,
    payform,
    $sessionStorage,
    $rootScope,
    toaster,
    MESSAGES,
    helpers,
    datesFactory,
    FileUploader,
    $timeout,
    $parse,
    $state,
    packageService,
    coverageService,
    insuranceService,
    $localStorage,
    $uibModal
  ) {
    var order = this;
    $scope.verSubgrupo = true;
    $scope.showSubgroup = true;
    $scope.showContent = false;
    $scope.caratulaSaved = true;
    $scope.newPackage = false;
    $scope.showSaveCat = false;
    $scope.addSubgroupNew = false;
    $scope.categoryNew = false;
    $scope.receits = false;
    $scope.coverRenewed = false;
    order.contador = 0;
    $scope.recibos1 = [];
    $scope.recibos2 = [];
    $scope.referenciadores = [];
    $scope.type_ren = $stateParams.tipo;
    $scope.order = {
      form: {},
    };
    $scope.orderSub = {
      form: {},
    };
    $scope.order.renewal = {};
    $scope.order.renewal.is_renewable = 1;
    $scope.order.renewal.options = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.receipts_option = "on_cover";

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    // Varios referenciadores

    $scope.addReferenciador = function (type) {
      var addReferenciadores = {
        referenciador: $scope.referenciador,
      };
      $scope.referenciadores.push(addReferenciadores);
    };
    $scope.changeReferenciador = function (ref) {
      if (ref) {
        if (ref.data) {
          if (ref.data.url != ref.referenciador) {
            $http.get(ref.referenciador).then(function success(c) {
              var subBranchsComisions =
                c.data.user_info.info_vendedor[0].vendedor_subramos;
              subBranchsComisions.forEach(function (sr) {
                if (
                  (sr.subramo == $scope.caratula.subramo.subramo_code &&
                    sr.provider == $scope.caratula.aseguradora.id) ||
                  (sr.subramo == 0 && sr.provider == 0)
                ) {
                  ref.comision_vendedor = sr.comision;
                  ref.selectedRef = true;
                } else {
                  ref.comision_vendedor = 0;
                  ref.selectedRef = true;
                }
              });
            });
          }
          if (ref.data.url == ref.referenciador) {
            $http.get(ref.referenciador).then(function success(c) {
              var subBranchsComisions =
                c.data.user_info.info_vendedor[0].vendedor_subramos;
              subBranchsComisions.forEach(function (sr) {
                if (
                  (sr.subramo == $scope.caratula.subramo.subramo_code &&
                    sr.provider == $scope.caratula.aseguradora.id) ||
                  (sr.subramo == 0 && sr.provider == 0)
                ) {
                  ref.comision_vendedor = sr.comision;
                  ref.selectedRef = true;
                } else {
                  ref.comision_vendedor = ref.data.comision_policy;
                  ref.selectedRef = true;
                }
              });
            });
          }
        }
      }
      if (ref.referenciador) {
        ref.selectedRef = true;
      } else {
        ref.selectedRef = false;
      }
    };
    $scope.changeComRef = function (com) {};
    $scope.deleteReferenciador = function (index, ref) {
      SweetAlert.swal(
        {
          title: "¿Estás seguro?",
          text: "Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "¡Si!",
          cancelButtonText: "No",
        },
        function (isConfirm) {
          if (isConfirm) {
            if (index && ref.url) {
              // if(ref.url){
              //   $http.delete(ref.url);
              // }
              $scope.referenciadores.splice(index, 1);
            } else {
              // if(ref.url){
              //   $http.delete(ref.url);
              // }
              $scope.referenciadores.splice(index, 1);
            }
          }
        }
      );
    };
    // varios referenciadores
    $scope.show_certificate = false;
    $scope.subgroups = [];
    $scope.categories = [];
    $scope.certificados = [];
    $scope.config_saved = [];
    $scope.order.hidden = true;
    $scope.order.defaults = {
      payform: angular.copy(payform),
    };
    $scope.order.subgroups = [];
    $scope.order.categories = [];

    // Defaults
    $scope.order.show = {
      ot: true,
      receipt: false,
      generateReceipts: false,
      receiptsGenerated: false,
      firstTab: true,
      showForms: false,
      showCoverages: false,
    };
    $scope.orderSub.show = {
      ot: true,
      receipt: false,
      generateReceipts: false,
      receiptsGenerated: false,
      firstTab: true,
      showForms: false,
      showCoverages: false,
    };
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };
    $scope.order.form = {
      poliza_number: "",
      startDate: "",
      endingDate: "",
      internal_number: "",
    };
    $scope.form = {};
    $scope.form.subgrupo = {
      name: "",
      observations: "",
      contratante: "",
      recibos_poliza: [],
      parent: 0,
      caratula: 0,
    };

    $scope.renewalColect = true;
    $scope.verSubgrupo = false;
    $scope.showNewSubgroup = false;
    $scope.verReceipts = true;
    if ($scope.type_ren == 1) {
      $scope.order.show.ot = false;
    } else {
      $scope.order.show.ot = true;
    }
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var DEFAULT = "Default";
    var ADD = "add";
    var NEXT = "next";
    var NOT_GROUP = "notGroup";
    var new_coverage_data = [];
    var NOT_CATEGORY = "notCategory";
    var NEXT_RECEIPTS = "nextReceipts";

    $scope.selectContractor = true;
    $scope.selectedPagkage = false;
    $scope.showNewCoverage = false;
    $scope.showReceipts = false;
    $scope.caratula_receipts = false;
    $rootScope.show_contractor = false;
    $scope.generate_receipts_policy = true;
    $scope.dataToSave = {};
    $scope.caratula = {};
    $scope.excelFile = {};
    $scope.subgroup = {};
    $scope.category = {};
    $scope.coverageName = "";
    $scope.coverages = [];
    $scope.configurations = [];
    $scope.coveragesPackage = [];
    $scope.coveragesConfig = [];
    var startDate = datesFactory.convertDate(new Date());
    var endingDate = datesFactory.convertDate(
      new Date().setYear(new Date().getFullYear() + 1)
    );

    $scope.order.form.startDate = startDate;
    $scope.order.form.endingDate = endingDate;
    $scope.orderSub.form.startDate = startDate;
    $scope.orderSub.form.endingDate = endingDate;
    $scope.accesos = $sessionStorage.permisos;
    if ($scope.accesos) {
      $scope.accesos.forEach(function (perm) {
        if (perm.model_name == "Referenciadores") {
          $scope.acceso_ref = perm;
          $scope.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_adm_ref = true;
              } else {
                $scope.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_pag_ref = true;
              } else {
                $scope.acceso_pag_ref = false;
              }
            } else if (
              acc.permission_name == "Cambiar refrenciador en pólizas"
            ) {
              if (acc.checked == true) {
                $scope.acceso_chg_ref = true;
              } else {
                $scope.acceso_chg_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          $scope.coms = perm;
          $scope.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                $scope.permiso_comisiones = true;
              } else {
                $scope.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          $scope.acceso_files = perm;
          $scope.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                $scope.permiso_archivos = true;
              } else {
                $scope.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    getInternalNumber();

    $http.get(url.IP + "get-vendors/").then(function (user) {
      $scope.users = user.data;

      $scope.show_pagination = true;
      $scope.config_pagination = {
        count: user.data.count,
        next: user.data.next,
        previous: user.data.previous,
      };

      $scope.users.forEach(function (user) {
        user["phones"] = [];
        user["subramos"] = [];
      });
    });

    // $scope.receipts_option = 'on_subgroup';
    // N U E V  O ******************
    // $scope.receits_on_cover = true;

    $scope.receipts_option = "on_subgroup";
    $scope.selectReceiptsOption = function (parValue) {
      if (parValue == "on_subgroup") {
        $scope.receits_on_cover = false;
        $scope.receipts_option = "on_subgroup";
      } else {
        $scope.receits_on_cover = true;
        $scope.receipts_option = "on_cover";
      }
      if ($scope.order.form.comisiones) {
        for (var i = 0; i < $scope.order.form.comisiones.length; i++) {
          if ($scope.order.form.comisiones[i].efective_date == "Sin fecha") {
            $scope.order.form.comisiones.splice(i, 1);
          }
        }
      }
    };
    // ********N U E V O*************

    var d = new Date();
    var curr_date = d.getDate();
    var curr_month = d.getMonth() + 1;
    var curr_year = d.getFullYear();
    var date = curr_year + "-" + curr_month + "-" + curr_date;

    function getInternalNumber() {
      $http({
        method: "POST",
        url: url.IP + "internal-number/",
      })
        .then(
          function success(request) {
            if (request.status === 200 || request.status === 201) {
              $scope.order.form.internal_number = "OT000" + request.data.id;
              $scope.internal_number = "OT000" + request.data.id;
              $scope.caratula.internal_number =
                $scope.order.form.internal_number;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
      SweetAlert.swal(
        "Advertencia",
        "Al renovar esta colectividad, todos los certificados contenidos en esta vigencia pasaran a un estado inactivo., sin la posibilidad de revertirse el cambio.",
        "warning"
      );
    }

    $scope.goToList = function () {
      $state.go("colectividades.info", {
        polizaId: $scope.renovacionCaratula.id,
      });
    };

    $scope.existSubgroup = function (param) {
      if (param == 1) {
        $scope.exist_subgroup = true;
      } else {
        $scope.exist_subgroup = false;
      }
    };

    $scope.existCategoria = function (param) {
      if (param == 1) {
        $scope.exist_category = true;
      } else {
        $scope.exist_category = false;
      }
    };
    function mesDiaAnio(parDate) {
      var d = new Date(toDate(parDate));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      return date;
    }

    $scope.checkDate = function () {
      console.log($scope.order.form);
      $scope.order.form.startDate = $scope.caratula.start_of_validity;
      $scope.order.form.endingDate = $scope.caratula.end_of_validity;
    };

    providerService
      .getProviderByKey(date)
      .then(
        function success(data) {
          $scope.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      )
      .catch(function (e) {
        console.log("error", e);
      });

    $http({
      method: "GET",
      url: url.IP + "get-caratula/" + $stateParams.polizaId + "/",
    })
      .then(
        function success(request) {
          if (request.status === 200) {
            $scope.caratula = request.data;
            $scope.inicio_vigencia = moment($scope.caratula.start_of_validity)
              .add(1, "years")
              .format();
            $scope.fin_vigencia = moment($scope.caratula.end_of_validity)
              .add(1, "years")
              .format();

            $scope.inicio_vigencia_renovacion = $scope.inicio_vigencia;
            $scope.fin_vigencia_renovacion = $scope.fin_vigencia;
            // console.log("$scope.inicio_vigencia_renovacion",$scope.caratula.start_of_validity,$scope.caratula.end_of_validity)
            //console.log("$scope.fin_vigencia_renovacion",$scope.fin_vigencia_renovacion)

            $scope.caratulaId = request.data.id;
            $scope.caratula = request.data;
            $scope.caratula_poliza_number = request.data.poliza_number;
            $scope.caratula.poliza_number = "";
            $scope.order.renewal.is_renewable = $scope.caratula.is_renewable;
            $scope.order.renewal.selected = $scope.caratula.is_renewable;
            $scope.caratula.startDate = convertDate(
              $scope.caratula.start_of_validity
            );
            $scope.caratula.endingDate = convertDate(
              $scope.caratula.end_of_validity
            );
            $scope.order.form.startDate = convertDate($scope.inicio_vigencia);
            $scope.order.form.endingDate = convertDate($scope.fin_vigencia);
            $scope.caratula.payment = $scope.caratula.forma_de_pago;
            $scope.caratula.start_of_validity = convertDate(
              $scope.inicio_vigencia_renovacion
            ); //convertDate($scope.caratula.start_of_validity);
            $scope.caratula.end_of_validity = convertDate(
              $scope.fin_vigencia_renovacion
            ); //convertDate($scope.caratula.end_of_validity);
            $scope.aseguradoraSelection();
            $scope.changeRamo();
            $scope.caratulaToSaveOld = {};
            $scope.caratulaToSaveOld.renewed = true;
            $scope.caratulaToSaveOld.aseguradora =
              $scope.caratula.aseguradora.url;
            $scope.caratulaToSaveOld.clave = $scope.caratula.clave.url;
            $scope.caratulaToSaveOld.document_type = 3;
            $scope.caratulaToSaveOld.id = $scope.caratula.id;
            $scope.caratulaToSaveOld.identifier = $scope.caratula.identifier;
            $scope.caratulaToSaveOld.internal_number =
              $scope.caratula.internal_number;
            $scope.caratulaToSaveOld.poliza_number =
              $scope.caratula.poliza_number;
            $scope.caratulaToSaveOld.start_of_validity =
              $scope.caratula.start_of_validity; //new Date($scope.caratula.start_of_validity)
            $scope.caratulaToSaveOld.end_of_validity =
              $scope.caratula.end_of_validity; //new Date($scope.caratula.end_of_validity)
            $scope.caratulaToSaveOld.f_currency =
              $scope.caratula.f_currency == "Pesos" ? 1 : 2;
            $scope.caratulaToSaveOld.ramo = $scope.caratula.ramo.url;
            $scope.caratulaToSaveOld.subramo = $scope.caratula.subramo.url;
            $scope.caratulaToSaveOld.natural = $scope.caratula.natural
              ? $scope.caratula.natural.url
              : null;
            $scope.caratulaToSaveOld.juridical = $scope.caratula.juridical
              ? $scope.caratula.juridical.url
              : null;
            $scope.caratulaToSaveOld.vendor = $scope.caratula.vendor
              ? $scope.caratula.vendor.url
              : null;
            $scope.caratulaToSaveOld.administration_type = $scope.caratula
              .administration_type
              ? $scope.caratula.administration_type
              : null;

            // ------------------------------------elimina recibos
            if ($scope.caratula.recibos_poliza.length) {
              $scope.receits_on_cover = true;
              $scope.receipts_option = "on_cover";
            } else {
              $scope.receits_on_cover = false;
              $scope.receipts_option = "on_subgroup";
            }
            if ($scope.caratula.recibos_poliza.length) {
              $scope.generate_receipts_policy = true;
              $scope.caratula.recibos_poliza = [];
            }
            if (request.data.natural) {
              $scope.cover_contractor = request.data.natural;
              $scope.cover_contractor.direccion =
                request.data.natural.address_natural[0];
            } else {
              $scope.cover_contractor = request.data.juridical;
              $scope.cover_contractor.direccion =
                request.data.juridical.address_juridical[0];
            }
            if (
              $scope.caratula.forma_de_pago == "ANUAL" ||
              $scope.caratula.forma_de_pago == 12
            ) {
              $scope.order.form.payment = 12;
              $scope.orderSub.form.payment = 12;
              // $scope.caratula.payment = "ANUAL";
            } else if (
              $scope.caratula.forma_de_pago == "SEMESTRAL" ||
              $scope.caratula.forma_de_pago == 6
            ) {
              $scope.order.form.payment = 6;
              $scope.orderSub.form.payment = 6;
              // $scope.caratula.payment = "SEMESTRAL";
            } else if (
              $scope.caratula.forma_de_pago == "CONTADO" ||
              $scope.caratula.forma_de_pago == 5
            ) {
              $scope.order.form.payment = 5;
              $scope.orderSub.form.payment = 5;
              // $scope.caratula.payment = "CONTADO";
            } else if (
              $scope.caratula.forma_de_pago == "TRIMESTRAL" ||
              $scope.caratula.forma_de_pago == 3
            ) {
              $scope.order.form.payment = 3;
              $scope.orderSub.form.payment = 3;
              // $scope.caratula.payment = "TRIMESTRAL";
            } else if (
              $scope.caratula.forma_de_pago == "BIMESTRAL" ||
              $scope.caratula.forma_de_pago == 2
            ) {
              $scope.order.form.payment = 2;
              $scope.orderSub.form.payment = 2;
              // $scope.caratula.payment = "BIMESTRAL";
            } else if (
              $scope.caratula.forma_de_pago == "MENSUAL" ||
              $scope.caratula.forma_de_pago == 1
            ) {
              $scope.order.form.payment = 1;
              $scope.orderSub.form.payment = 1;
              // $scope.caratula.payment = "MENSUAL";
            }
            $scope.order.defaults = {
              payform: angular.copy(payform),
            };
            $scope.order.defaults.payform.forEach(function (i) {
              // console.log('i',i,$scope.caratula)
              if ($scope.caratula.forma_de_pago == i.value) {
                $scope.caratula.payment = 0;
                $scope.caratula.payment = i;
                $scope.isReceiptAvailable(i);
              }
            });
            $scope.order.form.payment = $scope.caratula.forma_de_pago;
            $scope.order.adminType = $scope.caratula.administration_type;
            $scope.order.form.receipts = $scope.caratula.recibos_poliza;
            $scope.order.form.ramo = $scope.caratula.ramo;
            $scope.order.form.subramo = $scope.caratula.subramo;
            $scope.orderSub.form.payment = $scope.caratula.forma_de_pago;
            $scope.orderSub.form.forma_de_pago = $scope.orderSub.payment;
            $scope.orderSub.form.receipts = $scope.caratula.recibos_poliza;
            $scope.orderSub.form.ramo = $scope.caratula.ramo;
            $scope.orderSub.form.subramo = $scope.caratula.subramo;
            $scope.caratula.internal_number = $scope.order.form.internal_number;
            var date1 = new Date($scope.caratula.start_of_validity);
            var date2 = new Date($scope.caratula.end_of_validity);
            var timeDiff = Math.abs(date2.getTime() - date1.getTime());
            $scope.order.form.policy_days_duration = Math.ceil(
              timeDiff / (1000 * 3600 * 24)
            );

            // Varios referenciadores
            $http.get(url.IP + "get-vendors").then(
              function success(data) {
                $scope.referenciador = data.data;
                $scope.referenciador.forEach(function (vendor) {
                  vendor.name = vendor.first_name + " " + vendor.last_name;
                });
              },
              function error(error) {
                toaster.ERROR("No pudieron ser cargados los referenciadores");
              }
            );
            try {
              if ($scope.caratula.ref_policy.length > 0) {
                $scope.caratula.ref_policy.forEach(function (refs) {
                  $http
                    .get(refs.referenciador)
                    .then(function success(response_ref_plicy) {
                      if (response_ref_plicy) {
                        refs.data = response_ref_plicy.data;
                        refs.referenciador = response_ref_plicy.data.url;
                        refs.data.comision_policy = refs.comision_vendedor;
                        refs.selectedRef = true;
                        $scope.referenciadores.push(refs);
                      }
                    });
                });
              } else if ($scope.caratula.vendor) {
                $http
                  .get($scope.caratula.vendor.url)
                  .then(function success(response_ref_plicy_vendor) {
                    var s_r =
                      response_ref_plicy_vendor.data.user_info.info_vendedor[0]
                        .vendedor_subramos;
                    s_r.forEach(function (sr) {
                      if (
                        sr.subramo == $scope.caratula.subramo.subramo_code &&
                        sr.provider == $scope.caratula.aseguradora.id
                      ) {
                        if (response_ref_plicy_vendor) {
                          response_ref_plicy_vendor.data =
                            response_ref_plicy_vendor.data;
                          response_ref_plicy_vendor.referenciador =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.vendor =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.comision_vendedor =
                            sr.comision;
                          response_ref_plicy_vendor.data.comision_policy =
                            response_ref_plicy_vendor.comision_vendedor;
                          response_ref_plicy_vendor.selectedRef = true;
                          $scope.referenciadores.push(
                            response_ref_plicy_vendor
                          );
                        }
                      } else if (sr.subramo == 0 && sr.provider == 0) {
                        if (response_ref_plicy_vendor) {
                          response_ref_plicy_vendor.data =
                            response_ref_plicy_vendor.data;
                          response_ref_plicy_vendor.referenciador =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.vendor =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.comision_vendedor =
                            sr.comision;
                          response_ref_plicy_vendor.data.comision_policy =
                            response_ref_plicy_vendor.comision_vendedor;
                          response_ref_plicy_vendor.selectedRef = true;
                          $scope.referenciadores.push(
                            response_ref_plicy_vendor
                          );
                        }
                      } else if (sr.subramo == 0 && sr.provider == -1) {
                        if (response_ref_plicy_vendor) {
                          response_ref_plicy_vendor.data =
                            response_ref_plicy_vendor.data;
                          response_ref_plicy_vendor.referenciador =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.vendor =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.comision_vendedor =
                            sr.comision;
                          response_ref_plicy_vendor.data.comision_policy =
                            response_ref_plicy_vendor.comision_vendedor;
                          response_ref_plicy_vendor.selectedRef = true;
                          $scope.referenciadores.push(
                            response_ref_plicy_vendor
                          );
                        }
                      } else if (sr.subramo == 0 && sr.provider == -2) {
                        if (response_ref_plicy_vendor) {
                          response_ref_plicy_vendor.data =
                            response_ref_plicy_vendor.data;
                          response_ref_plicy_vendor.referenciador =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.vendor =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.comision_vendedor =
                            sr.comision;
                          response_ref_plicy_vendor.data.comision_policy =
                            response_ref_plicy_vendor.comision_vendedor;
                          response_ref_plicy_vendor.selectedRef = true;
                          $scope.referenciadores.push(
                            response_ref_plicy_vendor
                          );
                        }
                      }
                    });
                    // if(response_ref_plicy_vendor){
                    //   response_ref_plicy_vendor.data = response_ref_plicy_vendor.data
                    //   response_ref_plicy_vendor.referenciador = response_ref_plicy_vendor.data.url
                    //   response_ref_plicy_vendor.vendor = response_ref_plicy_vendor.data.url
                    //   response_ref_plicy_vendor.comision_vendedor = response_ref_plicy_vendor.data.user_info.info_vendedor[0].comision_vendedor
                    //   $scope.referenciadores.push(response_ref_plicy_vendor)
                    // }
                  });
              } else {
                $scope.referenciadores.push($scope.referenciador);
              }
            } catch (e) {
              console.log(":::::..referenciador varios::error:::::.", e);
            }
            // Varios refs
            $scope.dataToSave = $scope.order;
            $scope.dataToSaveSubg = $scope.orderSub;
            $scope.selectReceiptsOption($scope.receipts_option);
            if ($stateParams.tipo != 1) {
              $scope.show_receipts = true;
            } else {
              $scope.show_receipts = false;
            }
          }
        },
        function error(error) {}
      )
      .catch(function (e) {
        console.log(e);
      });
    $scope.caratulaToSave = {};
    $scope.renewalSelection = function () {
      $scope.caratulaToSave.is_renewable = $scope.order.renewal.selected;
    };
    $scope.changeUntil_1 = function () {
      var since = toDate($scope.order.form.startDate).getTime();
      var until = toDate($scope.order.form.endingDate).getTime();
      var diff = until - since;
      var date = toDate($scope.order.form.startDate);
      var date1 = toDate($scope.order.form.endingDate);
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        var newdate = new Date();
        var since = toDate($scope.order.form.startDate).getTime();
        var date = toDate($scope.order.form.startDate);
        var date1 = toDate($scope.order.form.endingDate);
        $scope.order.form.startDate = new Date(
          date1.setYear(date1.getFullYear() - 1)
        );
        $scope.order.form.startDate = convertDate($scope.order.form.startDate);
        // $scope.order.form.endingDate = convertDate($scope.order.form.endingDate);
        // $scope.dataToSave.start_of_validity = new Date(datesFactory.mesDiaAnio($scope.order.form.startDate))
        // $scope.dataToSave.end_of_validity = new Date(datesFactory.mesDiaAnio($scope.order.form.endingDate));
        $scope.caratulaToSave.start_of_validity = new Date(
          datesFactory.mesDiaAnio($scope.order.form.startDate)
        );
        $scope.caratulaToSave.end_of_validity = new Date(
          datesFactory.mesDiaAnio($scope.order.form.endingDate)
        );
      }
    };

    // --*Guardar como no Renovación
    $scope.cloneColectNR = function () {
      // guardar como no renovación
      $scope.dataToSave = angular.copy(order.form);
      if ($scope.dataToSave.start_of_validity) {
        var startDate = new Date($scope.dataToSave.start_of_validity).setHours(
          12,
          0,
          0,
          0
        );
        var endingDate = new Date($scope.dataToSave.end_of_validity).setHours(
          11,
          59,
          59,
          0
        );
        $scope.dataToSave.startDate = new Date(startDate);
        $scope.dataToSave.endingDate = new Date(endingDate);
      } else {
        var startDate = new Date(
          mesDiaAnio($scope.dataToSave.startDate)
        ).setHours(12, 0, 0, 0);
        var endingDate = new Date(
          mesDiaAnio($scope.dataToSave.endingDate)
        ).setHours(11, 59, 59, 0);
        $scope.dataToSave.startDate = new Date(startDate);
        $scope.dataToSave.endingDate = new Date(endingDate);
      }

      if (!canBePoliza()) {
        return;
      } /*Validación de contratante */
      if (!validate2()) {
        return;
      } /*Validación de recibos y no. póliza */

      $q.all([
        helpers.existPolicyNumber("renovaciones_modulo").then(checkPromise),
      ]).then(function (val) {
        if (val[0] === true) {
          l.stop();
          SweetAlert.swal("Error", "Esta número de póliza ya existe.", "error");
        } else {
          if ($scope.dataToSave.start_of_validity) {
            var startDate = new Date(
              $scope.dataToSave.start_of_validity
            ).setHours(12, 0, 0, 0);
            var endingDate = new Date(
              $scope.dataToSave.end_of_validity
            ).setHours(11, 59, 59, 0);
            $scope.dataToSave.startDate = new Date(startDate);
            $scope.dataToSave.endingDate = new Date(endingDate);
          } else {
            var startDate = new Date(
              mesDiaAnio($scope.dataToSave.startDate)
            ).setHours(12, 0, 0, 0);
            var endingDate = new Date(
              mesDiaAnio($scope.dataToSave.endingDate)
            ).setHours(11, 59, 59, 0);
            $scope.dataToSave.startDate = new Date(startDate);
            $scope.dataToSave.endingDate = new Date(endingDate);
          }

          $scope.dataToSave.contratante = $scope.dataToSave.contratante.value;

          var form = angular.copy($scope.dataToSave);
          var fromDate = $scope.dataToSave.startDate;
          var today = new Date(new Date().toISOString().split("T")[0]);
          var obsevaciones = $scope.dataToSave.observations;
          form = getFormData(form);
          form.observations = obsevaciones;

          var auxDate = new Date(
            $scope.dataToSave.startDate.getTime() - 86400000
          );
          form.status = auxDate > new Date() ? 10 : 14;

          form.address = $scope.dataToSave.address.url;
          form.clave = $scope.dataToSave.clave.url;
          form.f_currency = order.f_currency;

          form.p_neta = order.poliza.primaNeta;
          form.p_total = order.poliza.primaTotal;
          form.derecho = order.poliza.derecho;
          form.rpf = order.poliza.rpf;
          form.iva = order.poliza.iva;

          // if (order.recibos_poliza.length == 0) {
          if (order.recibos_poliza.length == 0 && $scope.receits_on_cover) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.RECEIPTSREQUIRED, "error");
            return;
          }

          if (order.receipts.length) {
            order.receipts.forEach(function (item) {
              var init = new Date(mesDiaAnio(item.startDate)).setHours(
                12,
                0,
                0,
                0
              );
              var end = new Date(mesDiaAnio(item.endingDate)).setHours(
                11,
                59,
                59,
                0
              );

              item.startDate = new Date(init);
              item.endingDate = new Date(end);
              if (item.vencimiento) {
                var vencimiento = new Date(toDate(item.vencimiento)).setHours(
                  11.59,
                  59,
                  0
                );
                item.vencimiento = new Date(vencimiento);
              }
            });
          }

          var url = angular.copy(order.defaults);

          if ($scope.dataToSave.ceder_comision) {
            form.udi = $scope.dataToSave.udi;
            if ($scope.dataToSave.comision_percent) {
              form.comision_percent = $scope.dataToSave.comision_percent;
            } else {
              form.comision_percent = $scope.dataToSave.comision_percent;
            }
          } else {
            if ($scope.dataToSave.comision_percent) {
              form.comision_percent = $scope.dataToSave.comision_percent;
            } else {
              form.comision_percent = $scope.dataToSave.comision_percent;
            }
            form.udi = $scope.dataToSave.clave.udi;
          }

          if ($scope.dataToSave.udi) {
            form.udi = $scope.dataToSave.udi;
            form.comision = $scope.dataToSave.comision;
          } else {
            if ($scope.dataToSave.comision) {
              form.udi = $scope.dataToSave.comision.udi;
              var percent_ =
                parseInt($scope.dataToSave.comision.comission) / 100;
              form.comission = $scope.dataToSave.comision;
            } else {
              form.udi = 0;
              var percent_ =
                parseInt($scope.dataToSave.comision.comission) / 100;
              form.comission = $scope.dataToSave.comision;
            }
          }

          if ($scope.dataToSave.comision_percent) {
            var percent_ = parseFloat($scope.dataToSave.comision_percent) / 100;
            form.comision = $scope.dataToSave.comision;
          } else {
            var percent_ =
              parseFloat($scope.dataToSave.comision.comission) / 100;
            form.comission = $scope.dataToSave.comision;
          }

          form.internal_number = $scope.internal_number;

          /* Creación de la póliza */
          insuranceService.createInsurance(form).then(function (res) {
            // if($scope.poliza_data.status == 13){
            var data = {
              renewed: true,
              renewed_status: 1,
              status: 12,
            };
            /* Actualiza la póliza antigua */
            $http.patch($scope.poliza_data.url, data);
            // }

            /* Relación con la póliza original */
            var oldPolicy = {
              policy: myInsurance.poliza_number,
              base_policy: myInsurance.url,
              new_policy: res.url,
            };

            insuranceService
              .createOldPolicy(oldPolicy)
              .then(function (responseOldPolicy) {});

            /* Sube archivos */
            uploadFiles(res.id);

            order.defaults.policyUrl = res.url;
            url.policyUrl = { url: res.url };

            toaster.success(MESSAGES.OK.RENEWALPOLICY);
            var code = order.defaults.formInfo.code;

            /* Guarda coberturas */
            if (order.defaults.coverages.length > 0) {
              for (var i = 0; i < order.defaults.coverages.length; i++) {
                order.defaults.coverages[i].sum_insured =
                  order.defaults.coverages[i].sumInPolicy.value;
                order.defaults.coverages[i].deductible =
                  order.defaults.coverages[i].deductibleInPolicy.value;
                order.defaults.coverages[i].coinsurance = order.defaults
                  .coverages[i].coinsuranceInPolicy.value
                  ? order.defaults.coverages[i].coinsuranceInPolicy.value
                  : 0;
              }
              helpers.createCoverages(order.defaults.coverages, res);
            }

            SweetAlert.swal("Hecho", MESSAGES.OK.NEWPOLICY, "success");
            $state.go("polizas.info", { polizaId: res.id });
          });

          setTimeout(function () {
            order.receipts.forEach(function (receipt, index) {
              var initDate = new Date(receipt.startDate);
              var endDate = new Date(receipt.endingDate);
              var vencimiento = new Date(receipt.vencimiento);

              var saveReceiptRequest = {
                poliza: url.policyUrl.url,
                recibo_numero: index + 1,
                prima_neta: receipt.prima,
                rpf: receipt.rpf,
                derecho: receipt.derecho,
                iva: receipt.iva,
                sub_total: receipt.subTotal,
                prima_total: receipt.total,
                status: 4,
                startDate: new Date(initDate),
                endingDate: new Date(endDate),
                fecha_inicio: new Date(initDate),
                fecha_fin: new Date(endDate),
                vencimiento: new Date(vencimiento),
                description: "",
                receipt_type: 1,
                comision: parseFloat(receipt.comision).toFixed(2),
              };

              receiptService
                .createReceiptService(saveReceiptRequest)
                .then(function (response) {});
            });
          }, 1000);
        }
      });
    };

    $scope.percentageRange = function (input, index) {
      if (input < 0) {
        $scope.config_coverages.coveragesConfig[
          index
        ].coinsuranceInPolicy.value = 0;
      }
      if (input > 100) {
        $scope.config_coverages.coveragesConfig[
          index
        ].coinsuranceInPolicy.value = 100;
      }
    };

    $scope.cancel_noren = function () {
      $state.go("renovaciones.renovaciones");
    };
    // ----*Guardar como no Renovación

    $scope.changeAdminType = function () {
      $scope.dataToSave.adminType = $scope.order.adminType;

      if ($scope.order.adminType == "Autoadministrada") {
        $scope.caratulaToSave.administration_type = 2;
      } else if ($scope.order.adminType == "Simplificada") {
        $scope.caratulaToSave.administration_type = 1;
      } else {
        $scope.caratulaToSave.administration_type = 3;
      }
    };

    $scope.change_fp = false;
    $scope.isReceiptAvailable = function (form_payment) {
      $scope.caratulaToSave.forma_de_pago = form_payment.value;
      $scope.caratulaToSave.payment = form_payment.label;
      // $scope.caratula.payment = form_payment.value;
      $scope.order.form.payment = form_payment.value;
      if (
        $scope.caratulaToSave.forma_de_pago != $scope.caratula.forma_de_pago
      ) {
        SweetAlert.swal(
          "Advertencia",
          "Generar recibos es necesario",
          "warning"
        );
        if ($scope.caratula.receipts_by == 1) {
          $scope.receits_on_cover = true;
          $scope.receipts_option = "on_cover";
          $scope.change_fp = true;
          $scope.showContent = true;
          $scope.order.form.payment = form_payment.value;
        } else {
          if ($scope.caratula.status != "En trámite") {
            $scope.order.show.ot = false;
          }
          $scope.receits_on_cover = false;
          $scope.receipts_option = "on_subgroup";
          $scope.selectContractor = true;
          $scope.show_receipts = true;
          $scope.change_fp = true;
          $scope.order.form.payment = form_payment.value;
        }
      } else {
        $scope.change_fp = false;
      }
    };

    $scope.alertP = function (value) {
      if (value == 1) {
        SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
      } else if (value == 2) {
        SweetAlert.swal("Error", MESSAGES.ERROR.IDENTIFIERREQUIRED, "error");
      } else if (value == 3) {
        // SweetAlert.swal("Error", MESSAGES.ERROR.RECEIPTSREQUIRED, "error");
        if ($scope.receits_on_cover) {
          SweetAlert.swal("Error", MESSAGES.ERROR.RECEIPTSREQUIRED, "error");
          return;
        } else {
          SweetAlert.swal(
            "Infor",
            "Los recibos se deben crear en cada Subgrupo",
            "warning"
          );
          $scope.receits_on_cover = false;
          $scope.receipts_option = "on_subgroup";
        }
      }
    };

    $scope.savaCopyRenovacion = function () {
      SweetAlert.swal(
        {
          title: "¿Copiar la colectividad original?",
          text: "Se copiaran los grupos, certificados y paquetes de la colectividad original y no podra modificarlos.",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data = {
              new_id: $scope.renovacionCaratula.id,
              old_id: $scope.caratula.id,
              clone_certs: 0,
            };
            dataFactory
              .post("copy-data-renewal/", data)
              .then(function success(response) {
                if (response.status == 200) {
                  swal("¡Listo!", "Se ha renovado correctamente", "success");
                  $state.go("colectividades.info", {
                    polizaId: $scope.renovacionCaratula.id,
                  });
                }
              });
            $scope.currentIndex = 4;
          } else {
            swal(
              "¡Entendido!",
              "Sigue los pasos para renovar la coletividad",
              "success"
            );
            return;
          }
        }
      );
    };

    $scope.saveCaratulaRenovacion = function () {
      // $scope.order.show.ot = true;
      // $scope.receits_on_cover == false;
      if ($scope.type_ren == 1) {
        $scope.order.show.ot = false;
      } else {
        $scope.order.show.ot = true;
      }

      // if($scope.order.show.ot && $scope.receits_on_cover == false) {
      //   $scope.dataToSave.receipts = [];
      //   $scope.dataToSave.poliza = {
      //     iva: 0,
      //     p_total: 0,
      //     derecho: 0,
      //     rpf: 0,
      //     p_neta: 0
      //   }
      // }

      // $scope.dataToSave.poliza = {
      //   iva: $scope.dataToSave.iva,
      //   p_total: $scope.dataToSave.prima_total,
      //   derecho: $scope.dataToSave.derecho,
      //   rpf: $scope.dataToSave.rpf,
      //   p_neta: $scope.dataToSave.prima_neta
      // }
      try {
        if (
          $scope.dataToSave.poliza.p_neta == undefined ||
          !$scope.dataToSave.poliza.p_neta
        ) {
          if ($scope.dataToSave.form.p_neta) {
            $scope.dataToSave.p_neta = parseFloat(
              $scope.dataToSave.form.p_neta
            ).toFixed(2);
          }
        }
        if (
          $scope.dataToSave.poliza.p_total == undefined ||
          !$scope.dataToSave.poliza.p_total
        ) {
          if ($scope.dataToSave.form.p_total) {
            $scope.dataToSave.p_total = parseFloat(
              $scope.dataToSave.form.p_total
            ).toFixed(2);
          }
        }
      } catch (err) {
        $scope.dataToSave.poliza = {
          iva: $scope.dataToSave.iva,
          p_total: $scope.dataToSave.prima_total,
          derecho: $scope.dataToSave.derecho,
          rpf: $scope.dataToSave.rpf,
          p_neta: $scope.dataToSave.prima_neta,
        };
      }
      if (
        $scope.dataToSave.poliza.aplicarDescuento == undefined ||
        $scope.dataToSave.poliza.aplicarDescuento == false
      ) {
        var applyDesc = 0;
      } else {
        var applyDesc = $scope.dataToSave.poliza.descuento;
      }
      /* Actualiza la póliza anterior */
      var data = {
        status: 12,
        renewed: true,
      };

      $http.patch($scope.caratula.url, data);

      $scope.caratulaToSave = {};
      $scope.caratulaToSave.aseguradora = $scope.caratula.aseguradora.id;
      $scope.caratulaToSave.clave = $scope.caratula.clave.id;
      $scope.caratulaToSave.ramo = $scope.caratula.ramo.id;
      $scope.caratulaToSave.subramo = $scope.caratula.subramo.id;
      $scope.caratulaToSave.document_type = 3;
      $scope.caratulaToSave.f_currency =
        $scope.caratula.f_currency == "Pesos" ? 1 : 2;
      $scope.caratulaToSave.natural = $scope.caratula.natural
        ? $scope.caratula.natural.id
        : null;
      $scope.caratulaToSave.juridical = $scope.caratula.juridical
        ? $scope.caratula.juridical.id
        : null;
      $scope.caratulaToSave.folio = $scope.caratula.folio;
      $scope.caratulaToSave.identifier = $scope.caratula.identifier;
      $scope.caratulaToSave.internal_number = $scope.order.form.internal_number;
      $scope.caratulaToSave.poliza_number = $scope.caratula.poliza_number;
      $scope.caratulaToSave.observations = $scope.caratula.observations;
      $scope.caratulaToSave.forma_de_pago = $scope.order.form.payment;
      $scope.caratulaToSave.end_of_validity = new Date(
        datesFactory.mesDiaAnio($scope.caratula.end_of_validity)
      );
      $scope.caratulaToSave.start_of_validity = new Date(
        datesFactory.mesDiaAnio($scope.caratula.start_of_validity)
      );
      $scope.caratulaToSave.vendor = $scope.caratula.vendor
        ? $scope.caratula.vendor.id
        : null;
      $scope.caratulaToSave.is_renewable = $scope.order.renewal.selected;

      $scope.caratulaToSave.p_neta = $scope.dataToSave.poliza.primaNeta;
      $scope.caratulaToSave.p_total = $scope.dataToSave.poliza.primaTotal;
      $scope.caratulaToSave.rpf = $scope.dataToSave.poliza.rpf;
      $scope.caratulaToSave.derecho = $scope.dataToSave.poliza.derecho;
      $scope.caratulaToSave.iva = $scope.dataToSave.poliza.iva;
      $scope.caratulaToSave.descuento = applyDesc;
      if ($scope.receipts_option == "on_cover" || $scope.receits_on_cover) {
        $scope.caratulaToSave.receipts_by = 1;
      } else {
        if (
          $scope.receipts_option == "on_subgroup" ||
          !$scope.receits_on_cover
        ) {
          $scope.caratulaToSave.receipts_by = 2;
        }
      }

      var auxDate =
        new Date(
          new Date(datesFactory.mesDiaAnio($scope.order.form.startDate))
        ).getTime() - 86400000;
      if (auxDate < new Date() && new Date() < $scope.order.form.endingDate) {
        $scope.caratulaToSave.status = 14;
      } else if (auxDate > new Date()) {
        $scope.caratulaToSave.status = 10;
      } else if (new Date() > $scope.order.form.endingDate) {
        $scope.caratulaToSave.status = 13;
      } else {
        $scope.caratulaToSave.status = 14;
      }
      /* Recibos */
      if ($scope.caratulaToSave.status != 1) {
        if ($scope.dataToSave.recibos_poliza) {
          $scope.dataToSave.recibos_poliza.forEach(function (recibo) {
            var receipt_init = new Date(
              datesFactory.toDate(recibo.startDate)
            ).setHours(11, 59, 59);
            var receipt_end = new Date(
              datesFactory.toDate(recibo.endingDate)
            ).setHours(12, 0, 0);

            recibo.fecha_fin = new Date(receipt_end);
            recibo.fecha_inicio = new Date(receipt_init);
            recibo.startDate = new Date(receipt_init);
            recibo.endingDate = new Date(receipt_end);
            if (isNaN(recibo.comision)) {
              recibo.comision = 0;
            } else {
              recibo.comision = recibo.comision;
            }

            if (recibo.vencimiento) {
              var vencimiento = new Date(toDate(recibo.vencimiento)).setHours(
                11.59,
                59,
                0
              );
              recibo.vencimiento = new Date(vencimiento);
            }
          });
          $scope.caratulaToSave.recibos_poliza =
            $scope.dataToSave.recibos_poliza;
        } else {
          $scope.caratulaToSave.recibos_poliza = [];
        }
      } else {
        $scope.caratulaToSave.recibos_poliza = [];
      }

      // return;

      /* Creación de la nueva póliza */
      if ($scope.order.adminType == "Autoadministrada") {
        $scope.caratulaToSave.administration_type = 2;
      } else if ($scope.order.adminType == "Simplificada") {
        $scope.caratulaToSave.administration_type = 1;
      } else {
        $scope.caratulaToSave.administration_type = 3;
      }
      // $scope.caratulaToSave.administration_type = $scope.order.adminType == 'Autoadministrada' ? 2 : 1;

      if (order.contador == 0) {
        $http({
          method: "POST",
          url: url.IP + "caratulas/",
          data: $scope.caratulaToSave,
        }).then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            //varios referenciadores
            for (var i = 0; i < $scope.referenciadores.length; i++) {
              $scope.referenciadores[i].policy = response.data.url;
              $scope.ref_policy = $scope.referenciadores[i];
              if ($scope.ref_policy) {
                if ($scope.referenciadores[i].referenciador) {
                  var ref = {};
                  ref.referenciador = $scope.referenciadores[i].referenciador;
                  ref.comision_vendedor = $scope.referenciadores[i]
                    .comision_vendedor
                    ? $scope.referenciadores[i].comision_vendedor
                    : 0;
                  ref.policy = response.data.url;
                  dataFactory
                    .post("referenciadores-policy/", ref)
                    .then(
                      function success(request) {},
                      function error(error) {
                        console.log(error);
                      }
                    )
                    .catch(function (e) {
                      console.log(e);
                    });
                }
              }
            }
            // varios referenciadores
            order.contador = order.contador + 1;
            $scope.renovacionCaratula = response.data;
            $scope.renovacionCaratulaId = $scope.renovacionCaratula.id;
            /* Relación con la póliza original */
            var oldPolicy = {
              policy: $scope.caratula.poliza_number,
              base_policy: $scope.caratula.url,
              new_policy: response.data.url,
            };

            insuranceService
              .createOldPolicy(oldPolicy)
              .then(function (responseOldPolicy) {
                toaster.success("Póliza renovada, creación de histórico");
                // console.log('responseOldPolicy',responseOldPolicy,oldPolicy)
              });

            if ($scope.caratulaToSave.status != 1) {
              $scope.coverRenewed = true;
              $scope.verSubgrupo = true;
            } else {
              $scope.coverRenewed = false;
              $scope.verSubgrupo = false;
              if ($scope.renovacionCaratula.document_type == 3) {
                $state.go("colectividades.info", {
                  polizaId: $scope.renovacionCaratula.id,
                });
              }
            }

            var params = {
              model: 18,
              event: "POST",
              associated_id: response.data.id,
              identifier:
                "creó la renovación a partir de la colectividad " +
                $scope.caratula_poliza_number +
                ".",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});

            var params = {
              model: 18,
              event: "POST",
              associated_id: $scope.caratula.id,
              identifier:
                "renovó la colectividad a " + response.data.poliza_number + ".",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          }
        });
      }
      $scope.savaCopyRenovacion();
    };
    // Renovacion OT
    $scope.saveOTRenovacion = function () {
      // $scope.order.show.ot = true;
      // $scope.receits_on_cover == false;
      if ($scope.type_ren == 1) {
        $scope.order.show.ot = false;
      } else {
        $scope.order.show.ot = true;
      }

      if ($scope.order.show.ot && $scope.receits_on_cover == false) {
        $scope.dataToSave.receipts = [];
        $scope.dataToSave.poliza = {
          iva: 0,
          p_total: 0,
          derecho: 0,
          rpf: 0,
          p_neta: 0,
        };
      }

      /* Actualiza la póliza anterior */
      // var data = {
      //   // status : 2,
      //   renewed_status: 2
      // }
      if ($scope.caratula.status == 13) {
        var data = {
          renewed: true,
          status: 12,
          renewed_status: 2,
        };
      } else {
        var data = {
          renewed: true,
          status: 12,
          renewed_status: 2,
        };
      }

      $http.patch($scope.caratula.url, data);

      $scope.caratulaToSave = {};
      $scope.caratulaToSave.aseguradora = $scope.caratula.aseguradora.id;
      $scope.caratulaToSave.receipts_by = $scope.caratula.receipts_by;
      $scope.caratulaToSave.clave = $scope.caratula.clave.id;
      $scope.caratulaToSave.ramo = $scope.caratula.ramo.id;
      $scope.caratulaToSave.subramo = $scope.caratula.subramo.id;
      $scope.caratulaToSave.document_type = 3;
      $scope.caratulaToSave.f_currency =
        $scope.caratula.f_currency == "Pesos" ? 1 : 2;
      $scope.caratulaToSave.natural = $scope.caratula.natural
        ? $scope.caratula.natural.id
        : null;
      $scope.caratulaToSave.juridical = $scope.caratula.juridical
        ? $scope.caratula.juridical.id
        : null;
      $scope.caratulaToSave.folio = $scope.caratula.folio;
      $scope.caratulaToSave.identifier = $scope.caratula.identifier;
      $scope.caratulaToSave.internal_number = $scope.order.form.internal_number;
      $scope.caratulaToSave.poliza_number = "";
      $scope.caratulaToSave.observations = $scope.caratula.observations;
      $scope.caratulaToSave.forma_de_pago = $scope.order.form.payment;
      $scope.caratulaToSave.end_of_validity = new Date(
        datesFactory.mesDiaAnio($scope.caratula.end_of_validity)
      );
      $scope.caratulaToSave.start_of_validity = new Date(
        datesFactory.mesDiaAnio($scope.caratula.start_of_validity)
      );
      $scope.caratulaToSave.vendor = $scope.caratula.vendor
        ? $scope.caratula.vendor.id
        : null;
      $scope.caratulaToSave.is_renewable = $scope.order.renewal.selected;

      var auxDate = new Date(
        new Date($scope.order.form.startDate).getTime() - 86400000
      );
      if ($stateParams.tipo) {
        $scope.caratulaToSave.status = 1;
      }

      /* Recibos */
      if ($scope.caratulaToSave.status != 1) {
        if ($scope.dataToSave.receipts && $scope.receits_on_cover) {
          $scope.dataToSave.receipts.forEach(function (recibo) {
            var receipt_init = new Date(
              datesFactory.toDate(recibo.startDate)
            ).setHours(11, 59, 59);
            var receipt_end = new Date(
              datesFactory.toDate(recibo.endingDate)
            ).setHours(12, 0, 0);

            recibo.fecha_fin = new Date(receipt_init);
            recibo.fecha_inicio = new Date(receipt_end);
            recibo.startDate = new Date(receipt_init);
            recibo.endingDate = new Date(receipt_end);
            if (isNaN(recibo.comision)) {
              recibo.comision = 0;
            } else {
              recibo.comision = recibo.comision;
            }

            if (recibo.vencimiento) {
              var vencimiento = new Date(toDate(recibo.vencimiento)).setHours(
                11.59,
                59,
                0
              );
              recibo.vencimiento = new Date(vencimiento);
            }
          });
          $scope.caratulaToSave.recibos_poliza = $scope.dataToSave.receipts;
        } else {
          $scope.caratulaToSave.recibos_poliza = [];
        }
      } else {
        $scope.caratulaToSave.recibos_poliza = [];
      }
      // if ($scope.caratula.sucursal) {
      //   $scope.caratulaToSave.sucursal = $scope.caratula.sucursal;
      // }else{
      //   $scope.caratulaToSave.sucursal = ''
      // }
      /* Creación de la nueva póliza */
      $http({
        method: "POST",
        url: url.IP + "caratulas/",
        data: $scope.caratulaToSave,
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          //varios referenciadores
          for (var i = 0; i < $scope.referenciadores.length; i++) {
            $scope.referenciadores[i].policy = response.data.url;
            $scope.ref_policy = $scope.referenciadores[i];
            if ($scope.ref_policy) {
              if ($scope.referenciadores[i].referenciador) {
                var ref = {};
                ref.referenciador = $scope.referenciadores[i].referenciador;
                ref.comision_vendedor = $scope.referenciadores[i]
                  .comision_vendedor
                  ? $scope.referenciadores[i].comision_vendedor
                  : 0;
                ref.policy = response.data.url;
                dataFactory
                  .post("referenciadores-policy/", ref)
                  .then(
                    function success(request) {},
                    function error(error) {
                      console.log(error);
                    }
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              }
            }
          }
          // varios referenciadores
          $scope.renovacionCaratula = response.data;
          $scope.renovacionCaratulaId = $scope.renovacionCaratula.id;

          if ($scope.caratulaToSave.status != 1) {
            $scope.coverRenewed = true;
            $scope.verSubgrupo = true;
          } else {
            $scope.coverRenewed = false;
            $scope.verSubgrupo = false;
            if ($scope.renovacionCaratula.document_type == 3) {
              $state.go("colectividades.info", {
                polizaId: $scope.renovacionCaratula.id,
              });
            }
          }
          // ----------------
          /* Relación con la póliza original */
          var oldPolicy = {
            policy: $scope.caratula.poliza_number,
            base_policy: $scope.caratula.url,
            new_policy: response.data.url,
          };

          insuranceService
            .createOldPolicy(oldPolicy)
            .then(function (responseOldPolicy) {
              // console.log('responseOldPolicy',responseOldPolicy,oldPolicy)
            });
          // -------------/{}
          var params = {
            model: 18,
            event: "POST",
            associated_id: response.data.id,
            identifier:
              "creó la renovación a partir de la colectividad " +
              $scope.caratula_poliza_number,
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});

          var params = {
            model: 18,
            event: "POST",
            associated_id: $scope.caratula.id,
            identifier: "renovó la ot.",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
        }
      });
    };
    // Renovacion OT -

    // $scope.saveSubgroup = function (parValue) {
    $scope.saveSubgroup = function (parValue, x) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      $scope.subgroupDone = true;

      if (parValue == NOT_GROUP) {
        $scope.exist_subgroup = false;
        $scope.clientAlert =
          "Has seleccionado sin subgrupo por lo que no puedes crear ";
        var name = "Default";
        var observations = "";
        $scope.dataToSave.receipts = [];
        $scope.dataToSave.poliza = {
          iva: 0,
          p_total: 0,
          derecho: 0,
          rpf: 0,
          p_neta: 0,
        };
      } else if (parValue == ADD) {
        $scope.not_category = false;
        // if($scope.receits_on_cover) {
        if (!$scope.receits_on_cover) {
          if ($scope.subgroup.contratante) {
            if ($scope.subgroup.contratante.value.address_natural) {
              var natural = $scope.subgroup.contratante.value.id;
              var address = natural;
            } else if ($scope.subgroup.contratante.value.address_juridical) {
              var juridical = $scope.subgroup.contratante.value.id;
              var address = juridical;
            }
          } else {
            var juridical = null;
            var address = null;
            var natural = null;
          }
        } else {
          var natural = null;
          var juridical = null;
          var address = null;
          $scope.order.receipts = [];
        }

        if (!$scope.subgroup.name) {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORSUBGROUP, "error");
          return;
        }
        var observations = $scope.subgroup.observations;
        var name = $scope.subgroup.name;
        $scope.categoria_result = false;
      }
      if ($scope.subgroup.contratante) {
        if ($scope.subgroup.contratante.value.address_natural) {
          var natural = $scope.subgroup.contratante.value.id;
          var address = natural;
        } else if ($scope.subgroup.contratante.value.address_juridical) {
          var juridical = $scope.subgroup.contratante.value.id;
          var address = juridical;
        }
      } else {
        var juridical = null;
        var address = null;
        var natural = null;
      }
      if (!$scope.order.poliza) {
        $scope.order.poliza = {
          iva: 0,
          p_total: 0,
          derecho: 0,
          rpf: 0,
          p_neta: 0,
        };
      } else {
        if (!$scope.order.poliza.iva) {
          $scope.order.poliza = {
            iva: 0,
            p_total: 0,
            derecho: 0,
            rpf: 0,
            p_neta: 0,
          };
        }
      }

      if ($scope.dataToSave.receipts) {
        $scope.dataToSave.receipts.forEach(function (recibo) {
          if (isNaN(recibo.startDate)) {
            var receipt_init = new Date(
              datesFactory.toDate(recibo.startDate)
            ).setHours(11, 59, 59);
            var receipt_end = new Date(
              datesFactory.toDate(recibo.endingDate)
            ).setHours(12, 0, 0);
            // var vencimiento = new Date(datesFactory.toDate(recibo.vencimiento)).setHours(12,0,0);

            recibo.fecha_fin = new Date(receipt_end);
            recibo.fecha_inicio = new Date(receipt_init);
            recibo.startDate = new Date(receipt_init);
            recibo.endingDate = new Date(receipt_end);
            // recibo.vencimiento = new Date(vencimiento);

            if (recibo.vencimiento) {
              var vencimiento = new Date(toDate(recibo.vencimiento)).setHours(
                11.59,
                59,
                0
              );
              recibo.vencimiento = new Date(vencimiento);
            }
          }
        });

        $scope.dataToSave.recibos_poliza = $scope.dataToSave.receipts;
      } else {
        $scope.dataToSave.recibos_poliza = [];
      }

      if ($scope.order.show.ot) {
        $scope.dataToSave.receipts = [];
        $scope.dataToSave.poliza = {
          iva: 0,
          p_total: 0,
          derecho: 0,
          rpf: 0,
          p_neta: 0,
        };
      }

      var data = {
        address: address,
        natural: natural,
        juridical: juridical,
        observations: observations,
        p_total: 0,
        derecho: 0,
        rpf: 0,
        p_neta: 0,
        iva: 0,
        name: name,
        // recibos_poliza: [],
        recibos_poliza: $scope.dataToSave.recibos_poliza.length
          ? $scope.dataToSave.recibos_poliza
          : [],
        coverageInPolicy_policy: [],
        parent: $scope.renovacionCaratula.id,
        caratula: $scope.renovacionCaratula.id,
        document_type: 4,
        vendor: $scope.subgroup.vendor,
      };

      if (!$scope.subgroup.vendor) {
        data.vendor = "";
      }

      $scope.showReceipts = false;

      $http
        .post(url.IP + "subgrupos/", data)
        .then(
          function success(request) {
            if (request.status === 201) {
              $scope.editedReceipts = false;
              uploadFiles(request.data.id);
              $scope.subgroupId = request.data.id;
              FileUploaderBD(2);
              $scope.show_cat_again = true;
              $scope.show_sgr_again = false;
              l.stop();

              if (data.name !== DEFAULT) {
                $scope.sub_group.push(request.data);
                toaster.success("El subgrupo se ha guardado correctamente");
              }

              $scope.subgrupoResult = request.data;
              $scope.order.subgroups.push(request.data);

              $scope.order.receipts = [];
              $scope.order.poliza = {};
              // $scope.not_category = true;
              $scope.show_category = true;

              $scope.subgroup = {};
              $scope.tree_subs = treeIdsStructure();
            }
          },
          function error(error) {
            console.log("error - saveSubgrupo", error);
          }
        )
        .catch(function (e) {
          console.log("error - saveSubgrupo - catch", e);
        });
    };

    $scope.NotSubgroups = function () {
      //   SweetAlert.swal({
      //     title: '¿Continuar sin subgrupos?',
      //     text: "Ya no podrá crear subgrupos en esta colectividad.",
      //     type: "warning",
      //     showCancelButton: true,
      //     confirmButtonColor: "#DD6B55",
      //     confirmButtonText: "Si",
      //     closeOnConfirm: true
      // }, function(isConfirm) {
      //     if (isConfirm) {
      //       $scope.saveSubgroup('notGroup')
      //       toaster.info("Favor de dar click en siguiente");
      //     }
      // });
      SweetAlert.swal(
        "Advertencia",
        "No puedes dejar una renovación sin subgrupos, por favor agrega uno.",
        "warning"
      );
    };

    $scope.saveCategory = function (parValue) {
      $scope.categoryDone = true;
      if (parValue == NOT_CATEGORY) {
        var cat_observations = "";
        var cat_name = DEFAULT;
        var cat_hospital_level = "";
      } else if (parValue == ADD) {
        var cat_observations = $scope.category.observations;
        var cat_name = $scope.category.name;
        var cat_hospital_level = $scope.category.hospital_level;
        $scope.verCategoria = true;
        $scope.verPaquetes = true;
        $scope.showPaquetes = true;
      } else if (parValue == NEXT) {
        $scope.showCategoria = false;
        $scope.verPaquetes = true;

        return;
      }

      var data = {
        observations: cat_observations,
        name: cat_name,
        parent: $scope.subgrupoResult.url,
        hospital_level: cat_hospital_level,
        caratula: $scope.renovacionCaratula.id,
        document_type: 5, // 5: categoría
      };
      $http
        .post(url.IP + "categories/", data)
        .then(
          function success(request) {
            if (request.status === 201) {
              uploadFiles(request.data.id);
              $scope.categoryId = request.data.id;
              $scope.show_cat_again = false;
              $scope.not_category = false;
              FileUploaderBD(3);

              if (data.name !== DEFAULT) {
                toaster.success("La categoría se ha guardado correctamete");
              }
              $scope.order.categories.push(request.data);
              $scope.categoria_result = request.data;

              if (parValue == NOT_CATEGORY) {
                $scope.verPaquetes = true;
                $scope.showPaquetes = true;
              }
              $scope.category = {};
              $scope.newPackage = false;
              $scope.tree_subs = treeIdsStructure();
            }

            var info = {
              ramo: $scope.caratula.ramo.id,
              subramo: $scope.caratula.subramo.id,
              provider: $scope.caratula.aseguradora.id,
            };
            dataFactory
              .post("paquetes-data-by-subramo/", info)
              .then(
                function success(response) {
                  if (response.status === 200) {
                    $scope.order.defaults.packages = [];
                    if (response.data.length) {
                      $scope.order.defaults.packages = response.data;
                    }
                  }
                },
                function error(e) {
                  console.log("Error - paquetes-data-by-subramo", e);
                  $scope.order.defaults.packages = [];
                }
              )
              .catch(function (error) {});
          },
          function error(error) {
            console.log("error - category", error);
          }
        )
        .catch(function (e) {
          console.log("error - category - catch", e);
        });
      $scope.tree_subs = treeIdsStructure();
    };

    $scope.NotCategories = function () {
      SweetAlert.swal(
        {
          title: "¿Continuar sin categorias?",
          text: "Ya no podrá crear categorias en esta colectividad.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.saveCategory("notCategory");
            toaster.info("Favor de dar click en siguiente");
          }
        }
      );
    };

    $scope.savePackage = function (parObj) {
      parObj.provider = order.form.aseguradora.url;
      parObj.ramo = order.form.ramo.url;
      parObj.subramo = order.form.subramo.url;
      parObj.type_package = 1; // paquete normal
      parObj.coverage_package = [];

      packageService
        .createPackage(parObj)
        .then(
          function success(request) {
            order.defaults.packages.push(request);
            $scope.newPackage = false;
            $scope.addCoverages = true;
            $scope.packageCreated = request;
            SweetAlert.swal(
              "¡Listo!",
              "El paquete: " + request.package_name + ", se ha creado.",
              "success"
            );
          },
          function error(error) {
            console.log("error - createPackage", error);
          }
        )
        .catch(function (e) {
          console.log("error -createPackage- catch", e);
        });
    };

    $scope.returnInfo = function (insurance) {
      if (insurance.document_type == "Carátula") {
        insurance.document_type = 3;
      } else if (insurance.document_type == "Póliza") {
        insurance.document_type = 1;
      } else {
        insurance.document_type = insurance.document_type;
      }
      if (insurance.document_type == 1) {
        $state.go("polizas.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 3) {
        $state.go("colectividades.info", { polizaId: insurance.id });
      }
    };

    function FileUploaderBD(param) {
      if (param == 1) {
        $scope.filesCaratula = true;
        $timeout(function () {
          $http
            .get(url.IP + "polizas/" + $scope.caratula.id + "/archivos/")
            .then(function (response) {
              $scope.filesC = response.data.results;
            });
        }, 2000);
      } else if (param == 2) {
        // console.log ('subgrupo',$scope.subgroupId);
        $scope.filesSubgrupo = true;

        $timeout(function () {
          $http
            .get(url.IP + "polizas/" + $scope.subgroupId + "/archivos/")
            .then(function (response) {
              $scope.filesS = response.data.results;
              $scope.filesSubgrupo = false;
            });
        }, 3000);
      } else if (param == 3) {
        $scope.filesCategory = true;
        // console.log ('category',$scope.categoryId);
        $timeout(function () {
          $http
            .get(url.IP + "polizas/" + $scope.categoryId + "/archivos/")
            .then(function (response) {
              $scope.filesCat = response.data.results;
            });
        }, 3000);
      }
    }

    $scope.selectPackage = function (parValue) {
      $scope.package = parValue;
      $scope.selectedPackage = true;
      new_coverage_data = parValue.coverage_package;
      $scope.coveragesPackage = parValue.coverage_package;
      $scope.configurations = [];

      $scope.master = {
        source: angular.copy(parValue.coverage_package),
        coveragesConfig: [],
      };

      $scope.config_coverages = angular.copy($scope.master);
    };

    $scope.demo = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    $scope.addCategory = function (parValue) {
      $scope.addCategoryNew = true;
    };

    $scope.aseguradoraSelection = function () {
      if ($scope.caratula.aseguradora) {
        get_claves();
      }

      $http
        .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
        .then(
          function success(response) {
            $scope.ramos = response.data;
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    $scope.changeRamo = function () {
      if ($scope.caratula.ramo.ramo_code == 3) {
        $scope.autos = true;
        var subramos = [];
        if ($scope.caratula.ramo.subramo_ramo) {
          $scope.caratula.ramo.subramo_ramo.forEach(function (item) {
            if (item.subramo_code == 9) {
              subramos.push(item);
            }
          });
        } else if ($scope.caratula.ramo) {
          $http
            .get($scope.caratula.ramo.url)
            .then(
              function success(sub_ramo) {
                sub_ramo.data.subramo_ramo.forEach(function (item) {
                  if (item.subramo_code == 9) {
                    subramos.push(item);
                  }
                });
              },
              function error(e) {
                console.log("Error - subramos ramo", e);
              }
            )
            .catch(function (error) {
              console.log("Error - subramos-by-ramo - catch", error);
            });
        }

        $scope.subramos = subramos;
      } else {
        $scope.subramos_caratula = $scope.caratula.ramo.subramo_ramo;
      }
      if ($scope.caratula.ramo.ramo_code == 2) {
        $scope.vida = true;
        var subramos = [];
        if ($scope.caratula.ramo.subramo_ramo) {
          $scope.caratula.ramo.subramo_ramo.forEach(function (item) {
            if (item.subramo_code == 3) {
              subramos.push(item);
            }
          });
        } else if ($scope.caratula.ramo) {
          $http
            .get($scope.caratula.ramo.url)
            .then(
              function success(sub_ramo) {
                sub_ramo.data.subramo_ramo.forEach(function (item) {
                  if (item.subramo_code == 3) {
                    subramos.push(item);
                  }
                });
              },
              function error(e) {
                console.log("Error - subramos ramo", e);
              }
            )
            .catch(function (error) {
              console.log("Error - subramos-by-ramo - catch", error);
            });
        }

        $scope.subramos = subramos;
      } else {
        $scope.subramos_caratula = $scope.caratula.ramo.subramo_ramo;
      }

      if ($scope.caratula.ramo.ramo_code == 1) {
        $scope.vida = true;
        var subramos = [];
        if ($scope.caratula.ramo.subramo_ramo) {
          $scope.caratula.ramo.subramo_ramo.forEach(function (item) {
            if (item.subramo_code == 1) {
              subramos.push(item);
            }
          });
        } else if ($scope.caratula.ramo) {
          $http
            .get($scope.caratula.ramo.url)
            .then(
              function success(sub_ramo) {
                sub_ramo.data.subramo_ramo.forEach(function (item) {
                  if (item.subramo_code == 1) {
                    subramos.push(item);
                  }
                });
              },
              function error(e) {
                console.log("Error - subramos ramo", e);
              }
            )
            .catch(function (error) {
              console.log("Error - subramos-by-ramo - catch", error);
            });
        }

        $scope.subramos = subramos;
      } else {
        $scope.subramos_caratula = $scope.caratula.subramo.subramo_ramo;
      }
    };

    $scope.comisiones_poliza = [];

    function get_claves() {
      $http
        .get(url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                $scope.comisiones_poliza.push(item);
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });

            $scope.claves = clavesResponse.data;
            $scope.order.form.comisiones = $scope.comisiones_poliza;
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }

    $scope.filesCaratula = false;
    $scope.show_contractor_list = true;

    $scope.saveFilesC = function (param) {
      if (param == 1) {
        uploadFiles($scope.caratulaId);
        $scope.filesCaratula = false;
      }
    };

    $scope.hideFilesC = function (param) {
      if (param == 1) {
        $scope.filesCaratula = false;
      }
    };

    $scope.showFilesCar = false;
    $scope.showFilesS = false;
    $scope.showFilesCar = false;
    $scope.showFiles = function (param, id, parElement) {
      if (param == 1) {
        $scope.showFilesCar = true;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
        $http
          .get(url.IP + "polizas/" + $scope.caratulaId + "/archivos/")
          .then(function (response) {
            $scope.filesCaratula = true;
            $scope.filesC = response.data.results;
          });
      } else if (param == 2) {
        $scope.showFilesS = true;
        $scope.showFilesCar = false;
        $scope.showFilesC = false;
        $scope.subgroupId = id;

        $http
          .get(url.IP + "polizas/" + $scope.subgroupId + "/archivos/")
          .then(function (response) {
            // $scope.filesS = response.data.results;
            parElement.files = response.data.results;
            if (parElement.showFiles) {
              parElement.showFiles = false;
            } else {
              parElement.showFiles = true;
            }
          });

        if ($scope.showFilesC == true) {
          $scope.showFilesC = false;
        }
      } else if (param == 3) {
        $scope.showFilesC = true;
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.categoryId = id;

        $http
          .get(url.IP + "polizas/" + $scope.categoryId + "/archivos/")
          .then(function (response) {
            // $scope.filesCat = response.data.results;
            parElement.files = response.data.results;
            if (parElement.showFiles) {
              parElement.showFiles = false;
            } else {
              parElement.showFiles = true;
            }
          });
        if ($scope.showFilesS == true) {
          $scope.showFilesS = false;
        }
      } else if (param == 4) {
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
        $scope.showFilesCer = true;

        $http
          .get(url.IP + "polizas/" + $scope.certificateId + "/archivos/")
          .then(function (response) {
            // $scope.filesCer = response.data.results;
            parElement.files = response.data.results;
            if (parElement.showFiles) {
              parElement.showFiles = false;
            } else {
              parElement.showFiles = true;
            }
          });
      }
    };

    $scope.selectExcel = function (parData) {
      validateExcel(parData.ASEGURADOS);
      $scope.strcutureData = certStructure(parData);
      treeStructure(parData);

      // ocultar árbol
      $scope.id_tree = true;
    };

    function validateExcel(parData) {
      parData.forEach(function (child) {
        if (!child.INI_VIGENCIA) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna INI_VIGENCIA esta vacia",
            "error"
          );
          return;
        }
        if (!child.FIN_VIGENCIA) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna FIN_VIGENCIA esta vacia",
            "error"
          );
          return;
        }

        if (!child.PAQUETE) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PAQUETE esta vacia",
            "error"
          );
          return;
        }

        if (!child.PRIMA_TOTAL) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PRIMA_TOTAL esta vacia",
            "error"
          );
          return;
        } else if (child.PRIMA_TOTAL.search(",") >= 0) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PRIMA_TOTAL es invalida. Las cantidades deben ser sin comas o caracteres especiales",
            "error"
          );
          return;
        }

        if (
          $scope.order.form.ramo.ramo_code == 1 ||
          $scope.order.form.ramo.ramo_code == 2
        ) {
          if (!child.CERT_GRAL) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna CERT_GRAL esta vacia",
              "error"
            );
            return;
          }
          if (!child.CERTIFICADO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna CERTIFICADO esta vacia",
              "error"
            );
            return;
          }
          if ($scope.order.form.ramo.ramo_code == 2 && !child.INCISO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna INCISO esta vacia",
              "error"
            );
            return;
          }
          if (!child.AP_PAT) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna AP_PAT esta vacia",
              "error"
            );
            return;
          }
          if (!child.NOMBRE) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna NOMBRE esta vacia",
              "error"
            );
            return;
          }
          if (!child.FEC_NAC) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna FEC_NAC esta vacia",
              "error"
            );
            return;
          }

          if (!child.SEXO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna SEXO esta vacia",
              "error"
            );
            return;
          } else if (!(child.SEXO == "M" || child.SEXO == "F")) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna SEXO contiene un valor invalido",
              "error"
            );
            return;
          }

          if (!child.PARENTESCO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna PARENTESCO esta vacia",
              "error"
            );
            return;
          } else if (child.PARENTESCO > 4) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna PARENTESCO contiene un valor invalido",
              "error"
            );
            return;
          }

          if (!child.TIPO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna TIPO esta vacia",
              "error"
            );
            return;
          } else if (child.TIPO > 2) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna TIPO contiene un valor invalido",
              "error"
            );
            return;
          }

          // if($scope.order.form.ramo.ramo_code == 1 && !child.PORCENTAJE && child.TIPO == 2){
          //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna PORCENTAJE esta vacia', "error");
          //   return;
          // } else if($scope.order.form.ramo.ramo_code == 1 && child.PORCENTAJE > 100){
          //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna PORCENTAJE es mayor a 100', "error");
          //   return;
          // }

          // if($scope.order.form.ramo.ramo_code == 1 && !child.FUMADOR && child.TIPO == 1){
          //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna FUMADOR esta vacia', "error");
          //   return;
          // } else if($scope.order.form.ramo.ramo_code == 1 && child.FUMADOR > 1){
          //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna FUMADOR contiene un valor invalido', "error");
          //   return;
          // }
        } else if ($scope.order.form.subramo.subramo_code == 9) {
          if (!child.INCISO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna INCISO esta vacia",
              "error"
            );
            return;
          }

          if (!child.ASEGURADO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna ASEGURADO esta vacia",
              "error"
            );
            return;
          }

          if (!child.MARCA) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MARCA esta vacia",
              "error"
            );
            return;
          }

          if (!child.MODELO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MODELO esta vacia",
              "error"
            );
            return;
          }

          if (!child.AÑO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna AÑO esta vacia",
              "error"
            );
            return;
          }

          if (!child.VERSION) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna VERSION esta vacia",
              "error"
            );
            return;
          }

          if (!child.SERIAL) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna SERIAL esta vacia",
              "error"
            );
            return;
          }

          if (!child.MOTOR) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MOTOR esta vacia",
              "error"
            );
            return;
          }

          if (!child.COLOR) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna COLOR esta vacia",
              "error"
            );
            return;
          }

          if (!child.MATRICULA) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MATRICULA esta vacia",
              "error"
            );
            return;
          }

          if (!child.USO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna USO esta vacia",
              "error"
            );
            return;
          } else if (child.USO > 1) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna USO contiene un valor invalido",
              "error"
            );
            return;
          }
        }
      });
    }

    function treeStructure(parData) {
      var tree = [];

      for (var key in parData) {
        var data = parData[key];
        if (data.length) {
          // checar asegurados (parents)
          var parents = [];
          var childs = [];
          // console.log('caratula', order.form);
          if ($scope.order.form.subramo.subramo_code == 9) {
            // console.log('autos');

            data.forEach(function (car) {
              var parent_content =
                car.INCISO +
                " - " +
                car.MARCA +
                " - " +
                car.MODELO +
                " - " +
                car.AÑO +
                " - " +
                car.VERSION +
                " - " +
                car.SERIAL;

              var element = {
                text: parent_content,
              };

              tree.push(element);
            });
          } else {
            data.forEach(function (child) {
              if (child.TIPO == 2) {
                childs.push(child);
              }
            });

            data.forEach(function (parent) {
              // console.log('item', item);
              if (parent.TIPO == 1) {
                // parents.push(item);
                var nodes = [];
                childs.forEach(function (item) {
                  if (item.CERTIFICADO == parent.CERTIFICADO) {
                    var full_name =
                      item.NOMBRE + " " + item.AP_PAT + " " + item.AP_MAT;

                    if (item.INCISO) {
                      var inciso = item.INCISO;
                    } else {
                      var inciso = "";
                    }

                    if (item.PARENTESCO) {
                      var parentesco = item.PARENTESCO;
                    } else {
                      var parentesco = "";
                    }

                    if (item.PORCENTAJE) {
                      var porcentaje = item.PORCENTAJE;
                    } else {
                      var porcentaje = "";
                    }

                    var content =
                      inciso +
                      " - " +
                      full_name +
                      " - " +
                      item.FEC_NAC +
                      " - " +
                      parentesco +
                      " - " +
                      item.SEXO +
                      " - " +
                      porcentaje;

                    nodes.push({
                      text: content,
                    });
                  }
                });

                var parent_content =
                  parent.CERTIFICADO +
                  " - " +
                  parent.NOMBRE +
                  " " +
                  parent.AP_PAT +
                  " " +
                  parent.AP_MAT +
                  " - " +
                  parent.FEC_NAC;

                var element = {
                  text: parent_content,
                  nodes: nodes,
                };

                tree.push(element);
              }
            });
          }

          $("#tree").treeview({ data: tree });
        }
      }
    }

    function certStructure(parData, par_status) {
      var certificadosArray = [];
      var beneficiaries_life = [];
      var beneficiaries_gm = [];
      var life_data = [];
      var gm_data = [];

      for (var key in parData) {
        var data = parData[key];
        if (data.length) {
          if ($scope.order.form.subramo.subramo_code == 9) {
            // COCHES
            // console.log('FLOTILLAS');
            var autos_certs = [];

            data.forEach(function (item) {
              $scope.item_paquete = angular.copy(item.PAQUETE);

              if (item.USO) {
                if (item.USO >= "4" || item.USO <= "0") {
                  item.USO = "1";
                }
              } else {
                item.USO = "1";
              }

              if (!item.EMAIL) {
                item.EMAIL = "";
              }

              if (!item.CONTACTO) {
                item.CONTACTO = "";
              }
              if (item.BEN_PREFERENTE) {
                $scope.ben_p = item.BEN_PREFERENTE;
              } else {
                $scope.ben_p = "";
              }
              if (item.COMISION) {
                $scope.comision = item.COMISION;
              } else {
                $scope.comision = 0;
              }
              if (item.PRIMA_NETA) {
                $scope.p_neta = item.PRIMA_NETA;
              } else {
                $scope.p_neta = 0;
              }
              if (item.IVA) {
                $scope.iva = item.IVA;
              } else {
                $scope.iva = 0;
              }
              if (item.RPF) {
                $scope.rpf = item.RPF;
              } else {
                $scope.rpf = 0;
              }
              if (item.DERECHO) {
                $scope.derecho = item.DERECHO;
              } else {
                $scope.derecho = 0;
              }
              if (item.PRIMA_TOTAL) {
                $scope.p_total = item.PRIMA_TOTAL;
              } else {
                $scope.p_total = 0;
              }
              if (item.INCISO) {
                $scope.inciso = item.INCISO;
              } else {
                $scope.inciso = 0;
              }

              var data_autos = [
                {
                  brand: item.MARCA,
                  model: item.MODELO,
                  year: item.AÑO,
                  version: item.VERSION,
                  serial: item.SERIAL,
                  engine: item.MOTOR,
                  color: item.COLOR,
                  usage: item.USO,
                  license_plates: item.MATRICULA,
                  email: item.EMAIL,
                  preferential_benefiaciary: $scope.ben_p,
                  document_type: 6,
                },
              ];

              // autos_certs.push(data_autos);

              if (item.CATEGORIA) {
                var categoria_ = parseInt(item.CATEGORIA);
              } else {
                var categoria_ = $scope.categoria_result.id;
              }

              if (item.SUBGRUPO) {
                //// hacer for buscando coinicdencia con el id

                for (var i = 0; i < $scope.order.subgroups.length; i++) {
                  var item = $scope.order.subgroups[i];

                  if (item.id == parseInt(item.SUBGRUPO)) {
                    // console.log('subgrupo');
                    if (item.address) {
                      var address_ = item.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    } else {
                      var address_ = $scope.caratula.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    }
                  }
                }
              } else {
                var address_ = $scope.caratula.address;
                var natural_ = $scope.caratula.natural;
                var juridical_ = $scope.caratula.juridical;
              }

              if ($scope.order.show.ot) {
                var status_ = 1;
              } else {
                var status_ = 14;
              }

              // coberturas del paquete.
              /*if($scope.config_saved.length) {
                  $scope.config_saved.forEach(function(i) {
                    if(i.id == item.PAQUETE) {
                      $scope.coberturas_paquete = i.coveragesConfig;
                      $scope.coberturas_paquete.forEach(function(j) {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = j.coinsurance_coverage[0].coinsurance;
                      });
                    }
                  });
                }*/

              if ($scope.config_saved.length) {
                $scope.config_saved.forEach(function (i) {
                  if (i.id == $scope.item_paquete) {
                    $scope.coberturas_paquete = i.coverage_package;
                    $scope.coberturas_paquete.forEach(function (j) {
                      if (
                        $scope.caratula.subramo.subramo_name == "Gastos Médicos"
                      ) {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = j.coinsurance_coverage[0].coinsurance;
                      } else {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = 0;
                      }
                    });
                  }
                });
              }

              var certData = {
                internalNumber: null,
                folio: null,
                caratula: $scope.caratula.id,
                certificate_number: parseInt($scope.inciso),
                aseguradora: $scope.dataToSave.aseguradora,
                parent: categoria_,
                poliza_number:
                  $scope.caratula.poliza_number + " - INC. " + $scope.inciso,
                natural: $scope.caratula.natural
                  ? $scope.caratula.natural.id
                  : null,
                juridical: $scope.caratula.juridical
                  ? $scope.caratula.juridical.id
                  : null,
                ramo: $scope.caratula.ramo.id,
                subramo: $scope.caratula.subramo.id,
                paquete: item.PAQUETE,
                observations: "",
                old_policies: [],
                start_of_validity: new Date(
                  toDate($scope.caratula.start_of_validity)
                ),
                end_of_validity: new Date(
                  toDate($scope.caratula.end_of_validity)
                ),
                forma_de_pago: $scope.caratula.frecuencia_de_pago,
                status: status_,
                recibos_poliza: [],
                automobiles_policy: data_autos,
                damages_policy: [],
                accidents_policy: [],
                life_policy: [],
                document_type: 6,
                address: address_, // checar este
                // coverageInPolicy_policy: [], // checar si estas se agregan en el front o se agregarán en el back
                coverageInPolicy_policy: $scope.coberturas_paquete,
                endorsemeted: false,
                clave: $scope.caratula.clave.id,
                f_currency: ($scope.caratula.f_currency = "pesos" ? 1 : 2),
                identifier:
                  data_autos[0].brand +
                  "-" +
                  data_autos[0].model +
                  "-" +
                  data_autos[0].year,
                p_total: $scope.p_total ? $scope.p_total : 0,
                derecho: $scope.derecho ? $scope.derecho : 0,
                rpf: $scope.derecho ? $scope.derecho : 0,
                p_neta: $scope.p_neta ? $scope.p_neta : 0,
                iva: $scope.iva ? $scope.iva : 0,
                comision: $scope.comision ? $scope.comision : 0,
              };
              if (elem.ANTIGUEDAD) {
                certData.rec_antiguedad = toDate(item.ANTIGUEDAD);
              } else {
                certData.rec_antiguedad = null;

                certData = certData;
              }
              certificadosArray.push(certData);
            });

            return certificadosArray;
          } else {
            // se separan los beneficiarios
            data.forEach(function (item) {
              // TODO: Checar el tipo de
              var certificate = item.CERTIFICADO;
              if ($scope.order.form.subramo.subramo_name == "Vida") {
                if (item.TIPO == 2) {
                  var dataBeneficiary = {
                    certificate: certificate,
                    first_name: item.NOMBRE,
                    last_name: item.AP_PAT,
                    second_last_name: item.AP_MAT,
                    birthdate: toDate(convertDate(new Date(item.FEC_NAC))),
                    antiguedad: item.ANTIGUEDAD
                      ? toDate(item.ANTIGUEDAD)
                      : null,
                    sex: item.SEXO,
                    percentage: item.PORCENTAJE,
                    optional_relationship: item.PARENTESCO,
                  };

                  beneficiaries_life.push(dataBeneficiary);
                }
              } else if ($scope.order.form.ramo.ramo_code == 2) {
                // Accidentes y enfermedades

                if (item.PRIMA_NETA) {
                  $scope.p_neta = item.PRIMA_NETA;
                } else {
                  $scope.p_neta = 0;
                }

                if (item.COMISION) {
                  $scope.comision = item.COMISION;
                } else {
                  $scope.comision = 0;
                }
                if (item.IVA) {
                  $scope.iva = item.IVA;
                } else {
                  $scope.iva = 0;
                }
                if (item.RPF) {
                  $scope.rpf = item.RPF;
                } else {
                  $scope.rpf = 0;
                }
                if (item.DERECHO) {
                  $scope.derecho = item.DERECHO;
                } else {
                  $scope.derecho = 0;
                }
                if (item.PRIMA_TOTAL) {
                  $scope.p_total = item.PRIMA_TOTAL;
                } else {
                  $scope.p_total = 0;
                }
                if (item.CERTIFICADO) {
                  $scope.certificate = item.CERTIFICADO;
                } else {
                  $scope.certificate = 0;
                }
                if (item.TIPO == 2) {
                  var dataBeneficiary = {
                    certificate: certificate,
                    first_name: item.NOMBRE,
                    last_name: item.AP_PAT,
                    second_last_name: item.AP_MAT,
                    birthdate: toDate(convertDate(new Date(item.FEC_NAC))),
                    antiguedad: item.ANTIGUEDAD
                      ? toDate(item.ANTIGUEDAD)
                      : null,
                    sex: item.SEXO,
                    clause: item.INCISO,
                  };

                  beneficiaries_gm.push(dataBeneficiary);
                }
              }
            });

            data.forEach(function (elem) {
              var certificate = elem.CERTIFICADO;
              if ($scope.order.form.subramo.subramo_name == "Vida") {
                if (elem.PRIMA_NETA) {
                  $scope.p_neta = elem.PRIMA_NETA;
                } else {
                  $scope.p_neta = 0;
                }

                if (elem.COMISION) {
                  $scope.comision = elem.COMISION;
                } else {
                  $scope.comision = 0;
                }
                if (elem.IVA) {
                  $scope.iva = elem.IVA;
                } else {
                  $scope.iva = 0;
                }
                if (elem.RPF) {
                  $scope.rpf = elem.RPF;
                } else {
                  $scope.rpf = 0;
                }
                if (elem.DERECHO) {
                  $scope.derecho = elem.DERECHO;
                } else {
                  $scope.derecho = 0;
                }
                if (elem.PRIMA_TOTAL) {
                  $scope.p_total = elem.PRIMA_TOTAL;
                } else {
                  $scope.p_total = 0;
                }
                if (elem.CERTIFICADO) {
                  $scope.certificate = elem.CERTIFICADO;
                } else {
                  $scope.certificate = 0;
                }
                if (elem.TIPO == 1) {
                  if (elem.FUMADOR) {
                    if (elem.FUMADOR == 0) {
                      var smoker = false;
                    } else {
                      var smoker = true;
                    }
                  }

                  var dataGM = [];
                  var dataVida = [
                    {
                      personal: {
                        certificate: certificate,
                        first_name: elem.NOMBRE,
                        last_name: elem.AP_PAT,
                        second_last_name: elem.AP_MAT,
                        birthdate: toDate(convertDate(new Date(elem.FEC_NAC))),
                        antiguedad: elem.ANTIGUEDAD
                          ? toDate(elem.ANTIGUEDAD)
                          : null,
                        sex: elem.SEXO,
                        email: elem.EMAIL,
                        salary: parseInt(elem.SUELDO),
                        sum_assured: elem.SUMA_ASEGURADA
                          ? parseInt(elem.SUMA_ASEGURADA)
                          : 0,
                      },
                      smoker: smoker,
                      beneficiaries_life: [],
                    },
                  ];

                  beneficiaries_life.forEach(function (i) {
                    if (i.certificate == elem.CERTIFICADO) {
                      dataVida[0].beneficiaries_life.push(i);
                    }
                  });
                  // life_data.push(dataVida);
                }
              } else if ($scope.order.form.ramo.ramo_code == 2) {
                if (elem.PRIMA_NETA) {
                  $scope.p_neta = elem.PRIMA_NETA;
                } else {
                  $scope.p_neta = 0;
                }

                if (elem.COMISION) {
                  $scope.comision = elem.COMISION;
                } else {
                  $scope.comision = 0;
                }
                if (elem.IVA) {
                  $scope.iva = elem.IVA;
                } else {
                  $scope.iva = 0;
                }
                if (elem.RPF) {
                  $scope.rpf = elem.RPF;
                } else {
                  $scope.rpf = 0;
                }
                if (elem.DERECHO) {
                  $scope.derecho = elem.DERECHO;
                } else {
                  $scope.derecho = 0;
                }
                if (elem.PRIMA_TOTAL) {
                  $scope.p_total = elem.PRIMA_TOTAL;
                } else {
                  $scope.p_total = 0;
                }
                if (elem.CERTIFICADO) {
                  $scope.certificate = elem.CERTIFICADO;
                } else {
                  $scope.certificate = 0;
                }
                if (elem.TIPO == 1) {
                  var dataVida = [];
                  var dataGM = [
                    {
                      personal: {
                        certificate: certificate,
                        first_name: elem.NOMBRE,
                        last_name: elem.AP_PAT,
                        second_last_name: elem.AP_MAT,
                        birthdate: toDate(convertDate(new Date(elem.FEC_NAC))),
                        antiguedad: elem.ANTIGUEDAD
                          ? toDate(elem.ANTIGUEDAD)
                          : null,
                        email: elem.EMAIL,
                        sex: elem.SEXO,
                      },
                      disease_type: 0,
                      relationship_accident: [],
                    },
                  ];

                  beneficiaries_gm.forEach(function (i) {
                    if (i.certificate == elem.CERTIFICADO) {
                      dataGM[0].relationship_accident.push(i);
                    }
                  });
                  // console.log('dataGM', dataGM);
                  // gm_data.push(dataGM);
                }
              }
              if (elem.TIPO == 1) {
                if (elem.CATEGORIA) {
                  var categoria_ = parseInt(elem.CATEGORIA);
                } else {
                  var categoria_ = $scope.categoria_result.id;
                }

                if (elem.SUBGRUPO) {
                  //// hacer for buscando coinicdencia con el id

                  for (var i = 0; i < $scope.order.subgroups.length; i++) {
                    var item = $scope.order.subgroups[i];

                    if (item.id == parseInt(elem.SUBGRUPO)) {
                      // console.log('ok');
                      if (item.address) {
                        var address_ = item.address;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      } else {
                        var address_ = null;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      }
                    }
                  }
                } else {
                  // checar si tiene adress, si no, ponerle la de la caratula

                  var address_ = $scope.caratula.address_;
                  var natural_ = $scope.caratula.natural;
                  var juridical_ = $scope.caratula.juridical;
                }

                if ($scope.config_saved.length) {
                  $scope.config_saved.forEach(function (i) {
                    if (i.id == elem.PAQUETE) {
                      $scope.coberturas_paquete = i.coveragesConfig;
                      $scope.coberturas_paquete.forEach(function (j) {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                      });
                    }
                  });
                }

                var certData = {
                  internalNumber: null,
                  folio: null,
                  caratula: $scope.caratula.id,
                  aseguradora: $scope.dataToSave.aseguradora,
                  certificate_number: parseInt($scope.certificate),
                  parent: categoria_,
                  poliza_number:
                    $scope.caratula.poliza_number +
                    " - INC. " +
                    $scope.certificate,
                  natural: $scope.caratula.natural
                    ? $scope.caratula.natural.id
                    : null,
                  juridical: $scope.caratula.juridical
                    ? $scope.caratula.juridical.id
                    : null,
                  ramo: $scope.caratula.ramo.id,
                  subramo: $scope.caratula.subramo.id,
                  paquete: elem.PAQUETE,
                  observations: elem.OBSERVATIONS,
                  old_policies: [],
                  start_of_validity: new Date(
                    toDate($scope.caratula.start_of_validity)
                  ),
                  end_of_validity: new Date(
                    toDate($scope.caratula.end_of_validity)
                  ),
                  forma_de_pago: $scope.caratula.frecuencia_de_pago,
                  status: par_status,
                  recibos_poliza: [],
                  automobiles_policy: [],
                  damages_policy: [],
                  accidents_policy: dataGM,
                  life_policy: dataVida,
                  document_type: 6,
                  address: address_, // checar este
                  // coverageInPolicy_policy: [], // checar si estas se agregan en el front o se agregarán en el back
                  coverageInPolicy_policy: $scope.coberturas_paquete,
                  endorsemeted: false,
                  clave: $scope.caratula.clave.id,
                  f_currency: ($scope.caratula.f_currency = "pesos" ? 1 : 2),
                  identifier: elem.IDENTIFICADOR,
                  p_total: $scope.p_total ? $scope.p_total : 0,
                  derecho: $scope.derecho ? $scope.derecho : 0,
                  rpf: $scope.rpf ? $scope.rpf : 0,
                  p_neta: $scope.p_neta ? $scope.p_neta : 0,
                  iva: $scope.iva ? $scope.iva : 0,
                  comision: $scope.comision ? $scope.comision : 0,
                };

                life_data = [];
                if (elem.ANTIGUEDAD) {
                  certData.rec_antiguedad = toDate(elem.ANTIGUEDAD);
                } else {
                  certData.rec_antiguedad = null;

                  certData = certData;
                }
                certificadosArray.push(certData);
              }
            });

            return certificadosArray;
          }
        }
      }
    }

    $scope.newPackage = function () {
      if ($scope.creation_packages) {
        $scope.creation_packages = false;
      } else {
        $scope.creation_packages = true;
      }
    };

    $scope.showFilesCer = false;
    $scope.saveFiles = function (param, parElement) {
      $scope.num_section = param;
      $scope.element = parElement;

      if (param == 1) {
        uploadFiles($scope.caratulaId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
      }
      if (param == 2) {
        uploadFiles($scope.subgroupId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
      }
      if (param == 3) {
        uploadFiles($scope.categoryId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
      }
      if (param == 4) {
        uploadFiles($scope.certificateId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
        $scope.showFilesCer = false;
      }
    };

    $scope.saveFilesRen = function (param, id) {
      $scope.num_section = param;
      $scope.element = id;

      if (param == 1) {
        uploadFiles($scope.renovacionCaratulaId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
      }
      if (param == 2) {
        uploadFiles($scope.subgroupId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
      }
      if (param == 3) {
        uploadFiles($scope.categoryId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
      }
      if (param == 4) {
        uploadFiles($scope.certificateId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
        $scope.showFilesCer = false;
      }
    };

    $scope.hideFiles = function (identifier, data) {
      if (identifier == 1) {
        $scope.showFilesCar = false;
      }
      if (identifier == 2) {
        $scope.showFilesS = false;
      }
      if (identifier == 3) {
        $scope.showFilesC = false;
      }
      if (identifier == 4) {
        $scope.showFilesCer = false;
        data = [];
      }
    };
    $scope.showFilesCar = false;
    $scope.showFilesS = false;
    $scope.showFilesCar = false;

    $scope.addTemp = function () {
      $scope.verCertificados = true;
      if ($scope.category_selected.certsEmpty) {
        $scope.category_selected.certsEmpty = false;
      } else {
        $scope.category_selected.certsEmpty = true;
      }
    };

    $scope.saveCertificados = function () {
      $scope.loader = true;
      var data = {
        data: $scope.strcutureData,
      };

      $http({
        method: "POST",
        url: url.IP + "massive-certificates/",
        data: $scope.strcutureData,
      })
        .then(
          function success(request) {
            if (request.status === 201) {
              $scope.loader = false;

              toaster.success("Los certificados se han guardado correctamete.");
              /*updateChilds();*/

              $scope.not_certs = false;
              // $scope.category_selected.certsEmpty = false;
              $scope.certs_data = true;
            } else {
              $scope.loader = false;
            }
          },
          function error(error) {
            console.log("Error -  ");
          }
        )
        .catch(function (e) {
          console.log("Error - catch", e);
        });
    };

    $scope.matchesContractors = function (parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = $scope.order.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $http
            .post(url.IP + "contractors-match/", {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var juridicals = response.data.juridicals;
                var naturals = response.data.naturals;

                if (juridicals.length) {
                  juridicals.forEach(function (item) {
                    var obj = {
                      label: item.j_name,
                      value: item,
                    };
                    source.push(obj);
                  });
                } else if (naturals.length) {
                  naturals.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }

                    source.push(obj);
                  });
                }

                $scope.contractors_data = source;
              }
            });
        }
      } else {
        $scope.contractors_data.length = 0;
      }
    };

    $scope.checkNumPolicy = function () {
      if ($scope.order.form.poliza_number) {
        helpers
          .existPolicyNumber($scope.order.form.poliza_number)
          .then(function (request) {
            if (request == true) {
              SweetAlert.swal("Error", MESSAGES.ERROR.POLICYEXIST, "error");
              // toaster.warning('El número de póliza ya existe.');

              $scope.order.form.poliza_number = "";
            }
          })
          .catch(function (err) {});
      }
    };

    $scope.selectSubgroup = function (parData) {
      $scope.subgrupoResult = parData;
    };

    $scope.selectContractor = function () {
      $scope.show_contractor_list = true;
    };

    $scope.sub_group = [];

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    $scope.getPackages = function () {
      // if (category.certs.length){
      $http({
        method: "GET",
        url: url.IP + "caratula-pack/",
        params: {
          id: $scope.caratulaToSaveOld.id,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              var results = request.data.results;
              results.forEach(function (result) {
                $scope.dataPackToSave = {};
                $scope.dataPackToSave.policy = $scope.caratula.id;
              });
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
      // }
    };

    $rootScope.editTable = function () {
      if ($rootScope.showInput == false) {
        $rootScope.showInput = true;
      } else {
        $rootScope.showInput = false;
      }
    };

    $scope.calculate = function (poliza) {
      if ($scope.editedReceipts) {
        return;
      }

      $scope.order.receipts = [];
      $scope.order.poliza = poliza;
      if (!poliza.derecho) {
        poliza.derecho = 0;
      }

      if (!poliza.rpf) {
        poliza.rpf = 0;
      }

      var prima_neta = parseFloat(poliza.primaNeta);
      var derecho = parseFloat(poliza.derecho);
      var rpf = parseFloat(poliza.rpf);

      $scope.dataToSave.p_neta = prima_neta;
      $scope.dataToSave.derecho = derecho;
      $scope.dataToSave.rpf = rpf;

      var IVA = 0;
      var TOTAL_IVA = 1;

      if ($scope.order.poliza.ivaStatus) {
        IVA = 16;
        $scope.order.poliza.iva = 16;
        TOTAL_IVA = 1.16;
        var pointIva = 0.16;
      } else {
        IVA = 0;
        $scope.order.poliza.iva = 0;
        var pointIva = 0;
      }

      $scope.dataToSave.iva = IVA;

      // console.log('$scope.order.form.payment', $scope.order.form.payment);

      if (!$scope.order.form.payment) {
        toaster.info(MESSAGES.ERROR.SELPAY);
      } else {
        // TODO: checar esta función
        function getNumber(num) {
          // console.log('num', num)
          var num2 = Math.ceil(num);
          return new Array(num2);
        }

        function getSubtotal(poliza) {
          var sum = prima_neta + rpf + derecho;
          return Number(sum.toFixed(2));
        }

        function getTotal(poliza) {
          $scope.dataToSave.p_total = poliza.subTotal * TOTAL_IVA;
          return p(oliza.subTotal * TOTAL_IVA).toFixed(2);
        }

        function getIva(parValue) {
          var iva = parValue * pointIva;
          return parseFloat(iva);
        }

        function comissionCalc(parPneta) {
          // var p_neta_ = parseFloat(parPneta);
          var p_neta_ = parPneta;

          if ($scope.order.form.comision) {
            var comision_ =
              parseFloat($scope.order.form.comision.comission) / 100;
          } else {
            var comision_ = 0;
          }

          var result = parseFloat(p_neta_ * comision_).toFixed(2);
          return result;
        }
        $scope.order.receipts = [];
        $scope.order.defaults = { showReceipts: true };
        $scope.order.defaults.showReceipts = true;
        var initDate = new Date(
          new Date($scope.order.form.startDate).setHours(12, 0, 0, 0)
        );
        var endDate = new Date(
          new Date($scope.order.form.endingDate).setHours(11, 59, 59, 0)
        );

        // console.log('fomr', order.form);
        // console.log('endDate', endDate);
        var months = helpers.monthDiff(initDate, endDate);
        // Calculate diff between dates
        var dateDiff = moment(endDate).diff(moment(initDate), "days");
        var amountReceipts = ($scope.order.amountReceipts =
          months / $scope.order.form.payment);
        // console.log('amountReceipts', amountReceipts);
        //Calculate poliza results
        $scope.order.poliza.subTotal = getSubtotal($scope.order.poliza);
        $scope.order.poliza.primaTotal = getTotal($scope.order.poliza);
        $scope.order.poliza.iva = getIva($scope.order.poliza.subTotal);
        amountReceipts = Math.ceil(amountReceipts);
        var arrayLen = getNumber(amountReceipts);
        // Logic from vm
        var obj = {
          prima: $scope.order.poliza.primaNeta / amountReceipts,
          rpf: $scope.order.poliza.rpf / amountReceipts,
          derecho: $scope.order.poliza.derecho / amountReceipts,
          iva: $scope.order.poliza.iva,
          subTotal: $scope.order.poliza.subTotal / amountReceipts,
          primaTotal: $scope.order.poliza.primaTotal / amountReceipts,
        };
        for (var i = 0; i < arrayLen.length; i++) {
          // Check options
          if ($scope.order.configDerecho) {
            if (i === 0) {
              if ($scope.order.poliza.derecho) {
                obj.derecho = parseFloat($scope.order.poliza.derecho);
              } else {
                obj.derecho = 0;
              }
            } else {
              obj.derecho = 0;
            }
          }

          if ($scope.order.configRPF) {
            if (i === 0) {
              if (obj.rpf) {
                obj.rpf = parseFloat($scope.order.poliza.rpf);
              } else {
                obj.rpf = 0;
              }
            } else {
              obj.rpf = 0;
            }
          }

          endDate = new Date(
            new Date(
              moment(initDate).add($scope.order.form.payment.value, "months")
            ).setHours(11, 59, 59, 0)
          );
          var subTotal = obj.prima + obj.rpf + obj.derecho;

          var receipt = {
            recibo_numero: i + 1,
            prima_neta: parseFloat(obj.prima.toFixed(2)),
            prima: parseFloat(obj.prima.toFixed(2)),
            rpf: parseFloat(obj.rpf.toFixed(2)),
            derecho: parseFloat(obj.derecho.toFixed(2)),
            iva: getIva(subTotal).toFixed(2),
            subTotal: parseFloat(subTotal.toFixed(2)),
            prima_total: parseFloat((subTotal * 1.16).toFixed(2)),
            total: parseFloat((subTotal * 1.16).toFixed(2)),
            comision: comissionCalc(parseFloat(obj.prima.toFixed(2))),
            receipt_type: 1,
          };
          $scope.iva_currency = receipt.subTotal * 0.16;
          if (dateDiff === 364 || dateDiff === 365 || dateDiff === 366) {
            receipt.fecha_inicio = new Date(initDate.setHours(12, 0, 0, 0));
            receipt.startDate = new Date(initDate.setHours(12, 0, 0, 0));
            receipt.endingDate = endDate;
            receipt.fecha_fin = endDate;
          } else {
            receipt.startDate = "";
            receipt.endingDate = "";
            receipt.fecha_inicio = "";
            receipt.fecha_fin = "";
          }
          initDate = endDate;

          $scope.order.receipts.push(angular.copy(receipt));
          $scope.order.receipts.push(angular.copy(receipt));
          $scope.dataToSave.recibos_poliza = $scope.order.receipts;
          $scope.dataToSave.receipts = $scope.order.receipts;
        }
      }
    };

    $scope.addReceipts = function (id, parElement) {
      $scope.subgrupoId = id;
      $scope.sub_receipts = parElement;
      $scope.receits = true;
      $scope.order.show.ot = false;
    };
    $scope.returnToSubs = function () {
      $scope.show_receipts_sub = false;
      $scope.addSubgroupNew = false;
      $scope.addCategoryNew = false;
      $scope.receits = false;
    };
    $scope.saveReceipts = function (param) {
      $scope.sub_receipts.forma_de_pago = $scope.order.form.payment;
      $scope.dataToSave.forma_de_pago = $scope.order.form.payment;
      $scope.receiptsUrl = [];
      $scope.dataToSave.recibos_poliza.forEach(function (item, index) {
        if (isNaN(item.comision)) {
          item.comision = 0;
        } else {
          item.comision = item.comision;
        }
        if (param == 1) {
          // recibos en póliza
          item.poliza = $scope.caratula.url;
        } else if (param == 2) {
          // recibos en subgrupo
          item.poliza = $scope.sub_receipts.url;
        }

        // parseando recibos
        var start_date = new Date(toDate(item.startDate)).setHours(11, 59, 59);
        var end_date = new Date(toDate(item.endingDate)).setHours(12, 0, 0);
        // var vencimiento = new Date(toDate(item.vencimiento)).setHours(12,0,0);

        item.endingDate = new Date(end_date);
        item.fecha_fin = new Date(end_date);
        item.startDate = new Date(start_date);
        item.fecha_inicio = new Date(start_date);
        // item.vencimiento = new Date(vencimiento);

        if (item.vencimiento) {
          var vencimiento = new Date(toDate(item.vencimiento)).setHours(
            11.59,
            59,
            0
          );
          item.vencimiento = new Date(vencimiento);
          // console.log('receipt',item.vencimiento)
        }
        $http
          .post(url.IP + "recibos/", item)
          .then(function (data) {
            if (data.status === 201) {
              $scope.editedReceipts = false;
              if (param == 1) {
                $scope.caratula.recibos_poliza.push(item);
              } else if (param == 2) {
                $scope.sub_receipts.recibos_poliza.push(item);
                $scope.show_receipts_sub = false;
                $scope.receiptsUrl.push(data.data.url);
              }
              if (index == $scope.dataToSave - 1) {
                if (param == 1) {
                  $scope.show_receipts_cover_data = true;
                } else if (param == 2) {
                  $scope.show_receipts = false;
                }
              }
            }
          })
          .catch(function (error) {
            console.log("error", error);
            toaster.danger("No se han guardado los recibos");
          });
      });
    };
    $scope.saveReceiptsSub = function (param) {
      $scope.sub_receiptsNew = {};
      $scope.sub_receiptsNew.recibos_poliza = [];
      $scope.sub_receiptsNew.forma_de_pago = $scope.order.form.payment;
      $scope.dataToSaveSubg.forma_de_pago = $scope.order.form.payment;
      $scope.dataToSaveSubg.recibos_poliza.forEach(function (item, index) {
        if (param == 1) {
          // recibos en póliza
          item.poliza = $scope.caratula.url;
        } else if (param == 2) {
          // recibos en subgrupo
          item.poliza = $scope.sub_receiptsNew.url;
        }

        // parseando recibos
        var start_date = new Date(toDate(item.startDate)).setHours(11, 59, 59);
        var end_date = new Date(toDate(item.endingDate)).setHours(12, 0, 0);
        // var vencimiento = new Date(toDate(item.vencimiento)).setHours(12,0,0);

        item.endingDate = new Date(end_date);
        item.fecha_fin = new Date(end_date);
        item.startDate = new Date(start_date);
        item.fecha_inicio = new Date(start_date);
        // item.vencimiento = new Date(vencimiento);

        if (item.vencimiento) {
          var vencimiento = new Date(toDate(item.vencimiento)).setHours(
            11.59,
            59,
            0
          );
          item.vencimiento = new Date(vencimiento);
          // console.log('receipt',item.vencimiento)
        }
        $http
          .post(url.IP + "recibos/", item)
          .then(function (data) {
            if (data.status === 201) {
              $scope.editedReceipts = false;
              if (param == 1) {
                $scope.caratula.recibos_poliza.push(item);
              } else if (param == 2) {
                $scope.sub_receiptsNew.recibos_poliza.push(item);
                $scope.show_receipts_sub = false;
              }
              if (index == $scope.dataToSaveSubg - 1) {
                if (param == 1) {
                  $scope.show_receipts_cover_data = true;
                } else if (param == 2) {
                  $scope.show_receipts = false;
                }
              }
            }
          })
          .catch(function (error) {
            console.log("error", error);
            // toaster.danger('No se han guardado los recibos');
          });
      });
    };

    $scope.saveConfiguration = function (parData) {
      console.log(parData);
      var obj = {
        package_name: parData.package_name,
        policy: $scope.renovacionCaratula.id,
        provider: $scope.caratula.aseguradora.url,
        ramo: $scope.caratula.ramo.url,
        coverage_package: parData.coveragesConfig,
        subramo: $scope.caratula.subramo.url,
        type_package: 2,
      };

      packageService
        .createPackage(obj)
        .then(
          function success(request) {
            var coverages_config = [];

            parData.coveragesConfig.forEach(function (item, index) {
              var covObj = {
                coverage_name: item.coverage_name,
                provider: $scope.caratula.aseguradora.url,
                package: request.url,
                deductible_coverage: [],
                sums_coverage: [],
                coinsurance_coverage: [],
                typeCoverage: 2,
              };

              if (!item.sumInPolicy && item.sums_coverage.length) {
                covObj.sums_coverage.push(item.sums_coverage[0]);
              } else {
                var test = {
                  coverage_sum: item.url,
                  default: true,
                  id: 0,
                  sum_insured: item.sumInPolicy.value,
                  url: "",
                };
                covObj.sums_coverage.push(test);
              }

              if (!item.deductibleInPolicy && item.deductible_coverage.length) {
                covObj.deductible_coverage.push(item.deductible_coverage[0]);
              } else {
                if (item.deductibleInPolicy == undefined) {
                  var test = {
                    coverage_deductible: item.url,
                    default: true,
                    id: 0,
                    deductible: "",
                    url: "",
                  };
                } else {
                  var test = {
                    coverage_deductible: item.url,
                    default: true,
                    id: 0,
                    deductible: item.deductibleInPolicy.value,
                    url: "",
                  };
                }
                covObj.deductible_coverage.push(test);
              }
              if ($scope.caratula.subramo.subramo_name == "Gastos Médicos") {
                if (item.coinsurance_coverage) {
                  if (item.coinsuranceInPolicy == undefined) {
                    var test = {
                      coverage_coinsurance: null,
                      default: true,
                      id: 0,
                      coinsurance: 0,
                      url: "",
                    };
                  } else {
                    var test = {
                      coverage_coinsurance: item.url,
                      default: true,
                      id: 0,
                      coinsurance: item.coinsuranceInPolicy.value,
                      url: "",
                    };
                  }

                  covObj.coinsurance_coverage.push(test);
                }
              }

              coverageService
                .createCoverageConfig(covObj)
                .then(
                  function success(data) {
                    coverages_config.push(data);

                    if (parData.coveragesConfig.length == index + 1) {
                      // TODO: Eliminar del arreglo de configuraciones
                      $scope.configurations.splice(
                        $scope.configurations.indexOf(parData),
                        1
                      );
                      request.coveragesConfig = coverages_config;
                      request.source = new_coverage_data;
                      $scope.config_saved.push(request);

                      $scope.config_coverages = angular.copy($scope.master);

                      $scope.verCertificados = true;
                      $scope.showCertificado = true;
                    }
                  },
                  function error(error) {
                    console.log("error - createCoverage", error);
                    // TODO: Agregar alerta de confirmación
                  }
                )
                .catch(function (e) {
                  console.log("error - createCoverage - catch", e);
                  // TODO: Agregar alerta de confirmación
                });
            });

            // asignar ID en la vista
          },
          function error(error) {
            console.log("error - createPackage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createPackage - catch", e);
        });
    };

    function treeIdsStructure() {
      $scope.verCertificados = true;

      var tree_ids = [];
      $scope.order.subgroups.forEach(function (sub) {
        if (sub.name !== DEFAULT) {
          $scope.sub_group.push(sub);
          var element = {};
          element.data = sub;
          element.text = sub.id + ": " + sub.name;
          element.nodes = [];

          $scope.order.categories.forEach(function (category) {
            if (sub.url == category.parent) {
              if (category.name !== DEFAULT) {
                element.nodes.push({
                  text: category.id + ": " + category.name,
                });
              }
            }
          });

          tree_ids.push(element);
        } else {
          $scope.order.categories.forEach(function (category) {
            var element = {
              text: category.id + ": " + category.name,
            };
            tree_ids.push(element);
          });
        }
      });

      $("#tree_ids").treeview({ data: tree_ids });
      return tree_ids;
    }
    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    $scope.deleteCoverage = function (obj, index) {
      SweetAlert.swal(
        {
          title: "¿Esta seguro?",
          text: "¡La cobertura se eliminará!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "¡Si, eliminar!",
          cancelButtonText: "¡No, cancelar!",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.packages.splice(index, 1);
            $http({
              method: "DELETE",
              url: obj.url,
            });
            SweetAlert.swal("¡Eliminada!", "Paquete eliminado", "success");
          } else {
            SweetAlert.swal("Cancelada", "Paquete no removido", "error");
          }
        }
      );
    };
    $scope.deleteSubgroup = function (obj, index) {
      SweetAlert.swal(
        {
          title: "¿Esta seguro?",
          text: "¡El Subgrupo y Categorias se eliminarán!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "¡Si, eliminar!",
          cancelButtonText: "¡No, cancelar!",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: obj.id,
              model: 2,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {
                console.log(".................:::::.....", req);
              });
            $scope.subgroups.splice(index, 1);
            $http({
              method: "DELETE",
              url: obj.url,
            });
            SweetAlert.swal(
              "¡Eliminado!",
              "Subgrupo y Categorías eliminados",
              "success"
            );
          } else {
            SweetAlert.swal(
              "Cancelado",
              "Subgrupo y Categorías no removidos",
              "error"
            );
          }
        }
      );
    };

    var coverages_ = [];
    $scope.addCoverageToArray = function (param) {
      if (param.selected) {
        $scope.config_coverages.coveragesConfig.push(angular.copy(param));
      } else {
        $scope.config_coverages.coveragesConfig.forEach(function (
          item,
          index,
          object
        ) {
          if (param.id == item.id) {
            object.splice(index, 1);
          }
        });
      }
    };

    $scope.$watch("subgroup.contratante.value", function (newValue, oldValue) {
      if ($scope.subgroup.contratante) {
        $scope.subgroup.contratante.address_all = [];

        if ($scope.subgroup.contratante.value.address_natural) {
          $scope.subgroup.contratante.address_all =
            $scope.subgroup.contratante.value.address_natural;
        } else {
          $scope.subgroup.contratante.address_all =
            $scope.subgroup.contratante.value.address_juridical;
        }

        if ($scope.subgroup.contratante.value.j_name) {
          $scope.subgroup.contratante.val =
            $scope.subgroup.contratante.value.j_name;
        }

        if ($scope.subgroup.contratante.value.full_name) {
          $scope.subgroup.contratante.val =
            $scope.subgroup.contratante.value.full_name;
        }

        if ($scope.subgroup.contratante.value.phone_number) {
          $scope.subgroup.contratante.phone_number =
            $scope.subgroup.contratante.value.phone_number;
        }

        if ($scope.subgroup.contratante.value.email) {
          $scope.subgroup.contratante.email =
            $scope.subgroup.contratante.value.email;
        }

        try {
          if ($scope.subgroup.contratante.address_all.length == 1) {
            $scope.subgroup.contratante.address =
              $scope.subgroup.contratante.address_all[0];
          }
        } catch (err) {
          console.log("exception", err);
        }
      }
    });

    // Upload files
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    uploader.filters.push({
      name: "customFilter",
      fn: function (item /*{File|FileLikeObject}*/, options) {
        //jshint ignore:line
        return this.queue.length < 20;
      },
    });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      toaster.error(MESSAGES.ERROR.ERRORONUPLOADFILES);
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      fileItem.removeAfterUpload = true;
    };
    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }
    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      // console.log('pages', pages);

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.selectPage = function (parPage) {
        var url = "";
        if (config_.next || config_.previous) {
          if (config_.next) {
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            url = config_.next.substring(0, config_.next.indexOf("&page=") + 6);
            url += parPage.toString();

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              // console.log('param', params);
              url += "&" + params;
            }
          } else {
            url = "";

            var otherParameters = config_.previous.substring(
              config_.previous.indexOf("&page=") + 6
            );

            if (config_.previous.search("&page=") !== -1) {
              url = config_.previous.substring(
                0,
                config_.previous.indexOf("&page=") + 6
              );
              url += parPage.toString();
            } else {
              url = config_.previous;
            }

            if (config_.previous.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }

        getCertif(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getCertif(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              if ($scope.category_selected.certs.length) {
                $scope.category_selected.certsEmpty = false;
                $scope.category_selected.certs.forEach(function (item, index) {
                  if (item.life_policy.length) {
                    item.datos = item.life_policy[0];
                  } else if (item.accidents_policy.length) {
                    item.datos = item.accidents_policy[0];
                  } else if (item.damages_policy.length) {
                    item.datos = item.damages_policy[0];
                  }
                });
              } else {
                $scope.category_selected.certsEmpty = true;
              }

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }

      // configuraciÃƒÂ³n del datepicker
      $(".datepicker-me input").datepicker();

      $.fn.datepicker.defaults.format = "dd/mm/yyyy";
      $.fn.datepicker.defaults.startView = 0;
      $.fn.datepicker.defaults.autoclose = true;
      $.fn.datepicker.defaults.language = "es";
    };
    // Calculadora comision referenciador
    $scope.calculateComision = function (ref, index) {
      $rootScope.comVendedor = true;
      $scope.orderInfo = $scope.order;
      $localStorage.orderForm = JSON.stringify($scope.order.form);
      var modalInstance = $uibModal.open({
        templateUrl: "app/ordenes/calculateComision.modal.html",
        controller: OrderComisionCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          referenciador: function () {
            return ref;
          },
          index: function () {
            return index;
          },
          form: function () {
            return $scope.order.form;
          },
          from: function () {
            return null;
          },
          primaTotal: function () {
            return $scope.order.poliza.primaTotal;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };
    // Calcular comisión ppor referenciador
    function OrderComisionCtrl(
      $scope,
      from,
      $sessionStorage,
      $uibModalInstance,
      referenciador,
      index,
      form,
      $http,
      MESSAGES,
      toaster,
      primaTotal
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $rootScope.valueMonto = primaTotal;
      $rootScope.valueComInicial = 0;
      $rootScope.valueComision = 0;
      if (referenciador) {
        $http.get(referenciador.referenciador).then(function (data) {
          if (data.status == 200 || data.status == 201) {
            if (data.data) {
              $rootScope.name =
                data.data.first_name + " " + data.data.last_name;
              if (data.data.user_info) {
                if (data.data.user_info.info_vendedor[0]) {
                  $rootScope.valueGo =
                    data.data.user_info.info_vendedor[0].gastos_operacion;
                }
              }
            }
          }
        });
      }
      // Change monto --> calc comision
      $scope.changeMonto = function (go, monto, com, comI) {
        if (isNaN(monto)) {
          var toNumber = $scope.formatearNumero(monto);
          if (isNaN(toNumber)) {
            $rootScope.valueMonto = "";
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        }
      };
      $scope.comCalculatePeso = function (monto, comision) {
        if (
          isNaN(monto) ||
          isNaN(comision) ||
          parseFloat(comision) > parseFloat(monto)
        ) {
          if (parseFloat(comision) > parseFloat(monto)) {
            SweetAlert.swal(
              "Error",
              "Cantidad capturada en comisión no puede ser mayor a la prima total",
              "error"
            );
            $rootScope.valueComision = 0;
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        } else {
          $rootScope.valueComision = parseFloat(
            (parseFloat(comision) * 100) / parseFloat(monto)
          ).toFixed(2);
        }
      };
      $scope.validComision = function (comI) {
        if (isNaN(comI)) {
          $rootScope.valueComInicial = 0;
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
        }
      };
      $scope.cTotal = function (monto, com, comVendedor) {
        referenciador.comision_vendedor = comVendedor;
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.cancelCalculate = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
      $scope.formatearNumero = function (nStr) {
        nStr += "";
        var x = nStr.split(".");
        var x1 = x[0];
        var x2 = x.length > 1 ? "." + x[1] : "";
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + "," + "$2");
        }

        return x1 + x2;
      };
    }
  }
})();

/* global angular */
(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ColectividadesInfoCtrl", ColectividadesInfoCtrl);
  ColectividadesInfoCtrl.$inject = [
    "datesFactory",
    "statusPayform",
    "exportFactory",
    "$uibModal",
    "$sessionStorage",
    "$scope",
    "$rootScope",
    "$state",
    "$stateParams",
    "dataFactory",
    "$http",
    "url",
    "SweetAlert",
    "packageService",
    "coverageService",
    "toaster",
    "MESSAGES",
    "payform",
    "helpers",
    "$parse",
    "FileUploader",
    "$timeout",
    "formatValues",
    "$sce",
    "models",
    "sex",
    "generalService",
  ];

  function ColectividadesInfoCtrl(
    datesFactory,
    statusPayform,
    exportFactory,
    $uibModal,
    $sessionStorage,
    $scope,
    $rootScope,
    $state,
    $stateParams,
    dataFactory,
    $http,
    url,
    SweetAlert,
    packageService,
    coverageService,
    toaster,
    MESSAGES,
    payform,
    helpers,
    $parse,
    FileUploader,
    $timeout,
    formatValues,
    $sce,
    models,
    sex,
    generalService
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var token = JSON.parse(decryptedToken);
    var orgName =
      usr && usr.org && usr.org.urlname
        ? usr.org.urlname
        : usr.urlname || usr.orgname || "";

    $scope.uploadFiles = false;
    $scope.user = usr;
    $scope.coverages = [];
    $scope.subgroups = [];
    $scope.categories = [];
    $scope.certificados = [];
    $scope.config_saved = [];
    $scope.package_selected = "";
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };
    $scope.defaults = {
      sex: angular.copy(sex),
      years: [],
      policyUrl: {},
      contractors: [],
      providers: [],
      ramos: [],
      subramos: [],
      packages: [],
      coverages: [],
      formInfo: {},
      coverageInPackage: {},
      payform: angular.copy(payform),
    };
    $scope.renewalColect == false;
    $scope.edit = false;
    $scope.infoFlag = true;
    $scope.infoComp = true;
    $scope.sinistersFlag = false;
    $scope.endoFlag = false;
    $scope.notasFlag = false;

    $scope.show_caratula = true;
    $scope.show_subgrupo = false;
    $scope.show_paquete = false;
    $scope.show_certificado = false;

    var new_coverage_data = [];
    var coverages_ = [];

    $scope.sex = [
      { name: "FEMENINO", value: "F" },
      { name: "MASCULINO", value: "M" },
    ];
    $scope.relation = [
      { option: "TITULAR", id: 1 },
      { option: "CÓNYUGE", id: 2 },
      { option: "HIJO", id: 3 },
      { option: "OTRO", id: 4 },
    ];
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    var order = this;
    order.defaults = [];
    order.creation_packages = false;
    $scope.manual_life = false;
    $scope.manual = false;
    $scope.subforms = {
      selectedCar: {},
      beneficiariesList: [],
      relationshipList: [],
      damage: {
        coinsurance: "",
        insured_item: "",
        item_address: "",
        item_details: "",
      }, //template.formulario.danios
    };
    // permisos accesos
    $scope.accesos = $sessionStorage.permisos;
    if ($scope.accesos) {
      $scope.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          $scope.acceso_polizas = perm;
          $scope.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_adm_pol = true;
              } else {
                $scope.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                $scope.acceso_ver_pol = true;
              } else {
                $scope.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_canc_pol = true;
              } else {
                $scope.acceso_canc_pol = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_elim_pol = true;
              } else {
                $scope.acceso_elim_pol = false;
              }
            }
          });
        }
        if (perm.model_name == "Endosos") {
          $scope.acceso_endosos = perm;
          $scope.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                $scope.acceso_adm_end = true;
              } else {
                $scope.acceso_adm_end = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          $scope.acceso_reportes = perm;
          $scope.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                $scope.acceso_rep_fia = true;
              } else {
                $scope.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                $scope.acceso_rep_sin = true;
              } else {
                $scope.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                $scope.acceso_rep_end = true;
              } else {
                $scope.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                $scope.acceso_rep_pol = true;
              } else {
                $scope.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                $scope.acceso_rep_ren = true;
              } else {
                $scope.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                $scope.acceso_rep_cob = true;
              } else {
                $scope.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          $scope.acceso_ot = perm;
          $scope.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                $scope.acceso_adm_ot = true;
              } else {
                $scope.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                $scope.acceso_ver_ot = true;
              } else {
                $scope.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_canc_ot = true;
              } else {
                $scope.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_elim_ot = true;
              } else {
                $scope.acceso_elim_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          $scope.acceso_contg = perm;
          $scope.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                $scope.acceso_adm_cont = true;
              } else {
                $scope.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                $scope.acceso_ver_cont = true;
              } else {
                $scope.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Siniestros") {
          $scope.acceso_sin = perm;
          $scope.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                $scope.acceso_adm_sin = true;
              } else {
                $scope.acceso_adm_sin = false;
              }
            }
          });
        } else if (perm.model_name == "Mensajeria") {
          $scope.acceso_mns = perm;
          $scope.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                $scope.acceso_mns = true;
              } else {
                $scope.acceso_mns = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          $scope.acceso_form = perm;
          $scope.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                $scope.acceso_form = true;
              } else {
                $scope.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          $scope.acceso_correo = perm;
          $scope.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                $scope.acceso_cor = true;
              } else {
                $scope.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          $scope.acceso_cob = perm;
          $scope.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                $scope.acceso_ver_cob = true;
              } else {
                $scope.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                $scope.acceso_desp_cob = true;
              } else {
                $scope.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                $scope.acceso_pag_cob = true;
              } else {
                $scope.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                $scope.acceso_desco_cob = true;
              } else {
                $scope.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                $scope.acceso_conc_cob = true;
              } else {
                $scope.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                $scope.acceso_liq_cob = true;
              } else {
                $scope.acceso_liq_cob = false;
              }
            } else if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                $scope.acceso_elim_rec = true;
              } else {
                $scope.acceso_elim_rec = false;
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          $scope.acceso_ref = perm;
          $scope.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_adm_ref = true;
              } else {
                $scope.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_pag_ref = true;
              } else {
                $scope.acceso_pag_ref = false;
              }
            } else if (
              acc.permission_name == "Cambiar refrenciador en pólizas"
            ) {
              if (acc.checked == true) {
                $scope.acceso_chg_ref = true;
              } else {
                $scope.acceso_chg_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          $scope.coms = perm;
          $scope.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                $scope.permiso_comisiones = true;
              } else {
                $scope.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          $scope.acceso_files = perm;
          $scope.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                $scope.permiso_archivos = true;
              } else {
                $scope.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    // permiss
    $http({
      method: "GET",
      url: url.IP + "cartas-by-model",
      params: {
        model: 1,
      },
    }).then(function success(response) {
      $scope.cartas = response.data;
    });

    $scope.viewCarta = function (poliza, carta) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-form/",
        params: {
          id_poliza: poliza,
          id_carta: carta.id,
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }

        var params = {
          model: 18,
          event: "POST",
          associated_id: $scope.caratula.id,
          identifier: "generó la carta " + carta.name + ".",
        };

        dataFactory.post("send-log/", params);
        // $scope.pdf = response.data;
        // $http({
        //   method: 'GET',
        //   url: url.IP + 'get-pdf',
        //   params: {
        //     'pdf_name': $scope.pdf.pdf_name
        //   },
        //   responseType: 'arraybuffer'

        // }).then(function success(response) {

        //   })
      });
    };
    $scope.cancelRenovate = function (item) {
      swal(
        {
          title: "No renovar",
          text: "Motivo:",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: false,
        },
        function (inputValue) {
          if (inputValue === false) return false;
          if (inputValue === "") {
            swal.showInputError("Necesita especificar un motivo");
            return false;
          }
          var data = {
            reason_ren: inputValue,
            status: 15,
          };
          $http.patch(item.url, data).then(function (ren) {
            var params = {
              model: 18,
              event: "PATCH",
              associated_id: item.id,
              identifier:
                " canceló la renovación por: " +
                ren.data.reason_ren +
                " de la póliza: " +
                ren.data.poliza_number +
                ".",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          });
          $scope.caratula.status = 15;
          $scope.caratula.reason_ren = inputValue;
          swal("Hecho", MESSAGES.OK.OKNORENOVATION, "success");
        }
      );
    };
    $scope.hideComp = function (y) {
      if (y) {
        $scope.ajusteCaratula = false;
        $scope.infoFlag = true;
      }
    };
    $scope.verAjusteCuenta = function (item) {
      if (item) {
        $scope.endososRecibos = [];
        $scope.endososNotas = [];
        var data = {
          policy: item,
        };
        dataFactory
          .get("get-endosos-colect/", data)
          .then(function success(response) {
            if (response.status == 200 || response.status == 201) {
              if (response.data.endosos.length > 0) {
                $scope.ajusteCaratula = true;
                $scope.infoFlag = false;
                $scope.endorsement_history = response.data.endosos;
                $scope.ajuste_neta = 0;
                $scope.ajuste_total = 0;
                $scope.ajuste_rpf = 0;
                $scope.ajuste_iva = 0;
                $scope.ajuste_derecho = 0;

                response.data.endosos.forEach(function (endoso) {
                  $scope.ajuste_neta =
                    $scope.ajuste_neta + parseFloat(endoso.p_neta);
                  $scope.ajuste_rpf =
                    $scope.ajuste_rpf + parseFloat(endoso.rpf);
                  $scope.ajuste_derecho =
                    $scope.ajuste_derecho + parseFloat(endoso.derecho);
                  $scope.ajuste_iva =
                    $scope.ajuste_iva + parseFloat(endoso.iva);
                  $scope.ajuste_total =
                    $scope.ajuste_total + parseFloat(endoso.p_total);
                });
              }
            }
          });
      }
    };

    // $scope.getPDF = function(poliza) {
    //   console.log(poliza)
    //   $http({
    //     method: 'GET',
    //     url: url.IP + 'get-pdf-ot/',
    //     params: {
    //       'id': poliza
    //     }
    //   }).then(function success(response) {
    //     $scope.pdf = response.data;
    //     $http({
    //       method: 'GET',
    //       url: url.IP + 'get-pdf',
    //       params: {
    //         'pdf_name': $scope.pdf.pdf_name
    //       },
    //       responseType: 'arraybuffer'

    //     }).then(function success(response) {
    //         var file = new Blob([response.data], {type: 'application/pdf'});
    //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //           window.navigator.msSaveOrOpenBlob(file);
    //         }
    //         else{
    //           var fileURL = URL.createObjectURL(file);
    //           $scope.content = $sce.trustAsResourceUrl(fileURL);
    //           window.open($scope.content);
    //         }

    //         var params = {
    //           'model': 1,
    //           'event': "POST",
    //           'associated_id': $scope.caratula.id,
    //           'identifier': "generó el PDF."
    //         }
    //         dataFactory.post('send-log/', params).then(function success(response) {

    //         });
    //       })
    //   })
    // };
    $scope.shareCertificatesAPPEmail = function (caratula) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Se compartirán todos los certificados a la App",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id_poliza: caratula,
              is_owner: false,
              active: true,
            };
            dataFactory
              .post("shareCertificatesToAppEmail/", data_email)
              .then(function success(req) {
                console.log(".................:::::.....", req);
                if (req.status == 200 || req.status == 201) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "-Se han compartido los Certificados-",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al compartir certificados de la Carátula",
                    "error"
                  );
                }
              });
          }
        }
      );
    };
    $scope.shareCertificatesApp = function (caratula) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Se compartirán todos los certificados a los correos asignados a un usuario de la App",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id_poliza: caratula,
              is_owner: false,
              active: true,
            };
            dataFactory
              .post("shareCertificatesToApp/", data_email)
              .then(function success(req) {
                console.log(".................:::::.....", req);
                if (req.status == 200 || req.status == 201) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "Se han compartido los Certificados.",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al compartir certificados de la Carátula",
                    "error"
                  );
                }
              });
          }
        }
      );
    };

    $scope.shareCertificatesEmail = function (caratula) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Se compartirán todos los certificados al Correo Electrónico designado",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id_poliza: caratula,
              is_owner: false,
              active: true,
            };
            dataFactory
              .post("shareCertificatesToEmail/", data_email)
              .then(function success(req) {
                console.log(".................:::::.....", req);
                if (req.status == 200 || req.status == 201) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "Se han compartido los Certificados",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al compartir certificados de la Carátula",
                    "error"
                  );
                }
              });
          }
        }
      );
    };
    $scope.getLog = function () {
      dataFactory
        .get("get-specific-log", {
          model: 18,
          associated_id: $scope.caratula.id,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    };

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    $scope.addBeneficiarios = function (v, item, s) {
      if (s.subramo_code == 3) {
        $scope.manual = true;
        $scope.manual_life = false;
        $scope.num_certificate = v;
        $scope.certificado_add = item;
        $scope.sramo = s;
        var relacion = angular.copy(models.relationships());
        order.hidden = false;
        $scope.subforms.relationshipList.push(relacion);
      } else if (s.subramo_code == 1) {
        $scope.manual_life = true;
        $scope.manual = false;
        $scope.num_certificate = v;
        $scope.certificado_add = item;
        $scope.sramo = s;
        $scope.subforms.beneficiariesList.push(models.beneficiary());
      }
    };
    $scope.saveBeneficiarios = function () {
      if ($scope.sramo.subramo_code == 3) {
        var disease = $scope.certificado_add;
        var relationships = $scope.subforms.relationshipList;
        var type = helpers.diseaseType($scope.sramo.subramo_code);

        var submitObject = {
          code: $scope.sramo.subramo_code,
          personal: disease.accidents_policy[0].personal,
          relationships: relationships,
          coinsurance: disease.coinsurance,
          insurance: $scope.caratula,
          accident: disease.accidents_policy[0].url,
        };
        $scope.crearRelationship(submitObject);
      } else if ($scope.sramo.subramo_code == 1) {
        var life = $scope.certificado_add;
        var beneficiarios = $scope.subforms.beneficiariesList;
        var type = helpers.diseaseType($scope.sramo.subramo_code);
        var submitObject = {
          code: $scope.sramo.subramo_code,
          personal: life.life_policy[0].personal,
          beneficiarios: beneficiarios,
          coinsurance: life.coinsurance,
          insurance: $scope.caratula,
          life: life.life_policy[0].url,
        };
        $scope.crearRelationship(submitObject);
      }
    };
    $scope.changePerson = function (type, raw) {
      raw.person = type;
    };
    $scope.crearRelationship = function (x) {
      $scope.responseFromThis = {
        personalInfo: null,
        diseaseForm: null,
        relationships: [],
        beneficiarios: [],
      };
      if ($scope.sramo.subramo_code == 3) {
        x.relationships.forEach(function (relationship) {
          relationship.birthdate = relationship.birthdate
            ? toDate(relationship.birthdate)
            : null;
          relationship.antiguedad = relationship.antiguedad
            ? toDate(relationship.antiguedad)
            : null;
          relationship.accident = x.accident;
          relationship.relationship = relationship.relationship
            ? relationship.relationship.id
            : 0;
          relationship.sex = relationship.sex.value;

          generalService
            .createRelationship(relationship)
            .then(function (relationshipData) {
              $scope.responseFromThis.relationships.push(relationship);
              // $scope.selectCategory($scope.parCategory,1)
              $scope.manual = false;
            });
        });
        $scope.subforms.relationshipList = [];
      } else if ($scope.sramo.subramo_code == 1) {
        x.beneficiarios.forEach(function (element, index) {
          element.life = x.life;
          element.birthdate = element.birthdate
            ? toDate(element.birthdate)
            : null;
          element.optional_relationship = element.optional_relationship
            ? element.optional_relationship.id
            : 0;
          element.full_name =
            element.first_name +
            " " +
            element.last_name +
            " " +
            element.second_last_name;
          generalService
            .createBeneficiaries(element)
            .then(function (beneficiarie) {
              $scope.responseFromThis.beneficiarios.push(beneficiarie);
              $scope.manual_life = false;
            });
        });
        $scope.subforms.beneficiariesList = [];
      }
    };
    $scope.options = {
      relationshipList: {
        add: function (rel) {
          var relacion = angular.copy(models.relationships());
          order.hidden = false;
          $scope.subforms.relationshipList.push(relacion);
        },
        destroy: function (index, rel) {
          $scope.subforms.relationshipList.splice(index, 1);
        },
        selectType: function (newValue, old) {
          var oldValue = old != "" ? JSON.parse(old) : null;
          var newIndex = -1;
          $scope.options.types.some(function (valueData, index) {
            if (valueData.relationship == newValue.relationship) {
              newIndex = index;
              return true;
            }
          });
          var oldIndex = -1;

          if (newValue.relationship == 1 || newValue.relationship == 2) {
            // titular y conyugue
            $scope.options.types[newIndex].disabled = true;
          }

          if (oldValue) {
            $scope.options.types.some(function (val, index) {
              if (val.relationship == oldValue.relationship) {
                oldIndex = index;
                return true;
              }
            });

            if (oldValue.relationship == 1 || oldValue.relationship == 2) {
              // titular y conyugue
              $scope.options.types[oldIndex].disabled = false;
            }
          }
        },
      },
      beneficiary: {
        add: function () {
          // var beneficiary = angular.copy(order.subforms.life.beneficiaries);
          if (
            helpers.beneficiariesPercentageGreaterThanZero(
              $scope.subforms.beneficiariesList
            )
          ) {
            SweetAlert.swal("Error", MESSAGES.ERROR.GREATERTHAN100, "error");
            // toaster.info('No puede tener un porcentaje mayor a 100%.');
            return;
          } else {
            $scope.subforms.beneficiariesList.push(models.beneficiary());
          }
        },
        destroy: function (index) {
          $scope.subforms.beneficiariesList.splice(index, 1);
        },
      },
    };

    $scope.deleteFile = function (file, container) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este archivo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: file.id,
              id_poliza: $scope.caratula.id,
              model: 6,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {
                console.log(".................:::::.....", req);
              });
            $http({
              method: "GET",
              url: url.IP + "delete-manual",
              params: {
                file_id: file.id,
              },
            }).then(function success(response) {
              if (response.data.status == 204) {
                SweetAlert.swal(
                  "¡Eliminado!",
                  "El archivo fue eliminado.",
                  "success"
                );
                container.splice(container.indexOf(file), 1);
              }
            });
          }
        }
      );
    };
    $scope.renameFile = function (file, vmFiles) {
      var patch = {
        nombre: file.nombre,
        sensible: file.sensible,
      };
      $http.patch(file.url, patch).then(function (response) {
        console.log(response);
        if (response.status == 403) {
          $http.get(file.url).then(function (response) {
            console.log(response);
            file.nombre = response.data;
          });
        }
      });
    };
    $scope.editPackage = function (p, index) {
      p.edit = true;
    };
    $scope.savePackageEdit = function (p) {
      p.edit = false;
      var data = {
        package_name: p.package_name,
        policy: p.policy,
        id: p.id,
      };
      $http.patch(p.url, data).then(function success(response) {
        if (response.status == 200) {
        }
      });
      p.coverage_package.forEach(function (j) {
        var data = {
          coverage_name: j.coverage_name,
        };
        $http.patch(j.url, data).then(function success(response) {
          if (response.status == 200) {
          }
        });
        // otro
        $scope.data = {};
        $scope.data.url = j.url;
        $scope.data.policy = p.policy;
        $scope.data.package = p.url;
        $scope.data.id = p.id;

        $scope.data.coverage_name = j.coverage_name;
        // // COINSURANCE
        j.coinsurance_coverage.forEach(function (coa) {
          if (coa.coinsurance != null) {
            $scope.data.coinsurance_coverage = {
              coinsurance: coa.coinsurance,
              coverage_coinsurance: coa.coverage_coinsurance,
              id: coa.id,
            };
            $http({
              method: "POST",
              url: url.IP + "patch-package-coverage/",
              data: $scope.data,
            }).then(function (response) {});
          }
        });
        // tope coaseguro
        j.topecoinsurance_coverage.forEach(function (tcoa) {
          if (tcoa.topecoinsurance != null) {
            $scope.data.topecoinsurance_coverage = {
              topecoinsurance: tcoa.topecoinsurance,
              coverage_topecoinsurance: tcoa.coverage_topecoinsurance,
              id: tcoa.id,
            };
            $http({
              method: "POST",
              url: url.IP + "patch-package-coverage/",
              data: $scope.data,
            }).then(function (response) {});
          }
        });
        // // DEDUCTIBLE
        j.deductible_coverage.forEach(function (ded) {
          if (ded.deductible != null) {
            // console.log('ded____--',ded.id)
            $scope.data.deductible_coverage = {
              deductible: ded.deductible,
              coverage_deductible: ded.url,
              id: ded.id,
            };
            $http({
              method: "POST",
              url: url.IP + "patch-package-coverage/",
              data: $scope.data,
            }).then(function (response) {});
          }
        });
        // // SUMAS
        j.sums_coverage.forEach(function (sum) {
          if (sum.sum_insured != null) {
            // console.log('sum___--',sum.id)
            $scope.data.sums_coverage = {
              sum_insured: sum.sum_insured,
              coverage_sum: sum.url,
              id: sum.id,
            };
            $http({
              method: "POST",
              url: url.IP + "patch-package-coverage/",
              data: $scope.data,
            }).then(function (response) {});
          }
        });
        // console.log('data_',$scope.data)
        // $http({
        //   method: 'POST',
        //   url: url.IP + 'patch-package-coverage/',
        //   data: $scope.data
        // })
        // .then(function(response) {
        // })
      });
    };
    $scope.downloadExcelAdjustment = function () {
      //
      var blob = new Blob([document.getElementById("exportable").innerHTML], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });
      saveAs(blob, "Reporte_ajuste_anual.xls");
    };

    $scope.downloadExcel = function (parCategory, active) {
      // $http({
      //   method: 'GET',
      //   url: url.IP + 'excel-certificates/',
      //   params: {
      //     parent: parCategory.id,
      //     active: $scope.active_cert
      //   }
      // })
      // .then(function success(response) {
      //   if(response.status === 200) {
      //     exportFactory.excel(response.data, 'Asegurados');
      //   }
      // })
      $scope.filtros = {
        parent: parCategory.id,
        active: $scope.active_cert,
      };
      $http({
        method: "POST",
        // url: url.IP +'excel-certificates/' ,
        url: url.IP + "service_reporte-certificate-excel",
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Certificados.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
      // SweetAlert.swal("Mantenimiento", "Por el momento esta opción se encuentra en mantenimiento. Disculpa las molestias, muy pronto volverá a estar disponible.", "warning");
    };
    $scope.downloadExcelAll = function (caratula, active) {
      // $http({
      //   method: 'GET',
      //   url: url.IP + 'excel-certificates-all/',
      //   params: {
      //     caratula: caratula.id,
      //     active: $scope.active_cert
      //   }
      // })
      // .then(function success(response) {
      //   if(response.status === 200) {

      //     exportFactory.excel(response.data, 'Asegurados');
      //   }
      // })
      $scope.filtros = {
        parent: caratula.id,
        active: $scope.active_cert,
      };
      $http({
        method: "POST",
        // url: url.IP +'excel-certificates/' ,
        url: url.IP + "service_reporte-certificate-excel",
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Certificados.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
      // SweetAlert.swal("Mantenimiento", "Por el momento esta opción se encuentra en mantenimiento. Disculpa las molestias, muy pronto volverá a estar disponible.", "warning");
    };

    $scope.sendProvider = function (provider) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/aseguradoras/send.modal.html",
        controller: "SendPDFModalCtrl",
        size: "md",
        resolve: {
          provider: function () {
            return provider;
          },
          typeOT: function () {
            return 1;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };
    $scope.getPDF = function (poliza) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-ot/",
        responseType: "arraybuffer",
        params: {
          id: poliza,
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });

        var fileURL = URL.createObjectURL(file);
        $scope.content = $sce.trustAsResourceUrl(fileURL);
        window.open($scope.content);

        var params = {
          model: 18,
          event: "POST",
          associated_id: $scope.caratula.id,
          identifier: "generó el PDF.",
        };
        dataFactory.post("send-log/", params).then(function success(response) {
          console.log(response);
        });
        // $scope.pdf = response.data;
        // $http({
        //   method: 'GET',
        //   url: url.IP + 'get-pdf',
        //   params: {
        //     'pdf_name': $scope.pdf.pdf_name
        //   },
        //   responseType: 'arraybuffer'

        // }).then(function success(response) {

        // })
      });
    };

    $scope.deletePolicy = function (poliza) {
      // dataFactory.get('has-del-policy-permission')
      // .then(function success(response) {
      //  if(response.data){

      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            // console.log(id)
            return (
              $http
                .post(url.IP + "delete-colectivity/", { id: poliza.id })
                // return $http.patch(poliza.url)
                .then(deletePolicyComplete)
                .catch(deletePolicyFailed)
            );

            function deletePolicyComplete(response, status, headers, config) {
              //jshint ignore:line
              SweetAlert.swal(
                "¡Listo!",
                MESSAGES.OK.DELETECOLLECTIVITY,
                "success"
              );
              var data_email = {
                id: poliza.id,
                model: 2,
                type_person: 0,
              };
              dataFactory
                .post("send-email-admins-deletes/", data_email)
                .then(function success(req) {
                  console.log(".................:::::.....", req);
                });
              setTimeout(function () {
                $state.go("polizas.table");
              }, 1000);
            }

            function deletePolicyFailed(response, status, headers, config) {
              //jshint ignore:line
              return response;
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La colectividad no se ha eliminado",
              "error"
            );
          }
        }
      );
      // } else {
      //   SweetAlert.swal('Error', 'No tienes permiso para realizar esta acción', "error")
      //  }
      // })
    };
    $scope.show_binnacle_receipt = false;
    $scope.show_binnacle_receipt_endoso = false;
    $scope.returnToReceipts = function () {
      $scope.show_binnacle_receipt = false;
    };
    $scope.showBinnacleReceipt = function (param) {
      $scope.comments_data_receipt = [];
      $scope.modelRec = 4;
      $scope.receiptmodel = param.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          $scope.comments_data_receipt = request.data.results;
          $scope.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      $scope.receipt_id = param.id;
      $scope.show_binnacle_receipt = true;
    };
    $scope.returnToReceiptsEndoso = function () {
      $scope.show_binnacle_receipt_endoso = false;
    };
    $scope.showBinnacleReceiptEndoso = function (param) {
      $scope.comments_data_receipt = [];
      $scope.modelRec = 4;
      $scope.receiptmodel = param.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          $scope.comments_data_receipt = request.data.results;
          $scope.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      $scope.receipt_id = param.id;
      $scope.show_binnacle_receipt_endoso = true;
    };
    // $scope.files = []
    $scope.filesCaratula = false;
    $scope.search = function (cadena) {
      if ($scope.category_selected.certs.length > 0) {
        $scope.statusCert =
          $scope.category_selected.certs[0].certificado_inciso_activo;
      }
      $http({
        method: "GET",
        url: url.IP + "search-certificates/",
        params: {
          cadena: cadena,
          org: usr.org,
          parent: $scope.category_selected.id,
          is_category: $scope.category_selected.is_category,
          status: $scope.statusCert ? $scope.statusCert : "true",
        },
      }).then(function success(request) {
        $scope.category_selected.certs = request.data.results;

        if ($scope.category_selected.certs.length) {
          $scope.isCat = false;
          $scope.category_selected.certsEmpty = false;
          $scope.category_selected.certs.forEach(function (item, index) {
            if (item.life_policy.length) {
              item.datos = item.life_policy[0];
            } else if (item.accidents_policy.length) {
              item.datos = item.accidents_policy[0];
            } else if (item.damages_policy.length) {
              item.datos = item.damages_policy[0];
            }
          });
        } else {
          $scope.category_selected.certsEmpty = true;
        }
      });
    };

    $http({
      method: "GET",
      url: url.IP + "get-caratula/" + $stateParams.polizaId + "/",
    })
      .then(
        function success(request) {
          if (request.status === 200) {
            $scope.filesCaratula = true;
            $scope.caratula = request.data;
            $scope.caratulaId = $scope.caratula.id;
            // ---old policy
            $http({
              method: "GET",
              url: url.IP + "historic-policies/",
              params: {
                actual_id: $scope.caratula.id,
              },
            }).then(function success(response) {
              if (response.data.results.length) {
                $scope.showHistoric = true;
              }
              $scope.caratula_history = [];
              if ($scope.caratula.recibos_poliza.length > 0) {
                $scope.isCat = $scope.caratula.recibos_poliza[0].is_cat;
              }
              response.data.results.forEach(function function_name(old) {
                if ($scope.caratula.id != old.base_policy.id) {
                  $scope.caratula_history.push(old.base_policy);
                } else {
                  $scope.caratula_history.push(old.new_policy);
                }
              });
            });
            // olddd
            $http({
              method: "GET",
              url: url.IP + "get-endosos-sinister",
              params: {
                policy: request.data.id,
              },
            }).then(function success(response) {
              $scope.conteos_es = response.data;
            });

            $http({
              method: "GET",
              url: url.IP + "notas-by-contractor/",
              params: {
                contractor: request.data.natural
                  ? request.data.natural.id
                  : request.data.juridical.id,
                type_contractor: request.data.natural ? "natural" : "juridical",
                poliza_id: request.data.id,
              },
            }).then(function success(response) {
              $scope.notas_c = response.data;
            });
            // console.log('$scope.caratula.subramo',$scope.caratula)
            if ($scope.caratula.subramo.subramo_code == 9) {
              $scope.autos = true;
              $scope.car_years = [];
              var actualYear = new Date().getFullYear();
              var oldYear = actualYear - 80;
              for (var i = actualYear + 1; i >= oldYear; i--) {
                $scope.car_years.push(i);
              }
            } else if (
              $scope.caratula.ramo.ramo_code == 3 &&
              $scope.caratula.subramo.subramo_code != 9
            ) {
              $scope.danios = true;
            }

            order.form = $scope.caratula;
            $scope.caratula.ref_policy.forEach(function (refs) {
              $http
                .get(refs.referenciador)
                .then(function success(response_ref_plicy) {
                  if (response_ref_plicy) {
                    refs.data = response_ref_plicy.data;
                  }
                });
            });
            order.form.payment = $scope.caratula.forma_de_pago;
            order.form.startDate = convertDate(
              $scope.caratula.start_of_validity
            );
            order.form.endingDate = convertDate(
              $scope.caratula.end_of_validity
            );
            order.form.receipts = $scope.caratula.recibos_poliza;

            $scope.dataToSave = order;

            // $scope.show_receipts_ = true;

            payform.forEach(function (payform) {
              if ($scope.caratula.forma_de_pago == payform.value) {
                $scope.caratula.forma_de_pago = {
                  name: payform.label,
                  value: payform.value,
                };
              }
            });
            if (request.data.natural) {
              $scope.cover_contractor = request.data.natural;
              $scope.cover_contractor.direccion =
                request.data.natural.address_natural[0];
            } else if (request.data.juridical) {
              $scope.cover_contractor = request.data.juridical;
              $scope.cover_contractor.direccion =
                request.data.juridical.address_juridical[0];
            }

            $http
              .post(url.IP + "paquetes-data-by-subramo/", {
                ramo: $scope.caratula.ramo.id,
                subramo: $scope.caratula.subramo.id,
                provider: $scope.caratula.aseguradora.id,
              })
              .then(
                function success(response) {
                  if (response.status === 200) {
                    $scope.packages_data = [];
                    if (response.data.length) {
                      $scope.packages_data = response.data;
                    }
                  }

                  order.defaults.packages = $scope.packages_data;
                  // console.log('paquetes',response.data);
                },
                function error(e) {
                  console.log("Error - paquetes-data-by-subramo", e);
                  order.defaults.packages = [];
                }
              )
              .catch(function (error) {
                // console.log('Error - paquetes-data-by-subramo - catch', error);
                // order.defaults.packages = [];
              });

            $http({
              method: "GET",
              url: url.IP + "caratula-childs/" + $stateParams.polizaId + "/",
            }).then(function success(request) {
              if (request.status === 200) {
                var results = request.data;
                results.forEach(function (child) {
                  if (child.document_type == 4) {
                    $scope.poliza_aux = child.poliza_aux;
                    $scope.subgroups.push(child);
                    $scope.subgroupId = child.id;
                    child.categories = [];
                  } else if (child.document_type == 5) {
                    child.poliza_number = $scope.poliza_aux;
                    $scope.categories.push(child);
                    $scope.categoryId = child.id;
                    child.certs = [];
                  }
                });

                if ($scope.certificados.length == 0) {
                  $scope.not_certs = true;
                  $scope.verCertificados = true;
                  $scope.showCertificado = true;
                }

                if ($scope.categories.length == 0) {
                  $scope.coverIncomplete = true;
                }

                $scope.categories.forEach(function (category) {
                  $scope.certificados.forEach(function (cert) {
                    if (category.url == cert.parent) {
                      category.certs.push(cert);
                    }
                  });
                });
                $scope.subgroups.forEach(function (group) {
                  $scope.categories.forEach(function (category) {
                    if (group.url == category.parent) {
                      group.categories.push(category);
                    }
                  });

                  if (group.recibos_poliza.length) {
                    if (group.recibos_poliza.length > 0) {
                      $scope.isCat = group.recibos_poliza[0].is_cat;
                    }
                    $scope.show_receits_cover = false;
                  } else {
                    $scope.show_receits_cover = true;
                  }
                });

                if (!request.data.length) {
                  $scope.coverIncomplete = true;
                }
              }
            });
          }
        },
        function error(error) {}
      )
      .catch(function (e) {
        console.log(e);
      });
    $scope.changeDomiciliadoValue = function () {
      $scope.change_domiciliado = true;
      if ($scope.newDomiciliado == "true" || $scope.newDomiciliado == true) {
        $scope.domiciliadoSave = true;
      } else {
        $scope.domiciliadoSave = false;
      }
    };
    $scope.changedomiciliadoF = function (chng) {
      if (chng) {
        SweetAlert.swal(
          "Información",
          "Todos los Recibo(s) se actualizarán",
          "info"
        );
      }
      $scope.changeDomiciliado = chng;
      $scope.newDomiciliado = $scope.isCat;
    };
    $scope.saveDomiciliado = function (dom) {
      $scope.caratula.recibos_poliza.forEach(function (it) {
        $http.patch(it.url, { is_cat: dom }).then(function (recibo_cat) {
          $scope.isCat = dom;
          $scope.changeDomiciliado = false;
          SweetAlert.swal("¡Hecho!", "Recibo(s) actualizado(s)", "success");
        });
      });
      var paramsRec = {
        model: 18,
        event: "PATCH",
        associated_id: $scope.caratula.id,
        identifier:
          " cambio el estatus de Cargo Atm. (Domiciliado: " +
          dom +
          ") de los recibos desde la carátula.",
      };
      dataFactory
        .post("send-log/", paramsRec)
        .then(function success(response) {});
    };
    $scope.saveDomiciliadoG = function (dom, sub) {
      sub.recibos_poliza.forEach(function (it) {
        $http.patch(it.url, { is_cat: dom }).then(function (recibo_cat) {
          $scope.isCat = dom;
          $scope.changeDomiciliado = false;
          SweetAlert.swal("¡Hecho!", "Recibo(s) actualizado(s)", "success");
        });
      });
      var paramsRec = {
        model: 18,
        event: "PATCH",
        associated_id: $scope.caratula.id,
        identifier:
          " cambio el estatus de Cargo Atm. (Domiciliado: " +
          dom +
          ") de los recibos del Subgrupo: " +
          sub.name +
          " desde la carátula.",
      };
      dataFactory
        .post("send-log/", paramsRec)
        .then(function success(response) {});
    };
    // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    // ----------------------------------------------bitacoras
    $scope.polizaId = $stateParams.polizaId;
    $http({
      method: "GET",
      url: url.IP + "comments/",
      params: {
        model: 1,
        id_model: $scope.polizaId,
      },
    })
      .then(function (request) {
        // console.log('-------', request);
        $scope.comments_data = request.data.results;
        $scope.comments_config = {
          count: request.data.count,
          next: request.data.next,
          previous: request.data.previous,
        };
        // console.log('comments_data', $scope.comments_data);
      })
      .catch(function (e) {
        console.log("e", e);
      });
    // ----------------------------------------------bitacoras

    $scope.commentsExportLoading = false;
    function exportColectivoComments() {
      if (!$scope.polizaId || $scope.commentsExportLoading) {
        return;
      }
      $scope.commentsExportLoading = true;

      var resetLoading = function () {
        $scope.commentsExportLoading = false;
        if (!$scope.$$phase && !$scope.$root.$$phase) {
          $scope.$applyAsync();
        }
      };

      var params = {
        model: 18,
        id_model: $scope.polizaId,
      };
      if (orgName) {
        params.org = orgName;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: params,
          downloadName: "bitacora-colectividad.xlsx",
          token: token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }
    // ----------------------------------------------bitacoras

    $http({
      method: "GET",
      url: url.IP + "caratula-pack/",
      params: {
        id: $stateParams.polizaId,
      },
    })
      .then(
        function success(response) {
          $scope.packages = response.data.results;
        },
        function error(error) {}
      )
      .catch(function (e) {
        console.log(e);
      });

    // Show indicators
    // function showSinisters(insurance) {
    $scope.showSinistersCertificate = function (insurance) {
      $scope.infoFlag = false;
      $scope.sinistersFlag = true;

      $http({
        method: "GET",
        url: url.IP + "view-sinister",
        params: {
          policy: insurance.id,
        },
      }).then(function success(response) {
        $scope.sinisters = response.data.siniestros;
      });
    };
    $scope.infoSinister = function (sinister, insurance) {
      if (insurance.ramo.ramo_name == "Accidentes y Enfermedades") {
        $state.go("siniestros.info", { siniestroId: sinister.id });
      } else if (
        insurance.ramo.ramo_name == "Daños" &&
        insurance.subramo.subramo_name == "Automóviles"
      ) {
        $state.go("siniestros.auto_info", { siniestroId: sinister.id });
      } else if (insurance.ramo.ramo_name == "Vida") {
        $state.go("siniestros.vida_info", { siniestroId: sinister.id });
      } else if (
        insurance.ramo.ramo_name == "Daños" &&
        insurance.subramo.subramo_name != "Automóviles"
      ) {
        $state.go("siniestros.danio_info", { siniestroId: sinister.id });
      }
    };
    // function showNotas() {

    $scope.showNotas = function (insurance) {
      $scope.infoFlag = false;
      $scope.notasFlag = true;
    };
    $scope.hideNotas = function (insurance) {
      $scope.infoFlag = true;
      $scope.notasFlag = false;
    };
    $scope.concept = function (parConcept) {
      switch (parConcept) {
        case 1:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 2:
          return "CAMBIO DE SUMA ASEGURADA";
          break;
        case 3:
          return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
          break;
        case 4:
          return "AGREGAR ASEGURADO";
          break;
        case 5:
          return "AGREGAR COBERTURAS";
          break;
        case 6:
          return "DECLARACIÓN MENSUAL";
          break;
        case 8:
          return "CAMBIO DATOS FISCALES";
          break;
        case 9:
          return "ESPECIFICACIONES";
          break;
        case 11:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 12:
          return "DISMINUCIÓN EN LA SUMA ASEGURADA";
          break;
        case 13:
          return "BAJA DE COBERTURA";
          break;
        case 14:
          return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
          break;
        case 15:
          return "BAJA DE ASEGURADO";
          break;
        case 16:
          return "CANCELACIÓN DE PÓLIZA POR PETICIÓN";
          break;
        case 17:
          return "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO";
          break;
        case 23:
          return "ANTIGÜEDAD RECONOCIDA";
          break;
        case 24:
          return "ALTA ASEGURADOS";
          break;
        case 25:
          return "BAJA ASEGURADO";
          break;
        case 26:
          return "AJUSTE ANUAL A";
          break;
        case 27:
          return "RECONOCIMIENTO ANTIGÜEDAD";
          break;
        case 28:
          return "AJUSTE ANUAL D";
          break;
        case 41:
          return "ALTA DE UNIDAD";
          break;
        case 42:
          return "AGREGAR COBERTURA";
          break;
        case 43:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 44:
          return "AGREGAR CARGA";
          break;
        case 45:
          return "AGREGAR ADAPTACIONES Y CONVERSIONES";
          break;
        case 46:
          return "INCLUIR BP";
          break;
        case 47:
          return "CORREGIR DESCRIPCIÓN";
          break;
        case 48:
          return "AGREGAR TEXTOS ACLARATORIOS";
          break;
        case 49:
          return "ADAPTACIONES SOLO PARA EFECTOS DE RC";
          break;
        case 50:
          return "AGREGAR PLACAS, MOTOR O CORREGIR SERIE";
          break;
        case 51:
          return "CANCELACIONES";
          break;
        case 52:
          return "ELIMINACIÓN DE COBERTURAS";
          break;
        default:
          return "OTRO";
      }
    };
    // function showEndorsements(insurance) {
    $scope.showEndorsements = function (insurance) {
      // console.log('endoso<s')
      $scope.infoFlag = false;
      $scope.endoFlag = true;

      $http({
        method: "GET",
        url: url.IP + "view-endosos",
        params: {
          policy: insurance.id,
        },
      }).then(function success(response) {
        $scope.endorsements = response.data.endosos;
      });
    };

    // function returnToInfo(argument) {
    $scope.returnToInfo = function (argument) {
      $scope.infoFlag = true;
      $scope.sinistersFlag = false;
      $scope.endoFlag = false;
    };
    // function NotasModal(receipt) {
    $scope.NotasModal = function (receipt) {
      // console.log(receipt)
      var insurance = receipt;
      var modalInstance = $uibModal.open({
        templateUrl: "app/cobranzas/notaCredito.modal.html",
        controller: "NotaCreditoCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return insurance;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        vm.receipts.splice(index, 1);
        activate();
      });
    };
    $scope.showChange = function (endoso) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/infoChange.modal.html",
        controller: "InfoChangeCtrl",
        size: "lg",
        resolve: {
          endoso: function () {
            return endoso;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };
    // _____show indicators
    $scope.addReceipts = function (param) {
      $scope.sub_receipts = param;
      if ($scope.show_receipts_sub) {
        $scope.show_receipts_sub = false;
      } else {
        $scope.show_receipts_sub = true;
        $scope.editedReceipts = true;
      }
    };

    $scope.returnToSubs = function () {
      $scope.show_receipts_sub = false;
    };

    $scope.assignPolicy = function (id) {
      console.log(",fsfs", id);
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/polizas.assign.html",
        controller: assignModalView,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policy_id: function () {
            return id;
          },
          contratante: function () {
            return $scope.caratula.natural
              ? $scope.caratula.natural
              : $scope.caratula.juridical;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    $scope.goToPolicy = function (policy) {
      if (policy.document_type == 1) {
        $state.go("polizas.info", { polizaId: policy.id });
      } else if (policy.document_type == 3) {
        $state.go("colectividades.info", { polizaId: policy.id });
      }
    };
    // Convert To Policy
    $scope.convertPolicy = function (caratula) {
      $stateParams.polizaId = caratula.id;
      $stateParams.status = 1;
      $state.go("colectividades.convertirPoliza", {
        polizaId: $stateParams.polizaId,
        status: $stateParams.status,
      });
    };

    $rootScope.certificados_a_pagar = [];
    $rootScope.total_a_pagar = 0;
    // Convert To Policy-
    $scope.paid = function (item) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/colectividades/pago_parcial.modal.html",
        controller: pagosParcialesController,
        size: "md",
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        resolve: {
          receipt: function () {
            return item;
          },
          receipts: function () {
            return $scope.caratula.recibos_poliza;
          },
          receipts_sub: function () {
            var rcpts = [];
            $scope.subgroups.forEach(function (sub) {
              sub.recibos_poliza.forEach(function (recibo_de_subgrupo) {
                rcpts.push(recibo_de_subgrupo);
              });
            });
            return rcpts;
          },
        },
      });
      modalInstance.result.then(function (response) {
        var data = response.result;
        var cap_array = [];
        $rootScope.certificados_a_pagar.forEach(function (cap) {
          cap_array.push(cap.id);
        });
        $http
          .patch(item.url, {
            paid_out: true,
            cantidad: data.cantidad_pago_parcial,
            documento_pago: data.folio_pay,
            fecha_de_pago: datesFactory.toDate(data.pago_date),
            forma_pago: data.pay_form,
            certificados_a_pagar: cap_array,
          })
          .then(function success(response) {
            if (response.status == 500) {
              swal("¡Error!", response.data.detail, "error");
              return;
            }
            $scope.category_selected.certs.some(function (cer, index) {
              $rootScope.certificados_a_pagar.forEach(function (rootCert) {
                if (cer.id == rootCert.id) {
                  $scope.category_selected.certs[index].paid_out = true;
                }
              });
            });
            $rootScope.certificados_a_pagar = [];
            $rootScope.total_a_pagar = 0;
            swal("¡Hecho!", "Certificado pagado", "success");
          });
      });
    };

    function pagosParcialesController(
      $scope,
      statusPayform,
      $uibModalInstance,
      receipt,
      $rootScope,
      receipts,
      receipts_sub
    ) {
      try {
        $rootScope.total_a_pagar += parseFloat(receipt.p_total);
      } catch (e) {}
      if (receipts && receipts.length == 0) {
        $scope.receipts = receipts_sub;
      } else {
        $scope.receipts = receipts;
      }
      var flag = true;
      $rootScope.certificados_a_pagar.some(function (certificado) {
        if (certificado.id == receipt.id) {
          flag = false;
        }
      });
      if (flag) {
        $rootScope.certificados_a_pagar.push(receipt);
      }
      $scope.statusPayform = statusPayform;
      $scope.vm = {};

      $scope.remove_item = function (item) {
        if ($rootScope.certificados_a_pagar.length == 1) return;
        $rootScope.certificados_a_pagar.splice(
          $rootScope.certificados_a_pagar.indexOf(item),
          1
        );
      };

      $scope.changedPago = function (value, type) {
        $scope.vm.pay_form = value.value;
      };
      $scope.add_more = function () {
        $uibModalInstance.dismiss("cancel");
      };
      $scope.ok = function () {
        $scope.errors = [];
        if (!$scope.vm.cantidad_pago_parcial) {
          $scope.errors.push("Ingrese  una cantidad de pago");
          return;
        }
        if (!$scope.vm.folio_pay) {
          $scope.errors.push("Ingrese  un documento de pago");
          return;
        }
        if (!$scope.vm.pago_date) {
          $scope.errors.push("Ingrese una fecha de pago");
          return;
        }
        if (!$scope.vm.pay_form) {
          $scope.errors.push("Ingrese una forma de pago");
          return;
        }

        $uibModalInstance.close({ result: $scope.vm });
      };

      $scope.cancel = function () {
        $rootScope.certificados_a_pagar = [];
        $rootScope.total_a_pagar = 0;
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.changeStatusModal = function (contractor, receipt) {
      receipt.contratante = contractor;
      var insurance = $scope.caratula;
      var index = $scope.caratula.recibos_poliza.indexOf(receipt);
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return $scope.caratula;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        actualizar();
        /*$http({
          method: 'GET',
          url: url.IP + 'get-caratula/' + $stateParams.polizaId + '/',
        })
        .then(
          function success(request) {
            if(request.status === 200) {
              $scope.caratula = request.data;

              payform.forEach(function(payform) {
                if($scope.caratula.forma_de_pago == payform.value) {
                  $scope.caratula.forma_de_pago = {
                    name : payform.label,
                    value : payform.value
                  }
                }
              });
            }
          });*/
      });
    };

    $scope.saveReceipts = function (param) {
      // console.log('sub_receipts', $scope.sub_receipts);
      // console.log($scope.dataToSave);
      $scope.dataToSave.recibos_poliza.forEach(function (item, index) {
        if (param == 1) {
          // recibos en póliza
          item.poliza = $scope.caratula.url;
        } else if (param == 2) {
          // recibos en subgrupo
          item.poliza = $scope.sub_receipts.url;
        }

        // parseando recibos
        var start_date = new Date(toDate(item.startDate)).setHours(11, 59, 59);
        var end_date = new Date(toDate(item.endingDate)).setHours(12, 0, 0);
        // var vencimiento = new Date(toDate(item.vencimiento)).setHours(12,0,0);

        item.endingDate = new Date(end_date);
        item.fecha_fin = new Date(end_date);
        item.startDate = new Date(start_date);
        item.fecha_inicio = new Date(start_date);
        // item.vencimiento = new Date(vencimiento);

        if (item.vencimiento) {
          var vencimiento = new Date(toDate(item.vencimiento)).setHours(
            11.59,
            59,
            0
          );
          item.vencimiento = new Date(vencimiento);
          // console.log('receipt',item.vencimiento)
        }
        // console.log('receipt',item)
        $http
          .post(url.IP + "recibos/", item)
          .then(function (data) {
            if (data.status === 201) {
              $scope.editedReceipts = false;
              if (param == 1) {
                $scope.caratula.recibos_poliza.push(item);
              } else if (param == 2) {
                $scope.sub_receipts.recibos_poliza.push(item);
                $scope.show_receipts_sub = false;
              }
              if (index == $scope.dataToSave - 1) {
                if (param == 1) {
                  $scope.show_receipts_cover_data = true;
                } else if (param == 2) {
                  $scope.show_receipts = false;
                }
              }
            }
          })
          .catch(function (error) {
            console.log("error", error);
            toaster.danger("No se han guardado los recibos");
          });
      });
    };

    $scope.percentageRange = function (input, index) {
      if (input < 0) {
        $scope.config_coverages.coveragesConfig[
          index
        ].coinsuranceInPolicy.value = 0;
      }
      if (input > 100) {
        $scope.config_coverages.coveragesConfig[
          index
        ].coinsuranceInPolicy.value = 100;
      }
    };

    // PAQUETES
    $scope.selectPackage = function (param) {
      new_coverage_data = param.coverage_package;
      $scope.package_selected = param;
      $scope.master = {
        source: angular.copy(param.coverage_package),
        coveragesConfig: [],
      };

      $scope.config_coverages = angular.copy($scope.master);
    };
    $scope.addCoverPackage = function (param) {
      console.log(param, $scope.caratula);
      new_coverage_data = param.coverage_package;
      // $http.POST('paquetes-by-subram/o',{'id':})
      var data = {
        ramo: $scope.caratula.ramo.id,
        subramo: $scope.caratula.subramo.id,
        provider: $scope.caratula.aseguradora.id,
      };
      $http({
        method: "POST",
        url: url.IP + "paquetes-by-subramo/",
        data: data,
      }).then(function (response) {
        // console.log('response',response)
        $scope.config_coverages = response.data[3].coverage_package;
      });
    };

    $scope.deleteCoverage = function (parItem, parData) {
      parItem.selected = false;
      $scope.config_coverages.coveragesConfig.splice(
        $scope.config_coverages.coveragesConfig.indexOf(parItem),
        1
      );

      $scope.config_coverages.source.forEach(function (item) {
        if (parItem.id == item.id) {
          item.selected = false;
        }
      });
    };

    $scope.addCoveragesConfig = function () {
      $scope.config_coverages.coveragesConfig = coverages_;
    };

    $scope.addAll = function () {
      $scope.config_coverages.coveragesConfig = angular.copy(
        $scope.config_coverages.source
      );
      $scope.config_coverages.source.forEach(function (item) {
        item.selected = true;
      });
    };

    $scope.addCoverageToArray = function (param) {
      if (param.selected) {
        $scope.config_coverages.coveragesConfig.push(angular.copy(param));
      } else {
        $scope.config_coverages.coveragesConfig.forEach(function (
          item,
          index,
          object
        ) {
          if (param.id == item.id) {
            object.splice(index, 1);
          }
        });
      }
    };

    $scope.saveCoverage = function (parName, parType, parPackage, parData) {
      if (parPackage) {
        var paqueteData = parPackage;
      } else {
        var paqueteData = $scope.packageCreated;
      }

      var obj = {
        coverage_name: parName,
        provider: order.form.aseguradora.url,
        package: paqueteData.url,
        deductible: [],
        sums_coverage: [],
        coinsurance_coverage: [],
      };

      coverageService
        .createCoverage(obj)
        .then(
          function success(request) {
            $scope.coverages.push(request);
            $scope.coverageName = null;

            order.defaults.packages.forEach(function (item) {
              if (item.id == paqueteData.id) {
                if (parType == "config") {
                  $scope.config_coverages.source.push(request);
                  $scope.showNewCoverage = false;
                }
                if (item.coverage_package) {
                  item.coverage_package.push(request);
                } else {
                  item.coverage_package = [];
                  item.coverage_package.push(request);
                }
              }
            });
          },
          function error(error) {
            console.log("error - createCoverage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createCoverage - catch", e);
        });
    };

    $scope.saveConfiguration = function (parData) {
      for (var i = 0; i < parData.coveragesConfig.length; i++) {
        if (
          !parData.coveragesConfig[i].sumInPolicy &&
          !parData.coveragesConfig[i].deductibleInPolicy &&
          !parData.coveragesConfig[i].coinsuranceInPolicy
        ) {
          SweetAlert.swal("Error", MESSAGES.ERROR.DEDUCTIBLEREQUIRED, "error");
          return;
        }
      }

      var obj = {
        package_name: parData.package_name,
        policy: $scope.caratula.id,
        provider: $scope.caratula.aseguradora.url,
        ramo: $scope.caratula.ramo.url,
        coverage_package: parData.coveragesConfig,
        subramo: $scope.caratula.subramo.url,
        type_package: 2,
      };

      packageService
        .createPackage(obj)
        .then(
          function success(request) {
            var coverages_config = [];

            parData.coveragesConfig.forEach(function (item, index) {
              if ($scope.caratula.subramo.subramo_name == "Gastos Médicos") {
                var covObj = {
                  coverage_name: item.coverage_name,
                  priority: item.priority ? item.priority : 0,
                  provider: order.form.aseguradora.url,
                  package: request.url,
                  deductible_coverage: [],
                  sums_coverage: [],
                  coinsurance_coverage: [],
                  topecoinsurance_coverage: [],
                  typeCoverage: 2,
                };
              } else {
                var covObj = {
                  coverage_name: item.coverage_name,
                  priority: item.priority ? item.priority : 0,
                  provider: $scope.caratula.aseguradora.url,
                  package: request.url,
                  deductible_coverage: [],
                  sums_coverage: [],
                  coinsurance_coverage: [],
                  topecoinsurance_coverage: [],
                  typeCoverage: 2,
                };
              }

              if (!item.sumInPolicy && item.sums_coverage.length) {
                // covObj.sums_coverage.push(item.sums_coverage[0]);
                var test = {
                  coverage_sum: item.url,
                  default: true,
                  id: 0,
                  org: "",
                  sum_insured: 0,
                  url: "",
                };
                covObj.sums_coverage.push(test);
              } else {
                var test = {
                  coverage_sum: item.url,
                  default: true,
                  id: 0,
                  org: "",
                  sum_insured: item.sumInPolicy ? item.sumInPolicy.value : 0,
                  url: "",
                };
                covObj.sums_coverage.push(test);
              }

              if (!item.deductibleInPolicy && item.deductible_coverage.length) {
                // covObj.deductible_coverage.push(item.deductible_coverage[0]);
                var test = {
                  coverage_deductible: item.url,
                  default: true,
                  id: 0,
                  org: "",
                  deductible: 0,
                  url: "",
                };
                covObj.deductible_coverage.push(test);
              } else {
                var test = {
                  coverage_deductible: item.url,
                  default: true,
                  id: 0,
                  org: "",
                  deductible: item.deductibleInPolicy
                    ? item.deductibleInPolicy.value
                    : 0,
                  url: "",
                };
                covObj.deductible_coverage.push(test);
              }

              if ($scope.caratula.subramo.subramo_name == "Gastos Médicos") {
                if (
                  !item.coinsuranceInPolicy &&
                  item.coinsurance_coverage.length
                ) {
                  // covObj.coinsurance_coverage.push(item.coinsurance_coverage[0]);
                  var test = {
                    coverage_coinsurance: item.url,
                    default: true,
                    id: 0,
                    org: "",
                    coinsurance: 0,
                    url: "",
                  };
                  covObj.coinsurance_coverage.push(test);
                } else {
                  var test = {
                    coverage_coinsurance: item.url,
                    default: true,
                    id: 0,
                    org: "",
                    coinsurance: item.coinsuranceInPolicy
                      ? item.coinsuranceInPolicy.value
                      : 0,
                    url: "",
                  };
                  covObj.coinsurance_coverage.push(test);
                }
              }
              // else if(item.coinsuranceInPolicy == undefined){
              //   var test = {
              //     coverage_coinsurance: null,
              //     default: true,
              //     id: 0,
              //     org: "",
              //     coinsurance: item.coinsuranceInPolicy ? item.coinsuranceInPolicy.value : '',
              //     url: "",
              //   }
              //   covObj.coinsurance_coverage.push(test);
              // }

              if (
                $scope.caratula.subramo.subramo_code == 3 &&
                item.coinsuranceInPolicy
              ) {
                var test = {
                  coverage_coinsurance: item.url,
                  default: true,
                  id: 0,
                  org: "",
                  coinsurance: item.coinsuranceInPolicy.value,
                  url: "",
                };
                covObj.coinsurance_coverage.push(test);
              }
              if (
                $scope.caratula.subramo.subramo_code == 3 &&
                item.topecoinsuranceInPolicy
              ) {
                var test = {
                  coverage_topecoinsurance: item.url,
                  default: true,
                  id: 0,
                  org: "",
                  topecoinsurance: item.topeCoinsuranceInPolicy.value,
                  url: "",
                };
                covObj.topecoinsurance_coverage.push(test);
              }
              // if ($scope.caratula.subramo.subramo_code == 3 && item.coinsuranceInPolicy) {
              //   var test = {
              //     coverage_coinsurance: item.url,
              //     default: true,
              //     id: 0,
              //     org: "",
              //     coinsurance: item.coinsuranceInPolicy.value,
              //     url: "",
              //   }
              //   covObj.coinsurance_coverage.push(test);
              // }
              // else{
              //   var test = {
              //     coverage_coinsurance: item.url,
              //     default: true,
              //     id: 0,
              //     org: "",
              //     coinsurance: item.coinsuranceInPolicy.value,
              //     url: "",
              //   }
              //   covObj.coinsurance_coverage.push(test);
              //   console.log('covObj__recdlast____-',covObj)
              // }
              // }

              coverageService
                .createCoverageConfig(covObj)
                .then(
                  function success(data) {
                    if (
                      $scope.caratula.subramo.subramo_name == "Gastos Médicos"
                    ) {
                      data.sums_coverage[0].sum_insured =
                        data.sums_coverage[0].sum_insured;
                      data.sums_coverage[0].id = data.sums_coverage[0].id;
                      data.deductible_coverage[0].deductible =
                        data.deductible_coverage[0].deductible;
                      data.deductible_coverage[0].id =
                        data.deductible_coverage[0].id;
                      data.coinsurance_coverage[0].coinsurance =
                        data.coinsurance_coverage[0].coinsurance;
                      data.coinsurance_coverage[0].id =
                        data.coinsurance_coverage[0].id;
                    } else {
                      data.sums_coverage[0].sum_insured = data.sums_coverage[0]
                        .sum_insured
                        ? data.sums_coverage[0].sum_insured
                        : "";
                      data.deductible_coverage[0].deductible = data
                        .deductible_coverage[0].deductible
                        ? data.deductible_coverage[0].deductible
                        : "";
                      data.sums_coverage[0].id = data.sums_coverage[0].id
                        ? data.sums_coverage[0].id
                        : 0;
                      data.deductible_coverage[0].id = data
                        .deductible_coverage[0].id
                        ? data.deductible_coverage[0].id
                        : 0;
                      // data.coinsurance_coverage[0].coinsurance = 0;
                    }
                    coverages_config.push(data);

                    if (parData.coveragesConfig.length == index + 1) {
                      // TODO: Eliminar del arreglo de configuraciones
                      request.coverage_package = coverages_config;
                      request.source = new_coverage_data;
                      $scope.packages.push(request);

                      $scope.config_coverages = angular.copy($scope.master);
                    }
                    var params = {
                      model: 18,
                      event: "POST",
                      associated_id: $scope.caratula.id,
                      identifier:
                        "creó el paquete " + request.package_name + ".",
                    };

                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                  },
                  function error(error) {
                    console.log("error - createCoverage", error);
                    // TODO: Agregar alerta de confirmación
                  }
                )
                .catch(function (e) {
                  console.log("error - createCoverage - catch", e);
                  // TODO: Agregar alerta de confirmación
                });
            });
            // asignar ID en la vista
          },
          function error(error) {
            console.log("error - createPackage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createPackage - catch", e);
        });
    };

    $scope.cover_edit = function () {
      $state.go("colectividades.edit", { polizaId: $stateParams.polizaId });
    };

    $scope.cover_renewal = function (tipo) {
      $stateParams.subgroups = $scope.subgroups;
      $stateParams.categories = $scope.categories;
      $stateParams.packages = $scope.packages;
      $stateParams.document_type = $scope.caratula.document_type;
      if (
        $scope.caratula.status == "Cancelada" ||
        $scope.caratula.status == "OT Cancelada" ||
        $scope.caratula.status == 11 ||
        $scope.caratula.status == 2
      ) {
        SweetAlert.swal(
          {
            title: "Póliza Cancelada",
            text: "¿Está seguro de renovar?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            closeOnConfirm: true,
            closeOnCancel: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              if (tipo) {
                $state.go("colectividades.renewal", {
                  polizaId: $stateParams.polizaId,
                  tipo: tipo,
                });
              } else {
                $state.go("colectividades.renewal", {
                  polizaId: $stateParams.polizaId,
                });
              }
            } else {
              // swal("Cancelado", MESSAGES.OK.CANCELCERT, "error");
              return;
            }
          }
        );
      } else {
        if (tipo) {
          $state.go("colectividades.renewal", {
            polizaId: $stateParams.polizaId,
            tipo: tipo,
          });
        } else {
          $state.go("colectividades.renewal", {
            polizaId: $stateParams.polizaId,
          });
        }
      }
    };

    $scope.certDelete = function (parCertificate) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No podra recuperar el certificado una vez eliminado",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: parCertificate.id,
              model: 2,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {
                console.log(".................:::::.....", req);
              });
            $http.delete(parCertificate.url).then(function (data) {
              if (data.status == 204) {
                var params = {
                  model: 18,
                  event: "POST",
                  associated_id: $scope.caratula.id,
                  identifier:
                    "eliminó el certificado No." +
                    parCertificate.certificate_number +
                    ".",
                };

                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                SweetAlert.swal(
                  "¡Eliminado!",
                  MESSAGES.OK.DELETECERT,
                  "success"
                );
                updateChilds();
              }
            });
            $scope.category_selected.certs.splice(
              $scope.category_selected.certs.indexOf(parCertificate),
              1
            );
            if (!$scope.category_selected.certs.length) {
              $scope.category_selected.certsEmpty = true;
            }
          } else {
            swal("Cancelado", MESSAGES.OK.CANCELCERT, "error");
            return;
          }
        }
      );
    };

    $scope.selectCategory = function (parCategory, active) {
      $scope.show_section(4);
      $scope.category_selected = {};
      $scope.allCerts = false;
      $scope.parCategory = parCategory;
      $scope.category_selected.show_pagination = true;
      $scope.active_cert = active;
      if (active) {
        var active = active;
      } else {
        var active = 1;
      }
      $http({
        method: "GET",
        url: url.IP + "get-certificates/",
        params: {
          parent: parCategory.id,
          active: active,
        },
      }).then(function success(request) {
        $scope.category_selected = parCategory;
        $scope.category_selected.is_category = 1;
        $scope.category_selected.certs = request.data.results;
        $scope.category_selected.certs.forEach(function (item, index) {
          $scope.category_selected.certs[index].poliza_number =
            parCategory.poliza_number;
        });
        $scope.category_selected.config = {
          count: request.data.count,
          previous: request.data.previous,
          next: request.data.next,
        };
        $scope.testPagination(
          "category_selected.certs",
          "category_selected.config"
        );

        $scope.category_selected.show_pagination = true;

        if ($scope.category_selected.certs.length) {
          $scope.category_selected.certsEmpty = false;
          $scope.category_selected.certs.forEach(function (item, index) {
            var ps = {
              policy: item.id,
            };
            dataFactory
              .get("get-endosos-sinister/", ps)
              .then(function success(response) {
                item.endosos = response.data.endosos;
                item.siniestros = response.data.siniestros;
              });
            $scope.ar = [];
            $scope.ar.push(item.certificate_number);
            var objs = [];
            objs = $scope.ar;
            objs.sort(function (a, b) {
              return a - b;
            });
            if (item.life_policy.length) {
              item.datos = item.life_policy[0];
            } else if (item.accidents_policy.length) {
              item.datos = item.accidents_policy[0];
            } else if (item.damages_policy.length) {
              item.datos = item.damages_policy[0];
            }
          });
        } else {
          $scope.category_selected.certsEmpty = true;
        }
      });

      if (parCategory.certsEmpty) {
        $scope.showCertificado = true;
        $scope.verCertificados = true;
        $scope.show_certificate_dat = false;
        $scope.edit_certificate_data = false;
      } else {
        $scope.showCertificado = false;
        $scope.verCertificados = false;
        $scope.show_certificate_dat = false;
        $scope.edit_certificate_data = false;
      }
    };
    $scope.allCerts = false;
    // *Todos los certificados
    $scope.allCertificates = function (caratula, active) {
      $scope.show_section(4);
      $scope.allCerts = true;
      $scope.active_cert = 3;
      $http({
        method: "GET",
        url: url.IP + "get-allcertificates/",
        params: {
          caratula: caratula.id,
          active: active,
        },
      }).then(function success(request) {
        $scope.category_selected = caratula;
        $scope.category_selected.is_category = 0;
        $scope.category_selected.certs = request.data.results;
        $scope.category_selected.config = {
          count: request.data.count,
          previous: request.data.previous,
          next: request.data.next,
        };
        $scope.testPagination(
          "category_selected.certs",
          "category_selected.config"
        );

        $scope.category_selected.show_pagination = true;

        if ($scope.category_selected.certs.length) {
          $scope.category_selected.certsEmpty = false;
          $scope.category_selected.certs.forEach(function (item, index) {
            $scope.ar = [];
            $scope.ar.push(item.certificate_number);
            var objs = [];
            objs = $scope.ar;
            objs.sort(function (a, b) {
              return a - b;
            });
            if (item.life_policy.length) {
              item.datos = item.life_policy[0];
            } else if (item.accidents_policy.length) {
              item.datos = item.accidents_policy[0];
            } else if (item.damages_policy.length) {
              item.datos = item.damages_policy[0];
            }
          });
        } else {
          $scope.category_selected.certsEmpty = true;
        }
      });

      // if(caratula.certsEmpty) {

      //   $scope.showCertificado = true;
      //   $scope.verCertificados = true;
      //   $scope.show_certificate_data = false;
      //   $scope.edit_certificate_data = false;

      // } else {

      //   $scope.showCertificado = false;
      //   $scope.verCertificados = false;
      //   $scope.show_certificate_data = false;
      //   $scope.edit_certificate_data = false;

      // }
    };

    $scope.goToSiniester = function (param, type) {
      if (type == 2) {
        $scope.cert_info.relation = param.id;
      }
      $state.go("siniestros.accidentes", {
        myInsurance: $scope.cert_info,
        contractor: "",
      });
    };

    // $scope.show_certificate_dat = false;
    $scope.selectCerficate = function (parCertificate) {
      $scope.show_certificate_dat = true;
      $scope.cert_info = {};
      $scope.cert_info = parCertificate;
      $scope.certificateId = $scope.cert_info.id;

      $scope.showFiles(4, $scope.certificateId, $scope.cert_info);

      $http({
        method: "GET",
        url: $scope.cert_info.paquete,
      }).then(function success(response) {
        $scope.package_certificate = response.data;
      });
    };

    $scope.updateCert = function (parCertificate) {
      $scope.categoria_result = true;
      try {
        var date_antig = toDate(parCertificate.rec_antiguedad);
      } catch (e) {
        var date_antig = null;
      }

      if (parCertificate.accidents_policy.length) {
        parCertificate.accidents_policy[0].personal.full_name =
          parCertificate.accidents_policy[0].personal.first_name +
          " " +
          parCertificate.accidents_policy[0].personal.last_name +
          " " +
          parCertificate.accidents_policy[0].personal.second_last_name;
        for (
          var i = 0;
          i < parCertificate.accidents_policy[0].relationship_accident.length;
          i++
        ) {
          parCertificate.accidents_policy[0].relationship_accident[
            i
          ].full_name =
            parCertificate.accidents_policy[0].relationship_accident[i]
              .first_name +
            " " +
            parCertificate.accidents_policy[0].relationship_accident[i]
              .last_name +
            " " +
            parCertificate.accidents_policy[0].relationship_accident[i]
              .second_last_name;
        }
      }

      $http.patch(parCertificate.url, {
        certificate_number: parCertificate.certificate_number,
        rec_antiguedad: date_antig,
        poliza_number:
          $scope.caratula.poliza_number +
          " - INC." +
          parCertificate.certificate_number,
      });

      if (parCertificate.life_policy.length) {
        parCertificate.life_policy.forEach(function (policy) {
          policy.personal.birthdate = toDate(policy.personal.birthdate);
          policy.personal.antiguedad = toDate(policy.personal.antiguedad);
          $http.patch(policy.personal.url, policy.personal);
        });

        parCertificate.life_policy.forEach(function (policy) {
          policy.beneficiaries_life.forEach(function (beneficiario) {
            beneficiario.birthdate = toDate(beneficiario.birthdate);
            beneficiario.antiguedad = toDate(beneficiario.antiguedad);
            beneficiario.optional_relationship =
              beneficiario.optional_relationship.id;
            $http.patch(beneficiario.url, beneficiario);
          });
        });
      } else {
        parCertificate.accidents_policy.forEach(function (policy) {
          policy.personal.birthdate = toDate(policy.personal.birthdate);
          policy.personal.antiguedad = toDate(policy.personal.antiguedad);
          $http.patch(policy.personal.url, policy.personal);
        });

        parCertificate.accidents_policy.forEach(function (policy) {
          policy.relationship_accident.forEach(function (beneficiario) {
            beneficiario.birthdate = toDate(beneficiario.birthdate);
            beneficiario.antiguedad = toDate(beneficiario.antiguedad);
            beneficiario.relationship = beneficiario.relationship.id;
            if (parCertificate) {
              // return
            }
            $http.patch(beneficiario.url, beneficiario);
          });
        });
      }
      $scope.returnToCerts();
    };

    $scope.updateCertCars = function (parCertificate) {
      try {
        var date_antig = toDate(parCertificate.rec_antiguedad);
      } catch (e) {
        var date_antig = null;
      }

      $http
        .patch(parCertificate.url, {
          certificate_number: parCertificate.certificate_number,
          rec_antiguedad: date_antig,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC." +
            parCertificate.certificate_number,
        })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            var params = {
              model: 18,
              event: "POST",
              associated_id: $scope.caratula.id,
              identifier:
                "actualizó el certificado No." +
                parCertificate.certificate_number +
                ".",
            };

            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          }
        });

      if (parCertificate.automobiles_policy.length) {
        parCertificate.automobiles_policy.forEach(function (car) {
          car.policy = parCertificate.url;
          $http.patch(car.url, car).then(function success(req) {
            if (req.status === 200) {
            }
            $scope.returnToCerts();
          });
        });
      }
      swal(
        "¡Guardado!",
        "Se han guardado los cambios satisfactoriamente.",
        "success"
      );
    };
    $scope.charge_type = [
      { id: 1, name: "A" },
      { id: 2, name: "B" },
      { id: 3, name: "C" },
    ];
    $scope.editCerficate = function (parCertificate) {
      $scope.cert_info = {};
      $scope.cert_info = parCertificate;
      $scope.cert_info.rec_antiguedad = $scope.cert_info.rec_antiguedad
        ? convertDate(new Date($scope.cert_info.rec_antiguedad))
        : null;

      if ($scope.caratula.subramo.subramo_code == 9) {
        $scope.edit_certificate_data_autos = true;
        $scope.edit_certificate_data = true;
      } else {
        if ($scope.cert_info.life_policy.length) {
          if ($scope.cert_info.datos.personal) {
            if ($scope.cert_info.datos.personal.birthdate) {
              var d = new Date($scope.cert_info.datos.personal.birthdate);
              $scope.cert_info.datos.personal.birthdate_to_save = d;
              $scope.cert_info.datos.personal.birthdate = convertDate(d);
            } else {
              // var d = new Date($scope.cert_info.datos.personal.birthdate);
              $scope.cert_info.datos.personal.birthdate_to_save = "";
              $scope.cert_info.datos.personal.birthdate = "";
            }
            if ($scope.cert_info.datos.personal.antiguedad) {
              var d = new Date($scope.cert_info.datos.personal.antiguedad);
              $scope.cert_info.datos.personal.antiguedad_to_save = d;
              $scope.cert_info.datos.personal.antiguedad = convertDate(d);
            } else {
              // var d = new Date($scope.cert_info.datos.personal.antiguedad);
              $scope.cert_info.datos.personal.antiguedad_to_save = "";
              $scope.cert_info.datos.personal.antiguedad = "";
            }
            $scope.cert_info.datos.beneficiaries_life.forEach(function (benef) {
              if (benef.birthdate) {
                var a = new Date(benef.birthdate);
                benef.birthdate_to_save = a;
                benef.birthdate = convertDate(a);
              } else {
                benef.birthdate_to_save = "";
                benef.birthdate = "";
              }
              if (benef.antiguedad) {
                var a = new Date(benef.antiguedad);
                benef.antiguedad_to_save = a;
                benef.antiguedad = convertDate(a);
              } else {
                benef.antiguedad_to_save = "";
                benef.antiguedad = "";
              }
              $scope.relation.some(function (x) {
                if (x.id == benef.optional_relationship) {
                  benef.optional_relationship = x;
                  return true;
                }
              });
            });

            if ($scope.cert_info.datos.personal.sex == "F") {
              $scope.relatedSex = "FEMENINO";
            } else {
              $scope.relatedSex = "MASCULINO";
            }
            $scope.edit_certificate_data = true;
          }
        } else {
          if ($scope.cert_info.accidents_policy[0].personal.birthdate) {
            var d = new Date(
              $scope.cert_info.accidents_policy[0].personal.birthdate
            );
            $scope.cert_info.accidents_policy[0].personal.birthdate_to_save = d;
            $scope.cert_info.accidents_policy[0].personal.birthdate =
              convertDate(d);
          } else {
            $scope.cert_info.accidents_policy[0].personal.birthdate_to_save =
              "";
            $scope.cert_info.accidents_policy[0].personal.birthdate = "";
          }
          if ($scope.cert_info.accidents_policy[0].personal.antiguedad) {
            var d = new Date(
              $scope.cert_info.accidents_policy[0].personal.antiguedad
            );
            $scope.cert_info.accidents_policy[0].personal.antiguedad_to_save =
              d;
            $scope.cert_info.accidents_policy[0].personal.antiguedad =
              convertDate(d);
          } else {
            $scope.cert_info.accidents_policy[0].personal.antiguedad_to_save =
              "";
            $scope.cert_info.accidents_policy[0].personal.antiguedad = "";
          }

          $scope.cert_info.accidents_policy[0].relationship_accident.forEach(
            function (benef) {
              if (benef.birthdate) {
                var a = new Date(benef.birthdate);
                if (benef.antiguedad) {
                  var b = benef.antiguedad ? new Date(benef.antiguedad) : null;
                }
                benef.birthdate_to_save = a;
                benef.birthdate = convertDate(a);
                if (b) {
                  benef.antiguedad = convertDate(b);
                } else {
                  benef.antiguedad = null;
                }
              } else {
                benef.birthdate_to_save = "";
                benef.birthdate = "";
              }
              $scope.relation.some(function (x) {
                if (x.id == benef.relationship) {
                  benef.relationship = x;
                  return true;
                }
              });
            }
          );
          if ($scope.cert_info.accidents_policy[0].personal.sex == "F") {
            $scope.relatedSex = "FEMENINO";
          } else {
            $scope.relatedSex = "MASCULINO";
          }
          $scope.edit_certificate_data = true;
        }
      }
    };

    $scope.returnToCerts = function (categ) {
      $scope.show_certificate_dat = false;
      $scope.edit_certificate_data = false;
      $scope.edit_certificate_data_autos = false;
      if ($scope.parCategory && $scope.active_cert) {
        $scope.selectCategory($scope.parCategory, $scope.active_cert);
      }
    };

    $scope.selectExcel = function (parData) {
      validateExcel(parData.ASEGURADOS);
      $scope.strcutureData = certStructure(parData);
      treeStructure(parData);
      // ocultar árbol
      $scope.id_tree = true;
    };

    $scope.selectExcelInfoAdicional = function (parData) {
      $scope.dataInfoAdicional = certStructureInfo(parData);
      $scope.infoAditional = true;
    };
    function certStructureInfo(parData, par_status) {
      var certificadosArrayInfo = [];

      for (var key in parData) {
        var data = parData[key];
        if (data.length) {
          if (order.form.subramo.subramo_code == 9) {
            // COCHES
            var autos_certs = [];
            data.forEach(function (item) {
              if (!item.NUMPOLIZA) {
                SweetAlert.swal(
                  "Error en Layout",
                  "La columna NUMPOLIZA esta vacia",
                  "error"
                );
                return;
              }
              if (!item.CERTIFICADO) {
                SweetAlert.swal(
                  "Error en Layout",
                  "La columna CERTIFICADO esta vacia",
                  "error"
                );
                return;
              }
              var data_autos = [
                {
                  preferential_benefiaciary: item.BEN_PREFERENTE
                    ? item.BEN_PREFERENTE
                    : "",
                  beneficiary_address: item.BEN_DIRECCION
                    ? item.BEN_DIRECCION
                    : "",
                  beneficiary_rfc: item.BEN_RFC ? item.BEN_RFC : "",
                  adjustment: item.ADAPTACIONES ? item.ADAPTACIONES : "",
                  mont_adjustment: item.MONTO_ADAPTACIONES
                    ? item.MONTO_ADAPTACIONES
                    : "",
                  special_team: item.EQUIPAMIENTO ? item.EQUIPAMIENTO : "",
                  mont_special_team: item.MONTO_EQUIPAMIENTO
                    ? item.MONTO_EQUIPAMIENTO
                    : "",
                  service: item.SERVICIO ? item.SERVICIO : "",
                  procedencia: item.PROCEDENCIA ? item.PROCEDENCIA : "",
                  charge_type: item.CARGA ? item.CARGA : "",
                  sum_insured: item.SUMA_ASEGURADA ? item.SUMA_ASEGURADA : 0,
                  email: item.EMAIL ? item.EMAIL : "",
                },
              ];
              autos_certs.push(data_autos);
              var certData = {
                caratula: $scope.caratula.id,
                certificate_number: parseInt(item.CERTIFICADO),
                poliza_number:
                  $scope.caratula.poliza_number + " - INC. " + item.CERTIFICADO,
                ramo: $scope.caratula.ramo.ramo_code,
                subramo: $scope.caratula.subramo.subramo_code,
                old_policies: [],
                recibos_poliza: [],
                automobiles_policy: data_autos,
                damages_policy: [],
                accidents_policy: [],
                life_policy: [],
                document_type: 6,
              };
              certificadosArrayInfo.push(certData);
            });

            return certificadosArrayInfo;
          } else if (
            order.form.ramo.ramo_code == 3 &&
            order.form.subramo.subramo_code != 9
          ) {
            // DAÑOS
            var danios_certs = [];

            data.forEach(function (item) {
              if (!item.CONTACTO) {
                item.CONTACTO = "";
              }

              if (item.PAQUETE) {
                item.PAQUETE = item.PAQUETE;
              }

              if (item.PRIMA_NETA) {
                $scope.prima_neta = item.PRIMA_NETA;
              } else {
                $scope.prima_neta = 0;
              }
              if (item.DERECHO) {
                $scope.derecho = item.DERECHO;
              } else {
                $scope.derecho = 0;
              }
              if (item.RPF) {
                $scope.rpf = item.RPF;
              } else {
                $scope.rpf = 0;
              }
              if (item.IVA) {
                $scope.iva = item.IVA;
              } else {
                $scope.iva = 0;
              }
              var data_danios = [
                {
                  insured_item: item.NOMBRE,
                  item_address:
                    item.CALLE +
                    " #" +
                    item.NUMERO +
                    " " +
                    item.COLONIA +
                    " " +
                    item.DELEGACION +
                    " " +
                    item.CIUDAD +
                    " " +
                    item.ESTADO +
                    " C.P." +
                    item.CP,
                  document_type: 6,
                  p_neta: $scope.prima_neta,
                  derecho: $scope.derecho,
                  rpf: $scope.rpf,
                  iva: $scope.iva,
                },
              ];

              danios_certs.push(data_danios);

              if (item.CATEGORIA) {
                var categoria_ = parseInt(item.CATEGORIA);
              } else {
                var categoria_ = $scope.categoria_result.id;
              }

              if (item.SUBGRUPO) {
                for (var i = 0; i < order.subgroups.length; i++) {
                  var item_sub = order.subgroups[i];

                  if (item_sub.id == parseInt(item.SUBGRUPO)) {
                    if (item_sub.address) {
                      var address_ = item.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    } else {
                      var address_ = $scope.caratula.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    }
                  }
                }
              } else {
                var address_ = $scope.caratula.address;
                var natural_ = $scope.caratula.natural;
                var juridical_ = $scope.caratula.juridical;
              }

              if ($scope.caratula.status == "En trámite") {
                var status_ = 1;
              } else {
                var status_ = 14;
              }

              if ($scope.caratula.f_currency == "PESOS") {
                var f_currency_ = 1;
              } else if ($scope.caratula.f_currency == "DOLARES") {
                var f_currency_ = 2;
              } else if ($scope.caratula.f_currency == "UDI") {
                var f_currency_ = 3;
              } else if ($scope.caratula.f_currency == "EURO") {
                var f_currency_ = 4;
              }

              if (order.show.ot) {
                var status_ = 1;
              } else {
                var status_ = 14;
              }

              if ($scope.config_saved.length) {
                $scope.config_saved.forEach(function (i) {
                  if (i.id == item.PAQUETE) {
                    $scope.coberturas_paquete = i.coverage_package;
                    $scope.coberturas_paquete.forEach(function (j) {
                      if (
                        $scope.caratula.subramo.subramo_name == "Gastos Médicos"
                      ) {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                      } else {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                      }
                    });
                  }
                });
              }

              // var inciso_start = new Date(toDate(item.INI_VIGENCIA))
              // var inciso_end = new Date(toDate(item.FIN_VIGENCIA))
              var inciso_start = toDate(item.INI_VIGENCIA);
              var inciso_end = toDate(item.FIN_VIGENCIA);

              var certData = {
                internalNumber: null,
                aseguradora: $scope.caratula.aseguradora.id,
                folio: null,
                caratula: $scope.caratula.id,
                certificate_number: parseInt(item.INCISO),
                parent: categoria_,
                poliza_number:
                  $scope.caratula.poliza_number + " - INC. " + item.INCISO,
                natural: natural_,
                juridical: juridical_,
                ramo: $scope.caratula.ramo.id,
                subramo: $scope.caratula.subramo.id,
                paquete: item.PAQUETE,
                observations: "",
                old_policies: [],
                start_of_validity: inciso_start,
                end_of_validity: inciso_end,
                forma_de_pago: $scope.caratula.frecuencia_de_pago,
                status: status_,
                recibos_poliza: [],
                automobiles_policy: [],
                damages_policy: data_danios,
                accidents_policy: [],
                life_policy: [],
                document_type: 6,
                address: address_, // checar este
                coverageInPolicy_policy: $scope.coberturas_paquete,
                endorsemeted: false,
                clave: $scope.caratula.clave.id,
                f_currency: f_currency_,
                identifier:
                  data_danios[0].insured_item +
                  "-" +
                  data_danios[0].item_addres,
                p_total: item.PRIMA_TOTAL,
                derecho: item.DERECHO ? item.DERECHO : 0,
                rpf: item.RPF ? item.RPF : 0,
                p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                iva: item.IVA ? item.IVA : 0,
                contacto: item.CONTACTO,
              };
              if (item.PRIMA_NETA) {
                $scope.prima_neta = item.PRIMA_NETA;
                certData.prima_neta = $scope.prima_neta;
              } else {
                $scope.prima_neta = 0;
                certData.prima_neta = $scope.prima_neta;
              }
              if (item.DERECHO) {
                $scope.derecho = item.DERECHO;
                certData.derecho = $scope.derecho;
              } else {
                $scope.derecho = 0;
                certData.derecho = $scope.derecho;
              }
              if (item.RPF) {
                $scope.rpf = item.RPF;
                certData.rpf = $scope.rpf;
              } else {
                $scope.rpf = 0;
                certData.rpf = $scope.rpf;
              }
              if (item.IVA) {
                $scope.iva = item.IVA;
                certData.iva = $scope.iva;
              } else {
                $scope.iva = 0;
                certData.iva = $scope.iva;
              }
              if (item.ANTIGUEDAD) {
                certData.rec_antiguedad = toDate(item.ANTIGUEDAD);
              }
              certificadosArrayInfo.push(certData);
            });
            console.log("------", certificadosArrayInfo);
            return certificadosArrayInfo;
          } else if (order.form.subramo.subramo_code == 3) {
            // GASTOS
            var gastos_certs = [];
            data.forEach(function (item) {
              if (!item.NUMPOLIZA) {
                SweetAlert.swal(
                  "Error en Layout",
                  "La columna NUMPOLIZA esta vacia",
                  "error"
                );
                return;
              }
              if (!item.CERTIFICADO) {
                SweetAlert.swal(
                  "Error en Layout",
                  "La columna CERTIFICADO esta vacia",
                  "error"
                );
                return;
              }
              var data_gastos = [
                {
                  email: item.EMAIL ? item.EMAIL : "",
                },
              ];
              gastos_certs.push(data_gastos);
              var certData = {
                caratula: $scope.caratula.id,
                certificate_number: parseInt(item.CERTIFICADO),
                poliza_number:
                  $scope.caratula.poliza_number + " - INC. " + item.CERTIFICADO,
                ramo: $scope.caratula.ramo.ramo_code,
                subramo: $scope.caratula.subramo.subramo_code,
                old_policies: [],
                recibos_poliza: [],
                automobiles_policy: [],
                damages_policy: [],
                accidents_policy: data_gastos,
                life_policy: [],
                document_type: 6,
              };
              certificadosArrayInfo.push(certData);
            });

            return certificadosArrayInfo;
          } else if (order.form.subramo.subramo_code == 1) {
            // VIDA
            var vida_certs = [];
            data.forEach(function (item) {
              if (!item.NUMPOLIZA) {
                SweetAlert.swal(
                  "Error en Layout",
                  "La columna NUMPOLIZA esta vacia",
                  "error"
                );
                return;
              }
              if (!item.CERTIFICADO) {
                SweetAlert.swal(
                  "Error en Layout",
                  "La columna CERTIFICADO esta vacia",
                  "error"
                );
                return;
              }
              var data_vida = [
                {
                  email: item.EMAIL ? item.EMAIL : "",
                },
              ];
              vida_certs.push(data_vida);
              var certData = {
                caratula: $scope.caratula.id,
                certificate_number: parseInt(item.CERTIFICADO),
                poliza_number:
                  $scope.caratula.poliza_number + " - INC. " + item.CERTIFICADO,
                ramo: $scope.caratula.ramo.ramo_code,
                subramo: $scope.caratula.subramo.subramo_code,
                old_policies: [],
                recibos_poliza: [],
                automobiles_policy: [],
                damages_policy: [],
                accidents_policy: [],
                life_policy: data_vida,
                document_type: 6,
              };
              certificadosArrayInfo.push(certData);
            });

            return certificadosArrayInfo;
          }
        }
      }
    }
    $scope.saveInfoAdicional = function () {
      $scope.loader_info = true;
      var data = {
        data: $scope.dataInfoAdicional,
      };
      // console.log('-----------',data)
      $http({
        method: "POST",
        url: url.IP + "massive-certificateUpdate/",
        data: $scope.dataInfoAdicional,
      })
        .then(
          function success(request) {
            if (request.status === 200 || request.status === 201) {
              var params = {
                model: 18,
                event: "PATCH",
                associated_id: $scope.caratula.id,
                identifier: "actualización de certificados.",
              };

              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              SweetAlert.swal(
                "¡Hecho!",
                MESSAGES.OK.CERTIFICATESDONE,
                "success"
              );

              $scope.loader_info = false;
              updateChilds();
            } else {
              $scope.loader_info = false;
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.ERRORCERTIFICATES,
                "error"
              );
            }
          },
          function error(error) {
            console.log("Error -  ");
          }
        )
        .catch(function (e) {
          console.log("Error - catch", e);
        });
    };
    function validateExcel(parData) {
      parData.forEach(function (child) {
        if (!child.INI_VIGENCIA) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna INI_VIGENCIA esta vacia",
            "error"
          );
          return;
        }
        if (!child.FIN_VIGENCIA) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna FIN_VIGENCIA esta vacia",
            "error"
          );
          return;
        }

        if (!child.PAQUETE) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PAQUETE esta vacia",
            "error"
          );
          return;
        }

        if (!child.PRIMA_TOTAL) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PRIMA_TOTAL esta vacia",
            "error"
          );
          return;
        } else if (child.PRIMA_TOTAL.search(",") >= 0) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PRIMA_TOTAL es invalida. Las cantidades deben ser sin comas o caracteres especiales",
            "error"
          );
          return;
        }
        try {
          if (
            order.form.ramo.ramo_code == 1 ||
            order.form.ramo.ramo_code == 2
          ) {
            if (!child.CERT_GRAL) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna CERT_GRAL esta vacia",
                "error"
              );
              return;
            }
            if (!child.CERTIFICADO) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna CERTIFICADO esta vacia",
                "error"
              );
              return;
            }
            if (order.form.ramo.ramo_code == 2 && !child.INCISO) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna INCISO esta vacia",
                "error"
              );
              return;
            }
            if (!child.AP_PAT) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna AP_PAT esta vacia",
                "error"
              );
              return;
            }
            if (!child.NOMBRE) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna NOMBRE esta vacia",
                "error"
              );
              return;
            }
            if (!child.FEC_NAC) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna FEC_NAC esta vacia",
                "error"
              );
              return;
            }

            if (!child.SEXO) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna SEXO esta vacia",
                "error"
              );
              return;
            } else if (!(child.SEXO == "M" || child.SEXO == "F")) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna SEXO contiene un valor invalido",
                "error"
              );
              return;
            }

            if (order.form.ramo.ramo_code == 2 && !child.PARENTESCO) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna PARENTESCO esta vacia",
                "error"
              );
              return;
            } else if (order.form.ramo.ramo_code == 2 && child.PARENTESCO > 4) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna PARENTESCO contiene un valor invalido",
                "error"
              );
              return;
            }

            if (!child.TIPO) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna TIPO esta vacia",
                "error"
              );
              return;
            } else if (child.TIPO > 2) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna TIPO contiene un valor invalido",
                "error"
              );
              return;
            }

            // if(order.form.ramo.ramo_code == 1 && !child.PORCENTAJE && child.TIPO == 2){
            //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna PORCENTAJE esta vacia', "error");
            //   return;
            // } else if(order.form.ramo.ramo_code == 1 && child.PORCENTAJE > 100){
            //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna PORCENTAJE es mayor a 100', "error");
            //   return;
            // }

            // if(order.form.ramo.ramo_code == 1 && !child.FUMADOR && child.TIPO == 1){
            //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna FUMADOR esta vacia', "error");
            //   return;
            // } else if(order.form.ramo.ramo_code == 1 && child.FUMADOR > 1){
            //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna FUMADOR contiene un valor invalido', "error");
            //   return;
            // }
          } else if (order.form.subramo.subramo_code == 9) {
            if (!child.INCISO) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna INCISO esta vacia",
                "error"
              );
              return;
            }

            if (!child.ASEGURADO) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna ASEGURADO esta vacia",
                "error"
              );
              return;
            }

            if (!child.MARCA) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna MARCA esta vacia",
                "error"
              );
              return;
            }

            if (!child.MODELO) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna MODELO esta vacia",
                "error"
              );
              return;
            }

            if (!child.AÑO) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna AÑO esta vacia",
                "error"
              );
              return;
            }

            if (!child.VERSION) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna VERSION esta vacia",
                "error"
              );
              return;
            }

            if (!child.SERIAL) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna SERIAL esta vacia",
                "error"
              );
              return;
            }

            if (!child.MOTOR) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna MOTOR esta vacia",
                "error"
              );
              return;
            }

            if (!child.COLOR) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna COLOR esta vacia",
                "error"
              );
              return;
            }

            if (!child.MATRICULA) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna MATRICULA esta vacia",
                "error"
              );
              return;
            }

            if (!child.USO) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna USO esta vacia",
                "error"
              );
              return;
            } else if (child.USO > 1) {
              SweetAlert.swal(
                "Error en Layout",
                "En el renglon " +
                  (parseInt(child.__rowNum__) + 1) +
                  " la columna USO contiene un valor invalido",
                "error"
              );
              return;
            }
          }
        } catch (e) {}
      });
    }

    $scope.newPackage = function () {
      if ($scope.creation_packages) {
        $scope.creation_packages = false;
      } else {
        $scope.creation_packages = true;
      }
    };
    $scope.showFilesCer = false;
    $scope.saveFiles = function (param, parElement) {
      $scope.num_section = param;
      $scope.element = parElement;

      if (param == 1) {
        uploadFiles($scope.caratulaId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
      }
      if (param == 2) {
        uploadFiles($scope.subgroupId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
      }
      if (param == 3) {
        uploadFiles($scope.categoryId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
      }
      if (param == 4) {
        uploadFiles($scope.certificateId);
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
        $scope.showFilesCer = false;
      }
    };
    $scope.hideFiles = function (identifier, data) {
      if (identifier == 1) {
        $scope.showFilesCar = false;
      }
      if (identifier == 2) {
        $scope.showFilesS = false;
      }
      if (identifier == 3) {
        $scope.showFilesC = false;
      }
      if (identifier == 4) {
        $scope.showFilesCer = false;
        data = [];
      }
    };
    $scope.showFilesCar = false;
    $scope.showFilesS = false;
    $scope.showFilesCar = false;
    $scope.showFiles = function (param, id, parElement) {
      if (param == 1) {
        $scope.showFilesCar = true;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
        $http
          .get(url.IP + "polizas/" + $scope.caratulaId + "/archivos/")
          .then(function (response) {
            $scope.filesC = response.data.results;
          });
      } else if (param == 2) {
        $scope.showFilesS = true;
        $scope.showFilesCar = false;
        $scope.showFilesC = false;
        $scope.subgroupId = id;

        $http
          .get(url.IP + "polizas/" + $scope.subgroupId + "/archivos/")
          .then(function (response) {
            // $scope.filesS = response.data.results;
            parElement.files = response.data.results;
            if (parElement.showFiles) {
              parElement.showFiles = false;
            } else {
              parElement.showFiles = true;
            }
          });

        if ($scope.showFilesC == true) {
          $scope.showFilesC = false;
        }
      } else if (param == 3) {
        $scope.showFilesC = true;
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.categoryId = id;

        $http
          .get(url.IP + "polizas/" + $scope.categoryId + "/archivos/")
          .then(function (response) {
            // $scope.filesCat = response.data.results;
            parElement.files = response.data.results;
            if (parElement.showFiles) {
              parElement.showFiles = false;
            } else {
              parElement.showFiles = true;
            }
          });
        if ($scope.showFilesS == true) {
          $scope.showFilesS = false;
        }
      } else if (param == 4) {
        $scope.showFilesCar = false;
        $scope.showFilesS = false;
        $scope.showFilesC = false;
        $scope.showFilesCer = true;

        $http
          .get(url.IP + "polizas/" + $scope.certificateId + "/archivos/")
          .then(function (response) {
            // $scope.filesCer = response.data.results;
            parElement.files = response.data.results;
            if (parElement.showFiles) {
              parElement.showFiles = false;
            } else {
              parElement.showFiles = true;
            }
          });
      }
    };

    $scope.addTemp = function () {
      $scope.verCertificados = true;
      if ($scope.category_selected.certsEmpty) {
        $scope.category_selected.certsEmpty = false;
      } else {
        $scope.category_selected.certsEmpty = true;
      }
    };

    $scope.saveCertificados = function () {
      $scope.loader = true;
      if ($scope.strcutureData.length <= 800) {
        var data = {
          data: $scope.strcutureData,
        };
        console.log("post", data);
        $http({
          method: "POST",
          url: url.IP + "massive-certificates/",
          data: $scope.strcutureData,
        })
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                var params = {
                  model: 18,
                  event: "POST",
                  associated_id: $scope.caratula.id,
                  identifier: "agregó centificados.",
                };

                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                SweetAlert.swal(
                  "¡Hecho!",
                  MESSAGES.OK.CERTIFICATESDONE,
                  "success"
                );
                $("#tree").treeview({ data: [] });
                $scope.loader = false;
                updateChilds();

                $scope.not_certs = false;
                $scope.certs_data = true;
              } else {
                $scope.loader = false;
                SweetAlert.swal(
                  "Error",
                  MESSAGES.ERROR.ERRORCERTIFICATES,
                  "error"
                );
              }
            },
            function error(error) {
              console.log("Error -  ");
            }
          )
          .catch(function (e) {
            console.log("Error - catch", e);
          });
      } else {
        $scope.loader = false;
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORNUMCERTIFICATES, "error");
      }
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    $rootScope.editTable = function () {
      $scope.editedReceipts = true;
      if ($rootScope.showInput == false) {
        $rootScope.showInput = true;
      } else {
        $rootScope.showInput = false;
      }
    };
    // recibos
    $scope.calculate = function (poliza) {
      if ($scope.editedReceipts) {
        return;
      }

      $scope.dataToSave = {};

      // frecuencia de pago
      if (!poliza.derecho) {
        poliza.derecho = 0;
      }

      if (!poliza.rpf) {
        poliza.rpf = 0;
      }

      var prima_neta = parseFloat(poliza.primaNeta);
      var derecho = parseFloat(poliza.derecho);
      var rpf = parseFloat(poliza.rpf);

      $scope.dataToSave.p_neta = prima_neta;
      $scope.dataToSave.derecho = derecho;
      $scope.dataToSave.rpf = rpf;

      order.poliza = {
        p_neta: prima_neta,
        derecho: derecho,
        rpf: rpf,
      };

      var IVA = 0;
      var TOTAL_IVA = 1;

      if (this.order.poliza.ivaStatus) {
        IVA = 16;
        this.order.poliza.iva = 16;
        TOTAL_IVA = 1.16;
        var pointIva = 0.16;
      } else {
        IVA = 0;
        this.order.poliza.iva = 0;
        var pointIva = 0;
      }

      $scope.dataToSave.iva = IVA;

      if (!order.form.forma_de_pago.value) {
        toaster.info(MESSAGES.ERROR.SELPAY);
      } else {
        // TODO: checar esta función
        function getNumber(num) {
          // console.log('num', num)
          var num2 = Math.ceil(num);
          return new Array(num2);
        }

        function getSubtotal(poliza) {
          var sum = prima_neta + rpf + derecho;
          return Number(sum.toFixed(2));
        }

        function getTotal(poliza) {
          $scope.dataToSave.p_total = (poliza.subTotal * TOTAL_IVA).toFixed(2);
          return poliza.subTotal * TOTAL_IVA;
        }

        function getIva(parValue) {
          var iva = parValue * pointIva;
          return parseFloat(iva);
        }

        function comissionCalc(parPneta) {
          // var p_neta_ = parseFloat(parPneta);
          var p_neta_ = parPneta;

          if (order.form.comision) {
            var comision_ = parseFloat(order.form.comision.comission) / 100;
          } else {
            var comision_ = 0;
          }

          var result = parseFloat(p_neta_ * comision_).toFixed(2);
          return result;
        }

        this.order.receipts = [];
        this.order.defaults = {
          showReceipts: true,
        };

        var initDate = new Date(
          new Date(order.form.start_of_validity).setHours(12, 0, 0, 0)
        );
        var endDate = new Date(
          new Date(order.form.end_of_validity).setHours(11, 59, 59, 0)
        );
        // console.log('fomr', order.form);
        // console.log('endDate', endDate);
        var months = helpers.monthDiff(initDate, endDate);
        // Calculate diff between dates

        var dateDiff = moment(endDate).diff(moment(initDate), "days");
        var amountReceipts = (order.amountReceipts =
          months / order.form.forma_de_pago.value);
        //Calculate poliza results
        this.order.poliza.subTotal = getSubtotal(this.order.poliza);
        this.order.poliza.primaTotal = getTotal(this.order.poliza);
        this.order.poliza.iva = getIva(this.order.poliza.subTotal).toFixed(2);

        amountReceipts = Math.ceil(amountReceipts);
        var arrayLen = getNumber(amountReceipts);
        // Logic from order
        var obj = {
          prima: this.order.poliza.primaNeta / amountReceipts,
          rpf: this.order.poliza.rpf / amountReceipts,
          derecho: this.order.poliza.derecho / amountReceipts,
          iva: parseFloat(this.order.poliza.iva).toFixed(2),
          subTotal: this.order.poliza.subTotal / amountReceipts,
          primaTotal: this.order.poliza.primaTotal / amountReceipts,
        };
        for (var i = 0; i < arrayLen.length; i++) {
          // Check options
          if (this.order.configDerecho) {
            if (i === 0) {
              if (order.poliza.derecho) {
                obj.derecho = parseFloat(this.order.poliza.derecho);
              } else {
                obj.derecho = 0;
              }
            } else {
              obj.derecho = 0;
            }
          }

          if (this.order.configRPF) {
            if (i === 0) {
              if (obj.rpf) {
                obj.rpf = parseFloat(order.poliza.rpf);
              } else {
                obj.rpf = 0;
              }
            } else {
              obj.rpf = 0;
            }
          }

          endDate = new Date(
            new Date(
              moment(initDate).add(order.form.forma_de_pago.value, "months")
            ).setHours(11, 59, 59, 0)
          );
          var subTotal = obj.prima + obj.rpf + obj.derecho;

          var receipt = {
            recibo_numero: i + 1,
            prima_neta: parseFloat(obj.prima.toFixed(2)),
            prima: parseFloat(obj.prima.toFixed(2)),
            rpf: parseFloat(obj.rpf.toFixed(2)),
            derecho: parseFloat(obj.derecho.toFixed(2)),
            iva: getIva(subTotal).toFixed(2),
            subTotal: parseFloat(subTotal.toFixed(2)),
            prima_total: parseFloat((subTotal * 1.16).toFixed(2)),
            total: parseFloat((subTotal * 1.16).toFixed(2)),
            comision: comissionCalc(parseFloat(obj.prima.toFixed(2))),
            receipt_type: 1,
          };
          $scope.iva_currency = receipt.subTotal * 0.16;
          if (dateDiff === 364 || dateDiff === 365 || dateDiff === 366) {
            receipt.fecha_inicio = convertDate(initDate);
            receipt.startDate = convertDate(initDate);
            receipt.endingDate = convertDate(endDate);
            receipt.fecha_fin = convertDate(endDate);
          } else {
            receipt.startDate = "";
            receipt.endingDate = "";
            receipt.fecha_inicio = "";
            receipt.fecha_fin = "";
          }

          initDate = endDate;

          this.order.receipts.push(angular.copy(receipt));
          $scope.dataToSave.recibos_poliza = this.order.receipts;
        }
      }
    };

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      // console.log('pages', pages);

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.selectPage = function (parPage) {
        var url = "";
        if (config_.next || config_.previous) {
          if (config_.next) {
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            url = config_.next.substring(0, config_.next.indexOf("&page=") + 6);
            url += parPage.toString();

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              // console.log('param', params);
              url += "&" + params;
            }
          } else {
            url = "";

            var otherParameters = config_.previous.substring(
              config_.previous.indexOf("&page=") + 6
            );

            if (config_.previous.search("&page=") !== -1) {
              url = config_.previous.substring(
                0,
                config_.previous.indexOf("&page=") + 6
              );
              url += parPage.toString();
            } else {
              url = config_.previous;
            }

            if (config_.previous.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }

        getProviders(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
      function getProviders(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              if ($scope.category_selected.certs.length) {
                $scope.category_selected.certsEmpty = false;
                $scope.category_selected.certs.forEach(function (item, index) {
                  var ps = {
                    policy: item.id,
                  };
                  dataFactory
                    .get("get-endosos-sinister/", ps)
                    .then(function success(response) {
                      item.endosos = response.data.endosos;
                      item.siniestros = response.data.siniestros;
                    });
                  if (item.life_policy.length) {
                    item.datos = item.life_policy[0];
                  } else if (item.accidents_policy.length) {
                    item.datos = item.accidents_policy[0];
                  } else if (item.damages_policy.length) {
                    item.datos = item.damages_policy[0];
                  }
                });
              } else {
                $scope.category_selected.certsEmpty = true;
              }

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    $scope.deleteSub = function (sub) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Se eliminara el subgrupo con todas sus categorias y certificados",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var params = {
              model: 18,
              event: "DELETE",
              associated_id: $scope.caratula.id,
              identifier: "eliminó el subgrupo " + sub.name,
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            var data_email = {
              id: sub.id,
              model: 2,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {
                console.log(".................:::::.....", req, sub);
              });
            $http.delete(sub.url).then(function success(response) {
              if (response.status == 204) {
                $scope.subgroups.splice(sub, 1);
                SweetAlert.swal(
                  "Hecho",
                  "Se ha eliminado el subgrupo, sus categorias y certificados",
                  "success"
                );
              }
            });
          }
        }
      );
    };

    $scope.deleteCat = function (cat, categories) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Se eliminara la categoria y todos sus certificados",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var params = {
              model: 18,
              event: "DELETE",
              associated_id: $scope.caratula.id,
              identifier:
                "elimino la categoría " +
                cat.name +
                " del subgrupo " +
                categories.name +
                ".",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            var data_email = {
              id: cat.id,
              model: 2,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {
                console.log(".................:::::.....", req);
              });
            $http.delete(cat.url).then(function success(response) {
              if (response.status == 204) {
                categories.categories.splice(cat, 1);
                SweetAlert.swal(
                  "Hecho",
                  "Se ha eliminado la categoria y  todos sus certificados",
                  "success"
                );
              }
            });
          }
        }
      );
    };

    function ParseDate(fecha) {
      var dateParts = fecha.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      return dateObject;
    }

    function certStructure(parData, par_status) {
      var certificadosArray = [];
      var beneficiaries_life = [];
      var beneficiaries_gm = [];
      var life_data = [];
      var gm_data = [];

      // for(var key in parData) {
      //   var data = parData[key];
      //   if(data.length) {
      //     if(order.form.subramo.subramo_code == 9) { // COCHES
      //       var autos_certs = [];

      //       data.forEach(function(item) {

      //         if(!item.EMAIL) {
      //           item.EMAIL = '';
      //         }
      //         if(!item.CONTACTO){
      //           item.CONTACTO = '';
      //         }
      //         if(item.PAQUETE) {
      //           item.PAQUETE = item.PAQUETE;
      //         }

      //         // var data_autos = [{
      //         //   brand : item.MARCA,
      //         //   beneficiary_name : item.ASEGURADO,
      //         //   model : item.MODELO,
      //         //   year : item.AÑO,
      //         //   version : item.VERSION,
      //         //   serial : item.SERIAL,
      //         //   engine : item.MOTOR,
      //         //   color : item.COLOR,
      //         //   email: item.EMAIL,
      //         //   license_plates : item.MATRICULA,
      //         //   document_type : 6
      //         // }];
      //         if ( item.MOTOR) {
      //             $scope.mtr = item.MOTOR
      //           }else{
      //             $scope.mtr = ''
      //           }
      //           if ( item.COLOR) {
      //             $scope.clr = item.COLOR
      //           }else{
      //             $scope.clr = ''
      //           }
      //           if ( item.MARCA) {
      //             $scope.mrc = item.MARCA
      //           }else{
      //             $scope.mrc = 'NP'
      //           }
      //           if ( item.MODELO) {
      //             $scope.mdl = item.MODELO
      //           }else{
      //             $scope.mdl = 'NP'
      //           }
      //           if ( item.AÑO) {
      //             $scope.ani = item.AÑO
      //           }else{
      //             $scope.ani = 'NP'
      //           }

      //           if ( item.CONDUCTOR) {
      //             $scope.cndtr = item.CONDUCTOR
      //           }else{
      //             $scope.cndtr = ''
      //           }
      //           if ( item.BEN_PREFERENTE) {
      //             $scope.ben_p = item.BEN_PREFERENTE
      //           }else{
      //             $scope.ben_p = ''
      //           }
      //           var data_autos = [{
      //             brand : $scope.mrc,
      //             model : $scope.mdl,
      //             beneficiary_name : item.ASEGURADO,
      //             year : $scope.ani,
      //             driver : item.CONDUCTOR,
      //             version : item.VERSION,
      //             serial : item.SERIAL,
      //             engine : item.MOTOR,
      //             color : $scope.clr,
      //             usage : item.USO,
      //             license_plates : item.MATRICULA,
      //             email :item.EMAIL,
      //             preferential_benefiaciary :$scope.ben_p,
      //             document_type : 6
      //           }];
      //         autos_certs.push(data_autos);

      //         if(item.CATEGORIA) {
      //             var categoria_ = parseInt(item.CATEGORIA);
      //           } else {
      //             var categoria_ = $scope.categories[0].id
      //           }

      //           if(item.SUBGRUPO) {
      //             for(var i = 0; i < $scope.subgroups.length; i++) {

      //               var item_sub = $scope.subgroups[i];

      //               if(item_sub.id == parseInt(item.SUBGRUPO)) {
      //                   if(item_sub.address) {
      //                     var address_ = item.address;
      //                     var natural_ = item.natural;
      //                     var juridical_ = item.juridical;

      //                   } else {
      //                     var address_ = $scope.caratula.address;
      //                     var natural_ = item.natural;
      //                     var juridical_ = item.juridical;

      //                   }
      //                 }
      //             }

      //           } else {

      //             var address_ = $scope.caratula.address;
      //             if($scope.caratula.natural) {
      //               var natural_ = $scope.caratula.natural.id;
      //             } else {
      //               var juridical_  = $scope.caratula.juridical.id;
      //             }
      //           }

      //           if($scope.caratula.status == "En trámite") {
      //             var status_ = 1
      //           } else {
      //             var status_ = 14;
      //           }

      //           if($scope.caratula.f_currency == 'PESOS'){
      //             var f_currency_ = 1;
      //           } else {
      //             var f_currency_ = 2;
      //           }

      //           if($scope.packages.length) {
      //             $scope.packages.forEach(function(i) {
      //               if(i.id == item.PAQUETE) {
      //                 $scope.coberturas_paquete = i.coverage_package;
      //                 $scope.coberturas_paquete.forEach(function(j) {
      //                   if($scope.caratula.subramo.subramo_name == 'Gastos Médicos'){
      //                     j.package = i.id;
      //                     j.sum_insured = j.sums_coverage[0].sum_insured;
      //                     j.deductible = j.deductible_coverage[0].deductible;
      //                     j.coinsurance = j.coinsurance_coverage[0].coinsurance;
      //                   }
      //                   else{
      //                     j.package = i.id;
      //                     j.sum_insured = j.sums_coverage[0].sum_insured;
      //                     j.deductible = j.deductible_coverage[0].deductible;
      //                     j.coinsurance = 0;
      //                   }
      //                 });
      //               }
      //             });
      //           }

      //           // var inciso_start = new Date(toDate(item.INI_VIGENCIA))
      //           // var inciso_end = new Date(toDate(item.FIN_VIGENCIA))
      //           var inciso_start = toDate(convertDate(new Date((item.INI_VIGENCIA))))
      //           var inciso_end = toDate(convertDate(new Date((item.FIN_VIGENCIA))))
      //           var certData = {
      //             internalNumber: null,
      //             aseguradora: $scope.caratula.aseguradora.id,
      //             folio: null,
      //             caratula: $scope.caratula.id,
      //             certificate_number: parseInt(item.INCISO),
      //             parent: categoria_,
      //             poliza_number: $scope.caratula.poliza_number+' - INC. '+item.INCISO,
      //             natural: natural_,
      //             juridical: juridical_,
      //             ramo: $scope.caratula.ramo.id,
      //             subramo: $scope.caratula.subramo.id,
      //             paquete: item.PAQUETE,
      //             observations: '',
      //             old_policies: [],
      //             start_of_validity: inciso_start,
      //             end_of_validity: inciso_end,
      //             forma_de_pago: $scope.caratula.frecuencia_de_pago,
      //             status: status_,
      //             recibos_poliza: [],
      //             automobiles_policy: data_autos,
      //             damages_policy: [],
      //             accidents_policy: [],
      //             life_policy: [],
      //             document_type: 6,
      //             address: address_, // checar este
      //             coverageInPolicy_policy: $scope.coberturas_paquete,
      //             endorsemeted: false,
      //             clave: $scope.caratula.clave.id,
      //             f_currency: f_currency_,
      //             identifier: data_autos[0].brand+'-'+data_autos[0].model+'-'+data_autos[0].year,
      //             p_total: item.PRIMA_TOTAL,
      //             derecho: item.DERECHO ? item.DERECHO : 0,
      //             rpf: item.RPF ? item.RPF :0,
      //             p_neta: item.PRIMA_NETA ? item.PRIMA_NETA :0,
      //             iva: item.IVA  ? item.IVA: 0,
      //             comision: item.COMISION  ? item.COMISION: 0,
      //             contacto: item.CONTACTO
      //           };
      //           if (item.ANTIGUEDAD) {
      //               certData.rec_antiguedad = toDate(item.ANTIGUEDAD)
      //           }else{
      //             certData.rec_antiguedad = null;
      //           }

      //           certificadosArray.push(certData)

      //       });

      //       return certificadosArray;

      //     } else if(order.form.ramo.ramo_code == 3 && order.form.subramo.subramo_code != 9) { // DAÑOS
      //       var danios_certs = [];

      //       data.forEach(function(item) {
      //         if(!item.CONTACTO){
      //           item.CONTACTO = '';
      //         }

      //         if(item.PAQUETE) {
      //           item.PAQUETE = item.PAQUETE;
      //         }

      //         var data_danios = [{
      //           insured_item : item.NOMBRE,
      //           item_address : item.CALLE + ' #' + item.NUMERO + ' ' + item.COLONIA + ' ' + item.DELEGACION + ' ' + item.CIUDAD + ' ' + item.ESTADO + ' C.P.' + item.CP,
      //           document_type : 6
      //         }];

      //         danios_certs.push(data_danios);

      //         if(item.CATEGORIA) {
      //             var categoria_ = parseInt(item.CATEGORIA);
      //           } else {
      //             var categoria_ = $scope.categories[0].id
      //           }

      //           if(item.SUBGRUPO) {
      //             for(var i = 0; i < $scope.subgroups.length; i++) {

      //               var item_sub = $scope.subgroups[i];

      //               if(item_sub.id == parseInt(item.SUBGRUPO)) {
      //                   if(item_sub.address) {
      //                     var address_ = item.address;
      //                     var natural_ = item.natural;
      //                     var juridical_ = item.juridical;

      //                   } else {
      //                     var address_ = $scope.caratula.address;
      //                     var natural_ = item.natural;
      //                     var juridical_ = item.juridical;

      //                   }
      //                 }
      //             }

      //           } else {

      //             var address_ = $scope.caratula.address;
      //             if($scope.caratula.natural) {
      //               var natural_ = $scope.caratula.natural.id;
      //             } else {
      //               var juridical_  = $scope.caratula.juridical.id;
      //             }
      //           }

      //           if($scope.caratula.status == "OT Pendiente.") {
      //             var status_ = 1
      //           } else {
      //             var status_ = 14;
      //           }

      //           if($scope.caratula.f_currency == 'PESOS'){
      //             var f_currency_ = 1;
      //           } else {
      //             var f_currency_ = 2;
      //           }

      //           if($scope.packages.length) {
      //             $scope.packages.forEach(function(i) {
      //               if(i.id == item.PAQUETE) {
      //                 $scope.coberturas_paquete = i.coverage_package;
      //                 $scope.coberturas_paquete.forEach(function(j) {
      //                   if($scope.caratula.subramo.subramo_name == 'Gastos Médicos'){
      //                     j.package = i.id;
      //                     j.sum_insured = j.sums_coverage[0].sum_insured;
      //                     j.deductible = j.deductible_coverage[0].deductible;
      //                     j.coinsurance = j.coinsurance_coverage[0].coinsurance;
      //                   }
      //                   else{
      //                     j.package = i.id;
      //                     j.sum_insured = j.sums_coverage[0].sum_insured;
      //                     j.deductible = j.deductible_coverage[0].deductible;
      //                     j.coinsurance = 0;
      //                   }
      //                 });
      //               }
      //             });
      //           }

      //           // var inciso_start = new Date(toDate(item.INI_VIGENCIA))
      //           // var inciso_end = new Date(toDate(item.FIN_VIGENCIA))
      //           var inciso_start = toDate(convertDate(new Date((item.INI_VIGENCIA))))
      //           var inciso_end = toDate(convertDate(new Date((item.FIN_VIGENCIA))))
      //           var certData = {
      //             internalNumber: null,
      //             aseguradora: $scope.caratula.aseguradora.id,
      //             folio: null,
      //             caratula: $scope.caratula.id,
      //             certificate_number: parseInt(item.INCISO),
      //             parent: categoria_,
      //             poliza_number: $scope.caratula.poliza_number+' - INC. '+item.INCISO,
      //             natural: natural_,
      //             juridical: juridical_,
      //             ramo: $scope.caratula.ramo.id,
      //             subramo: $scope.caratula.subramo.id,
      //             paquete: item.PAQUETE,
      //             observations: '',
      //             old_policies: [],
      //             start_of_validity: inciso_start,
      //             end_of_validity: inciso_end,
      //             forma_de_pago: $scope.caratula.frecuencia_de_pago,
      //             status: status_,
      //             recibos_poliza: [],
      //             automobiles_policy: [],
      //             damages_policy:  data_danios,
      //             accidents_policy: [],
      //             life_policy: [],
      //             document_type: 6,
      //             address: address_, // checar este
      //             coverageInPolicy_policy: $scope.coberturas_paquete,
      //             endorsemeted: false,
      //             clave: $scope.caratula.clave.id,
      //             f_currency: f_currency_,
      //             identifier: data_danios[0].insured_item + '-' + data_danios[0].item_addres,
      //             p_total: item.PRIMA_TOTAL,
      //             derecho: item.DERECHO ? item.DERECHO : 0,
      //             rpf: item.RPF ? item.RPF : 0,
      //             p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
      //             iva:item.IVA ? item.IVA : 0,
      //             contacto: item.CONTACTO
      //           };
      //           if (item.ANTIGUEDAD) {
      //               certData.rec_antiguedad = toDate(item.ANTIGUEDAD)
      //           }else{
      //             certData.rec_antiguedad = null
      //           }
      //           certificadosArray.push(certData)

      //       });

      //       return certificadosArray;

      //     } else {
      //       data.forEach(function(item) {
      //         var certificate = item.CERTIFICADO;

      //         if(item.CATEGORIA) {
      //           var categoria_ = parseInt(item.CATEGORIA);
      //         } else {
      //           var categoria_ = $scope.categories[0].id
      //         }

      //         if(!item.CONTACTO){
      //           item.CONTACTO = '';
      //         }

      //         if($scope.caratula.subramo.subramo_name == 'Vida') {
      //           if(item.TIPO == 2) {
      //             var dataBeneficiary = {
      //               certificate: certificate,
      //               first_name: item.NOMBRE,
      //               last_name: item.AP_PAT,
      //               second_last_name: item.AP_MAT,
      //               // birthdate: new Date(toDate(item.FEC_NAC)),
      //               birthdate : toDate(item.FEC_NAC),
      //               sex: item.SEXO,
      //               percentage: item.PORCENTAJE,
      //               optional_relationship: item.PARENTESCO,
      //               familia: item.CERT_GRAL,
      //               antiguedad: item.ANTIGUEDAD ? toDate(item.ANTIGUEDAD) : null
      //             };

      //             beneficiaries_life.push(dataBeneficiary);
      //           }
      //         } else if ($scope.caratula.ramo.ramo_code == 2) {
      //           if(item.TIPO == 2) {
      //            var dataBeneficiary = {
      //             certificate: certificate,
      //             first_name: item.NOMBRE,
      //             last_name: item.AP_PAT,
      //             second_last_name: item.AP_MAT,
      //             relationship: item.PARENTESCO,
      //             // birthdate: new Date(toDate(item.FEC_NAC)),
      //             birthdate : toDate(item.FEC_NAC),
      //             sex: item.SEXO,
      //             clause: item.INCISO,
      //             familia: item.CERT_GRAL,
      //           };
      //           if (item.ANTIGUEDAD) {
      //             dataBeneficiary.antiguedad = toDate(item.ANTIGUEDAD)
      //           }else{
      //             dataBeneficiary.antiguedad = null
      //           }
      //           beneficiaries_gm.push(dataBeneficiary);

      //         }

      //         }
      //       });

      //       data.forEach( function(elem) {

      //         if(elem.CATEGORIA) {
      //           var categoria_ = parseInt(elem.CATEGORIA);
      //         } else {
      //           var categoria_ = $scope.categories[0].id
      //         }

      //         var certificate = elem.CERTIFICADO;
      //         if($scope.caratula.subramo.subramo_name == 'Vida') {

      //             console.log('--------4----',toDate(elem.FEC_NAC))
      //           if(elem.TIPO == 1) {

      //             if(elem.FUMADOR) {
      //               if(elem.FUMADOR == 0) {
      //                 var smoker = false;
      //               } else {
      //                 var smoker = true;
      //               }
      //             }

      //             var dataGM = [];
      //             var dataVida = [{
      //               personal: {
      //                 certificate: certificate,
      //                 first_name: elem.NOMBRE,
      //                 last_name: elem.AP_PAT,
      //                 second_last_name: elem.AP_MAT,
      //                 // birthdate: new Date(toDate(elem.FEC_NAC)),
      //                 birthdate : toDate(elem.FEC_NAC),
      //                 sex: elem.SEXO,
      //                 email: elem.EMAIL,
      //                 salary: parseInt(elem.SUELDO),
      //                 sum_assured: parseInt(elem.SUELDO),
      //                 antiguedad: elem.ANTIGUEDAD ? toDate(elem.ANTIGUEDAD) : null
      //               },
      //               smoker: smoker,
      //               beneficiaries_life: []
      //             }];
      //             beneficiaries_life.forEach(function(i) {
      //               if(i.familia == elem.CERT_GRAL) {
      //                 dataVida[0].beneficiaries_life.push(i);
      //               }
      //             });
      //             // life_data.push(dataVida);
      //           }

      //         } else if ($scope.caratula.ramo.ramo_code == 2) {
      //           if(elem.TIPO == 1) {

      //             var dataVida = [];
      //             var dataGM = [{
      //               personal: {
      //                 certificate: certificate,
      //                 first_name: elem.NOMBRE,
      //                 last_name: elem.AP_PAT,
      //                 second_last_name: elem.AP_MAT,
      //                 // birthdate: new Date(toDate(elem.FEC_NAC)),
      //                 birthdate : toDate(elem.FEC_NAC),
      //                 sex: elem.SEXO,
      //                 email: elem.EMAIL,
      //                 antiguedad: elem.ANTIGUEDAD ? toDate(elem.ANTIGUEDAD) : null
      //               },
      //               disease_type: 0,
      //               relationship_accident: []
      //             }];

      //             beneficiaries_gm.forEach(function(i) {
      //               if(i.familia == elem.CERT_GRAL) {
      //                 dataGM[0].relationship_accident.push(i);
      //               }
      //             });
      //             // gm_data.push(dataGM);
      //           }
      //         }
      //         if(elem.TIPO == 1) {
      //           if($scope.caratula.f_currency == "PESOS"){
      //             $scope.f_currencyToSave = 1;
      //           } else {
      //             $scope.f_currencyToSave = 2;
      //           }

      //           if($scope.packages.length) {
      //             $scope.packages.forEach(function(i) {
      //               if(i.id == elem.PAQUETE) {
      //                 $scope.coberturas_paquete = i.coverage_package;
      //                 $scope.coberturas_paquete.forEach(function(j) {
      //                   if($scope.caratula.subramo.subramo_name == 'Gastos Médicos'){
      //                     j.package = i.id;
      //                     j.sum_insured = j.sums_coverage[0].sum_insured;
      //                     j.deductible = j.deductible_coverage[0].deductible;
      //                     j.coinsurance = j.coinsurance_coverage.length ? j.coinsurance_coverage[0].coinsurance : 0;
      //                   }
      //                   else{
      //                     j.package = i.id;
      //                     j.sum_insured = j.sums_coverage[0].sum_insured;
      //                     j.deductible = j.deductible_coverage[0].deductible;
      //                     j.coinsurance = 0;
      //                   }
      //                 });
      //               }
      //             });
      //           }

      //           // var inciso_start = new Date(toDate(elem.INI_VIGENCIA))
      //           // var inciso_end = new Date(toDate(elem.FIN_VIGENCIA))

      //           if ($scope.caratula.subramo.subramo_name == 'Vida') {
      //             var inciso_start = new Date(convertDate(elem.INI_VIGENCIA))
      //             var inciso_end = new Date(convertDate(elem.FIN_VIGENCIA))
      //           }else{
      //             var inciso_start = toDate(convertDate(new Date((elem.INI_VIGENCIA))))
      //             var inciso_end = toDate(convertDate(new Date((elem.FIN_VIGENCIA))))
      //           }
      //           var certData = {
      //             internalNumber: null,
      //             folio: null,
      //             caratula: $scope.caratula.id,
      //             certificate_number: parseInt(elem.CERTIFICADO),
      //             parent: categoria_,
      //             poliza_number: $scope.caratula.poliza_number+' - INC. '+elem.CERTIFICADO,
      //             ramo: $scope.caratula.ramo.id,
      //             subramo: $scope.caratula.subramo.id,
      //             paquete: elem.PAQUETE,
      //             observations: elem.OBSERVATIONS,
      //             old_policies: [],
      //             forma_de_pago: $scope.caratula.frecuencia_de_pago,
      //             status: par_status,
      //             recibos_poliza: [],
      //             automobiles_policy: [],
      //             damages_policy: [],
      //             accidents_policy: dataGM,
      //             life_policy: dataVida,
      //             document_type: 6,
      //             coverageInPolicy_policy: $scope.coberturas_paquete,
      //             endorsemeted: false,
      //             clave: $scope.caratula.clave.id,
      //             f_currency: $scope.f_currencyToSave,
      //             identifier: elem.IDENTIFICADOR,
      //             p_total: elem.PRIMA_TOTAL,
      //             derecho: elem.DERECHO ? elem.DERECHO : 0,
      //             rpf: elem.RPF ? elem.RPF : 0,
      //             p_neta: elem.PRIMA_NETA ? elem.PRIMA_NETA: 0,
      //             iva: elem.IVA ? elem.IVA :0,
      //             start_of_validity: inciso_start,
      //             end_of_validity: inciso_end,
      //             contacto: elem.CONTACTO
      //           };
      //           if (elem.ANTIGUEDAD) {
      //               certData.rec_antiguedad = toDate(elem.ANTIGUEDAD)
      //           }else{

      //             certData.rec_antiguedad = null

      //             certData = certData;

      //           }
      //           life_data = [];
      //           certificadosArray.push(certData)
      //         }

      //       });
      //       return certificadosArray;
      //     }
      //   }
      // }
      // for(var key in parData) {

      //   var data = parData[key];

      //   if(data.length) {

      //     if($scope.caratula.subramo.subramo_code == 9) { // COCHES
      //       var autos_certs = [];

      //       data.forEach(function(item) {

      //         if(item.USO){
      //           if(item.USO >= "4" || item.USO <= "0"){
      //             item.USO = "1";
      //           }
      //         }
      //         else{
      //           item.USO = "1";
      //         }

      //         if(!item.EMAIL) {
      //           item.EMAIL = '';
      //         }

      //         if(!item.CONTACTO){
      //           item.CONTACTO = '';
      //         }
      //         if ( item.MOTOR) {
      //           $scope.mtr = item.MOTOR
      //         }else{
      //           $scope.mtr = ''
      //         }
      //         if ( item.COLOR) {
      //           $scope.clr = item.COLOR
      //         }else{
      //           $scope.clr = ''
      //         }
      //         if ( item.MARCA) {
      //           $scope.mrc = item.MARCA
      //         }else{
      //           $scope.mrc = 'NP'
      //         }
      //         if ( item.MODELO) {
      //           $scope.mdl = item.MODELO
      //         }else{
      //           $scope.mdl = 'NP'
      //         }
      //         if ( item.AÑO) {
      //           $scope.ani = item.AÑO
      //         }else{
      //           $scope.ani = 'NP'
      //         }

      //         if ( item.CONDUCTOR) {
      //           $scope.cndtr = item.CONDUCTOR
      //         }else{
      //           $scope.cndtr = ''
      //         }
      //         if ( item.BEN_PREFERENTE) {
      //           $scope.ben_p = item.BEN_PREFERENTE
      //         }else{
      //           $scope.ben_p = ''
      //         }

      //         if ( item.PRIMA_NETA) {
      //           $scope.p_neta = item.PRIMA_NETA
      //         }else{
      //           $scope.p_neta = 0
      //         }
      //         if ( item.DERECHO) {
      //           $scope.derecho = item.DERECHO
      //         }else{
      //           $scope.derecho = 0
      //         }
      //         if ( item.RPF) {
      //           $scope.rpf = item.RPF
      //         }else{
      //           $scope.rpf = 0
      //         }
      //         if ( item.IVA) {
      //           $scope.iva = item.IVA
      //         }else{
      //           $scope.iva = 0
      //         }
      //         if ( item.COMISION) {
      //           $scope.comision = item.COMISION
      //         }else{
      //           $scope.comision = 0
      //         }
      //         if ( item.PRIMA_TOTAL) {
      //           $scope.p_total = item.PRIMA_TOTAL
      //         }else{
      //           $scope.p_total = 0
      //         }

      //           var data_autos = [{
      //             brand : $scope.mrc,
      //             model : $scope.mdl,
      //             beneficiary_name : item.ASEGURADO,
      //             driver : item.CONDUCTOR,
      //             year : $scope.ani,
      //             version : item.VERSION,
      //             serial : item.SERIAL,
      //             engine : item.MOTOR,
      //             color : $scope.clr,
      //             usage : item.USO,
      //             license_plates : item.MATRICULA,
      //             email :item.EMAIL,
      //             // driver :$scope.cndtr,
      //             preferential_benefiaciary :$scope.ben_p,
      //             p_neta :$scope.p_neta,
      //             derecho :$scope.derecho,
      //             rpf :$scope.rpf,
      //             iva :$scope.iva,
      //             comision :$scope.comision,
      //             document_type : 6
      //           }];
      //            autos_certs.push(data_autos);
      //           if(item.CATEGORIA) {
      //             var categoria_ = parseInt(item.CATEGORIA);
      //           } else {
      //             var categoria_ = $scope.categoria_result.id;
      //           }

      //         if(item.SUBGRUPO) {

      //           for(var i = 0; i < $scope.subgroups.length; i++) {

      //             var item_sub = $scope.subgroups[i];

      //             if(item_sub.id == parseInt(item.SUBGRUPO)) {
      //                 if(item_sub.address) {
      //                   var address_ = item.address;
      //                   var natural_ = item.natural;
      //                   var juridical_ = item.juridical;

      //                 } else {

      //                   var address_ = $scope.caratula.address;
      //                   var natural_ = item.natural;
      //                   var juridical_ = item.juridical;

      //                 }
      //               }
      //           }

      //         } else {

      //           var address_ = $scope.caratula.address;
      //           var natural_ = $scope.caratula.natural;
      //           var juridical_  = $scope.caratula.juridical;
      //         }

      //         if($scope.show.ot) {
      //           var status_ = 1
      //         } else {
      //           var status_ = 14;
      //         }

      //         if($scope.config_saved.length) {
      //           $scope.config_saved.forEach(function(i) {
      //             if(i.id == item.PAQUETE) {
      //               $scope.coberturas_paquete = i.coverage_package;
      //               $scope.coberturas_paquete.forEach(function(j) {
      //                 if($scope.caratula.subramo.subramo_name == 'Gastos Médicos'){
      //                   j.package = i.id;
      //                   j.sum_insured = j.sums_coverage[0].sum_insured;
      //                   j.deductible = j.deductible_coverage[0].deductible;
      //                   j.coinsurance = j.coinsurance_coverage[0].coinsurance;
      //                 }
      //                 else{
      //                   j.package = i.id;
      //                   j.sum_insured = j.sums_coverage[0].sum_insured;
      //                   j.deductible = j.deductible_coverage[0].deductible;
      //                   j.coinsurance = 0;
      //                 }
      //               });
      //             }
      //           });
      //         }

      //         // var inciso_start = new Date(toDate(item.INI_VIGENCIA))
      //         // var inciso_end = new Date(toDate(item.FIN_VIGENCIA))
      //         var inciso_start = toDate(convertDate(new Date((item.INI_VIGENCIA))))
      //         var inciso_end = toDate(convertDate(new Date((item.FIN_VIGENCIA))))

      //         var certData = {
      //           internalNumber: null,
      //           folio: null,
      //           caratula: $scope.caratula.id,
      //           certificate_number: parseInt(item.INCISO),
      //           aseguradora: $scope.dataToSave.aseguradora,
      //           parent: categoria_,
      //           poliza_number: $scope.caratula.poliza_number+' - INC. '+item.INCISO,
      //           natural: natural_,
      //           juridical: juridical_,
      //           ramo: $scope.caratula.ramo.id,
      //           subramo: $scope.caratula.subramo.id,
      //           paquete: item.PAQUETE,
      //           observations: '',
      //           old_policies: [],
      //           start_of_validity: inciso_start,
      //           end_of_validity: inciso_end,
      //           forma_de_pago: $scope.caratula.frecuencia_de_pago,
      //           status: status_,
      //           recibos_poliza: [],
      //           automobiles_policy: data_autos,
      //           damages_policy: [],
      //           accidents_policy: [],
      //           life_policy: [],
      //           document_type: 6,
      //           address: address_, // checar este
      //           // coverageInPolicy_policy: [], // checar si estas se agregan en el front o se agregarán en el back
      //           coverageInPolicy_policy: $scope.coberturas_paquete,
      //           endorsemeted: false,
      //           clave: $scope.caratula.clave,
      //             f_currency: $scope.f_currencyToSave,
      //           identifier: data_autos[0].brand+'-'+data_autos[0].model+'-'+data_autos[0].year,
      //           p_total: $scope.p_total ? $scope.p_total : 0,
      //           derecho: $scope.derecho ? $scope.derecho : 0,
      //           rpf: $scope.rpf ? $scope.rpf : 0,
      //           p_neta: $scope.p_neta ? $scope.p_neta : 0,
      //           iva: $scope.iva ? $scope.iva : 0,
      //           comision: $scope.comision ? $scope.comision : 0,
      //           contacto: item.CONTACTO
      //         };
      //         if (item.ANTIGUEDAD) {
      //           certData.rec_antiguedad = toDate(item.ANTIGUEDAD)
      //         }
      //         // console.log('certData',certData)

      //         certificadosArray.push(certData)

      //       });

      //       return certificadosArray;

      //     } else if($scope.caratula.ramo.ramo_code == 3 && $scope.caratula.subramo.subramo_code != 9) { // DAÑOS
      //       var danios_certs = [];

      //       data.forEach(function(item) {
      //         if(!item.CONTACTO){
      //           item.CONTACTO = '';
      //         }

      //         if(item.PAQUETE) {
      //           item.PAQUETE = item.PAQUETE;
      //         }

      //         if ( item.PRIMA_NETA) {
      //           $scope.prima_neta = item.PRIMA_NETA
      //         }else{
      //           $scope.prima_neta = 0
      //         }
      //         if ( item.DERECHO) {
      //           $scope.derecho = item.DERECHO
      //         }else{
      //           $scope.derecho = 0
      //         }
      //         if ( item.RPF) {
      //           $scope.rpf = item.RPF
      //         }else{
      //           $scope.rpf = 0
      //         }
      //         if ( item.IVA) {
      //           $scope.iva = item.IVA
      //         }else{
      //           $scope.iva = 0
      //         }
      //         var data_danios = [{
      //           insured_item : item.NOMBRE,
      //           item_address : item.CALLE + ' #' + item.NUMERO + ' ' + item.COLONIA + ' ' + item.DELEGACION + ' ' + item.CIUDAD + ' ' + item.ESTADO + ' C.P.' + item.CP,
      //           document_type : 6,
      //           p_neta :$scope.prima_neta,
      //           derecho :$scope.derecho,
      //           rpf :$scope.rpf,
      //           iva :$scope.iva,
      //         }];

      //         danios_certs.push(data_danios);

      //         if(item.CATEGORIA) {
      //           var categoria_ = parseInt(item.CATEGORIA);
      //         } else {
      //           var categoria_ = $scope.categoria_result.id;
      //         }

      //         if(item.SUBGRUPO) {

      //           for(var i = 0; i < $scope.subgroups.length; i++) {

      //             var item_sub = $scope.subgroups[i];

      //             if(item_sub.id == parseInt(item.SUBGRUPO)) {
      //                 if(item_sub.address) {
      //                   var address_ = item.address;
      //                   var natural_ = item.natural;
      //                   var juridical_ = item.juridical;

      //                 } else {

      //                   var address_ = $scope.caratula.address;
      //                   var natural_ = item.natural;
      //                   var juridical_ = item.juridical;

      //                 }
      //               }
      //           }

      //         } else {

      //           var address_ = $scope.caratula.address;
      //           var natural_ = $scope.caratula.natural;
      //           var juridical_  = $scope.caratula.juridical;
      //         }

      //           if($scope.caratula.status == "En trámite") {
      //             var status_ = 1
      //           } else {
      //             var status_ = 14;
      //           }

      //           if($scope.caratula.f_currency == 'PESOS'){
      //             var f_currency_ = 1;
      //           } else if ($scope.caratula.f_currency == 'DOLARES') {
      //             var f_currency_ = 2;
      //           } else if($scope.caratula.f_currency == 'UDI'){
      //             var f_currency_ = 3;
      //           }
      //            else if($scope.caratula.f_currency == 'EURO'){
      //             var f_currency_ = 4;
      //           }

      //           if($scope.show.ot) {
      //             var status_ = 1
      //           } else {
      //             var status_ = 14;
      //           }

      //           if($scope.config_saved.length) {
      //             $scope.config_saved.forEach(function(i) {
      //               if(i.id == item.PAQUETE) {
      //                 $scope.coberturas_paquete = i.coverage_package;
      //                 $scope.coberturas_paquete.forEach(function(j) {
      //                   if($scope.caratula.subramo.subramo_name == 'Gastos Médicos'){
      //                     j.package = i.id;
      //                     j.sum_insured = j.sums_coverage[0].sum_insured;
      //                     j.deductible = j.deductible_coverage[0].deductible;
      //                   }
      //                   else{
      //                     j.package = i.id;
      //                     j.sum_insured = j.sums_coverage[0].sum_insured;
      //                     j.deductible = j.deductible_coverage[0].deductible;
      //                   }
      //                 });
      //               }
      //             });
      //           }

      //           // var inciso_start = new Date(toDate(item.INI_VIGENCIA))
      //           // var inciso_end = new Date(toDate(item.FIN_VIGENCIA))
      //           var inciso_start = toDate(convertDate(new Date((item.INI_VIGENCIA))))
      //           var inciso_end = toDate(convertDate(new Date((item.FIN_VIGENCIA))))

      //           var certData = {
      //             internalNumber: null,
      //             aseguradora: $scope.caratula.aseguradora.id,
      //             folio: null,
      //             caratula: $scope.caratula.id,
      //             certificate_number: parseInt(item.INCISO),
      //             parent: categoria_,
      //             poliza_number: $scope.caratula.poliza_number+' - INC. '+item.INCISO,
      //             natural: natural_,
      //             juridical: juridical_,
      //             ramo: $scope.caratula.ramo.id,
      //             subramo: $scope.caratula.subramo.id,
      //             paquete: item.PAQUETE,
      //             observations: '',
      //             old_policies: [],
      //             start_of_validity: inciso_start,
      //             end_of_validity: inciso_end,
      //             forma_de_pago: $scope.caratula.frecuencia_de_pago,
      //             status: status_,
      //             recibos_poliza: [],
      //             automobiles_policy: [],
      //             damages_policy:  data_danios,
      //             accidents_policy: [],
      //             life_policy: [],
      //             document_type: 6,
      //             address: address_, // checar este
      //             coverageInPolicy_policy: $scope.coberturas_paquete,
      //             endorsemeted: false,
      //             clave: $scope.caratula.clave.id,
      //             f_currency: $scope.f_currencyToSave,
      //             identifier: data_danios[0].insured_item + '-' + data_danios[0].item_addres,
      //             p_total: item.PRIMA_TOTAL,
      //             derecho: item.DERECHO ? item.DERECHO : 0,
      //             rpf: item.RPF ? item.RPF : 0,
      //             p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
      //             iva: item.IVA ? item.IVA : 0,
      //             contacto: item.CONTACTO
      //           };
      //           if ( item.PRIMA_NETA) {
      //             $scope.prima_neta = item.PRIMA_NETA
      //             certData.prima_neta  = $scope.prima_neta
      //           }else{
      //             $scope.prima_neta = 0
      //             certData.prima_neta  = $scope.prima_neta
      //           }
      //           if ( item.DERECHO) {
      //             $scope.derecho = item.DERECHO
      //             certData.derecho  = $scope.derecho
      //           }else{
      //             $scope.derecho = 0
      //             certData.derecho  = $scope.derecho
      //           }
      //           if ( item.RPF) {
      //             $scope.rpf = item.RPF
      //             certData.rpf  = $scope.rpf
      //           }else{
      //             $scope.rpf = 0
      //             certData.rpf  = $scope.rpf
      //           }
      //           if ( item.IVA) {
      //             $scope.iva = item.IVA
      //             certData.iva  = $scope.iva
      //           }else{
      //             $scope.iva = 0
      //             certData.iva  = $scope.iva
      //           }
      //           if (item.ANTIGUEDAD) {
      //             certData.rec_antiguedad = toDate(item.ANTIGUEDAD)
      //           }
      //           certificadosArray.push(certData)

      //       });

      //       return certificadosArray;

      //   } else {

      //       data.forEach(function(item) {
      //         var certificate = item.CERTIFICADO;
      //         if($scope.caratula.subramo.subramo_name == 'Vida') {

      //           if(item.TIPO == 2) {

      //             var dataBeneficiary = {
      //               certificate: certificate,
      //               first_name: item.NOMBRE,
      //               last_name: item.AP_PAT,
      //               second_last_name: item.AP_MAT,
      //               // birthdate: new Date(toDate(item.FEC_NAC)),
      //               birthdate: new Date(convertDate(item.FEC_NAC)),
      //               sex: item.SEXO,
      //               percentage: item.PORCENTAJE,
      //               optional_relationship: item.PARENTESCO,
      //               familia: item.CERT_GRAL
      //             };
      //             if (item.ANTIGUEDAD) {
      //               dataBeneficiary.antiguedad = toDate(item.ANTIGUEDAD)
      //             }

      //             beneficiaries_life.push(dataBeneficiary);
      //           }
      //         } else if ($scope.caratula.ramo.ramo_code == 2) { // Accidentes y enfermedades

      //           if(item.TIPO == 2) {
      //              var dataBeneficiary = {
      //               certificate: certificate,
      //               first_name: item.NOMBRE,
      //               last_name: item.AP_PAT,
      //               second_last_name: item.AP_MAT,
      //               relationship: item.PARENTESCO,
      //               birthdate: new Date(convertDate(item.FEC_NAC)),
      //               sex: item.SEXO,
      //               clause: item.INCISO,
      //               familia: item.CERT_GRAL
      //             };
      //             if (item.ANTIGUEDAD) {
      //               dataBeneficiary.antiguedad = toDate(item.ANTIGUEDAD)
      //             }

      //             beneficiaries_gm.push(dataBeneficiary);
      //             console.log('------dataBeneficiary-------',dataBeneficiary)
      //           }

      //         }
      //       });

      //       data.forEach( function(elem) {

      //         var certificate = elem.CERTIFICADO;
      //         if($scope.caratula.subramo.subramo_name == 'Vida') {

      //           if(elem.TIPO == 1) {

      //             if(elem.FUMADOR) {
      //               if(elem.FUMADOR == 0) {
      //                 var smoker = false;
      //               } else {
      //                 var smoker = true;
      //               }
      //             }

      //             var dataGM = [];
      //             var dataVida = [{
      //               personal: {
      //                 certificate: certificate,
      //                 first_name: elem.NOMBRE,
      //                 last_name: elem.AP_PAT,
      //                 second_last_name: elem.AP_MAT,
      //                 // birthdate: new Date(elem.FEC_NAC),
      //                 birthdate: new Date(convertDate(elem.FEC_NAC)),
      //                 antiguedad: elem.ANTIGUEDAD ? new Date(convertDate(elem.ANTIGUEDAD)) :  null,
      //                 sex: elem.SEXO,
      //                 email: elem.EMAIL,
      //                 salary: parseInt(elem.SUELDO),
      //                 sum_assured: parseInt(elem.SUELDO)
      //               },
      //               smoker: smoker,
      //               beneficiaries_life: []
      //             }];

      //             beneficiaries_life.forEach(function(i) {
      //               if(i.familia == elem.CERT_GRAL) {
      //                 dataVida[0].beneficiaries_life.push(i);
      //               }
      //             });
      //             // life_data.push(dataVida);
      //           }

      //         } else if ($scope.caratula.ramo.ramo_code == 2) {

      //           if(elem.TIPO == 1) {
      //             var dataVida = [];
      //             var dataGM = [{
      //               personal: {
      //                 certificate: certificate,
      //                 first_name: elem.NOMBRE,
      //                 last_name: elem.AP_PAT,
      //                 second_last_name: elem.AP_MAT,
      //                 // birthdate: new Date(toDate(elem.FEC_NAC)),
      //                 birthdate: new Date(convertDate(elem.FEC_NAC)),
      //                 antiguedad: elem.ANTIGUEDAD ? new Date(convertDate(elem.ANTIGUEDAD)) : null,
      //                 email: elem.EMAIL,
      //                 sex: elem.SEXO
      //               },
      //               disease_type: 0,
      //               relationship_accident: []
      //             }];

      //             beneficiaries_gm.forEach(function(i) {
      //               if(i.familia == elem.CERT_GRAL) {
      //                 dataGM[0].relationship_accident.push(i);
      //               }
      //             });
      //             // console.log('dataGM', dataGM);
      //             // gm_data.push(dataGM);
      //           }
      //         }
      //         if(elem.TIPO == 1) {

      //           if(elem.CATEGORIA) {
      //             var categoria_ = parseInt(elem.CATEGORIA);
      //           } else {
      //             var categoria_ = $scope.categoria_result.id;
      //           }

      //           if(!elem.CONTACTO){
      //             elem.CONTACTO = '';
      //           }

      //           if(elem.SUBGRUPO) {

      //             //// hacer for buscando coinicdencia con el id

      //             for(var i = 0; i < $scope.subgroups.length; i++) {

      //               var item = $scope.subgroups[i];

      //               if(item.id == parseInt(elem.SUBGRUPO)) {
      //                   // console.log('ok');
      //                   if(item.address) {
      //                     var address_ = item.address;
      //                     var natural_ = item.natural;
      //                     var juridical_ = item.juridical;

      //                   } else {

      //                     var address_ = null;
      //                     var natural_ = item.natural;
      //                     var juridical_ = item.juridical;

      //                   }
      //                 }
      //             }

      //           } else {

      //             // checar si tiene adress, si no, ponerle la de la caratula

      //             var address_ = $scope.caratula.address_;
      //             var natural_ = $scope.caratula.natural;
      //             var juridical_  = $scope.caratula.juridical;
      //           }

      //           if($scope.packages.length) {
      //             $scope.packages.forEach(function(i) {
      //               if(i.id == elem.PAQUETE) {
      //                 $scope.coberturas_paquete = i.coverage_package;
      //                 $scope.coberturas_paquete.forEach(function(j) {
      //                   if($scope.caratula.subramo.subramo_name == 'Gastos Médicos'){
      //                     j.package = i.id;
      //                     j.sum_insured = j.sums_coverage[0].sum_insured;
      //                     j.deductible = j.deductible_coverage[0].deductible;
      //                     j.coinsurance = j.coinsurance_coverage.length ? j.coinsurance_coverage[0].coinsurance : 0;
      //                   }
      //                   else{
      //                     j.package = i.id;
      //                     j.sum_insured = j.sums_coverage[0].sum_insured;
      //                     j.deductible = j.deductible_coverage[0].deductible;
      //                     j.coinsurance = 0;
      //                   }
      //                 });
      //               }
      //             });
      //           }

      //           // var inciso_start = new Date(toDate(elem.INI_VIGENCIA))
      //           // var inciso_end = new Date(toDate(elem.FIN_VIGENCIA))
      //           var inciso_start = toDate(convertDate(new Date((elem.INI_VIGENCIA))))
      //           var inciso_end = toDate(convertDate(new Date((elem.FIN_VIGENCIA))))

      //           var certData = {
      //             internalNumber: null,
      //             folio: null,
      //             caratula: $scope.caratula.id,
      //             aseguradora: $scope.caratula.aseguradora.id,
      //             certificate_number: parseInt(elem.CERTIFICADO),
      //             parent: categoria_,
      //             poliza_number: $scope.caratula.poliza_number+' - INC. '+elem.CERTIFICADO,
      //             natural: natural_,
      //             juridical: juridical_,
      //             ramo: $scope.caratula.ramo.id,
      //             subramo: $scope.caratula.subramo.id,
      //             paquete: elem.PAQUETE,
      //             observations: elem.OBSERVATIONS,
      //             old_policies: [],
      //             forma_de_pago: $scope.caratula.frecuencia_de_pago,
      //             status: par_status,
      //             recibos_poliza: [],
      //             automobiles_policy: [],
      //             damages_policy: [],
      //             accidents_policy: dataGM,
      //             life_policy: dataVida,
      //             document_type: 6,
      //             address: address_, // checar este
      //             // coverageInPolicy_policy: [], // checar si estas se agregan en el front o se agregarán en el back
      //             coverageInPolicy_policy: $scope.coberturas_paquete,
      //             endorsemeted: false,
      //             clave: $scope.caratula.clave.id,
      //             f_currency: $scope.f_currencyToSave,
      //             identifier: elem.IDENTIFICADOR,
      //             p_total: elem.PRIMA_TOTAL,
      //             p_neta: elem.PRIMA_NETA ? elem.PRIMA_NETA : 0,
      //             derecho: elem.derecho ? elem.derecho :0,
      //             rpf: elem.RPF ? elem.RPF : 0,
      //             iva: elem.IVA ? elem.IVA :0,
      //             start_of_validity: inciso_start,
      //             end_of_validity: inciso_end,
      //             contacto: elem.CONTACTO
      //           };
      //           if (elem.ANTIGUEDAD) {
      //             certData.rec_antiguedad = toDate(elem.ANTIGUEDAD)
      //           }

      //           life_data = [];

      //           certificadosArray.push(certData)
      //         }
      //       });

      //       return certificadosArray;
      //     }
      //   }
      // }
      for (var key in parData) {
        var data = parData[key];
        if (data.length) {
          if ($scope.caratula.subramo.subramo_code == 9) {
            // COCHES
            // console.log('FLOTILLAS');
            var autos_certs = [];

            data.forEach(function (item) {
              $scope.item_paquete = angular.copy(item.PAQUETE);

              if (item.USO) {
                if (item.USO >= "4" || item.USO <= "0") {
                  item.USO = "1";
                }
              } else {
                item.USO = "1";
              }

              if (!item.EMAIL) {
                item.EMAIL = "";
              }

              if (!item.CONTACTO) {
                item.CONTACTO = "";
              }
              if (item.BEN_PREFERENTE) {
                $scope.ben_p = item.BEN_PREFERENTE;
              } else {
                $scope.ben_p = "";
              }
              if (item.COMISION) {
                $scope.comision = item.COMISION;
              } else {
                $scope.comision = 0;
              }
              if (item.PRIMA_NETA) {
                $scope.p_neta = item.PRIMA_NETA;
              } else {
                $scope.p_neta = 0;
              }
              if (item.IVA) {
                $scope.iva = item.IVA;
              } else {
                $scope.iva = 0;
              }
              if (item.RPF) {
                $scope.rpf = item.RPF;
              } else {
                $scope.rpf = 0;
              }
              if (item.DERECHO) {
                $scope.derecho = item.DERECHO;
              } else {
                $scope.derecho = 0;
              }
              if (item.PRIMA_TOTAL) {
                $scope.p_total = item.PRIMA_TOTAL;
              } else {
                $scope.p_total = 0;
              }
              if (item.INCISO) {
                $scope.inciso = item.INCISO;
              } else {
                $scope.inciso = 0;
              }
              if (item.CONDUCTOR) {
                $scope.cndtr = item.CONDUCTOR;
              } else {
                $scope.cndtr = "";
              }

              var data_autos = [
                {
                  brand: item.MARCA,
                  model: item.MODELO,
                  driver: item.CONDUCTOR,
                  year: item.AÑO,
                  version: item.VERSION,
                  serial: item.SERIAL,
                  engine: item.MOTOR,
                  color: item.COLOR,
                  usage: item.USO,
                  license_plates: item.MATRICULA,
                  email: item.EMAIL,
                  preferential_benefiaciary: $scope.ben_p,
                  p_neta: item.p_neta,
                  derecho: item.derecho,
                  rpf: item.rpf,
                  iva: item.iva,
                  comision: $scope.comision,
                  document_type: 6,
                },
              ];

              // autos_certs.push(data_autos);

              if (item.CATEGORIA) {
                var categoria_ = parseInt(item.CATEGORIA);
              } else {
                var categoria_ = $scope.categoria_result.id;
              }

              if (item.SUBGRUPO) {
                //// hacer for buscando coinicdencia con el id
                if ($scope.order) {
                  for (var i = 0; i < $scope.order.subgroups.length; i++) {
                    var item = $scope.order.subgroups[i];

                    if (item.id == parseInt(item.SUBGRUPO)) {
                      // console.log('subgrupo');
                      if (item.address) {
                        var address_ = item.address;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      } else {
                        var address_ = $scope.caratula.address;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      }
                    }
                  }
                }
              } else {
                var address_ = $scope.caratula.address;
                var natural_ = $scope.caratula.natural;
                var juridical_ = $scope.caratula.juridical;
              }

              // if($scope.order.show.ot) {
              var status_ = 14;
              // } else {
              //   var status_ = 14;
              // }

              // coberturas del paquete.
              /*if($scope.config_saved.length) {
                  $scope.config_saved.forEach(function(i) {
                    if(i.id == item.PAQUETE) {
                      $scope.coberturas_paquete = i.coveragesConfig;
                      $scope.coberturas_paquete.forEach(function(j) {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = j.coinsurance_coverage[0].coinsurance;
                      });
                    }
                  });
                }*/

              if ($scope.packages.length) {
                $scope.packages.forEach(function (i) {
                  if (i.id == item.PAQUETE) {
                    $scope.coberturas_paquete = i.coverage_package;
                    $scope.coberturas_paquete.forEach(function (j) {
                      if (
                        $scope.caratula.subramo.subramo_name == "Gastos Médicos"
                      ) {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = j.coinsurance_coverage[0].coinsurance;
                      } else {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = 0;
                      }
                    });
                  }
                });
              }

              var inciso_start = new Date(toDate(item.INI_VIGENCIA));
              var inciso_end = new Date(toDate(item.FIN_VIGENCIA));
              var certData = {
                internalNumber: null,
                folio: null,
                caratula: $scope.caratula.id,
                certificate_number: parseInt($scope.inciso),
                aseguradora: $scope.dataToSave.aseguradora,
                parent: categoria_,
                poliza_number:
                  $scope.caratula.poliza_number + " - INC. " + $scope.inciso,
                natural: $scope.caratula.natural
                  ? $scope.caratula.natural.id
                  : null,
                juridical: $scope.caratula.juridical
                  ? $scope.caratula.juridical.id
                  : null,
                ramo: $scope.caratula.ramo.id,
                subramo: $scope.caratula.subramo.id,
                paquete: item.PAQUETE,
                observations: "",
                old_policies: [],
                start_of_validity: inciso_start,
                end_of_validity: inciso_end,
                forma_de_pago: $scope.caratula.frecuencia_de_pago,
                status: status_,
                recibos_poliza: [],
                automobiles_policy: data_autos,
                damages_policy: [],
                accidents_policy: [],
                life_policy: [],
                document_type: 6,
                address: address_, // checar este
                // coverageInPolicy_policy: [], // checar si estas se agregan en el front o se agregarán en el back
                coverageInPolicy_policy: $scope.coberturas_paquete,
                endorsemeted: false,
                clave: $scope.caratula.clave.id,
                f_currency: $scope.f_currencyToSave,
                identifier:
                  data_autos[0].brand +
                  "-" +
                  data_autos[0].model +
                  "-" +
                  data_autos[0].year,
                p_total: $scope.p_total ? $scope.p_total : 0,
                derecho: $scope.derecho ? $scope.derecho : 0,
                rpf: $scope.rpf ? $scope.rpf : 0,
                p_neta: $scope.p_neta ? $scope.p_neta : 0,
                iva: $scope.iva ? $scope.iva : 0,
                comision: $scope.comision ? $scope.comision : 0,
              };
              if (item.ANTIGUEDAD) {
                certData.rec_antiguedad = toDate(item.ANTIGUEDAD);
              } else {
                certData.rec_antiguedad = null;

                certData = certData;
              }
              certificadosArray.push(certData);
            });

            return certificadosArray;
          } else if (
            $scope.caratula.ramo.ramo_code == 3 &&
            $scope.caratula.subramo.subramo_code != 9
          ) {
            // DAÑOS
            var danios_certs = [];

            data.forEach(function (item) {
              if (!item.CONTACTO) {
                item.CONTACTO = "";
              }

              if (item.PAQUETE) {
                item.PAQUETE = item.PAQUETE;
              }

              if (item.PRIMA_NETA) {
                $scope.prima_neta = item.PRIMA_NETA;
              } else {
                $scope.prima_neta = 0;
              }
              if (item.DERECHO) {
                $scope.derecho = item.DERECHO;
              } else {
                $scope.derecho = 0;
              }
              if (item.RPF) {
                $scope.rpf = item.RPF;
              } else {
                $scope.rpf = 0;
              }
              if (item.IVA) {
                $scope.iva = item.IVA;
              } else {
                $scope.iva = 0;
              }
              var data_danios = [
                {
                  insured_item: item.NOMBRE,
                  item_address:
                    item.CALLE +
                    " #" +
                    " " +
                    item.COLONIA +
                    " " +
                    item.DELEGACION +
                    " " +
                    item.CIUDAD +
                    " " +
                    item.ESTADO +
                    " C.P." +
                    item.CP,
                  document_type: 6,
                  p_neta: $scope.prima_neta,
                  derecho: $scope.derecho,
                  rpf: $scope.rpf,
                  iva: $scope.iva,
                },
              ];

              danios_certs.push(data_danios);

              if (item.CATEGORIA) {
                var categoria_ = parseInt(item.CATEGORIA);
              } else {
                var categoria_ = $scope.categoria_result.id;
              }

              if (item.SUBGRUPO) {
                if ($scope.order) {
                  for (var i = 0; i < $scope.order.subgroups.length; i++) {
                    var item = $scope.order.subgroups[i];

                    if (item.id == parseInt(item.SUBGRUPO)) {
                      // console.log('subgrupo');
                      if (item.address) {
                        var address_ = item.address;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      } else {
                        var address_ = $scope.caratula.address;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      }
                    }
                  }
                }
              } else {
                var address_ = $scope.caratula.address;
                var natural_ = $scope.caratula.natural;
                var juridical_ = $scope.caratula.juridical;
              }

              if ($scope.caratula.status == "En trámite") {
                var status_ = 1;
              } else {
                var status_ = 14;
              }

              if ($scope.caratula.f_currency == "PESOS") {
                var f_currency_ = 1;
              } else if ($scope.caratula.f_currency == "DOLARES") {
                var f_currency_ = 2;
              } else if ($scope.caratula.f_currency == "UDI") {
                var f_currency_ = 3;
              } else if ($scope.caratula.f_currency == "EURO") {
                var f_currency_ = 4;
              }

              var status_ = 14;

              if ($scope.packages.length) {
                $scope.packages.forEach(function (i) {
                  if (i.id == item.PAQUETE) {
                    $scope.coberturas_paquete = i.coverage_package;
                    $scope.coberturas_paquete.forEach(function (j) {
                      if (
                        $scope.caratula.subramo.subramo_name == "Gastos Médicos"
                      ) {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = j.coinsurance_coverage[0].coinsurance;
                      } else {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = 0;
                      }
                    });
                  }
                });
              }

              // var inciso_start = new Date(toDate(item.INI_VIGENCIA))
              // var inciso_end = new Date(toDate(item.FIN_VIGENCIA))
              var inciso_start = toDate(item.INI_VIGENCIA);
              var inciso_end = toDate(item.FIN_VIGENCIA);

              var certData = {
                internalNumber: null,
                aseguradora: $scope.caratula.aseguradora.id,
                folio: null,
                caratula: $scope.caratula.id,
                certificate_number: parseInt(item.INCISO),
                parent: categoria_,
                poliza_number:
                  $scope.caratula.poliza_number + " - INC. " + item.INCISO,
                natural: natural_,
                juridical: juridical_,
                ramo: $scope.caratula.ramo.id,
                subramo: $scope.caratula.subramo.id,
                paquete: item.PAQUETE,
                observations: "",
                old_policies: [],
                start_of_validity: inciso_start,
                end_of_validity: inciso_end,
                forma_de_pago: $scope.caratula.frecuencia_de_pago,
                status: status_,
                recibos_poliza: [],
                automobiles_policy: [],
                damages_policy: data_danios,
                accidents_policy: [],
                life_policy: [],
                document_type: 6,
                address: address_, // checar este
                coverageInPolicy_policy: $scope.coberturas_paquete,
                endorsemeted: false,
                clave: $scope.caratula.clave.id,
                f_currency: f_currency_,
                identifier:
                  data_danios[0].insured_item +
                  "-" +
                  data_danios[0].item_addres,
                p_total: item.PRIMA_TOTAL,
                derecho: item.DERECHO ? item.DERECHO : 0,
                rpf: item.RPF ? item.RPF : 0,
                p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                iva: item.IVA ? item.IVA : 0,
                contacto: item.CONTACTO,
              };
              if (item.PRIMA_NETA) {
                $scope.prima_neta = item.PRIMA_NETA;
                certData.prima_neta = $scope.prima_neta;
              } else {
                $scope.prima_neta = 0;
                certData.prima_neta = $scope.prima_neta;
              }
              if (item.DERECHO) {
                $scope.derecho = item.DERECHO;
                certData.derecho = $scope.derecho;
              } else {
                $scope.derecho = 0;
                certData.derecho = $scope.derecho;
              }
              if (item.RPF) {
                $scope.rpf = item.RPF;
                certData.rpf = $scope.rpf;
              } else {
                $scope.rpf = 0;
                certData.rpf = $scope.rpf;
              }
              if (item.IVA) {
                $scope.iva = item.IVA;
                certData.iva = $scope.iva;
              } else {
                $scope.iva = 0;
                certData.iva = $scope.iva;
              }
              if (item.ANTIGUEDAD) {
                certData.rec_antiguedad = toDate(item.ANTIGUEDAD);
              }
              certificadosArray.push(certData);
            });
            console.log("------", certificadosArray);
            return certificadosArray;
          } else {
            // se separan los beneficiarios
            data.forEach(function (item) {
              // TODO: Checar el tipo de
              var certificate = item.CERTIFICADO;
              if ($scope.caratula.subramo.subramo_name == "Vida") {
                if (item.TIPO == 2) {
                  var dataBeneficiary = {
                    certificate: certificate,
                    first_name: item.NOMBRE,
                    last_name: item.AP_PAT,
                    second_last_name: item.AP_MAT,
                    birthdate: toDate(item.FEC_NAC),
                    antiguedad: item.ANTIGUEDAD
                      ? toDate(item.ANTIGUEDAD)
                      : null,
                    sex: item.SEXO,
                    percentage: item.PORCENTAJE,
                    optional_relationship: item.PARENTESCO,
                  };

                  beneficiaries_life.push(dataBeneficiary);
                }
              } else if ($scope.caratula.ramo.ramo_code == 2) {
                // Accidentes y enfermedades

                if (item.PRIMA_NETA) {
                  $scope.p_neta = item.PRIMA_NETA;
                } else {
                  $scope.p_neta = 0;
                }

                if (item.COMISION) {
                  $scope.comision = item.COMISION;
                } else {
                  $scope.comision = 0;
                }
                if (item.IVA) {
                  $scope.iva = item.IVA;
                } else {
                  $scope.iva = 0;
                }
                if (item.RPF) {
                  $scope.rpf = item.RPF;
                } else {
                  $scope.rpf = 0;
                }
                if (item.DERECHO) {
                  $scope.derecho = item.DERECHO;
                } else {
                  $scope.derecho = 0;
                }
                if (item.PRIMA_TOTAL) {
                  $scope.p_total = item.PRIMA_TOTAL;
                } else {
                  $scope.p_total = 0;
                }
                if (item.CERTIFICADO) {
                  $scope.certificate = item.CERTIFICADO;
                } else {
                  $scope.certificate = 0;
                }
                if (item.TIPO == 2) {
                  var dataBeneficiary = {
                    certificate: certificate,
                    first_name: item.NOMBRE,
                    last_name: item.AP_PAT,
                    second_last_name: item.AP_MAT,
                    birthdate: toDate(item.FEC_NAC),
                    antiguedad: item.ANTIGUEDAD
                      ? toDate(item.ANTIGUEDAD)
                      : null,
                    sex: item.SEXO,
                    clause: item.INCISO,
                    relationship: item.PARENTESCO,
                  };

                  beneficiaries_gm.push(dataBeneficiary);
                }
              }
            });

            data.forEach(function (elem) {
              var certificate = elem.CERTIFICADO;
              if ($scope.caratula.subramo.subramo_name == "Vida") {
                if (elem.PRIMA_NETA) {
                  $scope.p_neta = elem.PRIMA_NETA;
                } else {
                  $scope.p_neta = 0;
                }

                if (elem.COMISION) {
                  $scope.comision = elem.COMISION;
                } else {
                  $scope.comision = 0;
                }
                if (elem.IVA) {
                  $scope.iva = elem.IVA;
                } else {
                  $scope.iva = 0;
                }
                if (elem.RPF) {
                  $scope.rpf = elem.RPF;
                } else {
                  $scope.rpf = 0;
                }
                if (elem.DERECHO) {
                  $scope.derecho = elem.DERECHO;
                } else {
                  $scope.derecho = 0;
                }
                if (elem.PRIMA_TOTAL) {
                  $scope.p_total = elem.PRIMA_TOTAL;
                } else {
                  $scope.p_total = 0;
                }
                if (elem.CERTIFICADO) {
                  $scope.certificate = elem.CERTIFICADO;
                } else {
                  $scope.certificate = 0;
                }
                if (elem.TIPO == 1) {
                  if (elem.FUMADOR) {
                    if (elem.FUMADOR == 0) {
                      var smoker = false;
                    } else {
                      var smoker = true;
                    }
                  }

                  var dataGM = [];
                  var dataVida = [
                    {
                      personal: {
                        certificate: certificate,
                        first_name: elem.NOMBRE,
                        last_name: elem.AP_PAT,
                        second_last_name: elem.AP_MAT,
                        birthdate: toDate(elem.FEC_NAC),
                        antiguedad: elem.ANTIGUEDAD
                          ? toDate(elem.ANTIGUEDAD)
                          : null,
                        sex: elem.SEXO,
                        email: elem.EMAIL,
                        salary: parseInt(elem.SUELDO),
                        sum_assured: elem.SUMA_ASEGURADA
                          ? parseInt(elem.SUMA_ASEGURADA)
                          : 0,
                      },
                      smoker: smoker,
                      beneficiaries_life: [],
                    },
                  ];

                  beneficiaries_life.forEach(function (i) {
                    if (i.certificate == elem.CERTIFICADO) {
                      dataVida[0].beneficiaries_life.push(i);
                    }
                  });
                  // life_data.push(dataVida);
                }
              } else if ($scope.caratula.ramo.ramo_code == 2) {
                if (elem.PRIMA_NETA) {
                  $scope.p_neta = elem.PRIMA_NETA;
                } else {
                  $scope.p_neta = 0;
                }

                if (elem.COMISION) {
                  $scope.comision = elem.COMISION;
                } else {
                  $scope.comision = 0;
                }
                if (elem.IVA) {
                  $scope.iva = elem.IVA;
                } else {
                  $scope.iva = 0;
                }
                if (elem.RPF) {
                  $scope.rpf = elem.RPF;
                } else {
                  $scope.rpf = 0;
                }
                if (elem.DERECHO) {
                  $scope.derecho = elem.DERECHO;
                } else {
                  $scope.derecho = 0;
                }
                if (elem.PRIMA_TOTAL) {
                  $scope.p_total = elem.PRIMA_TOTAL;
                } else {
                  $scope.p_total = 0;
                }
                if (elem.CERTIFICADO) {
                  $scope.certificate = elem.CERTIFICADO;
                } else {
                  $scope.certificate = 0;
                }
                if (elem.TIPO == 1) {
                  var dataVida = [];
                  var dataGM = [
                    {
                      personal: {
                        certificate: certificate,
                        first_name: elem.NOMBRE,
                        last_name: elem.AP_PAT,
                        second_last_name: elem.AP_MAT,
                        birthdate: toDate(elem.FEC_NAC),
                        antiguedad: elem.ANTIGUEDAD
                          ? toDate(elem.ANTIGUEDAD)
                          : null,
                        email: elem.EMAIL,
                        sex: elem.SEXO,
                      },
                      disease_type: 0,
                      relationship_accident: [],
                    },
                  ];

                  beneficiaries_gm.forEach(function (i) {
                    if (i.certificate == elem.CERTIFICADO) {
                      dataGM[0].relationship_accident.push(i);
                    }
                  });
                  // console.log('dataGM', dataGM);
                  // gm_data.push(dataGM);
                }
              }
              if (elem.TIPO == 1) {
                if (elem.CATEGORIA) {
                  var categoria_ = parseInt(elem.CATEGORIA);
                } else {
                  var categoria_ = $scope.categoria_result.id;
                }

                if (elem.SUBGRUPO) {
                  //// hacer for buscando coinicdencia con el id

                  for (var i = 0; i < $scope.subgroups.length; i++) {
                    var item = $scope.subgroups[i];

                    if (item.id == parseInt(elem.SUBGRUPO)) {
                      // console.log('ok');
                      if (item.address) {
                        var address_ = item.address;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      } else {
                        var address_ = null;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      }
                    }
                  }
                } else {
                  // checar si tiene adress, si no, ponerle la de la caratula

                  var address_ = $scope.caratula.address_;
                  var natural_ = $scope.caratula.natural;
                  var juridical_ = $scope.caratula.juridical;
                }

                if ($scope.packages.length) {
                  $scope.packages.forEach(function (i) {
                    if (i.id == elem.PAQUETE) {
                      $scope.coberturas_paquete = i.coverage_package;
                      $scope.coberturas_paquete.forEach(function (j) {
                        if (
                          $scope.caratula.subramo.subramo_name ==
                          "Gastos Médicos"
                        ) {
                          j.package = i.id;
                          j.sum_insured = j.sums_coverage[0].sum_insured;
                          j.deductible = j.deductible_coverage[0].deductible;
                          j.coinsurance = j.coinsurance_coverage[0].coinsurance;
                        } else {
                          j.package = i.id;
                          j.sum_insured = j.sums_coverage[0].sum_insured;
                          j.deductible = j.deductible_coverage[0].deductible;
                          j.coinsurance = 0;
                        }
                      });
                    }
                  });
                }

                var inciso_start = toDate(elem.INI_VIGENCIA);
                var inciso_end = toDate(elem.FIN_VIGENCIA);
                var certData = {
                  internalNumber: null,
                  folio: null,
                  caratula: $scope.caratula.id,
                  aseguradora: $scope.dataToSave.aseguradora,
                  certificate_number: parseInt($scope.certificate),
                  parent: categoria_,
                  poliza_number:
                    $scope.caratula.poliza_number +
                    " - INC. " +
                    $scope.certificate,
                  natural: $scope.caratula.natural
                    ? $scope.caratula.natural.id
                    : null,
                  juridical: $scope.caratula.juridical
                    ? $scope.caratula.juridical.id
                    : null,
                  ramo: $scope.caratula.ramo.id,
                  subramo: $scope.caratula.subramo.id,
                  paquete: elem.PAQUETE,
                  observations: elem.OBSERVATIONS,
                  old_policies: [],
                  start_of_validity: inciso_start,
                  end_of_validity: inciso_end,
                  forma_de_pago: $scope.caratula.frecuencia_de_pago,
                  status: par_status,
                  recibos_poliza: [],
                  automobiles_policy: [],
                  damages_policy: [],
                  accidents_policy: dataGM,
                  life_policy: dataVida,
                  document_type: 6,
                  address: address_, // checar este
                  // coverageInPolicy_policy: [], // checar si estas se agregan en el front o se agregarán en el back
                  coverageInPolicy_policy: $scope.coberturas_paquete,
                  endorsemeted: false,
                  clave: $scope.caratula.clave.id,
                  f_currency: $scope.f_currencyToSave,
                  identifier: elem.IDENTIFICADOR,
                  p_total: $scope.p_total ? $scope.p_total : 0,
                  derecho: $scope.derecho ? $scope.derecho : 0,
                  rpf: $scope.rpf ? $scope.rpf : 0,
                  p_neta: $scope.p_neta ? $scope.p_neta : 0,
                  iva: $scope.iva ? $scope.iva : 0,
                  comision: $scope.comision ? $scope.comision : 0,
                };

                life_data = [];
                if (elem.ANTIGUEDAD) {
                  certData.rec_antiguedad = toDate(elem.ANTIGUEDAD);
                } else {
                  certData.rec_antiguedad = null;

                  certData = certData;
                }
                certificadosArray.push(certData);
              }
            });

            return certificadosArray;
          }
        }
      }
    }

    function treeStructure(parData) {
      var tree = [];
      for (var key in parData) {
        var data = parData[key];
        if (data.length) {
          var parents = [];
          var childs = [];

          if (order.form.subramo.subramo_code == 9) {
            data.forEach(function (car) {
              var parent_content =
                car.INCISO +
                " - " +
                car.MARCA +
                " - " +
                car.MODELO +
                " - " +
                car.AÑO +
                " - " +
                car.VERSION +
                " - " +
                car.SERIAL;

              var element = {
                text: parent_content,
              };

              tree.push(element);
            });
          } else if (
            order.form.ramo.ramo_code == 3 &&
            order.form.subramo.subramo_code != 9
          ) {
            data.forEach(function (item) {
              var parent_content =
                item.NOMBRE +
                " - " +
                item.CALLE +
                " #" +
                item.NUMERO +
                " " +
                item.COLONIA +
                " " +
                item.DELEGACION +
                " " +
                item.CIUDAD +
                " " +
                item.ESTADO +
                " C.P." +
                item.CP;

              var element = {
                text: parent_content,
              };

              if (item.INCISO) {
                tree.push(element);
              }
            });
          } else {
            data.forEach(function (child) {
              if (child.TIPO == 2) {
                childs.push(child);
              }
            });

            data.forEach(function (parent) {
              if (parent.TIPO == 1) {
                var nodes = [];
                childs.forEach(function (item) {
                  if (item.CERTIFICADO == parent.CERTIFICADO) {
                    var full_name =
                      item.NOMBRE +
                      " " +
                      item.AP_PAT +
                      " " +
                      (item.AP_MAT ? item.AP_MAT : "");

                    var content =
                      item.INCISO + " - " + full_name + " - " + item.FEC_NAC;

                    nodes.push({
                      text: content,
                    });
                  }
                });

                var parent_content =
                  parent.CERTIFICADO +
                  " - " +
                  parent.NOMBRE +
                  " " +
                  parent.AP_PAT +
                  " " +
                  (parent.AP_MAT ? parent.AP_MAT : "") +
                  " - " +
                  parent.FEC_NAC;

                var element = {
                  text: parent_content,
                  nodes: nodes,
                };

                tree.push(element);
              }
            });
          }

          $("#tree").treeview({ data: tree });
        }
      }
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    $scope.goToEndorsement = function () {
      $scope.caratula.doEndorsement = true;
      var params = {
        myInsurance: $scope.caratula,
        contractor: $scope.contractorModal,
      };
      $state.go("endorsement.collectivity", params);
    };

    $scope.goToSiniesterCaratula = function () {
      $scope.caratula.doSinisterCaratula = true;
      var params = {
        myInsurance: $scope.caratula,
        contractor: $scope.contractorModal,
      };

      switch ($scope.caratula.ramo.ramo_code) {
        case 1:
          $state.go("siniestros.create_vida", params);
          break;
        case 2:
          $state.go("siniestros.accidentes", params);
          break;
        case 3:
          $state.go("siniestros.create_autos", params);
          break;
        default:
          break;
      }
    };

    function updateChilds() {
      $scope.subgroups = [];
      $scope.categories = [];
      $scope.certificados = [];

      $http({
        method: "GET",
        url: url.IP + "caratula-childs/" + $stateParams.polizaId + "/",
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              var results = request.data;
              results.forEach(function (child) {
                if (child.document_type == 4) {
                  $scope.subgroups.push(child);
                  child.categories = [];
                } else if (child.document_type == 5) {
                  $scope.categories.push(child);
                  child.certs = [];
                } else if (child.document_type == 6) {
                  $scope.certificados.push(child);
                }
              });

              $scope.categories.forEach(function (category) {
                $scope.certificados.forEach(function (cert) {
                  if (category.url == cert.parent) {
                    category.certs.push(cert);
                  }
                });
                if (category.certs.length) {
                  category.certsEmpty = false;
                } else {
                  category.certsEmpty = true;
                }
              });

              $scope.subgroups.forEach(function (group) {
                $scope.categories.forEach(function (category) {
                  if (group.url == category.parent) {
                    group.categories.push(category);
                  }
                });
              });

              if (!request.data.length) {
                $scope.coverIncomplete = true;
              }

              if ($scope.subgroups.length == 1) {
                if ($scope.subgroups[0].categories.length == 1) {
                  var cat_ = $scope.subgroups[0].categories[0];
                  $scope.selectCategory(cat_);
                }
              }
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }

    function PolicyModalCtrl(
      $scope,
      contractorModal,
      $uibModalInstance,
      urlInsurance,
      receipts,
      caratula,
      usr
    ) {
      $scope.buttonDisabled = true;
      $scope.caratula = caratula;
      $scope.user = usr;

      if ($scope.caratula.poliza_number) {
        $scope.optionsCancel = [
          { value: 1, label: "Cancelación Tipo D" },
          { value: 2, label: "Precancelación" },
          { value: 3, label: "Cancelación definitiva" },
        ];
      } else {
        $scope.optionsCancel = [{ value: 2, label: "Precancelación" }];
      }
      $scope.cancelPolicy = function (option, reason) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (option.value == 1) {
          var params = {
            myInsurance: $scope.caratula,
            contractor: contractorModal,
          };
          $state.go("endorsement.collectivity", params);
          $uibModalInstance.dismiss("cancel");
        } else if (option.value == 2) {
          var user_cancel = $scope.user.nameFull;
          $scope.notas_cancel = [];
          $http
            .patch(urlInsurance, { status: 4, reason_cancel: reason })
            .then(function (data) {
              $scope.caratula.status = data.data.status;
              $scope.caratula.reason_cancel = data.data.reason_cancel;
              $http
                .post(url.IP + "cancel-policy-manual/", {
                  id: $scope.caratula.id,
                  user_cancel: user_cancel,
                })
                .then(
                  function success(request) {
                    $uibModalInstance.dismiss("cancel");
                    if (request.status === 200 || request.status === 201) {
                      receipts.forEach(function (child) {
                        if (child.status == 4) {
                          var params = {
                            model: 4,
                            event: "PATCH",
                            associated_id: child.id,
                            identifier:
                              " actualizo el recibo a Precancelado por Cancelación de colectividad ",
                          };
                          dataFactory
                            .post("send-log/", params)
                            .then(function success(response) {
                              // console.log('-------4 canc colec-----',response)
                            });
                          $http
                            .patch(child.url, { status: 8 })
                            .then(function (data_receipt) {});
                        }
                      });
                      swal(
                        "¡Listo!",
                        "Se ha enviado un correo al administrador",
                        "success"
                      );
                      var params = {
                        model: 18,
                        event: "POST",
                        associated_id: $scope.caratula.id,
                        identifier: $scope.caratula.poliza_number
                          ? "precanceló la póliza."
                          : "precanceló la OT.",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                      l.stop();
                    } else {
                      swal(
                        "Error",
                        "No se envió la póliza. Contacte a su administrador.",
                        "error"
                      );
                      l.stop();
                    }
                  },
                  function error(error) {
                    console.log("error - email", error);
                  }
                )
                .catch(function (e) {
                  console.log("error - catch", e);
                });
            });
        } else if (option.value == 3) {
          $http
            .patch(urlInsurance, { status: 11, reason_cancel: reason })
            .then(function (data) {
              $scope.caratula.status = data.data.status;
              receipts.forEach(function (child) {
                if (child.status == 4 || child.status == 3) {
                  var params = {
                    model: 4,
                    event: "PATCH",
                    associated_id: child.id,
                    identifier:
                      " actualizo el recibo a cancelado por Cancelación de colectividad ",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {
                      // console.log('-------4 canc colec rec canc-----',response)
                    });
                  $http.patch(child.url, { status: 2 });
                }
              });
              var params = {
                model: 18,
                event: "POST",
                associated_id: $scope.caratula.id,
                identifier: $scope.caratula.poliza_number
                  ? "canceló la póliza."
                  : "canceló la OT.",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              l.stop();
              $uibModalInstance.dismiss("cancel");
              swal(
                "Hecho",
                "Se ha cancelado definitivamente la póliza",
                "success"
              );
            });
        }
      };

      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.cancelPolicy = function (id) {
      // dataFactory.get('has-cancel-policy-permission')
      // .then(function success(response) {
      //   if(response.data){
      if (
        $scope.caratula.status == 4 ||
        $scope.caratula.status == 1 ||
        $scope.caratula.status == 2
      ) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: $scope.caratula.poliza_number
              ? "La póliza " +
                $scope.caratula.poliza_number +
                " quedara cancelada"
              : "Se cancelará la OT",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              if ($scope.caratula.status == 4) {
                var data = {
                  status: 11,
                };
              } else {
                var data = {
                  status: 2,
                };
              }
              $http
                .patch($scope.caratula.url, data)
                .then(function success(response) {
                  if (response.status === 200 || request.status === 201) {
                    SweetAlert.swal(
                      "Hecho",
                      MESSAGES.OK.POLICYCANCELED,
                      "success"
                    );
                    $state.go("colectividades.info", {
                      polizaId: $scope.caratula.id,
                    });
                    $scope.notas_cancel = [];
                    if ($scope.notas_c) {
                      $scope.notas_c.forEach(function notas(no) {
                        if (no.policy.id == $scope.caratula.id) {
                          if (no.status == 1) {
                            no.status = 4;
                            $scope.notas_cancel.push(no);
                            var params = {
                              model: 4,
                              event: "PATCH",
                              associated_id: no.id,
                              identifier:
                                " actualizo recibo a Pendiente de pago por Cancelación de colectividad ",
                            };
                            dataFactory
                              .post("send-log/", params)
                              .then(function success(response) {
                                // console.log('-------4 pend pago nota by canc-----',response)
                              });
                            $http
                              .patch(no.url, { status: 4 })
                              .then(function success(response) {
                                if (
                                  response.status == 200 ||
                                  response.status == 201
                                ) {
                                }
                              });
                          }
                        }
                      });
                    }
                    $scope.caratula.recibos_poliza.forEach(function (recibo) {
                      if (
                        recibo.status != 1 &&
                        recibo.status != 5 &&
                        recibo.status != 6
                      ) {
                        var params = {
                          model: 4,
                          event: "PATCH",
                          associated_id: recibo.id,
                          identifier:
                            " actualizo el recibo a cancelado por Cancelación de colectividad ",
                        };
                        dataFactory
                          .post("send-log/", params)
                          .then(function success(response) {
                            // console.log('-------4 canc colec canc rec-----',response)
                          });
                        $http.patch(recibo.url, { status: 2 });
                      }
                    });
                    var params = {
                      model: 18,
                      event: "POST",
                      associated_id: $scope.caratula.id,
                      identifier: $scope.caratula.poliza_number
                        ? "canceló la póliza."
                        : "canceló la OT.",
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                  }
                });
            } else {
              SweetAlert.swal("Cancelado", MESSAGES.OK.CANCELEDCANCEL, "error");
            }
          }
        );
      } else {
        var modalInstance = $uibModal.open({
          templateUrl: "app/polizas/poliza.modal.html",
          controller: PolicyModalCtrl,
          controllerAs: "vmm",
          size: "md",
          resolve: {
            contractorModal: function () {
              return $scope.contratante;
            },
            urlInsurance: function () {
              return $scope.caratula.url;
            },
            receipts: function () {
              return $scope.caratula.recibos_poliza;
            },
            caratula: function () {
              return $scope.caratula;
            },
            usr: function () {
              return $scope.user;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        modalInstance.result.then(function (receipt) {
          $state.go("colectividades.info", { polizaId: myInsurance.id });
        });
      }
      // } else {
      //   SweetAlert.swal("Error", "No tienes permiso para realizar esta acción", "error");
      // }
      // })
    };
    $scope.reactivePolicy = function (id) {
      // dataFactory.get('has-cancel-policy-permission')
      // .then(function success(response) {
      //   if(response.data){
      if (
        $scope.caratula.status == 4 ||
        $scope.caratula.status == "Precancelada"
      ) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: $scope.caratula.poliza_number
              ? "La carátula " +
                $scope.caratula.poliza_number +
                " quedará en Estatus Vigente"
              : "Se recativará la OT En Trámite",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              if (
                $scope.caratula.status == 4 ||
                $scope.caratula.status == "Precancelada"
              ) {
                var data = {
                  status: 14,
                };
              } else {
                var data = {
                  status: 1,
                };
              }
              $http
                .patch($scope.caratula.url, data)
                .then(function success(response) {
                  if (
                    response.status == 200 &&
                    ($scope.caratula.status == 4 ||
                      $scope.caratula.status == "Precancelada")
                  ) {
                    $scope.caratula.recibos_poliza.forEach(function (recibo) {
                      if (recibo.status == 8) {
                        var params = {
                          model: 4,
                          event: "PATCH",
                          associated_id: recibo.id,
                          identifier:
                            " actualizo el recibo de Precancelado a Pendiente pago por Reactivación de colectividad ",
                        };
                        dataFactory
                          .post("send-log/", params)
                          .then(function success(response) {
                            console.log("-------4 react colec-----", response);
                          });
                        $http.patch(recibo.url, { status: 4 });
                      }
                    });
                    var params = {
                      model: 18,
                      event: "POST",
                      associated_id: $scope.caratula.id,
                      identifier: $scope.caratula.poliza_number
                        ? "reactivo la carátula"
                        : "reactivo la OT.",
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                  }
                  SweetAlert.swal(
                    "Hecho",
                    MESSAGES.OK.POLICYREACTIVED,
                    "success"
                  );
                  $scope.caratula.status = response.data.status;
                });
            } else {
              SweetAlert.swal(
                "Reactivación",
                MESSAGES.OK.CANCELEDCANCEL,
                "error"
              );
            }
          }
        );
      } else {
        var modalInstance = $uibModal.open({
          templateUrl: "app/polizas/poliza.modal.html",
          controller: PolicyModalCtrl,
          controllerAs: "vmm",
          size: "md",
          resolve: {
            contractorModal: function () {
              return $scope.contratante;
            },
            urlInsurance: function () {
              return $scope.caratula.url;
            },
            receipts: function () {
              return $scope.receipts;
            },
            caratula: function () {
              return $scope.caratula;
            },
            usr: function () {
              return $scope.user;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        modalInstance.result.then(function (receipt) {
          $state.go("colectividades.info", { polizaId: $scope.caratula.id });
        });
      }
      //     } else {
      //       SweetAlert.swal("Error", "No tienes permiso para realizar esta acción", "error");
      //     }
      // })
    };

    function toDate(dateStr) {
      if (dateStr) {
        var dateString = dateStr; // Oct 23
        // console.log(dateStr)
        var dateParts = dateString.split("/");
        var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
        return dateObject;
      }
    }

    // Upload files
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    uploader.filters.push({
      name: "customFilter",
      fn: function (item /*{File|FileLikeObject}*/, options) {
        //jshint ignore:line
        return this.queue.length < 20;
      },
    });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      // $scope.showFiles($scope.num_section, $scope.element.id, $scope.element);
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      // console.log('fileItem',fileItem);
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      fileItem.removeAfterUpload = true;
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      // console.log('before');
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
        $scope.returnToCerts();
      }, 1000);
    }

    $scope.demo = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    $scope.show_section = function (value) {
      switch (value) {
        case 1:
          $scope.show_caratula = true;
          $scope.show_subgrupo = false;
          $scope.show_paquete = false;
          $scope.show_certificado = false;
          break;
        case 2:
          $scope.show_caratula = false;
          $scope.show_subgrupo = true;
          $scope.show_paquete = false;
          $scope.show_certificado = false;
          break;
        case 3:
          $scope.show_caratula = false;
          $scope.show_subgrupo = false;
          $scope.show_paquete = true;
          $scope.show_certificado = false;
          break;
        case 4:
          $scope.show_caratula = false;
          $scope.show_subgrupo = false;
          $scope.show_paquete = false;
          $scope.show_certificado = true;
          break;
        default:
          $scope.show_caratula = true;
          $scope.show_subgrupo = false;
          $scope.show_paquete = false;
          $scope.show_certificado = false;
      }
    };

    function assignModalView(
      $scope,
      $uibModalInstance,
      policy_id,
      url,
      contratante
    ) {
      $http.get(url.IP + "polizas/" + policy_id).then(function (dataCer) {
        if (dataCer.data.automobiles_policy.length > 0) {
          if (dataCer.data.automobiles_policy[0].email) {
            $scope.email = dataCer.data.automobiles_policy[0].email;
          } else if (contratante) {
            $scope.email = contratante.email;
          }
        } else if (dataCer.data.accidents_policy.length > 0) {
          $http
            .get(dataCer.data.accidents_policy[0].personal)
            .then(function (dataPersonal) {
              if (dataPersonal.data.email) {
                $scope.email = dataPersonal.data.email;
              } else if (contratante) {
                $scope.email = contratante.email;
              }
            });
        } else if (dataCer.data.life_policy.length > 0) {
          if (dataCer.data.life_policy[0].personal.email) {
            $scope.email = dataCer.data.life_policy[0].personal.email;
          } else if (contratante) {
            $scope.email = contratante.email;
          }
        }
      });
      $http
        .get(url.IP + "polizas/" + policy_id + "/archivos/")
        .then(function (response) {
          $scope.files = response.data.results;
          $scope.files.forEach(function (archivo, index) {
            $scope.files[index]["origin"] = "P";
          });
        });
      $http
        .post(url.IP + "get-assign/", { poliza: policy_id })
        .then(
          function success(response) {
            $scope.people_assigned = response.data;
            $scope.owner_exist = true;
            $scope.people_assigned.some(function (people) {
              if (people.is_owner == true) {
                $scope.owner_exist = false;
                return;
              }
            });
          },
          function error(err) {}
        )
        .catch(function (e) {});

      $scope.emails = [];
      $scope.showEmailInInput = function (email) {
        if (email) {
          $scope.email_assign = email;
        } else {
          $scope.email_assign = contratante.email;
        }
      };

      $scope.addEmail = function (email) {
        if (validateEmail(email) == false) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        } else {
          $scope.emails.push(email);
          $scope.email_assign = "";
        }
      };

      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      $scope.sendEmail = function (receipt) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $http
          .post(url.IP + "share-policy-manual/", {
            id: policy_id,
            emails: $scope.emails,
          })
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.POLICYSEND, "success");
                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: policy_id,
                  identifier: "compartió la póliza por email.",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $uibModalInstance.dismiss("cancel");
              } else {
                l.stop();
                SweetAlert.swal("ERROR", MESSAGES.ERROR.POLICYERROR, "error");
              }
            },
            function error(error) {
              console.log("error - email", error);
            }
          )
          .catch(function (e) {
            console.log("error - catch", e);
          });
      };

      $scope.deleteEmail = function (email) {
        $http({
          method: "GET",
          url: url.IP + "delete-assign/",
          params: {
            id: email.id,
          },
        })
          .then(function (request) {
            assignModalView($scope, $uibModalInstance, policy_id, url);
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };

      $scope.shareFile = function (file) {
        $http
          .get(url.IP + "patch-policy-file/" + file.id)
          .then(function (response) {
            $scope.files.some(function (filex) {
              if (filex.id == response.data.id) {
                filex.shared = response.data.shared;
              }
            });
            $scope.files[file] = response.data;
            // $scope.shared = response.data.shared;
          });
      };

      $scope.is_owner = false;

      $scope.assignPolicy = function (email) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (validateEmail(email) == false) {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
        var assign = {
          is_owner: $scope.is_owner,
          active: true,
          poliza: policy_id,
          email: email,
        };
        $http
          .post(url.IP + "assign-pendient/", assign)
          .then(function (response) {
            if (response.status === 200 || request.status === 201) {
              if (response.data.type == 1) {
                l.stop();
                SweetAlert.swal(
                  "Advertencia",
                  MESSAGES.INFO.POLICYASSIGNED,
                  "warning"
                );
              } else {
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.INFO.POLICYPENDIENT,
                  "success"
                );
                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: $scope.caratula.id,
                  identifier: "compartió la póliza por app.",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
              }
            }
          });

        $uibModalInstance.dismiss("cancel");
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }
    function actualizar() {
      $http({
        method: "GET",
        url: url.IP + "get-caratula/" + $stateParams.polizaId + "/",
      }).then(function success(request) {
        if (request.status === 200) {
          $scope.caratula = request.data;

          payform.forEach(function (payform) {
            if ($scope.caratula.forma_de_pago == payform.value) {
              $scope.caratula.forma_de_pago = {
                name: payform.label,
                value: payform.value,
              };
            }
          });
        }
      });
    }
    $scope.editReceipt = function (receipt, index) {
      if (receipt.status == 4 || receipt.status == "Pendiente de pago") {
        SweetAlert.swal(
          {
            title: "Advertencia",
            text: "Por el momento no se validarán las primas y ni las fechas al editar este recibo. ¿Deseas continuar?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var modalInstance = $uibModal.open({
                templateUrl: "app/colectividades/receipt.modal.html",
                controller: EditReceiptModalCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  recibo: function () {
                    return receipt;
                  },
                  index: function () {
                    return index;
                  },
                  caratula: function () {
                    return $scope.caratula;
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });
              modalInstance.closed.then(function (receipt) {
                actualizar();
              });
            } else {
              SweetAlert.swal(
                "Cancelado",
                "El recibo no ha sido actualizado",
                "error"
              );
            }
          }
        );
      } else {
        SweetAlert.swal(
          "Advertencia",
          "El recibo no se puede editar porque no esta pendiente de pago.",
          "warning"
        );
      }
    };
    $scope.deleteReceipt = function (receipt, index) {
      if (receipt.status == 4) {
        SweetAlert.swal(
          {
            title: "Advertencia",
            text: "¿Está seguro de eliminar este recibo?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var obj = {
                status: 0,
              };
              $http.patch(receipt.url, obj).then(function (response) {
                if (response.data.status == 0) {
                  $scope.caratula.recibos_poliza.splice(index, 1);
                }
                var paramsDelRec = {
                  model: 18,
                  event: "DELETE",
                  associated_id: $scope.caratula.id,
                  identifier:
                    " elimino un recibo (" +
                    receipt.recibo_numero +
                    ") de la colectividad",
                };
                dataFactory
                  .post("send-log/", paramsDelRec)
                  .then(function success(response) {});
                var data_email = {
                  id: receipt.id,
                  id_poliza: $scope.caratula.id,
                  model: 8,
                  type_person: 0,
                };
                dataFactory
                  .post("send-email-admins-deletes/", data_email)
                  .then(function success(req) {
                    // console.log('.................:::::.....',req)
                  });
              });
              //
            } else {
              SweetAlert.swal(
                "Cancelado",
                "El recibo no ha sido eliminado",
                "error"
              );
            }
          }
        );
      } else {
        SweetAlert.swal(
          "Advertencia",
          "El recibo no se puede eliminar porque no esta pendiente de pago.",
          "warning"
        );
      }
    };

    function EditReceiptModalCtrl(
      url,
      $http,
      $rootScope,
      recibo,
      index,
      caratula,
      $scope,
      $uibModalInstance
    ) {
      var rec = this;
      rec.recibo = recibo;
      var fecha_inicio = recibo.fecha_inicio;
      var fecha_fin = recibo.fecha_fin;
      var fecha_venc = recibo.vencimiento;

      rec.recibo.fecha_inicio = convertDate(recibo.fecha_inicio);
      rec.recibo.fecha_fin = convertDate(recibo.fecha_fin);
      rec.recibo.vencimiento = convertDate(recibo.vencimiento);
      // $scope.recibo.sub_total = (parseFloat(recibo.prima_neta) + parseFloat(recibo.rpf) + parseFloat(recibo.derecho)).toFixed(2);
      // console.log('-------',rec)
      function convertDate(inputFormat, indicator) {
        var date = inputFormat;
        if (inputFormat.length != 10) {
          function pad(s) {
            return s < 10 ? "0" + s : s;
          }
          var d = new Date(inputFormat);
          if (indicator) {
            date = [
              pad(d.getDate() + 1),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          } else {
            date = [
              pad(d.getDate()),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          }
        }

        return date;
      }

      function toDate(dateStr) {
        if (dateStr) {
          var dateString = dateStr; // Oct 23
          var dateParts = dateString.split("/");
          var dateObject = new Date(
            dateParts[2],
            dateParts[1] - 1,
            dateParts[0]
          ); // month is 0-based
          return dateObject;
        }
      }

      $scope.validateDecimal = function (form) {
        form = String(form).replace(/[A-Za-z]/g, "");
        form = String(form).replace(/,/g, "");
        return form;
      };

      $scope.changePrimas = function (data) {
        rec.recibo.sub_total = (
          parseFloat(data.prima_neta) +
          parseFloat(data.rpf) +
          parseFloat(data.derecho)
        ).toFixed(2);
        rec.recibo.prima_total = (
          parseFloat(rec.recibo.sub_total) + parseFloat(data.iva)
        ).toFixed(2);
      };

      $scope.saveReceipt = function (receipt) {
        if (
          process(rec.recibo.fecha_inicio) <
          process(convertDate(caratula.start_of_validity))
        ) {
          SweetAlert.swal(
            "Error",
            "La fecha de inicio del recibo no puede ser menor a la fecha de inicio de la póliza.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        var obj = {
          fecha_inicio: new Date(toDate(receipt.fecha_inicio)),
          fecha_fin: new Date(toDate(receipt.fecha_fin)),
          prima_neta: receipt.prima_neta,
          rpf: receipt.rpf,
          derecho: receipt.derecho,
          iva: receipt.iva,
          prima_total: receipt.prima_total,
          comision: receipt.comision,
          vencimiento: new Date(toDate(receipt.vencimiento)),
          delivered: receipt.delivered,
        };

        $http.patch(receipt.url, obj).then(function (response) {
          var params = {
            model: 18,
            event: "PATCH",
            associated_id: caratula.id,
            identifier: "actualizó el recibo " + receipt.recibo_numero + ".",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          var params = {
            model: 4,
            event: "POST",
            associated_id: receipt.id,
            identifier: "actualizó el recibo.",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          SweetAlert.swal("Listo", "El recibo ha sido actualizado", "success");
          $scope.cancel(true);
        });
      };
      $scope.cancel = function (v) {
        if (!v) {
          rec.recibo.fecha_inicio = fecha_inicio;
          rec.recibo.fecha_fin = fecha_fin;
          rec.recibo.vencimiento = fecha_venc;
        }
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.calculatePrima = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].prima_neta);
        }
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateRpf = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].rpf);
        }
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateDerecho = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].derecho);
        }
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateIva = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].iva);
        }
      }
      return total_comision.toFixed(2);
    };
    $scope.calculatePrimaTotal = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].prima_total);
        }
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateComision = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].comision);
        }
      }
      return total_comision.toFixed(2);
    };

    $scope.statusReceipt = function (parValue) {
      switch (parValue) {
        case 1:
          return "Pagado";
          break;
        case 2:
          return "Cancelado";
          break;
        case 3:
          return "Prorrogado";
          break;
        case 4:
          return "Pendiente de Pago";
          break;
        case 5:
          return "Liquidado";
          break;
        case 6:
          return "Conciliado";
          break;
        case 7:
          return "Cerrado";
          break;
        case 8:
          return "Precancelado";
          break;
        default:
          return parValue;
      }
    };

    $scope.deliveredReceipt = function (receipt) {
      SweetAlert.swal(
        {
          title: "Entregado",
          text: "Este recibo se marcara como entregado",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var params = {
              model: 4,
              event: "PATCH",
              associated_id: receipt.id,
              identifier: " actualizo el recibo a Entregado",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            $http({
              method: "PATCH",
              url: receipt.url,
              data: {
                delivered: true,
              },
            }).then(function success(response) {
              if (response.status == 200) {
                SweetAlert.swal("¡Listo!", "", "success");

                $state.go("colectividades.info", {
                  polizaId: $scope.caratula.id,
                });
              }
            });
          }
        }
      );
    };

    // configuraciÃ³n del datepicker
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

/* global angular */
(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ColectividadesEditCtrl", ColectividadesEditCtrl);

  ColectividadesEditCtrl.$inject = [
    "$uibModal",
    "$localStorage",
    "providerService",
    "$scope",
    "insuranceService",
    "$controller",
    "$http",
    "url",
    "$stateParams",
    "payform",
    "$sessionStorage",
    "$rootScope",
    "toaster",
    "MESSAGES",
    "helpers",
    "datesFactory",
    "dataFactory",
    "FileUploader",
    "$timeout",
    "SweetAlert",
    "packageService",
    "coverageService",
    "$state",
    "$location",
  ];

  function ColectividadesEditCtrl(
    $uibModal,
    $localStorage,
    providerService,
    $scope,
    $controller,
    insuranceService,
    $http,
    url,
    $stateParams,
    payform,
    $sessionStorage,
    $rootScope,
    toaster,
    MESSAGES,
    helpers,
    datesFactory,
    dataFactory,
    FileUploader,
    $timeout,
    SweetAlert,
    packageService,
    coverageService,
    $state,
    $location
  ) {
    // Defaults
    // $scope.order = this;
    $scope.verSubgrupo = true;
    $scope.showSubgroup = true;
    $scope.showContent = false;
    $scope.caratulaSaved = true;
    $scope.newPackage = false;
    $scope.verCaratula = true;
    $scope.can_change_frecuencia = true;
    $scope.noRecalculateReceipts = false;
    $scope.order = {
      form: {},
    };
    $scope.order.hidden = true;
    $scope.order.defaults = {
      payform: angular.copy(payform),
    };
    // $scope.order.form = {};
    $scope.order.subgroups = [];
    $scope.order.categories = [];
    $scope.order.defaults = {
      packages: [],
    };
    $scope.renewalColect == false;

    // Defaults
    $scope.order.show = {
      ot: true,
      receipt: false,
      generateReceipts: false,
      receiptsGenerated: false,
      firstTab: true,
      showForms: false,
      showCoverages: false,
    };
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };
    $scope.order.form = {
      payment: {},
    };
    $scope.order.payment = {};
    $scope.order.renewal = {};
    $scope.order.renewal.is_renewable = 1;
    $scope.order.renewal.options = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];

    $scope.order.f_currency = {};
    // $scope.order.f_currency.f_currency_selected = 1;
    $scope.order.f_currency.options = [
      { value: 1, label: "PESOS" },
      { value: 2, label: "DOLARES" },
      { value: 3, label: "UDI" },
      { value: 4, label: "EURO" },
      { value: 5, label: "DOLAR CANADIENSE" },
      { value: 6, label: "LIBRA ESTERLINA" },
      { value: 7, label: "YEN" },
    ];
    $scope.verReceipts = false;

    if ($stateParams.status) {
      $scope.verSubgrupo = false;
      $scope.verReceipts = true;
    }

    $scope.infoUser = $sessionStorage.infoUser;

    // console.log("LOCATION",$location.path())
    if ($location.path().indexOf("editar")) {
      //$scope.can_change_frecuencia = false;
      $scope.noRecalculateReceipts = true;
    } else {
      $scope.noRecalculateReceipts = false;
      //$scope.can_change_frecuencia = true;
    }

    if ($stateParams.status) {
      $scope.editot = true;
    } else {
      $scope.editot = false;
    }
    $scope.frec_disabled = true;
    $scope.arrayReceipts = [];

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var DEFAULT = "Default";
    var ADD = "add";
    var NEXT = "next";
    var NOT_GROUP = "notGroup";
    var NOT_CATEGORY = "notCategory";
    var NEXT_RECEIPTS = "nextReceipts";

    $scope.selectContractor = true;
    $scope.selectedPagkage = false;
    $scope.showNewCoverage = false;
    $scope.showReceipts = false;
    $scope.caratula_receipts = false;
    $rootScope.show_contractor = false;
    $scope.dataToSave = {};
    $scope.excelFile = {};
    $scope.subgroup = {};
    $scope.category = {};
    $scope.coverageName = "";
    $scope.coverages = [];
    $scope.configurations = [];
    $scope.coveragesPackage = [];
    $scope.coveragesConfig = [];
    $scope.saveSubgToPolicy = saveSubgToPolicy;

    $scope.receipts_option = "on_subgroup";
    $scope.statesparams = $stateParams;
    $scope.order.recalcular = true;
    $scope.mostrarAlertaSubgrupo = false;

    var d = new Date();
    var curr_date = d.getDate();
    var curr_month = d.getMonth() + 1; //Months are zero based
    var curr_year = d.getFullYear();
    var date = curr_year + "-" + curr_month + "-" + curr_date;

    $scope.accesos = $sessionStorage.permisos;
    if ($scope.accesos) {
      $scope.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          $scope.acceso_polizas = perm;
          $scope.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_adm_pol = true;
              } else {
                $scope.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                $scope.acceso_ver_pol = true;
              } else {
                $scope.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          $scope.acceso_form = perm;
          $scope.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                $scope.acceso_form = true;
              } else {
                $scope.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          $scope.acceso_ot = perm;
          $scope.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                $scope.acceso_adm_ot = true;
              } else {
                $scope.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                $scope.acceso_ver_ot = true;
              } else {
                $scope.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          $scope.acceso_contg = perm;
          $scope.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                $scope.acceso_adm_cont = true;
              } else {
                $scope.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                $scope.acceso_ver_cont = true;
              } else {
                $scope.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          $scope.coms = perm;
          $scope.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                $scope.permiso_comisiones = true;
              } else {
                $scope.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          $scope.acceso_files = perm;
          $scope.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                $scope.permiso_archivos = true;
              } else {
                $scope.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    dataFactory.get("sucursales-to-show/").then(function success(response) {
      $scope.sucursalList = response.data.results;
    });

    providerService
      .getProviderByKey(date)
      .then(
        function success(data) {
          $scope.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      )
      .catch(function (e) {
        console.log("error", e);
      });

    $http.get(url.IP + "get-vendors/").then(function (user) {
      $scope.users = user.data;
      // console.log($scope.users)

      $scope.show_pagination = true;
      $scope.config_pagination = {
        count: user.data.count,
        next: user.data.next,
        previous: user.data.previous,
      };

      $scope.users.forEach(function (user) {
        user["phones"] = [];
        user["subramos"] = [];
      });
    });

    $scope.domiciliado = false;
    $scope.changeDomiciliado = function () {
      $scope.change_domiciliado = true;
      if (
        $scope.order.form.domiciliado == "true" ||
        $scope.order.form.domiciliado == true
      ) {
        $scope.domiciliado = true;
      } else {
        $scope.domiciliado = false;
      }
    };

    // Varios referenciadores
    $scope.referenciadores = [];
    $scope.addReferenciador = function (type) {
      var addReferenciadores = {
        referenciador: $scope.referenciador,
      };
      $scope.referenciadores.push(addReferenciadores);
    };
    $scope.changeReferenciador = function (ref) {
      if (ref) {
        if (ref.data) {
          if (ref.data.url != ref.referenciador) {
            $http.get(ref.referenciador).then(function success(c) {
              var subBranchsComisions =
                c.data.user_info.info_vendedor[0].vendedor_subramos;
              subBranchsComisions.forEach(function (sr) {
                if (
                  (sr.subramo == $scope.caratula.subramo.subramo_code &&
                    sr.provider == $scope.caratula.aseguradora.id) ||
                  (sr.subramo == 0 && sr.provider == 0)
                ) {
                  ref.comision_vendedor = sr.comision;
                } else {
                  ref.comision_vendedor = 0;
                }
              });
            });
          }
          if (ref.data.url == ref.referenciador) {
            $http.get(ref.referenciador).then(function success(c) {
              var subBranchsComisions =
                c.data.user_info.info_vendedor[0].vendedor_subramos;
              subBranchsComisions.forEach(function (sr) {
                if (
                  (sr.subramo == $scope.caratula.subramo.subramo_code &&
                    sr.provider == $scope.caratula.aseguradora.id) ||
                  (sr.subramo == 0 && sr.provider == 0)
                ) {
                  ref.comision_vendedor = sr.comision;
                } else {
                  ref.comision_vendedor = ref.data.comision_policy;
                }
              });
            });
          }
        }
      }
      if (ref.referenciador) {
        ref.selectedRef = true;
      } else {
        ref.selectedRef = false;
      }
    };
    $scope.changeComRef = function (com) {};
    $scope.deleteReferenciador = function (index, ref) {
      SweetAlert.swal(
        {
          title: "¿Estás seguro?",
          text: "Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        },
        function (isConfirm) {
          if (isConfirm) {
            if (index && ref.url) {
              if (ref.url) {
                $http.delete(ref.url);
              }
              $scope.referenciadores.splice(index, 1);
            } else {
              if (ref.url) {
                $http.delete(ref.url);
              }
              $scope.referenciadores.splice(index, 1);
            }
          }
        }
      );
    };
    // varios referenciadores
    // Initialize wizard
    $scope.goToList = function () {
      $state.go("colectividades.info", { polizaId: $scope.caratula.id });
    };
    $http({
      method: "GET",
      url: url.IP + "get-caratula/" + $stateParams.polizaId + "/",
    })
      .then(
        function success(request) {
          $scope.newC = request.data.comision;
          $scope.order.f_currency.f_currency_selected = request.data.f_currency;
          if ($scope.order.f_currency.f_currency_selected == "Pesos") {
            $scope.order.f_currency.f_currency_selected = 1;
          } else if ($scope.order.f_currency.f_currency_selected == "Dólares") {
            $scope.order.f_currency.f_currency_selected = 2;
          }

          for (var i = 0; i < request.data.recibos_poliza.length; i++) {
            if (request.data.recibos_poliza[i].receipt_type == 1) {
              request.data.recibos_poliza[i].startDate = convertDate(
                request.data.recibos_poliza[i].fecha_inicio
              );
              request.data.recibos_poliza[i].endingDate = convertDate(
                request.data.recibos_poliza[i].fecha_fin
              );
              request.data.recibos_poliza[i].vencimiento = convertDate(
                request.data.recibos_poliza[i].vencimiento
              );
              $scope.arrayReceipts.push(request.data.recibos_poliza[i]);
              if (request.data.recibos_poliza[i].status != 4) {
                $scope.order.recalcular = false;
              }
            }
          }
          if (request.status === 200) {
            $scope.order.defaults = {
              payform: angular.copy(payform),
            };
            if (request.data.receipts_by == 1) {
              if (request.data.recibos_poliza[0]) {
                $scope.order.form.domiciliado =
                  request.data.recibos_poliza[0].is_cat;
                $scope.domiciliado = request.data.recibos_poliza[0].is_cat;
              }
            }
            var payment;
            $http.get(url.IP + "usuarios/").then(function (user) {
              $scope.order.responsables = user.data.results;
              $scope.order.ejecutivos = user.data.results;
            });
            try {
              request.data.collection_executive.name =
                request.data.collection_executive.first_name +
                " " +
                request.data.collection_executive.last_name;
              $scope.order.form.collection_executive =
                request.data.collection_executive;
              $scope.original_collection_executive =
                request.data.collection_executive;
            } catch (e) {
              console.log(e);
            }
            try {
              request.data.sucursal.sucursal_name =
                request.data.sucursal.sucursal_name +
                " - " +
                request.data.sucursal.details;
              $scope.order.form.sucursal = request.data.sucursal;
              $scope.original_sucursal = request.data.sucursal;
            } catch (e) {
              console.log(e);
            }
            switch (request.data.payment) {
              case "ANUAL":
                $scope.order.payment.value = 12;
                payment = {
                  value: 12,
                  name: "ANUAL",
                };
                break;

              case "CONTADO":
                $scope.order.payment.value = 5;
                payment = {
                  value: 5,
                  name: "CONTADO",
                };
                break;

              case "SEMESTRAL":
                $scope.order.payment.value = 2;
                payment = {
                  value: 2,
                  name: "SEMESTRAL",
                };
                break;

              case "TRIMESTRAL":
                $scope.order.payment.value = 3;
                payment = {
                  value: 3,
                  name: "TRIMESTRAL",
                };
                break;

              case "MENSUAL":
                $scope.order.payment.value = 1;
                payment = {
                  value: 1,
                  name: "MENSUAL",
                };
                break;

              default:
                $scope.order.payment.value = 12;
                payment = {
                  value: 12,
                  name: "ANUAL",
                };
                break;
            }

            // console.log('payment', payment);
            request.data.payment = payment;
            $scope.caratulaId = request.data.id;
            $scope.caratula = request.data;
            $scope.numRecs = 0;
            // $scope.totalRecs = 0
            $scope.totalRecs = $scope.caratula.recibos_poliza.length;
            $scope.caratula.recibos_poliza.forEach(function (i) {
              if (i.status == 4) {
                $scope.numRecs += 1;
              } else if (i.status != 4) {
                console.log(
                  "-CUENTA CON RECIBOS DIFERENTES DE PENDIENTE DE PAGO-",
                  i.status
                );
              }
            });
            if (
              $scope.numRecs == $scope.totalRecs &&
              $scope.caratula.receipts_by == 1
            ) {
              $scope.noRecalculateReceipts = false;
              if (
                $scope.caratula.status == "En trámite" ||
                $scope.caratula.status == "OT Cancelada."
              ) {
                $scope.order.show.ot = true;
              } else {
                $scope.order.show.ot = false;
              }
            }
            $scope.order.form.noRecalculateReceipts =
              $scope.noRecalculateReceipts;
            $scope.order.form.contratante = {};
            $scope.order.form.contratante.value = $scope.caratula.natural
              ? $scope.caratula.natural
              : $scope.caratula.juridical;
            if ($scope.order.form.contratante.value.full_name) {
              $scope.order.form.contratante.val =
                $scope.order.form.contratante.value.full_name;
            } else if ($scope.order.form.contratante.value.name) {
              $scope.order.form.contratante.val =
                $scope.order.form.contratante.value.name;
            } else if ($scope.order.form.contratante.value.first_name) {
              $scope.order.form.contratante.val =
                $scope.order.form.contratante.value.first_name +
                " " +
                $scope.order.form.contratante.value.last_name +
                " " +
                $scope.order.form.contratante.value.second_last_name;
            } else if ($scope.order.form.contratante.value.j_name) {
              $scope.order.form.contratante.val =
                $scope.order.form.contratante.value.j_name;
            }
            // $scope.caratula.payment = payment;
            $scope.order.form.subramo = request.data.subramo.subramo_name;

            $scope.order.receipts = $scope.arrayReceipts;
            $scope.order.poliza = {
              derecho: $scope.caratula.derecho,
              descuento: $scope.caratula.descuento,
              iva: $scope.caratula.iva,
              primaNeta: $scope.caratula.p_neta,
              primaTotal: $scope.caratula.p_total,
              rpf: $scope.caratula.rpf,
            };

            $scope.order.renewal.is_renewable = $scope.caratula.is_renewable;
            $scope.order.renewal.selected = $scope.caratula.is_renewable;
            $scope.order.adminType = $scope.caratula.administration_type;
            try {
              insuranceData.vendor.name =
                insuranceData.vendor.first_name +
                " " +
                insuranceData.vendor.last_name;
              $scope.caratula.vendor = insuranceData.vendor;
              $scope.original_vendor = insuranceData.vendor;
            } catch (e) {}

            if ($location.path().indexOf("convertir") != -1) {
              $scope.mostrarAlertaSubgrupo = true;
            }
            // Varios referenciadores
            $http.get(url.IP + "get-vendors").then(
              function success(data) {
                $scope.referenciador = data.data;
                $scope.referenciador.forEach(function (vendor) {
                  vendor.name = vendor.first_name + " " + vendor.last_name;
                });
              },
              function error(error) {
                toaster.ERROR("No pudieron ser cargados los referenciadores");
              }
            );
            try {
              if ($scope.caratula.ref_policy.length > 0) {
                $scope.caratula.ref_policy.forEach(function (refs) {
                  $http
                    .get(refs.referenciador)
                    .then(function success(response_ref_plicy) {
                      if (response_ref_plicy) {
                        refs.data = response_ref_plicy.data;
                        refs.referenciador = response_ref_plicy.data.url;
                        refs.data.comision_policy = refs.comision_vendedor;
                        refs.selectedRef = true;
                        $scope.referenciadores.push(refs);
                      }
                    });
                });
              } else if ($scope.caratula.vendor) {
                $http
                  .get($scope.caratula.vendor.url)
                  .then(function success(response_ref_plicy_vendor) {
                    var s_r =
                      response_ref_plicy_vendor.data.user_info.info_vendedor[0]
                        .vendedor_subramos;
                    s_r.forEach(function (sr) {
                      if (
                        sr.subramo == $scope.caratula.subramo.subramo_code &&
                        sr.provider == $scope.caratula.aseguradora.id
                      ) {
                        if (response_ref_plicy_vendor) {
                          response_ref_plicy_vendor.data =
                            response_ref_plicy_vendor.data;
                          response_ref_plicy_vendor.referenciador =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.vendor =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.comision_vendedor =
                            sr.comision;
                          response_ref_plicy_vendor.data.comision_policy =
                            response_ref_plicy_vendor.comision_vendedor;
                          response_ref_plicy_vendor.selectedRef = true;
                          $scope.referenciadores.push(
                            response_ref_plicy_vendor
                          );
                        }
                      }
                    });
                  });
              } else {
                $scope.referenciadores.push($scope.referenciador);
              }
            } catch (e) {
              console.log(":::::..referenciador varios::error:::::.", e);
            }
            // Varios refs

            if ($stateParams.status) {
              if ($stateParams.status == 1) {
                $scope.order.show.ot = false;
              } else {
                $scope.order.show.ot = true;
              }
            }
            // ---old policy
            $http({
              method: "GET",
              url: url.IP + "historic-policies/",
              params: {
                actual_id: $scope.caratula.id,
              },
            }).then(function success(response) {
              if (response.data.results.length) {
                $scope.showHistoric = true;
                $scope.hist_pol = response.data.results;
              }
              $scope.caratula_history = [];
              response.data.results.forEach(function function_name(old) {
                if ($scope.caratula.id != old.base_policy.id) {
                  $scope.caratula_history.push(old.base_policy);
                  $scope.verSubgrupo = true;
                } else {
                  $scope.caratula_history.push(old.new_policy);
                }
                if ($scope.caratula.url == old.new_policy.url) {
                  $scope.in_new_policy_hist = old.new_policy;
                }
              });
            });
            // olddd
            //package by subramo
            if ($stateParams.status == 1 && $scope.caratula) {
              $http
                .post(url.IP + "paquetes-data-by-subramo/", {
                  ramo: $scope.caratula.ramo.id,
                  subramo: $scope.caratula.subramo.id,
                  provider: $scope.caratula.aseguradora.id,
                })
                .then(
                  function success(response) {
                    if (response.status === 200) {
                      $scope.order.defaults.packages = response.data;
                    } else {
                      $scope.order.defaults.packages = [];
                    }
                  },
                  function error(e) {
                    console.log("Error - paquetes-data-by-subramo", e);
                    order.defaults.packages = [];
                  }
                )
                .catch(function (error) {
                  // console.log('Error - paquetes-data-by-subramo - catch', error);
                  // order.defaults.packages = [];
                });
            }
            // package by subramo
            $scope.caratula.start_of_validity = convertDate(
              $scope.caratula.start_of_validity
            );
            $scope.caratula.end_of_validity = convertDate(
              $scope.caratula.end_of_validity
            );
            $scope.aseguradoraSelection();
            $scope.changeRamo();
            // uploadFiles($scope.caratulaId);
            // console.log('asdfsadfsad'f, order);
            if (request.data.natural) {
              $scope.cover_contractor = request.data.natural;
              $scope.cover_contractor.direccion =
                request.data.natural.address_natural[0];
            } else {
              $scope.cover_contractor = request.data.juridical;
              $scope.cover_contractor.direccion =
                request.data.juridical.address_juridical[0];
            }
            if ($scope.caratula.recibos_poliza.length) {
              $scope.receits_on_cover = true;
            } else {
              $scope.receits_on_cover = false;
            }
            if ($scope.caratula.receipts_by == 1) {
              $scope.receits_on_cover = true;
            } else if ($scope.caratula.receipts_by == 2) {
              $scope.receits_on_cover = false;
            }
            if (
              $scope.caratula.forma_de_pago == "ANUAL" ||
              $scope.caratula.forma_de_pago == 12
            ) {
              $scope.order.form.payment.value = 12;
              // $scope.caratula.payment = "ANUAL";
              $scope.caratula.payment = {
                name: "ANUAL",
                value: 12,
              };
            } else if (
              $scope.caratula.forma_de_pago == "SEMESTRAL" ||
              $scope.caratula.forma_de_pago == 6
            ) {
              $scope.order.form.payment.value = 6;
              // $scope.caratula.payment = "SEMESTRAL";
              $scope.caratula.payment = { name: "SEMESTRAL", value: 6 };
            } else if (
              $scope.caratula.forma_de_pago == "CONTADO" ||
              $scope.caratula.forma_de_pago == 5
            ) {
              $scope.order.form.payment.value = 5;
              // $scope.caratula.payment = "CONTADO";
              $scope.caratula.payment = { name: "CONTADO", value: 5 };
            } else if (
              $scope.caratula.forma_de_pago == "TRIMESTRAL" ||
              $scope.caratula.forma_de_pago == 3
            ) {
              $scope.order.form.payment.value = 3;
              // $scope.caratula.payment = "TRIMESTRAL";
              $scope.caratula.payment = { name: "TRIMESTRAL", value: 3 };
            } else if (
              $scope.caratula.forma_de_pago == "BIMESTRAL" ||
              $scope.caratula.forma_de_pago == 2
            ) {
              $scope.order.form.payment.value = 2;
              // $scope.caratula.payment = "BIMESTRAL";
              $scope.caratula.payment = { name: "BIMESTRAL", value: 2 };
            } else if (
              $scope.caratula.forma_de_pago == "MENSUAL" ||
              $scope.caratula.forma_de_pago == 1
            ) {
              $scope.order.form.payment.value = 1;
              $scope.caratula.payment = { name: "MENSUAL", value: 1 };
            }

            var date1 = new Date($scope.caratula.start_of_validity);
            var date2 = new Date($scope.caratula.end_of_validity);
            var timeDiff = Math.abs(date2.getTime() - date1.getTime());
            $scope.order.form.policy_days_duration = Math.ceil(
              timeDiff / (1000 * 3600 * 24)
            );

            $scope.order.form.startDate = $scope.caratula.start_of_validity;
            $scope.order.form.endingDate = $scope.caratula.end_of_validity;
            $scope.order.form.ramo = $scope.caratula.ramo;
            $scope.order.form.comision_percent =
              $scope.caratula.comision_percent;
            $scope.change_comision_percent = false;

            if (
              $scope.caratula.status == "En trámite" ||
              $scope.caratula.status == "OT Cancelada."
            ) {
              $scope.order.show.ot = true;
            } else {
              $scope.order.show.ot = false;
            }

            $scope.dataToSave = $scope.order;
            $scope.dataToSave.poliza.descuento = parseFloat(
              $scope.dataToSave.poliza.descuento
            );
            $scope.dataToSave.poliza.rpf = parseFloat(
              $scope.dataToSave.poliza.rpf
            );
            $scope.dataToSave.poliza.iva = parseFloat(
              $scope.dataToSave.poliza.iva
            );
            $scope.show_receipts = true;

            $http({
              method: "GET",
              url: url.IP + "caratula-childs/" + $stateParams.polizaId + "/",
            }).then(function success(request) {
              if ($scope.caratula.receipts_by == 1) {
                $scope.receits_on_cover = true;
                $scope.selectContractor = false;
              } else if ($scope.caratula.receipts_by == 2) {
                $scope.receits_on_cover = false;
                $scope.selectContractor = true;
              }

              if (request.status === 200) {
                if ($scope.caratula.receipts_by == 1) {
                  $scope.receits_on_cover = true;
                }

                var results = request.data;
                results.forEach(function (child) {
                  if (child.document_type == 4) {
                    $scope.order.subgroups.push(child);
                    if ($scope.caratula.receipts_by == 2) {
                      $scope.order.form.domiciliado =
                        child.recibos_poliza[0].is_cat;
                      $scope.domiciliado = child.recibos_poliza[0].is_cat;
                    }
                    child.categories = [];
                    if ($stateParams.status) {
                      if (child.natural) {
                        $scope.receits_on_cover = false;
                        $scope.selectContractor = true;
                        $scope.showReceipts = true;
                        $scope.show_receipts = true;
                      } else if (child.juridical) {
                        $scope.receits_on_cover = false;
                        $scope.selectContractor = true;
                        $scope.show_receipts = true;
                        $scope.showReceipts = true;
                      }
                    }
                  } else if (child.document_type == 5) {
                    $scope.order.categories.push(child);
                    child.certs = [];
                  }
                });

                if ($scope.order.subgroups.length == 1) {
                  $scope.subgrupoResult = $scope.order.subgroups[0];
                } else if ($scope.order.subgroups.length > 1) {
                  var item = $scope.order.subgroups.length - 1;
                  $scope.subgrupoResult = $scope.order.subgroups[item];
                }

                $scope.order.categories.forEach(function (category) {
                  if (category.certs.length) {
                    category.certsEmpty = false;
                  } else {
                    category.certsEmpty = true;
                  }
                });

                $scope.order.subgroups.forEach(function (group) {
                  $scope.order.categories.forEach(function (category) {
                    if (group.url == category.parent) {
                      group.categories.push(category);
                    }
                  });
                });

                $scope.tree_subs = treeIdsStructure();
              }
            });
          }
        },
        function error(error) {}
      )
      .catch(function (e) {
        console.log(e);
      });
    $http({
      method: "GET",
      url: url.IP + "caratula-pack/",
      params: {
        id: $stateParams.polizaId,
      },
    })
      .then(
        function success(response) {
          $scope.packages = response.data.results;
        },
        function error(error) {}
      )
      .catch(function (e) {
        console.log(e);
      });
    $scope.caratulaToSave = {};
    $scope.change_fp = false;

    $scope.renewalSelection = function () {
      $scope.caratulaToSave.is_renewable = $scope.order.renewal.selected;
    };

    $scope.changeAdminType = function () {
      $scope.dataToSave.adminType = $scope.order.adminType;

      if ($scope.order.adminType == "Autoadministrada") {
        $scope.caratulaToSave.administration_type = 2;
      } else if ($scope.order.adminType == "Simplificada") {
        $scope.caratulaToSave.administration_type = 1;
      } else {
        $scope.caratulaToSave.administration_type = 3;
      }
    };

    $scope.existSubgroup = function (param) {
      if (param == 1) {
        $scope.exist_subgroup = true;
      } else {
        $scope.exist_subgroup = false;
      }
    };

    $scope.existCategoria = function (param) {
      if (param == 1) {
        $scope.exist_category = true;
      } else {
        $scope.exist_category = false;
      }
    };

    $scope.NotSubgroups = function () {
      // SweetAlert.swal({
      //   title: '¿Continuar sin subgrupos?',
      //   text: "Ya no podrá crear subgrupos en esta colectividad.",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#DD6B55",
      //   confirmButtonText: "Si",
      //   closeOnConfirm: true
      // }, function(isConfirm) {
      //     if (isConfirm) {
      //       $scope.saveSubgroup('notGroup')
      //       toaster.info("Favor de dar click en siguiente");
      //     }
      // });
      SweetAlert.swal(
        "Advertencia",
        "No es posible dejar una Póliza sin Subgrupo si elegiste. Crear Recibos por Subgrupo",
        "warning"
      );
    };

    $scope.NotCategories = function () {
      SweetAlert.swal(
        {
          title: "¿Continuar sin categorias?",
          text: "Ya no podrá crear categorias en esta colectividad.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.saveCategory("notCategory");
            toaster.info("Favor de dar click en siguiente");
            $state.go("colectividades.info", { polizaId: $scope.caratula.id });
          }
        }
      );
    };

    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = 0;
      var word_data = $scope.order.form.contratante.val;
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var juridicals = response.data.juridicals;
                var naturals = response.data.naturals;

                if (juridicals.length) {
                  juridicals.forEach(function (item) {
                    if (item.j_name) {
                      var obj = {
                        label: item.j_name,
                        value: item,
                      };
                    } else if (item.name) {
                      var obj = {
                        label: item.name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                } else if (naturals.length) {
                  naturals.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else if (item.name) {
                      var obj = {
                        label: item.name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }

                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
        $scope.contractors_data.length = 0;
      }
    };

    $scope.isReceiptAvailable = function (form_payment) {
      $scope.caratulaToSave.forma_de_pago = form_payment.value;
      $scope.caratulaToSave.payment = form_payment.label;
      $scope.caratula.payment = form_payment;
      if (
        $scope.caratulaToSave.forma_de_pago != $scope.caratula.forma_de_pago
      ) {
        SweetAlert.swal(
          "Advertencia",
          "Generar recibos es necesario, se eliminarán los anteriores",
          "warning"
        );
        if ($scope.caratula.receipts_by == 1) {
          $scope.receits_on_cover = true;
          $scope.change_fp = true;
          $scope.showContent = true;
          $scope.order.form.payment = form_payment.value;
        } else {
          $scope.tree_subs.forEach(function (item) {});
          if ($scope.caratula.status != "En trámite") {
            $scope.order.show.ot = false;
          }
          $scope.receits_on_cover = false;
          $scope.selectContractor = true;
          $scope.show_receipts = true;
          $scope.change_fp = true;
          $scope.order.form.payment = form_payment.value;
        }
      } else {
        $scope.change_fp = false;
      }
    };

    $scope.changeFrequency = function () {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Si cambias la forma de pago los recibos actuales serán eliminados y deberás recalcular.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.frec_disabled = false;
            $scope.caratula.receipts = [];
            $scope.edited_pay_frequency = true;
          }
        }
      );
    };

    $scope.sucursal = function (sc) {
      console.log("sucrsals");
    };
    $scope.change_comision = function () {
      $scope.change_comision_percent = true;
      if ($scope.order.form.comision_percent) {
        if ($scope.order.form.comision_percent > 100) {
          SweetAlert.swal("Error", "Debe ser menor o igual que 100 %", "error");
          $scope.order.form.comision_percent = 0;
          return;
        } else {
          $scope.newC = parseFloat(
            ($scope.caratula.p_neta * $scope.order.form.comision_percent) / 100
          ).toFixed(2);
        }
      }
    };

    $scope.saveCaratula = function () {
      if (
        $scope.receits_on_cover &&
        $scope.dataToSave &&
        !$scope.noRecalculateReceipts &&
        $scope.edited_pay_frequency
      ) {
        $scope.dataToSave.forma_de_pago = $scope.order.form.payment;
        $scope.receiptsUrl = [];
        if ($scope.dataToSave.recibos_poliza) {
          $scope.caratula.recibos_poliza.forEach(function (rec) {
            if (rec.receipt_type == 1 && $scope.caratula.receipts_by == 1) {
              // $scope.caratula.recibos_poliza.splice($scope.caratula.recibos_poliza.indexOf(rec), 1);
              try {
                $http.delete(rec.url).then(function (req) {
                  // console.log('delete', req);
                  var params = {
                    model: 18,
                    event: "DELETE",
                    associated_id: $scope.caratula.id,
                    identifier:
                      "elimino un recibo de la colectividad por cambio de frecuencia de pago.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                });
              } catch (recee) {
                console.log("--error delte rec", recee);
              }
            }
          });

          $scope.dataToSave.recibos_poliza.forEach(function (item, index) {
            // recibos en póliza
            item.poliza = $scope.caratula.url; // parseando recibos
            var start_date = new Date(toDate(item.startDate)).setHours(
              11,
              59,
              59
            );
            var end_date = new Date(toDate(item.endingDate)).setHours(12, 0, 0);

            item.endingDate = new Date(end_date);
            item.fecha_fin = new Date(end_date);
            item.startDate = new Date(start_date);
            item.fecha_inicio = new Date(start_date);

            if ($scope.caratula && $scope.caratula.receipts_by == 1) {
              item.poliza = $scope.caratula.url;
            }

            if (item.vencimiento) {
              var vencimiento = new Date(toDate(item.vencimiento)).setHours(
                11.59,
                59,
                0
              );
              item.vencimiento = new Date(vencimiento);
            }

            if ($scope.domiciliado) {
              item.is_cat = true;
            } else {
              item.is_cat = false;
            }
            $scope.caratula.rec_url = [];

            $http
              .post(url.IP + "recibos/", item)
              .then(function (data) {
                // console.log("nuevo recibo", data);
                if (data.status === 201) {
                  $scope.editedReceipts = false;
                  if ($scope.caratula.receipts_by == 1) {
                    $scope.caratula.rec_url.push(data.data.url);
                    $scope.caratula.recibos_poliza.push(data.data);
                  }
                  if (index == $scope.dataToSave - 1) {
                    if ($scope.caratula.receipts_by == 1) {
                      $scope.show_receipts_cover_data = true;
                    } else if ($scope.caratula.receipts_by == 2) {
                      $scope.show_receipts = false;
                    }
                  }
                }
              })
              .catch(function (error) {
                console.log("error", error);
                toaster.danger("No se han guardado los recibos");
              });
          });
        }
      }
      $scope.caratulaToSave.aseguradora = $scope.caratula.aseguradora.url;
      $scope.caratulaToSave.clave = $scope.caratula.clave.url;
      $scope.caratulaToSave.document_type = 3;
      $scope.caratulaToSave.f_currency =
        $scope.order.f_currency.f_currency_selected;
      $scope.caratulaToSave.natural = $scope.caratula.natural
        ? $scope.caratula.natural.url
        : null;
      $scope.caratulaToSave.juridical = $scope.caratula.juridical
        ? $scope.caratula.juridical.url
        : null;
      $scope.caratulaToSave.folio = $scope.caratula.folio;
      $scope.caratulaToSave.identifier = $scope.caratula.identifier;
      $scope.caratulaToSave.poliza_number = $scope.caratula.poliza_number;
      $scope.caratulaToSave.ramo = $scope.caratula.ramo.url;
      $scope.caratulaToSave.subramo = $scope.caratula.subramo.url;
      $scope.caratulaToSave.start_of_validity = new Date(
        datesFactory.toDate($scope.caratula.start_of_validity)
      );
      $scope.caratulaToSave.end_of_validity = new Date(
        datesFactory.toDate($scope.caratula.end_of_validity)
      );
      $scope.caratulaToSave.observations = $scope.caratula.observations;
      $scope.caratulaToSave.forma_de_pago = $scope.order.form.payment.value;
      $scope.caratulaToSave.vendor = "";
      $scope.caratulaToSave.collection_executive = $scope.order.form
        .collection_executive
        ? $scope.order.form.collection_executive.url
        : "";
      $scope.caratulaToSave.sucursal = $scope.order.form.sucursal
        ? $scope.order.form.sucursal.url
        : "";
      $scope.caratulaToSave.p_neta = $scope.dataToSave.poliza.primaNeta;
      $scope.caratulaToSave.p_total = $scope.dataToSave.poliza.primaTotal;
      $scope.caratulaToSave.derecho = $scope.dataToSave.poliza.derecho;
      $scope.caratulaToSave.rpf = $scope.dataToSave.poliza.rpf
        ? $scope.dataToSave.poliza.rpf
        : 0;
      $scope.caratulaToSave.descuento = $scope.dataToSave.poliza.descuento;
      $scope.caratulaToSave.comision = $scope.newC
        ? $scope.newC
        : $scope.dataToSave.poliza.comision;
      $scope.caratulaToSave.comision_percent = $scope.order.form
        .comision_percent
        ? $scope.order.form.comision_percent
        : $scope.dataToSave.comision_percent;
      $scope.contractorToSave = {};

      if ($scope.order.form.contratante.email) {
        $scope.contractorToSave.email = $scope.order.form.contratante.email;
      } else {
        $scope.contractorToSave.email = "";
      }
      if ($scope.order.form.contratante.phone_number) {
        $scope.contractorToSave.phone_number =
          $scope.order.form.contratante.phone_number;
      } else {
        $scope.contractorToSave.phone_number = "";
      }

      $http.patch(
        $scope.order.form.contratante.value.url,
        $scope.contractorToSave
      );

      if ($scope.order.form.contratante.value) {
        if ($scope.order.form.contratante.value.type_person == "Moral") {
          $scope.caratulaToSave.juridical =
            $scope.order.form.contratante.value.url;
          $scope.caratulaToSave.natural = "";
        } else if (
          $scope.order.form.contratante.value.type_person == "Fisica"
        ) {
          $scope.caratulaToSave.natural =
            $scope.order.form.contratante.value.url;
          $scope.caratulaToSave.juridical = "";
        }
      }
      if ($scope.caratula.ramo.ramo_code != 1) {
        $scope.caratulaToSave.iva = $scope.dataToSave.poliza.iva;
      } else {
        $scope.caratulaToSave.iva = 0;
      }

      if ($scope.caratula.rec_url) {
        $scope.caratulaToSave.recibos_poliza = $scope.caratula.rec_url;
        $scope.caratulaToSave.receipts = $scope.caratula.rec_url;
      }

      try {
        $scope.caratulaToSave.vendor = $scope.caratula.vendor.url;
      } catch (e) {}
      try {
        $scope.caratulaToSave.sucursal = $scope.order.form.sucursal
          ? $scope.order.form.sucursal.url
          : "";
      } catch (e) {}
      if (
        $scope.caratulaToSave.status == undefined ||
        !$scope.caratulaToSave.status
      ) {
        switch ($scope.caratula.status) {
          case "En trámite":
            $scope.caratulaToSave.status = 1;
            break;
          case "OT Cancelada":
            $scope.caratulaToSave.status = 2;
            break;
          case "Precancelada":
            $scope.caratulaToSave.status = 4;
            break;
          case "Por iniciar":
            $scope.caratulaToSave.status = 10;
            break;
          case "Cancelada":
            $scope.caratulaToSave.status = 11;
            break;
          case "Renovada":
            $scope.caratulaToSave.status = 12;
            break;
          case "Vencida":
            $scope.caratulaToSave.status = 13;
            break;
          case "Vigente":
            $scope.caratulaToSave.status = 14;
            break;
          case "No renovada":
            $scope.caratulaToSave.status = 15;
            break;
          case "Siniestrada":
            $scope.caratulaToSave.status = 16;
            break;
          default:
            $scope.caratulaToSave.status = 14;
        }
      }
      if ($stateParams.status != 1) {
        $http
          .patch($scope.caratula.url, $scope.caratulaToSave)
          .then(function success(response) {
            if (response.status === 200 || request.status === 201) {
              if (response.data.receipts_by == 1) {
                if (
                  $scope.order.form.domiciliado == false ||
                  $scope.order.form.domiciliado == true
                ) {
                  response.data.recibos_poliza.forEach(function (rec, e) {
                    $http
                      .patch(rec, { is_cat: $scope.order.form.domiciliado })
                      .then(
                        function success(reqIscat) {},
                        function error(error) {
                          console.log("patch-----is_cat---", error);
                        }
                      )
                      .catch(function (e) {
                        console.log(e);
                      });
                  });
                }
              }
              //varios referenciadores
              for (var i = 0; i < $scope.referenciadores.length; i++) {
                $scope.referenciadores[i].policy = response.data.url;
                if ($scope.referenciadores[i].url) {
                  $http
                    .patch(
                      $scope.referenciadores[i].url,
                      $scope.referenciadores[i]
                    )
                    .then(
                      function success(request) {},
                      function error(error) {
                        console.log(error);
                      }
                    )
                    .catch(function (e) {
                      console.log(e);
                    });
                } else {
                  $scope.ref_policy = $scope.referenciadores[i];
                  if ($scope.ref_policy) {
                    if ($scope.referenciadores[i].referenciador) {
                      var ref = {};
                      ref.referenciador =
                        $scope.referenciadores[i].referenciador;
                      ref.comision_vendedor = $scope.referenciadores[i]
                        .comision_vendedor
                        ? $scope.referenciadores[i].comision_vendedor
                        : 0;
                      ref.policy = response.data.url;
                      dataFactory
                        .post("referenciadores-policy/", ref)
                        .then(
                          function success(request) {},
                          function error(error) {
                            console.log(error);
                          }
                        )
                        .catch(function (e) {
                          console.log(e);
                        });
                    }
                  }
                }
              }
              // varios referenciadores
              if ($scope.caratula.rec_url) {
                $scope.caratulaToSave.recibos_poliza = $scope.caratula.rec_url;
                $scope.caratulaToSave.receipts = $scope.caratula.rec_url;
                $http
                  .patch($scope.caratula.url, $scope.caratulaToSave)
                  .then(function success(response) {
                    if (response.status == 200) {
                      //varios referenciadores
                      for (var i = 0; i < $scope.referenciadores.length; i++) {
                        $scope.referenciadores[i].policy = response.data.url;
                        if ($scope.referenciadores[i].url) {
                          $http
                            .patch(
                              $scope.referenciadores[i].url,
                              $scope.referenciadores[i]
                            )
                            .then(
                              function success(request) {},
                              function error(error) {
                                console.log(error);
                              }
                            )
                            .catch(function (e) {
                              console.log(e);
                            });
                        } else {
                          $scope.ref_policy = $scope.referenciadores[i];
                          if ($scope.ref_policy) {
                            if ($scope.referenciadores[i].referenciador) {
                              var ref = {};
                              ref.referenciador =
                                $scope.referenciadores[i].referenciador;
                              ref.comision_vendedor = $scope.referenciadores[i]
                                .comision_vendedor
                                ? $scope.referenciadores[i].comision_vendedor
                                : 0;
                              ref.policy = response.data.url;
                              dataFactory
                                .post("referenciadores-policy/", ref)
                                .then(
                                  function success(request) {},
                                  function error(error) {
                                    console.log(error);
                                  }
                                )
                                .catch(function (e) {
                                  console.log(e);
                                });
                            }
                          }
                        }
                      }
                      // varios referenciadores
                    }
                  });
              }
              if ($scope.change_comision_percent == true) {
                //true){
                //Cambiando la Comision de los recibos
                response.data.recibos_poliza.forEach(function (rec, e) {
                  $scope.monto_comision_nw = parseFloat(
                    ($scope.caratula.recibos_poliza[e].prima_neta *
                      $scope.order.form.comision_percent) /
                      100
                  ).toFixed(2);
                  $http
                    .patch(rec, { comision: $scope.monto_comision_nw })
                    .then(
                      function success(comision) {},
                      function error(error) {
                        console.log("patch-----change_comision---", error);
                      }
                    )
                    .catch(function (e) {
                      console.log(e);
                    });
                });
              }

              $scope.frec_disabled = true;
              $scope.edited_pay_frequency = false;
              toaster.success("Se ha guardado la caratula correctamente.");
            }
          });
      } else {
        //Recibos
        if ($stateParams.status) {
          if ($stateParams.status == 1) {
            $scope.saveReceiptsSub($scope.dataToSave);
          }
        }
        // --recibos
        $scope.caratulaToSave.status = 14;
        $http
          .patch($scope.caratula.url, $scope.caratulaToSave)
          .then(function success(response) {
            if (response.status === 200 || request.status === 201) {
              //varios referenciadores
              for (var i = 0; i < $scope.referenciadores.length; i++) {
                $scope.referenciadores[i].policy = response.data.url;
                if ($scope.referenciadores[i].url) {
                  $http
                    .patch(
                      $scope.referenciadores[i].url,
                      $scope.referenciadores[i]
                    )
                    .then(
                      function success(request) {},
                      function error(error) {
                        console.log(error);
                      }
                    )
                    .catch(function (e) {
                      console.log(e);
                    });
                } else {
                  $scope.ref_policy = $scope.referenciadores[i];
                  if ($scope.ref_policy) {
                    if ($scope.referenciadores[i].referenciador) {
                      var ref = {};
                      ref.referenciador =
                        $scope.referenciadores[i].referenciador;
                      ref.comision_vendedor = $scope.referenciadores[i]
                        .comision_vendedor
                        ? $scope.referenciadores[i].comision_vendedor
                        : 0;
                      ref.policy = response.data.url;
                      dataFactory
                        .post("referenciadores-policy/", ref)
                        .then(
                          function success(request) {},
                          function error(error) {
                            console.log(error);
                          }
                        )
                        .catch(function (e) {
                          console.log(e);
                        });
                    }
                  }
                }
              }
              // varios referenciadores

              var params = {
                model: 18,
                event: "POST",
                associated_id: response.data.id,
                identifier: "actualizó la OT.",
              };

              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              toaster.success("Se ha actualizado la OT correctamente.");
            }
          });
      }
      if ($scope.caratula.receipts_by == 2) {
        if ($scope.order.subgroups) {
          $scope.order.subgroups.forEach(function (sb) {
            if (sb.recibos_poliza.length > 0) {
              sb.recibos_poliza.forEach(function (rc) {
                $http
                  .patch(url.IP + "recibos/" + rc.id + "/", {
                    is_cat: $scope.order.form.domiciliado,
                  })
                  .then(
                    function success(rec_pol) {},
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              });
            }
          });
        }
      }
    };

    // Save caratula To policy Convert
    $scope.saveConvPolicyOT = function (dataToSave, carat, rec) {
      $scope.caratulaToSave = {};
      $scope.caratulaToSave.aseguradora = $scope.caratula.aseguradora.url;
      $scope.caratulaToSave.clave = $scope.caratula.clave.url;
      $scope.caratulaToSave.document_type = 3;
      $scope.caratulaToSave.receipts_by = $scope.caratula.receipts_by;
      $scope.caratulaToSave.f_currency =
        $scope.caratula.f_currency == "Pesos" ? 1 : 2;
      $scope.caratulaToSave.natural = $scope.caratula.natural
        ? $scope.caratula.natural.url
        : null;
      $scope.caratulaToSave.juridical = $scope.caratula.juridical
        ? $scope.caratula.juridical.url
        : null;
      $scope.caratulaToSave.folio = $scope.caratula.folio;
      $scope.caratulaToSave.identifier = $scope.caratula.identifier;
      $scope.caratulaToSave.poliza_number = $scope.caratula.poliza_number;
      $scope.caratulaToSave.ramo = $scope.caratula.ramo.url;
      $scope.caratulaToSave.subramo = $scope.caratula.subramo.url;
      $scope.caratulaToSave.start_of_validity = new Date(
        datesFactory.toDate($scope.caratula.start_of_validity)
      );
      $scope.caratulaToSave.end_of_validity = new Date(
        datesFactory.toDate($scope.caratula.end_of_validity)
      );
      $scope.caratulaToSave.observations = $scope.caratula.observations;
      $scope.caratulaToSave.vendor = "";
      $scope.caratulaToSave.status = 14;
      $scope.caratulaToSave.forma_de_pago = $scope.order.form.payment.value;

      try {
        $scope.caratulaToSave.vendor = $scope.caratula.vendor.url;
      } catch (e) {}
      if (
        $scope.caratula.poliza_number == "" ||
        $scope.caratula.poliza_number == null ||
        $scope.caratula.poliza_number == undefined
      ) {
        SweetAlert.swal("Error", "Número de póliza requerido", "error");
        return;
      }

      if (
        $scope.dataToSave.recibos_poliza == "" &&
        $scope.receits_on_cover == true
      ) {
        SweetAlert.swal("Error", "Generar recibos es necesario", "error");
        return;
      }

      $scope.receipts_poliza = [];
      if ($scope.dataToSave.recibos_poliza) {
        $scope.dataToSave.recibos_poliza.forEach(function (recibo) {
          var receipt_init = new Date(
            datesFactory.toDate(recibo.startDate)
          ).setHours(11, 59, 59);
          var receipt_end = new Date(
            datesFactory.toDate(recibo.endingDate)
          ).setHours(12, 0, 0);

          recibo.fecha_fin = new Date(receipt_end);
          recibo.fecha_inicio = new Date(receipt_init);
          recibo.startDate = new Date(receipt_init);
          recibo.endingDate = new Date(receipt_end);

          if (recibo.vencimiento) {
            var vencimiento = new Date(toDate(recibo.vencimiento)).setHours(
              11.59,
              59,
              0
            );
            recibo.vencimiento = new Date(vencimiento);
          }
        });
        // $scope.dataToSave.recibos_poliza = $scope.dataToSave.receipts;
      } else {
        $scope.dataToSave.recibos_poliza = [];
      }

      $scope.res_car_conv = [];
      if ($scope.caratula_history) {
        if ($scope.caratula_history.length != 0) {
          if ($scope.caratula_history[0].status == 13) {
            var data = {
              renewed: true,
              status: 12,
              renewed_status: 1,
            };
          } else if ($scope.caratula_history[0].renewed_status == 2) {
            var data = {
              renewed: true,
              renewed_status: 1,
            };
          }
        }
      }
      // Renewed status = 0 o 1 para las que son inciales y si es renewd status == 2
      // en porceso de renovacion , patch a la antarior con status renewed = 1 de renovada y, la convertida Ot a póliza con status
      if (
        dataToSave.recibos_poliza &&
        $scope.receits_on_cover == true &&
        $scope.caratula.receipts_by == 1
      ) {
        dataToSave.recibos_poliza.forEach(function (item, index) {
          // parseando recibos
          var start_date = item.startDate;
          var end_date = item.endingDate;

          item.endingDate = end_date;
          item.fecha_fin = end_date;
          item.startDate = start_date;
          item.fecha_inicio = start_date;
          // item.vencimiento = new Date(vencimiento);

          if (item.vencimiento) {
            var vencimiento = item.vencimiento;
            // console.log('receipt',item.vencimiento)
          }
          if (item.poliza == null || item.poliza == undefined || !item.poliza) {
            item.poliza = carat.url;
          }
          $http
            .post(url.IP + "recibos/", item)
            .then(function (data) {
              if (data.status === 201) {
                $scope.editedReceipts = false;
                $scope.receipts_poliza.push(data.data.url);
                if ($scope.receipts_poliza) {
                  if (
                    dataToSave.recibos_poliza.length ==
                    $scope.receipts_poliza.length
                  ) {
                    ($scope.caratulaToSave.p_total = dataToSave.p_total),
                      ($scope.caratulaToSave.derecho =
                        dataToSave.poliza.derecho),
                      ($scope.caratulaToSave.rpf = $scope.order.poliza.rpf
                        ? $scope.order.poliza.rpf
                        : 0),
                      ($scope.caratulaToSave.p_neta = dataToSave.p_neta),
                      ($scope.caratulaToSave.iva =
                        $scope.dataToSave.poliza.iva),
                      ($scope.caratulaToSave.descuento =
                        $scope.dataToSave.poliza.descuento),
                      ($scope.caratulaToSave.comision =
                        $scope.dataToSave.comision),
                      ($scope.caratulaToSave.comision_percent =
                        $scope.dataToSave.comision_percent),
                      ($scope.caratulaToSave.name = carat.name),
                      ($scope.caratulaToSave.recibos_poliza =
                        $scope.receipts_poliza);

                    if ($scope.caratulaToSave.recibos_poliza) {
                      $http
                        .patch(carat.url, $scope.caratulaToSave)
                        .then(function success(response) {
                          if (response.status == 200) {
                            $scope.res_car_conv = response;
                            console.log(
                              "---reposne patch car---",
                              $scope.res_car_conv
                            );
                            //varios referenciadores
                            for (
                              var i = 0;
                              i < $scope.referenciadores.length;
                              i++
                            ) {
                              $scope.referenciadores[i].policy =
                                response.data.url;
                              if ($scope.referenciadores[i].url) {
                                $http
                                  .patch(
                                    $scope.referenciadores[i].url,
                                    $scope.referenciadores[i]
                                  )
                                  .then(
                                    function success(request) {},
                                    function error(error) {
                                      console.log(error);
                                    }
                                  )
                                  .catch(function (e) {
                                    console.log(e);
                                  });
                              } else {
                                $scope.ref_policy = $scope.referenciadores[i];
                                if ($scope.ref_policy) {
                                  if ($scope.referenciadores[i].referenciador) {
                                    var ref = {};
                                    ref.referenciador =
                                      $scope.referenciadores[i].referenciador;
                                    ref.comision_vendedor = $scope
                                      .referenciadores[i].comision_vendedor
                                      ? $scope.referenciadores[i]
                                          .comision_vendedor
                                      : 0;
                                    ref.policy = response.data.url;
                                    dataFactory
                                      .post("referenciadores-policy/", ref)
                                      .then(
                                        function success(request) {},
                                        function error(error) {
                                          console.log(error);
                                        }
                                      )
                                      .catch(function (e) {
                                        console.log(e);
                                      });
                                  }
                                }
                              }
                            }
                            // varios referenciadores
                            if ($scope.res_car_conv) {
                              if ($scope.res_car_conv.status == 200) {
                                // $scope.verCaratula = false;
                                $scope.showContent = false;

                                // toaster.success("Se han guardado la carátula exitosamente");
                              }
                            }
                          }
                        });
                    }
                  }
                  $timeout(function () {
                    toaster.success(
                      "Se han guardado la carátula exitosamente."
                    );
                  }, 100);
                }
              }
            })
            .catch(function (error) {
              console.log("error", error);
              toaster.danger("No se han guardado los recibos");
            });
        });
        if ($scope.caratula_history) {
          if ($scope.caratula_history.length != 0) {
            if ($scope.caratula_history[0].status == 13) {
              var data = {
                renewed: true,
                status: 10,
                renewed_status: 1,
              };
            } else if ($scope.caratula_history[0].renewed_status == 2) {
              var data = {
                renewed: true,
                renewed_status: 1,
              };
            }
            /* Actualiza la póliza antigua */
            $http
              .patch($scope.caratula_history[0].url, data)
              .then(function success(response) {});
          }
        }
      }
      if (
        ($scope.dataToSave.receipts == "" ||
          $scope.dataToSave.receipts == undefined) &&
        $scope.receits_on_cover == false &&
        $scope.caratula.receipts_by == 2
      ) {
        // if($scope.caratulaToSave.recibos_poliza){
        $http
          .patch(carat.url, $scope.caratulaToSave)
          .then(function success(response) {
            if (response.status == 200) {
              $scope.res_car_conv = response.data;
              $scope.numRecs = $scope.totalRecs + 1;
              console.log("--numddd", $scope.numRecs, $scope.totalRecs);
              //varios referenciadores
              for (var i = 0; i < $scope.referenciadores.length; i++) {
                $scope.referenciadores[i].policy = response.data.url;
                if ($scope.referenciadores[i].url) {
                  $http
                    .patch(
                      $scope.referenciadores[i].url,
                      $scope.referenciadores[i]
                    )
                    .then(
                      function success(request) {},
                      function error(error) {
                        console.log(error);
                      }
                    )
                    .catch(function (e) {
                      console.log(e);
                    });
                } else {
                  $scope.ref_policy = $scope.referenciadores[i];
                  if ($scope.ref_policy) {
                    if ($scope.referenciadores[i].referenciador) {
                      var ref = {};
                      ref.referenciador =
                        $scope.referenciadores[i].referenciador;
                      ref.comision_vendedor = $scope.referenciadores[i]
                        .comision_vendedor
                        ? $scope.referenciadores[i].comision_vendedor
                        : 0;
                      ref.policy = response.data.url;
                      dataFactory
                        .post("referenciadores-policy/", ref)
                        .then(
                          function success(request) {},
                          function error(error) {
                            console.log(error);
                          }
                        )
                        .catch(function (e) {
                          console.log(e);
                        });
                    }
                  }
                }
              }
              // varios referenciadores
              toaster.success("Se han guardado la carátula exitosamente");
              $scope.showContent = false;
              if ($scope.caratula_history.length > 0) {
                if ($scope.caratula_history[0].status == 13) {
                  var data = {
                    renewed: true,
                    status: 12,
                    renewed_status: 1,
                  };
                } else if ($scope.caratula_history[0].renewed_status == 2) {
                  var data = {
                    renewed: true,
                    renewed_status: 1,
                  };
                }
                /* Actualiza la póliza antigua */
                $http
                  .patch($scope.caratula_history[0].url, data)
                  .then(function success(response) {});
              }
            }
          });
        // }
      }
      if (
        ($scope.dataToSave.receipts == "" ||
          $scope.dataToSave.receipts == undefined) &&
        $scope.receits_on_cover == false &&
        $scope.caratula.receipts_by == 2
      ) {
        SweetAlert.swal(
          "Recibos por subgrupo",
          "Agregue recibos a cada subgrupo, para completar la conversión"
        );
        $scope.show_contractor_list = true;
        $scope.receits_on_cover = false;
      }
    };
    // save receipts caratula

    function saveSubgToPolicy(data, sub, index) {
      if (
        (data.receipts == "" || !data.receipts) &&
        $scope.receits_on_cover == false
      ) {
        SweetAlert.swal(
          "Error",
          "Generar recibos es necesario, seleccione el grupo y agregue recibos",
          "error"
        );
        return;
      }
      if ($scope.dataToSave.receipts) {
        $scope.dataToSave.receipts.forEach(function (recibo) {
          if (isNaN(recibo.startDate)) {
            var receipt_init = new Date(
              datesFactory.toDate(recibo.startDate)
            ).setHours(11, 59, 59);
            var receipt_end = new Date(
              datesFactory.toDate(recibo.endingDate)
            ).setHours(12, 0, 0);
            // var vencimiento = new Date(datesFactory.toDate(recibo.vencimiento)).setHours(12,0,0);

            recibo.fecha_fin = new Date(receipt_end);
            recibo.fecha_inicio = new Date(receipt_init);
            recibo.startDate = new Date(receipt_init);
            recibo.endingDate = new Date(receipt_end);
            // recibo.vencimiento = new Date(vencimiento);

            if (recibo.vencimiento) {
              var vencimiento = new Date(toDate(recibo.vencimiento)).setHours(
                11.59,
                59,
                0
              );
              recibo.vencimiento = new Date(vencimiento);
            }

            if (
              $scope.order.form.domiciliado ||
              !$scope.order.form.domiciliado
            ) {
              recibo.is_cat = $scope.order.form.domiciliado;
            }
          }
        });

        $scope.dataToSave.recibos_poliza = $scope.dataToSave.receipts;
      } else {
        $scope.dataToSave.recibos_poliza = [];
      }

      if ($scope.order.show.ot) {
        $scope.dataToSave.receipts = [];
        $scope.dataToSave.poliza = {
          iva: 0,
          p_total: 0,
          derecho: 0,
          rpf: 0,
          p_neta: 0,
        };
      }
      $scope.saveReceiptsSub($scope.dataToSave, sub, index);
    }
    $scope.saveReceiptsSub = function (dataToSave, sub, index) {
      $scope.receipts_poliza = [];
      $scope.resp_subg = [];
      dataToSave.recibos_poliza.forEach(function (item, index) {
        // parseando recibos
        var start_date = item.startDate;
        var end_date = item.endingDate;

        item.endingDate = end_date;
        item.fecha_fin = end_date;
        item.startDate = start_date;
        item.fecha_inicio = start_date;
        item.is_cat = $scope.order.form.domiciliado;
        // item.vencimiento = new Date(vencimiento);
        if (item.vencimiento) {
          var vencimiento = item.vencimiento;
          // console.log('receipt',item.vencimiento)
        }

        if (
          (dataToSave.receipts == "" || !dataToSave.receipts) &&
          $scope.receits_on_cover == false
        ) {
          SweetAlert.swal("Error", "Generar recibos es necesario", "error");
          return;
        }

        $http
          .post(url.IP + "recibos/", item)
          .then(function (data) {
            if (data.status === 201) {
              $scope.editedReceipts = false;
              $scope.receipts_poliza.push(data.data.url);
              if ($scope.receipts_poliza) {
                if ($scope.receipts_poliza) {
                  var sdata = {
                    p_total: dataToSave.p_total,
                    derecho: dataToSave.poliza.derecho,
                    rpf: $scope.order.poliza.rpf ? $scope.order.poliza.rpf : 0,
                    p_neta: dataToSave.poliza.p_neta,
                    iva: parseFloat($scope.dataToSave.poliza.iva).toFixed(2),
                    name: sub.name,
                    recibos_poliza: $scope.receipts_poliza,
                  };
                  if (sdata.recibos_poliza) {
                    $http
                      .patch(sub.url, sdata)
                      .then(function success(response) {
                        if (response.status == 200) {
                          $scope.resp_subg = response;
                          $scope.order.receipts = [];
                          $scope.order.poliza = {};
                        }
                      });
                  }
                }
              }
            }
          })
          .catch(function (error) {
            console.log("error", error);
            toaster.danger("No se han guardado los recibos");
          });
      });
      if ($scope.resp_subg.status == 200) {
        toaster.success("Se han guardado los subgrupos exitosamente");
      }
    };
    // save receipts sub
    $scope.addPackage = function () {
      $scope.newPackage = true;
      $scope.configurations = [];
    };
    $scope.cancelNewPackage = function () {
      $scope.newPackage = false;
      $scope.addCoverages = false;
      $scope.package = "";
    };

    $scope.savePackage = function (parObj) {
      parObj.provider = $scope.caratula.aseguradora.url;
      parObj.ramo = $scope.caratula.ramo.url;
      parObj.subramo = $scope.caratula.subramo.url;
      parObj.type_package = 1; // paquete normal
      parObj.coverage_package = [];

      packageService
        .createPackage(parObj)
        .then(
          function success(request) {
            $scope.order.defaults.packages.push(request);
            $scope.newPackage = false;
            $scope.addCoverages = true;
            $scope.packageCreated = request;
            SweetAlert.swal(
              "¡Listo!",
              "El paquete: " + request.package_name + ", se ha creado.",
              "success"
            );
          },
          function error(error) {
            console.log("error - createPackage", error);
          }
        )
        .catch(function (e) {
          console.log("error -createPackage- catch", e);
        });
    };
    $scope.saveCoverage = function (parName, parType, parPackage, parData) {
      if (parPackage) {
        var paqueteData = parPackage;
      } else {
        var paqueteData = $scope.packageCreated;
      }

      var obj = {
        coverage_name: parName,
        provider: $scope.caratula.aseguradora.url,
        package: paqueteData.url,
        deductible: [],
        sums_coverage: [],
        coinsurance_coverage: [],
      };

      coverageService
        .createCoverage(obj)
        .then(
          function success(request) {
            $scope.coverages.push(request);
            $scope.coverageName = null;

            $scope.order.defaults.packages.forEach(function (item) {
              if (item.id == paqueteData.id) {
                if (parType == "config") {
                  $scope.config_coverages.source.push(request);
                  // parData.coveragesConfig.push(request);
                  $scope.showNewCoverage = false;
                }
                if (item.coverage_package) {
                  item.coverage_package.push(request);
                } else {
                  item.coverage_package = [];
                  item.coverage_package.push(request);
                }
              }
            });
          },
          function error(error) {
            console.log("error - createCoverage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createCoverage - catch", e);
        });
    };

    $scope.finishCoverages = function () {
      $scope.newPackage = false;
      $scope.addCoverages = false;
    };
    $scope.selectExcel = function (parData) {
      validateExcel(parData.ASEGURADOS);
      $scope.strcutureData = certStructure(parData);
      treeStructure(parData);

      $scope.id_tree = true;
    };

    function validateExcel(parData) {
      parData.forEach(function (child) {
        if (!child.INI_VIGENCIA) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna INI_VIGENCIA esta vacia",
            "error"
          );
          return;
        }
        if (!child.FIN_VIGENCIA) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna FIN_VIGENCIA esta vacia",
            "error"
          );
          return;
        }

        if (!child.PAQUETE) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PAQUETE esta vacia",
            "error"
          );
          return;
        }

        if (!child.PRIMA_TOTAL) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PRIMA_TOTAL esta vacia",
            "error"
          );
          return;
        } else if (child.PRIMA_TOTAL.search(",") >= 0) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PRIMA_TOTAL es invalida. Las cantidades deben ser sin comas o caracteres especiales",
            "error"
          );
          return;
        }

        if (order.form.ramo.ramo_code == 1 || order.form.ramo.ramo_code == 2) {
          if (!child.CERT_GRAL) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna CERT_GRAL esta vacia",
              "error"
            );
            return;
          }
          if (!child.CERTIFICADO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna CERTIFICADO esta vacia",
              "error"
            );
            return;
          }
          if (order.form.ramo.ramo_code == 2 && !child.INCISO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna INCISO esta vacia",
              "error"
            );
            return;
          }
          if (!child.AP_PAT) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna AP_PAT esta vacia",
              "error"
            );
            return;
          }
          if (!child.NOMBRE) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna NOMBRE esta vacia",
              "error"
            );
            return;
          }
          if (!child.FEC_NAC) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna FEC_NAC esta vacia",
              "error"
            );
            return;
          }

          if (!child.SEXO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna SEXO esta vacia",
              "error"
            );
            return;
          } else if (!(child.SEXO == "M" || child.SEXO == "F")) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna SEXO contiene un valor invalido",
              "error"
            );
            return;
          }

          if (!child.PARENTESCO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna PARENTESCO esta vacia",
              "error"
            );
            return;
          } else if (child.PARENTESCO > 4) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna PARENTESCO contiene un valor invalido",
              "error"
            );
            return;
          }

          if (!child.TIPO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna TIPO esta vacia",
              "error"
            );
            return;
          } else if (child.TIPO > 2) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna TIPO contiene un valor invalido",
              "error"
            );
            return;
          }

          if (
            order.form.ramo.ramo_code == 1 &&
            !child.PORCENTAJE &&
            child.TIPO == 2
          ) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna PORCENTAJE esta vacia",
              "error"
            );
            return;
          } else if (order.form.ramo.ramo_code == 1 && child.PORCENTAJE > 100) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna PORCENTAJE es mayor a 100",
              "error"
            );
            return;
          }

          if (
            order.form.ramo.ramo_code == 1 &&
            !child.FUMADOR &&
            child.TIPO == 1
          ) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna FUMADOR esta vacia",
              "error"
            );
            return;
          } else if (order.form.ramo.ramo_code == 1 && child.FUMADOR > 1) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna FUMADOR contiene un valor invalido",
              "error"
            );
            return;
          }
        } else if (order.form.subramo.subramo_code == 9) {
          if (!child.INCISO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna INCISO esta vacia",
              "error"
            );
            return;
          }

          if (!child.ASEGURADO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna ASEGURADO esta vacia",
              "error"
            );
            return;
          }

          if (!child.MARCA) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MARCA esta vacia",
              "error"
            );
            return;
          }

          if (!child.MODELO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MODELO esta vacia",
              "error"
            );
            return;
          }

          if (!child.AÑO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna AÑO esta vacia",
              "error"
            );
            return;
          }

          if (!child.VERSION) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna VERSION esta vacia",
              "error"
            );
            return;
          }

          if (!child.SERIAL) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna SERIAL esta vacia",
              "error"
            );
            return;
          }

          if (!child.MOTOR) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MOTOR esta vacia",
              "error"
            );
            return;
          }

          if (!child.COLOR) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna COLOR esta vacia",
              "error"
            );
            return;
          }

          if (!child.MATRICULA) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MATRICULA esta vacia",
              "error"
            );
            return;
          }

          if (!child.USO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna USO esta vacia",
              "error"
            );
            return;
          } else if (child.USO > 1) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna USO contiene un valor invalido",
              "error"
            );
            return;
          }
        }
      });
    }
    $scope.saveCertificados = function () {
      $scope.loader = true;
      var data = {
        data: $scope.strcutureData,
      };
      // console.log('strcutureData',$scope.strcutureData)
      $http({
        method: "POST",
        url: url.IP + "massive-certificates/",
        data: $scope.strcutureData,
      })
        .then(
          function success(request) {
            if (request.status === 201 || request.status === 200) {
              $scope.loader = false;
              toaster.success("Los certificados se han guardado correctamete.");
              $state.go("polizas.table");
            } else {
              $scope.loader = false;
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORCERTIFICATES,
                "error"
              );
            }
            // console.log('Request', request);
          },
          function error(error) {
            console.log("Error -  ");
            $scope.loader = false;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORCERTIFICATES, "error");
          }
        )
        .catch(function (e) {
          console.log("Error - catch", e);
        });
    };
    function treeStructure(parData) {
      var tree = [];

      for (var key in parData) {
        var data = parData[key];
        if (data.length) {
          // checar asegurados (parents)
          var parents = [];
          var childs = [];
          // console.log('caratula', order.form);
          if ($scope.caratula.subramo.subramo_code == 9) {
            // console.log('autos');

            data.forEach(function (car) {
              var parent_content =
                car.INCISO +
                " - " +
                car.MARCA +
                " - " +
                car.MODELO +
                " - " +
                car.AÑO +
                " - " +
                car.VERSION +
                " - " +
                car.SERIAL;

              var element = {
                text: parent_content,
              };

              tree.push(element);
            });
          } else if (
            $scope.caratula.ramo.ramo_code == 3 &&
            $scope.caratula.subramo.subramo_code != 9
          ) {
            data.forEach(function (item) {
              var parent_content =
                item.NOMBRE +
                " - " +
                item.CALLE +
                " #" +
                item.NUMERO +
                " " +
                item.COLONIA +
                " " +
                item.DELEGACION +
                " " +
                item.CIUDAD +
                " " +
                item.ESTADO +
                " C.P." +
                item.CP;

              var element = {
                text: parent_content,
              };

              if (item.INCISO) {
                tree.push(element);
              }
            });
          } else {
            data.forEach(function (child) {
              if (child.TIPO == 2) {
                childs.push(child);
              }
            });

            data.forEach(function (parent) {
              // console.log('item', item);
              if (parent.TIPO == 1) {
                // parents.push(item);
                var nodes = [];
                childs.forEach(function (item) {
                  if (item.CERTIFICADO == parent.CERTIFICADO) {
                    var full_name =
                      item.NOMBRE + " " + item.AP_PAT + " " + item.AP_MAT;

                    if (item.INCISO) {
                      var inciso = item.INCISO;
                    } else {
                      var inciso = "";
                    }

                    if (item.PARENTESCO) {
                      var parentesco = item.PARENTESCO;
                    } else {
                      var parentesco = "";
                    }

                    if (item.PORCENTAJE) {
                      var porcentaje = item.PORCENTAJE;
                    } else {
                      var porcentaje = "";
                    }

                    var content =
                      inciso +
                      " - " +
                      full_name +
                      " - " +
                      item.FEC_NAC +
                      " - " +
                      parentesco +
                      " - " +
                      item.SEXO +
                      " - " +
                      porcentaje;

                    nodes.push({
                      text: content,
                    });
                  }
                });

                var parent_content =
                  parent.CERTIFICADO +
                  " - " +
                  parent.NOMBRE +
                  " " +
                  parent.AP_PAT +
                  " " +
                  parent.AP_MAT +
                  " - " +
                  parent.FEC_NAC;

                var element = {
                  text: parent_content,
                  nodes: nodes,
                };

                tree.push(element);
              }
            });
          }

          $("#tree").treeview({ data: tree });
        }
      }
    }

    function certStructure(parData, par_status) {
      var certificadosArray = [];
      var beneficiaries_life = [];
      var beneficiaries_gm = [];
      var life_data = [];
      var gm_data = [];

      for (var key in parData) {
        var data = parData[key];

        if (data.length) {
          if ($scope.caratula.subramo.subramo_code == 9) {
            // COCHES
            var autos_certs = [];

            data.forEach(function (item) {
              if (item.USO) {
                if (item.USO >= "4" || item.USO <= "0") {
                  item.USO = "1";
                }
              } else {
                item.USO = "1";
              }

              if (!item.EMAIL) {
                item.EMAIL = "";
              }

              if (!item.CONTACTO) {
                item.CONTACTO = "";
              }
              if (item.BEN_PREFERENTE) {
                $scope.ben_p = item.BEN_PREFERENTE;
              } else {
                $scope.ben_p = "";
              }

              var data_autos = [
                {
                  brand: item.MARCA,
                  model: item.MODELO,
                  beneficiary_name: item.ASEGURADO,
                  year: item.AÑO,
                  version: item.VERSION,
                  serial: item.SERIAL,
                  engine: item.MOTOR,
                  color: item.COLOR,
                  usage: item.USO,
                  license_plates: item.MATRICULA,
                  email: item.EMAIL,
                  preferential_benefiaciary: $scope.ben_p,
                  document_type: 6,
                },
              ];

              autos_certs.push(data_autos);
              if (item.CATEGORIA) {
                var categoria_ = parseInt(item.CATEGORIA);
              } else {
                var categoria_ = $scope.categoria_result.id;
              }

              if (item.SUBGRUPO) {
                for (var i = 0; i < $scope.order.subgroups.length; i++) {
                  var item_sub = $scope.order.subgroups[i];

                  if (item_sub.id == parseInt(item.SUBGRUPO)) {
                    if (item_sub.address) {
                      var address_ = item.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    } else {
                      var address_ = $scope.caratula.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    }
                  }
                }
              } else {
                var address_ = $scope.caratula.address;
                var natural_ = $scope.caratula.natural;
                var juridical_ = $scope.caratula.juridical;
              }

              if ($scope.order.show.ot) {
                var status_ = 1;
              } else {
                var status_ = 14;
              }

              if ($scope.config_saved.length) {
                $scope.config_saved.forEach(function (i) {
                  if (i.id == item.PAQUETE) {
                    $scope.coberturas_paquete = i.coverage_package;
                    $scope.coberturas_paquete.forEach(function (j) {
                      if (
                        $scope.caratula.subramo.subramo_name == "Gastos Médicos"
                      ) {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = j.coinsurance_coverage[0].coinsurance;
                      } else {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = 0;
                      }
                    });
                  }
                });
              }

              var inciso_start = new Date(toDate(item.INI_VIGENCIA));
              var inciso_end = new Date(toDate(item.FIN_VIGENCIA));

              var certData = {
                internalNumber: null,
                folio: null,
                caratula: $scope.caratula.id,
                certificate_number: parseInt(item.INCISO),
                aseguradora: $scope.dataToSave.aseguradora,
                parent: categoria_,
                poliza_number:
                  $scope.caratula.poliza_number + " - INC. " + item.INCISO,
                natural: natural_,
                juridical: juridical_,
                ramo: $scope.caratula.ramo.id,
                subramo: $scope.caratula.subramo.id,
                paquete: item.PAQUETE,
                observations: "",
                old_policies: [],
                start_of_validity: inciso_start,
                end_of_validity: inciso_end,
                forma_de_pago: $scope.caratula.frecuencia_de_pago,
                status: status_,
                recibos_poliza: [],
                automobiles_policy: data_autos,
                damages_policy: [],
                accidents_policy: [],
                life_policy: [],
                document_type: 6,
                address: address_, // checar este
                // coverageInPolicy_policy: [], // checar si estas se agregan en el front o se agregarán en el back
                coverageInPolicy_policy: $scope.coberturas_paquete,
                endorsemeted: false,
                clave: $scope.caratula.clave.id,
                f_currency: $scope.caratula.f_currency == "Pesos" ? 1 : 2,
                identifier:
                  data_autos[0].brand +
                  "-" +
                  data_autos[0].model +
                  "-" +
                  data_autos[0].year,
                p_total: item.PRIMA_TOTAL,
                derecho: item.DERECHO ? item.DERECHO : 0,
                rpf: item.RPF ? item.RPF : 0,
                p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                iva: item.IVA ? item.IVA : 0,
                comision: item.COMISION ? item.COMISION : 0,
                contacto: item.CONTACTO,
              };
              // console.log('certData',certData)

              certificadosArray.push(certData);
            });

            return certificadosArray;
          } else if (
            $scope.caratula.ramo.ramo_code == 3 &&
            $scope.caratula.subramo.subramo_code != 9
          ) {
            // DAÑOS
            var danios_certs = [];

            data.forEach(function (item) {
              if (!item.CONTACTO) {
                item.CONTACTO = "";
              }

              if (item.PAQUETE) {
                item.PAQUETE = item.PAQUETE;
              }

              var data_danios = [
                {
                  insured_item: item.NOMBRE,
                  item_address:
                    item.CALLE +
                    " #" +
                    item.NUMERO +
                    " " +
                    item.COLONIA +
                    " " +
                    item.DELEGACION +
                    " " +
                    item.CIUDAD +
                    " " +
                    item.ESTADO +
                    " C.P." +
                    item.CP,
                  document_type: 6,
                },
              ];

              danios_certs.push(data_danios);

              if (item.CATEGORIA) {
                var categoria_ = parseInt(item.CATEGORIA);
              } else {
                var categoria_ = $scope.categoria_result.id;
              }

              if (item.SUBGRUPO) {
                for (var i = 0; i < $scope.order.subgroups.length; i++) {
                  var item_sub = $scope.order.subgroups[i];

                  if (item_sub.id == parseInt(item.SUBGRUPO)) {
                    if (item_sub.address) {
                      var address_ = item.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    } else {
                      var address_ = $scope.caratula.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    }
                  }
                }
              } else {
                var address_ = $scope.caratula.address;
                var natural_ = $scope.caratula.natural;
                var juridical_ = $scope.caratula.juridical;
              }

              if ($scope.caratula.status == "En trámite") {
                var status_ = 1;
              } else {
                var status_ = 14;
              }

              if ($scope.caratula.f_currency == "PESOS") {
                var f_currency_ = 1;
              } else {
                var f_currency_ = 2;
              }

              if ($scope.order.show.ot) {
                var status_ = 1;
              } else {
                var status_ = 14;
              }

              if ($scope.config_saved.length) {
                $scope.config_saved.forEach(function (i) {
                  if (i.id == item.PAQUETE) {
                    $scope.coberturas_paquete = i.coverage_package;
                    $scope.coberturas_paquete.forEach(function (j) {
                      if (
                        $scope.caratula.subramo.subramo_name == "Gastos Médicos"
                      ) {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                      } else {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                      }
                    });
                  }
                });
              }

              var inciso_start = new Date(toDate(item.INI_VIGENCIA));
              var inciso_end = new Date(toDate(item.FIN_VIGENCIA));

              var certData = {
                internalNumber: null,
                aseguradora: $scope.caratula.aseguradora.id,
                folio: null,
                caratula: $scope.caratula.id,
                certificate_number: parseInt(item.INCISO),
                parent: categoria_,
                poliza_number:
                  $scope.caratula.poliza_number + " - INC. " + item.INCISO,
                natural: natural_,
                juridical: juridical_,
                ramo: $scope.caratula.ramo.id,
                subramo: $scope.caratula.subramo.id,
                paquete: item.PAQUETE,
                observations: "",
                old_policies: [],
                start_of_validity: inciso_start,
                end_of_validity: inciso_end,
                forma_de_pago: $scope.caratula.frecuencia_de_pago,
                status: status_,
                recibos_poliza: [],
                automobiles_policy: [],
                damages_policy: data_danios,
                accidents_policy: [],
                life_policy: [],
                document_type: 6,
                address: address_, // checar este
                coverageInPolicy_policy: $scope.coberturas_paquete,
                endorsemeted: false,
                clave: $scope.caratula.clave.id,
                f_currency: f_currency_,
                identifier:
                  data_danios[0].insured_item +
                  "-" +
                  data_danios[0].item_addres,
                p_total: item.PRIMA_TOTAL,
                derecho: 0,
                rpf: 0,
                p_neta: 0,
                iva: 0,
                contacto: item.CONTACTO,
              };
              certificadosArray.push(certData);
            });

            return certificadosArray;
          } else {
            data.forEach(function (item) {
              var certificate = item.CERTIFICADO;
              if ($scope.caratula.subramo.subramo_name == "Vida") {
                if (item.TIPO == 2) {
                  var dataBeneficiary = {
                    certificate: certificate,
                    first_name: item.NOMBRE,
                    last_name: item.AP_PAT,
                    second_last_name: item.AP_MAT,
                    birthdate: new Date(toDate(item.FEC_NAC)),
                    sex: item.SEXO,
                    percentage: item.PORCENTAJE,
                    optional_relationship: item.PARENTESCO,
                    familia: item.CERT_GRAL,
                  };

                  if (item.ANTIGUEDAD) {
                    dataBeneficiary.antiguedad = toDate(
                      convertDate(item.ANTIGUEDAD)
                    );
                  }

                  beneficiaries_life.push(dataBeneficiary);
                }
              } else if ($scope.caratula.ramo.ramo_code == 2) {
                // Accidentes y enfermedades

                if (item.TIPO == 2) {
                  var dataBeneficiary = {
                    certificate: certificate,
                    first_name: item.NOMBRE,
                    last_name: item.AP_PAT,
                    second_last_name: item.AP_MAT,
                    birthdate: new Date(toDate(item.FEC_NAC)),
                    sex: item.SEXO,
                    clause: item.INCISO,
                    familia: item.CERT_GRAL,
                  };

                  if (item.ANTIGUEDAD) {
                    dataBeneficiary.antiguedad = new Date(
                      convertDate(item.ANTIGUEDAD)
                    );
                  }
                  beneficiaries_gm.push(dataBeneficiary);
                }
              }
            });

            data.forEach(function (elem) {
              var certificate = elem.CERTIFICADO;
              if ($scope.caratula.subramo.subramo_name == "Vida") {
                if (elem.TIPO == 1) {
                  if (elem.FUMADOR) {
                    if (elem.FUMADOR == 0) {
                      var smoker = false;
                    } else {
                      var smoker = true;
                    }
                  }
                  if (elem.ANTIGUEDAD) {
                    $scope.antig = toDate(convertDate(elem.ANTIGUEDAD));
                  } else {
                    $scope.antig = null;
                  }
                  var dataGM = [];
                  var dataVida = [
                    {
                      personal: {
                        certificate: certificate,
                        first_name: elem.NOMBRE,
                        last_name: elem.AP_PAT,
                        second_last_name: elem.AP_MAT,
                        birthdate: new Date(elem.FEC_NAC),
                        sex: elem.SEXO,
                        email: elem.EMAIL,
                        salary: parseInt(elem.SUELDO),
                        sum_assured: elem.SUMA_ASEGURADA
                          ? parseInt(elem.SUMA_ASEGURADA)
                          : 0,
                        antiguedad: $scope.antig,
                      },
                      smoker: smoker,
                      beneficiaries_life: [],
                    },
                  ];

                  beneficiaries_life.forEach(function (i) {
                    if (i.familia == elem.CERT_GRAL) {
                      dataVida[0].beneficiaries_life.push(i);
                    }
                  });
                  // life_data.push(dataVida);
                }
              } else if ($scope.caratula.ramo.ramo_code == 2) {
                if (elem.ANTIGUEDAD) {
                  $scope.antig = toDate(convertDate(elem.ANTIGUEDAD));
                } else {
                  $scope.antig = null;
                }
                if (elem.TIPO == 1) {
                  var dataVida = [];
                  var dataGM = [
                    {
                      personal: {
                        certificate: certificate,
                        first_name: elem.NOMBRE,
                        last_name: elem.AP_PAT,
                        second_last_name: elem.AP_MAT,
                        birthdate: new Date(toDate(elem.FEC_NAC)),
                        email: elem.EMAIL,
                        sex: elem.SEXO,
                        antiguedad: $scope.antig,
                      },
                      disease_type: 0,
                      relationship_accident: [],
                    },
                  ];

                  beneficiaries_gm.forEach(function (i) {
                    if (i.familia == elem.CERT_GRAL) {
                      dataGM[0].relationship_accident.push(i);
                    }
                  });
                  // gm_data.push(dataGM);
                }
              }
              if (elem.TIPO == 1) {
                if (elem.CATEGORIA) {
                  var categoria_ = parseInt(elem.CATEGORIA);
                } else {
                  var categoria_ = $scope.categoria_result.id;
                }

                if (!elem.CONTACTO) {
                  item.CONTACTO = "";
                }

                if (elem.SUBGRUPO) {
                  //// hacer for buscando coinicdencia con el id

                  for (var i = 0; i < $scope.order.subgroups.length; i++) {
                    var item = $scope.order.subgroups[i];

                    if (item.id == parseInt(elem.SUBGRUPO)) {
                      // console.log('ok');
                      if (item.address) {
                        var address_ = item.address;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      } else {
                        var address_ = null;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      }
                    }
                  }
                } else {
                  // checar si tiene adress, si no, ponerle la de la caratula

                  var address_ = $scope.caratula.address_;
                  var natural_ = $scope.caratula.natural;
                  var juridical_ = $scope.caratula.juridical;
                }

                if ($scope.config_saved.length) {
                  $scope.config_saved.forEach(function (i) {
                    // console.log('i----------',i)
                    if (i.id == elem.PAQUETE) {
                      // console.log('i', i);
                      $scope.coberturas_paquete = i.coveragesConfig;
                      $scope.coberturas_paquete.forEach(function (j) {
                        if (
                          $scope.caratula.subramo.subramo_name ==
                          "Gastos Médicos"
                        ) {
                          j.package = i.id;
                          j.sum_insured = j.sums_coverage[0].sum_insured;
                          j.deductible = j.deductible_coverage[0].deductible;
                          j.coinsurance = j.coinsurance_coverage[0].coinsurance;
                        } else {
                          j.package = i.id;
                          j.sum_insured = j.sums_coverage[0].sum_insured;
                          j.deductible = j.deductible_coverage[0].deductible;
                          j.coinsurance = 0;
                        }
                      });
                    }
                  });
                }

                var inciso_start = new Date(toDate(elem.INI_VIGENCIA));
                var inciso_end = new Date(toDate(elem.FIN_VIGENCIA));

                var certData = {
                  internalNumber: null,
                  folio: null,
                  caratula: $scope.caratula.id,
                  aseguradora: $scope.dataToSave.aseguradora,
                  certificate_number: parseInt(elem.CERTIFICADO),
                  parent: categoria_,
                  poliza_number:
                    $scope.caratula.poliza_number +
                    " - INC. " +
                    elem.CERTIFICADO,
                  natural: natural_,
                  juridical: juridical_,
                  ramo: $scope.caratula.ramo.id,
                  subramo: $scope.caratula.subramo.id,
                  paquete: elem.PAQUETE,
                  observations: elem.OBSERVATIONS,
                  old_policies: [],
                  forma_de_pago: $scope.caratula.frecuencia_de_pago,
                  status: par_status,
                  recibos_poliza: [],
                  automobiles_policy: [],
                  damages_policy: [],
                  accidents_policy: dataGM,
                  life_policy: dataVida,
                  document_type: 6,
                  address: address_, // checar este
                  // coverageInPolicy_policy: [], // checar si estas se agregan en el front o se agregarán en el back
                  coverageInPolicy_policy: $scope.coberturas_paquete,
                  endorsemeted: false,
                  clave: $scope.caratula.clave.id,
                  f_currency: $scope.caratula.f_currency == "Pesos" ? 1 : 2,
                  identifier: elem.IDENTIFICADOR,
                  p_total: elem.PRIMA_TOTAL,
                  derecho: 0,
                  rpf: 0,
                  p_neta: 0,
                  iva: 0,
                  start_of_validity: inciso_start,
                  end_of_validity: inciso_end,
                  contacto: elem.CONTACTO,
                };

                if (elem.ANTIGUEDAD) {
                  certData.rec_antiguedad = toDate(elem.ANTIGUEDAD);
                } else {
                  certData.rec_antiguedad = null;
                }
                life_data = [];

                certificadosArray.push(certData);
              }
            });

            return certificadosArray;
          }
        }
      }
    }
    function FileUploaderBD(param) {
      if ($scope.permiso_archivos) {
        if (param == 1) {
          $scope.filesCaratula = true;
          $timeout(function () {
            $http
              .get(url.IP + "polizas/" + $scope.caratula.id + "/archivos/")
              .then(function (response) {
                $scope.filesC = response.data.results;
              });
          }, 2000);
        } else if (param == 2) {
          // console.log ('subgrupo',$scope.subgroupId);
          $scope.filesSubgrupo = true;

          $timeout(function () {
            $http
              .get(url.IP + "polizas/" + $scope.subgroupId + "/archivos/")
              .then(function (response) {
                $scope.filesS = response.data.results;
                $scope.filesSubgrupo = false;
              });
          }, 3000);
        } else if (param == 3) {
          $scope.filesCategory = true;
          // console.log ('category',$scope.categoryId);
          $timeout(function () {
            $http
              .get(url.IP + "polizas/" + $scope.categoryId + "/archivos/")
              .then(function (response) {
                $scope.filesCat = response.data.results;
              });
          }, 3000);
        }
      }
    }
    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
      return dateObject;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    $scope.aseguradoraSelection = function () {
      // Nueva estructura
      // $scope.dataToSave.aseguradora = order.form.aseguradora.id;
      if ($scope.caratula.aseguradora) {
        get_claves();
      }

      $http
        .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
        .then(
          function success(response) {
            $scope.ramos = response.data;
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    $scope.changeVendedor = function (vendedor) {
      $scope.users.some(function (user) {
        if (vendedor == user.id) {
          // console.log(user)
          var vendedor_info = user.user_info.info_vendedor[0];
          if (vendedor_info.vendedor_subramos.length == 0) {
            SweetAlert.swal(
              "error",
              "El vendedor no tiene comisión en el subramo actual"
            );
            $scope.caratula.vendor = null;
            return;
          }

          var flag = false;
          var vendedor_flag = false;

          vendedor_info.vendedor_subramos.some(function (subramo, sub_index) {
            // console.log(subramo.provider, subramo.ramo, subramo.subramo)
            // console.log($scope.caratula.aseguradora.id, $scope.caratula.ramo.ramo_code, $scope.caratula.subramo.subramo_code)
            // console.log('--')
            if (
              (subramo.provider == $scope.caratula.aseguradora.id &&
                subramo.ramo == $scope.caratula.ramo.id &&
                subramo.subramo == $scope.caratula.subramo.id) ||
              (subramo.provider == $scope.caratula.aseguradora.id &&
                subramo.ramo == $scope.caratula.ramo.id &&
                subramo.subramo == 0) ||
              (subramo.provider == $scope.caratula.aseguradora.id &&
                subramo.ramo == 0 &&
                subramo.subramo == 0) ||
              (subramo.provider == 0 &&
                subramo.ramo == 0 &&
                subramo.subramo == 0) ||
              (subramo.provider == 0 &&
                subramo.ramo * -1 == $scope.caratula.ramo.ramo_code &&
                subramo.subramo * -1 == $scope.caratula.subramo.subramo_code)
            ) {
              vendedor_flag = true;
            }

            if (vendedor_info.vendedor_subramos.length == sub_index + 1) {
              if (!vendedor_flag) {
                SweetAlert.swal(
                  "Error",
                  "El vendedor no tiene comisión en el subramo actual",
                  "error"
                );
                $scope.caratula.vendor = $scope.original_vendor;
                return;
              }
            }
          });
        }
      });
    };

    $scope.changeRamo = function () {
      // $scope.dataToSave.ramo = order.form.ramo.id;
      if ($scope.caratula.ramo.ramo_code == 3) {
        $scope.autos = true;
        var subramos = [];
        if ($scope.caratula.ramo.subramo_ramo) {
          $scope.caratula.ramo.subramo_ramo.forEach(function (item) {
            if (item.subramo_code == 9) {
              subramos.push(item);
            }
          });
        } else if ($scope.caratula.ramo) {
          $http
            .get($scope.caratula.ramo.url)
            .then(
              function success(sub_ramo) {
                sub_ramo.data.subramo_ramo.forEach(function (item) {
                  if (item.subramo_code == 9) {
                    subramos.push(item);
                  }
                });
              },
              function error(e) {
                console.log("Error - subramos ramo", e);
              }
            )
            .catch(function (error) {
              console.log("Error - subramos-by-ramo - catch", error);
            });
        }

        $scope.subramos = subramos;
      } else if ($scope.caratula.ramo.ramo_code == 1) {
        $scope.vida = true;
        var subramos = [];
        if ($scope.caratula.ramo.subramo_ramo) {
          $scope.caratula.ramo.subramo_ramo.forEach(function (item) {
            if (item.subramo_code == 1) {
              subramos.push(item);
            }
          });
        } else if ($scope.caratula.ramo) {
          $http
            .get($scope.caratula.ramo.url)
            .then(
              function success(sub_ramo) {
                sub_ramo.data.subramo_ramo.forEach(function (item) {
                  if (item.subramo_code == 1) {
                    subramos.push(item);
                  }
                });
              },
              function error(e) {
                console.log("Error - subramos ramo", e);
              }
            )
            .catch(function (error) {
              console.log("Error - subramos-by-ramo - catch", error);
            });
        }

        $scope.subramos = subramos;
      } else if ($scope.caratula.ramo.ramo_code == 2) {
        $scope.vida = true;
        var subramos = [];
        if ($scope.caratula.ramo.subramo_ramo) {
          $scope.caratula.ramo.subramo_ramo.forEach(function (item) {
            if (item.subramo_code == 3) {
              subramos.push(item);
            }
          });
        } else if ($scope.caratula.ramo) {
          $http
            .get($scope.caratula.ramo.url)
            .then(
              function success(sub_ramo) {
                sub_ramo.data.subramo_ramo.forEach(function (item) {
                  if (item.subramo_code == 3) {
                    subramos.push(item);
                  }
                });
              },
              function error(e) {
                console.log("Error - subramos ramo", e);
              }
            )
            .catch(function (error) {
              console.log("Error - subramos-by-ramo - catch", error);
            });
        }

        $scope.subramos = subramos;
      } else {
        $scope.subramos = $scope.caratula.ramo.subramo_ramo;
      }
    };

    $scope.comisiones_poliza = [];
    function get_claves() {
      $http
        .get(url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                $scope.comisiones_poliza.push(item);
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });

            $scope.claves = clavesResponse.data;
            $scope.order.form.comisiones = $scope.comisiones_poliza;
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }

    // order.form.startDate = new Date();
    $scope.filesCaratula = false;
    $scope.show_contractor_list = true;
    $scope.saveFiles = function (param) {
      if (param == 1) {
        uploadFiles($scope.caratulaId);
        $scope.filesCaratula = false;
      }
    };
    $scope.hideFiles = function (param) {
      if (param == 1) {
        $scope.filesCaratula = false;
      }
    };
    $scope.showFiles = function (param) {
      // console.log('id',id)
      if (param == 1) {
        $scope.filesCaratula = true;
        // console.log('polizaId',$scope.caratulaId)
        $http
          .get(url.IP + "polizas/" + $scope.caratulaId + "/archivos/")
          .then(function (response) {
            $scope.filesC = response.data.results;
          });
      }
    };
    $scope.matchesContractors = function (parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = $scope.order.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var juridicals = response.data.juridicals;
                var naturals = response.data.naturals;

                if (juridicals.length) {
                  juridicals.forEach(function (item) {
                    var obj = {
                      label: item.j_name,
                      value: item,
                    };
                    source.push(obj);
                  });
                } else if (naturals.length) {
                  naturals.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }

                    source.push(obj);
                  });
                }

                $scope.contractors_data = source;
              }
            });
        }
      } else {
        $scope.contractors_data.length = 0;
      }
    };

    var new_coverage_data = [];

    $scope.selectPackage = function (parValue) {
      $scope.package = parValue;
      $scope.selectedPackage = true;
      new_coverage_data = parValue.coverage_package;
      $scope.coveragesPackage = parValue.coverage_package;
      $scope.configurations = [];

      $scope.master = {
        source: angular.copy(parValue.coverage_package),
        coveragesConfig: [],
      };

      $scope.config_coverages = angular.copy($scope.master);
    };
    var coverages_ = [];
    $scope.addCoverageToArray = function (param) {
      if (param.selected) {
        $scope.config_coverages.coveragesConfig.push(angular.copy(param));
      } else {
        $scope.config_coverages.coveragesConfig.forEach(function (
          item,
          index,
          object
        ) {
          if (param.id == item.id) {
            object.splice(index, 1);
          }
        });
      }
    };

    $scope.config_saved = [];

    $scope.saveConfiguration = function (parData) {
      var obj = {
        package_name: parData.package_name,
        policy: $scope.caratula.id,
        provider: $scope.caratula.aseguradora.url,
        ramo: $scope.caratula.ramo.url,
        coverage_package: parData.coveragesConfig,
        subramo: $scope.caratula.subramo.url,
        type_package: 2,
      };

      packageService
        .createPackage(obj)
        .then(
          function success(request) {
            // console.log('request.data',request)
            // SweetAlert.swal("¡Listo!","Paquete:"+request.package_name+"creado","success");
            var coverages_config = [];

            parData.coveragesConfig.forEach(function (item, index) {
              toaster.success("El paquete se ha guardado correctamete.");

              var covObj = {
                coverage_name: item.coverage_name,
                provider: $scope.caratula.aseguradora.url,
                package: request.url,
                deductible_coverage: [],
                sums_coverage: [],
                coinsurance_coverage: [],
                typeCoverage: 2,
              };

              if (!item.sumInPolicy && item.sums_coverage.length) {
                covObj.sums_coverage.push(item.sums_coverage[0]);
              } else {
                var test = {
                  coverage_sum: item.url,
                  default: true,
                  id: 0,
                  org: "",
                  sum_insured: item.sumInPolicy.value,
                  url: "",
                };
                covObj.sums_coverage.push(test);
              }

              if (!item.deductibleInPolicy && item.deductible_coverage.length) {
                covObj.deductible_coverage.push(item.deductible_coverage[0]);
              } else {
                if (item.deductibleInPolicy == undefined) {
                  var test = {
                    coverage_deductible: item.url,
                    default: true,
                    id: 0,
                    org: "",
                    deductible: "",
                    url: "",
                  };
                } else {
                  var test = {
                    coverage_deductible: item.url,
                    default: true,
                    id: 0,
                    org: "",
                    deductible: item.deductibleInPolicy.value,
                    url: "",
                  };
                }
                covObj.deductible_coverage.push(test);
              }
              if ($scope.caratula.subramo.subramo_name == "Gastos Médicos") {
                if (item.coinsurance_coverage) {
                  if (item.coinsuranceInPolicy == undefined) {
                    var test = {
                      coverage_coinsurance: item.url,
                      default: true,
                      id: 0,
                      org: "",
                      coinsurance: 0,
                      url: "",
                    };
                  } else {
                    var test = {
                      coverage_coinsurance: item.url,
                      default: true,
                      id: 0,
                      org: "",
                      coinsurance: item.coinsuranceInPolicy.value,
                      url: "",
                    };
                  }

                  covObj.coinsurance_coverage.push(test);
                }
              }
              coverageService
                .createCoverageConfig(covObj)
                .then(
                  function success(data) {
                    coverages_config.push(data);

                    if (parData.coveragesConfig.length == index + 1) {
                      // TODO: Eliminar del arreglo de configuraciones
                      $scope.configurations.splice(
                        $scope.configurations.indexOf(parData),
                        1
                      );
                      request.coveragesConfig = coverages_config;
                      request.source = new_coverage_data;
                      $scope.config_saved.push(request);

                      $scope.config_coverages = angular.copy($scope.master);

                      $scope.verCertificados = true;
                      $scope.showCertificado = true;
                    }
                  },
                  function error(error) {
                    console.log("error - createCoverage", error);
                    // TODO: Agregar alerta de confirmación
                  }
                )
                .catch(function (e) {
                  console.log("error - createCoverage - catch", e);
                  // TODO: Agregar alerta de confirmación
                });
            });

            // asignar ID en la vista
          },
          function error(error) {
            console.log("error - createPackage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createPackage - catch", e);
        });
    };

    $scope.selectSubgroup = function (parData) {
      $scope.subgrupoResult = parData;
    };

    $scope.selectContractor = function () {
      $scope.show_contractor_list = true;
    };

    $scope.sub_group = [];

    $scope.saveSubgroup = function (parValue) {
      if (parValue == NOT_GROUP) {
        var name = "Default";
        var observations = "";
        var name = "Default";
        var observations = "";
        $scope.dataToSave.receipts = [];
        $scope.dataToSave.poliza = {
          iva: 0,
          p_total: 0,
          derecho: 0,
          rpf: 0,
          p_neta: 0,
        };
      } else if (parValue == ADD) {
        if (!$scope.receits_on_cover) {
          var natural = $scope.subgroup.contratante.natural;
          var juridical = $scope.subgroup.contratante.juridical;
        } else {
          var natural = null;
          var juridical = null;
          $scope.order.receipts = [];
        }

        if (!$scope.subgroup.name) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORSUBGROUP, "error");
          return;
        }

        var observations = $scope.subgroup.observations;
        var name = $scope.subgroup.name;
      }

      if (!$scope.order.poliza) {
        $scope.order.poliza = {
          p_total: 0,
          derecho: 0,
          rpf: 0,
          p_neta: 0,
          iva: 0,
        };
      }

      if ($scope.order.receipts) {
        $scope.order.receipts.forEach(function (recibo) {
          var receipt_init = new Date(
            datesFactory.toDate(recibo.startDate)
          ).setHours(11, 59, 59);
          var receipt_end = new Date(
            datesFactory.toDate(recibo.endingDate)
          ).setHours(12, 0, 0);
          // var vencimiento = new Date(datesFactory.toDate(recibo.vencimiento)).setHours(12,0,0);

          recibo.fecha_fin = new Date(receipt_init);
          recibo.fecha_inicio = new Date(receipt_end);
          recibo.startDate = new Date(receipt_init);
          recibo.endingDate = new Date(receipt_end);
          // recibo.vencimiento = new Date(vencimiento);

          if (recibo.vencimiento) {
            var vencimiento = new Date(
              datesFactory.toDate(recibo.vencimiento)
            ).setHours(11.59, 59, 0);
            recibo.vencimiento = new Date(vencimiento);
          }

          if ($scope.domiciliado) {
            recibo.is_cat = true;
          } else {
            recibo.is_cat = false;
          }
        });
      } else {
        $scope.order.receipts = [];
      }

      var data = {
        natural: natural,
        juridical: juridical,
        observations: observations,
        p_total: $scope.order.poliza.p_total,
        derecho: $scope.order.poliza.derecho ? $scope.order.poliza.derecho : 0,
        rpf: $scope.order.poliza.rpf ? $scope.order.poliza.rpf : 0,
        p_neta: $scope.order.poliza.p_neta,
        iva: $scope.order.poliza.iva,
        name: name,
        recibos_poliza: $scope.order.receipts,
        coverageInPolicy_policy: [],
        parent: $scope.caratula.id,
        caratula: $scope.caratula.id,
        document_type: 4, // SUBGRUPO
      };

      $scope.showReceipts = false;

      $http
        .post(url.IP + "subgrupos/", data)
        .then(
          function success(request) {
            if (request.status === 201) {
              $scope.editedReceipts = false;
              $scope.show_cat_again = true;

              if (data.name !== DEFAULT) {
                $scope.sub_group.push(request.data);
                toaster.success("El subgrupo se ha guardado correctamente");
              }

              $scope.subgrupoResult = request.data;
              $scope.order.subgroups.push(request.data);
              uploadFiles(request.data.id);
              $scope.order.receipts = [];
              $scope.order.poliza = {};
              $scope.subgroup = {};
              $scope.dataToSave.receipts = [];
              $scope.dataToSave.poliza = {};
              $scope.tree_subs = treeIdsStructure();

              var params = {
                model: 18,
                event: "POST",
                associated_id: $scope.caratula.id,
                identifier: "creó el subgrupo " + request.data.name + ".",
              };

              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }
          },
          function error(error) {
            console.log("error - saveSubgrupo", error);
          }
        )
        .catch(function (e) {
          console.log("error - saveSubgrupo - catch", e);
        });
    };

    $scope.saveCategory = function (parValue) {
      if (parValue == NOT_CATEGORY) {
        var cat_observations = "";
        var cat_name = DEFAULT;
        var cat_hospital_level = "";
        // $scope.verCategoria = false;
      } else if (parValue == ADD) {
        var cat_observations = $scope.category.observations;
        var cat_name = $scope.category.name;
        var cat_hospital_level = $scope.category.hospital_level;
        $scope.verCategoria = true;
      } else if (parValue == NEXT) {
        $scope.showCategoria = false;
        // Al success de crear categoria default
        // $scope.verCertificados = true;
        // $scope.showCertificado = true;
        $scope.verPaquetes = true;

        return;
      }

      var data = {
        observations: cat_observations,
        name: cat_name,
        parent: $scope.subgrupoResult.url,
        hospital_level: cat_hospital_level,
        caratula: $scope.caratula.id,
        document_type: 5, // 5: categoría
      };

      $http
        .post(url.IP + "categories/", data)
        .then(
          function success(request) {
            if (request.status === 201) {
              $scope.show_cat_again = false;
              $scope.not_category = false;

              if (data.name !== DEFAULT) {
                toaster.success("La categoría se ha guardado correctamete");
              }

              $scope.order.categories.push(request.data);
              $scope.categoria_result = request.data;
              $scope.categoryId = $scope.categoria_result.id;

              $scope.tree_subs = treeIdsStructure(1);

              uploadFiles($scope.categoryId);

              if (parValue == NOT_CATEGORY) {
                $scope.verPaquetes = true;
                $scope.showPaquetes = true;
              }

              $scope.category = {};

              var params = {
                model: 18,
                event: "POST",
                associated_id: $scope.caratula.id,
                identifier:
                  "creó la categoría " +
                  request.data.name +
                  " en el subgrupo " +
                  $scope.subgrupoResult.name +
                  ".",
              };

              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }
          },
          function error(error) {
            console.log("error - category", error);
          }
        )
        .catch(function (e) {
          console.log("error - category - catch", e);
        });
    };

    $rootScope.editTable = function () {
      if ($rootScope.showInput == false) {
        $rootScope.showInput = true;
      } else {
        $rootScope.showInput = false;
      }
    };

    $scope.calculate = function (poliza) {
      if ($scope.editedReceipts) {
        return;
      }

      $scope.order.receipts = [];
      $scope.order.poliza = poliza;
      if (!poliza.derecho) {
        poliza.derecho = 0;
      }

      if (!poliza.rpf) {
        poliza.rpf = 0;
      }

      var prima_neta = parseFloat(poliza.primaNeta);
      var derecho = parseFloat(poliza.derecho);
      var rpf = parseFloat(poliza.rpf);

      $scope.dataToSave.p_neta = prima_neta;
      $scope.dataToSave.derecho = derecho;
      $scope.dataToSave.rpf = rpf;

      var IVA = 0;
      var TOTAL_IVA = 1;

      if ($scope.order.poliza.ivaStatus) {
        IVA = 16;
        $scope.order.poliza.iva = 16;
        TOTAL_IVA = 1.16;
        var pointIva = 0.16;
      } else {
        IVA = 0;
        $scope.order.poliza.iva = 0;
        var pointIva = 0;
      }

      $scope.dataToSave.iva = IVA;

      // console.log('$scope.order.form.payment', $scope.order.form.payment);

      if (!$scope.order.form.payment) {
        toaster.info(MESSAGES.ERROR.SELPAY);
      } else {
        // TODO: checar esta función
        function getNumber(num) {
          // console.log('num', num)
          var num2 = Math.ceil(num);
          return new Array(num2);
        }

        function getSubtotal(poliza) {
          var sum = prima_neta + rpf + derecho;
          return Number(sum.toFixed(2));
        }

        function getTotal(poliza) {
          $scope.dataToSave.p_total = poliza.subTotal * TOTAL_IVA;
          return p(oliza.subTotal * TOTAL_IVA).toFixed(2);
        }

        function getIva(parValue) {
          var iva = parValue * pointIva;
          return parseFloat(iva);
        }

        function comissionCalc(parPneta) {
          // var p_neta_ = parseFloat(parPneta);
          var p_neta_ = parPneta;

          if ($scope.order.form.comision) {
            var comision_ =
              parseFloat($scope.order.form.comision.comission) / 100;
          } else {
            var comision_ = 0;
          }

          var result = parseFloat(p_neta_ * comision_).toFixed(2);
          return result;
        }
        $scope.order.receipts = [];
        $scope.order.defaults = { showReceipts: true };
        $scope.order.defaults.showReceipts = true;
        var initDate = new Date(
          new Date($scope.order.form.startDate).setHours(12, 0, 0, 0)
        );
        var endDate = new Date(
          new Date($scope.order.form.endingDate).setHours(11, 59, 59, 0)
        );

        // console.log('fomr', order.form);
        // console.log('endDate', endDate);
        var months = helpers.monthDiff(initDate, endDate);
        // Calculate diff between dates
        var dateDiff = moment(endDate).diff(moment(initDate), "days");
        var amountReceipts = ($scope.order.amountReceipts =
          months / $scope.order.form.payment);
        // console.log('amountReceipts', amountReceipts);
        //Calculate poliza results
        $scope.order.poliza.subTotal = getSubtotal($scope.order.poliza);
        $scope.order.poliza.primaTotal = getTotal($scope.order.poliza);
        $scope.order.poliza.iva = getIva($scope.order.poliza.subTotal);
        amountReceipts = Math.ceil(amountReceipts);
        var arrayLen = getNumber(amountReceipts);
        // Logic from vm
        var obj = {
          prima: $scope.order.poliza.primaNeta / amountReceipts,
          rpf: $scope.order.poliza.rpf / amountReceipts,
          derecho: $scope.order.poliza.derecho / amountReceipts,
          iva: $scope.order.poliza.iva,
          subTotal: $scope.order.poliza.subTotal / amountReceipts,
          primaTotal: $scope.order.poliza.primaTotal / amountReceipts,
        };
        for (var i = 0; i < arrayLen.length; i++) {
          // Check options
          if ($scope.order.configDerecho) {
            if (i === 0) {
              if ($scope.order.poliza.derecho) {
                obj.derecho = parseFloat($scope.order.poliza.derecho);
              } else {
                obj.derecho = 0;
              }
            } else {
              obj.derecho = 0;
            }
          }

          if ($scope.order.configRPF) {
            if (i === 0) {
              if (obj.rpf) {
                obj.rpf = parseFloat($scope.order.poliza.rpf);
              } else {
                obj.rpf = 0;
              }
            } else {
              obj.rpf = 0;
            }
          }

          endDate = new Date(
            new Date(
              moment(initDate).add($scope.order.form.payment.value, "months")
            ).setHours(11, 59, 59, 0)
          );
          var subTotal = obj.prima + obj.rpf + obj.derecho;

          var receipt = {
            recibo_numero: i + 1,
            prima_neta: parseFloat(obj.prima.toFixed(2)),
            prima: parseFloat(obj.prima.toFixed(2)),
            rpf: parseFloat(obj.rpf.toFixed(2)),
            derecho: parseFloat(obj.derecho.toFixed(2)),
            iva: getIva(subTotal).toFixed(2),
            subTotal: parseFloat(subTotal.toFixed(2)),
            prima_total: parseFloat((subTotal * 1.16).toFixed(2)),
            total: parseFloat((subTotal * 1.16).toFixed(2)),
            comision: comissionCalc(parseFloat(obj.prima.toFixed(2))),
            receipt_type: 1,
          };
          $scope.iva_currency = receipt.subTotal * 0.16;
          if (dateDiff === 364 || dateDiff === 365 || dateDiff === 366) {
            receipt.fecha_inicio = new Date(initDate.setHours(12, 0, 0, 0));
            receipt.startDate = new Date(initDate.setHours(12, 0, 0, 0));
            receipt.endingDate = endDate;
            receipt.fecha_fin = endDate;
          } else {
            receipt.startDate = "";
            receipt.endingDate = "";
            receipt.fecha_inicio = "";
            receipt.fecha_fin = "";
          }
          initDate = endDate;

          $scope.order.receipts.push(angular.copy(receipt));
          $scope.order.receipts.push(angular.copy(receipt));
          $scope.dataToSave.recibos_poliza = $scope.order.receipts;
          $scope.dataToSave.receipts = $scope.order.receipts;
        }
      }
    };

    function treeIdsStructure(param) {
      $scope.verCertificados = true;

      var tree_ids = [];
      $scope.order.subgroups.forEach(function (sub) {
        if (sub.name !== DEFAULT) {
          if (!param) {
            $scope.sub_group.push(sub);
          }

          var element = {};
          element.data = sub;
          element.text = sub.id + ": " + sub.name;
          element.nodes = [];

          $scope.order.categories.forEach(function (category) {
            if (sub.url == category.parent) {
              if (category.name !== DEFAULT) {
                element.nodes.push({
                  text: category.id + ": " + category.name,
                });
              }
            }
          });

          tree_ids.push(element);
        } else {
          $scope.order.categories.forEach(function (category) {
            var element = {
              text: category.id + ": " + category.name,
            };
            tree_ids.push(element);
          });
        }
      });

      $("#tree_ids").treeview({ data: tree_ids });
      return tree_ids;
    }
    // $scope.order.form.contratante = {}
    // $scope.order.form.contratante.value = $scope.caratula.natural ? $scope.caratula.natural : $scope.caratula.juridical;
    $scope.$watch(
      "order.form.contratante.value",
      function (newValue, oldValue) {
        if ($scope.order.form.contratante) {
          // $scope.users.some(function(user) {
          // if (user.url == $scope.order.form.contratante.value.value.vendor){
          //     // $scope.order.form.vendor = user;
          //   }
          // })

          if ($scope.order.form.contratante.value.address_natural) {
            $scope.order.defaults.address =
              $scope.order.form.contratante.value.address_natural;
          } else {
            $scope.order.defaults.address =
              $scope.order.form.contratante.value.address_juridical;
          }

          if ($scope.order.form.contratante.value.phone_number) {
            $scope.order.form.contratante.phone_number =
              $scope.order.form.contratante.value.phone_number;
          }

          try {
            if ($scope.order.defaults.address.length == 1) {
              $scope.order.form.address = $scope.order.defaults.address[0];
            }
          } catch (err) {}

          if ($scope.order.form.contratante.value.email) {
            $scope.order.form.contratante.email =
              $scope.order.form.contratante.value.email;
          }
        }
      }
    );

    $scope.$watch("subgroup.contratante.value", function (newValue, oldValue) {
      if ($scope.subgroup.contratante) {
        $scope.subgroup.contratante.address_all = [];

        if ($scope.subgroup.contratante.value.address_natural) {
          $scope.subgroup.contratante.address_all =
            $scope.subgroup.contratante.value.address_natural;
        } else {
          $scope.subgroup.contratante.address_all =
            $scope.subgroup.contratante.value.address_juridical;
        }

        if ($scope.subgroup.contratante.value.j_name) {
          $scope.subgroup.contratante.val =
            $scope.subgroup.contratante.value.j_name;
        }

        if ($scope.subgroup.contratante.value.full_name) {
          $scope.subgroup.contratante.val =
            $scope.subgroup.contratante.value.full_name;
        }

        if ($scope.subgroup.contratante.value.phone_number) {
          $scope.subgroup.contratante.phone_number =
            $scope.subgroup.contratante.value.phone_number;
        }

        if ($scope.subgroup.contratante.value.email) {
          $scope.subgroup.contratante.email =
            $scope.subgroup.contratante.value.email;
        }

        try {
          if ($scope.subgroup.contratante.address_all.length == 1) {
            $scope.subgroup.contratante.address =
              $scope.subgroup.contratante.address_all[0];
          }
        } catch (err) {
          console.log("exception", err);
        }
      }
    });
    // Upload files
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    uploader.filters.push({
      name: "customFilter",
      fn: function (item /*{File|FileLikeObject}*/, options) {
        //jshint ignore:line
        return this.queue.length < 20;
      },
    });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
      // if ($uibModalInstance) {
      //     $uibModalInstance.dismiss('cancel');
      // }
      // $timeout(function() {
      //      // $state.go('polizas.table');
      // }, 1000);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      // console.log('uploader',uploader);
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      fileItem.removeAfterUpload = true;
    };
    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      // console.log('before');
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };
    // Calculadora comision referenciador
    $scope.calculateComision = function (ref, index) {
      $rootScope.comVendedor = true;
      $scope.orderInfo = $scope.order;
      $localStorage.orderForm = JSON.stringify($scope.order.form);
      var modalInstance = $uibModal.open({
        templateUrl: "app/ordenes/calculateComision.modal.html",
        controller: OrderComisionCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          referenciador: function () {
            return ref;
          },
          index: function () {
            return index;
          },
          form: function () {
            return $scope.order.form;
          },
          from: function () {
            return null;
          },
          primaTotal: function () {
            return $scope.order.poliza.primaTotal;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };
    // Calcular comisión ppor referenciador
    function OrderComisionCtrl(
      $scope,
      from,
      $sessionStorage,
      $uibModalInstance,
      referenciador,
      index,
      form,
      $http,
      MESSAGES,
      toaster,
      primaTotal
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $rootScope.valueMonto = primaTotal;
      $rootScope.valueComInicial = 0;
      $rootScope.valueComision = 0;
      if (referenciador) {
        $http.get(referenciador.referenciador).then(function (data) {
          if (data.status == 200 || data.status == 201) {
            if (data.data) {
              $rootScope.name =
                data.data.first_name + " " + data.data.last_name;
              if (data.data.user_info) {
                if (data.data.user_info.info_vendedor[0]) {
                  $rootScope.valueGo =
                    data.data.user_info.info_vendedor[0].gastos_operacion;
                }
              }
            }
          }
        });
      }
      // Change monto --> calc comision
      $scope.changeMonto = function (go, monto, com, comI) {
        if (isNaN(monto)) {
          var toNumber = $scope.formatearNumero(monto);
          if (isNaN(toNumber)) {
            $rootScope.valueMonto = "";
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        }
      };
      $scope.comCalculatePeso = function (monto, comision) {
        if (
          isNaN(monto) ||
          isNaN(comision) ||
          parseFloat(comision) > parseFloat(monto)
        ) {
          if (parseFloat(comision) > parseFloat(monto)) {
            SweetAlert.swal(
              "Error",
              "Cantidad capturada en comisión no puede ser mayor a la prima total",
              "error"
            );
            $rootScope.valueComision = 0;
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        } else {
          $rootScope.valueComision = parseFloat(
            (parseFloat(comision) * 100) / parseFloat(monto)
          ).toFixed(2);
        }
      };
      $scope.validComision = function (comI) {
        if (isNaN(comI)) {
          $rootScope.valueComInicial = 0;
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
        }
      };
      $scope.cTotal = function (monto, com, comVendedor) {
        referenciador.comision_vendedor = comVendedor;
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.cancelCalculate = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
      $scope.formatearNumero = function (nStr) {
        nStr += "";
        var x = nStr.split(".");
        var x1 = x[0];
        var x2 = x.length > 1 ? "." + x[1] : "";
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + "," + "$2");
        }

        return x1 + x2;
      };
    }
    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.checkNumPolicy = function () {
      if ($scope.caratula.poliza_number) {
        // helpers.existPolicy(order.form.poliza)
        helpers
          .existPolicyNumber($scope.caratula.poliza_number)
          .then(function (request) {
            if (request == true) {
              SweetAlert.swal("Error", MESSAGES.ERROR.POLICYEXIST, "error");
              // toaster.warning('El número de póliza ya existe.');
              $scope.caratula.poliza_number = "";
              $scope.order.form.poliza = "";
            }
          })
          .catch(function (err) {});
      }
    };
  }
})();

/* global angular */
(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ColectividadesCtrl", ColectividadesCtrl);

  ColectividadesCtrl.$inject = [
    "$parse",
    "insuranceService",
    "$scope",
    "$rootScope",
    "FileUploader",
    "ContratanteService",
    "$sessionStorage",
    "providerService",
    "$http",
    "url",
    "payform",
    "$localStorage",
    "$uibModal",
    "packageService",
    "coverageService",

    "toaster",
    "helpers",
    "MESSAGES",
    "$controller",
    "$state",
    "dataFactory",
    "SweetAlert",
    "datesFactory",
    "$stateParams",
    "$timeout",
    "$uibModalInstance",
    "formatValues",
    "emailService",
  ];

  function ColectividadesCtrl(
    $parse,
    insuranceService,
    $scope,
    $rootScope,
    FileUploader,
    ContratanteService,
    $sessionStorage,
    providerService,
    $http,
    url,
    payform,
    $localStorage,
    $uibModal,
    packageService,
    coverageService,
    toaster,
    helpers,
    MESSAGES,
    $controller,
    $state,
    dataFactory,
    SweetAlert,
    datesFactory,
    $stateParams,
    $timeout,
    $uibModalInstance,
    formatValues,
    emailService
  ) {
    var order = this;
    order.showButtonPoliza = showButtonPoliza;
    order.hideButtonOT = hideButtonOT;
    order.hidden = true;
    order.defaults = {
      payform: angular.copy(payform),
    };
    order.form = {};
    order.contador = 0;
    order.subgroups = [];
    order.categories = [];
    $scope.renewalColect == false;
    $scope.exist_subgroup = false;
    $scope.create_natural = true;
    $scope.create_juridical = true;
    // Defaults
    order.show = {
      ot: true,
      receipt: false,
      generateReceipts: false,
      receiptsGenerated: false,
      firstTab: true,
      showForms: false,
      showCoverages: false,
    };
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };
    $scope.create_natural = true;
    $scope.create_juridical = true;
    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          order.acceso_polizas = perm;
          order.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                order.acceso_adm_pol = true;
              } else {
                order.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                order.acceso_ver_pol = true;
              } else {
                order.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          order.acceso_form = perm;
          order.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                order.acceso_form = true;
              } else {
                order.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          order.coms = perm;
          order.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                order.permiso_comisiones = true;
              } else {
                order.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    if (!order.acceso_adm_ot && order.acceso_adm_pol) {
      order.show = {
        ot: false,
        receipt: true,
        generateReceipts: true,
        receiptsGenerated: true,
        firstTab: true,
        showForms: true,
        showCoverages: true,
      };
    }

    order.renewal = {};
    order.renewal.is_renewable = 1;
    order.renewal.options = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.fake_ramos = [
      {
        id: -1,
        ramo_code: -1,
        ramo_name: "Vida",
        subramo_ramo: [
          {
            id: -1,
            subramo_code: -1,
            subramo_name: "Vida",
          },
        ],
      },
      {
        id: -2,
        ramo_code: -2,
        ramo_name: "Accidentes y Enfermedades",
        subramo_ramo: [
          {
            id: -2,
            subramo_code: -2,
            subramo_name: "Accidentes Personales",
          },
          {
            id: -3,
            subramo_code: -3,
            subramo_name: "Gastos Médicos",
          },
          {
            id: -4,
            subramo_code: -4,
            subramo_name: "Salud",
          },
        ],
      },
      {
        id: -3,
        ramo_code: -3,
        ramo_name: "Daños",
        subramo_ramo: [
          {
            id: -5,
            subramo_code: -5,
            subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
          },
          {
            id: -6,
            subramo_code: -6,
            subramo_name: "Marítimo y Transportes",
          },
          {
            id: -7,
            subramo_code: -7,
            subramo_name: "Incendio",
          },
          {
            id: -8,
            subramo_code: -8,
            subramo_name: "Agrícola y de Animales",
          },
          {
            id: -9,
            subramo_code: -9,
            subramo_name: "Automóviles",
          },
          {
            id: -10,
            subramo_code: -10,
            subramo_name: "Crédito",
          },
          {
            id: -11,
            subramo_code: -11,
            subramo_name: "Crédito a la Vivienda",
          },
          {
            id: -12,
            subramo_code: -12,
            subramo_name: "Garantía Financiera",
          },
          {
            id: -13,
            subramo_code: -13,
            subramo_name: "Diversos",
          },
          {
            id: -14,
            subramo_code: -14,
            subramo_name: "Terremoto y Otros Riesgos Catastróficos",
          },
        ],
      },
    ];

    $scope.domiciliado = false;
    $scope.changeDomiciliado = function () {
      $scope.change_domiciliado = true;
      if (order.form.domiciliado == "true" || order.form.domiciliado == true) {
        $scope.domiciliado = true;
      } else {
        $scope.domiciliado = false;
      }
    };

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };
    getInternalNumber();
    getSucursales();
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    // var endingDate = (curr_year + 1) + "-" + curr_month + "-" + curr_date;

    var DEFAULT = "Default";
    var ADD = "add";
    var NEXT = "next";
    var NOT_GROUP = "notGroup";
    var NOT_CATEGORY = "notCategory";
    var NEXT_RECEIPTS = "nextReceipts";

    // order.form.endingDate = new Date(endingDate);

    var startDate = datesFactory.convertDate(new Date());
    var endingDate = datesFactory.convertDate(
      new Date().setYear(new Date().getFullYear() + 1)
    );

    order.form.startDate = startDate;
    order.form.endingDate = endingDate;
    order.form.vendor = "";

    var d = new Date();
    var curr_date = d.getDate();
    var curr_month = d.getMonth() + 1; //Months are zero based
    var curr_year = d.getFullYear();
    var date = curr_year + "-" + curr_month + "-" + curr_date;

    // $scope.dataToSave.start_of_validity = new Date(datesFactory.mesDiaAnio(startDate));
    // $scope.dataToSave.end_of_validity = new Date(datesFactory.mesDiaAnio(endingDate));

    $scope.showContent = true;
    $scope.selectContractor = true;
    $scope.show_receipts = true;
    $scope.caratulaSaved = false;
    $scope.selectedPagkage = false;
    $scope.showNewCoverage = false;
    $scope.showReceipts = false;
    $scope.caratula_receipts = false;
    $rootScope.show_contractor = false;
    $scope.verSubgrupo = false;
    $scope.newPackage = false;
    $scope.dataToSave = {};
    $scope.excelFile = {};
    $scope.subgroup = {};
    $scope.subgroup.vendor = "";
    $scope.category = {};
    $scope.coverageName = "";
    $scope.coverages = [];
    $scope.configurations = [];
    $scope.coveragesPackage = [];
    $scope.coveragesConfig = [];

    $scope.seller = [];
    $scope.isSeller = [];

    $scope.pay_ways = [
      { key: 1, val: "Clabe" },
      { key: 2, val: "Número de cuenta" },
      { key: 3, val: "Número de tarjeta" },
      { key: 4, val: "Efectivo" },
    ];

    $scope.fcs = [
      { key: 1, val: "Semanal" },
      { key: 2, val: "Quincenal" },
      { key: 3, val: "Mensual" },
    ];

    $scope.delete_subramos = [];
    $scope.delete_phones = [];

    order.subramo = {
      ramos: "",
      sub_ramos: "",
      provider: "",
      ramo: "",
      subramo: "",
      comision_percentage: "",
    };
    $scope.referenciadores = [];
    $http.get(url.IP + "usuarios/").then(function (user) {
      $scope.users = user.data.results;
      $scope.ejecutivos = user.data.results;

      $scope.show_pagination = true;
      $scope.config_pagination = {
        count: user.data.count,
        next: user.data.next,
        previous: user.data.previous,
      };

      $scope.testPagination("users", "config_pagination");

      $scope.users.forEach(function (user) {
        user["phones"] = [];
        user["subramos"] = [];
      });
    });
    $http.get(url.IP + "get-vendors/").then(function (user) {
      $scope.users_ref = user.data;
      $scope.referenciador = user.data;
      $scope.referenciadores.push($scope.referenciador);
    });

    providerService.getReadListProviders().then(function (provider) {
      $scope.aseguradoras = provider;
    });
    /*
  Vendedores --- function implement
*/

    $scope.addNewSubramo = function () {
      $scope.show_new_sub = true;
      $scope.create_sub = true;
    };
    $scope.addPhone = function (index) {
      if ($scope.users[index].phones) {
        $scope.users[index].phones.push("");
      } else {
        $scope.users[index].phones = [""];
      }
    };

    $scope.deletePhone = function (index, index2) {
      $scope.delete_phones.push($scope.users[index].phones.index2);
      $scope.users[index].phones.splice(index2, 1);
    };

    $scope.changeRamoVendedor = function (sub_ramo) {
      if (!sub_ramo.ramo) {
        $scope.subramos = [];
        sub_ramo.sub_ramos = [];
        return;
      }

      sub_ramo.sub_ramos = sub_ramo.ramo.subramo_ramo;
    };
    $scope.percentageRange = function (input, index) {
      if (input < 0) {
        $scope.config_coverages.coveragesConfig[
          index
        ].coinsuranceInPolicy.value = 0;
      }
      if (input > 100) {
        $scope.config_coverages.coveragesConfig[
          index
        ].coinsuranceInPolicy.value = 100;
      }
    };

    $scope.percentageRange1 = function (input, index) {
      if (input < 0) {
        $scope.config_coverages.coveragesConfig[
          index
        ].topeCoinsuranceInPolicy.value = 0;
      }
      if (input > 100) {
        $scope.config_coverages.coveragesConfig[
          index
        ].topeCoinsuranceInPolicy.value = 100;
      }
    };

    $scope.addSubramo = function (index) {
      if ($scope.users[index].subramos) {
        $scope.users[index].subramos.push({ ramos: $scope.fake_ramos });
      } else {
        $scope.users[index].subramos = [{}];
      }
    };

    function fillProvider() {
      var d = order.form.startDate;
      try {
        var curr_date = d.getDate();
        var curr_month = d.getMonth() + 1; //Months are zero based
        var curr_year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var curr_date = f.getDate();
        var curr_month = f.getMonth() + 1; //Months are zero based
        var curr_year = f.getFullYear();
      }

      var date = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(date).then(
        function success(data) {
          order.defaults.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      // console.log('pages', pages);

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
          } else {
            if (config_.previous.search("&page=") !== -1) {
              var url = config_.previous.substring(
                0,
                config_.previous.indexOf("&page=") + 6
              );
              url += parPage.toString();
            } else {
              var url = config_.previous;
            }
          }
        }

        // url += '&status=1'
        getProviders(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getProviders(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    $scope.addReferenciador = function (type) {
      var addReferenciadores = {
        referenciador: $scope.referenciador,
      };
      $scope.referenciadores.push(addReferenciadores);
    };
    $scope.changeReferenciador = function (ref, index) {
      if (ref.referenciador) {
        ref.selectedRef = true;
      } else {
        ref.selectedRef = false;
      }
    };
    $scope.changeComRef = function (com) {};
    $scope.deleteReferenciador = function (index, type) {
      $scope.referenciadores.splice(index, 1);
    };

    $scope.deleteSubramo = function (index_main, index_sub, data) {
      $scope.delete_subramos.push(data.subramos[index_sub]);
      data.subramos.splice(index_sub, 1);
    };

    $scope.changeVendedor_policy = function (vendedor) {
      $scope.users.some(function (user) {
        if (vendedor == user.id) {
          // console.log(user)
          var vendedor_info = user.user_info.info_vendedor[0];
          if (vendedor_info.vendedor_subramos.length == 0) {
            SweetAlert.swal(
              "error",
              "El vendedor no tiene comisión en el subramo actual"
            );
            order.form.vendor = null;
            return;
          }

          var flag = false;
          var vendedor_flag = false;

          vendedor_info.vendedor_subramos.some(function (subramo, sub_index) {
            // console.log(subramo.provider, subramo.ramo, subramo.subramo)
            // console.log(order.form.aseguradora.id, order.form.ramo.ramo_code, order.form.subramo.subramo_code)
            // console.log('--')
            if (
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == order.form.ramo.id &&
                subramo.subramo == order.form.subramo.id) ||
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == order.form.ramo.id &&
                subramo.subramo == 0) ||
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == 0 &&
                subramo.subramo == 0) ||
              (subramo.provider == 0 &&
                subramo.ramo == 0 &&
                subramo.subramo == 0) ||
              (subramo.provider == 0 &&
                subramo.ramo * -1 == order.form.ramo.ramo_code &&
                subramo.subramo * -1 == order.form.subramo.subramo_code)
            ) {
              vendedor_flag = true;
            }

            if (vendedor_info.vendedor_subramos.length == sub_index + 1) {
              if (!vendedor_flag) {
                SweetAlert.swal(
                  "Error",
                  "El vendedor no tiene comisión en el subramo actual",
                  "error"
                );
                order.form.vendor = $scope.original_vendor;
                return;
              }
            }
          });
        }
      });
    };

    $scope.checkSelected = function (value, parUser) {
      if (value) {
        $http.get(url.IP + "bancos/").then(function (bank) {
          $scope.banks = bank.data;

          if (parUser.user_info) {
            if (parUser.user_info.is_vendedor) {
              var seller_data = parUser.user_info.info_vendedor[0];
              $scope.original_data = vendedorStructure(parUser, seller_data);
            }
          } else {
            parUser.hired_date = datesFactory.convertDate(new Date());
          }
        });
      } else {
        $scope.users.forEach(function (user) {
          if (parUser.id == user.id) {
            user["phones"] = [];
            user["subramos"] = [];
          }
        });
      }
    };

    function vendedorStructure(parUser, parData) {
      var date = new Date(parData.hired_date);
      parUser.hired_date = datesFactory.convertDate(date);
      parUser.reference_number = parData.reference_number;
      parUser.gastos_operacion = parData.gastos_operacion;
      parUser.address = parData.address;
      parUser.email = parData.email;
      parUser.url = parData.url;

      $scope.banks.forEach(function (bank) {
        if (bank.id == parData.bank) {
          parUser.bank = bank;
        }
      });

      $scope.fcs.forEach(function (frec) {
        if (frec.key == parData.frequencia_de_cobro) {
          parUser.frequencia_de_cobro = frec;
        }
      });

      $scope.pay_ways.forEach(function (pay) {
        if (pay.key == parData.tipo_pago) {
          parUser.pay_way = pay;
        }
      });

      if (parData.vendedor_phone.length) {
        if (parData.vendedor_phone.length == 1) {
          parUser.phone = parData.vendedor_phone[0].phone;
        } else if (parData.vendedor_phone.length > 1) {
          parData.vendedor_phone.forEach(function (phone, index) {
            if (index == 0) {
              parUser.phone = parData.vendedor_phone[0].phone;
            } else {
              parUser.phones.push(phone.phone);
            }
          });
        }
      }

      parData.vendedor_subramos.forEach(function (sub_ramo) {
        var data = {
          provider: sub_ramo.provider,
          ramo: sub_ramo.ramo,
          subramo: sub_ramo.subramo,
          comision_percentage: sub_ramo.comision,
          comision: sub_ramo.comision,
          id: sub_ramo.id,
          url: sub_ramo.url,
          ramos: $scope.fake_ramos,
        };

        $scope.aseguradoras.forEach(function (provider) {
          if (sub_ramo.provider == 0 && sub_ramo.ramo != 0) {
            data.ramos = $scope.fake_ramos;

            data.ramos.forEach(function (ramo) {
              if (ramo.id == sub_ramo.ramo) {
                data.ramo = ramo;
                data.sub_ramos = ramo.subramo_ramo;

                ramo.subramo_ramo.forEach(function (sub) {
                  if (sub.id == sub_ramo.subramo) {
                    data.subramo = sub;
                  }
                });
              }
            });
          } else if (provider.id == sub_ramo.provider) {
            data.ramos = $scope.fake_ramos;

            data.provider = provider;

            $http
              .get(url.IP + "ramos-by-provider/" + provider.id)
              .then(function (ramo) {
                data.ramos = ramo.data;

                data.ramos.forEach(function (ramo) {
                  if (ramo.id == sub_ramo.ramo) {
                    data.ramo = ramo;
                    data.sub_ramos = ramo.subramo_ramo;

                    ramo.subramo_ramo.forEach(function (sub) {
                      if (sub.id == sub_ramo.subramo) {
                        data.subramo = sub;
                      }
                    });
                  }
                });
              });
          }
        });

        parUser.subramos.push(data);
      });

      return angular.copy(parUser);
    }

    $scope.saveSeller = function (main_index) {
      var user = angular.copy($scope.users[main_index]);

      if (user.user_info) {
        if (user.user_info.is_vendedor) {
          var vendedor_ = user.user_info.info_vendedor[0].id;
        }
      } else {
        var vendedor_ = user.id;
      }

      if (user.subramos.length) {
        var subramos_ = user.subramos.map(function (item) {
          var subramo_post = {
            provider: item.provider ? item.provider.id : 0,
            ramo: item.ramo ? item.ramo.id : 0,
            subramo: item.subramo ? item.subramo.id : 0,
            comision: item.comision_percentage
              ? parseFloat(item.comision_percentage)
              : 0,
            vendedor: vendedor_,
          };

          if (item.id) {
            subramo_post.id = item.id;
          }

          if (item.url) {
            subramo_post.url = item.url;
          }

          return subramo_post;
        });
      } else {
        var subramos_ = [];
      }

      if (user.phones.length) {
        var phones_ = user.phones.map(function (phn) {
          var phones_return = {
            phone: phn,
            vendedor: vendedor_,
          };

          if (phn.id) {
            phones_return.id = phn.id;
          }

          if (phn.url) {
            phones_return.url = phn.url;
          }

          return phones_return;
        });

        if (user.phone) {
          phones_.push({ phone: user.phone, vendedor: vendedor_ });
        }
      } else {
        if (user.phone) {
          var phones_ = [{ phone: user.phone, vendedor: vendedor_ }];
        }
      }

      var hired_date_ = datesFactory.toDate(user.hired_date);

      user.vendedor_subramos = subramos_;
      user.hired_date = hired_date_;
      user.vendedor_phone = phones_;
      user.gastos_operacion = user.gastos_operacion
        ? parseInt(user.gastos_operacion)
        : 0;
      user.user = user.id;
      user.vendedor = vendedor_;
      user.is_vendedor = true;

      if (user.user_info.info_vendedor.length > 0) {
        if (user.user_info.is_vendedor) {
          var data_source = {};

          var hired_date_original = datesFactory.toDate(
            $scope.original_data.hired_date
          );

          if (hired_date_original !== hired_date_) {
            data_source.hired_date = user.hired_date;
          }

          if ($scope.original_data.bank.id !== user.bank.id) {
            data_source.bank = user.bank.id;
          }

          if ($scope.original_data.reference_number !== user.reference_number) {
            data_source.reference_number = user.reference_number;
          }

          if ($scope.original_data.pay_way.key !== user.pay_way.key) {
            data_source.tipo_pago = user.pay_way.key;
          }

          if (
            parseFloat($scope.original_data.gastos_operacion) !==
            parseFloat(user.gastos_operacion)
          ) {
            data_source.gastos_operacion = user.gastos_operacion;
          }

          // if($scope.original_data.frequencia_de_cobro.key !== user.frequencia_de_cobro.key) {
          //     data_source.frequencia_de_cobro = user.frequencia_de_cobro.key
          // }

          if ($scope.original_data.email !== user.email) {
            data_source.email = user.email;
          }

          if ($scope.original_data.phone !== user.phone) {
            var source_phone = {};
            var source_url = user.user_info.info_vendedor[0].vendedor_phone[0];
            source_phone.phone = user.phone;
            $http.patch(source_url.url, source_phone).then(function (req) {
              if (req.status == 200) {
              }
            });
          }

          for (var i = 0; i < $scope.original_data.phones.length; i++) {
            if ($scope.original_data.phones[i] !== user.phones[i]) {
              var source_phone = {};
              var source_url =
                user.user_info.info_vendedor[0].vendedor_phone[i + 1];
              source_phone.phone = user.phones[i];
              $http.patch(source_url.url, source_phone).then(function (req) {
                if (req.status == 200) {
                }
              });
            }
          }

          if ($scope.original_data.address !== user.address) {
            data_source.address = user.address;
          }

          $http.patch(user.url, data_source).then(function (req) {
            // console.log('req', req);
            if (req.status == 200) {
              $http.get(url.IP + "get-vendors/").then(function (user) {
                $scope.users = user.data;
                SweetAlert.swal("¡Listo!", MESSAGES.OK.UPDATESELLER, "success");

                $scope.show_pagination = true;
                $scope.config_pagination = {
                  count: user.data.count,
                  next: user.data.next,
                  previous: user.data.previous,
                };

                $scope.testPagination("users", "config_pagination");

                $scope.users.forEach(function (user) {
                  user["phones"] = [];
                  user["subramos"] = [];
                });

                providerService
                  .getReadListProviders()
                  .then(function (provider) {
                    $scope.aseguradoras = provider;
                  });
              });
            }
          });

          if ($scope.original_data.subramos.length !== subramos_.length) {
            // DELETE $scope.delete_subramos
            if ($scope.delete_subramos.length) {
              $scope.delete_subramos.forEach(function (item_d) {
                $http.delete(item_d.url).then(function (delete_item) {
                  // console.log('delete_item', delete_item);
                });
              });
            }

            subramos_.forEach(function (item) {
              if (item.id) {
                $scope.original_data.subramos.forEach(function (o_item) {
                  if (o_item.id == item.id) {
                    if (
                      parseFloat(o_item.comision) !== parseFloat(item.comision)
                    ) {
                      $http
                        .patch(item.url, { comision: item.comision })
                        .then(function (comision) {
                          // console.log('comision_percentage - patch', comision);
                        });
                    }
                  }
                });
              } else {
                dataFactory
                  .post("subramos-vendedor/", item)
                  .then(function (subramo_) {
                    // console.log('subramo_', subramo_);
                  });
              }
            });
          } else {
            subramos_.forEach(function (item) {
              if (item.id) {
                $scope.original_data.subramos.forEach(function (o_item) {
                  if (o_item.id == item.id) {
                    var sub_ramo_data = {};

                    if (
                      parseFloat(o_item.comision) !== parseFloat(item.comision)
                    ) {
                      sub_ramo_data.comision = item.comision;
                    }

                    if (o_item.provider !== item.provider) {
                      sub_ramo_data.provider = item.provider;
                    }

                    if (o_item.ramo !== item.ramo) {
                      sub_ramo_data.ramo = item.ramo;
                    }

                    if (o_item.subramo !== item.subramo) {
                      sub_ramo_data.subramo = item.subramo;
                    }

                    $http
                      .patch(item.url, sub_ramo_data)
                      .then(function (request) {
                        // console.log(request);
                      });
                  }
                });
              }
            });
          }

          $scope.original_data.phones.push($scope.original_data.phone);

          if ($scope.original_data.phones.length !== phones_.length) {
            // DELETE $scope.delete_subramos
            if ($scope.delete_phones.length) {
              $scope.delete_phones.forEach(function (item) {
                $http.delete(item.url).then(function (delete_item) {
                  // console.log('delete_item', delete_item);
                });
              });
            }

            phones_.forEach(function (item) {
              if (item.id) {
                $scope.original_data.phones.forEach(function (o_item) {
                  if (o_item.id == item.id) {
                    if (
                      parseFloat(o_item.phone) !==
                      parseFloat(item.$scope.delete_phones)
                    ) {
                      $http
                        .patch(item.url, { phone: item.$scope.delete_phones })
                        .then(function (phine) {
                          console.log("phone - patch", phine);
                        });
                    }
                  }
                });
              } else {
                // post
                dataFactory
                  .post("phone-vendedor/", item)
                  .then(function (phne_) {
                    // console.log('phne', phne_);
                  });
              }
            });
          }
        } else {
          dataFactory.post("vendedores/", user).then(function (data) {
            if (data.status == 201) {
              $scope.isSeller[main_index] = false;

              $scope.users.forEach(function (user, index) {
                if (user.id == data.data.user) {
                  dataFactory
                    .get("get-vendors/" + data.data.user)
                    .then(function (req) {
                      req.data["phones"] = [];
                      req.data["subramos"] = [];
                      $scope.users[index] = req.data;
                    });
                }
              });
            }
          });
        }
      } else {
        user.bank = user.bank.id;
        user.tipo_pago = user.pay_way.key;
        user.frequencia_de_cobro = user.frequencia_de_cobro.key;

        dataFactory.post("vendedores/", user).then(function (data) {
          if (data.status == 201) {
            $scope.isSeller[main_index] = false;

            $scope.users.forEach(function (user, index) {
              if (user.id == data.data.user) {
                dataFactory
                  .get("get-vendors/" + data.data.user)
                  .then(function (req) {
                    req.data["phones"] = [];
                    req.data["subramos"] = [];
                    $scope.users[index] = req.data;
                  });
              }
            });

            $http.get(url.IP + "get-vendors/").then(function (user) {
              $scope.users = user.data;
              SweetAlert.swal("¡Listo!", MESSAGES.OK.CREATESELLER, "success");

              $scope.show_pagination = true;
              $scope.config_pagination = {
                count: user.data.count,
                next: user.data.next,
                previous: user.data.previous,
              };

              $scope.testPagination("users", "config_pagination");

              $scope.users.forEach(function (user) {
                user["phones"] = [];
                user["subramos"] = [];
              });

              providerService.getReadListProviders().then(function (provider) {
                $scope.aseguradoras = provider;
              });
            });
          }
        });
      }
    };

    order.f_currency = {};
    order.f_currency.f_currency_selected = 1;
    order.f_currency.options = [
      { value: 1, label: "PESOS" },
      { value: 2, label: "DOLARES" },
      { value: 3, label: "UDI" },
      { value: 4, label: "EUROS" },
    ];

    // $scope.receipts_option = 'on_cover';
    $scope.receipts_option = "on_subgroup";

    function get_claves() {
      $http
        .get(url.IP + "claves-by-provider/" + order.form.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });

            order.defaults.claves = clavesResponse.data;
            if (order.defaults.claves.length == 1) {
              order.form.clave = order.defaults.claves[0];
              $scope.dataToSave.clave = order.form.clave.id;
            }
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }

    function getInternalNumber() {
      $http({
        method: "POST",
        url: url.IP + "internal-number/",
      })
        .then(
          function success(request) {
            if (request.status === 200 || request.status === 201) {
              order.form.internal_number = "OT000" + request.data.id;
              $scope.internal_number = "OT000" + request.data.id;
              $scope.dataToSave.internal_number = $scope.internal_number;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }
    $scope.sucursal = function (sc) {
      // console.log('sucrsals', sc);
    };
    function getSucursales() {
      dataFactory
        .get("sucursales-to-show/")
        .then(
          function success(response) {
            if (response.status === 200 || response.status === 201) {
              $scope.sucursalList = response.data.results;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }

    $scope.checkNumPolicy = function () {
      if (order.form.poliza) {
        helpers
          .existPolicyNumber(order.form.poliza)
          .then(function (request) {
            if (request == true) {
              SweetAlert.swal("Error", MESSAGES.ERROR.POLICYEXIST, "error");
              // toaster.warning('El número de póliza ya existe.');

              order.form.poliza = "";
            }
          })
          .catch(function (err) {});
      }
    };

    function showButtonPoliza() {
      order.show.ot = false;
    }
    function hideButtonOT() {
      order.show.ot = true;
    }

    $scope.selectExcel = function (parData) {
      validateExcel(parData.ASEGURADOS);
      $scope.strcutureData = certStructure(parData);
      treeStructure(parData);

      $scope.id_tree = true;
    };

    function validateExcel(parData) {
      parData.forEach(function (child) {
        if (!child.INI_VIGENCIA) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna INI_VIGENCIA esta vacia",
            "error"
          );
          return;
        }
        if (!child.FIN_VIGENCIA) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna FIN_VIGENCIA esta vacia",
            "error"
          );
          return;
        }

        if (!child.PAQUETE) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PAQUETE esta vacia",
            "error"
          );
          return;
        }

        if (!child.PRIMA_TOTAL) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PRIMA_TOTAL esta vacia",
            "error"
          );
          return;
        } else if (child.PRIMA_TOTAL.search(",") >= 0) {
          SweetAlert.swal(
            "Error en Layout",
            "En el renglon " +
              (parseInt(child.__rowNum__) + 1) +
              " la columna PRIMA_TOTAL es invalida. Las cantidades deben ser sin comas o caracteres especiales",
            "error"
          );
          return;
        }

        if (order.form.ramo.ramo_code == 1 || order.form.ramo.ramo_code == 2) {
          if (!child.CERT_GRAL) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna CERT_GRAL esta vacia",
              "error"
            );
            return;
          }
          if (!child.CERTIFICADO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna CERTIFICADO esta vacia",
              "error"
            );
            return;
          }
          if (order.form.ramo.ramo_code == 2 && !child.INCISO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna INCISO esta vacia",
              "error"
            );
            return;
          }
          if (!child.AP_PAT) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna AP_PAT esta vacia",
              "error"
            );
            return;
          }
          if (!child.NOMBRE) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna NOMBRE esta vacia",
              "error"
            );
            return;
          }
          if (!child.FEC_NAC) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna FEC_NAC esta vacia",
              "error"
            );
            return;
          }

          if (!child.SEXO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna SEXO esta vacia",
              "error"
            );
            return;
          } else if (!(child.SEXO == "M" || child.SEXO == "F")) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna SEXO contiene un valor invalido",
              "error"
            );
            return;
          }

          if (!child.PARENTESCO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna PARENTESCO esta vacia",
              "error"
            );
            return;
          } else if (child.PARENTESCO > 4) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna PARENTESCO contiene un valor invalido",
              "error"
            );
            return;
          }

          if (!child.TIPO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna TIPO esta vacia",
              "error"
            );
            return;
          } else if (child.TIPO > 2) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna TIPO contiene un valor invalido",
              "error"
            );
            return;
          }

          // if(order.form.ramo.ramo_code == 1 && !child.PORCENTAJE && child.TIPO == 2){
          //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna PORCENTAJE esta vacia', "error");
          //   return;
          // } else if(order.form.ramo.ramo_code == 1 && child.PORCENTAJE > 100){
          //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna PORCENTAJE es mayor a 100', "error");
          //   return;
          // }

          // if(order.form.ramo.ramo_code == 1 && !child.FUMADOR && child.TIPO == 1){
          //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna FUMADOR esta vacia', "error");
          //   return;
          // } else if(order.form.ramo.ramo_code == 1 && child.FUMADOR > 1){
          //   SweetAlert.swal("Error en Layout", 'En el renglon ' + (parseInt(child.__rowNum__) + 1) +' la columna FUMADOR contiene un valor invalido', "error");
          //   return;
          // }
        } else if (order.form.subramo.subramo_code == 9) {
          if (!child.INCISO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna INCISO esta vacia",
              "error"
            );
            return;
          }

          if (!child.ASEGURADO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna ASEGURADO esta vacia",
              "error"
            );
            return;
          }

          if (!child.MARCA) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MARCA esta vacia",
              "error"
            );
            return;
          }

          if (!child.MODELO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MODELO esta vacia",
              "error"
            );
            return;
          }

          if (!child.AÑO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna AÑO esta vacia",
              "error"
            );
            return;
          }

          if (!child.VERSION) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna VERSION esta vacia",
              "error"
            );
            return;
          }

          if (!child.SERIAL) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna SERIAL esta vacia",
              "error"
            );
            return;
          }

          if (!child.MOTOR) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MOTOR esta vacia",
              "error"
            );
            return;
          }

          if (!child.COLOR) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna COLOR esta vacia",
              "error"
            );
            return;
          }

          if (!child.MATRICULA) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna MATRICULA esta vacia",
              "error"
            );
            return;
          }

          if (!child.USO) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna USO esta vacia",
              "error"
            );
            return;
          } else if (child.USO > 3) {
            SweetAlert.swal(
              "Error en Layout",
              "En el renglon " +
                (parseInt(child.__rowNum__) + 1) +
                " la columna USO contiene un valor invalido",
              "error"
            );
            return;
          }
        }
      });
    }

    $rootScope.show_contractor = false;
    $scope.returnToPolicy = function () {
      $rootScope.show_contractor = false;
    };

    $scope.matchesContractors = function (parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = order.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var juridicals = response.data.juridicals;
                var naturals = response.data.naturals;

                if (juridicals.length) {
                  juridicals.forEach(function (item) {
                    var obj = {
                      label: item.j_name,
                      value: item,
                    };
                    source.push(obj);
                  });
                }
                if (naturals.length) {
                  naturals.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }

                    source.push(obj);
                  });
                }

                $scope.contractors_data = source;
              }
            });
        }
      } else {
        // $scope.contractors_data.length = 0;
        // console.log($scope.contractors_data.length);
      }
    };

    $scope.selectReceiptsOption = function (parValue) {
      if (parValue == "on_subgroup") {
        $scope.receits_on_cover = false;
        $scope.receipts_option = "on_subgroup";
      } else {
        $scope.receits_on_cover = true;
        $scope.receipts_option = "on_cover";
      }
    };

    $scope.$watch(
      "order.form.contratante.value",
      function (newValue, oldValue) {
        if (order.form.contratante) {
          if ($scope.users) {
            $scope.users.some(function (user) {
              if (user.url == order.form.contratante.value.vendor) {
                if (true) {
                  // order.form.vendor = user.id;
                  $scope.referenciadores[0] = {
                    referenciador: user.url,
                  };
                }
              }
            });
          }

          if (order.form.contratante.value.j_name) {
            order.form.contratante.val = order.form.contratante.value.j_name;
          }

          if (order.form.contratante.value.full_name) {
            order.form.contratante.val = order.form.contratante.value.full_name;
          }

          if (order.form.contratante.value.address_natural) {
            order.defaults.address =
              order.form.contratante.value.address_natural;
          } else {
            order.defaults.address =
              order.form.contratante.value.address_juridical;
          }

          if (order.form.contratante.value.phone_number) {
            order.form.contratante.phone_number =
              order.form.contratante.value.phone_number;
          }

          if (order.form.contratante.value.email) {
            order.form.contratante.email = order.form.contratante.value.email;
          }

          try {
            if (order.defaults.address.length == 1) {
              order.form.address = order.defaults.address[0];
            }
          } catch (err) {}
        }
      }
    );

    $scope.$watch("subgroup.contratante.value", function (newValue, oldValue) {
      if ($scope.subgroup.contratante) {
        $scope.subgroup.contratante.address_all = [];

        if ($scope.subgroup.contratante.value.address_natural) {
          $scope.subgroup.contratante.address_all =
            $scope.subgroup.contratante.value.address_natural;
        } else {
          $scope.subgroup.contratante.address_all =
            $scope.subgroup.contratante.value.address_juridical;
        }

        if ($scope.subgroup.contratante.value.j_name) {
          $scope.subgroup.contratante.val =
            $scope.subgroup.contratante.value.j_name;
        }

        if ($scope.subgroup.contratante.value.full_name) {
          $scope.subgroup.contratante.val =
            $scope.subgroup.contratante.value.full_name;
        }

        if ($scope.subgroup.contratante.value.phone_number) {
          $scope.subgroup.contratante.phone_number =
            $scope.subgroup.contratante.value.phone_number;
        }

        if ($scope.subgroup.contratante.value.email) {
          $scope.subgroup.contratante.email =
            $scope.subgroup.contratante.value.email;
        }

        try {
          if ($scope.subgroup.contratante.address_all.length == 1) {
            $scope.subgroup.contratante.address =
              $scope.subgroup.contratante.address_all[0];
          }
        } catch (err) {
          console.log("exception", err);
        }
      }
    });

    providerService
      .getProviderByKey(date)
      .then(
        function success(data) {
          order.defaults.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      )
      .catch(function (e) {
        console.log("error", e);
      });

    // modal para crear el nuevo contratante
    $scope.contratanteCreatorModalEvent = function () {
      $rootScope.show_contractor = true;
      $scope.orderInfo = order;
      $localStorage.orderForm = JSON.stringify(order.form);
    };

    // SELECCIONA LA ASEGURADORA, SE TRAEN LAS CLAVES DE AGENTE DE DICHA ASEGURADORA Y LOS RAMOS DE LA MISMA
    $scope.aseguradoraSelection = function () {
      // Nueva estructura
      $scope.dataToSave.aseguradora = order.form.aseguradora.id;
      if (order.form.aseguradora) {
        get_claves();
      }

      $http
        .get(url.IP + "ramos-by-provider/" + order.form.aseguradora.id)
        .then(
          function success(response) {
            order.defaults.ramos = response.data;
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    $scope.changeRamo = function () {
      $scope.dataToSave.ramo = order.form.ramo.id;
      if (order.form.ramo.ramo_code == 3) {
        $scope.autos = true;

        order.defaults.subramos = order.form.ramo.subramo_ramo;
      } else {
        order.defaults.subramos = order.form.ramo.subramo_ramo;
      }
    };

    $scope.changeSubramo = function () {
      $scope.dataToSave.subramo = order.form.subramo.id;
      order.defaults.forms = order.form.subramo.forms_subramo;
      // console.log('dgfhj',order.form.subramo )

      if (order.form.subramo) {
        get_claves();
      }

      if (order.defaults.comisiones) {
        if (!order.defaults.comisiones.length) {
          $scope.not_comision = "NO HAY COMISOINES DISPONIBLES PARA ESTE RAMO";
        }
      }

      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: order.form.ramo.id,
          subramo: order.form.subramo.id,
          provider: order.form.aseguradora.id,
        })
        .then(
          function success(response) {
            if (response.status === 200) {
              order.defaults.packages = [];
              if (response.data.length) {
                order.defaults.packages = response.data;
              }
            }

            // order.defaults.packages= packages_data;
            // console.log('paquetes',response.data);
          },
          function error(e) {
            console.log("Error - paquetes-data-by-subramo", e);
            order.defaults.packages = [];
          }
        )
        .catch(function (error) {
          // console.log('Error - paquetes-data-by-subramo - catch', error);
          // order.defaults.packages = [];
        });

      // Asigna la forma
      order.show.showForms = true;
      order.defaults.formInfo = {
        code: order.form.subramo.subramo_code,
        name: order.form.subramo.subramo_name,
      };

      order.defaults.comisiones = [];
      if (order.form.clave.clave_comision.length) {
        order.form.clave.clave_comision.forEach(function (item) {
          if (order.form.subramo.subramo_name == item.subramo) {
            order.defaults.comisiones.push(item);
          }
        });
      }

      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: order.form.ramo.id,
          subramo: order.form.subramo.id,
          provider: order.form.aseguradora.id,
        })
        .then(
          function success(response) {
            if (response.status === 200) {
              order.defaults.packages = response.data;
            } else {
              order.defaults.packages = [];
            }
          },
          function error(e) {
            console.log("Error - paquetes-data-by-subramo", e);
            order.defaults.packages = [];
          }
        )
        .catch(function (error) {
          // console.log('Error - paquetes-data-by-subramo - catch', error);
          // order.defaults.packages = [];
        });

      order.form.comisiones = order.defaults.comisiones;
    };

    $scope.changeClave = function (parClave) {
      // console.log('changeClave', parClave);
      order.defaults.comisiones = [];
      order.defaults.comisiones = parClave.clave_comision;
      $scope.dataToSave.clave = parClave.id;
    };

    $scope.ceder_comision = function () {
      if (order.form.ceder_comision == true) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "Estas seguro de que deseas ceder la comisión?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              $scope.ceder_comision = order.form.ceder_comision;
              order.form.comision_percent = order.form.comision.comission;
              order.form.udi = order.form.comision.udi;
            } else {
              order.form.ceder_comision = false;
            }
          }
        );
      } else {
        // $scope.ceder_comision = order.form.ceder_comision;
      }
    };

    $scope.changeAdminType = function () {
      if (order.adminType == "Autoadministrada") {
        $scope.dataToSave.administration_type = 2;
      } else if (order.adminType == "Simplificada") {
        $scope.dataToSave.administration_type = 1;
      } else {
        $scope.dataToSave.administration_type = 3;
      }
    };

    $scope.isReceiptAvailable = function () {
      $scope.dataToSave.forma_de_pago = order.form.payment;
    };

    $scope.changeFCurrency = function () {
      // $scope.dataToSave.f_currency = order.f_currency;
      $scope.dataToSave.f_currency = order.f_currency.f_currency_selected;
    };

    $scope.changeObservations = function () {
      $scope.dataToSave.observations = order.form.observations;
    };

    $scope.changeIdentifier = function (parValue) {
      order.form.identifier = parValue;
      $scope.dataToSave.identifier = order.form.identifier;
    };

    $scope.myTrackingFunction = function (parItem) {};

    $scope.saveCaratula = function () {
      order.contador = order.contador + 1;
      $scope.contractorToSave = {};

      if (order.form.contratante.phone_number) {
        $scope.contractorToSave = {
          phone_number: order.form.contratante.phone_number,
        };
      }
      if (order.form.contratante.email) {
        $scope.contractorToSave.email = order.form.contratante.email;
      }
      if (
        $scope.contractorToSave.email ||
        $scope.contractorToSave.phonenumber
      ) {
        if ($scope.edit_juridical || $scope.edit_natural) {
          $http.patch(
            order.form.contratante.value.url,
            $scope.contractorToSave
          );
        }
      }

      if (order.show.ot) {
        $scope.dataToSave.status = 1;
      } else {
        $scope.dataToSave.status = 14;
        $scope.dataToSave.internal_number = order.form.internal_number;
        $scope.dataToSave.folio = order.form.folio;
        $scope.dataToSave.poliza_number = order.form.poliza;
      }
      // STATUS: 3 = caratula
      $scope.dataToSave.document_type = 3;
      $scope.dataToSave.parent = null;

      if (!order.form.identifier) {
        if (order.form.ramo.ramo_code == 1) {
          order.form.identifier = "VID_GPO_" + order.form.contratante.val;
        } else if (order.form.ramo.ramo_code == 2) {
          order.form.identifier = "GMM_GPO_" + order.form.contratante.val;
        } else if (order.form.ramo.ramo_code == 3) {
          if (order.form.subramo.subramo_code == 9) {
            order.form.identifier = "FLOTILLA_" + order.form.contratante.val;
          } else {
            order.form.identifier = "DAÑOS_GPO_" + order.form.contratante.val;
          }
        } else {
          order.form.identifier = "";
        }
      }
      $scope.dataToSave.identifier = order.form.identifier;
      $scope.dataToSave.internal_number = $scope.internal_number;
      $scope.dataToSave.sucursal = order.form.sucursal
        ? order.form.sucursal
        : "";

      if ($scope.dataToSave.recibos_poliza) {
        $scope.dataToSave.recibos_poliza.forEach(function (recibo, index) {
          var receipt_init = new Date(
            datesFactory.toDate(recibo.startDate)
          ).setHours(11, 59, 59);
          var receipt_end = new Date(
            datesFactory.toDate(recibo.endingDate)
          ).setHours(12, 0, 0);

          // Parseo de fechas
          recibo.fecha_fin = new Date(receipt_end);
          recibo.fecha_inicio = new Date(receipt_init);
          recibo.startDate = new Date(receipt_init);
          recibo.endingDate = new Date(receipt_end);

          if (recibo.startDate.getTime() > recibo.endingDate.getTime()) {
            // console.log('cambiando fechas')
            var new_start = angular.copy(recibo.endingDate);
            var new_end = angular.copy(recibo.startDate);

            recibo.startDate = new_start;
            recibo.fecha_inicio = new_start;
            recibo.endingDate = new_end;
            recibo.fecha_fin = new_end;
          }

          if (recibo.vencimiento) {
            var vencimiento = new Date(toDate(recibo.vencimiento)).setHours(
              11.59,
              59,
              0
            );
            recibo.vencimiento = new Date(vencimiento);
          }

          if (isNaN(recibo.comision)) {
            recibo.comision = 0;
          }

          if ($scope.domiciliado) {
            recibo.is_cat = true;
          } else {
            recibo.is_cat = false;
          }
        });
      } else {
        $scope.dataToSave.recibos_poliza = [];
      }

      if (order.form.contratante.value.address_natural) {
        $scope.dataToSave.natural = order.form.contratante.value.id;
        $scope.dataToSave.address =
          order.form.contratante.value.address_natural[0].id;
      } else {
        $scope.dataToSave.juridical = order.form.contratante.value.id;
        $scope.dataToSave.address =
          order.form.contratante.value.address_juridical[0].id;
      }

      if (order.form.ceder_comision) {
        // form.comision_percent = order.form.comision_percent;
        $scope.dataToSave.udi = order.form.udi;
        if (order.form.comision_percent) {
          $scope.dataToSave.comision_percent =
            $scope.dataToSave.comision_percent;
        } else {
          $scope.dataToSave.comision_percent =
            $scope.dataToSave.comision_percent;
        }
      } else {
        if (order.form.comision_percent) {
          $scope.dataToSave.comision_percent =
            $scope.dataToSave.comision_percent;
        } else {
          if (order.form.comision) {
            $scope.dataToSave.comision_percent =
              $scope.dataToSave.comision_percent;
          } else {
            $scope.dataToSave.comision_percent =
              $scope.dataToSave.comision_percent;
          }
        }
        if (order.form.comision) {
          $scope.dataToSave.udi = order.form.comision.udi;
        }
      }

      if ($scope.dataToSave.status == 1) {
        $scope.dataToSave.comision = $scope.dataToSave.comision;
      } else {
        // POLIZA
        if (order.form.comision_percent) {
          var percent_ = parseFloat(order.form.comision_percent) / 100;
          $scope.dataToSave.comision = $scope.dataToSave.comision;
        } else {
          if (order.form.comision) {
            if ($scope.dataToSave.p_neta) {
              $scope.dataToSave.udi = order.form.comision.udi;
              var percent_ = parseInt(order.form.comision.comission) / 100;
              $scope.dataToSave.comision = $scope.dataToSave.comision;
            } else {
              $scope.dataToSave.comision = $scope.dataToSave.comision;
            }
          } else {
            $scope.dataToSave.udi = 0;
            $scope.dataToSave.comision = $scope.dataToSave.comision;
            // $scope.dataToSave.comission = $scope.dataToSave.p_neta * parseInt(order.form.comision.comission);
          }
        }
      }

      $scope.caratula = $scope.dataToSave;
      $scope.dataToSave.internal_number = order.form.internal_number;
      $scope.dataToSave.folio = order.form.folio;
      $scope.dataToSave.poliza_number = order.form.poliza;
      $scope.dataToSave.clave = order.form.clave.id;
      $scope.dataToSave.vendor = order.form.vendor;
      $scope.dataToSave.responsable = order.form.responsable;
      $scope.dataToSave.collection_executive = order.form.collection_executive;
      $scope.dataToSave.is_renewable = order.renewal.selected;
      if ($scope.receits_on_cover == true) {
        $scope.dataToSave.receipts_by = 1;
      } else {
        $scope.dataToSave.receipts_by = 2;
      }
      if (order.poliza) {
        try {
          if (
            $scope.dataToSave.poliza.aplicarDescuento == undefined ||
            $scope.dataToSave.poliza.aplicarDescuento == false
          ) {
            var applyDesc = 0;
          } else {
            var applyDesc = $scope.dataToSave.poliza.descuento;
          }
        } catch (err) {
          var applyDesc = 0;
        }
        $scope.dataToSave.descuento = applyDesc;
        $scope.dataToSave.p_neta = order.poliza.primaNeta;
        $scope.dataToSave.p_total = order.poliza.primaTotal;
        $scope.dataToSave.rpf = order.poliza.rpf;
        $scope.dataToSave.derecho = order.poliza.derecho;
        $scope.dataToSave.iva = order.poliza.iva;
        if (order.form.comision_percent) {
          var percent_ = parseFloat(order.form.comision_percent) / 100;
          $scope.dataToSave.comision = $scope.dataToSave.comision;
        }
      }
      if (!$scope.dataToSave.vendor) {
        $scope.dataToSave.vendor = "";
      }
      if (!$scope.dataToSave.responsable) {
        $scope.dataToSave.responsable = "";
      }
      if (!$scope.dataToSave.collection_executive) {
        $scope.dataToSave.collection_executive = "";
      }
      if ($scope.receits_on_cover == true && order.show.ot == false) {
        if (!$scope.dataToSave.recibos_poliza) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
      }
      // $scope.dataToSave.sucursal = order.form.sucursal ? order.form.sucursal : '';
      if (order.contador == 1) {
        $http
          .post(url.IP + "caratulas/", $scope.dataToSave)
          .then(
            function success(request) {
              if (request.status === 201) {
                $scope.editedReceipts = false;
                toaster.success("La carátula se ha guardado correctamete");
                $scope.caratula = request.data;
                // varios referenciadores
                for (var i = 0; i < $scope.referenciadores.length; i++) {
                  $scope.referenciadores[i].policy = request.data.url;
                }

                $scope.referenciadores.forEach(function (rfpol) {
                  var ref = {};
                  ref.referenciador = rfpol.referenciador;
                  ref.comision_vendedor = rfpol.comision_vendedor
                    ? rfpol.comision_vendedor
                    : 0;
                  ref.policy = request.data.url;
                  if (ref.referenciador) {
                    dataFactory
                      .post("referenciadores-policy/", ref)
                      .then(
                        function success(request) {},
                        function error(error) {
                          console.log(error);
                        }
                      )
                      .catch(function (e) {
                        console.log(e);
                      });
                  } else {
                    // console.log('___Sin referenciador__')
                  }
                });

                // varios referenciadores

                uploadFiles($scope.caratula.id);
                $scope.verSubgrupo = true;
                $scope.showSubgroup = true;
                $scope.showContent = false;
                $scope.caratulaSaved = true;
                $scope.newPackage = false;
                FileUploaderBD(1);
              } else {
                console.log("error - save cover");

                if ($scope.dataToSave.recibos_poliza) {
                  $scope.dataToSave.receipts.forEach(function (recibo) {
                    var receipt_init = datesFactory.convertDate(
                      recibo.startDate
                    );
                    var receipt_end = datesFactory.convertDate(
                      recibo.endingDate
                    );

                    recibo.fecha_fin = receipt_init;
                    recibo.fecha_inicio = receipt_end;
                    recibo.startDate = receipt_init;
                    recibo.endingDate = receipt_end;

                    if (recibo.vencimiento) {
                      var vencimiento = datesFactory.convertDate(
                        recibo.vencimiento
                      );
                      recibo.vencimiento = vencimiento;
                    }
                  });
                } else {
                  $scope.dataToSave.recibos_poliza = [];
                }
              }
            },
            function error(error) {
              console.log("error - caratula", error);
            }
          )
          .catch(function (e) {
            console.log("error - caratula - catch", e);
          });
      }

      $scope.filesCaratula1 = true;
    };

    $scope.show_contractor_list = true;
    $scope.selectContractor = function () {
      $scope.show_contractor_list = true;
    };

    $scope.existSubgroup = function (param) {
      if (param == 1) {
        $scope.exist_subgroup = true;
      } else {
        $scope.exist_subgroup = false;
      }
    };

    $scope.existCategoria = function (param) {
      if (param == 1) {
        $scope.exist_category = true;
      } else {
        $scope.exist_category = false;
      }
    };

    function FileUploaderBD(param) {
      if (param == 1) {
        $scope.filesCaratula = true;
        $timeout(function () {
          $http
            .get(url.IP + "polizas/" + $scope.caratula.id + "/archivos/")
            .then(function (response) {
              $scope.filesC = response.data.results;
            });
        }, 2000);
      } else if (param == 2) {
        // console.log ('subgrupo',$scope.subgroupId);
        $scope.filesSubgrupo = true;

        $timeout(function () {
          $http
            .get(url.IP + "polizas/" + $scope.subgroupId + "/archivos/")
            .then(function (response) {
              $scope.filesS = response.data.results;
              $scope.filesSubgrupo = false;
            });
        }, 3000);
      } else if (param == 3) {
        $scope.filesCategory = true;
        // console.log ('category',$scope.categoryId);
        $timeout(function () {
          $http
            .get(url.IP + "polizas/" + $scope.categoryId + "/archivos/")
            .then(function (response) {
              $scope.filesCat = response.data.results;
            });
        }, 3000);
      }
    }

    $scope.sub_group = [];

    $scope.NotSubgroups = function () {
      // SweetAlert.swal({
      //   title: '¿Continuar sin subgrupos?',
      //   text: "Ya no podrá crear subgrupos en esta colectividad.",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#DD6B55",
      //   confirmButtonText: "Si",
      //   closeOnConfirm: true
      // }, function(isConfirm) {
      //     if (isConfirm) {
      //       $scope.saveSubgroup('notGroup')
      //       toaster.info("Favor de dar click en siguiente");
      //     }
      // });
      SweetAlert.swal(
        "Advertencia",
        "No es posible dejar una Póliza sin Subgrupo si elegiste. Crear Recibos por Subgrupo",
        "warning"
      );
    };

    $scope.NotCategories = function () {
      SweetAlert.swal(
        {
          title: "¿Continuar sin categorias?",
          text: "Ya no podrá crear categorias en esta colectividad.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.saveCategory("notCategory");
            toaster.info("Favor de dar click en siguiente");
          }
        }
      );
    };

    $scope.saveSubgroup = function (parValue) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      $scope.subgroupDone = true;

      if (parValue == NOT_GROUP) {
        $scope.exist_subgroup = false;
        $scope.clientAlert =
          "Has seleccionado sin subgrupo por lo que no puedes crear ";
        var name = "Default";
        var observations = "";
        $scope.dataToSave.receipts = [];
        $scope.dataToSave.poliza = {
          iva: 0,
          p_total: 0,
          derecho: 0,
          rpf: 0,
          p_neta: 0,
        };
      } else if (parValue == ADD) {
        if (!$scope.receits_on_cover) {
          if ($scope.subgroup.contratante.value.address_natural) {
            var natural = $scope.subgroup.contratante.value.id;
            var address = natural;
          } else if ($scope.subgroup.contratante.value.address_juridical) {
            var juridical = $scope.subgroup.contratante.value.id;
            var address = juridical;
          }

          var juridical = $scope.subgroup.contratante.value.juridical;
        } else {
          var natural = null;
          var juridical = null;
          var address = null;
          order.receipts = [];
        }

        if (!$scope.subgroup.name) {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORSUBGROUP, "error");
          return;
        }
        var observations = $scope.subgroup.observations;
        var name = $scope.subgroup.name;
      }

      if (!order.poliza) {
        order.poliza = {
          iva: 0,
          p_total: 0,
          derecho: 0,
          rpf: 0,
          p_neta: 0,
        };
      } else {
        if (!order.poliza.iva) {
          order.poliza = {
            iva: 0,
            p_total: 0,
            derecho: 0,
            rpf: 0,
            p_neta: 0,
          };
        }
      }
      if ($scope.dataToSave.recibos_poliza && !$scope.receits_on_cover) {
        $scope.dataToSave.recibos_poliza.forEach(function (recibo) {
          if (isNaN(recibo.startDate)) {
            var receipt_init = new Date(
              datesFactory.toDate(recibo.startDate)
            ).setHours(11, 59, 59);
            var receipt_end = new Date(
              datesFactory.toDate(recibo.endingDate)
            ).setHours(12, 0, 0);
            // var vencimiento = new Date(datesFactory.toDate(recibo.vencimiento)).setHours(12,0,0);

            recibo.fecha_fin = new Date(receipt_end);
            recibo.fecha_inicio = new Date(receipt_init);
            recibo.startDate = new Date(receipt_init);
            recibo.endingDate = new Date(receipt_end);
            // recibo.vencimiento = new Date(vencimiento);

            if (recibo.vencimiento) {
              var vencimiento = new Date(toDate(recibo.vencimiento)).setHours(
                11.59,
                59,
                0
              );
              recibo.vencimiento = new Date(vencimiento);
            }
            if ($scope.domiciliado) {
              recibo.is_cat = true;
            } else {
              recibo.is_cat = false;
            }
          }
        });
      } else {
        $scope.dataToSave.recibos_poliza = [];
      }

      if (order.show.ot) {
        $scope.dataToSave.recibos_poliza = [];
        $scope.dataToSave.poliza = {
          iva: 0,
          p_total: 0,
          derecho: 0,
          rpf: 0,
          p_neta: 0,
        };
      }

      var data = {
        address: address,
        natural: natural,
        juridical: juridical,
        observations: observations,
        p_total: 0,
        derecho: $scope.dataToSave.poliza.derecho,
        rpf: order.poliza.rpf ? order.poliza.rpf : 0,
        p_neta: $scope.dataToSave.poliza.p_neta,
        iva: $scope.dataToSave.poliza.iva
          ? parseFloat($scope.dataToSave.poliza.iva).toFixed(2)
          : 0,
        name: name,
        recibos_poliza: $scope.dataToSave.recibos_poliza,
        coverageInPolicy_policy: [],
        parent: $scope.caratula.id,
        caratula: $scope.caratula.id,
        document_type: 4,
        vendor: $scope.subgroup.vendor,
      };

      if (!$scope.subgroup.vendor) {
        data.vendor = "";
      }

      $scope.showReceipts = false;

      $http
        .post(url.IP + "subgrupos/", data)
        .then(
          function success(request) {
            if (request.status === 201) {
              $scope.editedReceipts = false;
              uploadFiles(request.data.id);
              $scope.subgroupId = request.data.id;
              FileUploaderBD(2);
              $scope.show_cat_again = true;
              $scope.show_sgr_again = false;
              l.stop();

              if (data.name !== DEFAULT) {
                $scope.sub_group.push(request.data);
                toaster.success("El subgrupo se ha guardado correctamente");
              }

              $scope.subgrupoResult = request.data;
              order.subgroups.push(request.data);

              order.receipts = [];
              order.poliza = {};
              // $scope.not_category = true;
              $scope.show_category = true;

              $scope.subgroup = {};
              $scope.tree_subs = treeIdsStructure();
            }

            var params = {
              model: 18,
              event: "POST",
              associated_id: $scope.caratula.id,
              identifier: "creó el subgrupo " + request.data.name + ".",
            };

            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          },
          function error(error) {
            console.log("error - saveSubgrupo", error);
          }
        )
        .catch(function (e) {
          console.log("error - saveSubgrupo - catch", e);
        });
    };

    $scope.selectSubgroup = function (parData) {
      // console.log('parData', parData);
      $scope.subgrupoResult = parData;
    };

    // ------------------ Categoría

    $scope.checkSubgroup = function () {
      if (order.subgroups.length == 1) {
        if (order.subgroups[0].name == DEFAULT) {
          $scope.selectSubgroup(order.subgroups[0]);
          $scope.category.subgroup = order.subgroups[0];
          $scope.subgroup_default = true;
        }
      } else {
        $scope.subgroup_default = false;
      }
    };

    $scope.saveCategory = function (parValue) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      if (parValue == NOT_CATEGORY) {
        $scope.exist_category = false;
        var cat_observations = "";
        var cat_name = DEFAULT;
        var cat_hospital_level = "";
      } else if (parValue == ADD) {
        var cat_observations = $scope.category.observations;
        var cat_name = $scope.category.name;
        var cat_hospital_level = $scope.category.hospital_level;
        $scope.verCategoria = true;
      } else if (parValue == NEXT) {
        $scope.showCategoria = false;
        $scope.verPaquetes = true;

        return;
      }

      $scope.categoryDone = true;

      var data = {
        observations: cat_observations,
        name: cat_name,
        parent: $scope.subgrupoResult.url,
        hospital_level: cat_hospital_level,
        caratula: $scope.caratula.id,
        document_type: 5,
      };

      $http
        .post(url.IP + "categories/", data)
        .then(
          function success(request) {
            if (request.status === 201) {
              uploadFiles(request.data.id);
              $scope.categoryId = request.data.id;
              $scope.verPaquetes = true;
              $scope.showPaquetes = true;
              $scope.show_cat_again = false;
              $scope.not_category = false;
              FileUploaderBD(3);
              l.stop();

              if (data.name !== DEFAULT) {
                toaster.success("La categoría se ha guardado correctamete");
              }
              order.categories.push(request.data);
              $scope.categoria_result = request.data;

              $scope.category = {};
              $scope.newPackage = false;
              $scope.tree_subs = treeIdsStructure();

              var params = {
                model: 18,
                event: "POST",
                associated_id: $scope.caratula.id,
                identifier:
                  "creó la categoría " +
                  request.data.name +
                  " en el subgrupo " +
                  $scope.subgrupoResult.name +
                  ".",
              };

              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }
          },
          function error(error) {
            console.log("error - category", error);
          }
        )
        .catch(function (e) {
          console.log("error - category - catch", e);
        });
      $scope.tree_subs = treeIdsStructure();
    };

    $scope.nextCategory = function () {
      // $scope.verCategoria = false;
      $scope.showCategoria = false;
      // Al success de crear categoria default
      // $scope.verCertificados = true;
      // $scope.showCertificado = true;
      $scope.verPaquetes = true;
      $scope.showPaquetes = true;
    };

    // ------------------ Paquetes

    $scope.getCoverages = function (parItem) {
      $scope.selected = false;
      $scope.coverages = [];
      $scope.coverages = parItem.coverage_package;
    };

    $scope.addPackage = function () {
      $scope.newPackage = true;
      $scope.configurations = [];
    };

    $scope.cancelNewPackage = function () {
      $scope.newPackage = false;
      $scope.addCoverages = false;
      $scope.package = "";
    };

    $scope.savePackage = function (parObj) {
      parObj.provider = order.form.aseguradora.url;
      parObj.ramo = order.form.ramo.url;
      parObj.subramo = order.form.subramo.url;
      parObj.type_package = 1; // paquete normal
      parObj.coverage_package = [];

      packageService
        .createPackage(parObj)
        .then(
          function success(request) {
            order.defaults.packages.push(request);
            $scope.newPackage = false;
            $scope.addCoverages = true;
            $scope.packageCreated = request;
            SweetAlert.swal(
              "¡Listo!",
              "El paquete: " + request.package_name + ", se ha creado.",
              "success"
            );
          },
          function error(error) {
            console.log("error - createPackage", error);
          }
        )
        .catch(function (e) {
          console.log("error -createPackage- catch", e);
        });
    };

    var new_coverage_data = [];

    $scope.selectPackage = function (parValue) {
      $scope.package = parValue;
      $scope.selectedPackage = true;
      new_coverage_data = parValue.coverage_package;
      $scope.coveragesPackage = parValue.coverage_package;
      $scope.configurations = [];

      $scope.master = {
        source: angular.copy(parValue.coverage_package),
        coveragesConfig: [],
      };

      $scope.config_coverages = angular.copy($scope.master);
    };

    $scope.saveCoverage = function (
      parName,
      priority,
      parType,
      parPackage,
      parData
    ) {
      $scope.coverages = [];
      if (parPackage) {
        var paqueteData = parPackage;
      } else {
        var paqueteData = $scope.packageCreated;
      }

      var obj = {
        coverage_name: parName,
        priority: priority ? priority : 0,
        provider: order.form.aseguradora.url,
        package: paqueteData.url,
        deductible: [],
        sums_coverage: [],
        coinsurance_coverage: [],
      };

      coverageService
        .createCoverage(obj)
        .then(
          function success(request) {
            toaster.success("La cobertura se ha guardado correctamete");
            $scope.coverages.push(request);
            $scope.coverages.push(request);
            $scope.coverageName = null;

            order.defaults.packages.forEach(function (item) {
              if (item.id == paqueteData.id) {
                if (parType == "config") {
                  $scope.config_coverages.source.push(request);
                  // parData.coveragesConfig.push(request);
                  $scope.showNewCoverage = false;
                }
                if (item.coverage_package) {
                  item.coverage_package.push(request);
                } else {
                  item.coverage_package = [];
                  item.coverage_package.push(request);
                }
              }
            });
          },
          function error(error) {
            console.log("error - createCoverage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createCoverage - catch", e);
        });
    };

    $scope.percentageRange = function (input, index) {
      if (input < 0) {
        $scope.config_coverages.coveragesConfig[
          index
        ].coinsuranceInPolicy.value = 0;
      }
      if (input > 100) {
        $scope.config_coverages.coveragesConfig[
          index
        ].coinsuranceInPolicy.value = 100;
      }
    };

    $scope.finishCoverages = function () {
      $scope.newPackage = false;
      $scope.addCoverages = false;
    };

    $scope.addConfiguration = function () {
      $scope.configurations.push({
        id: $scope.configurations.length + 1,
        coveragesConfig: [],
        source: new_coverage_data,
      });
    };

    $scope.deleteCoverage = function (parItem, parData) {
      parItem.selected = false;
      $scope.config_coverages.coveragesConfig.splice(
        $scope.config_coverages.coveragesConfig.indexOf(parItem),
        1
      );

      $scope.config_coverages.source.forEach(function (item) {
        if (parItem.id == item.id) {
          item.selected = false;
        }
      });
    };

    $scope.addCoveragesConfig = function () {
      $scope.config_coverages.coveragesConfig = coverages_;
    };

    $scope.addAll = function () {
      $scope.config_coverages.coveragesConfig = angular.copy(
        $scope.config_coverages.source
      );
      $scope.config_coverages.source.forEach(function (item) {
        item.selected = true;
      });
    };

    var coverages_ = [];
    $scope.addCoverageToArray = function (param) {
      if (param.selected) {
        $scope.config_coverages.coveragesConfig.push(angular.copy(param));
      } else {
        $scope.config_coverages.coveragesConfig.forEach(function (
          item,
          index,
          object
        ) {
          if (param.id == item.id) {
            object.splice(index, 1);
          }
        });
      }
    };

    $scope.config_saved = [];

    $scope.saveConfiguration = function (parData) {
      for (var i = 0; i < parData.coveragesConfig.length; i++) {
        if (
          !parData.coveragesConfig[i].sumInPolicy &&
          !parData.coveragesConfig[i].deductibleInPolicy
        ) {
          SweetAlert.swal("Error", MESSAGES.ERROR.DEDUCTIBLEREQUIRED, "error");
          return;
        }
      }

      var obj = {
        package_name: parData.package_name,
        policy: $scope.caratula.id,
        provider: order.form.aseguradora.url,
        ramo: order.form.ramo.url,
        coverage_package: parData.coveragesConfig,
        subramo: order.form.subramo.url,
        type_package: 2,
      };

      packageService
        .createPackage(obj)
        .then(
          function success(request) {
            // console.log('request.data',request)
            // SweetAlert.swal("¡Listo!","Paquete:"+request.package_name+"creado","success");
            var coverages_config = [];

            parData.coveragesConfig.forEach(function (item, index) {
              var covObj = {
                coverage_name: item.coverage_name,
                priority: item.priority ? item.priority : 0,
                provider: order.form.aseguradora.url,
                package: request.url,
                deductible_coverage: [],
                sums_coverage: [],
                coinsurance_coverage: [],
                topecoinsurance_coverage: [],
                typeCoverage: 2,
              };

              if (!item.sumInPolicy && item.sums_coverage.length) {
                covObj.sums_coverage.push(item.sums_coverage[0]);
              } else {
                var test = {
                  coverage_sum: item.url,
                  default: true,
                  id: 0,
                  org: "",
                  sum_insured: item.sumInPolicy ? item.sumInPolicy.value : 0,
                  url: "",
                };
                covObj.sums_coverage.push(test);
              }

              if (!item.deductibleInPolicy && item.deductible_coverage.length) {
                covObj.deductible_coverage.push(item.deductible_coverage[0]);
              } else {
                if (item.deductibleInPolicy == undefined) {
                  var test = {
                    coverage_deductible: item.url,
                    default: true,
                    id: 0,
                    org: "",
                    deductible: "",
                    url: "",
                  };
                } else {
                  var test = {
                    coverage_deductible: item.url,
                    default: true,
                    id: 0,
                    org: "",
                    deductible: item.deductibleInPolicy
                      ? item.deductibleInPolicy.value
                      : 0,
                    url: "",
                  };
                }
                covObj.deductible_coverage.push(test);
              }
              if (order.form.subramo.subramo_name == "Gastos Médicos") {
                if (item.coinsurance_coverage) {
                  if (item.coinsuranceInPolicy == undefined) {
                    var test = {
                      coverage_coinsurance: item.url,
                      default: true,
                      id: 0,
                      org: "",
                      coinsurance: 0,
                      url: "",
                    };
                  } else {
                    var test = {
                      coverage_coinsurance: item.url,
                      default: true,
                      id: 0,
                      org: "",
                      coinsurance: item.coinsuranceInPolicy
                        ? item.coinsuranceInPolicy.value
                        : 0,
                      url: "",
                    };
                  }

                  covObj.coinsurance_coverage.push(test);
                }

                if (item.topecoinsurance_coverage) {
                  if (item.topeCoinsuranceInPolicy == undefined) {
                    var test = {
                      coverage_topecoinsurance: item.url,
                      default: true,
                      id: 0,
                      org: "",
                      topecoinsurance: 0,
                      url: "",
                    };
                  } else {
                    var test = {
                      coverage_topecoinsurance: item.url,
                      default: true,
                      id: 0,
                      org: "",
                      topecoinsurance: item.topeCoinsuranceInPolicy
                        ? item.topeCoinsuranceInPolicy.value
                        : 0,
                      url: "",
                    };
                  }

                  covObj.topecoinsurance_coverage.push(test);
                }
              }

              // if(order.form.subramo.subramo_name == "Gastos Médicos"){
              //   if(!item.coinsuranceInPolicy && item.coinsurance_coverage.length){
              //     covObj.coinsurance_coverage.push(item.coinsurance_coverage[0]);
              //   }
              //   else{
              //     console.log('ll',item.coinsuranceInPolicy)
              //     if(item.coinsuranceInPolicy != undefined){
              //     console.log('lvaluel',item.coinsuranceInPolicy)
              //       var test = {
              //         coverage_coinsurance: item.url,
              //         default: true,
              //         id: 0,
              //         org: "",
              //         coinsurance: item.coinsuranceInPolicy.value,
              //         url: "",
              //       }
              //     }else if(item.coverageInPolicy == undefined){
              //       console.log('lnovall',item.coinsuranceInPolicy)
              //       var test = {
              //         coverage_coinsurance: item.url,
              //         default: true,
              //         id: 0,
              //         org: "",
              //         coinsurance: item.coinsuranceInPolicy,
              //         url: "",
              //       }
              //     }
              //     covObj.coinsurance_coverage.push(test);
              //   }
              // }
              coverageService
                .createCoverageConfig(covObj)
                .then(
                  function success(data) {
                    toaster.success("El paquete se ha guardado correctamete");

                    coverages_config.push(data);

                    if (parData.coveragesConfig.length == index + 1) {
                      // TODO: Eliminar del arreglo de configuraciones
                      $scope.configurations.splice(
                        $scope.configurations.indexOf(parData),
                        1
                      );
                      request.coveragesConfig = coverages_config;
                      request.source = new_coverage_data;
                      $scope.config_saved.push(request);

                      $scope.config_coverages = angular.copy($scope.master);

                      $scope.verCertificados = true;
                      $scope.showCertificado = true;
                    }

                    var params = {
                      model: 18,
                      event: "POST",
                      associated_id: $scope.caratula.id,
                      identifier:
                        "creó el paquete " + request.package_name + ".",
                    };

                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                  },
                  function error(error) {
                    console.log("error - createCoverage", error);
                    // TODO: Agregar alerta de confirmación
                  }
                )
                .catch(function (e) {
                  console.log("error - createCoverage - catch", e);
                  // TODO: Agregar alerta de confirmación
                });
            });

            // asignar ID en la vista
          },
          function error(error) {
            console.log("error - createPackage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createPackage - catch", e);
        });
    };

    $scope.saveChangesConfig = function (parData) {
      // Edición de coberturas de una configuración
      parData.coveragesConfig.forEach(function (item) {
        $http({
          method: "PATCH",
          url: item.url,
          data: {
            deductible_coverage: item.deductible_coverage,
            sums_coverage: item.sums_coverage,
            coinsurance_coverage: item.coinsurance_coverage,
          },
        })
          .then(
            function success(request) {},
            function error(error) {
              console.log("error - patch configurations ", e);
            }
          )
          .catch(function (e) {
            console.log("error - patch configurations - catch", e);
          });
      });
    };

    $scope.editValue = function (parType, parItem) {
      // console.log('test', parItem);
    };

    $scope.updateCerts = function () {
      treeIdsStructure();
    };

    // ------------------ Certificados
    // $scope.loader = true;

    $scope.saveCertificados = function () {
      $scope.loader = true;
      if ($scope.strcutureData.length <= 800) {
        var data = {
          data: $scope.strcutureData,
        };
        console.log("strcutureData", $scope.strcutureData);
        $http({
          method: "POST",
          url: url.IP + "massive-certificates/",
          data: $scope.strcutureData,
        })
          .then(
            function success(request) {
              if (request.status === 201 || request.status === 200) {
                $scope.loader = false;
                SweetAlert.swal(
                  "¡Hecho!",
                  MESSAGES.OK.CERTIFICATESDONE,
                  "success"
                );
                $("#tree").treeview({ data: [] });
                $state.go("colectividades.info", {
                  polizaId: $scope.caratula.id,
                });
                // $state.go('polizas.table');
              } else {
                $scope.loader = false;
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.ERRORCERTIFICATES,
                  "error"
                );
              }
              // console.log('Request', request);
            },
            function error(error) {
              console.log("Error -  ");
              $scope.loader = false;
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORCERTIFICATES,
                "error"
              );
            }
          )
          .catch(function (e) {
            console.log("Error - catch", e);
          });
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORNUMCERTIFICATES, "error");
        $scope.loader = false;
      }
    };

    $scope.checkDate = function (param) {
      if (param) {
        var date = new Date();
        order.form.endingDate = new Date(date.setYear(date.getFullYear() + 1));

        if (order.form.aseguradora) {
          get_claves();
        }
        order.form.startDate = new Date();
        order.form.endingDate = datesFactory.convertDate(order.form.endingDate);
        $scope.dataToSave.start_of_validity = new Date();
        $scope.dataToSave.end_of_validity = new Date(
          datesFactory.mesDiaAnio(order.form.endingDate)
        );

        order.form.startDate = datesFactory.convertDate(order.form.startDate);
      }

      if (order.form.startDate.length == 10) {
        var x = datesFactory.mesDiaAnio(order.form.startDate);
        var date = new Date(x);
        // order.form.endingDate = x;
        order.form.endingDate = new Date(date.setYear(date.getFullYear() + 1));
        if (order.form.aseguradora) {
          get_claves();
        }
        //--------------------------- ok
        order.form.startDate = new Date(x);
        order.form.endingDate = datesFactory.convertDate(order.form.endingDate);
        $scope.dataToSave.start_of_validity = new Date(x);
        $scope.dataToSave.end_of_validity = new Date(
          datesFactory.mesDiaAnio(order.form.endingDate)
        );

        order.form.startDate = datesFactory.convertDate(order.form.startDate);

        var date1 = new Date(order.form.startDate);
        var date2 = new Date(order.form.endingDate);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        order.form.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
        if (order.form.policy_days_duration < 365) {
          order.form.payment = 5;
        }
      }
    };
    $scope.changeUntil_1 = function () {
      var since = toDate(order.form.startDate).getTime();
      var until = toDate(order.form.endingDate).getTime();
      var diff = until - since;
      var date = toDate(order.form.startDate);
      var date1 = toDate(order.form.endingDate);
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        var newdate = new Date();
        var since = toDate(order.form.startDate).getTime();
        var date = toDate(order.form.startDate);
        var date1 = toDate(order.form.endingDate);
        order.form.startDate = new Date(date1.setYear(date1.getFullYear() - 1));
        order.form.startDate = convertDate(order.form.startDate);
        // order.form.endingDate = convertDate(order.form.endingDate);
        $scope.dataToSave.start_of_validity = new Date(
          datesFactory.mesDiaAnio(order.form.startDate)
        );
        $scope.dataToSave.end_of_validity = new Date(
          datesFactory.mesDiaAnio(order.form.endingDate)
        );
      }

      order.form.policy_days_duration = antiguedad;
    };
    /*$scope.$watch('order.form.endingDate', function (newValue, oldValue) {
      $scope.dataToSave.end_of_validity = newValue;
    });*/

    function treeIdsStructure() {
      $scope.verCertificados = true;

      var tree_ids = [];
      order.subgroups.forEach(function (sub) {
        if (sub.name !== DEFAULT) {
          var element = {};
          element.data = sub;
          element.text = "Subgrupo: ID = " + sub.id + ": Nombre= " + sub.name;
          element.nodes = [];

          order.categories.forEach(function (category) {
            if (sub.url == category.parent) {
              if (category.name !== DEFAULT) {
                element.nodes.push({
                  text:
                    "Categoría: ID = " +
                    category.id +
                    ": Nombre = " +
                    category.name,
                });
              } else if (category.name == DEFAULT) {
                element.nodes.push({
                  text:
                    "Categoría: ID = " +
                    category.id +
                    ": Nombre = " +
                    category.name,
                });
              }
            }
          });

          tree_ids.push(element);
        } else {
          order.categories.forEach(function (category) {
            if (category.name !== DEFAULT) {
              var element = {
                text:
                  "Categoría: ID = " +
                  category.id +
                  ": Nombre = " +
                  category.name,
              };
              tree_ids.push(element);
            } else if (category.name == DEFAULT) {
              var element = {
                text:
                  "Categoría: ID = " +
                  category.id +
                  ": Nombre = " +
                  category.name,
              };
              tree_ids.push(element);
            }
          });
        }
      });

      $("#tree_ids").treeview({ data: tree_ids });
      // $('#tree_subs').treeview({data: tree_ids});
      return tree_ids;
    }

    function treeStructure(parData) {
      var tree = [];

      for (var key in parData) {
        var data = parData[key];
        if (data.length) {
          // checar asegurados (parents)
          var parents = [];
          var childs = [];
          // console.log('caratula', order.form);
          if (order.form.subramo.subramo_code == 9) {
            // console.log('autos');

            data.forEach(function (car) {
              var parent_content =
                car.INCISO +
                " - " +
                car.MARCA +
                " - " +
                car.MODELO +
                " - " +
                car.AÑO +
                " - " +
                car.VERSION +
                " - " +
                car.SERIAL;

              var element = {
                text: parent_content,
              };

              tree.push(element);
            });
          } else if (
            order.form.ramo.ramo_code == 3 &&
            order.form.subramo.subramo_code != 9
          ) {
            data.forEach(function (item) {
              var parent_content =
                item.NOMBRE +
                " - " +
                item.CALLE +
                " #" +
                item.NUMERO +
                " " +
                item.COLONIA +
                " " +
                item.DELEGACION +
                " " +
                item.CIUDAD +
                " " +
                item.ESTADO +
                " C.P." +
                item.CP;

              var element = {
                text: parent_content,
              };

              if (item.INCISO) {
                tree.push(element);
              }
            });
          } else {
            data.forEach(function (child) {
              if (child.TIPO == 2) {
                childs.push(child);
              }
            });

            data.forEach(function (parent) {
              // console.log('item', item);
              if (parent.TIPO == 1) {
                // parents.push(item);
                var nodes = [];
                childs.forEach(function (item) {
                  if (item.CERTIFICADO == parent.CERTIFICADO) {
                    var full_name =
                      item.NOMBRE + " " + item.AP_PAT + " " + item.AP_MAT;

                    if (item.INCISO) {
                      var inciso = item.INCISO;
                    } else {
                      var inciso = "";
                    }

                    if (item.PARENTESCO) {
                      var parentesco = item.PARENTESCO;
                    } else {
                      var parentesco = "";
                    }

                    if (item.PORCENTAJE) {
                      var porcentaje = item.PORCENTAJE;
                    } else {
                      var porcentaje = "";
                    }

                    var content =
                      inciso +
                      " - " +
                      full_name +
                      " - " +
                      item.FEC_NAC +
                      " - " +
                      parentesco +
                      " - " +
                      item.SEXO +
                      " - " +
                      porcentaje;

                    nodes.push({
                      text: content,
                    });
                  }
                });

                var parent_content =
                  parent.CERTIFICADO +
                  " - " +
                  parent.NOMBRE +
                  " " +
                  parent.AP_PAT +
                  " " +
                  parent.AP_MAT +
                  " - " +
                  parent.FEC_NAC;

                var element = {
                  text: parent_content,
                  nodes: nodes,
                };

                tree.push(element);
              }
            });
          }

          $("#tree").treeview({ data: tree });
        }
      }
    }

    function certStructure(parData, par_status) {
      var certificadosArray = [];
      var beneficiaries_life = [];
      var beneficiaries_gm = [];
      var life_data = [];
      var gm_data = [];

      for (var key in parData) {
        var data = parData[key];

        if (data.length) {
          if (order.form.subramo.subramo_code == 9) {
            // COCHES
            var autos_certs = [];

            data.forEach(function (item) {
              if (item.USO) {
                if (item.USO >= "4" || item.USO <= "0") {
                  item.USO = "1";
                }
              } else {
                item.USO = "1";
              }

              if (!item.EMAIL) {
                item.EMAIL = "";
              }

              if (!item.CONTACTO) {
                item.CONTACTO = "";
              }
              if (item.MOTOR) {
                $scope.mtr = item.MOTOR;
              } else {
                $scope.mtr = "";
              }
              if (item.COLOR) {
                $scope.clr = item.COLOR;
              } else {
                $scope.clr = "";
              }
              if (item.MARCA) {
                $scope.mrc = item.MARCA;
              } else {
                $scope.mrc = "NP";
              }
              if (item.MODELO) {
                $scope.mdl = item.MODELO;
              } else {
                $scope.mdl = "NP";
              }
              if (item.AÑO) {
                $scope.ani = item.AÑO;
              } else {
                $scope.ani = "NP";
              }

              if (item.CONDUCTOR) {
                $scope.cndtr = item.CONDUCTOR;
              } else {
                $scope.cndtr = "";
              }
              if (item.BEN_PREFERENTE) {
                $scope.ben_p = item.BEN_PREFERENTE;
              } else {
                $scope.ben_p = "";
              }

              if (item.PRIMA_NETA) {
                $scope.p_neta = item.PRIMA_NETA;
              } else {
                $scope.p_neta = 0;
              }
              if (item.DERECHO) {
                $scope.derecho = item.DERECHO;
              } else {
                $scope.derecho = 0;
              }
              if (item.RPF) {
                $scope.rpf = item.RPF;
              } else {
                $scope.rpf = 0;
              }
              if (item.IVA) {
                $scope.iva = item.IVA;
              } else {
                $scope.iva = 0;
              }
              if (item.COMISION) {
                $scope.comision = item.COMISION;
              } else {
                $scope.comision = 0;
              }
              if (item.PRIMA_TOTAL) {
                $scope.p_total = item.PRIMA_TOTAL;
              } else {
                $scope.p_total = 0;
              }

              var data_autos = [
                {
                  brand: $scope.mrc,
                  model: $scope.mdl,
                  beneficiary_name: item.ASEGURADO,
                  driver: item.CONDUCTOR,
                  year: $scope.ani,
                  version: item.VERSION,
                  serial: item.SERIAL,
                  engine: item.MOTOR,
                  color: $scope.clr,
                  usage: item.USO,
                  license_plates: item.MATRICULA,
                  email: item.EMAIL,
                  // driver :$scope.cndtr,
                  preferential_benefiaciary: $scope.ben_p,
                  p_neta: $scope.p_neta,
                  derecho: $scope.derecho,
                  rpf: $scope.rpf,
                  iva: $scope.iva,
                  comision: $scope.comision,
                  document_type: 6,
                },
              ];
              autos_certs.push(data_autos);
              if (item.CATEGORIA) {
                var categoria_ = parseInt(item.CATEGORIA);
              } else {
                var categoria_ = $scope.categoria_result.id;
              }

              if (item.SUBGRUPO) {
                for (var i = 0; i < order.subgroups.length; i++) {
                  var item_sub = order.subgroups[i];

                  if (item_sub.id == parseInt(item.SUBGRUPO)) {
                    if (item_sub.address) {
                      var address_ = item.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    } else {
                      var address_ = $scope.caratula.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    }
                  }
                }
              } else {
                var address_ = $scope.caratula.address;
                var natural_ = $scope.caratula.natural;
                var juridical_ = $scope.caratula.juridical;
              }

              if (order.show.ot) {
                var status_ = 1;
              } else {
                var status_ = 14;
              }

              if ($scope.config_saved.length) {
                $scope.config_saved.forEach(function (i) {
                  if (i.id == parseInt(item.PAQUETE)) {
                    $scope.coberturas_paquete = i.coveragesConfig;
                    $scope.coberturas_paquete.forEach(function (j) {
                      if (
                        $scope.caratula.subramo.subramo_name == "Gastos Médicos"
                      ) {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = j.coinsurance_coverage[0].coinsurance;
                      } else {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                        j.coinsurance = 0;
                      }
                    });
                  }
                });
              }
              // var inciso_start = new Date(toDate(item.INI_VIGENCIA))
              // var inciso_end = new Date(toDate(item.FIN_VIGENCIA))
              var inciso_start = toDate(item.INI_VIGENCIA);
              var inciso_end = toDate(item.FIN_VIGENCIA);

              var certData = {
                internalNumber: null,
                folio: null,
                caratula: $scope.caratula.id,
                certificate_number: parseInt(item.INCISO),
                aseguradora: $scope.dataToSave.aseguradora,
                parent: categoria_,
                poliza_number:
                  $scope.caratula.poliza_number + " - INC. " + item.INCISO,
                natural: natural_,
                juridical: juridical_,
                ramo: $scope.caratula.ramo,
                subramo: $scope.caratula.subramo,
                paquete: item.PAQUETE,
                observations: "",
                old_policies: [],
                start_of_validity: inciso_start,
                end_of_validity: inciso_end,
                forma_de_pago: $scope.caratula.frecuencia_de_pago,
                status: status_,
                recibos_poliza: [],
                automobiles_policy: data_autos,
                damages_policy: [],
                accidents_policy: [],
                life_policy: [],
                document_type: 6,
                address: address_, // checar este
                // coverageInPolicy_policy: [], // checar si estas se agregan en el front o se agregarán en el back
                coverageInPolicy_policy: $scope.coberturas_paquete,
                endorsemeted: false,
                clave: $scope.caratula.clave,
                f_currency: $scope.caratula.f_currency,
                identifier:
                  data_autos[0].brand +
                  "-" +
                  data_autos[0].model +
                  "-" +
                  data_autos[0].year,
                p_total: $scope.p_total ? $scope.p_total : 0,
                derecho: $scope.derecho ? $scope.derecho : 0,
                rpf: $scope.rpf ? $scope.rpf : 0,
                p_neta: $scope.p_neta ? $scope.p_neta : 0,
                iva: $scope.iva ? $scope.iva : 0,
                comision: $scope.comision ? $scope.comision : 0,
                contacto: item.CONTACTO,
              };
              if (item.ANTIGUEDAD) {
                certData.rec_antiguedad = toDate(item.ANTIGUEDAD);
              }
              // console.log('certData',certData)

              certificadosArray.push(certData);
            });

            return certificadosArray;
          } else if (
            order.form.ramo.ramo_code == 3 &&
            order.form.subramo.subramo_code != 9
          ) {
            // DAÑOS
            var danios_certs = [];

            data.forEach(function (item) {
              if (!item.CONTACTO) {
                item.CONTACTO = "";
              }

              if (item.PAQUETE) {
                item.PAQUETE = item.PAQUETE;
              }

              if (item.PRIMA_NETA) {
                $scope.prima_neta = item.PRIMA_NETA;
              } else {
                $scope.prima_neta = 0;
              }
              if (item.DERECHO) {
                $scope.derecho = item.DERECHO;
              } else {
                $scope.derecho = 0;
              }
              if (item.RPF) {
                $scope.rpf = item.RPF;
              } else {
                $scope.rpf = 0;
              }
              if (item.IVA) {
                $scope.iva = item.IVA;
              } else {
                $scope.iva = 0;
              }
              var data_danios = [
                {
                  insured_item: item.NOMBRE,
                  item_address:
                    item.CALLE +
                    " #" +
                    item.NUMERO +
                    " " +
                    item.COLONIA +
                    " " +
                    item.DELEGACION +
                    " " +
                    item.CIUDAD +
                    " " +
                    item.ESTADO +
                    " C.P." +
                    item.CP,
                  document_type: 6,
                  p_neta: $scope.prima_neta,
                  derecho: $scope.derecho,
                  rpf: $scope.rpf,
                  iva: $scope.iva,
                },
              ];

              danios_certs.push(data_danios);

              if (item.CATEGORIA) {
                var categoria_ = parseInt(item.CATEGORIA);
              } else {
                var categoria_ = $scope.categoria_result.id;
              }

              if (item.SUBGRUPO) {
                for (var i = 0; i < order.subgroups.length; i++) {
                  var item_sub = order.subgroups[i];

                  if (item_sub.id == parseInt(item.SUBGRUPO)) {
                    if (item_sub.address) {
                      var address_ = item.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    } else {
                      var address_ = $scope.caratula.address;
                      var natural_ = item.natural;
                      var juridical_ = item.juridical;
                    }
                  }
                }
              } else {
                var address_ = $scope.caratula.address;
                var natural_ = $scope.caratula.natural;
                var juridical_ = $scope.caratula.juridical;
              }

              if ($scope.caratula.status == "En trámite") {
                var status_ = 1;
              } else {
                var status_ = 14;
              }

              if ($scope.caratula.f_currency == "PESOS") {
                var f_currency_ = 1;
              } else if ($scope.caratula.f_currency == "DOLARES") {
                var f_currency_ = 2;
              } else if ($scope.caratula.f_currency == "UDI") {
                var f_currency_ = 3;
              } else if ($scope.caratula.f_currency == "EURO") {
                var f_currency_ = 4;
              }

              if (order.show.ot) {
                var status_ = 1;
              } else {
                var status_ = 14;
              }

              if ($scope.config_saved.length) {
                $scope.config_saved.forEach(function (i) {
                  if (i.id == item.PAQUETE) {
                    $scope.coberturas_paquete = i.coveragesConfig;
                    $scope.coberturas_paquete.forEach(function (j) {
                      if (
                        $scope.caratula.subramo.subramo_name == "Gastos Médicos"
                      ) {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                      } else {
                        j.package = i.id;
                        j.sum_insured = j.sums_coverage[0].sum_insured;
                        j.deductible = j.deductible_coverage[0].deductible;
                      }
                    });
                  }
                });
              }

              // var inciso_start = new Date(toDate(item.INI_VIGENCIA))
              // var inciso_end = new Date(toDate(item.FIN_VIGENCIA))
              var inciso_start = toDate(item.INI_VIGENCIA);
              var inciso_end = toDate(item.FIN_VIGENCIA);

              var certData = {
                internalNumber: null,
                aseguradora: $scope.caratula.aseguradora.id,
                folio: null,
                caratula: $scope.caratula.id,
                certificate_number: parseInt(item.INCISO),
                parent: categoria_,
                poliza_number:
                  $scope.caratula.poliza_number + " - INC. " + item.INCISO,
                natural: natural_,
                juridical: juridical_,
                ramo: $scope.caratula.ramo.id,
                subramo: $scope.caratula.subramo.id,
                paquete: item.PAQUETE,
                observations: "",
                old_policies: [],
                start_of_validity: inciso_start,
                end_of_validity: inciso_end,
                forma_de_pago: $scope.caratula.frecuencia_de_pago,
                status: status_,
                recibos_poliza: [],
                automobiles_policy: [],
                damages_policy: data_danios,
                accidents_policy: [],
                life_policy: [],
                document_type: 6,
                address: address_, // checar este
                coverageInPolicy_policy: $scope.coberturas_paquete,
                endorsemeted: false,
                clave: $scope.caratula.clave.id,
                f_currency: f_currency_,
                identifier:
                  data_danios[0].insured_item +
                  "-" +
                  data_danios[0].item_addres,
                p_total: item.PRIMA_TOTAL,
                derecho: item.DERECHO ? item.DERECHO : 0,
                rpf: item.RPF ? item.RPF : 0,
                p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                iva: item.IVA ? item.IVA : 0,
                contacto: item.CONTACTO,
              };
              if (item.PRIMA_NETA) {
                $scope.prima_neta = item.PRIMA_NETA;
                certData.prima_neta = $scope.prima_neta;
              } else {
                $scope.prima_neta = 0;
                certData.prima_neta = $scope.prima_neta;
              }
              if (item.DERECHO) {
                $scope.derecho = item.DERECHO;
                certData.derecho = $scope.derecho;
              } else {
                $scope.derecho = 0;
                certData.derecho = $scope.derecho;
              }
              if (item.RPF) {
                $scope.rpf = item.RPF;
                certData.rpf = $scope.rpf;
              } else {
                $scope.rpf = 0;
                certData.rpf = $scope.rpf;
              }
              if (item.IVA) {
                $scope.iva = item.IVA;
                certData.iva = $scope.iva;
              } else {
                $scope.iva = 0;
                certData.iva = $scope.iva;
              }
              if (item.ANTIGUEDAD) {
                certData.rec_antiguedad = toDate(item.ANTIGUEDAD);
              }
              certificadosArray.push(certData);
            });

            return certificadosArray;
          } else {
            data.forEach(function (item) {
              var certificate = item.CERTIFICADO;
              if (order.form.subramo.subramo_name == "Vida") {
                if (item.TIPO == 2) {
                  var dataBeneficiary = {
                    certificate: certificate,
                    first_name: item.NOMBRE,
                    last_name: item.AP_PAT,
                    second_last_name: item.AP_MAT,
                    birthdate: toDate(item.FEC_NAC),
                    sex: item.SEXO,
                    percentage: item.PORCENTAJE,
                    optional_relationship: item.PARENTESCO,
                    familia: item.CERT_GRAL,
                  };
                  if (item.ANTIGUEDAD) {
                    dataBeneficiary.antiguedad = toDate(item.ANTIGUEDAD);
                  }

                  beneficiaries_life.push(dataBeneficiary);
                }
              } else if (order.form.ramo.ramo_code == 2) {
                // Accidentes y enfermedades

                if (item.TIPO == 2) {
                  var dataBeneficiary = {
                    certificate: certificate,
                    first_name: item.NOMBRE,
                    last_name: item.AP_PAT,
                    second_last_name: item.AP_MAT,
                    relationship: item.PARENTESCO,
                    birthdate: toDate(item.FEC_NAC),
                    sex: item.SEXO,
                    clause: item.INCISO,
                    familia: item.CERT_GRAL,
                  };
                  if (item.ANTIGUEDAD) {
                    dataBeneficiary.antiguedad = toDate(item.ANTIGUEDAD);
                  }

                  beneficiaries_gm.push(dataBeneficiary);
                  console.log("------dataBeneficiary-------", dataBeneficiary);
                }
              }
            });

            data.forEach(function (elem) {
              var certificate = elem.CERTIFICADO;
              if (order.form.subramo.subramo_name == "Vida") {
                if (elem.TIPO == 1) {
                  if (elem.FUMADOR) {
                    if (elem.FUMADOR == 0) {
                      var smoker = false;
                    } else {
                      var smoker = true;
                    }
                  }

                  var dataGM = [];
                  var dataVida = [
                    {
                      personal: {
                        certificate: certificate,
                        first_name: elem.NOMBRE,
                        last_name: elem.AP_PAT,
                        second_last_name: elem.AP_MAT,
                        birthdate: toDate(elem.FEC_NAC),
                        antiguedad: elem.ANTIGUEDAD
                          ? toDate(elem.ANTIGUEDAD)
                          : null,
                        sex: elem.SEXO,
                        email: elem.EMAIL,
                        salary: elem.SUELDO ? parseInt(elem.SUELDO) : 0,
                        sum_assured: elem.SUMA_ASEGURADA
                          ? parseInt(elem.SUMA_ASEGURADA)
                          : 0,
                      },
                      smoker: smoker,
                      beneficiaries_life: [],
                    },
                  ];

                  beneficiaries_life.forEach(function (i) {
                    if (i.familia == elem.CERT_GRAL) {
                      dataVida[0].beneficiaries_life.push(i);
                    }
                  });
                  // life_data.push(dataVida);
                }
              } else if (order.form.ramo.ramo_code == 2) {
                if (elem.TIPO == 1) {
                  var dataVida = [];
                  var dataGM = [
                    {
                      personal: {
                        certificate: certificate,
                        first_name: elem.NOMBRE,
                        last_name: elem.AP_PAT,
                        second_last_name: elem.AP_MAT,
                        birthdate: toDate(elem.FEC_NAC),
                        antiguedad: elem.ANTIGUEDAD
                          ? toDate(elem.ANTIGUEDAD)
                          : null,
                        email: elem.EMAIL,
                        sex: elem.SEXO,
                      },
                      disease_type: 0,
                      relationship_accident: [],
                    },
                  ];

                  beneficiaries_gm.forEach(function (i) {
                    if (i.familia == elem.CERT_GRAL) {
                      dataGM[0].relationship_accident.push(i);
                    }
                  });
                  // console.log('dataGM', dataGM);
                  // gm_data.push(dataGM);
                }
              }
              if (elem.TIPO == 1) {
                if (elem.CATEGORIA) {
                  var categoria_ = parseInt(elem.CATEGORIA);
                } else {
                  var categoria_ = $scope.categoria_result.id;
                }

                if (!elem.CONTACTO) {
                  elem.CONTACTO = "";
                }

                if (elem.SUBGRUPO) {
                  //// hacer for buscando coinicdencia con el id

                  for (var i = 0; i < order.subgroups.length; i++) {
                    var item = order.subgroups[i];

                    if (item.id == parseInt(elem.SUBGRUPO)) {
                      // console.log('ok');
                      if (item.address) {
                        var address_ = item.address;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      } else {
                        var address_ = null;
                        var natural_ = item.natural;
                        var juridical_ = item.juridical;
                      }
                    }
                  }
                } else {
                  // checar si tiene adress, si no, ponerle la de la caratula

                  var address_ = $scope.caratula.address_;
                  var natural_ = $scope.caratula.natural;
                  var juridical_ = $scope.caratula.juridical;
                }

                if ($scope.config_saved.length) {
                  $scope.config_saved.forEach(function (i) {
                    // console.log('i----------',i)
                    if (i.id == elem.PAQUETE) {
                      // console.log('i', i);
                      $scope.coberturas_paquete = i.coveragesConfig;
                      $scope.coberturas_paquete.forEach(function (j) {
                        if (
                          $scope.caratula.subramo.subramo_name ==
                          "Gastos Médicos"
                        ) {
                          j.package = i.id;
                          j.sum_insured = j.sums_coverage[0].sum_insured;
                          j.deductible = j.deductible_coverage[0].deductible;
                          j.coinsurance = j.coinsurance_coverage[0].coinsurance;
                        } else {
                          j.package = i.id;
                          j.sum_insured = j.sums_coverage[0].sum_insured;
                          j.deductible = j.deductible_coverage[0].deductible;
                          j.coinsurance = 0;
                        }
                      });
                    }
                  });
                }

                // var inciso_start = new Date(toDate(elem.INI_VIGENCIA))
                // var inciso_end = new Date(toDate(elem.FIN_VIGENCIA))
                var inciso_start = toDate(elem.INI_VIGENCIA);
                var inciso_end = toDate(elem.FIN_VIGENCIA);

                var certData = {
                  internalNumber: null,
                  folio: null,
                  caratula: $scope.caratula.id,
                  aseguradora: $scope.dataToSave.aseguradora,
                  certificate_number: parseInt(elem.CERTIFICADO),
                  parent: categoria_,
                  poliza_number:
                    $scope.caratula.poliza_number +
                    " - INC. " +
                    elem.CERTIFICADO,
                  natural: natural_,
                  juridical: juridical_,
                  ramo: $scope.caratula.ramo,
                  subramo: $scope.caratula.subramo,
                  paquete: elem.PAQUETE,
                  observations: elem.OBSERVATIONS,
                  old_policies: [],
                  forma_de_pago: $scope.caratula.frecuencia_de_pago,
                  status: par_status,
                  recibos_poliza: [],
                  automobiles_policy: [],
                  damages_policy: [],
                  accidents_policy: dataGM,
                  life_policy: dataVida,
                  document_type: 6,
                  address: address_, // checar este
                  // coverageInPolicy_policy: [], // checar si estas se agregan en el front o se agregarán en el back
                  coverageInPolicy_policy: $scope.coberturas_paquete,
                  endorsemeted: false,
                  clave: $scope.caratula.clave,
                  f_currency: $scope.caratula.f_currency,
                  identifier: elem.IDENTIFICADOR,
                  p_total: elem.PRIMA_TOTAL,
                  p_neta: elem.PRIMA_NETA ? elem.PRIMA_NETA : 0,
                  derecho: elem.DERECHO ? elem.DERECHO : 0,
                  rpf: elem.RPF ? elem.RPF : 0,
                  iva: elem.IVA ? elem.IVA : 0,
                  start_of_validity: inciso_start,
                  end_of_validity: inciso_end,
                  contacto: elem.CONTACTO,
                };
                if (elem.ANTIGUEDAD) {
                  certData.rec_antiguedad = toDate(elem.ANTIGUEDAD);
                }

                life_data = [];

                certificadosArray.push(certData);
              }
            });

            return certificadosArray;
          }
        }
      }
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function toDate(dateStr) {
      if (dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
        return dateObject;
      }
    }

    $rootScope.editTable = function () {
      $scope.editedReceipts = true;
      if ($rootScope.showInput == false) {
        $rootScope.showInput = true;
      } else {
        $rootScope.showInput = false;
      }
    };

    // Upload files
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
      // if ($uibModalInstance) {
      //     $uibModalInstance.dismiss('cancel');
      // }
      // $timeout(function() {
      //      // $state.go('polizas.table');
      // }, 1000);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      // console.log('uploader',fileItem)
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      fileItem.removeAfterUpload = true;
    };
    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.demo = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    var myInsurance = $stateParams.myInsurance;
    if (myInsurance != "some default") {
      var contrac = {};
      contrac.contratanteId = myInsurance.id;
      if (myInsurance.type_person == "Fisica") {
        contrac.type = "fisicas";
      }
      if (myInsurance.type_person == "Moral") {
        contrac.type = "morales";
      }
      ContratanteService.getContratanteFull(contrac).then(function (
        contractor
      ) {
        order.form.contratante = contractor;
        if (contractor.first_name) {
          order.form.contratante.val =
            contractor.first_name +
            " " +
            contractor.last_name +
            " " +
            contractor.second_last_name;
        }
        if (contractor.j_name) {
          order.form.contratante.val = contractor.j_name;
        }
        if (contractor.address_natural) {
          order.defaults.address = contractor.address_natural;
        }
        if (contractor.address_juridical) {
          order.defaults.address = contractor.address_juridical;
        }
        order.form.address = order.defaults.address[0];
        order.form.contratante.value = contractor;
      });
    }
    // Calculadora comision referenciador
    $scope.calculateComision = function (ref, index) {
      $rootScope.comVendedor = true;
      $scope.orderInfo = order;
      $localStorage.orderForm = JSON.stringify(order.form);
      console.log($scope.comVendedor, ref, index);
      var modalInstance = $uibModal.open({
        templateUrl: "app/ordenes/calculateComision.modal.html",
        controller: OrderComisionCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          referenciador: function () {
            return ref;
          },
          index: function () {
            return index;
          },
          form: function () {
            return order.form;
          },
          from: function () {
            return null;
          },
          primaTotal: function () {
            return order.poliza.primaTotal;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };
    // Calcular comisión ppor referenciador
    function OrderComisionCtrl(
      $scope,
      from,
      $sessionStorage,
      $uibModalInstance,
      referenciador,
      index,
      form,
      $http,
      MESSAGES,
      toaster,
      primaTotal
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $rootScope.valueMonto = primaTotal;
      $rootScope.valueComInicial = 0;
      $rootScope.valueComision = 0;
      if (referenciador) {
        $http.get(referenciador.referenciador).then(function (data) {
          if (data.status == 200 || data.status == 201) {
            if (data.data) {
              $rootScope.name =
                data.data.first_name + " " + data.data.last_name;
              if (data.data.user_info) {
                if (data.data.user_info.info_vendedor[0]) {
                  $rootScope.valueGo =
                    data.data.user_info.info_vendedor[0].gastos_operacion;
                }
              }
            }
          }
        });
      }
      // Change monto --> calc comision
      $scope.changeMonto = function (go, monto, com, comI) {
        if (isNaN(monto)) {
          var toNumber = $scope.formatearNumero(monto);
          if (isNaN(toNumber)) {
            $rootScope.valueMonto = "";
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        }
      };
      $scope.comCalculatePeso = function (monto, comision) {
        if (
          isNaN(monto) ||
          isNaN(comision) ||
          parseFloat(comision) > parseFloat(monto)
        ) {
          if (parseFloat(comision) > parseFloat(monto)) {
            SweetAlert.swal(
              "Error",
              "Cantidad capturada en comisión no puede ser mayor a la prima total",
              "error"
            );
            $rootScope.valueComision = 0;
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        } else {
          $rootScope.valueComision = parseFloat(
            (parseFloat(comision) * 100) / parseFloat(monto)
          ).toFixed(2);
        }
      };
      $scope.validComision = function (comI) {
        if (isNaN(comI)) {
          $rootScope.valueComInicial = 0;
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
        }
      };
      $scope.cTotal = function (monto, com, comVendedor) {
        referenciador.comision_vendedor = comVendedor;
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.cancelCalculate = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
      $scope.formatearNumero = function (nStr) {
        nStr += "";
        var x = nStr.split(".");
        var x1 = x[0];
        var x2 = x.length > 1 ? "." + x[1] : "";
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + "," + "$2");
        }

        return x1 + x2;
      };
    }
    // configuraciÃƒÂ³n del datepicker
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

angular.module("inspinia").controller("TestingCtrl", TestingCtrl);

TestingCtrl.$inject = [
  "insuranceService",
  "receiptService",
  "statusReceipt",
  "helpers",
  "pdfService",
];

function TestingCtrl(
  insuranceService,
  receiptService,
  statusReceipt,
  helpers,
  pdfService
) {
  var vm = this;
  vm.itemArray = [
    { id: 1, name: "first" },
    { id: 2, name: "second" },
    { id: 3, name: "third" },
    { id: 4, name: "fourth" },
    { id: 5, name: "fifth" },
  ];

  vm.selectedItem = vm.itemArray[0];

  //var scream = document.getElementById('scream');
  //var myCanvas = document.getElementById('imgCanvas');
  //var ctx = myCanvas.getContext('2d');
  // ctx.drawImage(scream, 10, 10 );

  //var img = new Image();
  //img.setAttribute('crossOrigin', 'anonymous');
  //img.onload = function () {
  //  ctx.drawImage(img, 0, 0); // Or at whatever offset you like
  //};
  //img.src = 'http://localhost:3000/logo.jpg';

  vm.cli = doPdf;
  //vm.cli = function () {
  // var img = 'http://pak101.com/forum/HotEngine/2011/6/13/innocent_cat_zlxso.jpg';
  // helpers.convertToDataURLviaCanvas(img, function(base64Img) {
  //     // Base64DataURL
  // ////console.log(img, base64Img)
  // });
  //var dataAss = myCanvas.toDataURL();
  /////console.log('dataAss', dataAss)

  // dataAss.replace("image/png", "image/octet-stream");
  ////console.log('dataAss', dataAss)

  // ////console.log('canvas.toDataURL()', myCanvas.toDataURL('image/jpg'));
  // ////console.log('canvas.toDataURL()', myCanvas.toDataURL());
  // ////console.log(myCanvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''))
  // ////console.log('img', img.toDataURL());

  //var docDefinition = {
  //  content: [
  //    'pdfmake (since it\'s based on pdfkit) supports JPEG and PNG format',
  //    'If no width/height/fit is provided, image original size will be used', {
  //      image: '../assets/images/logo.png'
  //    }
  //  ]
  //}
  function doPdf() {
    //pdfService.makePdf(rawrContent);
    pdfService.getPdf(3); // pon aqui directamente el ID de una poliza / ot o tambien puede ser objeto obtenido de leer-polzas
  }
  //var content = buildContent(rawrContent)
  ////console.log(content);
  //pdfMake.createPdf(content).open();
}

(function () {
  "use strict";

  angular.module("inspinia").controller("TareasModalCtrl", TareasModalCtrl);

  TareasModalCtrl.$inject = [
    "$http",
    "$scope",
    "$uibModal",
    "$uibModalInstance",
    "dataFactory",
    "task",
    "datesFactory",
    "SweetAlert",
    "MESSAGES",
    "data",
    "associated",
    "route",
    "modelo",
    "$state",
    "$sessionStorage",
    "FileUploader",
    "url",
    "receipt",
    "appStates",
    "$localStorage",
    "$location",
  ];

  function TareasModalCtrl(
    $http,
    $scope,
    $uibModal,
    $uibModalInstance,
    dataFactory,
    task,
    datesFactory,
    SweetAlert,
    MESSAGES,
    data,
    associated,
    route,
    modelo,
    $state,
    $sessionStorage,
    FileUploader,
    url,
    receipt,
    appStates,
    $localStorage,
    $location
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    $(".datepicker-me input").datepicker();

    $(".js-example-basic-multiple").select2();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
    $scope.historic_email = false;

    $scope.vm = this;
    var vm = this;

    vm.email_send_historic = "";
    $scope.involved = [];

    $scope.priorities = [
      {
        id: 1,
        name: "Alta",
      },
      {
        id: 2,
        name: "Media",
      },
      {
        id: 3,
        name: "Baja",
      },
    ];

    $scope.concepts = [
      {
        id: 1,
        name: "Cotización",
      },
      {
        id: 2,
        name: "Emisión",
      },
      {
        id: 3,
        name: "Endoso A",
      },
      {
        id: 4,
        name: "Corrección",
      },
      {
        id: 5,
        name: "Cancelación",
      },
      {
        id: 6,
        name: "Renovación",
      },
      {
        id: 7,
        name: "Otro",
      },
      {
        id: 8,
        name: "Reembolso",
      },
      {
        id: 9,
        name: "Programación de cirugía",
      },
      {
        id: 10,
        name: "Endoso B",
      },
      {
        id: 11,
        name: "Endoso D",
      },
      {
        id: 12,
        name: "Reconocimiento de antigüedad",
      },
      {
        id: 13,
        name: "Carta de antigüedad",
      },
    ];

    vm.showRecordatorios = showRecordatorios;
    function showRecordatorios() {
      vm.infoFlag = false;
      vm.recordatoriosFlag = true;
    }
    $scope.createRecordatorio = function (registroSelected, tipo) {
      $uibModalInstance.close();
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return $scope.vm.form;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    };
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    activate();

    function activate() {
      if (
        $location.path().indexOf("info") != -1 ||
        $location.path().indexOf("polizas") != -1 ||
        $location.path().indexOf("endoso") != -1 ||
        $location.path().indexOf("flotillas") != -1 ||
        $location.path().indexOf("info") != -1 ||
        $location.path().indexOf("cotizacion") != -1
      ) {
        $scope.desdeOT = true;
      } else {
        $scope.desdeOT = false;
      }
      $scope.emails_users = [];
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              } else if (acc.permission_name == "Cancelar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_canc_pol = true;
                } else {
                  vm.acceso_canc_pol = false;
                }
              } else if (acc.permission_name == "Eliminar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_elim_pol = true;
                } else {
                  vm.acceso_elim_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            vm.acceso_reportes = perm;
            vm.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  vm.acceso_rep_fia = true;
                } else {
                  vm.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  vm.acceso_rep_sin = true;
                } else {
                  vm.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  vm.acceso_rep_end = true;
                } else {
                  vm.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  vm.acceso_rep_pol = true;
                } else {
                  vm.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  vm.acceso_rep_ren = true;
                } else {
                  vm.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  vm.acceso_rep_cob = true;
                } else {
                  vm.acceso_rep_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Ordenes de trabajo") {
            vm.acceso_ot = perm;
            vm.acceso_ot.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar OTs") {
                if (acc.checked == true) {
                  vm.acceso_adm_ot = true;
                } else {
                  vm.acceso_adm_ot = false;
                }
              } else if (acc.permission_name == "Ver OTs") {
                if (acc.checked == true) {
                  vm.acceso_ver_ot = true;
                } else {
                  vm.acceso_ver_ot = false;
                }
              } else if (acc.permission_name == "Cancelar OTs") {
                if (acc.checked == true) {
                  vm.acceso_canc_ot = true;
                } else {
                  vm.acceso_canc_ot = false;
                }
              } else if (acc.permission_name == "Eliminar OTs") {
                if (acc.checked == true) {
                  vm.acceso_elim_ot = true;
                } else {
                  vm.acceso_elim_ot = false;
                }
              }
            });
          } else if (perm.model_name == "Contratantes y grupos") {
            vm.acceso_contg = perm;
            vm.acceso_contg.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar contratantes y grupos") {
                if (acc.checked == true) {
                  vm.acceso_adm_cont = true;
                } else {
                  vm.acceso_adm_cont = false;
                }
              } else if (acc.permission_name == "Ver contratantes y grupos") {
                if (acc.checked == true) {
                  vm.acceso_ver_cont = true;
                } else {
                  vm.acceso_ver_cont = false;
                }
              }
            });
          } else if (perm.model_name == "Siniestros") {
            vm.acceso_sin = perm;
            vm.acceso_sin.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar siniestros") {
                if (acc.checked == true) {
                  vm.acceso_adm_sin = true;
                } else {
                  vm.acceso_adm_sin = false;
                }
              }
            });
          } else if (perm.model_name == "Mensajeria") {
            vm.acceso_mns = perm;
            vm.acceso_mns.permissions.forEach(function (acc) {
              if (acc.permission_name == "Mensajeria") {
                if (acc.checked == true) {
                  vm.acceso_mns = true;
                } else {
                  vm.acceso_mns = false;
                }
              }
            });
          } else if (perm.model_name == "Formatos") {
            vm.acceso_form = perm;
            vm.acceso_form.permissions.forEach(function (acc) {
              if (acc.permission_name == "Formatos") {
                if (acc.checked == true) {
                  vm.acceso_form = true;
                } else {
                  vm.acceso_form = false;
                }
              }
            });
          } else if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Referenciadores") {
            vm.acceso_ref = perm;
            vm.acceso_ref.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar referenciadores") {
                if (acc.checked == true) {
                  vm.acceso_adm_ref = true;
                } else {
                  vm.acceso_adm_ref = false;
                }
              } else if (acc.permission_name == "Pagar a referenciadores") {
                if (acc.checked == true) {
                  vm.acceso_pag_ref = true;
                } else {
                  vm.acceso_pag_ref = false;
                }
              } else if (
                acc.permission_name == "Cambiar refrenciador en pólizas"
              ) {
                if (acc.checked == true) {
                  vm.acceso_chg_ref = true;
                } else {
                  vm.acceso_chg_ref = false;
                }
              }
            });
          } else if (perm.model_name == "Fianzas") {
            vm.acceso_fianzas = perm;
            vm.acceso_fianzas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar fianzas") {
                if (acc.checked == true) {
                  vm.acceso_adm_fia = true;
                } else {
                  vm.acceso_adm_fia = false;
                }
              } else if (acc.permission_name == "Ver fianzas") {
                if (acc.checked == true) {
                  vm.acceso_ver_fia = true;
                } else {
                  vm.acceso_ver_fia = false;
                }
              } else if (acc.permission_name == "Cancelar fianzas") {
                if (acc.checked == true) {
                  vm.acceso_canc_fia = true;
                } else {
                  vm.acceso_canc_fia = false;
                }
              } else if (acc.permission_name == "Eliminar fianzas") {
                if (acc.checked == true) {
                  vm.acceso_elim_fia = true;
                } else {
                  vm.acceso_elim_fia = false;
                }
              }
            });
          }
        });
      }
      if (task) {
        $scope.ticket1 = angular.copy(task);
        $scope.vm.form = angular.copy(task);
        $scope.original_assigned = $scope.vm.form.assigned;
        if (!$scope.original_assigned.url) {
          $http
            .get(url.IP + "usuarios/" + $scope.original_assigned.id)
            .then(function (response) {
              $scope.original_assigned = response.data;
              $scope.vm.form.assigned = response.data;
            });
        }
        $scope.title = "Tarea";
        $scope.vm.form.compromiso = datesFactory.convertDate(
          $scope.vm.form.date
        );
        $scope.vm.form.priority =
          $scope.priorities[$scope.vm.form.priority - 1];
        $scope.vm.form.concept = $scope.concepts[$scope.vm.form.concept - 1];
        var selected_user = [];
        if (task.model == 7) {
          dataFactory
            .get("contractor/" + task.associated)
            .then(function (request) {
              $scope.contractorNew = request.data;
            })
            .catch(function (e) {
              console.log("e", e);
            });
        }
        $.each(task.involved_task, function (i, e) {
          selected_user.push(e.person.id);
        });
        $scope.selected_user = selected_user;
        var params = {
          model: 22,
          id_model: task.id,
        };
        dataFactory
          .get("comments/", params)
          .then(function (request) {
            vm.comments_data = request.data.results;
            vm.comments_config = {
              count: request.data.count,
              previous: request.data.previous,
              next: request.data.next,
            };
          })
          .catch(function (e) {
            console.log("e", e);
          });

        $http
          .get(url.IP + "ticket/" + task.id + "/archivos/")
          .then(function (response) {
            if (response.status === 200) {
              vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.show_files_policy = true;
            } else if (response.status === 403) {
              $scope.show_files_policy = false;
            }
          });

        vm.polizaId = task.id;
      } else if (data) {
        $scope.vm.form = {};
        $scope.title = "Crear nueva tarea";
        $scope.vm.form.title = data;
        $scope.vm.form.route = route;
      } else {
        $scope.task = {};
        $scope.title = "Crear nueva tarea";
      }
      $http.post(url.IP + "emailsUsers").then(function (response) {
        $scope.emails_users = response.data.emails;
        $scope.historic_email = false;
      });
      dataFactory.get("usuarios/").then(function (data) {
        $scope.users = data.data.results;
        if ($scope.selected_user) {
          var selected_user = [];
          $.each(data.data.results, function (i, e) {
            if ($scope.selected_user.includes(e.id)) {
              selected_user.push(e);
            }
          });
          $scope.select_user = selected_user;
        }
      });

      $scope.track_task_id = "";
      $scope.track_task_entity_number = "";
      switch (vm.form.model) {
        case 1:
          $scope.origin_task = "póliza";
          $scope.track_task_id = "";
          break;
        case 2:
          $scope.origin_task = "endoso";
          $http
            .get(url.IP + "endorsement-single/" + vm.form.associated + "/")
            .then(function (responseEndoso) {
              if (responseEndoso.data["number_endorsement"] != "") {
                $scope.track_task_entity_number =
                  "Número de endoso: " +
                  responseEndoso.data["number_endorsement"];
              }
              if (responseEndoso.data["numero_poliza"] != "") {
                $scope.track_task_entity_number =
                  $scope.track_task_entity_number +
                  " - " +
                  "Número de póliza: " +
                  responseEndoso.data["numero_poliza"];
              }
              $scope.track_task_id =
                "Folio de endoso: " + responseEndoso.data["internal_number"];
            });
          break;
        case 3:
          $scope.origin_task = "póliza";
          $scope.track_task_id = "";
          break;
        case 4:
          $scope.origin_task = "póliza";
          $scope.track_task_id = "";
          break;
        case 5:
          $scope.origin_task = "póliza";
          $scope.track_task_id = "";
          break;
        case 6:
          $scope.origin_task = "siniestro";
          $scope.track_task_id = "";
          break;
        case 7:
          $scope.origin_task = "contratante";
          $scope.track_task_id = "";
          break;
        case 8:
          $scope.origin_task = "fianza";
          $scope.track_task_id = "";
          break;
        case 9:
          $scope.origin_task = "endoso";
          $scope.track_task_id = "";
          break;
        case 18:
          $scope.origin_task = "Póliza de grupo";
          $scope.track_task_id = "";
          break;
        case 28:
          $scope.origin_task = "colectividad";
          $scope.track_task_id = "";
          break;
        case 30:
          $scope.origin_task = "Cotización";
          $scope.track_task_id = "";
          break;
        default:
          break;
      }
    }

    $scope.close = function () {
      $uibModalInstance.close();
    };
    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $uibModalInstance.close();
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };
    $scope.selectUser = function (obj) {
      $scope.involved = [];
      obj.forEach(function (child) {
        child.person = child.url;
      });
      $scope.involved = obj;
    };

    $scope.saveTask = function () {
      var data_to_send = vm.form;
      data_to_send.involved_task = $scope.involved;
      data_to_send.assigned = vm.form.assigned.url;
      data_to_send.priority = vm.form.priority.id;
      data_to_send.concept = vm.form.concept ? vm.form.concept.id : 7;
      data_to_send.date = new Date(datesFactory.toDate(vm.form.compromiso));
      data_to_send.associated = associated;
      data_to_send.route = route;
      data_to_send.model = modelo;
      dataFactory
        .post("save-ticket/", data_to_send)
        .then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            var params = {
              model: 22,
              event: "POST",
              associated_id: response.data.id,
              identifier: "creó la tarea.",
            };

            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});

            if (receipt) {
              var params = {
                model: 4,
                event: "POST",
                associated_id: receipt,
                identifier: "creó una tarea con este recibo.",
              };

              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }

            uploadFiles(response.data);
            SweetAlert.swal("¡Hecho!", MESSAGES.OK.SAVETICKET, "success");
            $uibModalInstance.close();
          }
        });
    };

    $scope.updateTask = function () {
      $scope.name_assiged =
        vm.form.assigned.first_name + " " + vm.form.assigned.last_name;
      $scope.original_assigned_name =
        $scope.original_assigned.first_name +
        " " +
        $scope.original_assigned.last_name;
      vm.form.involved_task = $scope.involved;
      vm.form.assigned = vm.form.assigned.id;
      vm.form.priority = vm.form.priority.id;
      vm.form.concept = vm.form.concept ? vm.form.concept.id : 7;
      vm.form.route = vm.form.route;
      vm.form.owner = vm.form.owner.url;
      vm.form.model = vm.form.model;
      vm.form.date = new Date(datesFactory.toDate(vm.form.compromiso));
      if (vm.form.closedBy) {
        vm.form.closedBy = vm.form.closedBy.url;
      }
      $scope.changeAssigned = false;
      if (vm.form.assigned != $scope.original_assigned.url) {
        $scope.changeAssigned = true;
      }
      delete vm.form.archived;

      $http.patch(vm.form.url, vm.form).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          var involved_list = [];
          response.data.involved_task.forEach(function (inv) {
            var url = inv.person;
            var id_person = inv.id;
            $http.get(url).then(function (response) {
              if (response.status === 200) {
                involved_list.push({ id: id_person, person: response.data });
              }
            });
          });
          task.involved_task = involved_list;
          var params = {
            model: 22,
            event: "POST",
            associated_id: response.data.id,
            identifier: "actualizó la tarea.",
          };

          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          if ($scope.changeAssigned) {
            var params = {
              model: 22,
              event: "PATCH",
              associated_id: response.data.id,
              identifier:
                "actualizó la tarea; reasignándola de " +
                $scope.original_assigned_name +
                " a " +
                $scope.name_assiged +
                ".",
            };

            dataFactory
              .post("send-log/", params)
              .then(function success(response) {
                console.log(
                  "----------response log-----reasignación----",
                  response
                );
              });
          }
          uploadFiles(response.data);

          $uibModalInstance.close({ response: response });
          SweetAlert.swal("¡Listo!", MESSAGES.INFO.QUOTATIONCHANGE, "success");
          $state.reload();
        }
      });
    };

    $scope.goToRegis = function () {
      var params = {};
      if (vm.form.model == 1) {
        if (vm.acceso_ver_ot) {
          var name = "Información póliza";
          var route = "polizas.info";
          params = {
            polizaId: vm.form.associated,
          };
        }
      } else if (vm.form.model == 2) {
        if (vm.acceso_ver_ot) {
          var name = "Información endoso";
          var route = "endorsement.info";
        }
      } else if (vm.form.model == 3 || vm.form.model == 4) {
        if (vm.acceso_ver_pol) {
          var name = "Información póliza";
          var route = "polizas.info";
        }
      } else if (vm.form.model == 5) {
        if (vm.acceso_ver_pol) {
          var name = "Información póliza";
          var route = "polizas.info";
        }
      } else if (vm.form.model == 7) {
        if (vm.acceso_ver_cont) {
          if (
            $scope.contractorNew.type_person == 1 ||
            $scope.contractorNew.type_person == "Física"
          ) {
            var name = "Información contratante";
            var route = "contratantes.info";
            params = {
              type: "fisicas",
              contratanteId: $scope.contractorNew.id,
            };
          } else if (
            $scope.contractorNew.type_person == 2 ||
            $scope.contractorNew.type_person == "Moral"
          ) {
            var name = "Información contratante";
            var route = "contratantes.info";
            params = {
              type: "morales",
              contratanteId: $scope.contractorNew.id,
            };
          }
        }
      } else if (vm.form.model == 8) {
        if (vm.acceso_ver_fia) {
          var name = "Información fianza";
          var route = "fianzas.info";
        }
      } else if (vm.form.model == 9) {
        if (vm.acceso_ver_ot) {
          var name = "Información endoso";
          var route = "endorsement.info";
        }
      } else if (vm.form.model == 6) {
        var name = "Información siniestro";
        var route = "siniestros.info";
      } else if (vm.form.model == 18) {
        var name = "Información colectividad";
        var route = "colectividades.info";
      } else if (vm.form.model == 28) {
        var name = "Información flotilla";
        var route = "flotillas.info";
      } else if (vm.form.model == 30) {
        var name = "Información Cotización";
        var route = "cotizacion.info";
        var params = { id: vm.form.associated };
      }

      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      // Si esto se va a modificar, analizar con backend porque estan ligados directamente a los modelos
      // de creación de rutas para las tareas desde la bitacora
      if (vm.form.model == 1) {
        if (vm.acceso_ver_ot) {
          $state.go("polizas.info", { polizaId: vm.form.associated });
          $scope.close();
        }
      } else if (vm.form.model == 2) {
        if (vm.acceso_ver_ot) {
          $state.go("endorsement.info", { endosoId: vm.form.associated });
          $scope.close();
        }
      } else if (vm.form.model == 3 || vm.form.model == 4) {
        if (vm.acceso_ver_pol) {
          $state.go("polizas.info", { polizaId: vm.form.associated });
          $scope.close();
        }
      } else if (vm.form.model == 5) {
        if (vm.acceso_ver_pol) {
          $state.go("polizas.info", { polizaId: vm.form.associated });
          $scope.close();
        }
      } else if (vm.form.model == 7) {
        if (vm.acceso_ver_cont) {
          if ($scope.contractorNew.type_person == 1) {
            $state.go("contratantes.info", {
              type: "fisicas",
              contratanteId: $scope.contractorNew.id,
            });
            $scope.close();
          } else if ($scope.contractorNew.type_person == 2) {
            $state.go("contratantes.info", {
              type: "morales",
              contratanteId: $scope.contractorNew.id,
            });
            $scope.close();
          }
        }
      } else if (vm.form.model == 8) {
        if (vm.acceso_ver_fia) {
          $state.go("fianzas.info", { fianzaId: vm.form.associated });
          $scope.close();
        }
      } else if (vm.form.model == 9) {
        if (vm.acceso_ver_ot) {
          $state.go("endorsement.info", { endosoId: vm.form.associated });
          $scope.close();
        }
      } else if (vm.form.model == 6) {
        $state.go("siniestros.info", { siniestroId: vm.form.associated });
        $scope.close();
      } else if (vm.form.model == 18) {
        $state.go("colectividades.info", { polizaId: vm.form.associated });
        $scope.close();
      } else if (vm.form.model == 28) {
        $state.go("flotillas.info", { polizaId: vm.form.associated });
        $scope.close();
      } else if (vm.form.model == 30) {
        $state.go("cotizacion.info", { polizaId: vm.form.associated });
        $scope.close();
      }
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    // Change User
    vm.emails_selected = [];
    $scope.changeEmailSendH = function (x, y) {
      vm.emails_selected = [];
      x.forEach(function (r) {
        vm.emails_selected.push(r);
      });
    };
    $scope.selectManualEmails = function (x, y) {
      vm.emails_selected_manual = [];
      x.forEach(function (r) {
        $scope.invalidEmail = r;
        vm.emails_selected_manual.push(r);
      });
    };

    $scope.send_historic_email = function () {
      if ($scope.historic_email) {
        $scope.historic_email = false;
      } else {
        $scope.historic_email = true;
      }
    };
    // Send historic task to email
    $scope.send_historic = function (obj) {
      vm.emails_manuales = [];
      $scope.validate_email = false;
      $scope.invalidEmail = "";
      if ($scope.email_x == 2 || $scope.email_x == "2") {
        if (vm.emails_selected) {
          if (vm.emails_selected.length > 0) {
            $scope.validate_email = true;
          } else {
            $scope.validate_email = false;
          }
        } else {
          $scope.validate_email = false;
        }
      } else if ($scope.email_x == 1 || $scope.email_x == "1") {
        vm.emails_selected = [];
        $scope.validate_email = true;
        vm.email_tags = vm.emails_selected_manual;
        if (vm.email_tags) {
          vm.email_tags.forEach(function (email) {
            if (!validateEmail(email)) {
              $scope.invalidEmail = email;
              SweetAlert.swal(
                "Correo inválido",
                MESSAGES.ERROR.REVIEWEMAIL + " " + email,
                "error"
              );
              $scope.validate_email = false;
              return;
            } else {
              vm.emails_manuales.push(email);
            }
          });
        }
      }
      if ($scope.validate_email) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $http
          .post(url.IP + "send-historic-email", {
            email: vm.emails_manuales,
            id_tarea: obj.id,
            type_email: $scope.email_x,
            emails_selected: vm.emails_selected,
          })
          .then(function (response) {
            if (response.data.status == "send") {
              SweetAlert.swal("Enviado", MESSAGES.OK.HISTSENDEMAIL, "success");
              vm.email_send_historic = "";
              l.stop();
              $scope.historic_email = false;
            } else {
              SweetAlert.swal(
                "No Enviado",
                MESSAGES.ERROR.HISTERRORSENDEMAIL,
                "error"
              );
              l.stop();
              $scope.historic_email = false;
            }
          });
      } else {
        SweetAlert.swal(
          "Correo inválido",
          MESSAGES.ERROR.REVIEWEMAIL + " " + $scope.invalidEmail,
          "error"
        );
      }
    };

    /* Uploader files */

    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.ramo == undefined) {
        item.ramo = 2;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].ramo = item.ramo;
    };

    function uploadFiles(ticketId) {
      console.log(ticketId);
      $scope.userInfo = {
        id: ticketId.id,
      };
      $scope.userInfo.url = url.IP + "ticket/" + ticketId.id + "/archivos/";
      $scope.uploader.uploadAll();
    }

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
      console.log(uploader.queue);
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("TareasCrearOTModalController", TareasCrearOTModalController);

  TareasCrearOTModalController.$inject = [
    "$http",
    "$scope",
    "$uibModal",
    "$uibModalInstance",
    "dataFactory",
    "task",
    "datesFactory",
    "SweetAlert",
    "MESSAGES",
    "data",
    "associated",
    "route",
    "modelo",
    "$state",
    "$sessionStorage",
    "FileUploader",
    "url",
    "receipt",
    "appStates",
    "$localStorage",
    "$stateParams",
    "$rootScope",
  ];

  function TareasCrearOTModalController(
    $http,
    $scope,
    $uibModal,
    $uibModalInstance,
    dataFactory,
    task,
    datesFactory,
    SweetAlert,
    MESSAGES,
    data,
    associated,
    route,
    modelo,
    $state,
    $sessionStorage,
    FileUploader,
    url,
    receipt,
    appStates,
    $localStorage,
    $stateParams,
    $rootScope
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
    $scope.historic_email = false;

    $scope.vm = this;
    var vm = this;

    vm.email_send_historic = "";
    $scope.involved = [];
    $scope.seletedtOT = "";

    $scope.priorities = [
      {
        id: 1,
        name: "Alta",
      },
      {
        id: 2,
        name: "Media",
      },
      {
        id: 3,
        name: "Baja",
      },
    ];

    $scope.concepts = [
      {
        id: 1,
        name: "Cotización",
      },
      {
        id: 2,
        name: "Emisión",
      },
      {
        id: 3,
        name: "Endoso A",
      },
      {
        id: 4,
        name: "Corrección",
      },
      {
        id: 5,
        name: "Cancelación",
      },
      {
        id: 6,
        name: "Renovación",
      },
      {
        id: 7,
        name: "Otro",
      },
      {
        id: 8,
        name: "Reembolso",
      },
      {
        id: 9,
        name: "Programación de cirugía",
      },
      {
        id: 10,
        name: "Endoso B",
      },
      {
        id: 11,
        name: "Endoso D",
      },
      {
        id: 12,
        name: "Reconocimiento de antigüedad",
      },
      {
        id: 13,
        name: "Carta de antigüedad",
      },
    ];

    $scope.selectedOTOptions = [
      {
        id: 1,
        name: "Póliza Individual",
      },
      {
        id: 2,
        name: "Flotilla",
      },
      {
        id: 3,
        name: "Póliza de Grupo",
      },
      {
        id: 4,
        name: "Fianza",
      },
      {
        id: 5,
        name: "Fianza de colectividad",
      },
    ];
    $scope.selectedEndosoOptions = [
      {
        id: 6,
        name: "Póliza Individual",
      },
      {
        id: 7,
        name: "Fianza Individual",
      },
      {
        id: 8,
        name: "Póliza Grupo",
      },
      {
        id: 9,
        name: "Fianza Colectiva",
      },
    ];

    vm.showRecordatorios = showRecordatorios;
    function showRecordatorios() {
      vm.infoFlag = false;
      vm.recordatoriosFlag = true;
    }
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    activate();

    function activate() {
      $scope.emails_users = [];
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              } else if (acc.permission_name == "Cancelar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_canc_pol = true;
                } else {
                  vm.acceso_canc_pol = false;
                }
              } else if (acc.permission_name == "Eliminar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_elim_pol = true;
                } else {
                  vm.acceso_elim_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            vm.acceso_reportes = perm;
            vm.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  vm.acceso_rep_fia = true;
                } else {
                  vm.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  vm.acceso_rep_sin = true;
                } else {
                  vm.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  vm.acceso_rep_end = true;
                } else {
                  vm.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  vm.acceso_rep_pol = true;
                } else {
                  vm.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  vm.acceso_rep_ren = true;
                } else {
                  vm.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  vm.acceso_rep_cob = true;
                } else {
                  vm.acceso_rep_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Ordenes de trabajo") {
            vm.acceso_ot = perm;
            vm.acceso_ot.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar OTs") {
                if (acc.checked == true) {
                  vm.acceso_adm_ot = true;
                } else {
                  vm.acceso_adm_ot = false;
                }
              } else if (acc.permission_name == "Ver OTs") {
                if (acc.checked == true) {
                  vm.acceso_ver_ot = true;
                } else {
                  vm.acceso_ver_ot = false;
                }
              } else if (acc.permission_name == "Cancelar OTs") {
                if (acc.checked == true) {
                  vm.acceso_canc_ot = true;
                } else {
                  vm.acceso_canc_ot = false;
                }
              } else if (acc.permission_name == "Eliminar OTs") {
                if (acc.checked == true) {
                  vm.acceso_elim_ot = true;
                } else {
                  vm.acceso_elim_ot = false;
                }
              }
            });
          } else if (perm.model_name == "Contratantes y grupos") {
            vm.acceso_contg = perm;
            vm.acceso_contg.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar contratantes y grupos") {
                if (acc.checked == true) {
                  vm.acceso_adm_cont = true;
                } else {
                  vm.acceso_adm_cont = false;
                }
              } else if (acc.permission_name == "Ver contratantes y grupos") {
                if (acc.checked == true) {
                  vm.acceso_ver_cont = true;
                } else {
                  vm.acceso_ver_cont = false;
                }
              }
            });
          } else if (perm.model_name == "Siniestros") {
            vm.acceso_sin = perm;
            vm.acceso_sin.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar siniestros") {
                if (acc.checked == true) {
                  vm.acceso_adm_sin = true;
                } else {
                  vm.acceso_adm_sin = false;
                }
              }
            });
          } else if (perm.model_name == "Mensajeria") {
            vm.acceso_mns = perm;
            vm.acceso_mns.permissions.forEach(function (acc) {
              if (acc.permission_name == "Mensajeria") {
                if (acc.checked == true) {
                  vm.acceso_mns = true;
                } else {
                  vm.acceso_mns = false;
                }
              }
            });
          } else if (perm.model_name == "Formatos") {
            vm.acceso_form = perm;
            vm.acceso_form.permissions.forEach(function (acc) {
              if (acc.permission_name == "Formatos") {
                if (acc.checked == true) {
                  vm.acceso_form = true;
                } else {
                  vm.acceso_form = false;
                }
              }
            });
          } else if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Referenciadores") {
            vm.acceso_ref = perm;
            vm.acceso_ref.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar referenciadores") {
                if (acc.checked == true) {
                  vm.acceso_adm_ref = true;
                } else {
                  vm.acceso_adm_ref = false;
                }
              } else if (acc.permission_name == "Pagar a referenciadores") {
                if (acc.checked == true) {
                  vm.acceso_pag_ref = true;
                } else {
                  vm.acceso_pag_ref = false;
                }
              } else if (
                acc.permission_name == "Cambiar refrenciador en pólizas"
              ) {
                if (acc.checked == true) {
                  vm.acceso_chg_ref = true;
                } else {
                  vm.acceso_chg_ref = false;
                }
              }
            });
          } else if (perm.model_name == "Fianzas") {
            vm.acceso_fianzas = perm;
            vm.acceso_fianzas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar fianzas") {
                if (acc.checked == true) {
                  vm.acceso_adm_fia = true;
                } else {
                  vm.acceso_adm_fia = false;
                }
              } else if (acc.permission_name == "Ver fianzas") {
                if (acc.checked == true) {
                  vm.acceso_ver_fia = true;
                } else {
                  vm.acceso_ver_fia = false;
                }
              } else if (acc.permission_name == "Cancelar fianzas") {
                if (acc.checked == true) {
                  vm.acceso_canc_fia = true;
                } else {
                  vm.acceso_canc_fia = false;
                }
              } else if (acc.permission_name == "Eliminar fianzas") {
                if (acc.checked == true) {
                  vm.acceso_elim_fia = true;
                } else {
                  vm.acceso_elim_fia = false;
                }
              }
            });
          }
        });
      }
      if (task) {
        $scope.ticket1 = angular.copy(task);
        $scope.vm.form = angular.copy(task);
        $scope.original_assigned = $scope.vm.form.assigned;
        if (!$scope.original_assigned.url) {
          $http
            .get(url.IP + "usuarios/" + $scope.original_assigned.id)
            .then(function (response) {
              $scope.original_assigned = response.data;
              $scope.vm.form.assigned = response.data;
            });
        }
        $scope.title = "Tarea";
        $scope.vm.form.compromiso = datesFactory.convertDate(
          $scope.vm.form.date
        );
        $scope.vm.form.priority =
          $scope.priorities[$scope.vm.form.priority - 1];
        $scope.vm.form.concept = $scope.concepts[$scope.vm.form.concept - 1];
        var selected_user = [];
        $.each(task.involved_task, function (i, e) {
          selected_user.push(e.person.id);
        });
        $scope.selected_user = selected_user;
        var params = {
          model: 22,
          id_model: task.id,
        };
        dataFactory
          .get("comments/", params)
          .then(function (request) {
            vm.comments_data = request.data.results;
            vm.comments_config = {
              count: request.data.count,
              previous: request.data.previous,
              next: request.data.next,
            };
          })
          .catch(function (e) {
            console.log("e", e);
          });

        $http
          .get(url.IP + "ticket/" + task.id + "/archivos/")
          .then(function (response) {
            if (response.status === 200) {
              vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.show_files_policy = true;
            } else if (response.status === 403) {
              $scope.show_files_policy = false;
            }
          });

        vm.polizaId = task.id;
      } else if (data) {
        $scope.vm.form = {};
        $scope.title = "Crear nueva tarea";
        $scope.vm.form.title = data;
        $scope.vm.form.route = route;
      } else {
        $scope.task = {};
        $scope.title = "Crear nueva tarea";
      }
      $http.post(url.IP + "emailsUsers").then(function (response) {
        $scope.emails_users = response.data.emails;
        $scope.historic_email = false;
      });
      dataFactory.get("usuarios/").then(function (data) {
        $scope.users = data.data.results;
        if ($scope.selected_user) {
          var selected_user = [];
          $.each(data.data.results, function (i, e) {
            if ($scope.selected_user.includes(e.id)) {
              selected_user.push(e);
            }
          });
          $scope.select_user = selected_user;
        }
      });

      $scope.track_task_id = "";
      $scope.track_task_entity_number = "";
      switch (vm.form.model) {
        case 1:
          $scope.origin_task = "póliza";
          $scope.track_task_id = "";
          break;
        case 2:
          $scope.origin_task = "endoso";
          $http
            .get(url.IP + "endorsement-single/" + vm.form.associated + "/")
            .then(function (responseEndoso) {
              if (responseEndoso.data["number_endorsement"] != "") {
                $scope.track_task_entity_number =
                  "Número de endoso: " +
                  responseEndoso.data["number_endorsement"];
              }
              if (responseEndoso.data["numero_poliza"] != "") {
                $scope.track_task_entity_number =
                  $scope.track_task_entity_number +
                  " - " +
                  "Número de póliza: " +
                  responseEndoso.data["numero_poliza"];
              }
              $scope.track_task_id =
                "Folio de endoso: " + responseEndoso.data["internal_number"];
            });
          break;
        case 3:
          $scope.origin_task = "póliza";
          $scope.track_task_id = "";
          break;
        case 4:
          $scope.origin_task = "póliza";
          $scope.track_task_id = "";
          break;
        case 5:
          $scope.origin_task = "póliza";
          $scope.track_task_id = "";
          break;
        case 6:
          $scope.origin_task = "siniestro";
          $scope.track_task_id = "";
          break;
        case 7:
          $scope.origin_task = "contratante";
          $scope.track_task_id = "";
          break;
        case 8:
          $scope.origin_task = "fianza";
          $scope.track_task_id = "";
          break;
        case 9:
          $scope.origin_task = "endoso";
          $scope.track_task_id = "";
          break;
        case 18:
          $scope.origin_task = "Póliza de grupo";
          $scope.track_task_id = "";
          break;
        case 28:
          $scope.origin_task = "colectividad";
          $scope.track_task_id = "";
          break;
        case 30:
          $scope.origin_task = "Cotización";
          $scope.track_task_id = "";
          break;
        default:
          break;
      }
    }

    $scope.close = function () {
      $uibModalInstance.close();
    };

    $scope.goToCapture = function (val) {
      $rootScope.from_task = true;
      $rootScope.task_associated = vm.form;
      if (
        val &&
        vm.form.concept &&
        vm.form.concept.id == 2 &&
        val.tipo_ot &&
        val.tipo_ot.id
      ) {
        if (val.tipo_ot.id == 1) {
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Póliza Individual",
            "polizas.create",
            $stateParams
          );
        }
        if (val.tipo_ot.id == 2) {
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Flotilla",
            "flotillas.flotillas",
            $stateParams
          );
        }
        if (val.tipo_ot.id == 3) {
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Póliza de Grupo",
            "colectividades.main",
            $stateParams
          );
        }
        if (val.tipo_ot.id == 4) {
          $uibModalInstance.close();
          $scope.changeView("Crear Fianza", "fianzas.fianzas", $stateParams);
        }
        if (val.tipo_ot.id == 5) {
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Fianza Colectiva",
            "fianzas.colectividades",
            $stateParams
          );
        }
      } else {
        if (vm.form.concept && vm.form.concept.id == 1) {
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Cotización",
            "cotizacion.cotizacion",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 3 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 6
        ) {
          $rootScope.type_endorsement = 1;
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso",
            "endorsement.endorsement",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 3 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 7
        ) {
          $rootScope.type_endorsement = "A";
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso Fianza",
            "endorsement.fianza",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 3 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 8
        ) {
          $rootScope.type_endorsement = 1;
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso Póliza Grupo",
            "endorsement.collectivity",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 3 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 9
        ) {
          $rootScope.type_endorsement = "A";
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso Fianza Colectiva",
            "endorsement.collective",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 10 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 6
        ) {
          $rootScope.type_endorsement = 2;
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso",
            "endorsement.endorsement",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 10 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 7
        ) {
          $rootScope.type_endorsement = "B";
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso Fianza",
            "endorsement.fianza",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 10 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 8
        ) {
          $rootScope.type_endorsement = 2;
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso Póliza Grupo",
            "endorsement.collectivity",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 10 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 9
        ) {
          $rootScope.type_endorsement = "B";
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso Fianza Colectiva",
            "endorsement.collective",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 11 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 6
        ) {
          $rootScope.type_endorsement = 3;
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso",
            "endorsement.endorsement",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 11 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 7
        ) {
          $rootScope.type_endorsement = "D";
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso Fianza",
            "endorsement.fianza",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 11 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 8
        ) {
          $rootScope.type_endorsement = 3;
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso Póliza Grupo",
            "endorsement.collectivity",
            $stateParams
          );
        }
        if (
          vm.form.concept &&
          vm.form.concept.id == 11 &&
          vm.form.tipo_ot_p &&
          vm.form.tipo_ot_p.id &&
          vm.form.tipo_ot_p.id == 9
        ) {
          $rootScope.type_endorsement = "D";
          $uibModalInstance.close();
          $scope.changeView(
            "Crear Endoso Fianza Colectiva",
            "endorsement.collective",
            $stateParams
          );
        }
      }
    };
    $scope.changeView = function (name, route, params) {
      var existe = false;
      var route = route;
      var name = name;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };
    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $uibModalInstance.close();
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };
    $scope.selectUser = function (obj) {
      $scope.involved = [];
      obj.forEach(function (child) {
        child.person = child.url;
      });
      $scope.involved = obj;
    };

    $scope.saveTask = function () {
      vm.form.involved_task = $scope.involved;
      vm.form.assigned = vm.form.assigned.url;
      vm.form.priority = vm.form.priority.id;
      vm.form.concept = vm.form.concept ? vm.form.concept.id : 7;
      vm.form.date = new Date(datesFactory.toDate(vm.form.compromiso));
      vm.form.associated = associated;
      vm.form.route = route;
      vm.form.model = modelo;
      dataFactory
        .post("save-ticket/", vm.form)
        .then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            var params = {
              model: 22,
              event: "POST",
              associated_id: response.data.id,
              identifier: "creó la tarea.",
            };

            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});

            if (receipt) {
              var params = {
                model: 4,
                event: "POST",
                associated_id: receipt,
                identifier: "creó una tarea con este recibo.",
              };

              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }

            uploadFiles(response.data);
            SweetAlert.swal("¡Hecho!", MESSAGES.OK.SAVETICKET, "success");
            $uibModalInstance.close();
          }
        });
    };

    $scope.updateTask = function () {
      $scope.name_assiged =
        vm.form.assigned.first_name + " " + vm.form.assigned.last_name;
      $scope.original_assigned_name =
        $scope.original_assigned.first_name +
        " " +
        $scope.original_assigned.last_name;
      vm.form.involved_task = $scope.involved;
      vm.form.assigned = vm.form.assigned.id;
      vm.form.priority = vm.form.priority.id;
      vm.form.concept = vm.form.concept ? vm.form.concept.id : 7;
      vm.form.route = vm.form.route;
      vm.form.owner = vm.form.owner.url;
      vm.form.model = vm.form.model;
      vm.form.date = new Date(datesFactory.toDate(vm.form.compromiso));
      if (vm.form.closedBy) {
        vm.form.closedBy = vm.form.closedBy.url;
      }
      $scope.changeAssigned = false;
      if (vm.form.assigned != $scope.original_assigned.url) {
        $scope.changeAssigned = true;
      }
      delete vm.form.archived;

      $http.patch(vm.form.url, vm.form).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          var involved_list = [];
          response.data.involved_task.forEach(function (inv) {
            var url = inv.person;
            var id_person = inv.id;
            $http.get(url).then(function (response) {
              if (response.status === 200) {
                involved_list.push({ id: id_person, person: response.data });
              }
            });
          });
          task.involved_task = involved_list;
          var params = {
            model: 22,
            event: "POST",
            associated_id: response.data.id,
            identifier: "actualizó la tarea.",
          };

          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          if ($scope.changeAssigned) {
            var params = {
              model: 22,
              event: "PATCH",
              associated_id: response.data.id,
              identifier:
                "actualizó la tarea; reasignándola de " +
                $scope.original_assigned_name +
                " a " +
                $scope.name_assiged +
                ".",
            };

            dataFactory
              .post("send-log/", params)
              .then(function success(response) {
                console.log(
                  "----------response log-----reasignación----",
                  response
                );
              });
          }
          uploadFiles(response.data);

          $uibModalInstance.close({ response: response });
          SweetAlert.swal("¡Listo!", MESSAGES.INFO.QUOTATIONCHANGE, "success");
          $state.reload();
        }
      });
    };

    $scope.goToRegis = function () {
      if (vm.form.model == 1) {
        if (vm.acceso_ver_ot) {
          var name = "Información póliza";
          var route = "polizas.info";
        }
      } else if (vm.form.model == 2) {
        if (vm.acceso_ver_ot) {
          var name = "Información endoso";
          var route = "endorsement.info";
        }
      } else if (vm.form.model == 3 || vm.form.model == 4) {
        if (vm.acceso_ver_pol) {
          var name = "Información póliza";
          var route = "polizas.info";
        }
      } else if (vm.form.model == 5) {
        if (vm.acceso_ver_pol) {
          var name = "Información póliza";
          var route = "polizas.info";
        }
      } else if (vm.form.model == 7) {
        if (vm.acceso_ver_cont) {
          if ($scope.contractorNew.type_person == "Física") {
            var name = "Información contratante";
            var route = "contratantes.info";
          } else if ($scope.contractorNew.type_person == "Moral") {
            var name = "Información contratante";
            var route = "contratantes.info";
          }
        }
      } else if (vm.form.model == 8) {
        if (vm.acceso_ver_fia) {
          var name = "Información fianza";
          var route = "fianzas.info";
        }
      } else if (vm.form.model == 9) {
        if (vm.acceso_ver_ot) {
          var name = "Información endoso";
          var route = "endorsement.info";
        }
      } else if (vm.form.model == 6) {
        var name = "Información siniestro";
        var route = "siniestros.info";
      } else if (vm.form.model == 18) {
        var name = "Información colectividad";
        var route = "colectividades.info";
      } else if (vm.form.model == 28) {
        var name = "Información flotilla";
        var route = "flotillas.info";
      } else if (vm.form.model == 30) {
        var name = "Información Cotización";
        var route = "cotizacion.info";
        var params = { id: vm.form.associated };
      }

      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      // Si esto se va a modificar, analizar con backend porque estan ligados directamente a los modelos
      // de creación de rutas para las tareas desde la bitacora
      $scope.close();
      if (vm.form.model == 1) {
        if (vm.acceso_ver_ot) {
          $state.go("polizas.info", { polizaId: vm.form.associated });
        }
      } else if (vm.form.model == 2) {
        if (vm.acceso_ver_ot) {
          $state.go("endorsement.info", { endosoId: vm.form.associated });
        }
      } else if (vm.form.model == 3 || vm.form.model == 4) {
        if (vm.acceso_ver_pol) {
          $state.go("polizas.info", { polizaId: vm.form.associated });
        }
      } else if (vm.form.model == 5) {
        if (vm.acceso_ver_pol) {
          $state.go("polizas.info", { polizaId: vm.form.associated });
        }
      } else if (vm.form.model == 7) {
        if (vm.acceso_ver_cont) {
          // $state.go('contratantes.info', {
          //   type: $scope.contractorNew.type_person == 'Fisica',
          //   contratanteId: vm.form.associated
          // });
          if ($scope.contractorNew.type_person == "Física") {
            $state.go("contratantes.info", {
              type: "fisicas",
              contratanteId: insurance.contractor,
              contractor: $scope.contractorNew,
            });
          } else if ($scope.contractorNew.type_person == "Moral") {
            $state.go("contratantes.info", {
              type: "morales",
              contratanteId: insurance.contractor,
              contractor: $scope.contractorNew,
            });
          }
        }
      } else if (vm.form.model == 8) {
        if (vm.acceso_ver_fia) {
          $state.go("fianzas.info", { fianzaId: vm.form.associated });
        }
      } else if (vm.form.model == 9) {
        if (vm.acceso_ver_ot) {
          $state.go("endorsement.info", { endosoId: vm.form.associated });
        }
      } else if (vm.form.model == 6) {
        $state.go("siniestros.info", { siniestroId: vm.form.associated });
      } else if (vm.form.model == 18) {
        $state.go("colectividades.info", { polizaId: vm.form.associated });
      } else if (vm.form.model == 28) {
        $state.go("flotillas.info", { polizaId: vm.form.associated });
      } else if (vm.form.model == 30) {
        $state.go("cotizacion.info", { polizaId: vm.form.associated });
      }
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    // Change User
    vm.emails_selected = [];
    $scope.changeEmailSendH = function (x, y) {
      vm.emails_selected = [];
      x.forEach(function (r) {
        vm.emails_selected.push(r);
      });
    };
    $scope.selectManualEmails = function (x, y) {
      vm.emails_selected_manual = [];
      x.forEach(function (r) {
        $scope.invalidEmail = r;
        vm.emails_selected_manual.push(r);
      });
    };

    $scope.send_historic_email = function () {
      if ($scope.historic_email) {
        $scope.historic_email = false;
      } else {
        $scope.historic_email = true;
      }
    };
    // Send historic task to email
    $scope.send_historic = function (obj) {
      vm.emails_manuales = [];
      $scope.validate_email = false;
      $scope.invalidEmail = "";
      if ($scope.email_x == 2 || $scope.email_x == "2") {
        if (vm.emails_selected) {
          if (vm.emails_selected.length > 0) {
            $scope.validate_email = true;
          } else {
            $scope.validate_email = false;
          }
        } else {
          $scope.validate_email = false;
        }
      } else if ($scope.email_x == 1 || $scope.email_x == "1") {
        vm.emails_selected = [];
        $scope.validate_email = true;
        vm.email_tags = vm.emails_selected_manual;
        if (vm.email_tags) {
          vm.email_tags.forEach(function (email) {
            if (!validateEmail(email)) {
              $scope.invalidEmail = email;
              SweetAlert.swal(
                "Correo inválido",
                MESSAGES.ERROR.REVIEWEMAIL + " " + email,
                "error"
              );
              $scope.validate_email = false;
              return;
            } else {
              vm.emails_manuales.push(email);
            }
          });
        }
      }
      if ($scope.validate_email) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $http
          .post(url.IP + "send-historic-email", {
            email: vm.emails_manuales,
            id_tarea: obj.id,
            type_email: $scope.email_x,
            emails_selected: vm.emails_selected,
          })
          .then(function (response) {
            if (response.data.status == "send") {
              SweetAlert.swal("Enviado", MESSAGES.OK.HISTSENDEMAIL, "success");
              vm.email_send_historic = "";
              l.stop();
              $scope.historic_email = false;
            } else {
              SweetAlert.swal(
                "No Enviado",
                MESSAGES.ERROR.HISTERRORSENDEMAIL,
                "error"
              );
              l.stop();
              $scope.historic_email = false;
            }
          });
      } else {
        SweetAlert.swal(
          "Correo inválido",
          MESSAGES.ERROR.REVIEWEMAIL + " " + $scope.invalidEmail,
          "error"
        );
      }
    };

    /* Uploader files */

    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.ramo == undefined) {
        item.ramo = 2;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].ramo = item.ramo;
    };

    function uploadFiles(ticketId) {
      console.log(ticketId);
      $scope.userInfo = {
        id: ticketId.id,
      };
      $scope.userInfo.url = url.IP + "ticket/" + ticketId.id + "/archivos/";
      $scope.uploader.uploadAll();
    }

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
      console.log(uploader.queue);
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("TareasCtrl", TareasCtrl);

  TareasCtrl.$inject = [
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "appStates",
    "$state",
  ];

  function TareasCtrl(
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    appStates,
    $state
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    $(".js-example-basic-multiple").select2();
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
    $scope.historic_email = false;

    var vm = this;

    $scope.show = [];
    vm.comments_data = [];
    vm.createTask = createTask;
    vm.main_comming = $stateParams.main_comming;
    $scope.disabledButton = false;
    $scope.show_pag_task = false;
    vm.createRecordatorio = createRecordatorio;
    $scope.items = [];
    vm.showRecordatorios = showRecordatorios;
    $scope.fechahoy = false;
    $scope.concepts = [
      {
        id: 1,
        name: "Cotización",
      },
      {
        id: 2,
        name: "Emisión",
      },
      {
        id: 4,
        name: "Corrección",
      },
      {
        id: 5,
        name: "Cancelación",
      },
      {
        id: 6,
        name: "Renovación",
      },
      {
        id: 7,
        name: "Otro",
      },
      {
        id: 8,
        name: "Reembolso",
      },
      {
        id: 9,
        name: "Programación de cirugía",
      },
      {
        id: 3,
        name: "Endoso A",
      },
      {
        id: 10,
        name: "Endoso B",
      },
      {
        id: 11,
        name: "Endoso D",
      },
      {
        id: 12,
        name: "Reconocimiento de antigüedad",
      },
      {
        id: 13,
        name: "Carta de antigüedad",
      },
    ];

    $scope.priorities = [
      {
        id: 1,
        name: "Alta",
      },
      {
        id: 2,
        name: "Media",
      },
      {
        id: 3,
        name: "Baja",
      },
    ];

    $scope.statusTask = [
      {
        id: 4,
        name: "Completado/Cerrada",
      },
      {
        id: 8,
        name: "Archivado",
      },
      {
        id: 11,
        name: "Abiertas",
      },
    ];

    $scope.seeTask = [
      {
        id: 0,
        name: "Todas",
      },
      {
        id: 5,
        name: "Mis tareas",
      },
      {
        id: 6,
        name: "Creadas",
      },
      // , {
      //   id: 10,
      //   name: 'Abiertas'
      // }
    ];
    vm.form = {
      priority: 0,
      closed: 0,
      created: 0,
      assigned: "",
      chain: 0,
      archived: 0,
      order: 3,
      asc: 0,
      status: 0,
      ver: 0,
      assigned_url: null,
      priority_int: null,
    };

    $scope.involved = [];
    $scope.conceptTicket = function (obj) {
      switch (obj) {
        case 1:
          return "Cotización";
        case 2:
          return "Emisión";
        case 4:
          return "Corrección";
        case 5:
          return "Cancelación";
        case 6:
          return "Renovación";
        case 7:
          return "Otro";
        case 8:
          return "Reembolso";
        case 9:
          return "Programación de cirugía";
        case 3:
          return "Endoso A";
        case 10:
          return "Endoso B";
        case 11:
          return "Endoso D";
        case 12:
          return "Reconocimiento de antigüedad";
        case 13:
          return "Carta de antigüedad";
        default:
          return "Otro";
      }
    };

    $scope.selectUser = function (obj) {
      $scope.involved = [];
      obj.forEach(function (child) {
        child.person = child.url;
      });
      $scope.involved = obj;
    };
    $scope.addTaskOK = function (obj) {
      $scope.select_user = [];
      // $scope.$evalAsync(function () {
      //   $('#select_user').val(null).trigger('change');
      // });
      $scope.involvedUser = [];
      $scope.select_user = [];
      $scope.involved = [];
      $scope.uploader.queue = [];
      vm.form = {
        priority: 0,
        closed: 0,
        created: 0,
        assigned: "",
        chain: 0,
        archived: 0,
        order: 3,
        asc: 0,
        status: 0,
        ver: 0,
        assigned_url: null,
        priority_int: null,
      };
      $(".js-example-basic-multiple2").select2();
      $scope.show_task = true;
    };
    $scope.saveTask = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var data_to_send = vm.form;
      data_to_send.involved_task = $scope.involved;
      data_to_send.assigned = vm.form.assigned_url;
      data_to_send.priority = vm.form.priority_int ? vm.form.priority_int : 1;
      data_to_send.concept = vm.form.concept ? vm.form.concept : 7;
      data_to_send.date = new Date(datesFactory.toDate(vm.form.compromiso));
      data_to_send.associated = null;
      data_to_send.route = null;
      data_to_send.model = null;
      dataFactory
        .post("save-ticket/", data_to_send)
        .then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            $scope.involved = [];
            var params = {
              model: 22,
              event: "POST",
              associated_id: response.data.id,
              identifier: "creó la tarea.",
            };
            $localStorage.saved_created_tareas = {};
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {
                l.stop();
              });
            $(".js-example-basic-multiple2").select2();
            uploadFiles(response.data);
            SweetAlert.swal("¡Hecho!", MESSAGES.OK.SAVETICKET, "success");
            $scope.show_task = false;
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };
    function showRecordatorios() {
      vm.infoFlag = false;
      vm.recordatoriosFlag = true;
    }
    function createRecordatorio(registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return vm.insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    }
    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };
    /* Uploader files */

    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });
    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.ramo == undefined) {
        item.ramo = 2;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].ramo = item.ramo;
    };

    function uploadFiles(ticketId) {
      console.log(ticketId);
      $scope.userInfo = {
        id: ticketId.id,
      };
      $scope.userInfo.url = url.IP + "ticket/" + ticketId.id + "/archivos/";
      $scope.uploader.uploadAll();
      $(".js-example-basic-multiple2").select2();
      activate();
    }

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
      console.log(uploader.queue);
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };
    $(".js-example-basic-multiple2").select2();
    activate();
    function activate() {
      $(".js-example-basic-multiple2").select2();
      vm.id_task = $stateParams.id_task;
      $scope.params = {
        priority: 0,
        closed: 0,
        created: 0,
        assigned: 0,
        chain: 0,
        archived: 0,
        order: 3,
        asc: 0,
        status: 0,
        ver: 0,
      };
      if ($scope.params.status == 0) {
        $scope.params.status = 11;
      }
      if (vm.main_comming) {
        dataFactory
          .get("ticket/" + vm.id_task)
          .then(function success(response) {
            $scope.ticket = response.data;
            $scope.tickets = [$scope.ticket];
            $scope.openModal($scope.ticket);
            $scope.show_pag_task = false;
            $scope.ticket.involved_task.forEach(function (item) {
              $http.get(item.person).then(function success(respo) {
                item.person = respo.data;
                item.person_info = respo.data;
              });
            });
          });
      } else {
        dataFactory
          .get("get-ticket/", $scope.params)
          .then(function success(response) {
            if (response.data) {
              $scope.tickets = response.data.results;

              $scope.tareas_config = {
                count: response.data.count,
                previous: url.IP + "get-ticket/",
                next: url.IP + "get-ticket/",
              };

              $scope.tickets.forEach(function (child) {
                if (!$localStorage[child.owner.username]) {
                  $http({
                    method: "GET",
                    url:
                      url.IP_CAS + "get-user-picture/" + child.owner.username,
                  })
                    .then(function (request) {
                      if (request.status === 200) {
                        child.image = request.data.url;
                        $localStorage[child.owner.username] = request.data.url;
                      }
                    })
                    .catch(function (e) {
                      console.log("e", e);
                    });
                } else {
                  child.image = $localStorage[child.owner.username];
                }
              });
              $scope.show_pag_task = true;
              testPagination("tickets", "tareas_config");
            }
          });
        if (vm.id_task == -1) {
          $scope.show_task = true;
        }
      }

      $scope.users = [];
      $scope.involvedUser = [];

      dataFactory.get("usuarios/").then(function (data) {
        data.data.results.forEach(function (usr) {
          if (usr.user_info.is_active) {
            $scope.users.push(usr);
            $scope.involvedUser.push(usr);
          }
        });
      });

      vm.form.priority =
        $localStorage.saved_filters_tareas &&
        $localStorage.saved_filters_tareas["priority"]
          ? $localStorage.saved_filters_tareas["priority"]
          : 0;
      vm.form.status =
        $localStorage.saved_filters_tareas &&
        $localStorage.saved_filters_tareas["status"]
          ? $localStorage.saved_filters_tareas["status"]
          : 0;
      vm.form.ver =
        $localStorage.saved_filters_tareas &&
        $localStorage.saved_filters_tareas["ver"]
          ? $localStorage.saved_filters_tareas["ver"]
          : 0;
      if (vm.form.status == 0) {
        vm.form.status = { id: 11, name: "Abiertas" };
      }
    }

    $scope.exportToExcel = function (task, fechahoy) {
      if (task.length > 0) {
        $scope.params.status = vm.form.status ? vm.form.status.id : 0;
        $scope.params.priority = vm.form.priority ? vm.form.priority.id : 0;
        $scope.params.ver = vm.form.ver ? vm.form.ver.id : 0;
        $scope.params.fechahoy = $scope.fechahoy ? $scope.fechahoy : false;
        $http({
          method: "POST",
          // url: url.IP +'reporte-task' ,
          url: url.IP + "service_reporte-taskReport-excel",
          data: $scope.params,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function (data, status, headers, config) {
          if (data.status == 200) {
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Tasks.xls");
          } else {
            toaster.error(
              "Error",
              "Ha ocurrido un error al descargar el reporte",
              "error"
            );
          }
        });
      }
    };
    $scope.createOT = function (ticket) {
      // definir tipo de ot
      var modalInstance = $uibModal.open({
        templateUrl: "app/tasks/task.createot.modal.html",
        controller: "TareasCrearOTModalController",
        size: "lg",
        resolve: {
          task: function () {
            return ticket;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          receipt: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          // $scope.tickets.some(function(tiket,index) {
          //   if (tiket.id == response.response.data.id){
          //     $scope.tickets[index].archived = response.response.data.archived;
          //     $scope.tickets[index].up_date = 0;
          //     return
          //   }
          // })
        },
        function () {
          console.info("modal closed");
        }
      );
    };
    $scope.irOT = function (tarea) {
      var params = {};
      if (tarea.ot_model == 1) {
        // póliza emisión
        dataFactory
          .get("polizas/" + tarea.ot_id_reference)
          .then(function success(response) {
            var registro = response.data;
            if (registro.document_type == 1) {
              var name = "Información póliza";
              var route = "polizas.info";
              params = {
                polizaId: tarea.ot_id_reference,
              };
              $scope.redirigir(name, route, params);
            }
            if (registro.document_type == 3) {
              var name = "Información colectividad";
              var route = "colectividades.info";
              params = {
                polizaId: tarea.ot_id_reference,
              };
              $scope.redirigir(name, route, params);
            }
            if (registro.document_type == 11) {
              var name = "Información flotilla";
              var route = "flotillas.info";
              params = {
                polizaId: tarea.ot_id_reference,
              };
              $scope.redirigir(name, route, params);
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
      if (tarea.ot_model == 2) {
        // endoso obteer y sacar doc
        dataFactory
          .get("endorsement-info/" + tarea.ot_id_reference)
          .then(function success(response) {
            var registro = response.data;
            if (registro.document_type == 7 || registro.document_type == 8) {
              var name = "Informacion Endoso";
              var route = "endorsement.details";
            } else {
              var name = "Informacion Endoso";
              var route = "endorsement.info";
            }
            params = { endosoId: tarea.ot_id_reference };
            $scope.redirigir(name, route, params);
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
      if (tarea.ot_model == 3) {
        // cotizacion
        var name = "Información Cotización";
        var route = "cotizacion.info";
        var params = { id: tarea.ot_id_reference };
        $scope.redirigir(name, route, params);
      }
    };
    $scope.redirigir = function (name, route, params) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $state.go(route, params);
    };
    $scope.openModal = function (task) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/tasks/task.modal.html",
        controller: "TareasModalCtrl",
        size: "lg",
        resolve: {
          task: function () {
            return task;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          receipt: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          $scope.tickets.some(function (tiket, index) {
            try {
              if (response && tiket.id == response.response.data.id) {
                $scope.tickets[index].archived =
                  response.response.data.archived;
                $scope.tickets[index].up_date = 0;
                return;
              }
            } catch (r) {
              console.log("r", r);
            }
          });
          // $scope.tickets[$scope.tickets.indexOf(task)].archived = response.response.archived
          // console.log($scope.tickets[$scope.tickets.indexOf(task)].archived)
        },
        function () {
          //close callback
          console.info("modal closed");
        }
      );
    };
    // orden de columnastask_titulo
    vm.changeColumns = changeColumns;
    function changeColumns(par, asc) {
      switch (par) {
        case 1:
          $scope.getTickets(
            $scope.param_ticket,
            $scope.chain_ticket,
            par,
            asc,
            $scope.fechahoy
          );
          vm.task_folio = asc;
          vm.task_titulo = 0;
          vm.task_fecha = 0;
          vm.task_prioridad = 0;
          vm.task_usuario = 0;
          vm.task_owner = 0;
          break;
        case 2:
          $scope.getTickets(
            $scope.param_ticket,
            $scope.chain_ticket,
            par,
            asc,
            $scope.fechahoy
          );
          vm.task_folio = 0;
          vm.task_titulo = asc;
          vm.task_fecha = 0;
          vm.task_prioridad = 0;
          vm.task_usuario = 0;
          vm.task_owner = 0;
          break;
        case 3:
          $scope.getTickets(
            $scope.param_ticket,
            $scope.chain_ticket,
            par,
            asc,
            $scope.fechahoy
          );
          vm.task_folio = 0;
          vm.task_titulo = 0;
          vm.task_fecha = asc;
          vm.task_prioridad = 0;
          vm.task_usuario = 0;
          vm.task_owner = 0;
          break;
        case 4:
          $scope.getTickets(
            $scope.param_ticket,
            $scope.chain_ticket,
            par,
            asc,
            $scope.fechahoy
          );
          vm.task_folio = 0;
          vm.task_titulo = 0;
          vm.task_fecha = 0;
          vm.task_prioridad = asc;
          vm.task_usuario = 0;
          vm.task_owner = 0;
          break;
        case 5:
          $scope.getTickets(
            $scope.param_ticket,
            $scope.chain_ticket,
            par,
            asc,
            $scope.fechahoy
          );
          vm.task_folio = 0;
          vm.task_titulo = 0;
          vm.task_fecha = 0;
          vm.task_prioridad = 0;
          vm.task_usuario = asc;
          vm.task_owner = 0;
          break;
        case 6:
          $scope.getTickets(
            $scope.param_ticket,
            $scope.chain_ticket,
            par,
            asc,
            $scope.fechahoy
          );
          vm.task_folio = 0;
          vm.task_titulo = 0;
          vm.task_fecha = 0;
          vm.task_prioridad = 0;
          vm.task_usuario = 0;
          vm.task_owner = asc;
          break;
      }
    }
    function createTask(argument) {
      vm.main_comming = false;
      $scope.openModal();
    }

    $scope.getAllTickets = function (argument) {
      vm.main_comming = false;
      $scope.items = [];
      activate();
    };

    $scope.archiveTask = function (task) {
      swal(
        {
          title: "¿Estás seguro?",
          text: "¿Desea archivar la tarea?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            vm.main_comming = false;
            $http.patch(task.url, { archived: true }).then(function (response) {
              if (response.status === 200 || response.status === 201) {
                $scope.tickets.splice($scope.tickets.indexOf(task), 1);
                var params = {
                  model: 22,
                  event: "POST",
                  associated_id: task.id,
                  identifier: "archivó la tarea.",
                };

                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});

                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.INFO.QUOTATIONCHANGE,
                  "success"
                );
                // swal.close();
              }
            });
          } else {
            SweetAlert.swal(
              "Cancelado",
              MESSAGES.INFO.CANCELCONTRACTOR,
              "error"
            );
          }
        }
      );
    };

    $scope.openTask = function (task) {
      $scope.tickets = [];
      $scope.show_pag_task = false;
      swal(
        {
          title: "¿Estás seguro?",
          text: "¿Desea abrir la tarea?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            vm.main_comming = false;
            $http.patch(task.url, { closed: false }).then(function (response) {
              if (response.status === 200 || response.status === 201) {
                // $scope.tickets.splice($scope.tickets.indexOf(task), 1);
                var params = {
                  model: 22,
                  event: "POST",
                  associated_id: task.id,
                  identifier: "abrió la tarea.",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.INFO.QUOTATIONCHANGE,
                  "success"
                );
                activate();
                // swal.close();
                $scope.closeComment();
              }
            });
          } else {
            SweetAlert.swal(
              "Cancelado",
              MESSAGES.INFO.CANCELCONTRACTOR,
              "error"
            );
          }
        }
      );
    };

    $scope.show_comment = false;
    $scope.Complete = function (radio, index) {
      $scope.tickets = [];
      $scope.show_pag_task = false;
      if ($scope.infoUser.username != radio.owner.username) {
        if ($scope.infoUser.username != radio.assigned.username) {
          SweetAlert.swal(
            "Error",
            "No puedes realizar esta acción, no tienes vínculos con la tarea.",
            "error"
          );
          return;
        } else {
          $scope.show_comment = true;
          $scope.radio = radio;
          vm.main_comming = false;
          if (!radio.closed) {
            vm.comments_data = [];
            if ($scope.show[index]) {
              $scope.show[index] = false;
            } else {
              $scope.show = [];
              $scope.show[index] = true;
            }
            vm.polizaId = radio.id;
          } else {
            toaster.info("Esta tarea ya ha sido completada");
          }
        }
      } else {
        $scope.show_comment = true;
        $scope.radio = radio;
        vm.main_comming = false;
        if (!radio.closed) {
          vm.comments_data = [];
          if ($scope.show[index]) {
            $scope.show[index] = false;
          } else {
            $scope.show = [];
            $scope.show[index] = true;
          }
          vm.polizaId = radio.id;
        } else {
          toaster.info("Esta tarea ya ha sido completada");
        }
        // activate();
      }
    };

    $scope.closeComment = function () {
      $scope.tickets = [];
      $scope.show_pag_task = false;
      $scope.show_comment = false;
      activate();
    };

    $scope.getTickets = function (param, chain, order, asc, fechahoy) {
      $scope.fechahoy = fechahoy;
      var aux_users = [];
      if ($scope.selected_user && $scope.selected_user.length > 0) {
        aux_users = $scope.selected_user.map(function (user) {
          user = user.id;
          return user;
        });
      } else {
        aux_users = 0;
      }

      $scope.items = [];
      vm.main_comming = false;
      $scope.disabledButton = false;
      $scope.params = {
        priority: 0,
        closed: 0,
        created: 0,
        assigned: 0,
        chain: 0,
        archived: 0,
        fechahoy: fechahoy,
      };

      if (param == 0) {
        $scope.getAllTickets();
        return;
      } else if (param == 1) {
        $scope.params.priority = 1;
      } else if (param == 2) {
        $scope.params.priority = 2;
      } else if (param == 3) {
        $scope.params.priority = 3;
      } else if (param == 4) {
        $scope.params.closed = 1;
        $scope.disabledButton = true;
      } else if (param == 5) {
        $scope.params.assigned = 1;
      } else if (param == 6) {
        $scope.params.created = 1;
      } else if (param == 8) {
        $scope.params.archived = 1;
      }

      if (param == 7) {
        $scope.params.chain = chain;
        $scope.params.priority = 0;
      }
      $scope.param_ticket = param;
      $scope.chain_ticket = $scope.params.chain;
      $scope.order = order;
      $scope.asc = asc;
      $scope.params.order = order ? order : 3;
      $scope.params.asc = asc ? asc : 0;
      $scope.params.status = vm.form.status ? vm.form.status.id : 0;
      $scope.params.priority = vm.form.priority ? vm.form.priority.id : 0;
      $scope.params.ver = vm.form.ver ? vm.form.ver.id : 0;
      $scope.params.users = aux_users;
      $scope.params.fechahoy = fechahoy;

      dataFactory
        .get("get-ticket/", $scope.params)
        .then(function success(response) {
          $scope.tickets = response.data.results;
          $scope.ticketsResult = response.data;

          $scope.tareas_config = {
            count: response.data.count,
            previous: url.IP + "get-ticket/",
            next: url.IP + "get-ticket/",
          };
          $scope.show_pag_task = true;
          testPagination("insurances", "tareas_config");

          $scope.tickets.forEach(function (child) {
            if (!$localStorage[child.owner.username]) {
              $http({
                method: "GET",
                url: url.IP_CAS + "get-user-picture/" + child.owner.username,
              })
                .then(function (request) {
                  if (request.status === 200) {
                    child.image = request.data.url;
                    $localStorage[child.owner.username] = request.data.url;
                  }
                })
                .catch(function (e) {
                  console.log("e", e);
                });
            } else {
              child.image = $localStorage[child.owner.username];
            }
          });
        });

      $localStorage.saved_filters_tareas = angular.copy($scope.params);
      $localStorage.saved_filters_tareas["priority"] = vm.form.priority;
      $localStorage.saved_filters_tareas["status"] = vm.form.status;
      $localStorage.saved_filters_tareas["ver"] = vm.form.ver;
    };

    $scope.getLog = function (ticket) {
      dataFactory
        .get("get-specific-log", { model: 22, associated_id: ticket.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    };

    // If asigned --> involved
    // vm.changeAssigned = changeAssigned;
    // function changeAssigned(assigned) {
    //   angular.element(document).ready(function(){
    //     $('.js-example-basic-multiple').select2({select_user: []});
    //   });
    //   $scope.involvedUserFin = [];
    //   $scope.invLook = false;
    //   if (assigned) {
    //     $scope.users.forEach(function(child, index){
    //       if (child.id != assigned.id) {
    //         $scope.involvedUserFin.push(child)
    //         $scope.invLook = true;
    //       }
    //     })
    //   }else{
    //     $scope.involvedUserFin = [];
    //   }
    //   $scope.select_user = [];
    // }
    //
    vm.saveLocalstorange = saveLocalstorange;
    function saveLocalstorange(assigned) {
      $localStorage.saved_created_tareas = {};
    }

    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        $scope.params.page = parPage;

        dataFactory
          .get("get-ticket/", $scope.params)
          .then(function success(response) {
            $scope.tickets = response.data.results;

            $scope.tareas_config = {
              count: response.data.count,
              previous: url.IP + "get-ticket/",
              next: url.IP + "get-ticket/",
            };
            $scope.show_pag_task = true;
            testPagination("tickets", "tareas_config");

            $scope.tickets.forEach(function (child) {
              if (!$localStorage[child.owner.username]) {
                $http({
                  method: "GET",
                  url: url.IP_CAS + "get-user-picture/" + child.owner.username,
                })
                  .then(function (request) {
                    if (request.status === 200) {
                      child.image = request.data.url;
                      $localStorage[child.owner.username] = request.data.url;
                    }
                  })
                  .catch(function (e) {
                    console.log("e", e);
                  });
              } else {
                child.image = $localStorage[child.owner.username];
              }
            });
          });
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
    //-- Peticion de persistencia--//
    // console.log('Persistence Tareas');
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var json_data = {};
    //var form = document.getElementsByClassName("ng-scope");
    var form = document.getElementsByTagName("form");
    var elementos = {};
    //Valores reutilizables
    var interval, interval1, valor;
    var getCollet_go = false;
    var count = 0;
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("TareasAdminCtrl", TareasAdminCtrl);

  TareasAdminCtrl.$inject = [
    "$stateParams",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "dataFactory",
    "$http",
    "url",
    "$localStorage",
    "toaster",
    "$parse",
    "datesFactory",
    "$sessionStorage",
    "FileUploader",
    "PersistenceFactory",
  ];

  function TareasAdminCtrl(
    $stateParams,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    dataFactory,
    $http,
    url,
    $localStorage,
    toaster,
    $parse,
    datesFactory,
    $sessionStorage,
    FileUploader,
    PersistenceFactory
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.users = [];
    vm.users_selected = [];
    $scope.select_created_by = [];

    activate();
    // Start functionality
    function activate() {
      $(".js-example-basic-multiple").select2();
      $http.get(url.IP + "group-manager/").then(function (response) {
        $http.get(url.IP + "usuarios/").then(function (user) {
          user.data.results.forEach(function (usr) {
            response["data"].forEach(function (item) {
              if (item.user == usr.id) {
                vm.users_selected.push(usr);
                $scope.select_created_by.push(usr);
              }
            });
            if (usr.user_info.is_active) {
              vm.users.push(usr);
            }
          });
        });
      });
    }

    $scope.save = function () {
      console.log($scope.select_created_by);
      var toSave = $scope.select_created_by.map(function (item) {
        return item.id;
      });
      $http.post(url.IP + "group-manager/", toSave).then(function () {
        vm.users_selected = $scope.select_created_by;
      });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("TableroOtsCtrl", TableroOtsCtrl);

  TableroOtsCtrl.$inject = [
    "$timeout",
    "FileUploader",
    "providerService",
    "dataFactory",
    "SweetAlert",
    "$scope",
    "$rootScope",
    "MESSAGES",
    "toaster",
    "endorsementService",
    "insuranceService",
    "receiptService",
    "$stateParams",
    "$state",
    "helpers",
    "formService",
    "$http",
    "url",
    "$uibModal",
    "datesFactory",
    "$q",
    "$localStorage",
    "$sessionStorage",
    "statusReceiptsFactory",
    "$sce",
    "formatValues",
    "fileService",
    "emailService",
    "appStates",
  ];

  function TableroOtsCtrl(
    $timeout,
    FileUploader,
    providerService,
    dataFactory,
    SweetAlert,
    $scope,
    $rootScope,
    MESSAGES,
    toaster,
    endorsementService,
    insuranceService,
    receiptService,
    $stateParams,
    $state,
    helpers,
    formService,
    $http,
    url,
    $uibModal,
    datesFactory,
    $q,
    $localStorage,
    $sessionStorage,
    statusReceiptsFactory,
    $sce,
    formatValues,
    fileService,
    emailService,
    appStates
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    uploader.filters.push({
      name: "customFilter",
      fn: function (item, options) {
        return this.queue.length < 20;
      },
    });

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    uploader.filters.push({
      name: "customFilter",
      fn: function (item, options) {
        return this.queue.length < 20;
      },
    });

    var vm = this;
    $scope.fechasFilter = false;
    vm.pageTitle = "Pólizas";
    vm.insurance = {};
    vm.receipts = [];
    vm.goToInfo = goToInfo;
    vm.polizaId = $stateParams.polizaId;
    vm.addToData = addToData;
    vm.editContainer = editContainer;
    vm.form = {
      since: convertDate(
        new Date(new Date().setMonth(new Date().getMonth() - 1))
      ),
      until: convertDate(new Date()),
      password: "",
      usuario: "",
      aseguradora: "",
      startDate: convertDate(new Date()),
    };
    vm.defaults = {};
    $scope.loader = false;
    $scope.editcontainer_b = false;
    vm.accesos = $sessionStorage.permisos;
    vm.deleteFromData = deleteFromData;
    vm.deleteFromDataSave = deleteFromDataSave;
    vm.deleteContainer = deleteContainer;
    vm.moveOTState = moveOTState;
    vm.moveOTStateFilter = moveOTStateFilter;
    vm.getLog = getLog;
    vm.getPDF = getPDF;
    vm.saveColor = saveColor;
    vm.getDataPromotoria = getDataPromotoria;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                vm.acceso_canc_pol = true;
              } else {
                vm.acceso_canc_pol = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                vm.acceso_elim_pol = true;
              } else {
                vm.acceso_elim_pol = false;
              }
            } else if (acc.permission_name == "Rehabilitar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_rehabilitar = true;
              } else {
                vm.acceso_adm_rehabilitar = false;
              }
            }
          });
        }
        if (perm.model_name == "Endosos") {
          $scope.acceso_endosos = perm;
          $scope.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                $scope.acceso_adm_end = true;
              } else {
                $scope.acceso_adm_end = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                vm.acceso_canc_ot = true;
              } else {
                vm.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar OTs") {
              if (acc.checked == true) {
                vm.acceso_elim_ot = true;
              } else {
                vm.acceso_elim_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Siniestros") {
          vm.acceso_sin = perm;
          vm.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                vm.acceso_adm_sin = true;
              } else {
                vm.acceso_adm_sin = false;
              }
            }
          });
        } else if (perm.model_name == "Mensajeria") {
          vm.acceso_mns = perm;
          vm.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                vm.acceso_mns = true;
              } else {
                vm.acceso_mns = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            } else if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                vm.acceso_del_cob = true;
              } else {
                vm.acceso_del_cob = false;
              }
            } else if (
              acc.permission_name ==
              "No permitir editar recibos Pagados/Liquidados"
            ) {
              if (acc.checked == true) {
                vm.acceso_pl_cob = true; //no se editan
              } else {
                vm.acceso_pl_cob = false; //se pueden editar pagados-liquidados
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          vm.acceso_ref = perm;
          vm.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                vm.acceso_adm_ref = true;
              } else {
                vm.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                vm.acceso_pag_ref = true;
              } else {
                vm.acceso_pag_ref = false;
              }
            } else if (
              acc.permission_name == "Cambiar refrenciador en pólizas"
            ) {
              if (acc.checked == true) {
                vm.acceso_chg_ref = true;
              } else {
                vm.acceso_chg_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.acceso_dash = perm;
          vm.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    vm.repeat = [];
    activate();
    // functions
    $scope.cargando = true;
    vm.infoFlag = true;
    $scope.mensajeTablero = "";
    function activate() {
      $scope.mensajeTablero = "";
      $(".js-example-basic-multiple").select2();
      $scope.principal = {
        name: "Contenedor Principal",
        color: "#E8B2E9 ",
        contenedores: [{}],
      };
      $http.get(url.IP + "fsubramos-tablero/").then(function (response) {
        $scope.has_sr_conf =
          response &&
          response.data &&
          response.data.data &&
          response.data.data.length > 0
            ? true
            : false;
      });
      // $http.get(url.IP+ 'promotoria-tablero/')
      $http
        .post(url.IP + "get-data-promotoria-initial/")
        .then(
          function success(response) {
            if (response.data.results.length > 0) {
              if (response.data.perfilRestringido) {
                $scope.filtrado = true;
                $scope.principal = response.data.original;
                $scope.principal.contenedores =
                  response.data.original.data_details;
                $scope.resultsFilter = response.data.results;
                $scope.cargando = false;
              } else {
                $scope.principal = response.data.original;
                $scope.principal.contenedores =
                  response.data.original.data_details;
                $scope.principal.url = response.data.original.url;
                $scope.principal.id = response.data.original.id;
                $scope.filtrado = response.data.config;
                $scope.resultsFilter = response.data.results;
                $scope.cargando = false;
              }
            } else {
              $scope.cargando = false;
              vm.infoFlag = false;
              $scope.mensajeTablero = "Sin configuración";
              $scope.principal = {
                name: "Contenedor Principal",
                color: "#E8B2E9 ",
                contenedores: [],
              };
            }
          },
          function error(e) {
            console.log("Error - promotorias--", e);
          }
        )
        .catch(function (error) {
          $scope.principal.contenedores = [];
          console.log("Error - promotablero - catch", error);
        });
      // $http.post(url.IP+ 'get-data-promotoria-initial/')
      // .then(
      //   function success (response) {
      //     if(response.data.results.length >0){
      //       if(response.data.perfilRestringido){
      //         $scope.filtrado = true
      //         $scope.principal= response.data.original
      //         $scope.principal.contenedores= (response.data.original.data_details)
      //         $scope.resultsFilter= (response.data.results)
      //         $scope.cargando = false;
      //       }else{
      //         $scope.principal= response.data.original
      //         $scope.principal.contenedores= (response.data.original.data_details)
      //         $scope.principal.url= response.data.original.url
      //         $scope.principal.id= response.data.original.id
      //         $scope.filtrado =response.data.config
      //         $scope.resultsFilter= (response.data.results)
      //         $scope.cargando = false;
      //       }
      //     }else{
      //       $scope.principal = {
      //         'name': 'Contenedor Principal',
      //         'color':'#E8B2E9 ',
      //         'contenedores': []
      //       }
      //     }
      //   },
      //   function error (e) {
      //     console.log('Error - promotorias--', e);
      //   }
      // ).catch(function (error) {
      //   $scope.principal.contenedores=[]
      //   console.log('Error - promotablero - catch', error);
      // });
    }
    function getLog() {
      dataFactory
        .get("get-specific-log", {
          model: 36,
          associated_id: $scope.principal.id,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        });
    }
    $scope.filtrosSubramos = function () {
      getProviders();
      var modalInstance = $uibModal.open({
        templateUrl: "app/modals/filtros_subramos_tablero.html",
        controller: FiltrosSubramosTableroModalCtrl,
        size: "md",
        resolve: {},
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (result) {
        var payload = result["ramos"].map(function (item) {
          return item.subramo_code;
        });
        if (result && result["aseguradoras"]) {
          var asegs = result["aseguradoras"].map(function (item) {
            return item.id;
          });
        } else {
          var asegs = [];
        }
        if (result && result["type_ots"]) {
          var type_ots = result["type_ots"];
        } else {
          var type_ots = 0;
        }
        $http
          .post(url.IP + "fsubramos-tablero/", {
            subramos: payload,
            aseguradoras: asegs,
            type_ots: type_ots,
          })
          .then(function (response) {
            $scope.cargando = true;
            $http
              .post(url.IP + "get-data-promotoria-initial/")
              .then(
                function success(response) {
                  if (response.data.results.length > 0) {
                    if (response.data.perfilRestringido) {
                      $scope.filtrado = true;
                      $scope.principal = response.data.original;
                      $scope.principal.contenedores =
                        response.data.original.data_details;
                      $scope.resultsFilter = response.data.results;
                      $scope.cargando = false;
                    } else {
                      $scope.principal = response.data.original;
                      $scope.principal.contenedores =
                        response.data.original.data_details;
                      $scope.principal.url = response.data.original.url;
                      $scope.principal.id = response.data.original.id;
                      $scope.filtrado = response.data.config;
                      $scope.resultsFilter = response.data.results;
                      $scope.cargando = false;
                    }

                    var params = {
                      model: 36,
                      event: "POST",
                      associated_id: $scope.principal.id,
                      identifier:
                        " cambio la configuración de filtro por subramos en el tablero.",
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                  } else {
                    // SweetAlert.swal(
                    //     'Error',
                    //     'Ha ocurrido un error, intente de nuevo. Si la situación persiste, consulte a soporte@miurabox.com',
                    //     'error'
                    //   );
                    activate();
                    // $scope.principal = {
                    //   'name': 'Contenedor Principal',
                    //   'color':'#E8B2E9 ',
                    //   'contenedores': []
                    // }
                  }
                },
                function error(e) {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error, intente de nuevo. Si la situación persiste, consulte a soporte@miurabox.com",
                    "error"
                  );
                  activate();
                  console.log("Error - promotorias--", e);
                }
              )
              .catch(function (error) {
                // $scope.principal.contenedores=[];
                SweetAlert.swal(
                  "Error",
                  "Ha ocurrido un error, intente de nuevo. Si la situación persiste, consulte a soporte@miurabox.com",
                  "error"
                );
                activate();
                console.log("Error - promotablero - catch", error);
              });
            // $http({
            //   method: 'POST',
            //   url: url.IP + 'get-data-promotoria/',
            //   data: {
            //     ramos: payload,
            //     aseguradoras: asegs,
            //     type_ots:type_ots,
            //     principal: $scope.principal.id,
            //   }
            // })
            // .then(
            //   function success (response) {
            //     $scope.filtrado =true
            //     $scope.principal= (response.data.original)
            //     $scope.principal.contenedores= (response.data.original.data_details)
            //     $scope.resultsFilter= (response.data.results)
            //   },
            //   function error (e) {
            //     console.log('Error - get/promotorias--', e);
            //   }
            // ).catch(function (error) {
            //   console.log('Error - get/promotablero - catch', error);
            // });
            toaster.success("Información actualizada");
          });
      });
    };

    function FiltrosSubramosTableroModalCtrl($scope, $uibModalInstance) {
      $scope.type_ots = 0;
      $scope.subramos_toselected = [
        {
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          subramo_code: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
      ];
      // $scope.selectProv = function(sel){
      //   $scope.providers_selected = [];
      //   sel.forEach(function(cl) {
      //     $scope.providers_selected.push(cl)
      //   })
      // };
      getProvidersModal();
      $scope.cancel = cancel;
      $scope.saveConfig = saveConfig;
      $scope.ramos = [];
      $scope.aseguradoras = [];
      $http.get(url.IP + "fsubramos-tablero/").then(function (response) {
        if (response.data && response.data.data) {
          $scope.type_ots = response.data.type_ots;
          response.data.data.forEach(function (item) {
            $scope.subramos_toselected.forEach(function (sr) {
              if (sr["subramo_code"] == item) {
                $scope.ramos.push(sr);
              }
            });
          });
        }
        if (response.data && response.data.aseguradoras) {
          var date = new Date();
          var curr_date = date.getDate();
          var curr_month = date.getMonth() + 1; //Months are zero based
          var curr_year = date.getFullYear();
          var d = curr_year + "-" + curr_month + "-" + curr_date;
          providerService.getProviderByKey(d).then(function (data) {
            $scope.providers_toselected = data.data;
            response.data.aseguradoras.forEach(function (item) {
              $scope.providers_toselected.forEach(function (sr) {
                if (sr["id"] == item) {
                  $scope.aseguradoras.push(sr);
                }
              });
            });
          });
        }
      });
      $(".js-example-basic-multiple").select2();
      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }

      function saveConfig(sa) {
        var data = {
          ramos: $scope.ramos,
          aseguradoras: $scope.aseguradoras
            ? $scope.aseguradoras
            : $scope.providers_selected,
          type_ots: $scope.type_ots,
        };
        $uibModalInstance.close(data);
      }

      function getProvidersModal() {
        var date = new Date();
        var curr_date = date.getDate();
        var curr_month = date.getMonth() + 1; //Months are zero based
        var curr_year = date.getFullYear();
        var d = curr_year + "-" + curr_month + "-" + curr_date;
        providerService.getProviderByKey(d).then(function (data) {
          $scope.providers_toselected = data.data;
        });
      }
    }
    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        $scope.providers_toselected = data.data;
      });
    }
    $scope.colorArray1 = [
      { name: "Rojo", value: "#F44336" },
      { name: "Azul Claro", value: "#B6E3E9" },
      { name: "Rosa Claro", value: "#FDAFAB" },
      { name: "Amarillo Claro", value: "#FFF59D" },
      { name: "Morado", value: "#B7A9E0" },
      { name: "Gris", value: "#DFE5E5" },
      { name: "Crema", value: "#F1E9DC" },
      { name: "Amarillo", value: "#F8C45F" },
      { name: "Café", value: "#E3B895" },
      { name: "Rosa", value: "#FF319D" },
      { name: "Naranja", value: "#F47231" },
      { name: "Azul", value: "#5ECEF5" },
      { name: "Verde", value: "#00CD7A" },
      { name: "Verde limón", value: "#BEE920" },
      { name: "Verde Claro", value: "#BEE9CB" },
    ];
    $scope.colorArray = [
      "#B6E3E9",
      "#FDAFAB",
      "#FFF59D",
      "#B7A9E0",
      "#DFE5E5",
      "#F1E9DC",
      "#F8C45F",
      "#E3B895",
      "#FF319D",
      "#F47231",
      "#5ECEF5",
      "#00CD7A",
      "#BEE920",
      "#BEE9CB",
      "#F44336",
    ];
    function saveColor(argument) {
      $scope.colorSelected = argument;
      $scope.container.color = argument;
    }
    $scope.gotToInfo = function (info, cnt, ind, tipo) {
      if (tipo == 1) {
        dataFactory
          .get("leer-polizas-info/" + info.id)
          .then(function success(response) {
            if (response.data) {
              var policy = response.data;
              if (policy.document_type == 1) {
                $state.go("polizas.info", { polizaId: info.id });
              } else if (policy.document_type == 3) {
                $state.go("colectividades.info", { polizaId: info.id });
              } else if (policy.document_type == 6) {
                $state.go("colectividades.info", { polizaId: info.id });
              } else if (policy.document_type == 7) {
                $state.go("fianzas.info", { polizaId: info.id });
              } else if (policy.document_type == 8) {
                $state.go("fianzas.details", { polizaId: info.id });
              } else if (policy.document_type == 12) {
                // $state.go('flotillas.info',{polizaId: info.id})
              }
            }
          })
          .catch(function (error) {
            console.log("Error - getot - catch", error);
          });
      }
      if (tipo == 2) {
        $state.go("endorsement.info", { endosoId: info.id });
      }
    };
    $scope.cancelNewEdit = function () {
      $scope.container = {};
      $scope.newcontainer = false;
      $scope.editcontainer_b = false;
    };
    function moveOTState(cn_data, cn, newcontainer, principal, tipo) {
      if (!cn_data || !cn || !newcontainer || !principal) {
        console.error("Invalid parameters passed to moveOTState");
        return;
      }

      // Remove the ID from any existing container before adding it to the new one
      angular.forEach(principal.contenedores, function (container) {
        if (tipo === 1) {
          var index = container.polizas.indexOf(cn_data.id);
          if (index !== -1) {
            container.polizas.splice(index, 1);
          }
        } else if (tipo === 2) {
          var index = container.endoso.indexOf(cn_data.id);
          if (index !== -1) {
            container.endoso.splice(index, 1);
          }
        }
      });

      // Add the ID to the new container
      if (tipo === 1 && newcontainer.polizas.indexOf(cn_data.id) === -1) {
        newcontainer.polizas.push(cn_data.id);
      } else if (tipo === 2 && newcontainer.endoso.indexOf(cn_data.id) === -1) {
        newcontainer.endoso.push(cn_data.id);
      }

      // Prepare the payload ensuring unique IDs
      var payload = {
        polizas_ots: principal.contenedores.map(function (container) {
          return {
            tablero: container.tablero,
            color: container.color,
            polizas: Array.from(new Set(container.polizas)), // Ensuring unique IDs
            endoso: Array.from(new Set(container.endoso)), // Ensuring unique IDs
          };
        }),
        name: principal.name,
        color: principal.color,
        url: $scope.principal.url || "",
      };
      // Uncomment the following block to make the HTTP request once needed
      // /*
      if ($scope.principal.url && $scope.principal.url !== "") {
        $http
          .patch($scope.principal.url, payload)
          .then(
            function success(response) {
              var params = {
                model: 36,
                event: "PATCH",
                associated_id: $scope.principal.id,
                identifier:
                  " cambio la OT " +
                  (tipo == 1 ? "Póliza" : "Endoso") +
                  " de columna: " +
                  cn.tablero +
                  "  a: " +
                  newcontainer.tablero +
                  " (" +
                  cn_data.internal_number +
                  "):" +
                  cn_data.id,
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              // activate();
              $state.reload();
            },
            function error(e) {
              console.error("Error updating data:", e);
            }
          )
          .catch(function (error) {
            console.error("Error in moveOTState - catch:", error);
          });
      }
      // */
    }

    // function moveOTState(cn_data,cn,newcontainer,principal,tipo){
    //   // $scope.cargando = true;
    //   // cn.data.splice(cn_data,1)
    //   if(tipo ==1){
    //     cn.polizas.splice(cn.polizas.indexOf(cn_data.id), 1);
    //     newcontainer.polizas.push(cn_data.id)
    //   }
    //   if(tipo ==2){
    //     cn.endoso.splice(cn.endoso.indexOf(cn_data.id), 1);
    //     newcontainer.endoso.push(cn_data.id)
    //   }
    //   console.log('tablero**********',newcontainer,principal.contenedores,cn_data.id,tipo,cn)
    //   if(principal.contenedores && principal.contenedores.length>0){
    //     principal.contenedores.forEach(function(r,i) {
    //       if(r){
    //         if (r["details_endoso"]){
    //           r["details_endoso"] = []
    //         }
    //         if(r["details_polizas"]){
    //           r["details_polizas"] = []
    //         }
    //       }
    //     })
    //   }
    //   var payload = {
    //     'polizas_ots' :(principal.contenedores),
    //     'name':principal.name,
    //     'color':principal.color,
    //     'url': $scope.principal.url ? $scope.principal.url :''
    //   }
    //   console.log('payload',payload,cn,newcontainer)
    //   // if ($scope.principal.url && $scope.principal.url !='') {
    //   //   $http.patch($scope.principal.url,payload)
    //   //   .then(
    //   //     function success (response) {
    //   //       console.log('repsonseEEEEEEEE',response,payload)
    //   //       activate();
    //   //     },
    //   //     function error (e) {
    //   //       console.log('Error - promotorias--', e);
    //   //     }
    //   //   ).catch(function (error) {
    //   //     console.log('Error - promotablero - catch', error);
    //   //   });
    //   // }
    // }
    function getPDF(id_ot) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-ot/",
        responseType: "arraybuffer",
        params: {
          id: id_ot,
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          toaster.info("Se generó el PDF");
          $scope.pdf = response.data;
          var file = new Blob([response.data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
          var params = {
            model: 1,
            event: "POST",
            associated_id: id_ot,
            identifier: "generó el PDF.",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
        } else {
          toaster.warning("Ocurrió Un problema,Intenta nuevamente");
        }
      });
    }
    $scope.getPDFE = function (endoso) {
      var params = {
        poliza: endoso.policy ? endoso.policy.id : 0,
        fianza: 0,
        endoso: endoso.id,
      };
      $http({
        method: "GET",
        url: url.IP + "get-pdf-endorsement-new/",
        responseType: "arraybuffer",
        params: params,
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });

        var fileURL = URL.createObjectURL(file);
        $scope.content = $sce.trustAsResourceUrl(fileURL);
        window.open($scope.content);
      });
    };
    function moveOTStateFilter(
      filter_cn_data,
      filter_cn,
      newcontainer,
      principal,
      tipo
    ) {
      var contenedoredit = {};
      if (tipo == 1) {
        filter_cn.polizas.splice(
          filter_cn.polizas.indexOf(filter_cn_data.id),
          1
        );
        newcontainer.polizas.push(filter_cn_data.id);
      }
      if (tipo == 2) {
        filter_cn.endoso.splice(filter_cn.endoso.indexOf(filter_cn_data.id), 1);
        newcontainer.endoso.push(filter_cn_data.id);
      }
      principal.contenedores.forEach(function (r) {
        if (r) {
          if (r["details_endoso"]) {
            r["details_endoso"] = [];
          }
          if (r["details_polizas"]) {
            r["details_polizas"] = [];
          }
        }
        if (r.tablero == filter_cn.tablero) {
          if (tipo == 1) {
            r.polizas.forEach(function (d) {
              if (d == filter_cn_data.id) {
                r.polizas.splice(r.polizas.indexOf(d), 1);
              }
            });
          }
          if (tipo == 2) {
            r.endoso.forEach(function (d) {
              if (d == filter_cn_data.id) {
                r.endoso.splice(r.endoso.indexOf(d), 1);
              }
            });
          }
        }
      });
      var payload = {
        polizas_ots: principal.contenedores,
        tablero: principal.tablero,
        color: principal.color,
        url: $scope.principal.url ? $scope.principal.url : "",
      };
      if ($scope.principal.url && $scope.principal.url != "") {
        $http
          .patch($scope.principal.url, payload)
          .then(
            function success(response) {
              activate();
            },
            function error(e) {
              console.log("Error - promotorias--", e);
            }
          )
          .catch(function (error) {
            console.log("Error - promotablero - catch", error);
          });
      } else {
        console.log("-no princi", $scope.principal, principal.contenedores);
      }
    }
    function deleteContainer(container, principal, ind) {
      SweetAlert.swal(
        {
          title: "Eliminar Contenedor",
          text:
            "Se eliminará definitivamente del Tablero\n" +
            container.tablero +
            "\n¿Desea continuar?\n",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
            principal.contenedores.splice(
              principal.contenedores.indexOf(container),
              1
            );
            principal.contenedores.forEach(function (r) {
              if (r) {
                if (r["details_endoso"]) {
                  r["details_endoso"] = [];
                }
                if (r["details_polizas"]) {
                  r["details_polizas"] = [];
                }
              }
            });
            var payload = {
              polizas_ots: principal.contenedores,
              name: principal.name,
              color: principal.color,
              url: $scope.principal.url ? $scope.principal.url : "",
            };
            $http
              .patch($scope.principal.url, payload)
              .then(
                function success(response) {
                  var params = {
                    model: 36,
                    event: "DELETE",
                    associated_id: $scope.principal.id,
                    identifier:
                      " borro la columna del tablero: " +
                      container.tablero +
                      ".",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  activate();
                },
                function error(e) {
                  console.log("Error - promotorias--", e);
                }
              )
              .catch(function (error) {
                console.log("Error - promotablero - catch", error);
              });
          }
        }
      );
    }
    function editContainer(container, inde) {
      $scope.container = container;
      $scope.newcontainer = false;
      $scope.editcontainer_b = true;
      $scope.index = inde;
    }
    $scope.newcontainer = false;
    $scope.addContainer = function (argument) {
      $scope.newcontainer = true;
      $scope.editcontainer_b = false;
      $scope.container = {
        tipo: 1,
        tablero: "",
        color: "",
        polizas: [],
        endoso: [],
      };
    };
    function deleteFromData(p, container) {
      // container.data.splice(p,1)
      container.data.splice(container.data.indexOf(p), 1);
    }
    function deleteFromDataSave(cn_data, cn, principal, index) {
      SweetAlert.swal(
        {
          title: "Eliminar Registro",
          text:
            "Se eliminará definitivamente del Contenedor, ¿Desea continuar? \n" +
            cn_data.val,
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
            cn.data.splice(cn.data.indexOf(cn_data), 1);
            var payload = {
              polizas_ots: principal.contenedores,
              tablero: principal.tablero,
              color: principal.color,
              url: $scope.principal.url ? $scope.principal.url : "",
            };
            if ($scope.principal.url && $scope.principal.url != "") {
              $http
                .patch($scope.principal.url, payload)
                .then(
                  function success(response) {
                    $scope.principal = response.data;
                    $scope.principal.contenedores = response.data.config;
                    $scope.principal.url = response.data.url;
                    $scope.principal.id = response.data.id;
                  },
                  function error(e) {
                    console.log("Error - promotorias--", e);
                  }
                )
                .catch(function (error) {
                  console.log("Error - promotablero - catch", error);
                });
            }
          }
        }
      );
    }
    $scope.saveContainer = function (principal, arg) {
      $scope.mensajeTablero = "";
      $scope.newcontainer = false;
      if (
        arg.tablero == "EN TRÁMITE" ||
        arg.tablero == "Pendiente" ||
        arg.tablero == "PENDIENTE"
      ) {
        arg["tipo"] = 0;
      }
      arg["polizas"] = [];
      arg["endoso"] = [];
      principal.contenedores = principal.contenedores
        ? principal.contenedores
        : [];
      if (principal.contenedores && principal.contenedores.length > 0) {
        principal.contenedores.forEach(function (r, i) {
          if (r) {
            if (r["details_endoso"]) {
              r["details_endoso"] = [];
            }
            if (r["details_polizas"]) {
              r["details_polizas"] = [];
            }
          }
        });
      }
      principal.contenedores.push(arg);
      var payload = {
        polizas_ots: principal.contenedores ? principal.contenedores : [],
        url: $scope.principal.url ? $scope.principal.url : "",
      };
      if ($scope.principal.url && $scope.principal.url != "") {
        $http
          .patch($scope.principal.url, payload)
          .then(
            function success(response) {
              var params = {
                model: 36,
                event: "POST",
                associated_id: $scope.principal.id,
                identifier:
                  " agrego una columna al tablero: " + arg.tablero + " .",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              activate();
            },
            function error(e) {
              console.log("Error - promotorias--", e);
            }
          )
          .catch(function (error) {
            console.log("Error - promotablero - catch", error);
          });
      } else {
        $http
          .post(url.IP + "promotoria-tablero/", payload)
          .then(
            function success(response) {
              activate();
            },
            function error(e) {
              console.log("Error - promotorias--", e);
            }
          )
          .catch(function (error) {
            console.log("Error - promotablero - catch", error);
          });
      }
    };
    $scope.saveContainerFilter = function (principal, arg) {
      $scope.newcontainer = false;
      if (arg.name == "EN TRÁMITE" || arg.name == "Pendiente") {
        arg.tipo = 0;
      }
      principal.contenedores = principal.contenedores
        ? principal.contenedores
        : [];
      if (principal.contenedores && principal.contenedores.length > 0) {
        principal.contenedores.forEach(function (r, i) {
          if (r) {
            if (r["details_endoso"]) {
              r["details_endoso"] = [];
            }
            if (r["details_polizas"]) {
              r["details_polizas"] = [];
            }
          }
        });
      }
      principal.contenedores.push(arg);
      var payload = {
        // 'polizas_ots': []
        polizas_ots: principal.contenedores ? principal.contenedores : [],
        name: principal.name,
        color: principal.color,
        url: $scope.principal.url ? $scope.principal.url : "",
      };
      if ($scope.principal.url && $scope.principal.url != "") {
        $http
          .patch($scope.principal.url, payload)
          .then(
            function success(response) {
              var params = {
                model: 36,
                event: "POST",
                associated_id: $scope.principal.id,
                identifier: " agrego columna al tablero: " + arg.tablero + ".",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              $state.reload();
            },
            function error(e) {
              console.log("Error - promotorias--", e);
            }
          )
          .catch(function (error) {
            console.log("Error - promotablero - catch", error);
          });
      }
    };
    $scope.saveEditContainerFilter = function (principal, con) {
      $scope.editcontainer_b = false;
      $scope.newcontainer = false;
      principal.contenedores[$scope.index].tablero = con.tablero;
      principal.contenedores[$scope.index].color = con.color;
      if (principal.contenedores && principal.contenedores.length > 0) {
        principal.contenedores.forEach(function (r, i) {
          if (r) {
            if (r["details_endoso"]) {
              r["details_endoso"] = [];
            }
            if (r["details_polizas"]) {
              r["details_polizas"] = [];
            }
          }
        });
      }
      var payload = {
        polizas_ots: principal.contenedores,
        name: principal.name,
        color: principal.color,
        url: $scope.principal.url ? $scope.principal.url : "",
      };
      $http
        .patch($scope.principal.url, payload)
        .then(
          function success(response) {
            var params = {
              model: 36,
              event: "PATCH",
              associated_id: $scope.principal.id,
              identifier:
                " edito la columna del tablero: " +
                principal.contenedores[$scope.index].tablero +
                "por " +
                con.tablero +
                ".",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            activate();
          },
          function error(e) {
            console.log("Error - promotorias--", e);
          }
        )
        .catch(function (error) {
          console.log("Error - promotablero - catch", error);
        });
    };
    $scope.saveEditContainer = function (principal, con) {
      $scope.editcontainer_b = false;
      $scope.newcontainer = false;
      principal.contenedores[$scope.index].tablero = con.tablero;
      principal.contenedores[$scope.index].color = con.color;
      if (principal.contenedores && principal.contenedores.length > 0) {
        principal.contenedores.forEach(function (r, i) {
          if (r) {
            if (r["details_endoso"]) {
              r["details_endoso"] = [];
            }
            if (r["details_polizas"]) {
              r["details_polizas"] = [];
            }
          }
        });
      }
      var payload = {
        polizas_ots: principal.contenedores,
        name: principal.name,
        color: principal.color,
        url: $scope.principal.url ? $scope.principal.url : "",
      };
      $http
        .patch($scope.principal.url, payload)
        .then(
          function success(response) {
            var params = {
              model: 36,
              event: "PATCH",
              associated_id: $scope.principal.id,
              identifier:
                " edito el tablero: " +
                principal.contenedores[$scope.index].tablero +
                "  a: " +
                con.tablero +
                " .",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            activate();
          },
          function error(e) {
            console.log("Error - promotorias--", e);
          }
        )
        .catch(function (error) {
          console.log("Error - promotablero - catch", error);
        });
    };
    // $scope.saveEditContainer = function(principal,con){
    //   $scope.editcontainer_b = false
    //   $scope.newcontainer = false
    //   var payload = {
    //     'config' :JSON.stringify(principal.contenedores),
    //     'name':principal.name,
    //     'color':principal.color,
    //     'url': $scope.principal.url ? $scope.principal.url :''
    //   }
    //   $http.patch($scope.principal.url,payload)
    //   .then(
    //     function success (response) {
    //       $scope.principal = (response.data)
    //       $scope.principal.contenedores  = (response.data.data_details)
    //       $scope.principal.url= response.data.url
    //       $scope.principal.id= response.data.id
    //     },
    //     function error (e) {
    //       console.log('Error - promotorias--', e);
    //     }
    //   ).catch(function (error) {
    //     console.log('Error - promotablero - catch', error);
    //   });
    // }
    // ---------------
    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
    };
    $scope.selectAseguradoras = function (sel) {
      vm.aseguradoras_selected = [];
      vm.ida = sel[0];
      sel.forEach(function (r) {
        vm.aseguradoras_selected.push(parseInt(r));
      });
    };
    $scope.filtrado = false;
    function getDataPromotoria(data, pr, v) {
      if (v == 1) {
        $state.reload();
      } else if (vm.ramos_selected && vm.ramos_selected.length != 0) {
        $http({
          method: "POST",
          url: url.IP + "get-data-promotoria/",
          data: {
            ramos: vm.ramos_selected,
            principal: $scope.principal.id,
          },
        })
          .then(
            function success(response) {
              $scope.filtrado = true;
              $scope.principal = response.data.original;
              $scope.principal.contenedores =
                response.data.original.data_details;
              $scope.resultsFilter = response.data.results;
            },
            function error(e) {
              console.log("Error - get/promotorias--", e);
            }
          )
          .catch(function (error) {
            console.log("Error - get/promotablero - catch", error);
          });
      } else {
        $state.reload();
      }
    }
    // ---------------

    function fillProvider() {
      var d = vm.form.startDate;
      try {
        var curr_date = d.getDate();
        var curr_month = d.getMonth() + 1; //Months are zero based
        var curr_year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var curr_date = f.getDate();
        var curr_month = f.getMonth() + 1; //Months are zero based
        var curr_year = f.getFullYear();
      }

      var date = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(date).then(
        function success(data) {
          vm.defaults.providers = data.data;
          vm.defaults.providers.forEach(function (x) {
            if (
              x.alias == "Chubb" ||
              x.alias == "chubb" ||
              x.alias == "Aba" ||
              x.alias == "ABA"
            ) {
              vm.form.aseguradora = x;
            }
          });
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }
    $scope.dataShare = [];
    function goToInfo(insurance) {
      if (insurance.document_type == 1) {
        $scope.route_for_new_tab = "polizas.info";
        var name = "Información Póliza";
        var route = "polizas.info";
      } else if (insurance.document_type == 3) {
        $scope.route_for_new_tab = "colectividades.info";
        var name = "Información Colectividad";
        var route = "colectividades.info";
      } else if (insurance.document_type == 11) {
        $scope.route_for_new_tab = "flotillas.info";
        var name = "Información Flotilla";
        var route = "flotillas.info";
      } else if (insurance.document_type == 12) {
        $scope.route_for_new_tab = "flotillas.info";
        var name = "Información Flotilla";
        var route = "flotillas.info";
      }
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      // var index_tab = appStates.states.findIndex(function(state){return state.active === true});
      if (insurance.document_type == 1) {
        // appStates.states[index_tab] = {
        //   id: insurance.id,
        //   name: 'Info póliza '+ insurance.poliza_number,
        //   heading: 'Info póliza '+ insurance.poliza_number,
        //   route: 'polizas.info',
        //   active: appStates.states[index_tab].active,
        //   isVisible: appStates.states[index_tab].isVisible,
        //   href: $state.href('polizas.info', {polizaId: insurance.id})
        // }
        // $localStorage.tab_states = appStates.states;
        $state.go("polizas.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 3) {
        $state.go("colectividades.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 11) {
        $state.go("flotillas.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 12) {
        $state.go("flotillas.info", { polizaId: insurance.caratula });
      }
    }
    function addToData(p, container) {
      container.data.push(vm.policy_number);
      vm.policy_number = {};
    }
    $scope.findPolicy = function (parValue, container) {
      if (parValue) {
        if (parValue.val.length >= 3) {
          // if ($scope.infoUser.staff && !$scope.infoUser.superuser) {
          //   $scope.show_contractor = 'v2/polizas/get-endorsements-policies/';
          $scope.show_contractor = "get-ots/";
          dataFactory
            .post($scope.show_contractor, { word: parValue.val })
            .then(
              function success(request) {
                var results = [];
                var results2 = [];
                results = _.map(request.data.ots, function (item) {
                  var label =
                    "OT: " +
                    item.internal_number +
                    " - " +
                    item.contractor.full_name +
                    " - " +
                    datesFactory.convertDate(item.start_of_validity) +
                    " - " +
                    datesFactory.convertDate(item.end_of_validity) +
                    "-" +
                    item.ramo;
                  return {
                    label: label,
                    value: item.internal_number,
                    id: item.id,
                    tipo_registro: 0,
                  };
                });
                results2 = _.map(request.data.endosos, function (item_end) {
                  if (item_end.policy.document_type == 1) {
                    var ti = "Póliza";
                  } else if (item_end.policy.document_type == 3) {
                    var ti = "Póliza Grupo";
                  } else if (item_end.policy.document_type == 12) {
                    var ti = "Póliza Colectividad";
                  } else {
                    var ti = item_end.policy.document_type;
                  }
                  var label =
                    "Endoso: " +
                    item_end.internal_number +
                    " - " +
                    item_end.policy.contractor.full_name +
                    " - " +
                    datesFactory.convertDate(item_end.init_date) +
                    " - " +
                    datesFactory.convertDate(item_end.end_date) +
                    "-" +
                    item_end.policy.ramo.ramo_name;
                  return {
                    label: label,
                    value: item_end.internal_number,
                    id: item_end.id,
                    tipo_registro: 1,
                  };
                });
                results2.forEach(function (x) {
                  results.push(x);
                });
                $scope.autocompleteData = results;
                $scope.autocompleteDataEndoso = results2;
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };
    $scope.list1 = { title: "AngularJS - Drag Me" };
    $scope.list2 = {};
    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }
    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }
    $scope.lista = [
      { id: 1, name: "una" },
      { id: 2, name: "dos" },
    ];
    $scope.$broadcast("ngDraggable:inputEvent", {});
    // #--------------
    $scope.onDragComplete = function (data, evt) {
      console.log("drag success, data:", data);
    };
    $scope.onDropComplete = function (data, evt) {
      console.log("drop success, data:", data);
    };
    // *********************
    function mesDiaAnio(parDate) {
      var d = new Date(toDate(parDate));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      return date;
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("ScrslController", ScrslController);

  ScrslController.$inject = [
    "$scope",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "$q",
    "helpers",
    "globalVar",
    "generalService",
    "$state",
    "$localStorage",
  ];

  function ScrslController(
    $scope,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    $q,
    helpers,
    globalVar,
    generalService,
    $state,
    $localStorage
  ) {
    $scope.vm = this;
    $scope.showSucursal = false;
    $scope.edit = false;
    $scope.sucursal = {};
    $scope.address = {};

    $scope.createSucursal = function () {
      $scope.showSucursal = true;
      $scope.sucursal.sucursal_name = "";
      $scope.address.route = "";
      $scope.address.street_number = "";
      $scope.address.street_number_int = "";
      $scope.address.sublocality = "";
      $scope.address.administrative_area_level_1 = "";
      $scope.address.postal_code = "";
      $scope.address.details = "";
      $scope.sucursal.details = "";
      if ($localStorage["save_create_sucursal"]) {
        $scope.sucursal.sucursal_name = $localStorage["save_create_sucursal"]
          ? $localStorage["save_create_sucursal"]["sucursal_name"]
          : "";
        $scope.address.route = $localStorage["save_create_sucursal"]
          ? $localStorage["save_create_sucursal"]["route"]
          : "";
        $scope.address.street_number = $localStorage["save_create_sucursal"]
          ? $localStorage["save_create_sucursal"]["street_number"]
          : "";
        $scope.address.street_number_int = $localStorage["save_create_sucursal"]
          ? $localStorage["save_create_sucursal"]["street_number_int"]
          : "";
        $scope.address.sublocality = $localStorage["save_create_sucursal"]
          ? $localStorage["save_create_sucursal"]["sublocality"]
          : "";
        $scope.address.administrative_area_level_1 = $localStorage[
          "save_create_sucursal"
        ]
          ? $localStorage["save_create_sucursal"]["administrative_area_level_1"]
          : "";
        $scope.address.administrative_area_level_2 = $localStorage[
          "save_create_sucursal"
        ]
          ? $localStorage["save_create_sucursal"]["administrative_area_level_2"]
          : "";
        $scope.address.postal_code = $localStorage["save_create_sucursal"]
          ? $localStorage["save_create_sucursal"]["postal_code"]
          : "";
        $scope.address.details = $localStorage["save_create_sucursal"]
          ? $localStorage["save_create_sucursal"]["details"]
          : "";
        $scope.sucursal.details = $localStorage["save_create_sucursal"]
          ? $localStorage["save_create_sucursal"]["observations"]
          : "";
      }
      if ($scope.addresses.length == 0) {
        $scope.addresses.add(1);
      }
    };

    $scope.addresses = {
      add: addAddress,
      selectedState: selectedState,
      delete: deleteAddress,
    };

    activate();
    function activate() {
      dataFactory
        .get("sucursales-to-show-unpag/")
        .then(function success(response) {
          $scope.sucursalList = response.data;
        });
      // Direcciones
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          $scope.statesArray = data.data;
        });
    }

    if ("save_create_sucursal" in $localStorage) {
    } else {
      $localStorage["save_create_sucursal"] = {};
    }

    $scope.saveLocalstorange = function () {
      $localStorage["save_create_sucursal"]["sucursal_name"] = $scope.sucursal
        .sucursal_name
        ? $scope.sucursal.sucursal_name
        : "";
      $localStorage["save_create_sucursal"]["route"] = $scope.address.route
        ? $scope.address.route
        : "";
      $localStorage["save_create_sucursal"]["street_number"] = $scope.address
        .street_number
        ? $scope.address.street_number
        : "";
      $localStorage["save_create_sucursal"]["street_number_int"] = $scope
        .address.street_number_int
        ? $scope.address.street_number_int
        : "";
      $localStorage["save_create_sucursal"]["sublocality"] = $scope.address
        .sublocality
        ? $scope.address.sublocality
        : "";
      $localStorage["save_create_sucursal"]["administrative_area_level_1"] =
        $scope.address.administrative_area_level_1
          ? $scope.address.administrative_area_level_1
          : "";
      $localStorage["save_create_sucursal"]["administrative_area_level_2"] =
        $scope.address.administrative_area_level_2
          ? $scope.address.administrative_area_level_2
          : "";
      $localStorage["save_create_sucursal"]["postal_code"] = $scope.address
        .postal_code
        ? $scope.address.postal_code
        : "";
      $localStorage["save_create_sucursal"]["details"] = $scope.address.details
        ? $scope.address.details
        : "";
      $localStorage["save_create_sucursal"]["observations"] = $scope.sucursal
        .details
        ? $scope.sucursal.details
        : "";
    };

    function addAddress(type) {
      $scope.sucursal.address = [];
      // HACK remove before production
      var address = {
        raw: "",
        street_address: "",
        intersection: "",
        political: "",
        administrative_area_level_1: "",
        administrative_area_level_1_short: "",
        administrative_area_level_2: "",
        administrative_area_level_3: "",
        colloquial_area: "",
        sublocality: "",
        neighborhood: "",
        premise: "",
        subpremise: "",
        natural_feature: "",
        country: "",
        country_code: "",
        locality: "",
        postal_code: "",
        route: "",
        street_number: "",
        street_number_int: "",
        formatted: "",
        latitude: "",
        longitude: "",
        details: "",
        composed: "",
      };
      $scope.sucursal.address.push(address);
    }
    function deleteAddress(index, type) {
      $scope.sucursal.address.splice(index, 1);
    }

    function selectedState(selected, index, type) {
      $scope.sucursal.address[index].city = "";
      $scope.sucursal.address[index].citiesList = selected.cities;
    }

    $scope.saveSucursal = function (form) {
      $scope.dataToSave = {};
      $scope.dataToSave.sucursal_name = form.sucursal_name;
      $scope.dataToSave.details = form.details;
      $scope.sucursal.address = [];
      $scope.sucursal.address.push($scope.address);

      dataFactory
        .post("sucursal/", $scope.dataToSave)
        .then(function success(response) {
          if (response.status == 200 || response.status == 201) {
            $scope.sucursal.address.forEach(function (address) {
              $scope.acumulate = $scope.acumulate + 1;
              address.url = globalVar.address;
              address.administrative_area_level_1 =
                address.administrative_area_level_1.state;
              address.administrative_area_level_2 =
                address.administrative_area_level_2.city;
              address.sucursal = response.data.url;
              address.tipo = address.tipo ? address.tipo.name : "";
              // generalService.postService(address);

              $http
                .post(address.url, address)
                .then(function (resp) {
                  if (resp) {
                    $localStorage["save_create_sucursal"] = {};
                    $state.reload();
                    SweetAlert.swal(
                      "¡Listo!",
                      MESSAGES.OK.SUCURSALCREATE,
                      "success"
                    );
                    $scope.closeSucursal();
                  }
                })
                .catch(function (err) {
                  console.log("Error", err);
                });
            });
            $localStorage["save_create_sucursal"] = {};
          } else {
            activate();
            $scope.closeSucursal();
            $localStorage["save_create_sucursal"] = {};
          }
        });
    };

    $scope.closeSucursal = function () {
      $scope.showSucursal = false;
      if ($scope.edit) {
        $scope.sucursalList[
          $scope.idx
        ].address_sucursal[0].administrative_area_level_1 = $scope.copy_state;
        $scope.sucursalList[
          $scope.idx
        ].address_sucursal[0].administrative_area_level_2 = $scope.copy_city;
      }
    };

    $scope.editSucursal = function (item, index) {
      $scope.edit = true;
      $scope.sucursal = item;
      $scope.address = item.address_sucursal[0];
      $scope.idx = index;
      $scope.copy_state = item.address_sucursal[0].administrative_area_level_1;
      $scope.copy_city = item.address_sucursal[0].administrative_area_level_2;
      $scope.statesArray.forEach(function (state) {
        if (
          state.state == item.address_sucursal[0].administrative_area_level_1
        ) {
          $scope.address.administrative_area_level_1 = state;
          state.cities.forEach(function (city) {
            if (
              city.city == item.address_sucursal[0].administrative_area_level_2
            ) {
              $scope.address.administrative_area_level_2 = city;
            }
          });
        }
      });
      console.log("--suvirsal-", item);
      $scope.showSucursal = true;
    };

    $scope.updateSucursal = function (item) {
      item.address_sucursal[0].administrative_area_level_1 =
        item.address_sucursal[0].administrative_area_level_1.state;
      item.address_sucursal[0].administrative_area_level_2 =
        item.address_sucursal[0].administrative_area_level_2.city;
      $http
        .patch(item.url, item)
        .then(function (response) {
          if (response) {
            $http
              .patch(item.address_sucursal[0].url, item.address_sucursal[0])
              .then(function (respo) {
                if (respo) {
                  $localStorage["save_create_sucursal"] = {};
                  $state.reload();
                  SweetAlert.swal(
                    "¡Listo!",
                    "Sucursal actualizada correctamente.",
                    "success"
                  );
                  $scope.closeSucursal();
                }
              })
              .catch(function (err) {
                console.log("Error", err);
              });
          }
        })
        .catch(function (err) {
          console.log("Error", err);
        });
    };
  }
})();

"use strict";

angular.module("inspinia").factory("SiniestroService", SiniestroService);

SiniestroService.$inject = [
  "$state",
  "SweetAlert",
  "$q",
  "toaster",
  "$localStorage",
  "FileUploader",
  "insuranceService",
  "$uibModal",
  "ramoService",
  "$http",
  "url",
  "helpers",
];
function SiniestroService(
  $state,
  SweetAlert,
  $q,
  toaster,
  $localStorage,
  FileUploader,
  insuranceService,
  $uibModal,
  ramoService,
  $http,
  url,
  helpers
) {
  return {
    getSiniestros: getSiniestros,
    getPadecimientos: getPadecimientos,
  };

  function getSiniestros() {
    var dfd = $q.defer();
    return $http
      .get(url.IP + "siniestros/")
      .then(getReceiptsServiceComplete)
      .catch(getReceiptsServiceFailed);

    function getReceiptsServiceComplete(response) {
      dfd.resolve(response.data.results);
      return dfd.promise;
    }

    function getReceiptsServiceFailed(error) {
      ////console.log('getReceiptsServiceFailed', error);
    }
  }

  function getPadecimientos(parPadecimiento) {
    var padeString = parPadecimiento.split(" ").join("_");
    var defered = $q.defer();

    $http
      .get(url.IP + "padecimientos-by-substring/" + padeString)
      .success(function (response) {
        defered.resolve(response);
      })
      .error(function (err) {
        defered.reject(err);
      });

    return defered.promise;
  }
}

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("siniestrosInfoCtrl", siniestrosInfoCtrl);

  siniestrosInfoCtrl.$inject = [
    "facturas_conceptos",
    "datesFactory",
    "providerService",
    "packageService",
    "fileService",
    "$stateParams",
    "$rootScope",
    "$state",
    "SweetAlert",
    "$q",
    "toaster",
    "$localStorage",
    "FileUploader",
    "insuranceService",
    "$scope",
    "$uibModal",
    "ramoService",
    "$http",
    "url",
    "helpers",
    "exportFactory",
    "$sessionStorage",
    "MESSAGES",
    "$sce",
    "dataFactory",
    "$location",
    "$anchorScroll",
    "emailService",
  ];

  function siniestrosInfoCtrl(
    facturas_conceptos,
    datesFactory,
    providerService,
    packageService,
    fileService,
    $stateParams,
    $rootScope,
    $state,
    SweetAlert,
    $q,
    toaster,
    $localStorage,
    FileUploader,
    insuranceService,
    $scope,
    $uibModal,
    ramoService,
    $http,
    url,
    helpers,
    exportFactory,
    $sessionStorage,
    MESSAGES,
    $sce,
    dataFactory,
    $location,
    $anchorScroll,
    emailService
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var token = JSON.parse(decryptedToken);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.user = usr;

    vm.siniestro_id = $stateParams.siniestroId;
    vm.selectedRamo = null;
    vm.selectedSubRamo = null;
    vm.selectedPoliza;
    vm.sub_ramos = [
      { id: 2, label: "Accidentes personales" },
      { id: 3, label: "Gastos médicos" },
      { id: 4, label: "Salud" },
    ];
    vm.status = { id: 0, label: "Estatus" };
    vm.statuses = [
      { id: 1, label: "Pendiente" },
      { id: 2, label: "En trámite" },
      { id: 3, label: "Completado" },
      { id: 4, label: "Cancelada" },
      { id: 5, label: "Rechazada" },
      { id: 6, label: "En espera" },
    ];
    vm.insurances_number = [];
    vm.isInicial = true;
    vm.selectedContractor;
    $scope.subramo_select;
    vm.element = "";
    vm.ramos = [];
    vm.affected = [];
    vm.affect_list = [];
    vm.ramoId = -1;
    vm.insurances;
    vm.selected_affect = [];
    vm.selectInsurance;
    vm.affect_data = {};
    vm.selected_disease = [];
    vm.siniestros = [];
    vm.siniester_data = {};
    vm.siniester_data.siniestros_by_number = [];
    vm.siniester_data.selected_number_siniester;
    vm.enfermedades = [];
    vm.LookFor = LookFor;
    vm.getPdf = getPdf;
    vm.getPDFiniquito = getPDFiniquito;
    vm.crear_complemento = crear_complemento;
    vm.selectedPoliza;
    vm.ramos = {};
    vm.facturas = [];
    vm.ramos.ramo_selected = 1;
    $scope.observation_aux = "";
    $scope.final_procedente = 0.0;
    $scope.final_reclamado = 0.0;
    vm.facturas_conceptos = facturas_conceptos;
    vm.total = {};
    vm.ramos.options = [
      { id: 2, label: "Accidentes y Enfermedades" },
      { id: 3, label: "Daños" },
      { id: 1, label: "Vida" },
    ];
    var date = new Date();

    function exportSiniestroComments() {
      if (!vm.siniestro_id || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
        $scope.$evalAsync(function () {});
      };

      var paramsObj = {
        model: 5,
        id_model: vm.siniestro_id,
      };
      if (vm.org_name) {
        paramsObj.org = vm.org_name;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: paramsObj,
          downloadName: "bitacora-siniestro.xlsx",
          token: token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }

    vm.files = [];
    vm.form = {};
    var titles = {
      1: "Titular",
      2: "Cónyuge",
      3: "Hijo",
      4: "Otro",
    };
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    $scope.colors = [
      { name: "black", shade: "dark" },
      { name: "white", shade: "light", notAnOption: true },
      { name: "red", shade: "dark" },
      { name: "blue", shade: "dark", notAnOption: true },
      { name: "yellow", shade: "light", notAnOption: false },
    ];
    $scope.myColor = $scope.colors[2];
    vm.updateStatus = updateStatus;
    vm.uploadFiles = uploadFiles;
    vm.deleteFactura = deleteFactura;
    vm.addFactura = addFactura;
    vm.changeSinesterNumber = changeSinesterNumber;
    vm.ramo_changed = ramo_changed;
    vm.deleteSiniestro = deleteSiniestro;
    $scope.deleteFile = deleteFile;
    vm.saveEditInformation = saveEditInformation;
    vm.getPDF = getPDF;
    vm.viewObservation = viewObservation;
    vm.updateSiniestroStatus = updateSiniestroStatus;
    vm.updateSiniestro = updateSiniestro;
    $scope.aux_folio;
    $scope.aux_fecha_promesa = new Date();
    $scope.final_deducible;
    $scope.final_coaseguro;
    $scope.final_complemento;
    $scope.cancelRazon;
    vm.goToPolicy = goToPolicy;
    vm.viewCarta = viewCarta;
    vm.downloadFacturas = downloadFacturas;

    vm.cancel = cancel;
    vm.getLog = getLog;

    /* Functions */
    vm.showSubRamos = showSubRamos;
    vm.textAExpand = textAExpand;

    // Date picker stuff
    vm.dateNow = new Date();
    vm.dateLimit = new Date(
      vm.dateNow.getFullYear(),
      vm.dateNow.getMonth() + 2,
      vm.dateNow.getDate()
    );

    activate();

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    function deleteFile(file, container) {
      fileService.deleteFile(file, container);
      var params = {
        model: 5,
        event: "PATCH",
        associated_id: vm.infoSiniestro.siniestro.id,
        identifier:
          "elimino archivos del siniestro " +
          vm.infoSiniestro.siniestro.numero_siniestro,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
    }

    function goToPolicy(poliza) {
      $state.go("polizas.info", { polizaId: vm.infoSiniestro.poliza.id });
    }

    function viewCarta(poliza, carta) {
      $http({
        method: "GET",
        url: url.IP + "get-carta-siniestros/",
        params: {
          id: vm.infoSiniestro.siniestro.id,
          id_carta: carta,
          hospital: "",
          medico: "",
          medico2: "",
          sa_auth: "",
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          $scope.pdf = response.data;
          var params = {
            model: 5,
            event: "GET",
            associated_id: vm.infoSiniestro.siniestro.id,
            identifier:
              "emitio Carta del siniestro " +
              vm.infoSiniestro.siniestro.numero_siniestro,
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          $http({
            method: "GET",
            url: url.IP + "get-pdf",
            params: {
              pdf_name: $scope.pdf.pdf_name,
            },
            responseType: "arraybuffer",
          }).then(function success(response) {
            var file = new Blob([response.data], { type: "application/pdf" });
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file);
            } else {
              var fileURL = URL.createObjectURL(file);
              $scope.content = $sce.trustAsResourceUrl(fileURL);
              window.open($scope.content);
            }
          });
        }
      });
    }

    function getPDF(siniestro, poliza) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-siniester/",
        params: {
          poliza: poliza,
          siniestro: siniestro,
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          $scope.pdf = response.data;

          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }

          var params = {
            model: 5,
            event: "GET",
            associated_id: vm.infoSiniestro.siniestro.id,
            identifier:
              "emitio PDF del siniestro " +
              vm.infoSiniestro.siniestro.numero_siniestro,
          };
          dataFactory.post("send-log/", params);
          // $http({
          // method: 'GET',
          // url: url.IP + 'get-pdf',
          // params: {
          //     'pdf_name': $scope.pdf.pdf_name
          // }
          // }).then(function success(response) {

          // })
        }
      });
    }

    function crear_complemento(siniestro) {
      // console.log(siniestro)
      $rootScope.siniestro_tmp = siniestro;
      $rootScope.carga_siniestro = true;
      $state.go("siniestros.accidentes");
    }

    function ModalFiniquitoCtrl($uibModalInstance, $scope) {
      $scope.data = {};
      $scope.close = function () {
        $uibModalInstance.dismiss();
      };

      $scope.visualizar = function (data) {
        $uibModalInstance.close(data);
      };
    }

    function getPDFiniquito(siniestro, poliza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/modal.finiquito.html",
        controller: ModalFiniquitoCtrl,
        size: "md",
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (data) {
        $http({
          method: "POST",
          url: url.IP + "get-pdf-finiquito/",
          data: {
            poliza: poliza,
            siniestro: siniestro,
            cheque: data.cheque,
            observaciones: data.observaciones,
          },
        }).then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            var file = new Blob([response.data], { type: "application/pdf" });
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file);
            } else {
              var fileURL = URL.createObjectURL(file);
              $scope.content = $sce.trustAsResourceUrl(fileURL);
              window.open($scope.content);
            }
            $scope.pdf = response.data;
            var params = {
              model: 5,
              event: "POST",
              associated_id: vm.infoSiniestro.siniestro.id,
              identifier:
                "emitio una hoja de Finiquito " +
                vm.infoSiniestro.siniestro.numero_siniestro,
            };
            dataFactory.post("send-log/", params);
            // $http({
            // method: 'GET',
            // url: url.IP + 'get-pdf',
            // params: {
            //     'pdf_name': $scope.pdf.pdf_name
            // }
            // }).then(function success(response) {

            // })
          }
        });
      });
    }

    function updateSiniestroStatus(status) {
      // console.log('vm.status.id',vm.status.id,vm.facturas)
      if (
        vm.facturas.length == 0 &&
        vm.infoSiniestro.accidente.tipo_pago == 2 &&
        vm.status.id == 3
      ) {
        SweetAlert.swal(
          "Facturación",
          "No existen facturas, agréguelas para continuar",
          "warning"
        );
        return;
      }
      // ------
      $scope.factura_proc = false;
      if (!vm.facturas.length == 0) {
        vm.facturas.forEach(function (factura) {
          if (factura.procedente == 0) {
            $scope.factura_proc = true;
          }
        });
      }
      if ($scope.factura_proc == true && vm.status.id == 3) {
        SweetAlert.swal(
          "Facturación",
          "Agregue el procedente correspondiente a la factura",
          "warning"
        );
        return;
      }
      // -------
      if (status.id == 3 && vm.infoSiniestro.siniestro.status == 1) {
        SweetAlert.swal("No puedes completar una póliza desde este estatus");
        vm.status.id = vm.infoSiniestro.siniestro.status;
        return;
      }

      if (status.id == 2 && vm.infoSiniestro.siniestro.status != 2) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_en_tramite_modal.html",
          controller: ModalInstanceCtrlSiniestroEnTramite,
          resolve: {
            factura: function () {
              return url;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
      }
      if (
        (status.id == 4 && vm.infoSiniestro.siniestro.status != 4) ||
        (status.id == 5 && vm.infoSiniestro.siniestro.status != 5)
      ) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_cancel_modal.html",
          controller: ModalInstanceCtrlCancelSiniestro,
          resolve: {
            factura: function () {
              return url;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
      }

      if (
        vm.status.id == 3 &&
        vm.infoSiniestro.siniestro.status != 3 &&
        vm.infoSiniestro.accidente.tipo_pago != 2
      ) {
        // var modalInstance = $uibModal.open({
        //     templateUrl: 'app/siniestros/siniestro_completado_modal.html',
        //     controller: ModalInstanceCtrlSiniestroCompletado,
        //     resolve: {
        //         vm: function () {
        //           return vm;
        //         }
        //       }
        // });
        // return;
        $location.hash("pre_completado");
        $anchorScroll();
        SweetAlert.swal(
          "Advertencia",
          MESSAGES.WARNING.WARNINGSINIESTER,
          "warning"
        );
      }
    }
    function getLog() {
      dataFactory
        .get("get-specific-log", {
          model: 5,
          associated_id: vm.infoSiniestro.siniestro.id,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    }
    function updateSiniestro() {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/siniestro_completado_modal.html",
        controller: ModalInstanceCtrlSiniestroCompletado,
        resolve: {
          vm: function () {
            return vm;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      return;
    }

    function getPdf() {}

    function downloadFacturas(siniestro) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "data:application/vnd.ms-excel;charset=UTF-8",
        }
      );
      saveAs(blob, "Concentrado_Facturas" + ".xls");
    }

    function ModalInstanceCtrlCancelSiniestro(
      $scope,
      $uibModal,
      factura,
      $uibModalInstance
    ) {
      $scope.ok = function () {
        var razon = $scope.cancelRazon;
        if (razon == null) {
          SweetAlert.swal("Dato requerido", "Escriba la razón", "error");
          return;
        }
        $http
          .patch(vm.infoSiniestro.siniestro.url, {
            status: vm.status.id,
            reason: razon,
          })
          .then(function (siniestro) {
            if (siniestro.status === 200 || siniestro.status === 201) {
              $scope.siniestro_info = siniestro.data;
              $scope.idSiniestro = siniestro.data.id;
              if (siniestro.data.status == 4) {
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: vm.infoSiniestro.siniestro.id,
                  identifier:
                    "cancelo el siniestro " +
                    vm.infoSiniestro.siniestro.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
                // if (vm.infoSiniestro.poliza.contractor){
                //     $http.get(vm.infoSiniestro.poliza.contractor)
                //       .then(function(response) {
                //         if(response.data.email){
                //             if($localStorage.email_config){
                //                 if($localStorage.email_config.cancelacion_siniestro == true){
                //                     var model = 12;
                //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                 }
                //             }
                //         }
                //     });
                // }
              }
              if (siniestro.data.status == 5) {
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: vm.infoSiniestro.siniestro.id,
                  identifier:
                    "rechazo el siniestro " +
                    vm.infoSiniestro.siniestro.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
                // if (vm.infoSiniestro.poliza.contractor){
                //     $http.get(vm.infoSiniestro.poliza.contractor)
                //       .then(function(response) {
                //         if(response.data.email){
                //             if($localStorage.email_config){
                //                 if($localStorage.email_config.rechazo_siniestro == true){
                //                     var model = 13;
                //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                 }
                //             }
                //         }
                //     });
                // }
              }
              SweetAlert.swal(
                "¡Listo!",
                MESSAGES.OK.SINIESTERUPDATED,
                "success"
              );
            }
          });
        $uibModalInstance.dismiss("cancel");
        fillTable(vm.ramos.ramo_selected);
        $state.go("siniestros.lista");
      };

      $scope.cancel = function () {
        $rootScope.statusLabel = "Cambiar Estatus";
        $uibModalInstance.dismiss("cancel");
        vm.status.id = vm.infoSiniestro.siniestro.status;
      };
    }

    function ModalInstanceCtrlSiniestroEnTramite(
      $scope,
      $uibModal,
      factura,
      $uibModalInstance
    ) {
      $scope.aux_fecha_promesa = new Date();
      $scope.fc_visible = false;
      $scope.ok = function () {
        $scope.aux_fecha_promesa = $("#date")[0].value;
        $scope.aux_fecha_promesa = new Date($scope.aux_fecha_promesa);
        vm.fecha_promesa = $scope.aux_fecha_promesa;
        vm.siniester_data.companyFolio = $scope.aux_folio;
        if (
          !vm.siniester_data.companyFolio ||
          vm.siniester_data.companyFolio.length == 0 ||
          vm.fecha_promesa == "Invalid Date"
        ) {
          SweetAlert.swal("Dato requerido", "Complete los datos", "error");
          return;
        }
        $uibModalInstance.dismiss("cancel");

        saveEditInformation();
      };

      $scope.cancel = function () {
        $rootScope.statusLabel = "Cambiar Estatus";
        $uibModalInstance.dismiss("cancel");
        vm.status.id = vm.infoSiniestro.siniestro.status;
      };
    }

    $scope.statusSinister = "";
    function activate() {
      $scope.fileSinister = true;

      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 5,
          id_model: vm.siniestro_id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            next: request.data.next,
            previous: request.data.previous,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      $http
        .get(url.IP + "siniester_get_by_id/" + vm.siniestro_id)
        .then(function (siniestro) {
          vm.infoSiniestro = siniestro.data;
          // $scope.a_siniestro = vm.infoSiniestro.accidente.titular.id;
          // $http({
          //   method: 'GET',
          //   url: url.IP + 'count_siniestros_afectado',
          //   params: {
          //     id: vm.infoSiniestro.siniestro.id,
          //     id_a: $scope.a_siniestro
          //   }
          // }).then(function success(response) {
          //   if (response.status == 200) {
          //     $scope.complemento = response.data.total_siniestros.total
          //   }
          // })
          updateStatusList();
          $scope.view_cartas = true;

          $http({
            method: "GET",
            url: url.IP + "cartas-by-model",
            params: {
              model: 5,
            },
          }).then(function success(response) {
            vm.cartas = response.data;
          });

          if (vm.infoSiniestro.siniestro.status == 1) {
            $scope.statusSinister = "Pendiente";
          } else if (vm.infoSiniestro.siniestro.status == 2) {
            $scope.statusSinister = "En trámite";
          } else if (vm.infoSiniestro.siniestro.status == 3) {
            $scope.statusSinister = "Completado";
          } else if (vm.infoSiniestro.siniestro.status == 4) {
            $scope.statusSinister = "Cancelada";
          } else if (vm.infoSiniestro.siniestro.status == 5) {
            $scope.statusSinister = "Rechazada";
          }
          vm.status.id = siniestro.data.siniestro.status;
          vm.siniester_data.observations =
            vm.infoSiniestro.siniestro.observations;
          if (vm.infoSiniestro.accidente.initial == false) {
            vm.isInicial = false;
            $("#isNotInitial").prop("checked", true);
          } else {
            vm.isInicial = true;
            $("#isInitial").prop("checked", true);
          }
          if (siniestro.data.poliza.aseguradora) {
            providerService
              .getProviderById(siniestro.data.poliza.aseguradora)
              .then(function (aseguradora) {
                vm.affect_data.aseguradora = {
                  compania: aseguradora.data.alias,
                  url: aseguradora.data.url,
                };
              });
          } else {
            $http
              .get(
                url.IP + "leer-polizas-edit/" + siniestro.data.poliza.id + "/"
              )
              .then(function (policy) {
                vm.provisionalInfo = policy.data;
                if (vm.provisionalInfo.parent.parent.parent) {
                  vm.affect_data.aseguradora = {
                    compania:
                      vm.provisionalInfo.parent.parent.parent.aseguradora,
                  };
                }
                if (!vm.affect_data.aseguradora) {
                  $http
                    .get(policy.data.parent.parent.parent.aseguradora)
                    .then(function (aseguradora) {
                      vm.affect_data.aseguradora = {
                        compania: aseguradora.data.alias,
                        url: aseguradora.data.url,
                      };
                    });
                }
              });
          }

          vm.siniester_data.complemento =
            siniestro.data.accidente.complemento_siniestro;
          vm.siniester_data.companyFolio =
            siniestro.data.siniestro.folio_compania;
          if (siniestro.data.accidente.titular) {
            if (!siniestro.data.accidente.titular.full_name) {
              if (siniestro.data.accidente.titular.url) {
                var auxurl = siniestro.data.accidente.titular.url;
              } else {
                var auxurl = siniestro.data.accidente.titular;
              }
              $http.get(auxurl).then(function (titular) {
                titular.data.full_name =
                  titular.data.first_name +
                  " " +
                  titular.data.last_name +
                  " " +
                  titular.data.second_last_name;
                vm.selected_affect = titular.data.full_name;
                vm.affect_data.title = titles[1];
                vm.affect_data.birthdate = new Date(titular.data.birthdate);
              });
            } else {
              vm.selected_affect = siniestro.data.accidente.titular.full_name;
              vm.affect_data.title = titles[1];
              vm.affect_data.birthdate = new Date(
                siniestro.data.accidente.titular.birthdate
              );
            }
          } else if (siniestro.data.accidente.dependiente) {
            if (!siniestro.data.accidente.dependiente.full_name) {
              var dependiente = siniestro.data.accidente.dependiente;
              dependiente.full_name =
                dependiente.first_name +
                " " +
                dependiente.last_name +
                " " +
                dependiente.second_last_name;
              vm.selected_affect = dependiente.full_name;
              if (vm.affect) {
                vm.affect.title = titles[siniestro.data.accidente.relationship];
                vm.affect.birthdate = new Date(dependiente.birthdate);
              } else {
                vm["affect"] = {
                  title: titles[siniestro.data.accidente.relationship],
                };
                vm["affect"] = { birthdate: new Date(dependiente.birthdate) };
              }
            } else {
              vm.selected_affect =
                siniestro.data.accidente.dependiente.full_name;
              vm.affect_data.title =
                titles[siniestro.data.accidente.relationship];
              vm.affect_data.birthdate = new Date(
                siniestro.data.accidente.dependiente.birthdate
              );
            }
          } else if (vm.infoSiniestro.poliza) {
            if (
              vm.infoSiniestro.poliza.accidents_policy &&
              vm.infoSiniestro.poliza.document_type != 3
            ) {
              $http
                .get(vm.infoSiniestro.poliza.accidents_policy[0])
                .then(function (dependiente) {
                  if (dependiente.data.relationship_accident.length > 0) {
                    dependiente.data.full_name =
                      dependiente.data.relationship_accident[0].first_name +
                      " " +
                      dependiente.data.relationship_accident[0].last_name +
                      " " +
                      dependiente.data.relationship_accident[0]
                        .second_last_name;
                    vm.selected_affect = dependiente.data.full_name;
                    vm.affect_data.birthdate = new Date(
                      dependiente.data.relationship_accident[0].birthdate
                    );
                  }
                  vm.affect_data.title =
                    titles[siniestro.data.accidente.relationship];
                });
            } else {
              if (vm.infoSiniestro.poliza.document_type != 3) {
                vm.selected_affect =
                  siniestro.data.accidente.dependiente.first_name +
                  " " +
                  siniestro.data.accidente.dependiente.last_name +
                  " " +
                  siniestro.data.accidente.dependiente.second_last_name;
                vm.affect_data.title =
                  titles[siniestro.data.accidente.relationship];
                vm.affect_data.birthdate = new Date(
                  siniestro.data.accidente.dependiente.birthdate
                );
              } else {
                vm.selected_affect = siniestro.data.accidente.aux_affected;
                vm.affect_data.title = titles[1];
                vm.affect_data.birthdate = new Date();
              }
            }
          }
          if (siniestro.data.poliza.document_type == 3) {
            // console.log(siniestro)
            vm.selected_affect = siniestro.data.siniestro.aux_affected;
          }
          // console.log(vm.selected_affect)
          vm.fecha_promesa = siniestro.data.siniestro.promise_date;
          vm.siniester_data.capture_date = siniestro.data.siniestro.created_at;
          if (siniestro.data.poliza.contractor) {
            $http
              .get(siniestro.data.poliza.contractor)
              .then(function (contratante) {
                var name = contratante.data;
                vm.affect_data.contratante = {
                  name:
                    name.first_name +
                    " " +
                    name.last_name +
                    " " +
                    name.second_last_name,
                  url: contratante.data.url,
                };
                vm.affect_data.contractor_addres = {
                  address:
                    contratante.data.address_contractor[0].route +
                    " #" +
                    contratante.data.address_contractor[0].street_number +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_2 +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_1,
                  url: contratante.data.address_contractor[0].url,
                };
              });
          } else {
            $http
              .get(
                url.IP + "leer-polizas-edit/" + siniestro.data.poliza.id + "/"
              )
              .then(function (policy) {
                if (policy.data.parent.parent.contractor) {
                  var name = policy.data.parent.parent.contractor;
                  vm.affect_data.contratante = {
                    name:
                      name.first_name +
                      " " +
                      name.last_name +
                      " " +
                      name.second_last_name,
                    url: name.url,
                  };
                  vm.affect_data.contractor_addres = {
                    address:
                      name.address_contractor[0].route +
                      " #" +
                      name.address_contractor[0].street_number +
                      " " +
                      name.address_contractor[0].administrative_area_level_2 +
                      " " +
                      name.address_contractor[0].administrative_area_level_1,
                    url: name.address_contractor[0].url,
                  };
                } else if (policy.data.parent.parent.parent.contractor) {
                  var name = policy.data.parent.parent.parent.contractor;
                  vm.affect_data.contratante = {
                    name:
                      name.first_name +
                      " " +
                      name.last_name +
                      " " +
                      name.second_last_name,
                    url: name.url,
                  };
                  vm.affect_data.contractor_addres = {
                    address:
                      name.address_contractor[0].route +
                      " #" +
                      name.address_contractor[0].street_number +
                      " " +
                      name.address_contractor[0].administrative_area_level_2 +
                      " " +
                      name.address_contractor[0].administrative_area_level_1,
                    url: name.address_contractor[0].url,
                  };
                }
              });
          }
          vm.affect_data.policy_number = siniestro.data.poliza.poliza_number;
          ramoService
            .getSubramoById(siniestro.data.poliza.subramo)
            .then(function (res) {
              vm.siniester_data.subramo = {
                subramo_name: res.data.subramo_name,
                url: siniestro.data.poliza.subramo,
              };
            });

          switch (parseInt(vm.infoSiniestro.accidente.receiptStatus)) {
            case 1:
              vm.affect_data.policy_status = "Pagado";
              break;
            case 2:
              vm.affect_data.policy_status = "Cancelado";
              break;
            case 3:
              vm.affect_data.policy_status = "Prorrogado";
              break;
            case 4:
              vm.affect_data.policy_status = "Pendiente de pago";
              break;
            default:
              vm.affect_data.policy_status = "Sin Estatus";
          }

          vm.affect_data.policy_vigencia = new Date(
            siniestro.data.poliza.end_of_validity
          );
          vm.affect_data.policy_vigencia_init = new Date(
            siniestro.data.poliza.start_of_validity
          );
          if (siniestro.data.poliza.paquete) {
            packageService
              .getOnlyPackageById(siniestro.data.poliza.paquete)
              .then(function (paquete) {
                vm.affect_data.paquete = {
                  package_name: paquete.data.package_name,
                  url: paquete.data.url,
                };
              });
          }

          if (siniestro.data.accidente.initial == true) {
            $("#btn-inicial").addClass("btn-iniComp");
            $("#btn-complemento").removeClass("btn-iniComp");
          } else {
            $("#btn-inicial").removeClass("btn-iniComp");
            $("#btn-complemento").addClass("btn-iniComp");
          }

          var type_accident = siniestro.data.accidente.razon_siniestro;
          switch (type_accident) {
            case 1:
              $('#siniestroType option[value="1"]').attr(
                "selected",
                "selected"
              );
              break;
            case 2:
              $('#siniestroType option[value="2"]').attr(
                "selected",
                "selected"
              );
              break;
            case 3:
              $('#siniestroType option[value="3"]').attr(
                "selected",
                "selected"
              );
              break;
            default:
              break;
          }
          var payway_accident = siniestro.data.accidente.tipo_pago;
          switch (payway_accident) {
            case 1:
              $('#payWay option[value="1"]').attr("selected", "selected");
              break;
            case 2:
              $('#payWay option[value="2"]').attr("selected", "selected");
              break;
            case 3:
              $('#payWay option[value="3"]').attr("selected", "selected");
              break;
            case 4:
              $('#payWay option[value="4"]').attr("selected", "selected");
              break;
            default:
              break;
          }

          vm.affect_data.siniester_date = new Date(
            siniestro.data.siniestro.fecha_siniestro
          );
          vm.siniester_data.siniester_number =
            siniestro.data.siniestro.numero_siniestro;

          siniestro.data.facturas.forEach(function (factura) {
            var obj = {
              f_number: factura.numero_factura,
              proovedor: factura.proveedor,
              f_date: factura.fecha_factura,
              import: parseFloat(factura.importe),
              iva: factura.iva,
              total: factura.total,
              procedente: parseFloat(factura.procedente),
              url: factura.url,
              serie: factura.serie,
              observaciones: factura.observaciones,
              concepto: factura.concepto,
            };
            vm.facturas.push(obj);
          });
          fileService
            .getFiles(url.IP + "siniestros/" + vm.siniestro_id + "/archivos/")
            .then(function (files) {
              files.forEach(function (file) {
                vm.files.push(file);
              });
            });
        });
    }
    function cancel() {
      $state.go("siniestros.lista");
    }

    function updateStatusList() {
      var estado = vm.infoSiniestro.siniestro.status;
      switch (estado) {
        case 1:
          (vm.status = { id: 0, label: "Estatus" }),
            (vm.statuses = [
              { id: 2, label: "En trámite" },
              { id: 4, label: "Cancelada" },
              { id: 5, label: "Rechazada" },
              { id: 6, label: "En espera" },
            ]);
          break;
        case 2:
          (vm.status = { id: 0, label: "Estatus" }),
            (vm.statuses = [
              { id: 3, label: "Completado" },
              { id: 4, label: "Cancelada" },
              { id: 5, label: "Rechazada" },
              { id: 6, label: "En espera" },
            ]);
          break;
        case 3:
          (vm.status = { id: 0, label: "Estatus" }), (vm.statuses = []);
          break;
        case 4:
          vm.statuses = [];
          break;
        case 5:
          vm.statuses = [];
          break;
      }
    }

    function viewObservation(url, SiniesterStatus) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/facturas.observation.html",
        controller: ModalInstanceCtrlObservationsfact,
        resolve: {
          obj: function () {
            return { url: url, SiniesterStatus: SiniesterStatus };
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function ModalInstanceCtrlObservationsfact(
      $scope,
      $uibModal,
      obj,
      $uibModalInstance
    ) {
      $scope.SiniesterStatus = obj.SiniesterStatus;
      $http.get(obj.url).then(function (data) {
        $scope.observation_aux = data.data.observaciones;
      });

      $scope.ok = function () {
        var observ = {
          observaciones: $scope.observation_aux,
        };
        $http.patch(obj.url, observ).then(function (data) {
          if (data.status === 200 || data.status === 201) {
            $uibModalInstance.dismiss("cancel");
            var params = {
              model: 5,
              event: "PATCH",
              associated_id: vm.infoSiniestro.siniestro.id,
              identifier:
                "actualizo el siniestro" +
                vm.infoSiniestro.siniestro.numero_siniestro +
                " agrego observaciones",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          }
        });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    function ramo_changed() {
      fillTable(vm.ramos.ramo_selected);
    }

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      if (item.padecimiento_type == undefined) {
        item.padecimiento_type = "";
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].type_document = item.padecimiento_type;
    };

    function uploadFiles(siniestro_id, doc_type) {
      $scope.userInfo = {
        id: siniestro_id,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "siniestros/" + siniestro_id + "/archivos/";
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve($scope.uploader.uploadAll());
          return defer.promise;
        })
        .then(function () {
          toaster.success("Se han subido sus archivos correctamente");
          setTimeout(function () {
            fileService
              .getFiles(url.IP + "siniestros/" + vm.siniestro_id + "/archivos/")
              .then(function (res) {
                res.forEach(function (file) {
                  vm.files.push(file);
                });
              });
          }, 100);
        });
    }

    function addFactura() {
      var factura = {
        f_number: "",
        proovedor: "",
        f_date: "",
        import: "",
        iva: "",
        total: "",
        procedente: 0,
      };
      vm.facturas.push(factura);
    }

    $scope.calculateIva = function (index, item) {
      vm.facturas[index].import = parseFloat(item);
      vm.facturas[index].iva = parseFloat(
        (vm.facturas[index].import * 0.16).toFixed(2)
      );
      vm.facturas[index].total =
        vm.facturas[index].import + vm.facturas[index].iva;
      vm.facturas[index].total = vm.facturas[index].total.toFixed(2);
      if (item == "") {
        vm.facturas[index].import = 0;
        vm.facturas[index].iva = 0;
        vm.facturas[index].total = 0;
      }
    };

    $scope.calculateTotal = function (index, iva) {
      if (iva) {
        vm.facturas[index].iva = parseFloat(iva);
      } else if (iva == "") {
        vm.facturas[index].iva = 0;
      }
      if (vm.facturas[index].import) {
        vm.facturas[index].import = parseFloat(vm.facturas[index].import);
      }
      vm.facturas[index].total =
        vm.facturas[index].import + vm.facturas[index].iva;
      vm.facturas[index].total = vm.facturas[index].total.toFixed(2);
    };

    function Exist(list, obj) {
      for (var i = 0; i < list.length; i++) {
        if (obj.value == list[i].value) {
          return true;
        }
      }
      return false;
    }

    function changeSinesterNumber() {
      try {
        $http
          .get(vm.siniester_data.siniester_number.value.accidente.padecimiento)
          .then(function (enfermedad) {
            var obj = {
              label: enfermedad.data.code + " - " + enfermedad.data.descr,
              value: {
                code: enfermedad.data.code,
                url: enfermedad.data.url,
              },
            };
            vm.selected_disease = obj;
            var type_accident =
              vm.siniester_data.siniester_number.value.accidente
                .razon_siniestro;
            switch (type_accident) {
              case 1:
                $('#siniestroType option[value="1"]').attr(
                  "selected",
                  "selected"
                );
                break;
              case 2:
                $('#siniestroType option[value="2"]').attr(
                  "selected",
                  "selected"
                );
                break;
              case 3:
                $('#siniestroType option[value="3"]').attr(
                  "selected",
                  "selected"
                );
                break;
              default:
                break;
            }
          });
      } catch (err) {}
    }

    function ModalInstanceCtrlSiniestroCompletado(
      $scope,
      $uibModal,
      status,
      $uibModalInstance,
      vm
    ) {
      var suma_final_procedente = 0.0;
      var suma_final_reclamado = 0.0;
      vm.facturas.forEach(function (factura) {
        // if (!factura.procedente) {
        //     SweetAlert.swal("Procedente","Agregue un procedente válido","error");
        //     return;
        // }
        suma_final_procedente += parseFloat(factura.procedente);
        suma_final_reclamado += parseFloat(factura.total);
      });
      $scope.final_procedente = suma_final_procedente;
      $scope.final_reclamado = suma_final_reclamado;
      if (vm.infoSiniestro.accidente.titular) {
        $scope.a_siniestro = vm.infoSiniestro.accidente.titular.id;
      } else if (vm.infoSiniestro.accidente.dependiente) {
        $scope.a_siniestro = vm.infoSiniestro.accidente.dependiente.id;
      } else {
        $scope.a_siniestro = "";
      }
      if ($scope.a_siniestro != "") {
        $http({
          method: "GET",
          url: url.IP + "count_siniestros_afectado",
          params: {
            id: vm.infoSiniestro.siniestro.id,
            id_a: $scope.a_siniestro,
          },
        }).then(function success(response) {
          if (response.status == 200) {
            $scope.complemento =
              parseInt(response.data.total_siniestros.total) + 1;
            $scope.final_complemento =
              parseInt(response.data.total_siniestros.total) + 1;
          }
        });
      }
      $scope.ok = function () {
        var deducible = $scope.final_deducible;
        var coaseguro = $scope.final_coaseguro;
        var complemento = $scope.final_complemento;

        if (vm.infoSiniestro.accidente.tipo_pago == 2) {
          if (
            !$scope.monto_hospital ||
            !$scope.ded_hospital ||
            !$scope.coas_hospital
          ) {
            // SweetAlert.swal("Datos requeridos","Complete los datos","error");
            // return;
          }
          var obj_final = {
            procedente: $scope.final_procedente
              ? parseFloat($scope.final_procedente).toFixed(2)
              : 0,
            reclamado: $scope.final_reclamado ? $scope.final_reclamado : 0,
            deducible: $scope.deducible ? $scope.deducible : 0,
            coaseguro: $scope.coaseguro ? $scope.coaseguro : 0,
            complemento: $scope.complemento ? $scope.complemento : 0,
            monto_hospital: $scope.monto_hospital ? $scope.monto_hospital : 0,
            ded_hospital: $scope.ded_hospital ? $scope.ded_hospital : 0,
            coas_hospital: $scope.coas_hospital ? $scope.coas_hospital : 0,
            monto_honorarios: $scope.monto_honorarios
              ? $scope.monto_honorarios
              : 0,
            ded_honorarios: $scope.ded_honorarios ? $scope.ded_honorarios : 0,
            coas_honorarios: $scope.coas_honorarios
              ? $scope.coas_honorarios
              : 0,
            cirujano: $scope.cirujano ? $scope.cirujano : 0,
            anestesiologo: $scope.anestesiologo ? $scope.anestesiologo : 0,
            ayudante: $scope.ayudante ? $scope.ayudante : 0,
            otros: $scope.otros ? $scope.otros : 0,
            hospital: $scope.hospital ? $scope.hospital : "",
            fecha_cirugia: $scope.fecha_cirugia
              ? new Date(datesFactory.toDate($scope.fecha_cirugia))
              : null,
          };
        } else {
          if (
            !$scope.final_deducible ||
            !$scope.final_coaseguro ||
            !$scope.final_complemento
          ) {
            SweetAlert.swal("Datos requeridos", "Complete los datos", "error");
            return;
          }
          var obj_final = {
            procedente: $scope.final_procedente
              ? parseFloat($scope.final_procedente).toFixed(2)
              : 0,
            reclamado: $scope.final_reclamado
              ? parseFloat($scope.final_reclamado).toFixed(2)
              : 0,
            deducible: $scope.final_deducible ? $scope.final_deducible : 0,
            coaseguro: $scope.final_coaseguro ? $scope.final_coaseguro : 0,
            complemento: $scope.final_complemento
              ? $scope.final_complemento
              : 0,
          };
        }
        patchSiniester(obj_final);
        $uibModalInstance.dismiss("cancel");
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
        return;
      };
    }

    function saveEditInformation() {
      if (
        vm.status.id == 3 &&
        vm.infoSiniestro.siniestro.status != 3 &&
        vm.infoSiniestro.accidente.tipo_pago != 2
      ) {
        var modalInstance = $uibModal.open({
          templateUrl: "app/siniestros/siniestro_completado_modal.html",
          controller: ModalInstanceCtrlSiniestroCompletado,
          resolve: {
            vm: function () {
              return vm;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        return;
      } else if (
        vm.status.id == 3 &&
        vm.infoSiniestro.siniestro.status != 3 &&
        vm.infoSiniestro.accidente.tipo_pago == 2
      ) {
        var modalInstance = $uibModal.open({
          templateUrl: "app/siniestros/siniestro_completado_modal_prog.html",
          controller: ModalInstanceCtrlSiniestroCompletado,
          resolve: {
            vm: function () {
              return vm;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        return;
      }

      patchSiniester();
    }

    function updateReclamado() {
      $scope.total_reclamado = 0;
      vm.infoSiniestro.facturas.forEach(function (factura) {
        $scope.total_reclamado =
          parseFloat($scope.total_reclamado) + parseFloat(factura.total);
      });

      $http.patch(vm.infoSiniestro.accidente.url, {
        total_reclamado: $scope.total_reclamado,
      });
    }

    function patchSiniester(obj) {
      updateReclamado();
      var obj_siniestro = {
        folio_compania: vm.siniester_data.companyFolio,
        status: vm.status.id,
        promise_date: vm.fecha_promesa,
        fecha_siniestro: new Date(vm.affect_data.siniester_date),
        tipo_siniestro_general:
          vm.infoSiniestro.siniestro.tipo_siniestro_general,
        observations: vm.siniester_data.observations,
        numero_siniestro: vm.siniester_data.siniester_number,
      };
      $http
        .patch(vm.infoSiniestro.siniestro.url, obj_siniestro)
        .then(function (siniestro) {
          if (siniestro.status === 200 || siniestro.status === 201) {
            if (siniestro.data.status == 3) {
              var params = {
                model: 5,
                event: "PATCH",
                associated_id: vm.infoSiniestro.siniestro.id,
                identifier: "actualizo un siniestro estatus Completado ",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              $scope.idSiniestro = siniestro.data.id;
              // if (vm.infoSiniestro.poliza.contractor){
              //     $http.get(vm.infoSiniestro.poliza.contractor)
              //       .then(function(response) {
              //         if(response.data.email){
              //             if($localStorage.email_config){
              //                 if($localStorage.email_config.fin_siniestro == true){
              //                     var model = 4;
              //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
              //                 }
              //             }
              //         }
              //     });
              // }
            }
            if (siniestro.data.status == 2) {
              $scope.idSiniestro = siniestro.data.id;
              var params = {
                model: 5,
                event: "PATCH",
                associated_id: $scope.idSiniestro,
                identifier: "actualizo un siniestro estatus En Trámite",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              // if (vm.infoSiniestro.poliza.contractor){
              //     $http.get(vm.infoSiniestro.poliza.contractor)
              //       .then(function(response) {
              //         if(response.data.email){
              //             if($localStorage.email_config){
              //                 if($localStorage.email_config.tramite_siniestro == true){
              //                     var model = 11;
              //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
              //                 }
              //             }
              //         }
              //     });
              // }
            }
            if (siniestro.data.status == 6) {
              $scope.idSiniestro = siniestro.data.id;
              var params = {
                model: 5,
                event: "PATCH",
                associated_id: $scope.idSiniestro,
                identifier: "actualizo un siniestro estatus En espera",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              // if (vm.infoSiniestro.poliza.contractor){
              //     $http.get(vm.infoSiniestro.poliza.contractor)
              //       .then(function(response) {
              //         if(response.data.email){
              //             if($localStorage.email_config){
              //                 if($localStorage.email_config.espera_siniestro == true){
              //                     var model = 14;
              //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
              //                 }
              //             }
              //         }
              //     });
              // }
            }
          }

          // Facturas
          vm.facturas.forEach(function (factura, index) {
            if (!factura.import) {
              factura.import = 0.0;
            }
            if (!factura.iva) {
              factura.iva = 0.0;
            }
            if (!factura.total) {
              factura.total = 0.0;
            }
            if (vm.status.id == 3) {
              var obj_factura = {
                siniestro: siniestro.data.url,
                numero_factura: factura.f_number,
                proveedor: factura.proovedor,
                fecha_factura: new Date(factura.f_date),
                importe: factura.import.toFixed(2),
                iva: factura.iva.toFixed(2),
                total: factura.total,
                concepto: factura.concepto,
                procedente: factura.procedente
                  ? parseFloat(factura.procedente).toFixed(2)
                  : 0,
              };
            } else {
              var obj_factura = {
                siniestro: siniestro.data.url,
                numero_factura: factura.f_number,
                proveedor: factura.proovedor,
                fecha_factura: new Date(factura.f_date),
                importe: factura.import.toFixed(2),
                iva: factura.iva.toFixed(2),
                total: factura.total,
                concepto: factura.concepto,
              };
            }

            if (factura.url) {
              $http.patch(factura.url, obj_factura).then(function (facturax) {
                if (facturax.status === 200 || facturax.status === 201) {
                  if (facturax) {
                    var params = {
                      model: 5,
                      event: "PATCH",
                      associated_id: siniestro.data.id,
                      identifier: "actualizo facturas  del siniestro",
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                  }
                }
              });
            } else {
              $http
                .post(url.IP + "facturas/", obj_factura)
                .then(function (facturax) {
                  if (facturax.status === 200 || facturax.status === 201) {
                    if (facturax) {
                      var params = {
                        model: 5,
                        event: "POST",
                        associated_id: siniestro.data.id,
                        identifier: "creo facturas al Siniestro ",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                    }
                  }
                });
            }
          });

          uploadFiles(siniestro.data.id, $scope.padecimiento_type);

          var pago;
          switch ($('input[name="payWay"]:checked').val()) {
            case "reembolso":
              pago = 1;
              break;
            case "programacion":
              pago = 2;
              break;
            case "pagoDirecto":
              pago = 3;
              break;
            default:
              break;
          }
          var razon;
          var pago_;
          razon = $("#siniestroType option:selected").val();
          pago_ = $("#payWay option:selected").val();
          if (obj) {
            var total_final_pre =
              obj.procedente - obj.coaseguro - obj.deducible;
            var obj_accidente = {
              tipo_pago: pago,
              total_reclamado: obj.reclamado
                ? parseFloat(obj.reclamado).toFixed(2)
                : 0,
              total_procedente: obj.procedente
                ? parseFloat(obj.procedente).toFixed(2)
                : 0,
              total_coaseguro: obj.coaseguro,
              total_deducible: obj.deducible,
              total_final: parseFloat(total_final_pre).toFixed(2),
              complemento_siniestro: obj.complemento,
              monto_hospital: obj.monto_hospital ? obj.monto_hospital : 0,
              ded_hospital: obj.ded_hospital ? obj.ded_hospital : 0,
              coas_hospital: obj.coas_hospital ? obj.coas_hospital : 0,
              monto_honorarios: obj.monto_honorarios ? obj.monto_honorarios : 0,
              ded_honorarios: obj.ded_honorarios ? obj.ded_honorarios : 0,
              coas_honorarios: obj.coas_honorarios ? obj.coas_honorarios : 0,
              cirujano: obj.cirujano ? obj.cirujano : 0,
              anestesiologo: obj.anestesiologo ? obj.anestesiologo : 0,
              ayudante: obj.ayudante ? obj.ayudante : 0,
              otros: obj.otros ? obj.otros : 0,
              hospital: obj.hospital ? obj.hospital : "",
              fecha_cirugia: obj.fecha_cirugia ? obj.fecha_cirugia : null,
            };
          } else {
            var obj_accidente = {
              tipo_pago: pago_,
              razon_siniestro: razon,
            };
          }

          $http
            .patch(vm.infoSiniestro.accidente.url, obj_accidente)
            .then(function (accidente) {
              if (accidente.status == 200 || accidente.status == 201) {
                fillTable(2);
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.SINIESTERUPDATED,
                  "success"
                );
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: $scope.idSiniestro,
                  identifier:
                    "actualizo el siniestro " +
                    vm.infoSiniestro.siniestro.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $state.go("siniestros.lista");
              } else {
                SweetAlert.swal("Error", "Ha ocurrido un error", "error");
              }
            });
        });
    }

    function LookFor() {
      helpers.getDiseases().then(function (data) {
        var enfermedades_aux = data.data.results;
        enfermedades_aux.forEach(function (enfermedad) {
          var obj = {
            label: enfermedad.code + " - " + enfermedad.descr,
            value: {
              code: enfermedad.code,
              url: enfermedad.url,
            },
          };
          vm.enfermedades.push(obj);
        });
      });

      $http
        .get(url.IP + "polizas/" + vm.selected_affect.value.id + "/")
        .then(function (poliza) {
          vm.selectedPoliza = poliza;
          $http.get(poliza.data.subramo).then(function (subramo) {
            vm.siniester_data.subramo = subramo.data;
          });

          var data = {
            title: vm.selected_affect.value.title,
            policy_vigencia: new Date(poliza.data.end_of_validity),
            policy_vigencia_init: new Date(poliza.data.start_of_validity),
            siniester_date: new Date(),
            policy_number: poliza.data.poliza_number,
          };

          if (vm.selected_affect.value.tittle_id == 1) {
            poliza.data.accidents_policy.forEach(function (titular) {
              $http.get(titular.personal).then(function (principal) {
                data["birthdate"] = principal.data.birthdate;
              });
            });
          } else {
            poliza.data.accidents_policy.forEach(function (titular) {
              titular.relationship_accident.forEach(function (dependiente) {
                if (dependiente.first_name == vm.selected_affect.value.name) {
                  data["birthdate"] = dependiente.birthdate;
                }
              });
            });
          }

          var waitReceipt = [];
          waitReceipt.push(
            $http.get(url.IP + "get-current-receipt/" + poliza.data.id)
          );
          $q.all(waitReceipt).then(function (response) {
            var status = response[0].data.status;
            switch (status) {
              case 1:
                data["policy_status"] = "Pagado";
                break;
              case 2:
                data["policy_status"] = "Cancelado";
                break;
              case 3:
                data["policy_status"] = "Prorrogado";
                break;
              case 4:
                data["policy_status"] = "Pendiente de pago";
                break;
              default:
                data["policy_status"] = "Sin Estatus";
            }
          });
          if (poliza.data.contractor) {
            $http.get(poliza.data.contractor).then(function (contratante) {
              data["contractor_addres"] =
                contratante.data.address_contractor[0];
              data["contratante"] = contratante.data;
              data["contratante"].name = contratante.data.full_name;
            });
          }

          $http.get(poliza.data.aseguradora).then(function (aseguradora) {
            data["aseguradora"] = aseguradora.data;
          });

          $http.get(poliza.data.paquete).then(function (paquete) {
            data["paquete"] = paquete.data;
          });

          vm.affect_data = data;
        });
    }

    function fillTable(ramo_number) {
      vm.siniestros = [];
      $http
        .get(url.IP + "siniestros-definidos/" + ramo_number)
        .then(function (siniestros) {
          if (siniestros.status == 200 || siniestros.status == 201) {
            if (siniestros.data) {
              siniestros.data.forEach(function (siniestro) {
                vm.siniestros.push(siniestro);
              });
            }
          }
        });
    }

    function deleteFactura(url, index) {
      if ((url && index) || (url && !index)) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "El registro se borrara permanentemente aunque no se hayan guardado los cambios.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, eliminar",
            cancelButtonText: "No, cancelar",
            closeOnConfirm: false,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              try {
                $http.delete(url).then(function (response) {
                  if (response.status === 204) {
                    vm.facturas.splice(index, 1);
                    var params = {
                      model: 5,
                      event: "DELETE",
                      associated_id: vm.siniester_data.id,
                      identifier:
                        "elimino facturas del sinietsro" +
                        vm.siniester_data.numero_siniestro,
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                  }
                });
              } catch (err) {
                throw err;
              }
              SweetAlert.swal(
                "¡Eliminada!",
                "Tu factura ha sido eliminada.",
                "success"
              );
            } else {
              SweetAlert.swal("Cancelado", "", "error");
            }
          }
        );
      } else {
        vm.facturas.splice(index, 1);
      }
    }

    function deleteSiniestro(parUrl) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "¡Al eliminar tu siniestro no podra recuperarse nuevamente!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "No, cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            if (!parUrl) {
              var data_email = {
                id: $stateParams.siniestroId,
                model: 5,
                type_person: 0,
              };
              dataFactory
                .post("send-email-admins-deletes/", data_email)
                .then(function success(req) {
                  console.log(".................:::::.....", req);
                });
              $http
                .delete(url.IP + "siniestros/" + $stateParams.siniestroId)
                .then(function (response) {
                  if (response.status === 204) {
                    SweetAlert.swal(
                      "Eliminado",
                      "Siniestro eliminado exitosamente",
                      "success"
                    );
                    var params = {
                      model: 5,
                      event: "DELETE",
                      associated_id: $stateParams.siniestroId,
                      identifier:
                        "elimino el sinietsro" +
                        vm.siniester_data.numero_siniestro,
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                    $state.go("siniestros.lista");
                  }
                });
            } else {
              var data_email = {
                id: $stateParams.siniestroId,
                model: 5,
                type_person: 0,
              };
              dataFactory
                .post("send-email-admins-deletes/", data_email)
                .then(function success(req) {
                  console.log(".................:::::.....", req);
                });
              $http.delete(parUrl).then(function (response) {
                if (response.status === 204) {
                  SweetAlert.swal(
                    "Eliminado",
                    "Siniestro eliminado exitosamente",
                    "success"
                  );
                  var params = {
                    model: 5,
                    event: "DELETE",
                    associated_id: $stateParams.siniestroId,
                    identifier:
                      "elimino el sinietsro" +
                      vm.siniester_data.numero_siniestro,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  $state.go("siniestros.lista");
                }
              });
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "Tu registro esta a salvo :)",
              "error"
            );
          }
        }
      );
    }

    function checkSubRamo(event) {}

    function showSubRamos(event) {
      vm.ramoId = event.target.id;
    }

    function textAExpand(event) {
      var element = e.target;
      var scroll = element.scrollHeight - 60;
      element.style.height = scrollHeight + "px";
    }

    function updateStatus() {
      insuranceService.getInsurances().then(function (polizas) {
        polizas.forEach(function (poliza) {
          poliza.accidents_policy.forEach(function (titular) {
            $http.get(titular.personal).then(function (name) {
              var obj = {
                label:
                  name.data.first_name +
                  " " +
                  name.data.last_name +
                  " " +
                  name.data.second_last_name +
                  "   -   " +
                  "poliza: " +
                  poliza.poliza_number,
                value: {
                  id: poliza.id,
                  title: titles[1],
                  tittle_id: 1,
                  name: name.data.first_name,
                  url: titular.personal,
                },
              };
              vm.affected.push(obj);
            });

            titular.relationship_accident.forEach(function (dependiente) {
              var obj = {
                label:
                  dependiente.first_name +
                  " " +
                  dependiente.last_name +
                  " " +
                  dependiente.second_last_name +
                  "   -   " +
                  "poliza: " +
                  poliza.poliza_number,
                value: {
                  id: poliza.id,
                  title: titles[dependiente.relationship],
                  tittle_id: dependiente.relationship,
                  name: dependiente.first_name,
                  url: dependiente.url,
                },
              };
              vm.affected.push(obj);
            });
          });
        });
      });
    }

    $rootScope.statusLabel = "Cambiar Estatus";
    $scope.changeLabel = function (status) {
      $rootScope.statusLabel = status.label;
      vm.status.id = status.id;
      vm.status.label = status.label;
      vm.updateSiniestroStatus(vm.status);
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("siniestrosVidaInfoCtrl", siniestrosVidaInfoCtrl);

  siniestrosVidaInfoCtrl.$inject = [
    "$sce",
    "providerService",
    "packageService",
    "fileService",
    "$stateParams",
    "$rootScope",
    "$state",
    "SweetAlert",
    "$q",
    "toaster",
    "$localStorage",
    "FileUploader",
    "insuranceService",
    "$scope",
    "$uibModal",
    "ramoService",
    "$http",
    "url",
    "helpers",
    "$sessionStorage",
    "MESSAGES",
    "dataFactory",
    "emailService",
    "appStates",
    "whatsappWebFlagService",
    "siniestroWhatsappService",
  ];

  function siniestrosVidaInfoCtrl(
    $sce,
    providerService,
    packageService,
    fileService,
    $stateParams,
    $rootScope,
    $state,
    SweetAlert,
    $q,
    toaster,
    $localStorage,
    FileUploader,
    insuranceService,
    $scope,
    $uibModal,
    ramoService,
    $http,
    url,
    helpers,
    $sessionStorage,
    MESSAGES,
    dataFactory,
    emailService,
    appStates,
    whatsappWebFlagService,
    siniestroWhatsappService
  ) {
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var token = JSON.parse(decryptedToken);

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.user = usr;
    // ////console.log('info cotrl',vm)
    vm.siniestro_id = $stateParams.siniestroId;
    // ////console.log(vm.siniestro_id);
    vm.selectedRamo = null;
    vm.selectedSubRamo = null;
    vm.selectedPoliza;
    vm.sub_ramos = [
      { id: 2, label: "Accidentes personales" },
      { id: 3, label: "Gastos médicos" },
      { id: 4, label: "Salud" },
    ];
    vm.status = { id: 1, label: "Pendiente" };
    vm.statuses = [
      { id: 1, label: "Pendiente" },
      { id: 2, label: "En trámite" },
      { id: 3, label: "Completado" },
      { id: 4, label: "Cancelada" },
      { id: 5, label: "Rechazada" },
    ];
    vm.insurances_number = [];
    vm.isInicial = true;
    vm.selectedContractor;
    $scope.subramo_select;
    vm.element = "";
    vm.ramos = [];
    vm.affected = [];
    vm.affect_list = [];
    vm.ramoId = -1;
    vm.insurances;
    vm.selected_affect = [];
    vm.selectInsurance;
    vm.affect_data = {};
    vm.selected_disease = [];
    vm.siniestros = [];
    vm.siniester_data = {};
    vm.siniester_data.siniestros_by_number = [];
    vm.siniester_data.selected_number_siniester;
    vm.sendEmail = sendEmail;
    vm.sendWhatsAppWeb = openWhatsapp;
    vm.whatsappWebEnabled = whatsappWebFlagService.isEnabled();
    whatsappWebFlagService.subscribe(function (enabled) {
      vm.whatsappWebEnabled = enabled;
    });
    vm.enfermedades = [];
    // vm.LookFor =LookFor;
    vm.selectedPoliza;
    vm.ramos = {};
    vm.facturas = [];
    vm.ramos.ramo_selected = 1;
    $scope.observation_aux = "";
    $scope.final_procedente = 0.0;
    $scope.final_reclamado = 0.0;
    vm.total = {};
    $scope.isr = [];
    $scope.procedente = [];
    vm.ramos.options = [
      { id: 2, label: "Accidentes y Enfermedades" },
      { id: 3, label: "Daños" },
      { id: 1, label: "Vida" },
    ];

    vm.siniestros_type = [
      { id: 0, label: "Seleccione una opción" },
      { id: 1, label: "Natural" },
      { id: 2, label: "Accidental" },
      { id: 3, label: "Pérdidas orgánicas" },
      { id: 4, label: "Invalidez" },
      { id: 5, label: "Funerarios" },
    ];

    vm.siniestros_pay_form = [
      { id: 0, label: "Seleccione una opción" },
      { id: 1, label: "Cheque" },
      { id: 2, label: "Transferencia" },
    ];

    vm.relationship = [
      { id: 1, label: "Titular" },
      { id: 2, label: "Cónyuge" },
      { id: 3, label: "Hijo" },
      { id: 4, label: "Otro" },
    ];

    vm.contacts = [];
    vm.afectados = [];
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;
    $scope.newAfectado = false;
    function addContact() {
      var contact = {
        first_name: "",
        phone: "",
        email: "",
        references: "",
      }; //jshint ignore:line
      vm.contacts.push(contact);
    }

    function deleteContacts(url, index) {
      vm.contacts.splice(index, 1);
    }

    var date = new Date();

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    $scope.recordatoriosFlag = false;

    $scope.showRecordatorios = function () {
      $scope.recordatoriosFlag = !$scope.recordatoriosFlag;
    };

    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };
    $scope.createRecordatorio = function (registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return $scope.endorsement;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    vm.files = [];
    vm.form = {};
    var titles = {
      1: "Titular",
      2: "Cónyuge",
      3: "Hijo",
    };
    // vm.facturas = [{ f_number: '', proovedor: '', f_date: '', import: '', iva:'', total:'',procedente:'' }]

    $scope.colors = [
      { name: "black", shade: "dark" },
      { name: "white", shade: "light", notAnOption: true },
      { name: "red", shade: "dark" },
      { name: "blue", shade: "dark", notAnOption: true },
      { name: "yellow", shade: "light", notAnOption: false },
    ];
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };
    $scope.myColor = $scope.colors[2];
    //Modals
    vm.updateStatus = updateStatus;
    vm.uploadFiles = uploadFiles;
    vm.goToPolicy = goToPolicy;

    vm.ramo_changed = ramo_changed;
    vm.deleteSiniestro = deleteSiniestro;
    $scope.deleteFile = deleteFile;
    vm.saveEditInformation = saveEditInformation;
    vm.updateSiniestroStatus = updateSiniestroStatus;
    $scope.aux_folio;
    $scope.aux_fecha_promesa;
    $scope.final_deducible;
    $scope.final_coaseguro;
    $scope.final_complemento;
    $scope.cancelRazon;

    vm.cancel = cancel;
    vm.getPDF = getPDF;
    vm.viewCarta = viewCarta;

    //functions
    vm.showSubRamos = showSubRamos;
    vm.textAExpand = textAExpand;
    vm.crear_complemento = crear_complemento;

    // Date picker stuff
    vm.dateNow = new Date();
    vm.dateLimit = new Date(
      vm.dateNow.getFullYear(),
      vm.dateNow.getMonth() + 2,
      vm.dateNow.getDate()
    );

    activate();

    function crear_complemento(siniestro) {
      // console.log(siniestro)
      siniestro["poliza"] = vm.selectedPoliza.data;
      $rootScope.siniestro_tmp = siniestro;
      $rootScope.carga_siniestro = true;
      $state.go("siniestros.vida");
    }

    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    function deleteFile(file, container) {
      fileService.deleteFile(file, container);
      var params = {
        model: 5,
        event: "DELETE",
        associated_id: vm.infoSiniestro.id,
        identifier:
          "elimino archivos del siniestro" + vm.infoSiniestro.numero_siniestro,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
    }

    function goToPolicy(name, route, poliza) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, {
        polizaId: vm.selectedPoliza.data.id,
      });
    }

    function viewCarta(poliza, carta) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-form/",
        params: {
          id: vm.infoSiniestro.id,
          id_poliza: vm.selectedPoliza.data.id,
          id_carta: carta,
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
          $scope.pdf = response.data;
          var params = {
            model: 5,
            event: "GET",
            associated_id: vm.infoSiniestro.id,
            identifier:
              "creo la Carta del siniestro" + vm.infoSiniestro.numero_siniestro,
          };
          dataFactory.post("send-log/", params);
          // $http({
          //   method: 'GET',
          //   url: url.IP + 'get-pdf',
          //   params: {
          //     'pdf_name': $scope.pdf.pdf_name
          //   },
          //   responseType: 'arraybuffer'

          // }).then(function success(response) {

          //   })
        }
      });
    }
    vm.getLog = getLog;
    function getLog() {
      dataFactory
        .get("get-specific-log", {
          model: 5,
          associated_id: vm.infoSiniestro.id,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    }
    function getPDF(siniestro, poliza) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-siniester/",
        params: {
          poliza: poliza,
          siniestro: siniestro,
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
          $scope.pdf = response.data;
          var params = {
            model: 5,
            event: "GET",
            associated_id: vm.infoSiniestro.id,
            identifier:
              "creo un PDF del siniestro " + vm.infoSiniestro.numero_siniestro,
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          // $http({
          // method: 'GET',
          // url: url.IP + 'get-pdf',
          // params: {
          //     'pdf_name': $scope.pdf.pdf_name
          // }
          // }).then(function success(response) {

          // })
        }
      });
    }

    function updateSiniestroStatus(status) {
      if (status.id == 3 && vm.infoSiniestro.status == 1) {
        SweetAlert.swal(
          "No puedes completar una póliza desde este estatus",
          "error"
        );
        vm.status.id = vm.infoSiniestro.status;
        return;
      }

      if (status.id == 2 && vm.infoSiniestro.status != 2) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_en_tramite_modal.html",
          controller: ModalInstanceCtrlSiniestroEnTramite,
          resolve: {
            factura: function () {
              return url;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
      }
      if (
        (status.id == 4 && vm.infoSiniestro.status != 4) ||
        (status.id == 5 && vm.infoSiniestro.status != 5)
      ) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_cancel_modal.html",
          controller: ModalInstanceCtrlCancelSiniestro,
          resolve: {
            factura: function () {
              return url;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
      }
      if (vm.status.id == 3 && vm.infoSiniestro.status != 3) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_completado_vida.html",
          controller: ModalInstanceCtrlSiniestroCompletado,
          resolve: {
            vm: function () {
              return vm;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        return;
      }
    }

    function ModalInstanceCtrlCancelSiniestro(
      $scope,
      $uibModal,
      factura,
      $uibModalInstance
    ) {
      $scope.ok = function () {
        var razon = $scope.cancelRazon;
        if (razon == null) {
          SweetAlert.swal("Dato requerido", "Escriba la razón", "error");
          return;
        }
        // $http.patch(vm.infoSiniestro.url, {status: vm.status.id, reason: razon})
        $http
          .patch(vm.infoSiniestro.url, { status: vm.status.id, reason: razon })
          .then(function (siniestro) {
            if (siniestro.status === 200 || siniestro.status === 201) {
              if (siniestro.data.status == 5) {
                $scope.idSiniestro = siniestro.data.id;
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: siniestro.data.id,
                  identifier: "actualizo estatus del siniestro a Rechazado",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                // $http.get(vm.infoSiniestro.poliza.url)
                //   .then(function(poliza) {
                //     if (poliza.data.contractor) {
                //         $http.get(poliza.data.contractor)
                //           .then(function(response) {
                //             if(response.data.email){
                //                 if($localStorage.email_config){
                //                     if($localStorage.email_config.rechazo_siniestro == true){
                //                         var model = 13;
                //                         emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                     }
                //                 }
                //             }
                //         });
                //     }
                //     });
              }
              if (siniestro.data.status == 4) {
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: siniestro.data.id,
                  identifier: "actualizo estatus del siniestro a Cancelado",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
                // $http.get(vm.infoSiniestro.poliza.url)
                //   .then(function(poliza) {
                //     if (poliza.data.contractor) {
                //         $http.get(poliza.data.contractor)
                //           .then(function(response) {
                //             if(response.data.email){
                //                 if($localStorage.email_config){
                //                     if($localStorage.email_config.cancelacion_siniestro == true){
                //                         var model = 12;
                //                         emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                     }
                //                 }
                //             }
                //         });
                //     }
                //     });
              }
              SweetAlert.swal(
                "¡Listo!",
                MESSAGES.OK.SINIESTERUPDATED,
                "success"
              );
            }
          });
        $uibModalInstance.dismiss("cancel");
        fillTable(vm.ramos.ramo_selected);
        SweetAlert.swal("Guardado", "Siniestro Actualizado", "success");
        $state.go("siniestros.info", { siniestroId: $scope.idSiniestro });
      };

      $scope.cancel = function () {
        $rootScope.statusLabel = "Cambiar Estatus";
        $uibModalInstance.dismiss("cancel");
        vm.status.id = vm.infoSiniestro.status;
      };
    }

    function ModalInstanceCtrlSiniestroEnTramite(
      $scope,
      $uibModal,
      factura,
      $uibModalInstance
    ) {
      $scope.aux_fecha_promesa = new Date();
      $scope.ok = function () {
        $scope.aux_fecha_promesa = $("#date")[0].value;
        $scope.aux_fecha_promesa = new Date($scope.aux_fecha_promesa);
        vm.siniester_data.companyFolio = $scope.aux_folio;
        vm.fecha_promesa = $scope.aux_fecha_promesa;
        if (
          !vm.siniester_data.companyFolio ||
          vm.siniester_data.companyFolio.length == 0 ||
          vm.fecha_promesa == "Invalid Date"
        ) {
          SweetAlert.swal(
            "Datos requeridos",
            "Complete dato(s) requerido(s)",
            "error"
          );
          return;
        }
        var obj_tramite = {
          status: 2,
          promise_date: vm.fecha_promesa,
          folio_compania: vm.siniester_data.companyFolio,
        };
        // $http.patch(vm.infoSiniestro.url,obj_tramite).then(function success() {
        //     SweetAlert.swal("¡Listo!",MESSAGES.OK.SINIESTERUPDATED ,"success");
        // })
        $http
          .patch(vm.infoSiniestro.url, obj_tramite)
          .then(function (siniestro) {
            if (siniestro.status === 200 || siniestro.status === 201) {
              if (siniestro.data.status == 2) {
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: siniestro.data.id,
                  identifier: "actualizo estatus del siniestro a En trámite",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
                // $http.get(vm.infoSiniestro.poliza.url)
                //   .then(function(poliza) {
                //     if (poliza.data.contractor) {
                //         $http.get(poliza.data.contractor)
                //           .then(function(response) {
                //             if(response.data.email){
                //                 if($localStorage.email_config){
                //                     if($localStorage.email_config.rechazo_siniestro == true){
                //                         var model = 11;
                //                         emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                     }
                //                 }
                //             }
                //         });
                //     }
                //     });
              }
              if (siniestro.data.status == 6) {
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: siniestro.data.id,
                  identifier: "actualizo estatus del siniestro a En espera",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
                // $http.get(vm.infoSiniestro.poliza.url)
                //   .then(function(poliza) {
                //     if (poliza.data.contractor) {
                //         $http.get(poliza.data.contractor)
                //           .then(function(response) {
                //             if(response.data.email){
                //                 if($localStorage.email_config){
                //                     if($localStorage.email_config.cancelacion_siniestro == true){
                //                         var model = 14;
                //                         emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                     }
                //                 }
                //             }
                //         });
                //     }
                //     });
              }
              SweetAlert.swal(
                "¡Listo!",
                MESSAGES.OK.SINIESTERUPDATED,
                "success"
              );
            }
          });
        $uibModalInstance.dismiss("cancel");

        saveEditInformation();
      };

      $scope.cancel = function () {
        $rootScope.statusLabel = "Cambiar Estatus";
        $uibModalInstance.dismiss("cancel");
        vm.status.id = vm.infoSiniestro.status;
      };
    }

    function activate() {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 5,
          id_model: vm.siniestro_id,
        },
      })
        .then(function (request) {
          // console.log('-------', request);
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            next: request.data.next,
            previous: request.data.previous,
          };
          // console.log('comments_data', vm.comments_data);
        })
        .catch(function (e) {
          console.log("e", e);
        });
      window.scrollTo(0, 0);
      var url_siniestro =
        url.IP + "siniestros-vida-info/" + vm.siniestro_id + "/";
      $http.get(url_siniestro).then(function success(siniestro) {
        vm.vida_siniester_url = siniestro.data.vida_siniester[0].url;

        if (siniestro.data.vida_siniester[0].contacto_vida) {
          vm.contacts = siniestro.data.vida_siniester[0].contacto_vida;
        }

        if (siniestro.data.vida_siniester[0].nombre_afectado) {
          vm.afectados.nombre =
            siniestro.data.vida_siniester[0].nombre_afectado;
          vm.afectados.parentesco =
            siniestro.data.vida_siniester[0].parentesco_afectado;
        }

        vm.infoSiniestro = siniestro.data;
        $http({
          method: "GET",
          url: url.IP + "cartas-by-model",
          params: {
            model: 5,
          },
        }).then(function success(response) {
          vm.cartas = response.data;
        });

        if (vm.infoSiniestro.status == 1) {
          $scope.statusSinister = "Pendiente";
        } else if (vm.infoSiniestro.status == 2) {
          $scope.statusSinister = "En trámite";
        } else if (vm.infoSiniestro.status == 3) {
          $scope.statusSinister = "Completado";
        } else if (vm.infoSiniestro.status == 4) {
          $scope.statusSinister = "Cancelada";
        } else if (vm.infoSiniestro.status == 5) {
          $scope.statusSinister = "Rechazada";
        }
        vm.siniester_type = siniestro.data.vida_siniester[0].razon_siniestro;
        vm.siniester_pay_form = siniestro.data.vida_siniester[0].tipo_pago;
        vm.infoSiniestro = siniestro.data;
        try {
          vm.infoSiniestro.promise_date = new Date(
            vm.infoSiniestro.promise_date
          );
        } catch (e) {}
        try {
          vm.infoSiniestro.fecha_ingreso = new Date(
            vm.infoSiniestro.fecha_ingreso
          );
        } catch (e) {}
        updateStatusList();
        vm.status.id = siniestro.data.status;
        vm.siniester_data.observations = vm.infoSiniestro.observations;
        vm.siniester_data.companyFolio = siniestro.data.folio_compania;
        $http
          .get(url.IP + "get-current-receipt/" + siniestro.data.poliza_id)
          .then(function success(response) {
            var estatus = response.data.status;
            switch (parseInt(estatus)) {
              case 1:
                vm.affect_data.policy_status = "Pagado";
                break;
              case 2:
                vm.affect_data.policy_status = "Cancelado";
                break;
              case 3:
                vm.affect_data.policy_status = "Prorrogado";
                break;
              case 4:
                vm.affect_data.policy_status = "Pendiente de pago";
                break;
              default:
                vm.affect_data.policy_status = "Sin Estatus";
            }
          });

        $http
          .get(url.IP + "leer-polizas-edit/" + siniestro.data.poliza_id + "/")
          .then(function (poliza) {
            vm.selectedPoliza = poliza;
            if (poliza.data.document_type == 6) {
              // $http.get(poliza.data.life_policy[0].personal).then(function(titular) {
              $http
                .get(poliza.data.life_policy[0].personal.url)
                .then(function (titular) {
                  if (titular.data.last_name) {
                    if (titular.data.second_last_name) {
                      titular.data.full_name =
                        titular.data.first_name +
                        " " +
                        titular.data.last_name +
                        " " +
                        titular.data.second_last_name;
                    } else {
                      titular.data.full_name =
                        titular.data.first_name + " " + titular.data.last_name;
                    }
                  } else {
                    titular.data.full_name = titular.data.first_name;
                  }
                  vm.selected_affect = titular.data.full_name;
                  vm.affect_data.title = titles[1];
                  vm.affect_data.birthdate = new Date(titular.data.birthdate);
                });
              vm.selectedPoliza = poliza;
              ramoService
                .getSubramoById(poliza.data.subramo.id)
                .then(function (subramo) {
                  vm.siniester_data.subramo = subramo.data;
                });
              var data = {
                title: "Titular",
                policy_vigencia: new Date(poliza.data.end_of_validity),
                policy_vigencia_init: new Date(poliza.data.start_of_validity),
                // siniester_date: new Date() ,
                siniester_date: siniestro.data.fecha_siniestro
                  ? new Date(siniestro.data.fecha_siniestro)
                  : new Date(),
                policy_number: poliza.poliza_number
                  ? poliza.poliza_number
                  : poliza.data.parent.parent.parent.poliza_number,
              };

              poliza.data.life_policy.forEach(function (titular) {
                // $http.get(titular.personal).then(function(principal) {
                $http.get(titular.personal.url).then(function (principal) {
                  data["birthdate"] = principal.data.birthdate;
                });
                vm.beneficiaries = titular.beneficiaries_life;
              });
              var waitReceipt = [];
              if (poliza.data.parent.parent.recibos_poliza.lenght) {
                waitReceipt.push(
                  $http.get(
                    url.IP +
                      "get-current-receipt/" +
                      poliza.data.parent.parent.id
                  )
                );
              } else {
                waitReceipt.push(
                  $http.get(
                    url.IP +
                      "get-current-receipt/" +
                      poliza.data.parent.parent.parent.id
                  )
                );
              }
              $q.all(waitReceipt).then(function (response) {
                var status = response[0].data.status;
                data.policy_status = {};
                switch (status) {
                  case 1:
                    data.policy_status["label"] = "Pagado";
                    data.policy_status["id"] = status;
                    break;
                  case 2:
                    data.policy_status["label"] = "Cancelado";
                    data.policy_status["id"] = status;
                    break;
                  case 3:
                    data.policy_status["label"] = "Prorrogado";
                    data.policy_status["id"] = status;
                    break;
                  case 4:
                    data.policy_status["label"] = "Pendiente de pago";
                    data.policy_status["id"] = status;
                    break;
                  default:
                    data.policy_status["label"] = "Sin Estatus";
                    data.policy_status["id"] = status;
                }
              });
              if (poliza.data.parent.parent.contractor) {
                $http
                  .get(poliza.data.parent.parent.contractor)
                  .then(function (contratante) {
                    data["contractor_addres"] =
                      contratante.data.address_contractor[0].route +
                      " #" +
                      contratante.data.address_contractor[0].street_number +
                      " " +
                      contratante.data.address_contractor[0]
                        .administrative_area_level_2 +
                      " " +
                      contratante.data.address_contractor[0]
                        .administrative_area_level_1;
                    data["contratante"] = contratante.data;
                    vm.infoSiniestro.contratante_email = contratante.data.email;
                    data["contratante"].name =
                      contratante.data.first_name +
                      " " +
                      contratante.data.last_name;
                  });
              } else if (poliza.data.parent.parent.parent.contractor) {
                var contratante = poliza.data.parent.parent.parent.contractor;
                data["contractor_addres"] =
                  contratante.address_contractor[0].route +
                  " #" +
                  contratante.address_contractor[0].street_number +
                  " " +
                  contratante.address_contractor[0]
                    .administrative_area_level_2 +
                  " " +
                  contratante.address_contractor[0].administrative_area_level_1;
                data["contratante"] = contratante;
                vm.infoSiniestro.contratante_email = contratante.email;
                if (contratante.type_person == "Moral") {
                  data["contratante"].name = contratante.full_name;
                } else {
                  data["contratante"].name =
                    contratante.first_name + " " + contratante.last_name;
                }
              }
              // $http.get(poliza.data.parent.parent.parent.aseguradora).then(function(aseguradora) {
              //     data['aseguradora'] =  aseguradora.data;
              // });
              if (poliza.data.aseguradora) {
                providerService
                  .getProviderById(poliza.data.aseguradora)
                  .then(function (aseguradora) {
                    data["aseguradora"] = aseguradora.data;
                  });
              } else {
                data["aseguradora"] =
                  poliza.data.parent.parent.parent.aseguradora;
              }

              if (poliza.data.paquete) {
                packageService
                  .getPackageById(poliza.data.paquete.id)
                  .then(function (paquete) {
                    data["paquete"] = paquete.data;
                  });
              }
              $http.get(poliza.data.owner).then(function (user) {
                data["owner"] = user.data;
              });
              vm.affect_data = data;
            } else {
              if (poliza.data.life_policy[0]) {
                // $http.get(poliza.data.life_policy[0].personal).then(function(titular) {
                if (poliza.data.life_policy[0].personal) {
                  $http
                    .get(poliza.data.life_policy[0].personal.url)
                    .then(function (titular) {
                      if (titular.data.last_name) {
                        if (titular.data.second_last_name) {
                          titular.data.full_name =
                            titular.data.first_name +
                            " " +
                            titular.data.last_name +
                            " " +
                            titular.data.second_last_name;
                        } else {
                          titular.data.full_name =
                            titular.data.first_name +
                            " " +
                            titular.data.last_name;
                        }
                      } else {
                        titular.data.full_name = titular.data.first_name;
                      }

                      if (poliza.data.document_type == 3) {
                        vm.selected_affect = siniestro.data.aux_affected;
                      } else {
                        vm.selected_affect = titular.data.full_name;
                      }

                      vm.affect_data.title = titles[1];
                      vm.affect_data.birthdate = new Date(
                        titular.data.birthdate
                      );
                    });
                } else if (poliza.data.personal_life_policy) {
                  $http
                    .get(poliza.data.personal_life_policy[0].url)
                    .then(function (titular) {
                      if (titular.data.last_name) {
                        if (titular.data.second_last_name) {
                          titular.data.full_name =
                            titular.data.first_name +
                            " " +
                            titular.data.last_name +
                            " " +
                            titular.data.second_last_name;
                        } else {
                          titular.data.full_name =
                            titular.data.first_name +
                            " " +
                            titular.data.last_name;
                        }
                      } else {
                        titular.data.full_name = titular.data.first_name;
                      }

                      if (poliza.data.document_type == 3) {
                        vm.selected_affect = siniestro.data.aux_affected;
                      } else {
                        vm.selected_affect = titular.data.full_name;
                      }

                      vm.affect_data.title = titles[1];
                      vm.affect_data.birthdate = new Date(
                        titular.data.birthdate
                      );
                    });
                }
              }

              vm.selectedPoliza = poliza;
              ramoService
                .getSubramoById(poliza.data.subramo.id)
                .then(function (subramo) {
                  vm.siniester_data.subramo = subramo.data;
                });

              var data = {
                title: "Titular",
                policy_vigencia: new Date(poliza.data.end_of_validity),
                policy_vigencia_init: new Date(poliza.data.start_of_validity),
                // siniester_date: new Date() ,
                siniester_date: siniestro.data.fecha_siniestro
                  ? new Date(siniestro.data.fecha_siniestro)
                  : new Date(),
                policy_number: poliza.data.poliza_number,
              };

              poliza.data.life_policy.forEach(function (titular) {
                // $http.get(titular.personal).then(function(principal) {
                if (titular.personal) {
                  $http.get(titular.personal.url).then(function (principal) {
                    data["birthdate"] = principal.data.birthdate;
                  });
                }
                vm.beneficiaries = titular.beneficiaries_life;
              });
              var waitReceipt = [];
              waitReceipt.push(
                $http.get(url.IP + "get-current-receipt/" + poliza.data.id)
              );
              $q.all(waitReceipt).then(function (response) {
                var status = response[0].data.status;
                data.policy_status = {};
                switch (status) {
                  case 1:
                    data.policy_status["label"] = "Pagado";
                    data.policy_status["id"] = status;
                    break;
                  case 2:
                    data.policy_status["label"] = "Cancelado";
                    data.policy_status["id"] = status;
                    break;
                  case 3:
                    data.policy_status["label"] = "Prorrogado";
                    data.policy_status["id"] = status;
                    break;
                  case 4:
                    data.policy_status["label"] = "Pendiente de pago";
                    data.policy_status["id"] = status;
                    break;
                  default:
                    data.policy_status["label"] = "Sin Estatus";
                    data.policy_status["id"] = status;
                }
              });
              if (poliza.data.contractor) {
                $http.get(poliza.data.contractor).then(function (contratante) {
                  vm.infoSiniestro.contratante_email = contratante.data.email;
                  data["contractor_addres"] =
                    contratante.data.address_contractor[0].route +
                    " #" +
                    contratante.data.address_contractor[0].street_number +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_2 +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_1;
                  data["contratante"] = contratante.data;
                  data["contratante"].name = contratante.data.full_name;
                });
              }

              providerService
                .getProviderById(poliza.data.aseguradora)
                .then(function (aseguradora) {
                  data["aseguradora"] = aseguradora.data;
                });

              if (poliza.data.paquete) {
                packageService
                  .getPackageById(poliza.data.paquete.id)
                  .then(function (paquete) {
                    data["paquete"] = paquete.data;
                  });
              }

              $http.get(poliza.data.owner).then(function (user) {
                data["owner"] = user.data;
              });

              vm.affect_data = data;

              if (poliza.data.document_type == 3) {
                vm.selected_affect = siniestro.data.aux_affected;
              }

              if ($localStorage.save_edition_siniestro_vida) {
                vm.siniester_data.siniester_number =
                  $localStorage.save_edition_siniestro_vida &&
                  $localStorage.save_edition_siniestro_vida["siniester_number"]
                    ? $localStorage.save_edition_siniestro_vida[
                        "siniester_number"
                      ]
                    : "";
                vm.siniester_type =
                  $localStorage.save_edition_siniestro_vida &&
                  $localStorage.save_edition_siniestro_vida["siniester_type"]
                    ? $localStorage.save_edition_siniestro_vida[
                        "siniester_type"
                      ]
                    : 0;
                vm.siniester_pay_form =
                  $localStorage.save_edition_siniestro_vida &&
                  $localStorage.save_edition_siniestro_vida[
                    "siniester_pay_form"
                  ]
                    ? $localStorage.save_edition_siniestro_vida[
                        "siniester_pay_form"
                      ]
                    : 0;
              }
            } //asdsadd
          });
        vm.accesos = $sessionStorage.permisos;
        if (vm.accesos) {
          vm.accesos.forEach(function (perm) {
            if (perm.model_name == "Pólizas") {
              vm.acceso_polizas = perm;
              vm.acceso_polizas.permissions.forEach(function (acc) {
                if (acc.permission_name == "Administrar pólizas") {
                  if (acc.checked == true) {
                    vm.acceso_adm_pol = true;
                  } else {
                    vm.acceso_adm_pol = false;
                  }
                } else if (acc.permission_name == "Ver pólizas") {
                  if (acc.checked == true) {
                    vm.acceso_ver_pol = true;
                  } else {
                    vm.acceso_ver_pol = false;
                  }
                } else if (acc.permission_name == "Cancelar pólizas") {
                  if (acc.checked == true) {
                    vm.acceso_canc_pol = true;
                  } else {
                    vm.acceso_canc_pol = false;
                  }
                } else if (acc.permission_name == "Eliminar pólizas") {
                  if (acc.checked == true) {
                    vm.acceso_elim_pol = true;
                  } else {
                    vm.acceso_elim_pol = false;
                  }
                }
              });
            } else if (perm.model_name == "Formatos") {
              vm.acceso_form = perm;
              vm.acceso_form.permissions.forEach(function (acc) {
                if (acc.permission_name == "Formatos") {
                  if (acc.checked == true) {
                    vm.acceso_form = true;
                  } else {
                    vm.acceso_form = false;
                  }
                }
              });
            } else if (perm.model_name == "Siniestros") {
              vm.acceso_sin = perm;
              vm.acceso_sin.permissions.forEach(function (acc) {
                if (acc.permission_name == "Administrar siniestros") {
                  if (acc.checked == true) {
                    vm.acceso_adm_sin = true;
                  } else {
                    vm.acceso_adm_sin = false;
                  }
                }
              });
            } else if (perm.model_name == "Archivos") {
              vm.permarch = perm;
              vm.permarch.permissions.forEach(function (acc) {
                if (acc.permission_name == "Administrar archivos sensibles") {
                  if (acc.checked == true) {
                    vm.permiso_archivos = true;
                  } else {
                    vm.permiso_archivos = false;
                  }
                } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
                if (acc.permission_name == "Administrar adjuntos") {
                  if (acc.checked == true) {
                    vm.permiso_administrar_adjuntos = true;
                  } else {
                    vm.permiso_administrar_adjuntos = false;
                  }
                }
              });
            }
          });
        }
        vm.fecha_promesa = convertDate(siniestro.data.promise_date);
        vm.siniester_data.capture_date = siniestro.data.created_at;

        vm.affect_data.siniester_date = new Date(
          siniestro.data.fecha_siniestro
        );
        vm.siniester_data.siniester_number = siniestro.data.numero_siniestro;

        fileService
          .getFiles(url.IP + "siniestros/" + vm.siniestro_id + "/archivos/")
          .then(function (files) {
            files.forEach(function (file) {
              vm.files.push(file);
            });
          });
      });
    }

    $scope.save_info_tab = function () {
      $localStorage.save_edition_siniestro_vida = angular.copy(
        vm.siniester_data
      );
      $localStorage.save_edition_siniestro_vida["siniester_number"] =
        vm.siniester_data.siniester_number;
      $localStorage.save_edition_siniestro_vida["siniester_type"] =
        vm.siniester_type;
      $localStorage.save_edition_siniestro_vida["siniester_pay_form"] =
        vm.siniester_pay_form;
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
    }

    function cancel() {
      // $state.go('siniestros.lista');
      $state.reload();
    }

    function updateStatusList() {
      var estado = vm.infoSiniestro.status;
      switch (estado) {
        case 1:
          vm.statuses = [
            /*{'id':1,'label':'Pendiente'},*/
            { id: 2, label: "En trámite" },
            { id: 4, label: "Cancelada" },
            { id: 5, label: "Rechazada" },
          ];
          break;
        case 2:
          vm.statuses = [
            /*{'id':2,'label':'En trámite'},*/
            { id: 3, label: "Completado" },
            { id: 4, label: "Cancelada" },
            { id: 5, label: "Rechazada" },
          ];
          break;
        case 3:
          vm.statuses = [
            /*{'id':3,'label': 'Completado'}*/
          ];
          break;
        case 4:
          vm.statuses = [
            /*{'id':4,'label': 'Cancelada'}*/
          ];
          break;
        case 5:
          vm.statuses = [
            /*{'id':5,'label':'Rechazada'}*/
          ];
          break;
      }
    }

    function ramo_changed() {
      // console.log(vm.ramos.ramo_selected);
      fillTable(vm.ramos.ramo_selected);
    }
    $scope.changeTypeDoc = function (padecimiento) {
      $scope.padecimiento_type = padecimiento;
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    //   function getFiles() {
    //     var dfd =$q.defer()
    //     $http.get(url.IP+ 'siniestros/' +vm.siniestro_id+ '/archivos/').then(function(files) {
    //         dfd.resolve(files.data.results);
    //     });
    //     return dfd.promise;
    // }
    // Afectado a certificado
    $scope.changeAfectado = function (padecimiento) {
      $scope.newAfectado = true;
    };
    vm.getCertificate = getCertificate;
    function getCertificate(parId) {
      if (parId) {
        if (parId.val.length >= 3) {
          $http({
            method: "POST",
            url: url.IP + "get-certificatesforsiniestro/",
            data: {
              word: parId.val,
              id_collect: vm.infoSiniestro.poliza.id,
              mode: $scope.endorsement_type_manual,
            },
          })
            .then(
              function success(request) {
                //console.log(request);
                var results_cert = [];
                var mapeo_cert = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    // $scope.btnSearchDisabled = true;
                    toaster.warning("Certificado no encontrado");
                  } else {
                    // $scope.btnSearchDisabled = false;
                    toaster.success("Certificado existente");
                    request.data.forEach(function (poliza) {
                      vm.certificado_for_siniestro = poliza;
                      // vm.form.num_receipts = vm.form.num_receipts;
                      if (poliza.document_type == 6) {
                        mapeo_cert.push(poliza);
                      }
                    });
                    results_cert = _.map(mapeo_cert, function (item) {
                      if (item.contractor) {
                        var label = item.contractor ? item.contractor : "";
                        label =
                          "Certificado: " +
                          item.certificate_number +
                          "- " +
                          label +
                          " - " +
                          item.poliza_number;
                      }
                      return {
                        label: label ? label : "",
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                        url: item.url,
                        contacto: item.contacto,
                        certificate_number: item.certificate_number,
                      };
                    });
                    $scope.autocompleteDataCertificate = results_cert;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    }
    vm.getTypeCertificate = getTypeCertificate;
    function getTypeCertificate(certificado) {
      $scope.certificateForSiniestro = certificado;
      $scope.certificadoSiniestro = certificado;
      $scope.subgrupoReceipts = {};
      dataFactory
        .get("polizas/" + $scope.certificateForSiniestro.id)
        .then(function success(polizaSelected) {
          if (polizaSelected.status == 200 || polizaSelected.status == 201) {
            vm.certificado_ = polizaSelected.data;
            console.log("-vm.certificado_", vm.certificado_);
          }
        });
      console.log("-vm.certificado_", vm.certificado_);
    }
    function uploadFiles(siniestro_id, doc_type) {
      $scope.userInfo = {
        id: siniestro_id,
        type_document: doc_type,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP +
        "siniestros/" +
        siniestro_id +
        "/archivos/?type_document=" +
        doc_type;
      // ////console.log( $scope.uploader);
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve($scope.uploader.uploadAll());
          return defer.promise;
        })
        .then(function () {
          toaster.success("Se han subido sus archivos correctamente");

          setTimeout(function () {
            fileService
              .getFiles(url.IP + "siniestros/" + vm.siniestro_id + "/archivos/")
              .then(function (res) {
                res.forEach(function (file) {
                  vm.files.push(file);
                });
              });
          }, 100);
        });
    }

    function Exist(list, obj) {
      for (var i = 0; i < list.length; i++) {
        if (obj.value == list[i].value) {
          return true;
        }
      }
      return false;
    }

    function ModalInstanceCtrlSiniestroCompletado(
      $scope,
      $uibModal,
      status,
      $uibModalInstance,
      vm
    ) {
      $scope.beneficiaries = vm.beneficiaries;
      $scope.coverage = vm.selectedPoliza.data.coverageInPolicy_policy[0];
      $scope.ok = function () {
        if (vm.beneficiaries && vm.beneficiaries.length) {
          vm.beneficiaries.forEach(function (beneficiario) {
            var procedente_obj = {
              procedente: parseFloat(beneficiario.procedente).toFixed(2),
              // 'isr': parseFloat(beneficiario.isr).toFixed(2)
              isr: beneficiario.isr,
            };
            $http.patch(beneficiario.url, procedente_obj).then(
              function success(resp) {
                if (resp.status === 200 || resp.status === 201) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "Beneficiarios actualizados",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "¡Error!",
                    "Beneficiarios NO  actualizados, se requieren números válidos",
                    "error"
                  );
                }
              },
              function error(error) {
                console.log("error - beneficiaries", error);
              }
            );
          });
        }

        var status_obj = {
          status: 3,
        };
        if (status_obj.status == 3) {
          $scope.idSiniestro = vm.infoSiniestro.id;
          if (vm.infoSiniestro.poliza) {
            vm.infoSiniestro_info = {};
            vm.infoSiniestro_info.poliza = vm.infoSiniestro.poliza;
            // Send Email
            // if (vm.infoSiniestro_info.poliza.contractor){
            //     $http.get(vm.infoSiniestro_info.poliza.contractor)
            //       .then(function(response) {
            //         if(response.data.email){
            //             // Send email
            //             if($localStorage.email_config){
            //                 if($localStorage.email_config.fin_siniestro == true){
            //                     var model = 4;
            //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
            //                 }
            //             }
            //             // Send Email
            //         }
            //     });
            // }
            //Send Email
          }
        }
        $http.patch(vm.infoSiniestro.url, status_obj).then(function success() {
          var params = {
            model: 5,
            event: "PATCH",
            associated_id: vm.infoSiniestro.id,
            identifier: "actualizo estatus del siniestro a Completado",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          SweetAlert.swal("¡Listo!", MESSAGES.OK.SINIESTERUPDATED, "success");
        });
        $uibModalInstance.dismiss("cancel");
        // $state.go('siniestros.lista');
        $state.reload();
      };

      $scope.validateImpuesto = function (index, item) {
        if (item) {
          if (parseFloat(item) < 0) {
            $scope.beneficiaries[index].isr = 0;
          } else {
            $scope.beneficiaries[index].isr = parseFloat(
              $scope.beneficiaries[index].isr
            ).toFixed(2);
            $scope.beneficiaries[index].isr = parseFloat(
              $scope.beneficiaries[index].isr
            );
          }
        }
      };

      $scope.validateProcedente = function (index, item) {
        if (item) {
          if (parseFloat(item) < 0) {
            $scope.beneficiaries[index].procedente = 0;
          } else {
            $scope.beneficiaries[index].procedente = parseFloat(
              $scope.beneficiaries[index].procedente
            ).toFixed(2);
            $scope.beneficiaries[index].procedente = parseFloat(
              $scope.beneficiaries[index].procedente
            );
          }
        }
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
        return;
      };
    }

    function saveEditInformation() {
      if (vm.status.id == 3 && vm.infoSiniestro.status != 3) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_completado_vida.html",
          controller: ModalInstanceCtrlSiniestroCompletado,
          resolve: {
            vm: function () {
              return vm;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        return;
      }
      patchSiniester();
    }

    function patchSiniester(obj) {
      var obj_siniestro = {
        folio_compania: vm.infoSiniestro.folio_compania,
        numero_siniestro: vm.siniester_data.siniester_number,
        status: vm.status.id,
        promise_date: vm.fecha_promesa,
        fecha_siniestro: new Date(vm.affect_data.siniester_date),
        fecha_ingreso: new Date(vm.infoSiniestro.fecha_ingreso),
        tipo_siniestro_general: vm.infoSiniestro.tipo_siniestro_general,
        observations: vm.siniester_data.observations,
      };
      $http
        .patch(vm.infoSiniestro.url, obj_siniestro)
        .then(function (siniestro) {
          if (siniestro.status == 200 || siniestro.status == 201) {
            $http.patch(vm.vida_siniester_url, {
              razon_siniestro: vm.siniester_type,
              tipo_pago: vm.siniester_pay_form,
            });
            uploadFiles(vm.infoSiniestro.id, $scope.padecimiento_type);
            var params = {
              model: 5,
              event: "PATCH",
              associated_id: vm.infoSiniestro.id,
              identifier:
                "actualizo el siniestro " + vm.infoSiniestro.numero_siniestro,
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            SweetAlert.swal("¡Listo!", MESSAGES.OK.SINIESTERUPDATED, "success");

            // $state.go('siniestros.lista');
            $state.reload();
          } else {
            SweetAlert.swal("Error", "Ha ocurrido un error", "error");
            // $state.go('siniestros.lista');
            $state.reload();
          }
        });
    }

    $scope.saveEditInformation2 = function (obj) {
      var continuar = false;
      var obj_siniestro = {
        folio_compania: vm.siniester_data.companyFolio,
        promise_date: vm.fecha_promesa,
        fecha_siniestro: new Date(vm.affect_data.siniester_date),
        fecha_ingreso: new Date(vm.infoSiniestro.fecha_ingreso),
        tipo_siniestro_general: vm.infoSiniestro.tipo_siniestro_general,
        observations: vm.siniester_data.observations,
      };
      if (vm.infoSiniestro.poliza.document_type == 3) {
        continuar = false;
        if (vm.certificado_) {
          SweetAlert.swal(
            {
              title:
                "El siniestro inicialmente se creo a una Colectividad: " +
                vm.infoSiniestro.poliza.poliza_number,
              text:
                "¿Reasignar al certificado : " +
                vm.certificado_.certificate_number +
                "?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Si",
              cancelButtonText: "No",
              closeOnConfirm: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                obj_siniestro.poliza = vm.certificado_.url;
                obj_siniestro.aux_affected = vm.certificado_.life_policy[0]
                  .personal
                  ? vm.certificado_.life_policy[0].personal.first_name +
                    " " +
                    vm.certificado_.life_policy[0].personal.last_name
                  : null;
                continuar = true;
                $scope.saveChangesSiniester(obj_siniestro);
              } else {
                $scope.newAfectado = false;
                // $state.go('siniestros.lista');
                $state.reload();
              }
            }
          );
        }
      }
    };
    $scope.saveChangesSiniester = function (obj_siniestro) {
      $http
        .patch(vm.infoSiniestro.url, obj_siniestro)
        .then(function (siniestro) {
          $scope.newAfectado = false;
          if (siniestro.status == 200 || siniestro.status == 201) {
            uploadFiles(vm.infoSiniestro.id, $scope.padecimiento_type);
            var params = {
              model: 5,
              event: "PATCH",
              associated_id: vm.infoSiniestro.id,
              identifier:
                "actualizo el siniestro " + vm.infoSiniestro.numero_siniestro,
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            SweetAlert.swal("¡Listo!", MESSAGES.OK.SINIESTERUPDATED, "success");
            // $state.go('siniestros.lista');
            $state.reload();
          } else {
            SweetAlert.swal("Error", "Ha ocurrido un error", "error");
            // $state.go('siniestros.lista');
            $state.reload();
          }
        });
    };

    function fillTable(ramo_number) {
      vm.siniestros = [];
      $http
        .get(url.IP + "siniestros-definidos/" + ramo_number)
        .then(function (siniestros) {
          // console.log('siniestros',siniestros)
          siniestros.data.forEach(function (siniestro) {
            vm.siniestros.push(siniestro);
            // ////console.log(vm.siniestros);
            // });
          });
        });
    }

    function deleteSiniestro(url) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Al eliminar tu siniestro no podra recuperarse nuevamente!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "No, cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: vm.infoSiniestro.id,
              model: 5,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {
                console.log(".................:::::.....", req);
              });
            $http.delete(url).then(function (response) {
              if (response.status === 204) {
                SweetAlert.swal("Siniestro eliminado exitosamente");
                var params = {
                  model: 5,
                  event: "DELETE",
                  associated_id: vm.infoSiniestro.id,
                  identifier:
                    "elimino el siniestro" + vm.infoSiniestro.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
              }
              $state.go("siniestros.lista");
            });
          } else {
            SweetAlert.swal(
              "Cancelado",
              "Tu registro esta a salvo :)",
              "error"
            );
          }
        }
      );
    }

    function checkSubRamo(event) {}

    function showSubRamos(event) {
      vm.ramoId = event.target.id;
      //////console.log(event.target.id);
    }

    function textAExpand(event) {
      var element = e.target;
      var scroll = element.scrollHeight - 60; // <- Padding top and buttom sum
      element.style.height = scrollHeight + "px";
    }

    function updateStatus() {
      insuranceService.getInsurances().then(function (polizas) {
        polizas.forEach(function (poliza) {
          // ////console.log(poliza);
          poliza.accidents_policy.forEach(function (titular) {
            $http.get(titular.personal).then(function (name) {
              var obj = {
                label:
                  name.data.first_name +
                  " " +
                  name.data.last_name +
                  " " +
                  name.data.second_last_name +
                  "   -   " +
                  "poliza: " +
                  poliza.poliza_number,
                value: {
                  id: poliza.id,
                  title: titles[1],
                  tittle_id: 1,
                  name: name.data.first_name,
                  url: titular.personal,
                },
              };
              vm.affected.push(obj);
            });

            titular.relationship_accident.forEach(function (dependiente) {
              var obj = {
                label:
                  dependiente.first_name +
                  " " +
                  dependiente.last_name +
                  " " +
                  dependiente.second_last_name +
                  "   -   " +
                  "poliza: " +
                  poliza.poliza_number,
                value: {
                  id: poliza.id,
                  title: titles[dependiente.relationship],
                  tittle_id: dependiente.relationship,
                  name: dependiente.first_name,
                  url: dependiente.url,
                },
              };
              vm.affected.push(obj);
            });
          });
        });
      });
    }

    $rootScope.statusLabel = "Cambiar Estatus";
    $scope.changeLabel = function (status) {
      $rootScope.statusLabel = status.label;
      vm.status.id = status.id;
      vm.status.label = status.label;
      vm.updateSiniestroStatus(vm.status);
    };

    // Enviar correo electrónico Siniestro inicio***********
    function sendEmail(siniestro, poliza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/email_siniestro.html",
        controller: ModalEmailSiniestroCtrl,
        size: "lg",
        resolve: {
          from: function () {
            return null;
          },
          archivos: function () {
            return vm.files;
          },
          siniestro: function () {
            return siniestro;
          },
          poliza: function () {
            return poliza;
          },
          info: function () {
            return vm.infoSiniestro;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
      modalInstance.result.then(function (data) {});
    }

    function openWhatsapp(siniestro, poliza) {
      var targetSiniestro = siniestro || vm.infoSiniestro;
      if (!targetSiniestro) {
        return;
      }
      var info = {
        contratante: targetSiniestro.contratante,
        contratante_phone_number:
          targetSiniestro.contratante_phone_number ||
          (targetSiniestro.contratante &&
            (targetSiniestro.contratante.phone_number ||
              targetSiniestro.contratante.phone)),
      };
      siniestroWhatsappService.open({
        siniestro: targetSiniestro,
        poliza: poliza || (vm.selectedPoliza && vm.selectedPoliza.data),
        info: info,
      });
    }
    function ModalEmailSiniestroCtrl(
      $uibModalInstance,
      $scope,
      archivos,
      siniestro,
      poliza,
      info
    ) {
      var vmm = this;
      $scope.data = {};
      $scope.send = false;
      $scope.files = archivos;
      $scope.siniestro = siniestro;
      $scope.poliza = poliza;
      $scope.emailcontractor = info.contratante_email;
      $scope.subjectEmail =
        "Información del Siniestro: " +
        (siniestro.numero_siniestro
          ? siniestro.numero_siniestro
          : siniestro.folio_interno
        ).toString() +
        ", de la Póliza: " +
        (poliza.poliza_number
          ? poliza.poliza_number
          : poliza.internal_number
        ).toString();
      $scope.close = function () {
        $uibModalInstance.dismiss();
      };
      $http
        .get(url.IP + "share-siniestro-manual/" + siniestro.id)
        .then(function (response) {
          if (response.status === 200) {
            $scope.body = response.data.body;
          }
        })
        .catch(function (e) {
          console.log("error - catch", e);
        });
      $scope.visualizar = function (data) {
        $uibModalInstance.close(data);
      };
      dataFactory
        .get("emailtemplate-unpag/", {
          template_model: 4,
          id_policy: poliza.id,
        })
        .then(function success(response) {
          $scope.plantillas = response.data;
        });
      $scope.changePlantilla = function (item) {
        if (item) {
          $scope.subjectEmail = item.title;
          $scope.first_comment = item.text;
          if ($scope.first_comment.includes("\n")) {
            $scope.first_comment = $scope.first_comment.replace(
              "\n",
              "<br><br>"
            );
          }
          $scope.second_comment = item.bottom_text;
          $scope.custom_email = true;
          $scope.getTemplate(true);
        } else {
          $scope.subjectEmail = "";
          $scope.first_comment = "";
          $scope.second_comment = "";
          $scope.custom_email = true;
          $scope.getTemplate(true);
        }
      };
      $scope.getTemplate = function (custom_email) {
        if (custom_email) {
          $http
            .get(url.IP + "share-siniestro-manual/" + vm.insurance.id)
            .then(function (response) {
              if (response.status === 200) {
                $scope.head = response.data.head;
                $scope.body = response.data.body;
                $scope.footer = response.data.footer;
                $scope.subjectDefault = response.data.subject_default;
                if (
                  $scope.subjectEmail == "" ||
                  $scope.subjectEmail == undefined
                ) {
                  $scope.subjectEmail = $scope.subjectDefault;
                }
              }
            })
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          $scope.htmlVariable = "";
          $scope.first_comment = "";
          $scope.second_comment = "";
        }
      };
      $scope.sendEmailSiniestro = function (first_comment, second_comment) {
        $scope.send = true;
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        var data_shared = {
          id: siniestro.id,
          emails: $scope.emails,
          files: $scope.share_via_email,
          subject: $scope.subjectEmail,
          first_comment: first_comment,
          second_comment: second_comment,
          model: 5,
        };

        $http
          .post(url.IP + "share-siniestro-manual/", data_shared)
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.SENDEMAIL, "success");
                $scope.send = true;
                $uibModalInstance.dismiss("cancel");
              } else {
                $scope.send = true;
                l.stop();
                if (request.data && request.data.status) {
                  SweetAlert.swal("ERROR", request.data.status, "error");
                } else if (request.data && request.data.response) {
                  SweetAlert.swal(
                    "Error",
                    "No se envió el correo electrónico. Contacte a su administrador.",
                    "error"
                  );
                } else {
                  SweetAlert.swal(
                    "ERROR",
                    JSON.stringify(request.data),
                    "error"
                  );
                }
              }
            },
            function error(error) {
              l.stop();
              console.log("error - email", error);
            }
          )
          .catch(function (e) {
            l.stop();
            console.log("error - catch", e);
          });
      };
      $scope.showEmailInInput = function (email) {
        $scope.email_assign = email;
      };
      $scope.emails = [];
      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      $scope.emails = [];

      $scope.addEmail = function (email) {
        if (!validateEmail(email)) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }

        if ($scope.emails.indexOf(email) < 0) {
          $scope.emails.push(email);
          vmm.email_assign_mail = ""; // limpiamos el input
        } else {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.REPEATEMAIL, "error");
        }
      };
      $scope.remove_email = function (index) {
        $scope.emails.splice(index, 1);
      };
      $scope.share_via_email = [];
      $scope.shareFileEmail = function (file, value) {
        file.to_send = value;
        var index = $scope.share_via_email.indexOf(file.id);
        if (value) {
          if (index === -1) {
            $scope.share_via_email.push(file.id);
          }
        } else {
          if (index !== -1) {
            $scope.share_via_email.splice(index, 1);
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }
    // enviar correo electrónico Siniestro fin*********
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("SiniestrosVidaCtrl", SiniestrosVidaCtrl);
  SiniestrosVidaCtrl.$inject = [
    "emailService",
    "dataFactory",
    "MESSAGES",
    "packageService",
    "providerService",
    "$state",
    "SweetAlert",
    "$q",
    "toaster",
    "$localStorage",
    "FileUploader",
    "insuranceService",
    "SiniestroService",
    "$scope",
    "$uibModal",
    "ramoService",
    "$http",
    "url",
    "helpers",
    "$sessionStorage",
    "$location",
    "$rootScope",
    "$stateParams",
    "PersistenceFactory",
    "datesFactory",
  ];

  function SiniestrosVidaCtrl(
    emailService,
    dataFactory,
    MESSAGES,
    packageService,
    providerService,
    $state,
    SweetAlert,
    $q,
    toaster,
    $localStorage,
    FileUploader,
    insuranceService,
    SiniestroService,
    $scope,
    $uibModal,
    ramoService,
    $http,
    url,
    helpers,
    $sessionStorage,
    $location,
    $rootScope,
    $stateParams,
    PersistenceFactory,
    datesFactory
  ) {
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    $scope.url = $location.path();

    var vm = this;
    vm.user = usr;
    vm.selectedRamo = null;
    vm.selectedSubRamo = null;
    vm.selectedPoliza;
    vm.sub_ramos = [];
    vm.status = { id: 1, label: "Pendiente" };
    vm.statuses = [{ id: 1, label: "Pendiente" }];
    vm.insurances_number = [];
    vm.isInicial = true;
    vm.selectedContractor;
    $scope.subramo_select;
    vm.element = "";
    vm.ramos = [];
    vm.affected = [];
    vm.affect_list = [];
    vm.ramoId = -1;
    vm.insurances;
    vm.selected_affect = [];
    vm.selectInsurance;
    vm.affect_data = {};
    vm.selected_disease = [];
    vm.siniestros = [];
    vm.siniester_data = {};
    vm.siniester_data.siniestros_by_number = [];
    vm.siniester_data.selected_number_siniester;
    vm.enfermedades = [];
    vm.buscarEnfermedad = true;
    vm.show_caratula_afectado = false;
    vm.LookFor = LookFor;
    vm.selectedPoliza;
    vm.cancel = cancel;
    vm.ramos = {};
    vm.beneficiaries = [];
    vm.ramos.ramo_selected = 1;
    vm.ramos.options = [
      { id: 2, label: "Accidentes y Enfermedades" },
      { id: 3, label: "Daños" },
      { id: 1, label: "Vida" },
    ];

    vm.siniestros_type = [
      { id: 0, label: "Seleccione una opción" },
      { id: 1, label: "Natural" },
      { id: 2, label: "Accidental" },
      { id: 3, label: "Pérdidas orgánicas" },
      { id: 4, label: "Invalidez" },
      { id: 5, label: "Funerarios" },
    ];

    vm.siniestros_pay_form = [
      { id: 0, label: "Seleccione una opción" },
      { id: 1, label: "Cheque" },
      { id: 2, label: "Transferencia" },
    ];

    vm.relationship = [
      { id: 1, label: "Titular" },
      { id: 2, label: "Cónyuge" },
      { id: 3, label: "Hijo" },
      { id: 4, label: "Otro" },
    ];

    vm.siniester_type = 0;
    vm.siniester_pay_form = 0;
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };
    vm.afectados = [];

    vm.contacts = [];
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;
    $scope.count_contact = true;

    function addContact() {
      var contact = {
        first_name: "",
        phone: "",
        email: "",
        references: "",
      }; //jshint ignore:line
      vm.contacts.push(contact);
    }

    function deleteContacts(url, index) {
      vm.contacts.splice(index, 1);
    }

    vm.addAfectado = addAfectado;
    vm.deleteAfectado = deleteAfectado;
    $scope.count_afectado = true;

    function addAfectado() {
      $scope.count_afectado = false;
      var afectado = {
        nombre: "",
        parentesco: 1,
      };
      vm.afectados.push(afectado);
    }

    function deleteAfectado(url, index) {
      $scope.count_afectado = true;
      vm.afectados.splice(index, 1);
    }

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    // vm.user.permiso.crear = true;
    vm.closeModal = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };
    var date = new Date();

    // vm.fecha_promesa = new Date(date.setDate(date.getDate() + 5));
    vm.files;
    vm.form = {};
    var titles = {
      1: "Titular",
      2: "Conyuge",
      3: "Hijo",
    };
    // vm.facturas = [{ f_number: '', proovedor: '', f_date: '', import: '', iva:'', total:'',procedente:'' }]
    vm.facturas = [];

    $scope.myInsurance = $stateParams.myInsurance;
    try {
      if ($scope.myInsurance) {
        if ($scope.myInsurance.url) {
          if ($scope.myInsurance.doSinisterCaratula) {
            var obj = {
              val: "Carátula: " + $scope.myInsurance.poliza_number,
              value: {
                id: $scope.myInsurance.id,
                title: titles[1],
                tittle_id: 1,
                name: $scope.myInsurance.poliza_number,
                url: $scope.myInsurance.url,
              },
            };
          } else {
            if (
              $scope.myInsurance &&
              $scope.myInsurance.life_policy &&
              $scope.myInsurance.life_policy[0].personal
            ) {
              vm.selected_affect = [];
              var name_ = $scope.myInsurance.life_policy[0].personal;
              var name =
                $scope.myInsurance.life_policy[0].beneficiaries_life[0];
              $scope.val = $scope.myInsurance.poliza_number;
              var obj = {
                val:
                  name_.first_name +
                  " " +
                  name_.last_name +
                  " " +
                  name_.second_last_name +
                  "   -   " +
                  "POLIZA: " +
                  $scope.myInsurance.poliza_number,
                label:
                  name_.first_name +
                  " " +
                  name_.last_name +
                  " " +
                  name_.second_last_name +
                  "   -   " +
                  "POLIZA: " +
                  $scope.myInsurance.poliza_number,
                value: {
                  id: $scope.myInsurance.id,
                  title: titles[1],
                  tittle_id: 1,
                  name:
                    name_.first_name +
                    " " +
                    name_.last_name +
                    " " +
                    name_.second_last_name,
                  url: name_.url,
                },
              };
            } else {
              if (
                $scope.myInsurance.personal_life_policy &&
                $scope.myInsurance.personal_life_policy.length > 0
              ) {
                vm.selected_affect = [];
                var name_ = $scope.myInsurance.personal_life_policy[0];
                var name =
                  $scope.myInsurance.life_policy[0].beneficiaries_life[0];
                $scope.val = $scope.myInsurance.poliza_number;
                var obj = {
                  val:
                    name_.first_name +
                    " " +
                    name_.last_name +
                    " " +
                    name_.second_last_name +
                    "   -   " +
                    "POLIZA: " +
                    $scope.myInsurance.poliza_number,
                  label:
                    name_.first_name +
                    " " +
                    name_.last_name +
                    " " +
                    name_.second_last_name +
                    "   -   " +
                    "POLIZA: " +
                    $scope.myInsurance.poliza_number,
                  value: {
                    id: $scope.myInsurance.id,
                    title: titles[1],
                    tittle_id: 1,
                    name:
                      name_.first_name +
                      " " +
                      name_.last_name +
                      " " +
                      name_.second_last_name,
                    url: name_.url,
                  },
                };
              }
            }
          }
          vm.afectados = [{ nombre: obj.value.name }];
          vm.selected_affect = obj;
          LookFor();
        }
      }
    } catch (error) {
      console.log("error", error);
      activate();
    }

    $scope.colors = [
      { name: "black", shade: "dark" },
      { name: "white", shade: "light", notAnOption: true },
      { name: "red", shade: "dark" },
      { name: "blue", shade: "dark", notAnOption: true },
      { name: "yellow", shade: "light", notAnOption: false },
    ];
    $scope.myColor = $scope.colors[2];

    //Modals
    vm.updateStatus = updateStatus;
    vm.uploadFiles = uploadFiles;
    vm.saveSiniester = saveSiniester;

    vm.ramo_changed = ramo_changed;
    //functions
    vm.showSubRamos = showSubRamos;
    vm.textAExpand = textAExpand;

    // Date picker stuff
    vm.dateNow = new Date();
    vm.dateLimit = new Date(
      vm.dateNow.getFullYear(),
      vm.dateNow.getMonth() + 2,
      vm.dateNow.getDate()
    );

    activate();

    // var uploader = $scope.uploader = new FileUploader({
    //     headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json' },
    // });
    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    function ramo_changed() {
      // ////console.log(vm.ramos.ramo_selected);
      fillTable(vm.ramos.ramo_selected);
    }
    function NotExist(array, element) {
      ////console.log('array',array);
      ////console.log('element',element);
      if (array.length == 0) {
        return true;
      }
      array.forEach(function (elem) {
        if (elem.label == element.label) {
          return true;
        }
      });
      return false;
    }

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].type_document = item.padecimiento_type;
    };

    function getFiles() {
      // return receiptService.getFiles(receiptService.getReceiptID())
      //     .then(function(data) {
      //         vm.files = data;
      //         return vm.files;
      //     });
    }

    function uploadFiles(siniestro_id) {
      $scope.userInfo = {
        id: siniestro_id,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "siniestros/" + siniestro_id + "/archivos/";
      // ////console.log( $scope.uploader);
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve($scope.uploader.uploadAll());
          return defer.promise;
        })
        .then(function () {
          toaster.success("Se han subido sus archivos correctamente");

          // setTimeout(function() {
          //     getFiles().then(function(res) {
          //         vm.files = res;
          //     });
          // }, 1000);
        });
    }

    function Exist(list, obj) {
      for (var i = 0; i < list.length; i++) {
        if (obj.value == list[i].value) {
          return true;
        }
      }
      return false;
    }

    function cancel() {
      $localStorage["save_created_siniester_life"] = {};
      $state.go("siniestros.lista");
    }
    vm.cadenaBusq = cadenaBusq;
    function cadenaBusq(v) {
      $scope.cadena_a_buscar = v;
    }
    vm.BuscarPolizas = BuscarPolizas;
    function BuscarPolizas(polizaa) {
      //Se ingresa el numero de poliza
      // $scope.params = {
      //     num_poliza: vm.form.poliza && vm.form.poliza.value ? vm.form.poliza.value.num_poliza : vm.form.poliza ? vm.form.poliza : '',
      //     id_policy: vm.id_policy
      // }
      if (
        $localStorage["save_created_siniester_life"] &&
        $localStorage["save_created_siniester_life"]["selected_affect"] &&
        polizaa
      ) {
        if (
          $localStorage["save_created_siniester_life"]["selected_affect"] &&
          $localStorage["save_created_siniester_life"]["selected_affect"][
            "value"
          ] &&
          polizaa
        ) {
          if (
            $localStorage["save_created_siniester_life"]["selected_affect"][
              "value"
            ] &&
            $localStorage["save_created_siniester_life"]["selected_affect"][
              "value"
            ]["id"]
          ) {
            if (polizaa.value) {
              if (
                $localStorage["save_created_siniester_life"]["selected_affect"][
                  "value"
                ]["id"] != polizaa.value.id
              ) {
                $localStorage["save_created_siniester_life"][
                  "selected_affect"
                ] = vm.selected_affect;
                // vm.affected = polizaa
              }
            } else {
              $localStorage["save_created_siniester_life"]["selected_affect"] =
                vm.selected_affect;
            }
          }
        }
      }
      //Se ingresa el numero de poliza
      var polizaVal = polizaa;
      $scope.params = {
        num_poliza:
          vm.form.poliza && vm.form.poliza.value
            ? vm.form.poliza.value.num_poliza
            : vm.form.poliza
            ? vm.form.poliza
            : "",
        id_policy:
          vm.form.poliza && vm.form.poliza.value
            ? vm.form.poliza.value.id
            : vm.id_policy
            ? vm.id_policy
            : "",
      };
      dataFactory
        .get("buscar_afectado/", $scope.params) //ruta del back
        .then(
          function success(response) {
            //console.log("Busqueda",response)
            if (response.data.results != null) {
              //si el resultado de la consulta no es null
              //console.log("info",response.data.results)
              var resultado = response.data.results[0]; //guarda la informacion de la consulta
              //vm.selected_poliza = resultado.id
              if (
                resultado.document_type == 1 ||
                resultado.document_type == 6
              ) {
                //si el tipo de doc es poliza o certificado
                vm.show_caratula = false;
                vm.show_poliza = true;

                var titular = response.data.results[0].life_policy[0].personal;
                var beneficiarios =
                  response.data.results[0].life_policy[0].beneficiaries_life;

                //Guarda los datos del titular
                var obj = {
                  label:
                    titular.first_name +
                    " " +
                    titular.last_name +
                    " " +
                    titular.second_last_name +
                    " - TITULAR ",
                  value: {
                    id: resultado.id,
                    id_afectado: titular.id,
                    document_type: resultado.document_type,
                    relationship: 1,
                    title: titles[1],
                    birthdate: titular.birthdate,
                    full_name:
                      titular.first_name +
                      " " +
                      titular.last_name +
                      " " +
                      titular.second_last_name,
                    url: titular.url,
                  },
                };
                vm.affected.push(obj);

                beneficiarios.forEach(function (element) {
                  //recorre los elementos dentro de los beneficiarios
                  //Guarda los datos de los beneficiarios
                  obj = {
                    label:
                      element.first_name +
                      " " +
                      element.last_name +
                      " " +
                      element.second_last_name +
                      " - BENEFICIARIO ",
                    value: {
                      id: resultado.id,
                      id_afectado: element.id,
                      document_type: resultado.document_type,
                      relationship: element.relationship,
                      title: titles[element.relationship],
                      birthdate: element.birthdate,
                      full_name:
                        element.first_name +
                        " " +
                        element.last_name +
                        " " +
                        element.second_last_name,
                      url: element.url,
                    },
                  };

                  vm.affected.push(obj);
                });
                if ($localStorage.save_created_siniester_life) {
                  vm.selected_affect =
                    $localStorage["save_created_siniester_life"][
                      "selected_affect"
                    ] && $localStorage["save_created_siniester_life"]
                      ? $localStorage["save_created_siniester_life"][
                          "selected_affect"
                        ]
                      : vm.selected_affect
                      ? vm.selected_affect
                      : {};
                  LookFor();
                }
              } else if (resultado.document_type == 3) {
                vm.show_caratula = true;
                vm.show_poliza = false;
                vm.affected = [];
                vm.affected.length = 0;

                var obj = {
                  label: "",
                  value: {
                    id: resultado.id,
                    document_type: resultado.document_type,
                  },
                };
                vm.affected.push(obj);

                vm.selected_affect.value = vm.affected[0].value;
                if (!vm.carga_siniestro) {
                  LookFor();
                }
              }

              vm.affect_data = {};
            } else {
              SweetAlert.swal(
                "Error",
                "El Número de Poliza no es valido",
                "error"
              );
            }
          },

          function error(err) {
            console.log(err);
            //   SweetAlert.swal("Error","Ha ocurrido un error al obtener polizas siniestro","error");
          }
        )
        .catch(function (e) {
          console.log(e);
          //    SweetAlert.swal("Error","Ha ocurrido un error al obtener polizas siniestro","error");
        });
    }

    function saveSiniester() {
      if (vm.show_caratula_afectado) {
        if (
          vm.siniester_data.aux_affected == "" ||
          vm.siniester_data.aux_affected == undefined
        ) {
          SweetAlert.swal(
            "Dato requerido",
            "Debe agregar un beneficiario al siniestro de colectividad",
            "error"
          );
          return;
        }
      } else {
        if (!vm.selected_affect.val && !vm.selected_affect.value) {
          SweetAlert.swal("Asegurado", "Selecione un Asegurado", "error");
          return;
        }
      }
      if (!vm.affect_data.fecha_ingreso) {
        SweetAlert.swal(
          "Fecha emisión",
          "Agregue una Fecha de Emisión",
          "error"
        );
        return;
      }
      if (!vm.affect_data.siniester_date) {
        SweetAlert.swal(
          "Fecha en que ocurrio",
          "Agregue una Fecha de en que ocurrio",
          "error"
        );
        return;
      }
      if (!vm.siniester_type) {
        SweetAlert.swal(
          "Tipo de Siniestro",
          "Seleccione un Tipo de sinietsro",
          "error"
        );
        return;
      }
      if (!vm.siniester_pay_form) {
        SweetAlert.swal(
          "forma de Pago",
          "Seleccione una Forma de Pago",
          "error"
        );
        return;
      }
      // if (vm.afectados.length == 0) {
      //     SweetAlert.swal("Afectado","Debe agregar un afectado al siniestro","error");
      //     return
      // }else if (vm.afectados[0].nombre == undefined || vm.afectados[0].nombre == "" || !vm.afectados[0].nombre) {
      //     SweetAlert.swal("Nombre afectado","Debe agregar nombre de afectado","error");
      //     return
      // }

      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var obj_siniestro = {
        poliza: vm.selectedPoliza.data.url,
        aux_affected: vm.afectados.length
          ? vm.afectados[0].nombre
          : vm.siniester_data.aux_affected,
        status: vm.status.id,
        numero_siniestro: vm.siniester_data.siniester_number
          ? vm.siniester_data.siniester_number.label
          : "",
        fecha_siniestro: new Date(vm.affect_data.siniester_date),
        tipo_siniestro_general: 1,
        observations: vm.siniester_data.observations,
        fecha_ingreso: vm.affect_data.fecha_ingreso,
        vida_siniester: [
          {
            razon_siniestro: vm.siniester_type,
            tipo_pago: vm.siniester_pay_form,
            contacto_vida: vm.contacts,
            nombre_afectado: vm.afectados.length
              ? vm.afectados[0].nombre
              : null,
            parentesco_afectado: vm.afectados.length
              ? vm.afectados[0].parentesco
              : null,
          },
        ],
      };
      console.log("vidaaa", obj_siniestro, vm.siniester_data, vm.afectados);
      // l.stop();
      // return
      $http
        .post(url.IP + "siniestros-vida/", obj_siniestro)
        .then(function (siniestro) {
          l.stop();
          vm.beneficiaries.forEach(function (item) {
            $http
              .patch(item.url, { percentage: item.percentage })
              .then(function (siniestro) {});
          });
          PersistenceFactory.eliminar();
          $localStorage["save_created_siniester_life"] = {};
          vm.uploadFiles(siniestro.data.id);
          if (vm.selected_affect) {
            if (vm.selected_affect.label) {
              var params = {
                model: 1,
                event: "POST",
                associated_id: vm.selectedPoliza.data.id,
                identifier: "creó un siniestro.",
              };
              $scope.siniestro_info = siniestro.data;
              $scope.idSiniestro = siniestro.data.id;
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            } else {
              var params = {
                model: 18,
                event: "POST",
                associated_id: vm.selectedPoliza.data.id,
                identifier: "creó un siniestro.",
              };
              $scope.siniestro_info = siniestro.data;
              $scope.idSiniestro = siniestro.data.id;
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }
          }
          if ($scope.siniestro_info.poliza) {
            $http.get($scope.siniestro_info.poliza).then(function (response) {
              vm.infoSiniestro = {};
              vm.infoSiniestro.poliza = response.data;
              // Send Email
              // if (vm.infoSiniestro.poliza.contractor){
              //     $http.get(vm.infoSiniestro.poliza.contractor)
              //       .then(function(response) {
              //         if(response.data.email){
              //             // Send email
              //             if($localStorage.email_config){
              //                 if($localStorage.email_config.solicitud_siniestro == true){
              //                     var model = 3;
              //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
              //                 }
              //             }
              //             // Send Email
              //         }
              //     });
              // }
              //Send Email
            });
          }

          $scope.idSiniestro = siniestro.data.id;
          // fillTable(1);
          if ($scope.url !== "/index/main") {
            SweetAlert.swal(
              "Guardado",
              "Siniestro Guardado exitosamente",
              "success"
            );
            if ($scope.siniestro_info.poliza) {
              $http.get($scope.siniestro_info.poliza).then(function (response) {
                vm.infoSiniestro = {};
                vm.infoSiniestro.poliza = response.data;
                // Send Email
                // if (vm.infoSiniestro.poliza.contractor){
                //     $http.get(vm.infoSiniestro.poliza.contractor)
                //       .then(function(response) {
                //         if(response.data.email){
                //             // Send email
                //             if($localStorage.email_config){
                //                 if($localStorage.email_config.solicitud_siniestro == true){
                //                     var model = 3;
                //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                 }
                //             }
                //             // Send Email
                //         }
                //     });
                // }
                //Send Email
              });
            }
            $state.go("siniestros.vida_info", {
              siniestroId: $scope.idSiniestro,
            });
          } else {
            if ($uibModalInstance) {
              $uibModalInstance.dismiss("cancel");
            }
          }
        });
    }

    function LookFor(val) {
      var waitDiseases = [];
      vm.afectados = [
        {
          nombre: vm.selected_affect.value.url.full_name,
        },
      ];
      try {
        $http
          .get(
            url.IP + "leer-polizas-edit/" + vm.selected_affect.value.id + "/"
          )
          .then(function (poliza) {
            if (poliza.data.document_type == 3) {
              vm.show_caratula_afectado = true;
              SweetAlert.swal(
                "La póliza seleccionada es una carátula",
                "Tendrá que agregar un afectado manualmente.",
                "info"
              );
            } else {
              vm.show_caratula_afectado = false;
            }
            if (poliza.data.document_type == 6) {
              vm.selectedPoliza = poliza;
              ramoService
                .getSubramoById(poliza.data.subramo.id)
                .then(function (subramo) {
                  vm.siniester_data.subramo = subramo.data;
                });
              var data = {
                title: vm.selected_affect.value.title,
                policy_vigencia: new Date(poliza.data.end_of_validity),
                policy_vigencia_init: new Date(poliza.data.start_of_validity),
                siniester_date:
                  $localStorage["save_created_siniester_life"] &&
                  $localStorage["save_created_siniester_life"]["siniester_date"]
                    ? $localStorage["save_created_siniester_life"][
                        "siniester_date"
                      ]
                    : new Date(),
                fecha_ingreso:
                  $localStorage["save_created_siniester_life"] &&
                  $localStorage["save_created_siniester_life"]["fecha_ingreso"]
                    ? $localStorage["save_created_siniester_life"][
                        "fecha_ingreso"
                      ]
                    : new Date(),
                policy_number: poliza.data.parent.parent.parent.poliza_number,
              };
              if (vm.selected_affect.value.tittle_id == 1) {
                poliza.data.life_policy.forEach(function (titular) {
                  // $http.get(titular.personal).then(function(principal) {
                  $http.get(titular.personal.url).then(function (principal) {
                    data["birthdate"] = principal.data.birthdate;
                  });
                  vm.beneficiaries = titular.beneficiaries_life;
                });
              }
              var waitReceipt = [];
              if (poliza.data.parent.parent.recibos_poliza.lenght) {
                waitReceipt.push(
                  $http.get(
                    url.IP +
                      "get-current-receipt/" +
                      poliza.data.parent.parent.id
                  )
                );
              } else {
                waitReceipt.push(
                  $http.get(
                    url.IP +
                      "get-current-receipt/" +
                      poliza.data.parent.parent.parent.id
                  )
                );
              }
              $q.all(waitReceipt).then(function (response) {
                var status = response[0].data.status;
                data.policy_status = {};
                switch (status) {
                  case 1:
                    data.policy_status["label"] = "Pagado";
                    data.policy_status["id"] = status;
                    break;
                  case 2:
                    data.policy_status["label"] = "Cancelado";
                    data.policy_status["id"] = status;
                    break;
                  case 3:
                    data.policy_status["label"] = "Prorrogado";
                    data.policy_status["id"] = status;
                    break;
                  case 4:
                    data.policy_status["label"] = "Pendiente de pago";
                    data.policy_status["id"] = status;
                    break;
                  default:
                    data.policy_status["label"] = "Sin Estatus";
                    data.policy_status["id"] = status;
                }
              });
              if (poliza.data.parent.parent.contractor) {
                $http
                  .get(poliza.data.parent.parent.contractor)
                  .then(function (contratante) {
                    data["contractor_addres"] =
                      contratante.data.address_contractor[0].route +
                      " #" +
                      contratante.data.address_contractor[0].street_number +
                      " " +
                      contratante.data.address_contractor[0]
                        .administrative_area_level_2 +
                      " " +
                      contratante.data.address_contractor[0]
                        .administrative_area_level_1;
                    data["contratante"] = contratante.data;
                    data["contratante"].name = contratante.data.full_name;
                  });
              } else if (poliza.data.parent.parent.parent.contractor) {
                var contratante = poliza.data.parent.parent.parent.contractor;
                data["contractor_addres"] =
                  contratante.address_contractor[0].route +
                  " #" +
                  contratante.address_contractor[0].street_number +
                  " " +
                  contratante.address_contractor[0]
                    .administrative_area_level_2 +
                  " " +
                  contratante.address_contractor[0].administrative_area_level_1;
                data["contratante"] = contratante;
                data["contratante"].name = contratante.full_name;
              }
              // console.log('poliza.data.parent.parent.parent',poliza.data)
              if (poliza.data.parent.parent.parent) {
                if (poliza.data.parent.parent.parent.aseguradora) {
                  $http
                    .get(poliza.data.parent.parent.parent.url)
                    .then(function (pol) {
                      var url_prov = pol.data;
                      if (url_prov.aseguradora) {
                        $http
                          .get(url_prov.aseguradora)
                          .then(function (aseguradora) {
                            data["aseguradora"] = aseguradora.data;
                          });
                      }
                    });
                  // $http.get(poliza.data.parent.parent.parent.aseguradora).then(function(aseguradora) {
                  //     data['aseguradora'] =  aseguradora.data;
                  // });
                }
              }
              packageService
                .getPackageById(poliza.data.paquete.id)
                .then(function (paquete) {
                  data["paquete"] = paquete.data;
                });

              vm.affect_data = data;
            } else {
              vm.selectedPoliza = poliza;
              ramoService
                .getSubramoById(poliza.data.subramo.id)
                .then(function (subramo) {
                  vm.siniester_data.subramo = subramo.data;
                });
              var data = {
                title:
                  vm.selected_affect && vm.selected_affect.value
                    ? vm.selected_affect.value.title
                    : "",
                policy_vigencia: new Date(poliza.data.end_of_validity),
                policy_vigencia_init: new Date(poliza.data.start_of_validity),
                siniester_date:
                  $localStorage["save_created_siniester_life"] &&
                  $localStorage["save_created_siniester_life"]["siniester_date"]
                    ? $localStorage["save_created_siniester_life"][
                        "siniester_date"
                      ]
                    : new Date(),
                fecha_ingreso:
                  $localStorage["save_created_siniester_life"] &&
                  $localStorage["save_created_siniester_life"]["fecha_ingreso"]
                    ? $localStorage["save_created_siniester_life"][
                        "fecha_ingreso"
                      ]
                    : new Date(),
                policy_number: poliza.data.poliza_number,
              };
              if (vm.selected_affect.value.tittle_id == 1) {
                poliza.data.life_policy.forEach(function (titular) {
                  // $http.get(titular.personal).then(function(principal) {
                  if (titular.personal) {
                    $http.get(titular.personal.url).then(function (principal) {
                      data["birthdate"] = principal.data.birthdate;
                    });
                  }
                  vm.beneficiaries = titular.beneficiaries_life;
                });
                poliza.data.personal_life_policy.forEach(function (titular_p) {
                  // $http.get(titular_p.personal).then(function(principal) {
                  $http.get(titular_p.url).then(function (principal_life) {
                    data["birthdate"] = principal_life.data.birthdate;
                  });
                });
              }
              var waitReceipt = [];
              waitReceipt.push(
                $http.get(url.IP + "get-current-receipt/" + poliza.data.id)
              );
              $q.all(waitReceipt).then(function (response) {
                var status = response[0].data.status;
                data.policy_status = {};
                switch (status) {
                  case 1:
                    data.policy_status["label"] = "Pagado";
                    data.policy_status["id"] = status;
                    break;
                  case 2:
                    data.policy_status["label"] = "Cancelado";
                    data.policy_status["id"] = status;
                    break;
                  case 3:
                    data.policy_status["label"] = "Prorrogado";
                    data.policy_status["id"] = status;
                    break;
                  case 4:
                    data.policy_status["label"] = "Pendiente de pago";
                    data.policy_status["id"] = status;
                    break;
                  default:
                    data.policy_status["label"] = "Sin Estatus";
                    data.policy_status["id"] = status;
                }
              });
              if (poliza.data.contractor) {
                $http.get(poliza.data.contractor).then(function (contratante) {
                  data["contractor_addres"] =
                    contratante.data.address_contractor[0].route +
                    " #" +
                    contratante.data.address_contractor[0].street_number +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_2 +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_1;
                  data["contratante"] = contratante.data;
                  data["contratante"].name = contratante.data.full_name;
                });
              }
              providerService
                .getProviderById(poliza.data.aseguradora)
                .then(function (aseguradora) {
                  data["aseguradora"] = aseguradora.data;
                });
              if (poliza.data.paquete) {
                packageService
                  .getPackageById(poliza.data.paquete.id)
                  .then(function (paquete) {
                    data["paquete"] = paquete.data;
                  });
              }
              vm.affect_data = data;
              try {
                vm.afectados = [
                  {
                    nombre:
                      vm.selectedPoliza.data.life_policy[0].personal.full_name,
                  },
                ];
              } catch (u) {
                try {
                  vm.afectados = [
                    {
                      nombre:
                        vm.selectedPoliza.data.personal_life_policy[0].personal
                          .full_name,
                    },
                  ];
                } catch (u) {
                  vm.afectados = vm.afectados;
                }
              }
            }
          });
      } catch (err) {
        console.log("Error: " + err);
        // SweetAlert.swal("Error","Selecciona un Afectado valido","error");
      }
    }

    function fillTable(ramo_number) {
      vm.siniestros = [];
      $http
        .get(url.IP + "siniestros-infotable/" + ramo_number)
        .then(function (siniestros) {
          if (siniestros.data.results.length) {
            siniestros.data.results.forEach(function (siniestro) {
              vm.siniestros.push(siniestro);
            });
          }
        });
    }

    function activate() {
      vm.tmp_siniestro = angular.copy($rootScope.siniestro_tmp);
      vm.carga_siniestro = $rootScope.carga_siniestro;
      // console.log('vengo de allá ', $rootScope.siniestro_tmp, vm.carga_siniestro);
      if (vm.carga_siniestro) {
        // vm.selected_disease = parComplement.value.accidente[0];
        vm.siniester_data.observations = vm.tmp_siniestro.observations;

        vm.affect_data.siniester_date = vm.tmp_siniestro.fecha_siniestro;
        // vm.affect_data.fecha_ingreso = vm.tmp_siniestro.fecha_ingreso;

        if (
          vm.tmp_siniestro.vida_siniester &&
          vm.tmp_siniestro.vida_siniester.length
        ) {
          vm.siniester_type =
            vm.tmp_siniestro.vida_siniester[0].razon_siniestro;
          vm.siniester_pay_form =
            vm.tmp_siniestro.vida_siniester[0].razon_siniestro;
          if (
            vm.tmp_siniestro.vida_siniester[0].contacto_auto &&
            vm.tmp_siniestro.vida_siniester[0].contacto_auto.length
          ) {
            vm.contacts = vm.tmp_siniestro.vida_siniester[0].contacto_auto;
          }
        }

        if (vm.tmp_siniestro.poliza.document_type == 3) {
          vm.siniester_data.aux_affected = vm.tmp_siniestro.aux_affected;
          var label = "Carátula: " + vm.tmp_siniestro.poliza.poliza_number;
        } else {
          var label = "Póliza: " + vm.tmp_siniestro.poliza.poliza_number;
        }

        var ns = {
          label: vm.tmp_siniestro.numero_siniestro,
          value: 0,
        };
        vm.siniester_data.siniester_number = ns;
        // vm.siniester_data.observations = vm.tmp_siniestro.siniestro.observations
        // vm.affect_data.siniester_date = new Date(vm.tmp_siniestro.siniestro.fecha_siniestro)

        //  Falta cargar el asegurado al crearle un complemento al siniestro, numero de siniestro y forma de pago del siniestro

        // 'label':   vm.tmp_siniestro.accidente.ailment

        vm.isInicial = false;
        var obj = {
          label: label,
          val: label,
          value: {
            id: vm.tmp_siniestro.poliza_id,
            tittle_id: 1,
            name: vm.tmp_siniestro.poliza.poliza_number,
            url: undefined,
          },
        };
        vm.selected_affect = obj;
        console.log("vm.selected_affect", vm.selected_affect);
        LookFor();
      } else {
        updateStatus();
      }

      delete $rootScope.siniestro_tmp;
      $scope.fileSinister = true;
      window.scrollTo(0, 0);

      vm.selected_affect =
        $localStorage["save_created_siniester_life"] &&
        $localStorage["save_created_siniester_life"]["selected_affect"]
          ? $localStorage["save_created_siniester_life"]["selected_affect"]
          : vm.selected_affect
          ? vm.selected_affect
          : "";

      vm.siniester_data.aux_affected = $localStorage[
        "save_created_siniester_life"
      ]
        ? $localStorage["save_created_siniester_life"]["aux_affected"]
        : "";
      vm.affect_data.fecha_ingreso =
        $localStorage["save_created_siniester_life"] &&
        $localStorage["save_created_siniester_life"]["fecha_ingreso"]
          ? $localStorage["save_created_siniester_life"]["fecha_ingreso"]
          : "";
      vm.siniester_data.siniester_number = $localStorage[
        "save_created_siniester_life"
      ]
        ? $localStorage["save_created_siniester_life"]["siniester_number"]
        : "";
      vm.affect_data.siniester_date = $localStorage[
        "save_created_siniester_life"
      ]
        ? $localStorage["save_created_siniester_life"]["siniester_date"]
        : "";
      vm.siniester_type = $localStorage["save_created_siniester_life"]
        ? $localStorage["save_created_siniester_life"]["siniester_type"]
        : 0;
      vm.siniester_pay_form = $localStorage["save_created_siniester_life"]
        ? $localStorage["save_created_siniester_life"]["siniester_pay_form"]
        : 0;
      vm.status = $localStorage["save_created_siniester_life"]
        ? $localStorage["save_created_siniester_life"]["status"]
        : { id: 1, label: "Pendiente" };
      vm.contacts =
        $localStorage["save_created_siniester_life"] &&
        $localStorage["save_created_siniester_life"]["contacts"]
          ? $localStorage["save_created_siniester_life"]["contacts"]
          : [];
      vm.afectados =
        $localStorage["save_created_siniester_life"] &&
        $localStorage["save_created_siniester_life"]["afectados"]
          ? $localStorage["save_created_siniester_life"]["afectados"]
          : [];

      if ($localStorage["save_created_siniester_life"]) {
        if ($localStorage["save_created_siniester_life"]["selected_affect"]) {
          vm.LookFor();
        }
        if ($localStorage["save_created_siniester_life"]["fecha_ingreso"]) {
          vm.affect_data.fecha_ingreso =
            $localStorage["save_created_siniester_life"]["fecha_ingreso"];
        }
      }
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Archivos") {
            vm.permarch = perm;
            vm.permarch.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  vm.permiso_administrar_adjuntos = true;
                } else {
                  vm.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
        });
      }
    }

    if ("save_created_siniester_life" in $localStorage) {
    } else {
      $localStorage["save_created_siniester_life"] = {};
    }

    $scope.saveLocalstorange = function () {
      $localStorage["save_created_siniester_life"]["selected_affect"] =
        vm.selected_affect ? vm.selected_affect : {};
      $localStorage["save_created_siniester_life"]["aux_affected"] = vm
        .siniester_data.aux_affected
        ? vm.siniester_data.aux_affected
        : "";
      $localStorage["save_created_siniester_life"]["fecha_ingreso"] = vm
        .affect_data.fecha_ingreso
        ? vm.affect_data.fecha_ingreso
        : "";
      $localStorage["save_created_siniester_life"]["siniester_number"] = vm
        .siniester_data.siniester_number
        ? vm.siniester_data.siniester_number
        : 0;
      $localStorage["save_created_siniester_life"]["siniester_date"] = vm
        .affect_data.siniester_date
        ? vm.affect_data.siniester_date
        : "";
      $localStorage["save_created_siniester_life"]["siniester_type"] =
        vm.siniester_type ? vm.siniester_type : 0;
      $localStorage["save_created_siniester_life"]["siniester_pay_form"] =
        vm.siniester_pay_form ? vm.siniester_pay_form : 0;
      $localStorage["save_created_siniester_life"]["status"] = vm.status
        ? vm.status
        : { id: 1, label: "Pendiente" };
      $localStorage["save_created_siniester_life"]["contacts"] = vm.contacts
        ? vm.contacts
        : [];
      $localStorage["save_created_siniester_life"]["afectados"] = vm.afectados
        ? vm.afectados
        : [];
    };

    function showSubRamos(event) {
      vm.ramoId = event.target.id;
    }

    function textAExpand(event) {
      var element = e.target;
      var scroll = element.scrollHeight - 60; // <- Padding top and buttom sum
      element.style.height = scrollHeight + "px";
    }
    $scope.changeTypeDoc = function (padecimiento) {
      $scope.padecimiento_type = padecimiento;
    };
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      // var date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
      // return date;
      var date = inputFormat;
      if (inputFormat.length != 10) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }
      }
      return date;
    }
    $scope.habuscado = false;
    function updateStatus(param) {
      vm.affected = [];
      $scope.afectado_vida = param;
      var word_data = param && param.val ? param.val : param;
      $scope.habuscado = true;
      if (word_data) {
        if (word_data.length >= 3) {
          var word = word_data.split(" ").join("_");
          if ($scope.val) {
            var word = $scope.val;
            var word = word.split(" ").join("_");
          }
          insuranceService
            .getInsurances_by_ramo(1, word)
            .then(function (polizas) {
              polizas.forEach(function (poliza) {
                if (
                  poliza.document_type == 1 &&
                  (poliza.status == 10 ||
                    poliza.status == 12 ||
                    poliza.status == 14 ||
                    poliza.status == 13 ||
                    poliza.status == 15)
                ) {
                  if (poliza.document_type == 1) {
                    poliza.life_policy.forEach(function (titular) {
                      // $http.get(titular.personal).then(function(name) {
                      if (titular.personal) {
                        $http.get(titular.personal.url).then(function (name) {
                          var obj = {
                            label:
                              name.data.first_name +
                              " " +
                              name.data.last_name +
                              " " +
                              name.data.second_last_name +
                              "   -   " +
                              "poliza: " +
                              poliza.poliza_number +
                              " - Vigencia: " +
                              convertDate(new Date(poliza.start_of_validity)) +
                              " - " +
                              convertDate(new Date(poliza.end_of_validity)),
                            val:
                              name.data.first_name +
                              " " +
                              name.data.last_name +
                              " " +
                              name.data.second_last_name +
                              "   -   " +
                              "poliza: " +
                              poliza.poliza_number +
                              " - Vigencia: " +
                              convertDate(new Date(poliza.start_of_validity)) +
                              " - " +
                              convertDate(new Date(poliza.end_of_validity)),
                            value: {
                              id: poliza.id,
                              title: titles[1],
                              tittle_id: 1,
                              name: name.data.first_name,
                              url: titular.personal,
                            },
                          };

                          vm.affected.push(obj);
                        });
                      }
                    });
                    if (poliza.personal_life_policy.length > 0) {
                      poliza.personal_life_policy.forEach(function (ptitular) {
                        // $http.get(ptitular.personal).then(function(name) {
                        $http.get(ptitular.url).then(function (name) {
                          // vm.affected = []
                          var obj = {
                            label:
                              name.data.first_name +
                              " " +
                              name.data.last_name +
                              " " +
                              name.data.second_last_name +
                              "   -   " +
                              "poliza: " +
                              poliza.poliza_number +
                              " - Vigencia: " +
                              convertDate(new Date(poliza.start_of_validity)) +
                              " - " +
                              convertDate(new Date(poliza.end_of_validity)),
                            val:
                              name.data.first_name +
                              " " +
                              name.data.last_name +
                              " " +
                              name.data.second_last_name +
                              "   -   " +
                              "poliza: " +
                              poliza.poliza_number +
                              " - Vigencia: " +
                              convertDate(new Date(poliza.start_of_validity)) +
                              " - " +
                              convertDate(new Date(poliza.end_of_validity)),
                            value: {
                              id: poliza.id,
                              title: titles[1],
                              tittle_id: 1,
                              name: name.data.first_name,
                              url: ptitular.url,
                            },
                          };
                          // console.log('----x---mults pers life------',vm.affected)
                          vm.affected.push(obj);
                        });
                      });
                    }
                  }
                } else if (poliza.document_type == 6) {
                  poliza.life_policy.forEach(function (titular) {
                    // $http.get(titular.personal).then(function(name) {
                    $http.get(titular.personal.url).then(function (name) {
                      if (poliza.parent.parent.parent.poliza_number) {
                        var label_poliza =
                          poliza.parent.parent.parent.poliza_number;
                      } else {
                        var label_poliza =
                          poliza.parent.parent.parent.identifier;
                      }
                      var obj = {
                        label:
                          name.data.first_name +
                          " " +
                          name.data.last_name +
                          " " +
                          name.data.second_last_name +
                          "   -   " +
                          "poliza: " +
                          poliza.poliza_number +
                          " - Vigencia: " +
                          convertDate(new Date(poliza.start_of_validity)) +
                          " - " +
                          convertDate(new Date(poliza.end_of_validity)),
                        value: {
                          id: poliza.id,
                          title: titles[1],
                          tittle_id: 1,
                          name: name.data.first_name,
                          url: titular.personal,
                        },
                      };
                      function findCoincidences(argument) {
                        return argument.value.id === obj.value.id;
                      }

                      if (!vm.affected.find(findCoincidences)) {
                        vm.affected.push(obj);
                      }
                    });
                  });
                }
              });
              // $scope.habuscado = false
            });
        }
      } else {
        vm.affected.length = 0;
      }
    }

    //-- Peticion de persistencia--//
    // console.log('Persistence Siniestros Vida');
    var json_data = {};
    var form = document.getElementsByTagName("form");
    var adiccional = vm.selected_affect ? vm.selected_affect.val : ""; //angular.element('[model="vm.selected_affect"]')//document.getElementById("autocomplete");

    var elementos = {};
    //Valores reutilizables
    var interval, interval1, form_dt, valor, dt;
    var count = 0;
    var break_for = false;

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function set_dataForm(json) {
      PersistenceFactory.set_inputs(json);

      if (
        json["vm.selected_affect.val"] &&
        json["vm.selected_affect.val"] != ""
      ) {
        dt = json["vm.selected_affect.val"];
        vm.selected_affect.val = dt.nombre.substr(0, 10);
        vm.updateStatus();

        interval1 = setInterval(function () {
          if (vm.affected.length > 0) {
            clearInterval(interval1);
            angular.forEach(vm.affected, function (v, a) {
              if (v.value.id == dt.id && break_for == false) {
                vm.selected_affect = v;
                LookFor();
                Seguir();
                break_for = true;
              }
            });
            clearInterval(interval1);
          }
        }, 1000);
      }

      function Seguir() {
        if (json["vm.affect_data.fecha_ingreso"] != "") {
          valor = angular.element('[ng-model="vm.affect_data.fecha_ingreso"]');
          valor.val("");
        }

        if (json["vm.siniester_type"] != "") {
          vm.siniester_type = PersistenceFactory.changeInt(
            json["vm.siniester_type"]
          );
        }

        if (json["vm.siniester_pay_form"] != "") {
          vm.siniester_pay_form = PersistenceFactory.changeInt(
            json["vm.siniester_pay_form"]
          );
        }
      }
    }

    interval = setInterval(function () {
      if (form != undefined && PersistenceFactory.count == 0) {
        PersistenceFactory.inicial(
          usr.org,
          "Siniestro_Vida",
          usr.nameFull,
          PersistenceFactory.get_dataForm(form)
        );
      }
      if (
        PersistenceFactory.init_return != "" &&
        PersistenceFactory.init_return != undefined
      ) {
        clearInterval(interval);
        if (PersistenceFactory.init_return.status == "data_view") {
          set_dataForm(PersistenceFactory.json_return);
        }
        PersistenceFactory.interval = setInterval(function () {
          PersistenceFactory.editado(
            PersistenceFactory.get_dataForm(form, vm.selected_affect.val)
          );
        }, PersistenceFactory.intervalTime); /* /* */
      }
    }, 1000);
    //-- End Peticion de persistencia--//
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("SiniestrosTableCtrl", SiniestrosTableCtrl);

  SiniestrosTableCtrl.$inject = [
    "SweetAlert",
    "providerService",
    "dataFactory",
    "datesFactory",
    "$scope",
    "$http",
    "$parse",
    "$state",
    "url",
    "$sessionStorage",
  ];

  function SiniestrosTableCtrl(
    SweetAlert,
    providerService,
    dataFactory,
    datesFactory,
    $scope,
    $http,
    $parse,
    $state,
    url,
    $sessionStorage
  ) {
    var vm = this;

    vm.ramos = {};
    vm.ramos.ramo_selected = 2;
    vm.actual_tab = 1;
    vm.form = {
      provider: "",
      ramo: 0,
      since: datesFactory.convertDate(new Date()),
      until: datesFactory.convertDate(new Date()),
      contratante: 0,
      group: 0,
      num_poliza: "",
      dates: 2,
      afectado: "",
      num_sinister: "",
    };
    vm.ramos.options = [
      { id: 2, label: "Accidentes y Enfermedades" },
      { id: 3, label: "Autómoviles" },
      { id: 1, label: "Vida" },
      { id: 4, label: "Daños" },
    ];

    vm.table = {
      headers: [
        "Afectado",
        "Contratante",
        "Aseguradora",
        "Número de siniestro",
        "Padecimiento",
        "Reclamado",
        "Subramo",
        "Acciones",
        "Número de póliza",
        "Razón",
      ],
    };

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.addFilter = addFilter;
    vm.matchesContractors = matchesContractors;
    vm.getSinisters = getSinisters;
    vm.goToSinister = goToSinister;
    vm.deleteSin = deleteSin;
    vm.addSiniestro = addSiniestro;
    vm.changeSiniesterA = changeSiniesterA;
    vm.clearInput = clearInput;
    vm.exportToExcel = exportToExcel;
    vm.showBinnacle = showBinnacle;

    activate();
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Siniestros") {
          vm.acceso_sin = perm;
          vm.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                vm.acceso_adm_sin = true;
              } else {
                vm.acceso_adm_sin = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        }
      });
    }
    function activate() {
      providerService.getReadListProviders().then(function (data) {
        vm.providers = data;
      });
      vm.changeRamo(2);
    }
    vm.show_binnacle = false;
    function showBinnacle(param) {
      vm.comments_data = {};
      vm.comments_config = {};
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 5,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      vm.show_binnacle = true;
      vm.siniester_id = param.id;
    }

    function addSiniestro(ramo_code) {
      if (ramo_code) {
        if (ramo_code == 1) {
          $state.go("siniestros.vida");
        } else if (ramo_code == 2) {
          $state.go("siniestros.accidentes");
        } else if (ramo_code == 3) {
          $state.go("siniestros.autos");
        } else if (ramo_code == 4) {
          $state.go("siniestros.danios");
        }
      }
    }

    function changeProvider(obj) {
      if (!obj) {
        vm.ramosProvider = [];
        vm.form.provider = 0;
        return;
      }
      dataFactory.get("ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.ramosProvider = ramos.data;
      });
    }
    function clearInput(obj) {
      if (obj == vm.form.afectado) {
        vm.form.afectado = "";
      } else if (obj == vm.form.num_poliza) {
        vm.form.num_poliza = "";
      } else if (obj == vm.form.num_sinister) {
        vm.form.num_sinister = "";
      }
    }

    function changeRamo(param) {
      var ramo = { ramo_code: vm.ramos.ramo_selected };
      dataFactory
        .get("siniestros-conteos/", ramo)
        .then(function success(response) {
          vm.conteos = response.data;
        });
      vm.getSinisters(1, 1, vm.ramos.ramo_selected, 1);
    }

    function addFilter(param) {
      if (param == 1) {
        $scope.fechasFilter = true;
        vm.form.dates = 1;
      } else {
        $scope.fechasFilter = false;
        vm.form.dates = 2;
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          dataFactory
            .post("contractors-match/", { matchWord: parWord })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                // var juridicals = response.data.juridicals;
                // var naturals = response.data.naturals;

                // if(juridicals.length) {
                //   juridicals.forEach(function(item) {
                //     var obj = {
                //       label: item.j_name,
                //       value: item.id,
                //       type: 2
                //     };
                //     source.push(obj)
                //   });
                // } else if(naturals.length) {
                //   naturals.forEach(function(item) {

                //     if(item.full_name) {
                //       var obj = {
                //         label: item.full_name,
                //         value: item.id,
                //         type: 1
                //       };

                //     } else {
                //      var obj = {
                //         label: item.first_name+' '+ item.last_name+' '+ item.second_last_name,
                //         value: item.id,
                //         type: 1
                //       };
                //     }

                //     source.push(obj)
                //   });
                // }
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    console.log("itemddddd", item);
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type: item.type_person,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type: item.type_person,
                      };
                    }
                    source.push(obj);
                  });
                }

                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }
    function changeSiniesterA(par, asc, ramo, status) {
      switch (par) {
        case 1:
          vm.getSinisters(par, asc, ramo, status);
          vm.sin_afect_asc = asc;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_fingreso_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_npol_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 2:
          vm.getSinisters(par, asc, ramo, status);
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = asc;
          vm.sin_aseg_asc = 0;
          vm.sin_fingreso_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_npol_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 3:
          vm.getSinisters(par, asc, ramo, status);
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = asc;
          vm.sin_fingreso_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_npol_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 4:
          vm.getSinisters(par, asc, ramo, status);
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_fingreso_asc = asc;
          vm.sin_nsin_asc = 0;
          vm.sin_npol_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 5:
          vm.getSinisters(par, asc, ramo, status);
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_fingreso_asc = 0;
          vm.sin_nsin_asc = asc;
          vm.sin_npol_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 6:
          vm.getSinisters(par, asc, ramo, status);
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_fingreso_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_npol_asc = asc;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 7:
          vm.getSinisters(par, asc, ramo, status);
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_fingreso_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_npol_asc = 0;
          vm.sin_pad_asc = asc;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 8:
          vm.getSinisters(par, asc, ramo, status);
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_fingreso_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_npol_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = asc;
          vm.sin_subr_asc = 0;
          break;
        case 9:
          vm.getSinisters(par, asc, ramo, status);
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_fingreso_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_npol_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = asc;
          break;
      }
    }
    function getSinisters(order, asc, ramo, status) {
      if (ramo == 2) {
        //Accidentes
        var filtros = {
          status: status,
          ramo_number: ramo,
          order: order ? order : 1,
          asc: asc ? asc : 1,
          provider: vm.form.provider ? vm.form.provider.id : 0,
          contratante: 0,
          poliza_number: vm.form.num_poliza ? vm.form.num_poliza : 0,
          afectado: vm.form.afectado ? vm.form.afectado : 0,
          dates: vm.form.dates,
          since: vm.form.since + " " + "00:00:00",
          until: vm.form.until + " " + "23:59:59",
          num_siniestro: vm.form.num_sinister ? vm.form.num_sinister : 0,
        };
      } else if (ramo == 1) {
        //Vida
        var filtros = {
          status: status,
          ramo_number: ramo,
          order: order ? order : 1,
          asc: asc ? asc : 1,
          provider: vm.form.provider ? vm.form.provider.id : 0,
          contratante: 0,
          poliza_number: vm.form.num_poliza ? vm.form.num_poliza : 0,
          afectado: 0,
          dates: vm.form.dates,
          since: vm.form.since + " " + "00:00:00",
          until: vm.form.until + " " + "23:59:59",
          num_siniestro: vm.form.num_sinister ? vm.form.num_sinister : 0,
        };
      } else if (ramo == 3) {
        //Daños
        var filtros = {
          status: status,
          ramo_number: ramo,
          order: order ? order : 1,
          asc: asc ? asc : 1,
          provider: vm.form.provider ? vm.form.provider.id : 0,
          contratante: 0,
          poliza_number: vm.form.num_poliza ? vm.form.num_poliza : 0,
          afectado: 0,
          dates: vm.form.dates,
          since: vm.form.since + " " + "00:00:00",
          until: vm.form.until + " " + "23:59:59",
          num_siniestro: vm.form.num_sinister ? vm.form.num_sinister : 0,
        };
      } else if (ramo == 4) {
        //Daños - No auto
        var filtros = {
          status: status,
          ramo_number: ramo,
          order: order ? order : 1,
          asc: asc ? asc : 1,
          provider: vm.form.provider ? vm.form.provider.id : 0,
          contratante: vm.form.contratante.val ? vm.form.contratante.value : 0,
          type_person: vm.form.contratante.val ? vm.form.contratante.type : 0,
          poliza_number: vm.form.num_poliza ? vm.form.num_poliza : 0,
          afectado: 0,
          dates: vm.form.dates,
          since: vm.form.since + " " + "00:00:00",
          until: vm.form.until + " " + "23:59:59",
          num_siniestro: vm.form.num_sinister ? vm.form.num_sinister : 0,
        };
      }
      $scope.filtros = filtros;
      dataFactory
        .get("siniestros-infotable/", filtros)
        .then(function success(request) {
          vm.siniestros = [];
          vm.siniestros = request.data.results;
          vm.siniestros_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
          vm.show_pag_policy = true;

          testPagination("vm.siniestros", "vm.siniestros_config");

          vm.siniestros.forEach(function (siniestro) {
            if (siniestro.poliza.document_type == 6) {
              siniestro.cover_aseguradora =
                siniestro.poliza.parent.parent.parent.aseguradora;
            }
          });
        });
    }

    function exportToExcel(order, asc, ramo, status) {
      $http({
        method: "POST",
        url: url.IP + "report-sinister-excel",
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function (data, status, headers, config) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Siniestros.xls");
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }

    function deleteSin(siniestro) {
      $http.delete(siniestro.url).then(function success(response) {
        SweetAlert.swal("Eliminado", "Se ha eliminado el siniestro", "success");
        vm.getSinisters(1, 1, vm.ramos.ramo_selected, vm.actual_tab);
      });
    }

    function goToSinister(ramo, sinId) {
      if (ramo == 1) {
        $state.go("siniestros.vida_info", { siniestroId: sinId });
      } else if (ramo == 2) {
        $state.go("siniestros.info", { siniestroId: sinId });
      } else if (ramo == 3) {
        $state.go("siniestros.auto_info", { siniestroId: sinId });
      } else if (ramo == 4) {
        $state.go("siniestros.danio_info", { siniestroId: sinId });
      }
    }

    function testPagination(parModel, parConfig) {
      // console.log('dddddd');
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      //console.log('pages', config_);

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }
      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;

            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              // console.log('param', params);
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&status=") !== -1) {
              var status = prev_.substring(prev_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              // console.log('param', params);
              url += "&" + params + "&";
            }
          }
        }

        // url += '&status=1
        getSinisterPag(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      // console.log('id', $scope.id);
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getSinisterPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("SiniestrosTableCtrlV", SiniestrosTableCtrlV);

  SiniestrosTableCtrlV.$inject = [
    "$sessionStorage",
    "packageService",
    "providerService",
    "$state",
    "SweetAlert",
    "$q",
    "toaster",
    "$localStorage",
    "FileUploader",
    "insuranceService",
    "SiniestroService",
    "$scope",
    "$uibModal",
    "ramoService",
    "$http",
    "url",
    "helpers",
    "$parse",
    "exportFactory",
  ];

  function SiniestrosTableCtrlV(
    $sessionStorage,
    packageService,
    providerService,
    $state,
    SweetAlert,
    $q,
    toaster,
    $localStorage,
    FileUploader,
    insuranceService,
    SiniestroService,
    $scope,
    $uibModal,
    ramoService,
    $http,
    url,
    helpers,
    $parse,
    exportFactory
  ) {
    var vm = this;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    vm.ramos = {};
    vm.ramos.ramo_selected = 2;
    vm.ramos.options = [
      { id: 2, label: "Accidentes y Enfermedades" },
      { id: 3, label: "Daños" },
      { id: 1, label: "Vida" },
      { id: 4, label: "Daños - No auto" },
    ];
    vm.ramo_changed = ramo_changed;
    vm.table = {};
    vm.changeSiniesterA = changeSiniesterA;
    vm.changeSiniesterV = changeSiniesterV;

    vm.showBackButton = false;
    vm.showComments = true;

    activate();

    function ramo_changed() {
      getSinister(vm.ramos.ramo_selected, 1, 1, 1);
      $scope.ramo = vm.ramos.ramo_selected;
    }

    // $scope.ramo_selected = vm.ramos.ramo_selected;
    vm.search = search;
    vm.getSinister = getSinister;
    vm.showBinnacle = showBinnacle;
    vm.returnToReceipts = returnToReceipts;

    //----------------PAGINACIÓN 2, 1 ---------
    vm.buttonReportG = false;
    vm.buttonReportAu = false;
    vm.buttonReport = false;
    vm.table = {
      headers: [
        "Afectado",
        "Contratante",
        "Aseguradora",
        "Número de siniestro",
        "Padecimiento",
        "Reclamado",
        "Subramo",
        "Acciones",
        "Número de póliza",
        "Razón",
      ],
    };
    function changeSiniesterA(par, asc) {
      switch (par) {
        case 1:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_afect_asc = asc;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 2:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_cont_asc = asc;
          vm.sin_afect_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 3:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_aseg_asc = asc;
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 4:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_nsin_asc = asc;
          vm.sin_cont_asc = 0;
          vm.sin_afect_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 5:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_pad_asc = asc;
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_recl_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 6:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_recl_asc = asc;
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_subr_asc = 0;
          break;
        case 7:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_subr_asc = asc;
          vm.sin_afect_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_nsin_asc = 0;
          vm.sin_pad_asc = 0;
          vm.sin_recl_asc = 0;
          break;
      }
    }
    function changeSiniesterV(par, asc) {
      switch (par) {
        case 1:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_subr_asc = asc;
          vm.sin_nump_asc = 0;
          vm.sin_nums_asc = 0;
          vm.sin_affe_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_raz_asc = 0;
          break;
        case 2:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_nump_asc = asc;
          vm.sin_subr_asc = 0;
          vm.sin_nums_asc = 0;
          vm.sin_affe_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_raz_asc = 0;
          break;
        case 3:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_nums_asc = asc;
          vm.sin_subr_asc = 0;
          vm.sin_nump_asc = 0;
          vm.sin_affe_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_raz_asc = 0;
          break;
        case 4:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_affe_asc = asc;
          vm.sin_nump_asc = 0;
          vm.sin_subr_asc = 0;
          vm.sin_nums_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_raz_asc = 0;
          break;
        case 5:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_cont_asc = asc;
          vm.sin_subr_asc = 0;
          vm.sin_nump_asc = 0;
          vm.sin_nums_asc = 0;
          vm.sin_affe_asc = 0;
          vm.sin_aseg_asc = 0;
          vm.sin_raz_asc = 0;
          break;
        case 6:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_aseg_asc = asc;
          vm.sin_subr_asc = 0;
          vm.sin_nump_asc = 0;
          vm.sin_nums_asc = 0;
          vm.sin_affe_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_raz_asc = 0;
          break;
        case 7:
          getSinister($scope.ramo, $scope.param, par, asc);
          vm.sin_aseg_asc = 0;
          vm.sin_subr_asc = 0;
          vm.sin_nump_asc = 0;
          vm.sin_nums_asc = 0;
          vm.sin_affe_asc = 0;
          vm.sin_cont_asc = 0;
          vm.sin_raz_asc = asc;
          break;
      }
    }

    function getSinister(ramo_number, param, order, asc) {
      $scope.ramo = ramo_number;
      $scope.param = param;
      $scope.param = param;
      if (ramo_number == 1) {
        vm.buttonReport = true;
        vm.buttonReportG = false;
        vm.buttonReportAu = false;
      }
      if (ramo_number == 2) {
        vm.buttonReportG = true;
        vm.buttonReportAu = false;
        vm.buttonReport = false;
      }
      if (ramo_number == 3) {
        vm.buttonReportAu = true;
        vm.buttonReport = false;
        vm.buttonReportG = false;
      }

      $scope.filtros = {
        status: param,
        ramo_number: ramo_number,
        order: order,
        asc: asc,
      };
      if (ramo_number == 1 || ramo_number == 3) {
        $http({
          method: "GET",
          url: url.IP + "siniestros-infotable/",
          params: $scope.filtros,
        })
          .then(function success(request) {
            if (param < 6) {
              vm.loading = false;
              vm.siniestros = [];
              vm.siniestros_config = {};
              vm.siniestros = request.data.results;
              vm.siniestros_config = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              vm.show_pag_policy = true;

              testPagination("vm.siniestros", "vm.siniestros_config");
            }
            vm.siniestros.forEach(function (siniestro) {
              if (siniestro.poliza.document_type == 6) {
                siniestro.cover_aseguradora =
                  siniestro.poliza.parent.parent.parent.aseguradora;
              }
            });
            function error(error) {
              console.log("error", error);
            }
          })
          .catch(function (e) {
            console.log(e);
          });
      } else {
        $http({
          method: "GET",
          url: url.IP + "accidentes-infotable/",
          params: $scope.filtros,
        })
          .then(function success(request) {
            if (param < 7) {
              vm.loading = false;
              vm.siniestros = [];
              vm.siniestros_config = {};
              vm.siniestros = request.data.results;
              vm.siniestros_config = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              vm.show_pag_policy = true;

              testPagination("vm.siniestros", "vm.siniestros_config");
            }
            vm.siniestros.forEach(function (siniestro) {
              if (siniestro.poliza.document_type == 6) {
                siniestro.cover_aseguradora =
                  siniestro.poliza.parent.parent.parent.aseguradora;
                // $http.get(siniestro.poliza.parent.parent.parent.aseguradora).then(function success(aseguradora) {
                //   siniestro.cover_aseguradora = aseguradora.data.alias;
                // })
              }
            });

            function error(error) {
              console.log("error", error);
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
        //}
      }
    }
    //----------------PAGINACIÓN-----------

    vm.exportDatasiniester = exportDatasiniester;
    var ramo_number = $scope.ramo_selected;
    function exportDatasiniester(ramo_number) {
      if (vm.buttonReport == true || vm.buttonReportAu == true) {
        if (ramo_number == 1 || ramo_number == 3) {
          $http({
            method: "GET",
            url: url.IP + "reporte-siniestros-modulo/",
            params: $scope.filtros,
          })
            .then(
              function success(request) {
                if (request.status === 200) {
                  exportFactory.excel(request.data, "Siniestros");
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log(e);
            });
        }
      }
      if (vm.buttonReportG == true) {
        if (ramo_number == 2) {
          $http({
            method: "GET",
            url: url.IP + "reporte-siniestros-modulo/",
            params: $scope.filtros,
          })
            .then(
              function success(request) {
                if (request.status === 200) {
                  exportFactory.excel(request.data, "Siniestros");
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log(e);
            });
        }
      }
    }

    function search(cadena) {
      $http({
        method: "POST",
        url: url.IP + "seeker-sinisters/",
        data: {
          cadena: cadena,
          org: usr.org,
        },
      })
        .then(
          function success(request) {
            vm.siniestros = request.data;
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }
    $scope.responsiv = function () {
      $("#pendiente").trigger("resize");
      $("#tramite").trigger("resize");
      $("#cancelado").trigger("resize");
      $("#rechazado").trigger("resize");
      $("#completado").trigger("resize");
    };
    $scope.exportData = function (siniestros) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        }
      );
      saveAs(blob, "Reporte_" + siniestros + ".xls");
    };

    function activate() {
      getSinister(2, 1, 1, 1);
      $http({
        method: "GET",
        url: url.IP + "siniestros-conteos/",
      }).then(function success(response) {
        vm.conteos = response.data;
      });
    }

    function returnToReceipts() {
      vm.show_binnacle = false;
    }

    function showBinnacle(param) {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 5,
          id_model: param.id,
        },
      })
        .then(function (request) {
          // console.log('requestkñlñkñlkñlkñlkñlkñl', request);
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.show_binnacle = true;
      vm.siniester_id = param.id;
    }

    //------------Test Pagination 1----------
    function testPagination(parModel, parConfig) {
      // console.log('dddddd');
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      //console.log('pages', config_);

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }
      $scope.selectPage = function (parPage) {
        //   if(config_.next || config_.previous) {

        //     if(config_.next) {
        //       var next_ = config_.next;

        //       if((next_.search('&status=') !== -1) && (next_.search('&ramo_number=') !== -1)){
        //         var status = next_.substring(next_.indexOf("&status=") + 1);
        //         var ramo_number = next_.substring(next_.indexOf("&ramo_number=")+1);
        //       } else {
        //         var status = '';
        //         var ramo_number = '';
        //       }

        //       var url = config_.next.substring(0, config_.next.indexOf("&page=") + 6);
        //       url += parPage.toString();
        //       url += '&'+status
        //       url += '&'+ramo_number

        //     } else {
        //       var prev_ = config_.previous;
        //       if((config_.previous.search('&status=') !== -1) && (config_.previous.search('&ramo_number=') !== -1)) {
        //         var status = config_.previous.substring(config_.previous.indexOf("&status=") + 1);
        //         var ramo_number = config_.previous.substring(config_.previous.indexOf("&ramo_number=") + 1);
        //       } else {
        //         var status = '';
        //         var ramo_number = '';
        //       }

        //       if(config_.previous.search('&page=') !== -1) {
        //         var url = config_.previous.substring(0, config_.previous.indexOf("&page=") + 6);
        //         url += parPage.toString();
        //         url += '&'+status;
        //         url += '&'+ramo_number

        //       } else {
        //         var url = config_.previous
        //       }
        //     }
        //   }

        //   // url += '&status=1'
        //   getSinisterPag(url);
        //   $scope.actual_page = parPage;
        //   if($scope.actual_page > 1) {
        //     $scope.not_prev = false;
        //   }

        //   if($scope.actual_page == $scope.totalPages.length -1) {
        //     $scope.not_next = true;
        //   }

        // };
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;

            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              // console.log('param', params);
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&status=") !== -1) {
              var status = prev_.substring(prev_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              // console.log('param', params);
              url += "&" + params + "&";
            }
          }
        }

        // url += '&status=1
        getSinisterPag(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      // console.log('id', $scope.id);
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getSinisterPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }
    //----------TesPagination--------------
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("SiniestrosPlantillasCtrl", SiniestrosPlantillasCtrl);

  SiniestrosPlantillasCtrl.$inject = [
    "$timeout",
    "$scope",
    "$sce",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "$sessionStorage",
    "$uibModal",
    "textAngularManager",
    "FileUploader",
    "$rootScope",
  ];

  function SiniestrosPlantillasCtrl(
    $timeout,
    $scope,
    $sce,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    $sessionStorage,
    $uibModal,
    textAngularManager,
    FileUploader,
    $rootScope
  ) {
    var vm = this;
    $scope.showQuotation = false;
    $scope.showInfoQuotation = false;
    $scope.showEditInformation = false;
    $scope.plantilla = {};
    $scope.savingPlantilla = false;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.configuracionGlobal = {
      fecha_limite_email: false,
    };
    $(".js-example-basic-multiple").select2();
    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    $scope.allRamos = [];
    $scope.allRamos = [
      {
        code: 1,
        descr: "Vida",
      },
      {
        code: 2,
        descr: "Accidentes y Enfermedades",
      },
      {
        code: 3,
        descr: "Daños",
      },
      {
        code: 9,
        descr: "Daños/Automóviles",
      },
    ];
    $scope.createQuotation = function () {
      $scope.plantilla = {};
      $scope.showEditInformation = false;
      $scope.showQuotation = true;
      $scope.plantilla.subject_default = false;
    };
    $scope.subject_default = false;
    $scope.closeTemplate = function () {
      $scope.showQuotation = false;
      $scope.plantilla = {};
    };
    $scope.isReadOnly = true;
    activate();

    $scope.cambiarCampos = function () {
      $scope.configuracionGlobal = {};
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
        }
      });
      $scope.configurar = !$scope.configurar;
    };
    $scope.cambiarDato = function (dato, valor) {
      var data = {};
      data[dato.toString()] = valor;
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, data)
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory.post("orginfo/", data).then(function success(response) {
            if (response.status == 201) {
              $scope.configuracionGlobal = response.data;
              SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
              return;
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
            } else {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            }
          });
        }
      }
    };
    function activate() {
      dataFactory
        .get("emailtemplate/", { template_model: 4 })
        .then(function success(response) {
          vm.quotations = response.data.results;
          vm.config_pagination = response.data;
          $scope.show_pagination = true;
        });
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
        }
      });
    }

    $scope.selectProv = function (sel) {
      $scope.ramos_code = [];
      $scope.plantilla.ramo_code.forEach(function (cl) {
        $scope.ramos_code.push(parseInt(cl.code));
      });
    };

    function isBlankText(html) {
      if (!html) {
        return true;
      }
      var stripped = html.replace(/<[^>]+>/g, "");
      stripped = stripped.replace(/&nbsp;/g, "");
      stripped = stripped.replace(/\s/g, "");
      return stripped.length === 0;
    }

    $scope.showInformation = function (item) {
      if (item) {
        $scope.showInfoQuotation = !$scope.showInfoQuotation;
        $scope.quotation = item;
      } else {
        $scope.showInfoQuotation = !$scope.showInfoQuotation;
      }
    };

    $scope.saveDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (
        !form ||
        !form.name ||
        !$scope.ramos_code ||
        !$scope.ramos_code.length ||
        (!form.subject_default && !form.title) ||
        !form.text ||
        !form.bottom_text
      ) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de continuar.",
          "warning"
        );
        return;
      }

      if (isBlankText(form.text) || isBlankText(form.bottom_text)) {
        SweetAlert.swal(
          "Error",
          "El texto superior e inferior no pueden estar vacíos.",
          "warning"
        );
        return;
      }

      form.template_model = 4;
      form.ramo_code = $scope.ramos_code;
      $scope.savingPlantilla = true;

      dataFactory
        .post("emailtemplate/", form)
        .then(function success(response) {
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla guardada correctamente.",
            "success"
          );
          $scope.closeTemplate();
          activate();
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };
    $scope.cahngeFechaLimiteEmail = function (val) {
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, {
              fecha_limite_email: $scope.configuracionGlobal.fecha_limite_email,
            })
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory
            .post("orginfo/", {
              fecha_limite_email: $scope.configuracionGlobal.fecha_limite_email,
            })
            .then(function success(response) {
              if (response.status == 201) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
      }
    };
    $scope.updateDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (
        !form ||
        !form.name ||
        !form.text ||
        !form.bottom_text ||
        !$scope.ramos_code ||
        !$scope.ramos_code.length ||
        (!form.subject_default && !form.title)
      ) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de actualizar.",
          "warning"
        );
        return;
      }

      if (isBlankText(form.text) || isBlankText(form.bottom_text)) {
        SweetAlert.swal(
          "Error",
          "El texto superior e inferior no pueden estar vacíos.",
          "warning"
        );
        return;
      }

      $scope.savingPlantilla = true;

      var data = {
        name: form.name,
        title: form.title,
        text: form.text,
        bottom_text: form.bottom_text,
        subject_default: form.subject_default,
        ramo_code: $scope.ramos_code,
      };
      $http
        .patch(form.url, data)
        .then(function success(response) {
          $scope.showEditInformation = false;
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla actualizada correctamente.",
            "success"
          );
          $scope.closeTemplate();
          activate();
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.borrarPlantilla = function (item) {
      if (!item || !item.url) {
        return;
      }
      SweetAlert.swal(
        {
          title: "¿Confirmas la eliminación?",
          text: "La plantilla se eliminará permanentemente.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí, borrar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }
          $http
            .delete(item.url)
            .then(function success() {
              SweetAlert.swal(
                "¡Listo!",
                "Plantilla eliminada correctamente.",
                "success"
              );
              activate();
            })
            .catch(function () {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            });
        }
      );
    };

    $scope.editQuatation = function (form) {
      $scope.ramos_code = [];
      $scope.plantilla.name = form.name;
      $scope.plantilla.title = form.title;
      $scope.plantilla.text = form.text;
      $scope.plantilla.bottom_text = form.bottom_text;
      $scope.plantilla.url = form.url;
      $scope.plantilla.ramo_code = [];
      $scope.plantilla.subject_default = form.subject_default;
      $scope.showQuotation = true;
      $scope.showEditInformation = true;
      if (form.ramo_code) {
        var convertedCodes = form.ramo_code.map(function (code) {
          return parseInt(code);
        });
        // $scope.plantilla.ramo_code = form.ramo_code;
        convertedCodes.forEach(function (cl) {
          $scope.ramos_code.push(parseInt(cl));
          $scope.allRamos.forEach(function (cd) {
            if (parseInt(cd.code) == cl) {
              $scope.plantilla.ramo_code.push(cd);
            }
          });
        });
        $timeout(function () {
          $("#ramoSelect").select2();
        }, 0);
      }
    };
    $scope.$watch("plantilla.ramo_code", function (newValues, oldValues) {
      if (newValues !== oldValues) {
        $timeout(function () {
          $("#ramoSelect").trigger("change");
        }, 0);
      }
    });
    $scope.focusEditor = function () {
      $scope.editor_focus = true;
    };

    $scope.unfocusEditor = function () {};

    $scope.getFile = function () {
      var editor = textAngularManager.retrieveEditor("myEditorCreate").scope;
      editor.displayElements.text.trigger("focus");

      var modalInstance = $uibModal.open({
        template:
          '<label class="col-xs-12 btn btn-info">Agregar Imagen desde PC' +
          '<input multiple nv-file-select="" type="file" name="xyz" uploader="uploader" accept=".jpg" class="display-none"/>' +
          "</label>",
        // size: 'sm',
        controller: ModalInstanceFileCtrl,
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (imgUrl) {
        var imageLink;
        imageLink = $rootScope.image_url;
        var embed = '<img src="' + imageLink + ' ">';
        // return textAngular.$editor().wrapSelection('insertHTML', embed, true);

        var editor = textAngularManager.retrieveEditor("myEditorCreate");
        editor.scope.wrapSelection("insertHTML", embed, true);
      });
    };
    function ModalInstanceFileCtrl($scope, $rootScope, $uibModalInstance) {
      $scope.userInfo = {
        id: 0,
      };
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        allowedFileType: ["png", "jpg", "jpeg"],
      }));

      $scope.userInfo.url = $scope.uploader.url = url.IP + "plantillas-html/";
      $scope.uploader.autoUpload = true;
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $rootScope.image_url = response.arch;
        if ($uibModalInstance) {
          $uibModalInstance.close();
        }
      };
      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };
      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });
      };
      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = usr.org;
      };
      $scope.validateFiles = function () {
        var input = document.getElementById("fileInput");
        var files = input.files;
        var totalSize = 0;
        var errorMessageElement = document.getElementById("error-message");
        for (var i = 0; i < files.length; i++) {
          totalSize += files[i].size;
        }
        var totalSizeMB = totalSize / (1024 * 1024);
        if (totalSizeMB > 25) {
          errorMessageElement.style.display = "block";
          errorMessageElement.textContent =
            "La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.";
        } else {
          errorMessageElement.style.display = "none"; // Hide error message if files are valid
        }
      };
      function uploadFiles() {
        $scope.userInfo.url = $scope.uploader.url = url.IP + "plantillas-html/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("SiniestrosDaniosCtrl", SiniestrosDaniosCtrl);

  SiniestrosDaniosCtrl.$inject = [
    "dataFactory",
    "packageService",
    "providerService",
    "$state",
    "SweetAlert",
    "$q",
    "toaster",
    "$localStorage",
    "FileUploader",
    "insuranceService",
    "SiniestroService",
    "$scope",
    "$uibModal",
    "ramoService",
    "$http",
    "url",
    "helpers",
    "$sessionStorage",
    "$location",
    "MESSAGES",
    "$rootScope",
    "$stateParams",
    "emailService",
    "PersistenceFactory",
  ];

  function SiniestrosDaniosCtrl(
    dataFactory,
    packageService,
    providerService,
    $state,
    SweetAlert,
    $q,
    toaster,
    $localStorage,
    FileUploader,
    insuranceService,
    SiniestroService,
    $scope,
    $uibModal,
    ramoService,
    $http,
    url,
    helpers,
    $sessionStorage,
    $location,
    MESSAGES,
    $rootScope,
    $stateParams,
    emailService,
    PersistenceFactory
  ) {
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedToken);
    $scope.url = $location.path();
    $scope.myInsurance = $stateParams.myInsurance;

    var vm = this;
    vm.selectedRamo = null;
    vm.selectedSubRamo = null;
    vm.selectedPoliza;
    vm.sub_ramos = [];
    vm.status = { id: 1, label: "Pendiente" };
    vm.statuses = [{ id: 1, label: "Pendiente" }];
    $scope.existenFacturas = false;
    vm.insurances_number = [];
    vm.isInicial = true;
    vm.selectedContractor;
    $scope.subramo_select;
    vm.element = "";
    vm.ramos = [];
    vm.affected = [];
    vm.affect_list = [];
    vm.ramoId = -1;
    vm.insurances;
    vm.selected_affect = [];
    vm.selectInsurance;
    vm.affect_data = {};
    vm.selected_disease = [];
    vm.carga_siniestro = false;
    vm.siniestros = [];
    vm.show_affected = false;
    vm.siniester_data = {};
    vm.coverages = [];
    vm.siniester_data.siniestros_by_number = [];
    vm.siniester_data.selected_number_siniester;
    vm.siniester_data.tipo_de_cambio = 1;
    // vm.facturas_conceptos = facturas_conceptos;
    vm.facturas = [];
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };
    vm.deleteFactura = deleteFactura;
    vm.addFactura = addFactura;
    vm.downloadFacturas = downloadFacturas;
    vm.enfermedades = [];
    vm.buscarEnfermedad = true;
    vm.LookFor = LookFor;
    vm.selectedPoliza;
    vm.ramos = {};
    vm.beneficiaries = [];
    vm.cancel = cancel;
    vm.ramos.ramo_selected = 1;
    vm.contacts = [];
    vm.siniestros_type = [
      { id: 0, label: "Seleccione una opción" },
      { id: 1, label: "Colisión" },
      { id: 2, label: "Incendio" },
      { id: 3, label: "Vuelco" },
      { id: 4, label: "Robo total" },
      { id: 5, label: "Robo parcial" },
      { id: 6, label: "Cristales" },
      { id: 7, label: "Inundaciones" },
    ];
    vm.show_caratula_afectado = false;

    vm.siniester_type = 0;
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };
    $scope.danios_affected = false;
    try {
      if ($scope.myInsurance) {
        if ($scope.myInsurance.url) {
          vm.show_affected = true;
          if ($scope.myInsurance.doSinisterCaratula) {
            $scope.obj = {
              val: "Carátula: " + $scope.myInsurance.poliza_number,
              value: {
                id: $scope.myInsurance.id,
              },
            };
          } else {
            $scope.val = $scope.myInsurance.poliza_number;
            $scope.obj = {
              label:
                "serie: " +
                $scope.myInsurance.damages_policy[0].insured_item +
                "   -   " +
                "PÓLIZA: " +
                $scope.myInsurance.poliza_number,
              val: $scope.myInsurance.poliza_number,
              value: {
                id: $scope.myInsurance.id,
              },
            };
          }
          $scope.danios_affected = true;
          vm.selected_affect = $scope.obj;
          LookFor();
        }
      }
    } catch (error) {
      console.log("eeeeeee", error);
      // activate()
    }

    activate();

    function addContact() {
      if (!vm.contacts || vm.contacts.length == 0 || vm.contacts == "") {
        vm.contacts = [];
      }
      var contact = {
        first_name: "",
        phone: "",
        email: "",
        references: "",
      }; //jshint ignore:line
      vm.contacts.push(contact);
    }

    function deleteContacts(url, index) {
      vm.contacts.splice(index, 1);
    }

    vm.closeModal = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };
    function deleteFactura(url, index) {
      if ((url && index) || (url && !index)) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "El registro se borrara permanentemente aunque no se hayan guardado los cambios.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, eliminar",
            cancelButtonText: "No, cancelar",
            closeOnConfirm: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http.delete(url).then(function (response) {
                vm.facturas.splice(index, 1);
                SweetAlert.swal(
                  "¡Eliminada!",
                  "Tu factura ha sido eliminada.",
                  "success"
                );
              });
            }
          }
        );
      } else {
        vm.facturas.splice(index, 1);
      }
    }
    function cancel() {
      $state.go("siniestros.lista");
    }

    var date = new Date();

    // vm.fecha_promesa = new Date(date.setDate(date.getDate() + 5));
    vm.files;

    //Modals
    vm.updateStatus = updateStatus;
    vm.uploadFiles = uploadFiles;
    vm.saveSiniester = saveSiniester;
    vm.validateEmail = validateEmail;

    vm.ramo_changed = ramo_changed;
    //functions
    vm.showSubRamos = showSubRamos;
    vm.textAExpand = textAExpand;

    // Date picker stuff
    vm.dateNow = new Date();
    vm.dateLimit = new Date(
      vm.dateNow.getFullYear(),
      vm.dateNow.getMonth() + 2,
      vm.dateNow.getDate()
    );
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    activate();

    // var uploader = $scope.uploader = new FileUploader({
    //     headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json' },
    // });
    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + usr, Accept: "application/json" },
    }));

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    function ramo_changed() {
      // ////console.log(vm.ramos.ramo_selected);
      fillTable(vm.ramos.ramo_selected);
    }
    function NotExist(array, element) {
      ////console.log('array',array);
      ////console.log('element',element);
      if (array.length == 0) {
        return true;
      }
      array.forEach(function (elem) {
        if (elem.label == element.label) {
          return true;
        }
      });
      return false;
    }

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.padecimiento_type == undefined) {
        item.padecimiento_type = "";
      }
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].type_document = item.padecimiento_type;
    };

    function getFiles() {
      // return receiptService.getFiles(receiptService.getReceiptID())
      //     .then(function(data) {
      //         vm.files = data;
      //         return vm.files;
      //     });
    }

    function uploadFiles(siniestro_id) {
      $scope.userInfo = {
        id: siniestro_id,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "siniestros/" + siniestro_id + "/archivos/";
      // ////console.log( $scope.uploader);
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve($scope.uploader.uploadAll());
          return defer.promise;
        })
        .then(function () {
          toaster.success("Se han subido sus archivos correctamente");

          // setTimeout(function() {
          //     getFiles().then(function(res) {
          //         vm.files = res;
          //     });
          // }, 1000);
        });
    }

    function Exist(list, obj) {
      for (var i = 0; i < list.length; i++) {
        if (obj.value == list[i].value) {
          return true;
        }
      }
      return false;
    }

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
    $scope.changeTypeDoc = function (padecimiento) {
      $scope.padecimiento_type = padecimiento;
    };
    function saveSiniester() {
      console.log("vm.selected_affect", vm.selected_affect);
      $scope.saveOK = true;
      if (!vm.selected_affect.val && !vm.selected_affect.value) {
        SweetAlert.swal("Asegurado", "Debe agregar un Asegurado", "error");
        return;
      }
      if (vm.show_caratula_afectado) {
        if (
          vm.siniester_data.aux_affected == "" ||
          vm.siniester_data.aux_affected == undefined
        ) {
          SweetAlert.swal(
            "Dato requerido",
            "Debe agregar un bien asegurado",
            "error"
          );
          return;
        }
      }
      if (!vm.affect_data.fecha_ingreso) {
        SweetAlert.swal(
          "Fecha de Emisión",
          "Agregue una Fecha de Emisión",
          "error"
        );
        return;
      }
      if (!vm.siniester_data.estimacion_perdida) {
        SweetAlert.swal(
          "Estimación pérdida",
          "Agregue una cantidad en Estimación Pérdida",
          "error"
        );
        return;
      }
      if (!vm.siniester_data.causa_reclamacion) {
        SweetAlert.swal(
          "Causa de Reclamación",
          "Complete el campo Causa de Reclamación",
          "error"
        );
        return;
      }
      if (!vm.cobertura_afectada) {
        SweetAlert.swal(
          "Cobertura Afectada",
          "Complete el campo Cobertura Afectada",
          "error"
        );
        return;
      }
      if (!vm.affect_data.siniester_date) {
        SweetAlert.swal(
          "Fecha de Siniestro",
          "Complete el campo Fecha dde Siniestro",
          "error"
        );
        return;
      }
      if (!vm.siniester_data.currency || vm.siniester_data.currency == 0) {
        SweetAlert.swal("Moneda", "Seleccione una Moneda", "error");
        return;
      }

      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var obj_siniestro = {
        poliza: vm.selectedPoliza.data ? vm.selectedPoliza.data.url : "",
        // poliza: vm.selectedPoliza.data,
        status: vm.status.id,
        aux_affected: vm.siniester_data.aux_affected,
        affected_item: vm.siniester_data.aux_affected,
        numero_siniestro: vm.siniester_data.siniester_number,
        fecha_siniestro: new Date(vm.affect_data.siniester_date),
        tipo_siniestro_general: 4,
        observations: vm.siniester_data.observations,
        fecha_ingreso: vm.affect_data.fecha_ingreso,
        danios_sinister: [
          {
            bien_asegurado: vm.siniester_data.aux_affected,
            causa_reclamacion: vm.siniester_data.causa_reclamacion,
            cobertura_afectada: vm.cobertura_afectada,
            contacto_danio: vm.contacts,
            estimacion_perdida: vm.siniester_data.estimacion_perdida,
            tipo_cambio: vm.siniester_data.tipo_de_cambio,
            currency: vm.siniester_data.currency,
          },
        ],
      };
      if (obj_siniestro) {
      }
      if (obj_siniestro.danios_sinister[0].contacto_danio.length) {
        obj_siniestro.danios_sinister[0].contacto_danio.forEach(function (
          contact
        ) {
          if (
            contact.first_name == null ||
            contact.first_name == undefined ||
            contact.first_name == ""
          ) {
            $scope.saveOK = false;
          }
          if (contact.email) {
            if (!validateEmail(contact.email)) {
              l.stop();
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.INVALIDEMAILCONTACT,
                "error"
              );
              $scope.saveOK = false;
            }
          }
        });
      }
      if ($scope.saveOK == false) {
        l.stop();
        SweetAlert.swal(
          "Datos incompletos en el contacto",
          "Complete datos correctamente",
          "error"
        );
        return;
      }
      if ($scope.saveOK == true) {
        $http
          .post(url.IP + "siniestros-danios/", obj_siniestro)
          .then(function (siniestro) {
            // console.log(vm.siniester_type);
            if (siniestro.status == 200 || siniestro.status == 201) {
              l.stop();
              uploadFiles(siniestro.data.id);
              $scope.idSiniestro = siniestro.data.id;
              $scope.siniestro_info = siniestro.data;
              $localStorage["save_created_siniester_danios"] = {};
              var params = {
                model: 1,
                event: "POST",
                associated_id: vm.selectedPoliza.data.id,
                identifier: "creó un siniestro daños ",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              if ($scope.url !== "/index/main") {
                if ($scope.siniestro_info.poliza) {
                  $http
                    .get($scope.siniestro_info.poliza)
                    .then(function (response) {
                      vm.infoSiniestro = {};
                      vm.infoSiniestro.poliza = response.data;
                      // Send Email
                      // if (vm.infoSiniestro.poliza.contractor){
                      //     $http.get(vm.infoSiniestro.poliza.contractor)
                      //       .then(function(response) {
                      //         if(response.data.email){
                      //             // Send email
                      //             if($localStorage.email_config){
                      //                 if($localStorage.email_config.solicitud_siniestro == true){
                      //                     var model = 3;
                      //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
                      //                 }
                      //             }
                      //             // Send Email
                      //         }
                      //     });
                      // }
                      //Send Email
                    });
                }

                SweetAlert.swal(
                  "Guardado",
                  "Siniestro Guardado exitosamente",
                  "success"
                );
                $state.go("siniestros.danio_info", {
                  siniestroId: $scope.idSiniestro,
                });
              } else {
                if ($uibModalInstance) {
                  $uibModalInstance.dismiss("cancel");
                }
              }
              // Facturas
              vm.facturas.forEach(function (factura, index) {
                if (!factura.import) {
                  factura.import = 0.0;
                }
                if (!factura.iva) {
                  factura.iva = 0.0;
                }
                if (!factura.total) {
                  factura.total = 0.0;
                }
                var obj_factura = {
                  siniestro: siniestro.data.url,
                  numero_factura: factura.f_number,
                  concepto: factura.concepto,
                  proveedor: factura.proovedor,
                  fecha_factura: new Date(factura.f_date),
                  importe: factura.import.toFixed(2),
                  iva: factura.iva.toFixed(2),
                  total: factura.total,
                  serie: factura.serie,
                };
                $http
                  .post(url.IP + "facturas/", obj_factura)
                  .then(function (facturax) {
                    $scope.existenFacturas = true;
                    // console.log(facturax);
                    // uploadFilesFacturas(facturax.id);
                  });
              });
            }
          });
      }
    }
    function saveObservation(url) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/facturas.observation.html",
        controller: ModalInstanceCtrlObservationsfact,
        resolve: {
          factura: function () {
            return url;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function ModalInstanceCtrlObservationsfact(
      $scope,
      $uibModal,
      factura,
      $uibModalInstance
    ) {
      $http.get(factura).then(function (data) {
        $scope.observation_aux = data.data.observaciones;
      });

      $scope.ok = function () {
        var observ = {
          observaciones: $scope.observation_aux,
        };
        $http.patch(factura, observ).then(function (data) {
          $uibModalInstance.dismiss("cancel");
        });
      };
    }
    function addFactura() {
      var factura = {
        f_number: "",
        concepto: "",
        proovedor: "",
        f_date: "",
        import: "",
        iva: "",
        total: "",
        procedente: 0,
      };
      vm.facturas.push(factura);
    }

    function downloadFacturas(siniestro) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "data:application/vnd.ms-excel;charset=UTF-8",
        }
      );
      saveAs(blob, "Concentrado_Facturas" + ".xls");
    }

    $scope.calculateIva = function (index, item) {
      vm.facturas[index].import = parseFloat(item);
      vm.facturas[index].iva = parseFloat(
        (parseFloat(vm.facturas[index].import) * 0.16).toFixed(2)
      );
      vm.facturas[index].total =
        parseFloat(vm.facturas[index].import) +
        parseFloat(vm.facturas[index].iva);
      vm.facturas[index].total = parseFloat(vm.facturas[index].total).toFixed(
        2
      );
      if (item == "") {
        vm.facturas[index].import = 0;
        vm.facturas[index].iva = 0;
        vm.facturas[index].total = 0;
      }
    };

    $scope.calculateTotales = function () {
      vm.totalImporte = 0;
      vm.totalIva = 0;
      vm.totalTotal = 0;
      for (var i = 0; i < vm.facturas.length; i++) {
        vm.totalImporte = vm.totalImporte + parseFloat(vm.facturas[i].import);
        vm.totalIva = parseFloat(vm.totalIva) + parseFloat(vm.facturas[i].iva);
        vm.totalTotal = vm.totalTotal + parseFloat(vm.facturas[i].total);
      }
    };

    $scope.calculateTotal = function (index, iva) {
      if (iva) {
        vm.facturas[index].iva = parseFloat(iva);
      } else if (iva == "") {
        vm.facturas[index].iva = 0;
      }
      vm.facturas[index].total =
        vm.facturas[index].import + vm.facturas[index].iva;
      vm.facturas[index].total = vm.facturas[index].total.toFixed(2);
    };
    function getTotalReclamado() {
      $scope.total_reclamado_new = 0;
      vm.facturas.forEach(function (factura) {
        $scope.total_reclamado_new =
          parseFloat($scope.total_reclamado_new) + parseFloat(factura.total);
      });
    }

    vm.cadenaBusq = cadenaBusq;
    function cadenaBusq(v) {
      $scope.cadena_a_buscar = v;
    }
    function LookFor() {
      vm.show_affected = true;
      console.log("vm.selected_affect.", vm.selected_affect);
      try {
        $http
          .get(
            url.IP + "leer-polizas-edit/" + vm.selected_affect.value.id + "/"
          )
          .then(function (poliza) {
            vm.selectedPoliza = poliza;
            vm.siniester_data.aux_affected = vm.selected_affect.val
              ? vm.selected_affect && vm.selected_affect.val
              : "";
            if (poliza.data.document_type == 3) {
              // if(vm.carga_siniestro == false){
              SweetAlert.swal(
                "La póliza seleccionada es una carátula",
                "Tendrá que agregar un afectado manualmente.",
                "info"
              );
              // }
            }
            if (poliza.data.document_type == 3) {
              vm.show_caratula_afectado = true;
            } else {
              vm.show_caratula_afectado = false;
            }
            // console.log('poliza--selected',vm.selectedPoliza.data)
            ramoService
              .getSubramoById(poliza.data.subramo.id)
              .then(function (subramo) {
                vm.siniester_data.subramo = subramo.data;
              });
            var data = {
              title:
                vm.selected_affect && vm.selected_affect.value
                  ? vm.selected_affect.value.title
                  : "",
              policy_vigencia: new Date(poliza.data.end_of_validity),
              policy_vigencia_init: new Date(poliza.data.start_of_validity),
              siniester_date:
                $localStorage["save_created_siniester_danios"] &&
                $localStorage["save_created_siniester_danios"]["siniester_date"]
                  ? $localStorage["save_created_siniester_danios"][
                      "siniester_date"
                    ]
                  : new Date(),
              fecha_ingreso:
                $localStorage["save_created_siniester_danios"] &&
                $localStorage["save_created_siniester_danios"]["fecha_ingreso"]
                  ? $localStorage["save_created_siniester_danios"][
                      "fecha_ingreso"
                    ]
                  : new Date(),
              folio_interno: "",
              policy_number: poliza.data.poliza_number,
            };
            if (vm.selectedPoliza.data.coverageInPolicy_policy) {
              vm.coverages = [];
              vm.selectedPoliza.data.coverageInPolicy_policy.forEach(function (
                cv
              ) {
                vm.coverages.push(cv);
              });
            }
            var waitReceipt = [];
            waitReceipt.push(
              $http.get(url.IP + "get-current-receipt/" + poliza.data.id)
            );
            $q.all(waitReceipt).then(function (response) {
              var status = response[0].data.status;
              data.policy_status = {};
              switch (status) {
                case 1:
                  data.policy_status["label"] = "Pagado";
                  data.policy_status["id"] = status;
                  break;
                case 2:
                  data.policy_status["label"] = "Cancelado";
                  data.policy_status["id"] = status;
                  break;
                case 3:
                  data.policy_status["label"] = "Prorrogado";
                  data.policy_status["id"] = status;
                  break;
                case 4:
                  data.policy_status["label"] = "Pendiente de pago";
                  data.policy_status["id"] = status;
                  break;
                default:
                  data.policy_status["label"] = "Sin Estatus";
                  data.policy_status["id"] = status;
              }
            });

            // console.log('poliza.data-----',poliza.data.parent.parent.parent.natural)
            if (poliza.data.contractor) {
              $http.get(poliza.data.contractor).then(function (contratante) {
                data["contractor_addres"] =
                  contratante.data.address_contractor[0].route +
                  " #" +
                  contratante.data.address_contractor[0].street_number +
                  " " +
                  contratante.data.address_contractor[0]
                    .administrative_area_level_2 +
                  " " +
                  contratante.data.address_contractor[0]
                    .administrative_area_level_1;
                data["contratante"] = contratante.data;
                data["contratante"].name = contratante.data.full_name;
                $scope.contratante = data["contratante"].name;
                try {
                  $scope.obj = {
                    label:
                      $scope.contratante +
                      "   -   " +
                      "BIEN ASEGURADO: " +
                      poliza.data.damages_policy[0].insured_item +
                      "   -   " +
                      "PÓLIZA: " +
                      poliza.data.poliza_number,
                    val:
                      $scope.contratante +
                      "   -   " +
                      "BIEN ASEGURADO: " +
                      poliza.data.damages_policy[0].insured_item +
                      "   -   " +
                      "PÓLIZA: " +
                      poliza.data.poliza_number,
                    bien_asegurado: poliza.damages_policy[0].insured_item,
                    value: {
                      id: poliza.data.id,
                      bien_asegurado: poliza.damages_policy[0].insured_item,
                    },
                  };
                  vm.selected_affect = $scope.obj;
                } catch (err) {}
              });
            }
            // console.log('-----------',poliza.data.parent.parent.parent.natural)
            if (poliza.data.parent) {
              if (poliza.data.parent.parent) {
                if (poliza.data.parent.parent.parent) {
                  if (poliza.data.parent.parent.parent.contractor) {
                    $http
                      .get(poliza.data.parent.parent.parent.contractor.url)
                      .then(function (contratante) {
                        // console.log('contratante',contratante)
                        data["contractor_addres"] =
                          contratante.data.address_contractor[0].route +
                          " #" +
                          contratante.data.address_contractor[0].street_number +
                          " " +
                          contratante.data.address_contractor[0]
                            .administrative_area_level_2 +
                          " " +
                          contratante.data.address_contractor[0]
                            .administrative_area_level_1;
                        data["contratante"] = contratante.data;
                        data["contratante"].name = contratante.data.full_name;
                        $scope.contratante = data["contratante"].name;
                        try {
                          $scope.obj = {
                            label:
                              $scope.contratante +
                              "   -   " +
                              "BIEN ASEGURADO: " +
                              poliza.data.damages_policy[0].insured_item +
                              "   -   " +
                              "PÓLIZA: " +
                              poliza.data.poliza_number,
                            val:
                              $scope.contratante +
                              "   -   " +
                              "BIEN ASEGURADO: " +
                              poliza.data.damages_policy[0].insured_item +
                              "   -   " +
                              "PÓLIZA: " +
                              poliza.data.poliza_number,
                            bien_asegurado:
                              poliza.damages_policy[0].insured_item,
                            value: {
                              id: poliza.data.id,
                              bien_asegurado:
                                poliza.damages_policy[0].insured_item,
                            },
                          };
                          vm.selected_affect = $scope.obj;
                        } catch (err) {}
                      });
                  }
                }
              }
            }

            providerService
              .getProviderById(poliza.data.aseguradora)
              .then(function (aseguradora) {
                data["aseguradora"] = aseguradora.data;
              });

            if (poliza.data.paquete) {
              packageService
                .getPackageById(poliza.data.paquete.id)
                .then(function (paquete) {
                  data["paquete"] = paquete.data;
                });
            }

            vm.affect_data = data;
            // console.log('------vm.affect_data',vm.affect_data)
          });
      } catch (err) {
        SweetAlert.swal("Error", "Selecciona un Afectado valido", "error");
      }
    }
    function fillTable(ramo_number) {
      vm.siniestros = [];
      $http
        .get(url.IP + "siniestros-infotable/" + ramo_number)
        .then(function (siniestros) {
          siniestros.data.forEach(function (siniestro) {
            vm.siniestros.push(siniestro);
          });
        });
    }

    function activate() {
      vm.tmp_siniestro = angular.copy($rootScope.siniestro_tmp);
      vm.carga_siniestro = $rootScope.carga_siniestro;
      // console.log('seleccc',vm.tmp_siniestro,vm.carga_siniestro)
      // console.log('vengo de allá ', $rootScope.siniestro_tmp, vm.carga_siniestro);
      if (vm.carga_siniestro) {
        if (vm.tmp_siniestro.facturas && vm.tmp_siniestro.facturas.length) {
          vm.tmp_siniestro.facturas.forEach(function (factura_a_cargar) {
            var obj = {
              serie: factura_a_cargar.serie,
              f_number: factura_a_cargar.numero_factura,
              concepto: factura_a_cargar.concepto,
              proovedor: factura_a_cargar.proveedor,
              f_date: factura_a_cargar.fecha_factura,
              import: parseFloat(factura_a_cargar.importe),
              iva: factura_a_cargar.iva,
              total: factura_a_cargar.total,
            };
            vm.facturas.push(obj);
          });
        }

        // vm.selected_disease = parComplement.value.accidente[0];
        vm.siniester_data.observations = vm.tmp_siniestro.observations;

        vm.affect_data.siniester_date = vm.tmp_siniestro.fecha_siniestro;
        vm.affect_data.fecha_ingreso = vm.tmp_siniestro.fecha_ingreso;

        if (
          vm.tmp_siniestro.danios_sinister &&
          vm.tmp_siniestro.danios_sinister.length
        ) {
          vm.siniester_data.explicacion =
            vm.tmp_siniestro.danios_sinister[0].explicacion;
          vm.siniester_type =
            vm.tmp_siniestro.danios_sinister[0].tipo_siniestro;
          if (
            vm.tmp_siniestro.danios_sinister[0].contacto_auto &&
            vm.tmp_siniestro.danios_sinister[0].contacto_auto.length
          ) {
            vm.contacts = vm.tmp_siniestro.danios_sinister[0].contacto_auto;
          }
        }

        if (vm.tmp_siniestro.poliza.document_type == 3) {
          vm.siniester_data.aux_affected = vm.tmp_siniestro.aux_affected;
          var label = "Carátula: " + vm.tmp_siniestro.poliza.poliza_number;
        } else {
          var label = "Póliza: " + vm.tmp_siniestro.poliza_number;
        }

        var ns = {
          label: vm.tmp_siniestro.numero_siniestro,
          value: 0,
        };
        vm.siniester_data.siniester_number = ns;
        // vm.siniester_data.observations = vm.tmp_siniestro.siniestro.observations
        // vm.affect_data.siniester_date = new Date(vm.tmp_siniestro.siniestro.fecha_siniestro)

        //  Falta cargar el asegurado al crearle un complemento al siniestro, numero de siniestro y forma de pago del siniestro

        // 'label':   vm.tmp_siniestro.accidente.ailment

        vm.isInicial = false;
        var obj = {
          label: label,
          val: label,
          value: {
            id: vm.tmp_siniestro.poliza_id,
            tittle_id: 1,
            name: vm.tmp_siniestro.poliza.poliza_number,
            url: undefined,
          },
        };
        vm.selected_affect = obj;
        LookFor();
      } else {
        updateStatus();
      }

      delete $rootScope.siniestro_tmp;
      $scope.fileSinister = true;
      window.scrollTo(0, 0);

      vm.selected_affect =
        $localStorage["save_created_siniester_danios"] &&
        $localStorage["save_created_siniester_danios"]["selected_affect"]
          ? $localStorage["save_created_siniester_danios"]["selected_affect"]
          : vm.selected_affect
          ? vm.selected_affect
          : "";

      if ($localStorage["save_created_siniester_danios"]) {
        vm.facturas =
          $localStorage["save_created_siniester_danios"] &&
          $localStorage["save_created_siniester_danios"]["facturas"]
            ? $localStorage["save_created_siniester_danios"]["facturas"]
            : [];
        $scope.active = 0;
        if (!vm.facturas || vm.facturas.length == 0) {
          addFactura();
        }
        if ($localStorage["save_created_siniester_danios"]["selected_affect"]) {
          // vm.LookFor();
          vm.show_affected = true;
        }
      }
      if ($localStorage["save_created_siniester_danios"]) {
        vm.siniester_data.aux_affected = $localStorage[
          "save_created_siniester_danios"
        ]
          ? $localStorage["save_created_siniester_danios"]["aux_affected"]
          : "";
        vm.affect_data.fecha_ingreso = $localStorage[
          "save_created_siniester_danios"
        ]
          ? $localStorage["save_created_siniester_danios"]["fecha_ingreso"]
          : "";
        vm.siniester_data.siniester_number = $localStorage[
          "save_created_siniester_danios"
        ]
          ? $localStorage["save_created_siniester_danios"]["siniester_number"]
          : "";
        vm.siniester_data.estimacion_perdida = $localStorage[
          "save_created_siniester_danios"
        ]
          ? $localStorage["save_created_siniester_danios"]["estimacion_perdida"]
          : "";
        vm.siniester_data.causa_reclamacion = $localStorage[
          "save_created_siniester_danios"
        ]
          ? $localStorage["save_created_siniester_danios"]["causa_reclamacion"]
          : "";
        vm.siniester_data.currency = $localStorage[
          "save_created_siniester_danios"
        ]
          ? $localStorage["save_created_siniester_danios"]["currency"]
          : "";
        vm.siniester_data.tipo_de_cambio = $localStorage[
          "save_created_siniester_danios"
        ]
          ? $localStorage["save_created_siniester_danios"]["tipo_de_cambio"]
          : "";
        vm.cobertura_afectada = $localStorage["save_created_siniester_danios"]
          ? $localStorage["save_created_siniester_danios"]["cobertura_afectada"]
          : "";
        vm.affect_data.siniester_date = $localStorage[
          "save_created_siniester_danios"
        ]
          ? $localStorage["save_created_siniester_danios"]["siniester_date"]
          : "";
        vm.siniester_data.observations = $localStorage[
          "save_created_siniester_danios"
        ]
          ? $localStorage["save_created_siniester_danios"]["observations"]
          : "";
        vm.contacts =
          $localStorage["save_created_siniester_danios"] &&
          $localStorage["save_created_siniester_danios"]["contacts"]
            ? $localStorage["save_created_siniester_danios"]["contacts"]
            : [];

        if ($localStorage["save_created_siniester_danios"]["affect_data"]) {
          vm.affect_data.contratante = $localStorage[
            "save_created_siniester_danios"
          ]
            ? $localStorage["save_created_siniester_danios"]["affect_data"][
                "contratante"
              ]
            : "";
          vm.affect_data.policy_number = $localStorage[
            "save_created_siniester_danios"
          ]
            ? $localStorage["save_created_siniester_danios"]["affect_data"][
                "policy_number"
              ]
            : "";
          vm.siniester_data.subramo = $localStorage[
            "save_created_siniester_danios"
          ]
            ? $localStorage["save_created_siniester_danios"]["subramo"]
            : "";
          vm.affect_data.policy_status = $localStorage[
            "save_created_siniester_danios"
          ]
            ? $localStorage["save_created_siniester_danios"]["affect_data"][
                "policy_status"
              ]
            : "";
          vm.affect_data.contractor_addres = $localStorage[
            "save_created_siniester_danios"
          ]
            ? $localStorage["save_created_siniester_danios"]["affect_data"][
                "contractor_addres"
              ]
            : "";
          vm.affect_data.policy_vigencia_init = $localStorage[
            "save_created_siniester_danios"
          ]
            ? $localStorage["save_created_siniester_danios"]["affect_data"][
                "policy_vigencia_init"
              ]
            : "";
          vm.affect_data.policy_vigencia = $localStorage[
            "save_created_siniester_danios"
          ]
            ? $localStorage["save_created_siniester_danios"]["affect_data"][
                "policy_vigencia"
              ]
            : "";
          vm.affect_data.aseguradora = $localStorage[
            "save_created_siniester_danios"
          ]
            ? $localStorage["save_created_siniester_danios"]["affect_data"][
                "aseguradora"
              ]
            : "";
          vm.affect_data.paquete = $localStorage[
            "save_created_siniester_danios"
          ]
            ? $localStorage["save_created_siniester_danios"]["affect_data"][
                "paquete"
              ]
            : "";
        }

        if (vm.selected_affect && vm.selected_affect.value) {
          $http
            .get(
              url.IP + "leer-polizas-edit/" + vm.selected_affect.value.id + "/"
            )
            .then(function (poliza) {
              vm.selectedPoliza = poliza;
            });
        }
      }
      $scope.active = 0;
      if (!vm.facturas || vm.facturas.length == 0) {
        addFactura();
      }
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Archivos") {
            vm.permarch = perm;
            vm.permarch.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  vm.permiso_administrar_adjuntos = true;
                } else {
                  vm.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
        });
      }
    }

    if ("save_created_siniester_danios" in $localStorage) {
    } else {
      $localStorage["save_created_siniester_danios"] = {};
    }

    $scope.saveLocalstorange = function () {
      $localStorage["save_created_siniester_danios"]["selected_affect"] =
        vm.selected_affect ? vm.selected_affect : "";
      $localStorage["save_created_siniester_danios"]["aux_affected"] = vm
        .siniester_data.aux_affected
        ? vm.siniester_data.aux_affected
        : "";
      $localStorage["save_created_siniester_danios"]["fecha_ingreso"] = vm
        .affect_data.fecha_ingreso
        ? vm.affect_data.fecha_ingreso
        : "";
      $localStorage["save_created_siniester_danios"]["siniester_number"] = vm
        .siniester_data.siniester_number
        ? vm.siniester_data.siniester_number
        : "";
      $localStorage["save_created_siniester_danios"]["estimacion_perdida"] = vm
        .siniester_data.estimacion_perdida
        ? vm.siniester_data.estimacion_perdida
        : "";
      $localStorage["save_created_siniester_danios"]["causa_reclamacion"] = vm
        .siniester_data.causa_reclamacion
        ? vm.siniester_data.causa_reclamacion
        : "";
      $localStorage["save_created_siniester_danios"]["currency"] = vm
        .siniester_data.currency
        ? vm.siniester_data.currency
        : "";
      $localStorage["save_created_siniester_danios"]["tipo_de_cambio"] = vm
        .siniester_data.tipo_de_cambio
        ? vm.siniester_data.tipo_de_cambio
        : "";
      $localStorage["save_created_siniester_danios"]["cobertura_afectada"] =
        vm.cobertura_afectada ? vm.cobertura_afectada : "";
      $localStorage["save_created_siniester_danios"]["siniester_date"] = vm
        .affect_data.siniester_date
        ? vm.affect_data.siniester_date
        : "";
      $localStorage["save_created_siniester_danios"]["affect_data"] =
        vm.affect_data ? vm.affect_data : "";
      $localStorage["save_created_siniester_danios"]["subramo"] = vm
        .siniester_data.subramo
        ? vm.siniester_data.subramo
        : "";
      $localStorage["save_created_siniester_danios"]["observations"] = vm
        .siniester_data.observations
        ? vm.siniester_data.observations
        : "";
      $localStorage["save_created_siniester_danios"]["contacts"] = vm.contacts
        ? vm.contacts
        : "";
      $localStorage["save_created_siniester_danios"]["facturas"] = vm.facturas
        ? vm.facturas
        : [];
    };

    function showSubRamos(event) {
      vm.ramoId = event.target.id;
    }

    function textAExpand(event) {
      var element = e.target;
      var scroll = element.scrollHeight - 60;
      element.style.height = scrollHeight + "px";
    }
    $scope.habuscado = false;
    function updateStatus(cadena) {
      $scope.habuscado = true;
      vm.affected.length = 0;
      var word_data =
        vm.selected_affect && vm.selected_affect.val
          ? vm.selected_affect.val
          : cadena;
      if (word_data) {
        if (word_data.length >= 3) {
          var word = word_data.split(" ").join("_");
          if ($scope.val) {
            var word = $scope.val;
            var word = word.split(" ").join("_");
          }
          insuranceService
            .getInsurances_by_ramo(4, word)
            .then(function (polizas) {
              polizas.forEach(function (poliza) {
                if (poliza.parent) {
                  if (poliza.parent.parent) {
                    if (poliza.parent.parent.parent) {
                      if (poliza.parent.parent.parent.contractor) {
                        poliza.contractor =
                          poliza.parent.parent.parent.contractor;
                      }
                    }
                  }
                }
                if (
                  (poliza.document_type == 1 && poliza.status != 1) ||
                  poliza.document_type == 3 ||
                  poliza.document_type == 6
                ) {
                  if (poliza.contractor) {
                    var obj = {
                      label:
                        poliza.contractor.full_name +
                        "   -   " +
                        "poliza: " +
                        poliza.poliza_number,
                      bien_asegurado: "",
                      value: {
                        id: poliza.id,
                        bien_asegurado: "",
                      },
                    };
                    function findCoincidences(argument) {
                      return argument.value.id === obj.value.id;
                    }

                    if (!vm.affected.find(findCoincidences)) {
                      vm.affected.push(obj);
                    }
                  }
                }
              });
            });
        }
      } else {
        vm.affected.length = 0;
      }
    }
    // console.log('Aqui es: OT000151')
    //-- Peticion de persistencia--//
    console.log("Persistence Siniestros Daño");
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr1 = JSON.parse(decryptedUser);
    var json_data = {};
    var form = document.getElementsByTagName("form");
    var elementos = {};
    //Valores reutilizables
    var interval, interval1, form_dt, valor, dt, selected_affect;
    var break_for = false;

    function set_dataForm(json) {
      PersistenceFactory.set_inputs(json);
      console.log(json); //0001Q

      if (
        json["vm.selected_affect.val"] &&
        json["vm.selected_affect.val"] != ""
      ) {
        dt = json["vm.selected_affect.val"];
        vm.selected_affect.val = dt.nombre.substr(0, 10);
        vm.updateStatus();

        interval1 = setInterval(function () {
          if (vm.affected.length > 0) {
            clearInterval(interval1);
            angular.forEach(vm.affected, function (v, a) {
              if (v.value.id == dt.id && break_for == false) {
                vm.selected_affect = v;
                LookFor();
                Seguir();
                break_for = true;
              }
            });
            clearInterval(interval1);
          }
        }, 1000);
      }

      /*
          if(json['vm.selected_affect.val'] && json['vm.selected_affect.val'] != ''){
            dt = json['vm.selected_affect.val'];
            var nombre = dt.nombre.split(' ')
            vm.selected_affect.val = nombre[nombre.length-1];
            vm.updateStatus();

            //("poliza: ")

            interval1 = setInterval(function(){
              if(vm.affected.length>0){
                clearInterval(interval1);
                console.log(vm.affected)
                angular.forEach(vm.affected, function(v,a){
                  console.log('v: '+v+' -a: '+a )
                  console.log(v)
                  console.log(v.value.id == dt.id)
                  if(v.value.id == dt.id && break_for == false){
                    vm.selected_affect.val = v;
                    LookFor();
                    Seguir();
                    break_for = true;
                  }
                });
                clearInterval(interval1);
              }
            }, 1000);
          }
          */

      function Seguir() {
        if (json["vm.affect_data.fecha_ingreso"] != "") {
          valor = angular.element('[ng-model="vm.affect_data.fecha_ingreso"]');
          valor.val("");
        }
        if (json["vm.affect_data.siniester_date"] != "") {
          valor = angular.element('[ng-model="vm.affect_data.siniester_date"]');
          valor.val("");
        }
        /*

            if(json['vm.siniester_type'] != ''){
              vm.siniester_type = PersistenceFactory.changeInt(json['vm.siniester_type']);
            }*/
      }
    }

    interval = setInterval(function () {
      if (form != undefined && PersistenceFactory.count == 0) {
        PersistenceFactory.inicial(
          usr1.org,
          "Siniestro_Danio",
          usr1.nameFull,
          PersistenceFactory.get_dataForm(form)
        );
      }
      if (
        PersistenceFactory.init_return != "" &&
        PersistenceFactory.init_return != undefined
      ) {
        clearInterval(interval);
        if (PersistenceFactory.init_return.status == "data_view") {
          set_dataForm(PersistenceFactory.json_return);
        }
        PersistenceFactory.interval = setInterval(function () {
          console.log(vm.selected_affect);
          var aa = [
            {
              val: vm.selected_affect.val,
              value: {
                id: vm.selected_affect.value.id,
                bien_asegurado: vm.selected_affect.value.bien_asegurado,
              },
            },
          ];
          //vm.selected_affect
          PersistenceFactory.editado(PersistenceFactory.get_dataForm(form, aa)); //{'val':vm.selected_affect.val,'id':vm.selected_affect.value.id}));
        }, PersistenceFactory.intervalTime); /* /* */
      }
    }, 1000);
    //-- End Peticion de persistencia--//
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("siniestrosDanioInfoCtrl", siniestrosDanioInfoCtrl);

  siniestrosDanioInfoCtrl.$inject = [
    "datesFactory",
    "providerService",
    "packageService",
    "fileService",
    "$stateParams",
    "$rootScope",
    "$state",
    "SweetAlert",
    "$q",
    "toaster",
    "$localStorage",
    "FileUploader",
    "insuranceService",
    "$scope",
    "$uibModal",
    "ramoService",
    "$http",
    "url",
    "helpers",
    "$sessionStorage",
    "MESSAGES",
    "$sce",
    "dataFactory",
    "$location",
    "$anchorScroll",
    "emailService",
    "appStates",
  ];

  function siniestrosDanioInfoCtrl(
    datesFactory,
    providerService,
    packageService,
    fileService,
    $stateParams,
    $rootScope,
    $state,
    SweetAlert,
    $q,
    toaster,
    $localStorage,
    FileUploader,
    insuranceService,
    $scope,
    $uibModal,
    ramoService,
    $http,
    url,
    helpers,
    $sessionStorage,
    MESSAGES,
    $sce,
    dataFactory,
    $location,
    $anchorScroll,
    emailService,
    appStates
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var token = JSON.parse(decryptedToken);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.user = usr;

    vm.siniestro_id = $stateParams.siniestroId;

    $scope.actualizando = false;
    vm.selectedRamo = null;
    vm.selectedSubRamo = null;
    vm.selectedPoliza;
    vm.sub_ramos = [
      { id: 2, label: "Accidentes personales" },
      { id: 3, label: "Gastos médicos" },
      { id: 4, label: "Salud" },
    ];
    vm.status = { id: 0, label: "Estatus" };
    vm.statuses = [
      { id: 1, label: "Pendiente" },
      { id: 2, label: "En trámite" },
      { id: 3, label: "Completado" },
      { id: 4, label: "Cancelada" },
      { id: 5, label: "Rechazada" },
      { id: 6, label: "En espera" },
    ];
    vm.insurances_number = [];
    vm.isInicial = true;
    vm.selectedContractor;
    $scope.subramo_select;
    vm.element = "";
    vm.ramos = [];
    vm.affected = [];
    vm.affect_list = [];
    vm.ramoId = -1;
    vm.insurances;
    vm.selected_affect = [];
    vm.selectInsurance;
    vm.affect_data = {};
    vm.selected_disease = [];
    vm.siniestros = [];
    vm.siniester_data = {};
    vm.siniester_data.siniestros_by_number = [];
    vm.siniester_data.selected_number_siniester;
    vm.enfermedades = [];
    vm.LookFor = LookFor;
    vm.getPdf = getPdf;
    vm.getPDFiniquito = getPDFiniquito;
    vm.crear_complemento = crear_complemento;
    vm.selectedPoliza;
    vm.ramos = {};
    vm.contacts = [];
    vm.facturas = [];
    var facturasExcelColumnMap = {
      serie: "serie",
      nofactura: "f_number",
      concepto: "concepto",
      proveedor: "proovedor",
      fechadefactura: "f_date",
      importe: "import",
      iva: "iva",
      total: "total",
      procedente: "procedente",
    };
    var columnOrder = [
      "serie",
      "f_number",
      "concepto",
      "proovedor",
      "f_date",
      "import",
      "iva",
      "total",
      "procedente",
    ];
    var conceptoCanonical = {
      medicamentos: "Medicamentos",
      honorariosmedicos: "Honorarios Médicos",
      hospitalizacion: "Hospitalización",
      hospitalisacion: "Hospitalización",
      hospitalizasion: "Hospitalización",
      hospitalizazion: "Hospitalización",
      estudios: "Estudios",
      protesis: "Prótesis",
      ambulancia: "Ambulancia",
      otros: "Otros",
    };

    function normalizeConceptoRaw(value) {
      if (!value && value !== 0) {
        return "";
      }
      var clean = value
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "")
        .replace(/[^a-zA-Z]/g, "")
        .toLowerCase();
      return conceptoCanonical[clean] || value;
    }
    vm.ramos.ramo_selected = 1;
    $scope.observation_aux = "";
    $scope.final_procedente = 0.0;
    $scope.final_reclamado = 0.0;
    vm.total = {};
    vm.ramos.options = [
      { id: 2, label: "Accidentes y Enfermedades" },
      { id: 3, label: "Daños" },
      { id: 1, label: "Vida" },
    ];
    var date = new Date();

    vm.files = [];
    vm.form = {};
    var titles = {
      1: "Titular",
      2: "Cónyuge",
      3: "Hijo",
      4: "Otro",
    };
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    $scope.colors = [
      { name: "black", shade: "dark" },
      { name: "white", shade: "light", notAnOption: true },
      { name: "red", shade: "dark" },
      { name: "blue", shade: "dark", notAnOption: true },
      { name: "yellow", shade: "light", notAnOption: false },
    ];
    $scope.myColor = $scope.colors[2];
    vm.updateStatus = updateStatus;
    vm.uploadFiles = uploadFiles;
    vm.deleteFactura = deleteFactura;
    vm.addFactura = addFactura;
    vm.changeSinesterNumber = changeSinesterNumber;
    vm.ramo_changed = ramo_changed;
    vm.deleteSiniestro = deleteSiniestro;
    $scope.deleteFile = deleteFile;
    vm.saveEditInformation = saveEditInformation;
    vm.getPDF = getPDF;
    vm.viewObservation = viewObservation;
    vm.updateSiniestroStatus = updateSiniestroStatus;
    vm.updateSiniestro = updateSiniestro;
    $scope.aux_folio;
    $scope.aux_fecha_promesa = new Date();
    $scope.final_deducible;
    $scope.final_coaseguro;
    $scope.final_complemento;
    $scope.cancelRazon;
    vm.goToPolicy = goToPolicy;
    vm.viewCarta = viewCarta;
    vm.downloadFacturas = downloadFacturas;
    vm.sendEmail = sendEmail;

    vm.cancel = cancel;
    vm.getLog = getLog;

    /* Functions */
    vm.showSubRamos = showSubRamos;
    vm.textAExpand = textAExpand;

    // Date picker stuff
    vm.dateNow = new Date();
    vm.dateLimit = new Date(
      vm.dateNow.getFullYear(),
      vm.dateNow.getMonth() + 2,
      vm.dateNow.getDate()
    );

    activate();

    $scope.recordatoriosFlag = false;

    $scope.showRecordatorios = function () {
      $scope.recordatoriosFlag = !$scope.recordatoriosFlag;
    };

    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.createRecordatorio = function (registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return $scope.endorsement;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFiles = function (param) {
      uploadFiles(param.siniestro.id);
      activate();
    };
    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    function deleteFile(file, container) {
      var data_email = {
        id: file.id,
        id_siniestro: vm.infoSiniestro.id,
        model: 7,
        type_person: 0,
      };
      dataFactory
        .post("send-email-admins-deletes/", data_email)
        .then(function success(req) {});
      fileService.deleteFile(file, container);
      var params = {
        model: 5,
        event: "PATCH",
        associated_id: vm.infoSiniestro.siniestro.id,
        identifier:
          "elimino archivos del siniestro " +
          vm.infoSiniestro.siniestro.numero_siniestro,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
    }

    // function goToPolicy(name, route, poliza) {
    //   $scope.name_for_new_tab = name;
    //   $scope.route_for_new_tab = route;

    //   var existe = false;
    //   if (name && route){
    //     $scope.route_for_new_tab = route;
    //     $scope.name_for_new_tab = name;
    //     appStates.states.forEach(function(state) {
    //       if (state.route == $scope.route_for_new_tab){
    //         existe = true;
    //       }
    //     });
    //   }

    //   if (!existe){
    //     var active_tab = appStates.states.findIndex(function(item){
    //       if (item.active){
    //         return true
    //       }
    //       return false;
    //     });

    //     appStates.states[active_tab] = {
    //       name: $scope.name_for_new_tab,
    //       heading: $scope.name_for_new_tab,
    //       route: $scope.route_for_new_tab,
    //       active: true,
    //       isVisible: true,
    //       href: $state.href($scope.route_for_new_tab),
    //     }
    //   }
    //   $localStorage.tab_states = appStates.states;
    //   $localStorage.tab_index = $localStorage.tab_states.length -1;

    //   $state.go('polizas.info', {polizaId: vm.infoSiniestro.poliza.id});
    // }
    function goToPolicy(poliza) {
      if (vm.infoSiniestro.poliza.document_type == 3) {
        var name = "Información colectividad";
        var route = "colectividades.info";
      } else if (vm.infoSiniestro.poliza.document_type == 1) {
        var name = "Información pólizas";
        var route = "polizas.info";
      } else if (vm.infoSiniestro.poliza.document_type == 6) {
        var name = "Información colectividad";
        var route = "colectividades.info";
      } else if (vm.infoSiniestro.poliza.parent) {
        if (vm.infoSiniestro.poliza.parent.document_type == 5) {
          if (vm.infoSiniestro.poliza.parent.parent) {
            if (vm.infoSiniestro.poliza.parent.parent.document_type == 4) {
              if (vm.infoSiniestro.poliza.parent.parent.parent) {
                if (
                  vm.infoSiniestro.poliza.parent.parent.parent.document_type ==
                  3
                ) {
                  var name = "Información colectividad";
                  var route = "colectividades.info";
                }
              }
            }
          }
        }
      }

      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;

      if (vm.infoSiniestro.poliza.document_type == 3) {
        $state.go("colectividades.info", {
          polizaId: vm.infoSiniestro.poliza.id,
        });
      } else if (vm.infoSiniestro.poliza.document_type == 1) {
        $state.go("polizas.info", { polizaId: vm.infoSiniestro.poliza.id });
      } else if (vm.infoSiniestro.poliza.document_type == 6) {
        $state.go("colectividades.info", {
          polizaId: vm.infoSiniestro.poliza.parent.caratula,
        });
      } else if (vm.infoSiniestro.poliza.parent) {
        if (vm.infoSiniestro.poliza.parent.document_type == 5) {
          if (vm.infoSiniestro.poliza.parent.parent) {
            if (vm.infoSiniestro.poliza.parent.parent.document_type == 4) {
              if (vm.infoSiniestro.poliza.parent.parent.parent) {
                if (
                  vm.infoSiniestro.poliza.parent.parent.parent.document_type ==
                  3
                ) {
                  $state.go("colectividades.info", {
                    polizaId: vm.infoSiniestro.poliza.parent.parent.parent.id,
                  });
                }
              }
            }
          }
        }
      }
    }

    function viewCarta(poliza, carta) {
      $http({
        method: "GET",
        url: url.IP + "get-carta-siniestros/",
        params: {
          id: vm.infoSiniestro.siniestro.id,
          id_carta: carta,
          hospital: "",
          medico: "",
          medico2: "",
          sa_auth: "",
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          $scope.pdf = response.data;
          var params = {
            model: 5,
            event: "GET",
            associated_id: vm.infoSiniestro.siniestro.id,
            identifier:
              "emitio Carta del siniestro " +
              vm.infoSiniestro.siniestro.numero_siniestro,
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          $http({
            method: "GET",
            url: url.IP + "get-pdf",
            params: {
              pdf_name: $scope.pdf.pdf_name,
            },
            responseType: "arraybuffer",
          }).then(function success(response) {
            var file = new Blob([response.data], { type: "application/pdf" });
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file);
            } else {
              var fileURL = URL.createObjectURL(file);
              $scope.content = $sce.trustAsResourceUrl(fileURL);
              window.open($scope.content);
            }
          });
        }
      });
    }

    function getPDF(siniestro, poliza) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-siniester/",
        params: {
          poliza: poliza,
          siniestro: siniestro,
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }

          $scope.pdf = response.data;
          var params = {
            model: 5,
            event: "GET",
            associated_id: vm.infoSiniestro.siniestro.id,
            identifier:
              "emitio PDF del siniestro " +
              vm.infoSiniestro.siniestro.numero_siniestro,
          };
          dataFactory.post("send-log/", params);
          // $http({
          // method: 'GET',
          // url: url.IP + 'get-pdf',
          // params: {
          //     'pdf_name': $scope.pdf.pdf_name
          // }
          // }).then(function success(response) {

          // })
        }
      });
    }

    function crear_complemento(siniestro) {
      $rootScope.siniestro_tmp = siniestro;
      $rootScope.carga_siniestro = true;
      $state.go("siniestros.accidentes");
    }

    function ModalFiniquitoCtrl($uibModalInstance, $scope) {
      $scope.data = {};
      $scope.close = function () {
        $uibModalInstance.dismiss();
      };

      $scope.visualizar = function (data) {
        $uibModalInstance.close(data);
      };
    }

    function getPDFiniquito(siniestro, poliza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/modal.finiquito.html",
        controller: ModalFiniquitoCtrl,
        size: "md",
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (data) {
        $http({
          method: "POST",
          url: url.IP + "get-pdf-finiquito/",
          data: {
            poliza: poliza,
            siniestro: siniestro,
            cheque: data.cheque,
            observaciones: data.observaciones,
          },
        }).then(function success(response) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
          $scope.pdf = response.data;
          var params = {
            model: 5,
            event: "POST",
            associated_id: vm.infoSiniestro.siniestro.id,
            identifier:
              "emitio una hoja de Finiquito " +
              vm.infoSiniestro.siniestro.numero_siniestro,
          };
          dataFactory.post("send-log/", params);
          // $http({
          // method: 'GET',
          // url: url.IP + 'get-pdf',
          // params: {
          //     'pdf_name': $scope.pdf.pdf_name
          // }
          // }).then(function success(response) {

          // })
        });
      });
    }

    function updateSiniestroStatus(status) {
      if (vm.facturas.length == 0 && vm.status.id == 3) {
        SweetAlert.swal(
          "Facturación",
          "No existen facturas, agréguelas para continuar",
          "warning"
        );
        return;
      }
      // ------
      $scope.factura_proc = false;
      if (!vm.facturas.length == 0) {
        vm.facturas.forEach(function (factura) {
          if (factura.procedente == 0) {
            $scope.factura_proc = true;
          }
        });
      }
      if ($scope.factura_proc == true && vm.status.id == 3) {
        SweetAlert.swal(
          "Facturación",
          "Agregue el procedente correspondiente a la factura",
          "warning"
        );
        return;
      }
      // -------
      if (status.id == 3 && vm.infoSiniestro.siniestro.status == 1) {
        SweetAlert.swal("No puedes completar una póliza desde este estatus");
        vm.status.id = vm.infoSiniestro.siniestro.status;
        return;
      }

      if (status.id == 2 && vm.infoSiniestro.siniestro.status != 2) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_en_tramite_modal.html",
          controller: ModalInstanceCtrlSiniestroEnTramiteDanos,
          resolve: {
            factura: function () {
              return url;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
      }
      if (
        (status.id == 4 && vm.infoSiniestro.siniestro.status != 4) ||
        (status.id == 5 && vm.infoSiniestro.siniestro.status != 5)
      ) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_cancel_modal.html",
          controller: ModalInstanceCtrlCancelSiniestro,
          resolve: {
            factura: function () {
              return url;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
      }

      if (
        vm.status.id == 3 &&
        vm.infoSiniestro.siniestro.status != 3 &&
        vm.infoSiniestro.accidente.tipo_pago != 2
      ) {
        $location.hash("pre_completado");
        $anchorScroll();
        SweetAlert.swal(
          "Advertencia",
          MESSAGES.WARNING.WARNINGSINIESTER,
          "warning"
        );
      }
      if (status.id == 6 || status.id == 1) {
        $scope.actualizando = true;
        $http
          .patch(vm.infoSiniestro.siniestro.url, { status: status.id })
          .then(function (siniestro) {
            if (siniestro.status === 200 || siniestro.status === 201) {
              vm.infoSiniestro.siniestro = siniestro.data;
              $scope.siniestro_info = siniestro.data;
              $scope.idSiniestro = siniestro.data.id;

              if (siniestro.data.status == 6) {
                $scope.statusSinister = "En espera";
                $scope.actualizando = false;
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: vm.infoSiniestro.siniestro.id,
                  identifier:
                    " en espera el siniestro " +
                    vm.infoSiniestro.siniestro.numero_siniestro
                      ? vm.infoSiniestro.siniestro.numero_siniestro
                      : vm.infoSiniestro.siniestro.folio_interno,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
              }
              if (siniestro.data.status == 1) {
                $scope.statusSinister = "Pendiente";
                $scope.actualizando = false;
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: vm.infoSiniestro.siniestro.id,
                  identifier:
                    "pendiente el siniestro " +
                    vm.infoSiniestro.siniestro.numero_siniestro
                      ? vm.infoSiniestro.siniestro.numero_siniestro
                      : vm.infoSiniestro.siniestro.folio_interno,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
              }
              SweetAlert.swal(
                "¡Listo!",
                MESSAGES.OK.SINIESTERUPDATED,
                "success"
              );
            }
          });
      }
    }
    function getLog() {
      dataFactory
        .get("get-specific-log", {
          model: 5,
          associated_id: vm.infoSiniestro.siniestro.id,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    }
    function updateSiniestro() {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/siniestro_completado_modal.html",
        controller: ModalInstanceCtrlSiniestroCompletado,
        resolve: {
          vm: function () {
            return vm;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      // return;
    }

    function getPdf() {}

    function downloadFacturas(siniestro) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "data:application/vnd.ms-excel;charset=UTF-8",
        }
      );
      saveAs(blob, "Concentrado_Facturas" + ".xls");
    }

    function ModalInstanceCtrlCancelSiniestro(
      $scope,
      $uibModal,
      factura,
      $uibModalInstance
    ) {
      $scope.ok = function () {
        var razon = $scope.cancelRazon;
        if (razon == null) {
          SweetAlert.swal("Dato requerido", "Escriba la razón", "error");
          return;
        }
        $http
          .patch(vm.infoSiniestro.siniestro.url, {
            status: vm.status.id,
            reason: razon,
          })
          .then(function (siniestro) {
            if (siniestro.status === 200 || siniestro.status === 201) {
              $scope.siniestro_info = siniestro.data;
              $scope.idSiniestro = siniestro.data.id;
              if (siniestro.data.status == 4) {
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: vm.infoSiniestro.siniestro.id,
                  identifier:
                    "cancelo el siniestro " +
                    vm.infoSiniestro.siniestro.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
                // if (vm.infoSiniestro.poliza.contractor){
                //     $http.get(vm.infoSiniestro.poliza.contractor)
                //       .then(function(response) {
                //         if(response.data.email){
                //             if($localStorage.email_config){
                //                 if($localStorage.email_config.cancelacion_siniestro == true){
                //                     var model = 12;
                //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                 }
                //             }
                //         }
                //     });
                // }
              }
              if (siniestro.data.status == 5) {
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: vm.infoSiniestro.siniestro.id,
                  identifier:
                    "rechazo el siniestro " +
                    vm.infoSiniestro.siniestro.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
                // if (vm.infoSiniestro.poliza.contractor){
                //     $http.get(vm.infoSiniestro.poliza.contractor)
                //       .then(function(response) {
                //         if(response.data.email){
                //             if($localStorage.email_config){
                //                 if($localStorage.email_config.rechazo_siniestro == true){
                //                     var model = 13;
                //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                 }
                //             }
                //         }
                //     });
                // }
              }
              SweetAlert.swal(
                "¡Listo!",
                MESSAGES.OK.SINIESTERUPDATED,
                "success"
              );
              $state.go(
                "siniestros.danio_info",
                { siniestroId: vm.infoSiniestro.siniestro.id },
                {
                  reload: "siniestros.danio_info",
                  inherit: false,
                  notify: true,
                  location: "replace",
                }
              );
            }
          });
        $uibModalInstance.dismiss("cancel");
        // fillTable(vm.ramos.ramo_selected)
        $state.go(
          "siniestros.danio_info",
          { siniestroId: vm.infoSiniestro.siniestro.id },
          {
            reload: "siniestros.danio_info",
            inherit: false,
            notify: true,
            location: "replace",
          }
        );
      };

      $scope.cancel = function () {
        $rootScope.statusLabel = "Cambiar Estatus";
        $uibModalInstance.dismiss("cancel");
        vm.status.id = vm.infoSiniestro.siniestro.status;
      };
    }

    function ModalInstanceCtrlSiniestroEnTramiteDanos(
      $scope,
      $uibModal,
      factura,
      $uibModalInstance,
      $location
    ) {
      $scope.aux_fecha_promesa = new Date();
      $scope.fc_visible = false;
      if ($location.$$path.indexOf("/siniestros/danios/") != -1) {
        $scope.fc_visible = true;
      }
      $scope.ok = function () {
        $scope.aux_fecha_promesa = $("#date")[0].value;
        $scope.aux_fecha_promesa = new Date($scope.aux_fecha_promesa);
        vm.fecha_promesa = $scope.aux_fecha_promesa;
        vm.siniester_data.companyFolio = $scope.aux_folio;
        if (
          !vm.siniester_data.companyFolio ||
          vm.siniester_data.companyFolio.length == 0 ||
          vm.fecha_promesa == "Invalid Date"
        ) {
          SweetAlert.swal("Dato requerido", "Complete los datos", "error");
          return;
        }
        $uibModalInstance.dismiss("cancel");

        saveEditInformation();
      };

      $scope.cancel = function () {
        $rootScope.statusLabel = "Cambiar Estatus";
        $uibModalInstance.dismiss("cancel");
        vm.status.id = vm.infoSiniestro.siniestro.status;
      };
    }

    $scope.statusSinister = "";
    function activate() {
      $scope.fileSinister = true;

      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 5,
          id_model: vm.siniestro_id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            next: request.data.next,
            previous: request.data.previous,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      $http
        .get(url.IP + "siniestros-danios-info/" + vm.siniestro_id)
        .then(function (siniestro) {
          vm.infoSiniestro = siniestro.data;
          updateStatusList();
          // dataFactory.get('has-view-cartas-permission')
          // .then(function(req) {
          //     if(req.status == 200) {
          //         $scope.view_cartas = req.data;
          //     }
          // });

          $http({
            method: "GET",
            url: url.IP + "cartas-by-model",
            params: {
              model: 5,
            },
          }).then(function success(response) {
            vm.cartas = response.data;
          });

          if (vm.infoSiniestro.siniestro.status == 1) {
            $scope.statusSinister = "Pendiente";
          } else if (vm.infoSiniestro.siniestro.status == 2) {
            $scope.statusSinister = "En trámite";
          } else if (vm.infoSiniestro.siniestro.status == 3) {
            $scope.statusSinister = "Completado";
          } else if (vm.infoSiniestro.siniestro.status == 4) {
            $scope.statusSinister = "Cancelada";
          } else if (vm.infoSiniestro.siniestro.status == 5) {
            $scope.statusSinister = "Rechazada";
          } else if (vm.infoSiniestro.siniestro.status == 6) {
            $scope.statusSinister = "En espera";
          }
          vm.status.id = siniestro.data.siniestro.status;
          vm.siniester_data.observations =
            vm.infoSiniestro.siniestro.observations;

          if (siniestro.data.poliza.aseguradora) {
            providerService
              .getProviderById(siniestro.data.poliza.aseguradora)
              .then(function (aseguradora) {
                vm.affect_data.aseguradora = {
                  compania: aseguradora.data.alias,
                  url: aseguradora.data.url,
                };
              });
          } else {
            $http
              .get(
                url.IP + "leer-polizas-edit/" + siniestro.data.poliza.id + "/"
              )
              .then(function (policy) {
                vm.provisionalInfo = policy.data;
                if (vm.provisionalInfo.parent.parent.parent) {
                  vm.affect_data.aseguradora = {
                    compania:
                      vm.provisionalInfo.parent.parent.parent.aseguradora,
                  };
                }
                if (!vm.affect_data.aseguradora) {
                  $http
                    .get(policy.data.parent.parent.parent.aseguradora)
                    .then(function (aseguradora) {
                      vm.affect_data.aseguradora = {
                        compania: aseguradora.data.alias,
                        url: aseguradora.data.url,
                      };
                    });
                }
              });
          }

          if (siniestro.data.poliza.document_type == 3) {
            // console.log(siniestro)
            vm.selected_affect = siniestro.data.siniestro.aux_affected;
          }
          try {
            vm.infoSiniestro.siniestro.fecha_compromiso = new Date(
              vm.infoSiniestro.siniestro.fecha_compromiso
            );
          } catch (e) {}
          if (vm.infoSiniestro.danios_sin) {
            var danios = vm.infoSiniestro.danios_sin;
            vm.selected_affect = vm.infoSiniestro.danios_sin.bien_asegurado;
            vm.contacts = danios.contacto_danio;
          }
          vm.fecha_compromiso = siniestro.data.siniestro.fecha_compromiso;
          vm.folio_siniestro = siniestro.data.siniestro.folio_compania;
          vm.siniester_data.capture_date = siniestro.data.siniestro.created_at;
          try {
            vm.infoSiniestro.siniestro.siniestro.fecha_ingreso = new Date(
              vm.infoSiniestro.siniestro.siniestro.fecha_ingreso
            );
          } catch (u) {}
          try {
            vm.infoSiniestro.siniestro.siniestro.fecha_compromiso = new Date(
              vm.infoSiniestro.siniestro.siniestro.fecha_compromiso
            );
          } catch (u) {}
          if (siniestro.data.poliza.contractor) {
            $http
              .get(siniestro.data.poliza.contractor)
              .then(function (contratante) {
                var name = contratante.data;
                vm.infoSiniestro.contratante_email = name.email;
                vm.affect_data.contratante = {
                  name: name.full_name,
                  url: contratante.data.url,
                  birthdate: new Date(contratante.data.birth_date),
                };
                vm.affect_data.contractor_addres = {
                  address:
                    contratante.data.address_contractor[0].route +
                    " #" +
                    contratante.data.address_contractor[0].street_number +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_2 +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_1,
                  url: contratante.data.address_contractor[0].url,
                };
              });
          } else {
            $http
              .get(
                url.IP + "leer-polizas-edit/" + siniestro.data.poliza.id + "/"
              )
              .then(function (policy) {
                if (policy.data.parent.parent.contractor) {
                  vm.infoSiniestro.contratante_email = name.email;
                  var name = policy.data.parent.parent.contractor;
                  vm.affect_data.contratante = {
                    name: name.full_name,
                    url: name.url,
                  };
                  vm.affect_data.contractor_addres = {
                    address:
                      name.address_contractor[0].route +
                      " #" +
                      name.address_contractor[0].street_number +
                      " " +
                      name.address_contractor[0].administrative_area_level_2 +
                      " " +
                      name.address_contractor[0].administrative_area_level_1,
                    url: name.address_contractor[0].url,
                  };
                } else if (policy.data.parent.parent.parent.contractor) {
                  var name = policy.data.parent.parent.parent.contractor;
                  vm.infoSiniestro.contratante_email = name.email;
                  vm.affect_data.contratante = {
                    name: name.full_name,
                    url: name.url,
                  };
                  vm.affect_data.contractor_addres = {
                    address:
                      name.address_contractor[0].route +
                      " #" +
                      name.address_contractor[0].street_number +
                      " " +
                      name.address_contractor[0].administrative_area_level_2 +
                      " " +
                      name.address_contractor[0].administrative_area_level_1,
                    url: name.address_contractor[0].url,
                  };
                }
              });
          }
          vm.affect_data.policy_number = siniestro.data.poliza.poliza_number;
          ramoService
            .getSubramoById(siniestro.data.poliza.subramo)
            .then(function (res) {
              vm.siniester_data.subramo = {
                subramo_name: res.data.subramo_name,
                url: siniestro.data.poliza.subramo,
              };
            });

          vm.affect_data.policy_vigencia = new Date(
            siniestro.data.poliza.end_of_validity
          );
          vm.affect_data.policy_vigencia_init = new Date(
            siniestro.data.poliza.start_of_validity
          );
          if (siniestro.data.poliza.paquete) {
            packageService
              .getOnlyPackageById(siniestro.data.poliza.paquete)
              .then(function (paquete) {
                vm.affect_data.paquete = {
                  package_name: paquete.data.package_name,
                  url: paquete.data.url,
                };
              });
          }

          vm.affect_data.siniester_date = new Date(
            siniestro.data.siniestro.fecha_siniestro
          );
          vm.siniester_data.siniester_number =
            siniestro.data.siniestro.numero_siniestro;

          siniestro.data.facturas.forEach(function (factura) {
            var obj = {
              f_number: factura.numero_factura,
              proovedor: factura.proveedor,
              f_date: datesFactory.convertDate(factura.fecha_factura),
              import: parseFloat(factura.importe),
              iva: factura.iva,
              total: factura.total,
              procedente: parseFloat(factura.procedente),
              url: factura.url,
              serie: factura.serie,
              observaciones: factura.observaciones,
            };
            vm.facturas.push(obj);
          });
          fileService
            .getFiles(url.IP + "siniestros/" + vm.siniestro_id + "/archivos/")
            .then(function (files) {
              files.forEach(function (file) {
                vm.files.push(file);
              });
            });
        });
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              } else if (acc.permission_name == "Cancelar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_canc_pol = true;
                } else {
                  vm.acceso_canc_pol = false;
                }
              } else if (acc.permission_name == "Eliminar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_elim_pol = true;
                } else {
                  vm.acceso_elim_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Formatos") {
            vm.acceso_form = perm;
            vm.acceso_form.permissions.forEach(function (acc) {
              if (acc.permission_name == "Formatos") {
                if (acc.checked == true) {
                  vm.acceso_form = true;
                } else {
                  vm.acceso_form = false;
                }
              }
            });
          } else if (perm.model_name == "Siniestros") {
            vm.acceso_sin = perm;
            vm.acceso_sin.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar siniestros") {
                if (acc.checked == true) {
                  vm.acceso_adm_sin = true;
                } else {
                  vm.acceso_adm_sin = false;
                }
              }
            });
          } else if (perm.model_name == "Archivos") {
            vm.permarch = perm;
            vm.permarch.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  vm.permiso_administrar_adjuntos = true;
                } else {
                  vm.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
        });
      }
    }
    function cancel() {
      $state.go("siniestros.lista");
    }

    function updateStatusList() {
      var estado = vm.infoSiniestro.siniestro.status;
      switch (estado) {
        case 1:
          (vm.status = { id: 0, label: "Estatus" }),
            (vm.statuses = [
              { id: 2, label: "En trámite" },
              { id: 4, label: "Cancelada" },
              { id: 5, label: "Rechazada" },
              { id: 6, label: "En espera" },
            ]);
          break;
        case 2:
          (vm.status = { id: 0, label: "Estatus" }),
            (vm.statuses = [
              { id: 3, label: "Completado" },
              { id: 4, label: "Cancelada" },
              { id: 5, label: "Rechazada" },
              { id: 6, label: "En espera" },
            ]);
          break;
        case 3:
          (vm.status = { id: 0, label: "Estatus" }), (vm.statuses = []);
          break;
        case 4:
          vm.statuses = [];
          break;
        case 5:
          vm.statuses = [];
          break;
      }
    }

    function viewObservation(url, SiniesterStatus) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/facturas.observation.html",
        controller: ModalInstanceCtrlObservationsfact,
        resolve: {
          obj: function () {
            return { url: url, SiniesterStatus: SiniesterStatus };
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function ModalInstanceCtrlObservationsfact(
      $scope,
      $uibModal,
      obj,
      $uibModalInstance
    ) {
      $scope.SiniesterStatus = obj.SiniesterStatus;
      $http.get(obj.url).then(function (data) {
        $scope.observation_aux = data.data.observaciones;
      });

      $scope.ok = function () {
        var observ = {
          observaciones: $scope.observation_aux,
        };
        $http.patch(obj.url, observ).then(function (data) {
          if (data.status === 200 || data.status === 201) {
            $uibModalInstance.dismiss("cancel");
            var params = {
              model: 5,
              event: "PATCH",
              associated_id: vm.infoSiniestro.siniestro.id,
              identifier:
                "actualizo el siniestro" +
                vm.infoSiniestro.siniestro.numero_siniestro +
                " agrego observaciones",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          }
        });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    function ramo_changed() {
      fillTable(vm.ramos.ramo_selected);
    }

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      if (item.padecimiento_type == undefined) {
        item.padecimiento_type = "";
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].type_document = item.padecimiento_type;
    };

    function uploadFiles(siniestro_id, doc_type) {
      $scope.userInfo = {
        id: siniestro_id,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "siniestros/" + siniestro_id + "/archivos/";
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve($scope.uploader.uploadAll());
          return defer.promise;
        })
        .then(function () {
          toaster.success("Se han subido sus archivos correctamente");
          setTimeout(function () {
            fileService
              .getFiles(url.IP + "siniestros/" + vm.siniestro_id + "/archivos/")
              .then(function (res) {
                res.forEach(function (file) {
                  vm.files.push(file);
                });
              });
          }, 100);
        });
    }

    function addFactura() {
      var factura = {
        f_number: "",
        proovedor: "",
        f_date: "",
        import: "",
        iva: "",
        total: "",
        procedente: 0,
      };
      vm.facturas.push(factura);
    }

    $scope.calculateIva = function (index, item) {
      vm.facturas[index].import = parseFloat(item);
      vm.facturas[index].iva = parseFloat(
        (vm.facturas[index].import * 0.16).toFixed(2)
      );
      vm.facturas[index].total =
        vm.facturas[index].import + vm.facturas[index].iva;
      vm.facturas[index].total = vm.facturas[index].total.toFixed(2);
      if (item == "") {
        vm.facturas[index].import = 0;
        vm.facturas[index].iva = 0;
        vm.facturas[index].total = 0;
      }
    };

    $scope.calculateTotal = function (index, iva) {
      if (iva) {
        vm.facturas[index].iva = parseFloat(iva);
      } else if (iva == "") {
        vm.facturas[index].iva = 0;
      }
      if (vm.facturas[index].import) {
        vm.facturas[index].import = parseFloat(vm.facturas[index].import);
      }
      vm.facturas[index].total =
        vm.facturas[index].import + vm.facturas[index].iva;
      vm.facturas[index].total = vm.facturas[index].total.toFixed(2);
    };

    function Exist(list, obj) {
      for (var i = 0; i < list.length; i++) {
        if (obj.value == list[i].value) {
          return true;
        }
      }
      return false;
    }

    function changeSinesterNumber() {
      try {
        $http
          .get(vm.siniester_data.siniester_number.value.accidente.padecimiento)
          .then(function (enfermedad) {
            var obj = {
              label: enfermedad.data.code + " - " + enfermedad.data.descr,
              value: {
                code: enfermedad.data.code,
                url: enfermedad.data.url,
              },
            };
            vm.selected_disease = obj;
            var type_accident =
              vm.siniester_data.siniester_number.value.accidente
                .razon_siniestro;
            switch (type_accident) {
              case 1:
                $('#siniestroType option[value="1"]').attr(
                  "selected",
                  "selected"
                );
                break;
              case 2:
                $('#siniestroType option[value="2"]').attr(
                  "selected",
                  "selected"
                );
                break;
              case 3:
                $('#siniestroType option[value="3"]').attr(
                  "selected",
                  "selected"
                );
                break;
              default:
                break;
            }
          });
      } catch (err) {}
    }
    function ModalInstanceCtrlSiniestroCompletado(
      $scope,
      $uibModal,
      status,
      $uibModalInstance,
      vm
    ) {
      $scope.beneficiaries = vm.beneficiaries;
      // $scope.coverage = vm.selectedPoliza.data.coverageInPolicy_policy[0]
      $scope.imndemnizacion = 0.0;
      $scope.ok = function (ind, ded, coa) {
        if (vm.facturas) {
          console.log("-----sss----s-", vm.facturas);
        } else {
          SweetAlert.swal(
            "Facturas",
            "Agregue las Facturas con campos completos",
            "error"
          );
          return;
        }
        if (
          $scope.imndemnizacion == 0 ||
          $scope.imndemnizacion == null ||
          $scope.imndemnizacion == "0"
        ) {
          SweetAlert.swal("Dato requerido", "Complete la información", "error");
          return;
        }
        var status_obj = {
          status: 3,
          observations: vm.siniester_data.observations,
        };
        if (status_obj.status == 3) {
          var params = {
            model: 5,
            event: "PATCH",
            associated_id: vm.infoSiniestro.siniestro.id,
            identifier: "actualizo el siniestro a estatus Completado ",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          $scope.idSiniestro = vm.infoSiniestro.id;
          // if(vm.infoSiniestro.poliza){
          //     if (vm.infoSiniestro.poliza.contractor){
          //         $http.get(vm.infoSiniestro.poliza.contractor)
          //           .then(function(response) {
          //             if(response.data.email){
          //                 // Send email
          //                 if($localStorage.email_config){
          //                     if($localStorage.email_config.fin_siniestro == true){
          //                         var model = 4;
          //                         emailService.sendEmailAtm(model,$scope.idSiniestro)
          //                     }
          //                 }
          //                 // Send Email
          //             }
          //         });
          //     }
          //     //Send Email
          // }
        }
        $http.patch(vm.infoSiniestro.siniestro.url, status_obj);
        // -----------facturas
        vm.facturas.forEach(function (factura, index) {
          if (!factura.import) {
            SweetAlert.swal(
              "Facturas",
              "Agregue las Facturas con campos completos",
              "error"
            );
            return;
            factura.import = 0.0;
          }
          if (!factura.iva) {
            SweetAlert.swal(
              "Facturas",
              "Agregue las Facturas con campos completos",
              "error"
            );
            return;
            factura.iva = 0.0;
          }
          if (!factura.total) {
            factura.total = 0.0;
          }

          //Si el estatus del siniestro es completado, entonces agrega el procedente de la factura
          if (vm.infoSiniestro.siniestro.status == 3) {
            var obj_factura = {
              siniestro: vm.infoSiniestro.siniestro.url,
              numero_factura: factura.f_number,
              proveedor: factura.proovedor,
              fecha_factura: new Date(factura.f_date),
              importe: factura.import.toFixed(2),
              iva: factura.iva.toFixed(2),
              total: factura.total,
              procedente: factura.procedente
                ? parseFloat(factura.procedente).toFixed(2)
                : 0,
            };
          }
          //si el siniestro es distinto a completado no incluye el procedente por factura
          else {
            var obj_factura = {
              siniestro: vm.infoSiniestro.siniestro.url,
              numero_factura: factura.f_number,
              proveedor: factura.proovedor,
              fecha_factura: new Date(factura.f_date),
              importe: factura.import.toFixed(2),
              iva: factura.iva.toFixed(2),
              total: factura.total,
            };
          }

          if (factura.url) {
            $http.patch(factura.url, obj_factura).then(function (facturax) {
              if (facturax) {
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: vm.infoSiniestro.siniestro.id,
                  identifier:
                    "actualizo facturas  del siniestro" +
                    vm.infoSiniestro.siniestro.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
              }
            });
          } else {
            $http
              .post(url.IP + "facturas/", obj_factura)
              .then(function (facturax) {
                if (facturax) {
                  var params = {
                    model: 5,
                    event: "POST",
                    associated_id: vm.infoSiniestro.siniestro.id,
                    identifier: "creo facturas al Siniestro ",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                }
              });
          }
        });

        var indemnizacion_obj = {
          indemnizacion: $scope.imndemnizacion,
          total_deducible: ded ? ded : 0,
          total_coaseguro: coa ? coa : 0,
        };
        if (vm.infoSiniestro.danios_sin) {
          $http.patch(vm.infoSiniestro.danios_sin.url, indemnizacion_obj);
          $uibModalInstance.dismiss("cancel");
          SweetAlert.swal("¡Listo!", MESSAGES.OK.SINIESTERUPDATED, "success");
          // $state.go('siniestros.lista');
          $state.go(
            "siniestros.danio_info",
            {
              siniestroId: vm.infoSiniestro.siniestro.id
                ? vm.infoSiniestro.siniestro.id
                : siniestro.data.id,
            },
            {
              reload: "siniestros.danio_info",
              inherit: false,
              notify: true,
              location: "replace",
            }
          );
          // $state.go('siniestros.danio_info', {siniestroId: vm.infoSiniestro.siniestro.id ? vm.infoSiniestro.siniestro.id : siniestro.data.id});
        } else {
          $uibModalInstance.dismiss("cancel");
          SweetAlert.swal("¡Error!", MESSAGES.ERROR.SINIESTERERROR, "error");
          $state.go("siniestros.lista");
        }
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
        return;
      };
    }

    function saveEditInformation() {
      if (vm.status.id == 3 && vm.infoSiniestro.status != 3) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_completado_autos_modal.html",
          controller: ModalInstanceCtrlSiniestroCompletado,
          resolve: {
            vm: function () {
              return vm;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        // return;
      } else if (vm.status.id == 3 && vm.infoSiniestro.siniestro.status != 3) {
        var modalInstance = $uibModal.open({
          templateUrl: "app/siniestros/siniestro_completado_modal_prog.html",
          controller: ModalInstanceCtrlSiniestroCompletado,
          resolve: {
            vm: function () {
              return vm;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        // return;
      }

      patchSiniester();
    }

    function updateReclamado() {
      $scope.total_reclamado = 0;
      vm.infoSiniestro.facturas.forEach(function (factura) {
        $scope.total_reclamado =
          parseFloat($scope.total_reclamado) + parseFloat(factura.total);
      });
      if (vm.infoSiniestro.danios_sin) {
        $http.patch(vm.infoSiniestro.danios_sin.url, {
          total_reclamado: $scope.total_reclamado,
        });
        toaster.success("Se actualizo el siniestro");
      } else {
        toaster.error(
          "Ocurrio un error al actualizar parámetros del siniestro"
        );
      }
    }

    function patchSiniester(obj) {
      updateReclamado();
      var obj_siniestro = {
        folio_compania: vm.siniester_data.companyFolio,
        status: vm.status.id,
        fecha_compromiso: vm.fecha_promesa,
        fecha_siniestro: new Date(vm.affect_data.siniester_date),
        tipo_siniestro_general:
          vm.infoSiniestro.siniestro.tipo_siniestro_general,
        observations: vm.siniester_data.observations,
        numero_siniestro: vm.siniester_data.siniester_number,
      };
      $http
        .patch(vm.infoSiniestro.siniestro.url, obj_siniestro)
        .then(function (siniestro) {
          if (siniestro.status === 200 || siniestro.status === 201) {
            if (siniestro.data.status == 3) {
              var params = {
                model: 5,
                event: "PATCH",
                associated_id: siniestro.data.id,
                identifier: "actualizo un siniestro estatus Completado ",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              $scope.idSiniestro = siniestro.data.id;
              // if (vm.infoSiniestro.poliza.contractor){
              //     $http.get(vm.infoSiniestro.poliza.contractor)
              //       .then(function(response) {
              //         if(response.data.email){
              //             if($localStorage.email_config){
              //                 if($localStorage.email_config.fin_siniestro == true){
              //                     var model = 4;
              //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
              //                 }
              //             }
              //         }
              //     });
              // }
            }
            if (siniestro.data.status == 2) {
              $scope.idSiniestro = siniestro.data.id;
              var params = {
                model: 5,
                event: "PATCH",
                associated_id: $scope.idSiniestro,
                identifier: "actualizo un siniestro estatus En Trámite",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              // if (vm.infoSiniestro.poliza.contractor){
              //     $http.get(vm.infoSiniestro.poliza.contractor)
              //       .then(function(response) {
              //         if(response.data.email){
              //             if($localStorage.email_config){
              //                 if($localStorage.email_config.tramite_siniestro == true){
              //                     var model = 11;
              //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
              //                 }
              //             }
              //         }
              //     });
              // }
            }

            if (siniestro.data.status == 6) {
              $scope.idSiniestro = siniestro.data.id;
              var params = {
                model: 5,
                event: "PATCH",
                associated_id: $scope.idSiniestro,
                identifier: "actualizo un siniestro estatus En espera",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              // if (vm.infoSiniestro.poliza.contractor){
              //     $http.get(vm.infoSiniestro.poliza.contractor)
              //       .then(function(response) {
              //         if(response.data.email){
              //             if($localStorage.email_config){
              //                 if($localStorage.email_config.espera_siniestro == true){
              //                     var model = 14;
              //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
              //                 }
              //             }
              //         }
              //     });
              // }
            }
          }

          // Facturas
          vm.facturas.forEach(function (factura, index) {
            if (!factura.import) {
              factura.import = 0.0;
            }
            if (!factura.iva) {
              factura.iva = 0.0;
            }
            if (!factura.total) {
              factura.total = 0.0;
            }
            if (vm.status.id == 3) {
              var obj_factura = {
                siniestro: siniestro.data.url,
                numero_factura: factura.f_number,
                proveedor: factura.proovedor,
                fecha_factura: new Date(factura.f_date),
                importe: factura.import.toFixed(2),
                iva: factura.iva.toFixed(2),
                total: factura.total,
                procedente: factura.procedente
                  ? parseFloat(factura.procedente).toFixed(2)
                  : 0,
              };
            } else {
              var obj_factura = {
                siniestro: siniestro.data.url,
                numero_factura: factura.f_number,
                proveedor: factura.proovedor,
                fecha_factura: new Date(factura.f_date),
                importe: factura.import.toFixed(2),
                iva: factura.iva.toFixed(2),
                total: factura.total,
                procedente: factura.procedente
                  ? parseFloat(factura.procedente).toFixed(2)
                  : 0,
              };
            }

            if (factura.url) {
              $http.patch(factura.url, obj_factura).then(function (facturax) {
                if (facturax.status === 200 || facturax.status === 201) {
                  if (facturax) {
                    var params = {
                      model: 5,
                      event: "PATCH",
                      associated_id: siniestro.data.id,
                      identifier: "actualizo facturas  del siniestro",
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                  }
                }
              });
            } else {
              $http
                .post(url.IP + "facturas/", obj_factura)
                .then(function (facturax) {
                  if (facturax.status === 200 || facturax.status === 201) {
                    if (facturax) {
                      var params = {
                        model: 5,
                        event: "POST",
                        associated_id: siniestro.data.id,
                        identifier: "creo facturas al Siniestro ",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                    }
                  }
                });
            }
          });

          uploadFiles(siniestro.data.id, $scope.padecimiento_type);

          var pago;
          switch ($('input[name="payWay"]:checked').val()) {
            case "reembolso":
              pago = 1;
              break;
            case "programacion":
              pago = 2;
              break;
            case "pagoDirecto":
              pago = 3;
              break;
            default:
              break;
          }
          var razon;
          var pago_;
          razon = $("#siniestroType option:selected").val();
          pago_ = $("#payWay option:selected").val();
          if (obj) {
            var total_final_pre =
              obj.procedente - obj.coaseguro - obj.deducible;
            var obj_accidente = {
              tipo_pago: pago,
              total_reclamado: obj.reclamado
                ? parseFloat(obj.reclamado).toFixed(2)
                : 0,
              total_procedente: obj.procedente
                ? parseFloat(obj.procedente).toFixed(2)
                : 0,
              total_coaseguro: obj.coaseguro,
              total_deducible: obj.deducible,
              total_final: parseFloat(total_final_pre).toFixed(2),
              complemento_siniestro: obj.complemento,
              monto_hospital: obj.monto_hospital ? obj.monto_hospital : 0,
              ded_hospital: obj.ded_hospital ? obj.ded_hospital : 0,
              coas_hospital: obj.coas_hospital ? obj.coas_hospital : 0,
              monto_honorarios: obj.monto_honorarios ? obj.monto_honorarios : 0,
              ded_honorarios: obj.ded_honorarios ? obj.ded_honorarios : 0,
              coas_honorarios: obj.coas_honorarios ? obj.coas_honorarios : 0,
              cirujano: obj.cirujano ? obj.cirujano : 0,
              anestesiologo: obj.anestesiologo ? obj.anestesiologo : 0,
              ayudante: obj.ayudante ? obj.ayudante : 0,
              otros: obj.otros ? obj.otros : 0,
              hospital: obj.hospital ? obj.hospital : "",
              fecha_cirugia: obj.fecha_cirugia ? obj.fecha_cirugia : null,
            };
          } else {
            var obj_accidente = {
              tipo_pago: pago_,
              razon_siniestro: razon,
            };
          }
          if (vm.infoSiniestro.danios_sin) {
            $http
              .patch(vm.infoSiniestro.danios_sin.url, obj_accidente)
              .then(function (accidente) {
                if (accidente.status == 200 || accidente.status == 201) {
                  // fillTable(2);
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.SINIESTERUPDATED,
                    "success"
                  );
                  var params = {
                    model: 5,
                    event: "PATCH",
                    associated_id: vm.infoSiniestro.siniestro.id
                      ? vm.infoSiniestro.siniestro.id
                      : siniestro.data.id,
                    identifier:
                      "actualizo el siniestro " +
                      vm.infoSiniestro.siniestro.numero_siniestro,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});

                  $state.go(
                    "siniestros.danio_info",
                    {
                      siniestroId: vm.infoSiniestro.siniestro.id
                        ? vm.infoSiniestro.siniestro.id
                        : siniestro.data.id,
                    },
                    {
                      reload: "siniestros.danio_info",
                      inherit: false,
                      notify: true,
                      location: "replace",
                    }
                  );
                  // $state.go('siniestros.lista');
                  // $state.reload();
                  // $state.go('siniestros.danio_info', {siniestroId: vm.infoSiniestro.siniestro.id ? vm.infoSiniestro.siniestro.id : siniestro.data.id});
                } else {
                  SweetAlert.swal("Error", "Ha ocurrido un error", "error");
                }
              });
          } else {
            SweetAlert.swal("Error", "Ha ocurrido un error", "error");
          }
        });
    }
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;
    function addContact() {
      var contact = {
        first_name: "",
        phone: "",
        email: "",
        references: "",
        org_name: usr.org,
      }; //jshint ignore:line
      vm.contacts.push(contact);
    }

    function deleteContacts(url, index) {
      vm.contacts.splice(index, 1);
    }
    vm.saveContact = saveContact;
    function saveContact(contactos) {
      $scope.cnuevos = [];
      contactos.forEach(function (cn) {
        if (cn.id) {
          dataFactory
            .update("contactdanios/" + cn.id + "/", cn)
            .then(function success(response) {
              if (response.status == 200 || response.status == 201) {
                $scope.cnuevos.push(response.data);
                if ($scope.cnuevos.length == contactos.length) {
                  vm.contacts = $scope.cnuevos;
                }
              } else {
                $scope.cnuevos.push(cn);
                if ($scope.cnuevos.length == contactos.length) {
                  vm.contacts = $scope.cnuevos;
                }
              }
            });
        } else {
          cn.danio = vm.infoSiniestro.danios_sin.url;
          dataFactory
            .post("contactdanios/", cn)
            .then(function success(response) {
              if (response.status == 200 || response.status == 201) {
                $scope.cnuevos.push(response.data);
                if ($scope.cnuevos.length == contactos.length) {
                  vm.contacts = $scope.cnuevos;
                }
              }
            });
        }
      });
    }
    function LookFor() {
      vm.show_affected = true;
      helpers.getDiseases().then(function (data) {
        var enfermedades_aux = data.data.results;
        enfermedades_aux.forEach(function (enfermedad) {
          var obj = {
            label: enfermedad.code + " - " + enfermedad.descr,
            value: {
              code: enfermedad.code,
              url: enfermedad.url,
            },
          };
          vm.enfermedades.push(obj);
        });
      });

      $http
        .get(url.IP + "polizas/" + vm.selected_affect.value.id + "/")
        .then(function (poliza) {
          vm.selectedPoliza = poliza;
          $http.get(poliza.data.subramo).then(function (subramo) {
            vm.siniester_data.subramo = subramo.data;
          });

          var data = {
            title: vm.selected_affect.value.title,
            policy_vigencia: new Date(poliza.data.end_of_validity),
            policy_vigencia_init: new Date(poliza.data.start_of_validity),
            siniester_date: new Date(),
            policy_number: poliza.data.poliza_number,
          };

          if (vm.selected_affect.value.tittle_id == 1) {
            poliza.data.accidents_policy.forEach(function (titular) {
              $http.get(titular.personal).then(function (principal) {
                data["birthdate"] = principal.data.birthday;
              });
            });
          } else {
            poliza.data.accidents_policy.forEach(function (titular) {
              titular.relationship_accident.forEach(function (dependiente) {
                if (dependiente.first_name == vm.selected_affect.value.name) {
                  data["birthdate"] = dependiente.birthday;
                }
              });
            });
          }

          var waitReceipt = [];
          waitReceipt.push(
            $http.get(url.IP + "get-current-receipt/" + poliza.data.id)
          );
          $q.all(waitReceipt).then(function (response) {
            var status = response[0].data.status;
            switch (status) {
              case 1:
                data["policy_status"] = "Pagado";
                break;
              case 2:
                data["policy_status"] = "Cancelado";
                break;
              case 3:
                data["policy_status"] = "Prorrogado";
                break;
              case 4:
                data["policy_status"] = "Pendiente de pago";
                break;
              default:
                data["policy_status"] = "Sin Estatus";
            }
          });
          if (poliza.data.contractor) {
            $http.get(poliza.data.contractor).then(function (contratante) {
              data["contractor_addres"] =
                contratante.data.address_contractor[0];
              data["contratante"] = contratante.data;
              data["contratante"].name = contratante.data.full_name;
            });
          }
          $http.get(poliza.data.aseguradora).then(function (aseguradora) {
            data["aseguradora"] = aseguradora.data;
          });

          $http.get(poliza.data.paquete).then(function (paquete) {
            data["paquete"] = paquete.data;
          });

          vm.affect_data = data;
        });
    }

    function fillTable(ramo_number) {
      vm.siniestros = [];
      $http
        .get(url.IP + "siniestros-definidos/" + ramo_number)
        .then(function (siniestros) {
          if (siniestros.status == 200 || siniestros.status == 201) {
            if (siniestros.data) {
              siniestros.data.forEach(function (siniestro) {
                vm.siniestros.push(siniestro);
              });
            }
          }
        });
    }

    function deleteFactura(url, index) {
      if ((url && index) || (url && !index)) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "El registro se borrara permanentemente aunque no se hayan guardado los cambios.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, eliminar",
            cancelButtonText: "No, cancelar",
            closeOnConfirm: false,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              try {
                $http.delete(url).then(function (response) {
                  console.log(response);
                  if (response.status === 204) {
                    vm.facturas.splice(index, 1);
                    var params = {
                      model: 5,
                      event: "DELETE",
                      associated_id: vm.siniester_data.id,
                      identifier:
                        "elimino facturas del sinietsro" +
                        vm.siniester_data.numero_siniestro,
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                  }
                });
              } catch (err) {
                throw err;
              }
              SweetAlert.swal(
                "¡Eliminada!",
                "Tu factura ha sido eliminada.",
                "success"
              );
            } else {
              SweetAlert.swal("Cancelado", "", "error");
            }
          }
        );
      } else {
        vm.facturas.splice(index, 1);
      }
    }

    function deleteSiniestro(parUrl) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "¡Al eliminar tu siniestro no podra recuperarse nuevamente!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "No, cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            if (!parUrl) {
              $http
                .delete(url.IP + "siniestros/" + $stateParams.siniestroId)
                .then(function () {
                  SweetAlert.swal(
                    "Eliminado",
                    "Siniestro eliminado exitosamente",
                    "success"
                  );
                  var params = {
                    model: 5,
                    event: "DELETE",
                    associated_id: $stateParams.siniestroId,
                    identifier:
                      "elimino el sinietsro" +
                      vm.siniester_data.numero_siniestro,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  $state.go("siniestros.lista");
                });
            } else {
              $http.delete(parUrl).then(function () {
                SweetAlert.swal(
                  "Eliminado",
                  "Siniestro eliminado exitosamente",
                  "success"
                );
                var params = {
                  model: 5,
                  event: "DELETE",
                  associated_id: $stateParams.siniestroId,
                  identifier:
                    "elimino el sinietsro" + vm.siniester_data.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $state.go("siniestros.lista");
              });
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "Tu registro esta a salvo :)",
              "error"
            );
          }
        }
      );
    }

    function checkSubRamo(event) {}

    function showSubRamos(event) {
      vm.ramoId = event.target.id;
    }

    function textAExpand(event) {
      var element = e.target;
      var scroll = element.scrollHeight - 60;
      element.style.height = scrollHeight + "px";
    }

    function updateStatus() {
      insuranceService.getInsurances().then(function (polizas) {
        polizas.forEach(function (poliza) {
          poliza.accidents_policy.forEach(function (titular) {
            $http.get(titular.personal).then(function (name) {
              var obj = {
                label:
                  name.data.first_name +
                  " " +
                  name.data.last_name +
                  " " +
                  name.data.second_last_name +
                  "   -   " +
                  "poliza: " +
                  poliza.poliza_number,
                value: {
                  id: poliza.id,
                  title: titles[1],
                  tittle_id: 1,
                  name: name.data.first_name,
                  url: titular.personal,
                },
              };
              vm.affected.push(obj);
            });

            titular.relationship_accident.forEach(function (dependiente) {
              var obj = {
                label:
                  dependiente.first_name +
                  " " +
                  dependiente.last_name +
                  " " +
                  dependiente.second_last_name +
                  "   -   " +
                  "poliza: " +
                  poliza.poliza_number,
                value: {
                  id: poliza.id,
                  title: titles[dependiente.relationship],
                  tittle_id: dependiente.relationship,
                  name: dependiente.first_name,
                  url: dependiente.url,
                },
              };
              vm.affected.push(obj);
            });
          });
        });
      });
    }

    $rootScope.statusLabel = "Cambiar Estatus";
    $scope.changeLabel = function (status) {
      $rootScope.statusLabel = status.label;
      vm.status.id = status.id;
      vm.status.label = status.label;
      vm.updateSiniestroStatus(vm.status);
    };

    // Enviar correo electrónico Siniestro inicio***********
    function sendEmail(siniestro, poliza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/email_siniestro.html",
        controller: ModalEmailSiniestroCtrl,
        size: "lg",
        resolve: {
          from: function () {
            return null;
          },
          archivos: function () {
            return vm.files;
          },
          siniestro: function () {
            return siniestro;
          },
          poliza: function () {
            return poliza;
          },
          info: function () {
            return vm.infoSiniestro;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
      modalInstance.result.then(function (data) {});
    }
    function ModalEmailSiniestroCtrl(
      $uibModalInstance,
      $scope,
      archivos,
      siniestro,
      poliza,
      info
    ) {
      var vmm = this;
      $scope.data = {};
      $scope.send = false;
      $scope.files = archivos;
      $scope.siniestro = siniestro;
      $scope.poliza = poliza;
      $scope.emailcontractor = info.contratante_email;
      $scope.subjectEmail =
        "Información del Siniestro: " +
        (siniestro.numero_siniestro
          ? siniestro.numero_siniestro
          : siniestro.folio_interno
        ).toString() +
        ", de la Póliza: " +
        (poliza.poliza_number
          ? poliza.poliza_number
          : poliza.internal_number
        ).toString();
      $scope.close = function () {
        $uibModalInstance.dismiss();
      };
      $http
        .get(url.IP + "share-siniestro-manual/" + siniestro.id)
        .then(function (response) {
          if (response.status === 200) {
            $scope.body = response.data.body;
          }
        })
        .catch(function (e) {
          console.log("error - catch", e);
        });
      $scope.visualizar = function (data) {
        $uibModalInstance.close(data);
      };
      dataFactory
        .get("emailtemplate-unpag/", {
          template_model: 4,
          id_policy: poliza.id,
        })
        .then(function success(response) {
          $scope.plantillas = response.data;
        });
      $scope.changePlantilla = function (item) {
        if (item) {
          $scope.subjectEmail = item.title;
          $scope.first_comment = item.text;
          if ($scope.first_comment.includes("\n")) {
            $scope.first_comment = $scope.first_comment.replace(
              "\n",
              "<br><br>"
            );
          }
          $scope.second_comment = item.bottom_text;
          $scope.custom_email = true;
          $scope.getTemplate(true);
        } else {
          $scope.subjectEmail = "";
          $scope.first_comment = "";
          $scope.second_comment = "";
          $scope.custom_email = true;
          $scope.getTemplate(true);
        }
      };
      $scope.getTemplate = function (custom_email) {
        if (custom_email) {
          $http
            .get(url.IP + "share-siniestro-manual/" + vm.insurance.id)
            .then(function (response) {
              if (response.status === 200) {
                $scope.head = response.data.head;
                $scope.body = response.data.body;
                $scope.footer = response.data.footer;
                $scope.subjectDefault = response.data.subject_default;
                if (
                  $scope.subjectEmail == "" ||
                  $scope.subjectEmail == undefined
                ) {
                  $scope.subjectEmail = $scope.subjectDefault;
                }
              }
            })
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          $scope.htmlVariable = "";
          $scope.first_comment = "";
          $scope.second_comment = "";
        }
      };
      $scope.sendEmailSiniestro = function (first_comment, second_comment) {
        $scope.send = true;
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        var data_shared = {
          id: siniestro.id,
          emails: $scope.emails,
          files: $scope.share_via_email,
          subject: $scope.subjectEmail,
          first_comment: first_comment,
          second_comment: second_comment,
          model: 5,
        };

        $http
          .post(url.IP + "share-siniestro-manual/", data_shared)
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.SENDEMAIL, "success");
                $scope.send = true;
                $uibModalInstance.dismiss("cancel");
              } else {
                $scope.send = true;
                l.stop();
                if (request.data && request.data.status) {
                  SweetAlert.swal("ERROR", request.data.status, "error");
                } else if (request.data && request.data.response) {
                  SweetAlert.swal(
                    "Error",
                    "No se envió el correo electrónico. Contacte a su administrador.",
                    "error"
                  );
                } else {
                  SweetAlert.swal(
                    "ERROR",
                    JSON.stringify(request.data),
                    "error"
                  );
                }
              }
            },
            function error(error) {
              l.stop();
              console.log("error - email", error);
            }
          )
          .catch(function (e) {
            l.stop();
            console.log("error - catch", e);
          });
      };
      $scope.showEmailInInput = function (email) {
        $scope.email_assign = email;
      };
      $scope.emails = [];
      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      $scope.emails = [];

      $scope.addEmail = function (email) {
        if (!validateEmail(email)) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }

        if ($scope.emails.indexOf(email) < 0) {
          $scope.emails.push(email);
          vmm.email_assign_mail = ""; // limpiamos el input
        } else {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.REPEATEMAIL, "error");
        }
      };
      $scope.remove_email = function (index) {
        $scope.emails.splice(index, 1);
      };
      $scope.share_via_email = [];
      $scope.shareFileEmail = function (file, value) {
        file.to_send = value;
        var index = $scope.share_via_email.indexOf(file.id);
        if (value) {
          if (index === -1) {
            $scope.share_via_email.push(file.id);
          }
        } else {
          if (index !== -1) {
            $scope.share_via_email.splice(index, 1);
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }
    // enviar correo electrónico Siniestro fin*********
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("SiniestrosCtrl", SiniestrosCtrl);
  SiniestrosCtrl.$inject = [
    "dataFactory",
    "MESSAGES",
    "$timeout",
    "packageService",
    "providerService",
    "$state",
    "SweetAlert",
    "$q",
    "toaster",
    "$localStorage",
    "FileUploader",
    "insuranceService",
    "SiniestroService",
    "$scope",
    "$uibModal",
    "ramoService",
    "$http",
    "url",
    "helpers",
    "$sessionStorage",
    "$location",
    "facturas_conceptos",
    "$rootScope",
    "$stateParams",
    "emailService",
  ];

  function SiniestrosCtrl(
    dataFactory,
    MESSAGES,
    $timeout,
    packageService,
    providerService,
    $state,
    SweetAlert,
    $q,
    toaster,
    $localStorage,
    FileUploader,
    insuranceService,
    SiniestroService,
    $scope,
    $uibModal,
    ramoService,
    $http,
    url,
    helpers,
    $sessionStorage,
    $location,
    facturas_conceptos,
    $rootScope,
    $stateParams,
    emailService
  ) {
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    $scope.url = $location.path();

    var vm = this;
    vm.user = usr;
    vm.selectedRamo = null;
    vm.selectedSubRamo = null;
    vm.selectedPoliza;
    vm.sub_ramos = [];
    vm.status = { id: 1, label: "Pendiente" };
    vm.statuses = [{ id: 1, label: "Pendiente" }];
    vm.insurances_number = [];
    vm.isInicial = true;
    vm.selectedContractor;
    $scope.subramo_select;
    vm.element = "";
    vm.ramos = [];
    vm.affected = [];
    vm.affect_list = [];
    vm.ramoId = -1;
    vm.insurances;
    vm.selected_affect = [];
    vm.selectInsurance;
    vm.affect_data = {};
    vm.selected_disease = [];
    vm.siniestros = [];
    vm.siniester_data = {};
    vm.siniester_data.siniestros_by_number = [];
    vm.siniester_data.selected_number_siniester;
    vm.enfermedades = [];
    vm.buscarEnfermedad = true;
    vm.LookFor = LookFor;
    vm.buscaPadecimientos = buscaPadecimientos;
    vm.complementNumberData = complementNumberData;
    vm.complementNumberD = complementNumberD;
    vm.cancel = cancel;
    vm.selectedPoliza;
    vm.ramos = {};
    vm.contacts = [];
    vm.ramos.ramo_selected = 1;
    vm.show_caratula_afectado = false;
    vm.totalImporte = 0;
    vm.totalIva = 0;
    vm.totalTotal = 0;

    var date = new Date();
    vm.files;
    vm.form = {};
    vm.ramos.options = [
      { id: 2, label: "Accidentes y Enfermedades" },
      { id: 3, label: "Daños" },
      { id: 1, label: "Vida" },
    ];
    var myInsurance = $stateParams.myInsurance;
    var titles = {
      1: "Titular",
      2: "Cónyuge",
      3: "Hijo",
      4: "Otro",
    };

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };
    try {
      if (myInsurance) {
        if (myInsurance.url) {
          $scope.relation_p = myInsurance.relation;
          var name = [];
          if (myInsurance.doSinisterCaratula) {
            var obj = {
              val: "Carátula: " + myInsurance.poliza_number,
              value: {
                id: myInsurance.id,
                title: titles[1],
                tittle_id: 1,
                name: myInsurance.poliza_number,
                url: "",
              },
            };
          } else {
            if (myInsurance.relation) {
              for (
                var i = 0;
                i <
                myInsurance.accidents_policy[0].relationship_accident.length;
                i++
              ) {
                if (
                  myInsurance.relation ==
                  myInsurance.accidents_policy[0].relationship_accident[i].id
                ) {
                  name =
                    myInsurance.accidents_policy[0].relationship_accident[i];
                }
              }
              var obj = {
                val:
                  name.first_name +
                  " " +
                  name.last_name +
                  " " +
                  name.second_last_name +
                  "   -   " +
                  "POLIZA: " +
                  myInsurance.poliza_number,
                value: {
                  id: myInsurance.id,
                  title:
                    titles[
                      myInsurance.accidents_policy[0].relationship_accident[0]
                        .relationship
                    ],
                  tittle_id: 1,
                  name: name.first_name,
                  url: name.url,
                },
              };
              vm.selected_affect = [];
              $scope.val = name.first_name;
              $scope.val_label = obj.val;
            } else {
              name = myInsurance.accidents_policy[0].personal;
              var obj = {
                val:
                  name.first_name +
                  " " +
                  name.last_name +
                  " " +
                  name.second_last_name +
                  "   -   " +
                  "POLIZA: " +
                  myInsurance.poliza_number,
                value: {
                  id: myInsurance.id,
                  title: titles[1],
                  tittle_id: 1,
                  name: name.first_name,
                  url: name.url,
                },
              };
              $scope.val = name.first_name;
            }
          }

          vm.selected_affect.push(obj);
          vm.selected_affect = obj;
          LookFor();
        }
      }
    } catch (error) {
      console.log("error", error);
      activate();
    }

    vm.facturas_conceptos = facturas_conceptos;
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;
    $scope.count_contact = true;

    function addContact() {
      $scope.count_contact = false;
      var contact = {
        first_name: "",
        phone: "",
        email: "",
        references: "",
      };
      vm.contacts.push(contact);
    }

    function deleteContacts(url, index) {
      $scope.count_contact = true;
      vm.contacts.splice(index, 1);
    }

    vm.closeModal = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };

    vm.facturas = [];
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    $scope.colors = [
      { name: "black", shade: "dark" },
      { name: "white", shade: "light", notAnOption: true },
      { name: "red", shade: "dark" },
      { name: "blue", shade: "dark", notAnOption: true },
      { name: "yellow", shade: "light", notAnOption: false },
    ];

    $scope.myColor = $scope.colors[2];
    vm.checkRadio = CheckRadio;
    vm.updateStatus = updateStatus;
    vm.uploadFiles = uploadFiles;
    vm.saveSiniester = saveSiniester;
    vm.validateEmail = validateEmail;
    vm.deleteFactura = deleteFactura;
    vm.addFactura = addFactura;
    vm.downloadFacturas = downloadFacturas;
    vm.uploadFile = uploadFile;
    vm.changeSinesterNumber = changeSinesterNumber;
    vm.saveObservation = saveObservation;
    vm.autocompleteDiseases = autocompleteDiseases;
    vm.showSubRamos = showSubRamos;
    vm.textAExpand = textAExpand;
    vm.dateNow = new Date();
    vm.dateNow_emision = new Date();
    vm.dateLimit = new Date(
      vm.dateNow.getFullYear(),
      vm.dateNow.getMonth() + 2,
      vm.dateNow.getDate()
    );
    vm.dateLimit_emision = new Date(
      vm.dateNow_emision.getFullYear(),
      vm.dateNow_emision.getMonth() + 2,
      vm.dateNow_emision.getDate()
    );
    $scope.enfermedades = [];
    vm.relationship = [
      { value: 1, label: "Titular" },
      { value: 2, label: "Cónyuge" },
      { value: 3, label: "Hijo" },
      { value: 4, label: "Otro" },
    ];
    vm.user.permiso.crear = true;
    vm.carga_siniestro = false;
    activate();
    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    function complementNumberData(parComplement) {
      var compNumber = parComplement.val;
      if (compNumber.length >= 3) {
      }
      if (vm.siniester_data.siniester_number.value) {
        complementNumberD(vm.siniester_data.siniester_number);
      }
    }

    function complementNumberD(parComplement) {
      // console.log('parComplement',parComplement)

      if (parComplement.value) {
        var obj = {
          label: parComplement.value.accidente.ailment,
          val: parComplement.value.accidente.ailment,
          value: {
            code: parComplement.value.accidente.id,
            url: parComplement.value.accidente.url,
            label: parComplement.value.accidente.ailment,
          },
        };
        vm.selected_disease = obj;
        vm.siniester_data.observations =
          parComplement.value.siniestro.observations;
        vm.affect_data.siniester_date =
          parComplement.value.siniestro.fecha_siniestro;
        $("#siniestroType").val(parComplement.value.accidente.razon_siniestro);
        $("#payWay").val(parComplement.value.accidente.tipo_pago);
        if (vm.selected_disease.value) {
          var parPadecimiento = vm.selected_disease.value.label;
        } else {
          var parPadecimiento = vm.selected_disease.val;
        }
      }
    }
    // $scope.numberSelected = function (siniester_number){
    //     console.log('siniester_number',siniester_number)
    // }

    $scope.matchesSiniestros = function (parWord) {
      // console.log(' vm.selected_affect.value.id', vm.selected_affect.value.id,parWord)
      // console.log(' vm.siniester_data.siniestros-match', vm.siniester_data.siniester_number)
      var ids = [];
      vm.siniester_data.siniestros_by_number.forEach(function (it) {
        if (it.value.siniestro.id) {
          ids.push(it.value.siniestro.id);
        }
      });
      $scope.sinietsros_data = 0;
      var word_data = vm.siniester_data.siniester_number.val;
      if (word_data) {
        if (word_data.length >= 3) {
          $http
            .post(url.IP + "siniestros-match/", {
              matchWord: parWord.val,
              id: ids,
            })
            .then(function (response) {
              if (
                response.status === 200 &&
                (response.data.numero || response.data.accidente)
              ) {
                var source = [];
                var accidente = response.data.accidente;
                var numero = response.data.numero;

                if (accidente.length) {
                  accidente.forEach(function (item) {
                    var obj = {
                      label: item.ailment,
                      value: item,
                    };
                    source.push(obj);
                    vm.siniester_data.siniestros_by_number.forEach(function (
                      it
                    ) {
                      if (it.value.siniestro.url == item.siniestro) {
                        if (obj.value.siniestro == it.value.siniestro.url) {
                          obj.value.siniestro_data = it.value.siniestro;
                          obj.label =
                            obj.value.siniestro_data.numero_siniestro +
                            " - " +
                            obj.label;
                        }
                      }
                    });
                  });
                } else if (numero.length) {
                  numero.forEach(function (item) {
                    if (item.numero_siniestro) {
                      var obj = {
                        label: item.numero_siniestro,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label: item,
                        value: item,
                      };
                    }

                    source.push(obj);
                    vm.siniester_data.siniestros_by_number.forEach(function (
                      it
                    ) {
                      if (it.value.siniestro.id == item.id) {
                        if (obj.value.id == it.value.siniestro.id) {
                          obj.value.accidente =
                            it.value.siniestro.accidente_sinister;
                          obj.label =
                            obj.label + " - " + obj.value.accidente[0].ailment;
                        }
                        // console.log('source___XXX_xxxxxx_',source,obj)
                      }
                    });
                  });
                }

                $scope.siniestros_data = source;
              }
            });
        }
      } else {
        $scope.siniestros_data = [];
      }
    };

    function buscaPadecimientos(parPadecimiento) {
      var padeString = parPadecimiento.val;
      if (padeString.length >= 3) {
        SiniestroService.getPadecimientos(padeString)
          .then(function (data) {
            if (data.length) {
              $scope.enfermedades = [];
              vm.enfermedades = [];

              data.forEach(function (padecimientos) {
                vm.enfermedades.push({
                  label: padecimientos.descr,
                  value: {
                    id: padecimientos.id,
                    isSelectedFromMenu: true,
                    label: padecimientos.descr,
                    code: padecimientos.code,
                    url: padecimientos.url,
                  },
                });
                $scope.enfermedades = vm.enfermedades;
                vm.buscarEnfermedad = false;
              });
            }
          })
          .catch(function (err) {});
      }

      if (padeString.length <= 3 && !vm.buscarEnfermedad) {
        vm.enfermedades = [];
        vm.buscarEnfermedad = true;
      }
    }

    function saveObservation(url) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/facturas.observation.html",
        controller: ModalInstanceCtrlObservationsfact,
        resolve: {
          factura: function () {
            return url;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function ModalInstanceCtrlObservationsfact(
      $scope,
      $uibModal,
      factura,
      $uibModalInstance
    ) {
      $http.get(factura).then(function (data) {
        $scope.observation_aux = data.data.observaciones;
      });

      $scope.ok = function () {
        var observ = {
          observaciones: $scope.observation_aux,
        };
        $http.patch(factura, observ).then(function (data) {
          $uibModalInstance.dismiss("cancel");
        });
      };
    }

    function cancel() {
      $state.go("siniestros.lista");
    }

    function NotExist(array, element) {
      if (array.length == 0) {
        return true;
      }
      array.forEach(function (elem) {
        if (elem.label == element.label) {
          return true;
        }
      });
      return false;
    }

    function CheckRadio(obj) {
      $scope.radio_selected = obj;
      if (obj == "Inicial") {
        $("#btn-complemento").removeClass("btn-iniComp");
        $("#btn-inicial").addClass("btn-iniComp");
        // vm.siniester_data.siniester_number=[];
        vm.siniester_data.complemento = "";
        $("#siniestroType").val(0);
        vm.siniester_data.observations = "";
        $("#payWay").val(0);
        vm.isInicial = true;
        // vm.siniester_data.siniester_number.label = "Sin asignar";
        vm.selected_disease = [];
        vm.affect_data.siniester_date = new Date();
      } else {
        $("#btn-inicial").removeClass("btn-iniComp");
        $("#btn-complemento").addClass("btn-iniComp");
        // vm.siniester_data.siniester_number=[];
        vm.siniester_data.siniestros_by_number = [];
        vm.isInicial = false;
        // vm.siniester_data.siniester_number.label = "";
        try {
          $http
            .get(
              url.IP +
                "siniestros/get_specific/" +
                2 +
                "/" +
                vm.selected_affect.value.id +
                "/"
            )
            .then(function (response) {
              response.data.forEach(function (siniestro) {
                $http
                  .get(url.IP + "accidentes/get_specific/" + siniestro.id)
                  .then(function (accidente) {
                    accidente.data.forEach(function (accident) {
                      var obj_returned_siniestro = {
                        label: siniestro.numero_siniestro,
                        value: {
                          siniestro: siniestro,
                          accidente: accident,
                        },
                      };
                      vm.siniester_data.siniestros_by_number.push(
                        obj_returned_siniestro
                      );
                    });
                  });
              });
            })
            .catch(SiniesterNotFound);
        } catch (err) {
          console.log("entra a catch", err);
        }
        function SiniesterNotFound(error) {
          CheckRadio("Inicial");
          $("#btn-complemento").removeClass("btn-iniComp");
          SweetAlert.swal(
            "Complemento",
            "No existen siniestros anteriores registrados para esta póliza",
            "error"
          );
          return;
        }
      }
    }

    $scope.$watch(
      "vm.siniester_data.siniester_number.value",
      function (newValue, oldValue) {
        if (vm.siniester_data.siniester_number) {
          if (vm.siniester_data.siniester_number.value) {
            if (vm.siniester_data.siniester_number.value.accidente) {
              var obj = {
                label:
                  vm.siniester_data.siniester_number.value.accidente[0].ailment,
                val: vm.siniester_data.siniester_number.value.accidente[0]
                  .ailment,
                value: {
                  code: vm.siniester_data.siniester_number.value.accidente[0]
                    .id,
                  url: vm.siniester_data.siniester_number.value.accidente[0]
                    .url,
                  label:
                    vm.siniester_data.siniester_number.value.accidente[0]
                      .ailment,
                },
              };
              vm.selected_disease = obj;
              // vm.selected_disease = parComplement.value.accidente[0];
              if (vm.siniester_data.siniester_number.value.siniestro) {
                vm.siniester_data.observations = vm.siniester_data
                  .siniester_number.value.siniestro.observations
                  ? vm.siniester_data.siniester_number.value.siniestro
                      .observations
                  : "";
                vm.affect_data.siniester_date =
                  vm.siniester_data.siniester_number.value.siniestro.fecha_siniestro;
              } else {
                vm.siniester_data.observations = vm.siniester_data
                  .siniester_number.value.observations
                  ? vm.siniester_data.siniester_number.value.observations
                  : "";
                vm.affect_data.siniester_date =
                  vm.siniester_data.siniester_number.value.fecha_siniestro;
              }
              $("#siniestroType").val(
                vm.siniester_data.siniester_number.value.accidente[0]
                  .razon_siniestro
              );
              $("#payWay").val(
                vm.siniester_data.siniester_number.value.accidente[0].tipo_pago
              );
              if (vm.selected_disease.value) {
                var parPadecimiento = vm.selected_disease.value.label;
              } else {
                var parPadecimiento = vm.selected_disease.val;
              }
            } else if (
              vm.siniester_data.siniester_number.value.siniestro_data
            ) {
              var obj = {
                label: vm.siniester_data.siniester_number.value.ailment,
                val: vm.siniester_data.siniester_number.value.ailment,
                value: {
                  code: vm.siniester_data.siniester_number.value.id,
                  url: vm.siniester_data.siniester_number.value.url,
                  label: vm.siniester_data.siniester_number.value.ailment,
                },
              };
              vm.selected_disease = obj;
              // vm.selected_disease = parComplement.value.
              if (vm.siniester_data.siniester_number.value.siniestro_data) {
                vm.siniester_data.observations = vm.siniester_data
                  .siniester_number.value.siniestro_data.observations
                  ? vm.siniester_data.siniester_number.value.siniestro_data
                      .observations
                  : "";
                vm.affect_data.siniester_date =
                  vm.siniester_data.siniester_number.value.siniestro_data.fecha_siniestro;
              } else {
                vm.siniester_data.observations = vm.siniester_data
                  .siniester_number.value.siniester_data.observations
                  ? vm.siniester_data.siniester_number.value.siniestros_data
                      .observations
                  : "";
                vm.affect_data.siniester_date =
                  vm.siniester_data.siniester_number.value.siniestros_data.fecha_siniestro;
              }
              $("#siniestroType").val(
                vm.siniester_data.siniester_number.value.razon_siniestro
              );
              $("#payWay").val(
                vm.siniester_data.siniester_number.value.tipo_pago
              );
              if (vm.selected_disease.value) {
                var parPadecimiento = vm.selected_disease.value.label;
              } else {
                var parPadecimiento = vm.selected_disease.val;
              }
            }
          }
        }
      }
    );

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.padecimiento_type == undefined) {
        item.padecimiento_type = "";
      }
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].type_document = item.padecimiento_type;
    };

    function uploadFiles(siniestro_id, doc_type) {
      $scope.userInfo = {
        id: siniestro_id,
        type_document: doc_type,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "siniestros/" + siniestro_id + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    function addFactura() {
      var factura = {
        f_number: "",
        concepto: "",
        proovedor: "",
        f_date: "",
        import: "",
        iva: "",
        total: "",
        procedente: 0,
      };
      vm.facturas.push(factura);
    }

    function downloadFacturas(siniestro) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "data:application/vnd.ms-excel;charset=UTF-8",
        }
      );
      saveAs(blob, "Concentrado_Facturas" + ".xls");
    }

    $scope.calculateIva = function (index, item) {
      vm.facturas[index].import = parseFloat(item);
      vm.facturas[index].iva = parseFloat(
        (vm.facturas[index].import * 0.16).toFixed(2)
      );
      vm.facturas[index].total =
        vm.facturas[index].import + vm.facturas[index].iva;
      vm.facturas[index].total = vm.facturas[index].total.toFixed(2);
      if (item == "") {
        vm.facturas[index].import = 0;
        vm.facturas[index].iva = 0;
        vm.facturas[index].total = 0;
      }
    };

    $scope.calculateTotales = function () {
      vm.totalImporte = 0;
      vm.totalIva = 0;
      vm.totalTotal = 0;
      for (var i = 0; i < vm.facturas.length; i++) {
        vm.totalImporte = vm.totalImporte + vm.facturas[i].import;
        vm.totalIva = vm.totalIva + vm.facturas[i].iva;
        vm.totalTotal = vm.totalTotal + parseFloat(vm.facturas[i].total);
      }
    };

    $scope.calculateTotal = function (index, iva) {
      if (iva) {
        vm.facturas[index].iva = parseFloat(iva);
      } else if (iva == "") {
        vm.facturas[index].iva = 0;
      }
      vm.facturas[index].total =
        vm.facturas[index].import + vm.facturas[index].iva;
      vm.facturas[index].total = vm.facturas[index].total.toFixed(2);
    };

    function Exist(list, obj) {
      for (var i = 0; i < list.length; i++) {
        if (obj.value == list[i].value) {
          return true;
        }
      }
      return false;
    }

    function changeSinesterNumber() {
      try {
        $http
          .get(vm.siniester_data.siniester_number.value.accidente.padecimiento)
          .then(function (enfermedad) {
            var obj = {
              label: enfermedad.data.code + " - " + enfermedad.data.descr,
              value: {
                code: enfermedad.data.code,
                url: enfermedad.data.url,
              },
            };
            vm.selected_disease = obj;
            vm.siniester_data.observations =
              vm.siniester_data.siniester_number.value.siniestro.observations;

            var type_accident =
              vm.siniester_data.siniester_number.value.accidente
                .razon_siniestro;
            switch (type_accident) {
              case 1:
                $('#siniestroType option[value="1"]').attr(
                  "selected",
                  "selected"
                );
                break;
              case 2:
                $('#siniestroType option[value="2"]').attr(
                  "selected",
                  "selected"
                );
                break;
              case 3:
                $('#siniestroType option[value="3"]').attr(
                  "selected",
                  "selected"
                );
                break;
              default:
                break;
            }

            var payway_accident =
              vm.siniester_data.siniester_number.value.accidente.tipo_pago;
            switch (payway_accident) {
              case 1:
                $('#payWay option[value="1"]').attr("selected", "selected");
                break;
              case 2:
                $('#payWay option[value="2"]').attr("selected", "selected");
                break;
              case 3:
                $('#payWay option[value="3"]').attr("selected", "selected");
                break;
              case 4:
                $('#payWay option[value="4"]').attr("selected", "selected");
                break;
              default:
                break;
            }
          });
      } catch (err) {}
    }

    $scope.changeTypeDoc = function (padecimiento, index) {
      uploader.queue[index].padecimiento_type = padecimiento;
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return re.test(email);
    }
    function getTotalReclamado() {
      $scope.total_reclamado_new = 0;
      vm.facturas.forEach(function (factura) {
        $scope.total_reclamado_new =
          parseFloat($scope.total_reclamado_new) + parseFloat(factura.total);
      });
    }

    function saveSiniester() {
      getTotalReclamado();
      var razon;
      var pago;
      $scope.saveOK = true;
      if (vm.siniester_data.siniester_number) {
        if (vm.siniester_data.siniester_number.value) {
          if ($scope.radio_selected == "Complemento") {
            vm.siniester_data.siniester_number.label = vm.siniester_data
              .siniester_number.value.numero_siniestro
              ? vm.siniester_data.siniester_number.value.numero_siniestro
              : vm.siniester_data.siniester_number.value.siniestro_data
                  .numero_siniestro;
          }
        }
      }
      if (vm.show_caratula_afectado) {
        if (
          vm.siniester_data.aux_affected == "" ||
          vm.siniester_data.aux_affected == undefined
        ) {
          SweetAlert.swal(
            "Dato requerido",
            "Debe agregar un beneficiario al siniestro de colectividad",
            "error"
          );
          return;
        }
      }
      razon = $("#siniestroType option:selected").val();
      pago = $("#payWay option:selected").val();
      if (razon == 0 || pago == 0 || pago == null || pago == "") {
        SweetAlert.swal("Campos requeridos", "Complete los datos", "error");
        return;
      }
      if (vm.contacts.length) {
        vm.contacts.forEach(function (contact) {
          if (
            contact.phone == null ||
            contact.phone == undefined ||
            contact.phone == ""
          ) {
            $scope.saveOK = false;
          }
          if (contact.email) {
            if (!validateEmail(contact.email)) {
              $scope.saveOK = false;
            }
          }
        });
      }
      if ($scope.saveOK == false) {
        SweetAlert.swal(
          "Datos incompletos en el contacto",
          "Complete datos correctamente",
          "error"
        );
        return;
      }
      if ($scope.saveOK == true) {
        var obj_siniestro = {
          poliza: vm.selectedPoliza.data.url,
          status: vm.status.id,
          aux_affected: vm.siniester_data.aux_affected,
          relationship_aux_affected: vm.siniester_data.aux_affected_parent
            ? vm.siniester_data.aux_affected_parent
            : 1,
          numero_siniestro: vm.siniester_data.siniester_number.label
            ? vm.siniester_data.siniester_number.label
            : vm.siniester_data.siniester_number.val,
          fecha_siniestro: vm.affect_data.siniester_date
            ? new Date(vm.affect_data.siniester_date)
            : new Date(),
          tipo_siniestro_general: 2,
          observations: vm.siniester_data.observations,
          fecha_ingreso: vm.dateNow_emision,
        };
        $http
          .post(url.IP + "siniestros/", obj_siniestro)
          .then(function (siniestro) {
            uploadFiles(siniestro.data.id, $scope.padecimiento_type);
            if (siniestro.status == 201 || siniestro.status == 200) {
              SweetAlert.swal(
                "Guardado",
                "Siniestro Guardado exitosamente",
                "success"
              );
              $scope.idSiniestro = siniestro.data.id;
              $scope.siniestro_info = siniestro.data;
              $state.go("siniestros.lista");
            } else {
              SweetAlert.swal(
                "Error",
                "Ha ocurrido un error al guardar siniestro",
                "error"
              );
            }
            if ($scope.siniestro_info.poliza) {
              $http.get($scope.siniestro_info.poliza).then(function (response) {
                vm.infoSiniestro = {};
                vm.infoSiniestro.poliza = response.data;
                // Send Email
                if (vm.infoSiniestro.poliza.contractor) {
                  $http
                    .get(vm.infoSiniestro.poliza.contractor)
                    .then(function (response) {
                      if (response.data.email) {
                        // Send email
                        if ($localStorage.email_config) {
                          if (
                            $localStorage.email_config.solicitud_siniestro ==
                            true
                          ) {
                            var model = 3;
                            emailService.sendEmailAtm(
                              model,
                              $scope.idSiniestro
                            );
                          }
                        }
                        // Send Email
                      }
                    });
                }
                //Send Email
              });
            }
            // Facturas
            vm.facturas.forEach(function (factura, index) {
              if (!factura.import) {
                factura.import = 0.0;
              }
              if (!factura.iva) {
                factura.iva = 0.0;
              }
              if (!factura.total) {
                factura.total = 0.0;
              }
              var obj_factura = {
                siniestro: siniestro.data.url,
                numero_factura: factura.f_number,
                concepto: factura.concepto,
                proveedor: factura.proovedor,
                fecha_factura: new Date(factura.f_date),
                importe: factura.import.toFixed(2),
                iva: factura.iva.toFixed(2),
                total: factura.total,
                serie: factura.serie,
              };
              $http
                .post(url.IP + "facturas/", obj_factura)
                .then(function (facturax) {
                  // console.log(facturax);
                  // uploadFilesFacturas(facturax.id);
                });
            });

            // Accidente
            var razon;
            var pago;

            razon = $("#siniestroType option:selected").val();
            pago = $("#payWay option:selected").val();
            var kind = 0;
            switch (vm.siniester_data.subramo.subramo_code) {
              case 2:
                kind = 2;
                break;
              case 3:
                kind = 3;
                break;
              case 4:
                kind = 4;
                break;
              default:
                kind = 2;
                break;
            }
            if (vm.selected_disease.value) {
              var parPadecimiento = vm.selected_disease.value.label;
            } else {
              var parPadecimiento = vm.selected_disease.val;
            }
            var selected_affect_relathionship = vm.selected_affect.value.url
              ? vm.selected_affect.value.url.search("relationships")
              : -1;
            if (
              vm.selected_affect.value.tittle_id == 1 &&
              selected_affect_relathionship < 0
            ) {
              if (vm.contacts.length) {
                var obj_accidente = {
                  siniestro: siniestro.data.url,
                  ailment: parPadecimiento,
                  titular: vm.selected_affect.value.url
                    ? vm.selected_affect.value.url
                    : undefined,
                  relationship: vm.selected_affect.value.tittle_id,
                  kind_of_sinister: kind,
                  razon_siniestro: razon,
                  tipo_siniestro: 1,
                  tipo_pago: pago,
                  initial: vm.isInicial,
                  receiptStatus: vm.affect_data.policy_status.id,
                  contact_email: vm.contacts[0].email
                    ? vm.contacts[0].email
                    : "",
                  contact_first_name: vm.contacts[0].first_name
                    ? vm.contacts[0].first_name
                    : "",
                  contact_references: vm.contacts[0].references
                    ? vm.contacts[0].references
                    : "",
                  contact_phone: vm.contacts[0].phone
                    ? vm.contacts[0].phone
                    : "",
                  total_reclamado: $scope.total_reclamado_new.toFixed(2),
                };
              } else {
                var obj_accidente = {
                  siniestro: siniestro.data.url,
                  ailment: parPadecimiento,
                  titular: vm.selected_affect.value.url
                    ? vm.selected_affect.value.url
                    : undefined,
                  relationship: vm.selected_affect.value.tittle_id,
                  kind_of_sinister: kind,
                  razon_siniestro: razon,
                  tipo_siniestro: 1,
                  tipo_pago: pago,
                  initial: vm.isInicial,
                  receiptStatus: vm.affect_data.policy_status.id,
                  contact_email: "",
                  contact_first_name: "",
                  contact_references: "",
                  contact_phone: "",
                  total_reclamado: $scope.total_reclamado_new.toFixed(2),
                };
              }
            } else {
              if (vm.contacts.length) {
                var obj_accidente = {
                  siniestro: siniestro.data.url,
                  ailment: parPadecimiento,
                  dependiente: vm.selected_affect.value.url
                    ? vm.selected_affect.value.url
                    : undefined,
                  relationship: vm.selected_affect.value.tittle_id,
                  kind_of_sinister: kind,
                  razon_siniestro: razon,
                  tipo_siniestro: 1,
                  tipo_pago: pago,
                  initial: vm.isInicial,
                  receiptStatus: vm.affect_data.policy_status.id,
                  contact_email: vm.contacts[0].email
                    ? vm.contacts[0].email
                    : "",
                  contact_first_name: vm.contacts[0].first_name
                    ? vm.contacts[0].first_name
                    : "",
                  contact_references: vm.contacts[0].references
                    ? vm.contacts[0].references
                    : "",
                  contact_phone: vm.contacts[0].phone
                    ? vm.contacts[0].phone
                    : "",
                  total_reclamado: $scope.total_reclamado_new.toFixed(2),
                };
              } else {
                var obj_accidente = {
                  siniestro: siniestro.data.url,
                  ailment: parPadecimiento,
                  dependiente: vm.selected_affect.value.url
                    ? vm.selected_affect.value.url
                    : undefined,
                  relationship: vm.selected_affect.value.tittle_id,
                  kind_of_sinister: kind,
                  razon_siniestro: razon,
                  tipo_siniestro: 1,
                  tipo_pago: pago,
                  initial: vm.isInicial,
                  receiptStatus: vm.affect_data.policy_status.id,
                  contact_email: "",
                  contact_first_name: "",
                  contact_references: "",
                  contact_phone: "",
                  total_reclamado: $scope.total_reclamado_new.toFixed(2),
                };
              }
            }

            $http
              .post(url.IP + "accidentes/", obj_accidente)
              .then(function (accidente) {
                if ($scope.url !== "/index/main") {
                  if (accidente.status == 201 || accidente.status == 200) {
                    SweetAlert.swal(
                      "Guardado",
                      "Siniestro Guardado exitosamente",
                      "success"
                    );
                    var params = {
                      model: 1,
                      event: "POST",
                      associated_id: vm.selectedPoliza.data.id,
                      identifier: "creó un siniestro por " + parPadecimiento,
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                    $state.go("siniestros.lista");
                  } else {
                    SweetAlert.swal(
                      "Error",
                      "Ha ocurrido un error al guardar siniestro",
                      "error"
                    );
                    $http.delete($scope.siniestro_info.url);
                  }
                } else {
                  if ($uibModalInstance) {
                    $uibModalInstance.dismiss("cancel");
                  }
                }
              });
          });
      }
    }

    function uploadFile(index) {
      uploadFiles(index, padecimiento_type);
    }

    function autocompleteDiseases() {
      var waitValue = [];
      waitValue.push($http.get(url.IP + "get-current-receipt/1"));
      $q.all(waitValue).then(function (response) {});
    }

    function LookFor() {
      if (vm.carga_siniestro) {
        CheckRadio("Complemento");
      } else {
        CheckRadio("Inicial");
        vm.siniester_data.siniester_number = { label: "Sin asignar" };
      }

      try {
        $http
          .get(
            url.IP + "leer-polizas-edit/" + vm.selected_affect.value.id + "/"
          )
          .then(function (poliza) {
            if (poliza.data.document_type == 3) {
              vm.show_caratula_afectado = true;
              // if(vm.carga_siniestro == false){
              SweetAlert.swal(
                "La póliza seleccionada es una carátula",
                "Tendrá que agregar un afectado manualmente.",
                "info"
              );
              // }
            } else {
              vm.show_caratula_afectado = false;
            }
            if (poliza.data.document_type == 6) {
              vm.selectedPoliza = poliza;
              ramoService
                .getSubramoById(poliza.data.subramo.id)
                .then(function (subramo) {
                  vm.siniester_data.subramo = subramo.data;
                });
              var data = {
                title: vm.selected_affect.value.title,
                policy_vigencia: new Date(poliza.data.end_of_validity),
                policy_vigencia_init: new Date(poliza.data.start_of_validity),
                siniester_date: new Date(),
                policy_number: poliza.data.parent.parent.parent.poliza_number,
              };
              if (vm.selected_affect.value.tittle_id == 1) {
                poliza.data.accidents_policy.forEach(function (titular) {
                  $http.get(titular.personal).then(function (principal) {
                    data["birthdate"] = principal.data.birthdate;
                  });
                  vm.beneficiaries = titular.beneficiaries_life;
                });
              } else {
                poliza.data.accidents_policy.forEach(function (titular) {
                  titular.relationship_accident.forEach(function (dependiente) {
                    if (
                      dependiente.first_name == vm.selected_affect.value.name
                    ) {
                      data["birthdate"] = dependiente.birthdate;
                    }
                  });
                });
              }
              var waitReceipt = [];
              if (poliza.data.parent.parent.recibos_poliza.lenght) {
                waitReceipt.push(
                  $http.get(
                    url.IP +
                      "get-current-receipt/" +
                      poliza.data.parent.parent.id
                  )
                );
              } else {
                waitReceipt.push(
                  $http.get(
                    url.IP +
                      "get-current-receipt/" +
                      poliza.data.parent.parent.parent.id
                  )
                );
              }
              $q.all(waitReceipt).then(function (response) {
                var status = response[0].data.status;
                data.policy_status = {};
                switch (status) {
                  case 1:
                    data.policy_status["label"] = "Pagado";
                    data.policy_status["id"] = status;
                    break;
                  case 2:
                    data.policy_status["label"] = "Cancelado";
                    data.policy_status["id"] = status;
                    break;
                  case 3:
                    data.policy_status["label"] = "Prorrogado";
                    data.policy_status["id"] = status;
                    break;
                  case 4:
                    data.policy_status["label"] = "Pendiente de pago";
                    data.policy_status["id"] = status;
                    break;
                  default:
                    data.policy_status["label"] = "Sin Estatus";
                    data.policy_status["id"] = status;
                }
              });
              $scope.http_cont = false;
              $scope.http_cont_ = false;
              // console.log('natural',poliza.data.parent.parent)
              if (poliza.data.parent.parent.parent.contractor) {
                if (poliza.data.parent.parent.parent.contractor.url) {
                  if (
                    poliza.data.parent.parent.parent.contractor.url.indexOf(
                      "http"
                    ) != -1
                  ) {
                    $scope.http_cont_ = true;
                  } else {
                    $scope.http_cont_ = false;
                  }
                }
              }
              if (
                $scope.http_cont == false &&
                poliza.data.parent.parent.contractor
              ) {
                if (poliza.data.parent.parent.contractor) {
                  $http
                    .get(poliza.data.parent.parent.contractor)
                    .then(function (contratante) {
                      data["contractor_addres"] =
                        contratante.data.address_contractor[0].route +
                        " #" +
                        contratante.data.address_contractor[0].street_number +
                        " " +
                        contratante.data.address_contractor[0]
                          .administrative_area_level_2 +
                        " " +
                        contratante.data.address_contractor[0]
                          .administrative_area_level_1;
                      data["contratante"] = contratante.data;
                      data["contratante"].name = contratante.data.full_name;
                    });
                }
              } else if (
                $scope.http_cont == true &&
                poliza.data.parent.parent.contractor
              ) {
                if (poliza.data.parent.parent.contractor) {
                  if (poliza.data.parent.parent.contractor.url) {
                    $http
                      .get(poliza.data.parent.parent.contractor)
                      .then(function (contratante) {
                        data["contractor_addres"] =
                          contratante.data.address_contractor[0].route +
                          " #" +
                          contratante.data.address_contractor[0].street_number +
                          " " +
                          contratante.data.address_contractor[0]
                            .administrative_area_level_2 +
                          " " +
                          contratante.data.address_contractor[0]
                            .administrative_area_level_1;
                        data["contratante"] = contratante.data;
                        data["contratante"].name = contratante.data.full_name;
                      });
                  }
                }
              }
              if (poliza.data.parent.parent.parent.contractor) {
                var contratante = poliza.data.parent.parent.parent.contractor;
                data["contractor_addres"] =
                  contratante.address_contractor[0].route +
                  " #" +
                  contratante.address_contractor[0].street_number +
                  " " +
                  contratante.address_contractor[0]
                    .administrative_area_level_2 +
                  " " +
                  contratante.address_contractor[0].administrative_area_level_1;
                data["contratante"] = contratante;
                data["contratante"].name =
                  contratante.first_name + " " + contratante.last_name;
              }
              if (poliza.data.parent.parent.parent) {
                if (poliza.data.parent.parent.parent.aseguradora) {
                  $http
                    .get(poliza.data.parent.parent.parent.url)
                    .then(function (pol) {
                      var url_prov = pol.data;
                      if (url_prov.aseguradora) {
                        $http
                          .get(url_prov.aseguradora)
                          .then(function (aseguradora) {
                            vm.selectedPoliza.data.aseguradora =
                              aseguradora.data.id;
                            data["aseguradora"] = aseguradora.data;
                          });
                      }
                    });
                }
              }
              packageService
                .getPackageById(poliza.data.paquete.id)
                .then(function (paquete) {
                  data["paquete"] = paquete.data;
                });

              vm.affect_data = data;
            } else {
              vm.selectedPoliza = poliza;
              ramoService
                .getSubramoById(poliza.data.subramo.id)
                .then(function (subramo) {
                  vm.siniester_data.subramo = subramo.data;
                });

              var data = {
                title: vm.selected_affect.value.title,
                policy_vigencia: new Date(poliza.data.end_of_validity),
                policy_vigencia_init: new Date(poliza.data.start_of_validity),
                siniester_date: new Date(),
                policy_number: poliza.data.poliza_number,
              };

              if (vm.selected_affect.value.tittle_id == 1) {
                poliza.data.accidents_policy.forEach(function (titular) {
                  $http.get(titular.personal).then(function (principal) {
                    data["birthdate"] = principal.data.birthdate;
                  });
                });
              } else {
                poliza.data.accidents_policy.forEach(function (titular) {
                  titular.relationship_accident.forEach(function (dependiente) {
                    if (
                      dependiente.first_name == vm.selected_affect.value.name
                    ) {
                      data["birthdate"] = dependiente.birthdate;
                    }
                  });
                });
              }
              var waitReceipt = [];
              waitReceipt.push(
                $http.get(url.IP + "get-current-receipt/" + poliza.data.id)
              );
              $q.all(waitReceipt).then(function (response) {
                var status = response[0].data.status;
                data.policy_status = {};
                switch (status) {
                  case 1:
                    data.policy_status["label"] = "Pagado";
                    data.policy_status["id"] = status;
                    break;
                  case 2:
                    data.policy_status["label"] = "Cancelado";
                    data.policy_status["id"] = status;
                    break;
                  case 3:
                    data.policy_status["label"] = "Prorrogado";
                    data.policy_status["id"] = status;
                    break;
                  case 4:
                    data.policy_status["label"] = "Pendiente de pago";
                    data.policy_status["id"] = status;
                    break;
                  default:
                    data.policy_status["label"] = "Sin Estatus";
                    data.policy_status["id"] = status;
                }
              });

              if (poliza.data.contractor) {
                $http.get(poliza.data.contractor).then(function (contratante) {
                  data["contractor_addres"] =
                    contratante.data.address_contractor[0].route +
                    " #" +
                    contratante.data.address_contractor[0].street_number +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_2 +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_1;
                  data["contratante"] = contratante.data;
                  data["contratante"].name = contratante.data.full_name;
                });
              }

              providerService
                .getProviderById(poliza.data.aseguradora)
                .then(function (aseguradora) {
                  data["aseguradora"] = aseguradora.data;
                });

              if (poliza.data.document_type != 3) {
                packageService
                  .getPackageById(poliza.data.paquete.id)
                  .then(function (paquete) {
                    data["paquete"] = paquete.data;
                  });
              }
              vm.affect_data = data;
              // console.log(data);
            }
          });
      } catch (err) {
        SweetAlert.swal("Error", "Selecciona un Afectado valido", "error");
      }
    }

    function activate() {
      vm.tmp_siniestro = angular.copy($rootScope.siniestro_tmp);
      vm.carga_siniestro = $rootScope.carga_siniestro;
      // console.log('vengo de allá ', $rootScope.siniestro_tmp, vm.carga_siniestro);
      if (vm.carga_siniestro) {
        if (vm.tmp_siniestro.facturas && vm.tmp_siniestro.facturas.length) {
          vm.tmp_siniestro.facturas.forEach(function (factura_a_cargar) {
            var obj = {
              serie: factura_a_cargar.serie,
              f_number: factura_a_cargar.numero_factura,
              concepto: factura_a_cargar.concepto,
              proovedor: factura_a_cargar.proveedor,
              f_date: factura_a_cargar.fecha_factura,
              import: parseFloat(factura_a_cargar.importe),
              iva: factura_a_cargar.iva,
              total: factura_a_cargar.total,
            };
            vm.facturas.push(obj);
          });
        }
        var obj = {
          label: vm.tmp_siniestro.accidente.ailment,
          val: vm.tmp_siniestro.accidente.ailment,
          value: {
            label: vm.tmp_siniestro.accidente.ailment,
          },
        };
        if (vm.tmp_siniestro.accidente.contact_first_name) {
          vm.contacts = [
            {
              first_name: vm.tmp_siniestro.accidente.contact_first_name,
              phone: vm.tmp_siniestro.accidente.contact_phone,
              email: vm.tmp_siniestro.accidente.contact_email,
              references: vm.tmp_siniestro.accidente.contact_references,
            },
          ];
        }
        vm.selected_disease = obj;
        // vm.selected_disease = parComplement.value.accidente[0];
        vm.siniester_data.observations =
          vm.tmp_siniestro.siniestro.observations;
        vm.affect_data.siniester_date =
          vm.tmp_siniestro.siniestro.fecha_siniestro;

        $("#siniestroType").val(vm.tmp_siniestro.accidente.razon_siniestro);
        $("#payWay").val(vm.tmp_siniestro.accidente.tipo_siniestro);

        var obj = {
          label: label,
          val: label,
          value: {
            id: vm.tmp_siniestro.poliza.id,
            title: titles[1],
            tittle_id: 1,
            name: vm.tmp_siniestro.poliza.poliza_number,
            url: undefined,
          },
        };
        vm.selected_affect = obj;

        if (vm.tmp_siniestro.poliza.document_type == 3) {
          vm.siniester_data.aux_affected =
            vm.tmp_siniestro.siniestro.aux_affected;
          var label = "Carátula: " + vm.tmp_siniestro.poliza.poliza_number;
        } else {
          if (vm.tmp_siniestro.accidente) {
            if (vm.tmp_siniestro.accidente.dependiente) {
              var label =
                "Póliza: " +
                vm.tmp_siniestro.poliza.poliza_number +
                " - " +
                vm.tmp_siniestro.accidente.dependiente.full_name;
              vm.selected_affect.value.title =
                titles[vm.tmp_siniestro.accidente.dependiente.relationship];
              vm.selected_affect.value.tittle_id =
                vm.tmp_siniestro.accidente.dependiente.relationship;
              vm.selected_affect.value.url =
                vm.tmp_siniestro.accidente.dependiente.url;
            } else if (vm.tmp_siniestro.accidente.titular) {
              var label =
                "Póliza: " +
                vm.tmp_siniestro.poliza.poliza_number +
                " - " +
                vm.tmp_siniestro.accidente.titular.full_name;
              vm.selected_affect.value.title =
                titles[vm.tmp_siniestro.accidente.titular.relationship];
              vm.selected_affect.value.tittle_id =
                vm.tmp_siniestro.accidente.titular.relationship;
              vm.selected_affect.value.url =
                vm.tmp_siniestro.accidente.titular.url;
            } else {
              var label = "Póliza: " + vm.tmp_siniestro.poliza.poliza_number;
            }
          }
        }
        vm.selected_affect.label = label;
        vm.selected_affect.val = label;

        var ns = {
          label: vm.tmp_siniestro.siniestro.numero_siniestro,
          value: 0,
        };
        vm.siniester_data.siniester_number = ns;
        // vm.siniester_data.observations = vm.tmp_siniestro.siniestro.observations
        // vm.affect_data.siniester_date = new Date(vm.tmp_siniestro.siniestro.fecha_siniestro)

        //  Falta cargar el asegurado al crearle un complemento al siniestro, numero de siniestro y forma de pago del siniestro

        // 'label':   vm.tmp_siniestro.accidente.ailment

        vm.isInicial = false;

        LookFor();
      } else {
        updateStatus();
      }
      delete $rootScope.siniestro_tmp;
      $scope.fileSinister = true;

      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Archivos") {
            vm.permarch = perm;
            vm.permarch.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  vm.permiso_administrar_adjuntos = true;
                } else {
                  vm.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
        });
      }
    }

    function deleteFactura(url, index) {
      if ((url && index) || (url && !index)) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "El registro se borrara permanentemente aunque no se hayan guardado los cambios.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, eliminala",
            cancelButtonText: "No",
            closeOnConfirm: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http.delete(url).then(function (response) {
                vm.facturas.splice(index, 1);
                SweetAlert.swal(
                  "¡Eliminada!",
                  "Tu factura ha sido eliminada.",
                  "success"
                );
              });
            }
          }
        );
      } else {
        vm.facturas.splice(index, 1);
      }
    }

    function checkSubRamo(event) {}

    function showSubRamos(event) {
      vm.ramoId = event.target.id;
    }

    function textAExpand(event) {
      var element = e.target;
      var scroll = element.scrollHeight - 60;
      element.style.height = scrollHeight + "px";
    }

    function updateStatus() {
      vm.affected = [];
      vm.affected.length = 0;
      var word_data = vm.selected_affect.val;
      if (word_data) {
        if (word_data.length >= 3) {
          var word = word_data.split(" ").join("_");
          if ($scope.val) {
            var word = $scope.val;
            var word = word.split(" ").join("_");
          }
          insuranceService
            .getInsurances_by_ramo(2, word)
            .then(function (polizas) {
              vm.affected = [];
              polizas.results.forEach(function (poliza) {
                if (
                  poliza.status == 10 ||
                  poliza.status == 12 ||
                  poliza.status == 14
                ) {
                  if (poliza.document_type == 3) {
                    var obj = {
                      label: "Carátula: " + poliza.poliza_number,
                      val: "Carátula: " + poliza.poliza_number,
                      value: {
                        id: poliza.id,
                        title: titles[1],
                        tittle_id: 1,
                        name: poliza.poliza_number,
                        url: undefined,
                      },
                    };
                    function findCoincidences(argument) {
                      return argument.label === obj.label;
                    }
                    if (!vm.affected.find(findCoincidences)) {
                      vm.affected.push(obj);
                    }
                  } else {
                    if (
                      poliza.accidents_policy &&
                      poliza.accidents_policy.length
                    ) {
                      poliza.accidents_policy.forEach(function (accident) {
                        var name = accident.personal;
                        var obj = {
                          label:
                            name.first_name +
                            " " +
                            name.last_name +
                            " " +
                            name.second_last_name +
                            "   -   " +
                            "poliza: " +
                            poliza.poliza_number,
                          val:
                            name.first_name +
                            " " +
                            name.last_name +
                            " " +
                            name.second_last_name +
                            "   -   " +
                            "poliza: " +
                            poliza.poliza_number,
                          value: {
                            id: poliza.id,
                            title: titles[1],
                            tittle_id: 1,
                            name: name.first_name,
                            url: name.url,
                          },
                        };
                        function findCoincidences(argument) {
                          return argument.label === obj.label;
                        }
                        if (!vm.affected.find(findCoincidences)) {
                          vm.affected.push(obj);
                        }

                        accident.relationship_accident.forEach(function (
                          dependiente
                        ) {
                          var obj = {
                            label:
                              dependiente.first_name +
                              " " +
                              dependiente.last_name +
                              " " +
                              dependiente.second_last_name +
                              "   -   " +
                              "POLIZA: " +
                              poliza.poliza_number,
                            value: {
                              id: poliza.id,
                              title: titles[dependiente.relationship],
                              tittle_id: dependiente.relationship,
                              name: dependiente.first_name,
                              url: dependiente.url,
                            },
                          };
                          if (
                            $scope.val &&
                            $scope.relation_p &&
                            vm.selected_affect.value.name ==
                              dependiente.first_name
                          ) {
                            // vm.selected_affect = obj
                            // vm.selected_affect.val = obj.label
                          }
                          // $scope.select_aff = obj;
                          function findCoincidences(argument) {
                            return argument.label === obj.label;
                          }
                          if (!vm.affected.find(findCoincidences)) {
                            vm.affected.push(obj);
                          }
                        });
                      });
                    }
                  }
                } else if (poliza.document_type == 6) {
                  if (poliza.accidents_policy[0].personal) {
                    var obj = {
                      label:
                        poliza.accidents_policy[0].personal.first_name +
                        " " +
                        poliza.accidents_policy[0].personal.last_name +
                        " " +
                        poliza.accidents_policy[0].personal.second_last_name +
                        "   -   " +
                        "poliza: " +
                        poliza.poliza_number,
                      value: {
                        id: poliza.id,
                        title: titles[1],
                        tittle_id: 1,
                        name: poliza.accidents_policy[0].first_name,
                        url: poliza.accidents_policy[0].personal.url,
                      },
                    };
                    function findCoincidences(argument) {
                      return argument.label === obj.label;
                    }
                    if (!vm.affected.find(findCoincidences)) {
                      vm.affected.push(obj);
                    }
                  }
                  if (poliza.accidents_policy[0].relationship_accident) {
                    for (
                      var i = 0;
                      i <
                      poliza.accidents_policy[0].relationship_accident.length;
                      i++
                    ) {
                      var obj = {
                        label:
                          poliza.accidents_policy[0].relationship_accident[i]
                            .first_name +
                          " " +
                          poliza.accidents_policy[0].relationship_accident[i]
                            .last_name +
                          " " +
                          poliza.accidents_policy[0].relationship_accident[i]
                            .second_last_name +
                          "   -   " +
                          "poliza: " +
                          poliza.poliza_number,
                        value: {
                          id: poliza.id,
                          title: titles[1],
                          tittle_id: 2,
                          name: poliza.accidents_policy[0].first_name,
                          url: poliza.accidents_policy[0].relationship_accident[
                            i
                          ].url,
                        },
                      };
                      function findCoincidences(argument) {
                        return argument.label === obj.label;
                      }
                      if (!vm.affected.find(findCoincidences)) {
                        vm.affected.push(obj);
                      }
                    }
                  }
                }
              });
            });
        } else {
          vm.affected.length = 0;
        }
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("siniestrosAutosInfoCtrl", siniestrosAutosInfoCtrl);

  siniestrosAutosInfoCtrl.$inject = [
    "$sce",
    "providerService",
    "packageService",
    "fileService",
    "$stateParams",
    "$rootScope",
    "$state",
    "SweetAlert",
    "$q",
    "toaster",
    "$localStorage",
    "FileUploader",
    "insuranceService",
    "$scope",
    "$uibModal",
    "ramoService",
    "$http",
    "url",
    "helpers",
    "exportFactory",
    "$sessionStorage",
    "MESSAGES",
    "dataFactory",
    "emailService",
    "appStates",
    "whatsappWebFlagService",
    "siniestroWhatsappService",
    "datesFactory",
  ];

  function siniestrosAutosInfoCtrl(
    $sce,
    providerService,
    packageService,
    fileService,
    $stateParams,
    $rootScope,
    $state,
    SweetAlert,
    $q,
    toaster,
    $localStorage,
    FileUploader,
    insuranceService,
    $scope,
    $uibModal,
    ramoService,
    $http,
    url,
    helpers,
    exportFactory,
    $sessionStorage,
    MESSAGES,
    dataFactory,
    emailService,
    appStates,
    whatsappWebFlagService,
    siniestroWhatsappService,
    datesFactory
  ) {
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.user = usr;
    vm.siniestro_id = $stateParams.siniestroId;
    vm.user = usr;
    $scope.fc_visible = false;
    vm.selectedRamo = null;
    vm.selectedSubRamo = null;
    vm.selectedPoliza;
    $scope.newAfectado = false;
    vm.sub_ramos = [
      { id: 2, label: "Accidentes personales" },
      { id: 3, label: "Gastos médicos" },
      { id: 4, label: "Salud" },
    ];
    vm.status = { id: 0, label: "Estatus" };
    vm.statuses = [
      { id: 1, label: "Pendiente" },
      { id: 2, label: "En trámite" },
      { id: 3, label: "Completado" },
      { id: 4, label: "Cancelada" },
      { id: 5, label: "Rechazada" },
    ];
    vm.insurances_number = [];
    vm.isInicial = true;
    vm.selectedContractor;
    $scope.subramo_select;
    vm.element = "";
    vm.ramos = [];
    vm.affected = [];
    vm.affect_list = [];
    vm.ramoId = -1;
    vm.insurances;
    vm.selected_affect;
    vm.selectInsurance;
    vm.affect_data = {};
    vm.selected_disease = [];
    vm.siniestros = [];
    vm.siniester_data = {};
    vm.siniester_data.siniestros_by_number = [];
    vm.siniester_data.selected_number_siniester;
    vm.goToPolicy = goToPolicy;
    vm.sendEmail = sendEmail;
    vm.sendWhatsAppWeb = openWhatsapp;
    vm.whatsappWebEnabled = whatsappWebFlagService.isEnabled();
    whatsappWebFlagService.subscribe(function (enabled) {
      vm.whatsappWebEnabled = enabled;
    });
    vm.enfermedades = [];
    // vm.LookFor =LookFor;
    vm.selectedPoliza;
    vm.ramos = {};
    vm.ramos.ramo_selected = 1;
    $scope.observation_aux = "";

    vm.contacts = [];
    vm.siniestros_type = [
      { id: 0, label: "Seleccione una opción" },
      { id: 1, label: "Colisión" },
      { id: 2, label: "Incendio" },
      { id: 3, label: "Vuelco" },
      { id: 4, label: "Robo total" },
      { id: 5, label: "Robo parcial" },
      { id: 6, label: "Cristales" },
      { id: 7, label: "Inundaciones" },
      { id: 8, label: "Volcadura" },
      { id: 9, label: "Servicio de grua" },
      { id: 20, label: "Perdida Parcial" },
      { id: 10, label: "Perdida Total" },
      { id: 11, label: "Vandalismo" },
      { id: 12, label: "Alcance y proyección" },
      { id: 13, label: "Daños" },
      { id: 14, label: "Fenomenos Naturales" },
      { id: 15, label: "Colisión (Afectados)" },
      { id: 16, label: "Daños en neumatico" },
      { id: 17, label: "Asistencia Vial" },
      { id: 18, label: "Atropello" },
      { id: 19, label: "Trámites Administrativos" },
    ];
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;

    var date = new Date();

    vm.files = [];
    vm.form = {};

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    function addContact() {
      console.log("usr--", usr);
      var contact = {
        first_name: "",
        phone: "",
        email: "",
        references: "",
        org_name: usr.org,
      }; //jshint ignore:line
      vm.contacts.push(contact);
    }

    function deleteContacts(url, index) {
      vm.contacts.splice(index, 1);
    }

    $scope.recordatoriosFlag = false;

    $scope.showRecordatorios = function () {
      $scope.recordatoriosFlag = !$scope.recordatoriosFlag;
    };

    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.createRecordatorio = function (registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return $scope.endorsement;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    //Modals
    vm.updateStatus = updateStatus;
    vm.uploadFiles = uploadFiles;

    vm.saveContact = saveContact;
    function saveContact(contactos) {
      $scope.cnuevos = [];
      contactos.forEach(function (cn) {
        if (cn.id) {
          dataFactory
            .update("contactauto/" + cn.id + "/", cn)
            .then(function success(response) {
              if (response.status == 200 || response.status == 201) {
                $scope.cnuevos.push(response.data);
                if ($scope.cnuevos.length == contactos.length) {
                  vm.contacts = $scope.cnuevos;
                }
              } else {
                $scope.cnuevos.push(cn);
                if ($scope.cnuevos.length == contactos.length) {
                  vm.contacts = $scope.cnuevos;
                }
              }
            });
        } else {
          cn.auto = vm.infoSiniestro.auto_siniester[0].url;
          dataFactory.post("contactauto/", cn).then(function success(response) {
            if (response.status == 200 || response.status == 201) {
              $scope.cnuevos.push(response.data);
              if ($scope.cnuevos.length == contactos.length) {
                vm.contacts = $scope.cnuevos;
              }
            }
          });
        }
      });
    }

    vm.ramo_changed = ramo_changed;
    vm.deleteSiniestro = deleteSiniestro;
    $scope.deleteFile = deleteFile;
    vm.saveEditInformation = saveEditInformation;
    vm.updateSiniestroStatus = updateSiniestroStatus;
    $scope.aux_folio;
    $scope.aux_fecha_promesa;
    $scope.cancelRazon;

    vm.cancel = cancel;
    vm.viewCarta = viewCarta;

    //functions
    vm.showSubRamos = showSubRamos;
    vm.textAExpand = textAExpand;
    vm.getPDF = getPDF;

    vm.crear_complemento = crear_complemento;

    // Date picker stuff

    vm.dateNow = new Date();
    vm.dateLimit = new Date(
      vm.dateNow.getFullYear(),
      vm.dateNow.getMonth() + 2,
      vm.dateNow.getDate()
    );

    vm.getLog = getLog;
    function getLog() {
      dataFactory
        .get("get-specific-log", {
          model: 5,
          associated_id: vm.infoSiniestro.id,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    }
    function crear_complemento(siniestro) {
      siniestro["poliza"] = vm.selectedPoliza.data;
      $rootScope.siniestro_tmp = siniestro;
      $rootScope.carga_siniestro = true;
      $state.go("siniestros.autos");
    }

    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    function deleteFile(file, container) {
      fileService.deleteFile(file, container);
    }

    function viewCarta(poliza, carta) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-form/",
        params: {
          id: vm.infoSiniestro.id,
          id_poliza: vm.selectedPoliza.data.id,
          id_carta: carta,
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
        $scope.pdf = response.data;
        var params = {
          model: 5,
          event: "GET",
          associated_id: vm.infoSiniestro.id,
          identifier:
            "creo la Carta del siniestro " + vm.infoSiniestro.numero_siniestro,
        };
        dataFactory.post("send-log/", params);
        // $http({
        //   method: 'GET',
        //   url: url.IP + 'get-pdf',
        //   params: {
        //     'pdf_name': $scope.pdf.pdf_name
        //   },
        //   responseType: 'arraybuffer'

        // }).then(function success(response) {

        //   })
      });
    }

    function goToPolicy(name, route, poliza) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, { polizaId: poliza });
    }

    function getPDF(siniestro, poliza) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-siniester/",
        params: {
          poliza: poliza,
          siniestro: siniestro,
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
          $scope.pdf = response.data;
          var params = {
            model: 5,
            event: "GET",
            associated_id: vm.infoSiniestro.id,
            identifier:
              "creo PDF del siniestro " + vm.infoSiniestro.numero_siniestro,
          };
          dataFactory.post("send-log/", params);
          // $http({
          // method: 'GET',
          // url: url.IP + 'get-pdf',
          // params: {
          //     'pdf_name': $scope.pdf.pdf_name
          // }
          // }).then(function success(response) {

          // })
        }
      });
    }

    function updateSiniestroStatus(status) {
      if (status.id == 3 && vm.infoSiniestro.status == 1) {
        SweetAlert.swal("No puedes completar una póliza desde este estatus");
        vm.status.id = vm.infoSiniestro.status;
        return;
      }

      if (status.id == 2 && vm.infoSiniestro.status != 2) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_en_tramite_modal.html",
          controller: ModalInstanceCtrlSiniestroEnTramite,
          resolve: {
            factura: function () {
              return url;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
      }
      if (
        (status.id == 4 && vm.infoSiniestro.status != 4) ||
        (status.id == 5 && vm.infoSiniestro.status != 5)
      ) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_cancel_modal.html",
          controller: ModalInstanceCtrlCancelSiniestro,
          resolve: {
            factura: function () {
              return url;
            },
            infosiniestro: function () {
              return vm.infoSiniestro;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
      }
      if (vm.status.id == 3 && vm.infoSiniestro.status != 3) {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/siniestros/siniestro_completado_autos_modal.html",
          controller: ModalInstanceCtrlSiniestroCompletado,
          resolve: {
            vm: function () {
              return vm;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        return;
      }
      // patchSiniester();
    }

    function ModalInstanceCtrlCancelSiniestro(
      $scope,
      $uibModal,
      factura,
      $uibModalInstance,
      infosiniestro
    ) {
      $scope.ok = function () {
        var razon = $scope.cancelRazon;
        if (razon == null) {
          SweetAlert.swal("Dato requerido", "Escriba la razón", "error");
          return;
        }
        // $http.patch(vm.infoSiniestro.url, {status: vm.status.id, reason: razon}).then(function success() {
        //     SweetAlert.swal("¡Listo!",MESSAGES.OK.SINIESTERUPDATED ,"success");
        // })
        $http
          .patch(vm.infoSiniestro.url, { status: vm.status.id, reason: razon })
          .then(function (siniestro) {
            if (siniestro.status === 200 || siniestro.status === 201) {
              if (siniestro.data.status == 5) {
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: vm.infoSiniestro.id,
                  identifier:
                    "actualizo el siniestro a estatus Rechazado " +
                    vm.infoSiniestro.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
                vm.infoSiniestro = siniestro.data;
                // $http.get(vm.infoSiniestro.poliza)
                //   .then(function(poliza) {
                //     if (poliza.data.contractor) {
                //         $http.get(poliza.data.contractor)
                //           .then(function(response) {
                //             if(response.data.email){
                //                 if($localStorage.email_config){
                //                     if($localStorage.email_config.rechazo_siniestro == true){
                //                         var model = 13;
                //                         emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                     }
                //                 }
                //             }
                //         });
                //     }
                //     });
              }
              if (siniestro.data.status == 4) {
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: vm.infoSiniestro.id,
                  identifier:
                    "actualizo el siniestro a estatus Cancelado " +
                    vm.infoSiniestro.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
                // $http.get(vm.infoSiniestro.poliza)
                //   .then(function(poliza) {
                //     if (poliza.data.contractor) {
                //         $http.get(poliza.data.contractor)
                //           .then(function(response) {
                //             if(response.data.email){
                //                 if($localStorage.email_config){
                //                     if($localStorage.email_config.cancelacion_siniestro == true){
                //                         var model = 12;
                //                         emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                     }
                //                 }
                //             }
                //         });
                //     }
                //     });
              }
              SweetAlert.swal(
                "¡Listo!",
                MESSAGES.OK.SINIESTERUPDATED,
                "success"
              );
            }
          });
        $uibModalInstance.dismiss("cancel");
        // $route.reload();
        $state.go(
          "siniestros.auto_info",
          { siniestroId: infosiniestro.id },
          { reload: true }
        );
        activate();
        fillTable(vm.ramos.ramo_selected);
        vm.status.id = infosiniestro.status;
      };

      $scope.cancel = function () {
        $rootScope.statusLabel = "Cambiar Estatus";
        $uibModalInstance.dismiss("cancel");
        vm.status.id = vm.infoSiniestro.status;
      };
    }

    function ModalInstanceCtrlSiniestroEnTramite(
      $scope,
      $uibModal,
      $uibModalInstance
    ) {
      $scope.aux_fecha_promesa = new Date();
      $scope.fc_visible = false;
      $scope.ok = function () {
        vm.siniester_data.companyFolio = $scope.aux_folio;
        vm.fecha_promesa = $scope.aux_fecha_promesa;
        $scope.aux_fecha_promesa = $("#date")[0].value;
        $scope.aux_fecha_promesa = new Date($scope.aux_fecha_promesa);
        // vm.siniester_data.companyFolio = $scope.aux_folio;
        // vm.fecha_promesa = $scope.aux_fecha_promesa;
        // if(vm.fecha_promesa == 'Invalid Date'){
        //     SweetAlert.swal("Datos requeridos","Complete datos requeridos",'error');
        //     return;
        // }
        var obj_tramite = {
          status: 2,
          promise_date: vm.fecha_promesa,
          folio_compania: vm.siniester_data.companyFolio,
          observations: vm.siniester_data.observations,
        };
        // $http.patch(vm.infoSiniestro.url,obj_tramite).then(function success() {
        //     SweetAlert.swal("¡Listo!",MESSAGES.OK.SINIESTERUPDATED ,"success");
        // })

        $http
          .patch(vm.infoSiniestro.url, obj_tramite)
          .then(function (siniestro) {
            if (siniestro.status === 200 || siniestro.status === 201) {
              vm.infoSiniestro = siniestro.data;
              if (siniestro.data.status == 2) {
                var params = {
                  model: 5,
                  event: "PATCH",
                  associated_id: vm.infoSiniestro.id,
                  identifier:
                    "actualizo el siniestro a estatus En Trámite " +
                    vm.infoSiniestro.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $scope.idSiniestro = siniestro.data.id;
                // $http.get(vm.infoSiniestro.poliza)
                //   .then(function(poliza) {
                //     if (poliza.data.contractor) {
                //         $http.get(poliza.data.contractor)
                //           .then(function(response) {
                //             if(response.data.email){
                //                 if($localStorage.email_config){
                //                     if($localStorage.email_config.tramite_siniestro == true){
                //                         var model = 11;
                //                         emailService.sendEmailAtm(model,$scope.idSiniestro)
                //                     }
                //                 }
                //             }
                //         });
                //     }
                //     });
              }
              SweetAlert.swal(
                "¡Listo!",
                MESSAGES.OK.SINIESTERUPDATED,
                "success"
              );
            }
          });
        $uibModalInstance.dismiss("cancel");
        // $route.reload();
        saveEditInformation();
      };

      $scope.cancel = function () {
        $rootScope.statusLabel = "Cambiar Estatus";
        $uibModalInstance.dismiss("cancel");
        vm.status.id = vm.infoSiniestro.status;
      };
    }

    $scope.statusSinister = "";
    activate();

    function exportSiniestroComments() {
      if (!vm.siniestro_id || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
        $scope.$evalAsync(function () {});
      };

      var paramsObj = {
        model: 5,
        id_model: vm.siniestro_id,
      };
      if (vm.org_name) {
        paramsObj.org = vm.org_name;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: paramsObj,
          downloadName: "bitacora-siniestro.xlsx",
          token: token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }

    function activate() {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 5,
          id_model: vm.siniestro_id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            next: request.data.next,
            previous: request.data.previous,
          };
          // console.log('comments_data', vm.comments_data);
        })
        .catch(function (e) {
          console.log("e", e);
        });
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              } else if (acc.permission_name == "Cancelar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_canc_pol = true;
                } else {
                  vm.acceso_canc_pol = false;
                }
              } else if (acc.permission_name == "Eliminar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_elim_pol = true;
                } else {
                  vm.acceso_elim_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Formatos") {
            vm.acceso_form = perm;
            vm.acceso_form.permissions.forEach(function (acc) {
              if (acc.permission_name == "Formatos") {
                if (acc.checked == true) {
                  vm.acceso_form = true;
                } else {
                  vm.acceso_form = false;
                }
              }
            });
          } else if (perm.model_name == "Archivos") {
            vm.permarch = perm;
            vm.permarch.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  vm.permiso_administrar_adjuntos = true;
                } else {
                  vm.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
        });
      }

      window.scrollTo(0, 0);
      var url_siniestro = url.IP + "siniestros-autos/" + vm.siniestro_id + "/";
      $http.get(url_siniestro).then(function success(siniestro) {
        vm.infoSiniestro = siniestro.data;
        vm.siniestro_id = vm.infoSiniestro.id;
        $http({
          method: "GET",
          url: url.IP + "cartas-by-model",
          params: {
            model: 5,
          },
        }).then(function success(response) {
          vm.cartas = response.data;
        });

        if (vm.infoSiniestro.status == 1) {
          $scope.statusSinister = "Pendiente";
        } else if (vm.infoSiniestro.status == 2) {
          $scope.statusSinister = "En trámite";
        } else if (vm.infoSiniestro.status == 3) {
          $scope.statusSinister = "Completado";
        } else if (vm.infoSiniestro.status == 4) {
          $scope.statusSinister = "Cancelada";
        } else if (vm.infoSiniestro.status == 5) {
          $scope.statusSinister = "Rechazada";
        }
        if (vm.infoSiniestro.auto_siniester) {
          var auto = vm.infoSiniestro.auto_siniester[0];
          if (auto) {
            vm.contacts = auto.contacto_auto;
            vm.siniester_data.tercero = auto.tercero;
            vm.siniester_data.indemnizacion = auto.indemnizacion;
            vm.siniester_data.coaseguro = auto.coaseguro;
            vm.siniester_data.deducible = auto.deducible;
            vm.siniester_data.explicacion = auto.explicacion;
            vm.siniester_data.siniester_number =
              vm.infoSiniestro.numero_siniestro;
            vm.siniester_data.conductor = auto.conductor;
            vm.siniester_type =
              vm.infoSiniestro.auto_siniester[0].tipo_siniestro;
          }
        }
        try {
          vm.infoSiniestro.promise_date = new Date(
            vm.infoSiniestro.promise_date
          );
        } catch (e) {}
        updateStatusList();
        vm.status.id = vm.infoSiniestro.status;
        vm.siniester_data.observations = vm.infoSiniestro.observations;
        vm.siniester_data.companyFolio = vm.infoSiniestro.folio_compania;
        $http
          .get(url.IP + "get-current-receipt/" + vm.infoSiniestro.poliza_id)
          .then(function success(response) {
            var estatus = response.data.status;
            switch (parseInt(estatus)) {
              case 1:
                vm.affect_data.policy_status = "Pagado";
                break;
              case 2:
                vm.affect_data.policy_status = "Cancelado";
                break;
              case 3:
                vm.affect_data.policy_status = "Prorrogado";
                break;
              case 4:
                vm.affect_data.policy_status = "Pendiente de pago";
                break;
              default:
                vm.affect_data.policy_status = "Sin Estatus";
            }
          });
        $http
          .get(url.IP + "leer-polizas-edit/" + siniestro.data.poliza_id + "/")
          .then(function (poliza) {
            vm.selectedPoliza = poliza;
            ramoService
              .getSubramoById(poliza.data.subramo.id)
              .then(function (subramo) {
                vm.siniester_data.subramo = subramo.data;
              });

            var data = {
              policy_vigencia: new Date(poliza.data.end_of_validity),
              policy_vigencia_init: new Date(poliza.data.start_of_validity),
              // siniester_date: new Date() ,
              siniester_date: siniestro.data.fecha_siniestro
                ? datesFactory.convertDate(siniestro.data.fecha_siniestro)
                : new Date(),
              policy_number: poliza.data.poliza_number,
            };

            var waitReceipt = [];
            waitReceipt.push(
              $http.get(url.IP + "get-current-receipt/" + poliza.data.id)
            );
            $q.all(waitReceipt).then(function (response) {
              var status = response[0].data.status;
              data.policy_status = {};
              switch (status) {
                case 1:
                  data.policy_status["label"] = "Pagado";
                  data.policy_status["id"] = status;
                  break;
                case 2:
                  data.policy_status["label"] = "Cancelado";
                  data.policy_status["id"] = status;
                  break;
                case 3:
                  data.policy_status["label"] = "Prorrogado";
                  data.policy_status["id"] = status;
                  break;
                case 4:
                  data.policy_status["label"] = "Pendiente de pago";
                  data.policy_status["id"] = status;
                  break;
                default:
                  data.policy_status["label"] = "Sin Estatus";
                  data.policy_status["id"] = status;
              }
            });
            if (poliza.data.contractor) {
              $http.get(poliza.data.contractor).then(function (contratante) {
                data["contractor_addres"] =
                  contratante.data.address_contractor[0].route +
                  " #" +
                  contratante.data.address_contractor[0].street_number +
                  " " +
                  contratante.data.address_contractor[0]
                    .administrative_area_level_2 +
                  " " +
                  contratante.data.address_contractor[0]
                    .administrative_area_level_1;
                data["contratante"] = contratante.data;
                data["contratante"].name = contratante.data.full_name;
                vm.infoSiniestro.contratante_email = contratante.data.email;
                if (poliza.data.document_type == 3) {
                  vm.selected_affect = siniestro.data.aux_affected;
                } else vm.selected_affect = contratante.data.full_name + "   -   " + "serie: " + poliza.data.automobiles_policy[0].serial + "   -   " + "poliza: " + poliza.data.poliza_number;
              });
            }
            if (poliza.data.parent) {
              if (poliza.data.parent.parent) {
                if (poliza.data.parent.parent.parent) {
                  if (poliza.data.parent.parent.parent.contractor) {
                    $http
                      .get(poliza.data.parent.parent.parent.contractor.url)
                      .then(function (contratante) {
                        data["contractor_addres"] =
                          contratante.data.address_contractor[0].route +
                          " #" +
                          contratante.data.address_contractor[0].street_number +
                          " " +
                          contratante.data.address_contractor[0]
                            .administrative_area_level_2 +
                          " " +
                          contratante.data.address_contractor[0]
                            .administrative_area_level_1;
                        data["contratante"] = contratante.data;
                        data["contratante"].name = contratante.data.full_name;
                        vm.infoSiniestro.contratante_email =
                          contratante.data.email;
                        if (poliza.data.document_type == 3) {
                          vm.selected_affect = siniestro.data.aux_affected;
                        } else vm.selected_affect = contratante.data.full_name + "   -   " + "serie: " + poliza.data.automobiles_policy[0].serial + "   -   " + "poliza: " + poliza.data.poliza_number;
                      });
                  }
                }
              }
            }

            providerService
              .getProviderById(poliza.data.aseguradora)
              .then(function (aseguradora) {
                data["aseguradora"] = aseguradora.data;
              });

            if (poliza.data.paquete) {
              packageService
                .getPackageById(poliza.data.paquete.id)
                .then(function (paquete) {
                  data["paquete"] = paquete.data;
                });
            }

            vm.affect_data = data;

            if ($localStorage.save_edition_siniestro_auto) {
              if (
                $localStorage.save_edition_siniestro_auto["id"] ==
                vm.infoSiniestro.siniestro.id
              ) {
                vm.siniester_data.siniester_number =
                  $localStorage.save_edition_siniestro_auto &&
                  $localStorage.save_edition_siniestro_auto["siniester_number"]
                    ? $localStorage.save_edition_siniestro_auto[
                        "siniester_number"
                      ]
                    : "";
                vm.siniester_type =
                  $localStorage.save_edition_siniestro_auto &&
                  $localStorage.save_edition_siniestro_auto["siniester_type"]
                    ? $localStorage.save_edition_siniestro_auto[
                        "siniester_type"
                      ]
                    : 0;
                vm.siniester_data.explicacion =
                  $localStorage.save_edition_siniestro_auto &&
                  $localStorage.save_edition_siniestro_auto["explicacion"]
                    ? $localStorage.save_edition_siniestro_auto["explicacion"]
                    : 0;
                vm.siniester_data.tercero =
                  $localStorage.save_edition_siniestro_auto &&
                  $localStorage.save_edition_siniestro_auto["tercero"]
                    ? $localStorage.save_edition_siniestro_auto["tercero"]
                    : 0;
              }
            }
          });

        vm.fecha_promesa = siniestro.data.promise_date;
        vm.siniester_data.capture_date = siniestro.data.created_at;

        // vm.affect_data.siniester_date= new Date(siniestro.data.fecha_siniestro);
        vm.affect_data.siniester_date = siniestro.data.fecha_siniestro
          ? datesFactory.convertDate(siniestro.data.fecha_siniestro)
          : siniestro.data.fecha_siniestro;
        vm.siniester_data.siniester_number = siniestro.data.numero_siniestro;

        fileService
          .getFiles(url.IP + "siniestros/" + vm.siniestro_id + "/archivos/")
          .then(function (files) {
            files.forEach(function (file) {
              vm.files.push(file);
            });
          });
      });
    }

    $scope.save_info_tab = function () {
      $localStorage.save_edition_siniestro_auto = angular.copy(
        vm.siniester_data
      );
      $localStorage.save_edition_siniestro_auto["siniester_number"] =
        vm.siniester_data.siniester_number;
      $localStorage.save_edition_siniestro_auto["siniester_type"] =
        vm.siniester_type;
      $localStorage.save_edition_siniestro_auto["explicacion"] =
        vm.siniester_data.explicacion;
      $localStorage.save_edition_siniestro_auto["tercero"] =
        vm.siniester_data.tercero;
    };

    function cancel() {
      $state.go("siniestros.lista");
    }

    function updateStatusList() {
      var estado = vm.infoSiniestro.status;
      switch (estado) {
        case 1:
          vm.statuses = [
            /*{'id':1,'label':'Pendiente'},*/
            { id: 2, label: "En trámite" },
            { id: 4, label: "Cancelada" },
            { id: 5, label: "Rechazada" },
          ];
          break;
        case 2:
          vm.statuses = [
            /*{'id':2,'label':'En trámite'},*/
            { id: 1, label: "Pendiente" },
            { id: 3, label: "Completado" },
            { id: 4, label: "Cancelada" },
            { id: 5, label: "Rechazada" },
          ];
          break;
        case 3:
          vm.statuses = [
            /*{'id':3,'label': 'Completado'}*/
          ];
          break;
        case 4:
          vm.statuses = [
            /*{'id':4,'label': 'Cancelada'}*/
          ];
          break;
        case 5:
          vm.statuses = [
            /*{'id':5,'label':'Rechazada'}*/
          ];
          break;
      }
    }

    function ramo_changed() {
      // console.log(vm.ramos.ramo_selected);
      fillTable(vm.ramos.ramo_selected);
    }

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    //   function getFiles() {
    //     var dfd =$q.defer()
    //     $http.get(url.IP+ 'siniestros/' +vm.siniestro_id+ '/archivos/').then(function(files) {
    //         dfd.resolve(files.data.results);
    //     });
    //     return dfd.promise;
    // }

    function uploadFiles(siniestro_id, doc_type) {
      $scope.userInfo = {
        id: siniestro_id,
        type_document: doc_type,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP +
        "siniestros/" +
        siniestro_id +
        "/archivos/?type_document=" +
        doc_type;
      // ////console.log( $scope.uploader);
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve($scope.uploader.uploadAll());
          return defer.promise;
        })
        .then(function () {
          toaster.success("Se han subido sus archivos correctamente");

          setTimeout(function () {
            fileService
              .getFiles(url.IP + "siniestros/" + vm.siniestro_id + "/archivos/")
              .then(function (res) {
                res.forEach(function (file) {
                  vm.files.push(file);
                });
              });
          }, 100);
        });

      $state.go(
        "siniestros.auto_info",
        { siniestroId: siniestro_id },
        { reload: true }
      );
    }

    function Exist(list, obj) {
      for (var i = 0; i < list.length; i++) {
        if (obj.value == list[i].value) {
          return true;
        }
      }
      return false;
    }

    function ModalInstanceCtrlSiniestroCompletado(
      $scope,
      $uibModal,
      status,
      $uibModalInstance,
      vm
    ) {
      $scope.beneficiaries = vm.beneficiaries;
      $scope.coverage = vm.selectedPoliza.data.coverageInPolicy_policy[0];
      // $scope.imndemnizacion = 0.0;
      // $scope.coaseguro = 0.0;
      // $scope.deducible = 0.0;
      $scope.recibos_policy = [];
      if (vm.infoSiniestro.auto_siniester[0].tipo_siniestro == 4) {
        $http.get(vm.infoSiniestro.poliza).then(function (response) {
          vm.policy_info = {};
          vm.policy_info = response.data;
          if (vm.policy_info.recibos_poliza) {
            vm.policy_info.recibos_poliza.forEach(function (recibo) {
              $http.get(recibo).then(function (response) {
                if (response.data) {
                  if (
                    response.data.receipt_type == 1 &&
                    response.data.status == 4
                  ) {
                    $scope.recibos_policy.push(response.data);
                  }
                }
              });
            });
          }
        });
      }

      $scope.validateImndemnizacion = function (item) {
        if (item) {
          if (parseFloat(item) < 0) {
            $scope.imndemnizacion = 0;
          } else {
            $scope.imndemnizacion = parseFloat($scope.imndemnizacion).toFixed(
              2
            );
            $scope.imndemnizacion = parseFloat($scope.imndemnizacion);
          }
        }
      };

      $scope.validateDeducible = function (item) {
        if (item) {
          if (parseFloat(item) < 0) {
            $scope.deducible = 0;
          } else {
            $scope.deducible = parseFloat($scope.deducible).toFixed(2);
            $scope.deducible = parseFloat($scope.deducible);
          }
        }
      };

      $scope.validateCoaseguro = function (item) {
        if (item) {
          if (parseFloat(item) < 0) {
            $scope.coaseguro = 0;
          } else {
            $scope.coaseguro = parseFloat($scope.coaseguro).toFixed(2);
            $scope.coaseguro = parseFloat($scope.coaseguro);
          }
        }
      };

      $scope.ok = function () {
        // if ($scope.imndemnizacion == 0 || $scope.imndemnizacion == null || $scope.imndemnizacion == '0') {
        //     SweetAlert.swal("Dato requerido","Complete la información","error");
        //     return;
        // }
        var status_obj = {
          status: 3,
          observations: vm.siniester_data.observations,
        };
        if (status_obj.status == 3) {
          var params = {
            model: 5,
            event: "PATCH",
            associated_id: vm.infoSiniestro.id,
            identifier: "actualizo el siniestro a estatus Completado.",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          $scope.idSiniestro = vm.infoSiniestro.id;
          if (vm.infoSiniestro.poliza) {
            $http.get(vm.infoSiniestro.poliza).then(function (response) {
              vm.infoSiniestro_info = {};
              vm.infoSiniestro_info.poliza = response.data;
              // Send Email
              // if (vm.infoSiniestro_info.poliza.contractor){
              //     $http.get(vm.infoSiniestro_info.poliza.contractor)
              //       .then(function(response) {
              //         if(response.data.email){
              //             // Send email
              //             if($localStorage.email_config){
              //                 if($localStorage.email_config.fin_siniestro == true){
              //                     var model = 4;
              //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
              //                 }
              //             }
              //             // Send Email
              //         }
              //     });
              // }
              //Send Email
            });
          }
        }
        $http
          .patch(vm.infoSiniestro.url, status_obj)
          .then(function success(response) {
            if (response.status == 200 || response.status == 201) {
              vm.infoSiniestro = response.data;
            }
          });
        var money = {
          indemnizacion: $scope.imndemnizacion,
          coaseguro: $scope.coaseguro,
          deducible: $scope.deducible,
        };
        // var poliza_status_renovacion = {
        //     'is_renewable': 2,
        //     'status': 16
        // }
        // var status_receipt = {
        //     'status': 7
        // }

        $http
          .patch(vm.infoSiniestro.auto_siniester[0].url, money)
          .then(function success(response) {
            if (response.status == 200 || response.status == 201) {
              // console.log('siniestro upd',response)
              // if (vm.infoSiniestro.auto_siniester) {
              //     if (vm.infoSiniestro.auto_siniester[0]) {
              //         if (vm.infoSiniestro.auto_siniester[0].tipo_siniestro == 4) {
              //             $http.patch(vm.policy_info.url,poliza_status_renovacion).then(function success(response) {
              //                 if (response.status == 200 || response.status == 201){
              //                     $scope.recibos_policy.forEach(function(recibo){
              //                         $http.patch(recibo.url,status_receipt).then(function success(response) {
              //                             if (response.status == 200 || response.status == 201){
              //                             }
              //                         })
              //                     })
              //                 }
              //             })
              //         }
              //     }
              // }
            }
          });
        $uibModalInstance.dismiss("cancel");
        SweetAlert.swal("¡Listo!", MESSAGES.OK.SINIESTERUPDATED, "success");
        activate();
        $state.go(
          "siniestros.auto_info",
          { siniestroId: vm.infoSiniestro.id },
          { reload: true }
        );
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
        activate();
        return;
      };
    }

    function saveEditInformation() {
      // if( vm.status.id == 3 && vm.infoSiniestro.status != 3){
      //     var modalInstance = $uibModal.open({ //jshint ignore:line
      //         templateUrl: 'app/siniestros/siniestro_completado_autos_modal.html',
      //         controller: ModalInstanceCtrlSiniestroCompletado,
      //         resolve: {
      //             vm: function () {
      //               return vm;
      //             }
      //           }
      //     });
      //     return;
      // }
      patchSiniester();
    }
    // -----------------
    $scope.changeAfectado = function (padecimiento) {
      if (vm.selectedPoliza.data.document_type == 3) {
        $scope.newAfectado = true;
      } else {
        $scope.newAfectado = false;
      }
    };
    vm.getCertificate = getCertificate;
    function getCertificate(parId) {
      if (parId) {
        if (parId.val.length >= 3) {
          $http({
            method: "POST",
            url: url.IP + "get-certificatesforsiniestro/",
            data: {
              word: parId.val,
              id_collect: vm.selectedPoliza.data.id,
              mode: $scope.endorsement_type_manual,
            },
          })
            .then(
              function success(request) {
                //console.log(request);
                var results_cert = [];
                var mapeo_cert = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    // $scope.btnSearchDisabled = true;
                    toaster.warning("Certificado no encontrado");
                  } else {
                    // $scope.btnSearchDisabled = false;
                    toaster.success("Certificado existente");
                    request.data.forEach(function (poliza) {
                      vm.certificado_for_siniestro = poliza;
                      // vm.form.num_receipts = vm.form.num_receipts;
                      if (poliza.document_type == 6) {
                        mapeo_cert.push(poliza);
                      }
                    });
                    results_cert = _.map(mapeo_cert, function (item) {
                      if (item.contractor) {
                        var label = item.contractor ? item.contractor : "";
                        label =
                          "Certificado: " +
                          item.certificate_number +
                          "- " +
                          label +
                          " - " +
                          item.poliza_number;
                      }
                      return {
                        label: label ? label : "",
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                        url: item.url,
                        contacto: item.contacto,
                        certificate_number: item.certificate_number,
                      };
                    });
                    $scope.autocompleteDataCertificate = results_cert;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    }
    vm.getTypeCertificate = getTypeCertificate;
    function getTypeCertificate(certificado) {
      $scope.certificateForSiniestro = certificado;
      $scope.certificadoSiniestro = certificado;
      $scope.subgrupoReceipts = {};
      dataFactory
        .get("polizas/" + $scope.certificateForSiniestro.id)
        .then(function success(polizaSelected) {
          if (polizaSelected.status == 200 || polizaSelected.status == 201) {
            vm.certificado_ = polizaSelected.data;
          }
        });
    }
    // ------------
    $scope.saveEditInformation2 = function (obj) {
      var continuar = false;
      var obj_siniestro = {};
      if (vm.selectedPoliza.data.document_type == 3) {
        continuar = false;
        if (vm.certificado_) {
          SweetAlert.swal(
            {
              title:
                "El siniestro inicialmente se creo a una Colectividad: " +
                vm.selectedPoliza.poliza_number,
              text:
                "¿Reasignar al certificado : " +
                vm.certificado_.certificate_number +
                "?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Si",
              cancelButtonText: "No",
              closeOnConfirm: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                obj_siniestro.poliza = vm.certificado_.url;
                obj_siniestro.aux_affected = vm.certificado_
                  .automobiles_policy[0].serial
                  ? vm.certificado_.automobiles_policy[0].serial
                  : null;
                continuar = true;
                $scope.saveChangesSiniester(obj_siniestro);
              } else {
                $scope.newAfectado = false;
                $state.go("siniestros.lista");
              }
            }
          );
        }
      }
    };
    $scope.saveChangesSiniester = function (obj_siniestro) {
      $http
        .patch(vm.infoSiniestro.url, obj_siniestro)
        .then(function (siniestro) {
          $scope.newAfectado = false;
          if (siniestro.status == 200 || siniestro.status == 201) {
            uploadFiles(vm.infoSiniestro.id, $scope.padecimiento_type);
            var params = {
              model: 5,
              event: "PATCH",
              associated_id: vm.infoSiniestro.id,
              identifier:
                "actualizo el siniestro " + vm.infoSiniestro.numero_siniestro,
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            SweetAlert.swal("¡Listo!", MESSAGES.OK.SINIESTERUPDATED, "success");
            $state.go("siniestros.lista");
          } else {
            SweetAlert.swal("Error", "Ha ocurrido un error", "error");
            $state.go("siniestros.lista");
          }
        });
    };
    // -------d
    $scope.changeTypeDoc = function (padecimiento) {
      $scope.padecimiento_type = padecimiento;
    };
    function patchSiniester(obj) {
      if (vm.affect_data && vm.affect_data.siniester_date.length == 10) {
        vm.affect_data.siniester_date = datesFactory.toDate(
          vm.affect_data.siniester_date
        );
      } else {
        vm.affect_data.siniester_date = vm.affect_data.siniester_date;
      }
      if (
        vm.infoSiniestro &&
        vm.infoSiniestro.fecha_ingreso &&
        vm.infoSiniestro.fecha_ingreso.length == 10
      ) {
        vm.infoSiniestro.fecha_ingreso = datesFactory.toDate(
          vm.infoSiniestro.fecha_ingreso
        );
      } else {
        vm.infoSiniestro.fecha_ingreso = vm.infoSiniestro.fecha_ingreso;
      }
      var obj_siniestro = {
        fecha_siniestro: vm.affect_data.siniester_date
          ? vm.affect_data.siniester_date
          : new Date(),
        fecha_ingreso: vm.infoSiniestro.fecha_ingreso
          ? vm.infoSiniestro.fecha_ingreso
          : new Date(),
        observations: vm.siniester_data.observations,
        numero_siniestro: vm.siniester_data.siniester_number
          ? vm.siniester_data.siniester_number
          : "",
        folio_compania: vm.siniester_data.companyFolio,
      };
      $http
        .patch(vm.infoSiniestro.url, obj_siniestro)
        .then(function (siniestro_x) {
          if (siniestro_x.status == 200 || siniestro_x.status == 201) {
            // console.log('tg',siniestro_x)
          }
        });
      var obj_aut = {
        tipo_siniestro: vm.siniester_type ? vm.siniester_type : 0,
        tercero: vm.siniester_data.tercero ? vm.siniester_data.tercero : "",
        explicacion: vm.siniester_data.explicacion
          ? vm.siniester_data.explicacion
          : "",
        conductor: vm.siniester_data.conductor
          ? vm.siniester_data.conductor
          : "",
      };
      if (vm.infoSiniestro.auto_siniester) {
        if (vm.infoSiniestro.auto_siniester[0]) {
          if (vm.infoSiniestro.auto_siniester[0].url) {
            $http
              .patch(vm.infoSiniestro.auto_siniester[0].url, obj_aut)
              .then(function (siniestro_aut) {
                if (
                  siniestro_aut.status == 200 ||
                  siniestro_aut.status == 201
                ) {
                  // console.log('tgdd',siniestro_aut)
                }
              });
          }
        }
      }
      var params = {
        model: 5,
        event: "PATCH",
        associated_id: vm.infoSiniestro.id,
        identifier:
          "edito/actualizo el siniestro " + vm.infoSiniestro.numero_siniestro,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
      uploadFiles(vm.infoSiniestro.id, $scope.padecimiento_type);
      // $route.reload();
      SweetAlert.swal("¡Listo!", MESSAGES.OK.SINIESTERUPDATED, "success");
      // $state.go('siniestros.lista');
      vm.status.id = vm.infoSiniestro.status;
      $state.go(
        "siniestros.auto_info",
        { siniestroId: vm.infoSiniestro.id },
        { reload: true }
      );
      activate();
    }

    function fillTable(ramo_number) {
      vm.siniestros = [];
      $http
        .get(url.IP + "siniestros-definidos/" + ramo_number)
        .then(function (siniestros) {
          ////console.log('siniestros',siniestros)
          siniestros.data.forEach(function (siniestro) {
            vm.siniestros.push(siniestro);
            // ////console.log(vm.siniestros);
            // });
          });
        });
    }

    function deleteSiniestro(url) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Al eliminar tu siniestro no podra recuperarse nuevamente!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, eliminar.",
          cancelButtonText: "No, cancelar.",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: vm.infoSiniestro.id,
              model: 5,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {
                // console.log('.................:::::.....',req)
              });
            $http.delete(url).then(function (response) {
              if (
                response.status === 200 ||
                response.status === 201 ||
                response.status === 204
              ) {
                SweetAlert.swal("Siniestro eliminado exitosamente");
                var params = {
                  model: 5,
                  event: "DELETE",
                  associated_id: vm.infoSiniestro.id,
                  identifier:
                    "elimino el Siniestro " + vm.infoSiniestro.numero_siniestro,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $state.go("siniestros.lista");
              }
            });
          } else {
            SweetAlert.swal("Cancelado", "Tu registro esta a salvo", "error");
          }
        }
      );
    }

    function checkSubRamo(event) {}

    function showSubRamos(event) {
      vm.ramoId = event.target.id;
      //////console.log(event.target.id);
    }

    function textAExpand(event) {
      var element = e.target;
      var scroll = element.scrollHeight - 60; // <- Padding top and buttom sum
      element.style.height = scrollHeight + "px";
    }

    function updateStatus() {
      insuranceService.getInsurances().then(function (polizas) {
        polizas.forEach(function (poliza) {
          // ////console.log(poliza);
          poliza.accidents_policy.forEach(function (titular) {
            $http.get(titular.personal).then(function (name) {
              var obj = {
                label:
                  name.data.first_name +
                  " " +
                  name.data.last_name +
                  " " +
                  name.data.second_last_name +
                  "   -   " +
                  "poliza: " +
                  poliza.poliza_number,
                value: {
                  id: poliza.id,
                  title: titles[1],
                  tittle_id: 1,
                  name: name.data.first_name,
                  url: titular.personal,
                },
              };
              vm.affected.push(obj);
            });

            titular.relationship_accident.forEach(function (dependiente) {
              var obj = {
                label:
                  dependiente.first_name +
                  " " +
                  dependiente.last_name +
                  " " +
                  dependiente.second_last_name +
                  "   -   " +
                  "poliza: " +
                  poliza.poliza_number,
                value: {
                  id: poliza.id,
                  title: titles[dependiente.relationship],
                  tittle_id: dependiente.relationship,
                  name: dependiente.first_name,
                  url: dependiente.url,
                },
              };
              vm.affected.push(obj);
            });
          });
        });
      });
    }

    $rootScope.statusLabel = "Cambiar Estatus";
    $scope.changeLabel = function (status) {
      $rootScope.statusLabel = status.label;
      vm.status.id = status.id;
      vm.status.label = status.label;
      vm.updateSiniestroStatus(vm.status);
    };

    // Enviar correo electrónico Siniestro inicio***********
    function sendEmail(siniestro, poliza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/email_siniestro.html",
        controller: ModalEmailSiniestroCtrl,
        size: "lg",
        resolve: {
          from: function () {
            return null;
          },
          archivos: function () {
            return vm.files;
          },
          siniestro: function () {
            return siniestro;
          },
          poliza: function () {
            return poliza;
          },
          info: function () {
            return vm.infoSiniestro;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
      modalInstance.result.then(function (data) {});
    }

    function openWhatsapp(siniestro, poliza) {
      var targetSiniestro = siniestro || vm.infoSiniestro;
      if (!targetSiniestro) {
        return;
      }
      var info = {
        contratante: targetSiniestro.contratante,
        contratante_phone_number:
          targetSiniestro.contratante_phone_number ||
          (targetSiniestro.contratante &&
            (targetSiniestro.contratante.phone_number ||
              targetSiniestro.contratante.phone)),
      };
      siniestroWhatsappService.open({
        siniestro: targetSiniestro,
        poliza: poliza || (vm.selectedPoliza && vm.selectedPoliza.data),
        info: info,
      });
    }
    function ModalEmailSiniestroCtrl(
      $uibModalInstance,
      $scope,
      archivos,
      siniestro,
      poliza,
      info
    ) {
      var vmm = this;
      $scope.data = {};
      $scope.send = false;
      $scope.files = archivos;
      $scope.siniestro = siniestro;
      $scope.poliza = poliza;
      $scope.emailcontractor = info.contratante_email;
      $scope.subjectEmail =
        "Información del Siniestro: " +
        (siniestro.numero_siniestro
          ? siniestro.numero_siniestro
          : siniestro.folio_interno
        ).toString() +
        ", de la Póliza: " +
        (poliza.poliza_number
          ? poliza.poliza_number
          : poliza.internal_number
        ).toString();
      $scope.close = function () {
        $uibModalInstance.dismiss();
      };
      $http
        .get(url.IP + "share-siniestro-manual/" + siniestro.id)
        .then(function (response) {
          if (response.status === 200) {
            $scope.body = response.data.body;
          }
        })
        .catch(function (e) {
          console.log("error - catch", e);
        });
      $scope.visualizar = function (data) {
        $uibModalInstance.close(data);
      };
      dataFactory
        .get("emailtemplate-unpag/", {
          template_model: 4,
          id_policy: poliza.id,
        })
        .then(function success(response) {
          $scope.plantillas = response.data;
        });
      $scope.changePlantilla = function (item) {
        if (item) {
          $scope.subjectEmail = item.title;
          $scope.first_comment = item.text;
          if ($scope.first_comment.includes("\n")) {
            $scope.first_comment = $scope.first_comment.replace(
              "\n",
              "<br><br>"
            );
          }
          $scope.second_comment = item.bottom_text;
          $scope.custom_email = true;
          $scope.getTemplate(true);
        } else {
          $scope.subjectEmail = "";
          $scope.first_comment = "";
          $scope.second_comment = "";
          $scope.custom_email = true;
          $scope.getTemplate(true);
        }
      };
      $scope.getTemplate = function (custom_email) {
        if (custom_email) {
          $http
            .get(url.IP + "share-siniestro-manual/" + vm.insurance.id)
            .then(function (response) {
              if (response.status === 200) {
                $scope.head = response.data.head;
                $scope.body = response.data.body;
                $scope.footer = response.data.footer;
                $scope.subjectDefault = response.data.subject_default;
                if (
                  $scope.subjectEmail == "" ||
                  $scope.subjectEmail == undefined
                ) {
                  $scope.subjectEmail = $scope.subjectDefault;
                }
              }
            })
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          $scope.htmlVariable = "";
          $scope.first_comment = "";
          $scope.second_comment = "";
        }
      };
      $scope.sendEmailSiniestro = function (first_comment, second_comment) {
        $scope.send = true;
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        var data_shared = {
          id: siniestro.id,
          emails: $scope.emails,
          files: $scope.share_via_email,
          subject: $scope.subjectEmail,
          first_comment: first_comment,
          second_comment: second_comment,
          model: 5,
        };

        $http
          .post(url.IP + "share-siniestro-manual/", data_shared)
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.SENDEMAIL, "success");
                $scope.send = true;
                $uibModalInstance.dismiss("cancel");
              } else {
                $scope.send = true;
                l.stop();
                if (request.data && request.data.status) {
                  SweetAlert.swal("ERROR", request.data.status, "error");
                } else if (request.data && request.data.response) {
                  SweetAlert.swal(
                    "Error",
                    "No se envió el correo electrónico. Contacte a su administrador.",
                    "error"
                  );
                } else {
                  SweetAlert.swal(
                    "ERROR",
                    JSON.stringify(request.data),
                    "error"
                  );
                }
              }
            },
            function error(error) {
              l.stop();
              console.log("error - email", error);
            }
          )
          .catch(function (e) {
            l.stop();
            console.log("error - catch", e);
          });
      };
      $scope.showEmailInInput = function (email) {
        $scope.email_assign = email;
      };
      $scope.emails = [];
      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      $scope.emails = [];

      $scope.addEmail = function (email) {
        if (!validateEmail(email)) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }

        if ($scope.emails.indexOf(email) < 0) {
          $scope.emails.push(email);
          vmm.email_assign_mail = ""; // limpiamos el input
        } else {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.REPEATEMAIL, "error");
        }
      };
      $scope.remove_email = function (index) {
        $scope.emails.splice(index, 1);
      };
      $scope.share_via_email = [];
      $scope.shareFileEmail = function (file, value) {
        file.to_send = value;
        var index = $scope.share_via_email.indexOf(file.id);
        if (value) {
          if (index === -1) {
            $scope.share_via_email.push(file.id);
          }
        } else {
          if (index !== -1) {
            $scope.share_via_email.splice(index, 1);
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }
    // enviar correo electrónico Siniestro fin*********
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("SiniestrosAutosCtrl", SiniestrosAutosCtrl);

  SiniestrosAutosCtrl.$inject = [
    "dataFactory",
    "packageService",
    "providerService",
    "$state",
    "SweetAlert",
    "$q",
    "toaster",
    "$localStorage",
    "FileUploader",
    "insuranceService",
    "SiniestroService",
    "$scope",
    "$uibModal",
    "ramoService",
    "$http",
    "url",
    "helpers",
    "$sessionStorage",
    "$location",
    "MESSAGES",
    "$rootScope",
    "$stateParams",
    "emailService",
    "PersistenceFactory",
  ];

  function SiniestrosAutosCtrl(
    dataFactory,
    packageService,
    providerService,
    $state,
    SweetAlert,
    $q,
    toaster,
    $localStorage,
    FileUploader,
    insuranceService,
    SiniestroService,
    $scope,
    $uibModal,
    ramoService,
    $http,
    url,
    helpers,
    $sessionStorage,
    $location,
    MESSAGES,
    $rootScope,
    $stateParams,
    emailService,
    PersistenceFactory
  ) {
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedToken);
    $scope.url = $location.path();

    $scope.myInsurance = $stateParams.myInsurance;

    var vm = this;
    vm.selectedRamo = null;
    vm.selectedSubRamo = null;
    vm.selectedPoliza;
    vm.sub_ramos = [];
    vm.status = { id: 1, label: "Pendiente" };
    vm.statuses = [
      { id: 1, label: "Pendiente" },
      { id: 2, label: "En Trámite" },
    ];
    vm.insurances_number = [];
    vm.isInicial = true;
    vm.selectedContractor;
    $scope.subramo_select;
    vm.element = "";
    vm.ramos = [];
    vm.affected = [];
    vm.affect_list = [];
    vm.ramoId = -1;
    vm.insurances;
    vm.selected_affect = [];
    vm.selectInsurance;
    vm.affect_data = {};
    vm.selected_disease = [];
    vm.carga_siniestro = false;
    vm.siniestros = [];
    vm.siniester_data = {};
    vm.siniester_data.siniestros_by_number = [];
    vm.siniester_data.selected_number_siniester;
    vm.enfermedades = [];
    vm.buscarEnfermedad = true;
    vm.LookFor = LookFor;
    vm.selectedPoliza;
    vm.ramos = {};
    vm.beneficiaries = [];
    vm.cancel = cancel;
    vm.ramos.ramo_selected = 1;
    vm.contacts = [];
    $scope.ok_afectted = {};
    vm.ok_afectted = {};
    vm.siniestros_type = [
      { id: 0, label: "Seleccione una opción" },
      { id: 1, label: "Colisión" },
      { id: 2, label: "Incendio" },
      { id: 3, label: "Vuelco" },
      { id: 4, label: "Robo total" },
      { id: 5, label: "Robo parcial" },
      { id: 6, label: "Cristales" },
      { id: 7, label: "Inundaciones" },
      { id: 8, label: "Volcadura" },
      { id: 9, label: "Servicio de grua" },
      { id: 20, label: "Perdida Parcial" },
      { id: 10, label: "Perdida Total" },
      { id: 11, label: "Vandalismo" },
      { id: 12, label: "Alcance y proyección" },
      { id: 13, label: "Daños" },
      { id: 14, label: "Fenomenos Naturales" },
      { id: 15, label: "Colisión (Afectados)" },
      { id: 16, label: "Daños en neumatico" },
      { id: 17, label: "Asistencia Vial" },
      { id: 18, label: "Atropello" },
      { id: 19, label: "Trámites Administrativos" },
    ];
    vm.show_caratula_afectado = false;

    vm.siniester_type = 0;
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    try {
      if ($scope.myInsurance) {
        if ($scope.myInsurance.url) {
          if ($scope.myInsurance.doSinisterCaratula) {
            $scope.obj = {
              val: "Carátula: " + $scope.myInsurance.poliza_number,
              value: {
                id: $scope.myInsurance.id,
              },
            };
          } else {
            $scope.val = $scope.myInsurance.poliza_number;
            $scope.obj = {
              label:
                "serie: " +
                $scope.myInsurance.automobiles_policy[0].serial +
                "   -   " +
                "PÓLIZA: " +
                $scope.myInsurance.poliza_number,
              val: $scope.myInsurance.poliza_number,
              value: {
                id: $scope.myInsurance.id,
              },
            };
          }
          vm.ok_afectted = angular.copy($scope.obj);
          $scope.ok_afectted = angular.copy($scope.obj);
          vm.selected_affect = angular.copy($scope.obj);
          LookFor();
          // saveLocalstorange();
        } else {
          $scope.myInsurance = {};
        }
      }
    } catch (error) {
      console.log("dddd", error);
      // activate()
    }

    activate();

    function addContact() {
      var contact = {
        first_name: "",
        phone: "",
        email: "",
        references: "",
      }; //jshint ignore:line
      vm.contacts.push(contact);
    }

    function deleteContacts(url, index) {
      vm.contacts.splice(index, 1);
    }

    vm.closeModal = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };

    function cancel() {
      $localStorage["save_created_siniester_auto"] = {};
      $state.go("siniestros.lista");
    }

    var date = new Date();

    // vm.fecha_promesa = new Date(date.setDate(date.getDate() + 5));
    vm.files;

    //Modals
    vm.updateStatus = updateStatus;
    vm.uploadFiles = uploadFiles;
    vm.saveSiniester = saveSiniester;
    vm.validateEmail = validateEmail;

    vm.ramo_changed = ramo_changed;
    //functions
    vm.showSubRamos = showSubRamos;
    vm.textAExpand = textAExpand;

    // Date picker stuff
    vm.dateNow = new Date();
    vm.dateLimit = new Date(
      vm.dateNow.getFullYear(),
      vm.dateNow.getMonth() + 2,
      vm.dateNow.getDate()
    );
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    activate();

    // var uploader = $scope.uploader = new FileUploader({
    //     headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json' },
    // });
    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + usr, Accept: "application/json" },
    }));

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    function ramo_changed() {
      // ////console.log(vm.ramos.ramo_selected);
      fillTable(vm.ramos.ramo_selected);
    }
    function NotExist(array, element) {
      ////console.log('array',array);
      ////console.log('element',element);
      if (array.length == 0) {
        return true;
      }
      array.forEach(function (elem) {
        if (elem.label == element.label) {
          return true;
        }
      });
      return false;
    }

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.padecimiento_type == undefined) {
        item.padecimiento_type = "";
      }
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].type_document = item.padecimiento_type;
    };

    function getFiles() {
      // return receiptService.getFiles(receiptService.getReceiptID())
      //     .then(function(data) {
      //         vm.files = data;
      //         return vm.files;
      //     });
    }

    function uploadFiles(siniestro_id) {
      $scope.userInfo = {
        id: siniestro_id,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "siniestros/" + siniestro_id + "/archivos/";
      // ////console.log( $scope.uploader);
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve($scope.uploader.uploadAll());
          return defer.promise;
        })
        .then(function () {
          toaster.success("Se han subido sus archivos correctamente");

          // setTimeout(function() {
          //     getFiles().then(function(res) {
          //         vm.files = res;
          //     });
          // }, 1000);
        });
    }

    function Exist(list, obj) {
      for (var i = 0; i < list.length; i++) {
        if (obj.value == list[i].value) {
          return true;
        }
      }
      return false;
    }

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
    $scope.changeTypeDoc = function (padecimiento) {
      $scope.padecimiento_type = padecimiento;
    };
    function saveSiniester() {
      $scope.saveOK = true;
      if (!vm.ok_afectted.val) {
        SweetAlert.swal(
          "Asegurado",
          "Seleccione un Asegurado para el siniestro",
          "error"
        );
        return;
      }
      if (vm.show_caratula_afectado) {
        if (!vm.siniester_data.aux_affected) {
          SweetAlert.swal(
            "Asegurado",
            "Agregue un Asegurado para el siniestro",
            "error"
          );
          return;
        }
      }
      if (vm.siniester_type == 0) {
        SweetAlert.swal(
          "Dato requerido",
          "Elige un Tipo de siniestro",
          "error"
        );
        return;
      }
      if (vm.show_caratula_afectado) {
        if (
          vm.siniester_data.aux_affected == "" ||
          vm.siniester_data.aux_affected == undefined
        ) {
          SweetAlert.swal(
            "Dato requerido",
            "Debe agregar un beneficiario al siniestro de colectividad",
            "error"
          );
          return;
        }
      }
      // if(vm.status.id == 2){
      //     if(!vm.promise_date){
      //         SweetAlert.swal("Dato requerido","Elige una fecha compromiso","error");
      //         return;
      //     }
      // }

      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      var obj_siniestro = {
        poliza: vm.selectedPoliza.data.url,
        // poliza: vm.selectedPoliza.data,
        folio_compania: vm.folio_compania ? vm.folio_compania : null,
        status: vm.status.id,
        aux_affected: vm.siniester_data.aux_affected,
        numero_siniestro: vm.siniester_data.siniester_number
          ? vm.siniester_data.siniester_number
          : "",
        fecha_siniestro: new Date(vm.affect_data.siniester_date),
        promise_date: vm.promise_date ? new Date(vm.promise_date) : null,
        tipo_siniestro_general: 3,
        observations: vm.siniester_data.observations,
        fecha_ingreso: vm.affect_data.fecha_ingreso,
        auto_siniester: [
          {
            tipo_siniestro: vm.siniester_type,
            explicacion: vm.siniester_data.explicacion,
            tercero: vm.siniester_data.tercero,
            contacto_auto: vm.contacts,
            conductor: vm.siniester_data.conductor,
          },
        ],
      };

      if (obj_siniestro.auto_siniester[0].contacto_auto.length) {
        obj_siniestro.auto_siniester[0].contacto_auto.forEach(function (
          contact
        ) {
          if (
            contact.first_name == null ||
            contact.first_name == undefined ||
            contact.first_name == ""
          ) {
            $scope.saveOK = false;
          }
          if (contact.email) {
            if (!validateEmail(contact.email)) {
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.INVALIDEMAILCONTACT,
                "error"
              );
              $scope.saveOK = false;
            }
          }
        });
      }
      if ($scope.saveOK == false) {
        l.stop();
        SweetAlert.swal(
          "Datos incompletos en el contacto",
          "Complete datos correctamente",
          "error"
        );
        return;
      }
      if ($scope.saveOK == true) {
        $http
          .post(url.IP + "siniestros-autos/", obj_siniestro)
          .then(function (siniestro) {
            l.stop();
            if (siniestro.status === 200 || siniestro.status === 201) {
              $localStorage["save_created_siniester_auto"] = {};
              PersistenceFactory.eliminar();
              uploadFiles(siniestro.data.id);
              $scope.idSiniestro = siniestro.data.id;
              $scope.siniestro_info = siniestro.data;
              var params = {
                model: 5,
                event: "POST",
                associated_id: $scope.idSiniestro,
                identifier: "creó el siniestro.",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});

              if (vm.selected_affect) {
                if (vm.selected_affect.label) {
                  var params = {
                    model: 1,
                    event: "POST",
                    associated_id: vm.selectedPoliza.data.id,
                    identifier: "creó un siniestro.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                } else {
                  var params = {
                    model: 18,
                    event: "POST",
                    associated_id: vm.selectedPoliza.data.id,
                    identifier: "creó un siniestro.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                }
              }
              if ($scope.url !== "/index/main") {
                if ($scope.siniestro_info.poliza) {
                  $http
                    .get($scope.siniestro_info.poliza)
                    .then(function (response) {
                      vm.infoSiniestro = {};
                      vm.infoSiniestro.poliza = response.data;
                      // Send Email
                      // if (vm.infoSiniestro.poliza.contractor){
                      //     $http.get(vm.infoSiniestro.poliza.contractor)
                      //       .then(function(response) {
                      //         if(response.data.email){
                      //             // Send email
                      //             if($localStorage.email_config){
                      //                 if($localStorage.email_config.solicitud_siniestro == true){
                      //                     var model = 3;
                      //                     emailService.sendEmailAtm(model,$scope.idSiniestro)
                      //                 }
                      //             }
                      //             // Send Email
                      //         }
                      //     });
                      // }
                      //Send Email
                    });
                }

                SweetAlert.swal(
                  "¡Listo!",
                  "Siniestro guardado exitosamente.",
                  "success"
                );
                $state.go("siniestros.auto_info", {
                  siniestroId: $scope.idSiniestro,
                });
              } else {
                if ($uibModalInstance) {
                  $uibModalInstance.dismiss("cancel");
                }
              }
            }
          });
      }
    }

    function LookFor() {
      vm.ok_afectted = {};
      try {
        $http
          .get(
            url.IP + "leer-polizas-edit/" + vm.selected_affect.value.id + "/"
          )
          .then(function (poliza) {
            vm.selectedPoliza = poliza;

            if (poliza.data.document_type == 3) {
              // if(vm.carga_siniestro == false){
              SweetAlert.swal(
                "La póliza seleccionada es una carátula",
                "Tendrá que agregar un afectado manualmente.",
                "info"
              );
              // }
            }
            if (poliza.data.document_type == 3) {
              vm.show_caratula_afectado = true;
            } else {
              vm.show_caratula_afectado = false;
            }
            // console.log('poliza--selected',vm.selectedPoliza.data)
            ramoService
              .getSubramoById(poliza.data.subramo.id)
              .then(function (subramo) {
                vm.siniester_data.subramo = subramo.data;
              });
            var data = {
              title:
                vm.selected_affect && vm.selected_affect.value
                  ? vm.selected_affect.value.title
                  : "",
              policy_vigencia: new Date(poliza.data.end_of_validity),
              policy_vigencia_init: new Date(poliza.data.start_of_validity),
              siniester_date: new Date(),
              fecha_ingreso: new Date(),
              policy_number: poliza.data.poliza_number,
            };

            var waitReceipt = [];
            waitReceipt.push(
              $http.get(url.IP + "get-current-receipt/" + poliza.data.id)
            );
            $q.all(waitReceipt).then(function (response) {
              var status = response[0].data.status;
              data.policy_status = {};
              switch (status) {
                case 1:
                  data.policy_status["label"] = "Pagado";
                  data.policy_status["id"] = status;
                  break;
                case 2:
                  data.policy_status["label"] = "Cancelado";
                  data.policy_status["id"] = status;
                  break;
                case 3:
                  data.policy_status["label"] = "Prorrogado";
                  data.policy_status["id"] = status;
                  break;
                case 4:
                  data.policy_status["label"] = "Pendiente de pago";
                  data.policy_status["id"] = status;
                  break;
                default:
                  data.policy_status["label"] = "Sin Estatus";
                  data.policy_status["id"] = status;
              }
            });

            // console.log('poliza.data-----',poliza.data.parent.parent.parent.natural)
            if (poliza.data.contractor) {
              $http.get(poliza.data.contractor).then(function (contratante) {
                data["contractor_addres"] =
                  contratante.data.address_contractor[0].route +
                  " #" +
                  contratante.data.address_contractor[0].street_number +
                  " " +
                  contratante.data.address_contractor[0]
                    .administrative_area_level_2 +
                  " " +
                  contratante.data.address_contractor[0]
                    .administrative_area_level_1;
                data["contratante"] = contratante.data;
                data["contratante"].name = contratante.data.full_name;
                $scope.contratante = data["contratante"].name;
                try {
                  $scope.obj = {
                    label:
                      $scope.contratante +
                      "   -   " +
                      "SERIE: " +
                      poliza.data.automobiles_policy[0].serial +
                      "   -   " +
                      "PÓLIZA: " +
                      poliza.data.poliza_number,
                    val:
                      $scope.contratante +
                      "   -   " +
                      "SERIE: " +
                      poliza.data.automobiles_policy[0].serial +
                      "   -   " +
                      "PÓLIZA: " +
                      poliza.data.poliza_number,
                    value: {
                      id: poliza.data.id,
                    },
                  };
                  vm.ok_afectted = $scope.obj;
                } catch (err) {}
              });
            }
            // console.log('-----------',poliza.data.parent.parent.parent.natural)
            if (poliza.data.parent) {
              if (poliza.data.parent.parent) {
                if (poliza.data.parent.parent.parent) {
                  if (poliza.data.parent.parent.parent.contractor) {
                    $http
                      .get(poliza.data.parent.parent.parent.contractor.url)
                      .then(function (contratante) {
                        // console.log('contratante',contratante)
                        if (contratante.data.addres_contractor) {
                          data["contractor_addres"] =
                            contratante.data.addres_contractor[0].route +
                            " #" +
                            contratante.data.addres_contractor[0]
                              .street_number +
                            " " +
                            contratante.data.addres_contractor[0]
                              .administrative_area_level_2 +
                            " " +
                            contratante.data.addres_contractor[0]
                              .administrative_area_level_1;
                        } else {
                          data["contractor_addres"] = "";
                        }
                        //    data['contractor_addres'] =contratante.data.addres_contractor[0].route + ' #'+ contratante.data.addres_contractor[0].street_number + ' ' + contratante.data.addres_contractor[0].administrative_area_level_2 + ' ' + contratante.data.addres_contractor[0].administrative_area_level_1;
                        data["contratante"] = contratante.data;
                        data["contratante"].name = contratante.data.full_name;
                        $scope.contratante = data["contratante"].name;
                        try {
                          $scope.obj = {
                            label:
                              $scope.contratante +
                              "   -   " +
                              "SERIE: " +
                              poliza.data.automobiles_policy[0].serial +
                              "   -   " +
                              "PÓLIZA: " +
                              poliza.data.poliza_number,
                            val:
                              $scope.contratante +
                              "   -   " +
                              "SERIE: " +
                              poliza.data.automobiles_policy[0].serial +
                              "   -   " +
                              "PÓLIZA: " +
                              poliza.data.poliza_number,
                            value: {
                              id: poliza.data.id,
                            },
                          };
                          vm.ok_afectted = $scope.obj;
                        } catch (err) {}
                      });
                  }
                }
              }
            }

            providerService
              .getProviderById(poliza.data.aseguradora)
              .then(function (aseguradora) {
                data["aseguradora"] = aseguradora.data;
              });

            if (poliza.data.paquete) {
              packageService
                .getPackageById(poliza.data.paquete.id)
                .then(function (paquete) {
                  data["paquete"] = paquete.data;
                });
            }

            vm.affect_data = data;
            vm.ok_afectted = vm.selected_affect;
            $scope.ok_afectted = vm.selected_affect;
          });
        // saveLocalstorange();
      } catch (err) {
        // saveLocalstorange();
        SweetAlert.swal("Error", "Selecciona un Afectado valido", "error");
      }
    }

    function fillTable(ramo_number) {
      vm.siniestros = [];
      $http
        .get(url.IP + "siniestros-infotable/" + ramo_number)
        .then(function (siniestros) {
          siniestros.data.forEach(function (siniestro) {
            vm.siniestros.push(siniestro);
          });
        });
    }

    function activate() {
      try {
        if ($scope.myInsurance) {
          if ($scope.myInsurance.url) {
            if ($scope.myInsurance.doSinisterCaratula) {
              $scope.obj = {
                val: "Carátula: " + $scope.myInsurance.poliza_number,
                value: {
                  id: $scope.myInsurance.id,
                },
              };
            } else {
              $scope.val = $scope.myInsurance.poliza_number;
              $scope.obj = {
                label:
                  "serie: " +
                  $scope.myInsurance.automobiles_policy[0].serial +
                  "   -   " +
                  "PÓLIZA: " +
                  $scope.myInsurance.poliza_number,
                val: $scope.myInsurance.poliza_number,
                value: {
                  id: $scope.myInsurance.id,
                },
              };
            }
            vm.ok_afectted = angular.copy($scope.obj);
            $scope.ok_afectted = angular.copy($scope.obj);
            vm.selected_affect = angular.copy($scope.obj);
            LookFor();
            // saveLocalstorange();
          } else {
            $scope.myInsurance = {};
          }
        } else {
          $scope.myInsurance = {};
        }
      } catch (error) {
        console.log("errr", error);
        // activate()
      }
      vm.tmp_siniestro = angular.copy($rootScope.siniestro_tmp);
      vm.carga_siniestro = $rootScope.carga_siniestro;
      console.log(
        "xxxxxxxxxxxxx",
        $scope.ok_afectted,
        $scope.myInsurance,
        $stateParams.myInsurance
      );
      // console.log('vengo de allá ', $rootScope.siniestro_tmp, vm.carga_siniestro);
      if (vm.carga_siniestro) {
        if (vm.tmp_siniestro.facturas && vm.tmp_siniestro.facturas.length) {
          vm.tmp_siniestro.facturas.forEach(function (factura_a_cargar) {
            var obj = {
              serie: factura_a_cargar.serie,
              f_number: factura_a_cargar.numero_factura,
              concepto: factura_a_cargar.concepto,
              proovedor: factura_a_cargar.proveedor,
              f_date: factura_a_cargar.fecha_factura,
              import: parseFloat(factura_a_cargar.importe),
              iva: factura_a_cargar.iva,
              total: factura_a_cargar.total,
            };
            vm.facturas.push(obj);
          });
        }

        // vm.selected_disease = parComplement.value.accidente[0];
        vm.siniester_data.observations = vm.tmp_siniestro.observations;

        vm.affect_data.siniester_date = vm.tmp_siniestro.fecha_siniestro;
        vm.affect_data.fecha_ingreso = vm.tmp_siniestro.fecha_ingreso;

        if (
          vm.tmp_siniestro.auto_siniester &&
          vm.tmp_siniestro.auto_siniester.length
        ) {
          vm.siniester_data.explicacion =
            vm.tmp_siniestro.auto_siniester[0].explicacion;
          vm.siniester_type = vm.tmp_siniestro.auto_siniester[0].tipo_siniestro;
          if (
            vm.tmp_siniestro.auto_siniester[0].contacto_auto &&
            vm.tmp_siniestro.auto_siniester[0].contacto_auto.length
          ) {
            vm.contacts = vm.tmp_siniestro.auto_siniester[0].contacto_auto;
          }
        }

        /*if(vm.tmp_siniestro.auto_siniester[0].conductor){
                    vm.siniester_data.conductor = vm.tmp_siniestro.auto_siniester[0].conductor
                }*/

        if (vm.tmp_siniestro.poliza.document_type == 3) {
          vm.siniester_data.aux_affected = vm.tmp_siniestro.aux_affected;
          var label = "Carátula: " + vm.tmp_siniestro.poliza.poliza_number;
        } else {
          var label = "Póliza: " + vm.tmp_siniestro.poliza_number;
        }

        var ns = {
          label: vm.tmp_siniestro.numero_siniestro,
          value: 0,
        };
        vm.siniester_data.siniester_number = ns;
        // vm.siniester_data.observations = vm.tmp_siniestro.siniestro.observations
        // vm.affect_data.siniester_date = new Date(vm.tmp_siniestro.siniestro.fecha_siniestro)

        //  Falta cargar el asegurado al crearle un complemento al siniestro, numero de siniestro y forma de pago del siniestro

        // 'label':   vm.tmp_siniestro.accidente.ailment

        vm.isInicial = false;
        var obj = {
          label: label,
          val: label,
          value: {
            id: vm.tmp_siniestro.poliza_id,
            tittle_id: 1,
            name: vm.tmp_siniestro.poliza.poliza_number,
            url: undefined,
          },
        };
        vm.selected_affect = obj;
        LookFor();
        // saveLocalstorange();
      } else {
        updateStatus();
      }

      delete $rootScope.siniestro_tmp;
      $scope.fileSinister = true;
      window.scrollTo(0, 0);

      vm.selected_affect = $localStorage["save_created_siniester_auto"]
        ? $localStorage["save_created_siniester_auto"]["selected_affect"]
        : { val: "" };
      if ($localStorage["save_created_siniester_auto"]) {
        if ($localStorage["save_created_siniester_auto"]["selected_affect"]) {
          vm.LookFor();
        }
      }
      vm.siniester_data.aux_affected = $localStorage[
        "save_created_siniester_auto"
      ]
        ? $localStorage["save_created_siniester_auto"]["aux_affected"]
        : "";
      vm.affect_data.fecha_ingreso = $localStorage[
        "save_created_siniester_auto"
      ]
        ? $localStorage["save_created_siniester_auto"]["fecha_ingreso"]
        : "";
      vm.siniester_data.siniester_number = $localStorage[
        "save_created_siniester_auto"
      ]
        ? $localStorage["save_created_siniester_auto"]["siniester_number"]
        : "";
      vm.affect_data.siniester_date = $localStorage[
        "save_created_siniester_auto"
      ]
        ? $localStorage["save_created_siniester_auto"]["siniester_date"]
        : "";
      vm.siniester_type = $localStorage["save_created_siniester_auto"]
        ? $localStorage["save_created_siniester_auto"]["siniester_type"]
        : "";
      vm.siniester_data.tercero = $localStorage["save_created_siniester_auto"]
        ? $localStorage["save_created_siniester_auto"]["tercero"]
        : "";
      vm.siniester_data.explicacion = $localStorage[
        "save_created_siniester_auto"
      ]
        ? $localStorage["save_created_siniester_auto"]["explicacion"]
        : "";
      vm.status.id = $localStorage["save_created_siniester_auto"]
        ? $localStorage["save_created_siniester_auto"]["status"]
        : "";
      vm.folio_compania = $localStorage["save_created_siniester_auto"]
        ? $localStorage["save_created_siniester_auto"]["folio_compania"]
        : "";
      vm.promise_date = $localStorage["save_created_siniester_auto"]
        ? $localStorage["save_created_siniester_auto"]["promise_date"]
        : "";
      vm.siniester_data.conductor = $localStorage["save_created_siniester_auto"]
        ? $localStorage["save_created_siniester_auto"]["conductor"]
        : "";
      vm.siniester_data.observations = $localStorage[
        "save_created_siniester_auto"
      ]
        ? $localStorage["save_created_siniester_auto"]["observations"]
        : "";
      vm.contacts =
        $localStorage["save_created_siniester_auto"] &&
        $localStorage["save_created_siniester_auto"]["contacts"]
          ? $localStorage["save_created_siniester_auto"]["contacts"]
          : [];

      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Archivos") {
            vm.permarch = perm;
            vm.permarch.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  vm.permiso_administrar_adjuntos = true;
                } else {
                  vm.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
        });
      }
    }

    if ("save_created_siniester_auto" in $localStorage) {
    } else {
      $localStorage["save_created_siniester_auto"] = {};
    }

    vm.saveLocalstorange = saveLocalstorange;
    function saveLocalstorange() {
      $localStorage["save_created_siniester_auto"]["selected_affect"] =
        vm.selected_affect ? vm.selected_affect : "";
      $localStorage["save_created_siniester_auto"]["aux_affected"] = vm
        .siniester_data.aux_affected
        ? vm.siniester_data.aux_affected
        : "";
      $localStorage["save_created_siniester_auto"]["fecha_ingreso"] = vm
        .affect_data.fecha_ingreso
        ? vm.affect_data.fecha_ingreso
        : "";
      $localStorage["save_created_siniester_auto"]["siniester_number"] = vm
        .siniester_data.siniester_number
        ? vm.siniester_data.siniester_number
        : "";
      $localStorage["save_created_siniester_auto"]["siniester_date"] = vm
        .affect_data.siniester_date
        ? vm.affect_data.siniester_date
        : "";
      $localStorage["save_created_siniester_auto"]["siniester_type"] =
        vm.siniester_type ? vm.siniester_type : "";
      $localStorage["save_created_siniester_auto"]["tercero"] = vm
        .siniester_data.tercero
        ? vm.siniester_data.tercero
        : "";
      $localStorage["save_created_siniester_auto"]["explicacion"] = vm
        .siniester_data.explicacion
        ? vm.siniester_data.explicacion
        : "";
      $localStorage["save_created_siniester_auto"]["status"] = vm.status.id
        ? vm.status.id
        : "";
      $localStorage["save_created_siniester_auto"]["folio_compania"] =
        vm.folio_compania ? vm.folio_compania : "";
      $localStorage["save_created_siniester_auto"]["promise_date"] =
        vm.promise_date ? vm.promise_date : "";
      $localStorage["save_created_siniester_auto"]["conductor"] = vm
        .siniester_data.conductor
        ? vm.siniester_data.conductor
        : "";
      $localStorage["save_created_siniester_auto"]["observations"] = vm
        .siniester_data.observations
        ? vm.siniester_data.observations
        : "";
      $localStorage["save_created_siniester_auto"]["contacts"] = vm.contacts
        ? vm.contacts
        : [];
    }

    function showSubRamos(event) {
      vm.ramoId = event.target.id;
    }

    function textAExpand(event) {
      var element = e.target;
      var scroll = element.scrollHeight - 60;
      element.style.height = scrollHeight + "px";
    }

    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      // var date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
      // return date;
      var date = inputFormat;
      if (inputFormat.length != 10) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }
      }
      return date;
    }
    vm.cadenaBusq = cadenaBusq;
    function cadenaBusq(v) {
      $scope.cadena_a_buscar = v;
    }
    $scope.habuscado = false;
    function updateStatus(cadenaa) {
      console.log("zzzzzz", $scope.ok_afectted);
      vm.affected.length = 0;
      $scope.habuscado = true;
      var word_data =
        $scope.cadena_a_buscar && $scope.cadena_a_buscar.val
          ? $scope.cadena_a_buscar.val
          : $scope.cadena_a_buscar;

      if (word_data) {
        if (word_data.length >= 3) {
          var word = word_data.split(" ").join("_");
          if ($scope.val) {
            var word = $scope.val;
            var word = word.split(" ").join("_");
          }
          insuranceService
            .getInsurances_by_ramo(3, word)
            .then(function (polizas) {
              polizas.forEach(function (poliza) {
                if (poliza.parent) {
                  if (poliza.parent.parent) {
                    if (poliza.parent.parent.parent) {
                      if (poliza.parent.parent.parent.contractor) {
                        poliza.contractor =
                          poliza.parent.parent.parent.contractor;
                      }
                    }
                  }
                }
                // console.log('tye_document',poliza)
                if (
                  poliza.document_type == 1 ||
                  poliza.document_type == 6 ||
                  poliza.document_type == 12
                ) {
                  if (poliza.contractor && poliza.automobiles_policy[0]) {
                    var obj = {
                      label:
                        poliza.contractor.full_name +
                        "   -   " +
                        "serie: " +
                        poliza.automobiles_policy[0].serial +
                        "   -   " +
                        "poliza: " +
                        poliza.poliza_number,
                      value: {
                        id: poliza.id,
                      },
                    };
                    function findCoincidences(argument) {
                      return argument.value.id === obj.value.id;
                    }

                    if (!vm.affected.find(findCoincidences)) {
                      vm.affected.push(obj);
                    }
                  }
                }
              });
            });
        }
      } else {
        vm.affected.length = 0;
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "SiniestrosAccidentesCreateCtrl",
      SiniestrosAccidentesCreateCtrl
    );

  SiniestrosAccidentesCreateCtrl.$inject = [
    "$parse",
    "$scope",
    "dataFactory",
    "SweetAlert",
    "datesFactory",
    "$sce",
    "$uibModal",
    "toaster",
    "$http",
    "url",
    "insuranceService",
    "ramoService",
    "$q",
    "providerService",
    "packageService",
    "SiniestroService",
    "facturas_conceptos",
    "$rootScope",
    "$state",
    "$stateParams",
    "helpers",
    "$localStorage",
    "emailService",
    "$sessionStorage",
    "$location",
    "contactService",
    "FileUploader",
    "$timeout",
    "MESSAGES",
  ];

  function SiniestrosAccidentesCreateCtrl(
    $parse,
    $scope,
    dataFactory,
    SweetAlert,
    datesFactory,
    $sce,
    $uibModal,
    toaster,
    $http,
    url,
    insuranceService,
    ramoService,
    $q,
    providerService,
    packageService,
    SiniestroService,
    facturas_conceptos,
    $rootScope,
    $state,
    $stateParams,
    helpers,
    $localStorage,
    emailService,
    $sessionStorage,
    $location,
    contactService,
    FileUploader,
    $timeout,
    MESSAGES
  ) {
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.url = $location.path();

    var vm = this;
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    $scope.existenFacturas = false;
    $scope.new_siniestro = {};
    $scope.new_accidente = {};
    $scope.filters = {};
    $scope.siniestros = false;
    $scope.accidentes = false;
    $scope.fileSinister = true;
    $scope.unknownConceptsAlert = [];
    $scope.unknownConcepts = [];

    $scope.new_siniestro.fechaIngreso = datesFactory.convertDate(new Date()); // esta es la fecha de captura
    $scope.new_siniestro.fechaSiniestro = datesFactory.convertDate(new Date());
    $scope.new_siniestro.fechaTerminacion = datesFactory.convertDate(
      new Date()
    );
    $scope.new_siniestro.fecha = datesFactory.convertDate(new Date()); // esta es la fecha de ingreso
    $scope.new_siniestro.fecha_compromiso = datesFactory.convertDate(
      new Date()
    );

    vm.form = {};
    //vm.BuscarAfectados = BuscarAfectados;
    vm.buscaPadecimientos = buscaPadecimientos;
    vm.BuscarIniciales = BuscarIniciales;
    vm.checkRadio = CheckRadio;
    vm.selected_affect = [];
    vm.selected_poliza;
    vm.selected_disease = [];
    vm.selectedRamo = null;
    vm.selectedSubRamo = null;
    vm.selectedPoliza;
    vm.siniester_data = {};
    vm.siniester_data.siniestros_by_number = [];
    vm.siniester_data.selected_number_siniester;
    vm.affect_data = {};
    vm.addFactura = addFactura;
    vm.clearFacturas = clearFacturas;
    vm.facturas_conceptos = facturas_conceptos;
    var facturasExcelHeaders = [
      "Serie",
      "No. Factura",
      "Concepto",
      "Proveedor",
      "Fecha de factura",
      "Importe",
      "IVA",
      "Total",
      "Procedente",
    ];
    var facturasExcelColumnMap = {
      serie: "serie",
      nofactura: "f_number",
      concepto: "concepto",
      proveedor: "proovedor",
      fechadefactura: "f_date",
      importe: "import",
      iva: "iva",
      total: "total",
      procedente: "procedente",
    };
    var columnOrder = [
      "serie",
      "f_number",
      "concepto",
      "proovedor",
      "f_date",
      "import",
      "iva",
      "total",
      "procedente",
    ];
    var facturasExcelHeaders = [
      "Serie",
      "No. Factura",
      "Concepto",
      "Proveedor",
      "Fecha de factura",
      "Importe",
      "IVA",
      "Total",
      "Procedente",
    ];
    var facturasExcelColumnMap = {
      serie: "serie",
      nofactura: "f_number",
      concepto: "concepto",
      proveedor: "proovedor",
      fechadefactura: "f_date",
      importe: "import",
      iva: "iva",
      total: "total",
      procedente: "procedente",
    };
    vm.facturas = [];
    vm.show_caratula = false;
    vm.show_poliza = false;
    vm.deleteFactura = deleteFactura;
    vm.totalImporte = 0;
    vm.totalIva = 0;
    vm.totalTotal = 0;
    vm.totalProcedente = 0;
    vm.downloadFacturas = downloadFacturas;
    vm.downloadPlantillaFacturas = downloadPlantillaFacturas;
    vm.handleFacturasExcelFile = handleFacturasExcelFile;
    vm.importFacturasFromExcel = importFacturasFromExcel;
    vm.carga_siniestro = false;
    vm.isInicial = true;
    vm.updateStatus = updateStatus;
    vm.BuscarPolizas = BuscarPolizas;
    vm.LlenarDatos = LlenarDatos;
    vm.aux = false;
    vm.selected_state = [];
    vm.citiesArray = [];
    vm.statesArray = [];
    vm.ciudades_estados = ciudades_estados;
    vm.myInsurance = $stateParams.myInsurance;
    vm.affected = [];
    vm.affected.length = 0;
    vm.contactos = [];
    vm.check_city_state = check_city_state;
    vm.show_state_city = false;
    vm.uploadFiles = uploadFiles;
    vm.files;
    $scope.archivos = {};
    vm.id_policy;
    vm.updateHospital = updateHospital;
    vm.saveLocalstorange = saveLocalstorange;
    vm.saveLocalstorangeStatus = saveLocalstorangeStatus;
    vm.selected_affect_fucntion = selected_affect_fucntion;
    vm.hospital = {};
    vm.hospitals = [];

    //Funciones para contactos

    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;
    //Select de opciones de estatus
    vm.status = [
      {
        id: 1,
        name: "Pendiente",
      },
      {
        id: 2,
        name: "En Trámite",
      },
      {
        id: 3,
        name: "Completada/Procedente",
      },
      {
        id: 4,
        name: "Cancelada",
      },
      {
        id: 5,
        name: "Rechazada/ No Procedente",
      },
      {
        id: 6,
        name: "En espera/ Solicitud de Información",
      },
      {
        id: 7,
        name: "Reproceso",
      },
      {
        id: 8,
        name: "Inconformidad",
      },
    ];
    //select de opciones de tipo de siniestro
    vm.tipo = [
      {
        id: 1,
        name: "Accidente",
      },
      {
        id: 2,
        name: "Enfermedad",
      },
      {
        id: 3,
        name: "Parto",
      },
    ];
    //select para los tipos de pago
    vm.tipo_pago = [
      {
        id: 1,
        name: "Reembolso",
      },
      {
        id: 2,
        name: "Programacion",
      },
      {
        id: 3,
        name: "Pago Directo",
      },
      {
        id: 4,
        name: "Aclaración",
      },
    ];
    //select para el parentesco del afectado con el titular
    vm.parentesco = [
      {
        id: 1,
        name: "Titular",
      },
      {
        id: 2,
        name: "Conyugue",
      },
      {
        id: 3,
        name: "Hijo",
      },
      {
        id: 4,
        name: "Otro",
      },
    ];

    var titles = {
      1: "Titular",
      2: "Cónyuge",
      3: "Hijo",
      4: "Otro",
    };

    activate();

    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    $scope.nocertificado = false;
    function activate() {
      $scope.nocertificado = false;
      //Crear complemento desde el siniestro
      $scope.new_accidente.fecha_cirugia =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["fecha_cirugia"]
          ? $localStorage["save_created_siniester_accident"]["fecha_cirugia"]
          : convertDate(new Date());
      $scope.new_accidente.monto_hospital =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["monto_hospital"]
          ? $localStorage["save_created_siniester_accident"]["monto_hospital"]
          : 0;
      $scope.new_accidente.ded_hospital =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["ded_hospital"]
          ? $localStorage["save_created_siniester_accident"]["ded_hospital"]
          : 0;
      $scope.new_accidente.coas_hospital =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["coas_hospital"]
          ? $localStorage["save_created_siniester_accident"]["coas_hospital"]
          : 0;
      $scope.new_accidente.monto_honorarios =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["monto_honorarios"]
          ? $localStorage["save_created_siniester_accident"]["monto_honorarios"]
          : 0;
      $scope.new_accidente.cirujano =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["cirujano"]
          ? $localStorage["save_created_siniester_accident"]["cirujano"]
          : 0;
      $scope.new_accidente.anestesiologo =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["anestesiologo"]
          ? $localStorage["save_created_siniester_accident"]["anestesiologo"]
          : 0;
      $scope.new_accidente.ayudante =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["ayudante"]
          ? $localStorage["save_created_siniester_accident"]["ayudante"]
          : 0;
      $scope.new_accidente.otros =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["otros"]
          ? $localStorage["save_created_siniester_accident"]["otros"]
          : 0;
      $scope.new_accidente.coas_honorarios =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["coas_honorarios"]
          ? $localStorage["save_created_siniester_accident"]["coas_honorarios"]
          : 0;
      $scope.new_accidente.ded_honorarios =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["ded_honorarios"]
          ? $localStorage["save_created_siniester_accident"]["ded_honorarios"]
          : 0;
      vm.hospital =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["hospital"]
          ? $localStorage["save_created_siniester_accident"]["hospital"]
          : 0;

      vm.tmp_siniestro = angular.copy($rootScope.siniestro_tmp);
      vm.carga_siniestro = $rootScope.carga_siniestro;
      //Crear siniestro desde la poliza
      try {
        if (vm.myInsurance) {
          if (!vm.form) {
            vm.form = {};
          }
          vm.form.poliza = vm.myInsurance.poliza_number;
          vm.id_policy = vm.myInsurance.id;
          if (vm.myInsurance.doSinisterCaratula) {
            // si la poliza es una caratula
            var obj = {
              val: "Carátula: " + vm.myInsurance.poliza_number,
              value: {
                id: vm.myInsurance.id,
                title: titles[1],
                tittle_id: 1,
                name: vm.myInsurance.poliza_number,
                url: "",
              },
            };
            vm.selected_affect = obj;
            //vm.BuscarPolizas();
            vm.LlenarDatos();
            saveLocalstorange();
          } else {
            if (vm.myInsurance.url) {
              var name = [];
              vm.form.poliza = vm.myInsurance.poliza_number; //numer de poliza
              if (vm.myInsurance.relation) {
                //si se selecciona un dependiente
                for (
                  var i = 0;
                  i <
                  vm.myInsurance.accidents_policy[0].relationship_accident
                    .length;
                  i++
                ) {
                  if (
                    vm.myInsurance.relation ==
                    vm.myInsurance.accidents_policy[0].relationship_accident[i]
                      .id
                  ) {
                    //Nombre del dependiente
                    name =
                      vm.myInsurance.accidents_policy[0].relationship_accident[
                        i
                      ];
                  }
                }

                //datos del dependiente afectado
                var obj = {
                  label:
                    name.first_name +
                    " " +
                    name.last_name +
                    " " +
                    name.second_last_name,
                  value: {
                    birthdate: name.birthdate,
                    full_name:
                      name.first_name +
                      " " +
                      name.last_name +
                      " " +
                      name.second_last_name,
                    id: vm.myInsurance.id,
                    relationship: name.relationship,
                    title: titles[name.relationship],
                    url: name.url,
                  },
                };

                //vm.BuscarPolizas(); //busca la poliza
                vm.selected_affect = obj; //asigna los datos del afectado
                vm.LlenarDatos(); // llena la informacion
                saveLocalstorange();
              } else {
                //si el seleccionado es el titular
                name = vm.myInsurance.accidents_policy[0].personal;
                //informacion del titular
                var obj = {
                  label:
                    name.first_name +
                    " " +
                    name.last_name +
                    " " +
                    name.second_last_name,
                  value: {
                    birthdate: name.birthdate,
                    full_name:
                      name.first_name +
                      " " +
                      name.last_name +
                      " " +
                      name.second_last_name,
                    id: vm.myInsurance.id,
                    relationship: 1,
                    title: titles[1],
                    url: name.url,
                  },
                };
                //vm.BuscarPolizas(); //busca la poliza
                vm.selected_affect = obj; //asigna la informacion del afectado
                vm.LlenarDatos(); //llena los datos del form
                saveLocalstorange();
              }
            }
          }
          if (vm.myInsurance && vm.myInsurance.document_type == 6) {
            $scope.nocertificado = true;
          }
        }
      } catch (error) {
        console.log("error", error);
      }

      //Si se obtinen los datos del siniestro
      if (vm.carga_siniestro) {
        //se llena el numero de la poliza para buscarlo
        vm.form.poliza = vm.tmp_siniestro.poliza.poliza_number;
        vm.id_poliza = vm.tmp_siniestro.poliza.id;
        //BuscarPolizas();
        //console.log("siniestro tmp",vm.tmp_siniestro)
        //despues se llenan los datos del afectado si es un dependiente
        if (vm.tmp_siniestro.siniestro.aux_affected) {
          $scope.new_siniestro.aux_affected =
            vm.tmp_siniestro.siniestro.aux_affected;
          $scope.new_siniestro.relationship_aux_affected =
            vm.tmp_siniestro.siniestro.relationship_aux_affected;

          var obj = {
            label: vm.tmp_siniestro.siniestro.poliza_number,
            value: {
              id: vm.tmp_siniestro.poliza.id,
              document_type: vm.tmp_siniestro.poliza.document_type,
            },
          };

          vm.selected_affect = obj;
        } else if (vm.tmp_siniestro.accidente.dependiente) {
          //datos del beneficiario
          var obj = {
            label:
              vm.tmp_siniestro.accidente.affected_full_name + " - DEPENDIENTE ",
            value: {
              birthdate: vm.tmp_siniestro.accidente.dependiente.birthdate,
              full_name: vm.tmp_siniestro.accidente.affected_full_name,
              id: vm.tmp_siniestro.poliza.id,
              id_afectado: vm.tmp_siniestro.accidente.dependiente.id,
              relationship: vm.tmp_siniestro.accidente.dependiente.relationship,
              document_type: vm.tmp_siniestro.poliza.document_type,
              title: vm.tmp_siniestro.relationship,
              url: vm.tmp_siniestro.accidente.dependiente.url,
            },
          };

          vm.selected_affect = obj;
        } else if (vm.tmp_siniestro.accidente.titular) {
          //datos del titular
          var obj = {
            label:
              vm.tmp_siniestro.accidente.affected_full_name + " - Titular ",
            value: {
              birthdate: vm.tmp_siniestro.accidente.titular.birthdate,
              full_name: vm.tmp_siniestro.accidente.titular.full_name,
              id: vm.tmp_siniestro.poliza.id,
              id_afectado: vm.tmp_siniestro.accidente.titular.id,
              document_type: vm.tmp_siniestro.poliza.document_type,
              relationship: vm.tmp_siniestro.accidente.relationship,
              title: vm.tmp_siniestro.relationship,
              url: vm.tmp_siniestro.accidente.titular.url,
            },
          };

          vm.selected_affect = obj;
        }

        //Llenar la informacion del padecimiento
        var obj2 = {
          label: vm.tmp_siniestro.accidente.ailment,
          val: vm.tmp_siniestro.accidente.ailment,
          value: {
            label: vm.tmp_siniestro.accidente.ailment,
          },
        };
        vm.selected_disease = obj2;

        LlenarDatos(); //funcion para llenar la informacion

        if ($rootScope.tmp_complemento == true) {
          $scope.new_accidente.razon_siniestro =
            vm.tmp_siniestro.accidente.razon_siniestro;
          vm.checkRadio("Complemento");
        }
      }

      //Cargar la lista de los estados
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          vm.statesArray = data.data;
          //console.log(vm.statesArray)
          if ($localStorage["save_created_siniester_accident"]) {
            if ($localStorage["save_created_siniester_accident"]["state"]) {
              vm.statesArray.forEach(function (item) {
                if (
                  item.url ==
                  $localStorage["save_created_siniester_accident"]["state"][
                    "url"
                  ]
                ) {
                  $scope.new_siniestro.state = item;
                  ciudades_estados();
                }
              });
            }
          }
        });
      delete $rootScope.siniestro_tmp;
      delete $rootScope.carga_siniestro;
      vm.form.poliza = $localStorage["save_created_siniester_accident"]
        ? $localStorage["save_created_siniester_accident"]["poliza"]
        : "";

      if ($localStorage["save_created_siniester_accident"]) {
        if ($localStorage["save_created_siniester_accident"]["poliza"]) {
          vm.BuscarPolizas(
            $localStorage["save_created_siniester_accident"]["poliza"]
          );
        }
      }
      // vm.selected_affect = $localStorage['save_created_siniester_accident'] ? $localStorage['save_created_siniester_accident']['selected_affect'] : '';
      $scope.new_accidente.razon_siniestro = $localStorage[
        "save_created_siniester_accident"
      ]
        ? $localStorage["save_created_siniester_accident"]["razon_siniestro"]
        : 0;
      if ($localStorage["save_created_siniester_accident"]) {
        vm.status.forEach(function (item) {
          if (
            item.id ==
            $localStorage["save_created_siniester_accident"]["status"]
          ) {
            $scope.new_siniestro.status = item.id;
          }
        });
      }
      // $scope.new_accidente.status = $localStorage['save_created_siniester_accident'] ? $localStorage['save_created_siniester_accident']['status'] : 0;

      vm.selected_disease = $localStorage["save_created_siniester_accident"]
        ? $localStorage["save_created_siniester_accident"]["selected_disease"]
        : "";
      $scope.new_accidente.tipo_pago = $localStorage[
        "save_created_siniester_accident"
      ]
        ? $localStorage["save_created_siniester_accident"]["tipo_pago"]
        : "";
      $scope.new_siniestro.folio_compania = $localStorage[
        "save_created_siniester_accident"
      ]
        ? $localStorage["save_created_siniester_accident"]["folio_compania"]
        : "";
      $scope.new_accidente.reason = $localStorage[
        "save_created_siniester_accident"
      ]
        ? $localStorage["save_created_siniester_accident"]["reason"]
        : "";
      $scope.new_siniestro.observations = $localStorage[
        "save_created_siniester_accident"
      ]
        ? $localStorage["save_created_siniester_accident"]["observations"]
        : "";
      vm.show_state_city = $localStorage["save_created_siniester_accident"]
        ? $localStorage["save_created_siniester_accident"]["show_state_city"]
        : "";
      vm.contactos =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["contactos"]
          ? $localStorage["save_created_siniester_accident"]["contactos"]
          : [];
      vm.facturas =
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["facturas"]
          ? $localStorage["save_created_siniester_accident"]["facturas"]
          : [];
      $scope.active = 0;
      if (!vm.facturas || vm.facturas.length == 0) {
        addFactura();
      }
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Archivos") {
            vm.permarch = perm;
            vm.permarch.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  vm.permiso_administrar_adjuntos = true;
                } else {
                  vm.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
        });
      }
    }

    if ("save_created_siniester_accident" in $localStorage) {
    } else {
      $localStorage["save_created_siniester_accident"] = {};
    }

    function saveLocalstorange() {
      if (vm.form) {
        if (vm.form && vm.form.poliza) {
          if (vm.form.poliza) {
            if (vm.form.poliza.val) {
              $localStorage["save_created_siniester_accident"]["poliza"] = vm
                .form.poliza
                ? vm.form.poliza
                : "";
            } else {
              $localStorage["save_created_siniester_accident"]["poliza"] = vm
                .form.poliza
                ? {
                    val: vm.form.poliza,
                    value: {
                      id: vm.myInsurance.id,
                      num_poliza: vm.form.poliza,
                    },
                  }
                : "";
            }
          } else {
            $localStorage["save_created_siniester_accident"]["poliza"] = vm.form
              .poliza
              ? {
                  val: vm.myInsurance.poliza_number,
                  value: {
                    id: vm.myInsurance.id,
                    num_poliza: vm.myInsurance.poliza_number,
                  },
                }
              : "";
          }
        }
      }
      $localStorage["save_created_siniester_accident"]["selected_affect"] =
        vm.selected_affect ? vm.selected_affect : {};
      $localStorage["save_created_siniester_accident"]["razon_siniestro"] =
        $scope.new_accidente.razon_siniestro
          ? $scope.new_accidente.razon_siniestro
          : 0;
      // $localStorage['save_created_siniester_accident']['status'] =  $scope.new_accidente.status ? $scope.new_accidente.status : 0;
      $localStorage["save_created_siniester_accident"]["numero_siniestro"] =
        $scope.new_siniestro.numero_siniestro
          ? $scope.new_siniestro.numero_siniestro
          : "";
      $localStorage["save_created_siniester_accident"]["selected_disease"] =
        vm.selected_disease ? vm.selected_disease : "";
      $localStorage["save_created_siniester_accident"]["tipo_pago"] = $scope
        .new_accidente.tipo_pago
        ? $scope.new_accidente.tipo_pago
        : "";
      $localStorage["save_created_siniester_accident"]["folio_compania"] =
        $scope.new_siniestro.folio_compania
          ? $scope.new_siniestro.folio_compania
          : "";
      $localStorage["save_created_siniester_accident"]["reason"] = $scope
        .new_accidente.reason
        ? $scope.new_accidente.reason
        : "";
      $localStorage["save_created_siniester_accident"]["observations"] = $scope
        .new_siniestro.observations
        ? $scope.new_siniestro.observations
        : "";
      $localStorage["save_created_siniester_accident"]["show_state_city"] =
        vm.show_state_city ? vm.show_state_city : false;
      $localStorage["save_created_siniester_accident"]["state"] = $scope
        .new_siniestro.state
        ? $scope.new_siniestro.state
        : "";
      $localStorage["save_created_siniester_accident"]["city"] = $scope
        .new_siniestro.city
        ? $scope.new_siniestro.city
        : "";
      $localStorage["save_created_siniester_accident"]["contactos"] =
        vm.contactos ? vm.contactos : [];

      $localStorage["save_created_siniester_accident"]["hospital"] =
        vm.hospital;

      $localStorage["save_created_siniester_accident"]["fecha_cirugia"] = $scope
        .new_accidente.fecha_cirugia
        ? $scope.new_accidente.fecha_cirugia
        : "";
      $localStorage["save_created_siniester_accident"]["monto_hospital"] =
        $scope.new_accidente.monto_hospital
          ? $scope.new_accidente.monto_hospital
          : "";
      $localStorage["save_created_siniester_accident"]["ded_hospital"] = $scope
        .new_accidente.ded_hospital
        ? $scope.new_accidente.ded_hospital
        : "";
      $localStorage["save_created_siniester_accident"]["coas_hospital"] = $scope
        .new_accidente.coas_hospital
        ? $scope.new_accidente.coas_hospital
        : "";
      $localStorage["save_created_siniester_accident"]["monto_honorarios"] =
        $scope.new_accidente.monto_honorarios
          ? $scope.new_accidente.monto_honorarios
          : "";
      $localStorage["save_created_siniester_accident"]["cirujano"] = $scope
        .new_accidente.cirujano
        ? $scope.new_accidente.cirujano
        : "";
      $localStorage["save_created_siniester_accident"]["anestesiologo"] = $scope
        .new_accidente.anestesiologo
        ? $scope.new_accidente.anestesiologo
        : "";
      $localStorage["save_created_siniester_accident"]["ayudante"] = $scope
        .new_accidente.ayudante
        ? $scope.new_accidente.ayudante
        : "";
      $localStorage["save_created_siniester_accident"]["otros"] = $scope
        .new_accidente.otros
        ? $scope.new_accidente.otros
        : "";
      $localStorage["save_created_siniester_accident"]["coas_honorarios"] =
        $scope.new_accidente.coas_honorarios
          ? $scope.new_accidente.coas_honorarios
          : "";
      $localStorage["save_created_siniester_accident"]["ded_honorarios"] =
        $scope.new_accidente.ded_honorarios
          ? $scope.new_accidente.ded_honorarios
          : "";
      $localStorage["save_created_siniester_accident"]["facturas"] = vm.facturas
        ? vm.facturas
        : [];
    }

    function saveLocalstorangeStatus(sta) {
      $localStorage["save_created_siniester_accident"]["status"] = sta;
    }

    function toDate(dateStr) {
      if (!dateStr) {
        return null;
      }
      if (dateStr instanceof Date && !isNaN(dateStr)) {
        return dateStr;
      }
      var dateString = dateStr.toString();
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);

      return dateObject;
    }
    //Funcion para guardar los registros de los siniestros/accidentes/facturas
    $scope.saveSiniestro = function () {
      if (!vm.affect_data.policy_number) {
        SweetAlert.swal("Afectado", "No ha seleccionado el afectado", "error");
        return;
      }
      if (!vm.selected_affect.label) {
        SweetAlert.swal(
          "Afectado",
          "No ha seleccionado el certificado o el afectado",
          "error"
        );
        return;
      }
      if (
        vm.facturas.length == 0 &&
        $scope.new_siniestro.status == 3 &&
        $scope.new_accidente.tipo_pago == 1
      ) {
        SweetAlert.swal(
          "Facturación",
          "No existen facturas, agréguelas para continuar",
          "warning"
        );
        return;
      }
      // if (!$scope.new_siniestro.fechaIngreso || $scope.new_siniestro.fechaIngreso == undefined || $scope.new_siniestro.fechaIngreso == null){
      //     SweetAlert.swal("Fecha de Ingreso","Agregue una fecha de ingreso","error");
      //     return;
      // }
      if (
        !$scope.new_siniestro.fechaTerminacion ||
        $scope.new_siniestro.fechaTerminacion == undefined ||
        $scope.new_siniestro.fechaTerminacion == null
      ) {
        SweetAlert.swal(
          "Fecha de Ingreso",
          "Agregue una fecha de terminación",
          "error"
        );
        return;
      }
      if (
        !$scope.new_siniestro.fecha ||
        $scope.new_siniestro.fecha == undefined ||
        $scope.new_siniestro.fecha == null
      ) {
        SweetAlert.swal(
          "Fecha de captura",
          "Agregue una fecha de captura",
          "error"
        );
        return;
      }
      if ($scope.new_siniestro.status == 2) {
        if (
          !$scope.new_siniestro.fecha_compromiso ||
          $scope.new_siniestro.fecha_compromiso == undefined ||
          $scope.new_siniestro.fecha_compromiso == null
        ) {
          SweetAlert.swal(
            "Fecha compromiso",
            "Agregue una fecha compromiso",
            "error"
          );
          return;
        }
      }
      if (
        !$scope.new_accidente.razon_siniestro ||
        $scope.new_accidente.razon_siniestro == undefined ||
        $scope.new_accidente.razon_siniestro == null
      ) {
        SweetAlert.swal(
          "Tipo de Siniestro",
          "Seleccione un tipo de siniestro",
          "error"
        );
        return;
      }
      if (!$scope.new_siniestro.status) {
        SweetAlert.swal("Estatus", "Seleccione un estatus", "error");
        return;
      }
      if (
        !vm.selected_disease ||
        vm.selected_disease == undefined ||
        vm.selected_disease == null ||
        !vm.selected_disease.val
      ) {
        SweetAlert.swal("Padecimiento", "Seleccione un padecimiento", "error");
        return;
      }
      if (
        !$scope.new_accidente.tipo_pago ||
        $scope.new_accidente.tipo_pago == undefined ||
        $scope.new_accidente.tipo_pago == null
      ) {
        SweetAlert.swal("Tipo de Pago", "Seleccione un tipo de pago", "error");
        return;
      }
      if (vm.isInicial == false) {
        //complemento_siniestro id del siniestro inicial
        // console.log(vm.siniester_data)
        if (vm.siniester_data.siniester_number) {
          $scope.new_accidente.complemento_siniestro =
            vm.siniester_data.siniester_number.value.siniestro.id;
          $scope.new_accidente.accidente_inicial =
            vm.siniester_data.siniester_number.value.accidente.url;
          //Si se trata de un complemento el campo tipo_siniestro = 2(complemento)
          $scope.new_accidente.tipo_siniestro = 2;
          //Si es un complemento el valor de initial tiene que ser falso
          $scope.new_accidente.initial = false;
          $scope.new_siniestro.numero_siniestro =
            vm.siniester_data.siniester_number.value.siniestro.numero_siniestro;
        } else {
          $scope.new_accidente.complemento_siniestro =
            vm.siniester_data.siniester_number;
          $scope.new_accidente.accidente_inicial =
            vm.siniester_data.siniester_number;
          //Si se trata de un complemento el campo tipo_siniestro = 2(complemento)
          $scope.new_accidente.tipo_siniestro = 2;
          //Si es un complemento el valor de initial tiene que ser falso
          $scope.new_accidente.initial = false;
          $scope.new_siniestro.numero_siniestro =
            vm.siniester_data.siniester_number;
        }
        //fecha de terminación
      } else if (vm.isInicial == true) {
        //complemento_siniestro id es null
        $scope.new_accidente.complemento_siniestro = null;
        //Si se trata de un complemento el campo tipo_siniestro = 1(inicial)
        $scope.new_accidente.tipo_siniestro = 1;
        //Si es un complemento es inicial es verdadero
        $scope.new_accidente.initial = true;
      }

      //Fecha de captura
      $scope.new_siniestro.fecha_ingreso = $scope.new_siniestro.fechaIngreso
        ? toDate($scope.new_siniestro.fechaIngreso)
        : new Date();
      //Fecha de ingreso
      $scope.new_siniestro.fecha = $scope.new_siniestro.fecha
        ? toDate($scope.new_siniestro.fecha)
        : new Date();
      //fecha de siniestro
      $scope.new_siniestro.fecha_siniestro = $scope.new_siniestro.fechaSiniestro
        ? toDate($scope.new_siniestro.fechaSiniestro)
        : new Date();

      $scope.new_siniestro.fecha_terminacion = $scope.new_siniestro
        .fechaTerminacion
        ? toDate($scope.new_siniestro.fechaTerminacion)
        : new Date();
      //fecha compromiso
      // $scope.new_siniestro.fecha_compromiso = datesFactory.convertDate($scope.new_siniestro.fecha_compromiso);
      $scope.new_siniestro.fecha_compromiso = toDate(
        $scope.new_siniestro.fecha_compromiso
      );
      //Tipo general de siniestro siempre será "accidentes y enfermedades"
      $scope.new_siniestro.tipo_siniestro_general = 2;
      //Id de poliza
      $scope.new_siniestro.poliza = vm.selectedPoliza.data.url;

      //si esta seleccionado un estado
      if ($scope.new_siniestro.state) {
        $scope.new_siniestro.state = $scope.new_siniestro.state.url;
      }
      if ($scope.new_siniestro.city) {
        $scope.new_siniestro.city = $scope.new_siniestro.city;
      }

      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if ($scope.new_accidente.total_reclamado > 0) {
        var accidentes = true;
      } else {
        var accidentes = false;
      }
      $scope.new_siniestro.accidentes = accidentes;

      //Post a la tabla de siniestros
      dataFactory
        .post("siniestros-accidentes-create/", $scope.new_siniestro)
        .then(function success(responseSiniestro) {
          vm.uploadFiles(responseSiniestro.data.id);
          $localStorage["save_created_siniester_accident"] = {};
          if (
            responseSiniestro.status == 201 ||
            responseSiniestro.status == 200
          ) {
            l.stop();
            //console.log("responseSiniestro",responseSiniestro)

            //Asignar el id del siniestro al accidente tomando la url
            $scope.new_accidente.siniestro = responseSiniestro.data.url;
            //Se asigna el id del padecimiento seleccionado en el form
            if (vm.selected_disease.value) {
              $scope.new_accidente.padecimiento = vm.selected_disease.value.url;
              //Descripcion del padecimiento
              $scope.new_accidente.ailment = vm.selected_disease.value.label;
            } else {
              $scope.new_accidente.ailment = vm.selected_disease.val;
            }

            if (vm.selectedPoliza.data.document_type != 3) {
              $scope.new_accidente.affected_full_name =
                vm.selected_affect.value.full_name;
            } else {
              $scope.new_accidente.affected_full_name =
                $scope.new_siniestro.aux_affected;
            }

            //fecha de cirugia
            $scope.new_accidente.fecha_cirugia =
              $scope.new_accidente && $scope.new_accidente.fecha_cirugia
                ? datesFactory.toDate($scope.new_accidente.fecha_cirugia)
                : undefined;
            // $scope.new_accidente.fecha_cirugia = toDate($scope.new_accidente.fecha_cirugia);

            //id de titular de la póliza
            if (
              vm.selectedPoliza.data.document_type != 3 &&
              vm.selected_affect.value.relationship == 1
            ) {
              //las caratulas no tienen titular
              $scope.new_accidente.titular =
                vm.selectedPoliza.data.accidents_policy[0].personal;
            }

            //Si el afeactado no es el titular llena el campo de dependiente en la tabla de accidentes
            if (vm.selected_affect.value.relationship != 1) {
              $scope.new_accidente.dependiente = vm.selected_affect.value.url;
              $scope.new_accidente.relationship =
                vm.selected_affect.value.relationship;
            }

            //Total Final
            if ($scope.new_accidente.total_procedente) {
              $scope.new_accidente.total_procedente = parseFloat(
                $scope.new_accidente.total_procedente
              );
            } else {
              $scope.new_accidente.total_procedente = 0;
            }
            if ($scope.new_accidente.total_coaseguro) {
              $scope.new_accidente.total_coaseguro = parseFloat(
                $scope.new_accidente.total_coaseguro
              );
            } else {
              $scope.new_accidente.total_coaseguro = 0;
            }
            if ($scope.new_accidente.total_deducible) {
              $scope.new_accidente.total_deducible = parseFloat(
                $scope.new_accidente.total_deducible
              );
            } else {
              $scope.new_accidente.total_deducible = 0;
            }
            var total_final_pre = 0;
            total_final_pre =
              $scope.new_accidente.total_procedente -
              $scope.new_accidente.total_coaseguro -
              $scope.new_accidente.total_deducible;
            $scope.new_accidente.total_final =
              parseFloat(total_final_pre).toFixed(2);
            // }
            if (vm.hospital.val) {
              $scope.new_accidente.hospital = vm.hospital.val;
            }

            //Post a la tabla de accidentes

            dataFactory
              .post("accidentes-create/", $scope.new_accidente)
              .then(function success(responseAccidente) {
                if (
                  responseAccidente.status == 201 ||
                  responseAccidente.status == 200
                ) {
                  SweetAlert.swal(
                    "Hecho",
                    "Se ha añadido el siniestro",
                    "success"
                  );
                  //Agrega los contactos

                  vm.contactos.forEach(function (contact) {
                    contact.accidente = responseAccidente.data.url;
                    //console.log(contact);
                    contactService.createContact(contact);
                  });

                  var aux_padecimiento;
                  if (vm.selected_disease.value) {
                    aux_padecimiento = vm.selected_disease.value.label;
                  } else {
                    aux_padecimiento = vm.selected_disease.val;
                  }

                  var params = {
                    model: 5,
                    event: "POST",
                    associated_id: responseSiniestro.data.id,
                    identifier:
                      "creó un siniestro por " + aux_padecimiento + ".",
                  };

                  //console.log("params log", params)
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {
                      //console.log("response log", response)
                    });

                  if (vm.myInsurance) {
                    if (vm.myInsurance.document_type == 1) {
                      var params = {
                        model: 1,
                        event: "POST",
                        associated_id: vm.selected_affect.value.id,
                        identifier: "creó un siniestro.",
                      };

                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                    } else {
                      var params = {
                        model: 18,
                        event: "POST",
                        associated_id: vm.selected_affect.value.id,
                        identifier: "creó un siniestro.",
                      };

                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                    }
                  }

                  //ENVIAR CORREO DESPUES DE CREAR SINIESTRO
                  var model;
                  if (responseSiniestro.data.status == 2) {
                    model = 11;
                  } else if (responseSiniestro.data.status == 3) {
                    model = 4;
                  } else if (responseSiniestro.data.status == 4) {
                    model = 12;
                  } else if (responseSiniestro.data.status == 5) {
                    model = 13;
                  } else if (responseSiniestro.data.status == 6) {
                    model = 14;
                  }
                  // if(vm.selectedPoliza.data.contractor){
                  //     $http.get(vm.selectedPoliza.data.contractor)
                  //     .then(function(response) {
                  //         if(response.data.email){
                  //             console.log($localStorage)
                  //             if($localStorage.email_config){
                  //                 if($localStorage.email_config.tramite_siniestro == true){
                  //                     emailService.sendEmailAtm(model,responseSiniestro.data.id)
                  //                 }
                  //             }
                  //         }
                  //     });
                  // }

                  vm.form = {};
                  $scope.new_siniestro = {};
                  $scope.new_accidente = {};
                  $scope.siniestros = false;
                  $scope.accidentes = false;
                  $state.go("siniestros.info", {
                    siniestroId: responseSiniestro.data.id,
                  });
                } else {
                  console.log("error en factura");
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al guardar siniestro",
                    "error"
                  );
                  $http.delete(responseSiniestro.data.url);
                }
              });

            //Por cada factura se agrega un nuevo registro
            vm.facturas.forEach(function (factura, index) {
              if (!factura.import) {
                factura.import = 0.0;
              }
              if (!factura.iva) {
                factura.iva = 0.0;
              }
              if (!factura.total) {
                factura.total = 0.0;
              }
              if (!factura.procedente) {
                factura.procedente = 0.0;
              }

              //Formato para la fecha de la factura

              var fecha_factura_formato = toDate(vm.facturas[index].f_date);

              //Objeto con todos los datos de la factura
              var new_factura = {
                siniestro: responseSiniestro.data.url, //Id del siniestro
                numero_factura: vm.facturas[index].f_number, //Numero de factura
                proveedor: vm.facturas[index].proovedor, //Proveedor
                fecha_factura: fecha_factura_formato, //fecha de factura con el formato
                importe: vm.facturas[index].import, //importe
                iva: vm.facturas[index].iva, //iva
                total: parseFloat(vm.facturas[index].total).toFixed(2), //total
                serie: vm.facturas[index].serie, //numero de serie
                procedente: vm.facturas[index].procedente, //procedente
                concepto: vm.facturas[index].concepto, //concepto
              };
              //post a la tabla de facturas
              dataFactory
                .post("facturas-create/", new_factura)
                .then(function success(responseFactura) {
                  if (
                    responseFactura.status == 201 ||
                    responseFactura.status == 200
                  ) {
                    SweetAlert.swal(
                      "Hecho",
                      "Se ha añadido el siniestro",
                      "success"
                    );
                    vm.form = {};
                    $scope.existenFacturas = true;
                    $scope.new_siniestro = {};
                    $scope.new_accidente = {};
                    $scope.siniestros = false;
                    $scope.accidentes = false;
                    vm.facturas = [];
                    $state.go("siniestros.info", {
                      siniestroId: responseSiniestro.data.id,
                    });
                  } else {
                    console.log("error en factura");
                    SweetAlert.swal(
                      "Error",
                      "Ha ocurrido un error al guardar siniestro",
                      "error"
                    );
                    $http.delete(responseSiniestro.data.url);
                  }
                });
            });
          } else {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al guardar siniestro",
              "error"
            );
          }
        });
    };

    function updateStatus(cadena) {
      vm.affected_poliza = [];
      vm.affected = [];
      $scope.autocompleteDataCertificate = [];
      vm.word_certificate = "";
      var word_data = cadena.val ? cadena && cadena.val : cadena;
      if (word_data) {
        if (word_data.length >= 3) {
          var word = word_data.split(" ").join("_");
          if ($scope.val) {
            var word = $scope.val;
            var word = word.split(" ").join("_");
          }
          insuranceService
            .getInsurances_siniester(2, word)
            .then(function (polizas) {
              polizas.forEach(function (poliza) {
                if (poliza.parent) {
                  if (poliza.parent.parent) {
                    if (poliza.parent.parent.parent) {
                      if (poliza.parent.parent.parent.contractor) {
                        poliza.contractor =
                          poliza.parent.parent.parent.contractor;
                      }
                    }
                  }
                }
                if (poliza.document_type == 1) {
                  var obj = {
                    label:
                      "Póliza: " +
                      poliza.poliza_number +
                      " - Vigencia: " +
                      convertDate(new Date(poliza.start_of_validity)) +
                      " - " +
                      convertDate(new Date(poliza.end_of_validity)),
                    value: {
                      id: poliza.id,
                      num_poliza: poliza.poliza_number,
                    },
                  };
                  function findCoincidences(argument) {
                    return argument.value.id === obj.value.id;
                  }

                  if (!vm.affected_poliza.find(findCoincidences)) {
                    vm.affected_poliza.push(obj);
                  }
                } else if (poliza.document_type == 3) {
                  var obj = {
                    label:
                      "Carátula: " +
                      poliza.poliza_number +
                      " - Vigencia: " +
                      convertDate(new Date(poliza.start_of_validity)) +
                      " - " +
                      convertDate(new Date(poliza.end_of_validity)),
                    value: {
                      id: poliza.id,
                      num_poliza: poliza.poliza_number,
                    },
                  };
                  function findCoincidences(argument) {
                    return argument.value.id === obj.value.id;
                  }

                  if (!vm.affected_poliza.find(findCoincidences)) {
                    vm.affected_poliza.push(obj);
                  }
                }
              });
            });
        }
      } else {
        vm.affected.length = 0;
      }
      saveLocalstorange();
    }
    function selected_affect_fucntion(polizaok) {
      console.log("eeeeeeee", polizaok);
    }
    vm.getCertificate = getCertificate;
    function getCertificate(parId) {
      console.log("vm.selected_affect", vm.selected_affect);
      if (vm.form.poliza && vm.form.poliza.value) {
        vm.form.poliza = vm.selected_affect;
      }
      $scope.autocompleteDataCertificate = [];
      if (parId) {
        if (parId.val.length >= 3) {
          $http({
            method: "POST",
            url: url.IP + "get-certificatesforsiniestro/",
            data: {
              word: parId.val,
              id_collect: vm.form.poliza.value.id,
              mode: $scope.endorsement_type_manual,
            },
          })
            .then(
              function success(request) {
                //console.log(request);
                var results_cert = [];
                var mapeo_cert = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    // $scope.btnSearchDisabled = true;
                    toaster.warning("Certificado no encontrado");
                  } else {
                    // $scope.btnSearchDisabled = false;
                    toaster.success("Certificado existente");
                    request.data.forEach(function (poliza) {
                      vm.certificado_for_siniestro = poliza;
                      // vm.form.num_receipts = vm.form.num_receipts;
                      if (poliza.document_type == 6) {
                        mapeo_cert.push(poliza);
                      }
                    });
                    results_cert = _.map(mapeo_cert, function (item) {
                      if (item.contractor) {
                        var label = item.contractor ? item.contractor : "";
                        label =
                          "Certificado: " +
                          item.certificate_number +
                          " - Titular: " +
                          item.accidents_policy[0].personal.first_name +
                          " " +
                          item.accidents_policy[0].personal.last_name;
                      } else {
                        var label = item.contractor ? item.contractor : "";
                        label =
                          "Certificado: " +
                          item.certificate_number +
                          " - Titular: " +
                          item.accidents_policy[0].personal.first_name +
                          " " +
                          item.accidents_policy[0].personal.last_name;
                      }
                      return {
                        label: label ? label : "",
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                        url: item.url,
                        contacto: item.contacto,
                        certificate_number: item.certificate_number,
                      };
                    });
                    $scope.autocompleteDataCertificate = results_cert;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    }

    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      // var date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
      // return date;
      var date = inputFormat;
      if (inputFormat.length != 10) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }
      }
      return date;
    }

    //Funcion para la seleccion de iniciales o complementos
    function CheckRadio(obj) {
      //console.log("obj",obj)
      //Si se elige la opcion de inicial
      if (obj == "Inicial") {
        $("#btn-complemento").removeClass("btn-iniComp");
        $("#btn-inicial").addClass("btn-iniComp");
        vm.isInicial = true; //inicial verdadero
        //console.log(vm.isInicial)
        $scope.new_siniestro.numero_siniestro = "SIN ASIGNAR";
        if ($localStorage["save_created_siniester_accident"]) {
          if (
            $localStorage["save_created_siniester_accident"]["numero_siniestro"]
          ) {
            $scope.new_siniestro.numero_siniestro = $localStorage[
              "save_created_siniester_accident"
            ]
              ? $localStorage["save_created_siniester_accident"][
                  "numero_siniestro"
                ]
              : "";
          }
        }
      } else {
        $("#btn-inicial").removeClass("btn-iniComp");
        $("#btn-complemento").addClass("btn-iniComp");

        vm.siniester_data.siniestros_by_number = [];
        vm.isInicial = false; //inicial falso (complemento)
        //console.log("inicial",vm.isInicial)

        //console.log("vm.selected_affect.value.id",vm.selected_affect)

        try {
          var id_poliza = vm.selected_affect.value.id;
          var afectado_id = vm.selected_affect.value.id_afectado;
          var relationship = vm.selected_affect.value.relationship;
          var document_type = vm.selected_affect.value.document_type;

          $scope.params_afectado = {
            id_poliza: id_poliza,
            afectado_id: afectado_id,
            relationship: relationship,
            document_type: document_type,
            tipo_siniestro: 2,
          };

          //console.log("$scope.params_afectado",$scope.params_afectado)
          dataFactory
            .get("SelectForComplementos/", $scope.params_afectado) //ruta del back
            .then(function success(response) {
              //console.log("results",response.data)
              var sin = response.data.results;
              sin.forEach(function (siniestro) {
                $http
                  .get(url.IP + "accidentes/get_specific/" + siniestro.id)
                  .then(function (accidente) {
                    accidente.data.forEach(function (accident) {
                      //crea un objeto que guarda los datos del siniestro y el accidente
                      var obj_returned_siniestro = {
                        label: siniestro.numero_siniestro,
                        value: {
                          siniestro: siniestro,
                          accidente: accident,
                        },
                      };
                      vm.siniester_data.siniestros_by_number.push(
                        obj_returned_siniestro
                      );
                      console.log("returned", vm.siniester_data);
                    });
                  });
              });
            });
        } catch (err) {
          console.log("entra a catch", err);
        }
        function SiniesterNotFound(error) {
          console.log("es error");
          CheckRadio("Inicial");
          $("#btn-complemento").removeClass("btn-iniComp");
          SweetAlert.swal(
            "Complemento",
            "No existen siniestros anteriores registrados para esta póliza",
            "error"
          );
          return;
        }
      }
    }

    function Iniciales_Complemento() {
      //vm.selected_affect.value.id
      var afectado_titular = $scope.filters.since;
    }

    function BuscarIniciales(parWord) {
      //console.log("parWord",parWord)
      //console.log(' vm.selected_affect.value.id',parWord.label)
      //$scope.new_accidente.complemento_siniestro = parWord.label
      var ids = [];
      vm.siniester_data.siniestros_by_number.forEach(function (it) {
        if (it.value.siniestro.id) {
          ids.push(it.value.siniestro.id);
        }
      });
      $scope.sinietsros_data = 0;
      var word_data = vm.siniester_data.siniester_number.val;
      //vm.selected_disease.value = parWord.value.accidente.ailment;
      //console.log("ailment",vm.selected_disease.value)

      if (parWord.value.accidente.ailment) {
        var obj2 = {
          label: parWord.value.accidente.ailment,
          val: parWord.value.accidente.ailment,
          value: {
            label: parWord.value.accidente.ailment,
          },
        };
        vm.selected_disease = obj2;
      }

      // if(word_data) {
      //   if(word_data.length) {

      //     $http.post(url.IP + 'siniestros-match/',
      //       {
      //         'matchWord': parWord.val,
      //         'id': ids
      //       })
      //     .then(function(response) {
      //       if(response.status === 200 && (response.data.numero || response.data.accidente)) {

      //         var source = [];
      //         var accidente = response.data.accidente;
      //         var numero = response.data.numero;

      //         if(accidente.length) {
      //           accidente.forEach(function(item) {
      //             var obj = {
      //               label: item.ailment,
      //               value: item
      //             };
      //             source.push(obj);
      //               vm.siniester_data.siniestros_by_number.forEach(function(it){
      //                   if (it.value.siniestro.url == item.siniestro) {
      //                       if (obj.value.siniestro == it.value.siniestro.url) {
      //                           obj.value.siniestro_data = it.value.siniestro
      //                           obj.label = obj.value.siniestro_data.numero_siniestro +' - ' +  obj.label
      //                       }
      //                   }
      //               })
      //           });
      //         } else if(numero.length) {
      //           numero.forEach(function(item) {
      //             if(item.numero_siniestro) {
      //               var obj = {
      //                 label: item.numero_siniestro,
      //                 value: item
      //               };
      //             } else {
      //              var obj = {
      //                 label: item,
      //                 value: item
      //               };
      //             }

      //           source.push(obj)
      //           vm.siniester_data.siniestros_by_number.forEach(function(it){
      //               if (it.value.siniestro.id == item.id) {
      //                   if (obj.value.id == it.value.siniestro.id) {
      //                       obj.value.accidente = it.value.siniestro.accidente_sinister
      //                       obj.label = obj.label + ' - ' + obj.value.accidente[0].ailment
      //                   }
      //               }
      //           })
      //         });
      //         }

      //         $scope.siniestros_data = source;
      //         console.log("siniestros_data",$scope.siniestros_data)

      //       }
      //     });
      //   }
      // } else {
      //   $scope.siniestros_data = [];

      // }
    }

    //Funcion para la lista de padecimientos
    function buscaPadecimientos(parPadecimiento) {
      var padeString = parPadecimiento.val;
      if (padeString.length >= 3) {
        SiniestroService.getPadecimientos(padeString)
          .then(function (data) {
            if (data.length) {
              $scope.enfermedades = [];
              vm.enfermedades = [];

              data.forEach(function (padecimientos) {
                vm.enfermedades.push({
                  label: padecimientos.descr,
                  value: {
                    id: padecimientos.id,
                    isSelectedFromMenu: true,
                    label: padecimientos.descr,
                    code: padecimientos.code,
                    url: padecimientos.url,
                  },
                });
                $scope.enfermedades = vm.enfermedades;
                vm.buscarEnfermedad = false;
              });
            }
          })
          .catch(function (err) {});
      }

      if (padeString.length <= 3 && !vm.buscarEnfermedad) {
        vm.enfermedades = [];
        vm.buscarEnfermedad = true;
      }

      saveLocalstorange();
    }

    function updateHospital(item) {
      vm.hospitals = [];
      var padeString = item.val;
      if (padeString.length >= 3) {
        var padeString_ = padeString.split(" ").join("_");
        $http
          .get(url.IP + "hospitales-by-substring/" + padeString_)
          .then(function (data) {
            if (data.data.length) {
              vm.hospitals = [];

              data.data.forEach(function (hosp) {
                vm.hospitals.push({
                  label: hosp.descr,
                  value: { id: hosp.id, url: hosp.url },
                });
                vm.buscarEnfermedad = false;
              });
            }
          })
          .catch(function (err) {});
      }

      if (padeString.length <= 3 && !vm.buscarEnfermedad) {
        vm.hospitals = [];
        vm.buscarEnfermedad = true;
      }
    }

    //Funcion para agregar registros a la tabla de facturas
    function addFactura() {
      var factura = {
        f_number: "",
        concepto: "",
        proovedor: "",
        f_date: "",
        import: "",
        iva: "",
        total: "",
        procedente: 0,
      };
      vm.facturas.push(factura);
    }

    function clearFacturas() {
      vm.facturas = [];
      vm.totalImporte = 0;
      vm.totalIva = 0;
      vm.totalTotal = 0;
      vm.totalProcedente = 0;
      $scope.calculateTotales();
      vm.saveLocalstorange();
    }

    //Funcion para descargar las facturas en excel
    function downloadFacturas(siniestro) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "data:application/vnd.ms-excel;charset=UTF-8",
        }
      );
      saveAs(blob, "Concentrado_Facturas" + ".xls");
    }

    function downloadPlantillaFacturas() {
      try {
        var sample = [
          facturasExcelHeaders,
          [
            "1",
            "122",
            "Medicamentos",
            "Proveedor Ejemplo",
            "06/02/2026",
            "100",
            "16",
            "116",
            "0",
          ],
        ];
        var sheet = XLSX.utils.aoa_to_sheet(sample);
        var workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, sheet, "facturas");
        var wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "plantilla_facturas_siniestros.xlsx"
        );
      } catch (err) {
        SweetAlert.swal(
          "Error",
          "No se pudo generar la plantilla: " + (err.message || err),
          "error"
        );
      }
    }

    function handleFacturasExcelFile(input) {
      if (!input || !input.files || !input.files.length) {
        return;
      }
      vm.importFacturasFromExcel(input.files[0]);
      input.value = "";
    }

    var conceptoCanonical = {
      medicamentos: "Medicamentos",
      honorariosmedicos: "Honorarios Médicos",
      hospitalizacion: "Hospitalización",
      hospitalisacion: "Hospitalización",
      hospitalizasion: "Hospitalización",
      hospitalizazion: "Hospitalización",
      estudios: "Estudios",
      protesis: "Prótesis",
      ambulancia: "Ambulancia",
      otros: "Otros",
    };

    function guessConceptFromClean(clean) {
      if (!clean) {
        return "";
      }
      var shifted = clean.replace(/[ckz]/g, "s").replace(/q/g, "s");
      if (
        shifted.indexOf("medic") >= 0 ||
        shifted.indexOf("farmacos") >= 0 ||
        shifted.indexOf("farmacias") >= 0
      ) {
        return "Medicamentos";
      }
      if (
        shifted.indexOf("honorari") >= 0 ||
        shifted.indexOf("onor") >= 0 ||
        shifted.indexOf("medico") >= 0 ||
        shifted.indexOf("doctor") >= 0
      ) {
        return "Honorarios Médicos";
      }
      if (shifted.indexOf("hospital") >= 0 || shifted.indexOf("ospital") >= 0) {
        return "Hospitalización";
      }
      if (
        shifted.indexOf("estudi") >= 0 ||
        shifted.indexOf("labora") >= 0 ||
        shifted.indexOf("analiz") >= 0
      ) {
        return "Estudios";
      }
      if (
        shifted.indexOf("protes") >= 0 ||
        shifted.indexOf("protesi") >= 0 ||
        shifted.indexOf("protesz") >= 0
      ) {
        return "Prótesis";
      }
      if (shifted.indexOf("ambul") >= 0) {
        return "Ambulancia";
      }
      if (shifted.indexOf("otro") >= 0 || shifted.indexOf("demas") >= 0) {
        return "Otros";
      }
      return "";
    }

    function registerUnknownConcept(raw, list) {
      if (!raw) {
        return;
      }
      var clean = raw
        .toString()
        .replace(/\u00A0/g, " ")
        .trim();
      if (!clean) {
        return;
      }
      if (list.indexOf(clean) === -1) {
        list.push(clean);
      }
    }

    function isPlaceholderFactura(factura) {
      if (!factura) {
        return false;
      }
      var hasNumber = factura.f_number && factura.f_number.toString().trim();
      var hasConcept = factura.concepto && factura.concepto.toString().trim();
      var hasProvider =
        factura.proovedor && factura.proovedor.toString().trim();
      var hasImport =
        factura.import !== "" &&
        factura.import !== undefined &&
        factura.import !== null;
      var hasTotal =
        factura.total !== "" &&
        factura.total !== undefined &&
        factura.total !== null;
      var hasDate = factura.f_date && factura.f_date.toString().trim();
      return (
        !hasNumber &&
        !hasConcept &&
        !hasProvider &&
        !hasImport &&
        !hasTotal &&
        !hasDate
      );
    }

    function normalizeConceptoRaw(value) {
      if (!value && value !== 0) {
        return "";
      }
      var clean = value
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "")
        .replace(/[^a-zA-Z]/g, "")
        .toLowerCase();
      return conceptoCanonical[clean] || guessConceptFromClean(clean);
    }

    function formatDateForUI(date) {
      var d = date.getDate();
      var m = date.getMonth() + 1;
      var y = date.getFullYear();
      return (d < 10 ? "0" + d : d) + "/" + (m < 10 ? "0" + m : m) + "/" + y;
    }

    function parseFechaUsuario(value) {
      if (value instanceof Date && !isNaN(value)) {
        return formatDateForUI(value);
      }
      if (!value && value !== 0) {
        return "";
      }
      var str = value.toString().trim();
      if (!str) {
        return "";
      }
      var isoMatch = str.match(/^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})$/);
      if (isoMatch) {
        var year = parseInt(isoMatch[1], 10);
        var month = parseInt(isoMatch[2], 10);
        var day = parseInt(isoMatch[3], 10);
        if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
          return formatDateForUI(new Date(year, month - 1, day));
        }
      }
      var match = str.match(/^(\d{1,4})[\/\-](\d{1,2})[\/\-](\d{1,4})$/);
      if (match) {
        var a = parseInt(match[1], 10);
        var b = parseInt(match[2], 10);
        var c = parseInt(match[3], 10);
        var month = match[1].length > 2 && a > 31 ? c : a;
        var day = b;
        var year = match[1].length > 2 && a > 31 ? a : c;
        if (year < 100) {
          year += 2000;
        }
        if (month > 12 && day <= 12) {
          var temp = day;
          day = month;
          month = temp;
        }

        if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
          return formatDateForUI(new Date(year, month - 1, day));
        }
      }
      var iso = new Date(str);
      if (!isNaN(iso)) {
        return formatDateForUI(iso);
      }

      return str;
    }

    // function importFacturasFromExcel(file) {
    //             if (!file) {
    //                 return;
    //             }
    //             console.log("TESTsssss ENTRO")

    //             var reader = new FileReader();
    //             console.log("TEST ENTRO")
    //             reader.onload = function(evt) {
    //                 try {
    //                     var data = new Uint8Array(evt.target.result);
    //                     var workbook = XLSX.read(data, { type: 'array' });
    //                     var sheetName = workbook.SheetNames[0];
    //                     if (!sheetName) throw new Error('No hay hojas en el archivo.');
    //                     var rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1, defval: '', cellDates: true });
    //                     if (!rows.length) throw new Error('No hay datos en el archivo.');
    //                     function findHeaderRowIndex(list) {
    //                         for (var i = 0; i < list.length; i++) {
    //                             var normalized = list[i].map(function(cell) {
    //                                 return normalizeColumnName(cell);
    //                             });
    //                             if (normalized.indexOf('serie') >= 0 && normalized.indexOf('nofactura') >= 0) {
    //                                 return i;
    //                             }
    //                         }
    //                         return 0;
    //                     }
    //                     var headerIndex = findHeaderRowIndex(rows);
    //                     var imported = [];

    //                     rows.slice(headerIndex + 1).forEach(function(row) {
    //                         if (!row || row.length === 0) return;
    //                         var factura = {};
    //                         columnOrder.forEach(function(key, idx) {
    //                             var value = row[idx];
    //                             if (key === 'f_date') {
    //                                 if (typeof value === 'number' && XLSX.SSF) {
    //                                     value = XLSX.SSF.format('dd/mm/yyyy', value);
    //                                 }
    //                                 value = parseFechaUsuario(value);
    //                             }
    //                             if (typeof value === 'string') {
    //                                 value = value.replace(/\u00A0/g, ' ').trim();
    //                             }
    //                             factura[key] = value;
    //                         });
    //                         if (!factura.f_number && !factura.proovedor && !factura.import && !factura.total) return;
    //                         if (!factura.serie) {
    //                             factura.serie = vm.facturas.length + imported.length + 1;
    //                         }
    //                         factura.import = parseFloat(factura.import) || 0;
    //                         factura.iva = parseFloat(factura.iva) || 0;
    //                         factura.total = parseFloat(factura.total);
    //                         if (isNaN(factura.total)) factura.total = factura.import + factura.iva;
    //                         factura.procedente = parseFloat(factura.procedente);
    //                         factura.procedente = isNaN(factura.procedente) ? 0 : factura.procedente;
    //                         var rawConcept = (factura.concepto || '').replace(/\u00A0/g, ' ').trim();
    //                         var normalizedConcept = normalizeConceptoRaw(rawConcept);
    //                         console.log("normalized",normalizedConcept)
    //                         if (!normalizedConcept || normalizedConcept.toLowerCase().indexOf('selecciona') === 0) {
    //                             registerUnknownConcept(rawConcept, unknownConcepts);
    //                             factura.concepto = 'Otros';
    //                         } else {
    //                             factura.concepto = normalizedConcept;
    //                         }
    //                         factura.proovedor = factura.proovedor || '';
    //                         imported.push(factura);
    //                     });
    //                     $scope.$applyAsync(function() {
    //                         if (!imported.length) {
    //                             SweetAlert.swal('Importación', 'No se encontraron filas válidas.', 'warning');
    //                             return;
    //                         }
    //                         Array.prototype.push.apply(vm.facturas, imported);
    //                         $scope.calculateTotales();
    //                         SweetAlert.swal('Importación', imported.length + ' facturas agregadas.', 'success');
    //                         if (unknownConcepts.length) {
    //                             SweetAlert.swal('Conceptos no detectados', 'No se reconocieron los siguientes: ' + unknownConcepts.join(', '), 'warning');
    //                         }
    //                     });
    //                 } catch (err) {
    //                     console.error('Error importando facturas', err);
    //                     $scope.$applyAsync(function() {
    //                         SweetAlert.swal('Error', 'No se pudo leer el archivo: ' + (err.message || err), 'error');
    //                     });
    //                 }
    //             };
    //             reader.readAsArrayBuffer(file);
    //         }

    function normalizeColumnName(value) {
      if (!value && value !== 0) return "";
      return value.toString().trim().toLowerCase().replace(/[.\s]/g, "");
    }

    function downloadPlantillaFacturas() {
      try {
        var sample = [
          facturasExcelHeaders,
          [
            "1",
            "122",
            "Medicamentos",
            "Proveedor Ejemplo",
            "06/02/2026",
            "100",
            "16",
            "116",
            "100",
          ],
        ];
        var sheet = XLSX.utils.aoa_to_sheet(sample);
        var workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, sheet, "facturas");
        var wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "plantilla_facturas_siniestros.xlsx"
        );
      } catch (err) {
        SweetAlert.swal(
          "Error",
          "No se pudo generar la plantilla correcta: " + (err.message || err),
          "error"
        );
      }
    }

    function handleFacturasExcelFile(input) {
      if (!input || !input.files || input.files.length === 0) {
        return;
      }
      vm.importFacturasFromExcel(input.files[0]);
      input.value = "";
    }

    function importFacturasFromExcel(file) {
      if (!file) {
        return;
      }
      var reader = new FileReader();
      reader.onload = function (evt) {
        try {
          var data = new Uint8Array(evt.target.result);
          var workbook = XLSX.read(data, { type: "array" });
          var sheetName = workbook.SheetNames[0];
          if (!sheetName) {
            throw new Error("El archivo no contiene hojas.");
          }
          var rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
            header: 1,
            defval: "",
            cellDates: true,
          });
          if (!rows.length) {
            throw new Error("No hay datos en el archivo.");
          }
          function findHeaderRowIndex(list) {
            for (var i = 0; i < list.length; i++) {
              var normalized = list[i].map(function (cell) {
                return normalizeColumnName(cell);
              });
              if (
                normalized.indexOf("serie") >= 0 &&
                normalized.indexOf("nofactura") >= 0
              ) {
                return i;
              }
            }
            return 0;
          }
          var headerIndex = findHeaderRowIndex(rows);
          var headerRow = rows[headerIndex];

          var imported = [];
          var unknownConcepts = [];
          var missingInfo = [];
          var hasSinglePlaceholder =
            vm.facturas.length === 1 && isPlaceholderFactura(vm.facturas[0]);
          if (hasSinglePlaceholder) {
            vm.facturas.splice(0, 1);
          }
          rows.slice(headerIndex + 1).forEach(function (row, rowIndex) {
            if (!row || row.length === 0) {
              return;
            }
            var factura = {};
            headerRow.forEach(function (column, columnIndex) {
              var column2 = "";
              if (column.trim() == "Serie") {
                column2 = "serie";
              } else if (column.trim() == "No. Factura") {
                column2 = "nofactura";
              } else if (
                column.trim() ==
                "Concepto ( Medicamentos, Honorarios Médicos, Hospitalización, Estudios, Prótesis, Ambulancia, Otros)"
              ) {
                column2 = "concepto";
              } else if (column.trim() == "Fecha de factura") {
                column2 = "fechadefactura";
              } else if (column.trim() == "Proveedor") {
                column2 = "proveedor";
              } else {
                column2 = normalizeColumnName(column);
              }
              var key = facturasExcelColumnMap[column2];

              if (!key) {
                return;
              }
              var value = row[columnIndex];
              if (key === "f_date") {
                value = parseFechaUsuario(value);
              }
              if (typeof value === "string") {
                value = value.replace(/\u00A0/g, " ").trim();
              }
              factura[key] = value;
            });
            if (
              !factura.f_number &&
              !factura.proovedor &&
              !factura.import &&
              !factura.total
            ) {
              return;
            }

            if (!factura.serie) {
              factura.serie = vm.facturas.length + imported.length + 1;
            }
            factura.import = parseFloat(factura.import) || 0;
            factura.iva = parseFloat(factura.iva) || 0;
            factura.total = parseFloat(factura.total);
            if (isNaN(factura.total)) {
              factura.total = factura.import + factura.iva;
            }
            factura.procedente = parseFloat(factura.procedente);
            factura.procedente = isNaN(factura.procedente)
              ? 0
              : factura.procedente;
            var rawConcept = (factura.concepto || "")
              .replace(/\u00A0/g, " ")
              .trim();
            var normalizedConcept = normalizeConceptoRaw(rawConcept);
            console.log("normalizedConcept", normalizedConcept);

            if (
              !normalizedConcept ||
              normalizedConcept.toLowerCase().indexOf("selecciona") === 0
            ) {
              registerUnknownConcept(rawConcept, unknownConcepts);
              console.log("rawConcept", rawConcept);
              console.log("unknownConcepts", unknownConcepts);

              factura.concepto = "Otros";
            } else {
              factura.concepto = normalizedConcept;
            }
            factura.proovedor = factura.proovedor || "";
            var requiresValidation = !!(factura.f_number || factura.concepto);
            if (requiresValidation) {
              var missingFields = [];
              if (!factura.f_date) {
                missingFields.push("fecha");
              }
              if (!factura.import && factura.import !== 0) {
                missingFields.push("importe");
              }
              if (!factura.proovedor) {
                missingFields.push("proveedor");
              }
              if (missingFields.length) {
                var label = factura.f_number
                  ? "Factura " + factura.f_number
                  : factura.concepto
                  ? "Concepto " + factura.concepto
                  : "Fila " + (headerIndex + rowIndex + 2);
                missingInfo.push(
                  label + " requiere " + missingFields.join(", ")
                );
                return;
              }
            }
            imported.push(factura);
          });
          $scope.$applyAsync(function () {
            if (!imported.length) {
              SweetAlert.swal(
                "Importación",
                "No se encontraron filas válidas en el archivo.",
                "warning"
              );
              return;
            }
            Array.prototype.push.apply(vm.facturas, imported);
            $scope.calculateTotales();
            SweetAlert.swal(
              "Importación",
              "Se agregaron " + imported.length + " facturas desde el Excel.",
              "success"
            );
            if (unknownConcepts.length) {
              $scope.unknownConceptsAlert = unknownConcepts.slice();
            } else {
              $scope.unknownConceptsAlert = [];
            }
            if (unknownConcepts.length) {
              $scope.unknownConceptsAlert = unknownConcepts.slice();
            } else {
              $scope.unknownConceptsAlert = [];
            }
            if (missingInfo.length) {
              SweetAlert.swal(
                "Datos incompletos",
                "No se importaron las siguientes filas porque faltan campos: " +
                  missingInfo.join("; "),
                "warning"
              );
            }
          });
        } catch (err) {
          console.error("Error importando facturas", err);
          $scope.$applyAsync(function () {
            SweetAlert.swal(
              "Error",
              "No se pudo leer el archivo: " + (err.message || err),
              "error"
            );
          });
        }
      };
      reader.readAsArrayBuffer(file);
    }

    function normalizeColumnName(value) {
      if (!value && value !== 0) {
        return "";
      }
      return value
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[.\\s]/g, "");
    }

    //Funciones para hacer el calculo de las facuras
    $scope.calculateIva = function (index, item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.facturas[index].import = 0;
        } else {
          vm.facturas[index].import = parseFloat(
            vm.facturas[index].import
          ).toFixed(2);
        }
        vm.facturas[index].import = parseFloat(vm.facturas[index].import);
        vm.facturas[index].iva = (
          parseFloat(vm.facturas[index].import) * 0.16
        ).toFixed(2);
        vm.facturas[index].iva = parseFloat(vm.facturas[index].iva);
        vm.facturas[index].total = (
          parseFloat(vm.facturas[index].import) +
          parseFloat(vm.facturas[index].iva)
        ).toFixed(2);
        vm.facturas[index].total = parseFloat(vm.facturas[index].total);
        $scope.calculateTotales();
      } else {
        vm.facturas[index].import = 0;
        vm.facturas[index].iva = 0;
        vm.facturas[index].total = 0;
      }
    };

    $scope.calculateTotales = function () {
      vm.totalImporte = 0.0;
      vm.totalIva = 0.0;
      vm.totalTotal = 0.0;
      vm.totalProcedente = 0.0;
      for (var i = 0; i < vm.facturas.length; i++) {
        vm.totalImporte = vm.totalImporte + parseFloat(vm.facturas[i].import);
        vm.totalIva = vm.totalIva + vm.facturas[i].iva;
        vm.totalTotal = vm.totalTotal + parseFloat(vm.facturas[i].total);
        vm.totalProcedente =
          vm.totalProcedente + parseFloat(vm.facturas[i].procedente);
        vm.facturas[i].total = parseFloat(
          vm.facturas[i].import + vm.facturas[i].iva
        );
      }

      if (vm.totalProcedente) {
        vm.totalProcedente = vm.totalProcedente.toFixed(2);
      }
      $scope.new_accidente.total_reclamado = vm.totalTotal.toFixed(2);
      $scope.new_accidente.total_procedente = vm.totalProcedente;
    };

    $scope.calculateTotal = function (index, iva) {
      if (iva) {
        vm.facturas[index].iva = parseFloat(iva);
      } else if (iva == "") {
        vm.facturas[index].iva = 0;
      }
      vm.facturas[index].total = parseFloat(
        vm.facturas[index].import + vm.facturas[index].iva
      );
      vm.facturas[index].total = parseFloat(vm.facturas[index].total).toFixed(
        2
      );
      $scope.calculateTotales();
    };
    $scope.validateProcedente = function (index, item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.facturas[index].procedente = 0;
        } else {
          vm.facturas[index].procedente = parseFloat(
            vm.facturas[index].procedente
          ).toFixed(2);
          vm.facturas[index].procedente = parseFloat(
            vm.facturas[index].procedente
          );
          $scope.calculateTotales();
        }
      } else {
        vm.facturas[index].procedente = 0;
      }
    };
    //eliminar factura de la lista
    function deleteFactura(url, index) {
      if ((url && index) || (url && !index)) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "El registro se borrara permanentemente aunque no se hayan guardado los cambios.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, eliminar",
            cancelButtonText: "No",
            closeOnConfirm: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http.delete(url).then(function (response) {
                vm.facturas.splice(index, 1);
                SweetAlert.swal(
                  "¡Eliminada!",
                  "Tu factura ha sido eliminada.",
                  "success"
                );
              });
            }
          }
        );
      } else {
        vm.facturas.splice(index, 1);
      }
    }

    //Funcion para la busqueda de afectados por número de poliza
    function BuscarPolizas(polizaa) {
      //Se ingresa el numero de poliza
      // $scope.params = {
      //     num_poliza: vm.form.poliza && vm.form.poliza.value ? vm.form.poliza.value.num_poliza : vm.form.poliza ? vm.form.poliza : '',
      //     id_policy: vm.id_policy
      // }
      vm.affected = [];
      if (
        $localStorage["save_created_siniester_accident"] &&
        $localStorage["save_created_siniester_accident"]["selected_affect"] &&
        polizaa
      ) {
        if (
          $localStorage["save_created_siniester_accident"]["selected_affect"] &&
          $localStorage["save_created_siniester_accident"]["selected_affect"][
            "value"
          ] &&
          polizaa
        ) {
          if (
            $localStorage["save_created_siniester_accident"]["selected_affect"][
              "value"
            ] &&
            $localStorage["save_created_siniester_accident"]["selected_affect"][
              "value"
            ]["id"]
          ) {
            if (polizaa.value) {
              if (
                $localStorage["save_created_siniester_accident"][
                  "selected_affect"
                ]["value"]["id"] != polizaa.value.id
              ) {
                $localStorage["save_created_siniester_accident"][
                  "selected_affect"
                ] = vm.selected_affect;
                // vm.affected = polizaa
              }
            } else {
              $localStorage["save_created_siniester_accident"][
                "selected_affect"
              ] = vm.selected_affect;
            }
          }
        }
      }
      //Se ingresa el numero de poliza
      var polizaVal = polizaa;
      $scope.params = {
        num_poliza:
          vm.form.poliza && vm.form.poliza.value
            ? vm.form.poliza.value.num_poliza
            : vm.form.poliza
            ? vm.form.poliza
            : "",
        id_policy:
          vm.form.poliza && vm.form.poliza.value
            ? vm.form.poliza.value.id
            : vm.id_policy
            ? vm.id_policy
            : "",
      };
      dataFactory
        .get("buscar_afectado/", $scope.params) //ruta del back
        .then(
          function success(response) {
            //console.log("Busqueda",response)
            if (response.data.results != null) {
              //si el resultado de la consulta no es null
              //console.log("info",response.data.results)
              var resultado = response.data.results[0]; //guarda la informacion de la consulta
              //vm.selected_poliza = resultado.id
              if (
                resultado.document_type == 1 ||
                resultado.document_type == 6
              ) {
                //si el tipo de doc es poliza o certificado
                vm.show_caratula = false;
                vm.show_poliza = true;

                var titular =
                  response.data.results[0].accidents_policy[0].personal;
                var beneficiarios =
                  response.data.results[0].accidents_policy[0]
                    .relationship_accident;

                //Guarda los datos del titular
                var obj = {
                  label:
                    titular.first_name +
                    " " +
                    titular.last_name +
                    " " +
                    titular.second_last_name +
                    " - TITULAR ",
                  value: {
                    id: resultado.id,
                    id_afectado: titular.id,
                    document_type: resultado.document_type,
                    relationship: 1,
                    title: titles[1],
                    birthdate: titular.birthdate,
                    full_name:
                      titular.first_name +
                      " " +
                      titular.last_name +
                      " " +
                      titular.second_last_name,
                    url: titular.url,
                  },
                };
                vm.affected.push(obj);

                beneficiarios.forEach(function (element) {
                  //recorre los elementos dentro de los beneficiarios
                  //Guarda los datos de los beneficiarios
                  obj = {
                    label:
                      element.first_name +
                      " " +
                      element.last_name +
                      " " +
                      element.second_last_name +
                      " - DEPENDIENTE ",
                    value: {
                      id: resultado.id,
                      id_afectado: element.id,
                      document_type: resultado.document_type,
                      relationship: element.relationship,
                      title: titles[element.relationship],
                      birthdate: element.birthdate,
                      full_name:
                        element.first_name +
                        " " +
                        element.last_name +
                        " " +
                        element.second_last_name,
                      url: element.url,
                    },
                  };

                  vm.affected.push(obj);
                });
                if ($localStorage.save_created_siniester_accident) {
                  vm.selected_affect =
                    $localStorage["save_created_siniester_accident"][
                      "selected_affect"
                    ] && $localStorage["save_created_siniester_accident"]
                      ? $localStorage["save_created_siniester_accident"][
                          "selected_affect"
                        ]
                      : vm.selected_affect
                      ? vm.selected_affect
                      : {};
                  LlenarDatos();
                }
              } else if (resultado.document_type == 3) {
                vm.show_caratula = true;
                vm.show_poliza = false;
                vm.affected = [];
                vm.affected.length = 0;

                var obj = {
                  label: "",
                  value: {
                    id: resultado.id,
                    document_type: resultado.document_type,
                  },
                };
                vm.affected.push(obj);

                vm.selected_affect.value = vm.affected[0].value;
                if (!vm.carga_siniestro) {
                  LlenarDatos();
                }
              }

              vm.affect_data = {};
            } else {
              SweetAlert.swal(
                "Error",
                "El Número de Poliza no es valido",
                "error"
              );
            }
          },

          function error(err) {
            console.log(err);
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al guardar siniestro",
              "error"
            );
          }
        )
        .catch(function (e) {
          console.log(e);
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al guardar siniestro",
            "error"
          );
        });
    }

    //funcion para llenar los datos
    function LlenarDatos(afectado) {
      vm.checkRadio("Inicial"); //Siempre que se haga una busqueda el checkradio siempre iniciará como inicial
      try {
        if (vm.selected_affect) {
          vm.selected_affect = vm.selected_affect;
        } else {
          vm.selected_affect = afectado;
        }

        if (vm.selected_affect.value) {
          dataFactory
            .get("leer-polizas-edit/" + vm.selected_affect.value.id + "/") //ruta del back
            .then(function (poliza) {
              vm.selectedPoliza = poliza;
              if (poliza.data.document_type == 3) {
                vm.show_caratula = true;
              } else {
                vm.show_caratula = false;
              }
              //Funcion para poder obtener el subramo de la poliza
              ramoService
                .getSubramoById(poliza.data.subramo.id)
                .then(function (subramo) {
                  vm.siniester_data.subramo = subramo.data;
                });

              //En data se guarda la informacion para mostrarla en el for
              var data = {
                title: vm.selected_affect.value.title, //Parentesco
                policy_vigencia: new Date(poliza.data.end_of_validity), //fecha de vigencia
                policy_vigencia_init: new Date(poliza.data.start_of_validity), //fecha de vigencia
                siniester_date: new Date(), //Fecha de siniestro
                policy_number: poliza.data.poliza_number, //Numero de poliza
                birthdate: vm.selected_affect.value.birthdate,
              };
              //Obtener el estatus del pago
              var estaus_pago1 = [];
              estaus_pago1.push(
                $http.get(url.IP + "get-current-receipt/" + poliza.data.id)
              );
              $q.all(estaus_pago1).then(function (response) {
                var status = response[0].data.status;
                data.policy_status = {};
                //Los valores se guardan en data
                switch (status) {
                  case 1:
                    data.policy_status["label"] = "Pagado";
                    data.policy_status["id"] = status;
                    break;
                  case 2:
                    data.policy_status["label"] = "Cancelado";
                    data.policy_status["id"] = status;
                    break;
                  case 3:
                    data.policy_status["label"] = "Prorrogado";
                    data.policy_status["id"] = status;
                    break;
                  case 4:
                    data.policy_status["label"] = "Pendiente de pago";
                    data.policy_status["id"] = status;
                    break;
                  default:
                    data.policy_status["label"] = "Sin Estatus";
                    data.policy_status["id"] = status;
                }
              });
              if (poliza.data.contractor) {
                $http.get(poliza.data.contractor).then(function (contratante) {
                  //Obtiene la direccion del contratante
                  data["contractor_addres"] =
                    contratante.data.address_contractor[0].route +
                    " #" +
                    contratante.data.address_contractor[0].street_number +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_2 +
                    " " +
                    contratante.data.address_contractor[0]
                      .administrative_area_level_1;
                  //Informacion del contratante
                  data["contratante"] = contratante.data;
                  //Nombre del contratante
                  data["contratante"].name = contratante.data.full_name;
                });
              }
              //Obtener el nombre de la aseguradora
              if (poliza.data.aseguradora) {
                providerService
                  .getProviderById(poliza.data.aseguradora)
                  .then(function (aseguradora) {
                    data["aseguradora"] = aseguradora.data;
                  });
              }

              //Obtiene el paquete de su poliza
              if (poliza.data.document_type != 3) {
                packageService
                  .getPackageById(poliza.data.paquete.id)
                  .then(function (paquete) {
                    data["paquete"] = paquete.data;
                  });
              }
              vm.affect_data = data;
              $localStorage["save_created_siniester_accident"][
                "selected_affect"
              ] = vm.selected_affect ? vm.selected_affect : {};
              vm.affected.forEach(function (item) {
                if (item.value.url == vm.selected_affect.value.url) {
                  vm.selected_affect = item;
                }
              });
              // vm.selected_affect = $localStorage['save_created_siniester_accident']['selected_affect'] && $localStorage['save_created_siniester_accident'] ? $localStorage['save_created_siniester_accident']['selected_affect'] :vm.selected_affect ? vm.selected_affect : {};
              //Consulta los datos del contratante (certificados)
              if (poliza.data.document_type == 6) {
                vm.show_caratula = true;
                if (poliza.data.parent.parent.parent) {
                  if (poliza.data.parent.parent.parent.aseguradora) {
                    $http
                      .get(poliza.data.parent.parent.parent.url)
                      .then(function (pol) {
                        var url_prov = pol.data;
                        if (url_prov.aseguradora) {
                          $http
                            .get(url_prov.aseguradora)
                            .then(function (aseguradora) {
                              vm.selectedPoliza.data.aseguradora =
                                aseguradora.data.id;
                              data["aseguradora"] = aseguradora.data;
                            });
                        }
                      });
                  }
                }
                if (poliza.data.parent.parent.parent.contractor) {
                  var contratante = poliza.data.parent.parent.parent.contractor;
                  data["contractor_addres"] =
                    contratante.address_contractor[0].route +
                    " #" +
                    contratante.address_contractor[0].street_number +
                    " " +
                    contratante.address_contractor[0]
                      .administrative_area_level_2 +
                    " " +
                    contratante.address_contractor[0]
                      .administrative_area_level_1;
                  data["contratante"] = contratante;
                  data["contratante"].name = contratante.full_name;
                }
              }
            });
        }
      } catch (err) {
        //fin try
        console.log("erorrr", err);
        SweetAlert.swal("Error", "Selecciona un Afectado valido", "error");
      }
    }
    $scope.affectedCaratula = false;
    $scope.chooseCertificate = function (val) {
      $scope.params = {
        num_poliza: val.value ? val.value : 0,
        id_policy: val.id,
      };
      //console.log($scope.params)
      vm.affected_certificate = [];
      dataFactory
        .get("buscar_afectado/", $scope.params) //ruta del back
        .then(
          function success(response) {
            // console.log("Busqueda",response)
            if (response.data.results != null) {
              //si el resultado de la consulta no es null
              //console.log("info",response.data.results)
              var resultado = response.data.results[0]; //guarda la informacion de la consulta
              //vm.selected_poliza = resultado.id

              if (
                resultado.document_type == 1 ||
                resultado.document_type == 6
              ) {
                //si el tipo de doc es poliza o certificado
                $scope.affectedCaratula = true;

                var titular =
                  response.data.results[0].accidents_policy[0].personal;
                var beneficiarios =
                  response.data.results[0].accidents_policy[0]
                    .relationship_accident;

                //Guarda los datos del titular
                var obj = {
                  label:
                    titular.first_name +
                    " " +
                    titular.last_name +
                    " " +
                    titular.second_last_name +
                    " - TITULAR ",
                  value: {
                    id: resultado.id,
                    id_afectado: titular.id,
                    document_type: resultado.document_type,
                    relationship: 1,
                    title: titles[1],
                    birthdate: titular.birthdate,
                    full_name:
                      titular.first_name +
                      " " +
                      titular.last_name +
                      " " +
                      titular.second_last_name,
                    url: titular.url,
                  },
                };
                vm.affected_certificate.push(obj);

                beneficiarios.forEach(function (element) {
                  //recorre los elementos dentro de los beneficiarios
                  //Guarda los datos de los beneficiarios
                  obj = {
                    label:
                      element.first_name +
                      " " +
                      element.last_name +
                      " " +
                      element.second_last_name +
                      " - DEPENDIENTE ",
                    value: {
                      id: resultado.id,
                      id_afectado: element.id,
                      document_type: resultado.document_type,
                      relationship: element.relationship,
                      title: titles[element.relationship],
                      birthdate: element.birthdate,
                      full_name:
                        element.first_name +
                        " " +
                        element.last_name +
                        " " +
                        element.second_last_name,
                      url: element.url,
                    },
                  };

                  vm.affected_certificate.push(obj);
                });
              }

              vm.affect_data = {};
            } else {
              SweetAlert.swal(
                "Error",
                "El Número de Poliza no es valido",
                "error"
              );
            }
          },

          function error(err) {
            console.log(err);
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al guardar siniestro",
              "error"
            );
          }
        )
        .catch(function (e) {
          console.log(e);
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al guardar siniestro",
            "error"
          );
        });
    };
    //estados y ciudades
    function ciudades_estados() {
      vm.selected_state = $scope.new_siniestro.state;
      //console.log(vm.selected_state);
      vm.citiesArray = vm.selected_state.cities;
      //console.log(vm.citiesArray);

      //$scope.new_siniestro.state = vm.citiesArray.state;
      //$scope.new_siniestro.city = vm.citiesArray.city;
      //console.log($scope.new_siniestro.city)
      if ($localStorage["save_created_siniester_accident"]) {
        if ($localStorage["save_created_siniester_accident"]["city"]) {
          vm.citiesArray.forEach(function (item) {
            if (
              item.url ==
              $localStorage["save_created_siniester_accident"]["city"]
            ) {
              $scope.new_siniestro.city = item.url;
            }
          });
        }
      }
    }

    //agregar y eliminar contactos
    function addContact() {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
      };
      vm.contactos.push(contact);
    }

    //eliminar contacto
    function deleteContacts(contact) {
      vm.contactos.splice(contact);
    }

    function check_city_state() {
      vm.show_state_city = true;
    }

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function getFiles() {
      // return receiptService.getFiles(receiptService.getReceiptID())
      //     .then(function(data) {
      //         vm.files = data;
      //         return vm.files;
      //     });
    }

    function uploadFiles(siniestro_id) {
      $scope.userInfo = {
        id: siniestro_id,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "siniestros/" + siniestro_id + "/archivos/";
      // ////console.log( $scope.uploader);
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve($scope.uploader.uploadAll());
          return defer.promise;
        })
        .then(function () {
          toaster.success("Se han subido sus archivos correctamente");

          // setTimeout(function() {
          //     getFiles().then(function(res) {
          //         vm.files = res;
          //     });
          // }, 1000);
        });
    }

    //Cambiar el tipo de documento
    $scope.changeTypeDoc = function (padecimiento, index) {
      $scope.padecimiento_type = padecimiento;
      uploader.queue[index].formData[0].type_document = padecimiento;
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("SiniestrosAccidentesInfoCtrl", SiniestrosAccidentesInfoCtrl);

  SiniestrosAccidentesInfoCtrl.$inject = [
    "$parse",
    "$scope",
    "dataFactory",
    "SweetAlert",
    "datesFactory",
    "$sce",
    "$uibModal",
    "toaster",
    "$http",
    "url",
    "insuranceService",
    "ramoService",
    "$q",
    "providerService",
    "packageService",
    "SiniestroService",
    "facturas_conceptos",
    "$state",
    "$sessionStorage",
    "$stateParams",
    "$localStorage",
    "MESSAGES",
    "$rootScope",
    "helpers",
    "exportFactory",
    "emailService",
    "fileService",
    "FileUploader",
    "contactService",
    "appStates",
    "whatsappWebFlagService",
    "siniestroWhatsappService",
  ];

  function SiniestrosAccidentesInfoCtrl(
    $parse,
    $scope,
    dataFactory,
    SweetAlert,
    datesFactory,
    $sce,
    $uibModal,
    toaster,
    $http,
    url,
    insuranceService,
    ramoService,
    $q,
    providerService,
    packageService,
    SiniestroService,
    facturas_conceptos,
    $state,
    $sessionStorage,
    $stateParams,
    $localStorage,
    MESSAGES,
    $rootScope,
    helpers,
    exportFactory,
    emailService,
    fileService,
    FileUploader,
    contactService,
    appStates,
    whatsappWebFlagService,
    siniestroWhatsappService
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var token = JSON.parse(decryptedToken);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.user = usr;
    vm.infoSiniestro = [];
    vm.affect_data = {};
    vm.facturas = [];
    vm.facturas_conceptos = facturas_conceptos;
    vm.siniestro_id = $stateParams.siniestroId;
    vm.downloadFacturas = downloadFacturas;
    vm.getLog = getLog;
    vm.goToPolicy = goToPolicy;
    vm.getPDF = getPDF;
    vm.deleteSiniestro = deleteSiniestro;
    vm.fillTable = fillTable;
    vm.crear_complemento = crear_complemento;
    vm.siniestro_completado = false;
    vm.selected_state = [];
    vm.citiesArray = [];
    vm.statesArray = [];
    vm.ciudades_estados = ciudades_estados;
    vm.uploadFiles = uploadFiles;
    vm.files = [];
    $scope.deleteFile = deleteFile;
    $scope.fileSinister = true;
    $scope.observation_aux = "";
    vm.siniestro_inicial = null;
    vm.siniestro_complementos = null;
    vm.viewObservation = viewObservation;
    vm.getPDFiniquito = getPDFiniquito;
    vm.sendEmail = sendEmail;
    vm.sendWhatsAppWeb = openWhatsapp;
    vm.whatsappWebEnabled = whatsappWebFlagService.isEnabled();
    whatsappWebFlagService.subscribe(function (enabled) {
      vm.whatsappWebEnabled = enabled;
    });
    //Funciones de contactos
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;
    vm.goToSinister = goToSinister;
    vm.goToSinisterInfo = goToSinisterInfo;
    vm.viewCarta = viewCarta;
    var titles = {
      1: "Titular",
      2: "Cónyuge",
      3: "Hijo",
      4: "Otro",
    };

    //permisos
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        }
        if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
        }
        if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        }
        if (perm.model_name == "Siniestros") {
          vm.acceso_sin = perm;
          vm.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                vm.acceso_adm_sin = true;
              } else {
                vm.acceso_adm_sin = false;
              }
            }
          });
        }
        if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        }
        if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          vm.permarch = perm;
          vm.permarch.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                vm.permiso_administrar_adjuntos = true;
              } else {
                vm.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }

    $scope.recordatoriosFlag = false;

    $scope.showRecordatorios = function () {
      $scope.recordatoriosFlag = !$scope.recordatoriosFlag;
    };

    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.createRecordatorio = function (registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return $scope.endorsement;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    $scope.convertDate = function (inputFormat) {
      if (inputFormat) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat).getUTCDate();
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");

        return date;
      } else {
        return "";
      }
    };

    //select de opciones de tipo de siniestro
    vm.tipo = [
      {
        id: 1,
        name: "Accidente",
      },
      {
        id: 2,
        name: "Enfermedad",
      },
      {
        id: 3,
        name: "Parto",
      },
    ];
    //select para los tipos de pago
    vm.tipo_pago = [
      {
        id: 1,
        name: "Reembolso",
      },
      {
        id: 2,
        name: "Programacion",
      },
      {
        id: 3,
        name: "Pago Directo",
      },
      {
        id: 4,
        name: "Aclaración",
      },
    ];
    //Select de opciones de estatus
    vm.status = [
      {
        id: 2,
        name: "En Trámite",
      },
      {
        id: 3,
        name: "Completada/Procedente",
      },
      {
        id: 4,
        name: "Cancelada",
      },
      {
        id: 5,
        name: "Rechazada/ No Procedente",
      },
      {
        id: 6,
        name: "En espera/ Solicitud de Información",
      },
      ,
      {
        id: 7,
        name: "Reproceso",
      },
      {
        id: 8,
        name: "Inconformidad",
      },
    ];
    //select para el parentesco del afectado con el titular
    vm.parentesco = [
      {
        id: 1,
        name: "Titular",
      },
      {
        id: 2,
        name: "Conyugue",
      },
      {
        id: 3,
        name: "Hijo",
      },
      {
        id: 4,
        name: "Otro",
      },
    ];

    vm.tipo_title = {
      1: "Accidente",
      2: "Enfermedad",
      3: "Parto",
    };

    vm.pago_title = {
      1: "Reembolso",
      2: "Programacion",
      3: "Pago Directo",
      4: "Aclaración",
    };

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);

      return dateObject;
    }

    activate();

    function exportSiniestroComments() {
      if (!vm.siniestro_id || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
        $scope.$evalAsync(function () {});
      };

      var paramsObj = {
        model: 5,
        id_model: vm.siniestro_id,
      };
      if (vm.org_name) {
        paramsObj.org = vm.org_name;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: paramsObj,
          downloadName: "bitacora-siniestro.xlsx",
          token: token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }
    //FUNCION PARA CONSULTAR LOS DATOS DEL SINIESTRO SELECCIONADO
    function activate() {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 5,
          id_model: vm.siniestro_id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            next: request.data.next,
            previous: request.data.previous,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      //Cartas
      $http({
        method: "GET",
        url: url.IP + "cartas-by-model",
        params: {
          model: 5,
        },
      }).then(function success(response) {
        vm.cartas = response.data;
      });

      //Cargar la lista de los estados
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          vm.statesArray = data.data;
        });
      $scope.status_siniestro = ""; // estatus del siniestro
      $scope.inicial_complemento = "";

      dataFactory
        .get("siniester_get_by_id/" + vm.siniestro_id) //ruta del back para obtener info del siniestro
        .then(
          function success(response) {
            if (response.data) {
              vm.infoSiniestro = response.data;
              //dependiendo del numero de estatus imprime el texto
              if (vm.infoSiniestro.siniestro.status == 1) {
                $scope.status_siniestro = "Pendiente";
              } else if (vm.infoSiniestro.siniestro.status == 2) {
                $scope.status_siniestro = "En Trámite";
              } else if (vm.infoSiniestro.siniestro.status == 3) {
                $scope.status_siniestro = "Completada/Procedente";
                vm.siniestro_completado = true;
              } else if (vm.infoSiniestro.siniestro.status == 4) {
                $scope.status_siniestro = "Cancelada";
              } else if (vm.infoSiniestro.siniestro.status == 5) {
                $scope.status_siniestro = "Rechazada/ No Procedente";
              } else if (vm.infoSiniestro.siniestro.status == 6) {
                $scope.status_siniestro = "En espera/ Solicitud de Información";
              } else if (vm.infoSiniestro.siniestro.status == 7) {
                $scope.status_siniestro = "Reproceso";
              } else if (vm.infoSiniestro.siniestro.status == 8) {
                $scope.status_siniestro = "Inconformidad";
              }
              //Siniestro inicial o complemento
              if (vm.infoSiniestro.accidente) {
                if (vm.infoSiniestro.accidente.initial == true) {
                  $scope.inicial_complemento = "Inicial";
                  $scope.accidente_inicial_id = vm.infoSiniestro.accidente.id;
                } else if (vm.infoSiniestro.accidente.initial == false) {
                  $scope.inicial_complemento = "Complemento";
                  $scope.accidente_inicial =
                    vm.infoSiniestro.accidente.accidente_inicial;
                }
              } else {
                vm.infoSiniestro.accidente = {};
                toaster.info("El Siniestro no tiene accidente");
              }
              //Formato para las fechas del siniestro
              try {
                vm.infoSiniestro.siniestro.fecha_ingreso = vm.infoSiniestro
                  .siniestro.fecha_ingreso
                  ? datesFactory.convertDate(
                      vm.infoSiniestro.siniestro.fecha_ingreso
                    )
                  : "";
              } catch (e) {
                vm.infoSiniestro.siniestro.fecha_ingreso = vm.infoSiniestro
                  .siniestro.fecha_ingreso
                  ? datesFactory.convertDate(
                      vm.infoSiniestro.siniestro.fecha_ingreso
                    )
                  : "";
              }
              vm.infoSiniestro.siniestro.fecha_siniestro =
                datesFactory.convertDate(
                  vm.infoSiniestro.siniestro.fecha_siniestro
                );
              vm.infoSiniestro.siniestro.fecha = datesFactory.convertDate(
                vm.infoSiniestro.siniestro.fecha
              );

              //Obetener la informacion del contratante
              if (vm.infoSiniestro.poliza.contractor) {
                $http
                  .get(vm.infoSiniestro.poliza.contractor)
                  .then(function (contratante) {
                    vm.infoSiniestro.contratante_address =
                      contratante.data.address_contractor[0].route +
                      " " +
                      contratante.data.address_contractor[0].street_number +
                      " int" +
                      contratante.data.address_contractor[0].street_number_int +
                      " " +
                      contratante.data.address_contractor[0]
                        .administrative_area_level_2 +
                      "," +
                      contratante.data.address_contractor[0]
                        .administrative_area_level_1;
                    vm.infoSiniestro.contratante_name =
                      contratante.data.full_name;
                    vm.infoSiniestro.contratante_email = contratante.data.email;
                  });
              } else {
                //buscar la informacion del contratante si es un certificado
                $http
                  .get(
                    url.IP +
                      "leer-polizas-edit/" +
                      vm.infoSiniestro.poliza.id +
                      "/"
                  )
                  .then(function (policy) {
                    if (policy.data.parent.parent.contractor) {
                      var name = policy.data.parent.parent.contractor;
                      //console.log("nat_parent1",name)
                      vm.infoSiniestro.contratante_email = name.email;
                      vm.infoSiniestro.contratante_name = name.full_name;
                      vm.infoSiniestro.contratante_address =
                        name.address_contractor[0].route +
                        " #" +
                        name.address_contractor[0].street_number +
                        " " +
                        name.address_contractor[0].administrative_area_level_2 +
                        " " +
                        name.address_contractor[0].administrative_area_level_1;
                    } else if (policy.data.parent.parent.parent.contractor) {
                      var name = policy.data.parent.parent.parent.contractor;
                      vm.infoSiniestro.contratante_email = name.email;
                      vm.infoSiniestro.contratante_name = name.full_name;
                      vm.infoSiniestro.contratante_address =
                        name.address_contractor[0].route +
                        " #" +
                        name.address_contractor[0].street_number +
                        " " +
                        name.address_contractor[0].administrative_area_level_2 +
                        " " +
                        name.address_contractor[0].administrative_area_level_1;
                    }

                    if (policy.data.parent.parent.aseguradora) {
                      vm.infoSiniestro.aseguradora = {
                        aseguradora_name: policy.data.parent.parent.aseguradora,
                      };
                    } else if (policy.data.parent.parent.parent.aseguradora) {
                      vm.infoSiniestro.aseguradora = {
                        aseguradora_name:
                          policy.data.parent.parent.parent.aseguradora,
                      };
                    }
                  });
              }

              //obtener el estado
              if (vm.infoSiniestro.siniestro.state) {
                $http
                  .get(vm.infoSiniestro.siniestro.state)
                  .then(function (estado) {
                    for (var i in vm.statesArray) {
                      if (vm.statesArray[i].id == estado.data.id) {
                        vm.infoSiniestro.siniestro.state = vm.statesArray[i];

                        vm.ciudades_estados();
                      }
                    }
                  });
              }
              //obtener la ciudad
              if (vm.infoSiniestro.siniestro.city) {
                $http
                  .get(vm.infoSiniestro.siniestro.city)
                  .then(function (ciudad) {
                    vm.infoSiniestro.siniestro.city = ciudad.data.url;
                    vm.ciudad_name = ciudad.data.city;
                  });
              }

              //obtener el subramo de la poliza
              ramoService
                .getSubramoById(vm.infoSiniestro.poliza.subramo)
                .then(function (res) {
                  vm.infoSiniestro.subramo = {
                    subramo_name: res.data.subramo_name,
                    url: res.data.url,
                  };
                });

              if (vm.infoSiniestro.poliza.paquete) {
                //obtener informacion sonbre el paquete o plan de la poliza
                packageService
                  .getOnlyPackageById(vm.infoSiniestro.poliza.paquete)
                  .then(function (paquete) {
                    vm.infoSiniestro.paquete = {
                      package_name: paquete.data.package_name,
                      url: paquete.data.url,
                    };
                  });
              }
              //Obtener la informacion de la aseguradora
              if (vm.infoSiniestro.poliza.aseguradora) {
                providerService
                  .getProviderById(vm.infoSiniestro.poliza.aseguradora)
                  .then(function (aseguradora) {
                    vm.infoSiniestro.aseguradora = {
                      aseguradora_name: aseguradora.data.alias,
                      url: aseguradora.data.url,
                    };
                  });
              }

              //Obtener las facturas del siniestro
              vm.infoSiniestro.facturas.forEach(function (factura) {
                if (factura.fecha_factura) {
                  factura.fecha_factura = datesFactory.convertDate(
                    factura.fecha_factura
                  );
                } else {
                  factura.fecha_factura = factura.fecha_factura;
                }

                var obj = {
                  f_number: factura.numero_factura,
                  proovedor: factura.proveedor,
                  f_date: factura.fecha_factura,
                  import: parseFloat(factura.importe),
                  iva: factura.iva,
                  total: factura.total,
                  procedente: parseFloat(factura.procedente),
                  url: factura.url,
                  serie: factura.serie,
                  observaciones: factura.observaciones,
                  concepto: factura.concepto,
                };
                $scope.active = 0;
                vm.facturas.push(obj);
              });

              //formato para las fechas de vigencia
              vm.infoSiniestro.poliza.start_of_validity =
                datesFactory.convertDate(
                  vm.infoSiniestro.poliza.start_of_validity
                );
              vm.infoSiniestro.poliza.end_of_validity =
                datesFactory.convertDate(
                  vm.infoSiniestro.poliza.end_of_validity
                );
              //formato para la fecha de ciurgia
              if (vm.infoSiniestro.accidente) {
                vm.infoSiniestro.accidente.fecha_cirugia =
                  datesFactory.convertDate(
                    vm.infoSiniestro.accidente.fecha_cirugia
                  );
              } else {
                vm.infoSiniestro.accidente.fecha_cirugia =
                  datesFactory.convertDate(new Date());
              }
              //formato para la fecha de compromiso

              if (vm.infoSiniestro.siniestro.fecha_compromiso != null) {
                vm.infoSiniestro.siniestro.fecha_compromiso =
                  datesFactory.convertDate(
                    vm.infoSiniestro.siniestro.fecha_compromiso
                  );
              } else {
                vm.infoSiniestro.siniestro.fecha_compromiso =
                  "No hay fecha definida";
              }

              //Si doc_type es poliza o certificado
              if (
                vm.infoSiniestro.poliza.document_type == 1 ||
                vm.infoSiniestro.poliza.document_type == 6
              ) {
                var type_relationship = vm.infoSiniestro.accidente.relationship;
                //asignar el texto del tipo de relacion
                switch (type_relationship) {
                  case 1:
                    vm.infoSiniestro.relationship = "Titular";
                    break;
                  case 2:
                    vm.infoSiniestro.relationship = "Conyugue";
                    break;
                  case 3:
                    vm.infoSiniestro.relationship = "Hijo";
                    break;
                  case 4:
                    vm.infoSiniestro.relationship = "Otro";
                  default:
                    break;
                }

                //fortato para las fecha de nacimiento
                if (vm.infoSiniestro.accidente.dependiente) {
                  vm.infoSiniestro.afectado_birthdate =
                    datesFactory.convertDate(
                      vm.infoSiniestro.accidente.dependiente.birthdate
                    );
                } else {
                  if (
                    vm.infoSiniestro.accidente &&
                    vm.infoSiniestro.accidente.titular
                  ) {
                    vm.infoSiniestro.afectado_birthdate =
                      datesFactory.convertDate(
                        vm.infoSiniestro.accidente.titular.birthdate
                      );
                  } else {
                    vm.infoSiniestro.afectado_birthdate =
                      datesFactory.convertDate(new Date());
                  }
                }
              } else {
                var type_relationship =
                  vm.infoSiniestro.siniestro.relationship_aux_affected;
                //asignar el texto del tipo de relacion
                switch (type_relationship) {
                  case 1:
                    vm.infoSiniestro.relationship = "Titular";
                    break;
                  case 2:
                    vm.infoSiniestro.relationship = "Conyugue";
                    break;
                  case 3:
                    vm.infoSiniestro.relationship = "Hijo";
                    break;
                  case 4:
                    vm.infoSiniestro.relationship = "Otro";
                  default:
                    break;
                }
              }

              fileService
                .getFiles(
                  url.IP +
                    "siniestros/" +
                    vm.infoSiniestro.siniestro.id +
                    "/archivos/"
                )
                .then(function (files) {
                  files.forEach(function (file) {
                    vm.files.push(file);
                    //console.log(vm.files)
                  });
                });
            }

            if (
              vm.infoSiniestro &&
              vm.infoSiniestro.accidente &&
              vm.infoSiniestro.accidente.initial &&
              vm.infoSiniestro.accidente.initial == true
            ) {
              $scope.params = {
                accidente_inicial: $scope.accidente_inicial_id,
                exclude_complemento: null,
              };
              dataFactory
                .get("get-siniestro-complementos/", $scope.params)
                .then(function success(responseSiniestroComplementos) {
                  vm.siniestro_complementos =
                    responseSiniestroComplementos.data.results;
                  //console.log("complementos",vm.siniestro_complementos)
                });
            } else if (
              vm.infoSiniestro &&
              vm.infoSiniestro.accidente &&
              vm.infoSiniestro.accidente.initial &&
              vm.infoSiniestro.accidente.initial == false
            ) {
              $http
                .get($scope.accidente_inicial)
                .then(function (accidente_inicial) {
                  $scope.params = {
                    accidente_inicial: accidente_inicial.data.id,
                    exclude_complemento: vm.infoSiniestro.accidente.id,
                  };

                  dataFactory
                    .get("get-siniestro-inicial/", $scope.params)
                    .then(function success(responseSiniestroInicial) {
                      vm.siniestro_inicial =
                        responseSiniestroInicial.data.results;
                      //console.log("inicial",vm.siniestro_inicial)
                    });

                  dataFactory
                    .get("get-siniestro-complementos/", $scope.params)
                    .then(function success(responseSiniestroComplementos) {
                      vm.siniestro_complementos =
                        responseSiniestroComplementos.data.results;
                      //console.log("complementos",vm.siniestro_complementos)
                    });
                });
            }
          },
          function error(err) {
            console.log(err);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    }

    //EXPORTAR EXCEL DE FACTURAS
    function downloadFacturas(siniestro) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "data:application/vnd.ms-excel;charset=UTF-8",
        }
      );
      saveAs(blob, "Concentrado_Facturas" + ".xls");
    }
    //obtener el historial de log
    function getLog() {
      dataFactory
        .get("get-specific-log", {
          model: 5,
          associated_id: vm.infoSiniestro.siniestro.id,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    }
    //funcion para ir a la poliza correspondiente al siniestro
    function goToPolicy(poliza) {
      if (vm.infoSiniestro.poliza.document_type == 3) {
        var name = "Información colectividad";
        var route = "colectividades.info";
      } else if (vm.infoSiniestro.poliza.document_type == 1) {
        var name = "Información pólizas";
        var route = "polizas.info";
      } else if (vm.infoSiniestro.poliza.document_type == 6) {
        var name = "Información colectividad";
        var route = "colectividades.info";
      } else if (vm.infoSiniestro.poliza.parent) {
        if (vm.infoSiniestro.poliza.parent.document_type == 5) {
          if (vm.infoSiniestro.poliza.parent.parent) {
            if (vm.infoSiniestro.poliza.parent.parent.document_type == 4) {
              if (vm.infoSiniestro.poliza.parent.parent.parent) {
                if (
                  vm.infoSiniestro.poliza.parent.parent.parent.document_type ==
                  3
                ) {
                  var name = "Información colectividad";
                  var route = "colectividades.info";
                }
              }
            }
          }
        }
      }

      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;

      if (vm.infoSiniestro.poliza.document_type == 3) {
        $state.go("colectividades.info", {
          polizaId: vm.infoSiniestro.poliza.id,
        });
      } else if (vm.infoSiniestro.poliza.document_type == 1) {
        $state.go("polizas.info", { polizaId: vm.infoSiniestro.poliza.id });
      } else if (vm.infoSiniestro.poliza.document_type == 6) {
        $state.go("colectividades.info", {
          polizaId: vm.infoSiniestro.poliza.parent.caratula,
        });
      } else if (vm.infoSiniestro.poliza.parent) {
        if (vm.infoSiniestro.poliza.parent.document_type == 5) {
          if (vm.infoSiniestro.poliza.parent.parent) {
            if (vm.infoSiniestro.poliza.parent.parent.document_type == 4) {
              if (vm.infoSiniestro.poliza.parent.parent.parent) {
                if (
                  vm.infoSiniestro.poliza.parent.parent.parent.document_type ==
                  3
                ) {
                  $state.go("colectividades.info", {
                    polizaId: vm.infoSiniestro.poliza.parent.parent.parent.id,
                  });
                }
              }
            }
          }
        }
      }
    }
    //fucion para pdf
    function getPDF(siniestro, poliza) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-siniester/",
        params: {
          poliza: poliza,
          siniestro: siniestro,
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
          $scope.pdf = response.data;
          var params = {
            model: 5,
            event: "GET",
            associated_id: vm.infoSiniestro.siniestro.id,
            identifier:
              "emitio PDF del siniestro " +
              vm.infoSiniestro.siniestro.numero_siniestro,
          };
          dataFactory.post("send-log/", params);
          // $http({
          // method: 'GET',
          // url: url.IP + 'get-pdf',
          // params: {
          //     'pdf_name': $scope.pdf.pdf_name
          // }
          // }).then(function success(response) {

          // })
        }
      });
    }

    //funcion para el pdf de finiquito
    function ModalFiniquitoCtrl($uibModalInstance, $scope) {
      $scope.data = {};
      $scope.close = function () {
        $uibModalInstance.dismiss();
      };

      $scope.visualizar = function (data) {
        $uibModalInstance.close(data);
      };
    }

    function getPDFiniquito(siniestro, poliza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/modal.finiquito.html",
        controller: ModalFiniquitoCtrl,
        size: "md",
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (data) {
        $http({
          method: "POST",
          url: url.IP + "get-pdf-finiquito/",
          data: {
            poliza: poliza,
            siniestro: siniestro,
            cheque: data.cheque,
            observaciones: data.observaciones,
          },
        }).then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            var file = new Blob([response.data], { type: "application/pdf" });
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file);
            } else {
              var fileURL = URL.createObjectURL(file);
              $scope.content = $sce.trustAsResourceUrl(fileURL);
              window.open($scope.content);
            }
            $scope.pdf = response.data;
            var params = {
              model: 5,
              event: "POST",
              associated_id: vm.infoSiniestro.siniestro.id,
              identifier:
                "emitio una hoja de Finiquito " +
                vm.infoSiniestro.siniestro.numero_siniestro,
            };
            dataFactory.post("send-log/", params);
            // $http({
            // method: 'GET',
            // url: url.IP + 'get-pdf',
            // params: {
            //     'pdf_name': $scope.pdf.pdf_name
            // }
            // }).then(function success(response) {

            // })
          }
        });
      });
    }
    // Enviar correo electrónico Siniestro inicio***********
    function sendEmail(siniestro, poliza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/email_siniestro.html",
        controller: ModalEmailSiniestroCtrl,
        size: "lg",
        resolve: {
          from: function () {
            return null;
          },
          archivos: function () {
            return vm.files;
          },
          siniestro: function () {
            return siniestro;
          },
          poliza: function () {
            return poliza;
          },
          info: function () {
            return vm.infoSiniestro;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
      modalInstance.result.then(function (data) {});
    }

    function openWhatsapp(siniestro, poliza) {
      var targetSiniestro =
        siniestro || (vm.infoSiniestro && vm.infoSiniestro.siniestro);
      if (!targetSiniestro) {
        return;
      }
      var info = {
        contratante: targetSiniestro.contratante,
        contratante_phone_number:
          targetSiniestro.contratante_phone_number ||
          (targetSiniestro.contratante &&
            (targetSiniestro.contratante.phone_number ||
              targetSiniestro.contratante.phone)),
      };
      siniestroWhatsappService.open({
        siniestro: targetSiniestro,
        poliza: poliza || (vm.infoSiniestro && vm.infoSiniestro.poliza),
        info: info,
      });
    }
    function ModalEmailSiniestroCtrl(
      $uibModalInstance,
      $scope,
      archivos,
      siniestro,
      poliza,
      info
    ) {
      var vmm = this;
      $scope.data = {};
      $scope.send = false;
      $scope.files = archivos;
      $scope.siniestro = siniestro;
      $scope.poliza = poliza;
      $scope.emailcontractor = info.contratante_email;
      $scope.emailAsegurado =
        info &&
        info.accidente &&
        info.accidente.titular &&
        info.accidente.titular.email
          ? info.accidente.titular.email
          : "";

      if (
        $scope.emailAsegurado == "" &&
        $scope.poliza &&
        $scope.poliza.accidents_policy &&
        $scope.poliza.accidents_policy[0] &&
        $scope.poliza.accidents_policy[0].personal &&
        $scope.poliza.accidents_policy[0].personal.email
      ) {
        $scope.emailAsegurado =
          $scope.poliza.accidents_policy[0].personal.email;
      }
      $scope.subjectEmail =
        "Información del Siniestro: " +
        (siniestro.numero_siniestro
          ? siniestro.numero_siniestro
          : siniestro.folio_interno
        ).toString() +
        ", de la Póliza: " +
        (poliza.poliza_number
          ? poliza.poliza_number
          : poliza.internal_number
        ).toString();
      $scope.close = function () {
        $uibModalInstance.dismiss();
      };
      dataFactory
        .get("emailtemplate-unpag/", {
          template_model: 4,
          id_policy: poliza.id,
        })
        .then(function success(response) {
          $scope.plantillas = response.data;
        });
      $http
        .get(url.IP + "share-siniestro-manual/" + siniestro.id)
        .then(function (response) {
          if (response.status === 200) {
            $scope.body = response.data.body;
          }
        })
        .catch(function (e) {
          console.log("error - catch", e);
        });
      $scope.visualizar = function (data) {
        $uibModalInstance.close(data);
      };
      $scope.changePlantilla = function (item) {
        if (item) {
          $scope.subjectEmail = item.title;
          $scope.first_comment = item.text;
          if ($scope.first_comment.includes("\n")) {
            $scope.first_comment = $scope.first_comment.replace(
              "\n",
              "<br><br>"
            );
          }
          $scope.second_comment = item.bottom_text;
          $scope.custom_email = true;
          $scope.getTemplate(true);
        } else {
          $scope.subjectEmail = "";
          $scope.first_comment = "";
          $scope.second_comment = "";
          $scope.custom_email = true;
          $scope.getTemplate(true);
        }
      };
      $scope.getTemplate = function (custom_email) {
        if (custom_email) {
          $http
            .get(url.IP + "share-siniestro-manual/" + vm.insurance.id)
            .then(function (response) {
              if (response.status === 200) {
                $scope.head = response.data.head;
                $scope.body = response.data.body;
                $scope.footer = response.data.footer;
                $scope.subjectDefault = response.data.subject_default;
                if (
                  $scope.subjectEmail == "" ||
                  $scope.subjectEmail == undefined
                ) {
                  $scope.subjectEmail = $scope.subjectDefault;
                }
              }
            })
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          $scope.htmlVariable = "";
          $scope.first_comment = "";
          $scope.second_comment = "";
        }
      };
      $scope.sendEmailSiniestro = function (first_comment, second_comment) {
        $scope.send = true;
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        var data_shared = {
          id: siniestro.id,
          emails: $scope.emails,
          files: $scope.share_via_email,
          subject: $scope.subjectEmail,
          first_comment: first_comment,
          second_comment: second_comment,
          model: 5,
        };

        $http
          .post(url.IP + "share-siniestro-manual/", data_shared)
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.SENDEMAIL, "success");
                $scope.send = true;
                $uibModalInstance.dismiss("cancel");
              } else {
                $scope.send = true;
                l.stop();
                if (request.data && request.data.status) {
                  SweetAlert.swal("ERROR", request.data.status, "error");
                  l.stop();
                } else if (request.data && request.data.response) {
                  SweetAlert.swal(
                    "Error",
                    "No se envió el correo electrónico. Contacte a su administrador.",
                    "error"
                  );
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "ERROR",
                    JSON.stringify(request.data),
                    "error"
                  );
                  l.stop();
                }
              }
            },
            function error(error) {
              l.stop();
              console.log("error - email", error);
            }
          )
          .catch(function (e) {
            l.stop();
            console.log("error - catch", e);
          });
      };
      $scope.showEmailInInput = function (email) {
        $scope.email_assign = email;
      };
      $scope.emails = [];
      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      $scope.emails = [];

      $scope.addEmail = function (email) {
        if (!validateEmail(email)) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }

        if ($scope.emails.indexOf(email) < 0) {
          $scope.emails.push(email);
          vmm.email_assign_mail = ""; // limpiamos el input
        } else {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.REPEATEMAIL, "error");
        }
      };
      $scope.remove_email = function (index) {
        $scope.emails.splice(index, 1);
      };
      $scope.share_via_email = [];
      $scope.shareFileEmail = function (file, value) {
        file.to_send = value;
        var index = $scope.share_via_email.indexOf(file.id);
        if (value) {
          if (index === -1) {
            $scope.share_via_email.push(file.id);
          }
        } else {
          if (index !== -1) {
            $scope.share_via_email.splice(index, 1);
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }
    // enviar correo electrónico Siniestro fin*********

    //function para carta
    function viewCarta(poliza, carta) {
      $http({
        method: "GET",
        url: url.IP + "get-carta-siniestros/",
        params: {
          id: vm.infoSiniestro.siniestro.id,
          id_carta: carta,
          hospital: "",
          medico: "",
          medico2: "",
          sa_auth: "",
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          $scope.pdf = response.data;
          var params = {
            model: 5,
            event: "GET",
            associated_id: vm.infoSiniestro.siniestro.id,
            identifier:
              "emitio Carta del siniestro " +
              vm.infoSiniestro.siniestro.numero_siniestro,
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          $http({
            method: "GET",
            url: url.IP + "get-pdf",
            params: {
              pdf_name: $scope.pdf.pdf_name,
            },
            responseType: "arraybuffer",
          }).then(function success(response) {
            if (response.status === 200 || response.status === 201) {
              var file = new Blob([response.data], { type: "application/pdf" });
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file);
              } else {
                var fileURL = URL.createObjectURL(file);
                $scope.content = $sce.trustAsResourceUrl(fileURL);
                window.open($scope.content);
              }
            }
          });
        }
      });
    }

    //funcion para eliminar el registro del siniestro
    function deleteSiniestro(parUrl) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "¡Al eliminar tu siniestro no podra recuperarse nuevamente!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "No, cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            if (!parUrl) {
              $http
                .delete(url.IP + "siniestros/" + $stateParams.siniestroId)
                .then(function (response) {
                  if (response.status === 204) {
                    SweetAlert.swal(
                      "Eliminado",
                      "Siniestro eliminado exitosamente",
                      "success"
                    );
                    var params = {
                      model: 5,
                      event: "DELETE",
                      associated_id: $stateParams.siniestroId,
                      identifier:
                        "elimino el sinietsro" +
                        vm.infoSiniestro.siniestro.numero_siniestro,
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});

                    $state.go("siniestros.lista");
                  }
                });
            } else {
              $http.delete(parUrl).then(function (response) {
                if (response.status === 204) {
                  SweetAlert.swal(
                    "Eliminado",
                    "Siniestro eliminado exitosamente",
                    "success"
                  );
                  var params = {
                    model: 5,
                    event: "DELETE",
                    associated_id: $stateParams.siniestroId,
                    identifier:
                      "elimino el sinietsro" +
                      vm.infoSiniestro.siniestro.numero_siniestro,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  $state.go("siniestros.lista");
                }
              });
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "Tu registro esta a salvo :)",
              "error"
            );
          }
        }
      );
    }

    function fillTable(ramo_number) {
      vm.siniestros = [];
      $http
        .get(url.IP + "siniestros-definidos/" + ramo_number)
        .then(function (siniestros) {
          if (siniestros.status == 200 || siniestros.status == 201) {
            if (siniestros.data) {
              siniestros.data.forEach(function (siniestro) {
                vm.siniestros.push(siniestro);
              });
            }
          }
        });
    }

    //funcion para crear complemento
    function crear_complemento(siniestro, name, route) {
      //console.log("siniestro",siniestro)

      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };

      $rootScope.siniestro_tmp = siniestro;
      $rootScope.carga_siniestro = true;
      $rootScope.tmp_complemento = true;
      // $state.go('siniestros.accidentes');

      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $state.go($scope.route_for_new_tab);
    }

    //estados y ciudades
    function ciudades_estados() {
      vm.selected_state = vm.infoSiniestro.siniestro.state;
      //console.log(vm.selected_state)
      vm.citiesArray = vm.selected_state.cities;
      //console.log(vm.citiesArray);

      //vm.infoSiniestro.siniestro.state = vm.citiesArray.state;
      //vm.infoSiniestro.siniestro.city = vm.citiesArray.city;
    }

    //Funcion para ir a la info del siniestro
    function goToSinister(ramo, sinId) {
      //console.log(ramo);
      //console.log(sinId);
      if (ramo == 2) {
        $state.go("siniestros.edit", { siniestroId: sinId });
      }
    }

    //agregar contactos
    function addContact() {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
      };
      vm.infoSiniestro.accidente.contact_accidente.push(contact);
    }

    //eliminar contactos
    function deleteContacts(index, contact) {
      $localStorage.indx = index;
      $localStorage.urll = contact.url;

      SweetAlert.swal(
        {
          title: "¿Estás seguro?",
          text: "Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        },
        function (isConfirm) {
          if (isConfirm) {
            //console.log("confirmado")
            var index = $localStorage.indx;
            var url = $localStorage.urll;
            if ((url && index) || (url && !index)) {
              try {
                return contactService
                  .deleteContact(url) //elimina contacto
                  .then(function () {
                    vm.infoSiniestro.accidente.contact_accidente.splice(index); //elimina el registro en la interfaz
                    toaster.success(MESSAGES.OK.DELETECONTRACTOR);
                  });
              } catch (err) {
                throw err;
              }
            } else {
              vm.infoSiniestro.accidente.contact_accidente.splice(index);
            }
          }
        }
      );
    }

    //Agregar observaciones a los registros de facturas
    function viewObservation(url, SiniesterStatus) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/facturas.observation.html",
        controller: ModalInstanceCtrlObservationsfact,
        resolve: {
          obj: function () {
            return { url: url, SiniesterStatus: SiniesterStatus };
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    //modal para agregar observacines en las facturas
    function ModalInstanceCtrlObservationsfact(
      $scope,
      $uibModal,
      obj,
      $uibModalInstance
    ) {
      $scope.SiniesterStatus = obj.SiniesterStatus;
      $http.get(obj.url).then(function (data) {
        $scope.observation_aux = data.data.observaciones;
      });

      $scope.ok = function () {
        var observ = {
          observaciones: $scope.observation_aux,
        };
        $http.patch(obj.url, observ).then(function (data) {
          if (data.status === 200 || data.status === 201) {
            $uibModalInstance.dismiss("cancel");
            var params = {
              model: 5,
              event: "PATCH",
              associated_id: vm.infoSiniestro.siniestro.id,
              identifier:
                "actualizo el siniestro" +
                vm.infoSiniestro.siniestro.numero_siniestro +
                " agrego observaciones",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          }
        });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    // //Funciones para la administracion de archivos adjuntos
    // var uploader = $scope.uploader = new FileUploader({
    //     headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json' },
    // });

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // // ALERTA SUCCES UPLOADFILES
    // uploader.onSuccessItem = function(fileItem, response, status, headers) {
    //   toaster.success(MESSAGES.OK.UPLOADFILES);
    // };

    // // ALERTA ERROR UPLOADFILES
    // uploader.onErrorItem = function(fileItem, response, status, headers) {
    //   SweetAlert.swal("ERROR",MESSAGES.ERROR.ERRORONUPLOADFILES ,"error");
    // };
    //Eliminar el archivo de la lista
    function deleteFile(file, container) {
      //console.log(file)
      //console.log(container)
      var data_email = {
        id: file.id,
        id_siniestro: vm.infoSiniestro.id,
        model: 7,
        type_person: 0,
      };
      dataFactory
        .post("send-email-admins-deletes/", data_email)
        .then(function success(req) {
          console.log(".................:::::.....", req);
        });
      fileService.deleteFile(file, container);

      var params = {
        model: 5,
        event: "DELETE",
        associated_id: vm.infoSiniestro.siniestro.id,
        identifier:
          "elimino archivos del siniestro" +
          vm.infoSiniestro.siniestro.numero_siniestro,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
    }

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    //Cambiar el tipo de documento
    $scope.changeTypeDoc = function (padecimiento, index) {
      $scope.padecimiento_type = padecimiento;
      uploader.queue[index].formData[index].type_document = padecimiento;
    };

    // uploader.onAfterAddingFile = function(fileItem) {
    //     fileItem.formData.push({
    //         arch: fileItem._file
    //     })
    // }

    // uploader.onBeforeUploadItem = function(item) {
    //     if(item.file.sensible != undefined){
    //         item.formData[0].sensible = item.file.sensible;
    //     }
    //     item.url = $scope.userInfo.url;
    //     item.formData[0].nombre = item.file.name;
    //     item.alias = '';
    //     item.formData[0].owner = $scope.userInfo.id;
    // };

    // function uploadFiles(siniestro_id,doc_type) {

    //     $scope.userInfo = {
    //         id: siniestro_id,
    //         type_document: doc_type
    //     };

    //     $scope.userInfo.url = $scope.uploader.url = url.IP + 'siniestros/' + vm.infoSiniestro.siniestro.id +'/archivos/?type_document='+doc_type;
    //     // ////console.log( $scope.uploader);
    //     $q.when()
    //         .then(function() {
    //             var defer = $q.defer();
    //             defer.resolve($scope.uploader.uploadAll());
    //             return defer.promise;
    //         })
    //         .then(function() {
    //             toaster.success('Se han subido sus archivos correctamente');

    //             setTimeout(function() {
    //                 fileService.getFiles(url.IP+ 'siniestros/' +vm.infoSiniestro.siniestro.id+ '/archivos/').then(function(res) {
    //                     res.forEach(function(file) {
    //                         vm.files.push(file);
    //                     })

    //                 });
    //             }, 100);

    //         });
    // }

    $scope.okFile = 0;
    $scope.countFile = 0;

    // Upload files
    $scope.userInfo = {
      id: 0,
    };

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        //'Authorization': 'Token ' + token,
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal(
          "¡Listo!",
          "Archivos cargados exitosamente.",
          "success"
        );
        $state.go("siniestros.info", {
          siniestroId: vm.infoSiniestro.siniestro.id,
        });
        $state.reload();
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
      fileItem.removeAfterUpload = true;
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(siniestro_id) {
      $scope.userInfo = {
        id: siniestro_id,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "siniestros/" + siniestro_id + "/archivos/";

      $scope.files = [];

      // $timeout(function() {
      $scope.uploader.uploadAll();
      //   console.log('fdfsf', $scope.filesCover,$scope.files)
      // }, 1000);
    }

    $scope.showFiles = function (item) {
      $http
        .get(url.IP + "siniestros/" + item.id + "/archivos/")
        .then(function (response) {
          item.files = response.data.results;
          if (item.showFile) {
            item.showFile = false;
          } else {
            item.showFile = true;
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.saveFiles = function (param) {
      uploadFiles(param.siniestro.id);
    };

    //Funcion para ir a la info del siniestro
    function goToSinisterInfo(ramo, sinId) {
      if (vm.acceso_adm_sin) {
        if (ramo == 1) {
          $state.go("siniestros.vida_info", { siniestroId: sinId });
        } else if (ramo == 2) {
          $state.go("siniestros.info", { siniestroId: sinId });
        } else if (ramo == 3) {
          $state.go("siniestros.auto_info", { siniestroId: sinId });
        } else if (ramo == 4) {
          $state.go("siniestros.danio_info", { siniestroId: sinId });
        }
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("SiniestrosAccidentesEditCtrl", SiniestrosAccidentesEditCtrl);

  SiniestrosAccidentesEditCtrl.$inject = [
    "$parse",
    "$scope",
    "dataFactory",
    "SweetAlert",
    "datesFactory",
    "$sce",
    "$uibModal",
    "toaster",
    "$http",
    "url",
    "insuranceService",
    "ramoService",
    "$q",
    "providerService",
    "packageService",
    "SiniestroService",
    "facturas_conceptos",
    "$state",
    "$sessionStorage",
    "$stateParams",
    "$localStorage",
    "MESSAGES",
    "$rootScope",
    "helpers",
    "emailService",
    "fileService",
    "FileUploader",
    "contactService",
  ];

  function SiniestrosAccidentesEditCtrl(
    $parse,
    $scope,
    dataFactory,
    SweetAlert,
    datesFactory,
    $sce,
    $uibModal,
    toaster,
    $http,
    url,
    insuranceService,
    ramoService,
    $q,
    providerService,
    packageService,
    SiniestroService,
    facturas_conceptos,
    $state,
    $sessionStorage,
    $stateParams,
    $localStorage,
    MESSAGES,
    $rootScope,
    helpers,
    emailService,
    fileService,
    FileUploader,
    contactService
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var token = JSON.parse(decryptedToken);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.user = usr;
    vm.infoSiniestro = [];
    vm.affect_data = {};
    vm.facturas = [];
    vm.facturas_conceptos = facturas_conceptos;
    var facturasExcelHeaders = [
      "Serie",
      "No. Factura",
      "Concepto",
      "Proveedor",
      "Fecha de factura",
      "Importe",
      "IVA",
      "Total",
      "Procedente",
    ];
    var facturasExcelColumnMap = {
      serie: "serie",
      nofactura: "f_number",
      concepto: "concepto",
      proveedor: "proovedor",
      fechadefactura: "f_date",
      importe: "import",
      iva: "iva",
      total: "total",
      procedente: "procedente",
    };
    vm.updateSiniestro = updateSiniestro;
    vm.deleteFactura = deleteFactura;
    vm.siniestro_id = $stateParams.siniestroId;
    vm.addFactura = addFactura;
    vm.downloadFacturas = downloadFacturas;
    vm.getLog = getLog;
    vm.fillTable = fillTable;
    vm.crear_complemento = crear_complemento;
    vm.siniestro_completado = false;
    vm.selected_state = [];
    vm.citiesArray = [];
    vm.statesArray = [];
    vm.ciudades_estados = ciudades_estados;
    vm.uploadFiles = uploadFiles;
    vm.files = [];
    vm.handleFacturasExcelFile = handleFacturasExcelFile;
    vm.downloadPlantillaFacturas = downloadPlantillaFacturas;
    vm.importFacturasFromExcel = importFacturasFromExcel;
    $scope.deleteFile = deleteFile;
    $scope.fileSinister = true;
    $scope.observation_aux = "";
    //Funciones de contactos
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;
    vm.viewObservation = viewObservation;
    vm.buscaPadecimientos = buscaPadecimientos;
    vm.selected_disease = [];
    $scope.enfermedades = [];
    vm.updateHospital = updateHospital;
    vm.hospital = [];
    vm.hospitals = [];

    //select de opciones de tipo de siniestro
    vm.tipo = [
      {
        id: 1,
        name: "Accidente",
      },
      {
        id: 2,
        name: "Enfermedad",
      },
      {
        id: 3,
        name: "Parto",
      },
    ];
    //select para los tipos de pago
    vm.tipo_pago = [
      {
        id: 1,
        name: "Reembolso",
      },
      {
        id: 2,
        name: "Programacion",
      },
      {
        id: 3,
        name: "Pago Directo",
      },
      {
        id: 4,
        name: "Aclaración",
      },
    ];
    //Select de opciones de estatus
    vm.status = [
      {
        id: 1,
        name: "Pendiente",
      },
      {
        id: 2,
        name: "En Trámite",
      },
      {
        id: 3,
        name: "Completada/Procedente",
      },
      {
        id: 4,
        name: "Cancelada",
      },
      {
        id: 5,
        name: "Rechazada/ No Procedente",
      },
      {
        id: 6,
        name: "En espera/ Solicitud de Información",
      },
      {
        id: 7,
        name: "Reproceso",
      },
      {
        id: 8,
        name: "Inconformidad",
      },
    ];
    //select para el parentesco del afectado con el titular
    vm.parentesco = [
      {
        id: 1,
        name: "Titular",
      },
      {
        id: 2,
        name: "Conyugue",
      },
      {
        id: 3,
        name: "Hijo",
      },
      {
        id: 4,
        name: "Otro",
      },
    ];

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);

      return dateObject;
    }

    activate();
    //FUNCION PARA CONSULTAR LOS DATOS DEL SINIESTRO SELECCIONADO
    function activate() {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 5,
          id_model: vm.siniestro_id,
        },
      })
        .then(function (request) {
          // console.log('-------', request);
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            next: request.data.next,
            previous: request.data.previous,
          };
          // console.log('comments_data', vm.comments_data);
        })
        .catch(function (e) {
          console.log("e", e);
        });

      //Cargar la lista de los estados
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          vm.statesArray = data.data;
        });

      $scope.status_siniestro = ""; // estatus del siniestro
      $scope.inicial_complemento = "";
      dataFactory
        .get("siniester_get_by_id/" + vm.siniestro_id) //ruta del back para obtener info del siniestro
        .then(
          function success(response) {
            if (response.data) {
              vm.infoSiniestro = response.data;
              //dependiendo del numero de estatus imprime el texto
              if (vm.infoSiniestro.siniestro.status == 1) {
                $scope.status_siniestro = "Pendiente";
              } else if (vm.infoSiniestro.siniestro.status == 2) {
                $scope.status_siniestro = "En Trámite";
              } else if (vm.infoSiniestro.siniestro.status == 3) {
                $scope.status_siniestro = "Completada";
                vm.siniestro_completado = true;
              } else if (vm.infoSiniestro.siniestro.status == 4) {
                $scope.status_siniestro = "Cancelada";
              } else if (vm.infoSiniestro.siniestro.status == 5) {
                $scope.status_siniestro = "Rechazada";
              } else if (vm.infoSiniestro.siniestro.status == 6) {
                $scope.status_siniestro = "En espera";
              } else if (vm.infoSiniestro.siniestro.status == 7) {
                $scope.status_siniestro = "Reproceso";
              } else if (vm.infoSiniestro.siniestro.status == 8) {
                $scope.status_siniestro = "Inconformidad";
              }
              $scope.obj_original = angular.copy(response.data.siniestro);

              //Siniestro inicial o complemento
              if (vm.infoSiniestro.accidente.initial == true) {
                $scope.inicial_complemento = "Inicial";
              } else if (vm.infoSiniestro.accidente.initial == false) {
                $scope.inicial_complemento = "Complemento";
              }

              //Formato para las fechas del siniestro
              vm.infoSiniestro.siniestro.fecha_ingreso =
                datesFactory.convertDate(
                  vm.infoSiniestro.siniestro.fecha_ingreso
                );
              vm.infoSiniestro.siniestro.fecha_terminacion =
                datesFactory.convertDate(
                  vm.infoSiniestro.siniestro.fecha_terminacion
                );
              vm.infoSiniestro.siniestro.fecha_siniestro =
                datesFactory.convertDate(
                  vm.infoSiniestro.siniestro.fecha_siniestro
                );
              vm.infoSiniestro.siniestro.fecha = datesFactory.convertDate(
                vm.infoSiniestro.siniestro.fecha
              ); //fecha de ingreso
              vm.selected_disease.val = vm.infoSiniestro.accidente.ailment;
              vm.selected_disease.url = vm.infoSiniestro.accidente.padecimiento
                ? vm.infoSiniestro.accidente.padecimiento.url
                : "";
              // vm.infoSiniestro.accidente.padecimiento.val=vm.infoSiniestro.accidente.ailment
              vm.hospital.val = vm.infoSiniestro.accidente.hospital;

              //Obetener la informacion del contratante
              if (vm.infoSiniestro.poliza.contractor) {
                $http
                  .get(vm.infoSiniestro.poliza.contractor)
                  .then(function (contratante) {
                    vm.infoSiniestro.contratante_address =
                      contratante.data.address_contractor[0].route +
                      " " +
                      contratante.data.address_contractor[0].street_number +
                      " int" +
                      contratante.data.address_contractor[0].street_number_int +
                      " " +
                      contratante.data.address_contractor[0]
                        .administrative_area_level_2 +
                      "," +
                      contratante.data.address_contractor[0]
                        .administrative_area_level_1;
                    vm.infoSiniestro.contratante_name =
                      contratante.data.full_name;
                  });
              } else {
                //buscar la informacion del contratante si es un certificado
                $http
                  .get(
                    url.IP +
                      "leer-polizas-edit/" +
                      vm.infoSiniestro.poliza.id +
                      "/"
                  )
                  .then(function (policy) {
                    if (policy.data.parent.parent.contractor) {
                      var name = policy.data.parent.parent.contractor;
                      //console.log("nat_parent1",name)
                      vm.infoSiniestro.contratante_name =
                        name.first_name +
                        " " +
                        name.last_name +
                        " " +
                        name.second_last_name;
                      vm.infoSiniestro.contratante_address =
                        name.address_contractor[0].route +
                        " #" +
                        name.address_contractor[0].street_number +
                        " " +
                        name.address_contractor[0].administrative_area_level_2 +
                        " " +
                        name.address_contractor[0].administrative_area_level_1;
                    } else if (policy.data.parent.parent.parent.contractor) {
                      var name = policy.data.parent.parent.parent.contractor;
                      vm.infoSiniestro.contratante_name =
                        name.first_name +
                        " " +
                        name.last_name +
                        " " +
                        name.second_last_name;
                      vm.infoSiniestro.contratante_address =
                        name.address_contractor[0].route +
                        " #" +
                        name.address_contractor[0].street_number +
                        " " +
                        name.address_contractor[0].administrative_area_level_2 +
                        " " +
                        name.address_contractor[0].administrative_area_level_1;
                    }

                    if (policy.data.parent.parent.aseguradora) {
                      vm.infoSiniestro.aseguradora = {
                        aseguradora_name: policy.data.parent.parent.aseguradora,
                      };
                    } else if (policy.data.parent.parent.parent.aseguradora) {
                      vm.infoSiniestro.aseguradora = {
                        aseguradora_name:
                          policy.data.parent.parent.parent.aseguradora,
                      };
                    }
                  });
              }

              //obtener el estado
              if (vm.infoSiniestro.siniestro.state) {
                $http
                  .get(vm.infoSiniestro.siniestro.state)
                  .then(function (estado) {
                    for (var i in vm.statesArray) {
                      if (vm.statesArray[i].id == estado.data.id) {
                        vm.infoSiniestro.siniestro.state = vm.statesArray[i];
                        vm.ciudades_estados();
                      }
                    }
                  });
              }
              //obtener la ciudad
              if (vm.infoSiniestro.siniestro.city) {
                $http
                  .get(vm.infoSiniestro.siniestro.city)
                  .then(function (ciudad) {
                    vm.infoSiniestro.siniestro.city = ciudad.data.url;
                  });
              }

              //obtener el subramo de la poliza
              ramoService
                .getSubramoById(vm.infoSiniestro.poliza.subramo)
                .then(function (res) {
                  vm.infoSiniestro.subramo = {
                    subramo_name: res.data.subramo_name,
                    url: res.data.url,
                  };
                });

              if (vm.infoSiniestro.poliza.paquete) {
                //obtener informacion sonbre el paquete o plan de la poliza
                packageService
                  .getOnlyPackageById(vm.infoSiniestro.poliza.paquete)
                  .then(function (paquete) {
                    vm.infoSiniestro.paquete = {
                      package_name: paquete.data.package_name,
                      url: paquete.data.url,
                    };
                  });
              }
              //Obtener la informacion de la aseguradora
              if (vm.infoSiniestro.poliza.aseguradora) {
                providerService
                  .getProviderById(vm.infoSiniestro.poliza.aseguradora)
                  .then(function (aseguradora) {
                    vm.infoSiniestro.aseguradora = {
                      aseguradora_name: aseguradora.data.alias,
                      url: aseguradora.data.url,
                    };
                  });
              }
              //Obtener las facturas del siniestro
              $scope.active = 0;
              vm.infoSiniestro.facturas.forEach(function (factura) {
                factura.fecha_factura = datesFactory.convertDate(
                  factura.fecha_factura
                );
                var obj = {
                  f_number: factura.numero_factura,
                  proovedor: factura.proveedor,
                  f_date: factura.fecha_factura,
                  import: parseFloat(factura.importe),
                  iva: parseFloat(factura.iva),
                  total: parseFloat(factura.total),
                  procedente: parseFloat(factura.procedente),
                  url: factura.url,
                  serie: factura.serie,
                  observaciones: factura.observaciones,
                  concepto: factura.concepto,
                };
                vm.facturas.push(obj);
              });

              //formato para las fechas de vigencia
              vm.infoSiniestro.poliza.start_of_validity =
                datesFactory.convertDate(
                  vm.infoSiniestro.poliza.start_of_validity
                );
              vm.infoSiniestro.poliza.end_of_validity =
                datesFactory.convertDate(
                  vm.infoSiniestro.poliza.end_of_validity
                );
              //formato para la fecha de ciurgia
              vm.infoSiniestro.accidente.fecha_cirugia =
                datesFactory.convertDate(
                  vm.infoSiniestro.accidente.fecha_cirugia
                );
              //formato para la fecha de compromiso
              vm.infoSiniestro.siniestro.fecha_compromiso =
                datesFactory.convertDate(
                  vm.infoSiniestro.siniestro.fecha_compromiso
                );
              //Si doc_type es poliza o certificado
              if (
                vm.infoSiniestro.poliza.document_type == 1 ||
                vm.infoSiniestro.poliza.document_type == 6
              ) {
                var type_relationship = vm.infoSiniestro.accidente.relationship;
                //asignar el texto del tipo de relacion
                switch (type_relationship) {
                  case 1:
                    vm.infoSiniestro.relationship = "Titular";
                    break;
                  case 2:
                    vm.infoSiniestro.relationship = "Conyugue";
                    break;
                  case 3:
                    vm.infoSiniestro.relationship = "Hijo";
                    break;
                  case 4:
                    vm.infoSiniestro.relationship = "Otro";
                  default:
                    break;
                }

                //fortato para las fecha de nacimiento
                if (vm.infoSiniestro.accidente.dependiente) {
                  vm.infoSiniestro.afectado_birthdate =
                    datesFactory.convertDate(
                      vm.infoSiniestro.accidente.dependiente.birthdate
                    );
                } else {
                  vm.infoSiniestro.afectado_birthdate =
                    datesFactory.convertDate(
                      vm.infoSiniestro.accidente.titular.birthdate
                    );
                }
              } else {
                var type_relationship =
                  vm.infoSiniestro.siniestro.relationship_aux_affected;
                //asignar el texto del tipo de relacion
                switch (type_relationship) {
                  case 1:
                    vm.infoSiniestro.relationship = "Titular";
                    break;
                  case 2:
                    vm.infoSiniestro.relationship = "Conyugue";
                    break;
                  case 3:
                    vm.infoSiniestro.relationship = "Hijo";
                    break;
                  case 4:
                    vm.infoSiniestro.relationship = "Otro";
                  default:
                    break;
                }
              }

              vm.infoSiniestro.accidente.total_coaseguro = parseFloat(
                vm.infoSiniestro.accidente.total_coaseguro
              );
              vm.infoSiniestro.accidente.total_deducible = parseFloat(
                vm.infoSiniestro.accidente.total_deducible
              );
              vm.infoSiniestro.accidente.total_final = parseFloat(
                vm.infoSiniestro.accidente.total_final
              );
              vm.infoSiniestro.accidente.total_procedente = parseFloat(
                vm.infoSiniestro.accidente.total_procedente
              );
              vm.infoSiniestro.accidente.total_reclamado = parseFloat(
                vm.infoSiniestro.accidente.total_reclamado
              );

              vm.infoSiniestro.accidente.monto_hospital = parseFloat(
                vm.infoSiniestro.accidente.monto_hospital
              );
              vm.infoSiniestro.accidente.ded_hospital = parseFloat(
                vm.infoSiniestro.accidente.ded_hospital
              );
              vm.infoSiniestro.accidente.coas_hospital = parseFloat(
                vm.infoSiniestro.accidente.coas_hospital
              );
              vm.infoSiniestro.accidente.monto_honorarios = parseFloat(
                vm.infoSiniestro.accidente.monto_honorarios
              );
              vm.infoSiniestro.accidente.cirujano = parseFloat(
                vm.infoSiniestro.accidente.cirujano
              );
              vm.infoSiniestro.accidente.anestesiologo = parseFloat(
                vm.infoSiniestro.accidente.anestesiologo
              );
              vm.infoSiniestro.accidente.ayudante = parseFloat(
                vm.infoSiniestro.accidente.ayudante
              );
              vm.infoSiniestro.accidente.otros = parseFloat(
                vm.infoSiniestro.accidente.otros
              );
              vm.infoSiniestro.accidente.coas_honorarios = parseFloat(
                vm.infoSiniestro.accidente.coas_honorarios
              );
              vm.infoSiniestro.accidente.ded_honorarios = parseFloat(
                vm.infoSiniestro.accidente.ded_honorarios
              );

              $scope.calculateTotales();

              fileService
                .getFiles(
                  url.IP +
                    "siniestros/" +
                    vm.infoSiniestro.siniestro.id +
                    "/archivos/"
                )
                .then(function (files) {
                  files.forEach(function (file) {
                    vm.files.push(file);
                  });
                });
              vm.buscaPadecimientos(vm.infoSiniestro.accidente.padecimiento);
            }
            if ($localStorage.save_edition_siniestro_medical) {
              if (
                $localStorage.save_edition_siniestro_medical["id"] ==
                vm.infoSiniestro.siniestro.id
              ) {
                vm.infoSiniestro.siniestro.numero_siniestro =
                  $localStorage.save_edition_siniestro_medical &&
                  $localStorage.save_edition_siniestro_medical[
                    "numero_siniestro"
                  ]
                    ? $localStorage.save_edition_siniestro_medical[
                        "numero_siniestro"
                      ]
                    : "";
                vm.infoSiniestro.accidente.razon_siniestro =
                  $localStorage.save_edition_siniestro_medical &&
                  $localStorage.save_edition_siniestro_medical[
                    "razon_siniestro"
                  ]
                    ? $localStorage.save_edition_siniestro_medical[
                        "razon_siniestro"
                      ]
                    : 0;
                vm.infoSiniestro.siniestro.status =
                  $localStorage.save_edition_siniestro_medical &&
                  $localStorage.save_edition_siniestro_medical["status"]
                    ? $localStorage.save_edition_siniestro_medical["status"]
                    : 0;
                vm.selected_disease =
                  $localStorage.save_edition_siniestro_medical &&
                  $localStorage.save_edition_siniestro_medical[
                    "selected_disease"
                  ]
                    ? $localStorage.save_edition_siniestro_medical[
                        "selected_disease"
                      ]
                    : 0;
                vm.infoSiniestro.accidente.tipo_pago =
                  $localStorage.save_edition_siniestro_medical &&
                  $localStorage.save_edition_siniestro_medical["tipo_pago"]
                    ? $localStorage.save_edition_siniestro_medical["tipo_pago"]
                    : 0;
                vm.infoSiniestro.siniestro.state =
                  $localStorage.save_edition_siniestro_medical &&
                  $localStorage.save_edition_siniestro_medical["state"]
                    ? $localStorage.save_edition_siniestro_medical["state"]
                    : 0;
                vm.infoSiniestro.siniestro.city =
                  $localStorage.save_edition_siniestro_medical &&
                  $localStorage.save_edition_siniestro_medical["city"]
                    ? $localStorage.save_edition_siniestro_medical["city"]
                    : 0;
                vm.infoSiniestro.siniestro.selected_disease =
                  $localStorage.save_edition_siniestro_medical &&
                  $localStorage.save_edition_siniestro_medical["observations"]
                    ? $localStorage.save_edition_siniestro_medical[
                        "observations"
                      ]
                    : 0;
              }
            }
          },
          function error(err) {
            console.log(err);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
      //permisos
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Archivos") {
            vm.permarch = perm;
            vm.permarch.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  vm.permiso_administrar_adjuntos = true;
                } else {
                  vm.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
        });
      }
    }

    $scope.save_info_tab = function () {
      $localStorage.save_edition_siniestro_medical = angular.copy(
        vm.infoSiniestro.siniestro
      );
      $localStorage.save_edition_siniestro_medical["numero_siniestro"] =
        vm.infoSiniestro.siniestro.numero_siniestro;
      $localStorage.save_edition_siniestro_medical["razon_siniestro"] =
        vm.infoSiniestro.accidente.razon_siniestro;
      $localStorage.save_edition_siniestro_medical["status"] =
        vm.infoSiniestro.siniestro.status;
      $localStorage.save_edition_siniestro_medical["selected_disease"] =
        vm.selected_disease;
      $localStorage.save_edition_siniestro_medical["tipo_pago"] =
        vm.infoSiniestro.accidente.tipo_pago;
      $localStorage.save_edition_siniestro_medical["state"] =
        vm.infoSiniestro.siniestro.state;
      $localStorage.save_edition_siniestro_medical["city"] =
        vm.infoSiniestro.siniestro.city;
      $localStorage.save_edition_siniestro_medical["observations"] =
        vm.infoSiniestro.siniestro.observations;
    };

    function updateHospital(item) {
      vm.hospitals = [];
      var padeString = item.val;
      if (padeString.length >= 3) {
        var padeString_ = padeString.split(" ").join("_");
        $http
          .get(url.IP + "hospitales-by-substring/" + padeString_)
          .then(function (data) {
            if (data.data.length) {
              vm.hospitals = [];

              data.data.forEach(function (hosp) {
                vm.hospitals.push({
                  label: hosp.descr,
                  value: { id: hosp.id, url: hosp.url },
                });
                vm.buscarEnfermedad = false;
              });
            }
          })
          .catch(function (err) {});
      }

      if (padeString.length <= 3 && !vm.buscarEnfermedad) {
        vm.hospitals = [];
        vm.buscarEnfermedad = true;
      }
    }

    //FUNCION PARA ACTUALIZAR LA INFO DE LOS SINIESTROS
    function updateSiniestro() {
      if (
        vm.facturas.length == 0 &&
        vm.infoSiniestro.siniestro.status == 3 &&
        vm.infoSiniestro.accidente.tipo_pago == 1
      ) {
        SweetAlert.swal(
          "Facturación",
          "No existen facturas, agréguelas para continuar",
          "warning"
        );
        return;
      }
      var continuar = false;

      var model;
      //formato de fecha
      var fecha_ingreso_formato = toDate(
        vm.infoSiniestro.siniestro.fecha_ingreso
      );
      var fecha_terminacion_formato = toDate(
        vm.infoSiniestro.siniestro.fecha_terminacion
      );
      var fecha_siniestro_formato = toDate(
        vm.infoSiniestro.siniestro.fecha_siniestro
      );
      var fecha_comprimiso_formato = toDate(
        vm.infoSiniestro.siniestro.fecha_compromiso
      );
      var fecha_fecha = toDate(vm.infoSiniestro.siniestro.fecha); //fecha de ingreso

      //Objeto con la informacion del siniestro
      var obj_siniestro = {
        status: vm.infoSiniestro.siniestro.status,
        fecha_siniestro: fecha_siniestro_formato,
        tipo_siniestro_general:
          vm.infoSiniestro.siniestro.tipo_siniestro_general,
        observations: vm.infoSiniestro.siniestro.observations,
        numero_siniestro: vm.infoSiniestro.siniestro.numero_siniestro,
        fecha_compromiso: fecha_comprimiso_formato,
        folio_compania: vm.infoSiniestro.siniestro.folio_compania,
        fecha: fecha_fecha, //fecha de ingreso
        fecha_ingreso: fecha_ingreso_formato,
        fecha_terminacion: fecha_terminacion_formato,
      };

      //si el siniestro
      if (vm.infoSiniestro.siniestro.state) {
        obj_siniestro.state = vm.infoSiniestro.siniestro.state.url;
      }

      if (vm.infoSiniestro.siniestro.city) {
        obj_siniestro.city = vm.infoSiniestro.siniestro.city;
      }
      //objeto con la info de accidente
      var obj_accidente = {
        tipo_pago: vm.infoSiniestro.accidente.tipo_pago,
        razon_siniestro: vm.infoSiniestro.accidente.razon_siniestro,
      };

      //Si el estatus del sisniestro es 'en tramite'
      if (vm.infoSiniestro.siniestro.status == 2) {
        obj_siniestro.fecha_compromiso = fecha_comprimiso_formato;
        obj_siniestro.folio_compania =
          vm.infoSiniestro.siniestro.folio_compania;
      } //si el status del siniestro es "cancelado"
      else if (vm.infoSiniestro.siniestro.status == 4) {
        obj_siniestro.reason = vm.infoSiniestro.siniestro.reason;
      } //si el estatus del siniestro es 'rechazado'
      else if (vm.infoSiniestro.siniestro.status == 5) {
        obj_siniestro.observations = vm.infoSiniestro.siniestro.observations;
      }
      if (vm.infoSiniestro.poliza.document_type == 3) {
        continuar = false;
        if (vm.certificado_) {
          SweetAlert.swal(
            {
              title:
                "El siniestro inicialmente se creo a una Colectividad: " +
                vm.infoSiniestro.poliza.poliza_number,
              text:
                "¿Reasignar al certificado : " +
                vm.certificado_.certificate_number +
                "?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Si",
              cancelButtonText: "No",
              closeOnConfirm: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                obj_siniestro.poliza = vm.certificado_.url;
                obj_siniestro.aux_affected =
                  vm.certificado_.accidents_policy[0].personal.full_name;
                continuar = true;
                $scope.saveChangesSiniester(obj_siniestro);
              } else {
                obj_siniestro = obj_siniestro;
                $scope.saveChangesSiniester(obj_siniestro);
                continuar = true;
              }
            }
          );
        } else {
          SweetAlert.swal(
            "Información",
            "El siniestro esta asiganado a una Carátula, no ha selecionado un Afectado válido",
            "warning"
          );
          continuar = true;
          $scope.saveChangesSiniester(obj_siniestro);
        }
      } else {
        continuar = true;
        obj_siniestro = obj_siniestro;
        $scope.saveChangesSiniester(obj_siniestro);
      }
      //EDICION DE LA INFORMACIÓN DEL SINIESTRO
      if (continuar) {
        // $http.patch(vm.infoSiniestro.siniestro.url,obj_siniestro).then(function(siniestro){
        //     if(siniestro.status === 200 || siniestro.status === 201){
        //         uploadFiles(siniestro.data.id, $scope.padecimiento_type);
        //         // Editar las facturas del siniestro
        //         vm.facturas.forEach(function(factura, index) {
        //             if(!factura.import){
        //                 factura.import = 0.0;
        //             }
        //             if(!factura.iva){
        //                 factura.iva = 0.0;
        //             }
        //             if(!factura.total){
        //                 factura.total = 0.0;
        //             }
        //             //Si el estatus del siniestro es completado, entonces agrega el procedente de la factura
        //             if(siniestro.data.status == 3){
        //                 var obj_factura={
        //                     siniestro: siniestro.data.url,
        //                     numero_factura: factura.f_number,
        //                     proveedor:factura.proovedor,
        //                     fecha_factura: factura.f_date ? toDate(factura.f_date) : null,
        //                     importe:factura.import.toFixed(2),
        //                     iva:factura.iva.toFixed(2),
        //                     total:factura.total,
        //                     concepto:factura.concepto,
        //                     procedente:factura.procedente ? parseFloat(factura.procedente).toFixed(2): 0
        //                 }
        //             }
        //             //si el siniestro es distinto a completado no incluye el procedente por factura
        //             else{
        //                 var obj_factura={
        //                     siniestro: siniestro.data.url,
        //                     numero_factura: factura.f_number,
        //                     proveedor:factura.proovedor,
        //                     fecha_factura:factura.f_date ? toDate(factura.f_date) : null,
        //                     importe:factura.import.toFixed(2),
        //                     iva:factura.iva.toFixed(2),
        //                     total:factura.total,
        //                     concepto:factura.concepto
        //                 }
        //             }
        //             if(factura.url){
        //                 $http.patch(factura.url,obj_factura).then(function(facturax) {
        //                     if (facturax) {
        //                         var params = {
        //                           'model': 5,
        //                           'event': "PATCH",
        //                           'associated_id': siniestro.data.id,
        //                           'identifier': "actualizo facturas  del siniestro" + vm.infoSiniestro.siniestro.numero_siniestro
        //                         }
        //                         dataFactory.post('send-log/', params).then(function success(response) {
        //                         });
        //                     }
        //                 });
        //             }
        //             else{
        //                  $http.post(url.IP+'facturas/',obj_factura).then(function(facturax) {
        //                     if (facturax) {
        //                         var params = {
        //                           'model': 5,
        //                           'event': "POST",
        //                           'associated_id': siniestro.data.id,
        //                           'identifier': "creo facturas al Siniestro "
        //                         }
        //                         dataFactory.post('send-log/', params).then(function success(response) {
        //                         });
        //                     }
        //                 });
        //             }
        //         });
        //         obj_accidente.total_reclamado=vm.infoSiniestro.accidente.total_reclamado;
        //         //si el tipo de status es completado, pide los datos faltantes
        //         if(siniestro.data.status == 3){
        //             model = 4;
        //             obj_accidente.total_procedente = vm.infoSiniestro.accidente.total_procedente;
        //             obj_accidente.total_coaseguro = vm.infoSiniestro.accidente.total_coaseguro;
        //             obj_accidente.total_deducible = vm.infoSiniestro.accidente.total_deducible
        //             obj_accidente.total_procedente = vm.infoSiniestro.accidente.total_procedente;
        //             if(obj_accidente.total_procedente && obj_accidente.total_coaseguro && obj_accidente.total_deducible ){
        //                 var total_final_pre = 0;
        //                 total_final_pre = obj_accidente.total_procedente - obj_accidente.total_coaseguro - obj_accidente.total_deducible;
        //                 obj_accidente.total_final = parseFloat(total_final_pre).toFixed(2);
        //             }
        //             //if(obj_accidente.tipo_pago != 1){
        //                 //si el tipo de pago es pago directo agrega los campos de hospital ...
        //                 if (vm.infoSiniestro.accidente.tipo_pago == 3){
        //                     var fecha_cirugia_formato = toDate(vm.infoSiniestro.accidente.fecha_cirugia);
        //                     obj_accidente.hospital = vm.infoSiniestro.accidente.hospital;
        //                     obj_accidente.fecha_cirugia = fecha_cirugia_formato;
        //                     obj_accidente.monto_hospital = vm.infoSiniestro.accidente.monto_hospital;
        //                     obj_accidente.ded_hospital = vm.infoSiniestro.accidente.ded_hospital;
        //                     obj_accidente.coas_hospital = vm.infoSiniestro.accidente.coas_hospital;
        //                     obj_accidente.monto_honorarios = vm.infoSiniestro.accidente.monto_honorarios;
        //                     obj_accidente.cirujano = vm.infoSiniestro.accidente.cirujano;
        //                     obj_accidente.anestesiologo = vm.infoSiniestro.accidente.anestesiologo;
        //                     obj_accidente.ayudante = vm.infoSiniestro.accidente.ayudante;
        //                     obj_accidente.otros = vm.infoSiniestro.accidente.otros;
        //                     obj_accidente.coas_honorarios = vm.infoSiniestro.accidente.coas_honorarios;
        //                     obj_accidente.ded_honorarios = vm.infoSiniestro.accidente.ded_honorarios;
        //                 }
        //             //}
        //             //Log de siniestro
        //             $scope.idSiniestro = siniestro.data.id
        //             var params = {
        //                 'model': 5,
        //                 'event': "PATCH",
        //                 'associated_id': $scope.idSiniestro,
        //                 'identifier': "actualizo un siniestro estatus Completado"
        //             }
        //             dataFactory.post('send-log/', params).then(function success(response) {});
        //         }
        //         //si el estatus es en tramite manda un log
        //         else if (siniestro.data.status == 2){
        //             model = 11;
        //             //Log de siniestro
        //             $scope.idSiniestro = siniestro.data.id
        //             var params = {
        //                 'model': 5,
        //                 'event': "PATCH",
        //                 'associated_id': $scope.idSiniestro,
        //                 'identifier': "actualizó un siniestro estatus En trámite"
        //             }
        //             dataFactory.post('send-log/', params).then(function success(response) {});
        //         }
        //         //si el estatus es cancelado manda un log
        //         else if (siniestro.data.status == 4){
        //             model = 14;
        //             //Log de siniestro
        //             $scope.idSiniestro = siniestro.data.id
        //             var params = {
        //                 'model': 5,
        //                 'event': "PATCH",
        //                 'associated_id': $scope.idSiniestro,
        //                 'identifier': "actualizó un siniestro estatus Cancelado"
        //             }
        //             dataFactory.post('send-log/', params).then(function success(response) {});
        //         }
        //         //si el estatus es rechazado manda un log
        //         else if (siniestro.data.status == 5){
        //             model = 13;
        //             //Log de siniestro
        //             $scope.idSiniestro = siniestro.data.id
        //             var params = {
        //                 'model': 5,
        //                 'event': "PATCH",
        //                 'associated_id': $scope.idSiniestro,
        //                 'identifier': "actualizó un siniestro estatus Rechazado"
        //             }
        //             dataFactory.post('send-log/', params).then(function success(response) {});
        //         }
        //         //si el estatus es en espera manda un log
        //         else if (siniestro.data.status == 6){
        //             model = 14;
        //             //Log de siniestro
        //             $scope.idSiniestro = siniestro.data.id
        //             var params = {
        //                 'model': 5,
        //                 'event': "PATCH",
        //                 'associated_id': $scope.idSiniestro,
        //                 'identifier': "actualizó un siniestro estatus En espera"
        //             }
        //             dataFactory.post('send-log/', params).then(function success(response) {});
        //         }
        //         //ENVIAR CORREOS CUANDO SE ACTUALIZA LA INFORMACION
        //        if (vm.infoSiniestro.poliza.natural)
        //        {
        //             $scope.idSiniestro = siniestro.data.id;
        //             $http.get(vm.infoSiniestro.poliza.natural)
        //                 .then(function(response) {
        //                     if(response.data.email){
        //                         //console.log($localStorage)
        //                         if($localStorage.email_config){
        //                             if($localStorage.email_config.tramite_siniestro == true){
        //                                 emailService.sendEmailAtm(model,siniestro.data.id)
        //                            }
        //                         }
        //                     }
        //                 });
        //         }
        //         else if (vm.infoSiniestro.poliza.juridical)
        //         {
        //             $http.get(vm.infoSiniestro.poliza.juridical)
        //                 .then(function(response) {
        //                     if(response.data.email){
        //                         if($localStorage.email_config){
        //                             if($localStorage.email_config.tramite_siniestro == true){
        //                                 var model = 11;
        //                                 emailService.sendEmailAtm(model,$scope.idSiniestro)
        //                             }
        //                         }
        //                     }
        //                 });
        //             }
        //         if(vm.selected_disease){
        //             //console.log(vm.selected_disease)
        //             if(vm.selected_disease.value){
        //                 //console.log("editar",vm.selected_disease)
        //                 obj_accidente.padecimiento = vm.selected_disease.value.url;
        //                 obj_accidente.ailment = vm.selected_disease.value.label;
        //             }
        //             else{
        //                 obj_accidente.ailment = vm.selected_disease.val;
        //                 //obj_accidente.padecimiento = null
        //             }
        //         }
        //         //Solo se pueden editar los totales cuando el estatus no esta en completado
        //         $http.patch(vm.infoSiniestro.accidente.url,obj_accidente).then(function(accidente) {
        //             if ((accidente.status == 200) || (accidente.status == 201)){
        //                 vm.infoSiniestro.accidente.contact_accidente.forEach(function(contact) {
        //                     contact.accidente = vm.infoSiniestro.accidente.url;
        //                     if(!contact.url){
        //                         contactService.createContact(contact);
        //                     }else{
        //                         contactService.updateContact(contact);
        //                     }
        //                 });
        //                 //fillTable(2);
        //                 SweetAlert.swal("¡Listo!",MESSAGES.OK.SINIESTERUPDATED ,"success");
        //                 var params = {
        //                   'model': 5,
        //                   'event': "PATCH",
        //                   'associated_id': $scope.idSiniestro,
        //                   'identifier': "actualizo el siniestro " + vm.infoSiniestro.siniestro.numero_siniestro
        //                 }
        //                 dataFactory.post('send-log/', params).then(function success(response) {
        //                 });
        //                 $state.go('siniestros.lista');
        //             }
        //             else{
        //                 SweetAlert.swal('Error','Ha ocurrido un error','error');
        //             }
        //         });
        //     }
        // })
      }
      //console.log(obj_siniestro)
    }
    $scope.saveChangesSiniester = function (obj_siniestro) {
      var obj_accidente = {
        tipo_pago: vm.infoSiniestro.accidente.tipo_pago,
        razon_siniestro: vm.infoSiniestro.accidente.razon_siniestro,
      };
      var model = "";
      // aqui se actualiza
      if (vm.facturas.length > 0) {
        var accidentes = true;
      } else {
        var accidentes = false;
      }

      obj_siniestro.accidentes = accidentes;
      $http
        .patch(vm.infoSiniestro.siniestro.url, obj_siniestro)
        .then(function (siniestro) {
          if (siniestro.status === 200 || siniestro.status === 201) {
            $scope.obj_final = siniestro.data;

            uploadFiles(siniestro.data.id, $scope.padecimiento_type);
            // Editar las facturas del siniestro
            vm.facturas.forEach(function (factura, index) {
              if (!factura.import) {
                factura.import = 0.0;
              }
              if (!factura.iva) {
                factura.iva = 0.0;
              }
              if (!factura.total) {
                factura.total = 0.0;
              }

              //Si el estatus del siniestro es completado, entonces agrega el procedente de la factura
              if (siniestro.data.status == 3) {
                var obj_factura = {
                  siniestro: siniestro.data.url,
                  numero_factura: factura.f_number,
                  proveedor: factura.proovedor,
                  fecha_factura: factura.f_date ? toDate(factura.f_date) : null,
                  importe: factura.import.toFixed(2),
                  iva: factura.iva.toFixed(2),
                  total: factura.total,
                  concepto: factura.concepto,
                  procedente: factura.procedente
                    ? parseFloat(factura.procedente).toFixed(2)
                    : 0,
                };
              }
              //si el siniestro es distinto a completado no incluye el procedente por factura
              else {
                var obj_factura = {
                  siniestro: siniestro.data.url,
                  numero_factura: factura.f_number,
                  proveedor: factura.proovedor,
                  fecha_factura: factura.f_date ? toDate(factura.f_date) : null,
                  importe: factura.import.toFixed(2),
                  iva: factura.iva.toFixed(2),
                  total: factura.total,
                  concepto: factura.concepto,
                };
              }

              if (factura.url) {
                $http.patch(factura.url, obj_factura).then(function (facturax) {
                  if (facturax) {
                    var params = {
                      model: 5,
                      event: "PATCH",
                      associated_id: siniestro.data.id,
                      identifier:
                        "actualizo facturas  del siniestro" +
                        vm.infoSiniestro.siniestro.numero_siniestro,
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                  }
                });
              } else {
                $http
                  .post(url.IP + "facturas/", obj_factura)
                  .then(function (facturax) {
                    if (facturax) {
                      var params = {
                        model: 5,
                        event: "POST",
                        associated_id: siniestro.data.id,
                        identifier: "creo facturas al Siniestro ",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                    }
                  });
              }
            });

            try {
              obj_accidente.total_reclamado = parseFloat(
                vm.infoSiniestro.accidente.total_reclamado
              ).toFixed(2);
            } catch (err) {
              obj_accidente.total_reclamado =
                vm.infoSiniestro.accidente.total_reclamado;
            }
            //si el tipo de status es completado, pide los datos faltantes

            if (siniestro.data.status == 3) {
              model = 4;

              obj_accidente.total_procedente =
                vm.infoSiniestro.accidente.total_procedente;
              obj_accidente.total_coaseguro =
                vm.infoSiniestro.accidente.total_coaseguro;
              obj_accidente.total_deducible =
                vm.infoSiniestro.accidente.total_deducible;
              obj_accidente.total_procedente =
                vm.infoSiniestro.accidente.total_procedente;
              if (obj_accidente.total_procedente) {
                obj_accidente.total_procedente = parseFloat(
                  obj_accidente.total_procedente
                );
              } else {
                obj_accidente.total_procedente = 0;
              }
              if (obj_accidente.total_coaseguro) {
                obj_accidente.total_coaseguro = parseFloat(
                  obj_accidente.total_coaseguro
                );
              } else {
                obj_accidente.total_coaseguro = 0;
              }
              if (obj_accidente.total_deducible) {
                obj_accidente.total_deducible = parseFloat(
                  obj_accidente.total_deducible
                );
              } else {
                obj_accidente.total_deducible = 0;
              }
              var total_final_pre = 0;
              total_final_pre =
                obj_accidente.total_procedente -
                obj_accidente.total_coaseguro -
                obj_accidente.total_deducible;
              obj_accidente.total_final =
                parseFloat(total_final_pre).toFixed(2);
              // }
              //if(obj_accidente.tipo_pago != 1){
              //si el tipo de pago es pago directo agrega los campos de hospital ...
              if (
                vm.infoSiniestro.accidente.tipo_pago == 3 ||
                vm.infoSiniestro.accidente.tipo_pago == 2
              ) {
                try {
                  var fecha_cirugia_formato = toDate(
                    vm.infoSiniestro.accidente.fecha_cirugia
                  );
                  obj_accidente.hospital =
                    vm.hospital && vm.hospital.val ? vm.hospital.val : "";
                  obj_accidente.fecha_cirugia = fecha_cirugia_formato
                    ? fecha_cirugia_formato
                    : new Date();
                  obj_accidente.monto_hospital = vm.infoSiniestro.accidente
                    .monto_hospital
                    ? vm.infoSiniestro.accidente.monto_hospital
                    : 0;
                  obj_accidente.ded_hospital = vm.infoSiniestro.accidente
                    .ded_hospital
                    ? vm.infoSiniestro.accidente.ded_hospital
                    : 0;
                  obj_accidente.coas_hospital = vm.infoSiniestro.accidente
                    .coas_hospital
                    ? vm.infoSiniestro.accidente.coas_hospital
                    : 0;
                  obj_accidente.monto_honorarios = vm.infoSiniestro.accidente
                    .monto_honorarios
                    ? vm.infoSiniestro.accidente.monto_honorarios
                    : 0;
                  obj_accidente.cirujano = vm.infoSiniestro.accidente.cirujano
                    ? vm.infoSiniestro.accidente.cirujano
                    : 0;
                  obj_accidente.anestesiologo = vm.infoSiniestro.accidente
                    .anestesiologo
                    ? vm.infoSiniestro.accidente.anestesiologo
                    : 0;
                  obj_accidente.ayudante = vm.infoSiniestro.accidente.ayudante
                    ? vm.infoSiniestro.accidente.ayudante
                    : 0;
                  obj_accidente.otros = vm.infoSiniestro.accidente.otros
                    ? vm.infoSiniestro.accidente.otros
                    : 0;
                  obj_accidente.coas_honorarios = vm.infoSiniestro.accidente
                    .coas_honorarios
                    ? vm.infoSiniestro.accidente.coas_honorarios
                    : 0;
                  obj_accidente.ded_honorarios = vm.infoSiniestro.accidente
                    .ded_honorarios
                    ? vm.infoSiniestro.accidente.ded_honorarios
                    : 0;
                } catch (i) {
                  console.log("error accidente", i);
                }
              }
              //}
              //Log de siniestro
              $scope.idSiniestro = siniestro.data.id;
              var params = {
                model: 5,
                event: "PATCH",
                associated_id: $scope.idSiniestro,
                identifier: "actualizo un siniestro estatus Completado",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }
            //si el estatus es en tramite manda un log
            else if (siniestro.data.status == 2) {
              model = 11;
              //Log de siniestro
              $scope.idSiniestro = siniestro.data.id;
              var params = {
                model: 5,
                event: "PATCH",
                associated_id: $scope.idSiniestro,
                identifier: "actualizó un siniestro estatus En trámite",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }
            //si el estatus es cancelado manda un log
            else if (siniestro.data.status == 4) {
              model = 14;
              //Log de siniestro
              $scope.idSiniestro = siniestro.data.id;
              var params = {
                model: 5,
                event: "PATCH",
                associated_id: $scope.idSiniestro,
                identifier: "actualizó un siniestro estatus Cancelado",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }
            //si el estatus es rechazado manda un log
            else if (siniestro.data.status == 5) {
              model = 13;
              //Log de siniestro
              $scope.idSiniestro = siniestro.data.id;
              var params = {
                model: 5,
                event: "PATCH",
                associated_id: $scope.idSiniestro,
                identifier: "actualizó un siniestro estatus Rechazado",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }
            //si el estatus es en espera manda un log
            else if (siniestro.data.status == 6) {
              model = 14;
              //Log de siniestro
              $scope.idSiniestro = siniestro.data.id;
              var params = {
                model: 5,
                event: "PATCH",
                associated_id: $scope.idSiniestro,
                identifier: "actualizó un siniestro estatus En espera",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }

            //ENVIAR CORREOS CUANDO SE ACTUALIZA LA INFORMACION
            //    if (vm.infoSiniestro.poliza.contractor)
            //    {
            //         $scope.idSiniestro = siniestro.data.id;
            //         $http.get(vm.infoSiniestro.poliza.contractor)
            //             .then(function(response) {
            //                 if(response.data.email){
            //                     //console.log($localStorage)
            //                     if($localStorage.email_config){
            //                         if($localStorage.email_config.tramite_siniestro == true){
            //                             emailService.sendEmailAtm(model,siniestro.data.id)
            //                        }
            //                     }
            //                 }
            //             });
            //     }
            if (vm.selected_disease) {
              if (vm.selected_disease.value) {
                obj_accidente.padecimiento = vm.selected_disease.value.url;
                obj_accidente.ailment = vm.selected_disease.value.label;
              } else {
                obj_accidente.ailment = vm.selected_disease.val;
                //obj_accidente.padecimiento = null
              }
            }

            //Solo se pueden editar los totales cuando el estatus no esta en completado
            if (vm.certificado_) {
              obj_accidente.affected_full_name =
                vm.certificado_.accidents_policy[0].personal.full_name;
            }
            if ($scope.obj_original.status != $scope.obj_final.status) {
              obj_accidente.send_email = true;
            } else {
              obj_accidente.send_email = false;
            }
            $http
              .patch(vm.infoSiniestro.accidente.url, obj_accidente)
              .then(function (accidente) {
                if (accidente.status == 200 || accidente.status == 201) {
                  vm.infoSiniestro.accidente.contact_accidente.forEach(
                    function (contact) {
                      contact.accidente = vm.infoSiniestro.accidente.url;
                      if (!contact.url) {
                        contactService.createContact(contact);
                      } else {
                        contactService.updateContact(contact);
                      }
                    }
                  );

                  //fillTable(2);
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.SINIESTERUPDATED,
                    "success"
                  );
                  var params = {
                    model: 5,
                    event: "PATCH",
                    associated_id: $scope.idSiniestro,
                    identifier:
                      "actualizo el siniestro " +
                      vm.infoSiniestro.siniestro.numero_siniestro,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  $state.go("siniestros.info", {
                    siniestroId: $scope.idSiniestro
                      ? $scope.idSiniestro
                      : vm.infoSiniestro.siniestro.id,
                  });
                } else {
                  SweetAlert.swal("Error", "Ha ocurrido un error", "error");
                }
              });
          }
        });
    };
    //FUNCION PARA AGREGAR FILAS A LA TABLA DE FACTURAS
    function addFactura() {
      var factura = {
        f_number: "",
        proovedor: "",
        f_date: "",
        import: "",
        iva: "",
        total: "",
        procedente: 0,
      };
      vm.facturas.push(factura);
    }
    //CALCULAR EL IVA DE LAS FACTURAS
    $scope.calculateIva = function (index, item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.facturas[index].import = 0;
        } else {
          vm.facturas[index].import = parseFloat(
            vm.facturas[index].import
          ).toFixed(2);
        }
        vm.facturas[index].import = parseFloat(vm.facturas[index].import);
        vm.facturas[index].iva = (
          parseFloat(vm.facturas[index].import) * 0.16
        ).toFixed(2);
        vm.facturas[index].iva = parseFloat(vm.facturas[index].iva);
        vm.facturas[index].total = (
          parseFloat(vm.facturas[index].import) +
          parseFloat(vm.facturas[index].iva)
        ).toFixed(2);
        vm.facturas[index].total = parseFloat(vm.facturas[index].total);
        $scope.calculateTotales();
      } else {
        vm.facturas[index].import = 0;
        vm.facturas[index].iva = 0;
        vm.facturas[index].total = 0;
      }
    };
    //CALCULAR EL TOTAL DE LA FACTURA
    $scope.calculateTotal = function (index, iva) {
      if (iva) {
        vm.facturas[index].iva = parseFloat(iva);
      } else if (iva == "") {
        vm.facturas[index].iva = 0;
      }
      if (vm.facturas[index].import) {
        vm.facturas[index].import = parseFloat(vm.facturas[index].import);
      }
      vm.facturas[index].total = (
        parseFloat(vm.facturas[index].import) +
        parseFloat(vm.facturas[index].iva)
      ).toFixed(2);
      vm.facturas[index].total = parseFloat(vm.facturas[index].total);
      $scope.calculateTotales();

      if (vm.facturas[index].procedente < 0) {
        vm.facturas[index].procedente = 0;
      } else {
        vm.facturas[index].procedente = parseFloat(
          vm.facturas[index].procedente
        ).toFixed(2);
      }
    };
    $scope.validateProcedente = function (index, item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.facturas[index].procedente = 0;
        } else {
          vm.facturas[index].procedente = parseFloat(
            vm.facturas[index].procedente
          ).toFixed(2);
          vm.facturas[index].procedente = parseFloat(
            vm.facturas[index].procedente
          );
          $scope.calculateTotales();
        }
      } else {
        vm.facturas[index].procedente = 0;
      }
    };

    //TOTAL DE TODAS LAS FACTURAS
    $scope.calculateTotales = function () {
      vm.totalImporte = 0;
      vm.totalIva = 0;
      vm.totalTotal = 0;
      vm.totalProcedente = 0;
      for (var i = 0; i < vm.facturas.length; i++) {
        vm.totalImporte = vm.totalImporte + vm.facturas[i].import;
        vm.totalIva = vm.totalIva + vm.facturas[i].iva;
        vm.totalTotal = vm.totalTotal + parseFloat(vm.facturas[i].total);
        vm.totalProcedente =
          vm.totalProcedente + parseFloat(vm.facturas[i].procedente);
      }

      vm.infoSiniestro.accidente.total_reclamado = parseFloat(
        vm.totalTotal
      ).toFixed(2);
      vm.infoSiniestro.accidente.total_procedente = parseFloat(
        vm.totalProcedente
      ).toFixed(2);
    };
    //ELIMINAR FACTURAS DE LA TABLA
    function deleteFactura(url, index, item) {
      if ((url && index) || (url && !index)) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "El registro se borrara permanentemente aunque no se hayan guardado los cambios.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, eliminar",
            cancelButtonText: "Cancelar",
            closeOnConfirm: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http.delete(url).then(function (response) {
                vm.facturas.splice(index, 1);
                $scope.calculateTotales();
                var params = {
                  model: 5,
                  event: "DELETE",
                  associated_id: vm.infoSiniestro.siniestro.id,
                  identifier:
                    "elimino facturas del sinietsro " +
                    vm.infoSiniestro.siniestro.numero_siniestro,
                };
                SweetAlert.swal(
                  "¡Eliminada!",
                  "Tu factura ha sido eliminada.",
                  "success"
                );
              });
            }
          }
        );
      } else {
        vm.facturas.splice(index, 1);
      }
    }
    //EXPORTAR EXCEL DE FACTURAS
    function downloadFacturas(siniestro) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "data:application/vnd.ms-excel;charset=UTF-8",
        }
      );
      saveAs(blob, "Concentrado_Facturas" + ".xls");
    }

    function downloadPlantillaFacturas() {
      try {
        var sample = [
          facturasExcelHeaders,
          [
            "1",
            "122",
            "Medicamentos",
            "Proveedor Ejemplo",
            "06/02/2026",
            "100",
            "16",
            "116",
            "100",
          ],
        ];
        var sheet = XLSX.utils.aoa_to_sheet(sample);
        var workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, sheet, "facturas");
        var wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "plantilla_facturas_siniestros.xlsx"
        );
      } catch (err) {
        SweetAlert.swal(
          "Error",
          "No se pudo generar la plantilla correcta: " + (err.message || err),
          "error"
        );
      }
    }

    function handleFacturasExcelFile(input) {
      if (!input || !input.files || input.files.length === 0) {
        return;
      }
      vm.importFacturasFromExcel(input.files[0]);
      input.value = "";
    }

    function importFacturasFromExcel(file) {
      if (!file) {
        return;
      }
      var reader = new FileReader();
      reader.onload = function (evt) {
        try {
          var data = new Uint8Array(evt.target.result);
          var workbook = XLSX.read(data, { type: "array" });
          var sheetName = workbook.SheetNames[0];
          if (!sheetName) {
            throw new Error("El archivo no contiene hojas.");
          }
          var rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
            header: 1,
            defval: "",
          });
          if (!rows.length) {
            throw new Error("No hay datos en el archivo.");
          }
          var headerRow = rows[0];
          var imported = [];
          rows.slice(1).forEach(function (row) {
            if (!row || row.length === 0) {
              return;
            }
            var factura = {};
            headerRow.forEach(function (column, columnIndex) {
              var key = facturasExcelColumnMap[normalizeColumnName(column)];
              if (!key) {
                return;
              }
              var value = row[columnIndex];
              if (key === "f_date" && typeof value === "number" && XLSX.SSF) {
                value = XLSX.SSF.format("dd/mm/yyyy", value);
              }
              factura[key] = value;
            });
            if (
              !factura.f_number &&
              !factura.proovedor &&
              !factura.import &&
              !factura.total
            ) {
              return;
            }
            if (!factura.serie) {
              factura.serie = vm.facturas.length + imported.length + 1;
            }
            factura.import = parseFloat(factura.import) || 0;
            factura.iva = parseFloat(factura.iva) || 0;
            factura.total = parseFloat(factura.total);
            if (isNaN(factura.total)) {
              factura.total = factura.import + factura.iva;
            }
            factura.procedente = parseFloat(factura.procedente);
            factura.procedente = isNaN(factura.procedente)
              ? 0
              : factura.procedente;
            factura.concepto = factura.concepto || "";
            factura.proovedor = factura.proovedor || "";
            factura.f_date = factura.f_date ? factura.f_date.toString() : "";
            imported.push(factura);
          });
          $scope.$applyAsync(function () {
            if (!imported.length) {
              SweetAlert.swal(
                "Importación",
                "No se encontraron filas válidas en el archivo.",
                "warning"
              );
              return;
            }
            Array.prototype.push.apply(vm.facturas, imported);
            $scope.calculateTotales();
            SweetAlert.swal(
              "Importación",
              "Se agregaron " + imported.length + " facturas desde el Excel.",
              "success"
            );
          });
        } catch (err) {
          console.error("Error importando facturas", err);
          $scope.$applyAsync(function () {
            SweetAlert.swal(
              "Error",
              "No se pudo leer el archivo: " + (err.message || err),
              "error"
            );
          });
        }
      };
      reader.readAsArrayBuffer(file);
    }

    function normalizeColumnName(value) {
      if (!value && value !== 0) {
        return "";
      }
      return value.toString().trim().toLowerCase().replace(/[.\s]/g, "");
    }

    $scope.validateTotal = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.total_procedente = 0;
        } else {
          vm.infoSiniestro.accidente.total_procedente = parseFloat(
            vm.infoSiniestro.accidente.total_procedente
          ).toFixed(2);
          vm.infoSiniestro.accidente.total_procedente = parseFloat(
            vm.infoSiniestro.accidente.total_procedente
          );
        }
      }
    };

    $scope.validateCoaseguro = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.total_coaseguro = 0;
        } else {
          vm.infoSiniestro.accidente.total_coaseguro = parseFloat(
            vm.infoSiniestro.accidente.total_coaseguro
          ).toFixed(2);
          vm.infoSiniestro.accidente.total_coaseguro = parseFloat(
            vm.infoSiniestro.accidente.total_coaseguro
          );
        }
      }
    };

    $scope.validateDeducible = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.total_deducible = 0;
        } else {
          vm.infoSiniestro.accidente.total_deducible = parseFloat(
            vm.infoSiniestro.accidente.total_deducible
          ).toFixed(2);
          vm.infoSiniestro.accidente.total_deducible = parseFloat(
            vm.infoSiniestro.accidente.total_deducible
          );
        }
      }
    };

    $scope.validateAutorizado = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.monto_hospital = 0;
        } else {
          vm.infoSiniestro.accidente.monto_hospital = parseFloat(
            vm.infoSiniestro.accidente.monto_hospital
          ).toFixed(2);
          vm.infoSiniestro.accidente.monto_hospital = parseFloat(
            vm.infoSiniestro.accidente.monto_hospital
          );
        }
      }
    };

    $scope.validateDedHospital = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.ded_hospital = 0;
        } else {
          vm.infoSiniestro.accidente.ded_hospital = parseFloat(
            vm.infoSiniestro.accidente.ded_hospital
          ).toFixed(2);
          vm.infoSiniestro.accidente.ded_hospital = parseFloat(
            vm.infoSiniestro.accidente.ded_hospital
          );
        }
      }
    };

    $scope.validateCoasHospital = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.coas_hospital = 0;
        } else {
          vm.infoSiniestro.accidente.coas_hospital = parseFloat(
            vm.infoSiniestro.accidente.coas_hospital
          ).toFixed(2);
          vm.infoSiniestro.accidente.coas_hospital = parseFloat(
            vm.infoSiniestro.accidente.coas_hospital
          );
        }
      }
    };

    $scope.validateHonorarios = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.monto_honorarios = 0;
        } else {
          vm.infoSiniestro.accidente.monto_honorarios = parseFloat(
            vm.infoSiniestro.accidente.monto_honorarios
          ).toFixed(2);
          vm.infoSiniestro.accidente.monto_honorarios = parseFloat(
            vm.infoSiniestro.accidente.monto_honorarios
          );
        }
      }
    };

    $scope.validateCirujano = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.cirujano = 0;
        } else {
          vm.infoSiniestro.accidente.cirujano = parseFloat(
            vm.infoSiniestro.accidente.cirujano
          ).toFixed(2);
          vm.infoSiniestro.accidente.cirujano = parseFloat(
            vm.infoSiniestro.accidente.cirujano
          );
        }
      }
    };
    // Afectado a certificado
    vm.getCertificate = getCertificate;
    function getCertificate(parId) {
      if (parId) {
        if (parId.val.length >= 3) {
          $http({
            method: "POST",
            url: url.IP + "get-certificatesforsiniestro/",
            data: {
              word: parId.val,
              id_collect: vm.infoSiniestro.poliza.id,
              mode: $scope.endorsement_type_manual,
            },
          })
            .then(
              function success(request) {
                //console.log(request);
                var results_cert = [];
                var mapeo_cert = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    // $scope.btnSearchDisabled = true;
                    toaster.warning("Certificado no encontrado");
                  } else {
                    // $scope.btnSearchDisabled = false;
                    toaster.success("Certificado existente");
                    request.data.forEach(function (poliza) {
                      vm.certificado_for_siniestro = poliza;
                      // vm.form.num_receipts = vm.form.num_receipts;
                      if (poliza.document_type == 6) {
                        mapeo_cert.push(poliza);
                      }
                    });
                    results_cert = _.map(mapeo_cert, function (item) {
                      if (item.contractor) {
                        var label = item.contractor ? item.contractor : "";
                        label =
                          "Certificado: " +
                          item.certificate_number +
                          "- " +
                          label +
                          " - " +
                          item.poliza_number;
                      }
                      return {
                        label: label ? label : "",
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                        url: item.url,
                        contacto: item.contacto,
                        certificate_number: item.certificate_number,
                      };
                    });
                    $scope.autocompleteDataCertificate = results_cert;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    }
    vm.getTypeCertificate = getTypeCertificate;
    function getTypeCertificate(certificado) {
      $scope.certificateForSiniestro = certificado;
      $scope.certificadoSiniestro = certificado;
      $scope.subgrupoReceipts = {};
      dataFactory
        .get("polizas/" + $scope.certificateForSiniestro.id)
        .then(function success(polizaSelected) {
          if (polizaSelected.status == 200 || polizaSelected.status == 201) {
            vm.certificado_ = polizaSelected.data;
            if (vm.certificado_.accidents_policy) {
              if (vm.certificado_.accidents_policy[0]) {
                if (vm.certificado_.accidents_policy[0].personal) {
                  $http({
                    method: "GET",
                    url: vm.certificado_.accidents_policy[0].personal,
                  }).success(function (response1) {
                    vm.certificado_.accidents_policy[0].personal = response1;
                  });
                }
              }
            }
          }
        });
    }
    // -----------------
    $scope.validateAnestesiologo = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.anestesiologo = 0;
        } else {
          vm.infoSiniestro.accidente.anestesiologo = parseFloat(
            vm.infoSiniestro.accidente.anestesiologo
          ).toFixed(2);
          vm.infoSiniestro.accidente.anestesiologo = parseFloat(
            vm.infoSiniestro.accidente.anestesiologo
          );
        }
      }
    };

    $scope.validateAyudante = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.ayudante = 0;
        } else {
          vm.infoSiniestro.accidente.ayudante = parseFloat(
            vm.infoSiniestro.accidente.ayudante
          ).toFixed(2);
          vm.infoSiniestro.accidente.ayudante = parseFloat(
            vm.infoSiniestro.accidente.ayudante
          );
        }
      }
    };

    $scope.validateOtros = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.otros = 0;
        } else {
          vm.infoSiniestro.accidente.otros = parseFloat(
            vm.infoSiniestro.accidente.otros
          ).toFixed(2);
          vm.infoSiniestro.accidente.otros = parseFloat(
            vm.infoSiniestro.accidente.otros
          );
        }
      }
    };

    $scope.validateCoasHonorarios = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.coas_honorarios = 0;
        } else {
          vm.infoSiniestro.accidente.coas_honorarios = parseFloat(
            vm.infoSiniestro.accidente.coas_honorarios
          ).toFixed(2);
          vm.infoSiniestro.accidente.coas_honorarios = parseFloat(
            vm.infoSiniestro.accidente.coas_honorarios
          );
        }
      }
    };

    $scope.validateDeduHonorarios = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.infoSiniestro.accidente.ded_honorarios = 0;
        } else {
          vm.infoSiniestro.accidente.ded_honorarios = parseFloat(
            vm.infoSiniestro.accidente.ded_honorarios
          ).toFixed(2);
          vm.infoSiniestro.accidente.ded_honorarios = parseFloat(
            vm.infoSiniestro.accidente.ded_honorarios
          );
        }
      }
    };

    //obtener el historial de log
    function getLog() {
      dataFactory
        .get("get-specific-log", {
          model: 5,
          associated_id: vm.infoSiniestro.siniestro.id,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    }

    function fillTable(ramo_number) {
      vm.siniestros = [];
      $http
        .get(url.IP + "siniestros-definidos/" + ramo_number)
        .then(function (siniestros) {
          if (siniestros.status == 200 || siniestros.status == 201) {
            if (siniestros.data) {
              siniestros.data.forEach(function (siniestro) {
                vm.siniestros.push(siniestro);
              });
            }
          }
        });
    }

    //funcion para crear complemento
    function crear_complemento(siniestro) {
      //console.log("siniestro",siniestro)
      $rootScope.siniestro_tmp = siniestro;
      $rootScope.carga_siniestro = true;
      $rootScope.tmp_complemento = true;
      $state.go("siniestros.accidentes");
    }

    //estados y ciudades
    function ciudades_estados() {
      vm.selected_state = vm.infoSiniestro.siniestro.state;
      //console.log(vm.selected_state)
      vm.citiesArray = vm.selected_state.cities;
      //console.log(vm.citiesArray);

      //vm.infoSiniestro.siniestro.state = vm.citiesArray.state;
      //vm.infoSiniestro.siniestro.city = vm.citiesArray.city;
    }

    function addContact() {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
      };
      vm.infoSiniestro.accidente.contact_accidente.push(contact);
    }

    //eliminar contactos
    function deleteContacts(index, contact) {
      $localStorage.indx = index;
      $localStorage.urll = contact.url;

      SweetAlert.swal(
        {
          title: "¿Estás seguro?",
          text: "Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        },
        function (isConfirm) {
          if (isConfirm) {
            //console.log("confirmado")
            var index = $localStorage.indx;
            var url = $localStorage.urll;
            if ((url && index) || (url && !index)) {
              try {
                return contactService
                  .deleteContact(url) //elimina contacto
                  .then(function () {
                    vm.infoSiniestro.accidente.contact_accidente.splice(index); //elimina el registro en la interfaz
                    toaster.success(MESSAGES.OK.DELETECONTRACTOR);
                  });
              } catch (err) {
                throw err;
              }
            } else {
              vm.infoSiniestro.accidente.contact_accidente.splice(index);
            }
          }
        }
      );
    }

    function viewObservation(url, SiniesterStatus) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/siniestros/facturas.observation.html",
        controller: ModalInstanceCtrlObservationsfact,
        resolve: {
          obj: function () {
            return { url: url, SiniesterStatus: SiniesterStatus };
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function ModalInstanceCtrlObservationsfact(
      $scope,
      $uibModal,
      obj,
      $uibModalInstance
    ) {
      $scope.SiniesterStatus = obj.SiniesterStatus;
      $http.get(obj.url).then(function (data) {
        $scope.observation_aux = data.data.observaciones;
      });

      $scope.ok = function () {
        var observ = {
          observaciones: $scope.observation_aux,
        };
        $http.patch(obj.url, observ).then(function (data) {
          if (data.status === 200 || data.status === 201) {
            $uibModalInstance.dismiss("cancel");
            var params = {
              model: 5,
              event: "PATCH",
              associated_id: vm.infoSiniestro.siniestro.id,
              identifier:
                "actualizo el siniestro" +
                vm.infoSiniestro.siniestro.numero_siniestro +
                " agrego observaciones",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          }
        });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    //Funciones para administrar los archivos
    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };
    //Eliminar el archivo de la lista
    function deleteFile(file, container) {
      // console.log(file)
      // console.log(container)
      fileService.deleteFile(file, container);
      var data_email = {
        id: file.id,
        id_siniestro: vm.infoSiniestro.id,
        model: 7,
        type_person: 0,
      };
      dataFactory
        .post("send-email-admins-deletes/", data_email)
        .then(function success(req) {
          console.log(".................:::::.....", req);
        });
      var params = {
        model: 5,
        event: "DELETE",
        associated_id: vm.infoSiniestro.siniestro.id,
        identifier:
          "elimino archivos del siniestro" +
          vm.infoSiniestro.siniestro.numero_siniestro,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
    }

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    //Cambiar el tipo de documento
    $scope.changeTypeDoc = function (padecimiento) {
      $scope.padecimiento_type = padecimiento;
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(siniestro_id, doc_type) {
      $scope.userInfo = {
        id: siniestro_id,
        type_document: doc_type,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP +
        "siniestros/" +
        vm.infoSiniestro.siniestro.id +
        "/archivos/?type_document=" +
        doc_type;
      // ////console.log( $scope.uploader);
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve($scope.uploader.uploadAll());
          return defer.promise;
        })
        .then(function () {
          toaster.success("Se han subido sus archivos correctamente");

          setTimeout(function () {
            fileService
              .getFiles(
                url.IP +
                  "siniestros/" +
                  vm.infoSiniestro.siniestro.id +
                  "/archivos/"
              )
              .then(function (res) {
                res.forEach(function (file) {
                  vm.files.push(file);
                });
              });
          }, 100);
        });
    }

    //Funcion para la lista de padecimientos
    function buscaPadecimientos(parPadecimiento, val) {
      //console.log("lol",parPadecimiento)
      var padeString = parPadecimiento.val ? parPadecimiento.val : val;
      if (padeString && padeString.length >= 3) {
        SiniestroService.getPadecimientos(padeString)
          .then(function (data) {
            if (data) {
              if (data.length) {
                $scope.enfermedades = [];
                vm.enfermedades = [];
                data.forEach(function (padecimientos) {
                  vm.enfermedades.push({
                    label: padecimientos.descr,
                    value: {
                      id: padecimientos.id,
                      isSelectedFromMenu: true,
                      label: padecimientos.descr,
                      code: padecimientos.code,
                      url: padecimientos.url,
                    },
                  });
                  $scope.enfermedades = vm.enfermedades;
                  vm.buscarEnfermedad = false;
                });
              }
            }
          })
          .catch(function (err) {});

        //console.log("enfermedad",vm.selected_disease)
      }

      if (padeString && padeString.length <= 3 && !vm.buscarEnfermedad) {
        vm.enfermedades = [];
        vm.buscarEnfermedad = true;
      }
    }

    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("NewSiniestrosTableCtrl", NewSiniestrosTableCtrl);

  NewSiniestrosTableCtrl.$inject = [
    "$parse",
    "$scope",
    "dataFactory",
    "SweetAlert",
    "datesFactory",
    "$sce",
    "$uibModal",
    "toaster",
    "$http",
    "url",
    "$state",
    "$sessionStorage",
    "$localStorage",
    "appStates",
    "exportFactory",
    "whatsappWebFlagService",
    "siniestroWhatsappService",
  ];

  function NewSiniestrosTableCtrl(
    $parse,
    $scope,
    dataFactory,
    SweetAlert,
    datesFactory,
    $sce,
    $uibModal,
    toaster,
    $http,
    url,
    $state,
    $sessionStorage,
    $localStorage,
    appStates,
    exportFactory,
    whatsappWebFlagService,
    siniestroWhatsappService
  ) {
    var vm = this;
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    vm.Generar = Generar;
    vm.matchesContractors = matchesContractors;
    vm.goToSinister = goToSinister;
    vm.showBinnacle = showBinnacle;
    vm.exportSiniestroComments = exportSiniestroComments;
    vm.sendWhatsAppWeb = openWhatsapp;
    vm.whatsappWebEnabled = whatsappWebFlagService.isEnabled();
    whatsappWebFlagService.subscribe(function (enabled) {
      vm.whatsappWebEnabled = enabled;
    });
    vm.accesos = $sessionStorage.permisos;
    vm.tipos = [
      { id: 1, name: "Inicial" },
      { id: 2, name: "Complemento" },
    ];
    vm.exportarExcel = exportarExcel;
    vm.changeBLine = changeBLine;
    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    //permisos
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Siniestros") {
          vm.acceso_sin = perm;
          vm.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                vm.acceso_adm_sin = true;
              } else {
                vm.acceso_adm_sin = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        }
      });
    }

    vm.form = {
      contratante: 0,
      num_certificado: "",
      business_line: 0,
      only_caratula: 0,
    };

    function openWhatsapp(siniestro, poliza) {
      if (!vm.whatsappWebEnabled) {
        return;
      }
      var targetSiniestro = siniestro;
      if (!targetSiniestro) {
        return;
      }
      var info = {
        contratante:
          targetSiniestro.contratante || targetSiniestro.contratante_info,
        contratante_phone_number:
          targetSiniestro.contratante_phone_number ||
          (targetSiniestro.contratante &&
            (targetSiniestro.contratante.phone_number ||
              targetSiniestro.contratante.phone)) ||
          (targetSiniestro.contratante_info &&
            (targetSiniestro.contratante_info.phone_number ||
              targetSiniestro.contratante_info.phone)),
      };
      siniestroWhatsappService.open({
        siniestro: targetSiniestro,
        poliza: poliza || targetSiniestro.poliza,
        info: info,
      });
    }

    vm.commentsExportLoading = false;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var user = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    vm.org_name =
      user && user.org && user.org.urlname
        ? user.org.urlname
        : user.urlname || user.orgname || "";

    $scope.filters = {};
    $scope.table = {};
    $scope.siniestro = false;

    //Seleccion de fechas
    vm.fechas = [
      {
        id: 1,
        name: "Fecha de Ingreso",
      },
      {
        id: 2,
        name: "Fecha de Siniestro",
      },
    ];

    //Opciones para el estatus del siniestro
    vm.status = [
      {
        id: 1,
        name: "Pendiente",
      },
      {
        id: 2,
        name: "En Trámite",
      },
      {
        id: 3,
        name: "Completada/Procedente",
      },
      {
        id: 4,
        name: "Cancelada",
      },
      {
        id: 5,
        name: "Rechazada/ No Procedente",
      },
      {
        id: 6,
        name: "En espera/ Solicitud de Información",
      },
      {
        id: 7,
        name: "Reproceso",
      },
      {
        id: 8,
        name: "Inconformidad",
      },
    ];

    //Opciones para el ramo del siniestro
    vm.ramo = [
      {
        id: 1,
        name: "Vida",
      },
      {
        id: 2,
        name: "Accidentes y Enfermedades",
      },
      {
        id: 3,
        name: "Automóviles",
      },
      {
        id: 4,
        name: "Daños",
      },
    ];

    //Filtro para agrupar los resultados
    $scope.group_by = [
      {
        id: 1,
        name: "Pendiente",
      },
      {
        id: 2,
        name: "En Trámite",
      },
      {
        id: 3,
        name: "Completada",
      },
      {
        id: 4,
        name: "Cancelada",
      },
      {
        id: 5,
        name: "Rechazada",
      },
      {
        id: 6,
        name: "En espera",
      },
    ];

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    vm.businesLine = [
      {
        id: 1,
        name: "Comercial",
      },
      {
        id: 2,
        name: "Personal",
      },
      {
        id: 3,
        name: "Otro",
      },
    ];

    activate();

    function changeBLine(obj) {
      $scope.bLine = obj;
      if (obj) {
        vm.form.businesLine = obj;
      } else {
        vm.form.businesLine = 0;
      }
    }
    //SELECT 2 BASICO para el formulario
    // $(window).load(function() {
    //     $('.js-example-basic-single').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });

    //Seleccion de Ramo del Siniestro
    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      console.log("ramo");
    };

    //Seleccion de Status del siniestro
    $scope.selectStatus = function (sel) {
      vm.status_selected = [];
      vm.status_selected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.status_selected.push(parseInt(r));
      });
    };

    //Columnas de la tabla de resultados
    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };

    //Funcion para el cambio de fecha en until
    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    //Funcion para convertir la fecha de until  y since
    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    //Funcion para convertir la fecha de until y since
    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");

      return date;
    }

    //Funcion Principal
    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
        }
      });
      $scope.isColectividad = false;

      $scope.filters = {
        numero_poliza:
          $localStorage.saved_filters_siniestros &&
          $localStorage.saved_filters_siniestros["numero_poliza"]
            ? $localStorage.saved_filters_siniestros["numero_poliza"]
            : "",
        numero_siniestro:
          $localStorage.saved_filters_siniestros &&
          $localStorage.saved_filters_siniestros["numero_siniestro"]
            ? $localStorage.saved_filters_siniestros["numero_siniestro"]
            : "",
        folio_compania:
          $localStorage.saved_filters_siniestros &&
          $localStorage.saved_filters_siniestros["folio_compania"]
            ? $localStorage.saved_filters_siniestros["folio_compania"]
            : "",
        ramo:
          $localStorage.saved_filters_siniestros &&
          $localStorage.saved_filters_siniestros["ramo"]
            ? $localStorage.saved_filters_siniestros["ramo"]
            : 0,
        estatus:
          $localStorage.saved_filters_siniestros &&
          $localStorage.saved_filters_siniestros["estatus"]
            ? $localStorage.saved_filters_siniestros["estatus"]
            : 0,
        fechas:
          $localStorage.saved_filters_siniestros &&
          $localStorage.saved_filters_siniestros["fechas"]
            ? $localStorage.saved_filters_siniestros["fechas"]
            : 0,
        tipo:
          $localStorage.saved_filters_siniestros &&
          $localStorage.saved_filters_siniestros["tipo"]
            ? $localStorage.saved_filters_siniestros["tipo"]
            : 0,
      };
      (vm.form.contratante =
        $localStorage.saved_filters_siniestros &&
        $localStorage.saved_filters_siniestros["contratante"]
          ? $localStorage.saved_filters_siniestros["contratante"]
          : 0),
        (vm.word =
          $localStorage.saved_filters_siniestros &&
          $localStorage.saved_filters_siniestros["caratula"]
            ? $localStorage.saved_filters_siniestros["caratula"]
            : "");
      vm.form.businesLine =
        $localStorage.saved_filters_siniestros &&
        $localStorage.saved_filters_siniestros["businesLine"]
          ? $localStorage.saved_filters_siniestros["businesLine"]
          : 0;
    }

    $scope.isColectividadOK = function (x) {
      $scope.isColectividad = x;
      if (!x) {
        $scope.filters.certificado = "";
      }
    };
    $scope.clearInput = function (x, y) {
      $scope.isAddCert = "false";
      $scope.isColectividad = false;
      if (x == null || x == undefined || !x) {
        $scope.filters.certificado = "";
        y = "";
      }
    };

    function Generar(param, order, asc, page) {}

    //Filtro por tipo de status
    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "En Trámite";
          break;
        case 3:
          return "Completada";
          break;
        case 4:
          return "Cancelada";
          break;
        case 5:
          return "Rechazada";
          break;
        case 6:
          return "En espera";
          break;
        case 7:
          return "Reproceso";
          break;
        case 8:
          return "Inconformidad";
          break;
        default:
          return "En espera";
      }
    };

    $scope.ShowContextMenu = function (name, id, ramo) {
      $scope.name_for_new_tab = name;
      $scope.id_for_new_tab = id;
      if (vm.acceso_adm_sin) {
        if (ramo == 1) {
          $scope.route_for_new_tab = "siniestros.vida_info";
        } else if (ramo == 2) {
          $scope.route_for_new_tab = "siniestros.info";
        } else if (ramo == 3) {
          $scope.route_for_new_tab = "siniestros.auto_info";
        } else if (ramo == 4) {
          $scope.route_for_new_tab = "siniestros.danio_info";
        }
      }
    };

    $scope.open_new_tab = function () {
      var existe = false;
      appStates.states.forEach(function (state) {
        if (
          state.route == $scope.route_for_new_tab &&
          state.id == $scope.id_for_new_tab
        ) {
          existe = true;
        }
      });
      if (appStates.states.length > 3) {
        SweetAlert.swal("Error", "No se pueden abrir más pestañas.", "error");
      } else {
        if (!existe) {
          appStates.states.push({
            id: $scope.id_for_new_tab,
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab, {
              siniestroId: $scope.id_for_new_tab,
            }),
          });
          $localStorage.tab_states = appStates.states;
          $localStorage.tab_index = $localStorage.tab_states.length - 1;
        }
      }
    };

    vm.getCaratulas = getCaratulas;
    function getCaratulas(parId) {
      var results = [];
      var mapeo_caratulas = [];
      $scope.getSiniestros();
      if (parId) {
        if (parId.val.length >= 3) {
          $scope.show_cds = "get-all-caratulas/";
          $http({
            method: "POST",
            url: url.IP + $scope.show_cds,
            data: {
              word: parId.val,
            },
          })
            .then(
              function success(request) {
                var results = [];
                var mapeo_caratulas = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    vm.only_caratula_poliza = 0;
                    $scope.autocompleteData = [];
                    vm.word.id = 0;
                    toaster.warning("Carátula no encontrada");
                  } else {
                    request.data.forEach(function (poliza) {
                      vm.policy = poliza;
                      if (poliza.document_type == 11) {
                        mapeo_caratulas.push(poliza);
                      }
                    });
                    results = _.map(mapeo_caratulas, function (item) {
                      if (item.juridical) {
                        var label =
                          item.poliza_number +
                          " - " +
                          item.juridical.j_name +
                          " - " +
                          " - " +
                          convertDate(vm.policy.start_of_validity) +
                          " - " +
                          convertDate(vm.policy.end_of_validity);
                      } else if (item.natural) {
                        var label =
                          item.poliza_number +
                          " - " +
                          item.natural.full_name +
                          " - " +
                          convertDate(vm.policy.start_of_validity) +
                          " - " +
                          convertDate(vm.policy.end_of_validity);
                      } else {
                        var label = item.poliza_number;
                      }
                      return {
                        label: label,
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                      };
                    });
                    $scope.autocompleteData = results;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        } else {
          vm.only_caratula_poliza = 0;
          $scope.autocompleteData = [];
          vm.word.id = 0;
        }
      }
    }
    vm.getCarSelected = getCarSelected;
    function getCarSelected(caratula) {
      vm.only_caratula_poliza = caratula.id;
    }
    $scope.$watch("vm.word", function (newValue, oldValue) {
      if (vm.word) {
        if (vm.word.id) {
          vm.only_caratula_poliza = parseInt(vm.word.id);
        } else {
          vm.only_caratula_poliza = 0;
        }
      }
    });
    //FUNCION GET
    $scope.getSiniestros = function (page) {
      //Rango de fechas para la consulta
      $scope.siniestros = [];
      var since = $scope.filters.since;
      var until = $scope.filters.until;
      var affected_full_name = $scope.filters.affected_full_name;
      var numero_siniestro = $scope.filters.numero_siniestro;
      var numero_poliza = $scope.filters.numero_poliza;
      var numero_certificado = $scope.filters.certificado;
      //Parametros para filtrar la consulta de la informacion
      $scope.params = {
        numero_siniestro: numero_siniestro,
        contratante: vm.form.contratante.val ? vm.form.contratante.value : 0,
        since: since,
        until: until,
        affected_full_name: affected_full_name,
        fechas: $scope.filters.fechas ? $scope.filters.fechas.id : 0, //Filtro select tipo de fecha
        ramo: $scope.filters.ramo ? $scope.filters.ramo.id : 0, //Filtro select ramo
        status: $scope.filters.estatus ? $scope.filters.estatus.id : 0, //Filtro select status
        num_poliza: numero_poliza,
        num_certificado: numero_certificado,
        page: page ? page : 1,
        folio: $scope.filters.folio_compania
          ? $scope.filters.folio_compania
          : "",
        tipo: $scope.filters.tipo ? $scope.filters.tipo.id : 0,
        type_contractor:
          vm.form.contratante.type == "natural"
            ? 1
            : vm.form.contratante.type == "juridical"
            ? 2
            : 0,
        businessLine: $scope.bLine ? $scope.bLine.id : 0,
        only_caratula: vm.only_caratula_poliza ? vm.only_caratula_poliza : 0,
      };
      //Consulta para traer los siniestros
      var siniester_list = "SiniestroLista/";
      dataFactory
        .get(siniester_list, $scope.params) //ruta del back
        .then(
          function success(response) {
            if (response.data.results) {
              //Imprime la lista de la consulta
              $scope.siniestros = response.data.results;

              $scope.siniestros.map(function (siniestro) {
                siniestro["status"] = $scope.status(siniestro["status"]);
                if (siniestro.ramo != "Daños") {
                  if (siniestro.status == "Completada") {
                    siniestro.status = "Completada/Procedente";
                  } else if (siniestro.status == "Rechazada") {
                    siniestro.status = "Rechazada/ No Procedente";
                  } else if (siniestro.status == "En espera") {
                    siniestro.status = "En espera/ Solicitud de Información";
                  }
                }
              });
              // console.log("consulta",$scope.siniestros)

              $scope.siniestros.forEach(function (element) {
                //Informacion del contratante, para polizas, catatulas y certificados
                if (element.poliza.caratula) {
                  $http({
                    method: "GET",
                    url:
                      url.IP + "get-caratula/" + element.poliza.caratula + "/",
                  }).then(function success(request_caratula) {
                    if (request_caratula.status === 200) {
                      if (request_caratula.data.contractor) {
                        element.contratante_name =
                          request_caratula.data.contractor.full_name;
                      }
                      if (request_caratula.data.aseguradora) {
                        element.aseguradora_name =
                          request_caratula.data.aseguradora.alias;
                      }
                    }
                  });
                } else {
                  if (element.poliza.contractor) {
                    element.contratante_name = element.poliza.contractor;
                  }

                  if (element.poliza.aseguradora) {
                    element.aseguradora_name = element.poliza.aseguradora;
                  }
                }
              });

              $scope.show_pag_search = true;
              //Parametros para la paginacion de la tabla
              vm.comments_config = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };
              $scope.obtenerPaginacion(response.data, page ? page : 1);
              //llama a la funcion de paginacion de la tabla
              // testPagination('$scope.siniestros', 'vm.comments_config');
            } else {
              toaster.info("No se encontraron registros");
            }
          },
          function error(err) {
            console.log(err);
          }
        )
        .catch(function (e) {
          console.log(e);
        });

      $localStorage.saved_filters_siniestros = angular.copy($scope.params);
      $localStorage.saved_filters_siniestros["numero_poliza"] =
        $scope.filters.numero_poliza;
      $localStorage.saved_filters_siniestros["numero_siniestro"] =
        $scope.filters.numero_siniestro;
      $localStorage.saved_filters_siniestros["folio_compania"] =
        $scope.filters.folio_compania;
      $localStorage.saved_filters_siniestros["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_siniestros["ramo"] = $scope.filters.ramo;
      $localStorage.saved_filters_siniestros["estatus"] =
        $scope.filters.estatus;
      $localStorage.saved_filters_siniestros["fechas"] = $scope.filters.fechas;
      $localStorage.saved_filters_siniestros["businesLine"] =
        vm.form.businesLine;
      $localStorage.saved_filters_siniestros["tipo"] = $scope.filters.tipo;
      $localStorage.saved_filters_siniestros["caratula"] = vm.word;
    };

    //Funcion para hacer el march con los contratantes
    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type: item.type_person,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type: item.type_person,
                      };
                    }
                    source.push(obj);
                  });
                }

                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    //Funcion para ir a la info del siniestro
    function goToSinister(ramo, sinId) {
      if (vm.acceso_adm_sin) {
        if (ramo == 1) {
          $state.go("siniestros.vida_info", { siniestroId: sinId });
        } else if (ramo == 2) {
          $state.go("siniestros.info", { siniestroId: sinId });
        } else if (ramo == 3) {
          $state.go("siniestros.auto_info", { siniestroId: sinId });
        } else if (ramo == 4) {
          $state.go("siniestros.danio_info", { siniestroId: sinId });
        }
      }
    }
    $scope.obtenerPaginacion = function (pagesdata, pagina) {
      $scope.paginacion = {
        count: pagesdata["count"],
        previous: pagesdata["previous"],
        next: pagesdata["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }
      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      $localStorage.saved_filters_siniestros["page"] = pagina;
      $scope.getSiniestros(pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $localStorage.saved_filters_siniestros["page"] =
          $scope.paginacion["paginaActual"] - 1;
        $scope.getSiniestros($scope.paginacion["paginaActual"] - 1);
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $localStorage.saved_filters_siniestros["page"] =
          $scope.paginacion["paginaActual"] + 1;
        $scope.getSiniestros($scope.paginacion["paginaActual"] + 1);
      }
    };
    vm.show_binnacle = false;
    function showBinnacle(param) {
      vm.comments_data = {};
      vm.comments_config = {};
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 5,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      vm.show_binnacle = true;
      vm.siniester_id = param.id;
    }

    function exportSiniestroComments() {
      if (!vm.siniester_id || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
        $scope.$evalAsync(function () {});
      };

      var paramsObj = {
        model: 5,
        id_model: vm.siniester_id,
      };
      if (vm.org_name) {
        paramsObj.org = vm.org_name;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: paramsObj,
          downloadName: "bitacora-siniestro.xlsx",
          token: token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }

    function exportarExcel() {
      var since = $scope.filters.since;
      var until = $scope.filters.until;
      var affected_full_name = $scope.filters.affected_full_name;
      var numero_siniestro = $scope.filters.numero_siniestro;
      var numero_poliza = $scope.filters.numero_poliza;
      var num_certificado = $scope.filters.certificado;
      //Parametros para filtrar la consulta de la informacion
      $scope.params = {
        numero_siniestro: numero_siniestro ? numero_siniestro : null,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        since: since ? since : null,
        until: until ? until : null,
        affected_full_name: affected_full_name ? affected_full_name : null,
        fechas: $scope.filters.fechas ? $scope.filters.fechas.id : 0, //Filtro select tipo de fecha
        ramo: $scope.filters.ramo ? $scope.filters.ramo.id : 0, //Filtro select ramo
        status: $scope.filters.estatus ? $scope.filters.estatus.id : 0, //Filtro select status
        num_poliza: numero_poliza ? numero_poliza : null,
        num_certificado: num_certificado ? num_certificado : null,
        folio: $scope.filters.folio_compania
          ? $scope.filters.folio_compania
          : "",
        tipo: $scope.filters.tipo ? $scope.filters.tipo.id : 0,
        type_contractor:
          vm.form.contratante.type == "natural"
            ? 1
            : vm.form.contratante.type == "juridical"
            ? 2
            : 0,
        businessLine: $scope.bLine ? $scope.bLine.id : 0,
        only_caratula: vm.only_caratula_poliza ? vm.only_caratula_poliza : 0,
      };

      var excel_siniester = "service_reporte-siniestros-excel";
      $http({
        method: "POST",
        url: url.IP + excel_siniester,
        data: $scope.params,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Siniestros.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
    }

    // INICIO DE PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPagesP = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesP.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesP.length > 5) {
          $scope.end = $scope.totalPagesP.length;
          $scope.start = $scope.totalPagesP.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPageP($scope.totalPagesP.length);
        // $scope.actual_page = $scope.totalPagesP.length;
        // $scope.page = $scope.totalPagesP.length;
      };

      $scope.selectPageP = function (parPage) {
        $scope.actual_page = parPage;

        $scope.getSiniestros(parPage);
      };

      $scope.previousBlockPagesP = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesP.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesP = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesP.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesP.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // FIN PAGINACION
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").factory("whatsappWebHelper", whatsappWebHelper);

  function whatsappWebHelper() {
    return {
      normalizePhone: normalizePhone,
      normalizeLineBreaks: normalizeLineBreaks,
      extractPreviewText: extractPreviewText,
      composeMessage: composeMessage,
      buildWhatsAppUrl: buildWhatsAppUrl,
    };

    function normalizePhone(source) {
      if (source === undefined || source === null) {
        return "";
      }

      var value = source;

      if (angular.isObject(source)) {
        value =
          source.phone_mensajeria ||
          source.phoneMensajeria ||
          source.phone_number ||
          source.phoneNumber ||
          source.phone ||
          source.value ||
          "";
      }

      if (value === undefined || value === null) {
        return "";
      }

      value = value.toString().trim();

      if (!value) {
        return "";
      }

      return value.replace(/\D/g, "");
    }

    function normalizeLineBreaks(text) {
      if (text === undefined || text === null) {
        return "";
      }

      return text.toString().replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    }

    function extractPreviewText(previewHtml) {
      if (previewHtml === undefined || previewHtml === null) {
        return "";
      }

      var htmlString = previewHtml.toString();

      if (!htmlString) {
        return "";
      }

      var textWithBreaks = htmlString
        .replace(/<br\s*\/?\s*>/gi, "\n")
        .replace(/<\/p\s*>/gi, "\n")
        .replace(/<p[^>]*>/gi, "")
        .replace(/<\/div\s*>/gi, "\n")
        .replace(/<div[^>]*>/gi, "")
        .replace(/<\/li\s*>/gi, "\n")
        .replace(/<li[^>]*>/gi, "")
        .replace(/<\/h[1-6]\s*>/gi, "\n")
        .replace(/<h[1-6][^>]*>/gi, "")
        .replace(/&nbsp;/gi, " ");

      var plainText = textWithBreaks.replace(/<[^>]+>/g, "");

      return plainText
        .replace(/\u00a0/g, " ")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
    }

    function composeMessage(manualMessage, previewHtml, appendPreview) {
      appendPreview = appendPreview !== false;

      var manual = normalizeLineBreaks(manualMessage || "");
      var preview = appendPreview
        ? normalizeLineBreaks(extractPreviewText(previewHtml || ""))
        : "";

      var finalMessage = "";
      if (manual && manual.trim()) {
        finalMessage += manual.trim();
      }

      if (preview && preview.trim()) {
        if (finalMessage) {
          finalMessage += "\n\n";
        }
        finalMessage += preview.trim();
      }

      return finalMessage;
    }

    function buildWhatsAppUrl(phone, message) {
      var normalizedPhone = normalizePhone(phone);
      if (!normalizedPhone) {
        return null;
      }

      if (!normalizedPhone.startsWith("52")) {
        normalizedPhone = "52" + normalizedPhone;
      }

      if (!message) {
        return null;
      }

      var trimmedMessage = message.toString().trim();
      if (!trimmedMessage) {
        return null;
      }

      var encoded = trimmedMessage
        .split("\n")
        .map(function (line) {
          return encodeURIComponent(line);
        })
        .join("%0A");

      return "https://wa.me/" + normalizedPhone + "?text=" + encoded;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .factory("whatsappWebFlagService", whatsappWebFlagService);

  whatsappWebFlagService.$inject = [
    "$window",
    "$localStorage",
    "$sessionStorage",
    "$rootScope",
  ];

  function whatsappWebFlagService(
    $window,
    $localStorage,
    $sessionStorage,
    $rootScope
  ) {
    var cachedFlag = null;
    var initialized = false;
    var subscriptions = [];

    return {
      isEnabled: isEnabled,
      subscribe: subscribe,
    };

    function isEnabled() {
      ensureInitialized();
      //console.log('[WhatsappWebFlagService] isEnabled() →', cachedFlag);
      return cachedFlag === true;
    }

    function subscribe(listener, scope) {
      if (!angular.isFunction(listener)) {
        return angular.noop;
      }

      ensureInitialized();

      var subscription = { listener: listener };
      subscriptions.push(subscription);

      //console.log('[WhatsappWebFlagService] Nueva suscripción registrada. Total:', subscriptions.length);

      // Emitir valor actual
      safeInvoke(listener, cachedFlag === true);

      function unsubscribe() {
        var index = subscriptions.indexOf(subscription);
        if (index !== -1) {
          subscriptions.splice(index, 1);
          //console.log('[WhatsappWebFlagService] Suscripción eliminada. Total:', subscriptions.length);
        }
        if (subscription.destroyDeregister) {
          subscription.destroyDeregister();
          subscription.destroyDeregister = null;
        }
      }

      if (scope && scope.$on) {
        subscription.destroyDeregister = scope.$on("$destroy", unsubscribe);
      }

      return unsubscribe;
    }

    function ensureInitialized() {
      if (initialized) return;

      //console.log('[WhatsappWebFlagService] Inicializando...');
      initialized = true;
      cachedFlag = evaluateFlag();
      //console.log('[WhatsappWebFlagService] Valor inicial detectado:', cachedFlag);

      if ($localStorage) {
        watchStorage(function () {
          return angular.toJson($localStorage.org);
        });
        watchStorage(function () {
          return angular.toJson($localStorage.infoUser);
        });
      }

      if ($sessionStorage) {
        watchStorage(function () {
          return angular.toJson($sessionStorage.org);
        });
        watchStorage(function () {
          return angular.toJson($sessionStorage.infoUser);
        });
      }

      if ($window && $window.addEventListener) {
        var storageListener = function (e) {
          //console.log('[WhatsappWebFlagService] Evento storage detectado:', e.key);
          scheduleEvaluation();
        };
        $window.addEventListener("storage", storageListener);
      }
    }

    function watchStorage(getter) {
      if (!angular.isFunction(getter)) return;
      $rootScope.$watch(getter, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          //console.log('[WhatsappWebFlagService] Cambio detectado en $storage:', oldVal, '→', newVal);
          scheduleEvaluation();
        }
      });
    }

    function scheduleEvaluation() {
      $rootScope.$evalAsync(function () {
        var nextFlag = evaluateFlag();
        if (nextFlag !== cachedFlag) {
          //console.log('[WhatsappWebFlagService] Cambio de flag detectado:', cachedFlag, '→', nextFlag);
          cachedFlag = nextFlag;
          notifySubscribers();
        }
      });
    }

    function notifySubscribers() {
      //console.log('[WhatsappWebFlagService] Notificando a suscriptores. Total:', subscriptions.length);
      for (var i = 0; i < subscriptions.length; i++) {
        safeInvoke(subscriptions[i].listener, cachedFlag === true);
      }
    }

    function safeInvoke(listener, value) {
      try {
        listener(value);
      } catch (err) {
        console.error(
          "[WhatsappWebFlagService] Error al ejecutar listener:",
          err
        );
      }
    }

    function evaluateFlag() {
      //console.log('[WhatsappWebFlagService] Evaluando bandera...');
      var sources = [];

      function addCandidate(candidate) {
        if (!angular.isUndefined(candidate) && candidate !== null) {
          sources.push(candidate);
        }
      }

      if ($localStorage) {
        addCandidate($localStorage.org);
        addCandidate($localStorage.infoUser);
        if ($localStorage.infoUser && $localStorage.infoUser.org) {
          addCandidate($localStorage.infoUser.org);
        }
      }

      if ($sessionStorage) {
        addCandidate($sessionStorage.org);
        addCandidate($sessionStorage.infoUser);
        if ($sessionStorage.infoUser && $sessionStorage.infoUser.org) {
          addCandidate($sessionStorage.infoUser.org);
        }
      }

      if ($window) {
        collectRawStorageCandidates($window.localStorage);
        collectRawStorageCandidates($window.sessionStorage);
      }

      //console.log('[WhatsappWebFlagService] Total de candidatos a analizar:', sources.length);

      for (var i = 0; i < sources.length; i++) {
        var flag = extractWhatsappWebFlag(sources[i]);
        //console.log('[WhatsappWebFlagService] Candidato #' + i, sources[i], '→ flag:', flag);
        if (flag === true) {
          //console.log('[WhatsappWebFlagService] Bandera TRUE encontrada en candidato', i);
          return true;
        }
      }

      //console.log('[WhatsappWebFlagService] Ningún candidato devolvió TRUE → false');
      return false;

      function collectRawStorageCandidates(storage) {
        if (!storage) return;
        var keys = ["org", "ngStorage-org", "infoUser", "ngStorage-infoUser"];
        for (var k = 0; k < keys.length; k++) {
          var item = null;
          try {
            item = storage.getItem(keys[k]);
          } catch (error) {
            item = null;
          }
          if (item) {
            //console.log('[WhatsappWebFlagService] Encontrado en almacenamiento nativo:', keys[k], item);
            addCandidate(item);
          }
        }
      }
    }

    function extractWhatsappWebFlag(source, visited) {
      if (angular.isUndefined(source) || source === null) return null;

      var candidate = source;
      if (angular.isString(candidate)) {
        var trimmed = candidate.trim();
        if (!trimmed) return null;

        if (trimmed === "true" || trimmed === "false") {
          //console.log('[WhatsappWebFlagService] Valor string directo:', trimmed);
          return trimmed === "true";
        }

        try {
          candidate = JSON.parse(trimmed);
          //console.log('[WhatsappWebFlagService] String parseado como JSON:', candidate);
        } catch (error) {
          return null;
        }
      }

      if (angular.isNumber(candidate) || angular.isDate(candidate)) return null;

      if (angular.isArray(candidate)) {
        //console.log('[WhatsappWebFlagService] Explorando array...');
        for (var i = 0; i < candidate.length; i++) {
          var arrayFlag = extractWhatsappWebFlag(candidate[i], visited);
          if (arrayFlag !== null) return arrayFlag;
        }
        return null;
      }

      if (typeof candidate !== "object") return null;

      if (!visited) visited = [];
      if (visited.indexOf(candidate) !== -1) return null;
      visited.push(candidate);

      var objectKeys = Object.keys(candidate);
      for (var j = 0; j < objectKeys.length; j++) {
        var key = objectKeys[j];
        var lowerKey = key.toLowerCase();
        if (
          lowerKey === "whatsappweb" ||
          lowerKey === "whatsapp_web" ||
          lowerKey === "whatsapp_web_enabled" ||
          lowerKey === "whatsappwebenabled"
        ) {
          //console.log('[WhatsappWebFlagService] 🔍 Campo encontrado:', key, '→', candidate[key]);
          return normalizeWhatsappWebFlag(candidate[key]);
        }
      }

      for (var idx = 0; idx < objectKeys.length; idx++) {
        var nestedFlag = extractWhatsappWebFlag(
          candidate[objectKeys[idx]],
          visited
        );
        if (nestedFlag !== null) return nestedFlag;
      }

      return null;
    }

    function normalizeWhatsappWebFlag(value) {
      if (angular.isString(value)) {
        //console.log('[WhatsappWebFlagService] Normalizando string:', value);
        return value.toLowerCase() === "true";
      }
      //console.log('[WhatsappWebFlagService] Normalizando valor booleano/numérico:', value);
      return !!value;
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("RepositorioCtrl", RepositorioCtrl);

  RepositorioCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "FileUploader",
    "url",
    "SweetAlert",
    "dataFactory",
    "MESSAGES",
    "$parse",
    "providerService",
  ];

  function RepositorioCtrl(
    $sessionStorage,
    $scope,
    $http,
    FileUploader,
    url,
    SweetAlert,
    dataFactory,
    MESSAGES,
    $parse,
    providerService
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    activate(1);

    function activate(page) {
      vm.show_pag_rp = false;
      // dataFactory.get('repositorio-de-pago/')
      // .then(function success(response) {
      // 	console.log(response)
      //    $scope.layouts = response.data.results;
      // })
      var data = { page: page ? page : 1 };
      dataFactory
        .post("getrepositoriopago/", data)
        .then(function success(response) {
          console.log(response);
          $scope.layouts = response.data.results;
          $scope.search_results = {
            count: response.data.count,
            previous: url.IP + "getrepositoriopago/",
            next: url.IP + "getrepositoriopago/",
          };
          testPagination("layouts", "search_results");
          vm.show_pag_rp = true;
        });
    }
    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPagesP = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesP.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesP.length > 5) {
          $scope.end = $scope.totalPagesP.length;
          $scope.start = $scope.totalPagesP.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPageP($scope.totalPagesP.length);
      };

      $scope.selectPageP = function (parPage) {
        $scope.actual_page = parPage;
        activate(parPage);
      };

      $scope.previousBlockPagesP = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesP.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesP = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesP.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesP.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("VentaCruzadaController", VentaCruzadaController);

  VentaCruzadaController.$inject = [
    "toaster",
    "datesFactory",
    "MESSAGES",
    "$http",
    "url",
    "$scope",
    "$parse",
    "$sessionStorage",
    "$uibModal",
    "SweetAlert",
    "providerService",
  ];

  function VentaCruzadaController(
    toaster,
    datesFactory,
    MESSAGES,
    $http,
    url,
    $scope,
    $parse,
    $sessionStorage,
    $uibModal,
    SweetAlert,
    providerService
  ) {
    var vm = this;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    vm.users = [];
    vm.matchesGroup = matchesGroup;
    vm.form = {
      group: 0,
      only_active: false,
      notifyInactiveBranches: false,
    };

    $scope.infoUser = $sessionStorage.infoUser;

    $(".js-example-basic-multiple").select2();

    activate();
    getReferenciador();
    // Start functionality
    function activate() {
      getProviders();
      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });
    }
    $(".js-example-basic-multiple").select2();
    // tipo recibos
    $scope.recibo_endoso = "0";
    $scope.type_recibo = 0;

    $scope.filterChanged = function () {
      var filters = {
        vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        grupo: vm.form.group.val ? vm.form.group.value : 0,
      };
      // if (filters['vendedor'] != 0) vm.form.only_active = false;
      // if (filters['providers'] != 0) vm.form.only_active = false;
      // if (filters['ramos'] != 0) vm.form.only_active = false;
      // if (filters['subramos'] != 0) vm.form.only_active = false;
      // if (filters['grupo'] != 0) vm.form.only_active = false;
    };

    // getClientes API
    $scope.getClientes = function (page, otro) {
      $scope.filters = {
        vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        ramos_not: vm.ramos_selected_not ? vm.ramos_selected_not : 0,
        subramos_not: vm.subramos_selected_to_not
          ? vm.subramos_selected_to_not
          : 0,
        only_active: vm.form.only_active,
        notifyInactiveBranches: vm.form.notifyInactiveBranches,

        page: page ? page : 1,
        grupo: vm.form.group.val ? vm.form.group.value : 0,
      };
      console.log($scope.filters);

      var lc = Ladda.create(document.querySelector(".ladda-button"));
      lc.start();
      $scope.search_customer = "reporte-ventacruzada/";
      $http({
        method: "POST",
        url: url.IP + $scope.search_customer,
        data: $scope.filters,
      })
        .then(function success(response) {
          lc.stop();
          if (response.data.length == 0) {
            toaster.info("No se encontraron registros");
            $scope.edoclientes = [];
          } else {
            $scope.edoclientes = response.data.results;
            vm.ver_pagiando = true;
            console.log("page");
            $scope.obtenerPaginacion(response.data, page ? page : 1);
          }
        })
        .catch(function (e) {
          lc.stop();
          console.log("e", e);
        });
    };
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      $scope.paginaSeleccionada = pagina;
      $scope.getClientes(pagina, 1);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $scope.paginaSeleccionada = $scope.paginacion["paginaActual"] - 1;
        $scope.getClientes($scope.paginacion["paginaActual"] - 1);
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $scope.paginaSeleccionada = $scope.paginacion["paginaActual"] + 1;
        $scope.getClientes($scope.paginacion["paginaActual"] + 1);
      }
    };
    // Download report to excel
    $scope.export = function () {
      var lx = Ladda.create(document.querySelector(".ladda-button_excel"));
      lx.start();
      var scolumns = [
        "Nombre",
        "Correo",
        "Correo 2",
        "Correo 3",
        "Teléfono",
        "Teléfono 2",
        "Teléfono 3",
        "RFC",
        "Fecha de establecimiento/Nacimiento",
        "Grupo",
        "Referenciador",
        "Solo Fianzas",
        "RAMO: DAÑOS",
        "RAMO: ACCIDENTES Y ENFERMEDADES",
        "RAMO: VIDA",
        "Agrícola y de Animales",
        "Automóviles",
        "Crédito",
        "Crédito a la Vivienda",
        "Diversos",
        "Garantía Financiera",
        "Incendio",
        "Líneas Financieras",
        "Marítimo y Transportes",
        "Responsabilidad Civil y Riesgos Profesionales",
        "Vida",
        "Accidentes Personales",
        "Terremoto y Otros Riesgos Catastróficos",
        "Gastos Médicos",
        "Funerarios",
        "Salud",
        "ID Cliente",
        "Tipo Persona",
        "Baja",
        "Motivo Baja",
        "Adjuntos",
      ];
      $scope.filters["cols1"] = [];
      $scope.filters["cols1"] = scolumns;
      $scope.url_go_excel = "service_reporte-ventacruzada-excel";
      $http({
        method: "POST",
        url: url.IP + $scope.url_go_excel,
        data: $scope.filters,
      })
        .then(function success(response) {
          if (response.status == 200) {
            lx.stop();
            // Conexión a socket.io
            var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
            socket.emit("subscribe", response.data);
            // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
            socket.on(response.data, function (url) {
              socket.disconnect();
              SweetAlert.swal({
                title: "El reporte está listo para descargar",
                icon: "success",
                text: "Encuentra la liga de descarga en la sección de notificaciones",
                timer: 5000,
              });
            });
            toaster.info(
              "Generando...",
              "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
            );
          } else {
            lx.stop();
            toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
          }
        })
        .catch(function (error) {
          lx.stop();
          toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
        });
      // $scope.excel_customer = 'reporte-ventacruzada-excel';
      // $http({
      // 	method: 'POST',
      // 	url: url.IP + $scope.excel_customer,
      // 	data: $scope.filters,
      // 	headers: {'Content-Type': "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"},
      // 	responseType: "arraybuffer"})
      // .then(function(data, status, headers, config) {
      // if(data.status == 200){
      // 	lx.stop();
      // 	var blob = new Blob([data.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      // 	saveAs(blob, 'Reporte_Venta_Cruzada.xls');
      // } else {
      // 	SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDOWNLOADREP, "error")
      // 	lx.stop()
      // }
      // });
    };

    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group.val) {
        var word_data = vm.form.group.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    // Format Dates DD/MM/YYYY
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    $scope.selectSubramosToNot = function (sel) {
      vm.subramos_selected_to_not = [];
      sel.forEach(function (sr) {
        vm.subramos_selected_to_not.push(sr.subramo_code);
      });
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };

    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 6,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
        // ----
        {
          id: 15,
          subramo_code: 15,
          subramo_name: "Individual",
        },
        {
          id: 16,
          subramo_code: 16,
          subramo_name: "Colectivas",
        },
        {
          id: 17,
          subramo_code: 17,
          subramo_name: "Penales",
        },
        {
          id: 18,
          subramo_code: 18,
          subramo_name: "No penales",
        },
        {
          id: 19,
          subramo_code: 19,
          subramo_name: "Amparo a conductores",
        },
        {
          id: 20,
          subramo_code: 20,
          subramo_name: "Obra",
        },
        {
          id: 21,
          subramo_code: 21,
          subramo_name: "Proveeduria",
        },
        {
          id: 22,
          subramo_code: 22,
          subramo_name: "Fiscales",
        },
        {
          id: 23,
          subramo_code: 23,
          subramo_name: "Arrendamiento",
        },
        {
          id: 24,
          subramo_code: 24,
          subramo_name: "Otras",
        },
        {
          id: 25,
          subramo_code: 25,
          subramo_name: "Suministro",
        },
        {
          id: 26,
          subramo_code: 26,
          subramo_name: "Compra Venta",
        },
        {
          id: 27,
          subramo_code: 27,
          subramo_name: "Otras",
        },
        {
          id: 28,
          subramo_code: 28,
          subramo_name: "Relación con fianza",
        },
        {
          id: 29,
          subramo_code: 29,
          subramo_name: "Sin relación con fianza",
        },
      ];
    }
    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        console.log(data);
        vm.providers = data.data;
      });
    }

    function getReferenciador() {
      vm.vendedores = [];
      $http.get(url.IP + "get-vendors").then(function (user) {
        user.data.forEach(function (u) {
          var obj = {
            name: u.first_name + " " + u.last_name,
            id: u.id,
          };
          vm.vendedores.push(obj);
        });
      });
    }

    $scope.selectRamos = function (sel) {
      console.log("sel", sel);
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      sel.forEach(function (r) {
        $http.get(url.IP + "subramos-by-ramo_code/" + r).then(function (data) {
          data.data.forEach(function (sr) {
            vm.subramos_toselected.push(sr);
          });
        });
      });

      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.selectRamosNot = function (sel) {
      console.log("sel", sel);
      vm.ramos_selected_not = [];
      vm.ramos_selected_not = [];
      vm.subramos_toselected_not = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected_not.push(parseInt(r));
      });
      sel.forEach(function (r) {
        $http.get(url.IP + "subramos-by-ramo_code/" + r).then(function (data) {
          data.data.forEach(function (sr) {
            vm.subramos_toselected_not.push(sr);
          });
        });
      });

      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    // -----------PAGINACIÓN
    function PaginationResults(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        $scope.getEdosClientes(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteTaskController", ReporteTaskController);

  ReporteTaskController.$inject = [
    "toaster",
    "datesFactory",
    "dataFactory",
    "MESSAGES",
    "$http",
    "url",
    "$scope",
    "$parse",
    "$sessionStorage",
    "$uibModal",
    "SweetAlert",
    "$localStorage",
  ];

  function ReporteTaskController(
    toaster,
    datesFactory,
    dataFactory,
    MESSAGES,
    $http,
    url,
    $scope,
    $parse,
    $sessionStorage,
    $uibModal,
    SweetAlert,
    $localStorage
  ) {
    var vm = this;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    vm.users = [];
    vm.report_by = [
      {
        id: 1,
        name: "Fecha de cierre",
      },
      {
        id: 2,
        name: "Fecha de compromiso",
      },
    ];
    vm.form = {
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      report_by: "",
      closed: false,
      archived: false,
      opened: false,
    };

    $(".js-example-basic-multiple").select2();

    activate();
    // Start functionality
    function activate() {
      $http.get(url.IP + "usuarios/").then(function (user) {
        user.data.results.forEach(function (usr) {
          if (usr.user_info.is_active) {
            vm.users.push(usr);
          }
        });
      });
      //   $(window).load(function() {
      //     $('.js-example-basic-multiple').select2();
      // });
      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });
      // Radio prioridad
      $scope.priority_task = "0";
      $scope.priority_task = 0;
      vm.form.todos = true;

      vm.form.report_by =
        $localStorage.saved_filters_reporte_tareas &&
        $localStorage.saved_filters_reporte_tareas["report_by"]
          ? $localStorage.saved_filters_reporte_tareas["report_by"]
          : 0;
      $scope.priority_task =
        $localStorage.saved_filters_reporte_tareas &&
        $localStorage.saved_filters_reporte_tareas["priority_task"]
          ? $localStorage.saved_filters_reporte_tareas["priority_task"]
          : 0;
      vm.form.archived =
        $localStorage.saved_filters_reporte_tareas &&
        $localStorage.saved_filters_reporte_tareas["archived"]
          ? $localStorage.saved_filters_reporte_tareas["archived"]
          : false;
      vm.form.closed =
        $localStorage.saved_filters_reporte_tareas &&
        $localStorage.saved_filters_reporte_tareas["closed"]
          ? $localStorage.saved_filters_reporte_tareas["closed"]
          : false;
      vm.form.opened =
        $localStorage.saved_filters_reporte_tareas &&
        $localStorage.saved_filters_reporte_tareas["opened"]
          ? $localStorage.saved_filters_reporte_tareas["opened"]
          : false;
      vm.form.todos =
        $localStorage.saved_filters_reporte_tareas &&
        $localStorage.saved_filters_reporte_tareas["todos"]
          ? $localStorage.saved_filters_reporte_tareas["todos"]
          : true;
    }
    // Get tasks API
    $scope.getTasks = function (page, otro) {
      $scope.tasks = [];
      $scope.grupos_result = [];
      $scope.filters = {
        createdBy: vm.created_by ? vm.created_by : 0,
        closedBy: vm.closed_by ? vm.closed_by : 0,
        involvedUsers: vm.invloved_users ? vm.invloved_users : 0,
        since: vm.form.since ? vm.form.since : "",
        until: vm.form.until ? vm.form.until : "",
        reportBy: vm.form.report_by ? vm.form.report_by.id : 0,
        archived: vm.form.archived ? vm.form.archived : false,
        closed: vm.form.closed ? vm.form.closed : false,
        opened: vm.form.opened ? vm.form.opened : false,
        todos: vm.form.todos ? vm.form.todos : false,
        priority: $scope.priority_task ? $scope.priority_task : false,
        page: page ? page : 1,
      };
      $scope.filters.since = $scope.filters.since + " " + "00:00:00";
      $scope.filters.until = $scope.filters.until + " " + "23:59:59";
      $http({
        method: "POST",
        url: url.IP + "reporte-tasks/",
        data: $scope.filters,
      }).then(function success(response) {
        $scope.tasks = response.data.results;
        if (response.data.count == 0) {
          toaster.warning("No se encontraron resultados.");
        }
        $scope.task_config = {
          count: response.data.count,
          previous: url.IP + "reporte-tasks/",
          next: url.IP + "reporte-tasks/",
        };
        vm.show_pag_task = true;
        $scope.obtenerPaginacion(response.data, page);
        // PaginationResults('tasks', 'task_config');
      });

      $localStorage.saved_filters_reporte_tareas = angular.copy($scope.filters);
      $localStorage.saved_filters_reporte_tareas["report_by"] =
        vm.form.report_by;
      $localStorage.saved_filters_reporte_tareas["priority_task"] =
        $scope.priority_task;
      $localStorage.saved_filters_reporte_tareas["archived"] = vm.form.archived;
      $localStorage.saved_filters_reporte_tareas["closed"] = vm.form.closed;
      $localStorage.saved_filters_reporte_tareas["opened"] = vm.form.opened;
      $localStorage.saved_filters_reporte_tareas["todos"] = vm.form.todos;
    };
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      $localStorage.saved_filters_reporte_log["page"] = pagina;
      $scope.getTasks(pagina, 1);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $localStorage.saved_filters_reporte_log["page"] =
          $scope.paginacion["paginaActual"] - 1;
        $scope.getTasks($scope.paginacion["paginaActual"] - 1, 1);
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $localStorage.saved_filters_reporte_log["page"] =
          $scope.paginacion["paginaActual"] + 1;
        $scope.getTasks($scope.paginacion["paginaActual"] + 1, 1);
      }
    };
    $scope.selectPriority = function (parValue) {
      if (parValue == "1") {
        $scope.priority_task = 1;
      } else if (parValue == "2") {
        $scope.priority_task = 2;
      } else if (parValue == "3") {
        $scope.priority_task = 3;
      } else if (parValue == "0") {
        $scope.priority_task = 0;
      }
    };
    // Change Creada por
    $scope.selectCreatedBy = function (x, y) {
      vm.created_by = [];
      x.forEach(function (r) {
        vm.created_by.push(parseInt(r.id));
      });
    };
    // Change Cerrada por
    $scope.selectCloseBy = function (x, y) {
      vm.closed_by = [];
      x.forEach(function (r) {
        vm.closed_by.push(parseInt(r.id));
      });
    };
    // Change Involucrados
    $scope.selectInvolved = function (x, y) {
      vm.invloved_users = [];
      x.forEach(function (r) {
        vm.invloved_users.push(parseInt(r.id));
      });
    };
    $scope.estatusTask = function (ta) {
      if (ta == 0) {
        vm.form.todos = false;
      } else if (ta == 1) {
        vm.form.archived = false;
        vm.form.closed = false;
        vm.form.opened = false;
      }
    };
    $scope.prior = function (p) {
      switch (p) {
        case 1:
          return "Alta";
          break;
        case 2:
          return "Media";
          break;
        case 3:
          return "Baja";
          break;
        default:
          return "Pendiente";
      }
    };
    // concepto
    $scope.concept = function (p) {
      switch (p) {
        case 1:
          return "Cotización";
          break;
        case 2:
          return "Emisión";
          break;
        case 4:
          return "Corrección";
          break;
        case 5:
          return "Cancelación";
          break;
        case 6:
          return "Renovación";
          break;
        case 7:
          return "Otro";
          break;
        case 8:
          return "Reembolso";
          break;
        case 9:
          return "Programación de cirugía";
          break;
        case 3:
          return "Endoso A";
          break;
        case 10:
          return "Endoso B";
          break;
        case 11:
          return "Endoso D";
          break;
        case 12:
          return "Reconocimiento de antigüedad";
          break;
        case 13:
          return "Carta de antigüedad";
          break;
        default:
          return "Otro";
          break;
      }
    };
    // Actions
    $scope.getLog = function (ticket) {
      dataFactory
        .get("get-specific-log", { model: 22, associated_id: ticket.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    };
    // Ver
    $scope.openModal = function (task) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/tasks/task.modal.html",
        controller: "TareasModalCtrl",
        size: "lg",
        resolve: {
          task: function () {
            return task;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          $scope.tasks.some(function (tiket, index) {
            if (tiket.id == response.response.data.id) {
              $scope.tasks[index].archived = response.response.data.archived;
              return;
            }
          });
          // $scope.tickets[$scope.tickets.indexOf(task)].archived = response.response.archived
          // console.log($scope.tickets[$scope.tickets.indexOf(task)].archived)
        },
        function () {
          //close callback
          console.info("modal closed");
        }
      );
    };
    // Download report to excel
    $scope.export = function (param) {
      var lx = Ladda.create(document.querySelector(".ladda-button_excel"));
      lx.start();
      $scope.filters.orden = $scope.columnArray;
      $scope.filters.export_type = 2;
      if (param == 1) {
        $http({
          method: "POST",
          // url: url.IP +'reporte-tasks-excel' ,
          url: url.IP + "service_reporte-tareasReport-excel",
          data: $scope.filters,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function (data, status, headers, config) {
          if (data.status == 200) {
            lx.stop();
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte Tareas.xls");
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDOWNLOADREP, "error");
            lx.stop();
          }
        });
      }
    };
    // DOWNLOAD REPORT IF GROUP BY SELECTED
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        var param = 1;
        if (option) {
          // Totales de la Agrupación
          if (option == 1) {
            var l1 = Ladda.create(
              document.querySelector(".ladda-button_excel")
            );
            l1.start();
            filters.export_type = option;
            $http({
              method: "POST",
              url: url.IP + "reporte-log-excel",
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte Transacciones.xls");
                  $uibModalInstance.dismiss("cancel");
                  l1.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l1.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          } else if (option == 2) {
            filters.export_type = option;
            var la = Ladda.create(
              document.querySelector(".ladda-button_excel")
            );
            la.start();
            $http({
              method: "POST",
              url: url.IP + "reporte-log-excel",
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte Transacciones.xls");
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    // Format Dates DD/MM/YYYY
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    // -----------PAGINACIÓN
    function PaginationResults(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        $scope.getTasks(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteSiniestrosController", ReporteSiniestrosController);

  ReporteSiniestrosController.$inject = [
    "dataFactory",
    "appStates",
    "$sessionStorage",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "SweetAlert",
    "MESSAGES",
    "$parse",
    "exportFactory",
    "$state",
    "$uibModal",
    "$localStorage",
  ];

  function ReporteSiniestrosController(
    dataFactory,
    appStates,
    $sessionStorage,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    SweetAlert,
    MESSAGES,
    $parse,
    exportFactory,
    $state,
    $uibModal,
    $localStorage
  ) {
    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? -1 : str1 > str2 ? 1 : 0;
      },

      "non-empty-string-desc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? 1 : str1 > str2 ? -1 : 0;
      },
    });
    var hCols = [];
    var paso = 0;
    var savedFiltersSiniestro = {};
    $scope.$on("ngRepeatFinished", function () {
      paso++;
      // $('#example').DataTable().draw();

      //Only needed for the filename of export files.
      //Normally set in the title tag of your page.document.title = 'Simple DataTable';
      //Define hidden columns
      $("#example").DataTable().destroy();
      // DataTable initialisation
      $("#example").DataTable({
        dom:
          "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-12'p<br/>i>>",
        info: false,
        paging: false,
        autoWidth: true,
        columnDefs: [
          {
            visible: false,
            targets: hCols,
          },
          {
            type: "non-empty-string",
            targets: 0,
          },
        ],
        buttons: [
          {
            extend: "colvis",
            collectionLayout: "three-column",
            text: function () {
              var totCols = $("#example thead th").length;
              var hiddenCols = hCols.length;
              var shownCols = totCols - hiddenCols;
              return "Columnas (" + shownCols + " de " + totCols + ")";
            },
            prefixButtons: [
              {
                extend: "colvisGroup",
                text: "Mostrar todo",
                show: ":hidden",
              },
              {
                extend: "colvisRestore",
                text: "Restaurar",
              },
            ],
          },
        ],
        oLanguage: {
          oPaginate: {
            sNext: '<span class="pagination-default">&#x276f;</span>',
            sPrevious: '<span class="pagination-default">&#x276e;</span>',
          },
        },
        initComplete: function (settings, json) {
          // Adjust hidden columns counter text in button -->
          $("#example").on(
            "column-visibility.dt",
            function (e, settings, column, state) {
              var index = hCols.indexOf(column);
              if (state === false) {
                if (index === -1) {
                  hCols.push(column);
                }
              }
              if (
                $(".dt-button-collection.dropdown-menu.three-column").length ===
                  1 &&
                state === true
              ) {
                // console.log($('.dt-button-collection.dropdown-menu.three-column').length);
                if (index !== -1) {
                  hCols.splice(index, 1);
                }
                // console.log("si entro");
              }
              // var visCols = $('#example thead tr:first th').length;

              //Below: The minus 2 because of the 2 extra buttons Show all and Restore
              var tblCols =
                $(".dt-button-collection li[aria-controls=example] a").length -
                2;
              var visCols = tblCols - hCols.length;
              $(".buttons-colvis[aria-controls=example] span").html(
                "Columnas (" + visCols + " de " + tblCols + ")"
              );
              e.stopPropagation();
            }
          );
        },
      });
    });

    $scope.infoUser = $sessionStorage.infoUser;

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;
    vm.table = {};
    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "Pendiente",
      },
      {
        id: 2,
        name: "En Trámite",
      },
      {
        id: 3,
        name: "Completada/Procedente",
      },
      {
        id: 4,
        name: "Cancelada",
      },
      {
        id: 5,
        name: "Rechazada/ No Procedente",
      },
      {
        id: 6,
        name: "En espera/ Solicitud de Información",
      },
      {
        id: 7,
        name: "Reproceso",
      },
      {
        id: 8,
        name: "Inconformidad",
      },
    ];

    vm.option_policy = [
      {
        id: 1,
        name: "Siniestros",
      },
      {
        id: 2,
        name: "Operación de siniestros",
      },
    ];

    vm.group_by = [
      {
        id: 1,
        name: "Aseguradora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 6,
        name: "Estatus",
      },
      {
        id: 7,
        name: "Usuario",
      },
    ];

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.changeUntil = changeUntil;
    vm.matchesContractors = matchesContractors;
    vm.changeSinister = changeSinister;
    vm.goToInfo = goToInfo;
    $scope.ramo_slc = false;
    $scope.last_comentario = [];
    $scope.insurances_ = [];
    $scope.insurances = {};
    vm.accesos = $sessionStorage.permisos;
    vm.changeBLine = changeBLine;
    vm.only_caratula_poliza = 0;
    function changeBLine(obj) {
      $scope.bLine = obj;
      if (obj) {
        vm.form.businesLine = obj;
      } else {
        vm.form.businesLine = 0;
      }
    }
    vm.businesLine = [
      {
        id: 1,
        name: "Comercial",
      },
      {
        id: 2,
        name: "Personal",
      },
      {
        id: 3,
        name: "Otro",
      },
    ];
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        }
        if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        }
        if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        }
        if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        }
        if (perm.model_name == "Siniestros") {
          vm.acceso_sin = perm;
          vm.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                vm.acceso_adm_sin = true;
              } else {
                vm.acceso_adm_sin = false;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                vm.permiso_ver_referenciador = true;
              } else {
                vm.permiso_ver_referenciador = false;
              }
            }
          });
        }
      });
    }
    vm.formatearNumero = formatearNumero;

    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }

    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      status: 0,
      contratante: 0,
      report: {},
      num_poliza: "",
      businessLine: 0,
      celula: 0,
      only_caratula: 0,
    };

    vm.table = {
      headers: [
        "No Siniestro",
        "Estatus",
        "Fecha en que Ocurrio",
        "Fecha de Ingreso",
        "No.Póliza",
        "Contratante",
        "Proveedor",
        "Ramo",
        "Subramo",
        "Observaciones",
        "Folio",
        "Afectado",
        "Reclamado",
        "Bitacora",
        "Número de Serie",
        "Subgrupo",
        "Subsubgrupo",
        "Agrupación",
        "Subagrupación",
        "Subsubagrupación",
        "Clasificación",
        "Línea de Negocio",
        "Célula",
        "Fecha Terminación",
        "Fecha Bitácora",
      ],
    };

    $scope.status = function (parSttaus) {
      switch (parSttaus) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "En trámite";
          break;
        case 3:
          return "Completado";
          break;
        case 4:
          return "Cancelado";
          break;
        case 5:
          return "Rechazado";
          break;
        case 6:
          return "En espera";
          break;
      }
    };

    $(".js-example-basic-multiple").select2();

    $scope.columnArray = [1, 11, 2, 3, 4, 5, 6, 7, 8, 9, 12, 10];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;

    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };

    function changeSinister(par, asc) {
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.sinister_num_asc = asc;
          vm.sinister_status_asc = 0;
          vm.sinister_fini_asc = 0;
          vm.sinister_fing_asc = 0;
          vm.sinister_npol_asc = 0;
          vm.sinister_cont_asc = 0;
          vm.sinister_aseg_asc = 0;
          vm.sinister_ramo_asc = 0;
          vm.sinister_subr_asc = 0;
          vm.sinister_obs_asc = 0;
          vm.sinister_fint_asc = 0;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.sinister_status_asc = asc;
          vm.sinister_num_asc = 0;
          vm.sinister_fini_asc = 0;
          vm.sinister_fing_asc = 0;
          vm.sinister_npol_asc = 0;
          vm.sinister_cont_asc = 0;
          vm.sinister_aseg_asc = 0;
          vm.sinister_ramo_asc = 0;
          vm.sinister_subr_asc = 0;
          vm.sinister_obs_asc = 0;
          vm.sinister_fint_asc = 0;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.sinister_fini_asc = asc;
          vm.sinister_num_asc = 0;
          vm.sinister_status_asc = 0;
          vm.sinister_fing_asc = 0;
          vm.sinister_npol_asc = 0;
          vm.sinister_cont_asc = 0;
          vm.sinister_aseg_asc = 0;
          vm.sinister_ramo_asc = 0;
          vm.sinister_subr_asc = 0;
          vm.sinister_obs_asc = 0;
          vm.sinister_fint_asc = 0;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.sinister_fing_asc = asc;
          vm.sinister_status_asc = 0;
          vm.sinister_num_asc = 0;
          vm.sinister_fini_asc = 0;
          vm.sinister_npol_asc = 0;
          vm.sinister_cont_asc = 0;
          vm.sinister_aseg_asc = 0;
          vm.sinister_ramo_asc = 0;
          vm.sinister_subr_asc = 0;
          vm.sinister_obs_asc = 0;
          vm.sinister_fint_asc = 0;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.sinister_npol_asc = asc;
          vm.sinister_num_asc = 0;
          vm.sinister_status_asc = 0;
          vm.sinister_fini_asc = 0;
          vm.sinister_fing_asc = 0;
          vm.sinister_cont_asc = 0;
          vm.sinister_aseg_asc = 0;
          vm.sinister_ramo_asc = 0;
          vm.sinister_subr_asc = 0;
          vm.sinister_obs_asc = 0;
          vm.sinister_fint_asc = 0;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.sinister_cont_asc = asc;
          vm.sinister_num_asc = 0;
          vm.sinister_status_asc = 0;
          vm.sinister_fini_asc = 0;
          vm.sinister_fing_asc = 0;
          vm.sinister_npol_asc = 0;
          vm.sinister_aseg_asc = 0;
          vm.sinister_ramo_asc = 0;
          vm.sinister_subr_asc = 0;
          vm.sinister_obs_asc = 0;
          vm.sinister_fint_asc = 0;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = 0;
          break;
        case 7:
          Generar(par, asc);
          vm.sinister_aseg_asc = asc;
          vm.sinister_num_asc = 0;
          vm.sinister_status_asc = 0;
          vm.sinister_fini_asc = 0;
          vm.sinister_fing_asc = 0;
          vm.sinister_npol_asc = 0;
          vm.sinister_cont_asc = 0;
          vm.sinister_ramo_asc = 0;
          vm.sinister_subr_asc = 0;
          vm.sinister_obs_asc = 0;
          vm.sinister_fint_asc = 0;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.sinister_ramo_asc = asc;
          vm.sinister_num_asc = 0;
          vm.sinister_status_asc = 0;
          vm.sinister_fini_asc = 0;
          vm.sinister_fing_asc = 0;
          vm.sinister_npol_asc = 0;
          vm.sinister_cont_asc = 0;
          vm.sinister_aseg_asc = 0;
          vm.sinister_subr_asc = 0;
          vm.sinister_obs_asc = 0;
          vm.sinister_fint_asc = 0;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.sinister_subr_asc = asc;
          vm.sinister_num_asc = 0;
          vm.sinister_status_asc = 0;
          vm.sinister_fini_asc = 0;
          vm.sinister_fing_asc = 0;
          vm.sinister_npol_asc = 0;
          vm.sinister_cont_asc = 0;
          vm.sinister_aseg_asc = 0;
          vm.sinister_ramo_asc = 0;
          vm.sinister_obs_asc = 0;
          vm.sinister_fint_asc = 0;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.sinister_obs_asc = asc;
          vm.sinister_num_asc = 0;
          vm.sinister_status_asc = 0;
          vm.sinister_fini_asc = 0;
          vm.sinister_fing_asc = 0;
          vm.sinister_npol_asc = 0;
          vm.sinister_cont_asc = 0;
          vm.sinister_aseg_asc = 0;
          vm.sinister_ramo_asc = 0;
          vm.sinister_subr_asc = 0;
          vm.sinister_fint_asc = 0;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.sinister_obs_asc = 0;
          vm.sinister_num_asc = 0;
          vm.sinister_status_asc = 0;
          vm.sinister_fini_asc = 0;
          vm.sinister_fing_asc = 0;
          vm.sinister_npol_asc = 0;
          vm.sinister_cont_asc = 0;
          vm.sinister_aseg_asc = 0;
          vm.sinister_ramo_asc = 0;
          vm.sinister_subr_asc = 0;
          vm.sinister_fint_asc = asc;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = 0;
          break;
        // case 12:
        //   Generar(par, asc);
        //   vm.sinister_obs_asc = 0;
        //   vm.sinister_num_asc = 0;
        //   vm.sinister_status_asc = 0;
        //   vm.sinister_fini_asc = 0;
        //   vm.sinister_fing_asc = 0;
        //   vm.sinister_npol_asc = 0;
        //   vm.sinister_cont_asc = 0;
        //   vm.sinister_aseg_asc = 0;
        //   vm.sinister_ramo_asc = 0;
        //   vm.sinister_subr_asc = 0;
        //   vm.sinister_fint_asc = 0;
        //   vm.sinister_affect_asc = asc;
        //   vm.sinister_reclamado_asc = 0;
        //   break;
        case 12:
          Generar(par, asc);
          vm.sinister_obs_asc = 0;
          vm.sinister_num_asc = 0;
          vm.sinister_status_asc = 0;
          vm.sinister_fini_asc = 0;
          vm.sinister_fing_asc = 0;
          vm.sinister_npol_asc = 0;
          vm.sinister_cont_asc = 0;
          vm.sinister_aseg_asc = 0;
          vm.sinister_ramo_asc = 0;
          vm.sinister_subr_asc = 0;
          vm.sinister_fint_asc = 0;
          vm.sinister_affect_asc = 0;
          vm.sinister_reclamado_asc = asc;
          break;
      }
    }
    activate();
    getCelulasContractor();

    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }
    vm.form.until = convertDate(new Date());
    // var endingDate =  convertDate(new Date().setYear(new Date().getFullYear() + 1));
    var endingDate = convertDate(new Date());
    vm.form.until = endingDate;

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      getProviders();
      getUsuarios();
      getSubramos();

      vm.form.contratante =
        savedFiltersSiniestro && savedFiltersSiniestro["contratante"]
          ? savedFiltersSiniestro["contratante"]
          : "";
      vm.form.num_poliza =
        savedFiltersSiniestro && savedFiltersSiniestro["num_poliza"]
          ? savedFiltersSiniestro["num_poliza"]
          : "";
      vm.form.status =
        savedFiltersSiniestro && savedFiltersSiniestro["status"]
          ? savedFiltersSiniestro["status"]
          : 0;
      vm.form.businesLine =
        savedFiltersSiniestro && savedFiltersSiniestro["businesLine"]
          ? savedFiltersSiniestro["businesLine"]
          : "";
      vm.form.celula =
        savedFiltersSiniestro && savedFiltersSiniestro["celula"]
          ? savedFiltersSiniestro["celula"]
          : 0;
      vm.form.group_by =
        savedFiltersSiniestro && savedFiltersSiniestro["group_by"]
          ? savedFiltersSiniestro["group_by"]
          : "";
      vm.form.report =
        savedFiltersSiniestro && savedFiltersSiniestro["report"]
          ? savedFiltersSiniestro["report"]
          : 0;
      vm.word =
        savedFiltersSiniestro && savedFiltersSiniestro["caratula"]
          ? savedFiltersSiniestro["caratula"]
          : "";
    }

    $scope.open_in_same_tab_natural = function (
      name,
      route,
      params,
      identifier
    ) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $state.go($scope.route_for_new_tab, params);
    };

    function goToInfo(insurance) {
      if (vm.acceso_adm_sin) {
        if (insurance.poliza.accidents_policy.length > 0) {
          $scope.open_in_same_tab_natural(
            "Información siniestros",
            "siniestros.info",
            { siniestroId: insurance.id },
            insurance.id
          );
          // $state.go('siniestros.info', {siniestroId: insurance.id});
        } else if (insurance.poliza.automobiles_policy.length > 0) {
          $scope.open_in_same_tab_natural(
            "Información siniestros",
            "siniestros.info",
            { siniestroId: insurance.id },
            insurance.id
          );
          // $state.go('siniestros.auto_info', {siniestroId: insurance.id});
        } else if (insurance.poliza.life_policy.length > 0) {
          $scope.open_in_same_tab_natural(
            "Información siniestros",
            "siniestros.vida_info",
            { siniestroId: insurance.id },
            insurance.id
          );
          // $state.go('siniestros.vida_info', {siniestroId: insurance.id});
        }
      }
    }
    vm.getCaratulas = getCaratulas;
    function getCaratulas(parId) {
      var results = [];
      var mapeo_caratulas = [];
      if (parId) {
        if (parId.val.length >= 3) {
          $scope.show_cds = "get-all-caratulas/";
          $http({
            method: "POST",
            url: url.IP + $scope.show_cds,
            data: {
              word: parId.val,
            },
          })
            .then(
              function success(request) {
                var results = [];
                var mapeo_caratulas = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    vm.only_caratula_poliza = 0;
                    $scope.autocompleteData = [];
                    vm.word.id = 0;
                    toaster.warning("Carátula no encontrada");
                  } else {
                    request.data.forEach(function (poliza) {
                      vm.policy = poliza;
                      if (poliza.document_type == 11) {
                        mapeo_caratulas.push(poliza);
                      }
                    });
                    results = _.map(mapeo_caratulas, function (item) {
                      if (item.contractor) {
                        var label =
                          item.poliza_number +
                          " - " +
                          item.contractor.full_name +
                          " - " +
                          convertDate(vm.policy.start_of_validity) +
                          " - " +
                          convertDate(vm.policy.end_of_validity);
                      } else {
                        var label = item.poliza_number;
                      }
                      return {
                        label: label,
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                      };
                    });
                    $scope.autocompleteData = results;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        } else {
          vm.only_caratula_poliza = 0;
          $scope.autocompleteData = [];
          vm.word.id = 0;
        }
      }
    }
    vm.getCarSelected = getCarSelected;
    function getCarSelected(caratula) {
      vm.only_caratula_poliza = caratula.id;
    }
    $scope.$watch("vm.word", function (newValue, oldValue) {
      if (vm.word) {
        if (vm.word.id) {
          vm.only_caratula_poliza = parseInt(vm.word.id);
        } else {
          vm.only_caratula_poliza = 0;
        }
      }
    });
    $scope.showButtonExcel = false;
    function Generar(order, asc, parPage) {
      //$('#example').DataTable().destroy();
      setTimeout(function () {
        paso++;

        $("#example").DataTable().destroy();
        // DataTable initialisation
        $("#example").DataTable({
          dom:
            "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" +
            "<'row'<'col-sm-12'tr>>" +
            "<'row'<'col-sm-12'p<br/>i>>",
          info: false,
          paging: false,
          autoWidth: true,
          columnDefs: [
            {
              visible: false,
              targets: hCols,
            },
            {
              type: "non-empty-string",
              targets: 0,
            },
          ],
          buttons: [
            {
              extend: "colvis",
              collectionLayout: "three-column",
              text: function () {
                var totCols = $("#example thead th").length;
                var hiddenCols = hCols.length;
                var shownCols = totCols - hiddenCols;
                return "Columnas (" + shownCols + " de " + totCols + ")";
              },
              prefixButtons: [
                {
                  extend: "colvisGroup",
                  text: "Mostrar todo",
                  show: ":hidden",
                },
                {
                  extend: "colvisRestore",
                  text: "Restaurar",
                },
              ],
            },
          ],
          oLanguage: {
            oPaginate: {
              sNext: '<span class="pagination-default">&#x276f;</span>',
              sPrevious: '<span class="pagination-default">&#x276e;</span>',
            },
          },
          initComplete: function (settings, json) {
            // Adjust hidden columns counter text in button -->
            $("#example").on(
              "column-visibility.dt",
              function (e, settings, column, state) {
                var index = hCols.indexOf(column);
                if (state === false) {
                  if (index === -1) {
                    hCols.push(column);
                  }
                }
                if (
                  $(".dt-button-collection.dropdown-menu.three-column")
                    .length === 1 &&
                  state === true
                ) {
                  // console.log($('.dt-button-collection.dropdown-menu.three-column').length);
                  if (index !== -1) {
                    hCols.splice(index, 1);
                  }
                  // console.log("si entro");
                }
                // var visCols = $('#example thead tr:first th').length;

                //Below: The minus 2 because of the 2 extra buttons Show all and Restore
                var tblCols =
                  $(".dt-button-collection li[aria-controls=example] a")
                    .length - 2;
                var visCols = tblCols - hCols.length;
                $(".buttons-colvis[aria-controls=example] span").html(
                  "Columnas (" + visCols + " de " + tblCols + ")"
                );
                e.stopPropagation();
              }
            );
          },
        });
      }, 2000);
      var l = Ladda.create(document.querySelector(".ladda-buttonC"));
      l.start();
      $scope.order = order;
      $scope.asc = asc;

      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }

      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.comision = 0;

      var params = {
        provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider,
        ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
        subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        status: vm.form.status.id ? vm.form.status.id : vm.form.status,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        type_contractor: vm.form.contratante.type
          ? vm.form.contratante.type
          : 0,
        order: order,
        asc: asc,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        users: vm.usuarios_selected ? vm.usuarios_selected : 0,
        page: parPage ? parPage : 1,
        report: vm.form.report.id ? vm.form.report.id : 1,
        group_by: vm.form.group_by ? vm.form.group_by.id : 0,
        num_poliza: vm.form.num_poliza,
        businessLine: $scope.bLine ? $scope.bLine.id : 0,
        only_caratula: vm.only_caratula_poliza ? vm.only_caratula_poliza : 0,
      };
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          params.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }

      params.celula = cel ? cel : 0;
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      $scope.filtros = params;
      $scope.search_siniester = "reporte-siniestros-rep/";
      $http({
        method: "POST",
        url: url.IP + $scope.search_siniester,
        data: $scope.filtros,
      }).then(function success(response) {
        if (params.group_by == 0) {
          $("#example").DataTable().clear();
          $("#example").DataTable().destroy();
          $scope.grupos_result = [];
          $scope.insurances = response.data.results;
          l.stop();

          for (var i = 0; i < $scope.insurances.length; i++) {
            if ($scope.insurances[i].ramo != "Daños") {
              $scope.insurances[i].status =
                $scope.insurances[i].status == 1
                  ? "Pendiente"
                  : $scope.insurances[i].status == 2
                  ? "En Trámite"
                  : $scope.insurances[i].status == 3
                  ? "Completada/Procedente"
                  : $scope.insurances[i].status == 4
                  ? "Cancelado"
                  : $scope.insurances[i].status == 5
                  ? "Rechazada/ No Procedente"
                  : $scope.insurances[i].status == 6
                  ? " En espera/ Solicitud de Información"
                  : $scope.insurances[i].status == 7
                  ? "Reproceso"
                  : "Inconformidad";
            } else {
              $scope.insurances[i].status =
                $scope.insurances[i].status == 1
                  ? "Pendiente"
                  : $scope.insurances[i].status == 2
                  ? "En Trámite"
                  : $scope.insurances[i].status == 3
                  ? "Completado"
                  : $scope.insurances[i].status == 4
                  ? "Cancelado"
                  : $scope.insurances[i].status == 5
                  ? "Rechazado"
                  : $scope.insurances[i].status == 6
                  ? "En espera"
                  : $scope.insurances[i].status == 7
                  ? "Reproceso"
                  : "Inconformidad";
            }

            $scope.subramo = $scope.insurances[i].poliza.subramo;
            if ($scope.insurances[i].accidente_sinister.length != 0) {
              if ($scope.insurances[i].accidente_sinister[0]) {
                $scope.insurances[i].reclamado =
                  $scope.insurances[i].accidente_sinister[0].total_reclamado;
                $scope.insurances[i].procedente =
                  $scope.insurances[i].accidente_sinister[0].total_procedente;
                $scope.insurances[i].deducible =
                  $scope.insurances[i].accidente_sinister[0].total_deducible;
                $scope.insurances[i].coaseguro =
                  $scope.insurances[i].accidente_sinister[0].total_coaseguro;
                if (
                  $scope.insurances[i].accidente_sinister[0].total_final !=
                    0.0 ||
                  $scope.insurances[i].accidente_sinister[0].total_final !=
                    "0.00"
                ) {
                  $scope.insurances[i].total_final =
                    $scope.insurances[i].accidente_sinister[0].total_final;
                } else {
                  $scope.insurances[i].total_final =
                    parseFloat(
                      $scope.insurances[i].accidente_sinister[0]
                        .total_procedente
                    ) -
                    parseFloat(
                      $scope.insurances[i].accidente_sinister[0].total_deducible
                    ) -
                    parseFloat(
                      $scope.insurances[i].accidente_sinister[0].total_coaseguro
                    );
                }
              } else {
                $scope.insurances[i].reclamado = 0;
                $scope.insurances[i].procedente = 0;
                $scope.insurances[i].deducible = 0;
                $scope.insurances[i].coaseguro = 0;
                $scope.insurances[i].total_final = 0;
              }
            } else {
              $scope.insurances[i].reclamado = 0;
              $scope.insurances[i].procedente = 0;
              $scope.insurances[i].deducible = 0;
              $scope.insurances[i].coaseguro = 0;
              $scope.insurances[i].total_final = 0;
            }
          }

          $scope.insurances.forEach(function (item, index) {
            $http({
              method: "GET",
              url: url.IP + "comments/",
              params: {
                model: 5,
                id_model: item.id,
              },
            }).then(function (res) {
              var comments_ = res.data.results;
              var last_comment = null;

              if (comments_.length) {
                //var x = (comments_.length) -1;
                last_comment = comments_[0];
              }
              $scope.insurances[index].last_comment = last_comment;
            });
          });

          //console.log($scope.insurances);
          //$scope.insurances

          $scope.count_insurances = angular.copy($scope.insurances);
          if ($scope.insurances.length < 10) {
            for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
              var object = {
                numero_siniestro: " ",
                status: " ",
                fecha_siniestro: " ",
                fecha_inicio: " ",
                poliza: {
                  poliza_number: " ",
                  natural: " ",
                  aseguradora: " ",
                  ramo: " ",
                  subramo: " ",
                },
                reason: " ",
              };
              $scope.insurances.push(object);
            }
          }

          $scope.sinisters_config = {
            count: response.data.count,
            previous: response.data.previous,
            next: response.data.next,
          };
          vm.show_pag_sinisters = true;
          $scope.obtenerPaginacion(response.data, parPage ? parPage : 1);
          // testPagination('insurances', 'sinisters_config');

          if ($scope.insurances[0].numero_siniestro == " ") {
            toaster.warning("No se encontraron registros");
            $("#example").DataTable().clear();
            $("#example").DataTable().draw();
            $("#example").DataTable().destroy();
          } else {
            $scope.showButtonExcel = true;
          }
        } else {
          l.stop();
          $scope.grupos_result = response.data;
          $scope.showButtonExcel = true;
        }
        $("#example").DataTable().destroy();
      });

      savedFiltersSiniestro = angular.copy($scope.filtros);
      savedFiltersSiniestro["contratante"] = vm.form.contratante;
      savedFiltersSiniestro["num_poliza"] = vm.form.num_poliza;
      savedFiltersSiniestro["status"] = vm.form.status;
      savedFiltersSiniestro["businesLine"] = vm.form.businesLine;
      savedFiltersSiniestro["celula"] = vm.form.celula;
      savedFiltersSiniestro["group_by"] = vm.form.group_by;
      savedFiltersSiniestro["report"] = vm.form.report;
      savedFiltersSiniestro["caratula"] = vm.word;
    }

    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      savedFiltersSiniestro["page"] = pagina;
      vm.Generar(
        savedFiltersSiniestro && savedFiltersSiniestro["order"]
          ? savedFiltersSiniestro["order"]
          : 1,
        savedFiltersSiniestro && savedFiltersSiniestro["asc"]
          ? savedFiltersSiniestro["asc"]
          : 1,
        pagina
      );
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        savedFiltersSiniestro["page"] = $scope.paginacion["paginaActual"] - 1;
        vm.Generar(
          savedFiltersSiniestro && savedFiltersSiniestro["order"]
            ? savedFiltersSiniestro["order"]
            : 1,
          savedFiltersSiniestro && savedFiltersSiniestro["asc"]
            ? savedFiltersSiniestro["asc"]
            : 1,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        savedFiltersSiniestro["page"] = $scope.paginacion["paginaActual"] + 1;
        vm.Generar(
          savedFiltersSiniestro && savedFiltersSiniestro["order"]
            ? savedFiltersSiniestro["order"]
            : 1,
          savedFiltersSiniestro && savedFiltersSiniestro["asc"]
            ? savedFiltersSiniestro["asc"]
            : 1,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };

    $scope.exportData = function (name) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "data:application/vnd.ms-excel;charset=UTF-8",
        }
      );
      saveAs(blob, "Reporte_" + name + ".xls");
    };
    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        console.log(data);
        vm.providers = data.data;
      });
    }
    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }

    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }
    $scope.exportDataExcel = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            // templateUrl: 'app/reportes/reportexcel.option.html',
            // controller: 'ReportExcelByCtrl',
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "md",
            resolve: {
              filters: function () {
                return $scope.filtros;
              },
              from: function () {
                return null;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.filtros.orden = $scope.columnArray;
        $scope.filtros.export_type = 2;
        var $listM = $("#example th")
          .map(function () {
            return $.trim($(this).text());
          })
          .get();

        if ($listM.includes("Inicial / Complemento")) {
          $listM.push("Inicial / Complemento");
        }
        if ($listM.includes("Folio de la Aseguradora")) {
          $listM.push("Folio de la Aseguradora");
        }
        if ($listM.includes("Tipo de Pago")) {
          $listM.push("Tipo de Pago");
        }
        if ($listM.includes("Padecimiento")) {
          $listM.push("Padecimiento");
        }
        if ($listM.includes("Fecha Compromiso")) {
          $listM.push("Fecha Compromiso");
        }
        if ($listM.includes("Inicio Póliza")) {
          $listM.push("Inicio Póliza");
        }
        if ($listM.includes("Modelo")) {
          $listM.push("Modelo");
        }
        if ($listM.includes("Marca")) {
          $listM.push("Marca");
        }
        if ($listM.includes("Versión")) {
          $listM.push("Versión");
        }
        if ($listM.includes("Creado por")) {
          $listM.push("Creado por");
        }
        if ($listM.includes("Fin Póliza")) {
          $listM.push("Fin Póliza");
        }
        if ($listM.includes("Tipo")) {
          $listM.push("Tipo");
        }
        if ($listM.includes("Afectado")) {
          $listM.push("Afectado");
        }
        if ($listM.includes("Ramo")) {
          $listM.push("Ramo");
        }

        if ($listM.includes("No Siniestro")) {
          $listM.push("No Siniestro");
        }
        if ($listM.includes("Folio")) {
          $listM.push("Folio");
        }
        if ($listM.includes("Proveedor")) {
          $listM.push("Proveedor");
        }
        if ($listM.includes("No.Póliza")) {
          $listM.push("No.Póliza");
        }
        if ($listM.includes("Fecha en que Ocurrio")) {
          $listM.push("Fecha en que Ocurrio");
        }
        if ($listM.includes("Tipo de trámite")) {
          $listM.push("Tipo de trámite");
        }
        if ($listM.includes("Fecha creación")) {
          $listM.push("Fecha de creación");
        }
        if ($listM.includes("Referenciador")) {
          $listM.push("Referenciador");
        }
        if ($listM.includes("Grupo")) {
          $listM.push("Grupo");
        }
        if ($listM.includes("Bitácora")) {
          $listM.push("Bitácora");
        }
        if ($listM.includes("Procedente")) {
          $listM.push("Procedente");
        }
        if ($listM.includes("Deducible")) {
          $listM.push("Deducible");
        }
        if ($listM.includes("Coaseguro")) {
          $listM.push("Coaseguro");
        }
        if ($listM.includes("Total Final")) {
          $listM.push("Total Final");
        }
        if ($listM.includes("Creado Por")) {
          $listM.push("Creado Por");
        }

        var scolumns = [
          "No Siniestro",
          "Folio",
          "Afectado",
          "Versión",
          "Marca",
          "Modelo",
          "Estatus",
          "Fecha en que Ocurrio",
          "Fecha de Ingreso",
          "No.Póliza",
          "Contratante",
          "Grupo",
          "Proveedor",
          "Ramo",
          "Subramo",
          "Reclamado",
          "Procedente",
          "Deducible",
          "Coaseguro",
          "Total Final",
          "Observaciones",
          "Tipo de trámite",
          "Fecha de creación",
          "Referenciador",
          "Bitácora",
          "Número de Serie",
          "Subgrupo",
          "Subsubgrupo",
          "Agrupación",
          "Subagrupación",
          "Subsubagrupación",
          "Clasificación",
          "Línea de Negocio",
          "Célula",
          "Fecha Terminación",
          "Fecha Bitácora",
          "Creado Por",
          "Folio de la Aseguradora",
        ];

        var foo = [];

        $.grep(scolumns, function (el) {
          if ($.inArray(el, $listM) != -1) {
            foo.push(el);
          }
        });

        $scope.filtros["cols1"] = foo;
        if (param == 1) {
          $scope.excel_siniester = "service_reporte-siniestrosReport-excel";
          $http({
            method: "POST",
            url: url.IP + $scope.excel_siniester,
            data: $scope.filtros,
            headers: {
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "arraybuffer",
          })
            .then(function (data) {
              if (data.status == 200) {
                l.stop();
                var blob = new Blob([data.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, "Reporte_Siniestros.xls");
              } else {
                SweetAlert.swal(
                  "Error",
                  "Ha ocurrido un error al descargar el reporte",
                  "error"
                );
                l.stop();
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }
    // -----------PAGINACIÓN
    $scope.actual_page = 1;

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      // $scope.selectPage = function (parPage) {

      //   if(config_.next || config_.previous) {

      //     if(config_.next) {
      //       var next_ = config_.next;
      //       var otherParameters = config_.next.substring(config_.next.indexOf("&page=") + 6);

      //       if(next_.search('&status=') !== -1) {
      //         var status = next_.substring(next_.indexOf("&status=") + 1);
      //       } else {
      //         var status = '';
      //       }

      //       var url = config_.next.substring(0, config_.next.indexOf("&page=") + 6);
      //       url += parPage.toString();
      //       url += '&'+status

      //       if(config_.next.search('&') !== -1) {
      //         var params = otherParameters.substring(2, otherParameters.indexOf('&')+1000);
      //         url += '&'+params;
      //       }

      //     } else {

      //       var prev_ = config_.previous;
      //       var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
      //       if(prev_.search('&status=') !== -1) {
      //         var status = prev_.substring(prev_.indexOf("&status=") + 1);
      //       } else {
      //         var status = '';
      //       }

      //       if(prev_.search('&page=') !== -1) {
      //         var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
      //         url += parPage.toString();
      //         url += '&'+status;

      //       } else {
      //         var url = config_.previous
      //       }
      //       if(config_.prev_.search('&') !== -1) {
      //         var params = otherParameters.substring(2, otherParameters.indexOf('&')+1000);
      //       url += '&'+params;
      //       }
      //     }
      //   }

      //   // url += '&status=1'
      //   getSinistersPag(url);
      //   if($scope.actual_page > 1) {
      //     $scope.not_prev = false;
      //   }

      //   if($scope.actual_page == $scope.totalPages.length -1) {
      //     $scope.not_next = true;
      //   }

      // };
      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getSinistersPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              $scope.data_pagination = request.data.results;
              for (var i = 0; i < $scope.data_pagination.length; i++) {
                $scope.data_pagination[i].status =
                  $scope.data_pagination[i].status == 1
                    ? "Pendiente"
                    : $scope.data_pagination[i].status == 2
                    ? "En Trámite"
                    : $scope.data_pagination[i].status == 3
                    ? "Completado"
                    : $scope.data_pagination[i].status == 4
                    ? "Cancelado"
                    : "Rechazado";
              }
              $scope.count_pagination = angular.copy($scope.data_pagination);
              if ($scope.data_pagination.length < 10) {
                for (var i = 0; i < 10 - $scope.count_pagination.length; i++) {
                  var object = {
                    numero_siniestro: " ",
                    status: " ",
                    fecha_siniestro: " ",
                    fecha_inicio: " ",
                    poliza: {
                      poliza_number: " ",
                      natural: " ",
                      aseguradora: " ",
                      ramo: " ",
                      subramo: " ",
                    },
                    reason: " ",
                  };
                  $scope.data_pagination.push(object);
                }
              }

              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }

    // -----------------PAGINACIÓN

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            vm.ramos = response.data;
          });
      }
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }

    $scope.selectRamos = function (sel) {
      $scope.ramo_slc = true;
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };

    jQuery(function ($) {
      $("#exportButton").click(function () {
        // parse the HTML table element having an id=exportTable
        var dataSource = shield.DataSource.create({
          data: "#exportTable",
          schema: {
            type: "table",
            fields: {
              Recibo: { type: String },
              RPF: { type: Number },
              Estatus: { type: String },
            },
          },
        });

        // when parsing is done, export the data to PDF
        dataSource.read().then(function (data) {
          var pdf = new shield.exp.PDFDocument({
            author: "PrepBootstrap",
            created: new Date(),
          });

          pdf.addPage("a4", "portrait");

          pdf.table(
            50,
            50,
            data,
            [
              { field: "Recibo", title: "Número de Recibo", width: 200 },
              { field: "RPF", title: "RPF", width: 50 },
              { field: "Estatus", title: "Estatus del recibo", width: 200 },
            ],
            {
              margins: {
                top: 50,
                left: 50,
              },
            }
          );

          pdf.saveAs({
            fileName: "ReporteSiniestros",
          });
        });
      });
    });
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      $scope.infoUser = $sessionStorage.infoUser;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        var param = 1;
        if (option) {
          // Totales de la Agrupación
          var filter_siniester = "service_reporte-siniestrosReport-excel";
          if (option == 1) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            filters.export_type = option;
            $http({
              method: "POST",
              url: url.IP + filter_siniester,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Siniestros.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          } else if (option == 2) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            filters.export_type = option;
            $http({
              method: "POST",
              url: url.IP + filter_siniester,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Siniestros.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "ReporteRenovacionesPendientesController",
      ReporteRenovacionesPendientesController
    );

  ReporteRenovacionesPendientesController.$inject = [
    "appStates",
    "$sessionStorage",
    "$state",
    "$uibModal",
    "url",
    "$scope",
    "$http",
    "providerService",
    "toaster",
    "SweetAlert",
    "MESSAGES",
    "$parse",
    "exportFactory",
    "$localStorage",
  ];

  function ReporteRenovacionesPendientesController(
    appStates,
    $sessionStorage,
    $state,
    $uibModal,
    url,
    $scope,
    $http,
    providerService,
    toaster,
    SweetAlert,
    MESSAGES,
    $parse,
    exportFactory,
    $localStorage
  ) {
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.table = {};
    vm.changeUntil = changeUntil;
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.formatearNumero = formatearNumero;
    vm.changeRenewal = changeRenewal;
    vm.goToInfo = goToInfo;

    $scope.infoUser = $sessionStorage.infoUser;

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: "",
      grupo: 0,
      cve: "",
      validity: 2,
      renovadas: 2,
    };
    vm.table = {
      headers: [
        "Número de Póliza",
        "Tipo",
        "Contratante",
        "Aseguradora",
        "Ramo",
        "Subramo",
        "Paquete",
        "Frecuencia de Pago",
        "Estatus Póliza",
        "Inicio Vigencia",
        "Fecha de Creación",
        "Folio",
        "Moneda",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Observaciones",
        "Clave de Agente",
        "Fin Vigencia",
      ],
    };

    vm.option = [
      {
        id: 1,
        name: "Renovadas",
      },
      {
        id: 2,
        name: "Por renovar",
      },
    ];

    vm.validity = [
      {
        id: 1,
        name: "Inicio de vigencia",
      },
      {
        id: 2,
        name: "Fin de vigencia",
      },
    ];

    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por Iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
      {
        id: 15,
        name: "No renovada",
      },
    ];

    vm.group_by = [
      {
        id: 1,
        name: "Aseguradora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 7,
        name: "Usuario",
      },
    ];

    // $(window).load(function() {
    //     $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    $(".js-example-basic-multiple").select2();
    $scope.columnArray = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;

    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };
    $scope.orden = function (value) {
      $scope.insurances.forEach(function (id) {
        if (id.id) {
          $http({
            method: "GET",
            url: url.IP + "historic-policies/",
            params: {
              actual_id: id.id,
            },
          }).then(function success(response) {
            if (response.data.results.length) {
              vm.showHistoric = true;
            }
            vm.policy_history = [];
            response.data.results.forEach(function function_name(old) {
              if (old.base_policy) {
                if (id.id == old.base_policy.id) {
                  // vm.policy_history.push(old.base_policy);
                  if (old.new_policy) {
                    id.historic =
                      "Folio Interno: " + old.new_policy.internal_number;
                  }
                } else {
                  if (old.base_policy) {
                    // id.historic ='Renovada de: '+old.base_policy.internal_number;
                  }
                }
              }
            });
          });
        }
      });
    };

    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }
    activate();
    vm.form.since = convertDate(new Date());
    vm.form.until = convertDate(new Date());

    function activate() {
      getProviders();
      getUsuarios();
      getSubramos();
      $(".js-example-basic-multiple").select2();
      $scope.total = 0;
      vm.form.renovadas = {
        id: 2,
        name: "Por renovar",
      };

      vm.form.contratante =
        $localStorage.saved_filters_reporte_reno_pendiente &&
        $localStorage.saved_filters_reporte_reno_pendiente["contratante"]
          ? $localStorage.saved_filters_reporte_reno_pendiente["contratante"]
          : "";
      vm.form.group =
        $localStorage.saved_filters_reporte_reno_pendiente &&
        $localStorage.saved_filters_reporte_reno_pendiente["group"]
          ? $localStorage.saved_filters_reporte_reno_pendiente["group"]
          : "";
      vm.form.status =
        $localStorage.saved_filters_reporte_reno_pendiente &&
        $localStorage.saved_filters_reporte_reno_pendiente["status"]
          ? $localStorage.saved_filters_reporte_reno_pendiente["status"]
          : 0;
      vm.form.payment =
        $localStorage.saved_filters_reporte_reno_pendiente &&
        $localStorage.saved_filters_reporte_reno_pendiente["payment"]
          ? $localStorage.saved_filters_reporte_reno_pendiente["payment"]
          : 0;
      vm.form.cve_agente =
        $localStorage.saved_filters_reporte_reno_pendiente &&
        $localStorage.saved_filters_reporte_reno_pendiente["cve_agente"]
          ? $localStorage.saved_filters_reporte_reno_pendiente["cve_agente"]
          : "";
      vm.form.group_by =
        $localStorage.saved_filters_reporte_reno_pendiente &&
        $localStorage.saved_filters_reporte_reno_pendiente["group_by"]
          ? $localStorage.saved_filters_reporte_reno_pendiente["group_by"]
          : 0;
      vm.form.validity =
        $localStorage.saved_filters_reporte_reno_pendiente &&
        $localStorage.saved_filters_reporte_reno_pendiente["validity"]
          ? $localStorage.saved_filters_reporte_reno_pendiente["validity"]
          : 0;
    }

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        console.log(data);
        vm.providers = data.data;
      });
    }
    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }
    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
      return dateObject;
    }

    function changeGroupBy() {
      $scope.grupos_result = [];
      $scope.showSums = false;
      vm.show_pag_cobranza = false;
    }

    function changeRenewal(par, asc) {
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.renewal_nump_asc = asc;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = asc;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = asc;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = asc;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = asc;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = asc;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 7:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = asc;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = asc;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = asc;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = asc;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = asc;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 12:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = asc;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 13:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = asc;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 14:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = asc;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 15:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = asc;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 16:
          Generar(par, asc);
          vm.renewal_nump_asc = asc;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = asc;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 17:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = asc;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 18:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = asc;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 19:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = asc;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 20:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = asc;
          vm.renewal_clave_asc = 0;
          break;
        case 21:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = asc;
          break;
        case 22:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_fin_asc = asc;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
      }
    }

    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group.val) {
        var word_data = vm.form.group.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    $scope.open_in_same_tab_natural = function (
      name,
      route,
      params,
      identifier
    ) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };

    function goToInfo(insurance) {
      if (vm.acceso_ver_pol) {
        if (insurance.document_type == "Póliza") {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "polizas.info",
            { polizaId: insurance.id },
            insurance.id
          );
          // $state.go('polizas.info', {polizaId: insurance.id})
        } else if (insurance.document_type == "Colectividad") {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "colectividades.info",
            { polizaId: insurance.id },
            insurance.id
          );
          // $state.go('colectividades.info', {polizaId: insurance.id})
        }
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    $scope.showButtonExcel = false;

    function Generar(order, asc, parPage) {
      var l = Ladda.create(document.querySelector(".ladda-buttonC"));
      l.start();

      $scope.order = order;
      $scope.asc = asc;
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));

      if (antiguedad < 0) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }

      $scope.prima_neta = 0;
      $scope.sub_total = 0;
      $scope.comision = 0;
      if (vm.form.provider) {
        var p = vm.form.provider.id;
      } else {
        var p = 0;
      }
      if (vm.form.ramo) {
        var r = vm.form.ramo.id;
      } else {
        var r = 0;
      }
      if (vm.form.subramo) {
        var s = vm.form.subramo.id;
      } else {
        var s = 0;
      }
      if (vm.form.status) {
        var e = vm.form.status.id;
      } else {
        var e = 0;
      }
      if (vm.form.payment) {
        var f = vm.form.payment.id;
      } else {
        var f = 0;
      }
      if (vm.form.contratante) {
        var c = vm.form.contratante.value;
      } else {
        var c = vm.form.contratante;
      }
      if (vm.form.group) {
        if (!vm.form.group.val) {
          var g = 0;
        } else {
          var g = vm.form.group;
        }
      } else {
        var g = vm.form.group;
      }
      if (vm.form.validity) {
        var v = vm.form.validity;
      } else {
        var v = vm.form.validity;
      }

      var params = {
        provider: p,
        ramo: r,
        subramo: s,
        since: vm.form.since,
        until: vm.form.until,
        payment: f,
        status: e,
        contratante: c ? c : 0,
        grupo: g ? g.value : 0,
        cve: vm.form.cve_agente ? vm.form.cve_agente : 0,
        validity: v.id ? v.id : 2,
        order: order,
        asc: asc,
        renovadas: vm.form.renovadas.id ? vm.form.renovadas.id : 1,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        users: vm.usuarios_selected ? vm.usuarios_selected : 0,
        page: parPage ? parPage : 1,
        group_by: vm.form.group_by ? vm.form.group_by.id : 0,
      };
      if (params.grupo == undefined) {
        params.grupo = 0;
      }
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          params.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.group) {
        if (vm.form.group.val == "") {
          params.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
      }
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      $scope.filtros = params;
      $scope.search_renewal = "reporte-renovaciones-rep/";
      $http({
        method: "POST",
        url: url.IP + $scope.search_renewal,
        data: $scope.filtros,
      }).then(function success(response) {
        if (params.group_by == 0) {
          // $scope.insurances = response.data.results;
          $scope.insurances = response.data.results;
          $scope.orden($scope.insurances);
          l.stop();
          var i = 0;
          var j = 0;
          $scope.insurances.forEach(function (pago) {
            var fpago = pago.forma_de_pago;
            switch (fpago) {
              case 1:
                $scope.insurances[i].forma_de_pago = "Mensual";
                break;
              case 2:
                $scope.insurances[i].forma_de_pago = "Bimestral";
                break;
              case 3:
                $scope.insurances[i].forma_de_pago = "Trimestral";
                break;
              case 5:
                $scope.insurances[i].forma_de_pago = "Contado";
                break;
              case 6:
                $scope.insurances[i].forma_de_pago = "Semestral";
                break;
              case 12:
                $scope.insurances[i].forma_de_pago = "Anual";
                break;
              case 24:
                $scope.insurances[i].forma_de_pago = "Quincenal";
                break;
              case 4:
                $scope.insurances[i].forma_de_pago = "Cuatrimestral";
                break;
            }
            i = i + 1;
            var status = pago.status;
            switch (status) {
              case 1:
                $scope.insurances[j].status = "En trámite";
                break;
              case 2:
                $scope.insurances[j].status = "OT Cancelada";
                break;
              case 4:
                $scope.insurances[j].status = "Precancelada";
                break;
              case 10:
                $scope.insurances[j].status = "Por iniciar";
                break;
              case 11:
                $scope.insurances[j].status = "Cancelada";
                break;
              case 12:
                $scope.insurances[j].status = "Renovada";
                break;
              case 13:
                $scope.insurances[j].status = "Vencida";
                break;
              case 14:
                $scope.insurances[j].status = "Vigente";
                break;
              case 15:
                $scope.insurances[j].status = "No renovada";
                break;
              case 16:
                $scope.insurances[j].status = "Siniestrada";
                break;
            }
            j = j + 1;
          });

          $scope.insurances = response.data.results;
          $scope.sumas = response.data.sumas;
          for (var i = 0; i < $scope.insurances.length; i++) {
            $scope.insurances[i].document_type =
              $scope.insurances[i].document_type == 1
                ? "Póliza"
                : "Colectividad";
            $scope.insurances[i].f_currency =
              $scope.insurances[i].f_currency == 1 ? "Pesos" : "Dolares";
          }

          $scope.count_insurances = angular.copy($scope.insurances);
          if ($scope.insurances.length < 10) {
            for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
              var object = {
                poliza_number: " ",
                document_type: " ",
                natural: " ",
                aseguradora: " ",
                ramo: " ",
                subramo: " ",
                paquete: " ",
                forma_de_pago: " ",
                status: " ",
                start_of_validity: " ",
                created_at: " ",
                folio: " ",
                f_currency: " ",
                prima_neta: null,
                rpf: null,
                derecho: null,
                iva: null,
                prima_total: null,
                comision: null,
                observations: " ",
                clave: {
                  clave: " ",
                },
              };
              $scope.insurances.push(object);
            }
          }
          $scope.renovaciones_config = {
            count: response.data.count,
            previous: url.IP + $scope.search_renewal,
            next: url.IP + $scope.search_renewal,
          };
          vm.show_pag_renewal = true;
          testPagination("insurances", "renovaciones_config");
          if ($scope.insurances[0].poliza_number == " ") {
            toaster.warning("No se encontraron registros");
          } else {
            $scope.showButtonExcel = true;
            $scope.showSums = true;
          }
        } else {
          l.stop();
          $scope.grupos_result = response.data.results;
          $scope.showButtonExcel = true;
        }
      });

      $localStorage.saved_filters_reporte_reno_pendiente = angular.copy(
        $scope.filtros
      );
      $localStorage.saved_filters_reporte_reno_pendiente["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_reporte_reno_pendiente["group"] =
        vm.form.group;
      $localStorage.saved_filters_reporte_reno_pendiente["status"] =
        vm.form.status;
      $localStorage.saved_filters_reporte_reno_pendiente["payment"] =
        vm.form.payment;
      $localStorage.saved_filters_reporte_reno_pendiente["cve_agente"] =
        vm.form.cve_agente;
      $localStorage.saved_filters_reporte_reno_pendiente["group_by"] =
        vm.form.group_by;
      $localStorage.saved_filters_reporte_reno_pendiente["validity"] =
        vm.form.validity;
    }
    $scope.actual_page = 1;

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        vm.Generar($scope.order, $scope.asc, parPage);
      };
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getRenewalPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              $scope.data_pagination = request.data.results;
              for (var i = 0; i < $scope.data_pagination.length; i++) {
                $scope.insurances[i].document_type =
                  $scope.insurances[i].document_type == 1
                    ? "Póliza"
                    : "Colectividad";
                $scope.data_pagination[i].f_currency =
                  $scope.data_pagination[i].f_currency == 1
                    ? "Pesos"
                    : "Dolares";
              }
              $scope.count_pagination = angular.copy($scope.data_pagination);
              if ($scope.data_pagination.length < 10) {
                for (var i = 0; i < 10 - $scope.count_pagination.length; i++) {
                  var object = {
                    poliza_number: " ",
                    document_type: " ",
                    natural: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    paquete: " ",
                    forma_de_pago: " ",
                    status: " ",
                    start_of_validity: " ",
                    created_at: " ",
                    folio: " ",
                    f_currency: " ",
                    prima_neta: null,
                    rpf: null,
                    derecho: null,
                    iva: null,
                    prima_total: null,
                    comision: null,
                    observations: " ",
                    clave: {
                      clave: " ",
                    },
                  };
                  $scope.data_pagination.push(object);
                }
              }

              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, $scope.data_pagination);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }
    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            vm.ramos = response.data;
          });
      }
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }
    jQuery(function ($) {
      $("#exportButton").click(function () {
        // parse the HTML table element having an id=exportTable
        var dataSource = shield.DataSource.create({
          data: "#exportTable",
          schema: {
            type: "table",
            fields: {
              Recibo: { type: String },
              RPF: { type: Number },
              Estatus: { type: String },
            },
          },
        });

        // when parsing is done, export the data to PDF
        dataSource.read().then(function (data) {
          var pdf = new shield.exp.PDFDocument({
            author: "PrepBootstrap",
            created: new Date(),
          });

          pdf.addPage("a4", "portrait");

          pdf.table(
            50,
            50,
            data,
            [
              { field: "Recibo", title: "Número de Recibo", width: 200 },
              { field: "RPF", title: "RPF", width: 50 },
              { field: "Estatus", title: "Estatus del recibo", width: 200 },
            ],
            {
              margins: {
                top: 50,
                left: 50,
              },
            }
          );

          pdf.saveAs({
            fileName: "ReporteRenovaciones",
          });
        });
      });
    });

    $scope.exportData = function (name) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "data:application/vnd.ms-excel;charset=UTF-8",
        }
      );
      saveAs(blob, "Reporte_" + name + ".xls");
    };

    $scope.exportDataExcel = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            // templateUrl: 'app/reportes/reportexcel.option.html',
            // controller: 'ReportExcelByCtrl',
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "md",
            resolve: {
              filters: function () {
                return $scope.filtros;
              },
              from: function () {
                return null;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.filtros.orden = $scope.columnArray;
        $scope.filtros.excel_type = 2;
        if (param == 1) {
          $scope.excel_renewal = "service_reporte-renovacionesReport-excel";
          $http({
            method: "POST",
            url: url.IP + $scope.excel_renewal,
            data: $scope.filtros,
            headers: {
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "arraybuffer",
          })
            .then(function (data) {
              if (data.status == 200) {
                l.stop();
                var blob = new Blob([data.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, "Reporte_Renovaciones.xls");
              } else {
                SweetAlert.swal(
                  "Error",
                  "Ha ocurrido un error al descargar el reporte",
                  "error"
                );
                l.stop();
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      $scope.infoUser = $sessionStorage.infoUser;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        var param = 1;
        if (option) {
          // Totales de la Agrupación
          var filter_renewal = "service_reporte-renovacionesReport-excel";
          if (option == 1) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            filters.excel_type = option;
            $http({
              method: "POST",
              url: url.IP + filter_renewal,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Renovaciones.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          } else if (option == 2) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            filters.excel_type = option;
            $http({
              method: "POST",
              url: url.IP + filter_renewal,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Renovaciones.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteRenovacionesController", ReporteRenovacionesController);

  ReporteRenovacionesController.$inject = [
    "dataFactory",
    "$sessionStorage",
    "$state",
    "$uibModal",
    "url",
    "$scope",
    "$http",
    "providerService",
    "toaster",
    "SweetAlert",
    "MESSAGES",
    "$parse",
    "exportFactory",
    "$localStorage",
    "appStates",
  ];

  function ReporteRenovacionesController(
    dataFactory,
    $sessionStorage,
    $state,
    $uibModal,
    url,
    $scope,
    $http,
    providerService,
    toaster,
    SweetAlert,
    MESSAGES,
    $parse,
    exportFactory,
    $localStorage,
    appStates
  ) {
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;
    var savedFiltersRenovaciones = {};
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.GenerarEnProceso = GenerarEnProceso;
    vm.Generar = Generar;
    vm.table = {};
    vm.changeUntil = changeUntil;
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.formatearNumero = formatearNumero;
    vm.changeRenewal = changeRenewal;
    vm.goToInfo = goToInfo;
    vm.accesos = $sessionStorage.permisos;
    vm.only_caratula_poliza = 0;
    $scope.insurances_en_proceso = [];
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: "",
      grupo: 0,
      cve: "",
      validity: 2,
      renovadas: 1,
      businessLine: 0,
      celula: 0,
      only_caratula: 0,
    };
    vm.form.subgrouping = 0;
    vm.form.subsubgrouping = 0;
    vm.form.groupinglevel = 0;
    vm.form.subgrouping = 0;
    vm.form.subsubgrouping = 0;
    vm.form.classification = 0;

    vm.table = {
      headers: [
        "No.Póliza",
        "Tipo",
        "Contratante",
        "Proveedor",
        "Ramo",
        "Subramo",
        "Paquete",
        "Forma de Pago",
        "Estatus Póliza",
        "Inicio Póliza",
        "Fecha de Creación",
        "Folio",
        "Moneda",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Observaciones",
        "Clave",
        "Fin Póliza",

        "Email",
        "Teléfono",
        "Asegurado",
        "Referenciador",
        "Creado por",
        "Fecha renovación",
        "Estatus de la Renovación",
        "Sucursal",
        "Póliza Anterior",
        "Póliza Siguiente",
        "Responsable",
        "C.P.",
        "Identificador",
        "Grupo",
        "Agrupación",
        "Subagrupación",
        "Subsubagrupación",
        "Clasificación",
        "Línea de Negocio",
        "Célula",
        "Contacto(nombre)",
        "Contacto(telefono)",
        "Contacto(emai)",
        "N.Carátula",
        "CaratulaContratante",
        "Serie(Automovil)",
      ],
    };

    vm.option = [
      {
        id: 1,
        name: "Renovadas",
      },
      {
        id: 2,
        name: "Por renovar",
      },
    ];

    vm.validity = [
      {
        id: 1,
        name: "Inicio de vigencia",
      },
      {
        id: 2,
        name: "Fin de vigencia",
      },
    ];

    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
      {
        id: 7,
        name: "Semanal",
      },
      {
        id: 14,
        name: "Catorcenal",
      },
    ];
    $scope.orgName = usr.orgname;
    if ($scope.orgName) {
      vm.status = [
        {
          id: 1,
          name: "En trámite",
        },
        {
          id: 2,
          name: "OT Cancelada",
        },
        {
          id: 4,
          name: "Precancelada",
        },
        {
          id: 10,
          name: "Por Iniciar",
        },
        {
          id: 11,
          name: "Cancelada",
        },
        {
          id: 12,
          name: "Renovada",
        },
        {
          id: 13,
          name: "Vencida - En Proceso de Renovación",
        },
        {
          id: 14,
          name: "Vigente",
        },
        {
          id: 15,
          name: "No renovada",
        },
      ];
    } else {
      vm.status = [
        {
          id: 1,
          name: "En trámite",
        },
        {
          id: 2,
          name: "OT Cancelada",
        },
        {
          id: 4,
          name: "Precancelada",
        },
        {
          id: 10,
          name: "Por Iniciar",
        },
        {
          id: 11,
          name: "Cancelada",
        },
        {
          id: 12,
          name: "Renovada",
        },
        {
          id: 13,
          name: "Vencida",
        },
        {
          id: 14,
          name: "Vigente",
        },
        {
          id: 15,
          name: "No renovada",
        },
      ];
    }

    vm.group_by = [
      {
        id: 1,
        name: "Aseguradora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 7,
        name: "Usuario",
      },
    ];

    vm.businesLine = [
      {
        id: 1,
        name: "Comercial",
      },
      {
        id: 2,
        name: "Personal",
      },
      {
        id: 3,
        name: "Otro",
      },
    ];
    $scope.infoUser = $sessionStorage.infoUser;

    $(".js-example-basic-multiple").select2();

    $scope.columnArray = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;

    vm.matchesGroupinglevel = matchesGroupinglevel;
    vm.matchesClassification = matchesClassification;

    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;

    vm.changeSubgrouping = changeSubgrouping;
    vm.changeSubsubgrouping = changeSubsubgrouping;
    $scope.subgroups = [];
    $scope.subsubgroups = [];
    $scope.subgrouping = [];
    $scope.subsubgrouping = [];
    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;

    vm.changeSubgrouping = changeSubgrouping;
    vm.changeSubsubgrouping = changeSubsubgrouping;
    vm.changeBLine = changeBLine;
    vm.getCaratulas = getCaratulas;
    function getCaratulas(parId) {
      var results = [];
      var mapeo_caratulas = [];
      if (parId) {
        if (parId.val.length >= 3) {
          $scope.show_cds = "get-all-caratulas/";
          $http({
            method: "POST",
            url: url.IP + $scope.show_cds,
            data: {
              word: parId.val,
            },
          })
            .then(
              function success(request) {
                var results = [];
                var mapeo_caratulas = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    vm.only_caratula_poliza = 0;
                    $scope.autocompleteData = [];
                    vm.word.id = 0;
                    toaster.warning("Carátula no encontrada");
                  } else {
                    request.data.forEach(function (poliza) {
                      vm.policy = poliza;
                      if (poliza.document_type == 11) {
                        mapeo_caratulas.push(poliza);
                      }
                    });
                    results = _.map(mapeo_caratulas, function (item) {
                      if (item.contractor) {
                        var label =
                          item.poliza_number +
                          " - " +
                          item.contractor.full_name +
                          " - " +
                          convertDate(vm.policy.start_of_validity) +
                          " - " +
                          convertDate(vm.policy.end_of_validity);
                      } else {
                        var label = item.poliza_number;
                      }
                      return {
                        label: label,
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                      };
                    });
                    $scope.autocompleteData = results;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        } else {
          vm.only_caratula_poliza = 0;
          $scope.autocompleteData = [];
          vm.word.id = 0;
        }
      }
    }
    vm.getCarSelected = getCarSelected;
    function getCarSelected(caratula) {
      vm.only_caratula_poliza = caratula.id;
    }
    $scope.$watch("vm.word", function (newValue, oldValue) {
      if (vm.word) {
        if (vm.word.id) {
          vm.only_caratula_poliza = parseInt(vm.word.id);
        } else {
          vm.only_caratula_poliza = 0;
        }
      }
    });
    getCelulasContractor();
    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    function changeBLine(obj) {
      $scope.bLine = obj;
      if (obj) {
        vm.form.businesLine = obj;
      } else {
        vm.form.businesLine = 0;
      }
    }
    function changeSubgroup(subg) {
      vm.form.subgroup = subg;
      vm.subgroup = subg;
      $scope.subsubgroups = subg.subsubgrupos ? subg.subsubgrupos : [];
    }
    function changeSubsubgroup(subg) {
      vm.form.subsubgroup = subg;
      vm.subsubgroup = subg;
    }
    // Nivel de agrupación
    function changeSubgrouping(subgl) {
      vm.form.subgrouping = subgl;
      vm.subgrouping = subgl;
      $scope.subsubgrouping = subgl.subsubgrupos ? subgl.subsubgrupos : [];
    }
    function changeSubsubgrouping(subgl) {
      vm.form.subsubgrouping = subgl;
      vm.subsubgrouping = subgl;
    }
    // $scope.currentColumn = function(column, event){
    //   $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    // };

    // $scope.finalColumn = function(column, evet) {
    //   $scope.columnArrayNew = angular.copy($scope.columnArray);
    //   $scope.column = column;
    //   $scope.position = event.path[0].cellIndex;
    //   $scope.columnArray[$scope.position] = $scope.column;

    //   if($scope.currentPosition > $scope.position){
    //     for(var i=$scope.position; i<$scope.currentPosition; i++){
    //       $scope.columnArray[i+1] = $scope.columnArrayNew[i];
    //     }
    //   }
    //   else if($scope.currentPosition < $scope.position){
    //     for(var i=$scope.position; i>$scope.currentPosition; i--){
    //       $scope.columnArray[i-1] = $scope.columnArrayNew[i];
    //     }
    //   }
    // };
    $scope.orden = function (value) {
      $scope.insurances.forEach(function (id) {
        if (id.id) {
          $http({
            method: "GET",
            url: url.IP + "historic-policies/",
            params: {
              actual_id: id.id,
            },
          }).then(function success(response) {
            if (response.data.results.length) {
              vm.showHistoric = true;
            }
            vm.policy_history = [];
            response.data.results.forEach(function function_name(old) {
              if (old.base_policy) {
                if (id.id == old.base_policy.id) {
                  // vm.policy_history.push(old.base_policy);
                  if (old.new_policy) {
                    id.historic =
                      "Folio Interno: " + old.new_policy.internal_number;
                  }
                } else {
                  if (old.base_policy) {
                    // id.historic ='Renovada de: '+old.base_policy.internal_number;
                  }
                }
              }
            });
          });
        }
      });
    };

    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    activate();
    vm.form.since = convertDate(new Date());
    vm.form.until = convertDate(new Date());
    // var endingDate =  convertDate(new Date().setYear(new Date().getFullYear() + 1));

    //var endingDate =  convertDate(new Date());
    //vm.form.until = endingDate;
    function getSucursales() {
      $http
        .get(url.IP + "sucursales-to-show-unpag")
        .then(function success(response) {
          $scope.sucursales = response.data;
        });
    }
    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      $scope.infoUser = $sessionStorage.infoUser;
      var params_columns = {};
      var url_send = url.IP + "save-config-fields-reports/";
      params_columns = {
        tipo: 3,
      };
      // $scope.filteredKeys = [];
      $scope.filteredKeys = [
        "Tipo",
        "No.Póliza",
        "Contratante",
        "Email",
        "Teléfono",
        "Proveedor",
        "Ramo",
        "Subramo",
        "Forma de Pago",
        "Estatus Póliza",
        "Inicio Póliza",
        "Fin Póliza",
        "Moneda",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Clave",
        "Asegurado",
        "Observaciones",
        "Referenciador",
        "Folio",
        "Fecha de Creación",
        "Creado por",
        "Fecha renovación",
        "Estatus de la Renovación",
        "Sucursal",
        "Póliza Anterior",
        "Responsable",
        "Paquete",
        "C.P.",
        "Identificador",
        "Grupo",
        "Agrupación",
        "Subagrupación",
        "Subsubagrupación",
        "Clasificación",
        "Línea de Negocio",
        "Célula",
        "Contacto(nombre)",
        "Contacto(telefono)",
        "Contacto(email)",
        "N.Carátula",
        "CaratulaContratante",
        "Serie(Automovil)",
        "Conducto de Pago",
        "Póliza Siguiente",
      ];
      $http
        .get(url_send, { params: params_columns })
        .then(function (response) {
          if (response.data && response.data.data) {
            // $scope.filteredKeys = [];
            // $scope.filteredKeys = Object.keys(response.data.data).filter(function(key) {
            //   return response.data.data[key] === true;
            // });
            $scope.filteredKeys = $scope.filteredKeys.filter(function (key) {
              return response.data.data[key] === true;
            });
          } else {
            $scope.filteredKeys = [
              "Tipo",
              "No.Póliza",
              "Contratante",
              "Email",
              "Teléfono",
              "Proveedor",
              "Ramo",
              "Subramo",
              "Forma de Pago",
              "Estatus Póliza",
              "Inicio Póliza",
              "Fin Póliza",
              "Moneda",
              "Prima Neta",
              "RPF",
              "Derecho",
              "IVA",
              "Prima Total",
              "Comisión",
              "Clave",
              "Asegurado",
              "Observaciones",
              "Referenciador",
              "Folio",
              "Fecha de Creación",
              "Creado por",
              "Fecha renovación",
              "Estatus de la Renovación",
              "Sucursal",
              "Póliza Anterior",
              "Responsable",
              "Paquete",
              "C.P.",
              "Identificador",
              "Grupo",
              "Agrupación",
              "Subagrupación",
              "Subsubagrupación",
              "Clasificación",
              "Línea de Negocio",
              "Célula",
              "Contacto(nombre)",
              "Contacto(telefono)",
              "Contacto(email)",
              "N.Carátula",
              "CaratulaContratante",
              "Serie(Automovil)",
              "Conducto de Pago",
              "Póliza Siguiente",
            ];
          }
        })
        .catch(function (error) {
          console.error("Error loading settings", error);
        });
      getSucursales();
      getProviders();
      getUsuarios();
      getSubramos();
      $scope.total = 0;

      vm.form.contratante =
        savedFiltersRenovaciones && savedFiltersRenovaciones["contratante"]
          ? savedFiltersRenovaciones["contratante"]
          : "";
      vm.form.group =
        savedFiltersRenovaciones && savedFiltersRenovaciones["group"]
          ? savedFiltersRenovaciones["group"]
          : "";
      vm.form.groupinglevel =
        savedFiltersRenovaciones && savedFiltersRenovaciones["groupinglevel"]
          ? savedFiltersRenovaciones["groupinglevel"]
          : "";
      vm.form.classification =
        savedFiltersRenovaciones && savedFiltersRenovaciones["classification"]
          ? savedFiltersRenovaciones["classification"]
          : 0;
      vm.form.businesLine =
        savedFiltersRenovaciones && savedFiltersRenovaciones["businesLine"]
          ? savedFiltersRenovaciones["businesLine"]
          : 0;
      vm.form.businessLine =
        savedFiltersRenovaciones && savedFiltersRenovaciones["businessLine"]
          ? savedFiltersRenovaciones["businessLine"]
          : 0;
      vm.form.celula =
        savedFiltersRenovaciones && savedFiltersRenovaciones["celula"]
          ? savedFiltersRenovaciones["celula"]
          : 0;
      vm.form.status =
        savedFiltersRenovaciones && savedFiltersRenovaciones["status"]
          ? savedFiltersRenovaciones["status"]
          : 0;
      vm.form.payment =
        savedFiltersRenovaciones && savedFiltersRenovaciones["payment"]
          ? savedFiltersRenovaciones["payment"]
          : 0;
      vm.form.cve_agente =
        savedFiltersRenovaciones && savedFiltersRenovaciones["cve_agente"]
          ? savedFiltersRenovaciones["cve_agente"]
          : "";
      vm.form.group_by =
        savedFiltersRenovaciones && savedFiltersRenovaciones["group_by"]
          ? savedFiltersRenovaciones["group_by"]
          : 0;
      vm.form.validity =
        savedFiltersRenovaciones && savedFiltersRenovaciones["validity"]
          ? savedFiltersRenovaciones["validity"]
          : "";
      vm.form.renovadas =
        savedFiltersRenovaciones && savedFiltersRenovaciones["renovadas"]
          ? savedFiltersRenovaciones["renovadas"]
          : 0;
      vm.form.since =
        savedFiltersRenovaciones && savedFiltersRenovaciones["since"]
          ? savedFiltersRenovaciones["since"]
          : "";
      vm.form.until =
        savedFiltersRenovaciones && savedFiltersRenovaciones["until"]
          ? savedFiltersRenovaciones["until"]
          : "";
      // vm.form.report_by = savedFiltersRenovaciones && savedFiltersRenovaciones['report_by'] ? savedFiltersRenovaciones['report_by'] : '';
      $scope.bLine =
        savedFiltersRenovaciones && savedFiltersRenovaciones["bLine"]
          ? savedFiltersRenovaciones["bLine"]
          : 0;

      if (vm.tipo_report && savedFiltersRenovaciones) {
        vm.tipo_report.forEach(function (item) {
          if (item.id == parseInt(savedFiltersRenovaciones["report_by"])) {
            vm.form.report_by = item.id;
          }
        });
      }
    }
    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        vm.providers = data.data;
      });
    }
    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }
    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function changeGroupBy() {
      $scope.grupos_result = [];
      $scope.showSums = false;
      vm.show_pag_cobranza = false;
    }
    vm.sortOrders = {}; // Object to track sorting order per column
    function changeRenewal(par, asc) {
      vm.sortOrders[par] = vm.sortOrders[par] === 1 ? 2 : 1;
      vm.sortKey = par;
      asc = vm.sortOrders[par];
      if (par == "No.Póliza") {
        par = 1;
      } else if (par == "Tipo") {
        par = 2;
      } else if (par == "Contratante") {
        par = 3;
      } else if (par == "Proveedor") {
        par = 4;
      } else if (par == "Ramo") {
        par = 5;
      } else if (par == "Subramo") {
        par = 6;
      } else if (par == "Paquete") {
        par = 7;
      } else if (par == "Forma de Pago") {
        par = 8;
      } else if (par == "Estatus Póliza") {
        par = 9;
      } else if (par == "Inicio Póliza") {
        par = 10;
      } else if (par == "Fecha de Creación") {
        par = 11;
      } else if (par == "Folio") {
        par = 12;
      } else if (par == "Moneda") {
        par = 13;
      } else if (par == "Prima Neta") {
        par = 14;
      } else if (par == "RPF") {
        par = 15;
      } else if (par == "Derecho") {
        par = 16;
      } else if (par == "IVA") {
        par = 17;
      } else if (par == "Prima Total") {
        par = 18;
      } else if (par == "Comisión") {
        par = 19;
      } else if (par == "Observaciones") {
        par = 20;
      } else if (par == "Clave") {
        par = 21;
      } else if (par == "Fin Póliza") {
        par = 23;
      } else {
        par = 4;
      }
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.renewal_nump_asc = asc;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = asc;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = asc;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = asc;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = asc;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = asc;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 7:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = asc;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = asc;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = asc;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = asc;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = asc;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 12:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = asc;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 13:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = asc;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 14:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = asc;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 15:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = asc;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 16:
          Generar(par, asc);
          vm.renewal_nump_asc = asc;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = asc;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 17:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = asc;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 18:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = asc;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 19:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = asc;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
        case 20:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = asc;
          vm.renewal_clave_asc = 0;
          break;
        case 21:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = asc;
          break;
        case 22:
          Generar(par, asc);
          vm.renewal_nump_asc = 0;
          vm.renewal_tipo_asc = 0;
          vm.renewal_cont_asc = 0;
          vm.renewal_aseg_asc = 0;
          vm.renewal_ramo_asc = 0;
          vm.renewal_subr_asc = 0;
          vm.renewal_pack_asc = 0;
          vm.renewal_frecpago_asc = 0;
          vm.renewal_status_asc = 0;
          vm.renewal_fin_asc = asc;
          vm.renewal_vig_asc = 0;
          vm.renewal_creac_asc = 0;
          vm.renewal_folio_asc = 0;
          vm.renewal_fpago_asc = 0;
          vm.renewal_pneta_asc = 0;
          vm.renewal_rpf_asc = 0;
          vm.renewal_der_asc = 0;
          vm.renewal_iva_asc = 0;
          vm.renewal_ptotal_asc = 0;
          vm.renewal_com_asc = 0;
          vm.renewal_obser_asc = 0;
          vm.renewal_clave_asc = 0;
          break;
      }
    }

    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      vm.form.subgroup = 0;
      vm.form.subsubgroup = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        if (vm.form.group.val) {
          var word_data = vm.form.group.val;
        }
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  // var obj = {
                  //   label: item.group_name,
                  //   value: item.id
                  // };
                  // $scope.subgroups = item.subgrupos;
                  // $scope.subsubgroups = [];
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    $scope.$watch("vm.form.group.value", function (newValue, oldValue) {
      if (vm.form.group) {
        if (vm.form.group.value) {
          $http
            .get(url.IP + "grupos/" + vm.form.group.value)
            .then(function (item) {
              vm.form.group.data = item.data;

              $scope.subgroups = item.data.subgrupos;
              $scope.subgroups.forEach(function (itm) {
                $scope.subsubgroups = itm.subsubgrupos;
              });
            });
        }
      }
    });

    function matchesGroupinglevel(parWord, parType) {
      $scope.subgrouping = [];
      $scope.subsubgrouping = [];
      $scope.groupunglevels_data = 0;
      vm.form.subgrouping = 0;
      vm.form.subsubgrouping = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.groupinglevel.val) {
        var word_data = vm.form.groupinglevel.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_grouping = "groupinglevel-match/";

          $http
            .post(url.IP + $scope.show_grouping, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groupinglevels = response.data ? response.data : [];
                groupinglevels.forEach(function (item) {
                  $scope.subsubgrouping = [];
                  $scope.subgrouping.forEach(function (itm) {
                    $scope.subsubgrouping = itm.subsubgrupos;
                  });
                  var obj = {
                    label: item.description,
                    value: item.id,
                    url: item.url,
                    subgrupos: item.subgrupos,
                  };
                  source.push(obj);
                });

                $scope.groupinglevels_data = source;
              }
            });
        }
      }
    }
    // --GroupingLevel
    // classification
    function matchesClassification(parWord, parType) {
      $scope.classification_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.classification.val) {
        var word_data = vm.form.classification.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_claass = "classification-match/";

          $http
            .post(url.IP + $scope.show_claass, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var classifica = response.data;
                classifica.forEach(function (item) {
                  var obj = {
                    label: item.classification_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.classification_data = source;
              }
            });
        }
      }
    }

    function goToInfo(insurance) {
      if (vm.acceso_ver_pol) {
        if (insurance.document_type == "Póliza") {
          var name = "Información póliza";
          var route = "polizas.info";
        } else if (insurance.document_type == "Colectividad") {
          var name = "Información póliza grupo";
          var route = "colectividades.info";
        } else if (insurance.document_type == "Carátula") {
          var name = "Información colectividad";
          var route = "flotillas.info";
        } else if (insurance.document_type == "Póliza de Carátula") {
          var name = "Información colectividad";
          var route = "flotillas.info";
        }
      }

      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      if (vm.acceso_ver_pol) {
        if (insurance.document_type == "Póliza") {
          $state.go("polizas.info", { polizaId: insurance.id });
        } else if (insurance.document_type == "Colectividad") {
          $state.go("colectividades.info", { polizaId: insurance.id });
        } else if (insurance.document_type == "Carátula") {
          $state.go("flotillas.info", { polizaId: insurance.id });
        } else if (insurance.document_type == "Póliza de Carátula") {
          $state.go("flotillas.info", { polizaId: insurance.caratula });
        }
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }

                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    $scope.showButtonExcel = false;
    $scope.myFunction = function (isLast, item) {
      if (isLast) console.log(item);
    };
    function Generar(order, asc, parPage) {
      $scope.insurances = [];
      if (!vm.form.renovadas.id) {
        SweetAlert.swal(
          "Error",
          "Selecciona una opción de reporte por.",
          "error"
        );
        return;
      }

      var l = Ladda.create(document.querySelector(".ladda-buttonC"));
      l.start();

      $scope.order = order;
      $scope.asc = asc;
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));

      if (antiguedad < 0) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }

      $scope.prima_neta = 0;
      $scope.sub_total = 0;
      $scope.comision = 0;
      if (vm.form.provider) {
        var p = vm.form.provider.id;
      } else {
        var p = 0;
      }
      if (vm.form.ramo) {
        var r = vm.form.ramo.id;
      } else {
        var r = 0;
      }
      if (vm.form.subramo) {
        var s = vm.form.subramo.id;
      } else {
        var s = 0;
      }
      if (vm.form.status) {
        var e = vm.form.status.id;
      } else {
        var e = 0;
      }
      if (vm.form.payment) {
        var f = vm.form.payment.id;
      } else {
        var f = 0;
      }
      if (vm.form.contratante) {
        var c = vm.form.contratante.value;
      } else {
        var c = vm.form.contratante;
      }
      if (vm.form.group) {
        if (!vm.form.group.val) {
          var g = 0;
        } else {
          var g = vm.form.group;
        }
      } else {
        var g = vm.form.group;
      }
      if (vm.form.validity) {
        var v = vm.form.validity;
      } else {
        var v = vm.form.validity;
      }
      if (vm.form.subgroup) {
        if (vm.form.subgroup.id) {
          var g1 = vm.form.subgroup.id;
        } else {
          var g1 = 0;
        }
      }
      if (vm.form.subsubgroup) {
        if (vm.form.subsubgroup.id) {
          var g2 = vm.form.subsubgroup.id;
        } else {
          var g2 = 0;
        }
      } else {
        var g2 = 0;
      }
      if (vm.form.groupinglevel) {
        if (vm.form.groupinglevel.val) {
          var gl = vm.form.groupinglevel.value;
        } else {
          var gl = 0;
        }
      } else {
        var gl = 0;
      }
      if (vm.form.subgrouping) {
        if (vm.form.subgrouping.id) {
          var gl1 = vm.form.subgrouping.id;
        } else {
          var gl1 = 0;
        }
      } else {
        var gl1 = 0;
      }
      if (vm.form.subsubgrouping) {
        if (vm.form.subsubgrouping.id) {
          var gl2 = vm.form.subsubgrouping.id;
        } else {
          var gl2 = 0;
        }
      } else {
        var gl2 = 0;
      }
      var params = {
        provider: p,
        ramo: r,
        subramo: s,
        since: vm.form.since,
        until: vm.form.until,
        payment: f,
        status: e,
        contratante: c ? c : 0,
        grupo: g ? g.value : 0,
        cve: vm.form.cve_agente ? vm.form.cve_agente : 0,
        validity: v && v.id ? v.id : 2,
        order: order,
        asc: asc,
        sucursal: vm.form.sucursal ? vm.form.sucursal.id : "",
        renovadas: vm.form.renovadas.id ? vm.form.renovadas.id : 1,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        users: vm.usuarios_selected ? vm.usuarios_selected : 0,
        page: parPage ? parPage : 1,
        group_by: vm.form.group_by ? vm.form.group_by.id : 0,
        classification: vm.form.classification.value
          ? vm.form.classification.value
          : vm.form.classification,
        subgrupo: g1 ? g1 : 0,
        subsubgrupo: g2 ? g2 : 0,
        groupinglevel: gl ? gl : 0,
        subgrupinglevel: gl1 ? gl1 : 0,
        subsubgrupinglevel: gl2 ? gl2 : 0,
        businessLine: $scope.bLine ? $scope.bLine.id : 0,
        only_caratula: vm.only_caratula_poliza ? vm.only_caratula_poliza : 0,
      };
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          params.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.group) {
        if (vm.form.group.val == "") {
          params.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
      }
      if (params.grupo == undefined) {
        params.grupo = 0;
      }
      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }
      params.celula = cel ? cel : 0;
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      savedFiltersRenovaciones = angular.copy(params);
      savedFiltersRenovaciones["contratante"] = vm.form.contratante
        ? vm.form.contratante
        : "";
      savedFiltersRenovaciones["group"] = vm.form.group ? vm.form.group : "";
      savedFiltersRenovaciones["businesLine"] = vm.form.businesLine
        ? vm.form.businesLine
        : "";
      savedFiltersRenovaciones["groupinglevel"] = vm.form.groupinglevel
        ? vm.form.groupinglevel
        : "";
      savedFiltersRenovaciones["classification"] = vm.form.classification
        ? vm.form.classification
        : "";
      savedFiltersRenovaciones["celula"] = vm.form.celula ? vm.form.celula : "";
      savedFiltersRenovaciones["status"] = vm.form.status ? vm.form.status : "";
      savedFiltersRenovaciones["payment"] = vm.form.payment
        ? vm.form.payment
        : "";
      savedFiltersRenovaciones["cve_agente"] = vm.form.cve_agente
        ? vm.form.cve_agente
        : "";
      savedFiltersRenovaciones["group_by"] = vm.form.group_by
        ? vm.form.group_by
        : "";
      savedFiltersRenovaciones["validity"] = vm.form.validity
        ? vm.form.validity
        : "";
      savedFiltersRenovaciones["renovadas"] = vm.form.renovadas
        ? vm.form.renovadas
        : "";
      savedFiltersRenovaciones["since"] = vm.form.since ? vm.form.since : "";
      savedFiltersRenovaciones["until"] = vm.form.until ? vm.form.until : "";
      savedFiltersRenovaciones["bLine"] = vm.form.businesLine
        ? vm.form.businesLine
        : "";
      savedFiltersRenovaciones["report_by"] = vm.form.report_by
        ? vm.form.report_by
        : "";
      $scope.filtros = params;
      $scope.url_go = "reporte-renovaciones-rep/";
      // $scope.url_go = 'v2/polizas/reporte-renovaciones-rep/';
      $http({
        method: "POST",
        url: url.IP + $scope.url_go,
        data: $scope.filtros,
      })
        .then(function success(response) {
          if (params.group_by == 0) {
            $("#example").DataTable().clear();
            $("#example").DataTable().destroy();
            // $scope.insurances = response.data.results;
            $scope.insurances = response.data.results;
            $scope.orden($scope.insurances);
            l.stop();
            var i = 0;
            var j = 0;
            $scope.insurances.forEach(function (pago) {
              var fpago = pago.forma_de_pago;
              switch (fpago) {
                case 1:
                  $scope.insurances[i].forma_de_pago = "Mensual";
                  break;
                case 2:
                  $scope.insurances[i].forma_de_pago = "Bimestral";
                  break;
                case 3:
                  $scope.insurances[i].forma_de_pago = "Trimestral";
                  break;
                case 5:
                  $scope.insurances[i].forma_de_pago = "Contado";
                  break;
                case 6:
                  $scope.insurances[i].forma_de_pago = "Semestral";
                  break;
                case 12:
                  $scope.insurances[i].forma_de_pago = "Anual";
                  break;
                case 24:
                  $scope.insurances[i].forma_de_pago = "Quincenal";
                  break;
                case 4:
                  $scope.insurances[i].forma_de_pago = "Cuatrimestral";
                  break;
                case 7:
                  $scope.insurances[i].forma_de_pago = "Semanal";
                  break;
                case 14:
                  $scope.insurances[i].forma_de_pago = "Catorcenal";
                  break;
              }
              i = i + 1;
              var status = pago.status;
              switch (status) {
                case 1:
                  $scope.insurances[j].status = "En trámite";
                  break;
                case 2:
                  $scope.insurances[j].status = "OT Cancelada";
                  break;
                case 4:
                  $scope.insurances[j].status = "Precancelada";
                  break;
                case 10:
                  $scope.insurances[j].status = "Por iniciar";
                  break;
                case 11:
                  $scope.insurances[j].status = "Cancelada";
                  break;
                case 12:
                  $scope.insurances[j].status = "Renovada";
                  break;
                case 13:
                  $scope.insurances[j].status = "Vencida";
                  break;
                case 14:
                  $scope.insurances[j].status = "Vigente";
                  break;
                case 15:
                  $scope.insurances[j].status = "No renovada";
                  break;
                case 16:
                  $scope.insurances[j].status = "Siniestrada";
                  break;
              }
              j = j + 1;
            });

            $scope.insurances = response.data.results;
            $scope.sumas = response.data.sumas;

            for (var i = 0; i < $scope.insurances.length; i++) {
              if ($scope.insurances[i].document_type == 1) {
                $scope.insurances[i].document_type = "Póliza";
              } else if ($scope.insurances[i].document_type == 3) {
                $scope.insurances[i].document_type = "Colectividad";
              } else if ($scope.insurances[i].document_type == 7) {
                $scope.insurances[i].document_type = "Fianza";
              } else if ($scope.insurances[i].document_type == 8) {
                $scope.insurances[i].document_type = "Fianza Colectiva";
              } else if ($scope.insurances[i].document_type == 11) {
                $scope.insurances[i].document_type = "Carátula";
              } else if ($scope.insurances[i].document_type == 12) {
                $scope.insurances[i].document_type = "Póliza de Carátula";
              } else {
                $scope.insurances[i].document_type = "Póliza";
              }
              $scope.insurances[i].f_currency =
                $scope.insurances[i].f_currency == 1 ? "Pesos" : "Dolares";
            }

            $scope.count_insurances = angular.copy($scope.insurances);
            if (
              $scope.insurances &&
              $scope.insurances.length != 0 &&
              $scope.insurances.length < 10
            ) {
              for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
                var object = {
                  poliza_number: " ",
                  document_type: " ",
                  natural: " ",
                  aseguradora: " ",
                  ramo: " ",
                  subramo: " ",
                  paquete: " ",
                  forma_de_pago: " ",
                  status: " ",
                  start_of_validity: " ",
                  created_at: " ",
                  folio: " ",
                  f_currency: " ",
                  prima_neta: null,
                  rpf: null,
                  derecho: null,
                  iva: null,
                  prima_total: null,
                  comision: null,
                  observations: " ",
                  clave: {
                    clave: " ",
                  },
                };
                $scope.insurances.push(object);
              }
            }
            $scope.renovaciones_config = {
              count: response.data.count,
              previous: url.IP + $scope.url_go,
              next: url.IP + $scope.url_go,
            };
            vm.show_pag_renewal = true;
            $scope.obtenerPaginacion(response.data, parPage ? parPage : 1);
            // testPagination('insurances', 'renovaciones_config');

            if ($scope.insurances[0].poliza_number == " ") {
              toaster.warning("No se encontraron registros");
              $("#example").DataTable().clear();
              $("#example").DataTable().draw();
              $("#example").DataTable().destroy();
            } else {
              $scope.showButtonExcel = true;
              $scope.showSums = true;
            }
          } else {
            l.stop();
            $scope.grupos_result = response.data.results;
            $scope.showButtonExcel = true;
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
      // en proceso de renovación
      if (vm.form.renovadas && vm.form.renovadas.id == 2) {
        $http({
          method: "POST",
          url: url.IP + "reporte-polizaenproceso-rep/",
          data: params,
        }).then(function success(response_en_proceso) {
          if (
            response_en_proceso.status == 200 ||
            response_en_proceso.status == 201
          ) {
            $scope.insurances_en_proceso = [];
            if (params.group_by == 0) {
              $scope.insurances_en_proceso = response_en_proceso.data.results;
              if (
                $scope.insurances_en_proceso &&
                $scope.insurances_en_proceso.length != 0
              ) {
                for (var i = 0; i < $scope.insurances_en_proceso.length; i++) {
                  if ($scope.insurances_en_proceso[i].old_policies > 0) {
                    if (
                      $scope.insurances_en_proceso[i].old_policies[0]
                        .base_policy.id == $scope.insurances_en_proceso[i].id
                    ) {
                      $scope.insurances_en_proceso[i].asociada = $scope
                        .insurances_en_proceso[i].old_policies[0].new_policy
                        .poliza_number
                        ? $scope.insurances_en_proceso[i].old_policies[0]
                            .new_policy.poliza_number
                        : $scope.insurances_en_proceso[i].old_policies[0]
                            .new_policy.internal_number;
                    }
                  }
                  if ($scope.insurances_en_proceso[i].document_type == 1) {
                    $scope.insurances_en_proceso[i].document_type == "Póliza";
                  } else if (
                    $scope.insurances_en_proceso[i].document_type == 3
                  ) {
                    $scope.insurances_en_proceso[i].document_type ==
                      "Colectividad";
                  } else if (
                    $scope.insurances_en_proceso[i].document_type == 11
                  ) {
                    $scope.insurances_en_proceso[i].document_type == "Carátula";
                  } else if (
                    $scope.insurances_en_proceso[i].document_type == 12
                  ) {
                    $scope.insurances_en_proceso[i].document_type ==
                      "Póliza de Carátula";
                  }
                  if (
                    $scope.insurances_en_proceso[i].document_type == "Póliza"
                  ) {
                    $scope.insurances_en_proceso[i].document_type =
                      $scope.insurances_en_proceso[i].status == 1
                        ? "OT"
                        : $scope.insurances_en_proceso[i].status == 2
                        ? "OT"
                        : "Póliza";
                  }
                  $scope.insurances_en_proceso[i].forma_de_pago =
                    $scope.insurances_en_proceso[i].forma_de_pago == 1
                      ? "Mensual"
                      : $scope.insurances_en_proceso[i].forma_de_pago == 2
                      ? "Bimestral"
                      : $scope.insurances_en_proceso[i].forma_de_pago == 3
                      ? "Trimestral"
                      : $scope.insurances_en_proceso[i].forma_de_pago == 5
                      ? "Contado"
                      : $scope.insurances_en_proceso[i].forma_de_pago == 6
                      ? "Semestral"
                      : $scope.insurances_en_proceso[i].forma_de_pago == 7
                      ? "Semanal"
                      : $scope.insurances_en_proceso[i].forma_de_pago == 14
                      ? "Catorcenal"
                      : "Anual";
                  $scope.insurances_en_proceso[i].f_currency =
                    $scope.insurances_en_proceso[i].f_currency == 1
                      ? "Pesos"
                      : "Dolares";
                }
                $scope.count_insurances_en_proceso = angular.copy(
                  $scope.insurances_en_proceso
                );

                $scope.policy_config2 = {
                  count: response_en_proceso.data.count,
                  previous: response_en_proceso.data.previous,
                  next: response_en_proceso.data.next,
                };
                vm.show_pag_policy_en_proceso = true;
                $scope.obtenerPaginacion2(
                  response_en_proceso.data,
                  parPage ? parPage : 1
                );
              }
            } else {
              $scope.insurances_en_proceso = [];
              l.stop();
              $scope.grupos_result = response_en_proceso.data;
            }
          } else {
            $scope.insurances_en_proceso = [];
            l.stop();
            toaster.warning("Error en la llamada registros");
          }
        });
      }
      // en proceso de renovación
    }

    // en proceso
    $scope.obtenerPaginacion2 = function (clasificacion, pagina) {
      $scope.paginacion2 = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas2: [],
        paginaInicio2: 0,
        paginaActual2: pagina,
        paginaFin: 0,
      };
      var numeroPaginas2 = Math.ceil($scope.paginacion2["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas2; i++) {
        if ($scope.paginacion2["totalPaginas2"].length <= 5) {
          $scope.paginacion2["totalPaginas2"].push(i + 1);
        }
      }
      if ($scope.paginacion2["totalPaginas2"].length > 5) {
        $scope.paginacion2["paginaInicio2"] =
          $scope.paginacion2["totalPaginas2"] - 5;
      } else {
        $scope.paginacion2["paginaInicio2"] = 1;
      }
      if ($scope.paginacion2["totalPaginas2"].length > 5) {
        $scope.paginacion2["paginaFin2"] = 5;
      } else {
        $scope.paginacion2["paginaFin2"] =
          $scope.paginacion2["totalPaginas2"].length;
      }
    };

    $scope.selecionPagina2 = function (pagina) {
      $localStorage.saved_filters_reporte_poliza["page2"] = pagina;
      vm.GenerarEnProceso(1, 1, pagina);
    };

    $scope.anteriorPagina2 = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $localStorage.saved_filters_reporte_poliza["page"] =
          $scope.paginacion2["paginaActual"] - 1;
        vm.GenerarEnProceso(
          $localStorage["saved_filters_reporte_poliza"] &&
            $localStorage["saved_filters_reporte_poliza"]["order"]
            ? $localStorage["saved_filters_reporte_poliza"]["order"]
            : 1,
          $localStorage["saved_filters_reporte_poliza"] &&
            $localStorage["saved_filters_reporte_poliza"]["asc"]
            ? $localStorage["saved_filters_reporte_poliza"]["asc"]
            : 1,
          $scope.paginacion2["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina2 = function () {
      var numeroPaginas = Math.ceil($scope.paginacion2["count"] / 10);
      if (numeroPaginas > $scope.paginacion2["paginaActual"]) {
        $localStorage.saved_filters_reporte_poliza["page"] =
          $scope.paginacion2["paginaActual"] + 1;
        vm.Generar(
          $localStorage["saved_filters_reporte_poliza"] &&
            $localStorage["saved_filters_reporte_poliza"]["order"]
            ? $localStorage["saved_filters_reporte_poliza"]["order"]
            : 1,
          $localStorage["saved_filters_reporte_poliza"] &&
            $localStorage["saved_filters_reporte_poliza"]["asc"]
            ? $localStorage["saved_filters_reporte_poliza"]["asc"]
            : 1,
          $scope.paginacion2["paginaActual"] + 1
        );
      }
    };
    // en en proceso
    function GenerarEnProceso(order, asc, parPage) {
      // en proceso de renovación
      $http({
        method: "POST",
        url: url.IP + "reporte-polizaenproceso-rep/",
        data: params,
      }).then(function success(response_en_proceso) {
        if (
          response_en_proceso.status == 200 ||
          response_en_proceso.status == 201
        ) {
          if (params.group_by == 0) {
            $scope.insurances_en_proceso = response_en_proceso.data.results;

            for (var i = 0; i < $scope.insurances_en_proceso.length; i++) {
              if ($scope.insurances_en_proceso[i].old_policies > 0) {
                if (
                  $scope.insurances_en_proceso[i].old_policies[0].base_policy
                    .id == $scope.insurances_en_proceso[i].id
                ) {
                  $scope.insurances_en_proceso[i].asociada = $scope
                    .insurances_en_proceso[i].old_policies[0].new_policy
                    .poliza_number
                    ? $scope.insurances_en_proceso[i].old_policies[0].new_policy
                        .poliza_number
                    : $scope.insurances_en_proceso[i].old_policies[0].new_policy
                        .internal_number;
                }
              }
              if ($scope.insurances_en_proceso[i].document_type == 1) {
                $scope.insurances_en_proceso[i].document_type == "Póliza";
              } else if ($scope.insurances_en_proceso[i].document_type == 3) {
                $scope.insurances_en_proceso[i].document_type == "Colectividad";
              } else if ($scope.insurances_en_proceso[i].document_type == 11) {
                $scope.insurances_en_proceso[i].document_type == "Carátula";
              } else if ($scope.insurances_en_proceso[i].document_type == 12) {
                $scope.insurances_en_proceso[i].document_type ==
                  "Póliza de Carátula";
              }
              if ($scope.insurances_en_proceso[i].document_type == "Póliza") {
                $scope.insurances_en_proceso[i].document_type =
                  $scope.insurances_en_proceso[i].status == 1
                    ? "OT"
                    : $scope.insurances_en_proceso[i].status == 2
                    ? "OT"
                    : "Póliza";
              }
              $scope.insurances_en_proceso[i].forma_de_pago =
                $scope.insurances_en_proceso[i].forma_de_pago == 1
                  ? "Mensual"
                  : $scope.insurances_en_proceso[i].forma_de_pago == 2
                  ? "Bimestral"
                  : $scope.insurances_en_proceso[i].forma_de_pago == 3
                  ? "Trimestral"
                  : $scope.insurances_en_proceso[i].forma_de_pago == 5
                  ? "Contado"
                  : $scope.insurances_en_proceso[i].forma_de_pago == 6
                  ? "Semestral"
                  : $scope.insurances_en_proceso[i].forma_de_pago == 7
                  ? "Semanal"
                  : $scope.insurances_en_proceso[i].forma_de_pago == 14
                  ? "Catorcenal"
                  : "Anual";
              $scope.insurances_en_proceso[i].f_currency =
                $scope.insurances_en_proceso[i].f_currency == 1
                  ? "Pesos"
                  : "Dolares";
            }

            $scope.count_insurances_en_proceso = angular.copy(
              $scope.insurances_en_proceso
            );
            if ($scope.insurances_en_proceso.length < 10) {
              for (
                var i = 0;
                i < 10 - $scope.count_insurances_en_proceso.length;
                i++
              ) {
                var object = {
                  contratante: " ",
                  poliza_number: " ",
                  aseguradora: " ",
                  ramo: " ",
                  subramo: " ",
                  paquete: " ",
                  prima_neta: null,
                  rpf: null,
                  derecho: null,
                  iva: null,
                  prima_total: null,
                  comision: null,
                  forma_de_pago: " ",
                  document_type: " ",
                  status: " ",
                  start_of_validity: " ",
                  folio: " ",
                  f_currency: " ",
                  observations: " ",
                  created_at: " ",
                  clave: " ",
                };
                $scope.insurances_en_proceso.push(object);
              }
            }

            $scope.policy_config2 = {
              count: response_en_proceso.data.count,
              previous: response_en_proceso.data.previous,
              next: response_en_proceso.data.next,
            };
            vm.show_pag_policy_en_proceso = true;
            $scope.obtenerPaginacion2(
              response_en_proceso.data,
              parPage ? parPage : 1
            );
          } else {
            l.stop();
            $scope.grupos_result = response_en_proceso.data;
          }
        } else {
          l.stop();
          toaster.warning("Error en la llamada registros");
        }
      });
      // en proceso de renovación
    }
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      savedFiltersRenovaciones["page"] = pagina;
      vm.Generar(1, 1, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        savedFiltersRenovaciones["page"] =
          $scope.paginacion["paginaActual"] - 1;
        vm.Generar(
          savedFiltersRenovaciones && savedFiltersRenovaciones["order"]
            ? savedFiltersRenovaciones["order"]
            : 1,
          savedFiltersRenovaciones && savedFiltersRenovaciones["asc"]
            ? savedFiltersRenovaciones["asc"]
            : 1,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        savedFiltersRenovaciones["page"] =
          $scope.paginacion["paginaActual"] + 1;
        vm.Generar(
          savedFiltersRenovaciones && savedFiltersRenovaciones["order"]
            ? savedFiltersRenovaciones["order"]
            : 1,
          savedFiltersRenovaciones && savedFiltersRenovaciones["asc"]
            ? savedFiltersRenovaciones["asc"]
            : 1,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };
    // -----------PAGINACIÓN

    $scope.actual_page = 1;

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        vm.Generar($scope.order, $scope.asc, parPage);
      };
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getRenewalPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              $scope.data_pagination = request.data.results;
              for (var i = 0; i < $scope.data_pagination.length; i++) {
                $scope.insurances[i].document_type =
                  $scope.insurances[i].document_type == 1
                    ? "Póliza"
                    : "Colectividad";
                $scope.data_pagination[i].f_currency =
                  $scope.data_pagination[i].f_currency == 1
                    ? "Pesos"
                    : "Dolares";
              }
              $scope.count_pagination = angular.copy($scope.data_pagination);
              if ($scope.data_pagination.length < 10) {
                for (var i = 0; i < 10 - $scope.count_pagination.length; i++) {
                  var object = {
                    poliza_number: " ",
                    document_type: " ",
                    natural: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    paquete: " ",
                    forma_de_pago: " ",
                    status: " ",
                    start_of_validity: " ",
                    created_at: " ",
                    folio: " ",
                    f_currency: " ",
                    prima_neta: null,
                    rpf: null,
                    derecho: null,
                    iva: null,
                    prima_total: null,
                    comision: null,
                    observations: " ",
                    clave: {
                      clave: " ",
                    },
                  };
                  $scope.data_pagination.push(object);
                }
              }

              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, $scope.data_pagination);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }

    // -----------------PAGINACIÓN

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            vm.ramos = response.data;
          });
      }
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }
    jQuery(function ($) {
      $("#exportButton").click(function () {
        // parse the HTML table element having an id=exportTable
        var dataSource = shield.DataSource.create({
          data: "#exportTable",
          schema: {
            type: "table",
            fields: {
              Recibo: { type: String },
              RPF: { type: Number },
              Estatus: { type: String },
            },
          },
        });

        // when parsing is done, export the data to PDF
        dataSource.read().then(function (data) {
          var pdf = new shield.exp.PDFDocument({
            author: "PrepBootstrap",
            created: new Date(),
          });

          pdf.addPage("a4", "portrait");

          pdf.table(
            50,
            50,
            data,
            [
              { field: "Recibo", title: "Número de Recibo", width: 200 },
              { field: "RPF", title: "RPF", width: 50 },
              { field: "Estatus", title: "Estatus del recibo", width: 200 },
            ],
            {
              margins: {
                top: 50,
                left: 50,
              },
            }
          );

          pdf.saveAs({
            fileName: "ReporteRenovaciones",
          });
        });
      });
    });

    $scope.exportData = function (name) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "data:application/vnd.ms-excel;charset=UTF-8",
        }
      );
      saveAs(blob, "Reporte_" + name + ".xls");
    };
    $scope.addSiniestros = function (param) {
      $scope.addSiniestrosBitacora = param;
    };
    $scope.exportDataExcel = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            // templateUrl: 'app/reportes/reportexcel.option.html',
            // controller: 'ReportExcelByCtrl',
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "md",
            resolve: {
              filters: function () {
                return $scope.filtros;
              },
              from: function () {
                return null;
              },
              addSiniestrosBitacora: function () {
                return $scope.addSiniestrosBitacora;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.filtros.orden = $scope.columnArray;
        $scope.filtros.excel_type = 2;
        var $listM = $("#example th")
          .map(function () {
            return $.trim($(this).text());
          })
          .get();

        if ($listM.includes("Contratante")) {
          $listM.push("Contratante");
        }
        if ($listM.includes("Grupo")) {
          $listM.push("Grupo");
        }
        if ($listM.includes("No.Póliza")) {
          $listM.push("No.Póliza");
        }
        if ($listM.includes("Proveedor")) {
          $listM.push("Proveedor");
        }
        if ($listM.includes("Ramo")) {
          $listM.push("Ramo");
        }
        if ($listM.includes("Subramo")) {
          $listM.push("Subramo");
        }
        if ($listM.includes("Paquete")) {
          $listM.push("Paquete");
        }
        if ($listM.includes("Prima Neta")) {
          $listM.push("Prima Neta");
        }
        if ($listM.includes("RPF")) {
          $listM.push("RPF");
        }
        if ($listM.includes("Derecho")) {
          $listM.push("Derecho");
        }
        if ($listM.includes("IVA")) {
          $listM.push("IVA");
        }
        if ($listM.includes("Prima Total")) {
          $listM.push("Prima Total");
        }
        if ($scope.permiso_comisiones) {
          if ($listM.includes("Comisión")) {
            $listM.push("Comisión");
          }
        }
        if ($listM.includes("Forma de Pago")) {
          $listM.push("Forma de Pago");
        }
        if ($listM.includes("Tipo")) {
          $listM.push("Tipo");
        }
        if ($listM.includes("Estatus Póliza")) {
          $listM.push("Estatus Póliza");
        }
        if ($listM.includes("Estatus de la Renovación")) {
          $listM.push("Estatus de la Renovación");
        }
        if ($listM.includes("Inicio Póliza")) {
          $listM.push("Inicio Póliza");
        }
        if ($listM.includes("Fin Póliza")) {
          $listM.push("Fin Póliza");
        }
        if ($listM.includes("Fecha de Creación")) {
          $listM.push("Fecha de Creación");
        }
        if ($listM.includes("Folio")) {
          $listM.push("Folio");
        }
        if ($listM.includes("Moneda")) {
          $listM.push("Moneda");
        }
        if ($listM.includes("Conducto de Pago")) {
          $listM.push("Conducto de Pago");
        }
        if ($listM.includes("Observaciones")) {
          $listM.push("Observaciones");
        }
        if ($listM.includes("Clave")) {
          $listM.push("Clave");
        }
        if ($listM.includes("Póliza Siguiente")) {
          $listM.push("Póliza Siguiente");
        }
        if ($listM.includes("Responsable")) {
          $listM.push("Responsable");
        }
        if ($listM.includes("Identificador")) {
          $listM.push("Identificador");
        }
        if ($listM.includes("Email")) {
          $listM.push("Email");
        }
        if ($listM.includes("Teléfono")) {
          $listM.push("Teléfono");
        }
        if ($listM.includes("Asegurado")) {
          $listM.push("Asegurado");
        }
        if ($listM.includes("Referenciador")) {
          $listM.push("Referenciador");
        }
        if ($listM.includes("Creado por")) {
          $listM.push("Creado por");
        }
        if ($listM.includes("Fecha renovación")) {
          $listM.push("Fecha renovación");
        }
        if ($listM.includes("Sucursal")) {
          $listM.push("Sucursal");
        }
        if ($listM.includes("Póĺiza Anterior")) {
          $listM.push("Póĺiza Anterior");
        }
        if ($listM.includes("C.P.")) {
          $listM.push("C.P.");
        }
        if ($listM.includes("Agrupación")) {
          $listM.push("Agrupación");
        }
        if ($listM.includes("Subagrupación")) {
          $listM.push("Subagrupación");
        }
        if ($listM.includes("Subsubagrupación")) {
          $listM.push("Subsubagrupación");
        }
        if ($listM.includes("Clasificación")) {
          $listM.push("Clasificación");
        }
        if ($listM.includes("Línea de Negocio")) {
          $listM.push("Línea de Negocio");
        }
        if ($listM.includes("Célula")) {
          $listM.push("Célula");
        }
        if ($listM.includes("Contacto(nombre)")) {
          $listM.push("Contacto(nombre)");
        }
        if ($listM.includes("Contacto(telefono)")) {
          $listM.push("Contacto(telefono)");
        }
        if ($listM.includes("Contacto(email)")) {
          $listM.push("Contacto(email)");
        }
        if ($listM.includes("N.Carátula")) {
          $listM.push("N.Carátula");
        }
        if ($listM.includes("CaratulaContratante")) {
          $listM.push("CaratulaContratante");
        }
        if ($listM.includes("Serie(Automovil)")) {
          $listM.push("Serie(Automovil)");
        }

        var scolumns = [
          "Tipo",
          "No.Póliza",
          "Contratante",
          "Email",
          "Teléfono",
          "Proveedor",
          "Ramo",
          "Subramo",
          "Forma de Pago",
          "Estatus Póliza",
          "Inicio Póliza",
          "Fin Póliza",
          "Moneda",
          "Prima Neta",
          "RPF",
          "Derecho",
          "IVA",
          "Prima Total",
          "Comisión",
          "Clave",
          "Asegurado",
          "Observaciones",
          "Referenciador",
          "Folio",
          "Fecha de Creación",
          "Creado por",
          "Fecha renovación",
          "Estatus de la Renovación",
          "Sucursal",
          "Póliza Anterior",
          "Póliza Siguiente",
          "Responsable",
          "Paquete",
          "C.P.",
          "Identificador",
          "Grupo",
          "Agrupación",
          "Subagrupación",
          "Subsubagrupación",
          "Clasificación",
          "Línea de Negocio",
          "Célula",
          "Contacto(nombre)",
          "Contacto(telefono)",
          "Contacto(email)",
          "N.Carátula",
          "CaratulaContratante",
          "Serie(Automovil)",
          "Conducto de Pago",
        ];

        var foo = [];

        $.grep(scolumns, function (el) {
          if ($.inArray(el, $listM) != -1) {
            foo.push(el);
          }
        });

        // $scope.filtros['cols1']=foo;
        $scope.filtros["cols1"] = $scope.filteredKeys;
        $scope.filtros["addsiniestrop"] = $scope.addSiniestrosBitacora
          ? $scope.addSiniestrosBitacora
          : false;
        $scope.url_go_excel = "service_reporte-renovacionesReport-excel";
        // $scope.url_go_excel = 'v2/polizas/reporte-renovaciones-excel';
        if (param == 1) {
          $http({
            method: "POST",
            url: url.IP + $scope.url_go_excel,
            data: $scope.filtros,
            headers: {
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "arraybuffer",
          })
            .then(function (data) {
              if (data.status == 200) {
                l.stop();
                var blob = new Blob([data.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, "Reporte_Renovaciones.xls");
              } else {
                SweetAlert.swal(
                  "Error",
                  "Ha ocurrido un error al descargar el reporte",
                  "error"
                );
                l.stop();
              }
            })
            .catch(function (e) {
              l.stop();
              console.log("e", e);
            });
        }
      }
    };
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance,
      addSiniestrosBitacora
    ) {
      var vmm = this;
      $scope.infoUser = $sessionStorage.infoUser;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        var param = 1;
        if (option) {
          // Totales de la Agrupación
          $scope.url_go_excel = "service_reporte-renovacionesReport-excel";
          filters["addsiniestrop"] = addSiniestrosBitacora
            ? addSiniestrosBitacora
            : false;
          if (option == 1) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            filters.excel_type = option;
            // $scope.url_go_excel = 'v2/polizas/reporte-renovaciones-excel';
            $http({
              method: "POST",
              url: url.IP + $scope.url_go_excel,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Renovaciones.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          } else if (option == 2) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            filters.excel_type = option;
            $http({
              method: "POST",
              // url: url.IP +'reporte-renovaciones-excel' ,
              url: url.IP + "service_reporte-renovacionesReport-excel",
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Renovaciones.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "ReportePolizasContributoriasController",
      ReportePolizasContributoriasController
    );

  ReportePolizasContributoriasController.$inject = [
    "appStates",
    "dataFactory",
    "$sessionStorage",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$parse",
    "exportFactory",
    "$uibModal",
    "$localStorage",
  ];

  function ReportePolizasContributoriasController(
    appStates,
    dataFactory,
    $sessionStorage,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $parse,
    exportFactory,
    $uibModal,
    $localStorage
  ) {
    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? -1 : str1 > str2 ? 1 : 0;
      },

      "non-empty-string-desc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? 1 : str1 > str2 ? -1 : 0;
      },
    });
    var hCols = [];
    var paso = 0;
    $scope.$on("ngRepeatFinished", function () {
      paso++;
      // console.log("hola");
      $("#example").DataTable().destroy();

      //Only needed for the filename of export files.
      //Normally set in the title tag of your page.document.title = 'Simple DataTable';
      //Define hidden columns

      // DataTable initialisation
      $("#example").DataTable({
        dom:
          "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-12'p<br/>i>>",
        info: false,
        paging: false,
        autoWidth: true,
        columnDefs: [
          {
            visible: false,
            targets: hCols,
          },
          {
            type: "non-empty-string",
            targets: 0,
          },
        ],
        buttons: [
          {
            extend: "colvis",
            collectionLayout: "three-column",
            text: function () {
              var totCols = $("#example thead th").length;
              var hiddenCols = hCols.length;
              var shownCols = totCols - hiddenCols;
              return "Columnas (" + shownCols + " de " + totCols + ")";
            },
            prefixButtons: [
              {
                extend: "colvisGroup",
                text: "Mostrar todo",
                show: ":hidden",
              },
              {
                extend: "colvisRestore",
                text: "Restaurar",
              },
            ],
          },
        ],
        oLanguage: {
          oPaginate: {
            sNext: '<span class="pagination-default">&#x276f;</span>',
            sPrevious: '<span class="pagination-default">&#x276e;</span>',
          },
        },
        initComplete: function (settings, json) {
          // Adjust hidden columns counter text in button -->
          $("#example").on(
            "column-visibility.dt",
            function (e, settings, column, state) {
              var index = hCols.indexOf(column);
              if (state === false) {
                if (index === -1) {
                  hCols.push(column);
                }
              }
              if (
                $(".dt-button-collection.dropdown-menu.three-column").length ===
                  1 &&
                state === true
              ) {
                // console.log($('.dt-button-collection.dropdown-menu.three-column').length);
                if (index !== -1) {
                  hCols.splice(index, 1);
                }
                // console.log("si entro");
              }
              // var visCols = $('#example thead tr:first th').length;

              //Below: The minus 2 because of the 2 extra buttons Show all and Restore
              var tblCols =
                $(".dt-button-collection li[aria-controls=example] a").length -
                2;
              var visCols = tblCols - hCols.length;
              $(".buttons-colvis[aria-controls=example] span").html(
                "Columnas (" + visCols + " de " + tblCols + ")"
              );
              e.stopPropagation();
            }
          );
        },
      });
    });

    $(".js-example-basic-multiple").select2();

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.org_name = usr.urlname;

    var vm = this;
    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 7,
        name: "Semanal",
      },
      {
        id: 14,
        name: "Catorcenal",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
      {
        id: 15,
        name: "No renovada",
      },
    ];
    vm.option_policy = [
      {
        id: 1,
        name: "Fecha de ingreso",
      },
      {
        id: 2,
        name: "Vigencia",
      },
    ];

    vm.option_policy = [
      {
        id: 1,
        name: "Fecha de ingreso",
      },
      {
        id: 2,
        name: "Vigencia",
      },
    ];
    vm.Generar = Generar;
    vm.tableRes = {};
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.changeUntil = changeUntil;
    vm.changePolicy = changePolicy;
    vm.goToInfo = goToInfo;
    vm.formatearNumero = formatearNumero;
    vm.changeGroupBy = changeGroupBy;
    vm.only_caratula_poliza = 0;
    vm.form = {
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      contratante: 0,
      group: 0,
    };

    $scope.subgroups = [];
    $scope.subsubgroups = [];
    $scope.subgrouping = [];
    $scope.subsubgrouping = [];
    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;

    vm.changeSubgrouping = changeSubgrouping;
    vm.changeSubsubgrouping = changeSubsubgrouping;
    vm.table = {
      headers: [
        "No.Póliza",
        "Tipo",
        "Contratante",
        "Proveedor",
        "Ramo",
        "Subramo",
        "Paquete",
        "Forma de Pago",
        "Estatus",
        "Inicio Póliza",
        "Folio",
        "Moneda",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Observaciones",
        "Creado por",
        "Clave",
        "Asegurado/Serial",
        "Fecha creación",
        "Marca - Modelo - Año",
        "Versión",
        "Placas",
        "Motor",
        "Adaptaciones",
        "Dirección",
        "Fin Póliza",
      ],
    };

    vm.group_by = [
      {
        id: 1,
        name: "Aseguradora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 6,
        name: "Estatus",
      },
      {
        id: 7,
        name: "Usuario",
      },
    ];

    $scope.origins = [
      {
        id: 1,
        name: "Nuevas",
      },
      {
        id: 2,
        name: "Renovación",
      },
      {
        id: 0,
        name: "Ambos",
      },
    ];
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    $scope.vigency = false;
    $scope.created_at = false;

    $scope.columnArray = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;

    function changeSubgroup(subg) {
      vm.form.subgroup = subg;
      vm.subgroup = subg;
      $scope.subsubgroups = subg.subsubgrupos ? subg.subsubgrupos : [];
    }
    function changeSubsubgroup(subg) {
      vm.form.subsubgroup = subg;
      vm.subsubgroup = subg;
    }
    // Nivel de agrupación
    function changeSubgrouping(subgl) {
      vm.form.subgrouping = subgl;
      vm.subgrouping = subgl;
      $scope.subsubgrouping = subgl.subsubgrupos ? subgl.subsubgrupos : [];
    }
    function changeSubsubgrouping(subgl) {
      vm.form.subsubgrouping = subgl;
      vm.subsubgrouping = subgl;
    }
    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };

    $scope.$watch("vm.word", function (newValue, oldValue) {
      if (vm.word) {
        if (vm.word.id) {
          vm.only_caratula_poliza = parseInt(vm.word.id);
        } else {
          vm.only_caratula_poliza = 0;
        }
      }
    });
    function changePolicy(par, asc) {
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.policy_nump_asc = asc;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = asc;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.policy_aseg_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = asc;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.policy_ramo_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = asc;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.policy_subramo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = asc;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.policy_pack_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = asc;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;

        case 7:
          Generar(par, asc);
          vm.policy_conc_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = asc;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.policy_fpago_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.policy_status_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.policy_vig_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.policy_hasta_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = asc;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 12:
          Generar(par, asc);
          vm.policy_clave_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = asc;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 13:
          Generar(par, asc);
          vm.policy_folio_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = asc;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 14:
          Generar(par, asc);
          vm.policy_moneda_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = asc;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 15:
          Generar(par, asc);
          vm.policy_pneta_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = asc;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 16:
          Generar(par, asc);
          vm.policy_rpf_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = asc;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 17:
          Generar(par, asc);
          vm.policy_der_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = asc;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 18:
          Generar(par, asc);
          vm.policy_iva_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = asc;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 19:
          Generar(par, asc);
          vm.policy_ptotal_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = asc;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 20:
          Generar(par, asc);
          vm.policy_com_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 21:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = asc;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 22:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 23:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_contgroup_asc = asc;
          vm.policy_created_asc = 0;
          break;
        case 24:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_contgroup_asc = asc;
          break;
      }
    }

    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }

    $scope.renewals = 0;
    $scope.valueRadioRen = function (val) {
      if (val == 1) {
        vm.form.renewals = 1;
        toaster.warning("De clic en Consultar");
      } else if (val == 2) {
        vm.form.renewals = 1;
        toaster.warning("De clic en Consultar");
      } else {
        vm.form.renewals = 0;
        toaster.warning("De clic en Consultar");
      }
    };

    activate();
    vm.form.since = convertDate(new Date());
    vm.form.until = convertDate(new Date());
    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function activate() {
      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.sub_total = 0;
      $scope.comision = 0;
      if (!vm.acceso_ver_ot) {
        vm.form.ot_rep = 3;
        vm.ot_rep = 3;
      }
      /* Información de usuario */
      $scope.infoUser = $sessionStorage.infoUser;
      vm.form.contratante =
        $localStorage.saved_filters_reporte_poliza &&
        $localStorage.saved_filters_reporte_poliza["contratante"]
          ? $localStorage.saved_filters_reporte_poliza["contratante"]
          : "";
      vm.form.group =
        $localStorage.saved_filters_reporte_poliza &&
        $localStorage.saved_filters_reporte_poliza["group"]
          ? $localStorage.saved_filters_reporte_poliza["group"]
          : 0;
      vm.form.group_by =
        $localStorage.saved_filters_reporte_poliza &&
        $localStorage.saved_filters_reporte_poliza["group_by"]
          ? $localStorage.saved_filters_reporte_poliza["group_by"]
          : 0;
      vm.form.dates_sel =
        $localStorage.saved_filters_reporte_poliza &&
        $localStorage.saved_filters_reporte_poliza["dates_sel"]
          ? $localStorage.saved_filters_reporte_poliza["dates_sel"]
          : 0;
      vm.word =
        $localStorage.saved_filters_reporte_poliza &&
        $localStorage.saved_filters_reporte_poliza["caratula"]
          ? $localStorage.saved_filters_reporte_poliza["caratula"]
          : "";

      if (vm.form.dates_sel) {
        $scope.vigency = true;
      }
    }
    function changeGroupBy() {
      $scope.grupos_result = [];
      $scope.showSums = false;
      vm.show_pag_cobranza = false;
    }

    $scope.changeReport = function () {
      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id == 1) {
          $scope.created_at = true;
          $scope.vigency = false;
        } else if (vm.form.dates_sel.id == 2) {
          $scope.vigency = true;
          $scope.created_at = false;
        }
      } else {
        $scope.vigency = false;
        $scope.created_at = false;
      }
    };

    $scope.reporte = false;
    $scope.showButtonExcel = false;
    function Generar(order, asc, parPage) {
      if (vm.acceso_ver_ot || vm.acceso_ver_pol) {
        var l = Ladda.create(document.querySelector(".ladda-buttonC"));
        l.start();
        $scope.order = order;
        $scope.asc = asc;
        if (
          vm.form.dates_sel == undefined ||
          vm.form.dates_sel == null ||
          !vm.form.dates_sel
        ) {
          l.stop();
          SweetAlert.swal(
            "Información",
            "Es necesario seleccionar una opción de Reporte por",
            "error"
          );
          return;
        }
        var since = toDate(vm.form.since).getTime();
        var until = toDate(vm.form.until).getTime();
        var diff = until - since;
        var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
        if (antiguedad < 0) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        }

        $scope.reporte = true;
        $scope.insurances = [];
        $scope.total = 0;
        $scope.prima_neta = 0;
        $scope.comision = 0;
        if (vm.form.subgroup) {
          if (vm.form.subgroup.id) {
            var g1 = vm.form.subgroup.id;
          } else {
            var g1 = 0;
          }
        }
        if (vm.form.subsubgroup) {
          if (vm.form.subsubgroup.id) {
            var g2 = vm.form.subsubgroup.id;
          } else {
            var g2 = 0;
          }
        } else {
          var g2 = 0;
        }
        var params = {
          since: vm.form.since ? vm.form.since : vm.form.si,
          until: vm.form.until ? vm.form.until : vm.form.un,
          contratante: vm.form.contratante.value
            ? vm.form.contratante.value
            : 0,
          grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
          type_contractor: vm.form.contratante.type
            ? vm.form.contratante.type
            : 0,
          order: order,
          asc: asc,
          page: parPage ? parPage : 1,
          report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 0,
        };
        if (vm.form.contratante) {
          if (vm.form.contratante.val == "") {
            params.contratante = 0;
            vm.form.contratante.value = "";
            vm.form.contratante.type = "";
          }
        }
        if (vm.form.group) {
          if (vm.form.group.val == "") {
            params.grupo = 0;
            vm.form.group.value = "";
            vm.form.group.type = "";
          }
        }
        params.since = params.since + " " + "00:00:00";
        params.until = params.until + " " + "23:59:59";
        $scope.filtros = params;
        $scope.url_go = "reporte-polizacontrib-rep/";
        $scope.url_go_excel = "service_reporte-polizascontribReport-excel";
        $http({
          method: "POST",
          url: url.IP + $scope.url_go,
          data: params,
        }).then(function success(response) {
          if (response.status == 200 || response.status == 201) {
            $("#example").DataTable().clear();
            $scope.insurances = response.data.results;
            $scope.sumas = response.data.sumas;
            l.stop();
            for (var i = 0; i < $scope.insurances.length; i++) {
              if ($scope.insurances[i].old_policies > 0) {
                if (
                  $scope.insurances[i].old_policies[0].base_policy.id ==
                  $scope.insurances[i].id
                ) {
                  $scope.insurances[i].asociada = $scope.insurances[i]
                    .old_policies[0].new_policy.poliza_number
                    ? $scope.insurances[i].old_policies[0].new_policy
                        .poliza_number
                    : $scope.insurances[i].old_policies[0].new_policy
                        .internal_number;
                }
              }
              if ($scope.insurances[i].document_type == 3) {
                $scope.insurances[i].document_type == "Póliza de Grupo";
              }
              if ($scope.insurances[i].document_type == "Póliza") {
                $scope.insurances[i].document_type =
                  $scope.insurances[i].status == 1
                    ? "OT"
                    : $scope.insurances[i].status == 2
                    ? "OT"
                    : "Póliza";
              }
              $scope.insurances[i].forma_de_pago =
                $scope.insurances[i].forma_de_pago == 1
                  ? "Mensual"
                  : $scope.insurances[i].forma_de_pago == 2
                  ? "Bimestral"
                  : $scope.insurances[i].forma_de_pago == 3
                  ? "Trimestral"
                  : $scope.insurances[i].forma_de_pago == 5
                  ? "Contado"
                  : $scope.insurances[i].forma_de_pago == 6
                  ? "Semestral"
                  : $scope.insurances[i].forma_de_pago == 7
                  ? "Semanal"
                  : $scope.insurances[i].forma_de_pago == 14
                  ? "Catorcenal"
                  : "Anual";
              $scope.insurances[i].f_currency =
                $scope.insurances[i].f_currency == 1 ? "Pesos" : "Dolares";
            }
            $scope.count_insurances = angular.copy($scope.insurances);
            if ($scope.insurances.length < 10) {
              for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
                var object = {
                  contratante: " ",
                };
                $scope.insurances.push(object);
              }
            }
            $scope.policy_config = {
              count: response.data.count,
              previous: response.data.previous,
              next: response.data.next,
            };
            vm.show_pag_policy = true;
            testPagination("insurances", "policy_config");
            if ($scope.insurances[0].poliza_number == " ") {
              toaster.warning("No se encontraron registros");
              $("#example").DataTable().clear();
              $("#example").DataTable().draw();
              $("#example").DataTable().destroy();
            } else {
              $scope.showButtonExcel = true;
              $scope.showSums = true;
            }
            $scope.insurances.forEach(function (line) {
              if (line.url) {
                $http({
                  method: "GET",
                  url: url.IP + "historic-policies/",
                  params: {
                    actual_id: line.id,
                  },
                }).then(function success(response) {
                  if (response.data.results.length > 0) {
                    response.data.results.forEach(function (item) {
                      if (line.id == item.new_policy.id) {
                        line.origin = "Renovación";
                      } else {
                        line.origin = "Nueva";
                      }
                    });
                  } else {
                    line.origin = "Nueva";
                  }
                });
              }
            });
          } else {
            l.stop();
            toaster.warning("Error en la llamada registros");
          }
          $("#example").DataTable().destroy();
        });
      } else {
        SweetAlert("Error", "No tiene acceso a ver OTs ni Pólizas", "error");
      }
      $localStorage.saved_filters_reporte_poliza = angular.copy(params);
      $localStorage.saved_filters_reporte_poliza["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_reporte_poliza["group"] = vm.form.group;
      $localStorage.saved_filters_reporte_poliza["dates_sel"] =
        vm.form.dates_sel;
    }

    $scope.open_in_same_tab_natural = function (
      name,
      route,
      params,
      identifier
    ) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $state.go($scope.route_for_new_tab, params);
    };

    function goToInfo(insurance) {
      if (vm.acceso_ver_pol) {
        if (insurance.document_type == 3) {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "colectividades.info",
            { polizaId: insurance.id },
            insurance.id
          );
        }
      }
    }
    $scope.exportDataExcel = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.filtros.orden = $scope.columnArray;
      $scope.filtros.excel_type = 2;
      var $listM = $("#example th")
        .map(function () {
          return $.trim($(this).text());
        })
        .get();
      if (vm.permiso_comisiones) {
        if ($listM.includes("Comisión")) {
          $listM.push("Comisión");
        }
        if ($listM.includes("Comisión Porcentaje")) {
          $listM.push("Comisión Porcentaje");
        }
      }
      if ($listM.includes("Tipo")) {
        $listM.push("Tipo");
      }
      if ($listM.includes("No.Póliza")) {
        $listM.push("No.Póliza");
      }
      if ($listM.includes("No.Interno")) {
        $listM.push("No.Interno");
      }
      if ($listM.includes("Contratante")) {
        $listM.push("Contratante");
      }
      if ($listM.includes("Email")) {
        $listM.push("Email");
      }
      if ($listM.includes("Grupo")) {
        $listM.push("Grupo");
      }
      if ($listM.includes("Proveedor")) {
        $listM.push("Proveedor");
      }
      if ($listM.includes("Ramo")) {
        $listM.push("Ramo");
      }
      if ($listM.includes("Subramo")) {
        $listM.push("Subramo");
      }
      if ($listM.includes("Identificador")) {
        $listM.push("Identificador");
      }
      if ($listM.includes("Paquete")) {
        $listM.push("Paquete");
      }
      if ($listM.includes("Prima Neta")) {
        $listM.push("Prima Neta");
      }
      if ($listM.includes("Descuento")) {
        $listM.push("Descuento");
      }
      if ($listM.includes("RPF")) {
        $listM.push("RPF");
      }
      if ($listM.includes("Derecho")) {
        $listM.push("Derecho");
      }
      if ($listM.includes("IVA")) {
        $listM.push("IVA");
      }
      if ($listM.includes("Prima Total")) {
        $listM.push("Prima Total");
      }
      if ($listM.includes("Forma de Pago")) {
        $listM.push("Forma de Pago");
      }
      if ($listM.includes("Asegurado/Serial")) {
        $listM.push("Asegurado");
      }
      if ($listM.includes("Estatus")) {
        $listM.push("Estatus");
      }
      if ($listM.includes("Inicio Póliza")) {
        $listM.push("Inicio Póliza");
      }
      if ($listM.includes("Fin Póliza")) {
        $listM.push("Fin Póliza");
      }
      if ($listM.includes("Referenciador")) {
        $listM.push("Referenciador");
      }
      if ($listM.includes("Folio")) {
        $listM.push("Folio");
      }
      if ($listM.includes("Moneda")) {
        $listM.push("Moneda");
      }
      if ($listM.includes("Fecha creación")) {
        $listM.push("Fecha creación");
      }
      if ($listM.includes("Observaciones")) {
        $listM.push("Observaciones");
      }
      if ($listM.includes("Creado por")) {
        $listM.push("Creado por");
      }
      if ($listM.includes("Clave")) {
        $listM.push("Clave");
      }
      if ($listM.includes("Marca - Modelo - Año")) {
        $listM.push("Marca");
        $listM.push("Modelo");
        $listM.push("Año");
      }
      if ($listM.includes("Versión")) {
        $listM.push("Versión");
      }
      if ($listM.includes("Placas")) {
        $listM.push("Placas");
      }
      if ($listM.includes("Serie")) {
        $listM.push("Serie");
      }
      if ($listM.includes("Motor")) {
        $listM.push("Motor");
      }
      if ($listM.includes("Adaptaciones")) {
        $listM.push("Adaptaciones");
      }
      if ($listM.includes("Dirección")) {
        $listM.push("Dirección");
      }
      if ($listM.includes("Ejecutivo Cobranza")) {
        $listM.push("Ejecutivo Cobranza");
      }
      if ($listM.includes("Responsable")) {
        $listM.push("Responsable");
      }
      if ($listM.includes("Sucursal")) {
        $listM.push("Sucursal");
      }
      if ($listM.includes("Conducto de Pago")) {
        $listM.push("Conducto de Pago");
      }
      if ($listM.includes("Renovable")) {
        $listM.push("Renovable");
      }
      if ($listM.includes("OT/Póliza asociada")) {
        $listM.push("OT/Póliza asociada");
      }
      if ($listM.includes("Origen Póliza")) {
        $listM.push("Origen Póliza");
      }
      if ($listM.includes("Agrupación")) {
        $listM.push("Agrupación");
      }
      if ($listM.includes("Subagrupación")) {
        $listM.push("Subagrupación");
      }
      if ($listM.includes("Subsubagrupación")) {
        $listM.push("Subsubagrupación");
      }
      if ($listM.includes("Clasificación")) {
        $listM.push("Clasificación");
      }
      if ($listM.includes("Línea de Negocio")) {
        $listM.push("Línea de Negocio");
      }
      if ($listM.includes("Célula")) {
        $listM.push("Célula");
      }
      if ($listM.includes("Contacto(nombre)")) {
        $listM.push("Contacto(nombre)");
      }
      if ($listM.includes("Contacto(telefono)")) {
        $listM.push("Contacto(telefono)");
      }
      if ($listM.includes("Contacto(email)")) {
        $listM.push("Contacto(email)");
      }
      if ($listM.includes("Carátula")) {
        $listM.push("Carátula");
      }
      if ($listM.includes("Carátula")) {
        $listM.push("Carátula");
      }
      if ($listM.includes("Póliza Anterior")) {
        $listM.push("Póliza Anterior");
      }
      if ($listM.includes("Póliza Siguiente")) {
        $listM.push("Póliza Siguiente");
      }
      if ($listM.includes("Fecha Cancelación")) {
        $listM.push("Fecha Cancelación");
      }
      if ($listM.includes("Adjuntos")) {
        $listM.push("Adjuntos");
      }
      if ($listM.includes("Bitacora")) {
        $listM.push("Bitacora");
      }
      if ($listM.includes("Colectividad/PG completa")) {
        $listM.push("Colectividad/PG completa");
      }
      if ($listM.includes("Estado Circulación")) {
        $listM.push("Estado Circulación");
      }
      if ($listM.includes("Tipo Administración")) {
        $listM.push("Tipo Administración");
      }
      if ($listM.includes("RFC Clave")) {
        $listM.push("RFC Clave");
      }
      if ($listM.includes("RFC HomoClave")) {
        $listM.push("RFC HomoClave");
      }
      if ($listM.includes("Domicilio Calle-Núm")) {
        $listM.push("Domicilio Calle-Núm");
      }
      if ($listM.includes("Domicilio Colonia")) {
        $listM.push("Domicilio Colonia");
      }
      if ($listM.includes("Domicilio C.P.")) {
        $listM.push("Domicilio C.P.");
      }
      if ($listM.includes("Domicilio Población/Municipio")) {
        $listM.push("Domicilio Población/Municipio");
      }
      if ($listM.includes("Domicilio Estado")) {
        $listM.push("Domicilio Estado");
      }
      var scolumns = [
        "Tipo",
        "No.Póliza",
        "Contratante",
        "Grupo",
        "Proveedor",
        "Ramo",
        "Subramo",
        "Identificador",
        "Paquete",
        "Prima Neta",
        "Descuento",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Comisión Porcentaje",
        "Forma de Pago",
        "Asegurado/Serial",
        "Estatus",
        "Inicio Póliza",
        "Fin Póliza",
        "Referenciador",
        "Folio",
        "Moneda",
        "Fecha creación",
        "Observaciones",
        "Creado por",
        "Clave",
        "Marca",
        "Modelo",
        "Año",
        "Versión",
        "Placas",
        "Motor",
        "Adaptaciones",
        "Dirección",
        "Ejecutivo Cobranza",
        "Responsable",
        "Sucursal",
        "Renovable",
        "OT/Póliza asociada",
        "Origen Póliza",
        "Agrupación",
        "Subagrupación",
        "Subsubagrupación",
        "Clasificación",
        "Línea de Negocio",
        "Célula",
        "Contacto(nombre)",
        "Contacto(telefono)",
        "Contacto(email)",
        "Carátula",
        "Póliza Siguiente",
        "Fecha Cancelación",
        "Adjuntos",
        "Colectividad/PG completa",
        "Estado Circulación",
        "Tipo Administración",
        "No.Interno",
        "Serie",
        "Póliza Anterior",
        "Conducto de Pago",
        "Colectividad/PG completa",
        "Bitacora",
        "RFC Clave",
        "RFC HomoClave",
        "Domicilio Calle-Núm",
        "Domicilio Colonia",
        "Domicilio C.P.",
        "Domicilio Población/Municipio",
        "Domicilio Estado",
      ];
      var foo = [];
      $.grep(scolumns, function (el) {
        if ($.inArray(el, $listM) != -1) {
          foo.push(el);
        }
      });
      $scope.filtros["ot_rep"] = $scope.ot_rep;
      $scope.filtros["cols1"] = foo;
      if (param == 1) {
        $http({
          method: "POST",
          url: url.IP + $scope.url_go_excel,
          data: $scope.filtros,
          headers: { "Content-Type": "application/json" },
        })
          .then(function (data) {
            if (data.status == 200) {
              l.stop();
              // Conexión a socket.io
              // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
              // if($scope.org_name =='ancora'){
              //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
              // }else{
              var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
              // }
              socket.emit("subscribe", data.data);
              // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
              socket.on(data.data, function (url) {
                // vm.main.notifications['count']  +=1;
                var notificacion = {
                  title: "El reporte solicitado ha sido generado",
                  description: url,
                  model: 26,
                  id_reference: 0,
                };
                dataFactory
                  .post("notificaciones/", notificacion)
                  .then(function success(response) {
                    SweetAlert.swal({
                      title: "El reporte está listo para descargar",
                      icon: "success",
                      text: "Encuentra la liga de descarga en la sección de notificaciones",
                      timer: 5000,
                    });
                    socket.disconnect();
                  })
                  .catch(function (err) {
                    socket.disconnect();
                  });
              });
              toaster.info(
                "Generando...",
                "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
              );
            } else {
              l.stop();
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      vm.form.subgroup = 0;
      vm.form.subsubgroup = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        if (vm.form.group.val) {
          var word_data = vm.form.group.val;
        }
      }
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }
    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }
    $scope.actual_page = 1;
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;
      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }
      $scope.lastPage = function () {
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }
        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };
      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;
        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
      $scope.status = function (parValue) {
        switch (parValue) {
          case 1:
            return "En trámite";
            break;
          case 2:
            return "OT Cancelada";
            break;
          case 4:
            return "Precancelada";
            break;
          case 10:
            return "Por iniciar";
            break;
          case 11:
            return "Cancelada";
            break;
          case 12:
            return "Renovada";
            break;
          case 13:
            return "Vencida";
            break;
          case 14:
            return "Vigente";
            break;
          case 15:
            return "No renovada";
            break;
          default:
            return "Pendiente";
        }
      };
      function getPolicyPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              $scope.data_pagination = request.data.results;
              for (var i = 0; i < $scope.data_pagination.length; i++) {
                if ($scope.insurances[i].document_type == 1) {
                  $scope.insurances[i].document_type == "Póliza";
                } else if ($scope.insurances[i].document_type == 3) {
                  $scope.insurances[i].document_type == "Colectividad";
                } else if ($scope.insurances[i].document_type == 11) {
                  $scope.insurances[i].document_type == "Carátula";
                } else if ($scope.insurances[i].document_type == 12) {
                  $scope.insurances[i].document_type == "Póliza de Carátula";
                }
                // $scope.data_pagination[i].document_type = $scope.data_pagination[i].document_type == 1 ? "Póliza" : "Colectividad";
                if ($scope.data_pagination[i].document_type == "Póliza") {
                  $scope.data_pagination[i].document_type =
                    $scope.data_pagination[i].status == 1
                      ? "OT"
                      : $scope.data_pagination[i].status == 2
                      ? "OT"
                      : "Póliza";
                }
                $scope.data_pagination[i].forma_de_pago =
                  $scope.data_pagination[i].forma_de_pago == 1
                    ? "Mensual"
                    : $scope.data_pagination[i].forma_de_pago == 2
                    ? "Bimestral"
                    : $scope.data_pagination[i].forma_de_pago == 3
                    ? "Trimestral"
                    : $scope.data_pagination[i].forma_de_pago == 5
                    ? "Contado"
                    : $scope.data_pagination[i].forma_de_pago == 6
                    ? "Semestral"
                    : "Anual";
                $scope.data_pagination[i].status =
                  $scope.data_pagination[i].status == 1
                    ? "En trámite"
                    : $scope.data_pagination[i].status == 2
                    ? "OT Cancelada"
                    : $scope.data_pagination[i].status == 10
                    ? "Por Iniciar"
                    : $scope.data_pagination[i].status == 11
                    ? "Cancelada"
                    : $scope.data_pagination[i].status == 12
                    ? "Renovada"
                    : $scope.data_pagination[i].status == 13
                    ? "Vencida"
                    : $scope.data_pagination[i].status == 15
                    ? "No renovada"
                    : "Vigente";
                $scope.data_pagination[i].f_currency =
                  $scope.data_pagination[i].f_currency == 1
                    ? "Pesos"
                    : "Dolares";
              }
              $scope.count_pagination = angular.copy($scope.data_pagination);
              if ($scope.data_pagination.length < 10) {
                for (var i = 0; i < 10 - $scope.count_pagination.length; i++) {
                  var object = {
                    poliza_number: " ",
                    document_type: " ",
                    natural: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    paquete: " ",
                    forma_de_pago: " ",
                    status: " ",
                    start_of_validity: " ",
                    created_at: " ",
                    folio: " ",
                    f_currency: " ",
                    prima_neta: null,
                    rpf: null,
                    derecho: null,
                    iva: null,
                    prima_total: null,
                    comision: null,
                    observations: " ",
                    clave: " ",
                  };
                  $scope.data_pagination.push(object);
                }
              }

              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      $scope.infoUser = $sessionStorage.infoUser;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = 1;
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        var param = 1;
        if (option) {
          // Totales de la Agrupación
          var filter_policy = "service_reporte-polizascontribReport-excel";
          if (option == 1) {
            filters["excel_type"] = 1;
            var $listM = $("#example th")
              .map(function () {
                return $.trim($(this).text());
              })
              .get();
            filters["cols2"] = $listM;
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            $scope.url_go_excel = "service_reporte-polizascontribReport-excel";
            filters.export_type = option;
            $http({
              method: "POST",
              url: url.IP + filter_policy,
              data: filters,
            })
              .then(function success(response) {
                if (response.status == 200) {
                  l.stop();
                  // Conexión a socket.io
                  // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // if($scope.org_name =='ancora'){
                  //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                  // }else{
                  var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // }
                  socket.emit("subscribe", response.data);
                  // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                  // socket.on('result', function(url){
                  socket.on(response.data, function (url) {
                    var notificacion = {
                      title: "El reporte solicitado ha sido generado",
                      description: url,
                      model: 26,
                      id_reference: 0,
                    };
                    dataFactory
                      .post("notificaciones/", notificacion)
                      .then(function success(response) {
                        SweetAlert.swal({
                          title: "El reporte está listo para descargar",
                          icon: "success",
                          text: "Encuentra la liga de descarga en la sección de notificaciones",
                          timer: 5000,
                        });
                        socket.disconnect();
                        if ($uibModalInstance) {
                          $uibModalInstance.dismiss("cancel");
                        }
                      })
                      .catch(function (err) {
                        socket.disconnect();
                        if ($uibModalInstance) {
                          $uibModalInstance.dismiss("cancel");
                        }
                      });
                  });
                  toaster.info(
                    "Generando...",
                    "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                  );
                } else {
                  l.stop();
                  if ($uibModalInstance) {
                    $uibModalInstance.dismiss("cancel");
                  }
                  toaster.error(
                    "Aviso",
                    "Ha ocurrido un error, intente nuevamente"
                  );
                }
              })
              .catch(function (error) {
                l.stop();
                toaster.error(
                  "Aviso",
                  "Ha ocurrido un error, intente nuevamente"
                );
              });
          } else if (option == 2) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            $scope.url_go_excel = "service_reporte-polizascontribReport-excel";
            $http({
              method: "POST",
              url: url.IP + $scope.url_go_excel, //'reporte-polizas-excel',
              data: filters,
              headers: { "Content-Type": "application/json" },
            })
              .then(function (data) {
                if (data.status == 200) {
                  l.stop();
                  // Conexión a socket.io
                  // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // if($scope.org_name =='ancora'){
                  //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                  // }else{
                  var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // }
                  //var socket = io.connect("http://127.0.0.1:8080");
                  socket.emit("subscribe", data.data);
                  // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                  socket.on(data.data, function (url) {
                    // vm.main.notifications['count']  +=1;
                    var notificacion = {
                      title: "El reporte solicitado ha sido generado",
                      description: url,
                      model: 26,
                      id_reference: 0,
                    };
                    dataFactory
                      .post("notificaciones/", notificacion)
                      .then(function success(response) {
                        SweetAlert.swal({
                          title: "El reporte está listo para descargar",
                          icon: "success",
                          text: "Encuentra la liga de descarga en la sección de notificaciones",
                          timer: 5000,
                        });
                        socket.disconnect();
                        if ($uibModalInstance) {
                          $uibModalInstance.dismiss("cancel");
                        }
                      })
                      .catch(function (err) {
                        socket.disconnect();
                        if ($uibModalInstance) {
                          $uibModalInstance.dismiss("cancel");
                        }
                      });
                  });
                  toaster.info(
                    "Generando...",
                    "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                  );
                } else {
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    // -----------------PAGINACIÓN
    jQuery(function ($) {
      $("#exportButton").click(function () {
        // parse the HTML table element having an id=exportTable
        var dataSource = shield.DataSource.create({
          data: "#exportTable",
          schema: {
            type: "table",
            fields: {
              Recibo: { type: String },
              RPF: { type: Number },
              Estatus: { type: String },
            },
          },
        });

        // when parsing is done, export the data to PDF
        dataSource.read().then(function (data) {
          var pdf = new shield.exp.PDFDocument({
            author: "PrepBootstrap",
            created: new Date(),
          });

          pdf.addPage("a4", "portrait");

          pdf.table(
            50,
            50,
            data,
            [
              { field: "Recibo", title: "Número de Recibo", width: 200 },
              { field: "RPF", title: "RPF", width: 50 },
              { field: "Estatus", title: "Estatus del recibo", width: 200 },
            ],
            {
              margins: {
                top: 50,
                left: 50,
              },
            }
          );

          pdf.saveAs({
            fileName: "ReportePolizas",
          });
        });
      });
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "ReportePolizasGastosMedicosController",
      ReportePolizasGastosMedicosController
    );

  ReportePolizasGastosMedicosController.$inject = [
    "$sessionStorage",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$parse",
    "exportFactory",
    "$uibModal",
    "$localStorage",
    "appStates",
  ];

  function ReportePolizasGastosMedicosController(
    $sessionStorage,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $parse,
    exportFactory,
    $uibModal,
    $localStorage,
    appStates
  ) {
    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? -1 : str1 > str2 ? 1 : 0;
      },

      "non-empty-string-desc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? 1 : str1 > str2 ? -1 : 0;
      },
    });
    var hCols = [];
    var paso = 0;
    $scope.$on("ngRepeatFinished", function () {
      paso++;
      // console.log("hola");
      $("#example").DataTable().destroy();

      // DataTable initialisation
      $("#example").DataTable({
        dom:
          "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-12'p<br/>i>>",
        info: false,
        paging: false,
        autoWidth: true,
        columnDefs: [
          {
            visible: false,
            targets: hCols,
          },
          {
            type: "non-empty-string",
            targets: 0,
          },
        ],
        buttons: [
          {
            extend: "colvis",
            collectionLayout: "three-column",
            text: function () {
              var totCols = $("#example thead th").length;
              var hiddenCols = hCols.length;
              var shownCols = totCols - hiddenCols;
              return "Columnas (" + shownCols + " de " + totCols + ")";
            },
            prefixButtons: [
              {
                extend: "colvisGroup",
                text: "Mostrar todo",
                show: ":hidden",
              },
              {
                extend: "colvisRestore",
                text: "Restaurar",
              },
            ],
          },
        ],
        oLanguage: {
          oPaginate: {
            sNext: '<span class="pagination-default">&#x276f;</span>',
            sPrevious: '<span class="pagination-default">&#x276e;</span>',
          },
        },
        initComplete: function (settings, json) {
          // Adjust hidden columns counter text in button -->
          $("#example").on(
            "column-visibility.dt",
            function (e, settings, column, state) {
              var index = hCols.indexOf(column);
              if (state === false) {
                if (index === -1) {
                  hCols.push(column);
                }
              }
              if (
                $(".dt-button-collection.dropdown-menu.three-column").length ===
                  1 &&
                state === true
              ) {
                // console.log($('.dt-button-collection.dropdown-menu.three-column').length);
                if (index !== -1) {
                  hCols.splice(index, 1);
                }
                // console.log("si entro");
              }
              // var visCols = $('#example thead tr:first th').length;

              //Below: The minus 2 because of the 2 extra buttons Show all and Restore
              var tblCols =
                $(".dt-button-collection li[aria-controls=example] a").length -
                2;
              var visCols = tblCols - hCols.length;
              $(".buttons-colvis[aria-controls=example] span").html(
                "Columnas (" + visCols + " de " + tblCols + ")"
              );
              e.stopPropagation();
            }
          );
        },
      });
    });

    $(".js-example-basic-multiple").select2();

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.orgName = usr.orgname;

    vm.option_policy = [
      {
        id: 1,
        name: "Fecha de ingreso",
      },
      {
        id: 2,
        name: "Vigencia",
      },
    ];

    vm.Generar = Generar;
    vm.tableRes = {};
    vm.changeUntil = changeUntil;
    vm.changePolicy = changePolicy;
    vm.goToInfo = goToInfo;
    vm.formatearNumero = formatearNumero;

    vm.form = {
      since: convertDate(new Date()),
      until: convertDate(new Date()),
    };

    vm.table = {
      headers: [
        "Número de Póliza",
        "Contratante",
        "Vigencia Póliza",
        "Prima Neta",
        "Dirección",
        "Titular",
        "Fecha Nac. Titular",
        "Beneficiario",
        "Fecha Nac. Beneficiario",
      ],
    };

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    $scope.vigency = false;
    $scope.created_at = false;

    $scope.columnArray = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;

    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };

    function changePolicy(par, asc) {
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.policy_nump_asc = asc;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = asc;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.policy_aseg_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = asc;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.policy_ramo_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = asc;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.policy_subramo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = asc;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.policy_pack_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = asc;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;

        case 7:
          Generar(par, asc);
          vm.policy_conc_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = asc;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.policy_fpago_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.policy_status_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.policy_vig_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.policy_hasta_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = asc;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 12:
          Generar(par, asc);
          vm.policy_clave_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = asc;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 13:
          Generar(par, asc);
          vm.policy_folio_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = asc;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 14:
          Generar(par, asc);
          vm.policy_moneda_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = asc;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 15:
          Generar(par, asc);
          vm.policy_pneta_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = asc;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 16:
          Generar(par, asc);
          vm.policy_rpf_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = asc;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 17:
          Generar(par, asc);
          vm.policy_der_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = asc;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 18:
          Generar(par, asc);
          vm.policy_iva_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = asc;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 19:
          Generar(par, asc);
          vm.policy_ptotal_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = asc;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 20:
          Generar(par, asc);
          vm.policy_com_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 21:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = asc;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 22:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 23:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_contgroup_asc = asc;
          vm.policy_created_asc = 0;
          break;
        case 24:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_contgroup_asc = asc;
          break;
      }
    }

    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }
    if (vm.acceso_ver_ot) {
      $scope.ot_rep = 1;
      vm.form.ot_rep = 1;
    } else {
      vm.form.ot_rep = 3;
      $scope.ot_rep = 3;
    }
    $scope.valueRadioRep = function (val) {
      if (val == true) {
        if (!vm.acceso_ver_ot) {
          $scope.ot_rep = 3;
          vm.form.ot_rep = 3;
        } else {
          vm.form.ot_rep = true;
          toaster.warning("De clic en Consultar");
        }
      } else {
        vm.form.ot_rep = 3;
        toaster.warning("De clic en Consultar");
      }
    };

    $scope.renewals = 0;
    $scope.valueRadioRen = function (val) {
      if (val == 1) {
        vm.form.renewals = 1;
        toaster.warning("De clic en Consultar");
      } else if (val == 2) {
        vm.form.renewals = 1;
        toaster.warning("De clic en Consultar");
      } else {
        vm.form.renewals = 0;
        toaster.warning("De clic en Consultar");
      }
    };

    activate();
    vm.form.since = convertDate(new Date());
    vm.form.until = convertDate(new Date());

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }
    /*
      function changeCreated(created) {
        }
        */

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function activate() {
      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.sub_total = 0;
      $scope.comision = 0;
      if (!vm.acceso_ver_ot) {
        vm.form.ot_rep = 3;
        vm.ot_rep = 3;
      }

      vm.form.dates_sel =
        $localStorage.saved_filters_reporte_titulares &&
        $localStorage.saved_filters_reporte_titulares["dates_sel"]
          ? $localStorage.saved_filters_reporte_titulares["dates_sel"]
          : 0;
      if ($localStorage.saved_filters_reporte_titulares) {
        if ($localStorage.saved_filters_reporte_titulares["dates_sel"]) {
          if (vm.form.dates_sel.id == 1) {
            $scope.created_at = true;
            $scope.vigency = false;
          } else if (vm.form.dates_sel.id == 2) {
            $scope.vigency = true;
            $scope.created_at = false;
          }
        }
      }
      $scope.ot_rep =
        $localStorage.saved_filters_reporte_titulares &&
        $localStorage.saved_filters_reporte_titulares["ot_rep"]
          ? $localStorage.saved_filters_reporte_titulares["ot_rep"]
          : 1;
      $scope.renewals =
        $localStorage.saved_filters_reporte_titulares &&
        $localStorage.saved_filters_reporte_titulares["renewals"]
          ? $localStorage.saved_filters_reporte_titulares["renewals"]
          : 0;
    }

    $scope.changeReport = function () {
      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id == 1) {
          $scope.created_at = true;
          $scope.vigency = false;
        } else if (vm.form.dates_sel.id == 2) {
          $scope.vigency = true;
          $scope.created_at = false;
        }
      } else {
        $scope.vigency = false;
        $scope.created_at = false;
      }
    };

    $scope.reporte = false;
    $scope.showButtonExcel = false;
    $scope.numberFormatUdi = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueUdi = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      } else {
      }
    };
    $scope.numberFormatDolar = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueDolar = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      } else {
      }
    };

    function Generar(order, asc, parPage) {
      if (vm.acceso_ver_ot || vm.acceso_ver_pol) {
        var l = Ladda.create(document.querySelector(".ladda-buttonC"));
        l.start();

        $scope.order = order;
        $scope.asc = asc;
        if (vm.form.dates_sel == undefined || vm.form.dates_sel == null) {
          l.stop();
          SweetAlert.swal(
            "Información",
            "Es necesario seleccionar una opción de Reporte por",
            "error"
          );

          return;
        }

        var since = toDate(vm.form.since).getTime();
        var until = toDate(vm.form.until).getTime();
        var diff = until - since;

        $scope.reporte = true;
        $scope.insurances = [];
        $scope.total = 0;
        $scope.prima_neta = 0;
        $scope.comision = 0;

        var params = {
          report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 0,
          since: vm.form.since ? vm.form.since : vm.form.si,
          until: vm.form.until ? vm.form.until : vm.form.un,
          ot: vm.form.ot_rep,
          order: order,
          asc: asc,
          page: parPage ? parPage : 1,
          group_by: vm.form.group_by ? vm.form.group_by.id : 0,
          renewals: $scope.renewals ? $scope.renewals : 0,
        };
        params.since = params.since + " " + "00:00:00";
        params.until = params.until + " " + "23:59:59";
        $scope.filtros = params;
        $http({
          method: "POST",
          url: url.IP + "reporte-poliza-gastos-medicos/", //'reporte-poliza-rep/',
          data: params,
        }).then(function success(response) {
          if (response.status == 200 || response.status == 201) {
            $("#example").DataTable().clear();
            if (params.group_by == 0) {
              $scope.insurances = response.data.results;
              $scope.sumas = response.data.sumas;
              l.stop();

              for (var i = 0; i < $scope.insurances.length; i++) {
                $scope.insurances[i].document_type =
                  $scope.insurances[i].document_type == 1
                    ? "Póliza"
                    : "Colectividad";
                if ($scope.insurances[i].document_type == "Póliza") {
                  $scope.insurances[i].document_type =
                    $scope.insurances[i].status == 1
                      ? "OT"
                      : $scope.insurances[i].status == 2
                      ? "OT"
                      : "Póliza";
                }
                $scope.insurances[i].forma_de_pago =
                  $scope.insurances[i].forma_de_pago == 1
                    ? "Mensual"
                    : $scope.insurances[i].forma_de_pago == 2
                    ? "Bimestral"
                    : $scope.insurances[i].forma_de_pago == 3
                    ? "Trimestral"
                    : $scope.insurances[i].forma_de_pago == 5
                    ? "Contado"
                    : $scope.insurances[i].forma_de_pago == 6
                    ? "Semestral"
                    : "Anual";
                // $scope.insurances[i].status = $scope.insurances[i].status == 1 ? "En trámite" :
                //   $scope.insurances[i].status == 2 ? "OT Cancelada" : $scope.insurances[i].status == 10 ? "Por Iniciar" :
                //   $scope.insurances[i].status == 11 ? "Cancelada" : $scope.insurances[i].status == 12 ? "Renovada" :
                //   $scope.insurances[i].status == 13 ? "Vencida" : $scope.insurances[i].status == 15 ? "No renovada" : "Vigente";
                $scope.insurances[i].f_currency =
                  $scope.insurances[i].f_currency == 1 ? "Pesos" : "Dolares";
              }

              $scope.count_insurances = angular.copy($scope.insurances);
              if ($scope.insurances.length < 10) {
                for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
                  var object = {
                    contratante: " ",
                    poliza_number: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    paquete: " ",
                    prima_neta: null,
                    rpf: null,
                    derecho: null,
                    iva: null,
                    prima_total: null,
                    comision: null,
                    forma_de_pago: " ",
                    document_type: " ",
                    status: " ",
                    start_of_validity: " ",
                    folio: " ",
                    f_currency: " ",
                    observations: " ",
                    created_at: " ",
                    clave: " ",
                    accidents_policy: [],
                  };
                  $scope.insurances.push(object);
                }
              }

              $scope.policy_config = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };
              vm.show_pag_policy = true;
              testPagination("insurances", "policy_config");

              if ($scope.insurances[0].poliza_number == " ") {
                toaster.warning("No se encontraron registros");
                $("#example").DataTable().clear();
                $("#example").DataTable().draw();
                $("#example").DataTable().destroy();
              } else {
                $scope.showButtonExcel = true;
                $scope.showSums = true;
              }
            } else {
              l.stop();
              $scope.grupos_result = response.data;
              $scope.showButtonExcel = true;
              $scope.showSums = false;
            }
          } else {
            l.stop();
            toaster.warning("Error en la llamada registros");
            console.log("______", response);
          }

          $("#example").DataTable().destroy();
        });
      } else {
        SweetAlert("Error", "No tiene acceso a ver OTs ni Pólizas", "error");
      }

      $localStorage.saved_filters_reporte_titulares = angular.copy(params);
      $localStorage.saved_filters_reporte_titulares["dates_sel"] =
        vm.form.dates_sel;
      $localStorage.saved_filters_reporte_titulares["ot_rep"] = $scope.ot_rep;
      // $localStorage.saved_filters_reporte_titulares['renewals'] = $scope.renewals;
    }

    //Remite las opciones de Reporte por:
    function goToInfo(insurance) {
      if (vm.acceso_ver_pol) {
        if (insurance.document_type == "Póliza") {
          var name = "Información pólizas";
          var route = "polizas.info";
        } else if (insurance.document_type == "Colectividad") {
          var name = "Información colectividad";
          var route = "colectividades.info";
        }
      }

      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      if (vm.acceso_ver_pol) {
        if (insurance.document_type == "Póliza") {
          $state.go("polizas.info", { polizaId: insurance.id });
        } else if (insurance.document_type == "Colectividad") {
          $state.go("colectividades.info", { polizaId: insurance.id });
        }
      }
    }

    /**/
    $scope.exportDataExcel = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.filtros.orden = $scope.columnArray;
      $scope.filtros.excel_type = 2;
      var $listM = $("#example th")
        .map(function () {
          return $.trim($(this).text());
        })
        .get();
      console.log($listM);

      console.log($listM);

      var scolumns = [
        "Número de Póliza",
        "Contratante",
        "Vigencia Póliza",
        "Prima Neta",
        "Dirección",
        "Titular",
        "Fecha Nac. Titular",
        "Beneficiario",
        "Fecha Nac. Beneficiario",
      ];

      var foo = [];

      $.grep(scolumns, function (el) {
        if ($.inArray(el, $listM) != -1) {
          foo.push(el);
        }
      });

      $scope.filtros["cols1"] = foo;

      if (param == 1) {
        $http({
          method: "POST",
          url: url.IP + "reporte-poliza-gastos-medicos-excel",
          data: $scope.filtros,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
          .then(function (data) {
            if (data.status == 200) {
              l.stop();
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Pólizas.xls");
            } else {
              SweetAlert.swal(
                "Error",
                "Ha ocurrido un error al descargar el reporte",
                "error"
              );
              l.stop();
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    // -----------PAGINACIÓN

    $scope.actual_page = 1;

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
      $scope.status = function (parValue) {
        switch (parValue) {
          case 1:
            return "En trámite";
            break;
          case 2:
            return "OT Cancelada";
            break;
          case 4:
            return "Precancelada";
            break;
          case 10:
            return "Por iniciar";
            break;
          case 11:
            return "Cancelada";
            break;
          case 12:
            return "Renovada";
            break;
          case 13:
            return "Vencida";
            break;
          case 14:
            return "Vigente";
            break;
          case 15:
            return "No renovada";
            break;
          default:
            return "Pendiente";
        }
      };
      function getPolicyPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              $scope.data_pagination = request.data.results;
              for (var i = 0; i < $scope.data_pagination.length; i++) {
                $scope.data_pagination[i].document_type =
                  $scope.data_pagination[i].document_type == 1
                    ? "Póliza"
                    : "Colectividad";
                if ($scope.data_pagination[i].document_type == "Póliza") {
                  $scope.data_pagination[i].document_type =
                    $scope.data_pagination[i].status == 1
                      ? "OT"
                      : $scope.data_pagination[i].status == 2
                      ? "OT"
                      : "Póliza";
                }
                $scope.data_pagination[i].forma_de_pago =
                  $scope.data_pagination[i].forma_de_pago == 1
                    ? "Mensual"
                    : $scope.data_pagination[i].forma_de_pago == 2
                    ? "Bimestral"
                    : $scope.data_pagination[i].forma_de_pago == 3
                    ? "Trimestral"
                    : $scope.data_pagination[i].forma_de_pago == 5
                    ? "Contado"
                    : $scope.data_pagination[i].forma_de_pago == 6
                    ? "Semestral"
                    : "Anual";
                $scope.data_pagination[i].status =
                  $scope.data_pagination[i].status == 1
                    ? "En trámite"
                    : $scope.data_pagination[i].status == 2
                    ? "OT Cancelada"
                    : $scope.data_pagination[i].status == 10
                    ? "Por Iniciar"
                    : $scope.data_pagination[i].status == 11
                    ? "Cancelada"
                    : $scope.data_pagination[i].status == 12
                    ? "Renovada"
                    : $scope.data_pagination[i].status == 13
                    ? "Vencida"
                    : $scope.data_pagination[i].status == 15
                    ? "No renovada"
                    : "Vigente";
                $scope.data_pagination[i].f_currency =
                  $scope.data_pagination[i].f_currency == 1
                    ? "Pesos"
                    : "Dolares";
              }
              $scope.count_pagination = angular.copy($scope.data_pagination);
              if ($scope.data_pagination.length < 10) {
                for (var i = 0; i < 10 - $scope.count_pagination.length; i++) {
                  var object = {
                    poliza_number: " ",
                    document_type: " ",
                    contractor: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    paquete: " ",
                    forma_de_pago: " ",
                    status: " ",
                    start_of_validity: " ",
                    created_at: " ",
                    folio: " ",
                    f_currency: " ",
                    prima_neta: null,
                    rpf: null,
                    derecho: null,
                    iva: null,
                    prima_total: null,
                    comision: null,
                    observations: " ",
                    clave: " ",
                  };
                  $scope.data_pagination.push(object);
                }
              }

              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }

    // -----------------PAGINACIÓN
    jQuery(function ($) {
      $("#exportButton").click(function () {
        // parse the HTML table element having an id=exportTable
        var dataSource = shield.DataSource.create({
          data: "#exportTable",
          schema: {
            type: "table",
            fields: {
              Recibo: { type: String },
              RPF: { type: Number },
              Estatus: { type: String },
            },
          },
        });

        // when parsing is done, export the data to PDF
        dataSource.read().then(function (data) {
          var pdf = new shield.exp.PDFDocument({
            author: "PrepBootstrap",
            created: new Date(),
          });

          pdf.addPage("a4", "portrait");

          pdf.table(
            50,
            50,
            data,
            [
              { field: "Recibo", title: "Número de Recibo", width: 200 },
              { field: "RPF", title: "RPF", width: 50 },
              { field: "Estatus", title: "Estatus del recibo", width: 200 },
            ],
            {
              margins: {
                top: 50,
                left: 50,
              },
            }
          );

          pdf.saveAs({
            fileName: "ReportePolizas",
          });
        });
      });
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReportePolizasController", ReportePolizasController);

  ReportePolizasController.$inject = [
    "appStates",
    "dataFactory",
    "$sessionStorage",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$parse",
    "exportFactory",
    "$uibModal",
    "$localStorage",
  ];

  function ReportePolizasController(
    appStates,
    dataFactory,
    $sessionStorage,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $parse,
    exportFactory,
    $uibModal,
    $localStorage
  ) {
    // jQuery.extend( jQuery.fn.dataTableExt.oSort, {
    //   "non-empty-string-asc": function (str1, str2) {
    //     if(str1 == "")
    //       return 1;
    //     if(str2 == "")
    //       return -1;
    //     return ((str1 < str2) ? -1 : ((str1 > str2) ? 1 : 0));
    //   },

    //   "non-empty-string-desc": function (str1, str2) {
    //     if(str1 == "")
    //       return 1;
    //     if(str2 == "")
    //       return -1;
    //     return ((str1 < str2) ? 1 : ((str1 > str2) ? -1 : 0));
    //   }
    // } );
    // var hCols = [];
    // var paso=0;
    // $scope.$on('ngRepeatFinished', function() {
    //   paso++;
    //   // console.log("hola");
    //   $('#example').DataTable().destroy();

    //   //Only needed for the filename of export files.
    //   //Normally set in the title tag of your page.document.title = 'Simple DataTable';
    //   //Define hidden columns

    //   // DataTable initialisation
    //   $('#example').DataTable({
    //     "dom": "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-12'p<br/>i>>",
    //     "info": false,
    //     "paging": false,
    //     "autoWidth": true,
    //     "columnDefs": [
    //       {
    //         "visible": false,
    //         "targets": hCols
    //       },
    //       {
    //         "type": 'non-empty-string',
    //         "targets": 0
    //       }
    //     ],
    //     "buttons": [{
    //       extend: 'colvis',
    //       collectionLayout: 'three-column',
    //       text: function() {
    //         var totCols = $('#example thead th').length;
    //         var hiddenCols = hCols.length;
    //         var shownCols = totCols - hiddenCols;
    //         return 'Columnas (' + shownCols + ' de ' + totCols + ')';
    //       },
    //       prefixButtons: [{
    //         extend: 'colvisGroup',
    //         text: 'Mostrar todo',
    //         show: ':hidden'
    //       }, {
    //         extend: 'colvisRestore',
    //         text: 'Restaurar'
    //       }]
    //     }]
    //     ,oLanguage: {
    //       oPaginate: {
    //         sNext: '<span class="pagination-default">&#x276f;</span>',
    //         sPrevious: '<span class="pagination-default">&#x276e;</span>'
    //       }
    //     }
    //     ,"initComplete": function(settings, json) {

    //       // Adjust hidden columns counter text in button -->
    //       $('#example').on('column-visibility.dt', function(e, settings, column, state) {

    //         var index = hCols.indexOf(column);
    //         if(state===false){
    //           if (index === -1) { hCols.push(column);}
    //         }
    //         if($('.dt-button-collection.dropdown-menu.three-column').length===1 && state===true){
    //           // console.log($('.dt-button-collection.dropdown-menu.three-column').length);
    //           if (index !== -1) {hCols.splice(index, 1);}
    //          // console.log("si entro");
    //         }
    //         // var visCols = $('#example thead tr:first th').length;

    //         //Below: The minus 2 because of the 2 extra buttons Show all and Restore
    //         var tblCols = $('.dt-button-collection li[aria-controls=example] a').length - 2;
    //         var visCols = tblCols-hCols.length;
    //         $('.buttons-colvis[aria-controls=example] span').html('Columnas (' + visCols + ' de ' + tblCols + ')');
    //         e.stopPropagation();
    //       });
    //     }
    //   });

    // });

    $(".js-example-basic-multiple").select2();

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.orgName = usr.orgname;
    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 7,
        name: "Semanal",
      },
      {
        id: 14,
        name: "Catorcenal",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];
    if ($scope.orgName == "ancora") {
      vm.status = [
        {
          id: 1,
          name: "En trámite",
        },
        {
          id: 2,
          name: "OT Cancelada",
        },
        {
          id: 4,
          name: "Precancelada",
        },
        {
          id: 10,
          name: "Por iniciar",
        },
        {
          id: 11,
          name: "Cancelada",
        },
        {
          id: 12,
          name: "Renovada",
        },
        {
          id: 13,
          name: "Vencida - En Proceso de Renovación",
        },
        {
          id: 14,
          name: "Vigente",
        },
        {
          id: 15,
          name: "No renovada",
        },
      ];
    } else {
      vm.status = [
        {
          id: 1,
          name: "En trámite",
        },
        {
          id: 2,
          name: "OT Cancelada",
        },
        {
          id: 4,
          name: "Precancelada",
        },
        {
          id: 10,
          name: "Por iniciar",
        },
        {
          id: 11,
          name: "Cancelada",
        },
        {
          id: 12,
          name: "Renovada",
        },
        {
          id: 13,
          name: "Vencida",
        },
        {
          id: 14,
          name: "Vigente",
        },
        {
          id: 15,
          name: "No renovada",
        },
      ];
    }
    vm.option_policy = [
      {
        id: 1,
        name: "Fecha de ingreso",
      },
      {
        id: 2,
        name: "Vigencia",
      },
      {
        id: 3,
        name: "Con cobertura",
      },
    ];

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.org_name = usr.urlname;
    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.tableRes = {};
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.changeUntil = changeUntil;
    vm.changePolicy = changePolicy;
    vm.goToInfo = goToInfo;
    vm.formatearNumero = formatearNumero;
    vm.changeGroupBy = changeGroupBy;
    vm.changeCreated = changeCreated;
    vm.matchesClaves = matchesClaves;
    vm.only_caratula_poliza = 0;
    vm.form = {
      provider: 0,
      vendedor: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      created_at: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: 0,
      group: 0,
      recibos_pagados: true,
      recibos_no_pagados: false,
      recibos_liquidados: false,
      recibos_conciliados: false,
      include_por_iniciar: false,
      num_poliza: "",
      cve_agente: "",
      ot_rep: 3,
      identifier: "",
      celula: 0,
      businesLine: 0,
      only_caratula: 0,
    };

    vm.form.subgrouping = 0;
    vm.form.subsubgrouping = 0;
    vm.form.groupinglevel = 0;
    vm.form.subgrouping = 0;
    vm.form.subsubgrouping = 0;
    vm.form.classification = 0;
    vm.form.sucursal = 0;
    vm.form.group_by = 0;
    vm.form.dates_sel = 0;
    vm.form.origin = 0;
    vm.form.valueDolar = 0;
    vm.form.valueUdi = 0;
    vm.word = "";
    $scope.order = 1;
    $scope.asc = 1;
    vm.matchesGroupinglevel = matchesGroupinglevel;
    vm.matchesClassification = matchesClassification;

    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;

    vm.changeSubgrouping = changeSubgrouping;
    vm.changeSubsubgrouping = changeSubsubgrouping;
    $scope.subgroups = [];
    $scope.subsubgroups = [];
    $scope.subgrouping = [];
    $scope.subsubgrouping = [];
    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;

    vm.changeSubgrouping = changeSubgrouping;
    vm.changeSubsubgrouping = changeSubsubgrouping;
    vm.table = {
      headers: [
        "No.Póliza",
        "Tipo",
        "Contratante",
        "Proveedor",
        "Ramo",
        "Subramo",
        "Paquete",
        "Forma de Pago",
        "Estatus",
        "Inicio Póliza",
        "Folio",
        "Moneda",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Observaciones",
        "Creado por",
        "Clave",
        "Asegurado/Serial",
        "Fecha creación",
        "Marca - Modelo - Año",
        "Versión",
        "Placas",
        "Motor",
        "Adaptaciones",
        "Dirección",
        "Fin Póliza",
        "Tipo(por subramo)",
      ],
    };

    vm.group_by = [
      {
        id: 1,
        name: "Aseguradora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 6,
        name: "Estatus",
      },
      {
        id: 7,
        name: "Usuario",
      },
      {
        id: 8,
        name: "Contratante",
      },
    ];

    $scope.origins = [
      {
        id: 1,
        name: "Nuevas",
      },
      {
        id: 2,
        name: "Renovación",
      },
      {
        id: 0,
        name: "Ambos",
      },
    ];
    vm.changeBLine = changeBLine;
    function changeBLine(obj) {
      $scope.bLine = obj;
      if (obj) {
        vm.form.businesLine = obj;
      } else {
        vm.form.businesLine = 0;
      }
    }
    vm.businesLine = [
      {
        id: 1,
        name: "Comercial",
      },
      {
        id: 2,
        name: "Personal",
      },
      {
        id: 3,
        name: "Otro",
      },
    ];
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                vm.permiso_ver_referenciador = true;
              } else {
                vm.permiso_ver_referenciador = false;
              }
            }
          });
        }
      });
    }
    $scope.vigency = false;
    $scope.created_at = false;

    $scope.columnArray = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;

    function changeSubgroup(subg) {
      vm.form.subgroup = subg;
      vm.subgroup = subg;
      $scope.subsubgroups = subg.subsubgrupos ? subg.subsubgrupos : [];
    }
    function changeSubsubgroup(subg) {
      vm.form.subsubgroup = subg;
      vm.subsubgroup = subg;
    }
    // Nivel de agrupación
    function changeSubgrouping(subgl) {
      vm.form.subgrouping = subgl;
      vm.subgrouping = subgl;
      $scope.subsubgrouping = subgl.subsubgrupos ? subgl.subsubgrupos : [];
    }
    function changeSubsubgrouping(subgl) {
      vm.form.subsubgrouping = subgl;
      vm.subsubgrouping = subgl;
    }
    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };

    vm.getCaratulas = getCaratulas;
    function getCaratulas(parId) {
      var results = [];
      var mapeo_caratulas = [];
      if (parId) {
        if (parId.val.length >= 3) {
          $scope.show_cds = "get-all-caratulas/";
          $http({
            method: "POST",
            url: url.IP + $scope.show_cds,
            data: {
              word: parId.val,
            },
          })
            .then(
              function success(request) {
                var results = [];
                var mapeo_caratulas = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    vm.only_caratula_poliza = 0;
                    $scope.autocompleteData = [];
                    vm.word.id = 0;
                    toaster.warning("Carátula no encontrada");
                  } else {
                    request.data.forEach(function (poliza) {
                      vm.policy = poliza;
                      if (poliza.document_type == 11) {
                        mapeo_caratulas.push(poliza);
                      }
                    });
                    results = _.map(mapeo_caratulas, function (item) {
                      if (item.contractor) {
                        var label =
                          item.poliza_number +
                          " - " +
                          item.contractor.full_name +
                          " - " +
                          convertDate(item.start_of_validity) +
                          " - " +
                          convertDate(item.end_of_validity) +
                          " | " +
                          item.statuslabel;
                      } else {
                        var label =
                          item.poliza_number + " | " + item.statuslabel;
                      }
                      return {
                        label: label,
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                      };
                    });
                    $scope.autocompleteData = results;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        } else {
          vm.only_caratula_poliza = 0;
          $scope.autocompleteData = [];
          vm.word.id = 0;
        }
      }
    }
    vm.getCarSelected = getCarSelected;
    function getCarSelected(caratula) {
      vm.only_caratula_poliza = caratula.id;
    }
    $scope.$watch("vm.word", function (newValue, oldValue) {
      if (vm.word) {
        if (vm.word.id) {
          vm.only_caratula_poliza = parseInt(vm.word.id);
        } else {
          vm.only_caratula_poliza = 0;
        }
      }
    });
    vm.sortOrders = {}; // Object to track sorting order per column
    function changePolicy(par, asc) {
      vm.sortOrders[par] = vm.sortOrders[par] === 1 ? 2 : 1;
      vm.sortKey = par;
      asc = vm.sortOrders[par];
      if (par == "No.Póliza") {
        par = 1;
      } else if (par == "Tipo") {
        par = 2;
      } else if (par == "Contratante") {
        par = 3;
      } else if (par == "Proveedor") {
        par = 4;
      } else if (par == "Ramo") {
        par = 5;
      } else if (par == "Subramo") {
        par = 6;
      } else if (par == "Paquete") {
        par = 7;
      } else if (par == "Forma de Pago") {
        par = 8;
      } else if (par == "Estatus") {
        par = 9;
      } else if (par == "Inicio Póliza") {
        par = 10;
      } else if (par == "Folio") {
        par = 11;
      } else if (par == "Moneda") {
        par = 12;
      } else if (par == "Prima Neta") {
        par = 13;
      } else if (par == "RPF") {
        par = 14;
      } else if (par == "Derecho") {
        par = 15;
      } else if (par == "IVA") {
        par = 16;
      } else if (par == "Prima Total") {
        par = 17;
      } else if (par == "Comisión") {
        par = 18;
      } else if (par == "Observaciones") {
        par = 19;
      } else if (par == "Creado por") {
        par = 20;
      } else if (par == "Clave") {
        par = 21;
      } else if (par == "Fecha creación") {
        par = 23;
      } else if (par == "Grupo") {
        par = 24;
      } else {
        par = 1;
      }
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.policy_nump_asc = asc;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = asc;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.policy_aseg_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = asc;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.policy_ramo_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = asc;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.policy_subramo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = asc;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.policy_pack_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = asc;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;

        case 7:
          Generar(par, asc);
          vm.policy_conc_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = asc;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.policy_fpago_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.policy_status_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.policy_vig_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.policy_hasta_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = asc;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 12:
          Generar(par, asc);
          vm.policy_clave_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = asc;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 13:
          Generar(par, asc);
          vm.policy_folio_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = asc;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 14:
          Generar(par, asc);
          vm.policy_moneda_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = asc;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 15:
          Generar(par, asc);
          vm.policy_pneta_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = asc;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 16:
          Generar(par, asc);
          vm.policy_rpf_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = asc;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 17:
          Generar(par, asc);
          vm.policy_der_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = asc;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 18:
          Generar(par, asc);
          vm.policy_iva_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = asc;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 19:
          Generar(par, asc);
          vm.policy_ptotal_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = asc;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 20:
          Generar(par, asc);
          vm.policy_com_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 21:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = asc;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 22:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 23:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_contgroup_asc = asc;
          vm.policy_created_asc = 0;
          break;
        case 24:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_contgroup_asc = asc;
          break;
      }
    }

    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }
    if (vm.acceso_ver_ot) {
      $scope.ot_rep = 3;
      vm.form.ot_rep = 3;
    } else {
      vm.form.ot_rep = 3;
      $scope.ot_rep = 3;
    }
    $scope.valueRadioRep = function (val) {
      if (val == true) {
        if (!vm.acceso_ver_ot) {
          $scope.ot_rep = 3;
          vm.form.ot_rep = 3;
        } else {
          vm.form.ot_rep = true;
          toaster.warning("De clic en Consultar");
        }
      } else {
        vm.form.ot_rep = val;
        toaster.warning("De clic en Consultar");
      }
    };

    $scope.renewals = 0;
    $scope.valueRadioRen = function (val) {
      if (val == 1) {
        vm.form.renewals = 1;
        toaster.warning("De clic en Consultar");
      } else if (val == 2) {
        vm.form.renewals = 1;
        toaster.warning("De clic en Consultar");
      } else {
        vm.form.renewals = 0;
        toaster.warning("De clic en Consultar");
      }
    };

    activate();
    getCelulasContractor();

    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    vm.form.since = convertDate(new Date());
    vm.form.until = convertDate(new Date());
    //var endingDate =  convertDate(new Date());
    //vm.form.until = endingDate;
    // vm.form.businesLine = 0
    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function changeCreated(created) {}

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function activate() {
      $scope.estadosDisabled = false;
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      var params_columns = {};
      var url_send = url.IP + "save-config-fields-reports/";
      params_columns = {
        tipo: 2,
      };
      $scope.filteredKeys = [
        "Tipo",
        "No.Póliza",
        "Contratante",
        "Grupo",
        "Proveedor",
        "Ramo",
        "Subramo",
        "Tipo(por subramo)",
        "Identificador",
        "Paquete",
        "Prima Neta",
        "Descuento",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Comisión Porcentaje",
        "Forma de Pago",
        "Asegurado/Serial",
        "Estatus",
        "Inicio Póliza",
        "Fin Póliza",
        "Referenciador",
        "Folio",
        "Moneda",
        "Fecha creación",
        "Observaciones",
        "Creado por",
        "Clave",
        "Marca",
        "Modelo",
        "Año",
        "Versión",
        "Placas",
        "Motor",
        "Adaptaciones",
        "Dirección",
        "Ejecutivo Cobranza",
        "Responsable",
        "Sucursal",
        "Renovable",
        "OT/Póliza asociada",
        "Origen Póliza",
        "Agrupación",
        "Subagrupación",
        "Subsubagrupación",
        "Clasificación",
        "Línea de Negocio",
        "Célula",
        "Contacto(nombre)",
        "Contacto(telefono)",
        "Contacto(email)",
        "Carátula",
        "Póliza Siguiente",
        "Fecha Cancelación",
        "Adjuntos",
        "Colectividad/PG completa",
        "Estado Circulación",
        "Tipo Administración",
        "No.Interno",
        "Serie",
        "Póliza Anterior",
        "Conducto de Pago",
        "Bitacora",
        "Email",
        "Contributoria",
        "RFC de Cliente",
        "Seguimiento",
      ];
      $http
        .get(url_send, { params: params_columns })
        .then(function (response) {
          if (response.data && response.data.data) {
            // $scope.filteredKeys = [];
            // $scope.filteredKeys = Object.keys(response.data.data).filter(function(key) {
            //   return response.data.data[key] === true;
            // });
            $scope.filteredKeys = $scope.filteredKeys.filter(function (key) {
              return response.data.data[key] === true;
            });
          } else {
            $scope.filteredKeys = [
              "Tipo",
              "No.Póliza",
              "Contratante",
              "Grupo",
              "Proveedor",
              "Ramo",
              "Subramo",
              "Tipo(por subramo)",
              "Identificador",
              "Paquete",
              "Prima Neta",
              "Descuento",
              "RPF",
              "Derecho",
              "IVA",
              "Prima Total",
              "Comisión",
              "Comisión Porcentaje",
              "Forma de Pago",
              "Asegurado/Serial",
              "Estatus",
              "Inicio Póliza",
              "Fin Póliza",
              "Referenciador",
              "Folio",
              "Moneda",
              "Fecha creación",
              "Observaciones",
              "Creado por",
              "Clave",
              "Marca",
              "Modelo",
              "Año",
              "Versión",
              "Placas",
              "Motor",
              "Adaptaciones",
              "Dirección",
              "Ejecutivo Cobranza",
              "Responsable",
              "Sucursal",
              "Renovable",
              "OT/Póliza asociada",
              "Origen Póliza",
              "Agrupación",
              "Subagrupación",
              "Subsubagrupación",
              "Clasificación",
              "Línea de Negocio",
              "Célula",
              "Contacto(nombre)",
              "Contacto(telefono)",
              "Contacto(email)",
              "Carátula",
              "Póliza Siguiente",
              "Fecha Cancelación",
              "Adjuntos",
              "Colectividad/PG completa",
              "Estado Circulación",
              "Tipo Administración",
              "No.Interno",
              "Serie",
              "Póliza Anterior",
              "Conducto de Pago",
              "Bitacora",
              "Email",
              "Contributoria",
              "RFC de Cliente",
              "Seguimiento",
            ];
          }
        })
        .catch(function (error) {
          console.error("Error loading settings", error);
        });
      getProviders();
      getUsuarios();
      getSubramos();
      getReferenciador();
      getSucursales();
      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.sub_total = 0;
      $scope.comision = 0;
      if (!vm.acceso_ver_ot) {
        vm.form.ot_rep = 3;
        vm.ot_rep = 3;
      }
      /* Información de usuario */
      $scope.infoUser = $sessionStorage.infoUser;

      if (vm.form.dates_sel) {
        $scope.vigency = true;
        if (vm.form.dates_sel.id && vm.form.dates_sel.id == 3) {
          $scope.vigency = false;
          $scope.created_at = false;
          $scope.estadosDisabled = true;
          // limpiar selección
          $scope.select_status = [];
          // opcional: notificar al handler
          // // si usas Select2, fuerza el refresh:
          angular.element("#estadoMultiple").val("").trigger("change.select2");
        }
      }
    }
    function getSucursales() {
      $http.get(url.IP + "sucursales-to-show-unpag").then(function (data) {
        $scope.sucursales = data;
      });
    }
    function changeGroupBy() {
      $scope.grupos_result = [];
      $scope.showSums = false;
      vm.show_pag_cobranza = false;
    }
    // $scope.$watch('estadosDisabled', function(disabled) {
    //   if (disabled) {
    //     // limpiar selección
    //     $scope.select_status = [];
    //     // opcional: notificar al handler
    //     $scope.selectEstatus($scope.select_status);
    //     // // si usas Select2, fuerza el refresh:
    //     angular.element('#estadoMultiple')
    //       .val('')
    //       .trigger('change.select2');
    //   }
    // });
    $scope.changeReport = function (valor_por_iniciar) {
      vm.form.include_por_iniciar = valor_por_iniciar
        ? valor_por_iniciar
        : false;
      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id == 1) {
          $scope.created_at = true;
          $scope.vigency = false;
          $scope.estadosDisabled = false;
        } else if (vm.form.dates_sel.id == 2) {
          $scope.vigency = true;
          $scope.created_at = false;
          $scope.estadosDisabled = false;
        } else if (vm.form.dates_sel.id == 3) {
          $scope.vigency = false;
          $scope.created_at = false;
          $scope.estadosDisabled = true;
          $scope.select_status = [];
          vm.status_selected = [];
          // limpiar selección
          $scope.select_status = [];
          // opcional: notificar al handler
          // // si usas Select2, fuerza el refresh:
          angular.element("#estadoMultiple").val("").trigger("change.select2");
        }
      } else {
        $scope.vigency = false;
        $scope.created_at = false;
        $scope.estadosDisabled = false;
      }
    };

    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }
    function getReferenciador() {
      vm.vendedores = [];
      $http.get(url.IP + "get-vendors").then(function (user) {
        user.data.forEach(function (u) {
          var obj = {
            name: u.first_name + " " + u.last_name,
            id: u.id,
          };
          vm.vendedores.push(obj);
        });
      });
    }

    $scope.reporte = false;
    $scope.showButtonExcel = false;
    $scope.numberFormatUdi = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueUdi = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      } else {
      }
    };
    $scope.numberFormatDolar = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueDolar = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      } else {
      }
    };
    function Generar(order, asc, parPage) {
      $scope.insurances = [];
      $scope.sumas = {};
      if (vm.acceso_ver_ot || vm.acceso_ver_pol) {
        var l = Ladda.create(document.querySelector(".ladda-buttonC"));
        l.start();

        $scope.order = order;
        $scope.asc = asc;
        if (
          vm.form.dates_sel == undefined ||
          vm.form.dates_sel == null ||
          !vm.form.dates_sel
        ) {
          l.stop();
          SweetAlert.swal(
            "Información",
            "Es necesario seleccionar una opción de Reporte por",
            "error"
          );

          return;
        }
        var since = toDate(vm.form.since).getTime();
        var until = toDate(vm.form.until).getTime();
        var diff = until - since;
        var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
        if (antiguedad < 0) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        }
        $scope.reporte = true;
        $scope.insurances = [];
        $scope.total = 0;
        $scope.prima_neta = 0;
        $scope.comision = 0;
        if (vm.form.subgroup) {
          if (vm.form.subgroup.id) {
            var g1 = vm.form.subgroup.id;
          } else {
            var g1 = 0;
          }
        }
        if (vm.form.subsubgroup) {
          if (vm.form.subsubgroup.id) {
            var g2 = vm.form.subsubgroup.id;
          } else {
            var g2 = 0;
          }
        } else {
          var g2 = 0;
        }
        if (vm.form.groupinglevel) {
          if (vm.form.groupinglevel.val) {
            var gl = vm.form.groupinglevel.value;
          } else {
            var gl = 0;
          }
        } else {
          var gl = 0;
        }
        if (vm.form.subgrouping) {
          if (vm.form.subgrouping.id) {
            var gl1 = vm.form.subgrouping.id;
          } else {
            var gl1 = 0;
          }
        } else {
          var gl1 = 0;
        }
        if (vm.form.subsubgrouping) {
          if (vm.form.subsubgrouping.id) {
            var gl2 = vm.form.subsubgrouping.id;
          } else {
            var gl2 = 0;
          }
        } else {
          var gl2 = 0;
        }
        if (vm.form.celula) {
          if (vm.form.celula.id) {
            var cel = vm.form.celula.id;
          } else {
            var cel = 0;
          }
        } else {
          var cel = 0;
        }
        var params = {
          provider: vm.form.provider.id
            ? vm.form.provider.id
            : vm.form.provider,
          ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
          subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
          since: vm.form.since ? vm.form.since : vm.form.si,
          until: vm.form.until ? vm.form.until : vm.form.un,
          payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
          // status: vm.form.status.id ? vm.form.status.id : vm.form.status,
          status: vm.status_selected ? vm.status_selected : [],
          contratante: vm.form.contratante.value
            ? vm.form.contratante.value
            : 0,
          grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
          type_contractor: vm.form.contratante.type
            ? vm.form.contratante.type
            : 0,
          poliza: vm.form.num_poliza ? vm.form.num_poliza : 0,
          identifier: vm.form.identifier ? vm.form.identifier : 0,
          cve: vm.form.cve_agente.value ? vm.form.cve_agente.value : 0,
          ot: vm.form.ot_rep,
          order: order,
          asc: asc,
          page: parPage ? parPage : 1,
          group_by: vm.form.group_by ? vm.form.group_by.id : 0,
          origin: vm.form.origin ? vm.form.origin.id : 0,
          ramos: vm.ramos_selected ? vm.ramos_selected : 0,
          subramos: vm.subramos_selected ? vm.subramos_selected : 0,
          providers: vm.providers_selected ? vm.providers_selected : 0,
          claves: vm.claves_selected ? vm.claves_selected : 0,
          users: vm.usuarios_selected ? vm.usuarios_selected : 0,
          report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 0,
          sucursal: vm.form.sucursal ? vm.form.sucursal.id : 0,
          renewals: $scope.renewals ? $scope.renewals : 0,
          valDolar: vm.form.valueDolar
            ? parseFloat(vm.form.valueDolar).toFixed(2)
            : 0,
          valUdi: vm.form.valueUdi
            ? parseFloat(vm.form.valueUdi).toFixed(2)
            : 0,
          vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
          classification: vm.form.classification.value
            ? vm.form.classification.value
            : vm.form.classification,
          subgrupo: g1 ? g1 : 0,
          subsubgrupo: g2 ? g2 : 0,
          groupinglevel: gl ? gl : 0,
          subgrupinglevel: gl1 ? gl1 : 0,
          subsubgrupinglevel: gl2 ? gl2 : 0,
          businessLine: $scope.bLine ? $scope.bLine.id : 0,
          celula: cel ? cel : 0,
          only_caratula: vm.only_caratula_poliza ? vm.only_caratula_poliza : 0,
        };
        if (vm.form.contratante) {
          if (vm.form.contratante.val == "") {
            params.contratante = 0;
            vm.form.contratante.value = "";
            vm.form.contratante.type = "";
          }
        }
        if (vm.form.group) {
          if (vm.form.group.val == "") {
            params.grupo = 0;
            vm.form.group.value = "";
            vm.form.group.type = "";
          }
        }
        params.since = params.since + " " + "00:00:00";
        params.until = params.until + " " + "23:59:59";
        params.include_por_iniciar = vm.form.include_por_iniciar
          ? vm.form.include_por_iniciar
          : false;
        $scope.filtros = params;
        $scope.url_go = "reporte-poliza-rep/";
        // $scope.url_go_excel = 'reporte-polizas-excel';
        $scope.url_go_excel = "service_reporte-polizasReport-excel";
        $http({
          method: "POST",
          url: url.IP + $scope.url_go, //'reporte-poliza-rep/',
          data: params,
        }).then(function success(response) {
          if (response.status == 200 || response.status == 201) {
            $("#example").DataTable().clear();
            if (params.group_by == 0) {
              $scope.insurances = response.data.results;
              $scope.sumas = response.data.sumas;
              l.stop();

              for (var i = 0; i < $scope.insurances.length; i++) {
                if ($scope.insurances[i].old_policies > 0) {
                  if (
                    $scope.insurances[i].old_policies[0].base_policy.id ==
                    $scope.insurances[i].id
                  ) {
                    $scope.insurances[i].asociada = $scope.insurances[i]
                      .old_policies[0].new_policy.poliza_number
                      ? $scope.insurances[i].old_policies[0].new_policy
                          .poliza_number
                      : $scope.insurances[i].old_policies[0].new_policy
                          .internal_number;
                  }
                }
                if ($scope.insurances[i].document_type == 1) {
                  $scope.insurances[i].document_type == "Póliza";
                } else if ($scope.insurances[i].document_type == 3) {
                  $scope.insurances[i].document_type == "Colectividad";
                } else if ($scope.insurances[i].document_type == 11) {
                  $scope.insurances[i].document_type == "Carátula";
                } else if ($scope.insurances[i].document_type == 12) {
                  $scope.insurances[i].document_type == "Póliza de Carátula";
                }
                // $scope.insurances[i].document_type = $scope.insurances[i].document_type == 1 ? "Póliza" : "Colectividad";
                if ($scope.insurances[i].document_type == "Póliza") {
                  $scope.insurances[i].document_type =
                    $scope.insurances[i].status == 1
                      ? "OT"
                      : $scope.insurances[i].status == 2
                      ? "OT"
                      : "Póliza";
                }
                $scope.insurances[i].forma_de_pago =
                  $scope.insurances[i].forma_de_pago == 1
                    ? "Mensual"
                    : $scope.insurances[i].forma_de_pago == 2
                    ? "Bimestral"
                    : $scope.insurances[i].forma_de_pago == 3
                    ? "Trimestral"
                    : $scope.insurances[i].forma_de_pago == 5
                    ? "Contado"
                    : $scope.insurances[i].forma_de_pago == 6
                    ? "Semestral"
                    : $scope.insurances[i].forma_de_pago == 7
                    ? "Semanal"
                    : $scope.insurances[i].forma_de_pago == 14
                    ? "Catorcenal"
                    : "Anual";
                // $scope.insurances[i].status = $scope.insurances[i].status == 1 ? "En trámite" :
                //   $scope.insurances[i].status == 2 ? "OT Cancelada" : $scope.insurances[i].status == 10 ? "Por Iniciar" :
                //   $scope.insurances[i].status == 11 ? "Cancelada" : $scope.insurances[i].status == 12 ? "Renovada" :
                //   $scope.insurances[i].status == 13 ? "Vencida" : $scope.insurances[i].status == 15 ? "No renovada" : "Vigente";
                $scope.insurances[i].f_currency =
                  $scope.insurances[i].f_currency == 1 ? "Pesos" : "Dolares";
              }

              $scope.count_insurances = angular.copy($scope.insurances);
              if (
                $scope.insurances &&
                $scope.insurances.length != 0 &&
                $scope.insurances.length < 10
              ) {
                for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
                  var object = {
                    contratante: " ",
                    poliza_number: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    paquete: " ",
                    prima_neta: null,
                    rpf: null,
                    derecho: null,
                    iva: null,
                    prima_total: null,
                    comision: null,
                    forma_de_pago: " ",
                    document_type: " ",
                    status: " ",
                    start_of_validity: " ",
                    folio: " ",
                    f_currency: " ",
                    observations: " ",
                    created_at: " ",
                    clave: " ",
                  };
                  $scope.insurances.push(object);
                }
              }

              $scope.policy_config = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };
              vm.show_pag_policy = true;
              $scope.obtenerPaginacion(response.data, parPage ? parPage : 1);
              // testPagination('insurances', 'policy_config');

              if ($scope.insurances[0].poliza_number == " ") {
                toaster.warning("No se encontraron registros");
              } else {
                $scope.showButtonExcel = true;
                $scope.showSums = true;
              }
            } else {
              l.stop();
              $scope.grupos_result = response.data;
              $scope.showButtonExcel = true;
              $scope.showSums = false;
            }
            $scope.insurances.forEach(function (line) {
              if (line.url) {
                $http({
                  method: "GET",
                  url: url.IP + "historic-policies/",
                  params: {
                    actual_id: line.id,
                  },
                }).then(function success(response) {
                  if (response.data.results.length > 0) {
                    response.data.results.forEach(function (item) {
                      if (line.id == item.new_policy.id) {
                        line.origin = "Renovación";
                      } else {
                        line.origin = "Nueva";
                      }
                    });
                  } else {
                    line.origin = "Nueva";
                  }
                });
              }
            });
          } else {
            l.stop();
            toaster.warning("Error en la llamada registros");
          }
        });
      } else {
        SweetAlert("Error", "No tiene acceso a ver OTs ni Pólizas", "error");
      }
    }
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      vm.Generar($scope.order || 1, $scope.asc || 1, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        vm.Generar(
          $scope.order || 1,
          $scope.asc || 1,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        vm.Generar(
          $scope.order || 1,
          $scope.asc || 1,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };

    $scope.open_in_same_tab_natural = function (
      name,
      route,
      params,
      identifier
    ) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $state.go($scope.route_for_new_tab, params);
    };

    function goToInfo(insurance) {
      if (vm.acceso_ver_pol) {
        if (insurance.document_type == "Póliza") {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "polizas.info",
            { polizaId: insurance.id },
            insurance.id
          );
          $state.go("polizas.info", { polizaId: insurance.id });
        } else if (insurance.document_type == "Colectividad") {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "colectividades.info",
            { polizaId: insurance.id },
            insurance.id
          );
          // $state.go('colectividades.info', {polizaId: insurance.id})
        } else if (insurance.document_type == "Póliza de Carátula") {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "flotillas.info",
            { polizaId: insurance.parent.id },
            insurance.parent.id
          );
          // $state.go('flotillas.info', {polizaId: insurance.parent.id})
        } else if (insurance.document_type == "Carátula") {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "flotillas.info",
            { polizaId: insurance.id },
            insurance.id
          );
          // $state.go('flotillas.info', {polizaId: insurance.id})
        } else if (insurance.document_type == 1) {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "polizas.info",
            { polizaId: insurance.id },
            insurance.id
          );
          // $state.go('polizas.info', {polizaId: insurance.id})
        } else if (insurance.document_type == 3) {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "colectividades.info",
            { polizaId: insurance.id },
            insurance.id
          );
          // $state.go('colectividades.info', {polizaId: insurance.id})
        } else if (insurance.document_type == 12) {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "flotillas.info",
            { polizaId: insurance.parent.id },
            insurance.parent.id
          );
          // $state.go('flotillas.info', {polizaId: insurance.parent.id})
        } else if (insurance.document_type == 11) {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "flotillas.info",
            { polizaId: insurance.id },
            insurance.id
          );
          // $state.go('flotillas.info', {polizaId: insurance.id})
        }
      }
    }

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        vm.providers = data.data;
      });
    }

    $scope.exportDataExcel = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            // templateUrl: 'app/reportes/reportexcel.option.html',
            // controller: 'ReportExcelByCtrl',
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "md",
            resolve: {
              filters: function () {
                return $scope.filtros;
              },
              from: function () {
                return null;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.filtros.orden = $scope.columnArray;
        $scope.filtros.excel_type = 2;
        var $listM = $("#example th")
          .map(function () {
            return $.trim($(this).text());
          })
          .get();
        if (vm.permiso_comisiones) {
          if ($listM.includes("Comisión")) {
            $listM.push("Comisión");
          }
          if ($listM.includes("Comisión Porcentaje")) {
            $listM.push("Comisión Porcentaje");
          }
        }
        if ($listM.includes("Tipo")) {
          $listM.push("Tipo");
        }
        if ($listM.includes("No.Póliza")) {
          $listM.push("No.Póliza");
        }
        if ($listM.includes("No.Interno")) {
          $listM.push("No.Interno");
        }
        if ($listM.includes("Contratante")) {
          $listM.push("Contratante");
        }
        if ($listM.includes("Email")) {
          $listM.push("Email");
        }
        if ($listM.includes("Grupo")) {
          $listM.push("Grupo");
        }
        if ($listM.includes("Proveedor")) {
          $listM.push("Proveedor");
        }
        if ($listM.includes("Ramo")) {
          $listM.push("Ramo");
        }
        if ($listM.includes("Subramo")) {
          $listM.push("Subramo");
        }
        $listM.push("Tipo(por subramo)");
        if ($listM.includes("Tipo(por subramo)")) {
          $listM.push("Tipo(por subramo)");
        }
        if ($listM.includes("Identificador")) {
          $listM.push("Identificador");
        }
        if ($listM.includes("Paquete")) {
          $listM.push("Paquete");
        }
        if ($listM.includes("Prima Neta")) {
          $listM.push("Prima Neta");
        }
        if ($listM.includes("Descuento")) {
          $listM.push("Descuento");
        }
        if ($listM.includes("RPF")) {
          $listM.push("RPF");
        }
        if ($listM.includes("Derecho")) {
          $listM.push("Derecho");
        }
        if ($listM.includes("IVA")) {
          $listM.push("IVA");
        }
        if ($listM.includes("Prima Total")) {
          $listM.push("Prima Total");
        }
        if ($listM.includes("Forma de Pago")) {
          $listM.push("Forma de Pago");
        }
        if ($listM.includes("Asegurado/Serial")) {
          $listM.push("Asegurado");
        }
        if ($listM.includes("Estatus")) {
          $listM.push("Estatus");
        }
        if ($listM.includes("Inicio Póliza")) {
          $listM.push("Inicio Póliza");
        }
        if ($listM.includes("Fin Póliza")) {
          $listM.push("Fin Póliza");
        }
        if ($listM.includes("Referenciador")) {
          $listM.push("Referenciador");
        }
        if ($listM.includes("Folio")) {
          $listM.push("Folio");
        }
        if ($listM.includes("Moneda")) {
          $listM.push("Moneda");
        }
        if ($listM.includes("Fecha creación")) {
          $listM.push("Fecha creación");
        }
        if ($listM.includes("Observaciones")) {
          $listM.push("Observaciones");
        }
        if ($listM.includes("Creado por")) {
          $listM.push("Creado por");
        }
        if ($listM.includes("Clave")) {
          $listM.push("Clave");
        }
        if ($listM.includes("Marca - Modelo - Año")) {
          $listM.push("Marca");
          $listM.push("Modelo");
          $listM.push("Año");
        }
        if ($listM.includes("Versión")) {
          $listM.push("Versión");
        }
        if ($listM.includes("Placas")) {
          $listM.push("Placas");
        }
        if ($listM.includes("Serie")) {
          $listM.push("Serie");
        }
        if ($listM.includes("Motor")) {
          $listM.push("Motor");
        }
        if ($listM.includes("Adaptaciones")) {
          $listM.push("Adaptaciones");
        }
        if ($listM.includes("Dirección")) {
          $listM.push("Dirección");
        }
        if ($listM.includes("Ejecutivo Cobranza")) {
          $listM.push("Ejecutivo Cobranza");
        }
        if ($listM.includes("Responsable")) {
          $listM.push("Responsable");
        }
        if ($listM.includes("Sucursal")) {
          $listM.push("Sucursal");
        }
        if ($listM.includes("Conducto de Pago")) {
          $listM.push("Conducto de Pago");
        }
        if ($listM.includes("Renovable")) {
          $listM.push("Renovable");
        }
        if ($listM.includes("OT/Póliza asociada")) {
          $listM.push("OT/Póliza asociada");
        }
        if ($listM.includes("Origen Póliza")) {
          $listM.push("Origen Póliza");
        }
        if ($listM.includes("Agrupación")) {
          $listM.push("Agrupación");
        }
        if ($listM.includes("Subagrupación")) {
          $listM.push("Subagrupación");
        }
        if ($listM.includes("Subsubagrupación")) {
          $listM.push("Subsubagrupación");
        }
        if ($listM.includes("Clasificación")) {
          $listM.push("Clasificación");
        }
        if ($listM.includes("Línea de Negocio")) {
          $listM.push("Línea de Negocio");
        }
        if ($listM.includes("Célula")) {
          $listM.push("Célula");
        }
        if ($listM.includes("Contacto(nombre)")) {
          $listM.push("Contacto(nombre)");
        }
        if ($listM.includes("Contacto(telefono)")) {
          $listM.push("Contacto(telefono)");
        }
        if ($listM.includes("Contacto(email)")) {
          $listM.push("Contacto(email)");
        }
        if ($listM.includes("Carátula")) {
          $listM.push("Carátula");
        }
        if ($listM.includes("Carátula")) {
          $listM.push("Carátula");
        }
        if ($listM.includes("Póliza Anterior")) {
          $listM.push("Póliza Anterior");
        }
        if ($listM.includes("Póliza Siguiente")) {
          $listM.push("Póliza Siguiente");
        }
        if ($listM.includes("Fecha Cancelación")) {
          $listM.push("Fecha Cancelación");
        }
        if ($listM.includes("Adjuntos")) {
          $listM.push("Adjuntos");
        }
        if ($listM.includes("Bitacora")) {
          $listM.push("Bitacora");
        }
        if ($listM.includes("Colectividad/PG completa")) {
          $listM.push("Colectividad/PG completa");
        }
        if ($listM.includes("Estado Circulación")) {
          $listM.push("Estado Circulación");
        }
        if ($listM.includes("Tipo Administración")) {
          $listM.push("Tipo Administración");
        }
        var scolumns = [
          "Tipo",
          "No.Póliza",
          "Contratante",
          "Grupo",
          "Proveedor",
          "Ramo",
          "Subramo",
          "Tipo(por subramo)",
          "Identificador",
          "Paquete",
          "Prima Neta",
          "Descuento",
          "RPF",
          "Derecho",
          "IVA",
          "Prima Total",
          "Comisión",
          "Comisión Porcentaje",
          "Forma de Pago",
          "Asegurado/Serial",
          "Estatus",
          "Inicio Póliza",
          "Fin Póliza",
          "Referenciador",
          "Folio",
          "Moneda",
          "Fecha creación",
          "Observaciones",
          "Creado por",
          "Clave",
          "Marca",
          "Modelo",
          "Año",
          "Versión",
          "Placas",
          "Motor",
          "Adaptaciones",
          "Dirección",
          "Ejecutivo Cobranza",
          "Responsable",
          "Sucursal",
          "Renovable",
          "OT/Póliza asociada",
          "Origen Póliza",
          "Agrupación",
          "Subagrupación",
          "Subsubagrupación",
          "Clasificación",
          "Línea de Negocio",
          "Célula",
          "Contacto(nombre)",
          "Contacto(telefono)",
          "Contacto(email)",
          "Carátula",
          "Póliza Siguiente",
          "Fecha Cancelación",
          "Adjuntos",
          "Colectividad/PG completa",
          "Estado Circulación",
          "Tipo Administración",
          "No.Interno",
          "Serie",
          "Póliza Anterior",
          "Conducto de Pago",
          "Colectividad/PG completa",
          "Bitacora",
        ];
        var foo = [];

        $.grep(scolumns, function (el) {
          if ($.inArray(el, $listM) != -1) {
            foo.push(el);
          }
        });

        $scope.filtros["ot_rep"] = $scope.ot_rep;
        // console.log('ot_rep',$scope.ot_rep);
        // $scope.filtros['cols1']=foo;
        $scope.filtros["cols1"] = $scope.filteredKeys;
        $scope.filtros["include_por_iniciar"] = vm.form.include_por_iniciar
          ? vm.form.include_por_iniciar
          : false;
        if (param == 1) {
          $http({
            method: "POST",
            url: url.IP + $scope.url_go_excel, //'reporte-polizas-excel',
            data: $scope.filtros,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (data) {
              if (data.status == 200) {
                l.stop();
                // Conexión a socket.io
                // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // if($scope.org_name =='ancora'){
                //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                // }else{
                var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // }
                socket.emit("subscribe", data.data);
                // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                socket.on(data.data, function (url) {
                  // vm.main.notifications['count']  +=1;
                  var notificacion = {
                    title: "El reporte solicitado ha sido generado",
                    description: url,
                    model: 26,
                    id_reference: 0,
                  };
                  // dataFactory.post('notificaciones/', notificacion)
                  // .then(function success(response) {
                  SweetAlert.swal({
                    title: "El reporte está listo para descargar",
                    icon: "success",
                    text: "Encuentra la liga de descarga en la sección de notificaciones",
                    timer: 5000,
                  });
                  socket.disconnect();
                  // }).catch(function(err) {
                  socket.disconnect();
                  // })
                });
                toaster.info(
                  "Generando...",
                  "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                );
                //     var blob = new Blob([data.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                //     saveAs(blob, 'Reporte_Pólizas.xls');
              } else {
                l.stop();
              }
              // else if(data.status== 202) {
              //   SweetAlert.swal("Espera", "El reporte será enviado a su correo", "success")
              //   l.stop()
              // }

              // else if(data.status== 503) {
              //   SweetAlert.swal("Error", "Error de conexión", "error")
              //   l.stop()
              // }

              //   else {
              //     SweetAlert.swal("Error", "Ha ocurrido un error al descargar el reporte", "error")
              //     l.stop()
              //   }
            })
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };
    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      vm.form.subgroup = 0;
      vm.form.subsubgroup = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        if (vm.form.group.val) {
          var word_data = vm.form.group.val;
        }
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  // var obj = {
                  //   label: item.group_name,
                  //   value: item.id
                  // };
                  // $scope.subgroups = item.subgrupos;
                  // $scope.subsubgroups = [];
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    $scope.$watch("vm.form.group.value", function (newValue, oldValue) {
      if (vm.form.group) {
        if (vm.form.group.value) {
          $http
            .get(url.IP + "grupos/" + vm.form.group.value)
            .then(function (item) {
              vm.form.group.data = item.data;

              $scope.subgroups = item.data.subgrupos;
              $scope.subgroups.forEach(function (itm) {
                $scope.subsubgroups = itm.subsubgrupos;
              });
            });
        }
      }
    });

    function matchesGroupinglevel(parWord, parType) {
      $scope.subgrouping = [];
      $scope.subsubgrouping = [];
      $scope.groupunglevels_data = 0;
      vm.form.subgrouping = 0;
      vm.form.subsubgrouping = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.groupinglevel.val) {
        var word_data = vm.form.groupinglevel.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_grouping = "groupinglevel-match/";

          $http
            .post(url.IP + $scope.show_grouping, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groupinglevels = response.data ? response.data : [];
                groupinglevels.forEach(function (item) {
                  $scope.subsubgrouping = [];
                  $scope.subgrouping.forEach(function (itm) {
                    $scope.subsubgrouping = itm.subsubgrupos;
                  });
                  var obj = {
                    label: item.description,
                    value: item.id,
                    url: item.url,
                    subgrupos: item.subgrupos,
                  };
                  source.push(obj);
                });

                $scope.groupinglevels_data = source;
              }
            });
        }
      }
    }
    // --GroupingLevel
    // classification
    function matchesClassification(parWord, parType) {
      $scope.classification_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.classification.val) {
        var word_data = vm.form.classification.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_claass = "classification-match/";

          $http
            .post(url.IP + $scope.show_claass, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var classifica = response.data;
                classifica.forEach(function (item) {
                  var obj = {
                    label: item.classification_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.classification_data = source;
              }
            });
        }
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    function matchesClaves(parWord, parType) {
      $scope.claves_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.cve_agente.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          var url_filter = "claves-match/";
          $http
            .post(url.IP + url_filter, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                console.log("Rsponse: matchesClaves");
                console.log(response.data);

                var source = [];
                var clavs = response.data;

                if (clavs.length) {
                  clavs.forEach(function (item) {
                    var obj = {
                      label: item.clave + " - " + item.name,
                      value: item.clave,
                      //type: 'juridical'
                    };
                    source.push(obj);
                  });
                }

                $scope.claves_data = source;
              }
            });
        }
      } else {
      }
    }

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            vm.ramos = response.data;
          });
      }
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };
    vm.status_selected = [];
    $scope.selectEstatus = function (sel) {
      vm.status_selected = [];
      sel.forEach(function (cl) {
        vm.status_selected.push(cl);
      });
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }
    // -----------PAGINACIÓN

    $scope.actual_page = 1;

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
      $scope.status = function (parValue) {
        switch (parValue) {
          case 1:
            return "En trámite";
            break;
          case 2:
            return "OT Cancelada";
            break;
          case 4:
            return "Precancelada";
            break;
          case 10:
            return "Por iniciar";
            break;
          case 11:
            return "Cancelada";
            break;
          case 12:
            return "Renovada";
            break;
          case 13:
            return "Vencida";
            break;
          case 14:
            return "Vigente";
            break;
          case 15:
            return "No renovada";
            break;
          default:
            return "Pendiente";
        }
      };
      function getPolicyPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              $scope.data_pagination = request.data.results;
              for (var i = 0; i < $scope.data_pagination.length; i++) {
                if ($scope.insurances[i].document_type == 1) {
                  $scope.insurances[i].document_type == "Póliza";
                } else if ($scope.insurances[i].document_type == 3) {
                  $scope.insurances[i].document_type == "Colectividad";
                } else if ($scope.insurances[i].document_type == 11) {
                  $scope.insurances[i].document_type == "Carátula";
                } else if ($scope.insurances[i].document_type == 12) {
                  $scope.insurances[i].document_type == "Póliza de Carátula";
                }
                // $scope.data_pagination[i].document_type = $scope.data_pagination[i].document_type == 1 ? "Póliza" : "Colectividad";
                if ($scope.data_pagination[i].document_type == "Póliza") {
                  $scope.data_pagination[i].document_type =
                    $scope.data_pagination[i].status == 1
                      ? "OT"
                      : $scope.data_pagination[i].status == 2
                      ? "OT"
                      : "Póliza";
                }
                $scope.data_pagination[i].forma_de_pago =
                  $scope.data_pagination[i].forma_de_pago == 1
                    ? "Mensual"
                    : $scope.data_pagination[i].forma_de_pago == 2
                    ? "Bimestral"
                    : $scope.data_pagination[i].forma_de_pago == 3
                    ? "Trimestral"
                    : $scope.data_pagination[i].forma_de_pago == 5
                    ? "Contado"
                    : $scope.data_pagination[i].forma_de_pago == 6
                    ? "Semestral"
                    : "Anual";
                $scope.data_pagination[i].status =
                  $scope.data_pagination[i].status == 1
                    ? "En trámite"
                    : $scope.data_pagination[i].status == 2
                    ? "OT Cancelada"
                    : $scope.data_pagination[i].status == 10
                    ? "Por Iniciar"
                    : $scope.data_pagination[i].status == 11
                    ? "Cancelada"
                    : $scope.data_pagination[i].status == 12
                    ? "Renovada"
                    : $scope.data_pagination[i].status == 13
                    ? "Vencida"
                    : $scope.data_pagination[i].status == 15
                    ? "No renovada"
                    : "Vigente";
                $scope.data_pagination[i].f_currency =
                  $scope.data_pagination[i].f_currency == 1
                    ? "Pesos"
                    : "Dolares";
              }
              $scope.count_pagination = angular.copy($scope.data_pagination);
              if ($scope.data_pagination.length < 10) {
                for (var i = 0; i < 10 - $scope.count_pagination.length; i++) {
                  var object = {
                    poliza_number: " ",
                    document_type: " ",
                    natural: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    paquete: " ",
                    forma_de_pago: " ",
                    status: " ",
                    start_of_validity: " ",
                    created_at: " ",
                    folio: " ",
                    f_currency: " ",
                    prima_neta: null,
                    rpf: null,
                    derecho: null,
                    iva: null,
                    prima_total: null,
                    comision: null,
                    observations: " ",
                    clave: " ",
                  };
                  $scope.data_pagination.push(object);
                }
              }

              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }

    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      $scope.infoUser = $sessionStorage.infoUser;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = 1;
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        var param = 1;
        filters.include_por_iniciar = vm.form.include_por_iniciar
          ? vm.form.include_por_iniciar
          : false;
        if (option) {
          // Totales de la Agrupación
          var filter_policy = "service_reporte-polizasReport-excel";
          if (option == 1) {
            filters["excel_type"] = 1;
            var $listM = $("#example th")
              .map(function () {
                return $.trim($(this).text());
              })
              .get();
            filters["cols2"] = $listM;
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            $scope.url_go_excel = "service_reporte-polizasReport-excel";
            filters.export_type = option;
            $http({
              method: "POST",
              url: url.IP + filter_policy,
              data: filters,
            })
              .then(function success(response) {
                if (response.status == 200) {
                  l.stop();
                  // Conexión a socket.io
                  // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // if($scope.org_name =='ancora'){
                  //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                  // }else{
                  var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // }
                  socket.emit("subscribe", response.data);
                  // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                  // socket.on('result', function(url){
                  socket.on(response.data, function (url) {
                    var notificacion = {
                      title: "El reporte solicitado ha sido generado",
                      description: url,
                      model: 26,
                      id_reference: 0,
                    };
                    dataFactory
                      .post("notificaciones/", notificacion)
                      .then(function success(response) {
                        SweetAlert.swal({
                          title: "El reporte está listo para descargar",
                          icon: "success",
                          text: "Encuentra la liga de descarga en la sección de notificaciones",
                          timer: 5000,
                        });
                        socket.disconnect();
                        if ($uibModalInstance) {
                          $uibModalInstance.dismiss("cancel");
                        }
                      })
                      .catch(function (err) {
                        socket.disconnect();
                        if ($uibModalInstance) {
                          $uibModalInstance.dismiss("cancel");
                        }
                      });
                  });
                  toaster.info(
                    "Generando...",
                    "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                  );
                } else {
                  l.stop();
                  if ($uibModalInstance) {
                    $uibModalInstance.dismiss("cancel");
                  }
                  toaster.error(
                    "Aviso",
                    "Ha ocurrido un error, intente nuevamente"
                  );
                }
              })
              .catch(function (error) {
                l.stop();
                toaster.error(
                  "Aviso",
                  "Ha ocurrido un error, intente nuevamente"
                );
              });
          } else if (option == 2) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            $scope.url_go_excel = "service_reporte-polizasReport-excel";
            $http({
              method: "POST",
              url: url.IP + $scope.url_go_excel, //'reporte-polizas-excel',
              data: filters,
              headers: { "Content-Type": "application/json" },
            })
              .then(function (data) {
                if (data.status == 200) {
                  l.stop();
                  // Conexión a socket.io
                  // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // if($scope.org_name =='ancora'){
                  //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                  // }else{
                  var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // }
                  socket.emit("subscribe", data.data);
                  // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                  socket.on(data.data, function (url) {
                    // vm.main.notifications['count']  +=1;
                    var notificacion = {
                      title: "El reporte solicitado ha sido generado",
                      description: url,
                      model: 26,
                      id_reference: 0,
                    };
                    dataFactory
                      .post("notificaciones/", notificacion)
                      .then(function success(response) {
                        SweetAlert.swal({
                          title: "El reporte está listo para descargar",
                          icon: "success",
                          text: "Encuentra la liga de descarga en la sección de notificaciones",
                          timer: 5000,
                        });
                        socket.disconnect();
                        if ($uibModalInstance) {
                          $uibModalInstance.dismiss("cancel");
                        }
                      })
                      .catch(function (err) {
                        socket.disconnect();
                        if ($uibModalInstance) {
                          $uibModalInstance.dismiss("cancel");
                        }
                      });
                  });
                  toaster.info(
                    "Generando...",
                    "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                  );
                  //     var blob = new Blob([data.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                  //     saveAs(blob, 'Reporte_Pólizas.xls');
                } else {
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    // -----------------PAGINACIÓN
    jQuery(function ($) {
      $("#exportButton").click(function () {
        // parse the HTML table element having an id=exportTable
        var dataSource = shield.DataSource.create({
          data: "#exportTable",
          schema: {
            type: "table",
            fields: {
              Recibo: { type: String },
              RPF: { type: Number },
              Estatus: { type: String },
            },
          },
        });

        // when parsing is done, export the data to PDF
        dataSource.read().then(function (data) {
          var pdf = new shield.exp.PDFDocument({
            author: "PrepBootstrap",
            created: new Date(),
          });

          pdf.addPage("a4", "portrait");

          pdf.table(
            50,
            50,
            data,
            [
              { field: "Recibo", title: "Número de Recibo", width: 200 },
              { field: "RPF", title: "RPF", width: 50 },
              { field: "Estatus", title: "Estatus del recibo", width: 200 },
            ],
            {
              margins: {
                top: 50,
                left: 50,
              },
            }
          );

          pdf.saveAs({
            fileName: "ReportePolizas",
          });
        });
      });
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteOTEndosoController", ReporteOTEndosoController);

  ReporteOTEndosoController.$inject = [
    "appStates",
    "$sessionStorage",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$parse",
    "exportFactory",
    "$uibModal",
    "$localStorage",
  ];

  function ReporteOTEndosoController(
    appStates,
    $sessionStorage,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $parse,
    exportFactory,
    $uibModal,
    $localStorage
  ) {
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;
    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
      {
        id: 15,
        name: "No renovada",
      },
    ];
    vm.option_policy = [
      {
        id: 1,
        name: "Fecha de ingreso",
      },
      {
        id: 2,
        name: "Vigencia",
      },
    ];

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.tableRes = {};
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.changeUntil = changeUntil;
    vm.changePolicy = changePolicy;
    vm.goToInfo = goToInfo;
    vm.formatearNumero = formatearNumero;
    vm.changeGroupBy = changeGroupBy;
    vm.changeCreated = changeCreated;

    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      created_at: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: 0,
      group: 0,
      recibos_pagados: true,
      recibos_no_pagados: false,
      recibos_liquidados: false,
      recibos_conciliados: false,
      num_poliza: "",
      cve_agente: "",
      ot_rep: 1,
      identifier: "",
    };

    vm.table = {
      headers: [
        "Número de Póliza",
        "Tipo",
        "Contratante",
        "Aseguradora",
        "Ramo",
        "Subramo",
        "Paquete",
        "Frecuencia de Pago",
        "Estatus Póliza",
        "Vigencia Póliza",
        "Folio",
        "Moneda",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Observaciones",
        "Creado Por",
        "Clave de Agente",
        "Asegurado/Serial",
        "Fecha de creación",
        "Marca - Modelo - Año",
        "Versión",
        "Placas",
        "Motor",
        "Adaptaciones",
        "Dirección",
      ],
    };

    vm.group_by = [
      {
        id: 1,
        name: "Aseguradora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 6,
        name: "Estatus",
      },
      {
        id: 7,
        name: "Usuario",
      },
    ];

    $scope.infoUser = $sessionStorage.infoUser;

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    $scope.vigency = false;
    $scope.created_at = false;
    // $(window).load(function() {
    //     $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    $scope.columnArray = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;

    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };

    function changePolicy(par, asc) {
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.policy_nump_asc = asc;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = asc;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.policy_aseg_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = asc;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.policy_ramo_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = asc;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.policy_subramo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = asc;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.policy_pack_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = asc;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;

        case 7:
          Generar(par, asc);
          vm.policy_conc_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = asc;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.policy_fpago_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.policy_status_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.policy_vig_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.policy_hasta_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = asc;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 12:
          Generar(par, asc);
          vm.policy_clave_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = asc;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 13:
          Generar(par, asc);
          vm.policy_folio_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = asc;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 14:
          Generar(par, asc);
          vm.policy_moneda_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = asc;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 15:
          Generar(par, asc);
          vm.policy_pneta_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = asc;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 16:
          Generar(par, asc);
          vm.policy_rpf_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = asc;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 17:
          Generar(par, asc);
          vm.policy_der_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = asc;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 18:
          Generar(par, asc);
          vm.policy_iva_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = asc;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 19:
          Generar(par, asc);
          vm.policy_ptotal_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_obs_asc = asc;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 20:
          Generar(par, asc);
          vm.policy_com_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_obs_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 21:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = asc;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 22:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_created_asc = 0;
          break;
        case 23:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_contgroup_asc = asc;
          vm.policy_created_asc = 0;
          break;
        case 24:
          Generar(par, asc);
          vm.policy_obs_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pack_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_fpago_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_hasta_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_moneda_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_com_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_ase_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_contgroup_asc = asc;
          break;
      }
    }

    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }
    vm.form.ot_rep = 3;
    $scope.ot_rep = 3;
    $scope.valueRadioRep = function (val) {
      if (val == 1) {
        $scope.ot_rep = 1;
        vm.form.ot_rep = 1;
      } else if (val == 2) {
        vm.form.ot_rep = 2;
      } else if (val == 3) {
        vm.form.ot_rep = 3;
      }
    };

    $scope.renewals = 0;
    $scope.valueRadioRen = function (val) {
      if (val == 1) {
        vm.form.renewals = 1;
        toaster.warning("De clic en Consultar");
      } else if (val == 2) {
        vm.form.renewals = 1;
        toaster.warning("De clic en Consultar");
      } else {
        vm.form.renewals = 0;
        toaster.warning("De clic en Consultar");
      }
    };

    activate();
    vm.form.since = convertDate(new Date());
    vm.form.until = convertDate(new Date());
    //var endingDate =  convertDate(new Date());
    //vm.form.until = endingDate;

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function changeCreated(created) {}

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function activate() {
      $(".js-example-basic-multiple").select2();
      getProviders();
      getUsuarios();
      getSubramos();
      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.sub_total = 0;
      $scope.comision = 0;
      if (!vm.acceso_ver_ot) {
        vm.form.ot_rep = 3;
        vm.ot_rep = 3;
      }

      vm.form.identifier =
        $localStorage.saved_filters_reporte_otendoso &&
        $localStorage.saved_filters_reporte_otendoso["identifier"]
          ? $localStorage.saved_filters_reporte_otendoso["identifier"]
          : "";
      vm.form.contratante =
        $localStorage.saved_filters_reporte_otendoso &&
        $localStorage.saved_filters_reporte_otendoso["contratante"]
          ? $localStorage.saved_filters_reporte_otendoso["contratante"]
          : "";
      vm.form.group =
        $localStorage.saved_filters_reporte_otendoso &&
        $localStorage.saved_filters_reporte_otendoso["group"]
          ? $localStorage.saved_filters_reporte_otendoso["group"]
          : 0;
      vm.form.cve_agente =
        $localStorage.saved_filters_reporte_otendoso &&
        $localStorage.saved_filters_reporte_otendoso["cve_agente"]
          ? $localStorage.saved_filters_reporte_otendoso["cve_agente"]
          : "";
      vm.form.dates_sel =
        $localStorage.saved_filters_reporte_otendoso &&
        $localStorage.saved_filters_reporte_otendoso["dates_sel"]
          ? $localStorage.saved_filters_reporte_otendoso["dates_sel"]
          : 0;

      $scope.ot_rep =
        $localStorage.saved_filters_reporte_otendoso &&
        $localStorage.saved_filters_reporte_otendoso["ot_rep"]
          ? $localStorage.saved_filters_reporte_otendoso["ot_rep"]
          : 3;

      if (vm.form.dates_sel) {
        $scope.vigency = true;
      }
    }

    function changeGroupBy() {
      $scope.grupos_result = [];
      $scope.showSums = false;
      vm.show_pag_cobranza = false;
    }

    $scope.changeReport = function () {
      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id == 1) {
          $scope.created_at = true;
          $scope.vigency = false;
        } else if (vm.form.dates_sel.id == 2) {
          $scope.vigency = true;
          $scope.created_at = false;
        }
      } else {
        $scope.vigency = false;
        $scope.created_at = false;
      }
    };
    $scope.fpago = function (pago) {
      switch (pago) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 4:
          return "Cuatrimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        case 24:
          return "Quincenal";
          break;
      }
    };
    $scope.fmoneda = function (mon) {
      switch (mon) {
        case 1:
          return "Pesos";
          break;
        case 2:
          return "Dólares";
          break;
        case 3:
          return "UDI";
          break;
        case 4:
          return "Euro";
          break;
      }
    };

    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }

    $scope.reporte = false;
    $scope.showButtonExcel = false;

    function Generar(order, asc, parPage) {
      if (vm.acceso_ver_ot || vm.acceso_ver_pol) {
        var l = Ladda.create(document.querySelector(".ladda-buttonC"));
        l.start();

        $scope.order = order;
        $scope.asc = asc;
        if (vm.form.dates_sel == undefined || vm.form.dates_sel == null) {
          l.stop();
          SweetAlert.swal(
            "Información",
            "Es necesario seleccionar una opción de Reporte por",
            "error"
          );

          return;
        }

        var since = toDate(vm.form.since).getTime();
        var until = toDate(vm.form.until).getTime();
        var diff = until - since;
        var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
        if (antiguedad < 0) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        }

        $scope.reporte = true;
        $scope.insurances = [];
        $scope.total = 0;
        $scope.prima_neta = 0;
        $scope.comision = 0;

        var params = {
          provider: vm.form.provider.id
            ? vm.form.provider.id
            : vm.form.provider,
          ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
          subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
          since: vm.form.since ? vm.form.since : vm.form.si,
          until: vm.form.until ? vm.form.until : vm.form.un,
          payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
          status: vm.form.status.id ? vm.form.status.id : vm.form.status,
          contratante: vm.form.contratante.value
            ? vm.form.contratante.value
            : 0,
          grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
          type_contractor: vm.form.contratante.type
            ? vm.form.contratante.type
            : 0,
          poliza: vm.form.num_poliza ? vm.form.num_poliza : 0,
          identifier: vm.form.identifier ? vm.form.identifier : 0,
          cve: vm.form.cve_agente ? vm.form.cve_agente : 0,
          ot: vm.form.ot_rep,
          order: order,
          asc: asc,
          page: parPage ? parPage : 1,
          group_by: vm.form.group_by ? vm.form.group_by.id : 0,
          ramos: vm.ramos_selected ? vm.ramos_selected : 0,
          subramos: vm.subramos_selected ? vm.subramos_selected : 0,
          providers: vm.providers_selected ? vm.providers_selected : 0,
          claves: vm.claves_selected ? vm.claves_selected : 0,
          users: vm.usuarios_selected ? vm.usuarios_selected : 0,
          report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 1,
          renewals: $scope.renewals ? $scope.renewals : 0,
        };
        if (vm.form.contratante) {
          if (vm.form.contratante.val == "") {
            params.contratante = 0;
            vm.form.contratante.value = "";
            vm.form.contratante.type = "";
          }
        }
        if (vm.form.group) {
          if (vm.form.group.val == "") {
            params.grupo = 0;
            vm.form.group.value = "";
            vm.form.group.type = "";
          }
        }
        params.since = params.since + " " + "00:00:00";
        params.until = params.until + " " + "23:59:59";
        $scope.filtros = params;
        $scope.search_otsendoso = "reporte-otsendosos-rep/";
        $http({
          method: "POST",
          url: url.IP + $scope.search_otsendoso,
          data: params,
        }).then(function success(response) {
          if (response.status == 200 || response.status == 201) {
            if (response.data.results) {
              $scope.policy_config = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };

              vm.show_pag_policy = true;
              testPagination("insurances", "policy_config");
              $scope.insurances = response.data.results;
            } else {
              $scope.insurances = [];
            }
            $scope.endosos = response.data.endosos;
            l.stop();
            if ($scope.insurance) {
              $scope.sumas = response.data.sumas;
              for (var i = 0; i < $scope.insurances.length; i++) {
                $scope.insurances[i].document_type =
                  $scope.insurances[i].document_type == 1
                    ? "Póliza"
                    : "Colectividad";
                if ($scope.insurances[i].document_type == "Póliza") {
                  $scope.insurances[i].document_type =
                    $scope.insurances[i].status == 1
                      ? "OT"
                      : $scope.insurances[i].status == 2
                      ? "OT"
                      : "Póliza";
                }
                $scope.insurances[i].forma_de_pago =
                  $scope.insurances[i].forma_de_pago == 1
                    ? "Mensual"
                    : $scope.insurances[i].forma_de_pago == 2
                    ? "Bimestral"
                    : $scope.insurances[i].forma_de_pago == 3
                    ? "Trimestral"
                    : $scope.insurances[i].forma_de_pago == 5
                    ? "Contado"
                    : $scope.insurances[i].forma_de_pago == 6
                    ? "Semestral"
                    : "Anual";
                // $scope.insurances[i].status = $scope.insurances[i].status == 1 ? "En trámite" :
                //   $scope.insurances[i].status == 2 ? "OT Cancelada" : $scope.insurances[i].status == 10 ? "Por Iniciar" :
                //   $scope.insurances[i].status == 11 ? "Cancelada" : $scope.insurances[i].status == 12 ? "Renovada" :
                //   $scope.insurances[i].status == 13 ? "Vencida" : $scope.insurances[i].status == 15 ? "No renovada" : "Vigente";
                $scope.insurances[i].f_currency =
                  $scope.insurances[i].f_currency == 1 ? "Pesos" : "Dolares";
              }

              $scope.count_insurances = angular.copy($scope.insurances);
              if ($scope.insurances.length < 10) {
                for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
                  var object = {
                    contratante: " ",
                    poliza_number: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    paquete: " ",
                    prima_neta: null,
                    rpf: null,
                    derecho: null,
                    iva: null,
                    prima_total: null,
                    comision: null,
                    forma_de_pago: " ",
                    document_type: " ",
                    status: " ",
                    start_of_validity: " ",
                    folio: " ",
                    f_currency: " ",
                    observations: " ",
                    created_at: " ",
                    clave: " ",
                  };
                  $scope.insurances.push(object);
                }
              }

              $scope.policy_config = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };

              vm.show_pag_policy = true;
              testPagination("insurances", "policy_config");

              if ($scope.insurances[0].poliza_number == " ") {
                toaster.warning("No se encontraron registros");
              } else {
                $scope.showButtonExcel = true;
                $scope.showSums = true;
              }
            }
          } else {
            l.stop();
            toaster.warning("Error en la llamada registros");
            console.log("______", response);
          }
        });
      } else {
        SweetAlert("Error", "No tiene acceso a ver OTs ni Pólizas", "error");
      }

      $localStorage.saved_filters_reporte_otendoso = angular.copy(params);
      $localStorage.saved_filters_reporte_otendoso["identifier"] =
        vm.form.identifier;
      $localStorage.saved_filters_reporte_otendoso["contratente"] =
        vm.form.contratante;
      $localStorage.saved_filters_reporte_otendoso["group"] = vm.form.group;
      $localStorage.saved_filters_reporte_otendoso["cve_agente"] =
        vm.form.cve_agente;
      $localStorage.saved_filters_reporte_otendoso["dates_sel"] =
        vm.form.dates_sel;
      $localStorage.saved_filters_reporte_otendoso["ot_rep"] = $scope.ot_rep;
    }

    $scope.open_in_same_tab_natural = function (
      name,
      route,
      params,
      identifier
    ) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };

    function goToInfo(insurance) {
      if (vm.acceso_ver_pol) {
        if (insurance.document_type == 1) {
          $scope.open_in_same_tab_natural(
            "Información póliza",
            "polizas.info",
            { polizaId: insurance.id },
            insurance.id
          );
          // $state.go('polizas.info', {polizaId: insurance.id})
        } else if (insurance.document_type == 3) {
          $scope.open_in_same_tab_natural(
            "Información colectividad",
            "colectividades.info",
            { polizaId: insurance.id },
            insurance.id
          );
          // $state.go('colectividades.info', {polizaId: insurance.id})
        }
      }
    }

    $scope.goToEndorsement = function (endoso) {
      $scope.open_in_same_tab_natural(
        "Información endoso",
        "endorsement.info",
        { endosoId: endoso.id },
        endoso.id
      );
    };

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        console.log(data);
        vm.providers = data.data;
      });
    }

    $scope.exportDataExcel = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.filtros.orden = $scope.columnArray;
      $scope.filtros.excel_type = 2;
      if (param == 1) {
        $scope.excel_otsendoso = "service_reporte-otsEndososReport-excel";
        $http({
          method: "POST",
          url: url.IP + $scope.excel_otsendoso,
          data: $scope.filtros,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
          .then(function (data) {
            if (data.status == 200) {
              l.stop();
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte OTs/Endosos.xls");
            } else {
              SweetAlert.swal(
                "Error",
                "Ha ocurrido un error al descargar el reporte",
                "error"
              );
              l.stop();
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group.val) {
        var word_data = vm.form.group.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            vm.ramos = response.data;
          });
      }
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http.get(url.IP + "subramos-by-ramo/" + vm.id).then(function (data) {
            vm.subramos_toselected = data.data;
          });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.id);
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }
    // -----------PAGINACIÓN

    $scope.actual_page = 1;

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
      $scope.status = function (parValue) {
        switch (parValue) {
          case 1:
            return "En trámite";
            break;
          case 2:
            return "OT Cancelada";
            break;
          case 4:
            return "Precancelada";
            break;
          case 10:
            return "Por iniciar";
            break;
          case 11:
            return "Cancelada";
            break;
          case 12:
            return "Renovada";
            break;
          case 13:
            return "Vencida";
            break;
          case 14:
            return "Vigente";
            break;
          case 15:
            return "No renovada";
            break;
          default:
            return "Pendiente";
        }
      };
      function getPolicyPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              $scope.data_pagination = request.data.results;
              for (var i = 0; i < $scope.data_pagination.length; i++) {
                $scope.data_pagination[i].document_type =
                  $scope.data_pagination[i].document_type == 1
                    ? "Póliza"
                    : "Colectividad";
                if ($scope.data_pagination[i].document_type == "Póliza") {
                  $scope.data_pagination[i].document_type =
                    $scope.data_pagination[i].status == 1
                      ? "OT"
                      : $scope.data_pagination[i].status == 2
                      ? "OT"
                      : "Póliza";
                }
                $scope.data_pagination[i].forma_de_pago =
                  $scope.data_pagination[i].forma_de_pago == 1
                    ? "Mensual"
                    : $scope.data_pagination[i].forma_de_pago == 2
                    ? "Bimestral"
                    : $scope.data_pagination[i].forma_de_pago == 3
                    ? "Trimestral"
                    : $scope.data_pagination[i].forma_de_pago == 5
                    ? "Contado"
                    : $scope.data_pagination[i].forma_de_pago == 6
                    ? "Semestral"
                    : "Anual";
                $scope.data_pagination[i].status =
                  $scope.data_pagination[i].status == 1
                    ? "En trámite"
                    : $scope.data_pagination[i].status == 2
                    ? "OT Cancelada"
                    : $scope.data_pagination[i].status == 10
                    ? "Por Iniciar"
                    : $scope.data_pagination[i].status == 11
                    ? "Cancelada"
                    : $scope.data_pagination[i].status == 12
                    ? "Renovada"
                    : $scope.data_pagination[i].status == 13
                    ? "Vencida"
                    : $scope.data_pagination[i].status == 15
                    ? "No renovada"
                    : "Vigente";
                $scope.data_pagination[i].f_currency =
                  $scope.data_pagination[i].f_currency == 1
                    ? "Pesos"
                    : "Dolares";
              }
              $scope.count_pagination = angular.copy($scope.data_pagination);
              if ($scope.data_pagination.length < 10) {
                for (var i = 0; i < 10 - $scope.count_pagination.length; i++) {
                  var object = {
                    poliza_number: " ",
                    document_type: " ",
                    natural: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    paquete: " ",
                    forma_de_pago: " ",
                    status: " ",
                    start_of_validity: " ",
                    created_at: " ",
                    folio: " ",
                    f_currency: " ",
                    prima_neta: null,
                    rpf: null,
                    derecho: null,
                    iva: null,
                    prima_total: null,
                    comision: null,
                    observations: " ",
                    clave: " ",
                  };
                  $scope.data_pagination.push(object);
                }
              }

              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }

    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;

      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = 1;
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        filters.excel_type = option;
        $http({
          method: "POST",
          // url: url.IP +'reporte-otsendosos-excel',
          url: url.IP + "service_reporte-otsEndososReport-excel",
          data: filters,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
          .then(function (data) {
            if (data.status == 200) {
              // l.stop();
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte OTS / Endosos.xls");
              $uibModalInstance.dismiss("cancel");
              l.stop();
            } else {
              SweetAlert.swal(
                "Error",
                "Ha ocurrido un error al descargar el reporte",
                "error"
              );
              l.stop();
              $uibModalInstance.dismiss("cancel");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    // -----------------PAGINACIÓN
    jQuery(function ($) {
      $("#exportButton").click(function () {
        // parse the HTML table element having an id=exportTable
        var dataSource = shield.DataSource.create({
          data: "#exportTable",
          schema: {
            type: "table",
            fields: {
              Recibo: { type: String },
              RPF: { type: Number },
              Estatus: { type: String },
            },
          },
        });

        // when parsing is done, export the data to PDF
        dataSource.read().then(function (data) {
          var pdf = new shield.exp.PDFDocument({
            author: "PrepBootstrap",
            created: new Date(),
          });

          pdf.addPage("a4", "portrait");

          pdf.table(
            50,
            50,
            data,
            [
              { field: "Recibo", title: "Número de Recibo", width: 200 },
              { field: "RPF", title: "RPF", width: 50 },
              { field: "Estatus", title: "Estatus del recibo", width: 200 },
            ],
            {
              margins: {
                top: 50,
                left: 50,
              },
            }
          );

          pdf.saveAs({
            fileName: "ReportePolizas",
          });
        });
      });
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteLogController", ReporteLogController);

  ReporteLogController.$inject = [
    "datesFactory",
    "MESSAGES",
    "$http",
    "url",
    "$scope",
    "$parse",
    "$sessionStorage",
    "$uibModal",
    "SweetAlert",
    "$localStorage",
  ];

  function ReporteLogController(
    datesFactory,
    MESSAGES,
    $http,
    url,
    $scope,
    $parse,
    $sessionStorage,
    $uibModal,
    SweetAlert,
    $localStorage
  ) {
    var vm = this;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    vm.users = [];
    vm.group_by = [
      {
        id: 1,
        name: "Usuario",
      },
    ];
    vm.form = {
      since: convertDate(new Date()),
      until: convertDate(new Date()),
    };
    vm.models = [
      {
        id: 1,
        model: "Pólizas",
      },
      {
        id: 2,
        model: "Contratantes Físicos",
      },
      {
        id: 3,
        model: "Contratantes Morales",
      },
      {
        id: 4,
        model: "Recibos",
      },
      {
        id: 5,
        model: "Siniestros",
      },
      {
        id: 6,
        model: "Renovaciones",
      },
      {
        id: 7,
        model: "Recibos -> Comisiones",
      },
      {
        id: 8,
        model: "Grupos",
      },
      {
        id: 9,
        model: "Paquetes",
      },
      {
        id: 10,
        model: "Endosos",
      },
      {
        id: 11,
        model: "Aseguradoras",
      },
      {
        id: 12,
        model: "Estados de Cuenta",
      },
      {
        id: 13,
        model: "Fianzas",
      },
      {
        id: 14,
        model: "Afianzadoras",
      },
      {
        id: 15,
        model: "Comentarios",
      },
      {
        id: 16,
        model: "Logs",
      },
      {
        id: 17,
        model: "Cartas",
      },
      {
        id: 18,
        model: "Colectividades",
      },
      {
        id: 19,
        model: "Gráficas",
      },
      {
        id: 20,
        model: "Notas",
      },
      {
        id: 21,
        model: "Fianzas -> Reclamaciones",
      },
      {
        id: 22,
        model: "Tareas",
      },
    ];
    activate();
    $(".js-example-basic-multiple").select2();
    // Start functionality
    function activate() {
      $http.get(url.IP + "usuarios-general/").then(function (user) {
        user.data.results.forEach(function (usr) {
          vm.users.push(usr);
        });
      });
      //  $(window).load(function() {
      //    $('.js-example-basic-multiple').select2();
      // });
      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });
      $(".js-example-basic-multiple").select2();

      vm.form.group_by =
        $localStorage.saved_filters_reporte_log &&
        $localStorage.saved_filters_reporte_log["group_by"]
          ? $localStorage.saved_filters_reporte_log["group_by"]
          : 0;
      vm.form.model =
        $localStorage.saved_filters_reporte_log &&
        $localStorage.saved_filters_reporte_log["model"]
          ? $localStorage.saved_filters_reporte_log["model"]
          : 0;
    }
    // Get logs API
    $scope.getLogs = function (page, otro) {
      $scope.logs = [];
      $scope.grupos_result = [];
      $scope.filters = {
        users: vm.users_selected ? vm.users_selected : 0,
        since: vm.form.since ? vm.form.since : "",
        until: vm.form.until ? vm.form.until : "",
        model: vm.form.model ? vm.form.model.id : 0,
        groupBy: vm.form.group_by ? vm.form.group_by.id : 0,
        page: page ? page : 1,
      };
      $scope.filters.since = $scope.filters.since + " " + "00:00:00";
      $scope.filters.until = $scope.filters.until + " " + "23:59:59";
      $http({
        method: "POST",
        url: url.IP + "reporte-log/",
        data: $scope.filters,
      }).then(function success(response) {
        if ($scope.filters.groupBy == 0) {
          $scope.logs = response.data.results;
          $scope.log_config = {
            count: response.data.count,
            previous: url.IP + "reporte-log/",
            next: url.IP + "reporte-log/",
          };
          vm.show_pag_log = true;
          $scope.obtenerPaginacion(response.data, page ? page : 1);
          // PaginationResults('logs', 'log_config');
        } else {
          $scope.grupos_result = response.data.results;
        }
      });
      $localStorage.saved_filters_reporte_log = angular.copy($scope.filters);
      $localStorage.saved_filters_reporte_log["group_by"] = vm.form.group_by;
      $localStorage.saved_filters_reporte_log["model"] = vm.form.model;
    };
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      $localStorage.saved_filters_reporte_log["page"] = pagina;
      $scope.getLogs(pagina, 1);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $localStorage.saved_filters_reporte_log["page"] =
          $scope.paginacion["paginaActual"] - 1;
        $scope.getLogs($scope.paginacion["paginaActual"] - 1, 1);
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $localStorage.saved_filters_reporte_log["page"] =
          $scope.paginacion["paginaActual"] + 1;
        $scope.getLogs($scope.paginacion["paginaActual"] + 1, 1);
      }
    };
    // Change User
    $scope.selectUser = function (x, y) {
      vm.users_selected = [];
      x.forEach(function (r) {
        vm.users_selected.push(parseInt(r.id));
      });
    };
    // Download report to excel
    $scope.export = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "md",
            resolve: {
              filters: function () {
                return $scope.filters;
              },
              from: function () {
                return null;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var lx = Ladda.create(document.querySelector(".ladda-button_excel"));
        lx.start();
        $scope.filters.orden = $scope.columnArray;
        $scope.filters.export_type = 2;
        if (param == 1) {
          $http({
            method: "POST",
            // url: url.IP +'reporte-log-excel' ,
            url: url.IP + "service_reporte-logReport-excel",
            data: $scope.filters,
            headers: {
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "arraybuffer",
          }).then(function (data, status, headers, config) {
            if (data.status == 200) {
              lx.stop();
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte Transacciones.xls");
            } else {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.ERRORDOWNLOADREP,
                "error"
              );
              lx.stop();
            }
          });
        }
      }
    };
    // DOWNLOAD REPORT IF GROUP BY SELECTED
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        var param = 1;
        if (option) {
          // Totales de la Agrupación
          if (option == 1) {
            var l1 = Ladda.create(
              document.querySelector(".ladda-button_excel")
            );
            l1.start();
            filters.export_type = option;
            $http({
              method: "POST",
              // url: url.IP +'reporte-log-excel' ,
              url: url.IP + "service_reporte-logReport-excel",
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte Transacciones.xls");
                  $uibModalInstance.dismiss("cancel");
                  l1.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l1.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          } else if (option == 2) {
            filters.export_type = option;
            var la = Ladda.create(
              document.querySelector(".ladda-button_excel")
            );
            la.start();
            $http({
              method: "POST",
              // url: url.IP +'reporte-log-excel' ,
              url: url.IP + "service_reporte-logReport-excel",
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte Transacciones.xls");
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    // Format Dates DD/MM/YYYY
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    // -----------PAGINACIÓN
    function PaginationResults(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        $scope.getLogs(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteFianzasBenController", ReporteFianzasBenController);

  ReporteFianzasBenController.$inject = [
    "$sessionStorage",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$parse",
    "exportFactory",
    "$uibModal",
  ];

  function ReporteFianzasBenController(
    $sessionStorage,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $parse,
    exportFactory,
    $uibModal
  ) {
    $scope.infoUser = $sessionStorage.infoUser;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.token = token;
    $scope.decrptedtoken = usr;

    $scope.infoUser = $sessionStorage.infoUser;

    $(".js-example-basic-multiple").select2();
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;

    vm.Generar = Generar;

    vm.form = {};
    activate();

    function activate() {
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            vm.acceso_reportes = perm;
            vm.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  vm.acceso_rep_fia = true;
                } else {
                  vm.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  vm.acceso_rep_sin = true;
                } else {
                  vm.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  vm.acceso_rep_end = true;
                } else {
                  vm.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  vm.acceso_rep_pol = true;
                } else {
                  vm.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  vm.acceso_rep_ren = true;
                } else {
                  vm.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  vm.acceso_rep_cob = true;
                } else {
                  vm.acceso_rep_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Endosos") {
            vm.acceso_endosos = perm;
            vm.acceso_endosos.permissions.forEach(function (acc) {
              if (acc.permission_name == "Registrar endosos") {
                if (acc.checked == true) {
                  vm.acceso_reg_end = true;
                } else {
                  vm.acceso_reg_end = false;
                }
              }
            });
          } else if (perm.model_name == "Ordenes de trabajo") {
            vm.acceso_ot = perm;
            vm.acceso_ot.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar OTs") {
                if (acc.checked == true) {
                  vm.acceso_adm_ot = true;
                } else {
                  vm.acceso_adm_ot = false;
                }
              } else if (acc.permission_name == "Ver OTs") {
                if (acc.checked == true) {
                  vm.acceso_ver_ot = true;
                } else {
                  vm.acceso_ver_ot = false;
                }
              }
            });
          } else if (perm.model_name == "Comisiones") {
            vm.coms = perm;
            vm.coms.permissions.forEach(function (acc) {
              if (acc.permission_name == "Comisiones") {
                if (acc.checked == true) {
                  vm.permiso_comisiones = true;
                } else {
                  vm.permiso_comisiones = false;
                }
              }
            });
          }
        });
      }
      Generar();
    }

    $scope.reporte = false;
    $scope.showButtonExcel = false;

    function Generar(order, asc, parPage) {
      $scope.reporte = true;
      $scope.insurances = [];
      var params = {
        provider: 0,
        page: parPage ? parPage : 1,
      };
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      $scope.filtros = params;

      $scope.search_fianza = "reporte-fianzasben-rep/";
      $http({
        method: "POST",
        url: url.IP + $scope.search_fianza,
        data: params,
      }).then(function success(response) {
        if (response.data) {
          $scope.insurances = response.data.results;
          $scope.count_insurances = angular.copy($scope.insurances);
          $scope.policy_config = {
            count: response.data.count,
            previous: response.data.previous,
            next: response.data.next,
          };
          vm.show_pag_policy = true;
          testPagination("insurances", "policy_config");
          $scope.showButtonExcel = true;
          $scope.showSums = true;
        }
      });
    }

    $scope.exportDataExcel = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.filtros.excel_type = 2;
      $scope.excel_fianza = "service_reporte-fianzasBenReport-excel";
      $http({
        method: "POST",
        url: url.IP + $scope.excel_fianza,
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function (data, status, headers, config) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Fianzas_Beneficiarios.xls");
          l.stop();
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };
    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo/" + vm.id, sel)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getPolicyPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              $scope.data_pagination = request.data.results;
              for (var i = 0; i < $scope.data_pagination.length; i++) {
                $scope.data_pagination[i].document_type =
                  $scope.data_pagination[i].document_type == 1
                    ? "Póliza"
                    : "Colectividad";
                if ($scope.data_pagination[i].document_type == "Póliza") {
                  $scope.data_pagination[i].document_type =
                    $scope.data_pagination[i].status == 1
                      ? "OT"
                      : $scope.data_pagination[i].status == 2
                      ? "OT"
                      : "Póliza";
                }
                $scope.data_pagination[i].forma_de_pago =
                  $scope.data_pagination[i].forma_de_pago == 1
                    ? "Mensual"
                    : $scope.data_pagination[i].forma_de_pago == 2
                    ? "Bimestral"
                    : $scope.data_pagination[i].forma_de_pago == 3
                    ? "Trimestral"
                    : $scope.data_pagination[i].forma_de_pago == 5
                    ? "Contado"
                    : $scope.data_pagination[i].forma_de_pago == 6
                    ? "Semestral"
                    : "Anual";
                $scope.data_pagination[i].status =
                  $scope.data_pagination[i].status == 1
                    ? "En trámite"
                    : $scope.data_pagination[i].status == 2
                    ? "OT Cancelada"
                    : $scope.data_pagination[i].status == 10
                    ? "Por Iniciar"
                    : $scope.data_pagination[i].status == 11
                    ? "Cancelada"
                    : $scope.data_pagination[i].status == 12
                    ? "Renovada"
                    : $scope.data_pagination[i].status == 13
                    ? "Vencida"
                    : $scope.data_pagination[i].status == 15
                    ? "No renovada"
                    : "Vigente";
                $scope.data_pagination[i].f_currency =
                  $scope.data_pagination[i].f_currency == 1
                    ? "Pesos"
                    : "Dolares";
              }
              $scope.count_pagination = angular.copy($scope.data_pagination);
              if ($scope.data_pagination.length < 10) {
                for (var i = 0; i < 10 - $scope.count_pagination.length; i++) {
                  var object = {
                    fianza_number: " ",
                    document_type: " ",
                    natural: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    paquete: " ",
                    forma_de_pago: " ",
                    status: " ",
                    start_of_validity: " ",
                    created_at: " ",
                    folio: " ",
                    f_currency: " ",
                    prima_neta: null,
                    rpf: null,
                    derecho: null,
                    iva: null,
                    prima_total: null,
                    comision: null,
                    observations: " ",
                    clave: " ",
                  };
                  $scope.data_pagination.push(object);
                }
              }

              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteFianzasController", ReporteFianzasController);

  ReporteFianzasController.$inject = [
    "dataFactory",
    "$sessionStorage",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$parse",
    "exportFactory",
    "$uibModal",
    "$localStorage",
    "appStates",
  ];

  function ReporteFianzasController(
    dataFactory,
    $sessionStorage,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $parse,
    exportFactory,
    $uibModal,
    $localStorage,
    appStates
  ) {
    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? -1 : str1 > str2 ? 1 : 0;
      },

      "non-empty-string-desc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? 1 : str1 > str2 ? -1 : 0;
      },
    });
    var hCols = [];
    var paso = 0;
    var savedFiltersFianza = {};
    $scope.$on("ngRepeatFinished", function () {
      paso++;
      // console.log("hola");
      // $('#example').DataTable().draw();

      //Only needed for the filename of export files.
      //Normally set in the title tag of your page.document.title = 'Simple DataTable';
      //Define hidden columns
      $("#example").DataTable().destroy();
      // DataTable initialisation
      $("#example").DataTable({
        dom:
          "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-12'p<br/>i>>",
        info: false,
        paging: false,
        autoWidth: true,
        columnDefs: [
          {
            visible: false,
            targets: hCols,
          },
          {
            type: "non-empty-string",
            targets: 0,
          },
        ],
        buttons: [
          {
            extend: "colvis",
            collectionLayout: "three-column",
            text: function () {
              var totCols = $("#example thead th").length;
              var hiddenCols = hCols.length;
              var shownCols = totCols - hiddenCols;
              return "Columnas (" + shownCols + " de " + totCols + ")";
            },
            prefixButtons: [
              {
                extend: "colvisGroup",
                text: "Mostrar todo",
                show: ":hidden",
              },
              {
                extend: "colvisRestore",
                text: "Restaurar",
              },
            ],
          },
        ],
        oLanguage: {
          oPaginate: {
            sNext: '<span class="pagination-default">&#x276f;</span>',
            sPrevious: '<span class="pagination-default">&#x276e;</span>',
          },
        },
        initComplete: function (settings, json) {
          // Adjust hidden columns counter text in button -->
          $("#example").on(
            "column-visibility.dt",
            function (e, settings, column, state) {
              var index = hCols.indexOf(column);
              if (state === false) {
                if (index === -1) {
                  hCols.push(column);
                }
              }
              if (
                $(".dt-button-collection.dropdown-menu.three-column").length ===
                  1 &&
                state === true
              ) {
                // console.log($('.dt-button-collection.dropdown-menu.three-column').length);
                if (index !== -1) {
                  hCols.splice(index, 1);
                }
                // console.log("si entro");
              }
              // var visCols = $('#example thead tr:first th').length;

              //Below: The minus 2 because of the 2 extra buttons Show all and Restore
              var tblCols =
                $(".dt-button-collection li[aria-controls=example] a").length -
                2;
              var visCols = tblCols - hCols.length;
              $(".buttons-colvis[aria-controls=example] span").html(
                "Columnas (" + visCols + " de " + tblCols + ")"
              );
              e.stopPropagation();
            }
          );
        },
      });
    });

    $scope.infoUser = $sessionStorage.infoUser;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.token = token;
    $scope.decrptedtoken = usr;

    $scope.infoUser = $sessionStorage.infoUser;

    $(".js-example-basic-multiple").select2();
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;
    var startDate = new Date();
    var endingDate = new Date();
    var emision = new Date();
    var d = startDate;
    var curr_date = d.getDate();
    var curr_month = d.getMonth() + 1;
    var curr_year = d.getFullYear();
    var date = curr_year + "-" + curr_month + "-" + curr_date;
    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "OT Pendiente",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 10,
        name: "Por iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Anulada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
      {
        id: 15,
        name: "Renovada",
      },
    ];
    vm.option_policy = [
      {
        id: 1,
        name: "Fecha de ingreso",
      },
      {
        id: 2,
        name: "Vigencia",
      },
      {
        id: 3,
        name: "Fecha de emisión",
      },
    ];
    if ($scope.decrptedtoken.org == "ancora") {
      vm.option_policy = [
        {
          id: 1,
          name: "Fecha de ingreso",
        },
        {
          id: 2,
          name: "Vigencia",
        },
        {
          id: 3,
          name: "Fecha de emisión",
        },
        {
          id: 4,
          name: "Emisión de Producción",
        },
      ];
    }

    $scope.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 10; i >= oldYear; i--) {
      $scope.years.push(i);
    }

    $scope.month = {};
    $scope.month.month_selected = 1;
    $scope.month.options = [
      { value: 0, label: "" },
      { value: 1, label: "Enero" },
      { value: 2, label: "Febrero" },
      { value: 3, label: "Marzo" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Mayo" },
      { value: 6, label: "Junio" },
      { value: 7, label: "Julio" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Septiembre" },
      { value: 10, label: "Octubre" },
      { value: 11, label: "Noviembre" },
      { value: 12, label: "Diciembre" },
    ];

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.EndososLista = EndososLista;
    vm.tableRes = {};
    vm.matchesContractors = matchesContractors;
    vm.matchesPrograma = matchesPrograma;
    vm.matchesGroup = matchesGroup;
    vm.changeUntil = changeUntil;
    vm.changePolicy = changePolicy;
    vm.goToInfo = goToInfo;
    vm.formatearNumero = formatearNumero;
    vm.changeGroupBy = changeGroupBy;
    vm.changeCreated = changeCreated;

    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      created_at: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: 0,
      programap: 0,
      group: 0,
      recibos_pagados: true,
      recibos_no_pagados: false,
      recibos_liquidados: false,
      recibos_conciliados: false,
      num_fianza: "",
      cve_agente: "",
      ot_rep: true,
      identifier: "",
      celula: 0,
    };

    vm.table = {
      headers: [
        "NO. FIANZA",
        "Tipo",
        "Fiado",
        "AFIANZADORA",
        "RAMO",
        "SUBRAMO",
        "Frecuencia de Pago",
        "Estatus Fianza",
        "Vigencia Fianza",
        "Folio",
        "Moneda",
        "Prima Neta",
        "Gastos de Expedición",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Observaciones",
        "Creado Por",
        "Clave de Agente",
        "Asegurado/Serial",
        "Fecha de creación",
      ],
    };

    vm.group_by = [
      {
        id: 1,
        name: "Afianzadora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 7,
        name: "Usuario",
      },
    ];
    $scope.vigency = false;
    $scope.created_at = false;
    $scope.emision_date = false;
    $scope.addBitacoraEndoso = false;
    $scope.columnArray = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;

    vm.form.subgrouping = 0;
    vm.form.subsubgrouping = 0;
    vm.form.groupinglevel = 0;
    vm.form.subgrouping = 0;
    vm.form.subsubgrouping = 0;
    vm.form.classification = 0;
    vm.matchesGroupinglevel = matchesGroupinglevel;
    vm.matchesClassification = matchesClassification;

    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;

    vm.changeSubgrouping = changeSubgrouping;
    vm.changeSubsubgrouping = changeSubsubgrouping;
    $scope.subgroups = [];
    $scope.subsubgroups = [];
    $scope.subgrouping = [];
    $scope.subsubgrouping = [];
    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;

    function changeSubgroup(subg) {
      vm.form.subgroup = subg;
      vm.subgroup = subg;
      $scope.subsubgroups = subg.subsubgrupos ? subg.subsubgrupos : [];
    }
    function changeSubsubgroup(subg) {
      vm.form.subsubgroup = subg;
      vm.subsubgroup = subg;
    }
    // Nivel de agrupación
    function changeSubgrouping(subgl) {
      vm.form.subgrouping = subgl;
      vm.subgrouping = subgl;
      $scope.subsubgrouping = subgl.subsubgrupos ? subgl.subsubgrupos : [];
    }
    function changeSubsubgrouping(subgl) {
      vm.form.subsubgrouping = subgl;
      vm.subsubgrouping = subgl;
    }
    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Anulada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "Renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "";
      }
    };
    $scope.statusEmision = function (parValue) {
      switch (parValue) {
        case 1:
          return "Documentos recibidos";
          break;
        case 2:
          return "Documentos pendientes";
          break;
        case 3:
          return "Carga de documentos";
          break;
        case 4:
          return "En autorización";
          break;
        case 5:
          return "Emitida";
          break;
          return "";
      }
    };
    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };

    function changePolicy(par, asc) {
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.policy_cont_asc = asc;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_nump_asc = asc;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.policy_aseg_asc = asc;
          vm.policy_cont_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.policy_ramo_asc = asc;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.policy_subramo_asc = asc;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.policy_clave_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = asc;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;

        case 7:
          Generar(par, asc);
          vm.policy_conc_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = asc;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.policy_folio_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = asc;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.policy_status_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = asc;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.policy_vig_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = asc;
          vm.policy_comision_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.policy_tarifa_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = asc;
          vm.policy_tipo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 12:
          Generar(par, asc);
          vm.policy_clave_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = asc;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 13:
          Generar(par, asc);
          vm.policy_folio_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = asc;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 14:
          Generar(par, asc);
          vm.policy_estatus_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_tipo_asc = asc;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 15:
          Generar(par, asc);
          vm.policy_pneta_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = asc;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 16:
          Generar(par, asc);
          vm.policy_rpf_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = asc;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 17:
          Generar(par, asc);
          vm.policy_der_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = asc;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 18:
          Generar(par, asc);
          vm.policy_iva_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = asc;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 19:
          Generar(par, asc);
          vm.policy_ptotal_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_clave_asc = asc;
          vm.policy_conc_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_status_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_esemision_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 20:
          Generar(par, asc);
          vm.policy_esemision_asc = asc;
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 21:
          Generar(par, asc);
          vm.policy_peinicio_asc = asc;
          vm.policy_esemision_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 22:
          Generar(par, asc);
          vm.policy_value_asc = asc;
          vm.policy_esemision_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 23:
          Generar(par, asc);
          vm.policy_perc_asc = asc;
          vm.policy_esemision_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 24:
          Generar(par, asc);
          vm.policy_num_asc = asc;
          vm.policy_esemision_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_proyecto_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 25:
          Generar(par, asc);
          vm.policy_proyecto_asc = asc;
          vm.policy_esemision_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_numic_asc = 0;
          break;
        case 26:
          Generar(par, asc);
          vm.policy_numic_asc = asc;
          vm.policy_esemision_asc = 0;
          vm.policy_cont_asc = 0;
          vm.policy_nump_asc = 0;
          vm.policy_aseg_asc = 0;
          vm.policy_ramo_asc = 0;
          vm.policy_subramo_asc = 0;
          vm.policy_pneta_asc = 0;
          vm.policy_rpf_asc = 0;
          vm.policy_der_asc = 0;
          vm.policy_iva_asc = 0;
          vm.policy_ptotal_asc = 0;
          vm.policy_comision_asc = 0;
          vm.policy_estatus_asc = 0;
          vm.policy_created_asc = 0;
          vm.policy_tipo_asc = 0;
          vm.policy_vig_asc = 0;
          vm.policy_folio_asc = 0;
          vm.policy_tarifa_asc = 0;
          vm.policy_owner_asc = 0;
          vm.policy_clave_asc = 0;
          vm.policy_peinicio_asc = 0;
          vm.policy_value_asc = 0;
          vm.policy_perc_asc = 0;
          vm.policy_num_asc = 0;
          vm.policy_proyecto_asc = 0;
          break;
      }
    }

    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }
    if (vm.acceso_ver_ot) {
      $scope.ot_rep = true;
      vm.form.ot_rep = true;
    } else {
      vm.form.ot_rep = false;
      $scope.ot_rep = false;
    }
    $scope.valueRadioRep = function (val) {
      if (val == true) {
        if (!vm.acceso_ver_ot) {
          $scope.ot_rep = false;
          vm.form.ot_rep = false;
        } else {
          vm.form.ot_rep = true;
          $scope.ot_rep = true;
          toaster.warning("De clic en Consultar");
        }
      } else {
        vm.form.ot_rep = false;
        $scope.ot_rep = false;
        toaster.warning("De clic en Consultar");
      }
    };

    activate();
    getCelulasContractor();

    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    vm.form.since = convertDate(new Date());
    var endingDate = convertDate(new Date());
    vm.form.until = endingDate;

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function changeCreated(created) {}

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      getProviders();
      getUsuarios();
      getSubramos();
      matchesPrograma();
      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.sub_total = 0;
      $scope.comision = 0;

      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            vm.acceso_reportes = perm;
            vm.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  vm.acceso_rep_fia = true;
                } else {
                  vm.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  vm.acceso_rep_sin = true;
                } else {
                  vm.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  vm.acceso_rep_end = true;
                } else {
                  vm.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  vm.acceso_rep_pol = true;
                } else {
                  vm.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  vm.acceso_rep_ren = true;
                } else {
                  vm.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  vm.acceso_rep_cob = true;
                } else {
                  vm.acceso_rep_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Endosos") {
            vm.acceso_endosos = perm;
            vm.acceso_endosos.permissions.forEach(function (acc) {
              if (acc.permission_name == "Registrar endosos") {
                if (acc.checked == true) {
                  vm.acceso_reg_end = true;
                } else {
                  vm.acceso_reg_end = false;
                }
              }
            });
          } else if (perm.model_name == "Ordenes de trabajo") {
            vm.acceso_ot = perm;
            vm.acceso_ot.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar OTs") {
                if (acc.checked == true) {
                  vm.acceso_adm_ot = true;
                } else {
                  vm.acceso_adm_ot = false;
                }
              } else if (acc.permission_name == "Ver OTs") {
                if (acc.checked == true) {
                  vm.acceso_ver_ot = true;
                } else {
                  vm.acceso_ver_ot = false;
                }
              }
            });
          } else if (perm.model_name == "Comisiones") {
            vm.coms = perm;
            vm.coms.permissions.forEach(function (acc) {
              if (acc.permission_name == "Comisiones") {
                if (acc.checked == true) {
                  vm.permiso_comisiones = true;
                } else {
                  vm.permiso_comisiones = false;
                }
              }
            });
          }
        });
      }

      vm.form.num_fianza =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["poliza"]
          ? $localStorage.saved_filters_reporte_fianza["poliza"]
          : "";
      vm.form.identifier =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["identifier"]
          ? $localStorage.saved_filters_reporte_fianza["identifier"]
          : "";
      vm.form.contratante =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["contratante"]
          ? $localStorage.saved_filters_reporte_fianza["contratante"]
          : "";
      vm.form.group =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["group"]
          ? $localStorage.saved_filters_reporte_fianza["group"]
          : 0;
      vm.form.groupinglevel =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["groupinglevel"]
          ? $localStorage.saved_filters_reporte_fianza["groupinglevel"]
          : "";
      vm.form.celula =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["celula"]
          ? $localStorage.saved_filters_reporte_fianza["celula"]
          : 0;
      vm.form.status =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["status"]
          ? $localStorage.saved_filters_reporte_fianza["status"]
          : 0;
      vm.form.cve_agente =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["cve_agente"]
          ? $localStorage.saved_filters_reporte_fianza["cve_agente"]
          : "";
      vm.form.group_by =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["group_by"]
          ? $localStorage.saved_filters_reporte_fianza["group_by"]
          : 0;
      vm.form.dates_sel =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["dates_sel"]
          ? $localStorage.saved_filters_reporte_fianza["dates_sel"]
          : 0;
      vm.form.programap =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["programap"]
          ? $localStorage.saved_filters_reporte_fianza["programap"]
          : "";
      $scope.ot_rep =
        $localStorage.saved_filters_reporte_fianza &&
        $localStorage.saved_filters_reporte_fianza["ot_rep"]
          ? $localStorage.saved_filters_reporte_fianza["ot_rep"]
          : false;

      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id != 4 && vm.form.dates_sel.id != "4") {
          $scope.vigency = true;
        } else {
          $scope.addBitacoraEndoso = true;
        }
      }
    }

    function changeGroupBy() {
      $scope.grupos_result = [];
      $scope.showSums = false;
      vm.show_pag_cobranza = false;
    }
    $scope.changeReport = function () {
      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id == 1) {
          $scope.created_at = true;
          $scope.vigency = false;
          $scope.emision_date = false;
        } else if (vm.form.dates_sel.id == 2) {
          $scope.vigency = true;
          $scope.created_at = false;
          $scope.emision_date = false;
        } else if (vm.form.dates_sel.id == 3) {
          $scope.vigency = false;
          $scope.created_at = false;
          $scope.emision_date = true;
        } else if (vm.form.dates_sel.id == 4) {
          $scope.vigency = false;
          $scope.created_at = false;
          $scope.emision_date = false;
          $scope.addBitacoraEndoso = true;
        }
      } else {
        $scope.vigency = false;
        $scope.created_at = false;
        $scope.emision_date = false;
      }
    };
    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }

    $scope.reporte = false;
    $scope.showButtonExcel = false;
    $scope.findBeneficiario = function (parValue) {
      if (parValue) {
        if (parValue.val.length >= 3) {
          $scope.shben = "get-beneficiarios-fianzas/";
          dataFactory
            .post($scope.shben, { word: parValue.val })
            .then(
              function success(request) {
                var results = [];
                results = _.map(request.data, function (item) {
                  var label = item.first_name
                    ? item.first_name +
                      " " +
                      item.last_name +
                      " " +
                      item.second_last_name
                    : item.j_name;
                  label = label + " - " + item.rfc;
                  return {
                    label: label,
                    value: item.poliza_number,
                    id: item.id,
                  };
                });
                $scope.autocompleteData = results;
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };
    function Generar(order, asc, parPage, parPageEnd) {
      $scope.parPageF = parPage;
      //$('#example').DataTable().draw();
      setTimeout(function () {
        paso++;
        $("#example").DataTable().destroy();
        // DataTable initialisation
        $("#example").DataTable({
          dom:
            "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" +
            "<'row'<'col-sm-12'tr>>" +
            "<'row'<'col-sm-12'p<br/>i>>",
          info: false,
          paging: false,
          autoWidth: true,
          columnDefs: [
            {
              visible: false,
              targets: hCols,
            },
            {
              type: "non-empty-string",
              targets: 0,
            },
          ],
          buttons: [
            {
              extend: "colvis",
              collectionLayout: "three-column",
              text: function () {
                var totCols = $("#example thead th").length;
                var hiddenCols = hCols.length;
                var shownCols = totCols - hiddenCols;
                return "Columnas (" + shownCols + " de " + totCols + ")";
              },
              prefixButtons: [
                {
                  extend: "colvisGroup",
                  text: "Mostrar todo",
                  show: ":hidden",
                },
                {
                  extend: "colvisRestore",
                  text: "Restaurar",
                },
              ],
            },
          ],
          oLanguage: {
            oPaginate: {
              sNext: '<span class="pagination-default">&#x276f;</span>',
              sPrevious: '<span class="pagination-default">&#x276e;</span>',
            },
          },
          initComplete: function (settings, json) {
            // Adjust hidden columns counter text in button -->
            $("#example").on(
              "column-visibility.dt",
              function (e, settings, column, state) {
                var index = hCols.indexOf(column);
                if (state === false) {
                  if (index === -1) {
                    hCols.push(column);
                  }
                }
                if (
                  $(".dt-button-collection.dropdown-menu.three-column")
                    .length === 1 &&
                  state === true
                ) {
                  if (index !== -1) {
                    hCols.splice(index, 1);
                  }
                }
                // var visCols = $('#example thead tr:first th').length;

                //Below: The minus 2 because of the 2 extra buttons Show all and Restore
                var tblCols =
                  $(".dt-button-collection li[aria-controls=example] a")
                    .length - 2;
                var visCols = tblCols - hCols.length;
                $(".buttons-colvis[aria-controls=example] span").html(
                  "Columnas (" + visCols + " de " + tblCols + ")"
                );
                e.stopPropagation();
              }
            );
          },
        });
      }, 2000);
      var l = Ladda.create(document.querySelector(".ladda-buttonC"));
      l.start();
      $scope.order = order;
      $scope.asc = asc;
      if (vm.form.dates_sel == undefined || vm.form.dates_sel == null) {
        l.stop();
        SweetAlert.swal(
          "Información",
          "Es necesario seleccionar una opción de Reporte por",
          "error"
        );
        return;
      }
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var created_at = toDate(vm.form.created_at).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }

      $scope.reporte = true;
      $scope.insurances = [];
      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.comision = 0;
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.programap) {
        if (vm.form.programap.val == "") {
          vm.form.programap.value = "";
          vm.form.programap.type = "";
        }
      }
      if (vm.form.subgroup) {
        if (vm.form.subgroup.id) {
          var g1 = vm.form.subgroup.id;
        } else {
          var g1 = 0;
        }
      }
      if (vm.form.subsubgroup) {
        if (vm.form.subsubgroup.id) {
          var g2 = vm.form.subsubgroup.id;
        } else {
          var g2 = 0;
        }
      } else {
        var g2 = 0;
      }
      if (vm.form.groupinglevel) {
        if (vm.form.groupinglevel.val) {
          var gl = vm.form.groupinglevel.value;
        } else {
          var gl = 0;
        }
      } else {
        var gl = 0;
      }
      if (vm.form.subgrouping) {
        if (vm.form.subgrouping.id) {
          var gl1 = vm.form.subgrouping.id;
        } else {
          var gl1 = 0;
        }
      } else {
        var gl1 = 0;
      }
      if (vm.form.subsubgrouping) {
        if (vm.form.subsubgrouping.id) {
          var gl2 = vm.form.subsubgrouping.id;
        } else {
          var gl2 = 0;
        }
      } else {
        var gl2 = 0;
      }

      var params = {
        provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider,
        ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
        subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
        status: vm.form.status.id ? vm.form.status.id : vm.form.status,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        programap: vm.programap ? vm.programap : 0,
        grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
        type_contractor: vm.form.contratante.type
          ? vm.form.contratante.type
          : 0,
        poliza: vm.form.num_fianza ? vm.form.num_fianza : 0,
        identifier: vm.form.identifier ? vm.form.identifier : 0,
        cve: vm.form.cve_agente ? vm.form.cve_agente : 0,
        ot: vm.form.ot_rep,
        order: order,
        asc: asc,
        page: parPage ? parPage : 1,
        pageE: parPageEnd ? parPageEnd : 1,
        group_by: vm.form.group_by ? vm.form.group_by.id : 0,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        claves: vm.claves_selected ? vm.claves_selected : 0,
        users: vm.usuarios_selected ? vm.usuarios_selected : 0,
        report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 0,
        classification: vm.form.classification.value
          ? vm.form.classification.value
          : vm.form.classification,
        subgrupo: g1 ? g1 : 0,
        subsubgrupo: g2 ? g2 : 0,
        groupinglevel: gl ? gl : 0,
        subgrupinglevel: gl1 ? gl1 : 0,
        subsubgrupinglevel: gl2 ? gl2 : 0,
        year_factura: vm.form.year_factura ? vm.form.year_factura : 0,
        month_factura: vm.form.month ? vm.form.month.month_selected : 0,
        beneficiary: vm.form.beneficiario ? vm.form.beneficiario.id : 0,
      };
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          params.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.beneficiario) {
        if (vm.form.beneficiario.val == "") {
          params.beneficiary = 0;
          vm.form.beneficiario.value = "";
          vm.form.beneficiario.type = "";
        }
      }
      if (vm.form.programap) {
        if (vm.form.programap.val == "") {
          params.programap = 0;
          vm.form.programap.value = "";
          vm.form.programap.type = "";
        }
      }
      if (vm.form.group) {
        if (vm.form.group.val == "") {
          params.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
      }

      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }

      params.celula = cel ? cel : 0;
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      $scope.filtros = params;

      $scope.search_fianza = "reporte-fianzas-rep/";
      $http({
        method: "POST",
        url: url.IP + $scope.search_fianza,
        data: params,
      }).then(function success(response) {
        $("#example").DataTable().clear();
        if (params.group_by == 0) {
          $scope.insurances = response.data.results;
          $scope.sumas = response.data.sumas;
          l.stop();

          for (var i = 0; i < $scope.insurances.length; i++) {
            $scope.insurances[i].document_type =
              $scope.insurances[i].document_type == 1
                ? "Póliza"
                : "Colectividad";
            if ($scope.insurances[i].document_type == "Póliza") {
              $scope.insurances[i].document_type =
                $scope.insurances[i].status == 1
                  ? "OT"
                  : $scope.insurances[i].status == 2
                  ? "OT"
                  : "Póliza";
            }
            $scope.insurances[i].forma_de_pago =
              $scope.insurances[i].forma_de_pago == 1
                ? "Mensual"
                : $scope.insurances[i].forma_de_pago == 2
                ? "Bimestral"
                : $scope.insurances[i].forma_de_pago == 3
                ? "Trimestral"
                : $scope.insurances[i].forma_de_pago == 5
                ? "Contado"
                : $scope.insurances[i].forma_de_pago == 6
                ? "Semestral"
                : "Anual";
          }

          $scope.count_insurances = angular.copy($scope.insurances);
          if ($scope.insurances.length < 10) {
            for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
              var object = {
                contratante: " ",
                fianza_number: " ",
                aseguradora: " ",
                ramo: " ",
                subramo: " ",
                paquete: " ",
                prima_neta: null,
                rpf: null,
                derecho: null,
                iva: null,
                prima_total: null,
                comision: null,
                forma_de_pago: " ",
                document_type: " ",
                status: " ",
                start_of_validity: " ",
                folio: " ",
                f_currency: " ",
                observations: " ",
                created_at: " ",
                clave: " ",
                bono_variable: "",
                monto_afianzado: "",
              };
              $scope.insurances.push(object);
            }
          }

          $scope.policy_config = {
            count: response.data.count,
            previous: response.data.previous,
            next: response.data.next,
          };
          vm.show_pag_policy = true;
          $scope.obtenerPaginacion(response.data, parPage ? parPage : 1);
          // testPagination('insurances', 'policy_config');
          if ($scope.insurances[0].fianza_number == " ") {
            toaster.warning("No se encontraron registros");
            $("#example").DataTable().clear();
            $("#example").DataTable().draw();
            $("#example").DataTable().destroy();
          } else {
            $scope.showButtonExcel = true;
            $scope.showSums = true;
          }
        } else {
          l.stop();
          $scope.grupos_result = response.data;
          $scope.showButtonExcel = true;
        }
        $("#example").DataTable().destroy();
      });

      $localStorage.saved_filters_reporte_fianza = angular.copy(params);
      $localStorage.saved_filters_reporte_fianza["num_fianza"] =
        vm.form.num_poliza;
      $localStorage.saved_filters_reporte_fianza["identifier"] =
        vm.form.identifier;
      $localStorage.saved_filters_reporte_fianza["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_reporte_fianza["classification"] =
        vm.form.classification;
      $localStorage.saved_filters_reporte_fianza["group"] = vm.form.group;
      $localStorage.saved_filters_reporte_fianza["groupinglevel"] =
        vm.form.groupinglevel;
      $localStorage.saved_filters_reporte_fianza["celula"] = vm.form.celula;
      $localStorage.saved_filters_reporte_fianza["status"] = vm.form.status;
      $localStorage.saved_filters_reporte_fianza["cve_agente"] =
        vm.form.cve_agente;
      $localStorage.saved_filters_reporte_fianza["group_by"] = vm.form.group_by;
      $localStorage.saved_filters_reporte_fianza["dates_sel"] =
        vm.form.dates_sel;
      $localStorage.saved_filters_reporte_fianza["programap"] =
        vm.form.programap;
      $localStorage.saved_filters_reporte_fianza["ot_rep"] = $scope.ot_rep;
    }
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      savedFiltersFianza["page"] = pagina;
      vm.Generar(
        savedFiltersFianza && savedFiltersFianza["order"]
          ? savedFiltersFianza["order"]
          : 1,
        savedFiltersFianza && savedFiltersFianza["asc"]
          ? savedFiltersFianza["asc"]
          : 1,
        pagina
      );
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        savedFiltersFianza["page"] = $scope.paginacion["paginaActual"] - 1;
        vm.Generar(
          savedFiltersFianza && savedFiltersFianza["order"]
            ? savedFiltersFianza["order"]
            : 1,
          savedFiltersFianza && savedFiltersFianza["asc"]
            ? savedFiltersFianza["asc"]
            : 1,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        savedFiltersFianza["page"] = $scope.paginacion["paginaActual"] + 1;
        vm.Generar(
          savedFiltersFianza && savedFiltersFianza["order"]
            ? savedFiltersFianza["order"]
            : 1,
          savedFiltersFianza && savedFiltersFianza["asc"]
            ? savedFiltersFianza["asc"]
            : 1,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };
    function EndososLista(parPageEnd) {
      var l = Ladda.create(document.querySelector(".ladda-buttonC"));
      l.start();
      $scope.order = 1;
      $scope.asc = 1;
      if (vm.form.dates_sel == undefined || vm.form.dates_sel == null) {
        l.stop();
        SweetAlert.swal(
          "Información",
          "Es necesario seleccionar una opción de Reporte por",
          "error"
        );
        return;
      }
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var created_at = toDate(vm.form.created_at).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }

      $scope.reporte = true;
      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.comision = 0;
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.programap) {
        if (vm.form.programap.val == "") {
          vm.form.programap.value = "";
          vm.form.programap.type = "";
        }
      }
      if (vm.form.subgroup) {
        if (vm.form.subgroup.id) {
          var g1 = vm.form.subgroup.id;
        } else {
          var g1 = 0;
        }
      }
      if (vm.form.subsubgroup) {
        if (vm.form.subsubgroup.id) {
          var g2 = vm.form.subsubgroup.id;
        } else {
          var g2 = 0;
        }
      } else {
        var g2 = 0;
      }
      if (vm.form.groupinglevel) {
        if (vm.form.groupinglevel.val) {
          var gl = vm.form.groupinglevel.value;
        } else {
          var gl = 0;
        }
      } else {
        var gl = 0;
      }
      if (vm.form.subgrouping) {
        if (vm.form.subgrouping.id) {
          var gl1 = vm.form.subgrouping.id;
        } else {
          var gl1 = 0;
        }
      } else {
        var gl1 = 0;
      }
      if (vm.form.subsubgrouping) {
        if (vm.form.subsubgrouping.id) {
          var gl2 = vm.form.subsubgrouping.id;
        } else {
          var gl2 = 0;
        }
      } else {
        var gl2 = 0;
      }

      var params = {
        provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider,
        ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
        subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
        status: vm.form.status.id ? vm.form.status.id : vm.form.status,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        programap: vm.programap ? vm.programap : 0,
        grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
        type_contractor: vm.form.contratante.type
          ? vm.form.contratante.type
          : 0,
        poliza: vm.form.num_fianza ? vm.form.num_fianza : 0,
        identifier: vm.form.identifier ? vm.form.identifier : 0,
        cve: vm.form.cve_agente ? vm.form.cve_agente : 0,
        ot: vm.form.ot_rep,
        order: 1,
        asc: 1,
        page: $scope.parPageF ? $scope.parPageF : 1,
        pageE: parPageEnd ? parPageEnd : 1,
        group_by: vm.form.group_by ? vm.form.group_by.id : 0,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        claves: vm.claves_selected ? vm.claves_selected : 0,
        users: vm.usuarios_selected ? vm.usuarios_selected : 0,
        report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 0,
        classification: vm.form.classification.value
          ? vm.form.classification.value
          : vm.form.classification,
        subgrupo: g1 ? g1 : 0,
        subsubgrupo: g2 ? g2 : 0,
        groupinglevel: gl ? gl : 0,
        subgrupinglevel: gl1 ? gl1 : 0,
        subsubgrupinglevel: gl2 ? gl2 : 0,
        year_factura: vm.form.year_factura ? vm.form.year_factura : 0,
        month_factura: vm.form.month ? vm.form.month.month_selected : 0,
        beneficiary: vm.form.beneficiario ? vm.form.beneficiario.id : 0,
      };
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          params.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.beneficiario) {
        if (vm.form.beneficiario.val == "") {
          params.beneficiary = 0;
          vm.form.beneficiario.value = "";
          vm.form.beneficiario.type = "";
        }
      }
      if (vm.form.programap) {
        if (vm.form.programap.val == "") {
          params.programap = 0;
          vm.form.programap.value = "";
          vm.form.programap.type = "";
        }
      }
      if (vm.form.group) {
        if (vm.form.group.val == "") {
          params.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
      }

      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }

      params.celula = cel ? cel : 0;
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      $scope.filtros = params;

      $scope.search_fianza = "reporte-fianzas-rep/";
      $http({
        method: "POST",
        url: url.IP + $scope.search_fianza,
        data: params,
      }).then(function success(response) {
        if (params.group_by == 0) {
          $scope.endosos = response.data.endosos;
          l.stop();
          $scope.endoso_config = {
            count: response.data.countendosos,
            previous: response.data.previous,
            next: response.data.next,
          };
          vm.show_pag_endosos = true;
          testPaginationEndosos("endosos", "endoso_config");

          $scope.showButtonExcel = true;
          $scope.showSums = true;
        }
      });
    }
    function goToInfo(insurance) {
      if (insurance.document_type == 8) {
        var name = "Información fianza";
        var route = "fianzas.details";
      } else {
        var name = "Información fianza";
        var route = "fianzas.info";
      }
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      if (insurance.document_type == 8) {
        $state.go("fianzas.details", { polizaId: insurance.id });
      } else {
        $state.go("fianzas.info", { polizaId: insurance.id });
      }
    }

    $scope.monthEmision = function (parConcept) {
      switch (parConcept) {
        case 0:
          return "";
          break;
        case 1:
          return "Enero";
          break;
        case 2:
          return "Febrero";
          break;
        case 3:
          return "Marzo";
          break;
        case 4:
          return "Abril";
          break;
        case 5:
          return "Mayo";
          break;
        case 6:
          return "Junio";
          break;
        case 7:
          return "Julio";
          break;
        case 8:
          return "Agosto";
          break;
        case 9:
          return "Septiembre";
          break;
        case 10:
          return "Octubre";
          break;
        case 11:
          return "Noviembre";
          break;
        case 12:
          return "Diciembre";
          break;
        default:
          return "";
      }
    };
    function getProviders() {
      providerService.getProviderFiByKey(date).then(
        function success(data) {
          vm.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }
    $scope.addBitEndoso = function (param) {
      $scope.addBitacoraEndoso = param;
    };
    $scope.exportDataExcel = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            // templateUrl: 'app/reportes/reportexcel.option.html',
            // controller: 'ReportExcelByCtrl',
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "md",
            resolve: {
              filters: function () {
                return $scope.filtros;
              },
              from: function () {
                return null;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.filtros.orden = $scope.columnArray;
        $scope.filtros.excel_type = 2;
        var $listM = $("#example th")
          .map(function () {
            return $.trim($(this).text());
          })
          .get();

        if ($listM.includes("FIADO")) {
          $listM.push("FIADO");
        }
        if ($listM.includes("NO. FIANZA")) {
          $listM.push("NO. FIANZA");
        }
        if ($listM.includes("AFIANZADORA")) {
          $listM.push("AFIANZADORA");
        }
        if ($listM.includes("RAMO")) {
          $listM.push("RAMO");
        }
        if ($listM.includes("SUBRAMO")) {
          $listM.push("SUBRAMO");
        }
        if ($listM.includes("ESTATUS EMISIÓN")) {
          $listM.push("ESTATUS EMISIÓN");
        }
        if ($listM.includes("PRIMA NETA")) {
          $listM.push("PRIMA NETA");
        }
        if ($listM.includes("GASTOS EXPEDICIÓN")) {
          $listM.push("GASTOS EXPEDICIÓN");
        }
        if ($listM.includes("DERECHO")) {
          $listM.push("DERECHO");
        }
        if ($listM.includes("IVA")) {
          $listM.push("IVA");
        }
        if ($listM.includes("PRIMA TOTAL")) {
          $listM.push("PRIMA TOTAL");
        }
        if ($listM.includes("COMISIÓN")) {
          $listM.push("COMISIÓN");
        }
        if ($listM.includes("ESTATUS")) {
          $listM.push("ESTATUS");
        }
        if ($listM.includes("FECHA CREACIÓN")) {
          $listM.push("FECHA CREACIÓN");
        }
        if ($listM.includes("TIPO FIANZA")) {
          $listM.push("TIPO FIANZA");
        }
        if ($listM.includes("Vigencia")) {
          $listM.push("VIGENCIA INICIO");
          $listM.push("VIGENCIA FIN");
        }
        if ($listM.includes("FOLIO")) {
          $listM.push("FOLIO");
        }
        if ($listM.includes("% TARIFA AFIANZADA")) {
          $listM.push("% TARIFA AFIANZADA");
        }
        if ($listM.includes("CREADOR POR")) {
          $listM.push("CREADOR POR");
        }
        if ($listM.includes("CLAVE AFIANZADORA")) {
          $listM.push("CLAVE AFIANZADORA");
        }
        if ($listM.includes("MONTO TOTAL")) {
          $listM.push("MONTO TOTAL");
        }
        if ($listM.includes("% GARANTÍA")) {
          $listM.push("% GARANTÍA");
        }
        if ($listM.includes("NÚM CONTRATO")) {
          $listM.push("NÚM CONTRATO");
        }
        if ($listM.includes("PROYECTO")) {
          $listM.push("PROYECTO");
        }
        if ($listM.includes("MONTO AFIANZADO")) {
          $listM.push("MONTO AFIANZADO");
        }
        if ($listM.includes("GRUPO")) {
          $listM.push("GRUPO");
        }
        if ($listM.includes("Subgrupo")) {
          $listM.push("Subgrupo");
        }
        if ($listM.includes("Subsubgrupo")) {
          $listM.push("Subsubgrupo");
        }
        if ($listM.includes("Agrupación")) {
          $listM.push("Agrupación");
        }
        if ($listM.includes("Subagrupación")) {
          $listM.push("Subagrupación");
        }
        if ($listM.includes("Subsubagrupación")) {
          $listM.push("Subsubagrupación");
        }
        if ($listM.includes("Clasificación")) {
          $listM.push("Clasificación");
        }
        if ($listM.includes("Célula")) {
          $listM.push("Célula");
        }
        if ($listM.includes("Monto del contrato con IVA")) {
          $listM.push("Monto del contrato con IVA");
        }
        if ($listM.includes("NOMBRE DEL BENEFICIARIO")) {
          $listM.push("NOMBRE DEL BENEFICIARIO");
        }
        if ($listM.includes("RFC BENEFICIARIO")) {
          $listM.push("RFC BENEFICIARIO");
        }
        if ($listM.includes("Bono Afianzadora")) {
          $listM.push("Bono Afianzadora");
        }
        if ($listM.includes("Fecha Bono")) {
          $listM.push("Fecha Bono");
        }
        if ($listM.includes("PROGRAMA DE PROVEEDORES")) {
          $listM.push("PROGRAMA DE PROVEEDORES");
        }
        if ($listM.includes("(NOMBRE) PROGRAMA DE PROVEEDORES")) {
          $listM.push("(NOMBRE) PROGRAMA DE PROVEEDORES");
        }
        if ($listM.includes("MONEDA")) {
          $listM.push("MONEDA");
        }
        if ($listM.includes("FECHA DE EMISION")) {
          $listM.push("FECHA DE EMISION");
        }
        if ($listM.includes("MONTO DE CANCELACION")) {
          $listM.push("MONTO DE CANCELACION");
        }
        if ($listM.includes("FECHA DE CANCELACION")) {
          $listM.push("FECHA DE CANCELACION");
        }
        if ($listM.includes("FECHA DE PAGO COMISIÓN")) {
          $listM.push("FECHA DE PAGO COMISIÓN");
        }
        if ($listM.includes("MAQUILA")) {
          $listM.push("MAQUILA");
        }
        if ($listM.includes("FECHA MAQUILA")) {
          $listM.push("FECHA MAQUILA");
        }
        if ($listM.includes("TIPO CAMBIO (CAPTURA)")) {
          $listM.push("TIPO CAMBIO (CAPTURA)");
        }
        if ($listM.includes("FECHA EMISIÓN FACTURA")) {
          $listM.push("FECHA EMISIÓN FACTURA");
        }
        if ($listM.includes("MES EMISIÓN PRODUCCIÓN")) {
          $listM.push("MES EMISIÓN PRODUCCIÓN");
        }
        if ($listM.includes("AÑO EMISIÓN PRODUCCIÓN")) {
          $listM.push("AÑO EMISIÓN PRODUCCIÓN");
        }
        if ($listM.includes("ENDOSOS TOTALES")) {
          $listM.push("ENDOSOS TOTALES");
        }
        if ($listM.includes("FOLIO FACTURA")) {
          $listM.push("FOLIO FACTURA");
        }
        if ($listM.includes("PLAZO DEL DOCUMENTO FUENTE")) {
          $listM.push("PLAZO INICIO DEL DOCUMENTO FUENTE");
        }
        if ($listM.includes("PLAZO DEL DOCUMENTO FUENTE")) {
          $listM.push("PLAZO FIN DEL DOCUMENTO FUENTE");
        }

        var scolumns = [
          "FIADO",
          "NO. FIANZA",
          "AFIANZADORA",
          "RAMO",
          "SUBRAMO",
          "ESTATUS EMISIÓN",
          "PRIMA NETA",
          "GASTOS EXPEDICIÓN",
          "DERECHO",
          "IVA",
          "PRIMA TOTAL",
          "COMISIÓN",
          "ESTATUS",
          "FECHA CREACIÓN",
          "TIPO FIANZA",
          "VIGENCIA INICIO",
          "VIGENCIA FIN",
          "FOLIO",
          "% TARIFA AFIANZADA",
          "CREADOR POR",
          "CLAVE AFIANZADORA",
          "MONTO TOTAL",
          "% GARANTÍA",
          "NÚM CONTRATO",
          "PROYECTO",
          "MONTO AFIANZADO",
          "GRUPO",
          "Subgrupo",
          "Subsubgrupo",
          "Agrupación",
          "Subagrupación",
          "Subsubagrupación",
          "Clasificación",
          "Célula",
          "Monto del contrato con IVA",
          "NOMBRE BENEFICIARIO",
          "RFC BENEFICIARIO",
          "Bono Afianzadora",
          "Fecha Bono",
          "PROGRAMA DE PROVEEDORES",
          "(NOMBRE) PROGRAMA DE PROVEEDORES",
          "MONEDA",
          "FECHA DE EMISION",
          "MONTO DE CANCELACION",
          "FECHA DE CANCELACION",
          "FECHA DE PAGO COMISIÓN",
          "MAQUILA",
          "FECHA MAQUILA",
          "TIPO CAMBIO (CAPTURA)",
          "FECHA EMISIÓN FACTURA",
          "MES EMISIÓN PRODUCCIÓN",
          "AÑO EMISIÓN PRODUCCIÓN",
          "FOLIO FACTURA",
          "PLAZO INICIO DEL DOCUMENTO FUENTE",
          "PLAZO FIN DEL DOCUMENTO FUENTE",
          "ENDOSOS TOTALES",
        ];
        var foo = [];

        $.grep(scolumns, function (el) {
          if ($.inArray(el, $listM) != -1) {
            foo.push(el);
          }
        });
        $scope.filtros["cols1"] = foo;
        $scope.filtros["addBitacora"] = $scope.addBitacoraEndoso;
        if (param == 1) {
          $scope.excel_fianza = "service_reporte-fianzasReport-excel";
          $http({
            method: "POST",
            url: url.IP + $scope.excel_fianza,
            data: $scope.filtros,
            headers: {
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "arraybuffer",
          })
            .then(function (data, status, headers, config) {
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Fianzas.xls");
              l.stop();
            })
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };
    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      vm.form.subgroup = 0;
      vm.form.subsubgroup = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        if (vm.form.group.val) {
          var word_data = vm.form.group.val;
        }
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  $scope.subgroups = item.subgrupos;
                  $scope.subsubgroups = [];
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }
    function matchesGroupinglevel(parWord, parType) {
      $scope.subgrouping = [];
      $scope.subsubgrouping = [];
      $scope.groupunglevels_data = 0;
      vm.form.subgrouping = 0;
      vm.form.subsubgrouping = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.groupinglevel.val) {
        var word_data = vm.form.groupinglevel.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_grouping = "groupinglevel-match/";

          $http
            .post(url.IP + $scope.show_grouping, {
              matchWord: parWord,
            })
            .then(function (response) {
              // if(response.status === 200 ) {
              //     var source = [];
              //     var groupinglevels = response.data ? response.data : [];
              //     groupinglevels.forEach(function(item) {
              //         $scope.subgrouping = item.subgrupos;
              //         $scope.subsubgrouping = []
              //         $scope.subgrouping.forEach(function(itm) {
              //           $scope.subsubgrouping = itm.subsubgrupos
              //         });
              //         var obj = {
              //            label: item.description,
              //            value: item.id,
              //         };
              //         source.push(obj);
              //     });
              //     $scope.groupinglevels_data = source;
              // }
              if (response.status === 200) {
                var source = [];
                var groupinglevels = response.data ? response.data : [];
                groupinglevels.forEach(function (item) {
                  $scope.subsubgrouping = [];
                  $scope.subgrouping.forEach(function (itm) {
                    $scope.subsubgrouping = itm.subsubgrupos;
                  });
                  var obj = {
                    label: item.description,
                    value: item.id,
                    url: item.url,
                    subgrupos: item.subgrupos,
                  };
                  source.push(obj);
                });

                $scope.groupinglevels_data = source;
              }
            });
        }
      }
    }
    // --GroupingLevel
    // classification
    function matchesClassification(parWord, parType) {
      $scope.classification_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.classification.val) {
        var word_data = vm.form.classification.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_claass = "classification-match/";

          $http
            .post(url.IP + $scope.show_claass, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var classifica = response.data;
                if (classifica.length) {
                  classifica.forEach(function (item) {
                    var obj = {
                      label: item.classification_name,
                      value: item.id,
                    };
                    source.push(obj);
                  });
                  $scope.classification_data = source;
                }
              }
            });
        }
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }
    function matchesPrograma(parWord) {
      $scope.show_contrata = "contractors-pp-fianzas/";
      $http
        .post(url.IP + $scope.show_contrata, {
          matchWord: parWord,
          poliza: false,
          pp: true,
        })
        .then(function (response) {
          if (response.status === 200 && response.data != 404) {
            var source = [];
            var contratactorsFound = response.data.contractors;
            if (contratactorsFound.length) {
              contratactorsFound.forEach(function (item) {
                if (item.full_name) {
                  var obj = {
                    label: item.full_name,
                    value: item,
                  };
                } else {
                  var obj = {
                    label:
                      item.first_name +
                      " " +
                      item.last_name +
                      " " +
                      item.second_last_name,
                    value: item,
                  };
                }
                source.push(obj);
              });
            }
            $scope.contractors_datapp = source;
          }
        });
    }

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            console.log("ramos", obj.id, response.data);
            vm.ramos = response.data;
          });
      }
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo/" + vm.id, sel)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.id);
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };
    $scope.selectedPP = function (sel) {
      vm.programap = [];
      sel.forEach(function (cl) {
        vm.programap.push(cl.value.id);
      });
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };
    $scope.statusEndoso = function (param) {
      switch (param) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Registrado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado";
          break;
        case 5:
          return "En trámite";
          break;
        default:
          return "Pendiente";
      }
    };
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 718,
          subramo_name: "Individual",
        },
        {
          id: 719,
          subramo_name: "Colectivas",
        },
        {
          id: 720,
          subramo_name: "Penales",
        },
        {
          id: 721,
          subramo_name: "No penales",
        },
        {
          id: 722,
          subramo_name: "Amparo a conductores",
        },
        {
          id: 723,
          subramo_name: "Obra",
        },
        {
          id: 724,
          subramo_name: "Proveeduria",
        },
        {
          id: 725,
          subramo_name: "Fiscales",
        },
        {
          id: 726,
          subramo_name: "Arrendamiento",
        },
        {
          id: 727,
          subramo_name: "Otras",
        },
        {
          id: 728,
          subramo_name: "Suministro",
        },
        {
          id: 729,
          subramo_name: "Compra Venta",
        },
        {
          id: 730,
          subramo_name: "Otras",
        },
        {
          id: 731,
          subramo_name: "Relación con fianza",
        },
        {
          id: 732,
          subramo_name: "Sin relación con fianza",
        },
      ];
    }
    $scope.actual_page = 1;

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getPolicyPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              $scope.data_pagination = request.data.results;
              for (var i = 0; i < $scope.data_pagination.length; i++) {
                $scope.data_pagination[i].document_type =
                  $scope.data_pagination[i].document_type == 1
                    ? "Póliza"
                    : "Colectividad";
                if ($scope.data_pagination[i].document_type == "Póliza") {
                  $scope.data_pagination[i].document_type =
                    $scope.data_pagination[i].status == 1
                      ? "OT"
                      : $scope.data_pagination[i].status == 2
                      ? "OT"
                      : "Póliza";
                }
                $scope.data_pagination[i].forma_de_pago =
                  $scope.data_pagination[i].forma_de_pago == 1
                    ? "Mensual"
                    : $scope.data_pagination[i].forma_de_pago == 2
                    ? "Bimestral"
                    : $scope.data_pagination[i].forma_de_pago == 3
                    ? "Trimestral"
                    : $scope.data_pagination[i].forma_de_pago == 5
                    ? "Contado"
                    : $scope.data_pagination[i].forma_de_pago == 6
                    ? "Semestral"
                    : "Anual";
                $scope.data_pagination[i].status =
                  $scope.data_pagination[i].status == 1
                    ? "En trámite"
                    : $scope.data_pagination[i].status == 2
                    ? "OT Cancelada"
                    : $scope.data_pagination[i].status == 10
                    ? "Por Iniciar"
                    : $scope.data_pagination[i].status == 11
                    ? "Cancelada"
                    : $scope.data_pagination[i].status == 12
                    ? "Renovada"
                    : $scope.data_pagination[i].status == 13
                    ? "Vencida"
                    : $scope.data_pagination[i].status == 15
                    ? "No renovada"
                    : "Vigente";
                $scope.data_pagination[i].f_currency =
                  $scope.data_pagination[i].f_currency == 1
                    ? "Pesos"
                    : "Dolares";
              }
              $scope.count_pagination = angular.copy($scope.data_pagination);
              if ($scope.data_pagination.length < 10) {
                for (var i = 0; i < 10 - $scope.count_pagination.length; i++) {
                  var object = {
                    fianza_number: " ",
                    document_type: " ",
                    natural: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    paquete: " ",
                    forma_de_pago: " ",
                    status: " ",
                    start_of_validity: " ",
                    created_at: " ",
                    folio: " ",
                    f_currency: " ",
                    prima_neta: null,
                    rpf: null,
                    derecho: null,
                    iva: null,
                    prima_total: null,
                    comision: null,
                    observations: " ",
                    clave: " ",
                  };
                  $scope.data_pagination.push(object);
                }
              }

              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }

    function testPaginationEndosos(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPagesE = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesE.push(i + 1);
      }

      $scope.lastPageE = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesE.length > 5) {
          $scope.end = $scope.totalPagesE.length;
          $scope.start = $scope.totalPagesE.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPageE($scope.totalPagesE.length);

        // $scope.actual_page = $scope.totalPagesE.length;
      };

      $scope.selectPageE = function (parPage) {
        $scope.actual_pageE = parPage;
        vm.EndososLista(parPage);
      };

      $scope.previousBlockPagesE = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_pageE) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesE.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesE = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_pageE) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesE.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesE.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getPolicyPagE(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              $scope.data_paginationendosos = request.data.endosos;
              $scope.count_pagination = angular.copy(
                $scope.data_paginationendosos
              );
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.endosos);

              var data1 = {
                count: request.data.count1,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config1 = $parse(parConfig);
              config1.assign($scope, []);
              config1.assign($scope, data1);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }
    jQuery(function ($) {
      $("#exportButton").click(function () {
        // parse the HTML table element having an id=exportTable
        var dataSource = shield.DataSource.create({
          data: "#exportTable",
          schema: {
            type: "table",
            fields: {
              Recibo: { type: String },
              RPF: { type: Number },
              Estatus: { type: String },
            },
          },
        });

        // when parsing is done, export the data to PDF
        dataSource.read().then(function (data) {
          var pdf = new shield.exp.PDFDocument({
            author: "PrepBootstrap",
            created: new Date(),
          });

          pdf.addPage("a4", "portrait");

          pdf.table(
            50,
            50,
            data,
            [
              { field: "Recibo", title: "Número de Recibo", width: 200 },
              { field: "RPF", title: "RPF", width: 50 },
              { field: "Estatus", title: "Estatus del recibo", width: 200 },
            ],
            {
              margins: {
                top: 50,
                left: 50,
              },
            }
          );

          pdf.saveAs({
            fileName: "ReporteFianzas",
          });
        });
      });
    });

    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      $scope.infoUser = $sessionStorage.infoUser;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      console.log("ssss", decryptedUser, decryptedToken);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        var param = 1;
        if (option) {
          // Totales de la Agrupación
          var filter_fianzas = "service_reporte-fianzasReport-excel";
          if (option == 1) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            filters.excel_type = option;
            $http({
              method: "POST",
              url: url.IP + filter_fianzas,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Fianzas.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          } else if (option == 2) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            filters.excel_type = option;
            $http({
              method: "POST",
              url: url.IP + filter_fianzas,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Fianzas.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteEndososController", ReporteEndososController);

  ReporteEndososController.$inject = [
    "dataFactory",
    "appStates",
    "MESSAGES",
    "$state",
    "SweetAlert",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$parse",
    "exportFactory",
    "$uibModal",
    "$sessionStorage",
    "$localStorage",
  ];

  function ReporteEndososController(
    dataFactory,
    appStates,
    MESSAGES,
    $state,
    SweetAlert,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $parse,
    exportFactory,
    $uibModal,
    $sessionStorage,
    $localStorage
  ) {
    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? -1 : str1 > str2 ? 1 : 0;
      },

      "non-empty-string-desc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? 1 : str1 > str2 ? -1 : 0;
      },
    });
    var hCols = [];
    var paso = 0;
    var savedFiltersEndoso = {};
    $scope.$on("ngRepeatFinished", function () {
      paso++;
      // console.log("hola");
      // $('#example').DataTable().draw();

      //Only needed for the filename of export files.
      //Normally set in the title tag of your page.document.title = 'Simple DataTable';
      //Define hidden columns
      $("#example").DataTable().destroy();
      // DataTable initialisation
      $("#example").DataTable({
        dom:
          "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-12'p<br/>i>>",
        info: false,
        paging: false,
        autoWidth: true,
        columnDefs: [
          {
            visible: false,
            targets: hCols,
          },
          {
            type: "non-empty-string",
            targets: 0,
          },
        ],
        buttons: [
          {
            extend: "colvis",
            collectionLayout: "three-column",
            text: function () {
              var totCols = $("#example thead th").length;
              var hiddenCols = hCols.length;
              var shownCols = totCols - hiddenCols;
              return "Columnas (" + shownCols + " de " + totCols + ")";
            },
            prefixButtons: [
              {
                extend: "colvisGroup",
                text: "Mostrar todo",
                show: ":hidden",
              },
              {
                extend: "colvisRestore",
                text: "Restaurar",
              },
            ],
          },
        ],
        oLanguage: {
          oPaginate: {
            sNext: '<span class="pagination-default">&#x276f;</span>',
            sPrevious: '<span class="pagination-default">&#x276e;</span>',
          },
        },
        initComplete: function (settings, json) {
          // Adjust hidden columns counter text in button -->
          $("#example").on(
            "column-visibility.dt",
            function (e, settings, column, state) {
              var index = hCols.indexOf(column);
              if (state === false) {
                if (index === -1) {
                  hCols.push(column);
                }
              }
              if (
                $(".dt-button-collection.dropdown-menu.three-column").length ===
                  1 &&
                state === true
              ) {
                // console.log($('.dt-button-collection.dropdown-menu.three-column').length);
                if (index !== -1) {
                  hCols.splice(index, 1);
                }
                // console.log("si entro");
              }
              // var visCols = $('#example thead tr:first th').length;

              //Below: The minus 2 because of the 2 extra buttons Show all and Restore
              var tblCols =
                $(".dt-button-collection li[aria-controls=example] a").length -
                2;
              var visCols = tblCols - hCols.length;
              $(".buttons-colvis[aria-controls=example] span").html(
                "Columnas (" + visCols + " de " + tblCols + ")"
              );
              e.stopPropagation();
            }
          );
        },
      });
    });

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.orgName = usr.orgname;
    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];
    vm.status = [
      {
        id: 1,
        name: "Pendiente",
      },
      {
        id: 5,
        name: "En trámite",
      },
      {
        id: 2,
        name: "Registrado",
      },
      {
        id: 3,
        name: "Rechazado",
      },
      {
        id: 4,
        name: "Cancelado",
      },
      {
        id: 6,
        name: "Anulado",
      },
    ];

    vm.type = [
      {
        id: "A",
        name: "A",
      },
      {
        id: "B",
        name: "B",
      },
      {
        id: "D",
        name: "D",
      },
    ];

    vm.tipo_report = [
      {
        id: 0,
        name: "Seguros / Fianzas",
      },
      {
        id: 1,
        name: "Seguros",
      },
      {
        id: 2,
        name: "Fianzas",
      },
    ];

    vm.group_by = [
      {
        id: 1,
        name: "Aseguradora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 6,
        name: "Estatus",
      },
      {
        id: 7,
        name: "Usuario",
      },
    ];

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.Generar = Generar;
    vm.table = {};
    vm.changeUntil = changeUntil;
    vm.matchesContractors = matchesContractors;
    vm.changeEndoso = changeEndoso;
    vm.formatearNumero = formatearNumero;
    vm.accesos = $sessionStorage.permisos;
    vm.changeBLine = changeBLine;
    function changeBLine(obj) {
      $scope.bLine = obj;
      if (obj) {
        vm.form.businesLine = obj;
      } else {
        vm.form.businesLine = 0;
      }
    }
    vm.businesLine = [
      {
        id: 1,
        name: "Comercial",
      },
      {
        id: 2,
        name: "Personal",
      },
      {
        id: 3,
        name: "Otro",
      },
    ];
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }

    $scope.open_in_same_tab_natural = function (
      name,
      route,
      params,
      identifier
    ) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      // $localStorage.tab_index = $localStorage.tab_states.length -1;
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.goToInfo = function (id) {
      if (vm.acceso_ver_ot) {
        if (id) {
          $scope.open_in_same_tab_natural(
            "Información endosos",
            "endorsement.info",
            { endosoId: id },
            id
          );
          // $state.go('endorsement.info', {endosoId: id})
        }
      }
    };
    $scope.status = function (parSttaus) {
      switch (parSttaus) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Registrado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado";
          break;
        case 5:
          return "En trámite";
          break;
      }
    };

    vm.table = {
      headers: [
        "No.Endoso",
        "Folio Endoso",
        "Estatus",
        "Fecha de Inicio",
        "Tipo de Endoso",
        "Número de Póliza",
        "Contratante",
        "Aseguradora",
        "Subramo",
        "Descripción",
        "Creado por",
      ],
    };

    $(".js-example-basic-multiple").select2();

    $scope.columnArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };

    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };
    $scope.currentColumn = function (column, event) {
      try {
        $scope.currentPosition = event.originalEvent.path[0].cellIndex;
      } catch (o) {
        $scope.currentPosition = 0;
      }
    };

    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      try {
        $scope.position = event.path[0].cellIndex;
      } catch (o) {
        $scope.position = 0;
      }
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };

    function changeEndoso(par, asc) {
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.endoso_num_asc = asc;
          vm.endoso_folio_asc = 0;
          vm.endoso_status_asc = 0;
          vm.endoso_fecha_asc = 0;
          vm.endoso_tipo_asc = 0;
          vm.endoso_nump_asc = 0;
          vm.endoso_cont_asc = 0;
          vm.endoso_aseg_asc = 0;
          vm.endoso_subramo_asc = 0;
          vm.endoso_desc_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.endoso_num_asc = 0;
          vm.endoso_folio_asc = asc;
          vm.endoso_status_asc = 0;
          vm.endoso_fecha_asc = 0;
          vm.endoso_tipo_asc = 0;
          vm.endoso_nump_asc = 0;
          vm.endoso_cont_asc = 0;
          vm.endoso_aseg_asc = 0;
          vm.endoso_subramo_asc = 0;
          vm.endoso_desc_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.endoso_status_asc = asc;
          vm.endoso_folio_asc = 0;
          vm.endoso_num_asc = 0;
          vm.endoso_fecha_asc = 0;
          vm.endoso_tipo_asc = 0;
          vm.endoso_nump_asc = 0;
          vm.endoso_cont_asc = 0;
          vm.endoso_aseg_asc = 0;
          vm.endoso_subramo_asc = 0;
          vm.endoso_desc_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.endoso_fecha_asc = asc;
          vm.endoso_folio_asc = 0;
          vm.endoso_num_asc = 0;
          vm.endoso_status_asc = 0;
          vm.endoso_tipo_asc = 0;
          vm.endoso_nump_asc = 0;
          vm.endoso_cont_asc = 0;
          vm.endoso_aseg_asc = 0;
          vm.endoso_subramo_asc = 0;
          vm.endoso_desc_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.endoso_tipo_asc = asc;
          vm.endoso_folio_asc = 0;
          vm.endoso_num_asc = 0;
          vm.endoso_status_asc = 0;
          vm.endoso_fecha_asc = 0;
          vm.endoso_nump_asc = 0;
          vm.endoso_cont_asc = 0;
          vm.endoso_aseg_asc = 0;
          vm.endoso_subramo_asc = 0;
          vm.endoso_desc_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.endoso_nump_asc = asc;
          vm.endoso_folio_asc = 0;
          vm.endoso_num_asc = 0;
          vm.endoso_status_asc = 0;
          vm.endoso_fecha_asc = 0;
          vm.endoso_tipo_asc = 0;
          vm.endoso_cont_asc = 0;
          vm.endoso_aseg_asc = 0;
          break;
        case 7:
          Generar(par, asc);
          vm.endoso_cont_asc = asc;
          vm.endoso_folio_asc = 0;
          vm.endoso_num_asc = 0;
          vm.endoso_status_asc = 0;
          vm.endoso_fecha_asc = 0;
          vm.endoso_tipo_asc = 0;
          vm.endoso_nump_asc = 0;
          vm.endoso_aseg_asc = 0;
          vm.endoso_subramo_asc = 0;
          vm.endoso_desc_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.endoso_cont_asc = 0;
          vm.endoso_folio_asc = 0;
          vm.endoso_num_asc = 0;
          vm.endoso_status_asc = 0;
          vm.endoso_fecha_asc = 0;
          vm.endoso_tipo_asc = 0;
          vm.endoso_nump_asc = 0;
          vm.endoso_aseg_asc = asc;
          vm.endoso_subramo_asc = 0;
          vm.endoso_desc_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.endoso_cont_asc = 0;
          vm.endoso_folio_asc = 0;
          vm.endoso_num_asc = 0;
          vm.endoso_status_asc = 0;
          vm.endoso_fecha_asc = 0;
          vm.endoso_tipo_asc = 0;
          vm.endoso_nump_asc = 0;
          vm.endoso_aseg_asc = 0;
          vm.endoso_subramo_asc = asc;
          vm.endoso_desc_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.endoso_cont_asc = 0;
          vm.endoso_folio_asc = 0;
          vm.endoso_num_asc = 0;
          vm.endoso_status_asc = 0;
          vm.endoso_fecha_asc = 0;
          vm.endoso_tipo_asc = 0;
          vm.endoso_nump_asc = 0;
          vm.endoso_aseg_asc = 0;
          vm.endoso_subramo_asc = 0;
          vm.endoso_desc_asc = asc;
          break;
      }
    }

    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      status: 0,
      contratante: 0,
      type: 0,
      celula: 0,
      report_by: vm.tipo_report[0],
    };

    activate();
    getCelulasContractor();

    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    vm.form.since = convertDate(new Date());
    vm.form.until = convertDate(new Date());

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal(
          "Error",
          "La fecha final no puede ser menor que la inicial",
          "error"
        );
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    // var endingDate =  convertDate(new Date().setYear(new Date().getFullYear() + 1));
    //var endingDate =  convertDate(new Date());
    //vm.form.until = endingDate;

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      getProviders();
      getUsuarios();
      getSubramos();
      $scope.infoUser = $sessionStorage.infoUser;

      vm.form.poliza =
        savedFiltersEndoso && savedFiltersEndoso["num_poliza"]
          ? savedFiltersEndoso["num_poliza"]
          : "";
      vm.form.contratante =
        savedFiltersEndoso && savedFiltersEndoso["contratante"]
          ? savedFiltersEndoso["contratante"]
          : "";
      vm.form.status =
        savedFiltersEndoso && savedFiltersEndoso["status"]
          ? savedFiltersEndoso["status"]
          : 0;
      vm.form.type =
        savedFiltersEndoso && savedFiltersEndoso["type"]
          ? savedFiltersEndoso["type"]
          : 0;
      vm.form.businesLine =
        savedFiltersEndoso && savedFiltersEndoso["businesLine"]
          ? savedFiltersEndoso["businesLine"]
          : 0;
      vm.form.celula =
        savedFiltersEndoso && savedFiltersEndoso["celula"]
          ? savedFiltersEndoso["celula"]
          : 0;
      vm.form.group_by =
        savedFiltersEndoso && savedFiltersEndoso["group_by"]
          ? savedFiltersEndoso["group_by"]
          : 0;
      vm.form.report_by =
        savedFiltersEndoso && savedFiltersEndoso["report_by"]
          ? savedFiltersEndoso["report_by"]
          : vm.tipo_report[0];
      vm.form.valueDolar =
        savedFiltersEndoso && savedFiltersEndoso["valueDolar"]
          ? savedFiltersEndoso["valueDolar"]
          : "";
      vm.form.valueUdi =
        savedFiltersEndoso && savedFiltersEndoso["valueUdi"]
          ? savedFiltersEndoso["valueUdi"]
          : "";
      vm.form.since =
        savedFiltersEndoso && savedFiltersEndoso["since"]
          ? savedFiltersEndoso["since"]
          : "";
      vm.form.until =
        savedFiltersEndoso && savedFiltersEndoso["until"]
          ? savedFiltersEndoso["until"]
          : "";
    }
    $scope.showButtonExcel = false;
    $scope.numberFormatUdi = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueUdi = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      } else {
      }
    };
    $scope.numberFormatDolar = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueDolar = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      } else {
      }
    };
    function Generar(order, asc, parPage) {
      $("#example").DataTable().destroy();
      setTimeout(function () {
        paso++;
        $("#example").DataTable().destroy();
        // DataTable initialisation
        $("#example").DataTable({
          dom:
            "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" +
            "<'row'<'col-sm-12'tr>>" +
            "<'row'<'col-sm-12'p<br/>i>>",
          info: false,
          paging: false,
          autoWidth: true,
          columnDefs: [
            {
              visible: false,
              targets: hCols,
            },
            {
              type: "non-empty-string",
              targets: 0,
            },
          ],
          buttons: [
            {
              extend: "colvis",
              collectionLayout: "three-column",
              text: function () {
                var totCols = $("#example thead th").length;
                var hiddenCols = hCols.length;
                var shownCols = totCols - hiddenCols;
                return "Columnas (" + shownCols + " de " + totCols + ")";
              },
              prefixButtons: [
                {
                  extend: "colvisGroup",
                  text: "Mostrar todo",
                  show: ":hidden",
                },
                {
                  extend: "colvisRestore",
                  text: "Restaurar",
                },
              ],
            },
          ],
          oLanguage: {
            oPaginate: {
              sNext: '<span class="pagination-default">&#x276f;</span>',
              sPrevious: '<span class="pagination-default">&#x276e;</span>',
            },
          },
          initComplete: function (settings, json) {
            // Adjust hidden columns counter text in button -->
            $("#example").on(
              "column-visibility.dt",
              function (e, settings, column, state) {
                var index = hCols.indexOf(column);
                if (state === false) {
                  if (index === -1) {
                    hCols.push(column);
                  }
                }
                if (
                  $(".dt-button-collection.dropdown-menu.three-column")
                    .length === 1 &&
                  state === true
                ) {
                  // console.log($('.dt-button-collection.dropdown-menu.three-column').length);
                  if (index !== -1) {
                    hCols.splice(index, 1);
                  }
                  // console.log("si entro");
                }
                // var visCols = $('#example thead tr:first th').length;

                //Below: The minus 2 because of the 2 extra buttons Show all and Restore
                var tblCols =
                  $(".dt-button-collection li[aria-controls=example] a")
                    .length - 2;
                var visCols = tblCols - hCols.length;
                $(".buttons-colvis[aria-controls=example] span").html(
                  "Columnas (" + visCols + " de " + tblCols + ")"
                );
                e.stopPropagation();
              }
            );
          },
        });
      }, 2000);
      var l = Ladda.create(document.querySelector(".ladda-buttonC"));
      l.start();

      $scope.order = order;
      $scope.asc = asc;

      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        l.stop();
        SweetAlert.swal(
          "Error",
          "La fecha final no puede ser menor que la inicial",
          "error"
        );
      }
      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }
      $scope.params = {
        provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider,
        ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
        subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        status: vm.form.status.id ? vm.form.status.id : vm.form.status,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        type_contractor: vm.form.contratante.type
          ? vm.form.contratante.type
          : 0,
        type: vm.form.type.id ? vm.form.type.id : vm.form.type,
        order: order,
        asc: asc,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        claves: vm.claves_selected ? vm.claves_selected : 0,
        users: vm.usuarios_selected ? vm.usuarios_selected : 0,
        page: parPage ? parPage : 1,
        group_by: vm.form.group_by ? vm.form.group_by.id : 0,
        valDolar: vm.form.valueDolar
          ? parseFloat(vm.form.valueDolar).toFixed(2)
          : 0,
        valUdi: vm.form.valueUdi ? parseFloat(vm.form.valueUdi).toFixed(2) : 0,
        businessLine: $scope.bLine ? $scope.bLine.id : 0,
        celula: cel ? cel : 0,
        numpoliza: vm.form.poliza ? vm.form.poliza : 0,
        report_by: vm.form.report_by ? vm.form.report_by.id : 0,
      };
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          $scope.params.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.group) {
        if (vm.form.group.val == "") {
          $scope.params.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
      }
      $scope.params.since = $scope.params.since + " " + "00:00:00";
      $scope.params.until = $scope.params.until + " " + "23:59:59";
      $scope.url_go = "reporte-endosos/";
      // $scope.url_go_excel = 'reporte-endosos-excel';
      $scope.url_go_excel = "service_reporte-endososReport-excel";
      $http({
        method: "POST",
        url: url.IP + $scope.url_go, //'reporte-endosos/',
        data: $scope.params,
      }).then(function success(response) {
        if ($scope.params.group_by == 0) {
          $("#example").DataTable().clear();
          $("#example").DataTable().destroy();
          $scope.grupos_result = [];
          $scope.insurances = response.data.results;
          $scope.sumas = response.data.sumas;
          l.stop();

          $scope.endorsments_config = {
            count: response.data.count,
            previous: url.IP + $scope.url_go, //'reporte-endosos/',
            next: url.IP + $scope.url_go, //'reporte-endosos/'
          };
          $scope.show_pag_endorsments = true;
          $scope.showSums = true;
          $scope.obtenerPaginacion(response.data, parPage ? parPage : 1);
          // $scope.testPagination('insurances', 'endorsments_config');
          if (!$scope.insurances) {
            toaster.warning("No se encontraron registros");
            $("#example").DataTable().clear();
            $("#example").DataTable().draw();
            $("#example").DataTable().destroy();
          } else {
            $scope.showButtonExcel = true;
          }
        } else {
          $scope.showSums = false;
          l.stop();
          $scope.grupos_result = response.data;
          $scope.showButtonExcel = true;
        }
      });

      savedFiltersEndoso = angular.copy($scope.params);
      savedFiltersEndoso["num_poliza"] = vm.form.num_poliza;
      savedFiltersEndoso["contratante"] = vm.form.contratante;
      savedFiltersEndoso["status"] = vm.form.status;
      savedFiltersEndoso["type"] = vm.form.type;
      savedFiltersEndoso["businesLine"] = vm.form.businesLine;
      savedFiltersEndoso["celula"] = vm.form.celula;
      savedFiltersEndoso["group_by"] = vm.form.group_by;
      savedFiltersEndoso["valueDolar"] = vm.form.valueDolar;
      savedFiltersEndoso["valueUdi"] = vm.form.valueUdi;
    }
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      savedFiltersEndoso["page"] = pagina;
      vm.Generar(
        savedFiltersEndoso && savedFiltersEndoso["order"]
          ? savedFiltersEndoso["order"]
          : 1,
        savedFiltersEndoso && savedFiltersEndoso["asc"]
          ? savedFiltersEndoso["asc"]
          : 1,
        pagina
      );
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        savedFiltersEndoso["page"] = $scope.paginacion["paginaActual"] - 1;
        vm.Generar(
          savedFiltersEndoso && savedFiltersEndoso["order"]
            ? savedFiltersEndoso["order"]
            : 1,
          savedFiltersEndoso && savedFiltersEndoso["asc"]
            ? savedFiltersEndoso["asc"]
            : 1,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        savedFiltersEndoso["page"] = $scope.paginacion["paginaActual"] + 1;
        vm.Generar(
          savedFiltersEndoso && savedFiltersEndoso["order"]
            ? savedFiltersEndoso["order"]
            : 1,
          savedFiltersEndoso && savedFiltersEndoso["asc"]
            ? savedFiltersEndoso["asc"]
            : 1,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };
    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService
        .getAfianzadoraPoviderByKey(d, vm.form.report_by.id)
        .then(function (data) {
          vm.providers = data.data;
        });
    }
    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }

    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      if (parseInt(vm.form.report_by.id) == 1) {
        vm.subramos_toselected = [
          {
            id: 9,
            subramo_name: "Automóviles",
          },
          {
            id: 3,
            subramo_name: "Gastos Médicos",
          },
          {
            id: 2,
            subramo_name: "Accidentes Personales",
          },
          {
            id: 1,
            subramo_name: "Vida",
          },
          {
            id: 30,
            subramo_name: "Funerarios",
          },
          {
            id: 7,
            subramo_name: "Incendio",
          },
          {
            id: 4,
            subramo_name: "Salud",
          },
          {
            id: 10,
            subramo_name: "Crédito",
          },
          {
            id: 11,
            subramo_name: "Crédito a la Vivienda",
          },
          {
            id: 13,
            subramo_name: "Diversos",
          },
          {
            id: 12,
            subramo_name: "Garantía Financiera",
          },
          {
            id: 8,
            subramo_name: "Agrícola y de Animales",
          },
          {
            id: 6,
            subramo_name: "Marítimo y Transportes",
          },
          {
            id: 5,
            subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
          },
          {
            id: 14,
            subramo_name: "Terremoto y Otros Riesgos Catastróficos",
          },
          {
            id: 31,
            subramo_name: "Líneas Financieras",
          },
        ];
      } else if (parseInt(vm.form.report_by.id) == 2) {
        vm.subramos_toselected = [
          {
            id: 26,
            subramo_name: "Compra Venta",
          },
          {
            id: 20,
            subramo_name: "Obra",
          },
          {
            id: 21,
            subramo_name: "Proveeduria",
          },
          {
            id: 31,
            subramo_name: "Líneas Financieras",
          },
          {
            id: 17,
            subramo_name: "Penales",
          },
          {
            id: 10,
            subramo_name: "Crédito",
          },
          {
            id: 0,
            subramo_name: "Fidelidad",
          },
          {
            id: 25,
            subramo_name: "Suministro",
          },
          {
            id: 29,
            subramo_name: "Sin relación con fianza",
          },
          {
            id: 19,
            subramo_name: "Amparo a Conductores",
          },
          {
            id: 15,
            subramo_name: "Individual",
          },
          {
            id: 22,
            subramo_name: "Fiscales",
          },
          {
            id: 28,
            subramo_name: "Relación con fianza",
          },
          {
            id: 18,
            subramo_name: "No penales",
          },
          {
            id: 23,
            subramo_name: "Arrendamiento",
          },
          {
            id: 21,
            subramo_name: "Proveeduría",
          },
          {
            id: 16,
            subramo_name: "Colectivas",
          },
        ];
      } else {
        vm.subramos_toselected = [
          {
            id: 9,
            subramo_name: "Automóviles",
          },
          {
            id: 3,
            subramo_name: "Gastos Médicos",
          },
          {
            id: 2,
            subramo_name: "Accidentes Personales",
          },
          {
            id: 1,
            subramo_name: "Vida",
          },
          {
            id: 30,
            subramo_name: "Funerarios",
          },
          {
            id: 7,
            subramo_name: "Incendio",
          },
          {
            id: 4,
            subramo_name: "Salud",
          },
          {
            id: 10,
            subramo_name: "Crédito",
          },
          {
            id: 11,
            subramo_name: "Crédito a la Vivienda",
          },
          {
            id: 13,
            subramo_name: "Diversos",
          },
          {
            id: 12,
            subramo_name: "Garantía Financiera",
          },
          {
            id: 8,
            subramo_name: "Agrícola y de Animales",
          },
          {
            id: 6,
            subramo_name: "Marítimo y Transportes",
          },
          {
            id: 5,
            subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
          },
          {
            id: 14,
            subramo_name: "Terremoto y Otros Riesgos Catastróficos",
          },
          {
            id: 31,
            subramo_name: "Líneas Financieras",
          },
          {
            id: 26,
            subramo_name: "Compra Venta",
          },
          {
            id: 20,
            subramo_name: "Obra",
          },
          {
            id: 21,
            subramo_name: "Proveeduria",
          },
          {
            id: 31,
            subramo_name: "Líneas Financieras",
          },
          {
            id: 17,
            subramo_name: "Penales",
          },
          {
            id: 10,
            subramo_name: "Crédito",
          },
          {
            id: 0,
            subramo_name: "Fidelidad",
          },
          {
            id: 25,
            subramo_name: "Suministro",
          },
          {
            id: 29,
            subramo_name: "Sin relación con fianza",
          },
          {
            id: 19,
            subramo_name: "Amparo a Conductores",
          },
          {
            id: 15,
            subramo_name: "Individual",
          },
          {
            id: 22,
            subramo_name: "Fiscales",
          },
          {
            id: 28,
            subramo_name: "Relación con fianza",
          },
          {
            id: 18,
            subramo_name: "No penales",
          },
          {
            id: 23,
            subramo_name: "Arrendamiento",
          },
          {
            id: 21,
            subramo_name: "Proveeduría",
          },
          {
            id: 16,
            subramo_name: "Colectivas",
          },
        ];
      }
      // vm.subramos_selected = [];
    }
    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    $scope.exportDataExcel = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            // templateUrl: 'app/reportes/reportexcel.option.html',
            // controller: 'ReportExcelByCtrl',
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "md",
            resolve: {
              filters: function () {
                return $scope.params;
              },
              from: function () {
                return null;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.params.export_type = 2;
        var $listM = $("#example th")
          .map(function () {
            return $.trim($(this).text());
          })
          .get();

        if ($listM.includes("No.Endoso")) {
          $listM.push("No.Endoso");
        }
        if ($listM.includes("Contratante")) {
          $listM.push("Contratante");
        }
        if ($listM.includes("Subramo")) {
          $listM.push("Subramo");
        }
        if ($listM.includes("Estatus")) {
          $listM.push("Estatus");
        }
        if ($listM.includes("Inicio Póliza")) {
          $listM.push("Inicio Póliza");
        }
        if ($listM.includes("Fin Póliza")) {
          $listM.push("Fin Póliza");
        }
        if ($listM.includes("Fecha de Inicio")) {
          $listM.push("Fecha de Inicio");
        }
        if ($listM.includes("Descripción")) {
          $listM.push("Descripción");
        }
        if ($listM.includes("Creado por")) {
          $listM.push("Creado por");
        }
        if ($listM.includes("Identificador Póliza/Fianza")) {
          $listM.push("Identificador Póliza/Fianza");
        }
        if ($listM.includes("Sucursal")) {
          $listM.push("Sucursal");
        }
        if ($listM.includes("Grupo")) {
          $listM.push("Grupo");
        }
        if ($listM.includes("Número de Póliza")) {
          $listM.push("Número de Póliza");
        }
        if ($listM.includes("Aseguradora")) {
          $listM.push("Aseguradora");
        }
        if ($listM.includes("Prima Neta")) {
          $listM.push("Prima Neta");
        }
        if ($listM.includes("RPF")) {
          $listM.push("RPF");
        }
        if ($listM.includes("Derecho")) {
          $listM.push("Derecho");
        }
        if ($listM.includes("IVA")) {
          $listM.push("IVA");
        }
        if ($listM.includes("Prima Total")) {
          $listM.push("Prima Total");
        }
        if (vm.permiso_comisiones) {
          if ($listM.includes("Comisión")) {
            $listM.push("Comisión");
          }
        }
        if ($listM.includes("Subgrupo")) {
          $listM.push("Subgrupo");
        }
        if ($listM.includes("Subsubgrupo")) {
          $listM.push("Subsubgrupo");
        }
        if ($listM.includes("Agrupación")) {
          $listM.push("Agrupación");
        }
        if ($listM.includes("Subagrupación")) {
          $listM.push("Subagrupación");
        }
        if ($listM.includes("Subsubagrupación")) {
          $listM.push("Subsubagrupación");
        }
        if ($listM.includes("Clasificación")) {
          $listM.push("Clasificación");
        }
        if ($listM.includes("Línea de Negocio")) {
          $listM.push("Línea de Negocio");
        }
        if ($listM.includes("Célula")) {
          $listM.push("Célula");
        }
        if ($listM.includes("Folio Aseguradora")) {
          $listM.push("Folio Aseguradora");
        }
        if ($listM.includes("Folio Endoso")) {
          $listM.push("Folio Interno");
        }
        if ($listM.includes("Tipo de Endoso")) {
          $listM.push("Tipo de Endoso");
        }
        if ($listM.includes("Fecha de creación")) {
          $listM.push("Fecha de creación");
        }
        var scolumns = [
          "No.Endoso",
          "Contratante",
          "Subramo",
          "Estatus",
          "Inicio Póliza",
          "Fin Póliza",
          "Descripción",
          "Creado por",
          "Identificador Póliza/Fianza",
          "Fecha de Inicio",
          "Sucursal",
          "Grupo",
          "Número de Póliza",
          "Aseguradora",
          "Prima Neta",
          "RPF",
          "Derecho",
          "IVA",
          "Prima Total",
          "Subgrupo",
          "Subsubgrupo",
          "Agrupación",
          "Subagrupación",
          "Subsubagrupación",
          "Clasificación",
          "Línea de Negocio",
          "Célula",
          "Folio Aseguradora",
          "Folio Endoso",
          "Tipo de Endoso",
          "Fecha de Creación",
        ];
        console.log("sx", scolumns.length);
        var foo = [];

        $.grep(scolumns, function (el) {
          if ($.inArray(el, $listM) != -1) {
            foo.push(el);
          }
        });

        $scope.params["cols1"] = foo;
        $scope.params["report_by"] = vm.form.report_by
          ? vm.form.report_by.id
          : 0;
        if (param == 1) {
          $http({
            method: "POST",
            url: url.IP + $scope.url_go_excel, //'reporte-endosos-excel',
            data: $scope.params,
            headers: {
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "arraybuffer",
          })
            .then(function (data) {
              if (data.status == 200) {
                l.stop();
                var blob = new Blob([data.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, "Reporte_Endosos.xls");
              } else {
                l.stop();
                SweetAlert.swal(
                  "Error",
                  "Ha ocurrido un error al descargar el reporte",
                  "error"
                );
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            vm.ramos = response.data;
          });
      }
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    $scope.changeReportBy = function () {
      getProviders();
      getSubramos();
    };

    function changeType(obj) {
      if (obj) {
        vm.form.type = obj;
      } else {
        vm.form.type = 0;
      }
    }

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&status=") !== -1) {
              var status = prev_.substring(prev_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }

        getData(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };
      $scope.selectPage = function (parPage) {
        vm.Generar($scope.order, $scope.asc, parPage);
      };
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getData(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    jQuery(function ($) {
      $("#exportButton").click(function () {
        // parse the HTML table element having an id=exportTable
        var dataSource = shield.DataSource.create({
          data: "#exportTable",
          schema: {
            type: "table",
            fields: {
              Recibo: { type: String },
              RPF: { type: Number },
              Estatus: { type: String },
            },
          },
        });

        // when parsing is done, export the data to PDF
        dataSource.read().then(function (data) {
          var pdf = new shield.exp.PDFDocument({
            author: "PrepBootstrap",
            created: new Date(),
          });

          pdf.addPage("a4", "portrait");

          pdf.table(
            50,
            50,
            data,
            [
              { field: "Recibo", title: "Número de Recibo", width: 200 },
              { field: "RPF", title: "RPF", width: 50 },
              { field: "Estatus", title: "Estatus del recibo", width: 200 },
            ],
            {
              margins: {
                top: 50,
                left: 50,
              },
            }
          );

          pdf.saveAs({
            fileName: "ReporteEndosos",
          });
        });
      });
    });
    // Reporte excel
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      $scope.infoUser = $sessionStorage.infoUser;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        var param = 1;
        if (option) {
          // Totales de la Agrupación
          var filter_endorsement = "service_reporte-endososReport-excel";
          if (option == 1) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            filters.export_type = option;
            $http({
              method: "POST",
              url: url.IP + filter_endorsement, //'reporte-endosos-excel' ,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Endosos.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          } else if (option == 2) {
            filters.export_type = option;
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            $http({
              method: "POST",
              url: url.IP + filter_endorsement, //'reporte-endosos-excel' ,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Endosos.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    // Reporte excel 1_______
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteEdoClientesController", ReporteEdoClientesController);

  ReporteEdoClientesController.$inject = [
    "toaster",
    "datesFactory",
    "MESSAGES",
    "$http",
    "url",
    "$scope",
    "$parse",
    "$sessionStorage",
    "$uibModal",
    "SweetAlert",
    "providerService",
    "$localStorage",
  ];

  function ReporteEdoClientesController(
    toaster,
    datesFactory,
    MESSAGES,
    $http,
    url,
    $scope,
    $parse,
    $sessionStorage,
    $uibModal,
    SweetAlert,
    providerService,
    $localStorage
  ) {
    var vm = this;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    vm.users = [];
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.group_by = [
      {
        id: 1,
        name: "Contratante",
      },
      {
        id: 2,
        name: "Aseguradora",
      },
      {
        id: 3,
        name: "Ramo",
      },
      {
        id: 4,
        name: "Subramo",
      },
    ];
    vm.form = {
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      contratante: 0,
      group: 0,
    };
    vm.status = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por Iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
    ];

    $scope.infoUser = $sessionStorage.infoUser;

    $(".js-example-basic-multiple").select2();
    activate();
    // Start functionality
    function activate() {
      getProviders();
      $http.get(url.IP + "usuarios/").then(function (user) {
        user.data.results.forEach(function (usr) {
          if (usr.user_info.is_active) {
            vm.users.push(usr);
          }
        });
      });
      //  $(window).load(function() {
      //    $('.js-example-basic-multiple').select2();
      // });
      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });

      vm.form.contratante =
        $localStorage.saved_filters_reporte_edo_cliente &&
        $localStorage.saved_filters_reporte_edo_cliente["contratante"]
          ? $localStorage.saved_filters_reporte_edo_cliente["contratante"]
          : "";
      vm.form.group =
        $localStorage.saved_filters_reporte_edo_cliente &&
        $localStorage.saved_filters_reporte_edo_cliente["group"]
          ? $localStorage.saved_filters_reporte_edo_cliente["group"]
          : 0;
      vm.form.status =
        $localStorage.saved_filters_reporte_edo_cliente &&
        $localStorage.saved_filters_reporte_edo_cliente["status"]
          ? $localStorage.saved_filters_reporte_edo_cliente["status"]
          : 0;
      vm.form.groupBy =
        $localStorage.saved_filters_reporte_edo_cliente &&
        $localStorage.saved_filters_reporte_edo_cliente["group_by"]
          ? $localStorage.saved_filters_reporte_edo_cliente["group_by"]
          : 0;
      $scope.recibo_endoso =
        $localStorage.saved_filters_reporte_edo_cliente &&
        $localStorage.saved_filters_reporte_edo_cliente["recibo_endoso"]
          ? $localStorage.saved_filters_reporte_edo_cliente["recibo_endoso"]
          : 0;
    }

    $(".js-example-basic-multiple").select2();
    // tipo recibos
    $scope.recibo_endoso = "0";
    $scope.type_recibo = 0;
    $scope.selectReceiptsOption = function (parValue) {
      if (parValue == "1") {
        $scope.type_recibo = 2;
      } else if (parValue == "2") {
        $scope.type_recibo = 1;
      } else if (parValue == "3") {
        $scope.type_recibo = 3;
      } else {
        $scope.type_recibo = 0;
      }
    };
    // Get Edos API
    $scope.getEdosClientes = function (page, otro) {
      $scope.edoclientes = [];
      $scope.edoclientes_edo = [];
      $scope.grupos_result = [];
      $scope.filters = {
        users: vm.users_selected ? vm.users_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        since: vm.form.since ? vm.form.since : "",
        until: vm.form.until ? vm.form.until : "",
        model: vm.form.model ? vm.form.model.id : 0,
        groupBy: vm.form.group_by ? vm.form.group_by.id : 0,
        page: page ? page : 1,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        type_contractor: vm.form.contratante.type
          ? vm.form.contratante.type
          : 0,
        status: vm.form.status ? vm.form.status.id : 0,
        tipo_recibo: $scope.type_recibo ? $scope.type_recibo : 0,
        grupo: vm.form.group.val ? vm.form.group.value : 0,
      };
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          $scope.filters.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.group) {
        if (vm.form.group.val == "") {
          $scope.filters.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
      }
      $scope.filters.since = $scope.filters.since + " " + "00:00:00";
      $scope.filters.until = $scope.filters.until + " " + "23:59:59";
      var lc = Ladda.create(document.querySelector(".ladda-button"));
      lc.start();
      $scope.search_customer = "reporte-edoclientes/";
      $http({
        method: "POST",
        url: url.IP + $scope.search_customer,
        data: $scope.filters,
      })
        .then(function success(response) {
          if ($scope.filters.groupBy == 0) {
            lc.stop();
            // $scope.edoclientes = response.data.results;
            // $scope.edoclientes = response.data.edoClientes;
            if (response.data.count == 0) {
              toaster.info("No se encontraron registros");
            } else {
              $scope.edoclientes = response.data.edo_rec;
              $scope.edoclientes_1 = response.data.results_all_others_status;
              // console.log('df--------',$scope.edoclientes_1.length)
              $scope.edoclientes_config = {
                count: response.data.count,
                previous: url.IP + $scope.search_customer,
                next: url.IP + $scope.search_customer,
              };
              vm.show_pag_edoclientes = true;
              PaginationResults("edoclientes", "edoclientes_config");
            }
          } else {
            lc.stop();
            if (response.data.count == 0) {
              toaster.info("No se encontraron registros");
            } else {
              $scope.grupos_result = response.data.results;
            }
          }
        })
        .catch(function (e) {
          lc.stop();
          console.log("e", e);
        });

      $localStorage.saved_filters_reporte_edo_cliente = angular.copy(
        $scope.filters
      );
      $localStorage.saved_filters_reporte_edo_cliente["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_reporte_edo_cliente["group"] = vm.form.group;
      $localStorage.saved_filters_reporte_edo_cliente["status"] =
        vm.form.status;
      $localStorage.saved_filters_reporte_edo_cliente["group_by"] =
        vm.form.group_by;
      $localStorage.saved_filters_reporte_edo_cliente["recibo_endoso"] =
        $scope.recibo_endoso;
    };

    $scope.receiptsStatus = function (parStatus) {
      switch (parStatus) {
        case 1:
          return "Pagado";
          break;
        case 2:
          return "Cancelado";
          break;
        case 3:
          return "Prorrogado";
          break;
        case 4:
          return "Pendiente de pago";
          break;
        case 5:
          return "Liquidado";
          break;
        case 6:
          return "Conciliado";
          break;
        case 7:
          return "Cerrado";
          break;
        case 8:
          return "Precancelado";
          break;
        default:
          return "Pendiente de pago";
      }
    };
    // Forma de pago
    $scope.payForm = function (x) {
      switch (x) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 4:
          return "Cuatrimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        default:
          return "Anual";
          break;
      }
    };
    // status poliza
    $scope.status = function (y) {
      switch (y) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          return;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        default:
          return "Vigente";
          break;
      }
    };
    // Change User
    $scope.selectUser = function (x, y) {
      vm.users_selected = [];
      x.forEach(function (r) {
        vm.users_selected.push(parseInt(r.id));
      });
    };
    // Download report to excel
    $scope.export = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "md",
            resolve: {
              filters: function () {
                return $scope.filters;
              },
              from: function () {
                return null;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var lx = Ladda.create(document.querySelector(".ladda-button_excel"));
        lx.start();
        $scope.filters.orden = $scope.columnArray;
        $scope.filters.export_type = 2;
        if (param == 1) {
          $scope.excel_customer = "reporte-edoClientes-excel";
          $http({
            method: "POST",
            url: url.IP + $scope.excel_customer,
            data: $scope.filters,
            headers: {
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "arraybuffer",
          }).then(function (data, status, headers, config) {
            if (data.status == 200) {
              lx.stop();
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte Edo.Clientes.xls");
            } else {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.ERRORDOWNLOADREP,
                "error"
              );
              lx.stop();
            }
          });
        }
      }
    };
    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group.val) {
        var word_data = vm.form.group.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }
    // DOWNLOAD REPORT IF GROUP BY SELECTED
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      $scope.infoUser = $sessionStorage.infoUser;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        var param = 1;
        if (option) {
          // Totales de la Agrupación
          var filter_customer = "reporte-edoClientes-excel";
          if (option == 1) {
            var l1 = Ladda.create(
              document.querySelector(".ladda-button_excel")
            );
            l1.start();
            filters.export_type = option;
            $http({
              method: "POST",
              url: url.IP + filter_customer,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte Edo.Clientes.xls");
                  $uibModalInstance.dismiss("cancel");
                  l1.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l1.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          } else if (option == 2) {
            filters.export_type = option;
            var la = Ladda.create(
              document.querySelector(".ladda-button_excel")
            );
            la.start();
            $http({
              method: "POST",
              url: url.IP + filter_customer,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte Edo.Clientes.xls");
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    // Format Dates DD/MM/YYYY
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };

    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 6,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
        // ----
        {
          id: 15,
          subramo_code: 15,
          subramo_name: "Individual",
        },
        {
          id: 16,
          subramo_code: 16,
          subramo_name: "Colectivas",
        },
        {
          id: 17,
          subramo_code: 17,
          subramo_name: "Penales",
        },
        {
          id: 18,
          subramo_code: 18,
          subramo_name: "No penales",
        },
        {
          id: 19,
          subramo_code: 19,
          subramo_name: "Amparo a conductores",
        },
        {
          id: 20,
          subramo_code: 20,
          subramo_name: "Obra",
        },
        {
          id: 21,
          subramo_code: 21,
          subramo_name: "Proveeduria",
        },
        {
          id: 22,
          subramo_code: 22,
          subramo_name: "Fiscales",
        },
        {
          id: 23,
          subramo_code: 23,
          subramo_name: "Arrendamiento",
        },
        {
          id: 24,
          subramo_code: 24,
          subramo_name: "Otras",
        },
        {
          id: 25,
          subramo_code: 25,
          subramo_name: "Suministro",
        },
        {
          id: 26,
          subramo_code: 26,
          subramo_name: "Compra Venta",
        },
        {
          id: 27,
          subramo_code: 27,
          subramo_name: "Otras",
        },
        {
          id: 28,
          subramo_code: 28,
          subramo_name: "Relación con fianza",
        },
        {
          id: 29,
          subramo_code: 29,
          subramo_name: "Sin relación con fianza",
        },
      ];
    }
    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        console.log(data);
        vm.providers = data.data;
      });
    }

    function getContractors() {
      ContratanteService.getContratantes().then(function (data) {
        vm.contractors = data;
      });
    }
    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }
    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };
    // -----------PAGINACIÓN
    function PaginationResults(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        $scope.getEdosClientes(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteCumpleaniosController", ReporteCumpleaniosController);

  ReporteCumpleaniosController.$inject = [
    "dataFactory",
    "datesFactory",
    "MESSAGES",
    "$http",
    "url",
    "$scope",
    "$parse",
    "$sessionStorage",
    "$uibModal",
    "SweetAlert",
  ];

  function ReporteCumpleaniosController(
    dataFactory,
    datesFactory,
    MESSAGES,
    $http,
    url,
    $scope,
    $parse,
    $sessionStorage,
    $uibModal,
    SweetAlert
  ) {
    var vm = this;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    activate();
    // Start functionality
    function activate() {
      $scope.since = new Date();
      $scope.until = new Date();
      var days = 7;
      $scope.until.setDate($scope.until.getDate() + days);
      $scope.until = datesFactory.convertDate($scope.until);
      // restar
      var dia = 1;
      //paso el dia a segundos
      var b = sumarDias($scope.since, -7);
      $scope.since = datesFactory.convertDate($scope.since);
      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });
    }
    // Get logs API
    $scope.getPersons = function (page, otro) {
      $scope.persons = [];
      var data = {
        since: $scope.since,
        until: $scope.until,
      };
      dataFactory
        .get("reportew-birthdays/", data)
        .then(function success(response) {
          $scope.persons = response.data;
          $scope.contractors = response.data.contractors;
          $scope.titulares = response.data.titulares;
          $scope.beneficiaries = response.data.beneficiaries;
          $scope.relationship = response.data.relationship;

          $scope.persons_length =
            $scope.contractors.length +
            $scope.titulares.length +
            $scope.beneficiaries.length +
            $scope.relationship.length;
        });
    };
    function sumarDias(fecha, dias) {
      fecha.setDate(fecha.getDate() + dias);
      return fecha;
    }
    // Download report to excel
    $scope.export = function (param) {
      var data = {
        since: $scope.since,
        until: $scope.until,
      };
      var lx = Ladda.create(document.querySelector(".ladda-button_excel"));
      lx.start();
      if (param == 1) {
        $http({
          method: "POST",
          // url: url.IP +'reporte-cumpleanios-excel' ,
          url: url.IP + "service_reporte-cumpleReport-excel",
          data: data,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function (data, status, headers, config) {
          if (data.status == 200) {
            lx.stop();
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte Cumpleaños.xls");
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDOWNLOADREP, "error");
            lx.stop();
          }
        });
      }
    };
    // DOWNLOAD REPORT IF GROUP BY SELECTED
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.optionsSent = [
        { value: 1, label: "Totales de la Agrupación" },
        { value: 2, label: "Desglose de consulta" },
      ];
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        var param = 1;
        if (option) {
          // Totales de la Agrupación
          if (option == 1) {
            var l1 = Ladda.create(
              document.querySelector(".ladda-button_excel")
            );
            l1.start();
            filters.export_type = option;
            $http({
              method: "POST",
              url: url.IP + "reporte-log-excel",
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte Transacciones.xls");
                  $uibModalInstance.dismiss("cancel");
                  l1.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l1.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          } else if (option == 2) {
            filters.export_type = option;
            var la = Ladda.create(
              document.querySelector(".ladda-button_excel")
            );
            la.start();
            $http({
              method: "POST",
              url: url.IP + "reporte-log-excel",
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte Transacciones.xls");
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    // Format Dates DD/MM/YYYY
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    // -----------PAGINACIÓN
    function PaginationResults(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        $scope.getPersons(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteCotizacionesController", ReporteCotizacionesController);

  ReporteCotizacionesController.$inject = [
    "appStates",
    "dataFactory",
    "$sessionStorage",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$parse",
    "exportFactory",
    "$uibModal",
    "$localStorage",
  ];

  function ReporteCotizacionesController(
    appStates,
    dataFactory,
    $sessionStorage,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $parse,
    exportFactory,
    $uibModal,
    $localStorage
  ) {
    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? -1 : str1 > str2 ? 1 : 0;
      },

      "non-empty-string-desc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? 1 : str1 > str2 ? -1 : 0;
      },
    });
    var hCols = [];
    var paso = 0;
    $scope.$on("ngRepeatFinished", function () {
      paso++;
      // console.log("hola");
      $("#example").DataTable().destroy();

      //Only needed for the filename of export files.
      //Normally set in the title tag of your page.document.title = 'Simple DataTable';
      //Define hidden columns

      // DataTable initialisation
      $("#example").DataTable({
        dom:
          "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-12'p<br/>i>>",
        info: false,
        paging: false,
        autoWidth: true,
        columnDefs: [
          {
            visible: false,
            targets: hCols,
          },
          {
            type: "non-empty-string",
            targets: 0,
          },
        ],
        buttons: [
          {
            extend: "colvis",
            collectionLayout: "three-column",
            text: function () {
              var totCols = $("#example thead th").length;
              var hiddenCols = hCols.length;
              var shownCols = totCols - hiddenCols;
              return "Columnas (" + shownCols + " de " + totCols + ")";
            },
            prefixButtons: [
              {
                extend: "colvisGroup",
                text: "Mostrar todo",
                show: ":hidden",
              },
              {
                extend: "colvisRestore",
                text: "Restaurar",
              },
            ],
          },
        ],
        oLanguage: {
          oPaginate: {
            sNext: '<span class="pagination-default">&#x276f;</span>',
            sPrevious: '<span class="pagination-default">&#x276e;</span>',
          },
        },
        initComplete: function (settings, json) {
          // Adjust hidden columns counter text in button -->
          $("#example").on(
            "column-visibility.dt",
            function (e, settings, column, state) {
              var index = hCols.indexOf(column);
              if (state === false) {
                if (index === -1) {
                  hCols.push(column);
                }
              }
              if (
                $(".dt-button-collection.dropdown-menu.three-column").length ===
                  1 &&
                state === true
              ) {
                // console.log($('.dt-button-collection.dropdown-menu.three-column').length);
                if (index !== -1) {
                  hCols.splice(index, 1);
                }
                // console.log("si entro");
              }
              // var visCols = $('#example thead tr:first th').length;

              //Below: The minus 2 because of the 2 extra buttons Show all and Restore
              var tblCols =
                $(".dt-button-collection li[aria-controls=example] a").length -
                2;
              var visCols = tblCols - hCols.length;
              $(".buttons-colvis[aria-controls=example] span").html(
                "Columnas (" + visCols + " de " + tblCols + ")"
              );
              e.stopPropagation();
            }
          );
        },
      });
    });

    $(".js-example-basic-multiple").select2();

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;

    vm.changeProvider = changeProvider;
    vm.changeSubRamo = changeSubRamo;
    vm.Generar = Generar;

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }

    activate();

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function activate() {
      getProviders();
      getSubramos();
    }

    $scope.reporte = false;
    $scope.showButtonExcel = false;

    vm.tipo = 0;
    vm.emitida_por = 0;
    vm.cotizada_en = [];
    vm.subramos = [];
    var d = new Date();
    d.setMonth(d.getMonth() - 3);
    vm.fecha_ingreso_inicial = convertDate(d);
    vm.fecha_ingreso_final = convertDate(new Date());

    $scope.tipos = [
      {
        name: "Todas",
        id: 0,
      },
      {
        name: "Emitidas",
        id: 2,
      },
      {
        name: "No Emitidas",
        id: 1,
      },
    ];

    function Generar(page) {
      var cotizadas_en = vm.cotizada_en.map(function (item) {
        return item.alias;
      });

      var subramos = vm.subramos.map(function (item) {
        return item.subramo_code;
      });

      var payload = {
        tipo: vm.tipo,
        emitida_por:
          vm.emitida_por && vm.emitida_por.alias ? vm.emitida_por.alias : 0,
        cotizada_en: cotizadas_en && cotizadas_en.length > 0 ? cotizadas_en : 0,
        subramos: subramos && subramos.length > 0 ? subramos : 0,
        fecha_ingreso_inicial: vm.fecha_ingreso_inicial,
        fecha_ingreso_final: vm.fecha_ingreso_final,
        page: page ? page : 1,
      };

      $scope.url = "reporte-cotizaciones";
      $http({
        method: "POST",
        url: url.IP + $scope.url,
        data: payload,
      }).then(function success(response) {
        console.log(response);
        $scope.cotizaciones = response.data.results;
        $scope.obtenerPaginacion(response.data, page ? page : 1);
      });
    }

    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      vm.Generar(pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        vm.Generar($scope.paginacion["paginaActual"] - 1);
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        vm.Generar($scope.paginacion["paginaActual"] + 1);
      }
    };
    $scope.exportDataExcel = function () {
      var cotizadas_en = vm.cotizada_en.map(function (item) {
        return item.alias;
      });

      var subramos = vm.subramos.map(function (item) {
        return item.subramo_code;
      });

      var payload = {
        tipo: vm.tipo,
        emitida_por:
          vm.emitida_por && vm.emitida_por.alias ? vm.emitida_por.alias : 0,
        cotizada_en: cotizadas_en && cotizadas_en.length > 0 ? cotizadas_en : 0,
        subramos: subramos && subramos.length > 0 ? subramos : 0,
        fecha_ingreso_inicial: vm.fecha_ingreso_inicial,
        fecha_ingreso_final: vm.fecha_ingreso_final,
      };

      $scope.url = "reporte-cotizaciones-excel/";
      $http({
        method: "POST",
        url: url.IP + $scope.url,
        data: payload,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function success(request) {
          if (request.status === 200) {
            var blob = new Blob([request.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte Cotizaciones.xls");
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.open_in_same_tab_natural = function (
      name,
      route,
      params,
      identifier
    ) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $state.go($scope.route_for_new_tab, params);
    };

    function goToInfo(insurance) {}

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        console.log(data);
        vm.providers = data.data;
      });
    }

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            vm.ramos = response.data;
          });
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };

    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }
    // -----------PAGINACIÓN

    $scope.actual_page = 1;

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        vm.Generar();
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
    jQuery(function ($) {
      $("#exportButton").click(function () {
        // parse the HTML table element having an id=exportTable
        var dataSource = shield.DataSource.create({
          data: "#exportTable",
          schema: {
            type: "table",
            fields: {
              Recibo: { type: String },
              RPF: { type: Number },
              Estatus: { type: String },
            },
          },
        });

        // when parsing is done, export the data to PDF
        dataSource.read().then(function (data) {
          var pdf = new shield.exp.PDFDocument({
            author: "PrepBootstrap",
            created: new Date(),
          });

          pdf.addPage("a4", "portrait");

          pdf.table(
            50,
            50,
            data,
            [
              { field: "Recibo", title: "Número de Recibo", width: 200 },
              { field: "RPF", title: "RPF", width: 50 },
              { field: "Estatus", title: "Estatus del recibo", width: 200 },
            ],
            {
              margins: {
                top: 50,
                left: 50,
              },
            }
          );

          pdf.saveAs({
            fileName: "ReportePolizas",
          });
        });
      });
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "ReporteCobranzaSubsecController",
      ReporteCobranzaSubsecController
    );

  ReporteCobranzaSubsecController.$inject = [
    "datesFactory",
    "MESSAGES",
    "providerService",
    "curr_rate_options",
    "$localStorage",
    "receiptService",
    "statusPayform",
    "toaster",
    "$uibModal",
    "statusReceipt",
    "SweetAlert",
    "$uibModalInstance",
    "modalService",
    "valueReceipt",
    "$sessionStorage",
    "$http",
    "url",
    "$parse",
    "$scope",
    "$state",
    "exportFactory",
    "$location",
    "dataFactory",
    "$rootScope",
  ];

  function ReporteCobranzaSubsecController(
    datesFactory,
    MESSAGES,
    providerService,
    curr_rate_options,
    $localStorage,
    receiptService,
    statusPayform,
    toaster,
    $uibModal,
    statusReceipt,
    SweetAlert,
    $uibModalInstance,
    modalService,
    valueReceipt,
    $sessionStorage,
    $http,
    url,
    $parse,
    $scope,
    $state,
    exportFactory,
    $location,
    dataFactory,
    $rootScope
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.accesos = $sessionStorage.permisos;
    vm.pageTitle = "Cobranza";
    vm.receipts = [];
    vm.receipt = {};
    vm.changeStatusModal = changeStatusModal;
    vm.showComment = showComment;
    vm.showPhone = showPhone;
    vm.showEmail = showEmail;
    vm.canceledReceipts = [];
    vm.paidReceipts = [];
    vm.NotasModal = NotasModal;
    vm.pendingReceipts = [];
    vm.close = close;
    vm.liquidar_is_posible = false;
    vm.pagar_is_posible = false;
    // vm.loading = false;
    vm.user = usr;
    vm.getUsuarios = getUsuarios;
    vm.table = {};
    vm.emailsReminderAdd = emailsReminderAdd;
    // vm.addEmails = addEmails;
    // vm.deleteEmails = deleteEmails;
    // TODO: quitar al terminar
    vm.user.permiso.editar = true;
    vm.buscar_por_folio = false;
    vm.folio_a_buscar = "";

    vm.responsiv = responsiv;
    vm.getCobranza = getCobranza;
    vm.testPagination = testPagination;
    vm.receipts_to_pay_lenght = 0;

    vm.changeProvider = changeProvider;
    vm.changeReferenciador = changeReferenciador;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeUntil = changeUntil;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.getNotas = getNotas;
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.showBinnacle = showBinnacle;
    vm.returnToReceipts = returnToReceipts;
    vm.returnToNote = returnToNote;
    vm.tipo_folio_buscar = 1;
    vm.getLog = getLog;
    $scope.user_pay = {};

    $scope.infoUser = $sessionStorage.infoUser;

    vm.accesos.forEach(function (acceso) {
      if (acceso.model_name == "Cobranza") {
        vm.acceso_cob = acceso;
        vm.acceso_cob.permissions.forEach(function (acc) {
          if (acc.permission_name == "Pagar y prorrogar") {
            if (acc.checked == true) {
              vm.acceso_pag_rec = true;
            } else {
              vm.acceso_pag_rec = false;
            }
          } else if (acc.permission_name == "Desconciliación de recibos") {
            if (acc.checked == true) {
              vm.acceso_desconc_rec = true;
            } else {
              vm.acceso_desconc_rec = false;
            }
          } else if (acc.permission_name == "Desliquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_desliq_rec = true;
            } else {
              vm.acceso_desliq_rec = false;
            }
          } else if (acc.permission_name == "Conciliar recibos") {
            if (acc.checked == true) {
              vm.acceso_conc_rec = true;
            } else {
              vm.acceso_conc_rec = false;
            }
          } else if (acc.permission_name == "Liquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_liq_rec = true;
            } else {
              vm.acceso_liq_rec = false;
            }
          } else if (acc.permission_name == "Ver cobranza") {
            if (acc.checked == true) {
              vm.acceso_ver_cob = true;
            } else {
              vm.acceso_ver_cob = false;
            }
          } else if (acc.model_name == "Archivos") {
            vm.acceso_files = acc;
            vm.acceso_files.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              }
            });
          }
        });
      } else if (acceso.model_name == "Correos electronicos") {
        vm.acceso_correo = acceso;
        vm.acceso_correo.permissions.forEach(function (acc) {
          if (acc.permission_name == "Correos") {
            if (acc.checked == true) {
              vm.acceso_cor = true;
            } else {
              vm.acceso_cor = false;
            }
          }
        });
      } else if (acceso.model_name == "Pólizas") {
        vm.acceso_polizas = acceso;
        vm.acceso_polizas.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar pólizas") {
            if (acc.checked == true) {
              vm.acceso_adm_pol = true;
            } else {
              vm.acceso_adm_pol = false;
            }
          } else if (acc.permission_name == "Ver pólizas") {
            if (acc.checked == true) {
              vm.acceso_ver_pol = true;
            } else {
              vm.acceso_ver_pol = false;
            }
          }
        });
      } else if (acceso.model_name == "Reportes") {
        vm.acceso_reportes = acceso;
        vm.acceso_reportes.permissions.forEach(function (acc) {
          if (acc.permission_name == "Reporte fianzas") {
            if (acc.checked == true) {
              vm.acceso_rep_fia = true;
            } else {
              vm.acceso_rep_fia = false;
            }
          } else if (acc.permission_name == "Reporte Siniestros") {
            if (acc.checked == true) {
              vm.acceso_rep_sin = true;
            } else {
              vm.acceso_rep_sin = false;
            }
          } else if (acc.permission_name == "Reporte Endosos") {
            if (acc.checked == true) {
              vm.acceso_rep_end = true;
            } else {
              vm.acceso_rep_end = false;
            }
          } else if (acc.permission_name == "Reporte pólizas") {
            if (acc.checked == true) {
              vm.acceso_rep_pol = true;
            } else {
              vm.acceso_rep_pol = false;
            }
          } else if (acc.permission_name == "Reporte renovaciones") {
            if (acc.checked == true) {
              vm.acceso_rep_ren = true;
            } else {
              vm.acceso_rep_ren = false;
            }
          } else if (acc.permission_name == "Reporte cobranza") {
            if (acc.checked == true) {
              vm.acceso_rep_cob = true;
            } else {
              vm.acceso_rep_cob = false;
            }
          }
        });
      }
    });
    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: 0,
      group: 0,
      vendedor: 0,
      tipo_recibo: 0,
      status_recibos: 0,
      deliver: 0,
    };

    vm.payment = [
      {
        id: 0,
        name: "Todas las formas de pago",
      },
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];

    vm.tipo_recibo = [
      {
        id: 0,
        name: "Todos",
      },
      {
        id: 1,
        name: "Iniciales ",
      },
      {
        id: 2,
        name: "Subsecuentes",
      },
    ];

    vm.status_recibos = [
      {
        id: 0,
        name: "Todos",
      },
      {
        id: 1,
        name: "Pendientes ",
      },
      {
        id: 2,
        name: "Pagados",
      },
      {
        id: 3,
        name: "Liquidados",
      },
      {
        id: 4,
        name: "Cancelados",
      },
      {
        id: 5,
        name: "Precancelados",
      },
    ];
    vm.table = {
      headers: [
        "Tipo",
        "Contratante",
        "Póliza",
        "Periodo",
        "Aseguradora",
        "Estatus",
        "Prima Total",
        "Creado Por",
        "Antigüedad",
        "Acciones",
      ],
    };
    vm.table_nc = {
      headers: [
        "Contratante",
        "Folio",
        "Número endoso",
        "Número póliza",
        "Fecha emisión",
        "Prima Total",
        "Forma de pago",
        "Moneda",
        "Antigüedad",
        "Acciones",
      ],
    };

    var arr = [];
    var nums = [];
    $scope.form = {};
    $scope.form.emails_reminder = [];
    // $scope.form.emails_reminder.forEach(function(elem, index) {
    //      arr.push(elem);
    // });

    /*Enviar correos*/
    $scope.receiptAll = valueReceipt;
    $scope.showAddEmail = false;
    $scope.optionsSent = [
      { value: 1, label: "Solo al contratante" },
      { value: 2, label: "Añadir correos adicionales" },
    ];

    $scope.deliverReceipt = [
      { id: 0, name: "Todos" },
      { id: 1, name: "Entregado" },
      { id: 2, name: "No Entregado" },
    ];

    $scope.selectUserPay = function (x, y) {
      vm.user_pay_selected = [];
      x.forEach(function (r) {
        vm.user_pay_selected.push(parseInt(r.id));
      });
    };
    $scope.showAddEmails = function (param) {
      if ($scope.receiptAll.poliza) {
        if (
          $scope.receiptAll.poliza.natural ||
          $scope.receiptAll.poliza.juridical
        ) {
          var name_contractor = $scope.receiptAll.poliza.natural
            ? $scope.receiptAll.poliza.natural
            : $scope.receiptAll.poliza.juridical;
          $http
            .post(url.IP + "contractors-contact/", {
              name: name_contractor,
            })
            .then(function (response) {
              if (response.status === 200) {
                $scope.correos = response.data.contact;
              }
            });
        } else if ($scope.receiptAll.contratante) {
          if ($scope.receiptAll.contratante.full_name) {
            var name_contractor = $scope.receiptAll.contratante.full_name;
            $http
              .post(url.IP + "contractors-contact/", {
                name: name_contractor,
              })
              .then(function (response) {
                if (response.status === 200) {
                  $scope.correos = response.data.contact;
                }
              });
          } else if ($scope.receiptAll.contratante.j_name) {
            var name_contractor = $scope.receiptAll.contratante.j_name;
            $http
              .post(url.IP + "contractors-contact/", {
                name: name_contractor,
              })
              .then(function (response) {
                if (response.status === 200) {
                  $scope.correos = response.data.contact;
                }
              });
          }
        }
      } else if ($scope.receiptAll.fianza) {
        var name_contractor = $scope.receiptAll.fianza.natural
          ? $scope.receiptAll.fianza.natural
          : $scope.receiptAll.fianza.juridical;
        $http
          .post(url.IP + "contractors-contact/", {
            name: name_contractor,
          })
          .then(function (response) {
            if (response.status === 200) {
              $scope.correos = response.data.contact;
            }
          });
      } else {
        $scope.correos = [];
      }
      if (param.value == 1) {
        $scope.showAddEmail = false;
      } else {
        $scope.showAddEmail = true;
      }
    };

    activate();
    vm.form.since = convertDate(new Date());
    // var endingDate =  convertDate(new Date().setYear(new Date().getFullYear() + 1));
    var endingDate = convertDate(new Date());
    vm.form.until = endingDate;

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal(
          "Error",
          "La fecha final no puede ser menor que la inicial",
          "error"
        );
        var newdate = convertDate(new Date());
        vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }
    // $(window).load(function() {
    //   $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    getSubramos();
    getProviders();
    getUsuarios();
    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
        vm.datos_users = data.data.results;
        vm.ejecutivos = [];
        vm.datos_users.forEach(function (u) {
          var obj = {
            name: u.first_name + " " + u.last_name,
            id: u.id,
          };
          vm.ejecutivos.push(obj);
        });
      });
    }
    function activate() {
      $(".js-example-basic-multiple").select2();
      $http({
        method: "GET",
        url: url.IP + "get_user_by_username/",
        params: {
          username: vm.user.name,
        },
      })
        .then(function (request) {
          $scope.user_pay = request.data;
        })
        .catch(function (e) {
          console.log("e", e);
        });
      $scope.ver_select_pay = false;
      getSubramos();
      getProviders();

      $scope.ver_select_pay = true;
      getProviders();
      getReferenciador();
      vm.form.tipo_recibo = 2;
      vm.form.deliver = {
        id: 0,
        name: "Todos",
      };
      vm.form.status_recibos = 0;

      vm.form.contratante =
        $localStorage.saved_filters_reporte_recibo_subsecuente &&
        $localStorage.saved_filters_reporte_recibo_subsecuente["contratante"]
          ? $localStorage.saved_filters_reporte_recibo_subsecuente[
              "contratante"
            ]
          : "";
      vm.form.group =
        $localStorage.saved_filters_reporte_recibo_subsecuente &&
        $localStorage.saved_filters_reporte_recibo_subsecuente["group"]
          ? $localStorage.saved_filters_reporte_recibo_subsecuente["group"]
          : 0;
      vm.form.poliza_number =
        $localStorage.saved_filters_reporte_recibo_subsecuente &&
        $localStorage.saved_filters_reporte_recibo_subsecuente["poliza_number"]
          ? $localStorage.saved_filters_reporte_recibo_subsecuente[
              "poliza_number"
            ]
          : "";
      vm.form.payment =
        $localStorage.saved_filters_reporte_recibo_subsecuente &&
        $localStorage.saved_filters_reporte_recibo_subsecuente["payment"]
          ? $localStorage.saved_filters_reporte_recibo_subsecuente["payment"]
          : 0;
      vm.form.vendedor =
        $localStorage.saved_filters_reporte_recibo_subsecuente &&
        $localStorage.saved_filters_reporte_recibo_subsecuente["vendedor"]
          ? $localStorage.saved_filters_reporte_recibo_subsecuente["vendedor"]
          : 0;
      vm.form.status_recibos =
        $localStorage.saved_filters_reporte_recibo_subsecuente &&
        $localStorage.saved_filters_reporte_recibo_subsecuente["status_recibos"]
          ? $localStorage.saved_filters_reporte_recibo_subsecuente[
              "status_recibos"
            ]
          : 0;
      vm.form.ejecutivo =
        $localStorage.saved_filters_reporte_recibo_subsecuente &&
        $localStorage.saved_filters_reporte_recibo_subsecuente["ejecutivo"]
          ? $localStorage.saved_filters_reporte_recibo_subsecuente["ejecutivo"]
          : 0;
      vm.form.deliver =
        $localStorage.saved_filters_reporte_recibo_subsecuente &&
        $localStorage.saved_filters_reporte_recibo_subsecuente["deliver"]
          ? $localStorage.saved_filters_reporte_recibo_subsecuente["deliver"]
          : 0;
    }

    function returnToReceipts(x) {
      vm.show_binnacle = false;
      $scope.filtros.tipo_recibo = vm.form.tipo_recibo
        ? vm.form.tipo_recibo
        : 0;
    }
    $scope.showTabs = function (param) {
      $scope.tab = param ? true : false;
    };
    function returnToNote() {
      vm.show_binnacle_nc = false;
    }
    function getLog(rece) {
      dataFactory
        .get("get-specific-log", { model: 4, associated_id: rece.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    }

    // function verFlotilla(rece) {
    $scope.verFlotilla = function (colect) {
      dataFactory
        .get("get-certificates-flotilla", { id_caratula: colect.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/flotilla.modal.html",
            controller: "CertificateCtrl",
            size: "lg",
            resolve: {
              certificates: function () {
                return response.data;
              },
              poliza_number: function () {
                return colect.poliza_number;
              },
              caratula: function () {
                return colect;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    };

    $scope.exportData = function (param) {
      $scope.filtros.tipo_recibo = vm.form.tipo_recibo
        ? vm.form.tipo_recibo
        : 0;
      $scope.filtros.user_pay = vm.user_pay_selected ? vm.user_pay_selected : 0;
      $scope.filtros.status = vm.form.status_recibos
        ? vm.form.status_recibos
        : 0;
      $scope.filtros.delivered = vm.form.deliver ? vm.form.deliver.id : 0;
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   // $scope.excel_subsecuente = 'v2/recibos/reporte-recibos-subsec-excel/';
      //   $scope.excel_subsecuente = 'service_reporte-v2-recibosSubsReport-excel'
      $scope.excel_subsecuente = "service_reporte-recibosSubsReport-excel";
      $http({
        // method: 'GET',
        // url: url.IP + 'reporte-cobranzamod',
        // params: $scope.filtros,
        method: "POST",
        url: url.IP + $scope.excel_subsecuente,
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function success(request) {
          if (request.status === 200) {
            var blob = new Blob([request.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte_RecibosSubsecuentes.xls");
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    function showBinnacle(param, parType) {
      vm.receipt = param;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.receipt_url = param.url;
      vm.receipt_id = param.id;
      if (param.gastos_expedicion) {
        vm.notas_id = param.id;
        vm.show_binnacle_nc = true;
      } else {
        vm.show_binnacle = true;
      }
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }
    vm.changeReceipts = changeReceipts;
    function changeReceipts(par, asc) {
      switch (par) {
        case 1:
          Generar($scope.param, par, asc);
          vm.receipts_tipo_asc = asc;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 2:
          Generar($scope.param, par, asc);
          vm.receipts_cont_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 3:
          Generar($scope.param, par, asc);
          vm.receipts_nump_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 4:
          Generar($scope.param, par, asc);
          vm.receipts_periodo_asc = asc;
          vm.receipts_cont_asc = 0;
          vm.receipts_tipo_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 5:
          Generar($scope.param, par, asc);
          vm.receipts_aseg_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          vm.receipts_ffin_asc = 0;
          break;
        case 6:
          Generar($scope.param, par, asc);
          vm.receipts_estatus_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 7:
          Generar($scope.param, par, asc);
          vm.receipts_ptotal_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 8:
          Generar($scope.param, par, asc);
          vm.receipts_operador_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_ffin_asc = 0;
          break;
      }
    }
    vm.changeNCr = changeNCr;
    vm.show_nota = false;
    function changeNCr(par, asc) {
      switch (par) {
        case 1:
          getNotas($scope.param, par, asc);
          vm.nota_cont_asc = asc;
          vm.nota_folio_asc = 0;
          vm.nota_numend_asc = 0;
          vm.nota_numpol_asc = 0;
          vm.nota_fecha_asc = 0;
          vm.nota_ptotal_asc = 0;
          vm.nota_pago_asc = 0;
          vm.nota_moneda_asc = 0;
          break;
        case 2:
          getNotas($scope.param, par, asc);
          vm.nota_folio_asc = asc;
          vm.nota_cont_asc = 0;
          vm.nota_numend_asc = 0;
          vm.nota_numpol_asc = 0;
          vm.nota_fecha_asc = 0;
          vm.nota_ptotal_asc = 0;
          vm.nota_pago_asc = 0;
          vm.nota_moneda_asc = 0;
          break;
        case 3:
          getNotas($scope.param, par, asc);
          vm.nota_numend_asc = asc;
          vm.nota_cont_asc = 0;
          vm.nota_folio_asc = 0;
          vm.nota_numpol_asc = 0;
          vm.nota_fecha_asc = 0;
          vm.nota_ptotal_asc = 0;
          vm.nota_pago_asc = 0;
          vm.nota_moneda_asc = 0;
          break;
        case 4:
          getNotas($scope.param, par, asc);
          vm.nota_numpol_asc = asc;
          vm.nota_folio_asc = 0;
          vm.nota_cont_asc = 0;
          vm.nota_numend_asc = 0;
          vm.nota_fecha_asc = 0;
          vm.nota_ptotal_asc = 0;
          vm.nota_pago_asc = 0;
          vm.nota_moneda_asc = 0;
          break;
        case 5:
          getNotas($scope.param, par, asc);
          vm.nota_fecha_asc = asc;
          vm.nota_cont_asc = 0;
          vm.nota_folio_asc = 0;
          vm.nota_numend_asc = 0;
          vm.nota_numpol_asc = 0;
          vm.nota_ptotal_asc = 0;
          vm.nota_pago_asc = 0;
          vm.nota_moneda_asc = 0;
          break;
        case 6:
          getNotas($scope.param, par, asc);
          vm.nota_fecha_asc = 0;
          vm.nota_cont_asc = 0;
          vm.nota_folio_asc = 0;
          vm.nota_numend_asc = 0;
          vm.nota_numpol_asc = 0;
          vm.nota_ptotal_asc = asc;
          vm.nota_pago_asc = 0;
          vm.nota_moneda_asc = 0;
          break;
        case 7:
          getNotas($scope.param, par, asc);
          vm.nota_fecha_asc = 0;
          vm.nota_cont_asc = 0;
          vm.nota_folio_asc = 0;
          vm.nota_numend_asc = 0;
          vm.nota_numpol_asc = 0;
          vm.nota_ptotal_asc = 0;
          vm.nota_pago_asc = asc;
          vm.nota_moneda_asc = 0;
          break;
        case 8:
          getNotas($scope.param, par, asc);
          vm.nota_fecha_asc = 0;
          vm.nota_cont_asc = 0;
          vm.nota_folio_asc = 0;
          vm.nota_numend_asc = 0;
          vm.nota_numpol_asc = 0;
          vm.nota_ptotal_asc = 0;
          vm.nota_pago_asc = 0;
          vm.nota_moneda_asc = asc;
          break;
      }
    }

    function Generar(param, order, asc, page) {
      $scope.param = param;
      getCobranza(param, order, asc, page);
      getNotas(param, order, asc, page);
      if (vm.show_binnacle == true || vm.show_binnacle_nc == true) {
        vm.show_binnacle = false;
        vm.show_binnacle_nc = false;
      }
    }
    vm.show_button1 = false;
    vm.show_button2 = false;
    vm.show_button3 = false;
    vm.show_button4 = false;
    vm.show_button0 = false;
    vm.show_button_nc = false;
    function getNotas(param, order, asc, page) {
      // -------------------------NOTAS DE CRÉDITO -----------
      if (vm.buscar_por_folio) {
      } else {
        var params = {
          provider: vm.form.provider.id
            ? vm.form.provider.id
            : vm.form.provider,
          vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
          ejecutivo: vm.form.ejecutivo ? vm.form.ejecutivo.id : 0,
          ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
          subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
          since: vm.form.since ? vm.form.since : vm.form.si,
          until: vm.form.until ? vm.form.until : vm.form.un,
          payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
          // status: vm.form.status.id ? vm.form.status.id : vm.form.status,
          contratante: vm.form.contratante.value
            ? vm.form.contratante.value
            : 0,
          grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
          type_contractor: vm.form.contratante.type
            ? vm.form.contratante.type
            : 0,
          status: param,
          page: page ? page : 1,
          dates: vm.form.dates,
          ramos: vm.ramos_selected ? vm.ramos_selected : 0,
          subramos: vm.subramos_selected ? vm.subramos_selected : 0,
          providers: vm.providers_selected ? vm.providers_selected : 0,
        };

        if (vm.form.contratante) {
          if (vm.form.contratante.val == "") {
            params.contratante = 0;
            vm.form.contratante.value = "";
            vm.form.contratante.type = "";
          }
        }
        if (vm.form.group) {
          if (vm.form.group.val == "") {
            params.grupo = 0;
            vm.form.group.value = "";
            vm.form.group.type = "";
          }
        }
        // if((params.since) <= (params.until)){
        params.since = params.since + " " + "00:00:00";
        params.until = params.until + " " + "23:59:59";
        if ($location.path() == "/cobranzas/recibosPendientes") {
          params.since = "01/01/1950" + " " + "00:00:00";
          params.until = "31/12/2099" + " " + "23:59:59";
          params.status = 1;
        }
        $scope.filtros = params;
        $scope.filtros.order = order;
        $scope.filtros.asc = asc;
        $scope.filtros.polizaId = 0;
        $scope.filtros.order = order;
        $scope.filtros.asc = asc;
        $scope.filtros.polizaId = 0;
        $scope.filtros.page = page ? page : 1;
        // $http({
        //   // method: 'GET',
        //   // url: url.IP + 'get-notas/',
        //   // params: $scope.filtros
        //   method: 'POST',
        //   url: url.IP + 'get-notas-cobranza/',
        //   data: $scope.filtros
        // })
        // .then(function success(response) {
        //   if(response.status === 200 && response.data.results.length) {
        //     $scope.results_nc = response.data.results;

        //     var today = new Date();
        //     today = today.getTime();

        //     if (response.data.results.length){
        //       vm.show_button_nc = true;
        //     }

        //     response.data.results.forEach(function (note) {
        //       var fecha = new Date(note.fecha_emision).getTime();
        //       var diff = today - fecha;
        //       note.antiguedad = parseInt(diff/(1000*60*60*24))
        //     })

        //     vm.notas_credito = response.data.results;

        //     // vm.notas_credito = {
        //     //   count: response.data.count,
        //     //   previous: response.data.previous,
        //     //   next: response.data.next
        //     // };
        //     vm.notas_credito_a = {
        //         count: response.data.count,
        //         previous: url.IP +'get-notas/',
        //         next: url.IP +'get-notas/'
        //       };
        //     testPagination_nc('vm.notas_credito', 'vm.notas_credito_a');

        //     if(vm.notas_credito){
        //       vm.show_pag_nc = true;
        //     } else{
        //       vm.show_pag_nc = false;
        //     }

        //   } else {
        //     $scope.results_nc = []
        //     vm.notas_credito = []
        //     toaster.warning("No se encontraron notas de crédito")
        //   }
        // });
        // ...................NOTAS DE CRÉDITO -----------------
      }
    }
    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http.get(url.IP + "subramos-by-ramo/" + vm.id).then(function (data) {
            vm.subramos_toselected = data.data;
          });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.id);
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };
    function getCobranza(param, order, asc, parPage) {
      vm.receipts = [];
      var lb = Ladda.create(document.querySelector(".ladda-button2"));

      lb.start();
      if (param == 1) {
        vm.pagar_is_posible = true;
      } else {
        vm.pagar_is_posible = false;
      }
      if (param == 2) {
        vm.liquidar_is_posible = true;
      } else {
        vm.liquidar_is_posible = false;
      }
      $scope.order = order;
      $scope.asc = asc;
      $scope.param_a = param;
      $scope.page = parPage ? parPage : 1;
      vm.show_pag_policy = false;
      $scope.results = [];
      vm.receipts = [];
      $scope.param = param;

      if (param == 1) {
        //pendiente
        vm.show_button1 = true;
      }
      var params = {
        provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider,
        vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
        ejecutivo: vm.form.ejecutivo ? vm.form.ejecutivo.id : 0,
        ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
        subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
        // status: vm.form.status.id ? vm.form.status.id : vm.form.status,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
        type_contractor: vm.form.contratante.type
          ? vm.form.contratante.type
          : 0,
        status: vm.form.status_recibos ? vm.form.status_recibos : 0,
        page: parPage ? parPage : 1,
        dates: vm.form.dates,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        tipo_recibo: vm.form.tipo_recibo ? vm.form.tipo_recibo : 0,
        delivered: vm.form.deliver ? vm.form.deliver.id : 0,
        user_pay: vm.user_pay_selected ? vm.user_pay_selected : 0,
      };
      if (vm.form.contratante.val == "") {
        params.contratante = 0;
        vm.form.contratante.value = "";
        vm.form.contratante.type = "";
      }
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";

      $scope.filtros = params;
      $scope.filtros.order = order;
      $scope.filtros.asc = asc;
      $scope.filtros.polizas = vm.form.poliza_number;

      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.search_subsecuente = 'v2/recibos/reporte-recibos-subsecuentes/';
      $scope.search_subsecuente = "reporte-recibos-subsecuentes/";

      $http({
        method: "POST",
        url: url.IP + $scope.search_subsecuente,
        data: $scope.filtros,
      }).then(
        function success(response) {
          vm.receipts_to_pay_lenght = response.data.count;
          $rootScope.results_rec = response.data;
          $rootScope.filtros_consulta = $scope.filtros;
          if (response.status === 200 && response.data.results.length) {
            $scope.results = response.data.results;
            lb.stop();
            // if($location.path() == "/cobranzas/recibosPendientes"){
            vm.receipts = response.data.results;
            vm.receipts = {
              count: response.data.count,
              previous: url.IP + $scope.search_subsecuente,
              next: url.IP + $scope.search_subsecuente,
            };
            testPagination("vm.receipts", "vm.receipts");
            vm.show_paginacion_recibos = true;
            // }

            var item_ = $scope.results[0];

            $scope.head_data = [];
            for (var i in item_) {
              var obj = { field: i };
              lb.stop();
              $scope.head_data.push(obj);
            }

            if (response.status === 200 && response.data.results.length) {
              lb.stop();
              vm.receipts = [];
              vm.receipt = {};
              vm.receipts = response.data.results;
              vm.receipt = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };
              if (vm.receipts) {
                vm.show_paginacion_recibos = true;
              } else {
                vm.show_paginacion_recibos = false;
              }
              testPagination("vm.receipts", "vm.receipt");
            }
          } else {
            lb.stop();
            toaster.warning("No se encontraron recibos");
            vm.show_paginacion_recibos = false;
          }
        },
        function error(err) {
          console.log("error", err);
          lb.stop();
        }
      );

      $localStorage.saved_filters_reporte_recibo_subsecuente =
        angular.copy(params);
      $localStorage.saved_filters_reporte_recibo_subsecuente["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_reporte_recibo_subsecuente["group"] =
        vm.form.group;
      $localStorage.saved_filters_reporte_recibo_subsecuente["poliza_number"] =
        vm.form.poliza_number;
      $localStorage.saved_filters_reporte_recibo_subsecuente["payment"] =
        vm.form.payment;
      $localStorage.saved_filters_reporte_recibo_subsecuente["vendedor"] =
        vm.form.vendedor;
      $localStorage.saved_filters_reporte_recibo_subsecuente["status_recibos"] =
        vm.form.status_recibos;
      $localStorage.saved_filters_reporte_recibo_subsecuente["ejecutivo"] =
        vm.form.ejecutivo;
      $localStorage.saved_filters_reporte_recibo_subsecuente["deliver"] =
        vm.form.deliver;
    }
    $scope.sendMailContractor = function (receipt) {
      if (receipt.contratante) {
        if (receipt.contratante.email && !receipt.contratante.email == "") {
          var arrayEmails = [];
          arrayEmails = [receipt.contratante.email];
          $http
            .post(url.IP + "payment-reminder-manual/", {
              r_id: receipt.id,
              emails: arrayEmails,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  SweetAlert.swal(
                    "Enviado",
                    "El recordatorio ha sido enviado",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "No se envió el recordatorio. Contacte a su administrador.",
                    "error"
                  );
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          toaster.info("El contratante no tiene correo, agregue correos");
        }
      } else {
        toaster.error("El contratante no tiene correo, agregue correos");
      }
    };

    $scope.liquidar_masivo = function (flag, order, asc, parPage) {
      if (flag == 1) {
        if (vm.receipts_to_pay_lenght > 1)
          var _text =
            "Confirmar el pago de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibos)";
        else
          var _text =
            "Confirmar el pago de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibo)";
        var data_alert = {
          title: "Pagar selección",
          text: _text,
          type: "warning",
          confirmButtonText: "Pagar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
        };
      } else {
        if (vm.receipts_to_pay_lenght > 1)
          var _text =
            "Confirmar liquidación de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibos)";
        else
          var _text =
            "Confirmar liquidación de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibo)";
        var data_alert = {
          title: "Liquidar selección",
          text: _text,
          type: "warning",
          confirmButtonText: "Liquidar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
        };
      }
      SweetAlert.swal(data_alert, function (isConfirm) {
        if (isConfirm) {
          var params = {
            provider: vm.form.provider.id
              ? vm.form.provider.id
              : vm.form.provider,
            vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
            ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
            subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
            since: vm.form.since ? vm.form.since : vm.form.si,
            until: vm.form.until ? vm.form.until : vm.form.un,
            payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
            ejecutivo: vm.form.ejecutivo ? vm.form.ejecutivo.id : 0,
            // status: vm.form.status.id ? vm.form.status.id : vm.form.status,
            tipo_recibo: vm.form.tipo_recibo ? vm.form.tipo_recibo : 0,
            contratante: vm.form.contratante.value
              ? vm.form.contratante.value
              : 0,
            grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
            type_contractor: vm.form.contratante.type
              ? vm.form.contratante.type
              : 0,
            status: flag,
            page: parPage ? parPage : 1,
            dates: vm.form.dates,
            ramos: vm.ramos_selected ? vm.ramos_selected : 0,
            subramos: vm.subramos_selected ? vm.subramos_selected : 0,
            providers: vm.providers_selected ? vm.providers_selected : 0,
            polizas: vm.form.poliza_number ? vm.form.poliza_number : 0,
          };
          if (vm.form.contratante.val == "") {
            params.contratante = 0;
            vm.form.contratante.value = "";
            vm.form.contratante.type = "";
          }
          // if((params.since) <= (params.until)){
          params.since = params.since + " " + "00:00:00";
          params.until = params.until + " " + "23:59:59";
          if ($location.path() == "/cobranzas/recibosPendientes") {
            params.since = "01/01/1950" + " " + "00:00:00";
            params.until = "31/12/2099" + " " + "23:59:59";
            params.status = 1;
          }
          $scope.filtros = params;
          $scope.filtros.order = order;
          $scope.filtros.asc = asc;
          $scope.filtros.user_pay = vm.user_pay_selected
            ? vm.user_pay_selected
            : 0;
          $scope.filtros.polizaId = 0;
          $http({
            // method: 'GET',
            // url: url.IP + 'get-cobranza/',
            // params: $scope.filtros
            method: "POST",
            url: url.IP + "pay-cobranza-massive/",
            data: $scope.filtros,
          }).then(function (response) {
            if (response.status == 200 || response.status == 201) {
              if (flag == 1) {
                swal(
                  "Pagado, folio: " + response.data.folio,
                  "La selección ha sido pagada",
                  "success"
                );
                $scope.log_liq_and_pay_massive(response.data);
              } else {
                swal(
                  "Liquidado, folio: " + response.data.folio,
                  "La selección ha sido liquidada",
                  "success"
                );
                $scope.log_liq_and_pay_massive(response.data);
              }
            } else {
              swal("Error: la selección no ha sido pagada", "error");
            }
            getCobranza(flag, order, asc, parPage);
          });
        } else {
        }
      });
    };
    // Liquidación de recibos seleccionados
    $scope.liquidar_selected = function () {
      if ($scope.recibos_a_liquidar.length > 0) {
        $scope.folio_liquidacion = $scope.recibos_a_liquidar[0].id;
        var _text =
          "¿ Confirma Liquidación de la selección de " +
          $scope.recibos_a_liquidar.length +
          " recibos ?";
      } else {
        toaster.warning("Debe agregar recibos a liquidar");
        return;
      }
      var data_alert = {
        title: "Liquidar recibos seleccionados",
        text: _text,
        type: "warning",
        confirmButtonText: "Liquidar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (isConfirm) {
        if (isConfirm) {
          $scope.recibos_a_liquidar.forEach(function (receipt, index) {
            $http({
              // method: 'GET',
              // url: url.IP + 'get-cobranza/',
              // params: $scope.filtros
              method: "PATCH",
              url: receipt.url,
              data: {
                liquidacion_folio: $scope.folio_liquidacion,
                status: 5,
              },
            }).then(function (response) {
              swal(
                "Liquidado, folio: " + response.data.liquidacion_folio,
                "La selección ha sido liquidada",
                "success"
              );
              $scope.log_liq_and_pay_selected(response.data);
            });
          });
          getCobranza(2, 1, 1, 1);
        } else {
        }
      });
    };
    // Pago de recibos seleccionados
    $scope.pay_receipts_selected = function () {
      if ($scope.recibos_a_pagar.length > 0) {
        $scope.folio_pago = $scope.recibos_a_pagar[0].id;
        var _text =
          "¿Confirma el Pago de la selección de " +
          $scope.recibos_a_pagar.length +
          " recibos?";
      } else {
        toaster.warning("Debe seleccionar recibos a pagar");
        return;
      }
      var data_alert = {
        title: "Pagar recibos seleccionados",
        text: _text,
        type: "warning",
        confirmButtonText: "Pagar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (isConfirm) {
        if (isConfirm) {
          $scope.recibos_a_pagar.forEach(function (receipt, index) {
            $http({
              // method: 'GET',
              // url: url.IP + 'get-cobranza/',
              // params: $scope.filtros
              method: "PATCH",
              url: receipt.url,
              data: {
                folio_pago: $scope.folio_pago,
                status: 1,
                user_pay: $scope.user_pay ? $scope.user_pay.url : null,
              },
            }).then(function (response) {
              swal(
                "Pagado, folio: " + response.data.folio_pago,
                "La selección ha sido pagada",
                "success"
              );
              $scope.log_liq_and_pay_selected(response.data);
            });
          });
          getCobranza(1, 1, 1, 1);
        } else {
        }
      });
    };
    // Conciliar conculta
    $scope.conciliar_masivo = function (flag, order, asc, parPage) {
      $rootScope.banco_selected = 0;
      $rootScope.name = "";
      $rootScope.account = "";
      $rootScope.observation = "";
      $rootScope.addAccount = false;
      $http.get(url.IP + "bancos/").then(function (bank) {
        $rootScope.bancos = bank.data;
      });
      $http.get(url.IP + "accounts/").then(function (response) {
        vm.accounts = response.data.results;
        $rootScope.acounts_data = response.data.results;
        vm.cuenta = $rootScope.acounts_data[0];
      });
      vm.form.conciliate_date = convertDate(new Date());
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/conciliar_masivo_modal.html",
        controller: "CobranzasCtrl",
        size: "md",
        resolve: {
          flag: function () {
            return flag;
          },
          order: function () {
            return order;
          },
          asc: function () {
            return asc;
          },
          parPage: function () {
            return parPage;
          },
          valueReceipt: function () {
            return "";
          },
        },
      });
    };
    $scope.add_account = function () {
      $rootScope.addAccount = true;
    };
    $scope.cancel_addAccount = function () {
      $rootScope.addAccount = false;
    };
    $scope.selectBanco = function (s) {
      $rootScope.banco_selected = s;
    };
    $scope.selectData = function (n, a, o) {
      if (n) {
        $rootScope.name = n;
      }
      if (a) {
        $rootScope.account = a;
      }
      if (o) {
        $rootScope.observation = n;
      }
    };
    $scope.saveAccount = function () {
      $rootScope.addAccount = false;
      if ($rootScope.banco_selected) {
        $http
          .post(url.IP + "accounts/", {
            name: $rootScope.name,
            account: $rootScope.account,
            observation: $rootScope.observation,
            bank: $rootScope.banco_selected,
          })
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                $rootScope.new_account = request.data;
                // accounts.push(request.data);
                toaster.success("Cuenta creada exitosamente");
              } else {
                toaster.warning("Error al crear cuenta");
              }
            },
            function error(error) {
              console.log("error - email", error);
            }
          )
          .catch(function (e) {
            console.log("error - catch", e);
          });
      } else {
        toaster.warning(MESSAGES.WARNING.EMPTYBANK);
      }
    };
    $scope.conciliar_consulta = function (cc, fa, acc, consulta, filtros) {
      if (!cc || !fa || !acc) {
        toaster.error("Complete todos los campos");
        return;
      }
      var _text =
        "Confirmar la Conciliación de la consulta (" +
        consulta.count +
        " recibo)";
      $scope.filtros_conciliacion = filtros;
      var data_alert = {
        title: "Conciliar selección",
        text: _text,
        type: "warning",
        confirmButtonText: "Conciliar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: false,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (isConfirm) {
        if (isConfirm) {
          $scope.filtros_conciliacion.comision_conciliada =
            parseFloat(cc).toFixed(2);
          $scope.filtros_conciliacion.conciliacion_date =
            datesFactory.toDate(fa);
          $scope.filtros_conciliacion.account = acc.id;
          $http({
            // method: 'GET',
            // url: url.IP + 'get-cobranza/',
            // params: $scope.filtros
            method: "POST",
            url: url.IP + "conciliar-cobranza-massive/",
            data: $scope.filtros_conciliacion,
          }).then(function (response) {
            if (response.status == 200 || response.status == 201) {
              swal("Conciliada, folio de conciliación: " + response.data.folio);
              vm.receipts = [];
              getCobranza(1, 1, 1, 1);
              activate();
            } else {
              swal("Error: La consulta NO ha sido conciliada", "error");
            }
            $uibModalInstance.dismiss("cancel");
            vm.receipts = [];
            getCobranza(1, 1, 1, 1);
            activate();
          });
        } else {
          $uibModalInstance.dismiss("cancel");
        }
      });
    };
    // Log de registro de pago y/o liquidación recibos masivo
    $scope.log_liq_and_pay_massive = function (rec) {
      if (rec.status == 1) {
        $scope.status_receipt =
          "actualizó recibo a pagado( con el folio de pago: " + rec.folio;
      } else if (rec.status == 5) {
        $scope.status_receipt =
          "actualizó reciboa liquidado con el folio de liquidación: " +
          rec.folio;
      }

      var params = {
        model: 4,
        event: "POST",
        associated_id: rec.id,
        identifier: $scope.status_receipt,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
    };
    // Log de registro de pago y/o liquidación recibos seleccionados
    $scope.log_liq_and_pay_selected = function (rec) {
      if (rec.status == 1) {
        $scope.status_receipt =
          "actualizó recibo(s) " +
          $scope.recibos_a_pagar.length +
          " a pagado(s) " +
          "con el folio de pago: " +
          $scope.folio_pago;
      } else if (rec.status == 5) {
        $scope.status_receipt =
          "actualizó recibo(s) " +
          $scope.recibos_a_liquidar.length +
          " a liquidado(s) " +
          " con el folio de liquidación: " +
          $scope.folio_liquidacion;
      }

      var params = {
        model: 4,
        event: "POST",
        associated_id: rec.id,
        identifier: $scope.status_receipt,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
    };
    $scope.addEmailsConfirm = function (valueReceipt) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        size: "md",
        resolve: {
          valueReceipt: function () {
            return valueReceipt;
          },
        },
      });
    };

    function responsiv() {
      $("#pendientes").trigger("resize");
      $("#pagados").trigger("resize");
      $("#cancelados").trigger("resize");
    }

    function changeStatusModal(receipt) {
      var insurance = receipt.poliza;
      var index = vm.receipts.indexOf(receipt);

      if ($uibModalInstance) {
        $uibModalInstance.close({
          action: 6,
          data: { receipt: receipt, from: true },
        });
      } else {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/cobranzas/cobranzas.modal.html",
          controller: "CobranzasModal",
          size: "lg",
          resolve: {
            receipt: function () {
              return receipt;
            },
            insurance: function () {
              return insurance;
            },
            from: function () {
              return null;
            },
            bono: function () {
              return null;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        modalInstance.result.then(function (receipt) {
          vm.receipts.splice(index, 1);
          activate();
        });
      }
    }
    function NotasModal(nota) {
      vm.insurance_ = nota;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/notaCredito.modal.html",
        controller: "NotaCreditoCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return nota;
          },
          insurance: function () {
            return vm.insurance_;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        vm.notas_credito.splice(index, 1);
        activate();
      });
    }

    function emailsReminderAdd(receipt) {
      $scope.form = {};
      $scope.form.emails_reminder = [];
      var mail = {
        email: "",
      };
      if (receipt.contratante) {
        var cmail = {
          email: receipt.contratante.email,
        };
      }
      if (receipt.contratante) {
        $scope.form.emails_reminder.push(cmail);
      } else {
        $scope.form.emails_reminder.push(mail);
      }
      vm.insurance_ = receipt;
      $scope.receipt_pay = receipt;
      $uibModal.receipt = receipt;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return vm.insurance_;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    }

    $scope.addEmails = function (type) {
      var mail = {
        email: "",
      };
      $scope.form.emails_reminder.push(mail);
    };

    $scope.deleteEmails = function (mail, type) {
      $scope.form.emails_reminder.splice(mail, 1);
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    $scope.subjectEmail = "";
    $scope.messageEmail = "";

    $scope.sendReminder = function (mails) {
      console.log(mails);
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (mails.length > 0) {
        $scope.error_email = false;
        $scope.receipt_pay = $uibModal.receipt;
        var arrayEmails = [];

        mails.forEach(function (it) {
          if (validateEmail(it.email)) {
            arrayEmails.push(it.email);
          } else {
            $scope.error_email = true;
          }
        });

        if (!$scope.error_email) {
          if ($scope.receiptAll.contratante) {
            arrayEmails.push($scope.receiptAll.contratante.email);
            $scope.correos.forEach(function (elem, index) {
              arrayEmails.push(elem.correo);
            });
          }

          if (arrayEmails.length == 0) {
            l.stop();
            SweetAlert.swal("Error", "Agregue correos", "error");
            return;
          }

          if (arrayEmails) {
            $http
              .post(url.IP + "payment-reminder-manual/", {
                r_id: $scope.receiptAll.id,
                emails: arrayEmails,
                asunto: $scope.subjectEmail,
                mensaje: $scope.messageEmail,
              })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    l.stop();
                    swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                    $uibModalInstance.dismiss("cancel");
                  } else {
                    l.stop();
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                    $uibModalInstance.dismiss("cancel");
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          }
        } else {
          l.stop();
          SweetAlert.swal(
            "Error",
            "Verifique el formato de los correo",
            "error"
          );
        }
      } else {
        if ($scope.receiptAll.contratante) {
          if (
            $scope.receiptAll.contratante.email &&
            !$scope.receiptAll.contratante.email == ""
          ) {
            var arrayEmails = [];
            arrayEmails = [$scope.receiptAll.contratante.email];
            $scope.correos.forEach(function (elem, index) {
              arrayEmails.push(elem.correo);
            });
            $http
              .post(url.IP + "payment-reminder-manual/", {
                r_id: $scope.receiptAll.id,
                emails: arrayEmails,
                asunto: $scope.subjectEmail,
                mensaje: $scope.messageEmail,
              })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    SweetAlert.swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                    $uibModalInstance.dismiss("cancel");
                  } else {
                    SweetAlert.swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                    $uibModalInstance.dismiss("cancel");
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
            toaster.error(
              "El contratante no tiene correo, agregue correos",
              "error"
            );
          }
        }
      }
    };

    function showPhone(receipt) {
      var number = String(receipt.contratante.phone);
      var formattedNumber = number;
      if (number[0] == "1") {
        var c = number[0] == "1" ? "1 " : "";
        number = number[0] == "1" ? number.slice(1) : number;
      } else if (number[0] == "0" && number[1] == "1") {
        var c = number[0] == "0" && number[1] == "1" ? "01 " : "";
        number =
          number[0] == "0" && number[1] == "1" ? number.slice(2) : number;
      } else var c = "";
      var area;
      var front;
      if (
        number.substring(0, 2) == 55 ||
        number.substring(0, 2) == 33 ||
        number.substring(0, 2) == 81
      ) {
        area = number.substring(0, 2);
        front = number.substring(2, 6);
      } else {
        area = number.substring(0, 3);
        front = number.substring(3, 6);
      }

      var end = number.substring(6, 10);
      var ext = number.substring(10, 15);

      if (front) {
        formattedNumber = c + "(" + area + ") " + front;
      }
      if (end) {
        formattedNumber += "-" + end;
      }
      if (ext) {
        formattedNumber += " ext. " + ext;
      }
      SweetAlert.swal(
        {
          title: "Teléfono",
          text: formattedNumber,
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "##87CEFA",
          confirmButtonText: "Se hizo llamada",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var obj = {
              track_phone: true,
            };
            $http.patch(receipt.url, obj);
            swal.close();
          }
        }
      );
      // SweetAlert.swal({
      //   title: "Teléfono:",
      //   text: formattedNumber,
      //   type: "info"
      // });
    }

    function showEmail(receipt) {
      if (receipt.contratante) {
        var data_alert = {
          title: "Correo",
          text: receipt.contratante.email,
          type: "info",
          confirmButtonText: "Enviar recordatorio",
          cancelButtonText: "Salir",
          showCancelButton: true,
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
        };
      } else {
        var data_alert_correo = {
          title: "Correo",
          text: "Escribe el correo para enviar el recordatorio:",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: false,
          animation: "slide-from-top",
          inputPlaceholder: "email@mail.com",
        };
      }
      if (data_alert) {
        SweetAlert.swal(data_alert, function (isConfirm) {
          if (isConfirm) {
            $http
              .post(url.IP + "payment-reminder-manual/", { r_id: receipt.id })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                  } else {
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
          }
        });
      } else if (data_alert_correo) {
        SweetAlert.swal(data_alert_correo, function (inputValue) {
          if (inputValue === false) return false;

          if (inputValue === "") {
            swal.showInputError("Ingresa un correo");
            return false;
          }
          $http
            .post(url.IP + "payment-reminder-manual/", {
              r_id: receipt.id,
              email: inputValue,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  swal("Enviado", "El recordatorio ha sido enviado", "success");
                } else {
                  swal(
                    "Error",
                    "No se envió el recordatorio. Contacte a su administrador.",
                    "error"
                  );
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        });
      }
    }

    function showComment(receipt) {
      SweetAlert.swal({
        title: "Observaciones",
        text: receipt.description,
        type: "info",
      });
    }

    function close() {
      $state.go("index.main");
    }
    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        vm.getCobranza($scope.param_a, $scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        console.log(data);
        vm.providers = data.data;
      });
    }
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }
    function getReferenciador() {
      vm.vendedores = [];
      $http.get(url.IP + "get-vendors").then(function (user) {
        // $scope.vendors_data = user.data;
        user.data.forEach(function (u) {
          var obj = {
            name: u.first_name + " " + u.last_name,
            id: u.id,
          };
          vm.vendedores.push(obj);
        });
      });
    }

    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group.val) {
        var word_data = vm.form.group.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_group = 'v2/contratantes/grupos-match/';
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   var filter_contractor = 'v2/contratantes/contractors-match/';
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    function changeReferenciador(obj) {
      // console.log('obj---chRef',obj)
    }

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      }
      $http.get(url.IP + "ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.ramos = ramos.data;
      });
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      }
      try {
        vm.subramos = obj.subramo_ramo;
      } catch (e) {}
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    $scope.print = function (item) {};
    $scope.showEndorsement = function (endoso) {
      if (endoso.receipt_type == 2) {
        if (endoso.poliza.subramo == "Gastos Medicos") var type = "disease";
        else if (endoso.poliza.subramo == "Vida") var type = "life";
        else var type = "automobile";
      }
      $state.go("endosos.pendingDataMassive", {
        endorsementId: endoso.id,
        endorsementType: type,
      });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "ReporteCobranzaPendienteController",
      ReporteCobranzaPendienteController
    );

  ReporteCobranzaPendienteController.$inject = [
    "$window",
    "$uibModal",
    "$sce",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$filter",
    "$parse",
    "exportFactory",
    "ContratanteService",
    "$sessionStorage",
    "$localStorage",
  ];

  function ReporteCobranzaPendienteController(
    $window,
    $uibModal,
    $sce,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $filter,
    $parse,
    exportFactory,
    ContratanteService,
    $sessionStorage,
    $localStorage
  ) {
    var vm = this;

    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por Iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
    ];

    vm.option_policy = [
      {
        id: 1,
        name: "Inicio de vigencia",
      },
      {
        id: 2,
        name: "Vencimiento",
      },
      {
        id: 3,
        name: "Fecha de pago",
      },
      {
        id: 4,
        name: "Fecha de liquidación",
      },
      {
        id: 5,
        name: "Fecha de conciliación",
      },
      {
        id: 6,
        name: "Reporte de operación",
      },
    ];

    $scope.columnArray = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;
    $scope.showButtonExcel = false;

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.table = {};
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.changeUntil = changeUntil;
    vm.changeReceipts = changeReceipts;
    vm.goToInfo = goToInfo;
    vm.formatearNumero = formatearNumero;
    vm.changeGroupBy = changeGroupBy;

    $scope.infoUser = $sessionStorage.infoUser;

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    vm.form = {
      provider: 0,
      vendedor: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: 0,
      group: 0,
      recibos_pagados: false,
      add_precancelados: false,
      recibos_no_pagados: true,
      recibos_liquidados: false,
      recibos_conciliados: false,
      recibos_delivered: false,
      recibos_precancelados: false,
      recibos_cancelados: false,
      recibos_cerrados: false,
      recibos_pago_parcial: false,
      cve_agente: "",
      identifier: "",
      valueDolar: "",
      valueUdi: "",
    };
    vm.table = {
      headers: [
        "Recibo",
        "Estatus Recibo",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Fecha de Inicio",
        "Fecha de Fin",
        "Comisión",
        "Fecha de Vencimiento",
        "Número de Póliza",
        "Tipo",
        "Contratante",
        "Aseguradora",
        "Ramo",
        "Subramo",
        "Frecuencia de Pago",
        "Estatus Póliza",
        "Vigencia Póliza",
        "Clave de Agente",
        "Fecha Pago",
        "Fecha Liquidación",
        "Folio de Liquidación",
      ],
    };

    vm.group_by = [
      {
        id: 1,
        name: "Aseguradora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 7,
        name: "Usuario",
      },
      // ,{
      //   id: 6,
      //   name: 'Responsable'
      // }
    ];

    // $(window).load(function() {
    //     $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }
    $scope.numberFormatUdi = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueUdi = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      } else {
        console.log("gddf------------------->", toNumber);
      }
    };
    $scope.numberFormatDolar = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueDolar = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      } else {
        console.log("gddf------------------->", toNumber);
      }
    };

    function moneda(num) {
      num = num.toString().replace(/\$|\,/g, "");
      if (isNaN(num)) {
        num = "0";
      }
      var sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      var cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) {
        cents = "0" + cents;
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num =
          num.substring(0, num.length - (4 * i + 3)) +
          "," +
          num.substring(num.length - (4 * i + 3));
      }
      return (sign ? "" : "-") + "$" + num + "." + cents;
    }

    //Solo permite introducir numeros.
    // function soloNumeros(e){
    // $scope.numberFormat = function (e) {
    //   var key = window.event ? e.which : e.keyCode;
    //   if (key < 48 || key > 57) {
    //     e.preventDefault();
    //   }
    // }
    $scope.receipts_option = "todos";
    $scope.receits_domiciliados = 0;

    $scope.selectReceiptsOption = function (parValue) {
      if (parValue == "no_domiciliados") {
        $scope.receits_domiciliados = 2;
      } else if (parValue == "domiciliados") {
        $scope.receits_domiciliados = 1;
      } else {
        $scope.receits_domiciliados = 0;
      }
    };
    $scope.fianza_poliza = "ambas_pf";
    $scope.fianza_poliza_sel = 0;

    $scope.selectFianzaOption = function (parValue) {
      if (parValue == "fianza") {
        $scope.fianza_poliza_sel = 2;
      } else if (parValue == "poliza") {
        $scope.fianza_poliza_sel = 1;
      } else if (parValue == "bono") {
        $scope.fianza_poliza_sel = 3;
      } else if (parValue == "colectiva") {
        $scope.fianza_poliza_sel = 4;
      } else {
        $scope.fianza_poliza_sel = 0;
      }
    };
    $scope.recibo_nota = "ambos";
    $scope.recibo_nota_sel = 0;

    $scope.selectReciboOption = function (parValue) {
      if (parValue == "recibo") {
        $scope.recibo_nota_sel = 1;
      } else if (parValue == "nota") {
        $scope.recibo_nota_sel = 2;
      } else {
        $scope.recibo_nota_sel = 0;
      }
    };

    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.changeReport = function () {
      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id == 1) {
          $scope.created_at = true;
          $scope.vigency = false;
        } else if (vm.form.dates_sel.id == 2) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 3) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 4) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 5) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 6) {
          $scope.vigency = true;
          $scope.created_at = false;
        }
      } else {
        $scope.vigency = false;
        $scope.created_at = false;
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };

    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };
    $scope.selectUserPay = function (x, y) {
      vm.user_pay_selected = [];
      x.forEach(function (r) {
        vm.user_pay_selected.push(parseInt(r.id));
      });
    };
    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };

    activate();
    function changeReceipts(par, asc) {
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.receipts_rec_asc = asc;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.receipts_status_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.receipts_pneta_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.receipts_rpf_asc = asc;
          vm.receipts_status_asc = 0;
          vm.receipts_rec_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.receipts_der_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.receipts_iva_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 7:
          Generar(par, asc);
          vm.receipts_ptotal_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.receipts_fini_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.receipts_ffin_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.receipts_com_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.receipts_fvenc_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 12:
          Generar(par, asc);
          vm.receipts_nump_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 13:
          Generar(par, asc);
          vm.receipts_tip_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 14:
          Generar(par, asc);
          vm.receipts_cont_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 15:
          Generar(par, asc);
          vm.receipts_aseg_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 16:
          Generar(par, asc);
          vm.receipts_ramo_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 17:
          Generar(par, asc);
          vm.receipts_subr_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 18:
          Generar(par, asc);
          vm.receipts_fpago_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 19:
          Generar(par, asc);
          vm.receipts_status1_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 20:
          Generar(par, asc);
          vm.receipts_vig_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 21:
          Generar(par, asc);
          vm.receipts_clave_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          break;
        case 34:
          Generar(par, asc);
          vm.receipts_clave_asc = 0;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_folioliq_asc = asc;
          break;
      }
    }

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");

      return date;
    }

    function activate() {
      getProviders();
      getContractors();
      getClaves();
      getUsuarios();
      getReferenciador();
      getSubramos();
      getPermisions();
      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.sub_total = 0;
      $scope.comision = 0;
      vm.form.sincea = 12;
      vm.ramos_selected = [];
      vm.subramos_ramo_sel = [];
      vm.subramos_selected = [];
      vm.contratantes_selected = [];
      vm.claves_selected = [];
      vm.usuarios_selected = [];
      vm.user_pay_selected = [];
      vm.form.since = convertDate(new Date());
      var endingDate = convertDate(new Date());
      vm.form.until = endingDate;

      vm.form.contratante =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["contratante"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente["contratante"]
          : "";
      vm.form.group =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["group"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente["group"]
          : 0;
      vm.form.vendedor =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["vendedor"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente["vendedor"]
          : 0;
      vm.form.cve_agente =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["cve_agente"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente["cve_agente"]
          : "";
      vm.form.identifier =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["identifier"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente["identifier"]
          : "";
      vm.form.group_by =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["group_by"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente["group_by"]
          : 0;
      vm.form.dates_sel =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["dates_sel"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente["dates_sel"]
          : 0;
      vm.form.add_precancelados =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["dates_sel"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente[
              "add_precancelados"
            ]
          : false;
      vm.form.valueDolar =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["valueDolar"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente["valueDolar"]
          : "";
      vm.form.valUdi =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["valUdi"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente["valUdi"]
          : "";
      $scope.receipts_option =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["receipts_option"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente[
              "receipts_option"
            ]
          : "todos";
      $scope.fianza_poliza =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["fianza_poliza"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente[
              "fianza_poliza"
            ]
          : "ambas_pf";
      $scope.recibo_nota =
        $localStorage.saved_filters_reporte_recibo_pendiente &&
        $localStorage.saved_filters_reporte_recibo_pendiente["recibo_nota"]
          ? $localStorage.saved_filters_reporte_recibo_pendiente["recibo_nota"]
          : "ambos";

      if (vm.form.dates_sel) {
        $scope.vigency = true;
      }
    }

    function changeGroupBy() {
      $scope.grupos_result = [];
      $scope.showSums = false;
      vm.show_pag_cobranza = false;
    }
    function getPermisions() {
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            vm.acceso_reportes = perm;
            vm.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  vm.acceso_rep_fia = true;
                } else {
                  vm.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  vm.acceso_rep_sin = true;
                } else {
                  vm.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  vm.acceso_rep_end = true;
                } else {
                  vm.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  vm.acceso_rep_pol = true;
                } else {
                  vm.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  vm.acceso_rep_ren = true;
                } else {
                  vm.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  vm.acceso_rep_cob = true;
                } else {
                  vm.acceso_rep_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Comisiones") {
            vm.coms = perm;
            vm.coms.permissions.forEach(function (acc) {
              if (acc.permission_name == "Comisiones") {
                if (acc.checked == true) {
                  vm.permiso_comisiones = true;
                } else {
                  vm.permiso_comisiones = false;
                }
              }
            });
          }
        });
      }
    }
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 6,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
        // ----
        {
          id: 15,
          subramo_code: 15,
          subramo_name: "Individual",
        },
        {
          id: 16,
          subramo_code: 16,
          subramo_name: "Colectivas",
        },
        {
          id: 17,
          subramo_code: 17,
          subramo_name: "Penales",
        },
        {
          id: 18,
          subramo_code: 18,
          subramo_name: "No penales",
        },
        {
          id: 19,
          subramo_code: 19,
          subramo_name: "Amparo a conductores",
        },
        {
          id: 20,
          subramo_code: 20,
          subramo_name: "Obra",
        },
        {
          id: 21,
          subramo_code: 21,
          subramo_name: "Proveeduria",
        },
        {
          id: 22,
          subramo_code: 22,
          subramo_name: "Fiscales",
        },
        {
          id: 23,
          subramo_code: 23,
          subramo_name: "Arrendamiento",
        },
        {
          id: 24,
          subramo_code: 24,
          subramo_name: "Otras",
        },
        {
          id: 25,
          subramo_code: 25,
          subramo_name: "Suministro",
        },
        {
          id: 26,
          subramo_code: 26,
          subramo_name: "Compra Venta",
        },
        {
          id: 27,
          subramo_code: 27,
          subramo_name: "Otras",
        },
        {
          id: 28,
          subramo_code: 28,
          subramo_name: "Relación con fianza",
        },
        {
          id: 29,
          subramo_code: 29,
          subramo_name: "Sin relación con fianza",
        },
      ];
    }
    function Generar(order, asc, parPage) {
      var l = Ladda.create(document.querySelector(".ladda-buttonC"));
      l.start();

      if (vm.form.dates_sel == undefined || vm.form.dates_sel == null) {
        l.stop();
        SweetAlert.swal(
          "Información",
          "Es necesario seleccionar una opción de Reporte por",
          "error"
        );
        return;
      }

      $scope.order = order;
      $scope.asc = asc;

      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));

      if (antiguedad < 0) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }

      $scope.total = 0.0;
      $scope.prima_neta = 0.0;
      $scope.comision = 0.0;

      var params = {
        provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider,
        vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
        ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
        subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
        status: vm.form.status.id ? vm.form.status.id : vm.form.status,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
        type_contractor: vm.form.contratante.type
          ? vm.form.contratante.type
          : 0,
        recibos_pagados: vm.form.recibos_pagados,
        recibos_no_pagados: vm.form.recibos_no_pagados,
        recibos_liquidados: vm.form.recibos_liquidados,
        recibos_conciliados: vm.form.recibos_conciliados,
        recibos_precancelados: vm.form.recibos_precancelados,
        recibos_cancelados: vm.form.recibos_cancelados,
        recibos_cerrados: vm.form.recibos_cerrados,
        recibos_pago_parcial: vm.form.recibos_pago_parcial,
        recibos_delivered: vm.form.recibos_delivered,
        recibos_precancel: vm.form.add_precancelados,
        cve: vm.form.cve_agente ? vm.form.cve_agente : 0,
        order: order,
        asc: asc,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        claves: vm.claves_selected ? vm.claves_selected : 0,
        users: vm.usuarios_selected ? vm.usuarios_selected : 0,
        user_pay: vm.user_pay_selected ? vm.user_pay_selected : 0,
        page: parPage ? parPage : 1,
        group_by: vm.form.group_by ? vm.form.group_by.id : 0,
        identifier: vm.form.identifier ? vm.form.identifier : 0,
        report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 1,
        domiciliados: $scope.receits_domiciliados,
        recibos_por: $scope.fianza_poliza_sel,
        option: $scope.recibo_nota_sel,
        valDolar: vm.form.valueDolar
          ? parseFloat(vm.form.valueDolar).toFixed(2)
          : 0,
        valUdi: vm.form.valueUdi ? parseFloat(vm.form.valueUdi).toFixed(2) : 0,
      };
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          params.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.group) {
        if (vm.form.group.val == "") {
          params.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
      }
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      $scope.filtros = params;
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.search_pendiente = 'v2/recibos/reporte-cobranza-rep/';
      $scope.search_pendiente = "reporte-cobranza-rep/";
      $http({
        method: "POST",
        url: url.IP + $scope.search_pendiente,
        data: $scope.filtros,
      }).then(
        function success(response) {
          if (params.group_by == 0) {
            $scope.insurances = response.data.results;
            l.stop();
            $scope.sumas = response.data.sumas;

            $scope.count_insurances = angular.copy($scope.insurances);
            if ($scope.insurances.length < 10) {
              for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
                var object = {
                  recibo_numero: " ",
                  status: " ",
                  prima_neta: null,
                  rpf: null,
                  derecho: null,
                  iva: null,
                  prima_total: null,
                  fecha_inicio: " ",
                  fecha_fin: " ",
                  comision: null,
                  vencimiento: " ",
                  poliza: {
                    poliza_number: " ",
                    natural: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    forma_de_pago: " ",
                    status: " ",
                    start_of_validity: " ",
                    clave: {
                      clave: " ",
                    },
                  },
                  receipt_type: " ",
                };
                $scope.insurances.push(object);
              }
            }

            $scope.cobranza_config = {
              count: response.data.count,
              previous: url.IP + $scope.search_pendiente,
              next: url.IP + $scope.search_pendiente,
            };
            vm.show_pag_cobranza = true;
            testPagination("insurances", "cobranza_config");

            if ($scope.insurances[0].recibo_numero == " ") {
              toaster.warning("No se encontraron registros");
            } else {
              $scope.showButtonExcel = true;
              $scope.showSums = true;
            }
          } else {
            l.stop();
            // $scope.showSums = true;
            // $scope.sumas = response.data.sumas
            $scope.grupos_result = response.data.results;
            $scope.showButtonExcel = true;
          }
        },
        function error(err) {
          console.log("error", err);
          l.stop();
        }
      );

      // $http({
      //    method: 'GET',
      //      url: url.IP + 'get-sumas-cobranza',
      //      params: params
      //  }).then(function success(response) {
      //      $scope.sumas = response.data;
      //  })

      $localStorage.saved_filters_reporte_recibo_pendiente =
        angular.copy(params);
      $localStorage.saved_filters_reporte_recibo_pendiente["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_reporte_recibo_pendiente["group"] =
        vm.form.group;
      $localStorage.saved_filters_reporte_recibo_pendiente["vendedor"] =
        vm.form.vendedor;
      $localStorage.saved_filters_reporte_recibo_pendiente["cve_agente"] =
        vm.form.cve_agente;
      $localStorage.saved_filters_reporte_recibo_pendiente["identifier"] =
        vm.form.identifier;
      $localStorage.saved_filters_reporte_recibo_pendiente["group_by"] =
        vm.form.group_by;
      $localStorage.saved_filters_reporte_recibo_pendiente["dates_sel"] =
        vm.form.dates_sel;
      $localStorage.saved_filters_reporte_recibo_pendiente[
        "add_precancelados"
      ] = vm.form.add_precancelados;
      $localStorage.saved_filters_reporte_recibo_pendiente["valueDolar"] =
        vm.form.valueDolar;
      $localStorage.saved_filters_reporte_recibo_pendiente["valUdi"] =
        vm.form.valUdi;
      $localStorage.saved_filters_reporte_recibo_pendiente["receipts_option"] =
        $scope.receipts_option;
      $localStorage.saved_filters_reporte_recibo_pendiente["fianza_poliza"] =
        $scope.fianza_poliza;
      $localStorage.saved_filters_reporte_recibo_pendiente["recibo_nota"] =
        $scope.recibo_nota;
    }

    function goToInfo(insurance) {
      if (vm.acceso_ver_pol) {
        if (insurance.poliza) {
          if (insurance.poliza.document_type == 1) {
            $state.go("polizas.info", { polizaId: insurance.poliza.id });
          } else if (insurance.poliza.document_type == 3) {
            $state.go("colectividades.info", { polizaId: insurance.poliza.id });
          }
        } else {
          $state.go("fianzas.info", { polizaId: insurance.fianza.id });
        }
      }
    }

    $scope.exportDataExcel = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            // templateUrl: 'app/reportes/reportexcel.option.html',
            // controller: 'ReportExcelByCtrl',
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "lg",
            resolve: {
              filters: function () {
                return $scope.filtros;
              },
              from: function () {
                return null;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.filtros.orden = $scope.columnArray;
        $scope.filtros.export_type = 2;
        if (param == 1) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   // $scope.excel_pendiente = 'v2/recibos/reporte-cobranza-excel';
          //   $scope.excel_pendiente = 'service_reporte-v2-cobranzaReport-excel';
          $scope.excel_pendiente = "service_reporte-cobranzaReport-1-excel";
          $http({
            method: "POST",
            url: url.IP + $scope.excel_pendiente,
            data: $scope.filtros,
            headers: {
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "arraybuffer",
          }).then(function (data, status, headers, config) {
            if (data.status == 200) {
              l.stop();
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Cobranza.xls");
            } else {
              SweetAlert.swal(
                "Error",
                "Ha ocurrido un error al descargar el reporte",
                "error"
              );
              l.stop();
            }
          });
        }
      }
    };

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        console.log(data);
        vm.providers = data.data;
      });
    }

    function getContractors() {
      ContratanteService.getContratantes().then(function (data) {
        vm.contractors = data;
      });
    }

    function getClaves() {
      providerService.getClaves().then(function (data) {
        vm.claves = data.results;
      });
    }

    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }

    $scope.typeReceipt = function (parType) {
      switch (parType) {
        case 1:
          return "Póliza";
          break;
        case 2:
          return "Endoso";
          break;
        case 3:
          return "Fianza";
          break;
        case 4:
          return "Bono";
          break;
      }
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "";
      }
    };

    function getReferenciador() {
      vm.vendedores = [];
      $http.get(url.IP + "get-vendors").then(function (user) {
        user.data.forEach(function (u) {
          var obj = {
            name: u.first_name + " " + u.last_name,
            id: u.id,
          };
          vm.vendedores.push(obj);
        });
      });
    }

    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group.val) {
        var word_data = vm.form.group.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_group = 'v2/contratantes/grupos-match/';
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   var filter_contractor = 'v2/contratantes/contractors-match/';
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    $scope.actual_page = 1;

    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            vm.ramos = response.data;
          });
      }
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }

    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.infoUser = $sessionStorage.infoUser;
      // $scope.optionsSent = [
      //     {'value': 1, 'label': 'Totales de la Agrupación'},
      //     {'value': 2, 'label': 'Desglose de consulta'},
      // ];
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        $scope.url_go_excel = "service_reporte-cobranzaReport-1-excel";
        if (option) {
          // Totales de la Agrupación
          if (option == 1) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            filters.export_type = option;
            $http({
              method: "POST",
              url: url.IP + $scope.url_go_excel,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Cobranza.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          } else if (option == 2) {
            filters.export_type = option;
            var la = Ladda.create(document.querySelector(".ladda-button"));
            la.start();
            $http({
              method: "POST",
              url: url.IP + $scope.url_go_excel,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Cobranza.xls");
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "ReporteCobrazaFianzasController",
      ReporteCobrazaFianzasController
    );

  ReporteCobrazaFianzasController.$inject = [
    "dataFactory",
    "$window",
    "$uibModal",
    "$sce",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$filter",
    "$parse",
    "exportFactory",
    "ContratanteService",
    "$sessionStorage",
    "$localStorage",
  ];

  function ReporteCobrazaFianzasController(
    dataFactory,
    $window,
    $uibModal,
    $sce,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $filter,
    $parse,
    exportFactory,
    ContratanteService,
    $sessionStorage,
    $localStorage
  ) {
    var vm = this;

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? -1 : str1 > str2 ? 1 : 0;
      },

      "non-empty-string-desc": function (str1, str2) {
        if (str1 == "") return 1;
        if (str2 == "") return -1;
        return str1 < str2 ? 1 : str1 > str2 ? -1 : 0;
      },
    });
    var hCols = [];
    var paso = 0;

    $scope.$on("ngRepeatFinished", function () {
      paso++;
      //$('#example').DataTable().draw();
      //Define hidden columns
      $("#example").DataTable().destroy();
      // DataTable initialisation
      $("#example").DataTable({
        dom:
          "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-12'p<br/>i>>",
        info: false,
        paging: false,
        autoWidth: true,
        columnDefs: [
          {
            visible: false,
            targets: hCols,
          },
          {
            type: "non-empty-string",
            targets: 0,
          },
        ],
        buttons: [
          {
            extend: "colvis",
            collectionLayout: "three-column",
            text: function () {
              var totCols = $("#example thead th").length;
              var hiddenCols = hCols.length;
              var shownCols = totCols - hiddenCols;
              return "Columnas (" + shownCols + " de " + totCols + ")";
            },
            prefixButtons: [
              {
                extend: "colvisGroup",
                text: "Mostrar todo",
                show: ":hidden",
              },
              {
                extend: "colvisRestore",
                text: "Restaurar",
              },
            ],
          },
        ],
        oLanguage: {
          oPaginate: {
            sNext: '<span class="pagination-default">&#x276f;</span>',
            sPrevious: '<span class="pagination-default">&#x276e;</span>',
          },
        },
        initComplete: function (settings, json) {
          // Adjust hidden columns counter text in button -->
          $("#example").on(
            "column-visibility.dt",
            function (e, settings, column, state) {
              var index = hCols.indexOf(column);
              if (state === false) {
                if (index === -1) {
                  hCols.push(column);
                }
              }
              if (
                $(".dt-button-collection.dropdown-menu.three-column").length ===
                  1 &&
                state === true
              ) {
                if (index !== -1) {
                  hCols.splice(index, 1);
                }
              }
              // var visCols = $('#example thead tr:first th').length;

              //Below: The minus 2 because of the 2 extra buttons Show all and Restore
              var tblCols =
                $(".dt-button-collection li[aria-controls=example] a").length -
                2;
              var visCols = tblCols - hCols.length;
              $(".buttons-colvis[aria-controls=example] span").html(
                "Columnas (" + visCols + " de " + tblCols + ")"
              );
              e.stopPropagation();
            }
          );
        },
      });
    });

    $(".js-example-basic-multiple").select2();
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
      {
        id: 7,
        name: "Semanal",
      },
      {
        id: 14,
        name: "Catorcenal",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por Iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
    ];

    vm.option_policy = [
      {
        id: 1,
        name: "Inicio de vigencia",
      },
      {
        id: 2,
        name: "Vencimiento",
      },
      {
        id: 3,
        name: "Fecha de pago",
      },
      {
        id: 4,
        name: "Fecha de liquidación",
      },
      {
        id: 6,
        name: "Reporte de operación",
      },
    ];

    $scope.columnArray = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;
    $scope.showButtonExcel = false;

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.table = {};
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.changeUntil = changeUntil;
    vm.changeReceipts = changeReceipts;
    vm.goToInfo = goToInfo;
    vm.formatearNumero = formatearNumero;
    vm.matchesPrograma = matchesPrograma;
    $(".js-example-basic-multiple").select2();
    vm.only_caratula_poliza = 0;
    vm.businesLine = [
      {
        id: 1,
        name: "Comercial",
      },
      {
        id: 2,
        name: "Personal",
      },
      {
        id: 3,
        name: "Otro",
      },
    ];

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.org_name = usr.urlname;
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    vm.form = {
      provider: 0,
      vendedor: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: 0,
      group: 0,
      recibos_pagados: true,
      add_precancelados: false,
      recibos_no_pagados: false,
      recibos_liquidados: false,
      recibos_conciliados: false,
      recibos_delivered: false,
      recibos_precancelados: false,
      cve_agente: "",
      identifier: "",
      valueDolar: "",
      valueUdi: "",
      subgroup: 0,
      subsubgroup: 0,
      groupinglevel: 0,
      subgrouping: 0,
      classification: 0,
      subsubgrouping: 0,
      businessLine: 0,
      celula: 0,
      only_caratula: 0,
      tipo_folio_buscar: null,
    };
    vm.form.classification = 0;
    vm.table = {
      headers: [
        "No.Póliza/Fianza",
        "Tipo Recibo",
        "No.Endoso",
        "Estatus Póliza/Endoso",
        "Grupo",
        "Fiado",
        "Correo electrónico",
        "Teléfono",
        "Alías Aseguradora/Afianzadora",
        "Ramo",
        "Subramo",
        "Identificador",
        "Riesgo/Asegurado",
        "Forma de Pago",
        "Moneda",
        "Serie No.Recibo",
        "Fecha Inicio recibo",
        "Fecha Fin recibo",
        "Vencimiento",
        "Antigüedad",
        "Promesa Pago",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Estatus recibo",
        "Conducto de Pago",
        "Metodo de Pago",
        "Documento de Pago",
        "Fecha Pago",
        "Fecha Liquidación",
        "Folio de Liquidación",
        "Fecha de conciliación",
        "Comisión conciliada",
        "Fecha Inicio Póliza/Fianza",
        "Fecha Fin Póliza/Fianza",
        "Clave de Agente",
        "Referenciador",
        "Sucursal",
        "Responsable",
        "Creado por",
        "Fecha Creación",
        "Tipo Cambio (Pago)",
        "Importe Pesos",
        "Ej. Cobranza",
        "Pagado por",
        "Bitacora",
        "Subgrupo",
        "Subsubgrupo",
        "Agrupación",
        "Subagrupación",
        "Subsubagrupación",
        "Clasificación",
        "Línea de Negocio",
        "Promesa Pago",
        "Número de Carátula",
        "Carátula Contratante",
        "Celula",
      ],
    };

    vm.group_by = [
      {
        id: 1,
        name: "Aseguradora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 7,
        name: "Usuario",
      },
      // ,{
      //   id: 6,
      //   name: 'Responsable'
      // }
    ];
    getCelulasContractor();

    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }
    $scope.numberFormatUdi = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueUdi = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      }
    };
    $scope.numberFormatDolar = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueDolar = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      }
    };

    function moneda(num) {
      num = num.toString().replace(/\$|\,/g, "");
      if (isNaN(num)) {
        num = "0";
      }
      var sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      var cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) {
        cents = "0" + cents;
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num =
          num.substring(0, num.length - (4 * i + 3)) +
          "," +
          num.substring(num.length - (4 * i + 3));
      }
      return (sign ? "" : "-") + "$" + num + "." + cents;
    }

    //Solo permite introducir numeros.
    // function soloNumeros(e){
    // $scope.numberFormat = function (e) {
    //   var key = window.event ? e.which : e.keyCode;
    //   if (key < 48 || key > 57) {
    //     e.preventDefault();
    //   }
    // }
    $scope.receipts_option = "todos";
    $scope.receits_domiciliado = 0;
    $scope.receits_domiciliados = [];
    $scope.cp_todos = true;

    $scope.selectReceiptsOption = function (parValue, param) {
      if (parValue == 0) {
        $scope.cp_todos = true;
        $scope.cp_domiciliado = false;
        $scope.cp_no_domiciliado = false;
        $scope.cp_agente = false;
        $scope.cp_cac = false;
        $scope.cp_nomina = false;
        $scope.cp_cut = false;
        $scope.receits_domiciliados = [];
      } else {
        $scope.cp_todos = false;
        if (param) {
          $scope.receits_domiciliados.push(parValue);
        } else {
          $scope.receits_domiciliados.forEach(function (item, index) {
            if (item == parValue) {
              $scope.receits_domiciliados.splice(index, 1);
            }
          });
        }
      }
    };

    $scope.fianza_poliza = "ambas_pf";
    $scope.fianza_poliza_sel = 0;

    $scope.selectFianzaOption = function (parValue) {
      if (parValue == "fianza") {
        $scope.fianza_poliza_sel = 2;
      } else if (parValue == "poliza") {
        $scope.fianza_poliza_sel = 1;
      } else if (parValue == "bono") {
        $scope.fianza_poliza_sel = 3;
      } else if (parValue == "colectiva") {
        $scope.fianza_poliza_sel = 4;
      } else if (parValue == "caratula") {
        $scope.fianza_poliza_sel = 5;
      } else {
        $scope.fianza_poliza_sel = 0;
      }
    };
    $scope.recibo_nota = "ambos";
    $scope.recibo_nota_sel = 0;

    $scope.selectReciboOption = function (parValue) {
      if (parValue == "recibo") {
        $scope.recibo_nota_sel = 1;
      } else if (parValue == "nota") {
        $scope.recibo_nota_sel = 2;
      } else {
        $scope.recibo_nota_sel = 0;
      }
    };

    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.changeReport = function () {
      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id == 1) {
          $scope.created_at = true;
          $scope.vigency = false;
        } else if (vm.form.dates_sel.id == 2) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 3) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 4) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 5) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 6) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 7) {
          $scope.vigency = true;
          $scope.created_at = false;
        }
      } else {
        $scope.vigency = false;
        $scope.created_at = false;
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };

    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };
    $scope.selectUserPay = function (x, y) {
      vm.user_pay_selected = [];
      x.forEach(function (r) {
        vm.user_pay_selected.push(parseInt(r.id));
      });
    };
    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };
    $scope.$watch("vm.word", function (newValue, oldValue) {
      if (vm.word) {
        if (vm.word.id) {
          vm.only_caratula_poliza = parseInt(vm.word.id);
        } else {
          vm.only_caratula_poliza = 0;
        }
      }
    });
    $scope.infoUser = $sessionStorage.infoUser;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.token = token;
    $scope.decrptedtoken = usr;
    $scope.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 10; i >= oldYear; i--) {
      $scope.years.push(i);
    }

    $scope.month = {};
    $scope.month.month_selected = 1;
    $scope.month.options = [
      { value: 0, label: "" },
      { value: 1, label: "Enero" },
      { value: 2, label: "Febrero" },
      { value: 3, label: "Marzo" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Mayo" },
      { value: 6, label: "Junio" },
      { value: 7, label: "Julio" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Septiembre" },
      { value: 10, label: "Octubre" },
      { value: 11, label: "Noviembre" },
      { value: 12, label: "Diciembre" },
    ];
    activate();
    function changeReceipts(par, asc) {
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.receipts_rec_asc = asc;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.receipts_status_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.receipts_pneta_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.receipts_rpf_asc = asc;
          vm.receipts_status_asc = 0;
          vm.receipts_rec_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.receipts_der_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.receipts_iva_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 7:
          Generar(par, asc);
          vm.receipts_ptotal_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.receipts_fini_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.receipts_ffin_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.receipts_com_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.receipts_fvenc_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 12:
          Generar(par, asc);
          vm.receipts_nump_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 13:
          Generar(par, asc);
          vm.receipts_tip_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 14:
          Generar(par, asc);
          vm.receipts_cont_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 15:
          Generar(par, asc);
          vm.receipts_aseg_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 16:
          Generar(par, asc);
          vm.receipts_ramo_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 17:
          Generar(par, asc);
          vm.receipts_subr_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 18:
          Generar(par, asc);
          vm.receipts_fpago_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 19:
          Generar(par, asc);
          vm.receipts_status1_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 20:
          Generar(par, asc);
          vm.receipts_vig_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 21:
          Generar(par, asc);
          vm.receipts_clave_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          break;
        case 34:
          Generar(par, asc);
          vm.receipts_clave_asc = 0;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_folioliq_asc = asc;
          break;
        case 43:
          Generar(par, asc);
          vm.receipts_clave_asc = 0;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.vm.receipts_promesa_pago_asc = asc;
          break;
      }
    }

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");

      return date;
    }
    function matchesPrograma(parWord) {
      if (parWord) {
        if (parWord.length >= 3) {
          if (vm.org_name == "ancora") {
            $scope.show_contrata = "contractors-match-fianzas/";
          } else {
            $scope.show_contrata = "contractors-match/";
          }
          $http
            .post(url.IP + $scope.show_contrata, {
              matchWord: parWord,
              poliza: false,
              pp: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_datapp = source;
              }
            });
        }
      }
    }
    function activate() {
      $(".js-example-basic-multiple").select2();
      getProviders();
      getContractors();
      getUsuarios();
      getReferenciador();
      getSubramos();
      getPermisions();
      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.sub_total = 0;
      $scope.comision = 0;
      vm.form.sincea = 12;
      vm.ramos_selected = [];
      vm.subramos_ramo_sel = [];
      vm.subramos_selected = [];
      vm.contratantes_selected = [];
      vm.claves_selected = [];
      vm.usuarios_selected = [];
      vm.user_pay_selected = [];
      vm.form.since = convertDate(new Date());
      var endingDate = convertDate(new Date());
      vm.form.until = endingDate;
      /* Información de usuario */
      $scope.infoUser = $sessionStorage.infoUser;

      vm.form.poliza_number = $localStorage["save_report_cobranza_fianza"]
        ? $localStorage["save_report_cobranza_fianza"]["poliza_number"]
        : "";
      vm.form.contratante = $localStorage["save_report_cobranza_fianza"]
        ? $localStorage["save_report_cobranza_fianza"]["contratante"]
        : "";
      vm.form.identifier = $localStorage["save_report_cobranza_fianza"]
        ? $localStorage["save_report_cobranza_fianza"]["identifier"]
        : "";
      vm.form.vendedor = $localStorage["save_report_cobranza_fianza"]
        ? $localStorage["save_report_cobranza_fianza"]["vendedor"]
        : 0;
      vm.form.programap = $localStorage["save_report_cobranza_fianza"]
        ? $localStorage["save_report_cobranza_fianza"]["programap"]
        : 0;
      vm.form.dates_sel = $localStorage["save_report_cobranza_fianza"]
        ? $localStorage["save_report_cobranza_fianza"]["dates_sel"]
        : 0;
      vm.form.recibos_pagados = $localStorage["save_report_cobranza_fianza"]
        ? $localStorage["save_report_cobranza_fianza"]["recibos_pagados"]
        : true;
      vm.form.recibos_no_pagados = $localStorage["save_report_cobranza_fianza"]
        ? $localStorage["save_report_cobranza_fianza"]["recibos_no_pagados"]
        : false;
      vm.form.recibos_liquidados = $localStorage["save_report_cobranza_fianza"]
        ? $localStorage["save_report_cobranza_fianza"]["recibos_liquidados"]
        : false;
      vm.form.recibos_conciliados = $localStorage["save_report_cobranza_fianza"]
        ? $localStorage["save_report_cobranza_fianza"]["recibos_conciliados"]
        : false;
      vm.form.recibos_precancelados = $localStorage[
        "save_report_cobranza_fianza"
      ]
        ? $localStorage["save_report_cobranza_fianza"]["recibos_precancelados"]
        : false;
      vm.form.recibos_delivered = $localStorage["save_report_cobranza_fianza"]
        ? $localStorage["save_report_cobranza_fianza"]["recibos_delivered"]
        : false;
    }

    if ("save_report_cobranza_fianza" in $localStorage) {
    } else {
      $localStorage["save_report_cobranza_fianza"] = {};
    }

    $scope.monthEmision = function (parConcept) {
      switch (parConcept) {
        case 0:
          return "";
          break;
        case 1:
          return "Enero";
          break;
        case 2:
          return "Febrero";
          break;
        case 3:
          return "Marzo";
          break;
        case 4:
          return "Abril";
          break;
        case 5:
          return "Mayo";
          break;
        case 6:
          return "Junio";
          break;
        case 7:
          return "Julio";
          break;
        case 8:
          return "Agosto";
          break;
        case 9:
          return "Septiembre";
          break;
        case 10:
          return "Octubre";
          break;
        case 11:
          return "Noviembre";
          break;
        case 12:
          return "Diciembre";
          break;
        default:
          return "";
      }
    };
    function changeGroupBy() {
      $scope.grupos_result = [];
      $scope.showSums = false;
      vm.show_pag_cobranza = false;
    }
    function getPermisions() {
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            vm.acceso_reportes = perm;
            vm.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  vm.acceso_rep_fia = true;
                } else {
                  vm.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  vm.acceso_rep_sin = true;
                } else {
                  vm.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  vm.acceso_rep_end = true;
                } else {
                  vm.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  vm.acceso_rep_pol = true;
                } else {
                  vm.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  vm.acceso_rep_ren = true;
                } else {
                  vm.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  vm.acceso_rep_cob = true;
                } else {
                  vm.acceso_rep_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Comisiones") {
            vm.coms = perm;
            vm.coms.permissions.forEach(function (acc) {
              if (acc.permission_name == "Comisiones") {
                if (acc.checked == true) {
                  vm.permiso_comisiones = true;
                } else {
                  vm.permiso_comisiones = false;
                }
              }
            });
          }
        });
      }
    }
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 15,
          subramo_code: 15,
          subramo_name: "Individual",
        },
        {
          id: 16,
          subramo_code: 16,
          subramo_name: "Colectivas",
        },
        {
          id: 17,
          subramo_code: 17,
          subramo_name: "Penales",
        },
        {
          id: 18,
          subramo_code: 18,
          subramo_name: "No penales",
        },
        {
          id: 19,
          subramo_code: 19,
          subramo_name: "Amparo a conductores",
        },
        {
          id: 20,
          subramo_code: 20,
          subramo_name: "Obra",
        },
        {
          id: 21,
          subramo_code: 21,
          subramo_name: "Proveeduria",
        },
        {
          id: 22,
          subramo_code: 22,
          subramo_name: "Fiscales",
        },
        {
          id: 23,
          subramo_code: 23,
          subramo_name: "Arrendamiento",
        },
        {
          id: 24,
          subramo_code: 24,
          subramo_name: "Otras",
        },
        {
          id: 25,
          subramo_code: 25,
          subramo_name: "Suministro",
        },
        {
          id: 26,
          subramo_code: 26,
          subramo_name: "Compra Venta",
        },
        {
          id: 27,
          subramo_code: 27,
          subramo_name: "Otras",
        },
        {
          id: 28,
          subramo_code: 28,
          subramo_name: "Relación con fianza",
        },
        {
          id: 29,
          subramo_code: 29,
          subramo_name: "Sin relación con fianza",
        },
      ];
    }
    function Generar(order, asc, parPage) {
      //$('#example').DataTable().draw();
      setTimeout(function () {
        paso++;
        $("#example").DataTable().destroy();
        // DataTable initialisation
        $("#example").DataTable({
          dom:
            "<'row'<'col-sm-3'B><'col-sm-3'l><'col-sm-6'p<br/>i>>" +
            "<'row'<'col-sm-12'tr>>" +
            "<'row'<'col-sm-12'p<br/>i>>",
          info: false,
          paging: false,
          autoWidth: true,
          columnDefs: [
            {
              visible: false,
              targets: hCols,
            },
            {
              type: "non-empty-string",
              targets: 0,
            },
          ],
          buttons: [
            {
              extend: "colvis",
              collectionLayout: "three-column",
              text: function () {
                var totCols = $("#example thead th").length;
                var hiddenCols = hCols.length;
                var shownCols = totCols - hiddenCols;
                return "Columnas (" + shownCols + " de " + totCols + ")";
              },
              prefixButtons: [
                {
                  extend: "colvisGroup",
                  text: "Mostrar todo",
                  show: ":hidden",
                },
                {
                  extend: "colvisRestore",
                  text: "Restaurar",
                },
              ],
            },
          ],
          oLanguage: {
            oPaginate: {
              sNext: '<span class="pagination-default">&#x276f;</span>',
              sPrevious: '<span class="pagination-default">&#x276e;</span>',
            },
          },
          initComplete: function (settings, json) {
            // Adjust hidden columns counter text in button -->
            $("#example").on(
              "column-visibility.dt",
              function (e, settings, column, state) {
                var index = hCols.indexOf(column);
                if (state === false) {
                  if (index === -1) {
                    hCols.push(column);
                  }
                }
                if (
                  $(".dt-button-collection.dropdown-menu.three-column")
                    .length === 1 &&
                  state === true
                ) {
                  if (index !== -1) {
                    hCols.splice(index, 1);
                  }
                }
                // var visCols = $('#example thead tr:first th').length;

                //Below: The minus 2 because of the 2 extra buttons Show all and Restore
                var tblCols =
                  $(".dt-button-collection li[aria-controls=example] a")
                    .length - 2;
                var visCols = tblCols - hCols.length;
                $(".buttons-colvis[aria-controls=example] span").html(
                  "Columnas (" + visCols + " de " + tblCols + ")"
                );
                e.stopPropagation();
              }
            );
          },
        });
      }, 2000);
      var l = Ladda.create(document.querySelector(".ladda-buttonC"));
      l.start();

      if (
        !vm.buscar_por_folio &&
        (vm.form.dates_sel == undefined || vm.form.dates_sel == null)
      ) {
        l.stop();
        SweetAlert.swal(
          "Información",
          "Es necesario seleccionar una opción de Reporte por",
          "error"
        );
        return;
      }

      if (vm.buscar_por_folio) {
        if (vm.form.folio_a_buscar == "" || !vm.form.folio_a_buscar) {
          l.stop();
          SweetAlert.swal(
            "Información",
            "Es necesario ingresar el número de folio",
            "error"
          );
          return;
        }
      }

      $scope.order = order;
      $scope.asc = asc;

      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));

      if (antiguedad < 0) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }

      $scope.total = 0.0;
      $scope.prima_neta = 0.0;
      $scope.comision = 0.0;

      if (vm.form.subgroup) {
        if (vm.form.subgroup.id) {
          var g1 = vm.form.subgroup.id;
        } else {
          var g1 = 0;
        }
      }
      if (vm.form.subsubgroup) {
        if (vm.form.subsubgroup.id) {
          var g2 = vm.form.subsubgroup.id;
        } else {
          var g2 = 0;
        }
      } else {
        var g2 = 0;
      }
      if (vm.form.groupinglevel) {
        if (vm.form.groupinglevel.val) {
          var gl = vm.form.groupinglevel.value;
        } else {
          var gl = 0;
        }
      } else {
        var gl = 0;
      }
      if (vm.form.subgrouping) {
        if (vm.form.subgrouping.id) {
          var gl1 = vm.form.subgrouping.id;
        } else {
          var gl1 = 0;
        }
      } else {
        var gl1 = 0;
      }
      if (vm.form.subsubgrouping) {
        if (vm.form.subsubgrouping.id) {
          var gl2 = vm.form.subsubgrouping.id;
        } else {
          var gl2 = 0;
        }
      } else {
        var gl2 = 0;
      }
      var params = {
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        grupo: vm.form.group.value ? vm.form.group.value : 0,
        recibos_pagados: vm.form.recibos_pagados,
        recibos_no_pagados: vm.form.recibos_no_pagados,
        recibos_liquidados: vm.form.recibos_liquidados,
        recibos_conciliados: vm.form.recibos_conciliados,
        recibos_precancelados: vm.form.recibos_precancelados,
        recibos_delivered: vm.form.recibos_delivered,
        recibos_precancel: vm.form.add_precancelados,
        order: order,
        asc: asc,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        page: parPage ? parPage : 1,
        identifier: vm.form.identifier ? vm.form.identifier : 0,
        report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 1,
        poliza_number: vm.form.poliza_number ? vm.form.poliza_number : "",
        vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
        year_factura: vm.form.year_factura ? vm.form.year_factura : 0,
        month_factura: vm.form.month ? vm.form.month.month_selected : 0,
        programap: vm.form.programap ? vm.form.programap.value : 0,
      };
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          params.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.group) {
        if (vm.form.group.val == "") {
          params.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
      }
      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }
      if (vm.form.programap) {
        if (vm.form.programap.val == "") {
          vm.form.programap.value = "";
          vm.form.programap.type = "";
        }
      }

      if (vm.form.programap) {
        if (vm.form.programap.val == "") {
          params.programap = 0;
          vm.form.programap.value = "";
          vm.form.programap.type = "";
        }
      }
      params.celula = cel ? cel : 0;
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      $scope.filtros = params;
      $scope.url_go = "reporte-cobranzafianza-rep/";
      $http({
        method: "POST",
        url: url.IP + $scope.url_go,
        data: $scope.filtros,
      }).then(
        function success(response) {
          $("#example").DataTable().clear();
          $scope.insurances = response.data.results;
          l.stop();
          $scope.sumas = response.data.sumas;
          $scope.filtros.count = response.data.count;

          $scope.count_insurances = angular.copy($scope.insurances);
          if ($scope.insurances.length < 10) {
            for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
              var object = {
                recibo_numero: " ",
                status: " ",
                prima_neta: null,
                rpf: null,
                derecho: null,
                iva: null,
                prima_total: null,
                fecha_inicio: " ",
                fecha_fin: " ",
                comision: null,
                vencimiento: " ",
                poliza: {
                  poliza_number: " ",
                  natural: " ",
                  aseguradora: " ",
                  ramo: " ",
                  subramo: " ",
                  forma_de_pago: " ",
                  status: " ",
                  start_of_validity: " ",
                  clave: {
                    clave: " ",
                  },
                },
                receipt_type: " ",
              };
              $scope.insurances.push(object);
            }
          }

          $scope.cobranza_config = {
            count: response.data.count,
            previous: url.IP + $scope.url_go,
            next: url.IP + $scope.url_go,
          };
          vm.show_pag_cobranza = true;
          $scope.obtenerPaginacion(response.data, parPage ? parPage : 1);
          // testPagination('insurances', 'cobranza_config');

          if ($scope.insurances[0].recibo_numero == " ") {
            toaster.warning("No se encontraron registros");
            $("#example").DataTable().clear();
            $("#example").DataTable().draw();
            $("#example").DataTable().destroy();
          } else {
            $scope.showButtonExcel = true;
            $scope.showSums = true;
          }
          $("#example").DataTable().destroy();
        },
        function error(err) {
          console.log("error", err);
          l.stop();
        }
      );

      $localStorage["save_report_cobranza_fianza"]["poliza_number"] =
        vm.form.poliza_number;
      $localStorage["save_report_cobranza_fianza"]["contratante"] =
        vm.form.contratante;
      $localStorage["save_report_cobranza_fianza"]["identifier"] =
        vm.form.identifier;
      $localStorage["save_report_cobranza_fianza"]["vendedor"] =
        vm.form.vendedor;
      $localStorage["save_report_cobranza_fianza"]["programap"] =
        vm.form.programap;
      $localStorage["save_report_cobranza_fianza"]["dates_sel"] =
        vm.form.dates_sel;
      $localStorage["save_report_cobranza_fianza"]["recibos_pagados"] =
        vm.form.recibos_pagados;
      $localStorage["save_report_cobranza_fianza"]["recibos_no_pagados"] =
        vm.form.recibos_no_pagados;
      $localStorage["save_report_cobranza_fianza"]["recibos_liquidados"] =
        vm.form.recibos_liquidados;
      $localStorage["save_report_cobranza_fianza"]["recibos_conciliados"] =
        vm.form.recibos_conciliados;
      $localStorage["save_report_cobranza_fianza"]["recibos_precancelados"] =
        vm.form.recibos_precancelados;
      $localStorage["save_report_cobranza_fianza"]["recibos_delivered"] =
        vm.form.recibos_delivered;
    }

    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      $localStorage.save_report_cobranza_fianza["page"] = pagina;
      vm.Generar(1, 1, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $localStorage.save_report_cobranza_fianza["page"] =
          $scope.paginacion["paginaActual"] - 1;
        vm.Generar(
          $localStorage["save_report_cobranza_fianza"] &&
            $localStorage["save_report_cobranza_fianza"]["order"]
            ? $localStorage["save_report_cobranza_fianza"]["order"]
            : 1,
          $localStorage["save_report_cobranza_fianza"] &&
            $localStorage["save_report_cobranza_fianza"]["asc"]
            ? $localStorage["save_report_cobranza_fianza"]["asc"]
            : 1,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $localStorage.save_report_cobranza_fianza["page"] =
          $scope.paginacion["paginaActual"] + 1;
        vm.Generar(
          $localStorage["save_report_cobranza_fianza"] &&
            $localStorage["save_report_cobranza_fianza"]["order"]
            ? $localStorage["save_report_cobranza_fianza"]["order"]
            : 1,
          $localStorage["save_report_cobranza_fianza"] &&
            $localStorage["save_report_cobranza_fianza"]["asc"]
            ? $localStorage["save_report_cobranza_fianza"]["asc"]
            : 1,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };
    function goToInfo(insurance) {
      if (vm.acceso_ver_pol) {
        if (insurance.poliza) {
          if (insurance.poliza.document_type == 1) {
            $state.go("polizas.info", { polizaId: insurance.poliza.id });
          } else if (insurance.poliza.document_type == 3) {
            $state.go("colectividades.info", { polizaId: insurance.poliza.id });
          } else if (insurance.poliza.document_type == 12) {
            $state.go("flotillas.info", {
              polizaId: insurance.poliza.parent.id,
            });
          } else if (insurance.poliza.document_type == 11) {
            $state.go("flotillas.info", {
              polizaId: insurance.poliza.parent.id,
            });
          }
        } else {
          $state.go("fianzas.info", { polizaId: insurance.fianza.id });
        }
      }
    }

    $scope.exportDataExcel = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.filtros.orden = $scope.columnArray;
      $scope.filtros.export_type = 2;
      var $listM = $("#example th")
        .map(function () {
          return $.trim($(this).text());
        })
        .get();
      if ($listM.includes("No. Fianza")) {
        $listM.push("No. Fianza");
      }
      if ($listM.includes("Tipo Recibo")) {
        $listM.push("Tipo Recibo");
      }
      if ($listM.includes("No. Endoso")) {
        $listM.push("No. Endoso");
      }
      if ($listM.includes("Estatus Fianza")) {
        $listM.push("Estatus Fianza");
      }
      if ($listM.includes("Fiado")) {
        $listM.push("Fiado");
      }
      if ($listM.includes("Grupo")) {
        $listM.push("Grupo");
      }
      if ($listM.includes("Correo Electrónico")) {
        $listM.push("Correo Electrónico");
      }
      if ($listM.includes("Teléfono")) {
        $listM.push("Teléfono");
      }
      if ($listM.includes("Afianzadora")) {
        $listM.push("Afianzadora");
      }
      if ($listM.includes("Ramo")) {
        $listM.push("Ramo");
      }
      if ($listM.includes("SubRamo")) {
        $listM.push("SubRamo");
      }
      if ($listM.includes("Identificador")) {
        $listM.push("Identificador");
      }
      if ($listM.includes("Frecuencia Pago")) {
        $listM.push("Frecuencia Pago");
      }
      if ($listM.includes("Moneda")) {
        $listM.push("Moneda");
      }
      if ($listM.includes("Serie Recibo")) {
        $listM.push("Serie Recibo");
      }
      if ($listM.includes("Fecha Inicio Recibo")) {
        $listM.push("Fecha Inicio Recibo");
      }
      if ($listM.includes("Fecha Fin Recibo")) {
        $listM.push("Fecha Fin Recibo");
      }
      if ($listM.includes("Vencimiento")) {
        $listM.push("Vencimiento");
      }
      if ($listM.includes("Antigüedad")) {
        $listM.push("Antigüedad");
      }
      if ($listM.includes("Promesa Pago")) {
        $listM.push("Promesa Pago");
      }
      if ($listM.includes("Prima Neta")) {
        $listM.push("Prima Neta");
      }
      if ($listM.includes("Gastos Expedición")) {
        $listM.push("Gastos Expedición");
      }
      if ($listM.includes("Derecho")) {
        $listM.push("Derecho");
      }
      if ($listM.includes("IVA")) {
        $listM.push("IVA");
      }
      if ($listM.includes("Prima Total")) {
        $listM.push("Prima Total");
      }
      if (vm.permiso_comisiones) {
        if ($listM.includes("Comisión")) {
          $listM.push("Comisión");
        }
        if ($listM.includes("Comisión Conciliada")) {
          $listM.push("Comisión Conciliada");
        }
      }
      if ($listM.includes("Estatus Recibo")) {
        $listM.push("Estatus Recibo");
      }
      if ($listM.includes("Método de Pago")) {
        $listM.push("Método de Pago");
      }
      if ($listM.includes("Fecha de Pago")) {
        $listM.push("Fecha de Pago");
      }
      if ($listM.includes("Fecha de Pago de Comisión")) {
        $listM.push("Fecha de Pago de Comisión");
      }
      if ($listM.includes("Fecha de Liquidación")) {
        $listM.push("Fecha de Liquidación");
      }
      if ($listM.includes("Folio de Liquidación")) {
        $listM.push("Folio de Liquidación");
      }
      if ($listM.includes("Fecha de Conciliación")) {
        $listM.push("Fecha de Conciliación");
      }
      if ($listM.includes("Fecha Inicio Fianza")) {
        $listM.push("Fecha Inicio Fianza");
      }
      if ($listM.includes("Fecha Fin Fianza")) {
        $listM.push("Fecha Fin Fianza");
      }
      if ($listM.includes("Clave Agente")) {
        $listM.push("Clave Agente");
      }
      if ($listM.includes("Referenciador")) {
        $listM.push("Referenciador");
      }
      if ($listM.includes("Responsable")) {
        $listM.push("Responsable");
      }
      if ($listM.includes("Creado Por")) {
        $listM.push("Creado Por");
      }
      if ($listM.includes("Fecha Creación")) {
        $listM.push("Fecha Creación");
      }
      if ($listM.includes("Tipo Cambio (Pago)")) {
        $listM.push("Tipo Cambio (Pago)");
      }
      if ($listM.includes("Importe Pesos")) {
        $listM.push("Importe Pesos");
      }
      if ($listM.includes("Ej. Cobranza")) {
        $listM.push("Ej. Cobranza");
      }
      if ($listM.includes("Pagado por")) {
        $listM.push("Pagado por");
      }
      if ($listM.includes("Bono Afianzadora")) {
        $listM.push("Bono Afianzadora");
      }
      if ($listM.includes("Fecha Bono")) {
        $listM.push("Fecha Bono");
      }
      if ($listM.includes("Fecha emisión factura")) {
        $listM.push("Fecha emisión factura");
      }
      if ($listM.includes("Mes emisión producción")) {
        $listM.push("Mes emisión producción");
      }
      if ($listM.includes("Año emisión producción")) {
        $listM.push("Año emisión producción");
      }
      if ($listM.includes("Folio factura")) {
        $listM.push("Folio factura");
      }
      if ($listM.includes("Maquila")) {
        $listM.push("Maquila");
      }
      if ($listM.includes("Fecha Maquila")) {
        $listM.push("Fecha Maquila");
      }
      if ($listM.includes("Tipo Cambio (CAPTURA)")) {
        $listM.push("Tipo Cambio (CAPTURA)");
      }
      var scolumns = [
        "No. Fianza",
        "Tipo Recibo",
        "No. Endoso",
        "Estatus Fianza",
        "Fiado",
        "Grupo",
        "Correo Electrónico",
        "Teléfono",
        "Afianzadora",
        "Ramo",
        "SubRamo",
        "Identificador",
        "Frecuencia Pago",
        "Moneda",
        "Serie Recibo",
        "Fecha Inicio Recibo",
        "Fecha Fin Recibo",
        "Vencimiento",
        "Antigüedad",
        "Promesa Pago",
        "Prima Neta",
        "Gastos Expedición",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Comisión Conciliada",
        "Estatus Recibo",
        "Método de Pago",
        "Fecha de Pago",
        "Fecha de Pago de Comisión",
        "Maquila",
        "Fecha de Liquidación",
        "Folio de Liquidación",
        "Fecha de Conciliación",
        "Fecha Inicio Fianza",
        "Fecha Fin Fianza",
        "Clave Agente",
        "Referenciador",
        "Responsable",
        "Creado Por",
        "Fecha Creación",
        "Tipo Cambio (Pago)",
        "Importe Pesos",
        "Ej. Cobranza",
        "Pagado por",
        "Bono Afianzadora",
        "Fecha Bono",
        "Fecha emisión factura",
        "Mes emisión producción",
        "Año emisión producción",
        "Folio factura",
        "Maquila",
        "Fecha Maquila",
        "Tipo Cambio (CAPTURA)",
      ];
      var foo = [];

      $.grep(scolumns, function (el) {
        if ($.inArray(el, $listM) != -1) {
          foo.push(el);
        }
      });

      $scope.filtros["cols1"] = foo;
      $scope.url_go_excel = "service_reporte-cobranzafianzasReport-excel";

      $http({
        method: "POST",
        url: url.IP + $scope.url_go_excel,
        data: $scope.filtros,
      })
        .then(function success(response) {
          if (response.status == 200) {
            l.stop();
            // Conexión a socket.io
            // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
            // if($scope.org_name =='ancora'){
            //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
            // }else{
            var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
            // }
            socket.emit("subscribe", response.data);
            // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
            // socket.on('result', function(url){
            socket.on(response.data, function (url) {
              socket.disconnect();
              SweetAlert.swal({
                title: "El reporte está listo para descargar",
                icon: "success",
                text: "Encuentra la liga de descarga en la sección de notificaciones",
                timer: 5000,
              });
              // var notificacion = {
              //   'title': 'El reporte solicitado ha sido generado',
              //   'description': url,
              //   'model': 26,
              //   'id_reference':0
              // }
              // dataFactory.post('notificaciones/', notificacion)
              // .then(function success(response) {
              //   SweetAlert.swal({
              //     title: 'El reporte está listo para descargar',
              //     icon: 'success',
              //     text: 'Encuentra la liga de descarga en la sección de notificaciones',
              //     timer: 5000
              //   });
              //   socket.disconnect();
              // }).catch(function(err) {
              //   socket.disconnect();
              // })
            });
            toaster.info(
              "Generando...",
              "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
            );
          } else {
            l.stop();
            toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
          }
        })
        .catch(function (error) {
          l.stop();
          toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
        });
    };

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderFiByKey(d).then(function (data) {
        vm.providers = data.data;
      });
    }

    function getContractors() {
      ContratanteService.getContratantes().then(function (data) {
        vm.contractors = data;
      });
    }

    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }

    $scope.typeReceipt = function (parType) {
      switch (parType) {
        case 1:
          return "Fianza";
          break;
        case 2:
          return "Endoso";
          break;
        case 3:
          return "Nota de Crédito";
          break;
        case 4:
          return "Bono";
          break;
      }
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "";
      }
    };

    function getReferenciador() {
      vm.vendedores = [];
      $http.get(url.IP + "get-vendors").then(function (user) {
        user.data.forEach(function (u) {
          var obj = {
            name: u.first_name + " " + u.last_name,
            id: u.id,
          };
          vm.vendedores.push(obj);
        });
      });
    }
    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        if (vm.form.group.val) {
          var word_data = vm.form.group.val;
        }
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_group = 'v2/contratantes/grupos-match/';
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  // var obj = {
                  //   label: item.group_name,
                  //   value: item.id
                  // };
                  // $scope.subgroups = item.subgrupos;
                  // $scope.subsubgroups = [];
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    $scope.$watch("vm.form.group.value", function (newValue, oldValue) {
      if (vm.form.group) {
        if (vm.form.group.value) {
          $http
            .get(url.IP + "grupos/" + vm.form.group.value)
            .then(function (item) {
              vm.form.group.data = item.data;

              $scope.subgroups = item.data.subgrupos;
              $scope.subgroups.forEach(function (itm) {
                $scope.subsubgroups = itm.subsubgrupos;
              });
            });
        }
      }
    });

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   var filter_contractor = 'v2/contratantes/contractors-match/';
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }
    $scope.actual_page = 1;

    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            vm.ramos = response.data;
          });
      }
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }

    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      // $scope.optionsSent = [
      //     {'value': 1, 'label': 'Totales de la Agrupación'},
      //     {'value': 2, 'label': 'Desglose de consulta'},
      // ];
      $scope.infoUser = $sessionStorage.infoUser;
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        filters.export_type = option;
        var la = Ladda.create(document.querySelector(".ladda-button"));
        la.start();
        $scope.url_go_excel = "service_reporte-cobranzafianzasReport-excel";
        $http({
          method: "POST",
          url: url.IP + $scope.url_go_excel,
          data: filters,
        })
          .then(function success(response) {
            if (response.status == 200) {
              la.stop();
              // Conexión a socket.io
              // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
              // if($scope.org_name =='ancora'){
              //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
              // }else{
              var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
              // }
              socket.emit("subscribe", response.data);
              // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
              // socket.on('result', function(url){
              socket.on(response.data, function (url) {
                socket.disconnect();
                SweetAlert.swal({
                  title: "El reporte está listo para descargar",
                  icon: "success",
                  text: "Encuentra la liga de descarga en la sección de notificaciones",
                  timer: 5000,
                });
                // var notificacion = {
                //   'title': 'El reporte solicitado ha sido generado',
                //   'description': url,
                //   'model': 26,
                //   'id_reference':0
                // }
                // dataFactory.post('notificaciones/', notificacion)
                // .then(function success(response) {
                //   SweetAlert.swal({
                //     title: 'El reporte está listo para descargar',
                //     icon: 'success',
                //     text: 'Encuentra la liga de descarga en la sección de notificaciones',
                //     timer: 5000
                //   });
                //   socket.disconnect();
                // }).catch(function(err) {
                //   socket.disconnect();
                // })
              });
              toaster.info(
                "Generando...",
                "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
              );
            } else {
              la.stop();
              toaster.error(
                "Aviso",
                "Ha ocurrido un error, intente nuevamente"
              );
            }
          })
          .catch(function (error) {
            la.stop();
            toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
          });
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteCobrazaLiqController", ReporteCobrazaLiqController);

  ReporteCobrazaLiqController.$inject = [
    "$window",
    "$uibModal",
    "$sce",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$filter",
    "$parse",
    "exportFactory",
    "ContratanteService",
    "$sessionStorage",
    "$localStorage",
  ];

  function ReporteCobrazaLiqController(
    $window,
    $uibModal,
    $sce,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $filter,
    $parse,
    exportFactory,
    ContratanteService,
    $sessionStorage,
    $localStorage
  ) {
    var vm = this;

    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por Iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
    ];

    vm.option_policy = [
      {
        id: 1,
        name: "Inicio de vigencia",
      },
      {
        id: 2,
        name: "Vencimiento",
      },
      {
        id: 3,
        name: "Fecha de pago",
      },
      {
        id: 4,
        name: "Fecha de liquidación",
      },
      {
        id: 5,
        name: "Fecha de conciliación",
      },
      {
        id: 6,
        name: "Reporte de operación",
      },
    ];

    $scope.infoUser = $sessionStorage.infoUser;

    $scope.columnArray = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;
    $scope.showButtonExcel = false;

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.table = {};
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.changeUntil = changeUntil;
    vm.changeReceipts = changeReceipts;
    vm.goToInfo = goToInfo;
    vm.formatearNumero = formatearNumero;
    vm.changeGroupBy = changeGroupBy;

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    vm.form = {
      provider: 0,
      vendedor: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: 0,
      group: 0,
      recibos_pagados: false,
      add_precancelados: false,
      recibos_no_pagados: false,
      recibos_liquidados: true,
      recibos_conciliados: false,
      recibos_delivered: false,
      recibos_cancelados: false,
      recibos_precancelados: false,
      recibos_cerrados: false,
      recibos_pago_parcial: false,
      cve_agente: "",
      identifier: "",
      valueDolar: "",
      valueUdi: "",
    };
    vm.table = {
      headers: [
        "Recibo",
        "Estatus Recibo",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Fecha de Inicio",
        "Fecha de Fin",
        "Comisión",
        "Fecha de Vencimiento",
        "Número de Póliza",
        "Tipo",
        "Contratante",
        "Aseguradora",
        "Ramo",
        "Subramo",
        "Frecuencia de Pago",
        "Estatus Póliza",
        "Vigencia Póliza",
        "Clave de Agente",
        "Fecha Pago",
        "Fecha Liquidación",
        "Folio de Liquidación",
      ],
    };

    vm.group_by = [
      {
        id: 1,
        name: "Aseguradora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 7,
        name: "Usuario",
      },
      // ,{
      //   id: 6,
      //   name: 'Responsable'
      // }
    ];

    // $(window).load(function() {
    //     $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });

    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }
    $scope.numberFormatUdi = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueUdi = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      } else {
        console.log("gddf------------------->", toNumber);
      }
    };
    $scope.numberFormatDolar = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueDolar = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      } else {
        console.log("gddf------------------->", toNumber);
      }
    };

    function moneda(num) {
      num = num.toString().replace(/\$|\,/g, "");
      if (isNaN(num)) {
        num = "0";
      }
      var sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      var cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) {
        cents = "0" + cents;
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num =
          num.substring(0, num.length - (4 * i + 3)) +
          "," +
          num.substring(num.length - (4 * i + 3));
      }
      return (sign ? "" : "-") + "$" + num + "." + cents;
    }

    //Solo permite introducir numeros.
    // function soloNumeros(e){
    // $scope.numberFormat = function (e) {
    //   var key = window.event ? e.which : e.keyCode;
    //   if (key < 48 || key > 57) {
    //     e.preventDefault();
    //   }
    // }
    $scope.receipts_option = "todos";
    $scope.receits_domiciliados = 0;

    $scope.selectReceiptsOption = function (parValue) {
      if (parValue == "no_domiciliados") {
        $scope.receits_domiciliados = 2;
      } else if (parValue == "domiciliados") {
        $scope.receits_domiciliados = 1;
      } else {
        $scope.receits_domiciliados = 0;
      }
    };
    $scope.fianza_poliza = "ambas_pf";
    $scope.fianza_poliza_sel = 0;

    $scope.selectFianzaOption = function (parValue) {
      if (parValue == "fianza") {
        $scope.fianza_poliza_sel = 2;
      } else if (parValue == "poliza") {
        $scope.fianza_poliza_sel = 1;
      } else if (parValue == "bono") {
        $scope.fianza_poliza_sel = 3;
      } else if (parValue == "colectiva") {
        $scope.fianza_poliza_sel = 4;
      } else {
        $scope.fianza_poliza_sel = 0;
      }
    };
    $scope.recibo_nota = "ambos";
    $scope.recibo_nota_sel = 0;

    $scope.selectReciboOption = function (parValue) {
      if (parValue == "recibo") {
        $scope.recibo_nota_sel = 1;
      } else if (parValue == "nota") {
        $scope.recibo_nota_sel = 2;
      } else {
        $scope.recibo_nota_sel = 0;
      }
    };

    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.changeReport = function () {
      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id == 1) {
          $scope.created_at = true;
          $scope.vigency = false;
        } else if (vm.form.dates_sel.id == 2) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 3) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 4) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 5) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 6) {
          $scope.vigency = true;
          $scope.created_at = false;
        }
      } else {
        $scope.vigency = false;
        $scope.created_at = false;
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };

    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };
    $scope.selectUserPay = function (x, y) {
      vm.user_pay_selected = [];
      x.forEach(function (r) {
        vm.user_pay_selected.push(parseInt(r.id));
      });
    };
    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };

    activate();
    function changeReceipts(par, asc) {
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.receipts_rec_asc = asc;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.receipts_status_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.receipts_pneta_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.receipts_rpf_asc = asc;
          vm.receipts_status_asc = 0;
          vm.receipts_rec_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.receipts_der_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.receipts_iva_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 7:
          Generar(par, asc);
          vm.receipts_ptotal_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.receipts_fini_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.receipts_ffin_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.receipts_com_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.receipts_fvenc_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 12:
          Generar(par, asc);
          vm.receipts_nump_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 13:
          Generar(par, asc);
          vm.receipts_tip_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 14:
          Generar(par, asc);
          vm.receipts_cont_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 15:
          Generar(par, asc);
          vm.receipts_aseg_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 16:
          Generar(par, asc);
          vm.receipts_ramo_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 17:
          Generar(par, asc);
          vm.receipts_subr_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 18:
          Generar(par, asc);
          vm.receipts_fpago_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 19:
          Generar(par, asc);
          vm.receipts_status1_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 20:
          Generar(par, asc);
          vm.receipts_vig_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 21:
          Generar(par, asc);
          vm.receipts_clave_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          break;
        case 34:
          Generar(par, asc);
          vm.receipts_clave_asc = 0;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_folioliq_asc = asc;
          break;
      }
    }

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");

      return date;
    }

    function activate() {
      getProviders();
      getContractors();
      getClaves();
      getUsuarios();
      getReferenciador();
      getSubramos();
      getPermisions();
      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.sub_total = 0;
      $scope.comision = 0;
      vm.form.sincea = 12;
      vm.ramos_selected = [];
      vm.subramos_ramo_sel = [];
      vm.subramos_selected = [];
      vm.contratantes_selected = [];
      vm.claves_selected = [];
      vm.usuarios_selected = [];
      vm.user_pay_selected = [];
      vm.form.since = convertDate(new Date());
      var endingDate = convertDate(new Date());
      vm.form.until = endingDate;
      vm.form.dates_sel = {
        id: 4,
        name: "Fecha de liquidación",
      };
      $scope.vigency = true;
      $scope.created_at = false;

      vm.form.contratante =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["contratante"]
          ? $localStorage.saved_filters_reporte_liqudacion["contratante"]
          : "";
      vm.form.group =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["group"]
          ? $localStorage.saved_filters_reporte_liqudacion["group"]
          : 0;
      vm.form.vendedor =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["vendedor"]
          ? $localStorage.saved_filters_reporte_liqudacion["vendedor"]
          : 0;
      vm.form.cve_agente =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["cve_agente"]
          ? $localStorage.saved_filters_reporte_liqudacion["cve_agente"]
          : "";
      vm.form.identifier =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["identifier"]
          ? $localStorage.saved_filters_reporte_liqudacion["identifier"]
          : "";
      vm.form.group_by =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["group_by"]
          ? $localStorage.saved_filters_reporte_liqudacion["group_by"]
          : 0;
      vm.form.dates_sel =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["dates_sel"]
          ? $localStorage.saved_filters_reporte_liqudacion["dates_sel"]
          : 0;
      vm.form.add_precancelados =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["dates_sel"]
          ? $localStorage.saved_filters_reporte_liqudacion["add_precancelados"]
          : false;
      vm.form.valueDolar =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["valueDolar"]
          ? $localStorage.saved_filters_reporte_liqudacion["valueDolar"]
          : "";
      vm.form.valueUdi =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["valueUdi"]
          ? $localStorage.saved_filters_reporte_liqudacion["valueUdi"]
          : "";
      $scope.receipts_option =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["receipts_option"]
          ? $localStorage.saved_filters_reporte_liqudacion["receipts_option"]
          : "todos";
      $scope.fianza_poliza =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["fianza_poliza"]
          ? $localStorage.saved_filters_reporte_liqudacion["fianza_poliza"]
          : "ambas_pf";
      $scope.recibo_nota =
        $localStorage.saved_filters_reporte_liqudacion &&
        $localStorage.saved_filters_reporte_liqudacion["recibo_nota"]
          ? $localStorage.saved_filters_reporte_liqudacion["recibo_nota"]
          : "ambos";
    }

    function changeGroupBy() {
      $scope.grupos_result = [];
      $scope.showSums = false;
      vm.show_pag_cobranza = false;
    }
    function getPermisions() {
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            vm.acceso_reportes = perm;
            vm.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  vm.acceso_rep_fia = true;
                } else {
                  vm.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  vm.acceso_rep_sin = true;
                } else {
                  vm.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  vm.acceso_rep_end = true;
                } else {
                  vm.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  vm.acceso_rep_pol = true;
                } else {
                  vm.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  vm.acceso_rep_ren = true;
                } else {
                  vm.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  vm.acceso_rep_cob = true;
                } else {
                  vm.acceso_rep_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Comisiones") {
            vm.coms = perm;
            vm.coms.permissions.forEach(function (acc) {
              if (acc.permission_name == "Comisiones") {
                if (acc.checked == true) {
                  vm.permiso_comisiones = true;
                } else {
                  vm.permiso_comisiones = false;
                }
              }
            });
          }
        });
      }
    }
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 6,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
        // ----
        {
          id: 15,
          subramo_code: 15,
          subramo_name: "Individual",
        },
        {
          id: 16,
          subramo_code: 16,
          subramo_name: "Colectivas",
        },
        {
          id: 17,
          subramo_code: 17,
          subramo_name: "Penales",
        },
        {
          id: 18,
          subramo_code: 18,
          subramo_name: "No penales",
        },
        {
          id: 19,
          subramo_code: 19,
          subramo_name: "Amparo a conductores",
        },
        {
          id: 20,
          subramo_code: 20,
          subramo_name: "Obra",
        },
        {
          id: 21,
          subramo_code: 21,
          subramo_name: "Proveeduria",
        },
        {
          id: 22,
          subramo_code: 22,
          subramo_name: "Fiscales",
        },
        {
          id: 23,
          subramo_code: 23,
          subramo_name: "Arrendamiento",
        },
        {
          id: 24,
          subramo_code: 24,
          subramo_name: "Otras",
        },
        {
          id: 25,
          subramo_code: 25,
          subramo_name: "Suministro",
        },
        {
          id: 26,
          subramo_code: 26,
          subramo_name: "Compra Venta",
        },
        {
          id: 27,
          subramo_code: 27,
          subramo_name: "Otras",
        },
        {
          id: 28,
          subramo_code: 28,
          subramo_name: "Relación con fianza",
        },
        {
          id: 29,
          subramo_code: 29,
          subramo_name: "Sin relación con fianza",
        },
      ];
    }
    function Generar(order, asc, parPage) {
      var l = Ladda.create(document.querySelector(".ladda-buttonC"));
      l.start();

      if (vm.form.dates_sel == undefined || vm.form.dates_sel == null) {
        l.stop();
        SweetAlert.swal(
          "Información",
          "Es necesario seleccionar una opción de Reporte por",
          "error"
        );
        return;
      }

      $scope.order = order;
      $scope.asc = asc;

      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));

      if (antiguedad < 0) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }

      $scope.total = 0.0;
      $scope.prima_neta = 0.0;
      $scope.comision = 0.0;

      var params = {
        provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider,
        vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
        ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
        subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
        status: vm.form.status.id ? vm.form.status.id : vm.form.status,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
        type_contractor: vm.form.contratante.type
          ? vm.form.contratante.type
          : 0,
        recibos_pagados: vm.form.recibos_pagados,
        recibos_no_pagados: vm.form.recibos_no_pagados,
        recibos_liquidados: vm.form.recibos_liquidados,
        recibos_conciliados: vm.form.recibos_conciliados,
        recibos_cancelados: vm.form.recibos_cancelados,
        recibos_precancelados: vm.form.recibos_precancelados,
        recibos_cerrados: vm.form.recibos_cerrados,
        recibos_pago_parcial: vm.form.recibos_pago_parcial,
        recibos_delivered: vm.form.recibos_delivered,
        recibos_precancel: vm.form.add_precancelados,
        cve: vm.form.cve_agente ? vm.form.cve_agente : 0,
        order: order,
        asc: asc,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        claves: vm.claves_selected ? vm.claves_selected : 0,
        users: vm.usuarios_selected ? vm.usuarios_selected : 0,
        user_pay: vm.user_pay_selected ? vm.user_pay_selected : 0,
        page: parPage ? parPage : 1,
        group_by: vm.form.group_by ? vm.form.group_by.id : 0,
        identifier: vm.form.identifier ? vm.form.identifier : 0,
        report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 1,
        domiciliados: $scope.receits_domiciliados,
        recibos_por: $scope.fianza_poliza_sel,
        option: $scope.recibo_nota_sel,
        valDolar: vm.form.valueDolar
          ? parseFloat(vm.form.valueDolar).toFixed(2)
          : 0,
        valUdi: vm.form.valueUdi ? parseFloat(vm.form.valueUdi).toFixed(2) : 0,
      };

      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          params.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.group) {
        if (vm.form.group.val == "") {
          params.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
      }
      $scope.filtros = params;
      $scope.search_liquidacion = "reporte-cobranza-rep/";
      $http({
        method: "POST",
        url: url.IP + $scope.search_liquidacion,
        data: $scope.filtros,
      }).then(
        function success(response) {
          if (params.group_by == 0) {
            $scope.insurances = response.data.results;
            l.stop();
            $scope.sumas = response.data.sumas;
            $scope.filtros.count = response.data.count;
            $scope.count_insurances = angular.copy($scope.insurances);
            if ($scope.insurances.length < 10) {
              for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
                var object = {
                  recibo_numero: " ",
                  status: " ",
                  prima_neta: null,
                  rpf: null,
                  derecho: null,
                  iva: null,
                  prima_total: null,
                  fecha_inicio: " ",
                  fecha_fin: " ",
                  comision: null,
                  vencimiento: " ",
                  poliza: {
                    poliza_number: " ",
                    natural: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    forma_de_pago: " ",
                    status: " ",
                    start_of_validity: " ",
                    clave: {
                      clave: " ",
                    },
                  },
                  receipt_type: " ",
                };
                $scope.insurances.push(object);
              }
            }

            $scope.cobranza_config = {
              count: response.data.count,
              previous: url.IP + $scope.search_liquidacion,
              next: url.IP + $scope.search_liquidacion,
            };
            vm.show_pag_cobranza = true;
            $scope.obtenerPaginacion(response.data, parPage ? parPage : 1);
            // testPagination('insurances', 'cobranza_config');

            if ($scope.insurances[0].recibo_numero == " ") {
              toaster.warning("No se encontraron registros");
            } else {
              $scope.showButtonExcel = true;
              $scope.showSums = true;
            }
          } else {
            l.stop();
            // $scope.showSums = true;
            // $scope.sumas = response.data.sumas
            $scope.grupos_result = response.data.results;
            $scope.showButtonExcel = true;
          }
        },
        function error(err) {
          console.log("error", err);
          l.stop();
        }
      );

      // $http({
      //    method: 'GET',
      //      url: url.IP + 'get-sumas-cobranza',
      //      params: params
      //  }).then(function success(response) {
      //      $scope.sumas = response.data;
      //  })

      $localStorage.saved_filters_reporte_liqudacion = angular.copy(params);
      $localStorage.saved_filters_reporte_liqudacion["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_reporte_liqudacion["group"] = vm.form.group;
      $localStorage.saved_filters_reporte_liqudacion["vendedor"] =
        vm.form.vendedor;
      $localStorage.saved_filters_reporte_liqudacion["cve_agente"] =
        vm.form.cve_agente;
      $localStorage.saved_filters_reporte_liqudacion["identifier"] =
        vm.form.identifier;
      $localStorage.saved_filters_reporte_liqudacion["group_by"] =
        vm.form.group_by;
      $localStorage.saved_filters_reporte_liqudacion["dates_sel"] =
        vm.form.dates_sel;
      $localStorage.saved_filters_reporte_liqudacion["add_precancelados"] =
        vm.form.add_precancelados;
      $localStorage.saved_filters_reporte_liqudacion["valueDolar"] =
        vm.form.valueDolar;
      $localStorage.saved_filters_reporte_liqudacion["valueUdi"] =
        vm.form.valueUdi;
      $localStorage.saved_filters_reporte_liqudacion["receipts_option"] =
        $scope.receipts_option;
      $localStorage.saved_filters_reporte_liqudacion["fianza_poliza"] =
        $scope.fianza_poliza;
      $localStorage.saved_filters_reporte_liqudacion["recibo_nota"] =
        $scope.recibo_nota;
    }
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      $localStorage.saved_filters_reporte_liqudacion["page"] = pagina;
      vm.Generar(1, 1, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $localStorage.saved_filters_reporte_liqudacion["page"] =
          $scope.paginacion["paginaActual"] - 1;
        vm.Generar(
          $localStorage["saved_filters_reporte_liqudacion"] &&
            $localStorage["saved_filters_reporte_liqudacion"]["order"]
            ? $localStorage["saved_filters_reporte_liqudacion"]["order"]
            : 1,
          $localStorage["saved_filters_reporte_liqudacion"] &&
            $localStorage["saved_filters_reporte_liqudacion"]["asc"]
            ? $localStorage["saved_filters_reporte_liqudacion"]["asc"]
            : 1,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $localStorage.saved_filters_reporte_liqudacion["page"] =
          $scope.paginacion["paginaActual"] + 1;
        vm.Generar(
          $localStorage["saved_filters_reporte_liqudacion"] &&
            $localStorage["saved_filters_reporte_liqudacion"]["order"]
            ? $localStorage["saved_filters_reporte_liqudacion"]["order"]
            : 1,
          $localStorage["saved_filters_reporte_liqudacion"] &&
            $localStorage["saved_filters_reporte_liqudacion"]["asc"]
            ? $localStorage["saved_filters_reporte_liqudacion"]["asc"]
            : 1,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };
    function goToInfo(insurance) {
      if (vm.acceso_ver_pol) {
        if (insurance.poliza) {
          if (insurance.poliza.document_type == 1) {
            $state.go("polizas.info", { polizaId: insurance.poliza.id });
          } else if (insurance.poliza.document_type == 3) {
            $state.go("colectividades.info", { polizaId: insurance.poliza.id });
          }
        } else {
          $state.go("fianzas.info", { polizaId: insurance.fianza.id });
        }
      }
    }

    $scope.exportDataExcel = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            // templateUrl: 'app/reportes/reportexcel.option.html',
            // controller: 'ReportExcelByCtrl',
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "lg",
            resolve: {
              filters: function () {
                return $scope.filtros;
              },
              from: function () {
                return null;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.filtros.orden = $scope.columnArray;
        $scope.filtros.export_type = 2;
        if (param == 1) {
          $scope.excel_liquidacion = "service_reporte-cobranzaReport-1-excel";
          $http({
            method: "POST",
            url: url.IP + $scope.excel_liquidacion,
            data: $scope.filtros,
            headers: {
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "arraybuffer",
          }).then(function (data, status, headers, config) {
            if (data.status == 200) {
              l.stop();
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Cobranza.xls");
            } else {
              SweetAlert.swal(
                "Error",
                "Ha ocurrido un error al descargar el reporte",
                "error"
              );
              l.stop();
            }
          });
        }
      }
    };

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        console.log(data);
        vm.providers = data.data;
      });
    }

    function getContractors() {
      ContratanteService.getContratantes().then(function (data) {
        vm.contractors = data;
      });
    }

    function getClaves() {
      providerService.getClaves().then(function (data) {
        vm.claves = data.results;
      });
    }

    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }

    $scope.typeReceipt = function (parType) {
      switch (parType) {
        case 1:
          return "Póliza";
          break;
        case 2:
          return "Endoso";
          break;
        case 3:
          return "Fianza";
          break;
        case 4:
          return "Bono";
          break;
      }
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "";
      }
    };

    function getReferenciador() {
      vm.vendedores = [];
      $http.get(url.IP + "get-vendors").then(function (user) {
        user.data.forEach(function (u) {
          var obj = {
            name: u.first_name + " " + u.last_name,
            id: u.id,
          };
          vm.vendedores.push(obj);
        });
      });
    }

    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group.val) {
        var word_data = vm.form.group.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    $scope.actual_page = 1;

    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            vm.ramos = response.data;
          });
      }
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }

    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      // $scope.optionsSent = [
      //     {'value': 1, 'label': 'Totales de la Agrupación'},
      //     {'value': 2, 'label': 'Desglose de consulta'},
      // ];
      $scope.infoUser = $sessionStorage.infoUser;
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        $scope.url_go_excel = "service_reporte-cobranzaReport-1-excel";
        if (option) {
          // Totales de la Agrupación
          if (option == 1) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            filters.export_type = option;
            $http({
              method: "POST",
              url: url.IP + $scope.url_go_excel,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Cobranza.xls");
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  l.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          } else if (option == 2) {
            filters.export_type = option;
            var la = Ladda.create(document.querySelector(".ladda-button"));
            la.start();
            $http({
              method: "POST",
              url: url.IP + $scope.url_go_excel,
              data: filters,
              headers: {
                "Content-Type":
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              },
              responseType: "arraybuffer",
            })
              .then(function (data, status, headers, config) {
                if (data.status == 200) {
                  var blob = new Blob([data.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(blob, "Reporte_Cobranza.xls");
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al descargar el reporte",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                  la.stop();
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteCobrazaController", ReporteCobrazaController);

  ReporteCobrazaController.$inject = [
    "dataFactory",
    "$window",
    "$uibModal",
    "$sce",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$filter",
    "$parse",
    "exportFactory",
    "ContratanteService",
    "$sessionStorage",
    "$localStorage",
    "$q",
  ];

  function ReporteCobrazaController(
    dataFactory,
    $window,
    $uibModal,
    $sce,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $filter,
    $parse,
    exportFactory,
    ContratanteService,
    $sessionStorage,
    $localStorage,
    $q
  ) {
    var vm = this;
    var savedFiltersCobranza = {};

    $(".js-example-basic-multiple").select2();
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
      {
        id: 7,
        name: "Semanal",
      },
      {
        id: 14,
        name: "Catorcenal",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por Iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
    ];

    vm.option_policy = [
      {
        id: 1,
        name: "Inicio de vigencia",
      },
      {
        id: 2,
        name: "Vencimiento",
      },
      {
        id: 3,
        name: "Fecha de pago",
      },
      {
        id: 4,
        name: "Fecha de liquidación",
      },
      {
        id: 5,
        name: "Fecha de conciliación",
      },
      {
        id: 6,
        name: "Reporte de operación",
      },
      {
        id: 7,
        name: "Fecha compromiso de pago",
      },
    ];

    $scope.columnArray = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;
    $scope.showButtonExcel = false;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.org_name = usr.urlname;

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.table = {};
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.changeUntil = changeUntil;
    vm.changeReceipts = changeReceipts;
    vm.goToInfo = goToInfo;
    vm.formatearNumero = formatearNumero;
    vm.changeGroupBy = changeGroupBy;
    vm.apagarBusquedaPorFolio = apagarBusquedaPorFolio;

    vm.matchesGroupinglevel = matchesGroupinglevel;
    vm.matchesClassification = matchesClassification;

    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;

    vm.changeSubgrouping = changeSubgrouping;
    vm.changeSubsubgrouping = changeSubsubgrouping;
    $scope.subgroups = [];
    $scope.subsubgroups = [];
    $scope.subgrouping = [];
    $scope.subsubgrouping = [];
    vm.changeBLine = changeBLine;
    $(".js-example-basic-multiple").select2();
    vm.only_caratula_poliza = 0;
    function changeBLine(obj) {
      $scope.bLine = obj;
      if (obj) {
        vm.form.businesLine = obj;
      } else {
        vm.form.businesLine = 0;
      }
    }
    vm.businesLine = [
      {
        id: 1,
        name: "Comercial",
      },
      {
        id: 2,
        name: "Personal",
      },
      {
        id: 3,
        name: "Otro",
      },
    ];
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                vm.permiso_ver_referenciador = true;
              } else {
                vm.permiso_ver_referenciador = false;
              }
            }
          });
        }
      });
    }
    vm.form = {
      provider: 0,
      vendedor: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: 0,
      group: 0,
      recibos_pagados: false,
      add_precancelados: false,
      recibos_no_pagados: true,
      recibos_prorrogados: false,
      recibos_liquidados: false,
      recibos_conciliados: false,
      recibos_delivered: false,
      recibos_precancelados: false,
      recibos_cancelados: false,
      recibos_cerrados: false,
      recibos_pago_parcial: false,
      cve_agente: "",
      identifier: "",
      valueDolar: "",
      valueUdi: "",
      subgroup: 0,
      subsubgroup: 0,
      groupinglevel: 0,
      subgrouping: 0,
      classification: 0,
      subsubgrouping: 0,
      businessLine: 0,
      celula: 0,
      only_caratula: 0,
      tipo_folio_buscar: null,
      policy_id: null,
      policy_label: null,
    };
    vm.form.classification = 0;
    // JIRA 838
    var canceler = null;
    vm.searchPolicies = function (term) {
      if (!term || term.length < 3) return [];

      // cancela request anterior
      if (canceler) canceler.resolve();
      canceler = $q.defer();

      return $http
        .get(url.IP + "polizas-autocomplete/", {
          params: { q: term, types: [1, 3], limit: 20 },
          timeout: canceler.promise,
        })
        .then(function (res) {
          vm.loadingPolicies = false;
          return res.data || [];
        })
        .catch(function () {
          return [];
        });
    };

    vm.onPolicySelected = function (item) {
      $scope.filtros = {};
      $scope.filtros.policy_id = item.id;
      $scope.filtros.policy_label = item.label;
    };

    vm.clearPolicy = function () {
      vm.policySearch = "";
      $scope.filtros.policy_id = null;
      $scope.filtros.policy_label = null;
    };
    // JIRA 838 END
    vm.table = {
      headers: [
        "No.Póliza/Fianza",
        "Tipo Recibo",
        "No.Endoso",
        "Endoso Descripción",
        "Estatus Póliza/Endoso",
        "Grupo",
        "Contratante",
        "Correo electrónico",
        "Teléfono",
        "Alías Aseguradora/Afianzadora",
        "Ramo",
        "Subramo",
        "Identificador",
        "Riesgo/Asegurado",
        "Forma de Pago",
        "Moneda",
        "Serie No.Recibo",
        "Fecha Inicio recibo",
        "Fecha Fin recibo",
        "Vencimiento",
        "Antigüedad",
        "Promesa Pago",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Estatus recibo",
        "Conducto de Pago",
        "Metodo de Pago",
        "Documento de Pago",
        "Fecha Pago",
        "Fecha Liquidación",
        "Folio de Liquidación",
        "Fecha de conciliación",
        "Comisión conciliada",
        "Fecha Inicio Póliza/Fianza",
        "Fecha Fin Póliza/Fianza",
        "Clave de Agente",
        "Referenciador",
        "Sucursal",
        "Responsable",
        "Creado por",
        "Fecha Creación",
        "Importe Pesos",
        "Ej. Cobranza",
        "Pagado por",
        "Bitacora",
        "Subgrupo",
        "Subsubgrupo",
        "Agrupación",
        "Subagrupación",
        "Subsubagrupación",
        "Clasificación",
        "Línea de Negocio",
        "Promesa Pago",
        "Número de Carátula",
        "Carátula Contratante",
        "Celula",
      ],
    };

    vm.group_by = [
      {
        id: 1,
        name: "Aseguradora",
      },
      {
        id: 2,
        name: "Ramo",
      },
      {
        id: 3,
        name: "Subramo",
      },
      {
        id: 4,
        name: "Grupo",
      },
      {
        id: 5,
        name: "Referenciador",
      },
      {
        id: 7,
        name: "Usuario",
      },
      // ,{
      //   id: 6,
      //   name: 'Responsable'
      // }
    ];

    vm.entregados = [
      {
        id: true,
        name: "Entregado",
      },
      {
        id: false,
        name: "No entregado",
      },
    ];

    getCelulasContractor();

    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }
    $scope.numberFormatUdi = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueUdi = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      }
    };
    $scope.numberFormatDolar = function (nStr) {
      var toNumber = vm.formatearNumero(nStr);
      if (isNaN(toNumber)) {
        vm.form.valueDolar = "";
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
      }
    };

    function moneda(num) {
      num = num.toString().replace(/\$|\,/g, "");
      if (isNaN(num)) {
        num = "0";
      }
      var sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      var cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) {
        cents = "0" + cents;
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num =
          num.substring(0, num.length - (4 * i + 3)) +
          "," +
          num.substring(num.length - (4 * i + 3));
      }
      return (sign ? "" : "-") + "$" + num + "." + cents;
    }

    $scope.selectReceiptsOption = function (parValue, param) {
      if (parValue == 0) {
        $scope.cp_todos = true;
        $scope.cp_domiciliado = false;
        $scope.cp_no_domiciliado = false;
        $scope.cp_agente = false;
        $scope.cp_cac = false;
        $scope.cp_nomina = false;
        $scope.cp_cut = false;
        $scope.receits_domiciliados = [];
      } else {
        $scope.$applyAsync(function () {
          $scope.cp_todos = false;
          $scope.$applyAsync();
          if (parValue == 1) {
            $scope.cp_no_domiciliado = param;
            $scope.cp_todos = false;
          } else if (parValue == 2) {
            $scope.cp_agente = param;
            $scope.cp_todos = false;
          } else if (parValue == 3) {
            $scope.cp_cac = param;
            $scope.cp_todos = false;
          } else if (parValue == 4) {
            $scope.cp_domiciliado = param;
            $scope.cp_todos = false;
          } else if (parValue == 5) {
            $scope.cp_nomina = param;
            $scope.cp_todos = false;
          } else if (parValue == 6) {
            $scope.cp_cut = param;
            $scope.cp_todos = false;
          }
          if (param) {
            if ($scope.receits_domiciliados.indexOf(parValue) === -1) {
              $scope.receits_domiciliados.push(parValue);
            }
          } else {
            $scope.receits_domiciliados.forEach(function (item, index) {
              if (item == parValue) {
                $scope.receits_domiciliados.splice(index, 1);
              }
            });
          }
        });
      }
    };

    $scope.selectFianzaOption = function (parValue) {
      if (parValue == "fianza") {
        $scope.fianza_poliza_sel = 2;
      } else if (parValue == "poliza") {
        $scope.fianza_poliza_sel = 1;
      } else if (parValue == "bono") {
        $scope.fianza_poliza_sel = 3;
      } else if (parValue == "colectiva") {
        $scope.fianza_poliza_sel = 4;
      } else if (parValue == "caratula") {
        $scope.fianza_poliza_sel = 5;
      } else {
        $scope.fianza_poliza_sel = 0;
      }
      $scope.fianza_poliza = parValue;
      savedFiltersCobranza["fianza_poliza"] = parValue;
      savedFiltersCobranza["fianza_poliza_sel"] = $scope.fianza_poliza_sel;
    };
    $scope.recibo_nota = "ambos";
    $scope.recibo_nota_sel = 0;

    $scope.selectReciboOption = function (parValue) {
      if (parValue == "recibo") {
        $scope.recibo_nota_sel = 1;
      } else if (parValue == "nota") {
        $scope.recibo_nota_sel = 2;
      } else {
        $scope.recibo_nota_sel = 0;
      }
    };

    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.changeReport = function () {
      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id == 1) {
          $scope.created_at = true;
          $scope.vigency = false;
        } else if (vm.form.dates_sel.id == 2) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 3) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 4) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 5) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 6) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 7) {
          $scope.vigency = true;
          $scope.created_at = false;
        }
      } else {
        $scope.vigency = false;
        $scope.created_at = false;
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };

    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };
    $scope.selectUserPay = function (x, y) {
      vm.user_pay_selected = [];
      x.forEach(function (r) {
        vm.user_pay_selected.push(parseInt(r.id));
      });
    };
    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };
    vm.getCaratulas = getCaratulas;
    function getCaratulas(parId) {
      var results = [];
      var mapeo_caratulas = [];
      if (parId) {
        if (parId.val.length >= 3) {
          $scope.show_cds = "get-all-caratulas/";
          $http({
            method: "POST",
            url: url.IP + $scope.show_cds,
            data: {
              word: parId.val,
            },
          })
            .then(
              function success(request) {
                var results = [];
                var mapeo_caratulas = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    vm.only_caratula_poliza = 0;
                    $scope.autocompleteData = [];
                    vm.word.id = 0;
                    toaster.warning("Carátula no encontrada");
                  } else {
                    request.data.forEach(function (poliza) {
                      vm.policy = poliza;
                      if (poliza.document_type == 11) {
                        mapeo_caratulas.push(poliza);
                      }
                    });
                    results = _.map(mapeo_caratulas, function (item) {
                      if (item.contractor) {
                        var label =
                          item.poliza_number +
                          " - " +
                          item.contractor.full_name +
                          " - " +
                          convertDate(item.start_of_validity) +
                          " - " +
                          convertDate(item.end_of_validity) +
                          " | " +
                          item.statuslabel;
                      } else {
                        var label =
                          item.poliza_number + " | " + item.statuslabel;
                      }
                      return {
                        label: label,
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                      };
                    });
                    $scope.autocompleteData = results;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        } else {
          vm.only_caratula_poliza = 0;
          $scope.autocompleteData = [];
          vm.word.id = 0;
        }
      }
    }
    vm.getCarSelected = getCarSelected;
    function getCarSelected(caratula) {
      vm.only_caratula_poliza = caratula.id;
    }
    $scope.$watch("vm.word", function (newValue, oldValue) {
      if (vm.word) {
        if (vm.word.id) {
          vm.only_caratula_poliza = parseInt(vm.word.id);
        } else {
          vm.only_caratula_poliza = 0;
        }
      }
    });
    activate();
    function changeReceipts(par, asc) {
      // console.log('uuuuuuuu',par,asc)
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.receipts_rec_asc = asc;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.receipts_status_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.receipts_pneta_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.receipts_rpf_asc = asc;
          vm.receipts_status_asc = 0;
          vm.receipts_rec_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.receipts_der_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.receipts_iva_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 7:
          Generar(par, asc);
          vm.receipts_ptotal_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.receipts_fini_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.receipts_ffin_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.receipts_com_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 11:
          Generar(par, asc);
          vm.receipts_fvenc_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 12:
          Generar(par, asc);
          vm.receipts_nump_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 13:
          Generar(par, asc);
          vm.receipts_tip_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 14:
          Generar(par, asc);
          vm.receipts_cont_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 15:
          Generar(par, asc);
          vm.receipts_aseg_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 16:
          Generar(par, asc);
          vm.receipts_ramo_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 17:
          Generar(par, asc);
          vm.receipts_subr_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 18:
          Generar(par, asc);
          vm.receipts_fpago_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 19:
          Generar(par, asc);
          vm.receipts_status1_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 20:
          Generar(par, asc);
          vm.receipts_vig_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_clave_asc = 0;
          break;
        case 21:
          Generar(par, asc);
          vm.receipts_clave_asc = asc;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          break;
        case 34:
          Generar(par, asc);
          vm.receipts_clave_asc = 0;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.receipts_folioliq_asc = asc;
          break;
        case 43:
          Generar(par, asc);
          vm.receipts_clave_asc = 0;
          vm.receipts_rec_asc = 0;
          vm.receipts_status_asc = 0;
          vm.receipts_pneta_asc = 0;
          vm.receipts_rpf_asc = 0;
          vm.receipts_der_asc = 0;
          vm.receipts_iva_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipts_tip_asc = 0;
          vm.receipts_fvenc_asc = 0;
          vm.receipts_com_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ramo_asc = 0;
          vm.receipts_subr_asc = 0;
          vm.receipts_fpago_asc = 0;
          vm.receipts_status1_asc = 0;
          vm.receipts_vig_asc = 0;
          vm.receipts_hasta_asc = 0;
          vm.vm.receipts_promesa_pago_asc = asc;
          break;
      }
    }

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");

      return date;
    }

    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      var params = {};
      var url_send = url.IP + "save-config-fields-reports/";
      params = {
        tipo: 1,
      };
      $scope.filteredKeys = [
        "No.Póliza/Fianza",
        "Tipo Recibo",
        "No.Endoso",
        "Endoso Descripción",
        "Estatus Póliza/Endoso",
        "Grupo",
        "Contratante",
        "Correo electrónico",
        "Teléfono",
        "Alías Aseguradora/Afianzadora",
        "Ramo",
        "Subramo",
        "Identificador",
        "Riesgo/Asegurado",
        "Forma de Pago",
        "Moneda",
        "Serie No.Recibo",
        "Fecha Inicio recibo",
        "Fecha Fin recibo",
        "Vencimiento",
        "Antigüedad",
        "Promesa Pago",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "Comisión",
        "Estatus recibo",
        "Conducto de Pago",
        "Metodo de Pago",
        "Documento de Pago",
        "Fecha Pago",
        "Fecha Liquidación",
        "Folio de Liquidación",
        "Folio de Pago",
        "Fecha de conciliación",
        "Comisión conciliada",
        "Fecha Inicio Póliza/Fianza",
        "Fecha Fin Póliza/Fianza",
        "Clave de Agente",
        "Referenciador",
        "Sucursal",
        "Responsable",
        "Creado por",
        "Fecha Creación",
        "Importe Pesos",
        "Ej. Cobranza",
        "Pagado por",
        "Bitacora",
        "Subgrupo",
        "Subsubgrupo",
        "Agrupación",
        "Subagrupación",
        "Subsubagrupación",
        "Clasificación",
        "Línea de Negocio",
        "Número de Carátula",
        "Carátula Contratante",
        "Célula",
        "Año(Automovil)",
        "Serie(Automovil)",
        "Contacto(nombre)",
        "Contacto(telefono)",
        "Contacto(email)",
        "Tipo Póliza",
        "Tipo de Cambio",
        "Póliza del Recibo con Endoso(s) en Trámite",
        "FechaInicioEndoso",
        "%Comisión Estimada",
        "%Comisión Conciliada",
        "Liquidado por",
        "Adjuntos",
        "Porcentaje de descuento",
        "Origen Póliza",
        "Póliza Anterior",
        "Póliza Siguiente",
        "Pérdida Total",
        "Fecha de Cancelación de Póliza",
      ];
      $http
        .get(url_send, { params: params })
        .then(function (response) {
          if (response.data && response.data.data) {
            // $scope.filteredKeys = [];
            // $scope.filteredKeys = Object.keys(response.data.data).filter(function(key) {
            //   return response.data.data[key] === true;
            // });
            $scope.filteredKeys = $scope.filteredKeys.filter(function (key) {
              return response.data.data[key] === true;
            });
          } else {
            $scope.filteredKeys = [
              "No.Póliza/Fianza",
              "Tipo Recibo",
              "No.Endoso",
              "Endoso Descripción",
              "Estatus Póliza/Endoso",
              "Grupo",
              "Contratante",
              "Correo electrónico",
              "Teléfono",
              "Alías Aseguradora/Afianzadora",
              "Ramo",
              "Subramo",
              "Identificador",
              "Riesgo/Asegurado",
              "Forma de Pago",
              "Moneda",
              "Serie No.Recibo",
              "Fecha Inicio recibo",
              "Fecha Fin recibo",
              "Vencimiento",
              "Antigüedad",
              "Promesa Pago",
              "Prima Neta",
              "RPF",
              "Derecho",
              "IVA",
              "Prima Total",
              "Comisión",
              "Estatus recibo",
              "Conducto de Pago",
              "Metodo de Pago",
              "Documento de Pago",
              "Fecha Pago",
              "Fecha Liquidación",
              "Folio de Liquidación",
              "Folio de Pago",
              "Fecha de conciliación",
              "Comisión conciliada",
              "Fecha Inicio Póliza/Fianza",
              "Fecha Fin Póliza/Fianza",
              "Clave de Agente",
              "Referenciador",
              "Sucursal",
              "Responsable",
              "Creado por",
              "Fecha Creación",
              "Importe Pesos",
              "Ej. Cobranza",
              "Pagado por",
              "Bitacora",
              "Subgrupo",
              "Subsubgrupo",
              "Agrupación",
              "Subagrupación",
              "Subsubagrupación",
              "Clasificación",
              "Línea de Negocio",
              "Número de Carátula",
              "Carátula Contratante",
              "Célula",
              "Año(Automovil)",
              "Serie(Automovil)",
              "Contacto(nombre)",
              "Contacto(telefono)",
              "Contacto(email)",
              "Tipo Póliza",
              "Tipo de Cambio",
              "Póliza del Recibo con Endoso(s) en Trámite",
              "FechaInicioEndoso",
              "%Comisión Estimada",
              "%Comisión Conciliada",
              "Liquidado por",
              "Adjuntos",
              "Porcentaje de descuento",
              "Origen Póliza",
              "Póliza Anterior",
              "Póliza Siguiente",
              "Pérdida Total",
              "Fecha de Cancelación de Póliza",
            ];
          }
        })
        .catch(function (error) {
          console.error("Error loading settings", error);
        });
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      $(".js-example-basic-multiple").select2();
      getProviders();
      getContractors();
      getClaves();
      getUsuarios();
      getReferenciador();
      getSubramos();
      getPermisions();
      getSucursales();
      $scope.total = 0;
      $scope.prima_neta = 0;
      $scope.sub_total = 0;
      $scope.comision = 0;
      vm.form.sincea = 12;
      vm.ramos_selected = [];
      vm.subramos_ramo_sel = [];
      vm.subramos_selected = [];
      vm.contratantes_selected = [];
      vm.claves_selected = [];
      vm.usuarios_selected = [];
      vm.user_pay_selected = [];
      vm.form.since = convertDate(new Date());
      var endingDate = convertDate(new Date());
      vm.form.until = endingDate;
      /* Información de usuario */
      $scope.infoUser = $sessionStorage.infoUser;
      vm.form.contratante =
        savedFiltersCobranza && savedFiltersCobranza["contratante"]
          ? savedFiltersCobranza["contratante"]
          : "";
      vm.form.group =
        savedFiltersCobranza && savedFiltersCobranza["group"]
          ? savedFiltersCobranza["group"]
          : "";
      vm.form.businesLine =
        savedFiltersCobranza && savedFiltersCobranza["businesLine"]
          ? savedFiltersCobranza["businesLine"]
          : 0;
      vm.form.groupinglevel =
        savedFiltersCobranza && savedFiltersCobranza["groupinglevel"]
          ? savedFiltersCobranza["groupinglevel"]
          : "";
      vm.form.classification =
        savedFiltersCobranza && savedFiltersCobranza["classification"]
          ? savedFiltersCobranza["classification"]
          : 0;
      vm.form.celula =
        savedFiltersCobranza && savedFiltersCobranza["celula"]
          ? savedFiltersCobranza["celula"]
          : 0;
      vm.form.cve_agente =
        savedFiltersCobranza && savedFiltersCobranza["cve_agente"]
          ? savedFiltersCobranza["cve_agente"]
          : "";
      vm.form.vendedor =
        savedFiltersCobranza && savedFiltersCobranza["vendedor"]
          ? savedFiltersCobranza["vendedor"]
          : 0;
      vm.form.sucursal =
        savedFiltersCobranza && savedFiltersCobranza["sucursal"]
          ? savedFiltersCobranza["sucursal"]
          : 0;
      vm.form.identifier =
        savedFiltersCobranza && savedFiltersCobranza["identifier"]
          ? savedFiltersCobranza["identifier"]
          : "";
      vm.form.group_by =
        savedFiltersCobranza && savedFiltersCobranza["group_by"]
          ? savedFiltersCobranza["group_by"]
          : "";
      vm.form.dates_sel =
        savedFiltersCobranza && savedFiltersCobranza["dates_sel"]
          ? savedFiltersCobranza["dates_sel"]
          : "";
      vm.form.add_precancelados =
        savedFiltersCobranza && savedFiltersCobranza["add_precancelados"]
          ? savedFiltersCobranza["add_precancelados"]
          : false;
      vm.form.valueDolar =
        savedFiltersCobranza && savedFiltersCobranza["valueDolar"]
          ? savedFiltersCobranza["valueDolar"]
          : "";
      vm.form.valueUdi =
        savedFiltersCobranza && savedFiltersCobranza["valueUdi"]
          ? savedFiltersCobranza["valueUdi"]
          : "";
      vm.form.buscar_por_folio =
        savedFiltersCobranza && savedFiltersCobranza["buscar_por_folio"]
          ? savedFiltersCobranza["buscar_por_folio"]
          : false;
      vm.form.recibos_pagados =
        savedFiltersCobranza && savedFiltersCobranza["recibos_pagados"]
          ? savedFiltersCobranza["recibos_pagados"]
          : false;
      vm.form.recibos_no_pagados =
        savedFiltersCobranza && savedFiltersCobranza["recibos_no_pagados"]
          ? savedFiltersCobranza["recibos_no_pagados"]
          : true;
      vm.form.recibos_prorrogados =
        savedFiltersCobranza && savedFiltersCobranza["recibos_prorrogados"]
          ? savedFiltersCobranza["recibos_prorrogados"]
          : false;
      vm.form.recibos_liquidados =
        savedFiltersCobranza && savedFiltersCobranza["recibos_liquidados"]
          ? savedFiltersCobranza["recibos_liquidados"]
          : false;
      vm.form.recibos_conciliados =
        savedFiltersCobranza && savedFiltersCobranza["recibos_conciliados"]
          ? savedFiltersCobranza["recibos_conciliados"]
          : false;
      vm.form.recibos_precancelados =
        savedFiltersCobranza && savedFiltersCobranza["recibos_conciliados"]
          ? savedFiltersCobranza["recibos_conciliados"]
          : false;
      vm.form.recibos_delivered =
        savedFiltersCobranza && savedFiltersCobranza["recibos_delivered"]
          ? savedFiltersCobranza["recibos_delivered"]
          : false;
      $scope.cp_todos =
        savedFiltersCobranza && savedFiltersCobranza["cp_todos"]
          ? savedFiltersCobranza["cp_todos"]
          : false;
      $scope.cp_domiciliado =
        savedFiltersCobranza && savedFiltersCobranza["cp_domiciliado"]
          ? savedFiltersCobranza["cp_domiciliado"]
          : false;
      $scope.cp_no_domiciliado =
        savedFiltersCobranza && savedFiltersCobranza["cp_no_domiciliado"]
          ? savedFiltersCobranza["cp_no_domiciliado"]
          : false;
      $scope.cp_agente =
        savedFiltersCobranza && savedFiltersCobranza["cp_agente"]
          ? savedFiltersCobranza["cp_agente"]
          : false;
      $scope.cp_cac =
        savedFiltersCobranza && savedFiltersCobranza["cp_cac"]
          ? savedFiltersCobranza["cp_cac"]
          : false;
      $scope.cp_nomina =
        savedFiltersCobranza && savedFiltersCobranza["cp_nomina"]
          ? savedFiltersCobranza["cp_nomina"]
          : false;
      $scope.cp_cut =
        savedFiltersCobranza && savedFiltersCobranza["cp_cut"]
          ? savedFiltersCobranza["cp_cut"]
          : false;
      $scope.recibo_nota =
        savedFiltersCobranza && savedFiltersCobranza["recibo_nota"]
          ? savedFiltersCobranza["recibo_nota"]
          : "ambos";
      vm.form.user =
        savedFiltersCobranza && savedFiltersCobranza["user"]
          ? savedFiltersCobranza["user"]
          : "";
      $scope.receits_domiciliados =
        savedFiltersCobranza && savedFiltersCobranza["receits_domiciliados"]
          ? savedFiltersCobranza["receits_domiciliados"]
          : [];
      $scope.vigency = savedFiltersCobranza && savedFiltersCobranza["vigency"];
      $scope.created_at =
        savedFiltersCobranza && savedFiltersCobranza["created_at"];
      $scope.fianza_poliza =
        savedFiltersCobranza && savedFiltersCobranza["fianza_poliza"]
          ? savedFiltersCobranza["fianza_poliza"]
          : "ambas_pf";
      $scope.fianza_poliza_sel = savedFiltersCobranza
        ? savedFiltersCobranza["fianza_poliza_sel"]
        : 0;
      var saved = savedFiltersCobranza;
      if ($scope.fianza_poliza == "fianza") {
        $scope.fianza_poliza_sel = 2;
      } else if ($scope.fianza_poliza == "poliza") {
        $scope.fianza_poliza_sel = 1;
      } else if ($scope.fianza_poliza == "bono") {
        $scope.fianza_poliza_sel = 3;
      } else if ($scope.fianza_poliza == "colectiva") {
        $scope.fianza_poliza_sel = 4;
      } else if ($scope.fianza_poliza == "caratula") {
        $scope.fianza_poliza_sel = 5;
      } else {
        $scope.fianza_poliza_sel = 0;
      }
      $scope.bLine = 0;
      $scope.changeReport();
    }

    function changeGroupBy() {
      $scope.subsubgroups_result = [];
      $scope.showSums = false;
      vm.show_pag_cobranza = false;
    }
    function getPermisions() {
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            vm.acceso_reportes = perm;
            vm.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  vm.acceso_rep_fia = true;
                } else {
                  vm.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  vm.acceso_rep_sin = true;
                } else {
                  vm.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  vm.acceso_rep_end = true;
                } else {
                  vm.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  vm.acceso_rep_pol = true;
                } else {
                  vm.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  vm.acceso_rep_ren = true;
                } else {
                  vm.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  vm.acceso_rep_cob = true;
                } else {
                  vm.acceso_rep_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Comisiones") {
            vm.coms = perm;
            vm.coms.permissions.forEach(function (acc) {
              if (acc.permission_name == "Comisiones") {
                if (acc.checked == true) {
                  vm.permiso_comisiones = true;
                } else {
                  vm.permiso_comisiones = false;
                }
              }
            });
          }
        });
      }
    }
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 6,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
        // ----
        {
          id: 15,
          subramo_code: 15,
          subramo_name: "Individual",
        },
        {
          id: 16,
          subramo_code: 16,
          subramo_name: "Colectivas",
        },
        {
          id: 17,
          subramo_code: 17,
          subramo_name: "Penales",
        },
        {
          id: 18,
          subramo_code: 18,
          subramo_name: "No penales",
        },
        {
          id: 19,
          subramo_code: 19,
          subramo_name: "Amparo a conductores",
        },
        {
          id: 20,
          subramo_code: 20,
          subramo_name: "Obra",
        },
        {
          id: 21,
          subramo_code: 21,
          subramo_name: "Proveeduria",
        },
        {
          id: 22,
          subramo_code: 22,
          subramo_name: "Fiscales",
        },
        {
          id: 23,
          subramo_code: 23,
          subramo_name: "Arrendamiento",
        },
        {
          id: 24,
          subramo_code: 24,
          subramo_name: "Otras",
        },
        {
          id: 25,
          subramo_code: 25,
          subramo_name: "Suministro",
        },
        {
          id: 26,
          subramo_code: 26,
          subramo_name: "Compra Venta",
        },
        {
          id: 27,
          subramo_code: 27,
          subramo_name: "Otras",
        },
        {
          id: 28,
          subramo_code: 28,
          subramo_name: "Relación con fianza",
        },
        {
          id: 29,
          subramo_code: 29,
          subramo_name: "Sin relación con fianza",
        },
      ];
    }
    function Generar(order, asc, parPage) {
      var l = Ladda.create(document.querySelector(".ladda-buttonC"));
      l.start();

      if (
        !vm.buscar_por_folio &&
        (vm.form.dates_sel == undefined || vm.form.dates_sel == null)
      ) {
        l.stop();
        SweetAlert.swal(
          "Información",
          "Es necesario seleccionar una opción de Reporte por",
          "error"
        );
        return;
      }

      if (vm.buscar_por_folio) {
        if (vm.form.folio_a_buscar == "" || !vm.form.folio_a_buscar) {
          l.stop();
          SweetAlert.swal(
            "Información",
            "Es necesario ingresar el número de folio",
            "error"
          );
          return;
        }
      }

      $scope.order = order;
      $scope.asc = asc;

      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));

      if (antiguedad < 0) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }

      $scope.total = 0.0;
      $scope.prima_neta = 0.0;
      $scope.comision = 0.0;

      if (vm.form.subgroup) {
        if (vm.form.subgroup.id) {
          var g1 = vm.form.subgroup.id;
        } else {
          var g1 = 0;
        }
      }
      if (vm.form.subsubgroup) {
        if (vm.form.subsubgroup.id) {
          var g2 = vm.form.subsubgroup.id;
        } else {
          var g2 = 0;
        }
      } else {
        var g2 = 0;
      }
      if (vm.form.groupinglevel) {
        if (vm.form.groupinglevel.val) {
          var gl = vm.form.groupinglevel.value;
        } else {
          var gl = 0;
        }
      } else {
        var gl = 0;
      }
      if (vm.form.subgrouping) {
        if (vm.form.subgrouping.id) {
          var gl1 = vm.form.subgrouping.id;
        } else {
          var gl1 = 0;
        }
      } else {
        var gl1 = 0;
      }
      if (vm.form.subsubgrouping) {
        if (vm.form.subsubgrouping.id) {
          var gl2 = vm.form.subsubgrouping.id;
        } else {
          var gl2 = 0;
        }
      } else {
        var gl2 = 0;
      }
      var params = {
        provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider,
        vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
        ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
        subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
        status: vm.form.status.id ? vm.form.status.id : vm.form.status,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        grupo: vm.form.group.value ? vm.form.group.value : 0,
        type_contractor: vm.form.contratante.type
          ? vm.form.contratante.type
          : 0,
        recibos_pagados: vm.form.recibos_pagados,
        recibos_no_pagados: vm.form.recibos_no_pagados,
        recibos_prorrogados: vm.form.recibos_prorrogados,
        recibos_liquidados: vm.form.recibos_liquidados,
        recibos_conciliados: vm.form.recibos_conciliados,
        recibos_precancelados: vm.form.recibos_precancelados,

        recibos_cancelados: vm.form.recibos_cancelados,
        recibos_cerrados: vm.form.recibos_cerrados,
        recibos_pago_parcial: vm.form.recibos_pago_parcial,

        recibos_delivered:
          vm.form.recibos_delivered && vm.form.recibos_delivered.id
            ? vm.form.recibos_delivered.id
            : false,
        recibos_precancel: vm.form.add_precancelados,
        cve: vm.form.cve_agente ? vm.form.cve_agente : 0,
        order: order,
        asc: asc,
        ramos: vm.ramos_selected ? vm.ramos_selected : 0,
        subramos: vm.subramos_selected ? vm.subramos_selected : 0,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        claves: vm.claves_selected ? vm.claves_selected : 0,
        users: vm.usuarios_selected ? vm.usuarios_selected : 0,
        user_pay: vm.user_pay_selected ? vm.user_pay_selected : 0,
        page: parPage ? parPage : 1,
        group_by: vm.form.group_by ? vm.form.group_by.id : 0,
        identifier: vm.form.identifier ? vm.form.identifier : 0,
        sucursal: vm.form.sucursal ? vm.form.sucursal.id : 0,
        report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 1,
        domiciliado: $scope.receits_domiciliado,
        domiciliados: $scope.receits_domiciliados,
        recibos_por: $scope.fianza_poliza_sel ? $scope.fianza_poliza_sel : 0,
        option: $scope.recibo_nota_sel,
        valDolar: vm.form.valueDolar
          ? parseFloat(vm.form.valueDolar).toFixed(2)
          : 0,
        valUdi: vm.form.valueUdi ? parseFloat(vm.form.valueUdi).toFixed(2) : 0,
        classification: vm.form.classification.value
          ? vm.form.classification.value
          : vm.form.classification,
        subgrupo: g1 ? g1 : 0,
        subsubgrupo: g2 ? g2 : 0,
        groupinglevel: gl ? gl : 0,
        subgrupinglevel: gl1 ? gl1 : 0,
        subsubgrupinglevel: gl2 ? gl2 : 0,
        businessLine: $scope.bLine ? $scope.bLine.id : 0,
        only_caratula: vm.only_caratula_poliza ? vm.only_caratula_poliza : 0,
        tipo_folio_buscar: vm.form.tipo_folio_buscar
          ? vm.form.tipo_folio_buscar
          : 0,
        folio_a_buscar: vm.form.folio_a_buscar ? vm.form.folio_a_buscar : 0,
        usuario_owner: vm.form.user ? vm.form.user.id : 0,
      };
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          params.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.group) {
        if (vm.form.group.val == "") {
          params.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
      }
      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }
      params.celula = cel ? cel : 0;
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      // jira 838
      params.policy_id = $scope.filtros ? $scope.filtros.policy_id : null;
      // jira 838 end
      $scope.filtros = params;

      $scope.url_go = "reporte-cobranza-rep/";
      // $scope.url_go = 'v2/recibos/reporte-cobranza-rep/';
      $http({
        method: "POST",
        url: url.IP + $scope.url_go,
        data: $scope.filtros,
      }).then(
        function success(response) {
          if (params.group_by == 0) {
            vm.insurances = response.data.results;
            vm.config_pagination = response.data;
            l.stop();
            $scope.sumas = response.data.sumas;
            $scope.filtros.count = response.data.count;

            $scope.count_insurances = angular.copy(vm.insurances);
            if (vm.insurances.length < 10) {
              for (var i = 0; i < 10 - $scope.count_insurances.length; i++) {
                var object = {
                  recibo_numero: " ",
                  status: " ",
                  prima_neta: null,
                  rpf: null,
                  derecho: null,
                  iva: null,
                  prima_total: null,
                  fecha_inicio: " ",
                  fecha_fin: " ",
                  comision: null,
                  vencimiento: " ",
                  poliza: {
                    poliza_number: " ",
                    natural: " ",
                    aseguradora: " ",
                    ramo: " ",
                    subramo: " ",
                    forma_de_pago: " ",
                    status: " ",
                    start_of_validity: " ",
                    clave: {
                      clave: " ",
                    },
                  },
                  receipt_type: " ",
                };
                vm.insurances.push(object);
              }
            }

            $scope.cobranza_config = {
              count: response.data.count,
              previous: url.IP + $scope.url_go,
              next: url.IP + $scope.url_go,
            };
            vm.show_pag_cobranza = true;
            $scope.obtenerPaginacion(response.data, parPage ? parPage : 1);
            // testPagination('insurances', 'cobranza_config');

            //if(vm.insurances[0].recibo_numero == " "){
            //toaster.warning("No se encontraron registros");
            //$('#example').DataTable().clear();
            //$('#example').DataTable().draw();
            //$('#example').DataTable().destroy();
            //}
            //else{
            $scope.showButtonExcel = true;
            $scope.showSums = true;
            //}
          } else {
            l.stop();
            $scope.grupos_result = response.data.results;
            $scope.showButtonExcel = true;
          }
        },
        function error(err) {
          console.log("error", err);
          l.stop();
        }
      );

      // $http({
      //    method: 'GET',
      //      url: url.IP + 'get-sumas-cobranza',
      //      params: params
      //  }).then(function success(response) {
      //      $scope.sumas = response.data;
      //  })

      savedFiltersCobranza = angular.copy(params);
      savedFiltersCobranza["contratante"] = vm.form.contratante;
      savedFiltersCobranza["group"] = vm.form.group;
      savedFiltersCobranza["businesLine"] = vm.form.businesLine;
      savedFiltersCobranza["groupinglevel"] = vm.form.groupinglevel;
      savedFiltersCobranza["classification"] = vm.form.classification;
      savedFiltersCobranza["celula"] = vm.form.celula;
      savedFiltersCobranza["cve_agente"] = vm.form.cve_agente;
      savedFiltersCobranza["vendedor"] = vm.form.vendedor;
      savedFiltersCobranza["sucursal"] = vm.form.sucursal;
      savedFiltersCobranza["identifier"] = vm.form.identifier;
      savedFiltersCobranza["group_by"] = vm.form.group_by;
      savedFiltersCobranza["dates_sel"] = vm.form.dates_sel;
      savedFiltersCobranza["add_precancelados"] = vm.form.add_precancelados;
      savedFiltersCobranza["valueDolar"] = vm.form.valueDolar;
      savedFiltersCobranza["valueUdi"] = vm.form.valueUdi;
      savedFiltersCobranza["buscar_por_folio"] = vm.buscar_por_folio;
      savedFiltersCobranza["recibos_pagados"] = vm.form.recibos_pagados;
      savedFiltersCobranza["recibos_no_pagados"] = vm.form.recibos_no_pagados;
      savedFiltersCobranza["recibos_prorrogados"] = vm.form.recibos_prorrogados;
      savedFiltersCobranza["recibos_liquidados"] = vm.form.recibos_liquidados;
      savedFiltersCobranza["recibos_conciliados"] = vm.form.recibos_conciliados;
      savedFiltersCobranza["recibos_precancelados"] =
        vm.form.recibos_precancelados;
      savedFiltersCobranza["recibos_delivered"] = vm.form.recibos_delivered;
      savedFiltersCobranza["cp_todos"] = $scope.cp_todos;
      savedFiltersCobranza["cp_domiciliado"] = $scope.cp_domiciliado;
      savedFiltersCobranza["cp_no_domiciliado"] = $scope.cp_no_domiciliado;
      savedFiltersCobranza["cp_agente"] = $scope.cp_agente;
      savedFiltersCobranza["cp_cac"] = $scope.cp_cac;
      savedFiltersCobranza["cp_nomina"] = $scope.cp_nomina;
      savedFiltersCobranza["cp_cut"] = $scope.cp_cut;
      if ($scope.cp_todos) {
        $scope.selectReceiptsOption(0, $scope.cp_todos);
      }
      if ($scope.cp_domiciliado) {
        $scope.selectReceiptsOption(4, $scope.cp_domiciliado);
      }
      if ($scope.cp_no_domiciliado) {
        $scope.selectReceiptsOption(1, $scope.cp_no_domiciliado);
      }
      if ($scope.cp_agente) {
        $scope.selectReceiptsOption(2, $scope.cp_agente);
      }
      if ($scope.cp_cac) {
        $scope.selectReceiptsOption(3, $scope.cp_cac);
      }
      if ($scope.cp_nomina) {
        $scope.selectReceiptsOption(5, $scope.cp_nomina);
      }
      if ($scope.cp_cut) {
        $scope.selectReceiptsOption(6, $scope.cp_cut);
      }
      savedFiltersCobranza["fianza_poliza"] = $scope.fianza_poliza;
      savedFiltersCobranza["recibo_nota"] = $scope.recibo_nota;
      savedFiltersCobranza["bLine"] = vm.form.businesLine
        ? vm.form.businesLine
        : "";
    }

    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      savedFiltersCobranza["page"] = pagina;
      vm.Generar(1, 1, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        savedFiltersCobranza["page"] = $scope.paginacion["paginaActual"] - 1;
        vm.Generar(
          savedFiltersCobranza && savedFiltersCobranza["order"]
            ? savedFiltersCobranza["order"]
            : 1,
          savedFiltersCobranza && savedFiltersCobranza["asc"]
            ? savedFiltersCobranza["asc"]
            : 1,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        savedFiltersCobranza["page"] = $scope.paginacion["paginaActual"] + 1;
        vm.Generar(
          savedFiltersCobranza && savedFiltersCobranza["order"]
            ? savedFiltersCobranza["order"]
            : 1,
          savedFiltersCobranza && savedFiltersCobranza["asc"]
            ? savedFiltersCobranza["asc"]
            : 1,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };
    function apagarBusquedaPorFolio(buscar_por_folio) {
      $(".js-example-basic-multiple").select2();
      if (buscar_por_folio) {
        vm.form.tipo_folio_buscar = 1;
        vm.form.folio_a_buscar = "";
        vm.form.user = 0;
      } else {
        vm.form.tipo_folio_buscar = null;
        vm.form.folio_a_buscar = null;
        vm.form.user = 0;
      }
    }

    function goToInfo(insurance) {
      if (vm.acceso_ver_pol) {
        if (insurance.poliza) {
          if (insurance.poliza.document_type == 1) {
            $state.go("polizas.info", { polizaId: insurance.poliza.id });
          } else if (insurance.poliza.document_type == 3) {
            $state.go("colectividades.info", { polizaId: insurance.poliza.id });
          } else if (insurance.poliza.document_type == 12) {
            $state.go("flotillas.info", {
              polizaId: insurance.poliza.parent.id,
            });
          } else if (insurance.poliza.document_type == 11) {
            $state.go("flotillas.info", {
              polizaId: insurance.poliza.parent.id,
            });
          }
        } else {
          $state.go("fianzas.info", { polizaId: insurance.fianza.id });
        }
      }
    }

    $scope.addSiniestros = function (param) {
      $scope.addSiniestrosBitacora = param;
    };
    $scope.exportDataExcel = function (param) {
      if (vm.form.group_by) {
        if (vm.form.group_by.id) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            // templateUrl: 'app/reportes/reportexcel.option.html',
            // controller: 'ReportExcelByCtrl',
            templateUrl: "app/reportes/reportexcel.option.html",
            controller: ReportExcelByCtrl,
            controllerAs: "vmm",
            size: "lg",
            resolve: {
              filters: function () {
                return $scope.filtros;
              },
              from: function () {
                return null;
              },
              addSiniestrosBitacora: function () {
                return $scope.addSiniestrosBitacora;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        }
      } else {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.filtros.orden = $scope.columnArray;
        $scope.filtros.export_type = 2;
        var $listM = $("#example th")
          .map(function () {
            return $.trim($(this).text());
          })
          .get();
        if ($listM.includes("No.Póliza/Fianza")) {
          $listM.push("No.Póliza/Fianza");
        }
        if ($listM.includes("Tipo Recibo")) {
          $listM.push("Tipo Recibo");
        }
        if ($listM.includes("Tipo Póliza")) {
          $listM.push("Tipo Póliza");
        }
        if ($listM.includes("No.Endoso")) {
          $listM.push("No.Endoso");
        }
        if ($listM.includes("Endoso Descripción")) {
          $listM.push("Endoso Descripción");
        }
        if ($listM.includes("Estatus Póliza/Endoso")) {
          $listM.push("Estatus Póliza/Endoso");
        }
        if ($listM.includes("Grupo")) {
          $listM.push("Grupo");
        }
        if ($listM.includes("Contratante")) {
          $listM.push("Contratante");
        }
        if ($listM.includes("Correo electrónico")) {
          $listM.push("Correo electrónico");
        }
        if ($listM.includes("Teléfono")) {
          $listM.push("Teléfono");
        }
        if ($listM.includes("Alías Aseguradora/Afianzadora")) {
          $listM.push("Alías Aseguradora/Afianzadora");
        }
        if ($listM.includes("Ramo")) {
          $listM.push("Ramo");
        }
        if ($listM.includes("Subramo")) {
          $listM.push("Subramo");
        }
        if ($listM.includes("Identificador")) {
          $listM.push("Identificador");
        }
        if ($listM.includes("Riesgo/Asegurado")) {
          $listM.push("Riesgo/Asegurado");
        }
        if ($listM.includes("Forma de Pago")) {
          $listM.push("Forma de Pago");
        }
        if ($listM.includes("Moneda")) {
          $listM.push("Moneda");
        }
        if ($listM.includes("Serie No.Recibo")) {
          $listM.push("Serie No.Recibo");
        }
        if ($listM.includes("Fecha Inicio recibo")) {
          $listM.push("Fecha Inicio recibo");
        }
        if ($listM.includes("Fecha Fin recibo")) {
          $listM.push("Fecha Fin recibo");
        }
        if ($listM.includes("Vencimiento")) {
          $listM.push("Vencimiento");
        }
        if ($listM.includes("Antigüedad")) {
          $listM.push("Antigüedad");
        }
        if ($listM.includes("Prima Neta")) {
          $listM.push("Prima Neta");
        }
        if ($listM.includes("RPF")) {
          $listM.push("RPF");
        }
        if ($listM.includes("Derecho")) {
          $listM.push("Derecho");
        }
        if ($listM.includes("IVA")) {
          $listM.push("IVA");
        }
        if ($listM.includes("Prima Total")) {
          $listM.push("Prima Total");
        }
        if (vm.permiso_comisiones) {
          if ($listM.includes("Comisión")) {
            $listM.push("Comisión");
          }
          if ($listM.includes("Comisión conciliada")) {
            $listM.push("Comisión conciliada");
          }
        }
        if ($listM.includes("Estatus recibo")) {
          $listM.push("Estatus recibo");
        }
        if ($listM.includes("Conducto de Pago")) {
          $listM.push("Conducto de Pago");
        }
        if ($listM.includes("Metodo de Pago")) {
          $listM.push("Metodo de Pago");
        }
        if ($listM.includes("Documento de Pago")) {
          $listM.push("Documento de Pago");
        }

        if ($listM.includes("Importe Pesos")) {
          $listM.push("Importe Pesos");
        }
        if ($listM.includes("Ej. Cobranza")) {
          $listM.push("Ej. Cobranza");
        }
        if ($listM.includes("Pagado por")) {
          $listM.push("Pagado por");
        }
        if ($listM.includes("Fecha Creación")) {
          $listM.push("Fecha Creación");
        }
        if ($listM.includes("Folio de Pago")) {
          $listM.push("Folio de Pago");
        }
        if ($listM.includes("Folio de Liquidación")) {
          $listM.push("Folio de Liquidación");
        }

        if ($listM.includes("Fecha Pago")) {
          $listM.push("Fecha Pago");
        }
        if ($listM.includes("Fecha Liquidación")) {
          $listM.push("Fecha Pago");
        }
        if ($listM.includes("Fecha de conciliación")) {
          $listM.push("Fecha de conciliación");
        }
        if ($listM.includes("Fecha Inicio Póliza/Fianza")) {
          $listM.push("Fecha Inicio Póliza/Fianza");
        }
        if ($listM.includes("Fecha Fin Póliza/Fianza")) {
          $listM.push("Fecha Fin Póliza/Fianza");
        }
        if ($listM.includes("Clave de Agente")) {
          $listM.push("Clave de Agente");
        }
        if ($listM.includes("Referenciador")) {
          $listM.push("Referenciador");
        }
        if ($listM.includes("Sucursal")) {
          $listM.push("Sucursal");
        }
        if ($listM.includes("Responsable")) {
          $listM.push("Responsable");
        }
        if ($listM.includes("Creado por")) {
          $listM.push("Creado por");
        }
        if ($listM.includes("Bítacora")) {
          $listM.push("Bítacora");
        }
        if ($listM.includes("Subgrupo")) {
          $listM.push("Subgrupo");
        }
        if ($listM.includes("Subsubgrupo")) {
          $listM.push("Subsubgrupo");
        }
        if ($listM.includes("Agrupación")) {
          $listM.push("Agrupación");
        }
        if ($listM.includes("Subagrupación")) {
          $listM.push("Subagrupación");
        }
        if ($listM.includes("Subsubagrupación")) {
          $listM.push("Subsubagrupación");
        }
        if ($listM.includes("Clasificación")) {
          $listM.push("Clasificación");
        }
        if ($listM.includes("Línea de Negocio")) {
          $listM.push("Línea de Negocio");
        }
        if ($listM.includes("Promesa Pago")) {
          $listM.push("Promesa Pago");
        }
        if ($listM.includes("Número de Carátula")) {
          $listM.push("Número de Carátula");
        }
        if ($listM.includes("Carátula Contratante")) {
          $listM.push("Carátula Contratante");
        }
        if ($listM.includes("Célula")) {
          $listM.push("Célula");
        }
        if ($listM.includes("Año(Automovil)")) {
          $listM.push("Año(Automovil)");
        }
        if ($listM.includes("Serie(Automovil)")) {
          $listM.push("Serie(Automovil)");
        }
        if ($listM.includes("Contacto(nombre)")) {
          $listM.push("Contacto(nombre)");
        }
        if ($listM.includes("Contacto(telefono)")) {
          $listM.push("Contacto(telefono)");
        }
        if ($listM.includes("Contacto(email)")) {
          $listM.push("Contacto(email)");
        }
        if ($listM.includes("Tipo de Cambio")) {
          $listM.push("Tipo de Cambio");
        }
        if ($listM.includes("Póliza del Recibo con Endoso(s) en Trámite")) {
          $listM.push("Póliza del Recibo con Endoso(s) en Trámite");
        }

        var scolumns = [
          "No.Póliza/Fianza",
          "Tipo Recibo",
          "No.Endoso",
          "Endoso Descripción",
          "Estatus Póliza/Endoso",
          "Grupo",
          "Contratante",
          "Correo electrónico",
          "Teléfono",
          "Alías Aseguradora/Afianzadora",
          "Ramo",
          "Subramo",
          "Identificador",
          "Riesgo/Asegurado",
          "Forma de Pago",
          "Tipo Póliza",
          "Moneda",
          "Serie No.Recibo",
          "Fecha Inicio recibo",
          "Fecha Fin recibo",
          "Vencimiento",
          "Antigüedad",
          "Promesa Pago",
          "Prima Neta",
          "RPF",
          "Derecho",
          "IVA",
          "Prima Total",
          "Comisión",
          "Estatus recibo",
          "Conducto de Pago",
          "Metodo de Pago",
          "Documento de Pago",
          "Fecha Pago",
          "Fecha Liquidación",
          "Folio de Pago",
          "Folio de Liquidación",
          "Fecha de conciliación",
          "Comisión conciliada",
          "Fecha Inicio Póliza/Fianza",
          "Fecha Fin Póliza/Fianza",
          "Clave de Agente",
          "Referenciador",
          "Sucursal",
          "Responsable",
          "Ej. Cobranza",
          "Pagado por",
          "Creado por",
          "Fecha Creación",
          "Importe Pesos",
          "Bitacora",
          "Subgrupo",
          "Subsubgrupo",
          "Agrupación",
          "Subagrupación",
          "Subsubagrupación",
          "Clasificación",
          "Línea de Negocio",
          "Célula",
          "Año(Automovil)",
          "Serie(Automovil)",
          "Contacto(nombre)",
          "Contacto(telefono)",
          "Contacto(email)",
          "Número de Carátula",
          "Carátula Contratante",
          "Tipo de Cambio",
          "Póliza del Recibo con Endoso(s) en Trámite",
        ];
        var foo = [];

        $.grep(scolumns, function (el) {
          if ($.inArray(el, $listM) != -1) {
            foo.push(el);
          }
        });

        // $scope.filtros['cols1']=foo;
        $scope.filtros["cols1"] = $scope.filteredKeys;
        $scope.filtros["addsiniestrop"] = $scope.addSiniestrosBitacora
          ? $scope.addSiniestrosBitacora
          : false;
        $scope.url_go_excel = "service_reporte-cobranzaReport-excel";
        if (param == 1) {
          $http({
            method: "POST",
            url: url.IP + $scope.url_go_excel,
            data: $scope.filtros,
          })
            .then(function success(response) {
              if (response.status == 200) {
                l.stop();
                // Conexión a socket.io
                // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // if($scope.org_name =='ancora'){
                //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                // }else{
                var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // }
                socket.emit("subscribe", response.data);
                // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                // socket.on('result', function(url){
                socket.on(response.data, function (url) {
                  var notificacion = {
                    title: "El reporte solicitado ha sido generado",
                    description: url,
                    model: 26,
                    id_reference: 0,
                  };
                  // dataFactory.post('notificaciones/', notificacion)
                  // .then(function success(response) {
                  SweetAlert.swal({
                    title: "El reporte está listo para descargar",
                    icon: "success",
                    text: "Encuentra la liga de descarga en la sección de notificaciones",
                    timer: 5000,
                  });
                  socket.disconnect();
                  // }).catch(function(err) {
                  socket.disconnect();
                  // })
                });
                toaster.info(
                  "Generando...",
                  "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                );
              } else {
                l.stop();
                toaster.error(
                  "Aviso",
                  "Ha ocurrido un error, intente nuevamente"
                );
              }
            })
            .catch(function (error) {
              l.stop();
              toaster.error(
                "Aviso",
                "Ha ocurrido un error, intente nuevamente"
              );
            });
        }
      }
    };

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        vm.providers = data.data;
      });
    }

    function getSucursales() {
      $http.get(url.IP + "sucursales-to-show-unpag").then(function (data) {
        $scope.sucursales = data;
      });
    }

    function getContractors() {
      ContratanteService.getContratantes().then(function (data) {
        vm.contractors = data;
      });
    }

    function getClaves() {
      providerService.getClaves().then(function (data) {
        vm.claves = data.results;
      });
    }

    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }

    $scope.typeReceipt = function (parType, pol) {
      switch (parType) {
        case 1:
          return "Póliza";
          break;
        case 2:
          return "Endoso";
          break;
        case 3:
          return "Nota de Crédito";
          break;
        case 4:
          return "Bono";
          break;
      }
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "";
      }
    };

    function getReferenciador() {
      vm.vendedores = [];
      $http.get(url.IP + "get-vendors").then(function (user) {
        user.data.forEach(function (u) {
          var obj = {
            name: u.first_name + " " + u.last_name,
            id: u.id,
          };
          vm.vendedores.push(obj);
        });
      });
    }
    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        if (vm.form.group.val) {
          var word_data = vm.form.group.val;
        }
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_group = 'v2/contratantes/grupos-match/';
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  // var obj = {
                  //   label: item.group_name,
                  //   value: item.id
                  // };
                  // $scope.subgroups = item.subgrupos;
                  // $scope.subsubgroups = [];
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    $scope.$watch("vm.form.group.value", function (newValue, oldValue) {
      if (vm.form.group) {
        if (vm.form.group.value) {
          $http
            .get(url.IP + "grupos/" + vm.form.group.value)
            .then(function (item) {
              vm.form.group.data = item.data;

              $scope.subgroups = item.data.subgrupos;
              $scope.subgroups.forEach(function (itm) {
                $scope.subsubgroups = itm.subsubgrupos;
              });
            });
        }
      }
    });

    function matchesGroupinglevel(parWord, parType) {
      $scope.subgrouping = [];
      $scope.subsubgrouping = [];
      $scope.groupunglevels_data = 0;
      vm.form.subgrouping = 0;
      vm.form.subsubgrouping = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.groupinglevel.val) {
        var word_data = vm.form.groupinglevel.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_grouping = "groupinglevel-match/";

          $http
            .post(url.IP + $scope.show_grouping, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groupinglevels = response.data ? response.data : [];
                groupinglevels.forEach(function (item) {
                  $scope.subsubgrouping = [];
                  $scope.subgrouping.forEach(function (itm) {
                    $scope.subsubgrouping = itm.subsubgrupos;
                  });
                  var obj = {
                    label: item.description,
                    value: item.id,
                    url: item.url,
                    subgrupos: item.subgrupos,
                  };
                  source.push(obj);
                });

                $scope.groupinglevels_data = source;
              }
            });
        }
      }
    }
    // --GroupingLevel
    // classification
    function matchesClassification(parWord, parType) {
      $scope.classification_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.classification.val) {
        var word_data = vm.form.classification.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_claass = "classification-match/";

          $http
            .post(url.IP + $scope.show_claass, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var classifica = response.data;
                classifica.forEach(function (item) {
                  var obj = {
                    label: item.classification_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.classification_data = source;
              }
            });
        }
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   var filter_contractor = 'v2/contratantes/contractors-match/';
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }
    function changeSubgroup(subg) {
      vm.form.subgroup = subg;
      vm.subgroup = subg;

      $scope.subsubgroups = subg.subsubgrupos ? subg.subsubgrupos : [];
    }
    function changeSubsubgroup(subg) {
      vm.form.subsubgroup = subg;
      vm.subsubgroup = subg;
    }
    // Nivel de agrupación
    function changeSubgrouping(subgl) {
      vm.form.subgrouping = subgl;
      vm.subgrouping = subgl;
      $scope.subsubgrouping = subgl.subsubgrupos ? subgl.subsubgrupos : [];
    }
    function changeSubsubgrouping(subgl) {
      vm.form.subsubgrouping = subgl;
      vm.subsubgrouping = subgl;
    }

    $scope.actual_page = 1;

    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      } else {
        $http
          .get(url.IP + "ramos-by-provider/" + obj.id)
          .then(function success(response) {
            vm.ramos = response.data;
          });
      }
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      } else {
        vm.subramos = vm.form.ramo.subramo_ramo;
      }
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }

    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }
    function ReportExcelByCtrl(
      $scope,
      filters,
      from,
      $sessionStorage,
      $uibModalInstance,
      addSiniestrosBitacora
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      // $scope.optionsSent = [
      //     {'value': 1, 'label': 'Totales de la Agrupación'},
      //     {'value': 2, 'label': 'Desglose de consulta'},
      // ];
      $scope.infoUser = $sessionStorage.infoUser;
      $scope.optionSent = "1";
      $scope.selectReport = function (option) {
        if (option == "1") {
          $scope.optionsSent = 1;
        } else {
          $scope.optionsSent = 2;
        }
      };
      $scope.downloadReport = function (option) {
        var param = 1;
        if (option == "1") {
          option = 1;
        } else {
          option = 2;
        }
        if (option) {
          // Totales de la Agrupación
          if (option == 1) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            // if ($scope.infoUser) {
            //   if (!$scope.infoUser.superuser && $scope.infoUser.staff ) {
            //     // $scope.url_go_excel = 'v2/recibos/reporte-cobranza-excel';
            //     $scope.url_go_excel = 'service_reporte-v2-cobranzaReport-excel';
            $scope.url_go_excel = "service_reporte-cobranzaReport-excel";
            // $scope.url_go_excel = 'v2/recibos/reporte-cobranza-excel';
            filters.export_type = option;
            filters["addsiniestrop"] = addSiniestrosBitacora
              ? addSiniestrosBitacora
              : false;
            $http({
              method: "POST",
              url: url.IP + $scope.url_go_excel,
              data: filters,
            })
              .then(function success(response) {
                if (response.status == 200) {
                  l.stop();
                  // Conexión a socket.io
                  // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // if($scope.org_name =='ancora'){
                  //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                  // }else{
                  var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // }
                  socket.emit("subscribe", response.data);
                  // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                  // socket.on('result', function(url){
                  socket.on(response.data, function (url) {
                    var notificacion = {
                      title: "El reporte solicitado ha sido generado",
                      description: url,
                      model: 26,
                      id_reference: 0,
                    };
                    dataFactory
                      .post("notificaciones/", notificacion)
                      .then(function success(response) {
                        SweetAlert.swal({
                          title: "El reporte está listo para descargar",
                          icon: "success",
                          text: "Encuentra la liga de descarga en la sección de notificaciones",
                          timer: 5000,
                        });
                        socket.disconnect();
                      })
                      .catch(function (err) {
                        socket.disconnect();
                      });
                  });
                  toaster.info(
                    "Generando...",
                    "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                  );
                } else {
                  l.stop();
                  toaster.error(
                    "Aviso",
                    "Ha ocurrido un error, intente nuevamente"
                  );
                }
              })
              .catch(function (error) {
                l.stop();
                toaster.error(
                  "Aviso",
                  "Ha ocurrido un error, intente nuevamente"
                );
              });
          } else if (option == 2) {
            filters.export_type = option;
            filters.addSiniestros = option;
            var la = Ladda.create(document.querySelector(".ladda-button"));
            la.start();
            $scope.url_go_excel = "service_reporte-cobranzaReport-excel";
            filters["addsiniestrop"] = addSiniestrosBitacora
              ? addSiniestrosBitacora
              : false;
            $http({
              method: "POST",
              url: url.IP + $scope.url_go_excel,
              data: filters,
            })
              .then(function success(response) {
                if (response.status == 200) {
                  la.stop();
                  // Conexión a socket.io
                  // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // if($scope.org_name =='ancora'){
                  //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                  // }else{
                  var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                  // }
                  socket.emit("subscribe", response.data);
                  // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                  // socket.on('result', function(url){
                  socket.on(response.data, function (url) {
                    var notificacion = {
                      title: "El reporte solicitado ha sido generado",
                      description: url,
                      model: 26,
                      id_reference: 0,
                    };
                    dataFactory
                      .post("notificaciones/", notificacion)
                      .then(function success(response) {
                        SweetAlert.swal({
                          title: "El reporte está listo para descargar",
                          icon: "success",
                          text: "Encuentra la liga de descarga en la sección de notificaciones",
                          timer: 5000,
                        });
                        socket.disconnect();
                      })
                      .catch(function (err) {
                        socket.disconnect();
                      });
                  });
                  toaster.info(
                    "Generando...",
                    "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                  );
                } else {
                  la.stop();
                  toaster.error(
                    "Aviso",
                    "Ha ocurrido un error, intente nuevamente"
                  );
                }
              })
              .catch(function (error) {
                la.stop();
                toaster.error(
                  "Aviso",
                  "Ha ocurrido un error, intente nuevamente"
                );
              });
          }
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteCertificadosController", ReporteCertificadosController);

  ReporteCertificadosController.$inject = [
    "dataFactory",
    "datesFactory",
    "$sessionStorage",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$parse",
    "exportFactory",
    "$uibModal",
    "$localStorage",
  ];

  function ReporteCertificadosController(
    dataFactory,
    datesFactory,
    $sessionStorage,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $parse,
    exportFactory,
    $uibModal,
    $localStorage
  ) {
    var vm = this;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    vm.users = [];
    vm.Generar = Generar;
    vm.exportDataExcel = exportDataExcel;
    vm.matchesContractors = matchesContractors;
    vm.insurances = [];
    vm.show_pag_policy = false;
    vm.changeDateFilter = changeDateFilter;
    vm.relations = {
      2: "Conyugue",
      3: "Hijo",
      4: "Otro",
    };

    vm.form = {
      contributory: 0,
      since: datesFactory.convertDate(new Date()),
      until: datesFactory.convertDate(new Date()),
      report_by: {
        id: 1,
        name: "Carátula",
      },
      order: "asc",
      date_filter_by: { id: 0, name: "Carátula" },
      email: "",
    };

    vm.filter_type = [
      {
        id: 1,
        name: "Carátula",
      },
      {
        id: 2,
        name: "No aplicar filtro de fecha",
      },
    ];

    vm.ramos_toselected = [
      {
        ramo_code: 1,
        ramo_name: "Vida",
      },
      {
        ramo_code: 2,
        // ramo_name: 'Gastos Médicos'
        ramo_name: "Accidentes y Enfermedades",
      },
      {
        ramo_code: 3,
        ramo_name: "Daños",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "Activo",
      },
      {
        id: 2,
        name: "Inactivo",
      },
    ];

    vm.status_ren = [
      {
        id: 1,
        name: "Renovadas",
      },
      {
        id: 2,
        name: "No renovadas",
      },
    ];

    vm.table = {
      headers: [
        "No poliza",
        "Contratante",
        "Certificado",
        "Estatus",
        "Ramo",
        "Subramo",
        "Aseguradora",
        "Paquete",
        "Tipo",
        "Nombre del Asegurado",
        "Sexo",
        "Correo",
        "Marca",
        "Modelo",
        "Año",
        "Version",
        "Serie",
        "Motor",
        "Conductor",
        "Vigencia",
        "Fecha de antiguedad",
        "RFC",
        "IVA",
        "Derechos",
        "Prima Neta",
        "Prima Total",
      ],
    };
    $(".js-example-basic-multiple").select2();
    function changeDateFilter() {
      if (vm.form.date_filter_by.id == 2) {
        SweetAlert.swal(
          "Advertencia",
          MESSAGES.WARNING.DATEFILTERREMOVED,
          "warning"
        );
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   var filter_contractor = 'v2/contratantes/contractors-match/';
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    function testPagination(parConfig) {
      var config_ = parConfig;
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;
      if (config_.next) {
        $scope.page_url = config_.next;
      } else {
        $scope.page_url = config_.previous;
      }

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        if (parPage == $scope.actual_page) {
          return;
        }
        $scope.actual_page = parPage;
        var page_index = $scope.page_url.indexOf("&page=");
        if (page_index > 0) {
          var newStringArray = $scope.page_url.split("");
          newStringArray[page_index + 6] = parPage;
          var url = newStringArray.join("");
          getUrl(url);
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }

    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }

    function getProviders() {
      providerService.getReadListProviders().then(function (data) {
        vm.providers = data;
      });
    }

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          subramo_code: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }

    function getReferenciador() {
      vm.vendedores = [];
      $http.get(url.IP + "get-vendors", vm.form).then(function (user) {
        user.data.forEach(function (u) {
          var obj = {
            name: u.first_name + " " + u.last_name,
            id: u.id,
          };
          vm.vendedores.push(obj);
        });
      });
    }

    function transform_insurances(insurances) {
      var generic_insurances = [];
      insurances.forEach(function (insurance) {
        if (
          insurance.accidents_policy &&
          insurance.accidents_policy.length > 0
        ) {
          var titular = {
            poliza_number: insurance.poliza_number,
            contratante: insurance.contractor,
            certificate_number: insurance.certificate_number,
            certificado_inciso_activo: insurance.certificado_inciso_activo,
            ramo: insurance.ramo,
            subramo: insurance.subramo,
            aseguradora: insurance.aseguradora,
            paquete: insurance.paquete,
            tipo: "Titular",
            nombre_asegurado: insurance.accidents_policy[0].personal.full_name,
            sexo:
              insurance.accidents_policy[0].personal.sex == "F"
                ? "Femenino"
                : "Masculino",
            email: insurance.accidents_policy[0].personal.email,
            marca: "",
            modelo: "",
            anio: "",
            version: "",
            serie: "",
            motor: "",
            rpf: insurance.accidents_policy[0].personal.rpf,
            derecho: insurance.accidents_policy[0].personal.derecho,
            iva: insurance.accidents_policy[0].personal.iva,
            p_neta: insurance.accidents_policy[0].personal.p_neta,
            p_total: insurance.accidents_policy[0].personal.p_total,
            conductor: "",
            vigencia:
              datesFactory.convertDate(insurance.start_of_validity) +
              " - " +
              datesFactory.convertDate(insurance.end_of_validity),
            fecha_antiguedad: insurance.accidents_policy[0].personal
              .fecha_antiguedad
              ? datesFactory.convertDate(
                  insurance.accidents_policy[0].personal.fecha_antiguedad
                )
              : "",
          };
          generic_insurances.push(titular);
          insurance.accidents_policy[0].relationship_accident.forEach(function (
            relationship
          ) {
            var dependiente = {
              poliza_number: insurance.poliza_number,
              contratante: insurance.contractor,
              certificate_number: relationship.certificate,
              certificado_inciso_activo: relationship.is_active,
              ramo: insurance.ramo,
              subramo: insurance.subramo,
              aseguradora: insurance.aseguradora,
              paquete: insurance.paquete,
              tipo: vm.relations[relationship.relationship],
              nombre_asegurado: relationship.full_name,
              sexo: relationship.sex == "F" ? "Femenino" : "Masculino",
              email: "",
              marca: "",
              modelo: "",
              anio: "",
              version: "",
              serie: "",
              motor: "",
              rpf: relationship.rpf,
              derecho: relationship.derecho,
              iva: relationship.iva,
              p_neta: relationship.p_neta,
              p_total: relationship.p_total,
              conductor: "",
              vigencia:
                datesFactory.convertDate(insurance.start_of_validity) +
                " - " +
                datesFactory.convertDate(insurance.end_of_validity),
              fecha_antiguedad: relationship.antiguedad
                ? datesFactory.convertDate(relationship.antiguedad)
                : "",
            };
            generic_insurances.push(dependiente);
          });
        } else if (insurance.ramo == "Accidentes y Enfermedades") {
          var titular = {
            poliza_number: insurance.poliza_number,
            contratante: insurance.contractor,
            certificate_number: insurance.certificate_number,
            certificado_inciso_activo: insurance.certificado_inciso_activo,
            ramo: insurance.ramo,
            subramo: insurance.subramo,
            aseguradora: insurance.aseguradora,
            paquete: insurance.paquete,
            tipo: "Certificado",
            nombre_asegurado: "Sin Titular",
            sexo: "",
            email: "",
            marca: "",
            modelo: "",
            anio: "",
            version: "",
            serie: "",
            motor: "",
            rpf: 0,
            derecho: 0,
            iva: 0,
            p_neta: 0,
            p_total: 0,
            conductor: "",
            vigencia:
              datesFactory.convertDate(insurance.start_of_validity) +
              " - " +
              datesFactory.convertDate(insurance.end_of_validity),
            fecha_antiguedad: "",
          };
          generic_insurances.push(titular);
        }
        if (insurance.life_policy && insurance.life_policy.length > 0) {
          var titular = {
            poliza_number: insurance.poliza_number,
            contratante: insurance.contractor,
            certificate_number: insurance.certificate_number,
            certificado_inciso_activo: insurance.certificado_inciso_activo,
            ramo: insurance.ramo,
            subramo: insurance.subramo,
            aseguradora: insurance.aseguradora,
            paquete: insurance.paquete,
            tipo: "Titular",
            nombre_asegurado: insurance.life_policy[0].personal.full_name,
            sexo:
              insurance.life_policy[0].personal.sex == "F"
                ? "Femenino"
                : "Masculino",
            email: insurance.life_policy[0].personal.email,
            marca: "",
            modelo: "",
            anio: "",
            version: "",
            serie: "",
            rpf: insurance.rpf,
            derecho: insurance.derecho,
            iva: insurance.iva,
            p_neta: insurance.p_neta,
            p_total: insurance.p_total,
            motor: "",
            conductor: "",
            vigencia:
              datesFactory.convertDate(insurance.start_of_validity) +
              " - " +
              datesFactory.convertDate(insurance.end_of_validity),
            fecha_antiguedad: insurance.life_policy[0].personal.antiguedad
              ? datesFactory.convertDate(
                  insurance.life_policy[0].personal.antiguedad
                )
              : "",
          };
          generic_insurances.push(titular);
        } else if (insurance.ramo == "Vida") {
          var titular = {
            poliza_number: insurance.poliza_number,
            contratante: insurance.contractor,
            certificate_number: insurance.certificate_number,
            certificado_inciso_activo: insurance.certificado_inciso_activo,
            ramo: insurance.ramo,
            subramo: insurance.subramo,
            aseguradora: insurance.aseguradora,
            paquete: insurance.paquete,
            tipo: "Certificado",
            nombre_asegurado: "Sin Titular",
            sexo: "",
            email: "",
            marca: "",
            modelo: "",
            anio: "",
            version: "",
            serie: "",
            motor: "",
            rpf: 0,
            derecho: 0,
            iva: 0,
            p_neta: 0,
            p_total: 0,
            conductor: "",
            vigencia:
              datesFactory.convertDate(insurance.start_of_validity) +
              " - " +
              datesFactory.convertDate(insurance.end_of_validity),
            fecha_antiguedad: "",
          };
          generic_insurances.push(titular);
        }
        if (
          insurance.automobiles_policy &&
          insurance.automobiles_policy.length > 0
        ) {
          var auto = {
            poliza_number: insurance.poliza_number,
            contratante: insurance.contractor,
            certificate_number: insurance.certificate_number,
            certificado_inciso_activo: insurance.certificado_inciso_activo,
            ramo: insurance.ramo,
            subramo: insurance.subramo,
            aseguradora: insurance.aseguradora,
            paquete: insurance.paquete,
            tipo: "Automóviles",
            nombre_asegurado: "",
            sexo: "",
            email: "",
            rpf: insurance.rpf,
            derecho: insurance.derecho,
            iva: insurance.iva,
            p_neta: insurance.p_neta,
            p_total: insurance.p_total,
            marca: insurance.automobiles_policy[0].brand,
            modelo: insurance.automobiles_policy[0].model,
            anio: insurance.automobiles_policy[0].year,
            version: insurance.automobiles_policy[0].version,
            serie: insurance.automobiles_policy[0].serial,
            motor: insurance.automobiles_policy[0].engine,
            conductor: insurance.automobiles_policy[0].driver,
            vigencia:
              datesFactory.convertDate(insurance.start_of_validity) +
              " - " +
              datesFactory.convertDate(insurance.end_of_validity),
            fecha_antiguedad: "",
          };
          generic_insurances.push(auto);
        } else if (insurance.ramo == "Daños") {
          var autsos = {
            poliza_number: insurance.poliza_number,
            contratante: insurance.contractor,
            certificate_number: insurance.certificate_number,
            certificado_inciso_activo: insurance.certificado_inciso_activo,
            ramo: insurance.ramo,
            subramo: insurance.subramo,
            aseguradora: insurance.aseguradora,
            paquete: insurance.paquete,
            tipo: "Certificado",
            nombre_asegurado: "Sin Titular",
            sexo: "",
            email: "",
            marca: "",
            modelo: "",
            anio: "",
            version: "",
            serie: "",
            motor: "",
            rpf: 0,
            derecho: 0,
            iva: 0,
            p_neta: 0,
            p_total: 0,
            conductor: "",
            vigencia:
              datesFactory.convertDate(insurance.start_of_validity) +
              " - " +
              datesFactory.convertDate(insurance.end_of_validity),
            fecha_antiguedad: "",
          };
          generic_insurances.push(autsos);
        }
      });
      vm.insurances = generic_insurances;
    }

    function Generar() {
      vm.insurances = [];
      $scope.actual_page = 1;
      var payload = angular.copy(vm.form);
      if (payload.select_provider) {
        var aux_provider = [];
        payload.select_provider.forEach(function (provider) {
          aux_provider.push(provider.id);
        });
        payload.select_provider = aux_provider;
      }
      if (payload.select_user) {
        var aux_user = [];
        payload.select_user.forEach(function (user) {
          aux_user.push(user.id);
        });
        payload.select_user = aux_user;
      }
      if (payload.select_sramo) {
        var aux_sramo = [];
        payload.select_sramo.forEach(function (sramo) {
          aux_sramo.push(sramo.subramo_code);
        });
        payload.select_sramo = aux_sramo;
      }
      if (payload.select_ramo) {
        var aux_ramo = [];
        payload.select_ramo.forEach(function (ramo) {
          aux_ramo.push(ramo.ramo_code);
        });
        payload.select_ramo = aux_ramo;
      }

      payload.status_cert = payload.status_cert ? payload.status_cert.id : 4;
      payload.status_ren_cert = payload.status_ren_cert
        ? payload.status_ren_cert.id
        : 0;
      payload.vendedor = payload.vendedor ? payload.vendedor.id : 0;
      payload.celula = payload.celula ? payload.celula.id : 0;
      payload.date_filter_by = payload.date_filter_by
        ? payload.date_filter_by.id
        : 0;
      payload.contratante = payload.contratante ? payload.contratante.value : 0;
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          payload.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.celula) {
        if (vm.form.celula.id) {
          payload.celula = vm.form.celula.id;
        } else {
          payload.celula = 0;
        }
      } else {
        payload.celula = 0;
      }
      $http({
        url: url.IP + "certificados-reporte",
        method: "GET",
        params: payload,
      }).then(function (data) {
        if (data["data"]["count"] == 0) {
          toaster.warning("No se encontraron registros");
          return;
        }
        vm.insurances = data["data"]["results"];
        transform_insurances(vm.insurances);
        testPagination(data["data"]);
        vm.show_pag_policy = true;
      });

      $localStorage.saved_filters_reporte_certificados = angular.copy(payload);
      $localStorage.saved_filters_reporte_certificados["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_reporte_certificados["num_poliza"] =
        vm.form.num_poliza;
      $localStorage.saved_filters_reporte_certificados["date_filter_by"] =
        vm.form.date_filter_by;
      $localStorage.saved_filters_reporte_certificados["celula"] =
        vm.form.celula;
      $localStorage.saved_filters_reporte_certificados["vendedor"] =
        vm.form.vendedor;
      $localStorage.saved_filters_reporte_certificados["num_certificado"] =
        vm.form.num_certificado;
      $localStorage.saved_filters_reporte_certificados["status_cert"] =
        vm.form.status_cert;
      $localStorage.saved_filters_reporte_certificados["status_ren_cert"] =
        vm.form.status_ren_cert;
    }

    function exportDataExcel() {
      var payload = angular.copy(vm.form);
      if (payload.select_provider) {
        var aux_provider = [];
        payload.select_provider.forEach(function (provider) {
          aux_provider.push(provider.id);
        });
        payload.select_provider = aux_provider;
      }
      if (payload.select_user) {
        var aux_user = [];
        payload.select_user.forEach(function (user) {
          aux_user.push(user.id);
        });
        payload.select_user = aux_user;
      }
      if (payload.select_sramo) {
        var aux_sramo = [];
        payload.select_sramo.forEach(function (sramo) {
          aux_sramo.push(sramo.subramo_code);
        });
        payload.select_sramo = aux_sramo;
      }
      if (payload.select_ramo) {
        var aux_ramo = [];
        payload.select_ramo.forEach(function (ramo) {
          aux_ramo.push(ramo.ramo_code);
        });
        payload.select_ramo = aux_ramo;
      }

      payload.status_cert = payload.status_cert ? payload.status_cert.id : 4;
      payload.status_ren_cert = payload.status_ren_cert
        ? payload.status_ren_cert.id
        : 0;
      payload.vendedor = payload.vendedor ? payload.vendedor.id : 0;
      payload.celula = payload.celula ? payload.celula.id : 0;
      payload.date_filter_by = payload.date_filter_by
        ? payload.date_filter_by.id
        : 0;
      payload.email = vm.form.email ? vm.form.email : null;
      payload.contratante = vm.form.contratante ? vm.form.contratante.value : 0;
      if (vm.form.contratante) {
        if (vm.form.contratante.val == "") {
          payload.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
      }
      if (vm.form.celula) {
        if (vm.form.celula.id) {
          payload.celula = vm.form.celula.id;
        } else {
          payload.celula = 0;
        }
      } else {
        payload.celula = 0;
      }

      var lx = Ladda.create(document.querySelector(".ladda-button_excel"));
      lx.start();
      $http({
        url: url.IP + "reporte-certificados-excel",
        method: "GET",
        params: payload,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      }).then(function (data) {
        if (data.status == 200) {
          lx.stop();
          SweetAlert.swal(
            "Aviso",
            "El archivo se está generando, en unos momentos lo recibirá en su bandeja de correo electrónico",
            "success"
          );
        } else {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDOWNLOADREP, "error");
          lx.stop();
        }
      });
    }

    function getUrl(url) {
      $http.get(url).then(function (data) {
        vm.insurances = data["data"]["results"];
        transform_insurances(vm.insurances);
      });
    }

    activate();
    // Start functionality
    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
        }
      });
      $http.get(url.IP + "usuarios/").then(function (user) {
        user.data.results.forEach(function (usr) {
          if (usr.user_info.is_active) {
            vm.users.push(usr);
          }
        });
      });
      getProviders();
      getSubramos();
      getReferenciador();
      getCelulasContractor();
      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });
      // Radio prioridad
      $scope.priority_task = "0";
      $scope.priority_task = 0;
      // vm.form.todos = true;
    }

    vm.form.contratante =
      $localStorage.saved_filters_reporte_certificados &&
      $localStorage.saved_filters_reporte_certificados["contratante"]
        ? $localStorage.saved_filters_reporte_certificados["contratante"]
        : "";
    vm.form.num_poliza =
      $localStorage.saved_filters_reporte_certificados &&
      $localStorage.saved_filters_reporte_certificados["num_poliza"]
        ? $localStorage.saved_filters_reporte_certificados["num_poliza"]
        : "";
    vm.form.date_filter_by =
      $localStorage.saved_filters_reporte_certificados &&
      $localStorage.saved_filters_reporte_certificados["date_filter_by"]
        ? $localStorage.saved_filters_reporte_certificados["date_filter_by"]
        : 0;
    vm.form.celula =
      $localStorage.saved_filters_reporte_certificados &&
      $localStorage.saved_filters_reporte_certificados["celula"]
        ? $localStorage.saved_filters_reporte_certificados["celula"]
        : 0;
    vm.form.vendedor =
      $localStorage.saved_filters_reporte_certificados &&
      $localStorage.saved_filters_reporte_certificados["vendedor"]
        ? $localStorage.saved_filters_reporte_certificados["vendedor"]
        : 0;
    vm.form.num_certificado =
      $localStorage.saved_filters_reporte_certificados &&
      $localStorage.saved_filters_reporte_certificados["num_certificado"]
        ? $localStorage.saved_filters_reporte_certificados["num_certificado"]
        : "";
    vm.form.status_cert =
      $localStorage.saved_filters_reporte_certificados &&
      $localStorage.saved_filters_reporte_certificados["status_cert"]
        ? $localStorage.saved_filters_reporte_certificados["status_cert"]
        : 0;
    vm.form.status_ren_cert =
      $localStorage.saved_filters_reporte_certificados &&
      $localStorage.saved_filters_reporte_certificados["status_ren_cert"]
        ? $localStorage.saved_filters_reporte_certificados["status_ren_cert"]
        : 0;
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteAuditoriaController", ReporteAuditoriaController);

  ReporteAuditoriaController.$inject = [
    "dataFactory",
    "$window",
    "$uibModal",
    "$sce",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$filter",
    "$parse",
    "exportFactory",
    "ContratanteService",
    "$sessionStorage",
    "$localStorage",
  ];

  function ReporteAuditoriaController(
    dataFactory,
    $window,
    $uibModal,
    $sce,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $filter,
    $parse,
    exportFactory,
    ContratanteService,
    $sessionStorage,
    $localStorage
  ) {
    var vm = this;
    var savedFiltersCobranza = {};

    $(".js-example-basic-multiple").select2();
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy HH:mm:ss";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;
    $scope.org_name = usr.urlname;

    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
      {
        id: 7,
        name: "Semanal",
      },
      {
        id: 14,
        name: "Catorcenal",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por Iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
    ];

    vm.option_policy = [
      {
        id: 1,
        name: "Inicio de vigencia",
      },
      {
        id: 2,
        name: "Vencimiento",
      },
      {
        id: 3,
        name: "Fecha de pago",
      },
      {
        id: 4,
        name: "Fecha de liquidación",
      },
      {
        id: 5,
        name: "Fecha de conciliación",
      },
      {
        id: 6,
        name: "Reporte de operación",
      },
      {
        id: 7,
        name: "Fecha compromiso de pago",
      },
    ];

    vm.Generar = Generar;
    vm.matchesGroup = matchesGroup;
    $(".js-example-basic-multiple").select2();

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    vm.form = {
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      group: 0,
      identifier: "",
    };

    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }
    $scope.$watch("vm.word", function (newValue, oldValue) {
      if (vm.word) {
        if (vm.word.id) {
          vm.only_caratula_poliza = parseInt(vm.word.id);
        } else {
          vm.only_caratula_poliza = 0;
        }
      }
    });
    activate();
    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };
    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };

    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };
    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        //var newdate = convertDate(new Date());
        //vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");

      return date;
    }

    function activate() {
      $(".js-example-basic-multiple").select2();
      getProviders();
      vm.form.since = convertDate(new Date());
      var endingDate = convertDate(new Date());
      vm.form.until = endingDate;
      /* Información de usuario */
      $scope.infoUser = $sessionStorage.infoUser;
      vm.form.identifier =
        $localStorage.saved_filters_reporte_poliza &&
        $localStorage.saved_filters_reporte_poliza["identifier"]
          ? $localStorage.saved_filters_reporte_poliza["identifier"]
          : "";
      vm.form.group =
        $localStorage.saved_filters_reporte_poliza &&
        $localStorage.saved_filters_reporte_poliza["group"]
          ? $localStorage.saved_filters_reporte_poliza["group"]
          : 0;
      $scope.ot_rep =
        $localStorage.saved_filters_reporte_poliza &&
        $localStorage.saved_filters_reporte_poliza["ot_rep"]
          ? $localStorage.saved_filters_reporte_poliza["ot_rep"]
          : 1;
      vm.word =
        $localStorage.saved_filters_reporte_poliza &&
        $localStorage.saved_filters_reporte_poliza["caratula"]
          ? $localStorage.saved_filters_reporte_poliza["caratula"]
          : "";
    }

    function saveLocalstorange() {
      savedFiltersCobranza["since"] = vm.form.since ? vm.form.since : "";
      savedFiltersCobranza["until"] = vm.form.until ? vm.form.until : "";
    }

    function getPermisions() {
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            vm.acceso_reportes = perm;
            vm.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  vm.acceso_rep_fia = true;
                } else {
                  vm.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  vm.acceso_rep_sin = true;
                } else {
                  vm.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  vm.acceso_rep_end = true;
                } else {
                  vm.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  vm.acceso_rep_pol = true;
                } else {
                  vm.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  vm.acceso_rep_ren = true;
                } else {
                  vm.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  vm.acceso_rep_cob = true;
                } else {
                  vm.acceso_rep_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Comisiones") {
            vm.coms = perm;
            vm.coms.permissions.forEach(function (acc) {
              if (acc.permission_name == "Comisiones") {
                if (acc.checked == true) {
                  vm.permiso_comisiones = true;
                } else {
                  vm.permiso_comisiones = false;
                }
              }
            });
          }
        });
      }
    }
    function Generar(order, asc, parPage) {
      var l = Ladda.create(document.querySelector(".ladda-buttonC"));
      l.start();
      $scope.order = order;
      $scope.asc = asc;
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));

      if (antiguedad < 0) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }

      $scope.total = 0.0;
      $scope.prima_neta = 0.0;
      $scope.comision = 0.0;

      var params = {
        grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
        ot: vm.form.ot_rep,
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        providers: vm.providers_selected ? vm.providers_selected : [],
        ramos: vm.ramos_selected ? vm.ramos_selected : [],
        subramos: vm.subramos_selected ? vm.subramos_selected : [],
        identifier: vm.form.identifier ? vm.form.identifier : "",
      };
      if (vm.form.group) {
        if (vm.form.group.val == "") {
          params.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
      }
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      $scope.filtros = params;
      console.log("filtrrr", $scope.filtros);
      $scope.url_go = "reporte-auditoria-rep/";
      $http({
        method: "POST",
        url: url.IP + $scope.url_go,
        data: $scope.filtros,
      }).then(
        function success(response) {
          $scope.auditoria = response.data.results;
          l.stop();
          $scope.sumas = response.data.sumas;
          $scope.filtros.count = response.data.count;
          $scope.count_auditoria = angular.copy($scope.auditoria);
          $scope.auditoria_config = {
            count: response.data.count,
            previous: url.IP + $scope.url_go,
            next: url.IP + $scope.url_go,
          };
          vm.show_pag_auditoria = true;
          testPagination("auditoria", "auditoria_config");
          $scope.showButtonExcel = true;
          $scope.showSums = true;
        },
        function error(err) {
          console.log("error", err);
          l.stop();
        }
      );
      savedFiltersCobranza = angular.copy(params);
    }
    function goToInfo(insurance) {
      if (vm.acceso_ver_pol) {
        if (insurance.poliza) {
          if (insurance.poliza.document_type == 1) {
            $state.go("polizas.info", { polizaId: insurance.poliza.id });
          } else if (insurance.poliza.document_type == 3) {
            $state.go("colectividades.info", { polizaId: insurance.poliza.id });
          } else if (insurance.poliza.document_type == 12) {
            $state.go("flotillas.info", {
              polizaId: insurance.poliza.parent.id,
            });
          } else if (insurance.poliza.document_type == 11) {
            $state.go("flotillas.info", {
              polizaId: insurance.poliza.parent.id,
            });
          }
        } else {
          $state.go("fianzas.info", { polizaId: insurance.fianza.id });
        }
      }
    }

    $scope.exportDataExcel = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      var scolumns = [
        "REGISTRO",
        "TIPO DE DATO",
        "NUMERO DE POLIZA",
        "ENDOSO",
        "CONTRATANTE",
        "CORREO",
        "TELEFONO",
        "ASEGURADORA",
        "CLAVE",
        "RAMO",
        "SUBRAMO",
        "TIPO",
        "BIEN ASEGURADO",
        "ESTATUS",
        "INICIO VIGENCIA (POL/END)",
        "FIN VIGENCIA (POL/END)",
        "FORMA DE PAGO",
        "REFERENCIADOR",
        "MONEDA",
        "CONDUCTO DE PAGO",
        "PRIMA NETA",
        "DESCUENTO",
        "RPF",
        "DERECHO",
        "IVA",
        "PRIMA TOTAL",
        "COMISION $",
        "COMISION %",
        "ID POLIZA",
        "SERIE RECIBO",
        "ESTATUS RECIBO",
        "Fecha Inicio recibo",
        "Fecha Fin recibo",
        "Vencimiento",
        "Prima Neta",
        "RPF",
        "Derecho",
        "IVA",
        "Prima Total",
        "COMISION",
        "Fecha Pago",
        "Fecha de conciliación",
        "Fecha Liquidación",
        "Folio de Pago",
        "Folio de Liquidación",
        "Comisión conciliada",
        "Fecha Creación",
        "Creado por",
        "Pagado por",
        "Liquidado por",
        "Bitácora",
        "Adjuntos",
        "DESCRIPCION/OBSERVACIONES",
        "POLIZA ANTERIOR",
        "POLIZA SIGUIENTE",
        "BALANCE PRIMA NETA",
        "BALANCE PRIMA TOTAL",
        "TOTAL PAGADO",
        "TOTAL PENDIENTE",
        "TOTAL CANCELADO",
        "OTs EN TRAMITE",
        "RECIBO VENCIDO",
        "BALANCE COMISION POLIZAvsRECIBOS",
        "TIEMPO INI. VIG./CREACION",
        "SAAM TIEMPO PAGO/APLICACIÓN",
        "TIEMPO  LIQUIDACION/APLICACIÓN",
        "ID RECIBO",
      ];
      $scope.filtros["cols1"] = scolumns;
      $scope.url_go_excel = "service_reporte-auditoriareporte-excel";
      $http({
        method: "POST",
        url: url.IP + $scope.url_go_excel,
        data: $scope.filtros,
      })
        .then(function success(response) {
          if (response.status == 200) {
            l.stop();
            // Conexión a socket.io
            // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
            // if($scope.org_name =='ancora'){
            //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
            // }else{
            var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
            // }
            socket.emit("subscribe", response.data);
            // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
            // socket.on('result', function(url){
            socket.on(response.data, function (url) {
              socket.disconnect();
              SweetAlert.swal({
                title: "El reporte está listo para descargar",
                icon: "success",
                text: "Encuentra la liga de descarga en la sección de notificaciones",
                timer: 5000,
              });
            });
            toaster.info(
              "Generando...",
              "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
            );
          } else {
            l.stop();
            toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
          }
        })
        .catch(function (error) {
          l.stop();
          toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
        });
    };
    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        console.log(data);
        vm.providers = data.data;
      });
    }
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 6,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }

    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      vm.form.subgroup = 0;
      vm.form.subsubgroup = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        if (vm.form.group.val) {
          var word_data = vm.form.group.val;
        }
      }
      console.log("dd", word_data, parWord, parType);
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  // var obj = {
                  //   label: item.group_name,
                  //   value: item.id
                  // };
                  // $scope.subgroups = item.subgrupos;
                  // $scope.subsubgroups = [];
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    $scope.$watch("vm.form.group.value", function (newValue, oldValue) {
      if (vm.form.group) {
        if (vm.form.group.value) {
          $http
            .get(url.IP + "grupos/" + vm.form.group.value)
            .then(function (item) {
              vm.form.group.data = item.data;

              $scope.subgroups = item.data.subgrupos;
              $scope.subgroups.forEach(function (itm) {
                $scope.subsubgroups = itm.subsubgrupos;
              });
            });
        }
      }
    });
    vm.form.ot_rep = 1;
    $scope.ot_rep = 1;
    $scope.valueRadioRep = function (val) {
      vm.form.ot_rep = val;
      toaster.info("De clic en Consultar");
    };

    $scope.actual_page = 1;
    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        vm.Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteAseguradosController", ReporteAseguradosController);

  ReporteAseguradosController.$inject = [
    "providerService",
    "toaster",
    "datesFactory",
    "dataFactory",
    "MESSAGES",
    "$http",
    "url",
    "$scope",
    "$parse",
    "$sessionStorage",
    "$uibModal",
    "SweetAlert",
    "$localStorage",
  ];

  function ReporteAseguradosController(
    providerService,
    toaster,
    datesFactory,
    dataFactory,
    MESSAGES,
    $http,
    url,
    $scope,
    $parse,
    $sessionStorage,
    $uibModal,
    SweetAlert,
    $localStorage
  ) {
    var vm = this;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.orgName = usr.orgname;
    vm.users = [];
    if ((usr.org = "ancora")) {
      vm.estatus = [
        { value: 10, name: "POR INICIAR" },
        { value: 11, name: "CANCELADA" },
        { value: 12, name: "RENOVADA" },
        { value: 13, name: "VENCIDA - EN PROCESO DE RENOVACIÓN" },
        { value: 14, name: "VIGENTE" },
        { value: 15, name: "NO RENOVADA" },
        // {value: 16, name: 'SINIESTRADA'},
      ];
    } else {
      vm.estatus = [
        { value: 10, name: "POR INICIAR" },
        { value: 11, name: "CANCELADA" },
        { value: 12, name: "RENOVADA" },
        { value: 13, name: "VENCIDA" },
        { value: 14, name: "VIGENTE" },
        { value: 15, name: "NO RENOVADA" },
        // {value: 16, name: 'SINIESTRADA'},
      ];
    }
    vm.form = {
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      subramo: "2",
      aseguradoras: [],
    };

    $(".js-example-basic-multiple").select2();

    activate();
    // Start functionality
    function activate() {
      getProviders();
      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });
      // Radio
      $scope.subramoSelected = "2";
      $scope.subramoSelected = 2;
      vm.form.todos = true;
    }
    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        vm.providers = data.data;
      });
    }
    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        default:
          return "Pendiente";
      }
    };
    $scope.payment = function (value) {
      switch (value) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 4:
          return "Cuatrimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        case 24:
          return "Quincenal";
          break;
        case 7:
          return "Semanal";
          break;
        case 14:
          return "Catorcenal";
          break;
        default:
          return "No especificada";
      }
    };
    // Get asegurados API
    $scope.getAsegurados = function (page, otro) {
      $scope.asegurados = [];
      $scope.grupos_result = [];
      $scope.filters = {
        estatus: vm.estadoSelected ? vm.estadoSelected : [],
        aseguradoras: vm.aseguradoraSelected ? vm.aseguradoraSelected : [],
        since: vm.form.since ? vm.form.since : "",
        until: vm.form.until ? vm.form.until : "",
        subramo: $scope.subramoSelected ? $scope.subramoSelected : 0,
        page: page ? page : 1,
      };
      $scope.filters.since = $scope.filters.since + " " + "00:00:00";
      $scope.filters.until = $scope.filters.until + " " + "23:59:59";
      $http({
        method: "POST",
        url: url.IP + "reporte-asegurados/",
        data: $scope.filters,
      }).then(function success(response) {
        $scope.asegurados = response.data.results;
        if (response.data.count == 0) {
          toaster.warning("No se encontraron resultados.");
        }
        $scope.asegs_config = {
          count: response.data.count,
          previous: url.IP + "reporte-asegurados/",
          next: url.IP + "reporte-asegurados/",
        };
        vm.show_pag_asegurados = true;
        $scope.obtenerPaginacion(response.data, page ? page : 1);
      });

      $localStorage.saved_filters_reporte_asegurados = angular.copy(
        $scope.filters
      );
      $localStorage.saved_filters_reporte_asegurados["report_by"] =
        vm.form.report_by;
      $localStorage.saved_filters_reporte_asegurados["subramoSelected"] =
        $scope.subramoSelected;
      $localStorage.saved_filters_reporte_asegurados["archived"] =
        vm.form.archived;
      $localStorage.saved_filters_reporte_asegurados["closed"] = vm.form.closed;
      $localStorage.saved_filters_reporte_asegurados["opened"] = vm.form.opened;
      $localStorage.saved_filters_reporte_asegurados["todos"] = vm.form.todos;
    };
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      $localStorage.saved_filters_reporte_asegurados["page"] = pagina;
      $scope.getAsegurados(pagina, 1);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $localStorage.saved_filters_reporte_asegurados["page"] =
          $scope.paginacion["paginaActual"] - 1;
        $scope.getAsegurados($scope.paginacion["paginaActual"] - 1, 1);
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $localStorage.saved_filters_reporte_asegurados["page"] =
          $scope.paginacion["paginaActual"] + 1;
        $scope.getAsegurados($scope.paginacion["paginaActual"] + 1, 1);
      }
    };
    $scope.selectSubramo = function (parValue) {
      if (parValue == "1") {
        $scope.subramoSelected = 1; //vida
      } else if (parValue == "2") {
        $scope.subramoSelected = 2; //accidentes
      } else if (parValue == "9") {
        $scope.subramoSelected = 9; //autos
      } else if (parValue == "0") {
        $scope.subramoSelected = 0; //daños
      }
    };
    // Change Creada por
    $scope.selectStatus = function (x, y) {
      vm.estadoSelected = [];
      x.forEach(function (r) {
        vm.estadoSelected.push(parseInt(r.value));
      });
    };
    // Change Cerrada por
    $scope.selectProv = function (x, y) {
      vm.aseguradoraSelected = [];
      x.forEach(function (r) {
        vm.aseguradoraSelected.push(parseInt(r.id));
      });
    };
    // Download report to excel
    $scope.export = function (param) {
      var lx = Ladda.create(document.querySelector(".ladda-button_excel"));
      lx.start();
      $scope.filters.export_type = 2;
      $http({
        method: "POST",
        // url: url.IP +'reporte-tasks-excel' ,
        url: url.IP + "service_reporte-aseguradosReport-excel",
        data: $scope.filters,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          lx.stop();
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte Asegurados.xls");
        } else {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDOWNLOADREP, "error");
          lx.stop();
        }
      });
    };
    // Format Dates DD/MM/YYYY
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    // -----------PAGINACIÓN
    function PaginationResults(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        $scope.getAsegurados(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteAdjuntosController", ReporteAdjuntosController);

  ReporteAdjuntosController.$inject = [
    "datesFactory",
    "MESSAGES",
    "$http",
    "url",
    "$scope",
    "$parse",
    "$sessionStorage",
    "$uibModal",
    "SweetAlert",
    "$localStorage",
  ];

  function ReporteAdjuntosController(
    datesFactory,
    MESSAGES,
    $http,
    url,
    $scope,
    $parse,
    $sessionStorage,
    $uibModal,
    SweetAlert,
    $localStorage
  ) {
    var vm = this;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    vm.users = [];
    vm.group_by = [
      {
        id: 1,
        name: "Usuario",
      },
    ];
    vm.form = {
      since: convertDate(new Date()),
      until: convertDate(new Date()),
    };
    vm.group = {};
    activate();
    $(".js-example-basic-multiple").select2();
    // Start functionality
    function activate() {}
    // Get logs API
    $scope.getAdjuntos = function (page, otro) {
      $scope.adjuntos = [];
      $scope.filters = {
        polizas: vm.form.polizas ? vm.form.polizas : false,
        endosos: vm.form.endosos ? vm.form.endosos : false,
        siniestros: vm.form.siniestros ? vm.form.siniestros : false,
        fianzas: vm.form.fianzas ? vm.form.fianzas : false,
        contratantes: vm.form.contratantes ? vm.form.contratantes : false,
        since: vm.form.since ? vm.form.since : "",
        until: vm.form.until ? vm.form.until : "",
        page: page ? page : 1,
        grupo: vm.group ? vm.group.value : 0,
      };
      $scope.filters.since = $scope.filters.since + " " + "00:00:00";
      $scope.filters.until = $scope.filters.until + " " + "23:59:59";
      if (vm.group) {
        if (vm.group.val == "") {
          $scope.filters.grupo = 0;
          vm.group.value = "";
          vm.group.type = "";
        }
      }
      $http({
        method: "POST",
        url: url.IP + "reporte-adjuntos/",
        data: $scope.filters,
      }).then(function success(response) {
        $scope.adjuntos = response.data;
        $scope.adjunto_config = {
          count: response.data.count,
          previous: url.IP + "reporte-adjuntos/",
          next: url.IP + "reporte-adjuntos/",
        };
        vm.show_pag_adjunto = true;
        PaginationResults("adjuntos", "adjunto_config");
      });
      $localStorage.saved_filters_reporte_log = angular.copy($scope.filters);
      $localStorage.saved_filters_reporte_log["group"] = vm.group;
    };

    vm.matchesGroup = matchesGroup;
    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.group) {
        if (vm.group.val) {
          var word_data = vm.group.val;
        }
      }
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }
    // Download report to excel
    $scope.export = function (param) {
      var lx = Ladda.create(document.querySelector(".ladda-button_excel"));
      lx.start();
      $scope.filters.orden = $scope.columnArray;
      $scope.filters.export_type = 2;
      if (param == 1) {
        $http({
          method: "POST",
          url: url.IP + "service_reporte-adjuntos-excel",
          data: $scope.filters,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function (data, status, headers, config) {
          if (data.status == 200) {
            lx.stop();
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte Adjuntos.xls");
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDOWNLOADREP, "error");
            lx.stop();
          }
        });
      }
    };
    // Format Dates DD/MM/YYYY
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    // -----------PAGINACIÓN
    function PaginationResults(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        $scope.getAdjuntos(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("RenewalModalCtrl", RenewalModalCtrl);

  RenewalModalCtrl.$inject = [
    "MESSAGES",
    "$rootScope",
    "appStates",
    "formatValues",
    "insuranceService",
    "$stateParams",
    "dataFactory",
    "SweetAlert",
    "$sce",
    "coverageService",
    "$sessionStorage",
    "$scope",
    "$uibModalInstance",
    "$uibModal",
    "myPolicy",
    "$http",
    "$state",
    "url",
    "$location",
    "$localStorage",
  ];

  function RenewalModalCtrl(
    MESSAGES,
    $rootScope,
    appStates,
    formatValues,
    insuranceService,
    $stateParams,
    dataFactory,
    SweetAlert,
    $sce,
    coverageService,
    $sessionStorage,
    $scope,
    $uibModalInstance,
    $uibModal,
    myPolicy,
    $http,
    $state,
    url,
    $location,
    $localStorage
  ) {
    function setRenewalDraft(policy) {
      $rootScope.renewalDraftPolicy = angular.copy(policy) || null;
    }

    function clearRenewalDraft() {
      $rootScope.renewalDraftPolicy = null;
    }

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var vm = $scope;
    vm.user = usr;
    vm.forms = {};
    vm.cancel = cancel;
    vm.renewal = renewal;
    vm.cancelRenovate = cancelRenovate;

    var url_ = url;
    var url = null;

    // Menú rapido
    vm.deletePolicy = deletePolicy;
    vm.cancelPolicy = cancelPolicy;
    vm.getPDF = getPDF;
    vm.openRenovateModal = openRenovateModal;
    vm.goToEdit = goToEdit;
    vm.goToPolicy = goToPolicy;
    vm.viewCarta = viewCarta;

    function deletePolicy(policy) {
      vm.policy_history_1 = [];
      $http({
        method: "GET",
        url: url_.IP + "historic-policies/",
        params: {
          actual_id: policy.id,
        },
      })
        .then(function success(response) {
          $scope.policy_history = [];
          if (response.data.results.length) {
            response.data.results.forEach(function function_name(old, index) {
              if (policy.id != old.base_policy.id) {
                $scope.policy_history.push(old.base_policy);
                if (index == 0) {
                  $scope.copy_policy_history = angular.copy(old.base_policy);
                }
              } else if (old.new_policy) {
                $scope.policy_history.push(old.new_policy);
              }
            });
          }
        })
        .catch(function (e) {
          console.log("error - caratula - catch", e);
        });
      // dataFactory.get('has-del-policy-permission')
      // .then(function success(response) {
      //  if(response.data){
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            console.log("policy", policy);
            if (policy.document_type == 1) {
              $scope.text_patch_ant = "";
              $scope.status_ant = "";
              $scope.text_patch_ant = "";
              if (policy.status == 1 || policy.status == 2) {
                if (vm.policy_history_1.length > 0) {
                  if (vm.policy_history_1[0].status != 12) {
                    $scope.text_patch_ant =
                      " \nSe cambiará el estatus de la póliza: " +
                      vm.policy_history_1[0].poliza_number +
                      " asociada";
                    $scope.status_ant = vm.policy_history_1[0].status;
                  } else {
                    if (vm.policy_history_1[0].status == 12) {
                      $scope.text_patch_ant = "";
                      $scope.status_ant = vm.policy_history_1[0].status;
                    }
                    $scope.text_patch_ant = "";
                    $scope.status_ant = vm.policy_history_1[0].status;
                  }
                }
              }
              if (vm.policy_history_1.length > 0) {
                $scope.date1 = convertDate(
                  datesFactory.toDate(
                    convertDate(vm.policy_history_1[0].end_of_validity)
                  )
                );
                if (process($scope.date1) < process(convertDate(new Date()))) {
                  $scope.status_ant = 13;
                } else if (
                  process($scope.date1) > process(convertDate(new Date()))
                ) {
                  $scope.status_ant = 14;
                } else {
                  $scope.status_ant = vm.policy_history_1[0].status;
                }
              }

              function process(date) {
                var parts = date.split("/");
                var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
                return date.getTime();
              }
              $http
                .patch(policy.url, { status: 0 })
                // $http.patch(policy.url)
                .then(deletePolicyComplete)
                .catch(deletePolicyFailed);
              function deletePolicyComplete(response, status, headers, config) {
                if (response.status === 200 || response.status === 201) {
                  var data_email = {
                    id: policy.id,
                    model: 2,
                    type_person: 0,
                  };
                  dataFactory
                    .post("send-email-admins-deletes/", data_email)
                    .then(function success(req) {});
                  if (vm.policy_history_1.length > 0) {
                    $http
                      .patch(vm.policy_history_1[0].url, {
                        renewed_status: 0,
                        status: $scope.status_ant,
                      })
                      .then(function (xPolicy) {
                        var params = {
                          model: 1,
                          event: "PATCH",
                          associated_id: vm.policy_history_1[0].id,
                          identifier:
                            "cambio el estatus de renovación de la póliza: " +
                            vm.policy_history_1[0].poliza_number +
                            " al eliminar la OT: " +
                            vm.insurance.internal_number,
                        };
                        dataFactory
                          .post("send-log/", params)
                          .then(function success(response) {});
                      });
                  }
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.DELETEPOLICY,
                    "success"
                  );

                  var params = {
                    model: 1,
                    event: "POST",
                    associated_id: policy.id,
                    identifier: "elimino la póliza.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});

                  policy.recibos_poliza.forEach(function (receipt) {
                    if (receipt.id) {
                      var params = {
                        model: 4,
                        event: "PATCH",
                        associated_id: receipt.id,
                        identifier:
                          " actualizo recibo a desactivado por eliminación de póliza",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                    }
                    $http.patch(receipt.url, { status: 0 });
                  });
                  $uibModalInstance.dismiss("cancel");
                  $state.reload();
                }
              }
              function deletePolicyFailed(response, status, headers, config) {
                return response;
              }
              // return $http.post(url_.IP + 'delete-policy', {'id':policy.id})
              //   .then(deletePolicyComplete)
              //   .catch(deletePolicyFailed);

              // function deletePolicyComplete(response, status, headers, config) { //jshint ignore:line
              //   SweetAlert.swal("¡Listo!", MESSAGES.OK.DELETEPOLICY, "success");
              //   setTimeout(function() {
              //     $uibModalInstance.dismiss('cancel');
              //     $state.reload();
              //   }, 1000);
              // }

              // function deletePolicyFailed(response, status, headers, config) { //jshint ignore:line
              //   return response;
              // }
            } else if (policy.document_type == 3) {
              return $http
                .post(url_.IP + "delete-colectivity/", { id: policy.id })
                .then(deletePolicyComplete)
                .catch(deletePolicyFailed);

              function deletePolicyComplete(response, status, headers, config) {
                //jshint ignore:line
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.DELETECOLLECTIVITY,
                  "success"
                );
                if ($scope.copy_policy_history) {
                  if ($scope.copy_policy_history.url) {
                    if (
                      process(
                        convertDate(
                          $scope.copy_policy_history.start_of_validity
                        )
                      ) > process(convertDate(new Date()))
                    ) {
                      var data = {
                        status: 10,
                        renewed_status: 0,
                      };
                    } else {
                      if (
                        process(
                          convertDate(
                            $scope.copy_policy_history.end_of_validity
                          )
                        ) > process(convertDate(new Date()))
                      ) {
                        var data = {
                          status: 14,
                          renewed_status: 0,
                        };
                      } else {
                        var data = {
                          status: 13,
                          renewed_status: 0,
                        };
                      }
                    }
                    function process(date) {
                      var parts = date.split("/");
                      var date = new Date(
                        parts[1] + "/" + parts[0] + "/" + parts[2]
                      );
                      return date.getTime();
                    }
                    $http
                      .patch($scope.copy_policy_history.url, data)
                      .then(function success(request) {
                        if (request.status === 200) {
                          var paramsRec = {
                            model: 18,
                            event: "PATCH",
                            associated_id: $scope.copy_policy_history.id,
                            identifier: " eliminó la renovación.",
                          };
                          dataFactory
                            .post("send-log/", paramsRec)
                            .then(function success(response) {});
                        }
                      })
                      .catch(function (e) {
                        console.log("error", e);
                      });
                  }
                }
                setTimeout(function () {
                  $uibModalInstance.dismiss("cancel");
                  $state.reload();
                }, 1000);
              }

              function deletePolicyFailed(response, status, headers, config) {
                //jshint ignore:line
                return response;
              }
            } else if (policy.document_type == 4) {
              return $http
                .post(url_.IP + "delete-colectivity/", { id: policy.caratula })
                .then(deletePolicyComplete)
                .catch(deletePolicyFailed);

              function deletePolicyComplete(response, status, headers, config) {
                //jshint ignore:line
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.DELETECOLLECTIVITY,
                  "success"
                );
                var data_email = {
                  id: policy.id,
                  model: 2,
                  type_person: 0,
                };
                dataFactory
                  .post("send-email-admins-deletes/", data_email)
                  .then(function success(req) {});
                setTimeout(function () {
                  $uibModalInstance.dismiss("cancel");
                  $state.reload();
                }, 1000);
              }

              function deletePolicyFailed(response, status, headers, config) {
                //jshint ignore:line
                return response;
              }
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La póliza no se ha eliminado",
              "error"
            );
          }
        }
      );
      //   } else {
      //     SweetAlert.swal('Error', 'No tienes permiso para realizar esta acción', "error");
      //   }
      // });
    }

    function cancelPolicy(id) {
      // dataFactory.get('has-cancel-policy-permission')
      // .then(function success(response) {
      //   if(response.data){
      SweetAlert.swal(
        {
          title: "Cancelar póliza",
          text: "Elija una opción",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#581845  ",
          confirmButtonText: "Por endoso tipo D",
          cancelButtonText: "Precancelación",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var params = {
              myInsurance: vm.insurance,
              contractor: $scope.contratante,
            };
            $state.go("endosos.endosos", params);
          } else {
            var data = {
              status: 4,
            };
            // SweetAlert.swal("Se ha enviando un correo al administrador", "info");
            // $http.patch(url.IP + 'polizas/'+ id + '/', data).then(function success(response) {
            // }) Manda correo
            $scope.emails = [];
            $scope.emails.push("ivan.tello@miurabox.com");
            $http
              .post(url_.IP + "cancel-policy-manual/", {
                id: id,
                emails: $scope.emails,
              })
              .then(
                function success(request) {
                  if (request.status === 200) {
                    swal(
                      "¡Listo!",
                      "Se ha enviado un correo al administrador",
                      "success"
                    );
                  } else {
                    toaster.warning(
                      "No se envió la póliza. Contacte a su administrador."
                    );
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          }
        }
      );
      //   } else {
      //     SweetAlert-swal("Error", "No tienes permiso para realizar esta acción", "error");
      //   }
      // })
    }

    $scope.dismis = function (forms, receipt) {
      $scope.policy = forms;
      if (forms.contractor) {
        receipt.contratante = forms.contractor;
      }
      receipt.poliza = {
        aseguradora: forms.aseguradora,
        id: forms.id,
        contractor: forms.contractor ? forms.contractor.full_name : null,
        polizaId: forms.id,
        poliza_number: forms.poliza_number,
        subramo: forms.subramo,
        url: forms.url,
      };
      $uibModalInstance.dismiss("cancel");
      changeStatusModal(receipt);
    };

    function changeStatusModal(receipt) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return angular.copy(receipt);
          },
          insurance: function () {
            return $scope.policy;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function getPDF(poliza) {
      $http({
        method: "GET",
        url: url_.IP + "get-pdf-ot/",
        params: {
          id: poliza,
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
        // $scope.pdf = response.data;
        // $http({
        //   method: 'GET',
        //   url: url_.IP + 'get-pdf',
        //   params: {
        //     'pdf_name': $scope.pdf.pdf_name
        //   }
        // }).then(function success(response) {

        // })
      });
    }

    function openRenovateModal(myInsurance, type) {
      $stateParams.myInsurance = myInsurance;
      // ---------------------------
      // evaluate
      $scope.existeRenovacion = false;
      $scope.conteo = 0;
      $scope.totalp = vm.policy_history ? vm.policy_history.length : 0;
      if (vm.policy_history) {
        vm.policy_history.forEach(function (old) {
          $scope.conteo = $scope.conteo + 1;
          if (old.status == 1) {
            $scope.existeRenovacion = true;
            SweetAlert.swal(
              "Información",
              "La póliza ya tiene una OT de renovación",
              "info"
            );
            $state.go("index.main");
            clearRenewalDraft();
            return;
          }
        });
      }
      if ($scope.conteo == $scope.totalp && $scope.existeRenovacion == false) {
        if (myInsurance.document_type == 1) {
          if (myInsurance.renewed) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRENEWPOLICY, "error");
            clearRenewalDraft();
          } else {
            $scope.id_for_new_tab = myInsurance.id;
            var name = "Renovación Póliza";
            var route = "renovaciones.polizas";
            $scope.name_for_new_tab = name;
            $scope.route_for_new_tab = route;
            var existe = false;
            if (name && route) {
              $scope.route_for_new_tab = route;
              $scope.name_for_new_tab = name;
              appStates.states.forEach(function (state) {
                if (state.route == $scope.route_for_new_tab) {
                  existe = true;
                }
              });
            }
            if (!existe) {
              var active_tab = appStates.states.findIndex(function (item) {
                if (item.active) {
                  return true;
                }
                return false;
              });

              appStates.states[active_tab] = {
                name: $scope.name_for_new_tab,
                heading: $scope.name_for_new_tab,
                route: $scope.route_for_new_tab,
                active: true,
                isVisible: true,
                href: $state.href($scope.route_for_new_tab),
              };
            }
            $localStorage.tab_states = appStates.states;
            var params = { polizaId: myInsurance.id, myInsurance: myInsurance };
            setRenewalDraft(myInsurance);
            $state.go($scope.route_for_new_tab, params);
          }
        } else if (myInsurance.document_type == 3) {
          if (myInsurance.renewed) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRENEWPOLICY, "error");
          } else {
            if (type == 1) {
              var params = { polizaId: myInsurance.id, tipo: 1 };
              $scope.id_for_new_tab = myInsurance.id;
              var name = "Renovar Póliza";
              var route = "colectividades.renewal";
              $scope.name_for_new_tab = name;
              $scope.route_for_new_tab = route;

              var existe = false;
              if (name && route) {
                $scope.route_for_new_tab = route;
                $scope.name_for_new_tab = name;
                appStates.states.forEach(function (state) {
                  if (state.route == $scope.route_for_new_tab) {
                    existe = true;
                  }
                });
              }

              if (!existe) {
                var active_tab = appStates.states.findIndex(function (item) {
                  if (item.active) {
                    return true;
                  }
                  return false;
                });

                appStates.states[active_tab] = {
                  name: $scope.name_for_new_tab,
                  heading: $scope.name_for_new_tab,
                  route: $scope.route_for_new_tab,
                  active: true,
                  isVisible: true,
                  href: $state.href($scope.route_for_new_tab),
                };
              }
              $localStorage.tab_states = appStates.states;
              // var params = { 'polizaId': myInsurance.id }
              $state.go($scope.route_for_new_tab, params);
            } else if (type == "") {
              var params = { polizaId: myInsurance.id, tipo: "" };
              $scope.id_for_new_tab = myInsurance.id;
              var name = "Renovar Póliza";
              var route = "colectividades.renewal";
              $scope.name_for_new_tab = name;
              $scope.route_for_new_tab = route;

              var existe = false;
              if (name && route) {
                $scope.route_for_new_tab = route;
                $scope.name_for_new_tab = name;
                appStates.states.forEach(function (state) {
                  if (state.route == $scope.route_for_new_tab) {
                    existe = true;
                  }
                });
              }

              if (!existe) {
                var active_tab = appStates.states.findIndex(function (item) {
                  if (item.active) {
                    return true;
                  }
                  return false;
                });

                appStates.states[active_tab] = {
                  name: $scope.name_for_new_tab,
                  heading: $scope.name_for_new_tab,
                  route: $scope.route_for_new_tab,
                  active: true,
                  isVisible: true,
                  href: $state.href($scope.route_for_new_tab),
                };
              }
              $localStorage.tab_states = appStates.states;
              // var params = { 'polizaId': myInsurance.id }
              $state.go($scope.route_for_new_tab, params);
            }
          }
        } else if (myInsurance.document_type == 4) {
          if (myInsurance.renewed) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRENEWPOLICY, "error");
          } else {
            if (type == 1) {
              var params = { polizaId: myInsurance.caratula, tipo: 1 };
              // $state.go('colectividades.renewal', params);
              $scope.route_for_new_tab = "colectividades.renewal";
              $scope.route_for_new_tab = "colectividades.renewal";
              $scope.id_for_new_tab = myInsurance.id;
              $scope.name_for_new_tab = "Renovar Póliza";
              var existe = false;
              if (name && route) {
                $scope.route_for_new_tab = route;
                $scope.name_for_new_tab = name;
                appStates.states.forEach(function (state) {
                  if (state.route == $scope.route_for_new_tab) {
                    existe = true;
                  }
                });
              }

              if (!existe) {
                var active_tab = appStates.states.findIndex(function (item) {
                  if (item.active) {
                    return true;
                  }
                  return false;
                });

                appStates.states[active_tab] = {
                  name: $scope.name_for_new_tab,
                  heading: $scope.name_for_new_tab,
                  route: $scope.route_for_new_tab,
                  active: true,
                  isVisible: true,
                  href: $state.href($scope.route_for_new_tab),
                };
              }
              $state.go($scope.route_for_new_tab, params);
            } else if (type == "") {
              var params = { polizaId: myInsurance.caratula, tipo: "" };
              // $state.go('colectividades.renewal', params);
              $scope.route_for_new_tab = "colectividades.renewal";
              $scope.id_for_new_tab = myInsurance.id;
              $scope.name_for_new_tab = "Renovar Póliza";
              var existe = false;
              appStates.states.forEach(function (state) {
                if (
                  state.route == $scope.route_for_new_tab &&
                  state.id == $scope.id_for_new_tab
                ) {
                  existe = true;
                }
              });
              if (appStates.states.length > 3) {
                SweetAlert.swal(
                  "Error",
                  "No se pueden abrir más pestañas.",
                  "error"
                );
              } else {
                if (!existe) {
                  appStates.states.push({
                    id: $scope.id_for_new_tab,
                    name: $scope.name_for_new_tab,
                    heading: $scope.name_for_new_tab,
                    route: $scope.route_for_new_tab,
                    active: true,
                    isVisible: true,
                    href: $state.href($scope.route_for_new_tab, params),
                  });
                  $localStorage.tab_states = appStates.states;
                  $state.go($scope.route_for_new_tab, params);
                }
              }
              $state.go($scope.route_for_new_tab, params);
            }
          }
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      } else {
        $state.go("index.main");
      }
      // *****************************+
    }

    function goToEdit(poliza) {
      console.log("poliza**", poliza);
      if (poliza.document_type == 1) {
        $stateParams.myInsurance = poliza;
        // $state.go('polizas.editar', {polizaId: poliza.id});
        // $state.go('colectividades.edit', {polizaId: poliza.id});
        var params = { polizaId: poliza.id };
        $scope.id_for_new_tab = poliza.id;
        var name = "Editar Póliza";
        var route = "polizas.editar";
        $scope.name_for_new_tab = name;
        $scope.route_for_new_tab = route;
        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }
        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });
          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab),
          };
        }
        $localStorage.tab_states = appStates.states;
        $state.go($scope.route_for_new_tab, params);
      } else if (poliza.document_type == 3) {
        $rootScope.edit_collective = poliza;
        $stateParams.myInsurance = poliza;
        // $state.go('colectividades.edit', {polizaId: poliza.id});
        var params = { polizaId: poliza.id, tipo: "" };
        $scope.id_for_new_tab = poliza.id;
        var name = "Editar Póliza de Grupo";
        var route = "colectividades.edit";
        $scope.name_for_new_tab = name;
        $scope.route_for_new_tab = route;
        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }
        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });
          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab),
          };
        }
        $localStorage.tab_states = appStates.states;
        $state.go($scope.route_for_new_tab, params);
      } else if (poliza.document_type == 4) {
        // $state.go('colectividades.edit', {polizaId: poliza.caratula});
        $rootScope.edit_collective = poliza.parent;
        $stateParams.myInsurance = poliza.parent;
        // $state.go('colectividades.edit', {polizaId: poliza.id});
        var params = { polizaId: poliza.caratula, tipo: "" };
        $scope.id_for_new_tab = poliza.caratula;
        var name = "Editar Póliza de Grupo";
        var route = "colectividades.edit";
        $scope.name_for_new_tab = name;
        $scope.route_for_new_tab = route;
        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }
        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });
          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab),
          };
        }
        $localStorage.tab_states = appStates.states;
        $state.go($scope.route_for_new_tab, params);
      }
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    }

    function goToPolicy(poliza) {
      if (poliza.document_type == 1) {
        $scope.open_in_same_tab(
          "Información Póliza",
          "polizas.info",
          { polizaId: poliza.id },
          poliza.id,
          null
        );
        // $state.go('polizas.info', {polizaId: poliza.id});
      } else if (poliza.document_type == 3) {
        $scope.open_in_same_tab(
          "Información Póliza",
          "colectividades.info",
          { polizaId: poliza.id },
          poliza.id,
          null
        );
        // $state.go('colectividades.info', {polizaId: poliza.id})
      } else if (poliza.document_type == 4) {
        $scope.open_in_same_tab(
          "Información Póliza",
          "colectividades.info",
          { polizaId: poliza.caratula },
          poliza.caratula,
          null
        );
        // $state.go('colectividades.info', {polizaId: poliza.caratula});
      }
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    }

    $scope.formatCoverage = function (parValue) {
      var res = parValue.replace("$", "");
      if (res) {
        var model = formatValues.currency(res);
        return model;
      } else {
        return "";
      }
    };
    if ($location.$$path == "/index/main") {
      $localStorage.ubication = $location.$$path;
    } else {
    }
    function cancelRenovate(poliza) {
      swal(
        {
          title: "No renovar",
          text: "Motivo:",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: false,
        },
        function (inputValue) {
          if (inputValue === false) return false;
          if (inputValue === "") {
            swal.showInputError("Necesita especificar un motivo");
            return false;
          }
          var data = {
            reason_ren: inputValue,
            status: 15,
          };
          $http.patch(poliza.url, data).then(function (ren) {
            var params = {
              model: 1,
              event: "PATCH",
              associated_id: poliza.id,
              identifier:
                " cancelo la renovación por: " +
                ren.data.reason_ren +
                " de la póliza: " +
                poliza.poliza_number +
                ".",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          });
          if ($location.$$path == "/index/main") {
            $http({
              method: "GET",
              url: url_.IP + "chart-renovaciones/",
            }).then(function (ren) {
              $localStorage.renovaciones_count = ren.data;
              $state.go("index.main");
              $state.reload();
            });
          }
          swal(
            "Hecho",
            "La póliza se ha cerrado y no se vera más en el listado de renovaciones",
            "success"
          );
          $uibModalInstance.dismiss("No renovada");
        }
      );
    }

    activate();

    function activate() {
      $http({
        method: "GET",
        url: url_.IP + "historic-policies/",
        params: {
          actual_id: myPolicy.id,
        },
      }).then(function success(response) {
        if (response.data.results.length) {
          vm.policy_history = [];
          vm.policy_history.renovada = [];
          response.data.results.forEach(function function_name(old) {
            if (myPolicy.id != old.base_policy.id) {
              vm.policy_history.push(old.base_policy);
            } else if (old.new_policy) {
              vm.policy_history.push(old.new_policy);
            }
            if (myPolicy.id == old.base_policy.id) {
              vm.policy_history.renovada.push(old.base_policy);
            }
          });
        }
      });
      insuranceService.getVendors().then(
        function success(data) {
          $scope.vendors = data.data;
          $scope.vendors.forEach(function (vendor) {
            vendor.name = vendor.first_name + " " + vendor.last_name;
          });
        },
        function error(error) {
          toaster.ERROR("No pudieron ser cargados eferenciadores");
        }
      );
      $http({
        method: "GET",
        url: url_.IP + "comments/",
        params: {
          model: 6,
          id_model: myPolicy.id,
        },
      })
        .then(function (request) {
          $scope.comments_data = request.data.results;
          $scope.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      $scope.renewal_id = myPolicy.id;
      $scope.view_cartas = true;
      // dataFactory.get('has-view-cartas-permission')
      // .then(function(req) {
      //     if(req.status == 200) {
      //         $scope.view_cartas = req.data;
      //     }
      // });
      forms();
      $http({
        method: "GET",
        url: url_.IP + "cartas-by-model",
        params: {
          model: 3,
        },
      }).then(function success(response) {
        $scope.cartas = response.data;
      });
    }

    function viewCarta(poliza, carta) {
      var params = {
        id_poliza: poliza,
        id_carta: carta,
      };
      dataFactory.get("get-pdf-form/", params).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
        // $scope.pdf = response.data;
        // var par = {
        //     'pdf_name': $scope.pdf.pdf_name
        //   }
        // dataFactory.get('get-pdf', par)
        // .then(function success(response) {

        //   })
      });
    }

    function cancel(param) {
      if ($uibModalInstance) $uibModalInstance.dismiss("cancel", param);
    }

    function forms() {
      vm.forms = myPolicy;
      return vm.forms;
    }

    function mesDiaAnio(parDate) {
      var d = new Date(toDate(parDate));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      return date;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    $scope.coberturas = myPolicy.coverageInPolicy_policy;

    if (myPolicy.contractor) url = myPolicy.contractor.url;

    var recibos = [];
    myPolicy.recibos_poliza.forEach(function (recibo) {
      var item = parseFloat(recibo);
      recibos.push(item);
      // recibos.push(recibo.data.prima_total);
      // TODO: suma de recibos y ordenado de los mismos.
    });

    $scope.recibos = recibos.sort();

    $scope.prima_total = function () {
      return recibos.reduce(getSum);
    };

    function getSum(total, num) {
      return total + num;
    }

    $http({
      method: "GET",
      url: url,
    }).then(
      function success(response) {
        $scope.contratante = response.data;
        if (myPolicy.contractor)
          $scope.addressContratante = response.data.address_contractor[0];
      },
      function error(response) {
        console.log("error", response);
      }
    );

    $scope.forma_pago = function (parValue) {
      switch (parValue) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        case 24:
          return "Quincenal";
          break;
        default:
          return "No especificada";
      }
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        // appStates.states.forEach(function(state) {
        //   if (state.route == $scope.route_for_new_tab){
        //     existe = true;
        //   }
        // });
      }

      // if (!existe){
      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    function renewal(myInsurance) {
      $scope.existeRenovacion = false;
      $scope.conteo = 0;
      $scope.totalp = vm.policy_history ? vm.policy_history.length : 0;
      if (vm.policy_history) {
        vm.policy_history.forEach(function (old) {
          $scope.conteo = $scope.conteo + 1;
          if (old.status == 1) {
            $scope.existeRenovacion = true;
            SweetAlert.swal(
              "Información",
              "La póliza ya tiene una OT de renovación",
              "info"
            );
            $state.go("index.main");
            clearRenewalDraft();
            return;
          }
        });
      }
      if (
        $uibModalInstance &&
        $scope.conteo == $scope.totalp &&
        $scope.existeRenovacion == false
      ) {
        $uibModalInstance.close();
        $stateParams.myInsurance = myInsurance;
        if (vm.forms.document_type == 1) {
          $scope.id_for_new_tab = myInsurance.id;
          var name = "Renovación Póliza";
          var route = "renovaciones.polizas";
          $scope.name_for_new_tab = name;
          $scope.route_for_new_tab = route;
          var existe = false;
          if (name && route) {
            $scope.route_for_new_tab = route;
            $scope.name_for_new_tab = name;
            appStates.states.forEach(function (state) {
              if (state.route == $scope.route_for_new_tab) {
                existe = true;
              }
            });
          }
          if (!existe) {
            var active_tab = appStates.states.findIndex(function (item) {
              if (item.active) {
                return true;
              }
              return false;
            });

            appStates.states[active_tab] = {
              name: $scope.name_for_new_tab,
              heading: $scope.name_for_new_tab,
              route: $scope.route_for_new_tab,
              active: true,
              isVisible: true,
              href: $state.href($scope.route_for_new_tab),
            };
          }
          $localStorage.tab_states = appStates.states;
          var params = { polizaId: myInsurance.id, myInsurance: myInsurance };
          setRenewalDraft(myInsurance);
          $state.go($scope.route_for_new_tab, params);
        } else if (vm.forms.document_type == 3) {
          var params = { polizaId: myInsurance.id };
          $scope.id_for_new_tab = myInsurance.id;
          var name = "Renovar Póliza";
          var route = "colectividades.renewal";
          $scope.name_for_new_tab = name;
          $scope.route_for_new_tab = route;
          var existe = false;
          if (name && route) {
            $scope.route_for_new_tab = route;
            $scope.name_for_new_tab = name;
            appStates.states.forEach(function (state) {
              if (state.route == $scope.route_for_new_tab) {
                existe = true;
              }
            });
          }
          if (!existe) {
            var active_tab = appStates.states.findIndex(function (item) {
              if (item.active) {
                return true;
              }
              return false;
            });
            appStates.states[active_tab] = {
              name: $scope.name_for_new_tab,
              heading: $scope.name_for_new_tab,
              route: $scope.route_for_new_tab,
              active: true,
              isVisible: true,
              href: $state.href($scope.route_for_new_tab),
            };
          }
          $localStorage.tab_states = appStates.states;
          var params = { polizaId: myInsurance.id };
          $state.go($scope.route_for_new_tab, params);
        } else if (vm.forms.document_type == 7) {
          // $state.go('fianzas.renovar',{polizaId: vm.forms.id, renovacion : 2});
          var params = {
            polizaId: vm.forms.id,
            renovacion: 2,
          };

          $scope.route_for_new_tab = "fianzas.renovar";
          $scope.id_for_new_tab = myInsurance.id;
          $scope.name_for_new_tab = "Renovar Fianza";
          $stateParams.renovacion = 2;
          var existe = false;
          appStates.states.forEach(function (state) {
            if (
              state.route == $scope.route_for_new_tab &&
              state.id == $scope.id_for_new_tab
            ) {
              existe = true;
            }
          });
          if (appStates.states.length > 3) {
            SweetAlert.swal(
              "Error",
              "No se pueden abrir más pestañas.",
              "error"
            );
          } else {
            if (!existe) {
              appStates.states.push({
                id: $scope.id_for_new_tab,
                name: $scope.name_for_new_tab,
                renovacion: 2,
                heading: $scope.name_for_new_tab,
                route: $scope.route_for_new_tab,
                active: true,
                isVisible: true,
                href: $state.href($scope.route_for_new_tab, params),
              });
              $localStorage.tab_states = appStates.states;
              $state.go($scope.route_for_new_tab, params);
            }
          }
          $state.go($scope.route_for_new_tab, params);
        } else if (vm.forms.document_type == 8) {
          // $state.go('fianzas.reissue', {polizaId: vm.forms.id});
          var params = { polizaId: myInsurance.id };
          $scope.route_for_new_tab = "fianzas.reissue";
          $scope.id_for_new_tab = myInsurance.id;
          $scope.name_for_new_tab = "Renovar Fianza";
          var existe = false;
          appStates.states.forEach(function (state) {
            if (
              state.route == $scope.route_for_new_tab &&
              state.id == $scope.id_for_new_tab
            ) {
              existe = true;
            }
          });
          if (appStates.states.length > 3) {
            SweetAlert.swal(
              "Error",
              "No se pueden abrir más pestañas.",
              "error"
            );
          } else {
            if (!existe) {
              appStates.states.push({
                id: $scope.id_for_new_tab,
                name: $scope.name_for_new_tab,
                heading: $scope.name_for_new_tab,
                route: $scope.route_for_new_tab,
                active: true,
                isVisible: true,
                href: $state.href($scope.route_for_new_tab, params),
              });
              $localStorage.tab_states = appStates.states;
              $state.go($scope.route_for_new_tab, params);
            }
          }
          $state.go($scope.route_for_new_tab, params);
        } else if (vm.forms.document_type == 11) {
          // $state.go('flotillas.renewal', {polizaId: vm.forms.id});
          var params = { polizaId: myInsurance.id };
          $scope.route_for_new_tab = "flotillas.renewal";
          $scope.id_for_new_tab = myInsurance.id;
          $scope.name_for_new_tab = "Renovar Colectividad";
          var existe = false;
          appStates.states.forEach(function (state) {
            if (
              state.route == $scope.route_for_new_tab &&
              state.id == $scope.id_for_new_tab
            ) {
              existe = true;
            }
          });
          if (appStates.states.length > 3) {
            SweetAlert.swal(
              "Error",
              "No se pueden abrir más pestañas.",
              "error"
            );
          } else {
            if (!existe) {
              appStates.states.push({
                id: $scope.id_for_new_tab,
                name: $scope.name_for_new_tab,
                heading: $scope.name_for_new_tab,
                route: $scope.route_for_new_tab,
                active: true,
                isVisible: true,
                href: $state.href($scope.route_for_new_tab, params),
              });
              $localStorage.tab_states = appStates.states;
              $state.go($scope.route_for_new_tab, params);
            }
          }
          $state.go($scope.route_for_new_tab, params);
        } else if (vm.forms.document_type == 12) {
          SweetAlert.swal(
            "Advertencia",
            "Las pólizas de colectividad solo se pueden renovar mediante layout.",
            "warning"
          );
          // $state.go('flotillas.renewal', {polizaId: myInsurance.caratula});
        }
      } else {
        $state.go("index.main");
      }
    }

    $scope.show_button_save_sum = false;
    $scope.show_button_save_ded = false;

    $scope.demo = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    $scope.saveSum = function (parValue, parCoverage) {
      var obj = {
        sum_insured: parValue,
        default: false,
        coverage_sum: parCoverage.url,
      };

      coverageService.createSumInsured(obj).then(function (req) {
        if (req.id) {
          $scope.result_ = false;
          parCoverage.sums_coverage.push(req);
        }
      });
    };

    $scope.saveDed = function (parValue, parCoverage) {
      var obj = {
        deductible: parValue,
        default: false,
        coverage_deductible: parCoverage.url,
      };

      coverageService.createDeducible(obj).then(function (req) {
        if (req.id) {
          $scope.result_ded = false;
          parCoverage.deductible_coverage.push(req);
        }
      });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("RenovacionesModalCtrl", RenovacionesModalCtrl);

  RenovacionesModalCtrl.$inject = [
    "$location",
    "packageService",
    "datesFactory",
    "models",
    "ContratanteService",
    "$q",
    "$http",
    "tiposBeneficiarios",
    "sex",
    "FileUploader",
    "formService",
    "$timeout",
    "url",
    "$localStorage",
    "$scope",
    "$filter",
    "groupService",
    "providerService",
    "insuranceService",
    "receiptService",
    "generalService",
    "toaster",
    "formaPago",
    "helpers",
    "MESSAGES",
    "fileService",
    "SweetAlert",
    "$sessionStorage",
    "$state",
    "$stateParams",
    "formatValues",
    "coverageService",
    "dataFactory",
    "$rootScope",
    "emailService",
    "$uibModal",
    "appStates",
    "$sce",
  ];

  function RenovacionesModalCtrl(
    $location,
    packageService,
    datesFactory,
    models,
    ContratanteService,
    $q,
    $http,
    tiposBeneficiarios,
    sex,
    FileUploader,
    formService,
    $timeout,
    url,
    $localStorage,
    $scope,
    $filter,
    groupService,
    providerService,
    insuranceService,
    receiptService,
    generalService,
    toaster,
    formaPago,
    helpers,
    MESSAGES,
    fileService,
    SweetAlert,
    $sessionStorage,
    $state,
    $stateParams,
    formatValues,
    coverageService,
    dataFactory,
    $rootScope,
    emailService,
    $uibModal,
    appStates,
    $sce
  ) {
    function getRenewalDraft() {
      return angular.copy($rootScope.renewalDraftPolicy) || null;
    }

    var order = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.orgName = usr.orgname;
    order.f_currency = {};
    order.f_currency.f_currency_selected = 1;
    order.f_currency.options = [
      { value: 1, label: "PESOS" },
      { value: 2, label: "DOLARES" },
      { value: 3, label: "UDI" },
    ];

    order.conducto_de_pago = {};
    order.conducto_de_pago.options = [
      { value: 1, label: "No domiciliada" },
      { value: 2, label: "Agente" },
      { value: 3, label: "CAC" },
      { value: 4, label: "CAT/Domiciliado" },
      { value: 5, label: "Nómina" },
      { value: 6, label: "CUT" },
    ];

    $scope.disabled_ot = false;
    order.renewal = {};
    $scope.es_renovacion = false;
    $scope.esEdicion = false;
    order.renewal.is_renewable = 1;
    order.renewal.options = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    order.businessline = [
      { id: 1, name: "Comercial" },
      { id: 2, name: "Personal" },
      { id: 0, name: "Otro" },
    ];
    order.types = [
      { id: 1, name: "Automóvil" },
      { id: 2, name: "Motocicleta" },
      { id: 3, name: "Tracto" },
      { id: 4, name: "Autobús" },
      { id: 5, name: "Pick Up" },
      { id: 6, name: "Camiones hasta 1.5 ton" },
      { id: 7, name: "Chofer app" },
      { id: 8, name: "Remolque" },
      { id: 9, name: "Camiones + 1.5 ton" },
    ];

    order.types_gm = [{ id: 46, name: "Familiar" }];
    order.types_ap = [
      { id: 64, name: "Viajero" },
      { id: 46, name: "Familiar" },
    ];

    order.types_life = [
      { id: 47, name: "Ahorro" },
      { id: 48, name: "Vitalicia" },
      { id: 49, name: "Temporal/Protección" },
    ];

    order.types_incendio = [
      { id: 1, name: "Familiar" },
      { id: 2, name: "Casa Habitación" },
      { id: 3, name: "Condominio" },
      { id: 4, name: "Edificio" },
      { id: 5, name: "Empresarial" },
      { id: 6, name: "Múltiple Empresarial" },
      { id: 10, name: "Sólo Incendio" },
    ];

    order.types_myt = [
      { id: 46, name: "Avión" },
      { id: 47, name: "Avioneta" },
      { id: 48, name: "Barco" },
      { id: 49, name: "Buque" },
      { id: 9, name: "Declaración" },
      { id: 50, name: "Dron" },
      { id: 51, name: "Embarcación de Placer" },
      { id: 7, name: "Específica" },
      { id: 52, name: "Helicóptero" },
      { id: 35, name: "Otro" },
      { id: 8, name: "Pronóstico" },
    ];

    order.types_ayc = [
      { id: 11, name: "Animales" },
      { id: 12, name: "Cultivo" },
    ];
    order.types_credito = [{ id: 13, name: "Crédito general" }];
    order.types_vivienda = [{ id: 14, name: "Crédito a la Vivienda" }];
    order.types_garantia = [
      {
        id: 15,
        name: "Documentos que sean objeto de oferta pública o de intermediación en mercados de valores",
      },
      { id: 16, name: "Emisores de Valores" },
      { id: 17, name: "Títulos de Crédito" },
    ];
    order.types_rc = [
      { id: 18, name: "Administración" },
      { id: 19, name: "Arquitectos" },
      { id: 20, name: "Aviones" },
      { id: 21, name: "Barcos" },
      { id: 22, name: "Contratista" },
      { id: 23, name: "Crime" },
      { id: 24, name: "Cyber (Protección de datos)" },
      { id: 25, name: "D&O (Consejeros y Funcionarios)" },
      { id: 26, name: "E&O Miscelaneos" },
      { id: 27, name: "Empresarial" },
      { id: 28, name: "Eventos" },
      { id: 29, name: "Familiar/Condominal" },
      { id: 30, name: "Hole in One" },
      { id: 31, name: "Ingeniería" },
      { id: 32, name: "Instituciones Financieras" },
      { id: 33, name: "Lineas Financieras" },
      { id: 34, name: "Médicos" },
      { id: 35, name: "Otro" },
    ];
    order.types_tyorc = [{ id: 36, name: "Riesgos Catastróficos" }];
    order.types_diversos = [
      { id: 37, name: "Calderas y Recipientes Sujetos a Presión" },
      { id: 38, name: "Dinero y Valores" },
      { id: 39, name: "Eq. Contratistas y Maquinaria pesada" },
      { id: 40, name: "Eq. Electrónico" },
      { id: 41, name: "Montaje de Maquinaria" },
      { id: 42, name: "Obra Civil en Contrucción" },
      { id: 43, name: "Obra Civil Terminada" },
      { id: 44, name: "Rotura de Cristales" },
      { id: 45, name: "Rotura de Maquinaria" },
      { id: 35, name: "Otro" },
      { id: 63, name: "Terrorismo y Sabotaje" },
    ];
    order.types_lf = [
      { id: 53, name: "CRIME/BBB" },
      { id: 54, name: "D&O" },
      { id: 55, name: "FIPI" },
      { id: 56, name: "CYBER" },
      { id: 57, name: "VCAPS" },
      { id: 58, name: "RCP MÉDICA" },
      { id: 59, name: "E&O MISCELANEO" },
      { id: 60, name: "RIESGO POLITICO" },
      { id: 61, name: "RC SERVIDORES PUBLICOS" },
      { id: 62, name: "RCP" },
    ];
    order.procedencia = [
      { id: 1, name: "Residente" },
      { id: 2, name: "Turista" },
      { id: 3, name: "Legalizado" },
      { id: 4, name: "Fronterizo" },
    ];
    order.charge_type = [
      { id: 1, name: "A" },
      { id: 2, name: "B" },
      { id: 3, name: "C" },
    ];

    $scope.sex = [
      { name: "MASCULINO", value: "M" },
      { name: "FEMENINO", value: "F" },
    ];

    $scope.usages = [
      { id: 1, name: "PARTICULAR" },
      { id: 2, name: "CARGA" },
      { id: 3, name: "SERVICIO PÚBLICO" },
    ];

    $scope.is_edition = false;
    $scope.nenewal = true;
    $scope.newCoverPack = false;
    $scope.ceder_comision = false;

    $scope.celulas = [];
    $scope.agrupaciones = [];
    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    $scope.infoUser = $sessionStorage.infoUser;

    var stuffLoaded = 0;
    var thingsToLoad = 0;
    $scope.reload = false;
    $scope.dateOut = false;
    $scope.referenciadores = [];
    $scope.lecturaPDF = function () {
      $scope.es_renovacion = true;
    };
    $scope.addReferenciador = function (type) {
      var addReferenciadores = {
        referenciador: $scope.referenciador,
      };
      $scope.referenciadores.push(addReferenciadores);
    };
    $scope.changeReferenciador = function (ref) {
      if (ref) {
        if (ref.data) {
          if (ref.data.url != ref.referenciador) {
            $http.get(ref.referenciador).then(function success(c) {
              var subBranchsComisions =
                c.data.user_info.info_vendedor[0].vendedor_subramos;
              subBranchsComisions.forEach(function (sr) {
                if (
                  (sr.subramo == order.form.subramo.subramo_code &&
                    sr.provider == order.form.aseguradora.id) ||
                  (sr.subramo == 0 && sr.provider == 0)
                ) {
                  ref.comision_vendedor = sr.comision;
                } else {
                  ref.comision_vendedor = 0;
                }
              });
            });
          }
          if (ref.data.url == ref.referenciador) {
            $http.get(ref.referenciador).then(function success(c) {
              var subBranchsComisions =
                c.data.user_info.info_vendedor[0].vendedor_subramos;
              subBranchsComisions.forEach(function (sr) {
                if (
                  (sr.subramo == order.form.subramo.subramo_code &&
                    sr.provider == order.form.aseguradora.id) ||
                  (sr.subramo == 0 && sr.provider == 0)
                ) {
                  ref.comision_vendedor = sr.comision;
                } else {
                  ref.comision_vendedor = ref.data.comision_policy;
                }
              });
            });
          }
        }
      }
      if (ref.referenciador) {
        ref.selectedRef = true;
      } else {
        ref.selectedRef = false;
      }
    };
    $scope.changeComRef = function (com) {
      if (com.comision_vendedor > 100) {
        com.comision_vendedor = 0;
      } else if (com.comision_vendedor < 0) {
        com.comision_vendedor = 0;
      }
      $scope.checkTotalComision(com);
    };
    $scope.checkTotalComision = function (item) {
      var totalComision = $scope.referenciadores.reduce(function (sum, item) {
        return sum + (parseFloat(item.comision_vendedor) || 0); // Convert to number, default to 0 if undefined
      }, 0);
      if (totalComision > 100) {
        $scope.comisionError =
          "La suma de las comisiones no puede superar el 100%";
        item.comision_vendedor = 0;
      } else {
        $scope.comisionError = null; // No error if total is within limit
      }
    };
    $scope.deleteReferenciador = function (index, ref) {
      SweetAlert.swal(
        {
          title: "¿Estás seguro?",
          text: "Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
            if (index && ref.url) {
              // if(ref.url){
              //   $http.delete(ref.url);
              // }
              $scope.referenciadores.splice(index, 1);
            } else {
              // if(ref.url){
              //   $http.delete(ref.url);
              // }
              $scope.referenciadores.splice(index, 1);
            }
          }
        }
      );
    };

    $scope.checkDateValues = function (values) {
      var date1 = datesFactory.toDate(order.form.startDate);
      var date2 = datesFactory.toDate(values);
      $scope.dateOut = false;
      if (date1 > date2) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        $scope.dateOut = true;
        return;
      } else {
        $scope.dateOut = false;
      }
    };

    var storedPolicy = $stateParams.myInsurance;
    if (!storedPolicy || storedPolicy === "some default") {
      storedPolicy = getRenewalDraft();
    }
    $scope.poliza_data = storedPolicy || {};

    if ($scope.poliza_data && $scope.poliza_data.id) {
      $http({
        method: "GET",
        url: url.IP + "historic-policies/",
        params: {
          actual_id: $scope.poliza_data.id,
        },
      }).then(function success(response) {
        if (response.data.results.length) {
          vm.showHistoric = true;
        }
        vm.policy_history = [];
        vm.policy_history.renovada = [];
        response.data.results.forEach(function function_name(old) {
          if ($scope.poliza_data.id != old.base_policy.id) {
            vm.policy_history.push(old.base_policy);
          } else if (old.new_policy) {
            vm.policy_history.push(old.new_policy);
          }
          if ($scope.poliza_data.id == old.base_policy.id) {
            vm.policy_history.renovada.push(old.base_policy);
          }
        });
        vm.policy_history.forEach(function (old) {
          if (old.status == 1) {
            SweetAlert.swal(
              "Información",
              "La póliza ya tiene una OT de renovación",
              "info"
            );
            if ($scope.poliza_data.document_type == 1) {
              //$state.go('polizas.info', {polizaId: $scope.poliza_data.id})
              gopolicieinfo($scope.idPolicy, $scope.poliza_data);
            } else if ($scope.poliza_data.document_type == 3) {
              $state.go("colectividades.info", {
                polizaId: $scope.poliza_data.id,
              });
            }
          }
        });
        vm.policy_history.renovada.forEach(function (renovada) {
          if (renovada.status == 12) {
            SweetAlert.swal(
              "Información",
              "La póliza ya ha sido renovada",
              "info"
            );
            if ($scope.poliza_data.document_type == 1) {
              //$state.go('polizas.info', {polizaId: $scope.poliza_data.id})
              gopolicieinfo($scope.idPolicy, $scope.poliza_data);
            } else if ($scope.poliza_data.document_type == 3) {
              $state.go("colectividades.info", {
                polizaId: $scope.poliza_data.id,
              });
            }
          }
        });
      });
    }
    // -------------
    $scope.show_receipts = true;
    var myInsurance = null;
    // $scope.poliza_data = null;
    order.insuranceObject = {};
    order.user = usr;
    order.show = {
      ot: false,
      receipt: false,
      generateReceipts: false,
      receiptsGenerated: false,
      firstTab: true,
      showForms: false,
      showCoverages: false,
      isPolicy: false,
    };

    var vm = ($scope.vm = {
      files: [],
    });

    order.disabled = {
      startDate: false,
    };

    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    order.form = {
      canCreate: false,
      contratante: {},
      poliza: "",
      internal_number: "",
      folio: "",
      ramo: "",
      type: "",
      subramo: "",
      aseguradora: "",
      paquete: "",
      ceder_comision: false,
      payment: "",
      startDate: new Date(),
      endingDate: new Date().setYear(new Date().getFullYear() + 1),
      vendor: "",
      domiciliado: false,
      business_line: 0,
    };

    order.subforms = {
      auto: {},
      life: {
        beneficiariesList: [],
        aseguradosList: [],
      },
      disease: {
        relationshipList: [],
      },
      damage: {
        coinsurance: "",
        insured_item: "",
        item_address: "",
        item_details: "",
      },
    };

    var renovationDraft = {};

    function resetRenovationDraft() {
      renovationDraft = {};
    }

    function hasRenovationDraft() {
      return renovationDraft && Object.keys(renovationDraft).length > 0;
    }

    function ensureRenovationDraft() {
      if (!hasRenovationDraft()) {
        renovationDraft = angular.copy(order.form) || {};
      }
      return renovationDraft;
    }

    order.defaults = {
      sex: angular.copy(sex),
      years: [],
      policyUrl: {},
      contractors: [],
      providers: [],
      ramos: [],
      subramos: [],
      packages: [],
      coverages: [],
      formInfo: {},
      coverageInPackage: {},
      payform: angular.copy(formaPago),
      getContractorsByGroup: function () {},
    };

    order.autocomplete = autocomplete;
    order.ceder_comision = ceder_comision;
    order.getInternalNumber = getInternalNumber;
    // Crear paquetes
    $scope.createPackRen = true;
    $scope.changeComision = function (event, backspace) {
      var len_value = String(order.form.give_comision).length;
      var value = parseFloat(order.form.give_comision);

      if (value > 100) {
        order.form.give_comision = 100;
      }
    };

    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = 0;
      var word_data = order.form.contratante.val;
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;

                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    function getmatches(word) {
      $http
        .post(url.IP + "cars-match/", { matchWord: word })
        .then(function (response) {
          var source = [];
          response.data.forEach(function (cars) {
            var obj = {
              label: cars.car_search,
              value: cars,
            };
            source.push(obj);
          });
          $scope.autocompleteCarsData = source;
        });
    }

    function autocomplete(param) {
      try {
        if (param.val.length > 1) {
          getmatches(param.val);
        }
      } catch (e) {}
    }

    /* Watchs */
    $scope.$watch(
      "order.subforms.auto.selectedCar.val",
      function (newValue, oldValue) {
        try {
          order.subforms.auto.brand =
            order.subforms.auto.selectedCar.val.value.car_brand;
          order.subforms.auto.model =
            order.subforms.auto.selectedCar.val.value.car_model;
          order.subforms.auto.version =
            order.subforms.auto.selectedCar.val.value.short_description.replace(
              order.subforms.auto.selectedCar.val.value.car_model,
              ""
            );
        } catch (e) {}
      }
    );

    $scope.$watch("order.form.subramo", function (newValue, oldValue) {
      if (order.form.subramo) {
        get_claves();

        try {
          if (
            parseFloat(order.form.comision_percent) !=
              parseFloat(order.form.clave.comission) ||
            parseFloat(order.form.udi) != parseFloat(order.form.clave.udi)
          ) {
            order.form.ceder_comision = true;
            ceder_comision(false);
          }
        } catch (e) {
          if (
            order.form.comision_percent != order.form.clave.comission ||
            order.form.udi != order.form.clave.udi
          ) {
            order.form.ceder_comision = true;
            ceder_comision(false);
          }
        }
      }
    });

    $scope.$watch(
      "order.form.contratante.value",
      function (newValue, oldValue) {
        if (order.form.contratante.value) {
          if (
            order.form.contratante.value &&
            order.form.contratante.value.address_contractor
          ) {
            order.defaults.address =
              order.form.contratante.value.address_contractor;
          }
          if (
            order.form.contratante.value &&
            order.form.contratante.value.value &&
            order.form.contratante.value.value.address_contractor
          ) {
            order.defaults.address =
              order.form.contratante.value.value.address_contractor;
          }
          if (order.form.contratante.value.phone_number) {
            order.form.contratante.phone_number =
              order.form.contratante.value.phone_number;
          }

          try {
            if (order.defaults.address.length == 1) {
              order.form.address = order.defaults.address[0];
            }
          } catch (err) {}

          if (order.form.contratante.value.email) {
            order.form.contratante.email = order.form.contratante.value.email;
          }
        }
      }
    );

    $scope.$watch("order.defaults.coverages", function (newValue, oldValue) {
      newValue.forEach(function (coverage) {
        coverage.deductible_coverage_parsed = [];
        coverage.sums_coverage_parsed = [];
        coverage.policy = order.insuranceObject.id;
        if (coverage.deductible_coverage) {
          coverage.deductible_coverage.forEach(function (deductible) {
            var obj = {
              label: deductible.deductible,
              value: deductible.deductible,
            };
            coverage.deductible_coverage_parsed.push(obj);
          });
        }
        if (coverage.sums_coverage) {
          coverage.sums_coverage.forEach(function (suma) {
            var obj = {
              label: suma.sum_insured,
              value: suma.sum_insured,
            };
            coverage.sums_coverage_parsed.push(obj);
          });
        }
      });
    });

    $scope.percentageRange = function (input, index) {
      if (input < 0) {
        order.defaults.coverages[index].coinsuranceInPolicy.value = 0;
      }
      if (input > 100) {
        order.defaults.coverages[index].coinsuranceInPolicy.value = 100;
      }
    };

    /* Funciones */
    order.options = {
      checkDate: function (param) {
        if (param) {
          if (order.form.startDate == "Invalid Date") {
            if (myInsurance) {
              order.form.startDate = myInsurance.start_of_validity;
            } else {
              order.form.startDate = convertDate(new Date());
            }
          }
          var date = new Date(order.form.startDate);
          var curr_date = date.getDate();
          var curr_month = date.getMonth() + 1; //Months are zero based
          var curr_year = date.getFullYear();
          var d = curr_year + "-" + curr_month + "-" + curr_date;
          var init_format = curr_month + "/" + curr_date + "/" + curr_year;

          date = new Date(init_format);
          if (d != "Invalid Date" && d != "NaN-NaN-NaN") {
            providerService.getProviderByKey(d).then(
              function success(data) {
                order.defaults.providers = data.data;
              },
              function error(err) {
                console.log("error", err);
              }
            );
          }

          order.form.endingDate = new Date(
            date.setYear(date.getFullYear() + 1)
          );
          if (order.form.aseguradora) {
            get_claves();
          }

          order.form.startDate = new Date(init_format);
          order.form.endingDate = convertDate(order.form.endingDate);
          order.form.start_of_validity = new Date(init_format);
          order.form.end_of_validity = new Date(
            mesDiaAnio(order.form.endingDate)
          );
          order.form.startDate = convertDate(order.form.startDate);
        } else {
          if (order.form.startDate.length == 10) {
            var x = mesDiaAnio(order.form.startDate);
            var date = new Date(x);

            var curr_date = date.getDate();
            var curr_month = date.getMonth() + 1; //Months are zero based
            var curr_year = date.getFullYear();
            var d = curr_year + "-" + curr_month + "-" + curr_date;
            providerService
              .getProviderByKey(d)
              .then(
                function success(data) {
                  order.defaults.providers = data.data;
                },
                function error(err) {
                  console.log("error", err);
                }
              )
              .catch(function (e) {
                console.log("e", e);
              });

            order.form.endingDate = new Date(
              date.setYear(date.getFullYear() + 1)
            );
            if (order.form.aseguradora) {
              get_claves();
            }

            order.form.startDate = new Date(x);
            order.form.endingDate = convertDate(order.form.endingDate);
            order.form.start_of_validity = new Date(x);
            order.form.end_of_validity = new Date(
              mesDiaAnio(order.form.endingDate)
            );

            order.form.startDate = convertDate(order.form.startDate);
          }
        }

        if (
          order.form.startDate == "Invalid Date" ||
          order.form.startDate == "NaN-NaN-NaN" ||
          order.form.startDate == "NaN/NaN/NaN"
        ) {
          if (myInsurance && order.form.start_of_validity) {
            order.form.startDate = convertDate(order.form.start_of_validity);
          } else {
            order.form.startDate = convertDate(new Date());
          }
        } else {
        }
        if (
          order.form.endingDate == "Invalid Date" ||
          order.form.endingDate == "NaN-NaN-NaN" ||
          order.form.endingDate == "NaN/NaN/NaN"
        ) {
          if (myInsurance && order.form.end_of_validity) {
            order.form.endingDate = convertDate(order.form.end_of_validity);
          } else {
            order.form.endingDate = convertDate(new Date());
          }
        } else {
        }
        $scope.calcularDias();
      },
      showPoliceCreator: function () {
        if (order.defaults.showReceipts === false) {
          return true;
        }
        return false;
      },
      hideTabs: function (param) {
        order.show.firstTab = param ? true : false;
        var total = 0.0;
        var subtotal = 0.0;
        order.receipts.forEach(function (elem) {
          primaNeta += parseFloat(elem.prima);
          derecho += parseFloat(elem.derecho);
          rpf += parseFloat(elem.rpf);
          total += parseFloat(elem.total);
          subtotal += parseFloat(elem.subTotal);
        });
        order.poliza.primaNeta = primaNeta;
        order.poliza.derecho = derecho.toFixed(3);
        order.poliza.rpf = rpf.toFixed(3);
        order.poliza.primaTotal = total;
        order.poliza.subTotal = subtotal;
      },
      changeProvider: function (obj) {
        order.form.aseguradora = obj;
        if (obj) {
          get_claves();
          var wait = [];
          wait.push(
            $http.get(url.IP + "ramos-by-provider/" + order.form.aseguradora.id)
          );
          $q.all(wait).then(function (response) {
            order.defaults.ramos = response[0].data;
            if ($scope.ramo_code) {
              order.defaults.ramos.forEach(function (item) {
                if (item.ramo_code == $scope.ramo_code) {
                  order.form.ramo = item;
                  item.subramo_ramo.forEach(function (subr) {
                    if ($scope.subramo_code) {
                      if (subr.subramo_code == $scope.subramo_code) {
                        order.defaults.subramos = item.subramo_ramo;
                        order.form.subramo = subr;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };
                        order.show.showForms = true;
                        $http
                          .post(url.IP + "paquetes-data-by-subramo/", {
                            ramo: order.form.ramo.id,
                            subramo: order.form.subramo.id,
                            provider: order.form.aseguradora.id,
                          })
                          .then(function (paquetes) {
                            order.defaults.packages = paquetes.data;
                          });
                      }
                    }
                  });
                }
              });
            }
          });
        } else {
          order.defaults.ramos = [];
        }
        order.options.changeRamo(undefined);
      },
      changeClave: function (parClave) {
        order.defaults.comisiones = [];
        console.log("order.defaults.111", parClave);
        order.form.clave = parClave;
        get_claves();
      },
      changeRamo: function (obj) {
        order.form.ramo = obj;
        if (obj) {
          order.defaults.subramos = obj.subramo_ramo;
        } else {
          order.form.ramo = "";
          order.defaults.subramos = [];
        }
        order.options.changeSubramo(undefined);
      },
      changeSubramo: function (obj) {
        order.form.subramo = obj;
        if (obj) {
          if (
            order &&
            order.form &&
            order.form.ramo &&
            order.form.ramo.ramo_code &&
            order.form.ramo.ramo_code == 2
          ) {
            order.subforms.disease.policy_type = 46;
          }
          order.defaults.forms = obj.forms_subramo;
          order.defaults.waitElement = [];
          order.defaults.waitElement.push(
            $http
              .post(url.IP + "paquetes-data-by-subramo/", {
                ramo: order.form.ramo.id,
                subramo: obj.id,
                provider: order.form.aseguradora.id,
              })
              .then(function (paquetes) {
                order.defaults.packages = paquetes.data;
              })
          );
          order.show.showForms = true;
          order.defaults.formInfo = {
            code: obj.subramo_code,
            name: obj.subramo_name,
          };
        } else {
          order.defaults.forms = undefined;
          order.defaults.packages = [];
          order.show.showForms = false;
          order.defaults.formInfo = {
            code: undefined,
            name: undefined,
          };
        }
        order.options.changePackage(undefined);
      },
      changePackage: function (obj) {
        order.form.paquete = obj;
        $scope.newCoverPack = true;
        if (obj) {
          order.defaults.coverages = [];
          order.defaults.coverageList = [];

          obj.coverage_package.forEach(function (element, index) {
            if (element.default) {
              order.defaults.coverages.push(angular.copy(element));
            } else {
            }
            order.defaults.coverageList.push(angular.copy(element));
          });
          order.show.showCoverages = true;
        } else {
          order.defaults.coverages = [];
          order.show.showCoverages = false;
        }
      },
      isReceiptAvailable: function (payment) {
        order.form.payment = payment;
        order.receipts = [];
        if (payment && order.form.poliza) {
          toaster.success("Ya puede generar sus recibos");
        }
      },
      deleteCoverage: function (obj, index) {
        if (usr.permiso.eliminar) {
          order.defaults.coverages.splice(index, 1);
          var cl = order.defaults.coverageList;
          var flag = false;

          for (var i = 0; i < cl.length; i++) {
            if (cl[i].id === obj.id) {
              flag = true;
            }
          }
          if (!flag) {
            order.defaults.coverageList.push(obj);
          }
        } else {
          SweetAlert.swal(
            "Oops...",
            "No tienes permiso para eliminar registros",
            "error"
          );
        }
      },
      addCoverage: function (obj) {
        var dfd = $q.defer();
        var delCoverage = order.defaults.coverages.length > 0 ? false : true;
        var wait = [];
        wait.push($http.get(obj.url));
        $q.all(wait).then(function (coverage) {
          coverage.forEach(function (cvg) {
            dfd.resolve(cvg);
            var cvgCopy = cvg.data;

            if (cvgCopy.id == obj.id) {
              if (!cvgCopy.coinsuranceInPolicy && obj.coinsuranceInPolicy) {
                var coaseguro_ = obj.coinsuranceInPolicy;

                if (coaseguro_.search("{") >= 0) {
                  var json = JSON.stringify(eval("(" + coaseguro_ + ")"));
                  var test = JSON.parse(json);

                  cvgCopy.coinsuranceInPolicy = {
                    value: test.value,
                  };

                  obj.coinsuranceInPolicy = {
                    value: test.value,
                  };
                } else {
                  obj.coinsuranceInPolicy = {
                    value: parseInt(coaseguro_),
                  };

                  obj.coinsuranceInPolicy = {
                    value: parseInt(coaseguro_),
                  };
                }
              } else if (
                cvgCopy.coinsuranceInPolicy &&
                obj.coinsuranceInPolicy
              ) {
              }

              // ---------
              if (
                !cvgCopy.topeCoinsuranceInPolicy &&
                obj.topeCoinsuranceInPolicy
              ) {
                var topecoaseguro_ = obj.topeCoinsuranceInPolicy;

                if (topecoaseguro_.search("{") >= 0) {
                  var json = JSON.stringify(eval("(" + topecoaseguro_ + ")"));
                  var test = JSON.parse(json);

                  cvgCopy.topeCoinsuranceInPolicy = {
                    value: test.value,
                  };

                  obj.topeCoinsuranceInPolicy = {
                    value: test.value,
                  };
                } else {
                  obj.topeCoinsuranceInPolicy = {
                    value: topecoaseguro_,
                  };

                  obj.topeCoinsuranceInPolicy = {
                    value: topecoaseguro_,
                  };
                }
              } else if (
                cvgCopy.topeCoinsuranceInPolicy &&
                obj.topeCoinsuranceInPolicy
              ) {
              }
            }

            for (var i = order.defaults.coverages.length - 1; i >= 0; i--) {
              if (
                order.defaults.coverages[i].coverage_name === obj.coverage_name
              ) {
                order.defaults.coverageList.forEach(function (coverage) {
                  if (coverage.coverage_name == obj.coverage_name) {
                    order.defaults.coverageList.splice(
                      order.defaults.coverageList.indexOf(coverage),
                      1
                    );
                  }
                });
                delCoverage = false;
                break;
              } else {
                delCoverage = true;
              }
            }
            if (delCoverage) {
              order.defaults.coverages.push(obj);
              order.defaults.coverageList.forEach(function (coverage) {
                if (coverage.coverage_name == obj.coverage_name) {
                  order.defaults.coverageList.splice(
                    order.defaults.coverageList.indexOf(coverage),
                    1
                  );
                }
              });

              cvgCopy.deductible_coverage_parsed = [];
              cvgCopy.sums_coverage_parsed = [];

              try {
                cvgCopy.deductible_coverage.forEach(function (deductible) {
                  var obj = {
                    label: deductible.deductible,
                    value: deductible.deductible,
                  };
                  cvgCopy.deductible_coverage_parsed.push(obj);
                });

                cvgCopy.sums_coverage.forEach(function (suma) {
                  var obj = {
                    label: suma.sum_insured,
                    value: suma.sum_insured,
                  };
                  cvgCopy.sums_coverage_parsed.push(obj);
                });
              } catch (e) {}
            }

            order.defaults.coverageInPackage = "";
            return dfd.promise;
          });
        });
      },
      life: {
        beneficiary: {
          add: function (beneficiary) {
            // var beneficiary = {
            //   person: 1
            // };
            if (beneficiary) {
              order.subforms.life.beneficiariesList.push(beneficiary);
            } else {
              order.subforms.life.beneficiariesList.push(models.beneficiary());
            }
          },
          // add: function() {
          // var beneficiary = angular.copy(order.subforms.life.beneficiaries);
          // if (helpers.beneficiariesPercentageGreaterThanZero(order.subforms.life.beneficiariesList)) {
          //     SweetAlert.swal("Error", MESSAGES.ERROR.GREATERTHAN100, "error")
          //     // toaster.info('No puede tener un porcentaje mayor a 100%.');
          //     return
          // } else {
          //     order.subforms.life.beneficiariesList.push(models.beneficiary());
          // }
          // },
          destroy: function (index) {
            order.subforms.life.beneficiariesList.splice(index, 1);
          },
        },
        asegurados: {
          add: function (asegs) {
            if (asegs) {
              order.subforms.life.aseguradosList.push(asegs);
            } else {
              order.subforms.life.aseguradosList.push(models.asegurados());
            }
          },
          destroy: function (index) {
            order.subforms.life.aseguradosList.splice(index, 1);
          },
        },
      },
      disease: {
        relationships: {
          add: function (relacion) {
            if (relacion) {
              order.options.disease.relationships.selectType(
                relacion.relationship,
                null
              );
              order.subforms.disease.relationshipList.push(relacion);
            } else {
              var relacion = {
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: null,
                antiguedad: null,
                sex: null,
                relationship: null,
                accident: null,
              };
              order.subforms.disease.relationshipList.push(relacion);
            }
          },
          destroy: function (index, rel) {
            order.subforms.disease.relationshipList.splice(index, 1);
          },
          selectType: function (newValue, old) {
            var oldValue = old != "" ? JSON.parse(old) : null;
            var newIndex = -1;

            order.options.disease.types.some(function (valueData, index) {
              if (valueData.relationship == newValue.relationship) {
                newIndex = index;
                return true;
              }
            });
            var oldIndex = -1;

            if (newValue.relationship == 1 || newValue.relationship == 2) {
              // titular y conyugue
              order.options.disease.types[newIndex].disabled = true;
            }

            if (oldValue) {
              order.options.disease.types.some(function (val, index) {
                if (val.relationship == oldValue.relationship) {
                  oldIndex = index;
                  return true;
                }
              });

              if (oldValue.relationship == 1 || oldValue.relationship == 2) {
                // titular y conyugue
                order.options.disease.types[oldIndex].disabled = false;
              }
            }
          },
        },
        /* 1-Titular, 2-Conyuge, 3-Hijo */
        types: angular.copy(tiposBeneficiarios),
      },
    };

    /* Vendedores */
    $scope.changeVendedor = function (vendedor) {
      $scope.users.some(function (user) {
        if (vendedor.id == user.id) {
          var vendedor_info = user.user_info.info_vendedor[0];
          if (vendedor_info.vendedor_subramos.length == 0) {
            SweetAlert.swal(
              "Error",
              "El vendedor no tiene comisión en el subramo actual",
              "error"
            );
            order.form.vendor = $scope.original_vendor;
            return;
          }

          var flag = false;
          var vendedor_flag = false;

          vendedor_info.vendedor_subramos.some(function (subramo, sub_index) {
            if (
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == order.form.ramo.id &&
                subramo.subramo == order.form.subramo.id) ||
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == order.form.ramo.id &&
                subramo.subramo == 0) ||
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == 0 &&
                subramo.subramo == 0) ||
              (subramo.provider == 0 &&
                subramo.ramo == 0 &&
                subramo.subramo == 0) ||
              (subramo.provider == 0 &&
                subramo.ramo * -1 == order.form.ramo.ramo_code &&
                subramo.subramo * -1 == order.form.subramo.subramo_code)
            ) {
              vendedor_flag = true;
            }

            if (vendedor_info.vendedor_subramos.length == sub_index + 1) {
              if (!vendedor_flag) {
                SweetAlert.swal(
                  "Error",
                  "El vendedor no tiene comisión en el subramo actual",
                  "error"
                );
                order.form.vendor = $scope.original_vendor;
                return;
              }
            }
          });
        }
      });
    };
    // Nuevo paquete
    $scope.addNewPackage = function () {
      $scope.show_new_pack = true;
      $scope.create_pack = true;
      $scope.show_new_sub = false;
    };
    $scope.savePackage = function (parObj) {
      parObj.provider = order.form.aseguradora.url;
      parObj.ramo = order.form.ramo.url;
      parObj.subramo = order.form.subramo.url;
      parObj.type_package = 1; // paquete normal
      parObj.coverage_package = [];

      packageService
        .createPackage(parObj)
        .then(
          function success(request) {
            if (request.id) {
              order.defaults.packages.push(request);
              $scope.create_pack = false;
              $scope.add_coverages = true;
              $scope.package_created = request;
            }
          },
          function error(error) {
            console.log("error - createPackage", error);
          }
        )
        .catch(function (e) {
          console.log("error -createPackage- catch", e);
        });
    };
    $scope.coverages = [];
    $scope.saveCoverage = function (parName, sum_insured, deductible) {
      var obj = {
        coverage_name: parName,
        // priority: priority ? priority : 0,
        provider: order.form.aseguradora.url,
        package: $scope.package_created.url,
        deductible: [],
        sums_coverage: [],
      };
      coverageService
        .createCoverage(obj)
        .then(
          function success(request) {
            $http({
              method: "POST",
              url: url.IP + "sumas-aseguradas/",
              data: {
                coverage_sum: request.url,
                sum_insured: sum_insured,
                default: true,
              },
            });
            $http({
              method: "POST",
              url: url.IP + "deducibles/",
              data: {
                coverage_deductible: request.url,
                deductible: deductible,
                default: true,
              },
            });

            if (request.id) {
              $scope.coverages.push(request);
              $scope.coverageName = "";
              parName = "";

              order.defaults.packages.forEach(function (item) {
                if (item.id == $scope.package_created.id) {
                  if (item.coverage_package) {
                    item.coverage_package.push(request);
                  } else {
                    item.coverage_package = [];
                    item.coverage_package.push(request);
                  }
                }
              });
            }
          },
          function error(error) {
            console.log("error - createCoverage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createCoverage - catch", e);
        });
    };

    $scope.finishCoverages = function () {
      $scope.create_pack = false;
      $scope.add_coverages = false;
      $scope.show_new_pack = false;
      $scope.coverages = [];
      // order.options.changePackage($scope.package_created);
      // order.options.changeSubramo.changeSubramo();
    };
    // Fin nuevo paquete
    /* Fechas para la nueva póliza */

    order.form.startDate = new Date($stateParams.myInsurance.end_of_validity);
    order.form.startDate = new Date(
      order.form.startDate.getTime() +
        order.form.startDate.getTimezoneOffset() * 60000
    );

    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 1; i >= oldYear; i--) {
      order.defaults.years.push(i);
    }

    function validate2() {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      // l.start();
      var flag = true;
      if (order.receipts.length == 0) {
        flag = false;
        l.stop();
        toaster.warning(MESSAGES.ERROR.RECEIPTSREQUIRED);
      }
      if (order.form.poliza == "" || order.form.poliza == null) {
        flag = false;
        l.stop();
        toaster.warning(MESSAGES.ERROR.POLICYNOREQUIRED);
      }
      return flag;
    }

    function checkPromise(obj) {
      return obj;
    }

    function get_claves() {
      $http
        .get(url.IP + "claves-by-provider/" + order.form.aseguradora.id)
        .then(function (clavesResponse) {
          clavesResponse.data.forEach(function (clave) {
            clave.clave_comision.forEach(function (item) {
              item.efective_date = new Date(item.efective_date)
                .toISOString()
                .split("T")[0];
              if (order.form.subramo) {
                if (item.subramo == order.form.subramo.subramo_name) {
                  order.form.comision_percent = parseFloat(item.comission);
                  order.form.udi = parseFloat(item.udi);
                }
              } else {
                order.form.comision_percent = 0;
                order.form.udi = 0;
              }
            });
          });

          order.defaults.claves = clavesResponse.data;
          if (order.defaults.claves.length == 1) {
            order.form.clave = order.defaults.claves[0];
          }

          $scope.comisiones_poliza = [];
          for (var i = 0; i < order.defaults.claves.length; i++) {
            if (order.form.clave.name == order.defaults.claves[i].name) {
              $scope.clave_poliza = order.defaults.claves[i];
            }
          }
          for (var i = 0; i < $scope.clave_poliza.clave_comision.length; i++) {
            try {
              if (
                order.form &&
                order.form.subramo &&
                order.form.subramo.subramo_name &&
                order.form.subramo.subramo_name.toLowerCase() ==
                  $scope.clave_poliza.clave_comision[i].subramo.toLowerCase()
              ) {
                $scope.comisiones_poliza.push(
                  $scope.clave_poliza.clave_comision[i]
                );
              }
            } catch (e) {
              console.log("oooooo", e);
            }
          }
          if (
            $scope.comisiones_poliza &&
            $scope.comisiones_poliza.length != 0
          ) {
            order.form.comisiones = $scope.comisiones_poliza;
          } else {
            order.form.comisiones = $scope.clave_poliza.clave_comision;
          }
        });
    }

    function blankName(name) {
      if (name === undefined || name === "" || name === null) {
        return "";
      } else {
        return name;
      }
    }

    $scope.checkValue = function (argument) {
      if (argument) {
        if (parseFloat(argument) < 0) {
          order.form.comision_percent = 0;
        } else if (parseFloat(argument) > 100) {
          order.form.comision_percent = 100;
        } else {
          order.form.comision_percent = parseFloat(
            order.form.comision_percent.toFixed(2)
          );
        }
      }
    };

    $scope.checkDecimal = function (argument) {
      if (argument) {
        if (parseFloat(argument) < 0) {
          order.form.udi = 0;
        } else if (parseFloat(argument) > 100) {
          order.form.udi = 100;
        } else {
          order.form.udi = parseFloat(order.form.udi.toFixed(2));
        }
      }
    };

    $scope.changeAgrupacion = function (data) {
      $scope.sub_asignaciones = data.subgrupos;
      $scope.sub_subasignaciones = [];
      if ($scope.info_sub.subgrouping_level) {
        $http
          .get(url.IP + "groupinglevel/" + $scope.info_sub.subgrouping_level.id)
          .then(function (response) {
            order.form.subgrouping = response.data;
            $scope.sub_asignaciones.forEach(function (item) {
              if (item.id == order.form.subgrouping.id) {
                $scope.changeSubagrupacion(item);
              }
            });
          });
      }
    };

    $scope.changeSubagrupacion = function (data) {
      if (data.subsubgrupos) {
        $scope.sub_subasignaciones = data.subsubgrupos;
        if ($scope.info_sub.subsubgrouping_level) {
          $http
            .get(
              url.IP +
                "groupinglevel/" +
                $scope.info_sub.subsubgrouping_level.id
            )
            .then(function (response) {
              order.form.subsubgrouping = response.data;
            });
        }
      }
    };

    //------------------------------
    $scope.newCoverages = function () {
      $scope.addNewCoverages = true;
    };
    $scope.finishNewCoverages = function () {
      $scope.addNewCoverages = false;
    };
    $scope.saveNewCoverage = function (parName, priority, parPackage) {
      $scope.ded = false;
      $scope.sum = false;
      if (parPackage) {
        var paqueteData = parPackage;
      } else {
        var paqueteData = $scope.packageCreated;
      }
      if (!parName || parName == undefined) {
        SweetAlert.swal(
          "Campo requerido",
          "Debe agregar un Nombre de Cobertura",
          "error"
        );
        return;
      }
      var obj = {
        coverage_name: parName,
        priority: priority ? priority : 0,
        provider: order.form.aseguradora.url,
        package: order.form.paquete.url,
        deductible: [],
        sums_coverage: [],
        coinsurance_coverage: [],
        topecoinsurance_coverage: [],
      };
      $scope.coverages = [];
      coverageService
        .createCoverage(obj)
        .then(
          function success(request) {
            $scope.coverages.push(request);
            order.defaults.coverages.push(request);
            $scope.coverageName = null;

            order.defaults.packages.forEach(function (item) {
              if (item.id == order.form.paquete.id) {
                if (item.coverage_package) {
                  item.coverage_package.push(request);
                } else {
                  item.coverage_package = [];
                  item.coverage_package.push(request);
                }
              }
            });
          },
          function error(error) {
            console.log("error - createCoverage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createCoverage - catch", e);
        });
    };
    // ----------------
    function getInternalNumber() {
      $http({
        method: "POST",
        url: url.IP + "internal-number/",
      })
        .then(
          function success(request) {
            if (request.status === 200 || request.status === 201) {
              $scope.internal_number = "OT000" + request.data.id;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }
    function isString(x) {
      return Object.prototype.toString.call(x) === "[object String]";
    }
    $scope.yaTermino = false;
    order.save = {
      /* Guardar como OT */
      saveChangesInOt: function () {
        var l_ot = Ladda.create(document.querySelector(".ladda-buttonOT"));
        l_ot.start();
        if (order.acceso_obl_ref) {
          $scope.referenciadores_copy = $scope.referenciadores.filter(function (
            item
          ) {
            return item && item.referenciador && isString(item.referenciador);
          });
          if (order.acceso_obl_ref) {
            if (
              ($scope.referenciadores && $scope.referenciadores.length == 0) ||
              ($scope.referenciadores_copy &&
                $scope.referenciadores_copy.length == 0)
            ) {
              SweetAlert.swal(
                "Error",
                "Seleccione al menos un referenciador.",
                "error"
              );
              l_ot.stop();
              return;
            }
          }
        }
        if (!order.form.ramo) {
          if (!order.form.ramo.url) {
            l_ot.stop();
            SweetAlert.swal("Oops...", MESSAGES.ERROR.RAMOREQUIRED, "error");
            return;
          }
        }
        $scope.referenciadores_copy = $scope.referenciadores.filter(function (
          item
        ) {
          return item && item.referenciador && isString(item.referenciador);
        });
        if (order.acceso_cno_pol == false) {
          if (
            ($scope.referenciadores && $scope.referenciadores.length == 0) ||
            ($scope.referenciadores_copy &&
              $scope.referenciadores_copy.length == 0)
          ) {
            SweetAlert.swal(
              "Error",
              "Seleccione al menos un referenciador.",
              "error"
            );
            l_ot.stop();
            return;
          }
        }
        if (!order.form.subramo) {
          if (!order.form.subramo.url) {
            l_ot.stop();
            SweetAlert.swal("Oops...", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
            return;
          }
        }
        if (order.form.ramo) {
          if (order.form.ramo.ramo_code == 1) {
            if (order.form.subramo.subramo_code != 30) {
              if (!order.subforms.life.aseguradosList[0].policy_type) {
                l_ot.stop();
                SweetAlert.swal("Error", "Selecciona un tipo.", "error");
                return;
              }
            }
          }
          if (order.form.ramo.ramo_code == 2) {
            if (!order.subforms.disease.policy_type) {
              l_ot.stop();
              SweetAlert.swal("Error", "Selecciona un tipo.", "error");
              return;
            }
          }
          if (order.form.ramo.ramo_code == 3) {
            if (order.form.subramo.subramo_code == 9) {
              if (!order.subforms.auto.policy_type) {
                l_ot.stop();
                SweetAlert.swal("Error", MESSAGES.ERROR.ERRORTYPEAUTO, "error");
                return;
              }
            } else {
              if (!order.subforms.damage.damage_type) {
                l_ot.stop();
                SweetAlert.swal("Error", "Selecciona un tipo.", "error");
                return;
              }
            }
          }
        }
        if (!order.form.clave) {
          if (!order.form.clave.url) {
            l_ot.stop();
            SweetAlert.swal("Oops...", MESSAGES.ERROR.CLAVE, "error");
            return;
          }
        }
        if (!order.form.contratante) {
          if (!order.form.contratante.url) {
            l_ot.stop();
            SweetAlert.swal("Oops...", MESSAGES.ERROR.CONTRACTORERROR, "error");
            return;
          }
        }
        if (!order.form.address) {
          if (!order.form.address.url) {
            l_ot.stop();
            SweetAlert.swal("Oops...", MESSAGES.ERROR.ADDRESS, "error");
            return;
          }
        }
        if (!order.form.aseguradora) {
          if (!order.form.aseguradora.url) {
            l_ot.stop();
            SweetAlert.swal(
              "Oops...",
              MESSAGES.ERROR.PROVIDERREQUIRED,
              "error"
            );
            return;
          }
        }
        if (!canBeOT()) {
          return;
        } /* Validación contratante */
        var url_mine;
        var form = angular.copy(order.form);
        var obsevaciones = order.form.observations;
        if ($scope.dateOut == true) {
          l_ot.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }
        for (var i = 0; i < order.subforms.life.aseguradosList.length; i++) {
          if (
            order.subforms.life.aseguradosList[i].birthdate == "" ||
            !order.subforms.life.aseguradosList[i].birthdate
          ) {
            SweetAlert.swal(
              "Error",
              "Agrega la fecha de nacimiento del asegurado  #" + (i + 1),
              "error"
            );
            return;
          }
        }
        if (order.receipts.length > 0) {
          SweetAlert.swal(
            {
              title: "Renovar como OT",
              text: "Guardar como OT no guardará recibos, ¿Desea continuar?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Sí",
              cancelButtonText: "No",
              closeOnConfirm: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                order.receipts = [];
                form = getFormData(form);
                form.business_line = order.form.business_line
                  ? order.form.business_line
                  : 0;
                form.celula = order.form.celula ? order.form.celula.url : "";
                form.observations = obsevaciones;
                form.status = 1;
                form.address = order.form.address.url;
                form.clave = order.form.clave.url;
                form.folio = order.form.folio;
                form.poliza = order.form.poliza;

                form.p_neta = 0;
                form.rpf = 0;
                form.derecho = 0;
                form.p_total = 0;
                form.iva = 0;
                if (order.form.responsable) {
                  form.responsable = order.form.responsable
                    ? order.form.responsable.url
                    : "";
                }
                if (order.form.collection_executive) {
                  form.collection_executive = order.form.collection_executive
                    ? order.form.collection_executive.url
                    : "";
                }

                if (order.form.sucursal) {
                  form.sucursal = order.form.sucursal
                    ? order.form.sucursal.url
                    : "";
                }

                if (order.form.ceder_comision) {
                  form.udi = order.form.udi;
                  if (order.form.comision_percent) {
                    form.comision_percent = order.form.comision_percent;
                  } else {
                    form.comision_percent = order.form.clave.comission;
                  }
                } else {
                  if (order.form.comision_percent) {
                    form.comision_percent = order.form.comision_percent;
                  } else {
                    form.comision_percent = order.form.clave.comission;
                  }
                  form.udi = order.form.clave.udi;
                }

                if (order.form.comision_percent) {
                  var percent_ = parseFloat(order.form.comision_percent) / 100;
                  order.form.comision = (order.form.p_neta * percent_).toFixed(
                    2
                  );
                } else {
                  var percent_ =
                    parseFloat(order.form.comision.comission) / 100;
                  order.form.comission = (order.form.p_neta * percent_).toFixed(
                    2
                  );
                  order.form.comision = (order.form.p_neta * percent_).toFixed(
                    2
                  );
                }

                $q.all([
                  helpers
                    .existPolicyNumber("renovaciones_modulo")
                    .then(checkPromise),
                ]).then(function (val) {
                  if (val[0] === true) {
                    SweetAlert.swal(
                      "Error",
                      "Esta número de póliza ya existe.",
                      "error"
                    );
                  } else {
                    // Dates original
                    // if(order.form.start_of_validity) {

                    //   var startDate = new Date( order.form.start_of_validity).setHours(12,0,0,0);
                    //   var endingDate = new Date( order.form.end_of_validity).setHours(11,59,59,0);
                    //   order.form.startDate = new Date(startDate);
                    //   order.form.endingDate = new Date(endingDate);

                    // } else {
                    //   var startDate = new Date(mesDiaAnio(order.form.startDate)).setHours(12,0,0,0);
                    //   var endingDate = new Date(mesDiaAnio(order.form.endingDate)).setHours(11,59,59,0);
                    //   order.form.startDate = new Date(startDate);
                    //   order.form.endingDate = new Date(endingDate);
                    // }
                    // Dates original
                    if (order.form.start_of_validity) {
                      var startDate = new Date(
                        order.form.start_of_validity
                      ).setHours(12, 0, 0, 0);
                      var endingDate = new Date(
                        order.form.end_of_validity
                      ).setHours(11, 59, 59, 0);
                      order.form.startDate_ = new Date(startDate);
                      order.form.endingDate_ = new Date(endingDate);
                    } else {
                      var startDate = new Date(
                        mesDiaAnio(order.form.startDate)
                      ).setHours(12, 0, 0, 0);
                      var endingDate = new Date(
                        mesDiaAnio(order.form.endingDate)
                      ).setHours(11, 59, 59, 0);
                      order.form.startDate_ = new Date(startDate);
                      order.form.endingDate_ = new Date(endingDate);
                    }
                    if (order.form.startDate) {
                      order.form.startDate_ = datesFactory.toDate(
                        order.form.startDate
                      );
                      order.form.endingDate_ = datesFactory.toDate(
                        order.form.endingDate
                      );
                    }
                    form.startDate = order.form.startDate_;
                    form.endingDate = order.form.endingDate_;
                    form.start_of_validity = form.startDate;
                    form.end_of_validity = form.endingDate;
                    // Dates ok
                    form.contractor = order.form.contratante.value.url;
                    form.internal_number = $scope.internal_number;
                    form.comision = form.comision.comission;
                    form.vendor = "";
                    form.state_circulation = order.form.state_circulation
                      ? order.form.state_circulation.state
                      : "";
                    form.conducto_de_pago =
                      order.conducto_de_pago.conducto_de_pago_selected;
                    // console.log('conducto_de_pago --reno..',form,order.form,order.conducto_de_pago)
                    insuranceService.createInsurance(form).then(function (res) {
                      var params = {
                        model: 1,
                        event: "POST",
                        associated_id: myInsurance.id,
                        identifier: "generó la OT para renovación.",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});

                      var params2 = {
                        model: 1,
                        event: "POST",
                        associated_id: res.id,
                        identifier:
                          "creo la OT a partir de la Póliza: " +
                          myInsurance.poliza_number,
                      };
                      dataFactory
                        .post("send-log/", params2)
                        .then(function success(response) {});
                      /*Actualización de Contratante*/
                      $scope.contractorToSave = {};

                      if (order.form.contratante.email) {
                        $scope.contractorToSave.email =
                          order.form.contratante.email;
                      } else {
                        $scope.contractorToSave.email = "";
                      }
                      if (order.form.contratante.phone_number) {
                        $scope.contractorToSave.phone_number =
                          order.form.contratante.phone_number;
                      } else {
                        $scope.contractorToSave.phone_number = "";
                      }
                      $http
                        .patch(
                          order.form.contratante.value.url,
                          $scope.contractorToSave
                        )
                        .then(function (data) {
                          if (data.status == 200 || data.status == 201) {
                            toaster.info("Contratante Actualizado");
                          }
                        });
                      // if (res.contractor){
                      //   $http.get(res.contractor)
                      //     .then(function(response) {
                      //       if(response.data.email){
                      //           //Send Email
                      //           if($localStorage.email_config){
                      //             if($localStorage.email_config.renovacion == true){
                      //               var model = 9;
                      //               emailService.sendEmailAtm(model,myInsurance.id)
                      //            }
                      //          }else{}
                      //         //Send Email
                      //       }
                      //   });
                      // }
                      // //Send Email

                      /* Actualiza la póliza antigua */
                      // Modifica *********+++
                      var data = {
                        renewed_status: 2,
                      };
                      $http
                        .patch($scope.poliza_data.url, data)
                        .then(function success(response) {});

                      /* Relación la póliza original*/
                      var oldPolicy = {
                        policy: myInsurance.poliza_number,
                        base_policy: myInsurance.url,
                        new_policy: res.url,
                      };

                      insuranceService
                        .createOldPolicy(oldPolicy)
                        .then(function (responseOldPolicy) {});
                      // varios referenciadores
                      for (var i = 0; i < $scope.referenciadores.length; i++) {
                        $scope.referenciadores[i].policy = res.url;
                        $scope.ref_policy = $scope.referenciadores[i];
                        if ($scope.ref_policy) {
                          if ($scope.referenciadores[i].referenciador) {
                            var ref = {};
                            ref.referenciador =
                              $scope.referenciadores[i].referenciador;
                            ref.comision_vendedor = $scope.referenciadores[i]
                              .comision_vendedor
                              ? $scope.referenciadores[i].comision_vendedor
                              : 0;
                            ref.policy = res.url;
                            dataFactory
                              .post("referenciadores-policy/", ref)
                              .then(
                                function success(request) {},
                                function error(error) {
                                  console.log(error);
                                }
                              )
                              .catch(function (e) {
                                console.log(e);
                              });
                          }

                          // if ($scope.referenciadores[i].url) {
                          //   $http.patch($scope.referenciadores[i].url, $scope.referenciadores[i]).then(
                          //     function success(request){
                          //     },
                          //     function error(error) {
                          //       console.log(error);
                          //     })
                          //   .catch(function(e){
                          //     console.log(e);
                          //   });
                        }
                        // }else{
                        //   $scope.ref_policy = $scope.referenciadores[i];
                        //   if($scope.ref_policy){
                        //     if ($scope.referenciadores[i].referenciador) {
                        //       var ref = {}
                        //       ref.referenciador = $scope.referenciadores[i].referenciador
                        //       ref.comision_vendedor = $scope.referenciadores[i].comision_vendedor ? $scope.referenciadores[i].comision_vendedor : 0
                        //       ref.policy = res.url
                        //       dataFactory.post('referenciadores-policy/',ref)
                        //       .then(
                        //         function success(request){
                        //           console.log('reque ref',request,ref)
                        //         },
                        //         function error(error) {
                        //           console.log(error);
                        //         })
                        //       .catch(function(e){
                        //         console.log(e);
                        //       });
                        //     }
                        //   }
                        // }
                      }
                      // varios referenciadores
                      /* Sube archivos */
                      uploadFiles(res.id);

                      order.defaults.policyUrl = res.url;
                      url_mine = res.url;

                      SweetAlert.swal("Hecho", MESSAGES.OK.NEWOT, "success");

                      /* Formulario por ramo */
                      var code = order.defaults.formInfo.code;
                      if (code === 9) {
                        var auto = angular.copy(order.subforms.auto);
                        auto.sub_branch = res.subramo;
                        auto.policy = res.url;
                        auto.org = res.org;

                        var submitObject = {
                          code: code,
                          insurance: res,
                          form: auto,
                          policy: order.insuranceObject.id,
                        };

                        formService
                          .createForm(submitObject)
                          .then(function (resAuto) {});
                      } else if (code === 1 || code === 30) {
                        // Personal information
                        var life = order.subforms.life;
                        var beneficiaries =
                          order.subforms.life.beneficiariesList;

                        // var personal = {
                        //     first_name: life.first_name ? life.first_name : '',
                        //     last_name: life.last_name ? life.last_name : '',
                        //     second_last_name: life.second_last_name ? life.second_last_name : '',
                        //     birthdate: life.birthdate,
                        //     sex: life.sex ? life.sex : ''
                        // };
                        var personal = order.subforms.life.aseguradosList;

                        var submitObject = {
                          code: code,
                          personal: personal,
                          personal_life_policy:
                            order.subforms.life.aseguradosList,
                          relationships: beneficiaries,
                          insurance: res,
                          smoker: order.insuranceObject.smoker
                            ? order.insuranceObject.smoker
                            : false,
                        };
                        if (submitObject.smoker == "True") {
                          submitObject.smoker = true;
                        } else if (submitObject.smoker == "False") {
                          submitObject.smoker = false;
                        }
                        formService
                          .createForm(submitObject)
                          .then(function (response) {});
                      } else if (code === 2 || code === 3 || code === 4) {
                        var disease = order.subforms.disease;
                        var relationships =
                          order.subforms.disease.relationshipList;

                        var type = helpers.diseaseType(
                          order.defaults.formInfo.code
                        );
                        var pt =
                          order &&
                          order.subforms &&
                          order.subforms.disease &&
                          order.subforms.disease.policy_type &&
                          order.subforms.disease.policy_type.id
                            ? order.subforms.disease.policy_type.id
                            : order &&
                              order.subforms &&
                              order.subforms.disease &&
                              order.subforms.disease.policy_type
                            ? order.subforms.disease.policy_type
                            : 46;
                        var personal = {
                          first_name: disease.first_name
                            ? disease.first_name
                            : "",
                          last_name: disease.last_name ? disease.last_name : "",
                          second_last_name: disease.second_last_name
                            ? disease.second_last_name
                            : "",
                          birthdate: disease.birthdate,
                          antiguedad: disease.antiguedad
                            ? disease.antiguedad
                            : null,
                          sex: disease.sex ? disease.sex : "",
                          policy_type: pt
                            ? pt
                            : disease.policy_type
                            ? disease.policy_type
                            : 46,
                        };
                        // var personal = order.subforms.life.aseguradosList;

                        var submitObject = {
                          code: code,
                          personal: personal,
                          relationships: relationships,
                          coinsurance: disease.coinsurance,
                          insurance: res,
                          policy: order.insuranceObject.id,
                        };

                        formService
                          .createForm(submitObject)
                          .then(function (response) {});
                      } else if (
                        code === 5 ||
                        code === 6 ||
                        code === 7 ||
                        code === 8 ||
                        code === 10 ||
                        code === 11 ||
                        code === 12 ||
                        code === 13 ||
                        (code === 14) | (code === 31)
                      ) {
                        var damage = order.subforms.damage;
                        var type = helpers.damageType(parseInt(code));

                        damage.sub_branch = res.subramo;
                        damage.damage_type = order.subforms.damage.damage_type;
                        damage.policy = res.url;

                        var submitObject = {
                          insurance: res,
                          code: code,
                          form: damage,
                          policy: order.insuranceObject.id,
                        };

                        formService
                          .createForm(submitObject)
                          .then(function (res) {});
                      }

                      /* Coberturas */
                      if (order.defaults.coverages.length > 0) {
                        helpers.createCoverages(order.defaults.coverages, res);
                      }
                      // $state.go('renovaciones.renovaciones');
                      gopolicieinfo(res.id, $scope.poliza_data);
                    });
                  }
                });
                return;
              } else {
                $scope.disabled_ot = true;
                SweetAlert.swal(
                  "Error",
                  MESSAGES.ERROR.POLICYNOREQUIRED,
                  "error"
                );
                $scope.validatePolicy("poliza", 1);
                return;
              }
            }
          );
        } else {
          form = getFormData(form);
          form.business_line = order.form.business_line
            ? order.form.business_line
            : 0;
          form.celula = order.form.celula ? order.form.celula.url : "";
          form.observations = obsevaciones;
          form.status = 1;
          form.address = order.form.address.url;
          form.clave = order.form.clave.url;

          form.folio = order.form.folio;
          form.poliza = order.form.poliza;

          form.p_neta = 0;
          form.rpf = 0;
          form.derecho = 0;
          form.p_total = 0;
          form.iva = 0;
          if (order.form.responsable) {
            form.responsable = order.form.responsable
              ? order.form.responsable.url
              : "";
          }
          if (order.form.collection_executive) {
            form.collection_executive = order.form.collection_executive
              ? order.form.collection_executive.url
              : "";
          }

          if (order.form.sucursal) {
            form.sucursal = order.form.sucursal ? order.form.sucursal.url : "";
          }

          if (order.form.ceder_comision) {
            form.udi = order.form.udi;
            if (order.form.comision_percent) {
              form.comision_percent = order.form.comision_percent;
            } else {
              form.comision_percent = order.form.clave.comission;
            }
          } else {
            if (order.form.comision_percent) {
              form.comision_percent = order.form.comision_percent;
            } else {
              form.comision_percent = order.form.clave.comission;
            }
            form.udi = order.form.clave.udi;
          }

          if (order.form.comision_percent) {
            var percent_ = parseFloat(order.form.comision_percent) / 100;
            order.form.comision = (order.form.p_neta * percent_).toFixed(2);
          } else {
            var percent_ = parseFloat(order.form.comision.comission) / 100;
            order.form.comission = (order.form.p_neta * percent_).toFixed(2);
          }

          $q.all([
            helpers.existPolicyNumber("renovaciones_modulo").then(checkPromise),
          ]).then(function (val) {
            if (val[0] === true) {
              SweetAlert.swal(
                "Error",
                "Esta número de póliza ya existe.",
                "error"
              );
            } else {
              if (order.form.start_of_validity) {
                var startDate = new Date(order.form.start_of_validity).setHours(
                  12,
                  0,
                  0,
                  0
                );
                var endingDate = new Date(order.form.end_of_validity).setHours(
                  11,
                  59,
                  59,
                  0
                );
                order.form.startDate_ = new Date(startDate);
                order.form.endingDate_ = new Date(endingDate);
              } else {
                var startDate = new Date(
                  mesDiaAnio(order.form.startDate)
                ).setHours(12, 0, 0, 0);
                var endingDate = new Date(
                  mesDiaAnio(order.form.endingDate)
                ).setHours(11, 59, 59, 0);
                order.form.startDate_ = new Date(startDate);
                order.form.endingDate_ = new Date(endingDate);
              }
              if (order.form.startDate) {
                order.form.startDate_ = datesFactory.toDate(
                  order.form.startDate
                );
                order.form.endingDate_ = datesFactory.toDate(
                  order.form.endingDate
                );
              }
              form.startDate = order.form.startDate_;
              form.endingDate = order.form.endingDate_;
              form.start_of_validity = form.startDate;
              form.end_of_validity = form.endingDate;
              form.contractor = order.form.contratante.value.url;
              if (order.form) {
              }
              form.internal_number = $scope.internal_number;
              form.comision = form.comision.comission;
              form.vendor = "";
              if (!form.comision) {
                form.comision = 0;
              }
              if (form.state_circulation) {
                if (form.state_circulation.state) {
                  form.state_circulation = form.state_circulation.state;
                }
              }
              form.groupinglevel = order.form.subsubgrouping
                ? order.form.subsubgrouping.url
                : order.form.subgrouping
                ? order.form.subgrouping.url
                : order.form.grouping_level
                ? order.form.grouping_level.url
                : null;

              if (form.grouping_level) {
              }
              form.conducto_de_pago =
                order.conducto_de_pago.conducto_de_pago_selected;
              // console.log('conducto_de_pago --reno..',form,order.form,order.conducto_de_pago)
              insuranceService.createInsurance(form).then(function (res) {
                if (res.estatus != 400 || res.estatus == 200) {
                  resetRenovationDraft();
                  $scope.poliza_data = myInsurance;
                  var params = {
                    model: 1,
                    event: "POST",
                    associated_id: myInsurance.id,
                    identifier: "generó la OT para renovación.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});

                  var params2 = {
                    model: 1,
                    event: "POST",
                    associated_id: res.id,
                    identifier:
                      "creo la OT a partir de la Póliza: " +
                      myInsurance.poliza_number,
                  };
                  dataFactory
                    .post("send-log/", params2)
                    .then(function success(response) {});
                  /*Actualización de Contratante*/
                  $scope.contractorToSave = {};

                  if (order.form.contratante.email) {
                    $scope.contractorToSave.email =
                      order.form.contratante.email;
                  } else {
                    $scope.contractorToSave.email = "";
                  }
                  if (order.form.contratante.phone_number) {
                    $scope.contractorToSave.phone_number =
                      order.form.contratante.phone_number;
                  } else {
                    $scope.contractorToSave.phone_number = "";
                  }
                  if (
                    order &&
                    order.form &&
                    order.form.contratante &&
                    order.form.contratante.value &&
                    order.form.contratante.value.url
                  ) {
                    $http
                      .patch(
                        order.form.contratante.value.url,
                        $scope.contractorToSave
                      )
                      .then(function (data) {
                        if (data.status == 200 || data.status == 201) {
                          toaster.info("Contratante Actualizado");
                        }
                      });
                  }
                  // if(res.contractor){
                  //   $http.get(res.contractor)
                  //     .then(function(response) {
                  //       if(response.data.email){
                  //           //Send Email
                  //           if($localStorage.email_config){
                  //             if($localStorage.email_config.renovacion == true){
                  //               var model = 9;
                  //               emailService.sendEmailAtm(model,myInsurance.id)
                  //            }
                  //          }else{}
                  //         //Send Email
                  //       }
                  //   });
                  // }
                  // //Send Email

                  /* Actualiza la póliza antigua */
                  // Modifica *************
                  var data = {
                    renewed_status: 2,
                  };
                  $http
                    .patch($scope.poliza_data.url, data)
                    .then(function success(response) {});

                  /* Relación la póliza original*/
                  var oldPolicy = {
                    policy: myInsurance.poliza_number,
                    base_policy: myInsurance.url,
                    new_policy: res.url,
                  };

                  insuranceService
                    .createOldPolicy(oldPolicy)
                    .then(function (responseOldPolicy) {});
                  // varios referenciadores
                  for (var i = 0; i < $scope.referenciadores.length; i++) {
                    if (
                      $scope.referenciadores &&
                      $scope.referenciadores[i] &&
                      $scope.referenciadores[i].policy
                    ) {
                      $scope.referenciadores[i].policy = res.url;
                      if ($scope.referenciadores[i].referenciador) {
                        var ref = {};
                        ref.referenciador =
                          $scope.referenciadores[i].referenciador;
                        ref.comision_vendedor = $scope.referenciadores[i]
                          .comision_vendedor
                          ? $scope.referenciadores[i].comision_vendedor
                          : 0;
                        ref.policy = res.url;
                        dataFactory
                          .post("referenciadores-policy/", ref)
                          .then(
                            function success(request) {},
                            function error(error) {
                              console.log(error);
                            }
                          )
                          .catch(function (e) {
                            console.log(e);
                          });
                      }
                    }
                    // if ($scope.referenciadores[i].url) {
                    //   $http.patch($scope.referenciadores[i].url, $scope.referenciadores[i]).then(
                    //     function success(request){
                    //     },
                    //     function error(error) {
                    //       console.log(error);
                    //     })
                    //   .catch(function(e){
                    //     console.log(e);
                    //   });
                    // }else{
                    //   $scope.ref_policy = $scope.referenciadores[i];
                    //   if($scope.ref_policy){
                    //     if ($scope.referenciadores[i].referenciador) {
                    //       var ref = {}
                    //       ref.referenciador = $scope.referenciadores[i].referenciador
                    //       ref.comision_vendedor = $scope.referenciadores[i].comision_vendedor ? $scope.referenciadores[i].comision_vendedor : 0
                    //       ref.policy = res.url
                    //       dataFactory.post('referenciadores-policy/',ref)
                    //       .then(
                    //         function success(request){
                    //         },
                    //         function error(error) {
                    //           console.log(error);
                    //         })
                    //       .catch(function(e){
                    //         console.log(e);
                    //       });
                    //     }
                    //   }
                    // }
                  }
                  // varios referenciadores
                  /* Sube archivos */
                  uploadFiles(res.id);

                  order.defaults.policyUrl = res.url;
                  url_mine = res.url;

                  SweetAlert.swal("Hecho", MESSAGES.OK.NEWOT, "success");
                  var irInfo = false;
                  /* Formulario por ramo */
                  var code = order.defaults.formInfo.code;
                  if (code === 9) {
                    var auto = angular.copy(order.subforms.auto);
                    auto.sub_branch = res.subramo;
                    auto.policy = res.url;
                    auto.org = res.org;

                    var submitObject = {
                      code: code,
                      insurance: res,
                      form: auto,
                      policy: order.insuranceObject.id,
                    };

                    formService
                      .createForm(submitObject)
                      .then(function (resAuto) {
                        gopolicieinfo(res.id, $scope.poliza_data);
                      });
                  } else if (code === 1 || code === 30) {
                    // Personal information
                    var life = order.subforms.life;
                    var beneficiaries = order.subforms.life.beneficiariesList;

                    // var personal = {
                    //     first_name: life.first_name ? life.first_name : '',
                    //     last_name: life.last_name ? life.last_name : '',
                    //     second_last_name: life.second_last_name ? life.second_last_name : '',
                    //     birthdate: life.birthdate,
                    //     sex: life.sex ? life.sex : ''
                    // };
                    var personal = order.subforms.life.aseguradosList;

                    var submitObject = {
                      code: code,
                      personal: personal,
                      personal_life_policy: order.subforms.life.aseguradosList,
                      relationships: beneficiaries,
                      insurance: res,
                      smoker: order.insuranceObject.smoker
                        ? order.insuranceObject.smoker
                        : false,
                    };
                    if (submitObject.smoker == "True") {
                      submitObject.smoker = true;
                    } else if (submitObject.smoker == "False") {
                      submitObject.smoker = false;
                    }
                    formService
                      .createForm(submitObject)
                      .then(function (response) {
                        gopolicieinfo(res.id, $scope.poliza_data);
                      });
                  } else if (code === 2 || code === 3 || code === 4) {
                    var disease = order.subforms.disease;
                    var relationships = order.subforms.disease.relationshipList;

                    var pt =
                      order &&
                      order.subforms &&
                      order.subforms.disease &&
                      order.subforms.disease.policy_type &&
                      order.subforms.disease.policy_type.id
                        ? order.subforms.disease.policy_type.id
                        : order &&
                          order.subforms &&
                          order.subforms.disease &&
                          order.subforms.disease.policy_type
                        ? order.subforms.disease.policy_type
                        : 46;
                    var type = helpers.diseaseType(
                      order.defaults.formInfo.code
                    );
                    var personal = {
                      first_name: disease.first_name ? disease.first_name : "",
                      last_name: disease.last_name ? disease.last_name : "",
                      second_last_name: disease.second_last_name
                        ? disease.second_last_name
                        : "",
                      birthdate: disease.birthdate,
                      sex: disease.sex ? disease.sex : "",
                      policy_type: pt
                        ? pt
                        : disease.policy_type
                        ? disease.policy_type
                        : 46,
                    };
                    // var personal = order.subforms.life.aseguradosList;

                    var submitObject = {
                      code: code,
                      personal: personal,
                      relationships: relationships,
                      coinsurance: disease.coinsurance,
                      insurance: res,
                      policy: order.insuranceObject.id,
                    };
                    formService
                      .createForm(submitObject)
                      .then(function (response) {
                        gopolicieinfo(res.id, $scope.poliza_data);
                      });
                  } else if (
                    code === 5 ||
                    code === 6 ||
                    code === 7 ||
                    code === 8 ||
                    code === 10 ||
                    code === 11 ||
                    code === 12 ||
                    code === 13 ||
                    code === 14 ||
                    code === 31
                  ) {
                    var damage = order.subforms.damage;
                    var type = helpers.damageType(parseInt(code));

                    damage.sub_branch = res.subramo;
                    damage.damage_type = order.subforms.damage.damage_type;
                    damage.policy = res.url;

                    var submitObject = {
                      insurance: res,
                      code: code,
                      form: damage,
                      policy: order.insuranceObject.id,
                    };

                    formService.createForm(submitObject).then(function (res1) {
                      gopolicieinfo(res.id, $scope.poliza_data);
                    });
                  }

                  /* Coberturas */
                  if (order.defaults.coverages.length > 0) {
                    helpers.createCoverages(order.defaults.coverages, res);
                  }

                  // $state.go('renovaciones.renovaciones');
                  // gopolicieinfo(res.id,$scope.poliza_data);
                } else {
                  SweetAlert.swal(
                    "Error",
                    MESSAGES.ERROR.ERRORCREATEPOLICY,
                    "error"
                  );
                }
              });
              // setTimeout(function() {
              //   order.receipts.forEach(function(receipt,index){
              //     var saveReceiptRequest = {
              //       poliza:url_mine,
              //       recibo_numero: index + 1,
              //       prima_neta: receipt.prima,
              //       rpf: receipt.rpf,
              //       derecho: receipt.derecho,
              //       iva: receipt.iva,
              //       sub_total: receipt.subTotal,
              //       prima_total: receipt.total,
              //       status: 4,
              //       isActive: false,
              //       isCopy:receipt.isCopy,
              //       startDate: toDate(receipt.startDate),
              //       endingDate: toDate(receipt.endingDate),
              //       fecha_inicio: toDate(receipt.startDate),
              //       fecha_fin: toDate(receipt.endingDate),
              //       vencimiento: toDate(receipt.vencimiento),
              //       description: "",
              //       receipt_type:1,
              //       is_cat : receipt.is_cat
              //     };

              //     receiptService.createReceiptService(saveReceiptRequest);
              //   });
              // }, 1000);
            }
          });
        }
      },
      saveInsurance: function () {
        /* Guardar como poliza */
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.dataToSave = angular.copy(order.form);
        if ($scope.dataToSave.startDate) {
          var startDate = new Date(
            $scope.dataToSave.start_of_validity
          ).setHours(12, 0, 0, 0);
          var endingDate = new Date($scope.dataToSave.end_of_validity).setHours(
            11,
            59,
            59,
            0
          );
          $scope.dataToSave.startDate = new Date(startDate);
          $scope.dataToSave.endingDate = new Date(endingDate);
        } else {
          var startDate = new Date(
            mesDiaAnio($scope.dataToSave.startDate)
          ).setHours(12, 0, 0, 0);
          var endingDate = new Date(
            mesDiaAnio($scope.dataToSave.endingDate)
          ).setHours(11, 59, 59, 0);
          $scope.dataToSave.startDate = new Date(startDate);
          $scope.dataToSave.endingDate = new Date(endingDate);
        }
        if (order.form.startDate) {
          $scope.dataToSave.start_of_validity = datesFactory.toDate(
            order.form.startDate
          );
          $scope.dataToSave.end_of_validity = datesFactory.toDate(
            order.form.endingDate
          );
        }

        $scope.dataToSave.give_comision = order.form.give_comision;

        if (!canBePoliza()) {
          return;
        } /* Validaciones */
        if (!validate2()) {
          return;
        } /* Validación de recibos y no. póliza */

        $q.all([
          helpers.existPolicy("renovaciones_modulo").then(checkPromise),
        ]).then(function (val) {
          if (val[0] === true) {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Esta número de póliza ya existe.",
              "error"
            );
          } else {
            if ($scope.dataToSave.start_of_validity) {
              var startDate = new Date(
                $scope.dataToSave.start_of_validity
              ).setHours(12, 0, 0, 0);
              var endingDate = new Date(
                $scope.dataToSave.end_of_validity
              ).setHours(11, 59, 59, 0);
              $scope.dataToSave.startDate = new Date(startDate);
              $scope.dataToSave.endingDate = new Date(endingDate);
            } else {
              var startDate = new Date(
                mesDiaAnio($scope.dataToSave.startDate)
              ).setHours(12, 0, 0, 0);
              var endingDate = new Date(
                mesDiaAnio($scope.dataToSave.endingDate)
              ).setHours(11, 59, 59, 0);
              $scope.dataToSave.startDate = new Date(startDate);
              $scope.dataToSave.endingDate = new Date(endingDate);
            }

            $scope.dataToSave.contratante = $scope.dataToSave.contratante.value;

            $scope.dataToSave.vendor = "";
            try {
              $scope.dataToSave.vendor = order.form.vendor.url;
            } catch (e) {}

            var form = angular.copy($scope.dataToSave);
            var fromDate = $scope.dataToSave.startDate;
            var today = new Date(new Date().toISOString().split("T")[0]);
            var obsevaciones = $scope.dataToSave.observations;
            form = getFormData(form, $scope.dataToSave.vendor);
            form.observations = obsevaciones;
            form.f_currency = order.f_currency.f_currency_selected;
            form.conducto_de_pago =
              order.conducto_de_pago.conducto_de_pago_selected;
            form.is_renewable = order.renewal.is_renewable;

            var auxDate = new Date(
              $scope.dataToSave.startDate.getTime() - 86400000
            );
            form.status = auxDate > new Date() ? 10 : 14;

            form.address = $scope.dataToSave.address.url;
            form.clave = $scope.dataToSave.clave.url;

            form.p_neta = order.poliza.primaNeta;
            form.p_total = order.poliza.primaTotal;
            form.derecho = order.poliza.derecho;
            form.rpf = order.poliza.rpf;
            form.iva = order.poliza.iva;
            form.descuento = order.poliza.descuento;

            if (order.receipts.length) {
              if ($scope.change_domiciliado) {
                if (order.form.domiciliado) {
                  var domiciliado = true;
                } else {
                  var domiciliado = false;
                }
              }

              order.receipts.forEach(function (item) {
                item.is_cat = domiciliado;
                var init = new Date(mesDiaAnio(item.fecha_inicio)).setHours(
                  12,
                  0,
                  0,
                  0
                );
                var end = new Date(mesDiaAnio(item.fecha_fin)).setHours(
                  11,
                  59,
                  59,
                  0
                );

                // item.endingDate = new Date(end);
                item.fecha_fin = new Date(end);
                // item.startDate = new Date(init);
                item.fecha_inicio = new Date(init);

                if (item.vencimiento) {
                  var vencimiento = new Date(toDate(item.vencimiento)).setHours(
                    11.59,
                    59,
                    0
                  );
                  item.vencimiento = new Date(vencimiento);
                }
                item.comision = item.comision
                  ? parseFloat(item.comision).toFixed(2)
                  : 0;
              });
            }
            var url_order = angular.copy(order.defaults);

            if ($scope.dataToSave.ceder_comision) {
              form.udi = $scope.dataToSave.udi;
              if ($scope.dataToSave.comision_percent) {
                form.comision_percent = $scope.dataToSave.comision_percent;
              } else {
                form.comision_percent = $scope.dataToSave.clave.comission;
              }
            } else {
              if ($scope.dataToSave.comision_percent) {
                form.comision_percent = $scope.dataToSave.comision_percent;
              } else {
                form.comision_percent = $scope.dataToSave.clave.comission;
              }
              form.udi = $scope.dataToSave.clave.udi;
            }

            if ($scope.dataToSave.udi) {
              form.udi = $scope.dataToSave.udi;
              form.comision =
                parseFloat(form.p_neta) *
                parseInt($scope.dataToSave.comision_percent);
            } else {
              if ($scope.dataToSave.comision) {
                form.udi = $scope.dataToSave.comision.udi;
                var percent_ =
                  parseInt($scope.dataToSave.comision.comission) / 100;
                form.comission = form.p_neta * percent_;
                form.comision = parseFloat(form.p_neta) * percent_;
              } else {
                form.udi = 0;
                var percent_ =
                  parseInt($scope.dataToSave.comision.comission) / 100;
                form.comision = form.p_neta * percent_;
                form.comission = parseFloat(form.p_neta) * percent_;
              }
            }

            if ($scope.dataToSave.comision_percent) {
              var percent_ =
                parseFloat($scope.dataToSave.comision_percent) / 100;
              form.comision = (parseFloat(form.p_neta) * percent_).toFixed(2);
            } else {
              var percent_ =
                parseFloat($scope.dataToSave.comision.comission) / 100;
              form.comission = (parseFloat(form.p_neta) * percent_).toFixed(2);
              form.comision = (parseFloat(form.p_neta) * percent_).toFixed(2);
            }

            form.comision = order.comision;
            form.comision_percent = order.comision_percent;

            form.internal_number = $scope.internal_number;
            if (order.form.responsable) {
              form.responsable = order.form.responsable
                ? order.form.responsable.url
                : "";
            }
            if (order.form.collection_executive) {
              form.collection_executive = order.form.collection_executive
                ? order.form.collection_executive.url
                : "";
            }
            if (order.form.sucursal) {
              form.sucursal = order.form.sucursal
                ? order.form.sucursal.url
                : "";
            }
            if (!form.comision) {
              form.comision = 0;
            } else {
              form.comision = parseFloat(form.comision).toFixed(2);
            }
            if (isNaN(form.comision)) {
              form.comision = 0;
            }
            form.recibos_poliza = order.receipts;
            form.recibos_poliza.forEach(function (recibo, index) {
              form.recibos_poliza[index]["conducto_de_pago"] =
                form.conducto_de_pago;
            });
            form.state_circulation = order.form.state_circulation
              ? order.form.state_circulation.state
              : "";
            form.business_line = order.form.business_line
              ? order.form.business_line
              : 0;
            form.celula = order.form.celula ? order.form.celula.url : "";
            form.groupinglevel = order.form.subsubgrouping
              ? order.form.subsubgrouping.url
              : order.form.subgrouping
              ? order.form.subgrouping.url
              : order.form.grouping_level
              ? order.form.grouping_level.url
              : "";
            /* Creación de la póliza */
            // console.log('conducto_de_pago --reno..',form,order.form,order.conducto_de_pago)
            insuranceService.createInsuranceReno(form).then(function (res) {
              $scope.yaTermino = false;
              $scope.idPolicy = res.id;
              resetRenovationDraft();
              $scope.poliza_data = myInsurance;
              var data = {
                renewed_status: 1,
                status: 12,
              };
              try {
                var serial =
                  order &&
                  order.subforms &&
                  order.subforms.auto &&
                  order.subforms.auto.serial
                    ? normalizeVIN(order.subforms.auto.serial)
                    : null;
                var st = order._vinWarningState || {};
                var finalHasInvalid = !!(
                  serial && hasInvalidVinLetters(serial)
                );

                // Aquí va tu llamada real al backend para guardar la póliza:
                order._saving = true;
                var shouldLog =
                  hasInvalidVinLetters(serial) &&
                  st.warned === true &&
                  st.userAcknowledged === true &&
                  st.warnedVinValue === serial; // opcional pero recomendado
                if (serial || shouldLog) {
                  var serial = normalizeVIN(order.subforms.auto.serial);
                  var st = order._vinWarningState || {};
                  if (
                    hasInvalidVinLetters(serial) &&
                    st.userAcknowledged &&
                    st.warnedVinValue === serial
                  ) {
                    // aquí haces tu log
                    var logInvalidSerial = {
                      model: 1,
                      event: "POST",
                      associated_id: $scope.idPolicy,
                      identifier:
                        "creó la póliza con una serie inválida. La serie contiene los caracteres ‘I’, ‘O’ u ‘Q’, los cuales no son válidos.(" +
                        serial +
                        ")",
                    };
                    dataFactory
                      .post("send-log/", logInvalidSerial)
                      .then(function success(response_x) {
                        console.log(
                          "-------ren-VIN_INVALID_OIQ_SAVED-----",
                          response_x
                        );
                      });
                  }
                }
              } catch (u) {}
              if (res.id) {
                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: res.id,
                  identifier:
                    "creó la renovación a partir de la póliza " +
                    myInsurance.poliza_number +
                    ".",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});

                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: myInsurance.id,
                  identifier: "renovó la póliza a " + res.poliza_number + ".",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                if (order.delete_receitps) {
                  if (order.delete_receitps.length > 0) {
                    var params_del_rec = {
                      model: 1,
                      event: "DELETE",
                      associated_id: res.id,
                      identifier:
                        "elimino recibos al crear la póliza (vigencia menor de un año)",
                    };
                    dataFactory
                      .post("send-log/", params_del_rec)
                      .then(function success(response_x) {});
                  }
                }
                /* Actualiza la póliza antigua */
                var urlCh = myInsurance.url;
                console.log(
                  "urlCh********+",
                  urlCh,
                  $scope.poliza_data.url,
                  myInsurance.url
                );
                if (urlCh) {
                  $http.patch(urlCh, data);
                }

                /* Relación con la póliza original */
                var oldPolicy = {
                  policy: myInsurance.poliza_number,
                  base_policy: myInsurance.url,
                  new_policy: res.url,
                };

                insuranceService
                  .createOldPolicy(oldPolicy)
                  .then(function (responseOldPolicy) {});
              }
              /*Actualización de Contratante*/
              $scope.contractorToSave = {};

              if (order.form.contratante.email) {
                $scope.contractorToSave.email = order.form.contratante.email;
              } else {
                $scope.contractorToSave.email = "";
              }
              if (order.form.contratante.phone_number) {
                $scope.contractorToSave.phone_number =
                  order.form.contratante.phone_number;
              } else {
                $scope.contractorToSave.phone_number = "";
              }
              $http
                .patch(
                  order.form.contratante.value.url,
                  $scope.contractorToSave
                )
                .then(function (data) {
                  if (data.status == 200 || data.status == 201) {
                    toaster.info("Contratante Actualizado");
                  }
                });
              // varios referenciadores
              console.log("Referenciadores:", $scope.referenciadores);

              for (var i = 0; i < $scope.referenciadores.length; i++) {
                if (!$scope.referenciadores[i]) {
                  continue;
                }
                $scope.referenciadores[i].policy = res.url;
                $scope.ref_policy = $scope.referenciadores[i];
                if ($scope.ref_policy) {
                  if ($scope.referenciadores[i].referenciador) {
                    var ref = {};
                    ref.referenciador = $scope.referenciadores[i].referenciador;
                    ref.comision_vendedor =
                      $scope.referenciadores[i].comision_vendedor || 0;
                    ref.policy = res.url;

                    dataFactory
                      .post("referenciadores-policy/", ref)
                      .then(
                        function success(request) {
                          // Handle success
                        },
                        function error(error) {
                          console.log(error);
                        }
                      )
                      .catch(function (e) {
                        console.log(e);
                      });
                  }
                }
              }

              // varios referenciadores

              if ($localStorage.dataFileR && $scope.read_pdf_ren) {
                try {
                  $localStorage.dataFileR.append("owner", $scope.idPolicy);
                  try {
                    $http.patch(data.data.url, { from_pdf: true });
                  } catch (u) {}
                  var xhr_file = new XMLHttpRequest();
                  // xhr_file.open("POST", url.SERVICE_PDF);
                  xhr_file.open(
                    "POST",
                    url.IP +
                      "polizas/" +
                      $scope.idPolicy +
                      "/archivos/?org=" +
                      $scope.orgName
                  );
                  xhr_file.timeout = 1200000;
                  xhr_file.ontimeout = function (e) {
                    console.log("error file", e);
                  };
                  xhr_file.setRequestHeader("Authorization", "Bearer " + token);
                  xhr_file.send($localStorage.dataFileR);
                  xhr_file.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                      $scope.fileUP = JSON.parse(xhr_file.response);
                      $localStorage.dataFileR = {};
                    }
                  };
                } catch (efile) {
                  console.log("nose cargo el pdf leído", efile);
                }
              }
              /* Sube archivos */
              uploadFiles(res.id);
              order.defaults.policyUrl = res.url;
              url_order.policyUrl = { url: res.url };
              toaster.success(MESSAGES.OK.RENEWALPOLICY);
              var code = order.defaults.formInfo.code;
              /* Formularios por ramo */

              if (code === 9) {
                var auto = angular.copy(order.subforms.auto);
                if (auto.policy_type && auto.policy_type.id) {
                  auto.policy_type = auto.policy_type.id;
                }
                if (auto.procedencia && auto.procedencia.id) {
                  auto.procedencia = auto.procedencia.id;
                }
                auto.sub_branch = res.subramo;
                auto.policy = res.url;
                auto.org = res.org;

                var submitObject = {
                  code: code,
                  insurance: res,
                  form: auto,
                  policy: order.insuranceObject.id,
                };

                formService.createForm(submitObject).then(function (resAuto) {
                  $scope.yaTermino = true;
                  gopolicieinfo($scope.idPolicy, res);
                });
              } else if (code === 1 || code === 30) {
                // Personal information
                var life = order.subforms.life;
                var beneficiaries = order.subforms.life.beneficiariesList;
                var personal = order.subforms.life.aseguradosList;
                var asegurados_1 = [];

                var submitObject = {
                  code: code,
                  relationships: beneficiaries,
                  insurance: res,
                  smoker: order.subforms.life.smoker,
                  policy: order.insuranceObject.id,
                  policy_type: life.policy_type,
                };
                personal.forEach(function (prs, index) {
                  if (i == 0) {
                    var personal_1 = {
                      first_name: prs.first_name ? prs.first_name : "",
                      last_name: prs.last_name ? prs.last_name : "",
                      second_last_name: prs.second_last_name
                        ? prs.second_last_name
                        : "",
                      birthdate: prs.birthdate ? prs.birthdate : new Date(),
                      antiguedad: prs.antiguedad ? prs.antiguedad : new Date(),
                      sex: prs.sex ? prs.sex : "",
                      full_name:
                        prs.first_name +
                        " " +
                        prs.last_name +
                        " " +
                        prs.second_last_name,
                    };
                    var personal_a = {
                      first_name: personal_1[0].first_name
                        ? personal_1[0].first_name
                        : "",
                      last_name: personal_1[0].last_name
                        ? personal_1[0].last_name
                        : "",
                      second_last_name: personal_1[0].second_last_name
                        ? personal_1[0].second_last_name
                        : "",
                      birthdate: personal_1[0].birthdate,
                      antiguedad: personal_1[0].antiguedad
                        ? personal_1[0].antiguedad
                        : null,
                      sex: personal_1[0].sex ? personal_1[0].sex : "",
                    };
                    submitObject.personal = personal_a;
                  } else {
                    asegurados_1.push(prs);
                  }
                });
                submitObject.personal_life_policy = asegurados_1;
                formService.createForm(submitObject).then(function (response) {
                  $scope.yaTermino = true;
                  gopolicieinfo($scope.idPolicy, res);
                });
              } else if (code === 2 || code === 3 || code === 4) {
                var disease = order.subforms.disease;
                var relationships = order.subforms.disease.relationshipList;

                var type = helpers.diseaseType(order.defaults.formInfo.code);
                var personal = {
                  first_name: disease.first_name ? disease.first_name : "",
                  last_name: disease.last_name ? disease.last_name : "",
                  second_last_name: disease.second_last_name
                    ? disease.second_last_name
                    : "",
                  birthdate: disease.birthdate,
                  antiguedad: disease.antiguedad ? disease.antiguedad : null,
                  sex: disease.sex ? disease.sex : "",
                  policy_type: disease.policy_type,
                };

                var submitObject = {
                  code: code,
                  personal: personal,
                  relationships: relationships,
                  coinsurance: disease.coinsurance,
                  insurance: res,
                  policy: order.insuranceObject.id,
                };

                formService.createForm(submitObject).then(function (response) {
                  $scope.yaTermino = true;
                  gopolicieinfo($scope.idPolicy, res);
                });
              } else if (
                code === 5 ||
                code === 6 ||
                code === 7 ||
                code === 8 ||
                code === 10 ||
                code === 11 ||
                code === 12 ||
                code === 13 ||
                code === 14 ||
                code === 31
              ) {
                var damage = order.subforms.damage;
                var type = helpers.damageType(parseInt(code));

                damage.sub_branch = res.subramo;
                damage.damage_type = order.subforms.damage.damage_type;
                damage.policy = res.url;

                var submitObject = {
                  insurance: res,
                  code: code,
                  form: damage,
                  policy: order.insuranceObject.id,
                };
                formService.createForm(submitObject).then(function (res) {
                  $scope.yaTermino = true;
                  gopolicieinfo($scope.idPolicy, res);
                });
              }

              /* Guarda coberturas */
              $scope.totalcoberturas = order.defaults.coverages.length;
              $scope.totalcreadas = 0;
              if (order.defaults.coverages.length > 0) {
                for (var i = 0; i < order.defaults.coverages.length; i++) {
                  $scope.totalcreadas = $scope.totalcreadas + 1;
                  if (
                    order.defaults.coverages[i] &&
                    order.defaults.coverages[i].sumInPolicy
                  ) {
                    order.defaults.coverages[i].sum_insured =
                      order.defaults.coverages[i].sumInPolicy &&
                      order.defaults.coverages[i].sumInPolicy.value
                        ? order.defaults.coverages[i].sumInPolicy.value
                        : 0;
                    order.defaults.coverages[i].deductible = order.defaults
                      .coverages[i].deductibleInPolicy
                      ? order.defaults.coverages[i].deductibleInPolicy.value
                      : 0;
                  }
                }
                helpers.createCoverages(order.defaults.coverages, res);
              }
              l.stop();
              // if($scope.yaTermino){
              SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWPOLICY, "success");
              // if($scope.totalcreadas == $scope.totalcoberturas){
              //   gopolicieinfo($scope.idPolicy,res);
              // }
              // gopolicieinfo($scope.idPolicy,res);
              // }
            });

            // setTimeout(function() {

            //   order.receipts.forEach(function(receipt,index){

            //     var initDate = new Date(receipt.startDate);
            //     var endDate = new Date(receipt.endingDate);
            //     var vencimiento = new Date(receipt.vencimiento);

            //     var saveReceiptRequest = {
            //       poliza: url_order.policyUrl.url ,
            //       recibo_numero: index + 1,
            //       prima_neta: receipt.prima ? receipt.prima : receipt.prima_neta,
            //       rpf: receipt.rpf,
            //       derecho: receipt.derecho,
            //       iva: receipt.iva,
            //       sub_total: receipt.subTotal ? receipt.subTotal : receipt.sub_total,
            //       prima_total: receipt.total ? receipt.total : receipt.prima_total,
            //       status: 4,
            //       startDate: new Date(initDate),
            //       endingDate: new Date(endDate),
            //       fecha_inicio: new Date(initDate),
            //       fecha_fin: new Date(endDate),
            //       vencimiento: new Date(vencimiento),
            //       description: "",
            //       receipt_type:1,
            //       comision: (parseFloat(receipt.comision)).toFixed(2),
            //       is_cat : receipt.is_cat
            //     };

            //     receiptService.createReceiptService(saveReceiptRequest)
            //     .then(function(response){
            //     });

            // });
            // }, 1000);
          }
        });
      },
      cloneInsurance: function () {
        // guardar como no renovación
        $scope.dataToSave = angular.copy(order.form);
        if ($scope.dataToSave.celula && $scope.dataToSave.celula.url) {
          $scope.dataToSave.celula = $scope.dataToSave.celula.url;
        }
        if (
          $scope.dataToSave.conducto_de_pago &&
          $scope.dataToSave.conducto_de_pago.conducto_de_pago_selected
        ) {
          $scope.dataToSave.conducto_de_pago =
            $scope.dataToSave.conducto_de_pago.conducto_de_pago_selected;
        }
        if ($scope.dataToSave.start_of_validity) {
          var startDate = new Date(
            $scope.dataToSave.start_of_validity
          ).setHours(12, 0, 0, 0);
          var endingDate = new Date($scope.dataToSave.end_of_validity).setHours(
            11,
            59,
            59,
            0
          );
          $scope.dataToSave.startDate = new Date(startDate);
          $scope.dataToSave.endingDate = new Date(endingDate);
        } else {
          var startDate = new Date(
            mesDiaAnio($scope.dataToSave.startDate)
          ).setHours(12, 0, 0, 0);
          var endingDate = new Date(
            mesDiaAnio($scope.dataToSave.endingDate)
          ).setHours(11, 59, 59, 0);
          $scope.dataToSave.startDate = new Date(startDate);
          $scope.dataToSave.endingDate = new Date(endingDate);
        }

        if (!canBePoliza()) {
          return;
        } /*Validación de contratante */
        if (!validate2()) {
          return;
        } /*Validación de recibos y no. póliza */

        $q.all([
          helpers.existPolicy("renovaciones_modulo").then(checkPromise),
        ]).then(function (val) {
          if (val[0] === true) {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Esta número de póliza ya existe.",
              "error"
            );
          } else {
            if ($scope.dataToSave.start_of_validity) {
              var startDate = new Date(
                $scope.dataToSave.start_of_validity
              ).setHours(12, 0, 0, 0);
              var endingDate = new Date(
                $scope.dataToSave.end_of_validity
              ).setHours(11, 59, 59, 0);
              $scope.dataToSave.startDate = new Date(startDate);
              $scope.dataToSave.endingDate = new Date(endingDate);
            } else {
              var startDate = new Date(
                mesDiaAnio($scope.dataToSave.startDate)
              ).setHours(12, 0, 0, 0);
              var endingDate = new Date(
                mesDiaAnio($scope.dataToSave.endingDate)
              ).setHours(11, 59, 59, 0);
              $scope.dataToSave.startDate = new Date(startDate);
              $scope.dataToSave.endingDate = new Date(endingDate);
            }

            $scope.dataToSave.contratante = $scope.dataToSave.contratante.value;

            var form = angular.copy($scope.dataToSave);
            var fromDate = $scope.dataToSave.startDate;
            var today = new Date(new Date().toISOString().split("T")[0]);
            var obsevaciones = $scope.dataToSave.observations;
            form = getFormData(form);
            form.observations = obsevaciones;

            var auxDate = new Date(
              $scope.dataToSave.startDate.getTime() - 86400000
            );
            form.status = auxDate > new Date() ? 10 : 14;

            form.address = $scope.dataToSave.address.url;
            form.clave = $scope.dataToSave.clave.url;
            form.f_currency = order.f_currency;
            form.conducto_de_pago = order.conducto_de_pago;

            form.p_neta = order.poliza.primaNeta;
            form.p_total = order.poliza.primaTotal;
            form.derecho = order.poliza.derecho;
            form.rpf = order.poliza.rpf;
            form.iva = order.poliza.iva;

            if (order.receipts.length) {
              order.receipts.forEach(function (item) {
                var init = new Date(mesDiaAnio(item.fecha_inicio)).setHours(
                  12,
                  0,
                  0,
                  0
                );
                var end = new Date(mesDiaAnio(item.fecha_fin)).setHours(
                  11,
                  59,
                  59,
                  0
                );

                item.startDate = new Date(init);
                item.endingDate = new Date(end);
                if (item.vencimiento) {
                  var vencimiento = new Date(toDate(item.vencimiento)).setHours(
                    11.59,
                    59,
                    0
                  );
                  item.vencimiento = new Date(vencimiento);
                }
                item.comision = item.comision
                  ? parseFloat(item.comision).toFixed(2)
                  : 0;
              });
            }

            var url = angular.copy(order.defaults);

            if ($scope.dataToSave.ceder_comision) {
              form.udi = $scope.dataToSave.udi;
              if ($scope.dataToSave.comision_percent) {
                form.comision_percent = $scope.dataToSave.comision_percent;
              } else {
                form.comision_percent = $scope.dataToSave.clave.comission;
              }
            } else {
              if ($scope.dataToSave.comision_percent) {
                form.comision_percent = $scope.dataToSave.comision_percent;
              } else {
                form.comision_percent = $scope.dataToSave.clave.comission;
              }
              form.udi = $scope.dataToSave.clave.udi;
            }

            if ($scope.dataToSave.udi) {
              form.udi = $scope.dataToSave.udi;
              form.comision =
                form.p_neta * parseInt($scope.dataToSave.comision_percent);
            } else {
              if ($scope.dataToSave.comision) {
                form.udi = $scope.dataToSave.comision.udi;
                var percent_ =
                  parseInt($scope.dataToSave.comision.comission) / 100;
                form.comision = form.p_neta * percent_;
                form.comission = form.p_neta * percent_;
              } else {
                form.udi = 0;
                var percent_ =
                  parseInt($scope.dataToSave.comision.comission) / 100;
                form.comision = form.p_neta * percent_;
                form.comission = form.p_neta * percent_;
              }
            }

            if ($scope.dataToSave.comision_percent) {
              var percent_ =
                parseFloat($scope.dataToSave.comision_percent) / 100;
              form.comision = (parseFloat(form.p_neta) * percent_).toFixed(2);
            } else {
              var percent_ =
                parseFloat($scope.dataToSave.comision.comission) / 100;
              form.comision = (parseFloat(form.p_neta) * percent_).toFixed(2);
              form.comission = (parseFloat(form.p_neta) * percent_).toFixed(2);
            }

            form.internal_number = $scope.internal_number;
            if (order.form.responsable) {
              form.responsable = order.form.responsable
                ? order.form.responsable.url
                : "";
            }
            if (order.form.collection_executive) {
              form.collection_executive = order.form.collection_executive
                ? order.form.collection_executive.url
                : "";
            }
            if (order.form.sucursal) {
              form.sucursal = order.form.sucursal
                ? order.form.sucursal.url
                : "";
            }
            if (!form.comision) {
              form.comision = 0;
            }
            form.business_line = order.form.business_line
              ? order.form.business_line
              : 0;
            /* Creación de la póliza */

            if (form.celula && form.celula.url) {
              form.celula = form.celula.url;
            }
            if (
              form.conducto_de_pago &&
              form.conducto_de_pago.conducto_de_pago_selected
            ) {
              form.conducto_de_pago =
                form.conducto_de_pago.conducto_de_pago_selected;
            }
            if (
              form.grouping_level &&
              form.grouping_level.grouping_level_selected
            ) {
              form.grouping_level = form.grouping_level.grouping_level_selected;
            }
            if (isNaN(form.comision)) {
              form.comision = 0;
              if ($scope.dataToSave.comision) {
                form.comision = $scope.dataToSave.comision
                  ? $scope.dataToSave.comision
                  : 0;
              }
            }
            form.recibos_poliza = [];

            order.receipts.forEach(function (receipt, index) {
              var initDate = new Date(receipt.startDate);
              var endDate = new Date(receipt.endingDate);
              var vencimiento = new Date(receipt.vencimiento);
              var saveReceiptRequest = {
                // poliza: url.policyUrl.url ,
                recibo_numero: index + 1,
                prima_neta: receipt.prima ? receipt.prima : receipt.prima_neta,
                rpf: receipt.rpf,
                derecho: receipt.derecho,
                iva: receipt.iva,
                sub_total: receipt.subTotal
                  ? receipt.subTotal
                  : receipt.sub_total,
                prima_total: receipt.total
                  ? receipt.total
                  : receipt.prima_total,
                status: 4,
                startDate: new Date(initDate),
                endingDate: new Date(endDate),
                fecha_inicio: new Date(initDate),
                fecha_fin: new Date(endDate),
                vencimiento: new Date(vencimiento),
                description: "",
                receipt_type: 1,
                comision: receipt.comision
                  ? parseFloat(receipt.comision).toFixed(2)
                  : 0,
                is_cat: receipt.is_cat,
              };
              form.recibos_poliza.push(saveReceiptRequest);
            });
            console.log("form-------", form, $scope.dataToSave);
            form.document_type = 1;
            insuranceService
              .createInsuranceNoRenovacion(form)
              .then(function (res) {
                if (myInsurance.status == 13) {
                  var data = {
                    status: 12,
                  };
                  /* Actualiza la póliza antigua */
                  $http.patch(myInsurance.url, data);
                }
                /*Actualización de Contratante*/
                $scope.contractorToSave = {};

                if (order.form.contratante.email) {
                  $scope.contractorToSave.email = order.form.contratante.email;
                } else {
                  $scope.contractorToSave.email = "";
                }
                if (order.form.contratante.phone_number) {
                  $scope.contractorToSave.phone_number =
                    order.form.contratante.phone_number;
                } else {
                  $scope.contractorToSave.phone_number = "";
                }
                $http
                  .patch(
                    order.form.contratante.value.url,
                    $scope.contractorToSave
                  )
                  .then(function (data) {
                    if (data.status == 200 || data.status == 201) {
                      toaster.info("Contratante Actualizado");
                    }
                  });
                /* Relación con la póliza original */
                var oldPolicy = {
                  policy: myInsurance.poliza_number,
                  base_policy: myInsurance.url,
                  new_policy: res.url,
                };

                insuranceService
                  .createOldPolicy(oldPolicy)
                  .then(function (responseOldPolicy) {});
                // varios referenciadores
                for (var i = 0; i < $scope.referenciadores.length; i++) {
                  if (!$scope.referenciadores[i]) {
                    continue;
                  }
                  // Existing logic
                  $scope.referenciadores[i].policy = res.url;
                  $scope.ref_policy = $scope.referenciadores[i];
                  if (
                    $scope.ref_policy &&
                    $scope.referenciadores[i].referenciador
                  ) {
                    var ref = {
                      referenciador: $scope.referenciadores[i].referenciador,
                      comision_vendedor:
                        $scope.referenciadores[i].comision_vendedor || 0,
                      policy: res.url,
                    };
                    dataFactory
                      .post("referenciadores-policy/", ref)
                      .then(
                        function success(request) {
                          console.log("Success:", request);
                        },
                        function error(error) {
                          console.error("Error in post:", error);
                        }
                      )
                      .catch(function (e) {
                        console.error("Catch error:", e);
                      });
                  }
                }
                // varios referenciadores
                /* Sube archivos */
                uploadFiles(res.id);

                order.defaults.policyUrl = res.url;
                url.policyUrl = { url: res.url };

                toaster.success(MESSAGES.OK.RENEWALPOLICY);
                var code = order.defaults.formInfo.code;

                /* Formularios por ramo */
                if (code === 9) {
                  var auto = angular.copy(order.subforms.auto);
                  auto.sub_branch = res.subramo;
                  auto.policy = res.url;
                  auto.org = res.org;

                  var submitObject = {
                    code: code,
                    insurance: res,
                    form: auto,
                    policy: order.insuranceObject.id,
                  };

                  formService
                    .createForm(submitObject)
                    .then(function (resAuto) {});
                } else if (code === 1 || code === 30) {
                  // Personal information
                  var life = order.subforms.life;
                  var personal = order.subforms.life.aseguradosList;
                  var beneficiaries = order.subforms.life.beneficiariesList;
                  var asegurados_1 = [];

                  var submitObject = {
                    code: code,
                    relationships: beneficiaries,
                    insurance: res,
                    smoker: order.subforms.life.smoker,
                    policy: order.insuranceObject.id,
                    policy_type: life.policy_type,
                  };
                  var personal_a = {};
                  personal.forEach(function (prs, index) {
                    if (index == 0) {
                      var personal_1 = {
                        first_name: prs.first_name ? prs.first_name : "",
                        last_name: prs.last_name ? prs.last_name : "",
                        second_last_name: prs.second_last_name
                          ? prs.second_last_name
                          : "",
                        birthdate: prs.birthdate ? prs.birthdate : new Date(),
                        antiguedad: prs.antiguedad
                          ? prs.antiguedad
                          : new Date(),
                        sex: prs.sex ? prs.sex : "",
                        full_name:
                          prs.first_name +
                          " " +
                          prs.last_name +
                          " " +
                          prs.second_last_name,
                        smoker: prs.smoker ? prs.smoker : "False",
                      };
                      var personal_a = {
                        first_name: personal_1.first_name
                          ? personal_1.first_name
                          : "",
                        last_name: personal_1.last_name
                          ? personal_1.last_name
                          : "",
                        second_last_name: personal_1.second_last_name
                          ? personal_1.second_last_name
                          : "",
                        birthdate: personal_1.birthdate,
                        antiguedad: personal_1.antiguedad
                          ? personal_1.antiguedad
                          : null,
                        sex: personal_1.sex ? personal_1.sex : "",
                        smoker: personal_1.smoker ? personal_1.smoker : "False",
                      };
                      submitObject.personal = personal_a;
                      if (personal_1.smoker == true) {
                        personal_1.smoker = "True";
                      } else if (personal_1.smoker == false) {
                        personal_1.smoker = "False";
                      }

                      if (personal_a.smoker == true) {
                        personal_a.smoker = "True";
                      } else if (personal_a.smoker == false) {
                        personal_a.smoker = "False";
                      }
                      submitObject.personal = personal_a;
                    } else {
                      if (prs.smoker == true) {
                        prs.smoker = "True";
                      } else if (prs.smoker == false) {
                        prs.smoker = "False";
                      }
                      asegurados_1.push(prs);
                    }
                  });
                  submitObject.personal_life_policy = asegurados_1;
                  // submitObject.personal = personal_a;
                  formService
                    .createForm(submitObject)
                    .then(function (response) {});
                  // var beneficiaries = order.subforms.life.beneficiariesList;
                  // var asegurados_life = order.subforms.life.aseguradosList;

                  // var personal = {
                  //     first_name: life.first_name ? life.first_name : '',
                  //     last_name: life.last_name ? life.last_name : '',
                  //     second_last_name: life.second_last_name ? life.second_last_name : '',
                  //     birthdate: life.birthdate,
                  //     sex: life.sex ? life.sex : ''
                  // };

                  // var submitObject = {
                  //     code: code,
                  //     personal: personal,
                  //     relationships: beneficiaries,
                  //     insurance: res,
                  //     smoker: order.subforms.life.smoker,
                  //     policy: order.insuranceObject.id
                  // }

                  // formService.createForm(submitObject)
                  //     .then(function(response){

                  //     });
                } else if (code === 2 || code === 3 || code === 4) {
                  var disease = order.subforms.disease;
                  var relationships = order.subforms.disease.relationshipList;

                  var type = helpers.diseaseType(order.defaults.formInfo.code);

                  var personal = {
                    first_name: disease.first_name ? disease.first_name : "",
                    last_name: disease.last_name ? disease.last_name : "",
                    second_last_name: disease.second_last_name
                      ? disease.second_last_name
                      : "",
                    birthdate: disease.birthdate,
                    antiguedad: disease.antiguedad ? disease.antiguedad : null,
                    sex: disease.sex ? disease.sex : "",
                    policy_type: disease.policy_type,
                  };

                  var submitObject = {
                    code: code,
                    personal: personal,
                    relationships: relationships,
                    coinsurance: disease.coinsurance,
                    insurance: res,
                    policy: order.insuranceObject.id,
                  };

                  formService
                    .createForm(submitObject)
                    .then(function (response) {});
                } else if (
                  code === 5 ||
                  code === 6 ||
                  code === 7 ||
                  code === 8 ||
                  code === 10 ||
                  code === 11 ||
                  code === 12 ||
                  code === 13 ||
                  code === 14 ||
                  code === 31
                ) {
                  var damage = order.subforms.damage;
                  var type = helpers.damageType(parseInt(code));

                  damage.sub_branch = res.subramo;
                  damage.damage_type = order.subforms.damage.damage_type;
                  damage.policy = res.url;

                  var submitObject = {
                    insurance: res,
                    code: code,
                    form: damage,
                    policy: order.insuranceObject.id,
                  };

                  formService
                    .createForm(submitObject)
                    .then(function (resDamage) {});
                }

                /* Guarda coberturas */
                if (order.defaults.coverages.length > 0) {
                  for (var i = 0; i < order.defaults.coverages.length; i++) {
                    order.defaults.coverages[i].sum_insured =
                      order.defaults.coverages[i].sumInPolicy.value;
                    order.defaults.coverages[i].deductible =
                      order.defaults.coverages[i].deductibleInPolicy.value;
                    order.defaults.coverages[i].coinsurance = order.defaults
                      .coverages[i].coinsuranceInPolicy.value
                      ? order.defaults.coverages[i].coinsuranceInPolicy.value
                      : 0;
                    order.defaults.coverages[i].topecoinsurance = order.defaults
                      .coverages[i].topeCoinsuranceInPolicy.value
                      ? order.defaults.coverages[i].topeCoinsuranceInPolicy
                          .value
                      : 0;
                  }
                  helpers.createCoverages(order.defaults.coverages, res);
                }

                SweetAlert.swal("Hecho", MESSAGES.OK.NEWPOLICY, "success");
                //$state.go('polizas.info', {polizaId: res.id})
                gopolicieinfo(res.id, $scope.poliza_data);
              });

            // setTimeout(function() {

            //   order.receipts.forEach(function(receipt,index){

            //     var initDate = new Date(receipt.startDate);
            //     var endDate = new Date(receipt.endingDate);
            //     var vencimiento = new Date(receipt.vencimiento);

            //     var saveReceiptRequest = {
            //       poliza: url.policyUrl.url ,
            //       recibo_numero: index + 1,
            //       prima_neta: receipt.prima ? receipt.prima : receipt.prima_neta,
            //       rpf: receipt.rpf,
            //       derecho: receipt.derecho,
            //       iva: receipt.iva,
            //       sub_total: receipt.subTotal ? receipt.subTotal : receipt.sub_total,
            //       prima_total: receipt.total ? receipt.total : receipt.prima_total,
            //       status: 4,
            //       startDate: new Date(initDate),
            //       endingDate: new Date(endDate),
            //       fecha_inicio: new Date(initDate),
            //       fecha_fin: new Date(endDate),
            //       vencimiento: new Date(vencimiento),
            //       description: "",
            //       receipt_type:1,
            //       comision: receipt.comision ? (parseFloat(receipt.comision)).toFixed(2) : 0,
            //       is_cat : receipt.is_cat
            //     };

            //     receiptService.createReceiptService(saveReceiptRequest)
            //     .then(function(response){
            //     });

            // });
            // }, 1000);
          }
        });
      },
      cancel: function () {
        $state.go("renovaciones.renovaciones");
      },
    };
    function gopolicieinfo(polizaid, data_) {
      var name = "Información Póliza";
      var route = "polizas.info";
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      if (polizaid) {
        var params = { polizaId: polizaid, url: polizaid, fromRenewal: true };
        $state.go($scope.route_for_new_tab, params);
      } else {
        if (data_ && data_.id) {
          var params = { polizaId: data_.id, url: data_.id, fromRenewal: true };
          $state.go($scope.route_for_new_tab, params);
        } else {
          $state.go("polizas.table");
        }
      }
    }
    function normalizeVIN(vin) {
      return (vin || "").toString().trim().toUpperCase();
    }
    function hasInvalidVinLetters(vin) {
      return /[OIQ]/.test(normalizeVIN(vin));
    }
    order._vinWarningState = order._vinWarningState || {
      warned: false, // ya se mostró alerta alguna vez
      warnedVinValue: null, // con qué VIN se alertó
      userAcknowledged: false, // presionó OK
    };
    function showVinInvalidCharsAlert(vin, cb) {
      SweetAlert.swal(
        {
          title: "Alerta",
          text:
            "<div style='text-align:left; line-height:1.5; font-size:14px;'>" +
            "<p style='margin:0 0 10px;'>" +
            "Por regla internacional, no existen números de serie vehicular (VIN) que contengan las letras <b>O</b>, <b>I</b> o <b>Q</b>." +
            "</p>" +
            "<p style='margin:0;'><b>Favor de revisar la serie capturada.</b></p>" +
            "</div>",
          type: "warning",
          html: true,
          showCancelButton: false,
          confirmButtonText: "OK",
          confirmButtonColor: "#2563eb",
          closeOnConfirm: true,
        },
        function () {
          if (typeof cb === "function") cb();
        }
      );
    }
    $scope.validatePolicy = function (param, value) {
      if (param == "poliza" && !order.form.canCreate) {
        SweetAlert.swal(
          "Error",
          "OPRIMA EL BOTON CALCULAR Y GENERAR RECIBOS",
          "error"
        );
        return;
      }

      if (!order.receipts.length) {
        order.receipts = order.recibos_poliza;
      }

      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (order.acceso_obl_ref) {
        $scope.referenciadores_copy = $scope.referenciadores.filter(function (
          item
        ) {
          return item && item.referenciador && isString(item.referenciador);
        });
        if (order.acceso_obl_ref) {
          if (
            ($scope.referenciadores && $scope.referenciadores.length == 0) ||
            ($scope.referenciadores_copy &&
              $scope.referenciadores_copy.length == 0)
          ) {
            SweetAlert.swal(
              "Error",
              "Seleccione al menos un referenciador.",
              "error"
            );
            l.stop();
            return;
          }
        }
      }

      var date1 = datesFactory.toDate(order.form.startDate);
      var date2 = datesFactory.toDate(order.form.endingDate);

      var since = toDate(order.form.startDate).getTime();
      var until = toDate(order.form.endingDate).getTime();

      $scope.arrayCoverage = order.defaults.coverages;
      $scope.count_coverage = 0;

      var flag_save_dependent = false;
      var flag_save_asegurado = false;

      if (param == "poliza") {
        if (!order.form.poliza) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
          return;
        }
      }
      if (!order.form.contratante.val) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        return;
      }
      if (!order.form.address) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        return;
      }
      if (
        !order.form.contratante.email &&
        !order.form.contratante.phone_number
      ) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORWITHOUTEMAIL, "error");
        return;
      }
      if (order.form.contratante.email) {
        if (!validateEmail(order.form.contratante.email)) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
          return;
        }

        function validateEmail(email) {
          var re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        }
      }
      if (date1 > date2) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }
      if (!order.form.aseguradora) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        return;
      }
      if (!order.form.clave) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        return;
      }
      if (!order.form.ramo) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        return;
      }
      if (!order.form.subramo) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (order.form.ramo.ramo_code == 1) {
        if (order.form.subramo.subramo_code != 30) {
          if (
            order.subforms &&
            order.subforms.life &&
            Array.isArray(order.subforms.life.aseguradosList) &&
            order.subforms.life.aseguradosList.length > 0 &&
            order.subforms.life.aseguradosList[0] &&
            !order.subforms.life.aseguradosList[0].policy_type
          ) {
            l.stop();
            SweetAlert.swal("Error", "Selecciona un tipo.", "error");
            return;
          } else {
            if (
              order.subforms &&
              order.subforms.life &&
              Array.isArray(order.subforms.life.aseguradosList) &&
              order.subforms.life.aseguradosList.length > 0 &&
              order.subforms.life.aseguradosList[0] &&
              order.subforms.life.aseguradosList[0].policy_type
            ) {
              console.log("continuar");
            } else if (
              order.subforms &&
              order.subforms.life &&
              Array.isArray(order.subforms.life.aseguradosList) &&
              order.subforms.life.aseguradosList.length > 0 &&
              order.subforms.life.aseguradosList[0] &&
              order.subforms.life.aseguradosList.length == 0
            ) {
              l.stop();
              SweetAlert.swal(
                "Error",
                "Revise el tipo, (agregue Asegurados)",
                "error"
              );
              return;
            }
          }
        }
      }
      if (order.form.ramo.ramo_code == 2) {
        if (!order.subforms.disease.policy_type) {
          l.stop();
          SweetAlert.swal("Error", "Selecciona un tipo.", "error");
          return;
        }
      }
      if (order.form.ramo.ramo_code == 3) {
        if (order.form.subramo.subramo_code == 9) {
          if (
            order.subforms &&
            order.subforms.auto &&
            order.subforms.auto.serial
          ) {
            // Normaliza siempre para comparar bien
            var serial = normalizeVIN(order.subforms.auto.serial);
            order._vinWarningState = order._vinWarningState || {
              warned: false,
              warnedVinValue: null,
              userAcknowledged: false,
            };
            if (serial && hasInvalidVinLetters(serial)) {
              var st = order._vinWarningState;
              // Importante: comparar normalizado
              var alreadyWarnedThisValue =
                st.warned === true &&
                st.warnedVinValue === serial &&
                st.userAcknowledged === true;
              if (!alreadyWarnedThisValue) {
                st.warned = true;
                st.warnedVinValue = serial;
                st.userAcknowledged = false;
                // 🔴 si ya arrancaste loader/enproceso antes, deténlo aquí mismo
                // (porque vas a "volver" y no seguir)
                $scope.enproceso = false;
                if (l) l.stop();
                showVinInvalidCharsAlert(serial, function () {
                  // El usuario dio OK: solo marcamos que ya vio la alerta
                  st.userAcknowledged = true;
                  // ✅ NO continuar con el proceso
                  // Regresar/permitir corrección:
                  $scope.enproceso = false;
                  // si usas Ladda, deténlo aquí
                  l.stop();
                  // Si quieres llevar el foco al input de serie:
                  setTimeout(function () {
                    var el = document.querySelector(
                      "#vinInput, input[name='serial'], input[ng-model='order.subforms.auto.serial']"
                    );
                    if (el) el.focus();
                  }, 50);

                  // Si necesitas digest por estar en setTimeout:
                  if (!$scope.$$phase) $scope.$applyAsync();
                });
                return; // 🚫 cortas el flujo: NO guarda
              }
            }
          }
          if (!order.subforms.auto.policy_type) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORTYPEAUTO, "error");
            return;
          }
        } else {
          if (!order.subforms.damage.damage_type) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Selecciona un tipo.", "error");
            return;
          }
        }
      }
      // if(!order.form.comision){
      //   l.stop();
      //   SweetAlert.swal("Error", MESSAGES.ERROR.COMISSION, "error");
      //   return;
      // }
      if (!order.form.payment) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORPAYFORM, "error");
        return;
      }
      if (param == "poliza") {
        if (!order.form.paquete) {
          l.stop();
          SweetAlert.swal("Error", "Elige un paquete", "error");
          return;
        }
        if (order.form.subramo.subramo_code == 1) {
          if (order.subforms.life.aseguradosList) {
            order.subforms.life.aseguradosList.forEach(function (asegs, index) {
              var idx = index + 1;
              if (asegs) {
                if (!asegs.first_name) {
                  l.stop();
                  flag_save_asegurado = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el nombre del asegurado  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!asegs.last_name) {
                  l.stop();
                  flag_save_asegurado = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el apellido paterno del asegurado  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!asegs.birthdate) {
                  l.stop();
                  flag_save_asegurado = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega la fecha de nacimiento del asegurado  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!asegs.sex) {
                  l.stop();
                  flag_save_asegurado = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el sexo del asegurado  #" + idx,
                    "error"
                  );
                  return;
                }
              }
            });
          }
          if (order.subforms.life.aseguradosList.length == 0) {
            l.stop();
            flag_save_asegurado = true;
            SweetAlert.swal("Error", "Agrega al menos 1 asegurado", "error");
            return;
          }

          // if(!order.subforms.life.first_name){
          //   l.stop();
          //   SweetAlert.swal("Error", "Agregue el nombre del asegurado", "error");
          //   return;
          // }
          // if(!order.subforms.life.last_name){
          //   l.stop();
          //   SweetAlert.swal("Error", "Agregue el apellido paterno del asegurado", "error");
          //   return;
          // }
          // if(!order.subforms.life.birthdate){
          //   l.stop();
          //   SweetAlert.swal("Error", "Agregue la fecha de nacimiento del asegurado", "error");
          //   return;
          // }
          // if(!order.subforms.life.sex){
          //   l.stop();
          //   SweetAlert.swal("Error", "Elige el sexo del asegurado", "error");
          //   return;
          // }
          // if(!order.subforms.life.smoker){
          //   l.stop();
          //   SweetAlert.swal("Error", "Responde si fuma o no el asegurado", "error");
          //   return;
          // }
          if (order.subforms.life.beneficiariesList) {
            order.subforms.life.beneficiariesList.forEach(function (
              beneficiary,
              index
            ) {
              var idx = index + 1;
              if (beneficiary.person == 1) {
                if (!beneficiary.first_name) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el nombre del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!beneficiary.last_name) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el apellido paterno del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!beneficiary.birthdate) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega la fecha de nacimiento del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!beneficiary.sex) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el sexo del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!beneficiary.percentage) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el porcentaje del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
              } else if (beneficiary.person == 2) {
                if (!beneficiary.j_name) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega la razón social del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!beneficiary.rfc) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el RFC del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
              }
            });
          }
        }
        if (order.form.subramo.subramo_code == 3) {
          if (!order.subforms.disease.first_name) {
            l.stop();
            SweetAlert.swal("Error", "Agregue el nombre del titular", "error");
            return;
          }
          if (!order.subforms.disease.last_name) {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Agregue el apellido paterno del titular",
              "error"
            );
            return;
          }
          if (!order.subforms.disease.birthdate) {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Agregue la fecha de nacimiento del titular",
              "error"
            );
            return;
          }
          if (!order.subforms.disease.sex) {
            l.stop();
            SweetAlert.swal("Error", "Elige el sexo del titular", "error");
            return;
          }
          if (order.subforms.disease.relationshipList) {
            order.subforms.disease.relationshipList.forEach(function (
              dependent,
              index
            ) {
              var idx = index + 1;
              if (!dependent.first_name) {
                l.stop();
                flag_save_dependent = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega el nombre del dependiente  #" + idx,
                  "error"
                );
                return;
              }
              if (!dependent.last_name) {
                l.stop();
                flag_save_dependent = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega el apellido paterno del dependiente  #" + idx,
                  "error"
                );
                return;
              }
              if (!dependent.relationship) {
                l.stop();
                flag_save_dependent = true;
                SweetAlert.swal(
                  "Error",
                  "Elige el parentesco del dependiente  #" + idx,
                  "error"
                );
                return;
              }
              if (!dependent.birthdate) {
                l.stop();
                flag_save_dependent = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega la fecha de nacimiento del dependiente  #" + idx,
                  "error"
                );
                return;
              }
              if (!dependent.sex) {
                l.stop();
                flag_save_dependent = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega el sexo del dependiente  #" + idx,
                  "error"
                );
                return;
              }
            });
          }
        }
        if (order.form.subramo.subramo_code == 7) {
          if (!order.subforms.damage.insured_item) {
            l.stop();
            SweetAlert.swal("Error", "Agrega el bien asegurado", "error");
            return;
          }
        }
        if (order.form.subramo.subramo_code == 9) {
          if (!order.subforms.auto.brand) {
            l.stop();
            SweetAlert.swal("Error", "Agrega la marca del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.model) {
            l.stop();
            SweetAlert.swal("Error", "Agrega el modelo del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.year) {
            l.stop();
            SweetAlert.swal("Error", "Elige el año del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.version) {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Agrega la versión del automóvil",
              "error"
            );
            return;
          }
          if (!order.subforms.auto.serial) {
            l.stop();
            SweetAlert.swal("Error", "Agrega la serie del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.usage) {
            l.stop();
            SweetAlert.swal("Error", "Elige el uso del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.service) {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Agrega el servicio del automóvil",
              "error"
            );
            return;
          }
        }
        if ($scope.arrayCoverage) {
          for (var i = 0; i < $scope.arrayCoverage.length; i++) {
            if (
              $scope.arrayCoverage[i].deductibleInPolicy ||
              $scope.arrayCoverage[i].sumInPolicy
            ) {
              $scope.count_coverage++;
            }
            // if(i+1 == $scope.arrayCoverage.length){
            //   if($scope.count_coverage == 0){
            //     l.stop();
            //     SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
            //     return;
            //   }
            // }
          }
        }
        if ($scope.arrayCoverage && $scope.arrayCoverage.length == 0) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
          return;
        }
        if (order.receipts.length == 0) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        } else {
          var flag_save = false;
          order.receipts.forEach(function (receipt) {
            if (!receipt.fecha_inicio || !receipt.fecha_fin) {
              l.stop();
              flag_save = true;
              SweetAlert.swal("Error", MESSAGES.ERROR.RECEIPTSDATES, "error");
              return;
            }
          });
          if (flag_save == true) {
            l.stop();
            return;
          }
          var sinceReceipt = toDate(order.receipts[0].fecha_inicio).getTime();
          var untilReceipt = toDate(
            order.receipts[order.receipts.length - 1].fecha_fin
          ).getTime();
        }
        if (since != sinceReceipt) {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.DATESOUT, "error");
          return;
        }
        if (until != untilReceipt) {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.DATESOUT, "error");
          return;
        } else {
          if (flag_save_dependent == false && flag_save_asegurado == false) {
            if ($scope.arrayCoverage.length == $scope.count_coverage) {
              l.stop();
              if (value == 1) {
                order.save.saveInsurance();
              } else if (value == 2) {
                order.save.cloneInsurance();
              }
            } else {
              SweetAlert.swal(
                {
                  title: "Coberturas sin datos",
                  text: "Las coberturas sin suma asegurda y sin deducible no se guardarán, ¿Estás seguro de continuar?",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Si",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                },
                function (isConfirm) {
                  if (isConfirm) {
                    swal.close();
                    l.stop();
                    if (value == 1) {
                      order.save.saveInsurance();
                    } else if (value == 2) {
                      order.save.cloneInsurance();
                    }
                  } else {
                    l.stop();
                  }
                }
              );
            }
          }
        }
      }
    };

    $scope.changeDomiciliado = function () {
      if (order.form.domiciliado) {
        $scope.change_domiciliado = true;
      } else {
        $scope.change_domiciliado = false;
      }
    };

    $scope.changeIva = function (parValue) {
      if (!parValue) {
        swal("La póliza se creará sin IVA.");
      }
    };

    order.receiptOptions = {};

    order.receipts = [];
    order.defaults.showReceipts = true;
    order.amountReceipts = 0;
    order.poliza = {
      primaNeta: 0,
      descuento: null,
      rpf: null,
      derecho: 0,
      subTotal: 0,
      iva: null,
      primaTotal: 0,
      payment: $stateParams.myInsurance.forma_de_pago,
    };
    order.recalcular = true;
    if (!myInsurance) {
      insuranceService.getInsuranceRead($stateParams).then(function (response) {
        myInsurance = response;
        activate();
        getInternalNumber();
        order.show.isPolicy = helpers.isPolicy(myInsurance);
      });
    } else {
      activate();
      getInternalNumber();
      order.show.isPolicy = helpers.isPolicy(myInsurance);
    }

    function ceder_comision(flag) {
      if (order.form.ceder_comision == true) {
        if (flag == true) {
          SweetAlert.swal(
            {
              title: "Ceder comisión",
              text: "¿Estas seguro de que deseas ceder la comisión?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Si, estoy seguro.",
              cancelButtonText: "Cancelar",
              closeOnConfirm: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                $scope.ceder_comision = order.form.ceder_comision;
              } else {
                order.form.ceder_comision = false;
              }
            }
          );
        } else {
          $scope.ceder_comision = order.form.ceder_comision;
        }
      } else {
        $scope.ceder_comision = order.form.ceder_comision;
      }
    }
    // ---------------change comision
    // change comision --------------

    $scope.checkEndDate = function () {
      $scope.calcularDias();
    };

    $scope.calcularDias = function () {
      var date_initial = order.form.startDate.split("/");
      var diaI = parseInt(date_initial[0]);
      var mesI = parseInt(date_initial[1]);
      var anioI = parseInt(date_initial[2]);
      var date_final = order.form.endingDate.split("/");
      var diaF = parseInt(date_final[0]);
      var mesF = parseInt(date_final[1]);
      var anioF = parseInt(date_final[2]);

      var date1 = new Date(mesI + "/" + diaI + "/" + anioI);
      var date2 = new Date(mesF + "/" + diaF + "/" + anioF);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      order.form.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );
      if (isNaN(order.form.policy_days_duration)) {
        order.form.policy_days_duration = 365;
      }
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    // $scope.save_info_tab = function(){
    //   var draft = ensureRenovationDraft();
    //   console.log('fraaaaaaa',draft)
    //   if (!order.form.payment) {
    //     order.form.payment = {};
    //     order.form.payment.value = order.form.payment && order.form.payment.value ? order.form.payment : myInsurance.forma_de_pago  ? myInsurance.forma_de_pago : 1;
    //   }
    //   draft['id'] = $scope.polizaId;
    //   draft['identifier'] = order.form.identifier;
    //   draft['business_line'] = order.form.business_line;
    //   if(order.form.celula){
    //     draft['celula'] = order.form.celula.url;
    //   }
    //   draft['f_currency'] = order.f_currency.f_currency_selected;
    //   draft['folio'] = order.form.folio;
    //   draft['poliza'] = order.form.poliza;
    //   draft['conducto_de_pago'] = order.conducto_de_pago.conducto_de_pago_selected;
    //   draft['sucursal'] = order.form.sucursal;
    //   draft['payment'] = order.form.payment && order.form.payment.value ? order.form.payment.value : myInsurance.forma_de_pago  ? myInsurance.forma_de_pago : 1;
    //   draft['folio'] = order.form.folio;
    //   draft['poliza'] = order.form.poliza;
    //   draft['paquete'] = order.form.paquete;
    //   draft['is_renewable'] = order.renewal.is_renewable;
    //   draft['responsable'] = order.form.responsable;
    //   draft['collection_executive'] = order.form.collection_executive;
    //   draft['automobiles_policy'] = order.subforms.auto;
    //   if(order.subforms.damage){
    //     draft['damages_policy'] = [];
    //     var obj = order.subforms.damage;
    //     draft['damages_policy'].push(obj)
    //   }else{
    //     draft['damages_policy'] = [];
    //   }
    //   draft['accidents_policy'] = myInsurance.accidents_policy;
    //   if(draft['accidents_policy'].length){
    //     draft['accidents_policy'][0]['personal']['second_last_name'] = order.subforms.disease.second_last_name
    //   }
    //   draft['life_policy'] = angular.copy(myInsurance.life_policy);
    //   if(draft['life_policy'].length){
    //     draft['life_policy'][0]['personal'] = order.subforms.life;
    //     draft['life_policy'][0]['beneficiaries_life'] = order.subforms.life.beneficiariesList;
    //   }
    //   draft['personal_life_policy'] = angular.copy(myInsurance.personal_life_policy);
    //   if(draft['personal_life_policy'].length){
    //     for(var i = 0; i < draft['personal_life_policy'].length; i++){
    //       draft['personal_life_policy'][i]['first_name'] = order.subforms.life.aseguradosList[i].first_name;
    //       draft['personal_life_policy'][i]['last_name'] = order.subforms.life.aseguradosList[i].last_name;
    //       draft['personal_life_policy'][i]['second_last_name'] = order.subforms.life.aseguradosList[i].second_last_name;
    //       draft['personal_life_policy'][i]['sex'] = order.subforms.life.aseguradosList[i].sex;
    //       draft['personal_life_policy'][i]['smoker'] = order.subforms.life.aseguradosList[i].smoker;
    //     }
    //   }
    //   draft['coverageInPolicy_policy'] = order.defaults.coverages;
    // }

    $scope.changeBusinessLine = function () {
      // $scope.save_info_tab();
    };
    $scope.changeCelula = function () {
      // $scope.save_info_tab();
    };
    $scope.changeCurrency = function () {
      // $scope.save_info_tab();
    };
    $scope.changeConducto = function () {
      // $scope.save_info_tab();
    };
    $scope.sucursal = function () {
      // $scope.save_info_tab();
    };
    $scope.changeFrequency = function () {
      // $scope.save_info_tab();
    };
    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      order.loading = true;
      $scope.accesos = $sessionStorage.permisos;
      if ($scope.accesos) {
        $scope.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            order.acceso_polizas = perm;
            order.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  order.acceso_adm_pol = true;
                } else {
                  order.acceso_adm_pol = false;
                }
              }
              if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  order.acceso_ver_pol = true;
                } else {
                  order.acceso_ver_pol = false;
                }
              }
              if (acc.permission_name == "Cancelar pólizas") {
                if (acc.checked == true) {
                  order.acceso_canc_pol = true;
                } else {
                  order.acceso_canc_pol = false;
                }
              }
              if (acc.permission_name == "Eliminar pólizas") {
                if (acc.checked == true) {
                  order.acceso_elim_pol = true;
                } else {
                  order.acceso_elim_pol = false;
                }
              }
              if (acc.permission_name == "Comisión no obligatoria") {
                if (acc.checked == true) {
                  order.acceso_cno_pol = true;
                } else {
                  order.acceso_cno_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            order.acceso_reportes = perm;
            order.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  order.acceso_rep_fia = true;
                } else {
                  order.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  order.acceso_rep_sin = true;
                } else {
                  order.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  order.acceso_rep_end = true;
                } else {
                  order.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  order.acceso_rep_pol = true;
                } else {
                  order.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  order.acceso_rep_ren = true;
                } else {
                  order.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  order.acceso_rep_cob = true;
                } else {
                  order.acceso_rep_cob = false;
                }
              }
            });
          }
          if (perm.model_name == "Ordenes de trabajo") {
            order.acceso_ot = perm;
            order.acceso_ot.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar OTs") {
                if (acc.checked == true) {
                  order.acceso_adm_ot = true;
                } else {
                  order.acceso_adm_ot = false;
                }
              } else if (acc.permission_name == "Ver OTs") {
                if (acc.checked == true) {
                  order.acceso_ver_ot = true;
                } else {
                  order.acceso_ver_ot = false;
                }
              } else if (acc.permission_name == "Cancelar OTs") {
                if (acc.checked == true) {
                  order.acceso_canc_ot = true;
                } else {
                  order.acceso_canc_ot = false;
                }
              } else if (acc.permission_name == "Eliminar OTs") {
                if (acc.checked == true) {
                  order.acceso_elim_ot = true;
                } else {
                  order.acceso_elim_ot = false;
                }
              }
            });
          }
          if (perm.model_name == "Contratantes y grupos") {
            order.acceso_contg = perm;
            order.acceso_contg.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar contratantes y grupos") {
                if (acc.checked == true) {
                  order.acceso_adm_cont = true;
                } else {
                  order.acceso_adm_cont = false;
                }
              } else if (acc.permission_name == "Ver contratantes y grupos") {
                if (acc.checked == true) {
                  order.acceso_ver_cont = true;
                } else {
                  order.acceso_ver_cont = false;
                }
              }
            });
          }
          if (perm.model_name == "Siniestros") {
            order.acceso_sin = perm;
            order.acceso_sin.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar siniestros") {
                if (acc.checked == true) {
                  order.acceso_adm_sin = true;
                } else {
                  order.acceso_adm_sin = false;
                }
              }
            });
          }
          if (perm.model_name == "Mensajeria") {
            order.acceso_mns = perm;
            order.acceso_mns.permissions.forEach(function (acc) {
              if (acc.permission_name == "Mensajeria") {
                if (acc.checked == true) {
                  order.acceso_mns = true;
                } else {
                  order.acceso_mns = false;
                }
              }
            });
          }
          if (perm.model_name == "Formatos") {
            order.acceso_form = perm;
            order.acceso_form.permissions.forEach(function (acc) {
              if (acc.permission_name == "Formatos") {
                if (acc.checked == true) {
                  order.acceso_form = true;
                } else {
                  order.acceso_form = false;
                }
              }
            });
          }
          if (perm.model_name == "Correos electronicos") {
            order.acceso_correo = perm;
            order.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  order.acceso_cor = true;
                } else {
                  order.acceso_cor = false;
                }
              }
            });
          }
          if (perm.model_name == "Cobranza") {
            order.acceso_cob = perm;
            order.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  order.acceso_ver_cob = true;
                } else {
                  order.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  order.acceso_desp_cob = true;
                } else {
                  order.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  order.acceso_pag_cob = true;
                } else {
                  order.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  order.acceso_desco_cob = true;
                } else {
                  order.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  order.acceso_conc_cob = true;
                } else {
                  order.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  order.acceso_liq_cob = true;
                } else {
                  order.acceso_liq_cob = false;
                }
              }
            });
          }
          if (perm.model_name == "Referenciadores") {
            order.acceso_ref = perm;
            order.acceso_ref.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar referenciadores") {
                if (acc.checked == true) {
                  order.acceso_adm_ref = true;
                } else {
                  order.acceso_adm_ref = false;
                }
              } else if (acc.permission_name == "Pagar a referenciadores") {
                if (acc.checked == true) {
                  order.acceso_pag_ref = true;
                } else {
                  order.acceso_pag_ref = false;
                }
              } else if (
                acc.permission_name == "Cambiar refrenciador en pólizas"
              ) {
                if (acc.checked == true) {
                  order.acceso_chg_ref = true;
                } else {
                  order.acceso_chg_ref = false;
                }
              } else if (
                acc.permission_name == "Referenciador no obligatorio"
              ) {
                if (acc.checked == true) {
                  order.acceso_obl_ref = false;
                } else {
                  order.acceso_obl_ref = true;
                }
              } else if (acc.permission_name == "Ver referenciadores") {
                if (acc.checked == true) {
                  order.acceso_ver_ref = true;
                } else {
                  order.acceso_ver_ref = false;
                }
              }
            });
          }
          if (perm.model_name == "Comisiones") {
            order.acceso_dash = perm;
            order.acceso_dash.permissions.forEach(function (acc) {
              if (acc.permission_name == "Comisiones") {
                if (acc.checked == true) {
                  order.permiso_comisiones = true;
                } else {
                  order.permiso_comisiones = false;
                }
              }
            });
          }
          if (perm.model_name == "Archivos") {
            order.acceso_files = perm;
            order.acceso_files.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  order.permiso_archivos = true;
                } else {
                  order.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  order.permiso_administrar_adjuntos = true;
                } else {
                  order.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
        });
      }
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          $scope.statesArray = data.data;
        });

      order.defaults.getContractorsByGroup();

      loadingThing("provider");
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        aThingIsDone("provider");
        loadingThing("insurance");
        order.form.startDate = myInsurance.start_of_validity
          ? convertDate(myInsurance.start_of_validity)
          : convertDate(new Date());
        order.defaults.providers = data.data;
        insuranceService
          .getInsuranceData(myInsurance)
          .then(function (insuranceData) {
            $scope.polizaId = angular.copy(insuranceData.id);
            $scope.saveInsuranceData = angular.copy(insuranceData);
            $scope.serialBase = null;
            if (
              $scope.saveInsuranceData &&
              $scope.saveInsuranceData.automobiles_policy &&
              $scope.saveInsuranceData.automobiles_policy[0]
            ) {
              $scope.serialBase =
                $scope.saveInsuranceData.automobiles_policy[0].serial || null;
            }
            if (
              hasRenovationDraft() &&
              renovationDraft &&
              renovationDraft.aseguradora &&
              renovationDraft.aseguradora.id
            ) {
              if (insuranceData.id == renovationDraft.id) {
                insuranceData = $scope.saveInsuranceData
                  ? $scope.saveInsuranceData
                  : renovationDraft;
                order.form.poliza = "";
                order.form.folio = renovationDraft.folio;
                $http
                  .get(
                    url.IP +
                      "claves-by-provider/" +
                      renovationDraft.aseguradora.id
                  )
                  .then(function (clavesResponse) {
                    clavesResponse.data.forEach(function (clave) {
                      clave.clave_comision.forEach(function (item) {
                        item.efective_date = new Date(item.efective_date)
                          .toISOString()
                          .split("T")[0];
                        if (order.form.subramo) {
                          if (item.subramo == order.form.subramo.subramo_name) {
                            order.form.comision_percent = parseFloat(
                              item.comission
                            );
                            order.form.udi = parseFloat(item.udi);
                          }
                        } else {
                          order.form.comision_percent = 0;
                          order.form.udi = 0;
                        }
                      });
                    });

                    order.defaults.claves = clavesResponse.data;
                    if (order.defaults.claves.length == 1) {
                      order.form.clave = order.defaults.claves[0];
                    }

                    $scope.comisiones_poliza = [];
                    for (var i = 0; i < order.defaults.claves.length; i++) {
                      if (
                        order.form.clave.name == order.defaults.claves[i].name
                      ) {
                        $scope.clave_poliza = order.defaults.claves[i];
                      }
                    }
                    order.form.comisiones = $scope.comisiones_poliza;
                  });
                insuranceData.automobiles_policy =
                  renovationDraft.automobiles_policy;
                order.subforms.auto = renovationDraft.automobiles_policy;
                insuranceData.damages_policy = renovationDraft.damages_policy;

                if (insuranceData.damages_policy) {
                  if (insuranceData.subramo.subramo_code == 6) {
                    order.types_myt.forEach(function (item) {
                      if (
                        item.name == insuranceData.damages_policy[0].damage_type
                      ) {
                        order.subforms.damage.damage_type = item;
                      }
                    });
                  }
                }
                insuranceData.accidents_policy =
                  renovationDraft.accidents_policy;
                insuranceData.life_policy = renovationDraft.life_policy;
                if (insuranceData.life_policy) {
                  if (insuranceData.life_policy.length) {
                    insuranceData.life_policy[0].beneficiaries_life.forEach(
                      function (item) {
                        try {
                          item.birthdate = datesFactory.toDate(item.birthdate);
                        } catch (e) {}
                        try {
                          item.antiguedad = datesFactory.toDate(
                            item.antiguedad
                          );
                        } catch (e) {}
                      }
                    );
                  }
                  insuranceData.personal_life_policy = angular.copy(
                    renovationDraft.personal_life_policy
                  );
                }
              }
            }

            $scope.ramo_code = insuranceData.ramo.ramo_code;
            $scope.subramo_code = insuranceData.subramo.subramo_code;
            order.f_currency.f_currency_selected = insuranceData.f_currency;
            order.conducto_de_pago.conducto_de_pago_selected =
              insuranceData.conducto_de_pago
                ? insuranceData.conducto_de_pago
                : myInsurance.conducto_de_pago
                ? myInsurance.conducto_de_pago
                : 1;

            insuranceService.getVendors().then(
              function success(data) {
                data.data.forEach(function (u) {
                  u.first_name = u.first_name.toUpperCase();
                  u.last_name = u.last_name.toUpperCase();
                  u.name =
                    u.first_name.toUpperCase() +
                    " " +
                    u.last_name.toUpperCase();
                });
                order.vendors = data.data;
                $scope.referenciador = data.data;
                order.vendors.forEach(function (vendor) {
                  vendor.name = vendor.first_name + " " + vendor.last_name;
                });
                $scope.referenciador.forEach(function (vendor) {
                  vendor.name = vendor.first_name + " " + vendor.last_name;
                });
              },
              function error(error) {
                toaster.ERROR("No pudieron ser cargados eferenciadores");
              }
            );
            $http.get(url.IP + "usuarios/").then(function (user) {
              user.data.results.forEach(function (u) {
                u.first_name = u.first_name.toUpperCase();
                u.last_name = u.last_name.toUpperCase();
                u.name =
                  u.first_name.toUpperCase() + " " + u.last_name.toUpperCase();
              });
              $scope.users = user.data.results;
              order.responsables = user.data.results;
              order.ejecutivos = user.data.results;
              order.responsables.forEach(function (responsable) {
                responsable.name =
                  responsable.first_name + " " + responsable.last_name;
              });
              order.ejecutivos.forEach(function (collection_executive) {
                collection_executive.name =
                  collection_executive.first_name +
                  " " +
                  collection_executive.last_name;
              });
            });
            order.form.identifier = insuranceData.identifier;
            if ($scope.orgName == "gpi") {
              order.form.identifier = "GENERAL";
            }
            order.form.f_currency = insuranceData.f_currency;
            order.form.conducto_de_pago = insuranceData.conducto_de_pago;
            $scope.change_domiciliado = insuranceData.domiciliada;
            order.form.domiciliado = insuranceData.domiciliada;
            order.form.startDate = insuranceData.start_of_validity;

            order.form.aseguradora = insuranceData.aseguradora;
            if (order.form.aseguradora) {
              order.options.changeProvider(order.form.aseguradora);
            }

            // var initDate = new Date(insuranceData.start_of_validity);
            // var endDate = new Date(insuranceData.end_of_validity);
            var initDate = new Date(insuranceData.end_of_validity);
            var endDate = initDate;
            var date1_ = new Date(insuranceData.start_of_validity);
            var date2_ = new Date(insuranceData.end_of_validity);

            var timeDiff_ = Math.abs(date2_.getTime() - date1_.getTime());
            // order.form.policy_days_duration = Math.ceil(timeDiff_ / (1000 * 3600 * 24));
            /* Comment two next lines for fix one day extra in init date*/
            order.form.address = insuranceData.address;
            order.form.clave = insuranceData.clave;
            order.form.business_line = insuranceData.business_line;
            order.form.internal_number = insuranceData.internal_number;
            order.form.observations = insuranceData.observations;
            order.form.hospital_level = insuranceData.hospital_level
              ? insuranceData.hospital_level
              : "";
            order.form.tabulator = insuranceData.tabulator
              ? insuranceData.tabulator
              : "";
            order.form.poliza = "";
            order.form.folio = insuranceData.folio ? insuranceData.folio : "";
            if (insuranceData.damages_policy) {
              if (insuranceData.subramo.subramo_code == 6) {
                order.types_myt.forEach(function (item) {
                  if (
                    item.name == insuranceData.damages_policy[0].damage_type
                  ) {
                    order.subforms.damage.damage_type = item.id;
                  }
                });
              }
            }
            if (!order.form.payment) {
              order.form.payment = {};
              order.form.payment.value =
                order.form.payment && order.form.payment.value
                  ? order.form.payment
                  : myInsurance.forma_de_pago
                  ? myInsurance.forma_de_pago
                  : 1;
            }
            insuranceContractor = insuranceData.contractor
              ? insuranceData.contractor
              : insuranceData.contratante
              ? insuranceData.contratante
              : undefined;
            if (insuranceData.celula) {
              $http.get(insuranceData.celula).then(function (response) {
                order.form.celula = response.data;
              });
            }

            if (insuranceData.grouping_level) {
              $http
                .get(
                  url.IP + "groupinglevel/" + insuranceData.grouping_level.id
                )
                .then(function (response) {
                  order.form.grouping_level = response.data;
                  $scope.info_sub = insuranceData;
                  $scope.changeAgrupacion(order.form.grouping_level);
                });
            }
            if (insuranceData.coverageInPolicy_policy) {
              order.defaults.coverages = insuranceData.coverageInPolicy_policy;
            }
            try {
              insuranceData.vendor.name =
                insuranceData.vendor.first_name +
                " " +
                insuranceData.vendor.last_name;
              order.form.vendor = insuranceData.vendor;
              $scope.original_vendor = insuranceData.vendor;
            } catch (e) {}
            try {
              insuranceData.responsable.name =
                insuranceData.responsable.first_name +
                " " +
                insuranceData.responsable.last_name;
              order.form.responsable = insuranceData.responsable;
              $scope.original_responsable = insuranceData.responsable;
            } catch (e) {}
            try {
              insuranceData.collection_executive.name =
                insuranceData.collection_executive.first_name +
                " " +
                insuranceData.collection_executive.last_name;
              order.form.collection_executive =
                insuranceData.collection_executive;
              $scope.original_collection_executive =
                insuranceData.collection_executive;
            } catch (e) {}
            try {
              if (insuranceData.sucursal) {
                insuranceData.sucursal.sucursal_name =
                  insuranceData.sucursal.sucursal_name +
                  " - " +
                  insuranceData.sucursal.details;
                $scope.order.form.sucursal = insuranceData.sucursal;
                $scope.original_sucursal = insuranceData.sucursal;
              }
            } catch (e) {
              console.log(e);
            }
            if (!insuranceData.ref_policy) {
              insuranceData.ref_policy = [];
              insuranceData.ref_policy =
                insuranceData.ref_policy && insuranceData.ref_policy
                  ? insuranceData.ref_policy
                  : myInsurance.ref_policy
                  ? myInsurance.ref_policy
                  : [];
            }
            if (insuranceData.ref_policy) {
              try {
                if (insuranceData.ref_policy) {
                  insuranceData.ref_policy.forEach(function (refs) {
                    $http
                      .get(refs.referenciador)
                      .then(function success(response_ref_plicy) {
                        if (response_ref_plicy) {
                          refs.data = response_ref_plicy.data;
                          refs.referenciador = response_ref_plicy.data.url;
                          refs.data.comision_policy = refs.comision_vendedor;
                          refs.selectedRef = true;
                          $scope.referenciadores.push(refs);
                        }
                      });
                  });
                } else if (insuranceData.vendor) {
                  $scope.referenciadores = [];
                  $http
                    .get(insuranceData.vendor.url)
                    .then(function success(response_ref_plicy_vendor) {
                      var s_r =
                        response_ref_plicy_vendor.data.user_info
                          .info_vendedor[0].vendedor_subramos;
                      s_r.forEach(function (sr) {
                        if (
                          sr.subramo == insuranceData.subramo.subramo_code &&
                          sr.provider == insuranceData.aseguradora.id
                        ) {
                          if (response_ref_plicy_vendor) {
                            response_ref_plicy_vendor.data =
                              response_ref_plicy_vendor.data;
                            response_ref_plicy_vendor.referenciador =
                              response_ref_plicy_vendor.data.url;
                            response_ref_plicy_vendor.vendor =
                              response_ref_plicy_vendor.data.url;
                            response_ref_plicy_vendor.comision_vendedor =
                              sr.comision;
                            response_ref_plicy_vendor.data.comision_policy =
                              response_ref_plicy_vendor.comision_vendedor;
                            response_ref_plicy_vendor.selectedRef = true;
                            $scope.referenciadores.push(
                              response_ref_plicy_vendor
                            );
                          }
                        } else {
                          // $scope.referenciadores.push($scope.referenciador)
                        }
                      });
                    });
                } else {
                  $scope.referenciadores.push($scope.referenciador);
                }
              } catch (e) {
                $scope.referenciadores.push($scope.referenciador);
              }
            } else {
              $scope.referenciadores.push($scope.referenciador);
            }
            if ($scope.referenciadores.length == 0) {
              $scope.referenciadores.push($scope.referenciador);
            }

            // var init_date = new Date(initDate.setYear(initDate.getFullYear() + 1));
            var init_date = new Date(initDate);
            var end_date = new Date(endDate.setYear(endDate.getFullYear() + 1));
            order.form.startDate = convertDate(init_date);
            order.form.endingDate = convertDate(end_date);
            order.form.comision = insuranceData.comision;
            order.form.comision_percent = parseFloat(
              insuranceData.comision_percent
            );
            order.form.udi = parseFloat(insuranceData.udi);
            var insuranceContractor = insuranceData.contractor
              ? insuranceData.contractor
              : insuranceData.contratante
              ? insuranceData.contratante
              : undefined;
            $scope.checkEndDate();
            if (insuranceContractor) {
              // if(order.form.contratante.value){
              order.form.contratante.value = insuranceContractor;
              // }else{
              //   order.form.contratante = {value: insuranceContractor};
              // }

              order.form.contratante.email = order.form.contratante.value.email;
              order.form.contratante.phone_number =
                order.form.contratante.value.phone_number;
              order.defaults.address =
                insuranceContractor &&
                insuranceContractor.value &&
                insuranceContractor.value.address_contractor;
              if (order.form.contratante.value.full_name) {
                order.form.contratante.val =
                  order.form.contratante.value.full_name;
              } else {
                order.form.contratante.val = insuranceContractor.val;
              }

              if (order.form.contratante.length) {
                order.defaults.contractors.some(function (agent) {
                  if (agent.url == insuranceContractor.url) {
                    order.form.contratante.value = agent;
                  }
                });
              }
            }
            if (insuranceData.state_circulation) {
              if ($scope.statesArray) {
                $scope.statesArray.forEach(function (item) {
                  if (item.state == insuranceData.state_circulation) {
                    order.form.state_circulation = item;
                  }
                });
              }
            }
            if (insuranceData.aseguradora) {
              order.form.aseguradora = insuranceData.aseguradora;
              if (order.form.aseguradora.length) {
                order.defaults.providers.some(function (provider) {
                  if (provider.id == insuranceData.aseguradora.id) {
                    order.form.aseguradora = provider;
                    return true;
                  }
                });
              }
            }

            if (insuranceData.ramo) {
              var wait = [];

              wait.push(
                $http.get(
                  url.IP + "ramos-by-provider/" + order.form.aseguradora.id
                )
              );
              $q.all(wait).then(function (response) {
                order.defaults.ramos = response[0].data;

                order.defaults.ramos.some(function (ramo) {
                  if (ramo.id == insuranceData.ramo.id) {
                    order.form.ramo = ramo;
                    order.options.changeRamo(ramo);
                    // subramo and fill combos
                    order.defaults.subramos = ramo.subramo_ramo;

                    if (insuranceData.subramo) {
                      order.defaults.subramos.some(function (subramo) {
                        if (subramo.id == insuranceData.subramo.id) {
                          order.form.subramo = subramo;
                          order.options.changeSubramo(subramo);

                          var code = order.defaults.formInfo.code;

                          if (code === 9) {
                            // auto
                            if (insuranceData.automobiles_policy.length > 0) {
                              var subformInfo =
                                insuranceData.automobiles_policy[0];
                              order.subforms.auto = {
                                brand: subformInfo.brand,
                                service: subformInfo.service,
                                color: subformInfo.color,
                                created_at: subformInfo.created_at,
                                document_type: subformInfo.document_type,
                                engine: subformInfo.engine,
                                id: subformInfo.id,
                                license_plates: subformInfo.license_plates,
                                model: subformInfo.model,
                                policy: subformInfo.policy,
                                serial: subformInfo.serial,
                                sub_branch: subformInfo.sub_branch,
                                updated_at: subformInfo.updated_at,
                                url: subformInfo.url,
                                usage: subformInfo.usage,
                                version: subformInfo.version,
                                year: parseInt(subformInfo.year),
                                driver: subformInfo.driver,
                                adjustment: subformInfo.adjustment,
                                mont_adjustment: subformInfo.mont_adjustment,
                                special_team: subformInfo.special_team,
                                mont_special_team:
                                  subformInfo.mont_special_team,
                                beneficiary_name: subformInfo.beneficiary_name,
                                beneficiary_address:
                                  subformInfo.beneficiary_address,
                                beneficiary_rfc: subformInfo.beneficiary_rfc,
                                policy_type: subformInfo.policy_type,
                                procedencia: subformInfo.procedencia,
                                charge_type: subformInfo.charge_type,
                              };
                              $scope.usages.forEach(function (item) {
                                if (item.id == subformInfo.usage) {
                                  order.subforms.auto.usage = item.id;
                                }
                              });
                            }
                          } else if (code === 1 || code == 30) {
                            // vida
                            if (insuranceData.life_policy.length > 0) {
                              var subformInfo = insuranceData.life_policy[0];

                              loadingThing("personal");
                              // formService.getPersonalInfoByUri(subformInfo.personal.url)
                              //   .then(function(personalResponse) {
                              var personal = insuranceData.personal_life_policy;
                              if (!personal.length) {
                                personal =
                                  insuranceData.life_policy[0].personal;
                              }
                              order.subforms.life.smoker =
                                subformInfo.smoker == undefined
                                  ? ""
                                  : subformInfo.smoker
                                  ? "True"
                                  : "False";
                              // order.subforms.life.beneficiariesList = [];
                              if (insuranceData.personal_life_policy.length) {
                                insuranceData.personal_life_policy.forEach(
                                  function (pers) {
                                    var asegs = {
                                      birthdate: convertDate(pers.birthdate),
                                      antiguedad: pers.antiguedad
                                        ? convertDate(pers.antiguedad)
                                        : null,
                                      first_name: pers.first_name,
                                      last_name: pers.last_name,
                                      second_last_name: pers.second_last_name,
                                      url: pers.url,
                                      sex: pers.sex,
                                      smoker: pers.smoker
                                        ? pers.smoker
                                        : "False",
                                      policy_type: pers.policy_type,
                                    };
                                    console.log("ooiiooo", pers);
                                    if (asegs.smoker == true) {
                                      asegs.smoker = "True";
                                    } else if (asegs.smoker == false) {
                                      asegs.smoker = "False";
                                    }
                                    order.options.life.asegurados.add(asegs);
                                  }
                                );
                              } else {
                                try {
                                  var personal_antig = personal;
                                  var prs_life = {
                                    birthdate: convertDate(
                                      personal_antig.birthdate
                                    ),
                                    antiguedad: personal_antig.antiguedad
                                      ? convertDate(personal_antig.antiguedad)
                                      : null,
                                    first_name: personal_antig.first_name,
                                    last_name: personal_antig.last_name,
                                    second_last_name:
                                      personal_antig.second_last_name,
                                    url: personal_antig.url,
                                    sex: personal_antig.sex,
                                    smoker: personal_antig.smoker
                                      ? personal_antig.smoker
                                      : "False",
                                    policy_type: pers.policy_type,
                                  };
                                  if (prs_life.smoker == true) {
                                    prs_life.smoker = "True";
                                  } else if (prs_life.smoker == false) {
                                    prs_life.smoker = "False";
                                  }
                                  order.options.life.asegurados.add(prs_life);
                                  order.subforms.life.smoker =
                                    subformInfo.smoker == undefined
                                      ? ""
                                      : subformInfo.smoker
                                      ? "True"
                                      : "False";
                                } catch (e) {}
                              }
                              // order.subforms.life.first_name = subformInfo.personal.first_name;
                              // order.subforms.life.last_name = subformInfo.personal.last_name;
                              // order.subforms.life.second_last_name = subformInfo.personal.second_last_name;
                              // order.subforms.life.birthdate = datesFactory.convertDate(subformInfo.personal.birthdate)
                              // order.subforms.life.sex = subformInfo.personal.sex;
                              if (personal && personal.policy_type) {
                                var personal_antig_ = personal;
                                var prs_life_ = {
                                  birthdate: convertDate(
                                    personal_antig_.birthdate
                                  ),
                                  antiguedad: personal_antig_.antiguedad
                                    ? convertDate(personal_antig_.antiguedad)
                                    : null,
                                  first_name: personal_antig_.first_name,
                                  last_name: personal_antig_.last_name,
                                  second_last_name:
                                    personal_antig_.second_last_name,
                                  url: personal_antig_.url,
                                  sex: personal_antig_.sex,
                                  smoker: personal_antig_.smoker
                                    ? personal_antig_.smoker
                                    : "False",
                                  policy_type: personal_antig_.policy_type,
                                };
                                if (prs_life_.smoker == true) {
                                  prs_life_.smoker = "True";
                                } else if (prs_life_.smoker == false) {
                                  prs_life_.smoker = "False";
                                }
                                order.subforms.life.aseguradosList.push(
                                  prs_life_
                                );
                              }
                              order.subforms.life.smoker =
                                subformInfo.smoker == undefined
                                  ? ""
                                  : subformInfo.smoker
                                  ? "True"
                                  : "False";

                              subformInfo.beneficiaries_life.forEach(function (
                                beneficiary
                              ) {
                                var ben = {
                                  birthdate: datesFactory.convertDate(
                                    beneficiary.birthdate
                                  ),
                                  antiguedad: beneficiary.antiguedad
                                    ? datesFactory.convertDate(
                                        beneficiary.antiguedad
                                      )
                                    : null,
                                  first_name: beneficiary.first_name,
                                  last_name: beneficiary.last_name,
                                  second_last_name:
                                    beneficiary.second_last_name,
                                  percentage: beneficiary.percentage,
                                  person: beneficiary.first_name ? 1 : 2,
                                  sex: beneficiary.sex,
                                  j_name: beneficiary.j_name,
                                  rfc: beneficiary.rfc,
                                  optional_relationship:
                                    beneficiary.optional_relationship,
                                };

                                order.options.life.beneficiary.add(ben);
                              });

                              aThingIsDone("personal");
                              // });
                            }
                          } else if (code === 2 || code === 3 || code === 4) {
                            if (insuranceData.accidents_policy.length > 0) {
                              var subformInfo =
                                insuranceData.accidents_policy[0];
                              loadingThing("personal");
                              formService
                                .getPersonalInfoByUri(subformInfo.personal.url)
                                .then(function (personalResponse) {
                                  subformInfo.personal = personalResponse.data;
                                  order.subforms.disease.sex =
                                    subformInfo.personal.sex;
                                  order.subforms.disease.coinsurance =
                                    subformInfo.coinsurance;
                                  order.subforms.disease.id = subformInfo.id;
                                  order.subforms.disease.url = subformInfo.url;
                                  order.subforms.disease.sub_branch =
                                    subformInfo.sub_branch;
                                  order.subforms.disease.policy =
                                    subformInfo.policy;
                                  order.subforms.disease.relationshipList = [];
                                  order.subforms.disease.first_name =
                                    subformInfo.personal.first_name;
                                  order.subforms.disease.personal_url =
                                    subformInfo.personal.url;
                                  order.subforms.disease.last_name =
                                    subformInfo.personal.last_name;
                                  order.subforms.disease.second_last_name =
                                    subformInfo.personal.second_last_name;
                                  order.subforms.disease.birthdate =
                                    datesFactory.convertDate(
                                      subformInfo.personal.birthdate
                                    );
                                  order.subforms.disease.antiguedad =
                                    subformInfo.personal.antiguedad
                                      ? datesFactory.convertDate(
                                          subformInfo.personal.antiguedad
                                        )
                                      : null;
                                  order.subforms.disease.policy_type =
                                    subformInfo.personal.policy_type
                                      ? subformInfo.personal.policy_type
                                      : 46;
                                  subformInfo.relationship_accident.forEach(
                                    function (relationship) {
                                      var rel = {
                                        birthdate: datesFactory.convertDate(
                                          relationship.birthdate
                                        ),
                                        antiguedad: relationship.antiguedad
                                          ? datesFactory.convertDate(
                                              relationship.antiguedad
                                            )
                                          : null,
                                        first_name: relationship.first_name,
                                        last_name: relationship.last_name,
                                        second_last_name:
                                          relationship.second_last_name,
                                        url: relationship.url,
                                        sex: null,
                                        relationship: relationship.relationship,
                                      };

                                      order.defaults.sex.some(function (sex) {
                                        if (sex.value == relationship.sex) {
                                          rel.sex = sex;
                                          return true;
                                        }
                                      });

                                      order.options.disease.types.some(
                                        function (type) {
                                          if (
                                            type.relationship ==
                                            relationship.relationship
                                          ) {
                                            rel.relationship = type;
                                            return true;
                                          }
                                        }
                                      );

                                      order.options.disease.relationships.add(
                                        rel
                                      );
                                    }
                                  );

                                  aThingIsDone("personal");
                                });
                            }
                          } else if (
                            code === 5 ||
                            code === 6 ||
                            code === 7 ||
                            code === 8 ||
                            code === 10 ||
                            code === 11 ||
                            code === 12 ||
                            code === 13 ||
                            code === 14 ||
                            code === 31
                          ) {
                            // daño general
                            if (insuranceData.damages_policy.length > 0) {
                              var subformInfo = insuranceData.damages_policy[0];
                              order.subforms.damage.coinsurance =
                                subformInfo.coinsurance;
                              order.subforms.damage.created_at =
                                subformInfo.created_at;
                              order.subforms.damage.damage_type =
                                subformInfo.damage_type;
                              order.subforms.damage.insured_item =
                                subformInfo.insured_item;
                              order.subforms.damage.item_address =
                                subformInfo.item_address;
                              order.subforms.damage.item_details =
                                subformInfo.item_details;
                              order.subforms.damage.policy = subformInfo.policy;
                              order.subforms.damage.sub_branch =
                                subformInfo.sub_branch;
                              order.subforms.damage.updated_at =
                                subformInfo.updated_at;
                              order.subforms.damage.url = subformInfo.url;
                              if (insuranceData.damages_policy) {
                                if (insuranceData.subramo.subramo_code == 6) {
                                  order.types_myt.forEach(function (item) {
                                    if (
                                      item.name ==
                                      insuranceData.damages_policy[0]
                                        .damage_type
                                    ) {
                                      order.subforms.damage.damage_type =
                                        item.id;
                                    }
                                  });
                                }
                              }
                            }
                          } else {
                          }

                          $q.all(order.defaults.waitElement).then(function (
                            packages
                          ) {
                            order.defaults.coverages = [];
                            if (insuranceData.paquete) {
                              order.form.paquete = insuranceData.paquete;
                              if (
                                insuranceData.paquete.coverage_package.length
                              ) {
                                var pack = insuranceData.paquete;
                                pack.coverage_package.forEach(function (
                                  element,
                                  index
                                ) {});
                              }

                              if (order.defaults.packages.length) {
                                order.defaults.packages.some(function (pkg) {
                                  if (pkg.id == insuranceData.paquete.id) {
                                    order.form.paquete = pkg;
                                    order.options.changePackage(pkg);
                                    order.defaults.coverages = [];
                                    if (
                                      myInsurance.coverageInPolicy_policy
                                        .length > 0
                                    ) {
                                      myInsurance.coverageInPolicy_policy.forEach(
                                        function (coverageInPolicy) {
                                          //https://miurabox.atlassian.net/browse/DES-428cambio lectura PDF
                                          var coverageInPackage =
                                            coverageInPolicy; //cambio lectura PDF
                                          // pkg.coverage_package.some(function(coverageInPackage) {
                                          // if (coverageInPolicy.coverage_name.toLowerCase() == coverageInPackage.coverage_name.toLowerCase()) {
                                          var flag = 0;
                                          coverageInPackage.sumInPolicy = {
                                            label: coverageInPolicy.sum_insured,
                                            value: coverageInPolicy.sum_insured,
                                          };

                                          coverageInPackage.deductibleInPolicy =
                                            {
                                              label:
                                                coverageInPolicy.deductible,
                                              value:
                                                coverageInPolicy.deductible,
                                            };
                                          coverageInPackage.primaInPolicy =
                                            coverageInPolicy.prima;
                                          coverageInPackage.coinsuranceInPolicy =
                                            coverageInPolicy.coinsurance;
                                          coverageInPackage.topeCoinsuranceInPolicy =
                                            coverageInPolicy.topecoinsurance;

                                          order.options.addCoverage(
                                            coverageInPackage
                                          );
                                          return true;
                                          // }
                                          // });
                                          //https://miurabox.atlassian.net/browse/DES-428cambio lectura PDF
                                        }
                                      );
                                    }
                                    pkg.coverage_package.forEach(function (
                                      element,
                                      index
                                    ) {});
                                  }
                                });
                              }
                            } else {
                              if (
                                myInsurance.coverageInPolicy_policy.length > 0
                              ) {
                                order.defaults.coverageList = [];
                                myInsurance.coverageInPolicy_policy.forEach(
                                  function (coverageInPolicy) {
                                    order.options.addCoverage(coverageInPolicy);
                                  }
                                );
                              }
                            }
                          });
                          if (insuranceData.forma_de_pago) {
                            order.defaults.payform.some(function (pf) {
                              if (
                                pf.value == insuranceData.forma_de_pago.value
                              ) {
                                order.options.isReceiptAvailable(pf, true);
                                return true;
                              }
                            });
                          }
                          // --------------------------d
                          order.defaults.comisiones = [];
                          if (order.form.clave) {
                            order.form.ceder_comision = false;
                            if (order.form.clave.clave_comision.length) {
                              order.form.clave.clave_comision.forEach(function (
                                item
                              ) {
                                if (
                                  order.form.subramo.subramo_name ==
                                  item.subramo
                                ) {
                                  order.defaults.comisiones.push(item);
                                  order.form.comisiones =
                                    order.defaults.comisiones;
                                }
                              });

                              if (order.defaults.comisiones) {
                                // if(!order.defaults.comisiones.length) {
                                //    SweetAlert.swal({
                                //       title: 'Error',
                                //       text: "Debe tener al menos una comisión capturada para la clave seleccionada",
                                //       type: "error",
                                //       showCancelButton: false,
                                //       confirmButtonColor: "#DD6B55",
                                //       confirmButtonText: "Aceptar",
                                //       closeOnConfirm: true
                                //   }, function(isConfirm) {
                                //       if (isConfirm) {
                                //         // $state.go('polizas.table');
                                //       }
                                //   });
                                // }
                              }

                              if (order.defaults.comisiones.length == 1) {
                                order.form.comision =
                                  order.defaults.comisiones[0].comission;
                                $scope.selectComision(order.form.comision);
                              }
                            }
                          }
                          // -d-------------------------------

                          insuranceData.recibos_poliza = [];

                          if (insuranceData.files) {
                            vm.files = insuranceData.files.results;
                          }
                          order.insuranceObject = insuranceData;
                          aThingIsDone("insurance");

                          return true;
                        }
                      });
                    }
                    return true;
                  }
                });
              });
            }
          });
      });

      dataFactory.post("celula_contractor_info/").then(function (response) {
        $scope.celulas = response.data;
      });

      dataFactory.get("groupingLevel-resume/").then(function (response) {
        $scope.agrupaciones = response.data;
      });

      dataFactory
        .get("sucursales-to-show-unpag/")
        .then(function success(response) {
          $scope.sucursalList = response.data;
        });
    }

    $scope.selectComision = function (param) {
      order.form.comision_percent = parseFloat(param.comission);
      order.form.udi = parseFloat(param.udi);
      order.form.comision_percent = parseFloat(param.comission);
      order.form.udi = parseFloat(param.udi);
      // order.form.comision = parseFloat(param.comission);
    };
    $scope.show_button_save_sum = false;
    $scope.show_button_save_ded = false;
    $scope.normalizeVINTest = function (v) {
      return (v || "").toString().trim().toUpperCase();
    };

    $scope.sameVIN = function (a, b) {
      return (
        $scope.normalizeVINTest(a) &&
        $scope.normalizeVINTest(a) === $scope.normalizeVINTest(b)
      );
    };

    $scope.hasInvalidVinLettersX = function (vin) {
      return /[OIQ]/i.test($scope.normalizeVIN(vin));
    };

    $scope.demo = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    $scope.saveSum = function (parValue, parCoverage) {
      var obj = {
        sum_insured: parValue,
        default: false,
        coverage_sum: parCoverage.url,
      };

      coverageService.createSumInsured(obj).then(function (req) {
        if (req.id) {
          $scope.result_ = false;
          parCoverage.sums_coverage.push(req);
        }
      });
    };

    $scope.saveDed = function (parValue, parCoverage) {
      var obj = {
        deductible: parValue,
        default: false,
        coverage_deductible: parCoverage.url,
      };

      coverageService.createDeducible(obj).then(function (req) {
        if (req.id) {
          $scope.result_ded = false;
          parCoverage.deductible_coverage.push(req);
        }
      });
    };

    function getFormData(form, vendor) {
      form.poliza_number = form.poliza ? form.poliza : "";
      form.contractor = form.contratante.url;
      form.internal_number = $scope.internal_number;

      form.folio = form.folio ? form.folio : null;
      form.aseguradora = form.aseguradora ? form.aseguradora.url : null;
      form.ramo = form.ramo ? form.ramo.url : null;
      form.subramo = form.subramo ? form.subramo.url : null;
      form.paquete = form.paquete ? form.paquete.url : null;
      form.observations = "";
      form.forma_de_pago = form.payment ? form.payment.value : null;
      form.old_policies = [];
      form.recibos_poliza = [];
      form.vendor = vendor;

      return form;
    }

    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
    };
    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    $scope.deleteFile = deleteFile;
    function deleteFile(file) {
      fileService.deleteFile(
        url.IP + "polizas/" + myInsurance.id + "/",
        file,
        vm.files,
        usr.role
      );
    }

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $scope.uploader.uploadAll();
      resetRenovationDraft();
    }

    /* Funciones de fechas */
    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function mesDiaAnio(parDate) {
      var d = new Date(toDate(parDate));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      return date;
    }

    /** Loading things **/
    function aThingIsDone(what) {
      stuffLoaded++;
      if (stuffLoaded >= thingsToLoad) {
        order.loading = false;
      }
    }

    function loadingThing(what) {
      thingsToLoad++;
      order.loading = true;
    }

    function canBeOT() {
      if (order.form.contratante) {
        return true;
      }
      SweetAlert.swal("Necesita seleccionar un contratante");
      return false;
    }

    function canBePoliza() {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      var flag = true;
      var code = parseInt(order.defaults.formInfo.code);

      if (!canBeOT()) {
        flag = false;
      }
      if (order.receipts.length == 0) {
        l.stop();
        flag = false;
        SweetAlert.swal("ERROR", MESSAGES.ERROR.RECEIPTSREQUIRED, "error");
      }

      if (!code) {
        flag = false;
        l.stop();
        SweetAlert.swal("Forma incompleta");
      } else if (code == 1 || code === 30) {
        //life
      } else if (code == 2 || code == 3 || code == 4) {
        //disease

        var subform = order.subforms.disease;
        if (
          subform.first_name == "" ||
          subform.last_name == "" ||
          subform.sex == "" ||
          !subform.first_name ||
          !subform.last_name ||
          !subform.sex
        ) {
          flag = false;
          SweetAlert.swal("Datos de formulario requerido");
          l.stop();
        }
      } else if (
        code == 5 ||
        code == 6 ||
        code == 7 ||
        code == 8 ||
        code == 10 ||
        code == 11 ||
        code == 12 ||
        code == 13 ||
        code == 14
      ) {
        var damage = order.subforms.damage;
        if (damage.insured_item == "" || !damage.insured_item) {
          flag = false;
          l.stop();
          SweetAlert.swal("Datos de formulario son requeridos, bien asegurado");
        }
      } else if (code == 9) {
        // auto
      }

      if (order.defaults.coverages.length == 0) {
        flag = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
        l.stop();
      }

      return flag;
    }
    // Calculadora de comisoones
    $scope.calculateComision = function (ref, index) {
      $rootScope.comVendedor = true;
      $scope.orderInfo = order;
      $localStorage.orderForm = JSON.stringify(order.form);

      var modalInstance = $uibModal.open({
        templateUrl: "app/ordenes/calculateComision.modal.html",
        controller: OrderComisionCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          referenciador: function () {
            return ref;
          },
          index: function () {
            return index;
          },
          form: function () {
            return order.form;
          },
          from: function () {
            return null;
          },
          primaTotal: function () {
            return order.poliza.primaTotal;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };
    // Calcular comisión ppor referenciador
    function OrderComisionCtrl(
      $scope,
      from,
      $sessionStorage,
      $uibModalInstance,
      referenciador,
      index,
      form,
      $http,
      MESSAGES,
      toaster,
      primaTotal
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $rootScope.valueMonto = primaTotal;
      $rootScope.valueComInicial = 0;
      $rootScope.valueComision = 0;
      if (referenciador) {
        $http.get(referenciador.referenciador).then(function (data) {
          if (data.status == 200 || data.status == 201) {
            if (data.data) {
              $rootScope.name =
                data.data.first_name + " " + data.data.last_name;
              if (data.data.user_info) {
                if (data.data.user_info.info_vendedor[0]) {
                  $rootScope.valueGo =
                    data.data.user_info.info_vendedor[0].gastos_operacion;
                }
              }
            }
          }
        });
      }
      // Change monto --> calc comision
      $scope.changeMonto = function (go, monto, com, comI) {
        if (isNaN(monto)) {
          var toNumber = $scope.formatearNumero(monto);
          if (isNaN(toNumber)) {
            $rootScope.valueMonto = "";
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        }
      };
      $scope.comCalculatePeso = function (monto, comision) {
        if (
          isNaN(monto) ||
          isNaN(comision) ||
          parseFloat(comision) > parseFloat(monto)
        ) {
          if (parseFloat(comision) > parseFloat(monto)) {
            SweetAlert.swal(
              "Error",
              "Cantidad capturada en comisión no puede ser mayor a la prima total",
              "error"
            );
            $rootScope.valueComision = 0;
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        } else {
          $rootScope.valueComision = parseFloat(
            (parseFloat(comision) * 100) / parseFloat(monto)
          ).toFixed(2);
        }
      };
      $scope.validComision = function (comI) {
        if (isNaN(comI)) {
          $rootScope.valueComInicial = 0;
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
        }
      };
      $scope.cTotal = function (monto, com, comVendedor) {
        referenciador.comision_vendedor = comVendedor;
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.cancelCalculate = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
      $scope.formatearNumero = function (nStr) {
        nStr += "";
        var x = nStr.split(".");
        var x1 = x[0];
        var x2 = x.length > 1 ? "." + x[1] : "";
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + "," + "$2");
        }

        return x1 + x2;
      };
    }
    // renovacion por PDF
    $scope.fileNameChanged = function (ele) {
      $scope.filePdf = ele.files[0];
      $scope.fileSelectedR = ele.files[0];
    };
    $scope.showFile = function (argument) {
      var reader = new FileReader();
      reader.readAsDataURL(argument.files[0]);
      $scope.fileSelectedR = argument.files[0];
      var reader_pdf = new FileReader();
      reader_pdf.readAsDataURL($scope.fileSelectedR);
      $scope.urlsfile = URL.createObjectURL(argument.files[0]);
      reader_pdf.onload = function () {
        $scope.pdffile = reader_pdf.result;
        $scope.okxfile = new Blob([$scope.pdffile], {
          type: "application/pdf",
        });
        var fileURL = $scope.urlsfile;
        $scope.content = $sce.trustAsResourceUrl(fileURL);
      };
      reader_pdf.onerror = function (error) {
        console.log("Error: ", error);
      };
    };
    // captura de la poliza PDF

    function sinDiacriticos(texto) {
      return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    $scope.checkNumSerie = function () {
      if (order.subforms.auto.serial) {
        helpers
          .existSerialRenovacion(
            order.subforms.auto.serial,
            $scope.saveInsuranceData.id
          )
          .then(function (request) {
            if (request.exist == true) {
              SweetAlert.swal(
                "Información",
                "La SERIE del AUTO ya existe en otra póliza vigente: " +
                  request.poliza,
                "info"
              );
              // order.subforms.auto.serial = '';
            }
          })
          .catch(function (err) {});
      }
    };

    function formatToMMDDYYYY(isoDateString) {
      if (!isoDateString) return "";
      var date = new Date(isoDateString);
      var month = (date.getMonth() + 1).toString().padStart(2, "0");
      var day = date.getDate().toString().padStart(2, "0");
      var year = date.getFullYear();
      return month + "/" + day + "/" + year;
    }
    function llenarInfoGm(aseguradora, clave) {
      order.show.ot = false;
      // ensureRenovationDraft()['activeJustified'] = 1;
      $scope.activeJustified = 1;
      order.show.ot = false;
      var date = new Date(order.form.startDate);
      if (isNaN(date)) {
        var date = new Date(mesDiaAnio(order.form.startDate));
      }
      if ($scope.read_pdf_ren.data["asegurados"]) {
        llenarAsegurados($scope.read_pdf_ren.data["asegurados"]);
      }
      $scope.paqueteOriginal = $scope.read_pdf_ren.data.cobertura;
      $http
        .get(url.IP + "claves-by-provider/" + order.form.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });
            order.defaults.claves = clavesResponse.data;
            if (order.defaults.claves.length == 1) {
              order.form.clave = order.defaults.claves[0];
              $scope.dataToSave.clave = order.form.clave.id;
              try {
                order.form.comision_percent = order.form.clave.comission;
                order.form.udi = order.form.clave.udi;
              } catch (e) {}
            }
            if (clave) {
              order.defaults.claves.forEach(function (item) {
                if (
                  item.clave.toString().replace(/\s/g, "") ===
                  clave.toString().replace(/\s/g, "")
                ) {
                  order.form.clave = item;
                }
              });
            }
            $http
              .get(url.IP + "ramos-by-provider/" + aseguradora.id)
              .then(function (ramo) {
                order.defaults.ramos = ramo.data;
                order.defaults.ramos.forEach(function (ramo) {
                  if (ramo.ramo_code == 2) {
                    order.form.ramo = ramo;
                    // $scope.save_info_tab()
                    order.defaults.subramos = ramo.subramo_ramo;
                    order.defaults.subramos.forEach(function (sub) {
                      if (sub.subramo_code == 3) {
                        order.form.subramo = sub;
                        // $scope.verComisiones();
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };

                        order.defaults.comisiones = [];

                        if (order.form.clave) {
                          if (order.form.clave.clave_comision.length) {
                            order.form.clave.clave_comision.forEach(function (
                              item
                            ) {
                              if (
                                order.form.subramo.subramo_name == item.subramo
                              ) {
                                order.defaults.comisiones.push(item);
                              }
                            });

                            order.form.comisiones = order.defaults.comisiones;
                            if (order.defaults.comisiones.length == 1) {
                              order.form.comision =
                                order.defaults.comisiones[0];
                              $scope.selectComision(order.form.comision);
                            }
                          }
                        }

                        $http
                          .post(url.IP + "paquetes-data-by-subramo/", {
                            ramo: order.form.ramo.id,
                            subramo: order.form.subramo.id,
                            provider: order.form.aseguradora.id,
                          })
                          .then(
                            function success(response) {
                              order.defaults.packages = [];
                              order.defaults.coverages = [];
                              $scope.paqueteSelected = false;
                              $scope.coberturasPackagePdf = [];
                              // $scope.read_pdf_ren.data.cobertura='PREMIER 200'
                              if (response.data.length) {
                                order.defaults.packages = response.data;
                                $scope.read_pdf_ren.data.cobertura =
                                  $scope.read_pdf_ren.data.cobertura.split(" ");
                                $scope.read_pdf_ren.data.cobertura =
                                  $scope.read_pdf_ren.data.cobertura[0];
                                if (
                                  $scope.read_pdf_ren.data.cobertura == "" ||
                                  $scope.read_pdf_ren.data.cobertura ==
                                    undefined
                                ) {
                                  $scope.read_pdf_ren.data.cobertura =
                                    "PREMIER 200";
                                }

                                order.defaults.packages.forEach(function (
                                  item
                                ) {
                                  // console.log(" comparando ",item.package_name,"con",$scope.read_pdf_ren.data.cobertura)
                                  if (
                                    item.package_name.toLowerCase() &&
                                    $scope.read_pdf_ren.data.cobertura.toLowerCase()
                                  ) {
                                    if (
                                      item.package_name.toLowerCase() ==
                                        $scope.read_pdf_ren.data.cobertura.toLowerCase() ||
                                      (item.package_name
                                        .toLowerCase()
                                        .includes(
                                          $scope.read_pdf_ren.data.cobertura.toLowerCase()
                                        ) &&
                                        !$scope.paqueteSelected)
                                    ) {
                                      $scope.paqueteSelected = true;
                                      order.form.paquete = item;
                                      $scope.dataToSave.paquete =
                                        order.form.paquete.id;
                                      for (i in $scope.read_pdf_ren.data[
                                        "Primas y coberturas"
                                      ]) {
                                        if (
                                          $scope.read_pdf_ren.data[
                                            "Primas y coberturas"
                                          ][i].hasOwnProperty("Deducible")
                                        ) {
                                          if (
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Deducible"] == "nan"
                                          ) {
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Deducible"] = "0";
                                          }
                                          if (
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Suma asegurada"] == "nan"
                                          ) {
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Suma asegurada"] = "0";
                                          }
                                          var it = {};
                                          it["coverage_name"] = i;
                                          it["url"] = i;
                                          it["package"] = item.id;
                                          it["deductibleInPolicy"] = {
                                            value:
                                              $scope.read_pdf_ren.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"],
                                          };
                                          it["deductible_coverage"] = [
                                            { deductible: 0 },
                                          ];
                                          it["deductible_coverage"][0][
                                            "deductible"
                                          ] =
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Deducible"];
                                          it["sumInPolicy"] = {
                                            value:
                                              $scope.read_pdf_ren.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"],
                                          };
                                          it["sums_coverage"] = [
                                            { sum_insured: 0 },
                                          ];
                                          it["sums_coverage"][0][
                                            "sum_insured"
                                          ] =
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Suma asegurada"];
                                          if (
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Coaseguro"]
                                          ) {
                                            it["coinsuranceInPolicy"] = {
                                              value:
                                                $scope.read_pdf_ren.data[
                                                  "Primas y coberturas"
                                                ][i]["Coaseguro"],
                                            };
                                          }
                                          $scope.coberturasPackagePdf.push(it);
                                          order.defaults.coverages =
                                            $scope.coberturasPackagePdf;
                                          $localStorage["defaults"] =
                                            order.defaults;
                                          order.form.paquete = item;
                                        }
                                      }
                                      order.coverageInPolicy_policy =
                                        order.defaults.coverages;
                                      order.form.paquete = item;
                                      $scope.dataToSave.paquete =
                                        order.form.paquete.id;
                                      // $scope.save_info_tab()
                                    }
                                  }
                                });

                                $scope.changeSubramo();
                                if (
                                  hasRenovationDraft() &&
                                  renovationDraft.paquete
                                ) {
                                  order.form.paquete = renovationDraft.paquete;
                                }
                              }
                            },
                            function error(e) {
                              console.log(
                                "Error - paquetes-data-by-subramo",
                                e
                              );
                              order.defaults.packages = [];
                            }
                          )
                          .catch(function (error) {
                            console.log(
                              "Error - paquetes-data-by-subramo - catch",
                              error
                            );
                            order.defaults.packages = [];
                          });
                      }
                    });
                  }
                });
              });
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }
    function llenarAsegurados(lista) {
      console.log("ssssssssss", order.subforms, $scope.contratante);
      if ($scope.contratante && $scope.contratante.sex) {
        order.subforms.disease.sex = $scope.contratante.sex;
      } else {
        console.warn("No se encontró contratante o no tiene sexo definido");
      }
      order.subforms.disease.relationshipList = [];
      order.subforms.disease.first_name = $scope.contratante.first_name;
      order.subforms.disease.last_name = $scope.contratante.last_name;
      order.subforms.disease.second_last_name =
        $scope.contratante.second_last_name;
      order.subforms.disease.birthdate = formatToMMDDYYYY(
        $scope.contratante.birth_date
      );
      if (
        $scope.read_pdf_ren &&
        $scope.read_pdf_ren.data &&
        $scope.read_pdf_ren.data.esTitular
      ) {
        order.subforms.disease.first_name = lista[0].first_name;
        order.subforms.disease.last_name = lista[0].last_name;
        order.subforms.disease.second_last_name = lista[0].second_last_name;
        if (lista[0].sex) {
          order.subforms.disease.sex = lista[0].sex;
        }
      } else {
        Object.keys(lista).map(function (key) {
          var rel = {
            antiguedad: lista[key].fecha
              ? lista[key].fecha
              : datesFactory.convertDate(new Date()),
            birthdate: null,
            first_name: lista[key].first_name,
            last_name: lista[key].last_name,
            second_last_name: lista[key].second_last_name,
            sex: null,
            relationship: { option: "OTRO", relationship: 4, disabled: false },
          };
          if (lista[key].sex) {
            rel.sex =
              lista[key].sex.toUpperCase() === "M"
                ? { value: "M", label: "MASCULINO" }
                : lista[key].sex.toUpperCase() === "F"
                ? { value: "F", label: "FEMENINO" }
                : null;
          }
          order.subforms.disease.relationshipList.push(rel);
        });
      }
    }
    function get_claves_pdf(aseguradora, clave) {
      if (!clave || clave == undefined) {
        try {
          clave =
            $scope.read_pdf.data["Datos generales de la poliza"][
              "Clave_interna_del_agente"
            ];
        } catch (u) {}
      }
      order.show.ot = false;
      // ensureRenovationDraft()['activeJustified'] = 1;
      var date = new Date(order.form.startDate);
      if (isNaN(date)) {
        var date = new Date(mesDiaAnio(order.form.startDate));
      }
      if ($scope.ramoPdf == "gastosmedicos") {
        llenarInfoGm(aseguradora, clave);
        return;
      }
      $http
        .get(url.IP + "claves-by-provider/" + order.form.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });
            order.defaults.claves = clavesResponse.data;
            if (order.defaults.claves.length == 1) {
              order.form.clave = order.defaults.claves[0];
              $scope.dataToSave.clave = order.form.clave.id;
              try {
                order.form.comision_percent = order.form.clave.comission;
                order.form.udi = order.form.clave.udi;
              } catch (e) {}
            }
            if (clave) {
              order.defaults.claves.forEach(function (item) {
                if (
                  item.clave.toString().replace(/\s/g, "") ===
                  clave.toString().replace(/\s/g, "")
                ) {
                  order.form.clave = item;
                }
              });
            }
            $http
              .get(url.IP + "ramos-by-provider/" + aseguradora.id)
              .then(function (ramo) {
                order.defaults.ramos = ramo.data;
                order.defaults.ramos.forEach(function (ramo) {
                  if (ramo.ramo_code == 3) {
                    order.form.ramo = ramo;
                    // $scope.save_info_tab()
                    order.defaults.subramos = ramo.subramo_ramo;
                    order.defaults.subramos.forEach(function (sub) {
                      if (sub.subramo_code == 9) {
                        order.form.subramo = sub;
                        // $scope.verComisiones();
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };

                        order.defaults.comisiones = [];

                        if (order.form.clave) {
                          if (order.form.clave.clave_comision.length) {
                            order.form.clave.clave_comision.forEach(function (
                              item
                            ) {
                              if (
                                order.form.subramo.subramo_name == item.subramo
                              ) {
                                order.defaults.comisiones.push(item);
                              }
                            });

                            order.form.comisiones = order.defaults.comisiones;
                            if (order.defaults.comisiones.length == 1) {
                              order.form.comision =
                                order.defaults.comisiones[0];
                              $scope.selectComision(order.form.comision);
                            }
                          }
                        }

                        $http
                          .post(url.IP + "paquetes-data-by-subramo/", {
                            ramo: order.form.ramo.id,
                            subramo: order.form.subramo.id,
                            provider: order.form.aseguradora.id,
                          })
                          .then(
                            function success(response) {
                              order.defaults.packages = [];
                              order.defaults.coverages = [];
                              $scope.paqueteSelected = false;
                              $scope.coberturasPackagePdf = [];

                              if (response.data.length) {
                                order.defaults.packages = response.data;
                                if (
                                  $scope.read_pdf_ren.data.cobertura == "" ||
                                  $scope.read_pdf_ren.data.cobertura ==
                                    undefined
                                ) {
                                  $scope.read_pdf_ren.data.cobertura = "AMPLIA";
                                }

                                order.defaults.packages.forEach(function (
                                  item
                                ) {
                                  if (
                                    item.package_name.toLowerCase() &&
                                    $scope.read_pdf_ren.data.cobertura.toLowerCase()
                                  ) {
                                    if (
                                      item.package_name.toLowerCase() ==
                                        $scope.read_pdf_ren.data.cobertura.toLowerCase() &&
                                      !$scope.paqueteSelected
                                    ) {
                                      $scope.paqueteSelected = true;
                                      order.form.paquete = item;
                                      $scope.dataToSave.paquete =
                                        order.form.paquete.id;
                                      for (i in $scope.read_pdf_ren.data[
                                        "Primas y coberturas"
                                      ]) {
                                        if (
                                          $scope.read_pdf_ren.data[
                                            "Primas y coberturas"
                                          ][i].hasOwnProperty("Deducible")
                                        ) {
                                          if (
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Deducible"] == "nan"
                                          ) {
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Deducible"] = "0";
                                          }
                                          if (
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Suma asegurada"] == "nan"
                                          ) {
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Suma asegurada"] = "0";
                                          }
                                          var it = {};
                                          it["coverage_name"] = i;
                                          it["url"] = i;
                                          it["package"] = item.id;
                                          it["deductibleInPolicy"] = {
                                            value:
                                              $scope.read_pdf_ren.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"],
                                          };
                                          it["deductible_coverage"] = [
                                            { deductible: 0 },
                                          ];
                                          it["deductible_coverage"][0][
                                            "deductible"
                                          ] =
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Deducible"];
                                          it["sumInPolicy"] = {
                                            value:
                                              $scope.read_pdf_ren.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"],
                                          };
                                          it["sums_coverage"] = [
                                            { sum_insured: 0 },
                                          ];
                                          it["sums_coverage"][0][
                                            "sum_insured"
                                          ] =
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Suma asegurada"];
                                          if (
                                            $scope.read_pdf_ren.data[
                                              "Primas y coberturas"
                                            ][i]["Coaseguro"]
                                          ) {
                                            it["coinsuranceInPolicy"] = {
                                              value:
                                                $scope.read_pdf_ren.data[
                                                  "Primas y coberturas"
                                                ][i]["Coaseguro"],
                                            };
                                          }
                                          $scope.coberturasPackagePdf.push(it);
                                          order.defaults.coverages =
                                            $scope.coberturasPackagePdf;
                                          $localStorage["defaults"] =
                                            order.defaults;
                                          order.form.paquete = item;
                                        }
                                      }
                                      order.coverageInPolicy_policy =
                                        order.defaults.coverages;
                                      order.form.paquete = item;
                                      $scope.dataToSave.paquete =
                                        order.form.paquete.id;
                                      // $scope.save_info_tab()
                                    }
                                  }
                                });
                                $scope.changeSubramo();
                                if (
                                  hasRenovationDraft() &&
                                  renovationDraft.paquete
                                ) {
                                  order.form.paquete = renovationDraft.paquete;
                                }
                              }
                            },
                            function error(e) {
                              console.log(
                                "Error - paquetes-data-by-subramo",
                                e
                              );
                              order.defaults.packages = [];
                            }
                          )
                          .catch(function (error) {
                            console.log(
                              "Error - paquetes-data-by-subramo - catch",
                              error
                            );
                            order.defaults.packages = [];
                          });
                      }
                    });
                  }
                });
              });
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }
    function formatearNumero_calculate(nStr, campo) {
      try {
        nStr += "";
        var x = nStr.split(".");
        var x1 = x[0];
        var x2 = x.length > 1 ? "." + x[1] : "";

        var cadenas = x1.split(",");
        var cadena_sin_comas = "";
        for (i = 0; i < cadenas.length; i++) {
          cadena_sin_comas = cadena_sin_comas + cadenas[i];
        }
        if (
          cadena_sin_comas != undefined &&
          cadena_sin_comas != "undefined" &&
          cadena_sin_comas != "NaN" &&
          cadena_sin_comas != NaN
        ) {
          return cadena_sin_comas + x2;
        } else {
          return nStr;
        }
      } catch (e) {
        return 0;
      }
    }
    function generarRequestId() {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      var hex = Array.prototype.map
        .call(bytes, function (b) {
          return ("0" + b.toString(16)).slice(-2);
        })
        .join("");
      return [
        hex.substr(0, 8),
        hex.substr(8, 4),
        hex.substr(12, 4),
        hex.substr(16, 4),
        hex.substr(20),
      ].join("-");
    }
    $scope.capturarPoliza = function () {
      $scope.dataToSave = {};
      if (!$scope.filePdf) {
        SweetAlert.swal(
          "Error",
          "Cargue un archivo pdf para capturar.",
          "error"
        );
        return;
      }
      resetRenovationDraft();
      // order.form = {};
      $localStorage["datos_pdf_renovacion"] = {};
      $localStorage["primas"] = {};
      $localStorage["defaults"] = {};
      SweetAlert.swal(
        {
          title: "🔎 Revisión de la información extraída",
          text:
            "<p style='margin:0 0 10px;'>Antes de guardar, verifique que los datos obtenidos del PDF sean <strong>correctos</strong> y estén <strong>completos</strong>.</p>" +
            "<p style='margin:0 0 6px 0;'><strong>Aspectos clave a validar:</strong></p>" +
            "<ul style='margin:0 0 0 18px; padding:0; line-height:1.5;'>" +
            "  <li><strong>Número de póliza</strong> y <strong>vigencia</strong></li>" +
            "  <li><strong>Serie</strong> (en caso de Automóviles) y <strong>Asegurados</strong></li>" +
            "  <li><strong>Coberturas</strong> y <strong>primas</strong></li>" +
            "  <li><strong>Datos del contratante</strong>: Nombre y RFC</li>" +
            "</ul>" +
            "<p style='margin:12px 0 0; font-size:12px; color:#5f6368;'>⚠️ En caso de detectar alguna discrepancia, informe a Soporte.</p>",
          type: "warning",
          html: true,
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Continuar",
          closeOnConfirm: true,
          closeOnCancel: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            console.log("continuar", isConfirm);
          }
        }
      );
      $scope.countFile = 0;
      $scope.loaderPdf = true;

      var xhr = new XMLHttpRequest();
      // xhr.open("POST", url.SERVICE_PDF);
      xhr.open("POST", url.LECTORPDF + "upload-pdf");

      var auxRamo =
        $scope.ramoPdf && $scope.ramoPdf.ramo_id ? $scope.ramoPdf.ramo_id : 0;

      var data = new FormData();
      var dataFile = new FormData();
      dataFile.append("arch", $scope.filePdf);
      dataFile.append("nombre", $scope.fileSelectedR.name);
      data.append("archivo", $scope.filePdf);
      // 3) Añade tus parámetros adicionales
      data.append("nombre", $scope.fileSelectedR.name);
      data.append("org", $scope.orgName);
      var requestId = generarRequestId();
      data.append("requestId", requestId);
      $localStorage.dataFileR = dataFile;
      $scope.fileSelectedR.formData = [];
      try {
        enviarPDFSerieXHR(
          $scope.fileSelectedR,
          $scope.orgName,
          Date.now().toString(),
          function (resp) {
            $scope.$apply(function () {
              var raw = resp.data.image_b64; // ajusta a tu ruta real (a veces es resp.data.data.image_b64)
              var src = raw.startsWith("data:")
                ? raw
                : "data:image/png;base64," + raw;

              // 1) lo que pintas
              $scope.imgSerieSrcR = $sce.trustAsResourceUrl(src);

              // 2) lo que guardas (string)
              $localStorage.imgSerieSrcR = src;
            });
          },
          function (err) {
            console.error(err);
          }
        );
      } catch (u) {
        console.log("uu erorr image", u);
      }
      try {
        enviarPDFPrimasXHR(
          $scope.fileSelectedR,
          $scope.orgName,
          Date.now().toString(),
          function (resp) {
            $scope.$apply(function () {
              var imagenok = "";
              var raw = resp.data.sections; // ajusta a tu ruta real (a veces es resp.data.data.image_b64)
              if (raw && raw[0] && raw[0].image_b64) {
                imagenok = raw[0].image_b64;
              } else {
                if (raw && raw[1] && raw[1].image_b64) {
                  imagenok = raw[1].image_b64;
                }
              }
              if (imagenok) {
                var src = imagenok.startsWith("data:")
                  ? imagenok
                  : "data:image/png;base64," + imagenok;
                // 1) lo que pintas
                $scope.imgPrimasSrcR = $sce.trustAsResourceUrl(src);
                // 2) lo que guardas (string)
                $localStorage.imgPrimasSrcR = src;
              }
            });
          },
          function (err) {
            console.error(err);
          }
        );
      } catch (u) {
        console.log("uu erorr image", u);
      }
      xhr.timeout = 1200000;
      xhr.ontimeout = function (e) {
        console.log("error", e);
        $scope.loaderPdf = true;
        SweetAlert.swal(
          "Error**",
          "A ocurrido un error al cargar el PDF, por favor intentalo de nuevo.",
          "error"
        );
      };
      xhr.send(data);
      xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          $scope.loaderPdf = false;
          $scope.read_pdf_ren = JSON.parse(xhr.response);
          if ($scope.read_pdf_ren.status != "200_OK_ACCEPTED") {
            SweetAlert.swal(
              "Error*",
              "A ocurrido un error al cargar el PDF, por favor intentalo de nuevo.",
              "error"
            );
          } else {
            if ($scope.read_pdf_ren.request_id !== requestId) {
              console.log(
                "No coincide***",
                $scope.read_pdf.request_id,
                requestId
              );
            } else {
              console.log("Resultado ok***:", $scope.read_pdf_ren.data);
            }
            $localStorage["datos_pdf_renovacion"] = $scope.read_pdf_ren;
            $scope.filePdf = {};
            $scope.activeJustified = 1;
            order.show.ot = false;
            if ($scope.read_pdf_ren.data["Numero de poliza"]) {
              order.form.poliza = $scope.read_pdf_ren.data["Numero de poliza"];
            }
            // if($scope.read_pdf_ren.data['Datos generales de la poliza'] && $scope.read_pdf_ren.data['Datos generales de la poliza']['Moneda'] &&  $scope.read_pdf_ren.data['Datos generales de la poliza']['Moneda'] =='NACIONAL'){
            //   $scope.order.f_currency.f_currency_selected = 1;
            // }else if($scope.read_pdf_ren.data['Datos generales de la poliza'] && $scope.read_pdf_ren.data['Datos generales de la poliza']['Moneda'] && !$scope.read_pdf_ren.data['Datos generales de la poliza']['Moneda'] =='EXTRANJERA'){
            //   $scope.order.f_currency.f_currency_selected = 2;
            // }
            if (
              $scope.read_pdf_ren.data["Datos generales de la poliza"] &&
              $scope.read_pdf_ren.data["Datos generales de la poliza"][
                "Moneda"
              ] &&
              $scope.read_pdf_ren.data["Datos generales de la poliza"][
                "Moneda"
              ] == "NACIONAL"
            ) {
              $scope.order.f_currency.f_currency_selected = 1;
              order.f_currency.f_currency_selected = 1;
            }
            if (
              $scope.read_pdf_ren.data["Datos generales de la poliza"] &&
              $scope.read_pdf_ren.data["Datos generales de la poliza"][
                "Moneda"
              ] &&
              ($scope.read_pdf_ren.data["Datos generales de la poliza"][
                "Moneda"
              ] == "Dolares" ||
                $scope.read_pdf_ren.data["Datos generales de la poliza"][
                  "Moneda"
                ].toLowerCase() == "dolares")
            ) {
              $scope.order.f_currency.f_currency_selected = 2;
              order.f_currency.f_currency_selected = 2;
            }
            if (
              $scope.read_pdf_ren.data["Datos generales de la poliza"] &&
              $scope.read_pdf_ren.data["Datos generales de la poliza"][
                "Moneda"
              ] &&
              !$scope.read_pdf_ren.data["Datos generales de la poliza"][
                "Moneda"
              ] == "EXTRANJERA"
            ) {
              order.f_currency.f_currency_selected = 2;
              $scope.order.f_currency.f_currency_selected = 2;
            }
            if (
              $scope.read_pdf_ren.data["Datos generales de la poliza"] &&
              $scope.read_pdf_ren.data["Datos generales de la poliza"][
                "Moneda"
              ] &&
              ($scope.read_pdf_ren.data["Datos generales de la poliza"][
                "Moneda"
              ] == "udi" ||
                $scope.read_pdf_ren.data["Datos generales de la poliza"][
                  "Moneda"
                ].toLowerCase() == "udis")
            ) {
              $scope.order.f_currency.f_currency_selected = 3;
              order.f_currency.f_currency_selected = 3;
            }
            order.conducto_de_pago.conducto_de_pago_selected = 1;
            $scope.pintarCoberturas = true;

            order.form.payment = {};
            order.form.from_pdf = true;
            order.form.payment.value =
              $scope.read_pdf_ren.data["Datos generales de la poliza"][
                "Forma de pago"
              ];

            if (order && order.form && order.form.payment) {
              var p = Number(order.form.payment.value); // por si viene "15" string

              if ([15, 7, 14].indexOf(p) !== -1) {
                order.form.payment.value = 12; // ✅ reset a anual

                SweetAlert.swal(
                  "Advertencia",
                  "La forma de pago detectada (" +
                    p +
                    ") no aplica en este formato. Se ajustó a ANUAL (12). Verifica tu archivo o selecciona la forma de pago correcta.",
                  "warning"
                );
              }
            }
            $scope.paqueteOriginal = $scope.read_pdf_ren.data.cobertura;
            if ($scope.read_pdf_ren.data["Datos del vehiculo"]) {
              order.subforms.auto.brand =
                $scope.read_pdf_ren.data["Datos del vehiculo"]["marca"];
              order.subforms.auto.model =
                $scope.read_pdf_ren.data["Datos del vehiculo"]["modelo"];
              order.subforms.auto.year =
                $scope.read_pdf_ren.data["Datos del vehiculo"]["anio"];
              order.subforms.auto.engine =
                $scope.read_pdf_ren.data["Datos del vehiculo"]["motor"];
              order.subforms.auto.serial =
                $scope.read_pdf_ren.data["Datos del vehiculo"]["serie"];
              if (order.subforms.auto.serial) {
                $scope.checkNumSerie();
              }
              // order.subforms.auto.license_plates = $scope.read_pdf_ren.data['Datos del vehiculo']['clave_vehicular'];
              order.subforms.auto.license_plates =
                $scope.read_pdf_ren.data["Datos del vehiculo"]["placas"];
              var datosVehiculo =
                $scope.read_pdf_ren.data["Datos del vehiculo"];

              order.subforms.auto.version = datosVehiculo.version
                ? datosVehiculo.version
                : datosVehiculo.descripcion_vehiculo
                ? datosVehiculo.descripcion_vehiculo
                : datosVehiculo.clave_vehicular;
              // order.subforms.auto.version = $scope.read_pdf_ren.data['Datos del vehiculo']['descripcion_vehiculo'] ? $scope.read_pdf_ren.data['Datos del vehiculo']['descripcion_vehiculo'] : $scope.read_pdf_ren.data['Datos del vehiculo']['clave_vehicular'];
              order.subforms.auto.color =
                $scope.read_pdf_ren.data["Datos del vehiculo"]["color"];
              order.subforms.auto.service =
                $scope.read_pdf_ren.data["Datos del vehiculo"]["servicio"];
              if (
                (order &&
                  order.subforms &&
                  order.subforms.auto &&
                  order.subforms.auto.service == "") ||
                order.subforms.auto.service == undefined ||
                order.subforms.auto.service == null
              ) {
                if (
                  $scope.read_pdf_ren &&
                  $scope.read_pdf_ren.data &&
                  $scope.read_pdf_ren.data["Datos del vehiculo"]["uso"]
                ) {
                  if (
                    parseInt(
                      $scope.read_pdf_ren.data["Datos del vehiculo"]["uso"]
                    ) == 1
                  ) {
                    order.subforms.auto.service = "PARTICULAR";
                  } else if (
                    parseInt(
                      $scope.read_pdf_ren.data["Datos del vehiculo"]["uso"]
                    ) == 2
                  ) {
                    order.subforms.auto.service = "CARGA";
                    if (
                      $scope.read_pdf_ren.data &&
                      $scope.read_pdf_ren.data["Datos del vehiculo"] &&
                      $scope.read_pdf_ren.data["Datos del vehiculo"][
                        "tipo de carga"
                      ]
                    ) {
                      if (
                        $scope.read_pdf_ren.data["Datos del vehiculo"][
                          "tipo de carga"
                        ] == "A"
                      ) {
                        order.subforms.auto.charge_type = 1;
                      } else if (
                        $scope.read_pdf_ren.data["Datos del vehiculo"][
                          "tipo de carga"
                        ] == "B"
                      ) {
                        order.subforms.auto.charge_type = 2;
                      } else if (
                        $scope.read_pdf_ren.data["Datos del vehiculo"][
                          "tipo de carga"
                        ] == "C"
                      ) {
                        order.subforms.auto.charge_type = 3;
                      } else {
                        order.subforms.auto.charge_type = 1;
                      }
                    }
                  } else if (
                    parseInt(
                      $scope.read_pdf_ren.data["Datos del vehiculo"]["uso"]
                    ) == 3
                  ) {
                    order.subforms.auto.service = "SERVICIO PÚBLICO";
                  } else {
                    order.subforms.auto.service = "PARTICULAR";
                  }
                }
              }
              order.form.identifier =
                order.subforms.auto.brand + " " + order.subforms.auto.model;
              if ($scope.orgName == "gpi") {
                order.form.identifier = "GENERAL";
              }
              // if(order.form.identifier !=order.subforms.auto.version){
              //   order.form.identifier = order.form.identifier+' '+order.subforms.auto.version
              // }
              try {
                order.subforms.auto.usage = parseInt(
                  $scope.read_pdf_ren.data["Datos del vehiculo"]["uso"]
                );
              } catch (err) {}
            }
            try {
              if (
                $scope.read_pdf_ren.data &&
                $scope.read_pdf_ren.data["Datos del vehiculo"] &&
                $scope.read_pdf_ren.data["Datos del vehiculo"][
                  "tipo de carga"
                ] &&
                $scope.read_pdf_ren.data["Datos del vehiculo"]["uso"]
              ) {
                if (
                  parseInt(
                    $scope.read_pdf_ren.data["Datos del vehiculo"]["uso"]
                  ) == 2
                ) {
                  if (
                    $scope.read_pdf_ren.data["Datos del vehiculo"][
                      "tipo de carga"
                    ] == "A"
                  ) {
                    order.subforms.auto.charge_type = 1;
                  } else if (
                    $scope.read_pdf_ren.data["Datos del vehiculo"][
                      "tipo de carga"
                    ] == "B"
                  ) {
                    order.subforms.auto.charge_type = 2;
                  } else if (
                    $scope.read_pdf_ren.data["Datos del vehiculo"][
                      "tipo de carga"
                    ] == "C"
                  ) {
                    order.subforms.auto.charge_type = 3;
                  } else {
                    order.subforms.auto.charge_type = 1;
                  }
                }
              }
            } catch (err) {}

            //  movi este corchete aqui para que pueda leer gastos medicos sin datos del vehiculo
            $scope.contratante = {};
            if ($scope.read_pdf_ren.data["ramo"]) {
              $scope.ramoPdf = $scope.read_pdf_ren.data["ramo"];
            } else {
              $scope.ramoPdf = "";
              $scope.contratante = {};
            }

            var aseguradora_a_capturar = sinDiacriticos(
              $scope.read_pdf_ren.data["aseguradora"].toLowerCase()
            );
            order.defaults.providers.some(function (x) {
              if (aseguradora_a_capturar == "chubb") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "CHUBB" ||
                  sinDiacriticos(x.alias).toLowerCase() == "Aba" ||
                  sinDiacriticos(x.alias).toLowerCase() == "ABA"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf_ren.data[
                          "Datos generales de la poliza"
                        ]["Clave_interna_del_agente"];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "qualitas") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "Quálitas" ||
                  sinDiacriticos(x.alias).toLowerCase() == "Qualitas" ||
                  sinDiacriticos(x.alias).toLowerCase() == "QUALITAS" ||
                  sinDiacriticos(x.alias).toLowerCase() == "QUÁLITAS"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }

              if (aseguradora_a_capturar == "gnp") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "gnp" ||
                  sinDiacriticos(x.alias).toLowerCase() == "gnp seguros" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "grupo nacional provincial" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "grupo nacional provincial "
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "axa") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "axa" ||
                  sinDiacriticos(x.alias).toLowerCase() == "axa seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "hdi") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "hdi" ||
                  sinDiacriticos(x.alias).toLowerCase() == "HDI"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "primero seguros") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "Primero Seguros" ||
                  sinDiacriticos(x.alias).toLowerCase() == "Pimero seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "ana") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "ana" ||
                  sinDiacriticos(x.alias).toLowerCase() == "ana seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }

              if (aseguradora_a_capturar == "momento") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "momento"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "afirme") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "seguros afirme"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "zurich") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "zurich seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "mapfre") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "mapfre"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (
                aseguradora_a_capturar == "seguros monterrey" ||
                aseguradora_a_capturar == "seguros monterrey new york life"
              ) {
                aseguradora_a_capturar = "seguros monterrey new york life";
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "seguros monterrey new york life"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (
                aseguradora_a_capturar == "seguros bx+" ||
                aseguradora_a_capturar == "bx+"
              ) {
                aseguradora_a_capturar = "bx+";
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "seguros ve por mas" ||
                  sinDiacriticos(x.alias).toLowerCase() == "bx+" ||
                  sinDiacriticos(x.alias).toLowerCase() == "seguros bx+" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "grupo financiero ve por mas"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (
                aseguradora_a_capturar == "Metlife" ||
                aseguradora_a_capturar == "metlife"
              ) {
                aseguradora_a_capturar = "Metlife";
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "met life" ||
                  sinDiacriticos(x.alias).toLowerCase() == "metlife"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (
                aseguradora_a_capturar == "PlanSeguro" ||
                aseguradora_a_capturar == "planseguro"
              ) {
                aseguradora_a_capturar = "Plan Seguro";
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "plan seguros" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "plan de seguro cía de seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf_ren.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              return false;
            });

            order.subforms.auto.policy_type = 1;
            order.subforms.auto.procedencia = 1;
            if (
              aseguradora_a_capturar == "hdi" &&
              $scope.read_pdf_ren.data["Datos del vehiculo"]["tipo"] ==
                "Pick Up"
            ) {
              order.subforms.auto.policy_type = 5;
            }
            // $scope.save_info_tab();

            order.form.from_pdf = true;
            // if(($scope.read_pdf_ren.data['Datos del asegurado']['propietario_contratante'].indexOf("S.A. DE") > -1)){
            //   $scope.read_pdf_ren_contractor.type = false;
            //   $scope.read_pdf_ren_contractor.name =$scope.read_pdf_ren.data['Datos del asegurado']['propietario_contratante'];
            // }else{
            //   $scope.read_pdf_ren_contractor.type = true;
            //   $scope.read_pdf_ren_contractor.name = $scope.read_pdf_ren.data['Datos del asegurado']['propietario_contratante']

            // }
            if (
              $scope.read_pdf_ren.data["Primas"] &&
              $scope.read_pdf_ren.data["Primas"]["Prima total"]
            ) {
              $scope.order.form.primaTotal = $scope.read_pdf_ren.data["Primas"][
                "Prima total"
              ]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_ren.data["Primas"]["Prima total"]
                    )
                  )
                : $scope.read_pdf_ren.data["Primas"]["IMPORTE TOTAL"]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_ren.data["Primas"]["IMPORTE TOTAL"]
                    )
                  )
                : 0;
              $scope.order.form.subTotal = $scope.read_pdf_ren.data["Primas"][
                "Subtotal"
              ]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_ren.data["Primas"]["Subtotal"]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }

            if (
              $scope.read_pdf_ren.data["Primas"] &&
              $scope.read_pdf_ren.data["Primas"]["Prima neta"]
            ) {
              $scope.order.form.primaNeta = $scope.read_pdf_ren.data["Primas"][
                "Prima neta"
              ]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_ren.data["Primas"]["Prima neta"]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }

            if (
              $scope.read_pdf_ren.data["Primas"] &&
              $scope.read_pdf_ren.data["Primas"]["Gastos de expedición"]
            ) {
              try {
                $scope.order.form.derecho = $scope.read_pdf_ren.data["Primas"][
                  "Gastos de expedición"
                ]
                  ? parseFloat(
                      formatearNumero_calculate(
                        $scope.read_pdf_ren.data["Primas"][
                          "Gastos de expedición"
                        ]
                      )
                    )
                  : 0;
                $localStorage["primas"] = $scope.order.form;
              } catch (o) {
                $scope.order.form.derecho = $scope.read_pdf_ren.data["Primas"][
                  "Gastos de expedici\u00f3n"
                ]
                  ? parseFloat(
                      formatearNumero_calculate(
                        $scope.read_pdf_ren.data["Primas"][
                          "Gastos de expedici\u00f3n"
                        ]
                      )
                    )
                  : 0;
                $localStorage["primas"] = $scope.order.form;
              }
            }
            if (
              $scope.read_pdf_ren.data["Primas"] &&
              $scope.read_pdf_ren.data["Primas"]["Gastos por Expedición."]
            ) {
              try {
                $scope.order.form.derecho = $scope.read_pdf_ren.data["Primas"][
                  "Gastos por Expedición."
                ]
                  ? parseFloat(
                      formatearNumero_calculate(
                        $scope.read_pdf_ren.data["Primas"][
                          "Gastos por Expedición."
                        ]
                      )
                    )
                  : 0;
                $localStorage["primas"] = $scope.order.form;
              } catch (o) {
                $scope.order.form.derecho = $scope.read_pdf_ren.data["Primas"][
                  "Gastos por Expedici\u00f3n."
                ]
                  ? parseFloat(
                      formatearNumero_calculate(
                        $scope.read_pdf_ren.data["Primas"][
                          "Gastos por Expedici\u00f3n."
                        ]
                      )
                    )
                  : 0;
                $localStorage["primas"] = $scope.order.form;
              }
            }
            if (
              $scope.read_pdf_ren.data["Primas"] &&
              $scope.read_pdf_ren.data["Primas"][
                "Financiamiento por pago fraccionado"
              ]
            ) {
              $scope.order.form.rpf = $scope.read_pdf_ren.data["Primas"][
                "Financiamiento por pago fraccionado"
              ]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_ren.data["Primas"][
                        "Financiamiento por pago fraccionado"
                      ]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }
            if (
              $scope.read_pdf_ren.data["Primas"] &&
              $scope.read_pdf_ren.data["Primas"]["Derecho de Póliza"]
            ) {
              $scope.order.form.derecho = $scope.read_pdf_ren.data["Primas"][
                "Derecho de Póliza"
              ]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_ren.data["Primas"]["Derecho de Póliza"]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }
            if (
              $scope.read_pdf_ren.data["Primas"] &&
              $scope.read_pdf_ren.data["Primas"]["IVA"]
            ) {
              $scope.order.form.iva = $scope.read_pdf_ren.data["Primas"]["IVA"]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_ren.data["Primas"]["IVA"]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }
            if (
              $scope.read_pdf_ren.data["Primas"] &&
              $scope.read_pdf_ren.data["Primas"]["I.V.A."]
            ) {
              $scope.order.form.iva = $scope.read_pdf_ren.data["Primas"][
                "I.V.A."
              ]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_ren.data["Primas"]["I.V.A."]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }
            order.form.startDate = $scope.read_pdf_ren.data["fecha_inicio"];
            order.form.endingDate = $scope.read_pdf_ren.data["fecha_fin"];
            order.form.endDate = $scope.read_pdf_ren.data["fecha_fin"];
            order.form.start_of_validity = new Date(
              $scope.read_pdf_ren.data["fecha_inicio"]
            );
            order.form.end_of_validity = new Date(
              $scope.read_pdf_ren.data["fecha_fin"]
            );

            $scope.dataToSave.start_of_validity = mesDiaAnio(
              order.form.startDate
            );
            $scope.dataToSave.end_of_validity = mesDiaAnio(
              order.form.endingDate
            );
            var date1 = new Date($scope.dataToSave.start_of_validity);
            var date2 = new Date($scope.dataToSave.end_of_validity);
            var timeDiff = Math.abs(date2.getTime() - date1.getTime());
            order.form.policy_days_duration = Math.ceil(
              timeDiff / (1000 * 3600 * 24)
            );
            order.form.from_pdf = true;
            $rootScope.readPDF = {
              individual: $scope.read_pdf_ren.data["Datos del asegurado"],
              corporation: $scope.read_pdf_ren.data["Datos del asegurado"],
              address: $scope.read_pdf_ren.data["contratante_domicilio"],
              first_name: $scope.read_pdf_ren.data["contratante_full_name"],
              last_name:
                $scope.read_pdf_ren.data["contratante_primer_apellido"],
              second_last_name:
                $scope.read_pdf_ren.data["contratante_segundo_apellido"],
              type_person: $scope.read_pdf_ren.data["persona"],
            };
            // $scope.save_info_tab();
          }
        } else {
          // 1) Obtener cuerpo
          var body = (xhr && (xhr.responseText || xhr.response)) || null;
          // 2) Parseo seguro
          var obj = null;
          if (body && typeof body === "string") {
            try {
              obj = JSON.parse(body);
            } catch (e) {
              obj = null;
            }
          } else if (body && typeof body === "object") {
            obj = body;
          }

          // 3) Mensaje
          var fallback =
            "Ha ocurrido un error al cargar el PDF; por favor inténtalo de nuevo.";
          var msg =
            (obj && obj.data && obj.data.error) || (obj && obj.error) || "";
          var reqId = obj && (obj.request_id || obj.requestId);
          // 4) Pintar (forzar digest si estás fuera de Angular)
          if (msg) {
            $scope.$applyAsync(function () {
              $scope.loaderPdf = false;
              SweetAlert.swal({
                title: "Error",
                text: reqId ? msg : msg,
                type: "error",
                confirmButtonText: "Entendido",
              });
            });
          }
        }
      };
    };
    $scope.hasInvalidVinLettersTest = function (vin) {
      if (!vin) return false;
      return /[OIQ]/i.test(vin);
    };

    function enviarPDFPrimasXHR(file, org, requestId, onOk, onErr) {
      var fd = new FormData();
      fd.append("archivo", file);
      if (org) fd.append("org", org);
      if (requestId) fd.append("requestId", requestId);

      var xhr = new XMLHttpRequest();
      xhr.open("POST", url.LECTORPDF + "imagen-primas-pdf", true);

      xhr.onload = function () {
        try {
          var resp = JSON.parse(xhr.responseText || "{}");
          if (xhr.status >= 200 && xhr.status < 300) onOk(resp);
          else onErr(resp);
        } catch (e) {
          onErr({ error: "Respuesta inválida", raw: xhr.responseText });
        }
      };

      xhr.onerror = function () {
        onErr({ error: "Error de red" });
      };

      xhr.send(fd);
    }
    function enviarPDFSerieXHR(file, org, requestId, onOk, onErr) {
      var fd = new FormData();
      fd.append("archivo", file);
      if (org) fd.append("org", org);
      if (requestId) fd.append("requestId", requestId);

      var xhr = new XMLHttpRequest();
      xhr.open("POST", url.LECTORPDF + "imagen-serie-pdf", true);

      xhr.onload = function () {
        try {
          var resp = JSON.parse(xhr.responseText || "{}");
          if (xhr.status >= 200 && xhr.status < 300) onOk(resp);
          else onErr(resp);
        } catch (e) {
          onErr({ error: "Respuesta inválida", raw: xhr.responseText });
        }
      };

      xhr.onerror = function () {
        onErr({ error: "Error de red" });
      };

      xhr.send(fd);
    }
    $scope.changePackage = function (param) {
      if (order.form.identifier) {
        order.form.identifier = order.form.identifier;
      } else if (param) {
        order.form.identifier = param.package_name;
      } else {
        order.form.identifier = order.form.identifier;
      }
      if ($scope.orgName == "gpi") {
        order.form.identifier = "GENERAL";
      }
      order.defaults.coverages = [];
      if (param) {
        order.form.paquete = param;
      }
      if (order.form.paquete) {
        $scope.newCoverPack = true;
        $scope.dataToSave.paquete = order.form.paquete.id;
        order.defaults.coverages = [];
        order.defaults.coverageList = [];
        order.form.paquete.coverage_package.forEach(function (element, index) {
          if (element.default) {
            order.defaults.coverages.push(angular.copy(element));
          } else {
            order.defaults.coverageList.push(angular.copy(element));
          }
        });
        order.coverageInPolicy_policy = order.defaults.coverages;
        order.show.showCoverages = true;

        if ($scope.read_pdf_ren && $scope.readPDF) {
          $scope.paqueteSelected = false;
          $scope.coberturasPackagePdf = [];
          if (
            $scope.read_pdf_ren.data.cobertura == "" ||
            $scope.read_pdf_ren.data.cobertura == undefined
          ) {
            $scope.read_pdf_ren.data.cobertura = "AMPLIA";
          }
          if ($scope.read_pdf_ren.data["Primas y coberturas"]) {
            $scope.paqueteSelected = true;
            $scope.dataToSave.paquete = order.form.paquete.id;
            for (i in $scope.read_pdf_ren.data["Primas y coberturas"]) {
              if (
                $scope.read_pdf_ren.data["Primas y coberturas"][
                  i
                ].hasOwnProperty("Deducible")
              ) {
                if (
                  $scope.read_pdf_ren.data["Primas y coberturas"][i][
                    "Deducible"
                  ] == "nan"
                ) {
                  $scope.read_pdf_ren.data["Primas y coberturas"][i][
                    "Deducible"
                  ] = "0";
                }
                if (
                  $scope.read_pdf_ren.data["Primas y coberturas"][i][
                    "Suma asegurada"
                  ] == "nan"
                ) {
                  $scope.read_pdf_ren.data["Primas y coberturas"][i][
                    "Suma asegurada"
                  ] = "0";
                }
                var it = {};
                it["coverage_name"] = i;
                it["url"] = i;
                it["package"] = order.form.paquete.id;
                it["deductibleInPolicy"] = {
                  value:
                    $scope.read_pdf_ren.data["Primas y coberturas"][i][
                      "Deducible"
                    ],
                };
                it["deductible_coverage"] = [{ deductible: 0 }];
                it["deductible_coverage"][0]["deductible"] =
                  $scope.read_pdf_ren.data["Primas y coberturas"][i][
                    "Deducible"
                  ];
                it["sumInPolicy"] = {
                  value:
                    $scope.read_pdf_ren.data["Primas y coberturas"][i][
                      "Suma asegurada"
                    ],
                };
                it["sums_coverage"] = [{ sum_insured: 0 }];
                it["sums_coverage"][0]["sum_insured"] =
                  $scope.read_pdf_ren.data["Primas y coberturas"][i][
                    "Suma asegurada"
                  ];
                if (
                  $scope.read_pdf_ren.data["Primas y coberturas"][i][
                    "Coaseguro"
                  ]
                ) {
                  it["coinsuranceInPolicy"] = {
                    value:
                      $scope.read_pdf_ren.data["Primas y coberturas"][i][
                        "Coaseguro"
                      ],
                  };
                }
                $scope.coberturasPackagePdf.push(it);
                order.defaults.coverages = $scope.coberturasPackagePdf;
                $localStorage["defaults"] = order.defaults;
                order.form.paquete = order.form.paquete;
              }
            }
            order.coverageInPolicy_policy = order.defaults.coverages;
          }
        }
      }
    };
    function similarity(a, b) {
      var aWords = a.toLowerCase().split(" ");
      var bWords = b.toLowerCase().split(" ");
      var score = 0;
      angular.forEach(aWords, function (word) {
        if (bWords.indexOf(word) !== -1) {
          score++;
        }
      });
      return score;
    }
    $scope.getMostSimilarPackage = function (target, packages) {
      var bestMatch = null;
      var highestScore = 0;
      if ($scope.paqueteOriginal && packages) {
        angular.forEach(packages, function (pkg) {
          var score = similarity($scope.paqueteOriginal, pkg.package_name);
          if (score > highestScore) {
            highestScore = score;
            bestMatch = pkg;
            return bestMatch;
          }
        });
      }
      return bestMatch;
    };
    $scope.changeSubramo = function () {
      if (order.form.subramo) {
        $scope.dataToSave.subramo = order.form.subramo.id;
        order.defaults.forms = order.form.subramo.forms_subramo;
        if (order.form.subramo.subramo_code == 1) {
          if (order.types_life.length == 1) {
            order.subforms.life.policy_type = order.types_life[0];
          }
        } else if (
          order.form.subramo.subramo_code == 2 ||
          order.form.subramo.subramo_code == 3 ||
          order.form.subramo.subramo_code == 4
        ) {
          if (order.types_gm.length == 1) {
            if (order.subforms && order.subforms.disease) {
              order.subforms.disease.policy_type = order.types_gm[0];
            } else {
              order.subforms = {
                auto: {
                  selectedCar: {},
                }, //template.formulario.automoviles
                life: {
                  beneficiariesList: [{ person: 1 }],
                  aseguradosList: [],
                }, //template.formulario.vida
                disease: {
                  relationshipList: [],
                }, //template.formulario.accidentes
                damage: {
                  coinsurance: "",
                  insured_item: "",
                  item_address: "",
                  item_details: "",
                }, //template.formulario.danios
              };
              order.subforms.disease.policy_type = order.types_gm[0];
            }
          }
        } else if (order.form.subramo.subramo_code == 7) {
          if (order.types_incendio.length == 1) {
            order.subforms.damage.policy_type = order.types_incendio[0];
          }
        } else if (order.form.subramo.subramo_code == 6) {
          if (order.types_myt.length == 1) {
            order.subforms.damage.policy_type = order.types_myt[0];
          }
        } else if (order.form.subramo.subramo_code == 8) {
          if (order.types_ayc.length == 1) {
            order.subforms.damage.policy_type = order.types_ayc[0];
          }
        } else if (order.form.subramo.subramo_code === 1) {
          if (order.types_credito.length == 1) {
            order.subforms.damage.policy_type = order.types_credito[0];
          }
        } else if (order.form.subramo.subramo_code == 10) {
          if (order.types_credito.length == 1) {
            order.subforms.damage.policy_type = order.types_credito[0];
          }
        } else if (order.form.subramo.subramo_code == 11) {
          if (order.types_vivienda.length == 1) {
            order.subforms.damage.policy_type = order.types_vivienda[0];
          }
        } else if (order.form.subramo.subramo_code == 13) {
          if (order.types_diversos.length == 1) {
            order.subforms.damage.policy_type = order.types_diversos[0];
          }
        } else if (order.form.subramo.subramo_code == 12) {
          if (order.types_garantia.length == 1) {
            order.subforms.damage.policy_type = order.types_garantia[0];
          }
        } else if (order.form.subramo.subramo_code == 5) {
          if (order.types_rc.length == 1) {
            order.subforms.damage.policy_type = order.types_rc[0];
          }
        } else if (order.form.subramo.subramo_code == 14) {
          if (order.types_tyorc.length == 1) {
            order.subforms.damage.policy_type = order.types_tyorc[0];
          }
        } else if (order.form.subramo.subramo_code == 31) {
          if (order.types_lf.length == 1) {
            order.subforms.damage.policy_type = order.types_lf[0];
          }
        } else if (order.form.subramo.subramo_code == 9) {
          if (order.types.length == 1) {
            order.subforms.auto.policy_type = order.types[0];
          }
        }
        get_claves();
      }
      if (hasRenovationDraft() && renovationDraft.paquete) {
        renovationDraft.paquete = null;
      }
      try {
        $http
          .post(url.IP + "paquetes-data-by-subramo/", {
            ramo: order.form.ramo.id,
            subramo: order.form.subramo.id,
            provider: order.form.aseguradora.id,
          })
          .then(
            function success(response) {
              order.defaults.packages = [];
              if (response.data.length) {
                order.defaults.packages = response.data;
                if (
                  order.defaults.packages &&
                  order.defaults.packages.length > 0
                ) {
                  // Usage example
                  if (
                    order.form.paquete ||
                    ($scope.read_pdf_ren &&
                      $scope.read_pdf_ren.data &&
                      $scope.read_pdf_ren.data.cobertura)
                  ) {
                    var result = $scope.getMostSimilarPackage(
                      $scope.read_pdf_ren.data.cobertura.toLowerCase(),
                      order.defaults.packages
                    );
                    if (result) {
                      order.form.paquete = result;
                    }
                    if (
                      !order.form.paquete ||
                      Object.keys(order.form.paquete).length === 0
                    ) {
                      order.form.paquete = order.defaults.packages[0];
                    }
                    $scope.changePackage(order.form.paquete);
                  }
                }
                if (hasRenovationDraft() && renovationDraft.paquete) {
                  order.form.paquete = renovationDraft.paquete;
                }
              }
            },
            function error(e) {
              console.log("Error - paquetes-data-by-subramo", e);
              order.defaults.packages = [];
            }
          )
          .catch(function (error) {
            console.log("Error - paquetes-data-by-subramo - catch", error);
            order.defaults.packages = [];
          });

        // Asigna la forma
        order.show.showForms = true;
        order.defaults.formInfo = {
          code: order.form.subramo.subramo_code,
          name: order.form.subramo.subramo_name,
        };

        order.defaults.comisiones = [];

        if (order.form.clave) {
          if (order.form.clave.clave_comision.length) {
            order.form.clave.clave_comision.forEach(function (item) {
              if (order.form.subramo.subramo_name == item.subramo) {
                order.defaults.comisiones.push(item);
              }
            });

            order.form.comisiones = order.defaults.comisiones;
            if (order.defaults.comisiones.length == 1) {
              order.form.comision = order.defaults.comisiones[0];
              $scope.selectComision(order.form.comision);
            }
          }
        }
        if (
          order.form.subramo.subramo_name == "Vida" ||
          order.form.subramo.subramo_name == "Funerarios"
        ) {
          order.options.life.asegurados.add();

          if (order.form.subramo.subramo_name == "Funerarios") {
            order.subforms.life.beneficiariesList.splice(0, 1);
          }
        }
      } catch (err) {}
    };
    // captura de la poliza final renovacion por PDF
    // renovación por PDF final
    /* Configuración del datepicker */
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("RenovacionesCtrl", RenovacionesCtrl);
  RenovacionesCtrl.$inject = [
    "SweetAlert",
    "providerService",
    "insuranceService",
    "$uibModal",
    "modalService",
    "MESSAGES",
    "helpers",
    "$http",
    "url",
    "$parse",
    "$scope",
    "$state",
    "$sessionStorage",
    "toaster",
    "formatValues",
    "coverageService",
    "exportFactory",
    "datesFactory",
    "appStates",
    "$localStorage",
    "$rootScope",
  ];

  function RenovacionesCtrl(
    SweetAlert,
    providerService,
    insuranceService,
    $uibModal,
    modalService,
    MESSAGES,
    helpers,
    $http,
    url,
    $parse,
    $scope,
    $state,
    $sessionStorage,
    toaster,
    formatValues,
    coverageService,
    exportFactory,
    datesFactory,
    appStates,
    $localStorage,
    $rootScope
  ) {
    function setRenewalDraft(policy) {
      $rootScope.renewalDraftPolicy = angular.copy(policy) || null;
    }

    function clearRenewalDraft() {
      $rootScope.renewalDraftPolicy = null;
    }

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.orgName = usr.orgname;
    var vm = this;
    vm.pageTitle = "Grupos";
    vm.submit = submit;
    vm.insurances = [];
    vm.table = {};
    vm.tableRes = {};
    vm.openRenovateModal = openRenovateModal;
    vm.responsiv = responsiv;
    vm.getRenovaciones = getRenovaciones;
    vm.testPagination = testPagination;
    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.changeUntil = changeUntil;
    vm.Generar = Generar;
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.showBinnacle = showBinnacle;
    vm.returnToReceipts = returnToReceipts;
    vm.matchesGroupinglevel = matchesGroupinglevel;
    vm.matchesClassification = matchesClassification;
    vm.changeBLine = changeBLine;
    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;
    vm.only_caratula_poliza = 0;
    vm.changeSubgrouping = changeSubgrouping;
    vm.changeSubsubgrouping = changeSubsubgrouping;
    $scope.subgroups = [];
    $scope.subsubgroups = [];
    $scope.subgrouping = [];
    $scope.subsubgrouping = [];
    vm.show_binnacle = false;
    vm.word = "";
    vm.form = getDefaultFilters();

    vm.table = {
      headers: [
        "Número de póliza",
        "Contratante",
        "Tipo",
        "Aseguradora",
        "Paquete",
        "Subramo",
        "Fecha de Inicio",
        "Fecha de Fin",
        "Forma de pago",
        "Estatus",
        "Antigüedad",
        "Acciones",
      ],
    };
    vm.tableRes = {
      headers: [
        "Número de póliza",
        "Contratante",
        "Tipo",
        "Aseguradora",
        "Paquete",
        "Subramo",
        "Fecha de Inicio",
        "Fecha de Fin",
        "Forma de pago",
        "Estatus",
        "Antigüedad",
        "Acciones",
      ],
    };
    vm.option = [
      {
        id: 1,
        name: "Renovadas",
      },
      {
        id: 2,
        name: "Por renovar",
      },
    ];
    vm.option_tp = [
      {
        id: 1,
        name: "Individual",
      },
      {
        id: 3,
        name: "Póliza de Grupo",
      },
      {
        id: 11,
        name: "Colectividad",
      },
      {
        id: 12,
        name: "Póliza de Colectividad",
      },
    ];
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
      {
        id: 15,
        name: "No renovada",
      },
    ];

    function getDefaultFilters() {
      return {
        provider: 0,
        ramo: 0,
        subramo: 0,
        since: datesFactory.convertDate(new Date()),
        until: datesFactory.convertDate(new Date()),
        payment: 0,
        status: 0,
        contratante: 0,
        grupo: "",
        renovadas: 1,
        businesLine: 0,
        subgroup: 0,
        subsubgroup: 0,
        groupinglevel: 0,
        subgrouping: 0,
        classification: 0,
        subsubgrouping: 0,
        business_line: 0,
        celula: 0,
        only_caratula: 0,
      };
    }
    vm.businesLine = [
      {
        id: 1,
        name: "Comercial",
      },
      {
        id: 2,
        name: "Personal",
      },
      {
        id: 3,
        name: "Otro",
      },
    ];
    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    activate(1, 1, 1);
    getCelulasContractor();
    vm.getCaratulas = getCaratulas;
    function getCaratulas(parId) {
      var results = [];
      var mapeo_caratulas = [];
      if (parId) {
        if (parId.val.length >= 3) {
          $scope.show_cds = "get-all-caratulas/";
          $http({
            method: "POST",
            url: url.IP + $scope.show_cds,
            data: {
              word: parId.val,
            },
          })
            .then(
              function success(request) {
                var results = [];
                var mapeo_caratulas = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    vm.only_caratula_poliza = 0;
                    $scope.autocompleteData = [];
                    vm.word.id = 0;
                    toaster.warning("Carátula no encontrada");
                  } else {
                    request.data.forEach(function (poliza) {
                      vm.policy = poliza;
                      if (poliza.document_type == 11) {
                        mapeo_caratulas.push(poliza);
                      }
                    });
                    results = _.map(mapeo_caratulas, function (item) {
                      if (item.contractor) {
                        var label =
                          item.poliza_number +
                          " - " +
                          item.contractor.full_name +
                          " - " +
                          convertDate(vm.policy.start_of_validity) +
                          " - " +
                          convertDate(vm.policy.end_of_validity);
                      } else {
                        var label = item.poliza_number;
                      }
                      return {
                        label: label,
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                      };
                    });
                    $scope.autocompleteData = results;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        } else {
          vm.only_caratula_poliza = 0;
          $scope.autocompleteData = [];
          vm.word.id = 0;
        }
      }
    }
    vm.getCarSelected = getCarSelected;
    function getCarSelected(caratula) {
      vm.only_caratula_poliza = caratula.id;
    }

    $scope.ShowContextMenu = function (myInsurance) {
      var params = {};
      $scope.id_for_new_tab = myInsurance.id;
      if (myInsurance.document_type == 1) {
        // $scope.id_for_new_tab = 0;
        // params = { 'myInsurance': myInsurance, 'container': vm.insurances };
        params = { polizaId: myInsurance.id };
        $scope.name_for_new_tab = "Renovación pólizas";
        $scope.route_for_new_tab = "renovaciones.polizas";
        $scope.params_for_new_tab = params;
        // $state.go('renovaciones.polizas', params);
      } else if (myInsurance.document_type == 3) {
        $scope.name_for_new_tab = "Renovación colectividades";
        params = { polizaId: myInsurance.id };
        $scope.route_for_new_tab = "colectividades.renewal";
        $scope.params_for_new_tab = params;
        // $state.go('colectividades.renewal', {polizaId: myInsurance.id});
      } else if (myInsurance.document_type == 7) {
        $scope.name_for_new_tab = "Renovación fianzas";
        params = { polizaId: myInsurance.id, renovacion: 2 };
        $scope.route_for_new_tab = "fianzas.renovar";
        $scope.params_for_new_tab = params;
        // $state.go('fianzas.renovar',{polizaId: myInsurance.id, renovacion : 2});
      } else if (myInsurance.document_type == 8) {
        $scope.name_for_new_tab = "Renovación fianzas";
        params = { polizaId: myInsurance.id };
        $scope.route_for_new_tab = "fianzas.reissue";
        $scope.params_for_new_tab = params;
        // $state.go('fianzas.reissue', {polizaId: myInsurance.id});
      } else if (myInsurance.document_type == 11) {
        $scope.name_for_new_tab = "Renovación flotillas";
        params = { polizaId: myInsurance.id };
        $scope.route_for_new_tab = "flotillas.renewal";
        $scope.params_for_new_tab = params;
        // $state.go('flotillas.renewal', {polizaId: myInsurance.id});
      }
    };

    $scope.open_new_tab = function () {
      var existe = false;
      appStates.states.forEach(function (state) {
        if (
          state.route == $scope.route_for_new_tab &&
          state.id == $scope.id_for_new_tab
        ) {
          existe = true;
        }
      });
      if (appStates.states.length > 3) {
        SweetAlert.swal("Error", "No se pueden abrir más pestañas.", "error");
      } else {
        if (!existe) {
          appStates.states.push({
            id: $scope.id_for_new_tab,
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab, {
              polizaId: $scope.id_for_new_tab,
            }),
          });
          $localStorage.tab_states = appStates.states;
        }
      }
    };

    $scope.$watch("vm.word", function (newValue, oldValue) {
      if (vm.word) {
        if (vm.word.id) {
          vm.only_caratula_poliza = parseInt(vm.word.id);
        } else {
          vm.only_caratula_poliza = 0;
        }
      }
    });
    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    function changeBLine(obj) {
      $scope.bLine = obj;
      if (obj) {
        vm.form.businesLine = obj;
      } else {
        vm.form.businesLine = 0;
      }
    }

    function changeSubgroup(subg) {
      vm.form.subgroup = subg;
      vm.subgroup = subg;
      $scope.subsubgroups = subg.subsubgrupos ? subg.subsubgrupos : [];
    }
    function changeSubsubgroup(subg) {
      vm.form.subsubgroup = subg;
      vm.subsubgroup = subg;
    }
    // Nivel de agrupación
    function changeSubgrouping(subgl) {
      if (subgl) {
        vm.form.subgrouping = subgl;
        vm.subgrouping = subgl;
        $scope.subsubgrouping = subgl.subsubgrupos ? subgl.subsubgrupos : [];
      } else {
        vm.form.subgrouping = 0;
        $scope.subsubgrouping = [];
      }
    }
    function changeSubsubgrouping(subgl) {
      vm.form.subsubgrouping = subgl;
      vm.subsubgrouping = subgl;
    }

    $scope.selectProv = function (sel) {
      vm.form.provider = [];
      sel.forEach(function (cl) {
        vm.form.provider.push(cl.id);
      });
    };

    $scope.selectRamos = function (sel) {
      vm.subramos_toselected = [];
      vm.form.ramo = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.form.ramo.push(parseInt(r));
        $http.get(url.IP + "subramos-by-ramo_code/" + r).then(function (data) {
          data.data.forEach(function (sr) {
            vm.subramos_toselected.push(sr);
          });
        });
      });
      // if (sel.length == 1) {
      // if (vm.id) {

      // }
      // }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        // getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.form.subramo = [];
      sel.forEach(function (sr) {
        if (sr.subramo_code) var code = sr.subramo_code;
        else var code = sr.id;
        vm.form.subramo.push(code);
      });
    };

    // getRenovaciones (1,1,1)
    vm.form.since = datesFactory.convertDate(new Date());
    // var endingDate =  convertDate(new Date().setYear(new Date().getFullYear() + 1));
    vm.form.until = datesFactory.convertDate(new Date());
    vm.changeRenewal = changeRenewal;
    function changeRenewal(par, asc) {
      switch (par) {
        case 1:
          Generar(par, asc);
          vm.ren_nump_asc = asc;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 2:
          Generar(par, asc);
          vm.ren_cont_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 3:
          Generar(par, asc);
          vm.ren_type_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 4:
          Generar(par, asc);
          vm.ren_aseg_asc = asc;
          vm.ren_cont_asc = 0;
          vm.ren_nump_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 5:
          Generar(par, asc);
          vm.ren_pack_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 6:
          Generar(par, asc);
          vm.ren_subr_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 7:
          Generar(par, asc);
          vm.ren_fini_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 8:
          Generar(par, asc);
          vm.ren_ffin_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 9:
          Generar(par, asc);
          vm.ren_fini_asc = 0;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = asc;
          vm.ren_est_asc = 0;
          break;
        case 10:
          Generar(par, asc);
          vm.ren_ffin_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = asc;
          break;
      }
    }
    vm.changeRenewalT = changeRenewalT;
    function changeRenewalT(par, asc) {
      var param = $scope.status;
      switch (par) {
        case 1:
          getRenovaciones(param, par, asc);
          vm.ren_nump_asc = asc;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 2:
          getRenovaciones(param, par, asc);
          vm.ren_cont_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 3:
          getRenovaciones(param, par, asc);
          vm.ren_type_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 4:
          getRenovaciones(param, par, asc);
          vm.ren_aseg_asc = asc;
          vm.ren_cont_asc = 0;
          vm.ren_nump_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 5:
          getRenovaciones(param, par, asc);
          vm.ren_pack_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 6:
          getRenovaciones(param, par, asc);
          vm.ren_subr_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 7:
          getRenovaciones(param, par, asc);
          vm.ren_fini_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 8:
          getRenovaciones(param, par, asc);
          vm.ren_ffin_asc = asc;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_fini_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = 0;
          break;
        case 9:
          getRenovaciones(param, par, asc);
          vm.ren_fini_asc = 0;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_ffin_asc = 0;
          vm.ren_pago_asc = asc;
          vm.ren_est_asc = 0;
          break;
        case 10:
          getRenovaciones(param, par, asc);
          vm.ren_ffin_asc = 0;
          vm.ren_fini_asc = 0;
          vm.ren_nump_asc = 0;
          vm.ren_cont_asc = 0;
          vm.ren_type_asc = 0;
          vm.ren_aseg_asc = 0;
          vm.ren_pack_asc = 0;
          vm.ren_subr_asc = 0;
          vm.ren_pago_asc = 0;
          vm.ren_est_asc = asc;
          break;
      }
    }

    function Generar(order, asc, parPage) {
      $scope.order = order ? order : 1;
      $scope.asc = asc ? asc : 1;
      $scope.actual_page = parPage ? parPage : 1;
      vm.insurances = [];
      $scope.results = true;
      if (vm.form.provider) {
        var p = vm.form.provider;
      } else {
        var p = 0;
      }
      if (vm.form.ramo) {
        var r = vm.form.ramo;
      } else {
        var r = 0;
      }
      if (vm.form.subramo) {
        var s = vm.form.subramo;
      } else {
        var s = 0;
      }
      if (vm.form.status) {
        var e = vm.form.status.id;
      } else {
        var e = 0;
      }
      if (vm.form.tipo_poliza) {
        var tp = vm.form.tipo_poliza.id;
      } else {
        var tp = 0;
      }
      if (vm.form.payment) {
        var f = vm.form.payment.id;
      } else {
        var f = 0;
      }
      if (vm.form.contratante.val) {
        var c = vm.form.contratante.value;
      } else {
        var c = 0;
      }
      if (vm.form.group) {
        if (vm.form.group.val) {
          var g = vm.form.group.value;
        } else {
          var g = 0;
        }
      }
      if (vm.form.subgroup) {
        if (vm.form.subgroup.id) {
          var g1 = vm.form.subgroup.id;
        } else {
          var g1 = 0;
        }
      }
      if (vm.form.subsubgroup) {
        if (vm.form.subsubgroup.id) {
          var g2 = vm.form.subsubgroup.id;
        } else {
          var g2 = 0;
        }
      } else {
        var g2 = 0;
      }
      if (vm.form.groupinglevel) {
        if (vm.form.groupinglevel.val) {
          var gl = vm.form.groupinglevel.value;
        } else {
          var gl = 0;
        }
      } else {
        var gl = 0;
      }
      if (vm.form.subgrouping) {
        if (vm.form.subgrouping.id) {
          var gl1 = vm.form.subgrouping.id;
        } else {
          var gl1 = 0;
        }
      } else {
        var gl1 = 0;
      }
      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }
      if (vm.form.subsubgrouping) {
        if (vm.form.subsubgrouping.id) {
          var gl2 = vm.form.subsubgrouping.id;
        } else {
          var gl2 = 0;
        }
      } else {
        var gl2 = 0;
      }
      var params = {
        provider: p,
        ramo: r,
        subramo: s,
        since: vm.form.since ? vm.form.since : 0,
        until: vm.form.until ? vm.form.until : 0,
        payment: f,
        status: e,
        tipo_poliza: tp,
        contratante: c,
        grupo: g,
        order: order ? order : 1,
        asc: asc ? asc : 1,
        renovadas: vm.form.renovadas.id ? vm.form.renovadas.id : 1,
        classification: vm.form.classification.value
          ? vm.form.classification.value
          : vm.form.classification,
        subgrupo: g1 ? g1 : 0,
        subsubgrupo: g2 ? g2 : 0,
        groupinglevel: gl ? gl : 0,
        subgrupinglevel: gl1 ? gl1 : 0,
        subsubgrupinglevel: gl2 ? gl2 : 0,
        businessLine: $scope.bLine ? $scope.bLine.id : 0,
        celula: cel ? cel : 0,
        page: parPage ? parPage : 1,
        only_caratula: vm.only_caratula_poliza ? vm.only_caratula_poliza : 0,
      };
      vm.insurances = [];
      if (
        vm.form.classification.val == "" ||
        vm.form.classification.val == null ||
        vm.form.classification == undefined
      ) {
        params.classification = 0;
      }
      if (vm.form.contratante.type == "natural") {
        vm.form.contratante.type = 1;
      }
      if (vm.form.contratante.type == "juridical") {
        vm.form.contratante.type = 2;
      } else {
        vm.form.contratante.type == 0;
      }
      params.grupo = vm.form.group ? g : 0;
      params.type_contractor = vm.form.contratante.type
        ? vm.form.contratante.type
        : 0;
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";

      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   var filter_renovation = 'v2/polizas/filtros-renovaciones/';
      var filter_renovation = "filtros-renovaciones/";
      $scope.params = params;
      $http({
        method: "GET",
        url: url.IP + filter_renovation,
        params: params,
      }).then(function success(response) {
        if (response.status === 200 && response.data.results.length) {
          vm.insurances = response.data.results;
          if (vm.insurances && vm.insurances.length > 0) {
            vm.insurances.forEach(function (item) {
              $http({
                method: "GET",
                url: url.IP + "historic-policies/",
                params: {
                  actual_id: item.id,
                },
              }).then(function success(response) {
                if (response.data.results.length) {
                  item.policy_history = [];
                  item.policy_history.renovada = [];
                  response.data.results.forEach(function function_name(old) {
                    if (item.id != old.base_policy.id) {
                      item.policy_history.push(old.base_policy);
                    } else if (old.new_policy) {
                      item.policy_history.push(old.new_policy);
                    }
                    if (item.id == old.base_policy.id) {
                      item.policy_history.renovada.push(old.base_policy);
                    }
                  });
                }
              });
            });
          }
          // vm.insurances = response.data.results; se repite no se si se deba borrar
          vm.insurances_config = {
            count: response.data.count,
            previous: response.data.previous,
            next: response.data.next,
          };

          vm.show_pag_renew = true;
          $scope.obtenerPaginacion(response.data, parPage ? parPage : 1);
          // testPagination('vm.insurances', 'vm.insurances_config');
        } else {
          vm.show_pag_renew = false;
          toaster.warning("No se encontraron registros");
        }
      });
    }

    $scope.exportData = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var filtros = $scope.params;
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   // var url_rep = 'v2/polizas/reporte-policy-renewal';
      //   var url_rep = 'service_reporte-v2-renovaciones-excel';
      var url_rep = "service_reporte-renovaciones-excel";
      if (param == 1) {
        $http({
          method: "GET",
          url: url.IP + url_rep, //'reporte-policy-renewal',
          params: filtros,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
          .then(function (data) {
            if (data.status == 200) {
              // l.stop();
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Renovaciones.xls");
            } else {
              SweetAlert.swal(
                "Error",
                "Ha ocurrido un error al descargar el reporte",
                "error"
              );
              // l.stop()
            }
            l.stop();
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
        //     params: filtros
        // }). then(function success(request) {
        //       if(request.status === 200) {
        //           exportFactory.excel(request.data, ' renovaciones');
        //       }

        //     })
        //     .catch(function (e) {
        //       console.log('e', e);
        //     });
      }
    };

    // nueva paginación inicial resultados
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      Generar($scope.order || 1, $scope.asc || 1, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        Generar(
          $scope.order || 1,
          $scope.asc || 1,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        Generar(
          $scope.order || 1,
          $scope.asc || 1,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };
    // vigentes tabs
    $scope.obtenerPaginacionVig = function (clasificacion, pagina) {
      $scope.paginacionVig = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
    };
    $scope.anteriorPaginaVig = function () {
      getResultadosByPage(vm.insurances_config.previous, 2);
    };

    $scope.siguientePaginaVig = function () {
      getResultadosByPage(vm.insurances_config.next, 2);
    };
    // vencidas 1
    function getResultadosByPage(page, param) {
      $http({
        method: "GET",
        url: page,
      })
        .then(function success(request) {
          if (param < 3) {
            vm.loading = false;
            vm.insurances = [];
            vm.receipt = {};
            vm.insurances = request.data.results;
            vm.insurances_config = {
              count: request.data.count,
              previous: request.data.previous,
              next: request.data.next,
            };
            if (param == 1) {
              $scope.obtenerPaginacionVenc(request.data, 1);
            }
            if (param == 2) {
              $scope.obtenerPaginacionVig(request.data, 1);
            }

            // testPagination('vm.insurances', 'vm.insurances_config');
          } else {
            console.log("Error");
          }
          function error(error) {
            console.log("error", error);
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }
    $scope.obtenerPaginacionVenc = function (clasificacion, pagina) {
      $scope.paginacionVenc = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
    };
    $scope.anteriorPaginaVenc = function () {
      getResultadosByPage(vm.insurances_config.previous, 1);
    };

    $scope.siguientePaginaVenc = function () {
      getResultadosByPage(vm.insurances_config.next, 1);
    };

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal(
          "Error",
          "La fecha final no puede ser menor que la inicial",
          "error"
        );
        var newdate = convertDate(new Date());
        vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function returnToReceipts() {
      vm.show_binnacle = false;
    }

    function showBinnacle(param) {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 6,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.show_binnacle = true;
      vm.renewal_id = param.id;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    function activate(status, order, asc) {
      $(".js-example-basic-multiple").select2();
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              } else if (acc.permission_name == "Cancelar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_canc_pol = true;
                } else {
                  vm.acceso_canc_pol = false;
                }
              } else if (acc.permission_name == "Eliminar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_elim_pol = true;
                } else {
                  vm.acceso_elim_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            vm.acceso_reportes = perm;
            vm.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  vm.acceso_rep_fia = true;
                } else {
                  vm.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  vm.acceso_rep_sin = true;
                } else {
                  vm.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  vm.acceso_rep_end = true;
                } else {
                  vm.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  vm.acceso_rep_pol = true;
                } else {
                  vm.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  vm.acceso_rep_ren = true;
                } else {
                  vm.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  vm.acceso_rep_cob = true;
                } else {
                  vm.acceso_rep_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Ordenes de trabajo") {
            vm.acceso_ot = perm;
            vm.acceso_ot.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar OTs") {
                if (acc.checked == true) {
                  vm.acceso_adm_ot = true;
                } else {
                  vm.acceso_adm_ot = false;
                }
              } else if (acc.permission_name == "Ver OTs") {
                if (acc.checked == true) {
                  vm.acceso_ver_ot = true;
                } else {
                  vm.acceso_ver_ot = false;
                }
              } else if (acc.permission_name == "Cancelar OTs") {
                if (acc.checked == true) {
                  vm.acceso_canc_ot = true;
                } else {
                  vm.acceso_canc_ot = false;
                }
              } else if (acc.permission_name == "Eliminar OTs") {
                if (acc.checked == true) {
                  vm.acceso_elim_ot = true;
                } else {
                  vm.acceso_elim_ot = false;
                }
              }
            });
          } else if (perm.model_name == "Contratantes y grupos") {
            vm.acceso_contg = perm;
            vm.acceso_contg.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar contratantes y grupos") {
                if (acc.checked == true) {
                  vm.acceso_adm_cont = true;
                } else {
                  vm.acceso_adm_cont = false;
                }
              } else if (acc.permission_name == "Ver contratantes y grupos") {
                if (acc.checked == true) {
                  vm.acceso_ver_cont = true;
                } else {
                  vm.acceso_ver_cont = false;
                }
              }
            });
          } else if (perm.model_name == "Siniestros") {
            vm.acceso_sin = perm;
            vm.acceso_sin.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar siniestros") {
                if (acc.checked == true) {
                  vm.acceso_adm_sin = true;
                } else {
                  vm.acceso_adm_sin = false;
                }
              }
            });
          } else if (perm.model_name == "Mensajeria") {
            vm.acceso_mns = perm;
            vm.acceso_mns.permissions.forEach(function (acc) {
              if (acc.permission_name == "Mensajeria") {
                if (acc.checked == true) {
                  vm.acceso_mns = true;
                } else {
                  vm.acceso_mns = false;
                }
              }
            });
          } else if (perm.model_name == "Formatos") {
            vm.acceso_form = perm;
            vm.acceso_form.permissions.forEach(function (acc) {
              if (acc.permission_name == "Formatos") {
                if (acc.checked == true) {
                  vm.acceso_form = true;
                } else {
                  vm.acceso_form = false;
                }
              }
            });
          } else if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Referenciadores") {
            vm.acceso_ref = perm;
            vm.acceso_ref.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar referenciadores") {
                if (acc.checked == true) {
                  vm.acceso_adm_ref = true;
                } else {
                  vm.acceso_adm_ref = false;
                }
              } else if (acc.permission_name == "Pagar a referenciadores") {
                if (acc.checked == true) {
                  vm.acceso_pag_ref = true;
                } else {
                  vm.acceso_pag_ref = false;
                }
              } else if (
                acc.permission_name == "Cambiar refrenciador en pólizas"
              ) {
                if (acc.checked == true) {
                  vm.acceso_chg_ref = true;
                } else {
                  vm.acceso_chg_ref = false;
                }
              } else if (acc.permission_name == "Ver referenciadores") {
                if (acc.checked == true) {
                  vm.acceso_ver_ref = true;
                } else {
                  vm.acceso_ver_ref = false;
                }
              }
            });
          }
        });
      }
      getProviders();
      // getSubramos();
      $scope.total = 0;
      vm.form = getDefaultFilters();
      vm.word = "";
      $scope.actual_page = 1;
      getInsurances(status, order, asc);
    }

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        vm.providers = data.data;
      });
    }

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      }
      $http.get(url.IP + "ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.ramos = ramos.data;
      });
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      }
      try {
        vm.subramos = obj.subramo_ramo;
      } catch (e) {}
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }

    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }

    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        if (vm.form.group.val) {
          var word_data = vm.form.group.val;
        }
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_group = 'v2/contratantes/grupos-match/';
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  $scope.subgroups = item.subgrupos;
                  // $scope.subsubgroups = [];
                  // $scope.subgroups.forEach(function(itm) {
                  //   $scope.subsubgroups = itm.subsubgrupos
                  // });
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    $scope.$watch("vm.form.group.value", function (newValue, oldValue) {
      if (vm.form.group) {
        if (vm.form.group.value) {
          $http
            .get(url.IP + "grupos/" + vm.form.group.value)
            .then(function (item) {
              vm.form.group.data = item.data;

              $scope.subgroups = item.data.subgrupos;
              $scope.subgroups.forEach(function (itm) {
                $scope.subsubgroups = itm.subsubgrupos;
              });
            });
        }
      }
    });

    function matchesGroupinglevel(parWord, parType) {
      $scope.subgrouping = [];
      $scope.subsubgrouping = [];
      $scope.groupunglevels_data = 0;
      vm.form.subgrouping = 0;
      vm.form.subsubgrouping = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.groupinglevel.val) {
        var word_data = vm.form.groupinglevel.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_grouping = "groupinglevel-match/";

          $http
            .post(url.IP + $scope.show_grouping, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groupinglevels = response.data ? response.data : [];
                groupinglevels.forEach(function (item) {
                  $scope.subsubgrouping = [];
                  $scope.subgrouping.forEach(function (itm) {
                    $scope.subsubgrouping = itm.subsubgrupos;
                  });
                  var obj = {
                    label: item.description,
                    value: item.id,
                    url: item.url,
                    subgrupos: item.subgrupos,
                  };
                  source.push(obj);
                });

                $scope.groupinglevels_data = source;
              }
            });
        }
      }
    }
    // --GroupingLevel
    // classification
    function matchesClassification(parWord, parType) {
      $scope.classification_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.classification.val) {
        var word_data = vm.form.classification.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_claass = "classification-match/";

          $http
            .post(url.IP + $scope.show_claass, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var classifica = response.data;
                classifica.forEach(function (item) {
                  var obj = {
                    label: item.classification_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.classification_data = source;
              }
            });
        }
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    function getRenovaciones(param, order, asc, page) {
      $scope.status = param;
      $http({
        method: "GET",
        url: url.IP + "leer-rpolizas-resume/",
        params: {
          status: param,
          order: order,
          asc: asc,
          page: page ? page : 1,
        },
      })
        .then(function success(request) {
          if (param < 3) {
            vm.loading = false;
            vm.insurances = [];
            vm.receipt = {};
            vm.insurances = request.data.results;
            vm.insurances_config = {
              count: request.data.count,
              previous: request.data.previous,
              next: request.data.next,
            };
            if (param == 1) {
              $scope.obtenerPaginacionVenc(request.data, 1);
            }
            if (param == 2) {
              $scope.obtenerPaginacionVig(request.data, 1);
            }

            // testPagination('vm.insurances', 'vm.insurances_config');
          } else {
            console.log("Error");
          }
          function error(error) {
            console.log("error", error);
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }

    function getInsurances(status, order, asc, page) {
      insuranceService
        .getPoliciesForRenovation(status, order, asc, page)
        .then(function (policies) {
          vm.insurances = policies.policies;
          vm.insurances_config = {
            count: policies.policies.count,
            previous: policies.policies.previous,
            next: policies.policies.next,
          };
          if (status == 1) {
            $scope.obtenerPaginacionVenc(policies.policies, 1);
          }
          if (status == 2) {
            $scope.obtenerPaginacionVig(policies.policies, 1);
          }
        });
    }

    function responsiv() {
      $("#vencidas").trigger("resize");
      $("#vigentes").trigger("resize");
    }

    function openRenovateModal(myInsurance) {
      if (vm.form.renovadas && vm.form.renovadas.id == 1) {
        return;
      }
      clearRenewalDraft();
      // return
      // evaluate
      $scope.existeRenovacion = false;
      $scope.conteo = 0;
      $scope.totalp = myInsurance.policy_history
        ? myInsurance.policy_history.length
        : 0;
      if (myInsurance.policy_history) {
        myInsurance.policy_history.forEach(function (old) {
          $scope.conteo = $scope.conteo + 1;
          if (old.status == 1) {
            $scope.existeRenovacion = true;
            SweetAlert.swal(
              "Información",
              "La póliza ya tiene una OT de renovación",
              "info"
            );
            $state.go("renovaciones.renovaciones");
            clearRenewalDraft();
            return;
          }
        });
      }
      if (myInsurance.renewed) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRENEWPOLICY, "error");
      } else if (
        $scope.conteo == $scope.totalp &&
        $scope.existeRenovacion == false
      ) {
        if (myInsurance.document_type == 1) {
          $scope.route_for_new_tab = "renovaciones.polizas";
          var name = "Renovación Póliza";
          var route = "renovaciones.polizas";
        } else if (myInsurance.document_type == 3) {
          $scope.route_for_new_tab = "colectividades.renewal";
          var name = "Renovación Colectividad";
          var route = "colectividades.renewal";
        } else if (myInsurance.document_type == 7) {
          $scope.route_for_new_tab = "fianzas.renovar";
          var name = "Renovación Colectividad";
          var route = "fianzas.renovar";
        } else if (myInsurance.document_type == 8) {
          $scope.route_for_new_tab = "fianzas.reissue";
          var name = "Renovación Colectividad";
          var route = "fianzas.reissue";
        } else if (myInsurance.document_type == 11) {
          $scope.route_for_new_tab = "flotillas.renewal";
          var name = "Renovación Flotilla";
          var route = "flotillas.renewal";
        } else if (myInsurance.document_type == 12) {
          $scope.route_for_new_tab = "flotillas.renewal";
          var name = "Renovación Flotilla";
          var route = "flotillas.renewal";
        }

        $scope.name_for_new_tab = name;
        $scope.route_for_new_tab = route;

        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }

        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });

          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab),
          };
        }
        $localStorage.tab_states = appStates.states;

        var params = { polizaId: myInsurance.id, myInsurance: myInsurance };
        if (myInsurance.document_type == 1) {
          setRenewalDraft(myInsurance);
          $state.go("renovaciones.polizas", params);
        } else if (myInsurance.document_type == 3) {
          $state.go("colectividades.renewal", { polizaId: myInsurance.id });
        } else if (myInsurance.document_type == 7) {
          $state.go("fianzas.renovar", {
            polizaId: myInsurance.id,
            renovacion: 2,
          });
        } else if (myInsurance.document_type == 8) {
          $state.go("fianzas.reissue", { polizaId: myInsurance.id });
        } else if (myInsurance.document_type == 11) {
          $state.go("flotillas.renewal", { polizaId: myInsurance.id });
        } else if (myInsurance.document_type == 12) {
          SweetAlert.swal(
            "Advertencia",
            "Las pólizas de colectividad solo se pueden renovar mediante layout.",
            "warning"
          );
          // $state.go('flotillas.renewal', {polizaId: myInsurance.caratula});
        }
      } else {
        return;
      }
    }

    function submit(isValid) {
      if (isValid) {
        alert("awesonme");
      }
    }

    // function testPagination(parModel, parConfig) {

    //   var config_ = $parse(parConfig)($scope)
    //   if(config_) {
    //     var pages = Math.ceil(config_.count / 10);
    //   }
    //   $scope.totalPages = [];
    //   var count_items = 0;
    //   var count_pages = 0;

    //   var previous_array = [];
    //   var next_array = [];

    //   $scope.start = 0;
    //   $scope.end = 5;
    //   $scope.actual_page = 1;
    //   $scope.not_prev = true;

    //   for (var i = 0; i < pages; i++) {
    //     $scope.totalPages.push(i+1);
    //   }

    //   $scope.lastPage = function() {
    //     // TODO: ultimo bloque
    //     if($scope.totalPages.length > 5) {
    //       $scope.end = $scope.totalPages.length;
    //       $scope.start = ($scope.totalPages.length) -5;
    //       $scope.show_prev_block = true;
    //     }

    //     $scope.selectPage($scope.totalPages.length);

    //     $scope.actual_page = $scope.totalPages.length;

    //   }

    //   $scope.selectPage = function (parPage) {
    //     if(config_.next || config_.previous) {
    //       if(config_.next) {
    //         var next_ = config_.next;

    //         var otherParameters = config_.next.substring(config_.next.indexOf("&page=") + 6);

    //         if(next_.search('&status=') !== -1) {
    //           var status = next_.substring(next_.indexOf("&status=") + 1);
    //         } else {
    //           var status = '';
    //         }

    //         var url = config_.next.substring(0, config_.next.indexOf("&page=") + 6);
    //         url += parPage.toString();
    //         url += '&'+status

    //          if(config_.next.search('&') !== -1) {
    //            var params = otherParameters.substring(2, otherParameters.indexOf('&')+1000);
    //             // url += '&'+params;
    //             }

    //       } else {

    //         var prev_ = config_.previous;
    //         var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
    //         if(prev_.search('&status=') !== -1) {
    //           var status = prev_.substring(prev_.indexOf("&status=") + 1);
    //         } else {
    //           var status = '';
    //         }

    //         if(prev_.search('&page=') !== -1) {
    //           var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
    //           url += parPage.toString();
    //           url += '&'+status;

    //         } else {
    //           var url = config_.previous
    //         }
    //         if(config_.prev_.search('&') !== -1) {
    //           var params = otherParameters.substring(2, otherParameters.indexOf('&')+1000);

    //         url += '&'+params;
    //         }
    //       }
    //     }

    //     // url += '&status=1'
    //     getRenovacionesPag(url);
    //     $scope.actual_page = parPage;
    //     if($scope.actual_page > 1) {
    //       $scope.not_prev = false;
    //     }

    //     if($scope.actual_page == $scope.totalPages.length -1) {
    //       $scope.not_next = true;
    //     }

    //   }

    //   $scope.previousBlockPages = function(param) {
    //     if(param) {
    //       if($scope.start < $scope.actual_page) {
    //         $scope.start = $scope.start - 1 ;
    //         $scope.end = $scope.end - 1;
    //       }

    //     } else {
    //       $scope.start = $scope.start - 5 ;
    //       $scope.end = $scope.end - 5;

    //       if($scope.end < $scope.totalPages.length) {
    //           $scope.not_next = false;
    //       }
    //     }

    //     if($scope.end <= 5) {
    //       $scope.start = 0;
    //       $scope.end = 5;
    //       $scope.show_prev_block = false;
    //     }
    //   }

    //   $scope.nextBlockPages = function(param) {

    //     $scope.show_prev_block = true;

    //     if(param) {
    //       if($scope.end > $scope.actual_page) {
    //         $scope.start = $scope.start + 1 ;
    //         $scope.end = $scope.end + 1;
    //       }
    //     } else {
    //       if($scope.end < $scope.totalPages.length) {
    //         $scope.start = $scope.start + 5 ;
    //         $scope.end = $scope.end + 5;

    //         if($scope.end == $scope.totalPages.length) {
    //             $scope.not_next = true;
    //         }
    //       } else {
    //         $scope.not_next = true;
    //       }
    //     }

    //   }

    //   function getRenovacionesPag(parUrl) {
    //     $http.get(parUrl)
    //     .then(
    //       function success(request) {
    //         var source = $parse(parModel);
    //         source.assign($scope, []);
    //         source.assign($scope, request.data.results);

    //         var data = {
    //           count: request.data.count,
    //           previous: request.data.previous,
    //           next: request.data.next
    //         }

    //       var config = $parse(parConfig);
    //         config.assign($scope, []);
    //         config.assign($scope, data);

    //       },
    //       function error(error) {
    //         console.log('error', error);
    //       }
    //     )
    //     .catch(function(e) {
    //       console.log('e', e);
    //     });
    //   };
    // }
    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPagesP = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesP.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesP.length > 5) {
          $scope.end = $scope.totalPagesP.length;
          $scope.start = $scope.totalPagesP.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPageP($scope.totalPagesP.length);
        // $scope.actual_page = $scope.totalPagesP.length;
        // $scope.page = $scope.totalPagesP.length;
      };

      $scope.selectPageP = function (parPage) {
        $scope.actual_page = parPage;

        Generar($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPagesP = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesP.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesP = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesP.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesP.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // ------- Guardar sumas aseguradas y deducibl
    $scope.show_button_save_sum = false;
    $scope.show_button_save_ded = false;
    $scope.demo = function (param) {
      var model = formatValues.currency(param);
      return model;
    };
    $scope.saveSum = function (parValue, parCoverage) {
      var obj = {
        sum_insured: parValue,
        default: false,
        coverage_sum: parCoverage.url,
      };
      coverageService.createSumInsured(obj).then(function (req) {
        if (req.id) {
          $scope.result_ = false;
          parCoverage.sums_coverage.push(req);
        }
      });
    };
    $scope.saveDed = function (parValue, parCoverage) {
      var obj = {
        deductible: parValue,
        default: false,
        coverage_deductible: parCoverage.url,
      };
      coverageService.createDeducible(obj).then(function (req) {
        if (req.id) {
          $scope.result_ded = false;
          parCoverage.deductible_coverage.push(req);
        }
      });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").factory("ramoService", ramoService);

  ramoService.$inject = ["url", "helpers", "$http"];

  function ramoService(url, helpers, $http) {
    var service = {
      createRamo: createRamo,
      createForm: createForm,
      getRamos: getRamos,
      getRamo: getRamo,
      getRamoByUri: getRamoByUri,
      updateRamo: updateRamo,
      deleteRamo: deleteRamo,
      createSubramo: createSubramo,
      getSubramos: getSubramos,
      getSubramo: getSubramo,
      getSubramoByUri: getSubramoByUri,
      getSubramoById: getSubramoById,
      updateSubramo: updateSubramo,
      deleteSubramo: deleteSubramo,
      getRamoById: getRamoById,
    };

    return service;

    ////////////

    // CREATE
    function createRamo(data) {
      return $http
        .post(url.IP + "ramos/", data)
        .then(createRamoComplete)
        .catch(createRamoFailed);

      function createRamoComplete(res) {
        if (!helpers.isResponseOk(res.status)) {
          return createRamoFailed(res);
        }
        return res;
      }

      function createRamoFailed(error) {
        return error;
      }
    }

    function createForm(req) {
      req.sub_branch = req.urlSubramo;
      return $http
        .post(req.urlForm, req)
        .then(createFormComplete)
        .catch(createFormFailed);

      function createFormComplete(res) {
        if (helpers.isResponseAnError(res.status)) {
          return createFormFailed(res);
        }
        return res;
      }

      function createFormFailed(error) {
        return error;
      }
    }

    //   READ
    function getRamos() {
      return $http
        .get(url.IP + "ramos/")
        .then(getRamosComplete)
        .catch(getRamosFailed);

      function getRamosComplete(response) {
        return response.data.results;
      }

      function getRamosFailed(error) {}
    }

    function getRamoByUri(url) {
      return $http.get(url).then(getRamoComplete).catch(getRamoFailed);

      function getRamoComplete(response) {
        return response;
      }

      function getRamoFailed(error) {}
    }

    function getRamoById(id) {
      return $http
        .get(url.IP + "ramo-by-id/" + id)
        .then(getRamoComplete)
        .catch(getRamoFailed);

      function getRamoComplete(response) {
        return response;
      }

      function getRamoFailed(error) {}
    }

    function getRamo(data) {
      if (!isNaN(Number(data.ramosId))) {
        data.ramosId = url.IP + "ramos/" + data.ramosId + "/";
      } else if (data.ramo) {
        data.ramosId = data.ramo;
      } else {
        data.ramosId = data.group;
      }
      return $http.get(data.ramosId).then(getRamoComplete).catch(getRamoFailed);

      function getRamoComplete(response) {
        return response.data;
      }

      function getRamoFailed(error) {}
    }

    //UPDATE
    function updateRamo(data) {
      return $http
        .put(url.IP + "ramos/" + data.id + "/", data)
        .then(updateRamoComplete)
        .catch(updateRamoFailed);

      function updateRamoComplete(response) {
        return response;
      }

      function updateRamoFailed(error) {}
    }

    //DELETE
    function deleteRamo(obj) {
      return $http
        .delete(url.IP + "ramos/" + obj.id + "/")
        .then(deleteRamoComplete)
        .catch(deleteRamoFailed);

      function deleteRamoComplete(response, status, headers, config) {
        //jshint ignore:line
        return response;
      }

      function deleteRamoFailed(response, status, headers, config) {
        //jshint ignore:line
      }
    }

    // CREATE
    function createSubramo(data) {
      return $http
        .post(url.IP + "subramos/", data)
        .then(createSubramoComplete)
        .catch(createSubramoFailed);

      function createSubramoComplete(response) {
        return response.data;
      }

      function createSubramoFailed(error) {}
    }

    //   READ
    function getSubramos() {
      return $http
        .get(url.IP + "subramos/")
        .then(getSubramosComplete)
        .catch(getSubramosFailed);

      function getSubramosComplete(response) {
        return response.data.results;
      }

      function getSubramosFailed(error) {}
    }

    function getSubramoByUri(uri) {
      return $http.get(uri).then(getSubramoComplete).catch(getSubramoFailed);

      function getSubramoComplete(response) {
        return response;
      }

      function getSubramoFailed(error) {
        return error;
      }
    }

    function getSubramoById(id) {
      return $http
        .get(url.IP + "subramo-by-id/" + id)
        .then(getSubramoComplete)
        .catch(getSubramoFailed);

      function getSubramoComplete(response) {
        return response;
      }

      function getSubramoFailed(error) {
        return error;
      }
    }

    function getSubramo(data) {
      if (data.ramo) {
        data = data.ramo;
      } else {
        data = data.subramo;
      }
      return $http.get(data).then(getSubramoComplete).catch(getSubramoFailed);

      function getSubramoComplete(response) {
        return response;
      }

      function getSubramoFailed(error) {
        return error;
      }
    }

    //UPDATE
    function updateSubramo(data) {
      return $http
        .put(url.IP + "subramos/" + data.id + "/", data)
        .then(updateSubramoComplete)
        .catch(updateSubramoFailed);

      function updateSubramoComplete(response) {
        return response;
      }

      function updateSubramoFailed(error) {}
    }

    //DELETE
    function deleteSubramo(obj) {
      return $http
        .delete(url.IP + "subramos/" + obj.id + "/")
        .then(deleteSubramoComplete)
        .catch(deleteSubramoFailed);

      function deleteSubramoComplete(response, status, headers, config) {
        //jshint ignore:line
        return response;
      }

      function deleteSubramoFailed(response, status, headers, config) {
        //jshint ignore:line
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").factory("receiptService", receiptService);

  receiptService.$inject = [
    "dataFactory",
    "url",
    "statusReceipt",
    "$http",
    "$q",
    "fileService",
    "$localStorage",
    "$sessionStorage",
  ];
  function receiptService(
    dataFactory,
    url,
    statusReceipt,
    $http,
    $q,
    fileService,
    $localStorage,
    $sessionStorage
  ) {
    // var dfd = $q.defer();
    /* Información de usuario */
    var infoUser = $localStorage.infoUser;

    var service = {
      createReceiptService: createReceiptService,
      getNextReceipts: getNextReceipts,
      getReceiptsService: getReceiptsService,
      getReceiptService: getReceiptService,
      getReceiptsReadService: getReceiptsReadService,
      getReceiptsReadChildrensService: getReceiptsReadChildrensService,
      getReceiptInfo: getReceiptInfo,
      getReceiptsInfoService: getReceiptsInfoService,
      getReceiptsByUriService: getReceiptsByUriService,
      updateReceiptService: updateReceiptService,
      updateReceiptServiceL: updateReceiptServiceL,
      getPolicyReceipts: getPolicyReceipts,
      deleteReceipt: deleteReceipt,
      deleteReceipts: deleteReceipts,
      cancelReceiptsFrom: cancelReceiptsFrom,
      getValidReceipts: getValidReceipts,
      getFiles: getFiles,
      setReceiptID: setReceiptID,
      getReceiptID: getReceiptID,
      patchReceipt: patchReceipt,
      getDashReceipts: getDashReceipts,
      getChildrenReceipts: getChildrenReceipts,
      getCountReceipts: getCountReceipts,
    };

    return service;

    ////////////

    var receiptID = 0;

    function setReceiptID(id) {
      receiptID = id;
    }

    function getReceiptID() {
      return receiptID;
    }

    function createReceiptService(data) {
      var dfd = $q.defer();
      // //console.log(data);
      ////console.log('createReceiptService', data);
      return $http
        .post(url.IP + "recibos/", data)
        .then(createReceiptServiceComplete)
        .catch(createReceiptServiceFailed);

      function createReceiptServiceComplete(response) {
        dfd.resolve(response.data);
        return dfd.promise;
      }

      function createReceiptServiceFailed(error) {
        dfd.reject(error);
        return dfd.promise;
      }
    }

    function getPolicyReceipts(polizaUrl) {
      return $http.get(polizaUrl).then(done).catch(fail);

      function done(result) {
        return result;
      }

      function fail(error) {
        ////console.log("getPolicyReceipts Error", error);
        return error;
      }
    }

    // Receipt always had poliza (obj.poliza)
    function getNextReceipts(receipt) {
      return $http
        .get(receipt.poliza.url)
        .then(getNextReceiptsComplete)
        .catch(getNextReceiptsFailed);

      function getNextReceiptsComplete(res) {
        var deferred = $q.defer();
        var receipts = [];
        angular.forEach(res.data.recibos_poliza, function (res) {
          receipts.push($http.get(res));
          // deferred.resolve(res);
          // receipts.push(deferred.promise);
        });
        ////console.log('receipt', receipt);

        var receiptsToCancel = [];
        $q.all(receipts).then(function (results) {
          angular.forEach(results, function (res) {
            ////console.log('results', res);
            if (receipt.recibo_numero <= res.data.recibo_numero) {
              receiptsToCancel.push(res.data);
              ////console.log('add');
            }
          });
          deferred.resolve(receiptsToCancel);
        });
        return deferred.promise;
        //
        // var nextReceipts = getAllReceiptsFromCollection(res.data.recibos_poliza);
        // nextReceipts.then(function(data){
        //   ////console.log('promise', data);
        // });
        // ////console.log('nextReceipts', nextReceipts);
        // return nextReceipts;
      }

      function getNextReceiptsFailed(error) {
        return error;
      }
    }

    function getDashReceipts(order, asc) {
      var dfd = $q.defer();
      infoUser = $localStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //   var chart_receipt = 'v2/recibos/graficas-recibos/';
      var chart_receipt = "graficas-recibos/";
      var params = {
        order: order,
        asc: asc,
        tipo: "total",
      };
      return $http({
        method: "GET",
        url: url.IP + chart_receipt,
        params: params,
      })
        .then(getReceiptsServiceComplete)
        .catch(getReceiptsServiceFailed);

      function getReceiptsServiceComplete(response) {
        console.log("iiiiiiiiiii", response);
        var results = {
          data: response.data.results,
          config: {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          },
        };
        // console.log(results)

        dfd.resolve(results);
        return dfd.promise;
        // dfd.resolve(response.data.results);
        //   return dfd.promise;
      }

      function getReceiptsServiceFailed(error) {
        ////console.log('getReceiptsServiceFailed', error);
      }
    }

    function getChildrenReceipts(receipt_id) {
      var dfd = $q.defer();
      return $http
        .get(url.IP + "get-receipt-children/" + receipt_id)
        .then(getReceiptsServiceComplete)
        .catch(getReceiptsServiceFailed);

      function getReceiptsServiceComplete(response) {
        dfd.resolve(response.data);
        return dfd.promise;
      }

      function getReceiptsServiceFailed(error) {
        ////console.log('getReceiptsServiceFailed', error);
      }
    }

    function getCountReceipts() {
      var dfd = $q.defer();
      return $http
        .get(url.IP + "count-receipts/")
        .then(getReceiptsServiceComplete)
        .catch(getReceiptsServiceFailed);

      function getReceiptsServiceComplete(response) {
        dfd.resolve(response.data.results);
        return dfd.promise;
      }

      function getReceiptsServiceFailed(error) {
        ////console.log('getReceiptsServiceFailed', error);
      }
    }

    function getValidReceipts() {
      var dfd = $q.defer();
      return $http
        .get(url.IP + "v1/receipts/")
        .then(getReceiptsServiceComplete)
        .catch(getReceiptsServiceFailed);

      function getReceiptsServiceComplete(response) {
        //dfd.resolve(response.data.results);
        //return dfd.promise;
        var results = {
          data: response.data,
          config: {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          },
        };

        return results;
        //------------------------------------------------------------------------------------------ 1
        //console.log('response', response);
        if (response.data) {
          response.data.results.forEach(function (item) {
            //console.log('status', item.status);
          });

          return response.data.results;
        }
        return getReceiptsServiceFailed(response);
      }

      function getReceiptsServiceFailed(error) {
        console.log("getReceiptsServiceFailed", error);
      }
    }

    function getReceiptsService() {
      // var dfd1 = $q.defer();
      var dfd = $q.defer();
      return $http
        .get(url.IP + "recibos/")
        .then(getReceiptsServiceComplete)
        .catch(getReceiptsServiceFailed);

      function getReceiptsServiceComplete(response) {
        // //console.log('__________',response);
        dfd.resolve(response.data.results);
        return dfd.promise;
      }

      function getReceiptsServiceFailed(error) {
        dfd.reject(error);
        return dfd.promise;
        ////console.log('getReceiptsServiceFailed', error);
      }
    }

    function getReceiptsReadService() {
      var dfd = $q.defer();
      return $http
        .get(url.IP + "leer-recibos/")
        .then(getReceiptsServiceComplete)
        .catch(getReceiptsServiceFailed);

      function getReceiptsServiceComplete(response) {
        dfd.resolve(response.data.results);
        return dfd.promise;
      }

      function getReceiptsServiceFailed(error) {
        ////console.log('getReceiptsServiceFailed', error);
      }
    }

    function getReceiptsReadChildrensService() {
      var dfd = $q.defer();
      return $http
        .get(url.IP + "recibo/info/")
        .then(getReceiptsReadChildrensServiceComplete)
        .catch(getReceiptsReadChildrensServiceFailed);

      function getReceiptsReadChildrensServiceComplete(response) {
        dfd.resolve(response.data.results);
        return dfd.promise;
      }

      function getReceiptsReadChildrensServiceFailed(error) {
        ////console.log('getReceiptsReadChildrensServiceFailed', error);
      }
    }

    function getReceiptInfo(receipt) {
      var id = receipt.id ? receipt.id : receipt;

      return $http
        .get(url.IP + "recibo/info/" + id + "/")
        .then(getReceiptsInfoServiceComplete)
        .catch(getReceiptsInfoServiceFailed);

      function getReceiptsInfoServiceComplete(response) {
        // dfd.resolve(response);
        return response;
      }

      function getReceiptsInfoServiceFailed(error) {
        ////console.log('getReceiptsInfoServiceFailed', error);
      }
    }

    function getReceiptsInfoService() {
      var dfd = $q.defer();
      return $http
        .get(url.IP + "recibo/info/")
        .then(getReceiptsInfoServiceComplete)
        .catch(getReceiptsInfoServiceFailed);

      function getReceiptsInfoServiceComplete(response) {
        dfd.resolve(response.data.results);
        return dfd.promise;
      }

      function getReceiptsInfoServiceFailed(error) {
        ////console.log('getReceiptsInfoServiceFailed', error);
      }
    }

    function getReceiptService(data) {
      if (!isNaN(Number(data.polizaId))) {
        data.recibosId = url.IP + "recibos/" + data.recibosId + "/";
      } else {
        data.recibosId = data.recibosId;
      }
      return $http
        .get(data.recibosId)
        .then(getReceiptServiceComplete)
        .catch(getReceiptServiceFailed);

      function getReceiptServiceComplete(response) {
        return response.data;
      }

      function getReceiptServiceFailed(error) {
        ////console.log('Error getReceiptServiceFailed:', error);
      }
    }

    function getReceiptsByUriService(data) {
      // var dfd = $q.defer();
      return $http
        .get(data)
        .then(getReceiptsByUriServiceComplete)
        .catch(getReceiptsByUriServiceFailed);

      function getReceiptsByUriServiceComplete(res) {
        // //console.log('res',res);
        return res.data;
      }

      function getReceiptsByUriServiceFailed(error) {
        return error;
      }
    }

    function updateReceiptService(editedObj) {
      if (editedObj.poliza) {
        delete editedObj["poliza"];
      }

      if (editedObj.status == 4) {
        editedObj.pay_doc = "";
        editedObj.pay_form = 1;
        editedObj.pay_date = new Date();
      }
      return $http
        .patch(editedObj.url, editedObj)
        .then(updateReceiptServiceComplete)
        .catch(updateReceiptServiceFailed);

      function updateReceiptServiceComplete(response) {
        return response;
      }

      function updateReceiptServiceFailed(error) {
        ////console.log('Error updateReceiptServiceFailed:', error);
        return error;
      }
    }

    function updateReceiptServiceL(editedObj) {
      if (editedObj.poliza) {
        delete editedObj["poliza"];
      }

      if (editedObj.status == 4) {
        editedObj.pay_doc = null;
        editedObj.pay_form = null;
        editedObj.pay_date = null;
        editedObj.curr_rate = null;
        editedObj.bank = null;
        editedObj.liquidacion_date = null;
        editedObj.liquidacion_doc = null;
        editedObj.liquidacion_form = null;
        editedObj.liquidacion_curr_rate = null;
        editedObj.liquidacion_bank = null;
        editedObj.liquidacion_folio = null;
        editedObj.folio_pago = null;
        editedObj.status = 4;
      }
      if (editedObj.status == 1) {
        editedObj.user_pay = editedObj.user_pay ? editedObj.user_pay : null;
        editedObj.folio_pago = editedObj.folio_pago
          ? editedObj.folio_pago
          : null;
      } else {
        console.log("--quitado3963--", editedObj);
        // editedObj.user_pay = null
      }
      return $http
        .patch(editedObj.url, editedObj)
        .then(updateReceiptServiceComplete)
        .catch(updateReceiptServiceFailed);

      function updateReceiptServiceComplete(response) {
        return response;
      }

      function updateReceiptServiceFailed(error) {
        ////console.log('Error updateReceiptServiceFailed:', error);
        return error;
      }
    }

    function deleteReceipts(receipts) {
      var dfd = $q.defer();
      var res = [];
      ////console.log("delete",receipts);
      receipts.forEach(function (receipt) {
        deleteReceipt(receipt).then(function (response) {
          res.push(response.data);
          if (res.length == receipts.length) {
            dfd.resolve(res);
          }
        });
      });

      return dfd.promise;
    }

    function deleteReceipt(receiptObj) {
      return $http
        .delete(receiptObj.url)
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          ////console.log("error");
          return error;
        });
    }

    function cancelReceiptsFrom(receipt, id_poliza) {
      if (receipt.policy) {
        if (receipt.policy.url) {
          receipt.policy = receipt.policy.url;
        }
      } else {
        receipt.policy = receipt.policy;
      }

      if (receipt.receipt_type != 1 || !receipt.policy) {
        var params = {
          model: 4,
          event: "PATCH",
          associated_id: receipt.id,
          identifier: " actualizo el recibo a cancelado. ",
        };
        dataFactory.post("send-log/", params).then(function success(response) {
          console.log("-------3 cancelado-----", response);
          return response;
        });
        $http.patch(receipt.url, {
          status: 2,
          description: receipt.description
            ? receipt.description
            : "Cancelado en " + new Date().toUTCString().split("T")[0],
        });
      } else {
        // $http.get(receipt.policy)
        $http
          .get(url.IP + "polizas/" + id_poliza)
          .then(function (insuranceResponse) {
            var waitForData = [];

            var insurance = insuranceResponse.data;
            insurance.recibos_poliza.forEach(function (recibo_en_poliza) {
              $http.get(recibo_en_poliza).then(function success(response) {
                var recibo_en_poliza_info = response.data;
                if (
                  recibo_en_poliza_info.status != 1 &&
                  recibo_en_poliza_info.status != 5 &&
                  recibo_en_poliza_info.status != 6 &&
                  recibo_en_poliza_info.receipt_type != 3
                ) {
                  $http.patch(recibo_en_poliza_info.url, {
                    status: 2,
                    description: receipt.description
                      ? receipt.description
                      : "Cancelado en " +
                        new Date().toUTCString().split("T")[0],
                  });
                }

                var params = {
                  model: 4,
                  event: "PATCH",
                  associated_id: recibo_en_poliza_info.id,
                  identifier: "canceló el recibo.",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
              });
            });
            $http
              .patch(insurance.url, { status: 11 })
              .then(function success(argument) {
                if (argument.status == 200 || argument.status == 201) {
                  if (
                    insurance.document_type == 1 ||
                    insurance.document_type == "Póliza"
                  ) {
                    var params = {
                      model: 1,
                      event: "PATCH",
                      associated_id: insurance.id,
                      identifier:
                        "canceló la póliza mediante cancelación de recibo.",
                    };
                  } else if (
                    insurance.document_type == 3 ||
                    insurance.document_type == "Carátula"
                  ) {
                    var params = {
                      model: 18,
                      event: "PATCH",
                      associated_id: insurance.id,
                      identifier:
                        "canceló la colectividad mediante cancelación de recibo.",
                    };
                  } else if (
                    insurance.document_type == 7 ||
                    insurance.document_type == "Fianza"
                  ) {
                    var params = {
                      model: 13,
                      event: "PATCH",
                      associated_id: insurance.id,
                      identifier:
                        "canceló la fianza mediante cancelación de recibo.",
                    };
                  } else {
                    var params = {
                      model: 1,
                      event: "PATCH",
                      associated_id: insurance.id,
                      identifier:
                        "canceló la poliza mediante cancelación de recibo.",
                    };
                  }
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                }
              });
          });
      }
    }

    function cancelReceiptsFrom_DEPRECATED(receipt) {
      var dfd = $.Deferred();
      var canceledReceipts = [];
      var toCancel = 0;
      var canceled = 0;
      var fromDate = new Date(receipt.fecha_inicio);
      fromDate = new Date(
        fromDate.getTime() + fromDate.getTimezoneOffset() * 60000
      );

      // Cancelando poliza

      canceling();
      updateReceiptService(receipt).then(function (canceledRecepit) {
        canceledReceipts.push(canceledRecepit.data);
        if (receipt.poliza) {
          canceling();
          $http.get(receipt.poliza).then(function (insurance) {
            insurance.data.recibos_poliza.forEach(function (recibo_en_poliza) {
              canceling();
              getReceiptsByUriService(recibo_en_poliza).then(function (recibo) {
                var dateInit = moment(
                  recibo.fecha_inicio,
                  "YYYY-MM-DD"
                ).toDate();
                if (fromDate < dateInit) {
                  recibo.status = receipt.status;
                  canceling();
                  updateReceiptService(recibo).then(function (canceledRecepit) {
                    canceledReceipts.push(canceledRecepit.data);
                    isDone();
                  });
                }
                isDone();
              });
            });
            isDone();
          });
        }
        isDone();
      });

      function canceling() {
        toCancel++;
      }

      function isDone() {
        canceled++;
        if (canceled >= toCancel) {
          dfd.resolve(canceledReceipts);
        }
      }

      return dfd.promise();
    }

    function getFiles(data) {
      return fileService.getFiles(url.IP + "recibos/" + data + "/archivos/");
    }

    function patchReceipt(url, obj) {
      return $http.patch(url, obj);
    }
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */
  var app = angular.module("inspinia");

  app.controller("PolizasTableCtrl", PolizasTableCtrl);

  PolizasTableCtrl.$inject = [
    "dataFactory",
    "$localStorage",
    "appStates",
    "$state",
    "SweetAlert",
    "$sessionStorage",
    "url",
    "$scope",
    "$http",
    "ContratanteService",
    "providerService",
    "packageService",
    "insuranceService",
    "toaster",
    "$parse",
    "exportFactory",
  ];

  function PolizasTableCtrl(
    dataFactory,
    $localStorage,
    appStates,
    $state,
    SweetAlert,
    $sessionStorage,
    url,
    $scope,
    $http,
    ContratanteService,
    providerService,
    packageService,
    insuranceService,
    toaster,
    $parse,
    exportFactory
  ) {
    var vm = this;
    var filterState = {};
    $scope.infoUser = $sessionStorage.infoUser;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.orgName = usr.orgname;

    vm.pageTitle = "Pólizas";
    var conditions = [];
    $scope.options = [
      { val: 1, name: "Número de póliza" },
      { val: 2, name: "Contratante" },
      { val: 3, name: "Aseguradora" },
      { val: 4, name: "Paquete" },
      { val: 5, name: "Ramo" },
      { val: 6, name: "Subramo" },
      /*{'val': 7, 'name':'Rango de fechas (Creación)'},
                        {'val': 8, 'name':'Rango de fechas (Vigencia)'}*/
    ];
    $scope.bLine = 0;
    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.changePayment = changePayment;
    vm.changeBLine = changeBLine;
    vm.changeUntil = changeUntil;
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.matchesGroupinglevel = matchesGroupinglevel;
    vm.matchesClassification = matchesClassification;
    vm.matchesSubGroup = matchesSubGroup;
    vm.changeOrder = changeOrder;
    vm.changeOrderOT = changeOrderOT;
    vm.goToInfo = goToInfo;
    vm.addFilter = addFilter;
    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;
    vm.canConsultar = canConsultar;

    vm.changeSubgrouping = changeSubgrouping;
    vm.changeSubsubgrouping = changeSubsubgrouping;

    vm.pVigentes = true;
    vm.pCanceladas = false;
    vm.pCerradas = false;
    vm.pVencidas = false;
    vm.pActivas = false;
    vm.oPendientes = true;
    vm.oCanceladas = false;
    vm.order_type_asc = 0;
    vm.order_poliza_asc = 0;
    vm.order_contractor_asc = 1;
    vm.order_provider_asc = 0;
    vm.order_subramo_asc = 0;
    vm.order_pay_asc = 0;
    vm.order_status_asc = 0;
    vm.order_vigencia_asc = 0;
    vm.order_anti_asc = 0;

    vm.order_ot_asc = 0;
    vm.order_conot_asc = 1;
    vm.order_aseg_asc = 0;
    vm.order_package_asc = 0;
    vm.order_subot_asc = 0;
    vm.order_payot_asc = 0;
    vm.order_statot_asc = 0;
    vm.order_valot_asc = 0;
    vm.subgroup = 0;
    vm.subsubgroup = 0;
    $scope.subsubgroups = [];
    $scope.subgroups = [];
    vm.groupinglevel = 0;
    vm.subgroupinglevel = 0;
    $scope.groupinglevel = [];
    $scope.subgroupinglevel = [];
    vm.subsubgroupinglevel = 0;
    $scope.subsubgroupinglevel = [];

    $scope.ShowContextMenu = function (name, document_type, insurance) {
      $scope.name_for_new_tab = name;
      var route = "polizas.info";
      if (document_type == 1) {
        route = "polizas.info";
      } else if (document_type == 3) {
        route = "colectividades.info";
      } else if (document_type == 11) {
        route = "flotillas.info";
      } else if (document_type == 12) {
        route = "flotillas.info";
      }
      $scope.route_for_new_tab = route;
      $scope.id_for_new_tab = insurance.id;

      if (document_type == 12) {
        $scope.id_for_new_tab = insurance.caratula;
      }
    };

    $scope.open_new_tab = function () {
      var existe = false;
      appStates.states.forEach(function (state) {
        if (
          state.route == $scope.route_for_new_tab &&
          state.id == $scope.id_for_new_tab
        ) {
          existe = true;
        }
      });
      if (appStates.states.length > 3) {
        SweetAlert.swal("Error", "No se pueden abrir más pestañas.", "error");
      } else {
        if (!existe) {
          appStates.states.push({
            id: $scope.id_for_new_tab,
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab, {
              polizaId: $scope.id_for_new_tab,
            }),
          });
          $localStorage.tab_states = appStates.states;
        }
      }

      // function goToInfo(insurance) {
      //   if(insurance.document_type == 1){
      //     $state.go('polizas.info', {polizaId: insurance.id})
      //   } else if(insurance.document_type == 3){
      //     $state.go('colectividades.info', {polizaId: insurance.id})
      //   }else if (insurance.document_type == 11) {
      //     $state.go('flotillas.info',{polizaId: insurance.id})
      //   }else if (insurance.document_type == 12) {
      //     $state.go('flotillas.info',{polizaId: insurance.caratula})
      //   }
      // }

      // $state.go($scope.route_for_new_tab, {polizaId: $scope.id_for_new_tab});
    };

    $scope.subgrouping = [];
    $scope.subsubgrouping = [];
    vm.only_caratula_poliza = 0;
    vm.acceso_ver_pol = vm.acceso_ver_pol || undefined;
    vm.acceso_ver_ot = vm.acceso_ver_ot || undefined;
    $scope.infoUser = $sessionStorage.infoUser;
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        }
        if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                vm.permiso_ver_referenciador = true;
              } else {
                vm.permiso_ver_referenciador = false;
              }
            }
          });
        }
      });
    }

    function canConsultar() {
      return true;
    }
    // $(window).load(function() {
    //   $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    $scope.status = function (value) {
      switch (value) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.payment = function (value) {
      switch (value) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 4:
          return "Cuatrimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        case 24:
          return "Quincenal";
          break;
        case 7:
          return "Semanal";
          break;
        case 14:
          return "Catorcenal";
          break;
        default:
          return "No especificada";
      }
    };

    function changeOrder(par, asc) {
      switch (par) {
        case 1:
          search(par, asc);
          vm.order_type_asc = asc;
          vm.order_poliza_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          break;
        case 2:
          search(par, asc);
          vm.order_poliza_asc = asc;
          vm.order_type_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          break;
        case 3:
          search(par, asc);
          vm.order_contractor_asc = asc;
          vm.order_type_asc = 0;
          vm.order_poliza_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          break;
        case 4:
          search(par, asc);
          vm.order_provider_asc = asc;
          vm.order_type_asc = 0;
          vm.order_poliza_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          vm.order_anti_asc = 0;
          break;
        case 5:
          search(par, asc);
          vm.order_subramo_asc = asc;
          vm.order_type_asc = 0;
          vm.order_poliza_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          break;
        case 6:
          search(par, asc);
          vm.order_pay_asc = asc;
          vm.order_type_asc = 0;
          vm.order_poliza_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          break;
        case 7:
          search(par, asc);
          vm.order_status_asc = asc;
          vm.order_type_asc = 0;
          vm.order_poliza_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_vigencia_asc = 0;
          break;
        case 8:
          search(par, asc);
          vm.order_vigencia_asc = asc;
          vm.order_type_asc = 0;
          vm.order_poliza_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          break;
      }
    }

    function changeOrderOT(par, asc) {
      switch (par) {
        case 1:
          searchOT(par, asc);
          vm.order_ot_asc = asc;
          vm.order_conot_asc = 0;
          vm.order_aseg_asc = 0;
          vm.order_package_asc = 0;
          vm.order_subot_asc = 0;
          vm.order_payot_asc = 0;
          vm.order_statot_asc = 0;
          vm.order_valot_asc = 0;
          break;
        case 2:
          searchOT(par, asc);
          vm.order_conot_asc = asc;
          vm.order_ot_asc = 0;
          vm.order_aseg_asc = 0;
          vm.order_package_asc = 0;
          vm.order_subot_asc = 0;
          vm.order_payot_asc = 0;
          vm.order_statot_asc = 0;
          vm.order_valot_asc = 0;
          break;
        case 3:
          searchOT(par, asc);
          vm.order_aseg_asc = asc;
          vm.order_conot_asc = 0;
          vm.order_ot_asc = 0;
          vm.order_package_asc = 0;
          vm.order_subot_asc = 0;
          vm.order_payot_asc = 0;
          vm.order_statot_asc = 0;
          vm.order_valot_asc = 0;
          break;
        case 4:
          searchOT(par, asc);
          vm.order_package_asc = asc;
          vm.order_ot_asc = 0;
          vm.order_conot_asc = 0;
          vm.order_aseg_asc = 0;
          vm.order_subot_asc = 0;
          vm.order_payot_asc = 0;
          vm.order_statot_asc = 0;
          vm.order_valot_asc = 0;
          break;
        case 5:
          searchOT(par, asc);
          vm.order_subot_asc = asc;
          vm.order_ot_asc = 0;
          vm.order_conot_asc = 0;
          vm.order_aseg_asc = 0;
          vm.order_package_asc = 0;
          vm.order_payot_asc = 0;
          vm.order_statot_asc = 0;
          vm.order_valot_asc = 0;
          break;
        case 6:
          searchOT(par, asc);
          vm.order_payot_asc = asc;
          vm.order_ot_asc = 0;
          vm.order_conot_asc = 0;
          vm.order_aseg_asc = 0;
          vm.order_package_asc = 0;
          vm.order_subot_asc = 0;
          vm.order_statot_asc = 0;
          vm.order_valot_asc = 0;
          break;
        case 7:
          searchOT(par, asc);
          vm.order_statot_asc = asc;
          vm.order_ot_asc = 0;
          vm.order_conot_asc = 0;
          vm.order_aseg_asc = 0;
          vm.order_package_asc = 0;
          vm.order_subot_asc = 0;
          vm.order_payot_asc = 0;
          vm.order_valot_asc = 0;
          break;
        case 8:
          searchOT(par, asc);
          vm.order_valot_asc = asc;
          vm.order_ot_asc = 0;
          vm.order_conot_asc = 0;
          vm.order_aseg_asc = 0;
          vm.order_package_asc = 0;
          vm.order_subot_asc = 0;
          vm.order_payot_asc = 0;
          vm.order_statot_asc = 0;
          break;
      }
    }

    function addFilter(param) {
      if (param == 1) {
        $scope.fechasFilter = true;
        vm.form.dates = 1;
      } else {
        $scope.fechasFilter = false;
        vm.form.dates = 2;
      }
    }
    function changeSubgroup(subg) {
      if (subg) {
        vm.form.subgroup = subg;
        vm.subgroup = subg;
        $scope.subsubgroups = subg.subsubgrupos ? subg.subsubgrupos : [];
      } else {
        vm.form.subgroup = 0;
        $scope.subsubgroups = [];
      }
    }
    function changeSubsubgroup(subg) {
      vm.form.subsubgroup = subg;
      vm.subsubgroup = subg;
    }
    // Nivel de agrupación
    function changeSubgrouping(subgl) {
      if (subgl) {
        vm.form.subgrouping = subgl;
        vm.subgrouping = subgl;
        $scope.subsubgrouping = subgl.subsubgrupos ? subgl.subsubgrupos : [];
      } else {
        vm.form.subgrouping = 0;
        $scope.subsubgrouping = [];
      }
    }
    function changeSubsubgrouping(subgl) {
      vm.form.subsubgrouping = subgl;
      vm.subsubgrouping = subgl;
    }

    function goToInfo(insurance) {
      if (insurance.document_type == 1) {
        $scope.route_for_new_tab = "polizas.info";
        var name = "Información Póliza";
        var route = "polizas.info";
      } else if (insurance.document_type == 3) {
        $scope.route_for_new_tab = "colectividades.info";
        var name = "Información Colectividad";
        var route = "colectividades.info";
      } else if (insurance.document_type == 11) {
        $scope.route_for_new_tab = "flotillas.info";
        var name = "Información Flotilla";
        var route = "flotillas.info";
      } else if (insurance.document_type == 12) {
        $scope.route_for_new_tab = "flotillas.info";
        var name = "Información Flotilla";
        var route = "flotillas.info";
      }
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      // var index_tab = appStates.states.findIndex(function(state){return state.active === true});
      if (insurance.document_type == 1) {
        // appStates.states[index_tab] = {
        //   id: insurance.id,
        //   name: 'Info póliza '+ insurance.poliza_number,
        //   heading: 'Info póliza '+ insurance.poliza_number,
        //   route: 'polizas.info',
        //   active: appStates.states[index_tab].active,
        //   isVisible: appStates.states[index_tab].isVisible,
        //   href: $state.href('polizas.info', {polizaId: insurance.id})
        // }
        // $localStorage.tab_states = appStates.states;
        $state.go("polizas.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 3) {
        $state.go("colectividades.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 11) {
        $state.go("flotillas.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 12) {
        $state.go("flotillas.info", { polizaId: insurance.caratula });
      }
    }

    $scope.valueRadio = function (val) {
      if (val == "true") {
        vm.form.inicio_fin = true;
      } else {
        vm.form.inicio_fin = false;
      }
    };
    vm.businesLine = [
      {
        id: 1,
        name: "Comercial",
      },
      {
        id: 2,
        name: "Personal",
      },
      {
        id: 3,
        name: "Otro",
      },
    ];

    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: { val: "", value: 0 },
      group: { val: "", value: 0 },
      num_poliza: "",
      inicio_fin: true,
      dates: 2,
      subgroup: { val: "", value: 0 },
      subsubgroup: { val: "", value: 0 },
      groupinglevel: { val: "", value: 0 },
      subgrouping: { val: "", value: 0 },
      classification: { val: "", value: 0 },
      subsubgrouping: { val: "", value: 0 },
      businessLine: 0,
      celula: 0,
      only_caratula: 0,
      providers: [],
      ramos: [],
      subramos: [],
    };

    vm.word = "";
    $scope.pageSelected = 0;

    // $scope.selectProv(vm.form.providers);
    // $scope.selectRamos(vm.form.providers);
    // $scope.selectSubramos(vm.form.providers);
    $scope.incio_fin = vm.form.inicio_fin;
    vm.payment = [
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 7,
        name: "Semanal",
      },
      {
        id: 12,
        name: "Anual",
      },
      {
        id: 14,
        name: "Catorcenal",
      },
    ];
    if ($scope.orgName == "ancora") {
      vm.status = [
        {
          id: 1,
          name: "En trámite",
        },
        {
          id: 2,
          name: "OT Cancelada",
        },
        {
          id: 4,
          name: "Precancelada",
        },
        {
          id: 10,
          name: "Por iniciar",
        },
        {
          id: 11,
          name: "Cancelada",
        },
        {
          id: 12,
          name: "Renovada",
        },
        {
          id: 13,
          name: "Vencida - En Proceso de Renovación",
        },
        {
          id: 14,
          name: "Vigente",
        },
        {
          id: 15,
          name: "No renovada",
        },
      ];
    } else {
      vm.status = [
        {
          id: 1,
          name: "En trámite",
        },
        {
          id: 2,
          name: "OT Cancelada",
        },
        {
          id: 4,
          name: "Precancelada",
        },
        {
          id: 10,
          name: "Por iniciar",
        },
        {
          id: 11,
          name: "Cancelada",
        },
        {
          id: 12,
          name: "Renovada",
        },
        {
          id: 13,
          name: "Vencida",
        },
        {
          id: 14,
          name: "Vigente",
        },
        {
          id: 15,
          name: "No renovada",
        },
      ];
    }

    //---------------------------------------------------------------------------------------------------
    getProviders();
    getRamos();
    getSubramos();
    getCelulasContractor();
    vm.activate = activate;
    vm.showBinnacle = showBinnacle;
    vm.returnToReceipts = returnToReceipts;
    vm.saveLocalstorage = saveLocalstorage;
    function currentOrder() {
      return typeof filterState.order !== "undefined" ? filterState.order : 1;
    }

    function currentAsc() {
      return typeof filterState.asc !== "undefined" ? filterState.asc : 1;
    }

    function persistFilterState(overrides) {
      filterState = angular.extend({}, filterState, overrides || {});
      filterState.form = angular.copy(vm.form);
      filterState.word = angular.copy(vm.word);
      filterState.incio_fin = $scope.incio_fin;
      filterState.bLine = $scope.bLine;
    }
    activate();
    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      getSubramos();
      getProviders();
      getGroupingLevel();
      getCelulasContractor();
      $scope.busqueda = true;
      $scope.from_activate = true;
      vm.show_results = false;
      vm.buttonReport = false;
      // checar si se llaman solo estos o para todas las categorias
      // $scope.getPolicies(1);
      // $scope.getPolicies(6);
      // getInsurancesAndOT();
    }
    function saveLocalstorage() {
      persistFilterState();
    }
    function getGroupingLevel() {
      $http.get(url.IP + "groupinglevel/").then(function (groupinglevel) {
        $scope.groupinglevel = groupinglevel.data.results;
      });
    }
    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0].ramo_code;
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      console.log(sel);

      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        if (sr.subramo_code) var code = sr.subramo_code;
        else var code = sr.id;
        vm.subramos_selected.push(code);
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };
    function getRamos() {
      vm.ramos_toselected = [
        {
          ramo_code: 1,
          ramo_name: "Vida",
        },
        {
          ramo_code: 2,
          ramo_name: "Accidentes y Enfermedades",
        },
        {
          ramo_code: 3,
          ramo_name: "Daños",
        },
      ];
    }

    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          subramo_code: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }
    vm.getCaratulas = getCaratulas;
    function getCaratulas(parId) {
      var results = [];
      var mapeo_caratulas = [];
      if (parId) {
        if (parId.val.length >= 3) {
          $scope.show_cds = "get-all-caratulas/";
          $http({
            method: "POST",
            url: url.IP + $scope.show_cds,
            data: {
              word: parId.val,
            },
          })
            .then(
              function success(request) {
                var results = [];
                var mapeo_caratulas = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    vm.only_caratula_poliza = 0;
                    $scope.autocompleteData = [];
                    vm.word.id = 0;
                    toaster.warning("Carátula no encontrada");
                  } else {
                    request.data.forEach(function (poliza) {
                      vm.policy = poliza;
                      if (poliza.document_type == 11) {
                        mapeo_caratulas.push(poliza);
                      }
                    });
                    results = _.map(mapeo_caratulas, function (item) {
                      if (item.juridical) {
                        var label =
                          item.poliza_number +
                          " - " +
                          item.juridical.j_name +
                          " - " +
                          " - " +
                          convertDate(vm.policy.start_of_validity) +
                          " - " +
                          convertDate(vm.policy.end_of_validity);
                      } else if (item.natural) {
                        var label =
                          item.poliza_number +
                          " - " +
                          item.natural.full_name +
                          " - " +
                          convertDate(vm.policy.start_of_validity) +
                          " - " +
                          convertDate(vm.policy.end_of_validity);
                      } else {
                        var label = item.poliza_number;
                      }
                      return {
                        label: label,
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                      };
                    });
                    $scope.autocompleteData = results;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        } else {
          vm.only_caratula_poliza = 0;
          $scope.autocompleteData = [];
          vm.word.id = 0;
        }
      }
    }
    vm.getCarSelected = getCarSelected;
    function getCarSelected(caratula) {
      vm.only_caratula_poliza = caratula.id;
      persistFilterState();
    }
    $scope.$watch("vm.word", function (newValue, oldValue) {
      if (vm.word) {
        if (vm.word.id) {
          vm.only_caratula_poliza = parseInt(vm.word.id);
        } else {
          vm.only_caratula_poliza = 0;
        }
      }
    });
    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal(
          "Error",
          "La fecha final no puede ser menor que la inicial",
          "error"
        );
        var newdate = convertDate(new Date());
        vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function returnToReceipts(param) {
      if (param) {
        vm.show_binnacle_ot = false;
      } else {
        vm.show_binnacle = false;
      }
    }

    function showBinnacle(param) {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 1,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      if (param.status == 1) {
        vm.show_binnacle_ot = true;
        vm.policy_id_ot = param.id;
      } else {
        vm.show_binnacle = true;
        vm.policy_id = param.id;
      }
    }
    vm.show_pag_search_ot = false;
    vm.search = search;
    vm.searchOT = searchOT;

    function search(order, asc, parPage) {
      if (vm.form.subgroup) {
        if (vm.form.subgroup.id) {
          var g1 = vm.form.subgroup.id;
        } else {
          var g1 = 0;
        }
      }
      if (vm.form.subsubgroup) {
        if (vm.form.subsubgroup.id) {
          var g2 = vm.form.subsubgroup.id;
        } else {
          var g2 = 0;
        }
      } else {
        var g2 = 0;
      }
      if (vm.form.groupinglevel) {
        if (vm.form.groupinglevel.val) {
          var gl = vm.form.groupinglevel.value;
        } else {
          var gl = 0;
        }
      } else {
        var gl = 0;
      }
      if (vm.form.subgrouping) {
        if (vm.form.subgrouping.id) {
          var gl1 = vm.form.subgrouping.id;
        } else {
          var gl1 = 0;
        }
      } else {
        var gl1 = 0;
      }
      if (vm.form.subsubgrouping) {
        if (vm.form.subsubgrouping.id) {
          var gl2 = vm.form.subsubgrouping.id;
        } else {
          var gl2 = 0;
        }
      } else {
        var gl2 = 0;
      }
      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }

      vm.search_config = [];
      vm.search_results = [];
      $scope.order = order;
      $scope.asc = asc;
      vm.buttonReport = true;
      $scope.busqueda = true;
      $scope.from_activate = false;
      var ramos_to_search = [];
      var subramos_to_search = [];
      vm.form.ramos.forEach(function (ramo) {
        ramos_to_search.push(ramo["ramo_code"]);
      });
      vm.form.subramos.forEach(function (subramo) {
        subramos_to_search.push(subramo["subramo_code"]);
      });

      var params = {};
      params = {
        provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider,
        ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
        subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
        businessLine: $scope.bLine ? $scope.bLine.id : 0,
        status: vm.form.status.id ? vm.form.status.id : vm.form.status,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        classification: vm.form.classification.value
          ? vm.form.classification.value
          : vm.form.classification,
        grupo: vm.form.group && vm.form.group.value ? vm.form.group.value : 0,
        subgrupo: g1 ? g1 : 0,
        subsubgrupo: g2 ? g2 : 0,
        groupinglevel: gl ? gl : 0,
        subgrupinglevel: gl1 ? gl1 : 0,
        subsubgrupinglevel: gl2 ? gl2 : 0,
        type_contractor: vm.form.contratante.type
          ? vm.form.contratante.type
          : 0,
        poliza: vm.form.num_poliza ? vm.form.num_poliza : 0,
        // internal: vm.form.internal_number ? vm.form.internal_number : 0,
        inicio_fin: vm.form.inicio_fin,
        order: order,
        asc: asc,
        page: parPage ? parPage : 1,
        dates: vm.form.dates,
        ramos: ramos_to_search,
        subramos: subramos_to_search,
        providers: vm.providers_selected ? vm.providers_selected : 0,
        celula: cel ? cel : 0,
        only_caratula: vm.only_caratula_poliza ? vm.only_caratula_poliza : 0,
      };
      persistFilterState({
        page: parPage ? parPage : 1,
        order: order,
        asc: asc,
      });

      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      if (
        vm.form.contratante.val == "" ||
        vm.form.contratante.val == null ||
        vm.form.contratante == undefined
      ) {
        params.contratante = 0;
      }
      if (
        vm.form.classification.val == "" ||
        vm.form.classification.val == null ||
        vm.form.classification == undefined
      ) {
        params.classification = 0;
      }
      // if(vm.form.group.val == "" || vm.form.group.val == null || vm.form.group == undefined){
      //   params.grupo = 0;
      // }
      // if(vm.form.classification.val == "" || vm.form.classification.val == null || vm.form.classification == undefined){
      //   params.classification = 0;
      // }
      // if($scope.subgroups.length == 0 || vm.form.subgroup.val == "" || vm.form.subgroup.val == null || vm.form.subgroup == undefined){
      //   params.subgrupo = 0;
      // }
      // if($scope.subsubgroups.length == 0 || vm.form.subsubgroup.val == "" || vm.form.subsubgroup.val == null || vm.form.subsubgroup == undefined){
      //   params.subsubgrupo = 0;
      // }
      if (
        vm.form.classification.val == "" ||
        vm.form.classification.val == null ||
        vm.form.classification == undefined
      ) {
        params.classification = 0;
      }
      $scope.filtros = params;
      var url_fpu = "filtros-polizas/";
      if (vm.acceso_ver_pol) {
        $http({
          method: "POST",
          url: url.IP + url_fpu,
          data: $scope.filtros,
        })
          .then(
            function success(request) {
              if (
                (request.status === 200 || request.status === 201) &&
                request.data.results.length
              ) {
                vm.show_results = true;
                vm.show_policy = false;
                var data = request.data.results;
                data.forEach(function (value) {
                  if (value.old_policies) {
                    value.old_policies.forEach(function (old) {
                      if (old) {
                        if (value.id == old.base_policy.id) {
                          if (value.renewed) {
                            value.historic = " Renovada";
                          } else {
                            value.historic = " por renovar";
                          }
                        } else if (value.id == old.new_policy.id) {
                          value.historic = "de Renovación";
                        } else {
                          value.historic = " nueva";
                        }
                      } else {
                        value.historic = " nueva";
                      }
                    });
                    if (value.historic) {
                    } else {
                      value.historic = " nueva";
                    }
                  }
                  // $http({
                  //   method: 'GET',
                  //   url: url.IP + 'historic-policies/',
                  //   params: {
                  //     actual_id: value.id
                  //   }
                  // }).then(function success(response) {
                  //   if(response.data.results.length){
                  //     response.data.results.forEach(function function_name(old) {
                  //       if(old.base_policy){
                  //         if(value.id == old.new_policy.id){
                  //           if (old.new_policy) {
                  //             value.historic ='de Renovación';
                  //           }
                  //         } else {
                  //             value.historic = ' nueva'
                  //         }
                  //       }else{
                  //         value = ''
                  //       }
                  //     })
                  //   }else{
                  //     value.historic = ' nueva'
                  //   }
                  // })
                });
                data.forEach(function (item) {
                  if (item.status == 1 || item.status == 2) {
                    vm.search_results = 0;
                    vm.show_pag_search = false;
                  } else {
                    vm.search_results.push(item);
                    $scope.search_results = {
                      count: request.data.count,
                      previous: url.IP + url_fpu,
                      next: url.IP + url_fpu,
                    };
                    // testPagination('vm.search_results', 'search_results');
                    $scope.obtenerPaginacion(
                      request.data,
                      parPage ? parPage : 1
                    );
                    vm.show_pag_search = true;
                  }
                });
              } else {
                toaster.warning("No se encontraron registros");
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    }

    function searchOT(par, asc, parPage) {
      if (vm.acceso_ver_ot) {
        $scope.filtros.order = par;
        $scope.filtros.asc = asc;
        $scope.filtros.page = parPage ? parPage : 1;
        $scope.order = par;
        $scope.asc = asc;
        persistFilterState({
          page: parPage ? parPage : 1,
          order: par,
          asc: asc,
        });
        // **************Filtros OTS
        vm.ot_results = [];
        if (vm.search_results == 0) {
          vm.show_pag_search = false;
        }
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   var url_fpu = 'v2/polizas/filtros-polizas-ot/';
        var url_fpu = "filtros-polizas-ot/";
        $http({
          // method: 'GET',
          // url: url.IP + url_fpu,
          // params: $scope.filtros
          method: "POST",
          url: url.IP + url_fpu,
          data: $scope.filtros,
        })
          .then(
            function success(request) {
              vm.ot_config = {};
              vm.ot_results = [];

              if (request.status === 200 || request.status === 201) {
                vm.show_results = true;
                vm.show_policy = false;
                // vm.show_pag_search_ot = false;
                var data = request.data.results;
                vm.ot_results = request.data.results;
                vm.ot_results.forEach(function (value) {
                  if (value.old_policies) {
                    value.old_policies.forEach(function (old) {
                      if (old) {
                        if (value.id == old.base_policy.id) {
                          if (value.renewed) {
                            value.historic = " Renovada";
                          } else {
                            value.historic = " por renovar";
                          }
                        } else if (value.id == old.new_policy.id) {
                          value.historic = "de Renovación";
                        } else {
                          value.historic = " nueva";
                        }
                      } else {
                        value.historic = " nueva";
                      }
                    });
                    if (value.historic) {
                    } else {
                      value.historic = " nueva";
                    }
                  }
                });
                // vm.ot_config = {
                //   count: request.data.count,
                //   previous: request.data.previous,
                //   next: request.data.next
                // };
                vm.ot_results = request.data.results;
                $scope.ot_results = {
                  count: request.data.count,
                  previous: url.IP + url_fpu,
                  next: url.IP + url_fpu,
                };
                // testPaginationSearch('ot_results', 'ot_results');
                $scope.obtenerPaginacionOT(request.data, parPage ? parPage : 1);
                vm.show_pag_search_ot = true;
                // testPaginationSearch('vm.ot_results', 'vm.ot_config');
              } else {
                toaster.warning("No se encontraron registros");
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    }
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (pagesdata, pagina) {
      $scope.paginacion = {
        count: pagesdata["count"],
        previous: pagesdata["previous"],
        next: pagesdata["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      var order = currentOrder();
      var asc = currentAsc();
      persistFilterState({ page: pagina, order: order, asc: asc });
      vm.search(order, asc, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        var order = currentOrder();
        var asc = currentAsc();
        var pagina = $scope.paginacion["paginaActual"] - 1;
        persistFilterState({ page: pagina, order: order, asc: asc });
        vm.search(order, asc, pagina);
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        var order = currentOrder();
        var asc = currentAsc();
        var pagina = $scope.paginacion["paginaActual"] + 1;
        persistFilterState({ page: pagina, order: order, asc: asc });
        vm.search(order, asc, pagina);
      }
    };
    $scope.obtenerPaginacionOT = function (pagesdata, pagina) {
      $scope.paginacionOT = {
        count: pagesdata["count"],
        previous: pagesdata["previous"],
        next: pagesdata["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacionOT["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacionOT["totalPaginas"].length <= 5) {
          $scope.paginacionOT["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacionOT["totalPaginas"].length > 5) {
        $scope.paginacionOT["paginaInicio"] =
          $scope.paginacionOT["totalPaginas"] - 5;
      } else {
        $scope.paginacionOT["paginaInicio"] = 1;
      }
      if ($scope.paginacionOT["totalPaginas"].length > 5) {
        $scope.paginacionOT["paginaFin"] = 5;
      } else {
        $scope.paginacionOT["paginaFin"] =
          $scope.paginacionOT["totalPaginas"].length;
      }
    };

    $scope.selecionPaginaOT = function (pagina) {
      var order = currentOrder();
      var asc = currentAsc();
      persistFilterState({ page: pagina, order: order, asc: asc });
      vm.searchOT(order, asc, pagina);
    };

    $scope.anteriorPaginaOT = function () {
      if ($scope.paginacionOT["paginaActual"] > 1) {
        var order = currentOrder();
        var asc = currentAsc();
        var pagina = $scope.paginacionOT["paginaActual"] - 1;
        persistFilterState({ page: pagina, order: order, asc: asc });
        vm.searchOT(order, asc, pagina);
      }
    };

    $scope.siguientePaginaOT = function () {
      var numeroPaginas = Math.ceil($scope.paginacionOT["count"] / 10);
      if (numeroPaginas > $scope.paginacionOT["paginaActual"]) {
        var order = currentOrder();
        var asc = currentAsc();
        var pagina = $scope.paginacionOT["paginaActual"] + 1;
        persistFilterState({ page: pagina, order: order, asc: asc });
        vm.searchOT(order, asc, pagina);
      }
    };
    $scope.exportData = function (aseguradoras) {
      if (aseguradoras == "Polizas") {
        var header =
          '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
        var blob = new Blob(
          [header + document.getElementById("policy_exportable").innerHTML],
          {
            type: "data:application/vnd.ms-excel;charset=UTF-8",
          }
        );
      } else {
        var header =
          '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
        var blob = new Blob(
          [header + document.getElementById("exportable").innerHTML],
          {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          }
        );
      }
      saveAs(blob, "Reporte_" + aseguradoras + ".xls");
    };

    $scope.exportDataFilter = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var data = $scope.filtros;
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //     // var url_rep = 'v2/generics/reporte-policy/';
      //     // var url_rep_ot = 'v2/generics/reporte-policy-ot/';
      //     var url_rep = 'service_reporte-v2-poliza-excel';
      //     var url_rep_ot = 'service_reporte-v2-poliza-excel_ot';
      var url_rep = "service_reporte-poliza-excel";
      var url_rep_ot = "service_reporte-poliza-excel_ot";
      if (param == 1) {
        // $http({
        // method: 'GET',
        // url: url.IP +'reporte-policy/',
        // params: $scope.filtros
        //   method: 'POST',
        //   url: url.IP + 'reporte-policy/',
        //   data: $scope.filtros
        // })
        // .then(function (request) {
        //   if(request.status === 200) {
        //       exportFactory.excel(request.data, 'Pólizas');
        //   }

        // })
        // .catch(function (e) {
        //   console.log('e', e);
        // });
        $http({
          method: "POST",
          url: url.IP + url_rep, //'reporte-policy/',
          data: $scope.filtros,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
          .then(function success(request) {
            if (request.status === 200) {
              var blob = new Blob([request.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Polizas_Módulo.xls");
            }
            l.stop();
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      }
      if (param == 2) {
        // $http({
        //       method: 'POST',
        //       url: url.IP + 'reporte-policy-ot/',
        //       data: $scope.filtros
        //       })
        //       .then(function (request) {
        //         if(request.status === 200) {
        //           exportFactory.excel(request.data, 'Pólizas_OT');
        //         }

        //       })
        //       .catch(function (e) {
        //         console.log('e', e);
        //       });
        $http({
          method: "POST",
          url: url.IP + url_rep_ot, //'reporte-policy-ot/'
          data: $scope.filtros,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
          .then(function success(request) {
            if (request.status === 200) {
              var blob = new Blob([request.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_PolizasOT_Módulo.xls");
            }
            l.stop();
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      }
    };
    //----------------------------------------------------------------------------------------------

    function getInsurancesAndOT() {
      vm.search_results = [];
      vm.vm.show_results = false;
      vm.ot = [];
      vm.policy = [];
      insuranceService.getPolicies().then(function (policies) {
        vm.ot = policies.ots;
        var url = null;
        var data = [];
        vm.policy = policies.policies;
      });
    }

    vm.show_policies = false;
    $scope.getPolicies = function (param) {
      vm.search_results = [];
      $scope.busqueda = true;
      vm.show_results = false;
      vm.show_policies = true;
      vm.show_policy = true;
      $http({
        method: "GET",
        url: url.IP + "polizas-custom/",
        params: {
          status: param,
        },
      })
        .then(
          function success(request) {
            if (param < 6) {
              vm.policy = [];
              vm.policy_config = {};
              request.data.results.forEach(function (item) {
                vm.policy.push(item);
              });
              vm.policy_config = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              vm.show_pag_policy = true;

              $scope.testPaginationPolicy("vm.policy", "vm.policy_config");
            } else {
              vm.ot = [];
              request.data.results.forEach(function (item) {
                vm.ot.push(item);
              });
              vm.ot_config = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              vm.show_pag_ot = true;
              $scope.testPaginationOT("vm.ot", "vm.ot_config");
            }
          },
          function error(error) {
            console.log("error", error);
          }
        )
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.testPaginationOT = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages_ot = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page_ot = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages_ot.push(i + 1);
      }

      $scope.lastPageOT = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages_ot.length > 5) {
          $scope.end = $scope.totalPages_ot.length;
          $scope.start = $scope.totalPages_ot.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages_ot.length);

        $scope.actual_page_ot = $scope.totalPages_ot.length;
      };

      $scope.selectPageOT = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;

            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&status=") !== -1) {
              var status = prev_.substring(prev_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }

        // url += '&status=1'
        getData(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };
      $scope.previousBlockPagesOT = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page_ot) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages_ot.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesOT = function (param) {
        $scope.show_prev_block_ot = true;

        if (param) {
          if ($scope.end > $scope.actual_page_ot) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages_ot.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages_ot.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getData(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    $scope.testPaginationPolicy = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages_policy = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages_policy.push(i + 1);
      }

      $scope.lastPagePolicy = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages_policy.length > 5) {
          $scope.end = $scope.totalPages_policy.length;
          $scope.start = $scope.totalPages_policy.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages_policy.length);

        $scope.actual_page = $scope.totalPages_policy.length;
      };

      $scope.selectPagePolicy = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;
          } else {
            var prev_ = config_.previous;
            if (config_.previous.search("&status=") !== -1) {
              var status = config_.previous.substring(
                config_.previous.indexOf("&status=") + 1
              );
            } else {
              var status = "";
            }

            if (config_.previous.search("&page=") !== -1) {
              var url = config_.previous.substring(
                0,
                config_.previous.indexOf("&page=") + 6
              );
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
          }
        }

        // url += '&status=1'
        getData(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages_policy.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPagesPolicy = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages_policy.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesPolicy = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages_policy.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages_policy.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getData(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPagesP = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesP.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesP.length > 5) {
          $scope.end = $scope.totalPagesP.length;
          $scope.start = $scope.totalPagesP.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPageP($scope.totalPagesP.length);
        // $scope.actual_page = $scope.totalPagesP.length;
        // $scope.page = $scope.totalPagesP.length;
      };

      $scope.selectPageP = function (parPage) {
        $scope.actual_page = parPage;

        vm.search($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPagesP = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesP.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesP = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesP.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesP.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
    // -----------PAGINACIÓN
    function testPaginationSearch(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        vm.searchOT($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        vm.providers = data.data;
      });
    }

    // Groupinhdssa
    function matchesGroupinglevel(parWord, parType) {
      $scope.subgrouping = [];
      $scope.subsubgrouping = [];
      $scope.groupunglevels_data = 0;
      vm.form.subgrouping = 0;
      vm.form.subsubgrouping = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.groupinglevel.val) {
        var word_data = vm.form.groupinglevel.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_grouping = "groupinglevel-match/";

          $http
            .post(url.IP + $scope.show_grouping, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groupinglevels = response.data ? response.data : [];
                groupinglevels.forEach(function (item) {
                  $scope.subsubgrouping = [];
                  $scope.subgrouping.forEach(function (itm) {
                    $scope.subsubgrouping = itm.subsubgrupos;
                  });
                  var obj = {
                    label: item.description,
                    value: item.id,
                    url: item.url,
                    subgrupos: item.subgrupos,
                  };
                  source.push(obj);
                });

                $scope.groupinglevels_data = source;
              }
            });
        }
      }
    }
    // --GroupingLevel
    // classification
    function matchesClassification(parWord, parType) {
      $scope.classification_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.classification.val) {
        var word_data = vm.form.classification.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_claass = "classification-match/";

          $http
            .post(url.IP + $scope.show_claass, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var classifica = response.data;
                classifica.forEach(function (item) {
                  var obj = {
                    label: item.classification_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.classification_data = source;
              }
            });
        }
      }
    }
    // --classification

    function matchesGroup(parWord, parType) {
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group.val) {
        var word_data = vm.form.group.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //     $scope.show_group = 'v2/contratantes/grupos-match/';
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  $scope.subgroups = item.subgrupos;
                  $scope.subsubgroups = [];
                  $scope.subgroups.forEach(function (itm) {
                    $scope.subsubgroups = itm.subsubgrupos;
                  });
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });

                $scope.groups_data = source;
              }
            });
        }
      }
    }

    function matchesSubGroup(parWord, parType) {
      $scope.subgroups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.subgroup.val) {
        var word_data = vm.form.subgroup.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_subgroup = "subgrupos-match/";
          $http
            .post(url.IP + $scope.show_subgroup, {
              matchWord: parWord,
              parent: vm.form.group.value,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var subgroups = response.data;
                subgroups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.subgroups_data = source;
              }
            });
        }
      }
    }

    $scope.$watch("vm.form.group.value", function (newValue, oldValue) {
      if (vm.form.group) {
        if (vm.form.group.value) {
          $http
            .get(url.IP + "grupos/" + vm.form.group.value)
            .then(function (item) {
              vm.form.group.data = item.data;

              $scope.subgroups = item.data.subgrupos;
              $scope.subgroups.forEach(function (itm) {
                $scope.subsubgroups = itm.subsubgrupos;
              });
            });
        }
      }
    });

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      }
      $http.get(url.IP + "ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.ramos = ramos.data;
      });
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      }
      try {
        vm.subramos = obj.subramo_ramo;
      } catch (e) {}
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }
    function changeBLine(obj) {
      console.log(obj);
      $scope.bLine = obj;
      if (obj) {
        vm.form.businesLine = obj;
      } else {
        vm.form.businesLine = 0;
      }
    }
    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    $(".datepicker-me input").datepicker();
    $(".js-example-basic-multiple").select2();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").factory("insuranceService", insuranceService);

  insuranceService.$inject = [
    "SweetAlert",
    "datesFactory",
    "dataFactory",
    "formService",
    "coverageService",
    "fileService",
    "ContratanteService",
    "packageService",
    "ramoService",
    "providerService",
    "payform",
    "receiptService",
    "url",
    "$q",
    "$http",
    "globalVar",
    "helpers",
    "$localStorage",
    "generalService",
    "$sessionStorage",
  ];

  function insuranceService(
    SweetAlert,
    datesFactory,
    dataFactory,
    formService,
    coverageService,
    fileService,
    ContratanteService,
    packageService,
    ramoService,
    providerService,
    payform,
    receiptService,
    url,
    $q,
    $http,
    globalVar,
    helpers,
    $localStorage,
    generalService,
    $sessionStorage
  ) {
    /* Informaci�n de usuario */
    var infoUser = $localStorage.infoUser;

    var files = [];
    var service = {
      applyEndorsement: applyEndorsement,
      getInsurances_by_ramo: getInsurances_by_ramo,
      getInsurances_siniester: getInsurances_siniester,
      createInsurance: createInsurance,
      createInsuranceReno: createInsuranceReno,
      createInsuranceNoRenovacion: createInsuranceNoRenovacion,
      createForms: createForms,
      createOldPolicy: createOldPolicy,
      getInsurances: getInsurances,
      getInsurance: getInsurance,
      getInsuranceRead: getInsuranceRead,
      getInsuranceByNumber: getInsuranceByNumber,
      getInsuranceByNumberURL: getInsuranceByNumberURL,
      getInsuranceData: getInsuranceData,
      getPolicies: getPolicies,
      deleteOT: deleteOT,
      getOTsResume: getOTsResume,
      getVendors: getVendors,
      // getOts: getOts,
      getFiles: getFiles,
      getandReadInsurances: getandReadInsurances,
      getPolicyAndEndorsement: getPolicyAndEndorsement,
      updateInsurance: updateInsurance,
      updateStatus: updateStatus,
      updateFullInsurance: updateFullInsurance,
      updateFullOT: updateFullOT,
      deleteInsurance: deleteInsurance,
      applyBackupEndorsement: applyBackupEndorsement,
      // updateFullBackupInsurance:updateFullBackupInsurance,
      getRequestBackupData: getRequestBackupData,
      getInsuranceDataBackup: getInsuranceDataBackup,
      getInsurancesForEndorsements: getInsurancesForEndorsements,
      getPDFInsurance: getPDFInsurance,
      getInsurancesForDash: getInsurancesForDash,
      getInsuranceResumeWithCoverages: getInsuranceResumeWithCoverages,
      getContractorPersonalInfo: getContractorPersonalInfo,
      getPoliciesForRenovation: getPoliciesForRenovation,
      copyInsuranceData: copyInsuranceData,
      updateOldPolicy: updateOldPolicy,
    };

    return service;

    ////////////
    function getVendors() {
      return $http.get(url.IP + "get-vendors");
    }

    function createOldPolicy(data) {
      return $http.post(url.IP + "v1/polizas/viejas/", data);
    }

    function updateStatus(data, status) {
      return $http.patch(data.url, { status: status });
    }

    function createInsurance(data) {
      delete data.contratante;
      if (data.vendor) {
        if (data.vendor.url) {
          data.vendor = data.vendor.url;
        }
      }
      if (data.poliza_number == "0") {
        delete data.poliza_number;
      }
      if (data.f_currency) {
        if (data.f_currency.f_currency_selected) {
          data.f_currency = data.f_currency.f_currency_selected;
        }
      }
      return $http
        .post(url.IP + "polizas/", data)
        .then(createInsuranceComplete)
        .catch(createInsuranceFailed);

      function createInsuranceComplete(response) {
        if (response.status === 400) {
          return createInsuranceFailed(response);
        }
        response.data.estatus = 200;
        return response.data;
      }

      function createInsuranceFailed(error) {
        error.estatus = error.status;
        return error;
      }
    }
    function createInsuranceNoRenovacion(data) {
      delete data.contratante;
      if (data.vendor) {
        if (data.vendor.url) {
          data.vendor = data.vendor.url;
        }
      }
      if (data.poliza_number == "0") {
        delete data.poliza_number;
      }
      if (data.f_currency) {
        if (data.f_currency.f_currency_selected) {
          data.f_currency = data.f_currency.f_currency_selected;
        }
      }
      return $http
        .post(url.IP + "renovation/", data)
        .then(createInsuranceCompleteNr)
        .catch(createInsuranceFailedNr);

      function createInsuranceCompleteNr(response) {
        if (response.status === 400) {
          return createInsuranceFailedNr(response);
        }
        response.data.estatus = 200;
        return response.data;
      }

      function createInsuranceFailedNr(error) {
        error.estatus = error.status;
        return error;
      }
    }
    function createInsuranceReno(data) {
      delete data.contratante;
      if (data.vendor) {
        if (data.vendor.url) {
          data.vendor = data.vendor.url;
        }
      }
      if (data.poliza_number == "0") {
        delete data.poliza_number;
      }
      if (data.f_currency) {
        if (data.f_currency.f_currency_selected) {
          data.f_currency = data.f_currency.f_currency_selected;
        }
      }
      data["domiciliada"] = data.domiciliado;
      return $http
        .post(url.IP + "renovation/", data)
        .then(createInsuranceComplete)
        .catch(createInsuranceFailed);

      function createInsuranceComplete(response) {
        if (response.status === 400) {
          return createInsuranceFailed(response);
        }
        return response.data;
      }

      function createInsuranceFailed(error) {
        return error;
      }
    }

    function copyInsuranceData(newp, oldp, desc) {
      if (desc == "CAMBIO DE FORMA DE PAGO") {
        var data = {
          newp: newp,
          oldp: oldp,
          cambio: 2,
        };
      } else {
        var data = {
          newp: newp,
          oldp: oldp,
          cambio: 1,
        };
      }

      dataFactory.post("copy-data/", data).then(function success(response) {
        var params = {
          model: 1,
          event: "POST",
          associated_id: newp,
          identifier: "registro el endoso con concepto " + desc,
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});
        return response.data;
      });
    }

    function createForms(data) {
      return $http
        .post(url.IP + "respuesta-formulario/", data)
        .then(createFormsComplete)
        .catch(createFormsFailed);

      function createFormsComplete(response) {
        return response.data;
      }

      function createFormsFailed(error) {}
    }

    function getInsurances_by_ramo(ramo_id, word) {
      var params = {
        pk: ramo_id,
        word: word,
      };
      infoUser = $localStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //   var filter_person = 'v2/siniestros/policies-by-ramo/';
      var filter_person = "policies-by-ramo/";
      return $http({
        method: "GET",
        url: url.IP + filter_person,
        params: params,
      })
        .then(getInsurancesComplete)
        .catch(getInsurancesFailed);
      // .get(url.IP + 'policies-by-ramo/' + ramo_id + '/' + word)

      function getInsurancesComplete(response) {
        return response.data;
      }

      function getInsurancesFailed(error) {
        console.log("My error" + error);
      }
    }

    function getInsurances_siniester(ramo_id, word) {
      var params = {
        pk: ramo_id,
        word: word,
      };
      infoUser = $localStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //   var filter_person = 'v2/siniestros/policies-siniester/';
      var filter_person = "policies-siniester/";
      return $http({
        method: "GET",
        url: url.IP + filter_person,
        params: params,
      })
        .then(getInsurancesComplete)
        .catch(getInsurancesFailed);
      // .get(url.IP + 'policies-by-ramo/' + ramo_id + '/' + word)

      function getInsurancesComplete(response) {
        return response.data;
      }

      function getInsurancesFailed(error) {
        console.log("My error" + error);
      }
    }

    function getInsurances() {
      return $http
        .get(url.IP + "polizas/")
        .then(getInsurancesComplete)
        .catch(getInsurancesFailed);

      function getInsurancesComplete(response) {
        return response.data.results;
      }

      function getInsurancesFailed(error) {}
    }

    function deleteOT(ot) {
      var uri = url.IP + "polizas/" + ot.id + "/";
      var data_email = {
        id: ot.id,
        model: 2,
        type_person: 0,
      };
      dataFactory
        .post("send-email-admins-deletes/", data_email)
        .then(function success(req) {
          return $http.delete(uri);
        });
      // return $http.delete(uri);
    }

    function getPoliciesForRenovation(status, order, asc) {
      var dfd = $.Deferred();
      var policies = [];
      var ots = [];

      getandReadInsurancesforRenovation(status, order, asc).then(function (
        insurances
      ) {
        //------------------------------------------------------------------------------------------ 2
        var policies = insurances;
        // policies.forEach(function(elem) {
        //    if (elem.juridical) {
        //         $http.get(url.IP + 'morales-resume-name/'+ elem.juridical+'/').then(function(response) {
        //         // $http.get(elem.juridical).then(function(response) {
        //             elem.juridical = response.data;
        //         })
        //     }
        //     else{
        //         $http.get(url.IP + 'fisicas-resume-name/'+ elem.natural+'/').then(function(response) {
        //         // $http.get(elem.natural).then(function(response) {
        //             elem.natural = response.data;
        //         })
        //     }
        // })
        var total = { policies: policies };
        dfd.resolve(total);
      });

      return dfd;
    }

    function getPolicies() {
      var dfd = $.Deferred();
      var policies = [];
      var ots = [];

      getandReadInsurances().then(function (insurances) {
        insurances.forEach(function (insurance) {
          // if (insurance.juridical) {
          //     $http.get(url.IP + 'morales-resume-name/'+ insurance.juridical+'/').then(function(response) {
          //         insurance.juridical = response.data;
          //     })
          // }
          // else{
          //     $http.get(url.IP + 'fisicas-resume-name/'+ insurance.natural+'/').then(function(response) {
          //         insurance.natural = response.data;
          //     })
          // }

          if (helpers.isPolicy(insurance) && insurance.document_type === 1) {
            policies.push(insurance);
          } else if (helpers.isOT(insurance)) {
            ots.push(insurance);
          }
        });
        var total = { policies: policies, ots: ots };
        dfd.resolve(total);
      });

      return dfd;
    }

    // function getOts() {
    //   var dfd = $.Deferred();
    //   var ots = [];

    //   getandReadInsurances()
    //     .then(function(insurances) {
    //       insurances.forEach(function(insurance) {
    //         if (helpers.isOT(insurance)) {
    //           ots.push(insurance);
    //         }
    //       });
    //       dfd.resolve(ots);
    //     });

    //   return dfd;
    // }

    function getandReadInsurancesforRenovation(status, order, asc) {
      // return $http.get(url.IP + 'leer-polizas/')
      // return $http.get(url.IP + 'leer-rpolizas-resume/')
      return $http({
        method: "GET",
        url: url.IP + "leer-rpolizas-resume/",
        params: {
          status: status,
          order: order,
          asc: asc,
        },
      })
        .then(getandReadInsurancesComplete)
        .catch(getandReadInsurancesFailed);

      function getandReadInsurancesComplete(response) {
        if (response.data) {
          response.data.results.forEach(function (item) {});

          return response.data.results;
        }
        return getandReadInsurancesFailed(response);
      }

      function getandReadInsurancesFailed(error) {
        return error;
      }
    }

    function getOTsResume(order, asc) {
      // // return $http.get(url.IP + 'leer-polizas/')
      // return $http.get(url.IP + 'leer-ots-resume/',
      //     params:{
      //                     tipo: parType
      //                   }
      //   )
      // $http({
      //                     method: 'GET',
      //                     url: url.IP +'leer-ots-resume/',
      //                     params:{
      //                       order: order,
      //                       asc: asc
      //                     }
      //                   })
      infoUser = $localStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //   var leer_ots = 'v2/polizas/leer-ots-resume-dash/';
      var leer_ots = "leer-ots-resume-dash/";

      return $http({
        method: "POST",
        url: url.IP + leer_ots,
        data: {
          order: order,
          asc: asc,
        },
      })
        .then(getandReadInsurancesComplete)
        .catch(getandReadInsurancesFailed);

      function getandReadInsurancesComplete(response) {
        if (response.data) {
          var results = {
            data: response.data.results,
            config: {
              count: response.data.count,
              next: response.data.next,
              previous: response.data.previous,
            },
          };

          return results;

          // return response.data.results;
        }
        return getandReadInsurancesFailed(response);
      }

      function getandReadInsurancesFailed(error) {
        return error;
      }
    }

    function getandReadInsurances() {
      // return $http.get(url.IP + 'leer-polizas/')
      return $http
        .get(url.IP + "leer-polizas-resume/")
        .then(getandReadInsurancesComplete)
        .catch(getandReadInsurancesFailed);

      function getandReadInsurancesComplete(response) {
        if (response.data) {
          return response.data.results;
        }
        return getandReadInsurancesFailed(response);
      }

      function getandReadInsurancesFailed(error) {
        return error;
      }
    }

    function getInsurancesForDash(order, asc) {
      // //return $http.get(url.IP + 'leer-polizas/')
      // return $http.get(url.IP + 'polizas-dash/')
      infoUser = $localStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //   var chart_renovation = 'v2/polizas/graficas-renovaciones/';
      var chart_renovation = "graficas-renovaciones/";
      return $http({
        method: "GET",
        url: url.IP + chart_renovation,
        params: {
          order: order,
          asc: asc,
          tipo: "total",
        },
      })
        .then(getandReadInsurancesComplete)
        .catch(getandReadInsurancesFailed);

      function getandReadInsurancesComplete(response) {
        if (response.data) {
          // return response.data.results;

          var results = {
            data: response.data.results,
            config: {
              count: response.data.count,
              previous: response.data.previous,
              next: response.data.next,
            },
          };

          return results;
        }
        return getandReadInsurancesFailed(response);
      }

      function getandReadInsurancesFailed(error) {
        return error;
      }
    }

    function getContractorPersonalInfo(id) {
      return $http
        .get(url.IP + "get-contractor-personal-info/" + id + "/")
        .then(getComplete)
        .catch(getFailed);

      function getComplete(response) {
        if (response) {
          return response.data;
        }
        return getFailed(response);
      }

      function getFailed(error) {
        return error;
      }
    }

    function getInsuranceResumeWithCoverages(id) {
      // return $http.get(url.IP + 'leer-polizas/')
      return $http
        .get(url.IP + "polizas/" + id + "/")
        .then(getandReadInsurancesComplete)
        .catch(getandReadInsurancesFailed);

      function getandReadInsurancesComplete(response) {
        if (response.data) {
          return response.data.coverageInPolicy_policy;
        }
        return getandReadInsurancesFailed(response);
      }

      function getandReadInsurancesFailed(error) {
        return error;
      }
    }

    function getInsurancesForEndorsements(parWord) {
      // return $http.get(url.IP + 'leer-polizas/')
      var data = {
        word: parWord,
      };
      return $http
        .post(url.IP + "leer-polizas-endorsements/", data)
        .then(getandReadInsurancesComplete)
        .catch(getandReadInsurancesFailed);

      function getandReadInsurancesComplete(response) {
        if (response.data) {
          return response.data;
        }
        return getandReadInsurancesFailed(response);
      }

      function getandReadInsurancesFailed(error) {
        return error;
      }
    }

    function getInsuranceRead(data, type) {
      console.log("oo", data);
      if (type == 2) {
        data.polizaId = url.IP + "leer-fianzas-info/" + data.id + "/";
      } else {
        if (angular.isObject(data)) {
          if (data.id) {
            data.polizaId = url.IP + "leer-polizas-info/" + data.id + "/";
          } else if (!isNaN(Number(data.polizaId))) {
            data.polizaId = url.IP + "leer-polizas-info/" + data.polizaId + "/";
          } else {
            data.polizaId = data.polizaId ? data.polizaId : "";
          }
        } else {
          if (angular.isObject(data)) {
            data.polizaId = data;
          }
        }
      }

      return $http
        .get(angular.isObject(data) ? data.polizaId : data)
        .then(getInsuranceReadComplete)
        .catch(getInsuranceReadFailed);

      function getInsuranceReadComplete(response) {
        if (response.data.coverageInPolicy_policy) {
          var delete_cov = [];
          response.data.coverageInPolicy_policy.forEach(function (cov) {
            if (
              (cov.coinsurance == null || cov.coinsurance == "") &&
              (cov.sum_insured == null || cov.sum_insured == "") &&
              (cov.deductible == null || cov.deductible == "")
            ) {
              delete_cov.push(coverageService.deleteCoverageByUri(cov.url));
            }
          });
        }
        return response.data;
      }

      function getInsuranceReadFailed(error) {}
    }

    function getPDFInsurance(insurance_id) {
      return $http
        .get(url.IP + "policy-for-pdf/" + insurance_id + "/")
        .then(getandPdfInsurancesComplete)
        .catch(getandReadInsurancesFailed);

      function getandPdfInsurancesComplete(response) {
        if (response.data) {
          return response.data.results;
        }
        return getandReadInsurancesFailed(response);
      }

      function getandReadInsurancesFailed(error) {
        return error;
      }
    }

    function getInsuranceData(insurance) {
      var dfd = $q.defer();
      var uri = url.IP + "leer-polizas-edit/" + insurance.id + "/";
      var insuranceComplete = {};
      var things = 0;
      var thingsToLoad = 1; // the insurance

      if (insurance.coverageInPolicy_policy) {
        // }
        //   else{
        getInsuranceResumeWithCoverages(insurance.id).then(function (
          coverages
        ) {
          insurance.coverageInPolicy_policy = coverages;
        });
      }
      $http
        .get(uri)
        .then(function (insuranceResponse) {
          if (checkResponse(insuranceResponse)) {
            return;
          }

          var insuranceEmpty = insuranceResponse.data;
          insuranceEmpty.coverageInPolicy_policy =
            insurance.coverageInPolicy_policy;
          insuranceEmpty.read = insurance;

          insuranceComplete = angular.copy(insuranceEmpty);

          //recibos
          thingsToLoad += insuranceComplete.recibos_poliza.length;
          insuranceComplete.recibos_poliza = [];
          insuranceEmpty.recibos_poliza.forEach(function (receiptUri) {
            receiptService
              .getReceiptsByUriService(receiptUri)
              .then(function (receiptObj) {
                insuranceComplete.recibos_poliza.push(receiptObj);
                thingLoaded("recibo"); // Receipt loaded
              });
          });

          //payform
          thingsToLoad++;
          payform.some(function (form) {
            if ((form.value = insuranceEmpty.forma_de_pago)) {
              insuranceComplete.forma_de_pago = form;
              insurance.forma_de_pago = form.value;
              return true;
            }
          });
          thingLoaded("payform"); // payform loaded
          //address

          try {
            thingsToLoad++;
            $http.get(insuranceResponse.data.address).then(function (address) {
              insuranceComplete.address = address.data;
              thingLoaded("address"); // provider loaded
            });
          } catch (e) {
            console.log("address error", e);
          }

          //clave
          thingsToLoad++;
          if (
            insuranceResponse.data.clave &&
            insuranceResponse.data.clave.url
          ) {
            $http.get(insuranceResponse.data.clave.url).then(function (clave) {
              insuranceComplete.clave = clave.data;
              thingLoaded("clave"); // provider loaded
            });
          } else {
            console.log("sin clave");
            SweetAlert.swal(
              "Información",
              "La póliza no tiene clave, deberá seleccionar una para guardar",
              "info"
            );
            thingLoaded("clave"); // provider loaded
          }
          //provider
          thingsToLoad++;
          providerService
            .getProviderById(insuranceEmpty.aseguradora)
            .then(function (providerResponse) {
              if (checkResponse(providerResponse)) {
                return;
              }
              insuranceComplete.aseguradora = providerResponse.data;
              thingLoaded("provider"); // provider loaded
            });

          // //ramo
          thingsToLoad++;
          ramoService
            .getRamoById(insuranceEmpty.ramo.id)
            .then(function (ramoResponse) {
              if (checkResponse(ramoResponse)) {
                return;
              }
              insuranceComplete.ramo = ramoResponse.data;
              thingLoaded("ramo");
            });

          //subramo
          thingsToLoad++;
          ramoService
            .getSubramoById(insuranceEmpty.subramo.id)
            // ramoService.getSubramoByUri(insuranceEmpty.subramo)
            .then(function (subramoResponse) {
              if (checkResponse(subramoResponse)) {
                return;
              }
              insuranceComplete.subramo = subramoResponse.data;
              thingLoaded("subramo");
            });

          // package
          if (insuranceEmpty.paquete) {
            thingsToLoad++;
            packageService
              .getPackageById(insuranceEmpty.paquete.id)
              // packageService.getPackageByUri(insuranceEmpty.paquete)
              .then(function (packageResponse) {
                if (checkResponse(packageResponse)) {
                  return;
                }
                insuranceComplete.paquete = packageResponse.data;
                thingLoaded("Paquete");
              });
          }

          //

          if (insuranceEmpty.life_policy.length > 0) {
            thingLoaded("personal");
            insuranceEmpty.life_policy.forEach(function (prs, prsPos) {});
            // thingsToLoad += insuranceEmpty.life_policy.length; // cargaremos cada life_policy
            insuranceEmpty.life_policy.forEach(function (elem, index) {
              thingsToLoad += elem.beneficiaries_life.length;
              elem.beneficiaries_life.forEach(function (ben, benPos) {
                $http.get(ben.life).then(function (response) {
                  insuranceComplete.life_policy[index].beneficiaries_life[
                    benPos
                  ].life = response.data;
                  thingLoaded("beneficiary");
                });
              });
            });
          } else if (insuranceEmpty.accidents_policy.length > 0) {
            thingsToLoad += insuranceEmpty.accidents_policy.length; // cargaremos cada life_policy
            insuranceEmpty.accidents_policy.forEach(function (elem, index) {
              thingsToLoad += elem.relationship_accident.length;
              // $http.get(elem.personal.url)
              $http.get(elem.personal).then(function (response) {
                insuranceComplete.accidents_policy[index].personal =
                  response.data;
                thingLoaded("accidents_policy");
              });
              elem.relationship_accident.forEach(function (ben, benPos) {
                $http.get(ben.accident).then(function (response) {
                  insuranceComplete.accidents_policy[
                    index
                  ].relationship_accident[benPos].accident = response.data;
                  thingLoaded("relationship_accident");
                });
              });
            });
          }

          // contractor
          thingsToLoad++;
          // if (insuranceEmpty.juridical) {
          //   ContratanteService.getContratanteByUri(insuranceEmpty.juridical)
          //     .then(function(contractorResponse) {
          //       if (checkResponse(contractorResponse)) {
          //         return;
          //       }
          //       insuranceComplete.juridical = contractorResponse.data;
          //       $http.get(insuranceComplete.juridical.group)
          //         .then(function(response) {
          //           insuranceComplete.juridical.group = response.data;
          //           thingLoaded("juridical");
          //         });
          //     });
          // }

          // if (insuranceEmpty.natural) {
          //   ContratanteService.getContratanteByUri(insuranceEmpty.natural)
          //     .then(function(contractorResponse) {
          //       if (checkResponse(contractorResponse)) {
          //         return;
          //       }
          //       insuranceComplete.natural = contractorResponse.data;
          //       // console.log('insurance', insuranceComplete.natural);
          //       $http.get(insuranceComplete.natural.group)
          //         .then(function(response) {
          //           insuranceComplete.natural.group = response.data;
          //           thingLoaded("natural");
          //         });
          //     });
          // }
          if (insuranceEmpty.contractor) {
            ContratanteService.getContratanteByUri(
              insuranceEmpty.contractor
            ).then(function (contractorResponse) {
              if (checkResponse(contractorResponse)) {
                return;
              }
              insuranceComplete.contractor = contractorResponse.data;
              $http
                .get(insuranceComplete.contractor.group)
                .then(function (response) {
                  insuranceComplete.contractor.group = response.data;
                  thingLoaded("contractor");
                });
            });
          }
          // files
          thingsToLoad++;
          var accesos = $sessionStorage.permisos;
          if (accesos) {
            accesos.forEach(function (perm) {
              if (perm.model_name == "Archivos") {
                var acceso_files = perm;
                acceso_files.permissions.forEach(function (acc) {
                  if (acc.permission_name == "Administrar archivos sensibles") {
                    if (acc.checked == true) {
                      var permiso_archivos = true;
                      getFiles(insurance).then(function (filesData) {
                        insuranceComplete.files = { results: filesData };
                        thingLoaded("files");
                      });
                    } else {
                      var permiso_archivos = true;
                      getFiles(insurance).then(function (filesData) {
                        insuranceComplete.files = { results: filesData };
                        thingLoaded("files");
                      });
                    }
                  }
                });
              }
            });
          }

          thingLoaded("insurance"); // Policy loaded
        })
        .catch(function (error) {
          dfd.reject(error);
        });

      function thingLoaded(what) {
        things++;
        if (things >= thingsToLoad) {
          var initDate = new Date(insuranceComplete.start_of_validity);
          var endingDate = new Date(insuranceComplete.end_of_validity);

          initDate = new Date(
            initDate.getTime() + initDate.getTimezoneOffset() * 60000
          );
          endingDate = new Date(
            endingDate.getTime() + endingDate.getTimezoneOffset() * 60000
          );

          insuranceComplete.start_of_validity = initDate;
          insuranceComplete.end_of_validity = endingDate;

          dfd.resolve(insuranceComplete);
        }
      }

      function checkResponse(response) {
        if (response.status < 200 || response.status >= 300) {
          dfd.reject(response);
          return true;
        }
        return false;
      }
      return dfd.promise;
    }

    function getInsurance(data) {
      if (!isNaN(Number(data.polizaId))) {
        data.polizaId = url.IP + "polizas/" + data.polizaId + "/";
      } else {
        if (data && data.polizaId) {
          data.polizaId = data.polizaId;
        }
      }
      return $http
        .get(data.polizaId)
        .then(getInsuranceComplete)
        .catch(getInsuranceFailed);

      function getInsuranceComplete(response) {
        return response.data;
      }

      function getInsuranceFailed(error) {}
    }

    function getInsuranceByNumber(data) {
      var url = globalVar.policyByNumber + data + "";
      return $http
        .get(url)
        .then(getInsuranceByNumberComplete)
        .catch(getInsuranceByNumberFailed);

      function getInsuranceByNumberComplete(response) {
        return response;
      }

      function getInsuranceByNumberFailed(error) {
        return error;
      }
    }

    function getInsuranceByNumberURL(data) {
      return $http
        .get(globalVar.policyByNumberURL + data)
        .then(getInsuranceByNumberURLComplete)
        .catch(getInsuranceByNumberURLFailed);

      function getInsuranceByNumberURLComplete(response) {
        return response;
      }

      function getInsuranceByNumberURLFailed(error) {
        return error;
      }
    }

    function updateOldPolicy(insurance) {
      dataFactory
        .get("get-renovation", { actual_id: insurance.id })
        .then(function success(response) {
          if (response.data.results.length) {
            var data = {
              status: 12,
              renewed_status: 1,
            };
            $http.patch(response.data.results[0].base_policy.url, data);
          }
        });
    }
    function formatNumber(val) {
      var number = Number(val.replace(/[^0-9.-]+/g, ""));
      return number;
    }

    function updateFullInsurance(insurance) {
      // return;
      var dfd = $q.defer();

      var saveObjRequest = {
        // Objeto para actualizar
        aseguradora: insurance.aseguradora ? insurance.aseguradora.url : "",
        end_of_validity: insurance.endingDate,
        folio: insurance.folio,
        forma_de_pago: insurance.payment ? insurance.payment.value : null,
        sucursal: insurance.sucursal ? insurance.sucursal : "",
        // juridical: insurance.contratante.type_person == 'Moral' ? insurance.contratante.url : null,
        // natural: insurance.contratante.type_person == 'Fisica' ? insurance.contratante.url : null,
        contractor: insurance.contratante.url,
        observations: insurance.observations,
        old_policies: insurance.old_policies,
        paquete: insurance.paquete ? insurance.paquete.url : null,
        poliza_number: insurance.poliza ? insurance.poliza : "",
        ramo: insurance.ramo ? insurance.ramo.url : null,
        // recibos_poliza: [],
        start_of_validity: insurance.startDate,
        status: insurance.status,
        subramo: insurance.subramo ? insurance.subramo.url : null,
        address: insurance.address.url,
        clave: insurance.clave.url,
        f_currency: insurance.f_currency,
        conducto_de_pago: insurance.conducto_de_pago,
        identifier: insurance.identifier,
        name: insurance.name,
        administration_type: insurance.administration_type,
        p_total: insurance.p_total,
        sub_total: insurance.sub_total,
        descuento: insurance.descuento ? insurance.descuento : 0,
        derecho: insurance.derecho ? insurance.derecho : 0,
        rpf: insurance.rpf ? insurance.rpf : 0,
        p_neta: insurance.p_neta,
        iva: insurance.iva,
        comision: insurance.comision,
        comision_percent: insurance.comision_percent,
        comision_rpf_percent: insurance.comision_rpf_percent,
        comision_derecho_percent: insurance.comision_derecho_percent,
        give_comision: insurance.give_comision,
        responsable: insurance.responsable,
        collection_executive: insurance.collection_executive
          ? insurance.collection_executive
          : "",
        is_renewable: insurance.is_renewable,
        hospital_level: insurance.hospital_level
          ? insurance.hospital_level
          : "",
        tabulator: insurance.tabulator ? insurance.tabulator : "",
        business_line: insurance.business_line ? insurance.business_line : 0,
        celula: insurance.celula ? insurance.celula : "",
        groupinglevel: insurance.groupinglevel ? insurance.groupinglevel : "",
        state_circulation: insurance.state_circulation
          ? insurance.state_circulation
          : "",
      };
      // return;
      if (insurance && !insurance.url && insurance.id) {
        insurance.url = url.IP + "polizas/" + insurance.id + "/";
        console.log("sin url***", insurance.url, url);
      }
      $http
        .patch(insurance.url, saveObjRequest)
        .catch(catchIt)
        .then(function (updateResponse) {
          var waitForDelete = [];
          insurance.old_coverages.forEach(function (old_coverage) {
            waitForDelete.push(
              coverageService.deleteCoverageByUri(old_coverage.url)
            );
          });

          var old_form_data = {};

          try {
            waitForDelete.push(
              $http.get(insurance.old_form).then(function (old_form) {
                old_form_data = old_form.data;
              })
            );
          } catch (err) {}
          $q.all(waitForDelete).then(function (responses) {
            var waitForNewData = [];
            var nuevosBen = [];

            if (insurance.form_object) {
              old_form_data.policy = insurance.url;
              old_form_data.sub_branch = insurance.subramo.url;

              var code = insurance.form_code;
              var personalInfo = {};
              if (code === 1 || code == 30) {
                // Inicio personal_life nuevo
                if (insurance.form_object.personal) {
                  insurance.form_object.personal.forEach(function (item) {
                    if (item.url) {
                      var personal_obj = {
                        first_name: item.first_name ? item.first_name : "",
                        last_name: item.last_name ? item.last_name : "",
                        second_last_name: item.second_last_name
                          ? item.second_last_name
                          : "",
                        birthdate: item.birthdate
                          ? new Date(datesFactory.toDate(item.birthdate))
                          : new Date(),
                        antiguedad: item.antiguedad
                          ? new Date(datesFactory.toDate(item.antiguedad))
                          : new Date(),
                        sex: item.sex ? item.sex : "",
                        smoker: item.smoker ? item.smoker : false,
                        policy_type: item.policy_type,
                      };
                      if (personal_obj.smoker == "True") {
                        personal_obj.smoker = true;
                      } else if (personal_obj.smoker == "False") {
                        personal_obj.smoker = false;
                      }
                      waitForNewData.push(
                        $http
                          .patch(item.url, personal_obj)
                          .then(function (personalInfo) {
                            if (personalInfo) {
                              var personalInfo = personalInfo;
                              if (
                                insurance.old_form == undefined ||
                                !insurance.old_form
                              ) {
                                var model = {
                                  sub_branch: insurance.subramo.url
                                    ? insurance.subramo.url
                                    : insurance.subramo,
                                  policy: insurance.url,
                                  personal: personalInfo.data.url,
                                  smoker: personalInfo.data.smoker,
                                };
                                generalService
                                  .lifeForm(model)
                                  .then(function (lifeFormData) {
                                    if (lifeFormData) {
                                      insurance.old_form =
                                        lifeFormData.data.url;
                                      if (nuevosBen) {
                                        nuevosBen.forEach(function (r) {
                                          if (insurance.old_form && r.data) {
                                            $http
                                              .patch(r.data.url, {
                                                life: insurance.old_form,
                                              })
                                              .then(function (pxxl) {});
                                          }
                                        });
                                      }
                                      return;
                                    }
                                  });
                              }
                            }
                          })
                      );
                    } else {
                      var personal_obj = {
                        first_name: item.first_name ? item.first_name : "",
                        last_name: item.last_name ? item.last_name : "",
                        second_last_name: item.second_last_name
                          ? item.second_last_name
                          : "",
                        birthdate: item.birthdate
                          ? new Date(datesFactory.toDate(item.birthdate))
                          : new Date(),
                        antiguedad: item.antiguedad
                          ? new Date(datesFactory.toDate(item.antiguedad))
                          : new Date(),
                        policy: insurance.url,
                        policy_type: item.policy_type,
                        smoker: insurance.smoker ? insurance.smoker : false,
                      };
                      Object.keys(personal_obj).forEach(function (k) {
                        if (
                          personal_obj[k] === "" ||
                          (typeof personal_obj[k] === "string" &&
                            personal_obj[k].trim() === "")
                        ) {
                          delete personal_obj[k];
                        }
                      });
                      if (personal_obj.smoker == "True") {
                        personal_obj.smoker = true;
                      } else if (personal_obj.smoker == "False") {
                        personal_obj.smoker = false;
                      }
                      waitForNewData.push(
                        $http
                          .post(globalVar.personal, personal_obj)
                          .then(function (personalInfo) {
                            if (personalInfo) {
                              var personalInfo = personalInfo;
                              if (
                                insurance.old_form == undefined ||
                                !insurance.old_form
                              ) {
                                var model = {
                                  sub_branch: insurance.subramo.url
                                    ? insurance.subramo.url
                                    : insurance.subramo,
                                  policy: insurance.url,
                                  personal: personalInfo.data.url,
                                  smoker: personalInfo.data.smoker,
                                };
                                generalService
                                  .lifeForm(model)
                                  .then(function (lifeFormData) {
                                    if (lifeFormData) {
                                      insurance.old_form =
                                        lifeFormData.data.url;
                                      if (nuevosBen) {
                                        nuevosBen.forEach(function (r) {
                                          if (insurance.old_form && r.data) {
                                            $http
                                              .patch(r.data.url, {
                                                life: insurance.old_form,
                                              })
                                              .then(function (pxxl) {});
                                          }
                                        });
                                      }
                                      return;
                                    }
                                  });
                              }
                            }
                          })
                      );
                    }
                  });
                }
                // fin personal nuevo
                // var personal_obj={
                //   first_name: insurance.form_object.personal.first_name,
                //   last_name: insurance.form_object.personal.last_name,
                //   second_last_name: insurance.form_object.personal.second_last_name,
                //   sex: insurance.form_object.personal.sex,
                //   birthdate: new Date(datesFactory.toDate(insurance.form_object.personal.birthdate)),
                //   full_name: insurance.form_object.personal.first_name + ' ' + insurance.form_object.personal.last_name + ' ' + insurance.form_object.personal.second_last_name

                // }

                // waitForNewData.push($http.patch(insurance.form_object.personal.url,personal_obj));
                insurance.form_object.relationships.forEach(function (item) {
                  if (item.url) {
                    var relationship_obj = {
                      first_name: item.first_name ? item.first_name : "",
                      last_name: item.last_name ? item.last_name : "",
                      second_last_name: item.second_last_name
                        ? item.second_last_name
                        : "",
                      optional_relationship: item.optional_relationship
                        ? item.optional_relationship
                        : "",
                      birthdate: item.birthdate
                        ? new Date(datesFactory.toDate(item.birthdate))
                        : new Date(),
                      antiguedad: item.antiguedad
                        ? new Date(datesFactory.toDate(item.antiguedad))
                        : new Date(),
                      sex: item.sex ? item.sex : "",
                      percentage: item.percentage ? item.percentage : 100,
                      person: item.person,
                      rfc: item.rfc ? item.rfc : "",
                      j_name: item.j_name ? item.j_name : "",
                      life: insurance.old_form,
                    };

                    waitForNewData.push(
                      $http
                        .patch(item.url, relationship_obj)
                        .then(function (pl) {
                          if (
                            insurance.old_form &&
                            insurance.old_form.bene &&
                            insurance.old_form.bene == null
                          ) {
                            $http
                              .patch(insurance.old_form, {
                                beneficiaries_life: pl,
                              })
                              .then(function (pxxl) {});
                          }
                        })
                    );
                  } else {
                    var relationship_obj = {
                      first_name: item.first_name ? item.first_name : "",
                      last_name: item.last_name ? item.last_name : "",
                      second_last_name: item.second_last_name
                        ? item.second_last_name
                        : "",
                      optional_relationship: item.optional_relationship
                        ? item.optional_relationship
                        : "",
                      birthdate: item.birthdate
                        ? new Date(datesFactory.toDate(item.birthdate))
                        : new Date(),
                      antiguedad: item.antiguedad
                        ? new Date(datesFactory.toDate(item.antiguedad))
                        : new Date(),
                      sex: item.sex ? item.sex : "",
                      percentage: item.percentage ? item.percentage : 100,
                      person: item.person,
                      rfc: item.rfc ? item.rfc : "",
                      j_name: item.j_name ? item.j_name : "",
                      life: insurance.old_form,
                    };
                    waitForNewData.push(
                      $http
                        .post(globalVar.beneficiaries, relationship_obj)
                        .then(function (pl) {
                          nuevosBen.push(pl);
                          if (
                            insurance.old_form &&
                            insurance.old_form.bene == null
                          ) {
                            $http
                              .patch(insurance.old_form, {
                                beneficiaries_life: pl,
                              })
                              .then(function (pxxl) {});
                          }
                        })
                    );
                  }
                });
              } else if (code === 2 || code === 3 || code === 4) {
                var noAccidentsDisease = false;
                var disease = 1;
                var relationships = 1;
                var personal_obj = {
                  first_name: insurance.form_object.personal.first_name,
                  last_name: insurance.form_object.personal.last_name,
                  second_last_name:
                    insurance.form_object.personal.second_last_name,
                  sex: insurance.form_object.personal.sex,
                  birthdate: insurance.form_object.personal.birthdate,
                  antiguedad: insurance.form_object.personal.antiguedad,
                  policy_type: insurance.form_object.personal.policy_type,
                  full_name:
                    insurance.form_object.personal.first_name +
                    " " +
                    insurance.form_object.personal.last_name +
                    " " +
                    insurance.form_object.personal.second_last_name,
                };
                Object.keys(personal_obj).forEach(function (k) {
                  if (
                    personal_obj[k] === "" ||
                    (typeof personal_obj[k] === "string" &&
                      personal_obj[k].trim() === "")
                  ) {
                    delete personal_obj[k];
                  }
                });
                var submitObject = {
                  code: code,
                  personal: personal_obj,
                  relationships: insurance.form_object.relationships,
                  coinsurance: disease.coinsurance,
                  insurance: updateResponse.data,
                };
                if (insurance.form_object.personal.url) {
                  waitForNewData.push(
                    $http.patch(
                      insurance.form_object.personal.url,
                      personal_obj
                    )
                  );
                } else {
                  // Crear form de Acicdentes gM si p�liza no tiene (es migrada)
                  noAccidentsDisease = true;
                  var dataToSave = {
                    code: code,
                    insurance: insurance,
                    accidents_policy: [],
                    personal: {},
                    relationships: [],
                  };
                  dataToSave.insurance = insurance;
                  insurance.form_object.relationships.forEach(function (
                    relationship
                  ) {
                    (relationship.first_name = relationship.first_name),
                      (relationship.last_name = relationship.last_name),
                      (relationship.second_last_name =
                        relationship.second_last_name),
                      (relationship.sex = relationship.sex.value),
                      (relationship.birthdate = relationship.birthdate
                        ? new Date(datesFactory.toDate(relationship.birthdate))
                        : null),
                      (relationship.antiguedad = relationship.antiguedad
                        ? new Date(datesFactory.toDate(relationship.antiguedad))
                        : null),
                      (relationship.relationship =
                        relationship.relationship.relationship),
                      // accident: insurance.old_form,
                      (relationship.full_name =
                        relationship.first_name +
                        " " +
                        relationship.last_name +
                        " " +
                        relationship.second_last_name);
                  });
                  var personal_x = {
                    first_name: insurance.form_object.personal.first_name,
                    last_name: insurance.form_object.personal.last_name,
                    second_last_name:
                      insurance.form_object.personal.second_last_name,
                    sex: insurance.form_object.personal.sex,
                    birthdate: insurance.form_object.personal.birthdate,
                    antiguedad: insurance.form_object.personal.antiguedad,
                    full_name:
                      insurance.form_object.personal.first_name +
                      " " +
                      insurance.form_object.personal.last_name +
                      " " +
                      insurance.form_object.personal.second_last_name,
                  };
                  dataToSave.personal = personal_x;
                  dataToSave.relationships =
                    insurance.form_object.relationships;
                  formService.createAccidentsDisease(dataToSave);
                }
                if (!noAccidentsDisease) {
                  insurance.form_object.relationships.forEach(function (
                    relationship
                  ) {
                    if (relationship.url) {
                      var relationship_obj = {
                        first_name: relationship.first_name,
                        last_name: relationship.last_name,
                        second_last_name: relationship.second_last_name,
                        sex: relationship.sex.value,
                        birthdate: relationship.birthdate
                          ? new Date(
                              datesFactory.toDate(relationship.birthdate)
                            )
                          : null,
                        antiguedad: relationship.antiguedad
                          ? new Date(
                              datesFactory.toDate(relationship.antiguedad)
                            )
                          : null,
                        relationship: relationship.relationship.relationship,
                        full_name:
                          relationship.first_name +
                          " " +
                          relationship.last_name +
                          " " +
                          relationship.second_last_name,
                      };
                      if (
                        !relationship.url == null ||
                        !relationship.url == ""
                      ) {
                        waitForNewData.push(
                          $http.patch(relationship.url, relationship_obj)
                        );
                      }
                    } else {
                      var relationship_obj = {
                        first_name: relationship.first_name,
                        last_name: relationship.last_name,
                        second_last_name: relationship.second_last_name,
                        sex: relationship.sex.value,
                        birthdate: relationship.birthdate
                          ? new Date(
                              datesFactory.toDate(relationship.birthdate)
                            )
                          : null,
                        antiguedad: relationship.antiguedad
                          ? new Date(
                              datesFactory.toDate(relationship.antiguedad)
                            )
                          : null,
                        relationship: relationship.relationship.relationship,
                        accident: insurance.old_form,
                        full_name:
                          relationship.first_name +
                          " " +
                          relationship.last_name +
                          " " +
                          relationship.second_last_name,
                      };
                      waitForNewData.push(
                        $http.post(globalVar.relationships, relationship_obj)
                      );
                    }
                  });
                }
              } else if (code === 9) {
                var montAdjustement = 0;
                var montEquipment = 0;

                if (insurance.form_object.form.mont_special_team) {
                  montEquipment = parseFloat(
                    formatNumber(insurance.form_object.form.mont_special_team)
                  ).toFixed(2);
                }

                if (insurance.form_object.form.mont_adjustment) {
                  montAdjustement = parseFloat(
                    formatNumber(insurance.form_object.form.mont_adjustment)
                  ).toFixed(2);
                }
                var automobile = {
                  brand: insurance.form_object.form.brand,
                  model: insurance.form_object.form.model,
                  year: insurance.form_object.form.year,
                  version: insurance.form_object.form.version,
                  serial: insurance.form_object.form.serial,
                  engine: insurance.form_object.form.engine,
                  color: insurance.form_object.form.color,
                  usage: insurance.form_object.form.usage,
                  service: insurance.form_object.form.service,
                  policy_type: insurance.form_object.form.policy_type,
                  procedencia: insurance.form_object.form.procedencia
                    ? insurance.form_object.form.procedencia
                    : 0,
                  charge_type: insurance.form_object.form.charge_type
                    ? insurance.form_object.form.charge_type
                    : 0,
                  license_plates: insurance.form_object.form.license_plates,
                  beneficiary_name: insurance.form_object.form.beneficiary_name,
                  beneficiary_address:
                    insurance.form_object.form.beneficiary_address,
                  beneficiary_rfc: insurance.form_object.form.beneficiary_rfc,
                  driver: insurance.form_object.form.driver,
                  adjustment: insurance.form_object.form.adjustment,
                  mont_adjustment: montAdjustement,
                  special_team: insurance.form_object.form.special_team,
                  mont_special_team: montEquipment,
                };
                if (insurance.form_object.form.state_circulation) {
                  if (insurance.form_object.form.state_circulation.state) {
                    $http
                      .patch(insurance.url, {
                        state_circulation:
                          insurance.form_object.form.state_circulation.state,
                      })
                      .then(function (responSt) {
                        console.log("enviado estado", responSt);
                      });
                  }
                }
                if (old_form_data.url) {
                  waitForNewData.push(
                    $http.patch(old_form_data.url, automobile)
                  );
                }
              } else {
                var data = {
                  insured_item: insurance.form_object.form.insured_item,
                  item_address: insurance.form_object.form.item_address,
                  item_details: insurance.form_object.form.item_details,
                  damage_type: insurance.form_object.form.damage_type,
                };

                $http.patch(insurance.form_object.form.url, data);
              }
            } else if (insurance.update_form) {
              $http.patch(insurance.update_form.url, insurance.update_form);
            }

            // inserting new coverages
            insurance.coverages.forEach(function (niu) {
              var newCvg = {
                policy: insurance.endorsementedUrl
                  ? insurance.endorsementedUrl
                  : insurance.url,
                package: insurance.paquete.url,
                coverage_name: niu.coverage_name ? niu.coverage_name : "",
                priority: niu.priority ? niu.priority : 0,
                deductible: niu.deductibleInPolicy
                  ? niu.deductibleInPolicy.label
                  : 0,
                sum_insured: niu.sumInPolicy ? niu.sumInPolicy.label : 0,
                prima: niu.primaInPolicy ? niu.primaInPolicy : 0,
                coinsurance: niu.coinsuranceInPolicy
                  ? niu.coinsuranceInPolicy.value
                  : 0,
                topecoinsurance: niu.topeCoinsuranceInPolicy
                  ? niu.topeCoinsuranceInPolicy.value
                  : 0,
              };
              // console.log('cobertura-----',newCvg)
              waitForNewData.push(
                coverageService.createCoberturaPoliza(newCvg)
              );
            });

            // inserting new recepits
            var receipt_array = [];

            var nr;
            var id_receipt;
            var recibo_tipo;
            var owner_id;
            var saveReceiptUrlRequest;

            // test
            if (!insurance.edited_pay_frequency) {
              // C�digo agregado el d�a 05/02/2019
              if (insurance.receipts_changes) {
                if (insurance.receipts_changes.delete_receipts.length) {
                  insurance.receipts_changes.delete_receipts.forEach(function (
                    item
                  ) {
                    if (item.receipt_type == 1) {
                      if (item.url) {
                        $http.delete(item.url).then(function (req) {
                          var params = {
                            model: 1,
                            event: "DELETE",
                            associated_id: insurance.id,
                            identifier: "elimino un recibo",
                          };
                          dataFactory
                            .post("send-log/", params)
                            .then(function success(response) {});
                        });
                      } else {
                        var params_ = {
                          model: 1,
                          event: "DELETE",
                          associated_id: insurance.id,
                          identifier:
                            "elimino recibos al crear la p�liza (vigencia menor de un a�o) " +
                            item.recibo_numero,
                        };
                        dataFactory
                          .post("send-log/", params_)
                          .then(function success(response) {});
                      }
                    }
                  });
                }
              }
              if (insurance.receipts_changes) {
                if (insurance.receipts_changes.patch_receipts.length) {
                  insurance.receipts_changes.patch_receipts.forEach(function (
                    item
                  ) {
                    $http.patch(item.url, item).then(function (req) {});
                  });
                }
              }
              if (insurance.receipts_changes) {
                if (insurance.receipts_changes.save_receipts.length) {
                  insurance.receipts_changes.save_receipts.forEach(function (
                    item
                  ) {
                    if (isNaN(item.comision)) {
                      item.comision = 0;
                    }

                    item.poliza = insurance.url;

                    dataFactory.post("recibos/", item).then(
                      function success(req) {
                        insurance.old_receipts.push(req.data);
                      },
                      function error(error) {
                        console.log("___________-", error);
                      }
                    );
                  });
                }
              }

              // ************************  ORIGINAL  *****************************
              // insurance.receipts.forEach(function(receipt, index) {

              //  if(receipt.receipt_type != 2){

              //     if(receipt.recibo_numero) {
              //       nr = receipt.recibo_numero;
              //       id_receipt = receipt.id;
              //       recibo_tipo = receipt.receipt_type;
              //       owner_id = receipt.rp_owner_id;

              //     } else {

              //       nr = index + 1;
              //       recibo_tipo = 1;
              //       owner_id = null;

              //     }

              //     receipt.comision = receipt.comision ? parseFloat(receipt.comision) : 0;
              //     var saveReceiptRequest = {
              //       poliza: insurance.url,
              //       recibo_numero: nr,
              //       prima_neta: receipt.prima,
              //       delivered: receipt.delivered,
              //       rpf: receipt.rpf,
              //       derecho: receipt.derecho,
              //       iva: receipt.iva,
              //       comision: receipt.comision ? (receipt.comision).toFixed(2) : 0 ,
              //       sub_total: receipt.subTotal,
              //       prima_total: receipt.total,
              //       status: receipt.status,
              //       fecha_inicio: receipt.startDate,
              //       fecha_fin: receipt.endingDate,
              //       description: "",
              //       receipt_type:recibo_tipo,
              //       rp_owner_id:owner_id,
              //       pay_form:receipt.pay_form,
              //       pay_doc:receipt.pay_doc,
              //       curr_rate:receipt.curr_rate,
              //       bank:receipt.bank,
              //       vencimiento: receipt.vencimiento,
              //       isActive: true,

              //     };
              //     saveReceiptUrlRequest= {
              //       poliza:insurance.url
              //     }

              //   // informaci�n de los recibos, url, etc, etc.
              //   if(insurance.old_receipts.length) {
              //     if(!insurance.edited_pay_frequency){

              //       insurance.old_receipts.forEach(function(item, index) {
              //         if(item.receipt_type == 1) {
              //           if(nr == item.recibo_numero){
              //             $http.patch(item.url,saveReceiptRequest);
              //           } else {
              //             // ESTA LINEA ES LA QUE PROVOCABA UN BUEN DE LLAMADAS
              //             // $http.patch(item.url,saveReceiptRequest);
              //           }
              //         }
              //       });
              //     } else {
              //       insurance.old_receipts = [];
              //     }

              //   } else {
              //     receiptService.createReceiptService(saveReceiptRequest);
              //   }
              //  }
              //  else{
              //  }

              // });
            }

            $q.all(waitForNewData).then(function (responses) {
              getInsuranceRead(insurance).then(function (response) {
                dfd.resolve(response);
              });
            }, catchIt);

            //END CREATE NEW DATA
          }, catchIt);
        });

      function catchIt(error) {
        dfd.reject(error);
      }

      return dfd.promise;
    }
    function checkRes(result) {
      if (result.status < 200 || result.status >= 300) {
        dfd.reject(result);
        return true;
      }
      return false;
    }
    function updateFullOT(insurance) {
      var dfd = $q.defer();
      var saveObjRequest = {
        // Objeto para actualizar
        aseguradora: insurance.aseguradora ? insurance.aseguradora.url : "",
        end_of_validity: insurance.endingDate,
        folio: insurance.folio,
        forma_de_pago: insurance.payment ? insurance.payment.value : null,
        // juridical: insurance.contratante.type_person == 'Moral' ? insurance.contratante.url : null,
        // natural: insurance.contratante.type_person == 'Fisica' ? insurance.contratante.url : null,
        contractor: insurance.contratante.url,
        observations: insurance.observations,
        old_policies: insurance.old_policies,
        paquete: insurance.paquete ? insurance.paquete.url : null,
        poliza_number: insurance.poliza ? insurance.poliza : " ",
        ramo: insurance.ramo ? insurance.ramo.url : null,
        // recibos_poliza: [],
        start_of_validity: insurance.startDate,
        status: insurance.status,
        subramo: insurance.subramo ? insurance.subramo.url : null,
        address: insurance.address.url,
        clave: insurance.clave.url,
        derecho: insurance.derecho ? insurance.derecho : 0,
        iva: insurance.iva ? insurance.iva : 0,
        p_neta: insurance.p_neta ? insurance.p_neta : 0,
        p_total: insurance.p_total ? insurance.p_total : 0,
        rpf: insurance.rpf ? insurance.rpf : 0,
        f_currency: insurance.f_currency ? insurance.f_currency : 1,
        conducto_de_pago: insurance.conducto_de_pago
          ? insurance.conducto_de_pago
          : 1,
        sucursal: insurance.sucursal ? insurance.sucursal : "",
        responsable: insurance.responsable,
        identifier: insurance.identifier,
        collection_executive: insurance.collection_executive
          ? insurance.collection_executive
          : "",
        hospital_level: insurance.hospital_level
          ? insurance.hospital_level
          : "",
        tabulator: insurance.tabulator ? insurance.tabulator : "",
        business_line: insurance.business_line ? insurance.business_line : 0,
        state_circulation: insurance.state_circulation
          ? insurance.state_circulation
          : "",
        celula: insurance.celula ? insurance.celula : "",
        groupinglevel: insurance.groupinglevel ? insurance.groupinglevel : "",
      };

      $http
        .patch(insurance.url, saveObjRequest)
        .catch(catchIt)
        .then(function (updateResponse) {
          var waitForDelete = [];
          //DELETE OLD DATA original
          insurance.old_coverages.forEach(function (old_coverage) {
            waitForDelete.push(
              coverageService.deleteCoverageByUri(old_coverage.url)
            );
          });

          var old_form_data;

          try {
            waitForDelete.push(
              $http.get(insurance.old_form).then(function (old_form) {
                old_form_data = old_form.data;
              })
            );
          } catch (err) {}
          //END DELETE
          $q.all(waitForDelete).then(function (responses) {
            var waitForNewData = [];

            // START CREATE NEW DATA
            if (insurance.form_object) {
              if (!old_form_data) {
                var old_form_data = {};
              }
              old_form_data.policy = insurance.url;
              if (insurance.form_object.form) {
                old_form_data.url = insurance.form_object.form.url;
              }
              old_form_data.sub_branch = insurance.subramo.url;
              // waitForNewData.push(formService);

              var code = insurance.form_code;
              if (code === 2 || code === 3 || code === 4) {
                var personal_obj = {
                  first_name: insurance.form_object.personal.first_name,
                  last_name: insurance.form_object.personal.last_name,
                  second_last_name:
                    insurance.form_object.personal.second_last_name,
                  sex: insurance.form_object.personal.sex,
                  birthdate: insurance.form_object.personal.birthdate,
                  antiguedad: insurance.form_object.personal.antiguedad,
                  policy_type: insurance.form_object.personal.policy_type,
                };
                waitForNewData.push(
                  $http.patch(insurance.form_object.personal.url, personal_obj)
                );

                insurance.form_object.relationships.forEach(function (
                  relationship
                ) {
                  if (relationship.url) {
                    var relationship_obj = {
                      first_name: relationship.first_name,
                      last_name: relationship.last_name,
                      second_last_name: relationship.second_last_name,
                      sex: relationship.sex.value,
                      // birthdate: relationship.birthdate,
                      birthdate: relationship.birthdate
                        ? new Date(datesFactory.toDate(relationship.birthdate))
                        : new Date(),
                      antiguedad: relationship.antiguedad
                        ? new Date(datesFactory.toDate(relationship.antiguedad))
                        : new Date(),
                      relationship: relationship.relationship.relationship,
                    };
                    waitForNewData.push(
                      $http.patch(relationship.url, relationship_obj)
                    );
                  } else {
                    var relationship_obj = {
                      first_name: relationship.first_name,
                      last_name: relationship.last_name,
                      second_last_name: relationship.second_last_name,
                      sex: relationship.sex.value,
                      // birthdate: relationship.birthdate,
                      birthdate: relationship.birthdate
                        ? new Date(datesFactory.toDate(relationship.birthdate))
                        : new Date(),
                      antiguedad: relationship.antiguedad
                        ? new Date(datesFactory.toDate(relationship.antiguedad))
                        : new Date(),
                      relationship: relationship.relationship.relationship,
                      accident: insurance.old_form,
                    };
                    waitForNewData.push(
                      $http.post(globalVar.relationships, relationship_obj)
                    );
                  }
                });
              } else if (code == 1) {
                // var personal_obj={
                //   first_name: insurance.form_object.personal.first_name,
                //   last_name: insurance.form_object.personal.last_name,
                //   second_last_name: insurance.form_object.personal.second_last_name,
                //   sex: insurance.form_object.personal.sex,
                //   birthdate: new Date(datesFactory.toDate(insurance.form_object.personal.birthdate)),
                // }

                // waitForNewData.push($http.patch(insurance.form_object.personal.url,personal_obj));
                // Inicio personal_life nuevo
                // insurance.form_object.personal.forEach(function(item){

                //   if(item.url){

                //     var personal_obj = {
                //       first_name: item.first_name ? item.first_name : "",
                //       last_name: item.last_name ? item.last_name : "",
                //       second_last_name: item.second_last_name ? item.second_last_name : "",
                //       birthdate: item.birthdate ? new Date(datesFactory.toDate(item.birthdate)) : new Date(),
                //       sex : item.sex ? item.sex : "",
                //       smoker : item.smoker ? item.smoker : false,
                //     }
                //     if (personal_obj.smoker == 'True') {
                //       personal_obj.smoker = true
                //     }
                //     else if (personal_obj.smoker == 'False') {
                //       personal_obj.smoker = false
                //     }

                //     waitForNewData.push($http.patch(item.url, personal_obj));
                //   }

                //   else{

                //      var personal_obj = {
                //       first_name: item.first_name ? item.first_name : "",
                //       last_name: item.last_name ? item.last_name : "",
                //       second_last_name: item.second_last_name ? item.second_last_name : "",
                //       birthdate: item.birthdate ? new Date(datesFactory.toDate(item.birthdate)) : new Date(),
                //       policy: insurance.url,
                //       smoker : item.smoker ? item.smoker : false,
                //     }
                //     if (personal_obj.smoker == 'True') {
                //       personal_obj.smoker = true
                //     }
                //     else if (personal_obj.smoker == 'False') {
                //       personal_obj.smoker = false
                //     }
                //     waitForNewData.push($http.post(globalVar.personal, personal_obj));
                //   }

                // });
                if (insurance.form_object.personal) {
                  insurance.form_object.personal.forEach(function (item) {
                    if (item.url) {
                      var personal_obj = {
                        first_name: item.first_name ? item.first_name : "",
                        last_name: item.last_name ? item.last_name : "",
                        second_last_name: item.second_last_name
                          ? item.second_last_name
                          : "",
                        birthdate: item.birthdate
                          ? new Date(datesFactory.toDate(item.birthdate))
                          : new Date(),
                        antiguedad: item.antiguedad
                          ? new Date(datesFactory.toDate(item.antiguedad))
                          : new Date(),
                        sex: item.sex ? item.sex : "",
                        smoker: item.smoker ? item.smoker : false,
                        policy_type: item.policy_type,
                      };
                      if (personal_obj.smoker == "True") {
                        personal_obj.smoker = true;
                      } else if (personal_obj.smoker == "False") {
                        personal_obj.smoker = false;
                      }

                      waitForNewData.push(
                        $http
                          .patch(item.url, personal_obj)
                          .then(function (personalInfo) {
                            if (personalInfo) {
                              var personalInfo = personalInfo;
                              if (
                                insurance.old_form == undefined ||
                                !insurance.old_form
                              ) {
                                var model = {
                                  sub_branch: insurance.subramo.url
                                    ? insurance.subramo.url
                                    : insurance.subramo,
                                  policy: insurance.url,
                                  personal: personalInfo.data.url,
                                  smoker: personalInfo.data.smoker,
                                };
                                generalService
                                  .lifeForm(model)
                                  .then(function (lifeFormData) {
                                    if (lifeFormData) {
                                      insurance.old_form =
                                        lifeFormData.data.url;
                                      return;
                                    }
                                  });
                              }
                            }
                          })
                      );
                    } else {
                      var personal_obj = {
                        first_name: item.first_name ? item.first_name : "",
                        last_name: item.last_name ? item.last_name : "",
                        second_last_name: item.second_last_name
                          ? item.second_last_name
                          : "",
                        birthdate: item.birthdate
                          ? new Date(datesFactory.toDate(item.birthdate))
                          : new Date(),
                        antiguedad: item.antiguedad
                          ? new Date(datesFactory.toDate(item.antiguedad))
                          : new Date(),
                        policy: insurance.url,
                        smoker: insurance.smoker ? insurance.smoker : false,
                        policy_type: item.policy_type,
                      };
                      if (personal_obj.smoker == "True") {
                        personal_obj.smoker = true;
                      } else if (personal_obj.smoker == "False") {
                        personal_obj.smoker = false;
                      }
                      waitForNewData.push(
                        $http
                          .post(globalVar.personal, personal_obj)
                          .then(function (personalInfo) {
                            if (personalInfo) {
                              var personalInfo = personalInfo;
                              if (
                                insurance.old_form == undefined ||
                                !insurance.old_form
                              ) {
                                var model = {
                                  sub_branch: insurance.subramo.url
                                    ? insurance.subramo.url
                                    : insurance.subramo,
                                  policy: insurance.url,
                                  personal: personalInfo.data.url,
                                  smoker: personalInfo.data.smoker,
                                };
                                generalService
                                  .lifeForm(model)
                                  .then(function (lifeFormData) {
                                    if (lifeFormData) {
                                      insurance.old_form =
                                        lifeFormData.data.url;
                                      return;
                                    }
                                  });
                              }
                            }
                          })
                      );
                    }
                  });
                }
                // fin personal nuevo

                insurance.form_object.relationships.forEach(function (item) {
                  if (item.url) {
                    var relationship_obj = {
                      first_name: item.first_name ? item.first_name : "",
                      last_name: item.last_name ? item.last_name : "",
                      second_last_name: item.second_last_name
                        ? item.second_last_name
                        : "",
                      optional_relationship: item.optional_relationship
                        ? item.optional_relationship
                        : "",
                      birthdate: item.birthdate
                        ? new Date(datesFactory.toDate(item.birthdate))
                        : new Date(),
                      antiguedad: item.antiguedad
                        ? new Date(datesFactory.toDate(item.antiguedad))
                        : new Date(),
                      sex: item.sex ? item.sex : "",
                      percentage: item.percentage ? item.percentage : 100,
                      person: item.person,
                      rfc: item.rfc ? item.rfc : "",
                      j_name: item.j_name ? item.j_name : "",
                    };

                    waitForNewData.push(
                      $http.patch(item.url, relationship_obj)
                    );
                  } else {
                    var relationship_obj = {
                      first_name: item.first_name ? item.first_name : "",
                      last_name: item.last_name ? item.last_name : "",
                      second_last_name: item.second_last_name
                        ? item.second_last_name
                        : "",
                      optional_relationship: item.optional_relationship
                        ? item.optional_relationship
                        : "",
                      birthdate: item.birthdate
                        ? new Date(datesFactory.toDate(item.birthdate))
                        : new Date(),
                      antiguedad: item.antiguedad
                        ? new Date(datesFactory.toDate(item.antiguedad))
                        : new Date(),
                      sex: item.sex ? item.sex : "",
                      percentage: item.percentage ? item.percentage : 100,
                      person: item.person,
                      rfc: item.rfc ? item.rfc : "",
                      j_name: item.j_name ? item.j_name : "",
                      life: insurance.old_form,
                    };

                    waitForNewData.push(
                      $http.post(globalVar.beneficiaries, relationship_obj)
                    );
                  }
                });
              }

              if (code === 9) {
                var automobile = {
                  brand: insurance.form_object.form.brand,
                  model: insurance.form_object.form.model,
                  year: insurance.form_object.form.year,
                  version: insurance.form_object.form.version,
                  serial: insurance.form_object.form.serial,
                  engine: insurance.form_object.form.engine,
                  color: insurance.form_object.form.color,
                  license_plates: insurance.form_object.form.license_plates,
                  mont_adjustment: insurance.form_object.form.mont_adjustment,
                  adjustment: insurance.form_object.form.adjustment,
                  mont_special_team:
                    insurance.form_object.form.mont_special_team,
                  special_team: insurance.form_object.form.special_team,
                  beneficiary_name: insurance.form_object.form.beneficiary_name,
                  beneficiary_address:
                    insurance.form_object.form.beneficiary_address,
                  beneficiary_rfc: insurance.form_object.form.beneficiary_rfc,
                  policy_type: insurance.form_object.form.policy_type,
                };
                if (insurance.form_object.form.url) {
                  waitForNewData.push(
                    $http.patch(insurance.form_object.form.url, automobile)
                  );
                }
              } else {
                if (insurance.form_object.form) {
                  var data = {
                    insured_item: insurance.form_object.form.insured_item,
                    item_address: insurance.form_object.form.item_address,
                    item_details: insurance.form_object.form.item_details,
                    damage_type: insurance.form_object.form.damage_type,
                  };

                  $http.patch(insurance.form_object.form.url, data);
                } else {
                }
              }
            } else if (insurance.update_form) {
              $http.patch(insurance.update_form.url, insurance.update_form);
            }
            // PRUEBAAAA
            // insurance.old_coverages.forEach(function(old_coverage) {
            //
            //   insurance.coverages.forEach(function(nv) {
            //
            //     if ((old_coverage.coverage_name == nv.coverage_name) && (nv.policy == insurance.url)) {
            //
            //     }
            //   })
            //   // waitForDelete.push(coverageService.deleteCoverageByUri(old_coverage.url));
            // });
            // ORIGINAL
            insurance.coverages.forEach(function (niu) {
              if (niu.sumInPolicy) {
                if (niu.sumInPolicy.label) {
                  var sum_in_policy = niu.sumInPolicy.label;
                } else if (niu.sumInPolicy.value) {
                  var sum_in_policy = niu.sumInPolicy.value;
                } else {
                  var sum_in_policy = 0;
                }
              }

              if (niu.deductibleInPolicy) {
                if (niu.deductibleInPolicy.label) {
                  var ded_in_policy = niu.deductibleInPolicy.label;
                } else if (niu.sumInPolicy.value) {
                  var ded_in_policy = niu.deductibleInPolicy.value;
                } else {
                  var ded_in_policy = 0;
                }
              }

              if (niu.coinsuranceInPolicy) {
                if (niu.coinsuranceInPolicy.value) {
                  var coi_in_policy = niu.coinsuranceInPolicy.value;
                }
              }

              if (niu.topeCoinsuranceInPolicy) {
                if (niu.topeCoinsuranceInPolicy.value) {
                  var topecoi_in_policy = niu.topeCoinsuranceInPolicy.value;
                }
              }
              var newCvg = {
                policy: insurance.url,
                package: insurance.paquete.url,
                coverage_name: niu.coverage_name ? niu.coverage_name : "",
                priority: niu.priority ? niu.priority : 0,
                deductible: ded_in_policy ? ded_in_policy : 0,
                sum_insured: sum_in_policy ? sum_in_policy : 0,
                prima: niu.primaInPolicy ? niu.primaInPolicy : 0,
                // coinsurance: niu.coinsuranceInPolicy ? niu.coinsuranceInPolicy : ''
                coinsurance: niu.coinsuranceInPolicy ? coi_in_policy : 0,
                topecoinsurance: niu.topeCoinsuranceInPolicy
                  ? topecoi_in_policy
                  : 0,
              };
              waitForNewData.push(
                coverageService.createCoberturaPoliza(newCvg)
              );
            });

            var receipt_array = [];
            var nr;
            var recibo_tipo;
            var owner_id;
            var saveReceiptUrlRequest;
            insurance.receipts.forEach(function (receipt, index) {
              if (receipt.receipt_type != 2) {
                if (receipt.recibo_numero) {
                  nr = receipt.recibo_numero;
                  recibo_tipo = receipt.receipt_type;
                  owner_id = receipt.rp_owner_id;
                } else {
                  nr = index + 1;
                  recibo_tipo = 1;
                  owner_id = null;
                }
                var saveReceiptRequest = {
                  poliza: insurance.url,
                  recibo_numero: nr,
                  prima_neta: receipt.prima,
                  rpf: receipt.rpf,
                  derecho: receipt.derecho,
                  iva: receipt.iva,
                  sub_total: receipt.subTotal,
                  prima_total: receipt.total,
                  status: receipt.status,
                  fecha_inicio: receipt.startDate,
                  fecha_fin: receipt.endingDate,
                  description: "",
                  receipt_type: recibo_tipo,
                  rp_owner_id: owner_id,
                  pay_form: receipt.pay_form,
                  pay_doc: receipt.pay_doc,
                  curr_rate: receipt.curr_rate,
                  bank: receipt.bank,
                  delivered: receipt.delivered ? receipt.delivered : false,
                  isActive: false,
                };
                saveReceiptUrlRequest = {
                  poliza: insurance.url,
                };

                // receipt_array.push(saveReceiptRequest);
                if (insurance.old_receipts.length > 0) {
                  for (var i = 0; i < insurance.old_receipts.length; i++) {
                    if (
                      nr == insurance.old_receipts[i].recibo_numero &&
                      insurance.old_receipts[i].receipt_type == 1
                    ) {
                      $http.patch(
                        insurance.old_receipts[i].url,
                        saveReceiptRequest
                      );
                    } else {
                      $http.patch(
                        insurance.old_receipts[i].url,
                        saveReceiptUrlRequest
                      );
                    }
                  }
                } else {
                  receiptService.createReceiptService(saveReceiptRequest);
                }
              } else {
              }
            });
            $q.all(waitForNewData).then(function (responses) {
              getInsuranceRead(insurance).then(function (response) {
                // setTimeout(function() {
                //   if (insurance.old_receipts.length > 0) {
                //     waitForDelete.push(receiptService.deleteReceipts(insurance.old_receipts));
                //   }
                // }, 1000);
                dfd.resolve(response);
              });
            }, catchIt);

            //END CREATE NEW DATA
          }, catchIt);
        });

      function catchIt(error) {
        dfd.reject(error);
      }

      return dfd.promise;
    }

    function updateInsurance(data) {
      if (!data.id) {
        return $http
          .put(data.url, data)
          .then(updateInsuranceComplete)
          .catch(updateInsuranceFailed);
      }

      return $http
        .put(url.IP + "polizas/" + data.id + "/", data)
        .then(updateInsuranceComplete)
        .catch(updateInsuranceFailed);

      function updateInsuranceComplete(response) {
        return response;
      }

      function updateInsuranceFailed(error) {
        return error;
      }
    }

    function deleteInsurance() {}

    function getFiles(insurance) {
      return fileService.getFiles(
        url.IP + "polizas/" + insurance.id + "/archivos/"
      );
      /*
      return $http.get(url.IP + 'polizas/' + insurance.id + '/archivos/')
          .then(getFilesComplete)
          .catch(getFilesFailed);

      function getFilesComplete(response) {
          return response;
      }

      function getFilesFailed(error) {
          return error;
      }*/
    }

    function getPolicyAndEndorsement(parData) {
      return $http.get(parData.req).then(function (insuranceRes) {
        return getInsuranceData(insuranceRes.data).then(function (res) {
          return $http.get(parData.endo).then(function (folioRes) {
            return { endorsement: res, original: folioRes.data };
          });
        });
      });
    }

    function getRequestData(insurance, endorsement) {
      var dfd = $q.defer();
      getInsuranceData(insurance).then(function (insuranceData) {
        var requestData = {
          address: endorsement.address,
          clave: endorsement.clave,
          payment: { value: endorsement.forma_de_pago.value },
          //Data to stay the same
          id: insurance.id,
          internal_number: insurance.internal_number,
          url: insurance.url,
          type: "",
          status: insurance.status,
          ramo: endorsement.ramo,
          subramo: endorsement.subramo,
          paquete: endorsement.paquete,
          poliza: insurance.poliza_number,
          polizaId: url.IP + "leer-polizas/" + insurance.id + "/",
          observations: insurance.observations,
          folio: insurance.folio,
          endingDate: new Date(insurance.end_of_validity),
          startDate: new Date(insurance.start_of_validity),
          aseguradora: endorsement.aseguradora, // object
          contratante: endorsement.juridical
            ? endorsement.juridical
            : endorsement.natural, // object
          form_code: insurance.subramo,
          //DATA TO ADD
          receipts: [], // endorsement.recibos_poliza,
          coverages: endorsement.coverageInPolicy_policy, // array
          //Data to delete
          old_receipts: insuranceData.recibos_poliza,
          old_coverages: insurance.coverageInPolicy_policy,
          old_policies: insurance.old_policies,
          update_form:
            endorsement.accidents_policy.length > 0
              ? endorsement.accidents_policy[0]
              : endorsement.automobiles_policy.length > 0
              ? endorsement.automobiles_policy[0]
              : endorsement.damages_policy.length > 0
              ? endorsement.damages_policy[0]
              : endorsement.life_policy.length > 0
              ? endorsement.life_policy[0]
              : undefined,
          old_form:
            insurance.accidents_policy.length > 0
              ? insurance.accidents_policy[0].url
              : insurance.automobiles_policy.length > 0
              ? insurance.automobiles_policy[0].url
              : insurance.damages_policy.length > 0
              ? insurance.damages_policy[0].url
              : insurance.life_policy.length > 0
              ? insurance.life_policy[0].url
              : undefined,
        };

        requestData.coverages.forEach(function (coverage) {
          coverage.deductibleInPolicy = { label: coverage.deductible };
          coverage.sumInPolicy = { label: coverage.sum_insured };
          coverage.primaInPolicy = coverage.prima;
          coverage.coinsuranceInPolicy = coverage.coinsurance;
          coverage.topeCoinsuranceInPolicy = coverage.topecoinsurance;
        });

        endorsement.recibos_poliza.forEach(function (recibo, index) {
          var reciboNuevo = {
            startDate: new Date(recibo.fecha_inicio),
            endingDate: new Date(recibo.fecha_fin),
            total: recibo.prima_total,
            subTotal: recibo.sub_total,
            iva: recibo.iva,
            derecho: recibo.derecho,
            rpf: recibo.rpf,
            prima: recibo.prima_neta,
            recibo_numero: recibo.recibo_numero,
            status: recibo.status,
            receipt_type: recibo.receipt_type,
            rp_owner_id: recibo.rp_owner_id,
            pay_form: recibo.pay_form,
            pay_doc: recibo.pay_doc,
            curr_rate: recibo.curr_rate,
            bank: recibo.bank,
          };
          requestData.receipts.push(reciboNuevo);
        });

        requestData.update_form.id = undefined;
        requestData.update_form.damage_type = undefined;

        requestData.update_form.policy = undefined;
        requestData.update_form.url = angular.copy(requestData.old_form);
        if (requestData.update_form.personal) {
          requestData.update_form.personal =
            requestData.update_form.personal.url;
        }

        requestData.old_form = undefined;
        dfd.resolve(requestData);
      });

      return dfd.promise;
    }

    function applyEndorsement(req) {
      var dfd = $q.defer();

      var original = req.original;
      var endorsement = req.endorsement;
      getRequestData(original, endorsement).then(function (requestData) {
        requestData.endorsementedUrl = endorsement.url;
        updateFullInsurance(requestData).then(function (response) {
          dfd.resolve(response);
        });
      });
      return dfd.promise;
    }

    function applyBackupEndorsement(req) {
      var dfd = $q.defer();
      var original = req.endorsement;
      var endorsement = req.original;
      getRequestData(original, endorsement).then(function (requestData) {
        updateFullInsurance(requestData).then(function (response) {
          dfd.resolve(response);
        });
      });
      return dfd.promise;
    }

    function getRequestBackupData(insurance, endorsement) {
      var dfd = $q.defer();
      ContratanteService.getContratantes().then(function (contratantes) {
        getInsuranceDataBackup(insurance).then(function (insuranceData) {
          var contratanteName;
          var typePerson;
          if (endorsement.juridical) {
            contratanteName = endorsement.juridical;
            typePerson = "juridical";
          } else {
            contratanteName = endorsement.natural;
            typePerson = "natural";
          }
          var contratant;

          for (var i = 0; i < contratantes.length; i++) {
            if (typePerson == "juridical") {
              if (contratantes[i].j_name == contratanteName) {
                contratant = contratantes[i];
              }
            } else {
              var name_natural =
                contratantes[i].first_name + " " + contratantes[i].last_name;
              if (name_natural == contratanteName) {
                contratant = contratantes[i];
              }
            }
          }

          var wait = [];
          var address;
          var clave;
          wait.push($http.get(endorsement.address));
          wait.push($http.get(endorsement.clave));
          $q.all(wait).then(function (data) {
            data.forEach(function (addressData) {
              if (addressData.data.route) {
                address = addressData.data;
              } else if (addressData.data.clave) {
                clave = addressData.data;
              }
            });
            // address=addressData.data
            var requestData = {
              address: address,
              clave: clave,
              payment: { value: endorsement.forma_de_pago.value },
              //Data to stay the same
              id: insurance.id,
              internal_number: insurance.internal_number,
              url: insurance.url,
              type: "",
              status: insurance.status,
              ramo: endorsement.ramo,
              subramo: endorsement.subramo,
              paquete: endorsement.paquete,
              poliza: insurance.poliza_number,
              polizaId: url.IP + "leer-polizas/" + insurance.id + "/",
              observations: endorsement.observations,
              folio: insurance.folio,
              endingDate: new Date(insurance.end_of_validity),
              startDate: new Date(insurance.start_of_validity),
              aseguradora: endorsement.aseguradora, // object

              contratante: contratant, // object
              form_code: insurance.subramo,
              //DATA TO ADD
              receipts: [], // endorsement.recibos_poliza,
              coverages: endorsement.coverageInPolicy_policy, // array
              //Data to delete
              old_receipts: insuranceData.recibos_poliza,
              old_coverages: insurance.coverageInPolicy_policy,
              old_policies: insurance.old_policies,
              update_form:
                endorsement.accidents_policy.length > 0
                  ? endorsement.accidents_policy[0]
                  : endorsement.automobiles_policy.length > 0
                  ? endorsement.automobiles_policy[0]
                  : endorsement.damages_policy.length > 0
                  ? endorsement.damages_policy[0]
                  : endorsement.life_policy.length > 0
                  ? endorsement.life_policy[0]
                  : undefined,
              old_form:
                insurance.accidents_policy.length > 0
                  ? insurance.accidents_policy[0].url
                  : insurance.automobiles_policy.length > 0
                  ? insurance.automobiles_policy[0].url
                  : insurance.damages_policy.length > 0
                  ? insurance.damages_policy[0].url
                  : insurance.life_policy.length > 0
                  ? insurance.life_policy[0].url
                  : undefined,
            };
            requestData.coverages.forEach(function (coverage) {
              coverage.deductibleInPolicy = { label: coverage.deductible };
              coverage.sumInPolicy = { label: coverage.sum_insured };
              coverage.primaInPolicy = coverage.prima;
              coverage.coinsuranceInPolicy = coverage.coinsurance;
              coverage.topeCoinsuranceInPolicy = coverage.topecoinsurance;
            });

            endorsement.recibos_poliza.forEach(function (receipt, index) {
              receiptService
                .getReceiptsByUriService(receipt)
                .then(function (recibo) {
                  var reciboNuevo = {
                    startDate: new Date(recibo.fecha_inicio),
                    endingDate: new Date(recibo.fecha_fin),
                    total: recibo.prima_total,
                    subTotal: recibo.sub_total,
                    iva: recibo.iva,
                    derecho: recibo.derecho,
                    rpf: recibo.rpf,
                    prima: recibo.prima_neta,
                    recibo_numero: recibo.recibo_numero,
                    status: recibo.status,
                    receipt_type: recibo.receipt_type,
                    rp_owner_id: recibo.rp_owner_id,
                    pay_form: recibo.pay_form,
                    pay_doc: recibo.pay_doc,
                    curr_rate: recibo.curr_rate,
                    bank: recibo.bank,
                  };
                  requestData.receipts.push(reciboNuevo);
                });
            });

            requestData.update_form.id = undefined;
            requestData.update_form.damage_type = undefined;

            requestData.update_form.policy = undefined;
            requestData.update_form.url = angular.copy(requestData.old_form);
            if (requestData.update_form.personal) {
              requestData.update_form.personal =
                requestData.update_form.personal.url;
            }

            requestData.old_form = undefined;
            //parsing subform
            dfd.resolve(requestData);

            //termina
          });
        });
      });

      return dfd.promise;
    }

    function getInsuranceDataBackup(insurance) {
      var recibos = [];
      files = [];

      var dfd = $q.defer();
      var uri = url.IP + "polizas/" + insurance.id + "/";
      var insuranceComplete = {};
      var things = 0;
      var thingsToLoad = 1; // the insurance

      $http
        .get(uri)
        .then(function (insuranceResponse) {
          if (checkResponse(insuranceResponse)) {
            return;
          }

          var insuranceEmpty = insuranceResponse.data;
          insuranceEmpty.coverageInPolicy_policy =
            insurance.coverageInPolicy_policy;
          insuranceEmpty.read = insurance;

          insuranceComplete = angular.copy(insuranceEmpty);

          // polizas viejas
          thingsToLoad += insurance.old_policies.length;
          insuranceComplete.old_policies = [];
          insurance.old_policies.forEach(function (old_policy) {
            $http.get(old_policy.url).then(function (obj) {
              $http.get(obj.data.base_policy).then(function (baseResponse) {
                var data = baseResponse.data;
                data.url_old_policy = data.url;
                data.url = old_policy.url;

                insuranceComplete.old_policies.push(baseResponse.data);
                thingLoaded("p?iza vieja");
              });
            });
          });

          //recibos
          thingsToLoad += insuranceComplete.recibos_poliza.length;
          insuranceComplete.recibos_poliza = [];
          insuranceEmpty.recibos_poliza.forEach(function (receiptUri) {
            receiptService
              .getReceiptsByUriService(receiptUri)
              .then(function (receiptObj) {
                insuranceComplete.recibos_poliza.push(receiptObj);
                thingLoaded("recibo"); // Receipt loaded
              });
          });

          //payform
          thingsToLoad++;
          payform.some(function (form) {
            if ((form.value = insuranceEmpty.forma_de_pago)) {
              insuranceComplete.forma_de_pago = form;
              return true;
            }
          });
          thingLoaded("payform"); // payform loaded

          //provider
          thingsToLoad++;
          providerService
            .getProviderByUri(insuranceEmpty.aseguradora)
            .then(function (providerResponse) {
              if (checkResponse(providerResponse)) {
                return;
              }
              insuranceComplete.aseguradora = providerResponse.data;
              thingLoaded("provider"); // provider loaded
            });

          //ramo
          thingsToLoad++;
          ramoService
            .getRamoByUri(insuranceEmpty.ramo)
            .then(function (ramoResponse) {
              if (checkResponse(ramoResponse)) {
                return;
              }
              insuranceComplete.ramo = ramoResponse.data;
              thingLoaded("ramo");
            });

          //subramo
          thingsToLoad++;
          ramoService
            .getSubramoByUri(insuranceEmpty.subramo)
            .then(function (subramoResponse) {
              if (checkResponse(subramoResponse)) {
                return;
              }
              insuranceComplete.subramo = subramoResponse.data;
              thingLoaded("subramo");
            });

          // package
          if (insuranceEmpty.paquete) {
            thingsToLoad++;
            packageService
              .getPackageByUri(insuranceEmpty.paquete)
              .then(function (packageResponse) {
                if (checkResponse(packageResponse)) {
                  return;
                }
                insuranceComplete.paquete = packageResponse.data;
                thingLoaded("Paquete");
              });
          }

          //

          if (insuranceEmpty.life_policy.length > 0) {
            thingsToLoad += insuranceEmpty.life_policy.length; // cargaremos cada life_policy
            insuranceEmpty.life_policy.forEach(function (elem, index) {
              thingsToLoad += elem.beneficiaries_life.length;
              $http.get(elem.personal).then(function (response) {
                insuranceComplete.life_policy[index].personal = response.data;
                thingLoaded("life_policy");
              });
              elem.beneficiaries_life.forEach(function (ben, benPos) {
                $http.get(ben.life).then(function (response) {
                  insuranceComplete.life_policy[index].beneficiaries_life[
                    benPos
                  ].life = response.data;
                  thingLoaded("beneficiary");
                });
              });
            });
          } else if (insuranceEmpty.accidents_policy.length > 0) {
            thingsToLoad += insuranceEmpty.accidents_policy.length; // cargaremos cada life_policy
            insuranceEmpty.accidents_policy.forEach(function (elem, index) {
              thingsToLoad += elem.relationship_accident.length;
              $http.get(elem.personal).then(function (response) {
                insuranceComplete.accidents_policy[index].personal =
                  response.data;
                thingLoaded("accidents_policy");
              });
              elem.relationship_accident.forEach(function (ben, benPos) {
                $http.get(ben.accident).then(function (response) {
                  insuranceComplete.accidents_policy[
                    index
                  ].relationship_accident[benPos].accident = response.data;
                  thingLoaded("relationship_accident");
                });
              });
            });
          }

          // contractor
          thingsToLoad++;
          if (insuranceEmpty.juridical) {
            ContratanteService.getContratanteByUri(
              insuranceEmpty.juridical
            ).then(function (contractorResponse) {
              if (checkResponse(contractorResponse)) {
                return;
              }
              insuranceComplete.juridical = contractorResponse.data;
              $http
                .get(insuranceComplete.juridical.group)
                .then(function (response) {
                  insuranceComplete.juridical.group = response.data;
                  thingLoaded("juridical");
                });
            });
          }

          if (insuranceEmpty.natural) {
            ContratanteService.getContratanteByUri(insuranceEmpty.natural).then(
              function (contractorResponse) {
                if (checkResponse(contractorResponse)) {
                  return;
                }
                insuranceComplete.natural = contractorResponse.data;
                $http
                  .get(insuranceComplete.natural.group)
                  .then(function (response) {
                    insuranceComplete.natural.group = response.data;
                    thingLoaded("natural");
                  });
              }
            );
          }

          // files
          thingsToLoad++;
          getFiles(insurance).then(function (filesData) {
            insuranceComplete.files = { results: filesData };
            thingLoaded("files");
          });

          thingLoaded("insurance"); // Policy loaded
        })
        .catch(function (error) {
          dfd.reject(error);
        });

      function thingLoaded(what) {
        things++;
        if (things >= thingsToLoad) {
          var initDate = new Date(insuranceComplete.start_of_validity);
          var endingDate = new Date(insuranceComplete.end_of_validity);

          initDate = new Date(
            initDate.getTime() + initDate.getTimezoneOffset() * 60000
          );
          endingDate = new Date(
            endingDate.getTime() + endingDate.getTimezoneOffset() * 60000
          );

          insuranceComplete.start_of_validity = initDate;
          insuranceComplete.end_of_validity = endingDate;

          dfd.resolve(insuranceComplete);
        }
      }

      function checkResponse(response) {
        if (response.status < 200 || response.status >= 300) {
          dfd.reject(response);
          return true;
        }
        return false;
      }

      return dfd.promise;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("PolizasPlantillasCtrl", PolizasPlantillasCtrl);

  PolizasPlantillasCtrl.$inject = [
    "$timeout",
    "$scope",
    "$sce",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "$sessionStorage",
    "$uibModal",
    "textAngularManager",
    "FileUploader",
    "$rootScope",
  ];

  function PolizasPlantillasCtrl(
    $timeout,
    $scope,
    $sce,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    $sessionStorage,
    $uibModal,
    textAngularManager,
    FileUploader,
    $rootScope
  ) {
    var vm = this;
    $scope.showQuotation = false;
    $scope.showInfoQuotation = false;
    $scope.showEditInformation = false;
    $scope.plantilla = {};
    $scope.savingPlantilla = false;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.configuracionGlobal = {
      fecha_limite_email: false,
    };
    $(".js-example-basic-multiple").select2();
    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    $scope.allRamos = [];
    $scope.allRamos = [
      {
        code: 1,
        descr: "Vida",
      },
      {
        code: 2,
        descr: "Accidentes y Enfermedades",
      },
      {
        code: 3,
        descr: "Daños",
      },
      {
        code: 9,
        descr: "Daños/Automóviles",
      },
    ];
    $scope.createQuotation = function () {
      $scope.plantilla = {};
      $scope.showEditInformation = false;
      $scope.showQuotation = true;
      $scope.plantilla.subject_default = false;
    };
    $scope.subject_default = false;
    $scope.closeTemplate = function () {
      $scope.showQuotation = false;
      $scope.plantilla = {};
    };
    $scope.isReadOnly = true;
    activate();

    $scope.cambiarCampos = function () {
      $scope.configuracionGlobal = {};
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
        }
      });
      $scope.configurar = !$scope.configurar;
    };
    $scope.cambiarDato = function (dato, valor) {
      var data = {};
      data[dato.toString()] = valor;
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, data)
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory.post("orginfo/", data).then(function success(response) {
            if (response.status == 201) {
              $scope.configuracionGlobal = response.data;
              SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
              return;
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
            } else {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            }
          });
        }
      }
    };
    function activate() {
      dataFactory
        .get("emailtemplate/", { template_model: 2 })
        .then(function success(response) {
          vm.quotations = response.data.results;
          vm.config_pagination = response.data;
          $scope.show_pagination = true;
        });
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
        }
      });
    }

    $scope.selectProv = function (sel) {
      $scope.ramos_code = [];
      $scope.plantilla.ramo_code.forEach(function (cl) {
        $scope.ramos_code.push(parseInt(cl.code));
      });
    };

    function isBlankText(html) {
      if (!html) {
        return true;
      }
      var stripped = html.replace(/<[^>]+>/g, "");
      stripped = stripped.replace(/&nbsp;/g, "");
      stripped = stripped.replace(/\s/g, "");
      return stripped.length === 0;
    }

    $scope.showInformation = function (item) {
      if (item) {
        $scope.showInfoQuotation = !$scope.showInfoQuotation;
        $scope.quotation = item;
      } else {
        $scope.showInfoQuotation = !$scope.showInfoQuotation;
      }
    };

    $scope.saveDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (
        !form ||
        !form.name ||
        !form.ramo_code ||
        !form.ramo_code.length ||
        !form.text ||
        !form.bottom_text ||
        !$scope.ramos_code ||
        !$scope.ramos_code.length ||
        (!form.subject_default && !form.title)
      ) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de continuar.",
          "warning"
        );
        return;
      }

      if (isBlankText(form.text) || isBlankText(form.bottom_text)) {
        SweetAlert.swal(
          "Error",
          "El texto superior e inferior no pueden estar vacíos.",
          "warning"
        );
        return;
      }

      form.template_model = 2;
      form.ramo_code = $scope.ramos_code;
      $scope.savingPlantilla = true;

      dataFactory
        .post("emailtemplate/", form)
        .then(function success(response) {
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla guardada correctamente.",
            "success"
          );
          $scope.closeTemplate();
          activate();
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };
    $scope.cahngeFechaLimiteEmail = function (val) {
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, {
              fecha_limite_email: $scope.configuracionGlobal.fecha_limite_email,
            })
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory
            .post("orginfo/", {
              fecha_limite_email: $scope.configuracionGlobal.fecha_limite_email,
            })
            .then(function success(response) {
              if (response.status == 201) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
      }
    };
    $scope.updateDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (
        !form ||
        !form.name ||
        !form.text ||
        !form.bottom_text ||
        !form.ramo_code ||
        !form.ramo_code.length ||
        !$scope.ramos_code ||
        !$scope.ramos_code.length ||
        (!form.subject_default && !form.title)
      ) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de actualizar.",
          "warning"
        );
        return;
      }

      if (isBlankText(form.text) || isBlankText(form.bottom_text)) {
        SweetAlert.swal(
          "Error",
          "El texto superior e inferior no pueden estar vacíos.",
          "warning"
        );
        return;
      }

      $scope.savingPlantilla = true;

      var data = {
        name: form.name,
        title: form.title,
        text: form.text,
        bottom_text: form.bottom_text,
        subject_default: form.subject_default,
        ramo_code: $scope.ramos_code,
      };
      $http
        .patch(form.url, data)
        .then(function success(response) {
          $scope.showEditInformation = false;
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla actualizada correctamente.",
            "success"
          );
          $scope.closeTemplate();
          activate();
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.borrarPlantilla = function (item) {
      if (!item || !item.url) {
        return;
      }
      SweetAlert.swal(
        {
          title: "¿Confirmas la eliminación?",
          text: "La plantilla se eliminará permanentemente.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí, borrar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }
          $http
            .delete(item.url)
            .then(function success() {
              SweetAlert.swal(
                "¡Listo!",
                "Plantilla eliminada correctamente.",
                "success"
              );
              activate();
            })
            .catch(function () {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            });
        }
      );
    };

    $scope.editQuatation = function (form) {
      $scope.ramos_code = [];
      $scope.plantilla.name = form.name;
      $scope.plantilla.title = form.title;
      $scope.plantilla.text = form.text;
      $scope.plantilla.bottom_text = form.bottom_text;
      $scope.plantilla.url = form.url;
      $scope.plantilla.ramo_code = [];
      $scope.plantilla.subject_default = form.subject_default;
      $scope.showQuotation = true;
      $scope.showEditInformation = true;
      if (form.ramo_code) {
        var convertedCodes = form.ramo_code.map(function (code) {
          return parseInt(code);
        });
        // $scope.plantilla.ramo_code = form.ramo_code;
        convertedCodes.forEach(function (cl) {
          $scope.ramos_code.push(parseInt(cl));
          $scope.allRamos.forEach(function (cd) {
            if (parseInt(cd.code) == cl) {
              $scope.plantilla.ramo_code.push(cd);
            }
          });
        });
        $timeout(function () {
          $("#ramoSelect").select2();
        }, 0);
      }
    };
    $scope.$watch("plantilla.ramo_code", function (newValues, oldValues) {
      if (newValues !== oldValues) {
        $timeout(function () {
          $("#ramoSelect").trigger("change");
        }, 0);
      }
    });
    $scope.focusEditor = function () {
      $scope.editor_focus = true;
    };

    $scope.unfocusEditor = function () {};

    $scope.getFile = function () {
      var editor = textAngularManager.retrieveEditor("myEditorCreate").scope;
      editor.displayElements.text.trigger("focus");

      var modalInstance = $uibModal.open({
        template:
          '<label class="col-xs-12 btn btn-info">Agregar Imagen desde PC' +
          '<input multiple nv-file-select="" type="file" name="xyz" uploader="uploader" accept=".jpg" class="display-none"/>' +
          "</label>",
        // size: 'sm',
        controller: ModalInstanceFileCtrl,
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (imgUrl) {
        var imageLink;
        imageLink = $rootScope.image_url;
        var embed = '<img src="' + imageLink + ' ">';
        // return textAngular.$editor().wrapSelection('insertHTML', embed, true);

        var editor = textAngularManager.retrieveEditor("myEditorCreate");
        editor.scope.wrapSelection("insertHTML", embed, true);
      });
    };
    function ModalInstanceFileCtrl($scope, $rootScope, $uibModalInstance) {
      $scope.userInfo = {
        id: 0,
      };
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        allowedFileType: ["png", "jpg", "jpeg"],
      }));

      $scope.userInfo.url = $scope.uploader.url = url.IP + "plantillas-html/";
      $scope.uploader.autoUpload = true;
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $rootScope.image_url = response.arch;
        if ($uibModalInstance) {
          $uibModalInstance.close();
        }
      };
      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };
      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });
      };
      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = usr.org;
      };
      $scope.validateFiles = function () {
        var input = document.getElementById("fileInput");
        var files = input.files;
        var totalSize = 0;
        var errorMessageElement = document.getElementById("error-message");
        for (var i = 0; i < files.length; i++) {
          totalSize += files[i].size;
        }
        var totalSizeMB = totalSize / (1024 * 1024);
        if (totalSizeMB > 25) {
          errorMessageElement.style.display = "block";
          errorMessageElement.textContent =
            "La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.";
        } else {
          errorMessageElement.style.display = "none"; // Hide error message if files are valid
        }
      };
      function uploadFiles() {
        $scope.userInfo.url = $scope.uploader.url = url.IP + "plantillas-html/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("PolizasInfoCtrl", PolizasInfoCtrl);

  PolizasInfoCtrl.$inject = [
    "$timeout",
    "FileUploader",
    "providerService",
    "dataFactory",
    "SweetAlert",
    "$scope",
    "$rootScope",
    "MESSAGES",
    "toaster",
    "endorsementService",
    "insuranceService",
    "receiptService",
    "$stateParams",
    "$state",
    "helpers",
    "formService",
    "$http",
    "url",
    "$uibModal",
    "datesFactory",
    "$q",
    "$localStorage",
    "$sessionStorage",
    "statusReceiptsFactory",
    "$sce",
    "formatValues",
    "fileService",
    "emailService",
    "appStates",
    "whatsappWebFlagService",
    "exportFactory",
  ];

  function PolizasInfoCtrl(
    $timeout,
    FileUploader,
    providerService,
    dataFactory,
    SweetAlert,
    $scope,
    $rootScope,
    MESSAGES,
    toaster,
    endorsementService,
    insuranceService,
    receiptService,
    $stateParams,
    $state,
    helpers,
    formService,
    $http,
    url,
    $uibModal,
    datesFactory,
    $q,
    $localStorage,
    $sessionStorage,
    statusReceiptsFactory,
    $sce,
    formatValues,
    fileService,
    emailService,
    appStates,
    whatsappWebFlagService,
    exportFactory
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.orgName = usr.orgname;
    $scope.decrptedtoken = usr;

    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 2;
    //     }
    // });

    $scope.conductos = {
      1: "No domiciliada",
      2: "Agente",
      3: "CAC",
      4: "CAT/Domiciliado",
      5: "Nómina",
      6: "CUT",
    };

    var vm = this;

    vm.whatsappWebEnabled = whatsappWebFlagService.isEnabled();
    whatsappWebFlagService.subscribe(function (enabled) {
      $scope.$evalAsync(function () {
        vm.whatsappWebEnabled = enabled;
      });
    }, $scope);

    vm.pageTitle = "Pólizas";
    vm.insurance = {};
    vm.receipts = [];
    vm.polizaId = $stateParams.polizaId;
    vm.endorsementReceipts = [];
    vm.receipts_manual = 0;
    vm.moveOTState = moveOTState;
    vm.show = {
      isPolicy: false,
    };
    vm.showRecordatorios = showRecordatorios;
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                vm.acceso_canc_pol = true;
              } else {
                vm.acceso_canc_pol = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                vm.acceso_elim_pol = true;
              } else {
                vm.acceso_elim_pol = false;
              }
            } else if (acc.permission_name == "Rehabilitar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_rehabilitar = true;
              } else {
                vm.acceso_adm_rehabilitar = false;
              }
            }
          });
        }
        if (perm.model_name == "Endosos") {
          $scope.acceso_endosos = perm;
          $scope.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                $scope.acceso_adm_end = true;
              } else {
                $scope.acceso_adm_end = false;
              }
            }
          });
        }
        if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                vm.acceso_canc_ot = true;
              } else {
                vm.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar OTs") {
              if (acc.checked == true) {
                vm.acceso_elim_ot = true;
              } else {
                vm.acceso_elim_ot = false;
              }
            } else if (acc.permission_name == "Tablero de OTs") {
              if (acc.checked == true) {
                vm.acceso_tab = true;
              } else {
                vm.acceso_tab = false;
              }
            }
          });
        }
        if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        }
        if (perm.model_name == "Siniestros") {
          vm.acceso_sin = perm;
          vm.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                vm.acceso_adm_sin = true;
              } else {
                vm.acceso_adm_sin = false;
              }
            }
          });
        }
        if (perm.model_name == "Mensajeria") {
          vm.acceso_mns = perm;
          vm.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                vm.acceso_mns = true;
              } else {
                vm.acceso_mns = false;
              }
            }
          });
        }
        if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        }
        if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        }
        if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_canc_pol = false;
                // vm.acceso_desp_cob = false
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            } else if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                vm.acceso_del_cob = true;
              } else {
                vm.acceso_del_cob = false;
              }
            } else if (
              acc.permission_name ==
              "No permitir editar recibos Pagados/Liquidados"
            ) {
              if (acc.checked == true) {
                vm.acceso_pl_cob = true; //no se editan
              } else {
                vm.acceso_pl_cob = false; //se pueden editar pagados-liquidados
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          vm.acceso_ref = perm;
          vm.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                vm.acceso_adm_ref = true;
              } else {
                vm.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                vm.acceso_pag_ref = true;
              } else {
                vm.acceso_pag_ref = false;
              }
            } else if (
              acc.permission_name == "Cambiar refrenciador en pólizas"
            ) {
              if (acc.checked == true) {
                vm.acceso_chg_ref = true;
              } else {
                vm.acceso_chg_ref = false;
              }
            } else if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                vm.acceso_ver_ref = true;
              } else {
                vm.acceso_ver_ref = false;
              }
            }
          });
        }
        if (perm.model_name == "Comisiones") {
          vm.acceso_dash = perm;
          vm.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
            // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                vm.permiso_administrar_adjuntos = true;
                $scope.permiso_administrar_adjuntos = true;
              } else {
                vm.permiso_administrar_adjuntos = false;
                $scope.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }
    // vm.repeat = [];
    //  vm.cg = {
    //   catalog: [],
    //   selectedDocs: [],
    //   loading: false,
    //   saving: false,
    //   selectedIds: [],// <-- ids, no objetos
    // };
    // vm.loadGeneralConditions = loadGeneralConditions;
    // vm.onGeneralConditionsChange = onGeneralConditionsChange;
    // vm.removeGeneralCondition = removeGeneralCondition;
    // vm.isGeneralConditionFile = isGeneralConditionFile;
    activate();
    // functions
    vm.goToEndoso = goToEndoso;
    vm.showNotas = showNotas;
    vm.returnToReceipts = returnToReceipts;
    vm.goToReceipt = goToReceipt;
    vm.deletePolicy = deletePolicy;
    vm.deleteFile = deleteFile;
    vm.assignPolicy = assignPolicy;
    vm.cancelPolicy = cancelPolicy;
    vm.reactivePolicy = reactivePolicy;
    vm.reActivatePolicy = reActivatePolicy;
    vm.showBinnacle = showBinnacle;
    vm.viewContractor = viewContractor;
    vm.showSinisters = showSinisters;
    vm.showEndorsements = showEndorsements;
    vm.showBinnacleReceipt = showBinnacleReceipt;
    vm.getPDF = getPDF;
    vm.viewCarta = viewCarta;
    vm.changeStatusModal = changeStatusModal;
    vm.openRenovateModal = openRenovateModal;
    vm.cancelRenovate = cancelRenovate;
    vm.checkStatusReceipts = checkStatusReceipts;
    vm.changeEndorsement = changeEndorsement;
    vm.user = usr;
    vm.files = [];
    vm.table = {};
    vm.tables = {};
    vm.tablec = {};
    vm.saveAsInsurance = saveAsInsurance;
    vm.returnToInfo = returnToInfo;
    vm.NotasModal = NotasModal;
    vm.getLog = getLog;
    vm.getLogReceipt = getLogReceipt;
    vm.showChange = showChange;
    vm.sendProvider = sendProvider;
    vm.deliveredReceipt = deliveredReceipt;
    vm.delivery = delivery;
    vm.sendEmail1 = sendEmail1;
    vm.showEmail = showEmail;
    vm.editRecibos = editRecibos;
    vm.createReceipts = createReceipts;
    vm.createNotes = createNotes;
    vm.createRecordatorio = createRecordatorio;

    vm.infoFlag = true;
    vm.sinistersFlag = false;
    vm.endoFlag = false;
    vm.notasFlag = false;
    $scope.form = {};
    $scope.form.emails_reminder = [];
    $scope.changeDomiciliado = false;
    vm.recordatoriosFlag = false;
    vm.isCollapsed = false;

    // Function to toggle the collapse state
    vm.toggleCollapse = function () {
      vm.isCollapsed = !vm.isCollapsed;
    };
    $scope.ShowContextMenu = function (name, route) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;

      var params = {
        myInsurance: vm.insurance,
        contractor: $scope.contractorModal,
      };
      if (route == "endorsement.endorsement") {
        $localStorage["save_filters_endoso_poliza"] = {};
        $localStorage["save_filters_endoso_poliza"]["poliza"] =
          vm.insurance.poliza_number;
        $localStorage["save_filters_endoso_poliza"]["poliza_id"] =
          vm.insurance.id;
        $localStorage["save_filters_endoso_poliza"]["origin_endorsement"] =
          vm.insurance;
      }
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.goToEndorsement = function (name, route, endorsement) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;

      var params = { endosoId: endorsement.id };
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.open_in_same_tab_sns = function (name, route, params, identifier) {
      var params = {
        myInsurance: vm.insurance,
        contractor: $scope.contractorModal,
      };
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.createSiniestro = function (contractorModal) {
      $localStorage["save_created_siniester_life"] = {};
      $scope.open_in_same_tab_sns(
        "Crear siniestro",
        "siniestros.create_vida",
        { myInsurance: vm.insurance, contractor: contractorModal },
        vm.insurance
      );
    };
    $scope.createSiniestroDanios = function (contractorModal) {
      $localStorage["save_created_siniester_danios"] = {};
      $scope.open_in_same_tab_sns(
        "Crear siniestro Daños",
        "siniestros.create_danios",
        { myInsurance: vm.insurance, contractor: contractorModal },
        vm.insurance
      );
    };

    $scope.renameFile = function (file, vmFiles) {
      var patch = {
        nombre: file.nombre,
        sensible: file.sensible,
      };
      $http
        .patch(file.url, patch)
        .then(function (response) {
          if (response.status == 403) {
            $http
              .get(file.url)
              .then(function (response) {
                console.log(response);
                file.nombre = response.data;
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.goToPolicy = function (policy) {
      $state.go("colectividades.info", { polizaId: policy.id });
    };
    $scope.getAllCertificates = function (kl) {
      $http({
        method: "POST",
        url: url.IP + "service_reporte_certificados_excel",
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function success(request) {
          if (request.status === 200) {
            var blob = new Blob([request.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte_Certificados.xls");
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      var urls = file.url;
      if (urls == undefined) {
        urls = url.IP + "polizas/" + file.owner + "/archivos/" + file.id;
      }
      $http.patch(urls, { nombre: file.nombre, sensible: file.sensible });
    };

    $scope.changeDomiciliadoValue = function () {
      $scope.change_domiciliado = true;
      if ($scope.newDomiciliado == "true" || $scope.newDomiciliado == true) {
        $scope.domiciliadoSave = true;
      } else {
        $scope.domiciliadoSave = false;
      }
    };
    $scope.changedomiciliadoF = function (chng) {
      if (chng) {
        SweetAlert.swal(
          "Información",
          "Todos los Recibo(s) se actualizarán",
          "info"
        );
      }
      $scope.changeDomiciliado = chng;
      $scope.newDomiciliado = $scope.isCat;
    };
    $scope.saveDomiciliado = function (dom) {
      vm.insurance.recibos_poliza.forEach(function (it) {
        $http.patch(it, { is_cat: dom }).then(function (recibo_cat) {
          $scope.isCat = dom;
          $scope.changeDomiciliado = false;
          SweetAlert.swal("¡Hecho!", "Recibo(s) actualizado(s)", "success");
        });
      });
      $http.patch(url.IP + "polizas/" + vm.insurance.id + "/", {
        domiciliada: dom,
      });
      var paramsRec = {
        model: 1,
        event: "PATCH",
        associated_id: vm.insurance.id,
        identifier:
          " cambio el estatus de Cargo Atm. (Domiciliado: " +
          dom +
          ") de los recibos desde la póliza.",
      };
      dataFactory
        .post("send-log/", paramsRec)
        .then(function success(response) {});
    };

    function createNotes(insurance) {
      if (insurance) {
        SweetAlert.swal(
          {
            title: "¡Aviso!",
            text: "Se creará una nueva nota de crédito. ¿Desea continuar?",
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
          },
          function (isConfirm) {
            if (isConfirm) {
              var modalInstance = $uibModal.open({
                templateUrl: "app/polizas/add.receiptsModal.html",
                controller: AddReceiptModalCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  serie: function () {
                    return null;
                  },
                  poliza: function () {
                    return insurance;
                  },
                  contractor: function () {
                    return $scope.contratante;
                  },
                  tipo: function () {
                    return 3;
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });

              modalInstance.closed.then(function (receipt) {
                activate();
              });
            } else {
            }
          }
        );
      } else {
        SweetAlert.swal("Error", "No se puede agregar", "error");
        return;
      }
    }

    function createReceipts(insurance) {
      if (insurance) {
        SweetAlert.swal(
          {
            title: "¡Aviso!",
            text: "Se creará un nuevo recibo. ¿Desea continuar?",
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
          },
          function (isConfirm) {
            if (isConfirm) {
              var serie = 0;
              vm.policy_receipts_show.forEach(function (recibo) {
                if (parseInt(recibo.recibo_numero) > serie) {
                  serie = parseInt(recibo.recibo_numero);
                }
              });
              var modalInstance = $uibModal.open({
                templateUrl: "app/polizas/add.receiptsModal.html",
                controller: AddReceiptModalCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  serie: function () {
                    return serie + 1;
                  },
                  poliza: function () {
                    return insurance;
                  },
                  contractor: function () {
                    return $scope.contratante;
                  },
                  tipo: function () {
                    return 1;
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });

              modalInstance.closed.then(function (receipt) {
                activate();
              });
            } else {
            }
          }
        );
      } else {
        SweetAlert.swal("Error", "No se puede agregar", "error");
        return;
      }
    }

    $scope.showReminder = function (recordatorio, index) {
      $http.patch(recordatorio.url, { seen: true }).then(function () {
        vm.recordatorios[index]["seen"] = true;
      });

      // var template_url = 'app/recordatorios/libres.modal.html';

      // var modalInstance = $uibModal.open({ //jshint ignore:line
      //     templateUrl: template_url,
      //     controller: ShowPolizaCtrl,
      //     size: 'lg',
      //     resolve: {
      //         recordatorio: function() {
      //             return recordatorio;
      //         }
      //     },
      //     backdrop: 'static', /* this prevent user interaction with the background */
      //     keyboard: false
      // });
    };
    function editRecibos(index, receiptId, receipt) {
      var texto =
        "Los cambios sólo se aplicarán en este recibo. ¿Deseas continuar?";
      if (vm.acceso_pl_cob == false && receipt.status == 1) {
        var texto =
          "Los cambios sólo se aplicarán en este recibo. \nEstas editando un recibo PAGADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      } else if (vm.acceso_pl_cob == false && receipt.status == 5) {
        var texto =
          "Los cambios sólo se aplicarán en este recibo. \nEstas editando un recibo LIQUIDADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      }
      if (receiptId && receipt) {
        SweetAlert.swal(
          {
            title: "¡Advertencia!",
            text: texto,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
          },
          function (isConfirm) {
            if (isConfirm) {
              var modalInstance = $uibModal.open({
                templateUrl: "app/polizas/edit.receiptsModal.html",
                controller: EditReceiptModalCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  recibo: function () {
                    return receipt;
                  },
                  index: function () {
                    return index;
                  },
                  poliza: function () {
                    return vm.insurance;
                  },
                  receipts: function () {
                    return vm.policy_receipts_show;
                  },
                  acceso_pl_cob: function () {
                    return vm.acceso_pl_cob;
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });
              modalInstance.closed.then(function (receipt) {
                activate();
              });
            } else {
            }
          }
        );
      } else {
        SweetAlert.swal("Error", "No se puede editar", "error");
        return;
      }
    }

    function sendEmail1(email, model) {
      var lb = Ladda.create(document.querySelector(".ladda-button"));
      lb.start();
      if (validateEmail(email) && model) {
        var data = {
          model: model,
          email: email,
          id: vm.insurance.id,
        };
        dataFactory
          .post("send-email-renovacion/", data)
          .then(function success(response) {
            if (response.status == 200) {
              SweetAlert.swal(
                "Enviado",
                "El recordatorio se ha enviado",
                "success"
              );
              vm.form.emailMain = "";
              lb.stop();
            } else {
              SweetAlert.swal("Error", "Ha ocurrido un error", "error");
              vm.form.emailMain = "";
              lb.stop();
            }
          });
      } else {
        SweetAlert.swal("Error", MESSAGES.ERROR.INVALIDEMAIL, "error");
        lb.stop();
        return;
      }
    }
    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
    function showEmail(insurance, model) {
      if (insurance.contratante) {
        var data_alert = {
          title: "Correo",
          text: insurance.contratante.email,
          type: "info",
          confirmButtonText: "Enviar recordatorio",
          cancelButtonText: "Salir",
          showCancelButton: true,
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
        };
      } else {
        var data_alert_correo = {
          title: "Correo",
          text: "Escribe el correo para enviar el recordatorio:",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: false,
          animation: "slide-from-top",
          inputPlaceholder: "email@mail.com",
        };
      }
      if (data_alert) {
        SweetAlert.swal(data_alert, function (isConfirm) {
          if (isConfirm) {
            $http
              .post(url.IP + "send-email-renovacion/", {
                id: insurance.id,
                model: model,
                email: insurance.contratante.email,
              })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                  } else {
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
          }
        });
      } else if (data_alert_correo) {
        SweetAlert.swal(data_alert_correo, function (inputValue) {
          if (inputValue === false) return false;

          if (inputValue === "") {
            swal.showInputError("Ingresa un correo");
            return false;
          }
          $http
            .post(url.IP + "send-email-renovacion/", {
              id: insurance.id,
              model: model,
              email: inputValue,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  swal("Enviado", "El recordatorio ha sido enviado", "success");
                } else {
                  swal(
                    "Error",
                    "No se envió el recordatorio. Contacte a su administrador.",
                    "error"
                  );
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        });
      }
    }
    // $scope.receiptAll = valueReceipt;
    $scope.showAddEmail = false;
    $scope.optionsSent = [
      { value: 1, label: "Sólo al contratante" },
      { value: 2, label: "Añadir correos" },
    ];

    $scope.showAddEmails = function (param) {
      if (param.value == 1) {
        $scope.showAddEmail = false;
      } else {
        $scope.showAddEmail = true;
      }
    };
    $scope.addEmailsConfirm = function (insurance, model) {
      $scope.form = {};
      $rootScope.modalInstance_emails = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/polizas/add.emails.reminder_reminder.html",
        controller: "PolizasInfoCtrl",
        size: "lg",
        resolve: {
          insurance: function () {
            return insurance;
          },
          model: function () {
            return model;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      $rootScope.modalInstance_emails.result.then(function (insurance) {});
    };
    $scope.sendReminder = function (mails, model) {
      var arrayEmails = [];
      if (mails) {
        mails.forEach(function (it) {
          arrayEmails.push(it.email);
        });
      }
      if ($scope.contratante.email) {
        arrayEmails.push($scope.contratante.email);
      }
      if (arrayEmails.length == 0) {
        SweetAlert.swal("Error", "Agregue correos", "error");
        return;
      } else {
        if ($rootScope.modalInstance_emails) {
          $rootScope.modalInstance_emails.close("a");
        }
      }

      if (arrayEmails) {
        SweetAlert.swal("Error", "Agregue correos__", "error");
        var data_alert = {
          title: "Correo",
          // text: arrayEmails,
          text: arrayEmails.join("\n"),
          type: "info",
          confirmButtonText: "Confirmar envio",
          cancelButtonText: "Salir",
          showCancelButton: true,
          closeOnConfirm: true,
          showLoaderOnConfirm: true,
          // showConfirmButton: $scope.add_emails
          showConfirmButton: true,
        };
      }
      if (data_alert) {
        SweetAlert.swal(data_alert, function (isConfirm) {
          if (isConfirm) {
            $http
              .post(url.IP + "send-email-renovacion/", {
                id: vm.insurance.id,
                emails: arrayEmails,
                asunto: $scope.subjectEmail,
                mensaje: $scope.messageEmail,
                model: 10,
              })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                  } else {
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
          }
        });
      }
    };

    $scope.saveNewReceipts = function () {
      // comision
      var com_percent = parseFloat(vm.insurance.comision_percent);
      var com_import =
        parseFloat($scope.dataToSave.p_neta) * (com_percent / 100);

      // patch de los valores y post de los recibos
      var _poliza_ = {
        derecho: $scope.dataToSave.derecho,
        descuento: $scope.dataToSave.descuento,
        iva: $scope.dataToSave.iva,
        p_neta: $scope.dataToSave.p_neta,
        p_total: $scope.dataToSave.p_total,
        rpf: $scope.dataToSave.rpf,
        comision_percent: vm.insurance.comision_percent,
        comision: com_import.toFixed(2),
      };

      var count = 0;

      for (var i in $scope.dataToSave.recibos_poliza) {
        var item = $scope.dataToSave.recibos_poliza[i];

        item.fecha_fin = datesFactory.toDate(item.fecha_fin);
        item.endingDate = datesFactory.toDate(item.endingDate);
        item.fecha_inicio = datesFactory.toDate(item.fecha_inicio);
        item.startDate = datesFactory.toDate(item.startDate);
        item.vencimiento = datesFactory.toDate(item.vencimiento);
        item.poliza = vm.insurance.url;

        dataFactory.post("recibos/", item).then(function (res) {
          count = count + 1;

          res.receipt_type = 1;
          vm.policy_receipts_show.push(res);
          vm.insurance.recibos_poliza.push(res.url);

          if ((count = $scope.dataToSave.recibos_poliza.length + 1)) {
            $scope.calculate_receipts = false;

            $http.patch(vm.insurance.url, _poliza_).then(function (res) {
              insuranceServices();
            });
            // volver a mostrar los recibos (agregar en el arreglo de recibos en información - policy_receipts_show -)
          }
        });
      }
    };
    $scope.deleteReceipts = function (receipt, index) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text:
            "No será posible recuperar este recibo: " + receipt.recibo_numero,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: receipt.id,
              id_poliza: vm.insurance.id,
              model: 8,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {
                // console.log('.................:::::.....',req)
              });
            $http
              .patch(receipt.url, { status: 0 })
              .then(function (recibo_delete) {
                var paramsDelRec = {
                  model: 1,
                  event: "DELETE",
                  associated_id: vm.insurance.id,
                  identifier:
                    " elimino un recibo (" +
                    receipt.recibo_numero +
                    ") de la póliza",
                };
                dataFactory
                  .post("send-log/", paramsDelRec)
                  .then(function success(response) {});
                if (recibo_delete.data.status == 0) {
                  vm.policy_receipts_show.splice(index, 1);
                }
                SweetAlert.swal("¡Hecho!", "Recibo eliminado", "success");
              });
          }
        }
      );
    };

    // renovar recibos
    $scope.renewReceipts = function () {
      // sacar fecha de fin del ultimo recibo
      var length_receipts = vm.policy_receipts_show.length - 1;
      var date_last_receipt = new Date(
        vm.policy_receipts_show[length_receipts].fecha_fin
      );
      var new_start_date =
        date_last_receipt.getDate() +
        "/" +
        (date_last_receipt.getMonth() + 1) +
        "/" +
        date_last_receipt.getFullYear();
      var new_end_date =
        date_last_receipt.getDate() +
        "/" +
        (date_last_receipt.getMonth() + 1) +
        "/" +
        (date_last_receipt.getFullYear() + 1);

      vm.insurance.startDate = new_start_date;
      vm.insurance.endingDate = new_end_date;
      vm.insurance.payment = {
        value: vm.insurance.forma_de_pago,
      };

      $scope.dataToSave = {
        receipts: [],
      };

      $scope.poliza_renew_rec = {
        primaNeta: null,
        descuento: null,
        rpf: null,
        subTotal: null,
        iva: null,
        primaTotal: null,
        configDerecho: false,
        configRPF: false,
        aplicarDescuento: false,
      };

      SweetAlert.swal(
        {
          title: "Renovar recibos",
          text: "¿Está seguro de renovar los recibos?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.calculate_receipts = true;
          }
        }
      );
    };

    $scope.addEmails = function (type) {
      var mail = {
        email: "",
      };
      $scope.form.emails_reminder.push(mail);
    };

    $scope.deleteEmails = function (mail, type) {
      $scope.form.emails_reminder.splice(mail, 1);
    };
    $scope.cancel = function () {
      if ($rootScope.modalInstance_emails) {
        $rootScope.modalInstance_emails.close("a");
      }
    };

    $scope.forma_pago = function (parValue) {
      switch (parValue) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 4:
          return "Cuatrimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        case 24:
          return "Quincenal";
          break;
        default:
          return "No especificada";
      }
    };

    $scope.tipo_pago = function (parValue) {
      switch (parValue) {
        case 1:
          return "Reembolso";
          break;
        case 2:
          return "Programación";
          break;
        case 3:
          return "Pago directo";
          break;
        case 4:
          return "Aclaración";
          break;
        default:
          return "No especificada";
      }
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        case 0:
          return "Eliminada/Desactivada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.concept = function (parConcept) {
      switch (parConcept) {
        case 1:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 2:
          return "CAMBIO DE SUMA ASEGURADA";
          break;
        case 3:
          return "OTRO";
          break;
        case 4:
          return "PRÓRROGA DE VIGENCIA";
          break;
        case 5:
          return "AGREGAR COBERTURAS";
          break;
        case 6:
          return "ALTA/BAJA DE DEPENDIENTES";
          break;
        case 8:
          return "CAMBIO DATOS FISCALES";
          break;
        case 9:
          return "ESPECIFICACIONES";
          break;
        case 11:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 12:
          return "DISMINUCIÓN EN LA SUMA ASEGURADA";
          break;
        case 13:
          return "CANCELACION DEFINITIVA A PETICION";
          break;
        case 14:
          return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
          break;
        case 15:
          return "BAJA DE ASEGURADO";
          break;
        case 16:
          return "CANCELACIÓN DE PÓLIZA POR PETICIÓN";
          break;
        case 17:
          return "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO";
          break;
        case 23:
          return "ANTIGÜEDAD RECONOCIDA";
          break;
        default:
          return "OTRO";
      }
    };

    $scope.policy_type = function (value) {
      switch (value) {
        case 1:
          return "Automóvil";
          break;
        case 2:
          return "Motocicleta";
          break;
        case 3:
          return "Tracto";
          break;
        case 4:
          return "Autobús";
          break;
        case 5:
          return "Pick Up";
          break;
        case 6:
          return "Camiones hasta 1.5 ton";
          break;
        case 7:
          return "Chofer app";
          break;
        case 8:
          return "Remolque";
          break;
        case 9:
          return "Camiones + 1.5 ton";
          break;
        default:
          return "No especificado";
      }
    };
    $scope.type_procedencia = function (value) {
      switch (value) {
        case 1:
          return "Residente";
          break;
        case 2:
          return "Turista";
          break;
        case 3:
          return "Legalizado";
          break;
        case 4:
          return "Fronterizo";
          break;
        default:
          return "No especificado";
      }
    };
    $scope.getCarga = function (value) {
      switch (value) {
        case 1:
          return "A";
          break;
        case 2:
          return "B";
          break;
        case 3:
          return "C";
          break;
        default:
          return "No especificado";
      }
    };

    $scope.policy_type_fire = function (value) {
      switch (value) {
        case 1:
          return "Familiar";
          break;
        case 2:
          return "Casa Habitación";
          break;
        case 3:
          return "Condominio";
          break;
        case 4:
          return "Edificio";
          break;
        case 5:
          return "Empresarial";
          break;
        case 6:
          return "Múltiple Empresarial";
          break;
        case 7:
          return "Específica";
          break;
        case 8:
          return "Pronóstico";
          break;
        case 9:
          return "Declaración";
          break;
        case 10:
          return "Soló Incendio";
          break;
        case 11:
          return "Animales";
          break;
        case 12:
          return "Cultivo";
          break;
        case 13:
          return "Crédito General";
          break;
        case 14:
          return "Crédito a la Vivienda";
          break;
        case 15:
          return "Documentos que sean objeto de oferta pública o de intermediación en mercados de valores";
          break;
        case 16:
          return "Emisores de Valores";
          break;
        case 17:
          return "Titulos de Crédito";
          break;
        case 18:
          return "Administración";
          break;
        case 19:
          return "Arquitectos";
          break;
        case 20:
          return "Aviones";
          break;
        case 21:
          return "Barcos";
          break;
        case 22:
          return "Contratista";
          break;
        case 23:
          return "Cime";
          break;
        case 24:
          return "Cyber (Protección de datos)";
          break;
        case 25:
          return "D&O (Consejeros y Funcionarios";
          break;
        case 26:
          return "&O Miscelaneos";
          break;
        case 27:
          return "Empresarial";
          break;
        case 28:
          return "Eventos";
          break;
        case 29:
          return "Familiar/Condominal";
          break;
        case 30:
          return "Hole in One";
          break;
        case 31:
          return "Ingeniería";
          break;
        case 32:
          return "Instituciones Financieras";
          break;
        case 33:
          return "Lineas Financieras";
          break;
        case 34:
          return "Médicos";
          break;
        case 35:
          return "Otro";
          break;
        case 36:
          return "Riesgos Catastróficos";
          break;
        case 37:
          return "Calderas y Recipientes Sujetos a Presión";
          break;
        case 63:
          return "Terrorismo y Sabotaje";
          break;
        case 38:
          return "Dinero y Valores";
          break;
        case 39:
          return "Eq. Contratistas y Maquinaria pesada";
          break;
        case 40:
          return "Eq. Electrónico";
          break;
        case 41:
          return "Montaje de Maquinaria";
          break;
        case 42:
          return "Obra Civil en Contrucción";
          break;
        case 43:
          return "Obra Civil Terminada";
          break;
        case 44:
          return "Rotura de Cristales";
          break;
        case 45:
          return "Rotura de Maquinaria";
          break;
        case 46:
          return "Familiar";
          break;
        case 47:
          return "Ahorro";
          break;
        case 48:
          return "Vitalicia";
          break;
        case 49:
          return "Temporal/Protección";
          break;
        case 52:
          return "Helicóptero";
          break;
        case 51:
          return "Embarcación de Placer";
          break;
        case 53:
          return "CRIME/BBB";
          break;
        case 54:
          return "D&O";
          break;
        case 55:
          return "FIPI";
          break;
        case 56:
          return "CYBER";
          break;
        case 57:
          return "VCAPS";
          break;
        case 58:
          return "RCP MÉDICA";
          break;
        case 59:
          return "E&O MISCELANEO";
          break;
        case 60:
          return "RIESGO POLITICO";
          break;
        case 61:
          return "RC SERVIDORES PUBLICOS";
          break;
        case 62:
          return "RCP";
          break;
        case 64:
          return "Viajero";
          break;
        default:
          return "";
      }
    };

    $scope.policy_type_fire_ok = function (value) {
      switch (value) {
        case 1:
          return "Familiar";
          break;
        case 2:
          return "Casa Habitación";
          break;
        case 3:
          return "Condominio";
          break;
        case 4:
          return "Edificio";
          break;
        case 5:
          return "Empresarial";
          break;
        case 6:
          return "Múltiple Empresarial";
          break;
        case 7:
          return "Específica";
          break;
        case 8:
          return "Pronóstico";
          break;
        case 9:
          return "Declaración";
          break;
        case 10:
          return "Soló Incendio";
          break;
        case 11:
          return "Animales";
          break;
        case 12:
          return "Cultivo";
          break;
        case 13:
          return "Crédito General";
          break;
        case 14:
          return "Crédito a la Vivienda";
          break;
        case 15:
          return "Documentos que sean objeto de oferta pública o de intermediación en mercados de valores";
          break;
        case 16:
          return "Emisores de Valores";
          break;
        case 17:
          return "Titulos de Crédito";
          break;
        case 18:
          return "Administración";
          break;
        case 19:
          return "Arquitectos";
          break;
        case 20:
          return "Aviones";
          break;
        case 21:
          return "Barcos";
          break;
        case 22:
          return "Contratista";
          break;
        case 23:
          return "Cime";
          break;
        case 24:
          return "Cyber (Protección de datos)";
          break;
        case 25:
          return "D&O (Consejeros y Funcionarios";
          break;
        case 26:
          return "&O Miscelaneos";
          break;
        case 27:
          return "Empresarial";
          break;
        case 28:
          return "Eventos";
          break;
        case 29:
          return "Familiar/Condominal";
          break;
        case 30:
          return "Hole in One";
          break;
        case 31:
          return "Ingeniería";
          break;
        case 32:
          return "Instituciones Financieras";
          break;
        case 33:
          return "Lineas Financieras";
          break;
        case 34:
          return "Médicos";
          break;
        case 35:
          return "Otro";
          break;
        case 36:
          return "Riesgos Catastróficos";
          break;
        case 37:
          return "Calderas y Recipientes Sujetos a Presión";
          break;
        case 63:
          return "Terrorismo y Sabotaje";
          break;
        case 38:
          return "Dinero y Valores";
          break;
        case 39:
          return "Eq. Contratistas y Maquinaria pesada";
          break;
        case 40:
          return "Eq. Electrónico";
          break;
        case 41:
          return "Montaje de Maquinaria";
          break;
        case 42:
          return "Obra Civil en Contrucción";
          break;
        case 43:
          return "Obra Civil Terminada";
          break;
        case 44:
          return "Rotura de Cristales";
          break;
        case 45:
          return "Rotura de Maquinaria";
          break;
        case 46:
          return "Avión";
          break;
        case 47:
          return "Avioneta";
          break;
        case 48:
          return "Barco";
          break;
        case 49:
          return "Buque";
          break;
        case 50:
          return "Dron";
          break;
        case 52:
          return "Helicóptero";
          break;
        case 51:
          return "Embarcación de Placer";
          break;
        case 53:
          return "CRIME/BBB";
          break;
        case 54:
          return "D&O";
          break;
        case 55:
          return "FIPI";
          break;
        case 56:
          return "CYBER";
          break;
        case 57:
          return "VCAPS";
          break;
        case 58:
          return "RCP MÉDICA";
          break;
        case 59:
          return "E&O MISCELANEO";
          break;
        case 60:
          return "RIESGO POLITICO";
          break;
        case 61:
          return "RC SERVIDORES PUBLICOS";
          break;
        case 62:
          return "RCP";
          break;
        case 64:
          return "Viajero";
          break;
        default:
          return "";
      }
    };

    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    function delivery(poliza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/mensajeria/create.delivery.html",
        controller: "DeliveryModalCtrl",
        size: "lg",
        resolve: {
          insurance: function () {
            return poliza;
          },
          contractor: function () {
            return $scope.contratante;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    $scope.cambiarReferenciador = function (data, poliza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/referenciadores.modal.html",
        controller: ReferenciadorModalCtrl,
        controllerAs: "vendedor",
        size: "lg",
        resolve: {
          poliza: function () {
            return poliza;
          },
          actual: function () {
            return data.data;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(
        function (response) {
          insuranceServices();
        },
        function () {
          insuranceServices();
          console.info("modal closed");
        }
      );
    };
    $scope.statusReceipts = function (parStatus) {
      switch (parStatus) {
        case 1:
          return "Pagado";
          break;
        case 2:
          return "Cancelado";
          break;
        case 3:
          return "Prorrogado";
          break;
        case 4:
          return "Pendiente de pago";
          break;
        case 5:
          return "Liquidado";
          break;
        case 6:
          return "Conciliado";
          break;
        case 7:
          return "Cerrado";
          break;
        case 8:
          return "Precancelado";
          break;
        case 9:
          return "Pago Parcial";
          break;
        default:
          return "Pendiente de pago";
      }
    };

    function checkStatusReceipts(parStatus) {
      $scope.statusReceipt = statusReceiptsFactory.receipts(parStatus.status);
      if (
        $scope.poliza_multianual &&
        $scope.statusReceipt == "Pendiente de pago" &&
        parStatus.prima_neta == 0
      ) {
        $scope.statusReceipt = "Pendiente de actualizar";
      }
      return $scope.statusReceipt;
    }

    function deliveredReceipt(receipt) {
      SweetAlert.swal(
        {
          title: "Entregado",
          text: "Este recibo se marcara como entregado",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var params = {
              model: 4,
              event: "PATCH",
              associated_id: receipt.id,
              identifier: " actualizo el recibo a Entregado",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            $http({
              method: "PATCH",
              url: receipt.url,
              data: {
                delivered: true,
              },
            }).then(function success(response) {
              if (response.status == 200) {
                SweetAlert.swal("¡Listo!", "", "success");

                $state.go("polizas.info", { polizaId: vm.insurance.id });
              }
            });
          }
        }
      );
    }

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        // $timeout(function() {
        if ($scope.param == "poliza") {
          SweetAlert.swal(MESSAGES.OK.UPGRADEPOLICY, "", "success");
        } else if ($scope.param == "ot") {
          SweetAlert.swal("¡Listo!", MESSAGES.OK.UPGRADEOT, "success");
        } else {
          // closeUiSelect();
          SweetAlert.swal(
            "¡Listo!",
            "Archivos cargados exitosamente.",
            "success"
          );
        }
        $state.go("polizas.info", { polizaId: vm.insurance.id });
        // }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
        order.options.checkDate("initial");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
        order.options.checkDate("initial");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales, renombre y, vuelva a cargarlo. " +
            $scope.specialchar,
          "error"
        );
      }
    };
    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    $scope.saveFiles = function (poliza) {
      $scope.countFile = $scope.uploader.queue.length;
      uploadFiles(poliza);
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $scope.uploader.uploadAll();
      saveLogFile($scope.countFile, polizaId);
    }
    function saveLogFile(num, id_p) {
      if (num > 0) {
        var params = {
          model: 1,
          event: "PATCH",
          associated_id: id_p,
          identifier: " añadio " + num + " archivos a la póliza.",
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});
      }
    }
    $scope.showInformationEndoso = function (endoso) {
      if (endoso.policy_type == 1) {
        $state.go("endosos.pendingData", {
          endorsementId: endoso.id,
          endorsementType: vm.checkEndorsementType(endoso),
          polizaId: endoso.policy.id,
        });
      } else if (endoso.policy_type == 2) {
        if (endoso.endorsement_type == "D") {
          if (endoso.policy.subramo == 1) var type = "life";
          else if (endoso.policy.subramo == 3) var type = "disease";
          else var type = "automobile";
        }
        $state.go("endosos.pendingDataMassive", {
          endorsementId: endoso.id,
          endorsementType: vm.checkEndorsementType(endoso)
            ? vm.checkEndorsementType(endoso)
            : type,
          polizaId: endoso.policy.id,
        });
      }
    };

    $scope.infoSinister = function (name, sinister, insurance) {
      $scope.name_for_new_tab = name;
      if (insurance.ramo == "Accidentes y Enfermedades") {
        $scope.route_for_new_tab = "siniestros.info";
        var route = "siniestros.info";
      } else if (
        insurance.ramo == "Daños" &&
        (insurance.subramo == "Automóviles" ||
          insurance.subramo.subramo_name == "Automóviles")
      ) {
        $scope.route_for_new_tab = "siniestros.auto_info";
        var route = "siniestros.auto_info";
      } else if (insurance.ramo == "Vida") {
        $scope.route_for_new_tab = "siniestros.vida_info";
        var route = "siniestros.vida_info";
      } else if (
        insurance.ramo == "Daños" &&
        (insurance.subramo != "Automóviles" ||
          insurance.subramo.subramo_name != "Automóviles")
      ) {
        $scope.route_for_new_tab = "siniestros.danio_info";
        var route = "siniestros.danio_info";
      }

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;

      if (insurance.ramo == "Accidentes y Enfermedades") {
        $state.go("siniestros.info", { siniestroId: sinister.id });
      } else if (
        insurance.ramo == "Daños" &&
        (insurance.subramo == "Automóviles" ||
          insurance.subramo.subramo_name == "Automóviles")
      ) {
        $state.go("siniestros.auto_info", { siniestroId: sinister.id });
      } else if (insurance.ramo == "Vida") {
        $state.go("siniestros.vida_info", { siniestroId: sinister.id });
      } else if (
        insurance.ramo == "Daños" &&
        (insurance.subramo != "Automóviles" ||
          insurance.subramo.subramo_name != "Automóviles")
      ) {
        $state.go("siniestros.danio_info", { siniestroId: sinister.id });
      }
    };

    $scope.goToSiniester = function (param, type, name, route) {
      $localStorage["save_created_siniester_accident"] = {};
      if (type == 2) {
        vm.insurance.relation = param.id;
      }
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      var params = { myInsurance: vm.insurance, contractor: "" };
      $state.go($scope.route_for_new_tab, params);
      //$state.go('siniestros.accidentes', {myInsurance: vm.insurance, contractor: ""})
    };

    $scope.goToPolicy = function (policy) {
      $state.go("polizas.info", { polizaId: policy.id });
    };

    $scope.createSiniester = function (name, route) {
      $localStorage["save_created_siniester_auto"] = {};
      $scope.open_in_same_tab_sns(name, route, {}, 0);
    };

    vm.checkEndorsementType = function checkType(obj) {
      if (obj.automobile) return "automobile";
      else if (obj.life) return "life";
      else if (obj.damage) return "damage";
      else if (obj.disease) {
        return "disease";
      }
    };

    function sendProvider(provider) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/aseguradoras/send.modal.html",
        controller: "SendPDFModalCtrl",
        size: "md",
        resolve: {
          provider: function () {
            return provider;
          },
          typeOT: function () {
            return 1;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function viewContractor(name, route) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;

      $stateParams.contractor = $scope.contratante;
      if ($scope.contratante.type_person == "Física") {
        $state.go($scope.route_for_new_tab, {
          type: "fisicas",
          contratanteId: vm.insurance.contractor,
          contractor: $scope.contratante,
        });
      } else if ($scope.contratante.type_person == "Moral") {
        $state.go($scope.route_for_new_tab, {
          type: "morales",
          contratanteId: vm.insurance.contractor,
          contractor: $scope.contratante,
        });
      }
    }

    function getLog() {
      dataFactory
        .get("get-specific-log", { model: 1, associated_id: vm.insurance.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    }
    function getLogReceipt(model, id) {
      dataFactory
        .get("get-specific-log", { model: model, associated_id: id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    }

    function showChange(endoso) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/infoChange.modal.html",
        controller: "InfoChangeCtrl",
        size: "lg",
        resolve: {
          endoso: function () {
            return endoso;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function NotasModal(receipt) {
      var insurance = receipt;
      var modalInstance = $uibModal.open({
        templateUrl: "app/cobranzas/notaCredito.modal.html",
        controller: "NotaCreditoCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return insurance;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        vm.receipts.splice(index, 1);
        activate();
      });
    }

    function checkType(type) {
      //jshint ignore:line
      return type === "Fisica" ? "fisicas" : "morales";
    }

    function showSinisters(insurance) {
      vm.infoFlag = false;
      vm.sinistersFlag = true;

      $http({
        method: "GET",
        url: url.IP + "view-sinister",
        params: {
          policy: insurance.id,
        },
      }).then(function success(response) {
        vm.sinisters = response.data.siniestros;
      });
    }

    function showNotas() {
      vm.infoFlag = false;
      vm.notasFlag = true;
    }
    function showRecordatorios() {
      vm.infoFlag = false;
      vm.recordatoriosFlag = true;
    }
    function showEndorsements(insurance) {
      vm.infoFlag = false;
      vm.endoFlag = true;

      $http({
        method: "GET",
        url: url.IP + "view-endosos",
        params: {
          policy: insurance.id,
        },
      }).then(function success(response) {
        vm.endorsements = response.data.endosos;
      });
    }

    function returnToInfo(argument) {
      vm.infoFlag = true;
      vm.sinistersFlag = false;
      vm.endoFlag = false;
    }

    function openRenovateModal(name, route) {
      $scope.errorpr = false;
      if (vm.policy_history && $scope.existeNueva) {
        vm.policy_history.forEach(function (e) {
          if (e.status == 1) {
            if (
              vm.insurance.renewed_status == 2 &&
              $scope.existeNueva == true
            ) {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.ERRORREPROCCESSRENPOLICY,
                "error"
              );
              $scope.errorpr = true;
              return;
            }
          }
        });
      }
      if (
        ((vm.insurance.renewed && $scope.errorpr) ||
          (vm.insurance.renewed_status == 2 && vm.policy_history.length > 0)) &&
        $scope.existeNueva
      ) {
        if (
          vm.insurance.renewed_status == 2 &&
          vm.policy_history.length > 0 &&
          $scope.existeNueva == true
        ) {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORREPROCCESSRENPOLICY,
            "error"
          );
          return;
        } else {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRENEWPOLICY, "error");
        }
      } else {
        $scope.name_for_new_tab = name;
        $scope.route_for_new_tab = route;

        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }

        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });

          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab),
          };
        }
        $localStorage.tab_states = appStates.states;

        if (
          vm.insurance.status == "Cancelada" ||
          vm.insurance.status == "OT Cancelada" ||
          vm.insurance.status == 11 ||
          vm.insurance.status == 2
        ) {
          SweetAlert.swal(
            {
              title: "Póliza Cancelada",
              text: "¿Está seguro de renovar?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Continuar",
              cancelButtonText: "Cancelar",
              closeOnConfirm: true,
              closeOnCancel: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                var params = {
                  polizaId: vm.insurance.id,
                  myInsurance: vm.insurance,
                };
                $rootScope.renewalDraftPolicy =
                  angular.copy(vm.insurance) || null;
                $state.go("renovaciones.polizas", params);
              } else {
                // swal("Cancelado", MESSAGES.OK.CANCELCERT, "error");
                return;
              }
            }
          );
        } else {
          var params = { polizaId: vm.insurance.id, myInsurance: vm.insurance };
          $rootScope.renewalDraftPolicy = angular.copy(vm.insurance) || null;
          $state.go("renovaciones.polizas", params);
        }
      }
    }

    function cancelRenovate(poliza) {
      swal(
        {
          title: "No renovar",
          text: "Motivo:",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: false,
        },
        function (inputValue) {
          if (inputValue === false) return false;
          if (inputValue === "") {
            swal.showInputError("Necesita especificar un motivo");
            return false;
          }
          var data = {
            reason_ren: inputValue,
            status: 15,
          };
          $http.patch(poliza.url, data).then(function (ren) {
            var params = {
              model: 1,
              event: "PATCH",
              associated_id: poliza.id,
              identifier:
                " cambio el estatus a no renovada por el motivo " +
                ren.data.reason_ren +
                " de la póliza " +
                ren.data.poliza_number +
                ".",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          });
          vm.insurance.status = 15;
          vm.insurance.reason_ren = inputValue;
          vm.insurance.renewed_status = 1;
          swal(
            "Hecho",
            "La póliza se ha cerrado y no se vera más en el listado de renovaciones",
            "success"
          );
        }
      );
    }

    function showBinnacle(param) {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 1,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.polizaId = param.id;
      vm.show_binnacle = true;
    }

    function exportPolicyComments() {
      if (!vm.polizaId || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
      };

      var params = {
        model: 1,
        id_model: vm.polizaId,
      };
      if (vm.org_name) {
        params.org = vm.org_name;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: params,
          downloadName: "bitacora-poliza-" + vm.polizaId + ".xlsx",
          token: token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando bitácora de póliza", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios de la póliza. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }
    // function getProviderIdFromInsurance() {
    //   console.log('iiiiiii',vm.insurance)
    //   if (!vm.insurance || !vm.insurance.aseguradora) return null;
    //   return vm.insurance.aseguradora.id || vm.insurance.aseguradora;
    // }

    // function getSubramoIdFromInsurance() {
    //   if (!vm.insurance || !vm.insurance.subramo) return null;
    //   if (angular.isObject(vm.insurance.subramo)) {
    //     return vm.insurance.subramo.id || null;
    //   }
    //   return vm.insurance.subramo || null;
    // }

    // function loadGeneralConditions() {
    //   var providerId = getProviderIdFromInsurance();
    //   var subramoId = getSubramoIdFromInsurance();
    //   if (!providerId || !subramoId) {
    //     vm.cg.catalog = [];
    //     vm.cg.selectedDocs = [];
    //     return;
    //   }

    //   vm.cg.loading = true;
    //   CondicionesGeneralesService.list({ aseguradora: providerId, subramo: subramoId })
    //     .then(function(res) {
    //       vm.cg.catalog = res.data.results || res.data || [];
    //       vm.cg.byId = {};
    //       vm.cg.catalog.forEach(function(c){
    //         vm.cg.byId[c.id] = c;
    //       });
    //       return CondicionesGeneralesService.getByPolicy(vm.insurance.id);
    //     })
    //     .then(function(res) {
    //       var rows = res.data.results || res.data || [];
    //       vm.cg.selectedDocs = rows
    //         .map(function(r){ return r.condicion_detalle; })
    //         .filter(function(x){ return !!x && !!x.id; });
    //     })
    //     // .then(function(res) {
    //     //   vm.cg.selectedDocs = res.data.results || res.data || [];
    //     // })
    //     .catch(function() {
    //       vm.cg.catalog = [];
    //       vm.cg.selectedDocs = [];
    //     })
    //     .finally(function() {
    //       vm.cg.loading = false;
    //     });
    // }
    // function closeUiSelect() {
    //   vm.cg.isOpen = false;
    //   try { document.activeElement && document.activeElement.blur(); } catch(e) {}
    // }
    // function onGeneralConditionsChange() {
    //   if (!vm.insurance || !vm.insurance.id) return;
    //   vm.cg.saving = true;
    //   // var ids = (vm.cg.selectedDocs || []).map(function(item) { return item.id; });
    //   var ids = (vm.cg.selectedDocs || [])
    //     .map(function(item){ return item.id; })
    //     .filter(function(x){ return !!x; });
    //   CondicionesGeneralesService.saveSelectionForPolicy(vm.insurance.id, ids)
    //     .then(function() {
    //       return $http.get(url.IP + 'polizas/' + vm.insurance.id + '/archivos/');
    //     })
    //     .then(function(response) {
    //       vm.files = response.data.results || [];
    //       $scope.files = vm.files;
    //     })
    //     .finally(function() {
    //       vm.cg.saving = false;
    //     });
    // }

    // function removeGeneralCondition(doc) {
    //   if (!vm.insurance || !vm.insurance.id || !doc || !doc.id) return;
    //   vm.cg.selectedDocs = (vm.cg.selectedDocs || []).filter(function(item) { return item.id !== doc.id; });
    //   onGeneralConditionsChange();
    // }

    // function isGeneralConditionFile(file) {
    //   return !!(file && (file.condicion_general || file.is_condicion_general || file.origin === 'CG'));
    // }
    function deleteFile(file, container) {
      // if (isGeneralConditionFile(file)) {
      //   SweetAlert.swal("Acción no permitida", "Las Condiciones Generales sólo se administran desde el módulo centralizado.", "info");
      //   return;
      // }
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este archivo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: file.id,
              id_poliza: vm.insurance.id,
              model: 6,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {});
            $http({
              method: "GET",
              url: url.IP + "delete-manual",
              params: {
                file_id: file.id,
              },
            }).then(function success(response) {
              if (response.data.status == 204) {
                SweetAlert.swal(
                  "¡Eliminado!",
                  "El archivo fue eliminado.",
                  "success"
                );
                var params = {
                  model: 1,
                  event: "PATCH",
                  associated_id: vm.insurance.id,
                  identifier: " elimino 1 archivo de la póliza " + file.nombre,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                container.splice(container.indexOf(file), 1);
              }
            });
          }
        }
      );
    }

    function showBinnacleReceipt(param) {
      $scope.receiptmodel = param.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_receipt = [];
          vm.comments_data_receipt = request.data.results;
          vm.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.receipt_id = param.id;
      vm.show_binnacle_receipt = true;
    }

    vm.show_binnacle_receiptE = false;
    vm.showBinnacleReceiptE = showBinnacleReceiptE;
    function showBinnacleReceiptE(param) {
      $scope.receiptmodel = param.url;
      vm.comments_data_receipt = [];
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_receipt = request.data.results;
          vm.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.receipt_id = param.id;
      vm.show_binnacle_receiptE = true;
    }
    vm.returnToReceiptsE = returnToReceiptsE;
    function returnToReceiptsE() {
      vm.show_binnacle_receiptE = false;
    }

    $scope.formatCoverage = function (parValue) {
      // 1) Nulos / vacíos
      if (parValue === null || parValue === undefined) return "";
      var raw = ("" + parValue).trim();
      if (!raw) return "";

      // 2) Porcentajes: regresa tal cual
      if (raw.indexOf("%") !== -1) return raw;

      // 3) Intento de número: quitamos símbolos y separadores
      var cleaned = raw.replace(/\$/g, "").replace(/,/g, "").trim();
      var num = parseFloat(cleaned);

      // 4) No numérico → dejar "-" o el valor proporcionado (si es un literal útil)
      if (isNaN(num)) {
        // Si el valor original es un literal (AMPARADA, SIN LÍMITE, etc.), respétalo;
        // si no, devuelve "-"
        return raw || "-";
      }

      // 5) Numérico → formatea como moneda
      try {
        if (formatValues && typeof formatValues.currency === "function") {
          return formatValues.currency(num);
        }
      } catch (e) {
        // sigue con el fallback
      }
      // Fallback sin formatValues.currency
      return (
        "$" +
        num.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    };

    //---guardar como poliza
    function saveAsInsurance(myInsurance) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/modals/otAsPolicyModal.html",
        controller: PolicyPendingModalCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policyModal: function () {
            return vm.insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      // $state.go('polizas.editar', myInsurance);
    }

    //---guardar como poliza
    $scope.addPhoneWhatsapp = function (insurance, contra) {
      insurance.contratante = contra;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.phone.whatsappsms_reminderpay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return insurance;
          },
          valueReceipt: function () {
            return insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };
    $scope.addEmailsConfirmPolicy = function (insurance, contra) {
      insurance.contratante = contra;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return insurance;
          },
          valueReceipt: function () {
            return insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };

    function changeStatusModal(receipt, contra, insurance) {
      // if(vm.acceso_adm_pol){
      receipt.isDB = false;
      receipt.contratante = contra;
      var index = vm.receipts.indexOf(receipt);
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return insurance;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
      // }
    }

    function activate() {
      $scope.moduleName = "Célula";
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      try {
        $http
          .post(url.IP + "get-data-promotoria-initial/")
          .then(
            function success(response) {
              if (response.data.results.length > 0) {
                $scope.principal = response.data.original;
                $scope.principal.contenedores =
                  response.data.original.data_details;
                $scope.principal.url = response.data.original.url;
                $scope.principal.id = response.data.original.id;
              }
            },
            function error(e) {
              console.log("Error - promotorias--", e);
            }
          )
          .catch(function (error) {
            $scope.principal.contenedores = [];
            console.log("Error - promotablero - catch", error);
          });
      } catch (e) {}
      // bitacoras
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 1,
          id_model: vm.polizaId,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            next: request.data.next,
            previous: request.data.previous,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      $scope.view_siniestros = true;
      $scope.view_cartas = true;
      $scope.assign_policy = true;

      insuranceServices();

      $http({
        method: "GET",
        url: url.IP + "cartas-by-model",
        params: {
          model: 1,
        },
      }).then(function success(response) {
        vm.cartas = response.data;
      });
    }
    $scope.saveBaja = false;
    $scope.changeBaja = function (url_c, valor, motivo_baja) {
      $scope.saveBaja = true;
      if (url_c) {
        $http
          .patch(url_c, { baja: valor, motivo_baja: motivo_baja })
          .then(function (response) {
            $scope.saveBaja = false;
            if (response.status == 200) {
              toaster.success(
                "Cambio exitoso",
                "El cambio se ha aplicado con éxito"
              );
            } else {
              $scope.saveBaja = false;
              toaster.warning("Ha ocurrido un problema", "Intente nuevamente");
              vm.form.baja = !valor;
              vm.form.motivo_baja = "";
            }
          });
      }
    };
    // ------------tablero OT------
    function moveOTState(newcontainer, principal, seguimiento, tipo) {
      SweetAlert.swal(
        {
          title: "Mover Registro",
          text:
            "Se moverá " +
            vm.insurance.internal_number +
            " de: " +
            vm.insurance.seguimiento +
            ", al Contenedor: " +
            newcontainer.tablero,
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
            if (principal.contenedores && principal.contenedores.length > 0) {
              principal.contenedores.forEach(function (r, i) {
                if (r.tablero == seguimiento) {
                  r.polizas.splice(r.polizas.indexOf(vm.insurance.id), 1);
                }
                if (r.tablero == newcontainer.tablero) {
                  r.polizas.push(vm.insurance.id);
                }
                if (r) {
                  if (r["details_endoso"]) {
                    r["details_endoso"] = [];
                  }
                  if (r["details_polizas"]) {
                    r["details_polizas"] = [];
                  }
                }
              });
            }
            var payload = {
              polizas_ots: principal.contenedores,
              name: principal.name,
              color: principal.color,
              url: $scope.principal.url ? $scope.principal.url : "",
            };
            if ($scope.principal.url && $scope.principal.url != "") {
              $http
                .patch($scope.principal.url, payload)
                .then(
                  function success(response) {
                    vm.insurance.seguimiento = newcontainer.tablero;
                    activate();
                  },
                  function error(e) {
                    console.log("Error - promotorias--", e);
                  }
                )
                .catch(function (error) {
                  console.log("Error - promotablero - catch", error);
                });
            }
          }
        }
      );
    }
    // tablero OT------------------
    function returnToReceipts() {
      vm.show_binnacle_receipt = false;
    }
    vm.table = {
      headers: [
        "Serie",
        "Prima neta",
        "Derecho",
        "RPF",
        "Iva",
        "Prima Total",
        "Estatus",
        "Acciones",
        "Vigencia",
        "Vencimiento",
      ],
    };
    vm.tables = {
      headers: [
        "Id",
        "Fecha de aplicación ",
        "Inicio de vigencia",
        "Fin de vigencia",
        "Tipo de endoso",
        "Aplicante",
      ],
    };
    vm.tablec = {
      headers: ["Cobertura", "Suma Asegurada", "Deducible", "Coaseguro"],
    };

    $scope.getUsage = function (value) {
      if (value == 1) {
        return "PARTICULAR";
      } else if (value == 2) {
        return "CARGA";
      } else if (value == 3) {
        return "SERVICIO PÚBLICO";
      } else {
        return "CARGA";
      }
    };

    function insuranceServices() {
      var array = [];
      var array1 = [];
      var output = insuranceService
        .getInsuranceRead($stateParams)
        .then(function (data) {
          vm.insurance = data;
          /* Saving the last state visited in the local storage. */
          $localStorage["last_state_visited"] = {
            id: vm.insurance.id,
            route: "polizas.info",
          };
          if (vm.insurance.life_policy.length > 0) {
            // if (vm.insurance.life_policy[0].personal) {
            //   if (vm.insurance.personal_life_policy.length > 0) {
            //     if ((vm.insurance.personal_life_policy.includes(vm.insurance.life_policy[0].personal.url)) && (vm.insurance.personal_life_policy.indexOf(vm.insurance.life_policy[0].personal.url))) {
            //     }else{
            //     }
            //   }
            // }
          }
          if (vm.insurance.ref_policy) {
            vm.insurance.ref_policy.forEach(function (refs) {
              $http
                .get(refs.referenciador)
                .then(function success(response_ref_plicy) {
                  if (response_ref_plicy) {
                    refs.data = response_ref_plicy.data;
                  }
                });
            });
          }
          if (parseInt(vm.insurance.business_line) == 1) {
            $scope.businessLine = "Comercial";
          }
          if (parseInt(vm.insurance.business_line) == 2) {
            $scope.businessLine = "Personal";
          }
          if (parseInt(vm.insurance.business_line) == 0) {
            $scope.businessLine = "Otro";
          }

          if (vm.insurance.celula) {
            $http.get(vm.insurance.celula).then(function (response) {
              $scope.celula = response.data.celula_name;
            });
          }

          // verificar si es o no multianual
          var d_start = new Date(vm.insurance.start_of_validity);
          var d_end = new Date(vm.insurance.end_of_validity);

          var year_start = d_start.getFullYear();
          var year_end = d_end.getFullYear();

          var vigencia_ = parseInt(year_end) - parseInt(year_start);

          if (vigencia_ > 1) {
            $scope.poliza_multianual = true;
          } else {
            $scope.poliza_multianual = false;
          }

          if (vm.insurance.automobiles_policy.length) {
            vm.insurance.automobiles_policy[0].usage = parseInt(
              vm.insurance.automobiles_policy[0].usage
            );
          }
          $scope.existeNueva = false;
          $http({
            method: "GET",
            url: url.IP + "historic-policies/",
            params: {
              actual_id: data.id,
            },
          }).then(function success(response) {
            if (response.data.results.length) {
              vm.showHistoric = true;
            }
            vm.policy_history = [];
            response.data.results.forEach(function function_name(old) {
              if (vm.insurance.id != old.base_policy.id) {
                vm.policy_history.push(old.base_policy);
              } else if (old.new_policy) {
                vm.policy_history.push(old.new_policy);
                $scope.existeNueva = true;
              }
            });
          });
          // --------------------
          $http({
            method: "GET",
            url: url.IP + "historic-policies/",
            params: {
              actual_id: data.id,
            },
          }).then(function success(response) {
            vm.policy_history_1 = [];
            response.data.results.forEach(function function_name(old) {
              if (vm.insurance.id != old.base_policy.id) {
                vm.policy_history_1.push(old.base_policy);
              }
            });
          });

          // -------------------------******

          if (vm.insurance.status < 10) {
            var param = {
              model: 6,
            };
          } else {
            var param = {
              model: 1,
            };
          }
          $http({
            method: "GET",
            url: url.IP + "cartas-by-model",
            params: param,
          }).then(function success(response) {
            vm.cartas = response.data;
          });

          $http({
            method: "GET",
            url: url.IP + "get-endosos-sinister",
            params: {
              policy: data.id,
            },
          }).then(function success(response) {
            vm.conteos = response.data;
          });
          // if (data.natural || data.juridical){
          if (data.contractor) {
            $http({
              method: "GET",
              url: url.IP + "notas-by-contractor/",
              params: {
                // contractor: data.natural ? data.natural : data.juridical,
                contractor: data.contractor,
                type_contractor: data.natural ? "natural" : "juridical",
                poliza_id: data.id,
              },
            }).then(function success(response) {
              vm.notas = response.data;
            });

            // if(data.juridical)
            //   var url_aux = url.IP + 'morales-resume-medium/'+ data.juridical+'/';
            // else
            //   var url_aux = url.IP + 'fisicas-resume-medium/'+ data.natural+'/';
            var url_aux =
              url.IP + "contractors-resume-medium/" + data.contractor + "/";
            $http({
              method: "GET",
              url: url_aux,
            }).then(
              function success(response) {
                $scope.contratante = response.data;
                if ($scope.contratante.phone_number) {
                  var phone_number = $scope.contratante.phone_number
                    .replace(/^\D+/g, "")
                    .replace("'}", "");
                  $scope.contratante.phone_number = phone_number;
                } else {
                  $scope.no_phone = "Sin teléfono asignado";
                }
                if ($scope.contratante.email) {
                  $scope.email = response.data.email;
                } else {
                  $scope.no_email = "Sin correo asignado";
                }
                // if(data.juridical)
                //   $scope.addressContratante = response.data.address_juridical[0];
                // else{
                //   $scope.addressContratante = response.data.address_natural[0];
                // }
                $scope.addressContratante = response.data.address_contractor[0];

                if ($scope.contratante.cellule) {
                  $scope.contratante.cellule =
                    $scope.contratante.cellule.celula_name;
                }
                if ($scope.contratante.grouping_level) {
                  $http
                    .get(
                      url.IP +
                        "groupinglevel/" +
                        $scope.contratante.grouping_level
                    )
                    .then(function (response) {
                      $scope.contratante.grouping_level =
                        response.data.description;
                    });
                }

                if ($scope.contratante.subgrouping) {
                  $http
                    .get(
                      url.IP + "groupinglevel/" + $scope.contratante.subgrouping
                    )
                    .then(function (response) {
                      $scope.contratante.subgrouping =
                        response.data.description;
                    });
                }

                if ($scope.contratante.subsubgrouping) {
                  $http
                    .get(
                      url.IP +
                        "groupinglevel/" +
                        $scope.contratante.subsubgrouping
                    )
                    .then(function (response) {
                      $scope.contratante.subsubgrouping =
                        response.data.description;
                    });
                }
              },
              function error(response) {
                console.log("error", response);
              }
            );
          }
          vm.observations = data.observations;

          vm.show.isPolicy = helpers.isPolicy(data);
          var wait = [];
          var dfd = $q.defer();
          data.recibos_poliza = data.receipts_poliza;
          // data.recibos_poliza.forEach(function (recibo) {
          //   wait.push($http.get(recibo));
          // })

          vm.files = [];
          $http
            .get(url.IP + "polizas/" + vm.insurance.id + "/archivos/")
            .then(function (response) {
              if (response.status === 200) {
                vm.files = response.data.results;
                $scope.files = response.data.results;
                $scope.show_files_policy = true;
                loadGeneralConditions();
              } else if (response.status === 403) {
                $scope.show_files_policy = false;
              }
            });

          // $q.all(wait).then(function(responses) {
          var aux = [];
          var recibos = [];
          vm.receipts = [];

          data.receipts_poliza.forEach(function (recibo) {
            // if(recibo.data.isCopy == true){
            if (recibo.isCopy == true) {
            } else {
              // var item = parseFloat(recibo.data.prima_total);
              var item = parseFloat(recibo.prima_total);
              recibos.push(item);
              // aux.push(recibo.data);
              aux.push(recibo);
            }
          });

          recibos = data.receipts_poliza;
          $scope.recibos = recibos.sort();

          $scope.prima_total = function () {
            return data.p_total;
          };

          $scope.prima_neta = function () {
            // var p_neta_desc = data.p_neta - (data.p_neta * (data.descuento * 0.01));
            // return p_neta_desc
            return data.p_neta;
          };

          $scope.derecho = function () {
            return data.derecho;
          };

          $scope.recargo = function () {
            return data.rpf;
          };

          $scope.iva = function () {
            return data.iva;
          };
          $scope.descuento = function () {
            // var p_desc = parseFloat(data.p_neta * ((data.descuento * 0.01))).toFixed(2);
            return data.descuento;
            // return p_desc;
          };

          function getSum(total, num) {
            return total + num;
          }

          vm.receipts = aux;
          vm.policy_receipts_show = [];
          vm.endorsement_receipts_show = [];
          vm.endosos_options = [];
          vm.endorsement_receipts_show_bak = [];
          $scope.data_sums = {
            p_neta: 0,
            derecho: 0,
            rpf: 0,
            p_total: 0,
            comision: 0,
            iva: 0,
          };
          vm.receipts_manual = 0;
          vm.receipts.forEach(function (receipt) {
            if (receipt.serie_manual) {
              vm.receipts_manual = vm.receipts_manual + 1;
            }
            $scope.isCat = false;
            if (receipt.status == 0) {
              return;
            }

            if (receipt.receipt_type == 1) {
              $scope.view_sums = false;
              $scope.isCat = receipt.is_cat;
              var lengRec = vm.insurance.recibos_poliza.length;
              var length = 0;
              $scope.data_sums.p_neta = parseFloat(
                parseFloat($scope.data_sums.p_neta) +
                  parseFloat(receipt.prima_neta)
              ).toFixed(2);
              $scope.data_sums.derecho = parseFloat(
                parseFloat($scope.data_sums.derecho) +
                  parseFloat(receipt.derecho)
              ).toFixed(2);
              $scope.data_sums.rpf = parseFloat(
                parseFloat($scope.data_sums.rpf) + parseFloat(receipt.rpf)
              ).toFixed(2);
              $scope.data_sums.p_total = parseFloat(
                parseFloat($scope.data_sums.p_total) +
                  parseFloat(receipt.prima_total)
              ).toFixed(2);
              if (receipt.status != 6) {
                $scope.data_sums.comision = parseFloat(
                  parseFloat($scope.data_sums.comision) +
                    parseFloat(receipt.comision)
                ).toFixed(2);
              } else if (receipt.status == 6) {
                $scope.data_sums.comision = parseFloat(
                  parseFloat($scope.data_sums.comision) +
                    parseFloat(receipt.comision_conciliada)
                ).toFixed(2);
              }
              $scope.data_sums.iva = parseFloat(
                parseFloat($scope.data_sums.iva) + parseFloat(receipt.iva)
              ).toFixed(2);
              vm.policy_receipts_show.push(receipt);
            } else {
              function findCoincidences(argument) {
                return argument === receipt.endo_aux;
              }
              if (!vm.endosos_options.find(findCoincidences)) {
                vm.endosos_options.push(receipt.endo_aux);
              }

              vm.endorsement_receipts_show.push(receipt);
              vm.endorsement_receipts_show_bak.push(receipt);
            }
          });

          if ($scope.poliza_multianual) {
            $scope.polizasMultianuales();
          }
          // });
        });
      return vm.insurance.folio;
    }

    $scope.polizasMultianuales = function () {
      $scope.receipts_policy = [];
      vm.receipts.forEach(function (item) {
        if (item.receipt_type == 1) {
          $scope.receipts_policy.push(item);
        }
      });

      $scope.aniosPoliza = [];

      var date_initial = convertDate(vm.insurance.start_of_validity).split("/");
      var date_final = convertDate(vm.insurance.end_of_validity).split("/");
      var anio_initial = parseInt(date_initial[2]);
      var anio_final = parseInt(date_final[2]);
      var total_anios = anio_final - anio_initial;

      for (var i = 1; i <= total_anios; i++) {
        $scope.aniosPoliza.push(i);
      }

      $scope.anioPoliza = $scope.aniosPoliza[0];
      $scope.showReceiptsYear($scope.anioPoliza);
    };

    $scope.showReceiptsYear = function (value) {
      var fechaPrincipal = convertDate(vm.insurance.start_of_validity);
      var arrayFecha = fechaPrincipal.split("/");
      var dia = parseFloat(arrayFecha[0]);
      var mes = parseFloat(arrayFecha[1]);
      var anioInicial = parseFloat(arrayFecha[2]) + (value - 1);
      var anioFinal = parseFloat(arrayFecha[2]) + value;
      var fechaInicial = mes + "/" + dia + "/" + anioInicial;
      var fechaTerminacion = mes + "/" + dia + "/" + anioFinal;
      if (vm.insurance.forma_de_pago != 5) {
        vm.policy_receipts_show = [];
        $scope.receipts_policy.forEach(function (item, index) {
          // if(item.fecha_inicio >= new Date(fechaInicial).toISOString() && item.fecha_inicio < new Date(fechaTerminacion).toISOString()){
          if (
            new Date(item.fecha_inicio) >= new Date(fechaInicial) &&
            new Date(item.fecha_inicio) < new Date(fechaTerminacion)
          ) {
            vm.policy_receipts_show.push(item);
          }
        });
      }
    };

    $scope.changeFrecuencyMultianual = function () {
      if ($scope.anioPoliza != 1) {
        $scope.flag_pay = false;
        vm.policy_receipts_show.forEach(function (item) {
          if (item.status != 4) {
            $scope.flag_pay = true;
          }
        });

        if ($scope.flag_pay) {
          SweetAlert.swal(
            "Error",
            "No se puede cambiar la frecuencia de este año porque existen recibos pagados.",
            "error"
          );
          return;
        } else {
          var policy_receipts = $scope.json_poliza[$scope.anioPoliza - 2];

          var dates = {
            inicio: convertDate(policy_receipts[0].fecha_inicio) + " 00:00:00",
            fin:
              convertDate(
                policy_receipts[policy_receipts.length - 1].fecha_fin
              ) + " 00:00:00",
            id_poliza: vm.insurance.id,
          };

          $http
            .post(url.IP + "get-anios-subsecuentes/", dates)
            .then(function (can_pay) {
              $scope.can_pay = can_pay.data.canpay;
              if ($scope.can_pay) {
                SweetAlert.swal(
                  {
                    title: "¿Estás seguro?",
                    text: "La frecuencia cambiará a partir de este año en adelante.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Si",
                    cancelButtonText: "No",
                  },
                  function (isConfirm) {
                    if (isConfirm) {
                      var modalInstance = $uibModal.open({
                        templateUrl: "app/polizas/recalculoModal.html",
                        controller: RecalcularModalCtrl,
                        controllerAs: "order",
                        size: "lg",
                        resolve: {
                          receipts: function () {
                            return vm.policy_receipts_show;
                          },
                          insurance: function () {
                            return vm.insurance;
                          },
                        },
                        backdrop:
                          "static" /* this prevent user interaction with the background */,
                        keyboard: false,
                      });
                      modalInstance.closed.then(function (receipt) {
                        activate();
                      });
                    }
                  }
                );
              } else {
                SweetAlert.swal(
                  "Error",
                  "No se puede cambiar la frecuencia de este año porque existen recibos anteriores pendientes.",
                  "error"
                );
                return;
              }
            });
        }
      }
    };

    function changeEndorsement(endorsement) {
      if (endorsement) {
        vm.endorsement_receipts_show = [];
        vm.endorsement_receipts_show_bak.forEach(function (child) {
          if (child.endo_aux == endorsement) {
            vm.endorsement_receipts_show.push(child);
          }
        });
      } else {
        vm.endorsement_receipts_show = vm.endorsement_receipts_show_bak;
      }
    }

    function RecalcularModalCtrl(
      $scope,
      $uibModalInstance,
      receipts,
      insurance
    ) {
      var order = this;

      $scope.payments = [
        { name: "Mensual", value: "12" },
        { name: "Bimestral", value: "2" },
        { name: "Trimestral", value: "3" },
        { name: "Semestral", value: "6" },
        { name: "Anual", value: "1" },
      ];

      order.form = {
        subramo: { subramo_name: insurance.subramo },
        startDate: convertDate(receipts[0].fecha_inicio),
        endingDate: convertDate(insurance.end_of_validity),
      };

      var date1 = new Date(receipts[0].fecha_inicio);
      var date2 = new Date(insurance.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      order.form.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );

      $scope.changePayment = function (pay) {
        order.form.payment = pay.value;
      };

      $scope.saveNewReceipts = function () {};

      $scope.cancel = function (pay) {
        $uibModalInstance.dismiss("cancel");
      };
    }

    function PolicyModalCtrl(
      $scope,
      contractorModal,
      $uibModalInstance,
      urlInsurance,
      receipts
    ) {
      $scope.buttonDisabled = true;
      $scope.addnotasToCancel = true;
      if (vm.insurance.poliza_number) {
        $scope.optionsCancel = [
          { value: 1, label: "Cancelación Tipo D" },
          { value: 2, label: "Precancelación" },
          { value: 3, label: "Cancelación definitiva - A petición" },
          { value: 4, label: "Cancelación definitiva - Falta de pago" },
        ];
      } else if (vm.acceso_canc_pol) {
        $scope.optionsCancel = [
          { value: 1, label: "Cancelación Tipo D" },
          { value: 2, label: "Precancelación" },
        ];
      } else {
        $scope.optionsCancel = [{ value: 2, label: "Precancelación" }];
      }
      $scope.optionCancel = $scope.optionsCancel[2];
      $scope.date_cancel = convertDate(new Date());
      vm.insurance.date_cancel = convertDate(new Date());
      $scope.checkCancelDate = function (dat) {
        $scope.date_cancel = dat;
      };
      $scope.addnotasToCancelF = function (addnotas) {
        $scope.addnotasToCancel = addnotas;
      };
      $scope.cancelPolicy = function (option, reason, date, addnotas) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (option.value == 1) {
          var params = {
            myInsurance: vm.insurance,
            contractor: contractorModal,
          };
          $scope.iracrearendoso("Endoso", "endorsement.endorsement", params);
          // $state.go('endorsement.endorsement',params);
          $uibModalInstance.dismiss("cancel");
        } else if (option.value == 2) {
          var user_cancel = vm.user.nameFull;
          vm.notas_cancel = [];
          $http
            .patch(urlInsurance, { status: 4, reason_cancel: reason })
            .then(function (data) {
              if (data.status === 200 || data.status === 201) {
                vm.insurance.status = data.data.status;
                vm.insurance.reason_cancel = data.data.reason_cancel;
                $http
                  .post(url.IP + "cancel-policy-manual/", {
                    id: vm.insurance.id,
                    user_cancel: user_cancel,
                  })
                  .then(
                    function success(request) {
                      $uibModalInstance.dismiss("cancel");
                      if (request.data.status == "sent") {
                        swal(
                          "¡Listo!",
                          "Se ha enviado un correo al administrador",
                          "success"
                        );
                        receipts.forEach(function (child) {
                          if (child.status == 4 && child.receipt_type != 3) {
                            var params = {
                              model: 4,
                              event: "PATCH",
                              associated_id: child.id,
                              identifier:
                                " actualizo el recibo pendiente de pago a cerrado al cancelar la póliza: " +
                                vm.insurance.poliza_number,
                            };
                            dataFactory
                              .post("send-log/", params)
                              .then(function success(response) {});
                            $http
                              .patch(child.url, { status: 8 })
                              .then(function (data_receipt) {});
                          }
                        });
                        var params = {
                          model: 1,
                          event: "POST",
                          associated_id: vm.insurance.id,
                          identifier: vm.insurance.poliza_number
                            ? "precanceló la póliza."
                            : "precanceló canceló la OT.",
                        };
                        dataFactory
                          .post("send-log/", params)
                          .then(function success(response) {});
                        l.stop();
                        activate();
                      } else {
                        swal(
                          "Error",
                          "No se envió la póliza. Contacte a su administrador.",
                          "error"
                        );
                        l.stop();
                      }
                    },
                    function error(error) {
                      console.log("error - email", error);
                    }
                  )
                  .catch(function (e) {
                    console.log("error - catch", e);
                  });
              }
            });
        } else if (option.value == 3 || option.value == 4) {
          if (date) {
            date = datesFactory.toDate(date);
          } else {
            date = new Date();
          }
          $http
            .patch(urlInsurance, {
              status: 11,
              reason_cancel: option.label + " // " + reason,
              date_cancel: date,
              cancelnotas: $scope.addnotasToCancel,
            })
            .then(function (data) {
              vm.insurance.status = data.data.status;
              receipts.forEach(function (child) {
                if (
                  (child.status == 4 || child.status == 3) &&
                  child.receipt_type != 3 &&
                  addnotas == false
                ) {
                  var params = {
                    model: 4,
                    event: "PATCH",
                    associated_id: child.id,
                    identifier:
                      " cancelo recibo al cancelar la póliza: " +
                      vm.insurance.poliza_number,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  $http.patch(child.url, { status: 2 });
                }
                if (
                  (child.status == 4 || child.status == 3) &&
                  addnotas == true
                ) {
                  var params = {
                    model: 4,
                    event: "PATCH",
                    associated_id: child.id,
                    identifier:
                      " cancelo recibo al cancelar la póliza: " +
                      vm.insurance.poliza_number,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  $http.patch(child.url, { status: 2 });
                }
              });
              if (addnotas == false) {
                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: vm.insurance.id,
                  identifier: "canceló la póliza de forma definitiva.",
                };
              } else {
                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: vm.insurance.id,
                  identifier:
                    "canceló la póliza de forma definitiva y sus notas.",
                };
              }
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              l.stop();
              activate();
              $uibModalInstance.dismiss("cancel");
              swal(
                "Hecho",
                "Se ha cancelado definitivamente la póliza",
                "success"
              );
            });
        }
      };
      $scope.iracrearendoso = function (name, route, params) {
        $scope.name_for_new_tab = name;
        $scope.route_for_new_tab = route;

        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }

        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });

          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab),
          };
        }
        $localStorage.tab_states = appStates.states;

        var params = { myInsurance: vm.insurance, contractor: contractorModal };
        if (route == "endorsement.endorsement") {
          $localStorage["save_filters_endoso_poliza"] = {};
          $localStorage["save_filters_endoso_poliza"]["poliza"] =
            vm.insurance.poliza_number;
          $localStorage["save_filters_endoso_poliza"]["poliza_id"] =
            vm.insurance.id;
          $localStorage["save_filters_endoso_poliza"]["origin_endorsement"] =
            vm.insurance;
        }
        $state.go($scope.route_for_new_tab, params);
      };
      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    function cancelPolicy(id) {
      // dataFactory.get('has-cancel-policy-permission')
      // .then(function success(response) {
      //   if(true){
      if (
        vm.insurance.status == 4 ||
        vm.insurance.status == 1 ||
        vm.insurance.status == 2
      ) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: vm.insurance.poliza_number
              ? "La póliza " + vm.insurance.poliza_number + " quedara cancelada"
              : "Se cancelará la OT",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              if (vm.insurance.status == 4) {
                var data = {
                  status: 11,
                };
              } else {
                var data = {
                  status: 2,
                };
              }
              $http
                .patch(vm.insurance.url, data)
                .then(function success(response) {
                  if (response.status == 200 && vm.insurance.status == 4) {
                    vm.notas_cancel = [];
                    if (vm.notas) {
                      vm.notas.forEach(function notas(no) {
                        if (no.policy.id == vm.insurance.id) {
                          // if (no.status == 1) {
                          //   no.status = 4
                          //   vm.notas_cancel.push(no)
                          //   $http.patch(no.url, {status: 4}).then(function success(response) {
                          //     if(response.status == 200 || response.status == 201){
                          //       var params = {
                          //         'model': 4,
                          //         'event': "PATCH",
                          //         'associated_id': response.data.id,
                          //         'identifier': ' cambio estatus de nota a pendiente de pago al cancelar la póliza',
                          //       }
                          //       dataFactory.post('send-log/', params).then(function success(response) {
                          //       });
                          //     }
                          //   })
                          // }
                        }
                      });
                    }
                    vm.insurance.recibos_poliza.forEach(function (recibo) {
                      $http.get(recibo).then(function success(respponse) {
                        if (
                          respponse.data.status != 1 &&
                          respponse.data.status != 5 &&
                          respponse.data.status != 6 &&
                          respponse.data.receipt_type != 3
                        ) {
                          var params = {
                            model: 4,
                            event: "PATCH",
                            associated_id: respponse.data.id,
                            identifier:
                              " cambio estatus de recibo a cancelado al cancelar la póliza",
                          };
                          dataFactory
                            .post("send-log/", params)
                            .then(function success(response) {});
                          $http.patch(recibo, { status: 2 });
                        }
                      });
                    });
                  }

                  var params = {
                    model: 1,
                    event: "POST",
                    associated_id: vm.insurance.id,
                    identifier: vm.insurance.poliza_number
                      ? "canceló la póliza."
                      : "canceló canceló la OT.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});

                  SweetAlert.swal(
                    "Hecho",
                    MESSAGES.OK.POLICYCANCELED,
                    "success"
                  );
                  vm.insurance.status = response.data.status;
                });
            } else {
              SweetAlert.swal("Cancelado", MESSAGES.OK.CANCELEDCANCEL, "error");
            }
          }
        );
      } else {
        var modalInstance = $uibModal.open({
          templateUrl: "app/polizas/poliza.modal.html",
          controller: PolicyModalCtrl,
          controllerAs: "vmm",
          size: "md",
          resolve: {
            contractorModal: function () {
              return $scope.contratante;
            },
            urlInsurance: function () {
              return vm.insurance.url;
            },
            receipts: function () {
              return vm.receipts;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        modalInstance.result.then(function (receipt) {
          $state.go("polizas.info", { polizaId: myInsurance.id });
        });
      }
      //     } else {
      //       SweetAlert.swal("Error", "No tienes permiso para realizar esta acción", "error");
      //     }
      // })
    }
    function reActivatePolicy(id, poliza_number) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/polizas.rehabilitar.html",
        controller: ReActivatePolicyCtrl,
        controllerAs: "vmm",
        size: "md",
        resolve: {
          idInsurance: function () {
            return vm.insurance.id;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (response) {
        $http
          .post(url.IP + "rehabilitar-poliza/", response)
          .then(
            function (response_rehabilitar) {
              console.log("response_rehabilitar", response_rehabilitar);

              var params = {
                model: 1,
                event: "POST",
                associated_id: id,
                identifier: poliza_number
                  ? "reactivo la póliza."
                  : "reactivo la OT.",
              };
              dataFactory.post("send-log/", params);
              toaster.success("Se rehabilitó la póliza correctamente");

              setTimeout(function () {
                location.reload();
              }, 1500);
            },
            function (error) {
              console.log("Error al rehabilitar ", error);
              toaster.error("ocurrión un error al rehabilitar la póliza");
            }
          )
          .catch(function (error) {
            console.log("Error al rehabilitar ", error);
            toaster.error("ocurrión un error al rehabilitar la póliza");
          });
      });
    }

    function ReActivatePolicyCtrl($scope, $uibModalInstance, idInsurance) {
      $scope.buttonDisabled = true;
      $scope.mostrar_alerta = false;
      $scope.motivo_rehabilitacion = "";
      $scope.reActivatePolicy = function () {
        $uibModalInstance.close({
          motivo_rehabilitacion: $scope.motivo_rehabilitacion,
          id: idInsurance,
        });
      };

      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    function createRecordatorio(registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return vm.insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }
    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };

    function reactivePolicy(id) {
      // dataFactory.get('has-cancel-policy-permission')
      // .then(function success(response) {
      //   if(true){
      if (vm.insurance.status == 4 || vm.insurance.status == 11) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: vm.insurance.poliza_number
              ? "La póliza " +
                vm.insurance.poliza_number +
                " quedará en Estatus Vigente"
              : "Se recativará la OT En Trámite",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              if (vm.insurance.status == 4 || vm.insurance.status == 11) {
                var data = {
                  status: 14,
                };
              } else {
                var data = {
                  status: 1,
                };
              }
              $http
                .patch(vm.insurance.url, data)
                .then(function success(response) {
                  if (
                    response.status == 200 &&
                    (vm.insurance.status == 4 || vm.insurance.status == 11)
                  ) {
                    console.log(
                      "---vm.insurance.recibos_poliza",
                      vm.insurance.recibos_poliza,
                      response
                    );
                    vm.insurance.recibos_poliza.forEach(function (recibo) {
                      $http.get(recibo).then(function success(respponse) {
                        if (respponse.data.status == 8) {
                          var params = {
                            model: 4,
                            event: "PATCH",
                            associated_id: respponse.data.id,
                            identifier:
                              " actualizo recibo de cerrado a pendiente de pago al reactivar la póliza: " +
                              vm.insurance.poliza_number,
                          };
                          dataFactory
                            .post("send-log/", params)
                            .then(function success(response) {});
                          $http.patch(recibo, { status: 4 });
                        } else if (respponse.data.status == 2) {
                          var params = {
                            model: 4,
                            event: "PATCH",
                            associated_id: respponse.data.id,
                            identifier:
                              " actualizo recibo de cancelado a pendiente de pago al reactivar la póliza: " +
                              vm.insurance.poliza_number,
                          };
                          dataFactory
                            .post("send-log/", params)
                            .then(function success(response) {});
                          $http.patch(recibo, { status: 4 });
                        }
                      });
                    });
                  }

                  var params = {
                    model: 1,
                    event: "POST",
                    associated_id: vm.insurance.id,
                    identifier: vm.insurance.poliza_number
                      ? "reactivo la póliza."
                      : "reactivo la OT.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});

                  SweetAlert.swal(
                    "Hecho",
                    MESSAGES.OK.POLICYREACTIVED,
                    "success"
                  );
                  vm.insurance.status = response.data.status;
                });
            } else {
              SweetAlert.swal(
                "Reactivación",
                MESSAGES.OK.CANCELEDCANCEL,
                "error"
              );
            }
          }
        );
      } else {
        var modalInstance = $uibModal.open({
          templateUrl: "app/polizas/poliza.modal.html",
          controller: PolicyModalCtrl,
          controllerAs: "vmm",
          size: "md",
          resolve: {
            contractorModal: function () {
              return $scope.contratante;
            },
            urlInsurance: function () {
              return vm.insurance.url;
            },
            receipts: function () {
              return vm.receipts;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        modalInstance.result.then(function (receipt) {
          $state.go("polizas.info", { polizaId: myInsurance.id });
        });
      }
      //     } else {
      //       SweetAlert.swal("Error", "No tienes permiso para realizar esta acción", "error");
      //     }
      // })
    }

    $scope.openModal = function (task) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/tasks/task.modal.html",
        controller: "TareasModalCtrl",
        size: "lg",
        resolve: {
          task: function () {
            return task;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          receipt: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          activate();
        },
        function () {
          console.info("modal closed");
        }
      );
    };
    function DeleteElementController(
      $scope,
      $uibModalInstance,
      log,
      valores,
      item,
      tipo,
      poliza
    ) {
      $scope.aeliminar = log;
      $scope.lista = valores;
      $scope.tipo = tipo;
      $scope.itemDelete = item;
      // 1------subgrupo,2-categoria,c3--ertificado
      $scope.okay = function (x) {
        var texto = "";
        var texto2 = "";
        var texto3 = "";
        if (item.document_type == 1) {
          texto = "Subgrupo";
          texto2 =
            "Se eliminará la Póliza, y todas sus dependencias, ¿Estás Seguro?";
          texto3 =
            "Se ha eliminado la Póliza " +
            item.name +
            "(" +
            item.id +
            ") y sus relaciones ";
        }
        SweetAlert.swal(
          {
            title: "Eliminar " + texto,
            text: texto2 + "\n",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              // if(param.categorias.length > 1){
              $http
                .delete(item.url)
                .then(function success(response) {
                  if (response.status == 204) {
                    var paramsLogP_ = {
                      model: 18,
                      event: "PATCH",
                      associated_id: poliza.id,
                      change: log,
                      identifier: texto3,
                    };
                    dataFactory
                      .post("send_log_specific/", paramsLogP_)
                      .then(function success(response) {});
                    var paramsLogP = {
                      model: 1,
                      event: "PATCH",
                      associated_id: carpolizaatula.id,
                      change: log,
                      identifier: texto3,
                    };
                    dataFactory
                      .post("send_log_specific/", paramsLogP)
                      .then(function success(response) {
                        SweetAlert.swal("¡Listo!", texto3, "success");
                        $uibModalInstance.dismiss("cancel");
                      });
                  }
                })
                .catch(function (e) {
                  console.log("e", e);
                });
              // }else{
              //   SweetAlert.swal("Error", "No se eliminó la categoría porque el subgrupo no puede quedarse sin categorías.", "error");
              // }
            }
          }
        );
        // $uibModalInstance.dismiss('cancel');
      };
      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }
    function ModalInstanceCtrlCancelPolicy($scope, $uibModalInstance) {
      if (vm.insurance.poliza_number > 0) $scope.is_policy = true;
      else $scope.is_policy = false;
      $scope.ok = function () {
        var d = new Date();
        var today = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        // today.toLocaleFormat('%YY- %mm-%dd');

        for (var i = 0; i < vm.receipts.length; i++) {
          if (vm.receipts[i].status != 1) {
            var params = {
              model: 4,
              event: "PATCH",
              associated_id: vm.receipts[i].id,
              identifier: " actualizo recibo a cancelado al cancelar la póliza",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            $http.patch(vm.receipts[i].url, { status: 2 });
          }
        }
        if (vm.insurance.status < 10) {
          var params = {
            model: 1,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " cancelo la OT",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          $http.patch(vm.insurance.url, { status: 2 });
        } else {
          var params = {
            model: 1,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " cancelo la póliza",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          $http
            .patch(vm.insurance.url, { status: 11 })
            .then(function success(dataupdatecancel) {
              if (vm.insurance.renewed_status == 2) {
                $http.patch(vm.insurance.url, { renewed_status: 1 });
              }
            });
        }

        setTimeout(function () {
          $state.go("polizas.table");
        }, 1000);
        $uibModalInstance.dismiss("cancel");
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.renovarPolizaRehabilitate = function (idp, numerop) {
      $scope.date1 = convertDate(
        datesFactory.toDate(convertDate(vm.insurance.end_of_validity))
      );
      if (process($scope.date1) < process(convertDate(new Date()))) {
        $scope.status_nuevo = 13;
      } else if (process($scope.date1) > process(convertDate(new Date()))) {
        $scope.status_nuevo = 14;
      } else {
        $scope.status_nuevo = 13;
      }
      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }
      SweetAlert.swal(
        {
          title: "Actualización de Póliza para Renovación",
          text:
            "Los cambios se aplicarán en la Póliza " +
            vm.insurance.poliza_number,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .patch(vm.insurance.url, {
                status: $scope.status_nuevo,
                renewed_status: 0,
                reason_ren: null,
              })
              .then(upgPolicyComplete)
              .catch(upgPolicyFailed);
            function upgPolicyComplete(response, status, headers, config) {
              if (response.status === 200 || response.status === 201) {
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.UPGRADEPOLICY,
                  "success"
                );
                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: vm.insurance.id,
                  identifier: "actualizo la póliza para ser renovada ",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                setTimeout(function () {
                  location.reload();
                }, 1500);
              }
            }
            function upgPolicyFailed(response, status, headers, config) {
              return response;
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La póliza no se ha afectado",
              "error"
            );
          }
        }
      );
    };
    function deletePolicy(id) {
      $scope.text_patch_ant = "";
      $scope.status_ant = "";
      $scope.text_patch_ant = "";
      if (vm.insurance.status == 1 || vm.insurance.status == 2) {
        if (vm.policy_history_1.length > 0) {
          if (vm.policy_history_1[0].status != 12) {
            $scope.text_patch_ant =
              " \nSe cambiará el estatus de la póliza: " +
              vm.policy_history_1[0].poliza_number +
              " asociada";
            $scope.status_ant = vm.policy_history_1[0].status;
          } else {
            if (vm.policy_history_1[0].status == 12) {
              $scope.text_patch_ant = "";
              $scope.status_ant = vm.policy_history_1[0].status;
            }
            $scope.text_patch_ant = "";
            $scope.status_ant = vm.policy_history_1[0].status;
          }
        }
      }
      if (vm.policy_history_1.length > 0) {
        $scope.date1 = convertDate(
          datesFactory.toDate(
            convertDate(vm.policy_history_1[0].end_of_validity)
          )
        );
        if (process($scope.date1) < process(convertDate(new Date()))) {
          $scope.status_ant = 13;
        } else if (process($scope.date1) > process(convertDate(new Date()))) {
          $scope.status_ant = 14;
        } else {
          $scope.status_ant = vm.policy_history_1[0].status;
        }
      }

      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }

      $http({
        method: "GET",
        url: url.IP + "get-relations-by-id/",
        params: {
          id: vm.insurance.id,
          id_caratula: vm.insurance.id,
        },
      })
        .then(function (response_relations) {
          var foo = response_relations.data["categorias"].map(function (bar) {
            return "ID: " + bar[2] + ",Nombre:" + bar[0] + "\n";
          });
          var crt = response_relations.data["certificados"].map(function (bar) {
            return (
              "ID: " +
              bar[3] +
              ",Certificado:" +
              bar[2] +
              ",Categoría:" +
              bar[0] +
              "\n"
            );
          });
          var arc = response_relations.data["archivos"].map(function (bar) {
            return (
              "ID: " +
              bar[3] +
              ",Nombre:" +
              bar[2] +
              ",PólizaID:" +
              bar[0] +
              "\n"
            );
          });
          var arcc = response_relations.data["archivosCertificados"].map(
            function (bar) {
              return (
                "ID: " +
                bar[3] +
                ",Nombre:" +
                bar[2] +
                ",PólizaID:" +
                bar[0] +
                "\n"
              );
            }
          );
          var end = response_relations.data["endosos"].map(function (bar) {
            return (
              "ID: " +
              bar[2] +
              ",Número:" +
              bar[1] +
              ",Interno:" +
              bar[0] +
              "\n"
            );
          });
          var endc = response_relations.data["endososCertificados"].map(
            function (bar) {
              return (
                "ID: " +
                bar[4] +
                ",Número:" +
                bar[1] +
                ",Interno:" +
                bar[0] +
                ",PolizaN:" +
                bar[2] +
                ",PolizaID:" +
                bar[3] +
                "\n"
              );
            }
          );
          var recs = response_relations.data["recibos"].map(function (bar) {
            return (
              "ID: " + bar[3] + ",Serie:" + bar[0] + ",Tipo:" + bar[1] + "\n"
            );
          });
          var sins = response_relations.data["siniestros"].map(function (bar_) {
            return (
              "ID: " +
              bar_[4] +
              ",Número:" +
              bar_[1] +
              ",Interno:" +
              bar_[0] +
              ",PolizaN:" +
              bar_[2] +
              ",PolizaID:" +
              bar_[3] +
              "\n"
            );
          });
          var sinsc = response_relations.data["siniestrosCertificados"].map(
            function (bar) {
              return (
                "ID: " +
                bar[4] +
                ",Número:" +
                bar[1] +
                ",Interno:" +
                bar[0] +
                ",PolizaN:" +
                bar[2] +
                ",PolizaID:" +
                bar[3] +
                "\n"
              );
            }
          );
          $scope.textLog =
            $scope.textLog +
            "Archivos: " +
            (response_relations.data["archivos"] ? arc : "Sin archivos") +
            "\n";
          $scope.textLog =
            $scope.textLog +
            "Endosos: " +
            (response_relations.data["endosos"] ? end : "Sin endosos") +
            "\n";
          $scope.textLog =
            $scope.textLog +
            "Recibos: " +
            (response_relations.data["recibos"] ? recs : "Sin recibos") +
            "\n";
          $scope.textLog =
            $scope.textLog +
            "Siniestros: " +
            (response_relations.data["siniestros"] ? sins : "Sin siniestros") +
            "\n";
        })
        .catch(function (e) {
          console.log("e", e);
        });
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Los cambios no podrán revertirse." + $scope.text_patch_ant,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .patch(vm.insurance.url, { status: 0 })
              // $http.patch(vm.insurance.url)
              .then(deletePolicyComplete)
              .catch(deletePolicyFailed);
            function deletePolicyComplete(response, status, headers, config) {
              if (response.status === 200 || response.status === 201) {
                var data_email = {
                  id: vm.insurance.id,
                  model: 2,
                  type_person: 0,
                };
                dataFactory
                  .post("send-email-admins-deletes/", data_email)
                  .then(function success(req) {});
                if (vm.policy_history_1.length > 0) {
                  $http
                    .patch(vm.policy_history_1[0].url, {
                      renewed_status: 0,
                      status: $scope.status_ant,
                    })
                    .then(function (xPolicy) {
                      var params = {
                        model: 1,
                        event: "PATCH",
                        associated_id: vm.policy_history_1[0].id,
                        identifier:
                          "cambio el estatus de renovación de la póliza: " +
                          vm.policy_history_1[0].poliza_number +
                          " al eliminar la OT: " +
                          vm.insurance.internal_number,
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                    });
                }
                SweetAlert.swal("¡Listo!", MESSAGES.OK.DELETEPOLICY, "success");

                var params = {
                  model: 1,
                  event: "POST",
                  change: $scope.textLog,
                  associated_id: vm.insurance.id,
                  identifier:
                    "elimino la póliza " + vm.insurance.poliza_number
                      ? vm.insurance.poliza_number
                      : vm.insurance.internal_number,
                };
                // dataFactory.post('send-log/', params).then(function success(response) {    });

                dataFactory
                  .post("send_log_specific/", params)
                  .then(function success(response) {});

                vm.insurance.recibos_poliza.forEach(function (receipt) {
                  if (receipt.id) {
                    var params = {
                      model: 4,
                      event: "PATCH",
                      associated_id: receipt.id,
                      identifier:
                        " actualizo recibo a desactivado por eliminación de póliza",
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                    console.log("receiptttttt", receipt);
                    if (receipt && typeof receipt.url === "string") {
                      // Si el objeto ya trae .url como string, úsala directamente
                      $http.patch(receipt.url, { status: 0 });
                    } else if (typeof receipt === "string") {
                      // Si a veces recibes directamente la URL como string
                      $http.patch(receipt, { status: 0 });
                    } else {
                      console.error(
                        "No se encontró una URL válida en receipt:",
                        receipt
                      );
                    }
                  }
                });

                var name = "Inicio";
                var route = "inicio.inicio";
                $scope.name_for_new_tab = name;
                $scope.route_for_new_tab = route;

                var existe = false;
                if (name && route) {
                  $scope.route_for_new_tab = route;
                  $scope.name_for_new_tab = name;
                  appStates.states.forEach(function (state) {
                    if (state.route == $scope.route_for_new_tab) {
                      existe = true;
                    }
                  });
                }

                if (!existe) {
                  var active_tab = appStates.states.findIndex(function (item) {
                    if (item.active) {
                      return true;
                    }
                    return false;
                  });

                  appStates.states[active_tab] = {
                    name: $scope.name_for_new_tab,
                    heading: $scope.name_for_new_tab,
                    route: $scope.route_for_new_tab,
                    active: true,
                    isVisible: true,
                    href: $state.href($scope.route_for_new_tab),
                  };
                }
                $localStorage.tab_states = appStates.states;
                $state.go($scope.route_for_new_tab);
              }
            }

            function deletePolicyFailed(response, status, headers, config) {
              return response;
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La póliza no se ha eliminado",
              "error"
            );
          }
        }
      );
    }

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function assignPolicy(id) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/polizas.assign.html",
        controller: assignModalView,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policy_id: function () {
            return id;
          },
          contratante: function () {
            return $scope.contratante;
          },
          permiso_administrar_adjuntos: function () {
            return $scope.permiso_administrar_adjuntos;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function assignModalView(
      $scope,
      $uibModalInstance,
      policy_id,
      url,
      contratante,
      permiso_administrar_adjuntos,
      dataFactory
    ) {
      $scope.email = contratante.email;
      $scope.soloEmail = true;
      $scope.permiso_administrar_adjuntos = permiso_administrar_adjuntos;
      $scope.tipopoliza = "Póliza individual";
      $scope.emailscontractor = contratante.email_contractor;
      $scope.contratanteInfo = contratante;
      var vmm = this;
      var share_via_email = [];
      var share_via_email_r = [];
      vmm.is_owner = false;
      vmm.email_assign_mail = "";
      vmm.custom_email = true;
      vmm.htmlVariable = "";
      vmm.first_comment = "";
      vmm.second_comment = "";
      vmm.correos = [];
      $scope.send = true;
      $scope.maxShareMb = 25;
      dataFactory
        .get("emailtemplate-unpag/", {
          template_model: 2,
          id_policy: policy_id,
        })
        .then(function success(response) {
          $scope.plantillas = response.data;
        });
      $http
        .post(url.IP + "get-assign/", { poliza: policy_id })
        .then(
          function success(response) {
            $scope.people_assigned = response.data;
            $scope.owner_exist = true;
            $scope.people_assigned.some(function (people) {
              if (people.is_owner == true) {
                $scope.owner_exist = false;
                return;
              }
            });
          },
          function error(err) {}
        )
        .catch(function (e) {});
      $scope.parseMb = function (sizeStr) {
        if (!sizeStr) return 0;
        // Sacamos número y unidad
        var parts = sizeStr.match(/^([\d.]+)\s*(MB|KB)$/i);
        if (!parts) return 0;

        var value = parseFloat(parts[1]) || 0;
        var unit = parts[2].toUpperCase();

        // Si es KB, lo convertimos a MB; si es MB, lo dejamos
        return unit === "KB" ? value / 1024 : value;
        // return parseFloat(sizeStr) || 0;
      };
      $http
        .get(url.IP + "share-policy-manual/" + vm.insurance.id)
        .then(function (response) {
          if (response.status === 200) {
            vmm.head = response.data.head;
            vmm.body = response.data.body;
            vmm.footer = response.data.footer;
          }
        })
        .catch(function (e) {
          console.log("error - catch", e);
        });
      $scope.changePlantilla = function (item) {
        if (item) {
          vmm.subjectEmail = item.title;
          vmm.first_comment = item.text;
          if (vmm.first_comment.includes("\n")) {
            vmm.first_comment = vmm.first_comment.replace("\n", "<br><br>");
          }
          vmm.second_comment = item.bottom_text;
          vmm.custom_email = true;
          $scope.getTemplate(true);
        } else {
          vmm.subjectEmail = "";
          vmm.first_comment = "";
          vmm.second_comment = "";
          vmm.custom_email = true;
          $scope.getTemplate(true);
        }
      };
      $scope.showEmailInInput = function (email) {
        $scope.email_assign = email;
        // $scope.email_assign = contratante.email;
      };

      $scope.emails = [];

      $scope.addEmail = function (email) {
        if (validateEmail(email) == false) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        } else {
          if ($scope.emails.indexOf(email) < 0) {
            $scope.emails.push(email);
          } else {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.REPEATEMAIL, "error");
          }
          vmm.email_assign_mail = "";
        }
      };
      $scope.remove_email = function (index) {
        $scope.emails.splice(index, 1);
      };

      if (contratante.full_name) {
        var name_contractor = contratante.full_name;
        $http
          .post(url.IP + "contractors-contact/", {
            name: name_contractor,
          })
          .then(function (response) {
            if (response.status === 200) {
              vmm.correos = response.data.contact;
            }
          });
      }

      $scope.sendEmail = function (receipt) {
        $scope.send = false;
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        var data_shared = {
          id: vm.insurance.id,
          emails: $scope.emails,
          files: share_via_email,
          files_r: share_via_email_r,
          subject: vmm.subjectEmail,
          first_comment: vmm.first_comment,
          second_comment: vmm.second_comment,
          model: 1,
          custom_email: vmm.custom_email,
        };
        $http
          .post(url.IP + "share-policy-manual/", data_shared)
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.POLICYSEND, "success");
                $scope.send = true;
                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: vm.insurance.id,
                  identifier: "compartió la póliza por email.",
                  save_logmail: 1,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $uibModalInstance.dismiss("cancel");
              } else {
                $scope.send = true;
                l.stop();
                if (request.data && request.data.status) {
                  SweetAlert.swal("ERROR", request.data.status, "error");
                } else if (request.data && request.data.response) {
                  // SweetAlert.swal("ERROR", request.data.response, "error");
                  SweetAlert.swal(
                    "Error",
                    "No se envió el recordatorio. Contacte a su administrador.",
                    "error"
                  );
                } else {
                  SweetAlert.swal(
                    "ERROR",
                    JSON.stringify(request.data),
                    "error"
                  );
                }
              }
            },
            function error(error) {
              console.log("error - email", error);
            }
          )
          .catch(function (e) {
            console.log("error - catch", e);
          });
      };

      $scope.getTemplate = function (custom_email) {
        if (custom_email) {
          $http
            .get(url.IP + "share-policy-manual/" + vm.insurance.id)
            .then(function (response) {
              if (response.status === 200) {
                vmm.head = response.data.head;
                vmm.body = response.data.body;
                vmm.footer = response.data.footer;
                vmm.subjectDefault = response.data.subject_default;
                if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
                  vmm.subjectEmail = vmm.subjectDefault;
                }
              }
            })
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          vmm.htmlVariable = "";
          vmm.first_comment = "";
          vmm.second_comment = "";
        }
      };
      $scope.emptySubject = function (v) {
        if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
          vmm.subjectEmail = vmm.subjectDefault;
        }
      };
      $scope.deleteEmail = function (email) {
        $http({
          method: "GET",
          url: url.IP + "delete-assign/",
          params: {
            id: email.id,
          },
        })
          .then(function (request) {
            $scope.people_assigned.splice(
              $scope.people_assigned.indexOf(email),
              1
            );
            assignModalView($scope, $uibModalInstance, vm.insurance.id, url);
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };
      if (vm.permiso_administrar_adjuntos) {
        $http
          .get(url.IP + "polizas/" + policy_id + "/archivos/")
          .then(function (response) {
            $scope.files = response.data.results;
            $scope.files.forEach(function (file) {
              file["to_send"] = false;
              file["origin"] = "P";
            });
            $http
              .post(url.IP + "get-recibos-files/", { poliza_id: policy_id })
              .then(function (response) {
                $scope.recibos_file = response.data;
                $scope.recibos_file.forEach(function (file_r) {
                  file_r["origin"] = "R";
                  $scope.files.push(file_r);
                });
                $scope.files.forEach(function (file) {
                  file["to_send"] = false;
                });
              });
          });
      }

      $scope.shareFileEmail = function (file) {
        if (file.to_send) {
          file.to_send = false;
        } else {
          file.to_send = true;
        }
        share_via_email = [];
        share_via_email_r = [];
        $scope.files.forEach(function (filex) {
          if (filex.to_send && filex.origin == "P") {
            share_via_email.push(filex.id);
          }
          if (filex.to_send && filex.origin == "R") {
            share_via_email_r.push(filex.id);
          }
        });
      };

      $scope.shareFile = function (file) {
        $http
          .get(url.IP + "patch-policy-file/" + file.id)
          .then(function (response) {
            if (file.shared) {
              $scope.fileshared = true;
            } else {
              $scope.fileshared = false;
            }
            $scope.files.some(function (filex) {
              if (filex.id == response.data.id) {
                filex.shared = response.data.shared;
              }
            });
            $scope.files[file] = response.data;
            // $scope.shared = response.data.shared;
          });
      };

      $scope.assignPolicy = function (email) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (email) {
          if (validateEmail(email) == false) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
            return;
          }
          var assign = {
            is_owner: vmm.is_owner,
            active: true,
            poliza: policy_id,
            email: email,
          };
          $http
            .post(url.IP + "assign-pendient/", assign)
            .then(function (response) {
              if (response.status === 200 || response.status === 201) {
                if (response.data.type == 1) {
                  l.stop();
                  SweetAlert.swal(
                    "Advertencia",
                    MESSAGES.INFO.POLICYASSIGNED,
                    "warning"
                  );
                  var params = {
                    model: 1,
                    event: "POST",
                    associated_id: vm.insurance.id,
                    identifier: "compartió la póliza por app.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                } else {
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.INFO.POLICYPENDIENT,
                    "success"
                  );
                  var params = {
                    model: 1,
                    event: "POST",
                    associated_id: vm.insurance.id,
                    identifier: "compartió la póliza por app.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                }
              }
            });

          $uibModalInstance.dismiss("cancel");
        } else {
          if ($scope.fileshared && $scope.fileshared == true) {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.FILESHARED, "success");
          }
          l.stop();
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }

    function goToReceipt(receipt, folio) {
      if (folio) {
        var vmmm = receipt;
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/polizas/polizas.receiptsModal.html",
          controller: receiptModalView,
          controllerAs: "vmmm",
          ////windowClass: 'animated fadeIn',
          size: "lg",
          // resolve:{'rn':receipt.recibo_numero,'recibo':receipt},
          resolve: {
            receiptModal: function () {
              return vmmm;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        function receiptModalView($scope, $uibModalInstance, receiptModal) {
          return vmmm;
        }
      } else {
        var vm = this;

        receiptService.setReceiptID(receipt.id);
        $state.go("polizas.recibos", {
          polizaId: vm.polizaId,
          receiptId: receipt.recibo_numero,
        });
      }
    }

    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }

    function getPDF(poliza) {
      var carga = Ladda.create(document.querySelector(".ladda-button"));
      carga.start();
      $http({
        method: "GET",
        url: url.IP + "get-pdf-ot/",
        responseType: "arraybuffer",
        params: {
          id: poliza,
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          toaster.info("Se generó el PDF");
          $scope.pdf = response.data;

          var file = new Blob([response.data], { type: "application/pdf" });

          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
          carga.stop();
          var params = {
            model: 1,
            event: "POST",
            associated_id: poliza,
            identifier: "generó el PDF.",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          // $http({
          //   method: 'GET',
          //   url: url.IP + 'get-pdf',
          //   params: {
          //     'pdf_name': $scope.pdf.pdf_name
          //   },
          //   responseType: 'arraybuffer'

          // }).then(function success(response) {

          //   })
        } else {
          toaster.warning("Ocurrió Un problema,Intenta nuevamente");
        }
      });
    }

    function viewCarta(poliza, carta) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-form/",
        params: {
          id_poliza: poliza,
          id_carta: carta.id,
        },
      }).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }

          var params = {
            model: 1,
            event: "POST",
            associated_id: poliza,
            identifier: "generó la carta " + carta.name + ".",
          };
          dataFactory.post("send-log/", params);
          toaster.info("Se generó el PDF");
          // $scope.pdf = response.data;
          // $http({
          //   method: 'GET',
          //   url: url.IP + 'get-pdf',
          //   params: {
          //     'pdf_name': $scope.pdf.pdf_name
          //   },
          //   responseType: 'arraybuffer'

          // }).then(function success(response) {

          //   })
        } else {
          toaster.warning("Ocurrió Un problema,Intenta nuevamente");
        }
      });
    }

    function goToEndoso(endoso) {
      // var vm = this;

      $state.go("polizas.info", { polizaId: endoso.policy.id });
    }
  }

  //------modal test
  function PolicyPendingModalCtrl(
    $localStorage,
    $scope,
    toaster,
    MESSAGES,
    policyModal,
    $uibModalInstance,
    dataFactory,
    SweetAlert,
    $state,
    insuranceService,
    receiptService,
    url,
    $http,
    $rootScope,
    emailService,
    helpers
  ) {
    var vmm = this;
    vmm.selectedType = "";
    vmm.save = save;
    vmm.status = [];
    vmm.prima_total = 0;
    vmm.iva = 16;
    vmm.sub_total = 0;
    vmm.folio = false;
    vmm.statusIva = true;
    var sumaEndosoRecibo = 0.0;
    vmm.form = {
      folio: "",
      canCreate: false,
    };

    vmm.conductos = {
      "No domiciliada": 1,
      Agente: 2,
      CAC: 3,
      "CAT/Domiciliado": 4,
      Nómina: 5,
      CUT: 6,
    };

    vmm.insuranceServices = insuranceServices;
    // vmm.changeNoPoliza = changeNoPoliza;
    vmm.options = {
      save: save,
      cancel: cancel,
    };
    vmm.policyInfo = policyModal;
    var myInsurance = vmm.policyInfo;
    var contratante = insuranceServices(
      url,
      $http,
      $rootScope,
      vmm.policyInfo,
      insuranceService,
      receiptService
    );
    var ramo = vmm.policyInfo.ramo;
    vmm.form.ramo = {};
    vmm.form.clave = vmm.policyInfo.clave;
    vmm.form.business_line = vmm.policyInfo.business_line;

    if (ramo == "Daños") {
      vmm.form.ramo.ramo_code = 3;
      vmm.form.ramo.ramo_name = "Daños";
    } else if (ramo == "Accidentes y Enfermedades") {
      vmm.form.ramo.ramo_code = 2;
      vmm.form.ramo.ramo_name = "Accidentes y Enfermedades";
    } else {
      vmm.form.ramo.ramo_code = 1;
      vmm.form.ramo.ramo_name = "Vida";
    }
    var payment = vmm.policyInfo.forma_de_pago;
    vmm.form.payment = payment.toString();
    vmm.policyInfo.poliza = vmm.form.poliza;
    // $scope.historicPolicy = function (noPoliza){
    try {
      $http({
        method: "GET",
        url: url.IP + "historic-policies/",
        params: {
          actual_id: vmm.policyInfo.id,
        },
      }).then(function success(response) {
        if (response.data.results.length) {
          vmm.showHistoric = true;
        }
        vmm.policy_history = [];
        response.data.results.forEach(function function_name(old) {
          if (vmm.policyInfo.id != old.base_policy.id) {
            vmm.policy_history.push(old.base_policy);
          } else if (old.new_policy) {
            vmm.policy_history.push(old.new_policy);
          }
        });
      });
    } catch (e) {
      console.log("History policy (update)_", e);
    }

    vmm.defaults = {};
    $http
      .get(url.IP + "claves-by-provider/" + vmm.policyInfo.aseguradora.id)
      .then(function (clavesResponse) {
        clavesResponse.data.forEach(function (clave) {
          clave.clave_comision.forEach(function (item) {
            item.efective_date = new Date(item.efective_date)
              .toISOString()
              .split("T")[0];
            if (vmm.form.subramo) {
              if (item.subramo == vmm.form.subramo.subramo_name) {
                vmm.form.comision_percent = parseFloat(item.comission);
                vmm.form.udi = parseFloat(item.udi);
              }
            } else {
              vmm.form.comision_percent = 0;
              vmm.form.udi = 0;
            }
          });
        });

        vmm.defaults.claves = clavesResponse.data;
        if (vmm.defaults.claves.length == 1) {
          vmm.form.clave = vmm.defaults.claves[0];
        }

        $scope.comisiones_poliza = [];
        for (var i = 0; i < vmm.defaults.claves.length; i++) {
          if (vmm.form.clave.name == vmm.defaults.claves[i].name) {
            $scope.clave_poliza = vmm.defaults.claves[i];
          }
        }

        for (var i = 0; i < $scope.clave_poliza.clave_comision.length; i++) {
          if (
            vmm.form.subramo.subramo_name ==
            $scope.clave_poliza.clave_comision[i].subramo
          ) {
            $scope.comisiones_poliza.push(
              $scope.clave_poliza.clave_comision[i]
            );
          }
        }

        vmm.form.comisiones = $scope.comisiones_poliza;
      });

    $scope.dataToSave = {};
    $scope.changeNoPoliza = function (noPoliza) {
      if (vmm.policy_history.length) {
        var noP = "renovaciones_poliza";
      } else {
        var noP = noPoliza;
      }
      helpers
        .existPolicy(noP)
        .then(function (request) {
          if (request == true) {
            SweetAlert.swal("Error", MESSAGES.ERROR.POLICYEXIST, "error");
            vmm.form.poliza = "";
          }
        })
        .catch(function (err) {});
      // }
    };

    var startDate = convertDate(new Date(vmm.policyInfo.start_of_validity));
    var endingDate = convertDate(new Date(vmm.policyInfo.end_of_validity));
    $scope.dataToSave.start_of_validity = new Date(mesDiaAnio(startDate));
    $scope.dataToSave.end_of_validity = new Date(mesDiaAnio(endingDate));
    vmm.form.startDate = convertDate($scope.dataToSave.start_of_validity);
    vmm.form.endingDate = convertDate($scope.dataToSave.end_of_validity);

    var date1_ = new Date(vmm.policyInfo.start_of_validity);
    var date2_ = new Date(vmm.policyInfo.end_of_validity);

    var timeDiff_ = Math.abs(date2_.getTime() - date1_.getTime());
    vmm.form.policy_days_duration = Math.ceil(timeDiff_ / (1000 * 3600 * 24));

    vmm.form.subramo = {
      subramo_name: vmm.policyInfo.subramo,
    };
    // ---------
    function getFormData(form) {
      var insurance = vmm.poliza;
      vmm.insuranceObject = vmm.poliza;
      form.poliza_number = form.poliza_number == "" ? 0 : form.poliza_number;
      form.url = insurance.url;
      form.id = insurance.id;
      form.clave = insurance.clave;
      form.owner = insurance.owner;
      form.created_at = insurance.created_at;
      form.internal_number = insurance.internal_number;
      form.old_policies = [];
      form.observations = insurance.observations;
      form.receipts = [];
      form.old_receipts = [];
      form.coverages = insurance.coverageInPolicy_policy;
      form.paquete = insurance.paquete_info
        ? insurance.paquete_info
        : insurance.paquete;
      form.old_coverages = [];
      form.old_form =
        vmm.insuranceObject.accidents_policy.length > 0
          ? vmm.insuranceObject.accidents_policy[0].url
          : vmm.insuranceObject.automobiles_policy.length > 0
          ? vmm.insuranceObject.automobiles_policy[0].url
          : vmm.insuranceObject.damages_policy.length > 0
          ? vmm.insuranceObject.damages_policy[0].url
          : vmm.insuranceObject.life_policy.length > 0
          ? vmm.insuranceObject.life_policy[0].url
          : undefined;

      return form;
    }
    // -----------
    function save() {
      if (!vmm.form.canCreate) {
        SweetAlert.swal(
          "Error",
          "OPRIMA EL BOTON CALCULAR Y GENERAR RECIBOS",
          "error"
        );
        return;
      }
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      vmm.recibos_data = angular.copy($scope.dataToSave.recibos_poliza);
      vmm.policyInfo.recibos_poliza = vmm.recibos_data;
      vmm.policyInfo.p_neta = $scope.dataToSave.p_neta;
      vmm.policyInfo.descuento = $scope.dataToSave.descuento;
      vmm.policyInfo.rpf = $scope.dataToSave.rpf;
      vmm.policyInfo.derecho = $scope.dataToSave.derecho;
      vmm.policyInfo.sub_total = $scope.dataToSave.sub_total;
      vmm.policyInfo.iva = $scope.dataToSave.iva;
      vmm.policyInfo.p_total = $scope.dataToSave.p_total;
      vmm.policyInfo.prima = $scope.dataToSave.poliza.primaNeta;
      vmm.policyInfo.poliza_number = vmm.form.poliza;
      vmm.policyInfo.folio = vmm.form.folio;
      vmm.policyInfo.comision = $scope.dataToSave.comision;
      vmm.policyInfo.comision_percent = $scope.dataToSave.comision_percent;
      vmm.policyInfo.comision_derecho_percent = parseFloat(
        $scope.dataToSave.poliza.comision_derecho_percent
      ).toFixed(2);
      vmm.policyInfo.comision_rpf_percent = parseFloat(
        $scope.dataToSave.poliza.comision_rpf_percent
      ).toFixed(2);
      vmm.policyInfo.recibos_poliza.forEach(function (recibo) {
        recibo["conducto_de_pago"] =
          vmm.conductos[vmm.policyInfo.conducto_de_pago];
      });
      if (
        $scope.dataToSave &&
        $scope.dataToSave.prima_comision &&
        parseFloat(vmm.policyInfo.comision_percent) !=
          parseFloat($scope.dataToSave.prima_comision)
      ) {
        vmm.policyInfo.comision_percent = $scope.dataToSave.prima_comision
          ? $scope.dataToSave.prima_comision
          : $scope.dataToSave.comision_percent
          ? $scope.dataToSave.comision_percent
          : 0;
      }

      var policy = angular.copy(vmm.policyInfo);
      vmm.poliza = vmm.policyInfo;

      //objeto form updated
      vmm.form.business_line = vmm.poliza.business_line;

      vmm.form.contratante = $rootScope.contratante;
      vmm.form.clave = vmm.poliza.clave;
      vmm.form.comision = vmm.poliza.comision;
      vmm.form.comision_percent = vmm.poliza.comision_percent;
      vmm.form.comision_derecho_percent = vmm.poliza.comision_derecho_percent;
      vmm.form.comision_rpf_percent = vmm.poliza.comision_rpf_percent;
      vmm.form.recibos_poliza = vmm.recibos_data;
      vmm.form.receipts = vmm.poliza.recibos_poliza;
      // vmm.form.coverages = vmm.poliza.coverageInPolicy_policy;
      vmm.form.coverages = [];
      // if(vmm.form.coverages.length){
      //   vmm.form.paquete = vmm.poliza.coverageInPolicy_policy[0].package;
      //   vmm.form.paquete = {};
      //   vmm.form.paquete.url = vmm.poliza.coverageInPolicy_policy[0].package;
      // }else{
      // // vmm.form.paquete = vmm.poliza.coverageInPolicy_policy[0].package;
      // }
      vmm.form.id = vmm.poliza.id;

      var startDate = new Date(vmm.poliza.start_of_validity).setHours(
        12,
        0,
        0,
        0
      );
      var endingDate = new Date(vmm.poliza.end_of_validity).setHours(
        11,
        59,
        59,
        0
      );
      vmm.form.startDate = new Date(startDate);
      vmm.form.endingDate = new Date(endingDate);

      vmm.form.start_of_validity = vmm.poliza.start_of_validity;
      vmm.form.end_of_validity = vmm.poliza.end_of_validity;
      vmm.form.f_currency = vmm.poliza.f_currency;
      vmm.form.p_neta = vmm.poliza.p_neta;
      vmm.form.descuento = vmm.poliza.descuento;
      vmm.form.rpf = vmm.poliza.rpf;
      vmm.form.sub_total = vmm.poliza.sub_total;
      vmm.form.p_total = vmm.poliza.p_total;
      vmm.form.subramo = vmm.poliza.subramo;
      vmm.form.url = vmm.poliza.url;
      vmm.form.aseguradora = vmm.poliza.aseguradora;
      vmm.form.poliza_number = vmm.poliza.poliza_number;
      vmm.form.receipts = vmm.poliza.recibos_poliza;
      vmm.form.recibos_poliza = vmm.poliza.recibos_poliza;
      if (vmm.poliza.automobiles_policy) {
        vmm.form.automobiles_policy = vmm.poliza.automobiles_policy;
      } else if (vmm.form.accidents_policy) {
        vmm.form.accidents_policy = vmm.poliza.accidents_policy;
      } else if (vmm.poliza.damages_policy) {
        vmm.form.damages_policy = vmm.poliza.damages_policy;
      }
      if (vmm.form.contratante.value) {
        vmm.form.contratante = vmm.form.contratante.value;
      } else if (vmm.form.contratante.id) {
      }
      // if(vmm.form.contratante.address_juridical){
      //   vmm.form.address = vmm.form.contratante.address_juridical;
      // }else{
      //   vmm.form.address = vmm.form.contratante.address_natural;
      // }
      if (vmm.form.contratante.address_contractor) {
        vmm.form.address = vmm.form.contratante.address_contractor;
      }
      var observacion = vmm.form.observations;
      var form = vmm.form;
      var fromDate = vmm.form.startDate;
      var today = new Date(new Date().toISOString().split("T")[0]);

      // myInsurance.
      form = getFormData(form);

      form.observations = observacion;
      form.f_currency = vmm.f_currency;

      form.p_neta = parseFloat(
        vmm.poliza.primaNeta ? vmm.poliza.primaNeta : vmm.poliza.p_neta
      ).toFixed(2);
      form.p_total = vmm.poliza.primaTotal
        ? vmm.poliza.primaTotal
        : vmm.poliza.p_total;
      form.derecho = vmm.poliza.derecho;
      form.rpf = vmm.poliza.rpf;
      form.iva = vmm.poliza.iva;
      form.descuento = vmm.poliza.descuento;
      form.sub_total = vmm.poliza.sub_total;
      form.receipts = vmm.poliza.recibos_poliza;
      form.clave = vmm.form.clave;

      form.collection_executive = vmm.poliza.collection_executive
        ? vmm.poliza.collection_executive.url
        : "";

      // if(vmm.form.ceder_comision){
      //   form.comision_percent = vmm.form.comision_percent;
      //   form.udi = vmm.polia.udi;
      //   if(vmm.form.comision_percent) {
      //     form.comision_percent = vmm.form.comision_percent;
      //   } else {
      //     form.comision_percent = vmm.form.clave.comission;
      //   }
      // }
      // else{
      //   if(vmm.form.comision_percent) {
      //     form.comision_percent = vmm.form.comision_percent;
      //   } else {
      //     form.comision_percent = vmm.form.clave.comission;
      //   }
      //   form.udi = (vmm.form.clave.udi);
      // }
      // if(vmm.form.comision_percent) {
      //   var percent_ = parseFloat(vmm.form.comision_percent) / 100;
      //   vmm.form.comision = (vmm.form.p_neta * percent_).toFixed(2);
      // } else {
      //   var percent_ = parseFloat(vmm.form.comision.comission) / 100;
      //   vmm.form.comission = (vmm.form.p_neta * percent_).toFixed(2);
      // }

      if (form.receipts) {
        form.receipts.forEach(function (item) {
          var init = new Date(mesDiaAnio(item.fecha_inicio)).setHours(
            12,
            0,
            0,
            0
          );
          var end = new Date(mesDiaAnio(item.fecha_fin)).setHours(
            11,
            59,
            59,
            0
          );
          // var vencimiento = new Date(mesDiaAnio(item.vencimiento)).setHours(11,59,59,0);

          // item.startDate = new Date(init);
          // item.endingDate = new Date(end);
          item.fecha_inicio = new Date(init);
          item.fecha_fin = new Date(end);
          // item.vencimiento = new Date(vencimiento);

          if (item.vencimiento) {
            var vencimiento = new Date(toDate(item.vencimiento)).setHours(
              11.59,
              59,
              0
            );
            item.vencimiento = new Date(vencimiento);
          }
        });
      }

      var delete_receipts = [];
      var patch_receipts = [];
      var save_receipts = [];

      form.receipts.forEach(function (item_new) {
        if (item_new.url) {
          patch_receipts.push(item_new);
        } else {
          save_receipts.push(item_new);
        }
      });

      var startDate = new Date();
      startDate = form.startDate.getTime();
      var auxDate = new Date(form.startDate.getTime() - 86400000);
      if (auxDate < new Date() && new Date() < form.endingDate) {
        form.status = 14;
      } else if (auxDate > new Date()) {
        form.status = 10;
      } else if (new Date() > form.endingDate) {
        form.status = 13;
      }
      var startDate = new Date(mesDiaAnio(vmm.form.start_of_validity)).setHours(
        12,
        0,
        0,
        0
      );
      var endingDate = new Date(mesDiaAnio(vmm.form.end_of_validity)).setHours(
        11,
        59,
        59,
        0
      );

      var container = [];

      form.receipts_changes = {
        delete_receipts: delete_receipts,
        patch_receipts: patch_receipts,
        save_receipts: save_receipts,
      };

      // aqui --------------------
      form.state_circulation = policyModal.state_circulation
        ? policyModal.state_circulation
        : "";
      form.business_line = vmm.form.business_line ? vmm.form.business_line : 0;
      form.celula = policyModal.celula ? policyModal.celula : null;
      form.groupinglevel = policyModal.groupinglevel
        ? policyModal.groupinglevel
        : null;
      form.sucursal = vmm.poliza.sucursal ? vmm.poliza.sucursal.url : "";
      form.coverages = [];
      insuranceService
        .updateFullInsurance(form)
        .then(function (updateResponse) {
          insuranceService.updateOldPolicy(updateResponse);
          // TODO borrar de container maybe?
          if ($uibModalInstance) {
            //Send Email
            // $http.get(vmm.form.contratante.url)
            //   .then(function(response) {
            //     if(response.data.email){
            //       if($localStorage.email_config){
            //         if($localStorage.email_config.registro_pol == true){
            //           var model = 2;
            //           emailService.sendEmailAtm(model,updateResponse.id)
            //         }else{ }
            //       }else{}
            //   }
            // });
            // Send Email
            if (vmm.policy_history) {
              vmm.policy_history.forEach(function (elem) {
                if (elem.status == 13) {
                  var data = {
                    status: 12,
                    renewed_status: 1,
                  };
                } else {
                  var data = {
                    renewed_status: 1,
                  };
                }
                /* Actualiza la póliza antigua */
                $http.patch(elem.url, data).then(function (res_pacth_ren) {});
              });
            }

            var index = container.indexOf(myInsurance);
            container.splice(index, 1);
            myInsurance = updateResponse;
            toaster.success("Póliza actualizada");
            $uibModalInstance.close(20000);
            $state.go("polizas.info", { polizaId: myInsurance.id });
          } else {
            toaster.success("Póliza actualizada");
            $state.go("polizas.info", { polizaId: myInsurance.id });
          }

          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWPOLICY, "success");

          var params = {
            model: 1,
            event: "POST",
            associated_id: myInsurance.id,
            identifier: "convirtió la OT en póliza.",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
        });
      //fin form
    }

    function cancel() {
      $uibModalInstance.dismiss("cancel");
    }
  }

  //---contractor
  function insuranceServices(
    url,
    $http,
    $rootScope,
    policy,
    insuranceService,
    receiptService,
    $scope
  ) {
    var vmm = this;

    var array = [];
    var array1 = [];
    var id_p = "";

    // if(policy.natural){
    //   id_p=policy.natural;
    // }
    // else{
    //   id_p= policy.juridical;
    // }
    id_p = policy.contractor;
    var output = insuranceService
      .getInsuranceRead(policy)
      .then(function (data) {
        // alert(JSON.stringify(data
        var hoy = new Date();

        // if(data.juridical)
        //   var url_aux = url.IP + 'morales-resume-medium/'+ data.juridical+'/';
        // else
        // var url_aux = url.IP + 'fisicas-resume-medium/'+ data.natural+'/';
        var url_aux =
          url.IP + "contractors-resume-medium/" + data.contractor + "/";
        $http({
          method: "GET",
          url: url_aux,
        }).then(
          function success(response) {
            $rootScope.contratante = response.data;

            if ($rootScope.contratante.phone_number) {
              $rootScope.phone_number = $rootScope.contratante.phone_number
                .replace(/^\D+/g, "")
                .replace("'}", "");
              $rootScope.contratante.phone_number = $rootScope.phone_number;
              $rootScope.email = $rootScope.contratante.email;
            }
            // if(data.juridical){
            //   $rootScope.addressContratante = response.data.address_juridical[0];
            // }
            // else{
            //   $rootScope.addressContratante = response.data.address_natural[0];
            // }
            $rootScope.addressContratante = response.data.address_contractor[0];
          },
          function error(response) {
            console.log("error", response);
          }
        );
      });
  }
  // Edición de recibos
  function EditReceiptModalCtrl(
    url,
    $http,
    $rootScope,
    recibo,
    index,
    $scope,
    $uibModalInstance,
    poliza,
    dataFactory,
    SweetAlert,
    receipts,
    datesFactory,
    acceso_pl_cob
  ) {
    var rec = this;
    rec.poliza = poliza;
    rec.recibo = recibo;
    var fecha_inicio = recibo.fecha_inicio;
    var fecha_fin = recibo.fecha_fin;
    var fecha_venc = recibo.vencimiento;
    rec.recibo.fecha_inicio = recibo.fecha_inicio;
    rec.recibo.fecha_fin = recibo.fecha_fin;
    rec.recibo.prima_neta = recibo.prima_neta;
    rec.recibo.derecho = recibo.derecho;
    rec.recibo.iva = recibo.iva;
    rec.recibo.rpf = recibo.rpf;
    rec.recibo.init = datesFactory.convertDate(recibo.fecha_inicio);
    rec.recibo.fecha_inicio = datesFactory.convertDate(recibo.fecha_inicio);
    rec.recibo.end = datesFactory.convertDate(recibo.fecha_fin);
    rec.recibo.fecha_fin = datesFactory.convertDate(recibo.fecha_fin);
    rec.recibo.venc = datesFactory.convertDate(recibo.vencimiento);
    rec.recibo.vencimiento = datesFactory.convertDate(recibo.vencimiento);
    rec.recibo.subtotal__ = 0;

    $scope.validateDecimal = function (form, data) {
      form = String(form).replace(/[A-Za-z]/g, "");
      form = String(form).replace(/,/g, "");
    };

    $scope.changePrimas = function (data) {
      var subtotal_ =
        parseFloat(data.prima_neta) +
        parseFloat(data.rpf) +
        parseFloat(data.derecho);
      if (poliza.subramo == "Vida" || poliza.ramo == "Vida") {
        var iva_ = 0;
      } else {
        var iva_ = subtotal_ * 0.16;
      }
      var ivaQuantity = iva_.toFixed(2);
      var prima_total_ = parseFloat(subtotal_ + parseFloat(iva_));

      data.sub_total = subtotal_.toFixed(2);
      data.prima_total = prima_total_.toFixed(2);
      data.iva = ivaQuantity;
    };

    $scope.validateDates = function (date) {
      rec.recibo.fecha_inicio = date;
    };
    var date1, date2, date3, dateDiff1, dateDiff2;
    $scope.validateDates_venc = function (date) {
      //Validando vacio
      if (date == undefined) {
        SweetAlert.swal(
          "Error",
          "La fecha de vencimiento no puede estar vacia",
          "error"
        );
        return;
      }
      //Validando no menor a fecha inicio
      date1 = datesFactory.toDate(date);
      date2 = datesFactory.toDate(rec.recibo.fecha_inicio);
      date3 = datesFactory.toDate(convertDate(poliza.end_of_validity));
      dateDiff1 = moment(date1).diff(moment(date2), "days");
      dateDiff2 = moment(date1).diff(moment(date3), "days");

      // if(dateDiff1 < 0){
      //   SweetAlert.swal("Error", "La fecha de vencimiento no puede ser menor que la inicial", "error");
      //   return;
      // }
      //Validando a no mayor a 30 dias de fin de vigencia de poliza
      if (dateDiff2 > 30) {
        SweetAlert.swal(
          "Error",
          "La fecha de vencimiento no puede ser mayor a 30 días a la fecha de la vigencia de la poliza",
          "error"
        );
        return;
      }
    };
    $scope.saveEdicionRecibo = function (data_receipt) {
      if (rec.recibo.vencimiento == undefined) {
        SweetAlert.swal(
          "Error",
          "La fecha de vencimiento no puede estar vacia",
          "error"
        );
        return;
      }
      //Validando no menor a fecha inicio
      date1 = datesFactory.toDate(rec.recibo.vencimiento);
      date2 = datesFactory.toDate(rec.recibo.fecha_inicio);
      date3 = datesFactory.toDate(convertDate(poliza.end_of_validity));
      dateDiff1 = moment(date1).diff(moment(date2), "days");
      dateDiff2 = moment(date1).diff(moment(date3), "days");

      // if(dateDiff1 < 0){
      //   SweetAlert.swal("Error", "La fecha de vencimiento no puede ser menor que la inicial", "error");
      //   return;
      // }
      //Validando a no mayor a 30 dias de fin de vigencia de poliza
      if (dateDiff2 > 30) {
        SweetAlert.swal(
          "Error",
          "La fecha de vencimiento no puede ser mayor a 30 días a la fecha de la vigencia de la poliza",
          "error"
        );
        return;
      }

      if (
        process(rec.recibo.fecha_inicio) <
        process(convertDate(poliza.start_of_validity))
      ) {
        SweetAlert.swal(
          "Error",
          "La fecha de inicio del recibo no puede ser menor a la fecha de inicio de la póliza.",
          "error"
        );
        return;
      }

      if (process(rec.recibo.fecha_fin) < process(rec.recibo.fecha_inicio)) {
        SweetAlert.swal(
          "Error",
          "La fecha fin del recibo no puede ser menor a la de su inicio.",
          "error"
        );
        return;
      }

      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }

      var data = {
        fecha_inicio: toDate(data_receipt.fecha_inicio),
        fecha_fin: toDate(data_receipt.fecha_fin),
        vencimiento: toDate(data_receipt.vencimiento),
        prima_neta: parseFloat(data_receipt.prima_neta).toFixed(2),
        derecho: parseFloat(data_receipt.derecho).toFixed(2),
        rpf: parseFloat(data_receipt.rpf).toFixed(2),
        iva: parseFloat(data_receipt.iva).toFixed(2),
        comision: parseFloat(data_receipt.comision).toFixed(2),
        sub_total: parseFloat(data_receipt.sub_total).toFixed(2),
        prima_total: parseFloat(data_receipt.prima_total).toFixed(2),
      };
      $http
        .patch(data_receipt.url, data)
        .then(
          function success(req) {
            SweetAlert.swal(
              "Actualizado",
              "El recibo " +
                data_receipt.recibo_numero +
                " ha sido actualizado.",
              "success"
            );
            $scope.cancel(true);
            $uibModalInstance.dismiss("cancel");
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
      var texto_log = "";
      if (data_receipt.status == 1 && acceso_pl_cob == false) {
        var texto_log = "EDICION DE RECIBO PAGADO \n";
      }
      if (data_receipt.status == 5 && acceso_pl_cob == false) {
        var texto_log = "EDICION DE RECIBO LIQUIDADO \n";
      }
      var params = {
        model: 4,
        event: "PATCH",
        associated_id: data_receipt.id,
        identifier:
          "actualizó el recibo " +
          data_receipt.recibo_numero +
          " de la póliza " +
          poliza.poliza_number +
          " " +
          texto_log,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
      try {
        var params_ = {
          model: 1,
          event: "PATCH",
          associated_id: poliza.id,
          identifier:
            "actualizó el recibo " +
            data_receipt.recibo_numero +
            " de la póliza " +
            poliza.poliza_number +
            " " +
            texto_log,
        };
        dataFactory
          .post("send-log/", params_)
          .then(function success(response) {});
      } catch (e) {}
    };
    $scope.cancel = function (v) {
      if (!v) {
        rec.recibo.fecha_inicio = fecha_inicio;
        rec.recibo.fecha_fin = fecha_fin;
        rec.recibo.vencimiento = fecha_venc;
      }
      $uibModalInstance.dismiss("cancel");
    };
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      // var date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
      // return date;
      var date = inputFormat;
      if (inputFormat.length != 10) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }
      }
      return date;
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }
  }
  function ReferenciadorModalCtrl(
    poliza,
    actual,
    $http,
    $rootScope,
    $uibModalInstance,
    dataFactory,
    SweetAlert,
    datesFactory,
    $localStorage,
    $scope
  ) {
    var vmm = this;
    $scope.referenciador_a_cambiar = actual;
    $scope.poliza_especifica = poliza;
    $scope.comisionError2 = "";
    activate();

    function activate() {
      // -------------------------Referenciadores
      dataFactory.get("get-vendors/").then(function (user) {
        user.data.forEach(function (vn) {
          vn.first_name = vn.first_name.toUpperCase();
          vn.last_name = vn.last_name.toUpperCase();
          vn.name = vn.first_name + " " + vn.last_name;
        });
        $scope.referenciadores = user.data.filter(function (vn) {
          return vn.id !== actual.id;
        });
        $scope.ref_to_patch_policy = "";
        $scope.ref_to_change_id = "";
        poliza.ref_policy.filter(function (vn) {
          if (vn.referenciador == actual.url) {
            $scope.ref_to_patch_policy = vn.url;
            $scope.ref_to_change_id = vn.id;
          }
        });
      });
    }
    $scope.validateComision = function () {
      // if ($scope.comision_vendedor > 100) {
      //   $scope.comision_vendedor = 100;
      // } else if ($scope.comision_vendedor < 0) {
      //   $scope.comision_vendedor = 0;
      // }
      $scope.checkTotalComision2($scope.comision_vendedor);
    };

    $scope.checkTotalComision2 = function (valor) {
      var totalComision = poliza.ref_policy.reduce(function (sum, item) {
        if (item.id !== $scope.ref_to_change_id) {
          return sum + (parseFloat(item.comision_vendedor) || 0);
        }
        return sum;
      }, 0);
      totalComision += parseFloat(valor);
      if (totalComision > 100) {
        $scope.comisionError2 =
          "La suma de las comisiones no puede superar el 100%";
        $scope.comision_vendedor = 0;
      } else {
        $scope.comisionError2 = "";
      }
    };
    $scope.cambiar = function (refe, comision) {
      var ref = {};
      $scope.comision_vendedor = 0;
      ref.referenciador = refe.url;
      ref.comision_vendedor = comision ? comision : 0;
      ref.policy = poliza.url;
      ref.anterior = $scope.ref_to_change_id;
      ref.is_changed = false;
      if (ref.referenciador) {
        dataFactory
          .post("referenciadores-policy/", ref)
          .then(
            function success(response_ref_created) {
              $scope.ref_cambiado = response_ref_created.data;
              console.log(
                "response to create new ref***",
                response_ref_created
              );
              // set flat to last refer
              $http
                .patch($scope.ref_to_patch_policy, { is_changed: true })
                .then(function (response_patch_ref_last) {
                  var params = {
                    model: 1,
                    event: "POST",
                    associated_id: poliza.id,
                    identifier:
                      "cambio el Referenciador: " +
                      $scope.referenciador_a_cambiar.first_name +
                      " " +
                      $scope.referenciador_a_cambiar.last_name +
                      " por " +
                      $scope.ref_cambiado.ref_name,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  setTimeout(function () {}, 1500);
                  $uibModalInstance.dismiss("cancel");
                })
                .catch(function (e) {
                  console.log("error", e);
                });
            },
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      } else {
        console.log("___Sin referenciador__");
      }
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };
  }
  function AddReceiptModalCtrl(
    tipo,
    serie,
    contractor,
    url,
    $http,
    $rootScope,
    $scope,
    $uibModalInstance,
    poliza,
    dataFactory,
    SweetAlert,
    datesFactory,
    $localStorage,
    emailService
  ) {
    var rec = this;
    rec.tipo = tipo;
    rec.recibo_numero = serie;
    rec.fecha_inicio = convertDate(new Date());
    rec.fecha_fin = convertDate(new Date());
    rec.prima_neta = 0.0;
    rec.rpf = 0.0;
    rec.derecho = 0.0;
    rec.sub_total = 0.0;
    rec.iva = 0.0;
    rec.comision = 0.0;
    rec.prima_total = 0.0;
    rec.vencimiento = convertDate(new Date());
    $scope.contratante = contractor;
    $scope.change_date = function (date) {
      rec.fecha_fin = date;
      rec.vencimiento = date;
    };

    $scope.validateDecimal = function (form, data) {
      form = String(form).replace(/[A-Za-z]/g, "");
      form = String(form).replace(/,/g, "");
    };

    $scope.changePrimas = function (data) {
      var subtotal_ =
        parseFloat(data.prima_neta) +
        parseFloat(data.rpf) +
        parseFloat(data.derecho);
      var iva_ = subtotal_ * 0.16;
      var prima_total_ = parseFloat(subtotal_ + parseFloat(iva_));
      rec.iva = iva_.toFixed(2);

      data.sub_total = subtotal_.toFixed(2);
      data.prima_total = prima_total_.toFixed(2);
      data.iva = iva_.toFixed(2);
    };

    $scope.validateDates = function (date) {
      rec.fecha_inicio = date;
    };
    var date1, date2, date3, dateDiff1, dateDiff2;
    $scope.validateDates_venc = function (date) {
      //Validando vacio
      if (date == undefined) {
        SweetAlert.swal(
          "Error",
          "La fecha de vencimiento no puede estar vacia",
          "error"
        );
        return;
      }
      //Validando no menor a fecha inicio
      date1 = datesFactory.toDate(date);
      date2 = datesFactory.toDate(rec.fecha_inicio);
      date3 = datesFactory.toDate(convertDate(poliza.end_of_validity));
      dateDiff1 = moment(date1).diff(moment(date2), "days");
      dateDiff2 = moment(date1).diff(moment(date3), "days");

      // if(dateDiff1 < 0){
      //   SweetAlert.swal("Error", "La fecha de vencimiento no puede ser menor que la inicial", "error");
      //   return;
      // }
      //Validando a no mayor a 30 dias de fin de vigencia de poliza
      if (dateDiff2 > 30) {
        SweetAlert.swal(
          "Error",
          "La fecha de vencimiento no puede ser mayor a 30 días a la fecha de la vigencia de la poliza",
          "error"
        );
        return;
      }
    };
    $scope.saveRecibo = function (data_receipt) {
      //var date = rec.vencimiento;
      if (rec.vencimiento == undefined) {
        SweetAlert.swal(
          "Error",
          "La fecha de vencimiento no puede estar vacia",
          "error"
        );
        return;
      }
      //Validando no menor a fecha inicio
      date1 = datesFactory.toDate(rec.vencimiento);
      date2 = datesFactory.toDate(rec.fecha_inicio);
      date3 = datesFactory.toDate(convertDate(poliza.end_of_validity));
      dateDiff1 = moment(date1).diff(moment(date2), "days");
      dateDiff2 = moment(date1).diff(moment(date3), "days");

      if (data_receipt.tipo != 3) {
        if (!data_receipt.serie_manual || data_receipt.serie_manual == "") {
          SweetAlert.swal(
            "Error",
            "Debe ingresar un número de serie manual válido",
            "error"
          );
          return;
        }
      }

      // if(dateDiff1 < 0){
      //   SweetAlert.swal("Error", "La fecha de vencimiento no puede ser menor que la inicial", "error");
      //   return;
      // }
      //Validando a no mayor a 30 dias de fin de vigencia de poliza
      if (dateDiff2 > 30) {
        SweetAlert.swal(
          "Error",
          "La fecha de vencimiento no puede ser mayor a 30 días a la fecha de la vigencia de la poliza",
          "error"
        );
        return;
      }

      if (
        process(rec.fecha_inicio) <
        process(convertDate(poliza.start_of_validity))
      ) {
        SweetAlert.swal(
          "Error",
          "La fecha de inicio del recibo no puede ser menor a la fecha de inicio de la póliza.",
          "error"
        );
        return;
      }

      if (process(rec.fecha_fin) < process(rec.fecha_inicio)) {
        SweetAlert.swal(
          "Error",
          "La fecha fin del recibo no puede ser menor a la de su inicio.",
          "error"
        );
        return;
      }

      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }

      var folio = "Sin folio";
      if (tipo == 3) {
        folio = data_receipt.recibo_numero;
        var data = {
          fecha_inicio: toDate(data_receipt.fecha_inicio),
          fecha_fin: toDate(data_receipt.fecha_fin),
          vencimiento: toDate(data_receipt.vencimiento),
          prima_neta:
            parseFloat(data_receipt.prima_neta).toFixed(2) < 0
              ? parseFloat(data_receipt.prima_neta).toFixed(2)
              : parseFloat(data_receipt.prima_neta).toFixed(2) * -1,
          derecho:
            parseFloat(data_receipt.derecho).toFixed(2) < 0
              ? parseFloat(data_receipt.derecho).toFixed(2)
              : parseFloat(data_receipt.derecho).toFixed(2) * -1,
          rpf:
            parseFloat(data_receipt.rpf).toFixed(2) < 0
              ? parseFloat(data_receipt.rpf).toFixed(2)
              : parseFloat(data_receipt.rpf).toFixed(2) * -1,
          iva:
            parseFloat(data_receipt.iva).toFixed(2) < 0
              ? parseFloat(data_receipt.iva).toFixed(2)
              : parseFloat(data_receipt.iva).toFixed(2) * -1,
          comision:
            parseFloat(data_receipt.comision).toFixed(2) < 0
              ? parseFloat(data_receipt.comision).toFixed(2)
              : parseFloat(data_receipt.comision).toFixed(2) * -1,
          sub_total:
            parseFloat(data_receipt.sub_total).toFixed(2) < 0
              ? parseFloat(data_receipt.sub_total).toFixed(2)
              : parseFloat(data_receipt.sub_total).toFixed(2) * -1,
          prima_total:
            parseFloat(data_receipt.prima_total).toFixed(2) < 0
              ? parseFloat(data_receipt.prima_total).toFixed(2)
              : parseFloat(data_receipt.prima_total).toFixed(2) * -1,
          recibo_numero: data_receipt.recibo_numero
            ? data_receipt.recibo_numero
            : serie,
          serie_manual: data_receipt.serie_manual,
          poliza: poliza.url,
          status: 4,
          receipt_type: tipo,
          isCopy: false,
          isActive: true,
          folio: folio,
        };
      } else {
        var data = {
          fecha_inicio: toDate(data_receipt.fecha_inicio),
          fecha_fin: toDate(data_receipt.fecha_fin),
          vencimiento: toDate(data_receipt.vencimiento),
          prima_neta: parseFloat(data_receipt.prima_neta).toFixed(2),
          derecho: parseFloat(data_receipt.derecho).toFixed(2),
          rpf: parseFloat(data_receipt.rpf).toFixed(2),
          iva: parseFloat(data_receipt.iva).toFixed(2),
          comision: parseFloat(data_receipt.comision).toFixed(2),
          sub_total: parseFloat(data_receipt.sub_total).toFixed(2),
          prima_total: parseFloat(data_receipt.prima_total).toFixed(2),
          recibo_numero: data_receipt.recibo_numero
            ? data_receipt.recibo_numero
            : serie,
          serie_manual: data_receipt.serie_manual,
          poliza: poliza.url,
          status: 4,
          receipt_type: tipo,
          isCopy: false,
          isActive: true,
          folio: folio,
        };
      }
      $http
        .post(url.IP + "recibos/", data)
        .then(
          function success(req) {
            SweetAlert.swal(
              "Creado",
              "El recibo " + data_receipt.recibo_numero + " ha sido creado.",
              "success"
            );
            var params = {
              model: 4,
              event: "POST",
              associated_id: req["data"].id,
              identifier:
                "creó el recibo " +
                data_receipt.recibo_numero +
                " de la póliza " +
                poliza.poliza_number,
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});

            var params_ = {
              model: 1,
              event: "POST",
              associated_id: req["data"].id,
              identifier:
                "creó el recibo " +
                data_receipt.recibo_numero +
                " de la póliza " +
                poliza.poliza_number,
            };

            dataFactory
              .post("send-log/", params_)
              .then(function success(response) {});
            // if(req.data.receipt_type ==3){//crear nota
            //   if (contractor && contractor.email){
            //       //Send Email
            //       if($localStorage.email_config){
            //         if($localStorage.email_config.create_nota == true){
            //           $scope.idRecibo = req.data.id
            //           var model = 7;
            //           emailService.sendEmailAtm(model,$scope.idRecibo)
            //         }
            //       }
            //       //Send Email
            //   }
            // }
            $uibModalInstance.dismiss("cancel");
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    };
    $scope.cancel = function (v) {
      $uibModalInstance.dismiss("cancel");
    };
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      // var date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
      // return date;
      var date = inputFormat;
      if (inputFormat.length != 10) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }
      }
      return date;
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }
  }
  function convertDate(inputFormat) {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    var date = [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join(
      "/"
    );
    return date;
  }

  function toDate(dateStr) {
    var dateString = dateStr; // Oct 23
    var dateParts = dateString.split("/");
    var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

    return dateObject;
  }

  function mesDiaAnio(parDate) {
    var d = new Date(toDate(parDate));
    var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
    return date;
  }

  //----------estatus test
})();

var order2 = null;
(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("OrderEditCtrl", OrderEditCtrl);

  OrderEditCtrl.$inject = [
    "$parse",
    "datesFactory",
    "ContratanteService",
    "$http",
    "$q",
    "pdfService",
    "tiposBeneficiarios",
    "sex",
    "formService",
    "$uibModalInstance",
    "$timeout",
    "url",
    "$localStorage",
    "FileUploader",
    "$scope",
    "$filter",
    "groupService",
    "providerService",
    "insuranceService",
    "receiptService",
    "generalService",
    "toaster",
    "formaPago",
    "helpers",
    "MESSAGES",
    "myInsurance",
    "container",
    "$stateParams",
    "$state",
    "fileService",
    "SweetAlert",
    "$sessionStorage",
    "formatValues",
    "coverageService",
    "dataFactory",
    "$rootScope",
    "$uibModal",
    "$location",
  ];

  function OrderEditCtrl(
    $parse,
    datesFactory,
    ContratanteService,
    $http,
    $q,
    pdfService,
    tiposBeneficiarios,
    sex,
    formService,
    $uibModalInstance,
    $timeout,
    url,
    $localStorage,
    FileUploader,
    $scope,
    $filter,
    groupService,
    providerService,
    insuranceService,
    receiptService,
    generalService,
    toaster,
    formaPago,
    helpers,
    MESSAGES,
    myInsurance,
    container,
    $stateParams,
    $state,
    fileService,
    SweetAlert,
    $sessionStorage,
    formatValues,
    coverageService,
    dataFactory,
    $rootScope,
    $uibModal,
    $location
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.identificador = true;
    $scope.newCoverPack = false;
    $scope.addNewCoverages = false;
    $scope.edited_pay_frequency = false;
    $scope.es_renovacion = false;
    $scope.esEdicion = true;
    var order = (order2 = this);
    var firstTime = true;
    if ($location.path().indexOf("editar") != -1) {
      $scope.validaPermisoEliminar = true;
    } else {
      $scope.validaPermisoEliminar = false;
    }
    // order.deleteFile=deleteFile;
    order.f_currency = {};
    order.f_currency.options = [
      { value: 1, label: "PESOS" },
      { value: 2, label: "DOLARES" },
      { value: 3, label: "UDI" },
    ];

    order.conducto_de_pago = {};
    order.conducto_de_pago.options = [
      { value: 1, label: "No domiciliada" },
      { value: 2, label: "Agente" },
      { value: 3, label: "CAC" },
      { value: 4, label: "CAT/Domiciliado" },
      { value: 5, label: "Nómina" },
      { value: 6, label: "CUT" },
    ];

    order.renewal = {};
    order.renewal.options = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    order.businessline = [
      { id: 1, name: "Comercial" },
      { id: 2, name: "Personal" },
      { id: 0, name: "Otro" },
    ];
    $scope.seller = [];
    $scope.isSeller = [];

    $scope.pay_ways = [
      { key: 1, val: "Clabe" },
      { key: 2, val: "Número de cuenta" },
      { key: 3, val: "Número de tarjeta" },
      { key: 4, val: "Efectivo" },
    ];

    $scope.fcs = [
      { key: 1, val: "Semanal" },
      { key: 2, val: "Quincenal" },
      { key: 3, val: "Mensual" },
    ];
    order.procedencia = [
      { id: 1, name: "Residente" },
      { id: 2, name: "Turista" },
      { id: 3, name: "Legalizado" },
      { id: 4, name: "Fronterizo" },
    ];
    order.charge_type = [
      { id: 1, name: "A" },
      { id: 2, name: "B" },
      { id: 3, name: "C" },
    ];
    $scope.delete_subramos = [];
    $scope.delete_phones = [];

    order.subramo = {
      ramos: "",
      sub_ramos: "",
      provider: "",
      ramo: "",
      subramo: "",
      comision_percentage: "",
    };

    order.types = [
      { id: 1, name: "Automóvil" },
      { id: 2, name: "Motocicleta" },
      { id: 3, name: "Tracto" },
      { id: 4, name: "Autobús" },
      { id: 5, name: "Pick Up" },
      { id: 6, name: "Camiones hasta 1.5 ton" },
      { id: 7, name: "Chofer app" },
      { id: 8, name: "Remolque" },
      { id: 9, name: "Camiones + 1.5 ton" },
    ];

    order.types_ap = [
      { id: 64, name: "Viajero" },
      { id: 46, name: "Familiar" },
    ];
    order.types_gm = [{ id: 46, name: "Familiar" }];

    order.types_life = [
      { id: 47, name: "Ahorro" },
      { id: 48, name: "Vitalicia" },
      { id: 49, name: "Temporal/Protección" },
    ];

    order.types_incendio = [
      { id: 1, name: "Familiar" },
      { id: 2, name: "Casa Habitación" },
      { id: 3, name: "Condominio" },
      { id: 4, name: "Edificio" },
      { id: 5, name: "Empresarial" },
      { id: 6, name: "Múltiple Empresarial" },
      { id: 10, name: "Sólo Incendio" },
    ];

    order.types_myt = [
      { id: 46, name: "Avión" },
      { id: 47, name: "Avioneta" },
      { id: 48, name: "Barco" },
      { id: 49, name: "Buque" },
      { id: 9, name: "Declaración" },
      { id: 50, name: "Dron" },
      { id: 51, name: "Embarcación de Placer" },
      { id: 7, name: "Específica" },
      { id: 52, name: "Helicóptero" },
      { id: 35, name: "Otro" },
      { id: 8, name: "Pronóstico" },
    ];

    order.types_ayc = [
      { id: 11, name: "Animales" },
      { id: 12, name: "Cultivo" },
    ];
    order.types_credito = [{ id: 13, name: "Crédito General" }];
    order.types_vivienda = [{ id: 14, name: "Crédito a la Vivienda" }];
    order.types_garantia = [
      {
        id: 15,
        name: "Documentos que sean objeto de oferta pública o de intermediación en mercados de valores",
      },
      { id: 16, name: "Emisores de Valores" },
      { id: 17, name: "Títulos de Crédito" },
    ];
    order.types_rc = [
      { id: 18, name: "Administración" },
      { id: 19, name: "Arquitectos" },
      { id: 20, name: "Aviones" },
      { id: 21, name: "Barcos" },
      { id: 22, name: "Contratista" },
      { id: 23, name: "Crime" },
      { id: 24, name: "Cyber (Protección de datos)" },
      { id: 25, name: "D&O (Consejeros y Funcionarios)" },
      { id: 26, name: "E&O Miscelaneos" },
      { id: 27, name: "Empresarial" },
      { id: 28, name: "Eventos" },
      { id: 29, name: "Familiar/Condominal" },
      { id: 30, name: "Hole in One" },
      { id: 31, name: "Ingeniería" },
      { id: 32, name: "Instituciones Financieras" },
      { id: 33, name: "Lineas Financieras" },
      { id: 34, name: "Médicos" },
      { id: 35, name: "Otro" },
    ];
    order.types_tyorc = [{ id: 36, name: "Riesgos Catastróficos" }];
    order.types_diversos = [
      { id: 37, name: "Calderas y Recipientes Sujetos a Presión" },
      { id: 38, name: "Dinero y Valores" },
      { id: 39, name: "Eq. Contratistas y Maquinaria pesada" },
      { id: 40, name: "Eq. Electrónico" },
      { id: 41, name: "Montaje de Maquinaria" },
      { id: 42, name: "Obra Civil en Contrucción" },
      { id: 43, name: "Obra Civil Terminada" },
      { id: 44, name: "Rotura de Cristales" },
      { id: 45, name: "Rotura de Maquinaria" },
      { id: 35, name: "Otro" },
      { id: 63, name: "Terrorismo y Sabotaje" },
    ];
    order.types_lf = [
      { id: 53, name: "CRIME/BBB" },
      { id: 54, name: "D&O" },
      { id: 55, name: "FIPI" },
      { id: 56, name: "CYBER" },
      { id: 57, name: "VCAPS" },
      { id: 58, name: "RCP MÉDICA" },
      { id: 59, name: "E&O MISCELANEO" },
      { id: 60, name: "RIESGO POLITICO" },
      { id: 61, name: "RC SERVIDORES PUBLICOS" },
      { id: 62, name: "RCP" },
    ];

    $scope.usages = [
      { id: 1, name: "PARTICULAR" },
      { id: 2, name: "CARGA" },
      { id: 3, name: "SERVICIO PÚBLICO" },
    ];

    $scope.celulas = [];
    $scope.agrupaciones = [];
    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    order.recalcular = true;

    $scope.is_edition = true;

    $scope.infoUser = $sessionStorage.infoUser;

    usr.permiso.editar = true;
    $scope.show_receipts = true;
    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          order.acceso_polizas = perm;
          order.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                order.acceso_adm_pol = true;
              } else {
                order.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                order.acceso_ver_pol = true;
              } else {
                order.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                order.acceso_canc_pol = true;
              } else {
                order.acceso_canc_pol = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                order.acceso_elim_pol = true;
              } else {
                order.acceso_elim_pol = false;
              }
            }
          });
        }
        if (perm.model_name == "Reportes") {
          order.acceso_reportes = perm;
          order.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                order.acceso_rep_fia = true;
              } else {
                order.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                order.acceso_rep_sin = true;
              } else {
                order.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                order.acceso_rep_end = true;
              } else {
                order.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                order.acceso_rep_pol = true;
              } else {
                order.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                order.acceso_rep_ren = true;
              } else {
                order.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                order.acceso_rep_cob = true;
              } else {
                order.acceso_rep_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                order.acceso_canc_ot = true;
              } else {
                order.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                order.acceso_elim_ot = true;
              } else {
                order.acceso_elim_ot = false;
              }
            }
          });
        }
        if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        }
        if (perm.model_name == "Siniestros") {
          order.acceso_sin = perm;
          order.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                order.acceso_adm_sin = true;
              } else {
                order.acceso_adm_sin = false;
              }
            }
          });
        }
        if (perm.model_name == "Mensajeria") {
          order.acceso_mns = perm;
          order.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                order.acceso_mns = true;
              } else {
                order.acceso_mns = false;
              }
            }
          });
        }
        if (perm.model_name == "Formatos") {
          order.acceso_form = perm;
          order.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                order.acceso_form = true;
              } else {
                order.acceso_form = false;
              }
            }
          });
        }
        if (perm.model_name == "Correos electronicos") {
          order.acceso_correo = perm;
          order.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                order.acceso_cor = true;
              } else {
                order.acceso_cor = false;
              }
            }
          });
        }
        if (perm.model_name == "Cobranza") {
          order.acceso_cob = perm;
          order.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                order.acceso_ver_cob = true;
              } else {
                order.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                order.acceso_desp_cob = true;
              } else {
                order.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                order.acceso_pag_cob = true;
              } else {
                order.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                order.acceso_desco_cob = true;
              } else {
                order.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                order.acceso_conc_cob = true;
              } else {
                order.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                order.acceso_liq_cob = true;
              } else {
                order.acceso_liq_cob = false;
              }
            } else if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                order.acceso_del_cob = true;
              } else {
                order.acceso_del_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          order.acceso_ref = perm;
          order.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                order.acceso_adm_ref = true;
              } else {
                order.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                order.acceso_pag_ref = true;
              } else {
                order.acceso_pag_ref = false;
              }
            } else if (
              acc.permission_name == "Cambiar refrenciador en pólizas"
            ) {
              if (acc.checked == true) {
                order.acceso_chg_ref = true;
              } else {
                order.acceso_chg_ref = false;
              }
            } else if (acc.permission_name == "Referenciador no obligatorio") {
              if (acc.checked == true) {
                order.acceso_obl_ref = false;
              } else {
                order.acceso_obl_ref = true;
              }
            } else if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                order.acceso_ver_ref = true;
              } else {
                order.acceso_ver_ref = false;
              }
            }
          });
        }
        if (perm.model_name == "Comisiones") {
          order.acceso_dash = perm;
          order.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                order.permiso_comisiones = true;
              } else {
                order.permiso_comisiones = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                order.permiso_administrar_adjuntos = true;
              } else {
                order.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }
    $scope.deleteFile = function (file, container, poliza) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este archivo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: file.id,
              id_poliza: $scope.myInsurance.id,
              model: 6,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {});
            $http({
              method: "GET",
              url: url.IP + "delete-manual",
              params: {
                file_id: file.id,
              },
            }).then(function success(response) {
              if (response.data.status == 204) {
                var params = {
                  model: 1,
                  event: "PATCH",
                  associated_id: $scope.myInsurance.id,
                  identifier: " elimino 1 archivo de la póliza " + file.nombre,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                SweetAlert.swal(
                  "¡Eliminado!",
                  "El archivo fue eliminado.",
                  "success"
                );
                container.splice(container.indexOf(file), 1);
              }
            });
          }
        }
      );
    };
    $scope.renameFile = function (file, vmFiles) {
      var patch = {
        nombre: file.nombre,
      };
      $http.patch(file.url, patch).then(function (response) {
        if (response.status == 403) {
          $http.get(file.url).then(function (response) {
            file.nombre = response.data;
          });
        }
      });
    };

    // -------------------------Referenciadores
    $http.get(url.IP + "get-vendors/").then(function (user) {
      user.data.forEach(function (vn) {
        vn.first_name = vn.first_name.toUpperCase();
        vn.last_name = vn.last_name.toUpperCase();
        vn.name =
          vn.first_name.toUpperCase() + " " + vn.last_name.toUpperCase();
      });
      $scope.users = user.data;
      $scope.show_pagination = true;
      $scope.config_pagination = {
        count: user.data.count,
        next: user.data.next,
        previous: user.data.previous,
      };
      $scope.testPagination("users", "config_pagination");
      $scope.users.forEach(function (user) {
        user["phones"] = [];
        user["subramos"] = [];
      });
    });
    //------------------------------
    $scope.newCoverages = function () {
      $scope.addNewCoverages = true;
    };
    $scope.finishNewCoverages = function () {
      $scope.addNewCoverages = false;
    };

    $scope.saveNewCoverage = function (parName, priority, parPackage) {
      $scope.coverages = [];
      $scope.ded = false;
      $scope.sum = false;
      if (parPackage) {
        var paqueteData = parPackage;
      } else {
        var paqueteData = $scope.packageCreated;
      }
      if (!parName || parName == undefined) {
        SweetAlert.swal(
          "Campo requerido",
          "Debe agregar un Nombre de Cobertura",
          "error"
        );
        return;
      }
      var obj = {
        coverage_name: parName,
        priority: priority ? priority : 0,
        provider: order.form.aseguradora.url,
        package: order.form.paquete.url,
        deductible: [],
        sums_coverage: [],
        coinsurance_coverage: [],
        topecoinsurance_coverage: [],
      };
      coverageService
        .createCoverage(obj)
        .then(
          function success(request) {
            $scope.coverages.push(request);
            order.defaults.coverages.push(request);
            $scope.coverageName = null;
            $scope.priority = null;

            order.defaults.packages.forEach(function (item) {
              if (item.id == order.form.paquete.id) {
                if (item.coverage_package) {
                  item.coverage_package.push(request);
                } else {
                  item.coverage_package = [];
                  item.coverage_package.push(request);
                }
              }
            });
          },
          function error(error) {
            console.log("error - createCoverage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createCoverage - catch", e);
        });
    };
    $scope.deleteSubramo = function (index_main, index_sub, data) {
      $scope.delete_subramos.push(data.subramos[index_sub]);
      data.subramos.splice(index_sub, 1);
    };

    $scope.changeDomiciliado = function () {
      $scope.change_domiciliado = true;
      if (order.form.domiciliado == "true" || order.form.domiciliado == true) {
        var domiciliado = true;
      } else {
        var domiciliado = false;
      }

      if (order.receipts.length) {
        order.receipts.forEach(function (item) {
          if (domiciliado) {
            item.is_cat = true;
          } else {
            item.is_cat = false;
          }
        });
      }
    };

    $scope.changeVendedor = function (vendedor) {
      $scope.users.some(function (user) {
        if (vendedor.id == user.id) {
          var vendedor_info = user.user_info.info_vendedor[0];
          if (vendedor_info.vendedor_subramos.length == 0) {
            SweetAlert.swal(
              "error",
              "El vendedor no tiene comisión en el subramo actual"
            );
            order.form.vendor = $scope.original_vendor;
            return;
          }

          var flag = false;
          var vendedor_flag = false;

          vendedor_info.vendedor_subramos.some(function (subramo, sub_index) {
            if (
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == order.form.ramo.id &&
                subramo.subramo == order.form.subramo.id) ||
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == order.form.ramo.id &&
                subramo.subramo == 0) ||
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == 0 &&
                subramo.subramo == 0) ||
              (subramo.provider == 0 &&
                subramo.ramo == 0 &&
                subramo.subramo == 0) ||
              (subramo.provider == 0 &&
                subramo.ramo * -1 == order.form.ramo.ramo_code &&
                subramo.subramo * -1 == order.form.subramo.subramo_code)
            ) {
              vendedor_flag = true;
            }

            if (vendedor_info.vendedor_subramos.length == sub_index + 1) {
              if (!vendedor_flag) {
                SweetAlert.swal(
                  "Error",
                  "El vendedor no tiene comisión en el subramo actual",
                  "error"
                );
                order.form.vendor = $scope.original_vendor;
                return;
              }
            }
          });
        }
      });
    };

    $scope.addNewSubramo = function () {
      $scope.show_new_sub = true;
      $scope.create_sub = true;
    };

    $scope.addPhone = function (index) {
      if ($scope.users[index].phones) {
        $scope.users[index].phones.push("");
      } else {
        $scope.users[index].phones = [""];
      }
    };

    $scope.deletePhone = function (index, index2) {
      $scope.delete_phones.push($scope.users[index].phones.index2);
      $scope.users[index].phones.splice(index2, 1);
    };

    $scope.addSubramo = function (index) {
      if ($scope.users[index].subramos) {
        $scope.users[index].subramos.push({});
      } else {
        $scope.users[index].subramos = [{}];
      }
    };

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
          } else {
            if (config_.previous.search("&page=") !== -1) {
              var url = config_.previous.substring(
                0,
                config_.previous.indexOf("&page=") + 6
              );
              url += parPage.toString();
            } else {
              var url = config_.previous;
            }
          }
        }

        // url += '&status=1'
        getProviders(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getProviders(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    $scope.cancelNewSubramo = function () {
      $scope.show_new_sub = false;
    };

    $scope.checkSelected = function (value, parUser) {
      if (value) {
        $http.get(url.IP + "bancos/").then(function (bank) {
          $scope.banks = bank.data;

          if (parUser.user_info) {
            if (parUser.user_info.is_vendedor) {
              var seller_data = parUser.user_info.info_vendedor[0];
              $scope.original_data = vendedorStructure(parUser, seller_data);
            }
          } else {
            parUser.hired_date = datesFactory.convertDate(new Date());
          }
        });
      } else {
        $scope.users.forEach(function (user) {
          if (parUser.id == user.id) {
            user["phones"] = [];
            user["subramos"] = [];
          }
        });
      }
    };

    function vendedorStructure(parUser, parData) {
      var date = new Date(parData.hired_date);
      parUser.hired_date = datesFactory.convertDate(date);
      parUser.reference_number = parData.reference_number;
      parUser.gastos_operacion = parData.gastos_operacion;
      parUser.address = parData.address;
      parUser.url = parData.url;

      $scope.banks.forEach(function (bank) {
        if (bank.id == parData.bank) {
          parUser.bank = bank;
        }
      });

      $scope.fcs.forEach(function (frec) {
        if (frec.key == parData.frequencia_de_cobro) {
          parUser.frequencia_de_cobro = frec;
        }
      });

      $scope.pay_ways.forEach(function (pay) {
        if (pay.key == parData.tipo_pago) {
          parUser.pay_way = pay;
        }
      });

      if (parData.vendedor_phone.length) {
        if (parData.vendedor_phone.length == 1) {
          parUser.phone = parData.vendedor_phone[0].phone;
        } else if (parData.vendedor_phone.length > 1) {
          parData.vendedor_phone.forEach(function (phone, index) {
            if (index == 0) {
              parUser.phone = parData.vendedor_phone[0].phone;
            } else {
              parUser.phones.push(phone.phone);
            }
          });
        }
      }

      parData.vendedor_subramos.forEach(function (sub_ramo) {
        if (
          sub_ramo.provider == order.form.aseguradora.id ||
          sub_ramo.provider == 0
        ) {
          var data = {
            comision_percentage: sub_ramo.comision,
            comision: sub_ramo.comision,
            id: sub_ramo.id,
            url: sub_ramo.url,
          };

          order.defaults.providers.forEach(function (provider) {
            if (sub_ramo.provider !== 0) {
              data.provider = provider;
            } else {
              data.provider = "";
            }

            $http
              .get(url.IP + "ramos-by-provider/" + provider.id)
              .then(function (ramo) {
                data.ramos = ramo.data;

                data.ramos.forEach(function (ramo) {
                  if (ramo.id == sub_ramo.ramo) {
                    data.ramo = ramo;
                    data.sub_ramos = ramo.subramo_ramo;

                    ramo.subramo_ramo.forEach(function (sub) {
                      if (sub.id == sub_ramo.subramo) {
                        data.subramo = sub;
                      }
                    });
                  }
                });
              });
          });

          parUser.subramos.push(data);
        }
      });

      return angular.copy(parUser);
    }

    $scope.saveSeller = function (main_index) {
      var user = angular.copy($scope.users[main_index]);

      if (user.user_info) {
        if (user.user_info.is_vendedor) {
          var vendedor_ = user.user_info.info_vendedor[0].id;
        }
      } else {
        var vendedor_ = user.id;
      }

      if (user.subramos.length) {
        var subramos_ = user.subramos.map(function (item) {
          var subramo_post = {
            provider: item.provider ? item.provider.id : 0,
            ramo: item.ramo ? item.ramo.id : 0,
            subramo: item.subramo ? item.subramo.id : 0,
            comision: item.comision_percentage
              ? parseFloat(item.comision_percentage)
              : 0,
            vendedor: vendedor_,
          };

          if (item.id) {
            subramo_post.id = item.id;
          }

          if (item.url) {
            subramo_post.url = item.url;
          }

          return subramo_post;
        });
      } else {
        var subramos_ = [];
      }

      if (user.phones.length) {
        var phones_ = user.phones.map(function (phn) {
          var phones_return = {
            phone: phn,
            vendedor: vendedor_,
          };

          if (phn.id) {
            phones_return.id = phn.id;
          }

          if (phn.url) {
            phones_return.url = phn.url;
          }

          return phones_return;
        });

        if (user.phone) {
          phones_.push({ phone: user.phone, vendedor: vendedor_ });
        }
      } else {
        if (user.phone) {
          var phones_ = [{ phone: user.phone, vendedor: vendedor_ }];
        }
      }

      var hired_date_ = datesFactory.toDate(user.hired_date);

      user.vendedor_subramos = subramos_;
      user.hired_date = hired_date_;
      user.vendedor_phone = phones_;
      user.gastos_operacion = user.gastos_operacion
        ? parseInt(user.gastos_operacion)
        : 0;
      user.user = user.id;
      user.vendedor = vendedor_;
      user.is_vendedor = true;

      if (user.user_info) {
        if (user.user_info.is_vendedor) {
          var data_source = {};

          if (typeof user.bank !== "object") {
            data_source.bank = user.bank;
          }

          if (typeof user.frequencia_de_cobro !== "object") {
            data_source.frequencia_de_cobro = user.frequencia_de_cobro;
          }

          if ($scope.original_data.address !== user.address) {
            data_source.address = user.address;
          }

          if (
            parseFloat($scope.original_data.gastos_operacion) !==
            parseFloat(user.gastos_operacion)
          ) {
            data_source.gastos_operacion = user.gastos_operacion;
          }

          var hired_date_original = datesFactory.toDate(
            $scope.original_data.hired_date
          );
          if (hired_date_original !== hired_date_) {
            data_source.hired_date = user.hired_date;
          }

          if ($scope.original_data.reference_number !== user.reference_number) {
            data_source.reference_number = user.reference_number;
          }

          if ($scope.original_data.pay_way.id !== user.pay_way.id) {
            data_source.pay_way = user.pay_way;
          }

          $http.patch(user.url, data_source).then(function (req) {
            if (req.status !== 200) {
              // error
            }
          });
          if ($scope.original_data.subramos.length !== subramos_.length) {
            // DELETE $scope.delete_subramos
            if ($scope.delete_subramos.length) {
              $scope.delete_subramos.forEach(function (item_d) {
                $http.delete(item_d.url).then(function (delete_item) {});
              });
            }

            subramos_.forEach(function (item) {
              if (item.id) {
                $scope.original_data.subramos.forEach(function (o_item) {
                  if (o_item.id == item.id) {
                    if (
                      parseFloat(o_item.comision) !== parseFloat(item.comision)
                    ) {
                      $http
                        .patch(item.url, { comision: item.comision })
                        .then(function (comision) {
                          toaster.success("Subramo editado correctamente");
                        });
                    }
                  }
                });
              } else {
                // post
                dataFactory
                  .post("subramos-vendedor/", item)
                  .then(function (subramo_) {
                    $http.get(url.IP + "get-vendors/").then(function (user) {
                      $scope.users = user.data;

                      $scope.show_pagination = true;
                      $scope.config_pagination = {
                        count: user.data.count,
                        next: user.data.next,
                        previous: user.data.previous,
                      };

                      $scope.testPagination("users", "config_pagination");

                      $scope.users.forEach(function (user) {
                        user["phones"] = [];
                        user["subramos"] = [];
                      });
                    });
                    //

                    toaster.success("Subramo agregado correctamente");
                  });
              }
            });
          } else {
            subramos_.forEach(function (item) {
              if (item.id) {
                $scope.original_data.subramos.forEach(function (o_item) {
                  if (o_item.id == item.id) {
                    if (
                      parseFloat(o_item.comision) !== parseFloat(item.comision)
                    ) {
                      $http
                        .patch(item.url, { comision: item.comision })
                        .then(function (comision) {
                          toaster.success("Subramo editado correctamente");
                        });
                    }
                  }
                });
              }
            });
          }

          $scope.original_data.phones.push($scope.original_data.phone);
          if ($scope.original_data.phones.length !== phones_.length) {
            // DELETE $scope.delete_subramos
            if ($scope.delete_phones.length) {
              $scope.$scope.delete_phones.forEach(function (item_d) {
                $http.delete(item_d.url).then(function (delete_item) {});
              });
            }

            phones_.forEach(function (item) {
              if (item.id) {
                $scope.original_data.phones.forEach(function (o_item) {
                  if (o_item.id == item.id) {
                    if (
                      parseFloat(o_item.phone) !==
                      parseFloat(item.$scope.delete_phones)
                    ) {
                      $http
                        .patch(item.url, { phone: item.$scope.delete_phones })
                        .then(function (phine) {});
                    }
                  }
                });
              } else {
                // post
                dataFactory
                  .post("phone-vendedor/", item)
                  .then(function (phne_) {});
              }
            });
          }
        } else {
          dataFactory.post("vendedores/", user).then(function (data) {
            if (data.status == 201) {
              $scope.isSeller[main_index] = false;
              $scope.users.forEach(function (user, index) {
                if (user.id == data.data.user) {
                  dataFactory
                    .get("usuarios/" + data.data.user)
                    .then(function (req) {
                      req.data.first_name = req.data.first_name.toUpperCase();
                      req.data.last_name = req.data.last_name.toUpperCase();
                      req.data["phones"] = [];
                      req.data["subramos"] = [];
                      $scope.users[index] = req.data;
                    });
                }
              });
            }
          });
        }
      } else {
        dataFactory.post("vendedores/", user).then(function (data) {
          if (data.status == 201) {
            $scope.isSeller[main_index] = false;
            $scope.users.forEach(function (user, index) {
              if (user.id == data.data.user) {
                dataFactory
                  .get("usuarios/" + data.data.user)
                  .then(function (req) {
                    req.data.first_name = req.data.first_name.toUpperCase();
                    req.data.last_name = req.data.last_name.toUpperCase();
                    req.data["phones"] = [];
                    req.data["subramos"] = [];
                    $scope.users[index] = req.data;
                  });
              }
            });
          }
        });
      }
    };

    $scope.checkValue = function (argument) {
      if (argument) {
        if (parseFloat(argument) < 0) {
          order.form.comision_percent = 0;
        } else if (parseFloat(argument) > 100) {
          order.form.comision_percent = 100;
        } else {
          order.form.comision_percent = parseFloat(
            order.form.comision_percent.toFixed(2)
          );
        }
      }
    };

    $scope.checkDecimal = function (argument) {
      if (argument) {
        if (parseFloat(argument) < 0) {
          order.form.udi = 0;
        } else if (parseFloat(argument) > 100) {
          order.form.udi = 100;
        } else {
          order.form.udi = parseFloat(order.form.udi.toFixed(2));
        }
      }
    };

    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = 0;
      var word_data = order.form.contratante.val;
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
        $scope.contractors_data.length = 0;
      }
    };

    var stuffLoaded = 0;
    var thingsToLoad = 0;

    $scope.sex = [
      { name: "MASCULINO", value: "M" },
      { name: "FEMENINO", value: "F" },
    ];

    order.insuranceObject = {};
    order.user = usr;
    order.hasReceipts = false;
    // Defaults
    order.show = {
      ot: false,
      receipt: false,
      generateReceipts: false,
      receiptsGenerated: false,
      firstTab: true,
      showForms: false,
      showCoverages: false,
      isPolicy: false,
    };

    // var vm =
    $scope.vm = {
      files: [],
    };

    order.form = {
      contratante: "",
      poliza: "",
      folio: "",
      ramo: "",
      type: "",
      subramo: "",
      aseguradora: "",
      paquete: "",
      payment: "",
      startDate: new Date(),
      endingDate: new Date().setYear(new Date().getFullYear() + 1),
      ceder_comision: false,
      comision_percent: 0.0,
      udi: 0.0,
      business_line: 0,
    };

    order.ceder_comision = ceder_comision;
    $scope.ceder_comision = false; // para mostrar los valores de las claves

    order.subforms = {
      auto: {
        selectedCar: {},
      }, //template.formulario.automoviles
      life: {
        beneficiariesList: [],
        aseguradosList: [],
      }, //template.formulario.vida
      disease: {
        relationshipList: [],
      }, //template.formulario.accidentes
      damage: {
        coinsurance: "",
        insured_item: "",
        item_address: "",
        item_details: "",
      }, //template.formulario.danios
    };
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    order.autocomplete = autocomplete;
    $scope.percentage_life = function (input, index, ben) {
      try {
        input = parseFloat(input).toFixed(2);
      } catch (e) {
        input = 0;
      }
      if (input < 0) {
        order.subforms.life.beneficiariesList[index].percentage = 0;
      }
      if (input > 100) {
        order.subforms.life.beneficiariesList[index].percentage = 100;
      }
      if (
        order.subforms.life.beneficiariesList[index].percentage == undefined
      ) {
        order.subforms.life.beneficiariesList[index].percentage = 0;
      }
      ben.percentage = parseFloat(input).toFixed(2);
      order.subforms.life.beneficiariesList[index].percentage = ben.percentage;
      if (ben.percentage == "NaN") {
        ben.percentage = parseFloat(0).toFixed(2);
        order.subforms.life.beneficiariesList[index].percentage =
          ben.percentage;
      }
      if (
        parseFloat(
          order.subforms.life.beneficiariesList[index].percentage
        ).toFixed(2) > 100.0
      ) {
        ben.percentage = 0.0;
        order.subforms.life.beneficiariesList[index].percentage = 0.0;
        SweetAlert.swal(
          "Error",
          "El porcentaje del beneficiario" +
            index +
            ", no puede ser mayor a 100.00.",
          "error"
        );
        return;
      }
      if (
        helpers.beneficiariesPercentageGreaterThanZero(
          order.subforms.life.beneficiariesList
        )
      ) {
        SweetAlert.swal(
          "Error",
          "Revise los porcentajes de los beneficiarios (la suma no debe pasar de 100)",
          "error"
        );
        return;
      }
    };
    function ceder_comision(flag) {
      if (order.form.ceder_comision == true) {
        if (flag == true) {
          SweetAlert.swal(
            {
              title: "¿Está seguro?",
              text: "Estas seguro de que deseas ceder la comisión?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Si, estoy seguro.",
              cancelButtonText: "Cancelar",
              closeOnConfirm: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                $scope.ceder_comision = order.form.ceder_comision;
                // SweetAlert.swal("¡Eliminado!", "El archivo fue eliminado.", "success");
              } else {
                order.form.ceder_comision = false;
              }
            }
          );
        } else {
          $scope.ceder_comision = order.form.ceder_comision;
        }
      } else {
        $scope.ceder_comision = order.form.ceder_comision;
      }
    }

    function getmatches(word) {
      $http
        .post(url.IP + "cars-match/", { matchWord: word })
        .then(function (response) {
          var source = [];
          if (response.data.length) {
            response.data.forEach(function (cars) {
              var obj = {
                label: cars.car_search,
                value: cars,
              };
              source.push(obj);
            });
          } else {
            source.length = 0;
          }

          $scope.autocompleteCarsData = source;
        })
        .catch(function (e) {});
    }

    // $scope.selectedCar = order.subforms.selectedCar;
    function autocomplete(param) {
      try {
        if (param.val.length > 1) {
          getmatches(param.val);
        }
      } catch (e) {}
    }

    $scope.changeIva = function (parValue) {
      if (!parValue) {
        swal("La póliza se creará sin IVA.");
      }
    };

    $scope.$watch(
      "order.subforms.auto.selectedCar.val",
      function (newValue, oldValue) {
        try {
          order.subforms.auto.brand =
            order.subforms.auto.selectedCar.val.value.car_brand;
          order.subforms.auto.model =
            order.subforms.auto.selectedCar.val.value.car_model;
          order.subforms.auto.version =
            order.subforms.auto.selectedCar.val.value.short_description.replace(
              order.subforms.auto.selectedCar.val.value.car_model,
              ""
            );
        } catch (e) {}
      }
    );

    $scope.checkEndDate = function () {
      if (order.form.startDate.length == 10) {
        order.form.endingDate = convertDate(mesDiaAnio(order.form.endingDate));
        order.form.end_of_validity = mesDiaAnio(order.form.endingDate);
        // $scope.dataToSave.end_of_validity = mesDiaAnio(order.form.endingDate);
      }
    };
    $scope.dateOut = false;
    $scope.checkDateValues = function (values) {
      var date1 = datesFactory.toDate(order.form.startDate);
      var date2 = datesFactory.toDate(values);
      $scope.dateOut = false;
      if (date1 > date2) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        $scope.dateOut = true;
        return;
      } else {
        $scope.dateOut = false;
      }
      var date1 = new Date(order.form.start_of_validity);
      var date2 = new Date(order.form.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      order.form.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );

      if (order.form.policy_days_duration > 366) {
        order.poliza.numeroRecibos = 12 / order.poliza.payment;
      }
    };

    $scope.changeFrequency = function () {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Si cambias la forma de pago los recibos actuales serán eliminados y deberás recalcular.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.frec_disabled = false;
            order.receipts = [];
            order.form.receipts = [];
            $scope.edited_pay_frequency = true;
            // SweetAlert.swal("¡Ok!", "", "success");
            // $http.delete(beneficiary.url)
            // .then(function(response) {
            //   order.subforms.life.beneficiariesList.splice(index, 1);
            //   SweetAlert.swal("¡Eliminado!", "El archivo fue eliminado.", "success");
            // });
          }
        }
      );
    };

    // life
    $scope.beneficiary = true;
    $scope.asegurado = true;
    $scope.addBeneficiary = function () {
      $scope.beneficiary = true;
    };

    $scope.delBeneficiary = function () {
      if (order.subforms.life.beneficiariesList.length == 0) {
        $scope.beneficiary = false;
      }
    };

    $scope.addAsegurado = function () {
      $scope.asegurado = true;
    };
    $scope.delAsegurado = function () {
      if (order.subforms.life.aseguradosList.length == 0) {
        $scope.asegurado = false;
      }
    };
    // -life

    function cCurrency(num) {
      num = num.toString().replace(/\$|\,/g, "");
      if (isNaN(num)) {
        num = "0";
      }
      var sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      var cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) {
        cents = "0" + cents;
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num =
          num.substring(0, num.length - (4 * i + 3)) +
          "," +
          num.substring(num.length - (4 * i + 3));
      }
      return (sign ? "" : "-") + "$" + num + "." + cents;
    }

    $scope.generarRecibos = function () {
      var form_ = order.form.payment.value;
      if (form_ == 5) {
        form_ = 12;
      }

      var initDate = new Date(order.form.start_of_validity);
      var endDate = new Date(order.form.end_of_validity);
      var months = helpers.monthDiff(initDate, endDate);

      var dateDiff = moment(endDate).diff(moment(initDate), "days");

      for (var i = 0; i < order2.receipts.length; i++) {
        if (i == 0) {
          var dayStartDate = new Date(toDate(order.form.startDate)).getDate();
          var monthStartDate = new Date(
            toDate(order.form.startDate)
          ).getMonth();
          var yearStartDate = new Date(
            toDate(order.form.startDate)
          ).getFullYear();
          monthStartDate = monthStartDate + form_;
          if (monthStartDate > 11) {
            monthStartDate = (monthStartDate % 12) + 1;
            yearStartDate++;
          } else {
            monthStartDate++;
          }
          if (dayStartDate < 10) {
            dayStartDate = "0" + dayStartDate;
          }
          if (monthStartDate < 10) {
            monthStartDate = "0" + monthStartDate;
          }
          var date = dayStartDate + "/" + monthStartDate + "/" + yearStartDate;
          order2.receipts[i].startDate = order.form.startDate;
          order2.receipts[i].endingDate = date;
        }
        if (i > 0) {
          var dateNew = new Date(toDate(order2.receipts[i - 1].endingDate));
          var dayStartDate = dateNew.getDate();
          var monthStartDate = dateNew.getMonth();
          var yearStartDate = dateNew.getFullYear();
          monthStartDate = monthStartDate + form_;
          if (monthStartDate > 11) {
            monthStartDate = (monthStartDate % 12) + 1;
            yearStartDate++;
          } else {
            monthStartDate++;
          }
          if (dayStartDate < 10) {
            dayStartDate = "0" + dayStartDate;
          }
          if (monthStartDate < 10) {
            monthStartDate = "0" + monthStartDate;
          }
          var date = dayStartDate + "/" + monthStartDate + "/" + yearStartDate;
          order2.receipts[i].startDate = order2.receipts[i - 1].endingDate;
          order2.receipts[i].endingDate = date;
        }

        if (order2.receipts[i].recibo_numero == 1) {
          order2.receipts[i].vencimiento = sumarDias(
            angular.copy(toDate(order2.receipts[i].startDate)),
            30
          );
          order2.receipts[i].vencimiento = convertDate(
            order2.receipts[i].vencimiento
          );
        } else {
          order2.receipts[i].vencimiento = order2.receipts[i].startDate;
        }
      }
    };

    function sumarDias(fecha, dias) {
      fecha.setDate(fecha.getDate() + dias);
      return fecha;
    }

    $scope.changeComision = function (event, backspace) {
      var len_value = String(order.form.give_comision).length;
      var value = parseFloat(order.form.give_comision);

      if (value > 100) {
        order.form.give_comision = 100;
      }
    };
    $scope.changeNoPoliza = function (noPoliza) {
      if ($localStorage.poliza_number != noPoliza) {
        helpers
          .existPolicyNumber(noPoliza)
          .then(function (request) {
            if (request == true) {
              SweetAlert.swal("Error", MESSAGES.ERROR.POLICYEXIST, "error");
              order.form.poliza = "";
            }
          })
          .catch(function (err) {});
      }
    };

    $scope.changeAgrupacion = function (data) {
      $scope.sub_asignaciones = data.subgrupos;
      $scope.sub_subasignaciones = [];
      if ($scope.info_sub.subgrouping_level) {
        $scope.sub_asignaciones.forEach(function (item) {
          if (item.id == $scope.info_sub.subgrouping_level.id) {
            $http
              .get(
                url.IP + "groupinglevel/" + $scope.info_sub.subgrouping_level.id
              )
              .then(function (response) {
                order.form.subgrouping = response.data;
                $scope.changeSubagrupacion(item);
              });
          }
        });
        // $http.get(url.IP + 'groupinglevel/' + $scope.info_sub.subgrouping_level.id)
        // .then(function(response) {
        //   order.form.subgrouping = response.data;
        //   $scope.sub_asignaciones.forEach(function(item){
        //     if(item.id == order.form.subgrouping.id){
        //       $scope.changeSubagrupacion(item);
        //     }
        //   });
        // });
      }
    };

    $scope.changeSubagrupacion = function (data) {
      if (data.subsubgrupos) {
        $scope.sub_subasignaciones = data.subsubgrupos;
        if ($scope.info_sub.subsubgrouping_level) {
          $scope.sub_subasignaciones.forEach(function (item) {
            if (item.id == $scope.info_sub.subsubgrouping_level.id) {
              $http
                .get(
                  url.IP +
                    "groupinglevel/" +
                    $scope.info_sub.subsubgrouping_level.id
                )
                .then(function (response) {
                  order.form.subsubgrouping = response.data;
                });
            }
          });
        }
      }
    };

    order.options = {
      checkDate: function (param) {
        if (param && param != 0) {
          var date = new Date(order.form.startDate);
          order.form.endingDate = new Date(
            date.setYear(date.getFullYear() + 1)
          );
          order.form.endingDate = convertDate(order.form.endingDate);

          if (order.form.aseguradora) {
            get_claves();
          }

          order.form.start_of_validity = order.form.startDate;
          order.form.end_of_validity = toDate(order.form.endingDate);

          order.form.startDate = convertDate(order.form.startDate);

          if (order.form.contratante.id) {
            order.form.contratante.value = order.form.contratante;
            if (order.form.contratante.full_name) {
              order.form.contratante.val = order.form.contratante.full_name;
            } else if (order.form.contratante.name) {
              order.form.contratante.val = order.form.contratante.name;
            } else if (order.form.contratante.first_name) {
              order.form.contratante.val =
                order.form.contratante.first_name +
                " " +
                insuranceContractor.last_name +
                " " +
                insuranceContractor.second_last_name;
            } else if (order.form.contratante.j_name) {
              order.form.contratante.val = order.form.contratante.j_name;
            }
          }
        } else if (param == 0) {
          if (order.form.contratante.id) {
            order.form.contratante.value = order.form.contratante;
            if (order.form.contratante.full_name) {
              order.form.contratante.val = order.form.contratante.full_name;
            } else if (order.form.contratante.name) {
              order.form.contratante.val = order.form.contratante.name;
            } else if (order.form.contratante.first_name) {
              order.form.contratante.val =
                order.form.contratante.first_name +
                " " +
                insuranceContractor.last_name +
                " " +
                insuranceContractor.second_last_name;
            } else if (order.form.contratante.j_name) {
              order.form.contratante.val = order.form.contratante.j_name;
            }
          }
        } else {
          $scope.generarRecibos();
          SweetAlert.swal(
            "Advertencia",
            MESSAGES.WARNING.WARNINGRECEIPTS,
            "warning"
          );
        }

        // fecha de fin de vigencia
        if (order.form.startDate.length == 10) {
          var x = mesDiaAnio(order.form.startDate);
          var date = new Date(x);
          order.form.endingDate = new Date(
            date.setYear(date.getFullYear() + 1)
          );
          if (order.form.subramo) {
            get_claves();
          }
          order.form.startDate = new Date(x);
          order.form.endingDate = convertDate(order.form.endingDate);
          order.form.start_of_validity = new Date(x);
          order.form.end_of_validity = new Date(
            mesDiaAnio(order.form.endingDate)
          );

          order.form.startDate = convertDate(order.form.startDate);
        }
      },
      showPoliceCreator: function () {
        if (order.defaults.showReceipts === false) {
          return true;
        }
        return false;
      },
      hideTabs: function (param) {
        if (param == false) {
          firstTime = false;
        }
        order.show.firstTab = param ? true : false;

        var primaNeta;
        var rpf;
        var derecho;
        var total = 0.0;
        var subtotal = 0.0;

        order2.receipts.forEach(function (elem) {
          primaNeta += parseFloat(elem.prima);
          derecho += parseFloat(elem.derecho);
          rpf += parseFloat(elem.rpf);
          total += parseFloat(elem.total);
          subtotal += parseFloat(elem.subTotal);
          // recibo_numero=elem.recibo_numero;
        });

        order.poliza.primaNeta = primaNeta;
        order.poliza.derecho = derecho.toFixed(2);
        order.poliza.rpf = rpf.toFixed(2);
        order.poliza.primaTotal = total;
        order.poliza.subTotal = subtotal;
      },
      changeProvider: function (obj) {
        order.form.aseguradora = obj;
        if (obj) {
          var wait = [];
          get_claves();
          wait.push(
            $http.get(url.IP + "ramos-by-provider/" + order.form.aseguradora.id)
          );
          $q.all(wait).then(function (response) {
            order.defaults.ramos = response[0].data;
          });
          // order.defaults.ramos = obj.ramo_provider;
        } else {
          order.defaults.ramos = [];
        }
        order.options.changeRamo(undefined);
      },
      changeClave: function (parClave) {
        order.defaults.comisiones = [];
        order.formService.clave = parClave.id;
      },
      changeRamo: function (obj) {
        order.form.ramo = obj;
        if (obj) {
          order.defaults.subramos = obj.subramo_ramo;
        } else {
          order.form.ramo = "";
          order.defaults.subramos = [];
        }
        order.options.changeSubramo(undefined);
      },
      changeSubramo: function (obj) {
        order.form.subramo = obj;
        if (obj) {
          if (
            order &&
            order.form &&
            order.form.ramo &&
            order.form.ramo.ramo_code &&
            order.form.ramo.ramo_code == 2
          ) {
            order.subforms.disease.policy_type = 46;
          }
          order.defaults.forms = obj.forms_subramo;
          order.defaults.waitElement = [];
          order.defaults.waitElement.push(
            $http
              .post(url.IP + "paquetes-data-by-subramo/", {
                ramo: order.form.ramo.id,
                subramo: obj.id,
                provider: order.form.aseguradora.id,
              })
              .then(function (paquetes) {
                order.defaults.packages = paquetes.data;
              })
          );

          order.show.showForms = true;
          order.defaults.formInfo = {
            code: obj.subramo_code,
            name: obj.subramo_name,
          };
        } else {
          order.defaults.forms = undefined;
          order.defaults.packages = [];
          order.show.showForms = false;
          order.defaults.formInfo = {
            code: undefined,
            name: undefined,
          };
        }
        order.options.changePackage(undefined);
      },
      changePackage: function (obj) {
        order.form.paquete = obj;
        if (obj) {
          $scope.newCoverPack = true;
          order.defaults.coverages = [];
          order.defaults.coverageList = [];

          $scope.coverages_data = angular.copy(obj.coverage_package);
          obj.coverage_package.forEach(function (element, index) {
            if (element.default) {
              order.defaults.coverages.push(angular.copy(element));
            } else {
              order.defaults.coverageList.push(angular.copy(element));
            }
          });
          order.show.showCoverages = true;
        } else {
          order.defaults.coverages = [];
          order.show.showCoverages = false;
        }
      },
      isReceiptAvailable: function (payment, inhibit) {
        order.form.payment = payment;
        // order.receipts = [];
        //order.form.payment = angular.copy(payment);
        if (payment && order.form.poliza && !inhibit) {
          toaster.success("Ya puede generar sus recibos");
        } else if (payment && !inhibit) {
          toaster.info("Favor de ingresar el número de poliza");
        }
      },
      deleteCoverage: function (obj, index) {
        // if(usr.permiso.eliminar){
        obj.toDelete = true;
        order.defaults.coverages.splice(index, 1);

        var cl = order.defaults.coverageList;
        var flag = false;
        for (var i = 0; i < cl.length; i++) {
          if (cl[i].id === obj.id) {
            flag = true;
          }
        }
        if (!flag) {
          order.defaults.coverageList.push(obj);
        }

        // }
        // else{
        //   SweetAlert.swal("Oops...", "No tienes permiso para eliminar registros", "error");
        // }
      },
      addCoverage: function (obj) {
        var dfd = $q.defer();
        var delCoverage = order.defaults.coverages.length > 0 ? false : true;
        var cvgCopy = angular.copy(obj);
        var wait = [];
        wait.push($http.get(obj.url));
        $q.all(wait).then(function (coverage) {
          coverage.forEach(function (cvg) {
            dfd.resolve(cvg);

            var cvgCopy = cvg.data;

            order.defaults.coverages.forEach(function (item) {
              if (item.id == cvgCopy.id) {
                cvgCopy.sums_coverage = item.sums_coverage;
                cvgCopy.deductible_coverage = item.deductible_coverage;
              }
            });

            if (cvgCopy.id == obj.id) {
              obj.sums_coverage = cvgCopy.sums_coverage;
              obj.deductible_coverage = cvgCopy.deductible_coverage;

              if (!cvgCopy.coinsuranceInPolicy && obj.coinsuranceInPolicy) {
                var coaseguro_ = obj.coinsuranceInPolicy;
                if (coaseguro_) {
                  obj.coinsuranceInPolicy = {
                    value: coaseguro_ ? coaseguro_ : 0,
                  };
                } else {
                  obj.coinsuranceInPolicy = {
                    value: coaseguro_ ? coaseguro_ : 0,
                  };

                  obj.coinsuranceInPolicy = {
                    value: coaseguro_ ? coaseguro_ : 0,
                  };
                }
              } else if (
                cvgCopy.coinsuranceInPolicy &&
                obj.coinsuranceInPolicy
              ) {
              }
              if (
                !cvgCopy.topeCoinsuranceInPolicy &&
                obj.topeCoinsuranceInPolicy
              ) {
                var topecoaseguro_ = obj.topeCoinsuranceInPolicy;
                if (topecoaseguro_) {
                  obj.topeCoinsuranceInPolicy = {
                    value: topecoaseguro_ ? topecoaseguro_ : 0,
                  };
                } else {
                  obj.topeCoinsuranceInPolicy = {
                    value: topecoaseguro_ ? topecoaseguro_ : 0,
                  };

                  obj.topeCoinsuranceInPolicy = {
                    value: topecoaseguro_ ? topecoaseguro_ : 0,
                  };
                }
              } else if (
                cvgCopy.topeCoinsuranceInPolicy &&
                obj.topeCoinsuranceInPolicy
              ) {
              }
            }

            for (var i = order.defaults.coverages.length - 1; i >= 0; i--) {
              if (
                order.defaults.coverages[i].coverage_name === obj.coverage_name
              ) {
                // toaster.info('Ya existe la cobertura: ' + obj.coverage_name);
                order.defaults.coverageList.forEach(function (coverage) {
                  if (coverage.coverage_name == obj.coverage_name) {
                    order.defaults.coverageList.splice(
                      order.defaults.coverageList.indexOf(coverage),
                      1
                    );
                  }
                });
                delCoverage = false;
                break;
              } else {
                delCoverage = true;
              }
            }

            if (delCoverage) {
              $scope.coverages_data.forEach(function (item) {
                if (item.coverage_name == obj.coverage_name) {
                  obj.sums_coverage = item.sums_coverage;
                  obj.deductible_coverage = item.deductible_coverage;
                }
              });

              order.defaults.coverages.push(obj);

              order.defaults.coverageList.forEach(function (coverage) {
                // coverage.sumInPolicy.value = cCurrency(coverage.sumInPolicy.value);
                // coverage.deductibleInPolicy.value = cCurrency(coverage.deductibleInPolicy.value)
                if (coverage.coverage_name == obj.coverage_name) {
                  order.defaults.coverageList.splice(
                    order.defaults.coverageList.indexOf(coverage),
                    1
                  );
                }
              });

              cvgCopy.deductible_coverage_parsed = [];
              cvgCopy.sums_coverage_parsed = [];

              try {
                cvgCopy.deductible_coverage.forEach(function (deductible) {
                  var obj = {
                    label: deductible.deductible,
                    value: deductible.deductible,
                  };
                  cvgCopy.deductible_coverage_parsed.push(obj);
                });

                cvgCopy.sums_coverage.forEach(function (suma) {
                  var obj = {
                    label: suma.sum_insured,
                    value: suma.sum_insured,
                  };

                  cvgCopy.sums_coverage_parsed.push(obj);
                });
              } catch (e) {}
            }

            order.defaults.coverageInPackage = "";
            return dfd.promise;
          });
        });
      },
      life: {
        beneficiary: {
          add: function (parBeneficiary) {
            var beneficiary = {
              person: 1,
            };
            if (parBeneficiary) {
              beneficiary = parBeneficiary;
            }
            order.subforms.life.beneficiariesList.push(beneficiary);
          },
          destroy: function (index, beneficiary) {
            if (beneficiary.url) {
              SweetAlert.swal(
                {
                  title: "¿Está seguro?",
                  text: "El beneficiario se eliminará definitivamente aunque no guarde los cambios",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Si, estoy seguro.",
                  cancelButtonText: "Cancelar",
                  closeOnConfirm: false,
                },
                function (isConfirm) {
                  if (isConfirm) {
                    // deleteIT(url, file.id)
                    $http.delete(beneficiary.url).then(function (response) {
                      order.subforms.life.beneficiariesList.splice(index, 1);
                      SweetAlert.swal(
                        "¡Eliminado!",
                        "El dependiente fue eliminado definitivamente.",
                        "success"
                      );
                    });
                  }
                }
              );
            } else {
              order.subforms.life.beneficiariesList.splice(index, 1);
            }
          },
        },
        asegurados: {
          add: function (parAsegurados) {
            console.log("2173", parAsegurados);
            var asegurados = {};
            if (parAsegurados) {
              asegurados = parAsegurados;
            }
            order.subforms.life.aseguradosList.push(asegurados);
          },
          destroy: function (index, asegurados) {
            if (asegurados.url) {
              SweetAlert.swal(
                {
                  title: "¿Está seguro?",
                  text: "El asegurado se eliminará definitivamente aunque no guarde los cambios",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Si, estoy seguro.",
                  cancelButtonText: "Cancelar",
                  closeOnConfirm: false,
                },
                function (isConfirm) {
                  if (isConfirm) {
                    // deleteIT(url, file.id)
                    $http.delete(asegurados.url).then(function (response) {
                      order.subforms.life.aseguradosList.splice(index, 1);
                      SweetAlert.swal(
                        "¡Eliminado!",
                        "El asegurado fue eliminado definitivamente.",
                        "success"
                      );
                    });
                  }
                }
              );
            } else {
              order.subforms.life.aseguradosList.splice(index, 1);
            }
          },
        },
      },
      disease: {
        fillContractorData: function () {
          /*if (!order.form.contratante) {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.CONTRACTORERROR, "error");
            order.options.checkDate('initial');
            return;
          }
          if (order.form.contratante.type_person != 'Fisica') {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.CONTRACTORTYPEPERSON, "error");
            order.options.checkDate('initial');
            return;
          }

          insuranceService.getContractorPersonalInfo(order.form.contratante.id).then(function(response){
            var data = response.data;
            order.subforms.disease.first_name = data.first_name;
            order.subforms.disease.last_name=data.last_name;
            order.subforms.disease.second_last_name = data.second_last_name;
            order.subforms.disease.birthdate = new Date(data.birthday);
            order.subforms.disease.sex = data.sex;
          });*/

          if (!order.form.contratante.value) {
            SweetAlert.swal("Error", MESSAGES.ERROR.CONTRACTORERROR, "error");
            return;
          } else {
            var contractor_ = order.form.contratante.value;
            if (
              order.form.contratante.value.type_person != "Fisica" &&
              order.form.contratante.value.type_person != 1
            ) {
              SweetAlert.swal(
                "Error",
                MESSAGES.INFO.CONTRACTORTYPEPERSON,
                "error"
              );
              return;
            } else {
              order.subforms.disease.first_name = contractor_.first_name;
              order.subforms.disease.last_name = contractor_.last_name;
              order.subforms.disease.second_last_name =
                contractor_.second_last_name;
              order.subforms.disease.birthdate = convertDate(
                contractor_.birth_date
              );
              order.subforms.disease.sex = contractor_.sex;
            }
          }
        },
        relationships: {
          add: function (relacion) {
            if (relacion) {
              order.options.disease.relationships.selectType(
                relacion.relationship,
                null
              );
              order.subforms.disease.relationshipList.push(relacion);
            } else {
              var rel = {
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: null,
                sex: null,
                relationship: null,
                accident: null,
              };
              order.subforms.disease.relationshipList.push(rel);
            }
          },
          destroy: function (index, rel) {
            if (rel.url) {
              SweetAlert.swal(
                {
                  title: "¿Está seguro?",
                  text: "El dependiente se eliminará definitivamente aunque no guarde los cambios",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Si, estoy seguro.",
                  cancelButtonText: "Cancelar",
                  closeOnConfirm: false,
                },
                function (isConfirm) {
                  if (isConfirm) {
                    // deleteIT(url, file.id)
                    $http.delete(rel.url).then(function (response) {
                      order.subforms.disease.relationshipList.splice(index, 1);
                      SweetAlert.swal(
                        "¡Eliminado!",
                        "El dependiente fue eliminado definitivamente.",
                        "success"
                      );
                    });
                  }
                }
              );
            } else {
              order.subforms.disease.relationshipList.splice(index, 1);
            }
          },
          selectType: function (newValue, old) {
            var oldValue = old != "" ? JSON.parse(old) : null;
            var newIndex = -1;
            order.options.disease.types.some(function (valueData, index) {
              if (valueData.relationship == newValue.relationship) {
                newIndex = index;
                return true;
              }
            });
            var oldIndex = -1;

            if (newValue.relationship == 1 || newValue.relationship == 2) {
              // titular y conyugue
              order.options.disease.types[newIndex].disabled = true;
            }

            if (oldValue) {
              order.options.disease.types.some(function (val, index) {
                if (val.relationship == oldValue.relationship) {
                  oldIndex = index;
                  return true;
                }
              });

              if (oldValue.relationship == 1 || oldValue.relationship == 2) {
                // titular y conyugue
                order.options.disease.types[oldIndex].disabled = false;
              }
            }
          },
        },
        // 1-Titular, 2-Conyuge, 3-Hijo
        types: angular.copy(tiposBeneficiarios),
      },
    };

    $scope.percentageRange = function (input, index) {
      if (input < 0) {
        order.defaults.coverages[index].coinsuranceInPolicy.value = 0;
      }
      if (input > 100) {
        order.defaults.coverages[index].coinsuranceInPolicy.value = 100;
      }
    };

    $scope.percentageRange1 = function (input, index) {
      if (input < 0) {
        order.defaults.coverages[index].topeCoinsuranceInPolicy.value = 0;
      }
      if (input > 100) {
        order.defaults.coverages[index].topeCoinsuranceInPolicy.value = 100;
      }
    };

    function get_claves() {
      // $http.post(url.IP+'claves-by-provider/'+order.form.aseguradora.id+ '/' + order.form.ramo.id + '/' + order.form.subramo.id,
      // {'initialDate': new Date(mesDiaAnio(order.form.startDate))})
      $http
        .get(url.IP + "claves-by-provider/" + order.form.aseguradora.id)
        .then(function (clavesResponse) {
          if (clavesResponse.status == 200) {
            // if(clavesResponse.length == 0){
            // }
            // clavesResponse.data.forEach(function(clave) {
            //   clave.efective_date = new Date(clave.efective_date).toISOString().split("T")[0];
            // });

            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                // clave.efective_date = new Date(clave.efective_date).toISOString().split("T")[0];
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });

            order.defaults.claves = clavesResponse.data;

            if (order.defaults.claves.length == 1) {
              order.form.clave = order.defaults.claves[0];
            }

            $scope.comisiones_poliza = [];
            for (var i = 0; i < order.defaults.claves.length; i++) {
              if (order.form.clave.name == order.defaults.claves[i].name) {
                $scope.clave_poliza = order.defaults.claves[i];
              }
            }

            for (
              var i = 0;
              i < $scope.clave_poliza.clave_comision.length;
              i++
            ) {
              try {
                if (
                  order.form.subramo.subramo_name ==
                  $scope.clave_poliza.clave_comision[i].subramo
                ) {
                  $scope.comisiones_poliza.push(
                    $scope.clave_poliza.clave_comision[i]
                  );
                }
              } catch (e) {}
            }

            order.form.comisiones = $scope.comisiones_poliza;
          }
        });
    }

    $scope.$watch("order.form.subramo", function (newValue, oldValue) {
      if (order.form.subramo) {
        get_claves();
        try {
          if (
            parseFloat(order.form.comision_percent) !=
              parseFloat(order.form.clave.comission) ||
            parseFloat(order.form.udi) != parseFloat(order.form.clave.udi)
          ) {
            order.form.ceder_comision = true;
            ceder_comision(false);
          }
        } catch (e) {
          if (
            order.form.comision_percent != order.form.clave.comission ||
            order.form.udi != order.form.clave.udi
          ) {
            order.form.ceder_comision = true;
            ceder_comision(false);
          }
        }
      }
    });

    $scope.$watch("order.defaults.coverages", function (newValue, oldValue) {
      newValue.forEach(function (coverage) {
        coverage.deductible_coverage_parsed = [];
        coverage.sums_coverage_parsed = [];

        try {
          coverage.deductible_coverage.forEach(function (deductible) {
            var obj = {
              label: deductible.deductible,
              value: deductible.deductible,
            };
            coverage.deductible_coverage_parsed.push(obj);
          });

          coverage.sums_coverage.forEach(function (suma) {
            var obj = {
              label: suma.sum_insured,
              value: suma.sum_insured,
            };
            coverage.sums_coverage_parsed.push(obj);
          });
        } catch (e) {}
      });
    });

    order.defaults = {
      sex: angular.copy(sex),
      years: [],
      policyUrl: {},
      contractors: [],
      providers: [],
      ramos: [],
      subramos: [],
      packages: [],
      coverages: [],
      formInfo: {},
      coverageInPackage: {},
      payform: angular.copy(formaPago),
      getContractorsByGroup: function () {
        // loadingThing("contractors");
        // ContratanteService.getMediumLevelContratantes()
        //   .then(function(res) {
        //     var contractors = [];
        //     res.forEach(function(contratante, index) {
        //       if(!contratante.j_name){
        //             contratante.id = blankName(contratante.id);
        //             contratante.groupName = contratante.group;
        //             contratante.name = blankName(contratante.first_name) + ' ' + blankName(contratante.last_name) + ' ' + blankName(contratante.second_last_name);
        //             contractors.push(contratante);
        //       }
        //       else{
        //             contratante.id = blankName(contratante.id);
        //             contratante.groupName = contratante.group;
        //             contratante.name = contratante.j_name;
        //             contractors.push(contratante);
        //       }
        //     });
        //     order.defaults.contractors = contractors;
        //     aThingIsDone("contractors");
        //   });
      },
    };

    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 1; i >= oldYear; i--) {
      order.defaults.years.push(i);
    }

    function blankName(name) {
      if (name === undefined || name === "" || name === null) {
        return "";
      } else {
        return name;
      }
    }

    function getFormData(form) {
      order.defaults.coverages.forEach(function (item) {
        // suma asegurada
        if (
          item.sumInPolicy == undefined ||
          item.sumInPolicy == null ||
          item.sumInPolicy == ""
        ) {
          item.sumInPolicy = {
            label: 0,
            value: 0,
          };
        }
        if (!item.sumInPolicy.label && item.sumInPolicy.value) {
          item.sumInPolicy.label = item.sumInPolicy.value;
        } else if (item.sumInPolicy.label && item.sumInPolicy.value) {
          if (item.sumInPolicy.label !== item.sumInPolicy.value) {
            item.sumInPolicy.label = item.sumInPolicy.value;
          }
        }

        // deducible
        if (item.deductibleInPolicy) {
          if (!item.deductibleInPolicy.label && item.deductibleInPolicy.value) {
            item.deductibleInPolicy.label = item.deductibleInPolicy.value;
          } else if (
            item.deductibleInPolicy.label &&
            item.deductibleInPolicy.value
          ) {
            if (
              item.deductibleInPolicy.label !== item.deductibleInPolicy.value
            ) {
              item.deductibleInPolicy.label = item.deductibleInPolicy.value;
            }
          }
        }

        // coinsurance
        // if(item.coinsuranceInPolicy) {

        //   if(!item.coinsuranceInPolicy.label && item.coinsuranceInPolicy.value) {
        //     item.coinsuranceInPolicy.label = item.coinsuranceInPolicy.value;
        //   } else if(item.coinsuranceInPolicy.label && item.coinsuranceInPolicy.value) {
        //     if(item.coinsuranceInPolicy.label !== item.coinsuranceInPolicy.value) {
        //       item.coinsuranceInPolicy.label = item.coinsuranceInPolicy.value;
        //     }
        //   }
        // }
      });

      var insurance = order.insuranceObject;
      form.poliza_number = form.poliza_number == "" ? 0 : form.poliza_number;
      form.url = insurance.url;
      form.id = insurance.id;
      form.owner = insurance.owner;
      form.created_at = insurance.created_at;
      form.internal_number = insurance.internal_number;
      form.old_policies = [];
      form.observations = insurance.observations;
      form.receipts = order.receipts;
      form.old_receipts = insurance.recibos_poliza;
      form.coverages = order.defaults.coverages;
      form.old_coverages = myInsurance.coverageInPolicy_policy;

      try {
        form.old_form =
          order.insuranceObject.accidents_policy.length > 0
            ? order.insuranceObject.accidents_policy[0].url
            : order.insuranceObject.automobiles_policy.length > 0
            ? order.insuranceObject.automobiles_policy[0].url
            : order.insuranceObject.damages_policy.length > 0
            ? order.insuranceObject.damages_policy[0].url
            : order.insuranceObject.life_policy.length > 0
            ? order.insuranceObject.life_policy[0].url
            : undefined;
      } catch (e) {
        form.old_form = undefined;
      }
      form.form_code = order.defaults.formInfo.code;

      try {
        insurance.old_policies.forEach(function (old) {
          form.old_policies.push(old.url);
        });
      } catch (e) {
        form.old_policies = [];
      }

      var code = order.defaults.formInfo.code;

      if (code === 9) {
        var auto = angular.copy(order.subforms.auto);
        form.form_object = {
          code: code,
          //insurance: res,
          form: auto,
        };
      } else if (code === 1 || code == 30) {
        // Personal information

        $scope.dataIncompleteBenef_f = false;
        $scope.dataIncompleteBenef_j = false;
        var life = order.subforms.life;
        var beneficiaries = order.subforms.life.beneficiariesList;
        var personal_life = order.subforms.life.aseguradosList;
        if (
          order.subforms.life.beneficiariesList.length >= 0 &&
          order.defaults.formInfo.code === 1 &&
          $scope.beneficiary == true
        ) {
          var count_j = 0;
          var count_f = 0;
          var beneficiariesList = _.map(
            order.subforms.life.beneficiariesList,
            function (item, i) {
              if (item.person == 1) {
                if (
                  item.first_name == null ||
                  item.first_name == "" ||
                  item.first_name == undefined
                ) {
                  $scope.dataIncompleteBenef_f = true;
                  count_f = count_f + 1;
                }
              } else if (item.person == 2) {
                if (
                  item.j_name == null ||
                  item.j_name == "" ||
                  item.j_name == undefined
                ) {
                  $scope.dataIncompleteBenef_j = true;
                  count_j = count_j + 1;
                }
              }

              if (item.person == 1) {
                if (
                  item.first_name != null ||
                  item.first_name != "" ||
                  item.first_name != undefined
                ) {
                  // $scope.dataIncompleteBenef_f = false
                  $scope.d_f = false;
                }
              } else if (item.person == 2) {
                if (
                  item.j_name != null ||
                  item.j_name != "" ||
                  item.j_name != undefined
                ) {
                  // $scope.dataIncompleteBenef_j = false
                  $scope.d_j = false;
                }
              }
            }
          );
          if (
            (count_f > 0 && $scope.dataIncompleteBenef_f == true) ||
            (count_j > 0 && $scope.dataIncompleteBenef_j == true)
          ) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            SweetAlert.swal(
              "Error",
              "Complete datos de beneficiario(s) nombre (si es Físico) o razón social (si es Moral)",
              "error"
            );
            l.stop();
            return;
          }
        }

        // var personal = {
        //   first_name: life.first_name ? life.first_name : '',
        //   last_name: life.last_name ? life.last_name : '',
        //   second_last_name: life.second_last_name ? life.second_last_name : '',
        //   birthdate: life.birthdate,
        //   sex: life.sex ? life.sex : '',
        //   url: life.url ? life.url : '',
        //   full_name: life.first_name + ' ' + life.last_name + ' ' + life.second_last_name
        // };

        form.form_object = {
          code: code,
          personal: personal_life,
          relationships: beneficiaries,
          //insurance: res,
          smoker: order.subforms.life.smoker,
        };
      } else if (code === 2 || code === 3 || code === 4) {
        var disease = order.subforms.disease;
        var relationships = order.subforms.disease.relationshipList;
        var type = helpers.diseaseType(order.defaults.formInfo.code);

        var personal = {
          first_name: disease.first_name ? disease.first_name : "",
          last_name: disease.last_name ? disease.last_name : "",
          second_last_name: disease.second_last_name
            ? disease.second_last_name
            : "",
          birthdate: new Date(datesFactory.toDate(disease.birthdate)),
          antiguedad: disease.antiguedad
            ? new Date(datesFactory.toDate(disease.antiguedad))
            : null,
          sex: disease.sex ? disease.sex : "",
          url: disease.personal_url ? disease.personal_url : "",
          full_name:
            disease.first_name +
            " " +
            disease.last_name +
            " " +
            disease.second_last_name,
          policy_type:
            disease.policy_type && disease.policy_type.id
              ? disease.policy_type.id
              : disease.policy_type
              ? disease.policy_type
              : "",
        };
        form.form_object = {
          code: code,
          personal: personal,
          relationships: relationships,
          coinsurance: disease.coinsurance,
          //insurance: res
        };
      } else if (
        code === 5 ||
        code === 6 ||
        code === 7 ||
        code === 8 ||
        code === 10 ||
        code === 11 ||
        code === 12 ||
        code === 13 ||
        code === 14 ||
        code === 14 ||
        code === 31
      ) {
        var damage = order.subforms.damage;
        var type = helpers.damageType(parseInt(code));
        //damage.sub_branch = res.subramo;
        damage.damage_type = order.subforms.damage.damage_type;
        //damage.policy = res.url;

        form.form_object = {
          //insurance: res,
          code: code,
          form: damage,
        };
      } else {
        form.form_object = undefined;
      }

      return form;
    }

    $scope.changePerson = function (type, raw) {
      raw.person = type;
    };

    $scope.changeBusinessLine = function (val) {};

    $scope.changeCelula = function (val) {};

    $scope.changeSucursal = function (val) {};

    $scope.changeCurrency = function (val) {};

    $scope.changeConducto = function (val) {};

    order.save = {
      openPdf: function () {
        var wait = [];
        wait.push(insuranceService.getInsuranceData(myInsurance));
        $q.all(wait).then(function (response) {
          pdfService.getPdf({ insuranceData: response[0], open: true });
        });
      },

      downloadPdf: function () {
        var wait = [];
        wait.push(insuranceService.getInsuranceData(myInsurance));
        $q.all(wait).then(function (response) {
          pdfService.getPdf({ insuranceData: response[0], open: false });
        });
      },

      saveChangesInOt: function () {
        // guardar como OT
        if ($scope.dateOut == true) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }
        var l_ot = Ladda.create(document.querySelector(".ladda-button-ot"));
        l_ot.start();

        if (order.form.start_of_validity) {
          var startDate = new Date(order.form.start_of_validity).setHours(
            12,
            0,
            0,
            0
          );
          var endingDate = new Date(order.form.end_of_validity).setHours(
            11,
            59,
            59,
            0
          );
          order.form.startDate = new Date(startDate);
          order.form.endingDate = new Date(endingDate);
        } else {
          var startDate = new Date(mesDiaAnio(order.form.startDate)).setHours(
            12,
            0,
            0,
            0
          );
          var endingDate = new Date(mesDiaAnio(order.form.endingDate)).setHours(
            11,
            59,
            59,
            0
          );
          order.form.startDate = new Date(startDate);
          order.form.endingDate = new Date(endingDate);
        }

        if (order.form.contratante.value) {
          order.form.contratante = order.form.contratante.value;
        } else if (order.form.contratante.id) {
        }

        if (!usr.permiso.editar) {
          l_ot.stop();
          SweetAlert.swal(
            "Oops...",
            "No tienes permiso para editar registros",
            "error"
          );
          return;
        }
        if (!order.form.ramo) {
          if (!order.form.ramo.url) {
            l_ot.stop();
            SweetAlert.swal("Oops...", MESSAGES.ERROR.RAMOREQUIRED, "error");
            return;
          }
        }
        if (!order.form.subramo) {
          if (!order.form.subramo.url) {
            l_ot.stop();
            SweetAlert.swal("Oops...", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
            return;
          }
        }
        if (order.form.ramo) {
          if (order.form.ramo.ramo_code == 1) {
            if (order.form.subramo.subramo_code != 30) {
              if (!order.subforms.life.aseguradosList[0].policy_type) {
                l_ot.stop();
                SweetAlert.swal("Error", "Selecciona un tipo.", "error");
                return;
              }
            }
          }
          if (order.form.ramo.ramo_code == 2) {
            if (!order.subforms.disease.policy_type) {
              l_ot.stop();
              SweetAlert.swal("Error", "Selecciona un tipo.", "error");
              return;
            }
          }
          if (order.form.ramo.ramo_code == 3) {
            if (order.form.subramo.subramo_code == 9) {
              if (!order.subforms.auto.policy_type) {
                l_ot.stop();
                SweetAlert.swal("Error", MESSAGES.ERROR.ERRORTYPEAUTO, "error");
                return;
              }
            } else {
              if (!order.subforms.damage.damage_type) {
                l_ot.stop();
                SweetAlert.swal("Error", "Selecciona un tipo.", "error");
                return;
              }
            }
          }
        }
        if (!order.form.clave) {
          if (!order.form.clave.url) {
            l_ot.stop();
            SweetAlert.swal("Oops...", MESSAGES.ERROR.CLAVE, "error");
            return;
          }
        }
        if (!order.form.contratante) {
          if (!order.form.contratante.url) {
            l_ot.stop();
            SweetAlert.swal("Oops...", MESSAGES.ERROR.CONTRACTORERROR, "error");
            return;
          }
        }
        if (!order.form.address) {
          if (!order.form.address.url) {
            l_ot.stop();
            SweetAlert.swal("Oops...", MESSAGES.ERROR.ADDRESS, "error");
            return;
          }
        }
        if (!order.form.aseguradora) {
          if (!order.form.aseguradora.url) {
            l_ot.stop();
            SweetAlert.swal(
              "Oops...",
              MESSAGES.ERROR.PROVIDERREQUIRED,
              "error"
            );
            return;
          }
        }

        if (!canBeOT()) {
          return;
        }

        if (!firstTime) {
          var primaNeta;
          var derecho;
          var rpf;
          var total = 0.0;
          var subtotal = 0.0;
          order2.receipts.forEach(function (elem) {
            primaNeta += parseFloat(elem.prima);
            derecho += parseFloat(elem.derecho);
            rpf += parseFloat(elem.rpf);
            total += parseFloat(elem.total);
            subtotal += parseFloat(elem.subTotal);
          });

          var pneta = parseFloat(order.poliza.primaNeta);
          var vrpf = parseFloat(order.poliza.rpf);
          var vderecho = parseFloat(order.poliza.derecho);
          var vsubtotal = parseFloat(order.poliza.subTotal);
          var vtotal = parseFloat(order.poliza.primaTotal);
          if (vtotal.toFixed(2) != total.toFixed(2)) {
            l_ot.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.TOTALDOESNTMATCH, "error");
            order.options.checkDate("initial");
            return;
          }
        }

        // else{}
        var observacion = order.form.observations
          ? order.form.observations
          : "";
        var form = order.form;

        form = getFormData(form);

        form.observations = observacion;
        form.f_currency = order.f_currency;
        form.conducto_de_pago = order.conducto_de_pago;
        // form.sucursal = order.form.sucursal ? order.form.sucursal : '';

        // form status = new Date()> form.endingDate ? 13 : 14;
        form.status = 1;
        if (form.status != 1) {
          if (form.receipts.length) {
            form.receipts.forEach(function (item) {
              var init = new Date(mesDiaAnio(item.startDate)).setHours(
                12,
                0,
                0,
                0
              );
              var end = new Date(mesDiaAnio(item.endingDate)).setHours(
                11,
                59,
                59,
                0
              );
              // var vencimiento = new Date(mesDiaAnio(item.vencimiento)).setHours(11,59,59,0);

              item.startDate = new Date(init);
              item.endingDate = new Date(end);
              // item.vencimiento = new Date(vencimiento);
              if (receipt) {
                if (receipt.vencimiento) {
                  var vencimiento = new Date(
                    toDate(receipt.vencimiento)
                  ).setHours(11.59, 59, 0);
                  receipt.vencimiento = new Date(vencimiento);
                }
              }
            });
          }
        }

        form.p_neta = order.poliza.primaNeta;
        form.descuento = order.poliza.descuento;
        form.p_total = order.poliza.primaTotal;
        form.derecho = order.poliza.derecho;
        form.rpf = order.poliza.rpf;
        form.iva = order.poliza.iva;

        if (order.form.ceder_comision) {
          // form.comision_percent = order.form.comision_percent;
          form.udi = order.form.udi;
          if (order.form.comision_percent) {
            form.comision_percent = order.form.comision_percent;
          } else {
            form.comision_percent = order.form.clave.comission;
          }
        } else {
          if (order.form.comision_percent) {
            form.comision_percent = order.form.comision_percent;
          } else {
            form.comision_percent = order.form.clave.comission;
          }
          form.udi = order.form.clave.udi;
        }
        if (order.form.comision_percent) {
          var percent_ = parseFloat(order.form.comision_percent) / 100;
          order.form.comision = (order.form.p_neta * percent_).toFixed(2);
        } else {
          var percent_ = parseFloat(order.form.comision) / 100;
          order.form.comission = (order.form.p_neta * percent_).toFixed(2);
        }

        if (order.f_currency) {
          form.f_currency = order.f_currency.f_currency_selected;
        }

        if (order.conducto_de_pago) {
          form.conducto_de_pago =
            order.conducto_de_pago.conducto_de_pago_selected;
        }
        try {
          form.vendor = order.form.vendor.url;
        } catch (e) {
          form.vendor = "";
        }

        try {
          form.responsable = order.form.responsable.url;
        } catch (e) {
          form.responsable = "";
        }
        try {
          form.collection_executive = order.form.collection_executive.url;
        } catch (e) {
          form.collection_executive = "";
        }

        try {
          form.hospital_level = order.form.hospital_level;
        } catch (e) {
          form.hospital_level = "";
        }
        try {
          form.tabulator = order.form.tabulator;
        } catch (e) {
          form.tabulator = "";
        }
        try {
          form.sucursal = order.form.sucursal.url;
        } catch (e) {
          form.sucursal = "";
        }

        form.state_circulation = order.form.state_circulation
          ? order.form.state_circulation.state
          : "";
        form.business_line = order.form.business_line
          ? order.form.business_line
          : 0;
        form.identifier = order.form.identifier;
        form.celula = order.form.celula ? order.form.celula.url : "";
        form.groupinglevel = order.form.subsubgrouping
          ? order.form.subsubgrouping.url
          : order.form.subgrouping
          ? order.form.subgrouping.url
          : order.form.grouping_level
          ? order.form.grouping_level.url
          : "";

        insuranceService.updateFullOT(form).then(function (updateResult) {
          var params = {
            model: 1,
            event: "POST",
            associated_id: updateResult.id,
            identifier: "actualizó la OT",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {
              l_ot.stop();
            });
          //varios referenciadores
          // for(var i=0; i<$scope.referenciadores.length; i++){
          //   $scope.referenciadores[i].policy = updateResult.url;
          //   $scope.referenciadores[i].comision_vendedor = $scope.referenciadores[i].comission_vendedor ? parseFloat($scope.referenciadores[i].comission_vendedor).toFixed(2) : 0
          //   if ($scope.referenciadores[i].url) {
          //     var ref_to_change=$scope.referenciadores[i];
          //     $http.patch($scope.referenciadores[i].url, $scope.referenciadores[i]).then(
          //       function success(request){
          //         console.log('zzzzzzzz',ref_to_change,request.data)
          //         try{
          //           console.log('ooooxxooo',ref_to_change,request.data)
          //           if((ref_to_change.ref_name).toLowerCase() != (request.data.ref_name).toLowerCase()){
          //             var params = {
          //               'model': 1,
          //               'event': "PATCH",
          //               'associated_id': updateResult.id,
          //               'identifier': " cambio el referenciador "+ref_to_change.ref_name +' por: '+request.data.ref_name+" a la póliza."
          //             }
          //             dataFactory.post('send-log/', params).then(function success(response) {
          //             });
          //           }
          //         }catch(iyu){console.log('iiiiiiiiii',iyu)}
          //       },
          //       function error(error) {
          //         console.log(error);
          //       })
          //     .catch(function(e){
          //       console.log(e);
          //     });
          //   }else{
          //     $scope.ref_policy = $scope.referenciadores[i];
          //     if($scope.ref_policy){
          //       if ($scope.referenciadores[i].referenciador) {
          //         var ref = {}
          //         ref.referenciador = $scope.referenciadores[i].referenciador
          //         ref.comision_vendedor = $scope.referenciadores[i].comission_vendedor ? parseFloat($scope.referenciadores[i].comission_vendedor).toFixed(2) : 0
          //         ref.policy = updateResult.url
          //         dataFactory.post('referenciadores-policy/',ref)
          //         .then(
          //           function success(request){
          //             $http.get(ref.referenciador).then(function success(response_ref_plicy) {
          //               if(response_ref_plicy){
          //                 $scope.inforef = response_ref_plicy.data
          //                 var params = {
          //                   'model': 1,
          //                   'event': "PATCH",
          //                   'associated_id': updateResult.id,
          //                   'identifier': " añadio el referenciador "+$scope.inforef.first_name+' '+$scope.inforef.last_name+" a la póliza."
          //                 }
          //                 dataFactory.post('send-log/', params).then(function success(response) {
          //                   console.log('respon***',response)
          //                  });
          //               }
          //             })
          //           },
          //           function error(error) {
          //             console.log(error);
          //           })
          //         .catch(function(e){
          //           console.log(e);
          //         });
          //       }
          //     }
          //   }
          // }
          // 8888888888888
          for (var i = 0; i < $scope.referenciadores.length; i++) {
            // Captura el índice en una IIFE para que no cambie en el callback
            (function (idx) {
              var ref_to_change = $scope.referenciadores[idx]; // mismo índice
              var originalName = (ref_to_change.ref_name || "").toLowerCase(); // snapshot del nombre original
              var url = ref_to_change.url;
              // Actualiza el campo policy que se va a enviar
              $scope.referenciadores[idx].policy = updateResult.url;
              $scope.referenciadores[idx].comision_vendedor = $scope
                .referenciadores[idx].comision_vendedor
                ? parseFloat(
                    $scope.referenciadores[idx].comision_vendedor
                  ).toFixed(2)
                : 0;
              if (url) {
                $http
                  .patch(url, $scope.referenciadores[idx])
                  .then(
                    function success(requestP) {
                      try {
                        // Compara únicamente para el MISMO índice (el que capturamos)
                        var newName = (
                          requestP.data && requestP.data.ref_name
                            ? requestP.data.ref_name
                            : ""
                        ).toLowerCase();
                        if (originalName !== newName) {
                          var params = {
                            model: 1,
                            event: "PATCH",
                            associated_id: updateResult.id,
                            identifier:
                              "cambió el referenciador " +
                              (ref_to_change.ref_name || "") +
                              " por: " +
                              (requestP.data.ref_name || "") +
                              " a la póliza.",
                          };
                          dataFactory
                            .post("send-log/", params)
                            .then(function () {
                              /* opcional: manejo éxito */
                            });
                        }
                      } catch (e) {
                        console.log("Error en comparación/log:", e);
                      }
                    },
                    function error(err) {
                      console.log(err);
                    }
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              } else {
                $scope.ref_policy = $scope.referenciadores[i];
                if ($scope.ref_policy) {
                  if ($scope.referenciadores[i].referenciador) {
                    var ref = {};
                    ref.referenciador = $scope.referenciadores[i].referenciador;
                    ref.comision_vendedor = $scope.referenciadores[i]
                      .comision_vendedor
                      ? parseFloat(
                          $scope.referenciadores[i].comision_vendedor
                        ).toFixed(2)
                      : 0;
                    ref.policy = updateResult.url;
                    dataFactory
                      .post("referenciadores-policy/", ref)
                      .then(
                        function success(request) {
                          $http
                            .get(ref.referenciador)
                            .then(function success(response_ref_plicy) {
                              if (response_ref_plicy) {
                                $scope.inforef = response_ref_plicy.data;
                                var params = {
                                  model: 1,
                                  event: "PATCH",
                                  associated_id: updateResult.id,
                                  identifier:
                                    " añadio el referenciador " +
                                    $scope.inforef.first_name +
                                    " " +
                                    $scope.inforef.last_name +
                                    " a la póliza.",
                                };
                                dataFactory
                                  .post("send-log/", params)
                                  .then(function success(response) {
                                    console.log("?response*", response);
                                  });
                              }
                            });
                        },
                        function error(error) {
                          console.log(error);
                        }
                      )
                      .catch(function (e) {
                        console.log(e);
                      });
                  }
                }
              }
            })(i); // <- fijamos el índice
          }
          // 99999999999999
          // varios referenciadores
          if ($uibModalInstance) {
            //if(updateResult.status >= 200 && updateResult < 300){
            var index = container.indexOf(myInsurance);
            //container[index] = updateResult;

            container[index] = helpers.copyExisting(
              container[index],
              updateResult
            );
            toaster.success("OT Actualizada exitosamente");
            //}else{
            //    toaster.error("Error al actualizar OT");
            //}
            $uibModalInstance.close(200);
          } else {
            if ($scope.countFile > 0) {
              // uploadFiles(data.data.id);
              $scope.param = "ot";
              uploadFiles(myInsurance.id);
            } else {
              // toaster.success("OT actualizada");
              SweetAlert.swal("¡Listo!", MESSAGES.OK.UPGRADEOT, "success");
              $state.go("polizas.info", { polizaId: myInsurance.id });
            }
          }
        });
      },
      saveInsurance: function (folio) {
        // guardar como poliza
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();

        var since = toDate(order.form.startDate).getTime();
        var until = toDate(order.form.endingDate).getTime();

        var sinceReceipt = toDate(order2.receipts[0].fecha_inicio).getTime();
        var untilReceipt = toDate(
          order2.receipts[order2.receipts.length - 1].fecha_fin
        ).getTime();

        $scope.contractorToSave = {};

        if (order.form.contratante.email) {
          $scope.contractorToSave.email = order.form.contratante.email;
        } else {
          $scope.contractorToSave.email = "";
        }
        if (order.form.contratante.phone_number) {
          $scope.contractorToSave.phone_number =
            order.form.contratante.phone_number;
        } else {
          $scope.contractorToSave.phone_number = "";
        }

        // if($scope.contractorToSave.email || $scope.contractorToSave.phonenumber){
        // $http.patch(order.form.contratante.value.url, $scope.contractorToSave);

        $http
          .patch(order.form.contratante.value.url, $scope.contractorToSave)
          .then(function (data) {
            if (data.status == 200 || data.status == 201) {
              // toaster.info('Contratante Actualizado')
            }
          });
        // }

        order.form.is_renewable = order.renewal.is_renewable;

        // order.form.contratante = order.form.contratante.value;
        if (order.form.contratante.value) {
          order.form.contratante = order.form.contratante.value;
        } else if (order.form.contratante.id) {
        }

        if (!usr.permiso.editar) {
          l.stop();
          SweetAlert.swal(
            "Oops...",
            "No tienes permiso para editar registros",
            "error"
          );
          return;
        }

        if (!order.form.subramo) {
          if (!order.form.subramo.url) {
            l.stop();
            SweetAlert.swal("Oops...", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
            return;
          }
        }
        if (!(order.form && order.form.ramo)) {
          $scope.enproceso = false;
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
          order.form.ramo.$setTouched();
          return;
        }
        if (!(order.form && order.form.subramo)) {
          $scope.enproceso = false;
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
          order.form.subramo.$setTouched();
          return;
        }
        // se comento al crear recibos en 0 entra a return y no guarda 08/09/2025
        // if (!canBePoliza()) {
        //   console.log('ccccccccccccccccccccccccccccccccccccccccc')
        //   return;
        // }
        if (!firstTime) {
          var primaNeta;
          var rpf;
          var derecho;
          var total = 0.0;
          var subtotal = 0.0;

          order2.receipts.forEach(function (elem) {
            primaNeta += parseFloat(elem.prima);
            derecho += parseFloat(elem.derecho);
            rpf += parseFloat(elem.rpf);
            total += parseFloat(elem.total);
            subtotal += parseFloat(elem.subTotal);
            elem.startDate = toDate(elem.startDate);
            elem.endingDate = toDate(elem.endingDate);
          });

          var pneta = parseFloat(order.poliza.primaNeta);
          var vrpf = parseFloat(order.poliza.rpf);
          var vderecho = parseFloat(order.poliza.derecho);
          var vsubtotal = parseFloat(order.poliza.subTotal);
          var vtotal = parseFloat(order.poliza.primaTotal);

          // validación para la prima total
          // if (vtotal.toFixed(2) != total.toFixed(2)) {
          //   l.stop();
          //   SweetAlert.swal("ERROR", MESSAGES.ERROR.TOTALDOESNTMATCH, "error");
          //   order.options.checkDate('initial');
          //   return;
          // }
        }

        var observacion = order.form.observations;
        var form = order.form;
        var fromDate = order.form.startDate;
        var today = new Date(new Date().toISOString().split("T")[0]);
        form = getFormData(form);

        // return;

        form.observations = observacion ? observacion : "";
        form.f_currency = order.f_currency.f_currency_selected;
        form.conducto_de_pago =
          order.conducto_de_pago.conducto_de_pago_selected;

        form.p_neta = parseFloat(order.poliza.primaNeta).toFixed(2);
        form.p_total = order.poliza.primaTotal;
        form.derecho = parseFloat(order.poliza.derecho).toFixed(2);
        form.rpf = parseFloat(order.poliza.rpf).toFixed(2);
        form.iva = order.poliza.iva;
        form.descuento = order.form.descuento;
        form.comision = order.comision;
        form.comision_percent = order.comision_percent;

        order.form.comision_percent = form.comision_percent;
        if (order.form.ceder_comision) {
          form.comision_percent = order.form.comision_percent;
          form.udi = order.form.udi;
          if (order.form.comision_percent) {
            form.comision_percent = order.form.comision_percent;
          } else {
            form.comision_percent = order.form.clave.comission;
          }
        } else {
          if (order.form.comision_percent) {
            form.comision_percent = order.form.comision_percent;
          } else {
            form.comision_percent = order.form.clave.comission;
          }
          form.udi = order.form.clave.udi;
        }
        if (order.form.comision_percent) {
          // var percent_ = parseFloat(order.form.comision_percent) / 100;
          // order.form.comision = (order.form.p_neta * percent_).toFixed(2);
          // order.form.comision = (order.form.p_neta * percent_).toFixed(2);
        } else {
          if (order.form.comision) {
            var percent_ = parseFloat(order.form.comision.comission) / 100;
            order.form.comission = (order.form.p_neta * percent_).toFixed(2);
            order.form.comision = 0;
          } else {
            var percent_ = 0;
            order.form.comission = 0;
            order.form.comision = 0;
            if (myInsurance.comision) {
              order.form.comision = myInsurance.comision
                ? parseFloat(myInsurance.comision).toFixed(2)
                : 0;
            }
          }
        }

        if (form.receipts.length) {
          if (
            order.form.domiciliado == "true" ||
            order.form.domiciliado == true
          ) {
            var domiciliado = true;
          } else {
            var domiciliado = false;
          }

          form.receipts.forEach(function (item) {
            item.is_cat = domiciliado;
            var init = new Date(mesDiaAnio(item.fecha_inicio)).setHours(
              12,
              0,
              0,
              0
            );
            var end = new Date(mesDiaAnio(item.fecha_fin)).setHours(
              11,
              59,
              59,
              0
            );

            // item.startDate = new Date(init);
            // item.endingDate = new Date(end);
            item.fecha_inicio = new Date(init);
            item.fecha_fin = new Date(end);

            if (item.vencimiento) {
              var vencimiento = new Date(toDate(item.vencimiento)).setHours(
                11.59,
                59,
                0
              );
              item.vencimiento = new Date(vencimiento);
            }

            if ($scope.edited_pay_frequency) {
              item.poliza = order.insuranceObject.url;
            }
          });
        }

        uploadFiles(myInsurance.id);
        if ($scope.change_domiciliado) {
          form.receipts.forEach(function (item) {
            if (item.url) {
              $http
                .patch(item.url, { is_cat: item.is_cat })
                .then(function (res_rec) {});
            }
          });
        }
        if (order.recibos_poliza && $scope.edited_pay_frequency == false) {
          $scope.recibos_todos.forEach(function (item, index) {
            if (item) {
              if (item.recibo_numero) {
                try {
                  if (order.recibos_poliza[index].recibo_numero != undefined) {
                    if (
                      item.recibo_numero ==
                      order.recibos_poliza[index].recibo_numero
                    ) {
                      var object = {
                        prima_neta: order.recibos_poliza[index].prima_neta,
                        rpf: order.recibos_poliza[index].rpf,
                        derecho: order.recibos_poliza[index].derecho,
                        sub_total: order.recibos_poliza[index].sub_total,
                        iva: order.recibos_poliza[index].iva,
                        prima_total: order.recibos_poliza[index].prima_total,
                        comision: order.recibos_poliza[index].comision,
                        fecha_inicio: toDate(
                          order.recibos_poliza[index].fecha_inicio
                        ),
                        fecha_fin: toDate(
                          order.recibos_poliza[index].fecha_fin
                        ),
                        vencimiento: toDate(
                          order.recibos_poliza[index].vencimiento
                        ),
                        conducto_de_pago:
                          order.conducto_de_pago.conducto_de_pago_selected,
                        status: 4,
                      };

                      $http.patch(item.url, object).then(function (req) {});
                    }
                  }
                } catch (errc) {
                  console.log("0d", errc);
                }
              }
            }
          });
        }

        // al cambiar la FREC o no 14/06/2019
        if ($scope.edited_pay_frequency) {
          form.edited_pay_frequency = true;
          var success_receipts = 0;
          var error_receipts = 0;
          var all_receipts = 0;
          $scope.conteoEliminados = 0;
          order.insuranceObject.recibos_poliza.forEach(function (item) {
            if (item.receipt_type == 1) {
              $http.delete(item.url).then(function (req) {
                $scope.conteoEliminados = $scope.conteoEliminados + 1;
              });
            }
          });
          form.receipts.forEach(function (new_receipt, receipt_index) {
            if (!new_receipt.url) {
            }

            dataFactory.post("recibos/", new_receipt).then(function (req) {
              order.insuranceObject.recibos_poliza.push(req.data);
              if (req.status == 200 || req.status == 201) {
                success_receipts += 1;
              } else {
                error_receipts += 1;
              }
              all_receipts = success_receipts + error_receipts;
              if (all_receipts == form.receipts + 1) {
                if (success_receipts == form.receipts.length) {
                } else {
                  SweetAlert.swal(
                    "Error",
                    MESSAGES.ERROR.RECEIPTSERROR,
                    "error"
                  );
                }
              }
            });
          });
        }
        // } else {

        //   /** SI NO SE CAMBIA LA FORMA DE PAGO **/

        //   var old_receipts = order.form.old_receipts;

        //   var delete_receipts = old_receipts;
        //   var patch_receipts  = [];
        //   var save_receipts   = [];

        //   /* SE HACE UN RECORRIDO DE LOS RECIBOS QUE SE MUESTRAN AL CLEINTE
        //     - Se separan cuales se actuailzan y cuales se guardan
        //   */
        //   order.receipts.forEach(function(item_new) {
        //     if(item_new.url) {
        //       patch_receipts.push(item_new);
        //     } else {
        //       save_receipts.push(item_new);
        //     }

        //   });

        //    SIS SE TIENEN RECIBOS POR ACUALIZAR

        //   if(patch_receipts.length) {

        //     patch_receipts.forEach(function(item){
        //       delete_receipts.forEach(function(item_o, index_o) {
        //         if(item.url == item_o.url) {
        //            delete_receipts.splice(index_o, 1);
        //         }
        //       });
        //     });

        //   }

        //   // delete_receipts.forEach(function(item) {

        //   //   if(item.receipt_type == 1) {
        //   //     $http.delete(item.url)
        //   //     .then(function(req) {
        //   //     });
        //   //   }

        //   // });

        //   // patch_receipts.forEach(function(item) {
        //   //    $http.patch(item.url)
        //   //     .then(function(req) {
        //   //     });
        //   // });

        //   // save_receipts.forEach(function(item) {

        //   //   dataFactory.post('recibos/', item)
        //   //   .then(function success(req) {

        //   //     order.insuranceObject.recibos_poliza.push(req.data);
        //   //     all_receipts = success_receipts + error_receipts;

        //   //     if(all_receipts == form.receipts+1) {

        //   //         if(success_receipts == form.receipts.length) {

        //   //         } else {
        //   //           SweetAlert.swal("Error", MESSAGES.ERROR.RECEIPTSERROR, "error")
        //   //         }
        //   //     }

        //   //   }, function error(error) {
        //   //   });
        //   // });

        //   form.receipts_changes = {
        //     delete_receipts : delete_receipts,
        //     patch_receipts  : patch_receipts,
        //     save_receipts   : save_receipts
        //   }

        // }
        // al cambiar la FREC o no 14/06/2019
        // else { // código agregado el viernes 25 enero 2019

        //   var original_rec = order.insuranceObject.recibos_poliza;
        //   var new_array = [];

        //   if(form.receipts.length) {
        //    form.receipts.forEach(function(new_receipt, receipt_index) {

        //     if(!new_receipt.url) {
        //       new_array.push(new_receipt);
        //     }

        //   });

        //   }

        //   if(original_rec.length == new_array.length) {
        //     // eliminar recibos y agregar los nuevos
        //     original_rec.forEach(function(item_) {

        //       if(item_.receipt_type == 1) {
        //         $http.delete(item_.url)
        //         .then(function(req) {
        //         });
        //       }

        //     });

        //     new_array.forEach(function(item) {

        //        dataFactory.post('recibos/', item)
        //       .then(function success(req) {
        //         order.insuranceObject.recibos_poliza.push(req.data);
        //         if(req.status == 200 || req.status == 201) {
        //           success_receipts += 1;
        //         } else {
        //           error_receipts += 1;
        //         }

        //         all_receipts = success_receipts + error_receipts;

        //         if(all_receipts == form.receipts+1) {

        //             if(success_receipts == form.receipts.length) {

        //             } else {
        //               SweetAlert.swal("Error", MESSAGES.ERROR.RECEIPTSERROR, "error")
        //             }
        //         }

        //       }, function error(error) {
        //         console.log('___________-', error);
        //       });
        //     });

        //   } else {
        //     // agregar todos los recibos de new_array

        //     new_array.forEach(function(item) {

        //        dataFactory.post('recibos/', item)
        //       .then(function success(req) {
        //         order.insuranceObject.recibos_poliza.push(req.data);
        //         if(req.status == 200 || req.status == 201) {
        //           success_receipts += 1;
        //         } else {
        //           error_receipts += 1;
        //         }

        //         all_receipts = success_receipts + error_receipts;

        //         if(all_receipts == form.receipts+1) {

        //             if(success_receipts == form.receipts.length) {

        //             } else {
        //               SweetAlert.swal("Error", MESSAGES.ERROR.RECEIPTSERROR, "error")
        //             }
        //         }

        //       }, function error(error) {
        //         console.log('___________-', error);
        //       });

        //     });

        //   }

        // }

        // ---------------------------  Código agregado jueves 31 enero 2019  ---------------------------

        // var old_receipts = order.insuranceObject.recibos_poliza;

        // var delete_receipts = old_receipts;
        // var patch_receipts  = [];
        // var save_receipts   = [];

        // order.receipts.forEach(function(item_new) {
        //   if(item_new.url) {

        //     patch_receipts.push(item_new);

        //   } else {
        //     save_receipts.push(item_new);
        //   }

        // });

        // if(patch_receipts.length) {

        //   patch_receipts.forEach(function(item){
        //     delete_receipts.forEach(function(item_o, index_o) {
        //       if(item.url == item_o.url) {
        //          delete_receipts.splice(index_o, 1);
        //       }
        //     });
        //   });

        // }

        // delete_receipts.forEach(function(item) {

        //   if(item.receipt_type == 1) {
        //     $http.delete(item.url)
        //     .then(function(req) {
        //     });
        //   }

        // });

        // patch_receipts.forEach(function(item) {
        //    $http.patch(item.url)
        //     .then(function(req) {
        //     });
        // });

        // save_receipts.forEach(function(item) {

        //   dataFactory.post('recibos/', item)
        //   .then(function success(req) {

        //     order.insuranceObject.recibos_poliza.push(req.data);
        //     all_receipts = success_receipts + error_receipts;

        //     if(all_receipts == form.receipts+1) {

        //         if(success_receipts == form.receipts.length) {

        //         } else {
        //           SweetAlert.swal("Error", MESSAGES.ERROR.RECEIPTSERROR, "error")
        //         }
        //     }

        //   }, function error(error) {
        //     console.log('___________-', error);
        //   });
        // });
        // return;

        if (order.subforms.auto.policy_type) {
          form.policy_type = order.subforms.auto.policy_type;
          form.procedencia = order.subforms.auto.procedencia;
          form.charge_type = order.subforms.auto.charge_type;
        }

        if (order.f_currency) {
          form.f_currency = order.f_currency.f_currency_selected;
        }

        if (order.conducto_de_pago) {
          form.conducto_de_pago =
            order.conducto_de_pago.conducto_de_pago_selected;
        }

        if (order.form.start_of_validity) {
          var startDate = new Date(order.form.start_of_validity).setHours(
            12,
            0,
            0,
            0
          );
          var endingDate = new Date(order.form.end_of_validity).setHours(
            11,
            59,
            59,
            0
          );
          order.form.startDate = new Date(startDate);
          order.form.endingDate = new Date(endingDate);
        } else {
          var startDate = new Date(mesDiaAnio(order.form.startDate)).setHours(
            12,
            0,
            0,
            0
          );
          var endingDate = new Date(mesDiaAnio(order.form.endingDate)).setHours(
            11,
            59,
            59,
            0
          );
          order.form.startDate = new Date(startDate);
          order.form.endingDate = new Date(endingDate);
        }

        if (
          myInsurance.status != 15 &&
          myInsurance.status != 11 &&
          myInsurance.status != 12
        ) {
          var auxDate = new Date(order.form.startDate.getTime() - 86400000);
          if (auxDate < new Date() && new Date() < form.endingDate) {
            form.status = 14;
          } else if (auxDate > new Date()) {
            form.status = 10;
          } else if (new Date() > form.endingDate) {
            form.status = 13;
          }
        }

        try {
          form.vendor = order.form.vendor.url;
        } catch (e) {
          form.vendor = "";
        }

        try {
          form.responsable = order.form.responsable.url;
        } catch (e) {
          form.responsable = "";
        }
        try {
          form.sucursal = order.form.sucursal.url;
        } catch (e) {
          form.sucursal = "";
        }
        try {
          form.collection_executive = order.form.collection_executive.url;
        } catch (e) {
          form.collection_executive = "";
        }
        try {
          form.hospital_level = order.form.hospital_level;
        } catch (e) {
          form.hospital_level = "";
        }
        try {
          form.tabulator = order.form.tabulator;
        } catch (e) {
          form.tabulator = "";
        }

        // return;
        if (!order.form.folio) {
          form.folio = folio;
        }

        // form.sucursal = order.form.sucursal ? order.form.sucursal : '';
        form.comision_derecho_percent = order.poliza.comision_derecho_percent
          ? order.poliza.comision_derecho_percent
          : $scope.insuranceOK.comision_derecho_percent;
        form.comision_rpf_percent = order.poliza.comision_rpf_percent
          ? order.poliza.comision_rpf_percent
          : $scope.insuranceOK.comision_rpf_percent;

        form.state_circulation = order.form.state_circulation
          ? order.form.state_circulation.state
          : "";
        form.identifier = order.form.identifier;
        form.business_line = order.form.business_line
          ? order.form.business_line
          : 0;
        form.celula = order.form.celula ? order.form.celula.url : "";
        form.groupinglevel = order.form.subsubgrouping
          ? order.form.subsubgrouping.url
          : order.form.subgrouping
          ? order.form.subgrouping.url
          : order.form.grouping_level
          ? order.form.grouping_level.url
          : "";
        if (
          order &&
          order.prima_comision &&
          parseFloat(form.comision_percent) != parseFloat(order.prima_comision)
        ) {
          form.comision_percent = order.prima_comision
            ? order.prima_comision
            : order.comision_percent
            ? order.comision_percent
            : 0;
        }
        insuranceService
          .updateFullInsurance(form)
          .then(function (updateResponse) {
            updateResponse.recibos_poliza.forEach(function (recibo) {
              $http.patch(recibo, { conducto_de_pago: form.conducto_de_pago });
            });
            if ($uibModalInstance) {
              var index = container.indexOf(myInsurance);
              container.splice(index, 1);
              toaster.success("Póliza actualizada");
              $uibModalInstance.close(20000);
            } else {
              if ($scope.countFile > 0) {
                $scope.param = "poliza";
                uploadFiles(myInsurance.id);

                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: updateResponse.id,
                  identifier: "actualizó la póliza y adjuntó archivos.",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
              } else {
                $http.get(order.form.contratante.url).then(function (response) {
                  if (response.data.email) {
                  }
                });

                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.UPGRADEPOLICY,
                  "success"
                );
                $state.go("polizas.info", { polizaId: updateResponse.id });
              }
              // varios referenciadores
              for (var i = 0; i < $scope.referenciadores.length; i++) {
                // Captura el índice en una IIFE para que no cambie en el callback
                (function (idx) {
                  var ref_to_change = $scope.referenciadores[idx]; // mismo índice
                  var originalName = (
                    ref_to_change.ref_name || ""
                  ).toLowerCase(); // snapshot del nombre original
                  var url = ref_to_change.url;

                  // Actualiza el campo policy que se va a enviar
                  $scope.referenciadores[idx].policy = updateResponse.url;
                  $scope.referenciadores[idx].comision_vendedor = $scope
                    .referenciadores[idx].comision_vendedor
                    ? parseFloat(
                        $scope.referenciadores[idx].comision_vendedor
                      ).toFixed(2)
                    : 0;

                  if (url) {
                    $http
                      .patch(url, $scope.referenciadores[idx])
                      .then(
                        function success(requestP) {
                          try {
                            // Compara únicamente para el MISMO índice (el que capturamos)
                            var newName = (
                              requestP.data && requestP.data.ref_name
                                ? requestP.data.ref_name
                                : ""
                            ).toLowerCase();
                            if (originalName !== newName) {
                              var params = {
                                model: 1,
                                event: "PATCH",
                                associated_id: updateResponse.id,
                                identifier:
                                  "cambió el referenciador " +
                                  (ref_to_change.ref_name || "") +
                                  " por: " +
                                  (requestP.data.ref_name || "") +
                                  " a la póliza.",
                              };
                              dataFactory
                                .post("send-log/", params)
                                .then(function () {
                                  /* opcional: manejo éxito */
                                });
                            }
                          } catch (e) {
                            console.log("Error en comparación/log:", e);
                          }
                        },
                        function error(err) {
                          console.log(err);
                        }
                      )
                      .catch(function (e) {
                        console.log(e);
                      });
                  } else {
                    $scope.ref_policy = $scope.referenciadores[i];
                    if ($scope.ref_policy) {
                      if ($scope.referenciadores[i].referenciador) {
                        var ref = {};
                        ref.referenciador =
                          $scope.referenciadores[i].referenciador;
                        ref.comision_vendedor = $scope.referenciadores[i]
                          .comision_vendedor
                          ? parseFloat(
                              $scope.referenciadores[i].comision_vendedor
                            ).toFixed(2)
                          : 0;
                        ref.policy = updateResponse.url;
                        dataFactory
                          .post("referenciadores-policy/", ref)
                          .then(
                            function success(request) {
                              $http
                                .get(ref.referenciador)
                                .then(function success(response_ref_plicy) {
                                  if (response_ref_plicy) {
                                    $scope.inforef = response_ref_plicy.data;
                                    var params = {
                                      model: 1,
                                      event: "PATCH",
                                      associated_id: updateResponse.id,
                                      identifier:
                                        " añadio el referenciador " +
                                        $scope.inforef.first_name +
                                        " " +
                                        $scope.inforef.last_name +
                                        " a la póliza.",
                                    };
                                    dataFactory
                                      .post("send-log/", params)
                                      .then(function success(response) {
                                        console.log("?response*", response);
                                      });
                                  }
                                });
                            },
                            function error(error) {
                              console.log(error);
                            }
                          )
                          .catch(function (e) {
                            console.log(e);
                          });
                      }
                    }
                  }
                  // varios referenciadores
                  insuranceService.updateOldPolicy(updateResponse);
                })(i); // <- fijamos el índice
              }

              // for(var i=0; i<$scope.referenciadores.length; i++){
              //   $scope.referenciadores[i].policy = updateResponse.url;
              //   $scope.referenciadores[i].comision_vendedor = $scope.referenciadores[i].comission_vendedor ? parseFloat($scope.referenciadores[i].comission_vendedor).toFixed(2) : 0
              //   if ($scope.referenciadores[i].url) {
              //     var ref_to_change=$scope.referenciadores[i];
              //     $http.patch($scope.referenciadores[i].url, $scope.referenciadores[i]).then(
              //       function success(requestP){
              //       try{
              //         console.log('a cambiar*',ref_to_change.ref_name)
              //         console.log('nuevo*',requestP.data.ref_name)
              //         if((ref_to_change.ref_name).toLowerCase() != (requestP.data.ref_name).toLowerCase()){
              //           var params = {
              //             'model': 1,
              //             'event': "PATCH",
              //             'associated_id': updateResponse.id,
              //             'identifier': " cambio el referenciador "+ref_to_change.ref_name +' por: '+requestP.data.ref_name+" a la póliza."
              //           }
              //           dataFactory.post('send-log/', params).then(function success(response) {
              //           });
              //         }
              //       }catch(iyu){console.log('euuuuuuuuuu',iyu)}
              //       },
              //       function error(error) {
              //         console.log(error);
              //       })
              //     .catch(function(e){
              //       console.log(e);
              //     });
              //   }else{
              //     $scope.ref_policy = $scope.referenciadores[i];
              //     if($scope.ref_policy){
              //       if ($scope.referenciadores[i].referenciador) {
              //         var ref = {}
              //         ref.referenciador = $scope.referenciadores[i].referenciador
              //         ref.comision_vendedor = $scope.referenciadores[i].comision_vendedor ? parseFloat($scope.referenciadores[i].comision_vendedor ).toFixed(2): 0
              //         ref.policy = updateResponse.url
              //         dataFactory.post('referenciadores-policy/',ref)
              //         .then(
              //           function success(request){
              //             $http.get(ref.referenciador).then(function success(response_ref_plicy) {
              //               if(response_ref_plicy){
              //                 $scope.inforef = response_ref_plicy.data
              //                 var params = {
              //                   'model': 1,
              //                   'event': "PATCH",
              //                   'associated_id': updateResponse.id,
              //                   'identifier': " añadio el referenciador "+$scope.inforef.first_name+' '+$scope.inforef.last_name+" a la póliza."
              //                 }
              //                 dataFactory.post('send-log/', params).then(function success(response) {
              //                   console.log('?response*',response)
              //                 });
              //               }
              //             })
              //           },
              //           function error(error) {
              //             console.log(error);
              //           })
              //         .catch(function(e){
              //           console.log(e);
              //         });
              //       }
              //     }
              //   }
              // }
              // varios referenciadores
              insuranceService.updateOldPolicy(updateResponse);
            }
          });
      },
      cancel: function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("Cancelado");
        } else {
          $state.go("polizas.info", { polizaId: myInsurance.id });
        }
      },
    };
    function isString(x) {
      return Object.prototype.toString.call(x) === "[object String]";
    }
    $scope.validatePolicy = function (param) {
      if (param == "poliza") {
        var l = Ladda.create(document.querySelector(".ladda-button"));
      } else {
        var l = Ladda.create(document.querySelector(".ladda-button-ot"));
      }
      l.start();
      if (order.acceso_obl_ref) {
        $scope.referenciadores_copy = $scope.referenciadores.filter(function (
          item
        ) {
          return item && item.referenciador && isString(item.referenciador);
        });
        if (order.acceso_obl_ref) {
          if (
            ($scope.referenciadores && $scope.referenciadores.length == 0) ||
            ($scope.referenciadores_copy &&
              $scope.referenciadores_copy.length == 0)
          ) {
            SweetAlert.swal(
              "Error",
              "Seleccione al menos un referenciador.",
              "error"
            );
            l.stop();
            return;
          } else {
            console.log(
              "continuar",
              $scope.referenciadores,
              order.acceso_cno_pol,
              $scope.referenciadores_copy
            );
          }
        }
      }
      var date1 = datesFactory.toDate(order.form.startDate);
      var date2 = datesFactory.toDate(order.form.endingDate);

      var since = toDate(order.form.startDate).getTime();
      var until = toDate(order.form.endingDate).getTime();

      $scope.arrayCoverage = order.defaults.coverages;
      $scope.count_coverage = 0;

      var flag_save_dependent = false;
      var flag_save_asegurado = false;

      if (param == "poliza") {
        if (!order.form.poliza) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
          return;
        }
      }
      if (!order.form.contratante.val) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        return;
      }
      if (!order.form.address) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        return;
      }
      if (
        !order.form.contratante.email &&
        !order.form.contratante.phone_number
      ) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORWITHOUTEMAIL, "error");
        return;
      }
      if (order.form.contratante.email) {
        if (!validateEmail(order.form.contratante.email)) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
          return;
        }

        function validateEmail(email) {
          var re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        }
      }
      if (date1 > date2) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }
      if (!order.form.aseguradora) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        return;
      }
      if (!order.form.clave) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        return;
      } else {
        $scope.clavenoexistente = false;
        if (order.defaults.claves) {
          order.defaults.claves.forEach(function (item) {
            if (order.form.clave.id == item.id) {
              $scope.clavenoexistente = true;
            }
          });
        } else {
          console.log("---sin claves--*");
          l.stop();
        }
        if (!$scope.clavenoexistente) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
          return;
        }
      }
      if (!order.form.ramo) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        return;
      }
      if (!order.form.subramo) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (order.form.ramo.ramo_code == 1) {
        if (order.form.subramo.subramo_code != 30) {
          if (!order.subforms.life.aseguradosList[0].policy_type) {
            l.stop();
            SweetAlert.swal("Error", "Selecciona un tipo.", "error");
            return;
          }
        }
      }
      if (order.form.ramo.ramo_code == 2) {
        if (!order.subforms.disease.policy_type) {
          l.stop();
          SweetAlert.swal("Error", "Selecciona un tipo.", "error");
          return;
        }
      }
      if (order.form.ramo.ramo_code == 3) {
        if (order.form.subramo.subramo_code == 9) {
          if (!order.subforms.auto.policy_type) {
            l.stop();
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORTYPEAUTO, "error");
            return;
          }
        } else {
          if (!order.subforms.damage.damage_type) {
            l.stop();
            SweetAlert.swal("Error", "Selecciona un tipo.", "error");
            return;
          }
          if (
            !order.subforms.damage.insured_item ||
            order.subforms.damage.insured_item == undefined ||
            order.subforms.damage.insured_item == "" ||
            order.subforms.damage.insured_item == ""
          ) {
            l.stop();
            SweetAlert.swal("Error", "Agregue un Bien asegurado.", "error");
            return;
          }
        }
      }
      // if(!order.form.comision){
      //   l.stop();
      //   SweetAlert.swal("Error", MESSAGES.ERROR.COMISSION, "error");
      //   return;
      // }
      if (!order.form.paquete) {
        l.stop();
        SweetAlert.swal("Error", "Elige un paquete", "error");
        return;
      }
      if (!order.form.payment) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORPAYFORM, "error");
        return;
      }
      if (param == "poliza") {
        if (!order.form.paquete) {
          l.stop();
          SweetAlert.swal("Error", "Elige un paquete", "error");
          return;
        }
        if (order.form.subramo.subramo_code == 1) {
          // if(!order.subforms.life.first_name){
          //   l.stop();
          //   SweetAlert.swal("Error", "Agregue el nombre del asegurado", "error");
          //   return;
          // }
          // if(!order.subforms.life.last_name){
          //   l.stop();
          //   SweetAlert.swal("Error", "Agregue el apellido paterno del asegurado", "error");
          //   return;
          // }
          // if(!order.subforms.life.birthdate){
          //   l.stop();
          //   SweetAlert.swal("Error", "Agregue la fecha de nacimiento del asegurado", "error");
          //   return;
          // }
          // if(!order.subforms.life.sex){
          //   l.stop();
          //   SweetAlert.swal("Error", "Elige el sexo del asegurado", "error");
          //   return;
          // }
          // if(!order.subforms.life.smoker){
          //   l.stop();
          //   SweetAlert.swal("Error", "Responde si fuma o no el asegurado", "error");
          //   return;
          // }
          if (order.subforms.life.beneficiariesList) {
            order.subforms.life.beneficiariesList.forEach(function (
              beneficiary,
              index
            ) {
              var idx = index + 1;
              if (beneficiary.person == 1) {
                if (!beneficiary.first_name) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el nombre del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!beneficiary.last_name) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el apellido paterno del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!beneficiary.birthdate) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega la fecha de nacimiento del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!beneficiary.sex) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el sexo del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!beneficiary.percentage) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el porcentaje del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
              } else if (beneficiary.person == 2) {
                if (!beneficiary.j_name) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega la razón social del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
                if (!beneficiary.rfc) {
                  l.stop();
                  flag_save_dependent = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el RFC del beneficiario  #" + idx,
                    "error"
                  );
                  return;
                }
              }
            });
          }
          // personal_life
          if (order.subforms.life.aseguradosList) {
            order.subforms.life.aseguradosList.forEach(function (asegs, index) {
              var idx = index + 1;
              // if(asegs.person == 1){
              if (!asegs.first_name) {
                l.stop();
                flag_save_asegurado = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega el nombre del asegurado  #" + idx,
                  "error"
                );
                return;
              }
              if (!asegs.last_name) {
                l.stop();
                flag_save_asegurado = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega el apellido paterno del asegurado  #" + idx,
                  "error"
                );
                return;
              }
              if (!asegs.birthdate) {
                l.stop();
                flag_save_asegurado = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega la fecha de nacimiento del asegurado  #" + idx,
                  "error"
                );
                return;
              }
              if (!asegs.sex) {
                l.stop();
                flag_save_asegurado = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega el sexo del asegurado  #" + idx,
                  "error"
                );
                return;
              }
              // }
            });
          }
          // personal_life val
        }
        if (order.form.subramo.subramo_code == 3) {
          if (!order.subforms.disease.first_name) {
            l.stop();
            SweetAlert.swal("Error", "Agregue el nombre del titular", "error");
            return;
          }
          if (!order.subforms.disease.last_name) {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Agregue el apellido paterno del titular",
              "error"
            );
            return;
          }
          if (!order.subforms.disease.birthdate) {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Agregue la fecha de nacimiento del titular",
              "error"
            );
            return;
          }
          if (!order.subforms.disease.sex) {
            l.stop();
            SweetAlert.swal("Error", "Elige el sexo del titular", "error");
            return;
          }
          if (order.subforms.disease.relationshipList) {
            order.subforms.disease.relationshipList.forEach(function (
              dependent,
              index
            ) {
              var idx = index + 1;
              if (!dependent.first_name) {
                l.stop();
                flag_save_dependent = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega el nombre del dependiente  #" + idx,
                  "error"
                );
                return;
              }
              if (!dependent.last_name) {
                l.stop();
                flag_save_dependent = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega el apellido paterno del dependiente  #" + idx,
                  "error"
                );
                return;
              }
              if (!dependent.relationship) {
                l.stop();
                flag_save_dependent = true;
                SweetAlert.swal(
                  "Error",
                  "Elige el parentesco del dependiente  #" + idx,
                  "error"
                );
                return;
              }
              if (!dependent.birthdate) {
                l.stop();
                flag_save_dependent = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega la fecha de nacimiento del dependiente  #" + idx,
                  "error"
                );
                return;
              }
              if (!dependent.sex) {
                l.stop();
                flag_save_dependent = true;
                SweetAlert.swal(
                  "Error",
                  "Agrega el sexo del dependiente  #" + idx,
                  "error"
                );
                return;
              }
            });
          }
        }
        if (order.form.subramo.subramo_code == 7) {
          if (!order.subforms.damage.insured_item) {
            l.stop();
            SweetAlert.swal("Error", "Agrega el bien asegurado", "error");
            return;
          }
        }
        if (order.form.subramo.subramo_code == 9) {
          if (!order.subforms.auto.brand) {
            l.stop();
            SweetAlert.swal("Error", "Agrega la marca del automóvil", "error");
            return;
          }
          // if(!order.subforms.auto.model){
          //   l.stop();
          //   SweetAlert.swal("Error", "Agrega el modelo del automóvil", "error");
          //   return;
          // }
          if (!order.subforms.auto.year) {
            l.stop();
            SweetAlert.swal("Error", "Elige el año del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.version) {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Agrega la versión del automóvil",
              "error"
            );
            return;
          }
          if (!order.subforms.auto.serial) {
            l.stop();
            SweetAlert.swal("Error", "Agrega la serie del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.usage) {
            l.stop();
            SweetAlert.swal("Error", "Elige el uso del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.service) {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Agrega el servicio del automóvil",
              "error"
            );
            return;
          }
        }
        if ($scope.edited_pay_frequency) {
          if (!order.recibos_poliza || order.recibos_poliza.length == 0) {
            l.stop();
            SweetAlert.swal("Error", MESSAGES.ERROR.RECEIPTSREQUIRED, "error");
            return;
          }
        }
        // if($scope.arrayCoverage){
        //   for(var i = 0; i < $scope.arrayCoverage.length; i++){
        //     if($scope.arrayCoverage[i].deductibleInPolicy || $scope.arrayCoverage[i].sumInPolicy){
        //       $scope.count_coverage++;
        //     }
        //     if(i+1 == $scope.arrayCoverage.length){
        //       if($scope.count_coverage == 0){
        //         l.stop();
        //         SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
        //         return;
        //       }
        //     }
        //   };
        // }
        // if($scope.arrayCoverage.length == 0){
        //   l.stop();
        //   SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
        //   return;

        if (
          order.receipts &&
          order.receipts.length == 0 &&
          order.recibos_poliza &&
          order.recibos_poliza.length == 0
        ) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        } else {
          var flag_save = false;
          if (order.receipts.length == 0) {
            if (order.recibos_poliza.length > 0) {
              order.receipts = order.recibos_poliza;
            }
          }
          order.receipts.forEach(function (receipt) {
            if (!receipt.fecha_inicio || !receipt.fecha_fin) {
              l.stop();
              flag_save = true;
              SweetAlert.swal("Error", MESSAGES.ERROR.RECEIPTSDATES, "error");
              return;
            }
          });
          if (flag_save == true) {
            l.stop();
            return;
          }
          var sinceReceipt = toDate(order.receipts[0].fecha_inicio).getTime();
          var untilReceipt = toDate(
            order.receipts[order.receipts.length - 1].fecha_fin
          ).getTime();
          if (order.form) {
            if (order.poliza.aplicarDescuento) {
              order.form.descuento = parseFloat(order.poliza.descuento).toFixed(
                2
              );
            } else {
              order.form.descuento = 0;
            }
          }
        }
        // if(since != sinceReceipt){
        //   l.stop();
        //   SweetAlert.swal("ERROR", MESSAGES.ERROR.DATESOUT, "error");
        //   return;
        // }
        if (order.poliza.fy) {
          l.stop();

          var date_since = new Date(since);
          var fy_year = date_since.getFullYear() + 1;
          var fy_month = date_since.getMonth();
          var fy_day = date_since.getDate();

          var date_one_year = new Date(fy_year, fy_month, fy_day);
          var date_one_year_time = date_one_year.getTime();

          if (untilReceipt != date_one_year_time) {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.DATESOUT_FY, "error");
            return;
          } else {
            if (flag_save_dependent == false) {
              if ($scope.arrayCoverage.length == $scope.count_coverage) {
                l.stop();
                if (!order.form.folio) {
                  if (order.form.contratante.value.type_person == "Moral") {
                    var data = {
                      id_contractor: order.form.contratante.value.id,
                      type_person: 2,
                    };
                    $scope.type_person_selected = 2;
                  } else {
                    var data = {
                      id_contractor: order.form.contratante.value.id,
                      type_person: 1,
                    };
                    $scope.type_person_selected = 1;
                  }

                  dataFactory
                    .post("count-policy-by-contractor/", data)
                    .then(function success(response) {
                      if (response.status == 200) {
                        var num = parseInt(response.data.total_policies) + 1;
                        if ($scope.type_person_selected == 1) {
                          var num_folio =
                            order.form.contratante.value.last_name.charAt(0) +
                            "_" +
                            order.form.contratante.value.first_name.charAt(0) +
                            "_" +
                            num;
                          order.save.saveInsurance(num_folio);
                        } else {
                          var num_folio =
                            order.form.contratante.value.j_name.charAt(0) +
                            "_" +
                            num;
                          order.save.saveInsurance(num_folio);
                        }
                      }
                    });
                } else {
                  order.save.saveInsurance();
                }
              } else {
                SweetAlert.swal(
                  {
                    title: "Coberturas sin datos",
                    text: "Las coberturas sin suma asegurada y sin deducible no se guardarán, ¿Estás seguro de continuar?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Si",
                    cancelButtonText: "No",
                    closeOnConfirm: false,
                  },
                  function (isConfirm) {
                    if (isConfirm) {
                      swal.close();
                      l.stop();
                      if (!order.form.folio) {
                        if (
                          order.form.contratante.value.type_person == "Moral"
                        ) {
                          var data = {
                            id_contractor: order.form.contratante.value.id,
                            type_person: 2,
                          };
                          $scope.type_person_selected = 2;
                        } else {
                          var data = {
                            id_contractor: order.form.contratante.value.id,
                            type_person: 1,
                          };
                          $scope.type_person_selected = 1;
                        }

                        dataFactory
                          .post("count-policy-by-contractor/", data)
                          .then(function success(response) {
                            if (response.status == 200) {
                              var num =
                                parseInt(response.data.total_policies) + 1;
                              var num_folio =
                                order.form.contratante.value.full_name.charAt(
                                  0
                                ) +
                                "_" +
                                num;
                              order.save.saveInsurance(num_folio);
                              // if($scope.type_person_selected == 1){
                              //   var num_folio = order.form.contratante.value.last_name.charAt(0)+'_'+order.form.contratante.value.first_name.charAt(0)+'_'+ num;
                              //   order.save.saveInsurance(num_folio);
                              // }else{
                              //   var num_folio = order.form.contratante.value.j_name.charAt(0)+'_'+ num;
                              //   order.save.saveInsurance(num_folio);
                              // }
                            }
                          });
                      } else {
                        order.save.saveInsurance();
                      }
                    } else {
                      l.stop();
                    }
                  }
                );
              }
            }
          }
        } else {
          // if(until != untilReceipt){
          //   l.stop();

          //   SweetAlert.swal("ERROR", MESSAGES.ERROR.DATESOUT, "error");
          //   return;

          // }
          // else{
          if (flag_save_dependent == false) {
            if ($scope.arrayCoverage.length == $scope.count_coverage) {
              l.stop();
              if (!order.form.folio) {
                if (order.form.contratante.value.type_person == "Moral") {
                  var data = {
                    id_contractor: order.form.contratante.value.id,
                    type_person: 2,
                  };
                  $scope.type_person_selected = 2;
                } else {
                  var data = {
                    id_contractor: order.form.contratante.value.id,
                    type_person: 1,
                  };
                  $scope.type_person_selected = 1;
                }

                dataFactory
                  .post("count-policy-by-contractor/", data)
                  .then(function success(response) {
                    if (response.status == 200) {
                      var num = parseInt(response.data.total_policies) + 1;
                      var num_folio =
                        order.form.contratante.value.full_name.charAt(0) +
                        "_" +
                        num;
                      order.save.saveInsurance(num_folio);
                      // if($scope.type_person_selected == 1){
                      //   var num_folio = order.form.contratante.value.last_name.charAt(0)+'_'+order.form.contratante.value.first_name.charAt(0)+'_'+ num;
                      //   order.save.saveInsurance(num_folio);
                      // }else{
                      //   var num_folio = order.form.contratante.value.j_name.charAt(0)+'_'+ num;
                      //   order.save.saveInsurance(num_folio);
                      // }
                    }
                  });
              } else {
                order.save.saveInsurance();
              }
            } else {
              SweetAlert.swal(
                {
                  title: "Coberturas sin datos",
                  text: "Las coberturas sin suma asegurda y sin deducible no se guardarán, ¿Estás seguro de continuar?",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Si",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                },
                function (isConfirm) {
                  if (isConfirm) {
                    swal.close();
                    l.stop();
                    if (!order.form.folio) {
                      if (order.form.contratante.value.type_person == "Moral") {
                        var data = {
                          id_contractor: order.form.contratante.value.id,
                          type_person: 2,
                        };
                        $scope.type_person_selected = 2;
                      } else {
                        var data = {
                          id_contractor: order.form.contratante.value.id,
                          type_person: 1,
                        };
                        $scope.type_person_selected = 1;
                      }

                      dataFactory
                        .post("count-policy-by-contractor/", data)
                        .then(function success(response) {
                          if (response.status == 200) {
                            var num =
                              parseInt(response.data.total_policies) + 1;
                            var num_folio =
                              order.form.contratante.value.full_name.charAt(0) +
                              "_" +
                              num;
                            order.save.saveInsurance(num_folio);
                            // if($scope.type_person_selected == 1){
                            //   var num_folio = order.form.contratante.value.last_name.charAt(0)+'_'+order.form.contratante.value.first_name.charAt(0)+'_'+ num;
                            //   order.save.saveInsurance(num_folio);
                            // }else{
                            //   var num_folio = order.form.contratante.value.j_name.charAt(0)+'_'+ num;
                            //   order.save.saveInsurance(num_folio);
                            // }
                          }
                        });
                    } else {
                      order.save.saveInsurance();
                    }
                  } else {
                    l.stop();
                  }
                }
              );
            }
          }
          // }
        }
      } else {
        l.stop();
        order.save.saveChangesInOt();
      }
    };

    $scope.checkEmail = function (email) {
      if (!validateEmail(email)) {
        SweetAlert.swal(
          "Error",
          "El formato del correo es invalido",
          "warning"
        );
        return;
      }
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    order.receipts = [];
    order.defaults.showReceipts = false;
    $scope.referenciadores = [
      {
        referenciador: $scope.referenciador,
      },
    ];
    // order.default.showReceipts = order.show.generateReceipts;
    order.amountReceipts = 0;
    order.poliza = {};

    if ($stateParams.message == 1) {
      SweetAlert.swal(
        "Error",
        "Asegúrese de que el nombre del archivo no tenga más de 350 caracteres",
        "error"
      );
    } else if ($stateParams.message == 2) {
      SweetAlert.swal("Error", MESSAGES.ERROR.FILETOOLARGE, "error");
    }

    if (!myInsurance) {
      insuranceService.getInsuranceRead($stateParams).then(function (response) {
        myInsurance = response;
        $scope.myInsurance = myInsurance;
        $scope.poliza_id = angular.copy(response.id);
        order.form.give_comision = parseFloat(myInsurance.give_comision);
        order.poliza.url_policy = $scope.myInsurance.url;
        order.form.url_policy = $scope.myInsurance.url;
        activate();
        order.show.isPolicy = helpers.isPolicy(myInsurance);
      });
    } else {
      activate();
      order.show.isPolicy = helpers.isPolicy(myInsurance);
    }

    $scope.campo_agrupacion = false;
    $scope.campo_celula = false;
    $scope.campo_lineanegocio = false;
    $scope.moduleName = "Célula";
    dataFactory.get("orginfo/").then(function success(response) {
      if (response.data.results.length) {
        $scope.configuracionGlobal = response.data.results[0];
        $scope.campo_agrupacion = $scope.configuracionGlobal.filtros_agrupacion;
        $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
        $scope.campo_lineanegocio =
          $scope.configuracionGlobal.filtros_lineanegocio;
        if ($scope.configuracionGlobal.moduleName) {
          $scope.moduleName = $scope.configuracionGlobal.moduleName;
        }
      }
    });
    function activate() {
      $scope.createPackRen = false;
      var storedStateCirculation =
        order.subforms &&
        order.subforms.auto &&
        order.subforms.auto.state_circulation
          ? order.subforms.auto.state_circulation
          : "";
      if (
        !storedStateCirculation &&
        myInsurance &&
        myInsurance.state_circulation
      ) {
        storedStateCirculation = myInsurance.state_circulation;
      }
      order.form.state_circulation = storedStateCirculation;

      if ($location.path().indexOf("editar")) {
        $scope.noRecalculateReceipts = true;
        $scope.createPackRen = false;
      } else {
        $scope.noRecalculateReceipts = false;
      }

      dataFactory
        .get("sucursales-to-show-unpag/")
        .then(function success(response) {
          $scope.sucursalList = response.data;
        });

      dataFactory.post("celula_contractor_info/").then(function (response) {
        $scope.celulas = response.data;
      });

      dataFactory.get("groupingLevel-resume/").then(function (response) {
        $scope.agrupaciones = response.data;
      });

      insuranceService.getVendors().then(
        function success(data) {
          order.vendors = data.data;
          $scope.referenciador = data.data;
          $scope.referenciador.forEach(function (vendor1) {
            vendor1.first_name = vendor1.first_name.toUpperCase();
            vendor1.last_name = vendor1.last_name.toUpperCase();
            vendor1.name =
              vendor1.first_name.toUpperCase() +
              " " +
              vendor1.last_name.toUpperCase();
          });
          order.vendors.forEach(function (vendor) {
            vendor.name =
              vendor.first_name.toUpperCase() +
              " " +
              vendor.last_name.toUpperCase();
          });
          $scope.referenciador.forEach(function (vendor) {
            vendor.name =
              vendor.first_name.toUpperCase() +
              " " +
              vendor.last_name.toUpperCase();
          });
        },
        function error(error) {
          toaster.ERROR("No pudieron ser cargados los referenciadores");
        }
      );

      $http.get(url.IP + "usuarios/").then(function (user) {
        user.data.results.forEach(function (vn) {
          vn.first_name = vn.first_name.toUpperCase();
          vn.last_name = vn.last_name.toUpperCase();
          vn.name =
            vn.first_name.toUpperCase() + " " + vn.last_name.toUpperCase();
        });
        order.responsables = user.data.results;
        order.ejecutivos = user.data.results;
      });

      $http
        .get(url.IP + "polizas/" + myInsurance.id + "/archivos/")
        .then(function (response) {
          $scope.files = response.data.results;
        });

      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          $scope.statesArray = data.data;
        });

      $scope.save_info_tab = function () {};

      $scope.identifier = function () {};

      $scope.changeType = function () {};

      $scope.frec_disabled = true;
      // if(!usr.permiso.editar){
      //   SweetAlert.swal("Oops...", "Los cambios que se hagan no surtirán efecto pues el usuario no tiene permiso para editar registros", "warning");
      // }

      order.loading = true;
      order.defaults.getContractorsByGroup();
      order.poliza.derecho = parseFloat(order.poliza.derecho);
      order.form.identifier = myInsurance.identifier;
      $scope.addReferenciador = function (type) {
        var addReferenciadores = {
          referenciador: $scope.referenciador ? $scope.referenciador : "",
        };
        $scope.referenciadores.push(addReferenciadores);
      };

      loadingThing("provider");
      var d = new Date();
      var curr_date = d.getDate();
      var curr_month = d.getMonth() + 1; //Months are zero based
      var curr_year = d.getFullYear();
      var date = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(date).then(function (data) {
        order.defaults.providers = data.data;
        aThingIsDone("provider");

        insuranceService.getInsuranceData(myInsurance).then(
          function (insuranceData) {
            $scope.insuranceOK = insuranceData;
            order.form.status = insuranceData.status;
            order.insurnaceData = insuranceData.status;
            if (insuranceData.status == 1 || insuranceData.status == 2) {
              order.show.ot = true;
            } else {
              order.show.ot = false;
            }
            $scope.numRecs = 0;
            $scope.totalRecs = 0;
            // $scope.totalRecs = insuranceData.recibos_poliza.length
            insuranceData.recibos_poliza.forEach(function (i) {
              if (i.receipt_type == 1 && i.status != 0) {
                $scope.totalRecs += 1;
              }
              if (i.status == 4 && i.receipt_type == 1 && i.status != 0) {
                $scope.numRecs += 1;
              } else if (i.status != 4) {
              }
              order.form.domiciliado = insuranceData.domiciliada;
            });

            if (insuranceData.automobiles_policy.length) {
              order.form.policy_type =
                insuranceData.automobiles_policy[0].policy_type;
              order.form.procedencia =
                insuranceData.automobiles_policy[0].procedencia;
              order.form.charge_type =
                insuranceData.automobiles_policy[0].charge_type;
            }

            if (insuranceData.damages_policy.length) {
              order.form.policy_type =
                insuranceData.damages_policy[0].damage_type;
            }

            if (insuranceData.recibos_poliza.length > 0) {
              order.hasReceipts = true;
            } else {
              order.hasReceipts = false;
            }

            if (insuranceData.hospital_level) {
              order.form.hospital_level = insuranceData.hospital_level;
            }
            if (insuranceData.tabulator) {
              order.form.tabulator = insuranceData.tabulator;
            }
            $localStorage.poliza_number = insuranceData.poliza_number;
            var initDate = new Date(
              new Date(insuranceData.start_of_validity).setHours(12, 0, 0, 0)
            );
            var endDate = new Date(
              new Date(insuranceData.end_of_validity).setHours(11, 59, 59, 0)
            );
            try {
              insuranceData.vendor.name =
                insuranceData.vendor.first_name +
                " " +
                insuranceData.vendor.last_name;
              order.form.vendor = insuranceData.vendor;
              $scope.original_vendor = insuranceData.vendor;
            } catch (e) {}

            try {
              if (insuranceData.responsable) {
                insuranceData.responsable.name =
                  insuranceData.responsable.first_name +
                  " " +
                  insuranceData.responsable.last_name;
                order.form.responsable = insuranceData.responsable;
                $scope.original_responsable = insuranceData.responsable;
              }
            } catch (e) {
              console.log("Error responsable", e);
            }

            try {
              if (insuranceData.collection_executive) {
                insuranceData.collection_executive.name =
                  insuranceData.collection_executive.first_name +
                  " " +
                  insuranceData.collection_executive.last_name;
                order.form.collection_executive =
                  insuranceData.collection_executive;
                $scope.original_collection_executive =
                  insuranceData.collection_executive;
              }
            } catch (e) {
              console.log("Error ejecutivo de cobranza", e);
            }
            try {
              if (insuranceData.ref_policy) {
                if (insuranceData.ref_policy.length > 0) {
                  insuranceData.ref_policy.forEach(function (refs) {
                    $http
                      .get(refs.referenciador)
                      .then(function success(response_ref_plicy) {
                        // if(response_ref_plicy){
                        //   var s_r = response_ref_plicy.data.user_info.info_vendedor[0].vendedor_subramos
                        //   s_r.forEach(function(sr) {
                        //     if ((sr.subramo == insuranceData.subramo.subramo_code) && (sr.provider == insuranceData.aseguradora.id)) {
                        //       if(response_ref_plicy){
                        //         // response_ref_plicy_vendor.comision_vendedor = sr.comision
                        //       }
                        //     }
                        //     // else if ((sr.subramo == 0) && (sr.provider == 0) && (sr.ramo == 0)) {
                        //     //   if(response_ref_plicy){
                        //     //     refs.comision_vendedor = sr.comision
                        //     //   }
                        //     // }
                        //   })
                        //   refs.data = response_ref_plicy.data
                        //   refs.referenciador = response_ref_plicy.data.url
                        //   refs.selectedRef = true
                        //   $scope.referenciadores.push(refs)
                        //   $scope.referenciadores.forEach(function(io){
                        //     if (io.referenciador == undefined) {
                        //       $scope.referenciadores.splice($scope.referenciadores.indexOf(io),1)
                        //     }
                        //   })
                        // }
                        if (
                          response_ref_plicy &&
                          response_ref_plicy.data &&
                          response_ref_plicy.data.user_info &&
                          response_ref_plicy.data.user_info.info_vendedor &&
                          response_ref_plicy.data.user_info.info_vendedor
                            .length > 0
                        ) {
                          var s_r =
                            response_ref_plicy.data.user_info.info_vendedor[0]
                              .vendedor_subramos;

                          s_r.forEach(function (sr) {
                            if (
                              sr.subramo ==
                                insuranceData.subramo.subramo_code &&
                              sr.provider == insuranceData.aseguradora.id
                            ) {
                              // Uncomment and assign commission if needed
                              // response_ref_plicy_vendor.comision_vendedor = sr.comision;
                            }
                          });

                          refs.data = response_ref_plicy.data;
                          refs.referenciador = response_ref_plicy.data.url;
                          refs.selectedRef = true;
                          $scope.referenciadores.push(refs);

                          // Clean up undefined referenciador entries
                          $scope.referenciadores =
                            $scope.referenciadores.filter(function (io) {
                              return io.referenciador !== undefined;
                            });
                        }
                      });
                  });
                }
              } else if (insuranceData.vendor) {
                $http
                  .get(insuranceData.vendor.url)
                  .then(function success(response_ref_plicy_vendor) {
                    // if(response_ref_plicy_vendor){
                    //   response_ref_plicy_vendor.data = response_ref_plicy_vendor.data
                    //   response_ref_plicy_vendor.referenciador = response_ref_plicy_vendor.data.url
                    //   response_ref_plicy_vendor.vendor = response_ref_plicy_vendor.data.url
                    //   response_ref_plicy_vendor.comision_vendedor = response_ref_plicy_vendor.data.user_info.info_vendedor[0].gastos_operacion
                    //   $scope.referenciadores.push(response_ref_plicy_vendor)
                    // }
                    var s_r =
                      response_ref_plicy_vendor.data.user_info.info_vendedor[0]
                        .vendedor_subramos;
                    s_r.forEach(function (sr) {
                      if (
                        sr.subramo == insuranceData.subramo.subramo_code &&
                        sr.provider == insuranceData.aseguradora.id
                      ) {
                        if (response_ref_plicy_vendor) {
                          response_ref_plicy_vendor.data =
                            response_ref_plicy_vendor.data;
                          response_ref_plicy_vendor.referenciador =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.vendor =
                            response_ref_plicy_vendor.data.url;
                          response_ref_plicy_vendor.comision_vendedor =
                            sr.comision;
                          response_ref_plicy_vendor.data.comision_policy =
                            response_ref_plicy_vendor.comision_vendedor;
                          response_ref_plicy_vendor.selectedRef = true;
                          $scope.referenciadores.push(
                            response_ref_plicy_vendor
                          );
                        }
                      }
                    });
                  });
              } else {
                $scope.referenciadores.push($scope.referenciador);
              }
            } catch (e) {
              console.log("Error en referenciador", e);
            }
            try {
              if (insuranceData.sucursal) {
                insuranceData.sucursal.sucursal_name =
                  insuranceData.sucursal.sucursal_name +
                  " - " +
                  insuranceData.sucursal.details;
                order.form.sucursal = insuranceData.sucursal;
                $scope.original_sucursal = insuranceData.sucursal;
              }
            } catch (e) {
              console.log("Error sucursal", e);
            }

            order.form.is_renewable = insuranceData.is_renewable;
            order.form.business_line = insuranceData.business_line;
            order.form.sucursal = insuranceData.sucursal
              ? insuranceData.sucursal
              : "";
            order.form.address = insuranceData.address;
            order.form.clave = insuranceData.clave;
            order.form.observations = insuranceData.observations;
            order.form.poliza =
              insuranceData.poliza_number == "0"
                ? ""
                : insuranceData.poliza_number;

            if (insuranceData.state_circulation) {
              $scope.statesArray.forEach(function (item) {
                if (item.state == insuranceData.state_circulation) {
                  order.form.state_circulation = item;
                  $scope.order.subforms.auto.state_circulation = item;
                }
              });
            }

            if (insuranceData.celula) {
              $http.get(insuranceData.celula).then(function (response) {
                order.form.celula = response.data;
              });
            }

            if (insuranceData.grouping_level) {
              $http
                .get(
                  url.IP + "groupinglevel/" + insuranceData.grouping_level.id
                )
                .then(function (response) {
                  order.form.grouping_level = response.data;
                  $scope.info_sub = insuranceData;
                  $scope.changeAgrupacion(order.form.grouping_level);
                });
            }

            // order.f_currency = insuranceData.f_currency;
            order.poliza.primaTotal = parseFloat(insuranceData.p_total).toFixed(
              2
            );
            order.poliza.rpf = parseFloat(insuranceData.rpf);
            order.poliza.derecho = parseFloat(insuranceData.derecho).toFixed(2);
            order.poliza.descuento = parseFloat(insuranceData.descuento);
            order.poliza.iva = parseFloat(insuranceData.iva);
            order.poliza.primaNeta = parseFloat(insuranceData.p_neta);
            order.poliza.subTotal = parseFloat(insuranceData.sub_total).toFixed(
              2
            );

            var desc = parseFloat(order.poliza.descuento) / 100;
            // order.poliza.subTotal = (insuranceData.p_neta - desc) + insuranceData.rpf + insuranceData.derecho;
            var cantidad_desc = parseFloat(order.poliza.primaNeta) * desc;
            var p_neta_desc =
              parseFloat(order.poliza.primaNeta) - parseFloat(cantidad_desc);
            // order.poliza.subTotal = p_neta_desc + parseFloat(insuranceData.rpf) + parseFloat(insuranceData.derecho);

            order.form.startDate = datesFactory.convertDate(initDate);
            order.form.endingDate = datesFactory.convertDate(endDate);

            order.form.start_of_validity = initDate;
            order.form.end_of_validity = endDate;

            order.form.udi = parseFloat(insuranceData.udi);
            order.form.comision_percent = parseFloat(
              insuranceData.comision_percent
            );

            // var insuranceContractor = insuranceData.natural ? insuranceData.natural : insuranceData.juridical ? insuranceData.juridical : undefined;
            var insuranceContractor = insuranceData.contractor;

            var date1 = new Date(order.form.start_of_validity);
            var date2 = new Date(order.form.end_of_validity);
            var timeDiff = Math.abs(date2.getTime() - date1.getTime());
            order.form.policy_days_duration = Math.ceil(
              timeDiff / (1000 * 3600 * 24)
            );
            order.poliza.payment = insuranceData.forma_de_pago.value.toString();
            order.poliza.numeroRecibos = insuranceData.recibos_poliza.length;

            if (order.form.policy_days_duration > 366) {
              order.poliza.numeroRecibos = 12 / order.poliza.payment;
            }
            order.poliza.derecho = parseFloat(order.poliza.derecho);
            // folio
            if (insuranceData.folio) {
              order.form.folio = insuranceData.folio;
            }

            // folio interno
            if (insuranceData.internal_number) {
              order.form.internal_number = insuranceData.internal_number;
            }

            // agent
            if (insuranceContractor) {
              if (order.defaults.contractors.length > 0) {
                order.defaults.contractors.some(function (agent) {
                  if (agent.url == insuranceContractor.url) {
                    order.form.contratante = {
                      value: undefined,
                      val: "",
                    };

                    order.form.contratante.value = agent;
                    if (agent.full_name) {
                      order.form.contratante.val = agent.full_name;
                    } else if (agent.name) {
                      order.form.contratante.val = agent.name;
                    } else if (agent.first_name) {
                      order.form.contratante.val =
                        agent.first_name +
                        " " +
                        agent.last_name +
                        " " +
                        agent.second_last_name;
                    } else if (agent.j_name) {
                      order.form.contratante.val = agent.j_name;
                    }
                  }
                });
              } else {
                order.form.contratante = {};
                if (order.form.contratante) {
                  order.form.contratante.value = insuranceContractor;
                  if (insuranceContractor.full_name) {
                    order.form.contratante.val = insuranceContractor.full_name;
                  } else if (insuranceContractor.name) {
                    order.form.contratante.val = insuranceContractor.name;
                  } else if (insuranceContractor.first_name) {
                    order.form.contratante.val =
                      insuranceContractor.first_name +
                      " " +
                      insuranceContractor.last_name +
                      " " +
                      insuranceContractor.second_last_name;
                  } else if (insuranceContractor.j_name) {
                    order.form.contratante.val = insuranceContractor.j_name;
                  }
                }
              }
            }

            $scope.$watch(
              "order.form.contratante.value",
              function (newValue, oldValue) {
                if (order.form.contratante.value) {
                  // $scope.users.some(function(user) {
                  // if (user.url == order.form.contratante.value.vendor){
                  //     // order.form.vendor = user;
                  //   }
                  // })

                  // if (order.form.contratante.value.address_natural) {
                  //     order.defaults.address = order.form.contratante.value.address_natural
                  // } else{
                  //     order.defaults.address = order.form.contratante.value.address_juridical
                  // }
                  order.defaults.address =
                    order.form.contratante.value.address_contractor;

                  if (order.form.contratante.value.phone_number) {
                    order.form.contratante.phone_number =
                      order.form.contratante.value.phone_number;
                  }

                  try {
                    if (order.defaults.address.length == 1) {
                      order.form.address = order.defaults.address[0];
                    }
                  } catch (err) {}

                  if (order.form.contratante.value.email) {
                    order.form.contratante.email =
                      order.form.contratante.value.email;
                  }
                }
              }
            );

            // provider and fill compo
            if (insuranceData.aseguradora) {
              order.defaults.providers.some(function (provider) {
                if (provider.id == insuranceData.aseguradora.id) {
                  order.form.aseguradora = provider;
                  order.options.changeProvider(provider);
                  return true;
                }
              });
            }
            // ramo and fill combos
            if (insuranceData.ramo) {
              var wait = [];
              // wait.push($http.get(order.form.aseguradora.url));
              wait.push(
                $http.get(
                  url.IP + "ramos-by-provider/" + order.form.aseguradora.id
                )
              );
              $q.all(wait).then(function (response) {
                order.defaults.ramos = response[0].data;
                order.defaults.ramos.some(function (ramo) {
                  if (ramo.id == insuranceData.ramo.id) {
                    order.form.ramo = ramo;
                    order.options.changeRamo(ramo);
                    // order.poliza.rpf = insuranceData.rpf;
                    // order.poliza.derecho = insuranceData.derecho;
                    // order.poliza.descuento = insuranceData.descuento;
                    // order.poliza.primaNeta = insuranceData.p_neta;
                    // order.poliza.primaTotal = insuranceData.p_total;

                    // subramo and fill combos

                    order.defaults.subramos = ramo.subramo_ramo;

                    if (insuranceData.subramo) {
                      order.defaults.subramos.some(function (subramo) {
                        if (subramo.id == insuranceData.subramo.id) {
                          order.form.subramo = subramo;
                          order.options.changeSubramo(subramo);

                          // subforms
                          //form
                          var code = order.defaults.formInfo.code;
                          if (code === 9) {
                            // auto
                            if (insuranceData.automobiles_policy.length > 0) {
                              var subformInfo =
                                insuranceData.automobiles_policy[0];
                              order.subforms.auto = {
                                brand: subformInfo.brand,
                                color: subformInfo.color,
                                created_at: subformInfo.created_at,
                                document_type: subformInfo.document_type,
                                engine: subformInfo.engine,
                                id: subformInfo.id,
                                license_plates: subformInfo.license_plates,
                                model: subformInfo.model,
                                policy: subformInfo.policy,
                                serial: subformInfo.serial,
                                sub_branch: subformInfo.sub_branch,
                                updated_at: subformInfo.updated_at,
                                url: subformInfo.url,
                                usage: subformInfo.usage,
                                policy_type: subformInfo.policy_type,
                                procedencia: subformInfo.procedencia,
                                charge_type: subformInfo.charge_type,
                                service: subformInfo.service,
                                version: subformInfo.version,
                                beneficiary_name: subformInfo.beneficiary_name,
                                beneficiary_address:
                                  subformInfo.beneficiary_address,
                                beneficiary_rfc: subformInfo.beneficiary_rfc,
                                driver: subformInfo.driver,
                                adjustment: subformInfo.adjustment,
                                mont_adjustment: subformInfo.mont_adjustment,
                                special_team: subformInfo.special_team,
                                mont_special_team:
                                  subformInfo.mont_special_team,
                                year: parseInt(subformInfo.year),
                              };
                              $scope.usages.forEach(function (item) {
                                if (item.id == subformInfo.usage) {
                                  order.subforms.auto.usage = item.id;
                                }
                              });
                              if (insuranceData.state_circulation) {
                                $scope.statesArray.forEach(function (item) {
                                  if (
                                    item.state ==
                                    insuranceData.state_circulation
                                  ) {
                                    order.form.state_circulation = item;
                                    order.subforms.auto.state_circulation =
                                      item;
                                    $scope.order.subforms.auto.state_circulation =
                                      item;
                                  }
                                });
                              }
                            }
                          } else if (code === 1 || code == 30) {
                            // vida

                            if (
                              insuranceData.personal_life_policy &&
                              insuranceData.life_policy.length == 0
                            ) {
                              insuranceData.personal_life_policy.forEach(
                                function (pers) {
                                  var ben = {
                                    birthdate: datesFactory.convertDate(
                                      pers.birthdate
                                    ),
                                    antiguedad: pers.antiguedad
                                      ? datesFactory.convertDate(
                                          pers.antiguedad
                                        )
                                      : null,
                                    first_name: pers.first_name,
                                    last_name: pers.last_name,
                                    second_last_name: pers.second_last_name,
                                    url: pers.url,
                                    sex: pers.sex,
                                    smoker: pers.smoker ? pers.smoker : "False",
                                    policy_type: pers.policy_type
                                      ? pers.policy_type
                                      : 49,
                                  };

                                  order.options.life.asegurados.add(ben);
                                }
                              );
                            }
                            if (insuranceData.life_policy.length > 0) {
                              var subformInfo = insuranceData.life_policy[0];
                              loadingThing("personal");
                              // formService.getPersonalInfoByUri(subformInfo.personal.url)
                              //   .then(function(personalResponse) {
                              // var personal = subformInfo.personal = personalResponse.data;
                              var personal = insuranceData.personal_life_policy;
                              if (!personal.length) {
                                personal =
                                  insuranceData.life_policy[0].personal;
                              }
                              // order.subforms.life.first_name = subformInfo.personal.first_name;
                              // order.subforms.life.url = subformInfo.personal.url;
                              // order.subforms.life.last_name = subformInfo.personal.last_name;
                              // order.subforms.life.second_last_name = subformInfo.personal.second_last_name;
                              // order.subforms.life.birthdate = convertDate(subformInfo.personal.birthdate);
                              // order.subforms.life.sex = subformInfo.personal.sex;
                              order.subforms.life.smoker =
                                subformInfo.smoker == undefined
                                  ? ""
                                  : subformInfo.smoker
                                  ? "True"
                                  : "False";
                              order.subforms.life.beneficiariesList = [];
                              if (insuranceData.personal_life_policy.length) {
                                insuranceData.personal_life_policy.forEach(
                                  function (pers) {
                                    var ben = {
                                      birthdate: datesFactory.convertDate(
                                        pers.birthdate
                                      ),
                                      antiguedad: pers.antiguedad
                                        ? datesFactory.convertDate(
                                            pers.antiguedad
                                          )
                                        : null,
                                      first_name: pers.first_name,
                                      last_name: pers.last_name,
                                      second_last_name: pers.second_last_name,
                                      url: pers.url,
                                      sex: pers.sex,
                                      smoker: pers.smoker
                                        ? pers.smoker
                                        : "False",
                                      policy_type: pers.policy_type,
                                    };
                                    if (ben.smoker == true) {
                                      ben.smoker = "True";
                                    } else if (ben.smoker == false) {
                                      ben.smoker = "False";
                                    }
                                    order.options.life.asegurados.add(ben);
                                  }
                                );
                              } else {
                                try {
                                  var personal_antig = personal;
                                  var prs_life = {
                                    birthdate: datesFactory.convertDate(
                                      personal_antig.birthdate
                                    ),
                                    antiguedad: personal_antig.antiguedad
                                      ? datesFactory.convertDate(
                                          personal_antig.antiguedad
                                        )
                                      : null,
                                    first_name: personal_antig.first_name,
                                    last_name: personal_antig.last_name,
                                    second_last_name:
                                      personal_antig.second_last_name,
                                    url: personal_antig.url,
                                    sex: personal_antig.sex,
                                    smoker: personal_antig.smoker
                                      ? personal_antig.smoker
                                      : "False",
                                  };
                                  if (prs_life.smoker == true) {
                                    prs_life.smoker = "True";
                                  } else if (prs_life.smoker == false) {
                                    prs_life.smoker = "False";
                                  }

                                  order.options.life.asegurados.add(prs_life);
                                  order.subforms.life.smoker =
                                    subformInfo.smoker == undefined
                                      ? ""
                                      : subformInfo.smoker
                                      ? "True"
                                      : "False";
                                } catch (e) {}
                              }

                              subformInfo.beneficiaries_life.forEach(function (
                                beneficiary
                              ) {
                                var ben = {
                                  birthdate: datesFactory.convertDate(
                                    beneficiary.birthdate
                                  ),
                                  antiguedad: beneficiary.antiguedad
                                    ? datesFactory.convertDate(
                                        beneficiary.antiguedad
                                      )
                                    : null,
                                  first_name: beneficiary.first_name,
                                  last_name: beneficiary.last_name,
                                  second_last_name:
                                    beneficiary.second_last_name,
                                  j_name: beneficiary.j_name,
                                  rfc: beneficiary.rfc,
                                  percentage: beneficiary.percentage,
                                  url: beneficiary.url,
                                  sex: beneficiary.sex,
                                  optional_relationship:
                                    beneficiary.optional_relationship,
                                  full_name:
                                    beneficiary.first_name +
                                    " " +
                                    beneficiary.last_name +
                                    " " +
                                    beneficiary.second_last_name,
                                  person: beneficiary.first_name ? 1 : 2,
                                };

                                order.options.life.beneficiary.add(ben);
                              });
                              //order.subforms
                              aThingIsDone("personal");
                              // });
                            }
                          } else if (code === 2 || code === 3 || code === 4) {
                            // otro tipo de info
                            if (insuranceData.accidents_policy.length > 0) {
                              var subformInfo =
                                insuranceData.accidents_policy[0];
                              loadingThing("personal");
                              formService
                                .getPersonalInfoByUri(subformInfo.personal.url)
                                .then(function (personalResponse) {
                                  subformInfo.personal = personalResponse.data;
                                  order.subforms.disease.sex =
                                    subformInfo.personal.sex;
                                  order.subforms.disease.coinsurance =
                                    subformInfo.coinsurance;
                                  order.subforms.disease.id = subformInfo.id;
                                  order.subforms.disease.url = subformInfo.url;
                                  order.subforms.disease.sub_branch =
                                    subformInfo.sub_branch;
                                  order.subforms.disease.policy =
                                    subformInfo.policy;
                                  order.subforms.disease.relationshipList = [];
                                  order.subforms.disease.first_name =
                                    subformInfo.personal.first_name;
                                  order.subforms.disease.personal_url =
                                    subformInfo.personal.url;
                                  order.subforms.disease.last_name =
                                    subformInfo.personal.last_name;
                                  order.subforms.disease.second_last_name =
                                    subformInfo.personal.second_last_name;
                                  order.subforms.disease.birthdate =
                                    datesFactory.convertDate(
                                      subformInfo.personal.birthdate
                                    );
                                  order.subforms.disease.antiguedad =
                                    subformInfo.personal.antiguedad
                                      ? datesFactory.convertDate(
                                          subformInfo.personal.antiguedad
                                        )
                                      : null;
                                  order.subforms.disease.policy_type =
                                    subformInfo.personal.policy_type;

                                  subformInfo.relationship_accident.forEach(
                                    function (relationship) {
                                      var rel = {
                                        birthdate: datesFactory.convertDate(
                                          relationship.birthdate
                                        ),
                                        antiguedad: relationship.antiguedad
                                          ? datesFactory.convertDate(
                                              relationship.antiguedad
                                            )
                                          : null,
                                        first_name: relationship.first_name,
                                        last_name: relationship.last_name,
                                        second_last_name:
                                          relationship.second_last_name,
                                        url: relationship.url,
                                        sex: null,
                                        relationship: relationship.relationship,
                                      };

                                      order.defaults.sex.some(function (sex) {
                                        if (sex.value == relationship.sex) {
                                          rel.sex = sex;
                                          return true;
                                        }
                                      });

                                      order.options.disease.types.some(
                                        function (type) {
                                          if (
                                            type.relationship ==
                                            relationship.relationship
                                          ) {
                                            rel.relationship = type;
                                            return true;
                                          }
                                        }
                                      );

                                      order.options.disease.relationships.add(
                                        rel
                                      );
                                    }
                                  );

                                  aThingIsDone("personal");
                                });
                            }
                          } else if (
                            code === 5 ||
                            code === 6 ||
                            code === 7 ||
                            code === 8 ||
                            code === 10 ||
                            code === 11 ||
                            code === 12 ||
                            code === 13 ||
                            code === 14 ||
                            code === 31
                          ) {
                            // daño general
                            if (insuranceData.damages_policy.length > 0) {
                              var subformInfo = insuranceData.damages_policy[0];
                              order.subforms.damage.coinsurance =
                                subformInfo.coinsurance;
                              order.subforms.damage.created_at =
                                subformInfo.created_at;
                              order.subforms.damage.damage_type =
                                subformInfo.damage_type;
                              order.subforms.damage.insured_item =
                                subformInfo.insured_item;
                              order.subforms.damage.item_address =
                                subformInfo.item_address;
                              order.subforms.damage.item_details =
                                subformInfo.item_details;
                              order.subforms.damage.policy = subformInfo.policy;
                              order.subforms.damage.sub_branch =
                                subformInfo.sub_branch;
                              order.subforms.damage.updated_at =
                                subformInfo.updated_at;
                              order.subforms.damage.url = subformInfo.url;
                            }
                          } else {
                          }

                          $q.all(order.defaults.waitElement).then(function (
                            packages
                          ) {
                            // package and fill combos
                            order.defaults.coverages = [];
                            if (insuranceData.paquete) {
                              order.form.paquete = insuranceData.paquete;
                              if (
                                insuranceData.paquete.coverage_package.length
                              ) {
                                var pack = insuranceData.paquete;
                                pack.coverage_package.forEach(function (
                                  element,
                                  index
                                ) {
                                  // if (element.default) {
                                  // order.defaults.coverageList.push(angular.copy(element));
                                  // }
                                });
                              }

                              if (order.defaults.packages.length) {
                                // order.defaults.coverageInPackage = [];
                                order.defaults.packages.some(function (pkg) {
                                  if (pkg.id == insuranceData.paquete.id) {
                                    order.form.paquete = pkg;
                                    order.options.changePackage(pkg);
                                    order.defaults.coverages = [];

                                    order.defaults.coverageList = [];
                                    var cob_demo = angular.copy(
                                      pkg.coverage_package
                                    );
                                    pkg.coverage_package.forEach(function (
                                      element,
                                      index
                                    ) {
                                      if (
                                        myInsurance.coverageInPolicy_policy
                                          .length
                                      ) {
                                        myInsurance.coverageInPolicy_policy.forEach(
                                          function (item) {
                                            if (
                                              element.coverage_name ==
                                              item.coverage_name
                                            ) {
                                              // eliminar cobertura del paquete
                                              cob_demo.splice(index, 1);
                                            }
                                          }
                                        );
                                      }
                                    });

                                    order.defaults.coverageList =
                                      pkg.coverage_package;

                                    if (
                                      myInsurance.coverageInPolicy_policy
                                        .length > 0
                                    ) {
                                      myInsurance.coverageInPolicy_policy.forEach(
                                        function (coverageInPolicy) {
                                          coverageInPolicy.sumInPolicy = {
                                            label: coverageInPolicy.sum_insured,
                                            value: coverageInPolicy.sum_insured,
                                          };

                                          coverageInPolicy.deductibleInPolicy =
                                            {
                                              label:
                                                coverageInPolicy.deductible,
                                              value:
                                                coverageInPolicy.deductible,
                                            };
                                          coverageInPolicy.primaInPolicy =
                                            coverageInPolicy.prima;

                                          if (
                                            isNaN(coverageInPolicy.coinsurance)
                                          ) {
                                            if (
                                              coverageInPolicy.coinsurance.indexOf(
                                                "%"
                                              ) != -1
                                            ) {
                                              coverageInPolicy.coinsurance =
                                                coverageInPolicy.coinsurance.replace(
                                                  "%",
                                                  ""
                                                );
                                              coverageInPolicy.coinsuranceInPolicy =
                                                parseInt(
                                                  coverageInPolicy.coinsurance
                                                );
                                            } else {
                                              coverageInPolicy.coinsuranceInPolicy = 1;
                                            }
                                          } else {
                                            coverageInPolicy.coinsuranceInPolicy =
                                              parseInt(
                                                coverageInPolicy.coinsurance
                                              );
                                          }

                                          if (
                                            coverageInPolicy.coinsuranceInPolicy <
                                            0
                                          ) {
                                            coverageInPolicy.coinsuranceInPolicy = 1;
                                          }

                                          if (
                                            coverageInPolicy.coinsuranceInPolicy >
                                            100
                                          ) {
                                            coverageInPolicy.coinsuranceInPolicy = 100;
                                          }
                                          //tope coaseguro
                                          if (
                                            isNaN(
                                              coverageInPolicy.topecoinsurance
                                            )
                                          ) {
                                            if (
                                              coverageInPolicy.topecoinsurance.indexOf(
                                                "%"
                                              ) != -1
                                            ) {
                                              coverageInPolicy.topecoinsurance =
                                                coverageInPolicy.topecoinsurance.replace(
                                                  "%",
                                                  ""
                                                );
                                              coverageInPolicy.topeCoinsuranceInPolicy =
                                                parseInt(
                                                  coverageInPolicy.topecoinsurance
                                                );
                                            } else {
                                              coverageInPolicy.topecoinsuranceInPolicy = 1;
                                            }
                                          } else {
                                            coverageInPolicy.topeCoinsuranceInPolicy =
                                              parseInt(
                                                coverageInPolicy.topecoinsurance
                                              );
                                          }

                                          if (
                                            coverageInPolicy.topeCoinsuranceInPolicy <
                                            0
                                          ) {
                                            coverageInPolicy.topeCoinsuranceInPolicy = 1;
                                          }

                                          if (
                                            coverageInPolicy.topeCoinsuranceInPolicy >
                                            100
                                          ) {
                                            coverageInPolicy.topeCoinsuranceInPolicy = 100;
                                          }

                                          order.options.addCoverage(
                                            coverageInPolicy
                                          );

                                          if (pkg.coverage_package.length) {
                                            pkg.coverage_package.some(function (
                                              coverageInPackage
                                            ) {
                                              // 3 cosas a comparar (nombre, suma en opciones y deducible en opciones)

                                              if (
                                                coverageInPolicy.coverage_name ==
                                                coverageInPackage.coverage_name
                                              ) {
                                                var flag = 0;
                                                coverageInPackage.sumInPolicy =
                                                  {
                                                    label:
                                                      coverageInPolicy.sum_insured,
                                                    value:
                                                      coverageInPolicy.sum_insured,
                                                  };

                                                coverageInPackage.deductibleInPolicy =
                                                  {
                                                    label:
                                                      coverageInPolicy.deductible,
                                                    value:
                                                      coverageInPolicy.deductible,
                                                  };
                                                coverageInPackage.primaInPolicy =
                                                  coverageInPolicy.prima;
                                                coverageInPackage.coinsuranceInPolicy =
                                                  coverageInPolicy.coinsurance;
                                                coverageInPackage.topeCoinsuranceInPolicy =
                                                  coverageInPolicy.topecoinsurance;

                                                order.options.addCoverage(
                                                  coverageInPackage
                                                );
                                                return true; // Si todo fue encontrado, termina el for, si no sigue busacndo
                                              } else {
                                                var flag = 0;
                                                var coverageInPackage = {
                                                  coverage_name:
                                                    coverageInPolicy.coverage_name,
                                                  sumInPolicy: {
                                                    label:
                                                      coverageInPolicy.sum_insured,
                                                    value:
                                                      coverageInPolicy.sum_insured,
                                                  },
                                                  deductibleInPolicy: {
                                                    label:
                                                      coverageInPolicy.deductible,
                                                    value:
                                                      coverageInPolicy.deductible,
                                                  },
                                                  primaInPolicy:
                                                    coverageInPolicy.prima,
                                                  coinsuranceInPolicy:
                                                    coverageInPolicy.coinsurance,
                                                  topeCoinsuranceInPolicy:
                                                    coverageInPolicy.topecoinsurance,
                                                  created_at:
                                                    coverageInPolicy.created_at,
                                                  id: coverageInPolicy.id,
                                                  org: coverageInPolicy.org,
                                                  owner: coverageInPolicy.owner,
                                                  package:
                                                    coverageInPolicy.package,
                                                  policy:
                                                    coverageInPolicy.policy,
                                                  updated_at:
                                                    coverageInPolicy.updated_at,
                                                  url: coverageInPolicy.url,
                                                };

                                                // order.options.addCoverage(coverageInPackage);
                                                // order.defaults.coverageInPackage.push(coverageInPackage);
                                              }
                                            });
                                          } else {
                                            var flag = 0;
                                            var coverageInPackage = {
                                              coverage_name:
                                                coverageInPolicy.coverage_name,
                                              sumInPolicy: {
                                                label:
                                                  coverageInPolicy.sum_insured,
                                                value:
                                                  coverageInPolicy.sum_insured,
                                              },
                                              deductibleInPolicy: {
                                                label:
                                                  coverageInPolicy.deductible,
                                                value:
                                                  coverageInPolicy.deductible,
                                              },
                                              primaInPolicy:
                                                coverageInPolicy.prima,
                                              coinsuranceInPolicy:
                                                coverageInPolicy.coinsurance,
                                              topeCoinsuranceInPolicy:
                                                coverageInPolicy.topecoinsurance,
                                              created_at:
                                                coverageInPolicy.created_at,
                                              id: coverageInPolicy.id,
                                              org: coverageInPolicy.org,
                                              owner: coverageInPolicy.owner,
                                              package: coverageInPolicy.package,
                                              policy: coverageInPolicy.policy,
                                              updated_at:
                                                coverageInPolicy.updated_at,
                                              url: coverageInPolicy.url,
                                            };

                                            order.options.addCoverage(
                                              coverageInPackage
                                            );
                                            // return true;
                                          }
                                        }
                                      );
                                    } else {
                                    }
                                  }
                                });
                              }
                            } else {
                              if (
                                myInsurance.coverageInPolicy_policy.length > 0
                              ) {
                                order.defaults.coverageList = [];
                                myInsurance.coverageInPolicy_policy.forEach(
                                  function (coverageInPolicy) {
                                    order.options.addCoverage(coverageInPolicy);
                                  }
                                );
                              }
                            }
                          });

                          if (insuranceData.forma_de_pago) {
                            order.defaults.payform.some(function (pf) {
                              if (
                                pf.value == insuranceData.forma_de_pago.value
                              ) {
                                order.options.isReceiptAvailable(pf, true);
                                return true;
                              }
                            });
                          }

                          order.renewal.is_renewable =
                            insuranceData.is_renewable;
                          order.f_currency.f_currency_selected =
                            insuranceData.f_currency;
                          order.conducto_de_pago.conducto_de_pago_selected =
                            insuranceData.conducto_de_pago;
                          // recibos
                          if (insuranceData.recibos_poliza.length > 0) {
                            order.defaults.showReceipts = true;
                          }
                          if (insuranceData.recibos_poliza.length > 0) {
                            var aux = angular.copy(
                              insuranceData.recibos_poliza
                            );
                            var tmp = [];
                            for (var i = 0; i < aux.length; i++) {
                              for (var j = 0; j < aux.length; j++) {
                                if (i + 1 == aux[j].recibo_numero) {
                                  tmp.push(aux[j]);
                                }
                              }
                            }

                            // return;
                            var prima_neta = 0.0;
                            var rpf;
                            var derecho;
                            var subTotal = 0.0;
                            var prima_total = 0.0;

                            $scope.recibos_todos = [];

                            tmp.forEach(function (recibo, index) {
                              if (recibo.receipt_type == 1) {
                                var receipt = {
                                  prima_neta: parseFloat(recibo.prima_neta),
                                  recibo_numero: recibo.recibo_numero,
                                  rpf: parseFloat(recibo.rpf),
                                  derecho: parseFloat(recibo.derecho),
                                  iva: parseFloat(recibo.iva),
                                  subTotal: parseFloat(recibo.sub_total),
                                  prima_total: parseFloat(recibo.prima_total),
                                  fecha_inicio: datesFactory.convertDate(
                                    recibo.fecha_inicio
                                  ),
                                  fecha_fin: datesFactory.convertDate(
                                    recibo.fecha_fin
                                  ),
                                  vencimiento: datesFactory.convertDate(
                                    recibo.vencimiento
                                  ),
                                  comision: parseFloat(recibo.comision),
                                  delivered: recibo.delivered,
                                  url: recibo.url,
                                  status: recibo.status,
                                  id: recibo.id,
                                };

                                if (recibo.status > 4) {
                                  $scope.liquidated_receipts = true;
                                }

                                if (recibo.isCopy == false) {
                                  $scope.recibos_todos.push(receipt);
                                  if (recibo.status != 0) {
                                    order.receipts.push(receipt);
                                    if (recibo.status != 4) {
                                      order.recalcular = false;
                                    }
                                  }
                                }
                              }
                            });

                            var last_receipt = tmp[tmp.length - 1];
                            var date_last_rec = new Date(
                              tmp[tmp.length - 1].fecha_fin
                            );
                            var policy_init = order.form.start_of_validity;
                            var policy_end = order.form.end_of_validity;

                            var anios_vigencia =
                              parseInt(policy_end.getFullYear()) -
                              parseInt(policy_init.getFullYear());

                            // VALIDA SI LA PÓLIZA ES MULTIANUAL O NO
                            if (anios_vigencia > 1) {
                              // DE SER MULTIANUAL, VERIFICA SI FUE CALCULADA POR EL PRIMER AÑO DE VIGENCIA O POR TODOS
                              if (
                                date_last_rec.getDate() ==
                                  policy_init.getDate() &&
                                date_last_rec.getMonth() ==
                                  policy_init.getMonth() &&
                                parseInt(date_last_rec.getFullYear()) ==
                                  parseInt(policy_init.getFullYear()) + 1
                              ) {
                                order.poliza.fy = true;
                              }
                            }
                          }

                          $scope.originals_receipts = order.receipts;

                          // Loaded files
                          if (
                            insuranceData &&
                            insuranceData.files &&
                            insuranceData.files.results
                          ) {
                            order.files = insuranceData.files.results;
                          } else {
                            order.files = [];
                          }
                          order.insuranceObject = insuranceData;
                          aThingIsDone("insurance");

                          $scope.show_receipts = true;
                          return true;
                        }
                      });
                    }
                    return true;
                  }
                });
              });
            }
          },
          function error(err) {
            console.log("error", err);
          }
        );
      });
      if (order.form) {
        if (order.form.status == 1 || order.form.status == 2) {
          order.show.ot = true;
        } else {
          order.show.ot = false;
        }
      }
    } //******************************************************************** */

    $scope.changeReferenciador = function (ref) {
      if (ref) {
        if (ref.data) {
          if (ref.data.url != ref.referenciador) {
            $http.get(ref.referenciador).then(function success(c) {
              if (
                c &&
                c.data &&
                c.data.user_info &&
                c.data.user_info.info_vendedor &&
                c.data.user_info.info_vendedor.length > 0
              ) {
                var subBranchsComisions =
                  c.data.user_info.info_vendedor[0].vendedor_subramos;
                subBranchsComisions.forEach(function (sr) {
                  if (
                    (sr.subramo == order.form.subramo.subramo_code &&
                      sr.provider == order.form.aseguradora.id) ||
                    (sr.subramo == 0 && sr.provider == 0)
                  ) {
                    ref.comision_vendedor = 0;
                    // ref.comision_vendedor = sr.comision;
                  } else {
                    ref.comision_vendedor = 0;
                  }
                });
              }
            });
          }
          if (ref.data.url == ref.referenciador) {
            $http.get(ref.referenciador).then(function success(c) {
              if (
                c &&
                c.data &&
                c.data.user_info &&
                c.data.user_info.info_vendedor &&
                c.data.user_info.info_vendedor.length > 0
              ) {
                var subBranchsComisions =
                  c.data.user_info.info_vendedor[0].vendedor_subramos;
                subBranchsComisions.forEach(function (sr) {
                  if (
                    (sr.subramo == order.form.subramo.subramo_code &&
                      sr.provider == order.form.aseguradora.id) ||
                    (sr.subramo == 0 && sr.provider == 0)
                  ) {
                    ref.comision_vendedor = 0;
                    // ref.comision_vendedor = sr.comision;
                  } else if (
                    sr.subramo == 0 &&
                    sr.provider == 0 &&
                    sr.ramo == 0
                  ) {
                    // refs.comision_vendedor = sr.comision
                    refs.comision_vendedor = 0;
                  } else {
                    ref.comision_vendedor = ref.data.comision_policy;
                  }
                });
              }
            });
          }
        }
      }
      if (ref.referenciador) {
        $http.get(ref.referenciador).then(function success(c) {
          if (
            c &&
            c.data &&
            c.data.user_info &&
            c.data.user_info.info_vendedor &&
            c.data.user_info.info_vendedor.length > 0
          ) {
            var subBranchsComisions =
              c.data.user_info.info_vendedor[0].vendedor_subramos;
            subBranchsComisions.forEach(function (sr) {
              if (
                (sr.subramo == order.form.subramo.subramo_code &&
                  sr.provider == order.form.aseguradora.id) ||
                (sr.subramo == 0 && sr.provider == 0)
              ) {
                // ref.comision_vendedor = sr.comision;
                ref.comision_vendedor = 0;
              } else {
                ref.comision_vendedor = 0;
              }
            });
          }
        });
      }
      if (ref.referenciador) {
        ref.selectedRef = true;
      } else {
        ref.selectedRef = false;
      }
    };
    $scope.changeComRef = function (com) {
      if (com.comision_vendedor > 100) {
        com.comision_vendedor = 0;
      } else if (com.comision_vendedor < 0) {
        com.comision_vendedor = 0;
      }
      $scope.checkTotalComision(com);
    };
    $scope.checkTotalComision = function (item) {
      var totalComision = $scope.referenciadores.reduce(function (sum, item) {
        return sum + (parseFloat(item.comision_vendedor) || 0); // Convert to number, default to 0 if undefined
      }, 0);
      if (totalComision > 100) {
        $scope.comisionError =
          "La suma de las comisiones no puede superar el 100%";
        item.comision_vendedor = 0;
      } else {
        $scope.comisionError = null; // No error if total is within limit
      }
    };
    $scope.deleteReferenciador = function (index, ref) {
      SweetAlert.swal(
        {
          title: "¿Estás seguro?",
          text: "Los cambios no podrán revertirse, se eliminará de la póliza",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
            if (index && ref.url) {
              if (ref.url) {
                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: $scope.myInsurance.id,
                  identifier: "elimino un referenciador: " + ref.ref_name,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $http.delete(ref.url);
              }
              $scope.referenciadores.splice(index, 1);
            } else {
              if (ref.url) {
                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: $scope.myInsurance.id,
                  identifier: "elimino un referenciador: " + ref.ref_name,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $http.delete(ref.url);
              }
              $scope.referenciadores.splice(index, 1);
            }
          }
        }
      );
    };
    // ------- Guardar sumas aseguradas y deducibles

    $scope.show_button_save_sum = false;
    $scope.show_button_save_ded = false;

    $scope.demo = function (param) {
      var model = formatValues.currency(param);
      return model;
    };
    $scope.sucursal = function (sc) {};
    $scope.saveSum = function (parValue, parCoverage) {
      order.form.paquete.coverage_package.forEach(function (item) {
        if (item.coverage_name == parCoverage.coverage_name) {
          var url_item = item.url;
          var obj = {
            sum_insured: parValue,
            default: false,
            coverage_sum: url_item,
          };

          coverageService.createSumInsured(obj).then(function (req) {
            if (req.id) {
              $scope.result_ = false;
              parCoverage.sums_coverage.push(req);
            }
          });
        }
      });
    };

    $scope.saveDed = function (parValue, parCoverage) {
      order.form.paquete.coverage_package.forEach(function (item) {
        if (item.coverage_name == parCoverage.coverage_name) {
          var url_item = item.url;
          var obj = {
            deductible: parValue,
            default: false,
            coverage_deductible: url_item,
          };

          coverageService.createDeducible(obj).then(function (req) {
            if (req.id) {
              $scope.result_ded = false;
              parCoverage.deductible_coverage.push(req);
            }
          });
        }
      });
    };

    //------------------------------

    $scope.countFile = 0;
    $scope.okFile = 0;

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item /*{File|FileLikeObject}*/, options) { //jshint ignore:line
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      // toaster.success(MESSAGES.OK.UPLOADFILES);
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          if ($scope.param == "poliza") {
            SweetAlert.swal(MESSAGES.OK.UPGRADEPOLICY, "", "success");
          }
          if ($scope.param == "ot") {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.UPGRADEOT, "success");
          }
          $state.go("polizas.info", { polizaId: myInsurance.id });

          if ($uibModalInstance) {
            $uibModalInstance.close(200);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
        order.options.checkDate("initial");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
        order.options.checkDate("initial");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };
    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    // $scope.deleteFile = deleteFile;

    // function deleteFile(file,container) {
    //   fileService.deleteFile(file,container);
    // }

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $timeout(function () {
        $scope.uploader.uploadAll();
        saveLogFile($scope.countFile, polizaId);
      }, 1000);
    }
    /** /Uploader files */
    function saveLogFile(num, id_p) {
      if (num > 0) {
        var params = {
          model: 1,
          event: "PATCH",
          associated_id: id_p,
          identifier: " añadio " + num + " archivos a la póliza.",
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});
      }
    }
    /** Loading things **/

    function aThingIsDone(what) {
      stuffLoaded++;
      if (stuffLoaded >= thingsToLoad) {
        order.loading = false;
      }
    }

    function loadingThing(what) {
      thingsToLoad++;
      order.loading = true;
    }

    function canBeOT() {
      if (order.form.contratante) {
        return true;
      }
      SweetAlert.swal("Error", "Necesita seleccionar un contratante", "error");
      return;
      order.options.checkDate("initial");
      return false;
    }

    function canBePoliza() {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var flag = true;
      var code = parseInt(order.defaults.formInfo.code);
      if (!canBeOT()) {
        flag = false;
      }
      if (order.receipts.length == 0) {
        flag = false;
        SweetAlert.swal("Recibos", "Debe gener recibos", "error");
        l.stop();
        order.options.checkDate("initial");
      }

      if (!code) {
        flag = false;
        toaster.warning("Forma incompleta");
        order.options.checkDate("initial");
      } else if (code == 1 || code == 30) {
        //life
      } else if (code == 2 || code == 3 || code == 4) {
        //disease
        var subform = order.subforms.disease;
        if (
          subform.first_name == "" ||
          subform.last_name == "" ||
          subform.sex == "" ||
          !subform.first_name ||
          !subform.last_name ||
          !subform.sex
        ) {
          flag = false;
          // toaster.warning("Datos de formulario requerido");
          SweetAlert.swal("Error", "Datos del formulario requeridos", "error");
          l.stop();
          order.options.checkDate("initial");
        }
      } else if (
        code == 5 ||
        code == 6 ||
        code == 7 ||
        code == 8 ||
        code == 10 ||
        code == 11 ||
        code == 12 ||
        code == 13 ||
        code == 14 ||
        code === 31
      ) {
        var damage = order.subforms.damage;
        if (damage.insured_item == "" || !damage.insured_item) {
          flag = false;
          SweetAlert.swal("Error", "Datos del formulario requeridos", "error");
          l.stop();
          order.options.checkDate("initial");
        }
      } else if (code == 9) {
        // auto
      }

      // if (order.defaults.coverages.length == 0) {
      //   flag = false;
      //   SweetAlert.swal("Coberturas","Al menos una cobertura es requerida" ,"warning");
      //   l.stop()
      //   order.options.checkDate(0);
      // }
      // else {
      //   order.defaults.coverages.some(function(item) {
      //     if (item.sumInPolicy == '' || !item.sumInPolicy ) {

      //       flag = false;
      //       SweetAlert.swal("Datos coberturas","Datos de coberturas requeridos" ,"warning");
      //       l.stop()
      //       order.options.checkDate('initial');
      //     }
      //     if (code == 2 || code == 3 || code == 4 || code == 5 || code == 6 || code == 7 || code == 8 || code == 10 || code == 11 || code == 12 || code == 13 || code == 14) {
      //       if (!item.coinsuranceInPolicy || item.coinsuranceInPolicy == '') {
      //       }
      //     }
      //   });
      // }

      return flag;
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function mesDiaAnio(parDate) {
      var d = new Date(toDate(parDate));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      return date;
    }

    function convertDate(inputFormat) {
      // console.log('fecha original',inputFormat)
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d_uno = new Date(inputFormat);
      var fecha = new Date(inputFormat);
      if (fecha.getUTCHours() <= 11) {
        fecha.setHours(fecha.getHours() + 12);
      } else {
        fecha.setHours(fecha.getHours() + 5);
      }
      var d = fecha;
      // var d = new Date(inputFormat).toISOString()//prueba
      // console.log('-fecha 2',d,new Date(d.toLocaleString()))
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
      // function pad(s) { return (s < 10) ? '0' + s : s; }
      // var d = new Date(inputFormat);
      // var date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
      // return date;
    }
    // Calculadora comision referenciador
    $scope.calculateComision = function (ref, index) {
      $rootScope.comVendedor = true;
      $scope.orderInfo = order;
      $localStorage.orderForm = JSON.stringify(order.form);
      var modalInstance = $uibModal.open({
        templateUrl: "app/ordenes/calculateComision.modal.html",
        controller: OrderComisionCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          referenciador: function () {
            return ref;
          },
          index: function () {
            return index;
          },
          form: function () {
            return order.form;
          },
          from: function () {
            return null;
          },
          primaTotal: function () {
            return order.poliza.primaTotal;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };
    // Calcular comisión ppor referenciador
    function OrderComisionCtrl(
      $scope,
      from,
      $sessionStorage,
      $uibModalInstance,
      referenciador,
      index,
      form,
      $http,
      MESSAGES,
      toaster,
      primaTotal
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $rootScope.valueMonto = primaTotal;
      $rootScope.valueComInicial = 0;
      $rootScope.valueComision = 0;
      if (referenciador) {
        $http.get(referenciador.referenciador).then(function (data) {
          if (data.status == 200 || data.status == 201) {
            if (data.data) {
              $rootScope.name =
                data.data.first_name + " " + data.data.last_name;
              if (data.data.user_info) {
                if (data.data.user_info.info_vendedor[0]) {
                  $rootScope.valueGo =
                    data.data.user_info.info_vendedor[0].gastos_operacion;
                }
              }
            }
          }
        });
      }
      // Change monto --> calc comision
      $scope.changeMonto = function (go, monto, com, comI) {
        if (isNaN(monto)) {
          var toNumber = $scope.formatearNumero(monto);
          if (isNaN(toNumber)) {
            $rootScope.valueMonto = "";
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        }
      };
      $scope.comCalculatePeso = function (monto, comision) {
        if (
          isNaN(monto) ||
          isNaN(comision) ||
          parseFloat(comision) > parseFloat(monto)
        ) {
          if (parseFloat(comision) > parseFloat(monto)) {
            SweetAlert.swal(
              "Error",
              "Cantidad capturada en comisión no puede ser mayor a la prima total",
              "error"
            );
            $rootScope.valueComision = 0;
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        } else {
          $rootScope.valueComision = parseFloat(
            (parseFloat(comision) * 100) / parseFloat(monto)
          ).toFixed(2);
        }
      };
      $scope.validComision = function (comI) {
        if (isNaN(comI)) {
          $rootScope.valueComInicial = 0;
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
        }
      };
      $scope.cTotal = function (monto, com, comVendedor) {
        referenciador.comision_vendedor = comVendedor;
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.cancelCalculate = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
      $scope.formatearNumero = function (nStr) {
        nStr += "";
        var x = nStr.split(".");
        var x1 = x[0];
        var x2 = x.length > 1 ? "." + x[1] : "";
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + "," + "$2");
        }

        return x1 + x2;
      };
    }

    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("PolizasCtrl", PolizasCtrl);

  PolizasCtrl.$inject = [
    "$localStorage",
    "ContratanteService",
    "providerService",
    "packageService",
    "insuranceService",
    "coverageService",
    "receiptService",
    "$uibModal",
    "$filter",
    "toaster",
    "helpers",
    "$sessionStorage",
  ];

  function PolizasCtrl(
    $localStorage,
    ContratanteService,
    providerService,
    packageService,
    insuranceService,
    coverageService,
    receiptService,
    $uibModal,
    $filter,
    toaster,
    helpers,
    $sessionStorage
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.pageTitle = "Pólizas";
    vm.saveInsurance = saveInsurance;
    vm.openModal = openModal;

    vm.insurances = [];
    vm.hideOT = hideOT;
    vm.saveOT = saveOT;

    vm.contratante = {};
    vm.contratantes = [];
    vm.ramos = [];
    vm.subramos = [];
    vm.providers = [];
    vm.packages = [];
    vm.receipts = [];
    vm.coverages = [];
    vm.user = usr;
    vm.endorsementReceipts = [];

    $scope.sex = [
      { name: "MASCULINO", value: "M" },
      { name: "FEMENINO", value: "F" },
    ];

    vm.show = {
      ot: true,
      receipt: false,
      generateReceipts: false,
      receiptsGenerated: false,
    };

    vm.payments = [
      { name: "Mensual", code: "1" },
      { name: "Bimestral", code: "2" },
      { name: "Trimestral", code: "3" },
      { name: "Contado", code: "5" },
      { name: "Semestral", code: "6" },
      { name: "Anual", code: "12" },
    ];

    vm.form = {
      contratante: "",
      poliza: "",
      ramo: "",
      type: "",
      subramo: "",
      aseguradora: "",
      package: "",
      payment: "",
      startDate: new Date(),
      endingDate: new Date(new Date().setYear(new Date().getFullYear() + 1)),
    };

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubramo = changeSubramo;
    vm.changePackage = changePackage;
    vm.deleteCoverage = deleteCoverage;

    activate();

    function activate() {
      getInsurances();
      ContratanteService.getContratantes().then(function (data) {
        vm.contratantes = data;
      });

      providerService.getProviders().then(function (data) {
        vm.providers = data;
      });
    }

    function changeProvider(obj) {
      vm.ramos = obj.ramo_provider;
    }

    function changeRamo(obj) {
      vm.subramos = obj.subramo_ramo;
    }

    function changeSubramo(obj) {
      vm.packages = obj.package_subramo;
    }

    function changePackage(obj) {
      vm.coverages = obj.coverage_package;
    }

    function deleteCoverage(obj, index) {
      vm.coverages.splice(index, 1);
    }

    function getInsurances() {
      insuranceService.getandReadInsurances().then(function (data) {
        vm.insurances = data;
      });
    }

    function hideOT() {
      vm.show.ot = false;
      var form = angular.copy(vm.form);
      form = {
        contratante: form.contratante,
        aseguradora: form.aseguradora.url,
        ramo: form.ramo.url,
        subramo: form.subramo.url,
        paquete: form.paquete.url,
        poliza_number: form.poliza,
        start_of_validity: form.startDate,
        end_of_validity: form.endingDate,
        forma_de_pago: form.payment || null,
        status: 1,
      };
      if (form.contratante.indexOf("Fisica")) {
        form.natural = form.contratante;
        form.juridical = null;
      } else {
        form.juridical = form.contratante;
        form.natural = null;
      }

      return insuranceService
        .createInsurance(form)
        .then(function (data) {
          getInsurances();
          vm.myInsurance = data;
          toaster.success("Se ha creado una orden de trabajo");
          return data;
        })
        .then(function (data) {
          var coverages = [];
          vm.coverages.forEach(function (elem) {
            var coverage = {
              policy: data.url,
              package: data.paquete,
              coverage_name: elem.coverage_name || "",
              prima: elem.primaInPolicy || "",
            };

            if (elem.sumInPolicy === undefined) {
              coverage.sum_insured = "";
            } else {
              coverage.sum_insured = elem.sumInPolicy.sum_insured;
            }

            if (elem.deductibleInPolicy === undefined) {
              coverage.deductible = "";
            } else {
              coverage.deductible = elem.deductibleInPolicy.deductible;
            }

            coverages.push(coverage);
            coverageService.createCoberturaPoliza(coverage);
          });
        });
    }

    // TODO update before save poliza
    function saveOT() {
      ////console.log('saving OT');
    }

    // Receipt modal
    // TODO dejar visualizado los recibos despues de calcular
    function openModal() {
      vm.show.receiptsGenerated = true;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/polizas/recibos.modal.html",
        controller: ModalInstanceCtrl,
        size: "lg",
        //windowClass: 'animated fadeIn'
      });
    }

    function ModalInstanceCtrl($scope, $uibModalInstance, toaster) {
      var vmm = $scope;

      vmm.showReceipts = vm.show.receiptsGenerated;
      vmm.amountReceipts = 0;
      vmm.poliza = {
        primaNeta: 0.0,
        iva: 16,
        rpf: 0.0,
        derecho: 0,
        subTotal: 0,
        primaTotal: 0,
      };
      vm.receipts = [];
      vmm.receipts = [];

      vmm.ok = function () {
        vm.show.receipt = true;
        if ($uibModalInstance) $uibModalInstance.close();
      };

      vmm.calculate = function () {
        if (!vm.form.payment) {
          toaster.info(ERROR.CHOOSEGROUP);
        } else {
          vmm.receipts = [];
          vmm.showReceipts = true;
          var initDate = $scope.form.startDate;
          var endDate = $scope.form.endingDate;
          var months = helpers.monthDiff(initDate, endDate);
          var amountReceipts = (vmm.amountReceipts = months / vm.form.payment);
          //Calculate poliza results
          vmm.poliza.subTotal = getSubtotal(vmm.poliza);
          vmm.poliza.primaTotal = getTotal(vmm.poliza);

          var arrayLen = vmm.getNumber(amountReceipts);

          // Logic from vm
          var obj = {
            prima: vmm.poliza.primaNeta / amountReceipts,
            rpf: vmm.poliza.rpf / amountReceipts,
            derecho: vmm.poliza.derecho / amountReceipts,
            iva: vmm.poliza.iva,
            subTotal: vmm.poliza.subTotal / amountReceipts,
            primaTotal: vmm.poliza.primaTotal / amountReceipts,
          };

          for (var i = 0; i < arrayLen.length; i++) {
            // Check options
            if (vmm.configDerecho) {
              if (i === 0) {
                obj.derecho = vmm.poliza.derecho;
              } else {
                obj.derecho = 0;
              }
            }

            if (vmm.configRPF) {
              if (i === 0) {
                obj.rpf = vmm.poliza.rpf;
              } else {
                obj.rpf = 0;
              }
            }

            endDate = new Date(
              moment(initDate).add(vm.form.payment, "months").calendar()
            );

            var subTotal = obj.prima + obj.rpf + obj.derecho;
            var receipt = {
              prima: parseFloat(obj.prima.toFixed(2)),
              rpf: parseFloat(obj.rpf.toFixed(2)),
              derecho: parseFloat(obj.derecho.toFixed(2)),
              iva: 16,
              subTotal: parseFloat(subTotal.toFixed(2)),
              total: parseFloat((subTotal * 1.16).toFixed(2)),
              startDate: initDate,
              endingDate: endDate,
              // 'endingDate':  vm.form.endingDate
            };
            initDate = endDate;
            vmm.receipts.push(angular.copy(receipt));
            vm.receipts = vmm.receipts;
          }
        }
      };

      vmm.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };

      vmm.getNumber = function (num) {
        return new Array(num);
      };

      function getSubtotal(poliza) {
        var sum =
          parseFloat(poliza.primaNeta) +
          parseFloat(poliza.rpf) +
          parseFloat(poliza.derecho);
        return Number(sum.toFixed(2));
      }

      function getTotal(poliza) {
        return poliza.subTotal * 1.16;
      }
    }

    function saveInsurance() {
      vm.myInsurance.status = 1;
      vm.myInsurance.forma_de_pago = vm.form.payment;
      insuranceService.updateInsurance(vm.myInsurance).then(function (data) {
        ////console.log('this saveInsurance');
        toaster.success("Se ha creado una póliza");
        getInsurances();
        vm.receipts.forEach(function (elem, index) {
          ////console.log('my index', index);
          var receipt = {
            poliza: vm.myInsurance.url,
            recibo_numero: index + 1,
            prima_neta: elem.prima,
            rpf: elem.rpf,
            derecho: elem.derecho,
            iva: elem.iva,
            sub_total: elem.subTotal,
            prima_total: elem.total,
            status: 1,
            fecha_inicio: $filter("date")(elem.startDate, "yyyy-MM-dd"),
            fecha_fin: $filter("date")(elem.endingDate$filter, "yyyy-MM-dd"),
            receipt_type: elem.receipt_type,
            rp_owner_id: elem.rp_owner_id,
          };
          receiptService.createReceiptService(receipt).then(function (data) {
            // //console.log('Recibos creados', data);
          });
        });
      });
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("CompartirAppCtrl", CompartirAppCtrl);

  CompartirAppCtrl.$inject = [
    "$timeout",
    "FileUploader",
    "providerService",
    "dataFactory",
    "SweetAlert",
    "$scope",
    "$rootScope",
    "MESSAGES",
    "toaster",
    "endorsementService",
    "insuranceService",
    "receiptService",
    "$stateParams",
    "$state",
    "helpers",
    "formService",
    "$http",
    "url",
    "$uibModal",
    "datesFactory",
    "$q",
    "$localStorage",
    "$sessionStorage",
    "statusReceiptsFactory",
    "$sce",
    "formatValues",
    "fileService",
    "emailService",
    "appStates",
  ];

  function CompartirAppCtrl(
    $timeout,
    FileUploader,
    providerService,
    dataFactory,
    SweetAlert,
    $scope,
    $rootScope,
    MESSAGES,
    toaster,
    endorsementService,
    insuranceService,
    receiptService,
    $stateParams,
    $state,
    helpers,
    formService,
    $http,
    url,
    $uibModal,
    datesFactory,
    $q,
    $localStorage,
    $sessionStorage,
    statusReceiptsFactory,
    $sce,
    formatValues,
    fileService,
    emailService,
    appStates
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    var vm = this;
    $scope.fechasFilter = false;
    vm.pageTitle = "Pólizas";
    vm.insurance = {};
    vm.receipts = [];
    vm.search = search;
    vm.polizasContractor = polizasContractor;
    vm.polizaId = $stateParams.polizaId;
    vm.form = {
      since: convertDate(
        new Date(new Date().setMonth(new Date().getMonth() - 1))
      ),
      until: convertDate(new Date()),
    };
    vm.show = {
      isPolicy: false,
    };
    $scope.loader = false;
    vm.addFilter = addFilter;
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                vm.acceso_canc_pol = true;
              } else {
                vm.acceso_canc_pol = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                vm.acceso_elim_pol = true;
              } else {
                vm.acceso_elim_pol = false;
              }
            } else if (acc.permission_name == "Rehabilitar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_rehabilitar = true;
              } else {
                vm.acceso_adm_rehabilitar = false;
              }
            }
          });
        }
        if (perm.model_name == "Endosos") {
          $scope.acceso_endosos = perm;
          $scope.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                $scope.acceso_adm_end = true;
              } else {
                $scope.acceso_adm_end = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                vm.acceso_canc_ot = true;
              } else {
                vm.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar OTs") {
              if (acc.checked == true) {
                vm.acceso_elim_ot = true;
              } else {
                vm.acceso_elim_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Siniestros") {
          vm.acceso_sin = perm;
          vm.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                vm.acceso_adm_sin = true;
              } else {
                vm.acceso_adm_sin = false;
              }
            }
          });
        } else if (perm.model_name == "Mensajeria") {
          vm.acceso_mns = perm;
          vm.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                vm.acceso_mns = true;
              } else {
                vm.acceso_mns = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            } else if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                vm.acceso_del_cob = true;
              } else {
                vm.acceso_del_cob = false;
              }
            } else if (
              acc.permission_name ==
              "No permitir editar recibos Pagados/Liquidados"
            ) {
              if (acc.checked == true) {
                vm.acceso_pl_cob = true; //no se editan
              } else {
                vm.acceso_pl_cob = false; //se pueden editar pagados-liquidados
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          vm.acceso_ref = perm;
          vm.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                vm.acceso_adm_ref = true;
              } else {
                vm.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                vm.acceso_pag_ref = true;
              } else {
                vm.acceso_pag_ref = false;
              }
            } else if (
              acc.permission_name == "Cambiar refrenciador en pólizas"
            ) {
              if (acc.checked == true) {
                vm.acceso_chg_ref = true;
              } else {
                vm.acceso_chg_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.acceso_dash = perm;
          vm.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    vm.repeat = [];
    $scope.compartidas = false;
    activate();
    // functions
    function addFilter(param) {
      if (param == 1) {
        $scope.fechasFilter = true;
        vm.form.dates = 1;
      } else {
        $scope.fechasFilter = false;
        vm.form.dates = 2;
      }
    }
    vm.infoFlag = true;
    function activate() {
      var params = {};
      $scope.addEmail = false;
      $scope.addEmail1 = false;
      $scope.addEmail2 = false;
      $scope.addFiles = false;
      params = {
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        inicio_fin: vm.form.inicio_fin,
        dates: vm.form.dates,
        compartidas: $scope.compartidas ? $scope.compartidas : false,
      };
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      $scope.filtros = params;
      $http({
        method: "POST",
        url: url.IP + "get-contractorsList",
        data: $scope.filtros,
      })
        .then(
          function success(request) {
            console.log("request", request);
            if (request.status === 200 || request.status === 201) {
              var data = request.data.data;
              $scope.polizasshare = data;
              console.log("===>>", data);
            } else {
              toaster.warning("No se encontraron registros");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }
    function search(pkc) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.params = {
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        inicio_fin: vm.form.inicio_fin,
        dates: vm.form.dates,
        pkcontractor: pkc ? pkc.id : 0,
        compartidas: $scope.compartidas ? $scope.compartidas : false,
      };
      $scope.params.since = $scope.params.since + " " + "00:00:00";
      $scope.params.until = $scope.params.until + " " + "23:59:59";
      $scope.filtros = $scope.params;
      $http({
        method: "POST",
        url: url.IP + "get-contractorsList",
        data: $scope.filtros,
      })
        .then(
          function success(request) {
            if (request.status === 200 || request.status === 201) {
              var data = request.data;
              $scope.contractors = data.contratantes;
              console.log("===>>", data);
              l.stop();
            } else {
              toaster.warning("No se encontraron registros");
              l.stop();
            }
          },
          function error(error) {
            l.stop();
          }
        )
        .catch(function (e) {
          console.log(e);
          l.stop();
        });
    }
    function polizasContractor(pkc, selector, correo1, correo2, addFiles) {
      $scope.loader = true;
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.params = {
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        inicio_fin: vm.form.inicio_fin,
        dates: vm.form.dates,
        pkcontractor: pkc ? pkc.id : 0,
        compartidas: $scope.compartidas ? $scope.compartidas : false,
      };
      $scope.params.since = $scope.params.since + " " + "00:00:00";
      $scope.params.until = $scope.params.until + " " + "23:59:59";
      $scope.filtros = $scope.params;
      if (pkc.polizasshare) {
        if (
          selector == true ||
          selector == false ||
          correo1 == true ||
          correo1 == false ||
          correo2 == true ||
          correo2 == false ||
          addFiles == true ||
          addFiles == false
        ) {
          pkc.polizasshare.forEach(function (con) {
            con[con.id] = {
              principal: selector,
              correo1: correo1,
              correo2: correo2,
              files: addFiles,
            };
          });
        }
      }
      l.stop();
      $scope.loader = false;
      return pkc;
      // $http({
      //   method: 'POST',
      //   url: url.IP + 'listaPolizasShare',
      //   data: $scope.filtros
      // })
      // .then(
      //   function success(request) {
      //     if((request.status === 200 || request.status === 201) && request.data.data.length) {
      //       var data = request.data.data;
      //       $scope.polizasshare =data;
      //       pkc.polizasshare =data;
      //       if (pkc.polizasshare) {
      //         if ((selector == true || selector ==false) || (correo1 == true || correo1 ==false) || (correo2 == true || correo2 ==false) || (addFiles == true || addFiles ==false)) {
      //           pkc.polizasshare.forEach(function(con) {
      //             con[con.id]={principal:selector,correo1:correo1,correo2:correo2,files:addFiles}
      //           })
      //         }
      //         // if (correo1 == true || correo1 ==false) {
      //         //   pkc.polizasshare.forEach(function(con) {
      //         //     con[con.id]={correo1:correo1}
      //         //   })
      //         // }
      //         // if (correo2 == true || correo2 ==false) {
      //         //   pkc.polizasshare.forEach(function(con) {
      //         //     con[con.id]={correo2:correo2}
      //         //   })
      //         // }
      //         // if (addFiles == true || addFiles ==false) {
      //         //   pkc.polizasshare.forEach(function(con) {
      //         //     con[con.id]={files:addFiles}
      //         //   })
      //         // }
      //       }
      //       l.stop();
      //       return pkc;
      //     } else {
      //       toaster.warning("No se encontraron registros");
      //       l.stop();
      //     }
      //   },
      //   function error(error) {
      //     l.stop();
      //   }
      // )
      // .catch(function(e){
      //     console.log(e);
      //     l.stop();
      // });
    }

    $scope.dataShare = [];
    $scope.sharetoemail = function (poliza, sh, nu) {
      if (poliza) {
        $scope.contractors.forEach(function (contrac, index) {
          if (contrac.id == poliza.contractor.id) {
            sh.id = poliza.id;
            $scope.dataShare.push(sh);
          }
        });
      } else {
      }
    };
    $scope.shareToPrincipal = function (
      poliza,
      addEmail,
      addEmail1,
      addEmail2,
      addFiles
    ) {
      $scope.addEmail = addEmail;
      $scope.addEmail1 = addEmail1;
      $scope.addEmail2 = addEmail2;
      $scope.addFiles = addFiles;
      $scope.loader = true;
      if (poliza) {
        poliza.forEach(function (contrac, index) {
          if (contrac.polizasshare) {
            if (
              addEmail == true ||
              addEmail == false ||
              addEmail1 == true ||
              addEmail1 == false ||
              addEmail2 == true ||
              addEmail2 == false ||
              addFiles == true ||
              addFiles == false
            ) {
              contrac.polizasshare.forEach(function (con) {
                con[con.id] = {
                  principal: addEmail,
                  correo1: addEmail1,
                  correo2: addEmail2,
                  files: addFiles,
                };
              });
            }
          }
        });
        $scope.loader = false;
      } else {
        $scope.loader = false;
      }
    };
    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }
    $scope.dataShare = [];
    $scope.compartir_app = function (polizas) {
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      try {
        polizas.forEach(function (index, contrac) {
          if (index.polizasshare) {
            index.polizasshare.forEach(function (x, pl) {
              x[x.id].id = x.id;
              if ($scope.dataShare) {
                $scope.dataShare.push(x[x.id]);
              }
            });
          }
        });
      } catch (e) {
        console.log("-eeeroror--", e);
        l.stop();
      }
      console.log("s.sssssss", $scope.dataShare);
      if ($scope.dataShare) {
        $scope.filtros.polizas = $scope.dataShare;
        $http({
          method: "POST",
          url: url.IP + "compartir-a-app/",
          data: $scope.filtros,
        })
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                var data = request.data.data;
                $scope.contractors = [];
                SweetAlert.swal(
                  "¡Listo!",
                  "Las pólizas han sido compartidas",
                  "success"
                );
                l.stop();
              } else {
                toaster.warning("No se encontraron registros");
                l.stop();
              }
            },
            function error(error) {
              l.stop();
            }
          )
          .catch(function (e) {
            console.log(e);
            l.stop();
          });
      }
    };
    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function mesDiaAnio(parDate) {
      var d = new Date(toDate(parDate));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      return date;
    }
  }
})();

(function () {
  angular.module("inspinia").factory("pdfService", pdfService);

  pdfService.$inject = [
    "$q",
    "$http",
    "url",
    "toaster",
    "insuranceService",
    "$localStorage",
    "$sessionStorage",
  ];

  function getDate() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + yyyy;
    return today;
  }

  function formatDate(cadena) {
    var year = cadena.getFullYear();
    var month = cadena.getMonth();
    var day = cadena.getDay();
    if (day < 10) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return day + "/" + month + "/" + year;
  }

  function formatDate2(cadena) {
    var datePart = cadena.split("-");
    var year = datePart[0];
    var month = datePart[1];
    var day = datePart[2];

    return day + "/" + month + "/" + year;
  }

  function asMoney(n, currency) {
    return (
      currency +
      " " +
      n.toFixed(2).replace(/./g, function (c, i, a) {
        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
      })
    );
  }

  function getSizeImage(url) {
    var w;
    var h;
    var img = new Image();
    img.src = url;
    img.onload = function () {
      w = this.width;
      h = this.height;
    };
    return { w: w, h: h };
  }

  function loadImage(imgSrc, callback) {
    var image = new Image();
    image.src = imgSrc;
    if (image.complete) {
      callback(image);
      image.onload = function () {};
    } else {
      image.onload = function () {
        callback(image);
        // clear onLoad, IE behaves erratically with animated gifs otherwise
        image.onload = function () {};
      };
      image.onerror = function () {
        alert("Could not load image.");
      };
    }
  }

  function getHeight(length, ratio) {
    var height = length / Math.sqrt(Math.pow(ratio, 2) + 1);
    return Math.round(height);
  }

  function getWidth(length, ratio) {
    var width = length / Math.sqrt(1 / (Math.pow(ratio, 2) + 1));
    return Math.round(width);
  }

  function getBase64Image(img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  function toDataUrl(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.responseType = "blob";
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.send();
  }

  function pdfService(
    $q,
    $http,
    url,
    toaster,
    insuranceService,
    $localStorage,
    $sessionStorage
  ) {
    var service = {
      getPdf: getPdf,
      pageSize: "LETTER",
      getPdfContent: getPdfContent,
      makePdf: makePdf,
    };
    return service;

    function getPdf(input) {
      getOt(input)
        .catch(function (error) {
          toaster.error(error);
        })
        .then(function (insuranceData) {
          var wait = $q.defer();

          var defaultText = "______________________________________";
          var contratanteData = insuranceData.natural
            ? {
                nombre:
                  insuranceData.natural.first_name +
                  " " +
                  insuranceData.natural.last_name,
                grupo: insuranceData.natural.group.group_name,
                type: 1,
                estado: defaultText,
                ciudad: insuranceData.ciudad,
                domicilio: defaultText,
                codigo_postal: defaultText,
                //contacto :  insuranceData.juridical.group.juridical_group.contact_juridical,
                forma_pago: defaultText,
                correo: defaultText,
                rfc: insuranceData.natural.rfc,
                telefono: defaultText,
                direcciones: insuranceData.natural.address_natural,
              }
            : insuranceData.juridical
            ? {
                nombre: insuranceData.juridical.j_name,
                grupo: insuranceData.juridical.group.group_name,
                type: 2,
                estado: defaultText,
                ciudad: insuranceData.ciudad,
                domicilio: defaultText,
                codigo_postal: defaultText,
                correo: defaultText,
                rfc: insuranceData.juridical.rfc,
                telefono: defaultText,
                direcciones: insuranceData.juridical.address_juridical,
              }
            : {
                nombre: "",
                grupo: "",
                type: 0,
                estado: defaultText,
                ciudad: defaultText,
                domicilio: defaultText,
                correo: defaultText,
                telefono: defaultText,
              };

          var requests = [];
          //return;
          // EN ORDEN!!
          if (contratanteData.type === 1) {
            // NATURAL
            if (insuranceData.natural.contact_natural) {
              var contact = insuranceData.natural.contact_natural[0]; // PRIMER CONTACTO
              contratanteData.contacto = contact.name;
              contratanteData.correo = contact.email;
              contratanteData.telefono = contact.phone_number;
            }
          } else if (contratanteData.type === 2) {
            // JURIDICAL

            if (insuranceData.juridical.contact_juridical.length > 0) {
              var contact = insuranceData.juridical.contact_juridical[0]; // PRIMER CONTACTO
              contratanteData.contacto = contact.name;
              contratanteData.correo = contact.email;
              contratanteData.telefono = contact.phone_number;
            }
          }
          address = insuranceData.address;
          contratanteData.ciudad = address.administrative_area_level_2;
          contratanteData.estado = address.administrative_area_level_1;
          var existsIntNum = address.street_number_int
            ? " Int. " + address.street_number_int
            : "";
          contratanteData.domicilio =
            address.route + " #" + address.street_number + existsIntNum;
          contratanteData.codigo_postal = address.postal_code;

          var subformData =
            insuranceData.damages_policy.length > 0
              ? {
                  code: 1,
                  campos:
                    insuranceData.damages_policy[
                      insuranceData.damages_policy.length - 1
                    ],
                }
              : insuranceData.accidents_policy.length > 0
              ? {
                  code: 2,
                  campos:
                    insuranceData.accidents_policy[
                      insuranceData.accidents_policy.length - 1
                    ],
                }
              : insuranceData.life_policy.length > 0
              ? {
                  code: 3,
                  campos:
                    insuranceData.life_policy[
                      insuranceData.life_policy.length - 1
                    ],
                }
              : insuranceData.automobiles_policy.length > 0
              ? {
                  code: 4,
                  campos:
                    insuranceData.automobiles_policy[
                      insuranceData.automobiles_policy.length - 1
                    ],
                }
              : { code: 0, campos: [] };

          // wait.promise.then(function(){
          var logo;

          var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
          var usr = JSON.parse(decryptedUser);

          $http({
            method: "POST",
            url: "https://test_cas.miurabox.info/us-login",
            // url: 'http://localhost:9000/us-login',
            // url: 'https://testcas.miurabox.com/us-login',
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/x-www-form-urlencoded",
            },
            data:
              "username=" +
              encodeURIComponent("") +
              "&password=" +
              encodeURIComponent("") +
              "&org=" +
              usr.org,
          }).then(function (data) {
            if (data.status == 200) {
              if (data.data.orgname.length == 0) {
                var url_aux = "../../assets/images/logos/saam_small.png";
              } else {
                var url_aux =
                  "https://test_cas.miurabox.com/media/" + data.data.orgname;
                // var url_aux= 'http://127.0.0.1:9000/media/'+data.data.orgname;
                // var url_aux= 'https://testcas.miurabox.com/media/'+data.data.orgname;
              }
            } else {
              var url_aux = "../../assets/images/logos/saam_small.png";
            }
            var rawrContent = {
              logo1: url_aux,
              //logo2: '../assets/logos/zyGpSw0lKOV1SoPe.png',
              logoMiura: "../../assets/images/logos/miurafaviconblack.png",
              contratante: contratanteData.nombre,
              domicilio: contratanteData.domicilio,
              codigo_postal: contratanteData.codigo_postal,
              estado: contratanteData.estado,
              ciudad: contratanteData.ciudad,
              contacto: contratanteData.contacto,
              correo: contratanteData.correo,
              telefono: contratanteData.telefono,
              rfc: contratanteData.rfc,
              grupo: contratanteData.grupo,
              //Movimiento
              vigenciaDe: new Date(insuranceData.start_of_validity),
              vigenciaA: new Date(insuranceData.end_of_validity),
              ramo: insuranceData.ramo.ramo_name,
              subramo: insuranceData.subramo.subramo_name,
              aseguradora: insuranceData.aseguradora.compania,
              folio_interno: insuranceData.internal_number,
              forma: subformData,
              forma_pago: insuranceData.forma_de_pago,
              plan_paquete: insuranceData.paquete,
              creadaEl: insuranceData.created_at,
              contactoAseg: insuranceData.aseguradora.contact_provider[0]
                ? insuranceData.aseguradora.contact_provider[0]
                : "",
              clave: insuranceData.clave,
              coberturas: insuranceData.coverageInPolicy_policy,
              asegurado: "--Aqui el nombre del asegurado--",
              observaciones: insuranceData.observations,
            };

            makePdf(rawrContent, {
              insuranceData: insuranceData,
              open: input.open,
            });
          });

          // });
        });
    } //content

    function getOt(object) {
      var dfd = $q.defer();

      if (!isNaN(object)) {
        $http
          .get(url.IP + "leer-polizas/" + object + "/")
          .catch(function (error) {
            dfd.reject(error);
          })
          .then(function (responseData) {
            insuranceService
              .getInsuranceData(responseData.data)
              .catch(function (error) {
                dfd.reject(error);
              })
              .then(function (insuranceData) {
                dfd.resolve(insuranceData);
              });
          });
      } else {
        if (object.insuranceData) {
          dfd.resolve(object.insuranceData);
        } else {
          insuranceService
            .getInsuranceData(object)
            .catch(function (error) {
              dfd.reject(error);
            })
            .then(function (insuranceData) {
              dfd.resolve(insuranceData);
            });
        }
      }
      return dfd.promise;
    }

    function makePdf(raw, input) {
      getPdfContent(raw)
        .then(function (content) {
          if (input.open) {
            try {
              pdfMake.createPdf(content).open();
            } catch (e) {
              pdfMake
                .createPdf(content)
                .download(input.insuranceData.internal_number + ".pdf");
            }
          } else {
            pdfMake
              .createPdf(content)
              .download(input.insuranceData.internal_number + ".pdf");
          }
        })
        .catch(function (error) {});
    }

    function getPdfContent(raw) {
      var dfd = $q.defer(); // promesa
      var imgsPromises = []; // lista de promesas de imagenes a cargar
      var labelwidth = 140;
      var styles = {
        info: {
          fontSize: 10,
        },
        header: {
          fontSize: 16.5,
          bold: true,
          alignment: "center",
        },
        subheader: {
          fontSize: 11.5,
          bold: true,
          alignment: "center",
        },
        tableHeader: {
          bold: true,
          fontSize: 10,
          color: "black",
        },
        quote: {
          italics: true,
        },
        small: {
          fontSize: 8,
        },
        footer: {
          italics: true,
          fontSize: 8,
          color: "gray",
        },
        address: {
          fontSize: 6,
        },
        summaryStyle: {
          fontSize: 10,
          alignment: "justify",
          margin: [10, 10, 0, 10],
        },
        label: {
          fontSize: 10,
          bold: true,
          width: 100,
        },
        th: {
          bold: true,
          fontSize: 10,
          color: "black",
          //width: "*"
        },
        td: {
          fontSize: 10,
        },
      };

      function showPhoneNumber(recibe) {
        var afterPlus = recibe.substr(1, 1);
        var dial, phone, ext, quit;
        if (afterPlus == 1) {
          dial = recibe.substr(0, 2);
          phone = recibe.substr(2, 10);
          quit = recibe.length - 12;
          ext = recibe.substr(-quit);
        } else {
          dial = recibe.substr(0, 3);
          phone = recibe.substr(3, 10);
          quit = recibe.length - 13;
          ext = recibe.substr(-quit);
        }
        return dial + " " + phone + " ext. " + ext;
      }

      var finalWidth, finalHeight;
      function alertImageSize(image) {
        if (image.width > image.height) {
          var maxWidth = 100,
            maxHeight = 39;
          if (image.width > maxWidth) {
            //ratio = maxWidth / image.width;
            ratio = Math.min(maxWidth / image.width, maxHeight / image.height);
            finalWidth = image.width * ratio;
            //finalHeight =  image.height * ratio / 2 - 10;
            finalHeight = finalHeight * ratio;
          }
        }
        if (image.width < image.height) {
          var maxWidth = 100,
            maxHeight = 39;
          if (image.height > maxHeight) {
            ratio = maxHeight / image.height;
            finalHeight = maxHeight;
            finalWidth = image.width * ratio;
          }
        }
        if (image.width == image.height) {
          finalHeight = 39;
          finalWidth = 39;
        }
      }
      loadImage(raw.logo1, alertImageSize);

      var imgObj, imgLogo, aux, upColumns;
      if (raw.logo1) {
        imgsPromises.push(getBase64FromImageUrl(raw.logo1, "logo1"));
      }
      if (raw.logo2) {
        imgsPromises.push(getBase64FromImageUrl(raw.logo2, "logo2"));
      }
      if (raw.logoMiura) {
        imgsPromises.push(getBase64FromImageUrl(raw.logoMiura, "logoMiura"));
      }
      if (imgsPromises.length > 0) {
        $q.all(imgsPromises).then(function (data) {
          data.forEach(function (response) {
            if (response.id == "logoMiura") {
              aux = response.data;
            }
            if (response.id == "logo1") {
              imgObj = {
                image: response.data,
                height: finalHeight,
                width: finalWidth, //maxHeight: 60, maxWidth: 80,
                alignment: "center",
              };
              upColumns = {
                columnGap: 15,
                columns: [
                  imgObj,
                  {
                    text: [
                      { text: usr.orgname, style: "header" },
                      {
                        text: "\nSolicitud de Póliza - " + raw.subramo + "\n",
                        fontSize: 14.5,
                        alignment: "center",
                      },
                    ],
                  },
                ],
              };
              content.splice(0, 0, upColumns);
            }
          });
        });
      }

      var content = [
        {
          text: [{ text: "\nCOMPAÑÍA", style: "subheader" }],
        },
        {
          text: [{ text: raw.aseguradora, alignment: "center" }],
        },
        {
          table: {
            widths: ["7.5%", "46%", "5%", "41.5%"],
            body: [
              [
                { text: " ", fontSize: 6 },
                { text: " ", fontSize: 6 },
                { text: " ", fontSize: 6 },
                { text: " ", fontSize: 6 },
              ],
              //[{ text: '' },{ text: '' },{ text: '' },{ text: '' }],
              [
                { text: "Ejecutivo:", style: "tableHeader" },
                {
                  text: raw.contactoAseg.name
                    ? raw.contactoAseg.name
                    : "Aún no se ha asignado",
                  style: "info",
                },
                { text: "Clave:", style: "tableHeader" },
                { text: raw.clave ? raw.clave.clave : "", style: "info" },
              ],
              [
                { text: "Teléfono:", style: "tableHeader" },
                {
                  text: raw.contactoAseg.phone_number
                    ? showPhoneNumber(raw.contactoAseg.phone_number)
                    : "Aún no se ha asignado",
                  style: "info",
                },
                { text: "Correo:", style: "tableHeader" },
                {
                  text: raw.contactoAseg.email
                    ? raw.contactoAseg.email
                    : "Aún no se ha asignado",
                  style: "info",
                },
              ],
            ],
          },
          layout: "lightHorizontalLines",
        },
        {
          text: [{ text: "\nDATOS DEL CONTRATANTE\n", style: "subheader" }],
        },
        {
          table: {
            widths: ["10.5%", "51%", "8.5%", "30%"],
            body: [
              [
                { text: " ", fontSize: 1.5 },
                { text: " ", fontSize: 1.5 },
                { text: " ", fontSize: 1.5 },
                { text: " ", fontSize: 1.5 },
              ],
              [
                { text: "Contratante:", style: "tableHeader" },
                {
                  text: [raw.contratante ? raw.contratante : ""],
                  style: "info",
                },
                { text: "RFC:", style: "tableHeader", alignment: "right" },
                { text: raw.rfc, style: "info" },
              ],
              [
                { text: "Domicilio:", style: "tableHeader" },
                { text: [raw.domicilio ? raw.domicilio : ""], style: "info" },
                { text: "C.P.:", style: "tableHeader", alignment: "right" },
                {
                  text: [raw.codigo_postal ? raw.codigo_postal : ""],
                  style: "info",
                },
              ],
              [
                { text: "Estado:", style: "tableHeader" },
                { text: [raw.estado ? raw.estado : ""], style: "info" },
                {
                  text: "Municipio:",
                  style: "tableHeader",
                  alignment: "right",
                },
                { text: [raw.ciudad ? raw.ciudad : ""], style: "info" },
              ],
            ],
          },
          layout: "lightHorizontalLines",
        },
        {
          text: "\nDATOS DE LA PÓLIZA\n",
          style: "subheader",
        },
        {
          table: {
            widths: ["15.2%", "43%", "11.5%", "30.3%"],
            body: [
              [
                { text: " ", fontSize: 1.5 },
                { text: " ", fontSize: 1.5 },
                { text: " ", fontSize: 1.5 },
                { text: " ", fontSize: 1.5 },
              ],
              [
                { text: "Plan/Paquete:", style: "tableHeader" },
                { text: [raw.plan_paquete.package_name], style: "info" },
                { text: "F. Creación:", style: "tableHeader" },
                {
                  text: formatDate2(raw.creadaEl.split("T")[0]),
                  style: "info",
                },
              ],
              [
                { text: "Forma de Pago:", style: "tableHeader" },
                {
                  text:
                    raw.forma_pago.value == 1
                      ? "Mensual"
                      : raw.forma_pago.value == 2
                      ? "Bimestral"
                      : raw.forma_pago.value == 3
                      ? "Trimestral"
                      : raw.forma_pago.value == 6
                      ? "Semestral"
                      : raw.forma_pago.value == 12
                      ? "Anual"
                      : "No pago",
                  style: "info",
                },
                { text: "Vigencia:", style: "tableHeader" },
                {
                  text:
                    formatDate(raw.vigenciaDe) +
                    " - " +
                    formatDate(raw.vigenciaA),
                  style: "info",
                },
              ],
            ],
          },
          layout: "lightHorizontalLines",
        },
      ];

      // coberturas
      var coveragesTable;
      if (raw.forma.code == 1) {
        coveragesTable = {
          table: {
            widths: ["51%", "17%", "16%", "16%"],
            headerRows: 1,
            body: [
              // TODO agregar coaseguro dependiendo del codigo
              [
                [{ text: "Cobertura", style: "th" }],
                [{ text: "Suma Asegurada", style: "th" }],
                [{ text: "Deducible", style: "th" }],
                [{ text: "Coaseguro", style: "th" }],
                // [{ text : 'Prima'             , style: 'th'}],
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === node.table.body.length ? 0.5 : 0.5;
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 0.5 : 0.5;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === node.table.body.length
                ? "black"
                : "black";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "black"
                : "black";
            },
          },
        };
      } else if (raw.forma.code == 2) {
        coveragesTable = {
          table: {
            widths: ["40%", "20%", "20%", "20%"],
            headerRows: 1,
            body: [
              [
                [{ text: "Cobertura", style: "th" }],
                [{ text: "Suma Asegurada", style: "th" }],
                [{ text: "Deducible", style: "th" }],
                [{ text: "Coaseguro", style: "th" }],
                //  [{ text : 'Prima'             , style: 'th'}],
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === node.table.body.length ? 0.5 : 0.5;
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 0.5 : 0.5;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === node.table.body.length
                ? "black"
                : "black";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "black"
                : "black";
            },
          },
        };
      } else {
        coveragesTable = {
          table: {
            widths: ["60%", "20%", "20%"],
            headerRows: 1,
            body: [
              [
                [{ text: "Cobertura", style: "th" }],
                [{ text: "Suma Asegurada", style: "th" }],
                [{ text: "Deducible", style: "th" }],
                // [{ text : 'Coaseguro'         , style: 'th'}],
                //  [{ text : 'Prima'             , style: 'th'}],
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === node.table.body.length ? 0.5 : 0.5;
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 0.5 : 0.5;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === node.table.body.length
                ? "black"
                : "black";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "black"
                : "black";
            },
          },
        };
      }

      raw.coberturas.forEach(function (cobertura) {
        // coaseguro
        if (raw.forma.code == 1) {
          coveragesTable.table.body.push([
            { text: cobertura.coverage_name, style: "td" },
            {
              text:
                cobertura.sum_insured.length != 0
                  ? !isNaN(cobertura.sum_insured)
                    ? asMoney(parseFloat(cobertura.sum_insured), "$")
                    : cobertura.sum_insureda
                  : "",
              style: "td",
              alignment: "right",
            },
            {
              text:
                cobertura.deductible.length != 0
                  ? !isNaN(cobertura.deductible)
                    ? asMoney(parseFloat(cobertura.deductible), "$")
                    : cobertura.deductible
                  : "",
              style: "td",
              alignment: "right",
            },
            // { text : cobertura.coinsurance.length!=0 ? !isNaN(cobertura.coinsurance) ? asMoney(parseFloat(cobertura.coinsurance), "$") : cobertura.coinsurance : '', style: 'td', alignment: 'right'},
            // { text : cobertura.prima.length!=0 ? !isNaN(cobertura.prima) ? asMoney(parseFloat(cobertura.prima), "$") : cobertura.prima : '', style: 'td', alignment: 'right'},
          ]);
        } else if (raw.forma.code == 2) {
          coveragesTable.table.body.push([
            { text: cobertura.coverage_name, style: "td" },
            {
              text:
                cobertura.sum_insured.length != 0
                  ? !isNaN(cobertura.sum_insured)
                    ? asMoney(parseFloat(cobertura.sum_insured), "$")
                    : cobertura.sum_insureda
                  : "",
              style: "td",
              alignment: "right",
            },
            {
              text:
                cobertura.deductible.length != 0
                  ? !isNaN(cobertura.deductible)
                    ? asMoney(parseFloat(cobertura.deductible), "$")
                    : cobertura.deductible
                  : "",
              style: "td",
              alignment: "right",
            },
            {
              text:
                cobertura.coinsurance.length != 0
                  ? !isNaN(cobertura.coinsurance)
                    ? asMoney(parseFloat(cobertura.coinsurance), "$")
                    : cobertura.coinsurance
                  : "",
              style: "td",
              alignment: "right",
            },
            // { text : cobertura.prima.length!=0 ? !isNaN(cobertura.prima) ? asMoney(parseFloat(cobertura.prima), "$") : cobertura.prima : '', style: 'td', alignment: 'right'},
          ]);
        } else {
          coveragesTable.table.body.push([
            { text: cobertura.coverage_name, style: "td" },
            {
              text:
                cobertura.sum_insured.length != 0
                  ? !isNaN(cobertura.sum_insured)
                    ? asMoney(parseFloat(cobertura.sum_insured), "$")
                    : cobertura.sum_insured
                  : "",
              style: "td",
              alignment: "right",
            },
            {
              text:
                cobertura.deductible.length != 0
                  ? !isNaN(cobertura.deductible)
                    ? asMoney(parseFloat(cobertura.deductible), "$")
                    : cobertura.deductible
                  : "",
              style: "td",
              alignment: "right",
            },
            // { text : cobertura.coinsurance.length!=0 ? !isNaN(cobertura.coinsurance) ? asMoney(parseFloat(cobertura.coinsurance), "$") : cobertura.coinsurance : '', style: 'td', alignment: 'right'},
            // { text : cobertura.prima.length!=0 ? !isNaN(cobertura.prima) ? asMoney(parseFloat(cobertura.prima), "$") : cobertura.prima : '', style: 'td', alignment: 'right'},
          ]);
        }
      });

      //TODO parseo de formas
      // 1 danios, 2 accidentes, 3 vida, 4 automoviles. 5 salud
      var forma = [{ text: "No existe una forma valida" }];
      if (raw.forma.code == 1) {
        // damages
        forma = [
          {
            table: {
              widths: ["15.7%", "84.3%", "0%", "0%"],
              headerRows: 1,
              body: [
                //[{ text: ' ' },{ text: ' ' },{ text: ' ' },{ text: ' ' }],
                [{ text: "" }, { text: "" }, { text: "" }, { text: "" }],
                [
                  { text: "Bien asegurado:", style: "tableHeader" },
                  {
                    text: [raw.forma.campos.insured_item],
                    style: "info",
                    colSpan: 3,
                  },
                  {},
                  {},
                ],
                [
                  { text: "Detalles:", style: "tableHeader" },
                  {
                    text: [raw.forma.campos.item_details],
                    style: "info",
                    colSpan: 3,
                  },
                  {},
                  {},
                ],
                [
                  { text: "Dirección:", style: "tableHeader" },
                  {
                    text: [raw.forma.campos.item_address],
                    style: "info",
                    colSpan: 3,
                  },
                  {},
                  {},
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];
      } else if (raw.forma.code == 2) {
        // accidents and health
        var tablaBeneficiarios = {
          table: {
            widths: ["25%", "21%", "20.5%", "11.5%", "12%", "10%"],
            body: [
              [
                [{ text: "Nombre", style: "th" }],
                [{ text: "Ap. Paterno", style: "th" }],
                [{ text: "Ap. Materno", style: "th" }],
                [{ text: "F. de Nac.", style: "th" }],
                [{ text: "Relación", style: "th" }],
                [{ text: "Sexo", style: "th" }],
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === node.table.body.length ? 0.5 : 0.5;
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 0.5 : 0.5;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === node.table.body.length
                ? "black"
                : "black";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "black"
                : "black";
            },
          },
        };

        tablaBeneficiarios.table.body.push([
          [{ text: raw.forma.campos.personal.first_name, style: "td" }],
          [{ text: raw.forma.campos.personal.last_name, style: "td" }],
          [{ text: raw.forma.campos.personal.second_last_name, style: "td" }],
          [
            {
              text: raw.forma.campos.personal.birthdate
                ? formatDate2(raw.forma.campos.personal.birthdate.split("T")[0])
                : "Ivalid date",
              style: "td",
            },
          ],
          [{ text: "Titular", style: "td" }],
          [
            {
              text:
                raw.forma.campos.personal.sex == "M"
                  ? "Masculino"
                  : raw.forma.campos.personal.sex == "F"
                  ? "Femenino"
                  : "No proporcionado",
              style: "td",
            },
          ],
        ]);

        raw.forma.campos.relationship_accident.forEach(function (ben) {
          tablaBeneficiarios.table.body.push([
            [{ text: ben.first_name, style: "td" }],
            [{ text: ben.last_name, style: "td" }],
            [{ text: ben.second_last_name, style: "td" }],
            [{ text: formatDate2(ben.birthdate.split("T")[0]), style: "td" }],
            [
              {
                text:
                  ben.relationship == 1
                    ? "Titular"
                    : ben.relationship == 2
                    ? "Cónyuge"
                    : ben.relationship == 3
                    ? "Hijo"
                    : "",
                style: "td",
              },
            ],
            [
              {
                text:
                  ben.sex == "M"
                    ? "Masculino"
                    : ben.sex == "F"
                    ? "Femenino"
                    : "No proporcionado",
                style: "td",
              },
            ],
          ]);
        });

        forma = [];

        //if(raw.forma.campos.relationship_accident.length > 0){
        forma.push("\n");
        forma.push({ text: "Asegurados", bold: true, fontSize: 11 });
        forma.push(tablaBeneficiarios);
        //}
      } else if (raw.forma.code == 3) {
        // life
        var tablaBeneficiarios = {
          table: {
            widths: ["20%", "20%", "20%", "14%", "11%", "10%", "5%"],
            body: [
              [
                [{ text: "Nombre", style: "th" }],
                [{ text: "Ap. Paterno", style: "th" }],
                [{ text: "Ap. Materno", style: "th" }],
                [{ text: "F. de Nac.", style: "th" }],
                [{ text: "Relación", style: "th" }],
                [{ text: "Sexo", style: "th" }],
                [{ text: "%", style: "th" }],
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === node.table.body.length ? 0.5 : 0.5;
            },
            vLineWidth: function (i, node) {
              return i === 0 || i === node.table.widths.length ? 0.5 : 0.5;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === node.table.body.length
                ? "black"
                : "black";
            },
            vLineColor: function (i, node) {
              return i === 0 || i === node.table.widths.length
                ? "black"
                : "black";
            },
          },
        };

        raw.forma.campos.beneficiaries_life.forEach(function (ben) {
          tablaBeneficiarios.table.body.push([
            [{ text: ben.first_name, style: "td" }],
            [{ text: ben.last_name, style: "td" }],
            [{ text: ben.second_last_name, style: "td" }],
            [{ text: formatDate2(ben.birthdate.split("T")[0]), style: "td" }],
            [{ text: ben.optional_relationship, style: "td" }],
            [
              {
                text:
                  ben.sex == "M"
                    ? "Masculino"
                    : ben.sex == "F"
                    ? "Femenino"
                    : "No proporcionado",
                style: "td",
              },
            ],
            [{ text: ben.percentage + "", style: "td" }],
          ]);
        });

        forma = [
          {
            table: {
              //widths: ['50%', '50%'],
              widths: ["13%", "34%", "13%", "20%", "13%", "7%"],
              body: [
                [
                  { text: "" },
                  { text: "" },
                  { text: "" },
                  { text: "" },
                  { text: "" },
                  { text: "" },
                ],
                [
                  { text: "Asegurado:", style: "tableHeader" },
                  {
                    text: [
                      raw.forma.campos.personal.first_name,
                      " ",
                      raw.forma.campos.personal.last_name,
                      " ",
                      raw.forma.campos.personal.second_last_name,
                    ],
                    style: "info",
                    colSpan: 5,
                  },
                  {},
                  {},
                  {},
                  {},
                ],
                [
                  { text: "Sexo:", style: "tableHeader" },
                  {
                    text: [
                      raw.forma.campos.personal.sex == "M"
                        ? "Masculino"
                        : "Femenino",
                    ],
                    style: "info",
                  },
                  { text: "F. de Nac.:", style: "tableHeader" },
                  {
                    text: formatDate2(
                      raw.forma.campos.personal.birthdate.split("T")[0]
                    ),
                    style: "info",
                  },
                  { text: "Fumador:", style: "tableHeader" },
                  {
                    text: [raw.forma.campos.smoker ? "Si" : "No"],
                    style: "info",
                  },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        if (raw.forma.campos.beneficiaries_life.length > 0) {
          forma.push("\n");
          forma.push({ text: "Asegurados ", bold: true, fontSize: 11 });
          forma.push(tablaBeneficiarios);
        }
      } else if (raw.forma.code == 4) {
        // autos
        forma = [
          {
            table: {
              headerRows: 1,
              widths: ["10%", "24%", "10%", "23%", "10%", "23%"],
              body: [
                [
                  { text: "" },
                  { text: "" },
                  { text: "" },
                  { text: "" },
                  { text: "" },
                  { text: "" },
                ],
                [
                  { text: "Marca:", style: "tableHeader" },
                  {
                    text: [
                      raw.forma.campos.brand ? raw.forma.campos.brand : "",
                    ],
                    style: "info",
                  },
                  { text: "Modelo:", style: "tableHeader" },
                  {
                    text: [
                      raw.forma.campos.model ? raw.forma.campos.model : "",
                    ],
                    style: "info",
                  },
                  { text: "Año:", style: "tableHeader" },
                  {
                    text: [
                      raw.forma.campos.year
                        ? raw.forma.campos.year.toString()
                        : "",
                    ],
                    style: "info",
                  },
                ],

                [
                  { text: "Version:", style: "tableHeader" },
                  {
                    text: [
                      raw.forma.campos.version ? raw.forma.campos.version : "",
                    ],
                    style: "info",
                  },
                  { text: "Serie:", style: "tableHeader" },
                  {
                    text: [
                      raw.forma.campos.serial ? raw.forma.campos.serial : "",
                    ],
                    style: "info",
                  },
                  { text: "Motor:", style: "tableHeader" },
                  {
                    text: [
                      raw.forma.campos.engine ? raw.forma.campos.engine : "",
                    ],
                    style: "info",
                  },
                ],

                [
                  { text: "Color:", style: "tableHeader" },
                  {
                    text: [
                      raw.forma.campos.color ? raw.forma.campos.color : "",
                    ],
                    style: "info",
                  },
                  { text: "Placas:", style: "tableHeader" },
                  {
                    text: [
                      raw.forma.campos.license_plates
                        ? raw.forma.campos.license_plates
                        : "",
                    ],
                    style: "info",
                    colSpan: 3,
                  },
                  {},
                  {},
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];
        // forma = [
        //   { text: 'Marca: ' },
        // ];
      } else if (raw.forma.code == 5) {
        //salud
        var tablaBeneficiarios = {
          style: "table",
          table: {
            body: [
              [
                { text: "Nombre", style: "th" },
                { text: "Apellidos", style: "th" },
                { text: "F. de Nac.", style: "th" },
                { text: "Relación", style: "th" },
                { text: "Sexo", style: "th" },
                { text: "%", style: "th" },
              ],
            ],
          },
        };

        raw.forma.campos.beneficiaries_life.forEach(function (ben) {
          tablaBeneficiarios.table.body.push([
            { text: ben.first_name, style: "td" },
            { text: ben.last_name + " " + ben.second_last_name, style: "td" },
            { text: formatDate2(ben.birthdate.split("T")[0]), style: "td" },
            { text: ben.optional_relationship, style: "td" },
            {
              text:
                ben.sex == "M"
                  ? "Masculino"
                  : ben.sex == "F"
                  ? "Femenino"
                  : "No proporcionado",
              style: "td",
            },
            { text: ben.percentage + "", style: "td" },
          ]);
        });

        forma = [
          {
            columns: [
              { width: "*", text: "" },
              {
                width: "auto",
                table: {
                  body: [
                    //[{ text: ' ' },{ text: ' ' },{ text: ' ' },{ text: ' ' }],
                    [{ text: "" }, { text: "" }, { text: "" }, { text: "" }],
                    [
                      { text: "Titular:", style: "tableHeader" },
                      {
                        text: [
                          raw.forma.campos.personal.first_name,
                          " ",
                          raw.forma.campos.personal.last_name,
                          " ",
                          raw.forma.campos.personal.second_last_name,
                        ],
                        style: "info",
                        colSpan: 3,
                      },
                      {},
                      {},
                    ],
                    [
                      { text: "F. de Nac.:", style: "tableHeader" },
                      {
                        text: formatDate2(
                          raw.forma.campos.personal.birthdate.split("T")[0]
                        ),
                        style: "info",
                        colSpan: 3,
                      },
                      {},
                      {},
                    ][
                      ({ text: "Sexo:", style: "tableHeader" },
                      {
                        text: [
                          raw.forma.campos.personal.sex == "M"
                            ? "Masculino"
                            : "Femenino",
                        ],
                        style: "info",
                        colSpan: 3,
                      },
                      {},
                      {})
                    ],
                  ],
                },
                layout: "lightHorizontalLines",
              },
              { width: "*", text: "" },
            ],
          },
        ];
        if (raw.forma.campos.beneficiaries_life.length > 0) {
          forma.push("\n");
          forma.push({ text: "Asegurados ", bold: true, fontSize: 11 });
          forma.push(tablaBeneficiarios);
        }
      } // <- end formas

      var columns = {
        columns: [forma, coveragesTable],
        width: "auto",
      };

      var obs = {
        text: [
          { text: "\nNotas u Observaciones", italics: "true", style: "info" },
        ],
      };

      var obsRect = {
        headerRows: 1,
        widths: [80, 120, 120, 25, 25, 35, 40],
        table: {
          widths: ["100%"],
          headerRows: 1,
          body: [
            [
              {
                text: [
                  raw.observaciones ? raw.observaciones : "Sin observaciones",
                ],
                style: "info",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 0.5 : 0.5;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 0.5 : 0.5;
          },
          hLineColor: function (i, node) {
            return i === 0 || i === node.table.body.length ? "gray" : "gray";
          },
          vLineColor: function (i, node) {
            return i === 0 || i === node.table.widths.length ? "gray" : "gray";
          },
        },
      };

      var jumpPage = {
        text: "",
        pageBreak: "before",
      };
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      var atteTable = {
        columns: [
          { width: "*", text: "" },
          {
            width: "auto",
            table: {
              headerRows: 1,
              body: [
                [{ text: "" }],
                [
                  {
                    text: "\n\nAtentamente,",
                    style: "th",
                    alignment: "center",
                  },
                ],
                [{ text: "" }],
                [{ text: "" }],
                [
                  {
                    text: usr.nameFull + "\nEJECUTIVO",
                    style: "info",
                    alignment: "center",
                  },
                ],
                // [{ text: 'EJECUTIVO', style: 'th', alignment: 'center'}]
              ],
            },
            layout: "noBorders",
          },
          { width: "*", text: "" },
        ],
      };

      var pageBreakBefore = function (
        currentNode,
        followingNodesOnPage,
        nodesOnNextPage,
        previousNodesOnPage
      ) {
        return (
          currentNode.id === "mediaRow" && currentNode.pageNumbers.length > 1
        );
      };

      var atte = {
        text: [
          { text: "\n\n\nAtentamente,\n", style: "th", alignment: "center" },
          { text: "\n" + usr.nameFull, style: "info", alignment: "center" },
          { text: "\nEJECUTIVO", style: "th", alignment: "center" },
        ],
      };

      content.push(forma);
      forma.push({ text: "\nCoberturas", bold: true, fontSize: 11 });
      content.push(coveragesTable);
      content.push(obs);
      content.push(obsRect);
      // content.push(jumpPage);
      content.push(atteTable);

      var footer = function (page, pages) {
        var today = new Date();
        return {
          columns: [
            {
              text: [
                { text: getDate(), style: "footer", alignment: "left" },
                //{ text: '\nCLEMENCIA BORJA TABOADA 528 LOCAL 20, COL. PROVINCIA JURIQUILLA, QUERETARO, QRO.', style: 'address' }
              ],
            },
            {
              text: [
                { text: "Página: ", style: "footer" },
                { text: page.toString(), style: "footer" },
                { text: " de ", style: "footer" },
                { text: pages.toString(), style: "footer" },
                {
                  text: "\n" + usr.orgLocation,
                  style: "address",
                  alignment: "center",
                },
              ],
              alignment: "center",
            },
            {
              columns: [
                {
                  text: [
                    {
                      text: "Creado por Miurabox",
                      style: "footer",
                      alignment: "right",
                    },
                  ],
                },
                {
                  image: aux,
                  width: 12,
                  height: 12,
                  margin: [3, 0],
                },
              ],
            },
          ],
          margin: [15, 0],
        };
      };

      content.push();

      // detectamos el logo 1
      if (raw.logo1) {
        imgsPromises.push(getBase64FromImageUrl(raw.logo1, "logo1"));
      }

      // detectamos el logo 2
      if (raw.logo2) {
        imgsPromises.push(getBase64FromImageUrl(raw.logo2, "logo2"));
      }

      // esperamos a que todas las promesas se resuelvan
      if (imgsPromises.length > 0) {
        $q.all(imgsPromises).then(
          function (data) {
            // on SUCCESS all
            data.forEach(function (response) {
              var imgObj = null;
              if (response.id == "logo1") {
                imgObj = {
                  image: response.data,
                  //height: 60,
                  //width: 80,
                  //alignment: 'left'
                };
                //content.splice(0, 0, imgObj);
              }
            });

            var obj = {
              styles: styles,
              content: content,
              footer: footer,
            };

            dfd.resolve(obj);
          },
          function (error) {
            // on error
            dfd.reject(error);
          }
        );
      } else {
        var obj = {
          styles: styles,
          content: content,
          footer: footer,
        };

        dfd.resolve(obj);
      }

      return dfd.promise;
    }

    function getBase64FromImageUrl(url, id) {
      var dfd = $q.defer();
      var img = new Image();

      img.setAttribute("crossOrigin", "anonymous");

      img.onerror = function () {
        dfd.reject("Error loading image from url: " + url);
      };

      img.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = this.width;
        canvas.height = this.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(this, 0, 0);

        var response = {
          id: id,
          data: canvas.toDataURL("image/png"),
        };

        dfd.resolve(response);
      };

      img.src = url;

      return dfd.promise;
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").factory("packageService", packageService);

  packageService.$inject = ["url", "$http", "$sessionStorage"];

  function packageService(url, $http, $sessionStorage) {
    /* Información de usuario */
    var infoUser = $sessionStorage.infoUser;

    var service = {
      createPackage: createPackage,
      paquetesConfig: paquetesConfig,
      getPackages: getPackages,
      getInfoPackages: getInfoPackages,
      getPackage: getPackage,
      updatePackages: updatePackages,
      deletePackage: deletePackage,
      getPackageByUri: getPackageByUri,
      getPackageById: getPackageById,
      getOnlyPackageById: getOnlyPackageById,
      verifyPackage: verifyPackage,
    };

    return service;

    ////////////

    function paquetesConfig(data) {
      return $http
        .post(url.IP + "coberturas-configuraciones/", data)
        .then(createPackageComplete)
        .catch(createPackageFailed);

      function createPackageComplete(response) {
        return response.data;
      }

      function createPackageFailed(error) {
        ////console.log('createPackageFailed',  error);
      }
    }

    function verifyPackage(data) {
      return $http
        .post(url.IP + "verify-package", data)
        .then(createPackageComplete)
        .catch(createPackageFailed);

      function createPackageComplete(response) {
        return response.data;
      }

      function createPackageFailed(error) {
        ////console.log('createPackageFailed',  error);
      }
    }

    function createPackage(data) {
      return $http
        .post(url.IP + "paquetes/", data)
        .then(createPackageComplete)
        .catch(createPackageFailed);

      function createPackageComplete(response) {
        return response.data;
      }

      function createPackageFailed(error) {
        ////console.log('createPackageFailed',  error);
      }
    }

    function getPackages() {
      return $http
        .get(url.IP + "package-custom/")
        .then(getPackagesComplete)
        .catch(getPackagesFailed);

      function getPackagesComplete(response) {
        ////console.log('getPackages' , response.data.results);
        return response.data.results;
      }

      function getPackagesFailed(error) {
        ////console.log('My error' + error);
      }
    }

    function getInfoPackages() {
      infoUser = $sessionStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //   var filter_pack = 'v2/paquetes/paquetes-information/';
      var filter_pack = "v1/paquetes/information/";
      return $http
        .get(url.IP + filter_pack)
        .then(getInfoPackagesComplete)
        .catch(getInfoPackagesFailed);

      function getInfoPackagesComplete(response) {
        //return response.data.results;
        var results = {
          data: response.data,
          config: {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          },
        };
        //console.log('Results packages',results.data)
        return results;
      }

      function getInfoPackagesFailed(error) {
        return error;
      }
    }

    function getPackage(data) {
      if (data.paqueteId) {
        data.paqueteId = url.IP + "paquetes-resume/" + data.paqueteId + "/";
      } else {
        data.paqueteId = data.paquete;
      }
      ////console.log('data.paqueteId', data.paqueteId);
      return $http
        .get(data.paqueteId)
        .then(getPackageComplete)
        .catch(getPackageFailed);

      function getPackageComplete(response) {
        return response.data;
      }

      function getPackageFailed(error) {
        ////console.log('Error getPackageFailed:', error);
      }
    }

    function getPackageByUri(uri) {
      return $http.get(uri).then(getPackageComplete).catch(getPackageFailed);

      function getPackageComplete(response) {
        return response;
      }

      function getPackageFailed(error) {
        ////console.log('Error getPackageFailed:', error);
      }
    }

    function getOnlyPackageById(id) {
      return $http
        .get(url.IP + "paquete-single-by-id/" + id)
        .then(getPackageComplete)
        .catch(getPackageFailed);

      function getPackageComplete(response) {
        return response;
      }

      function getPackageFailed(error) {
        ////console.log('Error getPackageFailed:', error);
      }
    }

    function getPackageById(id) {
      return $http
        .get(url.IP + "paquete-by-id/" + id)
        .then(getPackageComplete)
        .catch(getPackageFailed);

      function getPackageComplete(response) {
        return response;
      }

      function getPackageFailed(error) {
        ////console.log('Error getPackageFailed:', error);
      }
    }

    function updatePackages(oldPackage, newPackage) {}

    function deletePackage(obj) {
      ////console.log('obj', obj);
      return $http
        .delete(obj.url)
        .then(deletePackagesComplete)
        .catch(deletePackagesFailed);

      function deletePackagesComplete(response, status, headers, config) {
        //jshint ignore:line
        return response;
      }

      function deletePackagesFailed(response, status, headers, config) {
        //jshint ignore:line
        ////console.log('Error deletePackagesFailed:', response);
        return status;
      }
    }
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("PaquetesEditCtrl", PaquetesEditCtrl);

  PaquetesEditCtrl.$inject = [
    "$state",
    "$http",
    "$localStorage",
    "$stateParams",
    "$uibModal",
    "packageService",
    "coverageService",
    "providerService",
    "toaster",
    "SweetAlert",
    "$sessionStorage",
  ];

  function PaquetesEditCtrl(
    $state,
    $http,
    $localStorage,
    $stateParams,
    $uibModal,
    packageService,
    coverageService,
    providerService,
    toaster,
    SweetAlert,
    $sessionStorage
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;

    vm.pageTitle = "Paquetes";
    vm.package = null; // Paquete
    //vm.coberages = [];                      // Lista de coberturas
    vm.provider = {};
    vm.user = usr;

    // Variables de control
    // HACK ejemplo
    vm.form = {
      coverage_name: "",
      priority: null,
      suma_name: null,
      deducible_name: null,
      coverage_sums: [],
      coverage_deductibles: [],
    };

    // Funciones
    vm.addSum = addSum;
    vm.removeSum = removeSum;
    vm.addDeductible = addDeductible;
    vm.removeDeductible = removeDeductible;
    vm.submit = submit;
    vm.savePack = savePack;

    //Funciones submit
    //vm.submit = submit;
    //vm.submitSum = submitSum;
    //vm.submitDeductible = submitDeductible;
    //vm.reloadCoverages = reloadCoverages;

    //Modal
    //vm.createCoverageModal = createCoverageModal;
    vm.editCoverageModal = editCoverageModal;

    activate();

    /*
      // Agrega una cobertura
      function submit() {
          vm.form = {
              coverage_name: vm.form.coverage_name,  //jshint ignore:line
              provider: vm.provider.url,
              package: vm.package.url,
              prima: ''
          };
          var form = angular.copy(vm.form);
          return coverageService.createCoverage(form)
              .then(function(){
                  toaster.success('Se ha agregado correctamente una nueva cobertura');
                  vm.package.coverage_package.push(form);
                  vm.form = {}; // limpia la forma
              });
      }

      // Agrega una suma asegurada
      // TODO add sum insured in dropdown
      function submitSum(){
          vm.form2 = {
              sum_insured: vm.form2.sum_insured,
              coverage_sum: vm.form2.coverage_sum.url
          };
          var form2 = angular.copy(vm.form2);
          return coverageService.createSumInsured(form2)
              .then(function(data){
                  toaster.success('Se ha agregado correctamente una nueva suma asegurada');
                  // vm.package.coverage_package.push(form);
                  vm.form2 = {};
              });
      }


      // Agrega el costo de deducible
      function submitDeductible(){
          vm.form3 = {
              deductible: vm.form3.deductible,
              coverage_deductible: vm.form3.coverage_deductible.url
          };
          var form3 = angular.copy(vm.form3);

          return coverageService.createDeducible(form3)
              .then(function(data){
                  toaster.success('Se ha agregado correctamente un nuevo deducible');
                  // vm.package.coverage_package.push(form);
                  vm.form3 = {};
                  //vm.reloadCoverages();
              });
      }*/

    function resetForm() {
      (vm.form.coverage_name = ""),
        (vm.form.priority = 0),
        (vm.form.suma_name = 0),
        (vm.form.deducible_name = 0),
        (vm.form.coverage_sums = []),
        (vm.form.coverage_deductibles = []);
    }

    function savePack(pack) {
      $http
        .patch(pack.url, { package_name: pack.package_name })
        .then(function (data) {
          if (data.status == 200) {
            SweetAlert.swal(
              "¡Listo!",
              "El paquete ha sido actualizado",
              "success"
            );
            $state.go("paquetes.paquetes");
          }
        });
    }

    function activate() {
      resetForm();
      return packageService.getPackage($stateParams).then(function (data) {
        vm.package = data;
        //vm.package.coverage_package = data.coverage_package;
        return data;
      });
      // .then(function(data){
      //     providerService.getProvider(data)
      //       .then(function(data){
      //           vm.provider = data;
      //       });
      // });
    }
    /*
      function createCoverageModal(){
        var modalInstance = $uibModal.open({ //jshint ignore:line
          templateUrl: 'app/modals/modal.coverage.create.html',
          controller: addCoverageCtrl,
          ////windowClass: 'animated fadeIn',
          size: 'lg'
        });
      }
*/

    function editCoverageModal(coverageToEdit) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/modals/modal.coverage.create.html",
        controller: editCoverageCtrl,
        ////windowClass: 'animated fadeIn',
        size: "lg",
        resolve: {
          coverage: function () {
            return coverageToEdit;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function submit() {
      var returning = false;
      if (vm.form.coverage_name == "") {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORNAMECOVERAGE, "error");
        returning = true;
      }
      // if(vm.form.coverage_sums.length < 1){
      //   toaster.error('Es necesario agregar sumas aseguradas')
      //   returning = true;
      // }
      // if(vm.form.coverage_deductibles.length < 1){
      //   toaster.error('Es necesario agregar deducibles')
      //   returning = true;
      // }

      if (returning) {
        return;
      }

      var submitForm = {
        coverage_name: vm.form.coverage_name, //jshint ignore:line
        priority: vm.form.priority ? vm.form.priority : 0,
        provider: vm.provider.url,
        package: vm.package.url,
        prima: "",
        sums_coverage: vm.form.coverage_sums,
        deductible_coverage: vm.form.coverage_deductibles,
      };
      // Damos de alta la cobertura
      coverageService
        .createCoverageComplete(submitForm)
        .then(function (coverage) {
          toaster.success("Se ha agregado correctamente una nueva cobertura");
          //return data;
          resetForm();
          vm.package.coverage_package.push(coverage); // Agregando la cobertura a la vista 'en vivo'
        }); /*.then(function(coverage){
            // TODO tambien puede ser llamado con un updateCoverage (servicio no hecho)
            // Le agregamos todas las sumas aseguradas que se pidieron
            vm.form.coverage_sums.forEach(function(sum){
              var sumObj = {
                sum_insured : sum.sum_insured,
                coverage_sum: coverage.url
              };
              coverageService.createSumInsured(sumObj)
                .then(function(data){
                  coverage.sums_coverage.push(data);
                });
            });
            vm.form.coverage_deductibles.forEach(function(ded){
              var deductibleObj = {
                deductible : ded.deductible,
                coverage_deductible : coverage.url
              };
              coverageService.createDeducible(deductibleObj)
              .then(function(data){
                coverage.deductible_coverage.push(data);
              });
            });
            return coverage;
          }).then(function(coverage){
            vm.package.coverage_package.push(coverage);// Agregando la cobertura a la vista 'en vivo'
          });*/
    }

    function addSum(sumNum) {
      // if(isNaN(sumNum) || sumNum < 1){
      //   toaster.error('Favor de ingresar un numero valido');
      //   return;
      // }
      var newSum = {
        coverage_sum: "",
        id: -1,
        sum_insured: sumNum,
        default: false,
        url: "",
      };

      vm.form.coverage_sums.push(newSum);
      vm.form.suma_name = "";
    }

    function removeSum(index) {
      if (index > -1) {
        vm.form.coverage_sums.splice(index, 1);
      }
    }

    function addDeductible(deductibleNum) {
      // if(isNaN(deductibleNum) || deductibleNum < 1){
      //   toaster.error('Favor de ingresar un numero valido');
      //   return;
      // }
      var newDed = {
        coverage_deductible: "",
        deductible: deductibleNum,
        default: false,
        id: -1,
        url: "",
      };

      vm.form.coverage_deductibles.push(newDed);
      vm.form.deducible_name = "";
    }

    function removeDeductible(index) {
      if (index > -1) {
        vm.form.coverage_deductibles.splice(index, 1);
      }
    }
    /*
      function addCoverageCtrl($uibModalInstance,$scope,$stateParams,providerService,packageService,coverageService,toaster){
        $scope.title = 'Agregar cobertura - Paquete:' + vm.package.package_name;
        $scope.provider = {};
        $scope.package = null;

        // HACK ejemplo
        $scope.form = {
          coverage_name : 'Ejemplo',
          suma_name : 10000,
          deducible_name : 10,
          coverage_sums : [],
          coverage_deductibles : []
        }

        // Funciones
        $scope.addSum = addSum;
        $scope.removeSum = removeSum;
        $scope.addDeductible = addDeductible;
        $scope.removeDeductible = removeDeductible;
        $scope.cancel = cancel;
        $scope.submit = submit;

        activateCtrl()

        function activateCtrl(){
          $scope.package = vm.package;
          $scope.provider = vm.provider;
        }

        function submit(){
          var returning = false;
          if($scope.form.coverage_name == ""){
            toaster.error('Es necesario asignar un nombre a la cobertura')
            returning = true;
          }
          if($scope.form.coverage_sums.length < 1){
            toaster.error('Es necesario agregar sumas aseguradas')
            returning = true;
          }
          if($scope.form.coverage_deductibles.length < 1){
            toaster.error('Es necesario agregar deducibles')
            returning = true;
          }

          if(returning){
            return;
          }

          var coverage = null;
          var submitForm = {
            coverage_name: $scope.form.coverage_name,  //jshint ignore:line
            provider: $scope.provider.url,
            package: $scope.package.url,
            prima: ''
          }
          // Damos de alta la cobertura
          coverageService.createCoverage(submitForm)
            .then(function(data){
                toaster.success('Se ha agregado correctamente una nueva cobertura');
                coverage = data;
            }).then(function(){
              // TODO tambien puede ser llamado con un updateCoverage (servicio no hecho)
              // Le agregamos todas las sumas aseguradas que se pidieron
              $scope.form.coverage_sums.forEach(function(sum){
                var sumObj = {
                  sum_insured : sum.sum_insured,
                  coverage_sum: coverage.url
                };
                coverageService.createSumInsured(sumObj)
                  .then(function(data){
                  });
              });
              $scope.form.coverage_deductibles.forEach(function(ded){
                var deductibleObj = {
                  deductible : ded.deductible,
                  coverage_deductible : coverage.url
                };
                coverageService.createDeducible(deductibleObj)
                .then(function(data){
                });
              });
            }).then(function(){
              var coverageObj = {
                paqueteId : coverage.id
              };
              coverageService.getCoverage(coverageObj)
                .then(function(data){
                  vm.package.coverage_package.push(data);// Agregando la cobertura a la vista 'en vivo'
                })
            }).then(function(){
              $uibModalInstance.dismiss('success');
            });
        }

        function cancel(){
          $uibModalInstance.dismiss('cancel');
        }

        function addSum(sumNum){
          if(isNaN(sumNum) || sumNum < 1){
            toaster.error('Favor de ingresar un numero valido');
            return;
          }
          var newSum = {
            coverage_sum: '',
            id: -1,
            sum_insured: sumNum,
            url: ''
          };

          $scope.form.coverage_sums.push(newSum);
          $scope.form.suma_name = '';
        }

        function removeSum(index){
          if(index > -1){
            $scope.form.coverage_sums.splice(index,1);
          }
        }

        function addDeductible(deductibleNum){
          if(isNaN(deductibleNum) || deductibleNum < 1){
            toaster.error('Favor de ingresar un numero valido');
            return;
          }
          var newDed = {
            coverage_deductible: '',
            deductible: deductibleNum,
            id: -1,
            url: ''
          };

          $scope.form.coverage_deductibles.push(newDed);
          $scope.form.deducible_name = '';
        }

        function removeDeductible(index){
          if(index > -1){
            $scope.form.coverage_deductibles.splice(index,1);
          }
        }
      }*/

    function editCoverageCtrl(
      $http,
      url,
      $uibModalInstance,
      $scope,
      $stateParams,
      providerService,
      packageService,
      coverageService,
      toaster,
      coverage,
      formatValues
    ) {
      $scope.title = "Editar cobertura - Paquete: " + vm.package.package_name;
      $scope.coverage = angular.copy(coverage);
      $scope.provider = {};
      $scope.package = null;

      //HACK ejemplos default en suma_name y deducible_name
      $scope.form = {
        coverage_name: "",
        priority: "",
        suma_name: "",
        deducible_name: "",
        coverage_sums: [],
        coverage_deductibles: [],
      };

      $scope.edit = {
        coverage_sums_add: [],
        coverage_deductibles_add: [],
        coverage_sums_delete: [],
        coverage_deductibles_delete: [],
        coverage_name: "",
        priority: "",
        url: "",
      };

      $scope.formatValues_ = function (param) {
        var model = formatValues.currency(param);
        return model;
      };

      // Funciones
      $scope.addSum = addSum;
      $scope.removeSum = removeSum;
      $scope.addDeductible = addDeductible;
      $scope.removeDeductible = removeDeductible;
      $scope.cancel = cancel;
      $scope.submit = submit;
      $scope.deleteIt = deleteIt;

      activateCtrl();

      function activateCtrl() {
        $http
          .get(url.IP + "coberturas/" + $scope.coverage.id + "/")
          .then(function (coverage) {
            coverage = coverage.data;
            $scope.provider = vm.provider;
            $scope.form.coverage_name = coverage.coverage_name;
            $scope.form.coverage_name = coverage.coverage_name;
            $scope.form.priority = coverage.priority;
            $scope.form.coverage_deductibles = coverage.deductible_coverage;
            $scope.form.url = coverage.url;
            $scope.edit.url = coverage.url;
            $scope.form.user = $localStorage.user;
          });
      }

      function deleteIt() {
        if (confirm("¿Estas seguro de querer eliminar esta cobertura?")) {
          var submitForm = {
            deductible_coverage: $scope.form.coverage_deductibles,
            sums_coverage: $scope.form.coverage_sums,
            url: $scope.form.url,
          };
          // TODO El API debe poder borrar la cobertura
          coverageService
            .deleteCoverageComplete(submitForm)
            .then(function (response) {
              var indexParent = vm.package.coverage_package.indexOf(coverage);
              vm.package.coverage_package.splice(indexParent, 1);
              $uibModalInstance.dismiss("delete");
            });
        }
      }

      function submit() {
        var indexParent = vm.package.coverage_package.indexOf(coverage);
        $scope.coverage.sums_coverage = $scope.form.coverage_sums;
        $scope.coverage.deductible_coverage = $scope.form.coverage_deductibles;
        coverage = $scope.coverage;
        $scope.edit.coverage_name = $scope.form.coverage_name;
        $scope.edit.priority = $scope.form.priority;

        coverageService
          .updateCoverageComplete($scope.edit)
          .then(function (response) {
            if ((response.data.coverage_name = $scope.form.coverage_name)) {
              $scope.form.coverage_name = response.data.coverage_name;
              $scope.form.priority = response.data.priority;
            }
            vm.package.coverage_package.forEach(function (cov) {
              if (response.data.url == cov.url) {
                cov = response.data;
              }
            });
          });
        // $http.patch($scope.form.url, $scope.form);

        $scope.form.coverage_deductibles.forEach(function (item) {
          if (item.url) {
            $http.patch(item.url, item);
          }
        });

        $scope.form.coverage_sums.forEach(function (item) {
          if (item.url) {
            $http.patch(item.url, item);
          }
        });

        //coverageService.updateCoverage()
        $scope.coverage.coverage_name = $scope.edit.coverage_name;
        vm.package.coverage_package[indexParent] = $scope.coverage;
        //TODO llamar servicio de update
        toaster.success("Cobertura actualizada");
        $uibModalInstance.dismiss("ok");
        // $state.go('paquetes.paquetes');
      }

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }

      $scope.default_sum = function (param) {
        $scope.form.coverage_sums.forEach(function (item) {
          if (item.id) {
            if (item.id !== param.id) {
              item.default = false;
            }
          } else {
            // TODO: esperar a ver que show
          }
        });
      };

      $scope.default_deductible = function (param) {
        $scope.form.coverage_deductibles.forEach(function (item) {
          if (item.id) {
            if (item.id !== param.id) {
              item.default = false;
            }
          } else {
            // TODO: esperar a ver que show
          }
        });
      };

      var addedSum = false;
      function addSum(sumNum) {
        $scope.form.coverage_sums.forEach(function (elem) {
          if ($scope.form.suma_name == elem.sum_insured) {
            toaster.warning(
              "Suma existente",
              "La suma elegida ya está agregada."
            );
            addedSum = true;
          }
        });
        if (!addedSum) {
          sumNum = String(sumNum);
          if (sumNum.indexOf("$") != -1) {
            if (sumNum.indexOf(",") != -1) {
              var sunChar = sumNum.replace("$", "").replace(",", "");
            } else {
              var sunChar = sumNum.replace("$", "");
            }
          } else if (sumNum.indexOf(",") != -1) {
            var sunChar = sumNum.replace(",", "");
          } else {
            var sunChar = sumNum;
          }

          var newSum = {
            coverage_sum: "",
            id: -1,
            sum_insured: sunChar,
            url: "",
          };

          $scope.form.coverage_sums.push(newSum);
          $scope.edit.coverage_sums_add.push(newSum);
          $scope.form.suma_name = "";
        }
        addedSum = false;
      }

      function removeSum(index) {
        if (index > -1) {
          var value = $scope.form.coverage_sums[index];
          if ($scope.form.coverage_sums[index].id != -1) {
            $scope.edit.coverage_sums_delete.push(value);
            // $http.delete(value.url);
          } else {
            var relIndex = $scope.edit.coverage_sums_add.indexOf(value);
            $scope.edit.coverage_sums_add.splice(relIndex, 1);
          }
          $scope.form.coverage_sums.splice(index, 1);
        }
      }

      var addedDed = false;
      function addDeductible(deductibleNum) {
        $scope.form.coverage_deductibles.forEach(function (elem) {
          if ($scope.form.deducible_name == elem.deductible) {
            toaster.warning(
              "Deducible existente",
              "El deducible elegido ya está agregado."
            );
            addedDed = true;
          }
        });
        if (!addedDed) {
          // if(isNaN(deductibleNum) || deductibleNum < 1){
          //   toaster.error('Favor de ingresar un número válido');
          //   return;
          // }
          deductibleNum = String(deductibleNum);
          if (deductibleNum.indexOf("$") != -1) {
            if (deductibleNum.indexOf(",") != -1) {
              var dedChar = deductibleNum.replace("$", "").replace(",", "");
            } else {
              var dedChar = deductibleNum.replace("$", "");
            }
          } else if (deductibleNum.indexOf(",") != -1) {
            var dedChar = deductibleNum.replace(",", "");
          } else {
            var dedChar = deductibleNum;
          }

          var newDed = {
            coverage_deductible: "",
            deductible: dedChar,
            id: -1,
            url: "",
          };

          $scope.form.coverage_deductibles.push(newDed);
          $scope.edit.coverage_deductibles_add.push(newDed);
          $scope.form.deducible_name = "";
        }
        addedDed = false;
      }

      function removeDeductible(index) {
        if (index > -1) {
          var value = $scope.form.coverage_deductibles[index];
          if ($scope.form.coverage_deductibles[index].id != -1) {
            // $http.delete(value.url);
            $scope.edit.coverage_deductibles_delete.push(value);
          } else {
            var relIndex = $scope.edit.coverage_deductibles_add.indexOf(value);
            $scope.edit.coverage_deductibles_add.splice(relIndex, 1);
          }
          $scope.form.coverage_deductibles.splice(index, 1);
        }
      }
    }
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("PaquetesCtrl", PaquetesCtrl);

  PaquetesCtrl.$inject = [
    "url",
    "$http",
    "$q",
    "$localStorage",
    "packageService",
    "ramoService",
    "providerService",
    "groupService",
    "coverageService",
    "toaster",
    "$state",
    "$sessionStorage",
    "$scope",
    "SweetAlert",
    "$uibModal",
    "exportFactory",
    "PersistenceFactory",
  ];

  function PaquetesCtrl(
    url,
    $http,
    $q,
    $localStorage,
    packageService,
    ramoService,
    providerService,
    groupService,
    coverageService,
    toaster,
    $state,
    $sessionStorage,
    $scope,
    SweetAlert,
    $uibModal,
    exportFactory,
    PersistenceFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.pageTitle = "Paquetes";
    vm.submit = submit;
    vm.pack = [];
    vm.passProvider = passProvider;
    vm.user = usr;

    // vm.providers = [];
    vm.ramos = [];
    vm.subramos = [];
    vm.coverage_ramos = [];
    vm.coverage_subramos = [];
    vm.coverage_paquetes = [];

    //  personalizar paquetes
    vm.package_ramos = [];
    vm.package_subramos = [];
    vm.package_paquetes = [];
    vm.package_covs = [];
    vm.activate = activate;
    vm.search = search;
    vm.table = {};

    vm.goToPackageEditor = goToPackageEditor;

    // Changes
    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    // vm.changeSubramo = changeSubramo

    vm.changeCoverageProvider = changeCoverageProvider;
    vm.changeCoverageRamo = changeCoverageRamo;
    vm.changeCoverageSubramo = changeCoverageSubramo;

    vm.changePackageProvider = changePackageProvider;
    vm.changePackageRamo = changePackageRamo;
    vm.changePackageSubramo = changePackageSubramo;
    vm.changePackagePackage = changePackagePackage;
    vm.makeDefaultCoverage = makeDefaultCoverage;
    vm.ordenarCoberturas = ordenarCoberturas;
    vm.saveCovOrden = saveCovOrden;

    vm.packageArray = [];

    // Delete
    vm.deletePackage = deletePackage;
    vm.createCoverage = createCoverage;

    vm.form = {
      provider: "",
      coverage_name: "",
      package_name: "", //jshint ignore:line
      description: " ",
      ramo: "",
      subramo: "",
      coverage_ramo: "",
      coverage_subramo: "",
      coverage_paquete: "",
      coverage_package: [],
      package_ramo: "",
      package_subramo: "",
      package_paquete: "",
    };

    vm.table = {
      headers: [
        "Paquetes",
        "Aseguradora ",
        "Ramos",
        "Subramos",
        "Opciones",
        "Acciones",
      ],
    };

    initial();

    vm.showForm = false;
    vm.showForm1 = false;
    vm.showTable = false;
    vm.showForm2 = false;
    vm.showPackageForm = false;
    vm.toggleForm = toggleForm;
    vm.toggleForm1 = toggleForm1;
    vm.toggleForm2 = toggleForm2;
    vm.toggleTable = toggleTable;
    vm.hideForm = hideForm;
    vm.hideForm1 = hideForm1;
    vm.hideForm2 = hideForm2;
    vm.showPackage = showPackage;
    vm.hideFormPackage = hideFormPackage;
    vm.deletePackagesw = deletePackagesw;
    vm.editCoverage = editCoverage;
    vm.toggle = toggle;
    vm.ordenar = false;
    vm.cobDe = false;
    // --orden coverages
    $scope.columnArray = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    ];
    $scope.columnArrayNew = [];
    $scope.currentPosition = null;

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    $scope.finalColumn = function (column, evet) {
      $scope.columnArrayNew = angular.copy($scope.columnArray);
      $scope.column = column;
      $scope.position = event.path[0].cellIndex;
      $scope.columnArray[$scope.position] = $scope.column;

      if ($scope.currentPosition > $scope.position) {
        for (var i = $scope.position; i < $scope.currentPosition; i++) {
          $scope.columnArray[i + 1] = $scope.columnArrayNew[i];
        }
      } else if ($scope.currentPosition < $scope.position) {
        for (var i = $scope.position; i > $scope.currentPosition; i--) {
          $scope.columnArray[i - 1] = $scope.columnArrayNew[i];
        }
      }
    };
    $scope.currentColumn = function (column, event) {
      $scope.currentPosition = event.originalEvent.path[0].cellIndex;
    };
    function ordenarCoberturas(obj) {
      vm.test = true;
      vm.ordenar = true;
      vm.cobDe = true;
      if (vm.test == false) {
        vm.test = true;
      } else {
        vm.test = true;
        vm.ordenar = true;
        vm.cobDe = false;
      }
    }
    // ------orden coverages

    function toggle(value) {
      vm.showForm = value;
      vm.showForm1 = true;
    }

    function toggleForm() {
      if (vm.showForm == false) {
        vm.showForm = true;
      } else {
        vm.showForm = false;
      }
    }

    function hideForm() {
      if (vm.showForm == true) {
        vm.showForm = false;
      } else {
        vm.showForm = true;
      }
    }

    function toggleForm1() {
      if (vm.showForm1 == false) {
        vm.showForm1 = true;
      } else {
        vm.showForm1 = false;
      }
    }

    function hideForm1() {
      $scope.inputCoverage = false;
      if (vm.showForm1 == true) {
        vm.showForm1 = false;
      } else {
        vm.showForm1 = true;
      }
    }

    function toggleForm2() {
      if (vm.showForm2 == false) {
        vm.showForm2 = true;
      } else {
        vm.showForm2 = false;
      }
    }

    function hideForm2(p) {
      if (p) {
        if (p == 2) {
          vm.test = true;
          vm.ordenar = false;
          vm.cobDe = true;
        }
      } else if (vm.showForm2 == true) {
        vm.showForm2 = false;
      } else {
        vm.showForm2 = true;
      }
    }

    function toggleTable() {
      if (vm.showTable == false) {
        vm.showTable = true;
      } else {
        vm.showTable = false;
      }
    }

    function showPackage() {
      if (vm.showPackageForm == false) {
        vm.showPackageForm = true;
      } else {
        vm.showPackageForm = false;
      }
    }
    function hideFormPackage() {
      if (vm.showPackageForm == true) {
        vm.showPackageForm = false;
      } else {
        vm.showPackageForm = true;
      }
    }

    function deletePackagesw(pack, index) {
      sweetAlert(
        {
          title: "¿Está seguro?",
          text: "¡El paquete eliminará por completo!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, eliminar.",
          cancelButtonText: "No, cancelar.",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .post(url.IP + "delete-package/", { paquete: pack.id })
              .then(
                function success(request) {
                  if (request.status === 200) {
                    if (request.data.detail) {
                      vm.totalPackages.splice(index, 1);
                      sweetAlert("¡Eliminado!", request.data.detail, "success");
                    } else if (request.data.error) {
                      sweetAlert("Error", request.data.error);
                    }
                  } else {
                    //error
                    sweetAlert("El paquete no se pudo eliminar", "error");
                  }
                },
                function error(error) {
                  sweetAlert("error", error);
                }
              )
              .catch(function (e) {
                sweetAlert("Error", e);
              });
          } else {
            sweetAlert("Cancelado", "El paquete no se removio ", "error");
          }
        }
      );
    }

    function search(cadena) {
      $scope.param_cadena = cadena;
      vm.show_binnacle = false;
      vm.totalPackages = [];
      vm.show_pagination_pack = false;
      if (cadena.length) {
        var filter_pack = "search-packages/";
        $http({
          method: "GET",
          url: url.IP + filter_pack,
          params: {
            cadena: cadena,
          },
        })
          .then(
            function success(request) {
              if (request.status === 200 && request.data.results.length) {
                vm.totalPackages = request.data.results;
                vm.config_pagination = request.data;
                vm.show_pagination_pack = true;
              } else {
                toaster.warning("No se encontraron registros");
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else {
        vm.totalPackages = [];
      }

      vm.buttonReport = true;
    }

    $scope.exportData = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var excel_pack = "service_reporte-paquetes-excel";
      $http({
        method: "GET",
        url: url.IP + excel_pack,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(
          function success(data) {
            if (data.status == 200) {
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Paquetes.xls");
            } else {
              SweetAlert.swal(
                "Error",
                "Ha ocurrido un error al descargar el reporte",
                "error"
              );
            }
            l.stop();
          },
          function error(error) {
            l.stop();
            console.log("error", error);
          }
        )
        .catch(function (e) {
          l.stop();
          console.log(e);
        });
    };
    $scope.exportDataSeeker = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var data = { cadena: $scope.param_cadena };
      var excel_pack_seeker = "service_reporte-paquetes-excel";
      $http({
        method: "GET",
        url: url.IP + excel_pack_seeker,
        params: data,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(
          function success(data) {
            if (data.status == 200) {
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Paquetes.xls");
            } else {
              SweetAlert.swal(
                "Error",
                "Ha ocurrido un error al descargar el reporte",
                "error"
              );
            }
            l.stop();
          },
          function error(error) {
            l.stop();
            console.log("error", error);
          }
        )
        .catch(function (e) {
          l.stop();
          console.log(e);
        });
    };

    vm.test = true;
    function editCoverage(coverage, $index) {
      vm.package = [];
      vm.package = coverage;
      //vm.package =
      vm.coverage = coverage;
      $scope.coverage_name = "Editar cobertura:  " + vm.coverage.coverage_name;
      $scope.coverage = angular.copy(coverage);
      $scope.provider = {};
      $scope.package = null;

      $scope.form = {
        coverage_name: "",
        suma_name: 10000,
        deducible_name: 10,
        coverage_sums: [],
        coverage_deductibles: [],
      };

      $scope.edit = {
        coverage_sums_add: [],
        coverage_deductibles_add: [],
        coverage_sums_delete: [],
        coverage_deductibles_delete: [],
        coverage_name: "",
        url: "",
      };

      // Funciones
      $scope.addSum = addSum;
      $scope.removeSum = removeSum;
      $scope.addDeductible = addDeductible;
      $scope.removeDeductible = removeDeductible;
      $scope.cancel = cancel;
      $scope.submit = submit;
      $scope.deleteIt = deleteIt;

      activateCtrl();

      function activateCtrl() {
        $http
          .get(url.IP + "coberturas/" + $scope.coverage.id + "/")
          .then(function (coverage) {
            coverage = coverage.data;
            vm.package = coverage;
            $scope.provider = vm.provider;
            $scope.form.coverage_name = coverage.coverage_name;
            $scope.form.coverage_sums = coverage.sums_coverage;
            $scope.form.coverage_deductibles = coverage.deductible_coverage;
            $scope.form.url = coverage.url;
            $scope.edit.url = coverage.url;
            $scope.form.user = $localStorage.user;
          });
      }

      function submit() {
        //var indexParent = vm.package.coverage_package.indexOf(coverage);
        $scope.coverage.sums_coverage = $scope.form.coverage_sums;
        $scope.coverage.deductible_coverage = $scope.form.coverage_deductibles;
        coverage = $scope.coverage;
        $scope.edit.coverage_name = $scope.form.coverage_name;
        $scope.edit.coverage_sums_add = $scope.form.coverage_sums;
        $scope.edit.coverage_deductibles_add = $scope.form.coverage_deductibles;
        $scope.edit.coverage_sums_delete = $scope.form.coverage_sums;
        $scope.edit.coverage_deductibles_delete =
          $scope.form.coverage_deductibles;
        coverageService
          .updateCoverageComplete($scope.edit)
          .then(function (response) {
            vm.package_covs.forEach(function (cov) {
              if (response.data.url == cov.url) {
                cov.coverage_name = response.data.coverage_name;
              }
            });
          });

        //coverageService.updateCoverage()
        //vm.package.coverage_package[$index] = $scope.coverage;
        //TODO llamar servicio de update
        toaster.success("Cobertura actualizada");
        // activate();
        //window.location.reload();
        vm.test = true;
        // if(vm.showForm2 == true){
        //   vm.showForm2 = false;
        // }
      }
      function deleteIt() {
        if (confirm("¿Estas seguro de querer eliminar esta cobertura?")) {
          var submitForm = {
            deductible_coverage: $scope.form.coverage_deductibles,
            sums_coverage: $scope.form.coverage_sums,
            url: $scope.form.url,
          };
          // TODO El API debe poder borrar la cobertura
          coverageService
            .deleteCoverageComplete(submitForm)
            .then(function (response) {
              var indexParent = vm.package.coverage_package.indexOf(coverage);
              vm.package.coverage_package.splice(indexParent, 1);
              $uibModalInstance.dismiss("delete");
            });
        }
      }

      var addedSum = false;
      function addSum(sumNum) {
        $scope.form.coverage_sums.forEach(function (elem) {
          if ($scope.form.suma_name == elem.sum_insured) {
            toaster.warning(
              "Suma existente",
              "La suma elegida ya está agregada."
            );
            addedSum = true;
          }
        });
        if (!addedSum) {
          if (isNaN(sumNum) || sumNum < 1) {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORNUMBER, "error");
            return;
          }
          var newSum = {
            coverage_sum: "",
            id: -1,
            sum_insured: sumNum,
            url: "",
          };

          $scope.form.coverage_sums.push(newSum);
          $scope.edit.coverage_sums_add.push(newSum);

          $scope.form.suma_name = "";
        }
        addedSum = false;
      }

      function removeSum(index) {
        if (index > -1) {
          var value = $scope.form.coverage_sums[index];
          if ($scope.form.coverage_sums[index].id != -1) {
            $scope.edit.coverage_sums_delete.push(value);
            // $http.delete(value.url);
          } else {
            var relIndex = $scope.edit.coverage_sums_add.indexOf(value);
            $scope.edit.coverage_sums_add.splice(relIndex, 1);
          }
          $scope.form.coverage_sums.splice(index, 1);
        }
      }

      var addedDed = false;
      function addDeductible(deductibleNum) {
        $scope.form.coverage_deductibles.forEach(function (elem) {
          if ($scope.form.deducible_name == elem.deductible) {
            toaster.warning(
              "Deducible existente",
              "El deducible elegido ya está agregado."
            );
            addedDed = true;
          }
        });
        if (!addedDed) {
          if (isNaN(deductibleNum) || deductibleNum < 1) {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORNUMBER, "error");
            return;
          }
          var newDed = {
            coverage_deductible: "",
            deductible: deductibleNum,
            id: -1,
            url: "",
          };
          $scope.form.coverage_deductibles.push(newDed);
          $scope.edit.coverage_deductibles_add.push(newDed);
          $scope.form.deducible_name = "";
        }
        addedDed = false;
      }

      function removeDeductible(index) {
        if (index > -1) {
          var value = $scope.form.coverage_deductibles[index];
          if ($scope.form.coverage_deductibles[index].id != -1) {
            // $http.delete(value.url);
            $scope.edit.coverage_deductibles_delete.push(value);
          } else {
            var relIndex = $scope.edit.coverage_deductibles_add.indexOf(value);
            $scope.edit.coverage_deductibles_add.splice(relIndex, 1);
          }
          $scope.form.coverage_deductibles.splice(index, 1);
        }
      }

      function cancel() {
        // $uibModalInstance.dismiss('cancel');
        vm.test = true;
      }

      vm.test = false;
    }

    vm.coberturaTest = coberturaTest;
    function coberturaTest() {
      vm.test = true;
    }
    function initial() {
      providerService.getReadListProviders().then(function (data) {
        vm.providers = data;
      });
    }

    function activate() {
      vm.buttonReport = false;
      getProviders();
    }

    function getProviders() {
      vm.show_binnacle = false;
      vm.totalPackages = [];
      packageService.getInfoPackages().then(function (data) {
        vm.totalPackages = data.data.results;
        vm.config_pagination = data.config;
        vm.show_pagination_pack = true;
      });
    }
    $scope.returnToPackage = function () {
      vm.show_binnacle = false;
    };

    function goToPackageEditor(pack) {
      $state.go("paquetes.edit", { paqueteId: pack.id });
    }
    vm.showBinnacle = showBinnacle;
    //-----------------------------------------------------------comments
    function showBinnacle(param) {
      vm.show_binnacle = true;
      vm.package_id = param.id;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 9,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }
    //-------------------------------------------------------------comments

    function exportPackageComments() {
      if (!vm.package_id || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
      };

      var params = {
        model: 9,
        id_model: vm.package_id,
      };
      if (vm.org_name) {
        params.org = vm.org_name;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: params,
          downloadName: "bitacora-paquetes.xlsx",
          token: token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }

    function submit() {
      var form = angular.copy(vm.form);
      form.provider = form.provider.url;
      form.ramo = form.ramo.url;
      form.subramo = form.subramo.url;
      form.type_package = 1;

      var verify = {
        provider: vm.form.provider.id,
        ramo: vm.form.ramo.id,
        subramo: vm.form.subramo.id,
        package_name: vm.form.package_name,
      };
      packageService.verifyPackage(verify).then(function (response) {
        if (response) {
          SweetAlert.swal("Error", "El paquete ya existe", "error");
        } else {
          return packageService.createPackage(form).then(function (data) {
            //jshint ignore:line
            toaster.success("Se ha agregado correctamente un nuevo paquete");
            vm.pack = [];
            getProviders();
            vm.form = {};
          });
        }
      });
    }

    function changeProvider(obj) {
      $http.get(url.IP + "ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.ramos = ramos.data;
      });
      // vm.ramos = ;
    }

    function changeCoverageProvider(obj) {
      $http.get(url.IP + "ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.coverage_ramos = ramos.data;
      });
      // vm.ramos = ;
    }

    function changePackageProvider(obj) {
      $http.get(url.IP + "ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.package_ramos = ramos.data;
      });
      // vm.ramos = ;
      if (vm.test == false) {
        vm.test = true;
      }
    }

    function changeRamo(obj) {
      try {
        vm.subramos = obj.subramo_ramo;
      } catch (e) {}
    }

    function changeCoverageRamo(obj) {
      try {
        vm.coverage_subramos = obj.subramo_ramo;
      } catch (e) {}
    }

    function changePackageRamo(obj) {
      try {
        vm.package_subramos = obj.subramo_ramo;
      } catch (e) {}
      if (vm.test == false) {
        vm.test = true;
      }
    }

    $scope.inputCoverage = false;
    function changeCoverageSubramo(obj) {
      if (obj.subramo_code == 3) {
        $scope.inputCoverage = true;
      }
      try {
        $http
          .post(url.IP + "paquetes-by-subramo/", {
            ramo: vm.form.coverage_ramo.id,
            subramo: vm.form.coverage_subramo.id,
            provider: vm.form.coverage_provider.id,
          })
          .then(function (paquetes) {
            vm.coverage_paquetes = paquetes.data;
          });
      } catch (e) {}
    }

    function makeDefaultCoverage(coverage) {
      vm.package_covs.some(function (cov) {
        if (cov.id == coverage.id) {
          if (cov.default == true) {
            cov.default = false;
            // peticion desactivar default de covertura
            $http.patch(cov.url, cov).then(function (data) {
              toaster.success("cobertura desactivada");
            });
          } else {
            // peticion activar default de covertura
            cov.default = true;
            $http.patch(cov.url, cov).then(function (data) {
              toaster.success("cobertura activada");
            });
          }
        }
      });
    }
    function saveCovOrden(coverage) {
      $scope.orden_covs = [];
      vm.package_covs.forEach(function (covp) {
        coverage.forEach(function (covx) {
          if (covp.id == covx.id) {
            $scope.orden_covs.push(covx.priority);
            $http.patch(covx.url, covx).then(function (data) {
              vm.test = true;
              vm.ordenar = false;
              vm.cobDe = true;
            });
          }
        });
      });
    }
    vm.deleteCoverage = deleteCoverage;
    function deleteCoverage(obj, index) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "¡La cobertura se eliminará !",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, eliminar.",
          cancelButtonText: "No, cancelar.",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            vm.package_covs.splice(index, 1);
            $http({
              method: "DELETE",
              url: obj.url,
            });
            SweetAlert.swal("¡Eliminada!", "Cobertura eliminada.", "success");
          } else {
            SweetAlert.swal("Cancelada", "Cobertura no removida", "error");
          }
        }
      );
    }

    function changePackageSubramo(obj) {
      try {
        $http
          .post(url.IP + "paquetes-by-subramo/", {
            ramo: vm.form.package_ramo.id,
            subramo: vm.form.package_subramo.id,
            provider: vm.form.package_provider.id,
          })
          .then(function (paquetes) {
            vm.package_paquetes = paquetes.data;
          });
      } catch (e) {}
      if (vm.test == false) {
        vm.test = true;
      }
    }

    function changePackagePackage(obj) {
      $scope.columnArray = [];
      try {
        $http
          .post(url.IP + "covs-by-package/", {
            provider: vm.form.package_provider.id,
            package: vm.form.package_paquete.id,
          })
          .then(function (coberturas) {
            for (var i = 0; i < coberturas.data.length; i++) {
              $scope.columnArray.push(i);
              coberturas.data[i].priority = i + 1;
            }
            vm.package_covs = coberturas.data;
          });
      } catch (e) {}
      if (vm.test == false) {
        vm.test = true;
        vm.cobDe = true;
        vm.ordenar = false;
      } else {
        vm.cobDe = true;
        vm.ordenar = false;
      }
    }

    function createCoverage() {
      var deducibles = [];
      var sumas = [];
      var coinsurances = [];
      var topecoinsurances = [];
      sumas = vm.form.sum_insured;
      deducibles = vm.form.deducible;
      coinsurances = vm.form.coinsurance ? vm.form.coinsurance : [];
      topecoinsurances = vm.form.topeCoinsurance ? vm.form.topeCoinsurance : [];
      var coverage = {
        coverage_name: vm.form.coverage_name,
        priority: vm.form.priority ? vm.form.priority : 0,
        provider: vm.form.coverage_provider.url,
        package: vm.form.coverage_paquete.url,
        deductible_coverage: deducibles,
        sums_coverage: sumas,
        coinsurance_coverage: coinsurances,
        topecoinsurance_coverage: topecoinsurances,
      };
      coverageService.createCoverage(coverage).then(function (response) {
        $http({
          method: "POST",
          url: url.IP + "sumas-aseguradas/",
          data: {
            coverage_sum: response.url,
            sum_insured: vm.form.sum_insured ? vm.form.sum_insured : "",
          },
        });
        $http({
          method: "POST",
          url: url.IP + "deducibles/",
          data: {
            coverage_deductible: response.url,
            deductible: vm.form.deductible ? vm.form.deductible : "",
          },
        });
        $http({
          method: "POST",
          url: url.IP + "coinsurance/",
          data: {
            coverage_coinsurance: response.url,
            coinsurance: vm.form.coinsurance ? vm.form.coinsurance : "",
          },
        });
        $http({
          method: "POST",
          url: url.IP + "topecoinsurance/",
          data: {
            coverage_topecoinsurance: response.url,
            topecoinsurance: vm.form.topeCoinsurance
              ? vm.form.topeCoinsurance
              : "",
          },
        });
        toaster.success("Se ha agregado correctamente una nueva cobertura");
        reset_coverage();
      });
    }
    function reset_coverage(argument) {
      vm.form.coverage_name = "";
      vm.form.coverage_provider = "";
      vm.form.coverage_paquete = "";
      vm.form.coverage_ramo = "";
      vm.form.coverage_subramo = "";
    }

    function deletePackage(paquetes, index) {
      packageService.deletePackage(paquetes).then(function (data) {
        vm.pack.splice(index, 1); //jshint ignore:line
      });
    }

    function passProvider(data) {
      var arr = [];
      data.ramo_provider.forEach(function (elem) {
        elem.subramo_ramo.forEach(function (elem2) {
          elem2.package_subramo.forEach(function (elem3) {
            var pack = {
              ramo: elem.ramo_name,
              subramo: elem2.subramo_name,
              package: elem3.package_name,
              packageId: elem3.id,
              url: elem3.url,
            };
            arr.push(pack);
          });
        });
      });
      vm.pack = arr;
    }

    //-- Peticion de persistencia--//
    var json_data = {};
    var form = document.getElementsByTagName("form");
    var elementos = {};
    //Valores reutilizables
    var interval, interval1, dt, valor;

    function set_dataForm(json) {
      PersistenceFactory.set_inputs(json);

      // Validar Botones
      if (json["vm.form.package_name"] != "") {
        PersistenceFactory.val_botons("!vm.form.package_name");
      }

      // Validar Select´s
      if (json["vm.form.provider"] != "") {
        valor = PersistenceFactory.find_index(
          vm.providers,
          json["vm.form.provider"]
        );
        changeProvider(vm.providers[valor]);
      }

      if (json["vm.form.ramo"] != "") {
        interval1 = setInterval(function () {
          if (vm.ramos.length > 0) {
            clearInterval(interval1);

            valor = PersistenceFactory.find_index(
              vm.ramos,
              json["vm.form.ramo"]
            );
            changeRamo(vm.ramos[valor]);
            vm.form.ramo = vm.ramos[valor];

            if (vm.subramos.length > 0 && json["vm.form.subramo"] != "") {
              valor = PersistenceFactory.find_index(
                vm.subramos,
                json["vm.form.subramo"]
              );
              vm.form.subramo = vm.subramos[valor];
            }
          }
        }, 1000);
      }

      if (
        json["vm.form.package_provider"] != "" &&
        json["vm.form.package_provider"] != undefined
      ) {
        valor = PersistenceFactory.find_index(
          vm.providers,
          json["vm.form.provider"]
        );
        changePackageProvider(vm.providers[valor]);
      }
    }

    //PersistenceFactory.inicial(vm.user.org,vm.pageTitle,vm.user.nameFull,PersistenceFactory.get_dataForm(form));

    // interval = setInterval(function(){
    //   if(form != undefined && PersistenceFactory.count == 0){
    //       PersistenceFactory.inicial(vm.user.org,vm.pageTitle,vm.user.nameFull,PersistenceFactory.get_dataForm(form));
    //     }
    //   if(PersistenceFactory.init_return != '' && PersistenceFactory.init_return != undefined){
    //   //if(PersistenceFactory.init_return != ''){
    //     clearInterval(interval);
    //     if(PersistenceFactory.init_return.status == 'data_view' ){
    //       set_dataForm(PersistenceFactory.json_return);
    //     }
    //     PersistenceFactory.interval = setInterval(function(){
    //       PersistenceFactory.editado(PersistenceFactory.get_dataForm(form));
    //     }, PersistenceFactory.intervalTime); /* */
    //   }
    // }, 2000);
    //-- End Peticion de persistencia--//
  }
})();

// DEVELOP

/* global angular */
(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("OrderCtrl", OrderCtrl);

  OrderCtrl.$inject = [
    "$parse",
    "datesFactory",
    "SweetAlert",
    "ContratanteService",
    "$http",
    "$state",
    "models",
    "tiposBeneficiarios",
    "sex",
    "formService",
    "$timeout",
    "$q",
    "url",
    "$uibModalInstance",
    "$localStorage",
    "FileUploader",
    "$scope",
    "$rootScope",
    "$filter",
    "groupService",
    "providerService",
    "insuranceService",
    "receiptService",
    "generalService",
    "toaster",
    "payform",
    "helpers",
    "MESSAGES",
    "$uibModal",
    "$sessionStorage",
    "$location",
    "$stateParams",
    "packageService",
    "coverageService",
    "formatValues",
    "dataFactory",
    "emailService",
    "$sce",
    "PaquetesMatcher",
  ];

  function OrderCtrl(
    $parse,
    datesFactory,
    SweetAlert,
    ContratanteService,
    $http,
    $state,
    models,
    tiposBeneficiarios,
    sex,
    formService,
    $timeout,
    $q,
    url,
    $uibModalInstance,
    $localStorage,
    FileUploader,
    $scope,
    $rootScope,
    $filter,
    groupService,
    providerService,
    insuranceService,
    receiptService,
    generalService,
    toaster,
    payform,
    helpers,
    MESSAGES,
    $uibModal,
    $sessionStorage,
    $location,
    $stateParams,
    packageService,
    coverageService,
    formatValues,
    dataFactory,
    emailService,
    $sce,
    PaquetesMatcher
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var __url = angular.copy(url);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.orgName = usr.orgname;
    $scope.identificador = false;
    $scope.dateOut = false;
    $scope.referenciadores = [];
    $scope.org_name = usr.urlname;
    $scope.cotizador = localStorage.getItem("pdf_generado") === "1";
    $scope.contratante = [];
    $scope.enproceso = false;
    $scope.yaseestableciopaquete = false;
    $scope.coberturasPackagePdf = [];
    var order = this;
    $scope.eliminadoManualCobertura = false;
    var saveCreatedPoliza = {};
    var lastActiveTab = null;
    var LAST_ACTIVE_TAB_KEY = "orderLastActiveTab";
    var TAB_INDEX_OT = 0;
    var TAB_INDEX_POLICY = 1;

    if (angular.isNumber($localStorage[LAST_ACTIVE_TAB_KEY])) {
      lastActiveTab = $localStorage[LAST_ACTIVE_TAB_KEY];
    }

    function hasSavedPolizaData() {
      return saveCreatedPoliza && Object.keys(saveCreatedPoliza).length > 0;
    }
    $q.when()
      .then(function () {
        var defer = $q.defer();
        defer.resolve(helpers.getStates());
        return defer.promise;
      })
      .then(function (data) {
        $scope.statesArray = data.data;
      });

    var startDate;
    var endingDate;
    $scope.create_natural = true;
    $scope.create_juridical = true;
    order.f_currency = {};
    order.f_currency.f_currency_selected = 1;
    order.f_currency.options = [
      { value: 1, label: "PESOS" },
      { value: 2, label: "DOLARES" },
      { value: 3, label: "UDI" },
      { value: 4, label: "EURO" },
      { value: 5, label: "DOLAR CANADIENSE" },
      { value: 6, label: "LIBRA ESTERLINA" },
      { value: 7, label: "YEN" },
    ];

    $scope.ramos = [
      {
        ramo_name: "Vida",
        ramo_id: 1,
      },
      {
        ramo_name: "Gastos Médicos",
        ramo_id: 2,
      },
      {
        ramo_name: "Daños",
        ramo_id: 3,
      },
      {
        ramo_name: "Automóviles",
        ramo_id: 9,
      },
    ];

    order.conducto_de_pago = {};
    order.conducto_de_pago.conducto_de_pago_selected = 1;
    order.conducto_de_pago.options = [
      { value: 1, label: "No domiciliada" },
      { value: 2, label: "Agente" },
      { value: 3, label: "CAC" },
      { value: 4, label: "CAT/Domiciliado" },
      { value: 5, label: "Nómina" },
      { value: 6, label: "CUT" },
    ];

    order.renewal = {};
    order.renewal.is_renewable = 1;
    order.renewal.selected = 1;
    order.renewal.options = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    order.types = [
      { id: 1, name: "Automóvil" },
      { id: 2, name: "Motocicleta" },
      { id: 3, name: "Tracto" },
      { id: 4, name: "Autobús" },
      { id: 5, name: "Pick Up" },
      { id: 6, name: "Camiones hasta 1.5 ton" },
      { id: 7, name: "Chofer app" },
      { id: 8, name: "Remolque" },
      { id: 9, name: "Camiones + 1.5 ton" },
    ];
    order.types_ap = [
      { id: 64, name: "Viajero" },
      { id: 46, name: "Familiar" },
    ];
    order.types_gm = [{ id: 46, name: "Familiar" }];
    order.businessline = [
      { id: 1, name: "Comercial" },
      { id: 2, name: "Personal" },
      { id: 0, name: "Otro" },
    ];
    order.types_life = [
      { id: 47, name: "Ahorro" },
      { id: 48, name: "Vitalicia" },
      { id: 49, name: "Temporal/Protección" },
    ];
    order.procedimiento = [
      { id: 1, name: "Residente" },
      { id: 2, name: "Turista" },
      { id: 3, name: "Legalizado" },
      { id: 4, name: "Fronterizo" },
    ];
    order.charge_type = [
      { id: 1, name: "A" },
      { id: 2, name: "B" },
      { id: 3, name: "C" },
    ];

    $scope.usages = [
      { id: 1, name: "PARTICULAR" },
      { id: 2, name: "CARGA" },
      { id: 3, name: "SERVICIO PÚBLICO" },
    ];
    order.types_incendio = [
      { id: 1, name: "Familiar" },
      { id: 2, name: "Casa Habitación" },
      { id: 3, name: "Condominio" },
      { id: 4, name: "Edificio" },
      { id: 5, name: "Empresarial" },
      { id: 6, name: "Múltiple Empresarial" },
      { id: 10, name: "Sólo Incendio" },
    ];
    order.types_myt = [
      { id: 46, name: "Avión" },
      { id: 47, name: "Avioneta" },
      { id: 48, name: "Barco" },
      { id: 49, name: "Buque" },
      { id: 9, name: "Declaración" },
      { id: 50, name: "Dron" },
      { id: 51, name: "Embarcación de Placer" },
      { id: 7, name: "Específica" },
      { id: 52, name: "Helicóptero" },
      { id: 35, name: "Otro" },
      { id: 8, name: "Pronóstico" },
    ];
    order.types_ayc = [
      { id: 11, name: "Animales" },
      { id: 12, name: "Cultivo" },
    ];
    order.types_credito = [{ id: 13, name: "Crédito General" }];
    order.types_vivienda = [{ id: 14, name: "Crédito a la Vivienda" }];
    order.types_garantia = [
      {
        id: 15,
        name: "Documentos que sean objeto de oferta pública o de intermediación en mercados de valores",
      },
      { id: 16, name: "Emisores de Valores" },
      { id: 17, name: "Títulos de Crédito" },
    ];
    order.types_rc = [
      { id: 18, name: "Administración" },
      { id: 19, name: "Arquitectos" },
      { id: 20, name: "Aviones" },
      { id: 21, name: "Barcos" },
      { id: 22, name: "Contratista" },
      { id: 23, name: "Crime" },
      { id: 24, name: "Cyber (Protección de datos)" },
      { id: 25, name: "D&O (Consejeros y Funcionarios)" },
      { id: 26, name: "E&O Miscelaneos" },
      { id: 27, name: "Empresarial" },
      { id: 28, name: "Eventos" },
      { id: 29, name: "Familiar/Condominal" },
      { id: 30, name: "Hole in One" },
      { id: 31, name: "Ingeniería" },
      { id: 32, name: "Instituciones Financieras" },
      { id: 33, name: "Lineas Financieras" },
      { id: 34, name: "Médicos" },
      { id: 35, name: "Otro" },
    ];
    order.types_tyorc = [{ id: 36, name: "Riesgos Catastróficos" }];
    order.types_diversos = [
      { id: 37, name: "Calderas y Recipientes Sujetos a Presión" },
      { id: 38, name: "Dinero y Valores" },
      { id: 39, name: "Eq. Contratistas y Maquinaria pesada" },
      { id: 40, name: "Eq. Electrónico" },
      { id: 41, name: "Montaje de Maquinaria" },
      { id: 42, name: "Obra Civil en Contrucción" },
      { id: 43, name: "Obra Civil Terminada" },
      { id: 44, name: "Rotura de Cristales" },
      { id: 45, name: "Rotura de Maquinaria" },
      { id: 35, name: "Otro" },
      { id: 63, name: "Terrorismo y Sabotaje" },
    ];
    order.types_lf = [
      { id: 53, name: "CRIME/BBB" },
      { id: 54, name: "D&O" },
      { id: 55, name: "FIPI" },
      { id: 56, name: "CYBER" },
      { id: 57, name: "VCAPS" },
      { id: 58, name: "RCP MÉDICA" },
      { id: 59, name: "E&O MISCELANEO" },
      { id: 60, name: "RIESGO POLITICO" },
      { id: 61, name: "RC SERVIDORES PUBLICOS" },
      { id: 62, name: "RCP" },
    ];
    $scope.paqueteGuardado = false;
    $scope.dataToSave = {};
    $scope.coverages = [];
    $scope.addCoverages = false;
    $scope.newCoverPack = false;

    $scope.celulas = [];
    $scope.agrupaciones = [];
    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    $scope.campo_agrupacion = false;
    $scope.campo_celula = false;
    $scope.campo_lineanegocio = false;
    $scope.moduleName = "Célula";
    dataFactory.get("orginfo/").then(function success(response) {
      if (response.data.results.length) {
        $scope.configuracionGlobal = response.data.results[0];
        $scope.campo_agrupacion = $scope.configuracionGlobal.filtros_agrupacion;
        $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
        $scope.campo_lineanegocio =
          $scope.configuracionGlobal.filtros_lineanegocio;
        if ($scope.configuracionGlobal.moduleName) {
          $scope.moduleName = $scope.configuracionGlobal.moduleName;
        }
      }
    });
    order.ceder_porcentaje = ceder_porcentaje;
    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Referenciadores") {
          order.acceso_refereciador = perm;
          order.acceso_refereciador.permissions.forEach(function (acc) {
            if (acc.permission_name == "Cambiar refrenciador en pólizas") {
              if (acc.checked == true) {
                order.acceso_chng_ref = true;
              } else {
                order.acceso_chng_ref = false;
              }
            }
            if (acc.permission_name == "Referenciador no obligatorio") {
              if (acc.checked == true) {
                order.acc_referenciador_obligatorio = true;
              } else {
                order.acc_referenciador_obligatorio = false;
              }
            }
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                order.acceso_ver_ref = true;
              } else {
                order.acceso_ver_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Pólizas") {
          order.acceso_polizas = perm;
          order.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                order.acceso_adm_pol = true;
              } else {
                order.acceso_adm_pol = false;
              }
            }
            if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                order.acceso_ver_pol = true;
              } else {
                order.acceso_ver_pol = false;
              }
            }
            if (acc.permission_name == "Comisión no obligatoria") {
              if (acc.checked == true) {
                order.permiso_comision_no_obligatoria = true;
              } else {
                order.permiso_comision_no_obligatoria = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          order.acceso_reportes = perm;
          order.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                order.acceso_rep_fia = true;
              } else {
                order.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                order.acceso_rep_sin = true;
              } else {
                order.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                order.acceso_rep_end = true;
              } else {
                order.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                order.acceso_rep_pol = true;
              } else {
                order.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                order.acceso_rep_ren = true;
              } else {
                order.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                order.acceso_rep_cob = true;
              } else {
                order.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          order.coms = perm;
          order.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                order.permiso_comisiones = true;
              } else {
                order.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                order.permiso_administrar_adjuntos = true;
              } else {
                order.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };
    $scope.calculateComision = function (item, index) {
      console.log("hyyyyyyyyyyyyy", item, index);
    };

    $scope.checkDate = function (param) {
      if (param.length == 10) {
        var x = mesDiaAnio(param);
        param = convertDate(x);
      }
    };

    if ($localStorage.orderFormCotizacion) {
      try {
        var dataOrderForm = JSON.parse($localStorage.orderFormCotizacion);
        startDate = convertDate(new Date(mesDiaAnio(dataOrderForm.startDate)));
        endingDate = convertDate(
          new Date(mesDiaAnio(dataOrderForm.endingDate))
        );
        $scope.dataToSave.start_of_validity = new Date(mesDiaAnio(startDate));
        $scope.dataToSave.end_of_validity = new Date(mesDiaAnio(endingDate));
      } catch (e) {
        startDate = convertDate(new Date());
        var endingDate = convertDate(
          new Date().setYear(new Date().getFullYear() + 1)
        );

        $scope.dataToSave.start_of_validity = new Date(mesDiaAnio(startDate));
        $scope.dataToSave.end_of_validity = new Date(mesDiaAnio(endingDate));
      }
    } else {
      startDate = convertDate(new Date());
      // console.log('startDate', startDate);
      var endingDate = convertDate(
        new Date().setYear(new Date().getFullYear() + 1)
      );

      $scope.dataToSave.start_of_validity = new Date(mesDiaAnio(startDate));
      $scope.dataToSave.end_of_validity = new Date(mesDiaAnio(endingDate));
    }
    order.showButtonPoliza = showButtonPoliza;
    order.hideButtonOT = hideButtonOT;
    order.setContractor = setContractor;
    order.getInternalNumber = getInternalNumber;
    order.refreshProvider = fillProvider;

    // order.
    order.hidden = true;

    $scope.sex = [
      { name: "MASCULINO", value: "M" },
      { name: "FEMENINO", value: "F" },
    ];

    $scope.seller = [];
    $scope.isSeller = [];

    $scope.pay_ways = [
      { key: 1, val: "Clave" },
      { key: 2, val: "Número de cuenta" },
      { key: 3, val: "Número de tarjeta" },
      { key: 4, val: "Efectivo" },
    ];

    $scope.fcs = [
      { key: 1, val: "Semanal" },
      { key: 2, val: "Quincenal" },
      { key: 3, val: "Mensual" },
    ];

    $scope.delete_subramos = [];
    $scope.delete_phones = [];

    order.subramo = {
      ramos: "",
      sub_ramos: "",
      provider: "",
      ramo: "",
      subramo: "",
      comision_percentage: "",
    };

    order.ceder_comision = ceder_comision;
    $scope.ceder_comision = false; // para mostrar los valores de las claves

    order.form = {
      canCreate: false,
      contratante: "",
      poliza: "",
      folio: "",
      tel: "",
      correo: "",
      ramo: "",
      type: "",
      subramo: "",
      aseguradora: "",
      paquete: "",
      payment: "",
      internal_number: "",
      startDate: startDate,
      endingDate: endingDate,
      start_of_validity: new Date(mesDiaAnio(startDate)),
      end_of_validity: new Date(mesDiaAnio(endingDate)),
      ceder_comision: false,
      comision_percent: 0.0,
      renewal: 1,
      hospital_level: "",
      tabulator: "",
      business_line: 0,
      is_edit: false,
      from_pdf: false,
    };
    $scope.order = order;
    $scope.fake_ramos = [
      {
        id: -1,
        ramo_code: -1,
        ramo_name: "Vida",
        subramo_ramo: [
          {
            id: -1,
            subramo_code: -1,
            subramo_name: "Vida",
          },
        ],
      },
      {
        id: -2,
        ramo_code: -2,
        ramo_name: "Accidentes y Enfermedades",
        subramo_ramo: [
          {
            id: -2,
            subramo_code: -2,
            subramo_name: "Accidentes Personales",
          },
          {
            id: -3,
            subramo_code: -3,
            subramo_name: "Gastos Médicos",
          },
          {
            id: -4,
            subramo_code: -4,
            subramo_name: "Salud",
          },
        ],
      },
      {
        id: -3,
        ramo_code: -3,
        ramo_name: "Daños",
        subramo_ramo: [
          {
            id: -5,
            subramo_code: -5,
            subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
          },
          {
            id: -6,
            subramo_code: -6,
            subramo_name: "Marítimo y Transportes",
          },
          {
            id: -7,
            subramo_code: -7,
            subramo_name: "Incendio",
          },
          {
            id: -8,
            subramo_code: -8,
            subramo_name: "Agrícola y de Animales",
          },
          {
            id: -9,
            subramo_code: -9,
            subramo_name: "Automóviles",
          },
          {
            id: -10,
            subramo_code: -10,
            subramo_name: "Crédito",
          },
          {
            id: -11,
            subramo_code: -11,
            subramo_name: "Crédito a la Vivienda",
          },
          {
            id: -12,
            subramo_code: -12,
            subramo_name: "Garantía Financiera",
          },
          {
            id: -13,
            subramo_code: -13,
            subramo_name: "Diversos",
          },
          {
            id: -14,
            subramo_code: -14,
            subramo_name: "Terremoto y Otros Riesgos Catastróficos",
          },
        ],
      },
    ];
    // var vm = this;
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };
    order.user = usr;
    $http.get(url.IP + "get-vendors/").then(function (user) {
      $scope.referenciador = user.data;
      $scope.referenciador.forEach(function (user) {
        user.first_name = user.first_name.toUpperCase();
        user.last_name = user.last_name.toUpperCase();
        user["phones"] = [];
        user["subramos"] = [];
      });
    });
    // $(w).load(function() {
    //   $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    $http.get(url.IP + "usuarios/").then(function (user) {
      // $scope.users = user.data.results;
      // console.log('users', $scope.users);
      $scope.users = [];
      $scope.ejecutivo_cobranza = [];
      user.data.results.forEach(function (usr) {
        usr.first_name = usr.first_name.toUpperCase();
        usr.last_name = usr.last_name.toUpperCase();
        if (usr.user_info.is_active) {
          $scope.users.push(usr);
          $scope.ejecutivo_cobranza.push(usr);
        }
      });

      $scope.show_pagination = true;
      $scope.config_pagination = {
        count: user.data.count,
        next: user.data.next,
        previous: user.data.previous,
      };

      $scope.testPagination("users", "config_pagination");

      $scope.users.forEach(function (user) {
        user["phones"] = [];
        user["subramos"] = [];
      });
    });

    // $scope.aseguradorasPdfs = [
    //   {'alias': 'ABA'},
    //   {'alias': 'AIG'},
    //   {'alias': 'ATLAS'},
    //   {'alias': 'GNP'},
    //   {'alias': 'HDI'},
    //   {'alias': 'MAPFRE'},
    //   {'alias': 'PS'},
    //   {'alias': 'QUALITAS'},
    //   {'alias': 'SURA'},
    //   {'alias': 'ZURICH'}
    // ];

    $http.get(url.IP + "aseguradoras-lectura-documentos").then(function (data) {
      $scope.aseguradorasPdfs = data.data;
    });

    $scope.loaderPdf = false;
    $scope.read_pdf_contractor = {};

    providerService.getReadListProviders().then(function (provider) {
      $scope.aseguradoras = provider;
    });

    var NO_COVERAGES_VALUES = "noCoveragesValues";

    $scope.fileNameChanged = function (ele) {
      $scope.filePdf = ele.files[0];
      $scope.fileSelected = ele.files[0];
    };
    $scope.showFile = function (argument) {
      var reader = new FileReader();
      reader.readAsDataURL(argument.files[0]);
      $scope.fileSelected = argument.files[0];
      // $scope.uploader.queue = argument.files[0]
      var reader_pdf = new FileReader();
      reader_pdf.readAsDataURL($scope.fileSelected);
      $scope.urlsfile = URL.createObjectURL(argument.files[0]);
      reader_pdf.onload = function () {
        $scope.pdffile = reader_pdf.result;
        $scope.okxfile = new Blob([$scope.pdffile], {
          type: "application/pdf",
        });
        var fileURL = $scope.urlsfile;
        $scope.content = $sce.trustAsResourceUrl(fileURL);
        // window.open($scope.content);
      };
      reader_pdf.onerror = function (error) {
        console.log("Error: ", error);
      };
    };
    $scope.verpdf = function (ele) {
      // console.log('-eleeee',ele,$scope.filePdf)
    };
    $scope.changePdf = function (item) {
      $scope.aseguradoraPdf = item;
      order.defaults.providers.forEach(function (pv) {
        if (pv.alias == item) {
          order.form.aseguradora = pv;
        }
      });
    };
    $scope.changeBusinessLine = function (val) {
      // console.log('...businesline---',val)
    };

    $scope.changeRamoPdf = function (ramo) {
      $scope.ramoPdf = ramo;
      if (order.defaults.ramos) {
        if (order.defaults.ramos.length > 0) {
          order.defaults.ramos.forEach(function (rm) {
            if (rm.ramo_code == ramo.ramo_id) {
              order.form.ramo = rm;
            }
            if (ramo.ramo_id == 9 && rm.ramo_code == 3) {
              order.form.ramo = rm;
            }
          });
        }
      }
    };
    function formatearNumero_calculate(nStr, campo) {
      try {
        nStr += "";
        var x = nStr.split(".");
        var x1 = x[0];
        var x2 = x.length > 1 ? "." + x[1] : "";

        var cadenas = x1.split(",");
        var cadena_sin_comas = "";
        for (i = 0; i < cadenas.length; i++) {
          cadena_sin_comas = cadena_sin_comas + cadenas[i];
        }
        if (
          cadena_sin_comas != undefined &&
          cadena_sin_comas != "undefined" &&
          cadena_sin_comas != "NaN" &&
          cadena_sin_comas != NaN
        ) {
          return cadena_sin_comas + x2;
        } else {
          return nStr;
        }
      } catch (e) {
        return 0;
      }
    }
    function sinDiacriticos(texto) {
      return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    function generarRequestId() {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      var hex = Array.prototype.map
        .call(bytes, function (b) {
          return ("0" + b.toString(16)).slice(-2);
        })
        .join("");
      return [
        hex.substr(0, 8),
        hex.substr(8, 4),
        hex.substr(12, 4),
        hex.substr(16, 4),
        hex.substr(20),
      ].join("-");
    }
    $scope.mostrarAdvertenciaSerie = true; // flag inicial
    $scope.omitirAdvertencia = function () {
      $scope.mostrarAdvertenciaSerie = false;
      $scope.saveLogOmitedFlagSerie = true;
    };
    $scope.capturarPoliza = function () {
      if (!$scope.filePdf) {
        SweetAlert.swal(
          "Error",
          "Cargue un archivo pdf para capturar.",
          "error"
        );
        return;
      }
      $scope.read_pdf = {};
      order.form = {};
      $localStorage["datos_pdf"] = {};
      $localStorage["primas"] = {};
      $localStorage["defaults"] = {};
      SweetAlert.swal(
        {
          title: "🔎 Revisión de la información extraída",
          text:
            "<p style='margin:0 0 10px;'>Antes de guardar, verifique que los datos obtenidos del PDF sean <strong>correctos</strong> y estén <strong>completos</strong>.</p>" +
            "<p style='margin:0 0 6px 0;'><strong>Aspectos clave a validar:</strong></p>" +
            "<ul style='margin:0 0 0 18px; padding:0; line-height:1.5;'>" +
            "  <li><strong>Número de póliza</strong> y <strong>vigencia</strong></li>" +
            "  <li><strong>Serie</strong> (en caso de Automóviles) y <strong>Asegurados</strong></li>" +
            "  <li><strong>Coberturas</strong> y <strong>primas</strong></li>" +
            "  <li><strong>Datos del contratante</strong>: Nombre y RFC</li>" +
            "</ul>" +
            "<p style='margin:12px 0 0; font-size:12px; color:#5f6368;'>⚠️ En caso de detectar alguna discrepancia, informe a Soporte.</p>",
          type: "warning",
          html: true,
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Continuar",
          closeOnConfirm: true,
          closeOnCancel: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            console.log("continuar", isConfirm);
          }
        }
      );

      $scope.countFile = 0;
      $scope.loaderPdf = true;

      var xhr = new XMLHttpRequest();
      // xhr.open("POST", url.SERVICE_PDF);
      xhr.open("POST", url.LECTORPDF + "upload-pdf");
      // xhr.open("POST", 'https://lector-pdf.mbxservicios.com/upload-pdf');
      try {
        obtenerSerieImagen($scope.filePdf);
      } catch (e) {
        console.log("eror al extraer imagen", e);
      }
      var auxRamo =
        $scope.ramoPdf && $scope.ramoPdf.ramo_id ? $scope.ramoPdf.ramo_id : 0;

      var data = new FormData();
      var dataFile = new FormData();
      dataFile.append("arch", $scope.filePdf);
      dataFile.append("nombre", $scope.fileSelected.name);
      data.append("archivo", $scope.filePdf);
      // data.append("insurance", $scope.aseguradoraPdf);
      // 3) Añade tus parámetros adicionales
      data.append("nombre", $scope.fileSelected.name);
      data.append("org", $scope.orgName);
      var requestId = generarRequestId();
      data.append("requestId", requestId);
      $localStorage.dataFile = dataFile;
      $scope.fileSelected.formData = [];

      try {
        enviarPDFSerieXHR(
          $scope.fileSelected,
          $scope.orgName,
          Date.now().toString(),
          function (resp) {
            $scope.$apply(function () {
              var raw = resp.data.image_b64; // ajusta a tu ruta real (a veces es resp.data.data.image_b64)
              var src = raw.startsWith("data:")
                ? raw
                : "data:image/png;base64," + raw;

              // 1) lo que pintas
              $scope.imgSerieSrc = $sce.trustAsResourceUrl(src);

              // 2) lo que guardas (string)
              $localStorage.imgSerieSrc = src;
            });
          },
          function (err) {
            console.error(err);
          }
        );
      } catch (u) {
        console.log("uu erorr image", u);
      }
      try {
        enviarPDFPrimasXHR(
          $scope.fileSelected,
          $scope.orgName,
          Date.now().toString(),
          function (resp) {
            $scope.$apply(function () {
              var imagenok = "";
              var raw = resp.data.sections; // ajusta a tu ruta real (a veces es resp.data.data.image_b64)
              if (raw && raw[0] && raw[0].image_b64) {
                imagenok = raw[0].image_b64;
              } else {
                if (raw && raw[1] && raw[1].image_b64) {
                  imagenok = raw[1].image_b64;
                }
              }
              if (imagenok) {
                var src = imagenok.startsWith("data:")
                  ? imagenok
                  : "data:image/png;base64," + imagenok;
                // 1) lo que pintas
                $scope.imgPrimasSrc = $sce.trustAsResourceUrl(src);
                // 2) lo que guardas (string)
                $localStorage.imgPrimasSrc = src;
              }
            });
          },
          function (err) {
            console.error(err);
          }
        );
      } catch (u) {
        console.log("uu erorr image", u);
      }
      xhr.timeout = 1200000;
      xhr.ontimeout = function (e) {
        console.log("error", e);
        $scope.loaderPdf = true;
        SweetAlert.swal(
          "Error**",
          "A ocurrido un error al cargar el PDF, por favor intentalo de nuevo.",
          "error"
        );
      };
      xhr.send(data);
      xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          $scope.loaderPdf = false;
          $scope.read_pdf = JSON.parse(xhr.response);
          if ($scope.read_pdf.status != "200_OK_ACCEPTED") {
            SweetAlert.swal(
              "Error*",
              "A ocurrido un error al cargar el PDF, por favor intentalo de nuevo.",
              "error"
            );
          } else {
            if ($scope.read_pdf.request_id !== requestId) {
              console.log(
                "No coincide*",
                $scope.read_pdf.request_id,
                requestId
              );
              // SweetAlert.swal("Error", "Cargue un archivo pdf para capturar.", "error");
              // return;
            }
            // else {
            //   console.log('Resultado ok *:', $scope.read_pdf.data);
            // }
            $localStorage["datos_pdf"] = $scope.read_pdf;
            $scope.filePdf = {};
            $scope.referenciadores = [$scope.referenciador];
            // $scope.referenciadores = []
            // $http.get(url.IP + 'get-vendors/')
            // .then(function(user) {
            //   $scope.referenciador = user.data;
            //   $scope.referenciador.forEach(function(user) {
            //     user.first_name = user.first_name.toUpperCase()
            //     user.last_name = user.last_name.toUpperCase()
            //     user['phones'] = [];
            //     user['subramos'] = [];
            //   });
            // });
            $scope.activeJustified = 1;
            order.show.ot = false;
            if ($scope.read_pdf.data["Numero de poliza"]) {
              order.form.poliza = $scope.read_pdf.data["Numero de poliza"];
            }
            if (
              $scope.read_pdf.data["Datos generales de la poliza"] &&
              $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
              $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
                "NACIONAL"
            ) {
              $scope.order.f_currency.f_currency_selected = 1;
              order.f_currency.f_currency_selected = 1;
            }
            if (
              $scope.read_pdf.data["Datos generales de la poliza"] &&
              $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
              ($scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
                "Dolares" ||
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Moneda"
                ].toLowerCase() == "dolares")
            ) {
              $scope.order.f_currency.f_currency_selected = 2;
              order.f_currency.f_currency_selected = 2;
            }
            if (
              $scope.read_pdf.data["Datos generales de la poliza"] &&
              $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
              !$scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
                "EXTRANJERA"
            ) {
              order.f_currency.f_currency_selected = 2;
              $scope.order.f_currency.f_currency_selected = 2;
            }
            if (
              $scope.read_pdf.data["Datos generales de la poliza"] &&
              $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
              ($scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
                "udi" ||
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Moneda"
                ].toLowerCase() == "udis")
            ) {
              $scope.order.f_currency.f_currency_selected = 3;
              order.f_currency.f_currency_selected = 3;
            }
            order.conducto_de_pago.conducto_de_pago_selected = 1;
            $scope.pintarCoberturas = true;

            order.form.payment =
              $scope.read_pdf.data["Datos generales de la poliza"][
                "Forma de pago"
              ];
            if (!order.form.payment) {
              try {
                order.form.payment =
                  $scope.read_pdf.data["Primas"]["Forma_de_Pago"];
              } catch (idx) {}
            }
            if (order && order.form) {
              var p = Number(order.form.payment); // por si viene "15" string

              if ([15, 7, 14].indexOf(p) !== -1) {
                order.form.payment = 12; // ✅ reset a anual

                SweetAlert.swal(
                  "Advertencia",
                  "La forma de pago detectada (" +
                    p +
                    ") no aplica en este formato. Se ajustó a ANUAL (12). Verifica tu archivo o selecciona la forma de pago correcta.",
                  "warning"
                );
              }
            }
            $scope.paqueteOriginal = $scope.read_pdf.data.cobertura;
            if ($scope.read_pdf.data["Datos del vehiculo"]) {
              order.subforms.auto.brand =
                $scope.read_pdf.data["Datos del vehiculo"]["marca"];
              order.subforms.auto.model =
                $scope.read_pdf.data["Datos del vehiculo"]["modelo"];
              order.subforms.auto.year =
                $scope.read_pdf.data["Datos del vehiculo"]["anio"];
              order.subforms.auto.engine =
                $scope.read_pdf.data["Datos del vehiculo"]["motor"];
              order.subforms.auto.serial =
                $scope.read_pdf.data["Datos del vehiculo"]["serie"];
              $scope.serieAGuardar = order.subforms.auto.serial;
              if (order.subforms.auto.serial) {
                $scope.checkNumSerie();
              }
              // order.subforms.auto.license_plates = $scope.read_pdf.data['Datos del vehiculo']['clave_vehicular'];
              order.subforms.auto.license_plates =
                $scope.read_pdf.data["Datos del vehiculo"]["placas"];
              var datosVehiculo = $scope.read_pdf.data["Datos del vehiculo"];

              order.subforms.auto.version = datosVehiculo.version
                ? datosVehiculo.version
                : datosVehiculo.descripcion_vehiculo
                ? datosVehiculo.descripcion_vehiculo
                : datosVehiculo.clave_vehicular;
              order.subforms.auto.color =
                $scope.read_pdf.data["Datos del vehiculo"]["color"];
              order.subforms.auto.service =
                $scope.read_pdf.data["Datos del vehiculo"]["servicio"];
              if (
                (order &&
                  order.subforms &&
                  order.subforms.auto &&
                  order.subforms.auto.service == "") ||
                order.subforms.auto.service == undefined ||
                order.subforms.auto.service == null
              ) {
                if (
                  $scope.read_pdf &&
                  $scope.read_pdf.data &&
                  $scope.read_pdf.data["Datos del vehiculo"]["uso"]
                ) {
                  if (
                    parseInt(
                      $scope.read_pdf.data["Datos del vehiculo"]["uso"]
                    ) == 1
                  ) {
                    order.subforms.auto.service = "PARTICULAR";
                  } else if (
                    parseInt(
                      $scope.read_pdf.data["Datos del vehiculo"]["uso"]
                    ) == 2
                  ) {
                    order.subforms.auto.service = "CARGA";
                    if (
                      $scope.read_pdf.data &&
                      $scope.read_pdf.data["Datos del vehiculo"] &&
                      $scope.read_pdf.data["Datos del vehiculo"][
                        "tipo de carga"
                      ]
                    ) {
                      if (
                        $scope.read_pdf.data["Datos del vehiculo"][
                          "tipo de carga"
                        ] == "A"
                      ) {
                        order.subforms.auto.charge_type = 1;
                      } else if (
                        $scope.read_pdf.data["Datos del vehiculo"][
                          "tipo de carga"
                        ] == "B"
                      ) {
                        order.subforms.auto.charge_type = 2;
                      } else if (
                        $scope.read_pdf.data["Datos del vehiculo"][
                          "tipo de carga"
                        ] == "C"
                      ) {
                        order.subforms.auto.charge_type = 3;
                      } else {
                        order.subforms.auto.charge_type = 1;
                      }
                    }
                  } else if (
                    parseInt(
                      $scope.read_pdf.data["Datos del vehiculo"]["uso"]
                    ) == 3
                  ) {
                    order.subforms.auto.service = "SERVICIO PÚBLICO";
                  } else {
                    order.subforms.auto.service = "PARTICULAR";
                  }
                }
              }
              order.form.identifier =
                order.subforms.auto.brand + " " + order.subforms.auto.model;
              // if(order.form.identifier !=order.subforms.auto.version){
              //   order.form.identifier = order.form.identifier+' '+order.subforms.auto.version
              // }
              try {
                order.subforms.auto.usage = parseInt(
                  $scope.read_pdf.data["Datos del vehiculo"]["uso"]
                );
              } catch (err) {}
            }
            try {
              if (
                $scope.read_pdf.data &&
                $scope.read_pdf.data["Datos del vehiculo"] &&
                $scope.read_pdf.data["Datos del vehiculo"]["tipo de carga"] &&
                $scope.read_pdf.data["Datos del vehiculo"]["uso"]
              ) {
                if (
                  parseInt($scope.read_pdf.data["Datos del vehiculo"]["uso"]) ==
                  2
                ) {
                  if (
                    $scope.read_pdf.data["Datos del vehiculo"][
                      "tipo de carga"
                    ] == "A"
                  ) {
                    order.subforms.auto.charge_type = 1;
                  } else if (
                    $scope.read_pdf.data["Datos del vehiculo"][
                      "tipo de carga"
                    ] == "B"
                  ) {
                    order.subforms.auto.charge_type = 2;
                  } else if (
                    $scope.read_pdf.data["Datos del vehiculo"][
                      "tipo de carga"
                    ] == "C"
                  ) {
                    order.subforms.auto.charge_type = 3;
                  } else {
                    order.subforms.auto.charge_type = 1;
                  }
                }
              }
            } catch (err) {}

            //  movi este corchete aqui para que pueda leer gastos medicos sin datos del vehiculo
            if ($scope.read_pdf.data["ramo"]) {
              $scope.ramoPdf = $scope.read_pdf.data["ramo"];
            } else {
              $scope.ramoPdf = "";
              $scope.contratante = {};
            }

            var aseguradora_a_capturar = sinDiacriticos(
              $scope.read_pdf.data["aseguradora"].toLowerCase()
            );
            order.defaults.providers.some(function (x) {
              if (aseguradora_a_capturar == "chubb") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "CHUBB" ||
                  sinDiacriticos(x.alias).toLowerCase() == "Aba" ||
                  sinDiacriticos(x.alias).toLowerCase() == "ABA" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "chubb seguros mexico"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "qualitas") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "Quálitas" ||
                  sinDiacriticos(x.alias).toLowerCase() == "Qualitas" ||
                  sinDiacriticos(x.alias).toLowerCase() == "QUALITAS" ||
                  sinDiacriticos(x.alias).toLowerCase() == "QUÁLITAS"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }

              if (aseguradora_a_capturar == "gnp") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "gnp" ||
                  sinDiacriticos(x.alias).toLowerCase() == "gnp seguros" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "grupo nacional provincial" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "grupo nacional provincial "
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "axa") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "axa" ||
                  sinDiacriticos(x.alias).toLowerCase() == "axa seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "hdi") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "hdi" ||
                  sinDiacriticos(x.alias).toLowerCase() == "HDI"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "primero seguros") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "Primero Seguros" ||
                  sinDiacriticos(x.alias).toLowerCase() == "Pimero seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "ana") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "ana" ||
                  sinDiacriticos(x.alias).toLowerCase() == "ana seguros" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "ana compania de seguros "
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }

              if (aseguradora_a_capturar.toLowerCase() == "momento") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "momento"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "afirme") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "seguros afirme"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "zurich") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "zurich seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "mapfre") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "mapfre"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (
                aseguradora_a_capturar == "seguros monterrey" ||
                aseguradora_a_capturar == "seguros monterrey new york life"
              ) {
                aseguradora_a_capturar = "seguros monterrey new york life";
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "seguros monterrey new york life"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (
                aseguradora_a_capturar == "seguros bx+" ||
                aseguradora_a_capturar == "bx+" ||
                aseguradora_a_capturar == "Seguros Bx+"
              ) {
                aseguradora_a_capturar = "bx+";
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "seguros ve por mas" ||
                  sinDiacriticos(x.alias).toLowerCase() == "bx+" ||
                  sinDiacriticos(x.alias).toLowerCase() == "seguros bx+" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "grupo financiero ve por mas" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "grupo financiero ve por mas "
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (
                aseguradora_a_capturar == "Metlife" ||
                aseguradora_a_capturar == "metlife"
              ) {
                aseguradora_a_capturar = "metlife";
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "met life" ||
                  sinDiacriticos(x.alias).toLowerCase() == "metlife"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (
                aseguradora_a_capturar == "PlanSeguro" ||
                aseguradora_a_capturar == "planseguro" ||
                aseguradora_a_capturar == "plan seguro"
              ) {
                aseguradora_a_capturar = "plan seguro";
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "plan seguros" ||
                  sinDiacriticos(x.alias).toLowerCase() == "plan seguro " ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "plan de seguro cía de seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (
                aseguradora_a_capturar == "Bupa" ||
                aseguradora_a_capturar == "bupa"
              ) {
                aseguradora_a_capturar = "bupa";
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "bupa" ||
                  sinDiacriticos(x.alias).toLowerCase() == "bupa seguros" ||
                  sinDiacriticos(x.alias).toLowerCase() == "seguros bupa" ||
                  sinDiacriticos(x.alias).toLowerCase() == "bupa mexico"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              if (aseguradora_a_capturar == "zurich") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "zurich " ||
                  sinDiacriticos(x.alias).toLowerCase() == "zurich seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                }
              }
              // vida
              if (aseguradora_a_capturar == "atlas") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "seguros atlas"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                  return true;
                }
              }
              return false;
            });

            order.subforms.auto.policy_type = { id: 1, name: "Automóvil" };
            order.subforms.auto.procedencia = { id: 1, name: "Residente" };
            if (
              aseguradora_a_capturar == "hdi" &&
              $scope.read_pdf.data["Datos del vehiculo"]["tipo"] == "Pick Up"
            ) {
              order.subforms.auto.policy_type = { id: 5, name: "Pick Up" };
            }
            // $scope.saveLocalstorange();

            // if ($scope.read_pdf.data.data.life_policy){
            //   order.subforms.life.aseguradosList = [$scope.read_pdf.data.data.life_policy.personal];
            //   order.subforms.life.beneficiariesList = [$scope.read_pdf.data.data.life_policy.beneficiaries_life]
            //   order.subforms.life.beneficiariesList = order.subforms.life.beneficiariesList.map(function(item){
            //     item = item[0];
            //     item['person'] = 1;
            //     item['percentage'] = item['percentage'] ? parseFloat(item['percentage']) : 0;
            //     return item
            //   })
            // }

            // if ($scope.read_pdf.data.data.accidents_policy){
            //   order.subforms.disease.first_name = [$scope.read_pdf.data.data.accidents_policy.disease_type.first_name];
            //   order.subforms.disease.last_name = [$scope.read_pdf.data.data.accidents_policy.disease_type.last_name];
            //   order.subforms.disease.second_last_name = [$scope.read_pdf.data.data.accidents_policy.disease_type.second_last_name];
            //   order.subforms.disease.birthdate = [$scope.read_pdf.data.data.accidents_policy.disease_type.birthdate];
            //   $scope.sex.forEach(function(item){
            //     if(item.value == $scope.read_pdf.data.data.accidents_policy.disease_type.sex){
            //       order.subforms.disease.sex = item.value;
            //     }
            //   })
            //   order.subforms.disease.antiguedad = [$scope.read_pdf.data.data.accidents_policy.disease_type.antiguedad];
            //   order.subforms.disease.relationship_accident = [$scope.read_pdf.data.data.life_policy.relationship_accident]
            //   order.subforms.disease.relationship_accident = order.subforms.disease.relationship_accident.map(function(item){
            //     item = item[0];
            //     item['person'] = 1;
            //     item['percentage'] = item['percentage'] ? parseFloat(item['percentage']) : 0;
            //     return item
            //   })

            // }

            order.form.from_pdf = true;
            if (
              $scope.read_pdf.data["contratante_full_name"].indexOf("S.A. DE") >
              -1
            ) {
              $scope.read_pdf_contractor.type = false;
              $scope.read_pdf_contractor.name =
                $scope.read_pdf.data["contratante_full_name"];
            } else {
              $scope.read_pdf_contractor.type = true;
              // $scope.read_pdf_contractor.name = $scope.read_pdf.data['Datos del asegurado']['propietario_contratante']
              $scope.read_pdf_contractor.name =
                $scope.read_pdf.data["contratante_full_name"];
            }
            if (
              $scope.read_pdf.data["Primas"] &&
              $scope.read_pdf.data["Primas"]["Prima total"]
            ) {
              $scope.order.form.primaTotal = $scope.read_pdf.data["Primas"][
                "Prima total"
              ]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf.data["Primas"]["Prima total"]
                    )
                  )
                : $scope.read_pdf.data["Primas"]["IMPORTE TOTAL"]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf.data["Primas"]["IMPORTE TOTAL"]
                    )
                  )
                : 0;
              $scope.order.form.subTotal = $scope.read_pdf.data["Primas"][
                "Subtotal"
              ]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf.data["Primas"]["Subtotal"]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }

            if (
              $scope.read_pdf.data["Primas"] &&
              $scope.read_pdf.data["Primas"]["Prima neta"]
            ) {
              $scope.order.form.primaNeta = $scope.read_pdf.data["Primas"][
                "Prima neta"
              ]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf.data["Primas"]["Prima neta"]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }

            if (
              $scope.read_pdf.data["Primas"] &&
              $scope.read_pdf.data["Primas"]["Gastos de expedición"]
            ) {
              try {
                $scope.order.form.derecho = $scope.read_pdf.data["Primas"][
                  "Gastos de expedición"
                ]
                  ? parseFloat(
                      formatearNumero_calculate(
                        $scope.read_pdf.data["Primas"]["Gastos de expedición"]
                      )
                    )
                  : 0;
                $localStorage["primas"] = $scope.order.form;
              } catch (o) {
                $scope.order.form.derecho = $scope.read_pdf.data["Primas"][
                  "Gastos de expedici\u00f3n"
                ]
                  ? parseFloat(
                      formatearNumero_calculate(
                        $scope.read_pdf.data["Primas"][
                          "Gastos de expedici\u00f3n"
                        ]
                      )
                    )
                  : 0;
                $localStorage["primas"] = $scope.order.form;
              }
            }
            if (
              $scope.read_pdf.data["Primas"] &&
              $scope.read_pdf.data["Primas"]["Gastos por Expedición."]
            ) {
              try {
                $scope.order.form.derecho = $scope.read_pdf.data["Primas"][
                  "Gastos por Expedición."
                ]
                  ? parseFloat(
                      formatearNumero_calculate(
                        $scope.read_pdf.data["Primas"]["Gastos por Expedición."]
                      )
                    )
                  : 0;
                $localStorage["primas"] = $scope.order.form;
              } catch (o) {
                $scope.order.form.derecho = $scope.read_pdf.data["Primas"][
                  "Gastos por Expedici\u00f3n."
                ]
                  ? parseFloat(
                      formatearNumero_calculate(
                        $scope.read_pdf.data["Primas"][
                          "Gastos por Expedici\u00f3n."
                        ]
                      )
                    )
                  : 0;
                $localStorage["primas"] = $scope.order.form;
              }
            }
            if (
              $scope.read_pdf.data["Primas"] &&
              $scope.read_pdf.data["Primas"][
                "Financiamiento por pago fraccionado"
              ]
            ) {
              $scope.order.form.rpf = $scope.read_pdf.data["Primas"][
                "Financiamiento por pago fraccionado"
              ]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf.data["Primas"][
                        "Financiamiento por pago fraccionado"
                      ]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }
            if (
              $scope.read_pdf.data["Primas"] &&
              $scope.read_pdf.data["Primas"]["Derecho de Póliza"]
            ) {
              $scope.order.form.derecho = $scope.read_pdf.data["Primas"][
                "Derecho de Póliza"
              ]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf.data["Primas"]["Derecho de Póliza"]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }
            if (
              $scope.read_pdf.data["Primas"] &&
              $scope.read_pdf.data["Primas"]["Descuento"]
            ) {
              var valor =
                parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf.data["Primas"]["Descuento"]
                  )
                ) || 0;
              // Si el valor es negativo → convertirlo a positivo multiplicando por -1
              if (valor < 0) {
                valor = valor * -1;
              }
              $scope.order.form.descuento = valor;
              $localStorage["primas"] = $scope.order.form;
            } else {
              $scope.order.form.descuento = 0;
            }
            if (
              $scope.read_pdf.data["Primas"] &&
              $scope.read_pdf.data["Primas"]["I.V.A."]
            ) {
              $scope.order.form.iva = $scope.read_pdf.data["Primas"]["I.V.A."]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf.data["Primas"]["I.V.A."]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }
            if (
              $scope.read_pdf.data["Primas"] &&
              $scope.read_pdf.data["Primas"]["IVA"]
            ) {
              $scope.order.form.iva = $scope.read_pdf.data["Primas"]["IVA"]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf.data["Primas"]["IVA"]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.order.form;
            }

            // $scope.verComisiones();
            order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
            order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
            try {
              $scope.order.form.startDate =
                $scope.read_pdf.data["fecha_inicio"];
              $scope.order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
              order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
              order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
            } catch (f) {}
            order.form.endDate = $scope.read_pdf.data["fecha_fin"];
            order.form.start_of_validity = new Date(
              $scope.read_pdf.data["fecha_inicio"]
            );
            order.form.end_of_validity = new Date(
              $scope.read_pdf.data["fecha_fin"]
            );

            $scope.dataToSave.start_of_validity = mesDiaAnio(
              order.form.startDate
            );
            $scope.dataToSave.end_of_validity = mesDiaAnio(
              order.form.endingDate
            );

            var date1 = new Date($scope.dataToSave.start_of_validity);
            var date2 = new Date($scope.dataToSave.end_of_validity);
            var timeDiff = Math.abs(date2.getTime() - date1.getTime());
            order.form.policy_days_duration = Math.ceil(
              timeDiff / (1000 * 3600 * 24)
            );
            // $scope.checkEndDate()
            order.form.from_pdf = true;
            // $rootScope.readPDF = {
            //   individual:$scope.read_pdf.data['Datos del asegurado'],
            //   corporation: $scope.read_pdf.data['Datos del asegurado'],
            //   address: $scope.read_pdf.data['contratante_domicilio'],
            //   first_name: $scope.read_pdf.data['contratante_full_name'],
            //   last_name: $scope.read_pdf.data['contratante_primer_apellido'],
            //   second_last_name: $scope.read_pdf.data['contratante_segundo_apellido'],
            //   type_person: $scope.read_pdf.data['persona'],

            // };
            var asegurado = $scope.read_pdf.data["Datos del asegurado"] || {};
            $scope.first_name =
              asegurado.propietario_contratante &&
              asegurado.propietario_contratante.trim()
                ? asegurado.propietario_contratante
                : asegurado.contratante_full_name || "";
            $scope.first_name = sinDiacriticos($scope.first_name);

            order.form.from_pdf = true;
            $rootScope.readPDF = {
              individual: $scope.read_pdf.data["Datos del asegurado"],
              corporation: $scope.read_pdf.data["Datos del asegurado"],
              address: $scope.read_pdf.data["contratante_domicilio"],
              first_name: $scope.first_name,
              last_name: $scope.read_pdf.data["contratante_primer_apellido"],
              second_last_name:
                $scope.read_pdf.data["contratante_segundo_apellido"],
              type_person: $scope.read_pdf.data["persona"],
            };
            $scope.saveLocalstorange();
            // if($scope.infoUser.staff && !$scope.infoUser.superuser){
            //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
            $scope.show_contratante = "contractors-match/";
            $http
              .post(url.IP + $scope.show_contratante, {
                matchWord: $scope.read_pdf_contractor.name,
                poliza: true,
              })
              .then(function (response) {
                if (response.status === 200) {
                  if (response.data != 404) {
                    if (response.data.contractors.length) {
                      //contractor selection
                      if (response.data.contractors.length) {
                        for (
                          var i = 0;
                          i < response.data.contractors.length;
                          i++
                        ) {
                          var reg = /\d{,}/g;
                          var reg2 = /\d{.}/g;
                          var nombre_pdf = $scope.read_pdf_contractor.name
                            .replace(reg, "")
                            .toLowerCase();
                          var nombre_pdf = nombre_pdf
                            .replace(reg2, "")
                            .toLowerCase();
                          var nombre_api = response.data.contractors[
                            i
                          ].full_name
                            .replace(reg, "")
                            .toLowerCase();
                          var nombre_api = nombre_pdf
                            .replace(reg2, "")
                            .toLowerCase();
                          if (
                            nombre_pdf
                              .replace(",", "")
                              .replace(".", "")
                              .toLowerCase() ==
                            nombre_api
                              .replace(",", "")
                              .replace(".", "")
                              .toLowerCase()
                          ) {
                            order.form.contratante.val =
                              response.data.contractors[i].full_name;
                            order.form.contratante.value =
                              response.data.contractors[i];
                            order.form.contratante.phone =
                              response.data.contractors[i].phone;
                            order.form.contratante.email =
                              response.data.contractors[i].email;
                          }
                          $scope.contratante = response.data.contractors[i];
                          if ($scope.read_pdf.data["asegurados"]) {
                            llenarAsegurados(
                              $scope.read_pdf.data["asegurados"]
                            );
                          }
                          if (i + 1 == response.data.contractors.length) {
                            if (!order.form.contratante.value) {
                              $scope.objetoPoliza = order.form;
                              $scope.saveLocalstorange();
                              order.contratanteCreatorModalEvent();
                            }
                          }
                        }
                      } else {
                        $scope.objetoPoliza = order.form;
                        $scope.saveLocalstorange();
                        order.contratanteCreatorModalEvent();
                      }
                      // }
                    } else {
                      $scope.objetoPoliza = order.form;
                      $scope.saveLocalstorange();
                      order.contratanteCreatorModalEvent();
                    }
                  } else {
                    $scope.objetoPoliza = order.form;
                    order.contratanteCreatorModalEvent();
                  }
                } else {
                  $scope.objetoPoliza = order.form;
                  $scope.saveLocalstorange();
                  order.contratanteCreatorModalEvent();
                }
              });
          }
        } else {
          // 1) Obtener cuerpo
          var body = (xhr && (xhr.responseText || xhr.response)) || null;
          // 2) Parseo seguro
          var obj = null;
          if (body && typeof body === "string") {
            try {
              obj = JSON.parse(body);
            } catch (e) {
              obj = null;
            }
          } else if (body && typeof body === "object") {
            obj = body;
          }

          // 3) Mensaje
          var fallback =
            "Ha ocurrido un error al cargar el PDF; por favor inténtalo de nuevo.";
          var msg =
            (obj && obj.data && obj.data.error) || (obj && obj.error) || "";
          var reqId = obj && (obj.request_id || obj.requestId);
          // 4) Pintar (forzar digest si estás fuera de Angular)
          if (msg) {
            $scope.$applyAsync(function () {
              $scope.loaderPdf = false;
              SweetAlert.swal({
                title: "Info",
                text: reqId ? msg : msg,
                type: "info",
                confirmButtonText: "Entendido",
              });
            });
          }
        }
      };
      xhr.onerror = function () {
        console.error("❌ Error de red / servidor");
        $scope.loaderPdf = false;
        SweetAlert.swal(
          "Info",
          "Ha ocurrido un error al cargar el PDF; por favor inténtalo de nuevo o, contacte con soporte (servidor).",
          "info"
        );
      };
    };

    function enviarPDFPrimasXHR(file, org, requestId, onOk, onErr) {
      var fd = new FormData();
      fd.append("archivo", file);
      if (org) fd.append("org", org);
      if (requestId) fd.append("requestId", requestId);

      var xhr = new XMLHttpRequest();
      xhr.open("POST", url.LECTORPDF + "imagen-primas-pdf", true);

      xhr.onload = function () {
        try {
          var resp = JSON.parse(xhr.responseText || "{}");
          if (xhr.status >= 200 && xhr.status < 300) onOk(resp);
          else onErr(resp);
        } catch (e) {
          onErr({ error: "Respuesta inválida", raw: xhr.responseText });
        }
      };

      xhr.onerror = function () {
        onErr({ error: "Error de red" });
      };

      xhr.send(fd);
    }
    function enviarPDFSerieXHR(file, org, requestId, onOk, onErr) {
      var fd = new FormData();
      fd.append("archivo", file);
      if (org) fd.append("org", org);
      if (requestId) fd.append("requestId", requestId);

      var xhr = new XMLHttpRequest();
      xhr.open("POST", url.LECTORPDF + "imagen-serie-pdf", true);

      xhr.onload = function () {
        try {
          var resp = JSON.parse(xhr.responseText || "{}");
          if (xhr.status >= 200 && xhr.status < 300) onOk(resp);
          else onErr(resp);
        } catch (e) {
          onErr({ error: "Respuesta inválida", raw: xhr.responseText });
        }
      };

      xhr.onerror = function () {
        onErr({ error: "Error de red" });
      };

      xhr.send(fd);
    }
    $scope.hasInvalidVinLettersTest = function (vin) {
      if (!vin) return false;
      return /[OIQ]/i.test(vin);
    };
    $scope.addReferenciador = function (type) {
      var addReferenciadores = {
        referenciador: $scope.referenciador,
      };
      if ($scope.referenciadores) {
        $scope.referenciadores = $scope.referenciadores;
      } else {
        $scope.referenciadores = [];
      }
      $scope.referenciadores.push(addReferenciadores);
    };
    $scope.changeReferenciador = function (ref, index) {
      $scope.saveLocalstorange();
      if (ref.referenciador) {
        ref.selectedRef = true;
      } else {
        ref.selectedRef = false;
      }
    };
    $scope.changeComRef = function (com) {
      if (com.comision_vendedor > 100) {
        com.comision_vendedor = 0;
      } else if (com.comision_vendedor < 0) {
        com.comision_vendedor = 0;
      }
      $scope.checkTotalComision(com);
    };
    $scope.checkTotalComision = function (item) {
      var totalComision = $scope.referenciadores.reduce(function (sum, item) {
        return sum + (parseFloat(item.comision_vendedor) || 0); // Convert to number, default to 0 if undefined
      }, 0);
      if (totalComision > 100) {
        $scope.comisionError =
          "La suma de las comisiones no puede superar el 100%";
        item.comision_vendedor = 0;
      } else {
        $scope.comisionError = null; // No error if total is within limit
      }
    };
    $scope.deleteReferenciador = function (index, type) {
      $scope.referenciadores.splice(index, 1);
    };
    $scope.referenciador_policy = [];
    $scope.changeResponsable = function (data, type) {
      $scope.referenciador_policy.push(data);
      $scope.saveLocalstorange();
    };
    $scope.addPhone = function (index) {
      if ($scope.users[index].phones) {
        $scope.users[index].phones.push("");
      } else {
        $scope.users[index].phones = [""];
      }
    };

    $scope.deletePhone = function (index, index2) {
      $scope.delete_phones.push($scope.users[index].phones.index2);
      $scope.users[index].phones.splice(index2, 1);
    };
    $scope.domiciliado = false;
    $scope.changeDomiciliado = function () {
      $scope.change_domiciliado = true;
      if (order.form.domiciliado == "true" || order.form.domiciliado == true) {
        $scope.domiciliado = true;
      } else {
        $scope.domiciliado = false;
      }
    };

    $scope.changeRamoVendedor = function (sub_ramo) {
      if (!sub_ramo.ramo) {
        $scope.subramos = [];
        sub_ramo.sub_ramos = [];
        return;
      }

      sub_ramo.sub_ramos = sub_ramo.ramo.subramo_ramo;
    };

    $scope.addSubramo = function (index) {
      if ($scope.users[index].subramos) {
        $scope.users[index].subramos.push({ ramos: $scope.fake_ramos });
      } else {
        $scope.users[index].subramos = [{}];
      }
    };
    $scope.changeProc = function (index) {};

    $scope.changeComision = function (event, com) {
      var len_value = String($scope.dataToSave.give_comision).length;
      var value = parseFloat($scope.dataToSave.give_comision);
      var comd = parseFloat($scope.dataToSave.give_comision);

      // console.log('value', value);
      if (value > 100) {
        $scope.dataToSave.give_comision = "";
        $scope.dataToSave.give_comision = 100;
      } else if (isNaN(value)) {
        $scope.dataToSave.give_comision = "";
        // SweetAlert.swal("Error","Comisión Inválida, se guardará en 0", "error")
        // $scope.dataToSave.give_comision = 0;
      } else if (value < 0) {
        $scope.dataToSave.give_comision = "";
        $scope.dataToSave.give_comision = 0;
      }

      if (isNaN(comd)) {
        // console.log('1111111', comd);
        $scope.dataToSave.give_comision = "";
        // SweetAlert.swal("Error","Comisión Inválida, se guardará en 0", "error")
        // $scope.dataToSave.give_comision = 0;
      }

      if ($scope.letras_com(com) == 1) {
        // console.log('2222222');
        $scope.dataToSave.give_comision = "";
        SweetAlert.swal(
          "Error",
          "Comisión Inválida, se guardará en 0",
          "error"
        );
        $scope.dataToSave.give_comision = 0;
      }
    };
    var letras = "abcdefghyjklmnñopqrstuvwxyz";
    var l = "ABCDEFGHYJKLMNÑOPQRSTUVWXYZ";

    $scope.letras_com = function (comision) {
      for (i = 0; i < comision.length; i++) {
        if (
          letras.indexOf(comision.charAt(i), 0) != -1 ||
          l.indexOf(comision.charAt(i), 0) != -1
        ) {
          return 1;
        }
      }
      return 0;
    };

    $scope.checkImporte = function (param) {
      if (parseFloat(param) < 0) {
        $scope.dataToSave.comision_currency = 0;
        SweetAlert.swal(
          "Error",
          "La comisión no puede ser menor a 0.",
          "error"
        );
        return;
      } else {
        $scope.dataToSave.comision_currency = parseFloat(
          $scope.dataToSave.comision_currency.toFixed(2)
        );
      }

      var prima_neta = parseFloat(order.poliza.primaNeta);
      var comision = parseFloat(order.form.comision_percent);

      comision = comision / 100;

      var x = prima_neta / 100;
      var currency = parseFloat(param);

      order.form.comision_percent = parseFloat(
        parseFloat(currency / x).toFixed(2)
      );
    };

    $scope.checkValue = function (argument) {
      var floatValue = parseFloat(argument);

      if (floatValue < 0) {
        order.form.comision_percent = 0;

        SweetAlert.swal(
          "Error",
          "La comisión no puede ser menor a 0.",
          "error"
        );
        return;
      } else if (floatValue > 100) {
        order.form.comision_percent = 100;
      } else {
        if (!order.poliza.primaNeta) {
          order.poliza.primaNeta = 0;
        }

        order.form.comision_percent = parseFloat(
          order.form.comision_percent.toFixed(2)
        );

        var prima_neta = parseFloat(order.poliza.primaNeta);
        var comision = parseFloat(order.form.comision_percent);

        comision = comision / 100;

        $scope.dataToSave.comision_currency = (prima_neta * comision).toFixed(
          2
        );
      }
    };

    function fillProvider() {
      var d = order.form.startDate;
      try {
        var curr_date = d.getDate();
        var curr_month = d.getMonth() + 1; //Months are zero based
        var curr_year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var curr_date = f.getDate();
        var curr_month = f.getMonth() + 1; //Months are zero based
        var curr_year = f.getFullYear();
      }

      var date = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(date).then(
        function success(data) {
          order.defaults.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      // console.log('pages', pages);

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
          } else {
            if (config_.previous.search("&page=") !== -1) {
              var url = config_.previous.substring(
                0,
                config_.previous.indexOf("&page=") + 6
              );
              url += parPage.toString();
            } else {
              var url = config_.previous;
            }
          }
        }

        // url += '&status=1'
        getProviders(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getProviders(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    $scope.deleteSubramo = function (index_main, index_sub, data) {
      $scope.delete_subramos.push(data.subramos[index_sub]);
      data.subramos.splice(index_sub, 1);
    };

    $scope.changeVendedor_policy = function (vendedor) {
      $scope.users.some(function (user) {
        if (vendedor == user.id) {
          // console.log(user)
          var vendedor_info = user.user_info.info_vendedor[0];
          if (vendedor_info.vendedor_subramos.length == 0) {
            SweetAlert.swal(
              "error",
              "El vendedor no tiene comisión en el subramo actual"
            );
            order.form.vendor = null;
            return;
          }

          var flag = false;
          var vendedor_flag = false;

          vendedor_info.vendedor_subramos.some(function (subramo, sub_index) {
            if (
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == order.form.ramo.id &&
                subramo.subramo == order.form.subramo.id) ||
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == order.form.ramo.id &&
                subramo.subramo == 0) ||
              (subramo.provider == order.form.aseguradora.id &&
                subramo.ramo == 0 &&
                subramo.subramo == 0) ||
              (subramo.provider == 0 &&
                subramo.ramo == 0 &&
                subramo.subramo == 0) ||
              (subramo.provider == 0 &&
                subramo.ramo * -1 == order.form.ramo.ramo_code &&
                subramo.subramo * -1 == order.form.subramo.subramo_code)
            ) {
              vendedor_flag = true;
            }

            if (vendedor_info.vendedor_subramos.length == sub_index + 1) {
              if (!vendedor_flag) {
                SweetAlert.swal(
                  "Error",
                  "El vendedor no tiene comisión en el subramo actual",
                  "error"
                );
                order.form.vendor = $scope.original_vendor;
                return;
              }
            }
          });
        }
      });
    };

    $scope.changePerson = function (type, raw) {
      raw.person = type;
    };

    function setContractor() {
      order.subforms.auto.driver = order.form.contratante.val;
    }

    function getInternalNumber() {
      $http({
        method: "POST",
        url: url.IP + "internal-number/",
      })
        .then(
          function success(request) {
            if (request.status === 200 || request.status === 201) {
              $scope.internal_number = "OT000" + request.data.id;
              order.form.internal_number = "OT000" + request.data.id;
              $scope.dataToSave.internal_number = $scope.internal_number;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }

    function ceder_comision() {
      // console.log(order.form);

      if (order.form.ceder_comision == true) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "¿Estas seguro de que deseas modificar la comisión?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              if (order.form.comision) {
                $scope.ceder_comision = order.form.ceder_comision;
                order.form.comision_percent = order.form.comision.comission;
                order.form.comision_percent = parseFloat(
                  order.form.comision_percent
                );

                if (!$scope.dataToSave.comision) {
                  $scope.dataToSave.comision_currency = 0;
                }

                if (!order.poliza.primaNeta) {
                  order.poliza.primaNeta = 0;
                }

                var prima_neta = parseFloat(order.poliza.primaNeta);
                var comision = parseFloat(order.form.comision_percent);

                comision = comision / 100;

                $scope.dataToSave.comision_currency = parseFloat(
                  prima_neta * comision
                ).toFixed(2);
                $scope.dataToSave.comision_currency = parseFloat(
                  $scope.dataToSave.comision_currency
                );
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.COMISSION, "error");
                // toaster.warning("");
              }
            } else {
              order.form.ceder_comision = false;
            }
          }
        );
      } else {
        $scope.ceder_comision = order.form.ceder_comision;
        order.form.comision_percent = parseFloat(order.form.comision.comission);
      }
    }

    function ceder_porcentaje() {
      if (order.form.ceder_porcentaje == true) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "Cederá un porcentaje de la comisión",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              if (order.form.comision) {
                order.form.ceder_porcentaje = true;
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.COMISSION, "error");
              }
            } else {
              order.form.ceder_porcentaje = false;
            }
          }
        );
      } else {
        $scope.ceder_porcentaje = order.form.ceder_porcentaje;
        $scope.dataToSave.give_comision = 0;
      }
    }

    function getmatches(word) {
      if (word.length >= 3) {
        $http
          .post(url.IP + "cars-match/", { matchWord: word })
          .then(function (response) {
            var source = [];
            if (response.data.length) {
              response.data.forEach(function (cars) {
                var obj = {
                  label: cars.car_search,
                  value: cars,
                };
                source.push(obj);
              });
            } else {
              source.length = 0;
            }
            $scope.autocompleteCarsData = source;
          });
      }
    }
    function persistActiveTab(tabIndex) {
      lastActiveTab = tabIndex;
      $localStorage[LAST_ACTIVE_TAB_KEY] = tabIndex;
    }

    function applyActiveTab(tabIndex) {
      if ($scope.activeJustified !== tabIndex) {
        $scope.activeJustified = tabIndex;
      }
      var shouldShowOt = tabIndex === TAB_INDEX_OT;
      if (order.show.ot !== shouldShowOt) {
        order.show.ot = shouldShowOt;
      }
    }

    function showButtonPoliza() {
      persistActiveTab(TAB_INDEX_POLICY);
      applyActiveTab(TAB_INDEX_POLICY);
    }

    function hideButtonOT() {
      persistActiveTab(TAB_INDEX_OT);
      applyActiveTab(TAB_INDEX_OT);
    }

    function restoreActiveTab() {
      var storedTab = $localStorage[LAST_ACTIVE_TAB_KEY];
      if (storedTab === TAB_INDEX_OT || storedTab === TAB_INDEX_POLICY) {
        applyActiveTab(storedTab);
        lastActiveTab = storedTab;
      } else if (lastActiveTab === TAB_INDEX_OT) {
        applyActiveTab(TAB_INDEX_OT);
      } else if (lastActiveTab === TAB_INDEX_POLICY) {
        applyActiveTab(TAB_INDEX_POLICY);
      }
    }

    // ------- Guardar sumas aseguradas y deducibles
    $scope.demo = function (param) {
      // console.log('demo');
      var model = formatValues.currency(param);
      // console.log('modle', model);
      return model;
    };

    $scope.renewalSelection = function () {
      $scope.dataToSave.is_renewable = order.renewal.selected;
    };

    $scope.show_button_save_sum = false;
    $scope.show_button_save_ded = false;

    $scope.saveSum = function (parValue, parCoverage) {
      $scope.n_exis = 0;
      parCoverage.sums_coverage.forEach(function (item) {
        $scope.exist_flag = false;
        if (item) {
          if (item.sum_insured == parValue) {
            $scope.exist_flag = true;
            $scope.n_exis = $scope.n_exis + 1;
            if ($scope.exist_flag == true) {
              $scope.exist_flag = true;
              $scope.n_exis = $scope.n_exis + 1;
            }
          } else if ($scope.n_exis == 0 || $scope.n_exis == undefined) {
            $scope.exist_flag = false;
          }
          if ($scope.n_exis > 0) {
            $scope.exist_flag = true;
          }
        }
      });
      if (
        !$scope.exist_flag ||
        $scope.n_exis == 0 ||
        $scope.n_exis == undefined
      ) {
        var obj = {
          sum_insured: parValue,
          default: false,
          coverage_sum: parCoverage.url,
        };

        coverageService.createSumInsured(obj).then(function (req) {
          if (req.id) {
            $scope.result_ = false;
            parCoverage.sums_coverage.push(req);
          }
        });
      }
    };

    $scope.saveDed = function (parValue, parCoverage) {
      $scope.n_exis = 0;
      parCoverage.deductible_coverage.forEach(function (item) {
        $scope.exist_flag = false;
        if (item) {
          if (item.deductible == parValue) {
            $scope.exist_flag = true;
            $scope.n_exis = $scope.n_exis + 1;
            if ($scope.exist_flag == true) {
              $scope.exist_flag = true;
              $scope.n_exis = $scope.n_exis + 1;
            }
          } else if ($scope.n_exis == 0 || $scope.n_exis == undefined) {
            $scope.exist_flag = false;
          }
          if ($scope.n_exis > 0) {
            $scope.exist_flag = true;
          }
        }
      });
      if (
        !$scope.exist_flag ||
        $scope.n_exis == 0 ||
        $scope.n_exis == undefined
      ) {
        var obj = {
          deductible: parValue,
          default: false,
          coverage_deductible: parCoverage.url,
        };
        coverageService.createDeducible(obj).then(function (req) {
          if (req.id) {
            $scope.result_ = false;
            parCoverage.deductible_coverage.push(req);
          }
        });
      }
    };
    //------------------------------
    $scope.newCoverages = function () {
      $scope.addNewCoverages = true;
    };

    $scope.finishNewCoverages = function () {
      $scope.addNewCoverages = false;
    };
    $scope.saveNewCoverage = function (parName, priority, parPackage) {
      $scope.ded = false;
      $scope.sum = false;
      if (parPackage) {
        var paqueteData = parPackage;
      } else {
        var paqueteData = $scope.packageCreated;
      }
      if (!parName || parName == undefined) {
        SweetAlert.swal(
          "Campo requerido",
          "Debe agregar un Nombre de Cobertura",
          "error"
        );
        return;
      }
      var obj = {
        coverage_name: parName,
        priority: priority ? priority : 0,
        provider: order.form.aseguradora.url,
        package: order.form.paquete.url,
        deductible: [],
        sums_coverage: [],
        coinsurance_coverage: [],
        topecoinsurance_coverage: [],
      };
      coverageService
        .createCoverage(obj)
        .then(
          function success(request) {
            $scope.coverages.push(request);
            order.defaults.coverages.push(request);
            $scope.coverageName = null;

            order.defaults.packages.forEach(function (item) {
              if (item.id == order.form.paquete.id) {
                if (item.coverage_package) {
                  item.coverage_package.push(request);
                } else {
                  item.coverage_package = [];
                  item.coverage_package.push(request);
                }
              }
            });
          },
          function error(error) {
            console.log("error - createCoverage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createCoverage - catch", e);
        });
    };

    $scope.checkNumPolicy = function () {
      if (order.form.poliza) {
        // helpers.existPolicy(order.form.poliza)
        helpers
          .existPolicyNumber(order.form.poliza)
          .then(function (request) {
            if (request == true) {
              SweetAlert.swal("Error", MESSAGES.ERROR.POLICYEXIST, "error");
              // toaster.warning('El número de póliza ya existe.');

              order.form.poliza = "";
            }
          })
          .catch(function (err) {});
      }
    };

    $scope.checkNumSerie = function () {
      if (order.subforms.auto.serial) {
        $scope.serieAGuardar = order.subforms.auto.serial;
        helpers
          .existSerial(order.subforms.auto.serial)
          .then(function (request) {
            if (request.exist == true) {
              SweetAlert.swal(
                "Información",
                "La SERIE del AUTO ya existe en otra póliza vigente: " +
                  request.poliza,
                "info"
              );
              // order.subforms.auto.serial = '';
            }
          })
          .catch(function (err) {});
      }
    };

    function validate() {
      var flag = true;
      var code = parseInt(order.defaults.formInfo.code);
      if (order.form.contratante == "" || order.form.contratante == null) {
        flag = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.CONTRACTORERROR, "error");
      } else if (order.form.address == null) {
        flag = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
      } else if (order.form.contratante.phone_number == null) {
        flag = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.PHONE, "error");
      } else if (order.form.clave == null) {
        flag = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
      } else if (order.form.paquete == null || order.form.paquete == "") {
        flag = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.PACKAGE, "error");
      } else if (!code) {
        flag = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.DATAFORMREQUIRED, "error");
      } else if (code == 1) {
        //life
      } else if (code == 2 || code == 3 || code == 4) {
        //disease
        var subform = order.subforms.disease;
        if (
          subform.first_name == "" ||
          subform.last_name == "" ||
          subform.second_last_name == "" ||
          subform.sex == "" ||
          !subform.first_name ||
          !subform.last_name ||
          !subform.second_last_name ||
          !subform.sex
        ) {
          flag = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.DATAFORMREQUIRED, "error");
        }
        if (!(subform.birthdate instanceof Date)) {
          flag = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.DATES, "error");
        }
      } else if (
        code == 5 ||
        code == 6 ||
        code == 7 ||
        code == 8 ||
        code == 10 ||
        code == 11 ||
        code == 12 ||
        code == 13 ||
        code == 14
      ) {
        //damage
        var damage = order.subforms.damage;
        if (
          damage.insured_item == "" ||
          damage.item_address == "" ||
          damage.item_details == "" ||
          !damage.insured_item ||
          !damage.item_address ||
          !damage.item_details
        ) {
          flag = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.DATAFORMREQUIRED, "error");
        }
      } else if (code == 9) {
        // auto

        var auto = order.subforms.auto;
        // if (auto != null) {
        //   if(!auto.brand || auto.color == '' || auto.engine == ''
        //      || auto.license_plates == '' || auto.model == '' || auto.serial == '' || !auto.year) {
        //       flag = false;
        //       toaster.warning("Datos de formulario requeridos");
        //   }
        // }
        if (auto != null) {
          if (!auto.brand || auto.model == "" || !auto.year) {
            flag = false;
            SweetAlert.swal("Error", MESSAGES.ERROR.AUTOFORM, "error");
            l.stop();
            return;
          }
        } else {
          flag = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.AUTOFORM, "error");
          return;
          // toaster.warning("Datos del auto (marca, modelo y año) requeridos");
        }
      }
      return flag;
    }

    function validate2() {
      var flag = true;
      if (order.defaults.coverages.length == 0) {
        flag = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
        return;
        // toaster.warning("Al menos una cobertura es requerida");
      }
      if (order.receipts.length == 0) {
        flag = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.RECEIPTSREQUIRED, "error");
        return;
        // toaster.warning("Generar recibos es requerido");
      }
      if (order.form.poliza == "" || order.form.poliza == null) {
        flag = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.POLIZANOREQUIRED, "error");
        // toaster.warning("Número de póliza requerido");
      }
      return flag;
    }

    order.show = {
      ot: true,
      receipt: false,
      generateReceipts: false,
      receiptsGenerated: false,
      firstTab: true,
      showForms: false,
      showCoverages: false,
    };
    if (!order.acceso_adm_ot && order.acceso_adm_pol) {
      order.show = {
        ot: false,
        receipt: true,
        generateReceipts: true,
        receiptsGenerated: true,
        firstTab: true,
        showForms: true,
        showCoverages: true,
      };
    }
    order.contratanteCreatorModalEvent = contratanteCreatorModalEvent;
    order.getmatches = getmatches;

    order.loading = true;

    order.form = models.orderForm();

    order.subforms = {
      auto: {
        selectedCar: {},
      }, //template.formulario.automoviles
      life: {
        beneficiariesList: [{ person: 1 }],
        aseguradosList: [],
      }, //template.formulario.vida
      disease: {
        relationshipList: [],
      }, //template.formulario.accidentes
      damage: {
        coinsurance: "",
        insured_item: "",
        item_address: "",
        item_details: "",
      }, //template.formulario.danios
    };

    $scope.checkDateValues = function (values) {
      var date1 = datesFactory.toDate(order.form.startDate);
      var date2 = datesFactory.toDate(values);
      $scope.dateOut = false;
      if (date1 > date2) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        // $scope.dateEnd(date1);
        $scope.dateOut = true;
        return;
      } else {
        $scope.dateOut = false;
      }
    };
    $scope.dateEnd = function (dateI) {
      order.form.endingDate = "";
      var f = new Date();
      var f = new Date(dateI.setFullYear(dateI.getFullYear() + 1));
      // order.form.endingDate = convertDate(f);
      var date = new Date();
      // order.form.endingDate = new Date(date.setYear(date.getFullYear() + 1));
      var x = mesDiaAnio(order.form.startDate);
      // console.log('ok', x);

      var date = new Date(x);
      // order.form.endingDate = x;
      order.form.endingDate = new Date(date.setYear(date.getFullYear() + 1));
      order.form.endingDate = convertDate(order.form.endingDate);
    };
    $scope.checkEndDate = function (event) {
      if (order.form.startDate.length == 10) {
        order.form.endingDate = convertDate(mesDiaAnio(order.form.endingDate));
        $scope.dataToSave.end_of_validity = formatDateToISO(
          order.form.endingDate,
          2
        );
      }

      if (order.form.startDate) {
        if (order.form.endingDate.length == 10) {
          if (isNaN(order.form.endingDate)) {
            // order.form.endingDate = '';
          }
        } else if (order.form.endingDate.length < 10) {
          // console.log('endingDate', order.form.endingDate);
          order.form.endingDate = "";

          // console.log('param', param);

          // if((order.form.endingDate).search('NaN') > -1) {
          //   var check_date = (order.form.endingDate).toString();
          //   if(check_date.length == 10) {
          //     order.form.endingDate = '';
          //   } else if(check_date == 'NaN/NaN/NaN') {
          //     order.form.endingDate = '';
          //   }
          // }
        }
      }
      if (event) {
        var pastedText = "";
        if (event) {
          var clipboardData =
            event.originalEvent.clipboardData || window.clipboardData;
          pastedText = clipboardData.getData("text");
          order.form.endingDate = pastedText;
          order.form.endDate = pastedText;
          $scope.dataToSave.end_of_validity = formatDateToISO(
            order.form.endingDate
          );
        }
      }
      // VALIDACIÓN DE POLIZAS MENORES A UN AÑO
      var date1 = new Date($scope.dataToSave.start_of_validity);
      var date2 = new Date($scope.dataToSave.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      order.form.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );
      if (!$scope.read_pdf) {
        if (order.form.policy_days_duration < 365) {
          order.form.payment = 5;
        }
      }
      // console.log(diffDays);
      $scope.calcularDias();
    };
    $scope.checkDateValues = function (values, event) {
      var date1 = datesFactory.toDate(order.form.startDate);
      var date2 = datesFactory.toDate(values);
      $scope.dateOut = false;
      if (date1 > date2) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        $scope.dateOut = true;
        return;
      } else {
        $scope.dateOut = false;
      }
      if (event) {
        var pastedText = "";
        if (event) {
          var clipboardData =
            event.originalEvent.clipboardData || window.clipboardData;
          pastedText = clipboardData.getData("text");
          order.form.endingDate = pastedText;
          order.form.endDate = pastedText;
        }
      }
    };
    $scope.calcularDias = function () {
      var date_initial = order.form.startDate.split("/");
      var diaI = parseInt(date_initial[0]);
      var mesI = parseInt(date_initial[1]);
      var anioI = parseInt(date_initial[2]);
      var date_final = order.form.endingDate.split("/");
      var diaF = parseInt(date_final[0]);
      var mesF = parseInt(date_final[1]);
      var anioF = parseInt(date_final[2]);
      var date1 = new Date(mesI + "/" + diaI + "/" + anioI);
      var date2 = new Date(mesF + "/" + diaF + "/" + anioF);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      order.form.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );
      if (isNaN(order.form.policy_days_duration)) {
        order.form.policy_days_duration = 365;
      }
    };
    order.options = {
      checkDate: function (param, event) {
        var pastedText = "";
        if (event) {
          var clipboardData =
            event.originalEvent.clipboardData || window.clipboardData;
          pastedText = clipboardData.getData("text");
        }
        if (param) {
          var date = new Date();
          order.form.endingDate = new Date(
            date.setYear(date.getFullYear() + 1)
          );

          if (order.form.aseguradora) {
            get_claves();
          }
          order.form.startDate = new Date();
          order.form.endingDate = convertDate(order.form.endingDate);

          try {
            $scope.order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
            $scope.order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
            order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
            order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
          } catch (f) {
            console.log("xxxxxxxxxxxxx", f);
            $http.get(url.IP + "get-vendors/").then(function (user) {
              $scope.referenciadores = user.data;
              $scope.referenciadores.forEach(function (user) {
                user.first_name = user.first_name.toUpperCase();
                user.last_name = user.last_name.toUpperCase();
                user["phones"] = [];
                user["subramos"] = [];
              });
              $scope.referenciadores = [$scope.referenciador];
            });
          }
          $scope.dataToSave.start_of_validity = new Date();
          $scope.dataToSave.end_of_validity = formatDateToISO(
            order.form.endingDate
          );

          order.form.startDate = convertDate(order.form.startDate);
          if (
            isNaN(order.form.startDate) &&
            $scope.read_pdf &&
            $scope.read_pdf.data &&
            $scope.read_pdf.data.fecha_inicio
          ) {
            order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
          }
          if (
            $scope.read_pdf &&
            $scope.read_pdf.data &&
            $scope.read_pdf.data.fecha_inicio
          ) {
            $scope.dataToSave.start_of_validity = new Date(
              $scope.read_pdf.data["fecha_inicio"]
            );
            $scope.dataToSave.end_of_validity = formatDateToISO(
              $scope.read_pdf.data["fecha_fin"]
            );
          }
        }
        if (pastedText) {
          order.form.startDate = pastedText;
        }
        // else{
        //   SweetAlert.swal("ERROR", MESSAGES.ERROR.RECEIPTSREQUIRED, "error");
        // }
        if (order.form.startDate.length == 10) {
          var x = mesDiaAnio(order.form.startDate);
          // console.log('ok', x);

          var date = new Date(x);
          // order.form.endingDate = x;
          order.form.endingDate = new Date(
            date.setYear(date.getFullYear() + 1)
          );

          if (order.form.aseguradora) {
            get_claves();
          }
          //--------------------------- ok
          order.form.startDate = new Date(x);
          order.form.endingDate = convertDate(order.form.endingDate);
          $scope.dataToSave.start_of_validity = new Date(x);
          $scope.dataToSave.end_of_validity = formatDateToISO(
            order.form.endingDate
          );

          order.form.startDate = convertDate(order.form.startDate);
          // console.log('AQUI', order.form.startDate, $scope.dataToSave.end_of_validity, $scope.dataToSave.start_of_validity);

          //order.receipts = [];
          //order.recibos_poliza = [];

          // order.form.startDate = convertDate(order.form.startDate);
          // order.form.endingDate = convertDate(order.form.endingDate);
        }

        var date1 = new Date($scope.dataToSave.start_of_validity);
        var date2 = new Date($scope.dataToSave.end_of_validity);

        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        order.form.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
        if (order.form.policy_days_duration < 365) {
          order.form.payment = 5;
        } else {
          // order.form.payment = '';
        }
      },
      showPoliceCreator: function () {
        // if (order.defaults.showReceipts === false) {
        //     return true;
        // }
        // return false;

        if (order.receipts.length) {
          return true;
        } else {
          return false;
        }
      },
      hideTabs: function (param) {
        order.show.firstTab = param ? true : false;
      },
      changeAddress: function (address) {
        order.form.address = address;
      },
      // CHANGE OPTIONS END

      deleteCoverage: function (obj, index) {
        $scope.eliminadoManualCobertura = true;
        order.defaults.coverages.splice(index, 1);
        if ($scope.read_pdf && $scope.read_pdf.data) {
          console.log("fue por lectura se pierde si la borra");
        } else {
          order.defaults.coverageInPackage = "";
          order.defaults.coverageList.push(obj);
        }
      },
      addCoverage: function (obj, index) {
        var delCoverage = false;
        if (order.defaults.coverages.length == 0) {
          delCoverage = true;
        }
        if ($scope.read_pdf && $scope.read_pdf.data) {
          console.log("fue por lectura se pierde si la borra");
        } else {
          for (var i = order.defaults.coverages.length - 1; i >= 0; i--) {
            if (
              order &&
              order.defaults &&
              order.defaults.coverages &&
              order.defaults.coverages[i] &&
              obj &&
              obj.coverage_name &&
              order.defaults.coverages[i].coverage_name === obj.coverage_name
            ) {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.COVERAGEALREADYEXIST,
                "error"
              );
              // toaster.info('Ya existe esta cobertura.');
              order.defaults.coverageList.forEach(function (coverage) {
                if (coverage.coverage_name == obj.coverage_name) {
                  order.defaults.coverageList.splice(
                    order.defaults.coverageList.indexOf(coverage),
                    1
                  );
                }
              });
              return;
            } else {
              delCoverage = true;
            }
          }
        }

        if (delCoverage) {
          order.defaults.coverages.push(obj);
          order.defaults.coverageList.forEach(function (coverage) {
            if (coverage.coverage_name == obj.coverage_name) {
              order.defaults.coverageList.splice(
                order.defaults.coverageList.indexOf(coverage),
                1
              );
            }
          });
          // order.defaults.coverageList.splice(order.defaults.coverageList.indexOf(obj), 1);
          // order.defaults.coverageList.splice(obj., 1);
        }
        order.defaults.coverageInPackage = "";
        // order.defaults.coverageList.splice(index, 1);
      },
      changeClave: function (parClave) {
        // if($scope.readPDF && $scope.read_pdf && parClave){
        //   $scope.readPDF = {}
        //   $scope.read_pdf={}
        // }
        order.defaults.comisiones = [];
        $scope.dataToSave.clave = parClave.id;
        order.form.clave = parClave;
        if (order.form.subramo) {
          $scope.changeSubramo();
        }
      },
      life: {
        beneficiary: {
          add: function () {
            // var beneficiary = angular.copy(order.subforms.life.beneficiaries);
            // if (helpers.beneficiariesPercentageGreaterThanZero(order.subforms.life.beneficiariesList)) {
            // SweetAlert.swal("Error", MESSAGES.ERROR.GREATERTHAN100, "error")
            // toaster.info('No puede tener un porcentaje mayor a 100%.');
            // return
            // } else {
            order.subforms.life.beneficiariesList.push(models.beneficiary());
            // }
          },
          destroy: function (index) {
            order.subforms.life.beneficiariesList.splice(index, 1);
          },
        },
        asegurados: {
          add: function () {
            order.subforms.life.aseguradosList.push(models.asegurados());

            var lista2 = order.subforms.life.aseguradosList || [];
            // if($scope.read_pdf && $scope.read_pdf.data && order.subforms.life.aseguradosList && order.subforms.life.aseguradosList.length !=1){
            //   order.subforms.life.aseguradosList = lista2.filter(function (item) {
            //     return !isEmptyAsegurado(item);
            //   });
            // }
          },
          destroy: function (index) {
            order.subforms.life.aseguradosList.splice(index, 1);
          },
          fillContractorData: function () {
            if (!order.form.contratante.value) {
              SweetAlert.swal("Error", MESSAGES.ERROR.CONTRACTORERROR, "error");
              return;
            } else {
              var contractor_ = order.form.contratante.value;
              if (
                order.form.contratante.value.type_person != "Física" &&
                order.form.contratante.value.type_person != 1
              ) {
                SweetAlert.swal(
                  "Error",
                  MESSAGES.INFO.CONTRACTORTYPEPERSON,
                  "error"
                );
                return;
              } else {
                order.subforms.life.aseguradosList[0].first_name =
                  contractor_.first_name;
                order.subforms.life.aseguradosList[0].last_name =
                  contractor_.last_name;
                order.subforms.life.aseguradosList[0].second_last_name =
                  contractor_.second_last_name;
                order.subforms.life.aseguradosList[0].birthdate = convertDate(
                  contractor_.birth_date
                );
                order.subforms.life.aseguradosList[0].antiguedad = null;
                order.subforms.life.aseguradosList[0].sex = contractor_.sex;
                order.subforms.life.aseguradosList[0].smoker = false;
              }
            }
          },
        },
      },
      disease: {
        fillContractorData: function () {
          if (!order.form.contratante.value) {
            SweetAlert.swal("Error", MESSAGES.ERROR.CONTRACTORERROR, "error");
            return;
          } else {
            var contractor_ = order.form.contratante.value;
            if (
              order.form.contratante.value.type_person != "Física" &&
              order.form.contratante.value.type_person != 1
            ) {
              SweetAlert.swal(
                "Error",
                MESSAGES.INFO.CONTRACTORTYPEPERSON,
                "error"
              );
              return;
            } else {
              order.subforms.disease.first_name = contractor_.first_name;
              order.subforms.disease.last_name = contractor_.last_name;
              order.subforms.disease.second_last_name =
                contractor_.second_last_name;
              order.subforms.disease.birthdate = convertDate(
                contractor_.birth_date
              );
              order.subforms.disease.antiguedad = null;
              order.subforms.disease.sex = contractor_.sex;
            }
          }
        },
        checkDate: function (val, param, t, event, ind) {
          var clipboardData =
            event.originalEvent.clipboardData || window.clipboardData;
          var pastedText = clipboardData.getData("text");
          if (t == 1) {
            order.subforms.disease.birthdate = datesFactory.convertDate(
              datesFactory.toDate(pastedText)
            );
          } else if (t == 2) {
            order.subforms.disease.antiguedad = datesFactory.convertDate(
              datesFactory.toDate(pastedText)
            );
          }
        },
        relationships: {
          add: function (rel) {
            var relacion = angular.copy(models.relationships());
            order.hidden = false;
            order.subforms.disease.relationshipList.push(relacion);
          },
          destroy: function (index, rel) {
            order.subforms.disease.relationshipList.splice(index, 1);
          },
          checkDate: function (val, param, t, event, ind) {
            var clipboardData =
              event.originalEvent.clipboardData || window.clipboardData;
            var pastedText = clipboardData.getData("text");
            if (t == 1) {
              order.subforms.disease.birthdate = datesFactory.convertDate(
                datesFactory.toDate(pastedText)
              );
            } else if (t == 2) {
              order.subforms.disease.antiguedad = datesFactory.convertDate(
                datesFactory.toDate(pastedText)
              );
            } else if (t == 3) {
              order.subforms.disease.relationshipList[ind].birthdate =
                datesFactory.convertDate(datesFactory.toDate(pastedText));
            } else if (t == 4) {
              order.subforms.disease.relationshipList[ind].antiguedad =
                datesFactory.convertDate(datesFactory.toDate(pastedText));
            }
          },
          selectType: function (newValue, old) {
            var oldValue = old != "" ? JSON.parse(old) : null;
            var newIndex = -1;
            order.options.disease.types.some(function (valueData, index) {
              if (valueData.relationship == newValue.relationship) {
                newIndex = index;
                return true;
              }
            });
            var oldIndex = -1;

            if (newValue.relationship == 1 || newValue.relationship == 2) {
              // titular y conyugue
              order.options.disease.types[newIndex].disabled = true;
            }

            if (oldValue) {
              order.options.disease.types.some(function (val, index) {
                if (val.relationship == oldValue.relationship) {
                  oldIndex = index;
                  return true;
                }
              });

              if (oldValue.relationship == 1 || oldValue.relationship == 2) {
                // titular y conyugue
                order.options.disease.types[oldIndex].disabled = false;
              }
            }
          },
        },
        // 1-Titular, 2-Conyuge, 3-Hijo
        types: angular.copy(tiposBeneficiarios),
      },
    };
    // --------------lectura pdf--------------***********
    function addYearsSafeLocal(d, years) {
      var copy = new Date(d.getTime());
      copy.setFullYear(copy.getFullYear() + years);
      return copy;
    }

    function buildLocalDateFromDMY(dateStr, hourLocal) {
      var parts = String(dateStr).split("/");
      var day = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10);
      var year = parseInt(parts[2], 10);

      if (!day || !month || !year) return null;

      // ✅ Fecha en horario LOCAL (México si el navegador está en México)
      return new Date(year, month - 1, day, hourLocal, 0, 0, 0);
    }

    function formatDateToISO(dateStr, tipo) {
      // horas locales por tipo (igual que tu intención)
      var hourLocal = tipo == 1 ? 8 : tipo == 2 ? 17 : 7;

      var date;

      // ✅ Fallback si no viene dateStr
      if (!dateStr) {
        var base = new Date(); // hoy local
        var base2 = tipo == 2 ? addYearsSafeLocal(base, 1) : base;

        date = new Date(
          base2.getFullYear(),
          base2.getMonth(),
          base2.getDate(),
          hourLocal,
          0,
          0,
          0
        );

        return date.toISOString();
      }

      // ✅ Parse normal DD/MM/YYYY
      date = buildLocalDateFromDMY(dateStr, hourLocal);

      // Si no parsea, cae al fallback
      if (!date || isNaN(date.getTime())) {
        return formatDateToISO(null, tipo);
      }

      return date.toISOString();
    }

    // function formatDateToISO(dateStr, tipo) {
    //   if(dateStr){
    //     var parts = dateStr.split('/');
    //     var day = parts[0];
    //     var month = parts[1];
    //     var year = parts[2];
    //     var date;
    //     // ⏰ Medianoche por defecto
    //     date = new Date(year + '-' + month + '-' + day + 'T07:00:00Z');
    //     if (tipo == 1) {
    //       // 🕗 8:00 AM UTC
    //       date = new Date(year + '-' + month + '-' + day + 'T08:00:00Z');
    //     }
    //     if (tipo == 2) {
    //       // 🕙 10:00 PM UTC
    //       date = new Date(year + '-' + month + '-' + day + 'T17:00:00Z');
    //     }
    //     return date.toISOString();
    //   }
    // }
    $scope.showImgPrimas = false;
    $scope.cargarInformacion = function (data) {
      try {
        if ($localStorage.imgSerieSrc) {
          $scope.imgSerieSrc = $sce.trustAsResourceUrl(
            $localStorage.imgSerieSrc
          );
        }
        if ($localStorage.imgPrimasSrc) {
          $scope.imgPrimasSrc = $sce.trustAsResourceUrl(
            $localStorage.imgPrimasSrc
          );
        }
      } catch (u) {
        console.log("uu erorr image", u);
      }
      $scope.read_pdf = data;
      $scope.serieDetectada = $scope.serieDetectada
        ? $scope.serieDetectada
        : $localStorage.serieDetectada
        ? $localStorage.serieDetectada
        : "";
      order.form.identifier = " ";
      if (
        $scope.read_pdf &&
        $scope.read_pdf.data &&
        "Numero de poliza" in $scope.read_pdf.data &&
        $scope.read_pdf.data["Numero de poliza"]
      ) {
        if (
          $scope.read_pdf &&
          $scope.read_pdf.data &&
          "Numero de poliza" in $scope.read_pdf.data &&
          $scope.read_pdf.data["Numero de poliza"]
        ) {
          order.form.poliza = $scope.read_pdf.data["Numero de poliza"];
        }
        if (
          $scope.read_pdf.data["Datos generales de la poliza"] &&
          $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
          $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
            "NACIONAL"
        ) {
          $scope.order.f_currency.f_currency_selected = 1;
          order.f_currency.f_currency_selected = 1;
        }
        if (
          $scope.read_pdf.data["Datos generales de la poliza"] &&
          $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
          ($scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
            "Dolares" ||
            $scope.read_pdf.data["Datos generales de la poliza"][
              "Moneda"
            ].toLowerCase() == "dolares")
        ) {
          $scope.order.f_currency.f_currency_selected = 2;
          order.f_currency.f_currency_selected = 2;
        }
        if (
          $scope.read_pdf.data["Datos generales de la poliza"] &&
          $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
          !$scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
            "EXTRANJERA"
        ) {
          order.f_currency.f_currency_selected = 2;
          $scope.order.f_currency.f_currency_selected = 2;
        }
        if (
          $scope.read_pdf.data["Datos generales de la poliza"] &&
          $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
          ($scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
            "udi" ||
            $scope.read_pdf.data["Datos generales de la poliza"][
              "Moneda"
            ].toLowerCase() == "udis")
        ) {
          $scope.order.f_currency.f_currency_selected = 3;
          order.f_currency.f_currency_selected = 3;
        }
        order.conducto_de_pago.conducto_de_pago_selected = 1;
        $scope.pintarCoberturas = true;

        order.form.payment =
          $scope.read_pdf.data["Datos generales de la poliza"]["Forma de pago"];
        if (!order.form.payment) {
          try {
            order.form.payment =
              $scope.read_pdf.data["Primas"]["Forma_de_Pago"];
          } catch (idx) {}
        }
        if (order && order.form) {
          var p = Number(order.form.payment); // por si viene "15" string

          if ([15, 7, 14].indexOf(p) !== -1) {
            order.form.payment = 12; // ✅ reset a anual

            SweetAlert.swal(
              "Advertencia",
              "La forma de pago detectada (" +
                p +
                ") no aplica en este formato. Se ajustó a ANUAL (12). Verifica tu archivo o selecciona la forma de pago correcta.",
              "warning"
            );
          }
        }
        $scope.activeJustified = 1;
        order.show.ot = false;
        order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
        order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
        try {
          $scope.order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
          $scope.order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
          order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
          order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
        } catch (f) {}
        order.form.endDate = $scope.read_pdf.data["fecha_fin"];
        order.form.start_of_validity = new Date(
          $scope.read_pdf.data["fecha_inicio"]
        );
        order.form.end_of_validity = new Date(
          $scope.read_pdf.data["fecha_fin"]
        );

        $scope.dataToSave.start_of_validity = mesDiaAnio(
          datesFactory.convertDate(order.form.startDate)
        );
        $scope.dataToSave.end_of_validity = mesDiaAnio(
          datesFactory.convertDate(order.form.endingDate)
        );
        if (
          isNaN($scope.dataToSave.start_of_validity) ||
          !$scope.dataToSave.start_of_validity
        ) {
          $scope.dataToSave.start_of_validity = formatDateToISO(
            order.form.startDate,
            1
          );
          $scope.dataToSave.end_of_validity = formatDateToISO(
            order.form.endingDate,
            2
          );
        }
        var date1 = new Date($scope.dataToSave.start_of_validity);
        var date2 = new Date($scope.dataToSave.end_of_validity);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        order.form.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
        if ($scope.read_pdf.data["Datos del vehiculo"]) {
          order.subforms.auto.brand =
            $scope.read_pdf.data["Datos del vehiculo"]["marca"];
          order.subforms.auto.model =
            $scope.read_pdf.data["Datos del vehiculo"]["modelo"];
          if ("anio" in $scope.read_pdf.data["Datos del vehiculo"]) {
            order.subforms.auto.year =
              $scope.read_pdf.data["Datos del vehiculo"]["anio"];
          } else if ("modelo" in $scope.read_pdf.data["Datos del vehiculo"]) {
            order.subforms.auto.year =
              $scope.read_pdf.data["Datos del vehiculo"]["modelo"];
          }
          order.subforms.auto.engine =
            $scope.read_pdf.data["Datos del vehiculo"]["motor"];
          order.subforms.auto.serial =
            $scope.read_pdf.data["Datos del vehiculo"]["serie"];
          $scope.serieAGuardar = order.subforms.auto.serial;
          if (order.subforms.auto.serial) {
            $scope.checkNumSerie();
          }
          $scope.paqueteOriginal = $scope.read_pdf.data.cobertura;
          order.subforms.auto.driver =
            $scope.read_pdf.data["Datos del vehiculo"]["driver"];
          // order.subforms.auto.license_plates = $scope.read_pdf.data['Datos del vehiculo']['clave_vehicular'];
          order.subforms.auto.license_plates =
            $scope.read_pdf.data["Datos del vehiculo"]["placas"];
          var datosVehiculo = $scope.read_pdf.data["Datos del vehiculo"];

          order.subforms.auto.version = datosVehiculo.version
            ? datosVehiculo.version
            : datosVehiculo.descripcion_vehiculo
            ? datosVehiculo.descripcion_vehiculo
            : datosVehiculo.clave_vehicular;
          order.subforms.auto.color =
            $scope.read_pdf.data["Datos del vehiculo"]["color"];
          order.subforms.auto.service =
            $scope.read_pdf.data["Datos del vehiculo"]["servicio"];
          if (
            (order &&
              order.subforms &&
              order.subforms.auto &&
              order.subforms.auto.service == "") ||
            order.subforms.auto.service == undefined ||
            order.subforms.auto.service == null
          ) {
            if (
              $scope.read_pdf &&
              $scope.read_pdf.data &&
              $scope.read_pdf.data["Datos del vehiculo"]["uso"]
            ) {
              if (
                parseInt($scope.read_pdf.data["Datos del vehiculo"]["uso"]) == 1
              ) {
                order.subforms.auto.service = "PARTICULAR";
              } else if (
                parseInt($scope.read_pdf.data["Datos del vehiculo"]["uso"]) == 2
              ) {
                order.subforms.auto.service = "CARGA";
              } else if (
                parseInt($scope.read_pdf.data["Datos del vehiculo"]["uso"]) == 3
              ) {
                order.subforms.auto.service = "SERVICIO PÚBLICO";
              } else {
                order.subforms.auto.service = "PARTICULAR";
              }
            }
          }
          order.form.identifier =
            order.subforms.auto.brand + " " + order.subforms.auto.model;
          if ($scope.orgName == "gpi") {
            order.form.identifier = "GENERAL";
          }
          // if(order.form.identifier !=order.subforms.auto.version){
          //   order.form.identifier = order.form.identifier+' '+order.subforms.auto.version
          // }
          try {
            order.subforms.auto.usage = parseInt(
              $scope.read_pdf.data["Datos del vehiculo"]["uso"]
            );
          } catch (err) {}

          order.subforms.auto.state_circulation = "";
          // $scope.statesArray.forEach(function(item){
          //   if ($scope.read_pdf.data['contratante_domicilio']['Estado']) {
          //     if(sinDiacriticos($scope.read_pdf.data['contratante_domicilio']['Estado'].toLowerCase()) == sinDiacriticos(item.state.toLowerCase())){
          //       order.subforms.auto.state_circulation = item;
          //     }
          //   }else{
          //     $scope.read_pdf.data['contratante_domicilio']['Estado'] = ''
          //   }
          // });
          // $scope.saveLocalstorange();
          order.subforms.auto.policy_type = { id: 1, name: "Automóvil" };
          order.subforms.auto.procedencia = { id: 1, name: "Residente" };
          order.form.from_pdf = true;
          // $scope.saveLocalstorange();
        }
        // if ($scope.read_pdf.data.data.life_policy){
        //   order.subforms.life.aseguradosList = [$scope.read_pdf.data.data.life_policy.personal];
        //   order.subforms.life.beneficiariesList = [$scope.read_pdf.data.data.life_policy.beneficiaries_life]
        //   order.subforms.life.beneficiariesList = order.subforms.life.beneficiariesList.map(function(item){
        //     item = item[0];
        //     item['person'] = 1;
        //     item['percentage'] = item['percentage'] ? parseFloat(item['percentage']) : 0;
        //     return item
        //   })
        // }

        // if ($scope.read_pdf.data.data.accidents_policy){
        //   order.subforms.disease.first_name = [$scope.read_pdf.data.data.accidents_policy.disease_type.first_name];
        //   order.subforms.disease.last_name = [$scope.read_pdf.data.data.accidents_policy.disease_type.last_name];
        //   order.subforms.disease.second_last_name = [$scope.read_pdf.data.data.accidents_policy.disease_type.second_last_name];
        //   order.subforms.disease.birthdate = [$scope.read_pdf.data.data.accidents_policy.disease_type.birthdate];
        //   $scope.sex.forEach(function(item){
        //     if(item.value == $scope.read_pdf.data.data.accidents_policy.disease_type.sex){
        //       order.subforms.disease.sex = item.value;
        //     }
        //   })
        //   order.subforms.disease.antiguedad = [$scope.read_pdf.data.data.accidents_policy.disease_type.antiguedad];
        //   order.subforms.disease.relationship_accident = [$scope.read_pdf.data.data.life_policy.relationship_accident]
        //   order.subforms.disease.relationship_accident = order.subforms.disease.relationship_accident.map(function(item){
        //     item = item[0];
        //     item['person'] = 1;
        //     item['percentage'] = item['percentage'] ? parseFloat(item['percentage']) : 0;
        //     return item
        //   })

        // }
        $rootScope.order = order;
        // if(($scope.read_pdf.data['Datos del asegurado']['propietario_contratante'].indexOf("S.A. DE") > -1)){
        //   $scope.read_pdf_contractor.type = false;
        //   $scope.read_pdf_contractor.name =$scope.read_pdf.data['Datos del asegurado']['propietario_contratante'];
        // }else{
        //   $scope.read_pdf_contractor.type = true;
        //   $scope.read_pdf_contractor.name = $scope.read_pdf.data['Datos del asegurado']['propietario_contratante']

        // }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Prima neta"]
        ) {
          $rootScope.order.form.primaNeta = $scope.read_pdf.data["Primas"][
            "Prima neta"
          ]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"]["Prima neta"]
                )
              )
            : 0;
          order.form = $rootScope.order.form;
          $rootScope.order = order;
        }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Prima total"]
        ) {
          $rootScope.order.form.primaTotal = $scope.read_pdf.data["Primas"][
            "Prima total"
          ]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"]["Prima total"]
                )
              )
            : $scope.read_pdf.data["Primas"]["IMPORTE TOTAL"]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"]["IMPORTE TOTAL"]
                )
              )
            : 0;
          $rootScope.order.form.subTotal = $scope.read_pdf.data["Primas"][
            "Subtotal"
          ]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"]["Subtotal"]
                )
              )
            : 0;
          order.form = $rootScope.order.form;
          $rootScope.order = order;
        }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Gastos de expedición"]
        ) {
          try {
            $rootScope.order.form.derecho = $scope.read_pdf.data["Primas"][
              "Gastos de expedición"
            ]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf.data["Primas"]["Gastos de expedición"]
                  )
                )
              : 0;
            order.form = $rootScope.order.form;
            $rootScope.order = order;
          } catch (o) {
            $rootScope.order.form.derecho = $scope.read_pdf.data["Primas"][
              "Gastos de expedici\u00f3n"
            ]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf.data["Primas"]["Gastos de expedici\u00f3n"]
                  )
                )
              : 0;
            order.form = $rootScope.order.form;
            $rootScope.order = order;
          }
        }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Gastos por Expedición."]
        ) {
          try {
            $rootScope.order.form.derecho = $scope.read_pdf.data["Primas"][
              "Gastos por Expedición."
            ]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf.data["Primas"]["Gastos por Expedición."]
                  )
                )
              : 0;
            order.form = $rootScope.order.form;
            $rootScope.order = order;
          } catch (o) {
            $rootScope.order.form.derecho = $scope.read_pdf.data["Primas"][
              "Gastos por Expedici\u00f3n"
            ]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf.data["Primas"]["Gastos por Expedici\u00f3n"]
                  )
                )
              : 0;
            order.form = $rootScope.order.form;
            $rootScope.order = order;
          }
        }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Derecho de Póliza"]
        ) {
          $scope.order.form.derecho = $scope.read_pdf.data["Primas"][
            "Derecho de Póliza"
          ]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"]["Derecho de Póliza"]
                )
              )
            : 0;
          $localStorage["primas"] = $scope.order.form;
        }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Financiamiento por pago fraccionado"]
        ) {
          $rootScope.order.form.rpf = $scope.read_pdf.data["Primas"][
            "Financiamiento por pago fraccionado"
          ]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"][
                    "Financiamiento por pago fraccionado"
                  ]
                )
              )
            : 0;
          order.form = $rootScope.order.form;
          $rootScope.order = order;
        }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["IVA"]
        ) {
          $scope.order.form.iva = $scope.read_pdf.data["Primas"]["IVA"]
            ? parseFloat(
                formatearNumero_calculate($scope.read_pdf.data["Primas"]["IVA"])
              )
            : 0;
          order.form.iva = $scope.read_pdf.data["Primas"]["IVA"]
            ? parseFloat(
                formatearNumero_calculate($scope.read_pdf.data["Primas"]["IVA"])
              )
            : 0;
          $localStorage["primas"] = $scope.order.form;
        }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["I.V.A."]
        ) {
          $scope.order.form.iva = $scope.read_pdf.data["Primas"]["I.V.A."]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"]["I.V.A."]
                )
              )
            : 0;
          order.form.iva = $scope.read_pdf.data["Primas"]["I.V.A."]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"]["I.V.A."]
                )
              )
            : 0;
          $localStorage["primas"] = $scope.order.form;
        }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Descuento"]
        ) {
          var valor =
            parseFloat(
              formatearNumero_calculate(
                $scope.read_pdf.data["Primas"]["Descuento"]
              )
            ) || 0;
          // Si el valor es negativo → convertirlo a positivo multiplicando por -1
          if (valor < 0) {
            valor = valor * -1;
          }
          $scope.order.form.descuento = valor;
          $localStorage["primas"] = $scope.order.form;
        } else {
          $scope.order.form.descuento = 0;
        }
        if ("primas" in $localStorage && $localStorage["primas"]) {
          order.form.primaNeta = parseFloat(
            $localStorage["primas"]["primaNeta"]
              ? $localStorage["primas"]["primaNeta"]
              : 0
          );
          order.form.derecho = parseFloat(
            $localStorage["primas"]["derecho"]
              ? $localStorage["primas"]["derecho"]
              : 0
          );
          order.form.rpf = parseFloat(
            $localStorage["primas"]["rpf"] ? $localStorage["primas"]["rpf"] : 0
          );
          order.form.descuento = parseFloat(
            $localStorage["primas"]["descuento"]
              ? $localStorage["primas"]["descuento"]
              : 0
          );
          order.form.primaTotal = parseFloat(
            $localStorage["primas"]["prima_total"]
              ? $localStorage["primas"]["primaTotal"]
              : parseFloat(
                  $localStorage["primas"]["IMPORTE TOTAL"]
                    ? $localStorage["primas"]["IMPORTE TOTAL"]
                    : 0
                )
          );
          order.form.subTotal = parseFloat(
            $localStorage["primas"]["Subtotal"]
              ? $localStorage["primas"]["Subtotal"]
              : 0
          );
        }
        // $scope.checkEndDate()
        if ($scope.read_pdf.data["ramo"]) {
          $scope.ramoPdf = $scope.read_pdf.data["ramo"];
        } else {
          $scope.ramoPdf = "";
          $scope.contratante = {};
        }
        order.form.from_pdf = true;
        $rootScope.order = order;
        var aseguradora_a_capturar = sinDiacriticos(
          $scope.read_pdf.data["aseguradora"].toLowerCase()
        );
        order.defaults.providers.some(function (x) {
          if (aseguradora_a_capturar == "chubb") {
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "CHUBB" ||
              sinDiacriticos(x.alias).toLowerCase() == "Aba" ||
              sinDiacriticos(x.alias).toLowerCase() == "ABA" ||
              sinDiacriticos(x.alias).toLowerCase() == "chubb seguros mexico"
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              if (!cl || cl == undefined) {
                try {
                  cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave_interna_del_agente"
                    ];
                } catch (u) {}
              }
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (aseguradora_a_capturar == "qualitas") {
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "Quálitas" ||
              sinDiacriticos(x.alias).toLowerCase() == "Qualitas" ||
              sinDiacriticos(x.alias).toLowerCase() == "QUALITAS" ||
              sinDiacriticos(x.alias).toLowerCase() == "QUÁLITAS"
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              if (!cl || cl == undefined) {
                try {
                  cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave_interna_del_agente"
                    ];
                } catch (u) {}
              }
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (aseguradora_a_capturar == "gnp") {
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "gnp" ||
              sinDiacriticos(x.alias).toLowerCase() == "gnp seguros" ||
              sinDiacriticos(x.alias).toLowerCase() ==
                "grupo nacional provincial" ||
              sinDiacriticos(x.alias).toLowerCase() ==
                "grupo nacional provincial "
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (aseguradora_a_capturar == "axa") {
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "axa" ||
              sinDiacriticos(x.alias).toLowerCase() == "axa seguros"
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (aseguradora_a_capturar == "hdi") {
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "axa" ||
              sinDiacriticos(x.alias).toLowerCase() == "HDI"
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (aseguradora_a_capturar == "primero seguros") {
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "Primero Seguros" ||
              sinDiacriticos(x.alias).toLowerCase() == "Pimero seguros"
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (aseguradora_a_capturar == "ana") {
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "ana" ||
              sinDiacriticos(x.alias).toLowerCase() == "ana seguros" ||
              sinDiacriticos(x.alias).toLowerCase() ==
                "ana compania de seguros "
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              if (!cl || cl == undefined) {
                try {
                  cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave_interna_del_agente"
                    ];
                } catch (u) {}
              }
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (aseguradora_a_capturar.toLowerCase() == "momento") {
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "momento"
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              if (!cl || cl == undefined) {
                try {
                  cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave_interna_del_agente"
                    ];
                } catch (u) {}
              }
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (aseguradora_a_capturar == "afirme") {
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "seguros afirme"
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              if (!cl || cl == undefined) {
                try {
                  cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave_interna_del_agente"
                    ];
                } catch (u) {}
              }
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (aseguradora_a_capturar == "zurich") {
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "zurich seguros"
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              if (!cl || cl == undefined) {
                try {
                  cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave_interna_del_agente"
                    ];
                } catch (u) {}
              }
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (aseguradora_a_capturar == "mapfre") {
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "mapfre"
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              if (!cl || cl == undefined) {
                try {
                  cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave_interna_del_agente"
                    ];
                } catch (u) {}
              }
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (
            aseguradora_a_capturar == "seguros monterrey" ||
            aseguradora_a_capturar == "seguros monterrey new york life"
          ) {
            aseguradora_a_capturar = "seguros monterrey new york life";
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() ==
                "seguros monterrey new york life"
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];

              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (
            aseguradora_a_capturar == "seguros bx+" ||
            aseguradora_a_capturar == "bx+" ||
            aseguradora_a_capturar == "Seguros Bx+"
          ) {
            aseguradora_a_capturar = "bx+";
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "seguros ve por mas" ||
              sinDiacriticos(x.alias).toLowerCase() == "bx+" ||
              sinDiacriticos(x.alias).toLowerCase() == "seguros bx+" ||
              sinDiacriticos(x.alias).toLowerCase() ==
                "grupo financiero ve por mas" ||
              sinDiacriticos(x.alias).toLowerCase() ==
                "grupo financiero ve por mas "
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              if (!cl || cl == undefined) {
                try {
                  cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave_interna_del_agente"
                    ];
                } catch (u) {}
              }
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (
            aseguradora_a_capturar == "Metlife" ||
            aseguradora_a_capturar == "metlife"
          ) {
            aseguradora_a_capturar = "metlife";
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "met life" ||
              sinDiacriticos(x.alias).toLowerCase() == "metlife"
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];

              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (
            aseguradora_a_capturar == "PlanSeguro" ||
            aseguradora_a_capturar == "planseguro" ||
            aseguradora_a_capturar == "plan seguro"
          ) {
            aseguradora_a_capturar = "plan seguro";
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "plan seguros" ||
              sinDiacriticos(x.alias).toLowerCase() ==
                "plan de seguro cía de seguros" ||
              sinDiacriticos(x.alias).toLowerCase() == "plan seguro" ||
              sinDiacriticos(x.alias).toLowerCase() == "plan seguro "
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              if (!cl || cl == undefined) {
                try {
                  cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave_interna_del_agente"
                    ];
                } catch (u) {}
              }
              get_claves_pdf(x, cl);
              return true;
            }
          }
          if (
            aseguradora_a_capturar == "Bupa" ||
            aseguradora_a_capturar == "bupa"
          ) {
            aseguradora_a_capturar = "bupa";
            if (
              sinDiacriticos(x.alias).toLowerCase() == aseguradora_a_capturar ||
              sinDiacriticos(x.alias).toLowerCase() ==
                aseguradora_a_capturar.toUpperCase() ||
              sinDiacriticos(x.alias).toLowerCase() == "bupa" ||
              sinDiacriticos(x.alias).toLowerCase() == "bupa seguros" ||
              sinDiacriticos(x.alias).toLowerCase() == "seguros bupa" ||
              sinDiacriticos(x.alias).toLowerCase() == "bupa mexico" ||
              sinDiacriticos(x.alias).toLowerCase() == "bupa "
            ) {
              order.form.aseguradora = x;
              var cl =
                $scope.read_pdf.data["Datos generales de la poliza"][
                  "Clave interna del agente"
                ];
              if (!cl || cl == undefined) {
                try {
                  cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave_interna_del_agente"
                    ];
                } catch (u) {}
              }
              get_claves_pdf(x, cl);
              return true;
            }
          }
          return false;
        });
      } else {
        order.form.from_pdf = false;
        order.form.identifier = "";
      }
    };
    $scope.$watch("order.form.startDate", function (newValue, oldValue) {
      try {
        if (
          $scope.read_pdf &&
          $scope.read_pdf.startDate == order.form.startDate
        ) {
          order.form.from_pdf = true;
          order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
          order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
          try {
            $scope.order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
            $scope.order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
            order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
            order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
          } catch (f) {}
          order.form.endDate = $scope.read_pdf.data["fecha_fin"];
          order.form.start_of_validity = new Date(
            $scope.read_pdf.data["fecha_inicio"]
          );
          order.form.end_of_validity = new Date(
            $scope.read_pdf.data["fecha_fin"]
          );

          $scope.dataToSave.start_of_validity = mesDiaAnio(
            datesFactory.convertDate(order.form.startDate)
          );
          $scope.dataToSave.end_of_validity = mesDiaAnio(
            datesFactory.convertDate(order.form.endingDate)
          );
          if (
            isNaN($scope.dataToSave.start_of_validity) ||
            !$scope.dataToSave.start_of_validity
          ) {
            $scope.dataToSave.start_of_validity = formatDateToISO(
              order.form.startDate,
              1
            );
            $scope.dataToSave.end_of_validity = formatDateToISO(
              order.form.endingDate,
              2
            );
          }
          var date1 = new Date($scope.dataToSave.start_of_validity);
          var date2 = new Date($scope.dataToSave.end_of_validity);
          var timeDiff = Math.abs(date2.getTime() - date1.getTime());
          order.form.policy_days_duration = Math.ceil(
            timeDiff / (1000 * 3600 * 24)
          );
          if ("primas" in $localStorage && $localStorage["primas"]) {
            order.form.primaNeta = $localStorage["primas"]["primaNeta"];
            order.form.derecho = $localStorage["primas"]["derecho"];
            order.form.rpf = $localStorage["primas"]["rpf"];
            order.form.primaTotal = $localStorage["primas"]["primaTotal"];
            order.form.subTotal = $localStorage["primas"]["subTotal"];
            $rootScope.order.form = order.form;
          }
        }
      } catch (e) {
        order.form.from_pdf = false;
        order.form.identifier = "";
      }
    });
    // $scope.$watch('order.form', function(newValue, oldValue) {
    //   try{
    //     if($scope.read_pdf && $scope.read_pdf.data && $scope.read_pdf.data['cobertura'] && (!order.form.paquete || order.form.paquete==null || order.form.paquete==undefined) && order.form.aseguradora && order.form.clave==undefined){
    //       order.show.ot = false;
    //       try{
    //         get_claves_pdf(order.form.aseguradora,order.form.clave)
    //       }
    //       catch(e){
    //         console.log('errrrr x',e,order.form)
    //       }
    //     }
    //   }
    //   catch(e){
    //     console.log('errrrr paquete',e,order.form)
    //   }
    // });
    $scope.$watch("order.form", function (newValue, oldValue) {
      try {
        if (
          $scope.read_pdf &&
          $scope.read_pdf.data &&
          $scope.read_pdf.data.cobertura &&
          (!order.form.paquete ||
            order.form.paquete === null ||
            order.form.paquete === undefined) &&
          order.form.aseguradora &&
          order.form.clave === undefined
        ) {
          order.show.ot = false;

          // Similarity function
          function similarity(a, b) {
            var aWords = a.toLowerCase().split(" ");
            var bWords = b.toLowerCase().split(" ");
            var score = 0;

            angular.forEach(aWords, function (word) {
              if (bWords.indexOf(word) !== -1) {
                score++;
              }
            });
            return score;
          }

          // Find best matching paquete
          var cobertura = $scope.read_pdf.data.cobertura;
          var highestScore = -1;
          var bestMatch = null;

          angular.forEach(order.defaults.packages, function (pkg) {
            var currentScore = similarity(cobertura, pkg.package_name);
            if (currentScore > highestScore) {
              highestScore = currentScore;
              bestMatch = pkg;
            }
          });

          // Set paquete if best match is found
          if (bestMatch) {
            order.form.paquete = bestMatch;
          }

          // Call your function after setting paquete
          try {
            get_claves_pdf(order.form.aseguradora, order.form.clave);
          } catch (e) {
            console.log("Error al obtener claves PDF:", e, order.form);
          }
        }
      } catch (e) {
        console.log("Error general paquete:", e, order.form);
      }
    });
    function llenarInfoGm(aseguradora, clave) {
      order.show.ot = false;
      $scope.activeJustified = 1;
      order.show.ot = false;
      order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
      order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
      try {
        $scope.order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
        $scope.order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
        order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
        order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
      } catch (f) {}
      order.form.endDate = $scope.read_pdf.data["fecha_fin"];
      order.form.start_of_validity = new Date(
        $scope.read_pdf.data["fecha_inicio"]
      );
      order.form.end_of_validity = new Date($scope.read_pdf.data["fecha_fin"]);

      $scope.dataToSave.start_of_validity = mesDiaAnio(order.form.startDate);
      $scope.dataToSave.end_of_validity = mesDiaAnio(order.form.endingDate);
      var date1 = new Date($scope.dataToSave.start_of_validity);
      var date2 = new Date($scope.dataToSave.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      order.form.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );
      var date = new Date(order.form.startDate);
      if (isNaN(date)) {
        var date = new Date(mesDiaAnio(order.form.startDate));
      }
      if ($scope.read_pdf.data["asegurados"]) {
        llenarAsegurados($scope.read_pdf.data["asegurados"]);
      }
      $scope.paqueteOriginal = $scope.read_pdf.data.cobertura;
      $http
        .get(url.IP + "claves-by-provider/" + order.form.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });
            order.defaults.claves = clavesResponse.data;
            if (order.defaults.claves.length == 1) {
              order.form.clave = order.defaults.claves[0];
              $scope.dataToSave.clave = order.form.clave.id;
              try {
                order.form.comision_percent = order.form.clave.comission;
                order.form.udi = order.form.clave.udi;
              } catch (e) {}
            }
            if (clave) {
              order.defaults.claves.forEach(function (item) {
                if (
                  item.clave.toString().replace(/\s/g, "") ===
                  clave.toString().replace(/\s/g, "")
                ) {
                  order.form.clave = item;
                }
              });
            }
            $http
              .get(url.IP + "ramos-by-provider/" + aseguradora.id)
              .then(function (ramo) {
                order.defaults.ramos = ramo.data;
                order.defaults.ramos.forEach(function (ramo) {
                  if (ramo.ramo_code == 2) {
                    order.form.ramo = ramo;
                    $scope.saveLocalstorange();
                    order.defaults.subramos = ramo.subramo_ramo;
                    order.defaults.subramos.forEach(function (sub) {
                      if (sub.subramo_code == 3) {
                        order.form.subramo = sub;
                        // $scope.verComisiones();
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };

                        order.defaults.comisiones = [];

                        if (order.form.clave) {
                          if (order.form.clave.clave_comision.length) {
                            order.form.clave.clave_comision.forEach(function (
                              item
                            ) {
                              if (
                                order.form.subramo.subramo_name == item.subramo
                              ) {
                                order.defaults.comisiones.push(item);
                              }
                            });

                            order.form.comisiones = order.defaults.comisiones;
                            if (order.defaults.comisiones.length == 1) {
                              order.form.comision =
                                order.defaults.comisiones[0];
                              $scope.selectComision(order.form.comision);
                            }
                          }
                        }

                        $scope.cargandoPaquetes = true;
                        $http
                          .post(url.IP + "paquetes-data-by-subramo/", {
                            ramo: order.form.ramo.id,
                            subramo: order.form.subramo.id,
                            provider: order.form.aseguradora.id,
                          })
                          .then(
                            function success(response) {
                              $scope.cargandoPaquetes = false;
                              order.defaults.packages = [];
                              $scope.paqueteSelected = false;
                              $scope.coberturasPackagePdf = [];
                              // $scope.read_pdf.data.cobertura='PREMIER 200'
                              if (response.data.length) {
                                order.defaults.packages = response.data;
                                if (
                                  $scope.read_pdf.data.cobertura == "" ||
                                  $scope.read_pdf.data.cobertura == undefined
                                ) {
                                  $scope.read_pdf.data.cobertura =
                                    "PREMIER 200";
                                }
                                var best = null;
                                var bestScore = -1;
                                var target = $scope.read_pdf.data.cobertura;
                                var encontardo_paquete = true;
                                $scope.coberturasPackagePdf = [];
                                var res = pickBestPackageOriginal(
                                  order.defaults.packages,
                                  $scope.read_pdf.data.cobertura
                                );
                                var best = res ? res.best : null;
                                var score = res ? res.score : null;
                                var cobertura = $scope.read_pdf.data.cobertura;
                                console.log(res.best, res.best.package_name);
                                $scope.packages = order.defaults.packages;
                                // ---------------
                                if (best) {
                                  $scope.paqueteSelectedObject = best;
                                  encontardo_paquete = false;
                                  // console.log('✅ Mejor match:', best.package_name, 'score:', score);
                                } else {
                                  $scope.paqueteSelectedObject = null;
                                  encontardo_paquete = true;
                                  console.warn("No hubo coincidencias");
                                }
                                if (!encontardo_paquete) {
                                  $scope.paqueteSelected = true;
                                  order.form.paquete =
                                    $scope.paqueteSelectedObject;
                                  $scope.yaseestableciopaquete = true;
                                  $scope.dataToSave.paquete =
                                    order.form.paquete.id;
                                  for (i in $scope.read_pdf.data[
                                    "Primas y coberturas"
                                  ]) {
                                    if (
                                      $scope.read_pdf.data[
                                        "Primas y coberturas"
                                      ][i].hasOwnProperty("Deducible")
                                    ) {
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"] == "nan"
                                      ) {
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"] = "0";
                                      }
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"] == "nan"
                                      ) {
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"] = "0";
                                      }
                                      var it = {};
                                      it["coverage_name"] = i;
                                      it["url"] =
                                        slug(i) +
                                        "-" +
                                        (order.form.paquete.id || "pkg") +
                                        "-" +
                                        ($scope.coberturasPackagePdf.length +
                                          1);
                                      it["package"] = order.form.paquete.id;
                                      it["deductibleInPolicy"] = {
                                        value:
                                          $scope.read_pdf.data[
                                            "Primas y coberturas"
                                          ][i]["Deducible"],
                                      };
                                      it["deductible_coverage"] = [
                                        { deductible: 0 },
                                      ];
                                      it["deductible_coverage"][0][
                                        "deductible"
                                      ] =
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"];
                                      it["sumInPolicy"] = {
                                        value:
                                          $scope.read_pdf.data[
                                            "Primas y coberturas"
                                          ][i]["Suma asegurada"],
                                      };
                                      it["sums_coverage"] = [
                                        { sum_insured: 0 },
                                      ];
                                      it["sums_coverage"][0]["sum_insured"] =
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"];
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Coaseguro"]
                                      ) {
                                        it["coinsuranceInPolicy"] = {
                                          value:
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i]["Coaseguro"],
                                        };
                                      }
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Tope"]
                                      ) {
                                        it["topeCoinsuranceInPolicy"] = {
                                          value:
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i]["Tope"],
                                        };
                                      }
                                      $scope.coberturasPackagePdf.push(it);
                                      order.defaults.coverages =
                                        $scope.coberturasPackagePdf;
                                      $localStorage["defaults"] =
                                        order.defaults;
                                      order.form.paquete = order.form.paquete;
                                    }
                                  }
                                  order.coverageInPolicy_policy =
                                    order.defaults.coverages;
                                  order.form.paquete = order.form.paquete;
                                  $scope.dataToSave.paquete =
                                    order.form.paquete.id;
                                  $scope.saveLocalstorange();
                                } else {
                                  console.log(
                                    "buscar",
                                    encontardo_paquete,
                                    best
                                  );
                                  order.defaults.packages.forEach(function (
                                    item
                                  ) {
                                    var s = scorePackage(
                                      item.package_name,
                                      target
                                    );
                                    if (s > bestScore) {
                                      bestScore = s;
                                      best = item;
                                    }
                                    if (
                                      item.package_name.toLowerCase() &&
                                      $scope.read_pdf.data.cobertura.toLowerCase()
                                    ) {
                                      if (
                                        item.package_name.toLowerCase() ==
                                          $scope.read_pdf.data.cobertura.toLowerCase() ||
                                        (item.package_name
                                          .toLowerCase()
                                          .includes(
                                            $scope.read_pdf.data.cobertura.toLowerCase()
                                          ) &&
                                          !$scope.paqueteSelected) ||
                                        (best &&
                                          $scope.yaseestableciopaquete == false)
                                      ) {
                                        $scope.paqueteSelected = true;
                                        order.form.paquete = item;
                                        $scope.yaseestableciopaquete = true;
                                        $scope.dataToSave.paquete =
                                          order.form.paquete.id;
                                        for (i in $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ]) {
                                          if (
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i].hasOwnProperty("Deducible")
                                          ) {
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"] == "nan"
                                            ) {
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"] = "0";
                                            }
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"] == "nan"
                                            ) {
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"] = "0";
                                            }
                                            var it = {};
                                            it["coverage_name"] = i;
                                            it["url"] =
                                              slug(i) +
                                              "-" +
                                              (item.id || "pkg") +
                                              "-" +
                                              ($scope.coberturasPackagePdf
                                                .length +
                                                1);
                                            it["package"] = item.id;
                                            it["deductibleInPolicy"] = {
                                              value:
                                                $scope.read_pdf.data[
                                                  "Primas y coberturas"
                                                ][i]["Deducible"],
                                            };
                                            it["deductible_coverage"] = [
                                              { deductible: 0 },
                                            ];
                                            it["deductible_coverage"][0][
                                              "deductible"
                                            ] =
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"];
                                            it["sumInPolicy"] = {
                                              value:
                                                $scope.read_pdf.data[
                                                  "Primas y coberturas"
                                                ][i]["Suma asegurada"],
                                            };
                                            it["sums_coverage"] = [
                                              { sum_insured: 0 },
                                            ];
                                            it["sums_coverage"][0][
                                              "sum_insured"
                                            ] =
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"];
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Coaseguro"]
                                            ) {
                                              it["coinsuranceInPolicy"] = {
                                                value:
                                                  $scope.read_pdf.data[
                                                    "Primas y coberturas"
                                                  ][i]["Coaseguro"],
                                              };
                                            }
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Tope"]
                                            ) {
                                              it["topeCoinsuranceInPolicy"] = {
                                                value:
                                                  $scope.read_pdf.data[
                                                    "Primas y coberturas"
                                                  ][i]["Tope"],
                                              };
                                            }
                                            $scope.coberturasPackagePdf.push(
                                              it
                                            );
                                            order.defaults.coverages =
                                              $scope.coberturasPackagePdf;
                                            $localStorage["defaults"] =
                                              order.defaults;
                                            order.form.paquete = item;
                                          }
                                        }
                                        order.coverageInPolicy_policy =
                                          order.defaults.coverages;
                                        order.form.paquete = item;
                                        $scope.dataToSave.paquete =
                                          order.form.paquete.id;
                                        $scope.saveLocalstorange();
                                      }
                                    }
                                  });
                                }
                                // var best = null;
                                // var bestScore = -1;
                                // var target=$scope.read_pdf.data.cobertura
                                // $scope.coberturasPackagePdf=[]
                                // order.defaults.packages.forEach(function(item){
                                //   var s = scorePackage(item.package_name, target);
                                //   if (s > bestScore) { bestScore = s; best = item; }
                                //   if((item.package_name).toLowerCase() && $scope.read_pdf.data.cobertura.toLowerCase()){
                                //     if (((item.package_name.toLowerCase() == $scope.read_pdf.data.cobertura.toLowerCase())
                                //       || ( item.package_name.toLowerCase().includes($scope.read_pdf.data.cobertura.toLowerCase()))
                                //       && !$scope.paqueteSelected) || best && $scope.yaseestableciopaquete==false){
                                //       $scope.paqueteSelected = true;
                                //       order.form.paquete = item;
                                //       console.log('ddddddddddddd',best)
                                //       $scope.yaseestableciopaquete=true;
                                //       $scope.dataToSave.paquete = order.form.paquete.id;
                                //       for (i in $scope.read_pdf.data['Primas y coberturas']) {

                                //           if ($scope.read_pdf.data['Primas y coberturas'][i].hasOwnProperty('Deducible')) {
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Deducible'] =='nan'){
                                //               $scope.read_pdf.data['Primas y coberturas'][i]['Deducible']='0'
                                //             }
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada'] =='nan'){
                                //               $scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']='0'
                                //             }
                                //             var it ={}
                                //             it['coverage_name'] = i
                                //             it['url'] = slug(i) + '-' + (item.id || 'pkg') + '-' + ($scope.coberturasPackagePdf.length + 1);
                                //             it['package'] = item.id
                                //             it['deductibleInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Deducible']}
                                //             it['deductible_coverage']=[{'deductible':0}]
                                //             it['deductible_coverage'][0]['deductible'] =$scope.read_pdf.data['Primas y coberturas'][i]['Deducible']
                                //             it['sumInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']}
                                //             it['sums_coverage']=[{'sum_insured':0}]
                                //             it['sums_coverage'][0]['sum_insured'] =$scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Coaseguro']){
                                //               it['coinsuranceInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Coaseguro']}
                                //             }
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Tope']){
                                //               it['topeCoinsuranceInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Tope']}
                                //             }
                                //             $scope.coberturasPackagePdf.push(it)
                                //             order.defaults.coverages=$scope.coberturasPackagePdf
                                //             $localStorage['defaults'] = order.defaults
                                //             order.form.paquete = item;
                                //         }
                                //       }
                                //       order.coverageInPolicy_policy = order.defaults.coverages;
                                //       order.form.paquete = item;
                                //       $scope.dataToSave.paquete = order.form.paquete.id;
                                //       // $scope.saveLocalstorange()
                                //     }
                                //   }
                                // })
                                $scope.changeSubramo();
                                if ($localStorage) {
                                }
                              }
                            },
                            function error(e) {
                              $scope.cargandoPaquetes = false;
                              console.log(
                                "Error - paquetes-data-by-subramo",
                                e
                              );
                              order.defaults.packages = [];
                            }
                          )
                          .catch(function (error) {
                            $scope.cargandoPaquetes = false;
                            console.log(
                              "Error - paquetes-data-by-subramo - catch",
                              error
                            );
                            order.defaults.packages = [];
                          });
                      }
                    });
                  }
                });
              });
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }
    function llenarInfoVida(aseguradora, clave) {
      order.show.ot = false;
      $scope.activeJustified = 1;
      order.show.ot = false;
      order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
      order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
      try {
        $scope.order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
        $scope.order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
        order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
        order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
      } catch (f) {}
      order.form.endDate = $scope.read_pdf.data["fecha_fin"];
      order.form.start_of_validity = new Date(
        $scope.read_pdf.data["fecha_inicio"]
      );
      order.form.end_of_validity = new Date($scope.read_pdf.data["fecha_fin"]);

      $scope.dataToSave.start_of_validity = mesDiaAnio(
        datesFactory.convertDate(order.form.startDate)
      );
      $scope.dataToSave.end_of_validity = mesDiaAnio(
        datesFactory.convertDate(order.form.endingDate)
      );
      if (
        isNaN($scope.dataToSave.start_of_validity) ||
        !$scope.dataToSave.start_of_validity
      ) {
        $scope.dataToSave.start_of_validity = formatDateToISO(
          order.form.startDate,
          1
        );
        $scope.dataToSave.end_of_validity = formatDateToISO(
          order.form.endingDate,
          2
        );
      }
      var date1 = new Date($scope.dataToSave.start_of_validity);
      var date2 = new Date($scope.dataToSave.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      order.form.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );
      var date = new Date(order.form.startDate);
      if (isNaN(date)) {
        var date = new Date(mesDiaAnio(order.form.startDate));
      }
      if (
        $scope.read_pdf.data["asegurados"] ||
        $scope.read_pdf.data["beneficiarios"]
      ) {
        llenarAseguradosVida(
          $scope.read_pdf.data["asegurados"],
          $scope.read_pdf.data["beneficiarios"]
        );
      }
      $scope.paqueteOriginal = $scope.read_pdf.data.cobertura;
      $http
        .get(url.IP + "claves-by-provider/" + order.form.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });
            order.defaults.claves = clavesResponse.data;
            if (order.defaults.claves.length == 1) {
              order.form.clave = order.defaults.claves[0];
              $scope.dataToSave.clave = order.form.clave.id;
              try {
                order.form.comision_percent = order.form.clave.comission;
                order.form.udi = order.form.clave.udi;
              } catch (e) {}
            }
            if (clave) {
              order.defaults.claves.forEach(function (item) {
                if (
                  item.clave.toString().replace(/\s/g, "") ===
                  clave.toString().replace(/\s/g, "")
                ) {
                  order.form.clave = item;
                }
              });
            }
            $http
              .get(url.IP + "ramos-by-provider/" + aseguradora.id)
              .then(function (ramo) {
                order.defaults.ramos = ramo.data;
                order.defaults.ramos.forEach(function (ramo) {
                  if (ramo.ramo_code == 1) {
                    order.form.ramo = ramo;
                    $scope.saveLocalstorange();
                    order.defaults.subramos = ramo.subramo_ramo;
                    order.defaults.subramos.forEach(function (sub) {
                      if (sub.subramo_code == 1 && $scope.ramoPdf == "vida") {
                        order.form.subramo = sub;
                        // $scope.verComisiones();
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };

                        order.defaults.comisiones = [];

                        if (order.form.clave) {
                          if (order.form.clave.clave_comision.length) {
                            order.form.clave.clave_comision.forEach(function (
                              item
                            ) {
                              if (
                                order.form.subramo.subramo_name == item.subramo
                              ) {
                                order.defaults.comisiones.push(item);
                              }
                            });

                            order.form.comisiones = order.defaults.comisiones;
                            if (order.defaults.comisiones.length == 1) {
                              order.form.comision =
                                order.defaults.comisiones[0];
                              $scope.selectComision(order.form.comision);
                            }
                          }
                        }

                        $scope.cargandoPaquetes = true;
                        $http
                          .post(url.IP + "paquetes-data-by-subramo/", {
                            ramo: order.form.ramo.id,
                            subramo: order.form.subramo.id,
                            provider: order.form.aseguradora.id,
                          })
                          .then(
                            function success(response) {
                              $scope.cargandoPaquetes = false;
                              order.defaults.packages = [];
                              $scope.paqueteSelected = false;
                              $scope.coberturasPackagePdf = [];
                              // $scope.read_pdf.data.cobertura='PREMIER 200'
                              if (response.data.length) {
                                order.defaults.packages = response.data;
                                // $scope.read_pdf.data.cobertura = $scope.read_pdf.data.cobertura.split(" ");
                                // $scope.read_pdf.data.cobertura = $scope.read_pdf.data.cobertura[0];
                                if (
                                  $scope.read_pdf.data.cobertura == "" ||
                                  $scope.read_pdf.data.cobertura == undefined
                                ) {
                                  $scope.read_pdf.data.cobertura =
                                    "PREMIER 200";
                                }
                                var best = null;
                                var bestScore = -1;
                                var target = $scope.read_pdf.data.cobertura;
                                var encontardo_paquete = true;
                                $scope.coberturasPackagePdf = [];
                                var res = pickBestPackageOriginal(
                                  order.defaults.packages,
                                  $scope.read_pdf.data.cobertura
                                );
                                var best = res ? res.best : null;
                                var score = res ? res.score : null;
                                var cobertura = $scope.read_pdf.data.cobertura;
                                console.log(res.best, res.best.package_name);
                                $scope.packages = order.defaults.packages;
                                // ---------------
                                if (best) {
                                  $scope.paqueteSelectedObject = best;
                                  encontardo_paquete = false;
                                  // console.log('✅ Mejor match:', best.package_name, 'score:', score);
                                } else {
                                  $scope.paqueteSelectedObject = null;
                                  encontardo_paquete = true;
                                  console.warn("No hubo coincidencias");
                                }
                                if (!encontardo_paquete) {
                                  $scope.paqueteSelected = true;
                                  order.form.paquete =
                                    $scope.paqueteSelectedObject;
                                  $scope.yaseestableciopaquete = true;
                                  $scope.dataToSave.paquete =
                                    order.form.paquete.id;
                                  for (i in $scope.read_pdf.data[
                                    "Primas y coberturas"
                                  ]) {
                                    if (
                                      $scope.read_pdf.data[
                                        "Primas y coberturas"
                                      ][i].hasOwnProperty("Deducible")
                                    ) {
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"] == "nan"
                                      ) {
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"] = "0";
                                      }
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"] == "nan"
                                      ) {
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"] = "0";
                                      }
                                      var it = {};
                                      it["coverage_name"] = i;
                                      it["url"] =
                                        slug(i) +
                                        "-" +
                                        (order.form.paquete.id || "pkg") +
                                        "-" +
                                        ($scope.coberturasPackagePdf.length +
                                          1);
                                      it["package"] = order.form.paquete.id;
                                      it["deductibleInPolicy"] = {
                                        value:
                                          $scope.read_pdf.data[
                                            "Primas y coberturas"
                                          ][i]["Deducible"],
                                      };
                                      it["deductible_coverage"] = [
                                        { deductible: 0 },
                                      ];
                                      it["deductible_coverage"][0][
                                        "deductible"
                                      ] =
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"];
                                      it["sumInPolicy"] = {
                                        value:
                                          $scope.read_pdf.data[
                                            "Primas y coberturas"
                                          ][i]["Suma asegurada"],
                                      };
                                      it["sums_coverage"] = [
                                        { sum_insured: 0 },
                                      ];
                                      it["sums_coverage"][0]["sum_insured"] =
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"];
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Coaseguro"]
                                      ) {
                                        it["coinsuranceInPolicy"] = {
                                          value:
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i]["Coaseguro"],
                                        };
                                      }
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Tope"]
                                      ) {
                                        it["topeCoinsuranceInPolicy"] = {
                                          value:
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i]["Tope"],
                                        };
                                      }
                                      $scope.coberturasPackagePdf.push(it);
                                      order.defaults.coverages =
                                        $scope.coberturasPackagePdf;
                                      $localStorage["defaults"] =
                                        order.defaults;
                                      order.form.paquete = order.form.paquete;
                                    }
                                  }
                                  order.coverageInPolicy_policy =
                                    order.defaults.coverages;
                                  order.form.paquete = order.form.paquete;
                                  $scope.dataToSave.paquete =
                                    order.form.paquete.id;
                                  $scope.saveLocalstorange();
                                } else {
                                  order.defaults.packages.forEach(function (
                                    item
                                  ) {
                                    var s = scorePackage(
                                      item.package_name,
                                      target
                                    );
                                    if (s > bestScore) {
                                      bestScore = s;
                                      best = item;
                                    }
                                    if (
                                      item.package_name.toLowerCase() &&
                                      $scope.read_pdf.data.cobertura.toLowerCase()
                                    ) {
                                      if (
                                        item.package_name.toLowerCase() ==
                                          $scope.read_pdf.data.cobertura.toLowerCase() ||
                                        (item.package_name
                                          .toLowerCase()
                                          .includes(
                                            $scope.read_pdf.data.cobertura.toLowerCase()
                                          ) &&
                                          !$scope.paqueteSelected) ||
                                        (best &&
                                          $scope.yaseestableciopaquete == false)
                                      ) {
                                        $scope.paqueteSelected = true;
                                        order.form.paquete = item;
                                        $scope.yaseestableciopaquete = true;
                                        $scope.dataToSave.paquete =
                                          order.form.paquete.id;
                                        for (i in $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ]) {
                                          if (
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i].hasOwnProperty("Deducible")
                                          ) {
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"] == "nan"
                                            ) {
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"] = "0";
                                            }
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"] == "nan"
                                            ) {
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"] = "0";
                                            }
                                            var it = {};
                                            it["coverage_name"] = i;
                                            it["url"] =
                                              slug(i) +
                                              "-" +
                                              (item.id || "pkg") +
                                              "-" +
                                              ($scope.coberturasPackagePdf
                                                .length +
                                                1);
                                            it["package"] = item.id;
                                            it["deductibleInPolicy"] = {
                                              value:
                                                $scope.read_pdf.data[
                                                  "Primas y coberturas"
                                                ][i]["Deducible"],
                                            };
                                            it["deductible_coverage"] = [
                                              { deductible: 0 },
                                            ];
                                            it["deductible_coverage"][0][
                                              "deductible"
                                            ] =
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"];
                                            it["sumInPolicy"] = {
                                              value:
                                                $scope.read_pdf.data[
                                                  "Primas y coberturas"
                                                ][i]["Suma asegurada"],
                                            };
                                            it["sums_coverage"] = [
                                              { sum_insured: 0 },
                                            ];
                                            it["sums_coverage"][0][
                                              "sum_insured"
                                            ] =
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"];
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Coaseguro"]
                                            ) {
                                              it["coinsuranceInPolicy"] = {
                                                value:
                                                  $scope.read_pdf.data[
                                                    "Primas y coberturas"
                                                  ][i]["Coaseguro"],
                                              };
                                            }
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Tope"]
                                            ) {
                                              it["topeCoinsuranceInPolicy"] = {
                                                value:
                                                  $scope.read_pdf.data[
                                                    "Primas y coberturas"
                                                  ][i]["Tope"],
                                              };
                                            }
                                            $scope.coberturasPackagePdf.push(
                                              it
                                            );
                                            order.defaults.coverages =
                                              $scope.coberturasPackagePdf;
                                            $localStorage["defaults"] =
                                              order.defaults;
                                            order.form.paquete = item;
                                          }
                                        }
                                        order.coverageInPolicy_policy =
                                          order.defaults.coverages;
                                        order.form.paquete = item;
                                        $scope.dataToSave.paquete =
                                          order.form.paquete.id;
                                        $scope.saveLocalstorange();
                                      }
                                    }
                                  });
                                }
                                // var best = null;
                                // var bestScore = -1;
                                // var target=$scope.read_pdf.data.cobertura
                                // $scope.coberturasPackagePdf=[]
                                // order.defaults.packages.forEach(function(item){
                                //   var s = scorePackage(item.package_name, target);
                                //   if (s > bestScore) { bestScore = s; best = item; }
                                //   if((item.package_name).toLowerCase() && $scope.read_pdf.data.cobertura.toLowerCase()){
                                //     if (((item.package_name.toLowerCase() == $scope.read_pdf.data.cobertura.toLowerCase())
                                //       || ( item.package_name.toLowerCase().includes($scope.read_pdf.data.cobertura.toLowerCase()))
                                //       && !$scope.paqueteSelected) || best && $scope.yaseestableciopaquete==false){
                                //       $scope.paqueteSelected = true;
                                //       order.form.paquete = item;
                                //       console.log('ddddddddddddd',best)
                                //       $scope.yaseestableciopaquete=true;
                                //       $scope.dataToSave.paquete = order.form.paquete.id;
                                //       for (i in $scope.read_pdf.data['Primas y coberturas']) {

                                //           if ($scope.read_pdf.data['Primas y coberturas'][i].hasOwnProperty('Deducible')) {
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Deducible'] =='nan'){
                                //               $scope.read_pdf.data['Primas y coberturas'][i]['Deducible']='0'
                                //             }
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada'] =='nan'){
                                //               $scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']='0'
                                //             }
                                //             var it ={}
                                //             it['coverage_name'] = i
                                //             it['url'] = slug(i) + '-' + (item.id || 'pkg') + '-' + ($scope.coberturasPackagePdf.length + 1);
                                //             it['package'] = item.id
                                //             it['deductibleInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Deducible']}
                                //             it['deductible_coverage']=[{'deductible':0}]
                                //             it['deductible_coverage'][0]['deductible'] =$scope.read_pdf.data['Primas y coberturas'][i]['Deducible']
                                //             it['sumInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']}
                                //             it['sums_coverage']=[{'sum_insured':0}]
                                //             it['sums_coverage'][0]['sum_insured'] =$scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Coaseguro']){
                                //               it['coinsuranceInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Coaseguro']}
                                //             }
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Tope']){
                                //               it['topeCoinsuranceInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Tope']}
                                //             }
                                //             $scope.coberturasPackagePdf.push(it)
                                //             order.defaults.coverages=$scope.coberturasPackagePdf
                                //             $localStorage['defaults'] = order.defaults
                                //             order.form.paquete = item;
                                //         }
                                //       }
                                //       order.coverageInPolicy_policy = order.defaults.coverages;
                                //       order.form.paquete = item;
                                //       $scope.dataToSave.paquete = order.form.paquete.id;
                                //       // $scope.saveLocalstorange()
                                //     }
                                //   }
                                // })
                                $scope.changeSubramo();
                                if ($localStorage) {
                                }
                              }
                            },
                            function error(e) {
                              $scope.cargandoPaquetes = false;
                              console.log(
                                "Error - paquetes-data-by-subramo",
                                e
                              );
                              order.defaults.packages = [];
                            }
                          )
                          .catch(function (error) {
                            $scope.cargandoPaquetes = false;
                            console.log(
                              "Error - paquetes-data-by-subramo - catch",
                              error
                            );
                            order.defaults.packages = [];
                          });
                      }
                      if (
                        sub.subramo_code == 30 &&
                        $scope.ramoPdf == "funerarios"
                      ) {
                        order.form.subramo = sub;
                        // $scope.verComisiones();
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };

                        order.defaults.comisiones = [];

                        if (order.form.clave) {
                          if (order.form.clave.clave_comision.length) {
                            order.form.clave.clave_comision.forEach(function (
                              item
                            ) {
                              if (
                                order.form.subramo.subramo_name == item.subramo
                              ) {
                                order.defaults.comisiones.push(item);
                              }
                            });

                            order.form.comisiones = order.defaults.comisiones;
                            if (order.defaults.comisiones.length == 1) {
                              order.form.comision =
                                order.defaults.comisiones[0];
                              $scope.selectComision(order.form.comision);
                            }
                          }
                        }

                        $scope.cargandoPaquetes = true;
                        $http
                          .post(url.IP + "paquetes-data-by-subramo/", {
                            ramo: order.form.ramo.id,
                            subramo: order.form.subramo.id,
                            provider: order.form.aseguradora.id,
                          })
                          .then(
                            function success(response) {
                              $scope.cargandoPaquetes = false;
                              order.defaults.packages = [];
                              $scope.paqueteSelected = false;
                              $scope.coberturasPackagePdf = [];
                              // $scope.read_pdf.data.cobertura='PREMIER 200'
                              if (response.data.length) {
                                order.defaults.packages = response.data;
                                // $scope.read_pdf.data.cobertura = $scope.read_pdf.data.cobertura.split(" ");
                                // $scope.read_pdf.data.cobertura = $scope.read_pdf.data.cobertura[0];
                                if (
                                  $scope.read_pdf.data.cobertura == "" ||
                                  $scope.read_pdf.data.cobertura == undefined
                                ) {
                                  $scope.read_pdf.data.cobertura =
                                    "PREMIER 200";
                                }
                                var best = null;
                                var bestScore = -1;
                                var target = $scope.read_pdf.data.cobertura;
                                var encontardo_paquete = true;
                                $scope.coberturasPackagePdf = [];
                                var res = pickBestPackageOriginal(
                                  order.defaults.packages,
                                  $scope.read_pdf.data.cobertura
                                );
                                var best = res ? res.best : null;
                                var score = res ? res.score : null;
                                var cobertura = $scope.read_pdf.data.cobertura;
                                console.log(res.best, res.best.package_name);
                                $scope.packages = order.defaults.packages;
                                // ---------------
                                if (best) {
                                  $scope.paqueteSelectedObject = best;
                                  encontardo_paquete = false;
                                  // console.log('✅ Mejor match:', best.package_name, 'score:', score);
                                } else {
                                  $scope.paqueteSelectedObject = null;
                                  encontardo_paquete = true;
                                  console.warn("No hubo coincidencias");
                                }
                                if (!encontardo_paquete) {
                                  $scope.paqueteSelected = true;
                                  order.form.paquete =
                                    $scope.paqueteSelectedObject;
                                  $scope.yaseestableciopaquete = true;
                                  $scope.dataToSave.paquete =
                                    order.form.paquete.id;
                                  for (i in $scope.read_pdf.data[
                                    "Primas y coberturas"
                                  ]) {
                                    if (
                                      $scope.read_pdf.data[
                                        "Primas y coberturas"
                                      ][i].hasOwnProperty("Deducible")
                                    ) {
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"] == "nan"
                                      ) {
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"] = "0";
                                      }
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"] == "nan"
                                      ) {
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"] = "0";
                                      }
                                      var it = {};
                                      it["coverage_name"] = i;
                                      it["url"] =
                                        slug(i) +
                                        "-" +
                                        (order.form.paquete.id || "pkg") +
                                        "-" +
                                        ($scope.coberturasPackagePdf.length +
                                          1);
                                      it["package"] = order.form.paquete.id;
                                      it["deductibleInPolicy"] = {
                                        value:
                                          $scope.read_pdf.data[
                                            "Primas y coberturas"
                                          ][i]["Deducible"],
                                      };
                                      it["deductible_coverage"] = [
                                        { deductible: 0 },
                                      ];
                                      it["deductible_coverage"][0][
                                        "deductible"
                                      ] =
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"];
                                      it["sumInPolicy"] = {
                                        value:
                                          $scope.read_pdf.data[
                                            "Primas y coberturas"
                                          ][i]["Suma asegurada"],
                                      };
                                      it["sums_coverage"] = [
                                        { sum_insured: 0 },
                                      ];
                                      it["sums_coverage"][0]["sum_insured"] =
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"];
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Coaseguro"]
                                      ) {
                                        it["coinsuranceInPolicy"] = {
                                          value:
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i]["Coaseguro"],
                                        };
                                      }
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Tope"]
                                      ) {
                                        it["topeCoinsuranceInPolicy"] = {
                                          value:
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i]["Tope"],
                                        };
                                      }
                                      $scope.coberturasPackagePdf.push(it);
                                      order.defaults.coverages =
                                        $scope.coberturasPackagePdf;
                                      $localStorage["defaults"] =
                                        order.defaults;
                                      order.form.paquete = order.form.paquete;
                                    }
                                  }
                                  order.coverageInPolicy_policy =
                                    order.defaults.coverages;
                                  order.form.paquete = order.form.paquete;
                                  $scope.dataToSave.paquete =
                                    order.form.paquete.id;
                                  $scope.saveLocalstorange();
                                } else {
                                  order.defaults.packages.forEach(function (
                                    item
                                  ) {
                                    var s = scorePackage(
                                      item.package_name,
                                      target
                                    );
                                    if (s > bestScore) {
                                      bestScore = s;
                                      best = item;
                                    }
                                    if (
                                      item.package_name.toLowerCase() &&
                                      $scope.read_pdf.data.cobertura.toLowerCase()
                                    ) {
                                      if (
                                        item.package_name.toLowerCase() ==
                                          $scope.read_pdf.data.cobertura.toLowerCase() ||
                                        (item.package_name
                                          .toLowerCase()
                                          .includes(
                                            $scope.read_pdf.data.cobertura.toLowerCase()
                                          ) &&
                                          !$scope.paqueteSelected) ||
                                        (best &&
                                          $scope.yaseestableciopaquete == false)
                                      ) {
                                        $scope.paqueteSelected = true;
                                        order.form.paquete = item;
                                        $scope.yaseestableciopaquete = true;
                                        $scope.dataToSave.paquete =
                                          order.form.paquete.id;
                                        for (i in $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ]) {
                                          if (
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i].hasOwnProperty("Deducible")
                                          ) {
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"] == "nan"
                                            ) {
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"] = "0";
                                            }
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"] == "nan"
                                            ) {
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"] = "0";
                                            }
                                            var it = {};
                                            it["coverage_name"] = i;
                                            it["url"] =
                                              slug(i) +
                                              "-" +
                                              (item.id || "pkg") +
                                              "-" +
                                              ($scope.coberturasPackagePdf
                                                .length +
                                                1);
                                            it["package"] = item.id;
                                            it["deductibleInPolicy"] = {
                                              value:
                                                $scope.read_pdf.data[
                                                  "Primas y coberturas"
                                                ][i]["Deducible"],
                                            };
                                            it["deductible_coverage"] = [
                                              { deductible: 0 },
                                            ];
                                            it["deductible_coverage"][0][
                                              "deductible"
                                            ] =
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"];
                                            it["sumInPolicy"] = {
                                              value:
                                                $scope.read_pdf.data[
                                                  "Primas y coberturas"
                                                ][i]["Suma asegurada"],
                                            };
                                            it["sums_coverage"] = [
                                              { sum_insured: 0 },
                                            ];
                                            it["sums_coverage"][0][
                                              "sum_insured"
                                            ] =
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"];
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Coaseguro"]
                                            ) {
                                              it["coinsuranceInPolicy"] = {
                                                value:
                                                  $scope.read_pdf.data[
                                                    "Primas y coberturas"
                                                  ][i]["Coaseguro"],
                                              };
                                            }
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Tope"]
                                            ) {
                                              it["topeCoinsuranceInPolicy"] = {
                                                value:
                                                  $scope.read_pdf.data[
                                                    "Primas y coberturas"
                                                  ][i]["Tope"],
                                              };
                                            }
                                            $scope.coberturasPackagePdf.push(
                                              it
                                            );
                                            order.defaults.coverages =
                                              $scope.coberturasPackagePdf;
                                            $localStorage["defaults"] =
                                              order.defaults;
                                            order.form.paquete = item;
                                          }
                                        }
                                        order.coverageInPolicy_policy =
                                          order.defaults.coverages;
                                        order.form.paquete = item;
                                        $scope.dataToSave.paquete =
                                          order.form.paquete.id;
                                        $scope.saveLocalstorange();
                                      }
                                    }
                                  });
                                }
                                $scope.changeSubramo();
                                if ($localStorage) {
                                }
                              }
                            },
                            function error(e) {
                              $scope.cargandoPaquetes = false;
                              console.log(
                                "Error - paquetes-data-by-subramo",
                                e
                              );
                              order.defaults.packages = [];
                            }
                          )
                          .catch(function (error) {
                            $scope.cargandoPaquetes = false;
                            console.log(
                              "Error - paquetes-data-by-subramo - catch",
                              error
                            );
                            order.defaults.packages = [];
                          });
                      }
                    });
                  }
                });
              });
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }
    function slug(s) {
      return (s || "")
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // sin acentos
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }

    function norm(s) {
      if (!s) return "";
      return s
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // quita acentos
        .replace(/est(an|and)ar/g, "estandar") // normaliza variantes
        .replace(/[^a-z0-9 ]/g, " ") // quita signos
        .replace(/\s+/g, " ") // espacios únicos
        .trim();
    }

    function extractNum(s) {
      var m = (s || "").match(/\b(\d{2,3})\b/); // 60, 70, 80, 90, 100...
      return m ? m[1] : null;
    }

    /**
     * Devuelve un puntaje de similitud entre itemName y target.
     * Reglas:
     *  - Igual exacto: 100
     *  - Empieza con: 85
     *  - Incluye: 70
     *  - Coincidencia de número (60/80/90/100): +15
     *  - Coincidencia de token "estandar": +10
     */
    function scorePackage(itemName, target) {
      var a = norm(itemName);
      var b = norm(target);
      if (!a || !b) return 0;

      var score = 0;
      if (a === b) score = 100;
      else if (a.startsWith(b) || b.startsWith(a)) score = 85;
      else if (a.includes(b) || b.includes(a)) score = 70;

      var na = extractNum(a),
        nb = extractNum(b);
      if (na && nb && na === nb) score += 15;
      if (a.includes("estandar") && b.includes("estandar")) score += 10;

      return score;
    }
    // Asumo que ya tienes norm() y extractNum() y scorePackage(itemName, targetName)

    // Devuelve el mejor paquete y su puntaje
    function pickBestPackageOriginal(packages, targetName) {
      if (targetName == "Responsabilidad Civil") {
        if (
          order &&
          order.form &&
          order.form.aseguradora &&
          order.form.aseguradora.alias &&
          (order.form.aseguradora.alias == "GNP" ||
            order.form.aseguradora.alias == "GNP Seguros")
        )
          targetName = "RC";
      }
      if (!Array.isArray(packages) || !packages.length)
        return { best: null, score: 0, index: -1 };

      var best = null;
      var bestScore = -1;
      var bestIdx = -1;

      for (var idx = 0; idx < packages.length; idx++) {
        var pkg = packages[idx];
        var name = pkg && pkg.package_name ? pkg.package_name : "";
        var s = scorePackage(name, targetName);

        function tieBreak() {
          var bestName = best && best.package_name ? best.package_name : "";
          var aNum = extractNum(norm(name));
          var bNum = extractNum(norm(bestName));
          var tNum = extractNum(norm(targetName));

          if (aNum && !bNum) return true; // prioriza quien tenga número
          if (aNum && bNum && tNum && aNum === tNum) return true; // número igual al target
          if ((name || "").length > (bestName || "").length) return true; // nombre más largo
          return false;
        }

        if (s > bestScore || (s === bestScore && tieBreak())) {
          best = pkg;
          bestScore = s;
          bestIdx = idx;
        }
      }
      return { best: best, score: bestScore, index: bestIdx };
    }

    function llenarAseguradosVida(lista, beneficiarios) {
      // Determinar si hay titular en lista
      if (lista) {
        order.subforms.life.beneficiariesList = [];
        order.subforms.life.aseguradosList = [];
        var titular = lista.find(function (a) {
          return a.tipo.toUpperCase() == "TITULAR";
        });
        // Si es persona moral, usar también asegurado como titular
        var esPersonaMoral =
          $scope.read_pdf &&
          $scope.read_pdf.data &&
          $scope.read_pdf.data.persona == 2;

        order.subforms.life.aseguradosList.push(models.asegurados());
        if (titular || esPersonaMoral) {
          var aseguradoPrincipal = titular || lista[0]; // Usa titular o el primero si es persona moral

          order.subforms.life.aseguradosList[0].first_name =
            aseguradoPrincipal.first_name;
          order.subforms.life.aseguradosList[0].smoker = "False";
          order.subforms.life.aseguradosList[0].last_name =
            aseguradoPrincipal.last_name;
          order.subforms.life.aseguradosList[0].second_last_name =
            aseguradoPrincipal.second_last_name;
          order.subforms.life.aseguradosList[0].birthdate =
            aseguradoPrincipal.fecha || datesFactory.convertDate(new Date());
          order.subforms.life.aseguradosList[0].antiguedad =
            aseguradoPrincipal.antiguedad
              ? aseguradoPrincipal.antiguedad
              : null;
          order.subforms.life.aseguradosList[0].sex = "M";

          if (aseguradoPrincipal.sex) {
            order.subforms.life.aseguradosList[0].sex = aseguradoPrincipal.sex;
          }
        } else {
          // Si no hay titular y no es moral, usa contratante
          order.subforms.life.aseguradosList[0].smoker = "False";
          order.subforms.life.aseguradosList[0].first_name =
            $scope.contratante.first_name;
          order.subforms.life.aseguradosList[0].last_name =
            $scope.contratante.last_name;
          order.subforms.life.aseguradosList[0].second_last_name =
            $scope.contratante.second_last_name;
          order.subforms.life.aseguradosList[0].birthdate = formatToMMDDYYYY(
            $scope.contratante.birth_date
          );
          order.subforms.life.aseguradosList[0].sex = $scope.contratante.sex
            ? $scope.contratante.sex
            : "M";
        }
      }
      if (beneficiarios) {
        // Agregar los demás asegurados como dependientes (relaciones)
        beneficiarios.forEach(function (item) {
          if (!item || !item.tipo || item.tipo.toLowerCase() == "TITULAR")
            return; //
          // if (!item || (item.full_name).toLowerCase()  == aseguradoPrincipal.full_name.toLowerCase()) return; //
          var ben = {
            birthdate: item.fecha ? item.fecha : null,
            first_name:
              item.persona == 1 || item.persona == "1" ? item.first_name : "",
            last_name:
              item.persona == 1 || item.persona == "1" ? item.last_name : "",
            second_last_name:
              item.persona == 1 || item.persona == "1"
                ? item.second_last_name
                : "",
            sex: item.sex ? item.sex : "",
            optional_relationship: item.tipo ? item.tipo : "Otro",
            percentage: item.percentage ? item.percentage : 0,
            person: item.persona == 1 || item.persona == "1" ? 1 : 2,
            antiguedad: "",
            j_name:
              item.persona == 1 || item.persona == "1" ? item.first_name : "",
          };

          // Asignar sexo si viene
          // if (item.sex && (item.persona==1 || item.persona=='1')) {
          //   ben.sex = item.sex.toUpperCase() === 'M'
          //     ? { value: 'M', label: 'MASCULINO' }
          //     : item.sex.toUpperCase() === 'F'
          //       ? 'M'
          //       : null;
          // }
          order.subforms.life.beneficiariesList.push(ben);
        });
      }
      var lista2 = order.subforms.life.aseguradosList || [];
      order.subforms.life.aseguradosList = lista2.filter(function (item) {
        return !isEmptyAsegurado(item);
      });
    }
    function isEmptyAsegurado(x) {
      if (!x || typeof x !== "object") return true;
      var campos = [
        "first_name",
        "last_name",
        "second_last_name",
        "sex",
        "smoker",
        "antiguedad",
        "birthdate",
      ];
      for (var i = 0; i < campos.length; i++) {
        var v = x[campos[i]];
        if (v !== null && v !== undefined && String(v).trim() !== "")
          return false; // tiene algo
      }
      return true; // todos vacíos
    }
    function llenarAsegurados(lista) {
      order.subforms.disease.relationshipList = [];

      // Determinar si hay titular en lista
      var titular = lista.find(function (a) {
        return a.tipo == 1 || a.tipo.toLowerCase() == "titular";
      });

      // Si es persona moral, usar también asegurado como titular
      var esPersonaMoral =
        $scope.read_pdf &&
        $scope.read_pdf.data &&
        $scope.read_pdf.data.persona == 2;

      if (titular || esPersonaMoral) {
        var aseguradoPrincipal = titular || lista[0]; // Usa titular o el primero si es persona moral

        order.subforms.disease.first_name = aseguradoPrincipal
          ? aseguradoPrincipal.first_name
          : "";
        order.subforms.disease.last_name = aseguradoPrincipal
          ? aseguradoPrincipal.last_name
          : "";
        order.subforms.disease.second_last_name = aseguradoPrincipal
          ? aseguradoPrincipal.second_last_name
          : "";
        order.subforms.disease.birthdate = aseguradoPrincipal
          ? aseguradoPrincipal.fecha
          : "" || aseguradoPrincipal
          ? aseguradoPrincipal.birthdate
          : "";
        order.subforms.disease.antiguedad = aseguradoPrincipal
          ? aseguradoPrincipal.antiguedad
          : null;

        if (aseguradoPrincipal ? aseguradoPrincipal.sex : "") {
          order.subforms.disease.sex = aseguradoPrincipal.sex;
        }
      } else {
        // Si no hay titular y no es moral, usa contratante
        order.subforms.disease.first_name = $scope.contratante.first_name;
        order.subforms.disease.last_name = $scope.contratante.last_name;
        order.subforms.disease.second_last_name =
          $scope.contratante.second_last_name;
        order.subforms.disease.birthdate = formatToMMDDYYYY(
          $scope.contratante.birth_date
        );
        order.subforms.disease.sex = $scope.contratante.sex;
      }

      // Agregar los demás asegurados como dependientes (relaciones)
      lista.forEach(function (item) {
        if (
          !item ||
          !item.tipo ||
          item.tipo == 1 ||
          item.tipo.toLowerCase() == "titular"
        )
          return; // omitir titular
        var rel = {
          antiguedad: item.antiguedad ? item.antiguedad : null,
          birthdate: item.fecha ? item.fecha : null,
          first_name: item.first_name,
          last_name: item.last_name,
          second_last_name: item.second_last_name,
          sex: null,
          relationship: { option: "OTRO", relationship: 4, disabled: false },
        };

        // Asignar relación si coincide con catálogo
        tiposBeneficiarios.forEach(function (tb) {
          if (tb.relationship == item.tipo) {
            rel.relationship = tb;
          }
        });

        // Asignar sexo si viene
        if (item.sex) {
          rel.sex =
            item.sex.toUpperCase() === "M"
              ? { value: "M", label: "MASCULINO" }
              : item.sex.toUpperCase() === "F"
              ? { value: "F", label: "FEMENINO" }
              : null;
        }

        order.subforms.disease.relationshipList.push(rel);
      });
    }

    function formatToMMDDYYYY(isoDateString) {
      if (!isoDateString) return "";
      var date = new Date(isoDateString);
      var month = (date.getMonth() + 1).toString().padStart(2, "0");
      var day = date.getDate().toString().padStart(2, "0");
      var year = date.getFullYear();
      return month + "/" + day + "/" + year;
    }
    function get_claves_pdf(aseguradora, clave) {
      if (!clave || clave == undefined) {
        try {
          clave =
            $scope.read_pdf.data["Datos generales de la poliza"][
              "Clave_interna_del_agente"
            ];
        } catch (u) {}
      }
      order.show.ot = false;
      if ($localStorage) {
      }
      var date = new Date(order.form.startDate);
      if (isNaN(date)) {
        var date = new Date(mesDiaAnio(order.form.startDate));
      }
      if ($scope.ramoPdf == "gastosmedicos") {
        llenarInfoGm(aseguradora, clave);
        return;
      }
      if ($scope.ramoPdf == "vida" || $scope.ramoPdf == "funerarios") {
        llenarInfoVida(aseguradora, clave);
        return;
      }
      $http
        .get(url.IP + "claves-by-provider/" + order.form.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });
            order.defaults.claves = clavesResponse.data;
            if (order.defaults.claves.length == 1) {
              order.form.clave = order.defaults.claves[0];
              $scope.dataToSave.clave = order.form.clave.id;
              try {
                order.form.comision_percent = order.form.clave.comission;
                order.form.udi = order.form.clave.udi;
              } catch (e) {}
            }
            if (clave) {
              order.defaults.claves.forEach(function (item) {
                if (
                  item.clave.toString().replace(/\s/g, "") ===
                  clave.toString().replace(/\s/g, "")
                ) {
                  order.form.clave = item;
                }
              });
            }
            $http
              .get(url.IP + "ramos-by-provider/" + aseguradora.id)
              .then(function (ramo) {
                order.defaults.ramos = ramo.data;
                order.defaults.ramos.forEach(function (ramo) {
                  if (ramo.ramo_code == 3) {
                    order.form.ramo = ramo;
                    $scope.saveLocalstorange();
                    order.defaults.subramos = ramo.subramo_ramo;
                    order.defaults.subramos.forEach(function (sub) {
                      if (sub.subramo_code == 9) {
                        order.form.subramo = sub;
                        // $scope.verComisiones();
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };
                        order.show.showForms = true;
                        order.defaults.formInfo = {
                          code: order.form.subramo.subramo_code,
                          name: order.form.subramo.subramo_name,
                        };

                        order.defaults.comisiones = [];

                        if (order.form.clave) {
                          if (order.form.clave.clave_comision.length) {
                            order.form.clave.clave_comision.forEach(function (
                              item
                            ) {
                              if (
                                order.form.subramo.subramo_name == item.subramo
                              ) {
                                order.defaults.comisiones.push(item);
                              }
                            });

                            order.form.comisiones = order.defaults.comisiones;
                            if (order.defaults.comisiones.length == 1) {
                              order.form.comision =
                                order.defaults.comisiones[0];
                              $scope.selectComision(order.form.comision);
                            }
                          }
                        }
                        $scope.cargandoPaquetes = true;
                        $http
                          .post(url.IP + "paquetes-data-by-subramo/", {
                            ramo: order.form.ramo.id,
                            subramo: order.form.subramo.id,
                            provider: order.form.aseguradora.id,
                          })
                          .then(
                            function success(response) {
                              $scope.cargandoPaquetes = false;
                              order.defaults.packages = [];
                              order.defaults.coverages = [];
                              $scope.paqueteSelected = false;
                              $scope.coberturasPackagePdf = [];

                              if (response.data.length) {
                                order.defaults.packages = response.data;
                                if (
                                  $scope.read_pdf.data.cobertura == "" ||
                                  $scope.read_pdf.data.cobertura == undefined
                                ) {
                                  $scope.read_pdf.data.cobertura = "AMPLIA";
                                }
                                var best = null;
                                var bestScore = -1;
                                var target = $scope.read_pdf.data.cobertura;
                                var encontardo_paquete = true;
                                $scope.coberturasPackagePdf = [];

                                var res = pickBestPackageOriginal(
                                  order.defaults.packages,
                                  $scope.read_pdf.data.cobertura
                                );
                                var best = res ? res.best : null;
                                var score = res ? res.score : null;

                                var cobertura = $scope.read_pdf.data.cobertura;
                                $scope.packages = order.defaults.packages;
                                // Debería elegir: "ESMERALDA" (id 88256) por tier + similitud
                                // ----------
                                if (best) {
                                  $scope.paqueteSelectedObject = best;
                                  encontardo_paquete = false;
                                  // console.log('✅ Mejor match:', best.package_name, 'score:', score);
                                } else {
                                  $scope.paqueteSelectedObject = null;
                                  encontardo_paquete = true;
                                  console.warn("No hubo coincidencias");
                                }
                                if (!encontardo_paquete) {
                                  $scope.paqueteSelected = true;
                                  order.form.paquete =
                                    $scope.paqueteSelectedObject;
                                  $scope.yaseestableciopaquete = true;
                                  $scope.dataToSave.paquete =
                                    order.form.paquete.id;
                                  for (i in $scope.read_pdf.data[
                                    "Primas y coberturas"
                                  ]) {
                                    if (
                                      $scope.read_pdf.data[
                                        "Primas y coberturas"
                                      ][i].hasOwnProperty("Deducible")
                                    ) {
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"] == "nan"
                                      ) {
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"] = "0";
                                      }
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"] == "nan"
                                      ) {
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"] = "0";
                                      }
                                      var it = {};
                                      it["coverage_name"] = i;
                                      it["url"] =
                                        slug(i) +
                                        "-" +
                                        (order.form.paquete.id || "pkg") +
                                        "-" +
                                        ($scope.coberturasPackagePdf.length +
                                          1);
                                      it["package"] = order.form.paquete.id;
                                      it["deductibleInPolicy"] = {
                                        value:
                                          $scope.read_pdf.data[
                                            "Primas y coberturas"
                                          ][i]["Deducible"],
                                      };
                                      it["deductible_coverage"] = [
                                        { deductible: 0 },
                                      ];
                                      it["deductible_coverage"][0][
                                        "deductible"
                                      ] =
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Deducible"];
                                      it["sumInPolicy"] = {
                                        value:
                                          $scope.read_pdf.data[
                                            "Primas y coberturas"
                                          ][i]["Suma asegurada"],
                                      };
                                      it["sums_coverage"] = [
                                        { sum_insured: 0 },
                                      ];
                                      it["sums_coverage"][0]["sum_insured"] =
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Suma asegurada"];
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Coaseguro"]
                                      ) {
                                        it["coinsuranceInPolicy"] = {
                                          value:
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i]["Coaseguro"],
                                        };
                                      }
                                      if (
                                        $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ][i]["Tope"]
                                      ) {
                                        it["topeCoinsuranceInPolicy"] = {
                                          value:
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i]["Tope"],
                                        };
                                      }
                                      $scope.coberturasPackagePdf.push(it);
                                      order.defaults.coverages =
                                        $scope.coberturasPackagePdf;
                                      $localStorage["defaults"] =
                                        order.defaults;
                                      order.form.paquete = order.form.paquete;
                                    }
                                  }
                                  order.coverageInPolicy_policy =
                                    order.defaults.coverages;
                                  order.form.paquete = order.form.paquete;
                                  $scope.dataToSave.paquete =
                                    order.form.paquete.id;
                                } else {
                                  order.defaults.packages.forEach(function (
                                    item
                                  ) {
                                    var s = scorePackage(
                                      item.package_name,
                                      target
                                    );
                                    if (s > bestScore) {
                                      bestScore = s;
                                      best = item;
                                    }
                                    if (
                                      item.package_name.toLowerCase() &&
                                      $scope.read_pdf.data.cobertura.toLowerCase()
                                    ) {
                                      if (
                                        item.package_name.toLowerCase() ==
                                          $scope.read_pdf.data.cobertura.toLowerCase() ||
                                        (item.package_name
                                          .toLowerCase()
                                          .includes(
                                            $scope.read_pdf.data.cobertura.toLowerCase()
                                          ) &&
                                          !$scope.paqueteSelected) ||
                                        (best &&
                                          $scope.yaseestableciopaquete == false)
                                      ) {
                                        $scope.paqueteSelected = true;
                                        order.form.paquete = item;
                                        $scope.yaseestableciopaquete = true;
                                        $scope.dataToSave.paquete =
                                          order.form.paquete.id;
                                        for (i in $scope.read_pdf.data[
                                          "Primas y coberturas"
                                        ]) {
                                          if (
                                            $scope.read_pdf.data[
                                              "Primas y coberturas"
                                            ][i].hasOwnProperty("Deducible")
                                          ) {
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"] == "nan"
                                            ) {
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"] = "0";
                                            }
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"] == "nan"
                                            ) {
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"] = "0";
                                            }
                                            var it = {};
                                            it["coverage_name"] = i;
                                            it["url"] =
                                              slug(i) +
                                              "-" +
                                              (item.id || "pkg") +
                                              "-" +
                                              ($scope.coberturasPackagePdf
                                                .length +
                                                1);
                                            it["package"] = item.id;
                                            it["deductibleInPolicy"] = {
                                              value:
                                                $scope.read_pdf.data[
                                                  "Primas y coberturas"
                                                ][i]["Deducible"],
                                            };
                                            it["deductible_coverage"] = [
                                              { deductible: 0 },
                                            ];
                                            it["deductible_coverage"][0][
                                              "deductible"
                                            ] =
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Deducible"];
                                            it["sumInPolicy"] = {
                                              value:
                                                $scope.read_pdf.data[
                                                  "Primas y coberturas"
                                                ][i]["Suma asegurada"],
                                            };
                                            it["sums_coverage"] = [
                                              { sum_insured: 0 },
                                            ];
                                            it["sums_coverage"][0][
                                              "sum_insured"
                                            ] =
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Suma asegurada"];
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Coaseguro"]
                                            ) {
                                              it["coinsuranceInPolicy"] = {
                                                value:
                                                  $scope.read_pdf.data[
                                                    "Primas y coberturas"
                                                  ][i]["Coaseguro"],
                                              };
                                            }
                                            if (
                                              $scope.read_pdf.data[
                                                "Primas y coberturas"
                                              ][i]["Tope"]
                                            ) {
                                              it["topeCoinsuranceInPolicy"] = {
                                                value:
                                                  $scope.read_pdf.data[
                                                    "Primas y coberturas"
                                                  ][i]["Tope"],
                                              };
                                            }
                                            $scope.coberturasPackagePdf.push(
                                              it
                                            );
                                            order.defaults.coverages =
                                              $scope.coberturasPackagePdf;
                                            $localStorage["defaults"] =
                                              order.defaults;
                                            order.form.paquete = item;
                                          }
                                        }
                                        order.coverageInPolicy_policy =
                                          order.defaults.coverages;
                                        order.form.paquete = item;
                                        $scope.dataToSave.paquete =
                                          order.form.paquete.id;
                                        $scope.saveLocalstorange();
                                      }
                                    }
                                  });
                                }
                                // var best = null;
                                // var bestScore = -1;
                                // var target=$scope.read_pdf.data.cobertura ? $scope.read_pdf && $scope.read_pdf.data && $scope.read_pdf.data.cobertura :order.defaults.packages[0].package_name
                                // $scope.coberturasPackagePdf=[]
                                // order.defaults.packages.forEach(function(item){
                                //   var s = scorePackage(item.package_name, target);
                                //   if (s > bestScore) { bestScore = s; best = item; }
                                //   if((item.package_name).toLowerCase() && $scope.read_pdf.data.cobertura.toLowerCase()){
                                //     if (((item.package_name.toLowerCase() == $scope.read_pdf.data.cobertura.toLowerCase())
                                //       || ( item.package_name.toLowerCase().includes($scope.read_pdf.data.cobertura.toLowerCase()))
                                //       && !$scope.paqueteSelected) || best  && $scope.yaseestableciopaquete==false){
                                //       console.log('zzzzzzzz',best)
                                //       $scope.paqueteSelected = true;
                                //       order.form.paquete = item;
                                //       $scope.yaseestableciopaquete=true;
                                //       $scope.dataToSave.paquete = order.form.paquete.id;
                                //       for (i in $scope.read_pdf.data['Primas y coberturas']) {

                                //           if ($scope.read_pdf.data['Primas y coberturas'][i].hasOwnProperty('Deducible')) {
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Deducible'] =='nan'){
                                //               $scope.read_pdf.data['Primas y coberturas'][i]['Deducible']='0'
                                //             }
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada'] =='nan'){
                                //               $scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']='0'
                                //             }
                                //             var it ={}
                                //             it['coverage_name'] = i
                                //             it['url'] = slug(i) + '-' + (item.id || 'pkg') + '-' + ($scope.coberturasPackagePdf.length + 1);
                                //             it['package'] = item.id
                                //             it['deductibleInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Deducible']}
                                //             it['deductible_coverage']=[{'deductible':0}]
                                //             it['deductible_coverage'][0]['deductible'] =$scope.read_pdf.data['Primas y coberturas'][i]['Deducible']
                                //             it['sumInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']}
                                //             it['sums_coverage']=[{'sum_insured':0}]
                                //             it['sums_coverage'][0]['sum_insured'] =$scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Coaseguro']){
                                //               it['coinsuranceInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Coaseguro']}
                                //             }
                                //             if($scope.read_pdf.data['Primas y coberturas'][i]['Tope']){
                                //               it['topeCoinsuranceInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Tope']}
                                //             }
                                //             $scope.coberturasPackagePdf.push(it)
                                //             order.defaults.coverages=$scope.coberturasPackagePdf
                                //             $localStorage['defaults'] = order.defaults
                                //             order.form.paquete = item;
                                //         }
                                //       }
                                //       order.coverageInPolicy_policy = order.defaults.coverages;
                                //       order.form.paquete = item;
                                //       $scope.dataToSave.paquete = order.form.paquete.id;
                                //       $scope.saveLocalstorange()
                                //     }
                                //   }
                                // })
                                $scope.changeSubramo();
                                if ($localStorage) {
                                }
                              }
                            },
                            function error(e) {
                              $scope.cargandoPaquetes = false;
                              console.log(
                                "Error - paquetes-data-by-subramo",
                                e
                              );
                              order.defaults.packages = [];
                            }
                          )
                          .catch(function (error) {
                            $scope.cargandoPaquetes = false;
                            console.log(
                              "Error - paquetes-data-by-subramo - catch",
                              error
                            );
                            order.defaults.packages = [];
                          });
                      }
                    });
                  }
                });
              });
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }
    // ++++++++++++++++++++++++++++**************
    function get_claves() {
      var date = new Date(order.form.startDate);
      if (isNaN(date)) {
        var date = new Date(mesDiaAnio(order.form.startDate));
      }

      $http
        .get(url.IP + "claves-by-provider/" + order.form.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });

            order.defaults.claves = clavesResponse.data;
            if (order.defaults.claves.length == 1) {
              order.form.clave = order.defaults.claves[0];
              $scope.dataToSave.clave = order.form.clave.id;
              try {
                order.form.comision_percent = order.form.clave.comission;
                order.form.udi = order.form.clave.udi;
              } catch (e) {}
            }
            if (order.form.clave == undefined || !order.form.clave) {
              if (order.defaults.claves && order.defaults.claves.length != 0) {
                order.form.clave = order.defaults.claves[0];
                $scope.dataToSave.clave = order.form.clave.id;
                try {
                  order.form.comision_percent = order.form.clave.comission;
                  order.form.udi = order.form.clave.udi;
                } catch (e) {}
              }
            }
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }
    order.autocomplete = autocomplete;
    function autocomplete(param) {
      try {
        if (param.val.length > 1) {
          getmatches(param.val);
        }
      } catch (e) {}
    }

    $scope.addNewPackage = function () {
      $scope.show_new_pack = true;
      $scope.create_pack = true;
      $scope.show_new_sub = false;

      $scope.newPackageCoverage = {
        package_name: "",
        description: "",
        coverage_package: [
          {
            coverage_name: "",
            deductible: "",
            sums_coverage: [],
            coinsurance_coverage: [],
          },
        ],
      };
    };

    $scope.addNewPackageCoverage = function () {
      var coverage = {
        coverage_name: "",
        sums_coverage: [],
        deductible: [],
        coinsurance_coverage: [],
        topecoinsurance_coverage: [],
      };
      $scope.newPackageCoverage.coverage_package.push(coverage);
    };

    $scope.deleteNewPackageCoverage = function (index) {
      $scope.newPackageCoverage.coverage_package.splice(index, 1);
    };
    $scope.cancelNewPackage = function () {
      $scope.newPackageCoverage = [];
      $scope.show_new_pack = false;
      $scope.create_pack = false;
    };
    $scope.saveNewPackage = function () {
      $scope.paqueteGuardado = true;
      var parObj = {
        package_name: $scope.newPackageCoverage
          ? $scope.newPackageCoverage.package_name
          : "",
        description: $scope.newPackageCoverage.description,
        provider: order.form.aseguradora.url,
        ramo: order.form.ramo.url,
        subramo: order.form.subramo.url,
        type_package: 1, // paquete normal
        coverage_package: [],
      };
      packageService
        .createPackage(parObj)
        .then(
          function success(request) {
            if (request.id) {
              $scope.show_new_pack = false;
              $scope.paqueteGuardado = false;
              order.defaults.packages.push(request);
              // $scope.create_pack = false;
              // $scope.add_coverages = true;
              $scope.package_created = request;
              $scope.newPackageCoverage.coverage_package.forEach(function (
                item,
                index
              ) {
                var obj = {
                  coverage_name: item.coverage_name,
                  // priority: priority ? priority : 0,
                  provider: order.form.aseguradora.url,
                  package: $scope.package_created.url,
                  deductible: [],
                  sums_coverage: [],
                };

                coverageService
                  .createCoverage(obj)
                  .then(
                    function success(request) {
                      $http({
                        method: "POST",
                        url: url.IP + "sumas-aseguradas/",
                        data: {
                          coverage_sum: request.url,
                          sum_insured: item.sums_coverage,
                          default: true,
                        },
                      }).then(function success(sum) {
                        $http({
                          method: "POST",
                          url: url.IP + "deducibles/",
                          data: {
                            coverage_deductible: request.url,
                            deductible: item.deductible,
                            default: true,
                          },
                        }).then(function success(ded) {
                          if (request.id) {
                            $scope.coverages.push(request);
                            // $scope.coverageName = '';
                            // parName = '';
                            request.sums_coverage = sum;
                            request.deductible_coverage = ded;

                            order.defaults.packages.forEach(function (item) {
                              if (item.id == $scope.package_created.id) {
                                if (item.coverage_package) {
                                  item.coverage_package.push(request);
                                } else {
                                  item.coverage_package = [];
                                  item.coverage_package.push(request);
                                }
                              }
                            });
                          }
                        });
                      });
                    },
                    function error(error) {
                      console.log("error - createCoverage", error);
                    }
                  )
                  .catch(function (e) {
                    console.log("error - createCoverage - catch", e);
                  });

                if (
                  index + 1 ==
                  $scope.newPackageCoverage.coverage_package.length
                ) {
                  $scope.show_new_pack = false;
                  $scope.newPackageCoverage = {
                    package_name: "",
                    description: "",
                    coverage_package: [
                      {
                        coverage_name: "",
                        deductible: "",
                        sums_coverage: [],
                        coinsurance_coverage: [],
                      },
                    ],
                  };
                }
              });
            }
          },
          function error(error) {
            console.log("error - createPackage", error);
          }
        )
        .catch(function (e) {
          console.log("error -createPackage- catch", e);
        });
    };

    $scope.selectComision = function (param) {
      order.form.comision_percent = param.comission;
      order.form.udi = param.udi;
      $scope.dataToSave.comision_percent = param.comission;
      $scope.dataToSave.udi = param.udi;
    };

    $scope.addNewSubramo = function () {
      $scope.show_new_sub = true;
      $scope.create_sub = true;
      $scope.show_new_pack = false;
    };

    $scope.savePackage = function (parObj) {
      parObj.provider = order.form.aseguradora.url;
      parObj.ramo = order.form.ramo.url;
      parObj.subramo = order.form.subramo.url;
      parObj.type_package = 1; // paquete normal
      parObj.coverage_package = [];

      packageService
        .createPackage(parObj)
        .then(
          function success(request) {
            if (request.id) {
              order.defaults.packages.push(request);
              $scope.create_pack = false;
              $scope.add_coverages = true;
              $scope.package_created = request;
            }
          },
          function error(error) {
            console.log("error - createPackage", error);
          }
        )
        .catch(function (e) {
          console.log("error -createPackage- catch", e);
        });
    };

    $scope.saveCoverage = function (parName, sum_insured, deductible) {
      // var paqueteData = $scope.package_created;

      var obj = {
        coverage_name: parName,
        // priority: priority ? priority : 0,
        provider: order.form.aseguradora.url,
        package: $scope.package_created.url,
        deductible: [],
        sums_coverage: [],
      };

      coverageService
        .createCoverage(obj)
        .then(
          function success(request) {
            $http({
              method: "POST",
              url: url.IP + "sumas-aseguradas/",
              data: {
                coverage_sum: request.url,
                sum_insured: sum_insured,
                default: true,
              },
            });
            $http({
              method: "POST",
              url: url.IP + "deducibles/",
              data: {
                coverage_deductible: request.url,
                deductible: deductible,
                default: true,
              },
            });
            // console.log('request', request);
            if (request.id) {
              $scope.coverages.push(request);
              $scope.coverageName = "";
              parName = "";

              order.defaults.packages.forEach(function (item) {
                if (item.id == $scope.package_created.id) {
                  if (item.coverage_package) {
                    item.coverage_package.push(request);
                  } else {
                    item.coverage_package = [];
                    item.coverage_package.push(request);
                  }
                }
              });
            }
          },
          function error(error) {
            console.log("error - createCoverage", error);
          }
        )
        .catch(function (e) {
          console.log("error - createCoverage - catch", e);
        });
    };

    $scope.finishCoverages = function () {
      $scope.create_pack = false;
      $scope.add_coverages = false;
      $scope.show_new_pack = false;
      $scope.coverages = [];
      $scope.changePackage($scope.package_created);
      $scope.changeSubramo();
    };

    $scope.cancelNewPackage = function () {
      $scope.show_new_pack = false;
      $scope.package = {};
    };

    $scope.cancelNewSubramo = function () {
      $scope.show_new_sub = false;
    };

    $scope.checkSelected = function (value, parUser) {
      if (value) {
        $http.get(url.IP + "bancos/").then(function (bank) {
          $scope.banks = bank.data;

          if (parUser.user_info) {
            if (parUser.user_info.is_vendedor) {
              var seller_data = parUser.user_info.info_vendedor[0];
              $scope.original_data = vendedorStructure(parUser, seller_data);
            }
          } else {
            parUser.hired_date = datesFactory.convertDate(new Date());
          }
        });
      } else {
        $scope.users.forEach(function (user) {
          if (parUser.id == user.id) {
            user["phones"] = [];
            user["subramos"] = [];
          }
        });
      }
    };

    function vendedorStructure(parUser, parData) {
      var date = new Date(parData.hired_date);
      parUser.hired_date = datesFactory.convertDate(date);
      parUser.reference_number = parData.reference_number;
      parUser.gastos_operacion = parData.gastos_operacion;
      parUser.address = parData.address;
      parUser.email = parData.email;
      parUser.url = parData.url;

      $scope.banks.forEach(function (bank) {
        if (bank.id == parData.bank) {
          parUser.bank = bank;
        }
      });

      $scope.fcs.forEach(function (frec) {
        if (frec.key == parData.frequencia_de_cobro) {
          parUser.frequencia_de_cobro = frec;
        }
      });

      $scope.pay_ways.forEach(function (pay) {
        if (pay.key == parData.tipo_pago) {
          parUser.pay_way = pay;
        }
      });

      if (parData.vendedor_phone.length) {
        if (parData.vendedor_phone.length == 1) {
          parUser.phone = parData.vendedor_phone[0].phone;
        } else if (parData.vendedor_phone.length > 1) {
          parData.vendedor_phone.forEach(function (phone, index) {
            if (index == 0) {
              parUser.phone = parData.vendedor_phone[0].phone;
            } else {
              parUser.phones.push(phone.phone);
            }
          });
        }
      }

      parData.vendedor_subramos.forEach(function (sub_ramo) {
        var data = {
          provider: sub_ramo.provider,
          ramo: sub_ramo.ramo,
          subramo: sub_ramo.subramo,
          comision_percentage: sub_ramo.comision,
          comision: sub_ramo.comision,
          id: sub_ramo.id,
          url: sub_ramo.url,
          ramos: $scope.fake_ramos,
        };

        $scope.aseguradoras.forEach(function (provider) {
          if (sub_ramo.provider == 0 && sub_ramo.ramo != 0) {
            data.ramos = $scope.fake_ramos;

            data.ramos.forEach(function (ramo) {
              if (ramo.id == sub_ramo.ramo) {
                data.ramo = ramo;
                data.sub_ramos = ramo.subramo_ramo;

                ramo.subramo_ramo.forEach(function (sub) {
                  if (sub.id == sub_ramo.subramo) {
                    data.subramo = sub;
                  }
                });
              }
            });
          } else if (provider.id == sub_ramo.provider) {
            data.ramos = $scope.fake_ramos;

            data.provider = provider;

            $http
              .get(url.IP + "ramos-by-provider/" + provider.id)
              .then(function (ramo) {
                data.ramos = ramo.data;

                data.ramos.forEach(function (ramo) {
                  if (ramo.id == sub_ramo.ramo) {
                    data.ramo = ramo;
                    data.sub_ramos = ramo.subramo_ramo;

                    ramo.subramo_ramo.forEach(function (sub) {
                      if (sub.id == sub_ramo.subramo) {
                        data.subramo = sub;
                      }
                    });
                  }
                });
              });
          }
        });

        parUser.subramos.push(data);
      });

      return angular.copy(parUser);
    }

    $scope.saveSeller = function (main_index) {
      var user = angular.copy($scope.referenciador[main_index]);
      if (user.user_info) {
        if (user.user_info.is_vendedor) {
          var vendedor_ = user.user_info.info_vendedor[0].id;
        }
      } else {
        var vendedor_ = user.id;
      }

      if (user.subramos.length) {
        var subramos_ = user.subramos.map(function (item) {
          var subramo_post = {
            provider: item.provider ? item.provider.id : 0,
            ramo: item.ramo ? item.ramo.id : 0,
            subramo: item.subramo ? item.subramo.id : 0,
            comision: item.comision_percentage
              ? parseFloat(item.comision_percentage)
              : 0,
            vendedor: vendedor_,
          };

          if (item.id) {
            subramo_post.id = item.id;
          }

          if (item.url) {
            subramo_post.url = item.url;
          }

          return subramo_post;
        });
      } else {
        var subramos_ = [];
      }

      if (user.phones.length) {
        var phones_ = user.phones.map(function (phn) {
          var phones_return = {
            phone: phn,
            vendedor: vendedor_,
          };

          if (phn.id) {
            phones_return.id = phn.id;
          }

          if (phn.url) {
            phones_return.url = phn.url;
          }

          return phones_return;
        });

        if (user.phone) {
          phones_.push({ phone: user.phone, vendedor: vendedor_ });
        }
      } else {
        if (user.phone) {
          var phones_ = [{ phone: user.phone, vendedor: vendedor_ }];
        }
      }

      var hired_date_ = datesFactory.toDate(user.hired_date);

      user.vendedor_subramos = subramos_;
      user.hired_date = hired_date_;
      user.vendedor_phone = phones_;
      user.gastos_operacion = user.gastos_operacion
        ? parseInt(user.gastos_operacion)
        : 0;
      user.user = user.id;
      user.vendedor = vendedor_;
      user.is_vendedor = true;

      if (user.user_info.info_vendedor.length > 0) {
        if (user.user_info.is_vendedor) {
          var data_source = {};

          var hired_date_original = datesFactory.toDate(
            $scope.original_data.hired_date
          );

          if (hired_date_original !== hired_date_) {
            data_source.hired_date = user.hired_date;
          }

          if ($scope.original_data.bank.id !== user.bank.id) {
            data_source.bank = user.bank.id;
          }

          if ($scope.original_data.reference_number !== user.reference_number) {
            data_source.reference_number = user.reference_number;
          }

          if ($scope.original_data.pay_way.key !== user.pay_way.key) {
            data_source.tipo_pago = user.pay_way.key;
          }

          if (
            parseFloat($scope.original_data.gastos_operacion) !==
            parseFloat(user.gastos_operacion)
          ) {
            data_source.gastos_operacion = user.gastos_operacion;
          }

          // if($scope.original_data.frequencia_de_cobro.key !== user.frequencia_de_cobro.key) {
          //     data_source.frequencia_de_cobro = user.frequencia_de_cobro.key
          // }

          if ($scope.original_data.email !== user.email) {
            data_source.email = user.email;
          }

          if ($scope.original_data.phone !== user.phone) {
            var source_phone = {};
            var source_url = user.user_info.info_vendedor[0].vendedor_phone[0];
            source_phone.phone = user.phone;
            $http.patch(source_url.url, source_phone).then(function (req) {
              if (req.status == 200) {
              }
            });
          }

          for (var i = 0; i < $scope.original_data.phones.length; i++) {
            if ($scope.original_data.phones[i] !== user.phones[i]) {
              var source_phone = {};
              var source_url =
                user.user_info.info_vendedor[0].vendedor_phone[i + 1];
              source_phone.phone = user.phones[i];
              $http.patch(source_url.url, source_phone).then(function (req) {
                if (req.status == 200) {
                }
              });
            }
          }

          if ($scope.original_data.address !== user.address) {
            data_source.address = user.address;
          }

          $http.patch(user.url, data_source).then(function (req) {
            // console.log('req', req);
            if (req.status == 200) {
              $http.get(url.IP + "get-vendors/").then(function (user) {
                $scope.referenciador = user.data;
                SweetAlert.swal("¡Listo!", MESSAGES.OK.UPDATESELLER, "success");

                $scope.show_pagination = true;
                $scope.config_pagination_referenciador = {
                  count: user.data.count,
                  next: user.data.next,
                  previous: user.data.previous,
                };

                $scope.testPagination(
                  "referenciador",
                  "config_pagination_referenciador"
                );

                $scope.referenciador.forEach(function (user) {
                  user["phones"] = [];
                  user["subramos"] = [];
                });

                providerService
                  .getReadListProviders()
                  .then(function (provider) {
                    $scope.aseguradoras = provider;
                  });
              });
            }
          });

          if ($scope.original_data.subramos.length !== subramos_.length) {
            // DELETE $scope.delete_subramos
            if ($scope.delete_subramos.length) {
              $scope.delete_subramos.forEach(function (item_d) {
                $http.delete(item_d.url).then(function (delete_item) {
                  // console.log('delete_item', delete_item);
                });
              });
            }

            subramos_.forEach(function (item) {
              if (item.id) {
                $scope.original_data.subramos.forEach(function (o_item) {
                  if (o_item.id == item.id) {
                    if (
                      parseFloat(o_item.comision) !== parseFloat(item.comision)
                    ) {
                      $http
                        .patch(item.url, { comision: item.comision })
                        .then(function (comision) {
                          // console.log('comision_percentage - patch', comision);
                        });
                    }
                  }
                });
              } else {
                dataFactory
                  .post("subramos-vendedor/", item)
                  .then(function (subramo_) {
                    // console.log('subramo_', subramo_);
                  });
              }
            });
          } else {
            subramos_.forEach(function (item) {
              if (item.id) {
                $scope.original_data.subramos.forEach(function (o_item) {
                  if (o_item.id == item.id) {
                    var sub_ramo_data = {};

                    if (
                      parseFloat(o_item.comision) !== parseFloat(item.comision)
                    ) {
                      sub_ramo_data.comision = item.comision;
                    }

                    if (o_item.provider !== item.provider) {
                      sub_ramo_data.provider = item.provider;
                    }

                    if (o_item.ramo !== item.ramo) {
                      sub_ramo_data.ramo = item.ramo;
                    }

                    if (o_item.subramo !== item.subramo) {
                      sub_ramo_data.subramo = item.subramo;
                    }

                    $http
                      .patch(item.url, sub_ramo_data)
                      .then(function (request) {
                        // console.log(request);
                      });
                  }
                });
              }
            });
          }

          $scope.original_data.phones.push($scope.original_data.phone);

          if ($scope.original_data.phones.length !== phones_.length) {
            // DELETE $scope.delete_subramos
            if ($scope.delete_phones.length) {
              $scope.delete_phones.forEach(function (item) {
                $http.delete(item.url).then(function (delete_item) {
                  // console.log('delete_item', delete_item);
                });
              });
            }

            phones_.forEach(function (item) {
              if (item.id) {
                $scope.original_data.phones.forEach(function (o_item) {
                  if (o_item.id == item.id) {
                    if (
                      parseFloat(o_item.phone) !==
                      parseFloat(item.$scope.delete_phones)
                    ) {
                      $http
                        .patch(item.url, { phone: item.$scope.delete_phones })
                        .then(function (phine) {
                          console.log("phone - patch", phine);
                        });
                    }
                  }
                });
              } else {
                // post
                dataFactory
                  .post("phone-vendedor/", item)
                  .then(function (phne_) {
                    // console.log('phne', phne_);
                  });
              }
            });
          }
        } else {
          dataFactory.post("vendedores/", user).then(function (data) {
            if (data.status == 201) {
              $scope.isSeller[main_index] = false;

              $scope.users.forEach(function (user, index) {
                if (user.id == data.data.user) {
                  dataFactory
                    .get("get-vendors/" + data.data.user)
                    .then(function (req) {
                      req.data["phones"] = [];
                      req.data["subramos"] = [];
                      $scope.users[index] = req.data;
                    });
                }
              });
            }
          });
        }
      } else {
        user.bank = user.bank.id;
        user.tipo_pago = user.pay_way.key;
        user.frequencia_de_cobro = user.frequencia_de_cobro.key;

        dataFactory.post("vendedores/", user).then(function (data) {
          if (data.status == 201) {
            $scope.isSeller[main_index] = false;

            $scope.users.forEach(function (user, index) {
              if (user.id == data.data.user) {
                dataFactory
                  .get("get-vendors/" + data.data.user)
                  .then(function (req) {
                    req.data["phones"] = [];
                    req.data["subramos"] = [];
                    $scope.users[index] = req.data;
                  });
              }
            });

            $http.get(url.IP + "get-vendors/").then(function (user) {
              $scope.referenciador = user.data;
              SweetAlert.swal("¡Listo!", MESSAGES.OK.CREATESELLER, "success");

              $scope.show_pagination = true;
              $scope.config_pagination_referenciador = {
                count: user.data.count,
                next: user.data.next,
                previous: user.data.previous,
              };

              $scope.testPagination(
                "referenciador",
                "config_pagination_referenciador"
              );

              $scope.users.forEach(function (user) {
                user["phones"] = [];
                user["subramos"] = [];
              });

              providerService.getReadListProviders().then(function (provider) {
                $scope.aseguradoras = provider;
              });
            });
          }
        });
      }
    };

    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = 0;
      var word_data = order.form.contratante.val;
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data.contractors) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }

                    source.push(obj);
                  });
                }

                $scope.contractors_data = source;
              }
            });
        }
      } else {
        $scope.contractors_data = [];
      }
    };
    $scope.$watch(
      "order.subforms.auto.selectedCar.value",
      function (newValue, oldValue) {
        try {
          order.subforms.auto.brand =
            order.subforms.auto.selectedCar.value.car_brand;
          order.subforms.auto.model =
            order.subforms.auto.selectedCar.value.car_model;
          order.subforms.auto.version =
            order.subforms.auto.selectedCar.value.short_description.replace(
              order.subforms.auto.selectedCar.value.car_model,
              ""
            );
        } catch (e) {}
      }
    );
    $scope.initAddressSelection = function () {
      if (order.defaults.address.length === 1) {
        order.form.address = order.defaults.address[0];
      }
    };
    $scope.$watch(
      "order.form.contratante.value",
      function (newValue, oldValue) {
        if (
          $rootScope &&
          $rootScope.myInsurance &&
          $rootScope.myInsurance.myInsurance &&
          $rootScope.myInsurance.myInsurance.id &&
          order.form &&
          order.form.contratante
        ) {
          order.form.contratante.value = $rootScope.myInsurance.myInsurance;
          $rootScope.myInsurance = {};
        }
        if (
          order.form &&
          order.form.contratante &&
          order.form.contratante.value
        ) {
          $http.get(url.IP + "get-vendors/").then(function (user) {
            $scope.referenciador = user.data;
            $scope.referenciador.forEach(function (user) {
              user.first_name = user.first_name.toUpperCase();
              user.last_name = user.last_name.toUpperCase();
              user["phones"] = [];
              user["subramos"] = [];
            });
            if (user.data) {
              if (
                order.form &&
                order.form.contratante &&
                order.form.contratante.value &&
                order.form.contratante.value.vendor
              ) {
                $scope.referenciador.forEach(function (user) {
                  if (
                    user.url === order.form.contratante.value.vendor &&
                    !$scope.referenciadores.some(function (ref) {
                      return ref.referenciador === user.url;
                    })
                  ) {
                    order.form.vendor = user.id;
                    $scope.referenciadores.push({ referenciador: user.url });
                  }
                });
              }
              if (
                $localStorage.orderFormCotizacion &&
                $localStorage.orderFormCotizacion.referenciador
              ) {
                $scope.referenciador.forEach(function (user) {
                  if (
                    user.url ===
                      $localStorage.orderFormCotizacion.referenciador &&
                    !$scope.referenciadores.some(function (ref) {
                      return ref.referenciador === user.url;
                    })
                  ) {
                    $scope.referenciadores.push({ referenciador: user.url });
                  }
                });
              }
            }
            if (
              $scope.sucursalList &&
              order.form.contratante &&
              order.form.contratante.value &&
              order.form.contratante.value.sucursal &&
              order.form.contratante.sucursal &&
              order.form.contratante.sucursal.id
            ) {
              $scope.sucursalList.forEach(function (item) {
                if (item.id == order.form.contratante.sucursal.id) {
                  order.form.sucursal = order.form.contratante.sucursal.id;
                }
              });
            }
          });

          if (
            order.form.contratante.value &&
            order.form.contratante.value.full_name
          ) {
            order.form.contratante.val = order.form.contratante.value.full_name;
          }
          if (
            order.form.contratante.value &&
            order.form.contratante.value.address_contractor
          ) {
            order.defaults.address =
              order.form.contratante.value.address_contractor;
            $scope.initAddressSelection();
            for (var i = 0; i < order.defaults.address.length.length; i++) {
              if (order.defaults.address[i].tipo == null) {
                order.defaults.address[i].tipo == "";
              }
            }
            order.form.address = order.defaults.address[0];
          }

          if (order.form.contratante.value.phone_number) {
            order.form.contratante.phone_number =
              order.form.contratante.value.phone_number;
          }

          if (order.form.contratante.value.email) {
            order.form.contratante.email = order.form.contratante.value.email;
          }

          try {
            if (order.defaults.address.length == 1) {
              order.form.address = order.defaults.address[0];
            }
          } catch (err) {}

          // if(order.form.contratante.value.celula){
          //   $scope.celulas.forEach(function(item){
          //     if(item.celula_name == order.form.contratante.value.celula){
          //       order.form.celula = item;
          //     }
          //   });
          if (order.form.contratante.value.cellule) {
            $http
              .get(
                order.form.contratante.value.cellule.url
                  ? order.form.contratante.value.cellule.url
                  : order.form.contratante.value.cellule
              )
              .then(function (request) {
                if ($scope.celulas) {
                  $scope.celulas.forEach(function (item) {
                    if (String(item.url) == String(request.data.url)) {
                      order.form.celula = item;
                    }
                  });
                }
              });
          }

          if (
            $scope.sucursalList &&
            order.form.contratante &&
            order.form.contratante.value &&
            order.form.contratante.value.sucursal
          ) {
            $scope.sucursalList.forEach(function (item) {
              if (item.url == order.form.contratante.value.sucursal) {
                order.form.sucursal = item.id;
              }
            });
          }
          $scope.info_sub = order.form.contratante.value;
          // if(order.form.contratante.value.grouping_level){
          if (order.form.contratante.value.groupinglevel) {
            // $http.get(order.form.contratante.value.groupinglevel)
            $http
              .get(
                order.form.contratante.value.groupinglevel.url
                  ? order.form.contratante.value.groupinglevel.url
                  : order.form.contratante.value.groupinglevel
              )
              .then(function (request) {
                // $scope.agrupaciones.forEach(function(item){
                //   console.log('-00--order.form.contratante.value.grouping_level',order.form.contratante.value.groupinglevel)
                //   if(String(item.url) == String(request.data.url)){
                //     console.log('---order.form.contratante.value.grouping_level',order.form.contratante.value.groupinglevel)
                //     order.form.grouping_level = item;
                //     $scope.changeAgrupacion(item);
                //   }
                // });
                if (order.form.contratante.value.groupinglevel) {
                  // $http.get(order.form.contratante.value.groupinglevel)
                  $http
                    .get(
                      order.form.contratante.value.groupinglevel.url
                        ? order.form.contratante.value.groupinglevel.url
                        : order.form.contratante.value.groupinglevel
                    )
                    .then(function success(respons) {
                      if (respons.data.type_grouping == 3) {
                        $scope.info_sub.subsubgrouping =
                          respons.data.description;
                        $http
                          .get(respons.data.parent)
                          .then(function success(respon) {
                            $scope.info_sub.subgrouping =
                              respon.data.description;
                            $http
                              .get(respon.data.parent)
                              .then(function success(respo) {
                                order.form.grouping_level = respo.data;
                                $scope.changeAgrupacion(respo.data);
                              });
                            order.form.subgrouping == respon.data;
                          });
                        order.form.subsubgrouping == respons.data;
                      } else if (respons.data.type_grouping == 2) {
                        $scope.info_sub.subgrouping = respons.data.description;
                        $http
                          .get(respons.data.parent)
                          .then(function success(respon) {
                            order.form.grouping_level = respon.data;
                            $scope.changeAgrupacion(respon.data);
                          });
                        order.form.subgrouping == respons.data;
                      } else if (respons.data.type_grouping == 1) {
                        order.form.grouping_level = respons.data;
                        $scope.changeAgrupacion(respons.data);
                      }
                    });
                }
              });
          }
        }
      }
    );

    $scope.$watch("order.defaults.coverages", function (newValue, oldValue) {
      if (newValue) {
        newValue.forEach(function (coverage) {
          // console.log('coverage', coverage);
          coverage.deductible_coverage_parsed = [];
          coverage.sums_coverage_parsed = [];
          coverage.deductible_coverage.forEach(function (deductible) {
            var obj = {
              label: deductible.deductible,
              value: deductible.deductible,
            };
            coverage.deductible_coverage_parsed.push(obj);
          });

          coverage.sums_coverage.forEach(function (suma) {
            var obj = {
              label: suma.sum_insured,
              value: suma.sum_insured,
            };
            coverage.sums_coverage_parsed.push(obj);
          });
        });
      }
    });
    $scope.aseguradoraSelection = function () {
      // Nueva estructura
      if (order.form.aseguradora) {
        $scope.dataToSave.aseguradora = order.form.aseguradora.id;
      }

      if (order.form.aseguradora) {
        get_claves();
      }
      if (order.form.aseguradora) {
        $http
          .get(url.IP + "ramos-by-provider/" + order.form.aseguradora.id)
          .then(
            function success(response) {
              order.defaults.ramos = response.data;
              if ($localStorage.orderFormCotizacion) {
                order.defaults.ramos.forEach(function (ram) {
                  if (ram.ramo_name == $localStorage.orderFormCotizacion.ramo) {
                    order.form.ramo = ram;
                    $scope.changeRamo();
                    if (
                      order.form.ramo.ramo_code == 2 &&
                      order.subforms.disease
                    ) {
                      order.subforms.disease.first_name = JSON.parse(
                        $localStorage.orderFormCotizacion.accidents.replaceAll(
                          "'",
                          '"'
                        )
                      )["first_name"];
                      order.subforms.disease.last_name = JSON.parse(
                        $localStorage.orderFormCotizacion.accidents.replaceAll(
                          "'",
                          '"'
                        )
                      )["last_name"];
                      order.subforms.disease.second_last_name = JSON.parse(
                        $localStorage.orderFormCotizacion.accidents.replaceAll(
                          "'",
                          '"'
                        )
                      )["second_last_name"];
                      order.subforms.disease.birthdate = JSON.parse(
                        $localStorage.orderFormCotizacion.accidents.replaceAll(
                          "'",
                          '"'
                        )
                      )["birthdate"];
                      order.subforms.disease.antiguedad = JSON.parse(
                        $localStorage.orderFormCotizacion.accidents.replaceAll(
                          "'",
                          '"'
                        )
                      )["antiguedad"];
                      order.subforms.disease.sex = JSON.parse(
                        $localStorage.orderFormCotizacion.accidents.replaceAll(
                          "'",
                          '"'
                        )
                      )["sex"];
                      order.subforms.disease.relationshipList = JSON.parse(
                        $localStorage.orderFormCotizacion.accidents.replaceAll(
                          "'",
                          '"'
                        )
                      )["relationshipList"];
                      order.subforms.disease.relationshipList.map(function (
                        rel
                      ) {
                        rel["sex"] =
                          rel["value"] == "M" ? $scope.sex[0] : $scope.sex[1];
                        tiposBeneficiarios.forEach(function (tb) {
                          if (
                            tb.relationship ==
                            rel["relationship"]["relationship"]
                          ) {
                            rel["relationship"] = tb;
                          }
                        });
                        return rel;
                      });
                    }
                    if (order.form.ramo.ramo_code == 1 && order.subforms.life) {
                      order.subforms.life.aseguradosList = [];
                      order.subforms.life.beneficiariesList = [];
                      // "{'beneficiariesList': [{'person': 1, 'first_name': 'HIJO', 'last_name': 'DE JOAQUIN', 'second_last_name': 'DASD', 'optional_relationship': 'HJO', 'birthdate': '26/04/2022', 'sex': 'M', 'antiguedad': '27/04/2022', 'percentage': 100, 'j_name': '', 'rfc': ''}], 'aseguradosList': [{'first_name': 'JOAUIN', 'last_name': 'SADSA', 'second_last_name': 'ASDSAD', 'birthdate': '02/05/2022', 'sex': 'M', 'antiguedad': '25/04/2022', 'smoker': 'True'}]}"
                      var aseguradosList = JSON.parse(
                        $localStorage.orderFormCotizacion.life.replaceAll(
                          "'",
                          '"'
                        )
                      );
                      aseguradosList["aseguradosList"].forEach(function (al) {
                        var asegurado = {
                          first_name: al.first_name,
                          last_name: al.last_name,
                          second_last_name: al.second_last_name,
                          birthdate: al.birthdate,
                          sex: al.sex,
                          antiguedad: al.antiguedad,
                          smoker: al.smoker,
                        };

                        order.subforms.life.aseguradosList.push(asegurado);
                      });
                      aseguradosList["beneficiariesList"].forEach(function (
                        bl
                      ) {
                        var beneficiario = {
                          person: bl.person,
                          first_name: bl.first_name,
                          optional_relationship: bl.optional_relationship,
                          last_name: bl.last_name,
                          second_last_name: bl.second_last_name,
                          birthdate: bl.birthdate,
                          sex: bl.sex,
                          antiguedad: bl.antiguedad,
                          percentage: bl.percentage
                            ? parseFloat(bl.percentage).toFixed(2)
                            : 0,
                          j_name: bl.j_name,
                          rfc: bl.rfc,
                        };
                        order.subforms.life.beneficiariesList.push(
                          beneficiario
                        );
                      });
                    }
                  }
                });
              }
              if ($scope.aseguradoraPdf) {
                for (var i = 0; i < order.defaults.ramos.length; i++) {
                  if (order.defaults.ramos[i].ramo_code == 3) {
                    order.form.ramo = order.defaults.ramos[i];
                    order.defaults.subramos =
                      order.defaults.ramos[i].subramo_ramo;
                    if (order.defaults.subramos) {
                      for (var j = 0; j < order.defaults.subramos.length; j++) {
                        if (order.defaults.subramos[j].subramo_code == 9) {
                          order.form.subramo = order.defaults.subramos[j];
                          $scope.changeSubramo();
                        }
                      }
                    }
                  }
                }
                if (
                  !order.form.ramo ||
                  order.form.ramo == "" ||
                  order.form.ramo == undefined
                ) {
                  SweetAlert.swal(
                    "Advertencia",
                    "La aseguradora no tiene ramo de daños.",
                    "warning"
                  );
                }
                if (
                  !order.form.subramo ||
                  order.form.subramo == "" ||
                  order.form.subramo == undefined
                ) {
                  SweetAlert.swal(
                    "Advertencia",
                    "La aseguradora no tiene subramo de automoviles.",
                    "warning"
                  );
                }
              }
            },
            function error(e) {
              console.log("Error - ramos-by-provider", e);
            }
          )
          .catch(function (error) {
            console.log("Error - ramos-by-provider - catch", error);
          });
      }
    };

    $scope.changeRamo = function () {
      $scope.dataToSave.ramo = order.form.ramo.id;
      order.defaults.subramos = order.form.ramo.subramo_ramo;
      if ($localStorage.orderFormCotizacion) {
        order.defaults.subramos.forEach(function (subram) {
          if (
            subram.subramo_name == $localStorage.orderFormCotizacion.subramo
          ) {
            order.form.subramo = subram;
            // console.log();
          }
        });
        order.defaults.formInfo = {
          code: order.form.subramo.subramo_code,
          name: order.form.subramo.subramo_name,
        };
        if (
          $localStorage.orderFormCotizacion &&
          $localStorage.orderFormCotizacion.auto
        ) {
          try {
            var auto = JSON.parse(
              $localStorage.orderFormCotizacion.auto.replaceAll("'", '"')
            );
            if (auto && auto.usage) {
              auto.usage = parseInt(auto.usage);
            }
            order.subforms.auto = auto;
            order.form.state_circulation = auto.state_circulation;
          } catch (err) {
            console.log("errrrrrrrr", err);
          }
        }
        // if (order.form.ramo.ramo_code == 3 && order.form.subramo.subramo_code == 9){
        //   if ($localStorage.orderFormCotizacion && $localStorage.orderFormCotizacion.auto) {
        //     var auto = JSON.parse($localStorage.orderFormCotizacion.auto.replaceAll('\'','"'))
        //     order.subforms.auto = auto;
        //     order.form.state_circulation = auto.state_circulation;
        //   }
        // }

        if (
          order.form.ramo.ramo_code == 3 &&
          order.form.subramo.subramo_code != 9
        ) {
          if (
            $localStorage.orderFormCotizacion &&
            $localStorage.orderFormCotizacion.danios
          ) {
            var danios = JSON.parse(
              $localStorage.orderFormCotizacion.danios.replaceAll("'", '"')
            );
            order.subforms.damage = danios;
          }
        }

        if (order.form.subramo.subramo_code == 9) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.auto.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
            if (order.subforms.auto.policy_type["name"] == "Auto") {
              order.types.forEach(function (tipo) {
                if (tipo.id == order.subforms.auto.policy_type["id"]) {
                  order.subforms.auto.policy_type = tipo;
                }
              });
            }
          } catch (err) {}
        }
        if (order.form.subramo.subramo_code == 1) {
          // console.log('dfffffff',order.subforms)
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.life.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }
        if (order.form.subramo.subramo_code == 7) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.damage.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }
        if (order.form.subramo.subramo_code == 6) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.damage.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }
        if (order.form.subramo.subramo_code == 8) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.damage.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }
        if (order.form.subramo.subramo_code == 10) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.damage.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }
        if (order.form.subramo.subramo_code == 11) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.damage.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }
        if (order.form.subramo.subramo_code == 13) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.damage.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }
        if (order.form.subramo.subramo_code == 12) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.damage.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }
        if (order.form.subramo.subramo_code == 5) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.damage.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }
        if (order.form.subramo.subramo_code == 14) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.damage.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }
        if (order.form.subramo.subramo_code == 31) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.damage.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }
        if (
          order.defaults.formInfo.code == 2 ||
          order.defaults.formInfo.code == 3 ||
          order.defaults.formInfo.code == 4
        ) {
          try {
            var tipo = JSON.parse(
              $localStorage.orderFormCotizacion.tipo.replaceAll("'", '"')
            );
            order.subforms.disease.policy_type = {
              name: tipo["descr"],
              id: tipo["value"],
            };
          } catch (err) {}
        }

        $scope.changeSubramo();
      }
    };

    $scope.changeSubramo = function () {
      if (order.form.subramo) {
        $scope.dataToSave.subramo = order.form.subramo.id;
        order.defaults.forms = order.form.subramo.forms_subramo;
        if (order.form.subramo.subramo_code == 1) {
          if (order.types_life.length == 1) {
            order.subforms.life.policy_type = order.types_life[0];
          }
        } else if (
          order.form.subramo.subramo_code == 2 ||
          order.form.subramo.subramo_code == 3 ||
          order.form.subramo.subramo_code == 4
        ) {
          if (order.types_gm.length == 1) {
            if (order.subforms && order.subforms.disease) {
              order.subforms.disease.policy_type = order.types_gm[0];
            } else {
              order.subforms = {
                auto: {
                  selectedCar: {},
                }, //template.formulario.automoviles
                life: {
                  beneficiariesList: [{ person: 1 }],
                  aseguradosList: [],
                }, //template.formulario.vida
                disease: {
                  relationshipList: [],
                }, //template.formulario.accidentes
                damage: {
                  coinsurance: "",
                  insured_item: "",
                  item_address: "",
                  item_details: "",
                }, //template.formulario.danios
              };
              order.subforms.disease.policy_type = order.types_gm[0];
            }
          }
        } else if (order.form.subramo.subramo_code == 7) {
          if (order.types_incendio.length == 1) {
            order.subforms.damage.policy_type = order.types_incendio[0];
          }
        } else if (order.form.subramo.subramo_code == 6) {
          if (order.types_myt.length == 1) {
            order.subforms.damage.policy_type = order.types_myt[0];
          }
        } else if (order.form.subramo.subramo_code == 8) {
          if (order.types_ayc.length == 1) {
            order.subforms.damage.policy_type = order.types_ayc[0];
          }
        } else if (order.form.subramo.subramo_code === 1) {
          if (order.types_credito.length == 1) {
            order.subforms.damage.policy_type = order.types_credito[0];
          }
        } else if (order.form.subramo.subramo_code == 10) {
          if (order.types_credito.length == 1) {
            order.subforms.damage.policy_type = order.types_credito[0];
          }
        } else if (order.form.subramo.subramo_code == 11) {
          if (order.types_vivienda.length == 1) {
            order.subforms.damage.policy_type = order.types_vivienda[0];
          }
        } else if (order.form.subramo.subramo_code == 13) {
          if (order.types_diversos.length == 1) {
            order.subforms.damage.policy_type = order.types_diversos[0];
          }
        } else if (order.form.subramo.subramo_code == 12) {
          if (order.types_garantia.length == 1) {
            order.subforms.damage.policy_type = order.types_garantia[0];
          }
        } else if (order.form.subramo.subramo_code == 5) {
          if (order.types_rc.length == 1) {
            order.subforms.damage.policy_type = order.types_rc[0];
          }
        } else if (order.form.subramo.subramo_code == 14) {
          if (order.types_tyorc.length == 1) {
            order.subforms.damage.policy_type = order.types_tyorc[0];
          }
        } else if (order.form.subramo.subramo_code == 31) {
          if (order.types_lf.length == 1) {
            order.subforms.damage.policy_type = order.types_lf[0];
          }
        } else if (order.form.subramo.subramo_code == 9) {
          if (order.types.length == 1) {
            order.subforms.auto.policy_type = order.types[0];
          }
        }
        get_claves();
      }

      // order.form.paquete = '';
      // $scope.dataToSave.paquete = null;
      if ($localStorage) {
      }
      try {
        $scope.cargandoPaquetes = true;
        $http
          .post(url.IP + "paquetes-data-by-subramo/", {
            ramo: order.form.ramo.id,
            subramo: order.form.subramo.id,
            provider: order.form.aseguradora.id,
          })
          .then(
            function success(response) {
              $scope.cargandoPaquetes = false;
              order.defaults.packages = [];
              if (response.data.length) {
                order.defaults.packages = response.data;
                if (
                  order.defaults.packages &&
                  order.defaults.packages.length > 0
                ) {
                  // Usage example
                  if (
                    order.form.paquete ||
                    ($scope.read_pdf &&
                      $scope.read_pdf.data &&
                      $scope.read_pdf.data.cobertura)
                  ) {
                    var result = $scope.getMostSimilarPackage(
                      $scope.read_pdf.data.cobertura.toLowerCase(),
                      order.defaults.packages
                    );
                    if (result) {
                      order.form.paquete = result;
                    }
                    if (
                      !order.form.paquete ||
                      Object.keys(order.form.paquete).length === 0
                    ) {
                      order.form.paquete = order.defaults.packages[0];
                    }
                    $scope.changePackage(order.form.paquete);
                  }
                }
                if ($localStorage) {
                }
              }
            },
            function error(e) {
              $scope.cargandoPaquetes = false;
              console.log("Error - paquetes-data-by-subramo", e);
              order.defaults.packages = [];
            }
          )
          .catch(function (error) {
            $scope.cargandoPaquetes = false;
            console.log("Error - paquetes-data-by-subramo - catch", error);
            order.defaults.packages = [];
          });

        // Asigna la forma
        order.show.showForms = true;
        order.defaults.formInfo = {
          code: order.form.subramo.subramo_code,
          name: order.form.subramo.subramo_name,
        };

        order.defaults.comisiones = [];

        if (order.form.clave) {
          if (order.form.clave.clave_comision.length) {
            order.form.clave.clave_comision.forEach(function (item) {
              if (order.form.subramo.subramo_name == item.subramo) {
                order.defaults.comisiones.push(item);
              }
            });

            order.form.comisiones = order.defaults.comisiones;

            // if(order.defaults.comisiones){
            //   if(!order.defaults.comisiones.length) {
            //      SweetAlert.swal({
            //         title: 'Error',
            //         text: "Debe tener al menos una comisión capturada para la clave seleccionada",
            //         type: "error",
            //         showCancelButton: false,
            //         confirmButtonColor: "#DD6B55",
            //         confirmButtonText: "Aceptar",
            //         closeOnConfirm: true
            //     }, function(isConfirm) {
            //         if (isConfirm) {

            //         }
            //     });
            //   }
            // }

            if (order.defaults.comisiones.length == 1) {
              order.form.comision = order.defaults.comisiones[0];
              $scope.selectComision(order.form.comision);
            }
          } else {
            // SweetAlert.swal({
            //         title: 'Error',
            //         text: "Debe tener al menos una comisión capturada para la clave seleccionada",
            //         type: "error",
            //         showCancelButton: false,
            //         confirmButtonColor: "#DD6B55",
            //         confirmButtonText: "Aceptar",
            //         closeOnConfirm: true
            //     }, function(isConfirm) {
            //         if (isConfirm) {
            //         }
            //     });
          }
        }
        if (
          order.form.subramo.subramo_name == "Vida" ||
          order.form.subramo.subramo_name == "Funerarios"
        ) {
          if (
            order &&
            order.subforms &&
            order.subforms.life &&
            order.subforms.life.aseguradosList &&
            order.subforms.life.aseguradosList.length == 0
          ) {
            order.options.life.asegurados.add();
          }

          if (order.form.subramo.subramo_name == "Funerarios") {
            order.subforms.life.beneficiariesList.splice(0, 1);
          }
        }
      } catch (err) {}
    };

    // get Package more similar
    function similarity(a, b) {
      var aWords = a.toLowerCase().split(" ");
      var bWords = b.toLowerCase().split(" ");
      var score = 0;
      angular.forEach(aWords, function (word) {
        if (bWords.indexOf(word) !== -1) {
          score++;
        }
      });
      return score;
    }
    // Find best matching package name
    $scope.getMostSimilarPackage = function (target, packages) {
      var bestMatch = null;
      var highestScore = 0;
      if ($scope.paqueteOriginal && packages) {
        angular.forEach(packages, function (pkg) {
          var score = similarity($scope.paqueteOriginal, pkg.package_name);
          if (score > highestScore) {
            highestScore = score;
            bestMatch = pkg;
            return bestMatch;
          }
        });
      }
      return bestMatch;
    };
    $scope.changeProvider = function (sub_ramo, provider) {
      if (!provider) {
        $scope.subramos = [];
        $scope.ramos = [];
        sub_ramo.ramos = $scope.fake_ramos;
        return;
      }
    };

    $scope.changeRamoV = function (sub_ramo) {
      if (!sub_ramo.ramo) {
        $scope.subramos = [];
        sub_ramo.sub_ramos = [];
        return;
      }
    };

    $scope.changePackage = function (param) {
      $scope.yaseestableciopaquete = false;
      if (order.form.identifier) {
        order.form.identifier = order.form.identifier;
      } else if (param) {
        order.form.identifier = param.package_name;
      } else {
        order.form.identifier = order.form.identifier;
      }
      if ($scope.orgName == "gpi") {
        order.form.identifier = "GENERAL";
      }
      order.defaults.coverages = [];
      if (param) {
        order.form.paquete = param;
      }
      if (order.form.paquete) {
        $scope.newCoverPack = true;
        $scope.dataToSave.paquete = order.form.paquete.id;
        order.defaults.coverages = [];
        order.defaults.coverageList = [];
        order.form.paquete.coverage_package.forEach(function (element, index) {
          if (element.default) {
            order.defaults.coverages.push(angular.copy(element));
          } else {
            order.defaults.coverageList.push(angular.copy(element));
          }
        });
        order.coverageInPolicy_policy = order.defaults.coverages;
        order.show.showCoverages = true;

        if ($scope.read_pdf) {
          $scope.paqueteSelected = false;
          $scope.coberturasPackagePdf = [];
          // if($scope.read_pdf.data.cobertura=='' || $scope.read_pdf.data.cobertura==undefined){
          //   $scope.read_pdf.data.cobertura='AMPLIA'
          // }

          if (
            $scope.read_pdf &&
            $scope.read_pdf.data &&
            $scope.read_pdf.data["Primas y coberturas"]
          ) {
            for (i in $scope.read_pdf.data["Primas y coberturas"]) {
              if (
                $scope.read_pdf.data["Primas y coberturas"][i].hasOwnProperty(
                  "Deducible"
                )
              ) {
                if (
                  $scope.read_pdf.data["Primas y coberturas"][i]["Deducible"] ==
                  "nan"
                ) {
                  $scope.read_pdf.data["Primas y coberturas"][i]["Deducible"] =
                    "0";
                }
                if (
                  $scope.read_pdf.data["Primas y coberturas"][i][
                    "Suma asegurada"
                  ] == "nan"
                ) {
                  $scope.read_pdf.data["Primas y coberturas"][i][
                    "Suma asegurada"
                  ] = "0";
                }
                var it = {};
                it["coverage_name"] = i;
                it["url"] =
                  slug(i) +
                  "-" +
                  (order.form.paquete.id || "pkg") +
                  "-" +
                  ($scope.coberturasPackagePdf.length + 1);
                it["package"] = order.form.paquete.id;
                it["deductibleInPolicy"] = {
                  value:
                    $scope.read_pdf.data["Primas y coberturas"][i]["Deducible"],
                };
                it["deductible_coverage"] = [{ deductible: 0 }];
                it["deductible_coverage"][0]["deductible"] =
                  $scope.read_pdf.data["Primas y coberturas"][i]["Deducible"];
                it["sumInPolicy"] = {
                  value:
                    $scope.read_pdf.data["Primas y coberturas"][i][
                      "Suma asegurada"
                    ],
                };
                it["sums_coverage"] = [{ sum_insured: 0 }];
                it["sums_coverage"][0]["sum_insured"] =
                  $scope.read_pdf.data["Primas y coberturas"][i][
                    "Suma asegurada"
                  ];
                if (
                  $scope.read_pdf.data["Primas y coberturas"][i]["Coaseguro"]
                ) {
                  it["coinsuranceInPolicy"] = {
                    value:
                      $scope.read_pdf.data["Primas y coberturas"][i][
                        "Coaseguro"
                      ],
                  };
                }
                if ($scope.read_pdf.data["Primas y coberturas"][i]["Tope"]) {
                  it["topeCoinsuranceInPolicy"] = {
                    value:
                      $scope.read_pdf.data["Primas y coberturas"][i]["Tope"],
                  };
                }
                $scope.coberturasPackagePdf.push(it);
                order.defaults.coverages = $scope.coberturasPackagePdf;
                $localStorage["defaults"] = order.defaults;
                order.form.paquete = order.form.paquete;
              }
            }
            order.coverageInPolicy_policy = order.defaults.coverages;
          }
          // if($scope.read_pdf.data['Primas y coberturas']){
          //     $scope.paqueteSelected = true;
          //     $scope.dataToSave.paquete = order.form.paquete.id;
          //     for (i in $scope.read_pdf.data['Primas y coberturas']) {

          //         if ($scope.read_pdf.data['Primas y coberturas'][i].hasOwnProperty('Deducible')) {
          //           if($scope.read_pdf.data['Primas y coberturas'][i]['Deducible'] =='nan'){
          //             $scope.read_pdf.data['Primas y coberturas'][i]['Deducible']='0'
          //           }
          //           if($scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada'] =='nan'){
          //             $scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']='0'
          //           }
          //           var it ={}
          //           it['coverage_name'] = i
          //           it['url'] = i
          //           it['package'] = order.form.paquete.id
          //           it['deductibleInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Deducible']}
          //           it['deductible_coverage']=[{'deductible':0}]
          //           it['deductible_coverage'][0]['deductible'] =$scope.read_pdf.data['Primas y coberturas'][i]['Deducible']
          //           it['sumInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']}
          //           it['sums_coverage']=[{'sum_insured':0}]
          //           it['sums_coverage'][0]['sum_insured'] =$scope.read_pdf.data['Primas y coberturas'][i]['Suma asegurada']
          //           if($scope.read_pdf.data['Primas y coberturas'][i]['Coaseguro']){
          //             it['coinsuranceInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Coaseguro']}
          //           }
          //           if($scope.read_pdf.data['Primas y coberturas'][i]['Tope']){
          //             it['topeCoinsuranceInPolicy']={'value':$scope.read_pdf.data['Primas y coberturas'][i]['Tope']}
          //           }
          //           $scope.coberturasPackagePdf.push(it)
          //           order.defaults.coverages=$scope.coberturasPackagePdf
          //           $localStorage['defaults'] = order.defaults
          //           order.form.paquete = order.form.paquete;

          //       }
          //     }
          //     order.coverageInPolicy_policy = order.defaults.coverages;
          //     $scope.saveLocalstorange()
          //   }
        }
      }
      $scope.saveLocalstorange();
    };

    $scope.contractorSelection = function (parValue) {
      if (order.form.contratante.address_contractor) {
        order.defaults.address = order.form.contratante.address_contractor;
        $scope.dataToSave.contractor = order.form.contratante.id;
        $scope.dataToSave.address =
          order.form.contratante.address_contractor[0].id;
      }
      if (order.form.contratante.id) {
        $scope.phoneStatus = true;
        $scope.emailStatus = true;
        $(".phonenumber").prop("disabled", true);
      } else {
        $(".phonenumber").removeAttr("disabled");
        $scope.phoneStatus = false;
        $scope.emailStatus = false;
      }

      try {
        if (order.defaults.address.length == 1) {
          order.form.address = order.defaults.address[0];
        }
      } catch (exception) {}
    };

    $scope.isReceiptAvailable = function (payment) {
      order.receipts = [];
      $scope.dataToSave.forma_de_pago = payment.value;
    };

    $scope.changeCurrency = function () {
      // $scope.dataToSave.f_currency ? order.f_currency.f_currency_selected : 1;
      $scope.dataToSave.f_currency = order.f_currency.f_currency_selected;
      $scope.saveLocalstorange();
    };

    $scope.changeConducto = function () {
      // $scope.dataToSave.f_currency ? order.f_currency.f_currency_selected : 1;
      $scope.dataToSave.conducto_de_pago =
        order.conducto_de_pago.conducto_de_pago_selected;
      $scope.saveLocalstorange();
    };

    order.defaults = {
      sex: angular.copy(sex),
      years: [],
      policyUrl: {},
      contractors: [],
      providers: [],
      ramos: [],
      subramos: [],
      packages: [],
      coverages: [],
      formInfo: {},
      coverageInPackage: {},
      payform: angular.copy(payform),
    };

    // console.log('ordenes.controller');
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 1; i >= oldYear; i--) {
      order.defaults.years.push(i);
    }

    $scope.percentageRange = function (input, index) {
      if (input < 0) {
        order.defaults.coverages[index].coinsuranceInPolicy.value = 0;
      }
      if (input > 100) {
        order.defaults.coverages[index].coinsuranceInPolicy.value = 100;
      }
    };
    function normalizeDate(date) {
      var d = new Date(date);
      d.setHours(0, 0, 0, 0); // Elimina hora, minutos, segundos, ms
      return d;
    }
    $scope.percentageRange1 = function (input, index) {
      if (input < 0) {
        order.defaults.coverages[index].topeCoinsuranceInPolicy.value = 0;
      }
      if (input > 100) {
        order.defaults.coverages[index].topeCoinsuranceInPolicy.value = 100;
      }
    };

    order.save = {
      createOTAndPreparePolicy: function () {
        if (!validate()) {
          return;
        }
        if (
          order.subforms.life.aseguradosList.length == 0 &&
          order.defaults.formInfo.code == 1
        ) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ONEASEGURADOLIFE, "error");
          return;
        }
        // if (order.subforms.life.beneficiariesList.length === 0 && order.defaults.formInfo.code === 1) {
        //   $scope.enproceso=false;
        //   l.stop();
        //   SweetAlert.swal("Error", MESSAGES.ERROR.ONEBENEFICIARY, "error")
        //   return;
        // }
        if (!order.form.payment || order.form.payment == "") {
          SweetAlert.swal("Error", MESSAGES.ERROR.SELPAY, "error");
          // toaster.warning('Debe seleccionar forma de pago.')
        } else {
          if (
            helpers.beneficiariesPercentageGreaterThanZero(
              order.subforms.life.beneficiariesList
            )
          ) {
            SweetAlert.swal("Error", MESSAGES.ERROR.GREATERTHAN100, "info");
            // toaster.warning('No puede tener un porcentaje mayor a 100%.');
            // return
          } else {
            var form = angular.copy(order.form);
            form = getFormData(form);
            form.forma_de_pago = form.forma_de_pago.value;
            if (order.form.contratante.address_contractor) {
              order.defaults.address =
                order.form.contratante.address_contractor;
              form.contractor = order.form.contratante.id;
              form.address = order.form.contratante.address_contractor[0].id;
            }
            insuranceService.createInsurance(form).then(function (res) {
              uploadFiles(res.id);
              order.defaults.policyUrl = res.url;

              order.show.ot = false;
              SweetAlert.swal("Error", MESSAGES.OK.NEWOT, "error");
              // toaster.success(MESSAGES.OK.NEWOT);
              setTimeout(function () {
                $state.go("polizas.info", { polizaId: res.id });
              }, 1000);
              var code = order.defaults.formInfo.code;
              if (code === 9) {
                if (!order.subforms.auto)
                  order.subforms.auto = {
                    brand: "",
                  };
                var auto = angular.copy(order.subforms.auto);
                auto.sub_branch = res.subramo ? res.subramo : null;
                auto.policy = res.url;

                var submitObject = {
                  code: code,
                  insurance: res,
                  form: auto,
                };
                formService.createForm(submitObject);
              } else if (code === 1 || code == 30) {
                // Personal information
                // var life = order.subforms.life;
                var beneficiaries = order.subforms.life.beneficiariesList;
                var asegurados_life = order.subforms.life.aseguradosList;
                // var personal = {
                //     first_name: life.first_name ? life.first_name : '',
                //     last_name: life.last_name ? life.last_name : '',
                //     second_last_name: life.second_last_name ? life.second_last_name : '',
                //     birthdate: life.birthdate,
                //     sex: life.sex ? life.sex : '',
                //     full_name: life.first_name + ' ' + life.last_name + ' ' + life.second_last_name
                // };
                var personal = {
                  first_name: asegurados_life[0].first_name
                    ? asegurados_life[0].first_name
                    : "",
                  last_name: asegurados_life[0].last_name
                    ? asegurados_life[0].last_name
                    : "",
                  second_last_name: asegurados_life[0].second_last_name
                    ? asegurados_life[0].second_last_name
                    : "",
                  birthdate: asegurados_life[0].birthdate,
                  antiguedad: asegurados_life[0].antiguedad
                    ? asegurados_life[0].antiguedad
                    : null,
                  sex: asegurados_life[0].sex ? asegurados_life[0].sex : "",
                  full_name:
                    asegurados_life[0].first_name +
                    " " +
                    asegurados_life[0].last_name +
                    " " +
                    asegurados_life[0].second_last_name,
                };

                var submitObject = {
                  code: code,
                  personal: personal,
                  relationships: beneficiaries,
                  insurance: res,
                  smoker: order.subforms.asegurados_life[0].smoker,
                  asegurados_life: asegurados_life,
                  // smoker: order.subforms.life.smoker
                };

                formService.createForm(submitObject).then(function (creat) {
                  $scope.personal_1 = creat.data;
                });
                asegurados_life.forEach(function (element, index) {
                  var fn =
                    elemet.first_name +
                    " " +
                    elemet.last_name +
                    " " +
                    elemet.second_last_name;
                  if (
                    personal.first_name != element.first_name &&
                    personal.last_name != element.last_name &&
                    personal.full_name != fn
                  ) {
                    (element.first_name = elemet.first_name
                      ? elemet.first_name
                      : ""),
                      (element.last_name = elemet.last_name
                        ? elemet.last_name
                        : ""),
                      (element.second_last_name = elemet.second_last_name
                        ? elemet.second_last_name
                        : ""),
                      (element.birthdate = element.birthdate
                        ? new Date(element.birthdate)
                        : null);
                    element.antiguedad = element.antiguedad
                      ? new Date(element.antiguedad)
                      : null;
                    (element.sex = elemet.sex ? elemet.sex : ""),
                      (element.full_name =
                        elemet.first_name +
                        " " +
                        elemet.last_name +
                        " " +
                        elemet.second_last_name);
                    element.smoker = element.smoker ? true : false;
                    element.full_name =
                      element.first_name +
                      " " +
                      element.last_name +
                      " " +
                      element.second_last_name;
                    generalService
                      .createPersonalInformation(element)
                      .then(function (response) {
                        var lifeModel = {
                          sub_branch: res.subramo,
                          policy: res.url,
                          personal: response.data.url,
                          smoker: element.smoker ? element.smoker : false,
                        };
                      });
                  }
                });
                // generalService.createPersonalInformation(personal)
                //     .then(function(response) {
                //       console.log('fffffff',response)
                //         var lifeModel = {
                //             sub_branch: res.subramo,
                //             policy: res.url,
                //             personal: response.data.url,
                //             smoker: order.subforms.life.smoker ? order.subforms.life.smoker : false
                //         };
                //     });
              } else if (code === 2 || code === 3 || code === 4) {
                var disease = order.subforms.disease;
                var relationships = order.subforms.disease.relationshipList;

                var type = helpers.diseaseType(order.defaults.formInfo.code);

                var personal = {
                  first_name: disease.first_name ? disease.first_name : "",
                  last_name: disease.last_name ? disease.last_name : "",
                  second_last_name: disease.second_last_name
                    ? disease.second_last_name
                    : "",
                  birthdate: disease.birthdate,
                  antiguedad: disease.antiguedad ? disease.antiguedad : null,
                  sex: disease.sex ? disease.sex : "",
                  full_name:
                    disease.first_name +
                    " " +
                    disease.last_name +
                    " " +
                    disease.second_last_name,
                };
                var submitObject = {
                  code: code,
                  personal: personal,
                  relationships: relationships,
                  coinsurance: disease.coinsurance,
                  insurance: res,
                };

                formService.createForm(submitObject);
              } else if (
                code === 5 ||
                code === 6 ||
                code === 7 ||
                code === 8 ||
                code === 10 ||
                code === 11 ||
                code === 12 ||
                code === 13 ||
                code === 14
              ) {
                var damage = order.subforms.damage;
                var type = helpers.damageType(parseInt(code));

                damage.sub_branch = res.subramo;
                damage.damage_type = type;
                damage.policy = res.url;

                var submitObject = {
                  insurance: res,
                  code: code,
                  form: damage,
                };

                formService.createForm(submitObject);
              }

              if (order.defaults.coverages.length > 0) {
                helpers.createCoverages(order.defaults.coverages, res);
              }
              if ($uibModalInstance) {
                $uibModalInstance.close(200);
              }
              setTimeout(function () {
                SweetAlert.swal("Error", MESSAGES.OK.NEWOT, "error");
                // toaster.success(MESSAGES.OK.NEWOT);
                $state.go("polizas.info", { polizaId: res.id });
              }, 1000);
            });
          }
        }
      },
      closeModal: function () {
        $localStorage["datos_pdf"] = {};
        // $localStorage.removeItem('datos_pdf');
        $localStorage.dataFile = {};
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        } else {
          $state.go("polizas.table");
        }
      },
      closeAndReturn: function () {
        setTimeout(function () {
          SweetAlert.swal("Error", MESSAGES.OK.NEWOT, "error");
          // toaster.success(MESSAGES.OK.NEWOT);
          // $state.go('polizas.table');
        }, 1000);
      },
      saveInsurance: function (param, folio) {
        $scope.enproceso = true;
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.receitps_backup = angular.copy($scope.dataToSave.recibos_poliza);
        $scope.return = false;
        $scope.param = param;
        $scope.contractorToSave = {};
        $scope.dataToSave.vendor = order.form.vendor;
        var promises_array = [];
        $scope.dataToSave.parent = null;
        $scope.arrayCoverage = order.coverageInPolicy_policy;
        order.coverageInPolicy_policy = [];
        if (order.form.from_pdf) {
          $scope.dataToSave.from_pdf = order.form.from_pdf;
        } else {
          $scope.dataToSave.from_pdf = false;
        }

        if (order.form.hospital_level) {
          $scope.dataToSave.hospital_level = order.form.hospital_level;
        }
        if (order.form.tabulator) {
          $scope.dataToSave.tabulator = order.form.tabulator;
        }
        if (order.form.aseguradora) {
          $scope.dataToSave.aseguradora = order.form.aseguradora.id
            ? order.form.aseguradora.id
            : order.form.aseguradora
            ? order.form.aseguradora
            : order.form.aseguradora;
        }
        if (!(order.form && order.form.ramo)) {
          $scope.enproceso = false;
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
          return;
        }
        if (!(order.form && order.form.subramo)) {
          $scope.enproceso = false;
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
          return;
        }
        if (!order.form.ramo) {
          $scope.enproceso = false;
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
          return;
        }
        if (!order.form.subramo) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
          return;
        }
        if (!order.form.subramo) {
          if (!order.form.subramo.url) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Oops...", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
            return;
          }
        }
        if (!order.form.clave) {
          SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
          return;
        } else {
          $scope.clavenoexistente = false;
          if (order.defaults.claves) {
            order.defaults.claves.forEach(function (item) {
              if (order.form.clave.id == item.id) {
                $scope.clavenoexistente = true;
                $scope.dataToSave.clave = order.form.clave.id
                  ? order.form.clave.id
                  : order.form.clave
                  ? order.form.clave
                  : order.form.clave;
              }
            });
          } else {
            console.log("---sin claves--*");
            $scope.return = true;
          }
          if (!$scope.clavenoexistente) {
            $scope.return = true;
            SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
            return;
          }
        }
        var l = Ladda.create(document.querySelector(".ladda-button"));
        order.form.internal_number = $scope.internal_number;
        l.start();
        $scope.enproceso = true;

        if (param == "poliza") {
          if ($scope.dataToSave) {
            $scope.dataToSave.descuento = parseFloat(
              $scope.dataToSave.poliza.descuento
            ).toFixed(2);
            $scope.dataToSave.comision_derecho_percent = parseFloat(
              $scope.dataToSave.poliza.comision_derecho_percent
            ).toFixed(2);
            $scope.dataToSave.comision_rpf_percent = parseFloat(
              $scope.dataToSave.poliza.comision_rpf_percent
            ).toFixed(2);
          }
          $scope.dataToSave.recibos_poliza.forEach(function (item) {
            item.conducto_de_pago = $scope.dataToSave.conducto_de_pago;
            item.iva = item.iva ? parseFloat(item.iva).toFixed(2) : 0;
            item.prima_neta = item.prima_neta
              ? parseFloat(item.prima_neta).toFixed(2)
              : 0;
            item.prima_total = item.prima_total
              ? parseFloat(item.prima_total).toFixed(2)
              : 0;
            item.derecho = item.derecho
              ? parseFloat(item.derecho).toFixed(2)
              : 0;
            item.rpf = item.rpf ? parseFloat(item.rpf).toFixed(2) : 0;
            item.comision = item.comision
              ? parseFloat(item.comision).toFixed(2)
              : 0;
            item.descuento = item.descuento
              ? parseFloat(item.descuento).toFixed(2)
              : 0;
          });
        }
        if (folio) {
          $scope.num_folio = folio;
          $scope.dataToSave.folio = folio;
        } else {
        }

        if (
          order.form.contratante.email ||
          order.form.contratante.phone_number
        ) {
          if (order.form.contratante.phone_number) {
            $scope.contractorToSave.phone_number =
              order.form.contratante.phone_number;
          }
          if (order.form.contratante.email) {
            $scope.contractorToSave.email = order.form.contratante.email;
          }
        }

        if (
          $scope.contractorToSave.email ||
          $scope.contractorToSave.phone_number
        ) {
          $http
            .patch(order.form.contratante.value.url, $scope.contractorToSave)
            .then(function (data) {});
        }
        order.form.comision_percent = $scope.dataToSave.comision_percent;
        if (order.form.ceder_comision) {
          $scope.dataToSave.comision_percent = order.form.comision_percent;
          $scope.dataToSave.udi = String(
            parseFloat(order.form.comision_percent)
          );

          if (!$scope.dataToSave.comision_currency) {
            var comision_ =
              parseFloat(angular.copy(order.form.comision_percent)) / 100;
            if ($scope.dataToSave.p_neta) {
              $scope.dataToSave.comision = parseFloat(
                $scope.dataToSave.comision
              ).toFixed(2);
            } else {
              $scope.dataToSave.comision = 0.0;
            }
          } else {
            // $scope.dataToSave.comision = $scope.dataToSave.comision_currency;
          }
          $scope.dataToSave.comision = parseFloat(
            $scope.dataToSave.comision
          ).toFixed(2);

          // calculando de nuevo la comision
        } else {
          if (
            (order.form.comision_percent && $scope.dataToSave.p_neta) ||
            ($scope.dataToSave.comision_percent && $scope.dataToSave.p_neta)
          ) {
            if (!$scope.dataToSave.comision_percent) {
              $scope.dataToSave.comision_percent = order.form.comision_percent;
              $scope.dataToSave.udi = order.form.comision_percent;
              if (order.poliza) {
                $scope.dataToSave.ud;
              }
            }
            var percent_ = parseFloat($scope.dataToSave.comision_percent) / 100;
            $scope.dataToSave.comision = parseFloat($scope.dataToSave.comision);
            $scope.dataToSave.comision = $scope.dataToSave.comision.toFixed(2);
          } else {
            $scope.dataToSave.ceder_comision = 0;
            $scope.dataToSave.comision = 0;
            $scope.dataToSave.udi = 0;
            $scope.dataToSave.comision_percent = $scope.dataToSave
              .comision_percent
              ? $scope.dataToSave.comision_percent
              : 0;
          }
        }

        if (order.form.udi) {
          if (order.form.ceder_comision) {
            $scope.dataToSave.udi = String(
              parseFloat(order.form.comision_percent)
            );
          } else {
            $scope.dataToSave.udi = order.form.udi;
          }
        }

        if (order.form.comision_percent) {
          $scope.dataToSave.comision_percent = order.form.comision_percent;
        } else {
          if (order.form.comision) {
            $scope.dataToSave.comision_percent = order.form.comision.comission;
          } else {
            $scope.dataToSave.comision_percent = $scope.dataToSave
              .comision_percent
              ? $scope.dataToSave.comision_percent
              : 0;
          }
        }
        if (
          $scope.dataToSave &&
          $scope.dataToSave.prima_comision &&
          parseFloat($scope.dataToSave.comision_percent) !=
            parseFloat($scope.dataToSave.prima_comision)
        ) {
          $scope.dataToSave.comision_percent = $scope.dataToSave.prima_comision
            ? $scope.dataToSave.prima_comision
            : $scope.dataToSave.comision_percent
            ? $scope.dataToSave.comision_percent
            : 0;
        }
        if (order.form.contratante.value) {
          if (order.form.contratante.value.address_contractor) {
            $scope.dataToSave.contractor = order.form.contratante.value.id;
            if (!order.form.address) {
              $scope.dataToSave.address =
                order.form.contratante.value.address_contractor[0].id;
            } else {
              $scope.dataToSave.address = order.form.address.id;
            }
          }
        }

        if ($scope.arrayCoverage) {
          if ($scope.arrayCoverage.length > 0) {
            for (var i = 0; i < $scope.arrayCoverage.length; i++) {
              if (
                $scope.arrayCoverage[i].deductibleInPolicy ||
                $scope.arrayCoverage[i].sumInPolicy
              ) {
                try {
                  $scope.arrayCoverage[i]["package"] = order.form.paquete.id;
                } catch (e) {
                  $scope.arrayCoverage[i]["package"] = order.form.paquete.id;
                }
                order.coverageInPolicy_policy.push($scope.arrayCoverage[i]);
              }
              // else{
              //   $scope.flagCoverage = true;
              // }
            }
          }
        }
        // TEL / EMAIL - CONTRATANTE
        if (order.form.contratante) {
          var data = {};

          if (
            order.form.contratante.email &&
            !order.form.contratante.value.email
          ) {
            data.email = order.form.contratante.email;
          }
          if (
            order.form.contratante.phone_number &&
            !order.form.contratante.value.phone_number
          ) {
            data.phone_number = order.form.contratante.phone_number;
          }
        }

        $scope.dataToSave.business_line = order.form.business_line
          ? order.form.business_line.id
          : 0;

        $scope.dataToSave.celula = order.form.celula
          ? order.form.celula.id
          : null;
        $scope.dataToSave.groupinglevel = order.form.subsubgrouping
          ? order.form.subsubgrouping.id
          : order.form.subgrouping
          ? order.form.subgrouping.id
          : order.form.grouping_level
          ? order.form.grouping_level.id
          : null;

        var start_of_validity = new Date(
          $scope.dataToSave.start_of_validity
        ).setHours(12, 0, 0, 0);
        var end_of_validity = new Date(
          $scope.dataToSave.end_of_validity
        ).setHours(11, 59, 59, 0);
        try {
          if ($scope.dataToSave.end_of_validity.toString().length <= 10) {
            $scope.dataToSave.end_of_validity = formatDateToISO(
              order.form.endingDate,
              2
            );
          }
          if ($scope.dataToSave.start_of_validity.toString().length <= 10) {
            $scope.dataToSave.start_of_validity = formatDateToISO(
              order.form.startDate,
              1
            );
          }
        } catch (use_error) {
          console.log("eroror de fechas vigencia", use_error);
        }
        $scope.dataToSave.internal_number = $scope.internal_number;
        $scope.enproceso = true;
        if (param == "poliza") {
          var l = Ladda.create(document.querySelector(".ladda-button"));
          l.start();
          $scope.enproceso = true;
          var today = normalizeDate(new Date());
          var start = normalizeDate($scope.dataToSave.start_of_validity);
          var end = normalizeDate($scope.dataToSave.end_of_validity);
          if (today < start) {
            var status = 10;
          } else if (today > end) {
            var status = 13;

            if (
              $scope.orgName === "ancora" &&
              ($scope.dataToSave.is_renewable == 1 ||
                order.renewal.is_renewable == 1)
            ) {
              $scope.dataToSave.renewed_status = 2;
            }
          } else {
            var status = 14;
          }
        } else if (param == "ot") {
          var status = 1;
          if ($scope.dataToSave.folio) {
            promises_array.push(
              helpers
                .existOT($scope.dataToSave.folio)
                .then(checkPromise)
                .catch(function (error) {
                  // --- Manejo de errores sin romper el flujo ---
                  if (error && error.status === 404) {
                    console.warn(
                      "Folio no encontrado (404):",
                      $scope.dataToSave.folio
                    );
                    // Devolvemos algo válido para continuar
                    return { exists: false, folio: $scope.dataToSave.folio };
                  } else {
                    console.error("Error en existOT:", error);
                    // Devuelve algo neutro para que Promise.all no se rompa
                    return {
                      error: true,
                      message: "Error validando folio",
                      detail: error,
                    };
                  }
                })
            );
          }
        }
        if (param == "ot") {
          $scope.dataToSave.recibos_poliza = [];
          $scope.dataToSave.p_total = 0;
        }

        structure(status);

        $scope.dataToSave.identifier = order.form.identifier
          ? order.form.identifier
          : "";
        if (!$scope.dataToSave.identifier) {
          if (order.form.identifier.length == 0 || !order.form.identifier) {
            $scope.identifier();
          }
          $scope.dataToSave.identifier = order.form.identifier;
          $scope.dataToSave.internal_number = $scope.internal_number;
        }
        function checkPromise(obj) {
          return obj;
        }
        $q.all(promises_array)
          .then(
            function (val) {
              if ($scope.dataToSave.forma_de_pago) {
                $scope.dataToSave.p_total = parseFloat(
                  $scope.dataToSave.p_total
                ).toFixed(2);
                if ($scope.dataToSave.recibos_poliza) {
                  var primas_suma = 0.0;

                  $scope.dataToSave.recibos_poliza.forEach(function (receipt) {
                    receipt.iva = receipt.iva
                      ? parseFloat(receipt.iva).toFixed(2)
                      : 0;
                    receipt.prima_neta = receipt.prima_neta
                      ? parseFloat(receipt.prima_neta).toFixed(2)
                      : 0;
                    receipt.prima_total = receipt.prima_total
                      ? parseFloat(receipt.prima_total).toFixed(2)
                      : 0;
                    receipt.derecho = receipt.derecho
                      ? parseFloat(receipt.derecho).toFixed(2)
                      : 0;
                    receipt.rpf = receipt.rpf
                      ? parseFloat(receipt.rpf).toFixed(2)
                      : 0;
                    receipt.comision = receipt.comision
                      ? parseFloat(receipt.comision).toFixed(2)
                      : 0;
                    receipt.descuento = receipt.descuento
                      ? parseFloat(receipt.descuento).toFixed(2)
                      : 0;
                    primas_suma = primas_suma + receipt.prima_total;
                    var start_date = new Date(
                      toDate(receipt.fecha_inicio)
                    ).setHours(12, 0, 0, 0);
                    var end_date = new Date(toDate(receipt.fecha_fin)).setHours(
                      11,
                      59,
                      59,
                      0
                    );

                    // receipt.endingDate = new Date(end_date);
                    receipt.fecha_fin = new Date(end_date);
                    // receipt.startDate = new Date(start_date);
                    receipt.fecha_inicio = new Date(start_date);

                    if (receipt.vencimiento) {
                      var vencimiento = new Date(
                        toDate(receipt.vencimiento)
                      ).setHours(11.59, 59, 0);
                      receipt.vencimiento = new Date(vencimiento);
                    } else {
                      receipt.vencimiento = null;
                    }
                  });
                }

                if (order.coverageInPolicy_policy.length == 0) {
                  $scope.dataToSave.coverageInPolicy_policy = [
                    {
                      coverage_name: "",
                      priority: 0,
                      deductible: "",
                      package: order.form.paquete.id,
                      prima: "",
                      sum_insured: "",
                    },
                  ];
                }

                if (!$scope.dataToSave.vendor) {
                  $scope.dataToSave.vendor = "";
                }

                if (order.form.responsable) {
                  $scope.dataToSave.responsable = order.form.responsable;
                }
                if (order.form.ejecutivo_cobranza) {
                  $scope.dataToSave.collection_executive =
                    order.form.ejecutivo_cobranza;
                }
                if (order.form.sucursal) {
                  $scope.dataToSave.sucursal = order.form.sucursal;
                } else {
                  $scope.dataToSave.sucursal = "";
                }
                if ($scope.referenciadores.length > 0) {
                  if ($scope.referenciadores[0].referenciador) {
                    $scope.dataToSave.vendor = "";
                    if ($scope.referenciadores.length == 1) {
                      if ($scope.referenciadores[0].referenciador) {
                        $scope.referenciador.forEach(function (i) {
                          if (
                            i.url == $scope.referenciadores[0].referenciador
                          ) {
                            i.user_info.info_vendedor.forEach(function (o) {
                              o.vendedor_subramos.forEach(function (u) {
                                if (u.subramo == $scope.dataToSave.subramo) {
                                  $scope.referenciadores[0].comision_vendedor =
                                    parseFloat(u.comision).toFixed(2);
                                }
                              });
                            });
                          }
                        });
                      }
                    }
                  }
                }
                $scope.dataToSave.ramo = order.form.ramo.id;
                // $scope.dataToSave.state_circulation = order.form.state_circulation ? order.form.state_circulation.state : '';
                $scope.dataToSave.state_circulation = order.form
                  .state_circulation
                  ? order.form.state_circulation.state
                  : "";
                if (order.subforms) {
                  if (order.subforms.auto) {
                    if (order.subforms.auto.state_circulation) {
                      $scope.dataToSave.state_circulation = order.subforms.auto
                        .state_circulation
                        ? order.subforms.auto.state_circulation.state
                        : "";
                    }
                  }
                }
                if (
                  $rootScope.from_task &&
                  $rootScope.task_associated &&
                  $rootScope.task_associated.url
                ) {
                  $scope.dataToSave.from_task = $rootScope.from_task;
                  $scope.dataToSave.task_associated =
                    $rootScope.task_associated.id;
                }
                try {
                  if ($localStorage && $localStorage.orderFormCotizacion) {
                    var cotizacion = $localStorage.orderFormCotizacion;
                    $scope.dataToSave.cotizacion_asociada = cotizacion.id;
                  }
                } catch (y) {}
                // polizas/evaluar-vigencia-json/
                $http
                  .post(
                    url.IP + "validaciones/evaluar-vigencia-json/",
                    angular.copy($scope.dataToSave)
                  )
                  .then(function (resp) {
                    if (resp.data && resp.data.warning) {
                      try {
                        var l = Ladda.create(
                          document.querySelector(".ladda-button")
                        );
                        l.start();
                        l.stop();
                      } catch (u) {}
                      $scope.enproceso = false;
                      swal({
                        title: "⚠️ Inconsistencia en fechas de vigencia",
                        text:
                          "Atención\n\n" +
                          "El inicio de vigencia de la póliza no coincide con el inicio de vigencia del recibo 1.\n\n" +
                          "Favor de revisar y corregir las fechas antes de continuar.",
                        icon: "warning",
                        button: "Entendido",
                      });
                      return;
                    }
                    // guardar normal...
                    try {
                      var l = Ladda.create(
                        document.querySelector(".ladda-button")
                      );
                      l.start();
                    } catch (u) {}
                    $http
                      .post(
                        url.IP + "certificados/",
                        angular.copy($scope.dataToSave)
                      )
                      .then(
                        function success(data) {
                          $scope.idPolicy = data.data.id;
                          $scope.poliza_creada = data.data;
                          $localStorage.orderFormCotizacion = {};
                          if (
                            $rootScope.from_task &&
                            $rootScope.task_associated &&
                            $rootScope.task_associated.url
                          ) {
                            $http.patch($rootScope.task_associated.url, {
                              ot_model: 1,
                              ot_id_reference: $scope.idPolicy,
                            });
                          }
                          if (window.Pace) {
                            Pace.stop();
                            Pace.bar.finish();
                          }
                          try {
                            var serial =
                              order &&
                              order.subforms &&
                              order.subforms.auto &&
                              order.subforms.auto.serial
                                ? normalizeVIN(order.subforms.auto.serial)
                                : null;
                            var st = order._vinWarningState || {};
                            var finalHasInvalid = !!(
                              serial && hasInvalidVinLetters(serial)
                            );

                            // Aquí va tu llamada real al backend para guardar la póliza:
                            order._saving = true;
                            var shouldLog =
                              hasInvalidVinLetters(serial) &&
                              st.warned === true &&
                              st.userAcknowledged === true &&
                              st.warnedVinValue === serial; // opcional pero recomendado
                            if (serial || shouldLog) {
                              var serial = normalizeVIN(
                                order.subforms.auto.serial
                              );
                              var st = order._vinWarningState || {};
                              if (
                                hasInvalidVinLetters(serial) &&
                                st.userAcknowledged &&
                                st.warnedVinValue === serial
                              ) {
                                // aquí haces tu log
                                var logInvalidSerial = {
                                  model: 1,
                                  event: "POST",
                                  associated_id: $scope.idPolicy,
                                  identifier:
                                    "creó la póliza con una serie inválida. La serie contiene los caracteres ‘I’, ‘O’ u ‘Q’, los cuales no son válidos.(" +
                                    serial +
                                    ")",
                                };
                                dataFactory
                                  .post("send-log/", logInvalidSerial)
                                  .then(function success(response_x) {
                                    console.log(
                                      "-------2-VIN_INVALID_OIQ_SAVED-----",
                                      response_x
                                    );
                                  });
                              }
                            }
                          } catch (u) {}
                          $localStorage["datos_pdf"] = {};
                          // $localStorage.removeItem('datos_pdf');
                          $localStorage["primas"] = {};
                          $localStorage["defaults"] = {};
                          if ($scope.dataToSave.delete_receitps) {
                            if ($scope.dataToSave.delete_receitps.length > 0) {
                              var params_del_rec = {
                                model: 1,
                                event: "DELETE",
                                associated_id: data.data.id,
                                identifier:
                                  "elimino recibos al crear la póliza (vigencia menor de un año)",
                              };
                              dataFactory
                                .post("send-log/", params_del_rec)
                                .then(function success(response_x) {
                                  console.log(
                                    "-------2-recs_del-----",
                                    response_x
                                  );
                                });
                            }
                          }
                          // varios referenciadores
                          for (
                            var i = 0;
                            i < $scope.referenciadores.length;
                            i++
                          ) {
                            $scope.referenciadores[i].policy = data.data.url;
                          }
                          $scope.ref_policy = $scope.referenciadores;
                          $scope.ref_policy.forEach(function (rfpol) {
                            if (rfpol.referenciador) {
                              var ref2 = {};
                              ref2.referenciador = rfpol.referenciador;
                              ref2.comision_vendedor = rfpol.comision_vendedor
                                ? parseFloat(rfpol.comision_vendedor).toFixed(2)
                                : 0;
                              ref2.policy = data.data.url;
                              dataFactory
                                .post("referenciadores-policy/", ref2)
                                .then(
                                  function success(request) {},
                                  function error(error) {
                                    l.stop();
                                    return;
                                    console.log(error);
                                  }
                                )
                                .catch(function (e) {
                                  console.log(e);
                                });
                            }
                          });

                          // varios referenciadores
                          if (data.status == 201) {
                            $scope.flagCoverage = false;
                            order.form.from_pdf = false;
                            if ($localStorage.dataFile && $scope.read_pdf) {
                              try {
                                $localStorage.dataFile.append(
                                  "owner",
                                  data.data.id
                                );
                                try {
                                  $http.patch(data.data.url, {
                                    from_pdf: true,
                                  });
                                } catch (u) {}
                                var xhr_file = new XMLHttpRequest();
                                // xhr_file.open("POST", url.SERVICE_PDF);
                                xhr_file.open(
                                  "POST",
                                  url.IP +
                                    "polizas/" +
                                    data.data.id +
                                    "/archivos/?org=" +
                                    $scope.orgName
                                );
                                xhr_file.timeout = 1200000;
                                xhr_file.ontimeout = function (e) {
                                  console.log("error file", e);
                                };
                                xhr_file.setRequestHeader(
                                  "Authorization",
                                  "Bearer " + token
                                );
                                xhr_file.send($localStorage.dataFile);
                                xhr_file.onreadystatechange = function () {
                                  if (
                                    this.readyState == 4 &&
                                    this.status == 200
                                  ) {
                                    $scope.fileUP = JSON.parse(
                                      xhr_file.response
                                    );
                                    $localStorage.dataFile = {};
                                    $localStorage.archivoBase64 = {};
                                    $localStorage.serieDetectada = "";
                                    $scope.serieDetectada = "";
                                    $scope.serieAGuardar = "";
                                  }
                                };
                              } catch (efile) {
                                console.log("nose cargo el pdf leído", efile);
                              }
                            }
                            if ($scope.countFile > 0) {
                              uploadFiles(data.data.id);
                            } else {
                              if (!$scope.flagCoverage) {
                                if (param == "poliza") {
                                  $localStorage.dataFile = {};
                                  //Send Email
                                  var contrac = {};
                                  if (data.data.contractor) {
                                    var contrac = {};
                                    if (
                                      order.form.contratante.type_person == 1
                                    ) {
                                      contrac.type = "fisicas";
                                    } else if (
                                      order.form.contratante.type_person == 2
                                    ) {
                                      contrac.type = "morales";
                                    }
                                    contrac.contratanteId =
                                      data.data.contractor;
                                    // contrac.url = data.data.url
                                  }
                                  SweetAlert.swal(
                                    "¡Listo!",
                                    MESSAGES.OK.NEWPOLICY,
                                    "success"
                                  );
                                  try {
                                    l.stop();
                                  } catch (i) {}
                                  $scope.enproceso = false;
                                }
                                if (param == "ot") {
                                  //Send Email
                                  var contrac = {};
                                  if (data.data.contractor) {
                                    var contrac = {};
                                    if (
                                      order.form.contratante.type_person == 1
                                    ) {
                                      contrac.type = "fisicas";
                                    } else if (
                                      order.form.contratante.type_person == 2
                                    ) {
                                      contrac.type = "morales";
                                    }
                                    contrac.contratanteId =
                                      data.data.contractor;
                                    // contrac.url = data.data.url
                                  }
                                  try {
                                    l.stop();
                                  } catch (i) {}
                                  $scope.enproceso = false;
                                  SweetAlert.swal(
                                    "¡Listo!",
                                    MESSAGES.OK.NEWOT,
                                    "success"
                                  );
                                }
                                // $scope.sendEmail_Emision();
                                $state.go("polizas.info", {
                                  polizaId: $scope.idPolicy,
                                });
                              } else {
                                try {
                                  l.stop();
                                } catch (i) {}
                                $scope.enproceso = false;
                                if (param == "poliza") {
                                  // $scope.sendEmail_Emision();
                                  SweetAlert.swal(
                                    "¡Listo!",
                                    MESSAGES.OK.NEWPOLICY,
                                    "success"
                                  );
                                }
                                if (param == "ot") {
                                  SweetAlert.swal(
                                    "¡Listo!",
                                    MESSAGES.OK.NEWOT,
                                    "success"
                                  );
                                }
                                // $scope.sendEmail_Emision();
                                $state.go("polizas.info", {
                                  polizaId: $scope.idPolicy,
                                });
                              }
                            }
                          } else {
                            // AQUI VAN LOS ERRORES DEL BACK
                            if (data.data.ramo) {
                              try {
                                l.stop();
                              } catch (i) {}
                              $scope.enproceso = false;
                              SweetAlert.swal(
                                "Error",
                                "Vuelva a seleccionar el Ramo y, válide la información.",
                                "error"
                              );
                              // $scope.formatReceiptsAtError();
                            }
                            if (data.data.subramo) {
                              try {
                                l.stop();
                              } catch (i) {}
                              $scope.enproceso = false;
                              SweetAlert.swal(
                                "Error",
                                "Vuelva a seleccionar el Subramo y, válide la información.",
                                "error"
                              );
                              // $scope.formatReceiptsAtError();
                            }
                            if (data.data.p_total) {
                              try {
                                l.stop();
                              } catch (i) {}
                              $scope.enproceso = false;
                              SweetAlert.swal(
                                "Error",
                                MESSAGES.ERROR.PRIMATOTAL,
                                "error"
                              );
                              // $scope.formatReceiptsAtError();
                            }
                            if (data.data.recibos_poliza && param != "ot") {
                              try {
                                l.stop();
                              } catch (i) {}
                              $scope.enproceso = false;
                              SweetAlert.swal(
                                "Error",
                                MESSAGES.ERROR.RECEIPTSREQUIRED,
                                "error"
                              );
                              return;
                              // $scope.formatReceiptsAtError();
                            }
                            if (data.data.forma_de_pago) {
                              try {
                                l.stop();
                              } catch (i) {}
                              $scope.enproceso = false;
                              SweetAlert.swal(
                                "Error",
                                MESSAGES.ERROR.SELPAY,
                                "error"
                              );
                              return;
                              // $scope.formatReceiptsAtError();
                            }
                            if (data.data.poliza_number) {
                              try {
                                l.stop();
                              } catch (i) {}
                              $scope.enproceso = false;
                              SweetAlert.swal(
                                "Error",
                                MESSAGES.ERROR.POLIZAMAXLENGTH,
                                "error"
                              );
                              // $scope.formatReceiptsAtError();
                            }
                            if (data.data.folio) {
                              try {
                                l.stop();
                              } catch (i) {}
                              $scope.enproceso = false;
                              SweetAlert.swal(
                                "Error",
                                MESSAGES.ERROR.FOLIOMAXLENGTH,
                                "error"
                              );
                              $scope.formatReceiptsAtError();
                            }
                            if (data.data.automobiles_policy) {
                              if (data.data.automobiles_policy.policy_type) {
                                try {
                                  l.stop();
                                } catch (i) {}
                                $scope.enproceso = false;
                                SweetAlert.swal(
                                  "Error",
                                  MESSAGES.ERROR.OPTIONNOTVALID,
                                  "error"
                                );
                                return;
                              }
                            }
                            if (data.data.life_policy) {
                              if (data.data.life_policy) {
                                if (
                                  order.subforms.life.aseguradosList.length ===
                                    0 &&
                                  order.defaults.formInfo.code === 1
                                ) {
                                  $scope.enproceso = false;
                                  try {
                                    l.stop();
                                  } catch (i) {}
                                  SweetAlert.swal(
                                    "Error",
                                    MESSAGES.ERROR.ONEASEGURADOLIFE,
                                    "error"
                                  );
                                  return;
                                }
                              }
                            }

                            $scope.formatReceiptsAtError();
                          }
                        },
                        function error(err) {
                          $scope.enproceso = false;
                          console.log("ERROR ", err);
                          var e = err && err.data ? err.data : {};
                          if (e.ramo) {
                            try {
                              l.stop();
                            } catch (i) {}
                            $scope.enproceso = false;
                            // marca el campo como tocado para mostrar estilos de error
                            // if (order.form && order.form.ramo) order.form.ramo.$setTouched();
                            SweetAlert.swal(
                              "Error",
                              e.ramo[0] || "El ramo es obligatorio.",
                              "error"
                            );
                            return;
                          }
                          if (e.subramo) {
                            try {
                              l.stop();
                            } catch (i) {}
                            $scope.enproceso = false;
                            // if (order.form && order.form.subramo) order.form.subramo.$setTouched();
                            SweetAlert.swal(
                              "Error",
                              e.subramo[0] || "El subramo es obligatorio.",
                              "error"
                            );
                            return;
                          }
                          // genérico
                          // SweetAlert.swal("Error", "Revisa los datos enviados.", "error");
                        }
                      )
                      .catch(function (err) {
                        console.log("ooooooooo function catch", err);
                        $scope.enproceso = false;
                        try {
                          try {
                            l.stop();
                          } catch (i) {}
                        } catch (u) {}
                        console.log("ERROR - CATCH", err);
                      });
                  });
              }
            },
            function error(err) {
              console.log("ooooooooo function error", err);
              $scope.enproceso = false;
              try {
                try {
                  l.stop();
                } catch (i) {}
              } catch (u) {}
              console.log("err", err);
            }
          )
          .catch(function (e) {
            console.log("ooooooooo function catch *", e);
            try {
              l.stop();
            } catch (i) {}
            $scope.enproceso = false;
          });
      },
    };

    function isString(x) {
      return Object.prototype.toString.call(x) === "[object String]";
    }

    $scope.flag_ot = false;
    function fixDate(date) {
      if (typeof date === "string" && date.indexOf("T") !== -1) {
        var dateObj = new Date(date);
        if (!isNaN(dateObj.getTime())) {
          var day = ("0" + dateObj.getUTCDate()).slice(-2);
          var month = ("0" + (dateObj.getUTCMonth() + 1)).slice(-2);
          var year = dateObj.getUTCFullYear();
          return day + "/" + month + "/" + year;
        }
      } else if (date instanceof Date && !isNaN(date.getTime())) {
        var day = ("0" + date.getDate()).slice(-2);
        var month = ("0" + (date.getMonth() + 1)).slice(-2);
        var year = date.getFullYear();
        return day + "/" + month + "/" + year;
      }
      return date;
    }
    function normalizeVIN(vin) {
      return (vin || "").toString().trim().toUpperCase();
    }
    function hasInvalidVinLetters(vin) {
      return /[OIQ]/.test(normalizeVIN(vin));
    }
    order._vinWarningState = order._vinWarningState || {
      warned: false, // ya se mostró alerta alguna vez
      warnedVinValue: null, // con qué VIN se alertó
      userAcknowledged: false, // presionó OK
    };
    function showVinInvalidCharsAlert(vin, cb) {
      SweetAlert.swal(
        {
          title: "Alerta",
          text:
            "<div style='text-align:left; line-height:1.5; font-size:14px;'>" +
            "<p style='margin:0 0 10px;'>" +
            "Por regla internacional, no existen números de serie vehicular (VIN) que contengan las letras <b>O</b>, <b>I</b> o <b>Q</b>." +
            "</p>" +
            "<p style='margin:0;'><b>Favor de revisar la serie capturada.</b></p>" +
            "</div>",
          type: "warning",
          html: true,
          showCancelButton: false,
          confirmButtonText: "OK",
          confirmButtonColor: "#2563eb",
          closeOnConfirm: true,
        },
        function () {
          if (typeof cb === "function") cb();
        }
      );
    }

    $scope.validatePolicy = function (param) {
      SweetAlert.swal(
        {
          title: "Advertencia",
          text: "Se esta validando la información capturada, espere unos segundos.",
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#23c1f1ff",
          confirmButtonText: "Ok",
          closeOnConfirm: true,
          closeOnCancel: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            console.log("continuar", isConfirm);
          }
        }
      );
      $scope.enproceso = true;
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (param != "ot" && !order.form.canCreate) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal(
          "Error",
          "OPRIMA EL BOTÓN CALCULAR Y GENERAR RECIBOS",
          "error"
        );
        return;
      }

      var date1 = datesFactory.toDate(order.form.startDate);
      var date2 = datesFactory.toDate(order.form.endingDate);

      var since = toDate(order.form.startDate).getTime();
      var until = toDate(order.form.endingDate).getTime();

      $scope.arrayCoverage = order.coverageInPolicy_policy;
      $scope.count_coverage = 0;
      if (param == "poliza") {
        if (!order.form.poliza) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
          return;
        }
      }
      if (!order.form.contratante.val) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        return;
      }
      if (!order.form.address) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        return;
      }
      if (
        !order.form.contratante.email &&
        !order.form.contratante.phone_number
      ) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORWITHOUTEMAIL, "error");
        return;
      }
      if (order.form.contratante.email) {
        if (!validateEmail(order.form.contratante.email)) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
          return;
        }
        function validateEmail(email) {
          var re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        }
      }
      if (date1 > date2) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
        return;
      }
      if (!order.form.aseguradora) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        return;
      }
      $scope.referenciadores_copy = $scope.referenciadores.filter(function (
        item
      ) {
        return item && item.referenciador && isString(item.referenciador);
      });
      if (order.permiso_comision_no_obligatoria == false) {
        if (
          ($scope.referenciadores && $scope.referenciadores.length == 0) ||
          ($scope.referenciadores_copy &&
            $scope.referenciadores_copy.length == 0)
        ) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal(
            "Error",
            "Seleccione al menos un referenciador",
            "error"
          );
          return;
        } else {
          console.log(
            "continuar",
            $scope.referenciadores,
            order.permiso_comision_no_obligatoria,
            $scope.referenciadores_copy
          );
        }
      }

      // else{
      //   console.log('------permiso no obliga-----',$scope.referenciadores,order.permiso_comision_no_obligatoria,$scope.referenciadores_copy)
      // }
      if (!order.form.ramo) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        return;
      }
      if (!order.form.subramo) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (!order.form.clave) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        return;
      } else {
        $scope.clavenoexistente = false;
        if (order.defaults.claves) {
          order.defaults.claves.forEach(function (item) {
            if (order.form.clave.id == item.id) {
              $scope.clavenoexistente = true;
            }
          });
        } else {
          console.log("---sin claves--*");
          l.stop();
          $scope.enproceso = false;
        }
        if (!$scope.clavenoexistente) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
          return;
        }
      }
      if (!order.form.ramo) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        return;
      }
      if (!order.form.subramo) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (order.form.ramo.ramo_code == 1) {
        if (order.form.subramo.subramo_code != 30) {
          if (order.subforms.life.policy_type) {
            if (order.subforms.life.policy_type.id) {
              console.log("si", order.subforms.life.policy_type);
            } else {
              if (
                !order.subforms.life.policy_type ||
                order.subforms.life.policy_type.id
              ) {
                var l = Ladda.create(document.querySelector(".ladda-button"));
                l.start();
                l.stop();
                $scope.enproceso = false;
                SweetAlert.swal("Error", "Selecciona un tipo.", "error");
                return;
              }
            }
          } else {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Selecciona un tipo.", "error");
            return;
          }
        }
      }
      if (order.form.ramo.ramo_code == 2) {
        if (order.subforms.disease.policy_type) {
          if (order.subforms.disease.policy_type.id) {
            console.log("si", order.subforms.disease.policy_type);
          } else {
            if (
              !order.subforms.disease.policy_type ||
              order.subforms.disease.policy_type.id
            ) {
              var l = Ladda.create(document.querySelector(".ladda-button"));
              l.start();
              l.stop();
              $scope.enproceso = false;
              SweetAlert.swal("Error", "Selecciona un tipo.", "error");
              return;
            }
          }
        } else {
          var l = Ladda.create(document.querySelector(".ladda-button"));
          l.start();
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Error", "Selecciona un tipo.", "error");
          return;
        }
      }
      if (order.form.ramo.ramo_code == 3) {
        if (order.form.subramo.subramo_code == 9) {
          if (order.subforms.auto.policy_type) {
            if (order.subforms.auto.policy_type.id) {
              console.log("si", order.subforms.auto.policy_type);
            } else {
              if (
                !order.subforms.auto.policy_type ||
                order.subforms.auto.policy_type.id
              ) {
                var l = Ladda.create(document.querySelector(".ladda-button"));
                l.start();
                l.stop();
                $scope.enproceso = false;
                SweetAlert.swal("Error", "Selecciona un tipo.", "error");
                return;
              }
            }
            if (
              order.subforms &&
              order.subforms.auto &&
              order.subforms.auto.serial
            ) {
              // Normaliza siempre para comparar bien
              var serial = normalizeVIN(order.subforms.auto.serial);
              order._vinWarningState = order._vinWarningState || {
                warned: false,
                warnedVinValue: null,
                userAcknowledged: false,
              };
              if (serial && hasInvalidVinLetters(serial)) {
                var st = order._vinWarningState;
                // Importante: comparar normalizado
                var alreadyWarnedThisValue =
                  st.warned === true &&
                  st.warnedVinValue === serial &&
                  st.userAcknowledged === true;
                if (!alreadyWarnedThisValue) {
                  st.warned = true;
                  st.warnedVinValue = serial;
                  st.userAcknowledged = false;
                  // 🔴 si ya arrancaste loader/enproceso antes, deténlo aquí mismo
                  // (porque vas a "volver" y no seguir)
                  $scope.enproceso = false;
                  if (l) l.stop();
                  var l = Ladda.create(document.querySelector(".ladda-button"));
                  l.start();
                  l.stop();
                  $scope.enproceso = false;
                  showVinInvalidCharsAlert(serial, function () {
                    // El usuario dio OK: solo marcamos que ya vio la alerta
                    st.userAcknowledged = true;
                    // ✅ NO continuar con el proceso
                    // Regresar/permitir corrección:
                    $scope.enproceso = false;
                    // si usas Ladda, deténlo aquí
                    // l.stop();
                    // Si quieres llevar el foco al input de serie:
                    setTimeout(function () {
                      var el = document.querySelector(
                        "#vinInput, input[name='serial'], input[ng-model='order.subforms.auto.serial']"
                      );
                      if (el) el.focus();
                    }, 50);

                    // Si necesitas digest por estar en setTimeout:
                    if (!$scope.$$phase) $scope.$applyAsync();
                  });
                  return; // 🚫 cortas el flujo: NO guarda
                }
              }
            }
          } else {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Selecciona un tipo.", "error");
            return;
          }
        } else {
          if (order.subforms.damage.policy_type) {
            if (order.subforms.damage.policy_type.id) {
              console.log("si", order.subforms.damage.policy_type);
            } else {
              if (
                !order.subforms.damage.policy_type ||
                order.subforms.damage.policy_type.id
              ) {
                l.stop();
                $scope.enproceso = false;
                SweetAlert.swal("Error", "Selecciona un tipo.", "error");
                return;
              }
            }
          } else {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Selecciona un tipo.", "error");
            return;
          }
          if (
            !order.subforms.damage.insured_item ||
            order.subforms.damage.insured_item == undefined ||
            order.subforms.damage.insured_item == "" ||
            order.subforms.damage.insured_item == ""
          ) {
            var l = Ladda.create(document.querySelector(".ladda-button"));
            l.start();
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Agregue un Bien asegurado.", "error");
            return;
          }
        }
      }
      if (!order.form.payment) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORPAYFORM, "error");
        return;
      }

      $scope.referenciadores_copy = $scope.referenciadores.filter(function (
        item
      ) {
        return item && item.referenciador && isString(item.referenciador);
      });

      if (
        !order.acc_referenciador_obligatorio &&
        $scope.referenciadores_copy.length <= 0
      ) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal(
          "Error",
          "Seleccione al menos un referenciador",
          "error"
        );
        return;
      }

      // l.stop();
      // SweetAlert.swal("Succes", "Si pasa", "success");
      // return;

      if (!order.form.ramo) {
        if (!order.form.ramo.url) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Oops...", MESSAGES.ERROR.RAMOREQUIRED, "error");
          return;
        }
      }
      if (!order.form.subramo) {
        if (!order.form.subramo.url) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Oops...", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
          return;
        }
      }
      if (order.form.ramo) {
        if (!order.form.subramo) {
          if (!order.form.subramo.url) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Oops...", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
            return;
          }
        }
        if (order.form.ramo.ramo_code == 1) {
          if (order.form.subramo.subramo_code != 30) {
            if (order.subforms.life.policy_type) {
              if (order.subforms.life.policy_type.id) {
              } else {
                if (
                  !order.subforms.life.policy_type ||
                  order.subforms.life.policy_type.id
                ) {
                  var l = Ladda.create(document.querySelector(".ladda-button"));
                  l.start();
                  l.stop();
                  $scope.enproceso = false;
                  SweetAlert.swal("Error", "Selecciona un tipo.", "error");
                  return;
                }
              }
            } else {
              l.stop();
              $scope.enproceso = false;
              SweetAlert.swal("Error", "Selecciona un tipo.", "error");
              return;
            }
          }
        }
        if (order.form.ramo.ramo_code == 2) {
          if (order.subforms.disease.policy_type) {
            if (order.subforms.disease.policy_type.id) {
            } else {
              if (
                !order.subforms.disease.policy_type ||
                order.subforms.disease.policy_type.id
              ) {
                var l = Ladda.create(document.querySelector(".ladda-button"));
                l.start();
                l.stop();
                $scope.enproceso = false;
                SweetAlert.swal("Error", "Selecciona un tipo.", "error");
                return;
              }
            }
          } else {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Selecciona un tipo.", "error");
            return;
          }
        }
        if (order.form.ramo.ramo_code == 3) {
          if (order.form.subramo.subramo_code == 9) {
            if (order.subforms.auto.policy_type) {
              if (order.subforms.auto.policy_type.id) {
              } else {
                if (
                  !order.subforms.auto.policy_type ||
                  order.subforms.auto.policy_type.id
                ) {
                  l.stop();
                  $scope.enproceso = false;
                  SweetAlert.swal("Error", "Selecciona un tipo.", "error");
                  return;
                }
              }
            } else {
              var l = Ladda.create(document.querySelector(".ladda-button"));
              l.start();
              l.stop();
              $scope.enproceso = false;
              SweetAlert.swal("Error", "Selecciona un tipo.", "error");
              return;
            }
          } else {
            if (order.subforms.damage.policy_type) {
              if (order.subforms.damage.policy_type.id) {
              } else {
                if (
                  !order.subforms.damage.policy_type ||
                  order.subforms.damage.policy_type.id
                ) {
                  var l = Ladda.create(document.querySelector(".ladda-button"));
                  l.start();
                  l.stop();
                  $scope.enproceso = false;
                  SweetAlert.swal("Error", "Selecciona un tipo.", "error");
                  return;
                }
              }
            } else {
              var l = Ladda.create(document.querySelector(".ladda-button"));
              l.start();
              l.stop();
              $scope.enproceso = false;
              SweetAlert.swal("Error", "Selecciona un tipo.", "error");
              return;
            }
          }
        }
      }
      if (!order.form.clave) {
        if (!order.form.clave.url) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Oops...", MESSAGES.ERROR.CLAVE, "error");
          return;
        }
      }

      if (!order.form.ramo) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        return;
      }
      if (!order.form.subramo) {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (!order.form.contratante) {
        if (!order.form.contratante.url) {
          l.stop();
          SweetAlert.swal("Oops...", MESSAGES.ERROR.CONTRACTORERROR, "error");
          return;
        }
      }
      if (!order.form.address) {
        if (!order.form.address.url) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Oops...", MESSAGES.ERROR.ADDRESS, "error");
          return;
        }
      }
      if (!order.form.aseguradora) {
        if (!order.form.aseguradora.url) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Oops...", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
          return;
        }
      }
      if (param == "poliza") {
        if (!order.form.paquete) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Error", "Elige un paquete", "error");
          return;
        }
        if (order.form.subramo.subramo_code == 1) {
          $scope.flag_try = false;
          if (order.subforms.life.beneficiariesList) {
            try {
              order.subforms.life.beneficiariesList.forEach(function (
                beneficiary,
                index
              ) {
                var idx = index + 1;
                if (beneficiary.person == 1) {
                  if (!beneficiary.first_name) {
                    l.stop();
                    $scope.enproceso = false;
                    $scope.flag_try = true;
                    SweetAlert.swal(
                      "Error",
                      "Agrega el nombre del beneficiario  #" + idx,
                      "error"
                    );
                    throw new Error();
                  }
                  if (!beneficiary.last_name) {
                    l.stop();
                    $scope.enproceso = false;
                    $scope.flag_try = true;
                    SweetAlert.swal(
                      "Error",
                      "Agrega el apellido paterno del beneficiario  #" + idx,
                      "error"
                    );
                    throw new Error();
                  }
                  if (!beneficiary.birthdate) {
                    l.stop();
                    $scope.enproceso = false;
                    $scope.flag_try = true;
                    SweetAlert.swal(
                      "Error",
                      "Agrega la fecha de nacimiento del beneficiario  #" + idx,
                      "error"
                    );
                    throw new Error();
                  }
                  if (!beneficiary.sex) {
                    l.stop();
                    $scope.enproceso = false;
                    $scope.flag_try = true;
                    SweetAlert.swal(
                      "Error",
                      "Agrega el sexo del beneficiario  #" + idx,
                      "error"
                    );
                    throw new Error();
                  }
                  if (!beneficiary.percentage) {
                    l.stop();
                    $scope.enproceso = false;
                    $scope.flag_try = true;
                    SweetAlert.swal(
                      "Error",
                      "Agrega el porcentaje del beneficiario  #" + idx,
                      "error"
                    );
                    throw new Error();
                  }
                } else if (beneficiary.person == 2) {
                  if (!beneficiary.j_name) {
                    l.stop();
                    $scope.enproceso = false;
                    $scope.flag_try = true;
                    SweetAlert.swal(
                      "Error",
                      "Agrega la razón social del beneficiario  #" + idx,
                      "error"
                    );
                    throw new Error();
                  }
                  if (!beneficiary.rfc) {
                    l.stop();
                    $scope.enproceso = false;
                    $scope.flag_try = true;
                    SweetAlert.swal(
                      "Error",
                      "Agrega el RFC del beneficiario  #" + idx,
                      "error"
                    );
                    throw new Error();
                  }
                }
              });
            } catch (e) {
              console.log("dddddddddddddddddd", e);
            }
          }
          if (order.subforms.life.aseguradosList.length == 0) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Agrega un asegurado", "error");
            return;
          }
          if (order.subforms.life.aseguradosList) {
            try {
              order.subforms.life.aseguradosList.forEach(function (
                aseg,
                index
              ) {
                var idx = index + 1;
                if (!aseg.first_name) {
                  l.stop();
                  $scope.enproceso = false;
                  $scope.flag_try = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el nombre del asegurado  #" + idx,
                    "error"
                  );
                  throw new Error();
                }
                if (!aseg.last_name) {
                  l.stop();
                  $scope.enproceso = false;
                  $scope.flag_try = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el apellido paterno del asegurado  #" + idx,
                    "error"
                  );
                  throw new Error();
                }
                if (!aseg.birthdate) {
                  l.stop();
                  $scope.enproceso = false;
                  $scope.flag_try = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega la fecha de nacimiento del asegurado  #" + idx,
                    "error"
                  );
                  throw new Error();
                }
                if (!aseg.sex) {
                  l.stop();
                  $scope.enproceso = false;
                  $scope.flag_try = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el sexo del asegurado  #" + idx,
                    "error"
                  );
                  throw new Error();
                }
                if (!aseg.smoker) {
                  l.stop();
                  $scope.enproceso = false;
                  $scope.flag_try = true;
                  SweetAlert.swal(
                    "Error",
                    "Agrega si es fumador o no el asegurado  #" + idx,
                    "error"
                  );
                  throw new Error();
                }
              });
            } catch (e) {}
          }
          if ($scope.flag_try == true) {
            l.stop();
            $scope.enproceso = false;
            return;
          }
        }
        if (order.form.subramo.subramo_code == 3) {
          if (!order.subforms.disease.first_name) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Agregue el nombre del titular", "error");
            return;
          }
          if (!order.subforms.disease.last_name) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal(
              "Error",
              "Agregue el apellido paterno del titular",
              "error"
            );
            return;
          }
          if (!order.subforms.disease.birthdate) {
            console.log("-order", order.subforms.disease);
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal(
              "Error",
              "Agregue la fecha de nacimiento del titular",
              "error"
            );
            return;
          }
          if (!order.subforms.disease.sex) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Elige el sexo del titular", "error");
            return;
          }
          if (order.subforms.disease.relationshipList) {
            try {
              order.subforms.disease.relationshipList.forEach(function (
                dependent,
                index
              ) {
                var idx = index + 1;
                if (!dependent.first_name) {
                  l.stop();
                  $scope.enproceso = false;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el nombre del dependiente  #" + idx,
                    "error"
                  );
                  throw new Error();
                }
                if (!dependent.last_name) {
                  l.stop();
                  $scope.enproceso = false;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el apellido paterno del dependiente  #" + idx,
                    "error"
                  );
                  throw new Error();
                }
                if (!dependent.relationship) {
                  l.stop();
                  $scope.enproceso = false;
                  SweetAlert.swal(
                    "Error",
                    "Elige el parentesco del dependiente  #" + idx,
                    "error"
                  );
                  throw new Error();
                }
                if (!dependent.birthdate) {
                  l.stop();
                  $scope.enproceso = false;
                  SweetAlert.swal(
                    "Error",
                    "Agrega la fecha de nacimiento del dependiente  #" + idx,
                    "error"
                  );
                  throw new Error();
                }
                if (!dependent.sex) {
                  l.stop();
                  $scope.enproceso = false;
                  SweetAlert.swal(
                    "Error",
                    "Agrega el sexo del dependiente  #" + idx,
                    "error"
                  );
                  throw new Error();
                }
              });
            } catch (e) {
              $scope.enproceso = false;
            }
          }
        }
        if (order.form.subramo.subramo_code == 7) {
          if (
            !order.subforms.damage.insured_item ||
            order.subforms.damage.insured_item == undefined ||
            order.subforms.damage.insured_item == "" ||
            order.subforms.damage.insured_item == ""
          ) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Agrega el bien asegurado", "error");
            return;
          }
        }
        if (order.form.subramo.subramo_code == 9) {
          if (!order.subforms.auto.brand) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Agrega la marca del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.year) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Elige el año del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.version) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal(
              "Error",
              "Agrega la versión del automóvil",
              "error"
            );
            return;
          }
          if (!order.subforms.auto.serial) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Agrega la serie del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.usage) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", "Elige el uso del automóvil", "error");
            return;
          }
          if (!order.subforms.auto.service) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal(
              "Error",
              "Agrega el servicio del automóvil",
              "error"
            );
            return;
          }
        }
        if ($scope.arrayCoverage) {
          for (var i = 0; i < $scope.arrayCoverage.length; i++) {
            if (
              $scope.arrayCoverage[i].deductibleInPolicy ||
              $scope.arrayCoverage[i].sumInPolicy
            ) {
              try {
                $scope.arrayCoverage[i]["package"] = order.form.paquete.id;
              } catch (e) {
                $scope.arrayCoverage[i]["package"] = order.form.paquete.id;
              }
              $scope.count_coverage++;
            }
            if (i + 1 == $scope.arrayCoverage.length) {
              // if($scope.count_coverage == 0){
              //   l.stop();
              //   SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
              //   return;
              // }
            }
          }
        }
        // if($scope.arrayCoverage.length == 0){
        //   l.stop();
        //   SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
        //   return;
        // }

        if (!$scope.dataToSave.recibos_poliza) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        } else {
          var flag_save = false;
          $scope.dataToSave.recibos_poliza.forEach(function (receipt) {
            receipt.iva = receipt.iva ? parseFloat(receipt.iva).toFixed(2) : 0;
            receipt.prima_neta = receipt.prima_neta
              ? parseFloat(receipt.prima_neta).toFixed(2)
              : 0;
            receipt.prima_total = receipt.prima_total
              ? parseFloat(receipt.prima_total).toFixed(2)
              : 0;
            receipt.derecho = receipt.derecho
              ? parseFloat(receipt.derecho).toFixed(2)
              : 0;
            receipt.rpf = receipt.rpf ? parseFloat(receipt.rpf).toFixed(2) : 0;
            receipt.comision = receipt.comision
              ? parseFloat(receipt.comision).toFixed(2)
              : 0;
            receipt.descuento = receipt.descuento
              ? parseFloat(receipt.descuento).toFixed(2)
              : 0;
            receipt.fecha_inicio = fixDate(receipt.fecha_inicio);
            receipt.fecha_fin = fixDate(receipt.fecha_fin);
            if (
              receipt.fecha_inicio &&
              typeof receipt.fecha_inicio === "string" &&
              receipt.fecha_inicio.indexOf("T") !== -1
            ) {
              var dateObjInicio = new Date(receipt.fecha_inicio);

              if (!isNaN(dateObjInicio.getTime())) {
                var day = ("0" + dateObjInicio.getDate()).slice(-2);
                var month = ("0" + (dateObjInicio.getMonth() + 1)).slice(-2);
                var year = dateObjInicio.getFullYear();
                receipt.fecha_inicio = day + "/" + month + "/" + year;
              }
            }

            if (
              receipt.fecha_fin &&
              typeof receipt.fecha_fin === "string" &&
              receipt.fecha_fin.indexOf("T") !== -1
            ) {
              var dateObjFin = new Date(receipt.fecha_fin);

              if (!isNaN(dateObjFin.getTime())) {
                var day = ("0" + dateObjFin.getDate()).slice(-2);
                var month = ("0" + (dateObjFin.getMonth() + 1)).slice(-2);
                var year = dateObjFin.getFullYear();
                receipt.fecha_fin = day + "/" + month + "/" + year;
              }
            }

            if (!receipt.fecha_inicio || !receipt.fecha_fin) {
              l.stop();
              $scope.enproceso = false;
              flag_save = true;
              SweetAlert.swal("Error", MESSAGES.ERROR.RECEIPTSDATES, "error");
              return;
            }
          });
          if (flag_save == true) {
            l.stop();
            $scope.enproceso = false;
            return;
          }
          // var sinceReceipt = toDate($scope.dataToSave.recibos_poliza[0].fecha_inicio).getTime();
          // var untilReceipt = toDate($scope.dataToSave.recibos_poliza[$scope.dataToSave.recibos_poliza.length - 1].fecha_fin).getTime();
          var primerFecha = $scope.dataToSave.recibos_poliza[0].fecha_inicio;
          var ultimaFecha =
            $scope.dataToSave.recibos_poliza[
              $scope.dataToSave.recibos_poliza.length - 1
            ].fecha_fin;

          // validar claramente luego de arreglarlas
          if (
            !primerFecha ||
            !ultimaFecha ||
            typeof primerFecha !== "string" ||
            primerFecha.indexOf("/") === -1 ||
            typeof ultimaFecha !== "string" ||
            ultimaFecha.indexOf("/") === -1
          ) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal(
              "Error",
              "Formato de fechas inválido\n Genere recibos de nuevo.",
              "error"
            );
            return;
          }

          var sinceReceipt = toDate(primerFecha).getTime();
          var untilReceipt = toDate(ultimaFecha).getTime();
        }
        if (since != sinceReceipt) {
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.DATESOUT, "error");
          return;
        }
        var date_since = new Date(since);
        var date_until = new Date(until);
        var validity =
          parseInt(date_until.getFullYear()) -
          parseInt(date_since.getFullYear());
        if (until != untilReceipt) {
          if (validity == 1) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.DATESOUT, "error");
            return;
          } else if (validity > 1) {
            if ($scope.arrayCoverage.length == $scope.count_coverage) {
              if (!order.form.folio) {
                if (order.form.contratante.value.type_person == "Moral") {
                  var data = {
                    id_contractor: order.form.contratante.value.id,
                    type_person: 2,
                  };
                  $scope.type_person_selected = 2;
                } else {
                  var data = {
                    id_contractor: order.form.contratante.value.id,
                    type_person: 1,
                  };
                  $scope.type_person_selected = 1;
                }

                dataFactory
                  .post("count-policy-by-contractor/", data)
                  .then(function success(response) {
                    if (response.status == 200) {
                      var num = parseInt(response.data.total_policies) + 1;
                      if ($scope.type_person_selected == 1) {
                        var num_folio =
                          order.form.contratante.value.last_name.charAt(0) +
                          "_" +
                          order.form.contratante.value.first_name.charAt(0) +
                          "_" +
                          num;
                        order.save.saveInsurance(param, num_folio);
                      } else {
                        var num_folio =
                          order.form.contratante.value.full_name.charAt(0) +
                          "_" +
                          num;
                        order.save.saveInsurance(param, num_folio);
                      }
                    }
                  });
              } else {
                order.save.saveInsurance(param);
              }
            } else {
              SweetAlert.swal(
                {
                  title: "Coberturas sin datos",
                  text: "Las coberturas sin suma asegurda y sin deducible no se guardarán, ¿Estás seguro de continuar?",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Si",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                },
                function (isConfirm) {
                  if (isConfirm) {
                    swal.close();
                    l.stop();
                    $scope.enproceso = false;
                    if (!order.form.folio) {
                      if (order.form.contratante.value.type_person == "Moral") {
                        var data = {
                          id_contractor: order.form.contratante.value.id,
                          type_person: 2,
                        };
                        $scope.type_person_selected = 2;
                      } else {
                        var data = {
                          id_contractor: order.form.contratante.value.id,
                          type_person: 1,
                        };
                        $scope.type_person_selected = 1;
                      }

                      dataFactory
                        .post("count-policy-by-contractor/", data)
                        .then(function success(response) {
                          if (response.status == 200) {
                            var num =
                              parseInt(response.data.total_policies) + 1;
                            if ($scope.type_person_selected == 1) {
                              var num_folio =
                                order.form.contratante.value.full_name.charAt(
                                  0
                                ) +
                                "_" +
                                num;
                              order.save.saveInsurance(param, num_folio);
                            } else {
                              var num_folio =
                                order.form.contratante.value.full_name.charAt(
                                  0
                                ) +
                                "_" +
                                num;
                              order.save.saveInsurance(param, num_folio);
                            }
                          }
                        });
                    } else {
                      order.save.saveInsurance(param);
                    }
                  } else {
                    l.stop();
                    $scope.enproceso = false;
                  }
                }
              );
            }
          }
        } else {
          if ($scope.arrayCoverage.length == $scope.count_coverage) {
            l.stop();
            $scope.enproceso = false;
            if (!order.form.folio) {
              if (
                order.form.contratante.value.type_person == "Moral" ||
                order.form.contratante.value.type_person == 2
              ) {
                var data = {
                  id_contractor: order.form.contratante.value.id,
                  type_person: 2,
                };
                $scope.type_person_selected = 2;
              } else {
                var data = {
                  id_contractor: order.form.contratante.value.id,
                  type_person: 1,
                };
                $scope.type_person_selected = 1;
              }

              dataFactory
                .post("count-policy-by-contractor/", data)
                .then(function success(response) {
                  if (response.status == 200) {
                    var num = parseInt(response.data.total_policies) + 1;
                    if ($scope.type_person_selected == 1) {
                      var num_folio =
                        order.form.contratante.value.full_name.charAt(0) +
                        "_" +
                        order.form.contratante.value.full_name.charAt(2) +
                        "_" +
                        num;
                      order.save.saveInsurance(param, num_folio);
                    } else {
                      var num_folio =
                        order.form.contratante.value.full_name.charAt(0) +
                        "_" +
                        num;
                      order.save.saveInsurance(param, num_folio);
                    }
                  }
                });
            } else {
              order.save.saveInsurance(param);
            }
          } else {
            SweetAlert.swal(
              {
                title: "Coberturas sin datos",
                text: "Las coberturas sin suma asegurda y sin deducible no se guardarán, ¿Estás seguro de continuar?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                closeOnConfirm: false,
              },
              function (isConfirm) {
                if (isConfirm) {
                  swal.close();
                  l.stop();
                  $scope.enproceso = false;
                  if (!order.form.folio) {
                    if (
                      order.form.contratante.value.type_person == "Moral" ||
                      order.form.contratante.value.type_person == 2
                    ) {
                      var data = {
                        id_contractor: order.form.contratante.value.id,
                        type_person: 2,
                      };
                      $scope.type_person_selected = 2;
                    } else {
                      var data = {
                        id_contractor: order.form.contratante.value.id,
                        type_person: 1,
                      };
                      $scope.type_person_selected = 1;
                    }

                    dataFactory
                      .post("count-policy-by-contractor/", data)
                      .then(function success(response) {
                        if (response.status == 200) {
                          var num = parseInt(response.data.total_policies) + 1;
                          if ($scope.type_person_selected == 1) {
                            var num_folio =
                              order.form.contratante.value.full_name.charAt(0) +
                              "_" +
                              num;
                            order.save.saveInsurance(param, num_folio);
                          } else {
                            var num_folio =
                              order.form.contratante.value.full_name.charAt(0) +
                              "_" +
                              num;
                            order.save.saveInsurance(param, num_folio);
                          }
                        }
                      });
                  } else {
                    order.save.saveInsurance(param);
                  }
                } else {
                  $scope.enproceso = false;
                  l.stop();
                }
              }
            );
          }
        }
      } else {
        $scope.enproceso = false;
        l.stop();
        if (!order.form.paquete) {
          $scope.enproceso = false;
          l.stop();
          SweetAlert.swal("Error", "Elige un paquete", "error");
          return;
        }
        if (order.defaults.coverages.length == 0) {
          try {
            flag_save = false;
          } catch (e) {
            var flag_save = false;
          }
          l.stop();
          $scope.enproceso = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
          return;
        }
        if (!order.form.folio) {
          if (
            order.form.contratante.value.type_person == "Moral" ||
            order.form.contratante.value.type_person == 2
          ) {
            var data = {
              id_contractor: order.form.contratante.value.id,
              type_person: 2,
            };
            $scope.type_person_selected = 2;
          } else {
            var data = {
              id_contractor: order.form.contratante.value.id,
              type_person: 1,
            };
            $scope.type_person_selected = 1;
          }

          dataFactory
            .post("count-policy-by-contractor/", data)
            .then(function success(response) {
              if (response.status == 200) {
                try {
                  var fullName = order.form.contratante.value.full_name || "";
                  var cleanName = fullName
                    .replace(/\s+/g, "")
                    .replace(/[^a-zA-Z0-9]/g, "")
                    .toUpperCase();
                  var num = parseInt(response.data.total_policies) + 1;

                  var num_folio =
                    $scope.type_person_selected == 1
                      ? cleanName.charAt(0) +
                        "_" +
                        cleanName.charAt(2) +
                        "_" +
                        num
                      : cleanName.charAt(0) + "_" + num;

                  num_folio = encodeURIComponent(num_folio); // ← asegura que no rompa la URL

                  order.save.saveInsurance(param, num_folio);
                } catch (e) {
                  console.log("error to generate folio", e);
                }
              }
            });
        } else {
          if (!$scope.flag_ot) {
            $scope.flag_ot = true;
          } else {
            return;
          }
          order.save.saveInsurance(param);
        }
      }
    };

    $scope.changeAgrupacion = function (data) {
      $scope.sub_asignaciones = data.subgrupos;
      $scope.sub_subasignaciones = [];
      if ($scope.info_sub) {
        if ($scope.info_sub.subgrouping) {
          $scope.sub_asignaciones.forEach(function (item) {
            if (item.description == $scope.info_sub.subgrouping) {
              order.form.subgrouping = item;
              $scope.changeSubagrupacion(item);
            }
          });
        }
      } else {
        $scope.sub_asignaciones = data.subgrupos;
      }
      $scope.saveLocalstorange();
    };

    $scope.changeSubagrupacion = function (data) {
      if (data) {
        if (data.subsubgrupos) {
          $scope.sub_subasignaciones = data.subsubgrupos;
          if ($scope.info_sub) {
            if ($scope.info_sub.subsubgrouping) {
              $scope.sub_subasignaciones.forEach(function (item) {
                if (item.description == $scope.info_sub.subsubgrouping) {
                  order.form.subsubgrouping = item;
                }
              });
            }
          } else {
            $scope.sub_subasignaciones = data.subsubgrupos;
          }
        } else {
          $scope.sub_subasignaciones = data.subsubgrupos;
        }
      } else {
        $scope.sub_subasignaciones = [];
      }
    };

    $scope.flagCoverage = false;

    $scope.formatReceipts = function () {
      $scope.dataToSave.recibos_poliza = $scope.receitps_backup;

      // console.log('formatReceipts');

      // $scope.dataToSave.recibos_poliza.forEach(function(rec) {

      //   var start = datesFactory.toDate(rec.startDate);
      //   var end = datesFactory.toDate(rec.endingDate);

      //   console.log('start', start);
      //   console.log('end', end);
      //   // console.log('end', end);
      //   // console.log('---------------------');

      //   rec.endingDate = end;
      //   // rec.fecha_fin = end;
      //   rec.startDate = start;
      //   // rec.fecha_inicio = start;

      //   console.log('startDate', rec.startDate);

      //   console.log(rec);

      // });

      // order.receipts = $scope.dataToSave.recibos_poliza;
    };

    $scope.formatReceiptsAtError = function () {
      var primas_suma = 0.0;

      if ($scope.dataToSave.receipts) {
        $scope.dataToSave.recibos_poliza.forEach(function (receipt) {
          receipt.iva = receipt.iva ? parseFloat(receipt.iva).toFixed(2) : 0;
          receipt.prima_neta = receipt.prima_neta
            ? parseFloat(receipt.prima_neta).toFixed(2)
            : 0;
          receipt.prima_total = receipt.prima_total
            ? parseFloat(receipt.prima_total).toFixed(2)
            : 0;
          receipt.derecho = receipt.derecho
            ? parseFloat(receipt.derecho).toFixed(2)
            : 0;
          receipt.rpf = receipt.rpf ? parseFloat(receipt.rpf).toFixed(2) : 0;
          receipt.comision = receipt.comision
            ? parseFloat(receipt.comision).toFixed(2)
            : 0;
          receipt.descuento = receipt.descuento
            ? parseFloat(receipt.descuento).toFixed(2)
            : 0;
          primas_suma = primas_suma + receipt.prima_total;
          var start_date = convertDate(receipt.startDate);
          var end_date = convertDate(receipt.endingDate);

          receipt.endingDate = end_date;
          receipt.fecha_fin = end_date;
          receipt.startDate = start_date;
          receipt.fecha_inicio = start_date;

          if (receipt.vencimiento) {
            var vencimiento = convertDate(receipt.vencimiento);
            receipt.vencimiento = vencimiento;
          } else {
            receipt.vencimiento = null;
          }
        });

        // order.receipts = $scope.dataToSave.recibos_poliza;
      }
    };

    // Estructura
    $rootScope.numberPolicy = true;
    $scope.changeNoPoliza = function (noPoliza) {
      $rootScope.poliza_n = noPoliza;
      if ($rootScope.poliza_n == undefined) {
        $rootScope.numberPolicy = true;
      } else {
        $rootScope.numberPolicy = false;
      }
    };
    $rootScope.folioPolicy = true;
    $scope.changeFolio = function (folio) {
      $rootScope.poliza_f = folio;
      if ($rootScope.poliza_f == undefined) {
        $rootScope.folioPolicy = true;
      } else {
        $rootScope.folioPolicy = false;
      }
    };

    $scope.changeAdaptacion = function (param) {
      var param = param.replace(/,/g, "");
      var n = $scope.changeAdaptacion_(param);
      order.subforms.auto.mont_adjustment = n;
      //       return model;
    };
    $scope.changeMonto = function (param) {
      var param = param.replace(/,/g, "");
      var n = $scope.changeAdaptacion_(param);
      order.subforms.auto.mont_special_team = n;
      //       return model;
    };

    $scope.changeAdaptacion_ = function (num) {
      num = num.toString().replace(/\$|\,/g, "");
      if (isNaN(num)) {
        num = "0";
      }
      var sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      var cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) {
        cents = "0" + cents;
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num =
          num.substring(0, num.length - (4 * i + 3)) +
          "," +
          num.substring(num.length - (4 * i + 3));
      }
      return (sign ? "" : "-") + "$" + num + "." + cents;
    };

    function structure(parStatus) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.enproceso = true;
      if (!order.form.payment || order.form.payment == "") {
        l.stop();
        $scope.enproceso = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.SELPAY, "error");
        return;
        // toaster.warning('Debe seleccionar forma de pago.')
      }
      $scope.dataToSave.forma_de_pago = order.form.payment;
      $scope.dataToSave.folio = order.form.folio
        ? order.form.folio
        : $scope.num_folio;
      if (order.show.ot == true) {
        $scope.dataToSave.poliza_number = "";
      } else {
        $scope.dataToSave.poliza_number = order.form.poliza;
      }
      $scope.dataToSave.endorsement = false;
      $scope.dataToSave.folio_endorsement = null;
      $scope.dataToSave.document_type = 1;
      $scope.dataToSave.old_policies = [];
      $scope.dataToSave.status = parStatus; // 14 para crear pliza // 1 para crear OT
      $scope.dataToSave.internal_number = $scope.internal_number;
      // Defaults
      $scope.Validation = function () {
        // console.log('poliza_number',$rootScope.poliza_n);
        // console.log('folio_number',$rootScope.folio_n);
        if ($rootScope.poliza_f == undefined) {
          $rootScope.folioPolicy = true;
        } else {
          $rootScope.folioPolicy = false;
        }
        if ($rootScope.poliza_n == undefined) {
          $rootScope.numberPolicy = true;
        } else {
          $rootScope.numberPolicy = false;
        }
      };
      switch (order.form.subramo.subramo_code) {
        case 1:
          // if (order.subforms.life.beneficiariesList.length === 0 && order.defaults.formInfo.code === 1) {
          //   l.stop();
          //   $scope.enproceso=false;
          //   SweetAlert.swal("Error", MESSAGES.ERROR.ONEBENEFICIARY, "error");
          //   // $scope.formatReceiptsAtError();
          //   $scope.formatReceipts();
          //   return;
          // }
          if (
            helpers.beneficiariesPercentageGreaterThanZero(
              order.subforms.life.beneficiariesList
            )
          ) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", MESSAGES.ERROR.GREATERTHAN100, "error");
            // return;
          }

          if (order.form.subramo.subramo_code == 1) {
            var beneficiariesList = _.map(
              order.subforms.life.beneficiariesList,
              function (item, i) {
                return {
                  first_name: item.first_name ? item.first_name : "",
                  last_name: item.last_name ? item.last_name : "",
                  second_last_name: item.second_last_name
                    ? item.second_last_name
                    : "",
                  optional_relationship: item.optional_relationship
                    ? item.optional_relationship
                    : "",
                  birthdate: item.birthdate
                    ? new Date(toDate(item.birthdate))
                    : new Date(),
                  antiguedad: item.antiguedad
                    ? new Date(toDate(item.antiguedad))
                    : null,
                  sex: item.sex ? item.sex : "",
                  percentage: item.percentage
                    ? parseFloat(item.percentage).toFixed(2)
                    : 100,
                  person: item.person,
                  rfc: item.rfc ? item.rfc : "",
                  j_name: item.j_name ? item.j_name : "",
                };
              }
            );
            var asegurados_1 = [];
            var aseguradosList = _.map(
              order.subforms.life.aseguradosList,
              function (item, i) {
                if (i == 0) {
                  return {
                    first_name: item.first_name ? item.first_name : "",
                    last_name: item.last_name ? item.last_name : "",
                    second_last_name: item.second_last_name
                      ? item.second_last_name
                      : "",
                    birthdate: item.birthdate
                      ? new Date(toDate(item.birthdate))
                      : new Date(),
                    antiguedad: item.antiguedad
                      ? new Date(toDate(item.antiguedad))
                      : null,
                    sex: item.sex ? item.sex : "",
                    full_name:
                      item.first_name +
                      " " +
                      item.last_name +
                      " " +
                      item.second_last_name,
                    smoker: item.smoker ? item.smoker : false,
                    policy_type: order.subforms.life.policy_type.id,
                  };
                } else {
                  asegurados_1.push(item);
                }
              }
            );
            var asegurados_life = _.map(asegurados_1, function (plife, i) {
              return {
                first_name: plife.first_name ? plife.first_name : "",
                last_name: plife.last_name ? plife.last_name : "",
                second_last_name: plife.second_last_name
                  ? plife.second_last_name
                  : "",
                birthdate: plife.birthdate
                  ? new Date(toDate(plife.birthdate))
                  : new Date(),
                antiguedad: plife.antiguedad
                  ? new Date(toDate(plife.antiguedad))
                  : null,
                sex: plife.sex ? plife.sex : "",
                full_name:
                  plife.first_name +
                  " " +
                  plife.last_name +
                  " " +
                  plife.second_last_name,
                smoker: plife.smoker ? plife.smoker : false,
                policy_type: order.subforms.life.policy_type.id,
              };
            });
            $scope.dataToSave.life_policy = [
              {
                personal: {
                  first_name: aseguradosList[0].first_name,
                  last_name: aseguradosList[0].last_name,
                  second_last_name: aseguradosList[0].second_last_name,
                  birthdate: aseguradosList[0].birthdate,
                  antiguedad: aseguradosList[0].antiguedad
                    ? aseguradosList[0].antiguedad
                    : null,
                  sex: aseguradosList[0].sex,
                  full_name:
                    aseguradosList[0].first_name +
                    " " +
                    aseguradosList[0].last_name +
                    " " +
                    aseguradosList[0].second_last_name,
                  smoker: aseguradosList[0].smoker
                    ? aseguradosList[0].smoker
                    : false,
                  policy_type: order.subforms.life.policy_type.id,
                },
                personal_life: asegurados_life,
                smoker: order.subforms.life.smoker,
                beneficiaries_life: beneficiariesList,
              },
            ];
          } else {
            var aseguradosList = _.map(
              order.subforms.life.aseguradosList,
              function (item, i) {
                return {
                  first_name: item.first_name ? item.first_name : "",
                  last_name: item.last_name ? item.last_name : "",
                  second_last_name: item.second_last_name
                    ? item.second_last_name
                    : "",
                  birthdate: item.birthdate
                    ? new Date(toDate(item.birthdate))
                    : new Date(),
                  antiguedad: item.antiguedad
                    ? new Date(toDate(item.antiguedad))
                    : null,
                  sex: item.sex ? item.sex : "",
                  full_name:
                    item.first_name +
                    " " +
                    item.last_name +
                    " " +
                    item.second_last_name,
                  smoker: aseguradosList[0].smoker
                    ? aseguradosList[0].smoker
                    : false,
                  policy_type: order.subforms.life.policy_type.id,
                };
              }
            );
            $scope.dataToSave.life_policy = {
              // personal: {
              //   first_name: order.subforms.life.first_name,
              //   last_name: order.subforms.life.last_name,
              //   second_last_name : order.subforms.life.second_last_name,
              //   birthdate : new Date(toDate(order.subforms.life.birthdate)),
              //   sex: order.subforms.life.sex,
              //   full_name: order.subforms.life.first_name + ' ' + order.subforms.life.last_name + ' ' + order.subforms.life.second_last_name
              // },
              personal: aseguradosList,
              smoker: aseguradosList[0].smoker,
              beneficiaries_life: order.subforms.life.beneficiariesList,
            };
          }

          $scope.dataToSave.automobiles_policy = new Array();
          $scope.dataToSave.damages_policy = new Array();
          $scope.dataToSave.accidents_policy = new Array();
          break;
        case 30:
          // if (order.subforms.life.beneficiariesList.length === 0 && order.defaults.formInfo.code === 30) {
          //   l.stop();
          //   SweetAlert.swal("Error", MESSAGES.ERROR.ONEBENEFICIARY, "error");
          //   // $scope.formatReceiptsAtError();
          //   $scope.formatReceipts();
          //   return;
          // }

          // if (helpers.beneficiariesPercentageGreaterThanZero(order.subforms.life.beneficiariesList)) {
          //   l.stop();
          //   SweetAlert.swal("Error", MESSAGES.ERROR.GREATERTHAN100, "error");
          //   return;
          // }

          if (order.form.subramo.subramo_code == 30) {
            var beneficiariesList = _.map(
              order.subforms.life.beneficiariesList,
              function (item, i) {
                return {
                  first_name: item.first_name ? item.first_name : "",
                  last_name: item.last_name ? item.last_name : "",
                  second_last_name: item.second_last_name
                    ? item.second_last_name
                    : "",
                  optional_relationship: item.optional_relationship
                    ? item.optional_relationship
                    : "",
                  birthdate: item.birthdate
                    ? new Date(toDate(item.birthdate))
                    : new Date(),
                  antiguedad: item.antiguedad
                    ? new Date(toDate(item.antiguedad))
                    : null,
                  sex: item.sex ? item.sex : "",
                  percentage: item.percentage
                    ? parseFloat(item.percentage).toFixed(2)
                    : 100,
                  person: item.person,
                  rfc: item.rfc ? item.rfc : "",
                  j_name: item.j_name ? item.j_name : "",
                };
              }
            );
            var asegurados_1 = [];
            var aseguradosList = _.map(
              order.subforms.life.aseguradosList,
              function (item, i) {
                if (i == 0) {
                  return {
                    first_name: item.first_name ? item.first_name : "",
                    last_name: item.last_name ? item.last_name : "",
                    second_last_name: item.second_last_name
                      ? item.second_last_name
                      : "",
                    birthdate: item.birthdate
                      ? new Date(toDate(item.birthdate))
                      : new Date(),
                    antiguedad: item.antiguedad
                      ? new Date(toDate(item.antiguedad))
                      : null,
                    sex: item.sex ? item.sex : "",
                    full_name:
                      item.first_name +
                      " " +
                      item.last_name +
                      " " +
                      item.second_last_name,
                    smoker: item.smoker ? item.smoker : false,
                    policy_type: order.subforms.life.policy_type
                      ? order.subforms.life.policy_type.id
                      : null,
                  };
                } else {
                  asegurados_1.push(item);
                }
              }
            );
            var asegurados_life = _.map(asegurados_1, function (plife, i) {
              return {
                first_name: plife.first_name ? plife.first_name : "",
                last_name: plife.last_name ? plife.last_name : "",
                second_last_name: plife.second_last_name
                  ? plife.second_last_name
                  : "",
                birthdate: plife.birthdate
                  ? new Date(toDate(plife.birthdate))
                  : new Date(),
                antiguedad: plife.antiguedad
                  ? new Date(toDate(plife.antiguedad))
                  : null,
                sex: plife.sex ? plife.sex : "",
                full_name:
                  plife.first_name +
                  " " +
                  plife.last_name +
                  " " +
                  plife.second_last_name,
                smoker: plife.smoker ? plife.smoker : false,
                policy_type: order.subforms.life.policy_type
                  ? order.subforms.life.policy_type.id
                  : null,
              };
            });
            $scope.dataToSave.life_policy = [
              {
                personal: {
                  first_name: aseguradosList[0].first_name,
                  last_name: aseguradosList[0].last_name,
                  second_last_name: aseguradosList[0].second_last_name,
                  birthdate: aseguradosList[0].birthdate,
                  antiguedad: aseguradosList[0].antiguedad
                    ? aseguradosList[0].antiguedad
                    : null,
                  sex: aseguradosList[0].sex,
                  full_name:
                    aseguradosList[0].first_name +
                    " " +
                    aseguradosList[0].last_name +
                    " " +
                    aseguradosList[0].second_last_name,
                  smoker: aseguradosList[0].smoker
                    ? aseguradosList[0].smoker
                    : false,
                  policy_type: order.subforms.life.policy_type
                    ? order.subforms.life.policy_type.id
                    : null,
                },
                personal_life: asegurados_life,
                smoker: order.subforms.life.smoker,
                beneficiaries_life: beneficiariesList.length
                  ? beneficiariesList
                  : [],
              },
            ];
          } else {
            var aseguradosList = _.map(
              order.subforms.life.aseguradosList,
              function (item, i) {
                return {
                  first_name: item.first_name ? item.first_name : "",
                  last_name: item.last_name ? item.last_name : "",
                  second_last_name: item.second_last_name
                    ? item.second_last_name
                    : "",
                  birthdate: item.birthdate
                    ? new Date(toDate(item.birthdate))
                    : new Date(),
                  antiguedad: item.antiguedad
                    ? new Date(toDate(item.antiguedad))
                    : new Date(),
                  sex: item.sex ? item.sex : "",
                  full_name:
                    item.first_name +
                    " " +
                    item.last_name +
                    " " +
                    item.second_last_name,
                  smoker: aseguradosList[0].smoker
                    ? aseguradosList[0].smoker
                    : false,
                  policy_type: order.subforms.life.policy_type.id,
                };
              }
            );
            $scope.dataToSave.life_policy = {
              // personal: {
              //   first_name: order.subforms.life.first_name,
              //   last_name: order.subforms.life.last_name,
              //   second_last_name : order.subforms.life.second_last_name,
              //   birthdate : new Date(toDate(order.subforms.life.birthdate)),
              //   sex: order.subforms.life.sex,
              //   full_name: order.subforms.life.first_name + ' ' + order.subforms.life.last_name + ' ' + order.subforms.life.second_last_name
              // },
              personal: aseguradosList,
              smoker: aseguradosList[0].smoker,
              beneficiaries_life: order.subforms.life.beneficiariesList.length
                ? order.subforms.life.beneficiariesList
                : [],
            };
            try {
              if (
                $scope.dataToSave &&
                $scope.dataToSave.life_policy &&
                $scope.dataToSave.life_policy.beneficiaries_life
              ) {
                $scope.dataToSave.life_policy.beneficiaries_life.forEach(
                  function (item, index) {
                    var sx = item.sex;
                    if (angular.isObject(sx)) {
                      sx = sx.value || sx.val || sx.code || sx.sex || "";
                    }
                    if (angular.isString(sx)) {
                      var u = sx.toUpperCase().trim();
                      if (u.indexOf("FEM") === 0) sx = "F";
                      else if (u.indexOf("MAS") === 0) sx = "M";
                    }
                    item.sex = sx || "";
                  }
                );
              }
            } catch (u) {}
          }

          $scope.dataToSave.automobiles_policy = new Array();
          $scope.dataToSave.damages_policy = new Array();
          $scope.dataToSave.accidents_policy = new Array();
          break;

        case 9:
          if (!order.subforms.auto.year) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", MESSAGES.ERROR.AUTOFORM, "error");
            return;
          }
          if (!order.subforms.auto.version) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", MESSAGES.ERROR.AUTOFORM, "error");
            return;
          }
          if (!order.subforms.auto.usage) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", MESSAGES.ERROR.AUTOUSAGE, "error");
            return;
          }
          if (!order.subforms.auto.policy_type) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORTYPEAUTO, "error");
            return;
          }
          if (!order.subforms.auto.service) {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", MESSAGES.ERROR.AUTOSERVICE, "error");
            return;
          }
          if (order.subforms.auto.serial) {
            $scope.dataToSave.automobiles_policy = [
              {
                driver: order.subforms.auto.driver,
                brand: order.subforms.auto.brand,
                model: order.subforms.auto.model,
                year: parseInt(order.subforms.auto.year),
                version: order.subforms.auto.version,
                serial: order.subforms.auto.serial,
                engine: order.subforms.auto.engine,
                procedencia: order.subforms.auto.procedencia
                  ? order.subforms.auto.procedencia.id
                  : 0,
                charge_type: order.subforms.auto.charge_type
                  ? order.subforms.auto.charge_type
                  : 0,
                color: order.subforms.auto.color,
                license_plates: order.subforms.auto.license_plates,
                usage: order.subforms.auto.usage,
                service: order.subforms.auto.service,
                policy_type: order.subforms.auto.policy_type.id,
                beneficiary_name: order.subforms.auto.beneficiary_name,
                beneficiary_address: order.subforms.auto.beneficiary_address,
                beneficiary_rfc: order.subforms.auto.beneficiary_rfc,
                email: "",
                document_type: 1,
                adjustment: order.subforms.auto.adjustment,
                mont_adjustment: order.subforms.auto.mont_adjustment,
                special_team: order.subforms.auto.special_team,
                mont_special_team: order.subforms.auto.mont_special_team,
              },
            ];

            $scope.dataToSave.life_policy = new Array();
            $scope.dataToSave.damages_policy = new Array();
            $scope.dataToSave.accidents_policy = new Array();
          } else {
            l.stop();
            $scope.enproceso = false;
            SweetAlert.swal("Error", MESSAGES.ERROR.AUTOFORM, "error");
            return;
            $scope.error_format_receipts = true;
            return;
          }

          break;

        default:
          if (order.form.ramo.ramo_code == 2) {
            // Accidentes y enfermedades.
            var type = helpers.diseaseType(order.defaults.formInfo.code);
            if (order.subforms.disease.relationshipList) {
              var relationsList = [];

              for (
                var i = 0;
                i < order.subforms.disease.relationshipList.length;
                i++
              ) {
                var item = order.subforms.disease.relationshipList[i];

                if (
                  !item.first_name ||
                  !item.last_name ||
                  !item.birthdate ||
                  !item.relationship ||
                  !item.sex
                ) {
                  $scope.return = true;
                  l.stop();
                  $scope.enproceso = false;
                  SweetAlert.swal(
                    "Error",
                    "Ingrese datos de Dependientes",
                    "error"
                  );
                  return; // 🔴 Esto detiene TODO
                }

                relationsList.push({
                  first_name: item.first_name,
                  last_name: item.last_name,
                  second_last_name: item.second_last_name,
                  relationship: item.relationship.relationship,
                  birthdate: new Date(toDate(item.birthdate)),
                  antiguedad: item.antiguedad
                    ? new Date(toDate(item.antiguedad))
                    : null,
                  sex: item.sex.value,
                });
              }

              // Continúas usando relationsList si todo fue válido
            }

            // if (order.subforms.disease.relationshipList) {

            //   var relationsList = _.map(order.subforms.disease.relationshipList, function (item, i) {
            //     if (!item.first_name || !item.last_name || !item.birthdate || !item.relationship || !item.sex) {
            //       $scope.return = true
            //       l.stop();
            //       $scope.enproceso=false;
            //       SweetAlert.swal("Error","Ingrese datos de Dependientes", "error")
            //       return;
            //     }else{
            //       return {
            //         first_name: item.first_name,
            //         last_name: item.last_name,
            //         second_last_name: item.second_last_name,
            //         relationship: item.relationship.relationship,
            //         birthdate: new Date(toDate(item.birthdate)),
            //         antiguedad: item.antiguedad ? new Date(toDate(item.antiguedad)) : null,
            //         sex : item.sex.value
            //       };
            //     }
            //   });
            // }

            $scope.dataToSave.accidents_policy = [
              {
                personal: {
                  first_name: order.subforms.disease.first_name
                    ? order.subforms.disease.first_name
                    : "",
                  last_name: order.subforms.disease.last_name
                    ? order.subforms.disease.last_name
                    : "",
                  second_last_name: order.subforms.disease.second_last_name
                    ? order.subforms.disease.second_last_name
                    : "",
                  birthdate: order.subforms.disease.birthdate
                    ? new Date(toDate(order.subforms.disease.birthdate))
                    : new Date(),
                  antiguedad: order.subforms.disease.antiguedad
                    ? new Date(toDate(order.subforms.disease.antiguedad))
                    : new Date(),
                  sex: order.subforms.disease.sex
                    ? order.subforms.disease.sex
                    : "M",
                  full_name: order.subforms.disease.first_name
                    ? order.subforms.disease.first_name +
                      " " +
                      order.subforms.disease.last_name +
                      " " +
                      order.subforms.disease.second_last_name
                    : "",
                  policy_type: order.subforms.disease.policy_type.id,
                },
                disease_type: type,
                relationship_accident: relationsList,
              },
            ];
            $scope.dataToSave.life_policy = new Array();
            $scope.dataToSave.damages_policy = new Array();
            $scope.dataToSave.automobiles_policy = new Array();
          } else if (order.form.ramo.ramo_code == 3) {
            // Danios
            var type = helpers.damageType(
              parseInt(order.form.subramo.subramo_code)
            );
            $scope.dataToSave.damages_policy = [
              {
                damage_type: order.subforms.damage.policy_type
                  ? order.subforms.damage.policy_type.id
                  : 0,
                insured_item: order.subforms.damage.insured_item,
                item_address: order.subforms.damage.item_address,
                item_details: order.subforms.damage.item_details,
              },
            ];

            $scope.dataToSave.life_policy = new Array();
            $scope.dataToSave.accidents_policy = new Array();
            $scope.dataToSave.automobiles_policy = new Array();
          }

          break;
      }

      // COBERTURAS
      var coverages = [];
      order.coverageInPolicy_policy.forEach(function (item, index, array) {
        var prima = "";
        var coinsurance = "";
        var deductible = "";
        var sumInPolicy = "";
        var topecoinsurance = "";

        if (item.primaInPolicy) {
          prima = item_address.primaInPolicy.value
            ? item_address.primaInPolicy.value
            : "";
        }

        if (item.coinsuranceInPolicy) {
          coinsurance = item.coinsuranceInPolicy.value
            ? item.coinsuranceInPolicy.value
            : "";
        }

        if (item.topeCoinsuranceInPolicy) {
          topecoinsurance = item.topeCoinsuranceInPolicy.value
            ? item.topeCoinsuranceInPolicy.value
            : "";
        }

        if (item.deductibleInPolicy) {
          deductible = item.deductibleInPolicy.value;
        }
        if (item.sumInPolicy) {
          sumInPolicy = item.sumInPolicy.value;
        }

        var obj = {
          package: $scope.dataToSave.paquete,
          coverage_name: item.coverage_name,
          priority: item.priority ? item.priority : 0,
          sum_insured: sumInPolicy,
          deductible: deductible,
          prima: prima,
          coinsurance: coinsurance,
          topecoinsurance: topecoinsurance,
        };
        coverages.push(obj);
        if (index === array.length - 1) {
          $scope.dataToSave.coverageInPolicy_policy = coverages;
        }
      });
    }

    $scope.changeIva = function (parValue) {
      if (!parValue) {
        swal("La póliza se creará sin IVA.");
        //order.poliza.iva = 0;
      }
    };

    $scope.identifier = function (parValue) {
      if (
        order.form.identifier &&
        order.form.identifier != "" &&
        order.form.identifier != undefined
      ) {
        return;
      }

      if (order.form.paquete) {
        order.form.identifier = order.form.paquete.package_name;
      }
      if (
        order.subforms &&
        order.subforms.life &&
        order.subforms.life.second_last_name
      ) {
        // vida
        if (order.form.paquete.package_name) {
          order.form.identifier =
            order.subforms.life.first_name +
            "_" +
            order.subforms.life.last_name +
            "_" +
            order.subforms.life.second_last_name +
            "-" +
            order.form.paquete.package_name;
        }
      } else if (
        order.subforms &&
        order.subforms.damage &&
        order.subforms.damage.insured_item
      ) {
        if (order.form.paquete.package_name) {
          order.form.identifier =
            order.subforms.damage.insured_item +
            "-" +
            order.form.paquete.package_name;
        }
      } else if (order.subforms) {
        if (
          (order.subforms &&
            order.subforms.disease &&
            order.subforms.disease.first_name) ||
          (order.subforms.disease && order.subforms.disease.last_name) ||
          (order.subforms.disease && order.subforms.disease.second_last_name)
        ) {
          // gastos medicos
          if (!order.subforms.disease && !order.subforms.disease.first_name) {
            order.subforms.disease.first_name = "";
          }
          if (!order.subforms.disease && !order.subforms.disease.last_name) {
            order.subforms.disease.last_name = "";
          }

          if (
            !order.subforms.disease &&
            !order.subforms.disease.second_last_name
          ) {
            order.subforms.disease.second_last_name = "";
          }

          if (order.form.paquete && order.form.paquete.package_name) {
            order.form.identifier =
              order.subforms.disease.first_name +
              "_" +
              order.subforms.disease.last_name +
              "_" +
              order.subforms.disease.second_last_name +
              "-" +
              order.form.paquete.package_name;
          }
        }
      } else if (order.subforms) {
        if (order.subforms.auto && order.subforms.auto.year) {
          // autos
          if (order.subforms.auto.model != undefined) {
            order.form.identifier =
              order.subforms.auto.model + "_" + order.subforms.auto.year;
            if (order.subforms.auto.brand != undefined) {
              order.form.identifier =
                order.subforms.auto.model +
                "_" +
                order.subforms.auto.brand +
                "_" +
                order.subforms.auto.year;
            }
          } else if (order.subforms.auto.brand != undefined) {
            order.form.identifier =
              order.subforms.auto.brand + "_" + order.subforms.auto.year;
            if (order.subforms.auto.model != undefined) {
              order.form.identifier =
                order.subforms.auto.model +
                "_" +
                order.subforms.auto.brand +
                "_" +
                order.subforms.auto.year;
            }
          } else if (
            order.subforms.auto.model != undefined &&
            order.subforms.auto.brand != undefined
          ) {
            order.form.identifier =
              order.subforms.auto.model +
              "_" +
              order.subforms.auto.brand +
              "_" +
              order.subforms.auto.year;
          } else {
            order.form.identifier = order.subforms.auto.year;
          }
        }
      } else {
        order.form.identifier = "";
      }
      if ($scope.orgName == "gpi") {
        order.form.identifier = "GENERAL";
      }
      $scope.saveLocalstorange();
    };

    $scope.year_auto = function (parValue) {
      if (order.form.identifier || order.form.identifier.length > 0) {
        return;
      }
      if (order.subforms.auto && order.subforms.auto.year) {
        // autos
        if (order.subforms.auto.model != undefined) {
          order.form.identifier =
            order.subforms.auto.model + "_" + order.subforms.auto.year;
          if (order.subforms.auto.brand != undefined) {
            order.form.identifier =
              order.subforms.auto.model +
              "_" +
              order.subforms.auto.brand +
              "_" +
              order.subforms.auto.year;
          }
        } else if (order.subforms.auto.brand != undefined) {
          order.form.identifier =
            order.subforms.auto.brand + "_" + order.subforms.auto.year;
          if (order.subforms.auto.model != undefined) {
            order.form.identifier =
              order.subforms.auto.model +
              "_" +
              order.subforms.auto.brand +
              "_" +
              order.subforms.auto.year;
          }
        } else if (
          order.subforms.auto.model != undefined &&
          order.subforms.auto.brand != undefined
        ) {
          order.form.identifier =
            order.subforms.auto.model +
            "_" +
            order.subforms.auto.brand +
            "_" +
            order.subforms.auto.year;
        } else {
          order.form.identifier = order.subforms.auto.year;
        }
      } else {
        order.form.identifier = "";
        if (order.form.paquete) {
          order.form.identifier = order.form.paquete.package_name;
        }
      }
      if ($scope.orgName == "gpi") {
        order.form.identifier = "GENERAL";
      }
    };

    $scope.changeIdentifier = function (parValue) {
      order.form.identifier = parValue;
    };
    $scope.percentage_life = function (input, index, ben) {
      try {
        input = parseFloat(input).toFixed(2);
      } catch (e) {
        input = 0;
      }
      if (input < 0) {
        order.subforms.life.beneficiariesList[index].percentage = 0;
      }
      if (input > 100) {
        order.subforms.life.beneficiariesList[index].percentage = 100;
      }
      if (
        order.subforms.life.beneficiariesList[index].percentage == undefined
      ) {
        order.subforms.life.beneficiariesList[index].percentage = 0;
      }
      ben.percentage = parseFloat(input).toFixed(2);
      order.subforms.life.beneficiariesList[index].percentage = ben.percentage;
      if (ben.percentage == "NaN") {
        ben.percentage = parseFloat(0).toFixed(2);
        order.subforms.life.beneficiariesList[index].percentage =
          ben.percentage;
      }
      if (
        parseFloat(
          order.subforms.life.beneficiariesList[index].percentage
        ).toFixed(2) > 100.0
      ) {
        ben.percentage = 0.0;
        order.subforms.life.beneficiariesList[index].percentage = 0.0;
        SweetAlert.swal(
          "Error",
          "El porcentaje del beneficiario" +
            index +
            ", no puede ser mayor a 100.00.",
          "info"
        );
        // return
      }
      if (
        helpers.beneficiariesPercentageGreaterThanZero(
          order.subforms.life.beneficiariesList
        )
      ) {
        $scope.enproceso = false;
        SweetAlert.swal(
          "Error",
          "Revise los porcentajes de los beneficiarios (la suma no debe pasar de 100)",
          "info"
        );
        return;
      }
    };

    $scope.calculate = function (poliza) {
      if (!poliza.derecho) {
        poliza.derecho = 0;
      }

      if (!poliza.rpf) {
        poliza.rpf = 0;
      }

      var prima_neta = parseFloat(poliza.primaNeta);
      var derecho = parseFloat(poliza.derecho);
      var rpf = parseFloat(poliza.rpf);
      var descuento = parseFloat(poliza.descuento);

      $scope.dataToSave.p_neta = prima_neta;
      $scope.dataToSave.derecho = derecho;
      $scope.dataToSave.rpf = rpf;
      $scope.dataToSave.descuento = descuento;

      var IVA = 0;
      var TOTAL_IVA = 1;

      if (order.poliza.ivaStatus) {
        IVA = 16;
        order.poliza.iva = 16;
        TOTAL_IVA = 1.16;
        var pointIva = 0.16;
      } else {
        IVA = 0;
        order.poliza.iva = 0;
        var pointIva = 0;
      }

      //$scope.dataToSave.iva = IVA;
      var poliza_iva = (prima_neta + derecho + rpf) * 0.16;
      $scope.dataToSave.iva = poliza_iva.toFixed(2);
      if (order.poliza.ivaStatus) {
        order.poliza.iva = $scope.dataToSave.iva;
      } else {
        order.poliza.iva = 0;
      }

      if (!order.form.payment) {
        SweetAlert.swal("Error", "El número de póliza ya existe", "error");
        toaster.info(MESSAGES.ERROR.SELPAY);
      } else {
        // TODO: checar esta funciÃƒÂ³n
        function getNumber(num) {
          var num2 = Math.ceil(num);
          return new Array(num2);
        }

        function getSubtotal(poliza) {
          var sum = prima_neta + rpf + derecho;
          return Number(sum.toFixed(2));
        }

        function getTotal(poliza) {
          $scope.dataToSave.p_total = parseFloat(
            poliza.subTotal * TOTAL_IVA
          ).toFixed(2);
          var p_total = (poliza.subTotal * TOTAL_IVA).toFixed(2);
          p_total = p_total.toFixed(2);
          return parseFloat(p_total);
        }

        function getIva(parValue) {
          var iva = parValue * pointIva;
          return parseFloat(iva).toFixed(2);
        }

        function comissionCalc(parPneta) {
          // var p_neta_ = parseFloat(parPneta);
          var p_neta_ = parPneta;

          if (order.form.comision) {
            var comision_ = parseFloat(order.form.comision.comission) / 100;
            comision_ = comision_.toFixed(2);
          } else {
            var comision_ = 0;
          }

          var result = parseFloat(p_neta_ * comision_).toFixed(2);
          return result;
        }

        order.receipts = [];
        order.defaults.showReceipts = true;

        // var initDate = toDate(order.form.startDate);
        // var endDate = toDate(order.form.endingDate);
        var initDate = new Date($scope.dataToSave.start_of_validity);
        var endDate = new Date($scope.dataToSave.end_of_validity);

        var months = helpers.monthDiff(initDate, endDate);
        // Calculate diff between dates
        var dateDiff = moment(endDate).diff(moment(initDate), "days");
        var amountReceipts = (order.amountReceipts =
          months / order.form.payment.value);
        //Calculate poliza results
        order.poliza.subTotal = getSubtotal(order.poliza);
        order.poliza.primaTotal = getTotal(order.poliza);
        order.poliza.iva = getIva(order.poliza.subTotal);
        amountReceipts = Math.ceil(amountReceipts);

        var prima_neta_total = 0;

        var arrayLen = getNumber(amountReceipts);
        // Logic from vm
        var obj = {
          prima: order.poliza.primaNeta / amountReceipts,
          rpf: order.poliza.rpf / amountReceipts,
          derecho: order.poliza.derecho / amountReceipts,
          iva: order.poliza.iva,
          subTotal: order.poliza.subTotal / amountReceipts,
          primaTotal: order.poliza.primaTotal / amountReceipts,
        };

        for (var i = 0; i < arrayLen.length; i++) {
          // Check options
          if (order.configDerecho) {
            if (i === 0) {
              if (order.poliza.derecho) {
                obj.derecho = parseFloat(order.poliza.derecho);
              } else {
                obj.derecho = 0;
              }
            } else {
              obj.derecho = 0;
            }
          }

          if (order.configRPF) {
            if (i === 0) {
              if (obj.rpf) {
                obj.rpf = parseFloat(order.poliza.rpf);
              } else {
                obj.rpf = 0;
              }
            } else {
              obj.rpf = 0;
            }
          }

          endDate = new Date(
            new Date(
              moment(initDate).add(order.form.payment.value, "months")
            ).setHours(11, 59, 59)
          );
          var subTotal = obj.prima + obj.rpf + obj.derecho;

          prima_neta_total + parseFloat(obj.prima.toFixed(2));

          var receipt = {
            recibo_numero: i + 1,
            prima_neta: parseFloat(obj.prima.toFixed(2)),
            prima: parseFloat(obj.prima.toFixed(2)),
            rpf: parseFloat(obj.rpf.toFixed(2)),
            derecho: parseFloat(obj.derecho.toFixed(2)),
            iva: getIva(subTotal),
            subTotal: parseFloat(subTotal.toFixed(2)),
            prima_total: parseFloat((subTotal * 1.16).toFixed(2)),
            total: parseFloat((subTotal * TOTAL_IVA).toFixed(2)),
            receipt_type: 1,
            comision: comissionCalc(parseFloat(obj.prima.toFixed(2))),
          };

          $scope.iva_currency = receipt.subTotal * 0.16;

          if (dateDiff === 364 || dateDiff === 365 || dateDiff === 366) {
            receipt.fecha_inicio = convertDate(initDate);
            receipt.startDate = convertDate(initDate);
            receipt.endingDate = convertDate(endDate);
            receipt.fecha_fin = convertDate(endDate);
          } else {
            receipt.startDate = "";
            receipt.endingDate = "";
            receipt.fecha_inicio = "";
            receipt.fecha_fin = "";
          }
          initDate = endDate;

          order.receipts.push(angular.copy(receipt));
          $scope.dataToSave.recibos_poliza = order.receipts;
        }

        if (!order.receipts[0].startDate) {
          SweetAlert.swal("Error", MESSAGES.INFO.MANUALLYDATES, "warning");
          // toaster.warning("Agregar manualmente las fechas.");
        }
      }
    };

    order.receipts = [];
    order.defaults.showReceipts = false;
    // order.default.showReceipts = order.show.generateReceipts;
    order.amountReceipts = 0;
    order.poliza = {
      iva: 16,
      subTotal: "",
      primaTotal: "",
    };

    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    $scope.sucursal = function (sc) {
      console.log("sucrsals", sc);
    };
    activate();
    getInternalNumber();

    $scope.statesArray = [];

    function removeCircularReferences(obj) {
      var seen = new WeakSet();
      return JSON.parse(
        JSON.stringify(obj, function (key, value) {
          if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
              return; // Skip circular reference
            }
            seen.add(value);
          }
          return value;
        })
      );
    }
    function recuperarArchivo() {
      if (!$localStorage.archivoBase64) return null;
      var binary = atob($localStorage.archivoBase64);
      var len = binary.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return new File([bytes], $localStorage.archivoNombre, {
        type: $localStorage.archivoTipo,
      });
    }
    function activate() {
      $scope.yaseestableciopaquete = false;
      restoreActiveTab();
      if ($localStorage.orderFormCotizacion) {
        var cotizacion = $localStorage.orderFormCotizacion;
        $scope.cotizacion_formulario = $localStorage.orderFormCotizacion;
        if (cotizacion.prospecto == 2) {
          var cotizacion_contratante = cotizacion.contractor;

          $scope.show_contratante = "contractors-match/";
          $http
            .post(__url.IP + $scope.show_contratante, {
              matchWord: cotizacion_contratante,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data.contractors) {
                var source = [];
                var contratactorsFound = response.data.contractors;

                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    if (obj.label == cotizacion_contratante) {
                      order.form.contratante = obj;
                    }
                    source.push(obj);
                  });
                }

                $scope.contractors_data = source;
              }
            });
        }
        // order.form.aseguradora
        order.defaults.providers.forEach(function (aseg) {
          if (aseg.alias == cotizacion.aseguradora_seleccionada) {
            order.form.aseguradora = aseg;
          }
        });
      }
      dataFactory
        .get("sucursales-to-show-unpag/")
        .then(function success(response) {
          $scope.sucursalList = response.data;
        });
      var url_ = $location.path();
      if (url_.indexOf("editar") > -1) {
        $scope.frec_disabled = true;
        order.form.is_edit = true;
      } else {
        $scope.frec_disabled = false;
        order.form.is_edit = false;
      }

      var params = {
        start_date: order.form.startDate,
      };

      var d = order.form.startDate;
      var curr_date = d.getDate();
      var curr_month = d.getMonth() + 1; //Months are zero based
      var curr_year = d.getFullYear();
      var date = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(date).then(
        function success(data) {
          order.defaults.providers = data.data;
          if ($scope.cotizador) {
            $scope.cargarPolizaMulticotizador();
          }
          if ($localStorage.orderFormCotizacion) {
            order.defaults.providers.forEach(function (aseg) {
              if (
                aseg.alias ==
                $localStorage.orderFormCotizacion.aseguradora_seleccionada
              ) {
                order.form.aseguradora = aseg;
                $scope.aseguradoraSelection();
              }
            });
          }

          restorePdfDataFromStorage();
        },
        function error(err) {
          console.log("error", err);
        }
      );

      // dataFactory.get('celula_contractor/')
      dataFactory.post("celula_contractor_info/").then(function (response) {
        $scope.celulas = response.data;
      });

      dataFactory.get("groupingLevel-resume/").then(function (response) {
        $scope.agrupaciones = response.data;
      });
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          $scope.statesArray = data.data;
        });
    }

    function parseStoredPdf(rawPdf) {
      if (!rawPdf) {
        return null;
      }
      if (typeof rawPdf === "string") {
        try {
          rawPdf = JSON.parse(rawPdf);
        } catch (error) {
          return null;
        }
      }
      if (rawPdf && rawPdf.data) {
        return rawPdf;
      }
      return null;
    }

    function restorePdfDataFromStorage() {
      if ($scope.read_pdf && $scope.read_pdf.data) {
        return;
      }
      var storedPdf = parseStoredPdf($localStorage["datos_pdf"]);
      if (!storedPdf) {
        storedPdf = parseStoredPdf(localStorage.getItem("datos_pdf"));
      }
      if (storedPdf) {
        $scope.cargarInformacion(storedPdf);
      }
    }

    $scope.saveLocalstorange = function () {};

    // $scope.addReferenciador();
    if ($scope.referenciadores) {
    } else {
      $scope.referenciadores = [$scope.referenciador];
    }
    var myInsurance = $stateParams.myInsurance;
    if (myInsurance.url) {
      var contrac = {};
      contrac.contratanteId = myInsurance.id;
      if (myInsurance.type_person == 1) {
        contrac.type = "fisicas";
      }
      if (myInsurance.type_person == 2) {
        contrac.type = "morales";
      }
      ContratanteService.getContratanteFull(contrac).then(function (
        contractor
      ) {
        order.form.contratante = contractor;
        if (contractor.first_name) {
          order.form.contratante.val =
            contractor.first_name +
            " " +
            contractor.last_name +
            " " +
            contractor.second_last_name;
        }
        if (contractor.full_name) {
          order.form.contratante.val = contractor.full_name;
        }
        // if(contractor.address_natural){
        if (contractor.address_contractor) {
          order.defaults.address = contractor.address_contractor;
        }
        // if(contractor.address_juridical){
        //   order.defaults.address = contractor.address_juridical;
        // }
        order.form.address = order.defaults.address[0];
        order.form.contratante.value = contractor;
        if (order.form.contratante.value.celula) {
          $http
            .get(order.form.contratante.value.celula)
            .then(function success(respo) {
              order.form.celula = respo.data;
            });
        }
        $scope.info_sub = order.form.contratante.value;
        if (order.form.contratante.value.groupinglevel) {
          $http
            .get(order.form.contratante.value.groupinglevel)
            .then(function success(respons) {
              if (respons.data.type_grouping == 3) {
                $scope.info_sub.subsubgrouping = respons.data.description;
                $http.get(respons.data.parent).then(function success(respon) {
                  $scope.info_sub.subgrouping = respon.data.description;
                  $http.get(respon.data.parent).then(function success(respo) {
                    order.form.grouping_level = respo.data;
                    $scope.changeAgrupacion(respo.data);
                  });
                  order.form.subgrouping == respon.data;
                });
                order.form.subsubgrouping == respons.data;
              } else if (respons.data.type_grouping == 2) {
                $scope.info_sub.subgrouping = respons.data.description;
                $http.get(respons.data.parent).then(function success(respon) {
                  order.form.grouping_level = respon.data;
                  $scope.changeAgrupacion(respon.data);
                });
                order.form.subgrouping == respons.data;
              } else if (respons.data.type_grouping == 1) {
                order.form.grouping_level = respons.data;
                $scope.changeAgrupacion(respons.data);
              }
            });
        }
        if (
          !$scope.read_pdf ||
          $scope.read_pdf == undefined ||
          Object.keys($scope.read_pdf).length === 0
        ) {
          order.form.startDate = convertDate(new Date());
          order.options.checkDate();
        }
        // setTimeout(function() {
        $http.get(url.IP + "get-vendors/").then(function (user) {
          if (
            order &&
            order.form &&
            order.form.contratante &&
            order.form.contratante.value &&
            order.form.contratante.value.vendor &&
            order.form.contratante.value.vendor.url
          ) {
            user.data.forEach(function (user) {
              if (user.url == order.form.contratante.value.vendor.url) {
                order.form.vendor = user.id;
                $scope.referenciadores[0] = {
                  referenciador: user.url,
                };
              }
            });
          }
        });
        // }, 2000);
      });
    }

    $rootScope.show_contractor = false;
    $scope.$watch(
      function () {
        return $rootScope.show_contractor;
      },
      function (newValue, oldValue) {
        if (oldValue && !newValue) {
          restoreActiveTab();
        }
      }
    );
    $scope.returnToPolicy = function () {
      $rootScope.show_contractor = false;
      restoreActiveTab();
    };

    $scope.validarEmail = function (item) {
      if (!validateEmail(item)) {
        SweetAlert.swal(
          "Error",
          "El formato del correo es invalido",
          "warning"
        );
      }

      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
    };

    // modal para crear el nuevo contratante
    function contratanteCreatorModalEvent() {
      // if (angular.isNumber($scope.activeJustified)) {
      //   persistActiveTab($scope.activeJustified);
      // }
      $localStorage.serieDetectada = $scope.serieDetectada;
      $rootScope.show_contractor = true;
      $scope.orderInfo = order;
      $localStorage.orderForm = JSON.stringify(order.form);
      // var modalInstance = $uibModal.open({
      //     templateUrl: 'app/modals/modal.contratante.create.html',
      //     controller: 'ContratantesCtrl',
      //     controllerAs: 'vm',
      //     size: 'lg'
      // });
    }

    $scope.calculateComision = function (ref, index) {
      $rootScope.comVendedor = true;
      $scope.orderInfo = order;
      $localStorage.orderForm = JSON.stringify(order.form);
      var modalInstance = $uibModal.open({
        templateUrl: "app/ordenes/calculateComision.modal.html",
        controller: OrderComisionCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          referenciador: function () {
            return ref;
          },
          index: function () {
            return index;
          },
          form: function () {
            return order.form;
          },
          from: function () {
            return null;
          },
          primaTotal: function () {
            return order.poliza.primaTotal;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      //toaster.success(MESSAGES.OK.UPLOADFILES);
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
      $scope.okFile++;
      if ($scope.okFile == $scope.uploader.queue.length) {
        $timeout(function () {
          // $state.go('polizas.table');
          if (!$scope.flagCoverage) {
            if ($scope.param == "poliza") {
              // $scope.sendEmail_Emision();
              SweetAlert.swal(MESSAGES.OK.NEWPOLICY, "", "success");
            }
            if ($scope.param == "ot") {
              SweetAlert.swal(MESSAGES.OK.NEWOT, "", "success");
            }
            $state.go("polizas.info", { polizaId: $scope.idPolicy });
          } else {
            SweetAlert.swal(
              {
                title: "Advertencia",
                text: "Las coberturas sin sumas aseguradas ni deducibles, no se guardarán",
                type: "warning",
                showCancelButton: false,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Ok",
                cancelButtonText: "No",
                closeOnConfirm: false,
                closeOnCancel: true,
              },
              function (isConfirm) {
                if (isConfirm) {
                  if ($scope.param == "poliza") {
                    SweetAlert.swal(MESSAGES.OK.NEWPOLICY, "", "success");
                  }
                  if ($scope.param == "ot") {
                    SweetAlert.swal(MESSAGES.OK.NEWOT, "", "success");
                  }
                  $state.go("polizas.info", { polizaId: $scope.idPolicy });
                }
              }
            );
          }

          if ($uibModalInstance) {
            $uibModalInstance.close(200);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        // toaster.error(MESSAGES.ERROR.FILETOOLARGE);
        order.options.checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 2 });
      } else {
        // toaster.error(MESSAGES.ERROR.ERRORONUPLOADFILES);
        order.options.checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 1 });
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFilesPDF(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $scope.files = [];
      $scope.files_ = [];
      console.log("subir solo pdf", $scope.uploader);
      $timeout(function () {
        $scope.uploader.uploadAll();
        $scope.enproceso = false;
        $state.go("polizas.info", { polizaId: $scope.idPolicy });
      }, 1000);
    }
    function uploadFiles(polizaId) {
      try {
        var lm = Ladda.create(document.querySelector(".ladda-button"));
        lm.start();
      } catch (d) {}
      $scope.enproceso = true;
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $scope.files = [];
      $scope.files_ = [];
      $timeout(function () {
        $scope.uploader.uploadAll();
        $scope.enproceso = false;
        $state.go("polizas.info", { polizaId: $scope.idPolicy });
      }, 1000);
    }
    $scope.sendEmail_Emision = function (x) {
      if (
        $scope.poliza_creada.status != 1 ||
        $scope.poliza_creada.status != 2
      ) {
        //Send Email
        var contrac = {};
        if ($scope.poliza_creada.contractor) {
          if (order.form.contratante.type_person == 1) {
            contrac.type = "fisicas";
          } else if (order.form.contratante.type_person == 2) {
            contrac.type = "morales";
          }
          contrac.contratanteId = $scope.poliza_creada.contractor;
          contrac.url = $scope.poliza_creada.url;
        }
        ContratanteService.getContratanteFull(contrac).then(function (
          contractor
        ) {
          $scope.contratante = contractor;
          if ($scope.contratante.email) {
            if ($localStorage.email_config) {
              if ($localStorage.email_config.registro_pol == true) {
                var model = 2;
                emailService.sendEmailAtm(model, $scope.idPolicy);
              } else {
              }
            }
          }
        });
        //Send Email
        SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWPOLICY, "success");
      }
      if (
        $scope.poliza_creada.status == 1 ||
        $scope.poliza_creada.status == 2
      ) {
        //Send Email

        var contrac = {};
        if ($scope.poliza_creada.contractor) {
          if (order.form.contratante.type_person == 1) {
            contrac.type = "fisicas";
          } else if (order.form.contratante.type_person == 2) {
            contrac.type = "morales";
          }
          contrac.contratanteId = $scope.poliza_creada.contractor;
          contrac.url = $scope.poliza_creada.url;
        }
        ContratanteService.getContratanteFull(contrac).then(function (
          contractor
        ) {
          $scope.contratante = contractor;
          if ($scope.contratante.email) {
            if ($localStorage.email_config) {
              if ($localStorage.email_config.solicitud_pol == true) {
                var model = 1;
                emailService.sendEmailAtm(model, $scope.idPolicy);
              } else {
              }
            }
          }
        });
        //Send Email
        SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWOT, "success");
      }
    };

    //  function toDate(dateStr) {
    //     if (dateStr) {
    //       var dateString = dateStr; // Oct 23
    //       var dateParts = dateString.split("/");
    //       var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

    //       return dateObject;
    //     }
    //   }
    function toDate(dateStr) {
      if (typeof dateStr === "string") {
        if (dateStr.indexOf("T") !== -1) {
          // formato ISO
          return new Date(dateStr);
        }
        var dateParts = dateStr.split("/");
        if (dateParts.length === 3) {
          var day = parseInt(dateParts[0], 10);
          var month = parseInt(dateParts[1], 10) - 1; // meses comienzan en 0
          var year = parseInt(dateParts[2], 10);
          return new Date(year, month, day);
        }
      } else if (dateStr instanceof Date) {
        return dateStr; // ya es un objeto Date
      }
      return null;
    }

    function mesDiaAnio(parDate) {
      // console.log('parDate', parDate);
      var d = new Date(toDate(parDate));
      // console.log('d', d);
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      // console.log('date', date);
      return date;
    }
    // Calcular comisión ppor referenciador
    function OrderComisionCtrl(
      $scope,
      from,
      $sessionStorage,
      $uibModalInstance,
      referenciador,
      index,
      form,
      $http,
      MESSAGES,
      toaster,
      primaTotal
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $rootScope.valueMonto = primaTotal;
      $rootScope.valueComInicial = 0;
      $rootScope.valueComision = 0;
      if (referenciador) {
        $http.get(referenciador.referenciador).then(function (data) {
          if (data.status == 200 || data.status == 201) {
            if (data.data) {
              $rootScope.name =
                data.data.first_name + " " + data.data.last_name;
              if (data.data.user_info) {
                if (data.data.user_info.info_vendedor[0]) {
                  $rootScope.valueGo =
                    data.data.user_info.info_vendedor[0].gastos_operacion;
                }
              }
            }
          }
        });
      }
      // Change monto --> calc comision
      $scope.changeMonto = function (go, monto, com, comI) {
        if (isNaN(monto)) {
          var toNumber = $scope.formatearNumero(monto);
          if (isNaN(toNumber)) {
            $rootScope.valueMonto = "";
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        }
      };
      $scope.comCalculatePeso = function (monto, comision) {
        if (
          isNaN(monto) ||
          isNaN(comision) ||
          parseFloat(comision) > parseFloat(monto)
        ) {
          if (parseFloat(comision) > parseFloat(monto)) {
            SweetAlert.swal(
              "Error",
              "Cantidad capturada en comisión no puede ser mayor a la prima total",
              "error"
            );
            $rootScope.valueComision = 0;
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
          }
        } else {
          $rootScope.valueComision = parseFloat(
            (parseFloat(comision) * 100) / parseFloat(monto)
          ).toFixed(2);
        }
      };
      $scope.validComision = function (comI) {
        if (isNaN(comI)) {
          $rootScope.valueComInicial = 0;
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORFORMATNUMBER, "error");
        }
      };
      $scope.cTotal = function (monto, com, comVendedor) {
        referenciador.comision_vendedor = comVendedor;
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.cancelCalculate = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
      $scope.formatearNumero = function (nStr) {
        nStr += "";
        var x = nStr.split(".");
        var x1 = x[0];
        var x2 = x.length > 1 ? "." + x[1] : "";
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + "," + "$2");
        }
        return x1 + x2;
      };
    }
    function formattonumber(nStr, campo) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";

      var cadenas = x1.split(",");
      var cadena_sin_comas = "";
      for (i = 0; i < cadenas.length; i++) {
        cadena_sin_comas = cadena_sin_comas + cadenas[i];
      }
      if (
        cadena_sin_comas != undefined &&
        cadena_sin_comas != "undefined" &&
        cadena_sin_comas != "NaN" &&
        cadena_sin_comas != NaN
      ) {
        var value = cadena_sin_comas + x2.replace(/,/g, "");
        value = parseFloat(value).toLocaleString("en-US", {
          style: "decimal",
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });
        if (value == "NaN") {
          value = 0;
        }
        return value;
      } else {
        var value = nStr.replace(/,/g, "");
        value = parseFloat(value).toLocaleString("en-US", {
          style: "decimal",
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });
        if (value == "NaN") {
          value = 0;
        }
        return value;
      }
    }

    $scope.cargarPolizaMulticotizador = function () {
      console.log("cargarPolizaMulticotizador", $scope.cotizador);
      localStorage.setItem("pdf_generado", "");
      // order.form = {};
      order.subforms = {
        auto: {
          selectedCar: {},
        }, //template.formulario.automoviles
        life: {
          beneficiariesList: [{ person: 1 }],
          aseguradosList: [],
        }, //template.formulario.vida
        disease: {
          relationshipList: [],
        }, //template.formulario.accidentes
        damage: {
          coinsurance: "",
          insured_item: "",
          item_address: "",
          item_details: "",
        }, //template.formulario.danios
      };
      order.subforms.auto = order.subforms.auto || {};
      $scope.acceso_adm_ot = false;

      // var cotizador = localStorage.getItem('pdf_generado');
      //
      $scope.read_pdf = localStorage.getItem("datos_pdf");
      if ($scope.read_pdf) {
        console.log("$scope.read_pdf", $scope.read_pdf);

        $scope.read_pdf = JSON.parse($scope.read_pdf);
        showButtonPoliza();
        $timeout(restoreActiveTab);
        $scope.filePdf = {};
        if ($scope.read_pdf.data["Numero de poliza"]) {
          // console.log("ingreso Numero")
          order.form.poliza = $scope.read_pdf.data["Numero de poliza"];
        }
        if (
          $scope.read_pdf.data["Datos generales de la poliza"] &&
          $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
          $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
            "NACIONAL"
        ) {
          $scope.order.f_currency.f_currency_selected = 1;
          order.f_currency.f_currency_selected = 1;
        }
        if (
          $scope.read_pdf.data["Datos generales de la poliza"] &&
          $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
          ($scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
            "Dolares" ||
            $scope.read_pdf.data["Datos generales de la poliza"][
              "Moneda"
            ].toLowerCase() == "dolares")
        ) {
          $scope.order.f_currency.f_currency_selected = 2;
          order.f_currency.f_currency_selected = 2;
        }
        if (
          $scope.read_pdf.data["Datos generales de la poliza"] &&
          $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
          !$scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
            "EXTRANJERA"
        ) {
          order.f_currency.f_currency_selected = 2;
          $scope.order.f_currency.f_currency_selected = 2;
        }
        if (
          $scope.read_pdf.data["Datos generales de la poliza"] &&
          $scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] &&
          ($scope.read_pdf.data["Datos generales de la poliza"]["Moneda"] ==
            "udi" ||
            $scope.read_pdf.data["Datos generales de la poliza"][
              "Moneda"
            ].toLowerCase() == "udis")
        ) {
          $scope.order.f_currency.f_currency_selected = 3;
          order.f_currency.f_currency_selected = 3;
        }
        order.conducto_de_pago.conducto_de_pago_selected = 1;
        $scope.pintarCoberturas = true;

        order.form.payment =
          $scope.read_pdf.data["Datos generales de la poliza"]["Forma de pago"];
        if (!order.form.payment) {
          if (
            "Forma_de_Pago" in
            $scope.read_pdf.data["Datos generales de la poliza"]
          ) {
            order.form.payment =
              $scope.read_pdf.data["Datos generales de la poliza"][
                "Forma_de_Pago"
              ];
          }
        }

        if (!order.form.payment) {
          try {
            order.form.payment =
              $scope.read_pdf.data["Primas"]["Forma_de_Pago"];
          } catch (idx) {}
        }

        if ($scope.read_pdf.data["Datos del vehiculo"]) {
          console.log("$scope.vehiculo");

          order.subforms.auto.brand =
            $scope.read_pdf.data["Datos del vehiculo"]["marca"];
          order.subforms.auto.model =
            $scope.read_pdf.data["Datos del vehiculo"]["modelo"];
          order.subforms.auto.year =
            $scope.read_pdf.data["Datos del vehiculo"]["anio"];
          order.subforms.auto.engine =
            $scope.read_pdf.data["Datos del vehiculo"]["motor"];
          order.subforms.auto.serial =
            $scope.read_pdf.data["Datos del vehiculo"]["serie"];
          $scope.serieAGuardar = order.subforms.auto.serial;
          if (order.subforms.auto.serial) {
            $scope.checkNumSerie();
          }
          // order.subforms.auto.license_plates = $scope.read_pdf.data['Datos del vehiculo']['clave_vehicular'];
          order.subforms.auto.license_plates =
            $scope.read_pdf.data["Datos del vehiculo"]["placas"];
          var datosVehiculo = $scope.read_pdf.data["Datos del vehiculo"];

          order.subforms.auto.version = datosVehiculo.version
            ? datosVehiculo.version
            : datosVehiculo.descripcion_vehiculo
            ? datosVehiculo.descripcion_vehiculo
            : datosVehiculo.clave_vehicular;
          // order.subforms.auto.version = $scope.read_pdf.data['Datos del vehiculo']['descripcion_vehiculo'] ? $scope.read_pdf.data['Datos del vehiculo']['descripcion_vehiculo'] : $scope.read_pdf.data['Datos del vehiculo']['clave_vehicular'];
          order.subforms.auto.color =
            $scope.read_pdf.data["Datos del vehiculo"]["color"];
          order.subforms.auto.service =
            $scope.read_pdf.data["Datos del vehiculo"]["servicio"];
          if (
            (order &&
              order.subforms &&
              order.subforms.auto &&
              order.subforms.auto.service == "") ||
            order.subforms.auto.service == undefined ||
            order.subforms.auto.service == null
          ) {
            if (
              $scope.read_pdf &&
              $scope.read_pdf.data &&
              $scope.read_pdf.data["Datos del vehiculo"]["uso"]
            ) {
              if (
                parseInt($scope.read_pdf.data["Datos del vehiculo"]["uso"]) == 1
              ) {
                order.subforms.auto.service = "PARTICULAR";
              } else if (
                parseInt($scope.read_pdf.data["Datos del vehiculo"]["uso"]) == 2
              ) {
                order.subforms.auto.service = "CARGA";
              } else if (
                parseInt($scope.read_pdf.data["Datos del vehiculo"]["uso"]) == 3
              ) {
                order.subforms.auto.service = "SERVICIO PÚBLICO";
              } else {
                order.subforms.auto.service = "PARTICULAR";
              }
            }
          }
          order.form.identifier =
            order.subforms.auto.brand +
            " " +
            order.subforms.auto.model +
            " " +
            order.subforms.auto.version;
          if ($scope.orgName == "gpi") {
            order.form.identifier = "GENERAL";
          }
          try {
            order.subforms.auto.usage = parseInt(
              $scope.read_pdf.data["Datos del vehiculo"]["uso"]
            );
          } catch (err) {}
          var aseguradora_a_capturar = sinDiacriticos(
            $scope.read_pdf.data["aseguradora"].toLowerCase()
          );
          if (order.defaults && order.defaults.providers) {
            //  console.log("$scope.defaults",aseguradora_a_capturar)
            //  console.log("$scope.providers",order.defaults.providers)

            order.defaults.providers.forEach(function (x) {
              if (aseguradora_a_capturar == "chubb") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "CHUBB" ||
                  sinDiacriticos(x.alias).toLowerCase() == "Aba" ||
                  sinDiacriticos(x.alias).toLowerCase() == "ABA" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "chubb seguros mexico"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                }
              }
              if (aseguradora_a_capturar == "qualitas") {
                console.log("INGRESO");
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "Quálitas" ||
                  sinDiacriticos(x.alias).toLowerCase() == "Qualitas" ||
                  sinDiacriticos(x.alias).toLowerCase() == "QUALITAS" ||
                  sinDiacriticos(x.alias).toLowerCase() == "QUÁLITAS"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                }
              }
              if (aseguradora_a_capturar == "gnp") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "gnp" ||
                  sinDiacriticos(x.alias).toLowerCase() == "gnp seguros" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "grupo nacional provincial" ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    "grupo nacional provincial "
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                }
              }
              if (aseguradora_a_capturar == "axa") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "axa" ||
                  sinDiacriticos(x.alias).toLowerCase() == "axa seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                }
              }
              if (aseguradora_a_capturar == "zurich") {
                if (
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar ||
                  sinDiacriticos(x.alias).toLowerCase() ==
                    aseguradora_a_capturar.toUpperCase() ||
                  sinDiacriticos(x.alias).toLowerCase() == "zurich " ||
                  sinDiacriticos(x.alias).toLowerCase() == "zurich seguros"
                ) {
                  order.form.aseguradora = x;
                  var cl =
                    $scope.read_pdf.data["Datos generales de la poliza"][
                      "Clave interna del agente"
                    ];
                  if (!cl || cl == undefined) {
                    try {
                      cl =
                        $scope.read_pdf.data["Datos generales de la poliza"][
                          "Clave_interna_del_agente"
                        ];
                    } catch (u) {}
                  }
                  get_claves_pdf(x, cl);
                }
              }
            });
          }
          order.subforms.auto.policy_type = { id: 1, name: "Automóvil" };
          order.subforms.auto.procedencia = { id: 1, name: "Residente" };
        }

        //     order.form.from_pdf = true;
        if (
          $scope.read_pdf.data["contratante_full_name"].indexOf("S.A. DE") > -1
        ) {
          $scope.read_pdf_contractor.type = false;
          $scope.read_pdf_contractor.name =
            $scope.read_pdf.data["contratante_full_name"];
        } else {
          $scope.read_pdf_contractor.type = true;
          $scope.read_pdf_contractor.name =
            $scope.read_pdf.data["contratante_full_name"];
        }

        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Prima total"]
        ) {
          $scope.order.form.primaTotal = $scope.read_pdf.data["Primas"][
            "Prima total"
          ]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"]["Prima total"]
                )
              )
            : $scope.read_pdf.data["Primas"]["IMPORTE TOTAL"]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"]["IMPORTE TOTAL"]
                )
              )
            : 0;
          $scope.order.form.subTotal = $scope.read_pdf.data["Primas"][
            "Subtotal"
          ]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"]["Subtotal"]
                )
              )
            : 0;
          $localStorage["primas"] = $scope.order.form;
        }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Prima neta"]
        ) {
          $scope.order.form.primaNeta = $scope.read_pdf.data["Primas"][
            "Prima neta"
          ]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"]["Prima neta"]
                )
              )
            : 0;
          $localStorage["primas"] = $scope.order.form;
        }

        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Gastos de expedición"]
        ) {
          try {
            $scope.order.form.derecho = $scope.read_pdf.data["Primas"][
              "Gastos de expedición"
            ]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf.data["Primas"]["Gastos de expedición"]
                  )
                )
              : 0;
            $localStorage["primas"] = $scope.order.form;
          } catch (o) {
            $scope.order.form.derecho = $scope.read_pdf.data["Primas"][
              "Gastos de expedici\u00f3n"
            ]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf.data["Primas"]["Gastos de expedici\u00f3n"]
                  )
                )
              : 0;
            $localStorage["primas"] = $scope.order.form;
          }
        }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Gastos por Expedición."]
        ) {
          try {
            $scope.order.form.derecho = $scope.read_pdf.data["Primas"][
              "Gastos por Expedición."
            ]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf.data["Primas"]["Gastos por Expedición."]
                  )
                )
              : 0;
            $localStorage["primas"] = $scope.order.form;
          } catch (o) {
            $scope.order.form.derecho = $scope.read_pdf.data["Primas"][
              "Gastos por Expedici\u00f3n."
            ]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf.data["Primas"][
                      "Gastos por Expedici\u00f3n."
                    ]
                  )
                )
              : 0;
            $localStorage["primas"] = $scope.order.form;
          }
        }
        if (
          $scope.read_pdf.data["Primas"] &&
          $scope.read_pdf.data["Primas"]["Financiamiento por pago fraccionado"]
        ) {
          $scope.order.form.rpf = $scope.read_pdf.data["Primas"][
            "Financiamiento por pago fraccionado"
          ]
            ? parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf.data["Primas"][
                    "Financiamiento por pago fraccionado"
                  ]
                )
              )
            : 0;
          $localStorage["primas"] = $scope.order.form;
        }
        // $scope.verComisiones();
        order.form.startDate = $scope.read_pdf.data["fecha_inicio"];
        order.form.endingDate = $scope.read_pdf.data["fecha_fin"];
        order.form.endDate = $scope.read_pdf.data["fecha_fin"];
        order.form.start_of_validity = new Date(
          $scope.read_pdf.data["fecha_inicio"]
        );
        order.form.end_of_validity = new Date(
          $scope.read_pdf.data["fecha_fin"]
        );

        $scope.dataToSave.start_of_validity = mesDiaAnio(order.form.startDate);
        $scope.dataToSave.end_of_validity = mesDiaAnio(order.form.endingDate);
        var date1 = new Date($scope.dataToSave.start_of_validity);
        var date2 = new Date($scope.dataToSave.end_of_validity);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        order.form.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
        // $scope.checkEndDate()
        var asegurado = $scope.read_pdf.data["Datos del asegurado"] || {};
        var cobertura_paquete = $scope.read_pdf.data["cobertura"] || "";

        // Asignamos first_name dependiendo de si existe propietario_contratante
        $scope.first_name =
          asegurado.propietario_contratante &&
          asegurado.propietario_contratante.trim()
            ? asegurado.propietario_contratante
            : asegurado.contratante_full_name || "";
        $scope.first_name = sinDiacriticos($scope.first_name);

        order.form.from_pdf = true;
        $rootScope.readPDF = {
          individual: $scope.read_pdf.data["Datos del asegurado"],
          corporation: $scope.read_pdf.data["Datos del asegurado"],
          address: $scope.read_pdf.data["contratante_domicilio"],
          first_name: $scope.first_name,
          last_name: $scope.read_pdf.data["contratante_primer_apellido"],
          second_last_name:
            $scope.read_pdf.data["contratante_segundo_apellido"],
          type_person: $scope.read_pdf.data["persona"],
        };
        // si hay datos de quote rellenar

        $scope.show_contratante = "contractors-match/";
        $http
          .post(url.IP + $scope.show_contratante, {
            matchWord: $scope.read_pdf_contractor.name,
            poliza: true,
          })
          .then(function (response) {
            if (response.status === 200) {
              if (response.data != 404) {
                if (response.data.contractors.length) {
                  // if(!$scope.read_pdf_contractor.type){
                  if (response.data.contractors.length) {
                    for (var i = 0; i < response.data.contractors.length; i++) {
                      var reg = /\d{,}/g;
                      var reg2 = /\d{.}/g;
                      var nombre_pdf = $scope.read_pdf_contractor.name
                        .replace(reg, "")
                        .toLowerCase();
                      var nombre_pdf = nombre_pdf
                        .replace(reg2, "")
                        .toLowerCase();
                      var nombre_api = response.data.contractors[i].full_name
                        .replace(reg, "")
                        .toLowerCase();
                      var nombre_api = nombre_pdf
                        .replace(reg2, "")
                        .toLowerCase();
                      if (
                        nombre_pdf
                          .replace(",", "")
                          .replace(".", "")
                          .toLowerCase() ==
                        nombre_api
                          .replace(",", "")
                          .replace(".", "")
                          .toLowerCase()
                      ) {
                        order.form.contratante.val =
                          response.data.contractors[i].full_name;
                        order.form.contratante.value =
                          response.data.contractors[i];
                        order.form.contratante.phone =
                          response.data.contractors[i].phone;
                        order.form.contratante.email =
                          response.data.contractors[i].email;
                      }

                      if (i + 1 == response.data.contractors.length) {
                        if (!order.form.contratante.value) {
                          $scope.objetoPoliza = order.form;
                          $scope.saveLocalstorange();
                          order.contratanteCreatorModalEvent();
                        }
                      }
                    }
                  } else {
                    $scope.objetoPoliza = order.form;
                    $scope.saveLocalstorange();
                    order.contratanteCreatorModalEvent();
                  }
                  // }
                } else {
                  $scope.objetoPoliza = order.form;
                  $scope.saveLocalstorange();
                  order.contratanteCreatorModalEvent();
                }
              } else {
                $scope.objetoPoliza = order.form;
                order.contratanteCreatorModalEvent();
              }
            } else {
              $scope.objetoPoliza = order.form;
              $scope.saveLocalstorange();
              order.contratanteCreatorModalEvent();
            }
          });
      }
    };
    $scope.filePdfTemp = null;

    function guardarArchivo(file) {
      // Límite máximo en bytes (ej. 4 MB = 4 * 1024 * 1024)
      var MAX_SIZE = 4 * 1024 * 1024;

      // Limpiar valores anteriores
      delete $localStorage.archivoBase64;
      delete $localStorage.archivoNombre;
      delete $localStorage.archivoTipo;

      // Validar tamaño del archivo antes de leer
      if (file.size > MAX_SIZE) {
        console.log(
          "⚠️ El archivo es demasiado grande para guardarlo en memoria local (máx 4 MB)."
        );
        return;
      }

      var reader = new FileReader();
      reader.onload = function (e) {
        var base64 = e.target.result.split(",")[1]; // quitar prefijo data:
        try {
          $localStorage.archivoBase64 = base64;
          $localStorage.archivoNombre = file.name;
          $localStorage.archivoTipo = file.type;
        } catch (err) {}
      };
      reader.readAsDataURL(file);
    }

    // ------------------------------imagen serie
    function obtenerSerieImagen(filePDF) {
      $scope.serieDetectada = "";
      var file = filePDF;
      // Si no viene filePDF, intentar recuperarlo del localStorage
      if (!filePDF) {
        filePDF = recuperarArchivo();
        file = filePDF;
        if (!filePDF) {
          console.log("No se encontró archivo para procesar.");
          return;
        }
      } else {
        // Si vino del input, guardarlo para persistencia
        guardarArchivo(filePDF);
      }
      if (!file) return;
      if (typeof pdfjsLib === "undefined") {
        console.log(
          "PDF.js no está cargado. Verifica la inclusión de la librería."
        );
        return;
      }
      // Configuración worker para evitar warnings
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js";

      var vinRegex = /\b[A-HJ-NPR-Z0-9]{17}\b/; // VIN exacto
      var reader = new FileReader();

      reader.onload = function (e) {
        var typedarray = new Uint8Array(e.target.result);

        pdfjsLib
          .getDocument({
            data: typedarray,
            useWorkerFetch: false,
            standardFontDataUrl:
              "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/standard_fonts/",
          })
          .promise.then(function (pdf) {
            var paginaActual = 1;
            function buscarEnPagina() {
              if (paginaActual > pdf.numPages) {
                console.log("No se encontró la serie en el PDF.");
                return;
              }

              pdf.getPage(paginaActual).then(function (page) {
                page.getTextContent().then(function (textContent) {
                  var vinCoords = null;
                  var detectedVIN = null;

                  textContent.items.forEach(function (item) {
                    if (
                      vinRegex.test(item.str) ||
                      item.str.toLowerCase().includes("serie")
                    ) {
                      detectedVIN = item.str.match(vinRegex)
                        ? item.str.match(vinRegex)[0]
                        : null;
                      vinCoords = item.transform;
                    }
                  });

                  if (vinCoords) {
                    $scope.serieDetectada = detectedVIN || "";
                    $localStorage.serieDetectada = $scope.serieDetectada;
                    // Renderizar la página en un canvas
                    var viewport = page.getViewport({ scale: 2.0 });
                    var canvas = document.createElement("canvas");
                    var context = canvas.getContext("2d");
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    // page.render({ canvasContext: context, viewport: viewport }).promise.then(function() {
                    //     // Calcular recorte
                    //     var x = vinCoords[4];
                    //     var y = viewport.height - vinCoords[5];
                    //     var width = 600;
                    //     var height = 400;

                    //     var cropCanvas = document.createElement('canvas');
                    //     cropCanvas.width = width;
                    //     cropCanvas.height = height;
                    //     var cropCtx = cropCanvas.getContext('2d');
                    //     cropCtx.drawImage(canvas, x, y, width, height, 0, 0, width, height);

                    //     $scope.serieImagenBase64 = cropCanvas.toDataURL();
                    //     var base64String = cropCanvas.toDataURL();
                    //     $scope.serieImagenBase64 = $sce.trustAsResourceUrl(base64String);
                    //     $scope.$apply();
                    // });
                  } else {
                    paginaActual++;
                    buscarEnPagina(); // Siguiente página
                  }
                });
              });
            }

            buscarEnPagina(); // Empieza en página 1
          });
      };

      reader.readAsArrayBuffer(file);
    }
    // configuraciÃƒÂ³n del datepicker
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

function agregarOnChange(elem) {
  $(elem)
    .find("#nvo")
    .parent()
    .parent()
    .append(
      '<button onClick="closeOT()" class="btn btn-block btn-outline btn-success">Crear Contratante</button>'
    );
  $(elem).find("#nvo").parent().remove();
}

function closeOT() {
  $("#closeOT").click();
  $("#createCont").click();
}

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReporteOperacionController", ReporteOperacionController);

  ReporteOperacionController.$inject = [
    "statusReceipt",
    "$localStorage",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "url",
    "$scope",
    "$http",
    "toaster",
    "$parse",
    "exportFactory",
    "$uibModal",
  ];

  function ReporteOperacionController(
    statusReceipt,
    $localStorage,
    $state,
    SweetAlert,
    MESSAGES,
    providerService,
    url,
    $scope,
    $http,
    toaster,
    $parse,
    exportFactory,
    $uibModal
  ) {
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;
    vm.Generar = Generar;
    vm.tableRes = {};
    vm.formatearNumero = formatearNumero;
    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      created_at: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: 0,
      group: 0,
      recibos_pagados: true,
      recibos_no_pagados: false,
      recibos_liquidados: false,
      recibos_conciliados: false,
      num_poliza: "",
      cve_agente: "",
      ot_rep: true,
      identifier: "",
    };
    if ($localStorage.url_operation == "/operacion.semanal") {
      vm.Generar(1, 1, 1);
    } else {
      $state.go("index.main");
    }
    $scope.showSpecific1_a = false;
    $scope.showSpecific1_b = false;
    $scope.showSpecific2_a = false;
    $scope.showSpecific2_b = false;
    $scope.showSpecific2_c = false;
    $scope.showSpecific2_d = false;
    $scope.showSpecific3_a = false;
    $scope.showSpecific3_b = false;
    $scope.showSpecific3_c = false;
    $scope.showSpecific4_a = false;
    $scope.showSpecific5_a = false;
    $scope.showSpecific5_b = false;
    $scope.showSpecific6_a = false;
    $scope.showSpecific6_b = false;
    $scope.showAll = true;

    $scope.status_rec = function (value) {
      switch (value) {
        case 1:
          return "Pagado";
        case 2:
          return "Cancelado";
        case 3:
          return "Prorrogado";
        case 4:
          return "Pendiente de pago";
        case 5:
          return "Liquidado";
        case 6:
          return "Conciliado";
        case 7:
          return "Cerrado";
        case 0:
          return "Desactivado";
        default:
          return "Vencido";
      }
    };
    $scope.forma_pago = function (parValue) {
      switch (parValue) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        case 24:
          return "Quincenal";
          break;
        default:
          return "No especificada";
      }
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        default:
          return "Pendiente";
      }
    };
    $scope.status_sin = function (parSttaus) {
      switch (parSttaus) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "En trámite";
          break;
        case 3:
          return "Completado";
          break;
        case 4:
          return "Cancelado";
          break;
        case 5:
          return "Rechazado";
          break;
        case 6:
          return "En espera";
          break;
      }
    };

    $scope.status_endoso = function (parSttaus) {
      switch (parSttaus) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Registrado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado";
          break;
        case 5:
          return "En trámite";
          break;
      }
    };

    $scope.status_fianza = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Anulada";
          break;
        case 13:
          return "Rechazada";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "Renovada";
          break;
        default:
          return "";
      }
    };

    function formatearNumero(nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    }

    activate();

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function activate() {
      vm.Generar(1, 1);
    }

    $scope.showButtonExcel = false;

    function Generar(tipo) {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var created_at = toDate(vm.form.created_at).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));

      var fecha = new Date();
      var lunes_pasado = new Date(fecha.getTime() - 24 * 60 * 60 * 1000 * 7);
      var viernes_pasado = new Date(fecha.getTime() + 24 * 60 * 60 * 1000 * 7);
      var dias = new Array(
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado"
      );
      var day = dias[fecha.getDay()];
      var hoy = new Date();
      // Milisegundos de 4 días mas
      var suma4dias = 4 * 24 * 60 * 60 * 1000;
      var fecha_lunes = lunes_pasado.getTime() + 4 * 24 * 60 * 60 * 1000;
      var viernes_pasado = new Date(fecha_lunes);

      if (day == "Lunes") {
        var date_lunes = lunes_pasado;
        var date_viernes = viernes_pasado;
      } else {
        var date_lunes = lunes_pasado;
        var date_viernes = viernes_pasado;
      }

      var params = {
        since: lunes_pasado ? convertDate(lunes_pasado) : vm.form.si,
        until: viernes_pasado ? convertDate(viernes_pasado) : vm.form.un,
        tipo: tipo ? tipo : 1,
      };
      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      $scope.filtros = params;
      $http({
        method: "POST",
        url: url.IP + "reporte-operacion/",
        data: params,
      }).then(function success(response) {
        if (response.status == 200 || response.status == 201) {
          vm.resultados = response.data;
          $scope.showButtonExcel = true;
        } else {
          toaster.warning("Error en la llamada registros");
        }
      });
    }

    $scope.exportData = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (param == 1) {
        $http({
          method: "POST",
          url: url.IP + "reporte-operacion-excel",
          data: $scope.filtros,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function (data, status, headers, config) {
          if (data.status == 200) {
            l.stop();
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte_Operacion.xls");
          } else {
            toaster.error(
              "Error",
              "Ha ocurrido un error al descargar el reporte",
              "error"
            );
            l.stop();
          }
        });
      }
    };

    $scope.specificShow = function (tipo, categoria) {
      switch (tipo) {
        case 1:
          if (categoria == 1) {
            $scope.showAll = false;
            $scope.showSpecific1_a = true;
            $scope.showSpecific1_b = false;
          } else if (categoria == 2) {
            $scope.showAll = false;
            $scope.showSpecific1_b = true;
            $scope.showSpecific1_a = false;
          }
          break;
        case 2:
          if (categoria == 1) {
            $scope.showAll = false;
            $scope.showSpecific2_a = true;
            $scope.showSpecific2_b = false;
            $scope.showSpecific2_c = false;
            $scope.showSpecific2_d = false;
          } else if (categoria == 2) {
            $scope.showAll = false;
            $scope.showSpecific2_a = false;
            $scope.showSpecific2_b = true;
            $scope.showSpecific2_c = false;
            $scope.showSpecific2_d = false;
          } else if (categoria == 3) {
            $scope.showAll = false;
            $scope.showSpecific2_a = false;
            $scope.showSpecific2_b = false;
            $scope.showSpecific2_c = true;
            $scope.showSpecific2_d = false;
          } else if (categoria == 4) {
            $scope.showAll = false;
            $scope.showSpecific2_a = false;
            $scope.showSpecific2_b = false;
            $scope.showSpecific2_c = false;
            $scope.showSpecific2_d = true;
          }
          break;
        case 3:
          if (categoria == 1) {
            $scope.showAll = false;
            $scope.showSpecific3_a = true;
            $scope.showSpecific3_b = false;
            $scope.showSpecific3_c = false;
          } else if (categoria == 2) {
            $scope.showAll = false;
            $scope.showSpecific3_a = false;
            $scope.showSpecific3_b = true;
            $scope.showSpecific3_c = false;
          } else if (categoria == 3) {
            $scope.showAll = false;
            $scope.showSpecific3_a = false;
            $scope.showSpecific3_b = false;
            $scope.showSpecific3_c = true;
          }
          break;
        case 4:
          if (categoria == 1) {
            $scope.showAll = false;
            $scope.showSpecific4_a = true;
          }
        case 5:
          if (categoria == 1) {
            $scope.showAll = false;
            $scope.showSpecific5_a = true;
            $scope.showSpecific5_b = false;
          } else if (categoria == 2) {
            $scope.showAll = false;
            $scope.showSpecific5_a = false;
            $scope.showSpecific5_b = true;
          }
          break;
        case 6:
          if (categoria == 1) {
            $scope.showAll = false;
            $scope.showSpecific6_a = true;
            $scope.showSpecific6_b = false;
          } else if (categoria == 2) {
            $scope.showAll = false;
            $scope.showSpecific6_a = false;
            $scope.showSpecific6_b = true;
          }
          break;
        default:
          $scope.showAll = true;
          break;
      }
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        default:
          return "Pendiente";
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("notificacionListadoCtrl", notificacionListadoCtrl);

  notificacionListadoCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "FileUploader",
    "url",
    "SweetAlert",
    "dataFactory",
    "$parse",
    "providerService",
  ];

  function notificacionListadoCtrl(
    $sessionStorage,
    $scope,
    $http,
    FileUploader,
    url,
    SweetAlert,
    dataFactory,
    $parse,
    providerService
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;

    activate();

    function activate() {
      $http.get(url.IP + "notifications-app").then(function (response) {
        $scope.notifications = response.data;
      });
    }

    $scope.delete = function (item) {
      SweetAlert.swal(
        {
          title: "Eliminar Notificación",
          text: "¿Está seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "GET",
              url: url.IP + "delete-assign_notification_app/",
              params: {
                id: item.id,
              },
            })
              .then(function (request) {
                SweetAlert.swal(
                  "¡Listo!",
                  "Notificación eliminada correctamente.",
                  "success"
                );
                activate();
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      );
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("notificacionesCtrl", notificacionesCtrl);

  notificacionesCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "FileUploader",
    "url",
    "SweetAlert",
    "dataFactory",
    "$parse",
    "providerService",
    "datesFactory",
    "$timeout",
    "$state",
  ];

  function notificacionesCtrl(
    $sessionStorage,
    $scope,
    $http,
    FileUploader,
    url,
    SweetAlert,
    dataFactory,
    $parse,
    providerService,
    datesFactory,
    $timeout,
    $state
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;
    $scope.contractors = [];
    $scope.providers = [];
    $scope.ramos = [];
    $scope.notificaction = {
      model: 27,
    };
    $scope.obteniendoFiltros = false;
    // $scope.ramos = [
    //     {ramo_name: 'Vida', ramo_code: 1},
    //     {ramo_name: 'Accidentes y Enfermedades', ramo_code: 2},
    //     {ramo_name: 'Daños', ramo_code: 3}
    // ]
    $scope.showProgram = false;

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item, options){
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          SweetAlert.swal(
            "¡Listo!",
            "Notificación creada exitosamente.",
            "success"
          );
          $state.go("notificaciones.listado");
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        $scope.checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 2 });
      } else {
        $scope.checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 1 });
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
      fileItem.removeAfterUpload = true;
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(archNot) {
      $scope.userInfo = {
        id: archNot,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "notifications/" + archNot + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    activate();
    $(".js-example-basic-multiple").select2();
    function activate() {
      // getProviders();

      dataFactory.get("groupingLevel-resume/").then(function (response) {
        $scope.agrupaciones = response.data;
      });

      $scope.notificaction.startsAt = datesFactory.convertDate(new Date());
      $scope.notificaction.startsHr = new Date();
    }

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        $scope.providers = data.data;
      });
    }
    $scope.obteniendoFiltros = false;
    $scope.fillData = function (glevel) {
      // dataFactory.get('dataForNotifications-by-user-app/' + usr.name)
      var params = {
        glevel: glevel,
      };
      var url_data = "dataForNotifications-by-user-app/" + usr.name;
      $scope.obteniendoFiltros = true;
      dataFactory
        .post(url_data, params)
        .then(
          function success(response) {
            $scope.contractors = response.data.Contractors;
            $scope.obteniendoFiltros = false;
            if (response.data.Aseguradoras) {
              $scope.providers = response.data.Aseguradoras;
            }
            if (response.data.Ramos) {
              $scope.ramos = response.data.Ramos;
            }
          },
          function error(error) {
            $scope.obteniendoFiltros = false;
            console.log(error);
          }
        )
        .catch(function (e) {
          $scope.obteniendoFiltros = false;
          console.log(e);
        });
    };

    $scope.selectContra = function (sel) {
      $scope.notificaction.poliza_contractor = [];
      sel.forEach(function (cl) {
        $scope.notificaction.poliza_contractor.push(cl.id);
      });
    };

    $scope.selectProv = function (sel) {
      $scope.notificaction.poliza_provider = [];
      sel.forEach(function (cl) {
        $scope.notificaction.poliza_provider.push(cl.id);
      });
    };

    $scope.selectRamo = function (sel) {
      $scope.notificaction.poliza_ramo = [];
      sel.forEach(function (cl) {
        $scope.notificaction.poliza_ramo.push(cl.ramo_code);
      });
    };

    $scope.program = function (param) {
      $scope.showProgram = param;
    };

    $scope.checkDate = function () {
      var init_date = $scope.notificaction.startsAt.split("/");
      var day = parseInt(init_date[0]);
      var month = parseInt(init_date[1]);
      var year = parseInt(init_date[2]);
      var hour = new Date($scope.notificaction.startsHr).getHours();
      var minute = new Date($scope.notificaction.startsHr).getMinutes();
      if (day.toString().length == 1) {
        day = "0" + day;
      }
      if (month.toString().length == 1) {
        month = "0" + month;
      }
      var date = month + "-" + day + "-" + year + " " + hour + ":" + minute;
      // $scope.date_hour = datesFactory.toDate(datesFactory.convertDate(new Date(date)));
      $scope.date_hour =
        year +
        "-" +
        month +
        "-" +
        day +
        "T" +
        hour +
        ":" +
        minute +
        ":00.000000Z";
    };

    $scope.save = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      if (!$scope.notificaction.title) {
        l.stop();
        SweetAlert.swal("Error", "Escribe un título.", "error");
        return;
      }
      if (!$scope.notificaction.description) {
        l.stop();
        SweetAlert.swal("Error", "Escribe un texto.", "error");
        return;
      }
      // if(!$scope.notificaction.poliza_groupinglevel){
      //     l.stop();
      //     SweetAlert.swal('Error', 'Selecciona una agrupación.', 'error');
      //     return;
      // }
      if ($scope.date_hour) {
        if (
          process(datesFactory.convertDate(new Date($scope.date_hour))) <
          process(datesFactory.convertDate(new Date()))
        ) {
          l.stop();
          SweetAlert.swal(
            "Error",
            "La fecha de programación no puede ser menor a la fecha de hoy.",
            "error"
          );
          return;
        }
      }

      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }

      var data = {
        model: 27,
        title: $scope.notificaction.title,
        description: $scope.notificaction.description,
        org_name: usr.org,
        type_notification: 1,
        site: $scope.notificaction.site,
        poliza_groupinglevel: $scope.notificaction.poliza_groupinglevel
          ? $scope.notificaction.poliza_groupinglevel
          : null,
        poliza_contractor: $scope.notificaction.poliza_contractor
          ? $scope.notificaction.poliza_contractor
          : [],
        poliza_provider: $scope.notificaction.poliza_provider
          ? $scope.notificaction.poliza_provider
          : [],
        poliza_ramo: $scope.notificaction.poliza_ramo
          ? $scope.notificaction.poliza_ramo
          : [],
        startsAt: $scope.date_hour
          ? $scope.date_hour
          : datesFactory.toDate(datesFactory.convertDate(new Date())),
        id_reference: 0,
      };
      if ($scope.countFile > 0 && data.site) {
        data.type_notification = 2;
      }
      $http({
        method: "POST",
        url: url.IP + "notificaciones/",
        data: data,
      }).then(function success(response) {
        if (response.data.id) {
          if ($scope.countFile > 0) {
            l.stop();
            uploadFiles(response.data.id);
          } else {
            SweetAlert.swal(
              "¡Listo!",
              "Notificación creada exitosamente.",
              "success"
            );
            $state.go("notificaciones.listado");
          }
        } else {
          l.stop();
          SweetAlert.swal("Error", "Ocurrió un error.", "error");
          $state.go("notificaciones.main");
        }
      });
    };
  }
})();

angular.module("inspinia").factory("wsService", [
  "$window",
  function ($window) {
    var socket;
    var callbacks = []; // Array para almacenar callbacks

    return {
      connect: function (url) {
        socket = new WebSocket(url);

        socket.onopen = function () {
          console.log("Conexión WebSocket abierta");
        };

        socket.onclose = function () {
          console.log("Conexión WebSocket cerrada");
        };

        socket.onerror = function (event) {
          console.error("Error en WebSocket:", event);
        };

        socket.onmessage = function (event) {
          // Llamar a todos los callbacks registrados
          for (var i = 0; i < callbacks.length; i++) {
            callbacks[i](event.data);
          }
        };
      },
      onMessage: function (callback) {
        if (!callback) {
          // Si callback es null/undefined, limpiamos la lista de callbacks
          callbacks = [];
        } else {
          callbacks.push(callback);
        }
      },

      send: function (message) {
        if (socket && socket.readyState === WebSocket.OPEN) {
          socket.send(message);
        } else {
          console.error("WebSocket no está conectado.");
        }
      },
      disconnect: function () {
        if (socket) {
          socket.close(); // Cierra la conexión WebSocket
          console.log("WebSocket desconectado");
        } else {
          console.error("No hay conexión WebSocket para cerrar.");
        }
      },
    };
  },
]);

(function () {
  "use strict";
  /* jshint devel: true */

  angular
    .module("inspinia")
    .controller("MulticotizadorEmisionCtrl", MulticotizadorEmisionCtrl);

  MulticotizadorEmisionCtrl.$inject = [
    "$scope",
    "$http",
    "url",
    "$stateParams",
    "$localStorage",
    "$window",
    "$sessionStorage",
    "SweetAlert",
    "$state",
    "datesFactory",
  ];

  function MulticotizadorEmisionCtrl(
    $scope,
    $http,
    url,
    $stateParams,
    $localStorage,
    $window,
    $sessionStorage,
    SweetAlert,
    $state,
    datesFactory
  ) {
    console.log("12", $stateParams);
    if ($stateParams.myInsurance != "some default") {
      $scope.insurance_selected = $stateParams.myInsurance;
      $scope.contractor = $stateParams.contractor;
      $scope.postData = $stateParams.quoteInfo;
      $scope.postData.first_name = $stateParams.contractor.name
        ? $stateParams.contractor.name
        : $stateParams.contractor.first_name;
      $scope.postData.last_name = $stateParams.contractor.last_name;
      $scope.postData.second_last_name =
        $stateParams.contractor.second_last_name;
    }
    $scope.client = [];

    if ($localStorage.loginInfo) {
      var user_info = JSON.parse($localStorage.loginInfo);

      if (user_info.org.urlname == "local") {
        var mcFactory = {
          urlname: user_info.org.urlname + "mc",
          // urlname: 'local'
        };
      } else {
        var mcFactory = {
          urlname: user_info.org.urlname + "mc",
        };
      }
    } else {
      var mcFactory = {
        urlname: "",
      };
    }

    if (mcFactory.urlname == "local" || mcFactory.urlname == "localmc") {
      var url_ = {
        MC: "http://127.0.0.1:8001/",
      };
    } else {
      var url_ = {
        MC: "http://127.0.0.1:8001/",
        //MC : 'https://' + mcFactory.urlname + '.multicotizador.com/'
      };
    }

    $scope.return = function () {
      var data = {
        visible: true,
        request_emit: null,
        insurance_selected: null,
      };
      var params = { myInsurance: data };
      $state.go("multicotizador.multicotizador", params);
    };

    $scope.saveData = function (value) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var lada_ = $scope.postData.phone.substring(-1, 2);
      // var phone_ = $scope.postData.phone.substring(0, 10);
      // $scope.postData.phone = phone_;
      $scope.postData.lada = lada_;

      $http.get($scope.insurance_selected.parent_car_form).then(function (res) {
        var data = {
          first_name: $scope.postData.first_name,
          last_name: $scope.postData.last_name,
          second_last_name: $scope.postData.second_last_name,
          email: $scope.postData.email,
          phone: $scope.postData.phone,
          lada: $scope.postData.lada,
          rfc: $scope.postData.rfc,
        };

        $http.patch(res.data.user_info.url, data).then(function (res_) {
          if (res_.data.client_address.length == 1) {
            $http
              .patch(res_.data.client_address[0].url, {
                address_int_number: $scope.postData.address_int_number
                  ? $scope.postData.address_int_number
                  : "",
                address_number: $scope.postData.address_number,
                address_street: $scope.postData.address_street,
              })
              .then(function (response) {
                $window.localStorage.car_info = null;
                $window.localStorage.postData = null;
                $state.go("multicotizador.multicotizador");
              });
          }
        });

        $http
          .patch(res.data.url, {
            engine_number: $scope.client.motor,
            serie_number: $scope.client.serial,
            placas: $scope.client.placas,
          })
          .then(function (res__) {
            if (value == 1) {
              SweetAlert.swal(
                "¡Listo!",
                "Los datos se han guardado correctamente.",
                "success"
              );
              l.stop();
            }
          });
      });
    };

    $scope.createIssue = function () {
      console.log("115", $scope.postData);
      $scope.saveData(2);

      $scope.postData.address_col = $scope.postData.address_2;
      $scope.postData.address_int_number = $scope.postData.address_int_number
        ? $scope.postData.address_int_number
        : 0;
      $scope.postData.city = $scope.postData.ddMun;
      $scope.postData.state = $scope.postData.ddEst;
      $scope.postData.civil_status = $scope.postData.civil_state;
      $scope.postData.phone_number = $scope.postData.phone;
      $scope.postData.serie = $scope.client.serial;
      $scope.postData.serial = $scope.client.serial;
      $scope.postData.serie_number = $scope.client.serial;
      $scope.postData.numero_motor = $scope.client.motor;
      $scope.postData.engine_number = $scope.client.motor;
      $scope.postData.placas = $scope.client.placas;
      $scope.postData.urlname = mcFactory.urlname;
      $scope.postData.zip_code = $scope.contractor.zip;

      $scope.emitirPoliza($scope.insurance_selected);
    };

    $scope.emitirPoliza = function (parService) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      $scope.asg_selected = parService;
      // $scope.quote.visibleIssue = true;

      $scope.postData["quote_id"] = $scope.asg_selected.id;
      // $scope.postData['placas'] = $scope.client.placas;
      // $scope.postData['numero_motor'] = $scope.client.motor;
      // $scope.postData['serie_number'] = $scope.client.serial;

      $http
        .post(
          url_.MC +
            "run-emision-service/" +
            angular.copy($scope.asg_selected.service.id),
          $scope.postData
        )
        .then(function (response) {
          console.log("response", response);
          if (response.status == 200) {
            if (response.data) {
              //Qualitas ANA
              if (response.data.emision) {
                if (response.data.emision[1] == "default") {
                  SweetAlert.swal("Error", response.data.emision[2], "error");
                  l.stop();
                  return;
                } else {
                  $scope.finishEmision();
                  SweetAlert.swal(
                    "¡Listo!",
                    "la póliza ha sido emitida correctamente",
                    "success"
                  );
                  l.stop();
                }
              }
              //Zurich
              if (response.data.EMISION) {
                if (response.data.EMISION.numPoliza == 0) {
                  SweetAlert.swal(
                    "Error",
                    response.data.EMISION.mensaje,
                    "error"
                  );
                  l.stop();
                  return;
                } else {
                  $scope.finishEmision();
                  SweetAlert.swal(
                    "¡Listo!",
                    "la póliza ha sido emitida correctamente",
                    "success"
                  );
                  l.stop();
                }
              }
              //hdi
              if (response.data.error) {
                SweetAlert.swal("Error", response.data.error, "error");
                l.stop();
                return;
              } else {
                $scope.finishEmision();
                SweetAlert.swal(
                  "¡Listo!",
                  "la póliza ha sido emitida correctamente",
                  "success"
                );
                l.stop();
              }
            }

            //Qualitas ANA
            if (response.data) {
              if (response.data.impresion) {
                window.open(response.data.impresion.PDF, "_blank");
                $scope.btnPrint = false;
              }
            }
            //Zurich
            if (response.data) {
              if (response.data.IMPRESION) {
                if (response.data.IMPRESION.poliza) {
                  window.open(response.data.IMPRESION.poliza, "_blank");
                  var contentType = "application/pdf";
                  var folderpath = "layouts/";
                  var filename = "emision.pdf";
                  savebase64AsPDF(
                    folderpath,
                    filename,
                    response.data.IMPRESION.poliza,
                    contentType
                  );
                }
              }
            }

            if (response.data) {
              if (response.data.impresion) {
                if (response.data.impresion) {
                  var contentType = "application/pdf";
                  var folderpath = "layouts/";
                  var filename = "emision.pdf";
                  savebase64AsPDF(
                    folderpath,
                    filename,
                    response.data.impresion,
                    contentType
                  );
                }
              }
            }

            $scope.emision_result = response.data;
            $window.localStorage.emision_result = JSON.stringify(
              $scope.emision_result
            );

            // if(!response.data.error) {
            //   $http.patch($scope.show_quote_selected.url, {
            //     emitido: true,
            //     quote_selected: true,
            //     status: 3
            //   })
            //   .then(function(res) {

            //   });

            //   $http.patch($scope.show_quote_selected.user_info.client_address[0].url, {
            //     address_street: $scope.postData.address_street,
            //     address_number: $scope.postData.address_number,
            //     address_int_number: $scope.postData.address_int_number
            //   })
            //   .then(function(res_) {

            //   });

            //   if(response.data.PDF){
            //     window.open(response.data.PDF,'_blank');
            //     $scope.btnPrint = false;
            //   }
            //   else{
            //     if(response.data.error) {
            //       var errorMessage = response.data.error[2];
            //       sweetAlert("Error", errorMessage, "error");
            //     } else {

            //       if(response.data['WS error: ']) {
            //         console.log('error', response.data['WS error: ']);
            //         $scope.error_emision = response.data['WS error: '];
            //       }

            //     }
            //   }
            // } else {
            //   if(response.data['WS error: ']) {
            //     console.log('error', response.data['WS error: ']);
            //     $scope.error_emision = response.data['WS error: '];
            //   }
            // }

            var data = {
              visible: true,
              request_emit: null,
              insurance_selected: null,
            };
            var params = { myInsurance: data };
            $state.go("multicotizador.multicotizador", params);
          }
        });
    };

    $scope.finishEmision = function () {
      $scope.return();
      // $http.patch($scope.show_quote_selected.url, {
      //   emitido: true,
      //   quote_selected : true,
      //   status: 3
      // })
      // .then(function(res) {

      // });

      // $http.patch($scope.show_quote_selected.user_info.client_address[0].url, {
      //   address_street: $scope.postData.address_street,
      //   address_number: $scope.postData.address_number,
      //   address_int_number: $scope.postData.address_int_number
      // })
      // .then(function(res_) {

      // });
    };

    function anioMesDia(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
      // var dateObject = new Date(dateParts[2], dateParts[0] - 1, dateParts[1]); // month is 0-based
      var d = new Date(dateObject);
      var date = d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate();

      return date;
    }

    function mesDiaAnio(dateStr) {
      var d = new Date(toDate(dateStr));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();

      return date;
    }

    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }

    function savebase64AsPDF(folderpath, filename, content, contentType) {
      // Convert the base64 string in a Blob
      var DataBlob = b64toBlob(content, contentType);
      var blobUrl = URL.createObjectURL(DataBlob);

      // window.location = blobUrl;
      window.open(blobUrl, "_blank");
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("MulticotizadorCtrl", MulticotizadorCtrl);
  // .directive('fileModel', ['$parse', function ($parse) {
  //   return {
  //     restrict: 'A',
  //     link: function(scope, element, attrs) {
  //       var model = $parse(attrs.fileModel);
  //       var modelSetter = model.assign;

  //       element.bind('change', function(){
  //         scope.$apply(function(){
  //           modelSetter(scope, element[0].files[0]);
  //           console.log("Archivo asignado a fileselected:", scope.fileselected); // Depuración
  //         });
  //       });
  //     }
  //   };
  // }]);;

  MulticotizadorCtrl.$inject = [
    "$scope",
    "$rootScope",
    "$http",
    "url",
    "$stateParams",
    "$localStorage",
    "$sessionStorage",
    "toaster",
    "datesFactory",
    "$uibModal",
    "$window",
    "dataFactory",
    "$sce",
    "SweetAlert",
    "$state",
    "wsService",
    "$q",
    "$location",
    "FileUploader",
    "$timeout",
  ];

  function MulticotizadorCtrl(
    $scope,
    $rootScope,
    $http,
    url,
    $stateParams,
    $localStorage,
    $sessionStorage,
    toaster,
    datesFactory,
    $uibModal,
    $window,
    dataFactory,
    $sce,
    SweetAlert,
    $state,
    wsService,
    $q,
    $location,
    FileUploader,
    $timeout
  ) {
    // Variables de estado
    $scope.messages = []; // Para almacenar los mensajes recibidos
    $scope.connectionStatus = "Conectado"; // Estado de conexión

    function noSpan() {
      return null;
    }

    $scope.quotes = [];
    $scope.quoteLista = [];
    $scope.selected_quote = [];
    $scope.quoteCreated = [];
    $scope.currencyVal;
    $scope.neighborhoods = [];
    $scope.regimenFiscales = [];
    $scope.emisionVisible = false;
    $scope.resultadoPoliza = false;
    $scope.registroChubb = false;
    $scope.urlDownload = "";
    $scope.urlApi = "api.multicotizador.com";
    $scope.urlApiTm = "ms.multicotizador.com";
    $scope.urlGateway = "https://apigatewaymc.multicotizador.com/";
    $scope.urlSocket =
      "wss://apigatewaymc.multicotizador.com/ws/notificaciones/";
    $scope.Urllector = "https://lector-pdf.mbxservicios.com/";
    $scope.policy = "";
    $scope.cotizacion_id_emitido = "";
    $scope.fileselected = null;
    $scope.message_error = "";
    $scope.loader = false;
    $scope.resultadoPoliza = false;
    $scope.org_name = $localStorage.infoUser.org.name;
    $scope.aseguradora_seleccionada = "";

    $scope.URL_CHUBB = "https://avantthya-api.multicotizador.com/";
    $scope.URL_MAIL_SERVICE = "https://mail-info.mbxservicios.com/";
    $scope.respuestas_num = 0;
    var orgName =
      $sessionStorage.infoUser &&
      $sessionStorage.infoUser.org &&
      $sessionStorage.infoUser.org.name;
    $scope.org_name = orgName;
    $scope.origen = orgName;

    if ($scope.org_name == "gpi") {
      $scope.empresa = "AndreaZamora";
      $scope.origen = "miurabox";
    } else {
      $scope.empresa = orgName;
    }

    if ($localStorage.loginInfo) {
      var user_info = JSON.parse($localStorage.loginInfo);

      if (user_info.org.urlname == "local") {
        var mcFactory = {
          urlname: user_info.org.urlname + "mc",
          // urlname: 'local'
        };
      } else {
        var mcFactory = {
          urlname: user_info.org.urlname + "mc",
        };
      }
    } else {
      var mcFactory = {
        urlname: "",
      };
    }

    if (mcFactory.urlname == "local" || mcFactory.urlname == "localmc") {
      var url_ = {
        MC: "http://127.0.0.1:8001/",
      };
    } else {
      var url_ = {
        MC: $scope.urlGateway,
      };
    }

    // $('.select2-item').select2({
    //   templateSelection: noSpan
    // });

    $scope.create_cot = true;
    $scope.phone = "";
    $scope.checkZipe = false;

    $scope.car = {
      value: 4452,
      person_type: 1,
    };
    $scope.success_services = 0;
    $scope.detail_services = 0;
    $scope.request_detail = 0;

    $scope.client = {
      genders: [
        { name: "Masculino", value: "M", id: 2 },
        { name: "Femenino", value: "F", id: 1 },
      ],
      civilStates: [
        { name: "Casado", value: 1 },
        { name: "Soltero", value: 2 },
        { name: "Viudo", value: 3 },
        { name: "Divorciado", value: 4 },
      ],
      rfc: "",
      disableState: false,
      disableTown: false,
    };
    var frecuencys = [
      { name: "Anual", value: "C" },
      { name: "Semestral", value: "S" },
      { name: "Trimestral", value: "T" },
      { name: "Mensual", value: "M" },
    ];

    var packages = ["Amplia", "Limitada", "RC"];
    if (mcFactory.urlname == "prevexmc") {
      packages.push("Amplia Elite", "Auto Elite", "Amplia Plus");
    }
    var org = mcFactory.urlname;
    $scope.quote = {
      sorg: org,
      frecuencys: frecuencys,
      paymentMethods: [
        "Efectivo",
        "Depósito Bancario",
        "Tarjeta de Crédito",
        "Cheque",
      ],
      packages: packages,
      services: {},
      formDataID: "",
      collapsed: true,
      visible: false,
      servicesData: [],
      civils: [
        { value: 1, name: "Casado" },
        { value: 2, name: "Soltero" },
        { value: 3, name: "Viudo" },
        { value: 4, name: "Divorciado" },
      ],
    };

    $scope.paquetes = [
      { value: "01", name: "Amplia" },
      { value: "02", name: "Limitada" },
      { value: "03", name: "RC" },
    ];
    if (mcFactory.urlname == "prevexmc") {
      $scope.paquetes.push(
        { value: 4, name: "Amplia Elite" },
        { value: 5, name: "Auto Elite" },
        { value: 6, name: "Amplia Plus" }
      );
    }
    $scope.client.package = "Amplia";

    $scope.durations = [
      { value: 1, name: "1 año" },
      { value: 2, name: "2 años" },
      { value: 3, name: "3 años" },
      { value: 4, name: "4 años" },
      { value: 5, name: "5 años" },
    ];

    $scope.duration = $scope.durations[0];

    if (mcFactory.urlname == "prevexmc") {
      $scope.agencias = [
        { value: 1, name: "Automundo" },
        { value: 2, name: "Interlomas mundo" },
        { value: 3, name: "Automotores de México" },
      ];
    } else {
      $scope.agencias = [];
    }

    $scope.postData = {
      quoteFrecuency: frecuencys,
    };

    $window.localStorage.removeItem("show_quote_selected");
    if ($window.localStorage.car_info) {
      $scope.form1 = false;
      $scope.form2 = true;
      $scope.car = JSON.parse($window.localStorage.car_info);
    } else {
      $scope.form2 = false;
      $scope.form1 = true;
    }

    if ($window.localStorage.client) {
      $scope.client = JSON.parse($window.localStorage.client);

      if ($scope.client.last_name == ".EMPTY.") {
        $scope.car.person_type = 2;
      }

      for (var i = 0; i < $scope.paquetes.length; i++) {
        if ($scope.client.package == $scope.paquetes[i].name) {
          $scope.package_quote = $scope.paquetes[i];
        }
      }
    }

    if ($window.localStorage.car) {
      $scope.car = JSON.parse($window.localStorage.car);
    }

    if ($window.localStorage.servicesData) {
      $scope.quote.servicesData = JSON.parse($window.localStorage.servicesData);
      $scope.quote.visible = true;
    }

    if ($window.localStorage.postData) {
      $scope.postData = JSON.parse($window.localStorage.postData);
    }

    if ($window.localStorage.services) {
      $scope.services = JSON.parse($window.localStorage.services);
    }

    if ($window.localStorage.insurance_selected) {
      $scope.insurance_selected = JSON.parse(
        $window.localStorage.insurance_selected
      );
    }

    if ($window.localStorage.emision_result) {
      $scope.emision_result = JSON.parse($window.localStorage.emision_result);
    }
    var src_imgs = "../../assets/images/";

    $scope.returnForm1 = function () {
      $scope.form1 = true;
      $scope.form2 = false;
    };

    $scope.checkCarValue = function () {
      var date = new Date();
      var year = date.getFullYear();
      var next_year = date.getFullYear() + 1;
    };

    $scope.registrarEmisionVista = function () {
      $scope.resultadoPoliza = true;
    };
    $scope.fileNameChanged = function (ele) {
      $scope.fileselected = ele.files[0];
      $scope.filePdf = ele.files[0];
    };
    $scope.showFile = function (argument) {
      var reader = new FileReader();
      reader.readAsDataURL(argument.files[0]);
      $scope.fileSelected = argument.files[0];
      // $scope.uploader.queue = argument.files[0]
      var reader_pdf = new FileReader();
      reader_pdf.readAsDataURL($scope.fileSelected);
      $scope.urlsfile = URL.createObjectURL(argument.files[0]);
      reader_pdf.onload = function () {
        $scope.pdffile = reader_pdf.result;
        $scope.okxfile = new Blob([$scope.pdffile], {
          type: "application/pdf",
        });
        var fileURL = $scope.urlsfile;
        $scope.content = $sce.trustAsResourceUrl(fileURL);
        // window.open($scope.content);
      };
      reader_pdf.onerror = function (error) {
        console.log("Error: ", error);
      };
      // var reader2 = new FileReader();
      // $scope.urlfile =reader2.readAsDataURL(argument.files[0]);
      // console.log('........',reader,$scope.objectURL,$scope.fileSelected,$scope.urlfile)
    };
    $scope.obtenerPoliza = function (accion, aseguradora, cotizacion_id) {
      var params = {
        empresa: $scope.empresa,
        cotizacion_id: cotizacion_id,
      };
      if (aseguradora == "ps") {
        // AQUI SE PUSO DE ESTA FORMA PORQUE DESDE LA EMISION NOS DEVUELVE EL BASE 64
        if (accion === "registrar") {
          $scope.registrarPoliza();
        } else {
          $scope.enviarPoliza();
        }
        return;
      }
      var url_ = "";
      var complementoUrl = "";
      $scope.loader = true;
      switch (aseguradora) {
        case "ana":
          complementoUrl = "anaseguros";
          break;
        case "gnp":
          complementoUrl = "gnp";
          break;
        case "ps":
          complementoUrl = "ps";
          break;
        case "hdi":
          complementoUrl = "hdi";
          break;
        case "tumomento":
          complementoUrl = "tumomento";
          break;
        case "qualitas":
          complementoUrl = "qualitas";
          break;
      }

      url_ = "https://" + complementoUrl + "-" + $scope.urlApi + "/";

      if (aseguradora === "tumomento") {
        url_ = "https://" + complementoUrl + "-" + $scope.urlApiTm + "/";
      }

      if (aseguradora === "chubb") {
        url_ = $scope.URL_CHUBB;
      }
      $scope.aseguradora = aseguradora;
      if (
        aseguradora === "chubb" ||
        aseguradora == "gnp" ||
        aseguradora == "ana"
      ) {
        $http
          .get(url_ + "imprimir", { params: params })
          .then(function (response) {
            switch (aseguradora) {
              case "chubb":
                var pdfUrl = response.data.IM.PATHPDF;
                break;

              case "gnp":
                var pdfUrl = response.data.RESULTADO.URL_DOCUMENTO;
                break;

              case "ana":
                var pdfUrl =
                  response.data.transacciones.transaccion.poliza["@link"];
                break;
            }
            localStorage.setItem("url_impresion", pdfUrl);
            fetch(
              $scope.urlGateway +
                "/cotizar/proxy?url=" +
                encodeURIComponent(pdfUrl),
              {
                method: "GET",
              }
            )
              .then(function (response) {
                if (!response.ok) {
                  throw new Error("HTTP error! status: " + response.status);
                }
                return response.blob();
              })
              .then(function (blob) {
                $scope.filePdf = new File([blob], "documento.pdf", {
                  type: "application/pdf",
                });

                if (accion === "registrar") {
                  $scope.registrarPoliza();
                } else {
                  $scope.enviarPoliza();
                }
              })
              .catch(function (error) {
                console.error("Error al descargar el archivo:", error);
                toaster.pop(
                  "error",
                  "Error",
                  "No se pudo descargar el archivo."
                );
                $scope.loader = false;
              });
          })
          .catch(function (error) {
            console.error("Error al descargar el archivo:", error);
            toaster.pop("error", "Error", "No se pudo descargar el archivo.");
            $scope.loader = false;
          });
      } else if (aseguradora === "qualitas") {
        $http
          .post(url_ + "imprimir", params)
          .then(function (response) {
            var links = response.data.pdf;

            // Asegurarse de que links es un objeto y convertirlo en un array
            var linksArray = Array.isArray(links)
              ? links
              : Object.values(links);

            // Reemplazar find con un bucle para encontrar el enlace
            var link = null;
            for (var i = 0; i < linksArray.length; i++) {
              if (
                linksArray[i].indexOf(
                  "http://qbcenter.qualitas.com.mx/poliza/p"
                ) === 0
              ) {
                link = linksArray[i];
                break;
              }
            }

            if (link) {
              localStorage.setItem("url_impresion", link);

              fetch(
                $scope.urlGateway +
                  "/cotizar/proxy?url=" +
                  encodeURIComponent(link),
                {
                  method: "GET",
                }
              )
                .then(function (response) {
                  if (!response.ok) {
                    throw new Error("HTTP error! status: " + response.status);
                  }
                  return response.blob();
                })
                .then(function (blob) {
                  $scope.filePdf = new File([blob], "documento.pdf", {
                    type: "application/pdf",
                  });

                  if (accion === "registrar") {
                    $scope.registrarPoliza();
                  } else {
                    $scope.enviarPoliza();
                  }
                })
                .catch(function (error) {
                  console.error("Error al descargar el archivo:", error);
                  toaster.pop(
                    "error",
                    "Error",
                    "No se pudo descargar el archivo."
                  );
                  $scope.loader = false;
                });
            }
          })
          .catch(function (error) {
            console.error("Error al descargar el archivo:", error);
            toaster.pop("error", "Error", "No se pudo descargar el archivo.");
            $scope.loader = false;
          });
      } else if (aseguradora == "tumomento" || aseguradora == "hdi") {
        $http
          .get(url_ + "imprimir", { params: params, responseType: "blob" })
          .then(function (response) {
            console.log("Respuesta exitosa:", response);

            var blob = new Blob([response.data], { type: "application/pdf" });
            $scope.filePdf = new File([blob], "documento.pdf", {
              type: "application/pdf",
            });

            if (accion === "registrar") {
              $scope.registrarPoliza();
            } else {
              $scope.enviarPoliza();
            }
          })
          .catch(function (error) {
            console.error("Error al descargar el archivo:", error);

            var mensajeError = "No se pudo descargar el archivo.";
            if (error.status) {
              mensajeError += " Código de error: " + error.status;
            }
            toaster.pop("error", "Error", mensajeError);
          })
          .finally(function () {
            $scope.loader = false;
          });
      }
    };
    function convertirArchivoABase64(file) {
      var deferred = $q.defer(); // Usar $q de AngularJS para manejar promesas

      var reader = new FileReader();

      reader.onload = function (event) {
        var base64String = event.target.result.split(",")[1]; // Eliminar el prefijo 'data:...;base64,'
        deferred.resolve(base64String);
      };

      reader.onerror = function (error) {
        deferred.reject(error);
      };

      reader.readAsDataURL(file);

      return deferred.promise; // Devolver la promesa
    }

    $scope.enviarPoliza = function () {
      var quoteLista = localStorage.getItem("quote");
      var IDCotizacion = localStorage.getItem("id_cotizacion");
      quoteLista = JSON.parse(quoteLista);
      if ($scope.selected_quote.aseguradora == "ps") {
        var payload = {
          nombre:
            (quoteLista.nombre || "") +
            " " +
            (quoteLista.apellido_paterno || ""),
          correo: quoteLista.correo || "",
          id: IDCotizacion || "",
          poliza: $scope.policy || "",
          origen: quoteLista.origen || "",
          asunto: "Nueva póliza de primero seguros creada",
          base64: $scope.filePdf || "", // Archivo convertido a base64
        };
        $http({
          method: "POST",
          url:
            $scope.URL_MAIL_SERVICE +
            "mails/send-email-emision-multicotizador/",
          data: payload, // Enviar el JSON
          headers: {
            "Content-Type": "application/json", // Importante: JSON puro
          },
        })
          .then(function (response) {
            console.log("Email enviado correctamente:", response.data);
            toaster.pop("success", "Éxito", "Correo enviado correctamente.");
          })
          .catch(function (error) {
            console.error("Error al enviar el email:", error);
            toaster.pop("error", "Error", "No se pudo enviar el correo.");
          });
      } else {
        convertirArchivoABase64($scope.filePdf)
          .then(function (base64String) {
            var payload = {
              nombre:
                (quoteLista.nombre || "") +
                " " +
                (quoteLista.apellido_paterno || ""),
              correo: quoteLista.correo || "",
              id: IDCotizacion || "",
              poliza: $scope.policy || "",
              origen: quoteLista.origen || "",
              asunto:
                "Nueva póliza de " +
                (datosPDF.data["aseguradora"] || "") +
                " creada",
              base64: base64String || "", // Archivo convertido a base64
            };
            $http({
              method: "POST",
              url:
                $scope.URL_MAIL_SERVICE +
                "mails/send-email-emision-multicotizador/",
              data: payload, // Enviar el JSON
              headers: {
                "Content-Type": "application/json", // Importante: JSON puro
              },
            })
              .then(function (response) {
                console.log("Email enviado correctamente:", response.data);
                toaster.pop(
                  "success",
                  "Éxito",
                  "Correo enviado correctamente."
                );
              })
              .catch(function (error) {
                console.error("Error al enviar el email:", error);
                toaster.pop("error", "Error", "No se pudo enviar el correo.");
              });
          })
          .catch(function (error) {
            console.error("Error al convertir el archivo a Base64:", error);
          });
      }
    };

    $scope.crearTarea = function () {
      // ID del usuario al que va dirigido
      var usuarioAsignado = 35;
      // Link o archivo en base 64
      var linkPoliza =
        "JVBERi0xLjQKJdP0zOEKMSAwIG9iago8PAovQ3JlYXRpb25EYXRlKEQ6MjAyNDEyMTcxNDM1NDItMDYnMDAnKQovQ3JlYXRvcihQREZzaGFycCAxLjMxLjE3ODktZyBcKHd3dy5wZGZzaGFycC5jb21cKSkKL1Byb2R1Y2VyKFBERnNoYXJwIDEuMzEuMTc4OS1nIFwod3d3LnBkZnNoYXJwLmNvbVwpKQo+PgplbmRvYmoKMiAwIG9iago8PAovVHlwZS9DYXRhbG9nCi9QYWdlcyAzIDAgUgo+PgplbmRvYmoKMyAwIG9iago8PAovVHlwZS9QYWdlcwovQ291bnQgNwovS2lkc1s2MCAwIFIgNjIgMCBSIDY0IDAgUiA2NiAwIFIgNjggMCBSIDg5IDAgUiA5NiAwIFJdCj4+CmVuZG9iago0IDAgb2JqCjw8Ci9Qcm9jU2V0Wy9QREYvSW1hZ2VCL0ltYWdlQy9JbWFnZUkvVGV4dF0KL0ZvbnQKPDwKL0FyaWFsTVQgNSAwIFIKL0FyaWFsLUJvbGRNVCA4IDAgUgovQ291cmllciAxMSAwIFIKL1N5bWJvbCAxMiAwIFIKL1RpbWVzTmV3Um9tYW5QUy1Cb2xkTVQgMTMgMCBSCi9BcmlhbC1Cb2xkSXRhbGljTVQgMTYgMCBSCi9BcmlhbC1JdGFsaWNNVCAxOSAwIFIKPj4KL1hPYmplY3QKPDwKL0pmSW1hZ2UwMjgzIDIyIDAgUgovSmZJbWFnZTAyODQgMjMgMCBSCi9KZkltYWdlMDI4NSAyNCAwIFIKL0pmSW1hZ2UwMjg2IDI1IDAgUgovSmZJbWFnZTAyODcgMjYgMCBSCi9KZkltYWdlMDI4OCAyNyAwIFIKL0pmSW1hZ2UwMjg5IDI4IDAgUgovSmZJbWFnZTAyOTAgMjkgMCBSCi9KZkltYWdlMDI5MSAzMCAwIFIKL0pmSW1hZ2UwMjQ2IDMxIDAgUgovSmZJbWFnZTAyNDggMzIgMCBSCi9KZkltYWdlMDI0OSAzMyAwIFIKL0pmSW1hZ2UwMjUwIDM0IDAgUgovSmZJbWFnZTAyMzUgMzUgMCBSCi9KZkltYWdlMDI1MyAzNiAwIFIKL0pmSW1hZ2UwMjU0IDM3IDAgUgovSmZJbWFnZTAyNTUgMzggMCBSCi9KZkltYWdlMDI1NiAzOSAwIFIKL0pmSW1hZ2UwMjU3IDQwIDAgUgovSmZJbWFnZTAyNzAgNDEgMCBSCi9KZkltYWdlMDI3MSA0MiAwIFIKL0pmSW1hZ2UwMjcyIDQzIDAgUgovSmZJbWFnZTAyNzMgNDQgMCBSCi9KZkltYWdlMDI3NCA0NSAwIFIKL0pmSW1hZ2UwMjc1IDQ4IDAgUgovSmZJbWFnZTAyNzYgNDkgMCBSCi9KZkltYWdlMDI3NyA1MCAwIFIKL0ZtMDA2OF9hdXRvIDUxIDAgUgovRm0wMDY5X2F1dG8gNTIgMCBSCi9GbTAwMzRfYXV0byA1MyAwIFIKL0ZtMDAzN19hdXRvIDU0IDAgUgovRm0wMDM2X2F1dG8gNTUgMCBSCi9GbTAwMjdfYXV0byA1NiAwIFIKL0ZtMDAzOV9hdXRvIDU3IDAgUgovRm0wMDYwX2F1dG8gNTggMCBSCj4+Cj4+CmVuZG9iago1IDAgb2JqCjw8Ci9UeXBlL0ZvbnQKL1N1YnR5cGUvVHlwZTEKL0Jhc2VGb250L0FyaWFsTVQKL0ZpcnN0Q2hhciAzMgovTGFzdENoYXIgMjU1Ci9FbmNvZGluZy9XaW5BbnNpRW5jb2RpbmcKL0ZvbnREZXNjcmlwdG9yIDYgMCBSCi9XaWR0aHMgNyAwIFIKPj4KZW5kb2JqCjYgMCBvYmoKPDwKL1R5cGUvRm9udERlc2NyaXB0b3IKL0FzY2VudCA5MDUKL0NhcEhlaWdodCA3MTUKL0Rlc2NlbnQgLTIxMQovRmxhZ3MgMzIKL0ZvbnRCQm94Wy0yMjIgLTI1MCAxMDA2IDkyMl0KL0ZvbnROYW1lL0FyaWFsTVQKL0l0YWxpY0FuZ2xlIDAKL1N0ZW1WIDAKPj4KZW5kb2JqCjcgMCBvYmoKWwoyODEgMjgxIDM1MyA1NTUgNTU1IDg4NiA2NzAgMTk1IDMzMiAzMzIgMzg5IDU4NCAyODEgMzMyIDI4MSAyODEgNTU1IDU1NSA1NTUgNTU1IDU1NSA1NTUgNTU1IDU1NSA1NTUgNTU1IDI4MSAyODEgNTg0IDU4NCA1ODQgNTU1IDEwMTYgNjcwIDY3MCA3MjAgNzIwIDY3MCA2MTIgNzc4IDcyMCAyODEgNDk3IDY3MCA1NTUgODM2IDcyMCA3NzggNjcwIDc3OCA3MjAgNjcwIDYxMiA3MjAgNjcwIDk0NCA2NzAgNjcwIDYxMiAyODEgMjgxIDI4MSA0NjggNTU1IDMzMiA1NTUgNTU1IDQ5NyA1NTUgNTU1IDI4MSA1NTUgNTU1IDIyNCAyMjQgNDk3IDIyNCA4MzYgNTU1IDU1NSA1NTUgNTU1IDMzMiA0OTcgMjgxIDU1NSA0OTcgNzIwIDQ5NyA0OTcgNDk3IDMzMiAyNjAgMzMyIDU4NCA3NDkgNTU1IDI4MSAyMjQgNTU1IDMzMiAxMDAxIDU1NSA1NTUgMzMyIDEwMDEgNjcwIDMzMiAxMDAxIDI4MSA2MTIgMjgxIDI4MSAyMjQgMjI0IDMzMiAzMzIgMzUzIDU1NSAxMDAxIDMzMiAxMDAxIDQ5NyAzMzIgOTQ0IDI4MSA0OTcgNjcwIDI4MSAzMzIgNTU1IDU1NSA1NTUgNTU1IDI2MCA1NTUgMzMyIDczNSAzNjggNTU1IDU4NCAzMzIgNzM1IDU1NSA0MDQgNTQ4IDMzMiAzMzIgMzMyIDU3NiA1NDAgMjgxIDMzMiAzMzIgMzY4IDU1NSA4MzYgODM2IDgzNiA2MTIgNjcwIDY3MCA2NzAgNjcwIDY3MCA2NzAgMTAwMSA3MjAgNjcwIDY3MCA2NzAgNjcwIDI4MSAyODEgMjgxIDI4MSA3MjAgNzIwIDc3OCA3NzggNzc4IDc3OCA3NzggNTg0IDc3OCA3MjAgNzIwIDcyMCA3MjAgNjcwIDY3MCA2MTIgNTU1IDU1NSA1NTUgNTU1IDU1NSA1NTUgODg2IDQ5NyA1NTUgNTU1IDU1NSA1NTUgMjgxIDI4MSAyODEgMjgxIDU1NSA1NTUgNTU1IDU1NSA1NTUgNTU1IDU1NSA1NDggNjEyIDU1NSA1NTUgNTU1IDU1NSA0OTcgNTU1IDQ5NwpdCmVuZG9iago4IDAgb2JqCjw8Ci9UeXBlL0ZvbnQKL1N1YnR5cGUvVHlwZTEKL0Jhc2VGb250L0FyaWFsLUJvbGRNVAovRmlyc3RDaGFyIDMyCi9MYXN0Q2hhciAyNTUKL0VuY29kaW5nL1dpbkFuc2lFbmNvZGluZwovRm9udERlc2NyaXB0b3IgOSAwIFIKL1dpZHRocyAxMCAwIFIKPj4KZW5kb2JqCjkgMCBvYmoKPDwKL1R5cGUvRm9udERlc2NyaXB0b3IKL0FzY2VudCA5MDUKL0NhcEhlaWdodCA3MTUKL0Rlc2NlbnQgLTIxMQovRmxhZ3MgMzIKL0ZvbnRCQm94Wy0xNjcgLTI1MCAxMDA2IDkzOV0KL0ZvbnROYW1lL0FyaWFsLUJvbGRNVAovSXRhbGljQW5nbGUgMAovU3RlbVYgMTUwCj4+CmVuZG9iagoxMCAwIG9iagpbCjI4MSAzMzIgNDc2IDU1NSA1NTUgODg2IDcyMCAyMzggMzMyIDMzMiAzODkgNTg0IDI4MSAzMzIgMjgxIDI4MSA1NTUgNTU1IDU1NSA1NTUgNTU1IDU1NSA1NTUgNTU1IDU1NSA1NTUgMzMyIDMzMiA1ODQgNTg0IDU4NCA2MTIgOTcyIDcyMCA3MjAgNzIwIDcyMCA2NzAgNjEyIDc3OCA3MjAgMjgxIDU1NSA3MjAgNjEyIDgzNiA3MjAgNzc4IDY3MCA3NzggNzIwIDY3MCA2MTIgNzIwIDY3MCA5NDQgNjcwIDY3MCA2MTIgMzMyIDI4MSAzMzIgNTg0IDU1NSAzMzIgNTU1IDYxMiA1NTUgNjEyIDU1NSAzMzIgNjEyIDYxMiAyODEgMjgxIDU1NSAyODEgODg2IDYxMiA2MTIgNjEyIDYxMiAzODkgNTU1IDMzMiA2MTIgNTU1IDc3OCA1NTUgNTU1IDQ5NyAzODkgMjgxIDM4OSA1ODQgNzQ5IDU1NSAyODEgMjgxIDU1NSA0OTcgMTAwMSA1NTUgNTU1IDMzMiAxMDAxIDY3MCAzMzIgMTAwMSAyODEgNjEyIDI4MSAyODEgMjgxIDI4MSA0OTcgNDk3IDM1MyA1NTUgMTAwMSAzMzIgMTAwMSA1NTUgMzMyIDk0NCAyODEgNDk3IDY3MCAyODEgMzMyIDU1NSA1NTUgNTU1IDU1NSAyODEgNTU1IDMzMiA3MzUgMzY4IDU1NSA1ODQgMzMyIDczNSA1NTUgNDA0IDU0OCAzMzIgMzMyIDMzMiA1NzYgNTU1IDI4MSAzMzIgMzMyIDM2OCA1NTUgODM2IDgzNiA4MzYgNjEyIDcyMCA3MjAgNzIwIDcyMCA3MjAgNzIwIDEwMDEgNzIwIDY3MCA2NzAgNjcwIDY3MCAyODEgMjgxIDI4MSAyODEgNzIwIDcyMCA3NzggNzc4IDc3OCA3NzggNzc4IDU4NCA3NzggNzIwIDcyMCA3MjAgNzIwIDY3MCA2NzAgNjEyIDU1NSA1NTUgNTU1IDU1NSA1NTUgNTU1IDg4NiA1NTUgNTU1IDU1NSA1NTUgNTU1IDI4MSAyODEgMjgxIDI4MSA2MTIgNjEyIDYxMiA2MTIgNjEyIDYxMiA2MTIgNTQ4IDYxMiA2MTIgNjEyIDYxMiA2MTIgNTU1IDYxMiA1NTUKXQplbmRvYmoKMTEgMCBvYmoKPDwKL1R5cGUvRm9udAovU3VidHlwZS9UeXBlMQovQmFzZUZvbnQvQ291cmllcgovRW5jb2RpbmcvV2luQW5zaUVuY29kaW5nCj4+CmVuZG9iagoxMiAwIG9iago8PAovVHlwZS9Gb250Ci9TdWJ0eXBlL1R5cGUxCi9CYXNlRm9udC9TeW1ib2wKPj4KZW5kb2JqCjEzIDAgb2JqCjw8Ci9UeXBlL0ZvbnQKL1N1YnR5cGUvVHlwZTEKL0Jhc2VGb250L1RpbWVzTmV3Um9tYW5QUy1Cb2xkTVQKL0ZpcnN0Q2hhciAzMgovTGFzdENoYXIgMjU1Ci9FbmNvZGluZy9XaW5BbnNpRW5jb2RpbmcKL0ZvbnREZXNjcmlwdG9yIDE0IDAgUgovV2lkdGhzIDE1IDAgUgo+PgplbmRvYmoKMTQgMCBvYmoKPDwKL1R5cGUvRm9udERlc2NyaXB0b3IKL0FzY2VudCA4OTEKL0NhcEhlaWdodCA2NjIKL0Rlc2NlbnQgLTIxNgovRmxhZ3MgMzQKL0ZvbnRCQm94Wy01NTggLTMwNiAyMDMzIDEwMjVdCi9Gb250TmFtZS9UaW1lc05ld1JvbWFuUFMtQm9sZE1UCi9JdGFsaWNBbmdsZSAwCi9TdGVtViAxNTAKPj4KZW5kb2JqCjE1IDAgb2JqClsKMjUyIDMzMiA1NTUgNDk3IDQ5NyAxMDAxIDgzNiAyODEgMzMyIDMzMiA0OTcgNTY5IDI1MiAzMzIgMjUyIDI4MSA0OTcgNDk3IDQ5NyA0OTcgNDk3IDQ5NyA0OTcgNDk3IDQ5NyA0OTcgMzMyIDMzMiA1NjkgNTY5IDU2OSA0OTcgOTI5IDcyMCA2NzAgNzIwIDcyMCA2NzAgNjEyIDc3OCA3NzggMzg5IDQ5NyA3NzggNjcwIDk0NCA3MjAgNzc4IDYxMiA3NzggNzIwIDU1NSA2NzAgNzIwIDcyMCAxMDAxIDcyMCA3MjAgNjcwIDMzMiAyODEgMzMyIDU4NCA0OTcgMzMyIDQ5NyA1NTUgNDQ3IDU1NSA0NDcgMzMyIDQ5NyA1NTUgMjgxIDMzMiA1NTUgMjgxIDgzNiA1NTUgNDk3IDU1NSA1NTUgNDQ3IDM4OSAzMzIgNTU1IDQ5NyA3MjAgNDk3IDQ5NyA0NDcgMzk2IDIyNCAzOTYgNTE5IDc3OCA0OTcgMjUyIDMzMiA0OTcgNDk3IDEwMDEgNDk3IDQ5NyAzMzIgMTAwMSA1NTUgMzMyIDEwMDEgMjUyIDY3MCAyNTIgMjUyIDMzMiAzMzIgNDk3IDQ5NyAzNTMgNDk3IDEwMDEgMzMyIDEwMDEgMzg5IDMzMiA3MjAgMjUyIDQ0NyA3MjAgMjUyIDMzMiA0OTcgNDk3IDQ5NyA0OTcgMjI0IDQ5NyAzMzIgNzQ5IDMwMyA0OTcgNTY5IDMzMiA3NDkgNDk3IDQwNCA1NDggMzAzIDMwMyAzMzIgNTc2IDU0MCAyNTIgMzMyIDMwMyAzMzIgNDk3IDc0OSA3NDkgNzQ5IDQ5NyA3MjAgNzIwIDcyMCA3MjAgNzIwIDcyMCAxMDAxIDcyMCA2NzAgNjcwIDY3MCA2NzAgMzg5IDM4OSAzODkgMzg5IDcyMCA3MjAgNzc4IDc3OCA3NzggNzc4IDc3OCA1NjkgNzc4IDcyMCA3MjAgNzIwIDcyMCA3MjAgNjEyIDU1NSA0OTcgNDk3IDQ5NyA0OTcgNDk3IDQ5NyA3MjAgNDQ3IDQ0NyA0NDcgNDQ3IDQ0NyAyODEgMjgxIDI4MSAyODEgNDk3IDU1NSA0OTcgNDk3IDQ5NyA0OTcgNDk3IDU0OCA0OTcgNTU1IDU1NSA1NTUgNTU1IDQ5NyA1NTUgNDk3Cl0KZW5kb2JqCjE2IDAgb2JqCjw8Ci9UeXBlL0ZvbnQKL1N1YnR5cGUvVHlwZTEKL0Jhc2VGb250L0FyaWFsLUJvbGRJdGFsaWNNVAovRmlyc3RDaGFyIDMyCi9MYXN0Q2hhciAyNTUKL0VuY29kaW5nL1dpbkFuc2lFbmNvZGluZwovRm9udERlc2NyaXB0b3IgMTcgMCBSCi9XaWR0aHMgMTggMCBSCj4+CmVuZG9iagoxNyAwIG9iago8PAovVHlwZS9Gb250RGVzY3JpcHRvcgovQXNjZW50IDkwNQovQ2FwSGVpZ2h0IDcxNQovRGVzY2VudCAtMjExCi9GbGFncyA5NgovRm9udEJCb3hbLTI0OCAtMjUwIDEwNzkgOTQ0XQovRm9udE5hbWUvQXJpYWwtQm9sZEl0YWxpY01UCi9JdGFsaWNBbmdsZSAtMTIKL1N0ZW1WIDE1MAo+PgplbmRvYmoKMTggMCBvYmoKWwoyODEgMzMyIDQ3NiA1NTUgNTU1IDg4NiA3MjAgMjM4IDMzMiAzMzIgMzg5IDU4NCAyODEgMzMyIDI4MSAyODEgNTU1IDU1NSA1NTUgNTU1IDU1NSA1NTUgNTU1IDU1NSA1NTUgNTU1IDMzMiAzMzIgNTg0IDU4NCA1ODQgNjEyIDk3MiA3MjAgNzIwIDcyMCA3MjAgNjcwIDYxMiA3NzggNzIwIDI4MSA1NTUgNzIwIDYxMiA4MzYgNzIwIDc3OCA2NzAgNzc4IDcyMCA2NzAgNjEyIDcyMCA2NzAgOTQ0IDY3MCA2NzAgNjEyIDMzMiAyODEgMzMyIDU4NCA1NTUgMzMyIDU1NSA2MTIgNTU1IDYxMiA1NTUgMzMyIDYxMiA2MTIgMjgxIDI4MSA1NTUgMjgxIDg4NiA2MTIgNjEyIDYxMiA2MTIgMzg5IDU1NSAzMzIgNjEyIDU1NSA3NzggNTU1IDU1NSA0OTcgMzg5IDI4MSAzODkgNTg0IDc0OSA1NTUgMjgxIDI4MSA1NTUgNDk3IDEwMDEgNTU1IDU1NSAzMzIgMTAwMSA2NzAgMzMyIDEwMDEgMjgxIDYxMiAyODEgMjgxIDI4MSAyODEgNDk3IDQ5NyAzNTMgNTU1IDEwMDEgMzMyIDEwMDEgNTU1IDMzMiA5NDQgMjgxIDQ5NyA2NzAgMjgxIDMzMiA1NTUgNTU1IDU1NSA1NTUgMjgxIDU1NSAzMzIgNzM1IDM2OCA1NTUgNTg0IDMzMiA3MzUgNTU1IDQwNCA1NDggMzMyIDMzMiAzMzIgNTc2IDU1NSAyODEgMzMyIDMzMiAzNjggNTU1IDgzNiA4MzYgODM2IDYxMiA3MjAgNzIwIDcyMCA3MjAgNzIwIDcyMCAxMDAxIDcyMCA2NzAgNjcwIDY3MCA2NzAgMjgxIDI4MSAyODEgMjgxIDcyMCA3MjAgNzc4IDc3OCA3NzggNzc4IDc3OCA1ODQgNzc4IDcyMCA3MjAgNzIwIDcyMCA2NzAgNjcwIDYxMiA1NTUgNTU1IDU1NSA1NTUgNTU1IDU1NSA4ODYgNTU1IDU1NSA1NTUgNTU1IDU1NSAyODEgMjgxIDI4MSAyODEgNjEyIDYxMiA2MTIgNjEyIDYxMiA2MTIgNjEyIDU0OCA2MTIgNjEyIDYxMiA2MTIgNjEyIDU1NSA2MTIgNTU1Cl0KZW5kb2JqCjE5IDAgb2JqCjw8Ci9UeXBlL0ZvbnQKL1N1YnR5cGUvVHlwZTEKL0Jhc2VGb250L0FyaWFsLUl0YWxpY01UCi9GaXJzdENoYXIgMzIKL0xhc3RDaGFyIDI1NQovRW5jb2RpbmcvV2luQW5zaUVuY29kaW5nCi9Gb250RGVzY3JpcHRvciAyMCAwIFIKL1dpZHRocyAyMSAwIFIKPj4KZW5kb2JqCjIwIDAgb2JqCjw8Ci9UeXBlL0ZvbnREZXNjcmlwdG9yCi9Bc2NlbnQgOTA1Ci9DYXBIZWlnaHQgNzE1Ci9EZXNjZW50IC0yMTEKL0ZsYWdzIDk2Ci9Gb250QkJveFstMjYxIC0yNTAgMTA1OSA5MzZdCi9Gb250TmFtZS9BcmlhbC1JdGFsaWNNVAovSXRhbGljQW5nbGUgLTEyCi9TdGVtViAwCj4+CmVuZG9iagoyMSAwIG9iagpbCjI4MSAyODEgMzUzIDU1NSA1NTUgODg2IDY3MCAxOTUgMzMyIDMzMiAzODkgNTg0IDI4MSAzMzIgMjgxIDI4MSA1NTUgNTU1IDU1NSA1NTUgNTU1IDU1NSA1NTUgNTU1IDU1NSA1NTUgMjgxIDI4MSA1ODQgNTg0IDU4NCA1NTUgMTAxNiA2NzAgNjcwIDcyMCA3MjAgNjcwIDYxMiA3NzggNzIwIDI4MSA0OTcgNjcwIDU1NSA4MzYgNzIwIDc3OCA2NzAgNzc4IDcyMCA2NzAgNjEyIDcyMCA2NzAgOTQ0IDY3MCA2NzAgNjEyIDI4MSAyODEgMjgxIDQ2OCA1NTUgMzMyIDU1NSA1NTUgNDk3IDU1NSA1NTUgMjgxIDU1NSA1NTUgMjI0IDIyNCA0OTcgMjI0IDgzNiA1NTUgNTU1IDU1NSA1NTUgMzMyIDQ5NyAyODEgNTU1IDQ5NyA3MjAgNDk3IDQ5NyA0OTcgMzMyIDI2MCAzMzIgNTg0IDc0OSA1NTUgMjgxIDIyNCA1NTUgMzMyIDEwMDEgNTU1IDU1NSAzMzIgMTAwMSA2NzAgMzMyIDEwMDEgMjgxIDYxMiAyODEgMjgxIDIyNCAyMjQgMzMyIDMzMiAzNTMgNTU1IDEwMDEgMzMyIDEwMDEgNDk3IDMzMiA5NDQgMjgxIDQ5NyA2NzAgMjgxIDMzMiA1NTUgNTU1IDU1NSA1NTUgMjYwIDU1NSAzMzIgNzM1IDM2OCA1NTUgNTg0IDMzMiA3MzUgNTU1IDQwNCA1NDggMzMyIDMzMiAzMzIgNTc2IDU0MCAyODEgMzMyIDMzMiAzNjggNTU1IDgzNiA4MzYgODM2IDYxMiA2NzAgNjcwIDY3MCA2NzAgNjcwIDY3MCAxMDAxIDcyMCA2NzAgNjcwIDY3MCA2NzAgMjgxIDI4MSAyODEgMjgxIDcyMCA3MjAgNzc4IDc3OCA3NzggNzc4IDc3OCA1ODQgNzc4IDcyMCA3MjAgNzIwIDcyMCA2NzAgNjcwIDYxMiA1NTUgNTU1IDU1NSA1NTUgNTU1IDU1NSA4ODYgNDk3IDU1NSA1NTUgNTU1IDU1NSAyODEgMjgxIDI4MSAyODEgNTU1IDU1NSA1NTUgNTU1IDU1NSA1NTUgNTU1IDU0OCA2MTIgNTU1IDU1NSA1NTUgNTU1IDQ5NyA1NTUgNDk3Cl0KZW5kb2JqCjIyIDAgb2JqCjw8Ci9UeXBlL1hPYmplY3QKL1N1YnR5cGUvSW1hZ2UKL1dpZHRoIDM5MwovSGVpZ2h0IDQwCi9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI4MwovTGVuZ3RoIDM4MjMKPj4Kc3RyZWFtCnja7V1dbFTHFcb/5ieIEqo2KFKFeKlSAf5RRSH+wYaKvvShfayoiQNRFVUIRVGjpMY2tnmrEAVVeYhoQpTnCuWlD03BGEqrRGlDSZ5aAihCNFFF+Ela/+C92+/ut3vu2bm7a/vuzF2Tjji6Gl/jO3Nmznxzzsw5Z7KZbDbIzs/N8xnMByhkHmaymWxYzv2W5fyPLonNYO14hoUgm6Be+RMUjG+Sozw7uUL+pTOSbhR2zNqDqGFJGhNEHAVzWVB2Pqo66sNEPZmgMXMzc8KaboCt2sPv5wr4MgeX/RbxKD86ZraIu7mcAM9kwkIQzSk2Jl9eYk8+nH2oZVVPQ/3M1+WeWako357yEhW9DwoCOZ8fMuFrwTGSWvhXI0dGnvjGEw11DfUr6kF1K+r4JOmyC2pqaMITtTfWN6KA5/jR8cQQBxkeHhrG1+SbLU0trEhkmL3keraiLnYpWyKcsiVsAPs/scywipaG1qa6ZlD9ioai7+c4TUGAL5y/QAZJzY3N/NEiNKHr2Hv4uBYeVCRVY6xdyyqJEvXkxid/8cJLN/55ky2UqRch0tLRY8f2HataV+mpB6IU6R4Wfm1xxIqMWS9v1q9bP7BvIM9LZWjKsXzo54fat3SMj0yMDY93bO1Ey1984UW81ytmObGnzMxOz6L86m9e5RDrtsXL7khgBGUK3sTYRDVrN5BNPihdjRGP5CSIVmF3qiCI3HFOCQK3NrdijNhU/s8E81f0rnC21rcAlBpXNKGA769sWTnz35lwcAsA5Rqazr1zDgPHsRPowPy1Bk1Blp+VyYjO5Lojyxl6NQVZFXElDKLbQeGEmitSyxMvf7v7dmsGWZeBGPyVnrPuSDoc/d/b3Xvrk1sVxJXK/zMDz2xYvyF88zCvOJ393dnHVj8WGWiZBcwWmTgQIWlAvG0prEHSA5Q0dMLo8GiCYaUwYMpDCaTkyGcJCwIFCW2opUMH6wVWyBLP9uSVpSB5YzC45DcEgYZW4BLmCArEBOJSGqZcjibPTWp9id2OZljsTEE8rSYRjgz12zWhJaw3J2MNJKisWBCxIhjK8FJHtn9Xv+iHcY407ynMTT2D2Bi8KTLcYjKJ5t29cxdS3bCi8fLUn0N1t655cP8gCvgClrAFQZsf14yTa1I6iBTXJwsrUT2wJclaX9AVoXTFxRV84Vecs4nNqKWqcHEbhzhpWN8JGsO/YhWYGlScaNChA2U/JB2t6eKFizJ8GoEtdqZ81lDppXtTm7BFYFjXjJ7nurB2zVq9IiRb+7p2dgkX6EDRmrTRSqCI23fW56MeTWnJ22ffrqA1dbZ3cg4Cmk4eP/WH378TYtSlyxD1nd/beeL4iaKN0DIq00dXP5I5q41W/ig7TiWNXLukdTaCSUJoyuQNuqMjR7mkSn9yQKmipLHRVNDNjA6UiSN7EZWN94WryISWjqzd0Jq4sqR2hCF7TSLGumBxM1ZkUlvHRKSU9XxWjYqgFlJfIjpx7cOgyIlAAjHr6+3TiKRrNFREu5yWM121Bc0dNthrFbSmXT27KPlAJPQJOudHP/wx19+2rW2ApqhPgrLLUE9Xj9YPKUvbv7sduI3vg2BaCvGNI+p+uhsjglpQAO39/t4zr59JPK3wh7AHS24VVoMDCRZ6DEd8745PffCR/ISuoE5wo0m0Jvm+eW6SikFXhMD2qtCTlHMEdZ3/4/lLU5dQO7ARzyn8y5WdEmo5eeJkwb4Iex7TMNf59XI8V+LQanGE6WCILp+Y1LCGyCBYBuPQVC0yhc9q0szq84VIessrt6dfO40CuuVPFy7jJXpmeGiYNtqntz+VCVihZ9gJhsaCxiQ+u7eyOGpKBgh4Qmsy1pQFutQZO1K10Z6iY/2g2jkrWhPmSInvp6g1GWxahyYD5NMB3rjZAmQoKDYNQtERcLGnSjJoEpuO/AIuooP1FCdjqP8UDpdZwIpw8/pNLqzRXkSB8cH9g5s3bb73+T1A09S5i9n57N7dP4CidffO3ed/9rz2CqhwdiknR6Ino1LIWMpS7aHJQ9OjBU2oEUBhQBN7Pu+VV/A6S+A8YECTnMHVCprCDe3cmbIcDnI3WxwkxCuST4DSlu9s6WzvzMwGPKRD4cbHNzraOoBOcnYjx9Plxlr7gYjW5KHJQ5OHpsrDCn7ze9ErGgvWXEN+27+ASMlgpCQ04VkraKIMazsd6ASLUs4fDT9MQjHet2/poEB2bO088/oZMXWlUNkqNAQJfRuHpppgVDU7PMsHmnKGdn3cNcVDU7KeXJ5akwFN+mw0gTd4b3evwWOtoEmq07te1KAuXrhoHCvL9hGUovzp83ROXaRDuAp84DlUpaOoQo3G6dvU5JSHJg9Nyx+aSDWHJq01iRO+6BIJ3EKWj9YkzMrIiu505993IhdB5bQj+04h4wybmo9Oqw2HlnIDB9RiRdpxAk9Ak3GM5aHJCjQZS4CHpq8MNPGELizUN4Yul2qqJmjb8tlrMoBCXPLCfaRCoKsAkYBPXh0KCtFzs7kATwGugvpUWZ8s6SDhoclDk4emxUMTXXeITu3b2ovc+4OqnAdSPqGr0E4DKt9/733ZxxatSeuK0c7/fC5WRcdEFwe8LwhNhkFnRI+mjNK2oKmkm9ye/j0Y+n78y3ltOXXW6uvt6+nqaWlqERdWPW09NCXbBjfcwybGJkaHR8dGx0DjR8eHXhk6Nn4Mo++UUONzB54TV148B/cPfnH/i6qOb5TLpXZ+lufAvgEwCDbJL5oxcmSEBbuskeQNqtALK1SmFOTq/weaKMaGM63FqO2SJKPJyCNG0snM9dCUTFzF21y2PrTPcErBKQWXG4qQOL1bgSbtcqnjRHSkbfxHF97gOmYNXQ2uO9o67t+9nywa3UMT26yhSSaLrEGSASCdUFAJ79WHDh6aljqsMk9lHJljoVYxdFjpPvjrB7RlGNVrJTJITug0NGmuNY9OmSVAcbKc+vUp7VrpockuNHGhkWhfMbIcUS7Aqj6uRHlosgVN8bw3aYaio3Dw2YP5jV97EYuVoUm/dx0wqMPotm3Zdu/ze+B0dnp2bmbOQ5MtaBLtV+eacJ3oxsiuw/xgooR7aKreoNORpxq1UkhhJKDRv6ufJ+m2ujpu0FHZNqxIkSW74loOo/AMUzBVF43uoYnQZChLHEpR+41MiY72mnQaLp21yUOTFWjSiqhEeKWjNcmTuW6u/O0KszLahSads87I3WRkC3G318RFXLI9vPXmW9CdXMuVYLLAbx6aAjO2/ZGGJt3zNXEeKLknYAeaggia6PhXc2jS+GAxKYqxkkotJU69gzRkDPwajQGzp187LS6FOsi3GucBkRzUWBNVARwZtmQUkBLLeG+3Rq0c4o2HJg9NyZKiLBdoSjerp+EbydOranJ3LDdoMpL4QUuEZRdduhE42BjP1RhXgw2DzkOTh6YlQVMK4b01hyaG9xoeVtwuiBIVWoIm4bRW0MRAFW1RoknX/nFNPC2tSxrT3et9fnaChyYPTR6aFmnAan2J01byKifOpFoOmkJv8NppTcaVQJLVbcGQk2RgKFcgaS+yEJw9ND3i0JTndBHpBJ3uNbmGJrsGY2KDTtwYwmsacrgUJX5f+uBWgqZMbY6lZL+d5zhQDi9NXZKrHsmjRYBC7xnHkTxF8tDkoSkZNMXvSnO911RDaNJakxzug7jrIuiUYMKWhKaiGLqUFcWgKIYO8As2wb6ohcKjtVYFYSfIUawcUHpoetShKeI0RWiampwSaDLyKX31oAmwQ60pbtBpLCq6OfqRhSbUJZcBicvN1StX52bmosu+rV5RhD7s6eqJB24M7BsYemVobHRseGgYz4mxifGj4yNHRpzGS+L7x8aPjQ6PslIQB6LKzAOG62PamQeCRedrSiRscnqbu1Glnua5ONu8/NLL7FuMoN3wTwbSGoGl+36yT3vdiES5AHl94YiRBSidu3JQHVZwOvzoiz+Miw6T3UahoUlLzrt/eVdf1GJ/h2cuG6ULkKQBuURwOl1eS0MrnlaiBStMnMOHDovKZCQJN0K8XV8SKg4McoEvwCoB47Km6BtVapsUZVEJeJMuZ5RVfUOZsdtj3Tu65LXO8R1LaY9TaJLNUuMuLUde/fELfI2jKzx1VqJInVh6oIqGJrFoxGXXSOVkhZrqmgV/JD+efglQIi5tWPd1t2F0QT5ztcTjc6CNC1bSiZeMX7oa3g4TVKs1xblYJrnBDYMruVaW0xM2fWuTbBiK7oQuZWhMreLL0JKOtg4X0GTcUKbtqQpXqlnHK0EnVs3+n/7PtCR7FLU2WQydAU16ATJCfe1E3xSurMJTEIlPIBLeSMTBmdNvuoYmUF9vnyhFZJbWwSJv0LO7FovvPZ5HfnkkATSJ1lR5rylNgNKp5DTLVqCJ2634SPu2dsEl+qpJ2e7w6f7UHMVTnx0YPGDX4oirakZcZLltPRfAC95Xr1ytk2avW7vus399pv0Pl3qaxj8ENBldKoqZxmQdwWExtEqn6TAiraRMt1Kn0ATB/vLBl099+ynJe6Oj8tkw7cyQTiYcdA4GPby9twpdxYihWz7QJNPZQkvU5RQP7j1o29pmHNw7vX66pFkn6zig8vat28lu1l7QNC55+zNl2HUOLiPAVnb2Hv/a41evXMVAiNbEJWNJm8Oc791PdxucxkfQUcCgHlADA9m9WO/oIOEUmvS+OiScHcKr6NK3AozMD7AxR4dHq7m9d2x0TEBA673LS2vKZKudvCrZ6ez07OS5SZ66Gju01hWJkqkVyCMakD/kFccel9Akh0epJeCSbR8mvdnTv+eN375BTjEWXCzCPUCVaXbxuFQBmozTT3csa1zSturmTZuhFpI1tzOoAH3ovRDqM9lbn9w6eeJkT1cPlgBtxaeWNlD3c7K9JuEIWlPJrdGUoYl7TY6gSZ9McaHhBLl+7fr+n+7HlFmzak1cmC0G3cvsAD707+o/+OxBVC1Qad05MA5NridpOeps79yxfcfhQ4dvfHwjyoNdACJ9achSRZcGnXHqV441Ryqi9Crgd+M3N0KQjv/q+Id//zCfcCCFEIPAkydPnjx58uTJkydPnjx58uTJkydPnjx58uTJkydP6dH/AK2tmpQKZW5kc3RyZWFtCmVuZG9iagoyMyAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0ltYWdlCi9XaWR0aCAyNTkKL0hlaWdodCAyNTkKL0JpdHNQZXJDb21wb25lbnQgOAovSW1hZ2VNYXNrIGZhbHNlCi9Db2xvclNwYWNlL0RldmljZVJHQgovRmlsdGVyL0ZsYXRlRGVjb2RlCi9OYW1lL0pmSW1hZ2UwMjg0Ci9MZW5ndGggMzIzNAo+PgpzdHJlYW0KeNrtnb2LlFcUh/+UBAQJmEAwEoKEBImQJk1SmEKQFCkipAgkhYWdaKeNENIEIZBq00WEFIKFgghbCG4huIWIgSCKiOCCxebAwHA5d+bdmXnfe+655z4/fkU+15157/Oej/u1v48QQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhFrV9tNbWztXz936AnfrP+5fuvP4xrPX/3Y4/uVT39zdunL3LMMAz3394bWucNj57x4PHS+zvB733r4JPP4fPX9ACMCrW16Y8SiQPJAnizcoHyIlS+RCeIwDIPDb9jmeI56kcGi6NcQTxFP5ycvdFim4cPtbnh3uvIImFmBKhr23b2iT4nJuoo90c3eLJ4VLe2vnqnMQeEbYxttPbxEOMHZbLLzae8GjwTRUWUSBmWWjOsCwQF6EqRQokzEgzDca8DgwfdTrD6/xOHDFPQssK8JYLDmJh2MoeBC4ru88vkFehLGH7IingD24+sEXPALMcgtAwJQJgIABARAwIAACBgRAwIAACBgQAAEDAiBgQAAEDAiAgAEBEDAgAAIGBEDAgAAIzv3LPyfeP3boxJkjpy4e++HPT+VvAQEQOvRXP3946J13U8s/+e7XT376+3NAAIR+LLFAgTD31+ePSowABEDoJDVaBkJqSZ9+/OszQACE2JZESGoEiQ4y4Adw+Ojk4fBFBCDgmU9f/vjLsx8MECFFRODoAAgbpxaSSAceGFIpSCBYFiCkrAaEnkH4/vfjMkLUwJAXqbxOQ/ZbBPZlMSIYC4CwiiWRXqW0FB//5r2QAUKIWNhokn8Y4w0ACKuMgRUpmLcfAxfXCz+yvCgAITYIkvMsfPTyJpx5YSItcSFqm0VYyCfjxJI0AkJUENbKivO3ZewOvARK4T0MDoCw4iIEqYhXKaXT0lL+uvX35IHOS2nJDFuMhoCQO3/Rjfnf43UaVymjmvvUgHDg2oN1n6n8BNVgCVw+D6zia+tTA4Iaw+n7XOL+xsvP1MCQvw3PguSBeUsBEJoDQWpbtd5s2tmHHliYTUm3uGwPEOYUqDp3kscnaVWHLKhPPf6VAghVKJDsaMLZ0nzpWg8sqG6S/6AACOr1VWKNRP5H9LA1Mi+4POPQOQhmQ9QAN//bfzznSD2DYNzYKVSG+HcaF9zu8ekWhCplbJ8sqLjgMxr2CYLqeFsWsJM3aZsLCuvO1AOCzWq605c/rltFdrIMQ0VDbwdldAhCurK6VjMzX8jRQ1xIlyQJFK6Khd5AULO9rtbnFKJS8kD51GIPW8nURwaEKiDMzjl0ta/KgAVVktTdXq3SQj+9gq5ASJMiP6G5dI607CSKWoMwbRf46SB1BUI6ElwlqKqXO20hOXx41ywMGceIdJm6/HoecrY+QXC44KfcyXKzI5gkD1x2TpF9G0dGfornKrv/AKHEYHO4g1KdElCofpltvV8WI2RAmr2cXXUtugIh3VzvdgY2HaIGf9zCMzrMtlqn3dTqMyn9gJB+7W477el70mySfeHJXTY1lJ/eRT8g2I+xkWPDeO5V3sl5ylR62j19KHVXmwCCWxCqrP3IT3aNlA0CQosg1JrvU82l0tuInDwXQCAirDINZ8OCMAgIgFC3RsiLaLWPuxwLaUOv1qfuB4S0VeiWgnSK2cna6XXPvRwfgKpMNNM+dTWPkObnTn4r1Uoy2LlTJScEBJ+TCH5+SbWhptBcWxoKq1QKfS6xcEiB2svsbYe7wabjdEU6IPQJgkrFHe7cVPMLJVq76UZyQOihITOce7g9Cs9gA37FDTssw3a1E8H5wV9p561EsVDxe+gThIoTN8MU+D8Ksuh3WLGJ2hUIaTlWd97WeOq20Hc4OQsVDxjpCoT0DVw3CVG1Z0NHZKs7E8v9cOOo3dspFh5ewq1fplO0z1lrSrG3c43S4Gt/sVF+vVr1DG0kC5NTXGuRSW8gFI3sB1IQ5qTHdJp+2sCaTqkAQryFbeoC1gBn/5artuZB03K6p0MQ0krB5qvO7xQLcBp8uWpr3kmwzBs7Pw3b4ESdfPNjjDsR5KsrlOPN3xuWNzX3CUKaq5feEanW84e5PS2ttibP9IgI9mVC6X510Rmoui7X6pQ3hnFPr08QLA9PUH2qSHeCpFlf65+l2zvULPfJVuzZmn0uQGgUhLTcM4jCaYIU6ZJlQAgAgvHC7FpHTwMCILha95uWlmEuHJeSRwKrZZ8TEEoPztJBQd1pG6l9FMCdg2C83DG9ICNMUACEGCCkcwoGc77p8tcAGQUghAHBvoxVJ7cwCAHBCQjpHgGDjEWtwWMQAoITENQaaeNNXs3tUAOEqCCoSVKb1N3mTFEMCGNWzhhUzaqbGmNtNiAEACHdsGOz9FHdIObh3m1AAIRz2Y3w9j0rJhcAARAAARCcWJ1Kbb9djqoZEBxWCh+dPGyzZFoBSEMVELxNNJuNSbXBHxYAobrVkYyFLksanm4mRwKEPueaF+JAXAAEV/NrlueKEBcAwXOxYNnYVHEh0mlIgNAiCBXve23rSilAiA2CmmIzPpIo5EGRgNAoCGp1nPE1Z2p+wT4qqdscVCEf5iwOQNjg5WxwbvDAau3SJ7XOnW7lHnAYFgDB+SqI/HqR0rWzhCH1Jw776/NHA9TygLDBzEKVCw7U8CtUsOTzesJd2j2W70GiUk5K6yUMILSyTDQfopPvpMuvchiY0VPlQ+u3nwDCxllKlWnf/FUsgEwSHTarytXvY7McBRA8sJBWr1XOeM/f2yNLePlQ6fU3a32uMDckAsLIlmaVd6Da7zymgTN+JMdgARDGzzjX2mu8MDSsdSmPglqC3cZct36LOiCMf+7Gs2wDq2TX6q8KBerMvZHVbtMsAMJUdavxRNuBydKJM0cGkiVF0FSXu6Unu7Z1KwogbOz0aGsPS6ZVwTtwLk2+om/C4Vr0hwOC28I5ZaF6MiDv+XxphAoNBgO1xaWzgBBvK42EqoWL5YQRFTXKkateEfJHO59uA4TJX4BOmocDC0dt4tfkxTggwMLGmdIADvZzLp4vgwCEHrYbS7KU9jYtOW1lug0QysUFb430GQv24zA9M83tiQSA0E9c8DMF6fD+OEAoHRc4g6KJqWdAMGChlUmlnsMlIJhtN+YYCs+VFCBYNtLb3bdSNC5YHiQICE7W5lE+L1wlCAjhn7hUB2pWi5Ih39ZRPW8EhCoNk6mWPYfJkapXCoBgmQyo8tlbL93e6VrZumeFAYJx+ayWSXd+um+629TsED9AcFIyRD01ceRW07pb/ADBQy+94gkAfsoEm0veAcF5W7XPWQbBHxA6B2FZaOgqU6JGAISBGbcY50vTNQKEdcvn/KiuTiYa/GxeAwQ/OOTnscTGIT0EqXpCCAieV+AE3s6gViSy1ojBv8ocdLAiutZ9WIAQYN6txZN1l8WCA8/iAwSczrrmx9Z5eHlOGOz8LMQFBP9TTgvPJmoxU/J8FCQgNFpEz5KKhrZ/qoXo8su7agIAQkPbWPIKerZIyf86Jf9XJwBCjExpNrocEpGfdOdhhzIgxFu9POGtggYLSNxerwYIwdbspUOubhKuYgGnYQNCaRbEeaN1NvZq7QZtiwJAiORltYMkS/Y7HVRG5L+7BQjxrFo0xk1LtS/bfywAhNjNpYW91nmMKFS05rdqtjLTAQg9BIgBKCSHkTpi/Dx1Hob835sGCPSXFmZNQsS61YQkWvKT8/LE28QxIOA0X8pTl4W9JhnG8l9KmBh4pcu/HfhpzX05gNBzjFh4R/kYt7tpAhCYpD518diBd9EeaHWtOSAAQrtESKoz0HodKLd9Lh8CBFxogmC4agAEQMCAAAgYEAABAwIgYEAABAwIgIABARAwIAACBgRAwIAACBgQAAEDAiBgQAAE3IMfPX8ACBg/eblbF4Tfts/xFHB179fW1s5VngKu6z/uX6oOghQpPAhc19cfXtt3IB4ErutXey88gEB2hCtaqtR9H9p7+4bHgWv52et/991IkjSeCO6zX5TqyctdnggGBEpm3OfKilxX7p7luWBLX7j9rdSn3kB49PwBjwZ3Hg5merX3gqeDu60OqBSwvW/ubnkGQXI2ydx4TLhoaeBq7mCZ5JfkYeFy3vnv3n4jkl+V54U7LA1gAfezyhQWMBRsXC8w0YbHV8fVd2JO0kdinTYOsN1gEtFTxZvFgu2nt/bDialn3NA25NJVA5sX8LADVAQrSuId58Bg5St3z955fCNSRbBBo1W+AYmGDIaukp+bu1shSwCEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCPWs/wGJlbxgCmVuZHN0cmVhbQplbmRvYmoKMjQgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggMjU5Ci9IZWlnaHQgMjU5Ci9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI4NQovTGVuZ3RoIDMxMDcKPj4Kc3RyZWFtCnja7Z29axZJHMf/Cl9OY3y5P8FGbNOlC3bCtZ61CBYWNoII6dQuaTywsAhYndUJgloIauFBCAoBEQIqBLlIUOS5X9hj2dudZ3Z23nZ25vPlyyFc8jzZnfnM/H7zOpshhBBCCCGEEEIIIYQQQgghhBBCCCGEEEJoGtra3cPZ+8M/+1T1Wq8/f723+fHQX3/jwn3hxdb9dzsF0vFl//v5p5tUANzyxvYnqRuFRD7X3mxT4ljjvFmQvo8ixuaWmCHLdICSxUN96eX7bBIHeRYKFDv624+fk6ZAcKYQsZeuYbosCAUMDWGPLNAXYFxNN0yrX6AvwMRI8neSIONwvvX2wyRAoKRwaG/t7qW/doJiwoUnC8ya4ZhOFgThlNLBhYPwbGeXosFkCpQLZp0qIOBRfG/zI0usMRZLTE6ajHE682ssK8Ls3xEJkhQHZhyV9XUYEBgvwoAACJiZNUDAgAAIOB1vbH8CBIwBAWNAwBgQMAYEjAEBY0DAGBAwBgSMAQFjQMAYEDAGBIwBAWNASM2/njxVm4oHCIAACIAACIAACIAACICQPQjH1jY8gnD04RMqJyBMzsfvPpDqLf91B+Hw41enfvv9zNlzRx49p34CwlQs1VUqbV3DT16+KjXZGoTmRxFBAcK0vHjlRrP2nl65OI8Fk24FEABhuj5x806zAkvDPvQTFlbXW59AmgAIU7TU2zqwkU5h6K//8sefNQWSI1AzAWHSLFSNuV2eW4VGEmhRLQEBY0DAGBDys4T9EudIwK+3pMl2o0wYEKa1oMLEjBEBQn4gHFvbGArCmaVl+gVAyJWC3gmF5mScxewDBoRkffLy1bpun7h5p/fnT69cZCoZEDIDQcKbZsBTRzuSODfdzAiac8pUSEDIw83mvbkYtZURtOaO605Ev34VA8LkBotaAb8ehHq5HYsrACEzEKqVEnUs1B0jkvRBXP3fZn7NNgRAmNBMmVTdarJs6DCptaWLka8TdqT7YKAVEEbcgyaVMGbNN+FCEm2hkmoMCN6beqnwBzsll5YTqfBDLdn64vXbEl8RYgHCpJt6n73G0rI8HUQAgmbyVyr/KM1+tdAu8lfL18kjk1kAgstyOE2VlnxZKpgEVO6tbrWpp+k6+JcKXJErMY8XguRDWONXOAitmV8LS7ARKD9tfZHmoKSKi+ZaDjschCwQoEfQNPXVCH/3WImg2+pbeYrU86GMV8lO60wYQygWVtdLziYAoaoGUn+UTX1MFqR91sw+Dz0TQ2zRZRS7xqNAELoNpj7UmTeM7/0Pa50J42UNngA7dEyszEP2CgRBQoihLMTpF7r5cohzNgZl3AJRIWNNZQ6fdtve3kNU4vQL0U66G4RDCSfMAIJhZqrsFLzvNY585OPBoWRmOMj7yXstR4EgdFNI8/3CoWOksc4+lcev1pYYzlYDQpajRr1XG0SLkUY/BPggZDIYfc2PhdJA6AZFFiMk4fqFQSl86PWHrVO+lRMu2cRLRYHQusvApdWdx4JfEEZveE06iDx21RUFgjI78DtD7dgptFJXk0MwIqQP3W60O6w09amHokDw3pR5j5E8Ti4HmYvsG2Ka7rxDOSB4yQ7Mc+dqS/JQd8dt7D4nnHtZkGefIguFgOA3KDKcYsA1y+nvhigBhO4hEkOHTGHBiyWVWFhdT3MrRAkguGxmMZ9ro54P2tOUwjhAaSC4F5y0Y/QLQWOn0QOn7EGQjNhLC2a+EWC6J2CMezrNuCxkD4IyQQjUIwT6gyc3CCOvS9KBoQ2CsBDzPQOCRYoXuVDyW9gjCbJ5XzkKDgWCoBkkb55lPWKDnOD8ssd56mNrG8r33Fr1Hfm1FwjCvJ9Uls4orXHi88t+S0ez9jvmQCsgaAaXxtqZNXTzskm8kTIO81gId2AIIMyrEt2RT+kgxspSzeHNAwTNyLOUAiDEqVRS25VB0bgVozQQ/osJVTsg4vTLBYLQuu9bScHo29XLBOHQ/2+Ui5mpMXya5t3fxYKgTJEijBgAwqA6I3FUfRtU0K0okwaheX+oxxgJEGKCoAyKpM7PO1NUmq8QPcgUJ5fnTRDIKx163ZUycQOEOCB0D0uX3+2d+mndQVDa5LLJRs4WFOZEDD17ChC8zCzrZ7UM7avpnsTksrxbixWGmiMOqrOVasdMExg+9btm1dcckOMR8WOdEOW4fEvfuQBCZBAs7hfwntmFOBk79IC/+ysChHRAmHeljtBRXRTVzA014ZNjv5D4YmzNnZ7NtaPyFMp5gXn9AiAkAoLUbbv8TlmCjoF9svlydwBBWonekdLuoffd/TiAkAIIynsTzGMS5e+6zDWkmS8rW3jD3kp5g0+zX5DC0hxuAwhxQFA2R+btsLLFc1mqkWC+rGwrBq2LU7JgWCKAMMoybLt1jx6z5gTz5W5QZDF10m0x5nUogJACCHbLAzyCkGC+7CtoN+x2ASEoCMopYF/3l3XTbZckN7V82RfjrZ5l3qmDgBBhiUXrrXY3hviqLS5Jrt9hqHRAMIz6ACHOoHezXrXeuctNBx6T3JiLbWKC0G2dlIEoIHhf366ZLJbadeTRc4/v3ONHTXrf3KCPAoQ4p2FLVddcQy+YtKJWQACELEFQTlEFmsRsEQcIJiOogBATBM2cjq8q112qJPS1dklr3Fqh1CXX/KNC2BcI3TVayq9rPT4gAAIgAMJYO0r8ns9jfkC6yclXidh6gs/uwHBAGCWDtpu98nv+/KBdkCOc5W57/Vbow/kBwWPrZHFi/7y9DNZVy8uZ9qHv+PCyfhUQRgdBM9Ew9M1737elXNGamgctypInst4AGHRiHRCaZeRyLLyyebe4v7W1hSG162WVm/IMWVAiIK2HyfeGXmcFCL179oUOfUFXpx6Fvrgz8Q3LvfegKfOdaGf8AoLHVE5aeKkD9Rlu0jZqRj8megG9y3a8Op6UFqB6RVL5vQ9HAMKI2088Ht2Th73cH5rUEwGCcvDHZQBfOAp6LGoeLIx4byAgDN1iYzG+kX39b7UYhtP0aeYFgGBe0OYHP0r6UEJHYL71SZlkJXuIKyAYzTJolwRUZ38ViECz9+ztGtLsCAABY0DAGBAwBgSMAQFjQMAYEDAGBIwBAWNAwBgQMAYEjAEBY0DAGBAwBgSMAQFjQMAYEDAGBIwBAWNAwBgQMAYEjAEBY0DAGBAwBgSMAQFjQMAYEDAGBIwBAWNAsPbhx6+OrW043qmt/wrDH+v9dZNLuufdQh7o647ffeD46hZW148+fGLyh1WXzzq6+VBS9PLt1uWSEwhSjhbX/w29ENDx3sDmDd3mP2x4tb3j17ncJdq0CQvK+8dtbvJdWq4+cPH67ZOXr8ojAIKXFwsIHirn2XO9XZgvEMQSA8gHCgWLV24IF3a9ZzYgyNsABF8gnF65KP+2sPmV600Q7L6r2ftXfZCEBNbXN2cDQvPFBs2qSgDB/et63497eTW5s/6DAQEQAAEQACE0CINCI3cQDIeqAAEQIoNgMgrtCwTrkSJASGFsKuNRo6Hl5WLJ65lQA4QEQVi8fjsaCPIHH378ChAAIUEQerMDvz3C8bsPAGFcEKRyWriQHKH3EzzmCNbLKgCBZDk0CL0JrEcQpA9yD5AAARCYRwAEQACEjEGwi95rJwjCwup6hJQEEFh9mviiuzhj+77mEQ4GUa/ciLb6tF6JDQi5guCxtsQE4fTKxd7s1eOjua+vyAwE6R+lCHICoVpeLi2e46yTYeTgCwSTMRxfIHhZX8GeZYwBAWNAwBgQMAYEjAEBY0DAGBAw1nhrdw8QMP6y/x0QMJ6loWtvtikLDAj33+1QFhgQXn/+SllgQBDdevuB4sCjWAKSdEB4trNLieCSh4wYO8IjWlrgWWKiUHBkn3+6OUtP9zY/UjS4wJUVsIAZLFLq24+f0ltRQDiCL718P0tblBEuNihqik4BFxsUNbW1u0dJ4dIGi0icceETByQLGAroFDCpAf0CjuzXn7/OJi55BMaRcN5TBgyrYjqCofqy/52sAWc2a8YGZxzO0mCmtssg6F4e9rXhpqU+zErVtx8/Bf8LL7aoBiXnwlnmAgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQ0+hfg0Bf4CmVuZHN0cmVhbQplbmRvYmoKMjUgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggMjQ4Ci9IZWlnaHQgMjQ4Ci9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI4NgovTGVuZ3RoIDg4MzcKPj4Kc3RyZWFtCnja7Z2LcttIDkUzk9hOamr//0t3J3FicmnDgkC8Gv0gRUqoQrkUR6ao5iGI7gYu5rd5TktLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0vb36YPe5unP1PPcd7//ONQeJzPF5fj8zePOn5a8eJO4vWpz39qgpMdtpWfTw7ftuJw6+On3bGtULncKW+/35Lz815QOj70n6cYMXbO8vwHRB2X1wvntUf7PIGPoAJvk2vcon2Rqo/wjp+2Hig6PtdxnvhT+8iQ42lfL/Gg84fxse6j+D1Ix1k9K/ldeo+fRnhYBgevI7umx+RcfQChNbhcL9T/GJ8/r3/oENVCCO+H40T+NvgRzcd/WM5xfJafv3/9Ztf0aEPHOMf7FAyYtMKwBmPHDx5Tvvk6ztNs3aTxj4gcP41OXpbBQc5XPuGQcYuMxoFDRFE//xFBC76u4hz/fHmx+JAVhxN/P7uneo+fZnuGr399XezvL3//9eUvNPbP29pyMoup08/Fxp4qfBbaMjLxZwRyyw4iRxWOXPsRxePf8ALJ10dD/dvf3xD1Q42eyrn8FurJN5//1pzjYeGcl5/L+CfnO3B+NKprOR97ueX90jAPLXLY9hHx4yfnctyOTDilwvoWG31cBEL194zDyCdaHzHq+A/OOdjx/TmM3p7nzzhvG9LiiTV/xDHDS2ZH4/z4/twfN/Vy9wOAh212HcVzaP6I40OenA8ft62fxdtx3oxEct7D+cFH74icT9Uc0t+X/fmUnG/uz49x330F+/rl2w7zlE1nZw1T6eKpvq9Mfvm22xCdgp/kvJPzztlfcp6c36U/718aTc6T81FJgJvGLSwUT87Py/nwFMejcV6cTqY/T85vy3kV+VYm28CMguT8RJy3VXvdPD7HpNY45/Cbnolnxi3n5ZymTLOq4YNzDmdey/nT1ydI6YynRGJGIk2+XQ6SnB+X82lmlbw4yAsAPY/1rTmXy9eYNMWxn67vh3fiV1v4xMp6mQBvfTU87O9fv2kERYcLyId7oSG/Jch5c4o+fZzB3bp8HbUk5M78OYDx5/UPOqjnb89H5lxeNUALaz9ZjRKwDba8DVGk5bRss1J14/An8P7Xn6+0DoilncPQQf75EM7VWjyar96T0obqB+xs74/zhZDFQeEFfXl6YUFsle3AOb2+y8+FqOXepN/F8ufL27DG6lp/OpU5Xz5iuV+Qh4VzOjXAMAbeBq+XYdzan6tBV9zg9qT+/G45n3hdA/PnB+ScBdLXIPlS1L9wvjCM8wvqk5evhn/ozLjVciEah7zHLRd1OBrnoD+He2o7zuVQtHEOcYs6FGfnXBe7mOblW9OH+5Hjc5kxBf4Z9Qmp34PvhTcF0shnKFq9gz5003vJ+VUF8WNqg48JcJLwWQPjFqdkzJqwBBN1rPv9nuahVMsIOadgnCI+55wLGNiXwue1tfZubSfhWL0HPNOMYQ8eH4Oc5jqLqrhlSELanXOuFSeelHMaL0GITmNvfEjR9Ra8vpFLLOuDwJ/jYiZ9M85JB85D5zddDLZ57snmoXe5rqiukFPnAHHLdvnknZzT5WsaFauCcnj/Uq8OP1VJZ/ilqgfy/gi4vG0VtzA+Sfh3E3/eELc81D7RbnUTW+yHymJ5ehdgzIyPqsU+FwmnWcpqOSKfgDfVPWO84bzY2oTyS2Kr5qE3qXNJzo/JOY2Z6Vq6gvQUyPaherYXbXZH0UWd0ibnyXkz6hZauIZGn+m43hLMc7hm0UxE649wXlW7kZwn58M5p8E83VpykPb9+bzW4ZeSUMVtyuQ8OW9G3WcMQvSXpxecJ6qb/oX4/E2Pz2k03inlkZwn5z06HrgXj+79mh5QmY0PqQVUzzY5T85vzjk6cJqKCckq8VYCNMtd6vCzdc7ivmRynpxv6s8hdQfgt/ZDnbhlNQ+9JO2jNHG/flFynpwP0R+jeXrxryC3jDvVhJLz5HwHzouUJufJ+ak5D6rwJefJ+ek4b2DSmoom58n53XPOOEzOk/Ojcb4FhxtJvifnyfmQ+Dw5T86T8+Q8dUSH6hT9XRRt2/r+7ZHe3UhHKHWK7uA81UncDpxbeqHJeUQ/JDlPzu+Vc8hqSM7bhq6W81F1i3INsKevYpzDrY+/Nee1RSLJubOZaHEeL8YvitY6nG9dp5ycPw7n/qa55JOpCMZFJ4qiVVKkIjl3zlwmGyfnRcibOS/qoXVy3tYaw+ewWUleHn/5mZyfiHMUdx3LeVAsQrV9OO88fnK+577JkJZVUjlZj88vcqBWv05HPJaa7IeL0uh+/Flcir/cKZ9bXd++PNXqwkW2GIDwxZbjd3Z+jHdEldcr+57HM2Ap26zMgYpcAYfoBuPjDO+H/hSosY8mZcPBHB2MBp1P9VNqp3KrNhlfniTnm/bIBhkEdqXO6887xYSLZumTq6NHxZah7hJRX/6EjrnTTBw5x1YsaCjOz8T/lw+i+nVBvSxahQQQAupx6aR4iEXvI0d/aeBVW74djCFq3dArVW7m/mCcqwoqVISNjR7lnPZIYrptiK7FuZR6Y/4c30/7d8Q5RIlpGlf46+fW7R+5ZBi3SM43ukzMn7PQ5XSc7xmTO/eX1GOnNNL4PBi3yCZZTEeXuXQ1GLA4lP652FdF6hcFt7Tw+EvEAhZsEzb82p0iPt96TJqZLzjPqZ1z6sav/sfQ869K4VM+4sL5wiF7Xsil1Djn5Ca9fsQRlhQOzrnlsrZ+CPq0R4KEuDOMB8MUyIb60FVQVNNXJd5XlwQ5X9H2CUGLJSrHjFs6mzT1N3higZ9cOb9CddFbvgoHTTOTnijOQyN5LDRWb+CczotxPaQYt1S1cKKcQ9CyQ3zuzEwPGJ+z+NZ6mB7qPKl6G5OujUSMEXga5i/WUgzVVMT4al63wPOXhhQTXQa47nSanSDHfOPK3uzXe50eXfoYpVNhOdUh83SLc7rlJCfCVTc+tvelnO/tlyQqh+ScLSnE9QN3vg3pfNPSeXNCxJ05Z30V+fNo7c/p6n0b5zPRV9/pESyoPsijX332Sc7Zkp28QOqXkv8cm9DFlrIj88rIiuXAuMUP9a/+lnAeWkqKuIKJH39P5NiW7vE5X/E5mQGheoPIO6JznNU9cXaS8kaoXRfden8BWhrNb1z/3FpXaTgl5Jwdf2vU+UWfDj01YD4c99D9JxR1UOpDv3OQ2aHo5j671+hmKF3EuznnmKIjOcelLfVsqy4cjgm0tMbP2imKWIeR8jseJ+5lnEAbTTVakOy9N/JeB4pDOFcTnK7NPW1/Lvf9m5uh9M9zAXKQTF8xMJn65/FTYtll81pfnV6CbambVggtJ/D68/VQUbqVB2VOQrW45b0h5pac4zHZ7Fi9AeE9wPlN4ha1eehiyDnrZ9FfYoauCV3BnpxTj0eXTI85G2X+kG3WODMsNX+1mKQR32TBJFW1nkj9UPpg2qh+pCpuAX9etZ9Yta4IQ4TXq1MSYWydBfuCR0MdM1Qje5fQvHhTzmm+Ij0rP845AueYclm7aZ6c71OPGeSztl6+lvPaev+qOuiN4hbVP9euzzSUih+QcyVP40gBzEDRv6pLbO37WOKEkW2vm/vztlzNqq3hBomb1LWo4jPYdH6seHhxM2WUTtEBOd9asiz1Wwbqpg4Ryd9Bdy45b9adO7WO6K0435rPTddb2gpMTsr5MfU5IyIJTqXDeM6n0/vzYvJYL+dTcn44fz6q/i4Y/zfn84/SV6/1tzuUnu0QYskXZ0lHt1JYk/Pk/J44T3+enCfnh+Jcau/cinMno2Ng/9DavJHkfHZ19Yfkte7Jec/+8qac+1u6yfkNt/7P6M97OG/ol2EhXZQU6Oc8/hxJzns4rxX9axYRrTo+fV3l8dDZxkVB43mnxfyTzlu+WKdmjW3/RZHDJfUAD8651Eleyz1txXnt8VWRkKqHOw0qpLSjw3mwTnwHzmktYXIeLAZB0Ut/NDiHk1aCN81Sd6htVN9LOab5Wg42zfAbVeS8LW6hEOIJWzqiVpmVU/LD7iDUlZXft2orjfpzWfLQEIKqecVPX58iaoqgKLUYXB0oNKMKG7flX9ZX+i5COismquzoa7Xl5T5/e355esFEbihbWH5KeSV4YfVbsbSRoU5QjUbUOg6sVypuDbO4QtZxt4l8rtTULyUAUgfe42rSzeLcqTV7/0bged4+2J5mAB5loq+bvNN8KM5ff77S8itWBycL8EFvHAac1mbWLqNZx8cRg594T9E6VvwKy1DXytyxmsHr021dZ42XeLnprNIJv1CLnbBVuhURhMEXy+As5wOY0bo5Vp/uF6Q4UzMqBS9L0emRP0sC1/EkOCW4ZDfXu5D+HOVuvMyKSX/uq2vaLesq00okH4YLPdg1Dp9WD0dHLze4iLFSaRD1s1K/MdIaBp/gq4Gd5oa4jg0pjAaGduBR0c1GcmP89Rk4vj44H7Z4RfzJxHvRL90+v2Uyw0v/xpf1pLLvSb8/x7gIApXlwQEDCEOnBKXruCXo0sHNUk8lfSDrT6RGRE4rAUunSJ0KxWdGONTA+WdZ+gd+wHm/1Bh8ihoOfX6di5/59e8vCMvxGiHh35+/O3l6+8niaXOEovgM5RzbGQSFsBrq5qgXlfrkVFcwEvQykc/VEoo2IOrDPZi6yQ9LXljpoLWzdSZPSpWLOrfC4fjq+hI+nvAFPE1g3go/IaY9iD8P1uMw4C19ABrG1M1DjeOj76Lx3vvDVJvLW/0mHE6qKtSg6LhqS0u9fQAMi9taKSRLKrN//5RJZPMDXh4cADm8prEKHgHFmo6jI8rceHG4cO6J03P07T3rLXTdDx+Cy5yL7ntKzrF/UNwl6hHLZIpPSs5Duog25/HuKup7gHM1hKvtRlq8NDI+hzGnwRJdNFg97M6iVv2H2O+r0QZqtAmUlTeirkDK/QW2+FwUZ7NE8tlul/zctuJ69SMUolzJQbkEvbyAFnvFVgg9uqO1/ty5eWGpBzc41GDsmHUWtl9dkYzNnrB7ArPr9aXXevL6aOBFbBZJrn1Sy2XVAcefoorBcnHD34r1U+/KeV9T9L6TUYfcIodPxAicTjxPzTllGNh++ut5MYvz0EyfbFKo9R2O3pcjVRdfLIoQHj9+VZLVTPqKwneHuZsjyW59BbnYRaXd+/05O6yzqv/9+TttsHhef160qz/vzh+rfSiHwoYO7WLz+FOjyj2dsCPnpj+fzK8QTw3yb+pIZou6OYttpO7AnzevYxTbAfjNp2oXgWvzuGqDE7+kQvXqlnS2jFiw1XXVVwimehYHsFa1AO9T+OePlx+yT+7pOK/NZFM3WVa9okrJFfuMz0hx10kJ/qmksMo5+nNco+i5NNJFxF16cwo6dKiHF0vocjecR7YaWV4H5khA/gxLDeJNk0moac0Tx+e/iSBkFOdS5pq1JKBb5HSfvfZRq7Zud/a4g5yz4J9uecPU4D///Ic+j07NeXBdmm2CS38uF2Dhn9Zxfv/6raYUbpTnWRCBD6vKs0Rlh3MkBBIblii9n3OZoqyeQKdUIN1KeHl6wTTFU3PeXLhh6d926uVuVyzZtlihShCgX63Yd66X+rGGyMqH2UL/39LLTc6T8+T8bjiXv7GaCDRwvp0uYlv9l9MK4QicyxYkyfl2nMebCdbq/I/lfOC++a04t9YNtugf9LCc91/EO+B8H2nfuD7MdpyfTv/8Vus2VWJWm3LerEOydcvpfs4bpD+S84GcOzCM0j/cWszwaP587FeLc372ff9b6WMn52fhHE8+OX8EzuOtEO6V81Pr/DcXWcvysSHL8kPEG8f2o6kNTWunBgdpYUPrwZmAyR3oQrdvgk/zsJqpdb76pqgPFOdMzu+Yc7/Wsj+f0Mn5729W26AD3NDyIzm/D86rkvyLGyiyr3qwUnhsc8OGkvyH4vzgernbzSOCqpu1Cbebyno3wFbb6vqeOKfAPzjnUrAxXtesFqwViz46Oa/NWygeKpjvXcX5PvtQDuesxHW7zdZjcq5rwtRUzVMBTzVr2slTUvPERnFuHb8hP7CTc6qX26kvN5DzeB+Es3Pu1L+X6+vJpBWLzhwdDJXwIXFLbV6x9WTZlHNQk0jOB3Jeq12MgQoq7wG61r6PHsNPM9M4ovxQwq/iVFrhW+2wc9FFV2O5+BGWNFZnK0l1WFB+fPlJn4M9l1hthSBle5m0y531g2ai0CyfHKqeobsBDDjTyS82JUEBHCqeQEVC2CDrJW9T45xCBk6oMa6u6kvCaX1okfOqKTCV54KfULaGtI/i3NoLA41B1L23PNi5OK/SW6acg/w+uneqoer3iQNBbyyt/efHP7SNCOMcyf8UtHwr6bcXH82TPh3+/C5SH15TjF8gf/35ujXnKCUB+pP4SyuEqL3E/kyfBo3Lxf3x8kMvVp3ulnNa8o/iltQV+8n/qK+IZcK0KN5qEMP6FDRvTkmAV31YpsDumNZLZYu4BTlHbUYYsdq6/rhovNXcAVAf0r/4yPG51BWf1yKuC/CR+Jx6RflMxF5FdJCLIlQ9xa2z1sQwGp9Pc1wvpW3pngXPGJ9bqwGj2oYWY/J7is8t1K/9DggGFuef4yCd8AfndJJl9YVB/oeoDxUXQle/J61YFA26qU6PoipuoWxTrQnk3CrRal6VUqmOrHfdR3wu3zOvuyrAa9APV7t0yUAa+81R3XipHMK0dIYsamF8Lv22N8+t6ptgbwFE9k+lTDQdUnAITili7W6X1TgGo6biiu7ZObc2TT4JvyhjY8ccFp/rmymXrjewDglUgxKOOoelY77StetLHmNeHRtyqUmYfMN3mlkvlbg/t85ZHWqqWYeKu/BO63tZl6w2blH9OXNKp5uH1u6BSs8s2wCZTm9SXOsKmGm29luLXassWtiWBz0H2nzW6llQq1veoK9ldR5RA3W15N+XlI8TbjWLgZNhfXzuo85C9TzMiTG97tlVOZa3xqpkgwZCLue1oSaDRC0SgfUfb4rR9NSQqZiqm7UW6nE/Au84fGjCpGbx89hPpyG1nuKNcZF1CSTn51pviXI+8R1A9n5ln+WtxDl17JMeVOBrNVB0MtVlux/Ahn+1y3o4m1/0cG6lq0W2FGWKMtsjRt6a57nydnY4p30n749za2WY9SOW/1WIW8SjgTVPdM5B7kr7MvUs4MdrNNt9vqzQqK20UP6ytsUq9bf+3e3ogznrnPTPEXjZoexeOVfblBfX5a5ztGmOVNVhlLJ6EExmUFTc1FOXbqQzZB+Nt1tD3VBtin6tq4FblYUr6iTR7Bdmc079Bh6fLgoxheE741x2OmbN363nsp4fYmdS0RwAi3Oqph6sLaIt1Gm4IsXDGedW/539Ocdhx47w0F9V+uHgeo58CtBO3yx/xsp5s3oln5FztRvUdc1tvcjG8qAg/8TPHZXrM5gQJW8KxnmwESdmxdALSturqZwvP/Faywu6zyVgTmMZT+nP/QVAPx9Abr1RzuEjaHzOnubqLXZ2zhFFmcUqayX4Cnkpw4quz1xz0Uuc0769xeJouuoLzpByTp8myJW1IbIP52oKEJw59edyDoK5hbWc47CgP1fjc3QF6uCfOm4Ben198h79czx+McxW+8UEk/2KzR3Y94KuE5tu+QU3aGTb3EhdgPN+KzS1nl805YDWWdxTfShyaHVb7tc/x+Or+zvDObfWbazESInfzlvS+CSq6pnuOA2fczWx/BE4r+03UaV/Xtw0qWqy5iRB1fpzJxN7/1S6qo37Zs5l/oxsqng39f6WWL0lRDzq+A35wJauUa1OSzCjabf4PJ5w4uvgxdeLfFf2ULoWlosbon/uJDs5nNfeX+qmpPOwVhG6Cee+G6/Nv23QV5dhzL3qcdXq8A/RP3f8+Rbfy0qUujnnbX5+7FCwxIC7123e+f3DOJ9m1QZKMt6K81G6YU7wc4f6itMYf157/Mj+5hb+nMYtzspeZx5XA+ejNCQfnPN77SMwKhLY4VF4q+dFcYrkzMqHB29pxSKF2slafJliOOdqKkhynnZYHd0b+nO5T5Gc92fTPSbnkSTzIX1b2jkP18PW5v06y7nJ+Q3jltqq3sgq9KacB7c1I/58LOe+PsCpObfEbR7Tn8eLzpypwXnnoX7qxak5P4uur3WTbs15XG8Zs62qeGurV1IFxAamMMU5Pws5LJP8dPEVzW9kpXBW3Zz1/ipxFScl0l+iZ7K3UpSpzPm0qtBkHS2T89XgXGrTpOh3g97scHrVCiZaz0J1RyOriFh9QP9Xajk2r7cwvRRZXQKPHhUeVf+Ecsgu2bU2fFKUSzs5p6WIjh4I3p7v5TAXxXtHW/JWFGHVz6iuEJsuetB8WlaspDyMJqWIHotlsC5PFnFTWTDp3IqSgyxfHXPF8ZfszFlKf5xzrGVjNX2jOJfjjOcA6jpQ6gVsY6MB5jFurscFRU9Y9/T87VmWQB7BWIBBizextnr5+frzlf4Tr4vf3AcKLbEGUIqTgIGuRTyFkpZCIIdYv8ZXBaerBI36TFGDTKyDXn6CFmVDXb8ft+B3lzcmvhmr1OnJY0HfYjevv2Co3NaZx/UoWAkq/aeqf25F5tRpq7p2jPmGFjaWjpB1OeJ1eRiqsVJuqVPXs95iLsRN8+JV8CcuOuFcg8Yzxwld6HP5IP7cOQ2rLsNSybCq/ukNwqJ9dVIQ9OdSt1mNW+SMo5ZzbIWDTT3wgwZyrurwfEoCfviEX//+grAchS+Q8O/P32+rI6pK2W+aEdeps836wUndANpvhek3Wp+y+hP5t+tRYpzH1e3wtqIv5jddLzFeKi5LWekN1c+5JaJIvQrqA0N8DlN7+Ek1vQ+1JTR8/bm5KIBp2Or7kpMi41bbrETize59tgDl34DB2h+UsGazPCahoOpaSPBkcizt2zKA88mMW9Clf7aF+pjv06VRlAq5bXwuT742329Tf+6sYyv+dhLTuil2caeZdZnBFRipv+SXNcUF86nukFVya3JOv/g0M7F99A9DOPcyZy7aqjDUwDleMj6JPnkfLqrLSnsmfv3yrc4MvQtc/3m3L8vjeHnP+wu2bCgvCruRQxf3DzFbnNaXTy/WaQZLaIv1+BEpg7ES95J/hJzedAsG0JQBfDs2eTxN3ZxaYqah9f6bP5UWSBpByL99eSqL0K6lSms5dzZ9enTy/TruKh2hyMN6U84xaFkmoXRSs+o+KffIDq9rYfbXFpsp71/qd51F9IJ0f17K9PDFlh3OpSKQ02Q8MrVRmxJS7TtcM6nKe6Sxfbmz/DjOcesBe/Qsv8R+qZ8hzTrWOm8dNN7UQdVEzw9rfwXCgCxuWaxqEcmBMOLPy+NgPDKcPmXFlduqvNyq7fUher9XdC+R+XUjg4Tr+M9PeczT6vzj+TNP4vg9SzKlqIOk+nO9j6e4a2o5t6ir8pM+5+qUpEpHqM0D195H3p11Qfrn/35el18wj+Ljf//9779Hc+ZtOv8Ykl3nGtMm5yM5lzeLpa++rT9354M0c0yV4t8n/1zqyHVyDhEL7BChP4cBh7X05b9wonqi+Nzy0vAdcQV1o7pm1Z/Lk8HbrUU83+Y8UmdRlP2kzbCGc158RDqpaFWcs+uuxDD0xdsRg5bQeovWP4jpkw9MxVxN4gKcqzLpDfG5FSo3cE6343H5USa97+zP+zmneMv9NXUX77x6ubudz8el+Wqtt4xZZBCcywik2Z9XTTkPpWvxmUz+NtMel96lh7jl4tVZH8yTcj5qA3QU512fuw3no0q2tzaHW5xXYhDuHwo3zjBd8w44b3ZQD8K53w93zyTndj2By6Ynbn1GnlA03+bUOqLH8efN57Md57wEXnRzPpQzL8RFEykdiumssnq6k/rzKn3y3TjvFYvYgHO6lTzHWjUdzZ9f89wuu/xFzmnt+c3zz28invaAnB9N/7nBn8NU9NraciqcPOSf0wTd5Dw5P0Xcgl1isZljJP0YU4U/V2BOznnnJDQ5P/h6C85A/fos2U0+/flxOL9Okf58JE/+8eYdbUOn6mUNL8VSWykNzyugRUz7i+Yl550ihxvdR17LAKNlzLAWUcbxTUvOz+/PrXzdVQLhR16BX8fRtq0pVbacFr2jOB+SMpqcn4tzK9FiTeO+/ryzZVhri6j+PJnk/Ahxi+pd/U1JVq+0+PPmoqH+lgGjWnIn5w/tz+390z39eUvrSSOKTs4fjfOq4FZzhu3PiwaBmhbO35LzR+fc1z+3MqhXIuSBeahV7xaZh+JWOCSlZ9ySnBc5l/I+jlg3P/40M730zzqIL0+LAe1SXB12SdSyCEuGDjRs2Q447qH06AjRRRJVHAY4lyJOsKFZt95ClEIx0aV2ZzA5b/Tnk11kMSnKAxFni5x/oH69glDvVnSS6nVHSWSKnI9WQx/nYq0cldFruDpUz5wWSSXn+8QtVJlQ6vyr6yqynwVWKCPk7y+IjBtqgoFOoKpLSVPxKeTLn6ByOOR4FF1oPP8QpcWleAvVynOWmILlTvATVLZA1bxWbzY5b+acKXBiHTQvTrzkS7MLB0HFSonowvliVLEQT2C50FxwZtIlebEgdKEC/+T96c8Ub0Zwbqlvqfd7w9IoU7duy2g6O+f9GVxj1xWxsQK79HJTkgnjw/o5xudUhgJvDeRcDW79/SAQCZf9MuJLRlZ3D3km6iMjIuGu3krw0Zig+P35OxMWS8734Jz4RqdxWFFlnWqfvn8E6UNB9VFZpwzKkqeLQiSqnDrintI/K7FB9r9ouDrYdQim1Q1CyvfEeQ/qDest/roBex2ptaH6vZT/4DzUaRnG1E39OWNbyqX63YfMQ1U989qUyOS8Z73FX2qg3t6SqF3FABfIl+iFXkd8RmN/OrXe028lcG3yNen9ZYqcq4XGdP1QroKq/Ztqa+4Qddbb9JE5V31jxHQZeSNJlW6ysLZoVeKHso+AI1derFtv089XJSVVmWhLnpHf16SjivqhkYZK9Ph4p6tuPDoPPXmdhbk+1qZ/PvG1AkurUC5Z+Itmfh8u2SzA4ryh6Lta5KpGUlgRUL1wbt2tDY9UpF3tVfE4nCtBcqX+uXX7WLOeqn4TDueyJ6YMHjpltRq6/gXtKvcnWrpAy1raTh0Vtn0dUdm3lz74IpPQTpHSY3IefyLXdkrCfBKpe0Mf1sHFYauRhLrvUxS/3S+1Yyr8nsfkxLez1qVOTs7nkBq1RbQjpOyyFOxmdZ+ctzqoWWsaK8Nmp49286Z5sP6uAfhRt7waw1DOWev22tmi9bkYsEF8Ljsx0QGx+izfK+edjgsfylR1lo5h5/4s63se6bu3iV5EVXz+pg+R3jqnnvNifE45ZzWACL/VdyY59zmnTFJPUtsnVM4oIWRlvTvpps+tOPcbfNAoZRkfzHNguYgYt6jJKlVSBmweShepWP8CZ580OZ+N/mi4Sc3WuGCo402C/JwNmgxG18Z35rxOc3tapRb7nMf3Lq3TQIzpuiI9IHgM2r20Sjf+UJzfqh80XSKIFBFUXUSWA8YWmXfj3MknjAyRlULQc+mDkjXyQXN2f75PA2jZypA9fIdzfsD4vLiPw4ZoC86DrWqS84HkVxWF1T6U4+stN+fcGqLk/NSc+4u0/fMLPwa+SXzepv+/3aWPc07rRk+9rngrfz5M5Ccw8521vqX7z0Nrh+ggSxDJ+Ra3wNbrRafg/Lb9uVTOz77vf39xS3K+xdAl5w1zT0f0+GE5l0N0NM5PkX+elpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpZG7f8C7ju8CmVuZHN0cmVhbQplbmRvYmoKMjYgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggMjQ3Ci9IZWlnaHQgMjQ3Ci9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI4NwovTGVuZ3RoIDg3ODMKPj4Kc3RyZWFtCnja7Z2LcuM4DkV7Ov2a///T3Z3pzotaJbCvIBAkQYp6GjWslDvjyDJ1BIEgcDG8D4MPHz58+PDhw4cPHz58+PDhw4cPHz58+PDhw4cPHz58+PDhw4cPHz58+PDhw4cPHz58+PBx9RHewjhmvwyfo9dHhNun4PX0z37HX+XMfVgmH3Me5v887Hneme8JoQ8fx7DkE9i9b0Zuw1e8fdY+vo/ouR/bw+POf5gRQuP99X29u6m/x7L4+PRmv0csEwU2ZtMVEg7kwSz5ePLrETgOcfy+RMXnbz8+3jkegR/Eh3wcz6dIzPmRx9vLG5357YQ/DXt3m0YTAiNAn9Ud8obji+fXOBur3ukXgBxTNP4keE6wmrs74XT+48/X59c///7pecJBzg8gXP4ROMJ48Nrjc8Lpkt2OEBzyaJKDMsmTTQjnsOS3u/IOfC/I8XQQRqAn5Owm4njbIae/cshrXdyvX77+9eWv4wx+PnidMozjG/hY/tF0ELxI4dd8cBz/2/jfl68ZS86DSHjgjn/y9NfTOHp95c2u176Qi0nbffaaIe/y0etBLo5Pc26y5HfIySIdivCzQH6oGTsC5PyAm0FujPmMf+uQN6B+KF+lGfKOn86PmfJ4N4NcBBvjM3TILeNQZjw1MpCvcdX4xeoIOTAo3kQx5Pjcoz15jdfrgJAfbQ53hFwdXR4WDTCI03PI7fN2/PGAkItcC4fcIT8d5EUY1ISxAz5kTw35ju4T4+GJxvC23YdaL2LoEN2qnXzh1Y8z8/Tl2zjWnp+zwNPtPMO6aeengbzHLr9D7pbcIXfItzlPEcUSGRfdc7oeCvLU5zZAvksGy1UhP4slr7r7UrCJUEYxfm6fK76ZZd9McUu+6nmuZ7oPCHkqjSe/A1td/hAG2vdcA/JtsqavBzlqFqrSRI/grhRPFR8KsClvjXIFxTZlCnJeDZGHbW3IVy0PvCDkrLISidansORxab8KoQo5CAfkcU5LF8jp+H0gD/L4me/rkNOIrwtNGk3yeHW+P33HhHfcL+gCuciGoqON54xvIcDjmPE0P0vuCo4//qH6sKMvhZTm8TTo9TiBtUue4sITn0iFFQ2Xht/OdJ4N2ZhnsuRBseQ0b3SNjgy5CqFiVz+/IL8Rfn7/ia/2/Ps5c3ExFYTEB7RhSEGOmw7vp5uuF+SigJeeFON3cchNkGuWHP7qGS157KLTN4Il548ziyUHtMAsBbkw6T0hn9fWkaPy49uPhRVMgPwR3BU8CkUB1ykgFxDGq2Z+ieFOIN/beBORu6LKqgBvHB/n09OSh0FU9HfMe38QyDmE+Pqns+TK9wpDfFnpT1ILtwbIY4TgPnXzyYOUzWm7NLF9uGx0JQwZS47n+/F9cgwOVWzJxyd7HC1PJedkfH5V4YofeSWfXC3eb05ZFOGmx4E8jradAnJ14cnDLLG7AlOWseTqTUTvT0G++sIzDMIfW17Udm3I1cc6D0QcHHI1mpGKYPMH08ySp48Pvx3uDSAvfamv8ZOlG+Rh9sIhbzvPtfPqV03QEtXuKfaE+1GbRTDtwgQlDs/DLFiEys2m0Cd3pVedskN+Gci55aff2HcMOeSZhWccS1TPxyF3yJd82ZSkgxotqdVVnkHOloF8kS44V2s2e2UhOuQPDnnGCwXkDWlgKUueuq3UFY1D7pCvATkG+cm17sqQ0A8XokALJ8chd8iX65aMeFPuCv3z5c9LQyeIWBeXu/oOuUO+NuTFazoSPhpz+ufr82tVlC9jyRFIccgd8r0gj33yj7h6ZTMLteELbROnINd9co+uOOTL3JUqbdu26Ifwi3oVSjvkDnkXyFXOHXKH/NqQ10IY14Q65A750SBfGMfO5Aw45A75oSBvXhguF551yB3yLSGvykN2yB1yh9whd8gdcof80VRtrScT2r9UpgYzD/MukxYlTH5AvoEg6hC16HLIV4Tcpo6eWjw65O1Dm3OHfDtLvh7k5klra3R1Jsi1BAaHvG3qUpCLHJK8JOPRIO+lHqlCvo10syq14ZC3TePullz02bRDnir47aiPuiPks4qnkq6LQ543FPZckYwxb+jsrEJuV46qhbxNHDiScdsQ8qAsP92SNxCegVzt4cKTWi2JUnnI4/uiCLmUbgimO7F4/seEnCtJ0guHvAFyEhTta8mNkIv4dhXkk5xaBvKEfniVPReQE+HbQ455Q3WJN6ut6t8KxR5e4c6nGvM8vkjmlgiMw+0akTqWODiOD/0rKNOmannU40Py9/vTdzo+Pmj8vy9/Xt5e3gbWhXZ8YTk+9xPEjAHyzxjLdp2a8ymaDnlmxrjYjgL53RKSNDFddy5aovveYQZVCnLefERAXriIYeam0vF5KTSdIY8zkzw+xN455/qCN+hPHIL825fvNLrstFbplvNpPCnkaoFMxxFLYY9s/Pj2Iw/5eK1hEsdBavlquxPethsQ0vtjSZ8M5Prx5/cOnuA4H64dR/otOOZ4/q/Pr/S3v3780hW0DG6Vasm3HA55LfAQ9hcPeuGujNd6JOSDxjCDPBlF0SytgBxi+xxyLBBUzrlIMoc8Pn86Al8+8CeRKPy0QD6/Rrfcnm0gNybbHw3yJcKnHf3wOKbNOz6gdw9ccdBlmeTYB46v3QR5kJDbj4+bgp8/IIfHAuBJJN+4L2Cx5Nt4laKDWFVjr73i0kdbeBYgZ6qttPDM9YIxQw4DLiyzJfTEF568LYtwh25KLNoaoQvkG1yjYuXU6SDf8tmnos5fC1ZhOcsQMneFfGxdYJPdRALy4kVUj88jRaJfpIiXdnFXPsfXVa+gBX6HPLVy4ZcYcVcJOVs/3kKIWghOyR5shjzYLHmY7VLB5xeKc+ImxU0Uz8CJFp4HteRBbi9OO25BTx7e7TyDkpHFCRzeZx0BinfoLZQXyvnSxvgqlpaxnjmdIW7G8QXgF0Z+iaDox+vX4WO8DUeLZhwNciEXP8sZDlHzgrAb5Agb4jQy7oq6g8l9e3Us3ESYQf4+g1zERYtd1YrJD7c/fBuc8wzkmDdIUx75PPl2JP9lKk7bK7RVtSKjHkAcckyyYLsB8uQt+Xofjnc6KU5a8qjWKfWHHTNIVZ8hdXx+V/ImVhbIG7L+LH0A1RaHHPKU+9TWrkWx5A55FvIpQ3jeU2mGvfYIaEsWtV9HkaEXRz9en19rC4cLVnGZu0J65sJXQd41bypR7I9pnZzXPd2VNazcSuemuCtBrw7me4JGSJodzhjy2/Ih3HcM2YKu2DyiuTytCnJ0fJ5mNQy8u5xyPqF6cgbWW3wi/G2f0NxhIRed32mXPJ/2DMIp6aI5U7SKcCGADH5uuR+feMS5H2VphZBeXLf65DS+P32nW4+eMhnIi5VHmVRktBT/OPLbMA2HfG6NRX95GV15T7orSBZdCXKekz9FftgnIouPQIpzS9r0TLosPJGIJSEPMr8dwBunTtz7NAOTW/7pmW/GW/eH+DblZpYABSJgqfjbQv0cXMH8Zo2xlnlLyPnkCPcp7vJWzDaMU2LoTiH/RGSMbCxJIawQRbdOseMZbwJmdifRKXs9yNXdtLzl3x1yzrl919h6PmGK9Ea5yjtAzldnZ8ldsUcn2jpQ2yEX51MsW7NLUmwAeT6vMo6r1C6EUVO5G+Tp1o2Hhbw51bYX5CqfGchrayG3h9ziutdCHlfHHwrygydoccUqY5B5VUsuzicuZzs75Kphr9odS1Xr76WgdSJxoaodw46W3KZq+7VYrX9tyC2SFLtAfg0txONDnsmWvADkclf6SJBfRtU2Vf3RDfJQJ/ip8Fy/ibNSnLyq9Kw6hMieWQ75Nk+cWqu16pOuWcReIFfw9rP652sIQXSRAl4YFFoizu+Q94W8oTtbNeSbi9VsCfkaHSgc8i6QqyEsh9whXw5bbVx9bcjb+mzGO5VHkx3bEXJjIfNVIW/Yvm+A3J6ztARykS7VK0RZ2w+0GfJ453FLA35VyHmOSlUmgP1zuWJbHnW8gVciNHRPy0DeUPtZ3NavLe4YSo0e+kJuOb24ZvYykMf64d0hh+DnipCHQYj/cMjjXHqR0168Q40JWs2JPSL3uC/kqkRkStH62pCnsgS7QD4Svi/kIlFkqk2w3aHGVNtayEUm+RqQ8/N/KEseK/zwi8jFOdvSANS1DBdtgMo3ShJQZcZPIy+oKK4LZWWrZSOwk7xO00JmXDRB9VbQjkPRRHM4GjIvqJiIK1YaOlbwZw3NKkpj+N3Ei1Xxf6lM7BRZiLV1AbWQZ2529Q6ioULOFZ5xGkIVNl9NT5CrRhs7PuO1e/79/PLnha7s3z//Th0/PjGUv90gv2vZofwtLjGwPApRW/dx/Hn1oqqGV3XRuZ4GQU4FqqhRlbfPXJHskpDzx25Gnroh3i6emBxyPo385jJCzqXCY/EWXvtPV5Z3puBfObXi5pwAQlhCQL7Qko8H55DHZbltkIuJ5YXSagsYof14PcgzZVwdE7o4wGq/Kg5ennARSIEuCl9RxiIbvMJLSEmkxF1j3RWxQmxLcVHdlZS7tRxyKIBN86Op8ZCvQt/x4OVvxc2djOh6Zumt6NVX5rGr0s3x5c4v5dSZ55BLA8hq9vGw5p0jjOJCUquQQaXGLlILZzyA+B0qCmyNCZm1kCcfEGFWowTIj5ygZVG1rUqoi7vJ5DUtLTLvKuRCDtfoM0/uStADNTPbdW/uY7HAwl3BobCSpUlWH4KZW1X8ZhvI45BpLOaAN9D8XB5y0TdEhbx20zAFueqxGCGf+eQhJxXLLVXcuMoo+IkoDVT945ul1usTO2VGwVJ7egO/iYqauoD84O1UukOu+szoVBKfQOx1iLhf7LfYt1f4ofARQmpAT6adC6Gn5N1Ew5QZ5GGSbuaQq8v2jGiMCLlzn7mqfsSY3iCOL4JO/BnHhdZHd+6wkHeUARQN1OKR2kHr8hVS7oQqYcoXld0UoqLub2o3t6JAqB1Oda0nFf5DIaiYbzRZVCbJLCWuDXntAnN1yJcpm1VBPqQ7WcSrciHa3wA5Exea+oTOgiGhYNtTz8TizqyR84tBLtxFuzu0MeQV3Fa+WTTGyid+dIE8VpybqRO/Ky0M7AuioqQktioyq5XDytt2gTzlrqwBeb5oopdCozXrNQxxYo+63FgIueoC8c13LtC6MJcj5c8UDf4Fclrseiy9fHJVcbcI+RZylFGzWhH8iZ0BmEHawaxdMMarVz6Z2KwsQl7bNbtKuuR6kKs5Kr0WnqkoWV9L3nA7ZNqOx5DzF4Ac2+gLdFcmdwU7WSSoW3xML2/0lslavCrkKY3xVL5HF8h7+UJtNj9ODCBLjhQy9ekf59I0XxR4+PyOS6nN290VSyu9fGrug1hy8LnwiVaEfPkkNzs2vKEh98lTkOP/AvLMzovFAnN3JZVPZfHtG7Ii8+98NHely/GH+j6byxcUVRa1qj1KsQC5i5uxOmxhcJ/cIXfIHXKHfAnkRZ3/DWB7cMg7xuE7CjBeG/IlIv8OuUNehDyvYroe5HFijEO+JeTF9InLQN5wcdtE7I077w75lpD3Or5DfjTIz9VpwiE/I+QrdbJwyB1yh/ykkK+tD7mqPrlFJL9CgjhqXdGgAVulOmgsT1vSY6hXxw01+/GSFnt/yMN89EihnH1o2GJyGiDv2w5meTQpX6XukPe35B0hfz8K5Kv2PFp+nMtoIR4K8lTl0V6QV/knzZCL4x8KcruYvEO+uyXnJ6m21W5QvuoO+V4L5DzkbsnbRPgbKlV7QZ7qHZ+XQGxYgTa4K20+8Oo+eXDIF4nwW4ZdJN+isx1DntFFiesIuNxuX8iRhV6rLNQ9uqJUJDnkC0T4ixex2ZLH0bCBdZfIQF4UaugIuYiuUNHcjpDT1RElzA/ukzc8kYW+JX5+aAyGD2llSAuiOr62xaFlVasrgubTcsIkC1ZUL+G/r7oovBqatyTghduiPmiNNnCWu94hz2SrChFX6LBxk0XSwaipFDokbQsi1QWiz8oZqyB7DOHMeYeC1M5ObXEEF5mE3K4CeY+L21zd7JBbIIel+vHtBxwAXhlNavnEGL2nV7GAaD41vri1nDBATloQULMvQt72mBOTswTyWoyr3n+0BekaYC+05DTG60j9JmjSuNgsdDV7WXJR6o5/Zix5rAMD/Q3+GErNTEN8nh+EN5TBceKFcy/Ia4dDbvxcunyECt/Tx6WEfnjHBBh1y6nWJ4+1PeN4TvNjLm4T1gZ5R4/lodyVKshTaxYuy6O0aQ4D95lTcnzNAhSyVUS+4VQksKmKkC+HXMi/xwvPVBPbjpBX7QU45PnPhQgVn9sh0RICUsl2d8XYJ5T3ibBAnhd+jNt74Qllb4bLpwWqPtySd4Q845afRbr5mJDzJzL3Vaa24EFpsdcMeZLee6/DTEfmQWv8xzXx4kdMLeRxXAX9HxWfPChPoraLW1x7XgnyLsep3dafOnrMM2nJwsedEYzLSa4frjYrnJacYVLEQrREid4ERQ8cPrmQrgWEQiE/JRSJ4/N2D+hGJzbWRTMOeoGnYWoBWNXX8tYT52ydJtaAXBWsboAcPPBukrBgFCKmppYmLcEIcvXpn+r+VojeBBmZ4S0asVMJi83jk2puzEzaYj5wPqn2TNTNFiEpOuHU/DRAHvtvx+8ZtAbkFW3u05DzIB4Gt43iDirsLIeZm6q2H6KTnNqzhiG25PqXSmwGiTbN0A9PQZ6MTszj8MJyqgtAOHs3i9Hqo6qdLNRmtY8DeSzsCWtjT6vg7xfqrGoYbXxd7rkzf7yKblM8BwPuCu6y2OeXil6au8ITEkQce4h6nRQVw8RyG2Khxea2tZDnNcn5d+TzcxZV2y41uap7me+al1p1wjGGz4A7iIvYo29mLeR8212I2MdpA6mmIUOiRw/ez6Vrl1QAxT45d1FUcSHIRxctjAgUxK2IhHsm+jWfpSPzcsjzbVPiXkLFVNvX59cpIfDujnLJdx4itoRKBOTiIorH8ZSIGAqQZ9wVbNROxQWhbts9Pnlj2sD44uf3n+Sijz9v+Q8GyEUzdxFC4atm4ZM75HBHYwhTkNM1HSfw+fcznozjegqu5ngREWn58++fNsjFWhJmefzE8XOpWcP4GwLGAjnZN/644c6VHp8PJkuO5wtBzlNexSYa/RzPGf8c58cOOT9nnlWbKvR+QMjjXjYiP7zCkt8NF8IddHGBOl3B8Z8NllxUNyB6wFN5Uz65sGzqjie8hTi3xC55IUOUzCcfvzXFl1IrfZolelv+ootkmCLk3J2jC/QgkKt7bXwBXlU0ARMtdsOHeQu/YiqsfRudd6yAKwt3Gl5HcnLCzF2J3YPlBde1lUfCzmQg5D2X6SZKdcfopQNzScirBD/hdauQixyqYvmb8aIIyOOKNmNujIgQrgF5vrdgaofUIV+jat4IeaZlXhJyc/JJUlo5DXnc2ixjM+0pMV2kM+wlOancqtw8OOQ9FPPaJE3ykDfqh5shL+ZmpMpOq+ahLbek+f35eUD7bId8m8Qw1Sev6ly8BPJmAdLds+OM3yIv4OmQb3x9FcizKojNkHdR2d0X8l4qwcvVBh4L8lDNYVmpqR7yogW7AORLzh+PyCoRsEeEPGgQBmsnjjLkQSkKqE0ltUO+Tb50R3NdtazIQ75cQ9LHjndorWe79HPfhuH14+fTl2+HelJkIDc69g65Q56CvHlhuBnkbsmPM5rbkTjkKuS15XLngvwscnZVC0ajxmDRue0I+aFClBmjYdx4OhHklt3DY96JpsqaUu+bjM7tqpBvJulQBTk2g6r2L06B98EhV88Qv6lN2rdAzt+zVC02DXlKMaY2bWAJ5KnclVrJ67NAfljOLZDHGRepIOeOkMdaWKmKjJTPjJKcXtLNKuR5mSyHfEfITYKfB4CcZxJSarERcqRwrw35NSw5z1OlWlT1Pl170y0vNiVyX7HBRKq2t8odVlSb2p4WX4ogUVSDWJECcIprGKsXjG9ssIIaDLXGJ1N5xGvfcKfYawzzTwpeLQLdYF4eohZNGNMntiecP/igtKYqr643imwLyJ9/P08lEveKod///C5eXAE5lwyVO7NhNkW83KlxwahBzrUchcxdqlqfl7+plU12ubkGyGOFmbj8rYt0dq80EhCOqU4ZkyNAPnssapY8Y8Hi9DmIEfELKo4g/F6RWF7dYWEO+Ux6WmsikLHkgBx9Z/iJdYcc1dyxi8jvuxQnu0k3Bz2okuFtm5HfjplBHomtFbUEuToQ9DE4yeIPud4C1Xh2tOT8cU8vMrouqruSqcFcAnl846t1i/H5J9dE4VieeUqedwOf3NIiMKNwRfOcTxmNLblcrPEO5kFqZhaVLavdlTArlM5EV2K5KrxfhGggidAr+04/WlDcLSEudMxCZi5OtVfapyqXqmw6zN0texZi7K6oZXp8eYVL2RFyzgZoydSQqqq5IkqwEuQ58hPakqeo1j8s5FKE/32wPApTkIsncvyay1ryx1wXyOEIcS3BXAgxSMHquDC5TQR+Semu0EKsai6wjU8uH0ZhSPVB2Ngtz/vqDTt9wien9dqg9ZJQlldhSno3tvIsuytcQjyUWzSm3BU1ALs8r97Oj4gOHdknb54HHk9eY40wD4w8fW6IP31sqYT5/kUoZJcJ8Z+MHrha1d5nQXffDPr4InPxpVRcxdgOJiOmxIXWV1KdjUV6L5aSzSUKFZxWgvytolTfCLllx7Mj5KJnd97bb4Bc+szrQ36K1L42yG/qbaFzsm4c7SHIafDNFOFu1UKeAmwVX1dL0Er1W1nY2GvmaDF3aKUsxwtDHnef75uRLoRDVcgrsnNr3JWFPdOryt+qfXu77Mw8+rHGwvPaFWTxzq9YHHUZc4uqW3JczVScPAN5VVLNAWs8c/28Pr8vVy7tJZJ/Lru9HHI4LXxvfQ3IP57pnw45Qa6G+17+vDS4KxbBzA6Qh20Lme8r8XFOcO+Twu3yDgunJnxhDs8aXzwPuUgvabDk+UWfDM2dCHLRKePzuy+35BcgvAFyTOAsfBRWh5yvpyyeUpu7cmrIZyHETj75Y0KeaT3W5ToWfXJ106d4GhSaTvWdtMvKVfvkby2QN28c8zYr44vl7kqbCJJDvg3k6v5O3CfxSpCrva4c8mbIl6d19YV8ocrrZSBfCcIHgZxnLZ4C8i5pwCeC3Kgt6ZBXiVAdB/L1gDkX5O3Zkg75OmrDvSBf1Sqe0Sd3yB1y98kd8gtDbn+gO+QO+Xktee0myPJ7Jy/CY91USodMCyI/YV1IHPLjQN5Qe1grZeyQO+TdIa+C8HEhf3fITw95Lx+7Vv/8ASHfRV/dIYc+uV2mchfIu1TTxyL5Fsh7JVatHYd3yGPIU6q2DZ2I8xojxlyXzAp0R8g7Zg865AeH3FIEsRxyLvUT318bQC6Q7ltNv7zjs0PeC3LVei+BPFV0kCKc3q8rgG0IeXfJCId8G8i53otUz85Ez+YSDXRT8BYPsZQuCeaQqHJeUDTmWQiK6mJ0tuhNLK6O4+dF+Lnq7JI1hVBcfCjIe2X9tVjyIIVnUWda1u5j5WBqojWHFmbZojHI1VTo41K1gXbI4xkmzOJOE1wqBPXLKKHKuFvFFGW75rZb8u7uCi/wfP79XKyA45actASFaYKa3PiT3kBmfPxpERfCn3/I0LFnTVKDzga5sOF0YgLy+Mk1fvQ4J7d7Pwy/fvzaQFj+2pAvqQ9qcVcivZdcMXVQdEjQjooPXjRE/6QiMq6dWHRXeJRDadcSBfTs7gog16WnNYkzeE2pDgKrEn4Zd6X56y+HXKXFDnnxCnLa850sYr8i74dX7ajGPjmp8g757mbz5hTNfviDQ17U8VvXJw/SVBbclXfFXeFLqljQnvx2Wn5WaSHSTaG29uiSNiCPH+mEcGV1suTG6FAqJNVsx64E+V6VQZAYyu93qJBz/4R/EdFqivry1EJeK12YCs2l6rLjkCCPpUCLlYbdki833Zf0ybd3V6qVndLuihpegJfC15IWd4W/wFI33wiDQ57xoGKfPCOmhM9CT5+8JRefJVYoK1mwE+mTd9kvVhr3vE9qw0L3NdOMVd0Pgrg0Uff6/Mp/g75O+KV6xUmnZVH3t1jsiJ3Vh8ZdSIr0znoEhJti9u9/fpOJxm9iix07YDxkSq9v352dFQnuWfpGQcslE5+8DOQraStxbRzMeaaTgmp8xv/1/PuZEzUT/roDNsJPL/IW1W7Z8tpW/EzoddEyg+fxBZ0qbAL9c/ya4/+NOz7AMgNL2Znifu/TFGEeMt8Ul2Y8YF81gKNB3nOEaHXG0kW4X5GBXL0oEEyT3WnnIeUbNmHICIF2jCpw4zy++GCMTYLw/9FJE50j6KbAX027AKEcpRFSWpD7448z2iyjh5dKOA6FreELW/JeUuQizoZ0lHjxVZvnzOGhNq9EC3ZI4cDQjZDqwlbrl5Yllz+5uonxhkHdjhfBGZw8sL+JM989mdGYZ3iDW8697kkc+PNoeMTQ+0XOA18g4Gb5++ffGY/lNJCzdfps5M2yfWj2HDvRCHcUffLUJE89he8Pdw4Jf+Lzx7Tab6LPgivcPCj6ScvDmbuizQzO8HbO75OfM+2FldwMkcaABTL2T3G/ZzLcxBHEHXR5n7zZMxcxXjJx2HnnfecbIOfbf2QM//z7B64LZJ/HT0SUY3n8v/iVYcOJ3n/++4/YHuVzQmBjfTquOrk8Ozwx6owcx0a4f87zFmbd2ViyDWVd0oqbhjgOmXH6FHp2/Pz+033yKuDpcgNyWPKW8rEw6RjzFdzIOUECC0n/yyLOvxBynAmxWjYOzBtH1iXcrf/953980ZE/baSlpVpG4okwYkx4p1oajWyTT56RzD0R5HupsOIJuEgnfP6Ix5KN7/iQZfv141dqDdXZXXm/LzbDtGxUs8XUxHgiipNP4UQ6ZuaW4UFU3CzC98AJ8LbUsi37/c+xYh3f0Esaei/IN+tUG6dLEXIcPA4Gd+N5aCtu3grjiT+pjXsXNc/Vz82HEOnEiLpx+ZYJV3IHg+7HVEKapVUWh5aOj1u+GMWaHovvs/B+yzw8niXP55cSk+O1wPMU7jS5NxQfFhZp/CniD0g+F5e1i5Sc+Nz8bPOzGt9cvImIH3ISMn1FTR032OyJHVU44ZkeTHwTGYnr8YPYOA8PC3nsQ+KpSheIbAhP1YajKFb63F25xVXY+3sN/XPThND50PaN/XzIoYIv3WDJMQ+IiovznzbRQplwnD9CYXXz8EjuSkYzHx4L1u88DkCXiUIlcYiMkOAxcB4ttCdE2Us75efadsHIo84nrnD8ZFSkZtxi7GEKYybP/71wk2I+C8dxd6XS6Z0m/x4twfJNUApjInbzhQXrrn/LPzfvqEzRktL58PsOt3zzznLqc+3nP9uTuq+JRL225Ti7jM0WmHZjzmeMbJ1IcBIdlpVaS7bYpJgAtq27n7/yudnNMt63PfPEFP4bcd5iIXmK1z1sIvpnGc8fXgqYb5kHt+R3wyW0HWCWMc9c4QoLNLF5hA1rXOvuDxr1c1OQiOVzPr7N3d2phrTJjM+W4e+zqJQ4/2J0BcehBWzLPPjge9nzcASC3rPAIBZW8xaWUybt+yzTD0UHHXZsE59brKqG31L+UJZP26yggnmI5w1h89tZZRPgp/zeqEdq1Tz48OHDhw8fPnz48OHDhw8fPnz48OHDhw8fPnz48OHDhw8fPnz48OHDhw8fPnz48OHDhw8fPnz48OHDhw8fPnz48OHDhw8fPlYd/weog+OiCmVuZHN0cmVhbQplbmRvYmoKMjcgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggMTg3Ci9IZWlnaHQgMTU2Ci9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI4OAovTGVuZ3RoIDE5NTEKPj4Kc3RyZWFtCnja7Z29jlw1FMcfBSQeA3iC0AQJ6INE6oT0+wCkn61Du7tloFyli9JFdLNdRDXiHTjSSNZZ+67H11/X1+cn/YtsNDOasX/3+HzZPv13OiGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCj/Xmze/ffPV1or7/9ru//n7/5d8vjJtNffz0MZ0WjQ3MAEyGGECAkRUn8vrjw1HMC8wATDoDshhdXV25F7/78x3DaBwYsSGf//kcf+Pbt39gZ4wDoxn49cWLi+8V26Lfy2BaA0b+FE7cn7LuXHy7ODzYGcvAiH+ifdqUT9DAYGesARMyEA+aQjsjNooUjTVgPAYuOsDnz9GmCWasAaPtTErQJJLXYGcsA+OtTSkAaGZEx4cjI2wKmLVBk0gvTPJvRtgUMKHRSPlM/ZbE5QxNA0xeskXWL22dYMYUMBlB05kZ7IxZYLziUUrhwGMmMaWDpgFG9Pr1q7WZFr0wUTuwBozox+fPMwoB2BmzwHiBc/rs6xXt9u6GkbcDTHaFmjKlTWDyCgcwYxwYvcSIY9PaOqG9A+NFzRJAsTYBzNpqY/obaaGxCUx20OTZmcRMIJoAmLzCQQgbzOwOGPFD7j/c531OXtAkr6RPb7/A6Ic9o1aod7etmnpaaPal48NRbItX9MnrSdAfsir8oYVmAmuT4VRkB00ebNiZHUlnVzLeLl4QzFhTYadcdtDk9elle+Coos4bog/Xh5QZzz6ZQRcO1toKWmjGtB6R59c5MyV5++ygyTtOhP6ZQYCJWI8qwJQETafax4kIdRrCQsnvkiGyBkwkCHKTVd7plF04qMWMVx+vKCMlsJTDGdxryvMhJUGTx0yeuWtES0aNfqfST9ziIy9WpbrDWZKUK2mh0Xkhj7fszzw+HDXGFkI53cjtGVW90FfMhJQETR4z8lHppsadkRWagsLFzlpeuv+RqjofmJFDDl2RFP/BARP6qOW/1Frsr5ceT41CADHmJYMcMnMRvKbAeCfQWoibDtcHbwpkSWqa9ygJmjLsTFNgvOobtYwOXnfGUykOQ3oXTWtgPK+P/uTWHlS2x5h42lUHYLz6F5PbSDpuykt/eXZmEbwOwHifJhEofYONVFI4SOyI6AbM6fFJBUzugEFTGK2HdqYnMPqb0JjRp8eviheh2egJTLjZivkdMGhatDMuYO8MjMFs3uYOcHY2Q5jRXsSZmf7AZJy9j8oLB9mBhtcR0R+Y9B4SNELQ5JHgsmqdgSnvykBrCwclvVuenekPjJdaZJtVI5Vsa4qX4/sDQzZvR4WDlPirTzhD0LSXwoFXGdwKGF2/oJwNMAAz5u6GbGa2CqufWhnxZPpkZrLndARgvIwB13z3ibLzxnkQYEj/blJpyigBDwJMxUUWNY2yhwKG9O9WQVP645kIzCZiWrv5jekXUI4MDMz0DJoSRxtgqDStunopAszmzFjYyD9U0JTykMaB2bYrFWD66HB90Bs24/l2gEGr0hoAgxbjpqcGH2DQU27w4rmgAIMi9aYwaAIYFI+O03c+Agy1g7DnpBsw5GHmCJoiHXebA0Omd/PagT7s8fR4s3/PZdEOMOcz28VU7lQvX/7m5uKHZ896To3BJSnc/DWHRjsWdQ6nd0pUxrzYYjJgJKyQpR+PCGBSgBGnkQkFmHRgyAwADMAADMAAzO6AOV8BE151LV7Q7d3NHG7z/Yd7fQaazp+U7F40BYy3g+9iAmSP27W8gz2rJ9/sACNPnM69JzKzr3FYNClxiaVd9VxYAMY7pN0dKRYuPfI/4V2cu8Am3MYiT8diyVIenPAWmPSdjBaA8WiR4Yp7KeHKNfhVwt7R0CmzGe5fSARgbmC8Kz7XZvZ2cWW5Z1tWObTee1MOWZ0YmContFQ5tLnpppXyr6dbiy/a0omB0YNZctqAZmZH7Z15rcXyj/h6PTEwFQ/acmvTULG2a+Cs4mXpTzMIjHbq6u4HGefMLmcWEs+CSLdX1oDR81srbas9otHWo+pNaBECpwTGJejqXhQ11GGSzkOrexjUxTVuSmAamQLnyYxwYVmjL3PxyCOA2WNWvN038XYuzA2MS0S0vkho84SMi2iqe+C6MvJUSW6CcxF1COO80xYdm9V96ULvtPoGt3h0qXHa9Z04YTVN9MvPP1nYm7BVd8Te+4XCfUnVLYwFYG7vbna6/6Vk52OHyxAHUcm9bxfzveHeTHkq50CldUbLy91tvp/FeRqLxxDVasGy06jc6Ce7VW+E6kCjLKLN+2RdUquuxR7q0XPORt2ZLblKY79yg1l37RgKmBaHgbiVzuDla275qPXbndUaJ8NZ3RoMkmWa4AHUweY4x805B7XKNcE9zy8aU7qLrCQtqRsbRnv0aiVkdBbL7CV9ugM8e2HyGvKHfSgKk2k2g6N427+M7doh9fLkY26E1NWftbvSwr1vlmlZ3DuQ2JQrs6AL/aOdGxYvi8ifKUtnuE0SWha3F8nsR5ZpGeqwnjJ+1BB+53joFNIyZc6/VmvQhsWaPoHh2u3V4LG4NunK2pQjmXHgwDhZgmEltjfcce/d4Ln3e5nF44qTU71qiRBCCCGEEEIIIYQQQgghhBBCCCGEENL6H4X1BJsKZW5kc3RyZWFtCmVuZG9iagoyOCAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0ltYWdlCi9XaWR0aCAxNTMKL0hlaWdodCAxNTMKL0JpdHNQZXJDb21wb25lbnQgOAovSW1hZ2VNYXNrIGZhbHNlCi9Db2xvclNwYWNlL0RldmljZVJHQgovRmlsdGVyL0ZsYXRlRGVjb2RlCi9OYW1lL0pmSW1hZ2UwMjg5Ci9MZW5ndGggMTUxMwo+PgpzdHJlYW0KeNrtXTtuGzEUDJAT+RjyGeQbOCeQDyD3di+3glundUrBneBOcGekEnKHDGCAeCCp9e5KS87jDjAIEiSBuRy+D9+Px3/HoyAIgiAIgiAIgiAIgiAIgiAIgiAIRfD653XztFlcL378+Dkat79ut8/b3dtO+1ke2Hbs/9XV1TkMpljeLB8eHz7/fmqHJwWkb6ispRjE/vp+DanXzl8Q0H6Ql2+Jg0Bh5/voScgd/hnOBv5XH0L373uxMBrY7Q4xBLNg7eKaEPzi2HTQKk6H4vBxOLWZq7sV/nbqBUDAT7lSUrk9AW2WVZ4vv18qLim1sCBanJ5CdruonEmo36yWEHd2i1JtVlEMOwBbmbIJmy4SoaMiYQSnLlaeur4wr3P2UaPdAK2Oruepvp1nvCg1i8042wUcbB5E933vsbLITOD3c3Bu4cxE7l8zAc8otoArTNux3Mgytq1t8Mc5KNWGT2zDxxWsRTw2b0ei6yfnHflMecQpnYnH3t7pjXic853LdVbFBgHA4wwzRDY74Pckt/EVl90H6CiP/t7M5fGU1+frhnL4ONjoh7IGUQpv+7z1aOtFoo3v+bI4NjTXarhjDofcZvFUL5G1myHJTi6YUq2DAkEuRJLEZYUDtnnarO5W+HX3tiMJNNmNIkxu2hQPSa1LtlyZoVDBevhYpFRr//hnllCeHaMKGlj9zyCSffpBqpsAzoI9qmzOtyJJoj1sgHp9v2a7SLIVnDBTCdjqXwYqw3oYLPigxj2qg1fdlQ1eIomK8EUlFZts9yNfCjbaw4riYKt5mVsAyKlksJhBm1GFzbP9VtlGP8LoSvWUDXPinjZEkF1wFR27ulsxh4W7m9/ZqhpsjKV88MdLUhKcfgGWnbkxp1bvrY1UzKpxqUyQqorPrzoB785PyNFIJKcQzGIFGC7y4NllA1+Tlx4eHwgThcFVK9YLb+/gVNdJ6Cg48+5CBFnnZ7YFPOOGE4pKwpkYorKBRHMarxCVtD+u/1V3KKHMvUIFnNgQrCZJUDaQ5Mpub4GYT3CYaaeBwYL7pTLkDQvclYKrz9yH7pdKu8PFIhJe+h38Ujm1sLiI87imMpiwSdswOStAGqMyxNUn9UZsrYWonHqTJ43AiMqSVE7qxFIVordKZVj/pFTaghlRKSpFJQOVUrCiUlSyUSkPthkPVlTqXikqR2zy1LknUdlGDFaZkZYyI8pXNpOv5K8icE1lySoC8toe71SWrO1x4fmo4m7oRtGO0fZLZfAqy+wt/4uNKmke+uNomytFpetOLlE5Avz9lU6pLN9feaTvenZKZfmu5yP9LAKPVNaaRUA+IcQjlbUmhJD7sR6prDW350j8DoXVGB6pLN+AzDnjDjz2HyvBk9ypO+PuaKZf8nSy9x+c/jW0kOGlMxy/cCOodbp4uoHGjZUgmUVJMkGdbVj0Oai++Lp5Q5LZ6VjG+aiycqpJ+EE/lPeivYOKR0cl64Rge2fkSDmUiR+Er/9Yi4lj5vGF8SqwQ2mogp96hHT0jrEdfj257iIPMqK6gLaCi22jaMdcS802UIORnje9wJ71WgkvIH2umXrvwLvWkpr9Ni3I9pJUhzmQQ9vh4TNk1sadQHmzUWGDu/Xb5+q86JOp9wHOg9NomD2NYHOG4tnSebYVGjOUTc5Sokux2cAXjagyasboN/ldPUM67eX+IjYbzoUxv0R8KdmMfLn2vKDoG9u+iEVPuuDDmxHPhj+tpx1ZXC/aCwLMKsYVfbhfQm1d92xf2k1PMpwER0rJDm9s5uZ4TqjWxpkdiWfaZEQ7L6Xw8bYJWea7WKpOyWfEVU8DcZZiphpVNfk9488B0GYVhRRLyh4z1W+PY7NKCTfMX6r5m7lAlfRv7bMmEZY3S7hMF1e/UKG2QpW5UdpjCKX7BWeI6vn1Ffv3PQSwu/MdP0U9FFM0WfRBtokyqzA7zolKQAs4k+Al9UbOBPQ2Doykr5YGhkkdJGtZ+YX+lB0UBEEQBEEQBEEQBEEQBEEQBEEQBEEQBOA/vT3HdAplbmRzdHJlYW0KZW5kb2JqCjI5IDAgb2JqCjw8Ci9UeXBlL1hPYmplY3QKL1N1YnR5cGUvSW1hZ2UKL1dpZHRoIDIxOAovSGVpZ2h0IDEyNAovQml0c1BlckNvbXBvbmVudCA4Ci9JbWFnZU1hc2sgZmFsc2UKL0NvbG9yU3BhY2UvRGV2aWNlUkdCCi9GaWx0ZXIvRmxhdGVEZWNvZGUKL05hbWUvSmZJbWFnZTAyOTAKL0xlbmd0aCAyMzgzCj4+CnN0cmVhbQp42u1dPY4WORBF2hPNMYYzsDdgTzAcAPIhZ9MRKZt+EyIyRIbI0EajvcOWZKlkuexqd7ftLpef9AKYnu+btv1c/2W//PfyAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEyOr9++Pn1++vT3Jwl6NOOIfv/7m968NKJJB+UStCJ3d3evXv1xDI8fH3/++mlqRN9/fH//4f3hEdFnv/zzBcQYhtvz7f71/eH1KoEWkaTQVQx88+eb5H1ojG//ektynp5uqgPaVnJX0nda22tuQOtSIhItHAlJOfPhaZbPtNAloUriZdig6DXiP/3w7mGTe8fmioYMCvVYshj6B2t+h0BSMcvwfqIy0cX9qELfnFgmoNMZlyRLRRZrQSqWLPlKNgZPgeSS/Cv05V2pSMq0t3lA3x+LypGS3w1I7SbcILYEEyvRsPTfknarZ6MiuIJJ2crnupAV8ZTSpIFjlUicFCmgKpX1MTaW1PcZIRYz4VrPIn4T0jsgW72dU1q4AWxkNReLYrK79nKS5LZNV4LHBb9bX7WsPExmMrCCpGhXNrL5Gr8bmWGVH2RblOxDm2Y5mw1XRbcMIjHVlCSLYpJJ67EVGwPikGANu9jPMj75LCQRBQrasMZlCBFCZUqlFdSWjcl76mvHoQD7MiceFxS0DOBIGcjeKEnR5Cmxgp8mmb7ww5DMbYXYu8n6xbHXP8sqtHLWpkY27CzdPfmUrcpsSlf5YHMkhEw214xsXJOQyaolIUTllxONnGR4lUnuh8BDKecnZeNqhIzDJpt8S54m7nYcUs6ysd8oZKmDGzaajQMMoGKYEOIVbcnALjldpNZD5DbhavAXglE3mI3JWJyxcYU0YuzB0WDZ6Yglngw2sqNNvy9lI+epk4T1AErITKUnNrr3sqWCLuUCiGZKsO7h3UPIXA+Ifh9eTQds9JrRjrNsIVLNPrUkJItQTrtkk616Hf5ISnhlI9ereJWKid8h96BiUcu6L8W8GUkJ2iCy7sgHG/3lsjk3wazTF05RFklORIlFjKfE48dHl2zcrByYtFgxW9G9K8A4sobnfBzVDRvdeDSsXhV17IaNsR3ijI0+uhGzpCJ/mUfHj1jtxr8sPWs2FHX10SNPXQMmZI9m5x6VNruyTj5i3fzfkkkcFLqS1FaCsdk+4mGZwZHL1yNtdzgvP2msO1CF/6vMSSnApS/uprq/Cm21GxvbV7FxavGoJ854oymjTjzohLHZ72fRce3sNa8ri9uF2urrM2VL01mMQT4oVSKScnoNpDKTcQX4tWzkQTWxHrsGMy83P0a2XWQD18rGl26LUoubnKtwuU8tX6CJMJFh/4YRafdslDHGpE9fmRCdjXYqyur7feobu2ITMRaqOiuIq2faUfeycbrWV5Z1PKU8iqzvzJs9+zRuEpQVZYG9IQ9uio2ySmTvB2lESX6nR67EQqxgzCro3ZFKlQ7RUjk3hmzRTXfVARvrccY6PcDGJqdXDe694upoZR5KhNQLSBqeCjWm92fviUybheUNhdUBNtrvzM3moLOlONnITI2NVFojs2w8LB6zlU522HjMGLaT94yPb5LHgcZdGJKr7JZm2wxLKntqNiYHXBhk4yy+TM10xZTTa3hku5DlqgnFoasJUdbnDvTp3WXX2cl79mOj0luqd562reGxg03VliQFKr1pacXtFVyO2cjh6KBVyTUO/5AzEOI2pafhIO5SCyEpMr3KwiAbWchn/V8+n40JWa+s2UWKLRmp+nWT5gDs14TrmX09MaF4auGiCsV1lXEkO/uXw+BZoUczlvh9YSzKUedZEy4xqqWib85G+wXhm5GZUtt4sK+ONbko6t5gkvQqud1cidh3ZJRdw8pI2thx4YSU/3GToJSBHN4c30+9t4JiMwg2Fxvtm45ZYmTdwzhpqJjlSk9lNvxokI3yZbKHs4GNvaf9QCPMrhbChOc2ZWP2ZQZTUbHxFmRjfQ3PLKdCnVQZdnoiFmRjEGLk1gVaZhPW9DT4MvIpeTeBeAlXQ+EfPQp+K9h4oCdiQTau/CaJc8ebbjBKLjDYuCwb95ZDtEW2lAhsXFk2nrnF+Az08jzHbAT0mthsLyR8arARbAQbF2fj4LnS+69hN66G0vl+AwqHNmsd3bMRdylWbtK9Nd57UXNoj3s24tK6epXRz4YcYFxNMe24I16vKFNqIMcfj3a+ftgsNrtWFwRHvCvbXU9i70UGjqtteeahrJMcfU0P8vlKswPy6vDfst/jz1bQdKe1dALXGFdKkpFScZ2eQSjrpAum8nCSk2w8cPIt2LiaN105G018GbAx28++7NXbh9lI5g0pdHJnQotu9tuyMpZ++PT5ieQwfcPe450blgNZtpSA5vej9bhqYZiBimy1EbRSE0bYONfdMVzCF5TOsmhuYhlh41zGElvjs1gXPcBt4A31GtiIpMxJBdEwSmyBjTNKmLZXVMzrTbc1sSywcYXghjP0u/fqWjbar5TYNJwWFI+d6gouZ+M6sV83qD/Pdi42TnT4vJ6lXSov0y9EfC0bHei4iY5CbQK+hc1fqsJT5fMK+jo+0sQZG91ot6tOV3B2VfqFbHRWrQo2zrs0c2Wl9+rr2/PNaz7aHxtn96M3W2acdRT6ZuNEF1weTl67Ef5KN7QDNrrvRJ60YlPfXC7Z6FVHuyTk5qW9U7PRgaxYh5AxFcmyCre3u2GjPyd6V3/cpOHT+JrjF3FYxKRsXJCKyTy0amIagJhyMtc5OxuXUtC6yjZ+WApxL1bQpUwZn14yS2wEVCzZYGaLOZOLUyvDPvYjJFzjgWPlGPW3316O+owtm5c2z/LiLUPvuWy3iDI5zc8wbIv71/d7lW98O4ypGhieapID4F59aiMcBjIYiV4+WWjKnLRgh3DNG6zEY2nfwXqEvJWkBO68quWmrWtLs+K7R3E2+zEdN6yNV0aw25InJvngsB6LxHC7KAjWRExV3jpx3l7tJJDpz8Uj6hpopb8VC0PiIU6Na65ikrO/SIrunWQSDtIy5CUbo8KkQdJKZNFW5bgNojf9QPNcYlE2FFPicJbVV+mv7Ijoh+TtVu4LInZWvMNfHobb862ebCUxaM2CIjl/poeIPkvbCsHDC6UlMWoXLUPIyPKShRHtulGdfh+XUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABu8D/ViiaVCmVuZHN0cmVhbQplbmRvYmoKMzAgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggMjM0Ci9IZWlnaHQgMjM0Ci9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI5MQovTGVuZ3RoIDE0MzIzCj4+CnN0cmVhbQp42u1di5bbOK6cnUeS7mR37///5W6eMxnJl23YpWIBpCj5IdnLc3j6dDrdskSWQBAoFA7D4dBHH3300UcfffTRRx999NFHH3300UcfffTRRx999NFHH3300UcfffTRRx999NFHH3300UcffTzoGN++jn+Pb9+Mh79+/GU/2c8Yfqb7m+7Q/ml3/uPbD/sh/vfvv/5ePwPn722kS9ll7ev0uW6cPv34Tfq106XO4+efP08XGc73j4+r3hJ+ebrmeNjD6rxN8vne6jNzP4QMtEx7e7+Oq//n9z8niJ7XF4A5LfGqaUx/yHBiJNv39lIHwBvdFQRghOrpLSuj154Cv89P6udkwxWxV9LucEP0wsLYPXjTsflgVGD19W7Hw7Toq2yvQuK4LhNoqzMzfa6Drq0yrmA/Oc15+VWdxtF0M+b9HrEVgNPjnF6uDS3eGRVfP3/lSduV7U0ownLbRCU7PM0YHIaLb563/vQNDOZk1cfin+D1saEvXW6Hxdqz7bX/NYTLzfAfbmhksDVg8re6mWmHOtrhNN7MxZ7Qe3LFzzeZeQhHU/blv1/sF07b2WXrYluhfYPXoWLY8XNAV5wQu9vP//mc/gvHihJ6vfk1bJw26H24vrIDbnlLZ1TwLglLsodhsJTt+/vX7/au2d3admy/ue5T4DzbZadtcZh8vOyunANm94A7BJjTH9pOAc+hht7zO8gvUfoJ+xu7WBTaDjb0Nm1KE3SxVaUf/vrLr/sZ//jlH+//eP/7r7/bDU8+w/nI9ts/frPfSV9XXD9d2b5J10mDv8c2lD6oYjbTP9NH49PlOunn735/Zw9iP2SQy5i2j/H0UqQr4A73syL2gHIY2RDAcM/SBO5trmwgVsNmNn19ef8C8AA27cMAhj/H+PDuw1uUg+Zn2ihztyHdTwJYGvbpuGF8j3fQkJxehJq9IjfJ1sIAzPe57fjjtz9OK8LH0t24mn7meVHuMMIPDWPUaZXTf6XFXf1ZhgrA2JYGRlJCB1MEeJhid+mf4euGR7Br4s3CxsHnzSksfL6+fcVF7Bnxht5hFWxCMLd4fUorsh/0+iW4D2hD2xXP1Tm3UpnedSsFK8qfxaFX3gLM7MxeHzeZLDDOg4rYKnr56yVPumiknQL3bx/KH71P9NpU831eYtxWY0nWKIzQmu0193X1sjJ0sS3azjhB9GwnOacDX6IFukCC/TkHgbOcWoRe2O17mhTYfMyJwGCf6JUXnL2Iuzm6fn/0c2VLz7+5+gwiT2rLxC6KdxvYH65cnJ/CPsjnXDg0V7K9oTt302H+Nm4+YXh2RfYw4ArahMup4W62V5Y+zo6dd22Y3ws/Ma2ROKhMeOBQMKenZy+bHAZADjkXu/+JW1L2HMTq3sf19W/NQ3gO/ixzH9uLHco2Wfl07/faNzzJK2IOWBQPfpB/sigZkvuEt8rF8Sz4oCw7n+fjKraXj5N32wp9GPBRbC9mOw0Odd5uIPCSjjMeSzJXzCziI/yKbAg/L8cHwvMLp8OQWZBIPl98iuef7xPbBPvY5qhU/F62IW/R79snleRM6g+MO485YAUnf+9eGcCWmAMITrb5rgubm9fK+JQdk3MNae2Q/uMoQT2WDs/Wzn0MA+w46RtgJrS9cpK9w3IgNoLJmT9H7w+9Jw8wJ3PyZlrL2jdydx3t5HwDv9lonysBlUSihCdsC1Q5xXvkgA4h5LGALUmMR76H0qfUPQdxPjWNkjMQ1lmMgCI7HirxwMdCr+W2Mn7yeFjxCBlrq0BYXY1eiZ1KakwyHS3xLnY7kwliamucOx4D1qX5RbZH+NdkHXo923YdT4mXg1/wJ0Ovsk+xgV7ymucxz2vZXjZ6bGYR75qcjfLqwEHlYLJdEB5vxoF0PDGPhND2AgzL0Es3INmTqy3HM6F3mLiUzF9lgmsLmJnOXaqJuAS9zD7NIJQjDb82G++C02vHJcEMQ9Tb4RPUiYxa8lLW2N7jawh+4Grbm5X58PbxXOgNIjyh31vnfI5aT1e6hzWeAx3rDDZgKXz78u2U5BoymkGYrU5fP7z7YIaXLTAA9oaZ46cYmSfcjjnUYFV46RPTZcOA7Qq/F9dPz2iVUyurS0Z66503+DSeA3ZMME7F8Ep9QThgIpDo97VRq9ELpi4bEHC64DCUPAcENpOjiygEJ2qzws/zCzKRHnNH16Zo8q+OphKkRw3sLETvdOXjbRgLegXDGcuBOck2r2dB7+Q6nh82LXGJfVoJp3NiC1N33ZiDgZCT9bCcIFcDJ3zD9psTx+zsIaDEQ/KATNn1L6zh32y4MSTtK2ddV6MXr4O9JvZZK8jA+JPTmdSVpj5NzGF6N4e3gvR1mTiOwJciyRd6DqArIAGXvv/0+gmgfavjGwL0JlxZsjiN5GnA1YcB51yGff3nx3+ysWXyOSKlH18+ctjtWui1O7RfTrdxSULtRO0Y8jq1J0Nv/s0l5IeJSzBc2+890uTYzgMzWvh/hAqeAv6tQa56YxnxIKydQWKCmQlCh2P6VoVjVkKvfNaF5IdgOZ4Xvbzu+0EvaDOy3OYSYHPnogCDliHWvhqoVqOXc+6+XAh/ywksuLIdvbeNOewbvbb6/lh0ygjkETNAHRDiaEA7eoUEIuj1PLGQbb4evaNWxHT03hq98XRd1e/1L4sdvnAEQwA2Hab41LMCvSW+U6lMD6w2HDBbais6ep8bvbagTKgGXS3hk0PBIPlIKUGwOuWyqcpvSnW21B37nMh6v7ej92lsbx7Xgktgz2KyPMIOkuqMFr+3Hb3g9sP7NQ8cYwLkuDhTzOSNq9DRnx+94949B9XEowi8BailuhyhAGEhXo5eFifhM6+dGaErKDTgReidxVhH7yOhd8xVEcZM3xWRNBg9zgLLPxegd2xWWGVKcJ7hWmd7O3rb0SsiXZdXV90o3jsrVYFMXCWGL8VrKAKSOC3fWybhOy5mPq/ItdVfq47ep0dvmC604DDzGVDC7MvnM5LDmKlBdvR29F4RvSKhI8vHYlDIDrMQH8vacKg245UVdK07ejt6r4veMCVnIYI3bdUh4+FD9I9d5U+vn8zYpt9JTiwzyjp6O3pvh95SQtlsL/RLmYgu2hHmPGRaoDlTvaO3o/fq6C3VYCJZzLQHrotnZQbYXv/nqPzt6O3ovQ96ZRgv1wiTfEYDpDnywAqoSKh19Hb03hq9dQpNKJTqLXAIho7eXVUGIWkFbuElBLNsfa9UGSSKDVwba5QGSU+IFWUqI35zxUsKBh2XKSF2wZkL6KnW1UhK2Qo42/YI68TceLPQpM8TVQZlvfOOvylyRksV3rL+HVfKtbFkigEDpdBSDCL376WAGcONwOCgcaaiQ02sprsaswLtpegFYSMdLb2XfoXleDo9B24Ftc5zYKFR1N1cq65t6nmU9xQTsUfvAEDBDPkIwHW1gzRN13AqQBMjzF0+s+6cjVo6tNesvkn8YZoBXY6nq2vjiNBq2+tn4FrohTVjQRJ0ywr9WJ+5kICYpzU2WuDJVRjzqsBcL0XAvMBzOF8n2V68gBctx3h41qrMSe/CqY+uU/jnVbhmZdCgLc+wXyAUJqhA5hdeLvTxrAp4nQUGo8yoOF74F/FkVLIvqojnLd7zk5eeQYLleDLPgUQMAvGKhS0OcaTyilIXcszEisKEwgfmvsN8LmOPl1Uapr4V9RaB+YsjHboNb3h5uZFK+n7FqY2vH/b4bg90xMvxROg1AwIFjJNXuVzXV9gvYb/FSyJm0kjIjKdBVCT47Gak1wB+X/q0GrO91H2vRGww08pPjSZuYtLX+L3jJL2OJ7pkOVjC4vlsL5+duRfJUukhmzHm315LhU+KfZRwLmq6Zw1Jz16Yfll6BlW1rcKfw/byvfkQx+qYQ0nJcJ0Kn+q6Pxp6pR3JVKx9lx64XOebVfiOBx+K1EbY44QQr+2vNPLxwBVhUvzL8S7e07X5YI6BjHk+NjUUa9ExC1fkDhrgKBJs7SSyp26DAXJuL9bte+WE6DURPFZmYDlKNqFcszbtFOQSIOzAElWnT+SwW/7usF6oqFvX27hfgt67rsiYFQly66uHQO/Ut+Jegv+cFKtU34guLgd1udUCqs4RGROquZAeLc6AxeLUmBzfuF9b5q/SXZXSxBfq9/KDxGMtSsP29LYXh6GMPXsOXOqFo8et23xYTODbl28v71/kZVfn9myucXJkuyoTju+zeBpJ9okXaqkK1ocMFYAlzysC11dHr65I1fta1PC97sUxGekhPIfwGH7rAXV9aRfl0Tu1raSYM/+hpDs53mvPAsSe/Nu8DQSrMsKvQGQgE80+Qte3ObYrh/BYh17puGoN4Op9yZfGeyt9GEuCw/u0vT7ufc9uxTivlbRBTK7WHADJMZ1aDOcuKyyzXTnBEshM37AiX3Kn0YOe3x0oo0os1y6LtLK9GgBzWNq2zu9dzRdaPcD5hPclb8eeba/XPLxPb7v0Qa8fXv377vUQDHUf3n2A7i7uXBXsz+C0XwYdy64PKgLzECxobK8GO8/aLeioBAts253jZq6FXlkRzl/fuuUux8yLWkM7Rq/oh9+hPa7lc2UCGb0nCzlM0VpJYGX5emoLBeeEyyrZtYAjbeIPXvgxY2G5Riol9DKAL0fv3XpGcyjGn932gF7urcMiYPcf9UbV2o+MkCNCYQYb0f1gZVReF3QC5VxVJUrPp1dcVujBQV+qqkJgBoY8E8QbStgsfquVWlH3dAvoSgsSO4NsMuqdpzgxwXY4LI7wlC37ZVaCwldlWZQ7YU3tAHKZKY5XzKC3IXXFgRHfRuFubaNnOztnMZaNhplc6BFtaHtLbadQtyvkcw8GLdlwGOZrIrorubMW24vAr3ngIXpLOlc19OZdPu1Mekk84XYHOg4/rmELXDtNgJj/Vi91vUVLKQvgd7R0xMCzoOLGYJauZrEm5vQKzxYBinDhpOGmwd7L+q1Dr90Jbj5d2SpDvfr6jlZkWMuvuJLzwFUqpzZk23ngYRYj7J8botfnfG3dzYCjz5ow7bOWmmV2imzc/BFXQa+26Dqzf5n6uEIm4uqbddhpcQ+2d0s3xuc6xwM3FDsMAZmqLqfP/0S0VnJkCDhkZLAyejkxYR6IJ/mstr1ecNILum4bkuIVCXvt3RMw9ulTueW46UtUZjplHi8FxPypTZiHvOVlbQEHLe8Vv7ql/atvkVYqMOdS1sqpjd118Oe11HfY2tYNjlS5YdiBrNm2R8hYQXo46B2OxYiZVB4J6iQOnNGzx5xvWba9gGt48L8QvUzLFJ9hnbLf7TCTHQE2vZO3LrpRbW/40mG/4POFvAv169j/Cjsd68I+DBteznMhWhKycyVyJWeuUEGifYvnmmh2V0TEz16WSSZ9mJq8lNjpcldcXip85pseT3iJhUcHNULmxk913Ft44ICuZUhndOzPcP38n8/2t/ZEgBa3AC5+aFgZREwDuw1UIeEwZZ/y9fNX/OHL+xdINnnhBf6vy9GL5DI+JX3664dX6UmB+EBWwXc+FJurbDeGnsUS5RPjkG7GZpvBc4cElrm4abbtn6hCklr+Df1eFG3N38b5cWxML935r7iH9Qx6wzLAURvQs1fDTaXRVzoNxipz+UJa1OW2l3tk4+PYtea4Fr/UVrfOzHk+V4ro2RTBGw5oaA4LPE3djd02Tohb9MM+GkGqiyqSroHedBtvtpd41y28I6O7wCSmR0Nz9tnQOneQFC4N3gvJLr01aSU3FZkC1h7BWZgTLiArXgW9735/Z1t2llYeDpW0FKw0Hlle1YlxRAlrLId4JkaKm2hIt/cc0vPag6PtEThC/kiyVexuin6U1wJqMwhy2p2fFG7PDy7Bz3pS2FewmjcCugs+kbVouFgy/TLbJQa/J3Zebnt5t7I7sW7jYSpBSDVmt/HqwYJx8yCGRLryx5ePCTnmZrT2ebleFsDuJH06LAAKoo29n5XybRc0YxernYXrS7pQjV7RdVHpobyaBnkuofjyFPliTIn4hVWEl6PXnIEss3xWxKo0Xpd+cKfDxajKD3ZXYoqFvQ8DcofkLELN+HR20pBhv7Ub0+iiY1HqtQ+AJWSvRNQF1WSXq/CJPjkTDLhYiQ0y65XB6wCYL0cvVO9YAKTiI/nwAhYdcnwZYSDfXOxgyBTxSWviXskj3i5ZX+h0uhm3zBSL68IhnQrwJMgzZayc2kb9UkHeczww/NA+mHNk6L8muTNOYbCfc0Xbm0Xtzt9UyHKcuUa2uqSA6gPvpdqcKwKmdL5mv5c/HaKaKxpz3LOuLbQkTDFVgdyzuWgnRJVkMbicYVqviAwmoRtRI5G0RahGIhf0veO1rtPp5tUPqqLyx0W7vPVwHZPXmEUpkwrt3j4lEe4g3M9un1WZfkiFCCJm8NaMQ9teByfVaqxGEqqJIuQopBr2e5cqQXH+DidQ7EFc9TlxafLcQQW9HNfl1xAfJAImoBDYjXFej+3wPTZravJlsQ55JbkgZf/o9ercnDjjcoB2sdBSGg7LjYOPcAA4CZVVUoxBb6CKCp9I5GEtjHOOHRN7geSU7ZfrtlfEKjNd1jGrrEccA/ZZRLARs7qD7cULLtVJ6BueNdJ9BNuL+xdPXjbHdh51eMhFXs/X6QADcGtZk4S7rDYqoMIYwovG2yG9sMWdkPRExd2C4ZLmF7w1WEA75ueMWQbBUh53K/9BXBfuDfZZqCI/CnpBCOQAPicy4Fo0KiHXek/knBzs/izKkf6ZVlPCJkvVp8FDMMvMyWs4JLDMknBpqUGQ984fH2yucHwTdwKFS0x4uLC/+VJJarYALEY0ZVh2j152CST056mD609tXGxCpxsuBJYQFtN+Vij/i4ITKovlb+FRi9xZHUicVpa4kxB+hO/NDrkU6N3H9uI+sxB0LoGYhesfwXOQmecVtC0ybMrT6Dlk2VJyCM1scs4Ue67Z3koMYbbrimg68Yroz0lgs+UBJcoUtnEBvOG6SECD3UtEPC4X+W8sXuPIGDYgTg5ypnX/EbNKk185nq9Br/eBz4AUpxqi6Jm2M0XwMuJ0teOVRFw9btktkamYRVFpw/Jg9i+gSqoOwSZyh6pYiWdiWlaL51+T55AXofDBZJFzJQ0lK6ZJa2fGGq+YNaJ9AQWSX0x2Clq2jZPqPnMncA/KcDvvjMIVR/gonJl1lb9467W4I6eP8v8iLFlfCyi2cZ4ubCBSP7XxPIj3u3lFfGZecpoNRxgaE3DcuMRW2Q+2OVIIWTnEsck1FyV91od3H759+eZ7+UnkwZ+5cA8WwkKbbI4bwydBGlGUgUEeNn9JGI9SMeTLcuVM50sLv3/9zrsAc24rJKgw3i6bxcv7l1ldCORMpZpAyX4b1lZQ1FFKFDm42u7hWwCq3kOBASZmsM5GA3/YbtWInWwEYBZ8SWbWG4JoVDg+CzWRdWxKreSnrNMw5crZRayEJmAP+TQnyaw35AwHPgtwcrylD4UPfVvMEPs+MkQlQVpbfXG3Jp7AtvHeM10EtFXuJiYKD7MRYA0Plt0VZqFU9mIv3vhmjognI04paO183seqpZ0U0Z50HY4kcOIDQTOfZJT7lL2V+fbYxUrzxvcmv8YbvaUXuTojaD1WFo4WwhI+K8jwRhLWdh2orYozeR+qfAu/F3wnqbStS2+J82aPiQ1lViM9/ZqIl/oBhIC4nubzy3+/sFuLZpR8tmLvGpNv4M+ysfSw6Qpvfsj5Pj+9fuIMqRcGtJF2YSDKkAbkhCUeHLJmSMCTAaP+9cOrL20QVmpRTTrvOiH+AEpg7C0u2XA+IeJB8ApvTnLgcngRC8VuaMpms6EVbIKTRFLDW8OGqOQ5mC+tizhkrABJUXFxGb9ZtqFkrbuGzPYavO0RpNhT2ltIuAB7CjuB9UwcC5n68Jo9NRxyiKXPOpnsEkClSoqd8eAVOwN9MKhmifz15uReWDAsaEV6scXpfVtKKnCr+L04RjVGNjiAAODhHRHXt6R7A3h7XpkU6VjvVKbZVER1fA21Qa7kcTHyJRosPgnMKZ9DZyxe7sOL4iuYchM7pdLx+TgnnupvF4TR2yrXxojCEkjHrtlu2vJ08248xX9CiY9Q0TcrtKdJ89RuocXyZjc5GLlkhOC51LdI9Ka40UCwfRcU4UrszdC35BOlCPQ19V87B0l4QphgWboOP4g/r2WRxu00UiQqzkdyYfiHUl0+b4Wj6FQXP57ao09nDddlQMw4N2pHNwotYByjlj1DRurzbxbHfmd7zftm8aUYL9+AbQfSz0UqI1qaOCsZfsj64YpwilB6KjpvqtvTYN94OXalPt3R29H7uOjlWCKalYtcmDA8S6e2qX4hZ4BnHqabMbmsULBULTaqg5ioWXSsY2/BIpx29GCEzzpsPoolh3f8kwmN0F7gSCkr7YhTxEMSPUhhiBQ8Z0/ivpxjrQNUmg2W0Zu1bFySuau+FXxmR4hPyLpM729hsfqiHqnGLSGEqz6ZR4rqP84I49QsHHKbZ2ReEMuyr5ao4i7JFW62dBsMf5klLBDi4BeHGcV2VOeMRulUC0lwnxnx0iUBV6Rge4E9kKmw0/lhx1VTcpDKmh3Z3pzkYIaLgySNDIdQX5GT7J7m520vVp/PjKKDGlZA88tiBwovppRFVMb5bt3m/EhCxEf1carl7VU2DgOw4aESS2StFfsJl7MxhidJE3f8rHCu2CeZ5cjhQ0u2ayc9gxAbMQMVZslLvi73SGXuoogYGBnMR5Y8elVQccgYg+AeSAGm6PRK1Zuw1xBEnZEc9M1kh6BxhoWXmb3AyUe2w1OjgbkPxYpIWZBvijSrKukXC6TWWT12/lw2wvuxvV62Udy8kG8m8R+8yFCqx7Pjqf2RLawIw+pom5Vca5dFn6ThIHeX4Pq1ILs6VyceBqz88JuOjy9Nob+qwc9miSpK8DogixGqzZcEV8WRa4mx+zTK3vxePghA9t83kCrt75LohF9kOk5ehcMzmb3q11QzO2YETsRp4QzY1VgdJYst5FqIzO62hz29AnOTw91VQj1YzkqEqEDB1CkmU0HdqIlOvwSnt3vQ4xu+l9Nx5Z2qkCT5h+nmWdFlV56DPbKR8WyZRFfZO0h8fC5JPbDFNuct1NkOWylxDl2kYg1Rn//zGdD6+PLRv1wa9xOp5HGGVCx/KHQsEfuyGeMmiXy8Eni8vH+ZVzZ2ShE8kzb5ENXktBrfoUcv309FPVvW3VYZG+i+emUSyQGSjLzL8BsnMDYAW0gWNhMG0CfxQ+Vt8Vfta/pbhIgrvrqNWK9JZDxbso1U9tgop4y/NYUxJleIobNgiB0HJvHY3HvJNoioT3HYYMjeIHnR+MEXCRSIYKbtGmEp9H6yFRxHtbObKORwIt42ETujSfwcLad9PtSjl51tLqS1oxkIXXX2TvomWTNfNcZnHGkS7a/DBYZT7cDCJkezCvmYagQGxSuW6kvJVuMdTzPDiMILghAfk7RVYrEQNqnkAsx72WmfYqpozvhCuSC/iC0jCwaPlIM2oofv0Su7uWiA2BskHU79sOoALw3Kt+cVg8MBk7uiEQOsnw1pqy2sDO6VzAoDZh6z23Do9fXLCAXYFZhnpc2VxkMlyFzZ3ex/oUarDUn30aeYi1XDf8qZiFVJM1UZCvJUbK8ndPkMmmRMWmSpvO5NS8U6eO98P0vRW6d7cXNYS0CLus5sl+0whswG3A7FWdqRnJMZEmPBJsOTKcnJ7sJzGLJgPtSk+bUVJSjprg5aOLK0rFcT2N6cl8jxAUS3ZstCYU59lSXvbva9JIm82gaKjLJ+WGs1GEtEcbzd4kbaDlL3HDD5MN0iCsT8fJzmMnXrdWci0lKWzW4nETOsnehwYjeXqBTywlko4PwgvGWXPAfJ7knIqEVtI6xJZ5oxTiuzJaUiRlpvunHJuZglGSUYPmt7/aFJsnsIwvCigGF+uQqf99P2gF4+pPjWMBwz92Dw7HqTe/UMWDm1cTE1+8CY/FkBdlH39bWNPnBX8pBRlSan/mtCd8iY86FCVN3vZcUt+97cBrRmlkAZxx8yiaGFKnyorAnq2vaQKY40eCU4IJ4PHiQk3sjShJ6DcBjkfee+1e1GuCWjXWucLb2crl29wlLVXtS37jn4X/ZvpWeGSLpndR62pKayH46ZWGCBZQgA1UA+O41yOMU/8QtsbNUBdlKNddsr8bFZbQ1PoA1VWJUdMZvamNUcyIUpwjCCqK/YgaLusYuwtmRkWAtuFqViunmlQsNlGRPO7m1leIV2yERTSYHFKa3ccIW9HcWMcDdJ3/Q2k4au1n1blvZCQcXS5HilwdU6omxsA81hSjuyQuakWlz1+lgZQ7JLFoib6cRHSyAUaxAzxJKzd11PKt2D55AXWfuevJ74J6RH0WJiq86urNdvFMPr48B1HizrmbSw/trRC45BSxOZFoPPjyy8I6kkZW8/bFIsxa1eHjPrLTLXUk06JgQsdK8U50PKW5cV42jsu+34oldGLzY7VnoRzSsrbsXZClPkoatx4LlEIRiws3HdZbb3jAevVr1CyE4/LseDvIZ8yqg44WwApdkBZsMySrPxXsy20ODtn+zM2OkvUFrbjiGJm7HQGXRjmJNTQS8D1R5nEgbJ5aM9+Ufm1seBK3eO8DKXDFzNc6AczWrzK2kFTkyrjM/5cCHdVdgvLQpqRV2WmGvaEu+tHDekCRcuiKDEVl22EQ/kCgK2jRW/FzEHFrHJpCHyPSssSPT9u+M4cAFgFqATodHL0cseFPiNKwAswa7s41yLTOHTQvSmho3zwnENnaRC0FquJWoayg5nx0maeX+63ypNjHLC9CDCEJA0MZ/3vbITxzal965si6xfJ1fIWjyXoyV2w+321kcbKuiFXKqXMlg0GPnTQXXMBFtEbosd18oklKaXZX9M8WZW/yEUXpv63eRVKpj5sFhmg9qKUfNcPgAloVRGr3Ha9XFyzXxr5gtRFxbU0qiLxCrn5ry90pwLYdhPLqEXhbSNXSpaGgahyN1T3OX+je1fUiUSMrBNL457/KK1CIYgXCa9lW29oDErJYE+bLJ/5f9Z3Vdx/OBFh2WD/k+85owhjR0MXpFKAkKE0yFqKrwXXj6UvF04ORWR50WtOb0qL0QgBTYX9gbiUIOc2dv3rIdA7yxopSgVfcpCzYS6TbsaeoesbER4qh69wnW8D3pDFSywSnjP8myi9huo697joCr30B4n33m/tsbB5RVp8r258DV0FR1vX32wCL3msLHsA9cvCz0ABQtXQa/gZ9G0Iz6DmiMUTdfR275M4i0wXO2jWQ//fwe9fN6x9o7+DCK+dGWo2NFy22uEE5zFlNyVpwNKJfN3Ri/+dtZzaOnOMNuGQGrJ2fjzLz+059DekU0qwUPb2zjnl6L3TDcq1YjF1NwGeYTG0xwXIi31eyUTwcqoMpPrjpbsOYRSSOHDPi56G49vXKUYnk9L5dgifwqKmhLSlngOIh/B6QPVspubnEb0+p1ln+jlK7PHW++F9OinNjGwvjeQUBo8MELPwV8nlj1cgl5zA5A4Q3lpCb0lI3wV9IYvSN1il9CLS63rtyVpQS6fYQ/wCfzelhCZYFvSRj4SVQqXiVd2OXqZiBWLXkYsgjujtxRzkA0dEZgQvbOxoJKYtnwN24g/kOdQJJZXuXYiiAefKlMVy/XrhEk4aSRG2p4crm9511hEd5I8HWMmM/vJzGVFIkDKGFfE6jnokTVeHLX/I2sMhlDkroJBGWaeJPIEP18cKtkre4VZuDWU29qYZnYz9PLrPJGUnPI/t5+2qbZcqs0eKBMs7FxCLzJEPhAEOrFSXscg9/Tn9z+5jAsBfI4D+9qQWbfZNxSAhgmLTXE9L6cMZEPHPKMFGyfo7RtsNL5EwhPOvbAJ814keZGVNjwRer1CFAQHsoSj64UnvcCYb8ZpSuC54i5KgTw0xEql4upm0JuVNRYco/Z/y9GLirwpkpbLDHIZkXerfN9DKRMIyVGhMlLR9g4nzqHUhaGedIeG9yL05gkIjsOA7JGVXRx/mes4sC7MeLc5BHWN5RFC2+upcdO+TyIV2AWEPAC/t0SnP5VgD67pQDN6hXV5qogftF9eevyS3ApD0VTyuG9XyJz0QvfMQbJjLHtWrJ0uATTsj5s32r4denHQMOH9zOccZzpe8YEauDr1LMvLSOv948R5kDYHWVPUsZbFhjei0iVD1muppUwmbPbBxnNqu3mcn9cPryWaEMOPabezRQEii43TmX+L7Wzi65vgOWxYGXRT9Kbx73/+W8rnRQ6XzSM+Lv0ElkQ6rfjeIiW7xHlq+z6tlK2vSfz5gkTzscEA/PjyUQ6eTDBAXUkyxYLeloixLx3K5BeON/nlv1/YSAp6TdYPF7H+odx12qtzi6a0IRbnR/Pqmc1rz8jMB14pkaZ/MvTCqpj1wIbLDYI9odrO42nt4Nzamkp7wRJ6pZCHTyt2MvL7vhfeNxCK1dXAHVXKzOaX/fQK/ZIL86euu0fkQJ0yjDkYed4OXLgZrtbksBvj0J4L08UdYEF8tWnH7wC3rMK6ZU3xtdErGw0e/OX9C4RSxeDwy4tiDd70ba5AoW9h6YTkVWuL7B2bsFd4+t5sbyi+LQzYpegNj1H80aK3X2nVDZUbKBMKH1scJGRt+OOQvuFp4afzDpsv0twPO12cnNnWolPkPD+ilmghXNcmLq4Nn87LhBnHNSwdjlaVwlAY1tc41NbmML7t6RVhRu9ae9CyNBxzOGFyS3kHPoIl6LJ7nG0W5YYLLTyTzXtirq4MCt7fMjPfNwqZzaqLmDluRkh6kF7PtKeugd5Smo8P5hV5fOZgVBorgHhpJRslfYxKOr5S8lnC//8CesOqTMlOhg1TvEyx/Tkar7RXRHLzBURpOKwExT+JKa1Arz8715O8ONdX3seioOhATuz5vyRH1lLO31huz4e4/wX0hhXx0hX9zT+v3jYLb7ICagv711t1H0mbEg1cjXsX9AJgHMHwf1V0dKPpFez5HvQt/C6+N9EmXYTeFhbEftE7p0YCz6Fel82tSVoML6xZ1g2WMmueN8K9Ca5le1vUS7yIUFONjJP1Q3DJ85cESO08MYnmSeCxjt72j9i531tRgppajI2tzS+4frZC5vdKUCJJJHHgoO3UBehtZMWzB1U5QNXkqnJdRwvEcSO8UnO3+q367oFhBOO50VtS4ZOJnZdxO1f684GrUflQJB04i8EsFBbYueTUtq4goi6ns2h6JaJ4Sa29cBVCueMnRm9JAVX6o83fed6bskV/jAHG6fKwTRXrZV0YMWsh5aKJD8e7TLaikqApNTaSAKz8fLberdHxK7lDT4xeEcFrIZls0wc8lzjj96U04ZhqfhNbpEvgM/ikf0t+x2tEixJRaWOSmKG0MSqG6Mu0eUEvu9+N/ry5fziVZ4K0e1AjyRMNO3y/jOUrbZsmY+g85BNVe9AEE+IhHM8Pt1ohA2Mnqtje2WJVbqhRaZ+RvS/nBzyxMvIG3Bx1aURvqPg0G09Gb50dKkGJjN5EA9vZuXJCTt4dBi14OJ361o+etlTuAFVSxit5Dhh1GcZQmD3sTxE2PpP2YXwQYCpy1jd8le1Fnr0x8MKxyizfuicVPltiSGbtzXNgvU3uom43zIc7pHelviBdgQlXdUsI9NpUTA3XxmK/trDsy3sp6BBUQu/0Yg4TkxnRGNal9yeLpZ6DV1as97PjTWEnCqhZu88Gsf0NRmSImIUlgdmTuRinNCIHA6HJ3FI/ziYOnPawR2rlUmFWK0avq7PjDH6wXnmZai0eMmqbm8byeZsoFrO1TXAn6tNTX7ZtyUINnZSZcSrMfyndmogHed8usTn19q+I4rJ4YCmoW6+a5BqlSpKL/SJ+70SAGpn9pehlt1BELerFyLIB7Uf5H9hIe8HeI9L5ItpapHf/48tHqWI2lrX9Am+13758e3n/YsQ/6SjnM7PQzsVXWSZBLzswIUfU+JZGYiyhN5PsPn79/vV7+ol9BX6kDrTd9mK5hSNaSuXbE2VNScYddV2RBJaw8XcyjK+ObYsPmFDM0yL3vL+qClwPDR1dx4MvSa4kX5jNOHXboQJSUONmbG9+G9xilSEHa7MAvV5Ka5g5p5u/xMxnft7tO14NU5NTvEShhsbdhu88IhqSp93Ty46NMVmaew9p251Cf+G3CfkxvL5LVv03G7//8kf6+tsvv9tX++aPZFmPP+dCGybZIkfJNfihlLdkK3DPUGNAxtw8n/Gvw+Hv45jTkJFTG9fN1cP7cLlZNjzQc9i2In6c7hOCM75Zqh3nbz04JwvaKtCLCcfdBlq7edchhHcsaoriNQsjV/pJJfQaMtNX++bdr++BW/unffPvj//HZHUGMDbWtPXbbadh3osPTQjV2SrsUMFhLofVt77Nxs/F6BWm8dRRfa5XJhdbmRarvUrrOyDfyLE8Du4ZhMK9pZKw66Ab5qeQ+cLmG56hQr591gNO1BLcTs2X+uvbz2RaAdf3v32AHf7w+0v6L/sm/e8bqp2GmygCIWTHDklge88RMxztYXKtrgqvyZ9f/1qHXjlEVNBrfM701RjOLKV+6qWVe0Tb1lbgJ0zQ5XT8HdDrWzlzZRALxQRvPXm2wp1D3xxeO9ny9F34eTCIJsNr35jPgB+yHS49kSicmO2tnNq407e9dyJaMtW/D8ttrze/c2YN2Uwp3jwJUGxdU5yJVwxTGtHn5evt2q8+AtUst6PFAiAUWxPycLZqTjRMjvBISIWVxeKZlx5BmL32Es2f2pBbpBAf7uGkBDKs93tZg6ICPNsCmGvNNcXQc9iQG+NLerkoGJUmfPS+3YCXK6XicdR9aOoDpR7CqDp+bG/ZixbWlpfj4PBy6e0DO45VGuro5SR4+ooyYemctdL2hp3a5rAhtoulqzKvbDvby2+oz3ui1eNNBw4+fEgUZbMs69TGt5/anUcnF+/3erFHyfmGamAxeqkgyJeueJgJiUviP6xMMvw5rj61Bf5/uZWh2V4DAMuxWiX19kpQoy66qByESt23S51YBNJTXCqnLbkIGPIsSCIitL683b9KKhcZvdoVsQWpuETdWelP+Bhik8CnSOz1k+t+se2tA4+3J6lq4YXYGzGmqEYirM655uONcPV6DqjvyORtB+1DcVLFGTOukWBstvqyIvkbLmg9Bu6TbqG8vD9NnFJ7hSNkEF1JuD0GzQB1iZM3odcJGmTqE0Pc5VBcsr0RDGroHVVGb8WrF7S+cuemEL16assdA2YFCG4b681n0csK516bImy64a16qCViNNoF02joJd7OotqKmgVuaA8NL2hKGe8evcL3Xs8HHl0veGfDQ66ILwmRwxeq3talCAVjpfRxmCauNODw0PWCJ5N+bzt6j1+hIVNywmfRi9S5UqHmcgQZb+cRdMzwVnKsqaKDNHPUHQ8qOUsS1qUuCeaG8avEWh/+ZLQIxjPojeSChd7AoyWlyIJjizyHt2TxzwNXgnMLxQW2d9BcNmevwnwQR919ynKf6OXjqvE3TqzXy0rVNNZaqLUU9GILM+VPVpOG/OMip7cFvSIXIC1LkJAKT4KlenYYzGUzefQcfn7/G7G4koRRC3oDnb3SgY4ss4+Q7NzvBUJYEqRuKPzA3zLeZAZK6EUKGIxTVFqxPybnpnadpRbbG/q9IlUKhmEoHM1tKCWo0jjM6U3ohZg2JDpX+L1wX5ElMbtUMf7S0Pkx/N5xUtuTmrJFcV2EkYFkSZ+V6rKl3QkyQSzh5e9/XZqvxe/l6mMRQWXWeih7jsDprOpmMIdnthvC45zOWIReOAlpLaR+v+L2ZBVDj6I+PWb0uZazSYnP4OWOOUpTRy+op+krslFMQw3bHV4BvW5TMKurVijXkg0PdLwjSPSsDcAnrgUsvHS2WhZzyEVg6qlVaQLyiKc2CauuHu0dD7P4/N+H2X5toXSSeBT1Vonc+QVeCowbC5lWnoKjCsKdk47Avkrdd1WTzoAtYnGZXneD7v2atXsQ2/u46G13JOC1nqrgcyaVb4dU0e/1OBdRYpYrb7/b2UcQ/c92Im5H785tr9+4K2okOGMiKOc7ohpzPhzwaf3X2R9ye5R2foWIZs9r0HX0PpTt9U9XOlpm+mkkF8bbN+oWw1HCnmBVDgulLJ53e+o8/9NTLPFLO3p3i16RiKkzltOjwWpx9yJv+k5J3mj4Dn3Sjtn3fwl9Ccl61wUttQXnEnR19O4TvSKZW1EzADyyLgPDxC33mpAVnYe6/RRtVa/oK8c0eYRKUxsVJOx+7+P7vULmQWA2zIeWmGMcpK33HhIhNekZ5CmgopApXVbZ9lZSGyLbsqjst6N3z+hlVkk9iGRUHwBM+GBh8X5FWA+gEiojf4QUnApzTE6adSUKFldkAkNH753Rm/lvgt4jxtqV/KFKnZV2jgVxsFGTwmx7paVFqFFWiqSFIQLoXnqFtJCWxhJenHxcAyR6xfwBs6P3JraXWhRJBKCiKcdSD6xSEtrhep5Oymx9G81SJI0FgrjqSuimaO4G/k9ISAPHg837urryCkm4o/c66D2rcLA0jRxnah83FhjCTlQzoYKvyWEBPklVdIAr6PWy/+z3hl3IuXMcqpXhYGRNxy6oEVukntTRuxK9Pw9costnqDq3xOtXVEo/PHTxQXLg8qVzs54DpEW4+7yn34dyBHZqgw6hqFgspfyxfETYfqij9+ro/fHth51H0Aub6/dLxDaTSi4JOIe9VBC2AmKNF8RxVwlKzKLX96s6vVlE5DMGPpMicBtvNcXk/JhQj4mZr26vUIpmd/ReGb0/j2UFeasCbWY9xicy601pRKn5THFegmdQCVNmQU19OcRakjcR5qT14OD4npFv4RucCkzO/zvbTabeshAibPja0XtD9A6Hb1++MYsmDN4yJd4q5a18RsDjS3vS8oE8D8eSOz6wso2dsIwwzzU19UcTn5nTEPBPcME3Cd9cp8Jg8zYJQ6bCvS7ziHdntsa/o/dy9CIuass3X9l6XHGoasw2U04mWnSczPR5kHx6/cQyp1nnlDJtUuIkwAzuiiNjuBMoudnLaFVRdof/+vSvdZJHJabos6GX6p6gz7YawKpz0lYZpHXZIu40zlQQmGq69FKXUGr6X9P55GJbmDvs7OxCVE5DSDdjg2gMTds2Yd6sebYigwPxT7P8dmPW2IXzKdDx80HjUinBU0bMtK/leLgEukGn1yXoNTCYMG9Ts7lzNJ7h50njvI2KbIWBRPoXmx9SSdpmMB6Doifv9Mr8+MZS5kVwhSBrRHu3hHeZksjhUug+JHppi0wjzbbZsXXQRY94//ittnc8sOtbiXaamfL9fGGmXj+8In0AJagsLDzGScAKOz1U/2vnz6f54VZ6dkyTpien6tTzjfFysBH2DPlQo/6ZM8VOxm21tK+2Nx0WoxcmMa2vlYjWQ50QczZJMav/hVSmkBVP6spUQw2vSXIN3I+vlMY6SZSTqF1lWjgEZ+idZLfP+Qgz6dwA0XIrJUZlWFuE7jNXOLM8ipbOOJ0g0uxJ0L69ppgZ4KEmQIvtzaSk80Y2fgB77BMCM7a3Jhhz3ZlU2cNzYEm9+tmTN32OWtRTKow9fgS0uwq6gJ3rOHwWzx4TcUK8vzb/lVzhc8YcpMvzGPUurA4+QWe9/Jba3rPNkTKxSlSTmS1whr3zY8vNoVcfXIKJtu45FamEUzfJ42PCE6jMDP9Oeswf336YR8QeOIJ+HEXxZHjbQUSIO12NX5DV5vfh0Mvn3JOKY7l/xExq0vmuy2zv+c9x+Kp3H2M3GyFZc+Atfebp36wrwj2nsNyA/bymax6hnRd6Os4tC+Riokw5kx8Z9hNKULwn4mTH4rF4kFLT5KdEL04N2es8FMzvXDMaXlZhWLWg19alcfIhoIEdnNugCKUBATFPj5TiCPvNuu3VuEqDwB3vDvCI/D1z5aZQFGCQOWQNX8g83lK+7znQO4lz3rH3ls2zmZFYQzIXe1804ZKomu0yfGHORZtaerXbyHPgNpQiFw9j3tj2btI9zlseYE+p+1o+RPMQ6JUt8k4S2dSpqqIh+UDolaZFLLpY47nRHUplKIhkdR+JAZy1nifiJVPdKjk4nPWaVmRP6K2zrG+h/G9rmlw7X1r7oLYXwTrEoq3pcF1SzDw0S4ID7Whwmb6p2ExxIXxRv3GNZp1eyT8+iu3lo4rd/0lj/y4dNFAxIQv0oLbXJ8Xqh9nAtTiTGLmPBjyrStDY128i3YxUY8X2Ihpsx1Xm5z+K3+tbX92626CnIjwueqfUGMkxzQZG2PpZN21m/pjtrdVQ5KS7UCGtpV8bznql+tPd2l5/q3fotY2Tfijm+ai210k1Wp/iMDPLkY00Xj+8GoSybqpzYvsiyO8zg6Cu1Yl5ODOm25C49/5tL2fb79zp1atqPCp6KVCAY1c9U+zPy0y3sHueUdXLa/d8TRyn8GZlAdA79bEiZhWx+tuNmjbC48Yc6EAa9m0pybRObbAWlb3nJHZf9Tzzug2BMoBnVO4Cvfkxgd/W/QxW0/XR1EXt2PhkBH67cFdWIHnR9LZcHzdzSZ9HVuMJ5TFb+uOEM1xakTsPablup+O9oddWU1WUz9nPdv0B7JhsgdNXTjmtS/0vmt76xb3ncEkPX3NU4uRpAyO6MsPBimxhe5m/Mbu1bTLMYfMBfPsG7nFLF3vprx2eqVuu0257l06v2MlL1lTq3djv1dKP6gHQz3CwIlugl7U9save4YC2okUL77+szdVI0bRQBnMLYTS8Zk4lChqORdNbv1Wu+Jj02xfupxyg8ELBvtygFrtwMxyuyIZ+r++rvp+heMspu77jWyURoPycchEEJ3Ob1DyWTO/sDGessBU9TSiekEXPWPbqPGk1s1mY4XhFtkAv72uzxTWbDElUSakOn+Xn969Re4XjOlw9ccXGu4unV+5wWCOs59vgGn1aiJqzDbJLMxyuyLZ+ry/928sYlaCVCdKOrXEkqfANvcRS0+R7Tu+kgHqBS+mnizuk8w5bedLiDBdWZBPLFizlcNib+eXZ84zBzITOPWnwm2Nm1a8YwFw5vWQV14maysnUEzVbL1uY4eKK9NFHH3300UcfffTRRx999NFHH3300UcfffTRRx999NFHH3300UcfffTRRx999NFHH3300UcfffTRx9bj/wEZrFq7CmVuZHN0cmVhbQplbmRvYmoKMzEgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggMzkzCi9IZWlnaHQgNDAKL0JpdHNQZXJDb21wb25lbnQgOAovSW1hZ2VNYXNrIGZhbHNlCi9Db2xvclNwYWNlL0RldmljZVJHQgovRmlsdGVyL0ZsYXRlRGVjb2RlCi9OYW1lL0pmSW1hZ2UwMjQ2Ci9MZW5ndGggMzgyMwo+PgpzdHJlYW0KeNrtXV1sVMcVxv/mJ4gSqjYoUoV4qVIB/lFFIf7Bhoq+9KF9rKiJA1EVVQhFUaOkxja2easQBVV5iGhClOcK5aUPTcEYSqtEaUNJnloCKEI0UUX4SVr/4L3b7+63e+7Zubtr++7MXZOOOLoaX+M7c2bOfHPOzDlnsplsNsjOz83zGcwHKGQeZrKZbFjO/Zbl/I8uic1g7XiGhSCboF75ExSMb5KjPDu5Qv6lM5JuFHbM2oOoYUkaE0QcBXNZUHY+qjrqw0Q9maAxczNzwppugK3aw+/nCvgyB5f9FvEoPzpmtoi7uZwAz2TCQhDNKTYmX15iTz6cfahlVU9D/czX5Z5ZqSjfnvISFb0PCgI5nx8y4WvBMZJa+FcjR0ae+MYTDXUN9SvqQXUr6vgk6bILampowhO1N9Y3ooDn+NHxxBAHGR4eGsbX5JstTS2sSGSYveR6tqIudilbIpyyJWwA+z+xzLCKlobWprpmUP2KhqLv5zhNQYAvnL9ABknNjc380SI0oevYe/i4Fh5UJFVjrF3LKokS9eTGJ3/xwks3/nmTLZSpFyHS0tFjx/Ydq1pX6akHohTpHhZ+bXHEioxZL2/Wr1s/sG8gz0tlaMqxfOjnh9q3dIyPTIwNj3ds7UTLX3zhRbzXK2Y5safMzE7Povzqb17lEOu2xcvuSGAEZQrexNhENWs3kE0+KF2NEY/kJIhWYXeqIIjccU4JArc2t2KM2FT+zwTzV/SucLbWtwCUGlc0oYDvr2xZOfPfmXBwCwDlGprOvXMOA8exE+jA/LUGTUGWn5XJiM7kuiPLGXo1BVkVcSUMottB4YSaK1LLEy9/u/t2awZZl4EY/JWes+5IOhz939vde+uTWxXElcr/MwPPbFi/IXzzMK84nf3d2cdWPxYZaJkFzBaZOBAhaUC8bSmsQdIDlDR0wujwaIJhpTBgykMJpOTIZwkLAgUJbailQwfrBVbIEs/25JWlIHljMLjkNwSBhlbgEuYICsQE4lIaplyOJs9Nan2J3Y5mWOxMQTytJhGODPXbNaElrDcnYw0kqKxYELEiGMrwUke2f1e/6IdxjjTvKcxNPYPYGLwpMtxiMonm3b1zF1LdsKLx8tSfQ3W3rnlw/yAK+AKWsAVBmx/XjJNrUjqIFNcnCytRPbAlyVpf0BWhdMXFFXzhV5yzic2opapwcRuHOGlY3wkaw79iFZgaVJxo0KEDZT8kHa3p4oWLMnwagS12pnzWUOmle1ObsEVgWNeMnue6sHbNWr0iJFv7unZ2CRfoQNGatNFKoIjbd9bnox5NacnbZ9+uoDV1tndyDgKaTh4/9YffvxNi1KXLEPWd39t54viJoo3QMirTR1c/kjmrjVb+KDtOJY1cu6R1NoJJQmjK5A26oyNHuaRKf3JAqaKksdFU0M2MDpSJI3sRlY33havIhJaOrN3QmriypHaEIXtNIsa6YHEzVmRSW8dEpJT1fFaNiqAWUl8iOnHtw6DIiUACMevr7dOIpGs0VES7nJYzXbUFzR022GsVtKZdPbso+UAk9Ak650c//DHX37atbYCmqE+CsstQT1eP1g8pS9u/ux24je+DYFoK8Y0j6n66GyOCWlAA7f3+3jOvn0k8rfCHsAdLbhVWgwMJFnoMR3zvjk998JH8hK6gTnCjSbQm+b55bpKKQVeEwPaq0JOUcwR1nf/j+UtTl1A7sBHPKfzLlZ0Sajl54mTBvgh7HtMw1/n1cjxX4tBqcYTpYIgun5jUsIbIIFgG49BULTKFz2rSzOrzhUh6yyu3p187jQK65U8XLuMlemZ4aJg22qe3P5UJWKFn2AmGxoLGJD67t7I4akoGCHhCazLWlAW61Bk7UrXRnqJj/aDaOStaE+ZIie+nqDUZbFqHJgPk0wHeuNkCZCgoNg1C0RFwsadKMmgSm478Ai6ig/UUJ2Oo/xQOl1nAinDz+k0urNFeRIHxwf2Dmzdtvvf5PUDT1LmL2fns3t0/gKJ1987d53/2vPYKqHB2KSdHoiejUshYylLtoclD06MFTagRQGFAE3s+75VX8DpL4DxgQJOcwdUKmsIN7dyZshwOcjdbHCTEK5JPgNKW72zpbO/MzAY8pEPhxsc3Oto6gE5ydiPH0+XGWvuBiNbkoclDk4emysMKfvN70SsaC9ZcQ37bv4BIyWCkJDThWStoogxrOx3oBItSzh8NP0xCMd63b+mgQHZs7Tzz+hkxdaVQ2So0BAl9G4emmmBUNTs8yweacoZ2fdw1xUNTsp5cnlqTAU36bDSBN3hvd6/BY62gSarTu17UoC5euGgcK8v2EZSi/OnzdE5dpEO4CnzgOVSlo6hCjcbp29TklIcmD03LH5pINYcmrTWJE77oEgncQpaP1iTMysiK7nTn33ciF0HltCP7TiHjDJuaj06rDYeWcgMH1GJF2nECT0CTcYzlockKNBlLgIemrww08YQuLNQ3hi6XaqomaNvy2WsygEJc8sJ9pEKgqwCRgE9eHQoK0XOzuQBPAa6C+lRZnyzpIOGhyUOTh6bFQxNdd4hO7dvai9z7g6qcB1I+oavQTgMq33/vfdnHFq1J64rRzv98LlZFx0QXB7wvCE2GQWdEj6aM0ragqaSb3J7+PRj6fvzLeW05ddbq6+3r6eppaWoRF1Y9bT00JdsGN9zDJsYmRodHx0bHQONHx4deGTo2fgyj75RQ43MHnhNXXjwH9w9+cf+Lqo5vlMuldn6W58C+ATAINskvmjFyZIQFu6yR5A2q0AsrVKYU5Or/B5ooxoYzrcWo7ZIko8nII0bSycz10JRMXMXbXLY+tM9wSsEpBZcbipA4vVuBJu1yqeNEdKRt/EcX3uA6Zg1dDa472jru372fLBrdQxPbrKFJJousQZIBIJ1QUAnv1YcOHpqWOqwyT2UcmWOhVjF0WOk++OsHtGUY1WslMkhO6DQ0aa41j06ZJUBxspz69SntWumhyS40caGRaF8xshxRLsCqPq5EeWiyBU3xvDdphqKjcPDZg/mNX3sRi5WhSb93HTCow+i2bdl27/N74HR2enZuZs5Dky1oEu1X55pwnejGyK7D/GCihHtoqt6g05GnGrVSSGEkoNG/q58n6ba6Om7QUdk2rEiRJbviWg6j8AxTMFUXje6hidBkKEscSlH7jUyJjvaadBounbXJQ5MVaNKKqER4paM1yZO5bq787QqzMtqFJp2zzsjdZGQLcbfXxEVcsj289eZb0J1cy5VgssBvHpoCM7b9kYYm3fM1cR4ouSdgB5qCCJro+FdzaNL4YDEpirGSSi0lTr2DNGQM/BqNAbOnXzstLoU6yLca5wGRHNRYE1UBHBm2ZBSQEst4b7dGrRzijYcmD03JkqIsF2hKN6un4RvJ06tqcncsN2gykvhBS4RlF126ETjYGM/VGFeDDYPOQ5OHpiVBUwrhvTWHJob3Gh5W3C6IEhVagibhtFbQxEAVbVGiSdf+cU08La1LGtPd631+doKHJg9NHpoWacBqfYnTVvIqJ86kWg6aQm/w2mlNxpVAktVtwZCTZGAoVyBpL7IQnD00PeLQlOd0EekEne41uYYmuwZjYoNO3BjCaxpyuBQlfl/64FaCpkxtjqVkv53nOFAOL01dkqseyaNFgELvGceRPEXy0OShKRk0xe9Kc73XVENo0lqTHO6DuOsi6JRgwpaEpqIYupQVxaAohg7wCzbBvqiFwqO1VgVhJ8hRrBxQemh61KEp4jRFaJqanBJoMvIpffWgCbBDrSlu0GksKro5+pGFJtQllwGJy83VK1fnZuaiy76tXlGEPuzp6okHbgzsGxh6ZWhsdGx4aBjPibGJ8aPjI0dGnMZL4vvHxo+NDo+yUhAHosrMA4brY9qZB4JF52tKJGxyepu7UaWe5rk427z80svsW4yg3fBPBtIagaX7frJPe92IRLkAeX3hiJEFKJ27clAdVnA6/OiLP4yLDpPdRqGhSUvOu395V1/UYn+HZy4bpQuQpAG5RHA6XV5LQyueVqIFK0ycw4cOi8pkJAk3QrxdXxIqDgxygS/AKgHjsqboG1VqmxRlUQl4ky5nlFV9Q5mx22PdO7rktc7xHUtpj1Noks1S4y4tR1798Qt8jaMrPHVWokidWHqgioYmsWjEZddI5WSFmuqaBX8kP55+CVAiLm1Y93W3YXRBPnO1xONzoI0LVtKJl4xfuhreDhNUqzXFuVgmucENgyu5VpbTEzZ9a5NsGIruhC5laEyt4svQko62DhfQZNxQpu2pCleqWccrQSdWzf6f/s+0JHsUtTZZDJ0BTXoBMkJ97UTfFK6swlMQiU8gEt5IxMGZ02+6hiZQX2+fKEVkltbBIm/Qs7sWi+89nkd+eSQBNInWVHmvKU2A0qnkNMtWoInbrfhI+7Z2wSX6qknZ7vDp/tQcxVOfHRg8YNfiiKtqRlxkuW09F8AL3levXK2TZq9bu+6zf32m/Q+XeprGPwQ0GV0qipnGZB3BYTG0SqfpMCKtpEy3UqfQBMH+8sGXT337Kcl7o6Py2TDtzJBOJhx0DgY9vL23Cl3FiKFbPtAk09lCS9TlFA/uPWjb2mYc3Du9frqkWSfrOKDy9q3byW7WXtA0Lnn7M2XYdQ4uI8BWdvYe/9rjV69cxUCI1sQlY0mbw5zv3U93G5zGR9BRwKAeUAMD2b1Y7+gg4RSa9L46JJwdwqvo0rcCjMwPsDFHh0erub13bHRMQEDrvctLa8pkq528Ktnp7PTs5LlJnroaO7TWFYmSqRXIIxqQP+QVxx6X0CSHR6kl4JJtHya92dO/543fvkFOMRZcLMI9QJVpdvG4VAGajNNPdyxrXNK26uZNm6EWkjW3M6gAfei9EOoz2Vuf3Dp54mRPVw+WAG3Fp5Y2UPdzsr0m4QhaU8mt0ZShiXtNjqBJn0xxoeEEuX7t+v6f7seUWbNqTVyYLQbdy+wAPvTv6j/47EFULVBp3TkwDk2uJ2k56mzv3LF9x+FDh298fCPKg10AIn1pyFJFlwadcepXjjVHKqL0KuB34zc3QpCO/+r4h3//MJ9wIIUQg8CTJ0+ePHny5MmTJ0+ePHny5MmTJ0+ePHny5MmTJ0/p0f8Ara2alAplbmRzdHJlYW0KZW5kb2JqCjMyIDAgb2JqCjw8Ci9UeXBlL1hPYmplY3QKL1N1YnR5cGUvSW1hZ2UKL1dpZHRoIDM5MwovSGVpZ2h0IDQwCi9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI0OAovTGVuZ3RoIDM4MjMKPj4Kc3RyZWFtCnja7V1dbFTHFcb/5ieIEqo2KFKFeKlSAf5RRSH+wYaKvvShfayoiQNRFVUIRVGjpMY2tnmrEAVVeYhoQpTnCuWlD03BGEqrRGlDSZ5aAihCNFFF+Ela/+C92+/ut3vu2bm7a/vuzF2Tjji6Gl/jO3Nmznxzzsw5Z7KZbDbIzs/N8xnMByhkHmaymWxYzv2W5fyPLonNYO14hoUgm6Be+RMUjG+Sozw7uUL+pTOSbhR2zNqDqGFJGhNEHAVzWVB2Pqo66sNEPZmgMXMzc8KaboCt2sPv5wr4MgeX/RbxKD86ZraIu7mcAM9kwkIQzSk2Jl9eYk8+nH2oZVVPQ/3M1+WeWako357yEhW9DwoCOZ8fMuFrwTGSWvhXI0dGnvjGEw11DfUr6kF1K+r4JOmyC2pqaMITtTfWN6KA5/jR8cQQBxkeHhrG1+SbLU0trEhkmL3keraiLnYpWyKcsiVsAPs/scywipaG1qa6ZlD9ioai7+c4TUGAL5y/QAZJzY3N/NEiNKHr2Hv4uBYeVCRVY6xdyyqJEvXkxid/8cJLN/55ky2UqRch0tLRY8f2HataV+mpB6IU6R4Wfm1xxIqMWS9v1q9bP7BvIM9LZWjKsXzo54fat3SMj0yMDY93bO1Ey1984UW81ytmObGnzMxOz6L86m9e5RDrtsXL7khgBGUK3sTYRDVrN5BNPihdjRGP5CSIVmF3qiCI3HFOCQK3NrdijNhU/s8E81f0rnC21rcAlBpXNKGA769sWTnz35lwcAsA5Rqazr1zDgPHsRPowPy1Bk1Blp+VyYjO5Lojyxl6NQVZFXElDKLbQeGEmitSyxMvf7v7dmsGWZeBGPyVnrPuSDoc/d/b3Xvrk1sVxJXK/zMDz2xYvyF88zCvOJ393dnHVj8WGWiZBcwWmTgQIWlAvG0prEHSA5Q0dMLo8GiCYaUwYMpDCaTkyGcJCwIFCW2opUMH6wVWyBLP9uSVpSB5YzC45DcEgYZW4BLmCArEBOJSGqZcjibPTWp9id2OZljsTEE8rSYRjgz12zWhJaw3J2MNJKisWBCxIhjK8FJHtn9Xv+iHcY407ynMTT2D2Bi8KTLcYjKJ5t29cxdS3bCi8fLUn0N1t655cP8gCvgClrAFQZsf14yTa1I6iBTXJwsrUT2wJclaX9AVoXTFxRV84Vecs4nNqKWqcHEbhzhpWN8JGsO/YhWYGlScaNChA2U/JB2t6eKFizJ8GoEtdqZ81lDppXtTm7BFYFjXjJ7nurB2zVq9IiRb+7p2dgkX6EDRmrTRSqCI23fW56MeTWnJ22ffrqA1dbZ3cg4Cmk4eP/WH378TYtSlyxD1nd/beeL4iaKN0DIq00dXP5I5q41W/ig7TiWNXLukdTaCSUJoyuQNuqMjR7mkSn9yQKmipLHRVNDNjA6UiSN7EZWN94WryISWjqzd0Jq4sqR2hCF7TSLGumBxM1ZkUlvHRKSU9XxWjYqgFlJfIjpx7cOgyIlAAjHr6+3TiKRrNFREu5yWM121Bc0dNthrFbSmXT27KPlAJPQJOudHP/wx19+2rW2ApqhPgrLLUE9Xj9YPKUvbv7sduI3vg2BaCvGNI+p+uhsjglpQAO39/t4zr59JPK3wh7AHS24VVoMDCRZ6DEd8745PffCR/ISuoE5wo0m0Jvm+eW6SikFXhMD2qtCTlHMEdZ3/4/lLU5dQO7ARzyn8y5WdEmo5eeJkwb4Iex7TMNf59XI8V+LQanGE6WCILp+Y1LCGyCBYBuPQVC0yhc9q0szq84VIessrt6dfO40CuuVPFy7jJXpmeGiYNtqntz+VCVihZ9gJhsaCxiQ+u7eyOGpKBgh4Qmsy1pQFutQZO1K10Z6iY/2g2jkrWhPmSInvp6g1GWxahyYD5NMB3rjZAmQoKDYNQtERcLGnSjJoEpuO/AIuooP1FCdjqP8UDpdZwIpw8/pNLqzRXkSB8cH9g5s3bb73+T1A09S5i9n57N7dP4CidffO3ed/9rz2CqhwdiknR6Ino1LIWMpS7aHJQ9OjBU2oEUBhQBN7Pu+VV/A6S+A8YECTnMHVCprCDe3cmbIcDnI3WxwkxCuST4DSlu9s6WzvzMwGPKRD4cbHNzraOoBOcnYjx9Plxlr7gYjW5KHJQ5OHpsrDCn7ze9ErGgvWXEN+27+ASMlgpCQ04VkraKIMazsd6ASLUs4fDT9MQjHet2/poEB2bO088/oZMXWlUNkqNAQJfRuHpppgVDU7PMsHmnKGdn3cNcVDU7KeXJ5akwFN+mw0gTd4b3evwWOtoEmq07te1KAuXrhoHCvL9hGUovzp83ROXaRDuAp84DlUpaOoQo3G6dvU5JSHJg9Nyx+aSDWHJq01iRO+6BIJ3EKWj9YkzMrIiu505993IhdB5bQj+04h4wybmo9Oqw2HlnIDB9RiRdpxAk9Ak3GM5aHJCjQZS4CHpq8MNPGELizUN4Yul2qqJmjb8tlrMoBCXPLCfaRCoKsAkYBPXh0KCtFzs7kATwGugvpUWZ8s6SDhoclDk4emxUMTXXeITu3b2ovc+4OqnAdSPqGr0E4DKt9/733ZxxatSeuK0c7/fC5WRcdEFwe8LwhNhkFnRI+mjNK2oKmkm9ye/j0Y+n78y3ltOXXW6uvt6+nqaWlqERdWPW09NCXbBjfcwybGJkaHR8dGx0DjR8eHXhk6Nn4Mo++UUONzB54TV148B/cPfnH/i6qOb5TLpXZ+lufAvgEwCDbJL5oxcmSEBbuskeQNqtALK1SmFOTq/weaKMaGM63FqO2SJKPJyCNG0snM9dCUTFzF21y2PrTPcErBKQWXG4qQOL1bgSbtcqnjRHSkbfxHF97gOmYNXQ2uO9o67t+9nywa3UMT26yhSSaLrEGSASCdUFAJ79WHDh6aljqsMk9lHJljoVYxdFjpPvjrB7RlGNVrJTJITug0NGmuNY9OmSVAcbKc+vUp7VrpockuNHGhkWhfMbIcUS7Aqj6uRHlosgVN8bw3aYaio3Dw2YP5jV97EYuVoUm/dx0wqMPotm3Zdu/ze+B0dnp2bmbOQ5MtaBLtV+eacJ3oxsiuw/xgooR7aKreoNORpxq1UkhhJKDRv6ufJ+m2ujpu0FHZNqxIkSW74loOo/AMUzBVF43uoYnQZChLHEpR+41MiY72mnQaLp21yUOTFWjSiqhEeKWjNcmTuW6u/O0KszLahSads87I3WRkC3G318RFXLI9vPXmW9CdXMuVYLLAbx6aAjO2/ZGGJt3zNXEeKLknYAeaggia6PhXc2jS+GAxKYqxkkotJU69gzRkDPwajQGzp187LS6FOsi3GucBkRzUWBNVARwZtmQUkBLLeG+3Rq0c4o2HJg9NyZKiLBdoSjerp+EbydOranJ3LDdoMpL4QUuEZRdduhE42BjP1RhXgw2DzkOTh6YlQVMK4b01hyaG9xoeVtwuiBIVWoIm4bRW0MRAFW1RoknX/nFNPC2tSxrT3et9fnaChyYPTR6aFmnAan2J01byKifOpFoOmkJv8NppTcaVQJLVbcGQk2RgKFcgaS+yEJw9ND3i0JTndBHpBJ3uNbmGJrsGY2KDTtwYwmsacrgUJX5f+uBWgqZMbY6lZL+d5zhQDi9NXZKrHsmjRYBC7xnHkTxF8tDkoSkZNMXvSnO911RDaNJakxzug7jrIuiUYMKWhKaiGLqUFcWgKIYO8As2wb6ohcKjtVYFYSfIUawcUHpoetShKeI0RWiampwSaDLyKX31oAmwQ60pbtBpLCq6OfqRhSbUJZcBicvN1StX52bmosu+rV5RhD7s6eqJB24M7BsYemVobHRseGgYz4mxifGj4yNHRpzGS+L7x8aPjQ6PslIQB6LKzAOG62PamQeCRedrSiRscnqbu1Glnua5ONu8/NLL7FuMoN3wTwbSGoGl+36yT3vdiES5AHl94YiRBSidu3JQHVZwOvzoiz+Miw6T3UahoUlLzrt/eVdf1GJ/h2cuG6ULkKQBuURwOl1eS0MrnlaiBStMnMOHDovKZCQJN0K8XV8SKg4McoEvwCoB47Km6BtVapsUZVEJeJMuZ5RVfUOZsdtj3Tu65LXO8R1LaY9TaJLNUuMuLUde/fELfI2jKzx1VqJInVh6oIqGJrFoxGXXSOVkhZrqmgV/JD+efglQIi5tWPd1t2F0QT5ztcTjc6CNC1bSiZeMX7oa3g4TVKs1xblYJrnBDYMruVaW0xM2fWuTbBiK7oQuZWhMreLL0JKOtg4X0GTcUKbtqQpXqlnHK0EnVs3+n/7PtCR7FLU2WQydAU16ATJCfe1E3xSurMJTEIlPIBLeSMTBmdNvuoYmUF9vnyhFZJbWwSJv0LO7FovvPZ5HfnkkATSJ1lR5rylNgNKp5DTLVqCJ2634SPu2dsEl+qpJ2e7w6f7UHMVTnx0YPGDX4oirakZcZLltPRfAC95Xr1ytk2avW7vus399pv0Pl3qaxj8ENBldKoqZxmQdwWExtEqn6TAiraRMt1Kn0ATB/vLBl099+ynJe6Oj8tkw7cyQTiYcdA4GPby9twpdxYihWz7QJNPZQkvU5RQP7j1o29pmHNw7vX66pFkn6zig8vat28lu1l7QNC55+zNl2HUOLiPAVnb2Hv/a41evXMVAiNbEJWNJm8Oc791PdxucxkfQUcCgHlADA9m9WO/oIOEUmvS+OiScHcKr6NK3AozMD7AxR4dHq7m9d2x0TEBA673LS2vKZKudvCrZ6ez07OS5SZ66Gju01hWJkqkVyCMakD/kFccel9Akh0epJeCSbR8mvdnTv+eN375BTjEWXCzCPUCVaXbxuFQBmozTT3csa1zSturmTZuhFpI1tzOoAH3ovRDqM9lbn9w6eeJkT1cPlgBtxaeWNlD3c7K9JuEIWlPJrdGUoYl7TY6gSZ9McaHhBLl+7fr+n+7HlFmzak1cmC0G3cvsAD707+o/+OxBVC1Qad05MA5NridpOeps79yxfcfhQ4dvfHwjyoNdACJ9achSRZcGnXHqV441Ryqi9Crgd+M3N0KQjv/q+Id//zCfcCCFEIPAkydPnjx58uTJkydPnjx58uTJkydPnjx58uTJkydP6dH/AK2tmpQKZW5kc3RyZWFtCmVuZG9iagozMyAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0ltYWdlCi9XaWR0aCAzMDMKL0hlaWdodCAxNDAKL0JpdHNQZXJDb21wb25lbnQgOAovSW1hZ2VNYXNrIGZhbHNlCi9Db2xvclNwYWNlL0RldmljZVJHQgovRmlsdGVyL0ZsYXRlRGVjb2RlCi9OYW1lL0pmSW1hZ2UwMjQ5Ci9MZW5ndGggMTEzNjkKPj4Kc3RyZWFtCnja7X2LchvHtt1n2CIBECAAUj75mMQSHwBf9q3Kx+RaIgmApORKPibHEp8AJSffcutcSyJ6kDW9Zvb0CxAJEgxNdNUueAjh0QP36v1ee5SMRlGiRIkSJUqUKFGiRIkSJUqUKFGiRIkSJUqUKFGiRIkSJcozE5VdqBtl/jlTSYaJXPN702eU9a/Za9Ro+G2Ii29fvgXXiZf5nxAlytMU2fnctDdfb7i9062rRu42Vo+1HhX+OixPVpKtM0ci3kiRe5EXmOiOEuXpg1HQV+gXG4mytx9BHWMBBSpF9DNDwSPhqZHYO+ye9I63W1vN5UatUl2pN5eryztbO9mylXuDUaI8QXHtT0Ml8Z+sFzy6mXpjQC+RIwIXw+Tgzf5Rp7faWKmWl+rVZTwuL9UgjVq99GKxvFiulCrdw+6j6fQoUR5w/zvmHP+8urg63D/sHHRw8Xhmqm0/m0q5s3/Y3mhBA0IAPcAQqhBCnQhIQj8Cjw38a3W51+mJHft4mj1KlKlDNJ7Wuzi7OO4db65vNutN7mrI/pv9x1TWBKMgqHvQAcpECUKAuKVSBbK7tXPcPTr/eIaXvTs6wTMA6RJeU6n60I4S5elDEtv14O3Bdnv7xQ8vVhorsPEAQzyWFkpAYr1WP+oePYJmlDgSv+v0w2l7sw1YAWIr1XpzaXm5tPRyuQnp/LZ/ctjLDpOvw8sPZ3utbbygXq7W9emBIyUQEI4S5akK3C4onXT35iYfNA42PzYz8biztQMz9TF9LmhDmMSwMOH3YQE1eIJcXrkKPHbfHAzOLoE+M7bTe3sIeAKneAFeBh1qqsIsDBXdxigT/KP88ruZPvz3ZqjSvxhizN/LJ/Hw7WboBF6sqMtQP94kvMZmhk6pLVagR7B7qWtwjWfwJwRGIPRRGv0IBXYm+HoS8wkkRFQgfTlyrEeVmqM4DQDAWm5qAo94xPNX55d+NAbP4wCh7coj5ZIKMUqUqcD4HTwa0IM4SMy2p2FtZvpF4pDfFJ6/Pr86PujubLRXaw2gD7j7qb5CPEKV4BkInsH10X7nU//aSerdJprq2oHOW5yspYlHlSpoBl4YEQUMqRBhNsNSNaOpKvciATqGbvD61cYKLk56x6PoG0aZJRjd5LUaBR/NaGGS5yM6+4cAFxCXqptKtbJYhmDrwgVLQ4568/OfeofdVPVQt+a5OSkA+H4oUo2C+QgzeMIPAWYz2A4TfCNUGxZDpSZhmb3tXawn8b08/S141+baBl6JdzWXG3hcf7V2KR6iGkVIRpkFGLONrQJ/FulsOzR6/vHsuHsERYNd/Y/Vn6DyAMbyQonoYxoOexiorGnz7+L03FWmxjeaMJwUA7ETlGK1WslK4wLfizUQUBSsFs/0dGZQ2dhXOrGIJ/sXVzvtbb5+pd7EW4BKPGlmIVVMYUSZFobf1YzpVlReJsLUkrm3BQBSv2Cj0n4D7iQsQwuQ19jShQvGj2KqkWkFL90PcDn6LrDOb4Xf6i+P/wqsQeul54D2CnFEEFnQ4J8Hn9J35UrtJi83pQwu+7tbO5JPxBvx2M9Tn44FGyXKTMCoxj4DRQYlCG8L+5MGXuptlSpAIjDI6CitOEmItzdaeP3I9yupyLzNbKlCdat8JT7Egob+ZDihjMzQCsVjE4tcKAFfRzovn75YsvzmMvRnttY3qTp5mxCo/uKgiDoxyoMC8zbmn8Dh4M3+7uYWjM/VWqNRqdUWK3iEOVovVxmfYRYAeIQOYlEKa1GCPp1TESeeXbh+dfI6h0nh6Ol30RylScyDAtdA09vf3gZhbgLq219fATrxal82V3EtviRVZxCJEZVRZgLGHB3XVwPYcowfpqYd4VZaAgwhAGYapdEXkm7DK6F3YOAlNHSV7bvZqTerMNurhLl9s5VZMCM4wgUtZzyPGzErt91ETB6AAgxZ8Abw0sDG7Yv168LNjs3GTRUlkB/0drjzgkIrKS8LoP8JigDCQAc0C3YmjdJUJ5aqQBxzhYAhAUgwYt8Cg/dqVbB1sRnIlTX78ZzLswvAn56dWM5YOYCZ5h2UARYjC5Np6vzPw7cHzBvSIsXFkaHWo0SZQrjHqNfMzSydsFYyQr/g619f8Zr+ZR9WJfw7RmMY9gcMf1p5udpY2VzbgKsFxK0u1cU6rfy4iItft3aPD7pWCGVasy1gmiornGveEa5xYlAVQmiXEo8dVu8ME9icxefbDcKmPmVMFbdM7xKfyWBplCj3bU0K5ruZuTOSFDQjr84v3x+/wz5kGoI6BejjnzDbAE9oDRZCi05k9de7oxNxo6yo5r2Ve4o7s3fJ/mSowq3NNs1RrJNrw8UvO3sBEOn0REDt3ihgmdoQ90s/t7W+iU94sHuJMvciSrBQNEYeQaIx2M9Uf4s/LlAvYFfT2AP6YHBir+60t2mzvWyu0m2EWuy+OchcMDNykqPbXMCdNWOwz9FAOrQYFsM4LReP5UFl9w67bnaDp1AoCoRPuzg9B3LNjAxUf2Zj3zKQGyXKd808Nb4UU9fGbK+3qgtlNiNwS2Nvsyco9ZJUmlwDBqkv+AJmCaEioTWGhhlcpPPGVK1MqRYl8adGX//zCy7wvWyop+JmSy8eu4dddklIqHbox1jMqp5hAhjiRghAZhsBQ3ZCsX2YF7H7KcoDB3P0jsJOhrXJPYxNyIgoS0OZ+Ia6wcs+/vMDwCgOIx6Zm9t4vW6GMibTxVi+6nSWtm0invSOaYUSgIwprb9ak5Rf8LuC2Dw/Pf919xeYo1SpACNsAylCCGQromaMcm+Hi7lsWJIw3uj6sTNCUhKQk8Pe1cdzKo6j/Q7U5cvlZpo6zN1GbH64hKd/fPRzIt9uhmbRuLKfxHPyr1PfCLxCIE7MUcZVcI2jI6ujs8ncTNIAq7dXa+2zj2dbra2qrpKVagRqQxOADk1WbNKPck/BXoWmY5pbMm5AIoD269Yu3L1PF312Nl2fX+HP1Voj05LlNGeBt0Bf9ITFxQtC+ojzu6vkmelaHaUKVJJ9sFGpvsO5Dy+tI4xttG9FFfKiI52S3qODxyhzW/EyLj8YYP9TVsBkpElaGJDh4U9VQusOzmC6/Yw3MofIfc64DXdpavvdx8JMitaqAoxGJ5SyA6RJ3kbB6gL4blwPbiFlWtPLK2p4zI4qNSZcbGhM2J9p9ElXCkHpsxohM25v2RISZV4rXoL5QeugDh3g2F3YwxJmYaSF4AI205S34YXBMGutbzITRxeMZSpQOp/618k9dEHWLmFIerPGqfL1r69ZwVsOAbnAyZCaoLq4jnocKyy6k5xSOimfU8m4GlrcCKuGmIhhVvT33omcBkPDLY2BmtiydPv8oEmRJNYXMAisMVVN6LFbEBdAVlaKZqgJbE6+RlwwCOy3LDKTf9d98mtDv//I12iixYYJvNG97V02UEhkBkfEsT5Agv2SI4+0zTKk8U9fb34/ec9EDItRcX349sDKkth9VRGMEYy3zQ8aWx1Pdg462+3tZa0EuYGldgsYzPLdRm4Rth9UDEs0sTnFHM3q1kyj11fBU2XqxzZcGDFYVnFL8TYPB5wMRM2X//wip1CgHC5UrsOqA7wdGKTGp62ewdBYgEPIX3xFlNiyNDE/KE8CO1Aiku+jM8iak4KkxWgMhIJjpSUTc9j2TJS3N1oFR4RdmAqwU+P4eueWh8lXKTxTbsaBChfrxAKkuZ7NFMwVXkqTY6gWLlDUrSwljpsy848M+AS8b6cqNVqqEYy30DJC5At/ioYlMxTcw/TyinIRoyMPylE2vMRnFn9cKKKjXvutX6Htsgrfev0BRaMKx5YJBemn2N3aORBOVOXizgHgOCZSHFPspmT0laFg/jJFm7Aqrk2agjgUYw4BePtmXtqig6sBlEUJzpTet1SI3MlFW0Tu6LEeBjBk74/E8Cmt9U2GQahHhk4YxNv/YqPedf3K6fXT2xteIX1VWQ97IrrkCQ9Gkn1ohEzfL//66/3xOykfwmfCLiUM5dtHHneHM1snXLETZT7AOPmN56fncAmb9WZZs0PUNY8oTS/otcwftKvFsPHgFUrbApmuCdssK2ci3aS1sfN0Q7vmJFVwU92CoB6r2ni9zrAtTeUsT3HYDdS3GM1NLuG/8tafjM4+nMJoF4o2FtJkoVfPC5a8/4RqvYjH5wS9QE5tXGeQEzDJ29Jhs4knKHrQ2mPK/XB2HFAVsm4Nb9lub5+zQEUFeoVuf3pMMGV999bMibDujolCKWDLarB9a9Dn2BmX0Kfdfn7JXCoL9iA77e2L/H5Ht7vfKM9VWIjCzJoZw+dGcgIFyrCgRprsSPomsLuIQezh9VdrTjTezMp9/OcHeoUELzv4sOH3NaFEplxuPdlwsgZkTMZRK87nE4lABM4TFsyItUzf1mJTpO9mhkmVm8Q32Tl4jRd/6l8Dd4yREuOsWs+MhEec5BjlSeNxTH4tEIvQu+XP689Qakw0MCYjsX14WA6Xi5n+A0IlnSGpjV929qgabpwpuknI6rt92kWNyYSa9E36GvfCI8UZyZQGZ+zvdUAd/N3cQ8yozCESVxsruOYtJzYf423uN8qzL8z2gwzyp2w5bLBep4d9xbOdnhS27k8rL9/++5sz8lc7cXh95sM2Iz+S5Ar5RubrRdc4Bt4tN+QEf3BsTjx/hi0e9TzpKe6b1RWo3Jb/LAMyPi8plKdQfPg0dppIJJZ1fQ6HQEwXRpmcX5OwHtl9CUCqQppzsLvcxgE7PgMYQsWQNZfbHo9QhdyQPqEoNrDPqn3f6ITT3qsLCTipkG0UjGSy8sdvn3Toa4Y+Kp3fLf+698fvpEqcZImSnTFd1Ie/3yh//5be4MkM3QHEUWWQyIK7i2wVbiu68QlUOlI7yp0Pw+/SHjfml7D6TbXTmW1mHY5sfnw7I7dkqGDxTFFIoMINiU71uzL6doO/G+5dbHgqRDzDNaQBValtMJiH73+/UZ6B8MxnkZVss9M/PpI7VwpCUiktnRz2CjTZG0kqZ3D+UwlS45AV3+w1cFrtlMcPIzgqpktMd8IY3ivgtvDDizSxXq1XF8qrtQZk8+e16/Mrq7wciokhF70G/Brpb2LGmW1d6eclG5WUZodDurP4jxfCcrIzMpSHA3rinoxCdAzy/Jqp1+D4mJ3yZmWIQBJ+Ft4oNFAMrkKrShNf4pWEBRtpA9pBTaUp9Of0dQkQF8NC9NSDq9aP9jvZoLckpNmN+8o+bzwdsZOXlGBpa32zYH00PtwxBqRpS/orp7zfKE85JhP60wzcOcEWDhcrEn/YUdXlrdaWVF0O/ZEQedudsCNK8wI5ymZ4g+MShfnC4Mzubu2w3fjlcpP8qFinpaNv4Z05o6D8RAaEQa3aYoXlNOuv13GmxVx8lGA+2pzI6R7yw+T3k/dikbJIMp10ppmdXPYGG4nwAakOhLGTpWLymgeki7eOkcRi1RamJuk7ZnwmXVU5owhovVqHRTpK7tUP6EecpPJ2pZ7iHb/hR83yQftW7P+o6eYcg2oMP5hpFh7qKmX4dBLbh3I8lhn04+zJGwXEMVVBPciZTVI1PaORDYnDUe+1M+z/9pZqnRXXiz8uYHnAS5GqUNP2AyorBIoFwB7gWBl8FyxzwPD98btbhsWizFVAxgmVy66gRjg/PW9vtuvAEell6k0SbtOw5FaX0hEzccbKN9qiErfPopGO3vRoTh/qkHEzL3lXBYkZpbmJA3mtoOV9+gGNQCtnHbJslYFi/ALu9A2bIiBuy/nNU9wo0R3meT78evN58Ilj/kggU9XD382R00NvrJiUNzNMitc3603HoxSrLEDzMkufkf1WjM9IIRCeKUxlA2jh7N53LVVluKU6Kssv4m8It/TD//5jnDPrMI1EmTtx9lVu2l2cnnMmL/Nr0Iaw4pgudN0xCSfqP0kIzMRZGmWtLgOPrY0WqXcDZZ+3HIU29d2pLGO49vNrGefNx6Iu3WlqyLN7ig3Id+8HxBv/vP4s9bfMIUr2kOp1HC1bDOM8s66KO73l5ss3k0DmU/964/W6NFPAwcGjT+rrT5MBDGXaphC8WDBUkwK2353YO03SUBfX7Wy0G5Xaaq1BRnGsCjY2btPN8qsxjSd36gfUr2RVm9SQZ234fg+jU2mvYif+fIPR2GbkgTfnE6V0SYzt+6zahlPWv+xLu73EdrLZZN4ODPTuzaYH4eDNPpMvKQY1p3G9XC06JUMd+gGw3LEfkPFSBooZ4EprvFWgM8vSs7EL45mCUWh1RdeMTYgrK/dHDNK7IeWmn49z+E7hAzK2w8AOGRGzoko1A9dvTFvTyIzS6PiMySNHaPTeHk6/pDGFZyZmYQDAm2aih19a0ENFTTffffffbrIp1YFhEKoosZaQOx0cyC87eybJWJF3sOMbH/75YXd7Fy5hpVSp5bONTF7uZDYM1d++fDPvyFJhuhSBhqiU2OEx7Xyk/h3eL+BsT04UPOIFpLAr6yne+B1wsgXOsSjzlqrg3vSThl6WDU7T+qs16I7VxgrP873t3bSrwvCkin4lw505+3iGvdeAO7lYrsIk01GarKnW4PN82PsCBJIx3YI8LrAA3oWMW4K3K6by1KAokv6eycozAbYBfgQIfgRaCCl5XeTMj5J34ju2XHGh4+2fB5821zYAw5fNVSYs4NpgC2XQUyGlpt9+9uGUMIQqhELkxcnRyVgfagZKoci80+TWw3xxnjRyMivcDhRTRhgessmntlTNGnWeDDDR8Ts0YZ/rDM6+9Bcrr2cqbs65lAklVfQNl16UVmuN5dISZxTC2ZFQp+tm5k92D7ubsGa11bf44wI7iVJtKFRRufb0Y60PjEHjyY7WhnRUWVSAVZESx2ruUKPpO+KNyYmOW8qkD2ldYepLq2aQfS7KnFd9J3klCfYPtoqEaFh++VN9pX96MQrNlDcBdbh/CA3IxH1NO2K/7v7iUJO5mlSNZmGkmSWvvU4PZuGyLlOnb2hOHnQ6fKdO+gTwqDKSKPySQqdf9D2psXVNcWfObeevGUW5vhpwHHzaQf+iVC9XG5Va2hM0DDeoinIkDFM/aKlG93CrtZXRZRjBHGV0GpqxjofdgaIZoQ3po8E+rOo0Cg6ZjDDNadfSHjSnKMJ6h6hpaZYzF3iYvDs6oWfKcgj8sFbagtn80cSGlyhzWfidOjUbLaa96BviPH/XOcpgeOP5U6ow/wBACOtnIHCOBhxqbzIDGwT7kxP6D3JfMJVlSbyAA2tObgrwNeWB5SyuNQUY7YFrQi8J6Xu8xKKCYw/+80tPFFtFBdTN2CqynMSMeyabVVFdPu4dW1F6L6/N9gp2ndMhgiWGHXitu+1mlToM8e1bMDc6j3hHDNFcOeMq7tjK4aqt4DJUMd5RuODwS7Y2WnGXzicY3WDIhLHy+dQYVsJIuu2o03OrzrzCbFIE0/riuxhiHYUahB9WiadjmBxo5N+VVZvnbB4chJodDg4nzB2/Ojhy1AzA8iiA+mNxoLRd9E0uuChzqBmDk4nskirIydEJE/eStjDp5Z3InihW7Lf1V2uMhHDLZTD0Gn4fuPEwNLlJ/umkd1xeKAmnPdYGGGKpMrx46sWYxjNT9soPQOmhHmQLZ+4SPylbn2KAdM7BGKBjsmF1eX4J26mcE1z/Y/Wn1//tlRldND0pKQk40yFWvAXI5a7boRem7PJpZs1y/fWwMRmoRata70YBAgJAKmscDuIb3r+wx60AN8dR5R/+qX/N8RYkMMcaCnUct2hs/jXinELOxrK09mabZTAsTttY25B+wwD3i8rCEaTFlgw+3iVDK/yQzqxDvqINmUPhI2Rna+fSP1LUPVo8zH4oe0SpIHH/t7cydpzjLfBPiX2axZ05v3g0tp854nOrtcXyD4l59m1268Sj94SKgb2XdQqXlwDD7fb24GpgZuUkj+C0tz/4JhQYXpyeY8+ndqmO4uJeAEMeDmQecHuL1JTRWieAU4yE0x/FM4rDxxmCTq0LNYpJwygTugaOe8fYsSW9exnq7+jUs5SaOCUosK+wrzbXNoQBgyEabniz0fXxRmrmJbKsVM/6PnSx63meNzTXINVl9z8TnHvk4/vjd/RSWTOPI8vJlYgyjcwY82ymmsiCo8dRhpxpCDnU7Pd+f5Mg8eriCriThl9GaVLapVClilM/Fujrf6Djhc3ITL6QmwKuWa/TI1LcmRTedLYpk+nKxSC+rq/HYzF5wWMhbT121PFsyoqiPNmyGZeKwa6HxO5df7VG84l7GKad8qbTmmVjgCFM2cfpN3TjvcGGWVVkUoQwH49QSQVD6cM1eviYNZHFBcOiWNJHQenFIlayt70bd2MEYwRjBGOUpwlMJ2DIHARno2DbwPu7PLtwxjGYqTfAcHN9k312FdLUz7T5NzjyzEGoloO3Bw1dyiLEAjBWZ9VypQLVPmYRRXuzjd+nqUew4ec9/3iWzcaKUZr59g1N5WhuadbGMOrCJHhRn5Y3ZTg5x93t3Zqm3F9prACPdRJ3z7L5N3CAeBQfJI7j1EWZypF6ZzOgBRC+07CXp9LeTJlzkVJUyYHg91zcpaQ8yrMRhxgfsJLCNlZmpracUzOWR+a5n3udHmM7pCrFRRHemXHzr3DgOwQ11NdQfzILgO2QRR/W7Poa7AhMGo/Si2E3mVThysQZPwp91/6OKH/3UjfzJKdyIV8iAShjAcfl6ZKcu5u2lhz4R3r+RQbVGTf/Tqgk/713Uv5h4eVyU04VmQgwO9rewMiqvLSGviFtjPb4ku+s4neqlqsof2swckNyAxy82Ychx9Qzh4VJv16mSpyOp/3D8kIJr5eZmynb8ATulxlE6f3oTaIzm+3XGyvVOokFcFZwBnFWCGQPbHr4lEHuJP7rP/7FZ7q67JxIFBZKKTwoHASzzzqCcQ7BqDfD4GoA25LmE7OBacjFay4QPAK2ZH7gOQ93bHdrpyi5tPsaZtr867cd7e3spXexlBILNCq1bK6TMtohnbEyyQy3Ogz+rdYW2dvq5erORvvz5cAlyRGu75zuUmYgRjDOm7Q2WhnzoVaIKQ21k4g3jFJyEgp1PK6Lamo10YCcUfOvISe9Y9HRqc+7WPl00S/OB8PbTQz+nAff6uK6pgoRv6jOpKQzzTtHbrzUDppN6ESOYPy7FrAp97wtdojEXvQFjDdhLiUMM3Yjj2uaNBoyvYWzzCz6l9lr9pSRNaisdW3n9nqLdunSi1IWcbIjOTMvUrJ/MfyY0ocFGVz21Tja1ShzUFCalVuPjD6m/ALOIMu2hWawCG5I/WSeiYDiY9WW0PMClWdGg4aa/cwU2m9WpVyuYtII0lLGpQ8PEabg4Owyucew0SkyiUneg8mRiOIewoSAnewHduKUmXlJ3Nt8a0MDXHySdH/Mc2HbbK5tfB58Co6zH+hhFjT8CEO8OA3IC1PiIxZMMiVaNHTcqP7FFUvQSREDPL7vHouSmmbY6B2rza3OxCRTiDL7A/ZDyldjkLw54abYiDE/xqpP2om9wX78zKuqVK14qYFi0u/LIDNWbdEotYj3E7cCZ6bq3iwjJ2GaJBBTwrSbJOO8GiZTDhudohXLGGaHNfC3LS+Udtrbp398NLsRxTR1x51HeRbR0e/0zdmxl43X69gnDJlyt/jOF2B18+UbR22SZZEZOhm9PTL4A4lB9VgWl1TDph6i9si4yIzZPpR8ucOw0ekWk/+AQCIVNJ1EybRawWQV5qiM8lzBGKiX1k4fi0sri2VSzWQK0StBAQyZZ2S8FBed/cPEnC5xvxESD5AsOLuQenXGcl16N6kuuPuw0emMVbaJcaAkDi6TaVlOA0IysTM+cRs/czAqt2qUEwwBQydQ41S1AYZAH2xRltOUF8tdXd0djBZanG/qsQzvZAQPkXfBx4HQCyhrVd/y4R13GDZ69/VwTDBrd1kPj+X5c4H9SUCRXniOwJhrMRhv1HFUJTjAM5azxCIIpSMpJXBSrOWH3/3o0KP5PpzWIXONTf7S76iYmeERtiiPBVodJq1x+Bu9Xyxaqs81hSHP0Kfb2mxzSNnSi9JKtc56MMeC5Q7PXqanfLbWNy3C6hm3a32f1FffzlVeuM6IDR3YB/dVreE7NmeUZZbnA7ulHHdvexdITKLZOfdg9ENz11cDiSTg4r/v/dvlhzNHR8BnxBYSeii8uMjgP+ZxHbLZpMeBDuD/+v1/CncillqUGcwob6gC54YMraMhIcznpHO8F61xlOekGfXjt5yqiLYcwy9pCdbRifrrm8NBuqOnTi/+uIDtxFoat5DmUTyaMKmv7egxWcBSliz8a3vED99Kpor1pH/aZ8W7nK6Z1imc1sTIZkazc36T+3ZD06f+tcQ36PcBYolsb72jjrtHUhzysrmKR5ivbt7wsXZUmNTXENwOzgryjUMByaQn5VArP3SxhKOspQyJiVf6iUVfZHIPMtUoz0w5ahupe9ChKqT55LfL4QXcRTzS8cqsBz//HGeo2aM5vC6pbz6qmLVk6dGxWDn/58eR2Q45g9aPQITT4IzFeniIpaGwUjEY0TwN0hBujJHOpxgDKX7Z2RNSegj5bzPuTR1TTQeV1pusZ6ssllM3Z1z9zGMpx3GkvtRBjCnhpkovFv+8uh6nsx6e3FhYvg2tTYXIaDOOiHQ9to+JIyImDaNahGmK7cESLA4ss7ihzi/3tndJOkH6F3N4hEMBl2rGxzVTRyFS3+urgTDVwEnUc3BGZjeiMivAZ1zi27/s4xej2c+6XLPnZagSk/HGJ8WKMj9Cy5NVH2bTkJSNwR+UBGJGwWQM+A6qwkerbRtH6kuflwn0YoVj4sYzCZjkCxtcDap550Vm1RtDQ0ZmS3JMGj7LgEzQHgvxV+DE5rB7SGujNSBvm52gP+4d4zXYUVePkjq8ZwCnf3El/Q7FmOzbubG378NVHoj8/jJcwDQVnlisKmtUeeTzKsr/b8vTJb814//5kJSq5kJcfLHYrDfb2LfGG/2pMU82qlD4iXrlMEpZWpYyeBgNX+rW9UguGFX4lTAv3TIJu04GB102LFhbFAEAxkDNc5cJwzSlQvv84xmjMeXFMpDYOej4EyvMrWXWSz9RJKoiSAJlhM2vnPXfsUQwGd3aHLVtD8CfVegygyZtvhjfuhhlLlKH5v93o42XfUMsRKnX6tf9a5+w1+9QeLK+jChuZj/TOXGL5SK+ZFRc3zIwcgcwhnjqyDkp9D5FWWDuYhd8bjFQMx+Fpv4wTf7r5toGbafVxorMlfZnNgUB+JRjCxen5yx1g/x5/Xlk8BbOpLsh9xOLzg79LRtrGzjf0hHM1eXN9c3L80uHYj2y1sxtAMfypzQtNtnpSWc62X8xZ4w+Wa4Vsa7hKtI7e3d0wvyFcpT7zIxDpavdPvWv65oCvQG1WG++/vl1UWRoTGo2Y78xcDoP4ufd2BcsHXMFS4YRCQxzvKinHm24+fKNpZ50FUehcYSz2PaZTtSfPLjsZ5VLejbBmSbHy1j1fAopNZvWyChP0kz1824mbb7jT33XcHrKlhXVH9sfzAmqj7NgOn2w/KmUUwqd1talRzvp+92P10wd5QlUuMmGZBkbh8iYh/aMfNUwi6Aa+0+JTQhsWp7OZCu3mjr/RvYiAQ6O4W0yDJtrwNF01OlBugcdPB682Zc/025NNXLzgMrt35QxPfhtOVKEVCRZfWCUKCGVUXBvYq9utPrCLzEDMykY/Em8YdYmsoITtx2Cl2wAvQoDH7cJHLEUPI1bGo5hD/g67EL2dvbKi2W4cpVShWPmSi8WqctIhMgiASl9f9lcBa7ZDuZg32ysILMBG83w3pPecdx1UcalvWCzST1kS/dfZHtpRt0KBiSt8YIGA7DzeH01YC03i9aKjo9hcv7xrHfYLaaj5jfFETlw0HBBe5vxKAheDO0GG6CqDx8OdqxpHp6q9ijTl/FftePMXwbAlMGR/LlYhYvXkxcdP1pisIuwkg0nAF+Gz8FF6oOrWFQTJdwPhe0hTC9FZbLdUPCwBclJaAiLX0kuwpHiwmyMpX7qX5MZg9qK9ZyCNQBtp73NV7JzZG97t73RonoiQtO31JsCxmUjvInXp+ju9Pbf7P9+8h7Xh28PzPUcd48gHO3Kz3Sn9uQHBSO3rDXFXcQtF2WCdQoLiic/1EdaFZa3+MmUw1k0DYnl6RYM6EdSdmM9wBS9PCKR7VpAHPZ26r7td1aq9XT+mmbab1RqvOYoKFxzOhufxKMYios/Lixr1xh6cHN986h71Dno9HTpSxbVtAsCi85iHd4sWk706YHvqi1WCtpS/no3CsYGf1hyxrLibkZ9WFGegUC/cIhSoRMnF3HNQDM69GVsIOKw3c7+IYO60twnyg6bf3dzq7pQBuKABYIR1/UyrMkl4JEXeBLX/FNaoYGLtMpdBZxWq4LUOIiGTkhT5kX+ts+jACdD0Oznaq/5dd7Y9ChRRKiDIIUFZUdRslTXDELr5s6n25hGkCo1UXAEGi6AIwiBxkEzeI08iZcRaxRBpUASb4Hg+tetXfwTbd1E+H6V22g8NNRfsJpU8Hjxxym+iItJJ8HltwZ7mF4n/mmvtZ31Xxj14XcoZ40yH7K12Zb5FwXN0bhR1w+KR8IQXwrdR0ZHWKRiWwI4Sy9KL5ebotpoZwrWuP/xSMDyNYJQ2o18O/6kZtxeb42GIzyywO8iNN7RaaxwtKSJRNirQB++iOuBjk77kfUL4DwKN1dG45Z7BNKtHMEYa1DleMfegC8Gp6leq1dKlauLq/vS0SsvSZF8B84br9eBF6CJ03WpAYkgGn6EFa1NPM8/6QMSniuV5Uap2izX6otL4jOmSMyJ1CQ+zMJayMlhj6Yj03zB6utCZSuvLEcVuk9CQ4V5r/91/80+s7Rdie5GiTKuLPzrzf/59GfKRrhUWyovAYn3TF4kJnHT+Mx+kkc28AirmEgEdv5L8+XyQgUCiJV/WKA5SiUIRUYkQlEKWsUfBAZfVhsAI4RKKkOxRiKZNAoLHOu5SRcgtIdW3l8FGsqC3f2nH07x0zEyQ5pxM+kvucWLENd3lChmBTKVI/kVAcbt9rZVEnZP91BZVTEjm7YCLuFOe3tvexdGHQH1j8YqHis/LhJiwCYuqA3h31HZMV6aqUJtvtLyLPSgjt7Qx6Q2lEFRKVh0o66Jps+DT6Ixe77yCg6+108CX5vrmyuNFUZ68fjmf/xmOdp2HWms7o7yXUt1oFlf0hxBqTK5MOb2DmA2IFWNDZlCDTEbmCKltPRTfQWwAo7oIUpKgr4hjEkGXoBNPDIgQ6gSodSb1JUEJiT9TO2pUS1mLlsekMlIpbTmwpnAhhS8MtOPDi+WV3WwsbaRFgMsN8pa4UIhXpN1xHhL0ESPeIwyoRhVuhSPOBxKWZVm0wfe810nTOMM5p/0jlO7USsyqEKAi94foMRgKd1GIovzuKnv8K8STeU1zVrasSlsod8Wy5znSMI6jpajK9faaDnng+n3AYPs6qWWzOjNlV1lmp9dxDhhnvJSXlwVv5UKVN/d2LRyUaI4mpFbEee5xPrM/YN9e58zvBh5bwQP3x+/gzlHH40xT2KQNiqvJX+BP/unF7BgqfIIW6KP6k+SiUVgR2fw4RLC2gTkj7tHB2/2oQ2BUNLImH6c49hihUQZ7VVA8tV//Znj3oZ5HeBIMwlLJz5exjoct+dRuRWzJpYtZsUoUQyXkGl07K6jTi8LGxrVp19Fqd29kse8ACjS9PpCGaYjEIRHqj9Ri+mj9u9oMG+8XoduAoKIXEKYDQ5sPGQ5GctEWQBA5W6Czly/mR71kSIk4dBxW5oJiriGrP38mqmW5Ebh4EqnRurFwLLN7FK7W8SJQn81rII4EjHK5A5ibCpu5tHDujYq271mzQx1HAFIf1ACMtCAtZwgFIDCe7kwMQVpguJf2doMdEPxsRBUojS4SMu/7eDJuMr2wJjCXIVhzVSONHTJyIGvI3ci/sxGFRtWrht3He96R58xymhMAz73P7a0ZVCpUaAdz7PBEo/aV3YaDDxOKxaKAHwFEHf18dzMADJkSnUG2xIoEAomHhFEqARhsv7f/FvwFiKRvl7/si9xy/v3NXcPOgCdzGSUUcVZ0NX58DGJG/M3nx1vQJTngUpueIhf7iXejdniNG5SsMQoDvcPAUPqKQ5nxIe/OzpJddbXzFbc/HmNjmH5h4X/O/hcfJrx4exuoNWKC5iLElQxla9pDwdIKu5dNg/4A3psXSQwBf64NbYVM4ADkYapIAxHkSsjyvhKb+wcSzOayPJ4YCzah8SoB9Nduty0QsdNC5MwtNoSladN1MiPcPot+b72sYb8JqHgyT0Y7913aSIgWKomHkXvL5WXVpurVR2O7nV6x71jpyc6HNiJEsWrRwUYSy8Wnd1rVkoHUvbGLoV2+GVnj4yjZhAmjQiZey+NrI5MI5MIVUa6IWxYGkfHBEZWMx1vBlKmMFNNe9Lqbs4bW6ANORCWVjTAuIzjR1/Ua/XSQgmPbIpkCdzQ+5AoUczNxgAj3DQGJRgztOoz842tzE4Nw1/7pb3DfqU0JpP7d7tbO5wHJ1/njknSO9OK09qHgFOpYuYg5NGZDTpu5unUDpqZ2eF3yenk0H0AbtCYONN4FkHY1Jxe1JtpHYVdhhSVY5RxAutLxkjJ/M0bg0jQTJP1L66g74rimYUyozF4hAP1+8n7kUF5zU1rGZOhhsEJKsyMxgT1i6mp6bU5c7QfYOd7wVjzHCj0cv5Fb//9zUnvGL8SuYO2WlvFkqJmjBISk6mJ3bssGMMF0+UA6UAzoZFMBgAUT1AomF4uN8s/LLzrHA3OsgmGieT6HSKpkcenMYb8X9zVoT2n2+KkUhbffhKakHWfpJ7pFGfK/WaY/te2gR3gWwMcfbs08p1GmZjaENuJ3a/i8UlVGDWg2YJkBhLPPpxqH3BkOYOePh3lc5eccmu/QEV2ewFANdHvUwEHM5BAnDaAI6apDHELdJYpq5g8sWnYJzWERomSjCUr3m5vL1eXSwullcYKidEaQKXmSeNjr9PrHHTi7ooSZUZFOA5J6eBqcPD2oHvYPTk6AfQy9MWcdZQoM5CxA26UZeZNCMjHkGCUKA/rM7qj37zKN7/25r50HFGiRJlQJm33pAcLuiZH+6NEiXLffsMcmH6GLnEGhk7oQooSJcqDpLNVWGkmdiOSP3EmSpQoDx7AcYY9je19UGP6sKJEiRIlSpQoUaJEiRIlyt9Q/h97Zn11CmVuZHN0cmVhbQplbmRvYmoKMzQgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggMzE0Ci9IZWlnaHQgMTU1Ci9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI1MAovTGVuZ3RoIDc3NDUKPj4Kc3RyZWFtCnja7V1ZbFVVF7Zzb6fbCQiIRNBoCCE8+WL01QiJRh6IA8MPCmjQQDTiFFQwFKqJIFFbkAYDZZRoEQXKYBEUUJlkDlgqtFI6T7ctrVDv/+V+6crOuW2htPfec27X93BzenrGfda317DXXtvrVfQCNTU1//33X0dHhzaFQmFbtLa23vQB2/X19eCstolCYU+Anps3b77HB1K1vb1dOatQ2BDQp1CsYGhERERRURH2/Pvvv9osCoUN0dTU5PF44LFOnjwZ6hXkbWxs1GZRKOwMcDYyMvLee+9VS1ihsDM6fIiOjo6Pj8eft27d0viwQmFPQJlCpWIjKiqK8WGFQmFb/OsDXFcoVm0NhcL+GhZsXbhwoTaFQmF/7Nq1a8SIEapeFQpH2MNpaWmiarVBFAo7IyIiQtxYbQ2Fws6A63rp0iXVrQqFzcFAE3Djxg1lq0JhZ3R0dAwZMiQyMvLWrVvKVoXCzmhra8vJyYmOjtYcCYXC/mhvb4+Li4MlrE2hUNjcEvZ4PBEREQUFBdoaCoWdccsHWMKjRo3SxH6FwuZsxW9sbGxMTIyyVaGwuSXs9Q25KlsVCkegoaGBGU0KhcLmaG9vh3rVdlAo7I+2trbo6GhtB4XCEYiKitJGUCjsj46OjsTERM08VCgcAfit1dXV2g4Khc3BmTgFBQWa269Q2Bw3b950u93jxo1TtioU9vdbz5w5ExERgQ2t0aRQ2Fy3lpaWRkZGerWChEJhezQ3N8N11VmufY8AaCMoAi1jgFrCfQQr0ekyJYogALpVxay3HgQLReL3xo0bmZmZaMPr16+riaIItP0G3crFIrVB7tzKPXfuXGxsrMvlQuu53e6oqKht27ahDdUkVgSarUpVf5aRevitra2FAm1vb8/NzY2LiwNJoUnRaI2NjSUlJfjT65vNpGWZFYEW0ZaWFl3Byp+w0n1hJ+xb0hO/0KFc97atre3AgQP4c+nSpbBMzFMUigDJZ01NDae4DnDCcmVbcJD6lIGjL774Ijk5OTIykqvJ4zB0bvRbt27d6j/ZUM1gRUABTaFsJVtbW1u5nZaWhjYBSaOjo6kx8csIEv/EfpjE4CZOaW5uVilSBAfwyKAjOJQzABlqKkQxd6k0TXryMHZooCp8VWxD+aoyVQQNEDlmR4S922XSCuYuF4gHH9ECs2fPhvvpcrliYmI+/PBDsx3krMbGRpI3ISEBh/1nQKVIETS2ejwejreGsSVMTgmzbviAjfj4eLw7LF5sCH+xgTaxtAbaB/s5XlNbW6teqiIkKC8vh7je9CEseQqQifAxsQ2ugaGZmZnQkgsWLGDsqGeag7ksYKVLGyhCK8wXLlwI46x+GL2M9MLHfOedd6BDmXe0f/9+ak/0UT2/OA87fPgwvXsqX5UcRUjCLJBbFlILD7/Vn3qgW3Z2dkpKCuj2wgsviLMppm93LcPDsPHXX39JcqamQChCyNb169c7ukipJdTT0tLCAVOQsaioKCYmZtCgQYsXL8af0LB3flmyEkxn5hL+5FCsyowihMjKypozZ06YmfcrV66MiIiAmyk7m5qaLLGmnkEDGCTFRa5cuULXVZP2FSEEhBBO64svvuho8wD6FL9c5P3MmTNQhbDta2tre44g3fayaBxc6uOPP1aSKmyihmArLlu2zOvYKFNDQwN+t2/fDmUaFRXF+o3k1137mHRa4+Pjjx49auY4KRShhcvl2rFjh6N1KwdM/T3ZuxtBxrmgOYg/YsQIneygsJVudXraIZN1YQb3o70a54NXI8AKm4EBYecSlpHevtOKAzSgPNT0/PnzWzuhEqKwG1sHuIEhlvPUqVNjY2OZP6yyobAVoDtoCWtTAGvXroW7CjVdW1urU8sVNmTrgC3zYk6FA5gvrSKhsC2qq6uhTQayHpHJR/QINKyksC0KCwvj4uIGrI9GboKw8fHxly9f1txChW0ByYTtN5AtYZbsdrlct3zw6pRVhV09Vq+vNqmD2Nq/w0ys3JKQkMDtXuX8KxTBBHMJ4KzFxMTYgYa33S+VVaqqqvrI2fb2dpYujI6O1gEshf0BtQJtAkt42rRpoeWplDLrkoPcj2Nee+01MKumpqa5ufm2U8h7BqjKuqwPP/ywmr4KR1iV+I2Kijp8+HDIH8bj8dCFtPQnICZ+x44dC57+/vvvFsOgL1i8eDGMCrmpclZhZ0BQpZJwaFU8TVMQkBPJTTLm5+dLvdC6urq+367Nh3/++QfdlBYtVDhIt27cuBH6BXwJvsTKHbERGxubkpJy7Ngx0XRgKx4M+2H9CnN7NZe8h56BFYP51kpVhSPQ2to6a9as6Oho6LWeY8L9K9Ki0ThoQtWZlpbGkCy4mZiYCEKlpqZiT997EgvHGxsbqalv+9YKhX1w48aN5ORk8OJO5LZfCOt/F9ydziPLuMESxgb21NTUcICpX+4r1jXHlysrKxm20rx9hYNAvUbR7ZIXFGmwifUZ+oU4DCixNv4PP/wAVi5ZsgR/ut1uUKm8vJzrF/eva9zU1HTq1KmkpCSvUcxQoXAQqNq83SfHtvsARmdkZFy7dq3vQn7lyhX8Rvrg7SzHjbvjFkeOHGEF8n63UWlOs1/CtrJV4VDdWlxc3GWwhXug40ArlujsryQKrgxFK5QLt9GBBWe5zQrb/fWOXFkVN9VUJYVzARXGYibdKRqxk2FGgkTwKCWZ1sLrLlVhd5eF0Svl7gOq40BP9DZ4NvQ2HP2xrCinUDiLrRb2Uc9CyOPj46EBm5ub4bFCyA8dOjR37tw+DlCaY6lQeX2/VM8GMxU3qAra4i14Xx21UTgRJ0+ehJozScoUhRMnTrhcLmhVMUd7IIUIPzWsacFiu7vY1J3whcqXJYIt2cJ0tAHLdHI5kU+CA2C9wzW2PJhC4TgwScBkB8gFbYud3333HaOyPdOKZLl48SJ82/z8fKpLCewMHTq0u+mi3bnJJvvAr/r6elynqKjIv7vA06KrSUtL80/7N1+QISxcpI95xQpFaAG9c/z4cXP9JuyBc8oV2UT+8S8KvH/cGEeWlZVx/VMhFIOuYEdGRsbmzZu71MuSmssRIrKJz8BYE4uOMrol1VdIPfweOXIE+wsKCp588kmTg7wOL4ID4KuaeVDKVoUTQY5A9TAIQxZ88MEHKSkp1Iam3Yg/OQe2y1wCkCI5ORkaWU4By3gkrmZy0/IA0IxgU1NTEw9YuHAhLrJ27VruOX36NKiK3oMRaW/nXFTeEefu3buXC2qYF8czwNEG6+F0c9kaXbpR4XSqQvLBFMmLgJDDhyV5vZ0LnpoHgx3Z2dkWwxV0AClw7rRp00yLWpaPSUxM7C4clJ6ezlOKi4tx2D2dADfBL2EoroNbM6eXl8W/OBbDJeTwX3BclGaHD1wPzjI7QBF8qDHTL2zF76BBg1iKkyIt81z8UV1dzbRAAUgNsjMZCX+CbklJSean2bFjB64mNRlkP84imwAwfdGiRaAtruPxATtxL1wKKpUsq6yslEXiwNDx48fjYFGmzFHcsGED90Cnl5SUkNoqKr3i1G3dhB4O8I8Bdjn5Qj9HXz4Q2ErdysgqdFaX+fNMAcJ/LZ+AyRI4Zffu3diAmpPPVFtbiz3Q1GCrxHZE02E/K0HxChs3bgQNqSXppXJUl1oSp3ColJP7JAOKrMfp4plKCkRVVRXzo1SrWvrn23LNP/Bu/mkGAC2H0dCSogGmiWU5UROz7wINDQ0Q7MmTJ/NPOJ7iG0rDQoGibcVMpfyTROXl5aL+6EWKzQzqQRvm5uZiPzQsd+IXbIIyhS6+//77qZdFldPcdbvd4CkUpSQtg3d4KmzjePinOH7MmDF8tuXLl+NSNHdJ7V9++YUXDFzCUoC0Q3c6SFReD1zDN+JIFr8FnRo5xVwThE3KVDG5oPSx2KipqeGtOcWY/j7DAqRYY2Oj18gbx++ZM2fOnTu3c+fOgwcPTpgwAf32W2+99ffffx8+fPjEiROwc86ePcuUbw3I9wWQfygp0IEfAmSxBGT4xek/MurLcCt2PvroozieA6n4FjgA+pHfcd68eampqfhSVHzSnR46dIj27X333ScEr6+vpwjhvrgIuoUtW7awVhK/7IwZM2SmPE5BJ1BaWur1rSdFRYwegIKHjYyMDFjRPYzU9ONcnkBcxzRHzf/6v05HJ/jt8AtWSlOQgOiysJNWk+kXkNRoeQ6Fg6E///zzl19++eOPP6KFp0yZgi/O/hkb6DzRzvhqHNRDg2dnZ+MT4zPt2rULFhSoypuyN+ZkDQ7Z874cK1e69RFvvPEGPoH0lrKyhhgq+LO5uTklJYXdtSRR5OXlDR06FEoT3wUiAXLRfCWh+H3JUOwH13AueErtLAuLQwCgZ3EuviZXCuC5pqwyCPbHH3/gFHYX7Exw2fz8fJwycuRIUR+4BR5GBpi6U0bdWX09/8uEZEPduT/oz1DOXLiTCcXyOcRJAcUuXry4bt261atXw5xgS0qMjv0YA3H0GhixJwEZ2OcGyYjtp556ChurVq1Cj/rbb7/ROKFCNOc+iEZGg+PhLTTkF2eIUvoQsYR1RaE+duz4WKb5aprB7JBPnjwp/ALwQSEeIAXOmjNnjkgahzU5goMNMIiUQT+Aa9Lcxb0gV/JNsR97GNTFlaEQxZYWruG7415paWn87rwI7iKsx+1geuEuuI5Ej7uTfzM3mBqHwia2BGWpu1lIdO0JUV4cgxZRNJkoJ+Je7A9xu4qKChwPouH3yJEje/bsgYZ64okn+O5sKDry7NzY7+E1hYzYA9LJwfgX508JDbH97LPPZmVlVVZWoidEZysvJWShd+PtHJjWGUmOYCu+ONgnZgy++JAhQ2Db4AsuWbIEkpCQkMC+EXsgdTk5OdjJ4RVTODk2asq56TZCVjkj4Pr162Z+xZUrV9gV0y2CpJn108joSZMm8eLsTHDMJ598wlISEsHG8zzzzDMickIo//eVpR755PKQtBjhEVy9ehVOMRyuBQsW8OJUUvgFTZgyTaaQR+QL7QoARohEybCfp/AJucGz2IOlp6e//fbba9asuXDhwrVr14qLi6ExxceU5pXOh3kjppqTcI1pJ0vzSsENS5xNAgswWanc+7IgtSLQoKLEhiwjTknGV4aMMRUBojVs2DAwxfSkKDlkCg6GaDGJgvqF6phfHxykzuK9pG8nQW74IApLngqKgIFcct/lcklPIkpc/sTB6FhoyOXm5prDtVRPJAiHdLmH7yWKKbITYj1aLEkyi3YjQaKZWLFiBdhtMoItIC2mZWQUfWQrQ3zmTFV6KNiJTn7x4sV0W0T7SBTRjMxbTCxJHTSNKzF9T58+zXBWYWHhjBkz5s2bB01EdUMrDuQS7uDBYPHiX+CaDPSQLGQZSUcLENchieiFie1NVcgTsUE6f/bZZ59//vnu3bv5RnxahmjYq7BGsbCPGkqm9XVZco2WBkMrYlvKMf1b/kIRxoNr5rwY819c+Hv8+PGW0Ac1rFiM1K2QN7hakHBRMWIHmnpHeNHlfrEG6V7BGyX1yDIqsoceegiWIe4FIxm/FvNMNDu7CC6FbOovfy3Wgy/W3YSC3oZ8ZTb93Z2uGLB+qEVi2cNLAJPqg6E8DqHu2rXr6NGje/fuNWMU1FBCt9TUVBxJDQhCmTENRopgNz7yyCMZGRnQyHv27Dl16hS8MHqgYmCLjqb+FUeJRX0tflMP7KMXXF5ejgdAT6KTyhW2ZWKvDqBdx7pnGzZsAN0YsCXRuC2U5H+ZQ0gaYuP7778/dOgQVGpLS4s5wk4DWKxf/FcyimkxMnfXohP9c4rE9pZ+RkYGJUTpT1goX+hlHqk1WxS2oqG/aSdOlox3b9myRfw4GU2TOIm4e//73/9YnR5nJSQk4L9iSdp5HpmMmHg8HvQqo0ePVrFRhIqtJro7RhQZfjdv3swxR7CSCe2mupw4ceLly5ehtjjQJqqN5iVzhLy+RCCcCyJgjwRy7UlY0drsgjg4q9avIlTSSEfSHMEUlxMKZf369UJJepS0WsHZsrIyc102f9bzIrJTQiJcqtViZ9qKAmZ+LEwCWObz58/n0K2ODCpCaPpK9mZhYeGQIUNASViq4CPHOCZMmJCXl1dfXy/eqOXEO2cZlSlsYLfbbfPJKZLaitZITU2lJyu2gUIRNJKaAf8TJ05A00FR0tPENvQIM6Ul2CIuqlTcFdu4VwqR2QjQ1CtXrrS5hsKjSnkoCUD1y+pyCkUPqtNcaUWy+CRdDWoU9IG5S4HsLk+172Bgihn4HMe3oQvvNYZy0H29+eabOqlcETSqSpxk7dq1MlwCvqSnp5NB9B+ZYW6mzQRCPpubm5OSkqDHpViZDVFaWgpDndPxxHhQtioCoR1k8JG/77//PietMJBbU1MTqul+TGHCM7ACdmh1q393xCHd48ePM5Imjjaz+r3dpJ0rixV3LX7UBeDj2LFjmf/DRCBWIJHFDUOi1/hgI0aM8BrhKTtIO4xzOqRsMdLTMjeE00+0bIviLmBmdzN3DuK0bNkymbgBklrmZ4UQMpGfw0CSIxRCtqLj4lAvW5IJVPDf8/LyOO1FCjcx2eP555+XUhXezuHjm51QgVT0bHRJVw/jlqFLptGKarBPGIeTGUmKnJwc+zQmDN1jx45xuAoklfRIOPUybzQlJUWmA8i0OPzL7HNUOBXdUVXMyNWrV0uxmlOnTlH8oMhY1cpWUgTCUkmF/KnkAaQeAvg4fPjw+++/n70cdC4z9mUeK0MB6HCWLFkC/QvOMheLLW8pJKX8HZhOqAQ6JNWcJtxjjz1GkrJip1PqwOOBDxw4EELfgRtZWVnmtNPeeqMmE8nWjIwMXsrbuVKVV1fQGHhUlQ3WfoTTBNlgdYXq6mpzwRebCwaeEIoJ8lxbW8saQSGxSfbs2SNjWPg9f/48H6a3rj2/C0N2ULsVFRWwpXlN1if3nwCu5A1XSN0SmbrFZAZGPyorKy3SZedSHjKYa676FLRbezsD4PX19SwDTkLJ4h3mYlJ9sX/4RVjJjUtueTsX4pFYvQp2OClTCwH5ocePHw9lCscqNzdXUv4kvmH/kjucanrt2jUaikEIUFsWo9m3bx/cTAZ4OTeBxOF65f3bx4ohIdVg6urq+L344bREUvjRluI0b948KoKXX37ZLEYkNQAdEc2grLLEJZ85oEXsTarOnDnz119/Za0JOqpfffWV2WOYJb77fmtcTcq4eX11YDj6k5SUpJVsw8xFZQItRejpp59m1GLp0qXO7Y3Nikx4nddffz0I0TDeDiYo7jh69GgWXEKPV1hYGOTMZCrTeB+oZxsaGpiGzVKNKvxOB6tTwvdhX03Bc/QbMdWQflygp5xz/rsUged6HCtWrJCq2pLKFbR35623bduGz5qens7V7qT2tcJZwIdDN9vY2LhmzZqoqCj0w7DfvGERQgQ3m30AfcrKyrARhDdatWoV64uCp26322uPhVPx4vjE6LLwSHi8xx9/nNZUTU2N1wkhfQVRUVHBKvEsq85ocBh8O76Ix+MZMWIE5BOUkdKCAYUU1gY7+hLv7Xe2StlwPJvL5cLv9evXTf2rsKc3J4tzcWEXyYcJP1+GwhmS+1rcZ7tFKqTE8aVLl4St6szakK34KGaKu1TCDNw08JCAS50OHTpUyqkpCCZyw4nmLFrY7fSp1R62p8bZtGkTA0qyJ8wG47hKI96xpKRExxktMFcihnElS1Xa2SQYgCQVlQoTaP/+/WH5muQp1AeNfFtNBbIh2DgyzaeoqAgetw3L4Awc01dmoeIrcGTBQan4d8FWLsyanJzstUdI1s7weDyQBK5UxWFZOEc1NTUssa56NvhslYUeaPYUFBSEK1W9nQntcMcGDx6swnaHulVs4AceeICctWQt0jDT5gq0VpWF1zmyYFnQMMze19tZ054FeFUG7qKvg2CcO3eOSVBxcXEsDMW1frTrC4INDEB63W4364TQwglXtoKk0A5K1btuQ1nXlTlgQFpaGiRHeRpQSPo9eAoDmKVOwjg6SlONwSWdztl34YEz29jYyNIW+GW+orZqQF2SiooKNDWo6qCJM3ehUglSVT99vwCmb3V1NTZeeeUV5lLKUvJSj1HJ2182MOsjwfUoKSkJ+1bFC6JfYnWIsOyUQo7z589z7A9A589SUVC+9nQ6nNiZoDNkCkQY+3EMAnPUJjMzU7v9AAk/U91kEfmPPvqIsWJ/C8eedpedPTh0fZMmTYL1Ao3D1LtwlV4oU7wsZ75wCTm7lVt0OmRtawEn18PvkGUX7NPgDM44KIHtXx+SkpKmT58exmahBIGZh9PQ0CCLUCiCoGelMjn9WeqIkFuhICmsrLy8PAdN4923bx+6Pql+Gd66BgJTXV2tk6yDBhgwjA8fPHgQjY/eMjExMSoqqqqqyg7rMsCbdrlcaWlpTlGvDLzLwjTh2smzpjc+TahWwlLATgYpoF4zMjJA2OzsbA7r44uwAkD/Fou7Q/XKusr2n1ZGfQq24oEZBwjXwcf6+nquFOMN6zCa/SEqjEurpKamsrQjaGvaxuYS24EDPVbC/p4RGqSwsFCGHcM1HUJWetLS9KGFfzxn0KBB+DQsowF3zFwtGkcGZ867U4SBlQHi4uKYvBR+kszMSUaWvDpSYzMw0xgbXK6Xa5nNnTuXJIXVx7Uv9auZTislmSshhl9nzhfUohD2/Dqy3j03oDgYg4LCzcrKEiVrGn4Dmbws3xGWAQ18Vrya2+0mVdVdtTmEubKoJXtafEqOM3IVaYaqBmD7mHOxwwwwooqKihISElauXKlUdQQkM6epqQnEvHDhAtcDgsKVsIOEcAdmqRl692HzOvIRXS5Xenp6ZWWl02uSD3CQm0lJSVIjHZrX21mMiEVOsNHl0E/4qeCJEyeiBcLMoGJNg4qKCtWq4eHeejweaN5Ro0bRceP3ffXVV4XRXX7l8NO5W7duRQt4O3MmnfuO8tiymrDs1OK3zkV9fb1JRslj5BLeUDSJiYl//vmn/1gGjwwzwjI7whus8egAWb8MUKxevdqkqiLs/dzp06dDz4K5brcbvs/XX38tiY6il8PGHuZMT0j4gw8+6DjCyqOyF501axb7W/wZ/AQ2RfCd2aamJmEiHFt8fS56O3jw4Pz8/LB8cbzv1atXzUpiDiIsa4xwJgVU6vbt23V2+YCFTKqFkqV7i41NmzZZ5sSZ6VKOoyrUUG1tLbO/nKVVueoou1M4L9hmMVWl6oBVuJLrS+OKw7Us6QOwfHR3AWSniD2rcICt69atc0TxNFnsDJ8ADotl6E3ZOjBhDsKKGON33759ycnJzI9icqMc7FCvFo+9d+9eaCjbZuiZFY+hVe/pxNmzZ5Weih7ERsqDjBkzhjYkfw8ePCiBmnYfHGSYVVdXL1u2DC8CPeu1WTkO2W5tbSVJ4ZKwkAi9FU2BUNxWeGCSySRWFnmDkUzyzpo1y+LP2r9gF5ep4oCOx+OxySNxg9OWR44cyfoD6FLU6FX0nciyojRoGxcXt2XLFtKW4Ur7rILd3fOjq0lKSpIFskPbHzIs0NTUhEdCT4j+UNdYUfSLFqCEc9Ye694zjEz3duvWrWZ+lDmf1G5qoq6ujrY9aIIH47Jige5h5OJtbW00cbGHDB0+fPi7776rMqYINGTZQS4Fhd/Y2NipU6cKx82ijmZEpUtdE7SeRyp5eo3KdZZn63fNy/kXVVVVuDJ4yqmO48aNo02ic1QVgTbqQEbJU4XMp6WlcTYBPcQpU6a0t7dXV1eb84BCrmc5ndDrm6HDGmvwEy0maF+oanHhzaykixcvJiQkULPTg5ZQkqPTmBVO8WQtZiQ3vv32WxIWqpZa7KeffuIBcrypyIIvpQy0gqewBOCAc47w5cuX2f+YNeLunEcchZEBUzkr1gc2yKeffirkVXoqbEJkc3XjS5cuUVyZNwX9smjRIiZdSEFCkyBBkGF6jpxCCIZevXoVhEWvAhs1MzOztLQUj9erJSPJU1m+OSMjg/Rk4VC8stcoOCOL9ipbFXZgq5lFT8mUdckZmGKaOiR57NixJolCpW2hEOFXLl++HLSV0utk3OzZs4uKisxkEj4eOA5GFxcXL1iwgPY/f2nrYjsnJ4d9goqEwrlchgA3NDScPn36vffeu8cAuFxWVgbWcJoY9S/JzrJUAYow+6f9c2U6WAXDhg2TzC7wlxsMrOGX1AY2bNiwe/duXkeyklpaWm76oB9d4VBQpEEHGc5gCSkK+UsvvfTcc89xNWqw45tvvmEc1VIdLggmQW+1PJMz/RNF1NxVOJqtoiL9Jdmcb0tu1tXVzZw5c+fOnVBeqqcUCjubzVLd0WvkaSgUChuy1ayTzHwMNS8VivDA/wEsVCXBCmVuZHN0cmVhbQplbmRvYmoKMzUgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggMzkzCi9IZWlnaHQgNDAKL0JpdHNQZXJDb21wb25lbnQgOAovSW1hZ2VNYXNrIGZhbHNlCi9Db2xvclNwYWNlL0RldmljZVJHQgovRmlsdGVyL0ZsYXRlRGVjb2RlCi9OYW1lL0pmSW1hZ2UwMjM1Ci9MZW5ndGggMzgyMwo+PgpzdHJlYW0KeNrtXV1sVMcVxv/mJ4gSqjYoUoV4qVIB/lFFIf7Bhoq+9KF9rKiJA1EVVQhFUaOkxja2easQBVV5iGhClOcK5aUPTcEYSqtEaUNJnloCKEI0UUX4SVr/4L3b7+63e+7Zubtr++7MXZOOOLoaX+M7c2bOfHPOzDlnsplsNsjOz83zGcwHKGQeZrKZbFjO/Zbl/I8uic1g7XiGhSCboF75ExSMb5KjPDu5Qv6lM5JuFHbM2oOoYUkaE0QcBXNZUHY+qjrqw0Q9maAxczNzwppugK3aw+/nCvgyB5f9FvEoPzpmtoi7uZwAz2TCQhDNKTYmX15iTz6cfahlVU9D/czX5Z5ZqSjfnvISFb0PCgI5nx8y4WvBMZJa+FcjR0ae+MYTDXUN9SvqQXUr6vgk6bILampowhO1N9Y3ooDn+NHxxBAHGR4eGsbX5JstTS2sSGSYveR6tqIudilbIpyyJWwA+z+xzLCKlobWprpmUP2KhqLv5zhNQYAvnL9ABknNjc380SI0oevYe/i4Fh5UJFVjrF3LKokS9eTGJ3/xwks3/nmTLZSpFyHS0tFjx/Ydq1pX6akHohTpHhZ+bXHEioxZL2/Wr1s/sG8gz0tlaMqxfOjnh9q3dIyPTIwNj3ds7UTLX3zhRbzXK2Y5safMzE7Povzqb17lEOu2xcvuSGAEZQrexNhENWs3kE0+KF2NEY/kJIhWYXeqIIjccU4JArc2t2KM2FT+zwTzV/SucLbWtwCUGlc0oYDvr2xZOfPfmXBwCwDlGprOvXMOA8exE+jA/LUGTUGWn5XJiM7kuiPLGXo1BVkVcSUMottB4YSaK1LLEy9/u/t2awZZl4EY/JWes+5IOhz939vde+uTWxXElcr/MwPPbFi/IXzzMK84nf3d2cdWPxYZaJkFzBaZOBAhaUC8bSmsQdIDlDR0wujwaIJhpTBgykMJpOTIZwkLAgUJbailQwfrBVbIEs/25JWlIHljMLjkNwSBhlbgEuYICsQE4lIaplyOJs9Nan2J3Y5mWOxMQTytJhGODPXbNaElrDcnYw0kqKxYELEiGMrwUke2f1e/6IdxjjTvKcxNPYPYGLwpMtxiMonm3b1zF1LdsKLx8tSfQ3W3rnlw/yAK+AKWsAVBmx/XjJNrUjqIFNcnCytRPbAlyVpf0BWhdMXFFXzhV5yzic2opapwcRuHOGlY3wkaw79iFZgaVJxo0KEDZT8kHa3p4oWLMnwagS12pnzWUOmle1ObsEVgWNeMnue6sHbNWr0iJFv7unZ2CRfoQNGatNFKoIjbd9bnox5NacnbZ9+uoDV1tndyDgKaTh4/9YffvxNi1KXLEPWd39t54viJoo3QMirTR1c/kjmrjVb+KDtOJY1cu6R1NoJJQmjK5A26oyNHuaRKf3JAqaKksdFU0M2MDpSJI3sRlY33havIhJaOrN3QmriypHaEIXtNIsa6YHEzVmRSW8dEpJT1fFaNiqAWUl8iOnHtw6DIiUACMevr7dOIpGs0VES7nJYzXbUFzR022GsVtKZdPbso+UAk9Ak650c//DHX37atbYCmqE+CsstQT1eP1g8pS9u/ux24je+DYFoK8Y0j6n66GyOCWlAA7f3+3jOvn0k8rfCHsAdLbhVWgwMJFnoMR3zvjk998JH8hK6gTnCjSbQm+b55bpKKQVeEwPaq0JOUcwR1nf/j+UtTl1A7sBHPKfzLlZ0Sajl54mTBvgh7HtMw1/n1cjxX4tBqcYTpYIgun5jUsIbIIFgG49BULTKFz2rSzOrzhUh6yyu3p187jQK65U8XLuMlemZ4aJg22qe3P5UJWKFn2AmGxoLGJD67t7I4akoGCHhCazLWlAW61Bk7UrXRnqJj/aDaOStaE+ZIie+nqDUZbFqHJgPk0wHeuNkCZCgoNg1C0RFwsadKMmgSm478Ai6ig/UUJ2Oo/xQOl1nAinDz+k0urNFeRIHxwf2Dmzdtvvf5PUDT1LmL2fns3t0/gKJ1987d53/2vPYKqHB2KSdHoiejUshYylLtoclD06MFTagRQGFAE3s+75VX8DpL4DxgQJOcwdUKmsIN7dyZshwOcjdbHCTEK5JPgNKW72zpbO/MzAY8pEPhxsc3Oto6gE5ydiPH0+XGWvuBiNbkoclDk4emysMKfvN70SsaC9ZcQ37bv4BIyWCkJDThWStoogxrOx3oBItSzh8NP0xCMd63b+mgQHZs7Tzz+hkxdaVQ2So0BAl9G4emmmBUNTs8yweacoZ2fdw1xUNTsp5cnlqTAU36bDSBN3hvd6/BY62gSarTu17UoC5euGgcK8v2EZSi/OnzdE5dpEO4CnzgOVSlo6hCjcbp29TklIcmD03LH5pINYcmrTWJE77oEgncQpaP1iTMysiK7nTn33ciF0HltCP7TiHjDJuaj06rDYeWcgMH1GJF2nECT0CTcYzlockKNBlLgIemrww08YQuLNQ3hi6XaqomaNvy2WsygEJc8sJ9pEKgqwCRgE9eHQoK0XOzuQBPAa6C+lRZnyzpIOGhyUOTh6bFQxNdd4hO7dvai9z7g6qcB1I+oavQTgMq33/vfdnHFq1J64rRzv98LlZFx0QXB7wvCE2GQWdEj6aM0ragqaSb3J7+PRj6fvzLeW05ddbq6+3r6eppaWoRF1Y9bT00JdsGN9zDJsYmRodHx0bHQONHx4deGTo2fgyj75RQ43MHnhNXXjwH9w9+cf+Lqo5vlMuldn6W58C+ATAINskvmjFyZIQFu6yR5A2q0AsrVKYU5Or/B5ooxoYzrcWo7ZIko8nII0bSycz10JRMXMXbXLY+tM9wSsEpBZcbipA4vVuBJu1yqeNEdKRt/EcX3uA6Zg1dDa472jru372fLBrdQxPbrKFJJousQZIBIJ1QUAnv1YcOHpqWOqwyT2UcmWOhVjF0WOk++OsHtGUY1WslMkhO6DQ0aa41j06ZJUBxspz69SntWumhyS40caGRaF8xshxRLsCqPq5EeWiyBU3xvDdphqKjcPDZg/mNX3sRi5WhSb93HTCow+i2bdl27/N74HR2enZuZs5Dky1oEu1X55pwnejGyK7D/GCihHtoqt6g05GnGrVSSGEkoNG/q58n6ba6Om7QUdk2rEiRJbviWg6j8AxTMFUXje6hidBkKEscSlH7jUyJjvaadBounbXJQ5MVaNKKqER4paM1yZO5bq787QqzMtqFJp2zzsjdZGQLcbfXxEVcsj289eZb0J1cy5VgssBvHpoCM7b9kYYm3fM1cR4ouSdgB5qCCJro+FdzaNL4YDEpirGSSi0lTr2DNGQM/BqNAbOnXzstLoU6yLca5wGRHNRYE1UBHBm2ZBSQEst4b7dGrRzijYcmD03JkqIsF2hKN6un4RvJ06tqcncsN2gykvhBS4RlF126ETjYGM/VGFeDDYPOQ5OHpiVBUwrhvTWHJob3Gh5W3C6IEhVagibhtFbQxEAVbVGiSdf+cU08La1LGtPd631+doKHJg9NHpoWacBqfYnTVvIqJ86kWg6aQm/w2mlNxpVAktVtwZCTZGAoVyBpL7IQnD00PeLQlOd0EekEne41uYYmuwZjYoNO3BjCaxpyuBQlfl/64FaCpkxtjqVkv53nOFAOL01dkqseyaNFgELvGceRPEXy0OShKRk0xe9Kc73XVENo0lqTHO6DuOsi6JRgwpaEpqIYupQVxaAohg7wCzbBvqiFwqO1VgVhJ8hRrBxQemh61KEp4jRFaJqanBJoMvIpffWgCbBDrSlu0GksKro5+pGFJtQllwGJy83VK1fnZuaiy76tXlGEPuzp6okHbgzsGxh6ZWhsdGx4aBjPibGJ8aPjI0dGnMZL4vvHxo+NDo+yUhAHosrMA4brY9qZB4JF52tKJGxyepu7UaWe5rk427z80svsW4yg3fBPBtIagaX7frJPe92IRLkAeX3hiJEFKJ27clAdVnA6/OiLP4yLDpPdRqGhSUvOu395V1/UYn+HZy4bpQuQpAG5RHA6XV5LQyueVqIFK0ycw4cOi8pkJAk3QrxdXxIqDgxygS/AKgHjsqboG1VqmxRlUQl4ky5nlFV9Q5mx22PdO7rktc7xHUtpj1Noks1S4y4tR1798Qt8jaMrPHVWokidWHqgioYmsWjEZddI5WSFmuqaBX8kP55+CVAiLm1Y93W3YXRBPnO1xONzoI0LVtKJl4xfuhreDhNUqzXFuVgmucENgyu5VpbTEzZ9a5NsGIruhC5laEyt4svQko62DhfQZNxQpu2pCleqWccrQSdWzf6f/s+0JHsUtTZZDJ0BTXoBMkJ97UTfFK6swlMQiU8gEt5IxMGZ02+6hiZQX2+fKEVkltbBIm/Qs7sWi+89nkd+eSQBNInWVHmvKU2A0qnkNMtWoInbrfhI+7Z2wSX6qknZ7vDp/tQcxVOfHRg8YNfiiKtqRlxkuW09F8AL3levXK2TZq9bu+6zf32m/Q+XeprGPwQ0GV0qipnGZB3BYTG0SqfpMCKtpEy3UqfQBMH+8sGXT337Kcl7o6Py2TDtzJBOJhx0DgY9vL23Cl3FiKFbPtAk09lCS9TlFA/uPWjb2mYc3Du9frqkWSfrOKDy9q3byW7WXtA0Lnn7M2XYdQ4uI8BWdvYe/9rjV69cxUCI1sQlY0mbw5zv3U93G5zGR9BRwKAeUAMD2b1Y7+gg4RSa9L46JJwdwqvo0rcCjMwPsDFHh0erub13bHRMQEDrvctLa8pkq528Ktnp7PTs5LlJnroaO7TWFYmSqRXIIxqQP+QVxx6X0CSHR6kl4JJtHya92dO/543fvkFOMRZcLMI9QJVpdvG4VAGajNNPdyxrXNK26uZNm6EWkjW3M6gAfei9EOoz2Vuf3Dp54mRPVw+WAG3Fp5Y2UPdzsr0m4QhaU8mt0ZShiXtNjqBJn0xxoeEEuX7t+v6f7seUWbNqTVyYLQbdy+wAPvTv6j/47EFULVBp3TkwDk2uJ2k56mzv3LF9x+FDh298fCPKg10AIn1pyFJFlwadcepXjjVHKqL0KuB34zc3QpCO/+r4h3//MJ9wIIUQg8CTJ0+ePHny5MmTJ0+ePHny5MmTJ0+ePHny5MmTJ0/p0f8Ara2alAplbmRzdHJlYW0KZW5kb2JqCjM2IDAgb2JqCjw8Ci9UeXBlL1hPYmplY3QKL1N1YnR5cGUvSW1hZ2UKL1dpZHRoIDM5MwovSGVpZ2h0IDQxCi9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI1MwovTGVuZ3RoIDM5MTIKPj4Kc3RyZWFtCnja7V1dbFTHFcb/hJCIAFUbFKlCvFSpAP+ooiRgY4eKvvShfawoxIGoiiqEoqhREv9hm7cKUUiVh4gE0uS1Qnmp1BACNqVVqqiiJE9tElCEaKKW36QFG/tuv7vf7rln5+6u8ezMXZOOOLoaX+M7c2bOfHPOmTNncrO5XJSbmZ7hM5qJUJi9M5ubzcXl/G9ZLvzok9gM1o5nXIhyFvXKn6BgfJMcFdjJFwovvZF0o7Bj1h4lDbNpTJRwFE3nQLmZpOqkD6160qIx07enhTXdAFe1x9/PF/BlDi77LeFRfvTMbAl303kBvj0bF6JkTrExhfI8e/LO1B0tq3oa6mehLv/MSkWF9lSWqOR9VBTImcKQCV9zjpHUwr8aHhx++JsPNzU0NS5qBDUsauCTpMs+qKWpBU/U3tzYjAKeY/vGrCEOMjw0MISvyTfbWtpYkcgwe8n3bEVd7FK2RDhlS9gA9r+1zLCKtqbFLQ2toMZFTSXfz3OagQCffu80GSS1NrfyR4fQhK5j7+HjWnhQkVSNsfYtqyRK1COrHvnls89f+MdFtlCmXoJI80ePjRs2Llm8RE89EKVI97Dw64ojVmTMenmzfNnyHdt3FHipDk15lvf8Yk/H2s6x4fHRobHOdV1o+XPPPof3esWsJPaUmalbUyi/8ptXOMS6bemyPxIYQZmCNz46XsvaDWSTD0pXY8QTOYmSVdifKggid5xTgsCLWxdjjNhU/k+L+St6VzxbG9sASs2LWlDA9+9ru+/2f2/Hg1sEKN/QdPLESQwcx06gA/PXGTRFOX5WJiM6k+uOLGfo1QxkVcSVMIhuB8UTarpELbde/p7ofUIzyLoMxOCv9Jz1R9Lh6P+ezT2XPrtURVyp/D+548mVy1fGb+4UFKfjvzv+wP0PJAba7Bxmi0wciJA0IN22DNYg6QFKGjphZGjEYlgpDJjyUAIpOfJZwoJAgaUNNX/oYL3AClni2Z6CshTZNwaDS35jEGhaDFzCHEGBmEBcysKUy9Opk6e0vsRuRzMcdqYgnlaTCEeG+u2b0BLWm5exJhJUViyIWBEMZXi+I9u3pU/0wzRHmvcM5qaeQWwM3pQYbimZRPOuXbkGqW5a1Hx24k+xutvQ2r+zHwV8AUvYnKDNj2vGyTUpG0RK65PFlagR2GKz1hd1RShdaXEFX/gV56y1GTVfFS5t4xAnDevbojH8K1aBqUHFiQYdOlD8IdloTZOnJ2X4NAI77Ez5rKHSS/dmNmFLwLChFT3PdeHBpQ/qFcFu7dv02CbhAh0oWpM2WgkUafvO+XzUoyktefv421W0pq6OLs5BQNOhA4ff+f2JGKPOnIWoP/b9xw4eOFjiCK2gMn10/iOZs9po5Y/icSpr5LolrbMRTCyhabZg0O0b3sclVfqTA0oVJQtHU1E3MzpQJo74Iqob73NXMRtbOrJ2Q2viypLZFob4mkSMdcGhM1ZkUlvHRKSM9XxWjYqgFlJfIjpx7cOgyI6AhZj19vRqRNI1GiqiW04rma7agqaHDfZaFa1pS/cWSj4QCX2Czvnxj37C9bd9XTugKemTqOIy1L2pW+uHlKUN39sA3Mb3QTAthfjGE21+fDNGBLWgANr2g23HXj9mPa3wh7AHy7oKa8EBi4Uew5H23fGpNz7sd+iK6gQdTaI1yffNfZNMDLoSBHZXhZ6knCOo67133zszcQa1AxvxnMC/fNkroZZDBw8V7Yu45zEN853fKNtzZTat7o4wHQzR5ROTGtYQGQTLYByaqkOm8FlNmlm9v5BIb2Xl9sirR1BAt/zx9Fm8RM8MDQzRRvv88ucyAav0DDvB0FjQGOu9eyeLoyY7QMATWpOxpszRpd7YkaqN9pRs60e1zlnRmjBHynw/Q63JYNM5NBkgnw3wps0WIENRsWkSSraASyNV7KBJbDryC7hINtYznIyx/lPcXGYBK8LFTy9yYU18EUXG+3f2r1m95vrV64CmiZOTuZnctid+CEXr2pVrz/z8GR0VUGXvUnaORE9GpZCxjKU6QFOApnsLmlAjgMKAJvZ8ISqvGHVmETxgQJPswdULmmKHdn5PWTYH6c2WAAmJiuQToLT2u2u7OrpmpyJu0qFw4ZMLne2dQCfZu5Ht6UpjreNARGsK0BSgKUBT9WEFvwVf9KLmojXXVHD7FxHJDkbKQhOe9YImyrC204FOsChl/9GIwyQU433H2k4KZOe6rmOvHxNTVwrVrUJDkNC3aWiqC0bV4uFZONCUN7Qb06EpAZrsenJhak0GNOm9UYto8J7NPQaP9YImqU57vahBTZ6eNLaVxX0Epaiw+3wrry4yIFwdfOA+VLWtqGKNxu7bxKmJAE0BmhY+NJHqDk1aa5IgfNElLMJCFo7WJMzKyIrudOVfV5IQQRW0I36nmHEem5pJdquNgJZKAwfUYkU6cAJPQJOxjRWgyQk0GUtAgKavDTRxhy4uNDbHIZdqqlq0beH4mgygkJC82I9UPOgqQCTgU1CHouLpuan8AU8BrqL6VF2fLBsgEaApQFOApruHJobuEJ061neUhPdHNQUPZLxDV6WdBlR+8JcPxI8tWpPWFRPP/0z+rIo+E1164H1OaDIMOuP0aMYo7QqayobJbe3biqHvw7981JbXYK3ent7uTd1tLW0SwqqnbYAmOze4ER42Pjo+MjQyOjIKGts3NvDiwP6x/Rh9r4Qan971tITy4tm/s//LG1/WtH2jQi518LM8d2zfAQbBJvlFM4YHh1lwyxpJ3qAKvbBCZcpArv5/oIlibATTOjy1XZZkNHnyiCfpZOYGaLITV4k2F9eHjhnO6HBKMeSGIiRB706gSYdc6nMi+qRt+kcf0eD6zBq6Glx3tnfeuHbD7jR6gKay0MQILi5wAhTZyLA+W6FnboCm2qFJNrUzRifCgtR19LWjOndWjWyWhSa9maLPhGYjxnI4/eq/r4pPKUCT3QlfDU3aRyEpCLQV74nyB6wa00pUgCa7YZV5qs2cOh5FR2H3U7sLjl93JxYleEBDk5EdRccV+GaT7oj1a9dfv3odnE7dmpq+PR2gyRU0ifarc034TnRjZNdhfjBRwgM01a416ZOnGrUySGEkoNG3pY876a66Oq01UUMzrEiRJbfiWgmj8IxTMNV2Gj1AE6HJUJY4lLINamRK9ORr0mm4tGIcoMkJNGlFVE54ZaM1aYsS9Z776zlmZXQLTTpnnZG7ycgW4s/XxEVcsj28+cab0J0CNLmFJvTz4EuD3NTQexD+9nFQnSxtUgjQ5HCH7uyZs5OnJ+VIPp6+0w6ATvzhxMuHXuZs5bCueGjFW799ywc0iZJ2+NeH333nXc0mCm6TD6QTLIDQtwLCXGEzkCtRF/WsiaEpMtNu3NPQpEW6LnFNZVPruIGmKIEmxiTXHZq06uIwX5OxkkotZQJyoixkDPwajQGzR149ItHOOv9ALXFNIjmosS6qAjgy3FzJWbnUZRxua9R2K94EaArQZJevaaFAU1b8lt1H48Z6LWmFFho0GflFoTitXL4yuQ/I3dakUWPaQjcMugBNAZrmBU0ZZB6oOzQx84BhWtKTmeRQdQRNwmm9oIln6LSzC036+O8fSxC4c0nDp+QKJB1FFvdAgKZ7HJoKnN5FOkGvBp1vaHKrlVlrTRLGEF/TkIemJPH7/Ae3EjTV6wwdSPzt3McBAp+ZOCNXPZJHmxv35tLTjMiQAE0BmgI0zcvXRDc1m6QzKsv9s7VDUx2P99LzY2R1Y34S43JShzUakRJ0vwdoCtBkB03paxx9+5rqqDVpg07ijkCcsKI4WegSc0NTxjZsVHK8F5oh2AT7knBJeHTWqijuBMFDiZ0I0HSvQ1PCaYbQhGVUoMlI9fb1gybADg067QDnQq+xqORS+3sWmlCX3FMm0YDnz52fvj1N1qwzU1Ui9GH3pm45X6YPOA+8ODA6Mjo0MITn+Oj42L6x4cFhryFA+P7+sf0jQyOsFMSBqDEpihGVnXVSlOiuU8lZCZvs3uYve2qk51BCUF54/gX2LUbQbbAWz/gbZ963/3S7DggUifIB8vouJCNBWTbXeKE6rOCMRdR3Ehl3sNqZORqatOS8/+f39R1SLn07lMDpXJLJRPKZ5HNU6kyebU2L8XRykLnKxNm7Z6+oTMb9BUZsm+/7i8Vml7vFAVYWjMuaoi97qm++prvKDW67nFFW9eWJhrfH+cGNsjfOpzdTpD1eoUn2cYxr/jwdOErfLW5sXeGpE6bZOWF4hk5Dk1g0cprAyDLnhFoaWgV/JHWnfglQIi6tXPYNv1ccRoWk+pIqhANt3P2UzXWo6fug44urolq1pjQXC+TaAsPgstfK8nrC6m+vFoeh6E7oUp7aq9fRV7Sks73TBzQZlydqe6rKbY/O8cpIBcD+v/WfW5KH1u6Qvs4NrqFJL0DGdbpuDgYWb9PDUxCJTyAS3siJg2NH3vANTaDenl5RisgsrYO7vNzT7Vosx4LwHHxp0AKaRGuq7mvKEqB0lkvNshNoorsVH+lY3yG4xFg1KbsdPt2fmqN0VsZd/bvcWhxpVc04sl3JrecDeMH7/ffdr/P5L3tw2Rf//ELHH853N41/CGgyulQUM43JxrknV6c+5YOsSx8ClTLDSr1CEwT7q5tfPfqdRyXpjU4YwobJ7XhZJjjCoMcXi9egqxhn6BYONMl0dtASdW/Ozes329e1Gxv3afvOxyQ1Jix/BFRevnTZ4YayNo3LXkxPGfadHtA4+y+evRUPrTh/7jwGQrQmLhnzcg5zvm9+fLPBaXoEPZ1l1gNqYCC7F+sdY7e8QpP2q0PC2SG8JTN7K8BISgMbc2RopJaLxUdHRgUEtN67sLSm2ZqjQVTYzNStqVMnT3HX1fDQOlckymZ9IY9oQGGTV2IOfUKTbB5lmUeObh/m49rat/Xoa0fJKcaCi0XsA5zNzWvfShzLlaDJ2P30x7LGJW2rrlm9BmohWfM7g4rQh96LoX42d+mzS4cOHure1I0loGw0pm9fk+5nO1+TcAStqaxrNGNooq/JEzTpnSkuNJwgn3786c6f7cSUWbpkaVqYHeYDkdkBfOjb0rf7qd2oWqDSeXBgGpp8T9JK1NXRtXHDxr179l745EISUVkEIn2f0XxFlwadsetXiTVPKqL0KuB31bdWQZAO/OrAh3/7sJALJYPTT1GgQIECBQoUKFCgQIECBQoUKFCgQIECBQoUKFCgQIGyo/8BJVX0WgplbmRzdHJlYW0KZW5kb2JqCjM3IDAgb2JqCjw8Ci9UeXBlL1hPYmplY3QKL1N1YnR5cGUvSW1hZ2UKL1dpZHRoIDM5MwovSGVpZ2h0IDQwCi9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI1NAovTGVuZ3RoIDM4MjMKPj4Kc3RyZWFtCnja7V1dbFTHFcb/5ieIEqo2KFKFeKlSAf5RRSH+wYaKvvShfayoiQNRFVUIRVGjpMY2tnmrEAVVeYhoQpTnCuWlD03BGEqrRGlDSZ5aAihCNFFF+Ela/+C92+/ut3vu2bm7a/vuzF2Tjji6Gl/jO3Nmznxzzsw5Z7KZbDbIzs/N8xnMByhkHmaymWxYzv2W5fyPLonNYO14hoUgm6Be+RMUjG+Sozw7uUL+pTOSbhR2zNqDqGFJGhNEHAVzWVB2Pqo66sNEPZmgMXMzc8KaboCt2sPv5wr4MgeX/RbxKD86ZraIu7mcAM9kwkIQzSk2Jl9eYk8+nH2oZVVPQ/3M1+WeWako357yEhW9DwoCOZ8fMuFrwTGSWvhXI0dGnvjGEw11DfUr6kF1K+r4JOmyC2pqaMITtTfWN6KA5/jR8cQQBxkeHhrG1+SbLU0trEhkmL3keraiLnYpWyKcsiVsAPs/scywipaG1qa6ZlD9ioai7+c4TUGAL5y/QAZJzY3N/NEiNKHr2Hv4uBYeVCRVY6xdyyqJEvXkxid/8cJLN/55ky2UqRch0tLRY8f2HataV+mpB6IU6R4Wfm1xxIqMWS9v1q9bP7BvIM9LZWjKsXzo54fat3SMj0yMDY93bO1Ey1984UW81ytmObGnzMxOz6L86m9e5RDrtsXL7khgBGUK3sTYRDVrN5BNPihdjRGP5CSIVmF3qiCI3HFOCQK3NrdijNhU/s8E81f0rnC21rcAlBpXNKGA769sWTnz35lwcAsA5Rqazr1zDgPHsRPowPy1Bk1Blp+VyYjO5Lojyxl6NQVZFXElDKLbQeGEmitSyxMvf7v7dmsGWZeBGPyVnrPuSDoc/d/b3Xvrk1sVxJXK/zMDz2xYvyF88zCvOJ393dnHVj8WGWiZBcwWmTgQIWlAvG0prEHSA5Q0dMLo8GiCYaUwYMpDCaTkyGcJCwIFCW2opUMH6wVWyBLP9uSVpSB5YzC45DcEgYZW4BLmCArEBOJSGqZcjibPTWp9id2OZljsTEE8rSYRjgz12zWhJaw3J2MNJKisWBCxIhjK8FJHtn9Xv+iHcY407ynMTT2D2Bi8KTLcYjKJ5t29cxdS3bCi8fLUn0N1t655cP8gCvgClrAFQZsf14yTa1I6iBTXJwsrUT2wJclaX9AVoXTFxRV84Vecs4nNqKWqcHEbhzhpWN8JGsO/YhWYGlScaNChA2U/JB2t6eKFizJ8GoEtdqZ81lDppXtTm7BFYFjXjJ7nurB2zVq9IiRb+7p2dgkX6EDRmrTRSqCI23fW56MeTWnJ22ffrqA1dbZ3cg4Cmk4eP/WH378TYtSlyxD1nd/beeL4iaKN0DIq00dXP5I5q41W/ig7TiWNXLukdTaCSUJoyuQNuqMjR7mkSn9yQKmipLHRVNDNjA6UiSN7EZWN94WryISWjqzd0Jq4sqR2hCF7TSLGumBxM1ZkUlvHRKSU9XxWjYqgFlJfIjpx7cOgyIlAAjHr6+3TiKRrNFREu5yWM121Bc0dNthrFbSmXT27KPlAJPQJOudHP/wx19+2rW2ApqhPgrLLUE9Xj9YPKUvbv7sduI3vg2BaCvGNI+p+uhsjglpQAO39/t4zr59JPK3wh7AHS24VVoMDCRZ6DEd8745PffCR/ISuoE5wo0m0Jvm+eW6SikFXhMD2qtCTlHMEdZ3/4/lLU5dQO7ARzyn8y5WdEmo5eeJkwb4Iex7TMNf59XI8V+LQanGE6WCILp+Y1LCGyCBYBuPQVC0yhc9q0szq84VIessrt6dfO40CuuVPFy7jJXpmeGiYNtqntz+VCVihZ9gJhsaCxiQ+u7eyOGpKBgh4Qmsy1pQFutQZO1K10Z6iY/2g2jkrWhPmSInvp6g1GWxahyYD5NMB3rjZAmQoKDYNQtERcLGnSjJoEpuO/AIuooP1FCdjqP8UDpdZwIpw8/pNLqzRXkSB8cH9g5s3bb73+T1A09S5i9n57N7dP4CidffO3ed/9rz2CqhwdiknR6Ino1LIWMpS7aHJQ9OjBU2oEUBhQBN7Pu+VV/A6S+A8YECTnMHVCprCDe3cmbIcDnI3WxwkxCuST4DSlu9s6WzvzMwGPKRD4cbHNzraOoBOcnYjx9Plxlr7gYjW5KHJQ5OHpsrDCn7ze9ErGgvWXEN+27+ASMlgpCQ04VkraKIMazsd6ASLUs4fDT9MQjHet2/poEB2bO088/oZMXWlUNkqNAQJfRuHpppgVDU7PMsHmnKGdn3cNcVDU7KeXJ5akwFN+mw0gTd4b3evwWOtoEmq07te1KAuXrhoHCvL9hGUovzp83ROXaRDuAp84DlUpaOoQo3G6dvU5JSHJg9Nyx+aSDWHJq01iRO+6BIJ3EKWj9YkzMrIiu505993IhdB5bQj+04h4wybmo9Oqw2HlnIDB9RiRdpxAk9Ak3GM5aHJCjQZS4CHpq8MNPGELizUN4Yul2qqJmjb8tlrMoBCXPLCfaRCoKsAkYBPXh0KCtFzs7kATwGugvpUWZ8s6SDhoclDk4emxUMTXXeITu3b2ovc+4OqnAdSPqGr0E4DKt9/733ZxxatSeuK0c7/fC5WRcdEFwe8LwhNhkFnRI+mjNK2oKmkm9ye/j0Y+n78y3ltOXXW6uvt6+nqaWlqERdWPW09NCXbBjfcwybGJkaHR8dGx0DjR8eHXhk6Nn4Mo++UUONzB54TV148B/cPfnH/i6qOb5TLpXZ+lufAvgEwCDbJL5oxcmSEBbuskeQNqtALK1SmFOTq/weaKMaGM63FqO2SJKPJyCNG0snM9dCUTFzF21y2PrTPcErBKQWXG4qQOL1bgSbtcqnjRHSkbfxHF97gOmYNXQ2uO9o67t+9nywa3UMT26yhSSaLrEGSASCdUFAJ79WHDh6aljqsMk9lHJljoVYxdFjpPvjrB7RlGNVrJTJITug0NGmuNY9OmSVAcbKc+vUp7VrpockuNHGhkWhfMbIcUS7Aqj6uRHlosgVN8bw3aYaio3Dw2YP5jV97EYuVoUm/dx0wqMPotm3Zdu/ze+B0dnp2bmbOQ5MtaBLtV+eacJ3oxsiuw/xgooR7aKreoNORpxq1UkhhJKDRv6ufJ+m2ujpu0FHZNqxIkSW74loOo/AMUzBVF43uoYnQZChLHEpR+41MiY72mnQaLp21yUOTFWjSiqhEeKWjNcmTuW6u/O0KszLahSads87I3WRkC3G318RFXLI9vPXmW9CdXMuVYLLAbx6aAjO2/ZGGJt3zNXEeKLknYAeaggia6PhXc2jS+GAxKYqxkkotJU69gzRkDPwajQGzp187LS6FOsi3GucBkRzUWBNVARwZtmQUkBLLeG+3Rq0c4o2HJg9NyZKiLBdoSjerp+EbydOranJ3LDdoMpL4QUuEZRdduhE42BjP1RhXgw2DzkOTh6YlQVMK4b01hyaG9xoeVtwuiBIVWoIm4bRW0MRAFW1RoknX/nFNPC2tSxrT3et9fnaChyYPTR6aFmnAan2J01byKifOpFoOmkJv8NppTcaVQJLVbcGQk2RgKFcgaS+yEJw9ND3i0JTndBHpBJ3uNbmGJrsGY2KDTtwYwmsacrgUJX5f+uBWgqZMbY6lZL+d5zhQDi9NXZKrHsmjRYBC7xnHkTxF8tDkoSkZNMXvSnO911RDaNJakxzug7jrIuiUYMKWhKaiGLqUFcWgKIYO8As2wb6ohcKjtVYFYSfIUawcUHpoetShKeI0RWiampwSaDLyKX31oAmwQ60pbtBpLCq6OfqRhSbUJZcBicvN1StX52bmosu+rV5RhD7s6eqJB24M7BsYemVobHRseGgYz4mxifGj4yNHRpzGS+L7x8aPjQ6PslIQB6LKzAOG62PamQeCRedrSiRscnqbu1Glnua5ONu8/NLL7FuMoN3wTwbSGoGl+36yT3vdiES5AHl94YiRBSidu3JQHVZwOvzoiz+Miw6T3UahoUlLzrt/eVdf1GJ/h2cuG6ULkKQBuURwOl1eS0MrnlaiBStMnMOHDovKZCQJN0K8XV8SKg4McoEvwCoB47Km6BtVapsUZVEJeJMuZ5RVfUOZsdtj3Tu65LXO8R1LaY9TaJLNUuMuLUde/fELfI2jKzx1VqJInVh6oIqGJrFoxGXXSOVkhZrqmgV/JD+efglQIi5tWPd1t2F0QT5ztcTjc6CNC1bSiZeMX7oa3g4TVKs1xblYJrnBDYMruVaW0xM2fWuTbBiK7oQuZWhMreLL0JKOtg4X0GTcUKbtqQpXqlnHK0EnVs3+n/7PtCR7FLU2WQydAU16ATJCfe1E3xSurMJTEIlPIBLeSMTBmdNvuoYmUF9vnyhFZJbWwSJv0LO7FovvPZ5HfnkkATSJ1lR5rylNgNKp5DTLVqCJ2634SPu2dsEl+qpJ2e7w6f7UHMVTnx0YPGDX4oirakZcZLltPRfAC95Xr1ytk2avW7vus399pv0Pl3qaxj8ENBldKoqZxmQdwWExtEqn6TAiraRMt1Kn0ATB/vLBl099+ynJe6Oj8tkw7cyQTiYcdA4GPby9twpdxYihWz7QJNPZQkvU5RQP7j1o29pmHNw7vX66pFkn6zig8vat28lu1l7QNC55+zNl2HUOLiPAVnb2Hv/a41evXMVAiNbEJWNJm8Oc791PdxucxkfQUcCgHlADA9m9WO/oIOEUmvS+OiScHcKr6NK3AozMD7AxR4dHq7m9d2x0TEBA673LS2vKZKudvCrZ6ez07OS5SZ66Gju01hWJkqkVyCMakD/kFccel9Akh0epJeCSbR8mvdnTv+eN375BTjEWXCzCPUCVaXbxuFQBmozTT3csa1zSturmTZuhFpI1tzOoAH3ovRDqM9lbn9w6eeJkT1cPlgBtxaeWNlD3c7K9JuEIWlPJrdGUoYl7TY6gSZ9McaHhBLl+7fr+n+7HlFmzak1cmC0G3cvsAD707+o/+OxBVC1Qad05MA5NridpOeps79yxfcfhQ4dvfHwjyoNdACJ9achSRZcGnXHqV441Ryqi9Crgd+M3N0KQjv/q+Id//zCfcCCFEIPAkydPnjx58uTJkydPnjx58uTJkydPnjx58uTJkydP6dH/AK2tmpQKZW5kc3RyZWFtCmVuZG9iagozOCAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0ltYWdlCi9XaWR0aCA5NgovSGVpZ2h0IDk2Ci9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI1NQovTGVuZ3RoIDUzODEKPj4Kc3RyZWFtCnja7Zz3k5ZFtoBXEclJkiBIzjmK5BwkiKAuKCI5KWAgR8koYcg5JxFzlizZ3Z/27lbd3f0jtvwX7lP1VJ3q+hhGZhwGl/vVnOrq6bfffk+fPqlPn/5+/c+vv2bh3nD2zNks5AFfffFVFrJQYPj6y6+zkAd8+fmXWcgDshySN2Q1TBaykIUsZCELWchCFh4EfPv1t3rjX3z2RXietFDa8t0333127jNb+Pebr76h8vmnn9NO6b+PMDh3pgmcO3sOCjBriAZAH8B/eUrdUipRgUSffvIpJfVHlT4/fPcDk4VKlJCCFhlDakAZOkhASAFlvv/2e57KTlT8l26PMP9IDegQwqVYwU6P/ekx4PbN25KCzvSkgzxDhUYl8VGlD1P78fsfmSnsAYl+vvIzzCChaIE4Tz7xJI3KFOX5H89fPH+Rt+ymSD7C/BPCBSccOnCoauWqmz7cdOGnC0w5+OfOrTvqIhpHDBvRt3dfOstmKm3F7VHlH20Q5e6du0sUL1HssWLLliyDqZCpqZOnTpowCYaxc/u27SHXmFfH8Eiq/v+JtDBTaHJg34FGDRrt2bUHDYMoXbpw6frP12Gbn374CSbp37f/9KnTaYcydKAlVPR/yzQjwJiGqW1nUvFIryYstX2cLNOHUAf3H9ywbsPqD1avXb12/dr169asg0rIHR00/XKdQperF5TiEAHPCH4+RDbII54fdjkkCyWs8xPdYJWVy1ciZYhS8WLF0c9Unnj8CYRLtomevsWYOlEZWuhugmjmgrAP91zjXnylXATO8lWqq+EfCNKpQyd4Bs5ZtXLVxvUb586eS+P4ceNhLcfXC5LIGD5dyiCII6vVw/b5FV7U/f4jHABl8FW4dhplZ0eLswOuXLqyZtWax//0OFYMs969a/cO7TosWrDo3//8d8P6DZs1aUZ/SAQwQcCJ60EJ0tlh3b+4hfHTwXIPUcTSA46Uc1QUqQpimhBEV+f40eP79uzbnrO9RbMWZUuXnTVj1rjXxmnfW7Vo9eYbb/bo1oP6zOkz0UhbN2+l87Ejx5g1SgmAhQDGlFzhSbpDic1duOUPS6XHuqTiLzWooFuuXr6KSaKesyVnwbwFo0aOGth/YNPGTatVqVbyyZJwDpqHUuUDSCL0j422U5YqUarm0zXbtGoz7IVhyB1iCBw5dARa8QnFUDQUJaVMioXuerj0iT24W4Oli5e+Pvb1ju07VnmqinNUCQvoYYhQumRpmKdCuQoVy1eEYrVq1mrbum3L5i0b1GvAv9CEV+jD0/T1dBy6DR44GMN39sxZKKNScnOn2lGuH66Jj4r2lzVFjYh/sEFMqnKlyng1896bhx5Gyj75+BOmg+dz7eo1OAEthAzCcniJ7dq04/WXXnzp9MnTH274cOH8hchgz+49YT+IBqQjw42sBR4mwsgCXb54WYlTAB+iPxycE9qGCbKmEofdATpky6YtOIEYKTnn7Vlv37pxC+mDmMzFQcJlCq07aMAg+vfq0Qui0Q1mgIyUsAqOJbBj247JEyfXr1s/JRTjo9jhXhQUxjG0uvZCB0zSqcnThZaYKofC3VUFI4W6VqYgBeRSnVJp3bK1s0D0jHXAP1ZSl5IK1Bv757EMggJPA2v6DBo1eRXGQ5wXL1zcr08/BNPvWr4y+hW4lKEy/MzU2qq9A4F0Lg/CuBu74Iuu6cujXmYRQc89KZYLKfARsoAUuF/Q1gR56cxbc96eQ7c6teucPH5SxRJ9UvvuHJFHhjpx7AS6CJYLjkLLsShQiW9BTN14AybKncQxDBVeQWGprFj09F9WFu8X3MqUKsPaRShM1uVpl85d9JNfG/MadBAZy/C66cZM2cBWqlDJDVrq0rjQIYlBVd0k3uUR5MXkaQ0pn631LF6WEu3nFD05M0aIVShcE6ZEU2EdYXWt9uy3ZsNLrq+qm7q8pAKnDyJw8/pNFAuLS8kqMwKAroYZIA7dmBdCxFMajQhBdoDONNLCuzTqGtGIIFPeuXWHxs0fbe72fLeQOIzjzu07FXkJq+8k0VRKMHlhhZjCB5P+fBR9UvfZumDSuWNnpgMm6gpQlQdi9UEbMgK9e/bGL8JOjRwx0hIY/dLoIYOGwIHQkJ78S+OLw1+0JyVA44hhI2hEivmXOiXdbARefflVlBgVHCdJ5BdZHZgTsygXQczQogrgg7Dv7ox0g5kUyKOcZ0ybgW8MI02bMm3ZkmWGwuQo6kZ47B+eQHgFzgURi3bNU/pvhhcRLmW0UJFzlLLUd6JetXJVLCy4rVi2AspAqFRyC8W+G7sIQ6AbLHoZUwY+Pv1xKBnRgBmaNGqCRW7etDmAtRJoZNFxlngXKUMueEpJO6WAI2QjFUawDxWAbgxifyqOTElPKvXq1BOfwBCy16heY+KbExE0JLcQWSjiLdAHQ+NigQBINmrQCAyfqfGMjdWrVkfKQs3KzywZgCRa4uqgUvQSf7n9y6QJk3ixccPG1Gmh3Uf0VHj5N14MDzMtowNPo2LPbVu3wdhIN16B3qbu+vKly41hhscSG+0C8FWWPgWgD05+WOSuXbrSwj7ro40foai1aOlhREQFY0cgVvA5ewo3pyirNPyFbQJuXLuB7bvN3/WbnomkqiNsk9v88B/iEePrDPAirjhaPRQUOyCIKU0c815xy4LRhw3FmVNnaMd8qBuZqe6ZeFLxVELzB63UYIG/zgmbCPVquCsAZLl7owqV0vNWvT7XIuIekCI9vLan1KOEXKABL6kt35r5lm6YAZM44y4U+uCMIVwoQ5F/YfAL+rf6MEqTYUBX1l2YnBxnzU5QFbprxy7bmSCkCNUa4REaPeOQGrEZ0Xa4pfJD+kii4XGtPrybffq3bd1WEuEpiWH4kAXQ27nSJ+wCq4/2cPXBAXbi67WfqY0LzdYSZyk1Fp6CyScetTMXIyGwn/tZuiFNtAAVylXAtFUsX5E+RoFkGyP/DCvFbPHEhBasOV9nBfEucJDY7QYFjIdDvacqPgXy4MmyRkSrYEY/V/rgBb33znt4+O+/+z42HUU65tUxseix9CglNDBMxet6rWn4HXygD3zoKRh+sgxGuzoWMBICxdx6R5QsDjukku7Wu3Pf5YsikMomPoZePZ3Xr13fp1cfXAs7HDpwKHRajP/76XNw/0FWITxnfEWxwtkb2H8gXNS9a/dADyPC3J2IeCpctMD/9KcPK67zFhsBP+oGKhS+zhhvKWJyjodrrFewdI9uPfC0+/ftr9miZeiQoW462DUH85d8suT+vfsNSMqTBXahpc+pE6ekD5KrOFPOnD7TL/br0w/VyqKDBusOzsia6pctm+LDHCPCANDnjdffYClldZ3/1GOXnXRNVfhxbGG4wFDJqpWrxKFdm3a0I4xqQpCJUNX4ceNpXLdmHWvHcsjtGAhFNd1j5jeyEQH540ePS5/DBw8bE2a+eK0yQOT5RM4G9Yb1G/KUHVauZ0AIxfz350PDalWqsV0KVO//IFsMWRomi84xDGs71Na+QxCXwGAULhNbY+ULQYhwWWyx87W/SPmc8R22V49e8BKrg91R1VCRPzVVHjrAEuwTZWZk08BRJJj5CVwpnpYvW37Prj1xuJM3SpFl5OcYGUlhkKWLl8IhqqM4qqYzy+oWg82+8Rn4X/nio7witWPM+4eQzfC+cJjVfpgV9qfs+/wQaMDn0jMsAoCb5D507+695kdFtpiobs/ZjpGChZARY4Z6LL95VUTfhv5HDx8VJbgiQmER8+FbUEACYlCM5sE2rtq+PfvUhJqP/LqI+kuuuyJDifPJcju+FawGOBiKD4eZf8Ek0lpytuS4QMbxrKjz9dmgNsjTziv2yRUUaj0opSkmiyWVe9MzbiqwsYEUfEITt3Cn+ReOOnLoiMwWXll++ce3FFIniKGBK/r27suiK26UTB9lEoIshry1YN4CNSdEYKf2dLWn2buhKAB0KTMCMXbcGD4Ysu6zdelDaYdcgW14lPXr1ker8AqYMFlUmZkhnlHKGLSw8ZHB2CE6SK2atbRrcnX4h7/ncCf2KSEd7DKqPFVFC9Wze0+lQxVnMA308LHDFUG32zkA9NCWBgADMvpkAHTQqY7TxgCWQJmNI28dhiGDhqQObVrBKMg/MkB+/R/9VdkmNUB+nU9jx/EA/RbTRFjgImOkqAUYQ+WDbUX2cVHgcEq8SqRp7uy58CGdUZv8+86cd/CU8PHoSf1ewFNepCdAfd578yinTJpinA1vE9vKZI3HIuN4g1Jj+NDhdOZdvsVXcEu0KXHkVIAE44ivZhw0p5F2Joj3JYng2949e4MJJhVRcqV0POgW4NEVnB/7DgPOLL35Qv6bKzgCFSigsjWgzazjgLJrl66gBGWQZbkXjzFG8HyfV+LsNQ3oFdaJmEbNYfkiRChXplyIkvyMVwOrGP590MB840TDQLSKEc2MC5rGT4ogEV2/IiU+68Jehm3UgH4DOnXohG8PD9MS5ztFkCrAQhw7cmzGtBnYjg7tOuA0spvAgschi5zPv2jvB52nGnqb72JnFRaZVsMX7mKRHYX7XYVI5ayTzxphKCMLS1o9UGS8CxDyGy69+iq9RFDo53F5oxRHyRleun6plEFpF0GefGRzBRHi8Ct1CQpR6f2myGf43iH7gjJVNFnEfkVdFzYoFi5yJyRa0SS/uVKxv7s72TXNdisClGK367ci8JtSyf140eTDp6SI3ZCVwE1WL4Ili4BqYBVH/8HYRYZMRsQjI5s6ddt0dDPygv6ACef32sXc69+8p5P3T0DcK5X6v+gyQt70KfTk7T8+BfKmQ8alhrxfyaPzvXoWbKtesETxP9pPGN2/aBfKRH7zZ17u83dg4lHGbZf7mezdF2TufjGjJV+/TlNYP2WTMmcaR/3Nyyz3epSRXH0/zHA33XKF+5ey3ylrua5dHgS/z8XKl2hkPL1/fNLph33P45UC08poGA4PuxjPBM3TMGlZzzncnlxnml54j84p5hlvpfPKeCWNzplXLCYZKGXcpgn8A2IWd/fP16bGUOqxI8dWf7B6/dr1K5evpLS+dvVaKh+s+ODc2XOxLz588PDG9RtPnzwdEadIs+Hppg83bdu6LZJ+6XDm1JkN6zYcP3o8zU5JL+/s3b131cpVEU7R62McGsFhzao1XrvjX0qQodHduo4iH2I7v3P7TnqKP/2pr1uzLl6JU7D8UsnzCK9rxZlsmk9ouuDunbvdwl/46cLENyfSsmPbDuPPEdp1u1G5UuXaz9S+cumKS0afrZu3Fi9WfPLEyed/PO/u2+WO3Pue3XsWe6zYtavXYgOODwwad9/XSBPqmLUH+h7Nt2rRKs1vNNqZTmHkiJEXz1/Mb1zIw+62rduWLlmahWYVWH3K7Tnbd+3YRSVnSw712GWwUtOnTme++/bsY3amtZtm48l7w/oNmzdtzmTdFlFCWyY4bco0I0ixNXCzyVsD+g0A/6uXr6bbh/Jlyz//3POMsH/vfngbBrA8cezE5o82lylVZsigIQZ/QOzyxcudO3auU7vOnl17Dh04BK/yFhVYnZKv1Hy6ZoN6Ddz7F0DzgAn0uXXjlqJqTrgxKEpPxwwvXLpwaerkqawObHxg3wEQhlCU1KEDZa2atVo0a+GddyNXEBz6zH5rNkNFhlh6J87TB77u4rrvq1q56nOdnkOOmOzRw0eBI4eOMF+AVStXptyMaTNgG78CbTu278inQebUiVOSiJ4nj5/kLdYdlu7Vo1cB9vUGDdq3bV+2dFkv+0eYJTL30hv90Ar+gWONAEOoyElGIjzfadOqDfyjuDEOkshTLzLHOVRcpQTkH14J7uKjFctXZLRSJUrxrRLFSzA4daBCuQp0HvbCMLlRxCAUxITIdIuerDjv2tKkURMDnvm1X44P/8Cx0icjv9qoXSQpMUc4AQwnTZi0fOnyxQsXA4sWLFowb8GSRUsWzl9YqUKlZk2awWaRxw5fgeesGbO8ZZn+/ob5YNAHql7/+Xr8gAkIQB9UCoqdr6Bqli1ZtnTxUkpgzttzoBK6N8404R/kC9W3YtkK+lPSGQ6nTn+sSfWq1V8Z/UrB7tnxFfgH+vzjf/5hqpL5pZCLuvcHg6+gz8zpMz3393KKGRReRKJEzNE/XjlUP2/ZtIWVnf/+/L/c+QuvRGYUwPgA8gXBla/4fQYoQPvf//Z32ul5++btG9duMMJff/krH4Lb+/XpZwYmwHK0a9OOdQEB+pv5CQ7UefFf//uvenXqoZ0KIF8yxvChwz3bQo/VqF6DEqhWpZrnxSCjfWS5QcCUXaQmdSoip4VBQEZlayOqg9FgIUZDD7CU8QmUDCVyxCssiuImd7FevNKyecvGDRubJd60cVPKRg0a0QICE8ZPUE/yCu9iYlgFntLHNHLIRWk+OfwJgxWAeZwCGmzsn8ei4lBi3Z7vhrgBVLp37Q7A58wxEipg7D69+mAg9FhSZcvURo0cBSebTqawoxywOD269ejapSvDOiZ1/+UrQ4cMxTbF4vri4IGDeUSfLp27APSM/vw77rVxEQH27GnKpCmdOnQCfxSR+PsvnamMfmk0S1wAL1FrYu6K3qZGxyNOdZqHmCpqwfOm9DJahDd1euOkw3RERvNUWhlMz2i8++ZM0+NOZVYzGv6zHgXS5GlFqDK9OHFW5OND4uPnCuZCmxsTwds0N1KzzndNb07j0hEnz1B64RhnxMype+yS3rd1EHMOIxExYqSRlRRZxHFMHFZDEsWFJsdJ84Hjdklczcuvfxhea2QmhN8eCTCRGhSnk9rKON1If3Ei0IhUkMj6di7Bh5GdZcXkc/mNbnGrKxCLDByFS+/ULLuYi5TRCqd31lIk88U8aWJS7Bnj59SkQDhCsdtyUeRzj+3Se3ypsMSP26RXpOMuZJw8+rlgoTRjMDIo0tg7jcH26f1i+0iTuHnhu3G4kF//R/LGCZczClUZv5XhgqbHOnRz+QL5sEGhr2LWKappzlJsXtIbyrFY6bWO9BcMHDYOKOO3ZUJLyKjBNqnHnl8RC9lU5FWDMZE4lYs5Bk0ixTS9hBhXQYPZMn6JJaVMmiAa1AvNH+myqWjET3Wl/BA3EdJX/FD6gx755Z94PU0Eigvmqo40PpP+cF8IUUhlXJNJM+HTq/EZGiD4JC3TVU4VrAOGh29YJr2/n/48UQyofgjkH+Gf9spCFrKQhSxkIQsZ8H9I0/qcCmVuZHN0cmVhbQplbmRvYmoKMzkgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggMTA2Ci9IZWlnaHQgMTA4Ci9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI1NgovTGVuZ3RoIDQxMTIKPj4Kc3RyZWFtCnja7Z2JUxR3Fsdra7e2VO77ZgAPRJHLC7yNhiAaFTyjUUJUUGIIxsR4xwPxPkDwQuU+h+GY4RwGRM3m79pP94NewmHhyq7MTFe96poZm6b7y3vv+33v935jY31jo25TsPra+vHWZmrTbSpmbjdbOixjrKOtQ7epWHtru27/tU3okDosUzQid7zpITlF031PN93s0XQi1tHT0dPR09HT0dPR09Gb6iOopqM33lpbWuWWTEaTNH/aKYX+auYWxXjBCZzPscvSZW7raDWa2lpaOzssHOXMLnMnV5BrOgN6UnfzAvR40dLcoiAw4m+YxfQfMzW3cBrgcBSswFAAtLSbezq7G+sauEinuVM5wTl8j+el9Oauuju7saGBN+PtnU2xt4ND79++HxocGugf4EPevrENDlht1p4+cDM2NvMJ+GPTVcvPcPTwE2lcACNPnZ2VnbAkfrwlxSrHuNi4xPhEOS5LXBofG7c0IWlNyur7d+4N9g/gjS1NRryOP4GxyegM6IEY92PttZ777VxQQJCXh1eAr7+/j9+E5u3p7e/rL0dO8/bw4kM/b99//O3vOUeO4XhKJjS1NdY3Oglr4HsACHQBfgEebh4b1m3I+vZwXu6JCe1E7omC/IK843nHc44fP5bLJ4C2JTVtXuTc0KCQipeve7t6uJqkU2dAj2xPyiIqgwOC1q5aQ/TBAn3dvRMaUOOlEC6x2aNmSJJeycPimAULccWbhUWdKinbrDbOcQb0wORUfgExGGWIrK6ogkPBczTn/sXUmxfRQpByMrRL0ls4Pxrfu3PzNvQh9O1gioV0hMMIFXIDzY3NiuN1WHjeIP9Anp1IxHO6LV3AMhl6msghs3Em0HEykQv4yctX8rZd5W7pqDsSeqJMSEqieDHF8Xr6Tp74wRAaPj9q3tPSJyLePuB7YELwEpUY+oTzL52/GBFm8PXyuXGtEDc2q7g5pFrmoWR9WXwDBPBAVAe+l7kjo7/XCj5IDk0tT5AkOyxIEVEjOCpwIVdcZs3ZvHGTra8f6EwqZcjvciT0AI2nxnPkSGrq6eo588uZyPCIsODQ0uLH0KXiXWrh8AH05NisCuOffzrlOtuFpFf84BGBzI+AnrCtg0UujyO1GA8u7tdQ15CyMgXBtnt7BtkPr8N5xCZDb7TrAhTZ0svd8/usbJywqb4RFibqpUZzMM6VJoBkP3m6yxcvE7O+7l5V5YpOG5/xJrxOU0OTEFD24e8gC6QOMk/4gh+3qH8djZ4cyfck7ghbjjjepo2bfDy9t36Z9rZ/sL3Z1NVmFvQU3pwEPblzityyx2XEO5Z7NAe/Nam9Bby3XaUM0GsZSYCOgZ7Wg5L4ffTgkY+Xj6+375PHZd3tFmlAidgDio7Jyzqpi7dv2x4eEgbbEq0S6biuyD9hdgB0PL1H3AHgoG0wIS7BzcVt7+69E8Zp26hWnsAuDgk1UFyc/+0chQl+e7volnCNw3dH8RkkLgKP315aUurp7hlpiCwqLBoPXWubYu0dZsldw1M36mnEJuywbvVaBN6mDV+gUjpU6eLw6InQxYsoQtetWUfMpm5OVWTtJOhhUpRJ+1QCE8crvHp99j9nwbbPnzwbltDTJO1meN4Ttn1w70F4aHhwYPDNGzc7JhInAl2LqVWCd3iQCS6wdEEQxCxksXfXHmo0Keu6p0mczGT0epFkatJLS00LDQ5NXpEszDghevidscWEqpHypFWFDsv69jACLzZmcXVFVYfanxEAHR49EKC4uH/3fvT86Dmz5pDx+tR+yITokfRMrUqkS8HFDcMOhCqFSUhgcP4PP0q6U9RdQ5NpmsTJTEZPSoxdGbsQKsuSluF4w+PTk0Qu7mdWCwfJe411Dfv37ENdU5fJ8hmgEc5OwrnA9fLFSzKeh5sHVQaBLCXVhOg1G9F/yn2KwAO9spJSmMJtjuul8xfJfnidaJjhtUgHQk+m9CVf8ZaARatAtWQ8Lw+vjes3Kt25Ee03IXqErdnSKVcgwClMNqxdj0pZv2bd28EhRAuq2KISsXQVpDozNhlliYTr22+lNro/ifOAAJ5WXVkd4BcA1f56+leelBOk3TQZa9TVD6/Mcrx4/qKHq7shNPzurTsSqp1qb1lbz+1RlzOE1oGOn5J60B7RE6KUVpK435uBN5k7MwP9A5csXgKM/X39Aqx5pC0wBj1LZxfuByaCA5gTtqgUsIJkhSwkcltU/LWmnywN49WYvaMnZQKO96r8VVREVEhQyPGc49T4PJo452ToNTUbiVwSIzjnHM3BaRdFx5QWP8bl+nutMnrR190rTZVutdWsDCFYumQxV0sadh25wpg4z6GDh3C8pIQkWWnlQ560QZ2amCzvYVzkadnTuNg4f1//g/sPABQZr+p1ZU1lNb5XW1XTUFvPi/qaOn4RtbPWV+E38iezX/S0Bi8oPX/6PHZRLHyRdzwPX+KfZF0DOiDbT5b3ECx46aULl1A4hjADJQapL8DX393FzcfT28/blxfwiOtsl/CQsD279pAQOkdGgEzqmridoichqU34HMk+guOhVYSItT4Vx8l8j0JDKTeajMR4xo6MoIAgdHKUIZIabV7k3IgwAwaJYOAJsFTN6Wnp4n5cWVbY7Rc9jXMJT0IPjZd1KEuoVmutSwdgslqDOlf+BDVVNRWvKtB7L54+f1b29OXz8pKHxZWvKig9eEvJ9n1WtrI4EhJW9rgMohGNbb++pzXlgOtk3klvT+9IQ+SYx9EwnAz/0UmACwr5Ag4OCYOT1qTQeNs/ePNq4XxDFKRc/uxFjzqFpSQEs8V+8x7PS1qDI6Ba4i47K1u7k6mgN/4+h5lIzYdctkOVLkofvtH49VfpPm6eyUnL5RMpYUyt9up7sp6Fn/zy8y/EbPT8aIhD+73aOMEH1g1H3+To7XUiZuTvgvZDtOzbvZfUF+gXUHT9hpRv0pFWcLZP9CRm62vrVy5fCWPuztytDMqqzvaxK61jdibCJuhAmbxF9f1+8bK/jx/Mm/Xt4QGrzdjYbBnZAcpp9ssaPCAVWWhwKFRb/rx8NHSa733snWgjQKLoIJGQwGAcL3NHhgwwa/0WTa7bI3o8Wm11bcrKFHdX93179omQ0Pa6jrmlKea90VoIx6t8XbkscanbHNe1q9Ygm3E8bTFd0LNfxcKdX7l8hboMmffi2Qt5Xg09TUtP5Z7H14CSE7Zu2QqVUzVTvpH9gI6jFDKj2zt26nsb12/0dPdMS00bGhziYbVhTnEe7fVHxZfAzsWR3zJoeu3KNYlWmWBBxkgP1q6ngMjnVFIk89flr6SKV6hQTU0yKiBDF8pK4ghFaupFGS1rMkobX8pkTVrj0mBVePU6XkfdhwqilJssQjvstjuqo/eJo8he7p5bUtN4WKBrUrVZF8UChe3IViBtKVbWHKW8oqoVtQN0FGiSLaWlYLPa+JzqjD8K6XRb+jZCmPMnG/ixa99Dhn13KItMDoCAOTTwBvSknc6/8qFSUlm6eCHJSgDktZR48laSmNa1e/niZcKS+PCQsKT4xLrqWkCTlvIYDuqY1n1t/3/0gAUtYQgNP/b90XNnzl6+cOl0wc8o2yuXfr96+cqNa4W3i27dLCyiOrh3++6Dew9KS0rBAQdrqGuQNVxxRWFP7bLbt20P8g+MCDPcv3OvR/VP+AiExzTh7R09fCxlRbKPpzcFFGpWhp1QtmJhwaFU9ODA68jwiEhDJPXIoYOHBDcty4EermhU9/5Ye625x3IJWK529tff8OR2dUsLJ1BTUIAMj744BHqIh/qausMHDxFoK5YuX560LGbBQl4QcVhiXMKi6BhM2T8Vn4gsDA4MjouNwwOlkSLQyaQB7gc1XDh3wc3FDZVCVfvn+3+JMOYEzpTazZHQk70A1p4+HqGxrgGDHThWva4E1YbaeriY1/Ji+dLllCRbvtpCJMICdTV1eJSsQkrSA1UqPj8fv/S0dC7Y1WaGvk3qhJ7CKWrfwJHQk2VW2QHKk0INHCELmYdXNqSY2njL65rK6pjoGGrhUz+dklYzuIlikTY7eK5KXkVoxy+Jr3xVIetBw/PhajNKelaOhN6H9nerYq+/14or2vr683/4kWy2aHFsVUUVcMmKtuxclnO+Tt8mSVIbqnfSveGmNplsl32geCCqY9XKFH9f/50ZmW/fvJW+8bBKMXcCcu7RHOGda79fhSn+p9M+Mx89bSuQDN1RNcC/VA211bXDaxyIalUhv7EN/q5O1GP79+yTYP8sX00wcyIXl5NJAAHwwL5vENXLkpbJMiVhC2VID0F6d8TsV5tT4RdiXGZHnRa9v2xjMbXVVtUgYzxc3U+fOj00OCQEIVQLfSSvSIZKUDWPH5UMWG3ieM6MHnRJ4lI65+oo46n8AtfZLuAjok5Zp1DdT8Z+vD29oyKiSh4WU1PIwI+S9D7H1wbOEPRkjkI2Q0EKcYuXUIzkHDkmxQVeJ+0+0Duw/wAS5fzZ8zarTdl80WSEf0XzODNrdKtShBgsf/bC081jftQ8KlZZgJPxDDC8cf2GIcyQuTOTEkO+PEQLdmdmDUJPtO77oXc7v97hNsc1ddOXeCN8StEhEcpplBWUHtqyzugbbnPiyJXVB3yv4uVryHRe5NxL5y/yoWwxk6VY6g5fb19qtzFrcJ/xi1JnTuQSevhYwY8/oYEXzo9GLYsClIjempbu5+2rhPPd+zp6Y5fDVIWM+61bvRbf27UzEy4Qr8Pyck/MjYiChS+cPS8Tp3rkjja8Dt+7XXTLEBruMmsOGli69ED64O59tDHKOXNHBnia1FFnHb0xLVOw2p2xC5SS4hOpxYyNzUBaXVFFORYeErZ21RpIBG3cMTIjpEfuaLUMX0AWoEcNi8sRuQRyyopkql3qjprKaq2NMB690T0o51TL586cBToARKJIhH6zd39wQBC+h/DrVgd7pKAbH7kyzOxU6EntoG2HlyFSSgnZwSFjQl4eXifzTsos7nRt6LZr9GSGSvsiAvkKkSelT1xmu8yNnFtaUvpu6N2tolt+Pn5Y6ubUP979IUNlsgY0XV/AZdezo82NzdpuF2uvFZRCgkK+2PAFKJU/Lw8PDQ8KCFqdslpaBNJV7unqmWn/icDn2nEgXWKJx5qqmgXzFgT4BeSfzAfJDes24HUJcQnFD4sFMU5uamjSRq2cGT1tWyh+JV9PceHcBZxtcczihrqGnKM5lGMgWXitEOj4xGa1SXOPo/QKnBk9bbxTkAQNQQ/3S4xPJGCDA4PBUFCSmJVIl0/A08kjVwCUfRPQa8WrCvhCXC4sJIzs9+cff47+rgzZTVBXU9eijuE5OXoahtqmqju37uzdvTc9Lb0gvwBUJR/K7gAhaJE3Il2cGb3JtjyPmVueadLOjtCzC+hm1PexaFvYdPSmBb2ZD+OMQm/Mtxbo6H3Kdz7o6P3XIaxtgtbR+6ib0dFzEtPR09HT0dPR09HT0dPR09HT0XN49PT/N/xT1qZ19D4FvfEf/hvZue9uCmVuZHN0cmVhbQplbmRvYmoKNDAgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggNzAKL0hlaWdodCA3MAovQml0c1BlckNvbXBvbmVudCA4Ci9JbWFnZU1hc2sgZmFsc2UKL0NvbG9yU3BhY2UvRGV2aWNlUkdCCi9GaWx0ZXIvRmxhdGVEZWNvZGUKL05hbWUvSmZJbWFnZTAyNTcKL0xlbmd0aCA1NDUzCj4+CnN0cmVhbQp42t2bibuW09fH06AyTyVTEsmUqVCmZMhMMhMhft4Mr5/r99JgSirNc3rNmTLPSZQ5mWVIQpFIklBI0tN5P/fzec46+9zn1B/wXtc+93U/+97DWnuv4bvW3mfOV3MGDRg0YtiI4UOHDxsyjJeRw0eOGjHKGl548j565OiB/QfykzY+x901rqxQlpVVZatW8lf2zFPPMNTggYOXL1ue1n/+2ed9b+pLFwZxNKbgSRkzagw1lP79+n8z5xt73Xn7nTR2oqGDh9KL9jbjJfr6TgPJ69O7z/zv5lMeGv/QWjXWotSsUbPWWrV48Rkv1FN4qVOrTu2ataNyy0ZbMjvln7//kZJjjjqGT7T59ptvs0/FSsodt92RDksDR/OnL3x9+MGHbb/pxptSs3bttW2whiJhQfZzzz5HefLxJ3mnOFHKC6VunbrpvBbn2nXnXaHZXXA7jjziSKfIKt2+IlNPPfFUSgaDMwItGbx+3fpR/8hDj7gOW2+5dY7flP7cz6jk5YXnX6A8+vCjEonAfPH5F599+tmH738445MZvHzy0SfTP5jO+0cffkThZeaMmWxrvbXrQdVOO+4kL6VtWlWG2ND34+kfH9busD1a7NFyr5at9m7Vet/WUsj48+bO4+sWm2/BjOvWX1dqTzvltLlfz6Xjkl+XuBTbb7c99RtvuPHCBQs/eO8D5qXXpx9/SoEkSrxTP+erOYi0JMnRE4894e5MeGZCUMjIhX8K8TOt5+nC7tx859iFXNlko00YM11SukyaOMkxmzZp6jbJUZfzu5RGLg61csXK7bbdjk8MEjNWO4uVjDn+/vHO8tLklyhw5E9kgzYVjCQSFbvgFBttsBHtmzdrnrLpi80ab904VUMpZyKbQbBf+QTjF190cY7UbbbahgYbrr9hbvzVrfB999znRHL02COPIc+Mj0LZzLXNLTJLylLYgAWnPXvEemqaUsNixxBLJmUKfmIJXVIIpgEDIiqhvNRgoxxw2222ZRHkiO63jr01VZZ4gWzpgQDFZuKEiRQYsc3TTz4dHAV59AoKswbFjV6n3jrU7LjDjs6oKYvpgkhUKV1DJlIA3CNopoSZom8sKXrHTyye3XETsd2xzixIxnKRHho44ysvvUJBGGQhk7rigJoyZ2QEFzNl2QbskTNiMPfcfc9DDzlUlQ8Lj76889Y7qDxuBRMxbeo0JRmOnFGL16hho/aHt2+xa4s3XnvDAelId2Tb6e65+x6HDXoU4wabNkgbMNSLk16kPP7o4/6EI9eQLnaHEYl3jxAbpIKy/rrrK3UVJrpI6umnnh4zSrBL1/mczgy7YvkK1bNJ4yZS6EJ1vbhrSfHLNR01pHvDzRpSQ6+777zbFQ7CFIPNNtmsWo5C6kp7VCjTB9mLQRBRatJNhCM+Ndu+WU5Pj2p/lCLk/oY4nXHaGakuazeUfBqcd+55OZvmHmnrKPffe39wFJJDDWJZLUdKXSrnyowdFXVHoEFYb7rststuLKA1WcdCGUP1ur7XgJsHbLDeBrTfvMHm/fr0u+G6GxBXR1bxd2i6g+qg1MlRut1YBrcga18oc48kJqUqWM5xhCHK6ZGrwb4E7JGFaIBlYIRddtqlkp0vt/w8IYn2WYNEnMIIa5yVTF4uOO+CcEY+EUsmZQtcgXvH3au0pIXuOUVLOVJCQvFTmJEacHbfSTEySt3qPIVSWlrDQoU7c81BC4qBggdHue7YOuozPSpqH9a7KuaRx9VJnQ30F4ww+8vZoAsK8EO8Afh5/933//z9T3dBSjJcl/h6Pl15xZWYdKzWm2+8Cd6mpCvvglO+nPUlEGvyC5Od96IuF7nLrg9P9gjy2AK7/PLzL2IwSRIIUQNhq7N1Mg5HjlkySlXwhgXKtQwVuK7864nHn6iy//bLb4E9KvaxnHF/Ll60WP+CHqV7zXsly5BKbKF6kqpypOKLUmBHNVdCeCIwPEV6LpocBQqi3hmx3i77gvkLAhE59d9//V3ipVDarK9nf62+s0d+Cr50wUhdqKcvQQlEOogdNR3hYfVHuAa0CQkXEelWnBEZ4ysrYJvwUMGRmktNBDhbbbEVP3ffbXdtl5ihBDkKma1jCo0/JOnxqXFJIRjT4SLzFLSEZbBGPdVahp+KaALLsIZgKo2VQjetQdol6YH7HvDT8889L0lyRFAgg9DMpEALd0F/BMCwMStsdyhRocQeKUCqGhxpwyNYszEEUNimvffcm4jmkIMPOfjAgw8/9HBeKAcdcBCV7dq246XtQW2p58lPCs3a7Nem01mdJDg2He/z9rS33337XYPQMO/KOX4K1WY6OIIAdkrJAS3j2vbaYy9QkO2JmPZvvb9zEV6Br6CHd56QxM8D2hzAEzL4yTv14CiQGMEUJVQsbNHqgpFSg8pRBj8h2E3XxQRehWaHokEu0qfgs5y0UiC2+jgoPqU2JxRQ2sJgagTSxulo0SxNKfCi4vPJKFi3mwb+7pHRRHi3ECF0dnUWNcz46oK1WN5qHSKR+NX/c3XvXr2v7XntTTfeBGihXH/t9cOHDncK9vGaHtdQQDg33nAjLa+75jrfaXZz35sREpf97DPPHjZk2OCBg9dbZz1oBhsz1MD+Azuc0CGMDy89u/dkkLFjxkoP43e7qhsDOi+FKJspiOKrJZhKJoXaPr375ByiDYizcnGNKxzhye233p5b/KohofqLnbGLTj8aaDnty8uvi3+tAHLFeC2N41K5raAzoZmnLj6L+Ap5ZimY1tSexICZFhSb6bDMF0VsEoYokkUUFkcZhiNdAPtigwhveZZyX+XSjqmUU82X7sPMSW53YhdixlzSQI7+WPqHeRWQCRjj+3nfSwNyvk/LfTCDenAdgewQx331xVdgDH8CFeZ/Nx/hASq4aDjHiDR5duzQES4YXxiTKmZYQgc3YhIYgxmCzlSDcK+zZs4CBZVQViHLnuEpMDVYWoqGImAG6wDxIYG+GNSHb5XsH77/wTYXXnBhzukTlqa5vsiNiEYqwbxCiaPIy8WMESyEsOVMR/zEfShCE56ZQOHr70t+X/LrEoCKDYhuwDkARaVRu6QuMAvTLVywkNVjwdE16i+/9HI7LvtjGWX5suXgVYwDEB3JYcFhma/sIJ8QiZxeADkYhEkZjfZMIXfGR8DUv/78i750jAVBE4HNks3PMaPGSKe5IOI4JaQUTRTKGAGCkSs3K5Q6QA6hHJO23KslLZmIp/XYOs34vLnzkA0ZFBVQzypR4JSvFWm0olmGU1ou/W0pqwqdyI86xV6zmDDL4pRSK8WlwEczFPUUFoE27m8aldP92aefTSWcjUiNG3zhVvQRrmE+Ki+UHX/s8UomfSvEo1CSikBQP/7wY05scvjcRETOUpleU1ZT35dms817gw+dbsigIdgHNAvF5wmz+7baF4wBIDlw/wPBpa+/+rozgkBa7d3qhONOeOvNtyjvvfMeBcVHX9g47AmikqozsxB6sLMuEdCLaIsuU1+fKmqiqNSYF95BqoGWIZuOzEg49vKUlx0QSAY2gzwpBwdCJw0+fP9Ditg7tDj8Tsl4Fio59DT6xjIEarUjlFcLOXw/64yzwgLkPFoaLAfqjmzepV0vrURGEjHZNyyPqSojvvRgwsEjd5QOFfiEJ+pgKiPomThhYrVIzL6ndDwlddNBecpR7Vo169SuVavmWnXxezUhpgaVLEXKS0Ag7IOjdb24a0WmYlVZZLc6n9MZxEIBXQCHRg4fmctmw3uPbj0AP0AUsMoVl18Rq2rAAsBLVSPNh/M86cSTNDXdr+6OhDsLeKZ/v/68YK9A4LBQv17dIiM11qlf75Yxo0FEzOuwmCb6UjAgMIWhc8eRc5pRP/vL2ZTIM0x5cUq4iTD+4aZh6tijj80dISkYSjukehaQQs10v/CzijeUxLlAzMWzKJY11q5TW6Y2b9hgVWFlajSOOeoY9zcz2qvKeDpgbLHxUUTl2Lo8tk+iDFOmKk5VEbUodWmaoiJCWVWGJbFZdjpZBdiUB/U16tVlrWogcg0227TYoiKPpyYGRz/9+FPMLnYyhg2pyzZ3VSknkEsgOC9iY0stG09TRpgXMAnbfVGXi4ggMHeLFy2GAADVHi32IJTDKFF51x13zZwxk/aM5h45LGgKDLPfPvtlvrV2LQpKBKFx2hIbzS7rR7Cl8ohZBl8Rabq2k1+YTEE4XfPIBeWWLphCteUoXfkUABg1MDIwj0pzIwHOJ02clC5XyCfYWwKKEpVpEPaBZ5aor2xhggC8cEqnaWS662EBQv7Ef9EAvCHk4IkTt2QQtAgJxJBsAZVsPUVA4shnnHYGUBNUgA81L8c6g6YwmzzD4+fiu0iZ4vrhgsbicPAAX5mI8W18fufzzcNjZiUMpMESEe+4JpgCCsTIMvSg6bgh4YoYQ3hmOitIAlpTbzOW4pL/usTlYu8YKgNF5WvLyjBpipRyZ4KBvRV7BqGlHpalg5jS4UWxPeO4xUQrgk8K5EGMm6LUxeyoSXoBIOfyqMF0SEbuKP/cTufmiMwluqvNY4Rgs0dOF4eAgIQ07kM20iyHKCh3UUEiEexMtv/fcYSOgM2Inrqc3wWj1PagtnG6ffCBB7fet7Wlxa4tEFfMGtpBPaaJxuA9TNlll1z2xedfiO4oxlwQRuF92tRpc7+eaxIVZOipH8/pH0wHwvG87X9vw0IyPoGAPLK2RJpMwbyM/+///rem1YiSwY847Ig9d98TaGdYxAoAPs23U1iiNH8YZwdZ/rAyqDv6yKNdijQEpjz4wINh0Fy0BfMX0IDQ2BpslPAyvW4R56psQS5KTZ0gBZMlhcTvWYPypv+s+NtBBH4hA+amDC4czZ9xghbyEw4ul6wwCRxY13iBT0RYyoMc6c508YhNHFhXnP5XXsDAFVJISzx4Rkk2a9Zi8c+LXMAzTz8zBZDE7L2u7wW4urbntT279wSw8RO4NXrkaEUdIel2VTdqirgro9lk19DBQx3E1AflvHPPGzxwcO9evY03ERIAG8NmWKJQ8ibmRoRPolycr7k14SI08H7DdTcIIHkSdjl+hxNP6Ne3T4/u3f78A+NcWPnPChpDbSZd5adyYRYgAI+shqqeobm3jL4ldDAFUVlStDiCqm3AtYZoApCTGhw8V3opKAQyTS7JuFmODEDWqa0L/n3pErcpl0HN7XUA0XDrijHoJc2Wh/zH3S1dJLMb1yvP6VFLDlGkURgv8CU7VS9TRaXwHl6MNZC3cqFPIpcquTvsFUaPuDKVYZotWriISsNM400sFTUEvDaQo5ILLgelWkhCS59YRWya9o1CDCtWER6I3gcNGIQxgQaDaCcCMSKKtoSd2CNkjiehMSa3Xdt22DpiWGPqqjFamsbMg+TKQZ9P9QiS4uaPZ+VpKFcpwi2UzvgiTad0oW7p1CGujp/e7suQavE0M40ZI88gEkaX3ReDKZ78BJD408O15cuWm8AnXqBeYOMtGoW/BJMKpYs9Xp+DO2k2lQQoshfYzF6ey5cOgssPBGnmXGFLU47MM/NUxSLAf/XlVylGfJFmN5clDZ7uxd0VI1AlP24MxrWfOJuODY19DCwauS86YuEjO6RCxRWRJo2b0LiUFihU6GmkRoOjNL3Me9yvC5VXnlPkk+b2Y3/9WTrCKyavPFvUSofnDSsE2k9z9fpf4rVYW9c5rh+YNWLdYvz0nhKzwwvjy1FINV9FQXHlEncDrkCR2+zXhsg9VBulpqCA/OQFNXRBaK8LiOtt+CxUG/XXgyOcaDeqjf0n9DNMEJxQiUMHyTBs82bNXbTg6LhjjgMFHXnEkcqAexTZISbK9qgI7HfcYUcobLZ9s9zdLdcc85ULyUNsDLRDVU0ae+AF5Whu7Lvlu2+/4xMRq6R2OqsTzfC/aUozjh5Mr6VCm4ug0VP9RUxhvBZuKNLC7pG3aJjIqDyFWFXPE60xpdm0SdP0cEF5llrP+pEuCcC3iutSwYaj1FQa3aSMxLweEVblKAp+Ic2cKHXpHUgQjlCEJziEF2r+c+V/4o6HYD7u10XIRlgBCgJQgWHoyxM5BMZ4AxahAhT1valvvz79RFk5B33qyaeKfJzUFwCSFz90shVSl/gXCBMOAe8pVW8MVr0JoKjQUhaMGUt3Top65ERmErzCAQGEopUEuFBWrUirhoHbqzVKcW/BbcrtUa7Esa8cMYUGXNOtEXPY2ESlLjjyWDM9vDAeabx149yt3Zww++JJundf45QqMJJcpEckVIYGRRgoENXGoo8KYXDkQZsbp81U+OWIBloGpE6SkAHgyhuvvaFRpWDKQCPZ1YIi2SgIjTGhWDaeWe4rCWkFuqma4AU+nv7xlBenUB8XXfSPcorVBbETr+WiY/mK+CiMpyN7pTNdn4AEJlLioDZNdlUKzwtl6Sle5C0zD5tcEVSP3B3bKFTAhnB/xh1pxsBtTQUgth469cWR440UpUvn6qWKhh5RGZghlzcoXYhKsNm4u8YF2Ibs+d/NTxObkW0LF4x2B2wLBC6zCrw1iEouwRhnE7mcasibt4hj6UKPFEtvOjGm6bI0lWGDRg0bOZeBv8aZGb32k97JjGxb7kjF9mZ9zWHmVDIiOOVKpBrWO24MKq5pQtv3sHVqMZYhQE6IR/oPKV4I1xjytRRTF0oXazNLWNRo/7kmwquU5uy/fooeVphkMirN/5uiiSA6/relIhYoroxBDYCHoMMDPp6o9muvvBZSl9o6t0CwHdfGvLsFCiKMGjViFKjmztvvRN+xGF5QZ6dmzZw145MZ+KAKh1gkgGbTpk7D2qQOiwYDbh4AxGIEY1LYwRxRM2LYCMYHw5iMwjJUgPk13zgq/+RJbiZ1hYrby3HzTXGNqwI8veWFaQprlp7BxRUppEUZiJPiuMyWRrV0JAilnqfdzzn7nNQoKXUVEVlhTf95EXrEsHFjMGaMa9Xh3OUoSyEmefjUmcYV7khTIMmomKYvd38v0hS6iaW/LdWI/evCf6XkhdSdefqZAAmAhxDIhE/VAizR4GR38pMLEjLiJy0kQcGQQUNAPqAgCDv5pJPll0GGDRnWo1sPWQ5QHXqKlAKT+vTuAzHdruqGWA7sPxB8xRMEBQEZci6UTsQoiByzXHbJZaIgMUOKnNMDr2qLBCC3eqIwvyliSUNCC7DNr3pYYoH0/8XoElIXPs7psn9Qqi7tjHmP/dUgY1so4+8fH34nd6mv2hJf/b8GRh47Zmx6TSuEbctGW6ahX/vD29v9mznfsMhEHLmVzI5xE7/2808/W9+xQ8dcCktskEZ8Fowh5f8Aa+D8bQplbmRzdHJlYW0KZW5kb2JqCjQxIDAgb2JqCjw8Ci9UeXBlL1hPYmplY3QKL1N1YnR5cGUvSW1hZ2UKL1dpZHRoIDE5NAovSGVpZ2h0IDQwCi9CaXRzUGVyQ29tcG9uZW50IDgKL0ltYWdlTWFzayBmYWxzZQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL0ZpbHRlci9GbGF0ZURlY29kZQovTmFtZS9KZkltYWdlMDI3MAovTGVuZ3RoIDEyNTEzCj4+CnN0cmVhbQp42sRaCXRcxZWVrKX3Rd2tblmSbeyAWZIDhBCDwWbLeGAIJAaSEAhnWDJ4PHAGAiRzBshkIAk7xscEDIFAsI3NEhyzeJNkW/tmSbZl7VJLtiVZUkutbvX+l6p6U1X//+6WbOZgx4JzSi3p/+pfr9677737Xn0CCICwD/6bEPbJBmYfCSBxQAmQZZABI/pBB5FAxiKKITpHBBCICEQGhEACNggh/IfeZRcR/yJhXxX5fXqZ/WC+HF+K/S3ygZgAqZuELkEUSdglgX09yifKyhfJrA0MymaZtHRBEgOZqoFQcdgWlAlYBEw1hGZXEjroCogo6pI0VcmKTqjVJMKGzE3GtffVn0zOkBqJgp6k5ZI65EtQ9SUAiYAwnUbBwMGGJH6HWjxBREQBpJhbxRiDURJF9CKWk//J6oNTz8fJXSBI1wO3XRJFRNWMyHQY/xogRDQDYWUtarQYAwwiVBQpJYDI/YzMriQEFCUk7Y7T9Uavy3yg00HFmUNR2uNIUjZVUMyiDBvsDg8Lksz+xvFxCIUhThS7E9XoCnxImjuwH/4EDTwch0QNadqTtanqM9StEY5MFUWK6yWY2ZRbs2871Y/o0iJhaElQeQh3eg1IPCoouJ9lMVJ2UdwNKQbijqYASAsAX4NaTooiAmSmG04LE9NgJmHMfFAcHy4rhYhMFSoj1fSYh6zU9/i+kjpP1wDh+JFYtkNKNsUK9pJuRjSocBQpD+FmQyy3sugozjqQ+LZ4fJV56k5w7CdzHQtUhF+ZVRQlffoEFBGeTJGmdkI0T/wmUJSutmQgIqoRMaRG0imEKESGd66+H/wRNClLoKKIokJKaZVdS2VwkgpEikZ4yFI1oNIyxc9llZKp8Y1REBa1JHabQoiaMgIoDFJEoVuzNogWhhXpZaJsJU1pHPkEn+BwswckTT1J9oHSBkkbX+YWsy5kKs/iNHGSdsfqNPYrGoWu5rcWLoAdpZQvIKzyGVFBkYIWxiCQkoDSc9mMLaUymLIumg5XbbKs0nKiJhccYVyXzDaKeNWAk07B0a5FbgwzPGyWbZQWAzX+OE3W9ED0DaBI5T+KrTkVYdZBqiwoxYnVuEqvTISgtmaXw955848gEIEYVrSrZCgVMNxPlaIsHULTUjyeQWUV/9eiE9ZW55aUtPJEApjtJKKlM5rIZHXLSMnPKLmvVJ2IZ1+YdLAqmUIJP5jMdLrpWePrw1IKRRxCCorUPJuWg5KiUitSOlRRc9BmqXI68XsbIJKgF7WAhNI3gpN1PZp2cWaC01CEk0yJaCianuukJKjJ14AixKNfugukgpT4dVLZaR6n0UWNYyeLX7XURd8EijRJNBTJHELUmiQJADpLECUmvCTL9D4tzVq7uq2Gttw5jUu+DwNHIUZvQ0IQQaHDACcQqmmhVssSjCMr/8RF5vWyxEseUcIJQWFEmoBq4lf+4bQSnb5H41PTjKIE1tOS0gsIoglzKhkNn2x8NdbBnUirarWGCE8BLBtInLoxkUQMWiYhiJzQKpgdLKEkmyWsSYhlTmJJqj0o87qMzhPiFEVsfjgBk1P1ORljFv1+mwU9/gSEw2JcAG5/tfUoaSmcV2SpPI5T7iMgdQkkKcpB9PucxiJW+LE2piDKYnLL8ThfPcEAToDMuvsLLG8xN0eyJEiqv7NNYTUUolTuPgW7nFYG5MWLEgORnIzpVIGSiqI4/ZQlmdqIcNVxx8MyVuYiTE4ekc5UOtZQBFosYlZNoojjWVDEj0SCTc3Ulux+IrLPbR806byZGU3z50NNLQiU9OIIYoyaoUjAaQWXynZUFPEMRSGksIuYhBBbLYETUwyl9EYCsSxJw5Eosq45vR9LqGFhBkWffUIrMj4fY/5BY7Cg9uexWrxpRcGp9hzw6XQdMe+NSEqgQVoLm9tJZBGJ8HZEjAhBzgdSLIIlCIRPgiI8aygiqUBEIxCWFV+j1ozCqG/D3fehtsMUQiCHjt7xs2aDfjg3u9VoOrJqFfgDEIkJ6c15OZWAtIqeJHM3tVGCA43NQzEIjkB4Ao4PQ0UV2rotvmlLYsMm8sk22FcB3gEIhiEQAjGhkiXxFBt9p5VEJImLGhyFQa/UeoCCGROVmSnNLhVF6LRaoKckDF9CcUY5eWIlaTSR/i3ILFNMjMCxfmg/DBOBdELLxJTx7LIjjfSmoUg5DdNSEiPbCYj6oaL26aJF7f/zvxCcADkMJaW7ihZ4bZZek7GsoBC2fMwCCGFxVWV6UrJyV1o9CCdDsahBVxYgFoDAGNTXdP/bPaXnLih1GqudlgabuVFvbDJa623uhrO/07TihxNr10HMj2MhFUjS6bLTr3hXKQtD8rHHntxdeF7nHasgGFcPgEBxfKRC6MyegJxUGK1ITLZgkuyAeyuBaAJKK0t/8KP9i5d8PO9C0tDK2JFyuCaT/683eOb7RbydToiUXp6zGzThBKgFxXVvbCo8Z9v5F0FFOYhhmAwff+zxcouxy5CzP9fQed31MB6i+QhJnH3itCIL1OILpyV0FJeJLIJEo5APtmz4cN6CCpfnUJ7tkH5Oqy6zU5/db9ANGMzdOZaD1oJdrvmd968G/yBLrBjPcLR/lEXjL7fdsL/58msP5+QfvfpmGJ8CkTUdEFGbV+oGz3DyOpkwyTyehgYF5ky7Qgwm/bDxg09sRd7cuVX6YryrUklyKtnGs46iaWfoPDKrKJI1KamtBT9EfMJvn6ktvqDa7Dl+2x3gm4CgBEfGKi/6dpvNeNxsrTE7pT+/T51Xae/IWGSYlJXqhvEqNaHzxdhhHINZAoJjUFb6vntuu2XuoGluvcFV5Z63d9HC2ksvrrv8uzvOPmur2/2Jp3hDwULfsy/SqMXRqGbbL0tYrNf11VH05ZAjlJIFgweuWd5sMvXdcD1M+ZM74u8nkBnvJ/yDVdhXxn9qdwLmuU2OQNgHG9/+dK5nwJxXYXCQ3eWpZCcRtcTFKoM7k3RoepTjdT1Jnj9K2psYKopwCCJ++OPaMnNxj8VTZXXDp5+zuyERrV27y2ahKOqyOHYsvQ7Gw7TqZxbAgkIglA8xVaKqi9K6B4Qpuv3Dd91RZc8f07n6Mx1Hl90EG7dCdy/0dUJPG3Qdhn1lifVv7r17FVTUUwJPHyIQLCFNMbz8YAxcoIRfYhRYUoZqbkijYhS3DLqIF4Airwcp0RIEWoKqnoPVgjp5DgjByQPLLm+2Grwrb4TQOJYEjRcpbzvMZICqMLQooE+mn1QSmcdgfEJHQD244MIk5UmITJgZZ0BAZp7jo2TXSIbYFETHITQMf3lte4GzR69rcObD7jIGnjjvvVE9E74Em68sJGplC041VGfmZT5Z4vOpbtle2NEE+bJTJ5k9he9Zrc4pisKYtyYoEqje5IRMooxRby3Z7j67w2BrNZvrr70SQlE2dXRyz4obm02WHqv9i+Ji2LOHlnIoFpVQgigcAtOSi0iQOsuQk9kch2Goc/d3Fh2ymL3ZxqHzLoXWfpiMQTwGYpwxxnAMomGIBCEU4gSSQUKgSZAdTNBABlG6RyRCLMxmTsUYMQtHIRwGQYQwszgiiBdZETqiiSBHQIIpJC5CNMbIXpQWBRJ7aSnKvEbgvyWlZUZdPRA+vOTydqez+0YeiyjkFL/Q8r6oQFnGKoqoPJEQf6afSU43Egmz5STe/lK8ktEGSWuoIoY0urU4K4HZLiIyqzp4t5O/HoMwjmO2SSImO1V0FcJLkngEIhRFEzBOUfSXPWb7iNVeaTRBaQm3O1Y5LY7IVBiZF78xkX1lygdihANJwSQ/4JYwxYggKFiVmdgRKo/IpQqwTaEEot5B8MniLeGMGgm8zUitxzMu3XIEopMwFYSpKVqRQSwIo+HyK25otTgG8+z7XFamH7r3cAK2l5XneXrNtr0mIzz7DIz4IBRhX6fAE5k7KD0fotWkDEUCz9ckBl1NZWcX99utHXOy8e13gW8KT4YoPw8iWVSckO6KN0LDkShrTlIbAW87JKKsLRAKQ3cnfLot/sprU8+8PPb8S8H1b8T/+i7s3AkHOsFHVcdOMQhdSAoyGu8bhpZGKCkRNn44vmat7/nfjb/4+8Drb8HfSuHwIEzQ0JSQhGjqBQNfsOeyK5tz54z983XQ54WhURiaYGMqAlNhJgBjAAI7WKQl5EQQGpuEzVv8a54ffuqJ4CuvhNe/iT/+COpqobeLgVaJXxQ5YoxVnX0DUFud+HTb+Dvvep99fvyF5+LrXiVvb4GaA+DzgUCUwx4W3bAoYxkpJ0ChOFu6v0f8Yuvka6+PPfeC/6UX4PXXYdV/tpgcg9n6arOFbV8UlSCDErQUohiYgrEJqGqMvvlueM2LEy/9MfTeO8zlRwMQpIIJ6stjEj/4pG54+BDs3I42fzCxZr3vmVcCz70w/Opa7+fbQErw1w5PkrWJrAVQkRuX5o1AAPzjUFcPf1j7wWVX9f99Mwh8ube27DM6jugsXQYzHOljUYLieSLg//HtbTrbgNXZv2Bx34qV8PJ6pqKJUQp4MTTBekG0DtVSjMq44rxz3ddRtfi8low53QZ96LZbYHycdfh4QIgAjil1rYC0CEb4O2+yHKexMQYt9d5V9zadd16DOa/N5j5gdlbqDLVWS41BV2m2Vni+VbHiFrGpReXAk9GBhx6pv/CimvkLa9zFZbq8KqOtrcBaZ5lT63BV5hdXeBYO3v4LqNoLU+MUrKzOpIj3h7xLrxxy5fa59MfOPb/1rPMPLr54/3eX/e2C70vvfwzxEIoHmbNMjMFr6xovuaTEXVidX1RttR9w5u832uuNtmqDqdzt3nvRJX1PPgXBBG+2ElJeWbN8eeuisxqceTU2S7XHVemwNjgszRZzU5alIa94//LltHiBMAtZ1DiSwDkNjaI0hlSW961cWTd/UZ01v95WUGf10NFoch3U2XtzzSPZugqjFUoqICRpVXAIxvth03stV/9TWV5RoyW/yWisyZ5TZTJXFRU304U++pCFwTg/xEqg0NbPypYsqS8uqtKba/TWSqOnzlLcbCjcYZ/3+U9vZ0lBkk6EkMi4Bv9kDxHYNJ8fSvf13P3LrZ4Fe3NcO/KLR9Y9C1NDLML4Qv3/srIpxzRstPU9/CBQhIQmmQwbPmyyeY7oTF0ZGd3O+WX2edvOOn/wN49DVytExjHdBYsGOHVkxlDE4+3YWNWlS3vyizuzc0uMRrRhA0sELBrTZCxHUVylkSrhRyzR06o2FA1s3vz+/IJ9Vl2H0UjjWJvO0mIwH3TmHTQb+nTZg7kGb47zC+s8YSeN7YhmTpgU6y68tN1g9uothzJy2i2eJpOtyTyn2ZLZbNY3ZGb1mW2tDuen8wuhbDdFEVZ0NT7Ze9nSYVtGR1ZGry6n3+I4bHbU5xdvcRTBOxtZkKfUrrOz5ec/363L7bXZmvWmOoO13uKoyjW3uwrb9KYRnf5odk6TydGx8k4I8vgQEcZeXV9ptftyc49lZLRlZFTrsmvzTC1OU1NO5nF93tEce11OTs+Dj8IIfT4L57xjL4FvKPL6mu1z3fsNpqE8d3umYb/eVmPIazC7qAdRptGXaxjOzK6zOmHHPpadBX48EPaH/vTSRpOl3uZu1jnaTK52i61Fl9NmMHeabfXZWTsK3GPr/sQPQzGEggNPP1VtNY9mZ/tyDX1ZhgMWT72psCXHXWItanngIRYGxZOgSD26ZhlYos4FoyPiA49Vmwrrs/P6aDlmcjbbrd333AKTA6ycjIqwfddOT2GfwbTb44a9pQxFNCx09lYtvuBonp2qxZuVdczmOpzjbHEtKj3nAnh7PcQGAfzAy6u4wE7A1EqNLhqJRp9ds9uUP2Z192eZKvMLye9+D72DDLEirfcSlJuJSFL64axpTGkDHR99tn3Bog673WvSNTusJQX5rbeu7HpwdfejD3t/eW/v0iXNZvugqXCPsQh2lHDWTVEU6112bVuOvsNk3T+3aOAnd/asuv/Yr1cPPXxvz203l3o8HUbzcYerVm/Y871LYGSMI1aCgL/t4kvGXZZWQ0aNw7LdZfso375h4byXz10MlfsY+fFPHPzhrTR6jFhdHVk5u93OsiuXdv7Hg+2P/LrjsUc6bv1xhyPvaLauXe/ovf42mExw4pWQ/7qh2pI3aDAdMhuOX7N84N5/7f7VA32Prvbed1fDBRdVGqxDLmeJzQ1vbQJ/UH3Ri7rqG38uKyhuM1i9Rmud2Vp+9rc67/nFwH895H1kddtPbmq/8PymnCxfrr7aYIGyfdR3EMVfLAHvbdqkM7W65zdaC3YULu647c7AE78deeRXbTfd9LnFcszm7DFZS+YtgI9paKUUKzD09JPNFtO4Qd9hNo1cfU3vvfcd+c1/Dz78UPO/rx7dTKMWPwU7AUUxmZ/SsxwRgt6OvVdd1Why+/SeiTm2QKZxMiOzIzNjb3Ee1O5huTUWpVjqWnV/vd5AIe29+WbGOSnHGxmrv+rqDosukJsxmpkxmpE5mWU5kmFqzbb/3WbvePIBGOuE8ITG5dUyLcI6kzIcH6tY9oNmq2fQnN+tt9SZnLUXXxl8+gVobWK8USF1hPFKtec/NtVwxbXVGdkD2YZel8N70wqoL2eEJxRgY2QY3nit2uHqy3ZUGTzw2RcM5JTJD472LV3ea7IeNJuHV9wAx0ZgcoqR0uAIDB6BfXs7zz2nIzdnyJFX4nCKn2xlO6X01Tfct+zq9szMyBWXQUUpVJbBgQYo3QEHG2FsiGIs9Mq68rwir841YHAdnLsA3n0LhgaY6WnpEZiAkaPHv3fhiMHQm20ZvfFnEEiw4BANh9av/792vjNKrvJI+/Z07r63c/eMZhRIQgF5ASNbCFZIBIEsBFgCG2S8fDbZYEuAxTFOuywsXrzWfqwNtoQksolCEkiaHDSjyTn15Jynp3MOt7trq+7tGcnnk/fP93fPmaMjnWndfu/71lv1PFVPVb3e0pulrDIZ4P1jMDsHXh8t3umA8Un49a/rFLJBnWUQ1+mcpXwIotVue9Wa6+xqS1+WtllrDD7zLHS201t78f9OwfwwvP3HZiM3LZU16Y1QWkrYOBaFianzGzZ26HJaOUvDVRvgTAmM4Yv7weOjjfrDwQ6NYUKKxqzv2L4dnDNINxZef6VazsxolLVmExW2HBhu8MNj4HeRTUaTF3RyF/0EM4qdMMyMt23b3sKax9SG2SzVAiP1MmgPTICVD2o1/h/9CAIeZF70yc7W+rXrxrMUlXpD/Pin6DNhfu78bdvaFIxfzoTljJthfFKFN0vrZLhJg7XMZpw98CwtA2FbnBdFsGJiinI7eMqd7XU7dhYb0NkaR5S6Pqmxk82uyVvhfvJxOFeB9x1jHB8V4F80Gfr48zKDecpo7TBkd96yDZyTEHbQpoUj4HbjycLRQxgcpzhLs9EGxz/HZRN48/j6N99klysw6IzvuBemfPTmvIAJkV8jDvz4/fMWbkCraMy29P3mVxAJUH7DN9vzj1u6lUbPrvthbg6cC4RRQ0I/SNgP0/PVW+9sUbDTxmVntcvg41PgdVEeFSk25e2jMDk4dv26cYYZYhj33fcRoiZG5g++e6TJlD3GGfPNeig8C64wuBJEjEXwvODsveXGIam88YrLYWYIIg68SsE3/1ytsY0qbe2mVf4nfgbTcxTZfXGCl5EIVRMOvVXBqqeVylpWDaUFEAtQmPjs8yrOOqrPKbVY4b/eoIsTSlJODxEXkiOHI7Bnb6/S1CNV1Vy+Gtrake0OvfYvTTZDn0ZRueoyqGuBKRfhZHypeCgWifHwtxmnpcwVRhrc/7Cr9WdP1moNTqV+Wq6clUp9UpmLYRJqZh5tSSKv1FmhKB8SQaL/0UDg179xaHRdKm3+bdtgfAT6Bouv+YchjdIvYRbQhGSMR8J4GamPkftlHG5IgVHH//UjsqJQJKOFS6UyMiGhtovX0P3yy2Vr1lVquSHOPKk29klUGJgKVl0++vzPYXaWLgJusi/a9NhTXWbLMIZU0zIoKIWoJ0E3XERcPJ3jsb+cM+vGOa5coYSvT+BqCe+5PPZNm4YMhk6WHdn+HVggxoR81E0wHujhHc0lK21DnKqB0/YdeJE2GeGUd8q+5eYubfbQjj3g9pLnjBDJDMcF111Re9KYN200t8uUE//nGaKEAWc8Fc1cVmQJ3rnhTd+YUDIjCpl71z0w5xAIWtDzzhEhbGWftHBQdAZcERBS8tE0kRvweIP7n51Qa6nM3d8BCR8+p+ree7pZ25DcUppzFdS1QiQaE4EIhutwguLd20eqDaY5LVvPaqA4H3xO3Iqhfc81ytkJtb5j/RoY6YN5B3FqJO9ogRi/Fmbg0LtdSqOTM5eotZEvToDPM33w92UqaT/H5eddBvWdyHOStLlJPPeo0ICThEulVdEjIHdorf/iirwelcotU0zKsqbkUrdC6mAYtAp0LF45Z9fn1Nx+Jyw4KDKiSU5NInQcUevO5GTDnw/BiYJKfY5DqUH35VZLZuTkxLxZcg+jCMg0MwzTxWpq79gO80h/opQHQ6p1MUhLCHktdOnjg7NvvHZu8/WleraPM03rc9rlmnJOX3nrVhgdhIAX5nzVW7b3aNBp6Co33gyz+MAALySG6IgTIQg64P23CljpgFZZZuASp09QAhDf0Rns2nxTp1bZwclG70QP5sL7kxK2JQJCNXOgp2ztlQMabStn7tv/SzRXitReR+/mTW1GS9eOXcg7komkKL9MpSJUO/7LsQrONqPjGjktvPMB5VWSwSTvE8rYQkLMMd+x+fpurcyulM/tulvImSDWi/qOHENchCf1pU0JRZ/T5UosljnwVntC0QM/x5XULr8MunvJ9Y32n914XZNG163L7tpxH8y7kN76FtMRCUQJwTAceqdKbZhXc7UaFkoKKW3ldNV/9350lQjMFq5bD0f+BMjuv/gcPnkfTnwIp/8KX3wA+54fVnBOlarOwAY+eA9XOP/qK60q9biKLcq7Emq7SOSecUBxsUx/6erJ/1rR/1rR/78VBQQr+stb+XrNtFaDpz8jZaalWQ4Z42SYYBbjYTA8sUMyQ01OHrzxX0KWmPLDTdbscU7fZDTMfvsm2P3D1izOK1X7GGYe0bU8a0EicTHSeUaCDwzKJKNa9cnsZVDXQESeF4ojQj0oFoqLpQGheiBoUQOzMD8E7x7q23JbeRY7qc8eM1pqbabG+75DmZyekXMbvjXMGdoVyvbdD5AcJc4TuArGhBbRGGVZ3/5TebZpVG+oNJhi+WdoFwiTh+ybttrVWjzT8Tu3gMshKD/SYiaPQv9Af+naNUNqroM1D+z7JbHycAzczv6bvt1s0A3fvwd8/qUKdTKBodmZfvm1emP2iFpxjlNBeRl4PdRWAGFBJyZkuBZ8LZtu6uJ0HWoEY7soMymkqQNH3qthrUNawymLGgo/JwYhppF5waZdkcQLvxjQcDVoRV2DxMGb6gs2rEUMXK/RTz69D1w+vBoRcccENSN4/XD4gxrONssaz6m0UJiPnB3jV9099zaqNAjvu9WyJp32nN5cZlt2ysqeyNF+kaMpshkGbSvGlXqnRlnNqWb+738iyF94+VVc7ahMW5y7GmoWrSgtJhOTf1ccSBKaMP+r3zbqdIjMPVKJV6qYE3C1MysrSNgmK8CwDpmhJUtO+tipaUL4ofjg1luQqA4gzNDqh9XWUanOK1UFGYnweaWLkTsY2YJEviCRTjNMv0FDVlRcgigFbSeeion5YV4sCS3qq1NxAdskA0Si51xw8M8FGn2nSj1i0J1kVfzJ42DvP712w7Ces+s0fY/8EJxOCEQykiYRjqAPOfJ+gSl3gNEjR+MLS8n1xZPI9Ac23oHErU+lHL9zKwkJUjEhySEUK0M89A5WrFk3otJ2ao0D+35Bz0Hw4Hbbb7yhlVMP7dwJ7kA6gMRHqIygtXhmgy++VK41DOnVpRYtNNcJLS+UKwWhkEuiT3ey/Ya7+tQr7aqcybvQ5kNCDYIPHfmoSZU7qbTlG3SQf4JqYVRmFLJhaBwLIdj/Eq6kPm8ldPcTkmlowt0b0ZvrFZqZ51+k/ccfseszHqO/IG7/y3vnOMR1hnKTCcrL6bbOzpzZdkuTjp2QyQYk6JyN7WxevW75OZ0BuWGjxVKn1jVJdP1K8wSnrbIafIcOoy+aevlfEY4OqXXF6ItqOvCF+AwtE7vrk5dUwpCOGm37vQ8qjUaEwR4JguosH6NwMFkuomkyHyP1M5qgwjgpV+C3T/zLb2nN3jD8x+/qdMoxlWJBphpnFC65ziNB+2GCjCxEViRzSpVoSHOMdCYrq1mlPH3NNdDSiNyBTyOHSUfTqYjYOs0L/Yk8HQL+OxgXerqTIar4OHzw2u+bDaYZTt9mtdQ/8Rj0D5755g12raqbU7ft3kV0NRJf4p4h9AShNHz0ZYF5xZTc2qjJ4QuKSAMcQxYW7P3WHQNyc69aPXLXNgKflGUTCjJJKsihFSG2H1ErMfgO7dtH74i+yOmyf3tjh1ozsXMXOAOZKQPkPGPITGP//G8lrGnYxJUYNFCB5DoaD7t5PrTULEoO8No7B+XLO5S2ibu/B+4gWVGEDx5FK1o2rbAU6jnIP05WJDa4UKDn0djS+18aVyob8vLAbidjbunIv+Iqu1zVbTBMPPc8ON1EA3lR4SyI59BfHf2wypiNXrpMb4CKCuKqHmfxzrtaDDr0ReNGC791+/TWe8d27h3+7oN9u747cff9c/d8f/I7eybv2TNw27aW3d+F2mb0RaOvvlqr04/oTcXLV0JNMwTTfKbNnBfKbZe2IiH1F4bujpPr1vWrTSEJ62ZkXuRWErmbkXjIiuR+4U+3UtWhUZ1angfNLRTXCk+UGlXTnHqOQp5GzAxQ+GOyvIzCzcg9WUo0oVlGGlBamtTmovvuI7IfoXvHJ1Px9GI3B/IdPJTFpvgwtVEn43ijkbwjrW61V6xc0yXVNWtNTfc/AONj1Tt3tms0XUplzT9uhvlppBWikI4gHu4t7uexo1/pdU69BYFE9MsviJXj67t9bTfd2q7VtXPKwR3bEIMJQk5hh5Ip4mgDfSXrrxzSMnZOMrHvUfDMUZ523jN685Y+td6zey+lmBaz73H8lS8IfzpWalo+ouPOazWpo+8J6d8Y1WXRP0TClBJxTA9/c/OgjGtSa4d23yfUc8NIGD3H3qvhDGNaVYFRBmc/oyhMImXq3ktQTA+ED7w0qVQ05WVDbyelfUamCm+40a5jO3Sqmt33kIX4whDL6A+CeKx4fw4fKdHoFnTmaiVLdbSQD29K2+M/atdop5WqkbVXQ0cbzDjBEwa/8LPgB0+Aqg8BB1UY3U6hYTQ+dvAP503IvqUlK6xQdw7C4bSoxBO73flLS0oIFeAhBNxTv3utyrBsSkg2IsdHnu6goCbzy5QhRobm4ZPLx5WKRgM3/PAPwRuEglOFBsUMp8RfeSXKeYYJyyUIxZHpuyUKvwTdEVJ+5TiTNSg3nbWsgKpKCLqFASRC8kdEoHjf42FKbsTCaUKnohAmSXEh7qdt7+ypvGzdoNbWoNC1PvAALDjtz/zsvFI9ajTmW4xw5hQEfcloKJmOxxIRQuz+IHz8YSGnnFTK6jRCEEwI1W1voPXmLa2ctp2TD+64DS0kdaGBTrSi/qL1a/rZrE6ddHT/45TNQ1NxePo33zKgMMzfsQsWPOkg1deSooTVF4Himq9sqxDAdGu0Mz9+Gj8MoVAoEqAEDppuHIPy0OS3voWxqZnVDOzeSQ4wHCB0/R5aETvKqvJNCjh7nHg6L0wggSiF51AAYyWuvznPSlaEvMMdrrrn/jadys5KP1uZC22tdPFjvDjngeoO4SB89EGpSuNhjQ0qHZRVQCQEHofzjwcbWf2kQl3GquDwm5R58/kTQl1bELDh2wdTcbfYe0r9ON7wwCuv1JrJwRavNEOdEBmTyb9pqrwULvJGYkLfWRymp/sf+mGzOWdcIkds48iSTEkYhxIDExOWSvwME8iSOaSyeaP+hFaV/iofPvukxqCdkGV5BbNZYCRhOePPYtB40IkFJFK0KAxwM2q2yJbr+N2/0wbi5sZD6ZSgixBmkZARY+ifnKD7GAsSgImgM4qSljLmhIVR+M2vWwxWl8HapjMNPbcf/HzgvS/KDOYJg56y0OiH3Q7yb7QPgtgDAcMbb3RYTDNKKRo8lJQI7QAINsL2G7dgOOtVy8e33wGeaDItKqkEVBbkoW+saO11PSzXpNf3PfcCWWOCVGq9t98xIOPsV2+AXjuQtiQqBMEk2djE3Plbt/cotVNydb11OXxynPac4A0RJ4h6YHasb/01gyq2U6cbu/deKnCHkUVGI0feb9AYx9SGMwYTnC2inEymc4+nRokg+aIphaIlNxu67VTcdyUjbx2rkDNOi6JGp3H95GnwLFAeDN0Ucl40p9l5eONgq8kwq9bUavWQX054APe3s70yO6+XUfRbTdVrLofGWnAv0LUVK/h4hfEJpKtxw+gwpX99Qferr7cZbb0qbf6qHKg/T6gskdEL/Q89gKJ/Is0YPmRuun/vgzVmS48GMTM3qlDNKZSzCHUkTJiYOxEuNC17jq301rvgd6+1sJpZFQYvCVqRN0swG+R0UqJpLrliTq4aVrAlnCH4H6+TV0nGEQvxixNFMhovR/DTbbvO3Hx774EX+E8+hIoqxADQ0wMtdXDmk4Gn/qnMaOxWGwbUuiKjCcqKaUunXdWbt9SzOuRuVRqu458ehtZ6mB6hcsbEeOrYu90bN7VKFQ6FulqtBeRoEaGSPufp33TjgErZq1aO37ED3NFUSrS8NPmiYBx6JkrW3NCrtjZztt7nXhTK3BG0oplnnp0y59Sp2cFHHoSWShjtQf+wUFwMY+PoW+b+8/XzJtska+2Uc01XfyN07ChMT8CCmzjI+YqxZ59qt+b2MNpu1ja68z5wzIlSqNCbR5vU1jGV5bTBRpW+EPFL4TiS6WQE/O7ogRen5Nq2nOXQZSfshpC7o7t+7fI+lunVas+ZbYPP/ZRqMbOTlHtp74RDb3ddf12rUo5Aus5ohsJzuFHRSBDNI/Tii5WcvsNoaDAbK9ZdAwf/ANWV0N8Hk1PQOwBl58JvHy3e+/BXTz9BEcETcP7qVYQfI3pr/qpcqK+BAI37EfON/9NkJFI88RSOEdDGfOCa5Y8cPr3+G+WGXLvSOssY/QwXZJR+iXQuixmTMBMy+aBGT/KDu3fgvR7LYpDULxColkQE50NOTKEYVinQaTfcfheg1/L7CA/EE6JoD7GInzpeknRMLV0nbFc1ccsbWFONWlur5ZpysuuW28qsbJlO0chph9XmPqWtXJc7/uRPkVjFo36y9lOnP7StaNHqR5Rcm4qtMxp7rr9mYMumqqsvLzIb8DnTxjxXlq1OmU25a95D6gjP7OBNN/SpZR0c13/nTtLC8RBKpeLirK+AF/onSq/aOKZa2aHOHn1hP6WD0JBCEcg/26XlxtXKRp201sb2Xb2mLPeyd/KugK9PQXwOFgbrdu2pYpePa3P65JpKq6X8spWDN2wc+ubGQpv1nN44qsqeli/rVq8c2fUQSWUibnSY0bffr1EZJvSWM7YcfD4E/GleaOWma+8G3zR/4Pk55bL23PXQ0wd8hOC3fwH+eLDIbO5UG8b0tvNyRUte7uDG67uu+0bT6ivLdboeg2Gc004pZOUsB0UVVMfmEcw7YW604PatJZZstOQ+maFDxtabTA1XrKpdc2X58mVVBlOV3nLatKzvqWfIkboCjt+83m66vFtpLF6ZBy314EXiQSZEyCfBi9OoLpV1pNgq8G4+jnEEvxqDi71n9rlftG+8tVJpa5cZh7SWfoWmR6UYNxqGVJopo7lHpRrPMXXJJbNm44RGvcAaRhjpkEQ1xBlrNWwRx47cthXQBaHBI+SIheMIe0RLFojpQoqGNaBrTZ0tOJm3poHN69bberXcsIbtUcg7NIoeM9dj1DVr2Dq1pdh2xfxzvyK9SjxIUSgaRGwZOvzuybwVDUZLj9rYI2eRvNSbdaVmru7qVfDyP5+zrmyUrfxKd1Ws8CzwrnQUCcvM+ZuvLdWrTlvN1ffdT9gymek2TaVCFKq6+z+64roG/eozquzWn/+UZKiRGLk+p6NwmbVRq+iyahBTdSrZJv2y4zlXQGcHpByQdkHfUOuO71ew1hYV12Q0NJlNPRZbhUxRkmOBJ58IbdtZrV5Roltdu+NBquiFEcTGJ946WpC7Em3snWU2KDxDDoqPC7gc/aMLAjMzL+6rVuedsK6Fzm5IRshBIaR0OuO/P1iQu6pczg5acpvkijqttnlZTole17luDbzyr8UaVZPVfHLFCr64gpgdqd2D4J+H+YmuvT8otq7oMuQOaMydGrZZq27QaZr0XAerr9OZv85eHvvjm+BzY7Ttf/n1T9mc8zmrPkQA1lSL4RJDuD8qNt4m/+7An9QiwxE/RtJiwfjxlUeH4LNPux99rOgfvpm/bEWFaVktZ2pQKVrVWa06eZNOXa9VNeu5BtZYzZlLuOyzuVdWbblj/Je/haIimJmkh/DhjHJfxKQpAUKKTcHUaRsCl4P/+NPeJ548fePGr9ZdfWb5yq/NOV+brKdtObgbhTd+e/gXB9IFZ8AxKzSjCeJhxE6k4QxCXZX9xRcKr99cfNmG/MvXf7nmmq6nH4fGKhjuPvvYj1v2/qT4wadcLW1psZ0gGGh76YX6Rx4o/fEPmn7/OpXXBdpOemRC2WGkYMU/+XnjQ4+VPLC384NjJOpDEuSlynjw3Terd+/4ZM2q41ddfmL1+lMbt9Q8uR9Gxmn6TdxLnnbelfzTnxt27jqx/poTq9fiT9mdtzsP/wEWhgOH36x86JGaPY+O/NubgsaYsqMzpZWnv/f96r3fK33ix9BcD7FIemnKE5K1kGfw3UONDz92/on9MDaJr0zq7Kigl/Y4oaK0/Zlnv9hw7en1136+dsNfr72+fd8+sHdAd9u5px5v/NEjX37/IVdTu5DATJBkGpEPugWvAwpOtz39WPltt361Zm3BVVefXb32q9Vrym+6ueXhH3iOHYL5SRIPxOJDn3x+9sGHqh564Nyzj0J3M+lqlrqBKCETvzTTT140PCG1NMgkmSas6yfgisxiYhzO18Hhd2MHful77NGxe+4a+M5tPTu299+7a2DPHtfTP02+/O/w4XFo7IKJeZoiQpq3dDSV8MYDkXRMVI+TeH6xJZOP8xnVY8xPnNTrBOcU9HRAVTWcLYaTZ6CwFFpbqM4bdEEiQNw66CflrIim8PnIZtBE8f8OT1GivqEbBsdgfhbCLgpheHMxZi3QDD2yYLSHSJJSlMjfQy4y71hGaC2YNJ9MCGUdfwxcfkGIJeSgwqKkn4cIMus5GO6Hllaob4WRWcr2h3mKyClBq49B1uuiov/ACDQ0Q3ePgPkRS89CxENKAGcwkwyPCtL/sKD1xf/inCfxQDwaT4sTMheHYeLm+3yULRda2vH0ECxTyMOrh6Da76HCblMHtNphbIZSW0E/1WuQqSFhR/pGJdrF3mReyAniOcYFhfb8FHR2QV0z/bTbYXSS8gYhyrpH8ck0ICpEIg2fg145TKUBcd5mpjchdel80dIQlVgi01mdii/mgdHCotHMLgV8ggab2tBg3k1/egRJtk/Io7q9lMHAEBpJLrX9ijMYKR+VFGdcJP9mWlEyxQszAegKYEBBc8L9DAoKfPwzFKR/kiWHESam4ukLIknBm6EdJnFVcVGHHxekL1FS2aHlpyP0Dm58YDKRohQy2V6MVCX0knyE+uAW54+kEomEoFzPMFmvn5T/Yoe5UJKg7DoIe4tfhOw+lCQTivCLWyTIUkXAEI3RMvBjUaFjgg8JXfVxQfOfTIXjmSYOscxBjQkhOnpiqrzYC5BIL/5WVNSneD4WW5rVkBJz/fEIRUCvmzAb2laIh6BAbHlRC0orTicuTMsKhUj0HhUbfdHBoksPh+nbkXwhcqa7kIDUomY6LXgbNCe8aEEvmSUvJEKXnEw8cUl0zQv64jh/kTsSNZCZLms6L+ofEfdUbKWJL74zGWeaTjMzxjOVafIRlhMTRhDwGaE1Sabx9TK9K0LVQ+ykCFGtQOAn1IZCXpDUqsnExRMlLyQrhKEm/NLAJeGbcHnik0VjxSUnEmEx/CXE0THiVY9mWsmE9gFxcgt9n2BFaWT+0Rifvngk0eLsr2h6cRyHoNwVBywEhOZN/HUsIg5LRb6QFlcVjiUyvRrRuPiEuKA/WVJsXpQD59PJGPU3LDV9JDMjL9GDR+ilMjMt+aVWi5QIcakYQTu2uDOxUHJpUm9qcUJmLJb5vaCpidEDeCELIY6vi2U+zQsOgzJ4fEq434uT9JLi0Nc4n7io9ePSHC15YWRBIhWPxJKx1P/bsJbgk3G6/6mLoiSkY/ySoj5FpTGxpzeZ5GMXwHxKODIKr7w4hBBPPBmJLs1NCifozTKRbrGL529mPSUz/ZWiYQvbkowInUpxnhRUvDADQehhT/CCJyUrAlpSPCWEwMUs9eJQtnRGV4DHx4cSabFx68LYu2RInOYltFEv1viAz9h1KpW5SdF0KpUZ9oIuISk6vMxOi1OeFt1ykEImZCBFjDxhOpQUu4bpniUjFwaRiG4kkBSrKLiAMB/JbCUvvCU6IorQfDQVoxZwYVTLUkMcXkx+cSpCJBrL+IFoxgAyLj3T+5mZChUTvzEq1jHTS3qhdJQueSKZuDBjIfl3xyP8N8E4D6UKZW5kc3RyZWFtCmVuZG9iago0MiAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0ltYWdlCi9XaWR0aCAxNjUKL0hlaWdodCA1MAovQml0c1BlckNvbXBvbmVudCA4Ci9JbWFnZU1hc2sgZmFsc2UKL0NvbG9yU3BhY2UvRGV2aWNlUkdCCi9GaWx0ZXIvRmxhdGVEZWNvZGUKL05hbWUvSmZJbWFnZTAyNzEKL0xlbmd0aCAxMDQ2MAo+PgpzdHJlYW0KeNrsWnl0HMWZD/d9hOU+bElzz/T0THfPIVnGYCDJbt5u2N3schuMzfE4zDME4rAhbAi7ednNH/teHksILwGzyJewLcmyZBuMMRhsc8SXbOuw5VPomvue6av2V1Wj8ViWsMnuf/Dep3qt6uqqnvp9x+/7qolGCEQnxMSfZhBNIyY6TBN/VEz6r14iRomNIgbEJFqemEVcqoTkNQOPFEneJCV6S9VMQ8U8OlF1TGjSPp09azCpmphdGdU3ShCDvwDhPWwYf14rr25qmmbSMZpRxOJ8CaOEP02njxsm/0UGm0nX0K8RTSX6sUW/saKNIWFiN8pwG2QMCLbpBlUFQ2c401G6SrfR1At6GQHd1EulNNUBVaWCAWrRLOTQ0m0G8tXCx2gldkslJZ0AKdWk2qHmiJajyoUZdJ22dBhEM3MFoplscInfUotZYhbYEkQv0lc1VKBf1E3V5L+IKwpVBQ68OaZC32CpwpqbQNm0DXLMJvG/MXYNwNQ8KRUJwxpCLRxI4Tngki2QXJEUcJEnBY1elHJlKeZIoUrUDNEytOX9xcKxkRC1QEHXClQBShiTpCMLeZLLk6JGchiQJnqSFCNETdIZqArBq4x5AepvNGbYDGLjG49yRbBFY26cGRsz7QrWZTGoY2RwlzQ4bY0w50k9a4lZHMCNxfra2gba27PvrUu1tuTaWoptq7IrVuZbm/Oty1jbXGhpLq2kgotMW3NyVXN61bJsG+4uy7bSnmzr8mzrykzb8nTb8kT7SgjtxICOpbmO5mJnS7plRXZVe251e3FtS2Tl/yQ7mpPvt+9ZsUjr76E6U6IeAzYOuE2GtVYJQN8CXRZtLGRXuXG9yslTR8jEYH6R3dF4DDRUUsyQdILs6219+unhP/zhjen1S4Li+huljQ3eTUFxa8j/qSJ8qni2BITNVETIFkXcLHtx8UlQ3BQSuGwOsjGKDNkU9OPZTwL+LQoeF9H/UdC5QbF9XC++73N/IktbA9ImvwP/rp/R8F9Wy6c/X7D5P/993ztLSTpJCioPMGVdNsczhm+6UOjKfu84rLUK1tRKDIYw3zx4bnoHRgSs83Gyb/d7j8z53fR6sncneftPbdOVz6cJh6YLhyXLoM8S8dtjPvuoZB/1O7mMSBD3qN+Ndkh2DioQOxuGu8KIXxiSccsZF51JEa074ncOyfaRkGvIb40pnqTsGfU5ogHPgXppjV/snz+f9PUC8V8HfGRdJ8nkSE4be3nCtXQsjpvfwm2WTZdMgDW1ZQBNYzMQ53CbZYYMipUm+RQ50PPFXX/fKtpa/2Y62f0pSYxkVixpqxe6wo6RBmdMscQUW0x2QOKKMyW7krIrGnSNBj2QuEJlNIge3KISk51RBa0jKdnyIgQXzqjsjihCRHIlxLpi0Bn13BALub5slDu89q0/e4Yc7ifRkV2/eH6xaG+dHjBXrSCpFAFfA7UAgUREZy9fdkzfwj2W7pStoBKvy5pA7Zptl3ZsdFGnJCobJYf6Ns++91Ofc+80edWtIdK3jaTiJJtRmxa2KZ7uetdQ0DoqWWJ+KnHJmvJbUz57RLYPKw5I3O9K+B1RyQ6ht/zWuFQXlevQpvx1ObEmJ9axAa6IRC06K1nj7uuSgbqB6Z4O19RdzzxO4iOkkAbce/71+Q9kx54Z8qoZIbJqJUmnQN4Qa8AUdZrcqZUf9a0cB7RRRlVFPgstMHQDpNdgiRK7S82GuvE06e3aPuuOz3zuIUXsD8stMxvQQ/IFUjBJsqSuXLW6UdkVdMXqRZht1FsLg437LLSV4JNtFGKfg4k94edw1yXl2qh/Skypjcs1cf9U9OAWvPeIzxELuGK+GmjCaNi90Vu3a8ETJHKUcrN8iWQSXb/62SZx6nCDp1vxrKn3l9reIbkE6D2jbZS5kdKxX3dKG/LVe3XSYV938P+FYBjHXZu6eapY69yBE07OCqVCGXvm241COWbTzGhf16ZZd260T43IYkry9gel1lumkX17aJaEFDhPSLpUXPzWmka5S3FHQmI25I0LFOuUYo35axPUfqmlA+40bYG4FZL01WYVS9RXQ208YE3ItqRoi3qtUcmRqBeG/Jaj08T3PZaepx4lI4dIPk1fjOZlie0vP7fJe0My5Bz12YB4S6NidraSbJrkMkTP0XfWvg7cf6kwE/lLYTVOuDvh4OphxvFSNeCUQGcOnKVjZepNzVlH8jVWcSmppFAgRw9um33XVlCssBeeNiYJXZJn9S0NZM92mg1pOikWCVQlPZprXri63tdTL41KYlKgrhsIAu64vzbjqyvbdRXcWZi8aEl667JBD8gbsIM+FILeqM86KNlGbgp3CvYtP3mSRAdpDq6zok0Jria57eUFHwoUbkT/YcXTL/veCwfImtUkj+w+ixEnKbBMAgE2rSLj+sc/UrXhuKtzOls92Pj/c8WTadopLKFT8m2MmTaScGBNi58s0TZp+Yqm2fDtBq2iFHPk4MH199690WsdCnlgdGBfYNSUJMO69+4gvJIGXgfTK6RIJkqWv9UeFnsDckyWYz531GtJyBY47bS/hkFsh3Wnx+DO+B1pry3ndyYFW1R0pAPwCfYI3ELQPdDoa3fXdi+YT0YGWJ1trCCgFmDm215+foMwJR50MJrnLChCn9+9vCGYa19J446ao7pxojmculs2J3rKHO9Fq62b/8vlmJutMr1qXTpOf05cwqh6/IR1aRVZN6v/hbJNpmOsxMmqKLTSaPAqJ+VmqsZNm2GNRA27mkR03v3g7PU2y1CDBMaVUtxpvzPtsh9VfO/f3Ei6tpNiQdMNZkomLXtm4E5HCssXdkrSfiWYUKS8DFMFH4O7poGYQixS4VQtJVjzkivrc8TdlpwkpHxUlxJB74DiXi/UfbHgMTJ6iPoNcMVK9Ckidud2/fIXG8QbImFKCeD/KaMLu7pCYktYNjrbqUsvFFT4AYNMKpMgeGzfJkKBY3qcB5hoZFkTjOOcxqTk+cRFJ/HzFQWr6M9JNVOlEPPktAy3wYuQzHw0lsHQk4tCghzu2Tz7no8FZyQopQOeJHJqsTYu2bM+50DA/94MwL2D5PN4rqTrOl8LupOLkMyQ3vTmu+FQrywhs07IDkTniFLDGDiwtkO4S0+JNlh63GfLYH7BFvPY0vXywaD3A8G6d95ckjhC9DQtt7IoTI9ocFEoAu6ul14E3NF6J4JLUrTnFEtCnBIPe3aHfe03Negty5Ev8Ir9yXfyeIwms6mv0IGK4FmtpBXzxTLW1ZY4dj3ufarVYLztGxPxsbFVqG2qejX6E/4ufvDBN9Co+HY0oOJFzuJ0kgXWvZv++faNXttgoxz3O7KCJeWdEgvWDQZqhyVbb9C3esaNpLcPVBlpm8pPqQgtY9Opc3GSjxbblraHpN6wElN88AlxysztadGRESk/j9OEywHqDt4+HLDHQu4Rd202JB3xez70Ovc8N4+MHib8FMZk6snPzDA/eEIhvf3lFz7wTk2EPHGfmBBFIB4TamKiNRJyd0vWNQGP2d5G0hlwj/EbOJlXNybhXSc61aqeCgqVnZ8w3B9315iAWk8oE4YePg+lClUzlAqlydTYqHYO7ACJVaJ4NGf1NoTjnq7P5tzzoWgfnaYAXJhkQbSAa40oUweCtZGwqzssdtxyM9mzF5vPFQazlExebqVZHSklSWZEW9bUGQ72+HwxSYQZUlouOnJe2sIJjyp2aviS/UvZOhR2jiqOgXrpPYd1//x5ZHiAFDKkmKenXXi/alNCbg24/+1fPhRqk0Evhzsq2EH2UozqpwO2vqCzpTFIOjs54tgdSlLGmdXYIWC51siMJRFLQFKJVD6bPxF9DMhlcsl4EmOy6Wx5k6t8dSFX6NrZteKdFa++8upbb7710caPoqPRY+gwXDKpDGbAEulkGoJrtJgNPqE6BE8ANyyyqOJxTLvwjYW//+/ft7W0Hew/eJyjOBFxXk2hvlHjPtJAosr9OQSM63D/3jn3bxUc4OEjIFSyg/Mr2GZUtkZkZEn2fWFvx8xG0r2Hutayl+B1LINVX3W6vciRM5lcU9OGcLhX8sUalEzIkxBqVfheoTYiTY0ELQmfC0hFFdtQ2H6k3rlBtP756XlkcJhkS9Tb0HCjsehTVSUA3Pn0zpd+/pEHcLvhJeI+pOoueA9YN+ICdReKoyfgfr8xRNra8A5EzdPTe91geZxePiNlG2Ey31HSqVK907zs0osvvf7a6889+9xnn3n2REIOsG6deSvGXHbpZbVTa3u7eyu2CQV4/bXXbRbbhedfeNp3TuOCeTDykYceqfiBndt33nDdDd+95LtX/NUV11x1Ddprr7726iuvxqLorw/VA8Rh/HwYDvWaVXTCJH09fU89+RQmPP/c8/n8Z51x1nnnnIengDt/z/JT1Spq6oZe7tSQQNCjQ50ePtIjyww5su+DWXeur50SC/gBdEq2JyUHy57QOrClENCt/WGhY2YD6e4iebV8kmLyc3ID9kjL7qZpqIwKJGKk6e319cHdsjgE65NswDrrmZKtt3/pvT7tdyf97mGp7tB097u+qX3PPU7tOlekddzyAY3BwBkLf9RzqIjLu345BrdkZRGBvlgMNICmflSQ1vWFxOUhhbS3suCS4JyFlAxWcTWrPSu4BxZYumQx9vDsM89G+8RjT1TCIqe+3JGGAiHcPeO0M668/Epgx7d3ZGhE9svo5CicefqZ/OL075wOQX/3nm4Ox/Y/bwfW48ZU1APwod9Sa9n2xTauXfwFsErLipaLL7x43MjK42gfmvMQH89ftRIReHW8pNJYWPZXsBrsMODu37v9gbu2+J1DQTkT9EdEC0j1SeAuaNVwV07QirTkrplqmh5bJ4azTW90KMKXAVc6LKRkJ1hfGrgr7pjHMuy1xG/2r3Vd/fkzD2MkuB8Sg8phHOf8tNrHP7AgE8Md88OooZlOCH9JEIPBoACu3nljkKxrJdm4WcgVWVhguYfJ6ao2RjDRv2jxksrmP/n4kxW6dYzlFtVp9dM4rJdfdvmuHbv4xv74H36MTtgy+h02xyu/ewXovPbqaxiDHtj792/7PtetLz77AhbNl7jumutu/7vbb7vlth/+9Q9nTJ8B+LD6BeddgFsw2Ip1o+1c3Ql8ubvAQnAIP/rbH911x10BOcANnE/4m1//5sRYX06rWbZVPh8rEXqo1Nez4f47N/tso0FPlB1VJGQbLXOdOtwsyPISDc3h6bxFs5Qlaha7TZYu7J7mH1CckYBz2FOD/J2m8AHX4I2+9cJ1+599iAz2UZXLl4ha4ZBjcNPzO/0r4OYvRt/Z7wD0FH2/IyI7wAB3BtytM4J6ZwvycV3Nq5peCXYcbvopB+OBSxcvxe5xkwTcfN94POV2AfOZPm06tyaAtadrD/o3f7z5nLPOAQrodNqdkZFI2XOWtAP7D1x0wUUYDxC3bt6KTpgt1wHIfffcxzHlk69cvvKSiy6Bb+Fqs6p1FWePmASunk+CJX7wvR8MHBmoYDrr3lnohEahnXL9lKOHj5ZrPlVsB78YwaxAQWf/pPPkwJHP77l7o5vm17GAM6nYI94p2MlRbw2wnhTuvePhruKH/JMn6oRLGiJFnmTiq4Peg41SJCQgrYNRDwVc+8PudVLd7gWPkqF9lIfTLxbKJqcSjjgHmhfU2CIM7q6XXgBVS4TKcMN7sxejcZyGb5+NOnbYuLc2US90S+42SSh2rKDHK6WSXq6ClE2bOTu62LJFzdyZA7vHHn2suorCgzjgbmxo5HDDSIEd+sGa+FMwzzmz56AHNAwtCBgenH3/7JopNaIgbvlkCzp3bNtR8cl3/NMdFd8Ljof27jvvRj+UB+3ipsV86d/+x28xMw8xdqsdJIGP5+8GhyO4BR4dYOZrO9fyOdHPhSk0LazkjJJJ62YFcqD/s7lzPxE8wwFfVKYbCH6b8tfwo0y2jePh7g8JHTfXl+E2eXCtgltlToNlT5wfITgSQzWb3lwbEHeJziHFE5km9Tf41kq2nU/NISOHaUVOy9OxNLM2uHdg38vxL6wo1uVVJoKbvxjDmr4tPBIN4n5HBq1gyQcExPH27zVqa1tZBQahpkxTy186FSnczU3LzvjO6dxtznti3rgSCi+TVmL3VVdctXvXbvT/8fU/4hFukh6Xh8NRYeywRFAvBHceWBHuwfR4yOBwIwXgrgDzI/5y5492yaIlfGk49gqjePNPb1Z0A49QNE0Cor7o7UVwDs1Lm/f37R9Pzgt0K7UiI6uFAunp3vqPt2912xGvY5KQCYoJrzXjqcuIlIFHla8LN3MXYx+RahX86bVOUgl9yeL1DaGeacFD05SNfteuBU+RoaMkVSB5GuuL7OzNrBzbEMbIWdA+9uHkV8JNq/QM7gQcu8+V94spjyPptY4GXTuC7rYGiXS0kGScYMf0Ss3L5BXF5qYlZ7K4DDiemf9MxSVWkmtczLxpJh8AuMG70AmD5VSZI15XU/fcT57bu3tvudhSlcThcTwCjsdZFpx59fyYB+ScGz6CMh5H56EDhxA1uHqA9g8ODJ5YKuegj0/GK1LS2e6ryGrJ/n1b5jz4kb02FZYSkptbR1ZyFkVnVrAhuxkt4/t14KaHp/Rn4r3YwTP0kLkd3M/lSTxJmha3huQVjqkH5z/C8usSPVCjxVszSyukJRq8j/ENkzpyzs1PZt0MawePPvTC50oKrpwkQIFBQuJhzw7FtaxBJu+uIel05atkbDc9NjVNWAcnvdxO4c8RGR+Y9QAc8v333Q95eO7DQJkHd1wAU/6eP332p1wHOI6wfQhI3YsvvLhuzTqOOw/T8P+wbo4plnh+wfPIraBacx+ciwm5zsCcaaBnCt/R3nH6mMMJB8MIE9XqVynOV8o4lZ6qL1ERFzWaiw192THrnrWSODyjnpYiFSQyNSl2bJFl9RCkSOBsLCDa/redKw+So7zuOf5I+Y+UE7sqRdlI2t25j54+5tgZnUjisEwqsStFAIkIBAILSSColA2hbCKgkqLsSAUyEFuAg4mMsI1jl9CF0EqrvdhdCXTfu5JWK+01O/e1c3R/ee97PT09s4ti8qfsqq+2ent7umf79733fu8kuIECJXjlCcC9G6naKYJbd+irkFD2vExYwwOLBe7r8UrjTIHF05lfv39q4wY2dJwba40yNmA/C1x1VyjXrpmytIafbIK7Q2ghuBNYJlGDu5px48pcdsEGHvdZEwHwAlqiId/pBa3bF0RGPtoDhqLMWStVNYPs/fKDXwFohDgJFMA33b2ilw+SCJrZkKlnvvsMSbcBN10J/ApE1Xj5IMJE1YzbGse0W9Y8tgYwBdRIumkHEg8EGm/4g9Ojc2ag6wJEf4T7Dwpu/VeVRce7n1q/NyRejgTGZeeoODsbtsa8t6YwXupMeuG9uTIBDyhGghsD3SL6ZekbwI2akQrhsEMgX+HpMsS6yqwzeRZLjfzszY4nV7CzPayQUQtoRAvVgECpGovlarxWRGdUXn0huOELT4rWeBDLHbOSKx6UeyXvzrvvyhzuBqZQ4jSSHG+gFj/fvu1PqmjCT9C6xMEAMvgJhJnO0Mv/6l9/9eTxk0ZMA3Q1sLINT2xwO91kyuk+BJbuxWvscN/hr/zVV+gk+GiWZgt4T7DmzJpDoANPA+MOLiHddtu72+BZdEOgdtPTapQrMVIk06NqU2rVmcVc9vnepx//iOdBRkK2ceXWVLA5LVtSgjMjetMgzlg89sXgJjteCz/CO8VyF27TseAtXXnrv37j8/6P6+tnH7+fDZxiU1le+o5EjWdrNG7GK9XIbI3nUqnk7wk3V0dwsiUTcuAFIvA36ZjHs/eOxaz7IMtGGaoVRgF+Igvbtm//0z/7c4Lpnn+4Bxhv+4F2WG0ftx1sOwhr/779kk8ygiQXzl2gF27QJzgGZg4+1w9f/uHSxUvJ6aYd8u4778I1IN0AKCH7rb/7FjB2IABnT58FF373zt3gZxmhNnLEgJ8bGmbh/IXIyafFxunpQNiMrKiZs9EhTxzwwOnwpf7VK/f5rJfne0eD1njAGvU2ZSVPRnTjS+MFCf8H3DXp02tXaymYkqnSFTy+VHRk6+v7Qv7zEeXqQl+bb1bv4w+wS2e4SterQYp6AqyKde0/q2jErr4I3Em/ddw7a1JsiUXk45J4aMnt7GAbyyWZmtG0Aq/ArH5DjW37xXuG0gb6ZNBps7DAOyc9bzBzHe5p2S7wvED8QZMTgkDGzEFU2lEN6bNPD38KDhf5XPAgOA93gAfRGaB2FMMxR/INWm4EXRsj53qtmsobfCq8Nuli/z+v2eduii0MxPwCENqo15JVXEmhJafg27sR3PlpcGt6NhYOs1mV8EfzrRaTr23eq7jPBV0jActouOXaIvch75xjK+9lF89iAKQE1lsrqBU99KGau9b0IunpcE8qViTn9XDzhA5+4UnBEvc7wQv71O/e+7d3sp4uli+o+ZxWycNCg1MsGybj/fdqzBxoucGBiffCT/CRKcwCW+KWv7kFpBIu2Pwfm8FfBjThI1evXCVZM+Srp6uHmPz9995PzJyUOaz7/vE+OJNNZ+n+cCs4ppvD9eB2jV4fhQtI5GkT7tyxEy7WYa0+5YNfffD9577/8r+/vPH5jWAsDJE36mrKU1O1Ls2pMjbljV85tebhA27bkCJNKt5kyBkVZmdkJyXCvhjcyLJUtawHUjXCGh6Rntzps18JCYmQMy7NigdaRuU50bDQ7mo+unYVGziNBRWlPOW0zSXxpqozYoE3gptKH9O6dGOuZDws9vvse5fOY31dLJsEM63qaX+eAYQ9VuHNruB3v/8BvVgw0+seX0emkIAw3BwKopJ0g+jBNcvuWmaEQd752TskZfBBjJ+oGBolVQw+nRluABSkW0dE1QUTdovBEl0OF3jZcPLpDU/DV6I9sGjBIkMbGAkUa4vV4HvguDV435Ts41mHClfpagU8XdgAg4P9j67u9Nhic8URpSnRah/xNKcDAry0pO/3hhs4mcbDoKpOrnFrlQosNpLb+srgXC/IWtLTTO0DUawnd41GxG7FcfKx5ajV8xlMV9UStbi0Wi8w+0JwYwg95DkmOT5adic7sB/7CotcnFWtVCgiiIY/zwvbfvHednqr8N7WrllbVx3EsQbNGWmNUJAT4CZmvuWVLUZqw+v2DlwYMD4FypksNYD4+o9fh/OwQ778l18mdEjeSRvDzcHXFjwC/Iks/t3L7qYvAE+hM0AX4UEPLH8AdoWRPV9+33L4E6VdZFGm9HpDlzVmFTWekuY/y8SBQcyHLl9+4rFOb8vwXO+I3zYZ8ExITkooV+G2JBULOWK7dNtdNKXRiQJWyuU8byrkYfOpNEtNRP9z806xZdRvyfodOY8t57EnJW9C9mJJuWQbCTkPCnO6HlnBBi9giqRQ4skQSkvrDRC1FnGQR4T7+XbBGm/1GHBTLAj8x2phM2bEjkjOQ8uWsO5uls3hom7xwpReXq3ptqfCK67JdgOa8FZRuo1qz6pFBpkFuI2oGkl3LBoDSTT4MzB28JhWPrBy8aLFtAcAcfgUCeOR/iNAvAlu8MjCobAiKa3BVjDxX/qLLxnbBj7SeajTkPqfvPETeijoEEqFgEq5Y+kd8Fw4Txkx2FHIBqfXQtf6/vQGbL14CaHJsauX+h5ZibWIrfJ4wBkLYFPPuM+ekj1Jnz0tN6f8TQm55ULQvWvpfHbmBNpcve9f08tFODfkgdAyZplz45m3Xv1QsQ5EPBN+zEumfa6MgDXJsJGwRUjAOvOxiOeg13L84QfZ5Uu8urVY7c8m81CtJQMOXcqxTObkxhcOeO1gCyYxdmpJKDa4T15wF3yetGCP+WyJsLdPcf7yG3dqnV1Yt5bJ8A5IDm+pWFdBWi6TdL/739sMYgzSXf0nVDMXCvqDdA0I1IljJ+ivgDslraansOn4+vB1I98NokrW3HDnDSedzoCxBhfAeDSlrYHqE9bmmxspdTh4+823b1hKV4NbL25BnsQrHIYvnVy9qlP2DEckbO+SnDHZGxMcYMrRK5eaQEIHWoUPF89lF8/gDgFrUQGGVazVcTFtqpDF8v5sNLr1lR2y7fJ8aSyAWMclV8rnAY+exzmx+CSj2DPYYWQfC8sdkrvroeXswmm9eFirVOh26BlTc2cZTUM2R3DHQwKKttSMMVLRlhWxSjYtuSfD0mey48A3l6hdXdibDAp8CkM98CX1rWjs/GpjEfg4H+7cBe4VaFSQ0Ge/96xZKxpBjG///bebZjcBIuBfYz6iqo2Hh4Y3/WiT0+6Ez4KEgnjCfgA/HXQy8CvjDmC7QeG3NLXAlSCboiACJYNbwa9wDIwLbD14Zwa7NofrYXc99eRTX7vla6AWQJPQI2A9se4JsBp1xXgzNQbWfNnaHgAJzbNSnF0/e+TpR/e7rWMhf1T0ZvwCxqVFSy4kTLqtWcV9we/ecVuEXTyPVUakw9WSBvSVvHrwtUt5lo7m33h1r899OSjCngExBLlO+zwJ0YOgg3WQrGAaJoTZ+YAn5fdeVxxX5sn7vZajq1ewoXOsmAJk8avhdIiKRsluzF5pYIWPvfh8l3tOJmjHziOxeVLEIivYkJj69HtO+r07bl/IOg6gXCPWvI1Iq/D8jVrWMPqj66JKXW0S8Cv4SWVjDb4VcTbYFblMDi6AZThBFAGjPXPt6jUQdoAVXOn4ZNzwj/Bifp90Mk0PoltRmhLuACfNZasoQ9XvYA6JA3sfvDgIjwC7cOXSFfiVLE6D3WnoCtRDkmpjcbuGASb4klE2cu7YqpUdLvdYJDgh2qK+OVm/Le62lAJKwmUDBHfeNpedPcvjJ7pEV1MwGjbhpuOpt9/YI7iuBWWAMiWgMQUdDguwnpRRmaNTr2DTQVpyjrssQKuuB1yjCxVwCfvWPsiGzjNQEUXuRHAjW+UYAHfmxIvPdbtn5QIIN9+KWM0y7rOMtXqPSa7d88Poc+UyWBtTyGNXAioKTGFWIzj1brKpaNwQqBm81/oyRXPpCGUwZ6wWgzMNXQDmHhBzCTpFSBq6FYwbGqTOrOdrlag36DnSqmM3jFJMXoJabRYrqpUEK8bZlYET67+zX2gaXeCd9NtA5RY8lqLHXhJcwwFp79Il7ORJomolsAK8ibhU4KIdi6Vff22PJFxq9U3IdiAAUSwvQayBSvHKIlxYXSah0gC4Qb1j05DfPuRrGrlNPuSxnFr1T+zSeYy5FbG2DEvsqACliL2oZ174Hkh3MujhBsKBbUeKKz3Xf1h07f3GUtbZgSnOQoEnzHHwC9W8wdGUpvIC6QroIm2qbN7t8KobVGiDvJjLRGcMXBuIGGUq5WL5xs1cBr7myhZ6UMOOavAU4FlGhcOMX8b8Wb1up+bu6LqthLV7UxjcKnM7PjRwcsNDe31fvxrxRH2Wst9dFGwpR/PVkLx7yUJ25hTa7jKnVapaqXCfORFPvL11l89zJSRNyLZ0wDYutQDiCdGVAbInYuMnkD2i03BP8OxSPltOdqcU54TQlIo4x+CvEbnd1nTkkQfZwFnehlYky4tfsJQBSnBq43eB2k22ilG/l+sK+3jAfURy77t9EevuRJ8rncOXWcaSY5UUOCd/FMapeXZ8rpBmEhaCjApCpjd6mHsEjI8AUkZEa8YOEcN/J7VsBEAMQBsy49OPzRkQ8wXGBjCMxbSlsfpml5qjUdHndCBZxT5fHmW9NnDg0eXtIHrz5CilkmXn+aBnx20hduEYbokyH42Sz2LvSWo8/earH/ldA4ob5DcXBqbXFA04xgBl0YEd3OKsjDQrI87OiC0IvWgHw53wNufgtu4WNL6ydQL0c8A+GvJ0OyznH1oJSgafUszzmOwUjuLJR4+++Mw+n3UsIk4qXmCSqMMj4vuLgqyjjeWy6HPxdBe+WN3gqzw0Xp3gVVFn0M+q1tACUNeNZQbF1FNgnCQ5NTSAEYCtbRv1cxFs6BwxwqTTSyzMSbEZd8u0YR01rqYafk5F93Z4eRjf7TzagTQJFPTo0Im1Dx8UMSYGzji4ZqcDrl13RtjpfnTEQG6miiyXYpnx4a2b0OcKuZKtnph3NnhYMb8NSwQVNzrF0mzEugY3sGjnhKcFqD5Aj1lXwU79JnEQcL8zGVJ6XI7uBzlXz3HEQR+XsiwX++ylf/nYZwFHDLAeCfr6/J49d8xnfYdYPonNiUYJJk+tllQddLD+ehON8Z6r71zvdFPryvjNrXyfl16sg0Od6eT0tlB15n5h8zab8XwD+jM+dDonrxsuV+vrr3DuigtFvDoFDyUdEb/Ws/47bR7kQomA61zQ9ZslrdjOX8DaE5aeYolk9qevfChZBsPgX1thRRVrnJeUcCrOjawCPjtfmHnBP8E2iKEegGtc5I9zHw37iXCui+K6FpYPCq6jIOMDF3F0ADb8Vlg6c/ql5ztds1MBR7pVOCo4dt21iHXsZ5kk6oFKlhfB6q+XMnQqF15aM3Tw1YvCTTabpXGAYXVeHk3p0QhueldUnTuVx/DjteFPV63olmxjEeF82Ltj2SJ27iw6YvEcS2bGX9uyPyAM+B0TsgUcYfgJhpum6+CAHdEObC0qN/NliYk4hycquimOCgfwK7B3kG74mfTZo4I97veAWhjzu0bDgU5J7Fm1kl0aZOksZswzuXMvvdDlmh0Le08qjv23tbJDH2MFGuyHUlHTckU1hxEz+p/Uz+nurMdavUnhbvwnVWM2Ik1boqaSWgs4OQN8ZkKeXR08uu7hDqHpzHz514vmoSOGTb6p+Osv7ws6wF4nAl7Q3tjQLYPqdmZEJ6jojGRLy5aEv7k6qMdJQg0LCwixoN0B18NlWQk70TI+a1aGTWKL8fJI4GDg5nfKrr6V97Brg9gSEh89+oNne/ye40Fh5zcXsN42lk1heWEBG4xUhuW2uFFLdXDfwC29iaW7FlrRDKyppKmiV/tW50xW7TkNdOByDzx8ZOjYqnt/Kzl/t2wZ++wYi8WjP3/zt/KcwXnORKsvLSGCAGhCxm4gRByrfy1puRngnvQ7wO5H/ThYCSkWIs4v5gVRtKjvOylagKhjqh2kW8Rg6fW5wj6h6cDqFezqBTZ5/eKP/u2tllv33r6Q9R3EEYvgcxXK9N0xHUXNAqUZhlp87myim3ucplH8r9U2gT5SrbYb6pgAr1VQWT7HLg+2P7luSyjMjhxVt/z4d4pwZp4wHLKPyI4xnzPm80ZF76gsjCjeCQm1NK/zt4AyH1Xco8CsFAH+OiHhX/GMAl45qvpxxQ7HfNmBzI8CE5M9OHjN7xtR3MN+65UFYptfPLx8BTtzuv8Hz21ZMp/1tPOBmWW91o3qUqq9nlojxLV/1vzLH9D8Ja1uf5t7K3QjrxqxIKQ6ZSLv2Sy7OnzoXzde2bT5DVHcs2hu1wJ/Z8jTFfZ9ElH6ggFYHeHAoUigqzXwSUjpC/lg9YZ8XWEFzsPqblV6QxKsrjCuXv2vUgdeoHREpE/mye1+Vx9cGVC64SYRpTvsaQu42hcv/qkgf7x+ff8rmyb278K6lEoFFE9lilc2lznoqo6lXg5tRthchNEA9806a1FtfAON/7XxlvRB0oxHwvVGLdT2oDmLwNBisSP92U+6WW8P6zzAeg+BXlW79rHudtbdwXo6MIwJq7uLdcHqwJO97bhAJHsOsO42XHCAxx14GS36VPtB1tvN4ObwQbg5eNPgZPX3wJlSX1+8r18dGsQW8lKqrOHwY5oRxdtViIxxJq4PftS0ejNWnQGqzcBab264TVPG65wyzQQ3/VpBRVnGCCkvK0X9WeIjPsp8FFIBu+/LPAtW5uOLceGcaryySIsPNIYLSnz6cW3xdGexehkc06+Foj7QqcQ/UguAl9FNwMvA5c+BT13gkl1QGR2gyYEHsbIZ7husmxzu/+ccMBPJ02Pr2CfO4zBlfXZyhVa5thoGm9MF5emr0rhIOiu8IxD3DE1Ep44kPlcEk25lvROtqrfrhoBq6h9nosL6X+wcvFYKZW5kc3RyZWFtCmVuZG9iago0MyAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0ltYWdlCi9XaWR0aCAxNjUKL0hlaWdodCA1MAovQml0c1BlckNvbXBvbmVudCA4Ci9JbWFnZU1hc2sgZmFsc2UKL0NvbG9yU3BhY2UvRGV2aWNlUkdCCi9GaWx0ZXIvRmxhdGVEZWNvZGUKL05hbWUvSmZJbWFnZTAyNzIKL0xlbmd0aCAxMDQ2MAo+PgpzdHJlYW0KeNrsWnl0HMWZD/d9hOU+bElzz/T0THfPIVnGYCDJbt5u2N3schuMzfE4zDME4rAhbAi7ednNH/teHksILwGzyJewLcmyZBuMMRhsc8SXbOuw5VPomvue6av2V1Wj8ViWsMnuf/Dep3qt6uqqnvp9x+/7qolGCEQnxMSfZhBNIyY6TBN/VEz6r14iRomNIgbEJFqemEVcqoTkNQOPFEneJCV6S9VMQ8U8OlF1TGjSPp09azCpmphdGdU3ShCDvwDhPWwYf14rr25qmmbSMZpRxOJ8CaOEP02njxsm/0UGm0nX0K8RTSX6sUW/saKNIWFiN8pwG2QMCLbpBlUFQ2c401G6SrfR1At6GQHd1EulNNUBVaWCAWrRLOTQ0m0G8tXCx2gldkslJZ0AKdWk2qHmiJajyoUZdJ22dBhEM3MFoplscInfUotZYhbYEkQv0lc1VKBf1E3V5L+IKwpVBQ68OaZC32CpwpqbQNm0DXLMJvG/MXYNwNQ8KRUJwxpCLRxI4Tngki2QXJEUcJEnBY1elHJlKeZIoUrUDNEytOX9xcKxkRC1QEHXClQBShiTpCMLeZLLk6JGchiQJnqSFCNETdIZqArBq4x5AepvNGbYDGLjG49yRbBFY26cGRsz7QrWZTGoY2RwlzQ4bY0w50k9a4lZHMCNxfra2gba27PvrUu1tuTaWoptq7IrVuZbm/Oty1jbXGhpLq2kgotMW3NyVXN61bJsG+4uy7bSnmzr8mzrykzb8nTb8kT7SgjtxICOpbmO5mJnS7plRXZVe251e3FtS2Tl/yQ7mpPvt+9ZsUjr76E6U6IeAzYOuE2GtVYJQN8CXRZtLGRXuXG9yslTR8jEYH6R3dF4DDRUUsyQdILs6219+unhP/zhjen1S4Li+huljQ3eTUFxa8j/qSJ8qni2BITNVETIFkXcLHtx8UlQ3BQSuGwOsjGKDNkU9OPZTwL+LQoeF9H/UdC5QbF9XC++73N/IktbA9ImvwP/rp/R8F9Wy6c/X7D5P/993ztLSTpJCioPMGVdNsczhm+6UOjKfu84rLUK1tRKDIYw3zx4bnoHRgSs83Gyb/d7j8z53fR6sncneftPbdOVz6cJh6YLhyXLoM8S8dtjPvuoZB/1O7mMSBD3qN+Ndkh2DioQOxuGu8KIXxiSccsZF51JEa074ncOyfaRkGvIb40pnqTsGfU5ogHPgXppjV/snz+f9PUC8V8HfGRdJ8nkSE4be3nCtXQsjpvfwm2WTZdMgDW1ZQBNYzMQ53CbZYYMipUm+RQ50PPFXX/fKtpa/2Y62f0pSYxkVixpqxe6wo6RBmdMscQUW0x2QOKKMyW7krIrGnSNBj2QuEJlNIge3KISk51RBa0jKdnyIgQXzqjsjihCRHIlxLpi0Bn13BALub5slDu89q0/e4Yc7ifRkV2/eH6xaG+dHjBXrSCpFAFfA7UAgUREZy9fdkzfwj2W7pStoBKvy5pA7Zptl3ZsdFGnJCobJYf6Ns++91Ofc+80edWtIdK3jaTiJJtRmxa2KZ7uetdQ0DoqWWJ+KnHJmvJbUz57RLYPKw5I3O9K+B1RyQ6ht/zWuFQXlevQpvx1ObEmJ9axAa6IRC06K1nj7uuSgbqB6Z4O19RdzzxO4iOkkAbce/71+Q9kx54Z8qoZIbJqJUmnQN4Qa8AUdZrcqZUf9a0cB7RRRlVFPgstMHQDpNdgiRK7S82GuvE06e3aPuuOz3zuIUXsD8stMxvQQ/IFUjBJsqSuXLW6UdkVdMXqRZht1FsLg437LLSV4JNtFGKfg4k94edw1yXl2qh/Skypjcs1cf9U9OAWvPeIzxELuGK+GmjCaNi90Vu3a8ETJHKUcrN8iWQSXb/62SZx6nCDp1vxrKn3l9reIbkE6D2jbZS5kdKxX3dKG/LVe3XSYV938P+FYBjHXZu6eapY69yBE07OCqVCGXvm241COWbTzGhf16ZZd260T43IYkry9gel1lumkX17aJaEFDhPSLpUXPzWmka5S3FHQmI25I0LFOuUYo35axPUfqmlA+40bYG4FZL01WYVS9RXQ208YE3ItqRoi3qtUcmRqBeG/Jaj08T3PZaepx4lI4dIPk1fjOZlie0vP7fJe0My5Bz12YB4S6NidraSbJrkMkTP0XfWvg7cf6kwE/lLYTVOuDvh4OphxvFSNeCUQGcOnKVjZepNzVlH8jVWcSmppFAgRw9um33XVlCssBeeNiYJXZJn9S0NZM92mg1pOikWCVQlPZprXri63tdTL41KYlKgrhsIAu64vzbjqyvbdRXcWZi8aEl667JBD8gbsIM+FILeqM86KNlGbgp3CvYtP3mSRAdpDq6zok0Jria57eUFHwoUbkT/YcXTL/veCwfImtUkj+w+ixEnKbBMAgE2rSLj+sc/UrXhuKtzOls92Pj/c8WTadopLKFT8m2MmTaScGBNi58s0TZp+Yqm2fDtBq2iFHPk4MH199690WsdCnlgdGBfYNSUJMO69+4gvJIGXgfTK6RIJkqWv9UeFnsDckyWYz531GtJyBY47bS/hkFsh3Wnx+DO+B1pry3ndyYFW1R0pAPwCfYI3ELQPdDoa3fXdi+YT0YGWJ1trCCgFmDm215+foMwJR50MJrnLChCn9+9vCGYa19J446ao7pxojmculs2J3rKHO9Fq62b/8vlmJutMr1qXTpOf05cwqh6/IR1aRVZN6v/hbJNpmOsxMmqKLTSaPAqJ+VmqsZNm2GNRA27mkR03v3g7PU2y1CDBMaVUtxpvzPtsh9VfO/f3Ei6tpNiQdMNZkomLXtm4E5HCssXdkrSfiWYUKS8DFMFH4O7poGYQixS4VQtJVjzkivrc8TdlpwkpHxUlxJB74DiXi/UfbHgMTJ6iPoNcMVK9Ckidud2/fIXG8QbImFKCeD/KaMLu7pCYktYNjrbqUsvFFT4AYNMKpMgeGzfJkKBY3qcB5hoZFkTjOOcxqTk+cRFJ/HzFQWr6M9JNVOlEPPktAy3wYuQzHw0lsHQk4tCghzu2Tz7no8FZyQopQOeJHJqsTYu2bM+50DA/94MwL2D5PN4rqTrOl8LupOLkMyQ3vTmu+FQrywhs07IDkTniFLDGDiwtkO4S0+JNlh63GfLYH7BFvPY0vXywaD3A8G6d95ckjhC9DQtt7IoTI9ocFEoAu6ul14E3NF6J4JLUrTnFEtCnBIPe3aHfe03Negty5Ev8Ir9yXfyeIwms6mv0IGK4FmtpBXzxTLW1ZY4dj3ufarVYLztGxPxsbFVqG2qejX6E/4ufvDBN9Co+HY0oOJFzuJ0kgXWvZv++faNXttgoxz3O7KCJeWdEgvWDQZqhyVbb9C3esaNpLcPVBlpm8pPqQgtY9Opc3GSjxbblraHpN6wElN88AlxysztadGRESk/j9OEywHqDt4+HLDHQu4Rd202JB3xez70Ovc8N4+MHib8FMZk6snPzDA/eEIhvf3lFz7wTk2EPHGfmBBFIB4TamKiNRJyd0vWNQGP2d5G0hlwj/EbOJlXNybhXSc61aqeCgqVnZ8w3B9315iAWk8oE4YePg+lClUzlAqlydTYqHYO7ACJVaJ4NGf1NoTjnq7P5tzzoWgfnaYAXJhkQbSAa40oUweCtZGwqzssdtxyM9mzF5vPFQazlExebqVZHSklSWZEW9bUGQ72+HwxSYQZUlouOnJe2sIJjyp2aviS/UvZOhR2jiqOgXrpPYd1//x5ZHiAFDKkmKenXXi/alNCbg24/+1fPhRqk0Evhzsq2EH2UozqpwO2vqCzpTFIOjs54tgdSlLGmdXYIWC51siMJRFLQFKJVD6bPxF9DMhlcsl4EmOy6Wx5k6t8dSFX6NrZteKdFa++8upbb7710caPoqPRY+gwXDKpDGbAEulkGoJrtJgNPqE6BE8ANyyyqOJxTLvwjYW//+/ft7W0Hew/eJyjOBFxXk2hvlHjPtJAosr9OQSM63D/3jn3bxUc4OEjIFSyg/Mr2GZUtkZkZEn2fWFvx8xG0r2Hutayl+B1LINVX3W6vciRM5lcU9OGcLhX8sUalEzIkxBqVfheoTYiTY0ELQmfC0hFFdtQ2H6k3rlBtP756XlkcJhkS9Tb0HCjsehTVSUA3Pn0zpd+/pEHcLvhJeI+pOoueA9YN+ICdReKoyfgfr8xRNra8A5EzdPTe91geZxePiNlG2Ey31HSqVK907zs0osvvf7a6889+9xnn3n2REIOsG6deSvGXHbpZbVTa3u7eyu2CQV4/bXXbRbbhedfeNp3TuOCeTDykYceqfiBndt33nDdDd+95LtX/NUV11x1Ddprr7726iuvxqLorw/VA8Rh/HwYDvWaVXTCJH09fU89+RQmPP/c8/n8Z51x1nnnnIengDt/z/JT1Spq6oZe7tSQQNCjQ50ePtIjyww5su+DWXeur50SC/gBdEq2JyUHy57QOrClENCt/WGhY2YD6e4iebV8kmLyc3ID9kjL7qZpqIwKJGKk6e319cHdsjgE65NswDrrmZKtt3/pvT7tdyf97mGp7tB097u+qX3PPU7tOlekddzyAY3BwBkLf9RzqIjLu345BrdkZRGBvlgMNICmflSQ1vWFxOUhhbS3suCS4JyFlAxWcTWrPSu4BxZYumQx9vDsM89G+8RjT1TCIqe+3JGGAiHcPeO0M668/Epgx7d3ZGhE9svo5CicefqZ/OL075wOQX/3nm4Ox/Y/bwfW48ZU1APwod9Sa9n2xTauXfwFsErLipaLL7x43MjK42gfmvMQH89ftRIReHW8pNJYWPZXsBrsMODu37v9gbu2+J1DQTkT9EdEC0j1SeAuaNVwV07QirTkrplqmh5bJ4azTW90KMKXAVc6LKRkJ1hfGrgr7pjHMuy1xG/2r3Vd/fkzD2MkuB8Sg8phHOf8tNrHP7AgE8Md88OooZlOCH9JEIPBoACu3nljkKxrJdm4WcgVWVhguYfJ6ao2RjDRv2jxksrmP/n4kxW6dYzlFtVp9dM4rJdfdvmuHbv4xv74H36MTtgy+h02xyu/ewXovPbqaxiDHtj792/7PtetLz77AhbNl7jumutu/7vbb7vlth/+9Q9nTJ8B+LD6BeddgFsw2Ip1o+1c3Ql8ubvAQnAIP/rbH911x10BOcANnE/4m1//5sRYX06rWbZVPh8rEXqo1Nez4f47N/tso0FPlB1VJGQbLXOdOtwsyPISDc3h6bxFs5Qlaha7TZYu7J7mH1CckYBz2FOD/J2m8AHX4I2+9cJ1+599iAz2UZXLl4ha4ZBjcNPzO/0r4OYvRt/Z7wD0FH2/IyI7wAB3BtytM4J6ZwvycV3Nq5peCXYcbvopB+OBSxcvxe5xkwTcfN94POV2AfOZPm06tyaAtadrD/o3f7z5nLPOAQrodNqdkZFI2XOWtAP7D1x0wUUYDxC3bt6KTpgt1wHIfffcxzHlk69cvvKSiy6Bb+Fqs6p1FWePmASunk+CJX7wvR8MHBmoYDrr3lnohEahnXL9lKOHj5ZrPlVsB78YwaxAQWf/pPPkwJHP77l7o5vm17GAM6nYI94p2MlRbw2wnhTuvePhruKH/JMn6oRLGiJFnmTiq4Peg41SJCQgrYNRDwVc+8PudVLd7gWPkqF9lIfTLxbKJqcSjjgHmhfU2CIM7q6XXgBVS4TKcMN7sxejcZyGb5+NOnbYuLc2US90S+42SSh2rKDHK6WSXq6ClE2bOTu62LJFzdyZA7vHHn2suorCgzjgbmxo5HDDSIEd+sGa+FMwzzmz56AHNAwtCBgenH3/7JopNaIgbvlkCzp3bNtR8cl3/NMdFd8Ljof27jvvRj+UB+3ipsV86d/+x28xMw8xdqsdJIGP5+8GhyO4BR4dYOZrO9fyOdHPhSk0LazkjJJJ62YFcqD/s7lzPxE8wwFfVKYbCH6b8tfwo0y2jePh7g8JHTfXl+E2eXCtgltlToNlT5wfITgSQzWb3lwbEHeJziHFE5km9Tf41kq2nU/NISOHaUVOy9OxNLM2uHdg38vxL6wo1uVVJoKbvxjDmr4tPBIN4n5HBq1gyQcExPH27zVqa1tZBQahpkxTy186FSnczU3LzvjO6dxtznti3rgSCi+TVmL3VVdctXvXbvT/8fU/4hFukh6Xh8NRYeywRFAvBHceWBHuwfR4yOBwIwXgrgDzI/5y5492yaIlfGk49gqjePNPb1Z0A49QNE0Cor7o7UVwDs1Lm/f37R9Pzgt0K7UiI6uFAunp3vqPt2912xGvY5KQCYoJrzXjqcuIlIFHla8LN3MXYx+RahX86bVOUgl9yeL1DaGeacFD05SNfteuBU+RoaMkVSB5GuuL7OzNrBzbEMbIWdA+9uHkV8JNq/QM7gQcu8+V94spjyPptY4GXTuC7rYGiXS0kGScYMf0Ss3L5BXF5qYlZ7K4DDiemf9MxSVWkmtczLxpJh8AuMG70AmD5VSZI15XU/fcT57bu3tvudhSlcThcTwCjsdZFpx59fyYB+ScGz6CMh5H56EDhxA1uHqA9g8ODJ5YKuegj0/GK1LS2e6ryGrJ/n1b5jz4kb02FZYSkptbR1ZyFkVnVrAhuxkt4/t14KaHp/Rn4r3YwTP0kLkd3M/lSTxJmha3huQVjqkH5z/C8usSPVCjxVszSyukJRq8j/ENkzpyzs1PZt0MawePPvTC50oKrpwkQIFBQuJhzw7FtaxBJu+uIel05atkbDc9NjVNWAcnvdxO4c8RGR+Y9QAc8v333Q95eO7DQJkHd1wAU/6eP332p1wHOI6wfQhI3YsvvLhuzTqOOw/T8P+wbo4plnh+wfPIraBacx+ciwm5zsCcaaBnCt/R3nH6mMMJB8MIE9XqVynOV8o4lZ6qL1ERFzWaiw192THrnrWSODyjnpYiFSQyNSl2bJFl9RCkSOBsLCDa/redKw+So7zuOf5I+Y+UE7sqRdlI2t25j54+5tgZnUjisEwqsStFAIkIBAILSSColA2hbCKgkqLsSAUyEFuAg4mMsI1jl9CF0EqrvdhdCXTfu5JWK+01O/e1c3R/ee97PT09s4ti8qfsqq+2ent7umf79733fu8kuIECJXjlCcC9G6naKYJbd+irkFD2vExYwwOLBe7r8UrjTIHF05lfv39q4wY2dJwba40yNmA/C1x1VyjXrpmytIafbIK7Q2ghuBNYJlGDu5px48pcdsEGHvdZEwHwAlqiId/pBa3bF0RGPtoDhqLMWStVNYPs/fKDXwFohDgJFMA33b2ilw+SCJrZkKlnvvsMSbcBN10J/ApE1Xj5IMJE1YzbGse0W9Y8tgYwBdRIumkHEg8EGm/4g9Ojc2ag6wJEf4T7Dwpu/VeVRce7n1q/NyRejgTGZeeoODsbtsa8t6YwXupMeuG9uTIBDyhGghsD3SL6ZekbwI2akQrhsEMgX+HpMsS6yqwzeRZLjfzszY4nV7CzPayQUQtoRAvVgECpGovlarxWRGdUXn0huOELT4rWeBDLHbOSKx6UeyXvzrvvyhzuBqZQ4jSSHG+gFj/fvu1PqmjCT9C6xMEAMvgJhJnO0Mv/6l9/9eTxk0ZMA3Q1sLINT2xwO91kyuk+BJbuxWvscN/hr/zVV+gk+GiWZgt4T7DmzJpDoANPA+MOLiHddtu72+BZdEOgdtPTapQrMVIk06NqU2rVmcVc9vnepx//iOdBRkK2ceXWVLA5LVtSgjMjetMgzlg89sXgJjteCz/CO8VyF27TseAtXXnrv37j8/6P6+tnH7+fDZxiU1le+o5EjWdrNG7GK9XIbI3nUqnk7wk3V0dwsiUTcuAFIvA36ZjHs/eOxaz7IMtGGaoVRgF+Igvbtm//0z/7c4Lpnn+4Bxhv+4F2WG0ftx1sOwhr/779kk8ygiQXzl2gF27QJzgGZg4+1w9f/uHSxUvJ6aYd8u4778I1IN0AKCH7rb/7FjB2IABnT58FF373zt3gZxmhNnLEgJ8bGmbh/IXIyafFxunpQNiMrKiZs9EhTxzwwOnwpf7VK/f5rJfne0eD1njAGvU2ZSVPRnTjS+MFCf8H3DXp02tXaymYkqnSFTy+VHRk6+v7Qv7zEeXqQl+bb1bv4w+wS2e4SterQYp6AqyKde0/q2jErr4I3Em/ddw7a1JsiUXk45J4aMnt7GAbyyWZmtG0Aq/ArH5DjW37xXuG0gb6ZNBps7DAOyc9bzBzHe5p2S7wvED8QZMTgkDGzEFU2lEN6bNPD38KDhf5XPAgOA93gAfRGaB2FMMxR/INWm4EXRsj53qtmsobfCq8Nuli/z+v2eduii0MxPwCENqo15JVXEmhJafg27sR3PlpcGt6NhYOs1mV8EfzrRaTr23eq7jPBV0jActouOXaIvch75xjK+9lF89iAKQE1lsrqBU99KGau9b0IunpcE8qViTn9XDzhA5+4UnBEvc7wQv71O/e+7d3sp4uli+o+ZxWycNCg1MsGybj/fdqzBxoucGBiffCT/CRKcwCW+KWv7kFpBIu2Pwfm8FfBjThI1evXCVZM+Srp6uHmPz9995PzJyUOaz7/vE+OJNNZ+n+cCs4ppvD9eB2jV4fhQtI5GkT7tyxEy7WYa0+5YNfffD9577/8r+/vPH5jWAsDJE36mrKU1O1Ls2pMjbljV85tebhA27bkCJNKt5kyBkVZmdkJyXCvhjcyLJUtawHUjXCGh6Rntzps18JCYmQMy7NigdaRuU50bDQ7mo+unYVGziNBRWlPOW0zSXxpqozYoE3gptKH9O6dGOuZDws9vvse5fOY31dLJsEM63qaX+eAYQ9VuHNruB3v/8BvVgw0+seX0emkIAw3BwKopJ0g+jBNcvuWmaEQd752TskZfBBjJ+oGBolVQw+nRluABSkW0dE1QUTdovBEl0OF3jZcPLpDU/DV6I9sGjBIkMbGAkUa4vV4HvguDV435Ts41mHClfpagU8XdgAg4P9j67u9Nhic8URpSnRah/xNKcDAry0pO/3hhs4mcbDoKpOrnFrlQosNpLb+srgXC/IWtLTTO0DUawnd41GxG7FcfKx5ajV8xlMV9UStbi0Wi8w+0JwYwg95DkmOT5adic7sB/7CotcnFWtVCgiiIY/zwvbfvHednqr8N7WrllbVx3EsQbNGWmNUJAT4CZmvuWVLUZqw+v2DlwYMD4FypksNYD4+o9fh/OwQ778l18mdEjeSRvDzcHXFjwC/Iks/t3L7qYvAE+hM0AX4UEPLH8AdoWRPV9+33L4E6VdZFGm9HpDlzVmFTWekuY/y8SBQcyHLl9+4rFOb8vwXO+I3zYZ8ExITkooV+G2JBULOWK7dNtdNKXRiQJWyuU8byrkYfOpNEtNRP9z806xZdRvyfodOY8t57EnJW9C9mJJuWQbCTkPCnO6HlnBBi9giqRQ4skQSkvrDRC1FnGQR4T7+XbBGm/1GHBTLAj8x2phM2bEjkjOQ8uWsO5uls3hom7xwpReXq3ptqfCK67JdgOa8FZRuo1qz6pFBpkFuI2oGkl3LBoDSTT4MzB28JhWPrBy8aLFtAcAcfgUCeOR/iNAvAlu8MjCobAiKa3BVjDxX/qLLxnbBj7SeajTkPqfvPETeijoEEqFgEq5Y+kd8Fw4Txkx2FHIBqfXQtf6/vQGbL14CaHJsauX+h5ZibWIrfJ4wBkLYFPPuM+ekj1Jnz0tN6f8TQm55ULQvWvpfHbmBNpcve9f08tFODfkgdAyZplz45m3Xv1QsQ5EPBN+zEumfa6MgDXJsJGwRUjAOvOxiOeg13L84QfZ5Uu8urVY7c8m81CtJQMOXcqxTObkxhcOeO1gCyYxdmpJKDa4T15wF3yetGCP+WyJsLdPcf7yG3dqnV1Yt5bJ8A5IDm+pWFdBWi6TdL/739sMYgzSXf0nVDMXCvqDdA0I1IljJ+ivgDslraansOn4+vB1I98NokrW3HDnDSedzoCxBhfAeDSlrYHqE9bmmxspdTh4+823b1hKV4NbL25BnsQrHIYvnVy9qlP2DEckbO+SnDHZGxMcYMrRK5eaQEIHWoUPF89lF8/gDgFrUQGGVazVcTFtqpDF8v5sNLr1lR2y7fJ8aSyAWMclV8rnAY+exzmx+CSj2DPYYWQfC8sdkrvroeXswmm9eFirVOh26BlTc2cZTUM2R3DHQwKKttSMMVLRlhWxSjYtuSfD0mey48A3l6hdXdibDAp8CkM98CX1rWjs/GpjEfg4H+7cBe4VaFSQ0Ge/96xZKxpBjG///bebZjcBIuBfYz6iqo2Hh4Y3/WiT0+6Ez4KEgnjCfgA/HXQy8CvjDmC7QeG3NLXAlSCboiACJYNbwa9wDIwLbD14Zwa7NofrYXc99eRTX7vla6AWQJPQI2A9se4JsBp1xXgzNQbWfNnaHgAJzbNSnF0/e+TpR/e7rWMhf1T0ZvwCxqVFSy4kTLqtWcV9we/ecVuEXTyPVUakw9WSBvSVvHrwtUt5lo7m33h1r899OSjCngExBLlO+zwJ0YOgg3WQrGAaJoTZ+YAn5fdeVxxX5sn7vZajq1ewoXOsmAJk8avhdIiKRsluzF5pYIWPvfh8l3tOJmjHziOxeVLEIivYkJj69HtO+r07bl/IOg6gXCPWvI1Iq/D8jVrWMPqj66JKXW0S8Cv4SWVjDb4VcTbYFblMDi6AZThBFAGjPXPt6jUQdoAVXOn4ZNzwj/Bifp90Mk0PoltRmhLuACfNZasoQ9XvYA6JA3sfvDgIjwC7cOXSFfiVLE6D3WnoCtRDkmpjcbuGASb4klE2cu7YqpUdLvdYJDgh2qK+OVm/Le62lAJKwmUDBHfeNpedPcvjJ7pEV1MwGjbhpuOpt9/YI7iuBWWAMiWgMQUdDguwnpRRmaNTr2DTQVpyjrssQKuuB1yjCxVwCfvWPsiGzjNQEUXuRHAjW+UYAHfmxIvPdbtn5QIIN9+KWM0y7rOMtXqPSa7d88Poc+UyWBtTyGNXAioKTGFWIzj1brKpaNwQqBm81/oyRXPpCGUwZ6wWgzMNXQDmHhBzCTpFSBq6FYwbGqTOrOdrlag36DnSqmM3jFJMXoJabRYrqpUEK8bZlYET67+zX2gaXeCd9NtA5RY8lqLHXhJcwwFp79Il7ORJomolsAK8ibhU4KIdi6Vff22PJFxq9U3IdiAAUSwvQayBSvHKIlxYXSah0gC4Qb1j05DfPuRrGrlNPuSxnFr1T+zSeYy5FbG2DEvsqACliL2oZ174Hkh3MujhBsKBbUeKKz3Xf1h07f3GUtbZgSnOQoEnzHHwC9W8wdGUpvIC6QroIm2qbN7t8KobVGiDvJjLRGcMXBuIGGUq5WL5xs1cBr7myhZ6UMOOavAU4FlGhcOMX8b8Wb1up+bu6LqthLV7UxjcKnM7PjRwcsNDe31fvxrxRH2Wst9dFGwpR/PVkLx7yUJ25hTa7jKnVapaqXCfORFPvL11l89zJSRNyLZ0wDYutQDiCdGVAbInYuMnkD2i03BP8OxSPltOdqcU54TQlIo4x+CvEbnd1nTkkQfZwFnehlYky4tfsJQBSnBq43eB2k22ilG/l+sK+3jAfURy77t9EevuRJ8rncOXWcaSY5UUOCd/FMapeXZ8rpBmEhaCjApCpjd6mHsEjI8AUkZEa8YOEcN/J7VsBEAMQBsy49OPzRkQ8wXGBjCMxbSlsfpml5qjUdHndCBZxT5fHmW9NnDg0eXtIHrz5CilkmXn+aBnx20hduEYbokyH42Sz2LvSWo8/earH/ldA4ob5DcXBqbXFA04xgBl0YEd3OKsjDQrI87OiC0IvWgHw53wNufgtu4WNL6ydQL0c8A+GvJ0OyznH1oJSgafUszzmOwUjuLJR4+++Mw+n3UsIk4qXmCSqMMj4vuLgqyjjeWy6HPxdBe+WN3gqzw0Xp3gVVFn0M+q1tACUNeNZQbF1FNgnCQ5NTSAEYCtbRv1cxFs6BwxwqTTSyzMSbEZd8u0YR01rqYafk5F93Z4eRjf7TzagTQJFPTo0Im1Dx8UMSYGzji4ZqcDrl13RtjpfnTEQG6miiyXYpnx4a2b0OcKuZKtnph3NnhYMb8NSwQVNzrF0mzEugY3sGjnhKcFqD5Aj1lXwU79JnEQcL8zGVJ6XI7uBzlXz3HEQR+XsiwX++ylf/nYZwFHDLAeCfr6/J49d8xnfYdYPonNiUYJJk+tllQddLD+ehON8Z6r71zvdFPryvjNrXyfl16sg0Od6eT0tlB15n5h8zab8XwD+jM+dDonrxsuV+vrr3DuigtFvDoFDyUdEb/Ws/47bR7kQomA61zQ9ZslrdjOX8DaE5aeYolk9qevfChZBsPgX1thRRVrnJeUcCrOjawCPjtfmHnBP8E2iKEegGtc5I9zHw37iXCui+K6FpYPCq6jIOMDF3F0ADb8Vlg6c/ql5ztds1MBR7pVOCo4dt21iHXsZ5kk6oFKlhfB6q+XMnQqF15aM3Tw1YvCTTabpXGAYXVeHk3p0QhueldUnTuVx/DjteFPV63olmxjEeF82Ltj2SJ27iw6YvEcS2bGX9uyPyAM+B0TsgUcYfgJhpum6+CAHdEObC0qN/NliYk4hycquimOCgfwK7B3kG74mfTZo4I97veAWhjzu0bDgU5J7Fm1kl0aZOksZswzuXMvvdDlmh0Le08qjv23tbJDH2MFGuyHUlHTckU1hxEz+p/Uz+nurMdavUnhbvwnVWM2Ik1boqaSWgs4OQN8ZkKeXR08uu7hDqHpzHz514vmoSOGTb6p+Osv7ws6wF4nAl7Q3tjQLYPqdmZEJ6jojGRLy5aEv7k6qMdJQg0LCwixoN0B18NlWQk70TI+a1aGTWKL8fJI4GDg5nfKrr6V97Brg9gSEh89+oNne/ye40Fh5zcXsN42lk1heWEBG4xUhuW2uFFLdXDfwC29iaW7FlrRDKyppKmiV/tW50xW7TkNdOByDzx8ZOjYqnt/Kzl/t2wZ++wYi8WjP3/zt/KcwXnORKsvLSGCAGhCxm4gRByrfy1puRngnvQ7wO5H/ThYCSkWIs4v5gVRtKjvOylagKhjqh2kW8Rg6fW5wj6h6cDqFezqBTZ5/eKP/u2tllv33r6Q9R3EEYvgcxXK9N0xHUXNAqUZhlp87myim3ucplH8r9U2gT5SrbYb6pgAr1VQWT7HLg+2P7luSyjMjhxVt/z4d4pwZp4wHLKPyI4xnzPm80ZF76gsjCjeCQm1NK/zt4AyH1Xco8CsFAH+OiHhX/GMAl45qvpxxQ7HfNmBzI8CE5M9OHjN7xtR3MN+65UFYptfPLx8BTtzuv8Hz21ZMp/1tPOBmWW91o3qUqq9nlojxLV/1vzLH9D8Ja1uf5t7K3QjrxqxIKQ6ZSLv2Sy7OnzoXzde2bT5DVHcs2hu1wJ/Z8jTFfZ9ElH6ggFYHeHAoUigqzXwSUjpC/lg9YZ8XWEFzsPqblV6QxKsrjCuXv2vUgdeoHREpE/mye1+Vx9cGVC64SYRpTvsaQu42hcv/qkgf7x+ff8rmyb278K6lEoFFE9lilc2lznoqo6lXg5tRthchNEA9806a1FtfAON/7XxlvRB0oxHwvVGLdT2oDmLwNBisSP92U+6WW8P6zzAeg+BXlW79rHudtbdwXo6MIwJq7uLdcHqwJO97bhAJHsOsO42XHCAxx14GS36VPtB1tvN4ObwQbg5eNPgZPX3wJlSX1+8r18dGsQW8lKqrOHwY5oRxdtViIxxJq4PftS0ejNWnQGqzcBab264TVPG65wyzQQ3/VpBRVnGCCkvK0X9WeIjPsp8FFIBu+/LPAtW5uOLceGcaryySIsPNIYLSnz6cW3xdGexehkc06+Foj7QqcQ/UguAl9FNwMvA5c+BT13gkl1QGR2gyYEHsbIZ7husmxzu/+ccMBPJ02Pr2CfO4zBlfXZyhVa5thoGm9MF5emr0rhIOiu8IxD3DE1Ep44kPlcEk25lvROtqrfrhoBq6h9nosL6X+wcvFYKZW5kc3RyZWFtCmVuZG9iago0NCAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0ltYWdlCi9XaWR0aCAyMjYKL0hlaWdodCA0MAovQml0c1BlckNvbXBvbmVudCA4Ci9JbWFnZU1hc2sgZmFsc2UKL0NvbG9yU3BhY2UvRGV2aWNlUkdCCi9GaWx0ZXIvRmxhdGVEZWNvZGUKL05hbWUvSmZJbWFnZTAyNzMKL0xlbmd0aCAxNzUxMAo+PgpzdHJlYW0KeNrtvXd8XNW1P/r3+9x3A7Y0vam5SZreZ9Tc6cS0GDDh0pIbCCQhkEIcEmouNSGkkHBDAgEDxl1uki3ZKpas3jWart7r9Hr2W2ufmZFkzHt/v8/n98nBsUdnztl77e9a67vK3iK+BAkxESYZIiRJCIkRksC/xeH/GfoRQ6KEBOlPGPaTBEkmSZK9E+6L0D8T+Ad8lvlKmH5M2K+sudgP2Jvj7EuZ1G3JtZ+k7mfwYmAsCfgq+60oveLpL6aHif8l8UdMFG+OwwV/ibOfJvGLdHjwJPhR+vMofsr46cAYdu5ManRMAj9KDWDdu5KsKJi0BDIDwn+mHkxvZVCI7KAjqW8movhddjA4ngT9URjFzeCAccyZubDjiK+dZHosJDOm9MXQi84jPWwcOfthahSszOOZWaw+CgeaxNFH2StJogy9SAoLDJU/E0PxskLG26iIUk9OxNn1hedEYyQZZT9k8FYmTGETjsG/QoRZwhtSkouzQoim1mJ1WGuvAAgG35tCKTwwiHKjU03dwz4gs0LJ5Jo1ylzJ9P1pSETXI3Ddtbrsa0aSZGecfvg62SfY6WYEvg7eay6KMBAmopogVhNMGqXJlBri2sGrwkkKBliYlTh8J+SPx9mHJjJTYtJvZzIDXjODNf9eu/DJOPsBvYHiJJp6dzQUAtnBW2IJClsmGQRkskuFixiH9Y3hlVgrjTiFx1qUfk1wmckzKdmxf0mjNGNdkuvxuVa96X2J9BVnUlOKZ0SRmX4a7QBXiuFkyqYh6lgrlAAohelzVuXHIoQdD8Usw76Zxeq1ZutrMwMhBJnYIokH2EVkVZs1jwDHWDQZD8dIDAeSjJNgAAYRjYfjyTiLUiYYZa0ofjejrgmyZqXW4XAdsBNkrcpfZyHY7zNrLEOSSc+XpNG35smZr2duXivp5KrZj8UZdszRcJz9LnwpGkuyXw9Fw9FE7JqBf90EfV35KLLiaasAC4HrG4nGonSosRjoP9gfWKYkRUIilpFbnLVEAGG08+unQ5WUub5KMmS9bDNrzcJqnXjXfy1zf4KsMf5fW6PkdSwMHS+DEGXiqcGvW4swSfrRlILCxfBuFhTJBDUe8XiCQbe41rGukSZz3Zn6mDhAHzxegGo34hGe7A8Tf4iEwiQQJP4g8S2T5SWy4sdreZGEg7C6xL+cDCFo4eFh1tgm0iJKpIRxnTeuk0NahtcYLOZrS5HCJ5O2kRmUMqn5UoGnVi255i3RlE1PqXMo9eow9blo9gAsgRiZ9RE/6CB4sETcF2DRfb31Wac+GSfIXuxo42mURtHaJNg349NiMRRaxE+CPhILE98SCfopk8lIDMVHB7QGpUn6OZOyZv8fQF2HUpK8xsau8QvXWAwmw2GSa9Ab/5pJSUs+BUjWcK3BeZz9bnCFrCzg7AA54KlD8XgkEgfQwizAi4TSfnqNC1470OuilH3FUgQAh/YxHA0kgaKC1i/7Sccg+awy+ubfl371zuzPfzf7qzfnX/kD+ehLUneVjEygtBlc11DQF6LrH1vnB1loXcumWFwl15CoeIrtsJqW+jDz+bW+lf5jzU9ZT5WSKksz2BelLDlrOdnPqUwiVB9ZrWTCIdTHhu7FV//qeeal8J8/J8PTINVYIJhxC9dqOqspaba87qIfUgefsb1pTMBXloPE5iI2D+kdwsvpJf02MjsLBAPYGpVLjFlPUVKaTpeTzne95fw6VV7Lyq5HRK8lBmv+do0yMuT6riLlLVJiYWe9akiT6K0YMmgnnb3EOUr6XKTXTbrtJBwFR0IioKQJsAMgpTi4lIwlT2ZexQLjeiiNpHgFyCGRCJOYn0R8pLen69mD9Xu+c0KqO3njtgsb5Bc5ytN8xSmh8oxMe3yT4dT2O+yvvU3aOsGiQjwQTqN0zZoy11jvtN9kvulKrlrYDA6vY8RY5kl5UcqlZuabNpypezJuhVUiJo6L548ht/GxsgmG5z76/PNt1jNC9QWx9nOBomrfI6TPDZIMgvpnoJ4xO3HWUa9nIBmUUgKDa7jqy0Drw0yS/sg+8vGOOw8ryo+pK84Z955UVnyk39H07vvEF6Q8Gd4JhnQNShOZKa+i9Juo+LXUeM0n8TVcLyPH9SbiOs+59lvXI78skbg2TJiYq3386S9VZUf0u77UbD9lue1Qye3E4UE/AnEjQBToVCwWI2uMfyJFUGNpl3Rdxp2kIg2DoQZ8+pZj//ryrOGmM3xVA1fTKzZ7CyrG8ircUrNNahzKtThkRmeetU2or+JqLipvHnz2NTK3RCO+dTyHrIl0ktdx+6sWdZ2lggVNJjI09Rq5rRca/sdiNePlVy0GwiYFf/jYTxIB+CHQwCjG0PDelVgIOWCX/aR+T0OufiDf0J2r7txmrhSp2w/8iPiiGIN+I5e+jndgSCY3Es9gLGXQ4gkSiRLX5BHFjvZN5d35pe0CjV1ScoavGfzNW8QHLA6lF0zE1wVKmXclqFjSb7km3rwmFL2WnyS/McGSuRiS9hHphEDau606rGujx0xMwcBtKb6XQvtCsPnWAxcEysY8S32OqXlT6cl8E5laIGF/NLDEToS1Eql4PJ6KYjIh/jcRxST7AjDIKz7/h58clmnbZVavtGREYHTydA6e2svRjHC1wzyNl6se5qncGxVTPMuoaHtztuWE+lbiGWNdc8rHrHL+tSzpG+LTa+XLrFKFdXHueoVN0bZUViSTFkj/NIFohNVforzF70eOFPYjnQ6GwCyB7ceALxQJ/PGTEyLVUIFpiLvVISnuF8u7xPrzypuIc/xaDvz1qGm9/WHSKTiM0BOpsaKJSCYTMfrJ4MiFwh2DfL1XbBgXGOa45oYslfe37xBfCOKraDoFmHrouuBlXYB5Xf/+9fzJdVRszU+vFSmilNoH6hRY4kG1OnWxZCwVICQy5iiRQWmMDe7Bjy+Ge3fd38NVOWRmu8jgllkaZQYyOo2EHGCYgLCVAYgurkVpnDDkm6GS8fgsdQ/4yclL57aVXZUZ4fljfP1ottrGV9nEOqdQNyo0TPINYxzNmNTg4ChHeAaXpPxsto68/zmSZGbVSeFrGYYNVUmaw8TXrnWcSf0ZS16TPmX1N5FkVt1BfBWrqVxHRvjRZGKN9sE9kThNk4Fz6bVdvOv7/bd9v//2xwfveMxx++N1tz7U/4cPSCDEsndwxMA/l9/71ymJzp5jGBMohrmFHqFyQGo9XbSL2MdxeOCe4pRqJtlULcNCZt3YEtdaqiiL0nSuI3UD/L3HXbN1u52v8wi0wwL1hNBYw1fbXnkbFAeCuJQHxJzVauTGJqxS3iHFh9ctaIKkHx5L55HZT8PJjLlIxldNVmpg8NhQghVpKMkCI51IwTQnzdTFYjTNmYwQiFIgaGf5FZNMpHI7dAQAXkznxTJJV3jIUtC558HBLLlXiDMdE2pbJBriHYeAMQphOl1ZX5JBfphYE97G14ceX79SCec4mJ22vQ+1i0xDQr2brxnlKMF4unNMHQJFu0TbITV0i/SeLRU9Eo09x2jj6lqFpiu77if2MRIMsrJl1uZpWWkn1rmkRCr6IEmav2KvZDrqCeOVjhHYhFg0BYZklIkn1phb1jqlYwRMlUdAkenfcQ2C5GrHEYmpm29t5+q7uTo7R1d5Y2HT0wfJUgiQAALDdyxHyLnmT/NNXQVWB0c+JdQM55gac61Vew6Q+SjxR9KuFg1LOBlbiQYD8VgKG2sD6nBa0ym/CpDomnVk018M3tA/dqV4r0dodPAUbr4KZHuOU9T3ylskDLFAMpGpDmDaDyMLzIynnxGLxAibjrguSuPpj4IxJhxJEbhkKnhLUDOZ+iS65psJsiZKIxjOxJlVwxsja98F6+KPpfLw6B1SuXE0vJixW00iUZTufcC2sXhEqBnhqycF6naxingmAaWxKAo/U/1JpRTCa3AS+easPt4JkXo0cOzMMY7CLTAN80HZlS6ByiXWDfK1bVJT1TbrOcOuSu32E1vNp8XK1nxrr7T0lEg//cG/0JkCm42ngoboWrvNqjmsUTgObiS+So+p2sLswokM3YytjcojzGpBJ7JKSZPrCSqICwWYWPVBoPt+iI0Sy6S1tSbPOiYs9UjMTpEWxFUn1LQ9/SLxJUg0/SDQ5+lg3wtvfMpT9OSUDmxQNXG1HxQYYmcaMAVArVs0GYkx0WQqeGFp8KrRSpI1pY205woCc2KS0QSzKm0Wpb1jDVt2sigdFqvH+LoargJtaSCcehzcsxKjbjSRMZBRJpWaQF1JXs/jp17NhlxYdAsQ5NyRaCzjp1K+Jpa2XaxIw7Rasy7JzMZ7TAo5a6qKrEFgJ86Goisk6k8G0dgn0yaFhetyePCmB/uyi11iDbgMQGmnSIWmDCwDTC2Sqh6BmQnHEqwFjseiq9408Q1ZfcRDgvjDFx97pjnPOi40jvCViFKxpj9HXyNSu+75PqluIl0DxOYmnf2JDz7ue+iHxworju68h6wsIS5A1dKWZDWBwwqQdZqU6oCBiGA+ghYIErHVFH0sVXLFjHY4nSqM0YxOKqBOJCMhmA21CvEIE0V+Q61unDqBzATZggjmmZoaGzeVujdox3LMIzKtl1NYL5C3/uRFsgJGksokxBouhkwuTr/xQW3FPR0ld3Xe9UTi/GUSiBMf4oquC6VnTDQCtiYZZ0O71RwpcAGaN2BnAfacSiCermmyHI8GcPCubs+FghKXyAjqPypST/A1l3ly56tvY146GE1BAsTFYEEHqGqQiaXUNmVeksk03biWdqagi9m8IImuYIBBzSLDJOKxNLiT6VB5PVlFOVNprs1JJdbYZ/hRIJEIxFnMhzDvSWi4Ho+idYuv47hwx0p04OaHejlypxg8PqK0C1DqnITQHoOF2GoWhpIzLGQnmGgqoxX7RlsaS9Khzq5U3rK/Oc/sFmq9/GJAqZujapbquh97mszMkclpdOsQfYAzBcsZ8PnqGidqLwNhCTKBWCYLnU5OpiqzSE2xSBBjQqGYL5xYSZAgVVQMChMJUKYIs74cuj4OTdBKMXs/BMLBRCxArQuWNKJsvTyRDlVCiJYI6GUySOI+0tBYA3PhGcEdOEXKEYH8sri46zevUV4azdiHKHDUOBZHycwk8TgxqxYF9hJnUoYEiVkq7iaZpGgc5ZCkCW38eZik6t3xVCoXBszQFoYwOP8g0JkIW5kfGK4u3u6UmMCWjvAUMzxt1bc29f36FRRsggowAhwjGozMx1CRwsFkiFmNpFA7YjQfeU3EFIsnKKeIB+MhWreKJpMhVlDx0AqOkBa86GLEwkkAMCYvQoloioXF4plsUigahVVBJxVnYpEEYdaz7kQyHVQl8M94KJJcjiIXWJPYQVsa77/54W4OWDkWpdpOkYaMLIItjYHcMqiLopmORZaTyQAW9uNhVgjXD52oMUMVHvQes97alKMHTXfyCkeEqllZSS1P7fv7J4BJmB8TDWODSTIejgcxNR6lRQA67pRrSStgfBWlDNW5MC59KIixto9G3MsrWNWKso0VMWDkIGqUNq5oIg5iZtJpUbQNfgwPFxdp5StIVgLEF8DvJqlBjkRSkTgrSWx/iOIrmrtqxPqJ3IpBnnKIXzydo7vE29L25LNkyUcWaUGEjVmT1JfABLFQskzC9C8ryyRNjzH/Qct5aNYx4Aqj5/KHkd/Ow6NW8F3wrZiP5pkjGCVGqDqzZTuYdZK6VfjRgLdWu3dArHXyiif4inmRrlGkdL3+Nr4OpgZLAKPyBUkQhrFM/EskHIJoEHUKvovZjCR1P2u8fJoppfLG8KJYBFkuDG+ZJjdWMK+IwgcxwiATYRR4jPaSBGgiDo1bNNXhgu0FcXwjuDO8sAwHyIkvL+Mc8SthshKBEJ7MBfFPeEvCT60HDoItmDMUpQM3PdybrXZBFIPRk75NrCOeORKO0P6fNAGOUmUP+nBgYT8JBMBMpz3vN/HSBOl2fCkv6803Az6dgiKvSDXKNVzOUvne+V9gGkwwGGGtZYh1xOlcejDOkrG1SY9UjhQpGl1Qxyg5XR9977Oln7wz/fjLiz96y//K38mXVbBq+NNIBAtAZF1lDIuJ/gDiAaTd2h/5y6HFn7+9+MPfzTz56vKv/0y+vEAGxxBsfpB/PB4Lp4wM/DcXIm1DpMNF/lHZKi7xCkvsQq1bop2U6ev+M3fiu0+TVhup6yY9DlxNYBHL/vnKGvJVLTl8iRy9hKM6Xkta+kmQKlEwnqrvozOnegEzmvKTE43knUMLz7w59eQrM796K/jhp6S9HcEGcoZRNbeT9kHSMkgae0lzNxkZRyTA6vc5L6h29QpUQKgm+YoxgeosZ/PAb15BLIFNGl4mX9TM//K98R+/7H36xfmX3yfH64hzhqwgcoDwUP+YXJe2TZN3fzyMjAhwtRAlbR7y4enl59+b+8Hr8z99izlfR+YXUA0BaTYHae4lrU7S4iXNTtLlYbqGUMgBP97Q2U06B1E+TSBAD7k6QLqHyOwMOhrQXKdr+dAJ7wtvzf/g1fCP3iZ/+JLU95JlqgK0cJbp+SJLicG9j/RlAUqNTqHOLTY0Sw3EPQMuA0l+krbagGD73eRqL2noQhFd6SDtDtLpCnfZyVL4G4rTtGrvnjhlvaVLrAdW75aobbwiIKg9Iktdxb2kxYY1bhjEYjzVjRdLrlJxbHBjVgs0qcRTHAE2Om978a1Ltz70ZY75JEfbyLVc3Wiuv0F/kWM8lms9ar2j+1e/I+19+PZQNB7wI8GHWYBTAjDM+pLHqmvv/96nW82ncgz1fEPdDaq6LP0lUclRkfErxW77c6+Q+na0GOEAqE0gGQVrvHK6/n393mPqW2o37egVWl1c07DY7OCpIFoZkmpaNhlri8sPb7ac2f84bUUIhK+0vbrV8mVuWaXAclJqOZpr/ZCvvvTQ02ixAaVh1koko2AesfLuW/r82Pk7Hj69qaJqo672Rl0j31zJVx4SF1ftvG3wZ78i0z5ysvYjTcW/i61HtDtPKnf8tcgycfQUYh7sQK+zurh8gK+aEOvdWYUg5Cr+lvmX3iTuyejfjtTc9OhRkblGZL7AVV0W6auFxsN83anS+6Z+/09i96BNjkdo0Ty5mgFjGw8TlP6ADNsGRn75zhnN7Sf4pkt8a/0Gw4Us7b/lZSf2HSAnz5HJ+YYfPPv3wtKTylvObbvp5LY9H2v3HvrOY2R8Gs3+/NLJx5/6m7zkK/n2U0U7Til2fVpcdmjnHcTlIXMz0//4x98t5f/MU5+RGi7dIL/KNZ/i6o/Jd/f+5CC52oGvjsaCkUiUtaWL8cGbHgaUQpzoFupcEsMVQKl3FjNRyTATx7I+qbr6T+Otx9R7ThaVn1JWnFTv/Eq99x15xb9+9CsSSlwfpTD3UIgs+qu+/d2+3IpJnmVIpBmUqoclOrfUUM9TXLXcyfzlEHFNkyX6CoZCM7yaaWEt+ZroN4724V/HLhpuOSNUXxEZenKsA1LroMg4klvuFVm80pIhsbU7v/ysSHOkuCz24RfAisGoxhLoaRA/fV7HgR+fkWiBgbTn6QYLjF4IgqSmfoHWJjG788u7hLo6TnHVFsv8b98l88vgyyIsLTxf9+UW09VN5X0iq1Nk9nB1o1zTpNg6kLXFKVMOSpVdMm1DrvHi7Q8giwCCXdf6uXpnR/52h6h0UFrWm1dxSWzqe+hH6HnjmfJ/HKnd8EjjgUdPbdM1SFROoWGUb4RZ9It08EBbcWlXgfZ0Vt7QbQ+R1z64KtW052nbC3Q9+fqvpPLZQ0eo1waUehqKtrt4Gq9Q4xCr+3M0F3lbmGdejP7g4PkbFQOycpCPK9fcJ9MN5ponN+/p4ZqaxJZTObrzFbeQqmoSWg4vzSB5iyZXc1zozsKoqp+dOK/afT5L3p9f0ZZj7Ssoc+WWOnMsHVtKzos1lbk68tt3Rvd/72KusUVisYlK+iWWS7nai7feR+aA5MTIgu/8g0/AbV05pp48S5tMdzVH3aApI3b35G9fPZ5f1CgutuebPbnmAaHGmWcdyC1tERiaBPoL8gpSXYOmmBZ5cUgLkYGbH4ToySvUDfO1HpGuSaInnlkwJLGkH0mFZ7a2/P56sbVFbBjaVAKGsTO3tD7fesRyKxZSmQS5fsNJAtljMDj3wb/PbNB4+aW9PLUz1wjmFKJjcJfdEl3d5pIq423dTx0MHztP3C5kXFg/YLNPDLa8xtN1JqDtywHH6+8cFis7JQaPzDKVV+oQaIf4quEcg4MjHxeqZ4TaCa7am61yiAxtBWWf5Oh7XnyDzM8iyYmC6+lp3PGdq+AvJCYnXzm62WQTFHp48jG+ZlxsdHPU4wL9MEc9IzX1CdXncg3tTzxL5hdppBUjJ6vObzH2S61jklI7VzUqNMwISiY4BrdIaeNvBb4N07nKV7TuexitE5jHi1ePbymxSaxwDwDPLbFeBUV48BmwDwk2/4BNjFHicF245e6L+cruXDWwykWuZuI/CkcFutH8kgGRujtrq4svn8gzt3Dlzs1lYCqHpaqxAv3gxk0XJPLFTw9TlDKkx9O0bbuXo4GFs4vVNqmuU6RqEmm6pMZJSdnYjRqUCVc+JJR7ZfqB/2vbjKTcxTcOSM1NueqjxUbf4aPoeWOxDAnHfAhErkvBlT/963NBcYdYP51XMSYwuWUWYL8OocbFU4/KzC6R2SGzNnK3dRcYuwUaJ083ydVP8HQ9guLW3fvIjA8tz5z/0n2P14lUAK1Rid4jVrkkCkdxCfPT31Ru1rbzCyelmim+diRbMSxQO/lwaaZkpVM8S4/YcMxUTux28PtJ1sIvhPpveaCbW+wRYSZqRKC7KtKT0UXU9Lgf1MH1wtunb1SPS3aMi03ubKVzg8KRU3JcqCafnACrTlMI10NplBbBICwdm7xsvXcgZ4eNpx+VGJ0COUjbI1TauXKA06DYcoVnPMXV1FjvGPv5/5BLA2QB2TWAA7teMa9OWasvMff2h5+JivsKy/ohcrmx2JWttIu1vUJ5P79wWKqcyVGOcjdPCLZNSdTOLIV90/YjMtOF//ox2oSlOeIeqdx19yW+1sE3e2SmIamum1/kzNVPFZTCdBZk5Z6NGhCRQ6Tty9oGlqdLVnJMYhz46UtkfgW531dnzm42d4qtblGJja8G9g7wm8jSjAnVbkEx4AcM8hWuqvOuJ2icEiFn6k/kmW1i0xhH6+Eb7FJLIzz5oWdgMBHsK4/hCo4tN9z+8GWpDpTCJlRO5hln+YYpjs6VrRniG8BeuXNMbhgSTw3PGQTrwVMOi5UDWZuADFeJihY+O4zcD8hDt+dKIdpSCH7dQu04xzTCtfRwNX1iPdAAeMJCXgmo8JhMB7o5LjN7QAvEloENgJySZpGp0nArqb0KygUMmU1+4+JBwPW/x09IDP2bysHCjwkMwxyNO0sDXxyXWUBJ4Z8jHKPjRvVkrtXJVbm4Oi8sLl8/LNL384o7d9yNLYuI0mDDPY81CClKRVovX+USKrx55h6JtVdaAo6s71tbvTztlMg6zTfDNSE0wvSH+YY+qemwsLDt6Z9hiSSZQunAzQ90cYsdEo1ThChtFWmJaxJ5xeISOXTiC7GqW2gZ45eAWbB9a9ukxFTDV3Y//xJWtDHhkFjtLfxap3EggdlocvzSl2J9m9QK1NfBUYKJ8ErUmILmqsY5mnG+ySOxtgp0F6Smk8V7vAf/QJYCGJMmwymyBP9ffeXIZlOnTO/JNcDXJ0VYxgIX1rvZelWqapIUXeHn98mKhkSFw3n6bq7mLEfleuIgIIHaZ3/Pkz8D8zgoNA9z9cMyc59QZd9sbRapQIBXJYZL/7Gti6935JfZ86zufDNogY1vGdi0+wuBNvbBIXT91Q3AYy8X7GgVmmxSPSz38EbVtMAAyAED5RQbu0TG0zzl5X2PoExWQqSm/WLR9kGJYYSrAVQAShuEmjRKEwwoni88e/APx28oBJoBKwgP6d9Q6NqodostrRLzRZHutFhdI9b1SMxOiWUkfwfQDFZuILRxifacAFB6BFEaQpSCx7cL1C4xvEs7lW0audEwkVvWw1c6t1g7c7RAFS5s3FyTvbVJrBoqMDskOjRZkpJxjmVUsuPsDeqWe39AxiZIPBROxqJsVN49eFq+e7BgJ5gRcDTOG4snRSavwNgv0NdsLKoTarpFeofQMiIqHeZqR3labMbg6r1CPQQ1A1xF5/a7yGwAy6mzwSt3P9YoUiNKeeoRwDNP6RHp7fyyAWFZp8zckWdu4KsBsQ6+1b3RALYCwpYhjhK8f8/WMpA56XKlagQUpR284gGZBlwGeJwOoZa4Z5HUddtOqcvbcozDstLhbMMYz+gWGNr4yta99yE9TmBv+jdVSFk6GWJoj+5KIHroZGXhjiaubjKnAkbiyNE58rTgAoYFco9QPsQvtkm0jvySPlHJea6u9pYDpMeGXa9x2rK5GD926/1NBSYwCAP/kTMtVo0LlX1ZRW1Sy5Gs4oE7Hxt84KmOux6q0pRXC9StBdvPSEo77/8pmVjBLId/JXa2+kiOpkfK+nqNAwAsNTeLtdUFpsu77u5+6KmhA0/XG265IjV38HSdPPypg2P0iMu7xdY6651kdCpW1/B7667j1n2N6tt6co1jUoAfxNRaG0/en6NvzrO2mu88otld/cRPyEoYs/c1Xcck2n6JYZgHlgGovqkZdOqBp7AnCmAAAWx988nNJQO55f0iDdD1IYEa8DCat6NRaDqu3n31+892H3y57qH/blLfUr9R056t9+SUDwJKgdiIdGNi3TmRfA5QCsaKorS+uGKIohRsKRg6Nw5Mac831QuLTudrL995wP3C6/bnXqreedfRrM3AB8BlYKmar/dkwTQrTnF1cx9+hvlViKQgqF/xd//ylfMSw4DQ0M9TeMVa8OMwi16ZqXZrScO3DwwffKV+910N+WVtPL1davKK9R5QRqqPLrSlivYKQGkQWc18sP7uR+vFSjCk01zNDE8L4weNGxDvuiwuO1Vc1vmdR9vueazacNsFWWmXpMzJ0U4A+5Loh2CEUuNpid7xh09waxzAYDHAorQvVzco0QJKO/l6MjAJTr9l/xM1Ui0wW9T3bNW00NQjNJ7YaiVnL5FwOIap9XQx93oo9UdiqbIsOPClFVLX2X3nE+d5mnqO+opMB/HLgETlEqtGZGrgAOALbDcUzootQHguy4xnd99FXF76FEK+qj1RXNEjUw3zts5JwA6ovRJlR66uqexucqKJ2OfI+AoSoR7X8LOv/62grOWxl8gUgysI1sbnq3/8qRqBHMiGV2Yc4CpHc0vbJcYqxQ7y0WEysUCmF/G7HfbIwd9XF5h7t1SAhx0WW23fUgKvq8wuGv3Th0hubQ5M4Hx0CiySfePWEaEKsDqcb7mUXTTzyHOkeZB0DWHUHI5h9u9c87ltZX05YPARzG6xqZWncux/ClNDYE19y10//eXlXBNQIHB/Tql+UKCGwOE0Tz379MsQ4pElP5mbA65FurwzTxyszyvvlpUMSYywNK4NRbDi56Xq2UPHMiitk1fYhCxKkd1BcAqCvSQqGrj7u+RiI5BDfO9ciEz7yQefXtJs75BpwHp7uOopgXGCY2rhGc7uugfNTpimZHvtx0w3t+WWAO0fLTDbRWAA1X055su6PeTjw1iIWVmCoI8cPt9c8u16iNdEGrgT1V+gdUj0vXyK0pkgBsILwcv3PFovVcGYp7JUs1zMc3YLDFWyCvejv0aJzcyTmWWg1lMv/OFkXmmf2OjYUAzLhOom0F3iay4//guyQqveSwHgpWtR2sPTkoE58vL7p8SKvnyzja9yCBUQIAxy1Oe4yqU//JMsg43ys63+yW/qicq0pqDXjmJSOhACmpf4vLLrkZ8c3mwBp9abb3XJjCDYYZ5qChvPtO5suUugGpIZjvKK+l54jfiSZIGZff7diyKtMx+o4yYPv3CAs61NIm+uuJ3YvCAHLEpGaLtOOE788eFzjWTER1Zo2QgoZWf/MeMOMCBLBWX9N2zz5lnaOZoGzU2kpRujhkAAHVyEpqOXfaGPDp2W6YZyyzw5peA1vFz1FbHq/HcewfQ1KJo/Qep6WjaZpyD6E8n7uUVOsb5WrLE/fZDuHPGTKFupSpCatuNbTB15EGsoICD1ig3tPLVn/w/JYhTNqd1zoeLWqxK0PACAIY5iJL/sFE8x8fp7SIOBEy7QHCk4gqVlwOroj35zIqvIuXX7uMgwI7UMbig6LVbOfUZRGiQZlEJYAWwf3E0vp7AzX9dx6z3E1o/EyR/BVcCNBHHQWXKu6txmXb9QNSrQjHNUQF08W3Z8JdOS83UksERWFpg/fXZKoLPllg1DEMFVDPCKe6T6y5rdpKOHFmKCmMaPYaGQNLbUm24CGgYsCKwfgGcwR98pBJTuI5M+1KCF4IXvPHpZpgKlHs1STHG0IzzdZYG25eHnyCxAyEeWZmljZ4hMLPY990o1XwHM2Z5dPCkzgj525lov7/sBmaRB4gqg9MEOnnxABkEiorQXUPq3ypYcA7wXgk17rq5/k7ajQHNZpLE/+CPM8QIeYtiiE/J/o8dfbZaIJmm5N8EkYxhLBjBpSa70BV7/oPWmh4AuAs+x55VClA3UBfiqW4plne7Nli8Ky4ifIXPR/tufaM6WO2WKkZxiiIXt+eazuQpy8jysYzyKIWAwzraf0I1p4XT1P0Z/cPjMsTytK9/ioU1fwDxrhDry1y/Jii8S8qUKvGy1ILxClpdHH/9FHUcD4aEtWz4tMzTxC0+V30piMFHavHGps0aiGuYXO0Sg8lonV12fY+qEIGvJB2qYSISxsAcirW07VmRpy9cOiRUeAbBNRKn7/h9hZhjeeeHK6QJdf64JXCQYNK/U1MHXdO65H0vGMax0pFtiaOknFiauiaad9zQJgPtpQXEg4jvBL1qD0uG64u3g8VmUurkK8PXnclQon8gy3VbMNmxiAxhibGV55umDzSLNeK5lHKJ1gQZ8ZZVQ7XvtPRKcJ/7FySd+dSVL58wpcfDQBnoLSqpFKua9fwCoooEldmi0XoxlNeYPfwf6AXOxiXU2KWDb0C2Ut5d/m0z4sGq9EKy+7xFAKdDpYY5yQggs11QtM4BXxXQoTC0ZjuKWI9rN2D10YYsFDKl9Y+EwTzGVY7gq1p623kvGIhgkLgd6b3mwiysfkuixz0egGwDR6ff1cxRws5NX6MnTtEiLardqz5j2kg4n7p2IJtft2/qGnigmvT8rU+3Hxl2AEtg9TKYFsZ24rq3rsedO5Zqd4jLb/73NlacbKlD1CrYMbTae52uxROKZbLLu6xWonFK5R1Q8ItC3Co01e/aR2UUIRtgdTVhLxoRCOAH8gMFuw2QAy39kMRh/5x/gtR2gmzy1S2Joy7NU6W8mQ+OoLGyzeKZNLpnAUOvjE1V5FrvMClZ9WFhs22o6IS8B+o0bDGF5GvpqcvXApd2iYpD8JFcPkO547hXajxehdUHaanKx9WihtXWTblCscGDmX9fMV6GCw3SAtX58pFKiBEYHsTNwSAiyzm8oSrz8Z8xPxmn4n+oqpDWXSIQsLjt//EswESOUH0L0d0qsWvzsON4Jw+4duVxUgRk5GkQD8gHPV+98mEwuYFoMjEM8tQMmxna1QGRa3XYuz9orMg2LDE6B3JlvuJi1zfm9Z0longQWu3c/1MMxenPL7Hxgm+ousfa8fg8ZGkbiyqxpTUN5B0lXb5VhV4tENyTQgbt3QeDAK+wqu4NMrWAifT5Yc88j4PGB16ESiXQuvr5BvZeMzLD9IOjIMgn2mRWgCsiEhahuQOqapZrq8v3E7cNHLQX6MMZXgmPC5joRxLBqTIYIdR6efEZQ7OZsHiowfZWrjh6pRBUIRq6tqv8flP4flP7/FKWrHXfJ9HYk6sqYVKmTrcPh+s4FV974EMLbMUlpN7cQUGrLKbIX6K5wNEiA3WOXlbuHBBqHqAhGPswxX+EZe7/3HDrZUBjfTDMVoQjwZFgUfzK6RDcrMElYo5Xw8sF3a6ijxy4msbFOqGu+8xGsOeKOzigr8+QS2/eFu+pIQy+bRAL64eFuG8jVHpZqAP5YX4CbGweq8/QeIeYlxoTqGY6+fhWlMex0pJ2g5EIbxJgd+bohilJwhVeAbB94GklpMB547x8nRYBSi5ejwWLflvK6PDP5x1Gk+uD+qHtiu5lC2IwBs1iKfvivOpkeIOoV6oEhnBAqrkEplmspSqdyyy9kKxsfeAqNQCSOfc7YV59MNSnDA4FdNwxd1n27N68CcAjM2S5T13PlXhApoHR+aujmx3s3GAe5IC79qMwMI2+8/QCZXIKnxWmvfsJH8C/IkcJkerr2tnuvSgwerg4MyIhYN8gt7IKQYWYJbcZ88PLdjzRIVJjPF2NG1yEAinszGZ/DZiS2HT/TSj3jb9t+FwRfGAaK5G6p4kqO6vz2/cQDHDhBFkJ9Nx0AlIJmobZSSj8ptbgE2hGhZvyGggWJqn3DtuCTL2K7DgwMLrYNAPWT7UFjrt9tgoV4WLgYbaYKYCcTzVwlA3R4wfTGAzCwc/6Osv02kcUOyiJSOCSFECtd3lCExtY10qy5eSBbNQKLDuyaV9acbWm7/0kyvUDbJtObAgBFkQBhwvHgIhrxKD3oZsm/9MqfzkmNHVKDU2oYkZRcFRnrd+0nUz7sF2JWt0Lgdo1gACFxse1cjgkC6pFsxZRACVHGyRwTCSZSx75cGThbYGR79iYFaEsvczWdP30F4/oY7TRmU2dVbZVbrN05WhdEnUI1UClqSylKQ/Ho/x46KtMM5pV5BUYIoAZyTEALyZ8/JUsLoC0gonA0memIRn1enFt5/4MqnhzsJNYHc0xnJKqlDEr7RuqKKpxc5JBuvsqWrbgs0vU88RyG9r4Adt8FKVnG1lfa+wShRPtIVfGeRoHOJTOA4tslysucYuejz4IhJXPztpue6Nlg9kixemKXGloLzLUQs48sYsMGzC+E5gaNfDiG8d3o2Kldt7VKzGNZBtDZSYG2n1/YsvN2Mr+EqzMXrrvr0SYxRk8jmNvXAErr1TeT0YV1R6KwqzDp7yi/p4evHJJq7JIUSit33ocNM4DS+VDPzQc6uMpRIRgQRKldoB4AtMiME2L9PFc5y1PbNih7Su5Fs4+HveAGIrZnHJv50xtcrrnogTEMdqJCdLwSIN5R7DUKRjGjiCEn2w1KEsv+mB/CFr9r3/fbboAQzwIGfEiwzZanucxTol5MzPXteKAzS+ndZBwSKkd5pV3CsjPGW4l7kh5AEUsdmYLtBIlUzI4nXSSwAyEYDr7/72MSff+mUsD50EaNc9OuC/Id5EIzBErJWIQdajhIz3+Ccc7Okbf+cYGvAXcMHn9aoIGg4JxiD6G9rjjRpoEzm0xgHrEBSaAd5esvCNSI0uVIqr8uTvcxVrWd3mztl+qA2EP0BEyjlady3v9Daktj5GT1l/n63vxS7D0QGwbE+kt81ej3nicLi1jJpWeRhJKJCOt/5mbg885Hf1AvVo9KjG6+ZkRsOCtUpFAKE+/z1heWZ1A6lmNskWmPKreTXg/ekExtE0vVlcBKzIfIP8+e5KgHNpcAHkCPnLlGUJORZ1/CsH3Zb7vzh92CCrekFMZmF2raZJrKTSZyuRMGH13CamCUPV4KRA3urKb+uKKkR2SazDLOZesn+fpOUWH9ntvJwhJ6zXlEabNINSZQTcDY+Brw+GhLRxZSHctMegMIQGICUdrFV9tkiFKvRNEsU57cfR8ZSaG0+5bvQhA6LDSN8rQw2UGBCmZqk4D317o3FsOHbp4R/Gbzoz+h/Rs4ymg8ykbu1FQy182XBmJhJHMBPzlVf1i91/38a6TPgzXEaJg2CYewlg2aHvSTrsFW+e6hbLVHYrSLVOAoe/P0F2VGMh8gC2HPAz+p5yh7pSpPrsHOM/XJyr4SKId/+RrmFUGjg/GkP5bilnAtR9GyRWlrcThKqltOba5wysqmeAawXQ6ZtXaDfOyJn5OVRbDmvgSYgwTYX6zkxn1kbLTOfFurAMJVMJjaMa6qW6Kr2nkvqAO7Z4ppHqhMoVQ9JtSCJTwnUrc//xLmUhClFMwBAsTv9OZSm9gwzmHzpYYOLs1ELVOUtg2c0e/tyClxcQ2YCZcYBqTGS/IK0tyGo4r42H0XibAPq29+PzlyurKoBNzBsMQAPn1cZDjPl6dRyqxFqRfcJWcb8kyxOvTb98iin264YMA+R9mTamDtJpd7dhzoFZuBXIF7cvCLBzZZv8zVxT4+QtlFePFn713iWhwc45zYPMyV22lXwMhjz5O5ZWoBErSbNIDpgsXloYefbsDKvnk82zjN1XvF+mZpce1Nd9LKMsT40Ut3Pw4oneSpZriKSZ4GHPRlDfDShSR1xyE2IGCp4+RKe/l9XXwtVsdEymGK0uOA0tFltGnzkU5AqUDjFptApAD4HpGavPR+bfZmAKo7r8QhNtuF+qFNZWdFuqXf/BFbmPywEuCYAghU5vqZKB+bCEiEyPzy0J3fr75BdYKnOmO8ueeXL5HL9WR6Dnt9Z8FUzpO65rrb9jfywZhjksEh0jolmr588xc8ORofXzT8+49PiFRduVrwTV6RySYw9W/b9blIOf/7v2H5cjmIt4Ejmw2RDu9H+59arKyH12NPeyhMJgMXdjzQIzSObVACkxnOtcB0qmV6+0uvk/lp7F8CngBqMj1LbEMX9z9cI9WCuwdeOiTSwniqs4r6n38VzwlJUC7e1He2wASDBAIPP4VwoEqobH/+N+gsIiFEKbup5ELHqS2ldpFhEqvSWsDhKkoBNrNLVw88eYmPug/EDwIf0M06vuJc2W2kuYMs09QrSHh5Gf9ec6Wh/O5LQm2PGAvxoB0zItNFHrWl4eug1C0ohiUGv3mxwAwEmMytsDSDton6yejswPd+1igEAmkczTP0ZG32SA1XZLpPtRXY9gkRhz9KzrR8IdIPykqGs+QTvOJpKVotkNjoK+8iy/LRvtB5sPDLjoOvnRYoXVKrl2scyzZO8IzY9ilRXL7pLjLrp1n9aPW9j18RoyGd5ingT4dAe0m7l7Wl8fShgDH2lIXplZaK/T08kCrEp8pRcdqWAkrBSCxG2m/7botQ45SYvDzNBF+DO0qGpv0//OVJ3tbBoh19YqRPQxylXWSpFOrJVxdx4gns9MKNft+QL6X76JPgFHwffV4lNkAI7926s1Wqr5Xoj0pUDXvu7dj3qOfu7w9uv6+6wHAlVwveB8aGIQBPMybU90iNp1V7MEMOxrbffnrvvqubtA7utkmRfiRLPSYwdfH1F3ONHbfcT/7yMTl2nhw+M/+LN2uVt1TmlHyxpTz5yQm04cD0VmJjb31YuWHLpAwgYejfsBUdWUHJSU6R7Z4nyJ//TY5dIF9UkV//sVmztykHE9RA8gGiQ0I9oOtyYRmpbcbQGHvRIcbvuUjznG4hhpljfB3Qku6f/hpbCgHtcdw8h6Kv6Ti+tXwQu00wPhqSmVr4ascDP8TYEwhu1Df9r39XiSHgNY4VlNgECpi1R2ZqBawW71w8+A64HlLVSiobl3/2ZtXm7a1Zhsnc3W6ZBSgu2JAZjqaWI/86SuEhLoEKeNogVwEydOVaQYO8Dz1Djl6EkBCbtP/3aJP1zuYcE7hdxw1FDiHu5AUrVC3VtfzoF1jqCtMMw9RK1X2P1+TrBoXFE+KiMd4WN7fQlmu8KNIN7ftv8sEh0tRJPvrCfsfjFwV6++byQZ7GwzcNc40jPAMArFOoaNl5N5kJobYuxs/f9/hlmQq734UK+HNIpKlFlM6tbvVNbcWA+GipaQeidIKnn+KowZY25iqRl45QlC6FW27/ryaRDmuyPM04T90t0JDBSTI1f/qu/WfFchsKRzcD5khgahPqL6r3ktZBgF+S/L/mSwHFEPmOzJ/ecXez0OjlGMZEBtwzLjHYc4z1/OIrQnWPUN/2n1tduWa7GAKN4mGxEjwaRLKj4pKLPLXj2ZeZCD39MBzsfeV3x0WFw/kWd7ZymqubztZNCMwDfFWbRFUt2lZdoDwlK6oSyUGhPHk7WySWI5st0eNn6DaTAHGM1ppu6pBpOjlF4JLAYzo3KEalViA5p/nFZ6XaS3xN8waFg6t33CiHKBVo+SBfC76jSqAY/K8fkcUAtqwn6UlEjR01OSYYIUWpFjS6jleURmkINDdKz8AktR1Ht5X3gY8GOipSD8kMbXy18/5nwFJF2bhxcb6+4t52sRlCJ5dEjxlvLghZ38fRXJLoz+UaaraW1+ajEHrFVqDikzyLjavySHUQz45lqy8J1YuHjqJZBo7Y564vxOjJi211KhtYG6FuhKtxbZAD8lsg+pOoTheXV24tOcGXd0ghytZ6s1WzMiuYHZR/jvXEtgpS3Uh7qiN4/EUwvPDZkU9l8t4Cg1tUPMrdCuYU1gXrvFzNOYnqTJH5uKi4g2cYFpYASYMFxfwYvQClvTx1x/Z7yUwANWg5eP47WCEFfEJQ7BKrBsTai7rdZHQqdSZQ+lQ9pEqLS1d23tfL007ydNMc9PiNOaozbPQExmo52EptqV2GdecJrhIYLBmawtPw+nqqLHtaRepxsWkiSz0lMIBRbeApOr79MLIUCF7Y7cPXdfqgmAuB4d/+8QuB1p27Y5JrBPx7+cUOsXxIpnBIFcg9BGrwm26JHpjeMM5F4eAoPdKSFp7pou5O4pkOY20ygiW5qfm63fsbxMZBoXlcVDIuNGNHJRd7qj15usFcZU+Bsn+T2i7TOsV6h9DULDF/vq00eugkMvwV7OY9JJb3bt2J3YM3qOf5Ri9X7ZJq+3I1PTIV/GVKapwR6kezYAByMKF2qaUux3y49FYy6AGWy0TY3amhWEN9zSbLiEDv5irGJeqh7C2Xc5Udzx/ELoUwCsLP7ratbjm+paQv3zjE3eoSFo3k6ruztZ67wONjSRlpcCRMzjZ+ItX3FO62C4xTfP1MlmKaI5/gK7wStUOiGRRr+kWaQYnOITPaIWKSmuxcOdB1m1A5lmM5xS2e/eRz7LiO+YnN3rC5bISn82KBu9iJxEAzItBhP6pAbRdg20m7VNVVoO/M0QzkagfFqiG+AkKwYZGhT2Y9LDKM/fqPuOEoGvUHl1HHQkEy5x969LnTHLkDyHO2ysNRTIi1ToHcJVX3SuR9BTqYmlNs9ILdA+YgUA1ziyCcRFfFUQAf695xP/GME5jmytzZe/a3yXQQVQG0gHB2i7SXzDeT4WG6eTqW2ofGNt3OLV7ZsW9ArPFu3DojKB4WyJulGorSJRr0zdtu/24Xp2hQWDiWox7nKXslRuzfAM4WWiGHTx2WaftzSsCQujYUTUh1bon2HG/r+MFXyfgkUOh4MpLKTVxzRSNkcuZv5lurivcMyMqdG7VgxFx8+ZCwaIC/xcMrmhFr5sRG0HqwEhBL9mcXAlpsOeam/NLjWyvIqUbgFQHCrMAkYiHcedflPKm96VJBaYfE0gdqKzROCA0Q4Hiyt4FLckiKITC0ixQ27MO0DhbsPFe485Ndd5OpadyoNTc389afPpNAxFoymbNjVmh1ZSnQyokVw3l6iBHc39oyw9NOiU0A8r48a53M+M9cLalrwaRE5pAWEky2XDkj0w1z9eMC/aRYOyJUVAm3tj77AjbsBVEOvjjdi1TbebzA0pGrc4rlTkEhvKiba/De9xOyGMOdzYSJLMyT5fDinz/9WKhuzysd4mH/9sTGwilu8Ti/2MsrGgXLIDMCqRjgKm0F1qaNW0byLCO5RrDzHqG5Jsfi+/QrnBdEfINDV7btdm3UekQaUHxght0b5b1iTUvWVrfUANgYF2gBsYBMQLhLpgNRA6/GUzuEamD7nU++SOaw/yE6P08Pn4T/hYgvRAbH6vY+dEFq6Zfi4QOTUrOdU+jiF4FuerGrSgcfDueWtG/Y1s8r9vDkgFIgJA6B3sYx95Q/CJDDEurKXNXd+5txaphN9cgsPSLTec0uilKssrOnl9Bt3cBLF69W3N3LU47z5CAHeGB7vvVU+b1kdAXPjVnx2/Y+0LuhyC1VugSFwJk7hQbiniehAB6Ru+x3/PqN0xK9XVY6kWOBkH8EQJVvPipSkI+/IrPTmDy53mGtaGcjQdLSe7Tinqrcsla+cUhsHcmDKRtH4eJph29UDt+oBj7jEluGJObpLTvbuKpTQuVJCCLae+iGyvBSIurHbb4xLHwAz+zqr9738Fc5hua8kgGReZhnmgAiwcGTplwC7Mnx8A1j0opBYUnlBvVx6z7SZQe2EIssk6SPLM8u/fWfh7eWNoot7Teqx/K3gzXo46uGBBoMJYQmiGUwSSi1VvKV53bdRRpaSMgf8y2n22biyDybWqtzS8YF5ZNc8/hG9YKkBCKRwZ+/jhElxCZsgWMpTC50n96yvaegzJsDsMeMQX22zvHg81h7StITRdgjp5aDs+//47Ntlis5Zk+OlTYbqyGYGhRp4SvgEUA4doH5glCz9O3v2yRmmOy8oHSKV1HDMUY/OobZEqAZNlej4tZhGBLfNCUwT0oqekQW58797aabm6U6YNcz2cbJGzQ4QXCFG9VjPPOsdMeV/5Qfz9e1PfNzTGzCeIJh9qjqGN1/i2d4hsPEOVpz+38dF2r78soHOdrp/DJXthKs9OCGYpfQOii0XryhaGjHPa4ddw8IdRMi0yjfOCPd4bjR2ms+QBZDGL0uLV+6+5EOUcmicOeksMwpsPRJSuvN+4h3DPh5hIlHMicDgFOe9HXtONCXpV2QWuf5+lGhoa2g/KuSe8h4iPhjYO374KcbNLObyiHGn8R+/jIyNIc1xIAP7bbf13jf987y0BeDHCZEFofA2Juz/eSm7eRqHz2a4DpOf5rg7jZ8yMQK+eDwlb0HvhRrK0Xqar6qWWjoE1ltohKbuKxHVtaQU3JeojvJlTeXfHvqxbfI2AwJrjAhJDZsGEgPfEngSHyLZHbZ+/K7R/V7T8j0F7LUXSKLPXd7n6SkVWIGo9QkNp28QX5h227/wffJ6BJZxkPG6HkLYRJfwSTe+camOx6pUe45zlVCONBSUNois1zh69qk1qac0q82yiuLKuw/fIH0DBI/qPAKeyxCmurHAw1N/y4oqd6oqd2orN2guCIwfLShsOrJn5O5AJLwED2jOJAgF7v+LNaclOnP8YovSjRAEj7hKOoe/DF4h0gIm8+ZODUkGMj7SVXdhZv2H5NoAY0wmNZNZQ15llqZEa5GqbU6v5R8dIIcr/uSq8SOxyxNXZb+XxuV0x98gfE4PGfA9c/Cned5pgs3FDcJ9Oc3qr/ka6Z+8Rq50n2p/M7qPFMzRzcoLmmTWoCu9+aUN3MM1d9Stpi+7fvzRwRMeiK6GFiiWTYmFIEJMMvYBZLA878BqJOLk6+8d0qx67xIfylb2ZNjbearBrbuqBGaKnOstvueIrbRxu88dphTWMvTVG2U1/AMZ/9TW1t2AFsiwZkuLB+/59EvNiovbdDW8HRnOGCFjJ9qduMSJ9DPx9YeSDUXPLl9/7GNCghIL27Yeo4j/0Jm/Mf27xDPEiYC5kI1ex46uaG4Vqw5n1V4ga/7SmwmY0HcG45Vvzg2Cw16T5d9+xhHcXFDcYPYcJ6jrhJZ/y0r/cue/dEeJ4QVuN9z/ZU6QTkSQfrqx82/yUsNPS+9UXv/986V7juzbWf11l1V8r2nDbdevOO7V5963nfoMHE6US+iwVjQt3rYZuo3QcTpwUdRZHRgVEdH5z/5ovHAD8+Ybj8r33O6aNdx9Z6j1ttq9n9/7O0P0ITO+3BbEERPuL0rGcCzRaMo/vkFCGaTlRe6fvFy5R0PHjbuPabaVanaW2m4tfqOh71v/oV0D2B7W9CP9CyRCAfDbNo5EcND9X0jw22v/d5z8G3Pb94GZbH/9q0rB193VlYjvcfiVzQepFuD22xnvvfTusefaXj4ycsP/Xf9Y8+cfejJjnc/INhwyyQzPg6MmC9AsepbPHyi/gfPHd951xeqnTCYY5bbju/9jvuNP+IJust+prW7+YXXnC+96Xzxf4Zf+kP3y7/3t3QDAQa5R+cXrrz5V9vL7zl+/Tv3i294X/1jywuvL1aexdzaxMzMX/7Z+NCTn5tuOqTb/aXxpiOm2y7teyz618+Ja4yaoEA0sMKe2YjH+6w9AoQ9SxMEPjdHem3Db7x/6fbvntXfUqndfVhR3vzYc6EjZzEfu7TgPXas/ZcvD7/4tvPld4Zeemfw4Dvuv3wOIQk9nzne/eGnvS+86f3V2/aX3+5/6U3by++2/+49DGpi6fJopskjHG/72787X3138OX/GfrNy86X3uh5+e3W9z8mS7Qw4Y87P/i37cU3hl7+n8FX3+h/9e3Wl97GfU9RJoYoZRJgmAPBaF1T18HfDb/0tutXr9teeN35P3/ueOX98y++O1bbAkbv6yjFzD97uhd7JHw0jHv5wXEv+YlzgrQ5SIsDd7j3DYPCYoATxiOgGSYcwLQ2LmUkmT6JK5H+pRT0zJwk3BlawjMB4FHji/iENjvWCzyTWFEFThWmdiB9HHecoWcxMdH0wSBhtCE+P5mex1OFu5zYw9w/goVvoBkri1gFjAbpiQeYKEnQbWvw8hW2aAnhGL4lSHPgK3TjeQjofZIlWazZD8XxntkFerOPnrQQxMw//iIGCMXoISfBSOrgxEQcT2sH7YNnjs2R9iHcdG8fw2RygPp0zMTiKbKIK3YL/MIyPfqYtuUx9NwDXwQ/h/EsB2i0Hk6dMrFCB+AZI/0u0tZHRuZxmuDlQRMZWnOhnHs5FEwdsJc5yg91LhZO0l8JAuQERgLj6feQjn7S1ktlFUKtB6mG6DEXy8HUcRbgPVdw1xr14/SoavjnMq3dhOhh4yAHX3jNkWrsOca0yh6hhRg8ZGMRT9uABy5FUmUzLOrROaZOhKADCDGJQIQt1aEkAF14dCc9AB9m7aOvC8JaxLFsHb/ub3+AeIKeKBtNpE5ijiWx2ATWNUaPvwCzE2ARhXElg4eVxPzJUJye7cNE6OmnMfYAj/TpDUlCz3Kh2o9nbrBwiqTO0EBjSw+8jSUyB0guhyNrzlllUqdmxukwgjTtD6sfonnvED2gI8mekJwI4W+mQbvO2lImdRARFWOQttwn4klqb8m63zhCj9CJ0vFE6TF3cCdbt8V26xD7e4TCEQRqJJqWT5w2CAFKw/HUxY4Kz8SL49GcMH081SeEVxiVgp7jseZIDVCEKD1jJEEZL8gBZpeIp8QSpqdV4JEmaHDwc9B3elpOJBZhT9bA8wbZX2YUSp8zll7WRDAUA/wjS6FnevsWkErF06ccoQZhTZ+BEAB7pGPrfpUGe2YUwAY7AGi5HBadhcSaA6noEZHpdYoEmDCo7QobzJFQ5sAoeqZNcIlWvmjjBG3kYLGRCNGzylFutGAXpYaRoSerhNK/+OBrKP1/AIx8uB4KZW5kc3RyZWFtCmVuZG9iago0NSAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0ltYWdlCi9XaWR0aCAxOTEKL0hlaWdodCA1MAovQml0c1BlckNvbXBvbmVudCA4Ci9JbWFnZU1hc2sgZmFsc2UKL0NvbG9yU3BhY2UgNDYgMCBSCi9GaWx0ZXIvRmxhdGVEZWNvZGUKL05hbWUvSmZJbWFnZTAyNzQKL0xlbmd0aCA4MTEKPj4Kc3RyZWFtCnja7VjJciMhDO0b/JquuvJpXPWNcOwgFiGWduLMTKUyxavEdmOQHlrB931wcHBwcHBwcHBw8C5CCL+TtyHvEBHSv6do/6rsf03eeLhGAFlxSNLPXlk8EwZi4YF2qF4dl4dP14n2wqAK2VkHhbTeBeWvkjsAslv4zSm3eB4y+hGNkuoAqHyKvByyFAp9cvZ0eXFGBhWScKrqoZIAs7C3nbFH7QGX6M9euaJ4LD+iiMlLlXTMAtK8UQT1yeNwWAfj7R/VC6h/aUYJZkP/avZ3bY6mr8SnZ584xXm929LnhRv69N/T7wpgkmAzfR8FLM2X5OLYAR09qINDgse0pOLYL7bw5UuMJOAZaaf9oXwymb6ax0MLfA9AmHbK9PWK9IhB2BqnzI/auo1+8V5sBcO0BMGyi1t5sskJ2ibENv0MEVogdPqQiwyrjyN94FKWrYr1daSv9ueKZ/X+sWxwou//iH4yCyXPonBAqgbL9K1hWP4T0ShWbHqZUckHsELf1aJyD/UqFxkXbAa/YR58oF/nMV613Zh4pOAyVmnbpG5sLFx9R6FPOp8zfSgFYDK/3aSuux/o6166ZW6NR25YaXPcRbwJ0vlW+iDBmlMaxPyZftMXO30IS6KZlT7Yb9I3rsVsie1sCvNsfSMt61ILG/1Wx+g962OPi/fo+33jo06fjCBWL+O6o0pfCj2p2FenGSuxj0UkqV4StrHf1ZsX7HPu4NTcN4UTStnhUl5Lf9GGbU13jS97sS8rD447fKfyhDDlDkwRsa/7mKO7niKxpypNESd1X7JsU/ftVFvfKpxuiYDF+mRa082edkO178VH6AcRI123HSV11/U6vvEFfRMVptoZGv9SIHaxv6QujuZyYlCaYtItyacizQ8BRV9J3d2ZJ3abtOAB/1x5aDK+mH+gX/Q63dIlH9R5rjjLDOFjtfgvHJhvGz3We0Cq+4647jfZ+Z7RwRcSd/GtIej05wEHQ3+NaXahGkiEoLftLqMPDXRBZxxSSZAeRqN66Men7QVtuY2FEds7W/lmHtbPevm9kRHmyQ/qf/iXhN/5M8bBwcHBwcHBwQ/hA+x+cHwKZW5kc3RyZWFtCmVuZG9iago0NiAwIG9iagpbCi9JbmRleGVkL0RldmljZVJHQiAyNTUgNDcgMCBSCl0KZW5kb2JqCjQ3IDAgb2JqCjw8Ci9GaWx0ZXIvRmxhdGVEZWNvZGUKL0xlbmd0aCAzNzYKPj4Kc3RyZWFtCnjaHVK7rRgxDOMoHIWjaBSNwiLIHKwzQwqN8PoUF8kGDmcIsvgTgMZ9/X79btnzN7///IgoogkTIYaAQEFCCS1YiDACCiyoUIUuuJDC1E1mQ416EG6kMYtl0JBRRhs2YoyBgIGCCjpwkGACDDjQoAY98CCDmeW8HJfOIi/Iztun23UsSYkqqilToeZR3/KeklqyFGmeHtZVq9Qll1KaJ5J9rdXqlltpzVNO3/uy2rIVa54dzA2tqCNHieZ5xDmkGvXIo4zmjFt3d9x6dub7RK++c4087GI32+yw51nJI74cl84iL8jOO39Zx7Kqu9rVqZ5nOq9xa3e84XbPS4I+PeWr2h33vHiYE1m5VmeXoedlxjnlNffe05meC3L3YuVt2tu0GW5cm8ylSJ4XxZtoJsy8aHmWr7sH47Nnnbi8Weda1WG7ksq8JeBJXDVHyEdnkW8z6PO3fCztxJm3LryR+/qob/n792P/Wu3fLsuH7/2+d9vzHxbKRM4KZW5kc3RyZWFtCmVuZG9iago0OCAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0ltYWdlCi9XaWR0aCAxNTAKL0hlaWdodCA0MAovQml0c1BlckNvbXBvbmVudCA4Ci9JbWFnZU1hc2sgZmFsc2UKL0NvbG9yU3BhY2UvRGV2aWNlUkdCCi9GaWx0ZXIvRmxhdGVEZWNvZGUKL05hbWUvSmZJbWFnZTAyNzUKL0xlbmd0aCAxMDM4MAo+PgpzdHJlYW0KeNrtfIdzHFXW79/wvW9ZbCuPRqPsiLENCxgDZlniJjbBYkuTuntGkiVbThhYog2s1wQvebHXwALGYJucFhvbOMjKeZSl0WikkSbPdE+n887pnpFGZt9X36va71W9KqoaIc103773xN/v3HMtQEyBBIAEiggqD3IE5DioCRUkBehjvARJUUAFVQZZAfyUfqh4qXiDCvon9D3+CTI9oEp0s0p30Deqdlvq0j+U6CE1dbOa/JZ+k2gQbUzt5drgOKqiJn+RZ99Ij+PkldT92hzUuZHxEVmfopz8XUm+JTldJfmrMvsN/SBp6F+mhlLTZ64kf8V7UEq89lNWkqLS7k+tZU442ny022SJ5iynxKh9qf9PwQnLswtUZwdJfqt9osyKUU3JBNcrSSCqUgLkGLg7YKIFPM3gblYmu0EMAq/oL8LZKKKQFCP9ILkr8zWovVFOXfP0NvfeuRnp8pZ1Xc+uW02TqTS7ekWTmZpSojIrbZJJclDtnSkN6mvXlqmmKSD1guTL0mxPndPg3DNK+m//4k5daaQaNd0M0jUozxqbnNKgrKQmrM4uUJ84XvOUNesD810A5mkW9Zd8kaev7cHfd3NX9nArOuqu+6j2ZrnrC5DDqiQpckIbXEoKXHuZOCfelI/QVyTPNJWmrVnVb1DnGd58x5zzLe2/lP3KmpSkWfVr75S1S4sDcw6gzr09OTFZF7SoiU63unmhQ4F0VanzVpSmaDltjao871k1pSk5+WvqKc2EpDlz1ub2X8Qu9P2ECmlRi0aQU3/M+oU+SNr8ZX2FCky53FtvjtsLEjbDjLP8O8cq6P4YxGk1EU9KPiltWoJ6qSjU9M/nBSV11vhn7wEV5s9fnRdyUstN3ampJ6mvpK5V/c85TemCSr1MTdMgaFLEEJMASUyftvp925bnxYh/oUE5mSCU7xmAnIyhcz6ipkK3nB5c5uJBSiazIpBmo3cyn6ipFJPUoG6msvZpaoF4CRJNHD+a7B2pvyFsyeEt+UHH8nPc1dByDIQZXS+8IvNKKislbUOeF5E0B5wf2OccM7UGeTYO64ExFW/00dKCafJbijz6MhXyI7qk9Hg2pzDQNUUz1IwZ5sXBZLpVknH80nCRUsVcEtciniqlB0ZcspLmTt+3gbQIr+gzn59t0/19Lryk7EGdF4R1ffG0kHTtp4xZSpezrE0MzXO8zXP/jVFbbsKaF+SWXHT+BNqPAR8AUZJVWQtEIMiz85zDKsmXQlKDqvp9DabihqomNahAKiDoOWsW/MxlK02DFDz1R1LBEKS5NHRJfkvXID9rz5eoes7yNSGraQAhOYZKBqBoDjtPg+qcyanpqSEtV6R0oaYi/KUBMz0Xq+l+qqRBnmS6QU1pmCdtjZcEulRE0qxbjYHn4tj914ZsC2RbZsRZ3Oi4EprfAyGo3YpKFBVJUeXZt8t6+k7LZfKspNIQiDIfpcwzQt2nlFScnBPC3Ct40sX3o9b38GT6ZxhTRMRmKVtN+v7sarVxleRoSjI9KrOpRodCUjJSpc1eSjeeeRrRNa7IcxhGu/cSCJCUjaym5xdlLmgrswBMM4FkANamqqQvX5lDDmpS2qhQ1GAEJi+6d1wXtWcq9oyg03TeuRJaj0DCDwkBpChIYUigP4ZBjIMsgCqQ+NOHhTkNJmeCTyVCIITpQliLIygRMhWFx+XOAW0SCE9fKTGQeZC0n8kwgo/46VkaJAIJHkQ55Tf6MiSC0HJYI0ExELV0R0ld0F4UoXWhhHWUrqtM0SAZepgQpQgT9wHvAyEEmO6lFESfA1Ga+LRnxWSmxeWHSA6JsDZVfEtIuzSx4J+4TGka5KD2Im2GCmbgBIh4sx/UIOiQTFffvHglkxykIGIPSPhI2jglUUqmeEWB+XpMexS/RnXEYLJ5fNv6mNkg2nKnq0pOOFZC13EQJ2moqAfGW8H1FQyegMkW4McpPypRFA7BVG00clJ9bhiW0apRJrFBGD8LjR/BmcNw4TD0fA7TLSCOguwBMZBMVgTBEjTnYB+EusHXAv4OCA3Q46hHYRJmuqH3G2j9BHq/Bl8HxL0QD6BYEigT8s0IRAch2AFTTTDZCsF+CI+RQqUIqcbfB8FOUlNCpndRCI7TtzwO64KukzSx82+RoY6eg/gE6VSTC+YN8htFJAXo2J98UiKriHsgMQzTzTB+AWbaIdwP0iSIU9qY/eBpREcA7wUYb4KEbniTMNkF7lYYuQAT39G3ckBFXVPmkvU8Q9PDwfH+yAiMfAuth+HsAbj4LgycBv8QxHGcGAhxnWUIgm65SpoL6OmFB2+7t/4WvtKIGpxxljRUr4LGv0OkLfL1ge6nuJatd3Vu+2lj3dqG7Xe0Pc2EvzkEkUHgJ0ggJE+EObIoa0EP3TY0CueOdv/F0lx/U0/1de3WK5u5K5vq15578I7uV2rIMCKoIx7CmmtICbn39Ne7LSfv/0Xjw786s+O2C3vMEB4ET7vnvT83PfKHtq23ttes7dx8fev222be2QPjzZCYRmwlosClwMgn+z/felvbw7/CiZ3Y+euJD54hy+n+1nNwd9tjFeceuEseaIWEREuMoUlMwPDp6ff3dj66oc1xYy97dbdjVWv1mqbtt/Y8Wx098x5EPORZxI4xwkgq+QV6hkifCD4Y+m7m4+cu7L6vYdddF3CeD/689Wmz9+hemGyEicZ/Plx5fuddDfU/bdhx29nHKsDTgZap9H/7xeOWhh13t2+9vWX7zd/+6beARBvDgkTBRMS3JKIg+GGyJ/jhC11PVXZsv6XVeWWbY0V79VXNW25pe/iP028/Da7vyBKkiJxIKEm0kUpkoGMhrRow0e3b8lOxwqBYs6Oc0cWUwSe7wrvvbK8o9NhKfdaiAFcYrCqeZIoHbaVt1iUdD/0S2j4EcYL8kWSEVh6nQOFtHn3a3F5RPmQ1+Rwmv90QqzKFqoyBGtMoW9DHlrdWLIsfegj8AygaCeMe+ovrq/Ob1/ezy6edS9zMYt+Om+Dsq66Hf91iLphwFk+xJTNscchZ7LGaXBVlbZtvgbaPQPLJCYo5gXcfbags9TqX+qqWtVSUwcFNcOL5RucNA/YrPfYlQ4xJ6T6puXMMIm74+vmOmqt7zcu91mVhezFSJ54tDTnLJqtL+5nClsri4d33QOcJyv58nPxR1EIuRrPwKHz4bPfmG3vMZV7ncje71MMtneJK3TbTgL1soPYaOLm/t379uGPppKPUU3tl89afwngDCGPQfexk/fpRx8oZcyGuopFdBZ4WiquyiriCVJmYgO/ewJH7baUTtgKfOT/MleCU8GYvW+hxlPVbyno2reU/2E0xSg6is4iKhomJ6ybw0rKrBn7He3xb1osVOWDNFJk8Elrt8qmNi2QuX2ZywWlM2LNFeyYwmSqTzTuMfRZT47afQeuHIHgpDaEvSyGY6ujaY+7ZWCRVFUmOPJ7L4muLppmcaHV+1GnguRyJK4haCtvuKx9/+zHSPoY1THOdH3VsujbMlIAlT6zMgrplwS1XD1tKYk6D4syOW7JUzqjYFinWTNlROOFccXHn7TB2TsuMfvmtB8asxaLThHP2243wxC0ex3IvUy5zpYotT2Ayoe8bitLhgejHzzSYS4JVpTxTJFhMgsMUcxQGbKawoyjiyI86cgTO4GHKWupvRxeGBA4uknljPI+OTB54oN2yJGAv5C25ojk3wZVIzjKJMaqcQXYaUEqB2pWBmisEa17CmoXTcNVfD+5zkBiFziPt22/gneVw3wLg8kYwsg1foERDkU+A6Gj48xcuVC7zs8WKw6DaM4DNE20GmSsWuALFWRAzL0Lh44Bt9iWe12sh3AVKUIOpellN1JJ+iiB4uie3Xp8wL1RsCxV7VsxmjFoLFFu+whYEbblj9y6ctOSHGQMwGWD5kWK7XK0yeSsL+7f+jIxKCCo8xvzp6VfvRwtHyaCuI7YMD2Pocixr33R1R9WqfnuZHxdoy1Ad2eGqkibbldDwPuEBjMM9n7TXXhe0FoIF7ScDg0CsMg+lFLTl+C1ZwQqkqHmi+XLgspHs+LjiXmZp7I1dlOlik/DWA0MVBRg0BFtGzLwAzUx2mAS7QbbmQlVBwrYQ2j+GSB+cfOFcRXFgy7IAmxvl8qfsBd3s0mbnyvb6n3TWrBiyFEQ4U8yeE2Pyvbay0Yd/B74+9D6ZnHdCOba721oadRbgolQmV2YLwhaT9z7D6L054xUZcUeWVJ0TZ3Kj5myaJJsbYwqGt66H0YsUtNs+aNu8NswYwbwQrIv6EV2Md2g0XIb4DJz420XLCp9jsegsjFZmSKwhYM2ZseWP/jFr7J7MiMUIjmKw5qBVTLP5TUzZ9LsPAj+IyEROwqAkg0sSt4lO77breQtpEGwZKAEJw5d9cb95sfeh2+RX7PH9FcP11w6bcwVnfnzjj4D80TjwxyLfP56A2DhhsMGmRsf6aM1qNMUokzdgL57e93u4+CaMnITuz+D4k5N1V+EM4+bLEs4cdJzgy7UQn6YHuz/urLsmZEMNLgL7QhRUwGIaqSyZ3LVefO4+4ak/YBTy2fLjbDYKKsIapuz5Qzt/Cu4WiLrhjZ399xmkmiKZzVSYBXzlj3C9MbvBazH235fbW2GCjk9h4nxHzZrp6qIwlxtxFvRZjJ6Hb4dTL8HIlzDwMbS9xb9a1cesCLHFMXMm+rvLXB789BUChAgpXScwMQXsOeDIwsHDDtOgpdizZR3/l43w5rbEi5YurmyMNca5fNWWBfYM/BkyZ7tqr4WxZkqdnR+3bbo2YM0DLYb0cCvA20PSFnlwN/dsuSnoLItbc3lrNjI4N1fet2k1/9cKeHOL+mrVxLZbxq3Lw+Z8XJGyKX+cMTSwV8C5QzQxVJykzPE42pVIwGS7Z9s63pylaXARuryn0tS27XY48w4EECgiKBqGqYuJD/7Uwi6LOssUa65syZriyht23gmesyCMjn748jcbVo1YFkeYkiFL6chL1RBC9DgKop/gd3AITrzQb1+s1BQL1kWTtlzXrlsh6CY3bD3SvWl1hM0H6+WS7ccBp6m96hr14+cJz0QnSE2dnw4+dMs4OheTjWRHqMrpZMuh42uIDMOhHW5bCW9FEnQZb7tcqjFGuKI+c/HwY7+JvPfE5JG9CAsjR57qtZTGuTyZy/HYCvsf/yP42iktIrJVpglvRweFY3v7rcsSXBG+YoQxdTz+O/A3Q3Rg7NCjvcxiwZErmP+TrzZ2Old6X60DzzmIDUPcTdfYhf6nzCPWUpkxoPqQTaM2R3fcCJ5WiE2gBrvrb4jUFMu2RYIl04UcDXEpkg5hbPrwo73WIgz+qiVDdBT3ccuH9m6A0VMoSUK2whT4uqL/eHyIvTJkKxC57DiHZl8wtudeeqkGsVIcFemAoGtwfPuNmHQo49gzYva8fgzabZ8QUCHik6B70KiiffzRPa4NaPOmhDUnVFV+gbkSTr8O8QGM8OLx5xIv13nvv/N89fp4wzHEGyAg5/JTWomPw9AnwzWrohjibNkh1tBbfwOMtmLshY4jPbWrMRlhcE4wl486C8df20zQGnEOwWSNVjQdancs5h0G2fwjxbGonykW/nkQQn3wxraRCpPM5eGzIrvI78zvdVwBx/bATBtmGcqA3qauR/8wbi+WmCyVyRwzmwiA+UdIfcS8pogLCOMQaA3uujVYkYf5aNpZ0Fy7GtreBN+Fhu2/8DjLE2wW+uBwRfbwfhvEXCDOEDqSRZWPUaKc7pp46M4Za0HCnothPGDNHtq+DkYbIDEJ3Z+21lwzbTeiBtHRhmt/AiNNIPlh5mLbn+5CrEK5z5qBAGYQbSbSTfBVQeZABI8UHR2R3njQVVnCOzAkLogzhm52NXSdIgo2u8sG2j6DpkH3jutjFrSibJ41DtiKogfqkPqpgk6KtaoXwj8cdqZzbNvNmAsQV4Tsxd2WpeGDOyE2prGwEESmYLoXvK3kICj5mIckOfwd5nR4zTLBYJLKlex5UVtxf91NMHweEm7oONxVt8bP5YnM5TyzoJsphI4PtQKClvERQSPamW7ofvTOSZsBrAsxFyPQ5b94AcKdcKhuZEMB5hHRgqBr4ZAlL/bebnLbRAj4CPl+97GmmquDjhL0jljlZfyW5YhI4dy70PAOnH0DLr4Nze9AwxvQeAAeuzW8IRswBdiN7WwZnNkLLQcaN12N4Ze3LcDoOsAsgZYP0G2RB9AuAnIBRGJ48R749Nk+2xKMsejpM0xB/7YbCIvi5+0fddZcF2YLMAnKVsNQ1dUw0kqO0HW0pXpN0FEK9lxgMwctBXDxCFFCPqpXeUR9pxLNbOx8547bvGy2zF0mcZl9tvLQZwcgEQNR1Ki3vilC3Af5YFKD1twIV9JiXwrn/k57ExhjFSJEqhZ4BURo/ITySrVnYz7KLYJp11wyuc+GqJiIaixGNBZZducn0HDE8+5T/fu3De1le3fegSnAYy8I2rMkNhttFcH8YO1NyLAoaHQc6ay72s8ZRfsitHaXcxkMnKQChagVIqg4ikG4q33PvV6mGHM0puBhq0n4fD+EO5A+uCuLeGQNbB7K2V13JbhOgVZn0AqjIpx+tcO5IswWIjxTnXko5J6K0i7uqkbrFS2OVS3simZmeSO3ss1SPm0rliwGsBviZkO3tRiO74QTT7Y5ls+g4zuyohXZ7vp1EO5RpIioVSOoTIpEA4WNoablCOa+gLMkxuYGmIK+revAfYFKH50fdtauRQ0q5gWSJW+o6hoYbaMq0Im/tjNLEQaLtuxw5Y+ndt0A051ajZqgSUIWiR7g5MUoRvvh56omOKNk/w9gLx+0FI78fTfwIVwj1RwoA6pabRD5YCdG0ZglBzWIttHkvAo6jmGOUDCEqnOb4ERCBQ988MhwpQljWsKZN2HJnfzL70kRSogCeO+X7n2/661b3m4t6WOWDVnK3WbiXIhhKBY5szHTYT4Ksqa+zetg6CzwmOY+6Ky9LmwvAgspd2DTGhg9jxrUbUbL+yEI93c9WTHJLlZtOUhnBqwl8S9egnA3HNw8aitB8IkanLFmeR+9HWKjIImyolWVMdB98ucuZgnapGhDuJgZZXJiVfnhahPSiuimpTFnCSo3ypVF2VKZLQL0cXOWbC8YYlfCO9vho8dbLYvx5oQ9E/GGZ/vNFF6onAKSoKchmQqMyOlGv8IlhLhCjGAImEe2IJLRNNj1cevmdX7WJFkXCracgWr0wRaE0Mr7j/fYyyNVxjib6avMDj79O+BHVSkhCkpqC0ACQYRoFKK+6b896EXhWC8D++WYBdr31VOhSRaTW4WKpkFJAk/n+Lb1EcQnVkOELe2ovhZBvgZ7qIIjyamSOfosRsVjT4xaihAcio5MjyVj4s+/gVAPyD7p7NunnVcPWHLCjsxolQmB1qRjyYi1bNS+eKCiwGPLC7E5CBoRyYQYY9/mtaRBzEGdRzvq1qJXAgJdS+5AzWoyYNrRkpJYCzUY6u/evdFrKyFWyGb22UtiX/4Nwn3qoa3DtmKRNQi2LK+9wLdvAwFjJLs665US8MVz7balyMjQBQS2EB2k+75FLltBp7m4bUNRv6XEVVnkqijr3ljWZ1mMGafnXoPLvvyze5ar7zwK377cxaxCt+Wti3hb3ljtdQTq4hGtryG1q0tFlXHoOdbmWBHlTDi9uDV7ZAv6mqbB7o+btqzzOUyYhXk2z1WFfPAiafDYnh5uSZDLkZ25RB8eugs1qKUqrcotpvYsBAki3sDBh4fvMwCLEX6hu9LU/dxWqjmIwtzeHHoihp2Jdvf29REMIxZDwl7Sa18BTe9BzAfaHo9eTMXIRBSJn4ADW8c25CN+4O0Z44zR+5d7IN4P/aeaHT8JINtlc5HOY8pz1azue/Kenv2b/Eefh7NvwTfPDNSuitgKwGbkraah2nWUB5HXdx1t33K9nylVbXmiJbPfsQxGzwA18CiKbpAYRcM9Xbt/hzwCbJdhTu+zF2ka7EckM2QuFKsMUSZrhCvyvsBAZCJZxFa1Im3DOxgwE45ysOZHKgz8n26Db1+Vz72rXDgqnj2inD+sXngvcf49qeF98exhaDgKjUfi594NnP8Q3Beh9YOLzJoga0QIJNnzh+1XwKm3KLljXlbl1HaXSMXSo4+5LJQERTYjxGQPbdN90ANdx5vq106xhSgTBJM9VSthpJFGOP16s2M5wjnQCgJjD/4MfJ0gxlRtA0ie9ZdIAEHv6HOcx4LxIQuY7MH78j2HntA1mKqL6hrkYaIVMTD6IIYyJPIjKJaD24gyJ6RUu4+synHaQYgOjz9wu99sQIqNMLvPWhw7UIt5aujgI6O2cjAjuFoYsueNblsLFw9BpJNMFHN0fAKGv+jZfE3UUYpMRLAah+quhZGzII4nNcgWowbxqwEkTWOncPakAH2WiJEivd17fo+sEIOJyi7stxXFP38NHRMO1Y+YC1CDiNYGbEYPYkXBr+3fysl6fv+pi5tuCtpQArm8zeDGl4Y6CSEgUqJNjSBIASp0ICjF8IsxId4LwiCRcbwCPd0P/97LmhBJYhD22hYPPPJb8J4nWo3aQZiEQBSx9NDpwS03IhYVmSzUYJDJHdx2HYw1aho82rT5uikWWUNOjMlyVV8B7iZ6pPvzhpq1MSRl5kUSl9/HLoHz7xLCwbCvpSzCGzj/hB+G/9lSd12ouiRhy1Acxq6KEuHLA4TwVVme3RBStD0ab9PIzusRaRDYs2WEmTz3jnVUAorh6kRVkChpYk5EnX77BiY4zGWq9X/FHVktlqXw9UsQ7Gx7zDxhW4zgSnVk91Xmwif7IDakWWyIQGzcB+cP9nPlQTZTZBegywxuXkOleMKiR7vqrsfMCNYcsBhH2DXgPosapI4CHTOLcYgMde7Z4LcVk4XYsoesJfznr0CoC/5eO2Y2ysT18kYrcqafM2PkT6Ct0Z6gQtuh0/2uP7NEItisBLNo0F4Q/2A3cVs5qNKmUoSgV8wPUY/87lON9qtHHrkz/vZOaP4YgiN4Tb+/t8eSL1dlIeWM2k2T3DLvo3dC8yGItkCoDULtcOb1/gfvnKgoAgbnn0WM3p4/uPUmYvS8F1N8R901MyzyweyEeeFo1RVarSYIkx39T1mmLMXA5KuVmT6zaejhX4C/hSA0bW0mKL2iXUX7hNeqEbaFuYViTY6PK3JtvZmgmkBBQEltMGp7WDx4mzUNZsj2hWBfgAlu0Jo//OQG2uOIjpP8BWK+0PBeY93NOCXVvkix/Afyr44dd8DIGfBebHrwt16mnCp7TFZPRR6cfg29lexK300LDckvcm6zgXdmis7Lo2wGaXD4tKbB45oGjWg5aqVhmFtDezcQpo1OfbcYcUN0uHVPxZS1DCozwZqNAFj47CWqGBysHq3IRTNGI5+wZIdeMEN0IrXrK1MPnuD3vf9sj61MrMpFsjnN5TU515DJYeJOjBNlE7Siwam3B9ifBGxlPq60yb7seP2vYbSFahHuxtat13uriyOsgeiezTBpLejetKr9/vUDe/7Q8+AdCHRH7SYF1VeRBRYqCaIG++pvIuaOEus8SjCbLULNKubLPeiDQ+fJZvhJ/+G/9JmX8ZWYtvIlpmDIWjS2524C4QgzhBGKA56z3lfrBm1lPJsvsJcHnNld3NKBZxiIucnwFElNNdOItDXJg68DfT/M5ihcDgInnssKcnluWy7ic+EVDt5/HI48FNi/oduxBHkooLQraTffZSkaO/gAbegE29v2VgxZ8hG0S/YcjzkvvPcPMHES4oPEzYM98PYjbssS0W7EaID+G7Pk9lddRemeiofHO+rXhaqMkvU/E9asXmY5TDZQHhRnN5Ex+Q41/nmjG4Mhkw3mBaMWU+KLv0KwDQ5UT5gL40w+AuMxa9b0s/eS3JJ77hrql0Iw2dy782bMoQk2B/OR31owYC2feuLXuCL5oyfhw93RZzYO25dHrIWiPV+qLu51LO85eD+ZFj6L0fX84ZP2VVO06hzRnC2yBUh8JrmiMUvppL087jRJjpzYhv9ULVT5JHbAFri2ajUZERn9sfbq1YiFVMsCsC0cRQvH9IrJCJ1ouse1/Zce61LRUYpPJZw5E9bMAXtZ6KlfxV4zh168r79mNeYy5OaSNQMTsY8r/taxFrq+os01MZ5qQJJ/0OD/7xrk9a09NQHjLeM7bgpWZqIME/ZszINRp0FyZobtC4crDQPW0j6LCWFn1JEnWBfIGy4D1oTYvm3zzVR+QRqYGHMffqzPUS46jTFzZtxZNGItHtmx3ndgm+dvW0ceudtlXxFyLI1UZiesmhzsJnfdOhg4Q8i268P2LWunEGtxCyQmY7R2FfSdpL4FHQFLWk2GH2jbZx61GKmiziGjN0Y/fZ5qMq9X+ezFPFcQ5fKR9k7v3whRrx5BKdcjI8bViT4490az/YpJphCcRbIlR7TmI3DqMxd1MIs7Kk0TG7NEJk9mcgXOiItq2bSWuhEUHwEwjP+CT/72zUZ21Zi1IMTiuwpjaDBVxUgh487FM0yBuyID7l8ZrybSITDZAXuua9s6TSweaD7sqr8eKYyEGrQsGkcsOtpAU1IEiE/ChfebubVTjuVIIRFgi8xl2l7Vwgk2Z9yaGTJnAak+Q7Bkx6vKmyqXxj5/mQrU1NqhN4ZR60AC4jJovSvjbdM71/PmHLAbJMYY2bTYX1U6VbkANhdFOFPAZkR4KXAGtBZ0PbBnz7Cl56vWwYWjWseI3vLd2LzpJ2ircdaI/BfJV4gp6q/IHeOK0CUxdY6xJZH6lVFztkp1j9yx2mtg4BTER6DrWFfd2mm7EcGGUPnj8U0rYfAccS69v5iAVhDTlmuvxWsxqTglJhOzRujzlyDaDYdqhjZm48QEZ/6g2eB93opIT9S717U2lQRVqeIIb4SvXmtlV+MIoq1IsRljNqqBI8aLOAtQbhKbHbFnYkZrqLkRmj8kpaNVU+MNikerVDQd73+GaXdc1VtRPGQuRu9wM4u7mGVnnNf6XnbA2f29jqV+W47qzIuxhr66a7RGi0lo/6Rz0/oAW6bajaI5d9h5NW2pUD+DQA7Oj8onXm+xXzXNLY46cqLsQrTDmMOIATBm+THUFCqY9DkjivHshiWBd56A8LDWFyQmt5aoHCqiA4pIECREMr2u+lsnrOUzDHFwV/VVcHxXf+2aTnOhf9MVQa5crF0SYQtCXOGMsxxZcMeW9XDuPR0AE9YgV/bD6YNt1dcgUp1kF4fYkqijOFJT7K8u9FWXtlcUwtFdkb+a2/5o9DkWu5myxqprqAcmOgLtx87Vrh+uWoNAaMpR3MythtF2ZKE4QdIC8i6MG6H+tqdZF3MlSsNnL2zlrvB/8wZE++Nv7Whnlk5WL/E4y1vYFYMv1SFNSGhnPbRnUVJ6a6VEdObiO0MP/bzHstLrWDXBlk+yJYjzMTp57aZhW2GHrXQQQ2vTUYIKSkwS4mRFsYjWB+WjdIDIs+mdxD8eCr24aWqfLfhyVeitB5AXEGNq/Hv3ptVBJ7phZsCaM7z9JphqB34K2r8+u/nn/dxqH7fcY13c6LwBJnuohqLo/WwhitVNR/t2/aKDXdLHlQxy5R7nkqCjiK8umbJRoEaD6au/Gb58Ras1RWQJWYGqzB5RwSkqkqK32/k8jU/WNG/7ZfsDv218+J4vdv0W3Kdg7Fzfi/c3bbmjy3ld871FmKHaqta07rpr6r29ZEvCFCgRUYxRPzBGLVGg/T7XGdezdY1b77zIrWqyL26rvuJC1eqOR3+rfP03CPVNfvXGmYfv6Xny3t6nNpx6zBLraSAX7vvui4fMJ7f8pvn+313YfuvXD/we3EPUNSgo1IZBLaNRZDEn/vqnL+rvbnng16077/xq68+HvzmCgh39YP/XW3/VuPOu89tv/7T+5y1v7kVeLCd75slKFb3Zi3h3mOB9qI//6s3uP1fjIK1113XXre3efGPb9rt69zmiXx6kJisJvS9AXq/GQIwAPw1TbdD+0cSb90PDm1qHj48+xCviJi/DX4K98NXefobwqsjlIlgdfPAu4qpyWHKd++QR23cP/KZx+x0NW2799pGNCU83kgWVjjKQ8KkwHg9AfFz49s2BF2ubdt3duvW2tqrrW6rWNm69vWufc+az18DTRi/F20RBkhVllgYmq0KQ7NlGWc0Mgb8Xgi7w91CRB01R8BOPGGyA04fh8/3w5fPQeRyZI00bUyjmU5FXU+cRaM8RZSeQtGHwLJw6IHy6T/jiWeren+6icq4Yg+gMhAdogybioh1D6ubCDyepOSo0AlPdBPKnekDHMMlGYpEelKIQcNMj/m4IdMNMD+3RICWPTYDfRU8FuiA6BGE3FUVF/cyCVrHHOSEbFbQ6FZ2fiBEUxxn6O8D1KdV+XV/ARDN5aDyklTt5WW+WToR4V2PzK49e3HV3c+3a75glffs2AD+sle5jBB8wDdH8/RB2xfdXjFsMgiOXrzYiXAm8VK3tj0SoKy88CoFe8HdCoJN0rYQg7eySVltVKA1hnOHHtZ7AUwRXek/AjFYMQQyASRNRGV3JYwG6G6YOG6nJ6rG+c4TcTW/slALaLxJ1+wiCtsHnJXCFE6ZMKhPAUFK9uaKWVUVea+AUSSmJGMGt6FRyexdVEI/STp+itdMQMomQzeiAirYhwhSE8XO68FmqOCArRxBDDY20jyNSqKcZaipAz8Wf1FnKJxtT+SCFOymePAyVELVibqr3WE427EpaiQnicbofY6PoAclLNR8MmLxIT2ktalQWRyvq+vZT+/XDdaumq4t81UVt3BLlqxdo1ywWpl479FAJPREdcP8wuyxmNwjsIj9n6GJXwGcvkOXTGrSKJfWLRqmQomhdJRRV0PypBTwhaicjFK3PnLoZUc7a/g612gaohKKKydMTpGhZdz9dgzqjn2vzVqRkt3DyrJc8ZypaiRGTL8lTTZYbZxuw9WZtCqGqJKmE4GlI2pklKKKZwGxzdbLdfbZPR9HfQX9qe5S0bSrpk9SPLKZOH2gnNSjaawW+hD7H5OmG5FEIRftLUVP1NFKeqJmtKMjppwFTrfaa0UIc/6fMdu3r0Fc/0oVmGR7u3LNxxFEe53LitkX+6uImbs3Uy9ug6TPoOUMwrPGw7/XNHc41fluxzBgFR7abK+i8/3YYayAb1lsDFU0aqYZxDYimTpnJs637qGZR0VvDhVRoTDWky3qhbfY8lKomY6mS7Dyc18Su/t98Mu9KP8nyX16XnhVMb0xPPzdxyc3/6qu5oxD/x+v7N8w7zwjyv1hU8kQJWkBYunAcE/oMZ6LtRVtOwF4yVFnWb146vmnNiGNJb2Wu254fcRYL9vy4OSfqNLbZiiKfPashBFWTsm7uaspAYPag3SUHLOcdsrhUOP+tdf1wXapBRTv+IvhiHzx90bzYzxZJ9jyFMcmsSeJMgi2HGoq4DGAyeHNG1G6K1K7ssBROvcJBfIhaYXUdYWQWRf24ytyBIzn9ANoP1/+cBvWiOlHv6Q+ea928rs+CvNjA23ISjBFjJpJi2gWwLko4TB5u2TnzKt9bD1FfbtyfPEuXbDAQIe3IUPLsXvIozA/S/n+gRBX4KIH5ns+8L7I9tWv62HKXuXSEXTZsKUFqP2gr62JXjj9dCd+9Q0XpRFBP4pKUCsVK6nDv/DOV6r8M4D9c/1YNJv9lBQQiqBckL/wYjJyRT78ROr7PffAB95uPBD58PnryH0SdeA3268WN1LnbVOyUv5fjZo+j/SDq/1klanRGP5Mmy5IgxyIaz/JTY4wwQWRE0rmVgCwGOQgdr5Eo7+HjfIzXTq+pkirP/zcD4L+F9364/h0XAUidtKIWRO1Ivk5kiNyF6KdMm8mSom1/65hfr6gTTyFWI6iKNPcPmCT/EQPl36q+/w3Rl6RiCmVuZHN0cmVhbQplbmRvYmoKNDkgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggMTMzCi9IZWlnaHQgNDAKL0JpdHNQZXJDb21wb25lbnQgOAovSW1hZ2VNYXNrIGZhbHNlCi9Db2xvclNwYWNlL0RldmljZVJHQgovRmlsdGVyL0ZsYXRlRGVjb2RlCi9OYW1lL0pmSW1hZ2UwMjc2Ci9MZW5ndGggMTA0MDYKPj4Kc3RyZWFtCnja7Xt3eFRl2vdkeskkAdz1Rd31tStCei/TSyJ2jSQQII000khvk0xmMimg6yqW17Wtu2tbcFcXOzbsioKiKyJ9AVGkBEimnPre9/OcSXDL+/f3x3ddzzWZzDnnKXf93eWwPCuIIs+LHC/CBydERFGAb/iTwOMlUWRFFgYnipwgMvgv3gIXBHyIY8kvPF7kIqzIkHs4+I2LiDwDswo8JwqCANdxTg6fYDn4l8Xn8SEy4AlBDDH4CZMLZFnYDM/CBIKA08LOwrgpDm+m18nCYpheZmAV3Ar5gMExHJmIDYthuMbgFQE3IJDHebydJ0eB7ZIHyJx4KLid4xmYVwgLPKwbgjvJsnAX2ROZDgchHMewvBgUxeKaoebRh0/BPWQHPEO2J9BF6XcONy1wdC//OgRCdAFPwxOSsjzHkkvkV4FOA6ux9DckA50ZJ+dZnoV/IxxcAVZyLJ4EiYYHhkVZhkyA7GAj5KiRCNkS3E+ZGN0hXYnQRNo4pQ4cnePhIUJ+OD0wF2klHYjQDiWFzMmEQrAhgdCJFejxYEthKjOz7OAlUtAjSutRjsCEAtA2HAlO4So87J8j0iXtiUEegwRz+BMn0QEoBpzb9MGe8xNvSki84dODwH1pNpHKOmWHEGVNlPT/hh24osBK8gIkZaTtseesSMWN/ItCTgiMwkpvEGZkAM8JXyOUSvQqh88wkfDMrKh8gjQBER+UcjwTmQOmD5KBlwRRUgTgeIToF3mO53E2EAMgNCPAatMcf1oiNioyI0j6S/QH2QckFiRFiNKBEkDafIRyhJyBDKJjEVRPZlqkxGeFKDEJNaIUnp7Gs06Jomm5Nza9Ii6r5qbW++DfYBink+wMz8+Q/GdL/xvtwKXCHB4/RIgQYqPUJXTjo6ogko1SO0DFCTbLBon0wIIMUWaBZfmIdHBq14j88cLs/FMMfqIFIINOSH+hP8JZzoqo+/CdQakXGQapjGYK/kbgIstHnwqj2WAZkZuKCJEoi4H4uEOGxc2hleHR5vH/JJXUNgmS4hETzJPTsISpPBslGpFJlHGWXAcWMyERbZgQjqDewbmefv1rTfLyOe4ho3UgNqP6na9/wNNFCGNRovhZiyL+X+zgiYxNi+JpXgQJO8WLZwQck5w4KYinBPGEiAPsIfw7yeP3Y3CnQIjJR4/PzWoiiC7hCE9tHSgytR7w7BlRPM7iJ50KJocvZ3kcp8k4xeEejoviDxx+At1hY9Mc4RRPj4CKz7FMmCwNG4BtnOBwezgtGWeo6eaiQsJK1omPWsQoWYgfoJJPJYq4UDbKnAjZ7QketzEZEU+xZFqBKK1AHSmcDX0I0Cr7tl5ldqvaMaJzjsuSam5uXDtFrASaaHSaszznxaiF/Hfjzoc2nX+V81rbqsttq36Vv/JSazV8ubSg6jJLzaXWmkustRfbay52lF9iL4dLl1hWXWSpuNy16hJzeVJR/bL236594tUtX30/RTYfDvM8w1B15sE7k12DoAIlhyYevjD5+iutq66w1V2cX3mFpQbGZWRcaamEQf+9ytFwcUH5xaaKq9y1l1pX/CqnOOPmhhWdv73rD298vudMkNCfFyjqwKP9NMnbbqy4LGfJZabyy21VVzpWnZ92a/PwwygkxLFTEyRS70iM0D+zg+ckr4GOE3jBTDER0F/gsv++587PuP1SV/2l5lVXmquvKli2/8hJNJLECYLTjHBMiGFgrUf+8rlmQanR5ZM5xuW20blun2bBTS9/ui9EacxI2IGddZc/15NzRsnAs+qkFfOcvbKcFrWlS2Pp0uZ36PM7dHntmrwOVUGnytShMrVpTK3wO46CVqOtW5OzRpXRrMttlCeW/bJg1c2r7/rqCBOmCwEDYKcsg5QgKgLsWNm0Lm7R0oS8Fn1uu9HUo89do8tbo8lrV+e3a/LXwKcyvwuGPLtFW9CmM7XDKvr8Vl1eiyarWZ3eqEisnJNeVdH3+I7DbJDwAjwq0BgUr7Hn/oRrl883d+uzaueYGudkNyYsLNmy7SioD1hg6uhQHrnwjLVnJSPFSeCMnwFYyDNAC0Dhrw6yF2avNOQ3xeTCNtoT8prjFhaf5dCSoHXiJBcDGGZKEBOLWuaaOvSOEZnZq3SOxLkGjenV7oph1G4AkOwMlCPjX83WOWPpxFvyzGaVwxdTOCZzBWSOYZVtWGf3w6fS5lM4/HKnX+HwwQ1qu19NfldYhjT2UdBK+DfW7Yt39KpTyy/MXvHCu3vBibJ4bnS7iIo5NMIgJCvb7zOkVsfZvUqLX2UfU9l8OL99WG73ye3DMQ6Qq1EYcBa1E5dQWwe1Np/G6lNZR7SOiTjX2lizR51YCcr17tc/BQm6ZMIc2KEDP4kXZDbG5XTGuT1aW2+CfViXtGrpmnup9wmyUcsgEqhL7TPBmpIxFblZ2MNxAMyCLA/PNo4+pUleqXN4FK4RnX1kjrUvftEdEWJ/wqKE5KdCIfh3/Z/e1CaWxTuGlNZhmdWncflgG3MsnbFJJY+/9AlqNHWqM16L/7/YUTb+hiyp1nDdaExhQGYbVrkCOtugwe6BT51jSO0cUjkG1Q78rnMM62w+nc1rcIwY3eNgJ1WFozLbkGGxL9bZH5fbFndt2eufHpMMBSdZWZBlsP9lHXdrs2u1Tp8CTKs9oHGNKG0DhiJgjUdpH9K6AwpHQOkc1bpGQRIMtmGDfUgPNzi8OhfwaDTGGtA6xua4hjWpVb/KW/HxzlOI9yMIt4DXfetfl11TZiwainEOgajE2we0icte+vxYkGI5NhpagNTzPPURHAFyM74dB/4GcBxjhe0Hg+dllRvNnQqnF0Ql1hnQpdTVDTyKfoAieXTqYZj4HyfFRe412txWkCKFdVgF4urwyi098e5hbUZt5h1dxxFsEI1ARBKWYPZ/Zkep/3VlZjPwFAirco1o7QOqzDpDZq02rVqbUaXKqlBmlmszK3QZMKq06ZUwgCaypEpZWp0sd42+yC/L64DH4wvH1SmNyTd0HTyFIgTLMZGggGEgC55laefdmpxatXM4xhmQ2YfV5k5N7mp5aoUqo1KXU6PJqlZm1Giy6zWZdZr0akAmxoxKbcoKZUqFIqM+JqddbffBSUH85hUN61NXgtv6KUTOxGIIuPukeImrUW1uV7iHZTYvMF2ZvvrG5vvArQOqQHmMUHzJRjEnNTUSVYhX5vAHYAeHOlXnfVSRuNLo9socgwrb4DzHoHFh2cdfnUAAQSM1EcMZoPPg+lfk1yyPKxqROdGSAEdAupCYZk+sY0CduOyupz+cQjBJMANPzFaE4SLsf3LlZf435SmNarsXeKF3eDSZ9es2fLn9qPjh3vBH+6Y/2j/58f6TW/ed2Lbv5Pa9Jz/fe2LrgZMf7zvz+o5TPQ++ceUN3ar0GoNrCGwO0EHvHIxZVDLxp7emEFCR4JVD0Izs6FivzqrXgCV0+DTm7vNMtY9u/m7bUXHrwenP9p/6/MDkJ3uOf7L3xMf7Jz87cObzvSe3fnfy8/3B17YdW3P385cUtulzGtWmHo1jRGkaPL/Io150230bt5yF8CTEgL0CBRl5dFNM0lLYidLpl1m9GtuQJrnib1t2CoIU/vBsNCLjf+bQKazlqeMAEM2L2/YE5yaXxtl7gBEqt0/v6NOlrFgTeJoGvywD8U8E40RO2Hdc/FV+Y5y5H4w5sAPkGbRe4wzILV714nE4qS67PfmmgcNh3CGBcNRqSMH1f2KHMq1Z5/LLrf1aU+d8a/MX30uwPzIbqYnCbMDE0RgB7jkcEQvr74pJqweTIrP7NIsD6rzG5Ns7j0UIqmcjNIgLIjvuU2eu1jjA+/j05o4rXA2f7Q8GSXqDTk7jUCa6HEb3JCsCuHf3WdFUNaHMqNXDkQs8IDOgUNby/tNS1gGcr/hjWFx4fZsupxk4rnCNqt3jgAGKVg6B72DDFPHOuFL+3ICLpCFgdR6QwVSQgS2t7HoI3BzYyRjHMNDEaGs/L63km0MMRc7EJQJM4eHOrjs3KhbBnSPo/pxDWtcgmAt5bpfK4gEXLLP7jdYR2RXL/I+9DAIZChP5xEwOsXj8v+fIivG35an1MJW20AN45gJr/ZvbvwdfGWTQEYPZgaVpTEQ+aQYLrLYYnMbwZ/cp8b9dXTqTR1U0IXeNqvI9xrSqPadIUAVLcxiCgWwsa78X2IHuxu7XFXReaa/fvi8YIQFCeJqnogs4GYzBVITDAJwANKDPWRY58uHByMWFLYq8dn3hODgXQFzzc1fsP00wUoQHlAXEfmDDJ+prSsDjxNhAQUbi3X7tVbdvfP2bCI3oSW5M4j1Jx/EzsRmhc5gRgMKvf3F0XlYlwD+tc0RmGQJ1i0lZ0bruSbiEIJjlCJpi4ODbDvBz08tjLaBEXvAX4LlkaZW3+Z93t/0RTCXYK1XhuME+ZszrvMzd8N1pqiAUuyEvJIj1L/wo9b+hyGjSuAcVrj6Dpf0ia+17Xx6hiT3ijgXq/GiMRDYfwSCYhMQcG4Z93tr6UEzyarASMY6ROMeEMa3+/W+PS6AX3RYLOyltv1eV1aRyjYHL1hV0ATs+2zUZ4sRoYkn6lPaEak0AEFlwkhFPiqK9ejQmc7USDBEACcA5qaVfHyVOCrEcuoiTjGgqHVJnNmlRVf0Gl1+TWpO/xHOSw2iF5aXEGCE+2b3AzqaqOFRG8DXFnetVqdVGh19pGwHgB6gb5PObYxjvc5i3AqsfotCrcugpmB/ss/a6AEAdZV7Tr4uadrHiZ0fF8/Nq9OY+uQUgVgDgBzjB9nv/igrCYAArEofKSf6dOrFZdpT4t8SktyndI3KXN87Re35u1dadx1ERIjSHgwkDKZ8lyZGAqo3JTjHCTQFqartzozG7Xu8akFs9BtPgvOzVm3ccAhZMM5T/qNclHffKs5uUrglAVmpT15XOhu37zsAcwQgrSMaKiCo36+MAnoGCgEBCUAbHr/Y+rslcrbP6VWbfHNvgBbnVW/cFg7wE3mAW+P7Ey18ok1eANVO7AwB1AP/LFi559OXP0Paywky6g4CdoMQOKfkrng6KW749pU8rMdp74FkgZpzbD1HV4CObpwhgJtQL8uiGxbe/+MmQsjLO1g/IUGbqJUpU7nv81VMkw9Mx8bRsYXWsY1xr98JmYvPbf2Vt/PoHhlCUpiWj0ce/sGNpANmhdo+CO9YW9Pza1vLBl99jIoeh/g+z4OcYWz7EMxJy5MVQZApIXT34mC61ClweiMociyc+teKLw1PBaFouyo71EOIhO1yj4KEus9V+uusEzU/zUjKM3EwTzGRlPpoRBSU6I4o3N9+jSGvU2wBvBIwFXQmLbv/HaeKIeUzWswhRkRSWioAmu0Hr8sJxAMhp8psW3dJ6lMQ+OBnNbSM7QjNZK5gF1oJnXbUTqqxVGqcnBuHZiCanZcHilu8ZPAjJfJL4j+GmUdnv12Ws1hEzpXPDKmuuurHrKLkTyLb3R+HC/Oa4ggEt8MvSH2v3KZNr2u/eAFZ3GtxONF8hsYP/WQJr+egrKHUAmCEcMHn/y9z+7pdHUYnZMESyAs/R7CsvwRKW4UIk64+59SDHAqGyir26jCa9o9/gHIjP7fpVfv0PEXGKj0ihFs8hO9rvV2avUTknwAKgK7fVb/32NEPCdmKQZ5A4ho8z2U8wWXD8CEmaJd7qkWV3gLkDgYzNa8q4vul4kOYceI6n20PH9sL7ewxJJbGOQbCcAHgMzn7FopK7N3x0huaZOZIowK8RSdWJf4MlNrz3rTJlJfARPHiMfRDCOtWipXc/9SZs/mxEIHvEzCFL/IsxZSkYTIiCMcxxD8VcXXLvxq3TyAsGIBc80nfPy9pFlaA+wFa5bVRj8yTkVn12hA1yUSzBR7ERTa9J5QyhLPA3VXothHhqx6geQq2C9ve+OxskWcqIINWSQlFRF6Kp1zCBPSBRd/7hHc3Cirm2Ya3VY3QB0q6qGvzTFJU4rDWwkna036/ObtU4x0CcgB1XOdu27mano8gNNhmOTkvBVZjD1ArN2YJQDTy4OWbh8oTF4+A3IfrWpJR1rXs6QlOmJLpGhAoOlhPO8uKNDRPy9AbAnDIIZt1DRlPrJY76A1OYjaQKxxJDHA05QGJxCWsF+OIaw/XrZJZBiFxi81pTbuk+xkhImGRamAiDZ7m+8U5VRnVckU+B2B7QbFPazd3HWZoSRr6BvB6eFi+z1OszGzUWr9w1HmMblqVVl/ueOBPlAiozTSZzPwsJSwIvaXKa9IU+mXUIMInR3veXHachlvxRFH8SpXTubFJXRK+KVznxk/1ilfcpffKKeWAWTCCHAb2pKyFj2Xu7JpFlocgMOA6idq8H5AmiAuzQWnrmm1ve2inAnN+HpTTsKZI9BiN/LIyfMH4I4lrvfhuu8j5tSF8FMbLW1gu8iMtrmp9T8eU/2JCUBueleg6HegaEfm37EV3K8lhnf4x9QGEbmOP0QODgf/hV9CB8NFPBRf8S1Xjy9W/0iUviHb1y8wDY7fjCEdXCskdf/DvsfDocrZ4IHIjlhnd3aZKW6S3dMnOvxuWNtw8oFyx94uUd0+gHI+AXwOWBGEPk5X/oFQCZCY4hTeEo6qm1Jy5j5Qe7ToSp8ESre/8UnhePvCLPaoSZIZDRLF4XY+6+4rb+7BWDaaW96SX9WUs8MDJK+zJKezJLurOWdGeX9GTc0Zd02+DcnNWqlNq5do/WSnJcBb2yRWX+378GkhaJSLlLUllFdgDQ1WY1ADsw/WX3xBd0LrjZm73Ml720N6e0N7ekO7cYR/Yd3blL+zKLe7KX9JmWe6+9sT0usyomeZXO2qux9YN7gshdveC23z3/xVmiQTP+hdbp4JCT02G4dHvben3WKq1rQAnAxjKQkN92ibnu4BSqM0vLGIgg0AABngdIll08YMyoT3B5wKpACKnNbctd6jslsY/yGqkH8mla6Qd1iHX71Nf5lLYefVa9adnwaVo1pjLB4caA5iBO1xa2xOU0Kc09ADuBxfKkilvX/AalIixI1Zd/LsGIpYE3VZmthsKAzA4cGVe6A7LMBn1BE7gnTV67LrcDBkm6rlHltcFQ5q4B8ZbldKst3liINcyDeqdXbe68aLHnty/uPEWsnEBquTwroWsQquUdd2tJVB7j8sOAZ9V5Paq8VllGjSp3tSG/WZfdEJvXrM5rhYXkeU0KCOjy2jUFnSpLr65wROEeU7hGQDsuvbn/D2/uOksrGlidIHVeVBCSuCB+B3QThPC87GV6ey8EyFqb7zznsDapovc+DMfCoFERSgeWIdHuY5u2axYsmweMMPcCEAKvARH9n9/ZFxSlbA/ODwYuxP7PyztlV5diaGMZlDt9RrdHfs0tz771bViqzTHoaik6IFZu7aMvGRKL57gHYRsQAoNOaZOXbtr6PdpKliEtBBj7nDuWjrwtT2kEdmNa1T6qvu5OAEggjQDStDa/zhoAbIkpI5TqALp7x4jS4peZ/QrnWhgyyzDYZ2VBy6W3Dj/+zuETtCTNSI0BtJ4Iq5e1/0ZP2IFJY9eY2rVWbQMsOqwv8mucQ2rrgNE5pDH3w54BESmcXhWIHyxq88ntIzLHiMw5KnP4ZfldV90x/uePj56VqpMsbTBAEIhwnAtjORVJAWSvGX5YmV5vcI7KzUMAgQCMXWiu++YYE92ewHAQJ4tHImLKzV0ARea4Anr7kN7SA5DJveo3Z4jiMAwBCNFEbGLxkDq3Tefyg7SD1dXkri6sHaHVLoh9aBAVxH4BxKXw3ylGTL2hHsRM7xgB96F3A1pryl85cpZCShAfnhH5n7FjZeBtNbAD807DMssIAJI57qEEW1+c3Rtn98EAnAbyDz4LEKbBHoi1+GDn8YXjyBebT1cI5x0wugchopddXbyk9f7jEdJbEY4WPUnZbnkbskONCjgC7AAmGgrHlfYhlXMAgaLNA6SYUxQwgPNyjYJsgEgYHF74F5CtzjUqd/qVRaPqojFZTqcyqXJ5zyOnSemeoW0FpLTE0sQDcf/wse3A9JysWoPFAxYS4BwcUJFc3n3vXyYptAQjzyJkvWvDZ7IFy4w2YnJtENEMGFNWPP/BQcwYYImXGhF+KsiAjssWrjC6fBBeqZ1DEN/BeV/cugeromHalYGmEzSUtG2IkWlk/QPPvqZcUDKvcExm9cIp1NZBdWr5s+/sDJNQi9SOWQnuklHmfU2d2mCwwxKY7cHkW1ot+D5tSrk2pRKGOqVSkVauSKtUpazSghlPrNAlrVQmlSvSV8Vk1kJwN+96n9LUqbH2/AKVd7lr5dgUdVDRNBFlhy6zjrDDF+PyaSwDMRnNYKkUmdUx6dXqrDpFMixUDUOTWqVKrcSRXAEDfkHgZ2oHSwV+Rw2BP0xydemytruCUl0Y41xQ/JmuF/g1EkQr1HLnJtizzjaocgFHhmKtXfPzK776np9GU4q7OzIlXra4W2fuBunVAhSx+sAbFrfeexrjPto5xNMwE24+NCUazd1qorzGwmF1as31q397htR3hZkWDiFqFbDmhFQGKAW4S5/dqi8clzkC+sK1qqymnNLuM6QOEk0qcjNAd2VgszKtDqIGubUfM8Pp9UOPf/DSZ0c3vPPdxnd3PffBdxve3/XM+98+8/6ujVv2/vWd3S+8881zb3/97JZv1j3zdnHXby9bvFqTUW50dKns/QrbYIJ7XLZgRftvnsHST0gqwKHvaF9PXLlP6RpSWbsM2Q2BZ79+6sPvn/rgwFNbdj/3wYGN7x/885Y9G7bsfO69XX95b++Gd/ZsfG/PM1t2jj3+YumaO6901Maml2ut3TKbB7xzQpFHefUt44++EiRYlzundQo1k/RnAR7aPylelF9psHRiYt8xHOv2Aq9rRp4EW3GGQX6te2KLbGGFzj0GkBJ0MLagF2LY9745gVFihMJw7FaCyBce8T68BcIZUDQE247+2MSlmz48EKJKFC3vivxsSwgGUKSp6NG/bdMllQHyVLrvQuzq9KiSSv5nE8YpyG42hNyWms0i/58d/0+xo2xssyx5laFoGHRQaR0EgPT+nkiQYLxwtNOGdnRgyCbZZqn9ZpJkv5d7HtVlVIC1B7ersE8YLP3zC8p3HJnG3YWDImn2WNZ2Pyb3nCNql0dnab32pp6P9guTZJJpwq9wNJ8fJniGYh7a2wOfe38UlrWt12ZUJVzvk9kGAPMbcpsWFLXsPUZIxhPcyJColQQhwI4IqTJM/P41RdIycBwxJKFhMHfPya789EAQbMW+0+Ll9nqwVFigtI4Y3WOq5OoVvY9OSS1zESYMd7FBjKDEPZPi+QWrwfIDpMGaZlpdccvdGB9RgCu5+9nuCCIRKCYsh9TLLxuQZ65RWse1rlEgFMD1lOKeE6SwSKqQDCbJyVgyulme2Wy4blQGrjy39xe2jg++ncS2K5ajtTxS1OQYmtclxYUI6ZWCUDpEomkI366rvUueWq93j8lto8bCQMyC0oc37ZimcQGpr5W2PajKagH7rHYMGEzNF+dXbv3uDEbfEYr30BMLpPQQJs5NJNVwiJbAPQJKpwV3V9VaWVI18tQxcp47EHNl6bObvwuTpyQMh9AV+waxg4WUC4+cFa+5odVgalFYPIDZwI8o02qW9jx8TBT7HnpLlbgsrnBIZvcrXRN688AvM8uxNQLEgw3S1h4BwJogAFc673lOtqgc9AiAPeiIOqnsrS9/ZGiaN0KIzvEzrZ4zuQvSYIXI/8k3d4ATNDoCiFftAxApaNJW3vvsuzTMJB4kQkdx4A1ZZjNpUQioLcPzHd2f7D5DoBpDisssbVHko4AMVg1He2Nh4eBUBJbe9MHhhOwmrdmrcgVAeAyZ9VUDT5yVgmWRJEkeVGS1apwBlWMQ2HGNo2777klsIgtNS+lCrCNL3Zo0w86y5/S3hnk42pObdxszV8W6MQuktQUMWS0dE88FiU4QJ04KXgBOsS+RVO5CCLzW/fEtxaKShEIvFiIdfoO1d15uQ93al3/t7oqztkF0CV7eUDgGweaaiWempd5RDhMpcHAWwfDffxAvKKiGsFrrGo91+mNSau7ofQwtRigaUVJeUIxEjhCJsoO2ccHNBeVjirQGiCB0Do/B5ZenN1xzXfOhaXGKNtdxDB1L174nS2sGyKpyjSlNQ7+wtH+8+2yIlKukVtZoBzKN6RlSLApLpQ+WQstvj4mXX9enye/Wuod1zn5DZq19uQf7VEkrNs1ZATuUzlEwiTpTC6l3nJG6GVGwMY6jGeOZrmbMIJJeJtRTgl0/3h++yNkoL+hSudfGWAPq7NYlzffQPkae9D/BhkgrGlYlSKCO5PkxJCbd1GI0taosHrBXEOPEm3tikmpjbb0qM7o82LA+vxWikgOnSKRP0uA0KxkmWeI6/9PyReVg8SAQi7f0xWeueHf32WnqK9hoJYlU4GnanCc5GE7ikgDWDljz/MeHdMklc+zdahJezVs8pkpcPvL4FuDUFFpnlo7b/K/LM1sgtNFA2Gsdmu/ofP+7SdorzkWbimfb56KDpeEtSb/AdzCD197o0eZ3AxgA7huz6/OKu0NSPyRqfmnHA4qcNVh+cnohQrnMVvfZrrO0C1eQmnMlTiByj4SInLOCtAVS1RTFnZPif1+3RmXuAfOido+qs5tvXDVKnVp0Ho48zwkUd4IHmcKrD7/wsfxaVBAAG4CWSUuMF4N9pxciiDhHL/jWgQc3TRMgQNrqcFEwxfDL5wdC88BnmfsgBDDahsDmVHsfA/M1HW33ok3LwBfKE6leF63WkX57IUJ6L29onJCnVmB3XP6A3u7X53fMtzR8fUwMiz/LWUGoaHAOKC1dOnPHBY6md3cdC5Fch9S2zc90zhHdkxgjES8SQQC/d1K8enGfMqtb7RgHB6HNarSWB6bOqXeUdt6nzG4FU4YpxILWK52rt+0JRkjbPPUdsw1IUssHRWU8yRCiw4LZ3tkTvvzmfkVeJ9oc17A6rQpA11mBtCbOVPMJMQHtULdFY0SIIzJLB9XZjZgpNfUrwLs5AzKLDz4xK1vQfJm94sg0gSgkoBOIKwgSL1zW9YAmdVW8w6+xjsSZOufnV32ye5I2XPGkR04yV1FxFaVOk5mzYCBC+yte3nZInbpCbxuIK5zA2ZwjqtTq1jv/PCVKBhvG0nVvylKqY10eGECoCx317+8+RpKfwmwXOu2hAafBM9GudQ7rYhHMT0wJ4kuf/2NOdl0cpjUmVDZfXEFLSffvTvF0z/wUZUdOswZdOcTvzZfa6j7fFwrTsg552UDA/EY0lYY+K0Lb2QXygsBUhAPpeuK9f6gzMazD/I+jH7xh6+gjIen9BdKEwEpVxdlWZ2LRYaEn3/xWnVyKScjrxmROv8zmV7jXgQ8yOHzK5BVr//gqTVyQbBsJXUkD9uYvjieklcVbuzXWYRCz2IzKev8fQjQlxVJHPVNBizZCSyyIVsYplQXwfqggt3c/oslqNFg8GvMwjARL7y+zln1+cJqJtm3cOv6mLKsFgk08o6nrInvTlp0/SWckfUcSqMbKDcHGsDppBYZV0EYTNVzpeUyZhoRSWr3x7iFl4pKJP70VJHkAnmPhpEs6H4jJaEJ76OiLNTddbK/5aO/UNAFFmAMV6KsbYZG+YkIPKuCzbAS8KVagTonije0PydLqYhdPyCweY9GQfGHxYy9sYUWpK4PlZvtdpLceaCcuqUSASBRWeVSZdQrstwzIMPM2Nsc5rktvvXpxxyEW8QYDAD8coiVCYAc8UlS7Vp9VC5ECRC4gSBeYMKgPz7ybI8yq5CwLpLciok0AAumw4xia2X5r56m5WcvnmtoSHEMgvXOtA/rk5RWeRyaj/d63jW+WZTRhBsk6rMnruNjd8dF+hjb2hM/p7YlGOVLhiY2GJCd5sf+h1zXJywF4qGxDgBmMts7YlOJXtx1mRamviTT2PKDNbQOO6+x9RkvrpUUtHx9GPp5hpfmn0V2j2aFrhckrHnR1MODHImLj+FMQxBmdJIJw++KdffFZSz/ddZQVCCYXZ15X4SR4w1F7SrImHI5XPvrWkLYc1EpmHVRClFEwPNc8pF9Yef9fv8SUBe1mR3gmACQDmv7ltQ/jF90Yl1WtzWtUF7QY7W39Dzw/RdsaKbKNvqty7kshM+GHIM68kiG94QIngoUqBh7QJxXH5TSoMxrm5Lf+Iqf6l6m3vLXjMB1LRl4EmdFaPQDhYi29+oya+zZ98/eT4rbD4e3fh7YfYbcf4b48zO44HPn6UGjH4dAX3/OfHeLe+Or4g3/b1jCxMbXUL1u0Mhb7zbB7E1CoLLnCWT12hmg00WoGxGlZy3p9RqvO6tdZhuJsffF59Q+9cWjHcXH7YXHbQfaLQyxI3ReHGJh8+2EBvsCK2w4zb3596v6NX7ZMvJR+m1edWBln94LRkFv6Yp29YKluabrzDNZ2Bep5Jb2g7OCj7w5QkpD4ZQqbXu6JSSmPKxpRWIcTHKP69KacO4aOcXgpzIVIvyK+skFxsn/i3kvSCpOvb1iwuOnKxc0XmssPnkaHQgwawaX8bHr83M7bmZrSrPIQnkUIO748Mr2wqPIKV92CG9qucDWk3dR0QbLr93/dTEfZ+Muq9Fp09wXg7gE8dKM8LLpNn3QrDG3ybdqkYkPy7bFJtxsTbzUkwu/FqoW3x6avAIJAdBmT1QwaocRMOJi7YXgcTPSmbT+g7odJrzBgd05cvma9Nh0bD5SmQWC9wdKpyaxTXVtqhJA5uRSWA4XSLLxVnXSHNqUkNmWJMbkYftGlLNOl1KhTGjWZa2Ktgzr7qM4+Euf2zLE2xy665cM9ZyOkHSvaQMRT74npxKi14ImxouYDlP3DPWfmZiyNt/aqCwbm2QcMicsffxELeREu2hlKYGSIzMASC/ZjRPyRx3GKhiRC1G7zUoKRE/8NO2ZcxznfOADttKJ9jBd/EMRDHJZcj5H3XILRLETJyKuy1AYwI8rCtdhGbvUanINgefT2Xp29F0w9DOwSsffG2voAq8c6u+ML+3S2HqWpE+CN8box4ILWPhhfOGg0N8muufHODR8ep+82kgpRhLytVNq+HnCplqTKsbvP4YHwPNbZb7T3wCdIO8wZ6+7ROnrRmsGwwnLdBkcf8FrvHoVwBqJLtd2vNQ9CBKG89pYH/vrRaVJk56Iv+mFTkPS6IHeu/cYkFuFIiJC3svc+bVLFfPdwXFaNebn3LMEApJ+ZpYmHswzLRGU7PPM+EY28OAm6S7F/tAFm9qW2f6ruCbPuDLtJSSQV5qVGlpksEHMOM8vXvQ0Roh6MjM0HHJG7xhH/YGOJn75NIMdmYPJCgQ1/V9o9CnsfsAAiWSwIOoeN1j5ddoM+tey8zOKHXvgQ9PE0SxMXBI0TeShpuwcQBQAGiBcUrhFVYUDlGlHbvQoLeEk/9jVZwaT3wVoAhrF31DoI8RpWppx+CBb0haBTnXGWLtWiigvzKp549asp+u4VCR4lXZgpfvOkgQXb6EUaXfLCzLu24lcHpy/IXvVfBa26a27a+N53GEUytJ0YvTPcFhIAUnDAZcQhCGUJl3kSkNAWdCnC46IVtp+/PnPuu4fCz17NJALDUf2d6SKkQBAJRUZx/wYIbbSmzpj8bvDFsqwutdmjMg0oCjwKU3+MuVdh6laaulUFvap8Dwx5Hv6rzO9R53RrMloV11bOS61IXdzaOvy7/T9Gggx9vxKAHTsjLVOMWNmxXpdcrcvvAyuhNA/I8wfkef3qgkGt2avI7SffByA0k8P8sEpBr6agU2tqh4FfcltlC5fGp5UlFjUN/GbDEdJximF3ZEYK+dn3YLlo7YD0z7DRXnEIcDjy9s1pRlwzulF+kWtl1z1niGRKb9zMvL8mcmFUC+lVUNrjRAKuCJ0zWlUThHNfsDwXW4s/ezeW7iWK9+i7W7Tfi8UuznNfMeDF/wUkSatECmVuZHN0cmVhbQplbmRvYmoKNTAgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9JbWFnZQovV2lkdGggMjIxCi9IZWlnaHQgNDAKL0JpdHNQZXJDb21wb25lbnQgOAovSW1hZ2VNYXNrIGZhbHNlCi9Db2xvclNwYWNlL0RldmljZVJHQgovRmlsdGVyL0ZsYXRlRGVjb2RlCi9OYW1lL0pmSW1hZ2UwMjc3Ci9MZW5ndGggMTY4MDkKPj4Kc3RyZWFtCnja7b1nVJVXGjacdyaTYhcpdimKqCiKCALSO1IENSp2pUvv2LsmRo3diYmmGWOvsfeKsYsdEJHeD6c+fb/33vs5gMZkZtb6fnw/3pW9yIHzlF2uuxclhCT9aPmEh0SG0DIEDgk84iQkIBg8jxgRcQixCKlFnkMSy+sQzyCRx5cJHIdE/LvEi0jEf2TJt0jAD+UERqHFN8OjOB5JPELwk0WihB8Hf4en82okNCCpgUU6DUKMhL+UJ4ZfINELmwd5BLypZdAF6Ncj4DulVt9KLUO+RPzTkFpvy582RD8bUf9qevE7mwmTFgW8fJHFP/GNktRqDq0eTh8r3//+oYhk/a0OSPrAwUkfeN27h/rhIcEBiYiHQ8XHC2vBk8NHwyFeIwgqFnFaOGWEL8F/x1sPL0DwRw180EpwAPAMwIMOf8QPw08R6DzhP14QKQ7wHAWAjUhniQ+RlTAmRFH/UjKk/wDLVgMvlscLh3cIkkgmQKcBk9KJjIBxxSGGkTQ6/GL9YcHlEi9vkcBzHKxNlM+SZziBZUWBFVidxLDyxHh6CjokKWEz6J6wLfjBV4gylN8D0V8tR775rw7m/d9bYfIDz2mFZglJ0rsT+NNdBG/y1r0PS7HlytZPbvWHD1zwN7BsBW/9u/5bWEoElgIGj9A8P8yINLykZhALR8DILIFyAfwChhwuvRi+0vBIIxKYUaoV9QskxyoI8q8EohgEHBksvVZ8lzNI//UQyc0AB1HHCmp4v4jhwWs5pZpR8PhXeANHiY5ADimbYAaIY0QNJwCAYcIsiwSWTJjczPA8WR95OKCSIaQkvwtzUbiKJRvCIQJIjHwd/il9aBXi3w68QcJ7Q5LHB47873D7J2z8GZZ/wWZl1H1gaq2e+Rffvj/N9yb5pzdKf77gwweL/0ckmsDJcoAOiZMkDYe0AEsGH61+qVgawklywIskLARZclIciz8JnMgDc+REfGoMYR2yTOXk9WCeJvCCxBFKEHkJQ/t/guJ7k4fBg2xFGgnpgIgEpCMvx5yYE1VI1CCdGqnUmMMpYEiY7zfqgNED/pAWpDHcgfBQibxOFLDElhjgu4LM8wk28fc8vEgQMVlJ8gsw5WFMapCgw9si/hlircZfwpKnsyWDslv8KulP+JT+xGj+fnNaX/Mfb3wPe++yRFn5eEfZ+K9h+TfT+HtYEsaG5R5gRmreQAw2kMwssBY4C1EW9SInMQKIQyqkZZ0BjhaYpQ5OGvAmSAJL1DEthSWvV7P0TwZcSsApJcx54LPMrv9SWP9pva32R5CogIUJaEXydpgmTADYHX4Fo0WgWzIqpFaginJ0M0/1457KtVtKVn9Zuuar0nVrq7ZsFfYdRnceooo6BNoKfgBZMJJ3pEnUNumFBWAVtACe7BBDVkOWoMOsErgtL32A4QnSfwdLShjvgJPeLMq78z5a3t+q/x2uf3PZB7RWsYVd/0nzpN9K76mg7y/0Q/P8D7DE12OOJ0ryporNc4ON0StMcBbAfZRYreLBQCAaP5ahYCsIRC1lWTXhuoIgyuimYBRE/enIjJFuNi/bLBK1L1pzeek/kKGeeAWJMmNeI2pBG9TzcwIpYI8qBhW/5U+fKVyzJi8u9mxw8BGHkb8NGLTf2nq3peUv/fofthl+2dPv0ZRpJfMXVG7dih4+RHUKvC6tyGl5wgpBHrAclSGY4jhCnRS3IpYhElHjKfxaVBHp3dHqqw+cgdDMJPVD3izpQ3rYO7vxoX36K8i2/rP4l3L27/TPP7GOv4PlB02B/xWWVCUDVtBsQuLveNQijAkstUhSI7BwWawsMng+cDoaMBkoCYNYJFROJB1cgVU6Dpu1nGx3ku2gBgpBpoRhSRQ2QgDy+O+lObVxNNgiEykZiCpe5j1lTejcnarcLy+PDPjddPC5/tY3bIffGG5zwXrg+cFDLg0efnPwyDtDRuZZ2Vy16HvVyuzy8AGPvwjVbv4GPX6GFBrECoTvagVOrT8g8h5sUWH1Q7blKer0ujRPT/lD05X+Qtf/O7X5f/r7h89V+ivD5ENaotDKsm4Fy3ft8b/AHPr/eOgFK0AFhC9D3SESQSdDzoHAksNYlDBmQI9S1SEQbnU1SAsaHYgxfBc+Gg3Gg8hKWgnOEjRSHZhBoKDC4RKuKxHMYSuDIfgjyBfwJ/F/hWWzJQ5KANYWVBIRriDJwe4CBfNBwfNF6y95TjjVz/Gyud29oaMuDBl2eJDVNR/3tzHRTZnzlZlLauOzn4VNveTkesZm8OXB5jdsTG9am50fOvBOxGR+7yFUXYd0LNIS/g88EvslAJ8qCkuyFMLkmzdQkrWVZi/QX4/WMl76z2aR+Le2/d9hUngXlu8wtD/BUraU3/EOiJIekC3GuPgfCUr6W//Jf2vz4AFCWeRBHGPMcIQdSFTR18o+OEnLIZ0Oj5o69PIVc/SQ4tBePi8P1TXADSK1a+DQGiXUxCK1Fmt0nBIJKjDnsQGMrRx8vDoCXsAOJ4t5gkdRbA3Ld5iJ2Gxu0yMVZFOfbiNY1AIPeFDz2NUo6TSosR7Y3Z3ZiWeHul+3HHl7iMtJW8fj/gFvNq5DedfQndvoRSEqLENv6tCrCvSsGD3Krz6873ZOwm/ONhcG931oO+RKv/6XnN0aN21DVXVIrRFhLRqCTF4LLyCSm9jvoLXifcFwxOoD/j92SRHWLxEnGBJa5g0aACNrNCLTIq8l/h18tPZIcM0KtH5Q9yyFHEcYNU9IWJA+rDzgjZXBhI3UZhcNnpR8By/qXa8cgwcmNyIG9d5P6V3S4fW2Aveev4G6cJsPC4YgyPNs7R3iWRnnRNq8Q2XCO+Ifu+/IQwQW60hgjjfvhiDoXTcUkMBALt1Qrth00cU/z8XlhrPjORfP8uXrUK0CNSiRigMLAT0pb/rxaNNPh9CTQlQJ7FQHfAbDnRMFRiRGBGoiYFeohZbNpwcn8nS0dtO+P1XqnqULBAUBD1bgOWw6iSxqrEX5jw+GTThpM+qWtfM58yEPRofz3+1ALx4hRRVSN2LRTKzo6sJqVTUQDtgrHNJqkbIRXbtYkBB/xtr61kDr28NG7LdzrNi4HZXXIDWHNAK1cDhCqY0MKipVYuc9ryYYa3Z68KIs3/Xno/9GFPgWZawZkJxO4lmJ+Ol1OoEyEo4RZFWA3k/hJ+rpkeGIqivp1X49P6QYaEaj0KLQMlquRSgD8ASOYAMxLLYP5HnyeoUKRxVkZzIRYrIpKpHZUf9hs28Wn6qAPnRYZEr8O9xDD0iB0ahac2CEzV9BxqQgvW9tEQhimiLmCTyJJ7YOzB3bszVV6PHj4vmLLzj7nje1fdrf4YmZxUtLq3umg04OsH+9aj2qqkVNKnQv/9LEqMM2HudG+h138n+9+EsMzka1HHoRUb0ahCKqk1CljiitOtlTDXtByYmOFir/oLAQhBZ8ihJ2UgGT5FikaJBu393jP3avtfNFq1HXbD2LE9PRlYuorgzzbZEHsgN8VenQ4byn9qFTFq3dhq0LVm8iwWQqGlXf/XLe0//EwKHnHFz/bW3/BxBdaT1S4nMEMqoXUH6FNG/tgfAZ87FHU1SIkgLfSfVkYkeLAt9C14TSia5CVVARw4ycPpGw+HR4QXzfJwOPw7TMtLI4eEKGLLkFgwQvRnz3BOFbjn9Hh2zNk0jQQoSjbGW/aBnMG1nKd9lmbqYXUjRagd3XRP/nWVmUA5D4ZiEgK9ctk9f/IuKQGuGZrSQ4zzAUiLLewAmtGaZMBZSKsS5H3CmyfAEkaiXMhuCJRKFSN6Cb16+HjAUDId/U+nmPgeX9bUstB1QNGvrGwvZWH5uLXkHo4FF078HTqNgzFoMKhjjm9xl0u+eA64OdH06OQTfuoSYdqmoAIoSX3S0o/vnUxTN/5B8/e7OwoJoG+wTxHXMUie/q7LIf/r1IlyzEiDXOYOdkZcVvKZl7R0eccA8/PSq0IncFKn6DlHVYkUBcfaMKQFPNognpq7r5TvlsRMDCf+9WSUijxJywSUHkI6y+Uomu3z0/fvpeZ5+9vmHbw6fUXLoNcAPCgqccuPrMLjS998hZPhFLNZjnN3FISaJbdE5EnIutHVjow5/Jr6CESwRloKlify8YicS1JRC6RC3OC0n+DF/xHMuJLYEJlsen3zqAQrYIczxRFrVakbpYqSYvh/+A/whii1CGD1qdzFQ5BvsJZU0JBBBP9lZkW+Tvu+N9jauV6G9tmeoYXo704YgwK70X5JRkNsPBEgVZIYat0LIsw7M6XsOK2AMpYlGBhRTSNaBH926Mn3jdcki5uU2VSd9Ki4EFZpY3u/XMM7X8w2II2LOH7eyfz5qFFi2+bj30Xvc+dZZD6swGVZoOBABfMh+S98U0dOM2UmANDTTBPUdPnb79eP0P+4+dufEkv6S2rBERuwG7BJth2bwiEk9sVj3otyBUlQxWGWDDYeiIK4VXNUn1DeV5d2rPXFOdvM6cu43e1qH6RuzgAeLmqVmHqhuRbcCM3sEpnztPztjwK46oahikBAVYkhhRjh1WKNHrGuWZG01nb5adv1Fx/6mgZkAZrpbQmt8udHeJ7u6S5BLxFXDJBqRVILhfxB58VuZKhFreR6bM3ckqGOzexbBhRH0kVOLoQcj6myRRwGh5eU+adAJD46qiPLhmawW9H6yh3nkaL1aIeADlMETDaBUHFOmVTQyo5eRb+moB7DyRYhhzNgrjZntcEDidTuZpVMS3CmZJgvSeySKbKnpvrIb8ZPQMXMcJ9APwaSpV3qVapGZ5rPWxohYvB7uGdZJOoVMgVoN0yqdffXXEcnCR+ZB6476M+aBXFn1vDbS67eF7I3Tcs8TEylVLhR+3FybF3rMf+bLf4MZBtgWdu1aa9auztK7uPaDEcuhZi355kyejJwVYgnLo9zNXrjx4sWPfibuPXr96Wfm2oEzQ8ticF7lmId5sPzbDkiqhGl42wtRkAPtSIlTPIFm9Y7GzACl52TNN0E43Qa3BSAHKqFAjK79ZRqOzPnGNT9p4VCkLcYHXqkByAOA54lWVXUzYPCOuMBxZR7UILf3llIl7TG+/HKep696K+C8KMgcVuRb7SuHUBJ7oGHhOoKjzvMyU4PQ1JBal0U8eODSNOAjE/qXRMR7JR6khXE4FqrggL7mBxz+15F1qgRw3Vfk4FngmvAkzJQETLFzWhKkGEdqRp6cT9KYNkdQC8brA35XEDsXeP0HWZdQSVlv0yQNYC4U90OjE5hQUEA864rFhWzvYW4XssVebMg3y/CYJz6GJ7BWsC8gNVOn3fLWgAlMOD8+EC1QMR8kQblfiVUhKCYcRBSoja+vyl68+1X/oGzMbXc9BtV1NXw4Z9DjQB33/I3ryEodOKt+gZ/frUxLzB9gW9LJ61duyZMDQuz17P+1jUWs6sKSbeYWDw2Ery4I1G3DsTyMcO3zq/M37hZXKX/b8/vh+kU7BApsC+UVVLjpIMg6JTGLJhmECUwUZDGusVKOnZcqrj98eu/ni1J2iR5V8I0JVHEGFVqBbWVJR+7Ss7HV9fW2TFvZTp0UqHXqjRAUMulmHugXFdxi36COXxNjNV9/y6GkJU16nqdOoWBLlh+Ooa0JFb/myKqEJwCwC71DD1GCj6hFavf+0kfusTi5z7KZ+XYFQAYsuv6rad/X53ouFN541gdZKlWU9V5IBBn9s4PC5vGkSrjwrO3zz6b6r+QdvvbzyqrFYhZk/rJiaPCKhAw2HKuuF15W6kgZUpsS+DYDW/Te6I9cKjl1/eerW87cKkigCqNMwoswwQdjIfv46HSpVottFjQeuv/zt8tOD157fLqyrUGGugLHDccDxkCSn1pQ1cqUKsbBaW6XCjj6499yDUljR4Rsv7xY3VmhloqMc4K0G3XxVd/BK/s9n7p28++ZlPf67ltH7Gwj/FIgHXMvj6dVq0csq7cX7r/dfegQPvF7YVM5iqoRJqjgB/2TRm4rGqgZdaZW6GfOMJCfbKHSopBqVK1B+lbaBbKNE/ZYAJC1fvXvv6ZHuT/rblnfvX2E+oNDdGV27ACeHzl7ltu9Eh4+hb3c+c/R43mfoK/Phtwc6oBVfKxNTrw0ZXj3EqaK31as+ZjeGDNkfOl515TZQbENF3d3HBY9elOY/KakqVVAgEa+70DwkvewAtR+0KSBzMH7hgPZcyE9evdNtSrrd2IThYSm24Sl+sctjv9p15H5RFXHkg90DuIqeuzQ8Y75/TNqmnw5pSdy7oIybMX+Dd+Iq39xt7QKS/jVm8cfBi/pHrAlO3Tkla+v4uAWPSquayMJL67gpSWsjUreGxizfuu+simS/4bQVEWNj1b5Txt5RXXxS7aO3/Hy7PO7rnx0jsgYHJw7yT3YcN3fO6h9/vXSvlsW7ihVV4AmEH75WcufzS3I37onIXOsSkW4zJr5/UIxpQKTtlNxJczev33W4Xk04LYNlGexHcRWTufzbsJgV45PX7/j96dkn6rSv9zuOTbcLTR3gM9t+bHx40tKVOw8XKUR6xIomNWVS9UrdySv3F36ze1r2epdJmf28Zw4MjB0wOtZlSvbM3HXf7jsHijOW77wEAz4U17EhkTkTU7/0mz731wtPLuVXxi3dPnLKvIHhGVb+0SPHpaWs2XP+uaocoRIR7Tr3avaSn2zD06wC46wCYwYFxwclrZ2/7eibeq5Jy1OzHXRd4GTUU3j9WfWyb4+OiVtiFxo30HfWgMDokRG5U+Zt3XHsGhCagnhEVKy0YfvPY2ekRiQsufWqhuobTTzetNImbvX2veOiV0xOWTcpdemdkiolye/Bt8E5AcsoryzNnH91gG2h2eDC3v1L3EbpkhMK4hMvhk867e5/L2DMC++AR4PtnvUZWDjI4ZadK8AVvSiozMrN6zespO+wErP+T4Y6rOs/DP3xGDMCVlRp+NJqhY4cnoA1Ourcwak6dFDxQa0ClgH+gY7ffD0mcdPAcQv+MWKqcUByF5/kjq4pRt5Znb0T2jlPsRqTsvyH83WEZwLSbfwiTANjPrLyjVq6o1rE5vOtlw3DQ6INnSa2cY3pELzgn0EYlh0Ccto6R/fwjms7OPDis2oVESWFFayFb7KRZ8a/bCIytx5T6T1YoD8AblfsPtfRJaq9d0b/KWt7j043dos0cYvr6jrHIiCru0dqO+dEY8/EdfuvKolI4sgBAZjzKjSDwuPbDZ9k7Dqnm3tKR+c4Q98Uw6Csj90T23vEGTmNnz1/Q15hQwO2pLFoeFjS4Dgx85Phszt6ZDvF/HvY5JWdR07r7hHT3SOuT0Bat9HJn42aauAybeK8zRU03MHhbQRc/n7uqkNgZFeHKYYukcZec8wC0js6Rxv6p3f0jO/iPK2Hy5SJOVsf1WC+R+XpoyqdgUOEsVfqx8OjRsVtc4v+us2ISZ0Cs/41ao7F6OzerrEdbKc6zvjqwGO0+lBhH89MI6dkI5fUbt6ZPQNSjX3iDTwTP7OdHL3yl1Id5htEd8WyHjbttysv3SJXfzpsiolHQlfPRBOPeEPPBJPAnE8dZvX2iklbu7tUIyhYoEJ09NwNa4+pMOGQjM2gFNVL2IUIT/jlwuM+HlO7e0Z1dhgf/+WWIq2uEWvoHD4J0MaaGlFjHcp/UjYj6qHF0NJ+Q1+Y9b1pYnK9t1me9dDzVjZXh9vf83L5w2FI/gCLZ4MGnrMc9Hx2DHr1HD1/UhGb+Ec/2ypLhyf9Rux1CkB3nuI4tZZhQaumbjKBweJbnx7SoroIoGoKOo6h2Tu/nc4bFbGgrd3stq5JXUMXfu4e28Ez0dgn51P7OCP/lB7Byd08o7o7TVywYXeDgEqa0KgJqSY+ie1couPW/FYJggko90XNyNDojsPGAKMzCFnSJmT5//HNaeubbOgbb+Ay3cTxi9MPy7XEDfy6ircMnd8tdHmbUfHZO85jIcUCG8abAZ/X7LvRyTOh0+j5nfyyTQPTDRynDwjJsJ+8pLdXnKH7HIPRSwwC5hm5ztx6+AbW0hnMNgE2hSwaGZGF0e4YPTh0nlfMN56J6wdPX2IAE/BP7RWU/Llt6Lj0dQ1YNWVh7Y+qtG4xqz52Se88eo2R34KOzjE9fWKtQpI8or/q5hX/2agoQI5J6DyzMZkZ2/c1Ui873iqhpLo+YFpOd8dpne0jLIKSvePWh2TvtJq0tINHnGlwZnfvxHaOM5O3/F6gxrCEiT2sYrv6phgELu0attZo9NIOTlG9glJ7jV80YPpXvX2Su7vG9fTLMfTJ6hY4zzx0SVe3dIDloPDlQyYs7+43x8AjuoN3eu+wJR1HRa7eewNAXtvEwMHCeQHjtQ7L+MQ+quvo+YD5Hj4pfinbnKO+/th+hpF/lqF3alf32XM3/1KP1WAB9NiMr/ca+WSYhuT8equkjnDaggZxfNbGLqOmdw9KGTwh68brWpwihkD/aEKNjThvoaBIe/jI8+y5976Y/GCU7yMr29J+1nWDbACcj62HHe1nU52Ujc6dfjpjwiWbflf7m98b7nR46MjKnT+gujp08NgNr6A/+gzNs3KsXLkBvS4j9j9DQx4KRS0isR9Bkr26zVYYx4KaKNLI5+UXtaOmzevgFN3Nf65pSK6xe8zMVbt/uFp88G7Trstvx2dv6uU+ydI/0txt4neHL9WxqLgR2YXFd/NL7eAWG/vl7kqiMJc1SXtO5W0/fm/xvkfGwfPbBy1s45fpn/3dxtNP1h2+tfHAxcJaliP+jbdVuoEh2T1CFrYbOXvuv09ilZUF/o0dkHCUi3+80M4zGYDdzjdj6PiUHafv3a8UninQlaKmpE2HOvnEt/FJ6uAZ7xa17FmFlvB8HrvbEDp542Xqon9f+KP0WanyrYItbtIWNfEXH1W5RuQaesYb+iVbBKXuPJNPzay7ZRrHmUvae2e19ZrX3TfDZmzWxsM371Wyt9/q7teghE1n+oQubO+zoKN35oDw5GpKywyn5TQaSdr264mcr76/+bLieY2uoBE9rpJgesceVAyfkGPkFms2domRZ+zJh29oSPllHdvZObLL6GUdA5Z29Ez3iFr989Wi2w3ongIdvVfrPnNFj9C5n3ikdAnObe8ea+Ydt2zXxfwG9LAWXXytjPtmH6C9G3AJ55gvFv5QppODd68bBa+YlcBIYXq9gud/ffDRnVLpUTmbXy0ee1DlHru6s0+KgXeSuW/UD6fvUAvu6ou67l4p3X3TXGctKQHzAaHdlx6YOEeYB6eaeEZuOvZArcURbpAJiG1Er4ue5y7M8wu/ZOf+o+kgYeV6dOrCBRevF/2GlZoPKRjm/PtA+6IF69H9YlSrQ3fuPUqec9TW9paV/e99hp8dH4kKKlBx+bPFy/cMGPJ8ZjQwT8SC3sfWsiolzzKyx4QolbwgZ4e0hOGAv+OqBJAOyZuOAcBMghYA2TpMW365kKvWG5hgg1Rw6PLzCu+paRlf76rjEchx2J+hofHdAtP/aT8tavmuOmpP86iBwXc9YVDPoGxgd5+6zUnZeqKaPERFNofB4S2ppELVPzC5G8h3u8m5Ww+ziKRIgX1NpN7y3VfAim/rn9PZPyW/Cd+r1I+XWjR///V2PjFdxmR9aj/p++O3gLQYjQZULqr/4yx/JAcW1AJDE4kvPG4w9s/oHLTAwDN51vKfYSbA8O9XMfbT53fwSO0RsqiHZ+zGw3l1ersDllAmoeD0H9p65AJztghJuVTQiH3NHGwojm7Cpin0rohmlwXc9e8zz3sFZHQPW/YPuxkbD11VEpuioEYL4hX4ZCf/xX3DFh24VaLQ+xZqJfT7k8aOvkkG4xYZjJ3b3nN27rfHYBr1vPzAZ2o0YtZKo4AMkFzOkauuPIGzwhrjloMXO46a0d47vfuYRVsuVdWSCbD60PSdKtFqyvJO/hmfD4+YmL0ZXlTawMBPI6cZPX1Tu3vFbj774jmHfOKXdfWKMfGIDUj8+lk1zhzEiwE1v67yQVb2GZsRd/sMLBridHKgHdr+I6qoRmcvFLsFgvlz1zsAHTuNiupQvYid1I06VPYG7dn9OnhSvl3AvaCZ6Fo+2A8NW3dcDAwCdorqK5Cg1AgqGmNXq0kxgo4nSUZ6WLa4vXRqLZAIuvyycdDExR19s9r75piHL7hVireFXtvIypsPmvDTiqZSNQkLcthaHD4uyTgwvZ1rbMKaXxppRJDlGUZUSaiIQaaBqSYhCz+ym56x6ZCC7CRHrACSJy4UVygHhKT1DpnXyXHGgu3HWJJ2yjMcvLGWR/O/P9XRK6GtT+qImDWNGACCVmAV2iYW5/uhy6VK6+m57UPS/+UaCcaCipUDiBqGY1slU+rIuVPAlEpowIxv/uk19yPb2ZMW/qQgOQV/VGpdIxd3cE8w9k23n5hZIRKHD6sC4NUq1XC4u84WmoUva+ORahaasvbQZbARWEHQiCzx8KMGVnYVwhYpic1VLaBXAhqV8O9OQUs7+2Vlb/qtkcdegqI6pr3DDPOJ6z92TJqx+liJChHDXmA4TDWvdWhk8uaPPOZ8GpxiGBi1/49n2PwXGaW6UYtEYAsr9t829k7qEZLVxy/mxI2H+I0impCyAiRvG88k78ydJWSl2PODUyaxAwoIee2lEuOQuQbu8U6T5j8p01DyDIxfDXy7e1COzex1i469+MRxOgg1UDCO3HqtJt4ZkpTKoPynByyHFFrZlvW1et5/wFUXD3ToGHpT2rD9u6tOboq4OFSUjyqLcDSZWIOiClT8JlT7Ft24UTEm4qGt50VzuwfOQS8DJygi56C9v6H7eai2FCkbMNxolQNxjAg4tME1Jw/IwQJeC+QPm7DlyB+fO0Ybhy77eFTskn33Gmmglhx3SzxIn3KsEbCLo0SLbMelGAdl/8txVsraX5twRidN0CK2pw6Z+s/pFrLkH3az5m45qCU+W5KRx9MI3atKtVVoZp+wRZ2dZs7fdpyldRJk6wAz6w/d6uIT18k7wSlyBWZfLEm6EHUsq9YIYhVCCVsOfxaQZhCS6zwp52mxEuam1XE6wihAuj0oUe8583D7/mvbD+ftOvv44sumy1XIctaWzmO/buOWFpb1nYJceaukyWX2ImPf1PbO0SnrDxDaYbETXQRFTGhi0B8lDFBrB885PQJisrbuo6vADhlOArQAuuC4fzp668fjD7fsu777bN614qbfHqkdk3b90yO3vWf6/G2HgX5h956WqsEk6eS74HPn5Pk/3lJjL66OBGpx3AqsxRkbT3wakGY4fq5tzOJrr6swhLCrRqNlVHDxoXtVwPRMw+Z2cZn2y6mb8JfH5eoBgZEdfBKNQhfM3/f4DUJVDFKLWFTVM9j2BAF9RY0+90kz9M2wCk5fs/N3lkz+yJ3Sbp4xbT1SOgTMNwlbDMy2rWfqrLWHa4hqp1MLpOyAR2cu5w1yqOwzoNFqwNN+Zg+CRqPLV1F17YEvJv4+eOgZRwftiQOIaQApxal1NFFGxWsQo0A7d16ysCqwsis0tSmwsMvva3uv/5BLg20uBgcVrl2Lampp5hyrxogm6ZwgemjAv8W/ir3rAsb7wm2HQeEHvdrQK/b0cwVHC190AqsCwUg9nDgJBDRWknQnaSX0qlG0Co7tMXbRx05R8V/+pMXsDidFIDC0gD+okLnfHKPRi/8xIjpnw17Mb/F54kRTlkQ6ntdw5qHZ3UIWtXWYlbX5dxyYIGIXOC1Q+po95w1dp3f3ifOKWqojcp+kGeC8J4HBRLHlxKOP7KK7jVth6R91/sFrKkYLVWjH6QcBMastfeJ7u0aajJoF4snIO66ta2TPcQuNx3/5qVdOR/fUCTnfNRGG/6BK6zJrQRunGBPvtMU7L1CXnYhYDaPAmf9gqpSph36R0c0vtqfv7Mwte9Uk8oUzTHVo7d4b3rFfdnOdBW/p5hoJH4zdpnRynWY2frFZxLq2AUtAN8jasL+GuFhf1CETr9Se4V9+4hC3av/9Rhz61mCRqVWJLC6lS95+7l8uMe38ktwS194pUzKYD/CCTo3lmYSuvlQaOU0z8kvtEZj808V82J8Dd8osx2V+5pUB6nfYsoNJW8/kbDuRueHggl0XkzYfS95yPH77mek78gzClnUJnt/FPXb5d2cwP9HxQNERi7/r5JtuELS0g/c8Y7+codOXnixswCJJp8DyVAOD446duWIxrK7fsCoLiwdm3a+7u6BTJ9Hr1+cnRZw3Nb9uNfjK7ATs1WSx5Yh9jkBkIJdrG28Hhj/o3b+y3+AKU6sXPfsW97Uu7m1eOmAwgHP/ANv785ajKjXR5DCXI7qQQNIseMqqmzOmMMNn0NwN+zo6RoIsGzl7+a1SDRa0KhXiJV6lA5nFUXoQSTGsyILWDw+s4JFdRJZB0NxPXOMT1vyKdQYdrWvAgrigCZkFJHQOXPyZU1L2+n1YpGqxZ4jTJ2vk1/CmY+b1CFvZ3ik2e+sZFQmOqIgYhS1a88uZnp4zuntGOk3KYIl3V/bh0xR5CR26XvaZS5phyHJT38gLz8oaiChM23Kgy8jJZj5JPdziO4+YZug8+3P7aR8Nn9TBJ6GdX0q7gFzD4EVtHKImZn+rJnO487bJdcYCQ4/krj6ZQBoKojGS5B1BIPGdp9WsG0h5x8ld3WfkbDtCkkVQcYMQNX9Td7dZnVxjuwdmdnSPazNiUpsRE9q6TP3YcVpH38z2fgu6hKzq4JaSu/kQ2IawM/nVqOOoBOOg5Z87zVn0w1UccmJVuMwEZ8Fh/2HmtxcMfdO6+KR6xK+9V6IhDlxJLmVG6NLj6s4jvjANX/iJw4xNx+6Aov7vSwWmYTkGYSs+9Zln4J3S3n5qN5cZXUZOaes4u5NnwmfOs9u5x37uldwOnhmQ0dl5Vs43B1WkLAe01rMlvHFQ7meeuV2DVnw+Mn7OlhOA1RpBh+sEOQZPScuim3cvWNi+7WNd1se03GbQVZshaNcu9ObNdd+Axz3Nn5lbX/Yej64/ApCIWjWOq8HTNRy6cvOGk3e+2cBnpn1f9R9Y7e791tauvLepwtyyysL6tqXtHvdA9LYeKWT6Z0TKLUn8vTUsCeOq1aKUVT8Yu88BWNpNX3ynkmVxAjFDq2YYTAosqS8ipZgiAwwPPhU2IevwpM6jc//pFBf31a+Ngr6KE4xVAIkWmQUmgrHw0bCoBVuOsMTqhxsZSaSK39M60SxsvsmY5YCTnG1n1SRSoyNMD7jBpgNXurpOMXGb6Re9BF+Pw7QiTYKStCLMZe/FwrYuqYbBy0zcph95VFqB0OoDFzs6Te7hn9LTa45NaGbCyl/nbTmRvfV4ysZDkxZ/ax+53DAIDKic9o5RETnbaJTwXpkKYNnJJbGrT/bcbRfq5d2SEwNgJk/qkP305UZeSd09E9K+OUpNtvU/ne88LKz/+AWfucXYRK6a8c3B5G370nccit54IHD+TpuojV0CFhqGrGjvkpC59jeFiKH+pAZ1ckvtHv7VZ47xi3+5gcvoWI2Is0WwTgWmU+6357u4zTHySPaL3/C4FMflBX25Clx8+VldJ7uxPUPmfuY468eLz0FA77hc2Dso4zPvbIOQZV190kFMWwUkDgpN6+mf3nfcIhD3fULSewfE9w1JNA2M6+Uyeenm/SySYbng1yugT7b1WWgUsLStU0L4vO3P1VhIUasYbzHYRg/zb47wKu41pM7Ustqi/92epigyHq3Z8sbRu9SgT02vQffs3NFPe1FdNVI1oCYwShtQY4Nq5/c3HJxuD7S5bDuiMSkVHT6mjYl/2qNXZbdeZV1NnwwcftDLH70pI9VgSKClQDiqQ2I6rYT4/4Pl/4Pl/w9hCZ+VagamtGLnyc9HzOwTvtTYP+FYfi1217CkbkPL6khGF0nqk2jtNqwArJ5iNRo6PrXXhJX/cIyN/WqPQiJp8CRXEG4vUAMskw2Dl7R3Tclavwfr2zgDlGckOa71DHTLMTndxixuN3J2ztZTWuItYIg9Wy+hL3efNfGYZewV4zxjvrolWwyAy/I6rPXtuVT40dBpZhNX9/CJ/P1FI5iigydkmfinGvokOUxZfKWIr5Nkh1ItqIIiOl2gMJ+0pPPouZ87zJqYs5368W6XKF1mLm4/Kqmrd07u1vN1RNuh2WwcSdt4WIsGT1vVziOtm3dm2oZTjbhGRBkS+5WJa2wXvzS3rO+PF/NFxAEIx10Kq0Zo+4166+nfGAWvMPLNBiFey2BcPatGAH6T0FUfO8Qu+vk6hiWvxZngmMKwty3736c7u8QZu6X4xWx48hYXtOLOIjzOgIKpXnpZazByXM+QHEOPuG1HboKSc+RexeDxOW08UruFL5/766OfrlUeull68HrxrguFv/1RvftWxa833uy7/uzk/eLDtwr3nHvw/I2CJwGL629V1hNy/jUqoYP/kjbu2d385/byj1/8/Qkwl9RarH1pWEKyb4sfh015azOqrJtFg6llRV/rF30GFQ0ZVWBhW25o0WAx9N6A4WjBEvabr18szC1aubJoyTJmy9aa7KxLQ4cdtxqYN30qevgAXc97HjbhVd+Bqr6DG/tZ37awujtnDqquQiS1T2QluXcHVi2xG7MFloIOzGfY/+9PP/4/w6Z1Hbvyny5xSw7crxFwJgM23DmB17uRadYBdvIIPJg8pVo0NDwZVCmAZfTq3UriKoSnSURDK9BhbmkYMP9zx9ic9b/h4Kpa22xtAcBfVWv6j8nsGbqg48jpzZa4QJ4PiuLyn88b+yUZ+qfaz1xG45KCxHGMWhKw87wGoRW/XersFWMSmDJi2rx7jej4C8EqfEHXwKweQek/55XUk+QcjY74TAjDAXDazF4DBsLH9pFfzP2eIjbvjcpt9nIMS6/seVvPNxIfo77KHj/hYT0aFLXpY78FRn7zEr850yShs7feGAyd3G/MMpPAnH0vhWrqTeVBPdRoJTCt0YNG5JWy819uWe3dU7M2HajS4AjUsyoemCGYPJ87JSzZfRPHDhhQXYFIcQY87HbmjjMGbonGHmn+sd88LdUJchcTnMgHzzxbUNvBMbxHSFZXj+hfTtxoZNHrBsltSuZn9jON/HMW73lQSzOXGFn8qeiqcTZHSxmjVsc06bQJ6/Z18ojvHLiwa/iXwctPtHVN+NQxymXW6vuvWLWK6PAg0CQNqiurWrH6nMWA0n7WSvNBVd36vek+sLC/A1jWL/sNe2A2oMjD97GbxxXrIQeNu14ws7zYuz8A9amDW1FIWMO8XHT9PCp+KW7YftrCtszcrrrnwDd9rX83t6j7bitqrBQZDS935JBI6RZJhZdapwHrwHwGWF4vUlmOm98pMBeMu75fLL7yhlfqU8hIvwGai4IKa1Q1xBSt0YpgjTpMyDTyz/rMeU7Mqt0Kwl9phSJcX8KhPn5xwH7bOcZkrN/fnJDWxHA0u/Z1tdoyJLVHcG4Hh2nztx3FeCCFCTwJ1K7cc83AN7Wtb+agaSsBY1VqHdleQclhd+IjJfJLW2PgObOz2/So1buea9G5YmQemNXFO7NncNaJl8pq4mWlaZZgKtXpODg4q+mrOgQv+ad99IS5u5QkQ/LWGw3AsoNLCoWlQqSkStwVAjaBH9ZJltEbP/Jf0ilgUdzak/DqM7cKersn9Apa1CNs8eFXgoJ20cF4VAmcWiOiu5XIP+170C46eGVkbNinJok6L6oYI5eYPmEr2jjFLfvlJktgiRPVibZfKaD078508kwy9Ej1iV3/5K1KQHJfEZbA/nRBTRv7MX3C53YcOfXXk7doCWpI5Fyz0WmgKnjGby7hUUUdUXJwzxxcCqvD/AH7RSWcNIV9ggw5aPPAhI5uCWCAp/3y8FgJAtO+T9iCjg6ROWtONGma80l1SFePrl067u523dyqwHTgq14D6+x8bvUZerWv7ZNRnmjZSvTj7qND7c4NGPzCzvnNALvyvrblvW2fmA9Hq9ehO3+gmjJ06fx176A7lvbV/Zze9Bpyt6/17ZBQdP8mYht5kSGdK2iBFZEKfIsrkhARy+nAgkJVAkrcdLSdW4xR0Px2nqmucAbPVXWEcVXyuPiiRkRXn1V4TU3OXv8DjYMUq5D16NheofPajIpNXLOvgdQNI1L1AttQwqJeXrO7jc79h92stM3HARXlDMnaEuh7xcJKZb/glB7B89o7TJu39QiGJS5eEBhWgKNc8evVNp5Jn/nldh6d/VCBbfMmsP11+PgBcl+fut/Ja6Z5cGpn+/CtRy/Aw2+Xc8PG57R3Sug5ekHmrsulxJyHyVeweGkA7EU/XjAes7CN/8JPHOMpLIH15ZXoXGat6OiaauKVPXfLGcotcRU8KcOBY82v1ZpNX/WRT27noAUx607AXRfuvurhPLt38KJ/OkZvv1pdLWAHglylIWK5v3D7qY6OkV3DVrV3T0let6cK6+U466yL0wyYW1u7mct+vIpFA8cQOgS5iWGZtuN0B/eEjh7JHtFfPS5VcLTFiIQzIVWEW7Z1GNtr7MI2zpG/nH9EknXRjqM3evslwA6b+GUkbTqjwKEKTFIsyQuCtVRoUEG1ioaiqHb0WoW6uEQaeybaTpj3kkPlCMWv2tnDM7anZ7KVd8rv16uA+IlTSsRum5qSqh92/DJs6KURzhdtnA70GVI6Ke5B8ET066/oyRP0tpo7cvZ+SubBIfZ5fQZX9RtV1nPkwz4jpWXr0cMn6PSZB+O+yOtn87TnwGLTYa+sHI4PGFrz1deoohSxSkwv1GWD58uTVjPvwhJvDhas9Ty6/loxYnJ2G6eo7sELuvgk9x2b88Wi7zafzD/9XPjubFFYylpzr6lWwbHdHcO37T9XK6BCBXIE3XJ01id201PX7sfBMkZOUoXNfKtFIyKyugXNbe+ZPnTS4h+uFt+rQz+fu5+6dP2bGiUcYmGlul9oVvcxi9o7R9GYOK0ZZDkRw/KXK+29UjqFLQfuPXxK7uYTfzxsQG8llN+IkjbsM/SN7xGabegSGRi99EFJFRwBUNDomGWmAVlgWViMyQKt/okWvRZQkYT23K4YnbLG0HN2x8B57QMWtnNJmjzvRxr9uVvOuc5e2ckj3cQ3N3f7uUaa1EzbnfEMbExRnXbArNX/CJjbJWRRzDfH4a4XFY3jMjYbeyZ1DckFabj95PNyHarjUS2HTt0p9pqc1d8vsYdfZme/+YCxpLW/1hPOBtzSZNQMi9AFnUfO+vJnDEtWhx3AIvbe87CZWd+d7uSZ0MUn1Tth3YOyBpaUTgk8w5IQ5KWC+g6OY3uEzzXwSvjl8tNaklMKTw5MWtvRJaa92xyz4Jy4Vb9delpXy2Pvy61SZvWey57Tc4Ki5pUDYcLQYjpd+fPpngGpvf2SNh7OU5AduPaswtIn1jI4u5t7fFjyxtIGAmwWXq5F2npUXarY/fMfSWlV67aiczfRo+K7k6NPeXqiX39GL16j6ib0sghdvIZS5xdbDK/o45Bv4fBydgLa9fPloDEnB9k86DekwsbpodngPFuXK19MRVdvImUTYrQkF7056Vefvt8q+Egz0kGdaFKrARg/nbrhMHFue6fY9t7pn3mnGo3JBklq4JHR3XeuoWdCn5BUQ48oE5fJi7YfhDW+ViDnL9K6eid3cIpKXP1LEy6kognu2Kyq4UGN//1fo+YYha3s6JVk7BXXf0x6H+8ZU7PWVGpxKs7LStY0JNcwdOknIOW/Pasi4WZc80iU/FU/X+rokQhmJlzQYVSMkVt0v5DMfkFpfbzjzQIyjf3nt3NNM/dNPnCtkOR7C/DzyPUnpj6xPQPTDDyiewUlW4Sk9Q+b23/c0q7+6R08Z7b3iTEKXWjgv6D9yLiInB3Upr5TrnOatRTYGkj/rG1nauVifVpBD0yHKa8V7Gau+tQrq4t/biyBJTDtnWcffG47vnNginH4vA7uSZbhi4dNXt4nKANABY8CTdU0dIlJwIL2ztFzdxx/rcE4eVSlM3GeZhky19h+2tc/XcbJAxoSc8PlmEIDh3K+PWXgHm/gmQywvFeuINFeTKEMifxeeV5rYDfGNDTDwG329hN5KpxFzMHPq6+V9lPmd/NLBQXAxCvJMjTDMiSlj/8cQ79Ek4B0Y/c5Js5TQhMX1pPA2c3XjZ7Rq7r6pnjNWVvGyGILNiF32+l29tN7hWd28Zqx5dB10C1wJQ/O4yde8oYGVFOP1KRGrKTuakTkCethV+ztX0ZHoh92orNn0J07aP26N8PtyvsNemFlfdHL89z48B+sh5wZ4Zg3ZPg1i4HXbOyOOLmxJ06DdSHXNYs0okc7b8iN0eQOaGTAH5uUKprfrdMp4cvf84o9Z6/oNTq9vXfCp65RHTzndPHMNPLMMHCPbe88xSwgbvnuSzRZqLgRDfaKMPOM/NQqMH7BZi3xP+A3CjxPRMb5pzVW4+e1cY3DGYPO04xcpnYeHrrl0LV60hvzWZnGzDe+i1fSv4aOS9t0WEGaJdI8c3j4lz+e7GA/CVi35RfL+oXNNxgV1cUltjtsvmusiVuCkXd2v7BFP156g5ke2AW8VivifgdLvj/WLzDa2G1KO7svurlH9/ZN6Tgyqp3jzJ7BMVPW7zULze7mldTOZtzElLVgUzcJ6NbreueI9Pb2kw2dZ2d8c6CarEuD4zuYhCWtUF7FjRib8emwCGPX2OS1BxqI16hUh5b+eLa7f/Tno2YYeCZ28Uox9EwEha2tR4rp2CVhC/aOnPFV2xHTDJ0i5qzaUUuUw8eVGqNhwabuMzoO8F/17VESt2ppAlmvQ9kb93UaMbGzfYTr9HkPSxVUD8cFESyWv1cfl3ax9uznF2kwIuSHUzdxWQQpnq+V0IWXDY5TF3b3ijdyjeoyajZIkF6BKZ29Ez53mm00KtIpYu7qn45VEn0mcfmmDtaj2w8fe/xhtZrYp8AV4cRvFGocp85v5zKhg+vYYcHT/yio0iK56xmOj4BmptSQ/i48alAdCRp/3nLIowE2VwdYXbAZeMZm8F3HkfnDBj/pa1psYfbIyipvXAi6ewv9/vvLrLkXA8cA27w2ZRo6eQpV44pdsKA52lCmdavGZljqpTiPWynwJEcdD/hVzWOB/sPpe9HLvh05KX34+FS7cWk2oYmuU3Om5q679OQtCKxG4ourVArR6YvHRWYERsRv3rWviSERGB7nitPcb9BqzuVXhMxZ6jY52W1CfHBk5oyM5U/LFDTRpaRGOyF+bkhkzujpqdt/O12vk7vNaYiG9tuZm4GzMsfMWRa1dMeem6UR87YNDIy1/yLDKSJnxISMyNV7jz+ubyKaKgn7SBoBJ7/UsOjk7RfT0paOnplpHzTLPmj2yNDomblf7750DzTSyMWbQaj5TE5euOEHNamjf1GhSF68dvTUlLDZOd/tPVujIUF/at8xPLD0ino2ZdEm30mpE+OWbtyFNQ0tKfmpYtCvF+5PSFnhOC5pZHiq3Zhkh7Fpk3M2HL1feq+CT/tqV8DMDP/pSd8ePAuiAd5VVKuZEJsZNjM1bHrKj4fOKWn/HtreETQQlbDr8KUxkTmB09KyVm4rqcXavlbLA2yoKX37SXH4zOTx0eljZiacu3WXIU0kaPIMYP5VHVr/09ngWQudxiQ5hScPC4odNmZOaPzSDT+fzntWSTNV7rx8MzUxc3rKgqUbf4I/0QI0hpMb+Gzbd8ZnemJAdHrAtNifjp1WCLjUDqOF0Vd24eotFtXWXIiYdt/G6WXvgYV9BxX2H1AwwOp1v75lvXpX9zEvtRx0Z7DtybAxqOQNKitHdY3obRXWM8vLUX097n7AAihJueV7RW5/GhzuvMVhJV8krScFjsN5/qQoBhhaNXvmYcnB60/PPS591YDZUYNWoOBRkg4JCi0PH+BnbZOWZAfJSXNgtmAVkRUaSQVE3vOSUzcfvlWwKgl7XdQCoiVmTTqJZECLtNgQh5uxBSEBAwT9o1rF1zOomihFNRK6+0a5+/y9PRcfPKxkqFSCa9QsTylMyXK0HrZRh/GZX1h1+Oyt87eevChtABTBNOo4rP7BooAX1JKAoJLmtGskJYPqVYKOqNycJNvvrL70rF6N6pWoSYsjcrxE+sDq05MaOfSiXH3i6pMjl54+eqNuIP0iYJeqdRgJ1ToJpLNWX6pWq2KVHN5Arb5kTOAw3yANFTHUa7UI6KKBkYvtSCktTgZQsTgH4G2dGpZWr9ZycrcNLAZVDKcT5fyZyiZ07UHZwXMPjl15+kdRfaMkN6SDvaWU/rqqoV6HD0vDyWYargXg8FDxuLYI5lypYqo1DG3zq98F2gECHqFCitqi1auOWQwpGuRU1m94eW+rkl7mlaZ9VX361fWyLDAfcm2o456QMPS6mDBYTDxSXRPoiIJGhWUo8EDSH1KUWpW6i81e6ZYBKgQrCKKgr50XMPfEibgM3ihYGu4oo697amQpG+FIBasEqOOpLKAeJxFnAkik2SUNXuhIRrSapLRRGFCTkF5Pb9fyFIp4CNQKRjyPE8dwlENL3BwUsbRakNbowUmBagbSQMuy1CMNP7WkF40Mb33BoJIkomhQSyGnirbBEfVsQMIw4Il3C6wQkJs80ayI1xYBE6YwYEmkXEeuVGG3C0790YjyY6kBhVPdGKmJl0sa4bNG3wAUmA/x98qTV3MtRyEQXQ7mCdxbLcmiDJgDsYnwJc29Iinh4GJGzDxo50O85wq1AMTCtlojPjgOl/uBts+S59OGVzqatkYKgbEbm0xDy+CDUGol2mUEFyxIuIujROkTVG3c30fASTiMCj15fGXyjOOWw2+ZDCo2s39rOeKtxbB6S7uq/iPumw49aDHs3rwlqKwSF0+TZ+HmKqAU4RAdBiTF5Adg+W7fDEakvbMk0sKFNrSRaENfHSlBohXHOkkucAYaUutofTxGkZblGawEwCxw92n6LrKfOHIGH3SEN9JoI/BAFXHO0/6UYOBotKyg/5WUTotgAEpME+7KxOF+SjwQrr6/BM/yrFaL84RJHxVJpEPAfQbwqknnagxUnqNZHzrsGWCkd3oLaMSWXuusJBdQ0x489Cft7KIDCxi3kNPBqZJOLa0az5LeYpzEqDmNitWqOBxZADgpqEAUcFEnbhsmSHq2Rg5HQrQ5R3PXFwafF6wA1+ByBE6NnKjgJVr8S08ETFEOd6FHalFUMBxLYk8MTzJmJIHBvS+AchlaAI6bo5FmJjCTBlZgm3sUkQkodRxhBfi8MOZBQnK4hIa2quBIuT2jFjiGtp3GSWIcJUKg3CZG1gQZNdIp0YP75avWFU1OeOQxFvB5qHf/Uz2tjveyujrS99mcLJR3H9tHGk6iwTzMH1lOYvXdr6TmXhl/04WMAkaQOxXTliVY9APymuU/R3u+EVsGSTQAyVPAs3g9SA9I2rtQbGnCQ7o/ya0kWFbfbg23eiBForjTiNzwHcn9g3B7dVZDmlHoaLt1rEMJ+iZNkqAvcCcNYMgrMDGyagG3web1kWTUvBqBzL+5TQFojEBBauJfJh0L5G4UuMycbekChORub7hXMMNpCA+nPQ8AJZhSeV5NvLO4V5CGJ/qDhOFEt0L2b/C41JqKLdowD7eYYnh9r00SyCFz5lqlLjNUxJFOPAJP9HQgEOxOwZjE2YW4M4hAQKvlcYapRJsb0JpxXu4ty4O2RbQ4JH2o5TWsStbiGK6l9pw0TgFSYXF3X05u0MzLbclIybOIc+3ggMA8f/SUvXy18tCB6v171Hv3NP7wA3vkGHpRhENrgsiQmmV9Hx5dc5NeOmSGiTsPS38DS05fc60/S6G5BR5Zsh4PsEscrSGWsByT21MQisQQw0dL+Btp8cpRXAlqrZqAEFONKPchwp8FXu6rRj5IlO81g4pileZa80JLsx3qhSYpwazcYoh6v5q7+2LGypM+P3opiVP58OlTeEj6ji6cToP7ZZEgvvwPITT3TgHcMxoJdzbS6v/xAzxItZC+0zWcnaCjbTpoby257QY8WK1s6dZCXkhPX99TCO8q7oHAaAjPxtJJp0/5IyUuAkUsWRcO1mh4LQgJuiEysOS1g5JByZOoZITeRdpKEjcgkhtFYqVOkprUariZ0WnlMBavbzAF1wGdaShQRSoLGKx/8diTTNJjRKKO0i3WMmrcYQnzCpyYjVN/YWgUCFatw+tg9Unu+n+BQ+4V+B4s5d3+C1gydGskiaJLhmVzUyy6dthAjDeedMsSSOWaLEDxocsdlqT3u9jR1iWUCAUZTsAM6eE2/8Rf0R7ACKszJJgri9rmf+WEJdSq5964hTVFF2yo/skUKrSrlST3iaI/yRGLIkPbzXGsVn/ivL5Psr5lD48bLrd0RwWJrGVaN7ITdYy8Ln1XNOxoBQWGwXfxWrXMzAVW/rdg9ODEpUbNffDktm+0MzPIcBC/HLkHzC7gVJT2aWCOJRkd9F9PIMq2Rk3zm3A3NnIN9ntLvMzuiWaOu1qJxFAhR4kbleu7QlOXDOktQ1ZN25byXHMLI9KUSSCxBK1IHVh6HQsehn1x+h7ftPcvC0sG8cGpkKYJqQgsOewe5IlewZFOK6L8Lz20giWVJ38txP8vTvckEAplbmRzdHJlYW0KZW5kb2JqCjUxIDAgb2JqCjw8Ci9UeXBlL1hPYmplY3QKL1N1YnR5cGUvRm9ybQovRm9ybVR5cGUgMQovTWF0cml4WzEgMCAwIDEgMCAwXQovQkJveFstNTAwIC01MDAgOTAwMCAxMTUwMF0KL05hbWUvRm0wMDY4X2F1dG8KL0ZpbHRlci9GbGF0ZURlY29kZQovUmVzb3VyY2VzCjw8Ci9Qcm9jU2V0Wy9QREYvSW1hZ2VCL0ltYWdlQy9JbWFnZUkvVGV4dF0KL0ZvbnQKPDwKL0FyaWFsTVQgNSAwIFIKL0FyaWFsLUJvbGRNVCA4IDAgUgovQ291cmllciAxMSAwIFIKL1N5bWJvbCAxMiAwIFIKL1RpbWVzTmV3Um9tYW5QUy1Cb2xkTVQgMTMgMCBSCi9BcmlhbC1Cb2xkSXRhbGljTVQgMTYgMCBSCi9BcmlhbC1JdGFsaWNNVCAxOSAwIFIKPj4KL1hPYmplY3QKPDwKL0pmSW1hZ2UwMjgzIDIyIDAgUgovSmZJbWFnZTAyODQgMjMgMCBSCi9KZkltYWdlMDI4NSAyNCAwIFIKL0pmSW1hZ2UwMjg2IDI1IDAgUgovSmZJbWFnZTAyODcgMjYgMCBSCj4+Cj4+Ci9MZW5ndGggOTIxCj4+CnN0cmVhbQp42pVWTW/bOBC9G8h/mOMu0CiUKJIS9pSmQdBFux+xb0UPtMS4LChRISXvuv9wf0aOe9hT/0CH9Edsx3K3BwuExPc4M+/N0B8+AoH6YvIIk5TAXxcTkpRZBuFZwnp9fwcvX7oF5CIDnqcCBGMlXJY5A6dgDn/CHhvcHe9jNI0bP4HfbP0AuDkjm0iegSkhBFhJC2hA8Iyt1wamF5MAxK00TRFE4DKlOcSDWFZA1Uyufn1428iFIllB4Y1FwEUAFJyt94cF5CUrICtFeYTIzyDyAnLO+BGC7SMysUHgAkMmHM9g9AjBDxB0i8g3iJyJY4TYIl7PYJs1CHydcsx71uCLBVxdOy3N5Wtr6vczoIIloYazB/jpXnXW9RKG9meYfYbb2TERloLkZSRKSBHUFqgoSQrKgtrjzLKqdK3aXsESd4AFZ+cWRk4RkDFU8iBc5MtIkVBKI99MQadq7VRjPRj8eb0YdDjAQy1760epKWF5oN7RprRIiqKMtH98NfqLHMfyYhz7tq20t6PYnKbj2N9sArUC6dVicLI+wxIsNsbyblhIhzwGduUeJWJkP5WtZPslvtFDLetXUElj1CvsxgflFOZ4ujw8RcPzVJQvZEuzZxugbCjaU1Sskx6fEkLO2p0kDS7/Lue9qvQcZR9amL6fQmVb8MM5F2Dz0u/TTjX0aCgkfhwUNHapXI9lkMv/vDSn65qLtNwRnyT9x2C6gFWUDqV6Cpr3dkTukDwTOXkZJecJ52It0iDb2kI/YAO0WvneYWupR2wFJwM7FkV+HnyPnhovMSt5GkOerpq5NcAYSxjKGQ5Ixku4hcXg/jc0FunHT4z++nEYI7QESnl+torvjGwkrGAxPLlatmhL1WJNfTBTL6sxI0XyXFByoPd+D113Hdx8GuZzuDHr6XSGqMzSQ+PsRbidzCv09bpjmsBnx+mwwYtRujfad7bVc4NjVKJT9O9TpL5ua2d1PSJbhnctXq4HnKVIMrzoA+Wtgc4pH2d8bauhCeFBa6EbFBrRKxeq6XEshQGH68aiOyV0ceTC6srGajtsW4j7cRLiVLxtcQD5+Cr0ofpbo5lBmkXARkDoTK8lStbjPwZ1MgzdPljXyF4v7Zns+Hh2KzByxycr/bXdRFv1A95n4bi21v9iL4b+DiHGBI30cGPxS6VtGCV3OFAcjg8PkXCT+y7dX0LsS/xeqTgkIxOKhMPcBkueiyF5vk2/AY55khkKZW5kc3RyZWFtCmVuZG9iago1MiAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0Zvcm0KL0Zvcm1UeXBlIDEKL01hdHJpeFsxIDAgMCAxIDAgMF0KL0JCb3hbLTUwMCAtNTAwIDkwMDAgMTE1MDBdCi9OYW1lL0ZtMDA2OV9hdXRvCi9GaWx0ZXIvRmxhdGVEZWNvZGUKL1Jlc291cmNlcwo8PAovUHJvY1NldFsvUERGL0ltYWdlQi9JbWFnZUMvSW1hZ2VJL1RleHRdCi9Gb250Cjw8Ci9BcmlhbE1UIDUgMCBSCi9BcmlhbC1Cb2xkTVQgOCAwIFIKL0NvdXJpZXIgMTEgMCBSCi9TeW1ib2wgMTIgMCBSCi9UaW1lc05ld1JvbWFuUFMtQm9sZE1UIDEzIDAgUgovQXJpYWwtQm9sZEl0YWxpY01UIDE2IDAgUgovQXJpYWwtSXRhbGljTVQgMTkgMCBSCj4+Ci9YT2JqZWN0Cjw8Ci9KZkltYWdlMDI4MyAyMiAwIFIKL0pmSW1hZ2UwMjg0IDIzIDAgUgovSmZJbWFnZTAyODUgMjQgMCBSCi9KZkltYWdlMDI4NiAyNSAwIFIKL0pmSW1hZ2UwMjg3IDI2IDAgUgovSmZJbWFnZTAyODggMjcgMCBSCi9KZkltYWdlMDI4OSAyOCAwIFIKL0pmSW1hZ2UwMjkwIDI5IDAgUgovSmZJbWFnZTAyOTEgMzAgMCBSCj4+Cj4+Ci9MZW5ndGggNTQ3Cj4+CnN0cmVhbQp42q2SPY/TQBCG+0j5D28JUsjtrr/WFcrlTicQFEmMKBDFxN4kG/kjrJ0Dfh2/5UoKqnRU7DoB5S5xhBCF7bE97zPvzOyHj2DI+r1P6HGGz/0eG8ZCwN1j7OPpHU4/mqXVBTGHF4YcL1xkFOaY4F9Qnozl/6MxiECwiyxYKXgY+IesNrRpK9Qnia25v8y1VQPpdST2e6EIbAqzrgQHRMw9BCFDWvSuXi9eFbRUTEiJm6rfm/SdIODsILABwr2APxHER4LIDcIJfB65CkxA+H70WBGzY4UUe0Ukracw8gS4Hz8xZYd4UFwn4Pt8DuGFEFaVFPZ9iauR0ZS/TSCYHHqeh2SBZ+PVdj7HTJl7neqqfo5kjdvklOMHoeP8YXBPDqVtzTGuVakWrRxfQbWuG1Wmms7DfO75v12ddTRq1bsShHGuVdmoC6BLtvatjbd1UxXKYExGdbYnhF1gl6NvozTVmXMCVULlUF8aQ+VameplN9GTQae1NzkVVGYVMlVnCu9mIzu5MZWUPXQCYxGcbJIHYhhFsmXemZ80QKqMIedsgDk1yvwg+1y7H1TMtSuIPKeyoe6ZHgqdLXKzzagegNKcDNmNl8rtvGqM3X2tS61qF3azOQsfz5lzPrRXC7+tUyq/Eyo0VUpu0Oku08sKkyk2th60sYfi/YqaerTZdE9eBt0NTNVmZxrKK1B+lsDjML6MmFW5PewNHR113Osj3C+sHWiTCmVuZHN0cmVhbQplbmRvYmoKNTMgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9Gb3JtCi9Gb3JtVHlwZSAxCi9NYXRyaXhbMSAwIDAgMSAwIDBdCi9CQm94Wy01MDAgLTUwMCA5MDAwIDExNTAwXQovTmFtZS9GbTAwMzRfYXV0bwovRmlsdGVyL0ZsYXRlRGVjb2RlCi9SZXNvdXJjZXMKPDwKL1Byb2NTZXRbL1BERi9JbWFnZUIvSW1hZ2VDL0ltYWdlSS9UZXh0XQovRm9udAo8PAovQXJpYWxNVCA1IDAgUgovQXJpYWwtQm9sZE1UIDggMCBSCi9Db3VyaWVyIDExIDAgUgovU3ltYm9sIDEyIDAgUgovVGltZXNOZXdSb21hblBTLUJvbGRNVCAxMyAwIFIKL0FyaWFsLUJvbGRJdGFsaWNNVCAxNiAwIFIKL0FyaWFsLUl0YWxpY01UIDE5IDAgUgo+PgovWE9iamVjdAo8PAovSmZJbWFnZTAyODMgMjIgMCBSCi9KZkltYWdlMDI4NCAyMyAwIFIKL0pmSW1hZ2UwMjg1IDI0IDAgUgovSmZJbWFnZTAyODYgMjUgMCBSCi9KZkltYWdlMDI4NyAyNiAwIFIKL0pmSW1hZ2UwMjg4IDI3IDAgUgovSmZJbWFnZTAyODkgMjggMCBSCi9KZkltYWdlMDI5MCAyOSAwIFIKL0pmSW1hZ2UwMjkxIDMwIDAgUgovSmZJbWFnZTAyNDYgMzEgMCBSCj4+Cj4+Ci9MZW5ndGggMTUyNwo+PgpzdHJlYW0KeNqtWM1y1EYQvrvK79BHoECeX43kG6wxBVVOHNvhEnIYS7NrpbQ7y0hrA68BL8iRA4cUL5CW1jImmR+Xw0U1Xvf3qf+7R3/8CQTq3Z23sEMJXO3ukKxkJeCT8/Gp4OQF/PdHtwAuBbCcF6CU5PCE8RycgXP4De7LJkpGfx4bL8qfpBtTOeQCz6rg8uewMUKjbPBitIEWksASCkrU9tzC6e6OT5JRlk+S4zkoWeaSTpLj2S9JOJ1eP55RTxZ5/fDf6fVBScpVMWm6PQdFpaRsEt2eo++nRIob+7d/eGVvnD+I4s/j2SuZSykn0fEc9pWQhZpEx3NYVAl2o8B4/lF0d4dySrEkCTyhXAAIKoHnAqrlzt6r+culXhjC0LgDi4DdnWdnMEkDk+ggTjmcLfGHBew9dY1uj1CCF1lRlHA2hwezi835OZyaxcbZDo6+vGsq+xhOs6fZQzj7C56feThFQQZOL9+x7oyF2kCr4cTMrVtqBKG8dZjUvzQfdJg3FyrM23QWFMxsm8GrzWdnPjyGA4N/zDZ6c9F/WdoqTFxsneB3QJ0N6k6Wz7LjDEieExKmKyP2X11dZdXg06yyy73lOy+LUAyoUDSs1MDghZZMxKHXofSCqSh4HH3tBr/thKTeHUybIYmj0DcPzCrgcZl4a2v9QEXyOLDbVKZrLv1wzrBu4+/1pzIXOAKjwI8zu1zrv7/qT28e+l0tWJngwDLDOPs1EIVI5FcAV+YJ3FxfWufFyqHRRLG18QMlNsP7+FnmeSKn1sZ1duVHY8uVcXRTm1XfzJtK1wGKUiY0xxbgTy7FecLTH59uA1zbT+EWknMVqQp/D1C0iAPPG7Mygf5BSxkHv/fjOO47UZxrTLcIda0C50IUvfzsRzKqEsbq2rR61ZtAB1FlHF6bXrctBqnz1zGXNMngBypBE5pXG+Nqf3oJPtRUFO3HCZknskp3gXQkiXyc2VXdVI0N5ZaUPMHwAvPS6TaAz5kg98nNnKdy5Fi7vqk2rXYmVFIpikCUlSCJKJuu94dKqZS71t/a0LY1No8Cp3lQX+w8WBXDEnfZLMyqajQMqpy3pmpqnUGQlnGcuje0T57Ztv4X90tk6+y+36qxKxOF630wGp8XzUojBJc25q+dEnOxVGW4uR67BtfSlQn4dktQyjDBr/2wLdemwyJc9YG+NdJQQiN+PkRTBucum4EG1tbBWi8szJ2uhlrRgQK/pma8DFeL7vpRRzDv1mYovW+rGBdX4R35ZfY6tNldoyUj8ahvXd5b7Jd+HorDNJ08N1NxP5yBhWT/i0Tm6i6qHOu3G9ObsCKcMRmnOLBLjEvbhBS5ZkmYM1xZIloQnjLE2XWDteAau4ddune6H4o/TCkFF3HKI+0qvQ8Rq8TtK5mP4sy0X+Z2FXWNLBJ6nGSH2SziHEmKMhEirHHXrIfqwVpq4dJcfMVZYB+FrFOiAMlkgvbU4MYTpchpqqJaXeluP9yK0xSzVl+awaTteItw8eL2pPE6Sg/tZjHN6OtPAIkhJAhOzriVIwEMCYn56cKhFLi83MXaZmDCATIEU6O6vYmYLVhO46SHprrQY5ddNh0mSSBdGS5WaWMPx88lSDYMgYBaPC/oHaiOcNGqdZQjaduJmRs3Dv+I24uc3K+Cwg2cKE/HYzzPKKW3kmI/MkiITGj1+nqtCcSLYutGkrGKSUZLNj5zfDI2frT1zknK9gmBC+t0B4E5pwj/zpwi8RtYYHuIMhyYNvD5By2YBtv3L4I+9zxf4Z0mNmSlulM/GKtsGrfwfg93nO/Txu96gksN7rWJoXW6wUqZmANrnBR3IJrZc+P6zRiy5VoPbIELRi7votiBqTdVg4uyP/zY3O9AMm5LYaOoSNfcorWdGXpJdWNgkFCWoghm06MfCxj0uTOXjd66zKzg1sUO4le0bdtJ92kk3FR9aPKP0zG9gdjeuuiAVYVKXVS6talGs19PIxJODG59rgm31gJv/Gnu3zsbJUj25iOLpRXnSPpoptd6uM7VUZrkFoG7zOWQALdY/gGCTOZsCmVuZHN0cmVhbQplbmRvYmoKNTQgMCBvYmoKPDwKL1R5cGUvWE9iamVjdAovU3VidHlwZS9Gb3JtCi9Gb3JtVHlwZSAxCi9NYXRyaXhbMSAwIDAgMSAwIDBdCi9CQm94Wy01MDAgLTUwMCA5MDAwIDExNTAwXQovTmFtZS9GbTAwMzdfYXV0bwovRmlsdGVyL0ZsYXRlRGVjb2RlCi9SZXNvdXJjZXMKPDwKL1Byb2NTZXRbL1BERi9JbWFnZUIvSW1hZ2VDL0ltYWdlSS9UZXh0XQovRm9udAo8PAovQXJpYWxNVCA1IDAgUgovQXJpYWwtQm9sZE1UIDggMCBSCi9Db3VyaWVyIDExIDAgUgovU3ltYm9sIDEyIDAgUgovVGltZXNOZXdSb21hblBTLUJvbGRNVCAxMyAwIFIKL0FyaWFsLUJvbGRJdGFsaWNNVCAxNiAwIFIKL0FyaWFsLUl0YWxpY01UIDE5IDAgUgo+PgovWE9iamVjdAo8PAovSmZJbWFnZTAyODMgMjIgMCBSCi9KZkltYWdlMDI4NCAyMyAwIFIKL0pmSW1hZ2UwMjg1IDI0IDAgUgovSmZJbWFnZTAyODYgMjUgMCBSCi9KZkltYWdlMDI4NyAyNiAwIFIKL0pmSW1hZ2UwMjg4IDI3IDAgUgovSmZJbWFnZTAyODkgMjggMCBSCi9KZkltYWdlMDI5MCAyOSAwIFIKL0pmSW1hZ2UwMjkxIDMwIDAgUgovSmZJbWFnZTAyNDYgMzEgMCBSCj4+Cj4+Ci9MZW5ndGggMTYKPj4Kc3RyZWFtCnjai45VMFBI4eUCAAjrAaQKZW5kc3RyZWFtCmVuZG9iago1NSAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0Zvcm0KL0Zvcm1UeXBlIDEKL01hdHJpeFsxIDAgMCAxIDAgMF0KL0JCb3hbLTUwMCAtNTAwIDkwMDAgMTE1MDBdCi9OYW1lL0ZtMDAzNl9hdXRvCi9GaWx0ZXIvRmxhdGVEZWNvZGUKL1Jlc291cmNlcwo8PAovUHJvY1NldFsvUERGL0ltYWdlQi9JbWFnZUMvSW1hZ2VJL1RleHRdCi9Gb250Cjw8Ci9BcmlhbE1UIDUgMCBSCi9BcmlhbC1Cb2xkTVQgOCAwIFIKL0NvdXJpZXIgMTEgMCBSCi9TeW1ib2wgMTIgMCBSCi9UaW1lc05ld1JvbWFuUFMtQm9sZE1UIDEzIDAgUgovQXJpYWwtQm9sZEl0YWxpY01UIDE2IDAgUgovQXJpYWwtSXRhbGljTVQgMTkgMCBSCj4+Ci9YT2JqZWN0Cjw8Ci9KZkltYWdlMDI4MyAyMiAwIFIKL0pmSW1hZ2UwMjg0IDIzIDAgUgovSmZJbWFnZTAyODUgMjQgMCBSCi9KZkltYWdlMDI4NiAyNSAwIFIKL0pmSW1hZ2UwMjg3IDI2IDAgUgovSmZJbWFnZTAyODggMjcgMCBSCi9KZkltYWdlMDI4OSAyOCAwIFIKL0pmSW1hZ2UwMjkwIDI5IDAgUgovSmZJbWFnZTAyOTEgMzAgMCBSCi9KZkltYWdlMDI0NiAzMSAwIFIKL0pmSW1hZ2UwMjQ4IDMyIDAgUgovSmZJbWFnZTAyNDkgMzMgMCBSCi9KZkltYWdlMDI1MCAzNCAwIFIKPj4KPj4KL0xlbmd0aCAyODI2Cj4+CnN0cmVhbQp42rVbTXPcNhK9q8r/AVV7carkMb4/dIoj29mkHMdryb6s9wBxoBFTHHJCDu3I/9ZHH3zY8m1P2yA1UiSzAXqcXFTUDN4Du9FovAYw//4PoWR57+B3csAoeXfvgC4cdwT+CjH8NeTlj+TLD9sVEUoSzqkixihBHnChSRvIGfkX2ZfNWcuTbORHohWDhoJZsibGcjM+V+Tk3sHdpoJSN3Kux2dGtaBIW+heGBpZLaNmfEZbGi74ruXwjLYcuxxtclZGmy5IR6aaSmPZjnR4xkmFlLuWwzPeUjN33TI+I44SbEc6PlulEqTx2x0p2pIJY3f9j89oU6UY3zUdn5P9K6GvjRqe8ZYOwmjXMj6jLbW6GfvhGR97y2/GPj6jLa2RdNdyeJ42XgMHo9yJse3uH7zxVUhfAW+F9L0DJhiDKU3JAxhQQiRTRGhJivXBw5/Pf1r7VaBcWvK4AcC9AUCNGgHSaQKECkLPcXMX425hpBkxihlCtFbwVtzZ2xBFd5AfTsnupcaJruC70zV8sCIPH7Wlr36BFsIurHXk9Jzcf9avfEsuydNQXPjvyOlv5MnplzTW6YFmkuJJTbah25brpi4bsgykakjR+4pUnhTNeuP/+8mT87Jd+/jJpg1dqLeBbD5X5XtPQn002a2OTnIKsh7W79O+Lsqm9i30+qjfNi3QLZtJMmk44Qym3TXXgx+aanmH8Hmz9d20DxwErrYijX9Vl0u/nCRwdA7Bk24TCvguGjI9GDBf5xAtwyQa1hA1A/1oG8Czn+tpDm3tN7xB/D6PPm7qrq/Q0VBuDsnlNNiwOT54GYrKr30MsNAhMaW/YSgguue8xvFFf3Y2SaCknNP9SVj1bTNtgaZijh9/+fhHWTSH0xRqVjScLB4tpvHWzcG/uf/q+ZM3301nCiP0XY67Af12gU9rCwkXA77wXRhTmicvw3kTc9jzZkEg4x6S06YFkfEcJusheVF2DTGH5LipIAt68nP/oQ3vD8njUIWVj5OJHPe+v9h+XDcFNFu8WBCqNQWa4+Ui9oC+oKFMoy84js20dQ7Wp9vgKdeehurjeVM3075lCtas5BtYSpFMJTNISvV0jmAsgxRC8mmo1HyGzcdx5KZXCu6UnsEAw1ps2881OP8ISTOWp43oIbGMk/P7Is7yBayVeBCw3BT5Z9PGlXB6pjNK53AguYoNtQebu2wgkWTt3Vf4QopgqZZDUZHGeiQcwP9J3G99eIt1GqVxEoy4S1CQfUmgPRLTk0YIZfYxVEgj0jhmjpCJKqxyaexF201nGMl4Bvq6DC26gGph93KwtFA57edgqGn3iiTFVSaSmMQcrLTkezrYxJnHKBQr+BL1YVXWnvC4hnBU/EIC4FnFs2la0OXA05V1CYq+xXIbNWwO40lo35agoAjUAVUZRX93hHhIu1mETQV8WyhYejB51f7PEyDvym7IPJ68BdwR6gNnOcvKzq0vtg0uFuLSdGsktF5obcb8NR2t8eskrqzfgk1rLHVLmJ5JfHElltvpNMZ55r0rRGZzlUNCz8syIZGFhPI6ybAKdWh9hWUIEbV6Co9liEGWpoBdj6QWKLCTwLFsPUQ0OURYEh1qZAI4td8gQSmk08h12a0RsNYqE5ubZtl+mE5NzIhsdDRFmI5KExfXvQwepiG3LNHtWWi3feu7Q0TNWJ1mCH8UVd/hYc15DMsUwyUiY1QG18asWxapKSVAXCQ5MFWiHM+YDWkUcbnO+HwUsohIUMal0c+QoZaOqtxYpxOQslKkGdIJSGuReQMsTHX23RNTSziWtTuR8ocpIiFOMDisNmflx5qEetiRGxXEu3BG3r17t7guRh6u/0DpJSymeLndbj8VfdUgO2E2jeZqetoycGgSiFUvgvI0sPLYyivSwGdheqIzw1waedKctcgOGROZ1w0VkpVs5nWjvGk9Im+g3LF7+VdQkMZpY8fs8GAargXLwEukwnZ2L0dB/GZGB6YXKMoS20xWTuzlKWkc3SsSpZMZH42qZDoHCpkZnwYRMzqD63ok6xqeyRDrZlmel0Vqe1VrmyGpG2RL0fLs8BZNu/QtosaMzmU4YJhGxnOSfUY45lSoTfGdyOYcRA0iOy1kjCQYmQjxmDSJ88O6jh2qMG0z/eJLHKeWZrBhWSIVjczZiziZq5zBbSi2V4GJHH8IoTMvXsTNxW4TlUkseZHCxpk0yxKwbYNtf8gceHpe0qzjkCJUcVgKk8htG0oonpHqxmbQy09oeQMtktDfe6Ts5jrjpa5c+RqTfZle/fSM0saxrKXTmYNym5nESMrhXO/nIaNo5mW7gOVHlp1H5Vki04nEvnhUpMNqtiCnra+7om9bWIpJLE/IpvLvG9IFEhVwuQTp3n6oiS/CZuuXvgM528WG5aavrhaXq9Obq9Pm4TAH1i1yewVaIPlCcyK4xAVVlMrk6oiNXJ2TEfSwa+CDouarjpvi4f7NSRPOG0t5lHc4nYqHU4s/n0wt/nQmhRPblAPGs6ud5TfHWjidS9g/q/wYtjONc+mtvJ/qAoxG9i8Z+DRP8Wi3+mGblmYOywsP828b8G1JprT6koILvWCMjRRD7KZsUTKzc/q6XA1bpIgpjCsgUYNsoQvm+PBXw1/Oh0tj01ve/IhSctG0MOmQhGiouGHOkSDHE1DIJhkeI/KGxRskuwG6uQAzefGiXjZotMSEpTTD779gp+sqjWvOqnKFKw3GjU0TLDHDFRNpZFrYcQ7pOd0zttksdcZo/xamJVKAioy9SPaLu1NJHKa5GWdp4O72EnbCS9PwLSIvJOU8jdy0UIEi6k/mzIXSdYXUkVZnLa6bolxH5dpgtZ3JRSWi5ETGXRf+LLSI5NAy5+yre2VYTINMyvjcV6u+RsSZtvsZbaxjudjEt7kHX6MjVbZFX3cQY5DWkaMjARItSYIUdopmOu/6InRIrQClXaZXGCrIAlsMbzhL4xElzJ3KvDZW3ghOM6+8/diuyxqDW5aBYxtCVOVM7ZCaSsY94rSXEwdV0oJ2SaIvkVKOOpUGYtWGkrmgQlYzpRzNeRfqjQtkN4hpm0ZPG6oFF5mQwGpAJW0u/pttKNCF33CtcwZvQo2mHCty6ApPOdbhar/o15vqanEA2V+RaxkRi4AYquRG08SPhsUeuZwWr6L+pbcSrhiZdXPLlV/iNi9UVpfkkvzYQ/1Y+d9861PsQuGF6/VNOpBuSsT7/TRFpTh+IeQl2Dm6eOM/dUcErAKRHPd9hMTu2zE9/Arir7uVsWP8mzy6o/8alzrhklxf71PDOChPbpEKgiv+915M2XWRcvKNF97cV+rNd5BLQQ1RY1WSUuXe+m65/dCfed8nrr8YyW3uBs267NCKhkJiy3M8HzZlkOzK4rFAnmODRR2PVzLzeGwHmRk2A/0ineC5A4I8yyV2u3COAx6H81B3SOUSf8+Sp8DO+yzE1QwPImJJUj0H/qrr8eusUju9vwHSOjMDvcuTyMa0UnOG4WlZR4Ee0Cv4wszxxpv7x78+f/zq5MlT/BJ8vIp5i+grLsEb5fDf2fxUd327GhYKJPnGS6sphpO+RTIVZN8k8h9Gc+QaTzz+TWLjdidWoWRMxraUuIg3T1PI176qwiFS2LDcGy9eIGMUTweSUCpgmTrEbuFlXhpWcWSLQ+o0EssRsFCngakfLkip7nY7NSkK/Ba/dNzMYMje4lfx56RJO0ACdw18/n28itR34Xyxas4WiZszBiL6m36RQZW9Q3IHrxBZwKHYTANBXCIbAi7TJ3XuRpn9H2Phwh0KZW5kc3RyZWFtCmVuZG9iago1NiAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0Zvcm0KL0Zvcm1UeXBlIDEKL01hdHJpeFsxIDAgMCAxIDAgMF0KL0JCb3hbLTUwMCAtNTAwIDkwMDAgMTE1MDBdCi9OYW1lL0ZtMDAyN19hdXRvCi9GaWx0ZXIvRmxhdGVEZWNvZGUKL1Jlc291cmNlcwo8PAovUHJvY1NldFsvUERGL0ltYWdlQi9JbWFnZUMvSW1hZ2VJL1RleHRdCi9Gb250Cjw8Ci9BcmlhbE1UIDUgMCBSCi9BcmlhbC1Cb2xkTVQgOCAwIFIKL0NvdXJpZXIgMTEgMCBSCi9TeW1ib2wgMTIgMCBSCi9UaW1lc05ld1JvbWFuUFMtQm9sZE1UIDEzIDAgUgovQXJpYWwtQm9sZEl0YWxpY01UIDE2IDAgUgovQXJpYWwtSXRhbGljTVQgMTkgMCBSCj4+Ci9YT2JqZWN0Cjw8Ci9KZkltYWdlMDI4MyAyMiAwIFIKL0pmSW1hZ2UwMjg0IDIzIDAgUgovSmZJbWFnZTAyODUgMjQgMCBSCi9KZkltYWdlMDI4NiAyNSAwIFIKL0pmSW1hZ2UwMjg3IDI2IDAgUgovSmZJbWFnZTAyODggMjcgMCBSCi9KZkltYWdlMDI4OSAyOCAwIFIKL0pmSW1hZ2UwMjkwIDI5IDAgUgovSmZJbWFnZTAyOTEgMzAgMCBSCi9KZkltYWdlMDI0NiAzMSAwIFIKL0pmSW1hZ2UwMjQ4IDMyIDAgUgovSmZJbWFnZTAyNDkgMzMgMCBSCi9KZkltYWdlMDI1MCAzNCAwIFIKL0pmSW1hZ2UwMjM1IDM1IDAgUgo+Pgo+PgovTGVuZ3RoIDM2NjMKPj4Kc3RyZWFtCnjatVvNcts4Er6nKu/Qh9RUUhVL/ANI5qZISqIpW/ZKcmpnN3uASVjGDEU6pORYeY2Zp9nbPkqOOeSQmtuethuk7HhCgIqTTSo2KLG7P3Q3uhsN5J//AgfShw/ewgPXgXcPHzi92IsBf/q+/hnC7CV8/WG5hMB1wQtZACGPIzhwGYdSwhn8De7LzY895wdxczgEPvd/DDc/9oF7EQHk7Adg8yGOQ9Rb6CA2zw1auMFLlBM7vgNexGJY4VMUOh54Lg8hg/nDB1+9zhyHu8i9fj2Igxjtw6K45fU2rHqSrsMQlstRHIFDXBdQdc8z8EMfAhSNkvWYu66/p1wecU3LkVaPkZbtjTmCgHsekkYO4tfj/UgDnF4QI1QkddEEeryvVAeYH/BaKq/H+5Li68yPa1KnHu9LyoC5PNCAHbce768mFvpeTerU433VhJJipwHM6vGepNoRfG1YPQ6dONwXMbotvu6RM/pwEEbf5IsOcFwMGnLE6vHekJGWR+ENLY2/hTaKGmf06vHeayAiVTn1Gojque/vUhgVmun69XhPyG4Inh9GmjR06/H+UqM4cDUpc+rx/ssn5hHTpAGrx/tLxRDFQvILjJ2Iem+/8GL8Eok1ZnxAwWGwr2DG0A+QmJOu9EMcMucb1lAcN47BWD2+IX34wPUx9zn498D1A0CrMPBxbSerB/2fzycrsZSO5zMYFUjw8MHzBeze1gZ0nSCCxQo/WEJ/UCqRHTwvsvQIX/PdXhwEsDiHx8PxbDF5MRkORscwGsN8/PJ0pkez8fzkeDofPJ8cTkaDEQwnryeHcDKYDWBwujiew+J0NpkvBnMYHk/h5HAwxOHR+O/Iaoqj8RTGvdPeoPcEFr/CeNGCz8P5ID4ztl+AeI3+Awda5E4iTI9ni1fPj0+nI+jD6RwB4Ui/OoDFq8lsRDAXv8DhRKPH0eJYk9ZsJtP56WwwHY7N0Hw0hBXajdoWY3hxPNtNnPSwGI/g9fjVZHg4niPyO6JvkbfLxkTphX6rWqJehLGPZI/EuqgglRkMKrnclCItYAup/nQpc1mKTNL3kAm4/DNT7wWqaZJXm1Km+Pu8KFdirYocfoLLIlPJdkdFPIQBGMYS3/fswKZFj8Se7GSe1NzxY4OmY/ADz7UzHfZOesjrH+oShkUqn7WzopDqh14HwGEmrmStOZzyWiJfPYDEwhnLBx9rLTvncbUmM/RhvhZrEyssYjHdRXZOR0UuU9LecFOWMk+2BmaY/nyGxaId1sFKqMzCwYucDpWpTSpSgqPWW6PyY8LSYcgX5HfkH5diSZo6EdsV6V7lqLsso3FlEIDRHBN/h+JGskpKdZmoP3Nt4tfy4lOyyUgUDlWSSWheIec3WIiKNi+8FfRXfV6vZV6RhNkQ19zL3lHvmLxzgU562MMFddQb96B5yyaEOYFRCLKeyVWRvd1IGOdLkScXtW+9UuvkAtfwokSjyhIOlThTGdrFIIdh7RH4HfYtzmS5xiBSQaVIcekmUWcZLY1hcYVRYYmx5J1aXxSbdf3tWn+t/8w3aNFdEEKf3QWZwarYoGXrPyelWuloUMqV2qzasfr4L/5y+f51VchUJRihxteXqFqEdJwkm0uBLgOXqAn8V2FA6+sHeYWuZFCJh+Wxb1Z9Y1D/31oZemKk+K+kn+aqmepRsS5KVRnkYbZnocXUkzyVqxyjpfbay6KEow2aQwIKW6j1JhMlih9Jsb5Ac6xIujB6rx/GMW7sgtBucdd7hvXkRVmBMIYpLwpZV6xfnZXkJVOxModOlzh14FnI7ON5keuQcIHBzxStOGAdzDtijMS1QjFmKhJS3PFzCze3S1MjVcpEWwbzRJqWsqpsEZAUZ+U3ezHsL8Q1RT5008nIyCyiqcZ2ZnN5TSp7KdGFSnPcDJyuhDP4XPR/kcLAw2O0lXa6wsiRKBPRPxK/GcyHmYrYMKcr+WHkLvr6l3lOLovZ3SXlsZ6DTq0D2sXm7KyVNMJ6w0o61+u9aiV2KS1YqY8+XqukeNpOHeFLdtmmUtlzcO9lJX3zWLYHBM93PDtpVrQTBkEHYbVJZKWuDORx2DHbrD304H6ng/B3ioLi8yfxx5sn7arGQqEDu6gTliFiRx3aNtCxLgOfi6uiNCx4rIGttKlsX1SO499Lz8wNOgjrhGqg5n7HQlIpZmB1jjkzbWfBfbdjNSXFqt25OOesw0dutkV/tHIIqe3VsSzag0DIu6x8pnAr1U4cOW6HmbfmiBdy10hWKlktDYijILYTrz4Y4p3r+XZKgTEaC7B213Q5bpSt5Kmkqh+NVLWvY8+LnS4OhuDFow7kCRZZqSl28Q6xhtDldEnNRLumfY9zO+WwyLH+xLLP4Fl+HHco++WuLdDuYdz17PQGzwy76E5EuVYJlbEG0SzoYmGKfazLPWRlaGawiCKIjbTumrSHHw+3KnbAGHpMy4LzmHd5STth5Hfo6UotZZ4oYQh5/h7awn1dolLRM4Qvv8PB++bwFXvRfQs2G2lHwRbZqTsKNrdDtqVg64D95vErWUplKNoYbhqt5OJ8LdsrCS/yOpS9vpCG8BUwO2VdeeVbc+EVRoGdRb1nNsQgjzzUTm2o2MIOQkvlxeMOKxfnhpLNj+6naEaNfitlXXoZomXkdSipqbxk2h5GnK5FYUhS3HO8+02YB12r+PembdRerWHEDO4nOXSjDusuiyI1VHqMd5hJ5O0qDiO3Yw2WqvqtMsZKz7Ftu+QazotyfQFUPqlMpk9BJElRpipfZltYF4DagCbdA2KE2xQMuo6g9lEFxTm+qKpdix5zFjLQtBhbVlBnA1VdyNTQu8fyLmDc2sQcic9FBQIWskwkhunbPunzIlWIdpL/uim38BOclAV6/XqLJHSq1a5Xj/qZjMfmZtp0eHg6GR2byBFx9GUD4tvI0arM9e9JHkRuROS+kXxwREdro2Pqux6/Hs/GIxOOiFrU98WB1EHImbkBKio6Rjr6iAVnQV1W3WSVle5NNptCarMWTZu1sEzXd6PvnW7NiDnu9+sNtzOMufc2P5HzOPwO52PU17uf1aiNTM1UE/Vclle0QdCnfoNKVWtdCqJOZoVIK6U/pY9FnkgwQ+QOd+8JMXDs1F+gOpRLjE395vctMENIjDH5cN51ipHTyUSB1QUM6r2SPgSlvq2OeChoVKordGDjWQlnrvn8YbgR2duNkiUkO1GwElv8ibpFH9WhDr8CDKf1LHU9vpZgPpzhPDQ7hNjQucJ7OvjRiw2D+c1hL0bnDyCwGqufch2ub456zfKiwLzwBzlmAa0hoGMfmtNWihIzRYY5hg6A4EpkKt29pOdZSTClQRIYOhaN4gQvaIYyhbOtzjy7IxVFmkQZu29u0pQhFVGrgQfMnIvqE6gpZkw6r8AU2hxFPTPxo40a6wySaHl5fUlHQ/URQZNLX0hpZByREcw6mfRe465CHzhd92Ahro2MSLl+2DHjRbHWC63+bTt/CxlmNh5wM8dHDhYhJlrSV8DvR0t3o4LgfrSkBYs6zbQe41jOWuKx3pRCs7+EZqcItOcDM0Pf5oO4fIvmUsZM6jsYSITpqChLCVNTu0HzZZ45rp6oqoAQS7usBz9vPpTy/VMYSXzAiLW5WH9cFYmZMbdpINWXOXZT19cwHM5tCo0s83/37l0vIaX2kmLVX10bgr1L90y6roTcnPKhQ1f12ptU1UYnt9R8/cKJ6HS04wTqddNGaUz117ssJ7JURWo446I8jRK8Pc9fDb08DqHvmIPPIUZ6THM6tzQhn9I7pgv6PZPVJdb3+l4A3dsYqiuVUYqoL2PBFoYiF+kHLPPztPxQx3T5Hir1xW0h5LPzfBxSJjJDDUKzbyJMvR9FTaolXRAQ8PGLTIXZA1W9wRfKm3T5FJINnStXf2YFXDU3OCoo5RKLBEp3FU2mdkqczFJQr42YEZnCtIQvZJ9Wai0t6uW+2e1Xn3K1qiferkvKxl/tbBBTtangue7+I67m+aQumAn/2w16TgOfQNYXhvRNgrSwYI0srkDn3LgZlGL1sVSJuDGuvpFCaVN7BY7Kehu4vb0xsrv59U5lGZxR7qV9Ja4fda5zcSkzXEgpJSLknNec9D5dr7J6NZhRxxavQFw7aU9Bretcj3VGjjvCnbjLWjrtX2vT62rgqr7GU+nPlxtte4mPCE0z0ciPFBpws0KXQy+oSM7d7aYRdORa3ELvpO/uUm+V+VTbV+naJdcg0KqEX18G05vtwUpqExEfbSRhSCQaiW8ppC2Zqa4LbwvHLeLCmrRIVF0m3vU52LkPgqv9h1wbo8BUNBUzluZIa7lwQliZ5boUTvzWZ4bFCsM1XYsic795PB1Mhs8GAw+jnRO+eVKvmiY6NSWvflLoD8Nig0E5gzsMZ6gD9JNCcxsOJ7M3T/rmZrIGy+PAsolqUSk66xeFau2PSbHM9WOXsZu6tk2fd2ZixhvZHMGiT61QQqsald6A+WaV9gxnwLhdjO/sSVsvqVCcUGtBt11QNMYh2rQ0Vn5mvH/bzXgmL7Xrog9XuODR88vCcIElZjExdPZFuskFLMv/Cihwy7XbtJpudAbgOq5j7kkdZhgr8pRyc4VYT+eDZ+AeRJwfeJ5/wHgYWhh7Id+Xce20z8DCLbBUyo6DoCLfDsqL6dz/PtMNwwP0Spy259k4/6j5Nuy6J+zZYaGTh/+fCTecf9SEG3bWCSMqxznALd6B7/iuoQdEuyInsuTByw9LhevD1W0Pc8uOO3Vr+Pb/HnxP/y+K3B/BjHkB/RcnSzPxEXtKnfbTuQENdU6DKIj2YIBYHnkd7KgbHTBLN/aRy5wbhoenw/5wfmi+6efGfteVwVLJ/uvJ1HbVz407bn6eZCIRVf+ESrTKdtuvk9NpVfRPqy+2a/8DxwzM1gplbmRzdHJlYW0KZW5kb2JqCjU3IDAgb2JqCjw8Ci9UeXBlL1hPYmplY3QKL1N1YnR5cGUvRm9ybQovRm9ybVR5cGUgMQovTWF0cml4WzEgMCAwIDEgMCAwXQovQkJveFstNTAwIC01MDAgOTAwMCAxMTUwMF0KL05hbWUvRm0wMDM5X2F1dG8KL0ZpbHRlci9GbGF0ZURlY29kZQovUmVzb3VyY2VzCjw8Ci9Qcm9jU2V0Wy9QREYvSW1hZ2VCL0ltYWdlQy9JbWFnZUkvVGV4dF0KL0ZvbnQKPDwKL0FyaWFsTVQgNSAwIFIKL0FyaWFsLUJvbGRNVCA4IDAgUgovQ291cmllciAxMSAwIFIKL1N5bWJvbCAxMiAwIFIKL1RpbWVzTmV3Um9tYW5QUy1Cb2xkTVQgMTMgMCBSCi9BcmlhbC1Cb2xkSXRhbGljTVQgMTYgMCBSCi9BcmlhbC1JdGFsaWNNVCAxOSAwIFIKPj4KL1hPYmplY3QKPDwKL0pmSW1hZ2UwMjgzIDIyIDAgUgovSmZJbWFnZTAyODQgMjMgMCBSCi9KZkltYWdlMDI4NSAyNCAwIFIKL0pmSW1hZ2UwMjg2IDI1IDAgUgovSmZJbWFnZTAyODcgMjYgMCBSCi9KZkltYWdlMDI4OCAyNyAwIFIKL0pmSW1hZ2UwMjg5IDI4IDAgUgovSmZJbWFnZTAyOTAgMjkgMCBSCi9KZkltYWdlMDI5MSAzMCAwIFIKL0pmSW1hZ2UwMjQ2IDMxIDAgUgovSmZJbWFnZTAyNDggMzIgMCBSCi9KZkltYWdlMDI0OSAzMyAwIFIKL0pmSW1hZ2UwMjUwIDM0IDAgUgovSmZJbWFnZTAyMzUgMzUgMCBSCi9KZkltYWdlMDI1MyAzNiAwIFIKL0pmSW1hZ2UwMjU0IDM3IDAgUgovSmZJbWFnZTAyNTUgMzggMCBSCi9KZkltYWdlMDI1NiAzOSAwIFIKL0pmSW1hZ2UwMjU3IDQwIDAgUgo+Pgo+PgovTGVuZ3RoIDIwNTkKPj4Kc3RyZWFtCnjarVpLb9tIEr4byH+owx52gYTpdzdzGllWsh7ElkfWGLMY7KFNtW0uJFFDSs7j3/qYw5zyB7aaekR22E36AQMEKfP7qrq6Xl3Sn/8FApNXB3/BASXw6dUBSVKWAl45r68aRh/g5w/La2BUgNRcgTZawBtG8VMHl/AbPIlNK6ApYVs2kj6HzaSpBk1+KPc8Oq8cU5K8HBuXUr7kUiWSvAydURQMSeXLbGutHSVcv9BqmZAgtKYvox31TkekEHE6LT3mxxXpUkIEQv11A2XIgtgbqNrRtbMrKWAGhqJb1fdTOH910A5NKQdKGUPs+l4J1hXrxXJparH4Xn3fDSolZVvs+l5x8Rixa43XYv19d6iQTG+h9X03KOVUE1CGevD6QTOT7qP/BEaAk00KjHCtY8wo4qmUqd0PHzoqIhVFABF+uzcPzHQ1PFWM/ECvH7qjN+Gn6DYRUjRjZzddW40SqtTOhp5MPmrlGP1G75bu8fRRa9/hN0/NeMDF6pSCUsrULyum1g+7d3GLOWIJ/r2h3ACkFB8NJRqy2cHbX6+OZ/baEYbCjwqEvHoIEQACF8+VeAAQewApNu9LjEsskimqzNBj7iPkPoKRDYITAMmUXyWT6QOIugfZCsEbMEo0CtFbxOEYtovAyoMvG1RgPMMPruFtr8zt9M1hMZ2c4GvcJAajZHwF/zyyy6KCiZuCrdz1qrSTAr68LWBRFovcLW2ZF/+C8f9gMG6QQAz3Eh6wS5ZobWr23sXx+RCOBtAfHo6GQSKmSBPRT2peu7kr7dR5hWFqYfF9mn+1Yf240D/TMq4S7xOe9qwmeNfIgMbG1oJKv5SYaqdF4tUpXZZfFs1UQjOflLHx2TE9IKHsHSFwU5S2AjttJFGSdidpZGCpZg8YmhZ0kaOdszxgFq6wxEbVOHLT8Ja0mvMYRVcBO0qJwd9OMZhPiiAFQxMxxnWcop+cJe/C/tqKPypmeZZP8yJConUaJ/m4urYlfIErl91Y72Pu88JNkPf7PEKbYjmNr62YL8tiGrMPwSIQ5Ri970dUaIX3trkmTMIpb8kJIzsL4DFwWQcCNMStm4f2SAjsYjuQrIplIFQE1RxpTIu7jpEA0y8sLG53xCDYCbaoMrW3DvL50pVzu87pGMlLF+GUpEW5I1ddT4vKefdDBZuLgWK+x2o11Ukxd5OYrbjaX+ID9FmZzyycYk2KEBhJggRD9HpfOapshVYpqsieEZIGad7nc+vT4yz3LLAoytowcFXaLMuLOXp1hBk7yyDzB1uti/FeoEeoONNBquPkIuklzXWNp8J3RGlTjCqVKKVrisPeae9k8EcjR5pin4THI9pKMRyNB4Hy6nv9djX+fX7YbyYQFKuqEUq2KHF40QsYwmA9NIqz1lX0hyeDUbMlDBNgsOuNc5z3Tse906MACW4JdoImZTzOomHwcXAxOA3YQ2A7plLTUlXeF+XMRsMZtwbV6cBU16Xp37N8Gc8P1PcdRLNwbJ678hb9vUj6Ux9Wrjpxn/Os+KV/s7q8TLJi1mx84kcOQrH2gmczjNXJaoL9VQE2m1qMVgxWVwVsydEvtZLhNDBcuLJfXJZ2/tWejP/zSxbVVBEhvQlE7Sc/H4TK6z0pTCYEq3Ct+vDkbDREDxwPoHc++PD7qHc0DKjMMP9qxtT9pv+hLW7cXysX8EJB1I6hET3AVmSZ3wZ2WVLszKL4Q8ycIbC3jaZc3gdTumvWPxZZoDWmivspIIZREIxefzd3Adm43QYMMWH/rP0Qzn3Xghn65Jt3ztdwHsyxa0YmwqY4w/NWsTnHjNxVHZTMV6+ixKP7KR5LIEYtKA9TYwONBoV+MU3g19Vd6b6+BuzKE+iv7Opm+W1WZFFyGbPEpD7ubE3gG2UgSqG/xhh1xBKfPn1KdtHzdva5kcekAlOSEDKs2LabA8G0CJQt5iclElP2c+oWHlZTTfnT6xZNUZXGtrBj3apnAVTKZxUuf5wkxIjnVi6f24VQzy5daFeuXqZ2daHqXLx43ey0bnisX1onZ/Q8zSIppiUzx+EdUnOcoC034yYb+uTk7NHyadlZpn56jrXTPLZ2nh33oA6C5lOi9KfEdS6I1MtHJf6aU6TkGWk/zKukjud8HU35YWKznxC75vswXRpZf6dkjw6nOgwy8GyalfnCH5Pq024eGR35+JNKtnSKI5e5LV+dESpwgVlL3XtiVVJPYGxuETUGZ/QE/I8wLnpijeFi59EILnrQjsnj7Eny7k9ROuGYh2ki26a3S1sFXKYe64u2U1DwdBGa0kn/RWmqZMu05MwPFdwcS9TcBZICxbqkVNu4r85gvcUiEGrEYMDS+7k51QljbBdktry2MF+5allasIsFOnK5mVfBF7CTWT7P/f9KWK6qzVS+eo3/cLO7KiwWu4+w3EUxKe8qKN2iKJfIXKEMrwAG0NVdlk9n/pjopzkYV8sVTPJqUVS5r4Aw+36bT5OYXBqWO8Dlzr9ZwHySfZ/kuAe/jXBTb3Mkx8Vf2r30ZQNGlSZVvtlkISEXDWzeklnmcDlZgbsemE/V1Gi4MPdk842Ot8p6K9bbVTrrH9bTKtydiS1jEmhYgh/e5pvxl/VidnuDa8AdT4I9CLKkTZPzvVZg7a7bMUBAQ+MbstR0YdpOFioYfF6Urgr4oyZcY2Sm4UJ4djQO9DeGSW81+nio8N8ASkFIJ+i9L0Ip97+ywNM2Jinm2fDS9J2vf1XUP5Lp9GrN6htF2ZE2+O7/AVj6xHoKZW5kc3RyZWFtCmVuZG9iago1OCAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9TdWJ0eXBlL0Zvcm0KL0Zvcm1UeXBlIDEKL01hdHJpeFsxIDAgMCAxIDAgMF0KL0JCb3hbLTUwMCAtNTAwIDkwMDAgMTE1MDBdCi9OYW1lL0ZtMDA2MF9hdXRvCi9GaWx0ZXIvRmxhdGVEZWNvZGUKL1Jlc291cmNlcwo8PAovUHJvY1NldFsvUERGL0ltYWdlQi9JbWFnZUMvSW1hZ2VJL1RleHRdCi9Gb250Cjw8Ci9BcmlhbE1UIDUgMCBSCi9BcmlhbC1Cb2xkTVQgOCAwIFIKL0NvdXJpZXIgMTEgMCBSCi9TeW1ib2wgMTIgMCBSCi9UaW1lc05ld1JvbWFuUFMtQm9sZE1UIDEzIDAgUgovQXJpYWwtQm9sZEl0YWxpY01UIDE2IDAgUgovQXJpYWwtSXRhbGljTVQgMTkgMCBSCj4+Ci9YT2JqZWN0Cjw8Ci9KZkltYWdlMDI4MyAyMiAwIFIKL0pmSW1hZ2UwMjg0IDIzIDAgUgovSmZJbWFnZTAyODUgMjQgMCBSCi9KZkltYWdlMDI4NiAyNSAwIFIKL0pmSW1hZ2UwMjg3IDI2IDAgUgovSmZJbWFnZTAyODggMjcgMCBSCi9KZkltYWdlMDI4OSAyOCAwIFIKL0pmSW1hZ2UwMjkwIDI5IDAgUgovSmZJbWFnZTAyOTEgMzAgMCBSCi9KZkltYWdlMDI0NiAzMSAwIFIKL0pmSW1hZ2UwMjQ4IDMyIDAgUgovSmZJbWFnZTAyNDkgMzMgMCBSCi9KZkltYWdlMDI1MCAzNCAwIFIKL0pmSW1hZ2UwMjM1IDM1IDAgUgovSmZJbWFnZTAyNTMgMzYgMCBSCi9KZkltYWdlMDI1NCAzNyAwIFIKL0pmSW1hZ2UwMjU1IDM4IDAgUgovSmZJbWFnZTAyNTYgMzkgMCBSCi9KZkltYWdlMDI1NyA0MCAwIFIKL0pmSW1hZ2UwMjcwIDQxIDAgUgovSmZJbWFnZTAyNzEgNDIgMCBSCi9KZkltYWdlMDI3MiA0MyAwIFIKL0pmSW1hZ2UwMjczIDQ0IDAgUgovSmZJbWFnZTAyNzQgNDUgMCBSCi9KZkltYWdlMDI3NSA0OCAwIFIKL0pmSW1hZ2UwMjc2IDQ5IDAgUgovSmZJbWFnZTAyNzcgNTAgMCBSCj4+Cj4+Ci9MZW5ndGggMzk5Cj4+CnN0cmVhbQp42pWSS0/bUBSE95b8H2YJC5r7frAjAipQK7VqdojFxbkJQX5QEwn1R7PqH+i5dpI6VqKITTSR5ztz5tgPj2CY59lvZJzhPc8YvoJbB2EcKjjGZSdL/Mqznxj5vIA1tvMJ28nDPm0hmZdklE6wXh90SqcNrFWdk6TUXh2ZqQQ9dSncemt6vXPmGRfcUzWGC6EFICyndaVHUWWT+8VdFZaRdma4bojIO4I51RNSeIB+OAyx+wQfEF65TYRzSAvTqRgbAWIYIcRuKYXkhhBGjwg5jNByCzCKsJqKGjkC1F4LxTaEtakFvT/Pxy30gHByF8EBZTy4pIPuA2YYkYb2BB0UqRM3atzCbonpDLy38+5T8tZjVtH/JSZX7SqUF9OmnH8nl3RfnKOHC5z9CMsGscZTqIsGfyZNpwJiGYt1+7deJV2j/KhjuDzH7AU3s1EUTdLKpKgTMa9Ni3Ub6rdFbGNdrALauOjEvDky2yi6rDkxfPrJjRWjM3N7YuptLJ4Dvn1Uq3XEPCJV+D/vH7MP48QKZW5kc3RyZWFtCmVuZG9iago1OSAwIG9iago8PAovTGVuZ3RoIDIzNAovRmlsdGVyL0ZsYXRlRGVjb2RlCj4+CnN0cmVhbQp42oWST0sDMRTE7wv7Heaoh9r3L3nJ0aLeehByl6IoSpdF0e9vxOIGTS2BB4GZ35sMoQtyISJ8nRUtN8+C+2kc1jcTUUx3u4/3GVfzOGwK+FvN8ORQcUWZMA6EpzrXl2/Pu/1qM+8ftgVCCeVxHM62EWauaiznKC+4Lh1UpgPqCISPWi3o/1aJMYiSdQmBNEOZQ4to3SGAJSiUlH4Ir1V6YDDMBdGdm9LyUtrtr8SV6zn4397apYnBJorMRN3YFikgUconY2fN/eqqMic7EYSRYoTUKKE+sQsSM2pIXYY7XKmyZPkCn5MbhrAKZW5kc3RyZWFtCmVuZG9iago2MCAwIG9iago8PAovUGFyZW50IDMgMCBSCi9UeXBlL1BhZ2UKL01lZGlhQm94WzAgMCA2MTIgNzkyXQovUmVzb3VyY2VzIDQgMCBSCi9Db250ZW50cyA1OSAwIFIKL0dyb3VwCjw8Ci9DUy9EZXZpY2VSR0IKL1MvVHJhbnNwYXJlbmN5Ci9JIGZhbHNlCi9LIGZhbHNlCj4+Cj4+CmVuZG9iago2MSAwIG9iago8PAovTGVuZ3RoIDIxMDYKL0ZpbHRlci9GbGF0ZURlY29kZQo+PgpzdHJlYW0KeNq9WstuHLkV3QvQP3ATIBPIbb4fS6qqrJTR3dXuKgljJ0Gg8TgDBxKUKGPk+2aZRRbBfEf+IZfVcpNqktdlL+KHfBu8Lx7eF9mmK2o4pZSE3y9o/GQcJ+/vz89evrqnVMg/3376+YG0D+dnlxNhB25GGHeOcGopme7J+RklP8HPl/7x4+3di8uHux83E+FCk+kv52e/3ejvyPRX0k0nKgyYiyoqwlIaISTjRRXOSuCkOtUAwkzYgzArSkkGO+RUuSffV+Fz+KnhJ+eGPP5U1qZfth/fv+SUy6JezRhN9GIKVFGBcMYl+0lBTdVwrRVwlZ3gjCscE6eZ1lyVXdCC4uJ+s1v3vnygPLhvZXX/r3/v3236LfHrG7/v3hG/9W8rqpgFODiXVTduQHrqPOm+n1bALijpt4Gi1BU1Kss1qtFokEWckVRU9/Xp8eP720pMSFxWHn8hthX8qMi/ue723eT3wwVJyE33fd8MZSCclqhG7/1rZ6hkthIhnBJJja3JN8N28u1QiU7gCputCTuuKgcoJXeoaPnwpNK4xRdlMW00Kna168uCzuD2/FUHgVs+Gs04KttW5Kw2qNzYXV3vh7F8nhpyAhN+WxYzxn2LrwZaCir3qvfbd77sq9EWFx7L5cQ48U3AHmIO6no11m/KckILNEe2vumHrV9XGqOA4+Sa1fsIaTvS9k3fbS73XfhQbUqcKwgQKG1VyIjakbUkbKXWxF+O5NIT35A9U2RqezJOLVFkaK53lZ1aRRTXvKYeHOOVyqgdKskY9DIB+WvKvV9poqSsgjQNb4fJV5Ib8gWTrfRGznCTTCj4Uz5TpXXI73r1YpJSRrlgqhKKEBSYgp3fT31zvfb7ivMal/djG+CuTEzQLpSxpmp839/Uaj4MJBr6srS8NOixkFyHKZFB+Qtx/PnfbPT7w59A44/nZ9CA/kmCPudgeryfSTCgFbkj4/kZC8uKms/LgcyWRVwWhWUbl+2zZRGWNTsuBzJZnl2D8ey4rHi2bOhxOZCnyo08Kg/kqWvGxGWTL9u4b0tzz21UbmXuuXVH1wJ5uuz4cTmQp8qdPioP5KlrzsVlly9D8B/XZ/pUPaM6YdC59xBLR/9mOmeQCYPMdwDjVjTBbMFJnjjJnzv5LDwh6qMpPkeBgA+JKe4STTMeR4aDKRFjdKZzBpUwKJObEIkJ8dzEwUkpopOBzhlMwmAKu1AxFWY6c1IlTipV8EHFRJ7pTEOSbUyzwjZ1YkKrgg86OVVtCxpMcqqGF5w0CQ7GFICyMalnOjORZB47pN6Jk9YkDKbA4GJqz3RmwiUmnCzswsX0nulThtCsPzPM9KkJnqQgP6Tgcyc5i07OdGaCxZCb6cwEM4mGAg6cx3iY6ZxBJAwiBwryNmEwBSdFLCQznTOohKGQ3TxJPS4K2c1l4qQUBR+kjiYCnWtITEhX2GbS5LgqmVAxqmc6M6GT09SFkONaJgyFkOM6ZvdMZyZMcpqmkN3cqIRBlRgSHEyhynGbhJwthZxNotrqggYXs3umE4bPVf+wG5dA7kTew3jSI7kr9DBBY+jN9GkHEjRCPtOnJgQ1CYMpmGAxy2c6M8Ei5DOdmWAuYSj0cpG0ScELvVxwnTCUcEhSUIhCL4fRMGEo9HIhYtWf6cxJmTgpecEHGbN8pjMTMjEhC4MilIbIoEomVMzymc40JN1PnAybh10kKSh0YaYTOmb5TCcMzy7JAi7Xztj6yyG/UFSsnCjfsY2AS5mjqnrDWVXe12ZJuKHWL7x1UTXHN3PVm7ZWdWG42YdMFtUHS34BWK10ZcMBL1g3snivOaKmLriyK1V+BD/MVOU3cKaf3sAbv/9lgptdXQOvXK6O97Nf1/07Hx4KDk9BZOffXHcTfBzCA4K/nobNrzf9uhvJW9L4TT9sgdx3Y9+G16qx9qoi0Fvh9qH+RA2lS3zbO/HfQeZJWXgalUSH9hm/sTDxG4s3J+/rgVnVX2Va/59hJBs/dfveryu7VjDWoFpu/HrYk2bYdPumrzzxaAMZiCnxf/yOKAhc8ptK3EuNyusLbdXKMAS18CKxGDVDq6e8Hy4HMg1TZasHvBD5RXhpa1ElAS9GEcA01FZMAcTySlMELu3UcrisqFZRSKrdsB39Zb/uW9+Spoe8IzuA4BB+nkD4NV3tuVYZUI3pFxeU0vC3Vva0hrTFNGwH4nfrvvFI6CHi0CUUdAmHYGm5XI6l0+rrsLzsu20teR13qEa1ADpEPIcu37xTYvHmDXXVBztCyPC3D4+3ZPz0w4u7/95//PkD+cfDD48fyN0tKSOTRVbmnaGWL/cObldfGebdfhy2ldd9ZWHEwnSyBYGNyX8hsEOJwMS5YitqEew4Y8uxC7fG/+vJCkmXeyfr3w+eOvDkAXkFY8O6rzw/H84W0aqWnC0ivyDzYN5zyxHQjH5dbHdbcj36eX7a+vaXSvWG2oGp9pud3/vWIyAg0ktAUDArLwbB1Gfjeh975dfrruk3UIanod7EMOXLmhimYUmuI+KSi1XyXyRyGMMr4WIYra4Oald+nMLQ+a+2b+Df8EWbr07chyxCtC3KIkR+CWqIuOQUbfzGquUzpwlfEtTSpGmebiaHu8sAsffvcZoh9GsYJrftdTMNWC1CtC/qM4j8EhRx8yuKTO7G2eWjqGVcL0DxqTFXLz2hbqGqvli3MOkFgGHiTOKAWcaWz5uWK1X/jrQfp24L15RQ7W96/7ojTTuS3yGgYeq+DBoivQQ0RFxpuXLINAMz+vI51Ya3kC+Dtu6uQnYiiEFfwHTpRX0B07AENURcimeh9j+XFNeRCmVuZHN0cmVhbQplbmRvYmoKNjIgMCBvYmoKPDwKL1BhcmVudCAzIDAgUgovVHlwZS9QYWdlCi9NZWRpYUJveFswIDAgNjEyIDc5Ml0KL1Jlc291cmNlcyA0IDAgUgovQ29udGVudHMgNjEgMCBSCi9Hcm91cAo8PAovQ1MvRGV2aWNlUkdCCi9TL1RyYW5zcGFyZW5jeQovSSBmYWxzZQovSyBmYWxzZQo+Pgo+PgplbmRvYmoKNjMgMCBvYmoKPDwKL0xlbmd0aCAyMDE4Ci9GaWx0ZXIvRmxhdGVEZWNvZGUKPj4Kc3RyZWFtCnjapVrLbhtHFt0L0D/UMhlYUr2r27OiKFogIEo0HwaSyWBQ6u7IHfSD0822rfxdviFf4YUXg+y8mlukYsqZutVtDgwQpKlzbtV939uk59RwSilx/87o4ZOJOUnK05OLVyWlQv/LdtuaXNWnJ5crwvZ/zQjjcUyYMoKsSnJ6QskDvF6MmtwWZ5d1kc5WhAtNVj+fnnw309+T1S9ksvoLhQFxBwoELKURQjLupYgjCTRwkmcMAGYi2oOZF6UFVUHYaDa/mY78EjloxxipUOwlAjRMBIHLyfV6cbd8ERAbM46iz0fnfqSKdRB5NUFUy+Mgbnz+xi+RUSbC0J++e91l+D0jalDTZBVyS6aDuKL243Qsg7i2S7I2f1cjNxWUheH+a0rDwcNxX/jbbV3eNxlJs4JsmvpdlqV1c45TSROhjjG+npMzsswePldkXFdpnuR1lbXkOquyxhbwLs1IYcn8jyL/1eIyNGgYkbGejUDEuspTmzq2WZbCW/JIRsm2s442yf+oyFVuAYlLMIqiUfXT9+QqS7skvy8yYjdFnlj3rq2dmuD0y660ZNRmD11jQXRWkcS2tTtMm1d51m4bvwlFLMCA7H8E66f0M/H7m5Y6CEu6Es5Y5lm1RVxHg8lCDH49sYjTIAzxcxZDtgvh0rzddKAmP5wbzYNwJCyhSJgwrvBbhZmwfm2z/ZR0yGWFMSyI5tRfTiSNw0ZJkXAWIqyeAvF6xcLWvMke/cCIm2MOqqgOa2Zatdt82+1ThN/zqVDHiNZchz1w6WK3RoTGIgz2q8lQQ485qxFUBnGvclv9alt/rTZQOo/xhl0qYsagh60hq0BC2SVTJKnIMEVSV9vG7pKyP14VYEMEj0h6cMksAMNuTLkK4qp6iyClDh90+zGpoEb4o4dBaxIC/xvpTqSi4Xvm1TZ7aKzfOopDRxVCQ/pFwla7sA0goUeA2ogkby15+NRYxBoRlrqrtjUSBJKqPh2ntqkrPBSElBi4yR5yKOlQ6f35gnHnHgECWyGqhhCiQWSBFWYWBXHjusxbLHC5cgYOoG+tS8lI1AquwrIRAwvpmu0ALpSSJdNhMFK5eI9pg6lVxiasJ79x1C7gA7AN9BN548cqyXqU67eKinqEpp8sUmF7zIJ0L1pwfYwbaKVpjxtstnnmBhIk1DU7Rq7ZzV4BHLRp8gWeH8CqgTpHYHSqPpdZU5P5fPT6bEmpiM8oNeLM8V6M726v1svJK/gvaE3MGeX++UooSWIh0FHt9XqymKxGi7vDSf/xT4CmpyfQAbx/wsuIlIABj9i9L8jyL+lj/9XxYg7cJeEc2h6/nKevcDlM+/kPnMAvtcD491/h/M+2DV/zf+EEfh0rjH//VYB/Op5OZpcLTMwX6hIsQw0i5umrb7/GgRP4DTStCP/+K5zfuSgi4QtrCfOKxG7gBmpGI+rbrR1q0mjx22p9M0JHcsYj7mX485zz32+mP47I1YTs11cEQm09WcHHO7ABGa1Xd7Pf30xvJkvyAxmPZtO7W3i7mCynV5Pb1WSJlBZIgEypJ9H03H12rxpewRFJ84D47sVVnlx8pbuvEh1j9BlviEAhacfEzxaHz5eeXxlPa8VhhPCXesbDy0e4JhiIK4WmIxHFCl+7Hma52fxusRqBml/6WxZlnnMhLDdYixXDPXrRm91SqUWaHiX6GZDiwSPI/r3gZda8c/suRJV8gPy5aw2SrrANMvqrAWrIPiRF94gsSRQTfIAe7H+QTkzpSPfjHy/8WlBxFPej8yrNymq3yEM3A5CYBqgisV1rU+Qqzrsl1OMgA9IFKzBEL9avA8PifuimbpAlsKL9aKRJhGTA+sFvsre7bZe/GeJ0iNba3A/mQ8AfscmU60GXRxJAFJt+cApjcV6ByyC7PjmIA9n3UdEPLq1blPsJNExevQTbrATnwdxWcnms3yoVDbj8JmvcFbCJV6t4QOAgo4qRAyKnq5DtHBtw865FYlZAf3JsvCsx4MptuHjA2d1CJ+h2+c9ZgyoehtIhHFjmgEm6H71f+G0hepDcIV0E9LFg8auVGHKBJG+QMc7tEHoJkA2gYAPuj7ie2AVOHzjoANK1xr0Um8/3RZ4gDG6pPcCCJRL8Evr+XjjyiERpmPmPtbuK2QDw1n7IX2DP3wecvM23OeK12mjWT7C+nCyQ5aSQA2zXdEW2zeq/eykiyo7X/i55iFiH3R7yRpOjTYfQ/RQJsl5lbn/Si3Y93yaDlypBntpyzVk/D5bBeDwEjeV/wY3pR2Ndr1BD0D0JQA+gQB8laD7ABEjPIKMhmivrEn38rLT4Pyyn4iHo8IN37aaWARbAngcOOECB7B2Zq5x94Lf20SLNgx4AT7GGNaLcHG34XeIA2w2aFvDfizDKKfpTi3F6vvsNx8cPULheQo/phhQYlKmgAUKhDUY4q10ma7LHlyRig8iUkBjZwv1GYf+7GPupBUa6210TAb088ozR0OMuDOU5xPiNN+5h+8Yrgw/D+MQjrLjH4Ss7CmnAjWPOSb07pIR8BHWdhhgV18Ft4Pv378+Tt939/Tl0LRflhwt7b92vB5H2l7kmTGh0ExZzRWNy5v6cXM+nZHTtdoaHZaPbKcKHV9PR7Y+jJVnu9pDjN0jB1My439/17O6+mO7Fk0OQR3Ld2dQW9hfb2Jc9/gti3OMi+LrfmvOdNaGP8LnwfwHnj6j0CmVuZHN0cmVhbQplbmRvYmoKNjQgMCBvYmoKPDwKL1BhcmVudCAzIDAgUgovVHlwZS9QYWdlCi9NZWRpYUJveFswIDAgNjEyIDc5Ml0KL1Jlc291cmNlcyA0IDAgUgovQ29udGVudHMgNjMgMCBSCi9Hcm91cAo8PAovQ1MvRGV2aWNlUkdCCi9TL1RyYW5zcGFyZW5jeQovSSBmYWxzZQovSyBmYWxzZQo+Pgo+PgplbmRvYmoKNjUgMCBvYmoKPDwKL0xlbmd0aCAxMTI3Ci9GaWx0ZXIvRmxhdGVEZWNvZGUKPj4Kc3RyZWFtCnjarZdNb9tGEIbvBvwf9tgCtrXfH8e1RbcKLMmxGCPJpWApxmUhkS5FHdJ/3ENOvfXUWTtx23hnjAi1AYGy+czM7s68M8vPuJOcc5Z+T/k/31yQrN4eH00ut5xL91O1H3s27Y+PzksmHt8WTAolmVRSsnLLjo84u4PPSRzaajOH15Rn5Yfjo+/mVmunlBbylHPxPSt/ZUX5laUA/qTR5tHScxvCTqZtPZFc6qwB7wNnwnr1tQEhPhuQWS4IERIXUM5mOW2lSQHrlwM2WMCGieDltwZslE6c/caAnXaSKeMkFvDFclHGaZYVRmgmvVMY++rH+H4+W7B4dRtvivcsLuK7mDflpWBK6ICZirdAl0VkxdvyDFalOJst0hPn4YS92g9tXZ2w12+Km6KMN8v/PM6Lt7OLZd6vDpopLdHlOwseiJA5R1cv/ITriQjBZXkwrJJrlI8xvgqOa+GzvPHOg3/hMf6ymBeL2QJZOPeQrVyhNGRoPtOU1hxIjcZdLt8ty/wxW2eSV8MxdpXHguIkZq7zyS2gHijuSiNFIWlOnJmrPOk8vcB4vkLOw2qmRUATUQgppNLG5rNJGXgReFR44mqa+Pz+KucSjMrs9c3sNk7zmQRaZZjz0v0bPj3vN2uw4MJnA9fx9ekKeghovRDuVHIQQpCW6ZtVcQnyz7nz8B+2btiHpv6lYkKmZ5DKttn+PDTpS2LOEPGDAvYG+P8jhGps1mza1OC4GSCQE8KzhQ6VWh2eKZZNCzadXcyK+flNkb6gzUropCjyuYZ/MfakaZgghISHw3DLIQmARutaP/1gRWqYcriiBGl4yC/cGZ9QNPkX8WK2XMR8zSkIOXD/LPOtfYSLLh+vtiRW77f3m3bbNt3Y56O2IMCUhQrrG5zENoi7AKlGcet2d79vdki00llJ4k2HjWCO5jb5UxGO3t9qGD/Ve2SxIEiCpKGI8gMYD/ShrJs8pxS9PZv8aWoj6NO8aj7mwaSYBwRquKV3Ztbtxnbc123fNTuk0qFSD3BtpaUzcNXc7Yd+h8kDDee3yXHHD4nVKa5J7rKtut+r3UmeTgP4AdnwIEXSCDTYHlQFBKWq2z87RFQ0baLuu3Go6nFf5etOGpBxysBHRB6SmBEYtmK4yJBc148IqS0d6PhH3cFUn68eGIdI+Lc9UueG0+tsu7G5G6r86cCcEUga5BcpW5vKliDvh369rxHxtlrSUWMV6xTtdfdQsUgRwBz70h6vq6Hv8FLQz28nX+ChuWt3kMnrKq8XQqbCJwxUHbLV4qGzE+QGbcyO5C76bbvDChfqjl7wokqSjFStki/QyAGrh/ZDcJQkAyZJGOlcShgSI6VVh0DT+cMxaRaksHuYJ9ohz5rUt8jN3SATtaY3aP2pQu72UpOgxBqsOyQLrOF09lw2cIcaeuSSrMIhTp1y9EHCrckjyuI1HW9NiYrxBp9FWffXFlbKzuN0lm57KqSrnUm3Pc8m7Om+9wP8OXgLn+rJ099fq7LwCmVuZHN0cmVhbQplbmRvYmoKNjYgMCBvYmoKPDwKL1BhcmVudCAzIDAgUgovVHlwZS9QYWdlCi9NZWRpYUJveFswIDAgNjEyIDc5Ml0KL1Jlc291cmNlcyA0IDAgUgovQ29udGVudHMgNjUgMCBSCi9Hcm91cAo8PAovQ1MvRGV2aWNlUkdCCi9TL1RyYW5zcGFyZW5jeQovSSBmYWxzZQovSyBmYWxzZQo+Pgo+PgplbmRvYmoKNjcgMCBvYmoKPDwKL0xlbmd0aCAxODU4Ci9GaWx0ZXIvRmxhdGVEZWNvZGUKPj4Kc3RyZWFtCnjarVrNchNHEL5TxTvMMaky8vz/+LYIQUxZtpFECrikRtIAS0m7zq7kgrxG8oI55sAhlRdIrwMxkOmeYGyXVaUqfz2zX3d/3T2zfMSd5Jyz4fcev/7mgmSr7d07hw+3nKvwU9zvWvagvXvn/oKJf/5bMCE8fChl2GLL7t7h7BV8HlZdHTf37reb9XTBpJRs8fLune+m9nu2eMMmiy9MGC8/MYGAtXZKaSGzJlQwCkxw+WEXIwF7Hz4tfErpWHe9LTAqlP/HqLCHQh5KLnXWrLcWduf8f5/tMyNZrAxOfgL+L2yeujqxddqweFn3LROHeUNWSk4agqcU1kpj8uwOcMkdx+CPf6heTI9PWXXyYzWbvGDVafW8IkxJ5TBT1Y95nDaaxp0uJtVBnkbODYmdPFuM8khlFYkUEDDIos54Enp8iiyquA30opyH/KJKW5qlx/uuXkUEHAquefJ0MpssqtnZAeFazXUZz6aTZ8fjs/zzmyFlqGirqupxcFwLT+CJ53AWGMT8LcFzeJ5M22aXejZrV3Gzafu2ZwZia77v2Cz19To1KwCweWxY9Wrf7943B2w8Oh8xyC3LD9ij2P0Sh8/V+3jATkcneQaC1kPuGzQApOFa5Z0odCCxc2bO2YlmYmROWHV/zu5XrBqzmQDEg2M2Xzxghp2Nn56z4QdkLa+W1hsOiymFrXNajY/PTqsTJCO1Y0oG1MWPzo9Z9WgCOc0eTNh88ujp7GzOng9fHh5Xpy+qOZtXw7dxXi6cAtlW1mucwgPD1SjkWXROK6a8ERgcShzHkRoS9OuRxgemhUXD1hoCKyTTSloMKwXXI6twrrT22dp5TZg5kMaPTL7+QnQz7RETQnxQvOn52WwxCPVRXkA4PPyXVj41MNkgwgNFm8JdxFctUlW8JZHrlMdZTeM2MY9zIO0UbgX60sWLLvW7uKr/ahCyFSet9AkpSZAPFO51XCWsJNEMp/xO1dB6Ubh9E5FCpumt9i1CMSS9obf69nW9rAdy8+KrpaZ9NMk/q9ZS0L6NfT4KtQ3qJlEIKUuz+/M+DzTc0QumfKIZEWhu6+1F2+2QRW0hS9fYqq6QpH16te/y1EJXW5CGtssDFbRvN6DIak/n5mofESTMTDfJautLznx7USMR5IYuicT2iDed9qqgZNuLrl3GBjFwVTEC9bT5/NYukDjQ+rjOB4MP9JIgvnnVFpxec/U6YakmjNAkdp2Wqfs9jw28xFGHtFeBXhRCIq1rhCYo85ZER8Sh3pGwpt0uO6S+QHtSYAmpL5Zec/x6v1widULRS86vVKXPByEvPOv0j7f1qs3PSdoI2q3zUYWEvnQ3CmAdtCGBSC01wxBG4tK71KwRsA501vx6HjsE6gsJF5dtgwm+oTlCOhWrRLgJRfaqUaF8sk/NDsF64QpRny8VjhfSZZma9BJ6nNjV7W/5NsfB6qSNqml3Ma8vfhjfSP9sUM03HId16TJ1SJNkrSGxGFcetkrhKO2W0OVTWKzLV5bGETEhHMgShX2Xh3mpCtS+TN3V8QRy8AGtJE0vUisgUyncMHqNThAZVZyL/+EcBKwNzTIg1xGZS7ylF+7j5hJp1oWhA3G5T9iAoAph0S47rGY4V+AZ6WN1cHRgbFpE+oMssZsHQi0ngViXr2U5kpD5oBCDSONsvCmsCGP4fot03UqaQo7HBmmwoNOnffIH1nXbUFCWi9hjnb4uuKXBD4co3Mu626bRFNpJstU34qsjQnlJwgb3JGzN4eyOAiM0iaGyUri42veY6sMsRUG7tKqXyDmUdZbEYtVN+AK3l3GDKIMUhf3C7Fdf7DfYNCWHBoKkuEW0RQZZQNZIuSjseAu1YtdhJ0rOkGDsPMkEetEVxH29jmtkUDB0PF2Nq8ikqy1NU70dUgC5zdFB6kIGbDDtFz6Q0HwPYqSnY3GQCqThN1bdKP6N0yXvvEnY2RD3dNJho4LUdCT1e6RkBF/Ya4+Ufwsdf4Ef7JYm3CTobSi48rgBcdjt0SNqZwTtl4d1E6EbTUi2eu5o8W/xSiOJ44B2exH/fB/ZOrFNZNDDsD4xkIxdQm7iuB5OJ9zHi6D5u+2y3Vzfiozb5jI1dXsEU71ELs95uBoR8cuu2b+9+RGb2o8vKXBojvO3Pd7zYX5zDtnU19oT2g07tOLWdvjBolcSs3hNHDyHMooyc4vUgV7wb3rJ49rHP8M/fjA8OHmwDVr/78sull+/7PLki5Iy9PJBC/x1l5sTP1wweWlw3jfxMh0xEQxhwFnpyo7DI956xYK0/8P5SniBGHGgAPC46BXs+GqIPmLecXbIoIBY5EocLA1HJsZ+UyxCegzS/zEUsRd5gN8l8MulEJ4bw9XgKyAbeW3JgT674EpGrzmXTuOWvLG6/JBcCNie0rAxiyTJ0PMHxQsXwodcfJ4Snyun8SwYyW9JpEKA7II/cVv2hrdsgtfq1vanYH9eylvbHyBBVqT+BoN/AzUa9dEKZW5kc3RyZWFtCmVuZG9iago2OCAwIG9iago8PAovUGFyZW50IDMgMCBSCi9UeXBlL1BhZ2UKL01lZGlhQm94WzAgMCA2MTIgNzkyXQovUmVzb3VyY2VzIDQgMCBSCi9Db250ZW50cyA2NyAwIFIKL0dyb3VwCjw8Ci9DUy9EZXZpY2VSR0IKL1MvVHJhbnNwYXJlbmN5Ci9JIGZhbHNlCi9LIGZhbHNlCj4+Cj4+CmVuZG9iago2OSAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9MZW5ndGggMzE2MwovUmVzb3VyY2VzCjw8Ci9Gb250Cjw8Ci9MQ0NKVkcrQXJpYWwtQm9sZE1UIDcwIDAgUgovTENDSlZHK0FyaWFsTVQgNzUgMCBSCi9DS1hZUEgrVGltZXNOZXdSb21hblBTTVQgODAgMCBSCj4+Ci9YT2JqZWN0Cjw8Ci9XbnZQZGZfamloY2JqaXBwam9wa3BmZm9jaW5mZWtpbm5nbWFlZG0gODUgMCBSCj4+Ci9Qcm9jU2V0Wy9QREYvVGV4dC9JbWFnZUNdCj4+Ci9TdWJ0eXBlL0Zvcm0KL0ZpbHRlci9GbGF0ZURlY29kZQovQkJveFswIDAgMTAyNCA5MDFdCi9OYW1lL1dudlBkZl9oaGJlb2RuZGtmbGprbWdtb2JvZ2ZucGJiaGFqbWVraAo+PgpzdHJlYW0KeF7NnN1zFLkRwFXlN1e5Dsc2HwdUzQNnbg8D+h6pyD3kWOwFfLExNoZwVIoAvjNnG4dUJZX/Pi3Nl8ar8UqjsXMs4x33LtJP3a3ulmYG/ACbP1n1TjDl5anGpDz7+inbz04W5rN/woGnPj5emPf+s6OWHDdSPC36bWF+f2G+7AM/0FRzAp9rBn/se05F9vXXhXkmy3+UY9n0r5WeEh+5Yql4I67b8EtbTQDYwQ+Alb1YmA9Fk8KL1ojbaMyL5peKRDQhlA+tEbfQBJMeiA6p20QfNKa8aI24hcakD6JDqnqiVSZgxDWoJlPiI1dMtXAg+LnSVhNn0Kr2zr630Kj2ojXi3mitJvporWnWRAhCfb05YuaFYDOBI9B8EIaNK1/DjpjNRu4YYAydB8PQKelr2BGzAGj/EGPoPBhAR3Xua9gRswBo/xAj6HwYQMeF9jXsiNls6I4hRtD5MIBOMK9RHDGbDd0xxAg6HwbQSeIdtiNms6E7hhhB58MwdNrrMo6YzYbuGGIMnfbOirzupdWwI2YB0Dp1VvgwDJ3yhipHzGZDdwwxhk55o7ES3mE7YhYArVKjsQ/DpFjqHbYjZrOhO4YYQefDOO7M9I6YzYbuGOIUXS4ALzv7XuTZ6f7aNYA/c5K8JSbni1uNxNDx6WDQrgL8mbONUTfSIe5Np6aN0q4C/JmzjVE30iHuS0c9oeo4IHO2MJpGOsR96biYNuFxQOZsYTSNdIj70gnm9buZmbOF0TTSIe5LJ4nXsjMzZwujaaRD3JuujkRtulmZs41RN9Ih7kuXe9YrxwGZs4XRNNIh7k2nvNF4ZuZsYyhyvrgvnRJey87MnC2MppEOcV86j01aabbVnSt2d2/4DOl5aOcsyFhtKOrsnDCKp8RHLbG7veU00iF2G3HpSsLL2hOkuPyk/opzwpozXp2pqk7AWfbh2EA/3D/59/bHg79/Pvztwz8+H56efv5y+vvpwcGXD4cnB59+Pzw5+fX4/aePx9n4y8J8OcJqlJcwQvj70+7C/MPHz1+/2Z7c2z08/vSvv376z86X4/cn2y9/3s3qILp7APqwI4VRGvNkux+n26/eja9k36O5UZbtfobTJ7v16JxeNx8/fvZq495fvh6+PzJ95U5fTArblwjq6z5+ICm4erb7wXa8iu4hhb6D1xyS6Jfv0Q/wq0AUfplD2AgeoTX4Fk0HZKGATHGsK0CGxugVmqAd4NmA9zm0BZI5YJygpyDdQ9v29xV0HS3Be25le/abBG2id2icjk5C0SklmjTom4BuwL+FYxXOttAinN1Hr9GhRXyHvoHf78JZ8ckqfDKG4znaR6cwsB20ngyf62B4TYTjGBsWqdA5Bpy3MJx1QPrGgi7C8MznS+gGvJbQUjpoHgoqMcV5Bfo3+1oEtOeguSfwWrSY2+hPcLwNx7r/05ejj1NsdiLnhAWiKUFkjfbLCN0BVeV2St1JJTG/ZFLjQBJGOa9J7oJb7YNSXpUW3YL3CaincNC9YdDs9n4IGsWU1I4mwF6gqEXrU7dTIqGtFEMx0oIusQkvCx+ygLRTW+NOEWpvwbRZhsC1Aj8lTLFrozQz8FzGQXEiNWvscIqegUNsg2O8APd4ap1jHRxnK80sMkpXaXaROMYHTCjJlflioQITx5ZHaUZQBMcRcCk5aebpjp2V63BswbEzpCF01DxNM4TmNKIvM0GkaAzRI6mcF5g4DoQgCubQeTHTJO11OF7aTwaKmyRUR1BWalHhEesqT8pSZ8eWRGOoKP5rZ68J68aJkp2GMhwBmeY0xTowC1dIzlVeO819KGXvoB8hkK6Bcubg/CHS8FOYWPujFRA4/jxQJhaaBlJeaLoLxMiGSHcieMicS1Znlkeg9UfwMtmuOdJnd5nvRIQhMKUVlSpr81VjjrvgM0nGEJJEsKRZQ8jIcUvCcD1N5HBJLpzg0pOcuAxDlElOBKvhApOckKGrJ44xc6q+Ceh90ya4F2XGGNAapFjTBcLFWePcmCBDtUEpk7VnmpzaLHpNZn1mNbEP580GRKWtfXs2hmNAjeWCRAxgAI1Vc1mGauxyVg26WHmLi9DDdF86oq/pVcMyujHKhpjDPDSQsJw3y8k10PzTeivMzOGiBqyK1mI35KX14SfwDeO5k2GAgzfGGKO0Ll01gO3ZsGNAk9yE4BiQNDcpLoVnEYPGEO+rQV+DyJIa6qvoFkxAOaU1QQ4Kf+nEsVWfX6SZQ4rLM4eUNK6vtVGa9qtISYK1j3Xj9LAIeWvVvwdqbqZpkro1ifGHNHVrSiL6gtFrzHHte+k1ZxFxuOaB3RPRKnpNxNlMdW97q3IoQ6K6WURXZuNZScfXRjDZi6s3ozStlxEnnIMRZ+UHHDtliZ+kd2FvesouRfGi2PDgwSMWNG9GfB3KAbOja4qClVE2hMfnOBCEYa1d1U/sNZFxHe8nNgBN4LdNT5UwzDqY5joCOs1S1D4gkkUoSOTNxZkViEkrkJWv2D148/MGTBpzfhtdRd/Cz6WhduTDCWnORT2LH6LXUFuPIXCdZ8Ekc0keA5hmLlmsbHiwMi5wtcx56BYj1E85acWz6opzYZKXcP4sNb6RYkcnkCrNDCQnEX2dzeO30K1RNsicCO6fEedC5nQNO7a74MkpRmIdgZVmAkl4XF8D1U40eHkpIVRWKseg2hc26IzTVExKFdNL2JojpYrD+rpPYEWtmrUaRo8QGWWD+DkNVnpO8lrpq1bpZjelvapPMoDQJAIpzgDn+B0LvwOF5djxu1N7lW3Dme7DRFt7p18oVpbmh0U9xIJVwIXGtR8yeN0dZUP4YTgB4w6BU8G3N/fmkILXGlSMt9NCoYigS7OFtHdZZhGawJLWBfUEig9zi9lNUMAyqOIKVIlP4Wwdzq7Bu6kZr0B+vArny3Bmvm1WAxN7mOtdE6gtx6NBZlROQ4eQC6ZCNgrn7Dxbh5Kz2Mqtrnzv2eVB8W0Tksb2e6+GGQYPtQSVzobr2RrARUyOkSRnEWhZeozkeawulNb15eRqEnYZ6nbahOERaNlg+YKGLr0vbo8nkCEbzv40dNAXtMMiIygGGHZxeYfZO7OzkFFzyc5UR82NOK/6D7zgoAoHckjMlcNhZtybMnzC/EvmkKEcVDg7BcUe/gYE73Wrjzm0k0wSfNMUZZjX/vjKTsI35f5EAkV5sSVcIUyRZlqsgho20GJC90XMC+9ecmezYtX6REr39snBiO5FTpoLPQomR3lpuj9C8XhgBALONakRzD3tplTcs7m6zMz9YYqnATMavHckpXCvN5qKNep+vS4AEQrApLNrUhhk3+7lJc2K4rnDCKNwRqVzoXi7vgI16Q9RPF6YxTinaKbmd8g+0JHQvY6cG4yzszpImJrFA4LBrgj5jcjGE8raNb37YEekVKm6eygXxmWOSJgMxVOIWfhs1Cp3VWAcYJyWpCqEYDUIxfM6IJjnbHbMfOwPUDzrmP1/Z2LxnwFEVC8Ka1kbgqIn6GeI0/sphqgQgvXQ2k7eGGL0wZWKEIKqtgle2zy1P0C9hEMpOBGyvgv1Zrl3sGz3Fq7GlNVTNQNlcSBEksYSy0ldl5MhrGvomeGm5zXEkvouSyUS1LfNzLip4BnUJWb59K66pJMMQsKf0CKkuS/cFM7PwB33in2X/hhV3UaDMTBudr6lg5GojwoEh4IIqXU9McxjkCZNbYOBzHJiy07UpJxRAhEVrhnn/q11e6Vps7wYkmSiqpgM1kxrsWfCxTc2YFxFi3bDMQGlKij/AChVWflHQNGRBmKidana3FmQ0H3OoronD2Dt1xQ3dX2VAFBWVzh4/JQ2AEtggOXiYr19JYCoqMRiq13dBPcV6xFL9tbLG2keoXmkc7ZiR6I/FBUGKaLGrL6z9L05wmwlUW7B7AYMVhBVR+475UNpJmqbJ+hMMhmnbNGVOEoF0oArsvqWjXInyOyO2psFnNv2k4kkDyTiykmx5eZQSVRuICazBBfBjLHmKf9yNWxZBiuIZeE3hMlAJIFZM2mlfYp/v1ifmacI+oOoogYKB2mFsamMMkrWSMSEUg1IuWMyhCbCAS5WE8FzmWsiaNtbaw+19WBeRBc7jzaqq5MpqioJw+c2V9KZT+aJ07mzKXCUYDgdRcMwb5a4Z/LfKFUnwTGmUydLzas/jSqetQymOVOcLab1Xs3lsJgCpJq5j2AMGNbCCKbm8nXwCvO/5dwETVz3Prlkjv8BxwJ9vgplbmRzdHJlYW0KZW5kb2JqCjcwIDAgb2JqCjw8Ci9OYW1lL0xDQ0pWRytBcmlhbC1Cb2xkTVQKL1R5cGUvRm9udAovU3VidHlwZS9UeXBlMAovQmFzZUZvbnQvTENDSlZHK0FyaWFsLUJvbGRNVAovRW5jb2RpbmcvSWRlbnRpdHktSAovVG9Vbmljb2RlIDcxIDAgUgovRGVzY2VuZGFudEZvbnRzWzcyIDAgUl0KPj4KZW5kb2JqCjcxIDAgb2JqCjw8Ci9MZW5ndGggMTE0Ngo+PgpzdHJlYW0KL0NJREluaXQgL1Byb2NTZXQgZmluZHJlc291cmNlIGJlZ2luCjEyIGRpY3QgYmVnaW4KYmVnaW5jbWFwDQovQ0lEU3lzdGVtSW5mbyA8PCAvUmVnaXN0cnkgKEFkb2JlKS9PcmRlcmluZyAoVUNTKS9TdXBwbGVtZW50IDA+PiBkZWYKL0NNYXBOYW1lIC9BZG9iZS1JZGVudGl0eS1VQ1MgZGVmCi9DTWFwVHlwZSAyIGRlZgoxIGJlZ2luY29kZXNwYWNlcmFuZ2UNCjwwMDAzPjwwMDc5Pg0KZW5kY29kZXNwYWNlcmFuZ2UNCjQzIGJlZ2luYmZyYW5nZQ0KPDAwMDM+PDAwMDM+PDAwMjA+CjwwMDExPjwwMDExPjwwMDJFPgo8MDAxRD48MDAxRD48MDAzQT4KPDAwMjQ+PDAwMjQ+PDAwNDE+CjwwMDI2PjwwMDI2PjwwMDQzPgo8MDAyNz48MDAyNz48MDA0ND4KPDAwMjg+PDAwMjg+PDAwNDU+CjwwMDI5PjwwMDI5PjwwMDQ2Pgo8MDAyQz48MDAyQz48MDA0OT4KPDAwMkY+PDAwMkY+PDAwNEM+CjwwMDMwPjwwMDMwPjwwMDREPgo8MDAzMT48MDAzMT48MDA0RT4KPDAwMzI+PDAwMzI+PDAwNEY+CjwwMDMzPjwwMDMzPjwwMDUwPgo8MDAzNT48MDAzNT48MDA1Mj4KPDAwMzY+PDAwMzY+PDAwNTM+CjwwMDM3PjwwMDM3PjwwMDU0Pgo8MDAzOD48MDAzOD48MDA1NT4KPDAwMzk+PDAwMzk+PDAwNTY+CjwwMDQ0PjwwMDQ0PjwwMDYxPgo8MDA0NT48MDA0NT48MDA2Mj4KPDAwNDY+PDAwNDY+PDAwNjM+CjwwMDQ3PjwwMDQ3PjwwMDY0Pgo8MDA0OD48MDA0OD48MDA2NT4KPDAwNDk+PDAwNDk+PDAwNjY+CjwwMDRBPjwwMDRBPjwwMDY3Pgo8MDA0Qj48MDA0Qj48MDA2OD4KPDAwNEM+PDAwNEM+PDAwNjk+CjwwMDRGPjwwMDRGPjwwMDZDPgo8MDA1MD48MDA1MD48MDA2RD4KPDAwNTE+PDAwNTE+PDAwNkU+CjwwMDUyPjwwMDUyPjwwMDZGPgo8MDA1Mz48MDA1Mz48MDA3MD4KPDAwNTQ+PDAwNTQ+PDAwNzE+CjwwMDU1PjwwMDU1PjwwMDcyPgo8MDA1Nj48MDA1Nj48MDA3Mz4KPDAwNTc+PDAwNTc+PDAwNzQ+CjwwMDU4PjwwMDU4PjwwMDc1Pgo8MDA1OT48MDA1OT48MDA3Nj4KPDAwNUI+PDAwNUI+PDAwNzg+CjwwMDVEPjwwMDVEPjwwMDdBPgo8MDA3MD48MDA3MD48MDBFOT4KPDAwNzk+PDAwNzk+PDAwRjM+CmVuZGJmcmFuZ2UKZW5kY21hcApDTWFwTmFtZSBjdXJyZW50ZGljdCAvQ01hcCBkZWZpbmVyZXNvdXJjZSBwb3AKZW5kIGVuZA0KZW5kc3RyZWFtCmVuZG9iago3MiAwIG9iago8PAovV1szWzI3N10xN1syNzddMjlbMzMzXTM2WzcyMl0zOFs3MjIgNzIyIDY2NiA2MTBdNDRbMjc3XTQ3WzYxMCA4MzMgNzIyIDc3NyA2NjZdNTNbNzIyIDY2NiA2MTAgNzIyIDY2Nl02OFs1NTYgNjEwIDU1NiA2MTAgNTU2IDMzMyA2MTAgNjEwIDI3N103OVsyNzcgODg5IDYxMCA2MTAgNjEwIDYxMCAzODkgNTU2IDMzMyA2MTAgNTU2XTkxWzU1Nl05M1s1MDBdMTEyWzU1Nl0xMjFbNjEwXV0KL0ZvbnREZXNjcmlwdG9yIDczIDAgUgovVHlwZS9Gb250Ci9TdWJ0eXBlL0NJREZvbnRUeXBlMgovQmFzZUZvbnQvTENDSlZHK0FyaWFsLUJvbGRNVAovQ0lEVG9HSURNYXAvSWRlbnRpdHkKL0NJRFN5c3RlbUluZm8KPDwKL09yZGVyaW5nKElkZW50aXR5KQovU3VwcGxlbWVudCAwCi9SZWdpc3RyeShBZG9iZSkKPj4KL0RXIDEwMDAKPj4KZW5kb2JqCjczIDAgb2JqCjw8Ci9TdGVtViA4MAovQXZnV2lkdGggMjc3Ci9DYXBIZWlnaHQgNzE1Ci9EZXNjZW50IC0yMTAKL0xlYWRpbmcgMTA4OAovSXRhbGljQW5nbGUgMAovU3RlbUggMAovRm9udE5hbWUvTENDSlZHK0FyaWFsLUJvbGRNVAovRm9udEZpbGUyIDc0IDAgUgovTWF4V2lkdGggMAovQXNjZW50IDcyOAovVHlwZS9Gb250RGVzY3JpcHRvcgovTWlzc2luZ1dpZHRoIDI3NwovWEhlaWdodCAwCi9Gb250QkJveFstNjI3IC0yMTEgMjAwMCA5MzldCi9GbGFncyAyNjIxNzYKPj4KZW5kb2JqCjc0IDAgb2JqCjw8Ci9GaWx0ZXIvRmxhdGVEZWNvZGUKL0xlbmd0aCAyMjExMQo+PgpzdHJlYW0KeF7svXd81EUaP/7Mp27fzWazLQlsekICCWEDBCJZWqRILxIwEpBuodjQOwFRAQEVLIAKgp3DFooaUM9YTkXPciqeehbOjsrJKSIC2c/vPbOfDSEW7r7f+/3zfbHxvc/MfOYz5ZlnnnmemVkkRkRWWkQyec655KKI8dxDpxPReiK9ftqc6efvKki5D+FjRFqv6eddNk3+YLaTyFVF1Nk2Y+qkKV88PPxfRNUD8E7XGUjwLgiNRXwR4rkzzr9ofua9k7Yhfg9Rn+h5s8+ZJLd79EaiK99FvPv5k+bPCS7RJhA970H+yJx5U+fIw7o+jHgZUcqP6i7KELifMpR8yiAyPksiPtP4jD/jVPqaiGUmYH620YP0d1bIIrSdHaEAHWYh1pkGkkI/oaePUDPdQj4aTWuYl3LJT2NoIFOQp5hWstuNS4x9dBrdSHcZj7PFxhY8v4FeoMNowUcKo240FPnH0FTaJ39OtcZtZKGlZKeeNJL5aRK9g78f0Yab6Gb6M/ujcRi1+mgxyqui3tTbeMY4Rh1opbJKfdf6KK2mJ5hmnGPMpHaUTculYuMd42PKp1q6mx5Em4pZkzKAsuhcuobWsZD8AkK30D0UZw6pTu6rPo2aBtJYuoAupeW0hV5mXjZcfVc9YPzB+JI0SqVCtGkm7WMVbIh0r+Iwehnv0wTaSS+hv/yvSZmg3K9OiFcbG4xnKY0eZzb2JHtGLVevb77SuNN4mBxoT2dwZCjqmUxX0TO0m/5N30sLjYU0gEah5r+wTBZh+eD4O1JIWiAtkN+iTuhtHVp7MW2kBozILnqCngJv/kF76XPmY+lsEJvMVrPvJYc0RXpdvl3eIb+tMOVP4HcO5YFHF9G99Bj9lV6l15mK8svYcDaLzWZr2Qa2V2qQvpV+UizKVcpRpVnNj++NHzWGGj9SkMJ0Bl1OC8Hbu2k77aDXaA99Tz/QIeZh3dkMdidrYHvZt5JVypaGSXOkNdK90kPyUHm1/IxSofRRzlVeVd5Xl6gr9El6/Nh98ZviD8X/Zjxu/A2y40L5+VQDjl4JqbiXnqa3UPp79CF9wuUH5fdk49nZqOVCtozdzB5if2F/Y1+jlyT+sqWeUj/UOluaBz4tlm6Sbkbtr+PvDel96UPpG+lHWZWz5a7yXPlOuUFulN+Qv1A8Sr7SSemsDFPGKwZGplw9XR2lblYfUJ9VD2hV2hRtjvaVvli/2vLX5g7NH8UpPiPeEN8O2bVAki4HJ+6guyD3OzAGL4Ojr6HFe+kgRiHMslgB2l3JathgNoSdyc5iU9litpTdyNax29ld7GH0AH2QdLS9WOotjZImSVOlq6Wl0nXSDvztknZL70jvSvvR8oCcIxfLneWB8nh5gnwB+nCRvEC+GpxdLW+RX5ffkr+Uv5L3Y9QCSjvlYuVy5VblfmWH8jf1DPV8/N2lPq02qX9Tj6nHNEkLaxlaqTZL26x9omt6V324fq3+tv6DZQ7LYB3Q8gi1+kghzMF20hbJpyxk+5GQyRRyo+fFGIdRmBU/ULUcx7i4+HO0LU0KKan8TS2mNOD9i9gTVMH+Qgs1SYZWVPbSNvaBtFd5TjqN9rB6FlLuly9QX5ay6AFoo1XSk9ITrA/tkKqksdJ6mdjnbDN9DnmfTzezc9mF9ADbz3qwK1g3tpDelvzyKHY1VRl3SQqzsoHsAKEFdKUyhc6m3/2wSvqA9sXvUJzKH6GfGmkNRvRB+pj9iY4w1fgW2k2GNpoELbMS8n4Nca1Xh3m2EPMxBA1ynvY67WAatHg3rZdyOR2gn2mfugsS1Qea9Mv4TOUO5VOjm9ERMwyzjDZj3s2g0zFjPoeUPIU4j52FmW6DLinHrB5O42kKXQGtt9poMNYbVxmXGbPpFbx7hJWwI2wTZkQj3qiil/B3A73HVmAenk7/R5/4FGqir1mQ5bFyzIf96iXqKnWLukP9s/qq1hncvppuh0R/Amm2oQfn0N/oa/qJWTA2ISqhKNrbHW0fR+dJtfJT1JeFaQ7mbCH0eB+zJxeilMXg3nrM56cwNw5AT5xFf6Z3mcQC6NE5qN+CcgaDzxOR+z6M4FVsO1KmQGt3oG/QbxfrLl2E+mIoaQ20VhPa9AF9AW4bol0l0Av92FiU9ROdSVNQQ1cazrZiBB6jSmjWfvJfwe9c5qE+LJvdg/fqMUNdlEmV6qdMopL4UKO7NFN+CmuMgfRNWL3S6TQ2F61wox/NlMaGUUV8JNrwFpOVBvamaMWt0lRjqXxp/Dx6hf6EMYkpl+j9lHnKNcrRWJ8xo2PVvU6r6tmjsnu3imiX8s5lpZ06lhR3KCosyM/LzcnOirRvl5mRHg4FA/40X6o3xeN2OR12m9Wia6oiS4xK+ufU1Eca8usblPycAQM68njOJCRMapVQ3xBBUs2JeRoi9SJb5MScMeSc1iZnLJEz1pKTeSJVVNWxJNI/J9Lwar+cSCMbP2Icwtf1y6mNNOwX4SEivEqEnQhnZeGFSP/gjH6RBlYf6d9Qc8mM5f3r+6G4rXZb35y+U20dS2irzY6gHaGGQM6crSzQi4mAFOjfY6tEFica1RDO6de/IZTTj7egQc7rP2lKw/AR4/r3S8/Kqu1Y0sD6npMzuYFy+jS4i0UW6iuqadD6NuiimshM3htaEdla0rR8ZaOHJtcXO6bkTJl01rgGeVItryOlGPX2awhc/lnweBSFe/uOW9r6abq8vH9wZoRHly9fGmloGjGu9dMs/l1bizLwrpRXU7+8BlWvBBMHj4qgNuma2nEN7BpUGeE94b1K9G9qTn+eUj8r0mDN6ZMzY/msegxNeHkDjbwsa1s4HNtp7KVw/8jy0eNyshqq03NqJ/XL2Oqj5SMv2x6KRUInPulYstWTkmDsVpfbDDicrQNTW56JkMjOQ4NHtnCW8RblDIRANETOiaAl43LQp+78a2p3Wn5Od2TDp5bhrYYpGJGZDda+9cs9PXg6f79BzfPkRJb/SJCAnP3fnpgyyUzR8jw/Eg9yOWkRNTxPhhuKixs6dOAiovfFmKKNvUS8omPJJY1S15w5nggI2EfDwdtJtT1Kwf6sLD7AKxpjNBmRhkUjxiXiEZqcvo1ipcW1DVI9f9KUfJI2hj9ZlHzS8np9DiR5h7Dc0xos+S3/uT3+1P4zejQw/+88npp4PnhUzuAR48dF+i+vN3k7ePQJscTz7i3PzFBDat9xcrpkhqR0WTyFUJ7VkplHxjkalDz8pwmhntIgQyhFAovUNHjqByS+a21ZWb/5TqNuafVSo3GAvyXI8dfMVjb0KD4x3vOE+AmtcyyX0V4lXxo8evzy5bYTntVAAS1fXpMTqVlev3xSo7Fock7Ek7N8p3S/dP/yOf3rkwPaaOxakd5Qs7IWnZjBekBYJeqzNYctG7E1xpaNGj9uJ/yZyLLR47ZJTOpb36d2ay6ejdsZIYqJVImn8kQeifAIDWaQ822SReRP3xkjWiSeKiJBxM9pZCTSLMk0Ruc0Sok0T6KifFFRDJbmOY1K4kksmVtBmiWRtiiRu9DMbcETD3+yi6DTSTxMfLjS6Dt6XGtxEHOstiPEi+clFX+wQHTqs0NicU1vlKpjqaQqcZlsuhJnFLJoalySn2T5ZIXhHaRgsedQVXPVUM/BqiHNVVSNsOcYvjqXZaVkpeThi6GtxyJy07GYSkcpojTBDII/RexBFkJdubE0qTvZpHw3tacIlSF3SJl+SbAYRdYNaabqIfs7l3VBWTdxByf+JVoKj4XYJ7DbeEs7xdLl7kzTuis26yOyJGn5LKKWqZL6iOXVB3jr6niTqg5R9f5qlJSKkhiwm5cFF8zJ6bEfkiVzHjwNX1QnG+u9k3Tj3Zi1W2VUK8SX3mg0xayFFVEthi/E3o0NzyrAM3wVUQelg1poK3V0p25qtWMWzZKmytPUGZbptq9k9yCNSRYrk21Wq6JbGYuQ7oMNp1kVJaJqPlXVLLZYOLOXjVdhD2dGbXmSLGuKtZE9GXNpuqQqcFYtjkAgTI3SpJi9PRMu1CIms0YpN2Ztb2Vl1kVWybpLyiUFOawRlakh+9nnJBkZOlQ392Dd3GDz0P5T+32BgQJTqquG7E/xVpZWNRcXVy1VOxUvveL5pZ2CnOieqqqlzz+/VeMSs8MatTqjVFzbuYwNbrCPGtzQDgK0k2Qjvs2i2HYZcXDq2FZN6c4/tWxuXbH4ZGXJ+GNZqbKsPh3/86Lmxy6LvyD1ZJUdXn6BDYlvV3cdWy5FmvdyiZhkfKmerb4Ff++d2NAl1mt91/o30jrtRevb8tv2H2VrnrXQUegs8hX5L1Yvti5RLXqqHgikBgJFUgc5T9UL1VvVtdbd8l/sajUbBmNvpIfYXpheEoGp21OCUUFt6AcMjFgg2FGxuGIub9Q1eKKbDXMzdywtGHU3ssJYtrejTXZ/5xpL35EoKlyWwTLSCjbpzK2318t0GRNj5fb0BaMSzJ07ZP9QT92huiH7D+6n6uaDxXVzPyvmlAfqOpdRHaurq2OqpuREKMVDWZGAP6Dm5+dkaykef5fyrko1a98n/uq38Q/iy9jlLMqcm6eUx/8RvveSu195adMlW6T0CQf2sRvgi17Abtl4dkPNvKu/jh+Jf/3tGi6zN0NmJ0FmPZhAC2NdCiGGpwemKlMdaodAZWCAv9Y/w69WBrqmL02/VV1jV9un5DGSUr15bo8lVPCIzrhgb7fao7xXsdRFWSySVZYlZaV4IxTxlHkkT6O0Ynuks9lbPs+HeOrmHipGv8WErxbznermsrrUrPKA3+9N88HHw19OFkvpUt6tl1QRzc8vyM+5Wcp8vP7KxvqO3aYNuWryPc1vscIP/9htwMSqqvNG9XpU3ZWR/2z8y9cevWrTOYM7tFeePVbh8o79y5Ytj03zuriM3AJP7gB6aqdVsdMsqqJb8jRve5WVqY9gwqtWWcmDkrZZ8+wEo3awLA2wkZ3ZwxFnmTPmlJ2KNcK4ioFIoEeO1j0SA1g15GDVwaqWPqVUltbNxVq2k1SjaVtmpYpVZFtYkK2plZDvWmSSVcwUoaHSskzcolQf2yftbY7IXdRdh+NP/BSf+xNavxatvxqtt9K8WDVar6l5esRSZnna8rFFKbWsskgWCyW6YEX7q7VhcJtHytDMUjhiL7NL9hPbb/u19tfx5vPGe3njf619a+X9zT2lKc3redvuPdy8mnN2Jb52oG0yzRa93V4ejapcLHLyBI1V+wJRUmPqcHWRuldV26v16hz1gKosUjE/JJkskvweVpAG+DlyE591vJ1vIKbQBUrnjeZEmWcuEtVoEUMUPOSqfSUrVHcdqUE7NoBH96oPYxk6LRYervOyFcxusihqWJfk1t3XOu9s3f04L3dIs1k0LzUrbQMrlPaqDx8d+BPvIzqqhdBHhxSM2e1yviXfLisykzGcMWtGj6gt0qNn1Npo7N1u0tg9GZ2Qii/NarF9av3WpihWmy1VylA81va2HKlEiVhLbdOlGcpU6yzbpdJ85R7rFtuj1l22Q9YjNv9GZZV1o+0F627b36V3lXes79m+lL5SPrd+bXNeap1vu0paqVxlXWlbJenj7FOlWcp06wzbJdJlit5PGqz0sw62nWk50zrOpgdtpa6o1EOJWnvaql26LDkUzWq1pUlhJWDVEyo61h6MsllVh66Xay5HOZZxjyxZhlucUTv/Er102Z1RS8xVELXzLyStj3l4wG6RsUozSbfBesDKUF2V4g1UJnR4HSvd73l7P09IbzR6xjqilohisVrLZcUny4pkt9nKZQlBCcXIDkWSHDasc7qlvYu5GplzO3cvd2GN52I1oS4hToFRo6NquR7TF1qY5amFGIWn7BG7Q2qUuse8kKMYMlIMmai8vYM5eDHOzhdjOT84d39xsafqX56qcMjTPLd5blU46MHyhQTPZ3PReI9Y19DaE9czc+1KHYXZbDH2brVH+EJVJz5CDoupeC4XG8a44cKguFazJ+Dt6+zJ+P74h/FP4x9huQrKXx2pURYfXcABmVoH3ZvD5zR7LeayypolJAcsihezAdyl7V57tdyY6DansQ7okVyuW3y6bpEtkqTLVvALvJIV3mOF91gp117H2g0Rj4Vi9uH2ers8x77ILm2yN9mlhB6wWM1COY25Ro2KWsvFzGjCBE6ohotb5gaWdqhrdPKQGRPzj2HdryRgaSfeeXAoIUd8Ud8bs0IqLJGEjDQ9buVSIwwArvM6l/UVuRY9Zq+wLLJXiI6dFu4UtYzClyr75XI5Jis18jVQaZss2yyfydrz8uuW9y1yRC61ROWelmGWG+WNlk3yI5YG+WmLPWFYdamISrEuwrDaG3OWlkelCP/SfRVIWRuzZnWKSqPxJXLXtIsghi+LpOtBSQ7oJVKB3lPqog+VYvpZ0ljd6pPS9SFSf/02/QH9Fek96SvpS/1nyV4gFeqD9Pn6Mv1BSeM6aF5x8kNJUaglIQlch7CUdSwijWOp8b83b4UAdJTfOlIjP3msH195a2GzfAmbxU3pdFdszFp1rWWdY51LsTDdZXHrwYLgfOulXv3SlPlpS5RrLdc6lriu8V7rW5a2LLAsuCTs0L2QhHCaN+wLB9PCempHpzXUUZf9BY/YGNk8tohNtvE1OVKWGcusz5yTuShzU6YWyTyQKWV6CjYR4zZzmRjzldszFjzXYo6I9blOrM/C6oWgz6W61Gi3rl27de1iGiHEfF4YH1iaYYjU9i1/aPq121k/dk18Qfyp+M74Atb5i61bP/3w8cf3Sm/vXTdnW3GP+AXx2+Ib4rNhisz4OW4YxrHDRzkf+Lp8GLOA8+HSWJ6m7vTtDMqnq2y6+o4qeVPynC4XpXv4yuYmi/8XNoe/fWaZ2T810+NureUzTjQ7WqwOc4k7bnlgwGBW+dN8Grc7ckISusb7BqvjFvYP5hq5YMvktUNn7X7mrkcu6Xv2gIpN6i5/1oePLG2cmZLW/Hfl2Xh9p8m9h89w2lAxzCr1SfQnjbLocGxxpXug+0x9ln2WY4v1ftemnMdc71ptmkWzBSx+W1dXjavGrVs81hSfy+f2ebq6urpPd1/suszzls0+3zo/dEnmMuuy0JJMzer3WR1u1yjXxa6rXTe77naprojT4XM6HW5HmjPgz0v1+Fi9b5NP8vkoksXZBcalkcXF3YACcnqckvPt9IJNWoPWpL2hKdrSOTksklOWI+VkpbXmWnbnc45zTcjC/oN1+5NG/3HjQGgBaIA61xWe51lKJSEu7NW5dZyh5YKfut8fSM2SO0k5OSkpx7mas0aa/c2eRc8+U3/FrO3xO96ZN/rsaVX/2DOratiA3B1fqruGvbz43r9ndF/yQPwTVv1AbVbzenlo7rg+gyY4VL4aDzK+UL7H3Clhb8RO25nSmPlY4QslCoz6NBj1acHiqerUwou0+c6LCt9zvJPjqLWNcY3Jrs2Z4ZjmnZ41s3B6yaWZSzLXZDm8OXzFbtc+ymlsaigcHZE9IueZ7GdylLnZc3OuzL4y55/Z/8zRim0dnLnZuTmVzmjOYNtgZ7/svjmznFNzLnNenn2tc3n2fbb7nZuzU602q1PL1nJCtpDTn61n59icCguMDcZCkejsIJsd3BiUgrukqZQOLeQIV7ZPZ+kdfTINYFwtDQxHomUsxoazeraKbYKH3MQs7F9KLFzpUZjSsYM1+J0RYIFYaiAaGKwX5Ic7tS/Y5GmAjT2YfZeSGMBQxzdNmR88atxWinWvHcJHb6jnEGjxPO5izC0+WFf8WYLOK/4Mq11CdQljNRv8SM/sBX68YdJPt6VWZoM9IIjt3ublsTdibm+lM+KttAm4edpXMZcDac5KW5AjtbK49afWNDXSeth6OCuyK8DHgc6+2TU599n+lG2jutqkE5Dn9ycUS4H4q4h2hdJREi6PrqX5An5FSBb3hwaxSHjj0htWn3ZGdOe/6pcu/O5PzMcCevzd1CuuuHJgaUl31vD6xSsNejr+dfwd9mHG6mWXjYgOTPd26jn2sofnPDft+5edc8+pyK6M5pVOO/+pFQs+OJcxLl8l0Ek7hSc/L5ZTai1TytTh1jnwkVdZdY2pUp4iSzpZrHCplYV8vWUdYzZNh1dNC/ksQjRFdg2X5kiLpFWSIoUszQ+aozJi3FYJoyKs7eYqfMGj/szUSVXC/MTCUcFtbfZxfIhyXXyo8uzhw0d78X0PrBi5aFWIlse66xbdqnugRKynW0636mdax3rWeNamrEu73X+/53H/39M+1w5pdqfDAXdNz0u1OuwR5+vcqIJpkB1LH55eny7PSV+ULkXSy9I3pTelK+kMdnckVBZqCskhrgjCrQwB4bUlrIAqvi5wZSDM8NSsFAyJX0xtrHkel5STzd21iptYoT31hj8uWBRmhWVXvvvwm+8t8GViEfziqe7jz5++5mG5+Fg8fvj9NbWTbh+z4BC4bhjQnKPRP425tpPMLNxj8lYK43N0uEe0yfIOe0d6T3lPVbmhO19dy9ZItyrr1I0Wi0x2rdTCjel6y6VMD5FfK6J8bSCdrp2JUZQlKcLIh8HV5JZdE7lRmhyzawRvCnYUk9Rd0iRSMBEh2naFLVQWKR8rexVFaWT2mG2hvEj+WN4Lox9z9VHkgNm5i9lJ4vslZYyxkN5qvwQzrO5gXV1xcH+LVbn/RJvyuMXUtN2TsJUehZk0GsZ0nTCUuBqto2IGyyKLccuSSfbmg6w3u5BNZz2af1B3HX1OOQ2ODwRuoPGV0knpRTlUzubGZuhhS4aa6Q8PSh+QMTDvH56PU6xdQzWhM/OnhabnL8m/MXRT+L7wzvQXwy+lOzTNmebXQv4CrSitNnSptES6T3tUe0FzPB19zyNl5pZ3Tilx5saKO0VzY9mF+AplRmfnHsuVcmsyudYqc7mjp2UyyvRkNmT+nKlkZpawLhRDKrcvJBqTFctIqc6KpXvwFQxHsxqlix5VdIfTVsJXcTwTFI8FRY4S5IjFfPZ2nfMtRdZCZ217x0aHBEvegDEfc/mjjvCwKIvWY0ZczxnfpShrYoB9HGDDAhMDswNyINRlZu+kzwitN3d/HXdwixOxz4T8QiFhysGgFbpQrGjFiRHZVprJ5tbuTw5PLkzY9Mzo6NwpuVJdcS3fm8IyJ7s8ick6t44rrQKoKL7cyT5/IItrLU3DJOCaq1vXbgkTiXHLIs2HeYKkrhVsqlH85utPNg6W0/PiX9s9ujzgnrp7nhp7+41/OWP47MGj2dldv87tNq7fGf27eOzSJ51uu7n22sfjjSuvOSOjW8hSU7Nt2fjrBmfkRTJG9O8Zf9NbHiyo6jm2PL9b7lSwfCmk4WZhUWXQhp3kNQ7HOtsru6Wfni55x2pjbWP9Y4O1GT/pWoXS09kztSK9vzLYOTi1f/rN+q1Wm8MFx5nCGIRtqu7jY5Fqt7vJFsiyhOe0Y+08RZKc725kRTEHm0OL+JqTWZ3g99yqIfubq74YCksrYWft55oCin1uHavrOy5mn6ZNs03zTwvOzFDrYCcL/x2s88KkBMMK0lKhSlqsyqUstHjbs/F4884JW2Pe6MDL6q66evrUJequ5gM3x7+M/xw/EH9/Qu16qcO9w+ZsfOCxOzdwzT0Gfa/GTAjRP2MjxrlrvbX+Ge6Z3pn+K4KXhdZKax0veF4I/t3zTnCfts+yL3Vf2mEttXtq97RB3kH+mmCtY6ZD7+Ht5u8WlC9VL3UvVZe4rw1t9t7v3+l9zG91CQlNj7qECvBFXV2cPCXULiqoOyXq3MUUsoFn3hQ7xZCVYshHXVZBTndB/Sh4FAnojKeyLCp18oAzaxgUczhdz/KFwuMSrOS7gnxTsPjg/mK+LVj3WXFiVxA0sVKCp4ltQCFVXbupXOi4cQ5RVDrHv3GdM2zmFQvPHT4tjfmKD766L/4N8+9/9nPp2/JRo1dveWr9hNmlf36W5TMFXmre/VyLjAbvJplysyrW0Vur1dpqvQlpWQfROGy1zmm3qJ3UQ446eqRFQ4Pkfo5Baf1Ct1qtPiEudi41MZddd7kxFLZAkcuZz7ikuN0UvoHLTpYllDmuqqWHcw8lJEasfwlvQ9iPkBXnTG2mbaY3IS1aXW1WVoXZQfgdAfhWrUVFmRQ/2nvr+MfjR+PPblvMQs3e0n6XT1p29fQpS9dPqGUFsKNcLHSz5Dk2Z8sZF9x7z+N3bkR/e6O/BZAVH2Wwu3eSB/Okxl55q/U25xrPZvV+2xPWJ5yNYYvFxwZIp2s1tmHtNjsf0x4Lv2h7yfGO7V3HYf0npzPDnZEWg4ZIi7lSou60p9NeT5PThDS0qxbUFQCVrovBePcOd9W7JFfQy+29x0LpUdbFKzaWMyOJDebsogQt7pigwQxBY26o0038IM+DZk/0esHm7YrdG+TszrXrlMVK0xJCVNpuYrvZ7Ta2U9q5sywxpzsKhpvasPiEneb9MPdivmCs0FcdjLVz4wsqOMh1tbDWqpuFOehFI5DDyxuDTF5TVXO6LZkValZYeOIFwgNvJW/0tgAnDduttl4i2juruphvAtR+xjVonajeFQOXXLxSF6/eFQOzEhsF4lgBRim8jC7CzoC2YFzEIzAtuIyTnCWsjtSEXRiQjrBg132PxL+5ZibzvbWfebXmmLx4Up/xBfL8sWdVVTE2svS2Ox9d/SFkoTj+YvypK1YMYOddvrBv3wu53ghiAnwBj8JPjbHyrgrroEQ8kZRaZVFQtShPB6U0f4rk8/pTXKlu8rhSGXkkn9XitrOJdsMu2flA2DSW4vYzw8/8PNrOg3IPoGgt1Wezdqm2DLMMt8iWQk9pysQUKaWRKTGnKzVf8k2kTf4mv+TnMmF1RP2hwPyd0kxKjBlUKj8RO1YHUzH0GQUxTbjzBVTjq7LcjY+5DqV2EbZyeUAXWiGtS1oO1GtOcH3lrRfPvzC/b6/TKt58M/7leiV/+JKrR+U+76kcMfjDY4/LA8Xcj49Q6oUFUcqGxiZfmrk0U/I6nHM6L3Eu6qxEGLxEuYx1kbrIMdZX6itPcNf6avPGFo3FUJ3rPpxyONXb09nF37OwSwncI//gwn4lBxzNAdv1WLPtDqe9g8NZ4PIH0jo6HTDgg7l8BjwqZoAQdFeKEJLtdkeCFnZITICcvATtHE1MBGtaulj4J6pc4bR3F3DisnXkDLen6cGQ1qHInh8OcqVjDYXC4Rs6s85QQY0xG3XJzfKGylq0z0FT/3j2e5o/Sy5WzQfNHZ3k+k+icaLybRgcIb6M72dyb7eSA957combK/SWe6ZvZt70omnFM0s1vsoFVH8gue5XQIWZAhyogOUMazkCQyHVd1yXXcZ6WzILx17QLS/VuaDpnSsmM/b0XxYxvdecJ26If//Jsavqp1+/bMbUq2oKuqe1y/J3zjn79gcfvWEPs7PwQ7ccO/3JXbOqdl7vkq7604Y777h30wYw60Z4M7XQ637aFit2s/askg+kpw/rk/IR+5lZddWv5krjUmakqIxJqb4Ub6rsk5ibMzVT1q02my/N5iey2/It1lgkN/qIlRlWZgWbMST+7NzoquCmoDQneCAofRdkQfLl+9OE2kLeTWnsQBpLCwWqE4yHp2keOSB0yIwJ/c+t5P3gaUCYVxbhXmA14AZCOykNohwVy53Gg+yBZU9NWj8sM/5lZMRpNRd0iX8Js+DzjQPmLLuhebXU+f7xFf2uXdL8LToN2RbnxeJ8QqdLd5KVn0ik2Kpj1uFWaZG1wdpkfcP6nVVtb623LrRuQoIqazqpioxVLCbOIWSqg02kqZqu2CQda6aQxazcqBKymP063o9qMT3F0YnHNBLnFSePjm9KHB0rjzElfuzoICX/6PvJE23RwlHiBCVWxNunDlelRWqD2qS+oX6XODZZqG5CgorGyDAz5HxGyZZQSPlFS8y6zQNw85RkAZG2DjO9gPXcSUV4uw51QbM60jS/IypHLdFgNKef1N/SP9gvxxGRS4tGWeuLFhVtLLpHu1+/z/Go9qijoeiNor1FLioqLRqOB08XfVykFcXCGdFqxBeJh6qepejhTK4Kt9n0LKERFd2TklKQnpGRX2ADO92efG9KbHxFfQqbDeY0SjUxdzg9PzMDabMzWH0Gy0Dajjy4k9yK2EZUIBZWazWnsa5odwGyFsR6A1VAbkG0INbjtGhpwesFHxfI7oL2BYsKZCqIFJQVGAVKQajw06qkY2BuSyTmf9UhrGFQs4fm1nGSFEfhuEEt8J2uxO4Wm1fMVS0rTs1K4zZ/QFj+Ab8Qz4IW8TwuqQuYvKJp2pqymrvOuviuQshrZsGInjM6xb9sV92194yO8S+V/NV/Gj1mzOiJZ/Vb11wrTbyjU9WAFWviklRz+/iSmqtvbT6WOH1SajFmftoYC+qpgdTxlhkWpVFhGC1PP0s/9z6PqonpmqK7nJrDbof5JbF8P4npCt8ahfzWdLXZ8x0uzl+n09Eyax3sADT3ibNWcOoXE1c4ty2WW9YJ01QwCZNXqY1/mTuicuBFxRB+dcVbdbcNay+1e3Bq9+FXb4u3V/LX7+g74+o/8Lk6EjbZbeipExb82tiAr9iXlp9Sf0pTXpS+UiVvSA1ZpVrP2NSx/trgWmmdts6y1tFo3SP9Q/3Ausfxpfql9pXTc7/lFemv2nOWFxzqxZZrtastcoqQQnuAs8in6L5KPVyfPiddSndl0Qkmd8JxSRiiSY1unemZBjt0ZlBhXJ2zutSoF92iNB+cltz8vFa6e+Ty5vX/ZtH47m9vjP+0nEXWXHDBLbdccMEaKXsl05bHX/zu3/HnrjY237F586b1mzfz/q6In6esRX89sLlvi3XqnjogVfJG5UpnZWo0vZ880DkwtV/6z+lW7rclbfFD+s/pFsyf1j6a3273uF1JHy2lyOVy53s8wvi2t/XShuyvwkB6PvuFnyb0LV/DuJ/WyvaGbYGR5H02HTVufh/v9QqmdXl41k4mxY/tHHfDMAyx//ppkxcvOWf6Mgzt8Cnxj+LN8UPx92rGNO+Td25/YMP2++/i9vcE9H0y+p5CmbQh1s1bJUWdUV9VxiCpn7Ofb1CGZU57lmlJC0Rr1Vrbmc6xqbWB2vDYzPts92Ucth5y/uRzpJArnTNBsaclHFXd7dGCcDLaeYvgbeWnpAhH1XqDh3nC7RNL/6FW/T/YpvvFc00GzFRn2qalzgzMDE3LBANYiiYW7oR3xVduFj3ueskDu90z8dGLlzO5adbtVUyOH7hmyrRrr5406cb4eZL/9FHLNjIPI9Z+/IQNR2rkHXdvvKvhkdsf5lbnUiK5mxj9zbHCtSqzutgodZp6sSqXese5ZrjmeBWb1e1o75BucBgOqdoxzCE5GqVLY0W6jhkuS5qtkKwea5l1jlWxhhd6N3qlid6F3ke8b3gVr4fymSwkQJIWsU1w60Mp1TtZBiWd9ZYJfaguNCRhXIIZmN+V5QlhmEuDGwKjBjdUjBg/bqutvDskIUvM6hYzU0thm/ic7ntuv/raM08/refIUiV/7bn9Kn7s1HtL/N/oYxlmtAd97CA9G2vSUrQcS0EgJZCzzrvOt7bglg5W3Vfjk7xPOHe6Xsz6POew81C2VuQc45zqvMW+1nt/9k6H3jsnltsvf3r2lPyl3qW+JdlX5Vq75ffXauyDnMPcNVl9svXs3IL8bo6KLL6vXJGrazY1xZoVdBY4srOzc/Tc7FjJhY75vsvSLim6uMOytKs73JZ2S4cd2TtynIvYDYGVwVs7/KlDQ4kWyPLHsnKi/lhG+2h7P/sYhnwXS9bwvBvypLxYMDOaF+ZbVLEA1p3hJayshJWWsJJ2WWUQri5w5s21KXFjyFadWJn5yWeoeH4jZ/kxrDdiP8rUofw0imvW4v1kbo5XaIxpzM/ys7tm1WSNZrWBKWxm4BCzsYCkhLOypcJUp0MqDE9UmFJTaB8eZuGaVB2eAP7jRmkSdXPT+Vb+K9yOzmpM0Gxx1JHL43u3t89NxENhEY+lI3Cuk3XNrsle57w5+/nst7O1rGyHU1HCZFrq1IXb7NsDHauZ6daJeHZeVJxeZGL1J5Y4v1Dq2SJ2gMkEueenGYrImepHTsZiQ0hhE5UDisS74I+haH+XQAzlBmIoNBCr6BYN8P3GQCyvCF8o1x1oL7b2lMCYcAzrlzvMhoeNsGR2XhxoiA+/OVU3l9+hmpeIJpiReJjYU6W5+NTVCWc119gds9q91e5CfIEP3z7mrHT4HJU8uM3BzzS+3mqvFA4p4we7c83TCRjyWOwLcsXpBFcIrQ8n+AV5vv1XxsLeC845v1ueL21g/MEJC97//P23C+M/pUwcN7sskpHPnqkdd/C795pZafHIMYUZpZE0X8rgXmNvXf7k9Ss69+rT3p/TLi1j2qDBS258swGzqL3xlbRa3YBV8dVYUYTgkNmK3D1cg1y1bj2URkHZn0YBb6qPBbySjwVlq27THUHObjcFNgUaAnI9SFNADsDx3JbG+KKxndL4Lc2LYi6H3VpqKyX4fhOhJbhrWhiU8wPeMWnVvo2+R3xyvW+Rb5XvDd8Bn0o+jy/iK/MpvlB4/qakOTW4oRv0RE9xs89nNPEDjmOJ8w3PQeG37he3O5H1MxhSKV1Mv7WOwUn1CZ4GNPPgICWnoktFXop0eZO9IKNgUHDyH8+4vNJuvfJKFlby98ZHLy7OSH+/Q5cR/Tvfwl7f+9Y98WvBn+ugZUYp+bCQ1scCZ6ZMT1mjylYtpFVJVSmDpcEpX0q68GdSFLufbGk+uOTwy/PT0ogrSJdf2EkJ5/137CSrpcVAsrADFmb5bbcmsci0sY/qEptY+fn8qMR3/NREHtrjqZnnbjmDhdqPrB4wrwMLbRwz+ewta6RN8eDeqT2HXfwZa4KjgH7aYQmORz/tLD2WphaGS6M6/9L4l4V/yY3Gu9tBhYsSCfeI3qYwTbZbLDaHHX6Y5JXD1rAtmzraX7Q7MLcPxPyZkaiNVLuPQvY86mCPUg/7UrKatzdtzOkQZdmtgajCyMo0slE1v+VTWSyOgNNjXjvZFLvNapUkpiFsreT7obFgRmHU7mwv7s8pzkAg7LFV24aJawllMbsiVdqVamWYIiu7pDKYqItibkcFsQhUiMxCjuchWyEuXMXBIfvrsFLVhcTtUxEXFjo3z72VDE0QU7u4ju8RianOr40G+OZ7ahZjj8dHs4KXegQ0l+dllhUH95o/ebS/v2NHqV2Cpw7wtF7wdF1sRaH+kiKt03eyD9ge/YBTtehhJagVat2ou2UAq2V/ZBfrtnxWrHdlPfQaNkhfZz+sHdateUq+3sEWVXrY+ipDbc8pljNso5Va2xTlfNt8doXtZmWNvsu2R/nAdszmlBUdXrVfiSgdbF2UaluNYk1TQrYetqG2c233K48ru22HFKuOwdnuDfKRfHc7rCCFK+o0R0qUKTZdIUkQC1kt/LrQ3seKOkYNcSFtb8ztz43K+ZLVJ0lWVbPbzccH7IwHYwE8tueT6iNSNVWFFWGxWu2kNkrnb9O6WEFidsvUYc6Nzr1O2SnzZKmLnSd7DyQ2IRNXraceH6O5Qb6hEhriqTskQlSakHt88WOv4rnJk69EKLmDEqhMSNmjtog1S3RwGygJXc3Vbt3cufMY/+rCMKJ8MLNk2cEWxlezM598gQ2Kr2PXxu9/930pR5LjH7DcuLX5b2xg/HE+qtmwrd7BqHrYkB3e3QrDGmTEOntSojaGL51ZbNJP7LBN6mY/3Xa6YxwbJ81kM6WFXsvHyhuO75S9DsVWqtypPyFdRBaysdFYy60WjZU67hSKxO3xkO0GZSOWsUh+J7SdFe+w2rp43KYZwGksj9sBbo874i5zx9wL3Zo7HPOyJlhnkle3dKFFjlXcoOOXplCG7gjwGCvexthvWBMOWBMp8/+QtCa4CVdXPM9zEIqHn87ylINV+4vn8VPH5h8/w/d+Ttnc5H4WM96IuazBKHOTrQzUplu4Z8u3ZMUCyY0+rHaJm6sStIPNXmn3OACnWAhrqUsF69pN09WKrDSmd+2SlZbNrp9c2nl4/Fr5gvisGy7OYNv/wXbPKZWZtO/FeMnt+k9kGIm9dvUtKZ8GYHB0uo6+IqLOsRRpb+RARIpEhkXMkNA1rpRoxF44oFhikZ1SBRXxc1AuDRW8LOEjirJGJspi/DcIWbFUyZPJhmfWZ+7NlDOVcv52ZsvbdXgXUvGEsllapL5FMvWNpbKINy3KIjCKhstM3HmEuVwbsyL8OXkkJjVKkx5nF1BI+eKPCRfx4P46D3cQ6+aCV8XFXCSfWM56xvcrm1lxfA//CQD/KYT2xbRFfyz7dKK76kdLyMJT6a5Pq8Sv0v+24dPmI0eONXvIMg95rQAj8z29V3wo9fXQkSNHLveQmd7y8VynmUlSpYkt1Ci/QnOUC8kL1OiZVKu+SOPZl3QWnp0L9JUzKUN5kMYg/8WIXwh6k1RpNCP/WOAuoAswBMgHJgBnmhgF9MY7u4EtKGMiL0fQT2mW/iqdhroIWANMAm5Wx9IteLZWq6TJPB11rUQZOQjfivQN2hZajfA6PK/leQXl74+lQXhegvBN6ljD0K8jHWmEcDPS/aj/Rt5m0HzUf6FyobEf4Q4oeyCeLwUdAzrabG9QhD/l74i+8j5ey8PgzwKkrwZGAiuACeAPf78M77VH/DqE7WiXFdQBuBSibOSpkk6jBtCOqL+v2W8S/UY/WvqE9os2/TrG8Pa1BtrE+7UPeBV4o1Xb2uK6E3Ah9ZO7iPHjfXYCPaVXqQ/4Euf9Uj83fuKA5L2Lfj0BqMoU6mwhYwvaWa3uoHWIlwNVAhcSU9bTbPkgxmAHXa6toTuRTlJn4BDlSd9SWMujbuDfOJR/JjAVZT4n5GEKb4PxLWh75XMKo6x6YBbq3p3kE+cN4gMwruOQ9xifEeDr1cBM8GAdMI+3D/WXcp5j3H9iY+N/Qt69qGcwB+psL4C+J8aVLsb7c1EWE/UkxiFBATyfBZ4+DDwNPMPbkISQMxOirC0kS1uMH0BTgTDwKrCayxtQD1TyPKjfhvw2Ia+QGS6bXD64bKgvClkdxdue6IOYCyvMOXM+3p8AhIBC7UE6y0Qh8nL+TOYyy+dLsmwuW1xmklTI9LlC7l/i/eQy1YrerDbRCN4GUS9kK0nx3gaUexmncppo023yHtH3dVzekpTzhcsan498Tph0eKu+lphzpATvtxOyDllM0iQvWujrdBvKHKuthpx+Q0OV92mo/Fcaql4GeiP6txNp6I+yBzqsmIZZmqgIYzkM797ahq7j0PewWajrBuUB8GIPbRB83SNlK3uYqj5g7FOJ7VYfkBaI8C9oW7CmxDNOOVo/+2/T/08gvaM+QNMQ/lrdYxjoz418TujfsDIgkqRI3wYsAjpYitk6y7msUR9DHo3oIDBbiVEPNUbdlCaqVtIoBj7lIX2MdrrQu6tQ/ovsG7oO47VET6MceR90I+qS3sH6APDyQYe0kqMTZK6tLCVpUl7bUi4zoDeCqqAhzLtdwBPA+yb+CXwCeRwAnI6ycrh+Vvn6AB0NXGfK66IW+dxN60GvT8pnGzn9Qxv51NvKZVvK1xau38XagnmKuq5L9p/rR67juI5E3jP52pfM35a2ev8W6I6/Cz38Ko0353URUAaUoownTT3yBIzzg5ijX2lvGU/o1cYT8svGE9qtxn36ucZL2g5jPXhRpCbX1KaELuPzSTXXUs4nvi4m11E1n6aZ+uw2kRf1cz7wtol8l2H+zaLJKPevfF3l81Bej3kHfqK8xcpmOk/5hFah7W75kUS6MoqGcp2oXIIw0qHT+XO7vEo8H6n8QJcoRQhvBr2dUjSdLtGe5e8Yr4q0TxPPeJo6ntZC7kqVa+kedSuN42PF+yFVGC/zscecD1sW0QadIMOf0G3KEfS5CX18UdDbhTzxd7cbR3j/9J4UUGX0j+cB+DvqBoqY/FgjeNEkeHSLkGHwgpepvS3sDVLfRf6NdIXFRrdZCqCffqSwDl0i6tpKZ1pigu8KlwXl35gf30DGxtAy1Wf8LOT/QcOQj2AOfYP5xcHwLI1C6jd0O+bSMsGfBF3B54/8DaVxGUH/+DrtwDvXKvfSPO0BWqk1Qe72YC3Yg3H7Bn05l7ojvFp5wDiKvP1RBvG6kT6Cy7dYp2LGG3y+6E0U1GOoH3l4GxRu/6FeWK1r5JtoGXRJb8s3dLfG/bT/6GM8mKD8+qvxGsq4ArSbNJVeQiskhBmfC8qfMPdup97y/fD3p8F++JoWS6W0VB4KuduPNUOmK3hcKaFCeT8Nlg+L9WepaqNuIp8f6/hXNFypxftNNEXZRlNkA+EgcAvkEe+pjTRePQd21tkox4TUFe9Yabi2AuFSzHXkE3UcNgZyKJdRuXivFURbk+BtvqtVm29Br66EPPD28t8ftGovb2tLO802/lr7RD95uXhP5PkH9QafPgDyEjQ+QrqOHgA2Se/DDm+iBWyNsQtMrmmDAa3jygK2DBgOKMoCugO0I+jXwB5gPfAk8C+lgq5B2U2g27lfwCH9GboLFM/vBZ4CPko+aw1ez6+lt4byhbGrdVwtp0oOqQQ6veTEZyL/HRRV5mNsyoxdHPIlZOPQXFQEH7NI+gTpY/Fem7haSGuV2cg7kuSTten3gE/nVnyMte5jcjxA/f8BPmhFI5xifnXk6/PJ2vC/BsY3BSjjYXUTdRIy9BVpkm68zp6ks9le4wj0ucaRiFNY8PMOvGeOE9KXifQ24wdZ6cp53ja9bbztuJ4sjnJntkZSDpLQyynGoXyE/EDbONaDGIfGZazkl/GWen8LoykKPtUoo9GWT34Z1zxUyiHNQXwdnn9BBRwt8dFUxMHzcoC3ORzg9S4O6RPK4pBH4tlIkb8XRyu+juN8lZv4u+J9MT5JOW87PnjXozxPHvkz2MyjKdyWHpfhhGy3lo+2aUld8mt52syNzr9V5v9LwNx5GXgReOFkef9vwOWcEWQV8BBsurdgbzTAVr0bftYrdB1R8zKio88QHZsIPQQ9dewhpI1BOB/030AQaTNBsRod3YvwHDx7G3gV2KSk03zTrgwh3j/xbvN9Znl5iff5e0dg7Rztmnj/6FLgdoRfA0Yj/BzozaA/In8D3qsFXYC0xaBRxIcDkIdjf0O8F4B1/1gPYB+Adh6DGXOsFO/fAVzC7ZFWfsP/P/Q3/I//lCb2AKhO2Jxob1sf4j+myfE8CW3rayTH/2Q06Uv8gpp8gM33Mkcr3+d3fZwkxXj+bOIg8J1yrdEMm1IXdjRsWWFzc/vRpMLe3iPsSaYk9hQF5bYzqIPbztx+BeU+2Y3q62jPhXQG9/NFu5LrRivdKpXQVMBvAnqP+iLPm2jPAegeN9bXH2FbruIQSyyJfwcPMF7B2uWGzn2aPWn8CPoq4plYy6zJNS2pW3+hY0+ypv2v48p/uUYq//2aOszEzDZIpk8z0fZ5qYlsjrZr8X+Lk63d/8dr+W+s0a3X6f/beHKdT8Lai8o59BjaHfulXdrWDjhZ/GR27n8bb2t3tIpv5fid5yLe1i5JxtviF89/KXsJeyaM+ZZEm3n33wLztI8y23gvOV+TbWg7j1vmmxnXFlI/oH+Sss1UCD1SBKwE4KsaOaBYA43L+fpmOUblloeoHHGsv8YjQDVQm1j7jDS2g0j6iZtB8WsQ15VXRd5xJmpPJs9t5Zbb58I+BM9E21dhLA5SKdAT8AJbgfNbxrqU3wCL75Wx8nI/V/7M+BFl/fhbtuBvUfh587i/h7gbcTd0cbq2ldrxfQ3hfzfBf/0UevFFmqm27PEZzdp2kecshe8tv09DoeenwSeerXxqPMj39NQgSfq85DmK2FsT+3QIp4O69e/42Y/xkJLYnxurB7EO/kBjtN7Uju+BmHvxU5D3HL43Jf2T/7usYg85aNKOfH+Kr1dakVhjXMrxfeQeQK3SlToAlUrinGqCfARl3yXeXSHOZI5Sg/IQjUV5jbYtdLP1RbrZgv5Yx9IGPYM2KPPoJlsPWmfhe8gZtJqvV8l1FbyPJ8Ot9v74XmZuqz1N0ee2NoFoX1fo1Urjrtb1Jt+z9AVvRibOhpTEPvvv2jYopxvQETgIfPHr+53Gqwkq9kf5Gj+9Zc1vu09/B3VSikR9iT1ZrNmqA+U4RNsFj9u2JVkX+NL8W7ZQ0jZREntU/JxtsZI4g4sCPjNttLALetMZGK9hfM9MXUpBZTmNlLYYz7fkgc3E5Uh5Tcjsct5OJXFulw6cK/eifhK/Jvse+cSe5NviDO8aEwsgp/dx3oq9ON7GBwC+72jQSPDqi+PA3GqB8YXyAOriEOd+xvMmbldGCPkMmbKZrhymwcpmITNeLXEm6FZWA5x3cyCjXU1cyM/exPmeoIJX34Dvy2mY6CPfm3sAcgv+yHeI/cEJybyWahqtXwt5fQSysxj11lB7bR1wkIJaBezD5eh3f7y7mJZJ/6ZyDna98YmkIIyGcMhE5Qosc+ge4me//EzYPFe7GLgZ/eFnWz/wfCJv4iyXowOHtIVlSYlzwmQ4NREWaS+b+MHEfa2AfMY/gaPSftSdhfIltOtfiTbJHshqG+CdySZkIJOfASpnglcnom9b4F1OS9sC6ZzmtYWZHm4LpHPapy2Q3udX2vFb+X6rHb+Vnt8WSM//H7Tjt8rNaQuk5yi/3b7BbYH0wf9FO36Lz7ltgfTc32nH0LZA+tC27YB+wloefxo+6qPmuj8flP8byqeBzgYeRhh+rzHNjL9k5ptxHPxjtDfRD+C+NNZj41tgPTDiOHhdRlrinWQ9xrkIfw96eqIu/m78iUTdAmad8fvMtj4O+udWcd521B3/JFGfqBvtiO8iYccYtyHPTsR7mvXen2h3PAB6kVkfJfoo3rv/OAxMPwN6vJn3bdRx8LbH4fsbd1LCZmqkBC/vStTbDD/RCAEdzefLjusFegl+4nToQxtfqy0SnDVQrmuFzp1JvlZr1aVK4sx6Ldd3GlqjVFGmBhsOZdi43cB1uPAnofeFP/l3ca4+RSAX68jbiP8TZWyCHLqgN6+mQl6HOJe5kN9nMe7iNof8No3gELZGk1ire/P1wHYa1Wo90KaDFEb56fprtFI7m98vEWueXZ+B+HTYHfyMTKdLLHfQSv1dPJepButV32R60rfVrjEMtYTsSWo5RLX6K0i/mnLUMOXw+vQK4ns63ZJ1J20t6Fi3Oe5cdq5L4FgxcIZoM9oLmgKabp75rRA82Q2fXKYSceb0CZ4zcmoBzKtjVKhbYV88RsusEt2qTxS+e09lI0XV4/cFOvLzJ+1NKlGvorSk7669D76ejzE0Kd8bSe4HqBvoNuUllLWBIuJcy9wPaKHJMvh52zd0O2Qi3NauSdpRLfaNuUfQUofZH0752tmq/4K2sjcSewpb6Ux+NsbP8YTd0YYm28TP8fhZGso5m9sWll50tn451taHqEZ7nvqqfWGnD6K+ljBF9HspxO0zfRpkk9trfA8nQh3V2wlz3OgLQLKNWSTOxbi/YEBqjAsxfn8HzjL3J8YmQLDeDTvSx5jv4rlxMTDFzINnxnIz3NfElEQe/m7zh2b+h1DGdyaaSezbiDl7mIdb8Znbc0t/hSbP7m9WEnbr79P/cA+Nz2GMc1D75Rl/W8rPh3sm45ifbybAbTnjNdW0o9tSJXHef1OCGt+Y9EOTvsJljdt6bana5v6K+hv3WX7bjjXnWZKeeO+lLa1N2tcno0qrezK/RtX/cO9OnNdDTyXpL+8fmHtyLdS0y9vewzlOb4Sd9pFpx3L7fSC/+yDu5vwOuNxxaD8Y32s/tKbQkQC/0/Nr0NohXzsi/WHje/3h41Thdwx+B9oNeO8GrC/tje8t7VtT8nGgzasSMB4Dngc+Ar4FtgNNMjO+F//XjtXG98rq1hRrx2rhn/za/bqR2gbUuwH1jEF9mMn6brR3N97jdxp+B7DZSccybJks+vgDXwt/F6+hHlgLliWoZwneOYJ6jgj6A0eS70k+JvmCvn0pxivZ5mT9Zrn/t+OIMlf+Hn57XIwfOP5X/f69tqsvGn8DPuRhzKUPTL/kg8TdPZRxYpuvF+3+gl/HRT1nJsDnM/J+b+IH8PVz4B9cR5l4VkrcWfqKy5YMGeBAPSZQT1s5+MGEGU/cvzGatS+Md/VBxod8HvC7Pxzclvo1/uhTjb9BBj/U14C+hndmCR+J2178/Jnv3fA7tpNM3ZdlfRXr13ViTyaCfna0NEC2CfrnGZpGJ9h8xihTB/N7sPxOkVfbTqPlOJ0Jf3m14oBOesf4ggN1XW1it4nVCdvP+AvwnHlHkqf/qTXkTtSOA+EeiXXSwExK7scZ8xLg/0g6Tz/erqTuVWAJw9cl9G0Sxtst7Jdb0bZb4YMzWsntBbFGuGmgcgldD5vSJe7cmH6/wvce/g2aQBb4Mlq5UdwZHSWwD/n4vRpA3MlJ3FMaoeXSCGWvuF+TuPPL7/p+DHyPd7+FzTnm+N0aXga3B7ldJH8KPkKnyHfBx4XlLN8NOiYBRQb9I3z0ebBRP0K4AWiH9GzQS4H5COeDXg5MAB400/9A5fwXGbKKMAd8aeWxBJVNv1r41q8nIEdQB9Kll5HvaopK3yNtAGADBprgeZ6Ejcef9RH5yqV9qOMMssnpZrgvnr0PWBL+u9hX+N58lszT53ge/Qqqsa2jGul+0PlUo/Y2drF91E4ZTR6MqRPASMa5P8T9HcwcA7PVGAbcgfiBX9wLSJ6Tm1R9iSrVG6lc89NiNUSD4Qv01txYh8dRIfQPv389hlp9+H1ifpdY3pPY9zb3x0VYe4M6WWGf4zmZd44FlR5I/HP9bIxYO8VdegZvix5IlCnuT2OuJe1cvZ6u0++ELXknTTB1Ebe1+FqSovA7ZhdSpdgTKqI+5h0q0DjsOYPPh1HQDS17r5zyO21ctkxbkNuYD8p+fucKbVkHPpxG7cx3BwADgQUmDweh3DtanT89xqGW0//0POu/Pd9qez71W+dFyknuZignuavxi/h/eabS9u7Gye5ynCz+izOYk5yXKZ8azyj8njf0qJ7Jw8Ye4C8ywhyQZQPP3ocsZSHfVdIBzNkPsD4cpfbmnmg60n3QXz7lsJC/pYnyYJ/niT1Xvjc/p9XvHFbAdp3G7VJ5l/E813PcVhT24IXitxPJvdreLfu0vWiE0LXQqeZe7XXcTxM6yCagcT3DdRA7QDaAuJ4R+5IXIZ6V0Es8LF2C2XA9wsPxfGBCT3EdJE/EOxORdiShs4TO5LqNz0PoKzkGnI341yagg6TPQAH5z4l2SF/xs5r4jQkI32wjX5uE7pQS5Yp9SIS1xO9R+NrH761PQr7eJ7OXTPsyaWM+3zZ+MrsQeXa3RtvnLWc4H/O7/rAXXiS/Ota885v4fYi4G611Ef6K0DsYy/RW++9RJbHnHBXjdS2lQKek/8IvkGk2H9ukTw8+vUCJuyVJOjEBsU5zPn4pdCWjOlEHdJwpd5qwa7h/x32HLYmzCCXh+yV9Ob8pW4Xo2xqsg8v4PX9zvX8SZcdN3MMh7pDspvUqv8u8m/+/RuN7ka/MbNceoAl4A3j3RDS/YPpxE1r8oZ38X0mJ366lI/090iwTkP4RaUImMmgM3xfn4L8r4EB6YyvIlLgL1ZUS9wi5X9/PpNC5Yq5wPV+s3E1nyZdRtbKMBiijoA+WUmdlIugKlN0Fc53/buoGhGfTWPlK6qlcSVXAWOV2yPmVNBzjNFnpCfuC51sOf/1uGq7y+yPv0RprB1oDuhJrQU91Hd1q9nG0lEmLlTm0WLpUnLWMloab5yUXir2wyTw/fybkANxS/gUf+EU8+zfoEqAI/D2NzlK9tA7vrpPfoCLlINJLaJ1WiGcOYBDyrwQdBXoIz/4AfzaEfN/QKthSNm0E9M1dsIXuIwvKa6/9FTbbTuQtoe7qAPT/Orzzb8pV3bC7eRt+DbxNS8w2mZCGGz+jTatA/w58lGxLW4h2tAZvR9uyAd5P0W+0pW1dHIIPp5l5wQ+gK+p9A/gc+DfacibnkfruiXxqDdHGJOjE9greJcF52Bqcn63Rtk8mOK9bQ/Q1CfC+Beg3HwfB/+S4BwAeTox7e9HHgXQW75Poy+XG0eSYKz3oDNFu/hsbjL3SDn4gbxfqUa+iM/h4q7OR5yz0yyzTlKFVoq8831m8bOMj0Tb+fA/e5214Gc/RZ14vf855qZeQrA9GnuXI8wfkGUMh5ZjZ3v2gyfb/E/KNsrRbYbuNhY1p8lq88ygx0X6vyfdk2/n487ajTPUOs+060p+mKfCv1mnvIH8TbMhtSHsCeIUGav8U42SVp6CNW6hCavUbLcALZJvpXQC+f1NqxgUVc/c/BZ/j/yneE3qgNVaeDFwHmKg0aedWaQLKEOPa1nGhMy5F/3VaLOfzsPHzycrheqnFbvgdSJnGk0md1bYOyIQCWOADuVt0WWu8A33L54s5n1uNhRgHdRN1grxs4NBupw7wz65RP6VrpHK6G1gDDAUiwHSgs8Rt2XL4pwn0ATKAPKATEADszqlU4yrna4Cxyz1ZUL5HC6/A2AGsP5kN3NbWS9qAbfOxJ42/wlacAfoF6OLfuuvyW/G2d2na3ok5Wbt+xSY/8V7TEOMV5V7jr0ov2KZ3Ga/qO+GXfkfleg5ogCrsH8X3Y50tAU+OYV08F7iQ07btPJktrv6X/UZ9PwqbYru4y1KiPEw+fmagpiZ+F4W0WbZp1E+5BDpvLGVY8imi7aOQNp9u0c6lFfrPpGj7jKMi7yV0veUDiug3U8iq0hp9FOwUfv6QOOMQdxshZ/yOSpDfi8E6t1IJwzb2YT1+n0ZhPheq3Vt+h6XA5tig3gYbmt8t4PsRjAaKM/p9wp7jv232Y20+Xb+JvrWfZmyxvElkP526Q8768d+EtGAvSWwz7OXNVCPimyksjaAeoEWt0gaYtMikyfQLBD1IUwG/iRR20HhT6kTXIdyX3Qq//WkaAoxRngNvD6N8QDmHZA51Mmy834FyHnjP0QNj2Cp8Un+xDU52B7+tX9XWT2t7h75tXK6kkEBynpxLpRyQoXamT93O3I+CTy3OWR4lcV4qznJbhyHa/NyOU7GXlQucaeLGNkD5/HzIiAKdk/Y9cd++1e+l+G+HKOHzd0j+Pki5DOvgycD5g/xyAfRgGfnY5dQJZVzC9zjUL7BG/Bn4gaYgPF6E38G8uJw28bB+Ot0inq1EXZtpk76MNmklNF3dgjylVAXZXyze+4JWaNl492fEP4fs3kfzRVm30QXaKzRcK6A14jlP4/nnoMzFifxKb5T5NdbaMGzFMaC30ngpcf/kYvZX4zqJGc9IU2maVGZsUTKojx7FnPoc82cqyqmDr/o18D2NVx5Hmluc34hnPI/Uk1brFXj+PuI8H9KU62F/8/DHdDniK6Wexn3K18YDSh74jOdygIKijhvpAtgX/B1e30q9FPQzxH+i8fIqlMvjmKfKURqv3Q1fsVrsee6WcynbotB5HOjfcOvrtLI1HGHxG1ufhZIfY0jbecDG0rLknkjbu4O/2Jt4iCrZPqy55rqB8l5TxL+dgD7tMTbYNxhHrLcZP2tZ/F9tAUx/Tp8O3dwd9kU2+jsWGAI9VUFB2DZl2lp+v1B8zvsfYMt/B6b8NqQFCciN4Pxd6E09cOw4tKtbYS+RFXPKDn/f0YPIaUvAdQGR5zWiFKzTXvhqqQv+c6StJPIvIwo8TxTE+h5uIkoHMuGDtgPa92oF9CXrbLi10Bs50Pq5aEse/MR8zO0itLvDIqLiGUQlTybQ6cYEyiL/Q5z3H2Dz/xadbadwCqdwCqdwCqdwCqdwCqdwCqdwCqdwCqdwCqdwCqdwCqdwCqdwCqdwCqfw/7V3frFNXXccP3+CrxPi2AkhuIRwbjB2IK4bY0JNB8L3pgnVak0YSCu7f1RDi9RqUrEUu2z9k6SdkAoImm7dtK5aY6jI0FKam3tX6jRBpGWVqk0dUadpdNJUP7CnUdGHaW9T9j3HBjqNl2oPe7k3+Z7v8Tm/z/mde87JdfySuHLlypUrV65cuXLlypUrV65cuXLlypUrV65cuXLlypUrV65cuXL1fxYlJHCSfU52kjeIhzASIH3yr+FpafYxWUGY2UyG+Yz8YttIFxH8PX4esYKfdzxdYtz08XfJDAQQpQ6VIU4M/q6j+RJGBd7WrtzuiCbmlhdR+c5W1R57IzG+wKfJE2Qrmqfth2TztGMMJpRv3VHzvi3KbW+tW2tPCHMtsD6IEX+9tgd6DZqELkEeTGiafAktQ5yf42fs3QIjnMVAfrOdn8WtGyivQMsQx+zP4l7Okhv1lgbM6h2nsVmmf0dRnfwdUH6UAWgcmoGuQCvIYZST0DLEUTuDvjOE8TP8tB0QAbOJv03GIMZ/QfyUEoHRf+4E1Nq86fhXJQwzwH9KMhAjFv8eWYQYhn0d2OuEITxtx7aoJUw7TS2JAOJPYNInMJETSFlGSdVrA5LxJ5xVHXL4H9n+VsW9YMf7axUnEExksAo/IJQf4s+SELZ0FL4e/iRcbvVB/hTxqXkajj+QGEe+FMJTfDXZjG6Td5AEfJCvJZ0qrGS31PKU7E29Cdzx/TyoQvzcR/rhXq7ZCaHPc0Mt/qtO40o5v1ftwOrERX6Ua6QdUeOIWiP8F3kTdrZJ3cmw0+hLTJjNfBi3OYxlEZgjxSo/qwZ61sZAZisf4utIB/q+z7vIavhuvl75r/hpshv+SyeyTizO858o6sdyUKTfVTtauxxfS2LRbOS70GvxU9iAUyr5hBPZniBmhG8icYhhjcdQG1OH/jhqx7Frx7FTx7FTxzGp4/L/W/Jj6DmGmD7+PCnwI2QCmkRdHqvVNhZ0TlU2bkrM8bt4EAsTmMdSUrSudRpb5MyCdtsqFRZ0mlsSqYt8BOd8BGMavOisCSYOz/NedSt3O8FOCRRsHNeLfE1tawB2yC25yNdhIeTCdPH19mphmQKv5UEWhLLfsSW5SOyP7E9yu9kVvJb++7p/Vvc/1Hx5kS3VfijY59Kr5jr2Nwz2BPsrmUSNsXl2mcQB/IVV5CzYF2yOpOBX8fop+Bx8K/xDu/tTUWEVB4a5v2X7OuTNsst2tK9eEeF6ZU1nvdLWkTDD7GP2EVmHIf4M3wj/iC2SDfBL8CB8kRXJp/D38dTaAf9N3X/LFuQRZx+wC2Q73LFb5BQsW5M2Y3ukvWeT2qtMn1hg77Fpshah5+3IWrSecyIbhX8e41F2lhXtLtFmNrHTNEv/gaAyuSqdtLEzdlIOMmEv6GKOTbAJI5g0wkbMmOLxcDwWn+J6WI/pSX1KNwPsFB4gkww/v+wEyiTRGU4PZEAT7JjdkLTMf+Ge5H0xMo6yrGp5lAVVIygDt3q/VrUUO0r2QAxjjEJj0Dj0MmlA+Tz0AvQi9JJqKUIl6AieJgUQBRAFEAVFFEAUQBRAFBRRUNlLkCTyIPIg8iDyisiDyIPIg8grQs43DyKviAyIDIgMiIwiMiAyIDIgMorIgMiAyCjCAGGAMEAYijBAGCAMEIYiDBAGCEMRcRBxEHEQcUXEQcRBxEHEFREHEQcRV4QOQgehg9AVoYPQQeggdEXoIHQQuiICIAIgAiACigiACIAIgAgoIqD2pwRJogqiCqIKoqqIKogqiCqIqiKqIKogquzILF8yPwGyBGQJyJJCloAsAVkCsqSQJSBLQJbqt15Ui8FwbEahMWgckuwi2EWwi2AXFbuojlcJkqwFwgJhgbAUYYGwQFggLEVYICwQliLKIMogyiDKiiiDKIMogygroqwObgmSxLc/lN96a9jLNOvFey0bp5uVj5HrykfJVeUvkVnlL5Ip5S+QV5Q/T5LKj5CIcoynvEiEl9oi6Tc78AjYAz0BHYYmIflL0iVIU7Ur0JfQMttmbGjwa3u0SW1Gu6StmNGqGvN79ngmPTOeS54VM56qh+lmJ/Op5ygeLeQ1VY6hvAHhTQRlStVSrB95+/Gc3YavftZvtH6l3+ilV3rppV4600tf66VmI3uANqgnnU6SDBOnWaM5sktchZKRnl14Mp26cH2NsCP3igpdqNlmIwq/Ds1CU9ArUBJKQDEoDAnV1ov4rLGhPuQC1AN1Q7pMQTo6CCFtrV5jjvnolPOJjzTKPD2bwM3bPXFYxe7ZA/vA7jkozEZ6gfTI34ro+9i5afiMLa6h+3zN3rXFPOycLfphj9s998AetXs+E6aPPkREg0SH674f9y19ny0eRtheW2yGRe2eiIzuRaIwejfTLLkGD9epjbVMIVvsgG2wxX0y2kt65MZTD4mp6a2ApHMHE7oxR7MN1FgpvhI/EdeB/x0Li+PxhV5pgF0JV+jDRpNYiL2NYFPYZpOMx/vDbN0t6e+LqfAx8RbGouEL4k1xjzgVq3jRfBLzPqZS2OIVvcKmjVViXMRFMXZNjIgHxQGxTzweRrstHhMLcpokR7Ns+oLIYMDv4i7CtnggXFFT3C1+KAzRI+7TF+T6ku21cZOxBbkCJFHLfjfWtzdckWf8oWSFthq92tfahPaoNqDt0ELaBm291qW1e9u8AW+Lt9nb5PV6Pd4GL/MSb3tluWpECY5tuycgzSP/ChxpUPUAk6X6bwx4q6JeRh4k1iqeZun9AzRtLT5J0gd165/7QxXatPcRa0VogFptaZIeHrC2R9MVbXmflYymLS3zaHaW0lM5tFrs1Qolw9kKXZZNRzuttvvRSY6e7JwjlN519GQuR4Idz6WCqbZdrfftHrxDka+X0dtX8JvVLutn6f1Z69ddOSshK8tdubT18n79sewc8zPf0OAca5GWy841FJh/aJ9sbygM5hB2TYXhNLcgjPRIQ5h3gOgyDM+TARmGParFRYAjrlsa4pp8JKLiIk0+FddAZdzsVX1ocFbXVUyYkKsq5mqYfCMGJwbs4GwkoqJCOs3KKJoN6Wpim9VAQiAkJlQIxe91aiBBVTKr73ZIuB6y7VbINpWL09sxohbTvulmTPsmxET/x+vQQJQ6W0qjl4cOhYbyoaFDUN468dzTQWv8oK7PjpZkh27xSP7gk09LP3DIKoUODVqjoUF9dsvlO3Rflt1bQoOz5PLQcHb2snFo0N5ibBkKHRjMOamdWfM/ch27lSu78w6D7ZSDZWWulHmHblN2p2QuU+YyZa6UkVK5hp6R5z6TnfWSgdz9j9XcYSubcIbznd25gY5AYZc80HM7uoOjnR82EHqOrIzmrObQgOWDZFfMjJmyCz9nsqsFzf56V3B0R3fnh/RcvSuA5tbQALm5tEQGpa1te9NW9/5HsvKoWMaBO+/ZiLxUd5AMPTOIb7wuKuHrm5Fk5I5X8U5XqVQakUUpOkJI2urdn7bu3YuZaBpS5QdzaLvnZhvnqm22sXGosryIzigmQYsynaxFaRQraDThU5fGyp6yxuRHhaKztitx+CLewccgfI5jR+w+9fGZHXE2hOXnl6LTt63m+Lgq3V7bnUAGJwlUerjmRmsMlYnwRGwiWQ6XY+WkB60XptAopuRbqd03xUkxOnJzIVAt5rDYmJbMd9pe16USl2UlGs1FR6har+h/XbTutxd2pD7qiBq+GK1vSK19pD4IdqKWvXQTK9Uh1VlSUG2Q2qtbxe2rWJJDyfXEU/rfFIDNlAplbmRzdHJlYW0KZW5kb2JqCjc1IDAgb2JqCjw8Ci9OYW1lL0xDQ0pWRytBcmlhbE1UCi9UeXBlL0ZvbnQKL1N1YnR5cGUvVHlwZTAKL0Jhc2VGb250L0xDQ0pWRytBcmlhbE1UCi9FbmNvZGluZy9JZGVudGl0eS1ICi9Ub1VuaWNvZGUgNzYgMCBSCi9EZXNjZW5kYW50Rm9udHNbNzcgMCBSXQo+PgplbmRvYmoKNzYgMCBvYmoKPDwKL0xlbmd0aCAxNzM1Cj4+CnN0cmVhbQovQ0lESW5pdCAvUHJvY1NldCBmaW5kcmVzb3VyY2UgYmVnaW4KMTIgZGljdCBiZWdpbgpiZWdpbmNtYXANCi9DSURTeXN0ZW1JbmZvIDw8IC9SZWdpc3RyeSAoQWRvYmUpL09yZGVyaW5nIChVQ1MpL1N1cHBsZW1lbnQgMD4+IGRlZgovQ01hcE5hbWUgL0Fkb2JlLUlkZW50aXR5LVVDUyBkZWYKL0NNYXBUeXBlIDIgZGVmCjEgYmVnaW5jb2Rlc3BhY2VyYW5nZQ0KPDAwMDM+PDAwNzk+DQplbmRjb2Rlc3BhY2VyYW5nZQ0KNzQgYmVnaW5iZnJhbmdlDQo8MDAwMz48MDAwMz48MDAyMD4KPDAwMEU+PDAwMEU+PDAwMkI+CjwwMDBGPjwwMDBGPjwwMDJDPgo8MDAxMD48MDAxMD48MDAyRD4KPDAwMTE+PDAwMTE+PDAwMkU+CjwwMDEyPjwwMDEyPjwwMDJGPgo8MDAxMz48MDAxMz48MDAzMD4KPDAwMTQ+PDAwMTQ+PDAwMzE+CjwwMDE1PjwwMDE1PjwwMDMyPgo8MDAxNj48MDAxNj48MDAzMz4KPDAwMTc+PDAwMTc+PDAwMzQ+CjwwMDE4PjwwMDE4PjwwMDM1Pgo8MDAxOT48MDAxOT48MDAzNj4KPDAwMUE+PDAwMUE+PDAwMzc+CjwwMDFCPjwwMDFCPjwwMDM4Pgo8MDAxQz48MDAxQz48MDAzOT4KPDAwMUQ+PDAwMUQ+PDAwM0E+CjwwMDIwPjwwMDIwPjwwMDNEPgo8MDAyND48MDAyND48MDA0MT4KPDAwMjU+PDAwMjU+PDAwNDI+CjwwMDI2PjwwMDI2PjwwMDQzPgo8MDAyNz48MDAyNz48MDA0ND4KPDAwMjg+PDAwMjg+PDAwNDU+CjwwMDI5PjwwMDI5PjwwMDQ2Pgo8MDAyQT48MDAyQT48MDA0Nz4KPDAwMkI+PDAwMkI+PDAwNDg+CjwwMDJDPjwwMDJDPjwwMDQ5Pgo8MDAyRD48MDAyRD48MDA0QT4KPDAwMkU+PDAwMkU+PDAwNEI+CjwwMDJGPjwwMDJGPjwwMDRDPgo8MDAzMD48MDAzMD48MDA0RD4KPDAwMzE+PDAwMzE+PDAwNEU+CjwwMDMyPjwwMDMyPjwwMDRGPgo8MDAzMz48MDAzMz48MDA1MD4KPDAwMzQ+PDAwMzQ+PDAwNTE+CjwwMDM1PjwwMDM1PjwwMDUyPgo8MDAzNj48MDAzNj48MDA1Mz4KPDAwMzc+PDAwMzc+PDAwNTQ+CjwwMDM4PjwwMDM4PjwwMDU1Pgo8MDAzOT48MDAzOT48MDA1Nj4KPDAwM0E+PDAwM0E+PDAwNTc+CjwwMDNCPjwwMDNCPjwwMDU4Pgo8MDAzQz48MDAzQz48MDA1OT4KPDAwM0Q+PDAwM0Q+PDAwNUE+CjwwMDQ0PjwwMDQ0PjwwMDYxPgo8MDA0NT48MDA0NT48MDA2Mj4KPDAwNDY+PDAwNDY+PDAwNjM+CjwwMDQ3PjwwMDQ3PjwwMDY0Pgo8MDA0OD48MDA0OD48MDA2NT4KPDAwNDk+PDAwNDk+PDAwNjY+CjwwMDRBPjwwMDRBPjwwMDY3Pgo8MDA0Qj48MDA0Qj48MDA2OD4KPDAwNEM+PDAwNEM+PDAwNjk+CjwwMDREPjwwMDREPjwwMDZBPgo8MDA0RT48MDA0RT48MDA2Qj4KPDAwNEY+PDAwNEY+PDAwNkM+CjwwMDUwPjwwMDUwPjwwMDZEPgo8MDA1MT48MDA1MT48MDA2RT4KPDAwNTI+PDAwNTI+PDAwNkY+CjwwMDUzPjwwMDUzPjwwMDcwPgo8MDA1ND48MDA1ND48MDA3MT4KPDAwNTU+PDAwNTU+PDAwNzI+CjwwMDU2PjwwMDU2PjwwMDczPgo8MDA1Nz48MDA1Nz48MDA3ND4KPDAwNTg+PDAwNTg+PDAwNzU+CjwwMDU5PjwwMDU5PjwwMDc2Pgo8MDA1QT48MDA1QT48MDA3Nz4KPDAwNUI+PDAwNUI+PDAwNzg+CjwwMDVDPjwwMDVDPjwwMDc5Pgo8MDA1RD48MDA1RD48MDA3QT4KPDAwNUY+PDAwNUY+PDAwN0M+CjwwMDY5PjwwMDY5PjwwMEUxPgo8MDA3MD48MDA3MD48MDBFOT4KPDAwNzk+PDAwNzk+PDAwRjM+CmVuZGJmcmFuZ2UKZW5kY21hcApDTWFwTmFtZSBjdXJyZW50ZGljdCAvQ01hcCBkZWZpbmVyZXNvdXJjZSBwb3AKZW5kIGVuZA0KZW5kc3RyZWFtCmVuZG9iago3NyAwIG9iago8PAovV1szWzI3N10xNFs1ODMgMjc3IDMzMyAyNzcgMjc3IDU1NiA1NTYgNTU2IDU1NiA1NTYgNTU2IDU1NiA1NTYgNTU2IDU1NiAyNzddMzJbNTgzXTM2WzY2NiA2NjYgNzIyIDcyMiA2NjYgNjEwIDc3NyA3MjIgMjc3IDUwMCA2NjYgNTU2IDgzMyA3MjIgNzc3IDY2NiA3NzcgNzIyIDY2NiA2MTAgNzIyIDY2NiA5NDMgNjY2IDY2NiA2MTBdNjhbNTU2IDU1NiA1MDAgNTU2IDU1NiAyNzcgNTU2IDU1NiAyMjIgMjIyIDUwMCAyMjIgODMzIDU1NiA1NTYgNTU2IDU1NiAzMzMgNTAwIDI3NyA1NTYgNTAwIDcyMiA1MDAgNTAwIDUwMF05NVsyNTldMTA1WzU1Nl0xMTJbNTU2XTEyMVs1NTZdXQovRm9udERlc2NyaXB0b3IgNzggMCBSCi9UeXBlL0ZvbnQKL1N1YnR5cGUvQ0lERm9udFR5cGUyCi9CYXNlRm9udC9MQ0NKVkcrQXJpYWxNVAovQ0lEVG9HSURNYXAvSWRlbnRpdHkKL0NJRFN5c3RlbUluZm8KPDwKL09yZGVyaW5nKElkZW50aXR5KQovU3VwcGxlbWVudCAwCi9SZWdpc3RyeShBZG9iZSkKPj4KL0RXIDEwMDAKPj4KZW5kb2JqCjc4IDAgb2JqCjw8Ci9TdGVtViA4MAovQXZnV2lkdGggMjc3Ci9DYXBIZWlnaHQgNzE2Ci9EZXNjZW50IC0yMTAKL0xlYWRpbmcgMTA4OAovSXRhbGljQW5nbGUgMAovU3RlbUggMAovRm9udE5hbWUvTENDSlZHK0FyaWFsTVQKL0ZvbnRGaWxlMiA3OSAwIFIKL01heFdpZHRoIDAKL0FzY2VudCA3MjgKL1R5cGUvRm9udERlc2NyaXB0b3IKL01pc3NpbmdXaWR0aCAyNzcKL1hIZWlnaHQgMAovRm9udEJCb3hbLTY2NCAtMjExIDIwMDAgOTM5XQovRmxhZ3MgMzIKPj4KZW5kb2JqCjc5IDAgb2JqCjw8Ci9GaWx0ZXIvRmxhdGVEZWNvZGUKL0xlbmd0aCAzNjE5OQo+PgpzdHJlYW0KeF6kvAt4FNXZAHzOmevuzOzO3q/Z7GaTzWWBQBIuC9EsclFE5B4SZCXIVUAloNZrjTfAiIq2WrVWsd5QS11IgAC2IqVabSl+1Wq19fJZVPQT5bOUKpLd/z1ndjab2v5f/+fPZmbeOXNm5sx73vt7zkEYIWRBXYhD+uIrL49ue+H9OxFCDyEkXrpszfJLxjzhTSIkqQgp2eWrr17mdv9aQsj5PEI/UlcsXbTk4yXNExF6+jdwz6gVUOBsDLQi9AycosoVl1x+Va/2mBPOKxE6q2n1ZYsXWbb0jkXo8zY4H3PJoqvWeG+2PIfwsM1QP7pm7dI1j+44+hmcZxFS64W9KABbUHgKBfgE8iOU/wS2o/SYuzh/lF6nR/IZ3N1X2BDairbhi9E29AI6gI/DXc+hPagX/Qb50ET4ruvQD9EGJKL5UHIbmgU/Acp/iAP5XlSPHgU8PIoOQd156PtoL/Jif/5TdAO6lXsd7roVaagCjUcz0GXoDnxe/gq0AL3P34xGo/PQpWgN7sq35e/M35N/HD2B9nC/yfcjBQXRYvgdyn8h/Cn/FzQU7rgXPYDex/dYdqI0vKULav4ErUUPchke55fnT0ELYuh70AYeTUOH8H6ShKcvRZ9gP76OmwBPeSyfzR+EWmGUQSvQg2gvHonPJjFhQX5a/hDywjuugqc+gHagXfDrQ79A72BVOJ5/PH8cBdAQNAW+pxf9Hu/ncv035loAYwJgqRal4Mpl6JfoZfQajuMXyWWCKjQIaeGa/BvIjUagudDap+DOj/E/yPfhdwP3Ej85fxayAV7upthGv0b/jYO4Hk/HraSWXEYe5tYiGd44An5L0MWA7/vh6e/hJN5FVHKYe4x/lv9WLMt9kLdBjyTQj9FP0ItYgy+N4nX4Jvwm/iuZQBaSH5MPuR/yT/N/kBbBV1+ILkF3oGfRP7ATj8Ez8QV4Bb4Ob8B34wfwIfwaPkrGkzlkFfmSW8F1cr/gz4LfbH4df7OwXrhdPJpryx3M/VfuH/mG/Ho0E+jhRmj9vehh+LI96DB6G37vow+xgBVsg18Ux/BcfC38vo/vwD/FW/HTuBfe8hr+EH+Kv8J/x98SBD+RhEiMVMAvTtaS75EfkofIYfi9Rj4n33A+roJLciO5Zq6duwxatYHbDL+d3H/zQf4wnwc8Nwj3CY8IW4VnhQPCcVGVbpKR/LvTj/XX9b+XQ7mNuftyO3K9+f9GHujDIGChHDVD6xfBbyX0931Acc+h17EKuAviOnwmPg8wsxCvxJ34KsDkLfhB/ARr+8/x84Clt/CX0GaNhFmbh5GR5CwyHX4XkqWkk2wm95Be8iY5xUmcwtk5D1fHnc1luKXc5dzV3H1clvsd9y73IXeSOw2/PG/ly/kKPsEn+bP5hfwV/MP8J/wnwgLht8JHolW8RFwv9on/K42SzpRmSDOljHSXtEt6Q+4A6vwV2ol2o5I//AF3IzeJ24nuJI18gPye/B7oeSFawk0jQKlkK95Irse9pFK4ShxHxuHz0XE+Abh+iTxCTpJx3DQ8Fc9GK8kI42mim6eiqJn/FTrGPw/f9nt48lWiir9PvhRVtAMjkoJ3/pobzie536J3uPexxD+K/sxbsQ8fI09xM4AKfsGfKbShGPcQ+jnXia9HO8kkhKzfypuAjs/Hz4BcmIMb8NdcHnHkfKCi0dxf0c1oFfkTOgZ8vBH9CC/hl6M7USO+Dn2CngSuqBUuFetED36FXMx3ExfuRYR/Gr4uhSsxJ7jRLTjDPSh+Sd5GV6DDvBW9x/0MWn+Y/Jybxh8XZuEVwAHXo/WoM38julpo4/+AlyMOt6Iq/gOQbtdxDXwMjjeAVFkAMm0XcPdekAPjuWlQ4gfKOQ/oYi5IiAfhdz/ICR4o6GLg8XkgxX6PesU5pA8tF2wYpA5C/G9zs9D8/JPogfxydGn+HjQU5MGG/HXwxK3oI3QX2opvzV2L1qAIcM57+DxhMjksTM4PJd3kbTKb3De4fwHbVdiPPoPfz+HkTGEf6ubfQrNRS35T/o9A3TUgYR9AF6Fz0RH4yi/gDedw+1Fj7nyyPT+ZWwPf+z6amX8qX46taEV+NZqOnkdPSAJaJCWhj7P4D/C916KlZFb+cm5p7mLAw12AhTRg6wqQP7fxnfzN/DdoE/D8fSBvtgDfPAOcQ3kfpS+49fJ1azvXXHbpJatXrbx4xfJlSy/KtM1rnTtn+vnj0y1nntE8bmxqzOiRTY0NI4bXDxs6JFlXW1OdqKqMV8Si5ZGycCgY8Pu8HrfL6dDtNk1VrBZZEgWeIxgNmRSf3BHNJjqyfCJ+zjlD6Xl8ERQsKinoyEahaPLgOtloB6sWHVwzDTWX/VPNtFEzXayJ9Wgzah46JDopHs0emhiP9uH5M9sAvmNivD2aPcbgaQzezGAN4FgMbohO8q+YGM3ijuik7OQrV3RP6pgIj9uuWCfEJyy1Dh2CtlsVABWAsr74mu3YdyZmAPFNGrudIFmDRmWD8YmTsoH4RNqCLFc1adGS7IyZbZMmhmKx9qFDsnjC4vhFWRQ/K2tPsipoAntNVpyQldhrohfTr0G3R7cP2d+9qU9HF3Uk1SXxJYsWtGW5Re30HY4kvHdi1nfNEf/AKTzcOaFtQ+nVENc9yX9xlJ52d2+IZrfMbCu9GqP79nZ4BtxLqiZ3dE+GV28CJE6dHYW3kVvb27L4VnhllH4J/Srj+5bGJ9GSjpXRrCV+VnxF98oO6JpgdxbNujq2IxhM78l/gIKTot1z2uKxbEso3r5oYni7G3XPuronkI4GBl8ZOmS77jAQu91mLwCqVgosLV5jEKtOoamzipjFtEXxKUAQ2ejiKLSkLQ7fNIbulo5B3YvHQDX4a8dwV3YJ9MjFWcuEjm59LC2n92eFKj0e7f47AgqIH/t8cMmiQolYpf8dUZDSSZHU4LoJZ5PJbF0dJRFpAvQptPFMdj5y6JAr+0g8vkaPwgHQh2YAbhe1j60H9MditINv70uji+Ak2zWzzTiPootCO1C6PtmeJR30yn7zimcuvdJlXine3hEHSu5lJq4nKyeK/3bd65q0YmwWe/9fLi81rk+dHZ86c35bdFJ3RwG3U+cMOjOujyleK0BZ14Q2LkQKEAlx7CoQ5YJiZXrSpmb5KvgXGVEv6ZNkoEpWgqOTs3rHOca+3RqL/Yc39eWP07vYYeC2QjOzY5ODz8cNOh/UPLWbgwaDep06Z353t3XQNSA144VTCgegeDSnLRadkEVzgTOr4L8vv38M3dpD2TSgbAKtAPRnFBVOB1UMFeB2+KPUOXTIZBB03d2T49HJ3R3di/ryXRfFo3q8ew85QA50r5nUYRJOX37v7aHs5E3tgKsVeOzQIXF6pbt7yXbEVcFr0qHtmAGjJ9zenp2ebI9nL0rGY/G2pfAt28ciNTanYwJABJ21PY43ztyexhtnz2/bo4NXsnFO2w6CyYSOs9q3V8K1tj1RUBWslNBSWkhPovQETcWAmh1EZvVDe9IIdbGrPCtg54v7MGJlslmG0eI+YpTpxosS7EVpMCwX9/HGlbRZm4cy2SjrMmrXFGrLcEWnV/Yi0DiIXTT+tsPJnLa0dXR6bHpc+kzSQgAjtGgHlOyFuuMw6jkTt+DQdnjmLFbch7u2j0uH9rAnzSrU7IKatKyrWAYtp9VKHgTvMz587sAXzJ3f1nMmguezPdQ4i/5RSQuNKOUhJpgonc9Ltqmke+psoEB60TomZC25HKU3ZnE8uzB+VYx+XbY1fnUMCuPZKEhrqLQdnR1u7+6Owi8OWFnc2mbs6SU8JAxPas92XWTWDYWBJgZOVbiV0VVPmMqQ4tuuNd+2Ft5GgW7zddnF//Jt0PosvoDu2T9r/vZRKG68H7S08dLuBd3zgR5j2TL64kI74NQWbmdPgJbcz1qCmXJaDDbBMspLUSrkQEzGz91Ozk+yI2bH7nPjk5ZADbqB0h0JnRWLLmmnteKUaSjh/9tKuKQSVSTs4d36OPMMF84M9u3OLh98uqJ4OpluYKNUDTPEBHwLY9lYdmUou7o9WayyiH5zN/D2WMrgY9nNZ9OtA9TO2dmuxYugiaBvpiyOQ8G5UBBtu8jAIFXU3dRyWrwIbqNYLrwpe2ly0CNBJmAQUfAg+jnZrhnRjvZoB8gQPBOQHYpmBThGl4H5FF9E5cYM43tmgPCHw6Lu2XAvot0Wykogz5YtWhqnwjVL6d3APm0jD61Ds9uyKNTdHQcagiZWTYbK8PhEVkxMoQf4X5OML1pKLbtl1LBbapgc0FyGHfq00KR4rB2qkCqGS0AcMNpFdLe4m9qNmY4kYMLR7eyOprqB4TMgq/jE4tYOkGtRPTo5yrp6UQjOAAlT6Fk7PMioaKmiFeF+9p/IXpLcnpGqBkrY/2VJo7LMnsqMiOwMs4rE/gHoTGaJbwxcpB+PZ81negE6iiJPqJoC6E0DVYXo3cBFcwpqw7h/Cr01ZHaYcRuUtJsKAOh9exXeOKNUEi7IOqfOuiAEiB3KhBwS4Ic4JKGzegk+Ikp95IG0Cwn8EQ5ZJf4IRgFZFI4Q7nlwCi34ATwM+ZP6yeb+5vP1E83T+ptRC8D6adiNGB5zxBxVsMMgZE9Huf2n0wL6FkX5/eC2gO90jB/L70IKas/emmxLl6NLLeQbmbtUkETLpVbe+o2AL20BJ5qQgDpvvj8JL8hMO9F8rFk/0tyM6k/AK06MGB7aTZtslTjSxzVuX80hf32ysaGhsb5++Ij2KkdsZMzR6Ih5Yg6Cc534rmfwXbnOY/ierfS4NXcpbckzuffwzegQsqIltCU7rfD5z4p9eEY6gblmQrAVNyMr4eAEiWOksdPBg74M/MEt8OYtyqP3AwJOZE4c0aFl8Pl0rx/T+49hhzMF7dspiZjqEn9L8FD9IWhU48hGj1uUqkeNGr3r0Ix5DalR3KFDnbcnpgUWXQCtGY/7yEpyCfTBGQwvgTVkDUem4WnQkDgiQWENVArwa+6gGDmS0T9G9dOOjRiOOnGG2nMYEBCkr3GNjHnGk1rct3Mn3LAXPnQDfCOHRrOn+gn9pGbjQ55D/Baos4Vn33IykzkGnwFN7yk2vNDsvYcOHaIYQ/lPSEp4HZ7GMLYHcfn3drhTpC//XjrqTv2Iw4R7hHuOI9yVCLvhDiAtoB/uKCJHcR9+eicwV8818K5m/cQxHd7W3NK8QRiWzFyvHxwxHGeSyVAPUBd8S0sLvNqDGzF+enOuLSB8fsoNtDs3/wnvEPYjHZXhHG3BdmIo5GCEF9wRTfNZ+vJHe+12MpcC6YCmAeRAKi1BXlWFvUrLUH0ymTwEu0Pwxeybt4vffdIJeJJIn/Rxr6Yx4It0QFFE+kidliBdVemelhUfOfDM9Pm8uIFsVDbaX7EJFknxk0mu8zznBiaE5rgWeBYEZoVWSauUxa7VnlWBjtDV5Hvilco19g3i/dJ9+iv+d8ib4pvKn+3BYpPG6/kTSEUqdE8r8uW/Ah5SCvDXSEMaTqcdrb51lnQs3jTcgpFFtxDLeCvcZFa05I8aFXe3WjaXO1RV7cPp3laHTVEMQNY0AHpaHesQ2JBpFZ4URVRsmFWRXKiKjKq7WtHmyMu3U/qBT88kj8GegplOBhZQgTOdKAPaP5ue0dYrRgN6GAxrMPaUX4JT54XNCZsdtjH0D8MGsiu0XXP3cfW9qzWNDwKwYzUvAGUkW5KUzHXnqMYGr9fp0YkYr6hOuHRvY8Moh56IV0ji3FWvb7lyx+VnrXz90TeuvnvP09dd9/TT37/u3Ax5HfP4jJ8t7Mnl38nlcr/adv9u/JPcj748jlfglV9cvB5o/H2w074FGrNiG6WwHmvxy03AamILmYDVwEURKelYK5fWHE2r+BvIXeQBmf8Zjy1IFAhnEbBK8KtWhl0r7SeEo/DWvvwHvboOhNmX/yztYOQaZuRqY+QK2EoHKDGaFMeoL6gKac3eJNBn2eizBBwV0gIRAspe3IxvRYao6DR6hP3BiSGtW3wp7EjRnkGZJDYuhtLQNouYFgQLVi0U1y3OFEgVEGiA8VjcIYrSSBBfjeTb3vGvz/nRh/WX89eeeV35z89+dSF8QzNwtwSYi5BqxpsGR1kcuuZ3ucS5GmUoh4MBX6Qtug5QxC1EKKP6aIVIhF6NhG1wJaLSL4z0kX3QJqvPFy3XHYREy6Ep9W/QBtUfQvWUwJItdH+wgbIwKb5QdToJe2HaYncQ8z0fpBWni8yNuGkZffYOeDQVGIpC5gLweZph+1+9jXI1fR99G3tZ+uxxwjhxn/CCuE96WX4lLE1R29U5tlXqEts1zmtctzmfd34U/Ch0PKi+oOx2kYhVl0Xx1XDQHQ4H5XAQJKUcDHNaRO8jj/dMd2BHH/bvpO1EtGE9mKjWQexuLWF3a5HdtVbrOt/rIGgpy+N95EYURToek1YdO1vIQnIZuQFcpr2kEpXju7YzJs2A4D2ZpPKXcSco05Zj/ZkjDielB9htsA1L2kAcG1qswLJpS0gP62V6RBd/mT+OJGBUGY4W2Ex+HdOOMjizFriWdq0WkiSNREA1964mqltj3OsucK8j5WgElFI97YklRgNBjRo1sgn4lilHYGpQk6IE/7x0ejTxVT324JdbH7j2pofwHtfX//X6yXOeOvDTBZFt28Y3L97//YMfLVv1g4e6XYff/mxb2zPPP75x0QigxNb8x7wXKDGJT5ZoCSXgT9P+9YcRpiyTVOEE18atml21R6zWWk8kzEdqw0KtFtdUfwAjZ1SnTBiVEpRKaPVEPZXxoNDhh5yplhZQ+cfgY469pL/kTOkHkw10o/QxXNC82iRtvcZPcsxzXBniZnlX6yvdS7xXaFe712vd7ttCT2hWRdVsvIThfZgSAnVi92GaRtLwyF5V9fD+veRxFCAr0hZonQDN05yD6MJZQhfOEjXgXLcwelmURP2Uj6Jd0qCbpJKbpJKbpHUJpjsSGCX0BIGvPrGb3p/YPNTfh8fsCLyO9+IxYAbsTytFzbB5SB++p0BcyWOMvArC/0QyU9QB/UcoG4F9RGnNILUiee0QohxwJ5BROxVHuJMSEcKYj6ua3Qq0s3O13R6u5QHavbpWC/j9YQ+jqDCjqIb6RkpU1P5LwaGRaofRXqoNGFVJo4ugSWCUwiS6R/GKRGtv+b2rbnjup9c3nud2Kuv61q+8eJO7N/bZz696ddWyJTdtzh1988U8vtn/wIbsTdc96n6YXHX94ptuuSW68+XlO5YsfGhY5Bd37s/9/WNQGygIElAX9oJFqZEwpbznkZo/ZaC9t1UTCwpEMDWJaAKWom4xAcHULaIJWIraxgQkuVBZNgHJ1M6yXKxTUE2yCQgmIJqAxQQKeiw9utXZpq5QH1SfVl9RhfO487Qf8pwTRBZSRU4SrAongTbUtFc53s1xPKchomq8xO0j+8BwJHhL2op4HqqgV618H1m2WxCs6bLyJqup5qyGTcWAL5hxZe3Do9OalK6IN0ldsZHSZjuhPKpo7iZEdBIlYOjDzfQeAI7soveQnbY+vImR3ufU9qBa7gTVCc36xzpTcuCbnGx2pCi9pVIbhiV5kGx2ux3U3oQFYL5qYL46U6An3kgrjSmuYmiK48vKmukj2oEQoU7araaVlNo1I6WmEym1IgzHoSmmLdsLWnPQH0qGdqm8ReQ08EsadlPTBam8qUqTjY0Nhi4FBwU3Oho9cQfnwOS+/lvIT37w0ku9uZF44RPcrtPnPpF7FCT3vf2rQCBQqzcmPAl6VWIWicukEacJuNRCbztNwKUWutQJwB7K6IYQ3IMwYFWjaMRhmzXi8YSdVMkqdp6PhDUbRpIfTBBmQjOACUyq/qjAo4wMn9F/EIQclXFNTqam7Ww/NXh1WXfZfa6nXL9S31T/HJItLr+tLsi5rB6ny/Wqze62udw2uwZyLu2ir07bttiIzWZPe3ChGbvtPH6dykBQhmkHbZBjoX6ZfoN+l87r/7EM8zMZ5gcvQvcTvynD/JujzufxSGTH90LNMTtsO/+VLCsfLMsGSbMM9fJAfjEcZEDSZED4H9kgD0sKQFaoVGH2WoYLw5W9oCc5JteoZOsE96bdoBIwtBAKay4b2Bu8x5BwHo89zDNzN6zZnaA5d6y286bCrKcb0IvD0Jul4g1kmgv8XA7kGvK4JbCFE3N/4Xlg9U292zbN21Tz9J3k7f7d02+5ez+WL7/jxG/6cZfeffvBnz64Y3qLl/zvz3JXLsid/K+X797xAXz+NKA0D+jNMlSHPy3RnOV2XI4XYg6HaiJpDWsamFMhoSLi1qwRjKp0amgxX0uP+HRKOj6mN33M1/IVHKNDbxzSf22SUOaYfjBDSWjoqgCeKKU9EwMTo/Odc6KruCXSEnmlc0n0cvmK8K3y+vCb8htehxSlfVhtiABxbpwacyEKxdgF2qwZGoGGhfDr1BbtoxrTbCSmugvtrBpEP1Ul9FNVQj9V63RGPzpGOogq+Lbju6nNrW8eAjJqTE/EZLqIKYYjIDX3sedEcCqttfgW+i7z3eDjfXqhAmCDiVVbq89LH+Xz0jb7+khlT7LoOhm6spTejhmKkylMQFiRuPZQA6y3OhqPxvpM6qIPoLqzPbQTY8Gq1TCa0rSQu4LRlFsLCUxlhoQBmmowqAlLiWrmNYkS1Y5Oan7FK5BDH011JXaX0Br3bY9/yJRVrePnXkTGP7+8t/97r93y37kjP7nt6LZ3+0dPv/P8tY//9NprnuFn21YOnzb8zC/+srgj948/dB/7Pp6Kr8NPv7j1wOl3M8+09z18/3PPQS8tAn3pFZ4C3N/OohO2gxrm4Z/IvAWUChVMwwnmLaq2juMI7ZbpzKrlSNAur7P8D5oOVLmQcC1wuAzfAL5dwFZgYBo16myeduLY+fpJ6vPQaAO1dsFCMExb4MdQr0XlgFYor2HGa40thQiKiDhRio9yOkcv4nZuyh2bOsq+h7vpb7fxp7ZtujfnzH3b9+dt+DP88kOIQ7OBawLANT4UR8PJSwN806uiUGQYVWPg35C5w4Y5YxFRqIk4tQhV+CxIcWIXi1Ek7UBnTOraTYeEAuyi3c/Ri1RvcmYtrshyXKVHpdU97IkexnKegVjE4EAH1UHHUqlivGM3a4hoNkQ0GnKExT3sppotvJ+WAXA6XUEL6WvpnR4m+z3sSwe+z3wZvAvXFxpgbpTrp4304lrvFO+UxMfqp8MFy3B8PboeX8dfLncqa9UrtGt8t6NuvIlfL9+o3KKu1+7w/c7xksupoogfqfCmLcNwCTIH8XWkhK8jJl/vao2se8GCLeOdZDlKltROltROlkiB5Dp7OgpSwI6RXbcTex++u7fBb7K+32R9vxkE8a/LcpjrI8t7Ks1KlWalSjOoUrnOY7rqUU/aQzybR7xs6hqmYFjw5ERR3xSNZ2cqw1BJrZgSMVCR/2BHOBoEIbAjGq2nh6FRsNk/2F4bZVLB0DuZtZ2oE/yyHsDcMCYWQiHRWcPEglMTY0wsiCViIUUtFJxIjGwqOGOmqYygxOUukQalogGvXLP64xf2f7bqkg135E6+/Xbu5N0XrV+14tbbli3fOHbK5tk3bt120w1PcaHa+1dueef9Lct+VDvk4Mbn82Dm77/rRTxnxS03L1y84ZbT+Wmbpz/ZddMzW1Eh3kc5K4LqyPyBmMJupRy0e5UDdPtJRpZUyTO94KeBkhpKl34HI0wHi5c4/I4hSaUmYreV26bbOJvNjWZgzJxATXeIczE1NSqo802xfTCZaWASt4EhHGiWMpFO9de7vy7GGUoaMWAupeuYveRgvPhv3jr4Xf/0qvrSF6XPHhs8z5uOX+CdF1/GrfZeElwevyZ4fWRT8PbIg96ng88HP/N+HD0ZdZ3hfdi7zcuNrV0ikprIdNtCaleF6Uvw6zMMbdhLX1s+vrqE9stLaL/cpH0K4xRSSuop+ZPFekpJPQWPSTsGG1ubh1BduxN0rckFVSYXVJlcULXOUeQCR9pBHJuTg7gAVGCBAwr0XzS5BlTgPlQNtlU8/0FPLCpGzfhDJ860MwXIKzZDAQLOi0YV04SlUYiiAjTMqTPJyKZqqvngiIDwnQ4WWUxgRt4eRvdrtnmvWzT7+hmj8Kh9l+w6jaWX7jp27TX/+9OfvUN++8TlV+14+rrrH8Wz9WsuPe+GP61R/a2rsPyn97H+YO6vua9yn+R6fv4C1/TjXQcf2gTqD+h7D0J4PZ9geZfzmQaMgq8gShYiNvNcMxZ5K2kGsxsRGiN8VC7kHDqpLjums0xDiomE0E6Bl80kQIuRBmj0cLDtOXToENd+6NDppw4dgjeuxY/yY3mRvXEFe2O1IGJesqAqDldxRKriebEKlO4j5DAh5AUBBS04IBt5mCNG0gHeTzMdzawFKVCohj4RWLRHFAlmGRnCMjL1NFaLaTYGNn7s6THcb+jGXbi1/8dbEcn3IyS0g8csIRvppu0ZXwYeytclYa/TRdhSUi6UwLwJlzjCIl/0iFX1l4VbThlkDNVERfll4d4TZiFRzUI8UChaTT/aawZ9TRdLMd15q9X02U3AYjObYZZIRsnuVmyz68yF/aq3AHzNJBehCr2d6WKmVwW2r9eH68vlFZYOfSO3WX9FeEncrx/XFVlox61khr5Cyep/U/+m/c1m4VVe422cYrUIPK9qNlmUJBVgWVQljBC8Jm1nAeWopLrhEuE4WuahZVyUV91wlyUiCHJE5MQ+siZtQbL6aZpgQvZiBaS0knaqUbRU4mbN4A/z7/PcZh7zfRinlRnqful9ldusYpWe63bpsERukLokIv3A/uZbBskGYIN/PxBNMKAfOwZM2Bw81nKkmabPjtEkUBKcqA3D/OzIKBsIa4N+8KDt4MENgnEEq21qVpk9NRuZOd+QBPPbenk7J0t788fBlfva0Hhrqav17/9C22WxjxuRVlfLMsLAN7KKgVpbGltaWKgXKDaOG3Gci3GuGJeoFiWONP4XaXv32f4fP/o2/t8HJleEG4W9pybj53MTyXx8357v3XE7cNR9YM1+CrTsYP7Te0aGDAgsXUvzQzw/Od4aXxZfZ7nFIl4cvEJYY1mn3CzcrIjVXgvnr66LeMssYMkcLaH3o99N3KT9rRaLyxmpq6utReGyCHRQeSTiQLIf7s0V7/WXyHY/yG+V3Wtt9SdElRqSYl/+43QVVVuik6osUaSEIMq0pSIjPdFNyVKcUzXouYO9JvO5emtVQg3T56pW+jSVErNKn6UGh0Abv+MxWU2HKBJl6Y9oIfdxkmlSBhTyHqd6GdUagGhkQqws+5FJjlvgL2Y2Ms39sG8+n51PM6KPxt9AoBs26N9mHbwAqtEdKRqJZIFIlgUJ7bA460B27VztdGJkBK+RjMsM/4CUGEhAIY2OWEkc0UbiONZgxLETcRB2DaOpOqHwfSSx9bfrli2/9a55XS9uyv0An3HjmHOnTr7p4dyf8SUXJibMHzvn3k25bcLe9j1LL3yysfr5ruXbO0ZwsxzeZdOmXFb77RZJHbNq8qyraVx7Wf4T4UrhdVSG61nGejFZWQbiljkMDDdH0wspFEUN2mK0Bl1e1oVuKduMHhSe5Z7Q9nC92svaa+hI2d/KHDZnmaOsjKsTaxx14Wj52Vqre56nNbBCWFV2rfN254PcA7YHw1vx42Sr4482F3KjoO7WgzxN9e6oSTHTKVqT0u3AQCFXROVCEd6iJ+znokQUbJxguc/sdJ/Z6b5Cp1tbfYmojEEus1OtVWaUIgciixcwvw06k3Ug9CUABTfYwboJLtFMIvi6a0NpK8g13q7rKh/q4xp6V4Of6AJgx2qVM/rKSWMmRkAY+0Q+XlEJfeKsbGzgfVKCKnXicTupWud7D5yR+9VHx3Jv/fg5POHAX/CQcS80HvjB039dcMnH6x/7kJARX377Ir70Dx/huds/+O3QLff8NPfl3ftyn3Y/T7X4w6DD5gPf26FfDC3ujJbjCbLBnQ49YkeybxAXDc7dmlxUThFjweUsSWFhLGGxsly2n5UwpmIaIlheppto1a2FSJ9umFzAVPp/zFT/MJnqa5OpIv+CqQqnmUGcNGL4hKvTo7iQJIuyIPMyLwb8QT8RFSvIACsnerxur8vLiSHOF8NOG+z8cjiGvVZHDCVpxrEO/m7EmdB2pP9rVitwmc/r8zo9bgI8VhVrKCSLqoGzHsbfPDv/++2Xrzv/mrsP3ZrbjlN3PzFi0rQfrT5/W+53wl5P2XkX5Q4ffCqXe3pRw7ZRIyZ9+uTH/6iL0HEMPwXCofOeFHSM9ZdHFCKyLEmI42mXWS0RBckSpXG37myS5nDnRq1RjViDGm8hRR1vxuWLwswS/c+FmcXyb6SaOu6CAhcUumCaKdgy004c+Y4ko6aXIDOpJQgYWUxU8t+RWgY6PbHC9lO+8vTDXPL0H7lbhL3bci0/y2nbKG7A8eJvBdxY0OsMNxUMN3dJuIgeQM1DURJVCAkq/z/xkVaMMRkF8ZX7Djas4xb8W2wcMSI61DMYhIndDBP/hALnP2NgK/fu6Y9Itn8G/fqx2/qXQUsvAfm6B+RrFX6KfXsw5A55SEc1vlB2YSdXWYliTh+pQhHCBKCHthZj0RexcbGIaME4UV1VOYjTK0s4vbLI6VprZZTjAIfVHSyvcYRhhhmFhQTHO4xSmFFoo28ha7uqcXWZiewyE9llRaFalohasbUoVK3M8bUGEosvGCRUp+mZkwVM6gyV1OQpxoYAnXBuJOhSNEoGPD6Rj4fCwXAgzIlqQq/yJMoTchWfiFf5tbIY8tpdMajsdkUlOKsQqmI4rACzux2wi1hiMVTJwQ7RdwLT6816c9L8o+yPMqHdXLqyMmZjgbidqzG20ZhEw+7VosXpctl8TKTbuEGZPgcbl0Dl+sgqxyDJ7vVJwwiIdlECl83Jg3Af7eDOI5fclXtty59yj/T24Bl/fgTjexLPxS7addmtB74XG7MBk7u/f/xM0vIz3P/B2nV78IV/ehOv613e98Pha7qmzbxl+sZHDua+7lo0GjuARh4HaV9BZQeebFh4GlCC1+Vp4rmIxbrF+pqVWAVCFBmk4iBSkEtIQTZJYWerHJUkkWbBmDEGJJBWmEHGIugijXN7mFGGmVGW6dKwRhSTDhSTDhSDDna3KtHCeJL9aSs06j9gPrnAfCW6wFsQRVENR7UZWoe2RuPHtfuTmc7iQJKibjDICQB2yoZ0pTL1TEFgMLU5K/RqWlvNcQiDuS0LhDFky4CtTdMadLBeHPaPHyCnDhzoF4W9/U+S+acmk57+afA1L4BguhFwzuEZLANGzO/nTIBIBURwAIzXCm7cN0WEIxOGqoJqKEwOgGLVb43+YFUL8K5WKusIHV7TM+YMNsymp7HJOA4dbhxrao1jvMo4lkWMoz9oDMup0/SmqLBZeE4Afgd75S60BWURX4/SaAZ6Hx1HgjMKhZsRJxjpTto3/kKffW722Rdmn51M64YTx/rsp/yb7SXKesKCth1d4Kll2jvXNvcXXSCaB2Wmk/kX6gHhSApj7Cj2XzhAvRnA8+j8J9wi6sHgAJN/+lKyXLycXCFu1DY6RAuTer0KFXp9ONjLR+wWyyASt5SQuGWAxC0Jq/U/4IWeVjmh0Gga/XzFTD4qhlpggGHn0pI0S6QomagLR11p1wxXh4t34QRi4zQMHfuZSc9/KSiTqc5dJrqO6ZlOA23HGO0WIk3HkoApkEg7AYsWO890KXwjw1Vy8NCCUSMBcSxRkhj3nLRm8ZSVNQfaX7zpxUN4i3/rdRPWfZ/76nSg79WV71GdCp6hMIvKDDKH4TXCVYxOyZax1daR4ijr2dZ53HruLU660vo29zaYTlTqM5OvRtjEdwvP8J/JgpXHI/k3eWKhEsHijDVxUboDc7xHTTlpaQ+cy4UjT49l7Li/x+ml5e+lJwTgnVVVZ8iWQOAMvs7vPwvcPslitchWgeP5qGB1CwKcgUQS3SCUrFYkEB4DawHfWjmiYMT3kbFp+3ABbxGywn7hA4EXzpVpmTJcwlFw+bMSJ/WR9T3/VkKBalKi/7GVVOjBrwaMo600nFAgeNpr/ZnOYzQiRhVLMxU/zc10A9lCYwp0JBMc/SzxL8l6s9yMp2b9s6dmQwMRBOqk/2lMuxFbpifHe1QHRe3xtA8AUbc5mmTdpjdZKGTVgaWR0YL25ABj0cECDksF4HhIIMXTrSKUAqZ+b5cXQG9KpF2gOFNyhTvFp90p2iU7qwD0pAZYM9lOn4w712aSiAYxQvBIUeQ56AomPflB0rMRVHVjgYdxDMO/5LjvAPkTlvofIDflUf/J4yBIa8lb/T8/fT/5+LMcb9AiXwe0KKDHGS2qmIDmEpAcpfEc8tROiRSlKmd2Hle06bjof2rjnvyObyH+K9/i44xh0lLzDXGm+WqwnKkdPPBVfwAZ9Tdmod6PkGiHL9A5QxvIdYoh0AkAg8Y6gGgxlJxs0xzMnAJJCoBARyDWUEh10suCXeUsCBPZotiQbCFWRWQySC8IoFO7mADSER22Uvjyr80vP218eenw35b9+/XXXttPBzklCySCzBHG5RIT3iLbc2zPs73A9jKl9jiFCLOKweii5p9tIDJoZXvJDBzKFMHlbJSWgNWo1dlkZzsBvGBsAz8GkMlG2dCnMYA9ZB9pRU6kk9a0VjC/RbO72GMRzdslT9SfYC4fsJTxMZkSTWIwQSh9AyJ22U1CMn+lul79DaBSnaJOsXO1fJU2xNbGXcBfqV1l26DJChHklDbKNp1M5SZKaXmadpbNej95gLtPuk/eyj0liU5it9mGCwQEEZFVTRsuyADK6iz7LJzGhMiyxaqAkrTZdNpPHc4uJ3HuJVtBfYzYIUTlPjxip2qxmkHbQmQ2bWm1RtPqDQpW9sJn27ACdUkfHOwYjbeWpDcQ00UqNaRQ1L5Gx3ofad0dFTqELgE0NNna46B2UIAO/M80+/uZ7qDxTDgLlpweyVD6baZTAoq/oH6MxTk3XM/CnHAAXVMMZ7b9AqlgeMj5NxHJv8nCmFOzKlyrKRVUWv7r7TYrvVgYv/TGrljKNiTGxjDtGp2yNYxm4M6hUFoYp5RsX9uZAWlCkyOI9pdG5blgk1WZ2AuBT/ozrAHw0H2jRuMYmGM4jh3340p8wXBvYCReiIV9udbncm3C3m+/uvucGT/mTp+azP/225H8B99SifAQ6Lhy6jcSwriS85uBd9mMae5odSqmYSr7VS9LY4O+9hby2XGH46y5ssr2BOwlSQY1JBOJ42QLT4hFknkOzIhvi2YEV2JGcGb5TpBRoiiY5pNQNKkFg9fB0k0HGcNlogqOKjOUDmWN0qUIilzqwxa82qhhS2vQ5P/Ml+W/a04XfdkSay2ZSTYzesl0FoasDdjPTprqTaU28IxYTL3E5T/YDepIjsIOsaFEI4ZTnwoooVdOT04BCvfvmpyS0w0G2JCSQBvRgN2uAIANBkhL48aMDSWekmxu2Fz0/MQuF4BlBlgGoIeCX28vqidcwvUGIamcjLD0z2rJiI42YmrSY8dDL3Nk78unc0A1N/I3AMV0fdtFZyGBp/2u8AayoRA2bKKpQTt26253yBcK8bzOuxWfEuKf9u2yvWTjfD5/iETL0o7prum+dLBNaLPM0+c6Frrm+xb6W4PzQrf7HiB6IMJxzohi8QyyNT0lROIxbc1drZ5EVMLSL0smR0hAi7R7JdPgluiwB9qpErUmab9KZqJZoh3OhLIU7CrDZXZTZdpNErIXPXN7glJOcd5EwUV3tSKxRO4GwosHIh1m/DNTJJZp/zyZIpPpDG1XnCzwqVi4APOSOa5kfgSKNfA0bsa849E6amxAjiaSiFegxXgjHvVbPPnZ3tyuFw7n9m79DS576884dPWnd/8+9xZ5FV+Cf3Ig98Rf3s9t2fkbPP+XuX/kDuMmHOrByg9yHxkRT74feF1DfjzMsGiXOla5yVR9qvsC/QI3r6gREOTI5zfiRc5BHfIvhyz3tDoT8j7oHiPLYWuVWSZB1gtK8UTaSfEkB6NBDP9Bv2ZiXDMxrhWNFC36/zHw9N0wXKDUVhnILnQaXVLoDjMOx5xdGsrYblNZAMpmowEo/78OQDX4IgT6JRZzAFwMZpLae6atvqf9i9wruY342ucfzpw34pbcbcJem3Pprkv25fr7f8bhTTcsuNmj0ZhzW/5O4QvgHw+qIRzrgXsXJh5JkIB/tIcoYb6cBm3c5e64WCcM9SUT44Rm39jEecJ5vimJjDA33pa4TLiWu0bYxG0S7kUPco+jZ7k/oj96P0If+T7yB8NCEtUJ4wQ+I9zjvy/xxwRf5a1LNHlTiSn+KeFJ5ZPiUxOtcptjrmd+eH5Za/m86LyKi4VlnlWJaxN3hu9M/Nn/l0RA8WMP6KIdoRSiI2yHh1K83+2vE8YKPOG8NZxUk/B7BSTGOFdQIPQECZWRiJ0jcmVEsgQHEU2whGiCJQmtYMLlp73rMpnWZbqALsq9tH9dJtO6imTkOpcEo3VddaQuZpJRzCSjWJFxYwlQEEqRXxU/8z4ZvyqB2gF+HWDXaQXXxORWlrcoRNN8KeRo1F/RX8kUEhloLVXKnWtDaY+AkGT3JxKVkRqvt9JO0hwnVTLeliz2CONte4G3G40JOfV0xwaEMhegyuuTEtViSSCMsj6UjirwvIMKgNGJav7vG9amHv7JY79+Off8c1k86RUqBy7t/3jrJc8C+7+d+xCH/rJiwQVLf5JJbkhde8F+vOCdt/GSvS/mnnhnZ+79O+ozD+HUDmz9Qe6tHFTO/b56XIDS46Og/beBRPCjCnIDo8eYU7Fh56jw/PJl8iXlvIVNWZLZXmL7ShpMoB3FJgZRQDUBxQScffkPe5zBJjge76mobnLQ87LqJr1wtBeOcP1PPWUJ4zrU1wtHej09BYAq27nhc6OzlQXhS8JrLVfZrrbfat1o/5H2tL3PftT2iV0HWR512N0Oh91hVy3OEIkFvVbRSecSCX6LxesLBiK+X+b3l+Rt9huROZ8PxSqYnPMDJdrkyCC6HTwcrRgSiSRsD4nmXEXRlEws3BdggT+RZV8z0co1lV2VXGWF36TTgbFnRXHn/0/FnfhvbZM4day/G2cvaKDAEX8h90MN2YLUA98bTlL1bOaQMXFIKM7jLPmjBgMbSm+V0/aUXR/rcI5N0uHzncyGtYElEgykHGCrOGGzpcMpHVxkvaIctqLx0R7aYQnQUHBaWR0IIGwHqwNXMMYoyFcjnvhPqVmf1+eKc8MISNg4k7ZssFrsUdJ98HfXvPr6tJq55+VPHJh76byhsan/jR+99b7zf/RYbriwd/pvrn7ozbKqyvOvyHXiEbdsGqNI/VdwjaOvPnsFnSO4IP8J/z/C62g4N56NWXGg6pJxUYkSuDiyGPpLL/RgwASCAIwvZ/W0kly/WgIrJXC4BA6ZMPjm/gJBEBPABpCuaV3MLebXcZfzfFX1SC4VnsBNkc4rm1Q+sXJy9WyuXVpQNq/mNpctThMPlHgqTaDKBBImUG0CcUZXRmUDqDKBhAlU00jlZArVaIlKUslVV42yN8UnVk2qnx9tjc+tWq2s1FbZlrmX+q9WrtGusV+vX1G5rmo9163cpnXb79Bvrby56h7tPvt9nkjBbR4aSzhDiaAlUYsTCNUGnXzDiARaCqJHG3p16LYQCVV5taGR6ipcJXiFYqpUiAy1RCJejplONG2QMfIb9JBhs5Dqjxm/UHpoVaVNU4RYuCwSkiWR54iIqyoroEwUIqGhwTTlobvA9jjmRUNZAog5FDqO4hm4A6/Bm7GI+3A2rQ6NRF2us+bSFwuUpTV6RpsCX3CuZdBw1cEh0+JwVUsC1eJaanbabGRuLf0exsK1wYaY+h2NZY5CBRzhhJN6PvQupykBnMXRP845VFAERhSSQplpR6iy0gvZdlOTsZQ7neqo92eSR+juBMUUMDk17+mIiXYaJu0c4HFcesI4PrQbh/DQkHeoMSxsqOKNMGvIy5kZSWBXY/BdhDQ2FJK6ldVs2Cmbo1XI0XvcPi/vY/xM1VtiwW5t4W+uv+yZ2TMWjMutnnnx8u9/9cPHvlkv7LVvezr7aGoMfrut65r13/7k5dzfHsBv6ZfeMe+sdRMnLY/7FiVHP7b0sheXXPy7G22333njBdMbG1fVjNt55RWH113+KY0rDQerdi8di4Z9zIMVTZErmYBoZhmk/zPLIJpZBun/yDKA/BZIBIgNsUXOLH1kXU/UGFq1W4xiUk/HFWO8ExfyOkfTCpPzckHIf2XG2z40pf1pU7rnjEgOfaK864HS0Bt0PTicRzIf62ztgpZCuqb4F+pFssiWVgCngsnXBhoeYKP46JoKrlwZ350LCdq2baf+RnH3KPhzNCvmxuOY9rcm7G18m/yKzHv7CvmxJn6cPJk/V77S/qRw1C6piDjoFFzR4h6kMN0lDOEeSA24E8T06EnRoyd6IUv6geHRk0zUi6PeGV7S4V3j7fJy3n/rJexq1VjC1IxHWKOFeWmG9rSavGMtak8rX4igGdrTWtSe1oyHevYD2tOITE/TM4UkQ9F5Y25CkvoJogNwu2u1aEFEMVxnNlCy0VHw11h2gSUaHHzHgSW5b9/4fe7UmgNnb7v+zV3C3tPb382dfuxOrH3KTT+944WdFx1gqy0gC1hhk+n8QzKBUbAwpPDRoqkaeAAKKkcelI85VYTRIJe4NE/zVVHlmMgktiIfWPKfFbWebMK9rVa3pv2y8NyPzUJcWRizQkzAGjSjRbRaYTQnrjSzewCUBHbTTprfZ56lFQkWWcBEqH/3kP7uIUdjIzKiEHT4dGW9gOtQDVdlrVeHqx3qbfJtls3qfvW4qkTVGSrhiSKTwpByC1YVFnduaWGDD+Fuq8USlQW3LAsImI8IbkIEC7zq06gVyZalMl5KZJa0q0nNkHGXvFmGc4zTGknXpBYSfBd5hBBCSxxRYYZAhgsdwmZhv3BcEIQ+srFH6dhqhBI76Rx9uvl1Y1WMYOCY31gZozAmkg6JNEKF7oFw4A5kByL83x0WJ6YH2U3j2+ao/6nZGqg9aiaNGiK2GhgLHNApQt+dt8gE9i4BybIZyKE+RQw3GsHARkzG9//mD/j6YeUVQ/Gml/oPCHu/fatrzVVX8bUsbwgugHQltf7JP4xZr3aTtqDvgAMLJGIroTJ7vr9YgxtUw6Q3+8AoXF4s5iFKCM8gaFMbciYA7zOtKhs8wqRJewl92ksUsJp/A15jlAsmnG5srUUJR60z4U+hUaCrRvmnoLMdU5xn+9vQPEebc55fv1++304cfppG09m+YKk06jgYSHqahCZ1ojBRneqZI8xRL/AsEZaoqzyXC5er13rsgodG551gxNoJw3mLETzzMaOEUl+E4wWBiBJQnxXEj0Wz2e2q2+V0erw+vx/86uYeAfmj9Kg6HfSYnu+RLVEkEBLFIIcx8guyHPH43R6P36laLBGPE0CnQ7Xbo7rDresOp0WV/R7B7tBBGEOTBM6v2+0WC5ABtMnvdDocSA76fEF9vAXPRFHA2EzkgS2NBDxzV5SO9AsE+vDt2w3nIRMMTOsP+vv7g4F+//mTlk78uOgxmEFw6izQob3mlkptmFYaEh98ALLcYNMPHoRd80ETKt0BmduBzB0lTOG00mkhBgtUwbW60vg544RC0N02cKFHTQtpuuYIZumatRlUDHcO/IXSmuoEWQBdholHLowYpqFzg1dcBq+4nHBwNeI4piOHMX44d+3L71cGx1ix77M/TI+Hh378q9yl+3K/rZZ87twrIMtbfnTv/1Ry7/UHc5//7fZe7uenJvOZTdGlZ3/7WEGiTwHOcnFtzNNQkF6SrrCbcG+rozh63TbAN85ioTww+F0Qi6xjXtUGvAmX3yy0fMfFSNe1goEZwF6F1DprXWPwaG6MPMYyRhtrG+kc7bI6XTQn7aQ7WyERrRWOpQnq9GqaoY6aOezv4e8pJMHXSjVKnS3hHMWPlccq9InnyHP4jLxAmW+b41yOl/Ir5VXKxbalziv4a2TqNnzP+T3Xer5b6rbey/fJu50v8a/Ib/F/kt+2ven8hD8qH7V97BwisgVVVAfY6V66V2S6B4H5dQ8FCjyrqMjj1v1Wh0h98KNpG4V0ERENVAwhLCpP6RXIwmDPDHCmxYLpqrQc2GMuu03TsK5rDqfLpUC3EU3hVJdVwaJOXBaryxVFFlDRFo5oWlTl3KrKgXrhOEJcmqaqSK73YA9wWlRNqwTk2MLdUetm634rZ+3DfTsXFjRJX9oq9qb1GfphndOhUtoaRQG350CMapLk+Sco/2X8HwWOZY5lAGAsmBnEgxuEQexGJy3Dn91OOaxZPlh6MDjsYDtTD0Z8s8gTzHNXaA4hkMLUa/eHUk46NDiUchkHns5eDKXkilAK+n7/jjDNS+1Pl4dTLvDwOdg0m9fX7HJ6fWfIFoA4HiCF5iWGOeGZzpSilsXOwKgs1qxYKUQopLp8UObyQRmFCECDubSUbdtx5z87JqHdmkwzh6SQr6DhAjyg50yutZDROfUTbJ0dHzEBV7/e30+Sx3N3lcdGeHKbyWnyy9zGK1pmzMO39k87/Q1Rho6cEclh4FaxYH+ppIPZX4pQMG9UAEqcAFMPIRMumU2iikVtiAdZZcV1JHgwRMe7CvbZ6RL7bEB3WkpsNbs5AMN0XtT/w3nZ3SpbxnL8OOi3T3qcPsqzn6RtAPAB2HF0Z6HxNj9j5z+lxwHA18DOCVws11nrbfwKvEJcobwn8pQ/RFmyiKJF5CxWlY5pjloVt9WqiJxo4WigwEtLuSjBYGBhUVVEDC4HVvpIIG2xWoFlwM6z9RF/2qJaZqWtXVYCTLEzrSmKGkXcrOnkLsYcO9N05TC3GQRLK8xBUgtO0YcFN4n4d2m2AsMw45z6Qsf0fuPwMfWFmgFm6W7QVBuGJZMyWF8Cm5lCoQ10PooOu6lZH2iRcMlMFFm1qPxeEL9c/oQxJ426yZgFvyxsaAhswBjvbQ/QuFb7vyRa4y+0AysiDXdZVyvgIAxQLFtFgrliA1TrIOP6f/s5js2YdNaFOPxh/25yCTctN/m669Ztxs+d7un/AfUNasG7zVLaxLMNG63Env/npUV2tDptlFvtmqPpHHy2fI6Fs8qKpWArp20qsmlYiahgnEREkI79zS39BwuSMfksD/2HMW+x8rLVmiiLNdVY8TfgakUxD2YJb61Rwk2Y7ij19MCRp1TkoqVwixCRRKJYIyATrfswXcOOh64NIWm4nAYD+1y1RcFK0IaRIM5EAY36tWB6TDsBwo2OCm6edqKzWT+iny4OlG52pBh+2UJznVTq2fSC9bC2nc0DZ2N3LKQilsL+GBVX7+0MpEgF66Qkk3/QHcjKhqeCjcxmuu1YLRb84mQDFSIj8ajR1DnGUsxTS76ccc7p3/PB06+0c1t7uWeXnLtt22lp+TYaKT83f5QP82eiGjSaq2C+8hCLZqkLaMG6Wq2uLqWN8owOja2bUpfRMnUrtYvrOoZ3a+trH/T+OPi05qkxB8FVs/XtKPRk4JmaXYF9NQcDh2v+4Hm3Rp7oxREaMHJQN9XJ8h3GbLKRVPlOp1C5r9yfHFLXlOJTQ6bw5wxplduTy+SLk1eqG9RX1G+0b5KO0U02zOv1lU2+hpjbv7D2slpSG663tdjusj1iy9uER2zP2b60cbZ9ptjZ3Wpj6+zZzCF8NtoIN13ny8bm4tpEOlfXlijIRJufSbydrTZbmPP1kWd6/Ia7SiPaQ6zWs+b673WHwxIqfguaVG1tCHNK7SJ9ERpfagihkumACGSikURUWpHI2L8qVkmDB4UQ5+dG8KCSpxKhko6+pvPnK2nOgeKzko4YVGizK1mDK82ISmUfuSBtq07TtZGiieGJ5xJCiuYwaKwt0Zd/0wD2mT5HT2tiRIqNHYjEm4an9qfIlhRO+eh6JPThPtkcm+Kr8lfUm0vw1JtuTL3BimlHa33lC+JhkZSLLSIR3aZH7y6u4mM8Z1iraGPJBCbxRD/LIrCVAUSW5RRtLKPAhoWLI8YMDOSli8IZUb9kUgcGYev4HSvGMljmM/nRRzR+cSTZcgxO2YIUJTd3GjFVc1UnxOL/bL0T1BnajbhkUlVttX3cUJoYDVdbuQYGc4rf5wu7jZWcpOL47hY2xYqltmhiiw2xpDHB0ew3sqnaWPTkTMKChF6Px+31xROcKNmIMUkXKnHNS/asfO75s9edM3LVO8tx46SNN1xdlvVf+tptG5+ZoVt8Fc+HfRcdvGxBwyUXr/hpouzmuZOfvfX8G89327RgZZX10qFntHf6O2+fml507rCrjn976xlj8Ls1Yb1mWv05HRdMP+N7lI/XAx/T8S46KiNOxsfXYkG1VwojhUmC0FKeLSfl5RXhxvBZ4TXlm8vFsa5mb3PwPO95wYyc0drsGe+FwZXyam2F/VLvpcH95W+r7/jeCXzo+tz3eeCvZR+U58sDUaHeXu8eLrTY08J59hnCMuGdsr/zp3RV99h4ED+hMJgqVk/YptDJfwNJB3+Je1ucCJiuaPVXvqZgXUkrHUqXwhvzjBTGs4q/MNLtpJl/O24OtTUWwVToyiss8clC0ZSUlMtB8RSI0GEQ4a5WRyNymgMdeM0c6MAbI2NYNLKx6KhzhdWmAq1cFSH7Md6Mt+AsPo75ctyCp2MO0xAmZVpMl50oo+yFGXVjFvfDTkrdmFE3Neh7KVuxql7aZOyn7cVsGiMORM4ePShERwl3rTEHgpUdAeLvL6HppJnAbWHTBA1F3rkWCLoXW3Wbx5hervBiiE0vFyWC2JDFlBkqjQMFj2psiBCPjuIV1ZzbV7JWwtCnetduv+i5znTuq188v4o0zb37yp89ccWVPxP29v/9rul3vbou92XuzZ/g+16Ye/uh37720iHQgjPyR7ljoDeCZJGhv33546ZFaDWnPVtMwG4CugnQLiqNoTXZbrBjOxWfM9AaxCHeGVYkf5hXsM0jyRTXEsO1xNYykHSKa4lx/aE3XmLpFP1gpoFubKUCi4rLwxNcE3yzXbN9Ha4O34/Jj7kHtcf1x4OqrAWsK8nF3ErhCnWN1qU9qe607LLuVFWvul79K+FsFQvtl9lvsHN2DGognRjORsd3QLM2oy3oA3Qc3GC7XUEDbQxD09nCpgPhJJPM7a32SpvM9E1FCLHxfSdKdMMXxWqoUkmWg8WIMU7bkgxHOF2gZ5wuYA2PMqRwFIoYnaUZkZ3DSCvISGtK2GMKb49J2p6C8I61eioPS7hcapGIZGMjiKz0ARLTypK5SJekFthHGhFqOlgM1BtkWDLlYm1hiXe2iteYdri69gQda7DWnMADolPPHIF/lp8BgjWDfcZsSSdoCCfvZxQLToSTiV5FKs4RK5ktyVYAamJrrBYTMZSAuebtZV/+/J3cP9Z+etu2v5Q/F7hh/sZnHr9l5Z34Vt/uw7gMW3+GyY3PPRpatfpXr7954CaQlJOBct835kUTF5OU11kJr1VpTdpETRjpHhmeR+ZYZ7lnh5eTJcJSy2J3R3h/+RvCH13vBj5yfeT+0vc/gY+YRPSWlyeDVIxODVKZKg0jldow71gyUptKJmmT3VPC86yt2nLtI/ET7yl8wqZjD2dTdDtISkVyIBCVoHPGWweJyuLaAf5GjPYN2MSoymEfJFXt/5LcKlvtVbr+mgPrjrSjw9HlALlKWcWQrg4nFV8OZsFQOesQKWM5mLR1sDQGpQmHjdKEwxyb6zDH4Dr2ma0DwXq506Sy4rJvToPKdrU6KyUzp0zHVlDKG9f6gnRYel/KSzylvukSJ0UYCzPDQIoYrM0okhlnUpBRZCDSNKNETlLvmWUviqKRFRoTJkBeNh8pJDboNiAo6XjT0HaOCklwYDgQKTZkVQxJqUh2Q1K2NDpTLOsRG0lVPOh4g9roYPbSRWbGLD14wx+vWPnGzR331ff0R392xZVPbL32qkfXP7zp28cewVz3zPHEdmoycf7u1Rdfeud3B6lungq6OQKy0gMU52UU5ytHYQ94mRkhY5mrLOVWCZdZliqyh1p/DNUApGdRqCxM99XOt4VT7pNBfoRzbGBEeLxzWnB8eKZzQWBWeJHzkuCi8FXiVZ6T5KRfR15s13y+GV6acuK8YftmfYtOdJ0Pha0S2kueobxqarH9adbVOsice10gx+i04ONFqvqXSzr3tPrSGpikLBulmcslaub8FhZVsVTXNWU1rAXL6XyPqkQTPe6mZmc5LvfuMw3iXa3exqI+GJhALJt6Wq+U0pV1TSa9mGRWEFPpZCsdul4koTAjIUOohRnxsGljlIQGq9pMkg0mOQJlQE4nWUDGTInRaUqF1V2a+zubCyuaFCbks5kQoXQZYiqqC7SBMLwA7Eev0WgLr3spjWmrdaQP14mL0628qyDerCEm3qySORl84YWZ+qSjsT7TWSLijHGRbinGkm04xpZCE7kL9w75Ys+nuS+x+y9/xDZ8+qh1x62LN/W/Q2aqY1pvu+5p3Op7rBeXg42i4prce7lv9Ohze1fge9dPWPEk9bZdQIZdwuvIhy80xke6LdgeqA8MD6QDawI/Vh/SntbkoFajZQP7A3yAhcaC5U1lssap9rAVe0jS7eI5EVkfcWN33mV01u5WV5ofmFBvCgRfYea3Aq4EjzhyD2aDlntGjGlig5eT4fKmzQgH0lQEBdIaiKBCnKSGxUgqqFBCQwqRkq8Kg4XchcFCnzG7CtGpD2wF6r78KbYgHnrMH3ge70UxdBJbkRlOKfY5DayAT84ExbHksYwRWaHLDaccxsRSt+4QLZIog1ejW5wh5BDtIZzEybobb8RJECFrQzuR1euiaeihvas50Wpn432suDAQrsEYsR4f2TiyaTQdMwCKiuopD11Wc8cjj7iCN1953oLQmIZZEw8f5h7c1LmqafI850+skzsu2nR6GZUTZ+Vmcp+BnKDrS9WyfupQFME9RKlyn6dMcouWskDZECXhHhJPKaPc5yqT3a1Sm7JCOWX9u8c2LD6k+sz4mdXnVW8esmWINCo2qrZlyGRlcmxS7ZzYnNqLpcWxxbUdQ7qGvFN9NPZF/Mtqh88revrI9t6asEtilo4eRcOZndPFCBpcXXJ9WhfCYbt1UkVYtXo9jVWNdB3o0rWfvyrKi4F1oCtbrVV+/2s+rPvSvg5fl48fAr1I5g5hWsjHtJCvqIV8TAvRVQhZ6WeGFqK16KqEBS3kM2a2AAAK81SJjDpVeKfa6rvcjqtQRblJkOUmQZYXCNLXWl75gv2w/X173s6X21vs08HGM8WKvaCphrXamVixBynZ2Stoq+xh2iJjXVE700z2QHLI5TGqnJLnD0iWzsJ4Fb1UPzEFxSTOSbpi55HCClJHjPR7JxhGYA0Bk3o5hFxhgVnygHG1gq0vDFgXPa4aJjtchldqmPUgo0CCAMn56IoEzM+sNlaLonrLN9KcDli6Qtqy55SGCZdfv9Fvw1dm/3z80v+64/lrnlz65y2//OyBJ6+/buu2a67a2hacWdWwZP7o7O24+d37Md50f9fplV8fvupZru6/9r/wu1+99CsqTzYgxB1l4yteMWYde4G/PT46S+2DNPPsq/iR3CRur8azIo8v0OSTHarDzQkY2cOC5Fas6iB7Ri2hKtW0bdLVrWqVJd04qilvwfst2MuMGW+aLUZRw/ZuSjwWGkZx0K6yMOfOEqT1LCzuSrvOwuI+FjpGgjmLdCELdn5yF+1Ny/lsWIivaVRT1nvcS9Z4t3iz3ryX9xK3SURuk1DcJn25q4zJGDo07zggBUWBaT5A/P/T3puASVVc/cPnrt19e+/Zp2emm9kYaGRg2BxAp0F2lEVgZBAEZVE2EUHccVwA9zVRXKKIO5owDAgjmheiccOoJBF9Y6KSiMY1EoNGxZn7/U7de3t6GhB9k+f5nuf/zMCvT1Xdqlt1656qOufUcsUCbtvu+10yT/Rmlsrp5lKltmR8ZymGJIvuSxbq6LickRPy02XspQlnY/PSRJq2mGj/osFgSylk87DoxwJ6wFUR0H1Rye9GD0Zszr2cEnysfnSr1yBD0dBz9dqySOOTmCwl0dl6a51GHS4LC3bRc8JrtqzcueJXY7ect3DCDYOhDn5564wH72mdKd+/5uJJN17a+jR6ravBEIN5NzS5ZMPaD+1Mi6fmx9vPrYJjSIFt7G+fLKA0t5bmVh33lnrZ6+jpjkN3HC44UjdtTdOu2t1amltNm+tX7berOA7dcbjgSCtp+xxJu1tLc6spM9+Aek9/fs/jPTd71nmaPDs973n2e1zkiXnO8TR67rOD9npMjxHzQOFzqbLi0ZWnzZ32HbrXKysl0jVdNXRXhUbqfeo6tUndqe5V9Z3qflUmNa7uhk9VLTuDPEVNsZoqWE01uAiqGDRVZ9BUnTVYKlslDGY7dZw7k+HOHSzOqgZbWbOLYXGkG5/bmDjSX3Sbamg6H/hG/JmWOuvY0j45Cljq6i1btqifvv76wRy18uDbJJvr2yZKAwW/RKTVFr+k9nU6Dl9qeZTjCKSvp7AiOw6f4/Cn4jiNVnEcPsfht8XLinpVq9AGqX201ZqW59Y0l6rKqpZFkt8rK9k+Nax5XWnvpEy8E6/uKgoHb4YMlJeHccBfYRg3e6WYt8473qvwzszkAH4H9k5NYRbyCqOnt0TYr3z8GrxuYbkSo4m3ICv7l11GZo4jbAkaPC7EE6ZLqe4kNvzwalFr6b61VKFPnzUht3XsTcAdCla6Q0ZU8gRcUbJafMay5+imsAutPulZFA56019Vwn5XknUuPS/04lObV29pO6u0f2xA/y19htwxWv3497//9uI7A6NvVacfXPfbk+agu0O7V77hXeRKxNphF0jNA6avIk3fW6+267MpcT516Lx9DH2yqF63VEC9Xp/mUYL+f2lf64rHOSfMWolvOA6P4+C9e0mxkn+Kcr4hR/R4lpgQ3L850pUnCPdvAY1oIkAsANifvAohuqpqqj7AMxLsoB9jTDXOV84z3lbe110P61KZXumqcNfqx3rq/OP9DWqDPtXV4LlUvVC70/OC/gf1TX2f/rHr3/q37pyIYWiKosq8hd3jhsfjdldYG9cVVa2wNrMbaOYqr+pSNV5K4/WSobZIwaRHU8W0SKmbfTlxYZ8RpnFX4c1QpNp3rTts7LUqa1u9t4JSzSfF9nLq7CW5QpIga9fRePTUfFBBbzEcCf4k6/AG0VOwmRTDj7ADkTBXUYHP/9cuI+elc6ZgTFuE5iW6S7/mJboHEp+nJvWhdufV8tSW6mx15z3vLnCqe7Aifu1JO/9YjxTzXKXInnw/byCcsbTBOgY/aXh6FNd63MXFg3mPenMxb1V/ozkuyKYu9mH3YgfpUrKn/nVzZ3MXsc2wOZfJu80hscEdRPh8gmzyOjtQ2QrFWUXeUSV3di5yy84eLH5470NzPif+bFPUii7NaLCmENqXFYvthkEDvbZKqhtDqqpbQ6m1aMoeTK0JfBd6QGnDx20LpB3vtt1/mbb9+2ekprYVrXPk2EVt/KWtKzF+DhCniVx+6OiZmhg/zFiZMSamoh5mBMwY6dLuesi4tq1eE8OXODdkwLHW+SF9+1m0V2+LllrniyQrIPMFtZh2n/aepo7Hz35NiWnnaI2aqamoEkNWLCGJ7ySEpRxoR/eRtJP2gyHTJKZv2iWm4jSJyWJOS/dz24qfs47YNJ2VxfZgRuPUjoMZj2Y8ZWSfOSJ8mX/RzWRYL89+bVduEcePWFKuXgl9rExZIlY73UpZaZ1ZuhqUvocwnOYuTqvhojR3NM1dmOYuTjtftCjNHU1zF6a5fWmLZv1p7kCaO5jmzkpT10Jp7kiaO5zmzkoT0NOF9UiaO5zm9ttb29zOHjdemZE8yevvW6HuU/d5/pr3QVzbo30dl/Pc8TJPfjTuUZSykiI9hzUsl6SXFRaEjN0V0s0V6yrkCgyygYqbw1JYFXZLsbMuLGZMhd0ym1kkLD7YxGwSloX1UoyxYTFXGna2UrbbMFukGZvzHaNT++Yle3LIX59fcXNUioqcoqmcoiKnKB/TEOacokKEjwrbeZR7VaFURH2cZ9SZn40iq60k9ylzMilzuucyu3vOri+rkHaTxNMKcoy4k1ZEJ118SCcthAjKtTWH7x0byIFktlAhLPYPWP12eUWLdMHmTKHCmmASemjatNOM9KMp2d8qVmktPdc6uqSO+/sQ7xpMO4Er4MvOqsz2haNSxJ/jKBiOhSxxhD/ouCGjEF2lpHtzIIhsXeR1eRS9BM7mRbql2NbwvimnHeaIbRd54sxvoZAIY0q6anJ/zcMLVtwRW7nr3g2by6Yff87Ptkydc+LlA9XKn4+becbU7Ru3tnaVf7Fo5sCfP9h6h9x8wQUT7rql9U+O9voh2nWu9KGwsmRpip4lPxpqCb2v/D1rv/J1lq6yfFAKvr0wJK0N7c7fm2/mq3F3diA7NwLtVdJz/YY/4At0UGEDaS0/kFJhi+oD5flCY80X2qtX6K1eobd6U3qrV/R33lIRQ0xqCoFR6K3wf2tPchr27OfX1sZRr1CNvRL+e8flc/9ayDps/v58+Zz8dflN+Tvz1XxF7pOT6/BersONuY7clSt66K+3hMNW/3t41dXIUF3DaaqravfHO5ORTFV4XJ44Pjv1ZymzB4Q62+FCwjn7SJw5UPd5uz6bq4c9httwGYoeqgzrgagUNCI22/GRbUtZeIgmPX4jF8ylaBHBUppjK0mxkz0/n8ZLa9af986s+yeEjC3dF45a9ohaecfG4eecVHNp6zJ59dmLh9z6u9ZnMEgNMz9Su4Jb/FQgmcwvW3PEV6zEzl5hEeIeaC67CsSFiMso8I3UR7nr9Qb3mfp8t7tvaGBkYG6//OGhsZGxucPzp2vTPSeHZkRm5J6cv1hb7JkTWhxZnDsn/3wpx6Nr/lOVydpk41TfImWuNtdY5DPyilRXGD1kdgfbW3baDFB2yvYWqs8ujwo7W1Swmyv1CT+XmOexp06dKXXhEOK281EF+5gB4diZDJRX9O3lksgVcsVdiiu1nIQnB99DTyl2HLBpH+6Aw2QpZS1gTzwOQRsgX4Ctu+J8XxKzuFQkmErY7O3OS3TeJE7ToiSy5l5RJmdisv2zjz57qol6F7J53/7aYzonhZYmZkA8TdOC0s8s4CkhscxqkjbJc4Z2hkdlMY9jRTd5w9bMkFfNsz7z6Eo7xmCA9WEbYa1PN60Ne/Ca5/8s5V786XXvtX3+VPOa1c2bV61plrOkrjeuaPtr66ufXiGVSP7fvfK73z//yi480pq2+WoXcFWESqQ9ohda7gsdEzouNDak1sWb4nIs3s1XVlyTU1M8tPic+M1x98C8gdExeWOiDe5TfdPzpkcXuBf65ocW5y2M7oz/Mfud/HcK/1iyL3tfyd64Gc8tUxOhRE4/dWBohDomNC30gffT4raQNxxQcot4mYaeWxTwUqCgA0MVpDFUQYqhiuoLyncbUshIGrOMRkONC7aKJ+3tSB9aKxuNfGd7kqOfpY74sZZsGNxKgvxijeVSVh+5T/sEotMl2TOJyYL6SAXR4VdgOAsvQmkLL0IdFl58nbnwQiw2w1jl54UXsZED8qUOKy9SCy8SB/YduubC2jVf23HJBQXCgVxhng140eXoRS3KMalRTBjUmFecMSw3J1uc3N81rKQxzJoHB9561tW7F5z33sXTbuoZfnjFBY8/snzZprb52q+vnTjxenPtA20HrztxYOtB5cFXf/vKnld2vQWuGdU2X9kLrglRkfQ/gmsWeeWE3D1/kDxWvtCn1+XUFYwtuLlkXYnWN6tvtK5kWNaw6KSsSdHZWbOjs0oaS97Q90Q+1D/2fZIf6iaX+hI5tXI/32h5hG+aPF/+k+/P+e/nflzwYfR7OSip/uzCIq8roGcXqWCVvEAf6sAt1GEhQ7vpn3gCOiiFgsngrGBjUC0Rpv8SwS9BYfoPpkz/QWH6DwrTf1AIUsLonstvMGidnKBb0cXWtuDysMM0mR+LTebVh8sPmWPOWNGQrKp3lYvuTxj3XcK478q1FG1rtrC4JNOsb1v100z6jkH/wOBD+cNiD0nNFuyhegO631so2MPbkT2ksL2oob9tru8wy9yj+x1Tft32xZI/rnx+6frWLk9csOzhjSvOe6BtvuweNE7qKbnWtV358I3fnaD88tVXn3vxjTdfZLlmFZH8ArgjLIkvsyUHVWdJIVUqU/uqJ6iT1HnqclX3hN0et8efFfb4SXFLXtEZkOGputktuUvjWVKWXJr5/d302j6yzTulwX2TDKcJDrro4zvIrJbZW0+zNYyLjPzt4cze+0IzDpzLB+tyHdc6X86j0MtrAuK8qhnnSjOi21iohCzpbVH6p8mS6XKkNRXnwpi/av3x8+tOPe34oUMHnZZdolbev3TUwEe6jqybdW7rG1yHdeZHyibUYS+1RGjjqenNlK5QwHauAYLtq9KaQPqnTCrT3BVp7vI0d1mauzTN3SXNHU8JkZfUq6XZpQM9YzzDyutL55Ze4rnRc1X5w1mP93hW8XvyCvPzeo3t8WaeFpWnyHKoRjLyp7une6Yb073TfdP9C9wLPAuMBd4FvgX+LZVbugZ5a3N5t/7l04wG75zKOVXLy5aXN5bfZtzju7Xqjh4/7/Wg8Zjvga4PVm2ufL4yt8pR5kodR5njKHccVZYZzo7DjjLHUe44ink3RaSkdpq7a4XPUAvjlTmqt2dxIU89lhb0EMtUCuoKxhfMLNhY8HqBHiyIFSwpeK9AjRXcVCAX/BpslAMOFysYktkcPcSnsIWk3ZJMUkgS54Fuzs7tK1Y28OGIktRzevGiYrm4KMelWgtqhan8Q8cc/mEyi3lRLerpjRVKheUFyaz8vjWcvEZMTudbv9xNFIjvdRfEOWVBnFMVCAtdgVhmwFeHeKyRUz61faPqZnQ43XG/J4tqd3eXunPWfJvuzlkb3Z1Orrt1wCgcTzsvfXN990JRli5du/edVbOzRq6raayRa3i5RjnlW9qhaD5x6zVgVGYHl5Ad27iQcbt7zK2PlwfFQBkUDxKM233ud6xCwiVOj7KnOK3NH8lwfbD0Pcd4WNDbXkeB/jD9WwaQMxKfnzvOWaqbSCzl1RRpKuXnvBwswd8qXirW6bIVhnfxMwk7pzvnWbJ+susxJWVado/KcCgSygopeqk/HiVPlSsqacfgpyQb3i6BsiiVlvl97m5GVKrq6jH0hBqlWKiYtQLrTGfxI5TR7onLL7+cUqXhZWh8AF0qgCPxBKwkFXsrK4t7Wp917ektKCzMKRbyX077YmD+VnDmN127VnbtKffr23/AIecE4B8frSSmYeuag9dcfMkF/Spue+HO8UOO7X7LpEt/PS3c5Fs2/5IFubnV0at23FE//4VLX/+TdFzRwnPnDjuuLL+iZvTl40ZeWBVLjLr4zPyTp588oKyoOMso7zPkkunT7jvlCfRW5eaXcnftTsqTzhYWqngHi5C3w5bqdrcrza2nuQ0+ObiSbeM7k+VwNBZIJPn8hqRQbsiTCBqQGhVvMFRKpZL/MOKbfbxhKcQ3n2S63MM9w2e5znE1um52qQT1YZ2rybXTtduliyPN7LPNDoh24OKTA8QqT8tSYzvEKG3ppJZiwsImTw3Y+omlgLm2ywsoX+q/aV6G8Q8C3ef29Ok+Hqw/5w0YPFiH+/QJvZx2NEx0k5IrzjdSvHzud03Ss0iCxBEOGB4xdhs6s0CfmppqWxGoyLMWifFyj/AA8eVUsT9eDhWeOPiMRT2uumrzk09mJapK7r8vdPzc9fLs6yXXorYbrm+97aQehTzOXIlxZq9aiWJvs2bQC3nhVE5eXzmelcsHBe1PFkSy+yaypHJ3Vq5Pysr1YpgOo/6pT24Hq0NumkyWm2Z1yK3Iz2PzQKGwPeQJq0NeRCy1SG06yBNjdF7K3pCXbS+6sOfJ84RJK4/tDX6ucjNP2pkn5Y0rZBbJZVND4f5C+ZzCdYVNhWahWpiaZktN4NmTc5t5Hj8lOHgk8sQ9uz17ParHERw8KcHBnsI3xMS92JElJuuFrcEjpsk94wo6GHrtufBDjQqWECFWTg+utb+0iG6mUA0F/EE/72fmr0Uoekj1RcnvDluTZ927X25tLoQoB+YPC3OV4s3VBRvUOUuqrXWCXSvFnFle+zHMSt0le057YHzIu8UbPnvixBsHbblny6jF4/stk29t3XxD75ETJ910tVx78G1wQSGvowAXGPLsQ3ZBpR1mQIc/zEDOTZny04Vxd/tKbD6RIn2VdZ7mJsOtS3rqoIJycShldSL9vAJxXMG2fppEpeFag0dtf7jWkxsp6uvmHxlD1WZQyaYG23g9JV36UhV+hJ7nKa3oS7n4ge/t5Mqqnn0pjp+grxtVeSqNWupnjKKRRr1ULze4p3rmSfPk+e75ngvofOl8+UL3BZ7zjTXSGnm1co3rave1nl/QWs8txhO03vg1bXNtMl6m5423aY/xGb1vHKQDRg88jpFPuUYVVRoDjPGUNDxaMpLbVwMb97VnnDx8SoPOwi6ze5D5yCAx3nFdcJhQEblWRKisaT4vOKb6nQTqBng18WqCqlPHOQwwXG53hcfI9ngMUmS5wtrmrhkGGdaedd1leBSStGqf5Ct1J5NJT6NH9rRI0SeTWqMma3AlPXE5KZV6P/kDs/PnhQWtM1pnFOZ/vm+GtfSwNjWzFq7teForb+azt7W0/6Ufp8AnKIh3nX6CgtgVntVHkn7Vtuh/9lXE8hOfPdV2tlrZetWZSyavkK8WXMn7RreBKyPaZ8+As1IcydYcazO2tUDHYkKffbJMyJlh0lJrKeQUfyodpppSHBxytpnq7dtMPWnLu1JHNGypD7bHiKTFcLfH4FHBKV6HVmQVz9lnrqtph4S0T6ul7VMP+lIxIk6oyCoVw9UewzDbD3VQHTcUpdK0GO0HZantu9jDcUe5KsWTBeyo76aeTG13OwdIR1hvFoOjtZFMt20ub2zx+YVg+xEUaLjCcZ91YeeWgLU4ZGeyml3hpPAbYUUiH/QhSQ+CW/0+8bktX1iSVUMNG/a0ijUOh/kjqa+G3nw19IY4S9qe4xTcx3+W/JQbzJa6q90MeUz41PCNYSUsvoNsOB9IVh1HmAc2T6xL31BRsTUtn9wWK++r6j5Plh71FEQ0lVTd6/EG3JEQZSnZriJ31FscKKcKV3d3ItCX+rkGugcFhikj9aTrJPdY7wnBkeExkVODJ0cWuua4z4xcqF/kWu5+St8e3Br5Sj/oqfKGq6jK3zVQFewaqc4+lgZEznevdq9V7vA9Ij0qP+p92PckbdW3B15S39T/5PlI/Sj498gB/TtPkVcceucTvyHxG9At8VhYee1uJWoEgmqEwm6Xu8IVrAiw6SrgUvySr8LfYr6ZHMDDmB+9Q3dhn/JL2Vm64Q1XGonwZPVkY3p4UfiS8LVhI2yo6Cv4dVgvJvMMjurEgWrr4KvQPv5nic74H01mK+JsDpfmMQy31+czQuEwJIixmzWKQBEYnZxnBAPx58Iud9wVjkQSmitb01wBvOcKfyDb7w+4w8FgwnBnIzkf2GH3ZCRLrojqDoZ9Ab8oXgQyAH+XiLu2SJBPVDWyvw75Jf4gR6NfATc/kjTi4w1piXEZ74qWpyQ948PSkvBlYT5caUrSG9KkWWJ6WEHn98iT0tdZX88TSkXBSQdmzMiHUoD/3AnOyD/8YR12rxgWvz/irA5XIDSYscbeZDu2KTYptUHaH/fF5WfMvVAo96L9795CvYLxiPMRa7FjemxT30nt53W4zd2bXL0kEd5l0timPumHebjNvZtccetipONHAflYwd1boXIhQ4w0u5tdvTibZjpW3m5ln8oxlTwvPXnY3LvZiKtx4uv2Qgm+6RtbI7XUIyJONN2U1b6L25rp5hYqDtruqO0c6Y+HBzE6ZOWJE0OUroo0tu3p7Y/VqX0ee+q+fsdt3di25enHur2F4eLufeFd8tmta195VZ538G35kie/f52l2iDkmX9i5AjJCUue8bf3xKFA+1EeHY5uShdQcoKSV1dljy7rfjSFoFDAg9UJ0RrER9ei24IRKVhaYH3BYEJB7bTg7ert7jsDdwV3ajv1na5Xgp5gMre2UMny5PgLQ/2kgd7LpRu97urIKWqDq8E7NXCHtNZY690mt/he8u4K/C70trLH83v/n0MfGJFI+wkckXAw3x9yTuBgV1CcwGEYsn7oCRzzdF2xzuDQPeIUjmAwxIdwBIP+UOoEjpChB+WgEXqBXvDIoYrUGRwv+CV/RfoxHHpIHMNhjI9IkdH+lb5SI3i67lmZNCAybEvqE/RG8VnME5KBuLJSLh2Pqh8dvkSY0GYcsKQICBGhD0IHPj/kxI2eiRl2M5lxacg6ciMYXCNO2fit9QviEidvDLZZbUsgv7hWHIbhLa71lebVKgD7m7vUhnhwMXJqpdIutZ5kUerrEQ1iYk4sn2FvNOkT1cfCEV6us1jGOp5bkvrksWAygFfMKF2loHRV251/faBnUY+KzW+13SJd987bA9s+lquktm9H9hra52Cbr/U1aUxD2wzmuS5tE5V/gOcK5eeFxQ5vzVmxaztyHEeu4wiqzjFgkfYhO+Bc9TsOXyp+akLrkLWGrOA4t0qxtS+DrYuN7KDiVYoKghHdq2clI8G4N+mL2+xdUJ0ofKcw/9XCghATYe4UQ2x0c7BICnK9LyuqrcquD240lKQ/CR6KV/XqG+Ifl88TyfXnR7p6u/q6+vv7+vv7Be4Me6siVVmjchsiDVkNOfMj87Pm51yor/BfGL4o+6KcVf5rw9dHrs+6Jnut8aj3mdDT4e3Znxh/z/7K3xr6NtssKolk5QcCqQOkcrO8RVE1OCx4VVAJFqQewjLKRlInRA0IBn0hjC6QhQuys7IqIkY2PEEfho8Kr5Ht9RpZvPnfq/MNqChUJFcX7SiSi1rkuieDqJFkdos8OemtiyQj8szIjogcaZGGbg1KpTQ8avAlUWfJuK+Xb7xPmeAzxcE0QzdXB1FDct2WaPwSDCWowlb+sCu4nz98kB86sK8gtG/G0s8L80OfCxc47/P2puBOX6bGbcE+cmZsUwB9cH57H/y0dQ6q+RF38OJDK6ILzjbf3Tqg1igdUBtAN/FkTm3YPiS2gfVQ/miKzf/tf5SIbirgL4skjUUFwaBhiNoUMro1x9jVWs0/QBzfZMvrEAmgbV6WPajH4FF54UrN27b42XcSpbHE+1vaFg0p73VJfd+2Mx8LVZVHFwaL1arWO8+7/JIV8sKDL20c2jCJW0kVeuY30EoC0j9EK5EO/R5CMlAfaZFfdssRqcY6Z+W1pAcO6fgSsZLy2eQYOLrJVZ7qUK1Ua4yWRsgj3KM940PTpcnyZPc0z4TQImm2PNu9wHOxtNx9sec6aZX7Gs+30gE5WuCulLq5E55a90PutyQX9xrbQjl9ZQxeHj6OuyxSK8kDPYbsNowKSYb8IUv82WD5dC2BZzdORyNlHc0jxKlEwJBbpOAWSCOa/rR8KhG5eGJBzGiX+tcFJAokA7MCjYH9AU0c/FDOlwLLyVgpSRtJGk9LyCSFxBnaVBAMLe/C3SfP+liLHEOt7NiXELuGQq1swhwc+qBucOsHYl+hrYuFAr+1P6himxTBFE92kyrdbIu2as/NdQnfs9u4FrkqrY/PLW0QJ7Gw3PBuc1Ac82GRj7ZFaz3u3OhxLB0359UKw4iRWytnA4W57R0sr0LcbECQb1F6PbmIdT1N2Ct1y1jFkyC9xFEgepl1FEj/Pl1yquQHl01tG6/Maf3NkgsXSJ/eqrj1W89vPe1iz93gkmfaJkoN2h9RMSdYVilFWpnMh1J7vyzfp2xUZGUFEZ+zdr/KH/9mazDPnc4YHPoHL1PmHouCfNZbnT0DGn7mF20TXVd8s5JM0zprRHtWrqRhYEkX3UD/xIuLJgNy9aC6QfKgIhqVkKVBT8ml1I3tMEv7cSqxe1KkGmWn+pedam+X/V3kLoZI1SWVaoZIJVZtiFQn26kOOKmK9xfLxapIVZyeCs//rrpBHq89i+dfYT2/ZL60Oa+ATR47mfIS02QlHJdJjfJ7krJEuYwuU5QltESSx0sTZBmtLIRaWiOpUos8q1lerbTIk56kAvVPj1gHw7QeAC+hwtj4OEOsTog2U6P1pXSusqw+yrurPvuLukHKb/uIJ9hI/3Be693rbpkZHPyVO+om/lv/ftfuTH//i/dbv9vYemaI3BPh9ZAkUvCTkOv4tnF0Qoi+2/jdRSGyw1N/oRt0O0iuTaFJfotOU5dRDjDaVUzna/U0VVpD0+QNdAlDKaak+gSdi7gb4B8Cup3TIv4U4D1gMFAPFNphJwGnA5PYj7hPcVrc4xy+j6DLaJo7Rku0erMV+d2uvUjzgHvhXq++T4/qtbQY/geRbodKNIDjIM3t+gZai/B7cH02wu4FnQr//XBPR7pettvjuoEKmAI6wrvhPtfZz9tV+Q31V5eZf8WzNOCeY4DVyGMC6AhgLOJkgQ4F1kgv0tXSi+Z6XAelK5H/Gg4Hhtl0FO6zCtfrkK4c/ivhLkQ5dNAg0AWokp8gNGV6BrQaz3+K9dzAi3QWP3PqmVB+u0yHwirj2HQgz18DZXKt+QGoJ61smbgyA6OVPtQIuhCIAhPlV2mxeiJJqK87tQ9IYYDzuJ7eBY5T59A4+CWUc5K2he5iP3CSwDKzVb2H1ikH6Fhcu0i/Hc8xB/XdG/iaquXP6Bi9gi4Dfw3D/S8H7sU9PxL8MIcmI/+eoH3UDwQPrQauR15fOPXEdQP/5XivJyOv77lFIP0kYCTeSyOwiMuD/Ku5zvm9S/VttYi7D3GmMxCeJ4BnZ57kNJwe96qw+XB9O6X1iHMD6nUvqArkcBkcCD6zgWsv4D4FgA4UAz2BD4D1wEJgIDAWqELehHwVwa/gGeZNwR/gDe1F1CHKJnjWeoZ7xfu02sz99r04ny76E7TQRhe+J7cX0KEoyybn3tymmGccqjJ/LxR8/w9+TuapFEXbUz+lkVwG0QbBWw4FbkeZuT3cLk+hqwV9gq5knuXyOZTrhXlN1AnahE0Hpz1rL9FGQBWiMpvXr3SoUxcpehY9iHvO0s9An7KORqnLaZRyC52h7qdhSjfqqfVCGJ4HcZvkT+lk907qg3c5Hv47M+hahmuPtEDbied8HPW5h36BOl2q7pFL1T2Spj1ufqyR9LL2uLxSuA+hmZB2WteYMtKv/dTw/wvkN7XH0Wc+bn6i7TFNPM+t3CZcn0q9gLhDEd4MNALd3QlprXuh1OKaQiGd6ACwRE3SQC1JA9SdeD856OfRFhA+Rfsr7VBuwLveY/5JaqRGGfdw5dDp8u3o05CX/CZdyeD7g56TxkcdeC6Tlxzq8Gsm5T7f5qkYqI7295qNfTa+Br4CH40FTxbw2MD9sxgf0EcDq21+XZDiz5fpIdDrHP7M4NMFGfzpy+TLTCrGFvTvTjtFXtc4z8/9I/dx3EdyP8f9jBM/k6alv1beAD7mfvhVmma361IbY1DGv9ltH/0w3vcppqmPMB/Rt5iPKhHzUb0G7v8FNPMR1MUFqTF1qtlmj6fdNHsstcLJ64yjWh9abPdnD4r+5kv6mRhH60X5PPpGukw7iPeOPlCUd53dBlGfKPdCdRbq/C66Hs9RoKxBe0Q4MJ3rRLwLonweF0ALlZ+jnnksuoGuVP4MeYHT9qGwGC/q6BSU/WURhjGVKYdpp9B6/VOqUaegr91Jc/hd8XNwefjdu88jvzsH/cQe6q0+hjg5ZCDeOlEHSXpE8AWnXUjEdeGaTS7w7DjE4fvdL9IkKWLXx4OiLkR6yCLMw1wXuKeeQycLeeJTuk+bQqegDd3vaqT7oUYQ2sWjuMdDSDeGy4J0PIaNUX9Op6J9XY2+6Wr0OST4f5p5UHkcz3MB+nVAaUQdPU75WiPqcKF49mGq1ceu4fajbKBK5hH95+iHWZ74OV2rJmi4vpBuQNgNGvpJ5Hsdwq5C+02g7V6D9Nx2uN8m5H0NwjltHcsyLCNwe3ElKUtvFHIAiTKwnIL8lY/pfmUMXQ0+HuL+OephFR1DP+rPfMKibEI2X1NCdCnoALkP/QE5eOHmMfQp9XKar9ZTjdIbbTdMx6i/R1v9lu5WgjRT3UV3qy10PfvVLKpSmvD8WyBbcvjrNIHD5T/Av5amqYOR/mo6W51Jy5RN4L03yFDn4V0jnXYj+KQc6b/EfW1I79M0pR5tazXc32IcRDyRxxZzNEMdRceIdGkQZXWQUWZ5LJ5qDN4pysvuDuVFWVPldMp4mPKJ5+T7Ih3HUe+mwainvwAVFm2bKN9AjwPr5LfpBOUkulB61NyOSh6RgVHpfrWfdAnQU+1H24DL4e4B+j/ARssP2a0f/RlYhXvvBN2siwlAieSh1J8pwu4F1gKvONfSwfkcLjwdWtTc3sH/JMYaQDpgbmdkxkc990d+/dXjzO0M8OIYhn4ZZbtWULbSFeElSJfh16JoT09SuULmv49Wph8C/nqn1WMy/Rmd9wGa+yPwlzQaZ2qPDUctw38beL9hoBe71X9QjsVDlCW9ab4FWi+9SWHlPPAgAH9P+LOc+nTeE8JvE+EZ708earZxnWeGZ/rVjPd6NL+8mWamw+GDFD/cSscz1DrEBzL97pfpeIb+PK49f6hffeQomEbdlbu4TODBrof69fHUlSGXo6yFnAZtDkj5X0cfAXBckd5PIxncdhnyFuhrQOp6PxrOaK9X6s/1qtxlXXfej/NeMt8PytdbfY2GgHYFHQg6CXSMQ9t52OLtdP7IDHP6ksPFyWgbvY90z/+XgLazC3gReOFocf9TSAReBUKA/hfIIXWQI/dAPjmVdwu3oi/5vhp4GP3QZNC3EIbRu60b4Ic7jLAzQX9BdPAruM9F+B4LpqxGaZ0tVxYgbKud1m3fb5KV/uBLRN8dADZa6Q9uABbA/U8A4/nBd0B/A7oW8T9BuqtAn7Wut86EfwXwDPyfwr8ImAr3zaA5oD2ALCCC9LczWB45RA/9r9PD6x8/lkJmmY1yxtjmBXpJpg7xo6nzPo9CM3UN5/0fjWrtNoMMatUDdKa/Qe5rStd91B/QcRyK99mWDnWK2QqZ0sdyNMuyLD8L+dGmQn8TcizyJcp2KMvOLL+y7MzyKyjff42uifJMYT1flMseN9L7VukA3QuEgKhNFyLOt3JX8zX0PUHw91fQjR5kwA8e4+VGYsnR6xi7ghjrdqDf/Qr0VfiLQb9yxjSnbz2kjz3KmPbf9qs/cYxUf/qYWmNjZgaOFO7gWBujGZlj8U/F0cbu//NYfoQxOn2c/k/9zjjvwHM81TBcSXM7I1MuPUQOOIr/aHLuT/Vnyh0/2Z8hlzj+TBxyPZP3HHmmkApTyGh3PxWsW6hPtsv+Thky23Gqvdl+1NHwdKAfqLLH0PXAv9BnFAMYo8xb4V/p/p5q3L+kGvivBjAumnXAHL4G2l+6ge3bZiv8V8AfUl8VcafamHM0fs7kW5bPhXyIOhP94M1cfqoGBgERYBOw2HnXrEMi770yRl3Wc9Vp5lfqa0CGDHhU2o+WAr+EPwh/EH1xth5Gv52kR+BeDWqAGujfJ7bb+MxW/SIRh+cnRrB9Fv382eoetn2ZvxU2vTbir+zxPMqVGENjmm2ngz+HbUOuONtLzBbVss/N0r/EOHgKxkMPjx3It17MCS1U2Y77Jf1M8dIw24ac7diS2T7F45Xek0LCjpFuR34fsvF0GgbUqdY81RS2vygfiLmaNWx3V8bRM/b8VpOxge71vEj3uufQCPdlYr7pduUeuhJh97hupHv0hJhfmeKMqzwmHsb2x7bMwpRN037mTJlAlG86ncj2mPR8nXTuERhLvxR2KMuOeRTZBmP8tcAca77C/Prw9k7zd7bd8yx7jF+RGvMz7fTTaaKyEnqfY5N9GPRNOk1dDdh1nFkWJy/US+uRZCFHNoH7FHWZsBmuVq05uCy1fR5uhKjnj8X7Gs3vTPOjDQf5/ZtPqdb83FD1AsSXqUD9ArBsj2J+jm3DwCnynxD/XrTRs9FWwIPqbWIO7yobiGs+LNItsubN9ElAHco1D+k28NyRA1rVDnOfOoWuFRB2NXO9nG0+BXqu/IqYYwzac4EF6vU0Wdg02+cE89UqYbeuUicDeP/AhfCXi2e3qairJNIFabR4RrbN9STCNbcyyLaR2nFd22iEKwl+9dIIbTOVK0sgv+xEX1eEdzcG7zVIVyp/oxL1WJqthGkOQxphviZ9CgpJnSF/gvA/gd4CP8/9vkWnOfNqln2aDgrsgqwA2HO5jLkMeYPUxbJPU4PtLrbcCKulrQLOPTbQw2lAPPNvwEH5Z8h7KM2RW5DHOpQF+SghtL8MIM0ZNqrsfEaqp6CNdcQJmUBaptWZQDjTikzY4YWZQDjToZlA+NDDlONI8Y5UjiOFV2YC4ZX/hXIc6b5lmUB4mXrk8o3NBMLH/oRyHKmeyzOB8PIfKMe4TCB8XGY50D9Bj217AbrpE6D/a4/3H4OeCArua/st3NAvzHm2/3/teHcA0H/NO4m335A51Ab6PJN14DWgnwHQq82J7Wh7GbSIxJ+Tj3kb0B2ot/LitG1PW3kL2Hm2bbbSt/4S9KUMfy7woZWfyJv73u2gZcBd9vNdbefbZJW97bb2+G1F1jOKdE3tMBXgZKSPgU5qR9uTFsznQH8FsF30Rbtc7C6x64OfeRvfq71foO/Uu9BnzCLCWJ3t2mBR9WI6UfS5r3cYq84R/eH79Kjo70z0fYOpRvdDDvkFDWW5gftwba6If502B2MTQT6BrCDkhb2kqc9TgfYBzVTPpmHKVsjFI9HfIg+V52Vwb+63WeZQrqGTADFXKeaEeO7kAlpjbBHySwhxstW/o7x30g7obFdrU0lCet3VE/6bMa7fTxdoF9NF7sW0Q9/Pc6Y0D+NVTJ9JtdoVNMrRbfXF5NF8kAts6l5Ls109EL6B4uqHVORZA7luN01AnQ1w8nZkLdVF2Qjnd/aM9Q4Z3yeAE0WZUV7IYSp0a9a1xboBbQbqZI4ozzgx5/QYqdDRSfsCY/doqnJ5IHtV09WefFqnf43n0CGnJsS8/Dy77nvx/JPrTOqtraFKR3fX96GeJ5PhUJ6Pc+wBkN3uV88S8mJEzGvZ9oAUde7B822NdD14omemXOPIUSmZwrYRpGwOzvOA8viZen6bpskblk1hJ+TTHEpoOeAdtolkUrtMYh5vJ3jJlmddO2iMSwF9mObpq2mSdhLqJYsmuZ6jiGsk5bN85nIJuW4xj9Hat5BFJ1El3s0JAHQKcwGJeTGzwW7jbHN7C5iOxniaHca2Crxz04vwKXZaXDfPI6FniDg8f3at7T7BxhwrDqdtfceOz/2BY6t5z4LQQ+KUJqdq1lqq1YfQ9rl75p8RR6U/0obGbRg8kqUfOsefSW8DPcvxQ857D230VqSNA7ojR2dS1ZrvX2lRIRsyfcimDzCvsayXSbWM9SvaEdaz/IAca7Uzh3Zc9+LQ02xa6cjXR6Pp62TaqWna/kBKXj8atWxuhQ49zPoDyybXTi25PHMdjkPFOyFFezElv48R8/y8NucHoDlruK4AD3REPYPXExwOOkYShmtRR6iWnH9E6DchHeCOZcL8FwNlvtyCebeNT22sZygSdGlAvSUT5r8Elh12fd0w/RfIF3AfY8H1sgUh//8AUAfkwkjqjgiq81j4g4CUwXB9YeM6B6bJcOrdqUenXvBsH+K5z0qV2cnfvu9/+h7/0/fy33ruHyp7OmRrjZ5Dee2efthy4/0I/MsC90+Im2VDR70+DTwO7LJxGwNtpZDXKilzwU9zxXrFVJpD+OAG6KYM269Z6290HZKdK99qB7z2xwI1HK5+XHMt/nN1tepJrNuxZK8P8Bx+zVpjO8/u+8o9E+h+e51sjPsWjLvcznupv6F51EHmMydZ+rS5HuOkhvhhbTmNkF8xH9AuQp+w33xJuwyyAIC8rrLxso11luxnbpStdZA6rwMBfSwd0G1LGBzHGifNh8iSt1mOPddC29+t8PZyOX2v8g2e4yAViPWlSaFfT1DnQ6efTwXKp7gOeYHnm5TTaQiPGUp/yFa85uYCe70s2x7eBbXgR71MUB5Na9+8vobX1QBiTQ6/pxcwBnD8F0R6R7+vEvalhejH/0wxsfYH18SaHtyD1zqxXKRAo9DGgy8mIu5E8/fKWtBRNr4BzkZ562m+fBUdo8yDPrwb8k4OwpcCS+DOBw0CDcA9wArqLcIPgk++Q3xAUeH/HagG3V5D2Lc2rrfA14W+vZXmQCaeg/tZ8faINBZ0miM9K/KaowzF/RBPhqakQKJQcmy3juurkG6Hpb+zXYHji2tOHE97HNelNMKYRyOUK0GrIUcMMbdLH9NgdRqF8U79QD+869ds/YH1ptcB1JZ5L/y75Mx1Ac48uU21X9J87Tg6RmuFfPAX8MFeGqx9TXdrdVSlT8A49gSdS2l/vJ5Y5rXEe8zXHNu3A30q5Xiep5F4h8TrNxwqP86fbsHzThHjkVhLL0Hbosete4r101ZbE3KuaxhdiXY8ArD6IkvWYhunwW1PtdapVqkPUTHuhFuzDtWG2jK5PUxC35CyvTLlNW3MW7YsyDLmE/IfWK9FWQrN7fIEKrHTnkpCLzXZXv0zgG2W96TNP93O0J78z+avjub/qfNTR5ovOtrajKOt1TjE/xPnVDLXbhxtLcdR/RlzLkebLwOvsow8AuPKDn2DuQf+bcAt6F8fZKhkmsI+aslr1yhetO3l0EFHU7ltE2U7aQn6rxL1emHTX23dj7LQNw1VhW3e/N7e5yDsqWybY7lUyRf7IApVa18D35/1JLbfin0TKTttX5rCfS33qWLM4LXd0NPQ38zhvkV+mfrI31t9kLRHgLgvEnbJoSjjUEGFW+5u9ylDySP3wbPcZkEJmi+LPilg9VkK4X4t3J9h/LX6q2Kl0Oq/5DesPkh+F3EcHAA+4bka1qeFTs262WNibPrO6idFX4h+mt2su9j6U5DbIPqLIUeTl2zZ8vEM+rRDjyYX2mket9McGt+eu8FYkiXG5BepG6/tTeldRH24/rUPhb4yCtdZBmmX8x17u3hPeEfW3L6UqRfwfA6/W83W6UnYzdreSKMzLYhxmuvx75DLDIy7J4o80MeJ+Z5l5gG7nKyfFIBPr3N0vZQu5+gaRIPUe+lB5UzIQr14TZIY759J028fZIg1JC/TQ6yzMUXYq4g3yho3xBjyPLAb+D3wD+BNEnaq1j/hnU7leknpQ/fx+oG2p7S/oL5eII/7RCrQt1vyitJI57JdnIGy3cng+aIUNvC6GrEWahBZ6whZrx9mU/S5NFr088vE/MZ0JQL5YAL4ZAQdB39vuI9TL4Ws3lXMU9WrF4o9MVOUAtRD+/6qGg5TVyJetVjfO0m9mKZoz9MC7Y80W/uGHvaMoYdB71FkGqQNsfZPqOfSCNbTIFeskQ3oa8toHMaHAGSfVVwWUR7E52ui3S7FmHYNrVWfw7W/gy4B3BjHquHfT2ulT2itsgzvCXGUZ8S66bXqZ6C9cX2xTf+MsMXoH0KI9w7dop5Fbr0Bfc4ScquLgADFdOhU6Gem4x7HIk1vkc/fMSY+RzeLMhwOXKYldplsSJ+YB1CmG0G3Am87ZcmEKEc6uByZ907H3+3yZOTH4LpIB9eL+iX1RP63A78G3kCZjgfWaCd0rK90cFlT+KpjuUUdOuC6zATXrYOAXc+HAdd7OsRzL2p/DymgDvidiHdh84DyK+TNbn5ujrPfKiPzgOCRaSQ77x88eaIo94eivGvVClogyoZ8tBHoC/DuURcc5+TUPS1+ulGk43i4Jt4hl43reSN1E2V4UfDWGM6Xr3N96gcoqG9FnLeRRy7izKYykTffe7VVPpF2Pvow3EufjOsxjFUfIIyRa10T5befK1V2fv9cdtxT81tlhyy5Fm30RL0K9ypB/EsgVzKPTAFeoBH6RvGuIkoZrUV/UCqn7dcC8uww3hs2GugO9LH9TEtFO/6x4Pb+Y/GN6BPScc/RwP1BBmoyw9Rc84l0P/cfwDh5PuhDwu062n24j+L+6WjAOPaI039l5sF9GQMyQCDVr6VjHZ2SVv+i7nkttPo5/YKheyHT7KFV2vu0Sq5Ev16J+1ZSD6AEmA30AqJAsY1u9rVK2+8Gqny304iAj8cAc3vgD4Ky7I0WZUKPMe8+mgycKes5MmBmPMiJz0lvmjNBPwZddaS1LkfyZ66lyVwTc7RyHSKTZq5r2mLu1cjcq95ufqTuMz9yTYdM+DbVuAKgWVTr3cZaSlsP4q/PEC0EljHNLOfRZHHtJz438vtKyBSvWjoX6/FizuAJW/5YRtOgl7K+vxL+YtevKKLnUL4+ju7V/ofWuB4jj/52ag3Lavf15HdlUb4ngHH2NXuOA3q+9gDkryXCVprFEPJ3Ke1QqsGb29GvLIcs1YBx5W4yhH7I+uBfIMPczHtETbbVDGPZiefoWW7VrL3NvId5vj6YNnjrzWfdY8yI10c14LNhHXTWN0mWHhVr+UdYYVQoT4Qe9ih1SwsbZdNuNnXCzxb0kPWW5rdyT7pBrLu8E7rCDqHHsywShAydxVC7mv9mcJ3/ENRGKmcoH+AdprmPqi8+0hFHXYN/lDX3R+MVZRvaHsNpJwtpBAM8VGLJl0yFPWo86LegPCd6MjAyw828/rBFhS2rHDjFxq0ZqCYxP2T2BXo78j3cT6TvPeK9Q2Tp/N2d/UHqMMiIxwGZdHiam+sH8ZWu6Ad7UbZ0EfXEPVawjUP7BPz3O2A7jQCvjxDuJyA/vAS6C/y9nB4U14bTQ2otPeSaSw+Bp+8Gz96NPnSw9jBdK9LdRXfrHqR5mm7RNpifaXeibfG91tIa/RTE+wjXi+280F9qIyHrLIZ7Ic1X47hnPk3QLqVjdeh8egHK25u2ijUop5oXSneZ98sxiklvm1vUIhqqP0ZXQK5coz4AOfox0MXAmTRK+QIU4dop9jW4oROu0X8J/ynwL7auQ14ZIdwX0I3wXyE9az6gLjZ/qzwM/QjX5RcoJPIoo5nqlSIN53eF/rCd71IairpcI/xnmt+o5+B5/oVn3CLa/lPyWip1y7SIoe2mEe49dIXAbot6c5BuGRW5yfkzT8psB9JpdJts20Qy1w4eYpsYinS30UBn3MD9XlP57IQXzZ3qQvMB4wEi943oT6ag71kFautzOsL1MZBxRlCWrltQx0Kn/JLq9FP5uznib9H/EV9Dg78KeBvaJ/hWfhQ5+5Aj2hJqgrxoS/57iUKohsgFUBePJ8pdS1QAd8En7Si8qCOKkT6Ge3VB/NL9ROW4ZwXu0RXjStU6ou5wJ2YRHfMZUc9fEdVAF+sL/bR/L1RJM9HAoUTHwT1EJxoK9wkvQX1LQk27i+gklGn8PqKJi46MKWijp0BfnHYa0XQ8x0y091nfEM1eTzQX+Z35LtF8tPtF0DnPvproXJRlOWp/Be57YSHRxccSXXIJ0eXdia5A2FV4xjWNRDdgnLoZ7fK2yUQ/v8jG//443B74AQz7Ebjov4s7fJ3oRCc60YlOdKITnehEJzrRiU50ohOd6EQnOtGJTnSiE53oRCc60YlOdKITnehEJzrRiU50ohOd6EQnOtGJTnSiE53oRCc60YlOdKITnehEJzrRiU504v9nSEShG+QnaTDtIhfJFKIkrSbS8rTPSCN50+RVQ7xKD/4nl1IxxZSE0h2RY0r3Zr041qJUba7Mj+1+RulGewFZ6dacKI49pXRVipsHxZItStnmSE5NcMgxShxZVYvfOH6XABuBHYBKM5UShIfwexnQCGwEdgC7AZ0Iv3w1DiwB7gP28hWlWClqjsdCQ7oqBUhbgAcIKnn0BWACCsqZh1zzaDwwE7gJuA/QRTwOWQJcBuwA9osrSSWv+dY+KHte83WCbF6wqEZ4T7e802cI7+ZTGix60kSLDhttRRtoRevd1wruOdSiXXtYNFJR08jU8NfsHJKr5OIhc1Hwc/Aryb+loCRRjNYpOdQEyIpuhySVyObyypr7digqSYqsSDSHYuZORWr2h2uGGLIpf0ERisn/kD+3rsifbw6Ea+4bMkb+G20EdgCK/Df8+6v8V7pM3st1jt864D5gB/A68AWgy3vx7z38e1d+l4LyO1QN1AEzgfuAHcAXgEt+B78h+S/MSuKX3XWALP8FvyH5z3isP+M3KL8N19vy2yjaH5sH1NY8JRyJatsRq7AdeVHbEcmtaZH/0PxtN3BUJd40OOpppZSOpz5KaXNFb7BffvPg+bEW+f3N8URs3ZBe8hvUBMgoyRvI+Q2KAxOAWcA5gA7Xm3C9SY3AzcA6oAkAl+E3BMTlXcDvgDepF5AEJgBueXczsmmRX2+uHBobkiu/Jr9IeajxV+WXBP2d/IKgr8jPC/oyaAnoLvmF5pIYDfHiOiFNiE+tAa3GdU3+zebySMwcEpZ3oO5i+K0G6oDxwEzgJkCXd8ilzXNiEdzkadrlJsRspo8FfZjWuym5IJasPAEMGOefyoHHwYWf++L3VcrJytvvhJd/Km+8FS7+qbzqerj4p/Kiy+Hin8pFK+Din8o5C+Din8ppM+Hin8rxk+HCT4t877byrrEB4xdK8SFB+XzU0vmopfNRS+eTKp/P/+hblct2d3P37qixu5KJbt1jjdulxmekxpOlxvVS41ypcaXUeLnUOFhqPE1qTEiNRVJjidSYlBqflo5FVTRKyS0dvLXJfKlxl9T4S6lxmdRYKTVWSI3lUmNcGpBskbs0j+4jyHBBNg/hRgd63PHofYJyF9RoF/B8F/QJO/D7OmAKXxKR4qVW5IISpqWbu9dZ/p4Da5ag+TyHhM/hNTxH7wEqXtBzYKPncJPncIMgfuuAmcBO4AvABHTELkXBbxK/QfxWA3XATOAy4AtAF8X5ApBpiV3EjaJgXOhqu+DjAVV+Dv9K8a+L3CVZHCoKJUKjlJuKpGCJNL7ELJEHUG4uEUXC7nCL5N/6b/83//aTZ4hHvlG+ibtu+Wab3tT8LbpuaW1z5dOxITnSHVSigvOkWqqUKkCPpWXC34+K3Ez7UpH8OGhNc1E9kgWbK3vEtksBTrU19m3RvtjHRS0ynB8VPR17K96iSs2xPQh5fGvsjaJrYi9Xt7gR8kxliwSyPS6iPlV0bOyXu0TUy3HhrubYSiZbY5cWjYwtLBIX5loXTlsGXzIYO7lyWmwU7jes6IxYchnuuTVWV3RabLAVqx+n2RrrhSIkLGd3FLZbkci0rAQhW2L9pkwZ0CKdlezhut011TXe1d9V4+rh6uKKuYpdUVe2O+IOuQNun9twu926W3XLbnJnt5h7kwnCC8zWQ0z4VF6JVOEOyfwrjhhHu5bcMo2hpixlrDx20lBpbNPO2TT2jHjT15PKWiRj4rQmrWyo1BQZS2MnD206NjG2xWWe3DQgMbbJNeHUqZsk6cYGhDbJV7dINHlqi2Ry0KpoU+SEqU+RJIVX3RBlWrXqhoYGys9dUZdfFzk+XDti2GF+Ztm/ifa//A7u4qFNt4+dNLW534YNxUMbmmqE2zThHtt026T49KlPSV9K+4cPe0r6J5OGqU8px0tfDj+Zw5XjhzU0jG2R6kU8ikv/RDywzj9FPDdGaY5HcXeJFe8uK14F0iNeORPE83ioQsSr8HhEPFXieJuWlQ8ftqm8XMTJi9MyEWdZXjw9zq4KxKmoEHFyG2mXiLMrt5HjNB0vohQVIUpJkYgiFVKRiFIkFYoo9e1Rqu0o16SiXCNyUqT2OEVWHP9eJ45/L+Ikfuzf3KGJhLR5UMPs6cPnlg2fVTZ8LjCr6boVZ+U3NZ4Rj2+a3cAX4k1K5awzZp/F9PS5TQ1lc4c1zS4bFt80aPphLk/ny4PKhm2i6cMnT900PTl3WPOg5KDhZacPa9g8ckLfAR3yuiaVV98Jh7nZBL5ZX85r5IDDXB7Al0dyXgM4rwGc18jkSJEXCVafMHWTm4Y2nDDdoptlrwG2nRXt0jA0N3TO8YKHB3XJXxndDtHlUfImGpp8ZUOb/ABfOmbIMUP4EpoWXwogOGhfyl85qEt0u/SofSmE4HDZUEosP2/ZeZQ/fP4w6/8y/CFo+Xlc4dZvYtmR/nBteFPy9GHLlhONbeo+aWxT3cRpUze5XAidxY/UNNAJ83qHt5g7rcCeCBzIgYqSishhgznM47EjHvr+z7PpCdwKGuWnN0vJEmk5LWtQmkrGTpbRI0yehmedPm3qdghWPFYsa8ADLpMS0jLnHnaxEwmy/MTP7GD5ebbLrovlNrVSIskyp0pSf1xZiVSNLRe3FdWZmD51SEDpr1TTEMjOvUCPAT0GtAa0RqlORipjijwg5nEPiHmNYTGXPizm3LUhQf8fUvwYWQplbmRzdHJlYW0KZW5kb2JqCjgwIDAgb2JqCjw8Ci9OYW1lL0NLWFlQSCtUaW1lc05ld1JvbWFuUFNNVAovVHlwZS9Gb250Ci9TdWJ0eXBlL1R5cGUwCi9CYXNlRm9udC9DS1hZUEgrVGltZXNOZXdSb21hblBTTVQKL0VuY29kaW5nL0lkZW50aXR5LUgKL1RvVW5pY29kZSA4MSAwIFIKL0Rlc2NlbmRhbnRGb250c1s4MiAwIFJdCj4+CmVuZG9iago4MSAwIG9iago8PAovTGVuZ3RoIDM0Nwo+PgpzdHJlYW0KL0NJREluaXQgL1Byb2NTZXQgZmluZHJlc291cmNlIGJlZ2luCjEyIGRpY3QgYmVnaW4KYmVnaW5jbWFwDQovQ0lEU3lzdGVtSW5mbyA8PCAvUmVnaXN0cnkgKEFkb2JlKS9PcmRlcmluZyAoVUNTKS9TdXBwbGVtZW50IDA+PiBkZWYKL0NNYXBOYW1lIC9BZG9iZS1JZGVudGl0eS1VQ1MgZGVmCi9DTWFwVHlwZSAyIGRlZgoxIGJlZ2luY29kZXNwYWNlcmFuZ2UNCjwwMDAzPjwwMDAzPg0KZW5kY29kZXNwYWNlcmFuZ2UNCjEgYmVnaW5iZnJhbmdlDQo8MDAwMz48MDAwMz48MDAyMD4KZW5kYmZyYW5nZQplbmRjbWFwCkNNYXBOYW1lIGN1cnJlbnRkaWN0IC9DTWFwIGRlZmluZXJlc291cmNlIHBvcAplbmQgZW5kDQplbmRzdHJlYW0KZW5kb2JqCjgyIDAgb2JqCjw8Ci9XWzNbMjUwXV0KL0ZvbnREZXNjcmlwdG9yIDgzIDAgUgovVHlwZS9Gb250Ci9TdWJ0eXBlL0NJREZvbnRUeXBlMgovQmFzZUZvbnQvQ0tYWVBIK1RpbWVzTmV3Um9tYW5QU01UCi9DSURUb0dJRE1hcC9JZGVudGl0eQovQ0lEU3lzdGVtSW5mbwo8PAovT3JkZXJpbmcoSWRlbnRpdHkpCi9TdXBwbGVtZW50IDAKL1JlZ2lzdHJ5KEFkb2JlKQo+PgovRFcgMTAwMAo+PgplbmRvYmoKODMgMCBvYmoKPDwKL1N0ZW1WIDgwCi9BdmdXaWR0aCAyNTAKL0NhcEhlaWdodCA2NjIKL0Rlc2NlbnQgLTIxNQovTGVhZGluZyAxMDU5Ci9JdGFsaWNBbmdsZSAwCi9TdGVtSCAwCi9Gb250TmFtZS9DS1hZUEgrVGltZXNOZXdSb21hblBTTVQKL0ZvbnRGaWxlMiA4NCAwIFIKL01heFdpZHRoIDAKL0FzY2VudCA2OTMKL1R5cGUvRm9udERlc2NyaXB0b3IKL01pc3NpbmdXaWR0aCAyNTAKL1hIZWlnaHQgMAovRm9udEJCb3hbLTU2OCAtMjE2IDIwNDUgOTM1XQovRmxhZ3MgMzIKPj4KZW5kb2JqCjg0IDAgb2JqCjw8Ci9GaWx0ZXIvRmxhdGVEZWNvZGUKL0xlbmd0aCAxMzU5MQo+PgpzdHJlYW0KeF7tfXl8VEXW9qlb93Z3EkJC2CIBupOm2ZKQEDaBQDorgbATMGFQEsK+SDTAjA4KyqAYxAUdFEcBHVEGVDqJaEBnRH3VTx0UddwdxRHXcd8XyP2eU/fe0DQg+s38836/7ua5p5ZTVae2U6fqVgcSRBRDq0lSYs2KZb5us7WXiehmosQ/zK2dt2RJZcoUonY+otjKeYsvmNu2blc1UcpK8GyaP6d69oeTb55L1LUD/IPnI6D9uDNmwz8W/h7zlyz7XeCVba/DX0tUnL14aU01xaatI6reBv/AJdW/q02e6dlDdMc/wO+rPX9ObVPOxmvh/5oo4TrjKiJjLHmBrvJ6SiEy3wYOAx+0jDGPGIvI37LQPCTbI/XdNogCtIm2Ug/6XPSnR2g/jaE7KJ8m0vU0ip6l3dSWLhBPk05+KqIdFBBe0qiEOguDNtOrNIPOp3fpEPWmMnpTJCGfYqqlTjTU/BDPMlpn7gVXLBXSPbRPLBZTKAvuUi1DpKPkq8391Jl6mwfMV+C7hd4VPcwGKoXrPWpHvWgVXUtJtJCeMo9wC9EsulOsFB9SKlXRen2gXm8uouG0h14UZXCNowuMV2L20GKk+rPoLPabb5nv0990QXOQ06W0DhI30n6tnyw0tpGPetIIGk/ViP09vSrai/4yaPYyC8zNCL2TvtTStcelG3Kk02iaSRvoVrTGS3SYvhFxYpC4RezC9znxqfEKZCuj5XQhxsUtaL076S7aK/qL/lpnrTNaqzP1oamIu5q2o/wmOijKRKXYLx6W243sljyzg9nRfN80qS9VQMKt9DDK+FpkgwclyDS5TO+uLzNyjl6CGs7GWDtIz0GON9Hu39D3oi++b2sXa6vMs8wd5ruQxUNeOpMm0XRaSivot3QbevUR+h/6QvykxYDzWf0x40Ljc3Mj2rYnFUD2CeCegrzXo5caqRnfl1DLdsKHWpwpxovJYp64WmwSzeJV8arm0lK187SPZEg+Ld/QBxuGOQw5daLuKNdPZ9F89MDFaO2NqO8OeoyeFB1FT5GJGr2E9N9qw7UifP+sPau9KdfKq/UjxmUth1r+3fKTWU9ujLJRaIfltBOt8JnoBBn6iIWiTrwDya/R7pVtZaL0y0EyX5bLSrlOXi//j3xGP1/fpb9mjDaqjV3u6pZzW54zy8w/oC0EuSBXL8qggTQE42cuRtMiyFeL7/m0ki6heroK42UjbaNdqPdD9CS9SP+kj9EDJFIh8wKUvgSjbq24Ct/N4i7xsHhMPCneFt/yV0vDt7c2WMvTCrUSbZ62Ft/rtYPaS9oHsquskavkany3yPvkqzrpum4aOfiWGuuNO11Pu3u7S92zPH8/8snRvkcrj77ZQi1dWn7Tsqnl4Zb3zWnmBZA/QJnUD5JeDik3Ywxux3cnRuJ99Dj9nV5Wsn4pNGFgxCcLP0ZDBnotT4wSo/EdJybhOxXfs8R0fKvFLDEf31VitbhUrBF/EBvEH9X3RtRtu/iLuA/f+8U+fF8Ub4n3xEfiSw2DWJMYzQGtl5alDUVNC7VR2gRtMr7ztKX41mrnayvQQ3dqTdpe7SXZXgZkpqyW58nN8h75iPyH/EHX9Aw9S8/Vp+nz9DX6s/pz+iv6T4bXKDbmG1uMR1wproGuqa6Frhtdu10fuI64Xe6J7lnule5/uE1PANrqCdR7D4V/slzPijqjg/477S3Mi2RZa1wupqLFXFq5XCyvks8bc8Xn0ideE/VygVxk/lmWaN/LpWKa9pBIk15jmJxLV5Ipdmlva19r7+sdRbn2oeitXyvu15bKQs3FhRgv6B31NcYHRND1w7SLxH7tMblGrjH/SsOMLeItY4v2HPn0Q1p7eguz+nLtBiR6RlugracKfaDxEy1Au//F+B3ae6S2TvSV/9C30LvSr30lPheboDUOiDF6D+0cbajYBY17VHSnT8R5VCv+SEHxgPinaCYhdsg7xVitDXorpMWLIViGDshU8Q8ZS5Uso+ipdRQTtc+1qfJB10E5SAhoiefpQiFFNq1sba8WOhcz4HqtF3RaMbTJCyKHkukG6PuvWx5kjW28YqzHOLtVZtBkyqaztadpGObGu/hW0GWUQ/swBtdRtnYjrTRXi9nQ++OgPzVqFgspS8RBW3aGbKuwXnTS0qALZ6LU76H/n4LWLxOf0m+FDzNrP/XWOeZKvRiaqQr6dz2+s+ls+G6mja49xgs0QXQm0n0tWzDK36BzsOa8g/K7UC7km0636hmQ2gfNfB5S3NxSSkF8L6OnhUYXQeaRmOcT9VJo3k3mQtRwAdaosVgTn6QF5g1UiL6bbK4x19NM81ZzBs2jKeYO6N8VZiMNpsuNSm2aka4PhI59UvwP1qPXxXro7VJ6DfooIJLpI3zvgfwjjQeoXn8ZujPPvNJ8kTqiPdLQQrOwih6mJfQp2q1U7qcBLeO1BrNE1mKFeosmmXeaXhFL883F0LwP0na3Ad2zmrob2zF21+tztWzI24c6iSyEzjC2ypflF3otRT/RT/QT/UQ/0U/087/v0wnfzrC3kmHFpGAP2wcWR1/sTNi+z4JtMxC2xxDs3IbCfhkOO2cErJgC2D0lsCbGws6agO8UfKdij1WJnfcM2EtnwzKaiT3sbFhh87DzWoDvIlh5S2EXrVC7v9/CHroYFtlq7HUuhYV0Ob712M1ehX3/JlhGN8B+2oY94p9hrd0FK6cJO4tm2kt/w17oYbVvfAw7jSdgwT1FT8MW+zs9g/3n8/QC9h6v0euwzd6kt2BdHYJ99l7wrLXL6s4/r3bpuUsWL1q4YP68uXNmnT21fML4YN7IEbnDhw09c8jgQQMH5PTPzuqXmZHet0/vXj0DPfxpqT5v925dU7qckdy5U4f2Se0SE9rGt4mLjfG4XYYuNUEZxf6SKl+oZ1VI7+kvLc1kv78aAdVhAVUhH4JKjucJ+aoUm+94ziA450ZwBi3OYCunSPTlUm5mhq/Y7wsdKPL7msX0SRVwbyjyV/pCnyj3OOW+Rrnj4U5NRQJfcfL8Il9IVPmKQyUr5tcXVxUhu4a42EJ/4ZzYzAxqiI2DMw6uUGd/bYPoPFIoh9a5eFiDRp54CBXq4i8qDp3hL2IJQjJQXD07NHFSRXFRSmpqZWZGSBTW+GeFyF8QSkhXLFSoigm5CkNuVYxvAdeG1vsaMvbXX9mcSLOq0tvM9s+unlERktWVXEa7dJRbFOp84eHkY15knlRYcXl4bIqsL05e4GNvff3lvtC2SRXhsan8rKxEHiEtUFJVX4KCr0QTlk3xoSxtbWVFSKxFgT6uB9fJqt0cfzGHVC30hWL8Bf759Qur0DFd6kM0+YLUxi5dgnvNQ9Sl2FdfXuFPDeWl+Curi7o2dKD6yRc0nRH0nXF8TGZGQ2I7q1kb2ibYjjbx4Y45rXHKpdjZVTa5tV0FS+QfjeEQ8tX4IEmFH3U6kx9zzqT6mjPBhk+lQKrQbPTHglBMYVV94jCEJ3L6kBFI9PvqvyH0v/+Tj48PqbZDXIHEb4idPEpaBxriHXcoPT3Uty8PEHchehQyjlT+QZkZK5q1kL820QeC5qOJaNvqymFZaPzUVO7e9c1BmgVPaPWkCsvvo1kpjRTMSq8MaVUcs9+J6TiVY1Y7Ma3Jq/wYx/eqA8+OIU/P1n8JiZ3aF88fFhKdfiZ6jhVfNsVfNml6ha+4vspu27Ly43xW/JmtcbZLWBFo8JAeQEuN9mPoTZ5ewQH4ZwRK/MULqkox1SBjqH1hhUzRKi2XliJVVhi/M1pzZk9FG85LD7jU+J/d7PZgAKsQ4SsJJVaVWs/K2NTUX5io2fycUylyLJldp9Cw9OP9w4/zHydem3oJgfWeWln59Pr62OPiSqCs6utL/L6S+qr66mZz9Sy/L9Ffv1dWyIr62uIqp/ubzX3rU0IlV1aiEvPFsMwMP8fU189uIBkorwgFUxqEcgwpXF8ZmpBe6Q/NSven+ivmoJCGYdQmtbyqEC6NChr8Yt2khqBYN2V6xd5EIt+68opGTWiFVQWVDT0QV7HXRxRUoRqHciB7fOzBNh9zqVHzKP6UvUGi1SpWVwHKX9MsSIV5nDBBNc2aFZZoFdRTFRQkDTG6FRN0uHWEeayw1RZ3b5vbg5hEjtlHWDVIRVqfBnjKK4KxQ4LDgsODI7U8DS3CQY0I2Qfe4YKaRoo8kdKAPCer4GaxumF4MGWvymmyzbkanBy2ujUMkjNbWEYoz6r41GM1mDq9omkkIX/1BEcBf1hfQojwmaDUC88CpUtrsIDNBeUpXOXHrPaPadDGpysqFK0f4y+eDQ4GVohBkCrVN7uSufw8OriHT8kkwphY76nM6xOHOz5h++DBv/rQvOO981u9JQwsqIF+1gTBeFZjMzW0MCW0uDK9laU6tHqWrx6DeBiP5GEq8ShGFSb2qNDqmmqe45j0NX4EjEGAr2JWSmolMuR1pZ6X+ZpqJNN7tpYUOjf9uCwx+EU5itYCXJ3Q6om+qkpfFSaLmFSBieoLGaC+uVjr/dU8QSZa9ZkIXQVSXT8FaQkdUZkSckNjza2e4+fpHeKOtVrf0k1jQjSlIkQp9fX++pCAiIESMCP7niFXz9FM8K823V89h82QuWyFzLFWSIirWodzSyn2p1aCRQuotkTDYUTN4kdNPRs5Z1eloyXa1SfV+4bWY2SfjUmp96yZVoUJ7Ev0lfhUV1enwIdGGM2+SmRkMcYEmBHp1b+eoSXpDWe7A8dC1L+l6RazR+Wq1rzQRIfFrf7BcV56SOt8JiK58oL1saWdufGMwGg0bxCjKoVT+0Jaua0prfSjOWmK02FWMoSoqamWU+iegFg3MXzKzwi1L5v8mxQ0bCbbz5roSmR0NYgkuWlxaG16RYMmHtD+Ri5yaw81kqE3a3+7V1Ksmx17BJ3hcRkPIV4jKfpQjFgkzqHk9MRvc4/mjk/8Onfc0VzKgzvxCB79s1MaSG92v9y0mIQbtGGxoOSs9Kz07P6Vqe1S2wXwEF11OuKT+48EDfqJfPp+lovXQNc3j24b1atiZkLuN54zPMrcv+2dbo8wfWHRSOOnZUevTDzHM4n47aFQKVQ6d2pLMZ2VSD8t++H5xHPs8NZPu7GuoVxnVN3BTjosi2itThQAFrt2UqlrKFTueTQJceVAP4Rfq6+hAPjPhX8K6LXaUJIIHwN8DmQAUwAfMAuoAMYCK4FJ4A0BV3EeDuQGmuE+h6qNJyjRmEZpwBi4/fo71Fevo1S4S9mP8gbIbtQX7jTE9XF3A+8T5rscD740xTcN6epoNeJHwh8HJLk3UApoAtAe4V2Qzw6WGbRMPsx1NT+DewXkGA33T6AlkLUIdCzCJ8A9AohHmlxtqFkDdzu4R6Bt2sHdBihGuh84DfjjIeNsxHeAX2NelBsPmsK8yLOPfFmkiJvoVvkyNejl1EHV+wlqy/XmOjt1YvlZplOghOULhyWfAsuqHZPtBGgRmCMHqL66xK7rzdoBqpXbzC/h9rs6UDHD/TJ1R/0+Bobqs+kMdzfzA8g42riXBsHvAZIVOM+b6TL5NQURl+7ahHEzm0Zq/RExyPxR+z11cwVoFOqL9qZekL2Sxx7GQg/wTVHpZ1N3/V3qAneQgVH/nmojC6Xo+zLQQrT7px4yP0EehQzksxd4GOk7o/wsbgPudzGtZRd4P0Tcb4E6jJEzgM6IX6/G8E56mtOjnHwuw+oHSlRjEOCxB+Q4sPvHQZwD1f47FToBnYEhAJe7CXgAGA90Yx7k2wn83SHHxTxmeGzy+OCxocY/xpMas9yPdWgbHmPWnNmuzaV1QAcgw0V0mY2+4FXzhfuRZea5wHnz2OIx41DE97TH/cdcTx5TYdRvZKiy1RzksRVG+/DYZyqDqg59tP00gses1dYOVTIU83zkOeFQRx6en2qOgMpF1J7bjvvdoU5btNJtFEDcWONVGqX3p7PkYxj/M+CeCDoE7bNFzcHP9D/SYW0tae79lIG+5Lm7OYLeyHC/KBYiv/1oy576Adqs6Itamv6iMIxd5ofGLu1iC447nEZC7LfimDLC435t+P8LtJeMXTQX7o+MF01Tf5E28irh/rfIBnwORXgjsBro60kXN3oWiWb3VErEuPkaWKoHaZgRpCFYePL0jmreBRA+FXkP0Behr1/ESrefrpBT6TbXLhooX0Q/oiztJVrD4PxBa1vHUeSYO3EsKeqM15NQngPxDlVzaqj5pppXQ8231JwcarZYlHJ5bWD9bPD6QEo3t3PGa+u4vIV6ym/CxmfEOA0bn8ORLjFyXEZSe22Jd+Yp0nSCO4Hrr/TjNDWflJ5DXKPDH0lb0++kZm2n+TrXH+NyujOvgf5AAPGP2noEehj9zWvHBnOG67fmDDnGnIF63ue6HPRLs0nrZTYYzpoaoBxbl3Ux7LWU28k4QF1b19EATTAsfRbg9VTfgTXcWkd5fiYY71Oy8aXSbTlKXp6HPAezoPd6YR3/1vxRT6Jz5RUwojAvORxjZBLH6R7qKN+Gzh1Dy+QW8wV5rdJBxbKFKmU65jDSos2SDY26GkVUhjSk8mMeUA5j+V06xifrglL40VeOXua+d/1I8UAv41MajDoHjJ2qrqw3EvUbqQe3g0q7HOsK8nKnU5KuUbrNE1BplsBeUO0BHRjWFvbaPJLzdE1WYzZBpRlg/uhJoqEM4w4ajPIDqqxSGu4ZSj2NaeanPBbQLuPlE5QtS8kLdxc17i/HGtUH62Up1kdAvgO0YGwmWn6uu0XNH9R6v0qt522MLDpLZ3uC41zU3dWH+jF0P+KqKFPegXyWYlz9CPc9pqnsg39SOy4b4SW2fcJ2gqbmy3NI9yRl8hxjGbgMJc9NGG/PkpfXRPdtaMNYiqdf9DGt218ksLSaz2iv0jTQ4Vo5HcKU2Q33IrYD5Ws0U96O/ttNqXI61u/HsDYOxxo+Bm11kCrkM3CnIXwLsAK23zJK0BNotvwX+HIQV4t0B5DHbYhnXIY0b4DeQyPkU7RA7od98C+2EShVXw56NlBEheIuWqT9QItcg7EmD7fzZywzKxVug777l53WhpLVwclkvgC23UnkVbKGy8kynkQ+JQfyVenAo+uUgHZ6AwhYtGWStoF2Adu018A7ji4QO8x9aOSSCJSG+/VBYiXQTx9E9wOXwJ0B+jdgt+Wnm4DXgbXIez9ok0tdbBKkFWA8gyJsC3Aj8LQTFw4u52Th4TBSzH3H+fdgrQHE1+Y+RiS/fgkNRnmD9RHmPob8EGsI4FpFHdwrqIPshfDuSBfhN1Kg5/ZQD0nmd6eT6eeAT3ZYOwZ/SR1/KXju8vp8Or7/NrQN5gH0cZaS4Ttqb40h2MYvmS+DThMvYd1eDl0KwJ8Jf3unPZ1+Qvh1Kjyi/zBWiNs8MjzSr0f06+n8WhPNDIczDlrHw0YaydDzwA9E+j1P0kiG6zHEPXaiX7/zNJgOG+UmlgljsNeJftcE6sXQekDWLpwGcw5o9T8LvQowr0ofj/US4LnL0O7FWgy0xg+CzgfC2nUwt6u8yYp3+sfpl8j+gXz99WcoH7QnaDboFNuvqDMWnLEdPj4iwxxdcjKeiLmRfao8/38C5s5TwBPA46fj/U8hCGMVSATYDtGHYw8+CDbnND6qOfp3oiMdQNtjXcDMO3II7n/APQtIh/t+hN0Iug4UquZIC8JNrCMSdIveBfY70ToAebTUWmmPfgv81srj6ANEP71iY5mV/siVAPr3KCyzI/cCO4B7gCKkcfK5Fv7zQB+Ff5SV1xG4j74NXA6UATdY9Eg9wPExKONltkeME/eh/1V6qv3HL6XOPsOhRuQe4tfQ4b+IHrfXcPr/dNSw9xInoaodbPldYfL87B7HoRg/MeGALe1nm5LtaLZl2X5m+7GV8r6tVNH2dj4OTeA1kG1ntl+NAeq8kfdA6WH7wWJn3QjXreJr2gIkAik2XQSeH7DXeQa6JwE69RvU73YG/O15XQNl+/NZuBOw1j3EPKAH4O8G+o2zpjm69QQde5o17b/t13/lGqn/+jU1x8bMCJwq3MGZNkYzItfiX4vTrd3/z2v5Kdbo8HX6P/U767yDmJGUw3AHzX2MSLv0BDvgNP7T2bm/1h9pd/xqf4Rd4vgjcUJ85Nhz7Jku2AM7iJh3vxa8t9D3HLP9HRki53HrfLP9aKPicEAP9Maa1Qe4DfgKOqMbkARshP9izxEa6LmbcuDHumryPjYPmM1xoIPFBii3b82j8F8Kf6J+QPFW2Jh9uvEcOW7ZPlf2IdpM6cFrWH7KAoYDSUADsMTpa957oux/aQ8S8T5Xn25+oz8DRNiAp6WD6DzgbvgT4E/gdyIurPB8rgG9vMmmpN7TOGd80PWutYqnSOd3J4+p874sXaOpep25xLDOUpJcfShec6szOz5fUed0WIsy+WzItY7DzAvttarUPRf5r8M6MAD58tk3n4HX0bmyG9aHHeTT9pNunyGTc5bM51O8XrnylBxtWs+PJ1I6kCet9yYTdes9VV95JQ2UVfyuxvyBz921PLpVtFAs5DscCxljysnv3kBFMKL6uLsin/NphOew+S5ss3ddQ9X7nLHOusprouMOO/srVW117ExT1Tls7VWU5UO6VD6PCS/XSefejLX099Y5XfhabpzCttF2mi8gr1udM9LI8iLP5SPX+hPO6S+hMtmHyg3nTJbX7H/YstttHCmLUxbG5McnlH+MKtsE/LqehT7LMr/jMSat9znqPZxuvYsbZug0ls8bgaB+LwXleipGPbNbebapd1vtwMt7bOedWwqPL60XBUAHA735PFi9w9iq3uHF2GiHMZCtZPnRem9mxAJ87rhElfPVMahz2nh1Dg2/fB86jcHnapCHIS8yrwd9h9tOc94Fzqa58pHj3gm2kV+Qzm0nvwPQ/0AucLY9Ts+251apOjtEfVUdYVOhT1dB3q9lLfSF1T6K17WIilyPAC+gTdZC/99DHYz+1ME1jibol6POFwLdEP4q7NiN1B3oKUaaz4u/UnfAYGiV1F0uwdyqIp3P+7WPAfu9mnU+Td8xxBGkAcLe5U5haDtFqnU+TStsdzfLjbChdJ+CnQdwRxjAZ34m26K/KlB2OfJvgowT4UY5MhHjIgJIM8sG2+WdedzoZ0FHHY/CSCAt06xIIJxpIBJ2eJdIIJxpQSQQXnASOU7Fdyo5ThXeMxII7/lfkONU+fojgXC/fmr5yiKB8LJfIcep2rlHJBDe42fkGB8JhI+PlAP66T3gIexLPwXFXtq83gozi0CxurS8y+fYwFzbf8jmW3cM/DF/A5xtpTNnggd7XvNj4HZg0jG0PAzUW2mccszLgDm2rfCMlbblAatsJZ9dpkrryPpwhL8TsMcqT5XN8u8D9QM32Tz32+U+YsndciPopRb/0cNWHVW6R46Bzw3MyYj3giK9+TQwBXADHQE+N/gBeBbuM0DfBPg8oi/8g6x2aXkVeOOYXqDX9CSaJL9Va2N7t9ei+mClcwlrXWzYWnUudH43rEmp8jrqrP8J+utm6LXXKFY/l8iFfajS359gvUgH/xjoig3gnwY/YAShM+8A/43Ij9/DHEB8J+hklKH80Jv2e8NSOQJ6dwT11q33/wG1pkLfxlTDfmkH++QcpKug7u6/US9jEWWCh/RmIk8hZLiLMp29cMwurN+/h02vUQzWTTLeRzi/27Lr5LqUhun30VCHeh6FvYP1xtWF+kJPF8fcS6WuaXye1jKktWzb1tLuou4IvwN40B43wJF0gNfcgHovBBtNPgrK7/Fg2xjxCPeSl9938Tsne4/udY3G+rGJ2riewXw+Qv08BRRwTVR7+DJ5/Lvbkfz+yVUF/hdgf9h7d7cbbTiTYh3K9kb4eQDK7Mfv1NR7rWPnARZ18uD3bdY7rzci7RrHjgqzKdQZgVOGUx9FN6i7DwG7DIceb2+U0nD1bmynulvS5gRqy8Tv8fhdmmPPus4F+gKLaK6xncr1G7CWb6Vydz5sWp3asH2GNVaVx2u0cS3s/IPUBn0Dm9zMBpaQei9mok9NPo+oQ/+9DMzAZKw5Fk4T7bk0Af6RNu9KYIHl5jjzd3b4SDv/BRYPpz36T7iX22XZZzUt/7JgXg2kUpidqt6Jwr4/CW2163Wy74L8DD3d2VkrxRzGGJlgHLOHj3vHfyqKNLDjzI806+yK7VTHjj6O6mH3U8D/oU3ft8MTeKyxroikJ95fOcV9llNQZ561zrdI+/pU92BOTqtOsL+Po9jT2X7jF57dgSbZ7aToSe4fWGdyx6h17yjyHo5D1X040zQcO5bPFYdSJ74T8HMwrLtuia5y6O2TwLbvT4BxBDoUcOceD75j8HNwYcVkeHwnh8b7AgVztw3TxgsM6FBiGPLkUH1/Ejj1cX9vI9uCuufwM1Cy9j0G3n/8HLD3J4b7JxtLj4fT7k47Ou3i1NuR1ynfyfc/7cf/tF/+W/X+OdnDgTn5OvCKTfnuXqeTyc1j0NUeeBv4TtksPJ972eiEMfMF8BzwlY2DCtY9lU7yfzAGXiMKT3PCOOA7MQynT6z7N+3d0OTuASjzSk7PulDpwxUnbZ8DkC8LOAzkII11b4dtr9f1z6x1neHoPs9Bdd7A857v1o7k8w6Mi2z9YWJ78GkbbPvdr/bT1j3YBEvfUZHSuXx/6QroKBN7wk/UXdGNNp6zcYNm2X7jbXTkeyCgfwmH7Af7rJ9KPwzl/R7YRpa97bf9QEujFd4q29O6c0fSIMPoA8BukM2UKV/AGM/BWg7IqwDYC+o9zkw6Q58E/9WwrcLu3IA/U5+KNOOAqcqmGCkvPja31f0avlfD4Ds5Y8EfC1twBGiMukej9vdqX4+yUJdifQIlqLs/vEbx3RrkoQ9DGOwiWYXxOh7jIhn1ZtSi7t9akCuAy7AP3gz8APdOhH+P9p0MN/bG8nIA9qgWAu6EexToe6DbwAPbWMuGn7EGYV7QC4GLgHgL4jML2nzQCaAoS34Img+MB9rYdLyVTqwD3Qqcb/NNJ0PbABTA7QVNB70bKCCD8xMv2fzTw3jOOcbjvohKYufC5l4DmoVxmW/uEx9Srj6d2qFP40ntH1qesfYtLU/Cz3sMto22wP+U826i9b2C857cpoaLZuqXYa//BfZ9fK9nGyUYw7GufkyFRgal8rkFhX34PjGfIcip5HbOvh24Kqh9zGPQocR/BknpfkW1XerlGImpVphyY7dFu6w8eZ45Nq6rE2mu/rAj+ynbie/m8b35S9g+UTY21ny1vhbT2fb9qQLU83ZQngtPY7zEIs0oe/6O4vtsPK5sO/AehlZLFVwuv6fQJvJeQaXlvSn2pCafVWN/a45BvjeHvXvaxDD2/Gfvrk7n/7Xvpk71ruh09zJOd0/jBP+vfJ8SeW/jdPc4TuuPeN9yundlGKc7dOv3Bh2O/Q4Bfb/TfJCBcdQdOvqvtq02QtuE+foY5btS1XlkhrX2Q1ey7poNPQib385vgv640uURv3Ewf9Ds3zbIOeqclMNTlI7jM9+s1nPa1jNaaf8mQc2nP2B/iCHJezToIkPpFcY4WwftYph3aKnEZ5KsizqK5aCTFLqI9ZgNE2wd1Rd1+aOtf7aatyv9cp2to661zgzFXnOjrau8WJO6azcBU2w91B+UcS7gA3qr/fR1FtS+7EG1LrHejLfznYx0cBvWe4xErDW5PAfRJlNOZyth/T9g2wQODth2gqKnswnD0n1xMn77vc0YrDPtef/GNj/f63X2XK33orcoXVMUdubvnL2rs3amah233+tH7gn4XQ7WswJnP492etw+53HoTAvqzEet0e62MJOxlnLe9h4sEzRWt+7U+u19A/+mw9nvOfs4tc+Qj1O+UYK4GKyXW/hdgjmcrHM0j71Pvp3B44zvdrMtw9S2FypB/w2aQNY5G++FPwG+gbut5T76d8PawxW17oX2EOyMlo3Gkwh/HHulI5TiukH9piakfUU9+fdQDKTZzEBbHg4DdiXqHhTkpP6k7h5QkU2hc9VZxhCdf3PzNhVor9O58hEqkJdQjnyeesh6Goi4Cvk++uRlWgj3JH0ozdMett5ZwZ4ZD+pDWvXbKvi5vZzfVvEd/T6uJ4AdmPdzye+6AzSNYuVTsGdHoezb0a7X0yA5E/4m5U/WOkIPXo3xsox6yeeol9EFed6OsbEa9tMO9NUI6qV3h237NY2DTFn6H8ijt6VY1xTqgriuepLiGWKcj7COSPMcdAun3Ynw3XCvo2SW4aSATEqeMCh5LLi0juanjiwngOUIR9KJeR8H1J3liSyPodoiHGgXq23Mp4G/Ax87ciH8uPYKh5LVwYXII1xetKEDbstIcNuG44T62eB2D4eqtwP0QyvQBtwnqmx7DHC/ywPUXtWZebieI+x6oT6wh5Od/pef0XCVFjw8DpAmWcnF5awAL/f9LqS/DO40FT/IGU8qHYeDV/Vhkh2/C3XjsdcX857rrdrU/JTb03gY8j6P/PagjEqkhZ2o5OO870XZtvx6EXQW8jIeQniGanPVVypNEHlY8ieHy67GGcvOeTqyMw/2U67VlMwAf5ZxDfhRFuTLdVWBYmXgMrVp1Bm4AEgChgBtgOFAqsb61ApL/aV8KHuUx431/DuMk0/oFoYrDn35Iq013qG1Wk/olZ50BZABdAdqgGwgBehmo48d19P2e4DebTZRSds2rIPMfW2fV5Rtv2vJ2r/96XQ2WKSt4dggkXywUx4VL5kzQT8EXXuqexan8kfe44i8j3E6uU6wiSLv1NxrHjLIPKRvMj/QD5sfuGdQjvEa5WBNyjHa09C4N3/CTrwlA23CfwF2EVDHNFLO09mCxq+sN98/0xdi7ZtAcVgLxmMP2cN4wnrPaJRSGta9GdgTsT3F63WcZyQlGfdTG9cGrJl/MH9wrzY/Nf5imuqsFvtX962U5OpObdzfQ9/PCTv7tu/VYU0axXYd38lwvYw90BCs8eVUKn+gYmMQ/+bS/Nj+zUtnrHnp+kZ1f6BF570u9sv8flitydbvarvwOhNTQQtiR5jNcfcRxWZTDsZZ0XH7pZdIEzvUPfISKwzpJmEfgHUpLKzUpn1s6oSfq+gJd/1gg/ajDerO32Yq0R7CPgGAbGe4YrGHvxb4gcqwx4o1rof7TrrBSIb98CD53X3QNp1pqlFN+dAT+e7lCH+RpkPn+PXN5gvGs3Sp8T3SPUxr0L9+4zKMg4fJZVxOy4z98F9Hv3M9aX5rNCF+OfwIQ5vHGllIV634f6NfBPs6j6ZDl5DxAZ2L/cU8yJkpWqhOlJv/pu/4nr15UHyO9lxOPVxnYgyZ1EGfinV7JZAOO6sT7OXlsLfbY5/aA/6lWPe7UYL4JyW4cuHvTyXs13sjXSfE5SFdLq2B3uugSXMy9NV0mUp94c/VSshwZVGC3Ejl0H+5ejLSJFN3F58jI3/sN3JlCvTcEPh7QUf2QXuspXFGDiUoWwdt7r6Qihncpp5zqINnEXA2MJi6x65EmR9Re4bey/yOwWP95wAd24Mh38XcCXOfdp945/E47b3709yzP90clfdD5zEc/bQI9vEipUt5P11q0Zb3SZ1FqHcy/N51MjAqwi1Ivatjqs6vegBn2dgYgSxS74TMgUB/x64n3teF/d4I453f4dwN3hbnN0FYE3OxpuWeQIvD3Nw+4Je9KA17mw7iQuqHfJYjvzQ+27D+sgB/zHGR/SHOoeucPXnkvbUT9sYFSHcdDXPWDeT3jPrd/gNmjT7frInLoi4ewGDbhe//Ou8HV9AYYx903mbooTP5Lg3fJQEOUC3oe0Y5vce/1WY5GbGbKV/sh76fSlMAqa2iAR4SZ7nvhDyAdjORe436bTfnswMocx2kGcYc4Dd0WNnY28yjchv/1p3G6dbfMriK07IbmMe/z7f9syDjtdCBUv+YrjW60V/Qhn9xJx5ziyes1vOcBq4k2nrCeUXE2oU2m6LNpfZiKvUAbQcMB/rYyFd0D2wNC52gZ3KArpwm/LfhvzKtB4jlv3IsH4TdNpfc2lzziHiTchHWhn/z61pJA7HujPX0x/7jHSp3G9ivaDQNYSPc4xHWwTzgzqMs9/t0DtaTXmg3BeMS7JmXwGbbSbNc1u9x3zfexfrzMdLUIf4JGuteSNe6ZiDdNPhtuPOpNOZ6te/md198vydV3fHbREO1Xmrd5HUrEWlfNtJpiexAeeifm1Ae/02Ics/HGIN5NFb/Ky2HPZ4nx2E/5KXJ2i3U1z0FeS/GGjqbRvJvVu3fmAfU3ywYCp1ahzW4Tu2X4yDvo7r1twqCGCMV2tCWbUZH+gv4RkJ/5noWwn6xf4fv6db6e/wOAP8+v53tHw6dcpnGv73NoAHuuzFeF6jf4SZ5qikp9l+UFF8D92IVluCZRQmx70BPY99s2H8Tg9dptc/Lgd5ORzt8BDfn35naeRKpXWwM3KkqLAXjLMUTp+6/jZD2XTo+z8EmeDznpSifJb6BvC9Vv+lVYZCzvT1fToA8F+3JmBGGi4/BtYfvvLI5xfjJFIdoNsol/QPo1w9Arb/3MRlh1Rr/HQnML9g/YxjsZjhzNZIaX1MJQ++I9awj9eN56MxFBucLvi/4N+gav+sgmq/+tgP/rZKh6m9bzNFJXGpRupn/bgQD8X7N+rska5wzHU6L/IaBbyqwk6w9PX82RRFFFFFEEUUUUUQRRRRRRBFFFFFEEUUUUUQRRRRRRBFFFFFEEUUUUUQRRRRRRBFFFFFEEUUUUUQRRRRRRBFFFFFEEUUUUUQRRRRRRBFFFFFEEUUUUfyvgCBqN1bbQ7n0HLlJo0QK0mVEroH6v8kgLT+WyuVn2t3UjbzyU/kJ+Lzyk0ZXN2+z/LhJ9vXm5XeUh6lKfkhb5bv0FqBTIkIS4coDauE2AcPcL99uKi7OCTaDpvdTtLF3n5y9HNHYpWvOX+Xb2l3Ui7wIeKuxU4qKebOxoMB2DD7TcjT1zcx5Kz9WvkmfAZp8U75Fva1UTb375XyeH48AIS+mBCHIS9vkPykEaBSUrzX16Jmz9SH5d8Q/JZ+k2SrZk43x7XKQ4RPyfkpC9e6Te+yYPU1t2+VQfp3cgHbaj+dB4BDwOaDTUnknrQKuBnYDOiXg6QWygAkcInfJXZBzO9In4JkFLAWuBnS07E6EL+Kn3CEXUhrSXimvp46g6+V1it4O2gX0NoR3B70VfqZbbf+fQDn+Jjt8M/ydQG+06Q0ITwHdBD/TP9r+FXK5SrfMpttkXWN3b2J+d8T7gGxAwnU9XNej6a6Hj/AUco1crEpqAM0BXWJRNNdFjal+1UcXNXU+I2cbmvQiNP1FaLmL0HIXkY6olQ7PSosnU64Ez0rwrATPSrRKtqxDeXX8Z9rxTAR8gES716HdOTyE537goAr/A57XANvYJ3+LduwDqa6QCxt7ezHI5jUNDebkPSDnoqmDcm7TGd1yrj7mi4nlgQja1qYJzDtHxc5pimnDoXOaunSzKLgW5beVNfR7QKMOePYABgJFgC5rGntkeffJ8bTEQ8G23lXaKrlKX2Xo2UUi6SGZQxM9hCGZJDMp10P3eWfmiiFrt+WvlbN4HuKZCNQC1wA6ajsT4T55DjAT7TITQp3Df8IeT/6rp4nAQbgPgRrwJYAvAXwJCE1AaAJCCU+OmQhUAbV2rKs1xknD/J9zDNALsW0R2ha1PITn5+wCxsAXD188fPHgOqgdgYSJePqAiYBUYYcA9B+eTly2HV8FuFT854rHiQtyWu1IMKPX/j4i1Eds6yOu6SOCuXn5OcE0PJKSktZePXb32IfGPjtWnzl26dhVY+WQZnN/U2N6do6iaQGmexrP6JIzJCF/uLYbks3EcyvwFiDJi2cWkAcsBXRtN55eaLcsIA+YAMwEDKS4m+csnl47jsO3qjh2cbx2XLxEHe5qHDZgQv446LGZwFZAIu+7EH+X4rZcu1V4CM9DKnyCzb9NhXvxdNJIlYZ1x3T76QXygJlALWDQs/Is6N2zOH88vUAtsBvQ5XR8z5JnaXfje5d2l8wIxvfv6KVOnaD7k9p5EvMTtTbo1HixQz1vVM8r1DNPPXsE246J/3ZM/N/GxF82Jr4XHFpvykfE9eqZGozLj783P35Cfnyf/Hjk1plSKV7rqJ4ufop/q+d49cwIdkiN/yE1/qvU+C9S429JjT8vNX5EKqfrimkRr3VQzzh+ik3qOUY9ewbjvPGPe+PP8sYP8cbnx4stAqVTgXp2V88Ufoov700oSqCYB8SXVIScRGNuH2+zRooIszE3H6SlMXcUyNHG3C0gPzbmXud9UPwg1Gohvm3scdib31F8LUbr7P/Kpl+I0bQL9HPQeaB3UK4IgN7emHsJ8/8Z6W+C/zZK8zD/rTRRpdsqRqvwW+x0NzdmzEKpf2rMuACl3kQZqtQbGjMOI/S6xowrQDY2ZiwGuboxwAIubMzt681vJ+ZRD415ayigsSRj7RJLkfNi0FFW4uLGDE5VxAU0i8JGf3+QXizlg8JPE1Vx3ka/qmQ38qssupJfCZ1CAUXbigQlfDylKepp9F+CXFz3Bg57v8t9gCtO34iExi3edx5E/abB+y8xunGX97m93FyN3mczmkXgPu8z/ge8j/VoFtMavfszmj2IeCijWRN7vA1o5BB4NXGfd3fGPO/dfhW73Y9YdPXW3Ezvn/zTvZsD8Dd6L8l4kMWgJajxNERXZoz0js3d5S0JNAtEB3NRWDDWO8x/vncogs9sFqObdnn792hmUbKRx677vH1RYk8/RLnXO2jq1CH7tEHkFsuDGe5l7lnuae5J7uHuAe5Mt8/dzd3V3cGT5En0tPW08cR6PB6XR/doHvJ0aDYPBdMJ87CDK5GJS+enrtyJGj/V/ywCtSc8GmZPqL0s08qmFIhQUhmVlReEhqSXNbvNyaEz08tCnom/qWgQ4qpK+ELaumZB5RUYohy0NiWUVFixl4TIWrshhenKtRsqK0VZaH8Nlc3yhb6dgprETpoeMvwFydRpRV5yXtLIdkNLik7yqLKf6cc+yenhn+RuBaFNZVMqGgft3NmtoDKUo9ymCXdZaNQU34yKvdp52tLior1aLZPKir3iQu284skcLi4sqmxlozStFmyUy4TZmiiN2ShNNCm2sYoN4zWtuKghLc1iekSMZiaMo0cU0zwrrx4oAnlNZAI2rTv1UHn10LozGwaGlVlCeGZtSCSozBLakMqsKzM1BAJgyQgwS8OQABgaAkNU9K5j0f6AJU4lBVQ5AVGpyhHiGE9viweDwebRPOBJ/29+5hSk//KPaKp+Y3ZN8Rx/cZW/eA5QFVq/Yn5yaPUsn69h9hsc4QvJnlWzauYzrZ4TesM/pyg021/ka6iuOUl0DUdX+4saqKa4vKKhJjinqLE6WF3sry6qbLpjVWHZcWVd0VpW4aqTZLaKMyvksu4oO0l0GUffwWWVcVllXNYdwTtUWWWTC0TZxIoGDxVUFs6waJMWF4tpUZWSWlnQKbF2pJojw1OTL07ZpxPWr7j0ylAbf0EoHuCozPzMfI7iv9CNqLYITrCjki8enpqyT+ywoxIR3M5fQOmUXLygqPVfXV3dsjp+LF+ejuey5ckqcBkmb+qUslDJpOkVodxQbnEoWFVUKbg/wFgRHDzTPzMws/fM7fpS/9LA0t5Lt+sT/BMCE3pP2K7n+fMCeb3ztutZ/qxAVu+s7brX7w14e3u368vVp7KwIpj4UO6zudrS3FW5V+duzd2da1jBSQ+lPZumzUxbmrYq7eq0rWm701wcMaPivmDu1rTP0uRyjESxDJ/iIiXuclD8Y++y5VyROkjXoyqmNmZ1jEyM8cVkxwRjJsYYS+UqebWUXpkl8+QEOVMaMKMa3cMGgARLXMMGXBO3LS4Utz/uYJwRcu13HXQdcn3uMnyubFfQNdFV5ap1rXZd49rmirnGdY1bq4qrjVsdJxPjfHHZccG4iXGG1y0IdasDuI2WL08JJrpdRd642CKv1Iq8MZ4iLzdfZfry9MKK/DSqgX0sYMtnUnvADwwApgAGPYrnC8A7wFeATmvwvA74M9DEITJTZhYnLyjiNqhMZ02aLHOasgflnNkMWj3XolOmW7R4vEVz83OSQRvzBsTmJ8BUF7QPz6eA14CPgB8BQ+bIHJX5cmsOVtZRXbpAtQieZfyoS18m0uEQPHaW1aWnE4OnK8YTWNPF8bOYRN1yqqsjjC4QMKnQOk62nKnzQQQp/v8LwLBc/wplbmRzdHJlYW0KZW5kb2JqCjg1IDAgb2JqCjw8Ci9MZW5ndGggNjM3MwovQml0c1BlckNvbXBvbmVudCA4Ci9UeXBlL1hPYmplY3QKL1dpZHRoIDQ0MgovRGVjb2RlWzAgMSAwIDEgMCAxXQovU01hc2sgODYgMCBSCi9OYW1lL1dudlBkZl9qaWhjYmppcHBqb3BrcGZmb2NpbmZla2lubmdtYWVkbQovQ29sb3JTcGFjZS9EZXZpY2VSR0IKL1N1YnR5cGUvSW1hZ2UKL0ZpbHRlci9EQ1REZWNvZGUKL0hlaWdodCA2MAo+PgpzdHJlYW0K/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAQCAwMDAgQDAwMEBAQEBQkGBQUFBQsICAYJDQsNDQ0LDAwOEBQRDg8TDwwMEhgSExUWFxcXDhEZGxkWGhQWFxb/2wBDAQQEBAUFBQoGBgoWDwwPFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhb/wAARCAA8AboDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD7+rL8XeJvDnhXTU1DxR4g0vRLOSUQpcalex20byEFggaQgFiFY464U+lcD+2N8T/+FTfAbVvEdrLs1e7xp+i/LnF3KrbX5R1/doskuHG1vK25BYV+VviLWdY8QazNq+varfapqFxt868vrl55pdqhV3O5LHCqoGTwAB2qXKxSjc/W7/hcnwh/6Kr4J/8ACitP/jlH/C5PhD/0VXwT/wCFFaf/AByvyDopcxXKfr5/wuT4Q/8ARVfBP/hRWn/xyj/hcnwh/wCiq+Cf/CitP/jlfkHRRzByn6+f8Lk+EP8A0VXwT/4UVp/8co/4XJ8If+iq+Cf/AAorT/45X5B0Ucwcp+1emXtnqOm2+oafdwXdndxLNb3FvIJI5o2AZXRhwykEEEcEGp64n9mn/k3H4f8A/YqaZ/6SRV21WZhXE/8AC5PhB/0VXwT/AOFFaf8Axyu2r8TamTsVFXP2r0y9s9R0231DT7uC7s7uJZre4t5BJHNGwDK6MOGUgggjgg1PXE/s0/8AJuPw/wD+xU0z/wBJIq7aqJCiiigArE8Y+MvCHhL7N/wlfirRNC+2b/s39qajFa+ft27tnmMN2Ny5x03D1rbr4m/4LFf806/7iv8A7Z0m7Ia1Z9b+EfH/AIE8Vak+n+F/Gvh3W7yOIzPb6bqsFzIkYIUuVjYkKCyjPTLD1roq/PD/AIJJ/wDJx2tf9ipcf+ldpX6H0J3QNWYUUUUxHE/8Lk+EH/RVfBP/AIUVp/8AHK6/TL2z1HTbfUNPu4Luzu4lmt7i3kEkc0bAMrow4ZSCCCOCDX4qV+vn7NP/ACbj8P8A/sVNM/8ASSKpjK5Uo2O2oooqiQooooA53xd4/wDAnhXUk0/xR418O6JeSRCZLfUtVgtpHjJKhwsjAlSVYZ6ZU+lHhHx/4E8Vak+n+F/Gvh3W7yOIzPb6bqsFzIkYIUuVjYkKCyjPTLD1r4R/4K1/8nHaL/2Kdv8A+ld3R/wSU/5OO1r/ALFO4/8ASu0qebWxXLpc/RCiiiqJCuJ/4XJ8If8Aoqvgn/worT/45XbV+JtTJ2Kirn6+f8Lk+EP/AEVXwT/4UVp/8co/4XJ8If8Aoqvgn/worT/45X5B0ZpczK5D9fP+FyfCH/oqvgn/AMKK0/8AjlH/AAuT4Q/9FV8E/wDhRWn/AMcr8g80Zo5mHIfr5/wuT4Q/9FV8E/8AhRWn/wAcqbTPix8LNR1K30/T/iV4Pu7y7lWG3t7fXraSSaRiFVEUPlmJIAA5JNfj7mijmYch+2VFfnF/wTl+NGseEfjBpngXXNavpvC/iD/iX2tnNO8kNhdvIWheJNrFd8jNGwXYpM29ydgr9HapO5DVgqDU72z07TbjUNQu4LSztImmuLi4kEccMagszux4VQASSeABU9cT+0v/AMm4/ED/ALFPU/8A0klpiD/hcnwh/wCiq+Cf/CitP/jlH/C5PhD/ANFV8E/+FFaf/HK/IOio5mach+vn/C5PhD/0VXwT/wCFFaf/AByj/hcnwh/6Kr4J/wDCitP/AI5X5B5ozRzMOQ/Xz/hcnwh/6Kr4J/8ACitP/jlH/C5PhD/0VXwT/wCFFaf/AByvyDzRmjmYch+wWm/Fj4WajqVvp+n/ABL8H3d5dzLDb28GvW0kk0jEKqIofLMSQABySa7CvxNr6i/4Ji/FHxRpnxvsPhxcalfX3h7W7S4igsJromHT5o0kuRLEjA7c7ZVZUKhjLubJQCmpCcT9EK53xd4/8CeFdSTT/FHjXw7ol5JEJkt9S1WC2keMkqHCyMCVJVhnplT6VP8AEzUtY0b4ceINX8PWH9oavp+k3Vzp1n5Ly/abhImaOPYhDPucKNqkE5wOa/M34n2K+GvDWmXmk30HiC58V+A4Ne8QarLotvqrveXGoXEUpkuJzI9m0fmiFpYiGaaKMFVd9yNuwoq5+ptFfNP/AATzvJ9LvvH3w4t9f0PXNF8N3dhfadc6LdS3FlA19C8s9tbSPLIWgikjKqSdxbzGf5mIH0tTE1Zny5/wVs/5Nx0T/sbLf/0ku6+Jv2af+Tjvh/8A9jZpn/pXFX2z/wAFbP8Ak3HRP+xst/8A0ku6+Jv2af8Ak474f/8AY2aZ/wClcVQ/iLjsfr5RRRVmYUUUUAFFFFABRRRQAV+JtftlX4m1Ey4H6+fs0/8AJuPw/wD+xU0z/wBJIq7avx90z4sfFPTtNt9P0/4leMLSztIlht7e3165jjhjUBVRFD4VQAAAOABU3/C5Pi//ANFV8bf+FFd//HKOYOU/XyivyD/4XJ8X/wDoqvjb/wAKK7/+OUf8Lk+L/wD0VXxt/wCFFd//ABynzByn6+V8Tf8ABYr/AJp1/wBxX/2zr5c/4XJ8X/8Aoqvjb/worv8A+OVieMfGXi/xb9m/4SvxVreu/Y9/2b+1NRluvI3bd2zzGO3O1c467R6UnK6Go2Z9Ef8ABJP/AJOO1r/sVLj/ANK7Sv0Pr88P+CSf/Jx2tf8AYqXH/pXaV+h9OOxMtwoooqiT8Ta/Xz9mn/k3H4f/APYqaZ/6SRV+Qdfr5+zT/wAm4/D/AP7FTTP/AEkirOO5cztqKKK0ICiiigD87/8AgrX/AMnHaL/2Kdv/AOld3R/wSU/5OO1r/sU7j/0rtKP+Ctf/ACcdov8A2Kdv/wCld3R/wSU/5OO1r/sU7j/0rtKj7Rp9k/RCiiirMwr8Ta/bKvxNqJlwP18/Zp/5Nx+H/wD2Kmmf+kkVdtX4+6Z8WPinp2m2+n6f8SvGFpZ2kSw29vb69cxxwxqAqoih8KoAAAHAAqb/AIXJ8X/+iq+Nv/Ciu/8A45RzByn6+UV+Qf8AwuT4v/8ARVfG3/hRXf8A8co/4XJ8X/8Aoqvjb/worv8A+OU+YOU/Xyvlz/grZ/ybjon/AGNlv/6SXdfE3/C5Pi//ANFV8bf+FFd//HKy/F3j/wAd+KtNTT/FHjXxFrdnFKJkt9S1We5jSQAqHCyMQGAZhnrhj60nLQFGzNv9lmyvL/8AaV8AwWNpPdSr4msJmSGMuwjjuEkkcgfwqiMzHoFUk8Cv11r5q/4Jy/DP4Xab8H9M8daDLY+IfEl981/qk0CmbSrjYVeziVvmh2LIysRgyht+SjRhfpWnFWQpO7CuJ/aX/wCTcfiB/wBinqf/AKSS121cT+0v/wAm4/ED/sU9T/8ASSWqJW5+Qdfr5+zR/wAm4/D/AP7FPTP/AEkir8g67DTPix8U9O0230/T/iV4wtLO0iWG3t7fXrmOOGNQFVEUPhVAAAA4AFZxdjWSufsFRX5B/wDC5Pi//wBFV8bf+FFd/wDxyj/hcnxf/wCiq+Nv/Ciu/wD45VcxPKfr5RX5B/8AC5Pi/wD9FV8bf+FFd/8Axyj/AIXJ8X/+iq+Nv/Ciu/8A45RzByn2z/wVs/5Nx0X/ALGu3/8ASS7r5c/4J0/8nkeDv+37/wBILmvNfF3j/wAd+KtNTT/E/jXxFrdnHKJo7fUtVnuY1kAKhwsjEBgGYZ64Y+tfoF/wTa8AfDrQ/gva+M/DGoQa1r+twiPWdQKbZLGQbWewVDzGqHaT3lO2TlDEFndj2R9HV8/a3+yvo1r4r1nUPh74rm8G6b4tiktPEumW+j2t0s9nIAJLezlkXfZq4MhIXeu4phQIlWvoGitDO9jlvg58PfC/ww8B2nhLwlY/ZrG2+eSRyGmu5iAGmmcAb5GwMnAAACqFVVUdTRRQB8uf8FbP+TcdE/7Gy3/9JLuvib9mn/k474f/APY2aZ/6VxV99/8ABTHwleeKf2W727sTO0vhrUINXaCG2MrTRqHhkzg/IqJO0rNggLEc4GWH5xeB9evPCvjXR/E+nxwSXmiahBf26TqWjeSGRZFDgEEqSozgg47is5bmkdj9nqK/PD/hvL4v/wDQueCf/AG7/wDkmj/hvL4v/wDQueCf/AG7/wDkmq5kTys/Q+ivzw/4by+L/wD0Lngn/wAAbv8A+SaP+G8vi/8A9C54J/8AAG7/APkmjmQcrP0Por88P+G8vi//ANC54J/8Abv/AOSaP+G8vi//ANC54J/8Abv/AOSaOZBys/Q+iud+EOvXnir4T+F/FGoRwR3mt6JZ39wlupWNJJYEkYICSQoLHGSTjua6KqJCvxNr9sq/E2omXA/Uz9nv4T/CzUfgH4H1DUPhr4Pu7y78M6dNcXFxoNtJJNI1tGzO7FMsxJJJPJJrsP8AhTfwh/6JV4J/8J20/wDjdH7NP/JuPw//AOxU0z/0kirtqpEnE/8ACm/hD/0SrwT/AOE7af8Axuj/AIU38If+iVeCf/CdtP8A43XbUUxHE/8ACm/hD/0SrwT/AOE7af8AxuvkH/gqx4N8IeEv+ED/AOEU8KaJoX2z+0vtP9l6dFa+ft+ybd/lqN2NzYz03H1r70r4m/4LFf8ANOv+4r/7Z1Mtio7nE/8ABJP/AJOO1r/sVLj/ANK7Sv0Pr88P+CSf/Jx2tf8AYqXH/pXaV+h9EdgluFFFFUSfibX6+fs0/wDJuPw//wCxU0z/ANJIq/KX4t+ErzwH8Tte8G3xneXRdQltVmmtjA1xGrHy5hGSdqyJtdeSCrggkYNe2eB/21Pin4V8FaP4X0/QPB8lnomnwWFu9xZ3LSPHFGsalyLgAsQozgAZ7Cs4uzNJK5+klFfnh/w3l8X/APoXPBP/AIA3f/yTR/w3l8X/APoXPBP/AIA3f/yTVcyJ5WfofRX54f8ADeXxf/6FzwT/AOAN3/8AJNH/AA3l8X/+hc8E/wDgDd//ACTRzIOVif8ABWv/AJOO0X/sU7f/ANK7uj/gkp/ycdrX/Yp3H/pXaV41+0R8W/Efxl8bWvijxRZaXaXlpp6WCJpsUkcZjWSSQEiR3O7Mrd8YA49fpz/gkL4R/wCRw8e3On/88dI0+987/ttcx+WG/wCvM7mX2U/fFTvIp6RPtmiiitDMK/E2v2yr8TaiZcD9TP2e/hP8LNR+AfgfUNQ+Gvg+7vLvwzp01xcXGg20kk0jW0bM7sUyzEkkk8kmuw/4U38If+iVeCf/AAnbT/43Xwj4H/bU+KfhXwVo/hfT9A8HyWeiafBYW73FnctI8cUaxqXIuACxCjOABnsK1f8AhvL4v/8AQueCf/AG7/8AkmnzIXKz7Z/4U38If+iVeCf/AAnbT/43R/wpv4Q/9Eq8E/8AhO2n/wAbr4m/4by+L/8A0Lngn/wBu/8A5Jo/4by+L/8A0Lngn/wBu/8A5Jo5kHKz7Z/4U38If+iVeCf/AAnbT/43Xzh/wU+8AeBPCvwD0fUPC/grw7ol5L4mghe403SoLaR4zbXTFC0aglSVU46ZUelea/8ADeXxf/6FzwT/AOAN3/8AJNcF+0R+0v47+Mvgq18MeKNJ8O2lnaagl+j6bbTxyGRY5IwCZJnG3Erds5A59U5Kw1F3IP2IPiF4o8DftB+HbPQb7ZY+JtWs9L1WzlBaG5hlmWPcVyMSJ5jMjjkHI5VnVv1Tr8pf2H/CV54x/ak8IWlsZ44tL1BNXup47YzLDHakTDfgjYrukcW4nAaVepwp/VqnHYUtwrif2l/+TcfiB/2Kep/+kktdtXE/tL/8m4/ED/sU9T/9JJaolbn5B1+pn7Pfwn+Fmo/APwPqGofDXwfd3l34Z06a4uLjQbaSSaRraNmd2KZZiSSSeSTX5Z19HeB/21Pin4V8E6P4X0/QPB8lnomnwWFu9xZ3LSPHDGsalyLgAsQozgAZ7Cs4tI0kmz7u/wCFN/CH/olXgn/wnbT/AON0f8Kb+EP/AESrwT/4Ttp/8br4m/4by+L/AP0Lngn/AMAbv/5Jo/4by+L/AP0Lngn/AMAbv/5JquZE8rPtn/hTfwh/6JV4J/8ACdtP/jdH/Cm/hD/0SrwT/wCE7af/ABuvib/hvL4v/wDQueCf/AG7/wDkmj/hvL4v/wDQueCf/AG7/wDkmjmQcrPSv+Cn3gDwJ4V+Aekah4X8FeHdEvJPE0EL3Gm6VBbSPGba6YoWjUEqSqnHTKj0rxP/AIJoeJNd0n9qjRtC0/U54NN8QRXMWp2gIMd0sVrNLGWU/wASugIYYYAsM4ZgcT9oj9pfx38ZfBVr4X8UaT4dtLO01BL9H022njkMixyRgEyTONuJW7ZyBz63f+Cb9neXX7YPhee2tJ5orKK+munjjLLBGbOaMO5H3V3yRrk8bnUdSKnqVsj9P6KKK0MwooooAK+d/iB+xb8F/E/iSTV7WLW/Dvn5aWz0W7jS2Zy7MXVJY5Nn3gNqFUAUAKOc/RFFAXsfLn/DBvwh/wChj8bf+B1p/wDI1H/DBvwh/wChj8bf+B1p/wDI1fUdFLlQ+Zny5/wwb8If+hj8bf8Agdaf/I1H/DBvwh/6GPxt/wCB1p/8jV9R0UcqDmZ8uf8ADBvwh/6GPxt/4HWn/wAjUf8ADBvwh/6GPxt/4HWn/wAjV9R0UcqDmZl+B9Bs/CvgrR/C+nyTyWeiafBYW73DBpHjijWNS5AALEKM4AGewrUoopiCvlz/AIYN+EP/AEMfjb/wOtP/AJGr6jootcL2MvwPoNn4V8FaP4X0+SeSz0TT4LC3e4YNI8cUaxqXIABYhRnAAz2FalFFABRRRQAV5d+0p8BvCHxu/sX/AISvUtbs/wCwvtH2b+y54o9/neVu3+ZG+ceUuMY6nr29RooA8Z/Z3/Zo8CfBrxrdeKPC+reIru8u9PewdNSuYJIxG0kchIEcKHdmJe+ME8ens1FFABRRRQB5r+0D8CPh18Y7eF/Fumzx6laxeTa6tYTeTdwR7w5TJBR1yGAEisF3uV2lia8m/wCGDfhD/wBDH42/8DrT/wCRq+o6KVkO7Plz/hg34Q/9DH42/wDA60/+RqP+GDfhD/0Mfjb/AMDrT/5Gr6joo5UHMz5c/wCGDfhD/wBDH42/8DrT/wCRqP8Ahg34Q/8AQx+Nv/A60/8AkavqOijlQczPmPTP2FPg5a6lb3M+r+ML2KGVXe1uNQgEc6gglHMcCuFYDB2srYPBB5r6I8E+G9D8IeFLHw14a0yDTdK02IRWtrCDtRc5JJPLMSSzMSWZiSSSSa1KKdkhXYUUUUAFfLn/AAwb8If+hj8bf+B1p/8AI1fUdFFrhex8uf8ADBvwh/6GPxt/4HWn/wAjUf8ADBvwh/6GPxt/4HWn/wAjV9R0UuVD5mfLn/DBvwh/6GPxt/4HWn/yNR/wwb8If+hj8bf+B1p/8jV9R0UcqDmZ8uf8MG/CH/oY/G3/AIHWn/yNR/wwb8If+hj8bf8Agdaf/I1fUdFHKg5mcT8DfhN4G+EnhuTSPBekfZftXltfXk0hlub10TaHkc/8CO1QqKXcqq7jXbUUUxBWX440Gz8VeCdY8L6hJPHZ63p89hcPbsFkSOaNo2KFgQGAY4yCM9jWpRQB8uf8MG/CH/oY/G3/AIHWn/yNR/wwb8If+hj8bf8Agdaf/I1fUdFLlQ+Zny5/wwb8If8AoY/G3/gdaf8AyNR/wwb8If8AoY/G3/gdaf8AyNX1HRRyoOZny5/wwb8If+hj8bf+B1p/8jUf8MG/CH/oY/G3/gdaf/I1fUdFHKg5mfLn/DBvwh/6GPxt/wCB1p/8jV7b8DfhN4G+EnhuTSPBekfZftXltfXk0hlub10TaHkc/wDAjtUKil3Kqu4121FFkF2FFFFMQUUUUAf/2QplbmRzdHJlYW0KZW5kb2JqCjg2IDAgb2JqCjw8Ci9MZW5ndGggMTAxMwovQml0c1BlckNvbXBvbmVudCA4Ci9UeXBlL1hPYmplY3QKL1dpZHRoIDQ0MgovU3VidHlwZS9JbWFnZQovTmFtZS9XbnZQZGZfZnBnYWhtYWhjZWdla25jZXBvY2RvanBnaWxhb2hjcGQKL0NvbG9yU3BhY2UvRGV2aWNlR3JheQovRmlsdGVyL0ZsYXRlRGVjb2RlCi9IZWlnaHQgNjAKPj4Kc3RyZWFtCnhe7ZyNdaMwEIS3BEqgBJegElICJbgEleASVIJLUAkugRLoYA8nCHAirVbD893xst+9dz9hNaudMU6MzZFhGIZhGIZhGMbGxflmClKucjzHsCwZhBpAt09LeqHIAwxOUvyk9wCD63Jal/nQJXfAhYkBKI+vHM8RlyVRqAF0XVrihCLGmIIkuuvdyHjrvyl1cQo+TPH716m7MwblARw+Y3Iz9+wJsoAmN3N70e0e4fnvLkz9a4fuwSCUB3D4pMnxlH0K++JAcvzYRxfic4uPge7xtUNkFMoDOHzW5PhRlj2SHN83nY57Yt/5qXv+bccHw1AewOHTJsdDUfZQcrsNu/nRwZ7m5ChuX51Bv8mxJfekfNIdS2476Vz82qKfXRp2+h3jUB7A4fMmx8UfUo4lN606l+l5zl3u8x+jy+kH3wzlARz+L5ILroFrVXntfXUNhJ9DjsPz2fLCzk37h4lqtjYAh/+L5Dw1UFeuV+TIDHmdeu/mI5fR7ysxfRHAYUsukRsyTMP8+zCGl0pMXwRw2JJLZIccRp5/Da+VmL4I4LAllygM2f28nonpiwAOW3IJ/ZCYvoi++YYlt6AfEtMX0TffOG9yfbXCUQNpyO31XAlMXwRw+LzJ7S4wFiranE1D+lohqC8COHza5IT3eVS9f7AMGagKpi+yOhz1pHd2o0aX1KimW7frGwifS4Igu/YOvoGvh/BAdVSztbE6DBA1uqRGNR3DDILq1ruZ6YMUqGZr47ckVzEYTk56u3aHarY2fklyNYPR5B7lb50vqGZr45ckN1pye6JGl9SopmOQSRLFk2N7tiR6b3L2E8qeqNElNarpGOcmyOLJ/ftXBaQnLkuiUAPoqqZLNZ4aWJRDtaLRWV/VTWD6IoDDp01OsFjV+wdpSF8rBPVFAIfPm5xdcV6WRKEG0FVNl2o8NVBXrlfk0A+J6Yvom29Ycgv6ITF9EX3zDUtuQT8kpi+ib75hyS3oh8T0RfTNNyy5Bf2QmL6IvvnGu5OTLiilGk8N1H2rV+TQD4npi+ibb2iSG9p1nWZJqvHUQN23ekUOvXkXxilI6ptvaJJbrWhHfHWUiqJvIKRVxbN53W7wDSQjFOZBd4h/UVB8V3Krxe2UP+dzSPZJUfbAA43FWyoTgWEKim9LDr/Vb5Bk+QiKz35BSNeyF3qGKSi+LTnYi1FSPZacK8rCu/2kpzpXRikIvi05ujGGE1X5AMKpcSi5K2lA/fj7yWFP7Z/3MAkwThBkjyTnScfHyBAFuTcmh2w11j4cwCij+N41ntzrjfwyHwH5T1EKYu9MrnWr8VbLDUxuqipjyU3R13dsGIZhGIZhGIZhGMbf5A8JVCK4CmVuZHN0cmVhbQplbmRvYmoKODcgMCBvYmoKPDwKL0FJUyBmYWxzZQovVHlwZS9FeHRHU3RhdGUKL2NhIDEKL0NBIDEKL0JNL05vcm1hbAo+PgplbmRvYmoKODggMCBvYmoKPDwKL0ZpbHRlci9GbGF0ZURlY29kZQovTGVuZ3RoIDE2MQo+PgpzdHJlYW0KeF5djkEOwiAQAO8k/GFfgLSV0t59gJ56NEKBLRSomvh+2yimcS87yWYnwxnfBspuq/pLsi/0MDBAogTulByG9DqP9jqj1d6qaDyaoOKc/TJNPi3o9M3HgOCelBRpLRomqkru9aLp2LHrmk1PycfPmehlK9pSw/fwf/pJOYCO6zeUNkRl8pjGYGcfootZZWfTohSuaWZtO2VKLpS8Aa23QHUKZW5kc3RyZWFtCmVuZG9iago4OSAwIG9iago8PAovUGFyZW50IDMgMCBSCi9UeXBlL1BhZ2UKL01lZGlhQm94WzAgMCA2MTIgNzkyXQovUmVzb3VyY2VzCjw8Ci9YT2JqZWN0Cjw8Ci9XbnZQZGZfaGhiZW9kbmRrZmxqa21nbW9ib2dmbnBiYmhham1la2ggNjkgMCBSCj4+Ci9Qcm9jU2V0Wy9QREYvVGV4dC9JbWFnZUNdCi9FeHRHU3RhdGUKPDwKL1dudlBkZl9saGZjamZibWVqaGVrYm1sb2pwaWlqbnBoZ2Nham1raCA4NyAwIFIKPj4KPj4KL0NvbnRlbnRzWzg4IDAgUl0KL0dyb3VwCjw8Ci9DUy9EZXZpY2VSR0IKL1MvVHJhbnNwYXJlbmN5Ci9JIGZhbHNlCi9LIGZhbHNlCj4+Cj4+CmVuZG9iago5MCAwIG9iago8PAovVHlwZS9YT2JqZWN0Ci9MZW5ndGggMjgwNQovUmVzb3VyY2VzCjw8Ci9Gb250Cjw8Ci9MQ0NKVkcrQXJpYWwtQm9sZE1UIDcwIDAgUgovTENDSlZHK0FyaWFsTVQgNzUgMCBSCi9DS1hZUEgrVGltZXNOZXdSb21hblBTTVQgODAgMCBSCj4+Ci9YT2JqZWN0Cjw8Ci9XbnZQZGZfY2FnZWRtYW5vam9oa2xobHBiamNiamFqZmtsY3BubGIgOTEgMCBSCi9XbnZQZGZfZWdibm5wZGhqYmZia2xvZHBqcG9sYW5lbWJmbmhoYXAgOTIgMCBSCj4+Ci9Qcm9jU2V0Wy9QREYvVGV4dC9JbWFnZUNdCj4+Ci9TdWJ0eXBlL0Zvcm0KL0ZpbHRlci9GbGF0ZURlY29kZQovQkJveFswIDAgMTAyNCAxMTQwXQovTmFtZS9XbnZQZGZfaWpwZm1pYW5vZ2dua2ZuY2JtYmlna2NuZ2doa2tkaWEKPj4Kc3RyZWFtCnhexVtbU9u6FtYMb8zQaUm40xk/cCmlgK2LL5v24ezSJECAEEKAbjoMFCibhsvpmTln9r8/35ITO4U0W0YhGxNHli3pW5+W1lqSHHfZpT+n9e25XLaSnmzl/rhwDpzboUHn3/i4j+/fDA12Ltj46UZbrvs462po8GBosNmKuxzxSHq4Hwn86e+AK+fHt6FB4TcLRZFKAURh9Ci78VN2INLstI7Oue1VANjlW8BydocG/w5aS9QgaDVL0CLvUXbjp2zVlp3W0Tm3vYqnQJMdkcmOwHgnBB0zZTdUgQIs5+H3T6g6guqIKezQeqe8XwBqguqfKnO3eSd5pC0h0pRspTxX8lba+XpDuFcObv9bOb88ufh2dnt7f351fXZ59r1xd35/fX/XOL29uDm7vL26Or131u6GBptCtgTti5D4/702NLjycfPwqFJarP15c/Gf7Yv/Ve9uTm8re1s1x2sNrdpls4/I1pCcTu38cf2J5YGOOG/YwILj1K6R/FRL5Gtrtfzx40a9uPivH3+eNpZ+v2ucU4NBhwZdowaX3OVQeX7g1L7q1o8X2AybYwELmWIztlDoAmYnMkSCARwmSObZGjtgVVZnAwBUZRVWYvuswMrI30G63htwShmC465UCTjB/gKIMvsCMK+zdNlDFNr4mqLIph0Pm/L04HTMJVahRw/GErtsgo3hmGSjOMZYno0s2HWA8lQ2PEL5nLfwRGB/A2qw21QJq15QEc8Axa4bVJRR8YQK0vE5wnL4jLGX1AH6PIHBmsPxOj0/HVygZAZwjr21ih2/Y86G67upUg5oW2DV9UEYZgDgWHV9EIkMbXXu+vFedX03oyg8U4AykKIF8F1zMNZhra36JJIZUNh1SRRlayq/YEdwy+gJU4a54G6i78dvQHFRO0VLilXoZ8DhWFo8L0Nb5HjcUCUy59k0FJ2UfUKr//iC0wsVdwNDMJ5wRdQC48PjbLBDBCJVGJ8CzrsIUvZ1qLKme8aqV7zIzwDOsTe/LXV0jdkIPS/xwQIy18BGCdKXmKUHdjMAcSz1MaPQCPz8RB9nEAoJtgJr15vwOAyFIQwuXFe2YMzB8a2xI/A+AJO7q3tgH99ruC4ivaOdYxwhWfcOzwTVrne4nhE65rQoX7lJ70xrG5Fj0wtOLwZG2A+JFXefra1uiqeM52WeChOGFdSqYmvo4kDIEIFjxW4UZmgKwvpuGKh0sB/Gk9AFpyfqZIxC+H7qAjlbxxgv6HFuO9MJ3QxA7JhXYUahVRTJRGiXop1VmNk5xhecXui7MA27uZAyMbQ+VKCgXX7dfrbheVmg2NHvxUtO5m31KLYNjXkWrvS81KFRMHWkHVbZ1r748VpHKPrAs++qbG31ZpKGQMykPZoyRzyN2eaSmLVqrcxuFiCOvd9qKZjXj0lL0yl7/RIu7tUgDHrf3sOm4girL03Fq9GBLy2aajbXv20ML2puqCSPtCXabqb7GIKLVvLBNsbX028X5zent3fXd1ffG1eN+7Prr2fXp9eX3xtf728bZ//4Nsbf954w20rAPEm0BS0DdDxdcXjctnRtNCfL+OOBNi6BNGqQogSYVZFGCTT9KuvpWFGfCzrnAHlx8BYvD6STsxKi6HitbJ/Z8NSEzU1hy0AFyXpGrnnkkxQd4/p6BJMpWnoZZRNPhydVFnjOm15Q0W+V8UOjBvVyKVeqXWV2cMRKQbsZZb2KtNOmJHO0ITePIHjAmhbfN0WpAiWTeCHQs44AOvEHBeS0AcQJ1Cr7gosRdnzMlgFTQouRm0fuBzy9Bulctse29BnlljGVqlJiCQ8fsRcQ6TNdcrZI5dYwrRzH+R2qGcbAWEfA7bP3GB4rrAZWttHANBPgCGXeotpVvbixijoDe2ak+dhp24EaB4AipDlgs8A9hRFThlwjAPYZyJcBbYPYeQHw85ohXHgQNwKT2zhvQjIPHFI9K+jvYZJtFsJv4OYWKvlD0/QeggfgSaGxLdgRhWtP25YIZP+GRkdRv0L9m6hqD9ezbNueE27Kie+Fom2PYgpwPD1nnmWfIPZbaICEKLuQdhpySvTrEu5+gK4M48lZnN8iL4IQICiC2h/Fqob/RZifYTyqoBBbKD4GiQuocAoPT6DwPJ6mtYhtfE9Cdon7LgvRBRPgbwzlD3GXKh+1Z8Q1ZUQGAU+mNTPQi30wMY+OeQ9ww5CehBrWu6k7SENqDtKKwF6HlC9A2iH6fVE/HoGNHIqEkHYFZNGu+CjyljRtIbjhyN3BSJjCs6taZw7B1D50IaCRhf9FPLMBnnwMIKGHFi3a1lHPtDUrytz2KZkuIlX0uJ4E0HdQ4SJE+A2QS0jpSf8GrfOjB7+gZ0HPLkQl1V7EqMqhTBXQIzzkMOfpAvj63R5TAZxeeCblP0Nb3TyTMrdsnPs8i2fyodkB6wEnxoZGCS9dLViHqfGhFkUoko/hNQUF8QHsM6zgJgbWEeCOY3CtYhQVYTPGcD1Pg0FgIH2JF5c2MYoE1Cmkiz0UOaIHpvSiObRuG0/ScsQo9E5C2lGUK0EDcauIUrPI2gQFdahwHao8Aky4hRoqWXYGfkWLsbVRfugnYWhOm8kKxlYJgm8B/x6A7iKvRMhKwPkCN6X2EouQoKTtCdncfeCfAlMC1oLcdgnf4+CNvNE2rshm0IYPlfW1T9vH9xxsM9VK9ZTBxgc8Q+7/vWZ8CvVugt8SGNoBdfZ+SYamvEge+Im6fIBwHMoxAVVZQ7dPUpcXYjWokdU5xiPb6OAXRNM77WrJiUzDoGov/hYSzaLEOuRa1+acbszhWNUm/VA78Hm9VFvDszPgYZUKllHHEZR0HOddEKJwPkRDw7ieBIG7FAAdo6Rrz41vzI3y3CQOzQPqFIm9DDg5KEwBaHJQInJZEb73QEUEBqr6JaAD4qykjXMeI6QAUWeoNOlHWfvdTQhHfreIq3nUuoNU7Oz2UDpAXRQNSn1N7wy80wHCe1S1jEpXtJ9awVGOx5M9L+ZW0AvSWGZdL/vO6EHhQjHmkapDTZb0GItwLw+VoW7+BEH3cFdCgF2crfyS8oMMoJ1e+CXJn6Gtbn5JGls3ISKRWLc5PYkuNXc5q3rCvdHcFdlh9jwIY+PCvUglOwQnOPLsFT4nAJfT+4+kNHmo0EtY13WkCkjRS3OjGPQvoT6jSOeRyulIZwLlJnTZHM40hTh5+KaXvXDG1kF5IghT60BvGRGE1xr8a702cIJB6sUTvsnmYkGOLkcxXk7+iTmjPT3SnB4eJY4l21S1z3NGe1K4MSlSplFIpqlqn+eM9pwY2y4lBE/GUYapat/njNaccGPDKV1XuC1OMk1VezdnhIX69brnFI68PSHGxtbjPJ0Wj9BiK7oYHuXpEAT3MkBwehFAcPkMbXULILixYRJCpqGuBzV41WVtvleTWm5sIwxX47VWttTj6fCaq/Hc7Z9qeOEztNVNNTzflHsecem3uNez4wIcE4WWFMBUYIDJvLzuBQnSGBP3graZGVl96vfhJBwceBSLDcDKkVJX2KunA5V+mAGo0xPN4M/QVlfNcI17QapAptEMdGOubelrT788QUtDJW039rvs+dFLW3/BGfVCi0JT+AqanUxjfxmoPx2PiF/oDp+h/34huv8MTXX59Zwwak6/wcT5T96FlknrTxe3+eM90+a5Um0/3XuDQOmAxTvQVb14UWHx679Vvd9Mv6Q7bE6eybLt6XO9+UyqqwPa+rXuriXafajvJVuSnawNff4P3BrjlgplbmRzdHJlYW0KZW5kb2JqCjkxIDAgb2JqCjw8Ci9MZW5ndGggODA2NjYKL0JpdHNQZXJDb21wb25lbnQgOAovVHlwZS9YT2JqZWN0Ci9XaWR0aCAzODUKL0RlY29kZVswIDEgMCAxIDAgMV0KL1N1YnR5cGUvSW1hZ2UKL05hbWUvV252UGRmX2NhZ2VkbWFub2pvaGtsaGxwYmpjYmphamZrbGNwbmxiCi9Db2xvclNwYWNlL0RldmljZVJHQgovRmlsdGVyL0RDVERlY29kZQovSGVpZ2h0IDM4NQo+PgpzdHJlYW0K/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAQCAwMDAgQDAwMEBAQEBQkGBQUFBQsICAYJDQsNDQ0LDAwOEBQRDg8TDwwMEhgSExUWFxcXDhEZGxkWGhQWFxb/2wBDAQQEBAUFBQoGBgoWDwwPFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhb/wAARCAGBAYEDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD7+ooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAPn/8Abn/aa/4Zz/4Rf/iif+El/wCEl+2f8xb7H9m+z+R/0xk37vP9sbe+ePAP+Hmn/VE//Lr/APuOj/gud/zS7/uMf+2Nez/Dbwd+zv4O/Yz8GfEb4jfDvwPDYw+EtHn1TVLnwpBdSvLNBAm99kLyOzSyrk4JyxJ7mgDxj/h5p/1RP/y6/wD7jo/4eaf9UT/8uv8A+469A/4XJ/wTz/6BHw//APDcS/8AyHXX/BXUv2Lvi34quPDfw98F/D/WNTtbJr6aD/hBBb7YFdEL7prVFPzSoMA556cGgDzD4T/8FDv+E1+Knhnwb/wqD7D/AMJFrVppn2v/AISbzfs/nzJF5mz7Ku7bvzjIzjGR1r1/9uf9pr/hnP8A4Rf/AIon/hJf+El+2f8AMW+x/Zvs/kf9MZN+7z/bG3vnj4w+NuhaH4Z/4K6aNonhvRtP0fTLXxn4a8ix0+1S3gh3JYu22NAFXLMzHA5JJ716h/wXO/5pd/3GP/bGgD6f+Jfx0/4RL9ja2+PP/CLfbPtGjaXqf9i/2h5e37Y9uvl+f5Zzs+0ddnzbegzx8wf8PNP+qJ/+XX/9x1n/ABw/aI+DviD/AIJo2Xwp0jxh9o8XQ+GdCsX03+zLtMT20lmZk81ohF8oik53YO3gnIz1H/BIn4a/Drxj+zbrep+LvAHhfxBfQ+LbiCO61XRre6lSIWlowQPIhIUMzHGcZYnuaAPof9tb46f8M/fCvT/GX/CLf8JF9u1qLTPsn9ofZNm+GeXzN/lyZx5OMY/iznjB8A+E/wDwUO/4TX4qeGfBv/CoPsP/AAkWtWmmfa/+Em837P58yReZs+yru2784yM4xkda+l/2oPE3wa8K+AbPUPjhbaPP4ek1NIbVdV0RtSiF2YpWQiJYpCreWs3zbRgZGecH548WfEv9jbxH4V1Pw98ItN8Hw/ELVrKaz8IS6b4KksLpNWlQpZtDdG2QQSCdoispdAjYbcuMgA9P/bn/AGmv+Gc/+EX/AOKJ/wCEl/4SX7Z/zFvsf2b7P5H/AExk37vP9sbe+eOA/Zb/AG5/+Fx/HbQvhx/wq7+xf7a+0/6f/wAJD9p8nyraWf8A1f2ZN2fK2/eGN2ecYPn/AMC/+LSf2p/w3n/xMP7Y8n/hDP8AhLv+Ko8vyvM+2+R5f2n7PnzbPdnZvwn3tny/LFnZ+IvGP7YGswfs9vcW19qniDVJvCp0a5GksloTPIBCzNF5C/Zgw2kr8vy47UAftNXzB+xT+2D/AMNA/FTUPBv/AArv/hHfsOjS6n9r/tv7Xv2TQReXs8iPGfOznP8ADjHORy/7L/xjb9nrwDeeC/2svHOsad40vtTfVNPi1We51qVtNeKKKNhPb+eqr50FyNhcEEE7QGBPk/7FPgjxP+yT8VNQ+I/7Qemf8If4Z1TRpdEtL/7RHqHm3sk0E6ReXZtLIMx207bioUbME5IBAPYP2pP25/8AhTnx2134cf8ACrv7a/sX7N/p/wDwkP2bzvNtop/9X9mfbjzdv3jnbnjOB5//AMPNP+qJ/wDl1/8A3HXzB+3r428MfEb9rDxX4y8G6n/aWial9i+yXf2eSHzPLsreJ/kkVXGHjccgZxkcYNegf8E3vGX7PPhL/hM/+F82fh+4+2fYP7F/tfw4+qbdv2nz9m2GXy/vQ56buOu3gA9f/wCHmn/VE/8Ay6//ALjr6f8A2Kfjp/w0D8K9Q8Zf8It/wjv2HWpdM+yf2h9r37IYJfM3+XHjPnYxj+HOecD8ifjde+HtR+NHi/UPCKW6eHrvxBfTaOttbG3iW0a4doQkRVTGvllcLtG0YGBjFHgn4lfEXwdpUmmeEfH3ijw/YzTGeS10rWbi1ieUqqlykbgFiqqM4zhQO1AH7rV8gftSftz/APCnPjtrvw4/4Vd/bX9i/Zv9P/4SH7N53m20U/8Aq/sz7cebt+8c7c8ZwK/7UHxjb9oXwDZ+C/2TfHOsaj40sdTTVNQi0qe50WVdNSKWKRjPceQrL509sNgckkg7SFJHxBeWfiLwd+2Bo0H7Qj3FzfaX4g0ubxUdZuRqzPaAwSETMrS+ev2YqNoLfL8uO1AH1P8A8PNP+qJ/+XX/APcdfT/xL+On/CJfsbW3x5/4Rb7Z9o0bS9T/ALF/tDy9v2x7dfL8/wAs52faOuz5tvQZ4+QP2rvAngf9pD+wf+GPvBvh/Uv+EZ+0/wDCU/2RpcOheX9o8r7Lv+0LB52fIusbd23Bzt3DP2/8I/A1v/wzL4O8AeP/AA5p999h8M6ZY6rpWoQxXcHnwQRBkZTujfbJHkEZGVBB6GgD5A/4eaf9UT/8uv8A+46P+Hmn/VE//Lr/APuOvb/jVqX7F3wk8VW/hv4heC/h/o+p3Vkt9DB/wgguN0DO6B90Nq6j5onGCc8dORXIf8Lk/wCCef8A0CPh/wD+G4l/+Q6APP8A/h5p/wBUT/8ALr/+469//YY/aa/4aM/4Sj/iif8AhGv+Ea+x/wDMW+2faftHn/8ATGPZt8j3zu7Y58Y+N3xX/YU1H4L+L9P8I6V4HTxDd+H76HR2tvAMtvKt21u6wlJTaKI28wrhtw2nByMZryf/AIJS/G34YfBz/hPf+Fj+Jv7F/tr+zfsH+gXNz53lfa/M/wBTG+3Hmx/exndxnBwAff8A+1J8Tf8AhTnwJ134j/2J/bX9i/Zv9A+1/ZvO825ig/1mx9uPN3fdOduOM5HP/sU/HT/hoH4V6h4y/wCEW/4R37DrUumfZP7Q+179kMEvmb/LjxnzsYx/DnPOBx//AAUa1vS/E3/BOrxP4k0S6+1aZrFlpF9Yz+WyedBLf2jxvtYBlyrA4YAjPIFflz4J+JXxF8HaVJpnhHx94o8P2M0xnktdK1m4tYnlKqpcpG4BYqqjOM4UDtQB+u37a3x0/wCGfvhXp/jL/hFv+Ei+3a1Fpn2T+0PsmzfDPL5m/wAuTOPJxjH8Wc8YJ8NPjp/wlv7G1z8ef+EW+x/Z9G1TU/7F/tDzN32N7hfL8/yxjf8AZ+uz5d3Q452P2oPE3wa8K+AbPUPjhbaPP4ek1NIbVdV0RtSiF2YpWQiJYpCreWs3zbRgZGecH4g+NHw++PHxV8Taxrf7Mw1hvgrr0Ig0XT9H16PR9LliEKw3iLp8k0Plq1yt1vDRKHJZvmD5IB1H/DzT/qif/l1//cdfb/wn8T/8Jr8K/DPjL7D9h/4SLRrTU/snm+b9n8+FJfL34Xdt34zgZxnA6V8Afso+BPA/7N/9vf8ADYPg3w/pv/CTfZv+EW/tfS4dd8z7P5v2rZ9nWfycefa53bd2RjdtOM/xZ8NP2yfEfirU/EPwi1LxhD8PdWvZrzwhFpvjWOwtU0mVy9msNqblDBGIGiCxFEKLhdq4wAD9L6K8H/4J6eGvjL4V+C+qaf8AHC51i48QyeIJprVtV1tdSlFobe3VAJVlkCr5izfLuGDk45yfAP8AgoX+1p4H8VfBfS9P+B/xV1iDxDH4ghmum0qPUNNlNoLe4VwZWSMMvmND8u45ODjjIAO4/ak/bn/4U58dtd+HH/Crv7a/sX7N/p//AAkP2bzvNtop/wDV/Zn2483b945254zgd/8AsMftNf8ADRn/AAlH/FE/8I1/wjX2P/mLfbPtP2jz/wDpjHs2+R753dsc+cfs8/DjSfi7/wAE5pPE2s+ENH8W/EfX/D+tw22vaxaQXGqXN2st3Balr2cbwyBIURmcbAigEBRjh/2GP+MOv+Eo/wCGjv8Aii/+E0+x/wBg/wDMR+2fZPP+0f8AHl53l7PtUH39ud/y5w2ADoPix/wUO/4Qr4qeJvBv/CoPt3/CO61d6Z9r/wCEm8r7R5EzxeZs+ytt3bM4ycZxk9a5/wD4eaf9UT/8uv8A+468A+G/jT4UTf8ABRDVPHfjuTT9Q+HuoeJtbvpJNQ0mS7gngnW6Nu7WxjZzl5ISAUypwSBjj9Dvgr4b/ZV+LfhW48SfD34cfD/WNMtb1rGaf/hC4bfbOqI5TbNAjH5ZUOQMc9eDQByH7FP7YP8Aw0D8VNQ8G/8ACu/+Ed+w6NLqf2v+2/te/ZNBF5ezyI8Z87Oc/wAOMc5HP/tSftz/APCnPjtrvw4/4Vd/bX9i/Zv9P/4SH7N53m20U/8Aq/sz7cebt+8c7c8ZwPpfwT8Nfh14O1WTU/CPgDwv4fvpoTBJdaVo1vayvEWViheNASpZVOM4yoPYV+cH7VlhY6p/wV+t9M1Oyt72xvfFvhqC6tbmJZIp4ngsFdHRgQyspIIIwQSDQB6R/wAPNP8Aqif/AJdf/wBx0f8ADzT/AKon/wCXX/8Acde//HS2/ZB+Dn9l/wDCx/APw/0X+2vO+wf8URHc+d5Xl+Z/qbd9uPNj+9jO7jODjgP+Fyf8E8/+gR8P/wDw3Ev/AMh0Aef/APDzT/qif/l1/wD3HXsH7FP7YP8Aw0D8VNQ8G/8ACu/+Ed+w6NLqf2v+2/te/ZNBF5ezyI8Z87Oc/wAOMc5HX/BXw3+yr8W/Ctx4k+Hvw4+H+saZa3rWM0//AAhcNvtnVEcptmgRj8sqHIGOevBr4w/4Iqf8nTa//wBiZc/+ltlQB+n9FFFABRRRQAUUUUAfAH/Bc7/ml3/cY/8AbGvQP2lv+UNum/8AYmeGP/RthXn/APwXO/5pd/3GP/bGvb9c+HGufFv/AIJi+GPh74butPtdT1jwZ4e8ibUJHSBfKFnM25kR2HyxMBhTyR060AfkjX1//wAEVP8Ak6bX/wDsTLn/ANLbKj/h3F8b/wDoafh//wCDG9/+RK94/wCCen7JvxF+BHxo1Txd4u1rwve2N74fm02OPSrq4klEr3FvICRJBGNu2Fuc5yRx6AHg/wC0t/ymS03/ALHPwx/6KsK+3/2rv2cfBH7QP9g/8JlqviCx/wCEd+0/ZP7IuIYt/n+Vv3+bFJnHkpjGOpznjHxB+0t/ymS03/sc/DH/AKKsK+3/ANq79o7wR+z9/YP/AAmWleIL7/hIvtP2T+yLeGXZ5Hlb9/myx4z5yYxnoc44yAfKH7Zn7FXws+En7NniT4heG9f8YXWp6P8AZPIh1C8tngbzbuGFtypbox+WViMMOQOvSvCP2X/2sviL8CPAN54R8I6L4XvbG91N9Skk1W1uJJRK8UUZAMc8Y27YV4xnJPPp7v8Atmftq/Cz4t/s2eJPh74b0Dxha6nrH2TyJtQs7ZIF8q7hmbcyXDsPliYDCnkjp1rwj9l/9k34i/HfwDeeLvCOteF7KxstTfTZI9VuriOUypFFISBHBINu2Zec5yDx6gH6fftQfBTwr8d/ANn4R8XX+sWVjZammpRyaVNFHKZUiljAJkjkG3bM3GM5A565/LH9orw3Y/s5ftpXGmeCJbi/h8D6npmpac2sssrSyrDb3YExiEYZfMYjChTt4znmuf8A2X/gp4q+O/j688I+Eb/R7K+stMfUpJNVmljiMSSxRkAxxyHdumXjGMA8+v2P4Z+I+h/Cv4NyfsP+IbXULn4hX9ldeHItUsI0fRhc6uZJLZ2ld1m8tRfReYRCWBV9qvgZAPlD9q79o7xx+0D/AGD/AMJlpXh+x/4R37T9k/si3mi3+f5W/f5ksmceSmMY6nOeMdB/wS4/5Ps8C/8AcR/9Nt1Xf/8ADuL43/8AQ0/D/wD8GN7/APIlfov8EfDd94O+C/hDwjqctvNfeH/D9jpt1JbMzRPLDbpG5QsASpZTgkA4xkCgDy/9qD9k34dfHfx9Z+LvF2teKLK+stMTTY49KureOIxJLLICRJBId26Zuc4wBx1z+eP7UH7WXxF+O/gGz8I+LtF8L2VjZammpRyaVa3EcplSKWMAmSeQbdszcYzkDn1/Q79qD9rL4dfAjx9Z+EfF2i+KL2+vdMTUo5NKtbeSIRPLLGATJPGd26FuMYwRz1x2H7UHxr8K/AjwDZ+LvF2n6xe2N7qaabHHpUMUkoleKWQEiSSMbdsLc5zkjjrgA/EmivePi98a/Cvir9vy0+OGn6frEfh6DxBo2pNazwxLemK0S1WQBBIU3EwPtG/ByMkc4+x/+HjvwQ/6Fb4gf+C6y/8AkugDl/gj+wN8HvGPwX8IeLtT8SeOIb7xB4fsdSuo7a/tFiSWa3SRwga2JChmOASTjGSa6j/h3F8EP+hp+IH/AIMbL/5Ern/2X/2cfHE/7XunftPpqvh8eEfE97qHiOzsTcTf2lHbalb3DwJJH5XlCRRcx7wJSow2GbAz9v0AfmB/wRU/5Om1/wD7Ey5/9LbKuA/4Kj/8n2eOv+4d/wCm21r9Bv8AgoX8FPFXx3+C+l+EfCN/o9lfWXiCHUpJNVmljiMSW9xGQDHHId26ZeMYwDz6+MfC39o7wR+yT4Esf2fPiPpXiDVPE3g/zPt934et4Z7CX7VI97H5TzSxSHEdzGG3RrhgwGQASAc//wAEMf8AmqP/AHB//b6vv+vyh/4KQ/tHeCP2gf8AhDP+EN0rxBY/8I79v+1/2vbwxb/P+zbNnlSyZx5L5zjqMZ5xP8Pf2BvjD4x8A6H4u0zxJ4HhsfEGmW+pWsdzf3aypFNEsiBwtsQGCsMgEjOcE0AbH/Bav/k6bQP+xMtv/S29rzj/AIJ6fBTwr8d/jRqnhHxdf6xZWNl4fm1KOTSpoo5TKlxbxgEyRyDbtmbjGcgc9c+j/wDDuL43/wDQ0/D/AP8ABje//IlfIFAHqH7Znw40P4SftJ+JPh74butQutM0f7J5E2oSI87ebaQzNuZERT80rAYUcAdeteX193/sZ/tq/Cz4Sfs2eG/h74k0Dxhdano/2vz5tPs7Z4G827mmXaz3CMfllUHKjkHr1r1D/h478EP+hW+IH/gusv8A5LoA9P8ABPw40P4t/sAeCfh74kutQtdM1jwZoXnzafIiTr5UNtMu1nR1HzRKDlTwT061+dP/AAUL+CnhX4EfGjS/CPhG/wBYvbG98Pw6lJJqs0Ukole4uIyAY44xt2wrxjOSeemOfs/Dd9+0b+2BrOmeCJbewm8ceINU1LTm1lmiWKJjPdgTGISFW8tSMKGG7jOOa+t/gr8R9D/YR8K3Hwi+LtrqGta3rV63iO3uPCkaXNqttKiWyo7XDwOJA9nKSAhXay/MSSAAc/8ABX4j65+3d4quPhF8XbXT9F0TRbJvEdvceFI3trprmJ0tlR2uHnQxlLyUkBA25V+YAEH63s/Ddj+zl+x/rOmeCJbi/h8D+H9U1LTm1lllaWVRPdgTGIRhl8xiMKFO3jOea+GP+HcXxv8A+hp+H/8A4Mb3/wCRK7jXfjX4V/Z6/Zc8Qfsm+NNP1i+8aad4f1LTZdQ0eGKXS2l1BJriErJLJHLtVLyIOTECCGwGABIB80ftXftHeOP2gf7B/wCEy0rw/Y/8I79p+yf2RbzRb/P8rfv8yWTOPJTGMdTnPGP0O1z4j658JP8AgmL4Y+IXhu10+61PR/Bnh7yIdQjd4G80WcLblR0Y/LKxGGHIHXpX54/so/s4+OP2gf7e/wCEN1Xw/Y/8I79m+1/2vcTRb/P83Zs8uKTOPJfOcdRjPOPf/hb+zj44/ZJ8d2P7QfxH1Xw/qnhnwf5n2+08PXE09/L9qjeyj8pJoooziS5jLbpFwoYjJABAOf8A+Hjvxv8A+hW+H/8A4Lr3/wCS6sf8FC/2Tfh18CPgvpfi7wjrXii9vr3xBDpskeq3VvJEInt7iQkCOCM7t0K85xgnjpj3j/h478EP+hW+IH/gusv/AJLr3f8Aag+NfhX4EeAbPxd4u0/WL2xvdTTTY49KhiklErxSyAkSSRjbthbnOckcdcAH5s/AX9tX4p/CT4T6T8PfDegeD7rTNH87yJtQs7l5282eSZtzJcIp+aVgMKOAOvWvb/gX/wAbAv7U/wCFy/8AEj/4V35P9lf8Ij/o3n/bvM83z/tP2jdj7FFt27cbnzuyMZ/ib4ca58VPjJH+3B4eutPtvh7YXtr4jl0u/kdNZNtpAjjuUWJEaHzGNjL5YMwUhk3MmTjzD/gpD+0d4I/aB/4Qz/hDdK8QWP8Awjv2/wC1/wBr28MW/wA/7Ns2eVLJnHkvnOOoxnnAB9P/APDuL4If9DT8QP8AwY2X/wAiV7v+y/8ABTwr8CPAN54R8I3+sXtje6m+pSSarNFJKJXiijIBjjjG3bCvGM5J56Y8I/aW/wCUNum/9iZ4Y/8ARthR/wAEVP8Ak1nX/wDsc7n/ANIrKgCv/wAE9P2sviL8d/jRqnhHxdovheysbLw/NqUcmlWtxHKZUuLeMAmSeQbdszcYzkDn18H/AGlv+UyWm/8AY5+GP/RVhXvH/BPT9k34i/Aj40ap4u8Xa14XvbG98PzabHHpV1cSSiV7i3kBIkgjG3bC3Oc5I49PB/2lv+UyWm/9jn4Y/wDRVhQB6B/wXO/5pd/3GP8A2xr4Ar9X/wDgpD+zj44/aB/4Qz/hDdV8P2P/AAjv2/7X/a9xNFv8/wCzbNnlxSZx5L5zjqMZ5x8v/wDDuL43/wDQ0/D/AP8ABje//IlAH0B/wRU/5NZ1/wD7HO5/9IrKvn//AIIqf8nTa/8A9iZc/wDpbZV9j/8ABPT4KeKvgR8F9U8I+Lr/AEe9vr3xBNqUcmlTSyRCJ7e3jAJkjjO7dC3GMYI59Pjj/gip/wAnTa//ANiZc/8ApbZUAfp/RRRQAUUUUAFFFFAHxB/wWU8CeOPGv/CuP+EN8G+IPEX2H+1ftf8AZGlzXf2ff9j2b/LVtu7Y+M9dpx0NeH+E/iT+3x4Z8K6Z4b0Tw98QLXTNHsobGxg/4V4j+TBEgSNNzWZZsKoGWJJxyTX6n15/+1J8Tf8AhTnwJ134j/2J/bX9i/Zv9A+1/ZvO825ig/1mx9uPN3fdOduOM5AB8Af8Lk/4KGf9Aj4gf+G4i/8AkOj/AIXJ/wAFDP8AoEfED/w3EX/yHXoH/DzT/qif/l1//cdewfsU/tg/8NA/FTUPBv8Awrv/AIR37Do0up/a/wC2/te/ZNBF5ezyI8Z87Oc/w4xzkAHxx8NvB37RHjH9szwZ8RviN8O/HE19N4t0efVNUufCk9rEkUM8Cb32QpGirFEuTgDCknua9n/4Lnf80u/7jH/tjXsHxL/bB/4RL9sm2+A3/Cu/tn2jWtL0z+2v7b8vb9sS3bzPI8g52faOm/5tvUZ48f8A+C53/NLv+4x/7Y0AcP8AF7wB+yvYfsB2nifwxf8Ahdvie3h/RppoYPFjzXv2uR7UXYNmbggMFafcvl/Jg8Lt49Q/4JE/Er4deDv2bdb0zxd4+8L+H76bxbcTx2uq6zb2srxG0tFDhJHBKllYZxjKkdjXD/Cf/gnj/wAJr8K/DPjL/hb/ANh/4SLRrTU/sn/CM+b9n8+FJfL3/al3bd+M4GcZwOleAftrfAz/AIZ++Kmn+Df+Ep/4SL7do0Wp/a/7P+ybN808Xl7PMkzjyc5z/FjHGSAe3/8ABL/Qtc+Dnx91fxP8XdG1DwBol34ZnsLfVPFdq+lWs1y1zayLAktwERpCkUrBAdxWNjjCnFj4teE/FXjf/gqFpPxK8F+GdY8R+C5/Fvh+eLxLo9hLeaXJFAtmkzrdRK0RWN4pVchsKY2BwVNcR+2t+2D/AMNA/CvT/Bv/AArv/hHfsOtRan9r/tv7Xv2QzxeXs8iPGfOznP8ADjHOR9vf8EuP+TE/Av8A3Ef/AE5XVAHAf8FWvjb8T/g5/wAIF/wrjxN/Yv8AbX9pfb/9AtrnzvK+yeX/AK6N9uPNk+7jO7nOBjv/AIkeNPivN/wTv0vx34Ek1DUPiFqHhnRL6OTT9Jju55552tTcOtsI2Q5SSYkBMKMkAY4P25/2Zf8Ahoz/AIRf/itv+Ea/4Rr7Z/zCftn2n7R5H/TaPbt8j3zu7Y56D4l+J/8Ahmf9ja21X7D/AMJR/wAIHo2l6Z5fm/Yvt217ez8zOJfL+9vxhumM96APnD4K6N8PPip4VuPEP7cE2n2HxCtr1rPS4vFepHw1dHSVRHiZLVHtw8fnyXYEuwksGXcdmBx/7FPjbxP+1t8VNQ+HH7Qep/8ACYeGdL0aXW7Sw+zx6f5V7HNBAkvmWaxSHEdzOu0sVO/JGQCOg/4Vl/w8C/4vL/bf/Cu/7D/4pn+yvsn9r+f5P+lef52+325+27dmw48vO47sD5g/Yp+On/DP3xU1Dxl/wi3/AAkX27RpdM+yf2h9k2b5oJfM3+XJnHk4xj+LOeMEA6j9ob4efDbwX/wUZj+Hken2+k+A4PEGiQ3tvc6hKsUNpNFaPcl7iSTeikSSksXG0E4IAGO3/bn+CXwwuP8AhF/+GU/DP/CVbftn/CSf8Ijf3Ov/AGX/AFH2bz9kk3k7v9J25279r9dvHkHxL8T/APDTH7ZNtqv2H/hF/wDhPNa0vTPL837b9h3Jb2fmZxF5n3d+ML1xnvX6PfsMfsy/8M5/8JR/xW3/AAkv/CS/Y/8AmE/Y/s32fz/+m0m7d5/tjb3zwAY/xa8UeNfhL/wS90nX9AnuPD/inQPCXh+AG5skaWzlLWcEqPDMhAYK0ikMuQc9CKsf8Ev/AIpeO/i38AtX8SfELXf7Y1O18TT2MM/2OC32wLbWrhNsKIp+aVzkjPPXgV6h+1J8Mv8AhcfwJ134cf23/Yv9tfZv9P8Asn2nyfKuYp/9XvTdnytv3hjdnnGDz/7FPwM/4Z++FeoeDf8AhKf+Ei+3a1Lqf2v+z/smzfDBF5ezzJM48nOc/wAWMcZIB4x/wT08fftUeKvjRqmn/HCw8UQeHo/D801q2q+E002I3YuLdUAlW3jLN5bTfLuORk44yPH/ANrD4NeMvG//AAU2e7u/hv4o1XwXqviDQodQ1CDSrr7FJafZ7OO4JuY1AVVUSBmDDbtPIIr9J65/4seJ/wDhCvhX4m8ZfYft3/CO6Nd6n9k83yvtHkQvL5e/Dbd2zGcHGc4PSgD84P8Agq18Evhh8HP+EC/4Vx4Z/sX+2v7S+3/6fc3PneV9k8v/AF0j7cebJ93Gd3OcDH1frms/EPw//wAExfDGr/CmHUJvF1v4M8Pf2amn6aL6c7hZrLtgKOH/AHTSZ+U4GTxjI+Ef25/2mv8Ahoz/AIRf/iif+Ea/4Rr7Z/zFvtn2n7R5H/TGPZt8j3zu7Y59f+E//BQ7/hCvhX4Z8G/8Kg+3f8I7o1ppn2v/AISbyvtHkQpF5mz7K23dszjJxnGT1oA+p/8Agnp4m+Mvir4L6pqHxwttYg8Qx+IJobVdV0RdNlNoLe3ZCIlijDL5jTfNtOTkZ4wPgn/gl/8AC3wJ8W/j7q/hv4haF/bGmWvhme+hg+1z2+2dbm1QPuhdGPyyuME456cCvb/+Hmn/AFRP/wAuv/7jrz//AIIqf8nTa/8A9iZc/wDpbZUAch8cPhb4E8P/APBS6y+FOkaF9n8IzeJtCsX037XO+YLmOzMyeazmX5jLJzuyN3BGBj0//gpD+yvpHhL/AIQz/hQ3wn8QXH2z7f8A21/ZEV/qm3b9m8jfuaXy/vTY6bueu3jn/wBpb/lMlpv/AGOfhj/0VYV9f/tz/tNf8M5/8Iv/AMUT/wAJL/wkv2z/AJi32P7N9n8j/pjJv3ef7Y2988AHjHjX4P8AhL4C/sQ6b8dfBPha48L/ABX0Xw/pMzanczXEstrd3Rt7e8D2lwzQhitxOhVo/kLHAUqMWP2KfBHhj9rb4V6h8R/2g9M/4TDxNpetS6JaX/2iTT/Kso4YJ0i8uzaKM4kuZ23FSx34JwAB4/8AtSftz/8AC4/gTrvw4/4Vd/Yv9tfZv9P/AOEh+0+T5VzFP/q/sybs+Vt+8Mbs84wcD9in9sH/AIZ++FeoeDf+Fd/8JF9u1qXU/tf9t/ZNm+GCLy9nkSZx5Oc5/ixjjJAPpf8A4J6ePv2qPFXxo1TT/jhYeKIPD0fh+aa1bVfCaabEbsXFuqASrbxlm8tpvl3HIyccZHzf+2xZ+HtR/wCCql1p/i57dPD134g0CHWGubk28S2jWtksxeUMpjXyy2W3DaMnIxmv1Xr5A/ak/YY/4XH8dtd+I/8AwtH+xf7a+zf6B/wj32nyfKtooP8AWfaU3Z8rd90Y3Y5xkgHn/wAdP+LSf2X/AMMGf8TD+2PO/wCEz/4RH/iqPL8ry/sXn+Z9p+z5828242b8P97Z8vs/7WGnePfG/wDwTJe0u9D1jVfGmq+H9Cm1DT4NMb7bJd/aLOS4Bto0BVlYSFlCjbtPAArxj/lHR/1Ur/hZX/cG/s77B/4Eeb5n27/Y2+X/ABbuPQP2W/25/wDhcfx20L4cf8Ku/sX+2vtP+n/8JD9p8nyraWf/AFf2ZN2fK2/eGN2ecYIB4/8AsU/BT4AwfCvUE/af0jT/AAx4uOtSmxs/Feu3GhXUmn+TB5ciW7TQlozL9oAk2nLKwz8uAfsU+NvE/wC1t8VNQ+HH7Qep/wDCYeGdL0aXW7Sw+zx6f5V7HNBAkvmWaxSHEdzOu0sVO/JGQCPoD9tb9j7/AIaB+Kmn+Mv+Fif8I79h0aLTPsn9ifa9+yaeXzN/nx4z52MY/hznnAP2Kf2Pv+GfvipqHjL/AIWJ/wAJF9u0aXTPsn9ifZNm+aCXzN/nyZx5OMY/iznjBAPn/wCJfjbxP8P/ANsm2/ZT8I6n/Z3wiu9a0vRJvDf2eObfZailu97F9qkVrkeY13cHcJdy7/kK4XHP/wDBVr4JfDD4Of8ACBf8K48M/wBi/wBtf2l9v/0+5ufO8r7J5f8ArpH2482T7uM7uc4GMD9u7xP/AMIV/wAFP9U8ZfYft3/CO61oep/ZPN8r7R5FpZS+Xvw23dsxnBxnOD0r1/8A5SL/APVNf+Fa/wDcZ/tH7f8A+A/leX9h/wBvd5n8O3kA9Q+Nuha54m/4JF6NonhvRtQ1jU7rwZ4a8ix0+1e4nm2vYu22NAWbCqzHA4AJ7Vz/APwS/wBe0P4OfALV/DHxd1nT/AGt3fiae/t9L8V3SaVdTWzW1rGs6RXBR2jLxSqHA2lo2GcqcfV/wn8M/wDCFfCvwz4N+2/bv+Ed0a00z7X5XlfaPIhSLzNmW27tmcZOM4yeteAftrfsff8ADQPxU0/xl/wsT/hHfsOjRaZ9k/sT7Xv2TTy+Zv8APjxnzsYx/DnPOAAcv/wT08fftUeKvjRqmn/HCw8UQeHo/D801q2q+E002I3YuLdUAlW3jLN5bTfLuORk44yPB/28vAXxn/4b48QeP/AHw+8YX32G90u+0rVdP8Oz3cHnwWdqVdWEbRvtkjwQcjKkEdRX2/8AtrfHT/hn74V6f4y/4Rb/AISL7drUWmfZP7Q+ybN8M8vmb/LkzjycYx/FnPGD8wf8PNP+qJ/+XX/9x0Aef/8AC5P+Chn/AECPiB/4biL/AOQ6P+Fyf8FDP+gR8QP/AA3EX/yHX1/+wx+01/w0Z/wlH/FE/wDCNf8ACNfY/wDmLfbPtP2jz/8ApjHs2+R753dsc+gftSfE3/hTnwJ134j/ANif21/Yv2b/AED7X9m87zbmKD/WbH2483d905244zkAHwB/wuT/AIKGf9Aj4gf+G4i/+Q66j/gkT8NfiL4O/aS1vU/F3gDxR4fsZvCVxBHdaro1xaxPKbu0YIHkQAsVVjjOcKT2rY/4eaf9UT/8uv8A+469g/Yp/bB/4aB+KmoeDf8AhXf/AAjv2HRpdT+1/wBt/a9+yaCLy9nkR4z52c5/hxjnIAPp+iiigAooooAKKKKAPiD/AILKeO/HHgr/AIVx/wAIb4y8QeHft39q/a/7I1Sa0+0bPsezf5bLu273xnpuOOpr0f4teF/Gvxa/4Je6ToGgQXGv+KfEHhLw/OBc3qLLeShrOeV3mmcAsVWRiWbJOepNdx+1d+zj4I/aB/sH/hMtV8QWP/CO/afsn9kXEMW/z/K37/NikzjyUxjHU5zxj0j4e+G7Hwd4B0PwjpktxNY+H9Mt9NtZLllaV4oYljQuVABYqoyQAM5wBQB8wf8ABPT9mS18K/BfVNP+OHwk8L3HiGTxBNNatqtjY6lKLQ29uqASr5gVfMWb5dwwcnHOT4v+xT4I8T/sk/FTUPiP+0Hpn/CH+GdU0aXRLS/+0R6h5t7JNBOkXl2bSyDMdtO24qFGzBOSAf0fr88Pgr8R9c/bu8VXHwi+Ltrp+i6Jotk3iO3uPCkb2101zE6Wyo7XDzoYyl5KSAgbcq/MACCAe76L8df2MPG/xc0q7tJPC+q+NNV1O1h0/UJ/Bdx9tku9yR25FzJagqysIwrFht2jkAV4x/wXO/5pd/3GP/bGuw8WfsVfCz4OeFdT+LvhjX/GF3rfgCym8R6Xb6leW0lrNc2SG5iSZUt0doy8ShgrqxUnDA8jj/gX/wAbAv7U/wCFy/8AEj/4V35P9lf8Ij/o3n/bvM83z/tP2jdj7FFt27cbnzuyMAHt+uaN8Q/EH/BMXwxpHwpm1CHxdceDPD39mvp+pCxnG0WbS7Zy6BP3SyZ+YZGRznB+KfG37KP7Y/jHVY9T8XeGNY8QX0MIgjutV8XWV1KkQZmCB5LokKGZjjOMsT3rt/Fn7avxT+DnirU/hF4Y0Dwfd6J4AvZvDml3GpWdzJdTW1k5tonmZLhEaQpEpYqiqWJwoHA+t/8Agnp8a/FXx3+C+qeLvF2n6PZX1l4gm02OPSoZY4jElvbyAkSSSHdumbnOMAceoB5x/wALk/4J5/8AQI+H/wD4biX/AOQ66/wt+15+yN4Z0GDRPDfjPT9H0y13eRY6f4Wv7eCHcxdtsaWwVcszMcDkknvXIf8ADuL4If8AQ0/ED/wY2X/yJR/w7i+CH/Q0/ED/AMGNl/8AIlAHj/8AwUh/ao0jxb/whn/Chvix4gt/sf2/+2v7Ilv9L3bvs3kb9yxeZ92bHXbz03c/OHhbxF8e/jZr0HwxsPHHjDxVca5u2aPqHiaVoLryVM53C4lEXyiIuNx6qMc4r1D/AIKQ/s4+CP2fv+EM/wCEN1XxBff8JF9v+1/2vcQy7PI+zbNnlRR4z5z5znoMY5z6voXwU8K/s9fsueH/ANrLwXqGsX3jTTvD+m6lFp+sTRS6W0uoJDbzBo4o45dqpeSlAJQQQuSwBBAPL/BP7N/7cXg7SpNM8I2Pijw/YzTGeS10rxxa2sTylVUuUjuwCxVVGcZwoHavsf4K6l+xd8W/FVx4b+Hvgv4f6xqdrZNfTQf8IILfbArohfdNaop+aVBgHPPTg18of8PHfjf/ANCt8P8A/wAF17/8l19j/sv/ALJvw6+BHj688XeEda8UXt9e6Y+myR6rdW8kQieWKQkCOCM7t0K85xgnjpgA+Gf2ml8IfDP/AIKlw3FvYaf4d8M+HfE3h++mh0+xEUFpAkNlNK6wwr/vsQq5JJ4JNd//AMFIf2qNI8W/8IZ/wob4seILf7H9v/tr+yJb/S9277N5G/csXmfdmx1289N3PD/tseG7Hxj/AMFVLrwjqctxDY+IPEGgabdSWzKsqRTWtlG5QsCAwVjgkEZxkGvpj/h3F8EP+hp+IH/gxsv/AJEoA+b/AAn8Nv2+PE3hXTPEmieIfiBdaZrFlDfWM/8AwsNE86CVA8b7WvAy5VgcMARnkCvtf/gnp4a+MvhX4L6pp/xwudYuPEMniCaa1bVdbXUpRaG3t1QCVZZAq+Ys3y7hg5OOcnxj9l/9o7xxb/te6d+zAmleHz4R8MXuoeHLO+NvN/aUltptvcJA8knm+UZGFtHvIiCnLYVcjGx/wUL/AGsviL8CPjRpfhHwjovhe9sb3w/DqUkmq2txJKJXuLiMgGOeMbdsK8Yzknn0AD9qD4xt+0L4Bs/Bf7JvjnWNR8aWOppqmoRaVPc6LKumpFLFIxnuPIVl86e2GwOSSQdpCkj5/wBW+Bn7f2qaVc6Zqd344vbG9heC6tbn4hQSRTxOpV0dGvCGVlJBBGCCQa+z/wBl/wDZN+HXwI8fXni7wjrXii9vr3TH02SPVbq3kiETyxSEgRwRnduhXnOME8dMeofG7xJfeDvgv4v8XaZFbzX2geH77UrWO5VmieWG3eRA4UglSyjIBBxnBFAHyR/wTe/ZX1fwl/wmf/C+fhP4fuPtn2D+xf7XisNU27ftPn7NrS+X96HPTdx128en/tmfs4eE/EH7NniTSPhT8IfB8Pi64+yf2a+n6TY2M423cLS7ZyECfulkz8wyMjnOD8of8PHfjf8A9Ct8P/8AwXXv/wAl0f8ADx343/8AQrfD/wD8F17/APJdAHcfsv6Z8Ev2evAN54L/AGsvCnhfTvGl9qb6pp8Wq+Hk1qVtNeKKKNhPbxTqq+dBcjYXBBBO0BgT9X+Nrj9n/wDZy0qPxvqfh3wv4Hhv5hpS6jpXhoLLKzq0vkk2sJfaRAW5+XKDPOK+aPgr8OND/bu8K3Hxd+Lt1qGi63ot63hy3t/CkiW1q1tEiXKu63CTuZC95KCQ4Xaq/KCCTz/wV+I+uft3eKrj4RfF210/RdE0WybxHb3HhSN7a6a5idLZUdrh50MZS8lJAQNuVfmABBAPUPir8aP2UviRZ61F4Gn8P6l8VfEFk9n4X1IeFJ4NSbVmi8mxaO+lt1MMiy+SElaRRHtU7lC5HxB+1d4N/aG8Jf2D/wAL5vPEFx9s+0/2L/a/iNNU27fK8/Ztml8v70Oem7jrt4+z/Fn7FXws+DnhXU/i74Y1/wAYXet+ALKbxHpdvqV5bSWs1zZIbmJJlS3R2jLxKGCurFScMDyOP+Bf/GwL+1P+Fy/8SP8A4V35P9lf8Ij/AKN5/wBu8zzfP+0/aN2PsUW3btxufO7IwAfOHhP9kD9onxN4V0zxJonw8+1aZrFlDfWM/wDbenp50EqB432tOGXKsDhgCM8gVof8MS/tO/8ARM//ACv6b/8AJFfot+0V4kvv2cv2LbjU/BEVvfzeB9M0zTdOXWVaVZYlmt7QGYRGMs3lsTlSo3c4xxWf/wAE9PjX4q+O/wAF9U8XeLtP0eyvrLxBNpscelQyxxGJLe3kBIkkkO7dM3OcYA49QDzD9qD4xt+0L4Bs/Bf7JvjnWNR8aWOppqmoRaVPc6LKumpFLFIxnuPIVl86e2GwOSSQdpCkjPs/j9p3wq/Y/wBZ+Evxa+IWsaf8atP8P6pDLFPJd3t7Fd3AnlsiL+ISR7vKmtirCX5MgEqVIGP8avhxof7CPhW3+LvwiutQ1rW9avV8OXFv4rkS5tVtpUe5Z0W3SBxIHs4gCXK7Wb5SSCND4W/s4+CP2tvAlj+0H8R9V8QaX4m8YeZ9vtPD1xDBYRfZZHso/KSaKWQZjtoy26RssWIwCAAD4A8deO/HHjX7L/wmXjLxB4i+w7/sn9r6pNd/Z9+3fs8xm27tiZx12jPQV7B/wS4/5Ps8C/8AcR/9Nt1X1/8A8O4vgh/0NPxA/wDBjZf/ACJXP/FL9nHwR+yT4Evv2g/hxqviDVPE3g/y/sFp4huIZ7CX7VIllJ5qQxRSHEdzIV2yLhgpOQCCAcP/AMFdviV8RfB37SWiaZ4R8feKPD9jN4St55LXStZuLWJ5Td3alykbgFiqqM4zhQO1fS//AA21+zF/0Uz/AMoGpf8AyPXiHwV+HGh/t3eFbj4u/F261DRdb0W9bw5b2/hSRLa1a2iRLlXdbhJ3Mhe8lBIcLtVflBBJ+aP+CenwU8K/Hf40ap4R8XX+sWVjZeH5tSjk0qaKOUypcW8YBMkcg27Zm4xnIHPXIB6/8Yfh1rPxU/a0/wCGmdE8P2+vfBVtT07VNQ1q5eERS6bYRwRX7PZTMLh1T7LcqU8olwh2qwZc4/7c/wAbfhhb/wDCL/8ADKfib/hFd32z/hJP+ERsLnQPtX+o+zefsjh87b/pO3O7Zufpu57DxN8R9c+Ffxkj/Yf8PWun3Pw9v7218OS6pfxu+si21cRyXLrKjrD5im+l8smEqAqblfBz5h/wUh/Zx8Efs/f8IZ/whuq+IL7/AISL7f8Aa/7XuIZdnkfZtmzyoo8Z8585z0GMc5AO/wD2WJ/2jvh/4u8L/G342+LvGCfCJLI31/f6h4qfUYHgurVo7R2s0mklbdNPb4HlEqSGIXaSOX/4KF/tN3fir40aXqHwP+LfiiDw9H4fhhul0q+vtNiN2Li4ZyYm8ss3ltD8205GBnjA0P2a/jX4q/aFj8K/sm+NNP0ex8F6jpkemy6ho8MsWqLFp9t9ohKySySRbmeziDkxEEFsBSQR5h/wUL+CnhX4EfGjS/CPhG/1i9sb3w/DqUkmqzRSSiV7i4jIBjjjG3bCvGM5J56YAPd/gro3xD+Ffiq48Q/twTahf/D25sms9Li8V6kPEtqNWZ0eJktUe4KSeRHdgS7AApZdw34PsHhP4k/sD+JvFWmeG9E8PfD+61PWL2GxsYP+FeOnnTyuEjTc1mFXLMBliAM8kV7P+1B8FPCvx38A2fhHxdf6xZWNlqaalHJpU0UcplSKWMAmSOQbdszcYzkDnrnyD4e/sDfB7wd4+0PxdpniTxxNfeH9Tt9StY7m/tGieWGVZEDhbYEqWUZAIOM4IoA+h/AvgTwR4K+1f8Ib4N8P+Hft2z7X/ZGlw2n2jZu2b/KVd23e+M9Nxx1NfKH/AAUi/aI+DviD9njx98KdI8YfaPF0N7BYvpv9mXaYnttQhMyea0Qi+URSc7sHbwTkZ7D/AIKQ/tHeOP2fv+EM/wCEN0rw/ff8JF9v+1/2vbzS7PI+zbNnlyx4z5z5znoMY5z8/wD7UH7OPgif9kLUf2n31XxAPF3iey0/xHeWIuIf7NjudSuLd50jj8rzRGpuZNgMpYYXLNg5AMf/AIJ6ePv2V/CvwX1TT/jhYeF5/EMniCaa1bVfCb6lKLQ29uqASrbyBV8xZvl3DBycc5PpH/BL/wDZ3+MXwk+Pur+JPiF4P/sfTLrwzPYwz/2naXG6drm1cJthldh8sTnJGOOvIrzf/gnp+yb8Ovjv8F9U8XeLta8UWV9ZeIJtNjj0q6t44jElvbyAkSQSHdumbnOMAcdc+4f8E9P2sviL8d/jRqnhHxdovheysbLw/NqUcmlWtxHKZUuLeMAmSeQbdszcYzkDn1APseiiigAooooAKKKKAPmD/gpD+zj44/aB/wCEM/4Q3VfD9j/wjv2/7X/a9xNFv8/7Ns2eXFJnHkvnOOoxnnHz/wDtQftHeCLf9kLUf2YH0rxAfF3hiy0/w5eXwt4f7NkudNuLdJ3jk83zTGxtpNhMQY5XKrk4+/8Ax1478EeCvsv/AAmXjLw/4d+3b/sn9r6pDafaNm3fs81l3bd6Zx03DPUV8sftxfs0fCvWvgD4t+J3wx8B3GueNNcmt9Vsb7Rr69v2vmub2F5poYUkeN1aKWVvlQqFORgAEAFj/gip/wAms6//ANjnc/8ApFZV8/8A/DuL43/9DT8P/wDwY3v/AMiV5R4J+Ln7Rn7OWlSeCNMutY8Dw38x1VtO1Xw7CssrOqxecBdQF9pEAXj5cocc5r9Vv+F7fBD/AKLJ8P8A/wAKiy/+OUAfnR8Qv2BvjD4O8A654u1PxJ4HmsfD+mXGpXUdtf3bSvFDE0jhA1sAWKqcAkDOMkV8sV93/tofE39prxZ8TPGGgfCFfEHij4Va1ZJY2d14e8MRanYXkEtnHHdJFexwOX/etOjFZMqwZcgrgcf+wx8Evhhb/wDCUf8ADVnhn/hFd32P/hG/+Euv7nQPtX+v+0+Rvkh87b/o27G7ZuTpu5AOA/4Jcf8AJ9ngX/uI/wDptuq+t/8AgoX+yb8Rfjv8aNL8XeEda8L2VjZeH4dNkj1W6uI5TKlxcSEgRwSDbtmXnOcg8evp/gD4EfswfCi40/4w+HdL0fQYbCET2XiKfxNctZLFcRmFXEk1w0LLIs21Scg7xjnFeweCfFnhXxjpUmp+EfEuj+ILGGYwSXWlX8V1EkoVWKF42IDBWU4znDA9xQBsUV+TPgn9q79sfxjqsmmeEfE+seIL6GEzyWuleEbK6lSIMqlykdqSFDMozjGWA710/wDwuT/goZ/0CPiB/wCG4i/+Q6APqD/gpD+zj44/aB/4Qz/hDdV8P2P/AAjv2/7X/a9xNFv8/wCzbNnlxSZx5L5zjqMZ5x8v/wDDuL43/wDQ0/D/AP8ABje//IlYHjr9p/8AbV8FfZf+Ey1vxB4d+3b/ALJ/a/gy0tPtGzbv2eZaru270zjpuGeor9Bv2Z/jL4N8b/DXwTaXfxI8L6r401Xw/Zzahp8Gq2v22S7+yrJcA20bAqysJCyhRt2ngAUAflD+1B8FPFXwI8fWfhHxdf6Pe317pialHJpU0skQieWWMAmSOM7t0LcYxgjn07D/AIJ6fGvwr8CPjRqni7xdp+sXtje+H5tNjj0qGKSUSvcW8gJEkkY27YW5znJHHXH6HftQeAP2V/FXj6z1D44X/he38Qx6YkNquq+LH02U2gllZCIluIwy+Y03zbTk5GeMD4w/4J6fsyXfir40app/xw+Enii38PR+H5prVtVsb7TYjdi4t1QCVfLLN5bTfLuORk44yADuPE3w41z4qfGSP9uDw9dafbfD2wvbXxHLpd/I6aybbSBHHcosSI0PmMbGXywZgpDJuZMnH1f+yj+0d4I/aB/t7/hDdK8QWP8Awjv2b7X/AGvbwxb/AD/N2bPKlkzjyXznHUYzzg+L/gnwx8Of2HfHng3wbpn9m6JpvgzW/slp9okm8vzLe4lf55GZzl5HPJOM4HGBX5g/so+Mv2hvCX9vf8KGs/EFx9s+zf21/ZHhxNU27fN8jfuhl8v702Om7nrt4APof43fsDfGHxj8aPF/i7TPEngeGx8QeIL7UrWO5v7tZUimuHkQOFtiAwVhkAkZzgmuo+CvxH0P9hHwrcfCL4u2uoa1retXreI7e48KRpc2q20qJbKjtcPA4kD2cpICFdrL8xJIHoHx0/aNfw5+wyuqaX8T/D9r8XbXRtJF/YG5sm1K31Ay2y3scliwOyRc3AeMxjy8Nwu3jyf9l/U/gl+0L4BvPGn7WXivwvqPjSx1N9L0+XVfEKaLKumpFFLGogt5YFZfOnuTvKEkkjcQoAAOP/4KF/tZfDr47/BfS/CPhHRfFFlfWXiCHUpJNVtbeOIxJb3EZAMc8h3bpl4xjAPPTPUfsZ/tq/Cz4Sfs2eG/h74k0Dxhdano/wBr8+bT7O2eBvNu5pl2s9wjH5ZVByo5B69a8g/4Jf8Awt8CfFv4+6v4b+IWhf2xplr4ZnvoYPtc9vtnW5tUD7oXRj8srjBOOenAo+OHwt8CeH/+Cl1l8KdI0L7P4Rm8TaFYvpv2ud8wXMdmZk81nMvzGWTndkbuCMDAB9X/APDx34If9Ct8QP8AwXWX/wAl18MWfhu+/aN/bA1nTPBEtvYTeOPEGqalpzayzRLFExnuwJjEJCreWpGFDDdxnHNfoP46/Zg/Yq8FfZf+Ey0Tw/4d+3b/ALJ/a/jO7tPtGzbv2eZdLu270zjpuGeoq/8AAX4afsbeH/ixpOr/AAp1LwfN4ut/O/s1NP8AGsl9Od0Eiy7YDcuH/dNJn5TgZPGMgA+UP+HcXxv/AOhp+H//AIMb3/5Er6A/4LV/8ms6B/2Odt/6RXtfX9fnh8FdZ+IfxU8VXHh79uCHULD4e21k15pcvivTR4atTqyuiRKl0iW5eTyJLsiLeQVDNtOzIAPij4e+G77xj4+0PwjpktvDfeINTt9NtZLlmWJJZpVjQuVBIUMwyQCcZwDX6j/8E3v2cfHH7P3/AAmf/CZar4fvv+Ei+wfZP7IuJpdnkfad+/zIo8Z85MYz0OccZr/D34T/ALCmnePtD1Dwjqvgd/ENpqdvNo623j6W4la7WVWhCRG7YSN5gXC7TuOBg5xX1PQB5f8AtmfDjXPi3+zZ4k+Hvhu60+11PWPsnkTahI6QL5V3DM25kR2HyxMBhTyR0618If8ADuL43/8AQ0/D/wD8GN7/APIlHxc/ah/al/4aa8Y+APAHirUL77D4m1Ox0rStP8NWd3P5EE8oVFUW7SPtjjyScnCkk9TR/wALk/4KGf8AQI+IH/huIv8A5DoA+QK/Wb/gn34ksfB3/BNXQvF2pxXE1joGmazqV1HbKrSvFDe3kjhAxALFVOASBnGSK+eP21vgp8AZ/hXp6fswaRp/ifxcNaiN9Z+FNduNduo9P8mfzJHt1mmKxiX7ODJtGGZRn5sHwjTfi5+0Z4O8Gt+z3Bdaxpdjcwy6UfCs/h2EXrrelmaELJB9o3S/aCVwd37wbe1AH0v8dP8AjYF/Zf8Awpr/AIkf/Cu/O/tX/hLv9G8/7d5fleR9m+0bsfYpd27bjcmN2Tj7X+CPhu+8HfBfwh4R1OW3mvvD/h+x026ktmZonlht0jcoWAJUspwSAcYyBX5U/Au2/a++Dn9qf8K48A/EDRf7a8n7f/xRElz53leZ5f8Arrd9uPNk+7jO7nOBjY039q79sfUfGTeEdP8AE+sXfiFJpYG0eDwjZSXqyxBjIhgFrvDIEfcMZXac4waAP1mr4Q+NXxH0P9u7wrb/AAi+EVrqGi63ot6viO4uPFcaW1q1tEj2zIjW7zuZC95EQCgXarfMCAD4R42/au/bH8HarHpni7xPrHh++mhE8drqvhGytZXiLMocJJaglSysM4xlSO1fd37L/gD9lfwr4+vNQ+B9/wCF7jxDJpjw3S6V4sfUpRaGWJnJia4kCr5iw/NtGDgZ5wQD8qfj18ONc+EnxY1b4e+JLrT7rU9H8nz5tPkd4G82COZdrOiMfllUHKjkHr1r7P8A+CGP/NUf+4P/AO31e3/Hr4afsbeIPixq2r/FbUvB8Pi648n+0k1DxrJYzjbBGsW6AXKBP3Sx4+UZGDznJ+cP2rvHfgf9m/8AsH/hj7xl4f03/hJvtP8AwlP9kapDrvmfZ/K+y7/tDT+Tjz7rG3buyc7towAfo/Xg/wC1B+1l8OvgR4+s/CPi7RfFF7fXumJqUcmlWtvJEInlljAJknjO7dC3GMYI564+CfC37Xn7XPibXoNE8N+M9Q1jU7rd5Fjp/hawuJ5tql22xpbFmwqsxwOACe1eb/tQeJvjL4q8fWeofHC21iDxDHpiQ2q6roi6bKbQSyshESxRhl8xpvm2nJyM8YAB97/8PHfgh/0K3xA/8F1l/wDJdeD/ALSnwU8VftCx+Kv2svBeoaPY+C9R0yTUotP1iaWLVFi0+2+zzBo4o5ItzPZylAJSCCuSpJA9A/4KF/sl+B/CvwX0vUPgf8KtYuPEMniCGG6XSpNQ1KUWht7hnJiZ5Aq+YsPzbRg4GecHwjwzqX7aPh/4NyfCnSPBfxAt/CM1ldWL6b/wghfMFyZDMnmtamX5jLJzuyN3BGBgA9v/AOCGP/NUf+4P/wC31eb/ALdP7JvxF8K6h8RPjhqGteF5PD0/iC41JbWC6uGvRFd322MFDAE3AzpuG/AwcE8Z9I/4JS/8WU/4T3/hcv8Axbv+3P7N/sr/AIS7/iUf2h5P2vzfI+07PN2ebFu252+Ymcbhn6H/AOChFhfeOv2HPFNv4IsrjxLNq8Omz6dHo0TXjXsRvraQPCIgxkXywXyuRtGelAH481+w37L/AO1l8Ovjv4+vPCPhHRfFFlfWWmPqUkmq2tvHEYklijIBjnkO7dMvGMYB56Z+WP2Kfgp8AYPhXqCftP6Rp/hjxcdalNjZ+K9duNCupNP8mDy5Et2mhLRmX7QBJtOWVhn5cD7P+Cv7O/wd+Eniq48SfD3wf/Y+p3Vk1jNP/ad3cboGdHKbZpXUfNEhyBnjryaAPUKKKKACiiigAooooA+AP+C53/NLv+4x/wC2NfX/AOyd/wAms/DT/sTNJ/8ASKKug8deBPBHjX7L/wAJl4N8P+IvsO/7J/a+lw3f2fft37PNVtu7Ymcddoz0FeT/APBQi/vvAv7Dnim48EXlx4am0iHTYNOk0aVrNrKIX1tGEhMRUxr5ZKYXA2nHSgD44/4LV/8AJ02gf9iZbf8Apbe16B/w7L/6rZ/5an/3ZXP/ALFPxr+ANx8K9Qf9p/V9P8T+LhrUosbzxXoVxrt1Hp/kweXGlw0MxWMS/aCI9wwzMcfNk+sf8E9PAH7VHhX40apqHxwv/FFx4ek8PzQ2q6r4sTUohdm4t2QiJbiQq3lrN820YGRnnBAMf4T/AB0/4Zv+Knhn9j7/AIRb/hJv7N1q00z/AISn+0PsXmf2lMlz5n2Ty5MeX9t24807vLzld2B6/wDtz/sy/wDDRn/CL/8AFbf8I1/wjX2z/mE/bPtP2jyP+m0e3b5Hvnd2xzX+Mnxa/ZE8F/G28j+IcXheDx5pM1tPcXs/g+W6vYZRFHJA4uktnJZYzEVIclcAcEYHzR/wUh/ao0jxb/whn/Chvix4gt/sf2/+2v7Ilv8AS9277N5G/csXmfdmx1289N3IB9Aft3eGf+EK/wCCYGqeDftv27/hHdG0PTPtfleV9o8i7sovM2Zbbu2Zxk4zjJ61z/8AwRU/5NZ1/wD7HO5/9IrKun+LXhfxr8Wv+CXuk6BoEFxr/inxB4S8PzgXN6iy3koaznld5pnALFVkYlmyTnqTX54+Nrf9oD9nLVY/BGp+IvFHgia/hGqrp2leJSsUquzRecRazFNxMBXn5sIM8YoA/Qf9in9j7/hn74qah4y/4WJ/wkX27RpdM+yf2J9k2b5oJfM3+fJnHk4xj+LOeMH6fr44/wCCengD9qjwr8aNU1D44X/ii48PSeH5obVdV8WJqUQuzcW7IREtxIVby1m+baMDIzzg9/8AtgftL/CvwX4S8e/DyTx5caT48g8P3UNlb21jerLDdzWZe2KXEcexGJkiIYONpIyQQcAHhH/Bc7/ml3/cY/8AbGvkD9lv4m/8Kc+O2hfEf+xP7a/sX7T/AKB9r+zed5ttLB/rNj7cebu+6c7ccZyOg8C+Df2hv2mPtX9lXniDx5/wi+zzP7X8Ro/2H7Ruxs+1zDG/7Oc7P7gz2o+KX7Lnx2+HPgS+8ZeMvA39m6Jpvl/a7v8Ateym8vzJEiT5Ipmc5eRBwDjOTxk0AH7a3x0/4aB+Kmn+Mv8AhFv+Ed+w6NFpn2T+0Pte/ZNPL5m/y48Z87GMfw5zzgfs9Xwx/wAEifhr8OvGP7Nut6n4u8AeF/EF9D4tuII7rVdGt7qVIhaWjBA8iEhQzMcZxlie5r0D/grt4s8VeDv2bdE1Pwj4l1jw/fTeLbeCS60q/ltZXiNpdsULxsCVLKpxnGVB7UAez/tY/wDJrPxL/wCxM1b/ANIpa+QP+CGP/NUf+4P/AO31dx+w7+0v8K9a+APhL4Y/E7x5ca5401ya40q+sdZsb2/a+a5vZkhhmmeJ43VopYl+ZyoU4OACB7P468Zfs8/sz/Zf7Vs/D/gP/hKN/l/2R4cdPt32fbnf9khOdn2gY3/3zjvQB+UP7WP/ACdN8S/+xz1b/wBLZa9g/Yp/Y+/4aB+FeoeMv+Fif8I79h1qXTPsn9ifa9+yGCXzN/nx4z52MY/hznnA6/w78K7zRf2rNQ/aR+KXhPT5/gfqutalrZ1bUFt76C4sr/zvsMrWILznfJc2pCtDuQsCwXaSPpfwT+1d+xx4O0qTTPCPifR/D9jNMZ5LXSvCN7axPKVVS5SO1ALFVUZxnCgdqAPz5/Yp+On/AAz98VNQ8Zf8It/wkX27RpdM+yf2h9k2b5oJfM3+XJnHk4xj+LOeMH6f/wCFZf8AC2/+M8/7b/sf+z/+Km/4Qz7J9o8z+xv3fkfbt6Y877Bnf5B2eb919vzfGHwV+Fvjv4t+Krjw38PdC/tjU7Wya+mg+1wW+2BXRC+6Z0U/NKgwDnnpwa9Q+Ecvxf8Ah5+014O+BfjXX/EGn6YvibTLDV/CZ1xp9NltrueKSSCSGORoJI5Y5yXTlW8xgw5IoA9//wCUi/8A1TX/AIVr/wBxn+0ft/8A4D+V5f2H/b3eZ/Dt5P8AhmX/AIY6/wCMjv8AhNv+E0/4Qv8A5gP9k/2d9s+1/wCg/wDHx503l7PtW/8A1bZ2beM7h6B+3P8ABL4n2/8Awi//AAyn4Z/4RXd9s/4ST/hEb+20D7V/qPs3n7JIfO2/6Ttzu2bn6bufZ7y98PeDv2P9Gn/aES3ubHS/D+lw+KhrNsdWV7sCCMmZVWXz2+0lTuAb5vmz3oAr/sU/HT/hoH4V6h4y/wCEW/4R37DrUumfZP7Q+179kMEvmb/LjxnzsYx/DnPOB5B/wWr/AOTWdA/7HO2/9Ir2vL/jVo3xD+Kniq38Q/sPzahYfD22sls9Ui8KakPDVqdWV3eVntXe3LyeRJaAy7CCoVdx2YHv/wDwVA+Fvjv4t/ALSPDfw90L+2NTtfE0F9NB9rgt9sC210hfdM6KfmlQYBzz04NAH5o/snf8nTfDT/sc9J/9LYq/b6vw51D4efEnwX8erH4eSafcaT48g1Oyhsre21CJZYbubyntilxHJsRiZIiGDjaSMkEHH3P+yj478cfs3/29/wANg+MvEGm/8JN9m/4Rb+19Um13zPs/m/atn2dp/Jx59rndt3ZGN204APH/ANmn/lMlqX/Y5+J//RV/X1B+2t+2D/wz98VNP8G/8K7/AOEi+3aNFqf2v+2/smzfNPF5ezyJM48nOc/xYxxk/P8A8NPBHif4f/tk3P7Vni7TP7O+EV3rWqa3D4k+0Rzb7LUUuEspfssbNcjzGu7cbTFuXf8AOFw2PePG37SH7DvjHVY9T8XX3hfxBfQwiCO61XwPdXUqRBmYIHktCQoZmOM4yxPegCx+xT+x9/wz98VNQ8Zf8LE/4SL7do0umfZP7E+ybN80Evmb/PkzjycYx/FnPGDz/wC1J+zL9n+O2u/tWf8ACbbv+EV+zeJv+Eb/ALJx9q/sy2ifyPtXnfJ5v2XG/wAo7N/3Wxzw/wDwUL/a08D+Kvgvpen/AAP+KusQeIY/EEM102lR6hpsptBb3CuDKyRhl8xofl3HJwccZHrH7MreL/iZ/wAEtJre4v8AUPEXibxF4Z8QWMM2oXxlnu53mvYYkaaZv9xQWbAAHIAoA8f/AOHmn/VE/wDy6/8A7jr0D9lv9mX7R8dtC/as/wCE22/8JV9p8Tf8I3/ZOfsv9p20r+R9q875/K+1Y3+UN+z7q54+APjp8Evif8HP7L/4WP4Z/sX+2vO+wf6fbXPneV5fmf6mR9uPNj+9jO7jODj0j9h39oDXvBfx+8JSfEP4peKIPAekw3EFxZT6jeXVlDELKaOBBaoXBVZDEFAQhcA8AZAB2/8AwWr/AOTptA/7Ey2/9Lb2vqD9in9j7/hn74qah4y/4WJ/wkX27RpdM+yf2J9k2b5oJfM3+fJnHk4xj+LOeMH4w/4KgfFLwJ8W/j7pHiT4e67/AGxplr4ZgsZp/sc9vtnW5unKbZkRj8sqHIGOevBr7u/4ba/Zi/6KZ/5QNS/+R6APIP2/P2Pv+Et8RfEL49f8LE+x/Z9GfU/7F/sTzN32OwVfL8/zxjf9n67Pl3dDjn5g/YY/Zl/4aM/4Sj/itv8AhGv+Ea+x/wDMJ+2faftHn/8ATaPbt8j3zu7Y59X/AGvbf9oD4qa14y+LXwl8ReKNQ+CuoaY00UsHiU2VlLaW9osV6DYSzRybfNhuQymL58EgMGBPUf8ABDH/AJqj/wBwf/2+oA9A/Zb/AGGP+FOfHbQviP8A8LR/tr+xftP+gf8ACPfZvO822lg/1n2l9uPN3fdOduOM5Hz/AP8ABav/AJOm0D/sTLb/ANLb2rHg39oDXvBf/BSXXpPiH8UvFEHgPSfFuvQXFlPqN5dWUMQ+1xwILVC4KrIYgoCELgHgDI4j/gqB8UvAnxb+PukeJPh7rv8AbGmWvhmCxmn+xz2+2dbm6cptmRGPyyocgY568GgD9bq5/wCLHif/AIQr4V+JvGX2H7d/wjujXep/ZPN8r7R5ELy+Xvw23dsxnBxnOD0r4o/Zf1P42/s9ePrzxp+1l4r8Uad4LvtMfS9Pl1XxC+tRNqTyxSxqILeWdlbyYLk7ygAAI3AsAfb9W/bL/ZU1TSrnTNT+IFve2N7C8F1a3PhvUJIp4nUq6OjWxDKykggjBBINAHhH/KRf/qmv/Ctf+4z/AGj9v/8AAfyvL+w/7e7zP4dvP2/8J/DP/CFfCvwz4N+2/bv+Ed0a00z7X5XlfaPIhSLzNmW27tmcZOM4yetfEHx0/wCLt/2X/wAMGf8AEv8A7H87/hM/+ER/4pfzPN8v7F5/mfZvtGPKvNuN+zL/AHd/zfKHiz4t/tB+GfFWp+G9b+LXxAtdT0e9msb6D/hLLp/JnicpIm5ZSrYZSMqSDjgmgD2//gtX/wAnTaB/2Jlt/wClt7X6f1+NPgn4R/tGftG6VJ430y11jxvDYTHSm1HVfEULSxMirL5IN1OH2gThuPly5xzmvs//AIJ6eAP2qPCvxo1TUPjhf+KLjw9J4fmhtV1XxYmpRC7NxbshES3EhVvLWb5towMjPOCAfY9FFFABRRRQAUUUUAFflx+3T+1l8RfFWofET4H6hovhePw9B4guNNW6gtbhb0xWl9ujJczlNxMCbjswcnAHGPuf9q79o7wR+z9/YP8AwmWleIL7/hIvtP2T+yLeGXZ5Hlb9/myx4z5yYxnoc44z6R8PfElj4x8A6H4u0yK4hsdf0y31K1juVVZUimiWRA4UkBgrDIBIznBNAH4M19f/APDx343/APQrfD//AMF17/8AJdH/AAWr/wCTptA/7Ey2/wDS29o/4dxfG/8A6Gn4f/8Agxvf/kSgDuNd+CnhX9oX9lzxB+1l401DWLHxpqPh/UtSl0/R5ootLWXT0mt4Qscscku1ks4i4MpJJbBUEAeUf8E3v2cfBH7QP/CZ/wDCZar4gsf+Ed+wfZP7IuIYt/n/AGnfv82KTOPJTGMdTnPGPR/gj+wN8YfB3xo8IeLtT8SeB5rHw/4gsdSuo7a/u2leKG4SRwga2ALFVOASBnGSK2P+C53/ADS7/uMf+2NAH0v+0V4kvv2cv2LbjU/BEVvfzeB9M0zTdOXWVaVZYlmt7QGYRGMs3lsTlSo3c4xxXzx8Ffhxof7d3hW4+LvxdutQ0XW9FvW8OW9v4UkS2tWtokS5V3W4SdzIXvJQSHC7VX5QQSfq/wDZO/5NZ+Gn/YmaT/6RRV6BQB+YH/Dx343/APQrfD//AMF17/8AJddxrvwU8K/tC/sueIP2svGmoaxY+NNR8P6lqUun6PNFFpay6ek1vCFjljkl2slnEXBlJJLYKggD0D/gnp+yb8RfgR8aNU8XeLta8L3tje+H5tNjj0q6uJJRK9xbyAkSQRjbthbnOckcenyR/wAFR/8Ak+zx1/3Dv/Tba0Ae/wD/AAQx/wCao/8AcH/9vq+z/j18OND+Lfwn1b4e+JLrULXTNY8nz5tPkRJ18qeOZdrOjqPmiUHKngnp1r8kf2Uf2cfHH7QP9vf8Ibqvh+x/4R37N9r/ALXuJot/n+bs2eXFJnHkvnOOoxnnHm/xC8N33g7x9rnhHU5bea+8P6ncabdSWzM0TywytG5QsASpZTgkA4xkCgD9nv2X/gp4V+BHgG88I+Eb/WL2xvdTfUpJNVmiklErxRRkAxxxjbthXjGck89MH7UHwU8K/HfwDZ+EfF1/rFlY2WppqUcmlTRRymVIpYwCZI5Bt2zNxjOQOeufxJr6/wD+HcXxv/6Gn4f/APgxvf8A5EoA+mPh7+wN8HvB3j7Q/F2meJPHE194f1O31K1jub+0aJ5YZVkQOFtgSpZRkAg4zgivJ/8Agud/zS7/ALjH/tjXcfs1/Gvwr+z1J4V/ZN8aafrF94007U49Nl1DR4YpdLaXULn7RCVklkjl2ql5EHJiBBDYDAAnh/8Agud/zS7/ALjH/tjQB88eOP2sviL4q/Zoh+B+oaL4Xj8PQaZYaat1Ba3C3pitGhaMlzOU3EwJuOzBycAcY8Hr6n+Hv7A3xh8Y+AdD8XaZ4k8Dw2PiDTLfUrWO5v7tZUimiWRA4W2IDBWGQCRnOCa2P+HcXxv/AOhp+H//AIMb3/5EoA+x/wBl/wDZN+HXwI8fXni7wjrXii9vr3TH02SPVbq3kiETyxSEgRwRnduhXnOME8dMHjj9k34deKv2l4fjhqGteKI/EMGp2GpLawXVutkZbRYVjBQwF9pECbhvycnBHGPx5r9V/wBifw3feMf+CVdr4R0yW3hvvEHh/X9NtZLlmWJJZrq9jQuVBIUMwyQCcZwDQB9T1x/x6+HGh/Fv4T6t8PfEl1qFrpmseT582nyIk6+VPHMu1nR1HzRKDlTwT061+eH/AA7i+N//AENPw/8A/Bje/wDyJXhHgf4KeKvFX7S83wP0+/0ePxDBqd/prXU80q2RltFmaQhxGX2kQPtOzJyMgc4AP1u/Zf8Agp4V+BHgG88I+Eb/AFi9sb3U31KSTVZopJRK8UUZAMccY27YV4xnJPPTHwR/w8d+N/8A0K3w/wD/AAXXv/yXXhH7UHwU8VfAjx9Z+EfF1/o97fXumJqUcmlTSyRCJ5ZYwCZI4zu3QtxjGCOfTsP2oP2TfiL8CPANn4u8Xa14XvbG91NNNjj0q6uJJRK8UsgJEkEY27YW5znJHHoAcf44+NfirxV+0vD8cNQ0/R4/EMGp2GpLawQyrZGW0WFYwUMhfaRAm4b8nJwRxj63+Bf/ABsC/tT/AIXL/wASP/hXfk/2V/wiP+jef9u8zzfP+0/aN2PsUW3btxufO7Ix4h8Bf2Kvin8W/hPpPxC8N6/4PtdM1jzvIh1C8uUnXyp5IW3Klu6j5omIwx4I6dK9v+Bf/Gv3+1P+Fy/8Tz/hYnk/2V/wiP8ApPkfYfM83z/tP2fbn7bFt27s7XztwMgHs/8AwUE8N2Pg7/gmrrvhHTJbiax8P6Zo2m2slyytK8UN7ZxoXKgAsVUZIAGc4Ar5g/4J6fsm/Dr47/BfVPF3i7WvFFlfWXiCbTY49KureOIxJb28gJEkEh3bpm5zjAHHXPUftmftq/Cz4t/s2eJPh74b0Dxha6nrH2TyJtQs7ZIF8q7hmbcyXDsPliYDCnkjp1rwj9l/9k34i/HfwDeeLvCOteF7KxstTfTZI9VuriOUypFFISBHBINu2Zec5yDx6gHp/wDwUL/ZN+HXwI+C+l+LvCOteKL2+vfEEOmyR6rdW8kQie3uJCQI4Izu3QrznGCeOmPpD9ifxJfeDv8AglXa+LtMit5r7QPD+v6lax3Ks0Tyw3V7IgcKQSpZRkAg4zgivF/gr8ONc/YR8VXHxd+Lt1p+taJrVk3hy3t/Ckj3N0tzK6XKu63CQIIwlnKCQ5bcy/KQSR9v/AX4j6H8W/hPpPxC8N2uoWumax53kQ6hGiTr5U8kLblR3UfNExGGPBHTpQB8YfAv/jYF/an/AAuX/iR/8K78n+yv+ER/0bz/ALd5nm+f9p+0bsfYotu3bjc+d2Rj0D/h3F8EP+hp+IH/AIMbL/5Erz//AILnf80u/wC4x/7Y19f/ALJ3/JrPw0/7EzSf/SKKgD8uf+ChfwU8K/Aj40aX4R8I3+sXtje+H4dSkk1WaKSUSvcXEZAMccY27YV4xnJPPTB/wT0+CnhX47/GjVPCPi6/1iysbLw/NqUcmlTRRymVLi3jAJkjkG3bM3GM5A565+v/APgoX+yb8Rfjv8aNL8XeEda8L2VjZeH4dNkj1W6uI5TKlxcSEgRwSDbtmXnOcg8etj/gtX/yazoH/Y523/pFe0AeX+JviPrnwr+Mkf7D/h610+5+Ht/e2vhyXVL+N31kW2riOS5dZUdYfMU30vlkwlQFTcr4OdD46f8AGv3+y/8AhTX/ABPP+Fied/av/CXf6T5H2Hy/K8j7N9n25+2y7t27O1MbcHPwBX1B/wAE3v2jvBH7P3/CZ/8ACZaV4gvv+Ei+wfZP7It4Zdnkfad+/wA2WPGfOTGM9DnHGQD6P8J/sVfCz4x+FdM+LvifX/GFprfj+yh8R6pb6beW0drDc3qC5lSFXt3dYw8rBQzswUDLE8nQ/wCHcXwQ/wChp+IH/gxsv/kSuv8AgL+2r8LPi38WNJ+HvhvQPGFrqesed5E2oWdskC+VBJM25kuHYfLEwGFPJHTrWx+1B+1l8OvgR4+s/CPi7RfFF7fXumJqUcmlWtvJEInlljAJknjO7dC3GMYI564APzx/ag/ay+Ivx38A2fhHxdovheysbLU01KOTSrW4jlMqRSxgEyTyDbtmbjGcgc+vp/wh/ZN+HXir9gO7+OGoa14oj8QweH9Z1JbWC6t1sjLaPdLGChgL7SIE3Dfk5OCOMekfGr4j6H+3d4Vt/hF8IrXUNF1vRb1fEdxceK40trVraJHtmRGt3ncyF7yIgFAu1W+YEAH6f/Yz+HGufCT9mzw38PfEl1p91qej/a/Pm0+R3gbzbuaZdrOiMfllUHKjkHr1oA/LH9lH9o7xx+z9/b3/AAhuleH77/hIvs32v+17eaXZ5Hm7Nnlyx4z5z5znoMY5z5v8QvEl94x8fa54u1OK3hvtf1O41K6jtlZYklmlaRwgYkhQzHAJJxjJNfsN+1d+0d4I/Z+/sH/hMtK8QX3/AAkX2n7J/ZFvDLs8jyt+/wA2WPGfOTGM9DnHGfgj9ifxJY+Mf+Cqlr4u0yK4hsdf8Qa/qVrHcqqypFNa3siBwpIDBWGQCRnOCaAPpj/gip/yazr/AP2Odz/6RWVfX9FeD/sv/tZfDr47+Przwj4R0XxRZX1lpj6lJJqtrbxxGJJYoyAY55Du3TLxjGAeemQD3iiiigAooooAKKKKAPP/AI6fBL4YfGP+y/8AhY/hn+2v7F877B/p9zbeT5vl+Z/qZE3Z8qP72cbeMZOa+k/Ez4FeBdKtvBFv8TvA+kQ+GoU0qPTrnxPbCWyW3URCFxJLvDIE2nf82Qc81w/7c/7TX/DOf/CL/wDFE/8ACS/8JL9s/wCYt9j+zfZ/I/6Yyb93n+2NvfPH5Q/FjxP/AMJr8VPE3jL7D9h/4SLWrvU/snm+b9n8+Z5fL34Xdt34zgZxnA6UAfqd8atN/Yu+Lfiq38SfELxp8P8AWNTtbJbGGf8A4TsW+2BXdwm2G5RT80rnJGeevAr5Q/4XJ/wUM/6BHxA/8NxF/wDIdYH7FP7H3/DQPwr1Dxl/wsT/AIR37DrUumfZP7E+179kMEvmb/PjxnzsYx/DnPOB9/ftrfHT/hn74V6f4y/4Rb/hIvt2tRaZ9k/tD7Js3wzy+Zv8uTOPJxjH8Wc8YIB8kfBH4r/t16j8aPCGn+LtK8cJ4eu/EFjDrDXPgGK3iW0a4RZi8otFMa+WWy24bRk5GM19r/HT4JfDD4x/2X/wsfwz/bX9i+d9g/0+5tvJ83y/M/1Mibs+VH97ONvGMnPzB8J/+Ch3/Ca/FTwz4N/4VB9h/wCEi1q00z7X/wAJN5v2fz5ki8zZ9lXdt35xkZxjI619v0AfFH7OviP9pTSP20rf4aXmj+KLP4O6Lqep6Xpiz+FwllFpttDcJYqL5oN7qBHbhXaUl+Ms2450P+Chfj79qjwr8aNL0/4H2Hiifw9J4fhmum0rwmmpRC7NxcK4MrW8hVvLWH5dwwMHHOT1Hw0/bB/4S39sm5+A3/Cu/sf2fWtU0z+2v7b8zd9jS4bzPI8gY3/Z+m/5d3U45+n6APiD9in41/H63+KmoP8AtP6vqHhjwidGlFjeeK9Ct9CtZNQ86Dy40uGhhDSGL7QRHuOVVjj5cjY/bA8PfseeNPCXj34hyeKPA+rePJ/D91NZXFt423SzXcNmUtglvHc7HYGOIBQh3EDIJJzY/wCC1f8AyazoH/Y523/pFe18/wD7Lf7DH/C4/gToXxH/AOFo/wBi/wBtfaf9A/4R77T5PlXMsH+s+0puz5W77oxuxzjJAPQP+CGP/NUf+4P/AO31ez618Cv2MPG/xc1W0u4/C+q+NNV1O6m1DT4PGlx9tku9zyXANtHdAqysJCyhRt2ngAV4x/yjo/6qV/wsr/uDf2d9g/8AAjzfM+3f7G3y/wCLdx6B+y3+zL9o+O2hftWf8Jtt/wCEq+0+Jv8AhG/7Jz9l/tO2lfyPtXnfP5X2rG/yhv2fdXPAB3//AAxL+zF/0TP/AMr+pf8AyRVj/goX4m+MvhX4L6XqHwPttYn8QyeIIYbpdK0RdSlFobe4ZyYmikCr5iw/NtGDgZ5weY/bW/bB/wCGfvipp/g3/hXf/CRfbtGi1P7X/bf2TZvmni8vZ5EmceTnOf4sY4ye/wD21vjp/wAM/fCvT/GX/CLf8JF9u1qLTPsn9ofZNm+GeXzN/lyZx5OMY/iznjBAPyh+J3jT4rw/tBP478dyahp/xC0+9s76STUNJjtJ4J4I4jbu1sY1QYSOEgFMMMEg55+n/wBlHx34H/aQ/t7/AIbB8ZeH9S/4Rn7N/wAIt/a+qQ6F5f2jzftWz7O0HnZ8i1zu3bcDG3ccnxY+Bf8Aw0h8K/E37YP/AAlP/CM/2lo13qf/AAi39n/bfL/s2F7by/tfmR58z7Fuz5Q2+ZjDbcnyD9hj9mX/AIaM/wCEo/4rb/hGv+Ea+x/8wn7Z9p+0ef8A9No9u3yPfO7tjkA2PiF+1l8aPBHj7XPBfw1+I1vB4L8OancaX4aittNsLuKPTYJWitVSd4XaVRCkYDs7FhgliTmsf/htr9p3/opn/lA03/5Hrx/4seGf+EK+Knibwb9t+3f8I7rV3pn2vyvK+0eRM8XmbMtt3bM4ycZxk9a5+gD7v/4Kgfs7/B34SfALSPEnw98H/wBj6ndeJoLGaf8AtO7uN0DW105TbNK6j5okOQM8deTXzh8Lf2o/jt8OfAlj4N8G+Of7N0TTfM+yWn9kWU3l+ZI8r/PLCznLyOeScZwOMCvt/wD4LV/8ms6B/wBjnbf+kV7X5wfCfwz/AMJr8VPDPg37b9h/4SLWrTTPtfleb9n8+ZIvM2ZXdt35xkZxjI60Aff/APwTe/ao1fxb/wAJn/wvn4seH7f7H9g/sX+15bDS9277T5+zasXmfdhz128dN3Pxx8SfiLrPg79szxn8Rvhz4gt4b6HxbrE+l6pbJDdRPFNPOm9N6vG6tFK2DgjDAjsa+p/+HZf/AFWz/wAtT/7sr4g+LHhn/hCvip4m8G/bft3/AAjutXemfa/K8r7R5EzxeZsy23dszjJxnGT1oA+//wBinwR4Y/a2+FeofEf9oPTP+Ew8TaXrUuiWl/8AaJNP8qyjhgnSLy7NooziS5nbcVLHfgnAAHyx+1B4+/ao8VeAbPT/AI4WHiiDw9HqaTWrar4TTTYjdiKVUAlW3jLN5bTfLuORk44yOo/Yp/bB/wCGfvhXqHg3/hXf/CRfbtal1P7X/bf2TZvhgi8vZ5EmceTnOf4sY4yfv79tb4Gf8NA/CvT/AAb/AMJT/wAI79h1qLU/tf8AZ/2vfshni8vZ5keM+dnOf4cY5yADzD9j3W9U8M/8Elx4k0S6+y6no/hnxFfWM/lq/kzxXF88b7WBVsMoOGBBxyDXh/7KPjvwP+0h/b3/AA2D4y8P6l/wjP2b/hFv7X1SHQvL+0eb9q2fZ2g87PkWud27bgY27jn6/wDhp8DP+ES/Y2ufgL/wlP2z7Ro2qaZ/bX9n+Xt+2PcN5nkeYc7PtHTf823qM8fnD+3P+zL/AMM5/wDCL/8AFbf8JL/wkv2z/mE/Y/s32fyP+m0m7d5/tjb3zwAeT/G6z8Pad8aPF+n+EXt38PWniC+h0dra5NxE1otw6wlJSzGRfLC4bcdwwcnOa6j4K/tEfGL4SeFbjw38PfGH9j6ZdXrX00H9mWlxunZEQvumidh8sSDAOOOnJry+vqD9in9j7/hoH4V6h4y/4WJ/wjv2HWpdM+yf2J9r37IYJfM3+fHjPnYxj+HOecAA9P8AgrrPxD+Kniq48PftwQ6hYfD22smvNLl8V6aPDVqdWV0SJUukS3LyeRJdkRbyCoZtp2ZH2/8AAXRvh54f+E+k6R8KZtPm8I2/nf2a+n6kb6A7p5Gl2zl3L/vWkz8xwcjjGBx/7a3wM/4aB+Fen+Df+Ep/4R37DrUWp/a/7P8Ate/ZDPF5ezzI8Z87Oc/w4xzkHw08M/8ADM/7G1zpX27/AISj/hA9G1TU/M8r7F9u2vcXnl4zL5f3tmct0zjtQB0Hx0+CXww+Mf8AZf8Awsfwz/bX9i+d9g/0+5tvJ83y/M/1Mibs+VH97ONvGMnP54eMP2hv2kvDPxw174O/CXxBqEmmeGdavdE8OaFp/h61v54bKzkkjiiXdA80vlwwjLMWYhCzE8mvUP8Ah5p/1RP/AMuv/wC46+YPhp8dP+ES/bJufjz/AMIt9s+0a1qmp/2L/aHl7ftiXC+X5/lnOz7R12fNt6DPAB3Hjb9q79sfwdqsemeLvE+seH76aETx2uq+EbK1leIsyhwklqCVLKwzjGVI7V9L/wDBUDXtD+MfwC0jwx8ItZ0/x/rdp4mgv7jS/Cl0mq3UNsttdRtO8VuXdYw8sSlyNoaRRnLDPH/8Ky/4eBf8Xl/tv/hXf9h/8Uz/AGV9k/tfz/J/0rz/ADt9vtz9t27Nhx5edx3YHsH7FP7H3/DP3xU1Dxl/wsT/AISL7do0umfZP7E+ybN80Evmb/PkzjycYx/FnPGCAfmx8OfCsOl/tDeF/CfxS0m40SxPiDT4dfs9ZEmntBaSTRGQzFtjRKYXLbsrhTuBHWv0H/4U3/wTz/6C/wAP/wDw48v/AMmV8gf8FR/+T7PHX/cO/wDTba0fsMfsy/8ADRn/AAlH/Fbf8I1/wjX2P/mE/bPtP2jz/wDptHt2+R753dscgH0/8UvBv7PPw/8AAl94u/ZTvPD938XdO8v/AIRuDw94jfXL998iR3PlWLzTLNi1e5LZjbaoZ+Nu4Z/wV0b4efFTwrceIf24JtPsPiFbXrWelxeK9SPhq6OkqiPEyWqPbh4/PkuwJdhJYMu47MDxD9hHwz/whX/BT/S/Bv237d/wjuta5pn2vyvK+0eRaXsXmbMtt3bM4ycZxk9a3/8AgtX/AMnTaB/2Jlt/6W3tAHcftQan8Ev2evANn40/ZN8V+F9O8aX2pppeoS6V4hTWpW014pZZFMFxLOqr50Fsd4QEEAbgGIPiGk/tl/tV6pqttpmmfEC4vb69mSC1tbbw3p8ks8rsFRERbYlmZiAABkkgCtj9tb9j7/hn74V6f4y/4WJ/wkX27WotM+yf2J9k2b4Z5fM3+fJnHk4xj+LOeMHf/Zb/AGZfs/wJ0L9qz/hNt3/CK/afE3/CN/2Tj7V/ZlzK/kfavO+TzfsuN/lHZv8AutjkA9A+Bf8Axdv+1P8AhvP/AIl/9j+T/wAIZ/wl3/FL+Z5vmfbfI8v7N9ox5Vnuzv2ZT7u/5vYPhb4R/Ya+HPjux8ZeDfFfw/03W9N8z7Jd/wDCfmby/MjeJ/klumQ5SRxyDjORzg14/wD8pF/+qa/8K1/7jP8AaP2//wAB/K8v7D/t7vM/h28n/Dsv/qtn/lqf/dlAH3P4J8WeFfGOlSan4R8S6P4gsYZjBJdaVfxXUSShVYoXjYgMFZTjOcMD3FcP8Ff2d/g78JPFVx4k+Hvg/wDsfU7qyaxmn/tO7uN0DOjlNs0rqPmiQ5Azx15NfKH/AAs3/h37/wAWa/sT/hYn9uf8VN/av2v+yPI87/RfI8nZcbsfYt2/eM+ZjaNuT9/0AFFFFABRRRQAUUUUAeP/ALV3jL9nnwl/YP8Awvmz8P3H2z7T/Yv9r+HH1Tbt8rz9m2GXy/vQ56buOu3j4o8D/BxfCH7S83x98feBtHh+ANxqd/qltezwW1zZHTb1Zl05hpybpgpa4tdqeTmPILKm04+1/wBq79nHwR+0D/YP/CZar4gsf+Ed+0/ZP7IuIYt/n+Vv3+bFJnHkpjGOpznjGx44+CnhXxV+zRD8D9Qv9Yj8PQaZYaat1BNEt6YrRoWjJcxlNxMCbjswcnAHGADy/wAE/tXfsceDtKk0zwj4n0fw/YzTGeS10rwje2sTylVUuUjtQCxVVGcZwoHavmj/AIJf69rnxj+Pur+GPi7rOoeP9EtPDM9/b6X4run1W1huVubWNZ0iuC6LIEllUOBuCyMM4Y58o/4KF/BTwr8CPjRpfhHwjf6xe2N74fh1KSTVZopJRK9xcRkAxxxjbthXjGck89MfS/xq+HGh/sI+Fbf4u/CK61DWtb1q9Xw5cW/iuRLm1W2lR7lnRbdIHEgeziAJcrtZvlJIIAPZ9Q8Q/seeC/j1Y/DyTwv4H0nx5BqdlDZW9t4J2yw3c3lPbFLiO22IxMkRDBxtJGSCDj0j46fG34YfBz+y/wDhY/ib+xf7a877B/oFzc+d5Xl+Z/qY32482P72M7uM4OPnj9mv4KeFf2hZPCv7WXjTUNYsfGmo6nHqUun6PNFFpay6fc/Z4Qscscku1ks4i4MpJJbBUEAcP/wXO/5pd/3GP/bGgDqPjR8QfgP8VfDOsaJ+zMdHb41a9MJ9F1DR9Bk0fVJZRMs1466hJDD5bNbLdby0qlwWX5i+D6//AME9PDXxl8K/BfVNP+OFzrFx4hk8QTTWrarra6lKLQ29uqASrLIFXzFm+XcMHJxzk8B+wt+yb8OvCun/AA7+OGn614ok8Qz+H7fUmtZ7q3ayEt3Y7ZAEEAfaBO+0b8jAyTznP/4KF/tZfEX4EfGjS/CPhHRfC97Y3vh+HUpJNVtbiSUSvcXEZAMc8Y27YV4xnJPPoAWP+C1f/JrOgf8AY523/pFe1w/7Jnx8+H1h+whYfBnSPGdxZ/E/UdM1XS9E0+2tbqKX+0ru5uvsapdCMRRszzQkOZFCEgllwcY/wV+I+uft3eKrj4RfF210/RdE0WybxHb3HhSN7a6a5idLZUdrh50MZS8lJAQNuVfmABB8g1z4caH8JP8Agp14Y+Hvhu61C60zR/Gfh7yJtQkR52802czbmREU/NKwGFHAHXrQB7f8C/8Ai0n9qf8ADef/ABMP7Y8n/hDP+Eu/4qjy/K8z7b5Hl/afs+fNs92dm/Cfe2fL7vpP7Zf7Kml6VbaZpnxAt7KxsoUgtbW28N6hHFBEihUREW2AVVUAAAYAAArqP2rv2cfBH7QP9g/8JlqviCx/4R37T9k/si4hi3+f5W/f5sUmceSmMY6nOeMfmz8Ifgp4V8Vft+XfwP1C/wBYj8PQeINZ01bqCaJb0xWiXTRkuYym4mBNx2YOTgDjABsf8FQPil4E+Lfx90jxJ8Pdd/tjTLXwzBYzT/Y57fbOtzdOU2zIjH5ZUOQMc9eDX1f/AMFq/wDk1nQP+xztv/SK9o/4dxfBD/oafiB/4MbL/wCRK8v+CvxH1z9u7xVcfCL4u2un6Lomi2TeI7e48KRvbXTXMTpbKjtcPOhjKXkpICBtyr8wAIIB4x8G/hL+1341+CVnJ8PJfFE/gPVobmC3soPGEVrZTRGWSOdDavcoArSCUMCgDZJ5Byfrf/glL8Evif8ABz/hPf8AhY/hn+xf7a/s37B/p9tc+d5X2vzP9TI+3Hmx/exndxnBx9H/AAF+HGh/CT4T6T8PfDd1qF1pmj+d5E2oSI87ebPJM25kRFPzSsBhRwB1614h/wAFIf2jvHH7P3/CGf8ACG6V4fvv+Ei+3/a/7Xt5pdnkfZtmzy5Y8Z8585z0GMc5APjDQ9Z+Hnh//gp14n1f4rQ6fN4Rt/GfiH+0k1DTTfQHcbxYt0ARy/71o8fKcHB4xkff3wV8N/sq/FvwrceJPh78OPh/rGmWt61jNP8A8IXDb7Z1RHKbZoEY/LKhyBjnrwa+UP2oP2cfBE/7IWo/tPvqviAeLvE9lp/iO8sRcQ/2bHc6lcW7zpHH5XmiNTcybAZSwwuWbBz4x+y/+1l8RfgR4BvPCPhHRfC97Y3upvqUkmq2txJKJXiijIBjnjG3bCvGM5J59AD1f/gl/r2ufGP4+6v4Y+Lus6h4/wBEtPDM9/b6X4run1W1huVubWNZ0iuC6LIEllUOBuCyMM4Y56D46fs6+M/Cn7cy/F7QPAGn6L8KvC+taTrd1eafLZ28FnZWcVtLeSraRuJflMU7FUjLMQSoYsM9B8avhxof7CPhW3+LvwiutQ1rW9avV8OXFv4rkS5tVtpUe5Z0W3SBxIHs4gCXK7Wb5SSCPP8Awn+2r8U/jH4q0z4ReJ9A8H2mieP72Hw5qlxptncx3UNteuLaV4We4dFkCSsVLIyhgMqRwQDQ/wCCkP7VGkeLf+EM/wCFDfFjxBb/AGP7f/bX9kS3+l7t32byN+5YvM+7Njrt56bufQP2mvAngh/+CWkPxCfwb4fbxdqHhnw/f3niE6XCdSubmeayM88lzt815JDJIXcsWbe2ScmvAP8AgpD+zj4I/Z+/4Qz/AIQ3VfEF9/wkX2/7X/a9xDLs8j7Ns2eVFHjPnPnOegxjnP0/+0t/yht03/sTPDH/AKNsKAPhD4K/s7/GL4t+FbjxJ8PfB/8AbGmWt61jNP8A2naW+2dURym2aVGPyyocgY568Gv02/4KF+GvjL4q+C+l6f8AA+51i38Qx+IIZrptK1tdNlNoLe4VwZWljDL5jQ/LuOTg44yPOP8Agip/yazr/wD2Odz/AOkVlVf/AIJ6ftZfEX47/GjVPCPi7RfC9lY2Xh+bUo5NKtbiOUypcW8YBMk8g27Zm4xnIHPqAfMHw28Y/tEeDv2zPBnw5+I3xE8cRX0Pi3R4NU0u58Vz3UTxTTwPsfZM8bq0Uq5GSMMQe4r9Bv2rvGX7PPhL+wf+F82fh+4+2faf7F/tfw4+qbdvlefs2wy+X96HPTdx128Y/jj9k34deKv2l4fjhqGteKI/EMGp2GpLawXVutkZbRYVjBQwF9pECbhvycnBHGNj9q79nHwR+0D/AGD/AMJlqviCx/4R37T9k/si4hi3+f5W/f5sUmceSmMY6nOeMAHAftQfAv4f/Eb9kLUbz4HfCrwfJrfiCy0++8P3en6LZ6bPJA9xbzF1lkWMx5g35DFSQSpGTir/APwS/wDhb47+EnwC1fw38QtC/sfU7rxNPfQwfa4LjdA1taoH3Qu6j5onGCc8dORXzB4s/bV+Kfwc8Van8IvDGgeD7vRPAF7N4c0u41KzuZLqa2snNtE8zJcIjSFIlLFUVSxOFA4H1v8A8E9PjX4q+O/wX1Txd4u0/R7K+svEE2mxx6VDLHEYkt7eQEiSSQ7t0zc5xgDj1APzp+CviT9qr4t+Krjw38PfiP8AEDWNTtbJr6aD/hNJrfbArohfdNOin5pUGAc89ODX2v8ABv4+fD74XfBKz+EX7TfjO4/4TyxhuYPE2naza3WstJFcSySxJNPHHNFMrWs0PG9gFO04IKj53/4Iqf8AJ02v/wDYmXP/AKW2VfV/x6/Yq+Fnxb+LGrfELxJr/jC11PWPJ8+HT7y2SBfKgjhXar27sPliUnLHknp0oA+Mf+CkPjL9nnxb/wAIZ/woaz8P2/2P7f8A21/ZHhx9L3bvs3kb90MXmfdmx1289N3Pu/wR+K/7CmnfBfwhp/i7SvA7+IbTw/Yw6w1z4BluJWu1t0WYvKLRhI3mBstuO45OTnNdR/w7i+CH/Q0/ED/wY2X/AMiUf8O4vgh/0NPxA/8ABjZf/IlAHT+Cf2rv2OPB2lSaZ4R8T6P4fsZpjPJa6V4RvbWJ5SqqXKR2oBYqqjOM4UDtX0xX48/8FC/gp4V+BHxo0vwj4Rv9YvbG98Pw6lJJqs0Ukole4uIyAY44xt2wrxjOSeemPR/+Hjvxv/6Fb4f/APguvf8A5LoA9I/aG/Zo+KnjT/gozH8Q4/Advq3gOfxBok17cXN9ZNFNaQxWiXIe3kk3uoEcoKlDuAOAQRn7X8C+BPBHgr7V/wAIb4N8P+Hft2z7X/ZGlw2n2jZu2b/KVd23e+M9Nxx1NfBHwR/b5+MPjH40eEPCOp+G/A8Njr/iCx026ktrC7WVIprhI3KFrkgMFY4JBGcZBr9F6APzw0D4W+O/gz+3lrn7RHxJ0L+xPhrZeJtZvp9d+2QXOyC8NzDbP9ngd5zvkuYVwI8rvywABIz/ANtbwR4n/a2+Kmn/ABH/AGfNM/4TDwzpejRaJd3/ANoj0/yr2Oaed4vLvGikOI7mBtwUqd+AcggfT/8AwVH/AOTE/HX/AHDv/Tla1+fP7L/7WXxF+BHgG88I+EdF8L3tje6m+pSSara3EkoleKKMgGOeMbdsK8Yzknn0AOo/Yp+N+gXHxU1BP2n/ABtqHifwiNGlNjZ+K1utdtY9Q86Dy5Et2WYLIIvtAEm0YVmGfmwfq/xh+0N+zb4m+B+vfB34S+INPj1PxNo17onhzQtP8PXVhBNe3kckcUS7oEhi8yaYZZiqguWYjk18Uf8ABPT4KeFfjv8AGjVPCPi6/wBYsrGy8PzalHJpU0UcplS4t4wCZI5Bt2zNxjOQOeuft/4e/sDfB7wd4+0PxdpniTxxNfeH9Tt9StY7m/tGieWGVZEDhbYEqWUZAIOM4IoAx/8AglL8Evif8HP+E9/4WP4Z/sX+2v7N+wf6fbXPneV9r8z/AFMj7cebH97Gd3GcHHQftT/G/QPiB4R8UfBL4JeNtQf4uveixsLDTxdadOk9rdLJdot46xxJthguMnzQGAKgtuAJ/wAFIf2jvHH7P3/CGf8ACG6V4fvv+Ei+3/a/7Xt5pdnkfZtmzy5Y8Z8585z0GMc5/OjwP8a/FXhX9peb44afp+jyeIZ9Tv8AUmtZ4ZWshLdrMsgCCQPtAnfaN+RgZJ5yAH7UHhr4y+FfH1np/wAcLnWLjxDJpiTWrarra6lKLQyyqgEqyyBV8xZvl3DBycc5P7bV+JP7UHxr8VfHfx9Z+LvF2n6PZX1lpiabHHpUMscRiSWWQEiSSQ7t0zc5xgDj1/bagAooooAKKKKACiiigD4A/wCC53/NLv8AuMf+2NeT/D39gb4w+MfAOh+LtM8SeB4bHxBplvqVrHc392sqRTRLIgcLbEBgrDIBIznBNfe/7V3g39nnxb/YP/C+bzw/b/Y/tP8AYv8Aa/iN9L3bvK8/Ztmi8z7sOeu3jpu5+IPir8aP2rfhvea1F4Gn8Qab8KvD969n4X1IeFIJ9NXSVl8mxaO+lt2E0bReSElaRjJuU7mLZIB9j/8ABPT4KeKvgR8F9U8I+Lr/AEe9vr3xBNqUcmlTSyRCJ7e3jAJkjjO7dC3GMYI59Pzx/ag/ZN+IvwI8A2fi7xdrXhe9sb3U002OPSrq4klErxSyAkSQRjbthbnOckcen3t/wS/+KXjv4t/ALV/EnxC13+2NTtfE09jDP9jgt9sC21q4TbCiKfmlc5Izz14FdB8avEn7Kvxb8K2/hv4hfEf4f6xplrerfQwf8JpDb7Z1R0D7oZ0Y/LK4wTjnpwKAPhH9lj9nHxxB4R8L/tPvqvh8+EfDF6fEd5Yi4m/tKS2026Z50jj8ryjIwtpNgMoU5XLLk4P+CkP7R3gj9oH/AIQz/hDdK8QWP/CO/b/tf9r28MW/z/s2zZ5UsmceS+c46jGecdf8ftX+OWi6l4h+Fv7N2leINV+B89kbHSR4e8P/ANs2FxBcW4N6kWoeVK8mbiW6ViJSUbcoK7QB84f8KJ+N/wD0Rv4gf+Eve/8AxugDP+Avw41z4t/FjSfh74butPtdT1jzvIm1CR0gXyoJJm3MiOw+WJgMKeSOnWv1W/4J6fBTxV8CPgvqnhHxdf6Pe3174gm1KOTSppZIhE9vbxgEyRxnduhbjGMEc+nzxD4L+FHw8/Zx0jxX8FY9Pi/aL0zRrAJplhq0moazDqDrFFqUbaVJJIPMWJ7wSRmD90Fc4QplfYP2Kfjfr9v8K9QT9p/xtp/hjxcdalNjZ+K1tdCupNP8mDy5Et2WEtGZftAEm05ZWGflwAD86P2X/gp4q+O/j688I+Eb/R7K+stMfUpJNVmljiMSSxRkAxxyHdumXjGMA8+uheeG779nL9sDRtM8by29/N4H8QaXqWotozNKssSmC7IhMojLN5bAYYKN3Gcc1y/wV+KXjv4SeKrjxJ8Pdd/sfU7qyaxmn+xwXG6BnRym2ZHUfNEhyBnjrya+v/DukfA340/sp6h8R/iNqvh/XfjxrujakIoh4g+z6leahF50Gnxx6dBKiNIUitVSNYf3ny8MXJIB6h/w8d+CH/QrfED/AMF1l/8AJdfM/wCxP4ksfGP/AAVUtfF2mRXENjr/AIg1/UrWO5VVlSKa1vZEDhSQGCsMgEjOcE188eOvAnjjwV9l/wCEy8G+IPDv27f9k/tfS5rT7Rs279nmKu7bvTOOm4Z6iu4+C/g79ojwd4m0f4jfDn4d+OIb6GEz6Xqlt4UnuonimhZN6b4XjdWilbBwRhgR2NAH6XftQftZfDr4EePrPwj4u0XxRe317pialHJpVrbyRCJ5ZYwCZJ4zu3QtxjGCOeuPx5r0j9qDxN8ZfFXj6z1D44W2sQeIY9MSG1XVdEXTZTaCWVkIiWKMMvmNN8205ORnjA9I/wCCX/wt8CfFv4+6v4b+IWhf2xplr4ZnvoYPtc9vtnW5tUD7oXRj8srjBOOenAoA0P2WP2cfHEHhHwv+0++q+Hz4R8MXp8R3liLib+0pLbTbpnnSOPyvKMjC2k2AyhTlcsuTj1/46f8AGwL+y/8AhTX/ABI/+Fd+d/av/CXf6N5/27y/K8j7N9o3Y+xS7t23G5MbsnHu/wActT+CXwo/ZQ8dfB7w74r8L6DNYeEtWgsvDs/iFGvVluLaaZUEc0rTM0jTblByTvGOMV80f8Ea/HfgjwV/wsf/AITLxl4f8O/bv7K+yf2vqkNp9o2fbN+zzWXdt3pnHTcM9RQAfC39nHxx+yT47sf2g/iPqvh/VPDPg/zPt9p4euJp7+X7VG9lH5STRRRnElzGW3SLhQxGSAD4x/wUL+NfhX47/GjS/F3hHT9YsrGy8Pw6bJHqsMUcplS4uJCQI5JBt2zLznOQeOmfb/BXxg8W/Hr9t7UvgV428U2/ij4Ua14g1aFdMtoLeKK6tLUXFxZlLu3VZioa3gcMsnzhRksGOfcPG37N/wCw74O1WPTPF1j4X8P300InjtdV8cXVrK8RZlDhJLsEqWVhnGMqR2oA/PD9l/4KeKvjv4+vPCPhG/0eyvrLTH1KSTVZpY4jEksUZAMcch3bpl4xjAPPr9r/AAt/aO8Efsk+BLH9nz4j6V4g1TxN4P8AM+33fh63hnsJftUj3sflPNLFIcR3MYbdGuGDAZABPD/8Eifhr8RfB37SWt6n4u8AeKPD9jN4SuII7rVdGuLWJ5Td2jBA8iAFiqscZzhSe1eQf8FMLC+1T/goB4w0zTLK4vb69m0uC1tbaJpJZ5X0+0VERFBLMzEAADJJAFAH1v8A8PHfgh/0K3xA/wDBdZf/ACXXq/7RXhu+/aN/YtuNM8ES29hN440zTNS05tZZoliiaa3uwJjEJCreWpGFDDdxnHNfFH7DHwS+GFv/AMJR/wANWeGf+EV3fY/+Eb/4S6/udA+1f6/7T5G+SHztv+jbsbtm5Om7nuP2TPj58Qb/APbvsPgzpHjO3vPhhp2p6rpeiafbWtrLF/ZtpbXX2NUuhGZZFVIYSHMjFwASzZOQD6P/AOCenwU8VfAj4L6p4R8XX+j3t9e+IJtSjk0qaWSIRPb28YBMkcZ3boW4xjBHPp8cf8O4vjf/ANDT8P8A/wAGN7/8iV6h/wAFQP2iPjF8JPj7pHhv4e+MP7H0y68MwX00H9mWlxuna5ukL7ponYfLEgwDjjpyax/+Cen7WnjnxV8aNU0/44fFXR4PD0fh+aa1bVY9P02I3YuLdUAlVIyzeW03y7jkZOOMgA+n/wBnXw3ffs5fsW2+meN5be/m8D6Zqepai2jM0qyxLNcXZEJlEZZvLYDDBRu4zjmvmj46f8bAv7L/AOFNf8SP/hXfnf2r/wAJd/o3n/bvL8ryPs32jdj7FLu3bcbkxuycfW/xyv7Hx1+yh46uPBF5b+JYdX8JatBp0mjSreLeym2mjCQmIsJG8wFMLk7hjrXyR/wSl/4sp/wnv/C5f+Ld/wBuf2b/AGV/wl3/ABKP7Q8n7X5vkfadnm7PNi3bc7fMTONwyAc/8Lf2cfHH7JPjux/aD+I+q+H9U8M+D/M+32nh64mnv5ftUb2UflJNFFGcSXMZbdIuFDEZIAOh8avhxrn7d3iq3+LvwiutP0XRNFsl8OXFv4rke2umuYne5Z0W3SdDGUvIgCXDblb5QACdCbxp8V/iH+0dq/hT41SahL+zpqetX5fU7/SY9P0abT0aWXTZF1WOOM+W0qWZjkE/70sgy4fDfR/wV8Sfsq/CTwrceG/h78R/h/o+mXV619NB/wAJpDcbp2REL7pp3YfLEgwDjjpyaAPAPjV8R9D/AG7vCtv8IvhFa6hout6Ler4juLjxXGltatbRI9syI1u87mQveREAoF2q3zAgA+L/ABC/YG+MPg7wDrni7U/Engeax8P6ZcaldR21/dtK8UMTSOEDWwBYqpwCQM4yRXEfBXw3+1V8JPFVx4k+Hvw4+IGj6ndWTWM0/wDwhc1xugZ0cptmgdR80SHIGeOvJrv/AAf+0N+0l4m+OGg/B34teINQj0zxNrVloniPQtQ8PWthPNZXkkccsTbYEmi8yGY4ZSrAOGUjg0AeYfso/s4+OP2gf7e/4Q3VfD9j/wAI79m+1/2vcTRb/P8AN2bPLikzjyXznHUYzzj6v/Yz/Yq+Kfwk/aT8N/ELxJr/AIPutM0f7X58On3ly87ebaTQrtV7dFPzSqTlhwD16VoftXeBPHH7N/8AYP8Awx94N8Qab/wk32n/AISn+yNLm13zPs/lfZd/2hZ/Jx591jbt3ZOd20Y83/ZJ/ay+NF5+1RovhX40/Ea303w9HNewa5BrOm2GmrbSx2s+1JpPJjaJhOiDBYHd8p64oA/SevB/2X/2svh18d/H154R8I6L4osr6y0x9Skk1W1t44jEksUZAMc8h3bpl4xjAPPTPzh/wUL/AGtPHPhX40aXp/wP+Kujz+HpPD8M102lR6fqUQuzcXCuDKySFW8tYfl3DAwcc5Ox8atG+Hnwr8K2/iH9h+bT7/4hXN6tnqkXhTUj4luhpLI7ys9q73ASPz47QGXYCGKruG/BAPUP2p/2jvBFx4u8UfswJpXiAeLvE9kPDlnfG3h/s2O51K1VIHkk83zRGpuY95ERYYbCtgZ+AP2rv2cfHH7P39g/8Jlqvh++/wCEi+0/ZP7IuJpdnkeVv3+ZFHjPnJjGehzjjP1Pp9r8Lrn4C33xi+MWpaPpv7SOm6Ze6oBrGr/2dqkOpWnmnTGbSjJHHu8qGzKIYMSDaSr7yW+OPjp8bfif8Y/7L/4WP4m/tr+xfO+wf6BbW3k+b5fmf6mNN2fKj+9nG3jGTkA/X79k7/k1n4af9iZpP/pFFXD/ALUH7WXw6+BHj6z8I+LtF8UXt9e6YmpRyaVa28kQieWWMAmSeM7t0LcYxgjnrjQ/Y7+JXw61H4F/Dbwjp/j7wvd+IU8JadA2jwazbyXqyxWSGRDAH3hkCPuGMrtOcYNZ/wC1B4A/ZX8VePrPUPjhf+F7fxDHpiQ2q6r4sfTZTaCWVkIiW4jDL5jTfNtOTkZ4wAD44/4dxfG//oafh/8A+DG9/wDkSvu/9jP4ca58JP2bPDfw98SXWn3Wp6P9r8+bT5HeBvNu5pl2s6Ix+WVQcqOQevWuX/4KF+JvjL4V+C+l6h8D7bWJ/EMniCGG6XStEXUpRaG3uGcmJopAq+YsPzbRg4GecHkPBXx+1HSP2IdSvPiX8QtH0X4xWfh/Vpm0zWHtLHVIrtTcNZBtPcIQzRi3ZFMXzhlOG3ZIB9T1+SOh/EfQ/hJ/wU68T/ELxJa6hdaZo/jPxD58Onxo87eabyFdqu6KfmlUnLDgHr0r6P8A+Cb37VGr+Lf+Ez/4Xz8WPD9v9j+wf2L/AGvLYaXu3fafP2bVi8z7sOeu3jpu5sf8FC/gN8D7P9mPxp8afCvhy3k8Q6nNa6rBrltrF1PFctd38HmTIvnNCyyLM5GF24YFccUAfR/7L/xr8K/HfwDeeLvCOn6xZWNlqb6bJHqsMUcplSKKQkCOSQbdsy85zkHjpnj/ANl/9rL4dfHfx9eeEfCOi+KLK+stMfUpJNVtbeOIxJLFGQDHPId26ZeMYwDz0z+eP7L/AI+/ao8K+AbzT/gfYeKJ/D0mpvNdNpXhNNSiF2YolcGVreQq3lrD8u4YGDjnJ/Q79l/wB+yv4V8fXmofA+/8L3HiGTTHhul0rxY+pSi0MsTOTE1xIFXzFh+baMHAzzggHvFFFFABRRRQAUUUUAfAH/Bc7/ml3/cY/wDbGuf+E/x0/wCGkPhX4Z/Y+/4Rb/hGf7S0a00z/hKf7Q+2+X/ZsKXPmfZPLjz5n2LbjzRt8zOW24P1/wDtXeMv2efCX9g/8L5s/D9x9s+0/wBi/wBr+HH1Tbt8rz9m2GXy/vQ56buOu3j5g/ak+NH7KUPwJ12T4DT+H9B+IS/Zv7F1Hw94Un0m/g/0mLz/ACrtbeMx5g85W+cblZl53YIAf8LN/wCHfv8AxZr+xP8AhYn9uf8AFTf2r9r/ALI8jzv9F8jydlxux9i3b94z5mNo25PwBX2/+xT8a/gDcfCvUH/af1fT/E/i4a1KLG88V6Fca7dR6f5MHlxpcNDMVjEv2giPcMMzHHzZPD/8EifCfhXxj+0lremeLvDOj+ILGHwlcTx2uq2EV1Ekou7RQ4SRSAwVmGcZwxHc0AbH7Lf7c/8Awpz4E6F8OP8AhV39tf2L9p/0/wD4SH7N53m3Ms/+r+zPtx5u37xztzxnA9A/4eaf9UT/APLr/wDuOvb/ABNqX7F3h/4yR/CnV/Bfw/t/F017a2Kab/wggfM9yIzCnmramL5hLHzuwN3JGDj5w/4LKeBPBHgr/hXH/CG+DfD/AId+3f2r9r/sjS4bT7Rs+x7N/lKu7bvfGem446mgDwD4afHT/hEv2ybn48/8It9s+0a1qmp/2L/aHl7ftiXC+X5/lnOz7R12fNt6DPB+2t8dP+Ggfipp/jL/AIRb/hHfsOjRaZ9k/tD7Xv2TTy+Zv8uPGfOxjH8Oc84Gf4m/Z3+MXh/4Nx/FbV/B/wBn8IzWVrfJqX9p2j5guTGIX8pZTL8xlj425G7kDBx9j/8ABIn4a/Drxj+zbrep+LvAHhfxBfQ+LbiCO61XRre6lSIWlowQPIhIUMzHGcZYnuaAPCP21v2Pv+GfvhXp/jL/AIWJ/wAJF9u1qLTPsn9ifZNm+GeXzN/nyZx5OMY/iznjB3/2W/2Zfs/wJ0L9qz/hNt3/AAiv2nxN/wAI3/ZOPtX9mXMr+R9q875PN+y43+Udm/7rY5+9/wBqDxN8GvCvgGz1D44W2jz+HpNTSG1XVdEbUohdmKVkIiWKQq3lrN820YGRnnB/MH9rr4xtf/GHxNpHwZ8c6xp3wwvIYYNP0TR57nTdL8p7WMXKLZfu1VXmM5cGMByzMc7skA+h/wDlIv8A9U1/4Vr/ANxn+0ft/wD4D+V5f2H/AG93mfw7efp/4l+J/wDhmf8AY2ttV+w/8JR/wgejaXpnl+b9i+3bXt7PzM4l8v72/GG6Yz3r4g/4JS/G34YfBz/hPf8AhY/ib+xf7a/s37B/oFzc+d5X2vzP9TG+3Hmx/exndxnBx9X/APBRrW9L8Tf8E6vE/iTRLr7VpmsWWkX1jP5bJ50Et/aPG+1gGXKsDhgCM8gUAfnj+2t8dP8AhoH4qaf4y/4Rb/hHfsOjRaZ9k/tD7Xv2TTy+Zv8ALjxnzsYx/DnPOB9P/wDCsv8Ah37/AMXl/tv/AIWJ/bn/ABTP9lfZP7I8jzv9K8/zt9xux9i27Ngz5mdw24PwBX7zeNvCfhXxjpUemeLvDOj+ILGGYTx2uq2EV1EkoVlDhJFIDBWYZxnDEdzQB+fHxY+Bf/DSHwr8Tftg/wDCU/8ACM/2lo13qf8Awi39n/bfL/s2F7by/tfmR58z7Fuz5Q2+ZjDbcn4gr7P+OGva54c/4KXWXwi8PazqGk/D2bxNoVhL4QsLp4NGe2uY7NrmBrJCITHKZpTIhTa5kfcDuOfUP+CkP7K+r+Lf+EM/4UN8J/D9v9j+3/21/ZEVhpe7d9m8jfuaLzPuzY67eem7kA8/+E/wL/4Zv+Ffhn9sH/hKf+Em/s3RrTU/+EW/s/7F5n9pQpbeX9r8yTHl/bd2fKO7y8YXdkdB/wAKy/4eBf8AF5f7b/4V3/Yf/FM/2V9k/tfz/J/0rz/O32+3P23bs2HHl53HdgeoeD/2hv2bfDPwP0H4O/FrxBp8mp+GdGstE8R6FqHh66v4Ib2zjjjlibbA8MvlzQnDKWUlAyk8GvZ/2X/E3wa8VeAbzUPgfbaPB4ej1N4bpdK0RtNiN2IomcmJooyzeW0PzbTkYGeMAA9Ir8of27vE/wDwhX/BT/VPGX2H7d/wjutaHqf2TzfK+0eRaWUvl78Nt3bMZwcZzg9K+t/+Cu3izxV4O/Zt0TU/CPiXWPD99N4tt4JLrSr+W1leI2l2xQvGwJUsqnGcZUHtXP8A7PPw40n4u/8ABOaTxNrPhDR/FvxH1/w/rcNtr2sWkFxqlzdrLdwWpa9nG8MgSFEZnGwIoBAUYAPkj9uf9pr/AIaM/wCEX/4on/hGv+Ea+2f8xb7Z9p+0eR/0xj2bfI987u2OfP8A9lv4m/8ACnPjtoXxH/sT+2v7F+0/6B9r+zed5ttLB/rNj7cebu+6c7ccZyD46fBL4n/Bz+y/+Fj+Gf7F/trzvsH+n21z53leX5n+pkfbjzY/vYzu4zg4/Sb4beDv2d/B37Gfgz4jfEb4d+B4bGHwlo8+qapc+FILqV5ZoIE3vsheR2aWVcnBOWJPc0Afnz+2t8dP+Ggfipp/jL/hFv8AhHfsOjRaZ9k/tD7Xv2TTy+Zv8uPGfOxjH8Oc84B+xT8DP+GgfipqHg3/AISn/hHfsOjS6n9r/s/7Xv2TQReXs8yPGfOznP8ADjHOR+l3wV8N/sq/FvwrceJPh78OPh/rGmWt61jNP/whcNvtnVEcptmgRj8sqHIGOevBr8ifBPizxV4O1WTU/CPiXWPD99NCYJLrSr+W1leIsrFC8bAlSyqcZxlQe1AH3P8A8NNf8Mdf8Y4/8IT/AMJp/wAIX/zHv7W/s77Z9r/07/j38mby9n2rZ/rGzs3cZ2g/5SL/APVNf+Fa/wDcZ/tH7f8A+A/leX9h/wBvd5n8O3n5w8Lfs8/tJfGzQYPidYeH9Q8VW+ubtmsah4htWnuvJYwHcbicS/KYig3Dooxxivs//glL8Evif8HP+E9/4WP4Z/sX+2v7N+wf6fbXPneV9r8z/UyPtx5sf3sZ3cZwcAHQft3eGf8AhCv+CYGqeDftv27/AIR3RtD0z7X5XlfaPIu7KLzNmW27tmcZOM4yetflBX6/fFX9qH9lr7ZrXgDx/wCKtPvvsN69jqulah4avLuDz4JcMjKbdo32yR5BGRlQQehr8+f+Chfib4NeKvjRpeofA+20eDw9H4fhhul0rRG02I3YuLhnJiaKMs3ltD8205GBnjAAP0m/bW+On/DP3wr0/wAZf8It/wAJF9u1qLTPsn9ofZNm+GeXzN/lyZx5OMY/iznjB/MH4l/HT/hLf2ybb48/8It9j+z61pep/wBi/wBoeZu+xpbr5fn+WMb/ALP12fLu6HHP6DeNv2rv2OPGOlR6Z4u8T6P4gsYZhPHa6r4RvbqJJQrKHCSWpAYKzDOM4YjvXzB44+Di+L/2l4fj74B8DaPN8AbfU7DVLm9ggtrayGm2SwrqLHTn2zFQ1vdbk8nMmCVV9wyAdx/w80/6on/5df8A9x18QfFjxP8A8Jr8VPE3jL7D9h/4SLWrvU/snm+b9n8+Z5fL34Xdt34zgZxnA6V9f/tXeBPA/wC0h/YP/DH3g3w/qX/CM/af+Ep/sjS4dC8v7R5X2Xf9oWDzs+RdY27tuDnbuGfpfQvhn8CvhR+y54f8RfGH4Y+B7CbQfD+mw+Ir258MW19Kt2yQwuXaKKRpWM74LLuySWzjmgD8ia+//wDhWX/Dv3/i8v8Abf8AwsT+3P8Aimf7K+yf2R5Hnf6V5/nb7jdj7Ft2bBnzM7htwfnj/goX4m+DXir40aXqHwPttHg8PR+H4YbpdK0RtNiN2Li4ZyYmijLN5bQ/NtORgZ4wPL/G3xK+IvjHSo9M8XePvFHiCxhmE8drqus3F1EkoVlDhJHIDBWYZxnDEd6APtf/AIZl/wCGxf8AjI7/AITb/hC/+E0/5gP9k/2j9j+yf6D/AMfHnQ+Zv+y7/wDVrjft5xuJ/wAOy/8Aqtn/AJan/wB2V8YeFvix8U/DOgwaJ4b+JfjDR9Mtd3kWOn69c28EO5i7bY0cKuWZmOByST3rQ/4Xt8b/APosnxA/8Ki9/wDjlAHsH7CPhn/hCv8Agp/pfg37b9u/4R3Wtc0z7X5XlfaPItL2LzNmW27tmcZOM4yetb//AAWr/wCTptA/7Ey2/wDS29qv+yL8PPiT8LvjD4Z/ac+Lun3Fj4D8mbVdR8TXOoxXssi39rJHDM8UUkly7Sy3UWfkLAuS2AGI6j9tbwR4n/a2+Kmn/Ef9nzTP+Ew8M6Xo0WiXd/8AaI9P8q9jmnneLy7xopDiO5gbcFKnfgHIIAB0H/DzT/qif/l1/wD3HXyB+1J8Tf8Ahcfx2134j/2J/Yv9tfZv9A+1/afJ8q2ig/1mxN2fK3fdGN2OcZPs/wDwSJ8J+FfGP7SWt6Z4u8M6P4gsYfCVxPHa6rYRXUSSi7tFDhJFIDBWYZxnDEdzX2P4m1L9i7w/8ZI/hTq/gv4f2/i6a9tbFNN/4QQPme5EZhTzVtTF8wlj53YG7kjBwAfkjX6/WPwy/wCFx/8ABOPwj8OP7b/sX+2vBmgf6f8AZPtPk+VHaz/6vem7PlbfvDG7POMH5g/4LKeBPBHgr/hXH/CG+DfD/h37d/av2v8AsjS4bT7Rs+x7N/lKu7bvfGem446muH+Hvwn/AG69R8A6HqHhHVfHCeHrvTLebR1tvH0VvEto0StCEiN2pjXyyuF2jaMDAxigD1j/AIWb/wAO/f8AizX9if8ACxP7c/4qb+1ftf8AZHked/ovkeTsuN2PsW7fvGfMxtG3J9g/Yp/Y+/4Z++KmoeMv+Fif8JF9u0aXTPsn9ifZNm+aCXzN/nyZx5OMY/iznjB+OPG37KP7Y/jHVY9T8XeGNY8QX0MIgjutV8XWV1KkQZmCB5LokKGZjjOMsT3r6f8A+CengD9qjwr8aNU1D44X/ii48PSeH5obVdV8WJqUQuzcW7IREtxIVby1m+baMDIzzggH2PRRRQAUUUUAFFFFAHj/AO1d+zj4I/aB/sH/AITLVfEFj/wjv2n7J/ZFxDFv8/yt+/zYpM48lMYx1Oc8Y/Nn4Q/BTwr4q/b8u/gfqF/rEfh6DxBrOmrdQTRLemK0S6aMlzGU3EwJuOzBycAcY+5/+CkP7OPjj9oH/hDP+EN1Xw/Y/wDCO/b/ALX/AGvcTRb/AD/s2zZ5cUmceS+c46jGeceX/sZ/sVfFP4SftJ+G/iF4k1/wfdaZo/2vz4dPvLl52820mhXar26KfmlUnLDgHr0oA7D/AIdxfBD/AKGn4gf+DGy/+RK+f/8Agip/ydNr/wD2Jlz/AOltlR/wWr/5Om0D/sTLb/0tva84/ag/ZN+IvwI8A2fi7xdrXhe9sb3U002OPSrq4klErxSyAkSQRjbthbnOckcegB+h3jj9k34deKv2l4fjhqGteKI/EMGp2GpLawXVutkZbRYVjBQwF9pECbhvycnBHGPnj/gud/zS7/uMf+2NeIfAX9ir4p/Fv4T6T8QvDev+D7XTNY87yIdQvLlJ18qeSFtypbuo+aJiMMeCOnSuv/4dxfG//oafh/8A+DG9/wDkSgD6A/aW/wCUNum/9iZ4Y/8ARthR/wAEVP8Ak1nX/wDsc7n/ANIrKvij9nXxJY/s5ftpW+p+N4ri/h8D6nqem6iujKsrSyrDcWhMIlMYZfMYHLFTt5xnivtf/h478EP+hW+IH/gusv8A5LoA93/ag+CnhX47+AbPwj4uv9YsrGy1NNSjk0qaKOUypFLGATJHINu2ZuMZyBz1z8wfG79gb4PeDvgv4v8AF2meJPHE194f8P32pWsdzf2jRPLDbvIgcLbAlSyjIBBxnBFfc9FAH5Q/8E3v2cfBH7QP/CZ/8JlqviCx/wCEd+wfZP7IuIYt/n/ad+/zYpM48lMYx1Oc8Y+xv+Cgnhux8Hf8E1dd8I6ZLcTWPh/TNG021kuWVpXihvbONC5UAFiqjJAAznAFQf8ABSH9nHxx+0D/AMIZ/wAIbqvh+x/4R37f9r/te4mi3+f9m2bPLikzjyXznHUYzzj5/wDhb+zj44/ZJ8d2P7QfxH1Xw/qnhnwf5n2+08PXE09/L9qjeyj8pJoooziS5jLbpFwoYjJABAMf/gnp+yb8Ovjv8F9U8XeLta8UWV9ZeIJtNjj0q6t44jElvbyAkSQSHdumbnOMAcdc+4f8E9P2sviL8d/jRqnhHxdovheysbLw/NqUcmlWtxHKZUuLeMAmSeQbdszcYzkDn1+QP+Chfxr8K/Hf40aX4u8I6frFlY2Xh+HTZI9VhijlMqXFxISBHJINu2Zec5yDx0yftQfsm/EX4EeAbPxd4u1rwve2N7qaabHHpV1cSSiV4pZASJIIxt2wtznOSOPQA9H/AGlv+UyWm/8AY5+GP/RVhX1B/wAFIf2jvHH7P3/CGf8ACG6V4fvv+Ei+3/a/7Xt5pdnkfZtmzy5Y8Z8585z0GMc5n/4J9+JLHwd/wTV0LxdqcVxNY6Bpms6ldR2yq0rxQ3t5I4QMQCxVTgEgZxkivGPjp/xsC/sv/hTX/Ej/AOFd+d/av/CXf6N5/wBu8vyvI+zfaN2PsUu7dtxuTG7JwAfDHxC8SX3jHx9rni7U4reG+1/U7jUrqO2VliSWaVpHCBiSFDMcAknGMk1+k/8AwRU/5NZ1/wD7HO5/9IrKvzY+IXhu+8HePtc8I6nLbzX3h/U7jTbqS2ZmieWGVo3KFgCVLKcEgHGMgV+k/wDwRU/5NZ1//sc7n/0isqAPd/2oPgp4V+O/gGz8I+Lr/WLKxstTTUo5NKmijlMqRSxgEyRyDbtmbjGcgc9c/FHxS/aO8cfsk+O779nz4caV4f1Twz4P8v7Bd+Ibeae/l+1Rpeyea8MsUZxJcyBdsa4UKDkgk/o/XyR+3T+1l8OvCun/ABE+B+oaL4ok8Qz+H7jTVuoLW3ayEt3Y7oyXM4faBOm47MjBwDxkA+GP2rv2jvHH7QP9g/8ACZaV4fsf+Ed+0/ZP7It5ot/n+Vv3+ZLJnHkpjGOpznjH6XeCfhxofxb/AGAPBPw98SXWoWumax4M0Lz5tPkRJ18qG2mXazo6j5olByp4J6da/HGigD9tv2X/AIKeFfgR4BvPCPhG/wBYvbG91N9Skk1WaKSUSvFFGQDHHGNu2FeMZyTz0x+YP/BPT4KeFfjv8aNU8I+Lr/WLKxsvD82pRyaVNFHKZUuLeMAmSOQbdszcYzkDnrk/Zf8A2TfiL8d/AN54u8I614XsrGy1N9Nkj1W6uI5TKkUUhIEcEg27Zl5znIPHqftQfsm/EX4EeAbPxd4u1rwve2N7qaabHHpV1cSSiV4pZASJIIxt2wtznOSOPQA+j9C+Nfir9nr9qPw/+yb4L0/R77wXp3iDTdNi1DWIZZdUaLUHhuJi0kUkcW5XvJQhEQAAXIYgk/e9fmR8If2svh14V/YDu/gfqGi+KJPEM/h/WdNW6gtbdrIS3b3TRkuZw+0CdNx2ZGDgHjPMf8E3v2jvBH7P3/CZ/wDCZaV4gvv+Ei+wfZP7It4Zdnkfad+/zZY8Z85MYz0OccZAPrf4hfsDfB7xj4+1zxdqfiTxxDfeINTuNSuo7a/tFiSWaVpHCBrYkKGY4BJOMZJr4g/4KF/BTwr8CPjRpfhHwjf6xe2N74fh1KSTVZopJRK9xcRkAxxxjbthXjGck89Mfe3wF/bV+Fnxb+LGk/D3w3oHjC11PWPO8ibULO2SBfKgkmbcyXDsPliYDCnkjp1r5Q/4LV/8nTaB/wBiZbf+lt7QB5x/wT0+CnhX47/GjVPCPi6/1iysbLw/NqUcmlTRRymVLi3jAJkjkG3bM3GM5A565938TfEfXPhX8ZI/2H/D1rp9z8Pb+9tfDkuqX8bvrIttXEcly6yo6w+YpvpfLJhKgKm5Xwc/S/8AwUL+Cnir47/BfS/CPhG/0eyvrLxBDqUkmqzSxxGJLe4jIBjjkO7dMvGMYB59fzB8cfBTxV4V/aXh+B+oX+jyeIZ9TsNNW6gmlayEt2sLRkuYw+0CdNx2ZGDgHjIB+q37KP7OPgj9n7+3v+EN1XxBff8ACRfZvtf9r3EMuzyPN2bPKijxnznznPQYxzn5o1341+Kv2hf2o/EH7JvjTT9HsfBeo+INS02XUNHhli1RYtPea4hKySySRbmeziDkxEEFsBSQR8sftXfs4+OP2fv7B/4TLVfD99/wkX2n7J/ZFxNLs8jyt+/zIo8Z85MYz0OccZ+l9C+NfhX9oX9lzw/+yb4L0/WLHxpqPh/TdNi1DWIYotLWXT0huJi0kUkku1ks5QhERJJXIUEkAHgH/BQv4KeFfgR8aNL8I+Eb/WL2xvfD8OpSSarNFJKJXuLiMgGOOMbdsK8Yzknnpj7H/wCHcXwQ/wChp+IH/gxsv/kSuP8Agr8R9D/YR8K3Hwi+LtrqGta3rV63iO3uPCkaXNqttKiWyo7XDwOJA9nKSAhXay/MSSB8cfsv/BTxV8d/H154R8I3+j2V9ZaY+pSSarNLHEYklijIBjjkO7dMvGMYB59QCx+2Z8OND+En7SfiT4e+G7rULrTNH+yeRNqEiPO3m2kMzbmREU/NKwGFHAHXrXl9esXnhu+/Zy/bA0bTPG8tvfzeB/EGl6lqLaMzSrLEpguyITKIyzeWwGGCjdxnHNfqN+yj+0d4I/aB/t7/AIQ3SvEFj/wjv2b7X/a9vDFv8/zdmzypZM48l85x1GM84APIP2lv+UNum/8AYmeGP/RthR/wRU/5NZ1//sc7n/0isq+MPG3w41z4t/t/+Nvh74butPtdT1jxnrvkTahI6QL5U1zM25kR2HyxMBhTyR061+i3/BPT4KeKvgR8F9U8I+Lr/R72+vfEE2pRyaVNLJEInt7eMAmSOM7t0LcYxgjn0APjj/gip/ydNr//AGJlz/6W2VfY/jj9k34deKv2l4fjhqGteKI/EMGp2GpLawXVutkZbRYVjBQwF9pECbhvycnBHGPzB/Zf+Cnir47+Przwj4Rv9Hsr6y0x9Skk1WaWOIxJLFGQDHHId26ZeMYwDz6+7/8ADuL43/8AQ0/D/wD8GN7/APIlAHoH/Bc7/ml3/cY/9sa8n+Hv7fPxh8HeAdD8I6Z4b8DzWOgaZb6bayXNhdtK8UMSxoXK3IBYqoyQAM5wBWx/w7i+N/8A0NPw/wD/AAY3v/yJX6L/AAR8N33g74L+EPCOpy28194f8P2Om3UlszNE8sNukblCwBKllOCQDjGQKAPzo/4eO/G//oVvh/8A+C69/wDkuv0/r44/4KF/sm/EX47/ABo0vxd4R1rwvZWNl4fh02SPVbq4jlMqXFxISBHBINu2Zec5yDx6+D/8EVP+Tptf/wCxMuf/AEtsqAP0/ooooAKKKKACiiigAr82P2mPjr+2f4I+JXja7tJPFGleC9K8QXkOn6hP4Lt/sUdp9qaO3IuZLUhlZTGFYsd24ckmvqf9uf8Aaa/4Zz/4Rf8A4on/AISX/hJftn/MW+x/Zvs/kf8ATGTfu8/2xt7546D4l+Gf+GmP2NrbSvt3/CL/APCeaNpep+Z5X237Due3vPLxmLzPu7M5XrnHagD8ufG1x+0B+0bqsfjfU/DvijxxNYQjSl1HSvDRaKJUZpfJJtYQm4Gctz82HGeMV9f/APBXb4lfDrxj+zbommeEfH3hfxBfQ+LbeeS10rWbe6lSIWl2pcpG5IUMyjOMZYDuKx/+Fm/8O/f+LNf2J/wsT+3P+Km/tX7X/ZHked/ovkeTsuN2PsW7fvGfMxtG3JP+HZf/AFWz/wAtT/7soA8v/Ys+Jv7TXhyLwJpelr4gtfhFa61Eb+/PhiJtNt9PN6WvZJL5oDsjXNwXkMg8vDcrt49w/wCCkP7VGr+Ev+EM/wCFDfFjw/cfbPt/9tf2RLYapt2/ZvI37ll8v702Om7nrt48/wDix8dP+Gb/AIV+Jv2Pv+EW/wCEm/s3RrvTP+Ep/tD7F5n9pQvc+Z9k8uTHl/bduPNO7y85XdgfEFAH6v8Awn/Zc+BPxM+Ffhn4j+NvA39qeJvGGjWmt65f/wBr3sH2u9uoUnnl8uKZY03SSO21FVRnAAAAqv42/Zv/AGHfB2qx6Z4usfC/h++mhE8drqvji6tZXiLMocJJdglSysM4xlSO1cP+wH+2D/wlviL4e/Ab/hXf2P7PoyaZ/bX9t+Zu+x2DN5nkeQMb/s/Tf8u7qcc+P/8ABav/AJOm0D/sTLb/ANLb2gDgP+G2v2nf+imf+UDTf/kevs/4F/tGv4j/AGGW1TVPif4fuvi7daNqwsLAXNkupXGoCW5WyjjsVA3yNi3CRiM+ZleG3c/KH7a37H3/AAz98K9P8Zf8LE/4SL7drUWmfZP7E+ybN8M8vmb/AD5M48nGMfxZzxg9/wDsB/sff8Jb4d+Hvx6/4WJ9j+z60mp/2L/Ynmbvsd+y+X5/njG/7P12fLu6HHIBwHjr9p/9tXwV9l/4TLW/EHh37dv+yf2v4MtLT7Rs279nmWq7tu9M46bhnqK4/wAU/tDftJfGzQZ/hjf+INQ8VW+ubd+j6f4etWnuvJYTjaLeAS/KYg52nopzxmv0O/bn/Zl/4aM/4Rf/AIrb/hGv+Ea+2f8AMJ+2faftHkf9No9u3yPfO7tjngP2W/2GP+FOfHbQviP/AMLR/tr+xftP+gf8I99m87zbaWD/AFn2l9uPN3fdOduOM5ABw/8AwT0/ZL8D+KvgvqmofHD4Vaxb+IY/EE0NquqyahpsptBb27IRErxhl8xpvm2nJyM8YH0P8avEn7Kvxb8K2/hv4hfEf4f6xplrerfQwf8ACaQ2+2dUdA+6GdGPyyuME456cCuQ/bW/bB/4Z++Kmn+Df+Fd/wDCRfbtGi1P7X/bf2TZvmni8vZ5EmceTnOf4sY4yfygoA/Y7xto3w88P/sAeNtI+FM2nzeEbfwZrv8AZr6fqRvoDuhuWl2zl3L/AL1pM/McHI4xgflj8C/jb8T/AIOf2p/wrjxN/Yv9teT9v/0C2ufO8rzPL/10b7cebJ93Gd3OcDH6P/sI+Gf+E1/4JgaX4N+2/Yf+Ei0bXNM+1+V5v2fz7u9i8zZld23fnGRnGMjrXj//AA7L/wCq2f8Alqf/AHZQB8wfsvt4Q+I37XunXnxxv9Pk0TxBe6hfeILvUL4abBJO9vcTB2ljaMR5n2YClQSQoGDiv0u+CviT9lX4SeFbjw38PfiP8P8AR9Mur1r6aD/hNIbjdOyIhfdNO7D5YkGAccdOTX5o/DT4Gf8ACW/tk3PwF/4Sn7H9n1rVNM/tr+z/ADN32NLhvM8jzBjf9n6b/l3dTjn6f/4dl/8AVbP/AC1P/uygDxjwT+1d+2P4x1WTTPCPifWPEF9DCZ5LXSvCNldSpEGVS5SO1JChmUZxjLAd6+t/gL+zr4M+M3wn0n4k/tEeANQvfiVrfnf27PqEt5pc7+TPJBButYXiSPFvFABiNdwAY5LEn5v/AOCKn/J02v8A/YmXP/pbZV+n9AH5gf8ABVr4JfDD4Of8IF/wrjwz/Yv9tf2l9v8A9PubnzvK+yeX/rpH2482T7uM7uc4GPlDwtoWueJteg0Tw3o2oaxqd1u8ix0+1e4nm2qXbbGgLNhVZjgcAE9q/W79uf8AZl/4aM/4Rf8A4rb/AIRr/hGvtn/MJ+2faftHkf8ATaPbt8j3zu7Y5/OH4aeJ/wDhmf8AbJudV+w/8JR/wgetappnl+b9i+3bUuLPzM4l8v72/GG6Yz3oAseCfi5+0Z+zlpUngjTLrWPA8N/MdVbTtV8OwrLKzqsXnAXUBfaRAF4+XKHHOa6j41al+2j8W/Ctv4b+IXgv4gaxplrerfQwf8IIbfbOqOgfdDaox+WVxgnHPTgV7f8A8Ky/4eBf8Xl/tv8A4V3/AGH/AMUz/ZX2T+1/P8n/AErz/O32+3P23bs2HHl53HdgH/DzT/qif/l1/wD3HQB8Mal4T8Vad4yXwjqHhnWLTxC80UC6PPYSx3rSyhTGggK7yzh02jGW3DGcivqf9hj4JfDC3/4Sj/hqzwz/AMIru+x/8I3/AMJdf3Ogfav9f9p8jfJD523/AEbdjds3J03c8BY/E3/hcf8AwUc8I/Ef+xP7F/trxnoH+gfa/tPk+VJawf6zYm7PlbvujG7HOMn7+/bn/Zl/4aM/4Rf/AIrb/hGv+Ea+2f8AMJ+2faftHkf9No9u3yPfO7tjkA+KP2J7Pw9p3/BVS10/wi9u/h608Qa/Do7W1ybiJrRbW9WEpKWYyL5YXDbjuGDk5zX6D/Gr9nf4O/FvxVb+JPiF4P8A7Y1O1slsYZ/7Tu7fbAru4TbDKin5pXOSM89eBXyh/wAMy/8ADHX/ABkd/wAJt/wmn/CF/wDMB/sn+zvtn2v/AEH/AI+POm8vZ9q3/wCrbOzbxncPp/8AYp+On/DQPwr1Dxl/wi3/AAjv2HWpdM+yf2h9r37IYJfM3+XHjPnYxj+HOecAAx/+Chfib4y+FfgvpeofA+21ifxDJ4ghhul0rRF1KUWht7hnJiaKQKvmLD820YOBnnB8A0+1+F1z8Bb74xfGLUtH039pHTdMvdUA1jV/7O1SHUrTzTpjNpRkjj3eVDZlEMGJBtJV95LesfsU/tg/8NA/FTUPBv8Awrv/AIR37Do0up/a/wC2/te/ZNBF5ezyI8Z87Oc/w4xzkef/ALfn7H3/AAlviL4hfHr/AIWJ9j+z6M+p/wBi/wBieZu+x2Cr5fn+eMb/ALP12fLu6HHIB8geOvGX7Q37TH2X+1bPxB48/wCEX3+X/ZHhxH+w/aNud/2SEY3/AGcY3/3DjvX0/D4L+FHw8/Zx0jxX8FY9Pi/aL0zRrAJplhq0moazDqDrFFqUbaVJJIPMWJ7wSRmD90Fc4QplfAP2GP2mv+Gc/wDhKP8Aiif+El/4SX7H/wAxb7H9m+z+f/0xk37vP9sbe+eOg/YR8T/8Jr/wU/0vxl9h+w/8JFrWuan9k83zfs/n2l7L5e/C7tu/GcDOM4HSgD2/4K6N8PPip4VuPEP7cE2n2HxCtr1rPS4vFepHw1dHSVRHiZLVHtw8fnyXYEuwksGXcdmB8cfsv+JvjL4V8fXmofA+21ifxDJpjw3S6Voi6lKLQyxM5MTRSBV8xYfm2jBwM84P6L/trfsff8NA/FTT/GX/AAsT/hHfsOjRaZ9k/sT7Xv2TTy+Zv8+PGfOxjH8Oc84Hj/8AwrL/AId+/wDF5f7b/wCFif25/wAUz/ZX2T+yPI87/SvP87fcbsfYtuzYM+ZncNuCAfGHx61n4h+IPixq2r/FaHUIfF1x5P8AaSahposZxtgjWLdAEQJ+6WPHyjIwec5P1f8A8Ea/HfgjwV/wsf8A4TLxl4f8O/bv7K+yf2vqkNp9o2fbN+zzWXdt3pnHTcM9RXQf8My/8Ni/8ZHf8Jt/whf/AAmn/MB/sn+0fsf2T/Qf+PjzofM3/Zd/+rXG/bzjcT/h2X/1Wz/y1P8A7soA6D9qef8AZx+H/hHxR8bfgl4u8Hp8XUvRfWF/p/ipNRnee6ulju3WzeaSJt0M9xkeUQoJYBdoI6j/AIJ6ftN2vir4L6pqHxw+LfheDxDH4gmhtV1W+sdNlNoLe3ZCIl8sMvmNN8205ORnjA83/wCHZf8A1Wz/AMtT/wC7KP8Ah2X/ANVs/wDLU/8AuygD4w+CvxS8d/CTxVceJPh7rv8AY+p3Vk1jNP8AY4LjdAzo5TbMjqPmiQ5Azx15Nfo/8C/2jX8R/sMtqmqfE/w/dfF260bVhYWAubJdSuNQEtytlHHYqBvkbFuEjEZ8zK8Nu5+EP2KfgZ/w0D8VNQ8G/wDCU/8ACO/YdGl1P7X/AGf9r37JoIvL2eZHjPnZzn+HGOcjoLH4Zf8ACnP+CjnhH4cf23/bX9i+M9A/0/7J9m87zZLWf/V732483b945254zgAHQeOv2n/21fBX2X/hMtb8QeHft2/7J/a/gy0tPtGzbv2eZaru270zjpuGeorn/wDhtr9p3/opn/lA03/5Hr3/AP4Lnf8ANLv+4x/7Y1z/AMJ/+CeP/Ca/Cvwz4y/4W/8AYf8AhItGtNT+yf8ACM+b9n8+FJfL3/al3bd+M4GcZwOlAH0f/wAEv/il47+LfwC1fxJ8Qtd/tjU7XxNPYwz/AGOC32wLbWrhNsKIp+aVzkjPPXgVsfsv+AP2V/Cvj681D4H3/he48QyaY8N0uleLH1KUWhliZyYmuJAq+YsPzbRg4GecH54/4Wb/AMO/f+LNf2J/wsT+3P8Aipv7V+1/2R5Hnf6L5Hk7Ljdj7Fu37xnzMbRtyfYP2Kf2Pv8Ahn74qah4y/4WJ/wkX27RpdM+yf2J9k2b5oJfM3+fJnHk4xj+LOeMEA+n6KKKACiiigAooooA+AP+C53/ADS7/uMf+2NV/wDgnj4A/aosPir8P/E/ie/8UN8MG0xpoYZ/FiTWX2STT5BaAWYuCQoZoNq+X8mBwu3ix/wXO/5pd/3GP/bGq/8AwTx/ay+Ivir4q/D/AOB+oaL4Xj8PQaY2mrdQWtwt6YrTT5GjJczlNxMCbjswcnAHGAD6P/ag8ffsr+FfH1np/wAcLDwvP4hk0xJrVtV8JvqUotDLKqASrbyBV8xZvl3DBycc5PmH7UHxjb9oXwDZ+C/2TfHOsaj40sdTTVNQi0qe50WVdNSKWKRjPceQrL509sNgckkg7SFJHg//AAWr/wCTptA/7Ey2/wDS29o/4Iqf8nTa/wD9iZc/+ltlQB7h8AdX+Bui6b4e+Fv7SOleH9V+OE96LHVh4h8P/wBs39xPcXBNkkuoeVKkmbeW1VSZSEXapK7SB6f8dLb9kH4Of2X/AMLH8A/D/Rf7a877B/xREdz53leX5n+pt32482P72M7uM4OLHjj9k34deKv2l4fjhqGteKI/EMGp2GpLawXVutkZbRYVjBQwF9pECbhvycnBHGPnj/gud/zS7/uMf+2NAHhHxr+EPxc8F+IfEf7QPgTRbjw34Dn1ObVPDuvaNqkFk0Om3s5W1aGGKVZ4VeK4jXZsUqr7WVQCB9T/APBL/QtD+MfwC1fxP8XdG0/x/rdp4mnsLfVPFdqmq3UNsttayLAktwHdYw8srBAdoaRjjLHOh+0t/wAobdN/7Ezwx/6NsK+OP2X/ANrL4i/AjwDeeEfCOi+F72xvdTfUpJNVtbiSUSvFFGQDHPGNu2FeMZyTz6AHu/wV0b4h/CvxVceIf24JtQv/AIe3Nk1npcXivUh4ltRqzOjxMlqj3BSTyI7sCXYAFLLuG/B9Y+I37WH7NGl/s8+KPCfwt8bW+iXx8P6hDoFno3h++09YLuSGUxmErbosTGZw27K4Y7iR1ryf4K/EfXP27vFVx8Ivi7a6fouiaLZN4jt7jwpG9tdNcxOlsqO1w86GMpeSkgIG3KvzAAg+of8ADuL4If8AQ0/ED/wY2X/yJQB8gfAu5/a++Mf9qf8ACuPH3xA1r+xfJ+3/APFbyW3k+b5nl/664TdnypPu5xt5xkZ9v+AulftRfBn4saT8Sf2iPEvjCy+Guied/bs+oeLTqkCedBJBButYZ5XkzcSwAYjbaSGOApI+r/2Uf2cfBH7P39vf8IbqviC+/wCEi+zfa/7XuIZdnkebs2eVFHjPnPnOegxjnPP/APBUf/kxPx1/3Dv/AE5WtAHUeCbj9n/9o3SpPG+meHfC/jiGwmOlNqOq+Gg0sTIqy+SDdQh9oE4bj5cucc5r5Q/ag0z4JftC+AbPwX+yb4U8L6j40sdTTVNQi0rw8miyrpqRSxSMZ7iKBWXzp7YbA5JJB2kKSPAP2X/2sviL8CPAN54R8I6L4XvbG91N9Skk1W1uJJRK8UUZAMc8Y27YV4xnJPPp9L/Gr4caH+wj4Vt/i78IrrUNa1vWr1fDlxb+K5EubVbaVHuWdFt0gcSB7OIAlyu1m+UkggA2Pg98RdG+Ff7Jf/DM2t+ILjQfjUumajpen6LbJMZYtSv5J5bBUvYVNujP9qtmD+aAhcbmUq2O4/4JveDf2hvCX/CZ/wDC+bzxBcfbPsH9i/2v4jTVNu37T5+zbNL5f3oc9N3HXbx8IeCfiPrnxb/b/wDBPxC8SWun2up6x4z0Lz4dPjdIF8qa2hXaru7D5YlJyx5J6dK/Y6gD8wP2af8AlMlqX/Y5+J//AEVf11H/AAV2+JXxF8HftJaJpnhHx94o8P2M3hK3nktdK1m4tYnlN3dqXKRuAWKqozjOFA7Vy/7NP/KZLUv+xz8T/wDoq/r7H/ag/ZN+HXx38fWfi7xdrXiiyvrLTE02OPSrq3jiMSSyyAkSQSHdumbnOMAcdcgHMftrfBDX4PhXp7/sweCdP8MeLjrUQvrzwobXQrqTT/Jn8yN7hWhLRmX7OTHuOWVTj5cjP+Av7RXgz4M/CfSfht+0R4/1Cy+JWied/bsGoRXmqTp508k8G66hSVJM28sBGJG2ghTgqQPm/wD4eO/G/wD6Fb4f/wDguvf/AJLr5w+PXxH1z4t/FjVviF4ktdPtdT1jyfPh0+N0gXyoI4V2q7uw+WJScseSenSgD6v/AOCkP7VGkeLf+EM/4UN8WPEFv9j+3/21/ZEt/pe7d9m8jfuWLzPuzY67eem7n548efAb44Wfwvl+NPirw5cSeHtThg1WfXLnWLWeW5W7dPLmdfOaZmkaZCcruyxLY5ryevePHH7WXxF8Vfs0Q/A/UNF8Lx+HoNMsNNW6gtbhb0xWjQtGS5nKbiYE3HZg5OAOMAB+y/4A/ao8VeAbzUPgff8Aii38PR6m8N0uleLE02I3YiiZyYmuIyzeW0PzbTkYGeMDzf4K/C3x38W/FVx4b+Huhf2xqdrZNfTQfa4LfbArohfdM6KfmlQYBzz04Nfof/wRU/5NZ1//ALHO5/8ASKyr4I/Zf+Nfir4EePrzxd4R0/R72+vdMfTZI9VhlkiETyxSEgRyRnduhXnOME8egBn6h8PPiT4L+PVj8PJNPuNJ8eQanZQ2VvbahEssN3N5T2xS4jk2IxMkRDBxtJGSCDj6H/4U3/wUM/6C/wAQP/Djxf8AyZXhHjj41+KvFX7S8Pxw1DT9Hj8QwanYaktrBDKtkZbRYVjBQyF9pECbhvycnBHGP0X/AOCb37R3jj9oH/hM/wDhMtK8P2P/AAjv2D7J/ZFvNFv8/wC079/mSyZx5KYxjqc54wAeT/tZ/Hz4fX/7CF/8GdX8Z3F58T9O0zStL1vT7m1upZf7StLm1+2K90YzFIyvDMS4kYOQSGbIz84fsv8AgD9qjxV4BvNQ+B9/4ot/D0epvDdLpXixNNiN2IomcmJriMs3ltD8205GBnjA+3/iF+wN8HvGPj7XPF2p+JPHEN94g1O41K6jtr+0WJJZpWkcIGtiQoZjgEk4xkmvF/jV8R9c/YR8VW/wi+EVrp+taJrVkviO4uPFcb3N0tzK72zIjW7wIIwlnEQChbczfMQQAAfPHjb4R/tGfs5aVH431O11jwRDfzDSl1HSvEUKyys6tL5JNrOX2kQFuflygzzivpf4b/tTfDmb/gnfqngTx38SdQ1D4hah4Z1uxkj1C2vrueeedroW6NcmNkOUkhAJfCjAJGOPnj9qD9rL4i/HfwDZ+EfF2i+F7KxstTTUo5NKtbiOUypFLGATJPINu2ZuMZyBz6+X/BHw3Y+MfjR4Q8I6nLcQ2PiDxBY6bdSWzKsqRTXCRuULAgMFY4JBGcZBoA+t/wDgjX4E8EeNf+Fj/wDCZeDfD/iL7D/ZX2T+19Lhu/s+/wC2b9nmq23dsTOOu0Z6CrHgr4P+LfgL+29qXx18beFrfwv8KNF8QatMup201vLFa2l0Li3swlpbs0wUtcQIFWP5AwyFCnGx8dP+Nfv9l/8ACmv+J5/wsTzv7V/4S7/SfI+w+X5XkfZvs+3P22Xdu3Z2pjbg58Q+PX7avxT+Lfwn1b4e+JNA8H2umax5PnzafZ3KTr5U8cy7We4dR80Sg5U8E9OtAHu/7UGp/G39oXx9Z+NP2TfFfijUfBdjpiaXqEuleIX0WJdSSWWWRTBcSwMzeTPbHeEIIIG4lSBj/BXRviH8K/FVx4h/bgm1C/8Ah7c2TWelxeK9SHiW1GrM6PEyWqPcFJPIjuwJdgAUsu4b8H1D/gip/wAms6//ANjnc/8ApFZV5f8ABX4j65+3d4quPhF8XbXT9F0TRbJvEdvceFI3trprmJ0tlR2uHnQxlLyUkBA25V+YAEEA2NC8M/GXxf8AtR+H/H/wCudYt/gDN4g02ayttH1tdK0sWkLwpfhdNaWJlUzx3e9fJHmEswDb8n73r4I0L41+Kv2ev2o/D/7JvgvT9HvvBeneINN02LUNYhll1RotQeG4mLSRSRxble8lCERAABchiCT970AeH+LP2v8A9nbwz4q1Pw3rfxD+y6no97NY30H9iag/kzxOUkTcsBVsMpGVJBxwTWf/AMNtfsxf9FM/8oGpf/I9fCOh/DjQ/i3/AMFOvE/w98SXWoWumax4z8Q+fNp8iJOvlG8mXazo6j5olByp4J6dax/+ChfwU8K/Aj40aX4R8I3+sXtje+H4dSkk1WaKSUSvcXEZAMccY27YV4xnJPPTABn+NvhH+0Z+zlpUfjfU7XWPBEN/MNKXUdK8RQrLKzq0vkk2s5faRAW5+XKDPOK+7/2INO8Baj+xz4d+NvxP0PR9Z8Q6dDqGq6n4t1jTFv8AVFWzvLjZM1wyPO7RRQIEwSyiNQvQCvF/gr8R9c/bu8VXHwi+Ltrp+i6Jotk3iO3uPCkb2101zE6Wyo7XDzoYyl5KSAgbcq/MACCeJviPrnwr+Mkf7D/h610+5+Ht/e2vhyXVL+N31kW2riOS5dZUdYfMU30vlkwlQFTcr4OQD6v8C+Mv2ef2mPtX9lWfh/x5/wAIvs8z+1/Djv8AYftG7Gz7XCMb/s5zs/uDPaviD4b/ABx1D4bf8FENUsPF/wARfEGl/DXw74m1uwGkC8u5tNsraNbqG1gjs4tyiNG8lURU2ptXAAXj7f8A2Uf2cfBH7P39vf8ACG6r4gvv+Ei+zfa/7XuIZdnkebs2eVFHjPnPnOegxjnPzR/wUO/ZN+HXhX4VfED44afrXiiTxDPqa6k1rPdW7WQlu9QjWQBBAH2gTvtG/IwMk85APUPG37SH7DvjHVY9T8XX3hfxBfQwiCO61XwPdXUqRBmYIHktCQoZmOM4yxPeuf8A+CengD9qjwr8aNU1D44X/ii48PSeH5obVdV8WJqUQuzcW7IREtxIVby1m+baMDIzzg/mRX6b/wDBPT9rL4i/Hf40ap4R8XaL4XsrGy8PzalHJpVrcRymVLi3jAJknkG3bM3GM5A59QD7HooooAKKKKACiiigD4A/4Lnf80u/7jH/ALY18AV9/wD/AAXO/wCaXf8AcY/9sa+UP2M9G+HniD9pPw3pHxWm0+Hwjcfa/wC0n1DUjYwDbaTNFunDoU/erHj5hk4HOcEA8vr9hv8AgoX8FPFXx3+C+l+EfCN/o9lfWXiCHUpJNVmljiMSW9xGQDHHId26ZeMYwDz68/4J/ZR/Y48Y6VJqfhHwxo/iCxhmMEl1pXi69uoklCqxQvHdEBgrKcZzhge9ch/wT08fftUeKvjRqmn/ABwsPFEHh6Pw/NNatqvhNNNiN2Li3VAJVt4yzeW03y7jkZOOMgA8X8J/sVfFP4OeKtM+LvifX/B93ongC9h8R6pb6beXMl1NbWTi5lSFXt0RpCkTBQzqpYjLAcj7P/ZR/aO8EftA/wBvf8IbpXiCx/4R37N9r/te3hi3+f5uzZ5UsmceS+c46jGecfLH/BQ7x9+1RYfFX4geGPDFh4ob4YNpiwzTQeE0msvskmnxm7JvDbkhQzT7m8z5MHldvGP/AMEa/HfgjwV/wsf/AITLxl4f8O/bv7K+yf2vqkNp9o2fbN+zzWXdt3pnHTcM9RQB6x+0p8a/Cv7Qsnir9k3wXp+sWPjTUdTk02LUNYhii0tZdPuftExaSKSSXayWcoQiIkkrkKCSPhD9qD4KeKvgR4+s/CPi6/0e9vr3TE1KOTSppZIhE8ssYBMkcZ3boW4xjBHPp9D/AAP0LXPDn/BS69+LviHRtQ0n4ezeJtdv4vF9/avBoz21zHeLbTreuBCY5TNEI3D7XMibSdwzy/8AwV28WeFfGP7SWian4R8S6P4gsYfCVvBJdaVfxXUSSi7u2KF42IDBWU4znDA9xQB9v/8ABQv4KeKvjv8ABfS/CPhG/wBHsr6y8QQ6lJJqs0scRiS3uIyAY45Du3TLxjGAefXzD9mv41+Ff2epPCv7JvjTT9YvvGmnanHpsuoaPDFLpbS6hc/aISskskcu1UvIg5MQIIbAYAE6H/BQv9pu18K/BfS9Q+B/xb8Lz+IZPEEMN0ulX1jqUotDb3DOTE3mBV8xYfm2jBwM84Pwx8IPG3if4jftxeA/GXjLU/7S1vUvGeifa7v7PHD5nl3FvEnyRKqDCRoOAM4yecmgD7//AOCkP7OPjj9oH/hDP+EN1Xw/Y/8ACO/b/tf9r3E0W/z/ALNs2eXFJnHkvnOOoxnnHu/wR8N33g74L+EPCOpy28194f8AD9jpt1JbMzRPLDbpG5QsASpZTgkA4xkCuor44+EPj79qi/8A2/Lvwx4nsPFC/DBfEGswwzT+E0hsvskaXRtCLwW4JUssG1vM+fI5bdyAH/BQv9k34i/Hf40aX4u8I614XsrGy8Pw6bJHqt1cRymVLi4kJAjgkG3bMvOc5B49fB/+HcXxv/6Gn4f/APgxvf8A5Er9F/G3xK+HXg7VY9M8XePvC/h++mhE8drqus29rK8RZlDhJHBKllYZxjKkdjXUUAfjj4J+HGufCT9v/wAE/D3xJdafdano/jPQvPm0+R3gbzZraZdrOiMfllUHKjkHr1r9jq/OD9prwJ44T/gqXD8Qn8G+IF8I6f4m8P3954hOlzDTba2ghsjPPJc7fKSOMRyF3LBV2NkjBr7f/wCF7fBD/osnw/8A/Cosv/jlAHjHxC/b5+D3g7x9rnhHU/Dfjia+0DU7jTbqS2sLRonlhlaNyha5BKllOCQDjGQK+IP+Chfxr8K/Hf40aX4u8I6frFlY2Xh+HTZI9VhijlMqXFxISBHJINu2Zec5yDx0z2+gfCu08R/t5a54r+KfhPUI/hFrHibWb+bxLfrcWOjXFtMbl7OddQUpH5csjW/lusm2QugBbcAfpD/hTf8AwTz/AOgv8P8A/wAOPL/8mUAeD/8ABQv9rL4dfHf4L6X4R8I6L4osr6y8QQ6lJJqtrbxxGJLe4jIBjnkO7dMvGMYB56Z2P2X/ANo7wRcfshad+zAmleIB4u8T2WoeHLO+NvD/AGbHc6lcXCQPJJ5vmiNTcx7yIiww2FbAz8ceCfCfirxjqsmmeEfDOseIL6GEzyWulWEt1KkQZVLlI1JChmUZxjLAd69Y/Z7+E/xT8LfH3wP4n8T/AA08YaLomi+JtOv9U1TUtBuba1sLaK5jklnmldAkcaIrMzsQqqpJIAoA9P8A+HcXxv8A+hp+H/8A4Mb3/wCRK8o/Z18SWP7OX7aVvqfjeK4v4fA+p6npuoroyrK0sqw3FoTCJTGGXzGByxU7ecZ4r63/AOCkP7VGr+Ev+EM/4UN8WPD9x9s+3/21/ZEthqm3b9m8jfuWXy/vTY6bueu3jzf9orw5+zXq/wCxbcfEuz1jwvefGLWtM0zVNTaDxQXvZdSuZrd75jYrPsRiZLgsixAJzhV2jABsfGr4ca5+3d4qt/i78IrrT9F0TRbJfDlxb+K5HtrprmJ3uWdFt0nQxlLyIAlw25W+UAAnwj9qD9k34i/AjwDZ+LvF2teF72xvdTTTY49KuriSUSvFLICRJBGNu2Fuc5yRx6cv8Ff2iPjF8JPCtx4b+HvjD+x9Mur1r6aD+zLS43TsiIX3TROw+WJBgHHHTk19b/sv6Z8bf2hfH154L/ay8KeKNR8F2OmPqmnxar4efRYl1JJYoo2E9vFAzN5M9yNhcggk7SVBAB6//wAE+/Elj4O/4Jq6F4u1OK4msdA0zWdSuo7ZVaV4ob28kcIGIBYqpwCQM4yRXcfso/tHeCP2gf7e/wCEN0rxBY/8I79m+1/2vbwxb/P83Zs8qWTOPJfOcdRjPOPmD4nRfF/4eftBP8FfCmgeINM/Z0ivbOz1NDobS6bDpN1HFJqjSanJG0qR5nuy8pnBi+bDIEG36f8A2UfBv7PPhL+3v+FDXnh+4+2fZv7a/sjxG+qbdvm+Rv3TS+X96bHTdz128AH546H8R9D+En/BTrxP8QvElrqF1pmj+M/EPnw6fGjzt5pvIV2q7op+aVScsOAevSvX/jV8ONc/bu8VW/xd+EV1p+i6Jotkvhy4t/Fcj2101zE73LOi26ToYyl5EAS4bcrfKAAT9P8Aiz9kD9nbxN4q1PxJrfw8+1anrF7NfX0/9t6gnnTyuXkfas4VcsxOFAAzwBWx4Jt/2f8A9nLSpPBGmeIvC/giG/mOqtp2q+JQssrOqxecBdTF9pEAXj5cocc5oA8Q/wCCen7JvxF+BHxo1Txd4u1rwve2N74fm02OPSrq4klEr3FvICRJBGNu2Fuc5yRx6dR+1P8AtHeCLjxd4o/ZgTSvEA8XeJ7IeHLO+NvD/ZsdzqVqqQPJJ5vmiNTcx7yIiww2FbAyftrfG/X7j4V6en7MHjbT/E/i4a1Eb6z8KLa67dR6f5M/mSPbqsxWMS/ZwZNowzKM/Ng8f4d+FdnrX7KeoftI/FLwnqEHxw0rRtS1s6tqC3FjPb3th532GVrEFIBsjtrUhWh2uFBYNuJIB2H/AATe/Zx8cfs/f8Jn/wAJlqvh++/4SL7B9k/si4ml2eR9p37/ADIo8Z85MYz0OccZ5f8AaU+NfhX9oWTxV+yb4L0/WLHxpqOpyabFqGsQxRaWsun3P2iYtJFJJLtZLOUIRESSVyFBJFj/AIJS/G34n/GP/hPf+Fj+Jv7a/sX+zfsH+gW1t5Pm/a/M/wBTGm7PlR/ezjbxjJz8QfF/xt4n+HP7cXjzxl4N1P8As3W9N8Z639ku/s8c3l+ZcXET/JKrIcpI45BxnI5waAMf9qD4KeKvgR4+s/CPi6/0e9vr3TE1KOTSppZIhE8ssYBMkcZ3boW4xjBHPp97/wDBav8A5NZ0D/sc7b/0iva+GPG1x+0B+0bqsfjfU/DvijxxNYQjSl1HSvDRaKJUZpfJJtYQm4Gctz82HGeMV+p3ja3/AGf/ANo3So/BGp+IvC/jeGwmGqrp2leJQ0sTIrRecRazB9oE5Xn5cuM84oA/HH4e+G77xj4+0PwjpktvDfeINTt9NtZLlmWJJZpVjQuVBIUMwyQCcZwDX6j/APBN79nHxx+z9/wmf/CZar4fvv8AhIvsH2T+yLiaXZ5H2nfv8yKPGfOTGM9DnHGSP4M/sRfDP4j2dxcXHg/w74m8O3tvfQw6h45mintJ0KTRO0M11/uMAy4II4INef8A/BSH9qjV/CX/AAhn/Chvix4fuPtn2/8Atr+yJbDVNu37N5G/csvl/emx03c9dvAB7P4H/ay+HXir9peb4H6foviiPxDBqd/prXU9rbrZGW0WZpCHE5faRA+07MnIyBzj3ivn/wDZV+CXwwm0fwX8epPDO74ha9o0Gt6jrX2+5/f3t9abrqXyPM8ld5nl+VUCru+ULgY9Y8bfEr4deDtVj0zxd4+8L+H76aETx2uq6zb2srxFmUOEkcEqWVhnGMqR2NAHzR/w8d+CH/QrfED/AMF1l/8AJdez2fiSx/aN/Y/1nU/BEVxYQ+OPD+qabpy6yqxNFKwntAZhEZAq+YpOVLHbzjPFfHH7a3wU+AM/wr09P2YNI0/xP4uGtRG+s/Cmu3Gu3Uen+TP5kj26zTFYxL9nBk2jDMoz82D7B+zH45t/hv8A8E+4fA0viPT/AA/8VdN0bWBpvhe/mij1ldQknupbONbCX968khkgaOMxnzBImAwYZAPn/wD4dxfG/wD6Gn4f/wDgxvf/AJEr1D9jP9ir4p/CT9pPw38QvEmv+D7rTNH+1+fDp95cvO3m2k0K7Ve3RT80qk5YcA9eleX/APC5P+Chn/QI+IH/AIbiL/5DrP8AFP7QP7eHhnQZ9b8SN4w0fTLXb599qHgK3t4IdzBF3SPaBVyzKoyeSQO9AH0R/wAFC/2TfiL8d/jRpfi7wjrXheysbLw/Dpskeq3VxHKZUuLiQkCOCQbdsy85zkHj18H/AOCKn/J02v8A/YmXP/pbZVwH/DbX7Tv/AEUz/wAoGm//ACPX6XfBX9nf4O/CTxVceJPh74P/ALH1O6smsZp/7Tu7jdAzo5TbNK6j5okOQM8deTQB6hRRRQAUUUUAFFFFAHwB/wAFzv8Aml3/AHGP/bGvIPiX+x9/wiX7G1t8ev8AhYn2z7Ro2l6n/Yv9ieXt+2Pbr5fn+ec7PtHXZ823oM8fp9468CeCPGv2X/hMvBvh/wARfYd/2T+19Lhu/s+/bv2earbd2xM467RnoK/KH4uS/F/4h/tNeMfgX4K1/wAQahpjeJtTsNI8JjXGg02K2tJ5ZI4I4ZJFgjjijgBROFXy1CjgCgD6/wD+CKn/ACazr/8A2Odz/wCkVlXr/wC2t8dP+GfvhXp/jL/hFv8AhIvt2tRaZ9k/tD7Js3wzy+Zv8uTOPJxjH8Wc8YPgH7FPjbwx+yT8K9Q+HH7Qep/8If4m1TWpdbtLD7PJqHm2UkMECS+ZZrLGMyW067SwYbMkYIJ4/wD4KgftEfB34t/ALSPDfw98Yf2xqdr4mgvpoP7Mu7fbAttdIX3TRIp+aVBgHPPTg0AaH/Dc/wDwuv8A4s1/wq7+w/8AhYn/ABTP9q/8JD9p/s/7d/ovn+T9mTzdnm7tm9d23G5c5HgH7c/7Mv8Awzn/AMIv/wAVt/wkv/CS/bP+YT9j+zfZ/I/6bSbt3n+2NvfPHr/7L/jL9nl/2QtO8DwWfh//AIXhfWWoWehXA8OONSXVpri4GnNHqHk7YpAz22yUyqI8KSy7ePYP2GPgl8T7j/hKP+GrPDP/AAlW37H/AMI3/wAJdf22v/Zf9f8AafI3yTeTu/0bdjbv2p128AHf2Pwy/wCFx/8ABOPwj8OP7b/sX+2vBmgf6f8AZPtPk+VHaz/6vem7PlbfvDG7POMHwD/h2X/1Wz/y1P8A7sr6n8B/Hn4H3nxQi+C3hXxHbx+IdMmn0qDQ7bR7qCK2a0R/MhRvJWFVjWFwMNtwoC54qx8av2iPg78JPFVv4b+IXjD+x9TurJb6GD+zLu43QM7oH3QxOo+aJxgnPHTkUAfnj+2t+x9/wz98K9P8Zf8ACxP+Ei+3a1Fpn2T+xPsmzfDPL5m/z5M48nGMfxZzxg7/AOy3+zL9n+BOhftWf8Jtu/4RX7T4m/4Rv+ycfav7MuZX8j7V53yeb9lxv8o7N/3Wxz9Af8Fq/wDk1nQP+xztv/SK9rH/AOCenx5+B9n+zH4L+C3irxHbyeIdTmutKn0O50e6niuWu7+fy4XbyWhZZFmQHLbcMQ2OaAPV/wBhj9pr/hoz/hKP+KJ/4Rr/AIRr7H/zFvtn2n7R5/8A0xj2bfI987u2OfIPix/wUO/4Qr4qeJvBv/CoPt3/AAjutXemfa/+Em8r7R5EzxeZs+ytt3bM4ycZxk9a+v8AwL4E8EeCvtX/AAhvg3w/4d+3bPtf9kaXDafaNm7Zv8pV3bd74z03HHU188fEL4r/ALCmnePtc0/xdpXgd/ENpqdxDrDXPgGW4la7WVlmLyi0YSN5gbLbjuOTk5zQB8EftrfHT/hoH4qaf4y/4Rb/AIR37Do0WmfZP7Q+179k08vmb/LjxnzsYx/DnPOB+n37a3x0/wCGfvhXp/jL/hFv+Ei+3a1Fpn2T+0PsmzfDPL5m/wAuTOPJxjH8Wc8YPxR+1B8HF/aF8fWfjT9k3wNo+o+C7HTE0vUJdKgttFiXUklllkUwXHkMzeTPbHeEIIIG4lSB9P8Ajb9q79jjxjpUemeLvE+j+ILGGYTx2uq+Eb26iSUKyhwklqQGCswzjOGI70AeMf8ADc//AAuv/izX/Crv7D/4WJ/xTP8Aav8AwkP2n+z/ALd/ovn+T9mTzdnm7tm9d23G5c5HgH7c/wCzL/wzn/wi/wDxW3/CS/8ACS/bP+YT9j+zfZ/I/wCm0m7d5/tjb3zx0/7SHwf8W+LPiJr/AO0B+z/4Wt7X4YWsMeq6NrOjTW+lLarZW6LcTQ2zNFPEyXFvOeIwxZdy53An1j/glL/xev8A4T3/AIXL/wAXE/sP+zf7K/4S7/ib/wBn+d9r83yPtO/yt/lRbtuN3lpnO0YAPf7H4Zf8Lj/4Jx+Efhx/bf8AYv8AbXgzQP8AT/sn2nyfKjtZ/wDV703Z8rb94Y3Z5xg/nD+2t8DP+Gfvipp/g3/hKf8AhIvt2jRan9r/ALP+ybN808Xl7PMkzjyc5z/FjHGT6/8ADf446h8Nv+CiGqWHi/4i+INL+Gvh3xNrdgNIF5dzabZW0a3UNrBHZxblEaN5KoiptTauAAvHIf8ABUD4peBPi38fdI8SfD3Xf7Y0y18MwWM0/wBjnt9s63N05TbMiMfllQ5Axz14NAH2f+xT+x9/wz98VNQ8Zf8ACxP+Ei+3aNLpn2T+xPsmzfNBL5m/z5M48nGMfxZzxg+f/t+ftg/8Il4i+IXwG/4V39s+0aM+mf21/bfl7ftlgreZ5HkHOz7R03/Nt6jPGx+1B8Y2/aF8A2fgv9k3xzrGo+NLHU01TUItKnudFlXTUilikYz3HkKy+dPbDYHJJIO0hSR8/wDw5/ZP/aX1T9obwv4s+KXgm41uxHiDT5tfvNZ8QWOoNPaRzRCQTBrh2lUQoV24bKjaAelAHEfsMfsy/wDDRn/CUf8AFbf8I1/wjX2P/mE/bPtP2jz/APptHt2+R753dsc8/wDDT4Gf8Jb+2Tc/AX/hKfsf2fWtU0z+2v7P8zd9jS4bzPI8wY3/AGfpv+Xd1OOf1+8C+BPBHgr7V/whvg3w/wCHft2z7X/ZGlw2n2jZu2b/AClXdt3vjPTccdTXyx+0p4l+DXi+TxV4B+AVto9v8fptTkhsrnR9EbStUF3Dc778rqTRRKrGCO73t5w8wFlBbfggHxR+2t8DP+Gfvipp/g3/AISn/hIvt2jRan9r/s/7Js3zTxeXs8yTOPJznP8AFjHGT+n37a3x0/4Z++Fen+Mv+EW/4SL7drUWmfZP7Q+ybN8M8vmb/LkzjycYx/FnPGD+fPjb9lH9sfxjqsep+LvDGseIL6GEQR3Wq+LrK6lSIMzBA8l0SFDMxxnGWJ71z/7UHgD9qjwr4Bs9Q+OF/wCKLjw9JqaQ2q6r4sTUohdmKVkIiW4kKt5azfNtGBkZ5wQD9Br74m/8Lj/4Jx+LviP/AGJ/Yv8AbXgzX/8AQPtf2nyfKjuoP9ZsTdnyt33RjdjnGT4B/wAEMf8AmqP/AHB//b6vUP2PdE1TxN/wSXHhvRLX7VqeseGfEVjYweYqedPLcXyRpuYhVyzAZYgDPJFfCHjrwb+0N+zP9l/tW88QeA/+Eo3+X/ZHiNE+3fZ9ud/2SY52faBjf/fOO9AH1/8AFj/god/whXxU8TeDf+FQfbv+Ed1q70z7X/wk3lfaPImeLzNn2Vtu7ZnGTjOMnrXP/wDCsv8Ah4F/xeX+2/8AhXf9h/8AFM/2V9k/tfz/ACf9K8/zt9vtz9t27Nhx5edx3YHD/sO/s0fFTWvj94S+J3xO8B2+ueC9chuNVvr7Wb6yv1vlubKZ4ZpoXkeR2aWWJvmQsGOTggkWP+CoGva58HPj7pHhj4RazqHgDRLvwzBf3Gl+FLp9KtZrlrm6jad4rcojSFIolLkbisajOFGADxD9in46f8M/fFTUPGX/AAi3/CRfbtGl0z7J/aH2TZvmgl8zf5cmceTjGP4s54wf0++Gnif/AIaY/Y2udV+w/wDCL/8ACeaNqmmeX5v237Due4s/MziLzPu78YXrjPevzh/4Yl/ad/6Jn/5X9N/+SK4/xT4i+PfwT16f4Y3/AI48YeFbjQ9u/R9P8TSrBa+conG0W8pi+YShztPVjnnNAH1f/wAo6P8AqpX/AAsr/uDf2d9g/wDAjzfM+3f7G3y/4t3HxB8WPE//AAmvxU8TeMvsP2H/AISLWrvU/snm+b9n8+Z5fL34Xdt34zgZxnA6V6B4F8G/tDftMfav7KvPEHjz/hF9nmf2v4jR/sP2jdjZ9rmGN/2c52f3BntXp/wF/Z18Z/Bn4saT8Sf2iPAGn2Xw10Tzv7dn1CWz1SBPOgkgg3WsLyvJm4lgAxG20kMcBSQAfSH/AARU/wCTWdf/AOxzuf8A0isq6D9in9j7/hn74qah4y/4WJ/wkX27RpdM+yf2J9k2b5oJfM3+fJnHk4xj+LOeMHw/41aN8Q/ip4qt/EP7D82oWHw9trJbPVIvCmpDw1anVld3lZ7V3ty8nkSWgMuwgqFXcdmBx/8Awpv/AIKGf9Bf4gf+HHi/+TKAPoD9qT9hj/hcfx2134j/APC0f7F/tr7N/oH/AAj32nyfKtooP9Z9pTdnyt33RjdjnGT5/wD8Oy/+q2f+Wp/92V5//wAKb/4KGf8AQX+IH/hx4v8A5Mr6g/4JveDf2hvCX/CZ/wDC+bzxBcfbPsH9i/2v4jTVNu37T5+zbNL5f3oc9N3HXbwAc/8Ast/tNfZ/jtoX7Kf/AAhO7/hFftPhn/hJP7Wx9q/sy2lTz/svk/J5v2XOzzTs3/ebHPQftrfsff8ADQPxU0/xl/wsT/hHfsOjRaZ9k/sT7Xv2TTy+Zv8APjxnzsYx/DnPOB6v4/0z4JfCi31D4w+IvCnhfQZrCYz3viKDw8jXqy3EghZzJDE0zNI021iMk7znjNfKH7UGp/G39oXx9Z+NP2TfFfijUfBdjpiaXqEuleIX0WJdSSWWWRTBcSwMzeTPbHeEIIIG4lSAAeb/APBFT/k6bX/+xMuf/S2yr6A/ak/Zl+z/AB2139qz/hNt3/CK/ZvE3/CN/wBk4+1f2ZbRP5H2rzvk837Ljf5R2b/utjnx/wDYp8EeJ/2SfipqHxH/AGg9M/4Q/wAM6po0uiWl/wDaI9Q829kmgnSLy7NpZBmO2nbcVCjZgnJAPQfE6T4v/EP9oJ/jV4U1/wAQan+zpLe2d5qbnXGi02bSbWOKPVFk0ySRZXjzBdh4jATL82FcONwAf8PNP+qJ/wDl1/8A3HR/w01/w2L/AMY4/wDCE/8ACF/8Jp/zHv7W/tH7H9k/07/j38mHzN/2XZ/rFxv3c42n0D/hcn/BPP8A6BHw/wD/AA3Ev/yHX58fEbxVDpf7Q3ijxZ8LdWuNEsT4g1CbQLzRjJp7QWkk0ojEIXY0SmFwu3C4U7SB0oA6j9tb4Gf8M/fFTT/Bv/CU/wDCRfbtGi1P7X/Z/wBk2b5p4vL2eZJnHk5zn+LGOMn9nq/Bnxt4s8VeMdVj1Pxd4l1jxBfQwiCO61W/lupUiDMwQPIxIUMzHGcZYnvX6P8A/BPTwB+1R4V+NGqah8cL/wAUXHh6Tw/NDarqvixNSiF2bi3ZCIluJCreWs3zbRgZGecEA+x6KKKACiiigAooooAK/MD9mn/lMlqX/Y5+J/8A0Vf16B/wXO/5pd/3GP8A2xr0j9hb9rL4deKtP+HfwP0/RfFEfiGDw/b6a11Pa262RltLHdIQ4nL7SIH2nZk5GQOcAHf/ALUH7Jvw6+O/j6z8XeLta8UWV9ZaYmmxx6VdW8cRiSWWQEiSCQ7t0zc5xgDjrn8ea/Tf/goX+yb8Rfjv8aNL8XeEda8L2VjZeH4dNkj1W6uI5TKlxcSEgRwSDbtmXnOcg8ep/wAE9P2TfiL8CPjRqni7xdrXhe9sb3w/NpscelXVxJKJXuLeQEiSCMbdsLc5zkjj0APJ/wBl/wDZx8EQfshad+0+mq+ID4u8MWWoeI7OxNxD/ZslzptxcPAkkfleaY2NtHvAlDHLYZcjH0B/wTe/aO8cftA/8Jn/AMJlpXh+x/4R37B9k/si3mi3+f8Aad+/zJZM48lMYx1Oc8Y8v/bM/Yq+Kfxb/aT8SfELw3r/AIPtdM1j7J5EOoXlyk6+VaQwtuVLd1HzRMRhjwR06V8oftXfs4+OP2fv7B/4TLVfD99/wkX2n7J/ZFxNLs8jyt+/zIo8Z85MYz0OccZAPX/2af8AlMlqX/Y5+J//AEVf19j/ALUH7Jvw6+O/j6z8XeLta8UWV9ZaYmmxx6VdW8cRiSWWQEiSCQ7t0zc5xgDjrngP2Fv2svh14q0/4d/A/T9F8UR+IYPD9vprXU9rbrZGW0sd0hDicvtIgfadmTkZA5x9b0Afnh8FfiPrn7d3iq4+EXxdtdP0XRNFsm8R29x4Uje2umuYnS2VHa4edDGUvJSQEDblX5gAQfnj9orw3Y/s5ftpXGmeCJbi/h8D6npmpac2sssrSyrDb3YExiEYZfMYjChTt4znmv2Wrz/9rH/k1n4l/wDYmat/6RS0AeQf8E3v2jvHH7QP/CZ/8JlpXh+x/wCEd+wfZP7It5ot/n/ad+/zJZM48lMYx1Oc8Y/OD9rH/k6b4l/9jnq3/pbLX1//AMEMf+ao/wDcH/8Ab6vq/wDbM+HGufFv9mzxJ8PfDd1p9rqesfZPIm1CR0gXyruGZtzIjsPliYDCnkjp1oA/Mn9l/wDay+IvwI8A3nhHwjovhe9sb3U31KSTVbW4klErxRRkAxzxjbthXjGck8+h/wAE9Pgp4V+O/wAaNU8I+Lr/AFiysbLw/NqUcmlTRRymVLi3jAJkjkG3bM3GM5A565+l/gr8R9D/AGEfCtx8Ivi7a6hrWt61et4jt7jwpGlzarbSolsqO1w8DiQPZykgIV2svzEkgfnhQB93+JviPrnwr+Mkf7D/AIetdPufh7f3tr4cl1S/jd9ZFtq4jkuXWVHWHzFN9L5ZMJUBU3K+Dn6v/ZR/Zx8Efs/f29/whuq+IL7/AISL7N9r/te4hl2eR5uzZ5UUeM+c+c56DGOc/nj8Bf2Kvin8W/hPpPxC8N6/4PtdM1jzvIh1C8uUnXyp5IW3Klu6j5omIwx4I6dK9v8AgX/xr9/tT/hcv/E8/wCFieT/AGV/wiP+k+R9h8zzfP8AtP2fbn7bFt27s7XztwMgHiGh/DjQ/i3/AMFOvE/w98SXWoWumax4z8Q+fNp8iJOvlG8mXazo6j5olByp4J6da+r/APh3F8EP+hp+IH/gxsv/AJEr1f8AaK8N337Rv7FtxpngiW3sJvHGmaZqWnNrLNEsUTTW92BMYhIVby1IwoYbuM45r54+CvxH0P8AYR8K3Hwi+LtrqGta3rV63iO3uPCkaXNqttKiWyo7XDwOJA9nKSAhXay/MSSAAeX/APBFT/k6bX/+xMuf/S2yr9F/jd4kvvB3wX8X+LtMit5r7QPD99qVrHcqzRPLDbvIgcKQSpZRkAg4zgivmD/gnp+yb8RfgR8aNU8XeLta8L3tje+H5tNjj0q6uJJRK9xbyAkSQRjbthbnOckcen1f8QvElj4O8A654u1OK4msdA0y41K6jtlVpXihiaRwgYgFiqnAJAzjJFAHzx/wTe/aO8cftA/8Jn/wmWleH7H/AIR37B9k/si3mi3+f9p37/MlkzjyUxjHU5zxj4Q8bfEfXPhJ+3/42+IXhu10+61PR/Geu+RDqEbvA3mzXMLblR0Y/LKxGGHIHXpXYf8ABSH9o7wR+0D/AMIZ/wAIbpXiCx/4R37f9r/te3hi3+f9m2bPKlkzjyXznHUYzzjw/wCAvw41z4t/FjSfh74butPtdT1jzvIm1CR0gXyoJJm3MiOw+WJgMKeSOnWgD9Vv+Cenxr8VfHf4L6p4u8Xafo9lfWXiCbTY49KhljiMSW9vICRJJId26Zuc4wBx6+cf8Fq/+TWdA/7HO2/9Ir2uP+CvxH0P9hHwrcfCL4u2uoa1retXreI7e48KRpc2q20qJbKjtcPA4kD2cpICFdrL8xJIHYf8PHfgh/0K3xA/8F1l/wDJdAGx+xP4kvvB3/BKu18XaZFbzX2geH9f1K1juVZonlhur2RA4UglSyjIBBxnBFfBH7V37R3jj9oH+wf+Ey0rw/Y/8I79p+yf2RbzRb/P8rfv8yWTOPJTGMdTnPGNj4vfGvwr4q/b8tPjhp+n6xH4eg8QaNqTWs8MS3pitEtVkAQSFNxMD7RvwcjJHOP0m/ZR/aO8EftA/wBvf8IbpXiCx/4R37N9r/te3hi3+f5uzZ5UsmceS+c46jGecAHyx/wTx/ay+Ivir4q/D/4H6hovhePw9Bpjaat1Ba3C3pitNPkaMlzOU3EwJuOzBycAcY+j/wBqD9k34dfHfx9Z+LvF2teKLK+stMTTY49KureOIxJLLICRJBId26Zuc4wBx1z8cfs0/wDKZLUv+xz8T/8Aoq/r3j/goX+yb8Rfjv8AGjS/F3hHWvC9lY2Xh+HTZI9VuriOUypcXEhIEcEg27Zl5znIPHqAH/BPT9rL4i/Hf40ap4R8XaL4XsrGy8PzalHJpVrcRymVLi3jAJknkG3bM3GM5A59fkj/AIKj/wDJ9njr/uHf+m21rv8A/gip/wAnTa//ANiZc/8ApbZUftLf8pktN/7HPwx/6KsKAPQP+CGP/NUf+4P/AO31fZ/x6+HGh/Fv4T6t8PfEl1qFrpmseT582nyIk6+VPHMu1nR1HzRKDlTwT0618Yf8Fzv+aXf9xj/2xr0j9hb9rL4deKtP+HfwP0/RfFEfiGDw/b6a11Pa262RltLHdIQ4nL7SIH2nZk5GQOcAHt/7L/wU8K/AjwDeeEfCN/rF7Y3upvqUkmqzRSSiV4ooyAY44xt2wrxjOSeemPSK8H/ag/ay+HXwI8fWfhHxdovii9vr3TE1KOTSrW3kiETyyxgEyTxnduhbjGMEc9cecf8ABav/AJNZ0D/sc7b/ANIr2gCv8Xv2sviL4V/b8tPgfp+i+F5PD0/iDRtNa6ntbhr0RXaWrSEOJwm4Gd9p2YGBkHnPUf8ABSH9o7xx+z9/whn/AAhuleH77/hIvt/2v+17eaXZ5H2bZs8uWPGfOfOc9BjHOfn/APZf/aO8EXH7IWnfswJpXiAeLvE9lqHhyzvjbw/2bHc6lcXCQPJJ5vmiNTcx7yIiww2FbAz0HwL/AONfv9qf8Ll/4nn/AAsTyf7K/wCER/0nyPsPmeb5/wBp+z7c/bYtu3dna+duBkA8Q+PX7avxT+Lfwn1b4e+JNA8H2umax5PnzafZ3KTr5U8cy7We4dR80Sg5U8E9OtY/7L/7WXxF+BHgG88I+EdF8L3tje6m+pSSara3EkoleKKMgGOeMbdsK8Yzknn0/W74e+JLHxj4B0PxdpkVxDY6/plvqVrHcqqypFNEsiBwpIDBWGQCRnOCa2KAPzw+CvxH1z9u7xVcfCL4u2un6Lomi2TeI7e48KRvbXTXMTpbKjtcPOhjKXkpICBtyr8wAIPL/tKfGvxV+z1H4q/ZN8F6fo994L07TJNNi1DWIZZdUaLULb7RMWkikji3K95KEIiAAC5DEEk/4KF/tZfDr47/AAX0vwj4R0XxRZX1l4gh1KSTVbW3jiMSW9xGQDHPId26ZeMYwDz0zsfsv/tHeCLj9kLTv2YE0rxAPF3iey1Dw5Z3xt4f7NjudSuLhIHkk83zRGpuY95ERYYbCtgZAOA/4Jvfs4+CP2gf+Ez/AOEy1XxBY/8ACO/YPsn9kXEMW/z/ALTv3+bFJnHkpjGOpznjHp/7Zn7FXws+En7NniT4heG9f8YXWp6P9k8iHULy2eBvNu4YW3KlujH5ZWIww5A69K4//h3F8b/+hp+H/wD4Mb3/AORK6D4W/s4+OP2SfHdj+0H8R9V8P6p4Z8H+Z9vtPD1xNPfy/ao3so/KSaKKM4kuYy26RcKGIyQAQD4gr9/q83/Zf+NfhX47+Abzxd4R0/WLKxstTfTZI9VhijlMqRRSEgRySDbtmXnOcg8dM8f+y/8AtZfDr47+Przwj4R0XxRZX1lpj6lJJqtrbxxGJJYoyAY55Du3TLxjGAeemQD3iiiigAooooAKKKKAPP8A46fBL4YfGP8Asv8A4WP4Z/tr+xfO+wf6fc23k+b5fmf6mRN2fKj+9nG3jGTn8ufiN4R+LPwC/aG8UePfAXgrxR4Y0bwx4g1CHRNbn0Kaayt7SSaW2iImuI3jdWilVFZi27eCCSQa/Yavn/8A4Kj/APJifjr/ALh3/pytaAOI/wCCen7Tdr4q+C+qah8cPi34Xg8Qx+IJobVdVvrHTZTaC3t2QiJfLDL5jTfNtOTkZ4wPp/xt4s8K+DtKj1Pxd4l0fw/YzTCCO61W/itYnlKswQPIwBYqrHGc4Unsa/Bmvv8A/wCFm/8ADwL/AIs1/Yn/AArv+w/+Km/tX7X/AGv5/k/6L5Hk7Lfbn7bu37zjy8bTuyACv+118d/2n7D4w+JtX+DOqaxqPwws4YZ9P1vR/DNtqWl+UlrGbl1vfs8isqTCcOTIQhVlONuBj/so+O/A/wC0h/b3/DYPjLw/qX/CM/Zv+EW/tfVIdC8v7R5v2rZ9naDzs+Ra53btuBjbuOT4sfHT/hm/4V+Jv2Pv+EW/4Sb+zdGu9M/4Sn+0PsXmf2lC9z5n2Ty5MeX9t24807vLzld2B8QUAfrd8Bfhp+xt4f8AixpOr/CnUvB83i6387+zU0/xrJfTndBIsu2A3Lh/3TSZ+U4GTxjI9o8bfEr4deDtVj0zxd4+8L+H76aETx2uq6zb2srxFmUOEkcEqWVhnGMqR2NfBHwn+Bf/AAzf8K/DP7YP/CU/8JN/ZujWmp/8It/Z/wBi8z+0oUtvL+1+ZJjy/tu7PlHd5eMLuyPAP21vjp/w0D8VNP8AGX/CLf8ACO/YdGi0z7J/aH2vfsmnl8zf5ceM+djGP4c55wAD7n/4KF/tN2vhX4L6XqHwP+LfhefxDJ4ghhul0q+sdSlFobe4ZyYm8wKvmLD820YOBnnB+MNW/aw/aX8daVc+CLjxtcavD4lhfSpNOtvD9iZb1bhTEYUEdvvLOH2jZ82SMc11H7a37H3/AAz98K9P8Zf8LE/4SL7drUWmfZP7E+ybN8M8vmb/AD5M48nGMfxZzxg/P/wn8T/8IV8VPDPjL7D9u/4R3WrTU/snm+V9o8iZJfL34bbu2Yzg4znB6UAegeBfGX7Q37M/2r+yrPxB4D/4SjZ5n9r+HET7d9n3Y2fa4TnZ9oOdn98Z7V0H/DbX7Tv/AEUz/wAoGm//ACPR+3P+01/w0Z/wi/8AxRP/AAjX/CNfbP8AmLfbPtP2jyP+mMezb5Hvnd2xz0HxL/Y+/wCES/Y2tvj1/wALE+2faNG0vU/7F/sTy9v2x7dfL8/zznZ9o67Pm29BngA838bXH7QH7Ruqx+N9T8O+KPHE1hCNKXUdK8NFoolRml8km1hCbgZy3PzYcZ4xXQf8E9PDXwa8VfGjVNP+OFzo9v4ej8PzTWrarrbabEbsXFuqASrLGWby2m+XccjJxxkfY/8AwRU/5NZ1/wD7HO5/9IrKviD9in4Gf8NA/FTUPBv/AAlP/CO/YdGl1P7X/Z/2vfsmgi8vZ5keM+dnOf4cY5yAD9Pvhb4//Zp+HPgSx8G+Dfij8P8ATdE03zPslp/wmFvN5fmSPK/zyzM5y8jnknGcDjArn/jpc/sg/GP+y/8AhY/j74f61/YvnfYP+K3jtvJ83y/M/wBTcJuz5Uf3s428Yyc/MHxY/wCCeP8AwhXwr8TeMv8Ahb/27/hHdGu9T+yf8Iz5X2jyIXl8vf8Aam27tmM4OM5welfEFAH7DftZ+KpvhR+whf8AiL4Patb2EOg6ZpUPh29tjHfRLaNc2sKFGl8xZVMD4DNuyCGznmvzR8bXH7QH7Ruqx+N9T8O+KPHE1hCNKXUdK8NFoolRml8km1hCbgZy3PzYcZ4xX0P8J/jp/wANIfCvwz+x9/wi3/CM/wBpaNaaZ/wlP9ofbfL/ALNhS58z7J5cefM+xbceaNvmZy23B+v/ANin4Gf8M/fCvUPBv/CU/wDCRfbtal1P7X/Z/wBk2b4YIvL2eZJnHk5zn+LGOMkA+cP+CX/7RHxi+Lfx91fw38QvGH9saZa+GZ76GD+zLS32zrc2qB90MSMfllcYJxz04FfV/wC1j/yaz8S/+xM1b/0ilr4A/wCCKn/J02v/APYmXP8A6W2Vff8A+1j/AMms/Ev/ALEzVv8A0iloA/OH/gm94N/Z58W/8Jn/AML5vPD9v9j+wf2L/a/iN9L3bvtPn7Ns0Xmfdhz128dN3Pt/x60r9l34M/CfVviT+zv4l8H2XxK0Tyf7Cn0/xaNUnTzp44J9trNPKkmbeWcHMbbQSwwVBHzh+wx+zL/w0Z/wlH/Fbf8ACNf8I19j/wCYT9s+0/aPP/6bR7dvke+d3bHPv/8Aw7L/AOq2f+Wp/wDdlAHxh8avil47+Lfiq38SfELXf7Y1O1slsYZ/scFvtgV3cJthRFPzSuckZ568CvSP+Cenhr4NeKvjRqmn/HC50e38PR+H5prVtV1ttNiN2Li3VAJVljLN5bTfLuORk44yMf8AbW+Bn/DP3xU0/wAG/wDCU/8ACRfbtGi1P7X/AGf9k2b5p4vL2eZJnHk5zn+LGOMn0D9tb9j7/hn74V6f4y/4WJ/wkX27WotM+yf2J9k2b4Z5fM3+fJnHk4xj+LOeMEA9/wDix8Gf2In+FfiZPh7ceD9Q8XNo12PD1npvjma8urnUPJf7NHDbi6YzSNLsCxhW3MQMHOK+YPgXbftffBz+1P8AhXHgH4gaL/bXk/b/APiiJLnzvK8zy/8AXW77cebJ93Gd3OcDHr/7Af7H3/CW+Hfh78ev+FifY/s+tJqf9i/2J5m77Hfsvl+f54xv+z9dny7uhxz9P/tz/tNf8M5/8Iv/AMUT/wAJL/wkv2z/AJi32P7N9n8j/pjJv3ef7Y2988AH5c6f8Q/iT4L+PV98Q49QuNJ8eQanezXtxc6dEssN3N5qXIe3kj2IxMkoKlBtJOACBj9D/wDgnp+03a+KvgvqmofHD4t+F4PEMfiCaG1XVb6x02U2gt7dkIiXywy+Y03zbTk5GeMDzf8A4YY/4XX/AMXl/wCFo/2H/wALE/4qb+yv+Ee+0/2f9u/0ryPO+0p5uzzdu/Yu7bnaucD5g/bW+Bn/AAz98VNP8G/8JT/wkX27RotT+1/2f9k2b5p4vL2eZJnHk5zn+LGOMkA/Q74K6b+xd8JPFVx4k+HvjT4f6Pqd1ZNYzT/8J2LjdAzo5TbNcuo+aJDkDPHXk18cftB+LPCuo/8ABWDT/F2n+JdHu/DyeLfDs7axBfxSWSxRRWQkczhtgVCj7jnC7TnGDXrH/Dsv/qtn/lqf/dlH/Dsv/qtn/lqf/dlAB/wVa/4vX/wgX/Cmv+Lif2H/AGl/av8AwiP/ABN/7P8AO+yeV5/2bf5W/wAqXbuxu8t8Z2nHzB8LfAH7S3w58d2PjLwb8LviBput6b5n2S7/AOEPuJvL8yN4n+SWFkOUkccg4zkc4NfT/wDyjo/6qV/wsr/uDf2d9g/8CPN8z7d/sbfL/i3cH/DzT/qif/l1/wD3HQB84fGrw3+1V8W/FVv4k+IXw4+IGsana2S2MM//AAhc1vtgV3cJthgRT80rnJGeevAr1f8AZf8AjGv7Qvj688F/tZeOdH1HwXY6Y+qafFqs9tosS6kksUUbCe38hmbyZ7kbC5BBJ2kqCO4/4eaf9UT/APLr/wDuOvIP21v2Pv8Ahn74V6f4y/4WJ/wkX27WotM+yf2J9k2b4Z5fM3+fJnHk4xj+LOeMEA+1vAH7Nv7Jml2+n/FLwnoWjmx0SYarZ6/B4qu57KBrWQuZjKbloisbxHduyo2EN0NWPjpc/sg/GP8Asv8A4WP4++H+tf2L532D/it47byfN8vzP9TcJuz5Uf3s428Yyc/IH7Lf7TX2j4E6F+yn/wAITt/4Sr7T4Z/4ST+1s/Zf7TuZU8/7L5Pz+V9qzs80b9n3lzx6B/w7L/6rZ/5an/3ZQBx/iz4l/tk+HPFWp+HvhFpvjCb4e6TezWfhCXTfBUd/avpMTlLNobo2zmeMwLEVlLuXXDbmzk8R42/au/bH8HarHpni7xPrHh++mhE8drqvhGytZXiLMocJJaglSysM4xlSO1fU/wCy3+019n+O2hfsp/8ACE7v+EV+0+Gf+Ek/tbH2r+zLaVPP+y+T8nm/Zc7PNOzf95sc9B+2t+x9/wANA/FTT/GX/CxP+Ed+w6NFpn2T+xPte/ZNPL5m/wA+PGfOxjH8Oc84AB+cH/Cifjf/ANEb+IH/AIS97/8AG6+r/gR8MPgr4X/Zftdd12y0/R/2hNHsr680nSb/AFmaDWU1aOaaTTFXS3lG+RsWhjiMJEoZPlcPzof8PNP+qJ/+XX/9x0f8Ky/4W3/xnn/bf9j/ANn/APFTf8IZ9k+0eZ/Y37vyPt29Med9gzv8g7PN+6+35gD2D/gm94y/aG8W/wDCZ/8AC+bPxBb/AGP7B/Yv9r+HE0vdu+0+fs2wxeZ92HPXbx03c/P918b9f+IH7a3iP4JfG3xtp7/CJ/E2r2N/YagLXToEgtXuJLRGvEWOVNs0Fvg+aCxAUltxB+n/ANhj9pr/AIaM/wCEo/4on/hGv+Ea+x/8xb7Z9p+0ef8A9MY9m3yPfO7tjn5g/b8/Y+/4RLw78Qvj1/wsT7Z9o1p9T/sX+xPL2/bL9V8vz/POdn2jrs+bb0GeADH/AGoPjGv7PXj6z8F/sm+OdH07wXfaYmqahFpU9trUTak8ssUjGe489lbyYLYbA4AAB2gsSfuf4K/s7/B34SeKrjxJ8PfB/wDY+p3Vk1jNP/ad3cboGdHKbZpXUfNEhyBnjrya/FGv3+oAKKKKACiiigAooooA8/8Ajp8bfhh8HP7L/wCFj+Jv7F/trzvsH+gXNz53leX5n+pjfbjzY/vYzu4zg4+ONPtfijbfHq++MXxi1LWNS/Zu1LU73VANY1f+0dLm027806YzaUZJJNvmzWZRDBmM7SVTYStj/gud/wA0u/7jH/tjX0f4J+HGh/Fv9gDwT8PfEl1qFrpmseDNC8+bT5ESdfKhtpl2s6Oo+aJQcqeCenWgA+Cvhv8AZV+LfhW48SfD34cfD/WNMtb1rGaf/hC4bfbOqI5TbNAjH5ZUOQMc9eDX5E+CfFnirwdqsmp+EfEuseH76aEwSXWlX8trK8RZWKF42BKllU4zjKg9q/Z79l/4KeFfgR4BvPCPhG/1i9sb3U31KSTVZopJRK8UUZAMccY27YV4xnJPPTHhH/DuL4If9DT8QP8AwY2X/wAiUAeT/B74g/Afx7+yX/wh/jA6P4k+O3iTTNR0uzvNY0GS71S71KeSeLT1bUpYSAwVrVEdpgIwFBZQnHyx8dPgl8T/AIOf2X/wsfwz/Yv9ted9g/0+2ufO8ry/M/1Mj7cebH97Gd3GcHH3f4s/Yq+Fnwc8K6n8XfDGv+MLvW/AFlN4j0u31K8tpLWa5skNzEkypbo7Rl4lDBXVipOGB5Hxh+1d+0d44/aB/sH/AITLSvD9j/wjv2n7J/ZFvNFv8/yt+/zJZM48lMYx1Oc8YAPo/wCOH7RHwd8Qf8E0bL4U6R4w+0eLofDOhWL6b/Zl2mJ7aSzMyea0Qi+URSc7sHbwTkZ+YPgr+zv8Yvi34VuPEnw98H/2xplretYzT/2naW+2dURym2aVGPyyocgY568Gvsf4I/sDfB7xj8F/CHi7U/EnjiG+8QeH7HUrqO2v7RYklmt0kcIGtiQoZjgEk4xkmvp/9l/4KeFfgR4BvPCPhG/1i9sb3U31KSTVZopJRK8UUZAMccY27YV4xnJPPTAB8cfBXRviH8K/FVx4h/bgm1C/+HtzZNZ6XF4r1IeJbUaszo8TJao9wUk8iO7Al2ABSy7hvwce8+AOo/FT9sDRvi18Jfh7o+ofBXUPEGlzRSwR2llZS2luYIr0GwlMcm3zYbkMpi+fBIDBgT9v/tQfBTwr8d/ANn4R8XX+sWVjZammpRyaVNFHKZUiljAJkjkG3bM3GM5A565+UNC+Nfir9nr9qPw/+yb4L0/R77wXp3iDTdNi1DWIZZdUaLUHhuJi0kUkcW5XvJQhEQAAXIYgkgHu/wAdLb9kH4Of2X/wsfwD8P8ARf7a877B/wAURHc+d5Xl+Z/qbd9uPNj+9jO7jODj80f2gvit4k8R+NvFug6D478QXHw9uNauRouijULiPTU09bgtaRx2jEJHGiLFsj2DZtUADaAP1O/au/Zx8EftA/2D/wAJlqviCx/4R37T9k/si4hi3+f5W/f5sUmceSmMY6nOeMfKH7Zn7FXws+En7NniT4heG9f8YXWp6P8AZPIh1C8tngbzbuGFtypbox+WViMMOQOvSgD448E/Er4i+DtKk0zwj4+8UeH7GaYzyWulazcWsTylVUuUjcAsVVRnGcKB2r0Dxt8I/wBoz9nLSo/G+p2useCIb+YaUuo6V4ihWWVnVpfJJtZy+0iAtz8uUGecV4vX7bftQfBTwr8d/ANn4R8XX+sWVjZammpRyaVNFHKZUiljAJkjkG3bM3GM5A565APKP2ZW8X/Ez/glpNb3F/qHiLxN4i8M+ILGGbUL4yz3c7zXsMSNNM3+4oLNgADkAV5//wAE3v2V9X8Jf8Jn/wAL5+E/h+4+2fYP7F/teKw1Tbt+0+fs2tL5f3oc9N3HXbx5/wDFL9o7xx+yT47vv2fPhxpXh/VPDPg/y/sF34ht5p7+X7VGl7J5rwyxRnElzIF2xrhQoOSCT9Af8E3v2jvHH7QP/CZ/8JlpXh+x/wCEd+wfZP7It5ot/n/ad+/zJZM48lMYx1Oc8YAPlf4jfsn/ALS+l/tDeKPFnwt8E3GiWJ8QahNoF5o3iCx09oLSSaURiELcI0SmFwu3C4U7SB0r7P8A+Cenhr4y+Ffgvqmn/HC51i48QyeIJprVtV1tdSlFobe3VAJVlkCr5izfLuGDk45yfmD43ft8/GHwd8aPF/hHTPDfgeax0DxBfabayXNhdtK8UNw8aFytyAWKqMkADOcAV9P/APBPT41+Kvjv8F9U8XeLtP0eyvrLxBNpscelQyxxGJLe3kBIkkkO7dM3OcYA49QD4R8E/so/tj+DtVk1Pwj4Y1jw/fTQmCS60rxdZWsrxFlYoXjugSpZVOM4yoPar/xC+E/7deneAdc1Dxdqvjh/D1pplxNrC3Pj6K4ia0WJmmDxC7YyL5YbK7TuGRg5xWx/w8d+N/8A0K3w/wD/AAXXv/yXWP8AEL9vn4w+MfAOueEdT8N+B4bHX9MuNNupLawu1lSKaJo3KFrkgMFY4JBGcZBoA+ePAvjvxx4K+1f8Ib4y8QeHft2z7X/ZGqTWn2jZu2b/AC2Xdt3vjPTccdTX2/8AsD+D/wBrWb41eCfHfjvW/GGofD3ULKW+kk1Dxit3BPBPYym3drY3DOcvJCQCmVOCQMcfAFfrdrnxH1z4Sf8ABMXwx8QvDdrp91qej+DPD3kQ6hG7wN5os4W3Kjox+WViMMOQOvSgD5Q/4LV/8nTaB/2Jlt/6W3tfe/7UHib4NeFfANnqHxwttHn8PSamkNquq6I2pRC7MUrIREsUhVvLWb5towMjPOD8sfBX4caH+3d4VuPi78XbrUNF1vRb1vDlvb+FJEtrVraJEuVd1uEncyF7yUEhwu1V+UEEn6n/AGoPgp4V+O/gGz8I+Lr/AFiysbLU01KOTSpoo5TKkUsYBMkcg27Zm4xnIHPXIB4h8Rv2sP2aNL/Z58UeE/hb42t9Evj4f1CHQLPRvD99p6wXckMpjMJW3RYmMzht2Vwx3EjrXwx4F8G/tDftMfav7KvPEHjz/hF9nmf2v4jR/sP2jdjZ9rmGN/2c52f3BntX1v8AG79gb4PeDvgv4v8AF2meJPHE194f8P32pWsdzf2jRPLDbvIgcLbAlSyjIBBxnBFfJH7KP7R3jj9n7+3v+EN0rw/ff8JF9m+1/wBr280uzyPN2bPLljxnznznPQYxzkAseA9V/acvPihF8FvCvjvxxH4h0yafSoNDtvF8kEVs1oj+ZCjeesKrGsLgYbbhQFzxX1P8FdZ+Hnwr8K3Hh79uCHT7/wCIVzeteaXL4r00+JboaSyIkSpdIlwEj8+O7Ii3ghizbRvyTxN8OND+Ffwbj/bg8PXWoXPxCv7K18Ry6XfyI+jC51cxx3KLEiLN5ai+l8sGYsCqbmfByfBX4caH+3d4VuPi78XbrUNF1vRb1vDlvb+FJEtrVraJEuVd1uEncyF7yUEhwu1V+UEEkA+v/jV8UvAnwk8K2/iT4ha7/Y+mXV6tjDP9jnuN07I7hNsKOw+WJzkjHHXkV5f/AMNtfsxf9FM/8oGpf/I9fOHwV+I+uft3eKrj4RfF210/RdE0WybxHb3HhSN7a6a5idLZUdrh50MZS8lJAQNuVfmABB6j43fsDfB7wd8F/F/i7TPEnjia+8P+H77UrWO5v7Ronlht3kQOFtgSpZRkAg4zgigDyf8A4KtfG34YfGP/AIQL/hXHib+2v7F/tL7f/oFzbeT5v2Ty/wDXRpuz5Un3c4284yM+sfBH4r/sKad8F/CGn+LtK8Dv4htPD9jDrDXPgGW4la7W3RZi8otGEjeYGy247jk5Oc14R/wTe/Zx8EftA/8ACZ/8JlqviCx/4R37B9k/si4hi3+f9p37/NikzjyUxjHU5zxj6f8A+HcXwQ/6Gn4gf+DGy/8AkSgD44/4KF+Jvg14q+NGl6h8D7bR4PD0fh+GG6XStEbTYjdi4uGcmJooyzeW0PzbTkYGeMA/ag8AftUeFfANnqHxwv8AxRceHpNTSG1XVfFialELsxSshES3EhVvLWb5towMjPOD9j/8O4vgh/0NPxA/8GNl/wDIleX/AAV+I+uft3eKrj4RfF210/RdE0WybxHb3HhSN7a6a5idLZUdrh50MZS8lJAQNuVfmABBAPmjwH8BvjhefC+L40+FfDlxH4e0yGfVYNcttYtYJbZbR38yZF85ZlaNoXIwu7Kgrnivof8A4JvftUaR4S/4TP8A4Xz8WPEFx9s+wf2L/a8t/qm3b9p8/ZtWXy/vQ56buOu3jQ8TfEfXPhX8ZI/2H/D1rp9z8Pb+9tfDkuqX8bvrIttXEcly6yo6w+YpvpfLJhKgKm5Xwc+Yf8FIf2cfBH7P3/CGf8IbqviC+/4SL7f9r/te4hl2eR9m2bPKijxnznznPQYxzkA/QbUrj9n/AMHeDV/aEn8O+F9LsbmGLVR4qg8NAXrrelVWYtHD9o3S/aAGyN37w7u9dR8Ffil4E+LfhW48SfD3Xf7Y0y1vWsZp/sc9vtnVEcptmRGPyyocgY568GvnD9pb/lDbpv8A2Jnhj/0bYV8cfsv/ALWXxF+BHgG88I+EdF8L3tje6m+pSSara3EkoleKKMgGOeMbdsK8Yzknn0AOX+NX7O/xi+EnhW38SfELwf8A2Ppl1erYwz/2naXG6dkdwm2GV2HyxOckY468iv0W/wCCfd74e07/AIJq6FqHi5Ld/D1ppmszawtzbG4ia0W9vGmDxBWMi+WGyu07hkYOcV4R8FfiPrn7d3iq4+EXxdtdP0XRNFsm8R29x4Uje2umuYnS2VHa4edDGUvJSQEDblX5gAQTxN8R9c+Ffxkj/Yf8PWun3Pw9v7218OS6pfxu+si21cRyXLrKjrD5im+l8smEqAqblfByAcf+3P8AG34YW/8Awi//AAyn4m/4RXd9s/4ST/hEbC50D7V/qPs3n7I4fO2/6Ttzu2bn6bucCP4M/tu/Ez4cWdxcXHjDxF4Z8RWVvfQw6h45hlgu4HCTRO0M11/uMAy5BA4BFH/BSH9nHwR+z9/whn/CG6r4gvv+Ei+3/a/7XuIZdnkfZtmzyoo8Z8585z0GMc5n+Hv7fPxh8HeAdD8I6Z4b8DzWOgaZb6bayXNhdtK8UMSxoXK3IBYqoyQAM5wBQB9Qf8E9P2ZLXwr8F9U0/wCOHwk8L3HiGTxBNNatqtjY6lKLQ29uqASr5gVfMWb5dwwcnHOTn/8ABPTwB+1R4V+NGqah8cL/AMUXHh6Tw/NDarqvixNSiF2bi3ZCIluJCreWs3zbRgZGecHwf/h478b/APoVvh//AOC69/8Akuv0/oAKKKKACiiigAooooA+YP8AgpD+zj44/aB/4Qz/AIQ3VfD9j/wjv2/7X/a9xNFv8/7Ns2eXFJnHkvnOOoxnnHu/wR8N33g74L+EPCOpy28194f8P2Om3UlszNE8sNukblCwBKllOCQDjGQK+aP+CrXxt+J/wc/4QL/hXHib+xf7a/tL7f8A6BbXPneV9k8v/XRvtx5sn3cZ3c5wMfO+k/HP9v7VNKttT0y08cXtjewpPa3Vt8PYJIp4nUMjo62ZDKykEEHBBBFAH0B/wUL/AGTfiL8d/jRpfi7wjrXheysbLw/Dpskeq3VxHKZUuLiQkCOCQbdsy85zkHj1P+Cen7JvxF+BHxo1Txd4u1rwve2N74fm02OPSrq4klEr3FvICRJBGNu2Fuc5yRx6eD/8Lk/4KGf9Aj4gf+G4i/8AkOj/AIXJ/wAFDP8AoEfED/w3EX/yHQB6h+2Z+xV8U/i3+0n4k+IXhvX/AAfa6ZrH2TyIdQvLlJ18q0hhbcqW7qPmiYjDHgjp0r5Q/au/Zx8cfs/f2D/wmWq+H77/AISL7T9k/si4ml2eR5W/f5kUeM+cmMZ6HOOM+v8Awj/ah/al/wCGmvB3gDx/4q1Cx+3eJtMsdV0rUPDVnaT+RPPEGRlNusibo5MgjBwwIPQ19/8Ax0+CXww+Mf8AZf8Awsfwz/bX9i+d9g/0+5tvJ83y/M/1Mibs+VH97ONvGMnIB+SP7GfxH0P4SftJ+G/iF4ktdQutM0f7X58Onxo87ebaTQrtV3RT80qk5YcA9eldR/wUL+NfhX47/GjS/F3hHT9YsrGy8Pw6bJHqsMUcplS4uJCQI5JBt2zLznOQeOmfrf8AbM/Y++Evh/8AZs8Sav8ACn4W6hN4ut/sn9mpp97qF9Od13Csu2AyuH/dNJn5TgZPGMj86PG3hPxV4O1WPTPF3hnWPD99NCJ47XVbCW1leIsyhwkiglSysM4xlSO1AH6T/wDBav8A5NZ0D/sc7b/0iva+UPgL+xV8U/i38J9J+IXhvX/B9rpmsed5EOoXlyk6+VPJC25Ut3UfNExGGPBHTpX1f/wWr/5NZ0D/ALHO2/8ASK9rY/4Jl/Er4dad+yL4D8I6h4+8L2niF5ryBdHn1m3jvWll1G4MaCAvvLOHTaMZbcMZyKAPgj9q79nHxx+z9/YP/CZar4fvv+Ei+0/ZP7IuJpdnkeVv3+ZFHjPnJjGehzjjP6Ha58ONc+Lf/BMXwx8PfDd1p9rqeseDPD3kTahI6QL5Qs5m3MiOw+WJgMKeSOnWuw/au8G/s8+Lf7B/4XzeeH7f7H9p/sX+1/Eb6Xu3eV5+zbNF5n3Yc9dvHTdz8YeLPiX+2T4c8Van4e+EWm+MJvh7pN7NZ+EJdN8FR39q+kxOUs2hujbOZ4zAsRWUu5dcNubOSAfW/wDwT0+Cnir4EfBfVPCPi6/0e9vr3xBNqUcmlTSyRCJ7e3jAJkjjO7dC3GMYI59Pjj/gip/ydNr/AP2Jlz/6W2VfUH7FPxv1+3+FeoJ+0/420/wx4uOtSmxs/Fa2uhXUmn+TB5ciW7LCWjMv2gCTacsrDPy4Hl/xq0b4efCvwrb+If2H5tPv/iFc3q2eqReFNSPiW6GksjvKz2rvcBI/PjtAZdgIYqu4b8EA6j4vfsm/EXxV+35afHDT9a8Lx+HoPEGjak1rPdXC3pitEtVkAQQFNxMD7RvwcjJHOPZ/2rv2jvBH7P39g/8ACZaV4gvv+Ei+0/ZP7It4ZdnkeVv3+bLHjPnJjGehzjjPyB8J/jN+26nxU8Mv8Qrfxhp/hFdatD4hvNS8DQ2drbaf5yfaZJrg2qiGNYt5aQsu1QTkYzR/wWU8d+CPGv8Awrj/AIQ3xl4f8RfYf7V+1/2RqkN39n3/AGPZv8pm27tj4z12nHQ0AegfFL9o7wR+1t4Evv2fPhxpXiDS/E3jDy/sF34ht4YLCL7LIl7J5rwyyyDMdtIF2xtlioOASRn/AAV+I+h/sI+Fbj4RfF211DWtb1q9bxHb3HhSNLm1W2lRLZUdrh4HEgezlJAQrtZfmJJA6j9j/wAPfseeC/CXgL4hx+KPA+k+PIPD9rNe3Fz422yw3c1mEuQ9vJc7EYmSUFSg2knABAx2/wAatN/Yu+Lfiq38SfELxp8P9Y1O1slsYZ/+E7FvtgV3cJthuUU/NK5yRnnrwKAPlD/gip/ydNr/AP2Jlz/6W2Vff/7WP/JrPxL/AOxM1b/0ilrh/wBl/wAAfsr+FfH15qHwPv8AwvceIZNMeG6XSvFj6lKLQyxM5MTXEgVfMWH5towcDPOD84f8FDvH37VFh8VfiB4Y8MWHihvhg2mLDNNB4TSay+ySafGbsm8NuSFDNPubzPkweV28AHwRX1P8Pf2BvjD4x8A6H4u0zxJ4HhsfEGmW+pWsdzf3aypFNEsiBwtsQGCsMgEjOcE18sV+t2uaz8Q/D/8AwTF8Mav8KYdQm8XW/gzw9/ZqafpovpzuFmsu2Ao4f900mflOBk8YyAD5Q/4dxfG//oafh/8A+DG9/wDkSvCP2X/gp4q+O/j688I+Eb/R7K+stMfUpJNVmljiMSSxRkAxxyHdumXjGMA8+v6ff8E9PE3xl8VfBfVNQ+OFtrEHiGPxBNDarquiLpsptBb27IREsUYZfMab5tpycjPGB+YP7L/ib4y+FfH15qHwPttYn8QyaY8N0ulaIupSi0MsTOTE0UgVfMWH5towcDPOCAfT/wAEf2BvjD4O+NHhDxdqfiTwPNY+H/EFjqV1HbX920rxQ3CSOEDWwBYqpwCQM4yRXvH/AAUh/Zx8cftA/wDCGf8ACG6r4fsf+Ed+3/a/7XuJot/n/Ztmzy4pM48l85x1GM84+ONS/au/bH07xkvhHUPE+sWniF5ooF0efwjZR3rSyhTGggNrvLOHTaMZbcMZyKseOv2n/wBtXwV9l/4TLW/EHh37dv8Asn9r+DLS0+0bNu/Z5lqu7bvTOOm4Z6igD9Nvgj4bvvB3wX8IeEdTlt5r7w/4fsdNupLZmaJ5YbdI3KFgCVLKcEgHGMgV5f8AtQftZfDr4EePrPwj4u0XxRe317pialHJpVrbyRCJ5ZYwCZJ4zu3QtxjGCOeuPgnwt+15+1z4m16DRPDfjPUNY1O63eRY6f4WsLiebapdtsaWxZsKrMcDgAntXv8A8FdG+HnxU8K3HiH9uCbT7D4hW161npcXivUj4aujpKojxMlqj24ePz5LsCXYSWDLuOzAAPu+vzA/aW/5TJab/wBjn4Y/9FWFH/C5P+Chn/QI+IH/AIbiL/5DrmPht4O/aI8Y/tmeDPiN8Rvh344mvpvFujz6pqlz4UntYkihngTe+yFI0VYolycAYUk9zQB7P/wXO/5pd/3GP/bGvJ/h7+wN8YfGPgHQ/F2meJPA8Nj4g0y31K1jub+7WVIpolkQOFtiAwVhkAkZzgmvWP8Agud/zS7/ALjH/tjXgHwq/ah/al+x6L4A8AeKtQvvsNkljpWlaf4as7ufyIIsKiqLdpH2xx5JOThSSepoA+j/AIK/EfQ/2EfCtx8Ivi7a6hrWt61et4jt7jwpGlzarbSolsqO1w8DiQPZykgIV2svzEkgeb/8FC/2svh18d/gvpfhHwjoviiyvrLxBDqUkmq2tvHEYkt7iMgGOeQ7t0y8YxgHnpn3D9l/4ON+0L4BvPGn7WXgbWNR8aWOpvpeny6rBc6LKumpFFLGogt/IVl86e5O8oSSSNxCgDyf9tb4KfAGf4V6en7MGkaf4n8XDWojfWfhTXbjXbqPT/Jn8yR7dZpisYl+zgybRhmUZ+bBAPkj4I+JLHwd8aPCHi7U4riax0DxBY6ldR2yq0rxQ3CSOEDEAsVU4BIGcZIr9F/+HjvwQ/6Fb4gf+C6y/wDkuvP/ANlv4L/spQ/AnQo/jzB4f0H4hL9p/trTvEPiufSb+D/SZfI820a4jMeYPJZfkG5WVud2T6B/wpv/AIJ5/wDQX+H/AP4ceX/5MoA8P8WfsVfFP4x+KtT+LvhjX/B9ponj+9m8R6Xb6leXMd1DbXrm5iSZUt3RZAkqhgrsoYHDEcn0D4K/EfQ/2EfCtx8Ivi7a6hrWt61et4jt7jwpGlzarbSolsqO1w8DiQPZykgIV2svzEkgeL61+0r+0Jp3xc1X4YfBLxbcaj4e0bU7rS/CWmaNodnqbNptszrbrC/kSSTqtvEp3lnLKu4seTX0h+y/8HG/aF8A3njT9rLwNrGo+NLHU30vT5dVgudFlXTUiiljUQW/kKy+dPcneUJJJG4hQAAfCH7L/wAFPFXx38fXnhHwjf6PZX1lpj6lJJqs0scRiSWKMgGOOQ7t0y8YxgHn193/AOHcXxv/AOhp+H//AIMb3/5Eo/4Iqf8AJ02v/wDYmXP/AKW2Ve8fF7x9+1RYft+WnhjwxYeKG+GDeINGhmmg8JpNZfZJEtTdk3htyQoZp9zeZ8mDyu3gA+KP2rv2cfHH7P39g/8ACZar4fvv+Ei+0/ZP7IuJpdnkeVv3+ZFHjPnJjGehzjjPs/7NfwU8Vfs9R+Ff2svGmoaPfeC9O0yPUpdP0eaWXVGi1C2+zwhY5Y44tyveRFwZQAA2CxAB7j/gud/zS7/uMf8AtjXzx448fftUX/7NEPhjxPYeKF+GC6ZYQwzT+E0hsvskbQm0IvBbglSywbW8z58jlt3IB+n37L/xr8K/HfwDeeLvCOn6xZWNlqb6bJHqsMUcplSKKQkCOSQbdsy85zkHjpn4I/4Iqf8AJ02v/wDYmXP/AKW2Vecfsv8Aj79qjwr4BvNP+B9h4on8PSam8102leE01KIXZiiVwZWt5CreWsPy7hgYOOcn9Dv2X/AH7K/hXx9eah8D7/wvceIZNMeG6XSvFj6lKLQyxM5MTXEgVfMWH5towcDPOCAe8UUUUAFFFFABRRRQB8Af8Fzv+aXf9xj/ANsa9/sfib/wpz/gnH4R+I/9if21/YvgzQP9A+1/ZvO82O1g/wBZsfbjzd33TnbjjOR4B/wXO/5pd/3GP/bGvQP2lv8AlDbpv/YmeGP/AEbYUAef/wDDzT/qif8A5df/ANx17B+xT+2D/wANA/FTUPBv/Cu/+Ed+w6NLqf2v+2/te/ZNBF5ezyI8Z87Oc/w4xzkflBX1/wD8EVP+Tptf/wCxMuf/AEtsqAD9pb/lMlpv/Y5+GP8A0VYV9f8A7c/7TX/DOf8Awi//ABRP/CS/8JL9s/5i32P7N9n8j/pjJv3ef7Y2988fIH7S3/KZLTf+xz8Mf+irCvQP+C53/NLv+4x/7Y0Afb/wn8T/APCa/Cvwz4y+w/Yf+Ei0a01P7J5vm/Z/PhSXy9+F3bd+M4GcZwOleAftrfsff8NA/FTT/GX/AAsT/hHfsOjRaZ9k/sT7Xv2TTy+Zv8+PGfOxjH8Oc84F/wDYp/aI+DviD4e/Dn4U6R4w+0eLofDNnYvpv9mXaYntrFTMnmtEIvlEUnO7B28E5GeI/wCChfgD9qjxV8aNL1D4H3/ii38PR+H4YbpdK8WJpsRuxcXDOTE1xGWby2h+bacjAzxgAHD/APCzf+HgX/Fmv7E/4V3/AGH/AMVN/av2v+1/P8n/AEXyPJ2W+3P23dv3nHl42ndkeAWPwy/4U5/wUc8I/Dj+2/7a/sXxnoH+n/ZPs3nebJaz/wCr3vtx5u37xztzxnA/Sbxtcfs//s5aVH431Pw74X8Dw38w0pdR0rw0FllZ1aXySbWEvtIgLc/LlBnnFfJGv/C3x38Zv28tD/aI+G2hf238Nb3xNo19Brv2yC23wWZtobl/s87pONkltMuDHltmVBBBIBof8Fzv+aXf9xj/ANsa5/4T/wDBQ7/hCvhX4Z8G/wDCoPt3/CO6NaaZ9r/4SbyvtHkQpF5mz7K23dszjJxnGT1roP8Agud/zS7/ALjH/tjXwBQB7B+2t8dP+Ggfipp/jL/hFv8AhHfsOjRaZ9k/tD7Xv2TTy+Zv8uPGfOxjH8Oc84H0/wD8Ky/4d+/8Xl/tv/hYn9uf8Uz/AGV9k/sjyPO/0rz/ADt9xux9i27Ngz5mdw24PD/8E9PH37K/hX4L6pp/xwsPC8/iGTxBNNatqvhN9SlFobe3VAJVt5Aq+Ys3y7hg5OOcn1j9tbxt4Y/a2+Fen/Dj9nzU/wDhMPE2l61Frd3YfZ5NP8qyjhngeXzLxYoziS5gXaGLHfkDAJAB7/8ADTxP/wANMfsbXOq/Yf8AhF/+E80bVNM8vzftv2Hc9xZ+ZnEXmfd34wvXGe9fMH/Dsv8A6rZ/5an/AN2V4R8DdT+Nvwo/av8AAvwe8ReK/FGgw2Hi3SYL3w7B4hdrJYri5hmZDHDK0LLIs25gMg7znnNfS/8AwWU8d+OPBX/CuP8AhDfGXiDw79u/tX7X/ZGqTWn2jZ9j2b/LZd23e+M9Nxx1NAHyB8NPgZ/wlv7ZNz8Bf+Ep+x/Z9a1TTP7a/s/zN32NLhvM8jzBjf8AZ+m/5d3U45P21vgZ/wAM/fFTT/Bv/CU/8JF9u0aLU/tf9n/ZNm+aeLy9nmSZx5Oc5/ixjjJ5f4N2vxR8a/G2zj+HmpaxP481aa5nt72DV/st7NKYpJJ3N08iEM0YlLEuC2SOScH7X+Cus/Dz4V+Fbjw9+3BDp9/8Qrm9a80uXxXpp8S3Q0lkRIlS6RLgJH58d2RFvBDFm2jfkgHqH7FP7H3/AAz98VNQ8Zf8LE/4SL7do0umfZP7E+ybN80Evmb/AD5M48nGMfxZzxg+v/tY/wDJrPxL/wCxM1b/ANIpa+AP+FN/8FDP+gv8QP8Aw48X/wAmV7BdfG/QPh/+xT4j+CXxt8bagnxdTwzq9jf2GoC61Gd57pLiS0RrxFkifdDPb4PmkKCFJXaQAD84K+3/AIT/APBQ7/hCvhX4Z8G/8Kg+3f8ACO6NaaZ9r/4SbyvtHkQpF5mz7K23dszjJxnGT1r4gr9N/wBj/wAQ/seeNPCXgL4eR+F/A+rePJ/D9rDe29z4J3SzXcNmHuS9xJbbHYGOUli53EHBJIyAcP8A8PNP+qJ/+XX/APcdfMH7FPx0/wCGfvipqHjL/hFv+Ei+3aNLpn2T+0PsmzfNBL5m/wAuTOPJxjH8Wc8YP0v/AMFC/wBkvxz4q+NGl6h8D/hVo9v4ej8Pww3S6VJp+mxG7FxcM5MTPGWby2h+bacjAzxgfHHwV+Fvjv4t+Krjw38PdC/tjU7Wya+mg+1wW+2BXRC+6Z0U/NKgwDnnpwaAPs//AIVl/wALb/4zz/tv+x/7P/4qb/hDPsn2jzP7G/d+R9u3pjzvsGd/kHZ5v3X2/Mf8pF/+qa/8K1/7jP8AaP2//wAB/K8v7D/t7vM/h28+3/A/4W+O/D//AATRvfhTq+hfZ/F03hnXbFNN+1wPme5kvDCnmq5i+YSx87sDdyRg4/PHx14N/aG/Zn+y/wBq3niDwH/wlG/y/wCyPEaJ9u+z7c7/ALJMc7PtAxv/AL5x3oAPhp4n/wCGZ/2ybnVfsP8AwlH/AAgetappnl+b9i+3bUuLPzM4l8v72/GG6Yz3o/bW+On/AA0D8VNP8Zf8It/wjv2HRotM+yf2h9r37Jp5fM3+XHjPnYxj+HOecD6P8Rav8DfjT+ynp/w5+HOleH9d+PGu6NppllPh/wCz6leahF5M+oSSajPEiNIUiumeRpv3nzcsXAPyB8avhb47+Eniq38N/ELQv7H1O6slvoYPtcFxugZ3QPuhd1HzROME546cigD7P/4eaf8AVE//AC6//uOj/h5p/wBUT/8ALr/+46+j/jV4b/ZV+EnhW38SfEL4cfD/AEfTLq9Wxhn/AOELhuN07I7hNsMDsPlic5Ixx15FeMfELx5+xR438A654L+Gug+B5/GniPTLjS/DUVt4Fa0lk1KeJorVUne1RYmMzxgOzqFOCWAGaAPlj9uf9pr/AIaM/wCEX/4on/hGv+Ea+2f8xb7Z9p+0eR/0xj2bfI987u2OfX/hP8C/+Gb/AIV+Gf2wf+Ep/wCEm/s3RrTU/wDhFv7P+xeZ/aUKW3l/a/Mkx5f23dnyju8vGF3ZB+yj4E8D/s3/ANvf8Ng+DfD+m/8ACTfZv+EW/tfS4dd8z7P5v2rZ9nWfycefa53bd2RjdtONDwzo3xD0L4ySfE/4nzahL+zDLe3V5aWl/qQvdGGk3AkGlKukB3dYw8tl5cX2cGIhCVTZ8oBof8PNP+qJ/wDl1/8A3HXsH7FP7H3/AAz98VNQ8Zf8LE/4SL7do0umfZP7E+ybN80Evmb/AD5M48nGMfxZzxg9f8FfDf7Kvxb8K3HiT4e/Dj4f6xplretYzT/8IXDb7Z1RHKbZoEY/LKhyBjnrwa9A+NXxS8CfCTwrb+JPiFrv9j6ZdXq2MM/2Oe43TsjuE2wo7D5YnOSMcdeRQB+aP7d3hn/hNf8Agp/qng37b9h/4SLWtD0z7X5Xm/Z/PtLKLzNmV3bd+cZGcYyOtev/APDsv/qtn/lqf/dlZ+v/AAt8d/Gb9vLQ/wBoj4baF/bfw1vfE2jX0Gu/bILbfBZm2huX+zzuk42SW0y4MeW2ZUEEE/ofQB+MPw08T/8ADM/7ZNzqv2H/AISj/hA9a1TTPL837F9u2pcWfmZxL5f3t+MN0xnvX6ffsU/HT/hoH4V6h4y/4Rb/AIR37DrUumfZP7Q+179kMEvmb/LjxnzsYx/DnPOB+eOh6z8PPD//AAU68T6v8VodPm8I2/jPxD/aSahppvoDuN4sW6AI5f8AetHj5Tg4PGMj1/41aN8Q/ip4qt/EP7D82oWHw9trJbPVIvCmpDw1anVld3lZ7V3ty8nkSWgMuwgqFXcdmAAfOH7FPx0/4Z++KmoeMv8AhFv+Ei+3aNLpn2T+0PsmzfNBL5m/y5M48nGMfxZzxg/T/wDw80/6on/5df8A9x1w/wDwUL8ffsr+Kvgvpen/AAPsPC8HiGPxBDNdNpXhN9NlNoLe4VwZWt4wy+Y0Py7jk4OOMjzD9mv4B/EG/k8K/GbV/BlvefDDTtTj1TW9Qubq1li/s20uf9MZ7UyGWRVSGYFBGxcAgK2RkAsftz/tNf8ADRn/AAi//FE/8I1/wjX2z/mLfbPtP2jyP+mMezb5Hvnd2xz6/wDCf46f8NIfCvwz+x9/wi3/AAjP9paNaaZ/wlP9ofbfL/s2FLnzPsnlx58z7Ftx5o2+ZnLbcE/au8CeB/2kP7B/4Y+8G+H9S/4Rn7T/AMJT/ZGlw6F5f2jyvsu/7QsHnZ8i6xt3bcHO3cM+8eNfgDqOkfsQ6bZ/DT4e6Povxis/D+kwrqejx2ljqkV2pt1vSuoIUIZoxcK7CX5wzDLbsEA8n/4Wb/w79/4s1/Yn/CxP7c/4qb+1ftf9keR53+i+R5Oy43Y+xbt+8Z8zG0bcn2D9in9j7/hn74qah4y/4WJ/wkX27RpdM+yf2J9k2b5oJfM3+fJnHk4xj+LOeME/Yp+CGvz/AAr1B/2n/BOn+J/Fw1qUWN54rNrrt1Hp/kweXGlwzTFYxL9oIj3DDMxx82T9P0AFFFFABRRRQAUUUUAfAH/Bc7/ml3/cY/8AbGvo/wAE/DjQ/i3+wB4J+HviS61C10zWPBmhefNp8iJOvlQ20y7WdHUfNEoOVPBPTrXIf8FIf2cfHH7QP/CGf8Ibqvh+x/4R37f9r/te4mi3+f8AZtmzy4pM48l85x1GM84+X/8Ah3F8b/8Aoafh/wD+DG9/+RKAPoD/AIdxfBD/AKGn4gf+DGy/+RK9H/Zf/ZN+HXwI8fXni7wjrXii9vr3TH02SPVbq3kiETyxSEgRwRnduhXnOME8dMfHH/DuL43/APQ0/D//AMGN7/8AIlH/AA7i+N//AENPw/8A/Bje/wDyJQAftLf8pktN/wCxz8Mf+irCvt/9q79nHwR+0D/YP/CZar4gsf8AhHftP2T+yLiGLf5/lb9/mxSZx5KYxjqc54x8kfBH9gb4w+DvjR4Q8Xan4k8DzWPh/wAQWOpXUdtf3bSvFDcJI4QNbAFiqnAJAzjJFfovQB+LNn4kvv2cv2wNZ1PwRFb383gfxBqmm6cusq0qyxKZ7QGYRGMs3lsTlSo3c4xxX6Xf8E9PjX4q+O/wX1Txd4u0/R7K+svEE2mxx6VDLHEYkt7eQEiSSQ7t0zc5xgDj194ooA/Hn9qD9rL4i/HfwDZ+EfF2i+F7KxstTTUo5NKtbiOUypFLGATJPINu2ZuMZyBz67HwF/bV+Kfwk+E+k/D3w3oHg+60zR/O8ibULO5edvNnkmbcyXCKfmlYDCjgDr1r9bq5f43eG77xj8F/F/hHTJbeG+8QeH77TbWS5ZliSWa3eNC5UEhQzDJAJxnANAHxR8C/+NgX9qf8Ll/4kf8Awrvyf7K/4RH/AEbz/t3meb5/2n7Rux9ii27duNz53ZGPQP8Ah3F8EP8AoafiB/4MbL/5Er5//wCHcXxv/wChp+H/AP4Mb3/5Er1D9jP9ir4p/CT9pPw38QvEmv8Ag+60zR/tfnw6feXLzt5tpNCu1Xt0U/NKpOWHAPXpQB80f8FC/gp4V+BHxo0vwj4Rv9YvbG98Pw6lJJqs0Ukole4uIyAY44xt2wrxjOSeemOP/Zf+Nfir4EePrzxd4R0/R72+vdMfTZI9VhlkiETyxSEgRyRnduhXnOME8en3f/wUL/ZN+Ivx3+NGl+LvCOteF7KxsvD8OmyR6rdXEcplS4uJCQI4JBt2zLznOQePU/4J6fsm/EX4EfGjVPF3i7WvC97Y3vh+bTY49KuriSUSvcW8gJEkEY27YW5znJHHoAfCHjj41+KvFX7S8Pxw1DT9Hj8QwanYaktrBDKtkZbRYVjBQyF9pECbhvycnBHGPrf4F/8AGwL+1P8Ahcv/ABI/+Fd+T/ZX/CI/6N5/27zPN8/7T9o3Y+xRbdu3G587sjH3/XzB/wAFIf2cfHH7QP8Awhn/AAhuq+H7H/hHft/2v+17iaLf5/2bZs8uKTOPJfOcdRjPOAC/8Bf2KvhZ8JPixpPxC8N6/wCMLrU9H87yIdQvLZ4G82CSFtypbox+WViMMOQOvStj9qD9k34dfHfx9Z+LvF2teKLK+stMTTY49KureOIxJLLICRJBId26Zuc4wBx1yfF74KeKvFX7Adp8D9Pv9Hj8QweH9G01rqeaVbIy2j2rSEOIy+0iB9p2ZORkDnB/wT0+Cnir4EfBfVPCPi6/0e9vr3xBNqUcmlTSyRCJ7e3jAJkjjO7dC3GMYI59AD3ivkj9un9k34deKtP+Inxw1DWvFEfiGDw/caktrBdW62RltLHbGChgL7SIE3Dfk5OCOMfW9cv8bvDd94x+C/i/wjpktvDfeIPD99ptrJcsyxJLNbvGhcqCQoZhkgE4zgGgD8Ka+99C+CnhX9nr9lzw/wDtZeC9Q1i+8aad4f03UotP1iaKXS2l1BIbeYNHFHHLtVLyUoBKCCFyWAIPtH/BN79nHxx+z9/wmf8AwmWq+H77/hIvsH2T+yLiaXZ5H2nfv8yKPGfOTGM9DnHGfT/2zPhxrnxb/Zs8SfD3w3dafa6nrH2TyJtQkdIF8q7hmbcyI7D5YmAwp5I6daAOX/4J6fGvxV8d/gvqni7xdp+j2V9ZeIJtNjj0qGWOIxJb28gJEkkh3bpm5zjAHHr+YP7L/wAa/FXwI8fXni7wjp+j3t9e6Y+myR6rDLJEInlikJAjkjO7dCvOcYJ49P0+/wCCenwU8VfAj4L6p4R8XX+j3t9e+IJtSjk0qaWSIRPb28YBMkcZ3boW4xjBHPof8FC/gp4q+O/wX0vwj4Rv9Hsr6y8QQ6lJJqs0scRiS3uIyAY45Du3TLxjGAefUA+YPgj+3z8YfGPxo8IeEdT8N+B4bHX/ABBY6bdSW1hdrKkU1wkblC1yQGCscEgjOMg1sf8ABc7/AJpd/wBxj/2xr6v/AGM/hxrnwk/Zs8N/D3xJdafdano/2vz5tPkd4G827mmXazojH5ZVByo5B69a8w/4KQ/s4+OP2gf+EM/4Q3VfD9j/AMI79v8Atf8Aa9xNFv8AP+zbNnlxSZx5L5zjqMZ5wAfEH/BLj/k+zwL/ANxH/wBNt1Xf/wDBav8A5Om0D/sTLb/0tva9Q/Yz/Yq+Kfwk/aT8N/ELxJr/AIPutM0f7X58On3ly87ebaTQrtV7dFPzSqTlhwD16V930AfIH/Bav/k1nQP+xztv/SK9rx/9l/8AZx8EQfshad+0+mq+ID4u8MWWoeI7OxNxD/ZslzptxcPAkkfleaY2NtHvAlDHLYZcjH6P0UAfAHwL/wCNgX9qf8Ll/wCJH/wrvyf7K/4RH/RvP+3eZ5vn/aftG7H2KLbt243PndkYz/DPxH1z4qfGST9h/wAQ2un23w9sL268ORapYRumsm20gSSWztK7tD5jGxi8wiEKQz7VTIx7h/wUh/Zx8cftA/8ACGf8Ibqvh+x/4R37f9r/ALXuJot/n/Ztmzy4pM48l85x1GM848v/AGM/2Kvin8JP2k/DfxC8Sa/4PutM0f7X58On3ly87ebaTQrtV7dFPzSqTlhwD16UAfU/7L/wU8K/AjwDeeEfCN/rF7Y3upvqUkmqzRSSiV4ooyAY44xt2wrxjOSeemPzB/ag/ay+Ivx38A2fhHxdovheysbLU01KOTSrW4jlMqRSxgEyTyDbtmbjGcgc+v1//wAFC/2TfiL8d/jRpfi7wjrXheysbLw/Dpskeq3VxHKZUuLiQkCOCQbdsy85zkHj1+x6APy4/YW/ay+IvhXUPh38D9P0XwvJ4en8QW+mtdT2tw16Iru+3SEOJwm4Gd9p2YGBkHnP1R/wUh/aO8cfs/f8IZ/whuleH77/AISL7f8Aa/7Xt5pdnkfZtmzy5Y8Z8585z0GMc55f4vfsm/EXxV+35afHDT9a8Lx+HoPEGjak1rPdXC3pitEtVkAQQFNxMD7RvwcjJHOPsegD4w8J/sVfCz4x+FdM+LvifX/GFprfj+yh8R6pb6beW0drDc3qC5lSFXt3dYw8rBQzswUDLE8n6H/Zf+CnhX4EeAbzwj4Rv9YvbG91N9Skk1WaKSUSvFFGQDHHGNu2FeMZyTz0x4B8If2TfiL4V/b8u/jhqGteF5PD0/iDWdSW1gurhr0RXaXSxgoYAm4GdNw34GDgnjJ/wUL/AGTfiL8d/jRpfi7wjrXheysbLw/Dpskeq3VxHKZUuLiQkCOCQbdsy85zkHj1APD/APgoX+yb8OvgR8F9L8XeEda8UXt9e+IIdNkj1W6t5IhE9vcSEgRwRnduhXnOME8dMfT/APwT78N2PjH/AIJq6F4R1OW4hsfEGmazpt1JbMqypFNe3kblCwIDBWOCQRnGQa5D/gnp+yb8RfgR8aNU8XeLta8L3tje+H5tNjj0q6uJJRK9xbyAkSQRjbthbnOckceh8Xv2TfiL4q/b8tPjhp+teF4/D0HiDRtSa1nurhb0xWiWqyAIICm4mB9o34ORkjnAB7P+yj+zj4I/Z+/t7/hDdV8QX3/CRfZvtf8Aa9xDLs8jzdmzyoo8Z8585z0GMc50P2zPiPrnwk/Zs8SfELw3a6fdano/2TyIdQjd4G827hhbcqOjH5ZWIww5A69K9Qr44+EP7JvxF8K/t+Xfxw1DWvC8nh6fxBrOpLawXVw16IrtLpYwUMATcDOm4b8DBwTxkA9P/wCCenxr8VfHf4L6p4u8Xafo9lfWXiCbTY49KhljiMSW9vICRJJId26Zuc4wBx6+8V8cf8FC/wBk34i/Hf40aX4u8I614XsrGy8Pw6bJHqt1cRymVLi4kJAjgkG3bMvOc5B49fsegAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA//9kKZW5kc3RyZWFtCmVuZG9iago5MiAwIG9iago8PAovTGVuZ3RoIDYzNzMKL0JpdHNQZXJDb21wb25lbnQgOAovVHlwZS9YT2JqZWN0Ci9XaWR0aCA0NDIKL0RlY29kZVswIDEgMCAxIDAgMV0KL1NNYXNrIDkzIDAgUgovTmFtZS9XbnZQZGZfZWdibm5wZGhqYmZia2xvZHBqcG9sYW5lbWJmbmhoYXAKL0NvbG9yU3BhY2UvRGV2aWNlUkdCCi9TdWJ0eXBlL0ltYWdlCi9GaWx0ZXIvRENURGVjb2RlCi9IZWlnaHQgNjAKPj4Kc3RyZWFtCv/Y/+AAEEpGSUYAAQEBAGAAYAAA/9sAQwAEAgMDAwIEAwMDBAQEBAUJBgUFBQULCAgGCQ0LDQ0NCwwMDhAUEQ4PEw8MDBIYEhMVFhcXFw4RGRsZFhoUFhcW/9sAQwEEBAQFBQUKBgYKFg8MDxYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYW/8AAEQgAPAG6AwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/aAAwDAQACEQMRAD8A+/qy/F3ibw54V01NQ8UeINL0SzklEKXGpXsdtG8hBYIGkIBYhWOOuFPpXA/tjfE//hU3wG1bxHay7NXu8afovy5xdyq21+Udf3aLJLhxtbytuQWFflb4i1nWPEGszavr2q32qahcbfOvL65eeaXaoVdzuSxwqqBk8AAdqlysUo3P1u/4XJ8If+iq+Cf/AAorT/45R/wuT4Q/9FV8E/8AhRWn/wAcr8g6KXMVyn6+f8Lk+EP/AEVXwT/4UVp/8co/4XJ8If8Aoqvgn/worT/45X5B0Ucwcp+vn/C5PhD/ANFV8E/+FFaf/HKP+FyfCH/oqvgn/wAKK0/+OV+QdFHMHKftXpl7Z6jptvqGn3cF3Z3cSzW9xbyCSOaNgGV0YcMpBBBHBBqeuJ/Zp/5Nx+H/AP2Kmmf+kkVdtVmYVxP/AAuT4Qf9FV8E/wDhRWn/AMcrtq/E2pk7FRVz9q9MvbPUdNt9Q0+7gu7O7iWa3uLeQSRzRsAyujDhlIIII4INT1xP7NP/ACbj8P8A/sVNM/8ASSKu2qiQooooAKxPGPjLwh4S+zf8JX4q0TQvtm/7N/amoxWvn7du7Z5jDdjcucdNw9a26+Jv+CxX/NOv+4r/AO2dJuyGtWfW/hHx/wCBPFWpPp/hfxr4d1u8jiMz2+m6rBcyJGCFLlY2JCgsoz0yw9a6Kvzw/wCCSf8AycdrX/YqXH/pXaV+h9Cd0DVmFFFFMRxP/C5PhB/0VXwT/wCFFaf/AByuv0y9s9R0231DT7uC7s7uJZre4t5BJHNGwDK6MOGUgggjgg1+Klfr5+zT/wAm4/D/AP7FTTP/AEkiqYyuVKNjtqKKKokKKKKAOd8XeP8AwJ4V1JNP8UeNfDuiXkkQmS31LVYLaR4ySocLIwJUlWGemVPpR4R8f+BPFWpPp/hfxr4d1u8jiMz2+m6rBcyJGCFLlY2JCgsoz0yw9a+Ef+Ctf/Jx2i/9inb/APpXd0f8ElP+Tjta/wCxTuP/AErtKnm1sVy6XP0QoooqiQrif+FyfCH/AKKr4J/8KK0/+OV21fibUydioq5+vn/C5PhD/wBFV8E/+FFaf/HKP+FyfCH/AKKr4J/8KK0/+OV+QdGaXMyuQ/Xz/hcnwh/6Kr4J/wDCitP/AI5R/wALk+EP/RVfBP8A4UVp/wDHK/IPNGaOZhyH6+f8Lk+EP/RVfBP/AIUVp/8AHKm0z4sfCzUdSt9P0/4leD7u8u5Vht7e3162kkmkYhVRFD5ZiSAAOSTX4+5oo5mHIftlRX5xf8E5fjRrHhH4waZ4F1zWr6bwv4g/4l9rZzTvJDYXbyFoXiTaxXfIzRsF2KTNvcnYK/R2qTuQ1YKg1O9s9O0241DULuC0s7SJpri4uJBHHDGoLM7seFUAEkngAVPXE/tL/wDJuPxA/wCxT1P/ANJJaYg/4XJ8If8Aoqvgn/worT/45R/wuT4Q/wDRVfBP/hRWn/xyvyDoqOZmnIfr5/wuT4Q/9FV8E/8AhRWn/wAco/4XJ8If+iq+Cf8AworT/wCOV+QeaM0czDkP18/4XJ8If+iq+Cf/AAorT/45R/wuT4Q/9FV8E/8AhRWn/wAcr8g80Zo5mHIfsFpvxY+Fmo6lb6fp/wAS/B93eXcyw29vBr1tJJNIxCqiKHyzEkAAckmuwr8Ta+ov+CYvxR8UaZ8b7D4cXGpX194e1u0uIoLCa6Jh0+aNJLkSxIwO3O2VWVCoYy7myUApqQnE/RCud8XeP/AnhXUk0/xR418O6JeSRCZLfUtVgtpHjJKhwsjAlSVYZ6ZU+lT/ABM1LWNG+HHiDV/D1h/aGr6fpN1c6dZ+S8v2m4SJmjj2IQz7nCjapBOcDmvzN+J9ivhrw1pl5pN9B4gufFfgODXvEGqy6Lb6q73lxqFxFKZLicyPZtH5ohaWIhmmijBVXfcjbsKKufqbRXzT/wAE87yfS77x98OLfX9D1zRfDd3YX2nXOi3UtxZQNfQvLPbW0jyyFoIpIyqkncW8xn+ZiB9LUxNWZ8uf8FbP+TcdE/7Gy3/9JLuvib9mn/k474f/APY2aZ/6VxV9s/8ABWz/AJNx0T/sbLf/ANJLuvib9mn/AJOO+H//AGNmmf8ApXFUP4i47H6+UUUVZmFFFFABRRRQAUUUUAFfibX7ZV+JtRMuB+vn7NP/ACbj8P8A/sVNM/8ASSKu2r8fdM+LHxT07TbfT9P+JXjC0s7SJYbe3t9euY44Y1AVURQ+FUAAADgAVN/wuT4v/wDRVfG3/hRXf/xyjmDlP18or8g/+FyfF/8A6Kr42/8ACiu//jlH/C5Pi/8A9FV8bf8AhRXf/wAcp8wcp+vlfE3/AAWK/wCadf8AcV/9s6+XP+FyfF//AKKr42/8KK7/APjlYnjHxl4v8W/Zv+Er8Va3rv2Pf9m/tTUZbryN23ds8xjtztXOOu0elJyuhqNmfRH/AAST/wCTjta/7FS4/wDSu0r9D6/PD/gkn/ycdrX/AGKlx/6V2lfofTjsTLcKKKKok/E2v18/Zp/5Nx+H/wD2Kmmf+kkVfkHX6+fs0/8AJuPw/wD+xU0z/wBJIqzjuXM7aiiitCAooooA/O//AIK1/wDJx2i/9inb/wDpXd0f8ElP+Tjta/7FO4/9K7Sj/grX/wAnHaL/ANinb/8ApXd0f8ElP+Tjta/7FO4/9K7So+0afZP0QoooqzMK/E2v2yr8TaiZcD9fP2af+Tcfh/8A9ippn/pJFXbV+PumfFj4p6dptvp+n/ErxhaWdpEsNvb2+vXMccMagKqIofCqAAABwAKm/wCFyfF//oqvjb/worv/AOOUcwcp+vlFfkH/AMLk+L//AEVXxt/4UV3/APHKP+FyfF//AKKr42/8KK7/APjlPmDlP18r5c/4K2f8m46J/wBjZb/+kl3XxN/wuT4v/wDRVfG3/hRXf/xysvxd4/8AHfirTU0/xR418Ra3ZxSiZLfUtVnuY0kAKhwsjEBgGYZ64Y+tJy0BRszb/ZZsry//AGlfAMFjaT3Uq+JrCZkhjLsI47hJJHIH8KojMx6BVJPAr9da+av+Ccvwz+F2m/B/TPHWgy2PiHxJffNf6pNApm0q42FXs4lb5odiyMrEYMobfko0YX6VpxVkKTuwrif2l/8Ak3H4gf8AYp6n/wCkktdtXE/tL/8AJuPxA/7FPU//AEklqiVufkHX6+fs0f8AJuPw/wD+xT0z/wBJIq/IOuw0z4sfFPTtNt9P0/4leMLSztIlht7e3165jjhjUBVRFD4VQAAAOABWcXY1krn7BUV+Qf8AwuT4v/8ARVfG3/hRXf8A8co/4XJ8X/8Aoqvjb/worv8A+OVXMTyn6+UV+Qf/AAuT4v8A/RVfG3/hRXf/AMco/wCFyfF//oqvjb/worv/AOOUcwcp9s/8FbP+TcdF/wCxrt//AEku6+XP+CdP/J5Hg7/t+/8ASC5rzXxd4/8AHfirTU0/xP418Ra3ZxyiaO31LVZ7mNZACocLIxAYBmGeuGPrX6Bf8E2vAHw60P4L2vjPwxqEGta/rcIj1nUCm2SxkG1nsFQ8xqh2k95Ttk5QxBZ3Y9kfR1fP2t/sr6Na+K9Z1D4e+K5vBum+LYpLTxLplvo9rdLPZyACS3s5ZF32auDISF3ruKYUCJVr6BorQzvY5b4OfD3wv8MPAdp4S8JWP2axtvnkkchpruYgBppnAG+RsDJwAAAqhVVVHU0UUAfLn/BWz/k3HRP+xst//SS7r4m/Zp/5OO+H/wD2Nmmf+lcVfff/AAUx8JXnin9lu9u7EztL4a1CDV2ghtjK00ah4ZM4PyKiTtKzYICxHOBlh+cXgfXrzwr410fxPp8cEl5omoQX9uk6lo3khkWRQ4BBKkqM4IOO4rOW5pHY/Z6ivzw/4by+L/8A0Lngn/wBu/8A5Jo/4by+L/8A0Lngn/wBu/8A5JquZE8rP0Por88P+G8vi/8A9C54J/8AAG7/APkmj/hvL4v/APQueCf/AABu/wD5Jo5kHKz9D6K/PD/hvL4v/wDQueCf/AG7/wDkmj/hvL4v/wDQueCf/AG7/wDkmjmQcrP0PornfhDr154q+E/hfxRqEcEd5reiWd/cJbqVjSSWBJGCAkkKCxxkk47muiqiQr8Ta/bKvxNqJlwP1M/Z7+E/ws1H4B+B9Q1D4a+D7u8u/DOnTXFxcaDbSSTSNbRszuxTLMSSSTySa7D/AIU38If+iVeCf/CdtP8A43R+zT/ybj8P/wDsVNM/9JIq7aqRJxP/AApv4Q/9Eq8E/wDhO2n/AMbo/wCFN/CH/olXgn/wnbT/AON121FMRxP/AApv4Q/9Eq8E/wDhO2n/AMbr5B/4KseDfCHhL/hA/wDhFPCmiaF9s/tL7T/ZenRWvn7fsm3f5ajdjc2M9Nx9a+9K+Jv+CxX/ADTr/uK/+2dTLYqO5xP/AAST/wCTjta/7FS4/wDSu0r9D6/PD/gkn/ycdrX/AGKlx/6V2lfofRHYJbhRRRVEn4m1+vn7NP8Aybj8P/8AsVNM/wDSSKvyl+LfhK88B/E7XvBt8Z3l0XUJbVZprYwNcRqx8uYRknasibXXkgq4IJGDXtngf9tT4p+FfBWj+F9P0DwfJZ6Jp8FhbvcWdy0jxxRrGpci4ALEKM4AGewrOLszSSufpJRX54f8N5fF/wD6FzwT/wCAN3/8k0f8N5fF/wD6FzwT/wCAN3/8k1XMieVn6H0V+eH/AA3l8X/+hc8E/wDgDd//ACTR/wAN5fF//oXPBP8A4A3f/wAk0cyDlYn/AAVr/wCTjtF/7FO3/wDSu7o/4JKf8nHa1/2Kdx/6V2leNftEfFvxH8ZfG1r4o8UWWl2l5aaelgiabFJHGY1kkkBIkdzuzK3fGAOPX6c/4JC+Ef8AkcPHtzp//PHSNPvfO/7bXMflhv8ArzO5l9lP3xU7yKekT7ZooorQzCvxNr9sq/E2omXA/Uz9nv4T/CzUfgH4H1DUPhr4Pu7y78M6dNcXFxoNtJJNI1tGzO7FMsxJJJPJJrsP+FN/CH/olXgn/wAJ20/+N18I+B/21Pin4V8FaP4X0/QPB8lnomnwWFu9xZ3LSPHFGsalyLgAsQozgAZ7CtX/AIby+L//AELngn/wBu//AJJp8yFys+2f+FN/CH/olXgn/wAJ20/+N0f8Kb+EP/RKvBP/AITtp/8AG6+Jv+G8vi//ANC54J/8Abv/AOSaP+G8vi//ANC54J/8Abv/AOSaOZBys+2f+FN/CH/olXgn/wAJ20/+N184f8FPvAHgTwr8A9H1Dwv4K8O6JeS+JoIXuNN0qC2keM210xQtGoJUlVOOmVHpXmv/AA3l8X/+hc8E/wDgDd//ACTXBftEftL+O/jL4KtfDHijSfDtpZ2moJfo+m208chkWOSMAmSZxtxK3bOQOfVOSsNRdyD9iD4heKPA37Qfh2z0G+2WPibVrPS9Vs5QWhuYZZlj3FcjEieYzI45ByOVZ1b9U6/KX9h/wleeMf2pPCFpbGeOLS9QTV7qeO2Mywx2pEw34I2K7pHFuJwGlXqcKf1apx2FLcK4n9pf/k3H4gf9inqf/pJLXbVxP7S//JuPxA/7FPU//SSWqJW5+QdfqZ+z38J/hZqPwD8D6hqHw18H3d5d+GdOmuLi40G2kkmka2jZndimWYkkknkk1+WdfR3gf9tT4p+FfBOj+F9P0DwfJZ6Jp8FhbvcWdy0jxwxrGpci4ALEKM4AGewrOLSNJJs+7v8AhTfwh/6JV4J/8J20/wDjdH/Cm/hD/wBEq8E/+E7af/G6+Jv+G8vi/wD9C54J/wDAG7/+SaP+G8vi/wD9C54J/wDAG7/+SarmRPKz7Z/4U38If+iVeCf/AAnbT/43R/wpv4Q/9Eq8E/8AhO2n/wAbr4m/4by+L/8A0Lngn/wBu/8A5Jo/4by+L/8A0Lngn/wBu/8A5Jo5kHKz0r/gp94A8CeFfgHpGoeF/BXh3RLyTxNBC9xpulQW0jxm2umKFo1BKkqpx0yo9K8T/wCCaHiTXdJ/ao0bQtP1OeDTfEEVzFqdoCDHdLFazSxllP8AEroCGGGALDOGYHE/aI/aX8d/GXwVa+F/FGk+HbSztNQS/R9Ntp45DIsckYBMkzjbiVu2cgc+t3/gm/Z3l1+2D4XntrSeaKyivprp44yywRmzmjDuR91d8ka5PG51HUip6lbI/T+iiitDMKKKKACvnf4gfsW/BfxP4kk1e1i1vw75+Wls9Fu40tmcuzF1SWOTZ94DahVAFACjnP0RRQF7Hy5/wwb8If8AoY/G3/gdaf8AyNR/wwb8If8AoY/G3/gdaf8AyNX1HRS5UPmZ8uf8MG/CH/oY/G3/AIHWn/yNR/wwb8If+hj8bf8Agdaf/I1fUdFHKg5mfLn/AAwb8If+hj8bf+B1p/8AI1H/AAwb8If+hj8bf+B1p/8AI1fUdFHKg5mZfgfQbPwr4K0fwvp8k8lnomnwWFu9wwaR44o1jUuQACxCjOABnsK1KKKYgr5c/wCGDfhD/wBDH42/8DrT/wCRq+o6KLXC9jL8D6DZ+FfBWj+F9Pknks9E0+Cwt3uGDSPHFGsalyAAWIUZwAM9hWpRRQAUUUUAFeXftKfAbwh8bv7F/wCEr1LW7P8AsL7R9m/sueKPf53lbt/mRvnHlLjGOp69vUaKAPGf2d/2aPAnwa8a3Xijwvq3iK7vLvT3sHTUrmCSMRtJHISBHCh3ZiXvjBPHp7NRRQAUUUUAea/tA/Aj4dfGO3hfxbps8epWsXk2urWE3k3cEe8OUyQUdchgBIrBd7ldpYmvJv8Ahg34Q/8AQx+Nv/A60/8AkavqOilZDuz5c/4YN+EP/Qx+Nv8AwOtP/kaj/hg34Q/9DH42/wDA60/+Rq+o6KOVBzM+XP8Ahg34Q/8AQx+Nv/A60/8Akaj/AIYN+EP/AEMfjb/wOtP/AJGr6joo5UHMz5j0z9hT4OWupW9zPq/jC9ihlV3tbjUIBHOoIJRzHArhWAwdrK2DwQea+iPBPhvQ/CHhSx8NeGtMg03StNiEVrawg7UXOSSTyzEkszElmYkkkkmtSinZIV2FFFFABXy5/wAMG/CH/oY/G3/gdaf/ACNX1HRRa4XsfLn/AAwb8If+hj8bf+B1p/8AI1H/AAwb8If+hj8bf+B1p/8AI1fUdFLlQ+Zny5/wwb8If+hj8bf+B1p/8jUf8MG/CH/oY/G3/gdaf/I1fUdFHKg5mfLn/DBvwh/6GPxt/wCB1p/8jUf8MG/CH/oY/G3/AIHWn/yNX1HRRyoOZnE/A34TeBvhJ4bk0jwXpH2X7V5bX15NIZbm9dE2h5HP/AjtUKil3Kqu4121FFMQVl+ONBs/FXgnWPC+oSTx2et6fPYXD27BZEjmjaNihYEBgGOMgjPY1qUUAfLn/DBvwh/6GPxt/wCB1p/8jUf8MG/CH/oY/G3/AIHWn/yNX1HRS5UPmZ8uf8MG/CH/AKGPxt/4HWn/AMjUf8MG/CH/AKGPxt/4HWn/AMjV9R0UcqDmZ8uf8MG/CH/oY/G3/gdaf/I1H/DBvwh/6GPxt/4HWn/yNX1HRRyoOZny5/wwb8If+hj8bf8Agdaf/I1e2/A34TeBvhJ4bk0jwXpH2X7V5bX15NIZbm9dE2h5HP8AwI7VCopdyqruNdtRRZBdhRRRTEFFFFAH/9kKZW5kc3RyZWFtCmVuZG9iago5MyAwIG9iago8PAovTGVuZ3RoIDEwMTMKL0JpdHNQZXJDb21wb25lbnQgOAovVHlwZS9YT2JqZWN0Ci9XaWR0aCA0NDIKL1N1YnR5cGUvSW1hZ2UKL05hbWUvV252UGRmX2tjaWtwZm5tZGdsYWtwam9wZGJhY2hiYWNrYWplbmNhCi9Db2xvclNwYWNlL0RldmljZUdyYXkKL0ZpbHRlci9GbGF0ZURlY29kZQovSGVpZ2h0IDYwCj4+CnN0cmVhbQp4Xu2cjXWjMBCEtwRKoASXoBJSAiW4BJXgElSCS1AJLoES6GAPJwhwIq1Ww/Pd8bLfvXc/YTWrnTFOjM2RYRiGYRiGYRjGxsX5ZgpSrnI8x7AsGYQaQLdPS3qhyAMMTlL8pPcAg+tyWpf50CV3wIWJASiPrxzPEZclUagBdF1a4oQixpiCJLrr3ch4678pdXEKPkzx+9epuzMG5QEcPmNyM/fsCbKAJjdze9HtHuH57y5M/WuH7sEglAdw+KTJ8ZR9CvviQHL82EcX4nOLj4Hu8bVDZBTKAzh81uT4UZY9khzfN52Oe2Lf+al7/m3HB8NQHsDh0ybHQ1H2UHK7Dbv50cGe5uQobl+dQb/JsSX3pHzSHUtuO+lc/Nqin10advod41AewOHzJsfFH1KOJTetOpfpec5d7vMfo8vpB98M5QEc/i+SC66Ba1V57X11DYSfQ47D89nyws5N+4eJarY2AIf/i+Q8NVBXrlfkyAx5nXrv5iOX0e8rMX0RwGFLLpEbMkzD/PswhpdKTF8EcNiSS2SHHEaefw2vlZi+COCwJZcoDNn9vJ6J6YsADltyCf2QmL6IvvmGJbegHxLTF9E33zhvcn21wlEDacjt9VwJTF8EcPi8ye0uMBYq2pxNQ/paIagvAjh82uSE93lUvX+wDBmoCqYvsjoc9aR3dqNGl9Soplu36xsIn0uCILv2Dr6Br4fwQHVUs7WxOgwQNbqkRjUdwwyC6ta7memDFKhma+O3JFcxGE5Oert2h2q2Nn5JcjWD0eQe5W+dL6hma+OXJDdacnuiRpfUqKZjkEkSxZNje7Ykem9y9hPKnqjRJTWq6RjnJsjiyf37VwWkJy5LolAD6KqmSzWeGliUQ7Wi0Vlf1U1g+iKAw6dNTrBY1fsHaUhfKwT1RQCHz5ucXXFelkShBtBVTZdqPDVQV65X5NAPiemL6JtvWHIL+iExfRF98w1LbkE/JKYvom++Yckt6IfE9EX0zTcsuQX9kJi+iL75xruTky4opRpPDdR9q1fk0A+J6Yvom29okhvadZ1mSarx1EDdt3pFDr15F8YpSOqbb2iSW61oR3x1lIqibyCkVcWzed1u8A0kIxTmQXeIf1FQfFdyq8XtlD/nc0j2SVH2wAONxVsqE4FhCopvSw6/1W+QZPkIis9+QUjXshd6hikovi052ItRUj2WnCvKwrv9pKc6V0YpCL4tOboxhhNV+QDCqXEouStpQP34+8lhT+2f9zAJME4QZI8k50nHx8gQBbk3JodsNdY+HMAoo/jeNZ7c6438Mh8B+U9RCmLvTK51q/FWyw1MbqoqY8lN0dd3bBiGYRiGYRiGYRjG3+QPCVQiuAplbmRzdHJlYW0KZW5kb2JqCjk0IDAgb2JqCjw8Ci9BSVMgZmFsc2UKL1R5cGUvRXh0R1N0YXRlCi9jYSAxCi9DQSAxCi9CTS9Ob3JtYWwKPj4KZW5kb2JqCjk1IDAgb2JqCjw8Ci9GaWx0ZXIvRmxhdGVEZWNvZGUKL0xlbmd0aCAxNjEKPj4Kc3RyZWFtCnheXY5NDsIgEIX3JNxhToBQU1r2HkBXXZqWv1JgqJp4fm0U0zib+ZKX9+VxxreD+qVovtSpSncLAyAlcKPkMODzbNw1Lcku2qPG7GKya8lpNCbPOazRFh3APyipUiE4k51Qe73sBTs2vdj0lHz8nLWqk62sa/ge/qOflAPo/G5D3RaW1eUwYvEeo0M95Sn4qNH7OUYTRjgVSi6UvAC3vkB7CmVuZHN0cmVhbQplbmRvYmoKOTYgMCBvYmoKPDwKL1BhcmVudCAzIDAgUgovVHlwZS9QYWdlCi9NZWRpYUJveFswIDAgNjEyIDc5Ml0KL1Jlc291cmNlcwo8PAovWE9iamVjdAo8PAovV252UGRmX2lqcGZtaWFub2dnbmtmbmNibWJpZ2tjbmdnaGtrZGlhIDkwIDAgUgo+PgovUHJvY1NldFsvUERGL1RleHQvSW1hZ2VDXQovRXh0R1N0YXRlCjw8Ci9XbnZQZGZfbGpsZWpjZ25jbm1ma2xlcG9tbGFkZG1obWlwa2VvY2kgOTQgMCBSCj4+Cj4+Ci9Db250ZW50c1s5NSAwIFJdCi9Hcm91cAo8PAovQ1MvRGV2aWNlUkdCCi9TL1RyYW5zcGFyZW5jeQovSSBmYWxzZQovSyBmYWxzZQo+Pgo+PgplbmRvYmoKeHJlZgowIDk3CjAwMDAwMDAwMDAgNjU1MzUgZiAKMDAwMDAwMDAxNSAwMDAwMCBuIAowMDAwMDAwMTgwIDAwMDAwIG4gCjAwMDAwMDAyMjggMDAwMDAgbiAKMDAwMDAwMDMyNiAwMDAwMCBuIAowMDAwMDAxMjYyIDAwMDAwIG4gCjAwMDAwMDE0MTcgMDAwMDAgbiAKMDAwMDAwMTU4MiAwMDAwMCBuIAowMDAwMDAyNTA0IDAwMDAwIG4gCjAwMDAwMDI2NjUgMDAwMDAgbiAKMDAwMDAwMjgzNyAwMDAwMCBuIAowMDAwMDAzNzU5IDAwMDAwIG4gCjAwMDAwMDM4NTEgMDAwMDAgbiAKMDAwMDAwMzkxNiAwMDAwMCBuIAowMDAwMDA0MDg5IDAwMDAwIG4gCjAwMDAwMDQyNzMgMDAwMDAgbiAKMDAwMDAwNTE5NyAwMDAwMCBuIAowMDAwMDA1MzY2IDAwMDAwIG4gCjAwMDAwMDU1NDcgMDAwMDAgbiAKMDAwMDAwNjQ2OSAwMDAwMCBuIAowMDAwMDA2NjM0IDAwMDAwIG4gCjAwMDAwMDY4MDkgMDAwMDAgbiAKMDAwMDAwNzczMiAwMDAwMCBuIAowMDAwMDExNzU2IDAwMDAwIG4gCjAwMDAwMTUxOTIgMDAwMDAgbiAKMDAwMDAxODUwMSAwMDAwMCBuIAowMDAwMDI3NTQwIDAwMDAwIG4gCjAwMDAwMzY1MjUgMDAwMDAgbiAKMDAwMDAzODY3OCAwMDAwMCBuIAowMDAwMDQwMzkzIDAwMDAwIG4gCjAwMDAwNDI5NzggMDAwMDAgbiAKMDAwMDA1NzUwNCAwMDAwMCBuIAowMDAwMDYxNTI4IDAwMDAwIG4gCjAwMDAwNjU1NTIgMDAwMDAgbiAKMDAwMDA3NzEyNCAwMDAwMCBuIAowMDAwMDg1MDcxIDAwMDAwIG4gCjAwMDAwODkwOTUgMDAwMDAgbiAKMDAwMDA5MzIwOCAwMDAwMCBuIAowMDAwMDk3MjMyIDAwMDAwIG4gCjAwMDAxMDI4MTMgMDAwMDAgbiAKMDAwMDEwNzEyNyAwMDAwMCBuIAowMDAwMTEyNzgwIDAwMDAwIG4gCjAwMDAxMjU0OTUgMDAwMDAgbiAKMDAwMDEzNjE1NyAwMDAwMCBuIAowMDAwMTQ2ODE5IDAwMDAwIG4gCjAwMDAxNjQ1MzEgMDAwMDAgbiAKMDAwMDE2NTUzOSAwMDAwMCBuIAowMDAwMTY1NTg5IDAwMDAwIG4gCjAwMDAxNjYwMzcgMDAwMDAgbiAKMDAwMDE3NjYxOSAwMDAwMCBuIAowMDAwMTg3MjI3IDAwMDAwIG4gCjAwMDAyMDQyMzggMDAwMDAgbiAKMDAwMDIwNTY3MCAwMDAwMCBuIAowMDAwMjA2ODA4IDAwMDAwIG4gCjAwMDAyMDg5NDcgMDAwMDAgbiAKMDAwMDIwOTU3MyAwMDAwMCBuIAowMDAwMjEzMDcxIDAwMDAwIG4gCjAwMDAyMTc0MjYgMDAwMDAgbiAKMDAwMDIyMDI3NyAwMDAwMCBuIAowMDAwMjIxNjI3IDAwMDAwIG4gCjAwMDAyMjE5MzMgMDAwMDAgbiAKMDAwMDIyMjA5OCAwMDAwMCBuIAowMDAwMjI0Mjc3IDAwMDAwIG4gCjAwMDAyMjQ0NDIgMDAwMDAgbiAKMDAwMDIyNjUzMyAwMDAwMCBuIAowMDAwMjI2Njk4IDAwMDAwIG4gCjAwMDAyMjc4OTggMDAwMDAgbiAKMDAwMDIyODA2MyAwMDAwMCBuIAowMDAwMjI5OTk0IDAwMDAwIG4gCjAwMDAyMzAxNTkgMDAwMDAgbiAKMDAwMDIzMzY5MiAwMDAwMCBuIAowMDAwMjMzODYwIDAwMDAwIG4gCjAwMDAyMzUwNTggMDAwMDAgbiAKMDAwMDIzNTQ4OSAwMDAwMCBuIAowMDAwMjM1NzY4IDAwMDAwIG4gCjAwMDAyNTc5NTMgMDAwMDAgbiAKMDAwMDI1ODExMSAwMDAwMCBuIAowMDAwMjU5ODk4IDAwMDAwIG4gCjAwMDAyNjA0MzQgMDAwMDAgbiAKMDAwMDI2MDcwNCAwMDAwMCBuIAowMDAwMjk2OTc3IDAwMDAwIG4gCjAwMDAyOTcxNTUgMDAwMDAgbiAKMDAwMDI5NzU1MyAwMDAwMCBuIAowMDAwMjk3NzgwIDAwMDAwIG4gCjAwMDAyOTgwNjAgMDAwMDAgbiAKMDAwMDMxMTcyNSAwMDAwMCBuIAowMDAwMzE4MzQzIDAwMDAwIG4gCjAwMDAzMTk1NjkgMDAwMDAgbiAKMDAwMDMxOTY0MSAwMDAwMCBuIAowMDAwMzE5ODc0IDAwMDAwIG4gCjAwMDAzMjAxOTUgMDAwMDAgbiAKMDAwMDMyMzQxOSAwMDAwMCBuIAowMDAwNDA0MzE4IDAwMDAwIG4gCjAwMDA0MTA5MzYgMDAwMDAgbiAKMDAwMDQxMjE2MiAwMDAwMCBuIAowMDAwNDEyMjM0IDAwMDAwIG4gCjAwMDA0MTI0NjcgMDAwMDAgbiAKdHJhaWxlcgo8PAovSURbPENBMUI0RTcxRDIyMUNFNDRCMzM4QTE0NUVDREU5REM1PjxDQTFCNEU3MUQyMjFDRTQ0QjMzOEExNDVFQ0RFOURDNT5dCi9JbmZvIDEgMCBSCi9Sb290IDIgMCBSCi9TaXplIDk3Cj4+CnN0YXJ0eHJlZgo0MTI3ODgKJSVFT0YK";
      // ID de la póliza
      var policy = 21385;

      var hoy = new Date();
      var dia = ("0" + hoy.getDate()).slice(-2);
      var mes = ("0" + (hoy.getMonth() + 1)).slice(-2);
      var anio = hoy.getFullYear();
      var fechaCompromiso = dia + "/" + mes + "/" + anio;
      var fechaHoy = hoy.toISOString();
      // var url = {}
      // url.IP = 'http://127.0.0.1:8000/';
      $scope.dataToSend = {
        link: linkPoliza,
        priority: 1,
        closed: 0,
        created: 0,
        assigned:
          "https://api.miurabox.com/usuarios-general/" + usuarioAsignado + "/",
        chain: 0,
        archived: 0,
        order: 3,
        asc: 0,
        status: {
          id: 11,
          name: "Abiertas",
        },
        ver: 0,
        title: "Nueva emisión de póliza " + policy,
        select_user: [],
        compromiso: fechaCompromiso,
        concept: 1,
        descrip: "Se ha emitido una nueva póliza desde el cotizador.",
        involved_task: [],
        date: fechaHoy,
        associated: null,
        route: null,
        model: null,
      };

      // Puedes imprimir para verificar los datos
      console.log("Datos a enviar:", $scope.dataToSend);

      $http
        .post("https://api.miurabox.com/save-ticket-mc/", $scope.dataToSend)
        .then(function (response) {
          // Manejo de respuesta exitosa
          console.log("Datos enviados exitosamente:", response.data.id);
          $scope.guardarArchivoTask();
        })
        .catch(function (error) {
          // Manejo de errores
          console.error("Error al enviar los datos:", error);
        });
    };

    function generarRequestId() {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      var hex = Array.prototype.map
        .call(bytes, function (b) {
          return ("0" + b.toString(16)).slice(-2);
        })
        .join("");
      return [
        hex.substr(0, 8),
        hex.substr(8, 4),
        hex.substr(12, 4),
        hex.substr(16, 4),
        hex.substr(20),
      ].join("-");
    }

    $scope.registrarPoliza = function () {
      console.log("--", $scope.filePdf);

      if (!$scope.filePdf) {
        toaster.pop("error", "Error", "No se pudo obtener el archivo PDF.");
        return;
      }

      if ($scope.filePdf.type !== "application/pdf") {
        toaster.pop("error", "Error", "Solo se permiten archivos PDF.");
        return;
      }
      if ($scope.filePdf.size === 0) {
        console.error("El archivo descargado está vacío.");
        toaster.pop("error", "Error", "El archivo descargado está vacío.");
        return;
      }
      $scope.loader = true;

      console.log(":::", $scope.fileSelected);
      var formData = new FormData();
      formData.append("archivo", $scope.filePdf);
      formData.append("insurance", $scope.aseguradora);
      formData.append("org", $scope.org_name || "pruebas");
      formData.append("nombre", $scope.filePdf.name);

      var requestId = generarRequestId();
      formData.append("requestId", requestId);

      var xhr = new XMLHttpRequest();
      xhr.open("POST", $scope.Urllector + "upload-pdf", true);
      xhr.onload = function () {
        if (xhr.status === 200) {
          // guardarlo como registrado
          var payload = { status: "4" };
          $scope.guardarCotizacion(payload, "");

          localStorage.setItem("datos_pdf", xhr.response);
          localStorage.setItem("pdf_generado", 1);
          $location.path("/polizas/crear");
        } else {
          console.error("Error al enviar el archivo:", xhr.statusText);
        }
        $scope.loader = false;
        $scope.$apply();
      };
      xhr.onerror = function () {
        console.error("Error en la solicitud.");
        toaster.pop("error", "Error", "Error en la solicitud.");
        $scope.loader = false;
        $scope.$apply();
      };
      xhr.send(formData);
    };

    $scope.asignLogo = function (param) {
      var id_service = param.service.id;
      if (id_service == 1) {
        return src_imgs + "providers/Logo_Qualitas.png";
      } else if (id_service == 2) {
        return src_imgs + "providers/Logo_CHUBB.jpg";
      } else if (id_service == 13) {
        return src_imgs + "providers/Logo_Primero.png";
      } else if (id_service == 11) {
        return src_imgs + "providers/Logo_HDI.png";
      } else if (id_service == 12) {
        return src_imgs + "providers/Logo_ANA.png";
      } else if (id_service == 4) {
        return src_imgs + "providers/Logo_Zurich.png";
      } else if (id_service == 17) {
        return src_imgs + "providers/Logo_Afirme.jpeg";
      } else if (id_service == 20) {
        return src_imgs + "providers/Logo_potosi.png";
      } else if (id_service == 9) {
        return src_imgs + "providers/Logo_GNP.png";
      } else if (id_service == 6) {
        return src_imgs + "providers/Logo_Banorte.png";
      } else if (id_service == 19) {
        return src_imgs + "providers/Logo_Atlas.png";
      } else if (id_service == 8) {
        return src_imgs + "providers/Logo_Bxmas.png";
      }
    };

    //  nuevo codigo
    $scope.getCarBrands = function () {
      $http
        .get(url_.MC + "cotizar/marcas/base")
        .then(function success(response) {
          $scope.car.brands = response.data;
        })
        .catch(function error(e) {});
    };
    $scope.getCarBrands();

    $scope.getCarModels = function () {
      $scope.car.models = [];
      $http
        .get(url_.MC + "cotizar/submarcas/base/" + $scope.car.brand.descripcion)
        .then(
          function success(response) {
            $scope.car.models = response.data;
          },
          function error(e) {
            console.log("Error - get-car-model", e);
          }
        )
        .catch(function (error) {
          console.log("Error - get-car-model - catch", error);
        });
    };

    $scope.getCarYear = function () {
      // console.log($scope.car.model)
      $http
        .get(
          url_.MC +
            "cotizar/modelos/base/" +
            $scope.car.brand.descripcion +
            "/" +
            $scope.car.model.descripcion
        )
        .then(
          function success(response) {
            $scope.car.years = response.data;
          },
          function error(e) {
            console.log("Error - get-car-year", e);
          }
        )
        .catch(function (error) {
          console.log("Error - get-car-year - catch", error);
        });
    };

    $scope.getVersions = function () {
      // console.log($scope.car.model)
      $http
        .get(
          url_.MC +
            "cotizar/descripciones/base/" +
            $scope.car.brand.descripcion +
            "/" +
            $scope.car.model.descripcion +
            "/" +
            $scope.car.year
        )
        .then(
          function success(response) {
            $scope.car.versions = response.data;
          },
          function error(e) {
            console.log("Error - get-car-version", e);
          }
        )
        .catch(function (error) {
          console.log("Error - get-car-version - catch", error);
        });
    };

    $scope.selectValue = function (parValue) {
      if (parValue == 1) {
        $scope.car.value = 4452;
      } else {
        $scope.car.value = 4454;
      }
    };

    $scope.nextForm1 = function () {
      $scope.form1 = false;
      $scope.form2 = true;
      $window.localStorage.car_info = JSON.stringify($scope.car);
    };

    $scope.selectPerson = function (parValue) {
      if (parValue == 1) {
        $scope.car.person_type = 1;
        $scope.client.first_name = "";
        $scope.client.last_name = "";
        $scope.client.second_last_name = "";
        $scope.client.rfc = "";
        $scope.client.beneficiario = "";
      } else {
        $scope.car.person_type = 2;

        $scope.client.first_name = "";
        $scope.client.last_name = ".EMPTY.";
        $scope.client.second_last_name = ".EMPTY.";
        $scope.client.birthdate = "";
        $scope.client.civilState = 2;
        $scope.client.gender = "M";
      }
    };

    $scope.getAge = function () {
      var age = datesFactory.getAge($scope.client.birthdate);
      $scope.client.age = age;
    };

    $scope.getTowns = function () {
      for (var i = 0; i < $scope.client.states.length; i++) {
        if ($scope.client.state == $scope.client.states[i].name) {
          $scope.client.stateValue = $scope.client.states[i].value;
        }
      }

      $http
        .get(url_.MC + "get-cities/" + $scope.client.stateValue)
        .then(
          function success(response) {
            $scope.client.towns = response.data;
          },
          function error(e) {
            console.log("Error - get-towns", e);
          }
        )
        .catch(function (error) {
          console.log("Error - get-towns - catch", error);
        });
    };

    $scope.filterValue = function ($event, param) {
      var val_letter = parseInt($event.key);
      if ($event.key !== "(" && $event.key !== ")" && $event.key !== "-") {
      } else {
        if (isNaN(val_letter)) {
          $event.preventDefault();
        }
      }
      var newVal = String(param);
      var rawValue = newVal;

      if (newVal.length == 10) {
        // return;
        $event.preventDefault();
      }

      if (newVal.length == 0) {
        newVal = "";
      } else if (newVal.length <= 3 || newVal.length == 3) {
        if (newVal == "33" || newVal == "55" || newVal == "81") {
          newVal = newVal.replace(/^(\d{0,2})/, "($1)");
        } else {
          newVal = newVal.replace(/^(\d{0,3})/, "($1)");
        }
        $scope.postData.lada = rawValue;
      } else if (newVal.length >= 3) {
        var first_values = newVal.substring(-1, 2);
        if (
          first_values == "33" ||
          first_values == "55" ||
          first_values == "81"
        ) {
          newVal = newVal.replace(/^(\d{0,2})(\d{0,3})/, "($1) $2");
          $scope.postData.lada = first_values;
        } else {
          $scope.postData.lada = newVal.substring(-1, 3);
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, "($1) $2");
        }
      } else {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, "($1) $2-$3");
        var first_values = newVal.substring(-1, 2);
        if (
          first_values == "33" ||
          first_values == "55" ||
          first_values == "81"
        ) {
          $scope.postData.phone = newVal.substring(2, 10);
        } else {
          $scope.postData.phone = newVal.substring(3, 10);
        }
      }

      // $scope.phone = newVal;
      $scope.postData.phone = rawValue;
    };

    $scope.getTownsFromZip = function (evt) {
      $http
        .get(url_.MC + "cotizar/colonias-por-cp/base/" + $scope.client.zip)
        .then(
          function success(response) {
            if (response.status === 200) {
              $scope.client.suburbs = response.data.map(function (item) {
                return item.colonia;
              });
              $scope.client.estado = response.data[0].c_estado;
              $scope.client.ciudad = response.data[0].c_ciudad;
              // if($scope.client.zip == undefined){
              //   $scope.client.disableState = false;
              //   $scope.client.disableTown = false;
              // }else{
              //   $scope.client.disableState = true;
              //   $scope.client.disableTown = true;
              //   $scope.client.state = response.data.estado.name;
              //   $scope.client.stateValue = response.data.estado.value;
              //   $scope.getTowns();
              //   $scope.client.town = response.data.municipio;
              // console.log($scope.client.suburbs)
              //   if($scope.client.suburbs.length == 1) {
              //     $scope.client.suburb = $scope.client.suburbs[0].name;
              //   }
              // };
            } else {
              $scope.client.state = "";
              $scope.client.town = "";
            }
          },
          function error(e) {
            console.log("Error - get-cols-by-cp ", e);
          }
        )
        .catch(function (error) {
          console.log("Error - get-cols-by-cp - catch ", error);
        });
    };

    $scope.getSuburbs = function () {
      if ($scope.client.town != undefined) {
        $scope.client.selectedTown = $scope.client.town.replace(/ /g, "_");

        $http
          .get(
            url_.MC +
              "get-cols-by-state-city/" +
              $scope.client.stateValue +
              "/" +
              $scope.client.selectedTown
          )
          .then(
            function success(response) {
              $scope.client.suburbs = response.data;
            },
            function error(e) {
              console.log("Error - get-towns", e);
            }
          )
          .catch(function (error) {
            console.log("Error - get-towns - catch", error);
          });
      } else {
        delete $scope.client.suburbs;
      }
    };

    $scope.client.disableState = true;
    $scope.client.disableTown = true;
    $scope.disabledZipe = function (checkZipe) {
      $scope.checkZipe = checkZipe;

      if ($scope.checkZipe) {
        $scope.client.disableState = false;
        $scope.client.disableTown = false;
      } else {
        $scope.client.disableState = true;
        $scope.client.disableTown = true;
        $scope.getStates();
      }
      $scope.client.zip = "";
      delete $scope.client.suburbs;
    };

    $scope.getCodeZipe = function () {
      if ($scope.checkZipe) {
        if ($scope.client.suburbs) {
          for (var i = 0; i < $scope.client.suburbs.length; i++) {
            if ($scope.client.suburb.name == $scope.client.suburbs[i].name) {
              $scope.client.selectedSuburb = $scope.client.suburbs[i].name;
            }
          }
          $scope.client.selectedSuburb = $scope.client.suburb;
          $scope.client.selectedSuburbs = $scope.client.selectedSuburb.replace(
            / /g,
            "_"
          );
          $scope.client.selectedSuburbs2 =
            $scope.client.selectedSuburbs.replace(".", "");
          $http
            .get(
              url_.MC +
                "get-cp-by-state-city-col/" +
                $scope.client.stateValue +
                "/" +
                $scope.client.selectedTown +
                "/" +
                $scope.client.selectedSuburbs2
            )
            .then(
              function success(response) {
                $scope.client.zip = response.data.cp;
              },
              function error(e) {
                console.log("Error - get-suburbs", e);
              }
            )
            .catch(function (error) {
              console.log("Error - get-suburbs - catch", error);
            });
        }
      }
    };

    $scope.changeDuration = function (parValue) {
      var today = new Date();
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      var end = new Date(
        today.getFullYear() + parValue,
        today.getMonth() - 1 + 1,
        today.getDate()
      );

      $scope.client.inicio_vigencia = today;
      $scope.client.fin_vigencia = end;
      $scope.client.duracion = parValue;
    };

    $scope.calculateDuration = function () {
      var textD;
      var dateI = new Date($scope.client.inicio_vigencia).getFullYear();
      var dateF = new Date($scope.client.fin_vigencia).getFullYear();
      if (dateF - dateI == 1) {
        textD = "año";
      } else {
        textD = "años";
      }
      return dateF - dateI + " " + textD;
    };

    function getAge_(parDate) {
      var today = new Date();
      var birthDate = new Date(parDate);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age;
    }

    $scope.getDate = function () {
      var today = new Date();
      var today_year = new Date().getFullYear();
      var today_month = new Date().getMonth() + 1;
      var today_day = new Date().getDate();

      var age_year = today_year - 30;
      var age_month = new Date().getMonth() - 2;

      var age1 = new Date(age_year, age_month, today_day);
      var date_age = age1.setDate(age1.getDate() - 10);

      var age = getAge_(new Date(date_age));

      var a = new Date(date_age);
      var a_year = a.getFullYear();
      var a_month = a.getMonth();
      var a_day = a.getDate();

      var month__ = ("0" + (a_month + 1)).slice(-2);
      var day__ = ("0" + a_day).slice(-2);

      return {
        age: age,
        date_rfc: String(a_year).substring(2) + month__ + day__,
        birthdate: day__ + "/" + month__ + "/" + a_year,
      };
    };

    $scope.rellenarCamposPrueba = function () {
      // Sección automóvil
      $scope.car = $scope.car || {};
      // $scope.car.brands = [
      //   { descripcion: 'Nissan' },
      //   { descripcion: 'Toyota' },
      //   { descripcion: 'Honda' }
      // ];
      // $scope.car.models = [
      //   { descripcion: 'Versa', cat: '1001' },
      //   { descripcion: 'Sentra', cat: '1002' }
      // ];
      // $scope.car.years = [2023, 2022, 2021];
      // $scope.car.versions = [
      //   { descripcion: '1.6L Manual', clave: 'A1' },
      //   { descripcion: '1.6L CVT', clave: 'A2' }
      // ];

      // // Seleccionamos algo “por defecto”
      // $scope.car.brand = $scope.car.brands[0];  // Nissan
      // $scope.car.model = $scope.car.models[0];  // Versa
      // $scope.car.year = '2023';                   // 2023
      // $scope.car.version = $scope.car.versions[0]; // 1.6L Manual

      // Sección cliente
      $scope.client = $scope.client || {};
      $scope.client.zip = "76148";
      $scope.client.suburbs = ["Jurica", "Juriquilla"];
      $scope.client.suburb = "Jurica";
      $scope.client.name = "Juan";
      $scope.client.last_name = "Perez";
      $scope.client.second_last_name = "Lopez";
      $scope.client.birthdate = "01/05/1990"; // dd/mm/yyyy
      $scope.client.gender = { value: "M", name: "Masculino" };
      $scope.client.genders = [
        { value: "M", name: "Masculino" },
        { value: "F", name: "Femenino" },
      ];
      $scope.client.rfc = "PELE900501XXX";
      $scope.client.email = "jperez@example.com";
      $scope.client.phone = "4421234567";
      $scope.client.paquete = "01"; // 'Amplia' por ejemplo
      $scope.client.frecuencia = "C"; // 'Contado' en quote.frecuencys

      // Ciudad/Estado “de prueba”
      $scope.client.ciudad = "Querétaro";
      $scope.client.estado = "Queretaro";

      // Sección “car.brand.descripcion”, “car.model.descripcion”, etc.
      // Nota: “Marca” = 'Nissan'; “Modelo” = 'Versa'; “Año”=2023
      //       “Version” = '1.6L Manual', “cat”= '1001', “clave”='A1'

      console.log("¡Campos de prueba rellenados!");
    };
    // function postCotizacionAseguradora(formData, aseguradora) {
    //   const url = url_.MC + 'cotizar/cotizar-aseguradora/' + aseguradora;

    //   $http.post(url, formData)
    //     .then(function(response) {
    //       const idCot = formData.cotizacion_id || localStorage.getItem('id_cotizacion');
    //       if (!idCot) {
    //         console.warn("No hay cotización ID, se requiere para abrir WebSocket.");
    //         return;
    //       }

    //       const socketUrl = $scope.urlSocket + idCot;
    //       wsService.onMessage(null);
    //       wsService.connect(socketUrl);

    //       $scope.loader = true;
    //       $scope.respuestas_num = 0;

    //       wsService.onMessage(function(mensajeData) {
    //         try {
    //           const parsed = JSON.parse(mensajeData);
    //           const message = JSON.parse(parsed.message);

    //           if (!message.error) {
    //             const quotes = JSON.parse(localStorage.getItem('quotes')) || [];
    //             const existing = quotes.find(q => q.aseguradora === message.aseguradora);

    //             if (existing) {
    //               const index = quotes.findIndex(q => q.aseguradora === message.aseguradora);
    //               quotes[index] = message;
    //             } else {
    //               quotes.push(message);
    //             }

    //             localStorage.setItem('quotes', JSON.stringify(quotes));
    //             $scope.getStoredQuotes();
    //           }

    //           if (message.error) {
    //             SweetAlert.swal('Error', message.error);
    //           }

    //           if (message.aseguradora) {
    //             wsService.disconnect();
    //             console.log("✔ WebSocket cerrado tras recotización.");
    //           }

    //         } catch (err) {
    //           console.error("❌ Error procesando mensaje WebSocket:", err);
    //           wsService.disconnect();
    //         }

    //         $scope.loader = false;
    //         $scope.$apply();
    //       });

    //     })
    //     .catch(function(error) {
    //       console.error("❌ Error en recotización:", error);
    //       SweetAlert.swal('Error', 'Error al recotizar: ' + error.message);
    //     });
    // }

    function postCotizacion(formData) {
      $scope.formData = formData;
      $http
        .post(url_.MC + "cotizar/cotizar/base/", $scope.formData)
        .then(function (response) {
          if (response && response.data && response.data.cotizacion_principal) {
            $scope.IDCotizacion = response.data.cotizacion_principal;

            // Guardar en localStorage si deseas
            localStorage.setItem("quote", JSON.stringify($scope.formData));
            localStorage.setItem(
              "id_cotizacion",
              response.data.cotizacion_principal
            );

            SweetAlert.swal({
              icon: "success",
              title: "Cotización solicitada",
              text: "Mostrando opciones para tu auto",
              confirmButtonText: "OK",
            });
            // Llamar a otra función para cargar las opciones
            $scope.quoter(String(response.data.cotizacion_principal));
          }
        })
        .catch(function (error) {
          console.error("Error en la solicitud:", error);
          SweetAlert.swal({
            icon: "error",
            title: "Error",
            text: "Hubo un problema al crear la cotización. Intente de nuevo.",
            confirmButtonText: "OK",
          });
        });
    }

    $scope.createQuote = function () {
      localStorage.removeItem("quote");
      localStorage.removeItem("quotes");
      $scope.terminado = 0;

      try {
        // Validar fecha nacimiento
        if (!$scope.client.birthdate) {
          throw new Error("Fecha de nacimiento no proporcionada");
        }
        var parts = $scope.client.birthdate.split("/");
        if (parts.length !== 3) {
          throw new Error("Formato de fecha de nacimiento incorrecto");
        }

        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10) - 1;
        var year = parseInt(parts[2], 10);
        var date = new Date(year, month, day);
        if (isNaN(date.getTime())) {
          throw new Error("Fecha de nacimiento no válida");
        }
        var year_ = date.getFullYear();
        var month_ = ("0" + (date.getMonth() + 1)).slice(-2);
        var day_ = ("0" + date.getDate()).slice(-2);
        var dateBirthdate = year_ + "-" + month_ + "-" + day_;

        // Validar otros campos obligatorios
        if (
          !$scope.client.name ||
          !$scope.client.last_name ||
          !$scope.client.email ||
          !$scope.client.phone
        ) {
          throw new Error(
            "Nombre, apellido, correo y teléfono son obligatorios."
          );
        }

        // Construir formData
        $scope.formData = {
          apellido_paterno: $scope.client.last_name,
          apellido_materno: $scope.client.second_last_name,
          nombre: $scope.client.name,
          ciudad: $scope.client.ciudad,
          colonia: $scope.client.suburb,
          correo: $scope.client.email,
          cp: $scope.client.zip,
          descripcion: $scope.car.version.descripcion,
          estado: $scope.client.estado,
          fecha_nacimiento: dateBirthdate,
          marca: $scope.car.brand.descripcion,
          cat: $scope.car.model.cat,
          modelo: $scope.car.year,
          paquete: $scope.client.paquete, // <-- Paquete
          forma_de_pago: $scope.client.frecuencia, // <-- Frecuencia
          rfc: $scope.client.rfc,
          sexo: $scope.client.gender.value,
          submarca: $scope.car.model.descripcion,
          telefono: $scope.client.phone,
          clave: $scope.car.version.clave,
          empresa: $scope.empresa,
          poblacion: "México",
          origen: $scope.origen,
          terminos: true,
          check: false,
        };

        // Llamar a la función común que hace el POST
        postCotizacion($scope.formData);
      } catch (error) {
        SweetAlert.swal({
          icon: "error",
          title: "Validación de datos",
          text: error.message,
          confirmButtonText: "OK",
        });
      }
    };

    $scope.recotizar = function () {
      // console.log("🔁 Recotizando aseguradora desde 'Este no es mi auto'");

      var quoteInfo = localStorage.getItem("quote");
      var idCot = localStorage.getItem("id_cotizacion");
      var version = $scope.car.version;
      var aseguradora = $scope.aseguradora_seleccionada;

      // console.log($scope.selected_quote);
      // console.log(quoteInfo);

      if (!quoteInfo || !version || !aseguradora) {
        SweetAlert.swal("Error", "Faltan datos para recotizar.");
        return;
      }
      // console.log(quoteInfo,version,aseguradora)
      var quoteForm = JSON.parse(quoteInfo);

      // Actualizar solo datos del vehículo
      quoteForm.descripcion = version.descripcion;
      quoteForm.clave = version.clave;
      quoteForm.clave_auto = version.id;
      quoteForm.marca = $scope.car.brand.descripcion;
      quoteForm.submarca = $scope.car.model.descripcion;
      quoteForm.modelo = $scope.car.year;

      quoteForm.cotizacion_id = parseInt(idCot); // necesario para recotizar-aseguradora

      var url = url_.MC + "cotizar/cotizar-aseguradora/" + aseguradora;

      $scope.loader = true;
      $http
        .post(url, quoteForm)
        .then(function (response) {
          var socketUrl = $scope.urlSocket + idCot;

          wsService.connect(socketUrl);
          $scope.respuestas_num = 0;

          wsService.onMessage(function (mensajeData) {
            try {
              var parsed = JSON.parse(mensajeData);
              var message = JSON.parse(parsed.message);

              if (message.aseguradora === aseguradora && !message.error) {
                var stored = JSON.parse(localStorage.getItem("quotes")) || [];

                // 1. Filtrar todo lo que NO sea esa aseguradora
                // var newQuotes = stored.filter(q => q.aseguradora !== aseguradora);
                var newQuotes = stored.filter(function (q) {
                  return q.aseguradora !== aseguradora;
                });

                // 2. Agregar la nueva cotización limpia
                newQuotes.push(message);

                // 3. Guardar en localStorage
                localStorage.setItem("quotes", JSON.stringify(newQuotes));

                // localStorage.setItem('quotes', JSON.stringify(stored));
                $scope.getStoredQuotes();
                wsService.disconnect();
              }

              if (message.error) {
                SweetAlert.swal("Error", message.error);
                wsService.disconnect();
              }
            } catch (e) {
              console.error("Error WebSocket:", e);
              wsService.disconnect();
            }

            $scope.loader = false;
            $scope.$apply();
          });
        })
        .catch(function (error) {
          console.error("Error al recotizar aseguradora:", error);
          SweetAlert.swal("Error", "No se pudo recotizar: " + error.message);
          $scope.loader = false;
        });
    };

    $scope.quoter = function (numeroCotizacion) {
      if (!numeroCotizacion) {
        numeroCotizacion = prompt(
          "Por favor, ingresa el número de cotización:"
        );
        if (!numeroCotizacion) {
          console.error("Número de cotización no proporcionado");
          return;
        }
      }
      localStorage.removeItem("quotes");
      $scope.respuestas_num = 0;

      var socketUrl = $scope.urlSocket + numeroCotizacion;
      wsService.onMessage(null);
      wsService.connect(socketUrl);
      $scope.loader = true;

      $scope.quotes = {};
      wsService.onMessage(function (mensajeData) {
        var parsedMessage1 = {};
        var message1 = {};
        parsedMessage1 = JSON.parse(mensajeData);

        message1 = JSON.parse(parsedMessage1["message"]);
        if (message1) {
          $scope.respuestas_num++;
          if (message1["error"] || message1["ERROR"] || message1["errMsg"]) {
            if (message1["aseguradora"] === "ana") {
              if (message1["error"].includes("No existe la clave AMIS")) {
                message1["homologacion"] = message1["error"];
                $scope.quotes.push(message1);
              }
              if (
                message1["error"].includes(
                  "No se encontró auto correspondiente a la clave"
                )
              ) {
                message1["homologacion"] = message1["error"];
                $scope.quotes.push(message1);
              }
            }
            if (message1["aseguradora"] === "hdi") {
              if (
                message1["error"].includes(
                  "No se encontró auto correspondiente"
                )
              ) {
                message1["homologacion"] = message1["error"];
                $scope.quotes.push(message1);
              }
            }
            if (message1["aseguradora"] === "tumomento") {
              if (
                message1["error"].includes(
                  "No se encontró auto correspondiente a la clave"
                )
              ) {
                message1["homologacion"] = message1["error"];
                $scope.quotes.push(message1);
              }
            }
            if (message1["aseguradora"] === "ps") {
              if (message1["error"]) {
                if (
                  message1["error"].includes(
                    "No se encontró auto correspondiente a la clave"
                  )
                ) {
                  message1["homologacion"] = message1["error"];
                  $scope.quotes.push(message1);
                }
              }
              if (message1["errMsg"]) {
                if (message1["errMsg"].includes("no existente")) {
                  message1["homologacion"] = message1["errMsg"];
                  $scope.quotes.push(message1);
                }
              }
            }
          }

          saveQuoteToLocalStorage(message1);
          var payload = {};
          message1["cliente"] = {
            nombre:
              $scope.client.name +
              " " +
              $scope.client.last_name +
              " " +
              $scope.client.second_last_name,
            correo: $scope.client.email,
            telefono: $scope.client.phone,
          };
          payload[message1["aseguradora"]] = JSON.stringify(message1);
          if (message1["raw_response"]) {
            payload[message1["aseguradora"] + "_id"] =
              message1["raw_response"]["id"];
          }
          $scope.guardarCotizacion(payload, "");
        }
        if ($scope.respuestas_num >= 7) {
          console.log(
            "Se finalizo porque el respuestas_num ",
            $scope.respuestas_num
          );
          $timeout.cancel(timeout); // Cancelamos el timeout si se ha alcanzado el límite.
          finalizarProceso();
        }
        $scope.loader = false;
        $scope.$apply();
        $scope.getStoredQuotes();
      });
      // Configuración del tiempo máximo de espera
      var tiempoMaximo = 70000;
      if (!$scope.timeout && $scope.respuestas_num < 7) {
        var timeout = $timeout(function () {
          console.log("Tiempo máximo de espera alcanzado.");
          clearTimeout(timeout);
          finalizarProceso();
        }, tiempoMaximo);
      }
    };

    function finalizarProceso() {
      console.log(" Finalizando proceso");

      wsService.disconnect(); // Cerrar el WebSocket
      Pace.stop(); // Detener el indicador de progreso, si aplica
      $scope.verPDF(2); // Llamar a la función para generar y enviar el PDF
      $scope.respuestas_num = 0;
    }
    function saveQuoteToLocalStorage(quote) {
      var storedQuotes = localStorage.getItem("quotes");
      var quotesArray = storedQuotes ? JSON.parse(storedQuotes) : [];
      quotesArray.push(quote);
      localStorage.setItem("quotes", JSON.stringify(quotesArray));
      // console.log("Cotización guardada en localStorage:", quote);
    }

    $scope.getStoredQuotes = function () {
      // console.log("obteniendo las opciones");
      $scope.quotes = [];
      $scope.quoteLista = [];
      $scope.emisionVisible = false;
      var storedQuotes = localStorage.getItem("quotes");
      var quoteLista = localStorage.getItem("quote");
      $scope.loader = false;

      if (quoteLista) {
        $scope.quoteLista = JSON.parse(quoteLista);
      }

      if (storedQuotes) {
        try {
          var quotesArray1 = JSON.parse(storedQuotes);
          var allQuotes = [];
          if (quotesArray1[0]["aseguradora"]) {
            $scope.quotes = quotesArray1;
            $scope.quotes.forEach(function (quote) {
              if (quote.coberturas) {
                var totalPremium = 500;
                quote.coberturas.forEach(function (cobertura) {
                  if (cobertura["@NoCobertura"]) {
                    cobertura.NoCobertura = cobertura["@NoCobertura"];
                  }
                  if (cobertura.selected === true) {
                    totalPremium += cobertura.premium;
                  }
                });
                if (quote.aseguradora === "tumomento") {
                  quote.prima = totalPremium;
                }

                if (quote.aseguradora === "hdi" && quote.raw_response) {
                  quote.coberturas = [];
                  var coberturasList = [
                    quote.raw_response.CoberturasObligatorias,
                    quote.raw_response.CoberturasObligatoriasOpcionales,
                    quote.raw_response.CoberturasOpcionales,
                  ];
                  // console.log("recorriendo",quote)
                  coberturasList.forEach(function (cobertura) {
                    cobertura.forEach(function (coverage) {
                      if (coverage.Calculada) {
                        quote.coberturas.push(coverage);
                      }
                    });
                  });
                }
              }
            });

            console.log("All SIN COMBINAR Quotes:", $scope.quotes);
          }
        } catch (e) {
          console.error("Error al parsear JSON:", e.message);
        }
      } else {
        console.log("No hay cotizaciones almacenadas en localStorage.");
      }

      $scope.quote.visible = true;
      // $scope.package_quote = $scope.quoteLista.paquete;
      console.log("quoteLista.forma_de_pago", $scope.quoteLista);
      console.log("quoteLista.forma_de_pago", $scope);
      $scope.postData = {
        package_quote: $scope.quoteLista.paquete,
        quoteFrecuency: $scope.quoteLista.forma_de_pago,
      };
    };

    $scope.showCoverages = function (data) {
      var modalInstance = $uibModal.open({
        animation: true,
        size: "lg",
        templateUrl: "app/multicotizador/modals/multicotizador_coberturas.html",
        controller: "CoveragesModalController",
        resolve: {
          coveragesData: function () {
            return data;
          },
        },
      });
    };

    $scope.cotizarOtro = function () {
      $window.localStorage.removeItem("quote");
      $window.localStorage.removeItem("quotes");
      // $scope.quote.visible   = false;
      // $scope.resultadoPoliza = false;
      $scope.quotes = {};
      $window.location.reload();
    };
    $scope.validarRFC = function () {
      var rfc = $scope.client.rfc;
      var RFC_REGEX = /^([A-ZÑ&]{3,4})(\d{6})([A-Z\d]{3})$/i;
      if (rfc) {
        rfc = rfc.toUpperCase();
        if (RFC_REGEX.test(rfc)) {
          $scope.rfcValido = true;
        } else {
          $scope.rfcValido = false;
        }
      } else {
        $scope.rfcValido = false;
      }
    };

    $scope.wrongCar = function (parItem) {
      $scope.aseguradora_seleccionada = parItem.aseguradora;
      var modalInstance = $uibModal.open({
        animation: true,
        size: "lg",
        templateUrl: "app/multicotizador/modals/wrong-car.template.html",
        controller: "CarsModal",
        resolve: {
          parItem: function () {
            return parItem;
          },
        },
      });

      modalInstance.result.then(
        function (versionSeleccionada) {
          console.log("✅ CERRANDO MODAL", versionSeleccionada);

          // Asignar versión seleccionada a car.version para recotizar
          $scope.car.version = versionSeleccionada;

          // Recotiza con la nueva versión
          $scope.recotizar();
        },
        function () {
          $scope.loader = false;
        }
      );
    };

    $scope.seleccionarCotizacion = function (info) {
      $scope.selected_quote = info;
      $scope.loader = false;
      $scope.obtenerColonias(info.aseguradora);
      $scope.obtenerRegimen(info.aseguradora);

      $scope.registroChubb = false;

      $scope.emisionVisible = true;
    };
    $scope.obtenerRegimen = function (aseguradora) {
      var regimenesFiscales = {
        hdi: [
          {
            id: 43676,
            name: "Sueldos y salarios e ingresos asimilados a salarios",
          },
          { id: 43677, name: "Arrendamiento" },
          { id: 43678, name: "Régimen de enajenación o adquisición de bienes" },
          { id: 43679, name: "Demás ingresos" },
          {
            id: 43680,
            name: "Residentes en el extranjero sin establecimiento permanente en México",
          },
          { id: 43681, name: "Ingresos por dividendos (socios y accionistas)" },
          {
            id: 43682,
            name: "Personas físicas con actividades empresariales y profesionales",
          },
          { id: 43683, name: "Ingresos por intereses" },
          {
            id: 43684,
            name: "Régimen de los ingresos por obtención de premios",
          },
          { id: 43685, name: "Sin obligaciones fiscales" },
          { id: 43687, name: "Incorporación fiscal" },
          {
            id: 43691,
            name: "Régimen de las actividades empresariales con ingresos a través de plataformas tecnológicas",
          },
          { id: 43692, name: "Régimen simplificado de confianza" },
        ],
        gnp: [
          {
            id: 622,
            name: "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
            VALOR: 622,
          },
          { id: 606, name: "Arrendamiento", VALOR: 606 },
          { id: 609, name: "Consolidación", VALOR: 609 },
          { id: 624, name: "Coordinados", VALOR: 624 },
          {
            id: 629,
            name: "De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales",
            VALOR: 629,
          },
          { id: 608, name: "Demás ingresos", VALOR: 608 },
          {
            id: 630,
            name: "Enajenación de acciones en bolsa de valores",
            VALOR: 630,
          },
          { id: 601, name: "General de Ley Personas Morales", VALOR: 601 },
          { id: 628, name: "Hidrocarburos", VALOR: 628 },
          { id: 621, name: "Incorporación Fiscal", VALOR: 621 },
          {
            id: 611,
            name: "Ingresos por Dividendos (socios y accionistas)",
            VALOR: 611,
          },
          { id: 614, name: "Ingresos por intereses", VALOR: 614 },
          { id: 623, name: "Opcional para Grupos de Sociedades", VALOR: 623 },
          {
            id: 612,
            name: "Personas Físicas con Actividades Empresariales y Profesionales",
            VALOR: 612,
          },
          {
            id: 603,
            name: "Personas Morales con Fines no Lucrativos",
            VALOR: 603,
          },
          {
            id: 610,
            name: "Residentes en el Extranjero sin Establecimiento Permanente en México",
            VALOR: 610,
          },
          { id: 626, name: "Régimen Simplificado de Confianza", VALOR: 626 },
          {
            id: 607,
            name: "Régimen de Enajenación o Adquisición de Bienes",
            VALOR: 607,
          },
          {
            id: 625,
            name: "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
            VALOR: 625,
          },
          {
            id: 615,
            name: "Régimen de los ingresos por obtención de premios",
            VALOR: 615,
          },
          { id: 616, name: "Sin obligaciones fiscales", VALOR: 616 },
          {
            id: 620,
            name: "Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
            VALOR: 620,
          },
          {
            id: 605,
            name: "Sueldos y Salarios e Ingresos Asimilados a Salarios",
            VALOR: 605,
          },
        ],
      };

      if (regimenesFiscales[aseguradora]) {
        $scope.regimenFiscales = regimenesFiscales[aseguradora];
      } else {
        $scope.regimenFiscales = [
          { id: 0, name: "No hay regímenes disponibles" },
        ];
      }
    };

    $scope.obtenerColonias = function (aseguradora) {
      var complementoUrl = "";
      switch (aseguradora) {
        case "ana":
          complementoUrl = "anaseguros";
          break;
        case "gnp":
          complementoUrl = "gnp";
          break;
        case "ps":
          complementoUrl = "ps";
          break;
        case "hdi":
          complementoUrl = "hdi";
          break;
        case "tumomento":
          complementoUrl = "tumomento";
          break;
        default:
          break;
      }
      var empresa = $scope.empresa;
      var url2_ = {
        MC2: "https://" + complementoUrl + "-" + $scope.urlApi + "/",
      };
      var params = {
        empresa: empresa,
        cp: $scope.quoteLista.cp,
      };

      if (aseguradora == "ana") {
        $http
          .post(url2_.MC2 + "colonias-por-cp", params)
          .then(function success(response) {
            var coloniasTmp = response.data.transacciones.colonias;
            coloniasTmp = coloniasTmp.map(function (item) {
              return {
                nombre: item["#text"],
              };
            });
            if (!$scope.neighborhoods) {
              $scope.neighborhoods = [];
            }
            // $scope.neighborhoods.push(...coloniasTmp);
            $scope.neighborhoods = $scope.neighborhoods.concat(coloniasTmp);
            $scope.loader = false;
          });
      } else if (aseguradora == "tumomento") {
        var url_ = {
          MC: "https://" + complementoUrl + "-ms.multicotizador.com/",
          MCG: $scope.urlGateway,
        };
        $http
          .get(url_.MC + "colonias-por-cp", { params: params })
          .then(function success(response) {
            var coloniasTmp = response.data;
            coloniasTmp.forEach(function (item) {
              if (item) {
                $scope.neighborhoods.push({
                  clave: item.id,
                  nombre: item.colonia,
                });
              }
            });
            $scope.loader = false;
          });
      } else if (aseguradora == "hdi") {
        $http
          .get(url2_.MC2 + "colonias-hdi", { params: params })
          .then(function success(response) {
            var coloniasTmp = response.data.colonias;
            coloniasTmp.forEach(function (item) {
              if (item) {
                $scope.neighborhoods.push({ nombre: item.Colonia });
              }
            });
            $scope.loader = false;
          });
      } else if (aseguradora == "gnp" || aseguradora == "ps") {
        $http
          .get(url2_.MC2 + "colonias-por-cp", { params: params })
          .then(function success(response) {
            if (aseguradora == "gnp") {
              var coloniasTmp = response.data;
              coloniasTmp.forEach(function (item) {
                if (item) {
                  $scope.neighborhoods.push({
                    clave: item.CLAVE,
                    nombre: item.NOMBRE,
                  });
                }
              });
            } else if (aseguradora == "ps") {
              $scope.neighborhoods = response.data;
            }
            $scope.loader = false;
          });
      }
    };

    $scope.simularEmitirPoliza = function (callback) {
      var simulatedResponse = {
        transacciones: {
          transaccion: {
            "@cotizacion": "5258153",
            "@idCot": "",
            "@negocio": "1193",
            "@tiponegocio": "",
            "@tipotransaccion": "E",
            "@version": "1",
            asegurado: {
              "@calle": "AV ANTEA",
              "@colonia": "JURICA",
              "@cp": "76100",
              "@estado": "22014",
              "@id": "",
              "@materno": "LOPEZ",
              "@nombre": "JUAN",
              "@numeroexterior": "105",
              "@numerointerior": "105",
              "@pais": "MEXICO",
              "@paterno": "PEREZ",
              "@poblacion": "",
              "@tipopersona": "1",
            },
            error: null,
            msi: {
              "@aplica": "SI",
            },
            poliza: {
              "@agente": "05662",
              "@beneficiario": "",
              "@bonificacion": "22.89",
              "@endoso": "",
              "@fecemision": "22/07/2025",
              "@feciniciovig": "22/07/2025",
              "@fecterminovig": "22/07/2026",
              "@formapago": "C",
              "@id": "04005342605000000",
              "@moneda": "00",
              "@politicacancelacion": "1",
              "@tarifacuotas": "2504",
              "@tarifaderechos": "2504",
              "@tarifavalores": "2504",
              "@tipo": "",
            },
            prima: {
              "@comision": "0",
              "@derecho": "920",
              "@impuesto": "1733.93",
              "@primaneta": "9917.07",
              "@primatotal": "12571.00",
              "@recargo": "0",
            },
            recibo: {
              "@anoaprobacion": "",
              "@cadenaoriginal": "",
              "@comision": "",
              "@cuenta": "65501307318",
              "@derecho": "920",
              "@fecemision": "",
              "@feciniciovig": "22/07/2025",
              "@fecterminovig": "22/07/2026",
              "@folio": "",
              "@horaemision": "",
              "@id": "046394429",
              "@impuesto": "1733.93",
              "@numeroaprobacion": "",
              "@numseriecertificado": "",
              "@primaneta": "9917.07",
              "@primatotal": "12571.00",
              "@recargo": "0",
              "@referencia": "00000639442943304228",
              "@sellodigital": "",
              "@serie": "",
            },
            vehiculo: {
              "@amis": "B0350008",
              "@color": "01",
              "@conductor": "",
              "@conductorfecnac": "01/05/1990",
              "@conductorliciencia": "",
              "@conductorocupacion": "",
              "@descripcion": "HONDA CITY UNIQ",
              "@dispositivo": "",
              "@estado": "22014",
              "@fecdispositivo": "",
              "@id": "0001",
              "@modelo": "2023",
              "@motor": "34567890",
              "@placas": "2345678",
              "@plan": "01",
              "@poblacion": "",
              "@repuve": "",
              "@serie": "S12345HO345678900",
              "@servicio": "01",
              "@tipocarga": "",
              "@tipocargadescripcion": "",
              "@uso": "01",
              cobertura: [
                {
                  "@ded": "5%",
                  "@desc": "DAÑOS MATERIALES",
                  "@id": "02",
                  "@pma": "4,527.4",
                  "@sa": "",
                  "@tipo": "",
                },
                {
                  "@ded": "10%",
                  "@desc": "ROBO TOTAL",
                  "@id": "04",
                  "@pma": "1,162.95",
                  "@sa": "",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "RESPONSABILIDAD CIVIL",
                  "@id": "0",
                  "@pma": "",
                  "@sa": "3,000,000.00 LUC ",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "  RC BIENES",
                  "@id": "25",
                  "@pma": "1,316.75",
                  "@sa": "1,500,000.00 POR EVENTO",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "  RC PERSONAS",
                  "@id": "26",
                  "@pma": "757.04",
                  "@sa": "1,500,000.00 POR EVENTO",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "  EXTENSION RC",
                  "@id": "0",
                  "@pma": "",
                  "@sa": "AMPARADO",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "  RC DEL HIJO MENOR",
                  "@id": "0",
                  "@pma": "",
                  "@sa": "AMPARADO",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "  RC POR REMOLQUES",
                  "@id": "0",
                  "@pma": "",
                  "@sa": "AMPARADO",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc":
                    "  RC MOTOCICLISTA, CICLISTA Y/O CONDUCTOR CARRO DE GOLF",
                  "@id": "0",
                  "@pma": "",
                  "@sa": "AMPARADO",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "  RC POR TUMBABURROS Y/O CANASTILLAS",
                  "@id": "0",
                  "@pma": "",
                  "@sa": "AMPARADO",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "RC CATASTROFICA POR MUERTE",
                  "@id": "34",
                  "@pma": "279.67",
                  "@sa": "3,000,000.00 POR EVENTO",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "GASTOS MEDICOS",
                  "@id": "06",
                  "@pma": "507.84",
                  "@sa": "500,000.00",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "DEF. JUD. Y ASIS. LEGAL",
                  "@id": "07",
                  "@pma": "510.00",
                  "@sa": "AMPARADO",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "ANA ASISTENCIA",
                  "@id": "10",
                  "@pma": "575.00",
                  "@sa": "VIAL VIAJES",
                  "@tipo": "B",
                },
                {
                  "@ded": "",
                  "@desc": "MUERTE ACCIDENTAL",
                  "@id": "13",
                  "@pma": "81.00",
                  "@sa": "100,000.00",
                  "@tipo": "",
                },
                {
                  "@ded": "",
                  "@desc": "DESBIELAMIENTO",
                  "@id": "35",
                  "@pma": "199.42",
                  "@sa": "AMPARADO",
                  "@tipo": "",
                },
              ],
            },
          },
        },
      };
      // Simulate a small delay before invoking the callback
      setTimeout(function () {
        callback(simulatedResponse);
      }, 500);
    };

    $scope.registrarChubb = function (formPoliza) {
      var formData = {
        app: $scope.quoteLista.apellido_paterno,
        apm: $scope.quoteLista.apellido_materno,
        calle: formPoliza.calle,
        col: $scope.quoteLista.colonia,
        correo: $scope.quoteLista.correo,
        cotizacion_id: $scope.selected_quote.raw_response.id,
        cp: $scope.quoteLista.cp,
        edocivil: "1",
        env: "prod",
        lada: $scope.quoteLista.telefono.substr(0, 2),
        numero: $scope.quoteLista.telefono.slice(-8),
        numext: formPoliza.numeroexterior,
        numint: formPoliza.numerointerior,
        pnom: $scope.quoteLista.nombre,
        pob: $scope.quoteLista.poblacion,
        rfc: $scope.quoteLista.rfc.substr(0, 10),
        sexo: $scope.quoteLista.sexo,
        tipodir: "1",
        empresa: empresa,
      };
      $scope.registroChubb = true;
      // return
      $http
        .post($scope.URL_CHUBB + "registrar-fisica", formData, {
          headers: $scope.headers,
        })
        .then(
          function (response) {
            $scope.registroChubb = true;
          },
          function (error) {
            // En caso de error
            console.error(error);
          }
        );
    };

    $scope.emitirPoliza = function (formPoliza) {
      var empresa = $scope.empresa;
      var aseguradora = $scope.selected_quote.aseguradora;
      var fechaNacimiento = $scope.formatDate(
        $scope.quoteLista.fecha_nacimiento
      );
      var id_cotizacion = localStorage.getItem("id_cotizacion");
      // $scope.selected_quote.raw_response.id = 27234;
      $scope.policy = "";

      // ANA
      if ($scope.selected_quote.aseguradora == "ana") {
        var sexo = "";
        if ($scope.quoteLista.sexo == "F") {
          sexo = 2;
        } else {
          sexo = 1;
        }

        var formData = {
          calle: formPoliza.calle,
          colonia: formPoliza.colonia,
          correo: $scope.quoteLista.correo,
          cotizacion_id: $scope.selected_quote.raw_response.id,
          cp: $scope.quoteLista.cp,
          curp: formPoliza.curp,
          empresa: empresa,
          materno: $scope.quoteLista.apellido_materno,
          motor: formPoliza.motor,
          nombre: $scope.quoteLista.nombre,
          numeroexterior: formPoliza.numeroexterior,
          numerointerior: formPoliza.numerointerior,
          paterno: $scope.quoteLista.apellido_paterno,
          placas: formPoliza.placas,
          rfc: $scope.quoteLista.rfc,
          serie: formPoliza.serie,
          tipopersona: "1",
          telefono: $scope.quoteLista.telefono,
          fecha_nac: fechaNacimiento,
          sexo: sexo,
        };
      }

      // HDI
      if ($scope.selected_quote.aseguradora == "hdi") {
        var formData = {
          ApellidoMaterno: $scope.quoteLista.apellido_materno,
          ApellidoPaterno: $scope.quoteLista.apellido_paterno,
          calle: formPoliza.calle,
          colonia: formPoliza.colonia,
          cotizacion_id: $scope.selected_quote.raw_response.id,
          empresa: empresa,
          numeroExterior: formPoliza.numeroexterior,
          numeroInterior: formPoliza.numerointerior,
          numeroMotor: formPoliza.motor,
          numeroSerie: formPoliza.serie,
          placas: formPoliza.placas,
          PrimerNombre: $scope.quoteLista.nombre,
          regimenFiscal: formPoliza.regimenFiscal,
          RFC: $scope.quoteLista.rfc, //CAMBIAR POR EL NUEVO
          telefonoCasa: $scope.quoteLista.telefono,
          EstadoCivil: "S",
        };
      }
      if ($scope.selected_quote.aseguradora == "gnp") {
        // GNP
        var formData = {
          apellido_materno: $scope.quoteLista.apellido_materno,
          apellido_paterno: $scope.quoteLista.apellido_paterno,
          calle: formPoliza.calle,
          colonia: formPoliza.colonia,
          cotizacion_id: $scope.selected_quote.raw_response.id,
          // cotizacion_id:27234,
          email: $scope.quoteLista.correo,
          empresa: empresa,
          estado_civil: "S",
          motor: formPoliza.motor,
          nombre: $scope.quoteLista.nombre,
          numero_exterior: formPoliza.numeroexterior,
          numero_interior: formPoliza.numerointerior,
          numero_telefono: $scope.quoteLista.telefono.slice(-7),
          lada: $scope.quoteLista.telefono.substr(0, 3),
          placas: formPoliza.placas,
          razon_social: formPoliza.razon_social,
          regimen_fiscal: formPoliza.regimenFiscal,
          rfc: $scope.quoteLista.rfc,
          serie: formPoliza.serie,
          sexo: $scope.quoteLista.sexo,
          tipo_via: "AV",
        };
      }
      if ($scope.selected_quote.aseguradora == "chubb") {
        // CHUBB
        var formData = {
          // app: $scope.quoteLista.apellido_paterno,
          // apm: $scope.quoteLista.apellido_materno,
          // calle:formPoliza.calle,
          // col: $scope.quoteLista.colonia,
          // correo:$scope.quoteLista.correo,
          cotizacion_id: $scope.selected_quote.raw_response.id,
          // cp:  $scope.quoteLista.cp,
          // edocivil: '1',
          env: "prod",
          // lada:$scope.quoteLista.telefono.substr(0, 2),
          // numero: $scope.quoteLista.telefono.slice(-8),
          // numext:  formPoliza.numeroexterior,
          // numint:  formPoliza.numerointerior,
          // pnom:  $scope.quoteLista.nombre,
          // pob: $scope.quoteLista.poblacion,
          // rfc:  $scope.quoteLista.rfc.substr(0,10),
          // sexo:  $scope.quoteLista.sexo,
          // tipodir: '1',
          empresa: empresa,
          PLACAS: formPoliza.placas,
          MOTOR: formPoliza.motor,
          SERIE: formPoliza.serie,
        };
      }
      if ($scope.selected_quote.aseguradora == "ps") {
        // PRIMERO
        var formData = {
          aut_no_serie: formPoliza.serie,
          aut_placas: formPoliza.placas,
          cotizacion_id: $scope.selected_quote.raw_response.id,
          cte_apemat: $scope.quoteLista.apellido_materno,
          cte_apepat: $scope.quoteLista.apellido_paterno,
          cte_nombre: $scope.quoteLista.nombre,
          dir_calle_num: formPoliza.calle_numero,
          dir_col_id: formPoliza.colonia,
          email: $scope.quoteLista.correo,
          empresa: empresa,
          fecha_nacimiento: $scope.quoteLista.fecha_nacimiento,
          rfc: $scope.quoteLista.rfc, //CAMBIAR POR EL NUEVO
          sexo: $scope.quoteLista.sexo,
          tel_num: $scope.quoteLista.telefono,
        };
      }
      // momento
      if ($scope.selected_quote.aseguradora == "tumomento") {
        var formData = {
          empresa: empresa,
          name: $scope.quoteLista.nombre,
          lastName: $scope.quoteLista.apellido_paterno,
          secondLastName: $scope.quoteLista.apellido_materno,
          cotizacion_id: $scope.selected_quote.id_interno,
          serie: formPoliza.serie,
          placas: formPoliza.placas,
          numero_interior: formPoliza.numerointerior,
          numero_exterior: formPoliza.numeroexterior,
          calle: formPoliza.calle,
          colonia: formPoliza.colonia,
          email: $scope.quoteLista.correo,
          rfc: $scope.quoteLista.rfc,
          phone: $scope.quoteLista.telefono,
          // phone:  4444444445,
          // rfc: 'AAAJ970418GE3',
        };
      }
      if ($scope.selected_quote.aseguradora == "qualitas") {
        var formData = {
          motor: formPoliza.motor,
          serie: formPoliza.serie,
          nombre: $scope.quoteLista.nombre,
          apellido_paterno: $scope.quoteLista.apellido_paterno,
          apellido_materno: $scope.quoteLista.apellido_materno,
          cotizacion_id: $scope.selected_quote.raw_response.id,
          numero_exterior: formPoliza.numeroexterior,
          numero_interior: formPoliza.numerointerior,
          calle: formPoliza.calle,
          fecha_nacimiento: fechaNacimiento,
          rfc: $scope.quoteLista.rfc,
          telefono: $scope.quoteLista.telefono,
          empresa: empresa,
        };
      }
      var complementoUrl = "";

      switch (aseguradora) {
        case "ana":
          complementoUrl = "anaseguros";
          break;
        case "gnp":
          complementoUrl = "gnp";
          break;
        case "ps":
          complementoUrl = "ps";
          break;
        case "hdi":
          complementoUrl = "hdi";
          break;
        case "tumomento":
          complementoUrl = "tumomento";
          break;
        case "qualitas":
          complementoUrl = "qualitas";
          break;
        case "chubb":
          complementoUrl = "avantthya";
          break;
        default:
          break;
      }

      var url2_ = {
        MC2: "https://" + complementoUrl + "-" + $scope.urlApi + "/",
      };
      if (aseguradora == "tumomento") {
        var url2_ = {
          MC2: "https://" + complementoUrl + "-" + $scope.urlApiTm + "/",
        };
      }

      // console.log("Se enviara",formData);
      // console.log("Se enviara a",url2_.MC2);
      $scope.emisionVisible = false;
      $scope.loader = true;
      // return
      //   $scope.simularEmitirPoliza(
      //     function(response) {
      //         console.log(":::::::::::::::::::::::::::: POLIZA EMITIDA ::::::::::::::::::::::::::::");
      //         $scope.obtenerPoliza('enviar',$scope.selected_quote.aseguradora,$scope.selected_quote.raw_response.id);

      //       // 1) Actualiza selected_quote tal como antes
      //         $scope.selected_quote.impresion = response.poliza_pdf || true;

      //         // 2) Crea el payload mínimo
      //         var payload = { status: '2' };

      //         // 3) Inserta la cotización (ya trae 'impresion' dentro)
      //         var aseguradoraKey = $scope.selected_quote.aseguradora;   // ej. "ana", "qualitas"
      //         payload[aseguradoraKey] = JSON.stringify($scope.selected_quote);

      //         // 4) Envía
      //         $scope.guardarCotizacion(payload, url2_);
      //         // Assign data and update the state
      //         $scope.quoteCreated = response;
      //         $scope.resultadoPoliza = true;
      //         $scope.urlDownload = url2_.MC2;

      //         switch ($scope.selected_quote.aseguradora) {
      //             case 'ana':
      //                 // if (response.data &&
      //                 //     response.data.transacciones &&
      //                 //     response.data.transacciones.transaccion &&
      //                 //     response.data.transacciones.transaccion.poliza) {

      //                 //   var trx = response.data.transacciones.transaccion;
      //                 //   $scope.policy = trx.poliza['@id'];   // 04005342605000000

      //                 // } else {
      //                 //   console.error('Estructura inesperada:', response);
      //                 // }
      //                 // break;
      //                 if (response &&
      //                     response.transacciones &&
      //                     response.transacciones.transaccion &&
      //                     response.transacciones.transaccion.poliza) {

      //                   var trx = response.transacciones.transaccion;
      //                   $scope.policy = trx.poliza['@id'];   // 04005342605000000

      //                 } else {
      //                   console.error('Estructura inesperada:', response);
      //                 }
      //                 break;

      //             case 'chubb':
      //                 $scope.quoteCreated = response;
      //                 $scope.policy = response['POL']['CVE'] + ' ' + response['POL']['POL'];
      //                 break;
      //             case 'gnp':
      //                 $scope.quoteCreated = response;
      //                 $scope.policy = response['EMISION']['SOLICITUD']['NUM_POLIZA'];
      //                 break;
      //             case 'hdi':
      //                 $scope.policy = response.idPoliza;
      //                 $scope.quoteCreated = response;

      //                 break;
      //             case 'ps':
      //                 $scope.quoteCreated = response;
      //                 $scope.policy = response.pol_clave;
      //                 response.base64 = response.poliza_pdf;
      //                 $scope.filePdf = response.poliza_pdf;

      //                 break;
      //             case 'qualitas':
      //                 var mov = response.data.Movimientos.Movimiento;
      //                 $scope.quoteCreated.issue = response.data;
      //                 $scope.policy = mov['@NoPoliza'];
      //                 // $scope.quoteCreated = response.data.Movimiento;
      //                 // $scope.policy = response.data.Movimiento['@NoPoliza'];
      //                 $scope.obtenerPoliza('enviar',$scope.selected_quote.aseguradora,$scope.selected_quote.raw_response.id);
      //             break;
      //             default:
      //                 break;
      //         }

      //         if($scope.selected_quote.aseguradora != 'chubb' && $scope.selected_quote.aseguradora != 'tumomento'){
      //           if ($scope.quoteCreated.issue) {
      //               $scope.quoteCreated.issue.cotizacion_id = $scope.selected_quote.raw_response.id;
      //           } else {
      //               $scope.quoteCreated.issue = { cotizacion_id: $scope.selected_quote.raw_response.id };
      //           }
      //         }
      //         $scope.emisionVisible = false;
      //         $scope.loader = false;
      //         if($scope.selected_quote.aseguradora != 'tumomento' &&  $scope.selected_quote.aseguradora != 'ps'){
      //             $scope.cotizacion_id_emitido = $scope.quoteCreated.issue.cotizacion_id;
      //         }else if($scope.selected_quote.aseguradora == 'ps'){
      //             $scope.cotizacion_id_emitido = $scope.selected_quote.raw_response.id;
      //         }else{
      //             $scope.cotizacion_id_emitido = $scope.selected_quote.raw_response.id_interno;
      //         }
      //         console.log(":::::::::",$scope.quoteCreated)

      //         // $scope.crearTarea();
      //     },
      //     function(error) {
      //         console.error('Error en la emisión de la póliza:', error);
      //         SweetAlert.swal('Error', error.message || 'Ocurrió un error al emitir la póliza');
      //         $scope.emisionVisible = true;
      //         $scope.loader = false;
      //     }
      // );
      //   return
      $http
        .post(url2_.MC2 + "emitir", formData, { headers: $scope.headers })
        // $http.post('http://127.0.0.1:5000/emitir', formData, { headers: $scope.headers })
        .then(function (response) {
          console.log(response);
          // Verifica si la respuesta contiene un error
          if (response.data && response.data.error) {
            SweetAlert.swal("Error", response.data.error);
            $scope.emisionVisible = true;
            $scope.loader = false;
          } else if (
            response.data &&
            response.data.ERROR &&
            response.data.ERROR.DESCRIPCION
          ) {
            SweetAlert.swal("Error", response.data.ERROR.DESCRIPCION);
            $scope.emisionVisible = true;
            $scope.loader = false;
          } else if (response.data && response.data.errMsg) {
            SweetAlert.swal("Error", response.data.errMsg);
            $scope.emisionVisible = true;
            $scope.loader = false;
          } else if (aseguradora == "tumomento" && response.data.message) {
            SweetAlert.swal("Error", response.data.message);
            $scope.emisionVisible = true;
            $scope.loader = false;
          } else if (response.error) {
            SweetAlert.swal("Error", response.error);
            $scope.emisionVisible = true;
            $scope.loader = false;
          } else if (aseguradora == "ana" && response.data.message) {
            var errorText; // ← usa var en vez de let

            if (typeof response.data.message === "string") {
              errorText = response.data.message;
            } else if (
              typeof response.data.message === "object" &&
              response.data.message !== null
            ) {
              errorText = Object.values(response.data.message).join("\n");
            } else {
              errorText = "Ocurrió un error desconocido en la emisión.";
            }

            SweetAlert.swal("Error", errorText);
            $scope.emisionVisible = true;
            $scope.loader = false;
          } else {
            // console.log(":::::::::::::::::::::::::::: POLIZA EMITIDA ::::::::::::::::::::::::::::")
            $scope.quoteCreated = response.data;
            $scope.resultadoPoliza = true;
            $scope.urlDownload = url2_.MC2;

            switch ($scope.selected_quote.aseguradora) {
              case "ana":
                $scope.policy =
                  response.data.transacciones.transaccion.poliza["@id"];
                break;
              case "chubb":
                $scope.quoteCreated = response;
                $scope.policy =
                  response["POL"]["CVE"] + " " + response["POL"]["POL"];
                $scope.obtenerPoliza(
                  "enviar",
                  $scope.selected_quote.aseguradora,
                  $scope.selected_quote.raw_response.id
                );

                break;
              case "gnp":
                $scope.quoteCreated = response;
                $scope.policy = response["EMISION"]["SOLICITUD"]["NUM_POLIZA"];
                // $scope.obtenerPoliza('enviar',$scope.selected_quote.aseguradora,$scope.selected_quote.raw_response.id);

                break;

              case "hdi":
                // $scope.policy = response.data.idPoliza;
                $scope.policy = response.idPoliza;
                $scope.quoteCreated = response;
                break;
              case "ps":
                $scope.quoteCreated = response;
                $scope.policy = response.pol_clave;
                response.base64 = response.poliza_pdf;
                $scope.filePdf = response.poliza_pdf;
                break;
              case "qualitas":
                var mov = response.data.Movimientos.Movimiento;
                $scope.quoteCreated.issue = response.data;
                $scope.policy = mov["@NoPoliza"];
                // $scope.quoteCreated = response.data.Movimiento;
                // $scope.policy = response.data.Movimiento['@NoPoliza'];
                $scope.obtenerPoliza(
                  "enviar",
                  $scope.selected_quote.aseguradora,
                  $scope.selected_quote.raw_response.id
                );
                break;
              default:
                break;
            }

            // 1) Actualiza selected_quote tal como antes
            $scope.selected_quote.impresion = response.poliza_pdf || true;

            // 2) Crea el payload mínimo
            var payload = { status: "2" };

            // 3) Inserta la cotización (ya trae 'impresion' dentro)
            var aseguradoraKey = $scope.selected_quote.aseguradora; // ej. "ana", "qualitas"
            if (aseguradoraKey === "tumomento") {
              // 👉 ❌ NO serializamos           👉 llave: descr_tumomento
              payload["descr_" + aseguradoraKey] = selectedQuote;
            } else {
              // 👉 Sí serializamos             👉 llave: ana | qualitas | …
              payload[aseguradoraKey] = JSON.stringify(selectedQuote);
            }

            // 4) Envía
            $scope.guardarCotizacion(payload, url2_);

            // $scope.crearTarea();

            if ($scope.selected_quote.aseguradora != "chubb") {
              if ($scope.quoteCreated.issue) {
                $scope.quoteCreated.issue.cotizacion_id =
                  $scope.selected_quote.raw_response.id;
              } else {
                $scope.quoteCreated.issue = {
                  cotizacion_id: $scope.selected_quote.raw_response.id,
                };
              }
            }
            $scope.emisionVisible = false;
            $scope.loader = false;

            if (
              $scope.selected_quote.aseguradora != "tumomento" &&
              $scope.selected_quote.aseguradora != "ps"
            ) {
              $scope.cotizacion_id_emitido =
                $scope.quoteCreated.issue.cotizacion_id;
            } else if ($scope.selected_quote.aseguradora == "ps") {
              $scope.cotizacion_id_emitido =
                $scope.selected_quote.raw_response.id;
            } else {
              $scope.cotizacion_id_emitido =
                $scope.selected_quote.raw_response.id_interno;
            }
          }
        })
        .catch(function (err) {
          // Maneja los errores de la solicitud
          console.error("Error al emitir la cotización:", err);
          SweetAlert.swal("Error", "Error al emitir: " + err.message);
          $scope.emisionVisible = true;
          $scope.loader = false;
        });
    };
    $scope.guardarCotizacion = function (payload, url) {
      var id_cotizacion = localStorage.getItem("id_cotizacion");
      // var id_cotizacion = 5743;
      if (id_cotizacion) {
        return $http
          .patch(
            url_.MC + "cotizar/cotizaciones-unit/" + id_cotizacion + "/",
            payload,
            { headers: $scope.headers }
          )
          .then(function (response) {
            // console.log(response);
            return response.data;
          })
          .catch(function (err) {
            console.error("Error al guardar la cotización:", err);
            throw err;
          });
      }
    };

    $scope.formatDate = function (date) {
      if (!date) return "";
      var fecha = new Date(date);
      if (isNaN(fecha.getTime())) return "";
      var day = String(fecha.getUTCDate()).padStart(2, "0");
      var month = String(fecha.getUTCMonth() + 1).padStart(2, "0");
      var year = fecha.getUTCFullYear();
      return day + "/" + month + "/" + year;
    };

    $scope.formatCurrency = function (value) {
      var numberValue = parseFloat(value);
      if (isNaN(numberValue)) {
        return "";
      }

      return (
        "$" +
        numberValue.toLocaleString("es-MX", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    };
    $scope.formatCurrency = function (value) {
      var numberValue = parseFloat(value);
      if (isNaN(numberValue)) {
        return "";
      }

      return (
        "$" +
        numberValue.toLocaleString("es-MX", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    };
    $scope.regresarCotizaciones = function () {
      // console.log("ingreso")
      $scope.emisionVisible = false;
    };
    //   $scope.downloadMomento = function () {
    //     var data = {
    //         "empresa": "AndreaZamora",
    //         "cotizacion_id": 54
    //     };
    //     var url = 'http://127.0.0.1:8000/cotizar/convertir-archivo/';

    //     $http.get(url, { params: data, responseType: 'blob'  })
    //     .then(function(response) {
    //           var file = new Blob([response.data], { type: 'application/pdf' });
    //           var fileURL = URL.createObjectURL(file);
    //           window.open(fileURL);
    //           var downloadLink = document.createElement('a');
    //           downloadLink.href = fileURL;
    //           downloadLink.download = $scope.policy + '.pdf';
    //           downloadLink.click();
    //     }).catch(function(error) {
    //         console.error("Error al obtener el documento:", error);
    //     });
    // };

    $scope.downloadPdfGeneric = function (
      url,
      empresa,
      cotizacion_id,
      linkPath
    ) {
      if (!cotizacion_id) {
        console.error("Error: cotizacion_id no está definido.");
        $scope.loader = false;
        return;
      }
      var params = {
        empresa: empresa,
        cotizacion_id: cotizacion_id,
      };

      if (
        $scope.selected_quote.aseguradora === "hdi" ||
        $scope.selected_quote.aseguradora === "chubb" ||
        $scope.selected_quote.aseguradora === "tumomento"
      ) {
        // $http.get(url + 'imprimir', { params: params, responseType: 'arraybuffer' })
        $http
          .get(url + "imprimir", { params: params, responseType: "blob" })
          .then(function (response) {
            if ($scope.selected_quote.aseguradora == "hdi") {
              var file = new Blob([response.data], { type: "application/pdf" });
              var fileURL = URL.createObjectURL(file);
              window.open(fileURL);
              var downloadLink = document.createElement("a");
              downloadLink.href = fileURL;
              downloadLink.download = $scope.policy + ".pdf";
              downloadLink.click();
            } else if ($scope.selected_quote.aseguradora == "tumomento") {
              var file = new Blob([response.data], { type: "application/pdf" });
              var fileURL = URL.createObjectURL(file);

              var reader = new FileReader();
              reader.onload = function (e) {
                window.open(e.target.result);
              };

              reader.readAsDataURL(file);

              // Crear enlace de descarga
              var downloadLink = document.createElement("a");
              downloadLink.href = fileURL;
              downloadLink.download = $scope.policy + ".pdf";
              downloadLink.click();
            } else {
              var pdfUrl = response.data.PATHPDF;

              // Verifica si la URL está presente
              if (pdfUrl) {
                // Abre el archivo PDF en una nueva pestaña
                window.open(pdfUrl, "_blank");
              } else {
                console.error("No se ha proporcionado la URL del PDF.");
              }
            }
          })
          .then(function (blob) {
            $scope.filePdf = new File([blob], "documento.pdf", {
              type: "application/pdf",
            });
          })

          .catch(function (err) {
            console.error("Error al descargar PDF:", err);
            toastr.error(
              "Ocurrió un error al intentar descargar el PDF",
              "Error"
            );
          })
          .finally(function () {});
      } else if ($scope.selected_quote.aseguradora === "qualitas") {
        $http
          .post(url + "imprimir", params)
          .then(function (response) {
            var links = response.data.pdf;
            var linksArray = Object.values(links);

            // Reemplazo de find con un bucle for
            var link = null;
            for (var i = 0; i < linksArray.length; i++) {
              if (
                linksArray[i].indexOf(
                  "http://qbcenter.qualitas.com.mx/poliza/p"
                ) === 0
              ) {
                link = linksArray[i];
                break;
              }
            }

            if (link) {
              // Abrir el enlace en una nueva pestaña
              window.open(link, "_blank");
            } else {
              // Mostrar mensaje de error si no se encuentra el enlace
              toastr.error("Enlace del PDF no encontrado", "Error");
              console.error(
                "Error: No se encontró un enlace que cumpla con el criterio."
              );
            }
          })
          .catch(function (err) {
            console.error("Error al descargar PDF:", err);
            toastr.error(
              "Ocurrió un error al intentar descargar el PDF",
              "Error"
            );
          });
      } else {
        $http
          .get(url + "imprimir", { params: params })
          .then(function (response) {
            var link = linkPath.split(".").reduce(function (obj, key) {
              return obj && obj[key];
            }, response.data);

            if (link) {
              window.open(link, "_blank");
            } else {
              toastr.error("Enlace del PDF no encontrado", "Error");
              console.error("Error: No se encontró el enlace en la respuesta.");
            }
          })
          .catch(function (err) {
            console.error("Error al descargar PDF:", err);
            toastr.error(
              "Ocurrió un error al intentar descargar el PDF",
              "Error"
            );
          })
          .finally(function () {});
      }
    };
    function base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64); // Decodificar Base64 a una cadena binaria
      var length = binaryString.length;
      var bytes = new Uint8Array(length);

      // Convertir la cadena binaria en un Uint8Array
      for (var i = 0; i < length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer; // Retornar el ArrayBuffer
    }
    $scope.downloadPdfAna = function () {
      var cotizacionId =
        $scope.quoteCreated &&
        $scope.quoteCreated.issue &&
        $scope.quoteCreated.issue.cotizacion_id;

      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId, // Se pasa la variable cotizacionId
        "transacciones.transaccion.poliza.@link"
      );
    };
    $scope.downloadPdfQualitas = function () {
      var cotizacionId = $scope.selected_quote.raw_response.id;
      // var cotizacionId =  27908

      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId,
        "IM.PATHPDF"
      );
    };

    $scope.downloadPdfChubb = function () {
      var cotizacionId = $scope.selected_quote.raw_response.id;
      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId,
        "IM.PATHPDF"
      );
    };
    $scope.downloadPdfGnp = function () {
      var cotizacionId = $scope.selected_quote.raw_response.id;
      // var cotizacionId =28843;
      // $scope.urlDownload ='https://gnp-api.multicotizador.com/';

      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId,
        "RESULTADO.URL_DOCUMENTO"
      );
    };
    $scope.downloadPdfHdi = function () {
      var cotizacionId =
        $scope.quoteCreated && $scope.quoteCreated.cotizacion_id;
      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId,
        "",
        "blob"
      );
    };
    $scope.downloadPdfMomento = function () {
      // var cotizacionId = $scope.quoteCreated && $scope.quoteCreated && $scope.quoteCreated.cotizacion_id;
      var cotizacionId = $scope.selected_quote.raw_response.id_interno;

      $scope.downloadPdfGeneric(
        $scope.urlDownload,
        $scope.empresa,
        cotizacionId,
        "",
        "blob"
      );
    };
    $scope.downloadPdfPs = function (pdf) {
      $scope.loader = true;
      var linkSource = "data:application/pdf;base64," + pdf;
      var downloadLink = document.createElement("a");
      var fileName = $scope.policy + ".pdf";
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      $scope.loader = false;
    };
    $scope.enviarCotizacion = function (base64) {
      var quoteLista = localStorage.getItem("quote");
      var id_cot = localStorage.getItem("id_cotizacion");
      quoteLista = JSON.parse(quoteLista);
      console.log("quoteLista", quoteLista);
      var payload = {
        nombre: quoteLista.nombre + " " + quoteLista.apellido_materno,
        correo: quoteLista.correo,
        id: id_cot,
        origen: $scope.origen,
        asunto: "Resumen de cotizacion",
        base64: base64, // Archivo convertido a base64
      };
      $http({
        method: "POST",
        url:
          $scope.URL_MAIL_SERVICE +
          "mails/send-email-cotizacion-multicotizador/",
        data: payload, // Enviar el JSON
        headers: {
          "Content-Type": "application/json", // Importante: JSON puro
        },
      })
        .then(function (response) {
          console.log("Email enviado correctamente:", response.data);
          toaster.pop("success", "Éxito", "Correo enviado correctamente.");
        })
        .catch(function (error) {
          console.error("Error al enviar el email:", error);
          toaster.pop("error", "Error", "No se pudo enviar el correo.");
        });
    };
    $scope.verPDF = function (accion) {
      // Asegúrate de que jsPDF esté definido globalmente
      var jsPDF = window.jspdf ? window.jspdf.jsPDF : window.jsPDF; // Acceso seguro a jsPDF
      if ($scope.quotes) {
        // Filtra las cotizaciones para eliminar las que tienen error
        $scope.quotes = $scope.quotes.filter(function (quote) {
          return !quote.error;
        });
        $scope.data = $scope.quoteLista;
        var id_cotizacion = localStorage.getItem("id_cotizacion");

        var doc = new jsPDF();
        var headerColor = "#000A26";
        var textColor = "#FFFFFF";
        var logoPath = "../../assets/images/logos/b3a2868c-051.png";

        var img = new Image();
        img.src = logoPath;

        img.onload = function () {
          doc.setFillColor(headerColor);
          doc.rect(0, 0, doc.internal.pageSize.width, 16, "F"); // Dibuja el encabezado
          doc.setTextColor(textColor);
          doc.setFontSize(12);
          doc.text("Cotización " + id_cotizacion, 10, 10);

          var logoWidth = 60;
          var logoHeight = 10;
          var pageWidth = doc.internal.pageSize.width;

          // Añade la imagen al PDF

          doc.addImage(
            img,
            "PNG",
            pageWidth - logoWidth - 8,
            5,
            logoWidth,
            logoHeight
          );

          doc.setTextColor("#000000");
          doc.setFontSize(8);
          var textY = 30;

          // Determinar el género
          var sexoM = $scope.data.sexo === "M" ? "Masculino" : "Femenino";
          var paquete =
            $scope.data.paquete === "01"
              ? "Amplia"
              : $scope.data.paquete === "03"
              ? "Limitada"
              : $scope.data.paquete === "04"
              ? "RC"
              : "";
          var frecuencia =
            $scope.data.forma_de_pago === "C"
              ? "Contado"
              : $scope.data.forma_de_pago === "S"
              ? "Semestral"
              : $scope.data.forma_de_pago === "T"
              ? "Trimestral"
              : "Mensual";

          // Establecer fuente y texto en negrita para los encabezados
          doc.setFont("helvetica", "normal");
          doc.text("Nombre", 10, textY);
          doc.text("Marca", 90, textY);
          doc.text("Modelo", 140, textY);
          doc.text("Año", 180, textY);

          textY += 5;

          doc.setFontSize(12);
          doc.setFont("helvetica", "normal");
          doc.text(
            $scope.data.nombre +
              " " +
              $scope.data.apellido_paterno +
              " " +
              $scope.data.apellido_materno,
            10,
            textY
          );
          doc.text($scope.data.marca, 90, textY);
          doc.text($scope.data.submarca, 140, textY);
          doc.text($scope.data.modelo, 180, textY);
          // doc.text(sexoM, 60, textY);

          // Texto de notas con tamaño reducido

          textY += 7;

          // Restablecer el tamaño de la fuente para los siguientes encabezados
          doc.setFontSize(8);
          doc.setFont("helvetica", "nomal");
          doc.text("Género", 10, textY);
          doc.text("Fecha de nacimiento", 44, textY);
          // doc.text('C.P.', 60, textY);
          doc.text("Versión", 90, textY);

          // Incrementar posición de texto
          textY += 5;
          doc.setFontSize(12);
          var formattedDate = $scope.formatDate($scope.data.fecha_nacimiento);
          doc.setFont("helvetica", "normal");
          doc.text(sexoM, 10, textY);
          doc.text(formattedDate, 44, textY); // Descomentar si necesitas usar esta línea
          // doc.text($scope.data.cp, 60, textY);
          doc.text($scope.data.descripcion, 90, textY);

          textY += 7;
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.text("C.P.", 10, textY);
          doc.text("RFC", 44, textY);
          doc.text("Paquete", 90, textY);
          doc.text("Frecuencia", 140, textY);

          textY += 5;

          doc.setFont("helvetica", "normal");
          doc.setFontSize(12);
          doc.text($scope.data.cp, 10, textY);
          doc.text($scope.data.rfc, 44, textY);
          doc.text(paquete, 90, textY);
          doc.text(frecuencia, 140, textY);

          textY += 5;

          doc.setFontSize(6);
          doc.text("•Las cotizaciones tienen vigencia de 7 días.", 10, textY);
          doc.text(
            "•Se informa que en caso de que la unidad cuente con siniestro anterior a la protección de la unidad, este no será cubierto por la aseguradora.",
            10,
            textY + 4
          );

          // Tarjetas
          var cardWidth = 90; // Ancho de la tarjeta
          var cardHeight = 95; // Alto de la tarjeta
          var padding = 10; // Espaciado entre tarjetas

          var cardY = textY + 5; // Espacio inicial para las tarjetas
          var cardsPerPage = 0;

          // Función para cargar la imagen
          var loadImage = function (path) {
            return new Promise(function (resolve, reject) {
              var img = new Image();
              img.src = path;
              img.onload = function () {
                resolve(img);
              };
              img.onerror = function () {
                reject("Error loading image");
              };
            });
          };

          var loadImagesPromises = []; // Arreglo para las promesas de carga de imágenes
          for (var i = 0; i < $scope.quotes.length; i++) {
            var quote = $scope.quotes[i];
            if (cardsPerPage === 4) {
              doc.addPage();
              doc.setFillColor(headerColor);
              doc.rect(0, 0, doc.internal.pageSize.width, 16, "F");
              doc.setTextColor(textColor);
              doc.setFontSize(12);
              doc.text("Cotización " + id_cotizacion, 10, 10);

              cardY = 30;
              cardsPerPage = 0;
            }
            var cardX = cardsPerPage % 2 === 0 ? 10 : 110;

            // Cambiar por logo
            var logoText = quote.aseguradora;

            if (
              logoText === "qualitas" ||
              logoText === "ps" ||
              logoText === "tumomento"
            ) {
              logoText =
                logoText.charAt(0).toUpperCase() +
                logoText.slice(1).toLowerCase();
            } else {
              logoText = logoText.toUpperCase();
            }

            if (logoText === "Tumomento") {
              logoText = "tumomento";
            }

            var logoImg =
              "../../assets/images/providers/Logo_" + logoText + ".png";

            var cardX = cardsPerPage % 2 === 0 ? 10 : 110;

            var shadowOffset = 2;
            var shadowColor = "#B0B0B0";

            doc.setFillColor(shadowColor);
            doc.roundedRect(
              cardX + shadowOffset,
              cardY + shadowOffset,
              cardWidth,
              cardHeight,
              2,
              2,
              "F"
            );

            doc.setFillColor("#FFFFFF");
            doc.roundedRect(cardX, cardY, cardWidth, cardHeight, 2, 2, "F");

            doc.setFillColor("#214697");
            doc.roundedRect(
              cardX + 0.1,
              cardY,
              cardWidth - 0.14,
              10,
              2,
              2,
              "F"
            );

            doc.setTextColor("#FFFFFF");
            doc.setFontSize(9);
            doc.text("", cardX + 5, cardY + 7);

            doc.setDrawColor("#E0E0E0");
            doc.roundedRect(cardX, cardY, cardWidth, cardHeight, 2, 2, "S");

            var logoWidth = 17;
            var logoHeight = 10;
            doc.addImage(
              logoImg,
              "PNG",
              cardX + 2,
              cardY + 12,
              logoWidth,
              logoHeight
            );
            // Actualizar la posición Y y el contador de tarjetas
            // cardY += cardHeight + padding;

            // cardsPerPage++;
            // }).catch(function(error) {
            // }));
            // Qualitas
            if (
              quote.aseguradora.toLowerCase() === "qualitas" &&
              quote.coberturas
            ) {
              var descrHdi = $scope.data.descripcion || "";

              doc.setFont("helvetica", "bold");
              doc.setFontSize(7.5);
              doc.setTextColor("#FFFFFF");
              doc.text(descrHdi, cardX + logoWidth + 30, cardY + 7, {
                align: "center",
              });
              doc.setTextColor("#000000");
              doc.setFont("helvetica", "normal");
              doc.text("Total:", cardX + logoWidth + 20.5, cardY + 17);

              doc.setFontSize(8);
              doc.setFont("helvetica", "bold");
              var primaTotalFormatted = $scope.formatCurrency(
                quote.primas.PrimaTotal
              );
              doc.text(
                primaTotalFormatted,
                cardX + logoWidth + 35.5,
                cardY + 17
              );

              if ($scope.data.forma_de_pago !== "C") {
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text("Primer pago:", cardX + logoWidth + 10, cardY + 20);
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaPrimerFormatted = $scope.formatCurrency(
                  quote.recibos[0].PrimaTotal
                );
                doc.text(
                  primaPrimerFormatted,
                  cardX + logoWidth + 23,
                  cardY + 20
                );
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text(
                  "Siguientes pagos:",
                  cardX + logoWidth + 39,
                  cardY + 20
                );
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaSubFormatted = $scope.formatCurrency(
                  quote.recibos[1].PrimaTotal
                );
                doc.text(primaSubFormatted, cardX + logoWidth + 57, cardY + 20);
              }

              var tableStartY = cardY + 28;
              var tableRowHeight = 3.5;
              var tableWidth = cardWidth - 12;
              var columnWidths = [
                tableWidth * 0.5,
                tableWidth * 0.3,
                tableWidth * 0.2,
              ];

              var numberOfRows = quote.coberturas.length;
              var coverageY = tableStartY;

              doc.setDrawColor("#0474c4");
              doc.rect(
                cardX + 5,
                tableStartY - 5,
                tableWidth,
                numberOfRows * tableRowHeight + 5
              );
              for (var j = 0; j < numberOfRows; j++) {
                var coverage = quote.coberturas[j];
                doc.setFont("helvetica", "normal");
                doc.setFontSize(5);
                if (coverage.NoCobertura === "47") {
                  coverage.Cobertura = "RC Complementaria Personas";
                } else if (coverage.NoCobertura === "34") {
                  coverage.Cobertura = "RC en el Extranjero";
                }

                doc.text(coverage.Cobertura, cardX + 7, coverageY + 2.8);

                var formattedDeducible = parseInt(coverage.Deducible, 10);
                var finalDeducible = isNaN(formattedDeducible)
                  ? ""
                  : formattedDeducible;
                doc.text(
                  $scope.formatCurrency(coverage.SumaAsegurada),
                  cardX + columnWidths[0] + 12.5,
                  coverageY + 2.8
                );
                var textToDisplay = finalDeducible
                  ? finalDeducible + "%"
                  : "0 %";
                if (!textToDisplay) {
                  textToDisplay = 0;
                }
                doc.text(
                  textToDisplay,
                  cardX + columnWidths[0] + columnWidths[1] + 12.5,
                  coverageY + 2.8
                );

                doc.line(
                  cardX + 5,
                  coverageY,
                  cardX + tableWidth + 5,
                  coverageY
                );
                coverageY += tableRowHeight;
              }

              var lineYStart = tableStartY;
              var lineYEnd = coverageY;
              doc.line(
                cardX + columnWidths[0] + 10,
                lineYStart,
                cardX + columnWidths[0] + 10,
                lineYEnd
              );
              doc.line(
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYStart,
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYEnd
              );

              // Encabezados de tabla
              var headerX = cardX + 5;
              var headerY = cardY + 23;
              var headerHeight = 5.2;

              doc.setFillColor("#0474c4");
              doc.rect(headerX, headerY, columnWidths[0], headerHeight, "F");
              doc.setFont("helvetica", "bold");
              doc.setFontSize(5);
              doc.setTextColor("#FFFFFF");
              doc.text("Cobertura", headerX + 2, headerY + 3.5);

              var sumaAseguradaX = headerX + columnWidths[0];
              doc.setFillColor("#0474c4");
              doc.rect(
                sumaAseguradaX,
                headerY,
                columnWidths[1],
                headerHeight,
                "F"
              );
              doc.setTextColor("#FFFFFF");
              doc.text("Suma Asegurada", sumaAseguradaX + 7, headerY + 3.5);

              var deducibleX = sumaAseguradaX + columnWidths[1];
              doc.setFillColor("#0474c4");
              doc.rect(deducibleX, headerY, columnWidths[2], headerHeight, "F");
              doc.setTextColor("#FFFFFF");
              doc.text("Deducible", deducibleX + 5.5, headerY + 3.5);
            }

            // HDI
            if (quote.aseguradora.toLowerCase() === "hdi" && quote.coberturas) {
              var descrHdi = quote.descr_hdi || "";
              doc.setFont("helvetica", "bold");
              doc.setFontSize(7.5);
              doc.setTextColor("#ffffff");
              doc.text(descrHdi, cardX + logoWidth + 30, cardY + 7, {
                align: "center",
              });
              doc.setTextColor("#000000");
              doc.setFont("helvetica", "normal");
              doc.text("Total:", cardX + logoWidth + 20.5, cardY + 17);
              doc.setFontSize(13);
              doc.setFont("helvetica", "bold");
              var primaTotalFormatted = $scope.formatCurrency(
                quote.primas.PrimaTotal
              );
              doc.text(
                primaTotalFormatted,
                cardX + logoWidth + 35.5,
                cardY + 17
              );

              if ($scope.data.forma_de_pago !== "C") {
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text("Primer pago:", cardX + logoWidth + 10, cardY + 20);
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaPrimerFormatted = $scope.formatCurrency(
                  quote.recibos.PrimeraExhibicion
                );
                doc.text(
                  primaPrimerFormatted,
                  cardX + logoWidth + 23,
                  cardY + 20
                );
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text(
                  "Siguientes pagos:",
                  cardX + logoWidth + 39,
                  cardY + 20
                );
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaSubFormatted = $scope.formatCurrency(
                  quote.recibos.Importe
                );
                doc.text(primaSubFormatted, cardX + logoWidth + 57, cardY + 20);
              }

              var tableStartY = cardY + 28;
              var tableRowHeight = 3.5;
              var tableWidth = cardWidth - 12;
              var columnWidths = [
                tableWidth * 0.5,
                tableWidth * 0.3,
                tableWidth * 0.2,
              ];
              var numberOfRows = quote.coberturas.length;
              var coverageY = tableStartY;
              doc.setDrawColor("#0474c4");
              doc.rect(
                cardX + 5,
                tableStartY - 5,
                tableWidth,
                numberOfRows * tableRowHeight + 5
              );

              for (var j = 0; j < numberOfRows; j++) {
                var coverage = quote.coberturas[j];
                var Descripcion = coverage.Descripcion;
                var SumaAsegurada = coverage.SumaAsegurada;
                var Deducible = coverage.Deducible;

                doc.setFont("helvetica", "normal");
                doc.setFontSize(4.5);
                doc.text(Descripcion, cardX + 7, coverageY + 2.8);
                doc.text(
                  $scope.formatCurrency(SumaAsegurada),
                  cardX + columnWidths[0] + 12.5,
                  coverageY + 2.8
                );

                // if (Deducible !== '0.0') {
                doc.text(
                  Deducible + " %",
                  cardX + columnWidths[0] + columnWidths[1] + 12.5,
                  coverageY + 2.8
                );
                // }

                doc.line(
                  cardX + 5,
                  coverageY,
                  cardX + tableWidth + 5,
                  coverageY
                );
                coverageY += tableRowHeight;
              }

              var lineYStart = tableStartY;
              var lineYEnd = coverageY;
              doc.line(
                cardX + columnWidths[0] + 10,
                lineYStart,
                cardX + columnWidths[0] + 10,
                lineYEnd
              );
              doc.line(
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYStart,
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYEnd
              );

              // Table Headers
              var headerX = cardX + 5;
              var headerY = cardY + 23;
              var headerWidth = cardWidth - 46;
              var headerHeight = 5.2;
              doc.setFillColor("#0474c4");
              doc.rect(headerX, headerY, headerWidth, headerHeight, "F");
              doc.setFont("helvetica", "bold");
              doc.setFontSize(5);
              doc.setTextColor("#FFFFFF");
              doc.text("Cobertura", headerX + 2, headerY + 3.5);

              var sumaAseguradaX = headerX + headerWidth;
              doc.setFillColor("#0474c4");
              doc.rect(
                sumaAseguradaX,
                headerY,
                columnWidths[1],
                headerHeight,
                "F"
              );
              doc.setTextColor("#FFFFFF");
              doc.text("Suma Asegurada", sumaAseguradaX + 2, headerY + 3.5);

              var deducibleX = sumaAseguradaX + columnWidths[1];
              doc.setFillColor("#0474c4");
              doc.rect(
                deducibleX - 5,
                headerY,
                columnWidths[2],
                headerHeight,
                "F"
              );
              doc.setTextColor("#FFFFFF");
              doc.text("Deducible", deducibleX + 1.5, headerY + 3.5);
            }

            // ANA
            if (quote.aseguradora.toLowerCase() === "ana" && quote.coberturas) {
              var descrHdi = quote.descr_ana || "";
              doc.setFont("helvetica", "bold");
              doc.setFontSize(7);
              doc.setTextColor("#FFFFFF");
              doc.text(descrHdi, cardX + logoWidth + 30, cardY + 7, {
                align: "center",
              });
              doc.setTextColor("#000000");
              doc.setFont("helvetica", "normal");
              doc.text("Total:", cardX + logoWidth + 20.5, cardY + 17);
              doc.setFontSize(13);
              doc.setFont("helvetica", "bold");
              var primaTotalFormatted = $scope.formatCurrency(
                quote.primas.PTOTAL
              );
              doc.text(
                primaTotalFormatted,
                cardX + logoWidth + 35.5,
                cardY + 17
              );

              if ($scope.data.forma_de_pago !== "C") {
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text("Primer pago:", cardX + logoWidth + 10, cardY + 20);
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaPrimerFormatted = $scope.formatCurrency(
                  quote.recibos[0]["@primatotal"]
                );
                doc.text(
                  primaPrimerFormatted,
                  cardX + logoWidth + 23,
                  cardY + 20
                );
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text(
                  "Siguientes pagos:",
                  cardX + logoWidth + 39,
                  cardY + 20
                );
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaSubFormatted = $scope.formatCurrency(
                  quote.recibos[1]["@primatotal"]
                );
                doc.text(primaSubFormatted, cardX + logoWidth + 57, cardY + 20);
              }

              var tableStartY = cardY + 28;
              var tableRowHeight = 3.5;
              var tableWidth = cardWidth - 12;
              var columnWidths = [
                tableWidth * 0.5,
                tableWidth * 0.3,
                tableWidth * 0.2,
              ];
              var numberOfRows = quote.coberturas.length;
              var coverageY = tableStartY;
              doc.setDrawColor("#0474c4");
              doc.rect(
                cardX + 5,
                tableStartY - 5,
                tableWidth,
                numberOfRows * tableRowHeight + 5
              );

              for (var j = 0; j < numberOfRows; j++) {
                var coverage = quote.coberturas[j];
                doc.setFont("helvetica", "normal");
                doc.setFontSize(4);
                doc.text(coverage.desc, cardX + 7, coverageY + 2.8);

                var formattedDeducible = parseInt(coverage.ded, 10);
                var finalDeducible = isNaN(formattedDeducible)
                  ? ""
                  : formattedDeducible;
                doc.text(
                  coverage.sa,
                  cardX + columnWidths[0] + 15,
                  coverageY + 2.8
                );
                if (finalDeducible !== "") {
                  doc.text(
                    finalDeducible + " %",
                    cardX + columnWidths[0] + columnWidths[1] + 12.5,
                    coverageY + 2.8
                  );
                }

                doc.line(
                  cardX + 5,
                  coverageY,
                  cardX + tableWidth + 5,
                  coverageY
                );
                coverageY += tableRowHeight;
              }

              var lineYStart = tableStartY;
              var lineYEnd = coverageY;
              doc.line(
                cardX + columnWidths[0] + 14.5,
                lineYStart,
                cardX + columnWidths[0] + 14.5,
                lineYEnd
              );
              doc.line(
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYStart,
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYEnd
              );

              // Encabezados de tabla
              var headerX = cardX + 5;
              var headerY = cardY + 23;
              var headerHeight = 5.2;
              doc.setFillColor("#0474c4");
              doc.rect(headerX, headerY, columnWidths[0], headerHeight, "F");
              doc.setFont("helvetica", "bold");
              doc.setFontSize(5);
              doc.setTextColor("#FFFFFF");
              doc.text("Cobertura", headerX + 2, headerY + 3.5);

              var sumaAseguradaX = headerX + columnWidths[0];
              doc.setFillColor("#0474c4");
              doc.rect(
                sumaAseguradaX,
                headerY,
                columnWidths[1],
                headerHeight,
                "F"
              );
              doc.setTextColor("#FFFFFF");
              doc.text("Suma Asegurada", sumaAseguradaX + 11, headerY + 3.5);

              var deducibleX = sumaAseguradaX + columnWidths[1];
              doc.setFillColor("#0474c4");
              doc.rect(deducibleX, headerY, columnWidths[2], headerHeight, "F");
              doc.setTextColor("#FFFFFF");
              doc.text("Deducible", deducibleX + 5.5, headerY + 3.5);
            }

            // GNP
            if (quote.aseguradora.toLowerCase() === "gnp" && quote.coberturas) {
              var descrGnp = quote.descr_gnp || "";
              doc.setFont("helvetica", "bold");
              doc.setFontSize(7);
              doc.setTextColor("#FFFFFF");
              doc.text(descrGnp, cardX + logoWidth + 30, cardY + 7, {
                align: "center",
              });
              doc.setTextColor("#000000");
              doc.setFont("helvetica", "normal");
              doc.text("Total:", cardX + logoWidth + 20.5, cardY + 17);
              doc.setFontSize(13);
              doc.setFont("helvetica", "bold");
              if (quote.primas && quote.primas.TOTAL_PAGAR) {
                var primaTotalFormatted = $scope.formatCurrency(
                  quote.primas.TOTAL_PAGAR
                );
                doc.text(
                  primaTotalFormatted,
                  cardX + logoWidth + 35.5,
                  cardY + 17
                );
              }
              if ($scope.data.forma_de_pago !== "C") {
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text("Primer pago:", cardX + logoWidth + 10, cardY + 20);
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaPrimerFormatted = $scope.formatCurrency(
                  quote.recibos.PRIMER_RECIBO
                );
                doc.text(
                  primaPrimerFormatted,
                  cardX + logoWidth + 23,
                  cardY + 20
                );
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text(
                  "Siguientes pagos:",
                  cardX + logoWidth + 39,
                  cardY + 20
                );
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaSubFormatted = $scope.formatCurrency(
                  quote.recibos.RECIBO_SUBSECUENTE
                );
                doc.text(primaSubFormatted, cardX + logoWidth + 57, cardY + 20);
              }

              var tableStartY = cardY + 28;
              var tableRowHeight = 3.5;
              var tableWidth = cardWidth - 12;
              var columnWidths = [
                tableWidth * 0.5,
                tableWidth * 0.3,
                tableWidth * 0.2,
              ];
              var numberOfRows = quote.coberturas.length;
              var coverageY = tableStartY;
              doc.setDrawColor("#0474c4");
              doc.rect(
                cardX + 5,
                tableStartY - 5,
                tableWidth,
                numberOfRows * tableRowHeight + 5
              );

              for (var j = 0; j < numberOfRows; j++) {
                var coverage = quote.coberturas[j];
                doc.setFont("helvetica", "normal");
                doc.setFontSize(4);
                doc.text(coverage.NOMBRE, cardX + 7, coverageY + 2.8);

                var deducible = coverage.DEDUCIBLE;
                var finalDeducible = isNaN(deducible)
                  ? deducible
                  : deducible + " %";

                // finalDeducible = finalDeducible ? String(finalDeducible) : finalDeducible;
                var sumaAsegurada = coverage.SUMA_ASEGURADA;
                var sumaAseguradaFormatted = isNaN(sumaAsegurada)
                  ? sumaAsegurada
                  : $scope.formatCurrency(sumaAsegurada);

                doc.text(
                  sumaAseguradaFormatted,
                  cardX + columnWidths[0] + 12.5,
                  coverageY + 2.8
                );
                doc.text(
                  finalDeducible,
                  cardX + columnWidths[0] + columnWidths[1] + 12.5,
                  coverageY + 2.8
                );

                doc.line(
                  cardX + 5,
                  coverageY,
                  cardX + tableWidth + 5,
                  coverageY
                );
                coverageY += tableRowHeight;
              }

              var lineYStart = tableStartY;
              var lineYEnd = coverageY;
              doc.line(
                cardX + columnWidths[0] + 10,
                lineYStart,
                cardX + columnWidths[0] + 10,
                lineYEnd
              );
              doc.line(
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYStart,
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYEnd
              );

              // Encabezados de tabla
              var headerX = cardX + 5;
              var headerY = cardY + 23;
              var headerWidth = cardWidth - 46;
              var headerHeight = 5.2;
              doc.setFillColor("#0474c4");
              doc.rect(headerX, headerY, headerWidth, headerHeight, "F");
              doc.setFont("helvetica", "bold");
              doc.setFontSize(5);
              doc.setTextColor("#FFFFFF");
              doc.text("Cobertura", headerX + 2, headerY + 3.5);

              var sumaAseguradaX = headerX + headerWidth;
              var sumaAseguradaY = headerY;
              var sumaAseguradaWidth = cardWidth - headerWidth - 23;
              var sumaAseguradaHeight = headerHeight;

              doc.setFillColor("#0474c4");
              doc.rect(
                sumaAseguradaX,
                sumaAseguradaY,
                sumaAseguradaWidth,
                sumaAseguradaHeight,
                "F"
              );

              var sumaAseguradaTextX = sumaAseguradaX + 2;
              var sumaAseguradaTextY = sumaAseguradaY + 3.5;
              doc.setFont("helvetica", "bold");
              doc.setFontSize(5);
              doc.setTextColor("#FFFFFF");
              doc.text(
                "Suma Asegurada",
                sumaAseguradaTextX,
                sumaAseguradaTextY
              );

              var deducibleX = sumaAseguradaX + sumaAseguradaWidth;
              var deducibleY = headerY;
              var deducibleWidth = cardWidth * 0.255 - 12;
              var deducibleHeight = headerHeight;

              doc.setFillColor("#0474c4");
              doc.rect(
                deducibleX,
                deducibleY,
                deducibleWidth,
                deducibleHeight,
                "F"
              );

              var deducibleTextX = deducibleX + 1.5;
              var deducibleTextY = deducibleY + 3.5;
              doc.text("Deducible", deducibleTextX, deducibleTextY);
            }

            // PS
            if (quote.aseguradora.toLowerCase() === "ps" && quote.coberturas) {
              var descrHdi = quote.descr_ps || "";
              doc.setFont("helvetica", "bold");
              doc.setFontSize(7);
              doc.setTextColor("#FFFFFF");
              doc.text(descrHdi, cardX + logoWidth + 30, cardY + 7, {
                align: "center",
              });

              doc.setTextColor("#000000");
              doc.setFont("helvetica", "normal");
              doc.text("Total:", cardX + logoWidth + 20.5, cardY + 17);

              doc.setFontSize(13);
              doc.setFont("helvetica", "bold");
              var primaTotalFormatted = $scope.formatCurrency(
                quote.primas.prima_total
              );
              doc.text(
                primaTotalFormatted,
                cardX + logoWidth + 35.5,
                cardY + 17
              );

              if ($scope.data.forma_de_pago !== "C") {
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text("Primer pago:", cardX + logoWidth + 10, cardY + 20);
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaPrimerFormatted = $scope.formatCurrency(
                  quote.recibos.primer_recibo
                );
                doc.text(
                  primaPrimerFormatted,
                  cardX + logoWidth + 23,
                  cardY + 20
                );
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text(
                  "Siguientes pagos:",
                  cardX + logoWidth + 39,
                  cardY + 20
                );
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaSubFormatted = $scope.formatCurrency(
                  quote.recibos.recibo_subsecuente
                );
                doc.text(primaSubFormatted, cardX + logoWidth + 57, cardY + 20);
              }

              var tableStartY = cardY + 28;
              var tableRowHeight = 3.5;
              var tableWidth = cardWidth - 12;
              var columnWidths = [
                tableWidth * 0.5,
                tableWidth * 0.3,
                tableWidth * 0.2,
              ];
              var numberOfRows = quote.coberturas.length;
              var coverageY = tableStartY;

              doc.setDrawColor("#0474c4");
              doc.rect(
                cardX + 5,
                tableStartY - 5,
                tableWidth,
                numberOfRows * tableRowHeight + 5
              );

              var coverageDescriptions = {
                DM: "Daños Materiales",
                RED: "Reducible",
                RT: "Robo Total",
                RCTBP: "Responsabilidad Civil Por Daños A Terceros Bienes Y",
                DJUR: "Defensa Juridica",
                NPD: "No Pago De Deducible Por Pérdida Total Por Daños",
                GV: "Gestoría Vial",
                RCUSA: "Responsabilidad Civil En El Extranjero Ee.Uu.",
                EXCRCP: "Extensión Responsabilidad Civil",
                AS: "Auto Sustituto",
                GMO: "Gastos Médicos Ocupantes",
                ASVI: "Asistencia Vial",
              };

              for (var j = 0; j < numberOfRows; j++) {
                var coverage = quote.coberturas[j];
                var id = coverage.id;
                var dsc_sa = coverage.dsc_sa;
                var dsd_ded = coverage.dsc_ded;

                doc.setFont("helvetica", "normal");
                doc.setFontSize(4.8);

                var coverageDescription = coverageDescriptions[id] || id;
                doc.text(coverageDescription, cardX + 7, coverageY + 2.8);

                var formattedDeducible = parseInt(dsd_ded, 10);
                var finalDeducible = isNaN(formattedDeducible)
                  ? ""
                  : formattedDeducible;
                if (finalDeducible !== "") {
                  doc.text(
                    finalDeducible + " %",
                    cardX + columnWidths[0] + columnWidths[1] + 12.5,
                    coverageY + 2.8
                  );
                } else {
                  finalDeducible = "";
                }

                doc.text(
                  dsc_sa,
                  cardX + columnWidths[0] + 12.5,
                  coverageY + 2.8
                );
                // doc.text(finalDeducible, cardX + columnWidths[0] + columnWidths[1] + 12.5, coverageY + 2.8);
                doc.line(
                  cardX + 5,
                  coverageY,
                  cardX + tableWidth + 5,
                  coverageY
                );
                coverageY += tableRowHeight;
              }

              var lineYStart = tableStartY;
              var lineYEnd = coverageY;
              doc.line(
                cardX + columnWidths[0] + 10,
                lineYStart,
                cardX + columnWidths[0] + 10,
                lineYEnd
              );
              doc.line(
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYStart,
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYEnd
              );

              var headerX = cardX + 5;
              var headerY = cardY + 23;
              var headerWidth = cardWidth - 46;
              var headerHeight = 5.2;

              doc.setFillColor("#0474c4");
              doc.rect(headerX, headerY, headerWidth, headerHeight, "F");

              doc.setFont("helvetica", "bold");
              doc.setFontSize(6);
              doc.setTextColor("#FFFFFF");
              doc.text("Cobertura", headerX + 2, headerY + 3.5);

              var sumaAseguradaX = headerX + headerWidth;
              var sumaAseguradaY = headerY;
              var sumaAseguradaWidth = cardWidth - headerWidth - 23;
              var sumaAseguradaHeight = headerHeight;

              doc.setFillColor("#0474c4");
              doc.rect(
                sumaAseguradaX,
                sumaAseguradaY,
                sumaAseguradaWidth,
                sumaAseguradaHeight,
                "F"
              );

              var sumaAseguradaTextX = sumaAseguradaX + 2;
              var sumaAseguradaTextY = sumaAseguradaY + 3.5;
              doc.text(
                "Suma Asegurada",
                sumaAseguradaTextX,
                sumaAseguradaTextY
              );

              var deducibleX = sumaAseguradaX + sumaAseguradaWidth;
              var deducibleY = headerY;
              var deducibleWidth = cardWidth * 0.255 - 12;
              var deducibleHeight = headerHeight;

              doc.setFillColor("#0474c4");
              doc.rect(
                deducibleX,
                deducibleY,
                deducibleWidth,
                deducibleHeight,
                "F"
              );

              var deducibleTextX = deducibleX + 1.5;
              var deducibleTextY = deducibleY + 3.5;
              doc.text("Deducible", deducibleTextX, deducibleTextY);
            }

            // TUMOMENTO
            if (
              quote.aseguradora.toLowerCase() === "tumomento" &&
              quote.coberturas
            ) {
              var descrHdi = quote.request_xml["vehicle"]["version"] || "";
              doc.setFont("helvetica", "bold");
              doc.setFontSize(7);
              doc.setTextColor("#FFFFFF");
              doc.text(descrHdi, cardX + logoWidth + 30, cardY + 7, {
                align: "center",
              });

              doc.setTextColor("#000000");
              doc.setFont("helvetica", "normal");
              doc.text("Total:", cardX + logoWidth + 20.5, cardY + 17);

              doc.setFontSize(13);
              doc.setFont("helvetica", "bold");
              var primaTotalFormatted = $scope.formatCurrency(quote.prima);
              doc.text(
                primaTotalFormatted,
                cardX + logoWidth + 35.5,
                cardY + 17
              );

              if ($scope.data.forma_de_pago !== "C") {
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text("Primer pago:", cardX + logoWidth + 10, cardY + 20);
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaPrimerFormatted = $scope.formatCurrency(quote.prima);
                doc.text(
                  primaPrimerFormatted,
                  cardX + logoWidth + 23,
                  cardY + 20
                );
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text(
                  "Siguientes pagos:",
                  cardX + logoWidth + 39,
                  cardY + 20
                );
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaSubFormatted = $scope.formatCurrency(quote.prima);
                doc.text(primaSubFormatted, cardX + logoWidth + 57, cardY + 20);
              }

              var selectedCoberturas = quote.coberturas.filter(function (
                coverage
              ) {
                return coverage.selected;
              });

              var tableStartY = cardY + 28;
              var tableRowHeight = 3.5;
              var tableWidth = cardWidth - 12;
              var columnWidths = [
                tableWidth * 0.5,
                tableWidth * 0.3,
                tableWidth * 0.2,
              ];
              var numberOfRows = selectedCoberturas.length;
              var coverageY = tableStartY;

              doc.setDrawColor("#0474c4");
              doc.rect(
                cardX + 5,
                tableStartY - 5,
                tableWidth,
                numberOfRows * tableRowHeight + 5
              );

              var coverageDescriptions = {
                occupant_medical_expenses: "Gastos Médicos Ocupantes",
                personal_civil_liability: "Responsabilidad Civil Personal",
                personal_civil_liability_death:
                  "Responsabilidad Civil Personal Fallecimiento",
                property_civil_liability: "Responsabilidad Civil Propiedad",
                material_damage: "Daños Materiales",
                total_theft: "Robo Total",
                partial_theft: "Robo Parcial",
                driver_death: "Fallecimiento Conductor",
                legal_expenses: "Gastos Legales",
                roadside_assistance: "Asistencia Vial",
              };

              for (var j = 0; j < numberOfRows; j++) {
                var coverage = selectedCoberturas[j];
                var peril = coverage.peril;
                var insuredSum = coverage.insuredSum;
                var deductible = coverage.deductible;

                doc.setFont("helvetica", "normal");
                doc.setFontSize(4.8);

                var coverageDescription = coverageDescriptions[peril] || peril;
                doc.text(coverageDescription, cardX + 7, coverageY + 2.8);

                // doc.text(insuredSum, cardX + columnWidths[0] + 12.5, coverageY + 2.8);

                var formattedDeducible = parseInt(deductible, 10);
                var finalDeducible = isNaN(formattedDeducible)
                  ? ""
                  : formattedDeducible;
                if (finalDeducible !== "") {
                  doc.text(
                    finalDeducible + " %",
                    cardX + columnWidths[0] + columnWidths[1] + 12.5,
                    coverageY + 2.8
                  );
                }

                doc.line(
                  cardX + 5,
                  coverageY,
                  cardX + tableWidth + 5,
                  coverageY
                );
                coverageY += tableRowHeight;
              }

              var lineYStart = tableStartY;
              var lineYEnd = coverageY;
              doc.line(
                cardX + columnWidths[0] + 10,
                lineYStart,
                cardX + columnWidths[0] + 10,
                lineYEnd
              );
              doc.line(
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYStart,
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYEnd
              );

              var headerX = cardX + 5;
              var headerY = cardY + 23;
              var headerWidth = cardWidth - 46;
              var headerHeight = 5.2;

              doc.setFillColor("#0474c4");
              doc.rect(headerX, headerY, headerWidth, headerHeight, "F");

              doc.setFont("helvetica", "bold");
              doc.setFontSize(6);
              doc.setTextColor("#FFFFFF");
              doc.text("Cobertura", headerX + 2, headerY + 3.5);

              var sumaAseguradaX = headerX + headerWidth;
              var sumaAseguradaY = headerY;
              var sumaAseguradaWidth = cardWidth - headerWidth - 23;
              var sumaAseguradaHeight = headerHeight;

              doc.setFillColor("#0474c4");
              doc.rect(
                sumaAseguradaX,
                sumaAseguradaY,
                sumaAseguradaWidth,
                sumaAseguradaHeight,
                "F"
              );

              var sumaAseguradaTextX = sumaAseguradaX + 2;
              var sumaAseguradaTextY = sumaAseguradaY + 3.5;
              doc.text(
                "Suma Asegurada",
                sumaAseguradaTextX,
                sumaAseguradaTextY
              );

              var deducibleX = sumaAseguradaX + sumaAseguradaWidth;
              var deducibleY = headerY;
              var deducibleWidth = cardWidth * 0.255 - 12;
              var deducibleHeight = headerHeight;

              doc.setFillColor("#0474c4");
              doc.rect(
                deducibleX,
                deducibleY,
                deducibleWidth,
                deducibleHeight,
                "F"
              );

              var deducibleTextX = deducibleX + 1.5;
              var deducibleTextY = deducibleY + 3.5;
              doc.text("Deducible", deducibleTextX, deducibleTextY);
            }
            // chubb
            if (
              quote.aseguradora.toLowerCase() === "chubb" &&
              quote.coberturas
            ) {
              var descrHdi = quote.DESC || "";
              doc.setFont("helvetica", "bold");
              doc.setFontSize(7);
              doc.setTextColor("#FFFFFF");
              doc.text(descrHdi, cardX + logoWidth + 30, cardY + 7, {
                align: "center",
              });

              doc.setTextColor("#000000");
              doc.setFont("helvetica", "normal");
              doc.text("Total:", cardX + logoWidth + 20.5, cardY + 17);
              doc.setFontSize(13);
              doc.setFont("helvetica", "bold");

              var primaTotalFormatted = $scope.formatCurrency(
                quote.primas.PTOTAL
              );
              doc.text(
                primaTotalFormatted,
                cardX + logoWidth + 35.5,
                cardY + 17
              );

              if ($scope.data.forma_de_pago !== "C") {
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text("Primer pago:", cardX + logoWidth + 10, cardY + 20);
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaPrimerFormatted = $scope.formatCurrency(
                  quote.recibos.RECIBO[0].PTOTAL
                );
                doc.text(
                  primaPrimerFormatted,
                  cardX + logoWidth + 23,
                  cardY + 20
                );
                doc.setFontSize(6);
                doc.setFont("helvetica", "normal");
                doc.text(
                  "Siguientes pagos:",
                  cardX + logoWidth + 39,
                  cardY + 20
                );
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                var primaSubFormatted = $scope.formatCurrency(
                  quote.recibos.RECIBO[1].PTOTAL
                );
                doc.text(primaSubFormatted, cardX + logoWidth + 57, cardY + 20);
              }

              var selectedCoberturas = quote.coberturas.filter(function (
                coverage
              ) {
                return coverage.SEL === "1";
              });

              var tableStartY = cardY + 28;
              var tableRowHeight = 3.5;
              var tableWidth = cardWidth - 12;
              var columnWidths = [
                tableWidth * 0.5,
                tableWidth * 0.3,
                tableWidth * 0.2,
              ];
              var numberOfRows = selectedCoberturas.length;
              var coverageY = tableStartY;

              doc.setDrawColor("#0474c4");
              doc.rect(
                cardX + 5,
                tableStartY - 5,
                tableWidth,
                numberOfRows * tableRowHeight + 5
              );

              for (var j = 0; j < numberOfRows; j++) {
                var coverage = selectedCoberturas[j];
                if (coverage) {
                  doc.setFont("helvetica", "normal");
                  doc.setFontSize(4);
                  doc.text(coverage.DESC, cardX + 7, coverageY + 2.8);

                  var deducible = coverage.DEDESC;
                  var formattedDeducible = deducible
                    ? parseFloat(deducible.replace("%", "").trim())
                    : null;
                  var finalDeducible = isNaN(formattedDeducible)
                    ? ""
                    : formattedDeducible;

                  // finalDeducible = finalDeducible ? String(finalDeducible) : finalDeducible;
                  var sumaAsegurada = coverage.SUMAASEG;
                  var sumaAseguradaFormatted = isNaN(sumaAsegurada)
                    ? sumaAsegurada
                    : $scope.formatCurrency(sumaAsegurada);

                  doc.text(
                    sumaAseguradaFormatted,
                    cardX + columnWidths[0] + 12.5,
                    coverageY + 2.8
                  );
                  if (finalDeducible) {
                    doc.text(
                      finalDeducible + " %",
                      cardX + columnWidths[0] + columnWidths[1] + 12.5,
                      coverageY + 2.8
                    );
                  }
                  doc.line(
                    cardX + 5,
                    coverageY,
                    cardX + tableWidth + 5,
                    coverageY
                  );
                  coverageY += tableRowHeight;
                }
              }
              var lineYStart = tableStartY;
              var lineYEnd = coverageY;
              doc.line(
                cardX + columnWidths[0] + 10,
                lineYStart,
                cardX + columnWidths[0] + 10,
                lineYEnd
              );
              doc.line(
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYStart,
                cardX + columnWidths[0] + columnWidths[1] + 10,
                lineYEnd
              );

              // Encabezados de tabla
              var headerX = cardX + 5;
              var headerY = cardY + 23;
              var headerWidth = cardWidth - 46;
              var headerHeight = 5.2;
              doc.setFillColor("#0474c4");
              doc.rect(headerX, headerY, headerWidth, headerHeight, "F");
              doc.setFont("helvetica", "bold");
              doc.setFontSize(5);
              doc.setTextColor("#FFFFFF");
              doc.text("Cobertura", headerX + 2, headerY + 3.5);

              var sumaAseguradaX = headerX + headerWidth;
              var sumaAseguradaY = headerY;
              var sumaAseguradaWidth = cardWidth - headerWidth - 23;
              var sumaAseguradaHeight = headerHeight;

              doc.setFillColor("#0474c4");
              doc.rect(
                sumaAseguradaX,
                sumaAseguradaY,
                sumaAseguradaWidth,
                sumaAseguradaHeight,
                "F"
              );

              var sumaAseguradaTextX = sumaAseguradaX + 2;
              var sumaAseguradaTextY = sumaAseguradaY + 3.5;
              doc.setFont("helvetica", "bold");
              doc.setFontSize(5);
              doc.setTextColor("#FFFFFF");
              doc.text(
                "Suma Asegurada",
                sumaAseguradaTextX,
                sumaAseguradaTextY
              );

              var deducibleX = sumaAseguradaX + sumaAseguradaWidth;
              var deducibleY = headerY;
              var deducibleWidth = cardWidth * 0.255 - 12;
              var deducibleHeight = headerHeight;

              doc.setFillColor("#0474c4");
              doc.rect(
                deducibleX,
                deducibleY,
                deducibleWidth,
                deducibleHeight,
                "F"
              );

              var deducibleTextX = deducibleX + 1.5;
              var deducibleTextY = deducibleY + 3.5;
              doc.text("Deducible", deducibleTextX, deducibleTextY);
            }

            if (cardsPerPage % 2 === 1) {
              cardY += cardHeight + padding;
            }
            cardsPerPage++;
          }

          // Pie de página
          var pageHeight = doc.internal.pageSize.height;
          doc.setFillColor(headerColor);
          doc.rect(0, pageHeight - 20, doc.internal.pageSize.width, 20, "F");
          doc.setTextColor(textColor);
          doc.setFontSize(8);
          doc.text("Desarrollado por Miurabox 2024", 10, pageHeight - 10);

          // Centrar el texto "Andrea Zamora" en el medio de la página
          doc.text(
            "Andrea Zamora \n \n Seguros / Mesa de control",
            pageWidth / 2,
            pageHeight - 12,
            { align: "center" }
          );

          // Ajustar el texto del contacto a la derecha
          doc.text(
            "mesadecontrol@grupogpi.mx \n \n (442) 239 2837",
            pageWidth - 10,
            pageHeight - 12,
            { align: "right" }
          );

          // Espera a que todas las imágenes estén cargadas antes de guardar el PDF
          Promise.all(loadImagesPromises).then(function () {
            if (accion === 1) {
              // Descargar el PDF
              doc.save("cotizacion.pdf");
            } else {
              // Enviar el PDF por correo
              var pdfBase64 = doc.output("datauristring").split(",")[1]; // Elimina el encabezado del URI
              $scope.enviarCotizacion(pdfBase64);
            }
          });
        };
      }
    };

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }

  function carsModal($scope, $uibModalInstance, models, $rootScope, service) {
    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    };

    $rootScope.new_service = service;
    $scope.models_data = [];

    for (var mdl in models) {
      $scope.models_data.push({ model: mdl, data: models[mdl] });
    }

    $scope.new_car = {};

    $scope.sendData = function () {
      $rootScope.new_car_model = {
        model_desc: $scope.new_car.version.name,
        model_id: $scope.new_car.version.value,
      };

      $rootScope.new_model = true;

      $uibModalInstance.close();
    };

    if ($stateParams) {
      $scope.quote.visible = true;
      $scope.quote.request_emit = null;
      $scope.insurance_selected = null;
      $window.localStorage.removeItem("insurance_selected");
    }
  }
})();

app.controller(
  "CoveragesModalController",
  function ($scope, $uibModalInstance, coveragesData) {
    $scope.coverages = coveragesData;

    $scope.cancel = function () {
      $uibModalInstance.dismiss("cancel");
    };
  }
);

app.controller(
  "CarsModal",
  function (
    $scope,
    $sessionStorage,
    $http,
    url,
    $uibModalInstance,
    parItem,
    wsService,
    SweetAlert
  ) {
    $scope.data = parItem;
    $scope.aseguradora = $scope.data.aseguradora;
    $scope.provider = $scope.data.aseguradora;
    $scope.infoForm = JSON.parse(localStorage.getItem("quote"));
    $scope.urlApi = "-api.multicotizador.com";
    $scope.urlGateway = "https://apigatewaymc.multicotizador.com/";
    $scope.urlSocket =
      "wss://apigatewaymc.multicotizador.com/ws/notificaciones/";
    var orgName =
      $sessionStorage.user &&
      $sessionStorage.infoUser.org &&
      $sessionStorage.infoUser.org.name;
    $scope.org_name = orgName;
    if ($scope.org_name == "pruebas" || $scope.org_name == "gpi") {
      $scope.empresa = "AndreaZamora";
    }
    var complementoUrl = "";
    switch ($scope.aseguradora) {
      case "ana":
        complementoUrl = "anaseguros";
        break;
      case "gnp":
        complementoUrl = "gnp";
        break;
      case "ps":
        complementoUrl = "ps";
        break;
      case "hdi":
        complementoUrl = "hdi";
        break;
      case "chubb":
        complementoUrl = "avantthya";
        break;
      case "tumomento":
        complementoUrl = "tumomento";
        break;
      default:
        break;
    }
    // mandar a otro archivo unas vez terminadas las pruebas

    var url_ = {
      MC: "https://" + complementoUrl + $scope.urlApi + "/",
      MCG: $scope.urlGateway,
    };
    if ($scope.aseguradora == "tumomento") {
      var url_ = {
        MC: "https://" + complementoUrl + "-ms.multicotizador.com/",
        MCG: $scope.urlGateway,
      };
    }
    $scope.car = {
      years: [],
      types: [],
      brands: [],
      versions: [],
    };

    // Obtener tipos de autos
    $scope.getCarTypes = function (aseguradora, url, empresa) {
      var params = { empresa: empresa };
      if (aseguradora == "chubb") {
        url =
          url +
          "/" +
          $scope.empresa +
          "/" +
          $scope.new_car.brand.id +
          "/" +
          $scope.new_car.model.id +
          "/" +
          $scope.new_car.year.id;
      }
      $http
        .get(url_.MC + url, { params: params })
        .then(function success(response) {
          if (aseguradora == "ana") {
            var models = response.data.transacciones.categoria;
            models = models.map(function (item) {
              return {
                descripcion: item["#text"],
                id: item["@id"],
              }; // Asegúrate de que el punto y coma esté aquí correctamente
            });
            // $scope.car.types.push(...models);
            $scope.car.types = $scope.car.types.concat(models);
          } else if (aseguradora == "hdi") {
            var types = response.data;
            types.forEach(function (item) {
              $scope.car.types.push({ descripcion: item.descr, id: item.id });
            });
          } else if (aseguradora == "tumomento") {
            var types = response.data;
            types.forEach(function (item) {
              $scope.car.types.push({ descripcion: item.name, id: item.id });
            });
          } else if (aseguradora == "chubb") {
            var types = response.data;
            types.forEach(function (item) {
              $scope.car.types.push({
                descripcion: item.descripcion,
                id: item.id,
              });
            });
          }
        })
        .catch(function (error) {
          console.log("Error - get-car-types:", error);
          SweetAlert.swal(
            "Error",
            "Error al obtener tipos de autos: " + error.message
          );
        });
    };

    // Obtener años del auto
    $scope.getCarYear = function (aseguradora, url, empresa) {
      if (aseguradora === "gnp") {
        params = {
          marca: $scope.new_car.brand.id,
          submarca: $scope.new_car.model.id,
        };
      } else if (aseguradora === "hdi") {
        params = {
          tipo: $scope.new_car.type.id,
          marca: $scope.new_car.brand.id,
          submarca: $scope.new_car.model.id,
        };
      } else if (aseguradora === "chubb") {
        params = {
          empresa: $scope.empresa,
          marca: $scope.new_car.brand.descripcion,
          submarca: $scope.new_car.model.descripcion,
        };
      } else if (aseguradora === "tumomento") {
        params = {
          empresa: $scope.empresa,
          marca: $scope.new_car.brand.id,
          submarca: $scope.new_car.model.id,
        };
      } else {
        params = { empresa: empresa };
      }
      if (aseguradora === "chubb") {
        $http
          .post(url_.MC + url, params, { headers: $scope.headers })
          .then(function success(response) {
            if (aseguradora === "ana") {
              var models = response.data.transacciones.modelo;
              models.forEach(function (item) {
                $scope.car.years.push({ descripcion: item, id: item });
              });
            } else if (aseguradora === "gnp") {
              $scope.car.years = response.data;
            } else if (aseguradora === "chubb") {
              var models = response.data;
              models.forEach(function (item) {
                $scope.car.years.push({ descripcion: item, id: item });
              });
            } else if (aseguradora === "hdi" || aseguradora === "tumomento") {
              var models = response.data;
              models.forEach(function (item) {
                $scope.car.years.push({
                  descripcion: item,
                  id: parseInt(item),
                });
              });
              $scope.new_car.year = parseInt($scope.infoForm.modelo);
              $scope.getVersions("hdi", "vehiculos");

              // $scope.isYearDisabled = true;
            }
          })
          .catch(function (error) {
            console.log("Error - get-car-year:", error);
            SweetAlert.swal(
              "Error",
              "Error al obtener años del auto: " + error.message
            );
          });
      } else {
        $http
          .get(url_.MC + url, { params: params })
          .then(function success(response) {
            if (aseguradora === "ana") {
              var models = response.data.transacciones.modelo;
              models.forEach(function (item) {
                $scope.car.years.push({ descripcion: item, id: item });
              });
            } else if (aseguradora === "gnp") {
              $scope.car.years = response.data;
            } else if (aseguradora === "hdi" || aseguradora === "tumomento") {
              var models = response.data;
              models.forEach(function (item) {
                $scope.car.years.push({
                  descripcion: item,
                  id: parseInt(item),
                });
              });
              $scope.new_car.year = parseInt($scope.infoForm.modelo);
              $scope.getVersions("hdi", "vehiculos");

              // $scope.isYearDisabled = true;
            }
          })
          .catch(function (error) {
            console.log("Error - get-car-year:", error);
            SweetAlert.swal(
              "Error",
              "Error al obtener años del auto: " + error.message
            );
          });
      }
    };
    $scope.sendData = function () {
      if (!$scope.new_car || !$scope.new_car.version) {
        SweetAlert.swal("Error", "Selecciona una versión válida", "error");
        return;
      }

      $uibModalInstance.close($scope.new_car.version); // ← aquí se cierra correctamente el modal
    };

    // Obtener marcas de autos
    $scope.getCarBrands = function (aseguradora, url) {
      if (aseguradora === "ana") {
        params = {
          modelo: $scope.new_car.year.id,
          categoria: $scope.new_car.type.id,
          empresa: $scope.empresa,
        };
      } else if (aseguradora === "ps") {
        params = {
          empresa: $scope.empresa,
          tipoVehiculo: "01",
        };
      } else if (aseguradora === "hdi") {
        params = {
          tipo: $scope.new_car.type.id,
        };
      } else if (aseguradora === "tumomento") {
        params = {
          empresa: $scope.empresa,
        };
      } else {
        params = {
          empresa: $scope.empresa,
        };
      }

      $http
        .get(url_.MC + url, { params: params })
        .then(function success(response) {
          $scope.car = $scope.car || {};
          if (aseguradora === "gnp") {
            var brandsTmp = response.data;
            brandsTmp.forEach(function (item) {
              if (item.descr) {
                $scope.car.brands.push({
                  descripcion: item.descr,
                  id: item.id,
                });
              }
            });
          } else if (aseguradora === "hdi") {
            var brandsTmp = response.data;
            brandsTmp.forEach(function (item) {
              if (item.descr) {
                $scope.car.brands.push({
                  descripcion: item.descr,
                  id: item.id,
                });
              }
            });
          } else if (aseguradora === "ps") {
            var brandsTmp = response.data;
            brandsTmp.forEach(function (item) {
              if (item.marca) {
                $scope.car.brands.push({
                  descripcion: item.marca,
                  id: item.idMarca,
                });
              }
            });
          } else if (aseguradora === "ana") {
            var brandsTmp = response.data.transacciones.marca;
            brandsTmp = brandsTmp.map(function (item) {
              return {
                descripcion: item["#text"],
                id: item["@id"],
              };
            });
            // $scope.car.brands.push(...brandsTmp);
            $scope.car.brands = $scope.car.brands.concat(brandsTmp);
          } else if (aseguradora === "tumomento") {
            var brandsTmp = response.data;
            brandsTmp.forEach(function (item) {
              if (item.name) {
                $scope.car.brands.push({ descripcion: item.name, id: item.id });
              }
            });
          } else if (aseguradora === "chubb") {
            var brandsTmp = response.data;
            brandsTmp.forEach(function (item) {
              if (item.descripcion) {
                $scope.car.brands.push({
                  descripcion: item.descripcion,
                  id: item.id,
                });
              }
            });
          }
        })
        .catch(function (error) {
          console.error("Error al obtener las marcas de autos:", error);
          SweetAlert.swal(
            "Error",
            "Error al obtener marcas de autos: " + error.message
          );
        });
    };

    // Obtener modelos de autos
    $scope.getCarModels = function (aseguradora, url) {
      $scope.car.models = [];
      if (aseguradora === "gnp") {
        params = { marca: $scope.new_car.brand.id };
      } else if (aseguradora === "hdi") {
        params = {
          marca: $scope.new_car.brand.id,
          tipo: $scope.new_car.type.id,
        };
      } else if (aseguradora === "ps") {
        params = {
          marcaVehiculo: $scope.new_car.brand.id,
          empresa: $scope.empresa,
        };
      } else if (aseguradora === "ana") {
        params = {
          modelo: $scope.new_car.year.id,
          empresa: $scope.empresa,
          categoria: $scope.new_car.type.id,
          marca: $scope.new_car.brand.id,
        };
      } else if (aseguradora === "chubb") {
        url = url + "/" + $scope.empresa + "/" + $scope.new_car.brand.id;
        params = { marca: $scope.new_car.brand.id };
      } else if (aseguradora === "tumomento") {
        params = {
          empresa: $scope.empresa,
          marca: $scope.new_car.brand.id,
        };
      }

      $http
        .get(url_.MC + url, { params: params })
        .then(function success(response) {
          if (aseguradora === "gnp") {
            var modelsTmp = response.data;
            modelsTmp.forEach(function (item) {
              if (item.descr) {
                $scope.car.models.push({
                  descripcion: item.descr,
                  id: item.id,
                });
              }
            });
          } else if (aseguradora === "hdi") {
            var modelsTmp = response.data;
            modelsTmp.forEach(function (item) {
              if (item) {
                $scope.car.models.push({ descripcion: item, id: item });
              }
            });
          } else if (aseguradora === "ps") {
            var modelsTmp = response.data;
            modelsTmp.forEach(function (item) {
              if (item.subMarca) {
                $scope.car.models.push({
                  descripcion: item.subMarca,
                  id: item.idSubMarca,
                });
              }
            });
          } else if (aseguradora === "chubb") {
            var modelsTmp = response.data;
            modelsTmp.forEach(function (item) {
              if (item) {
                $scope.car.models.push({
                  descripcion: item.descripcion,
                  id: item.id,
                });
              }
            });
          } else if (aseguradora === "tumomento") {
            var modelsTmp = response.data;
            modelsTmp.forEach(function (item) {
              if (item) {
                $scope.car.models.push({ descripcion: item.name, id: item.id });
              }
            });
          } else if (aseguradora === "ana") {
            var modelsTmp = response.data.transacciones.submarca;
            modelsTmp = modelsTmp.map(function (item) {
              return {
                descripcion: item["#text"],
                id: item["@clave"],
              };
            });
            // $scope.car.models.push(...modelsTmp);
            $scope.car.models = $scope.car.models.concat(modelsTmp);
          }
        })
        .catch(function (error) {
          console.log("Error - get-car-model:", error);
          SweetAlert.swal(
            "Error",
            "Error al obtener modelos de autos: " + error.message
          );
        });
    };

    // Obtener versiones de autos
    $scope.getVersions = function (aseguradora, url) {
      if (aseguradora === "gnp") {
        params = {
          marca: $scope.new_car.brand.id,
          submarca: $scope.new_car.model.id,
          modelo: $scope.new_car.year,
        };
      } else if (aseguradora === "ps") {
        params = {
          marcaVehiculo: $scope.new_car.brand.id,
          subMarcaVehiculo: $scope.new_car.model.id,
          anio: $scope.infoForm.modelo,
          tipoVehiculo: "01",
          empresa: empresa,
        };
      } else if (aseguradora === "ana") {
        params = {
          modelo: $scope.new_car.year.id,
          categoria: $scope.new_car.type.id,
          marca: $scope.new_car.brand.id,
          submarca: $scope.new_car.model.id,
          empresa: $scope.empresa,
        };
      } else if (aseguradora === "hdi") {
        params = {
          tipo: $scope.new_car.type.id,
          marca: $scope.new_car.brand.id,
          submarca: $scope.new_car.model.id,
          modelo: $scope.infoForm.modelo,
        };
      } else if (aseguradora === "tumomento") {
        params = {
          empresa: empresa,
          marca: $scope.new_car.brand.id,
          submarca: $scope.new_car.model.id,
          modelo: $scope.new_car.year.id,
        };
      } else if (aseguradora === "chubb") {
        url =
          url +
          "/" +
          empresa +
          "/" +
          $scope.new_car.model2.id +
          "/" +
          $scope.new_car.year.id;
      }
      $http
        .get(url_.MC + url, { params: params })
        .then(function success(response) {
          if (aseguradora === "gnp") {
            var versions = response.data;
            versions.forEach(function (item) {
              $scope.car.versions.push({
                descripcion: item.descr,
                id: item.clave,
              });
            });
          } else if (aseguradora === "ps") {
            var versions = response.data;
            versions.forEach(function (item) {
              $scope.car.versions.push({
                descripcion: item.version,
                id: item.clave,
              });
            });
          } else if (aseguradora === "hdi") {
            var versions = response.data;
            versions.forEach(function (item) {
              $scope.car.versions.push({
                descripcion: item.version,
                id: item.id,
              });
            });
          } else if (aseguradora === "tumomento") {
            var versions = response.data;
            versions.forEach(function (item) {
              $scope.car.versions.push({
                descripcion: item.description,
                id: item.id,
              });
            });
          } else if (aseguradora === "chubb") {
            var versions = response.data;
            versions.forEach(function (item) {
              $scope.car.versions.push({
                descripcion: item.descripcion,
                id: item.id,
              });
            });
          } else if (aseguradora === "ana") {
            var versions = response.data.transacciones.vehiculo;
            versions = versions.map(function (item) {
              return {
                descripcion: item["#text"],
                id: item["@clave"],
              };
            });
            // $scope.car.versions.push(...versions);
            $scope.car.versions = $scope.car.versions.concat(versions);
          }
        })
        .catch(function (error) {
          console.log("Error - get-car-version:", error);
          SweetAlert.swal(
            "Error",
            "Error al obtener versiones de autos: " + error.message
          );
        });
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss("cancel");
    };
    $scope.closeModal = function () {
      $uibModalInstance.close();
    };

    switch ($scope.aseguradora) {
      case "ana":
        $scope.getCarTypes($scope.aseguradora, "categorias", $scope.empresa);
        $scope.getCarYear($scope.aseguradora, "modelos", $scope.empresa);
        break;
      case "gnp":
      case "ps":
        $scope.getCarBrands($scope.aseguradora, "marcas", $scope.empresa);
        break;
      case "chubb":
        $scope.getCarBrands(
          $scope.aseguradora,
          "marcas/" + $scope.empresa,
          $scope.empresa
        );
        break;
      case "hdi":
        $scope.getCarTypes($scope.aseguradora, "tipos", $scope.empresa);
        break;
      case "tumomento":
        $scope.getCarTypes($scope.aseguradora, "tipos", $scope.empresa);
        $scope.getCarBrands($scope.aseguradora, "marcas", $scope.empresa);
        break;
    }
  }
);

var app = angular.module("inspinia").directive("uiDate", function () {
  return {
    require: "?ngModel",
    link: function ($scope, element, attrs, controller) {
      element.mask("00/00/0000");
    },
  };
});

(function () {
  "use strict";

  angular.module("inspinia").controller("SelectAddressCtrl", SelectAddressCtrl);

  SelectAddressCtrl.$inject = [
    "direcciones",
    "$uibModalInstance",
    "pdfService",
    "insuranceData",
    "toaster",
    "$scope",
  ];

  function SelectAddressCtrl(
    direcciones,
    $uibModalInstance,
    pdfService,
    insuranceData,
    toaster,
    $scope
  ) {
    var svm = this;
    svm.loading = true;
    svm.direcciones = [];
    $scope.item;
    svm.actions = {
      cancel: function () {
        $uibModalInstance.close(1);
      },
      download: function () {
        // if(!svm.selected){
        //  return; // TODO TOAST ERROR
        //}
        var aux = $scope.item;
        var insurance = angular.copy(insuranceData);
        insurance.dirIndex = $scope.item.index;

        pdfService.getPdf({ insuranceData: insurance, open: false });
        $uibModalInstance.close(1);
      },
      open: function () {
        //if(!svm.selected){
        //  return; // TODO TOAST ERROR
        // }
        var insurance = angular.copy(insuranceData);
        insurance.dirIndex = $scope.item.index;

        pdfService.getPdf({ insuranceData: insurance, open: true });
        $uibModalInstance.close(1);
      },
    };

    activate();

    function activate() {
      svm.loading = true;
      if (direcciones.length == 0) {
        toaster.error("El contratante no tiene direcciones asignadas");
        $uibModalInstance.close(1);
        return;
      }
      svm.direcciones = [];

      direcciones.forEach(function (direccion) {
        var dir = angular.copy(direccion);

        dir.label =
          "Estado: " +
          direccion.administrative_area_level_1 +
          " Ciudad: " +
          direccion.administrative_area_level_2 +
          " Domicilio: " +
          direccion.route +
          " Numero: " +
          direccion.street_number +
          " Int: " +
          direccion.street_number_int;

        svm.direcciones.push(dir);
      });

      svm.loading = false;
    }
  }
})();

(function () {
  angular.module("inspinia").factory("modalService", modalService);

  modalService.$inject = [
    "$sessionStorage",
    "$http",
    "$uibModal",
    "$q",
    "insuranceService",
    "$ocLazyLoad",
    "moduleInjection",
    "pdfService",
    "$rootScope",
  ];

  function modalService(
    $sessionStorage,
    $http,
    $uibModal,
    $q,
    insuranceService,
    $ocLazyLoad,
    moduleInjection,
    pdfService,
    $rootScope
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var service = {
      defaultPath: defaultPath,
      infoModal: infoModal,
      renewModal: renewModal,
      editModal: editModal,
      // dirModal: dirModal,
      receiptsModal: receiptsModal,
      receiptChangeStatus: receiptChangeStatus,
      pathFinder: pathFinder,
    };

    return service;
    var isAModalOpen = false;

    function defaultPath(data) {
      var dfd = $q.defer();

      // console.log('data', data);
      // data = {};

      if (!data.myInsurance) {
        //////console.log("No insurance");
        return;
      }

      // insuranceService.getInsuranceData(data.myInsurance)
      //   .then(function(response) {
      //     if (!(response)) {
      //       return;
      //     }
      // data.insuranceData = response;
      data.insuranceData = data;
      // console.log('data', data);
      pathFinder(data, 1)
        .catch(modalClose)
        .then(function (response) {
          //////console.log("pathFinder Done")
          // console.log('response', response);
          dfd.resolve(response);
        });
      // });

      function modalClose(reason) {
        dfd.reject("Modal closed: " + reason);
      }

      function isWrong(res) {
        if (res.status < 200 || res.status >= 300) {
          dfd.reject("Bad response: " + res);
          return true;
        }
        return false;
      }

      return dfd.promise;
    }

    function pathFinder(dataRaw, goTo) {
      var dfd = $q.defer();
      validateInsuranceData(dataRaw).then(function (data) {
        if (isAModalOpen) {
          dfd.reject("A modal was already oppened");
        } else if (goTo == 200) {
          //ok
          dfd.resolve("All done");
        } else if (goTo == 1) {
          // Info Modal
          isAModalOpen = true;
          infoModal(data).then(thenWhat).catch(catchIt);
        } else if (goTo == 2) {
          // Edit Modal
          isAModalOpen = true;
          editModal(data).then(thenWhat).catch(catchIt);
        } else if (goTo == 3) {
          // Renew Modal
          isAModalOpen = true;

          renewModal(data).then(thenWhat).catch(catchIt);
        } else if (goTo == 5) {
          // modal Receipt
          isAModalOpen = true;
          receiptsModal(data).then(thenWhat).catch(catchIt);
        } else if (goTo == 6) {
          isAModalOpen = true;
          receiptChangeStatus(data).then(thenWhat).catch(catchIt);
        } else if (goTo == 7) {
          isAModalOpen == true;
          previewToRenew(data).then(thenWhat).catch(catchIt);
        } else {
          //////console.log("Wrong action: ", goTo);
          dfd.reject("Wrong action: " + goTo);
        }

        function thenWhat(action) {
          isAModalOpen = false;
          if (action == 200) {
            // all done
            dfd.resolve("All done");
          } else {
            if (action) {
              var theData = action.data ? action.data : data;
              var theAction = action.action ? action.action : action;

              pathFinder(theData, theAction)
                .catch(catchIt)
                .then(function (result) {
                  //////console.log("result",result);
                  dfd.resolve(result);
                });
            }
          }
        }

        function catchIt(data2) {
          isAModalOpen = false;
          dfd.reject(data2);
        }
      });

      return dfd.promise;
    }

    function previewToRenew(data) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/renovaciones/renovaciones.modal.html",
        controller: "RenewalModalCtrl",
        ////windowClass: 'animated fadeIn',
        size: "lg",
        resolve: {
          user: function () {
            return usr;
          },
          myPolicy: function () {
            return data.myInsurance;
          },
        },
      });

      return modalInstance.result;
    }

    function receiptChangeStatus(data) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        ////windowClass: 'animated fadeIn',
        resolve: {
          receipt: function () {
            return angular.copy(data.receipt);
          },
          from: function () {
            return angular.copy(data.from);
          },
          bono: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (receipt) {
          return modalInstance.result;
        },
        function () {
          return modalInstance.result;
        }
      );
      return modalInstance.result;
    }

    function receiptsModal(data) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/modals/modal.receipts.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        ////windowClass: 'animated fadeIn',
        size: "lg",
      });
      return modalInstance.result;
    }

    function infoModal(data) {
      if (data.insuranceData) {
        var modalInstance = $uibModal.open({
          templateUrl: "app/modals/modal.overview.html",
          controller: "modalOverview",
          controllerAs: "vm",
          ////windowClass: 'animated fadeIn',
          size: "lg",
          resolve: {
            user: function () {
              return usr;
            },
            myInsurance: function () {
              return data.myInsurance;
            },
            container: function () {
              return data.container;
            },
            insuranceData: function () {
              // return data.myInsurance;
              return data.insuranceData;
            },
          },
        });
        return modalInstance.result;
      } else {
        insuranceService
          .getInsuranceData(data.myInsurance)
          .then(function (response) {
            if (!response) {
              return;
            }
            data.insuranceData = response;
            var modalInstance = $uibModal.open({
              templateUrl: "app/modals/modal.overview.html",
              controller: "modalOverview",
              controllerAs: "vm",
              ////windowClass: 'animated fadeIn',
              size: "lg",
              resolve: {
                myInsurance: function () {
                  return data.myInsurance;
                },
                container: function () {
                  return data.container;
                },
                insuranceData: function () {
                  return data.insuranceData;
                },
              },
            });
            return modalInstance.result;
          });
      }
    }

    function editModal(data) {
      var dfd = $q.defer();
      // console.log('demo');

      if (!data.insuranceData) {
        insuranceService
          .getInsuranceData(data.myInsurance)
          .then(function (response) {
            data.insuranceData = response;
            var modalInstance = $uibModal.open({
              templateUrl: "app/modals/modal.editOT.html",
              controller: "OrderEditCtrl",
              controllerAs: "order",
              ////windowClass: 'animated fadeIn',
              size: "lg",
              resolve: {
                loadPlugin: function ($ocLazyLoad) {
                  return $ocLazyLoad.load([moduleInjection.toaster]);
                },
                myInsurance: function () {
                  return data.myInsurance;
                },
                container: function () {
                  return data.container;
                },
                insuranceData: function () {
                  return data.insuranceData;
                },
              },
            });

            modalInstance.result
              .then(function (response) {
                dfd.resolve(response);
              })
              .catch(function (response) {
                dfd.reject(response);
              });
          })
          .catch(function (response) {
            dfd.reject(response);
          });
      } else {
        var modalInstance = $uibModal.open({
          templateUrl: "app/modals/modal.editOT.html",
          controller: "OrderEditCtrl",
          controllerAs: "order",
          ////windowClass: 'animated fadeIn',
          size: "lg",
          resolve: {
            loadPlugin: function ($ocLazyLoad) {
              return $ocLazyLoad.load([moduleInjection.toaster]);
            },
            myInsurance: function () {
              return data.myInsurance;
            },
            container: function () {
              return data.container;
            },
            insuranceData: function () {
              return data.insuranceData;
            },
          },
        });

        modalInstance.result
          .then(function (response) {
            dfd.resolve(response);
          })
          .catch(function (response) {
            dfd.reject(response);
          });
      }

      return dfd.promise;
    }

    function validateData(data) {
      var dfd = $q.defer();
      if (data.insuranceData) {
        dfd.resolve(data);
      } else {
        insuranceService
          .getInsuranceData(data.myInsurance)
          .then(function (insuranceData) {
            data.insuranceData = insuranceData;
            dfd.resolve(data);
          })
          .catch(function (error) {
            dfd.reject(error);
          });
      }

      return dfd.promise;
    }

    // Arreglo con las direcciones
    // function dirModal(data) {
    //   var dfd = $q.defer();

    //   validateData(data)
    //     .then(function(data) {
    //       ////console.log('dataDir' , data)
    //       var array = data.insuranceData.natural ? data.insuranceData.natural.address_natural : data.insuranceData.juridical.address_juridical;
    //       var type = data.insuranceData.natural ? 1 : 2;
    //       var direcciones = [];
    //       var modalInstance;
    //       var allpromises = []; // promesas por cada nueva direccion

    //       array.forEach(function(address, index) {
    //             address.index = index;
    //             direcciones.push(address);
    //       });
    //       ////console.log('data',data)
    //       $q.all(allpromises).then(function(responses) {
    //         modalInstance = $uibModal.open({
    //           templateUrl: 'app/modals/selectAddress.modal.html',
    //           controller: 'SelectAddressCtrl',
    //           controllerAs: 'svm',
    //           resolve: {
    //             direcciones: function() {
    //               return direcciones;
    //             },
    //             insuranceData: function() {
    //               return data.insuranceData;
    //             }
    //           }
    //         });

    //         modalInstance.result
    //           .catch(function(error) {
    //             //////console.log(error);
    //             dfd.reject(error);
    //           }).then(function(response) {
    //             //////console.log(response);
    //             dfd.resolve(response);
    //           });

    //       }, function(error) {
    //         //////console.log(error);
    //         return;
    //       });
    //     }).catch(function(error) {
    //       dfd.reject(error);
    //     });
    //   return dfd.promise;
    // }

    function renewModal(data) {
      // insuranceService.getInsuranceResumeWithCoverages(data.myInsurance.id).then(function(response){
      // console.log('response',response)
      // data.coverageInPolicy_policy = response
      $rootScope.renewalDraftPolicy = angular.copy(data.myInsurance) || null;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        // templateUrl: 'app/ordenes/ordenes.generic.html',
        templateUrl: "app/renovaciones/renovaciones.modalNew.html",
        controller: "RenovacionesModalCtrl",
        controllerAs: "order",
        ////windowClass: 'animated fadeIn',
        size: "lg",
        resolve: {
          myInsurance: function () {
            return data.myInsurance;
            // });
          },
          container: function () {
            return data.container;
          },
        },
      });
      return modalInstance.result;
      // });
    }
    function validateInsuranceData(data) {
      var dfd = $q.defer();

      // if (!data) {
      //   dfd.resolve(data);
      // } else if (data.insuranceData || !data.myInsurance) {
      //   dfd.resolve(data);
      // } else {
      //   insuranceService.getInsuranceData(data.myInsurance)
      //     .then(function(insuranceData) {
      //       data.insuranceData = angular.copy(insuranceData);
      dfd.resolve(data);
      //     });
      // }

      return dfd.promise;
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("MensajeriaCtrl", MensajeriaCtrl);

  MensajeriaCtrl.$inject = [
    "$parse",
    "$scope",
    "dataFactory",
    "SweetAlert",
    "datesFactory",
    "$sce",
    "$uibModal",
    "toaster",
    "$http",
    "url",
    "$state",
    "$sessionStorage",
    "PersistenceFactory",
    "$localStorage",
  ];

  function MensajeriaCtrl(
    $parse,
    $scope,
    dataFactory,
    SweetAlert,
    datesFactory,
    $sce,
    $uibModal,
    toaster,
    $http,
    url,
    $state,
    $sessionStorage,
    PersistenceFactory,
    $localStorage
  ) {
    var vm = this;

    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    vm.form = {};
    vm.form.contratante = {};
    $scope.task = false;
    $scope.delivery = false;
    $scope.delivery_man = {};
    $scope.new_task = {};
    $scope.filters = {};
    $scope.new_task.fecha = datesFactory.convertDate(new Date());
    $scope.frecs = [
      {
        id: 1,
        name: "Itinerario de hoy",
      },
      {
        id: 2,
        name: "Rango de fechas",
      },
    ];

    $scope.status = [
      {
        id: 1,
        name: "Abiertas",
      },
      {
        id: 2,
        name: "Cerradas",
      },
    ];

    $scope.address_type = [
      {
        name: "Dirección Fiscal",
        id: 1,
      },
      {
        name: "Dirección de cobro",
        id: 2,
      },
      {
        name: "Dirección de paquetería",
        id: 3,
      },
      {
        name: "Dirección de riesgo",
        id: 4,
      },
    ];

    activate();

    function activate() {
      dataFactory.get("get-delivery").then(function success(responseGet) {
        if (responseGet.status == 200) {
          $scope.delivery_mans = responseGet.data;
        }
      });

      $scope.filters.mensajero =
        $localStorage.saved_filters_mensajeria &&
        $localStorage.saved_filters_mensajeria["mensajero"]
          ? $localStorage.saved_filters_mensajeria["mensajero"]
          : 0;
      $scope.filters.estatus =
        $localStorage.saved_filters_mensajeria &&
        $localStorage.saved_filters_mensajeria["estatus"]
          ? $localStorage.saved_filters_mensajeria["estatus"]
          : 0;
      $scope.frec_selected =
        $localStorage.saved_filters_mensajeria &&
        $localStorage.saved_filters_mensajeria["frec_selected"]
          ? $localStorage.saved_filters_mensajeria["frec_selected"]
          : 0;
    }

    $scope.saveDelivery = function () {
      dataFactory
        .post("create-delivery/", $scope.delivery_man)
        .then(function success(responseDelivery) {
          if (responseDelivery.data.created) {
            SweetAlert.swal(
              "Hecho",
              "Se ha agregado un nuevo mensajero",
              "success"
            );
            $scope.delivery_man = {};
            activate();
          } else {
            SweetAlert.swal("Error", responseDelivery.data.error, "error");
          }
        });
    };

    $scope.createDelivery = function () {
      $scope.task = false;
      $scope.delivery = true;
    };

    $scope.getDelivery = function () {
      $scope.task = true;
      $scope.delivery = false;
    };

    $scope.closeDelivery = function () {
      $scope.task = false;
      $scope.delivery = false;
      $scope.manual_opt = false;
      $scope.contratante_opt = false;
    };

    $scope.eraseInput = function () {
      $scope.manual_opt = true;
      $scope.contratante_opt = false;
      $scope.new_task.address = "";
    };

    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = 0;
      var word_data = vm.form.contratante.val;
      if (word_data) {
        if (word_data.length >= 3) {
          var filter_contractor = "contractors-match/";
          dataFactory
            .post(filter_contractor, { matchWord: parWord })
            .then(function (response) {
              if (response.status === 200 && response.data.contractors) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
        $scope.contractors_data = [];
      }
    };

    $scope.$watch("vm.form.contratante.value", function (newValue, oldValue) {
      if (vm.form.contratante.value) {
        if (vm.form.contratante.value.full_name) {
          vm.form.contratante.val = vm.form.contratante.value.full_name;
        }
        if (vm.form.contratante.value.address_contractor) {
          vm.address = vm.form.contratante.value.address_contractor;
          toaster.warning("Seleccione la dirección del combo");
        }
        try {
          if (vm.address.length == 1) {
            vm.form.address = vm.address[0];
          }
        } catch (err) {}
      }
    });

    $scope.saveTask = function () {
      if ($scope.new_task.address.id) {
        $scope.new_task.address =
          $scope.new_task.address.route +
          " " +
          $scope.new_task.address.street_number +
          " Int. " +
          $scope.new_task.address.street_number_int +
          " " +
          $scope.new_task.address.sublocality +
          " " +
          $scope.new_task.address.administrative_area_level_2 +
          ", " +
          $scope.new_task.address.administrative_area_level_1;
      }
      if (vm.form.contratante) {
        if (vm.form.contratante.value) {
          $scope.new_task.receptor = vm.form.contratante.value.full_name;
        }
      }
      $scope.new_task.delivery = $scope.new_task.delivery_selected.url;
      $scope.new_task.date = new Date(
        datesFactory.toDate($scope.new_task.fecha)
      );
      $scope.new_task.contact = $scope.new_task.contact;
      $scope.new_task.observations = $scope.new_task.observations;
      dataFactory
        .post("tasks/", $scope.new_task)
        .then(function success(responseTask) {
          if (responseTask.status == 201 || responseTask.status == 201) {
            SweetAlert.swal("Hecho", "Se ha asigando la tarea", "success");
            vm.form = {};
            vm.form.contratante = {};
            $scope.new_task = {};
            $scope.task = false;
            vm.address = [];
          }
        });
    };

    $scope.enableDates = function () {
      if ($scope.frec_selected.id == 2) {
        $scope.dates = true;
      } else {
        $scope.dates = false;
      }
    };

    $scope.getTasks = function (page) {
      if ($scope.frec_selected) {
        if ($scope.frec_selected.id == 1) {
          var frecuencia = 1;
          var since = new Date();
          var until = new Date();
        } else {
          var frecuencia = 2;
          var since = $scope.filters.since;
          var until = $scope.filters.until;
        }
      } else {
        var frecuencia = 3;
        var since = new Date();
        var until = new Date();
      }
      if ($scope.filters.mensajero) {
        var mensajero = $scope.filters.mensajero.id;
      } else {
        var mensajero = 0;
      }

      $scope.params = {
        mensajero: mensajero,
        since: since,
        until: until,
        frecuencia: frecuencia,
        status: $scope.filters.estatus ? $scope.filters.estatus.id : 1,
        page: page ? page : 1,
      };
      dataFactory
        .get("get-tasks/", $scope.params)
        .then(function success(responseTasks) {
          if (responseTasks.data.results) {
            $scope.tasks = responseTasks.data.results;
            //imprime la lista del objeto
            $scope.show_pag_search = true;

            vm.comments_config = {
              count: responseTasks.data.count,
              previous: responseTasks.data.previous,
              next: responseTasks.data.next,
            };

            testPagination("$scope.tasks", "vm.comments_config");
          } else {
            toaster.info("No se encontraron registros");
          }
        });

      $localStorage.saved_filters_mensajeria = angular.copy($scope.params);
      $localStorage.saved_filters_mensajeria["mensajero"] =
        $scope.filters.mensajero;
      $localStorage.saved_filters_mensajeria["estatus"] =
        $scope.filters.estatus;
      $localStorage.saved_filters_mensajeria["frec_selected"] =
        $scope.frec_selected;
    };

    $scope.reSchedule = function (item) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/mensajeria/reprogramar.modal.html",
        controller: MensajeriaModalCtrl,
        size: "md",
        resolve: {
          task: function () {
            return item;
          },
          type_function: function () {
            return 1;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function () {
        $scope.getTasks();
      });
    };

    $scope.editTask = function (item) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/mensajeria/reprogramar.modal.html",
        controller: MensajeriaModalCtrl,
        size: "md",
        resolve: {
          task: function () {
            return item;
          },
          type_function: function () {
            return 4;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function () {
        $scope.getTasks();
      });
    };

    $scope.reAssign = function (item) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/mensajeria/reprogramar.modal.html",
        controller: MensajeriaModalCtrl,
        size: "md",
        resolve: {
          task: function () {
            return item;
          },
          type_function: function () {
            return 2;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function () {
        $scope.getTasks();
      });
    };

    $scope.closeTask = function (item) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/mensajeria/reprogramar.modal.html",
        controller: MensajeriaModalCtrl,
        size: "md",
        resolve: {
          task: function () {
            return item;
          },
          type_function: function () {
            return 3;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function () {
        $scope.getTasks();
      });
    };

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPagesP = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesP.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesP.length > 5) {
          $scope.end = $scope.totalPagesP.length;
          $scope.start = $scope.totalPagesP.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPageP($scope.totalPagesP.length);
        // $scope.actual_page = $scope.totalPagesP.length;
        // $scope.page = $scope.totalPagesP.length;
      };

      $scope.selectPageP = function (parPage) {
        $scope.actual_page = parPage;

        $scope.getTasks(parPage);
      };

      $scope.previousBlockPagesP = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesP.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesP = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesP.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesP.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }

    function MensajeriaModalCtrl(
      task,
      dataFactory,
      $scope,
      $http,
      SweetAlert,
      $uibModalInstance,
      type_function,
      $sessionStorage
    ) {
      $(".datepicker-me input").datepicker();
      $.fn.datepicker.defaults.format = "dd/mm/yyyy";
      $.fn.datepicker.defaults.startView = 0;
      $.fn.datepicker.defaults.autoclose = true;
      $.fn.datepicker.defaults.language = "es";

      $scope.task = task;
      $scope.new_info = {};

      $scope.type_function = type_function;

      dataFactory.get("get-delivery").then(function success(responseGet) {
        if (responseGet.status == 200) {
          $scope.delivery_mans = responseGet.data;
        }
      });

      $scope.reprogramar = function () {
        if ($scope.new_info.fecha) {
          $scope.new_info.date = new Date(
            datesFactory.toDate($scope.new_info.fecha)
          );
        } else {
          $scope.new_info.date = $scope.task.date;
        }

        if (!$scope.new_info.time) {
          $scope.new_info.time = $scope.task.time;
        }
        $http
          .patch($scope.task.url, $scope.new_info)
          .then(function success(responsePatch) {
            if (responsePatch.status == 200) {
              $uibModalInstance.close();
              SweetAlert.swal(
                "Hecho",
                "Se ha reprogramado esta tarea",
                "success"
              );
            }
          });
      };

      $scope.reasignar = function () {
        $scope.new_info.delivery = $scope.new_info.mensajero.url;
        $http
          .patch($scope.task.url, $scope.new_info)
          .then(function success(responsePatch) {
            if (responsePatch.status == 200) {
              $uibModalInstance.close();
              SweetAlert.swal(
                "Hecho",
                "Se ha reasignado esta tarea",
                "success"
              );
            }
          });
      };
      $scope.editartarea = function (x, task) {
        if ($scope.new_info.mensajero) {
          if ($scope.new_info.mensajero.url) {
            $scope.new_info.delivery = $scope.new_info.mensajero.url;
          }
        }
        if (task) {
          $scope.new_info.action = task.action;
          $scope.new_info.type_address = task.type_address;
          $scope.new_info.contact = task.contact;
          $scope.new_info.address = task.address;
          $scope.new_info.observations = task.observations;
        }

        $http
          .patch($scope.task.url, $scope.new_info)
          .then(function success(responsePatch) {
            if (responsePatch.status == 200) {
              $uibModalInstance.close();
              SweetAlert.swal("Hecho", "Se ha editado esta tarea", "success");
            }
          });
      };

      $scope.cerrar = function () {
        $scope.new_info.status = 2;
        $scope.new_info.close_day = new Date(
          datesFactory.toDate($scope.new_info.fecha)
        );
        $http
          .patch($scope.task.url, $scope.new_info)
          .then(function success(responsePatch) {
            if (responsePatch.status == 200) {
              $uibModalInstance.close();
              SweetAlert.swal("Hecho", "Se ha cerrado esta tarea", "success");
            }
          });
      };
      $scope.close = function () {
        $uibModalInstance.close();
        return;
      };
    }

    $scope.getDeliveryPDF = function () {
      dataFactory
        .post("get-pdf-itinerario/", $scope.params)
        .then(function success(response) {
          $scope.pdf = response.data;
          dataFactory
            .get("get-pdf", { pdf_name: $scope.pdf.pdf_name })
            .then(function success(response) {
              var file = new Blob([response.data], { type: "application/pdf" });
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file);
              } else {
                var fileURL = URL.createObjectURL(file);
                $scope.content = $sce.trustAsResourceUrl(fileURL);
                window.open($scope.content);
              }
            });
        });
    };

    $scope.GetTasksExcel = function () {
      if ($scope.frec_selected) {
        if ($scope.frec_selected.id == 1) {
          var frecuencia = 1;
          var since = new Date();
          var until = new Date();
        } else {
          var frecuencia = 2;
          var since = $scope.filters.since;
          var until = $scope.filters.until;
        }
      } else {
        var frecuencia = 3;
        var since = new Date();
        var until = new Date();
      }
      if ($scope.filters.mensajero) {
        var mensajero = $scope.filters.mensajero.id;
      } else {
        var mensajero = 0;
      }

      $scope.params = {
        mensajero: mensajero,
        since: since,
        until: until,
        frecuencia: frecuencia,
        status: $scope.filters.estatus ? $scope.filters.estatus.id : 1,
      };
      $http({
        method: "POST",
        // url: url.IP +'getTasksExcel/',
        url: url.IP + "service_reporte-taskMnsj-excel",
        data: $scope.params,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Mensajeria.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
    };
    //-- Peticion de persistencia--//
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var json_data = {};
    var form = document.getElementsByTagName("form");
    var elementos = {};
    //Valores reutilizables
    var interval, interval1, form_dt;
    var count = 0;

    function set_dataForm(json) {
      var dt;

      if (json["delivery_man.first_name"]) {
        $scope.createDelivery();
        dt = '[name="form"]';
      }
      if (
        json["new_task.action"] ||
        json["new_task.contact"] ||
        json["new_task.delivery_selected"] ||
        json["new_task.observations"] ||
        json["new_task.time"]
      ) {
        $scope.getDelivery();
        dt = '[name="formTask"]';
      }
      console.log("dt: " + dt);

      if (dt != undefined) {
        interval1 = setInterval(function () {
          form_dt = angular.element(dt);
          if (form_dt.length > 0) {
            if (json["end_type"]) {
              if (json["end_type"] == 1) {
                $scope.contratante_opt = true;
                $scope.manual_opt = false;
              }
              if (json["end_type"] == 2) {
                $scope.manual_opt = true;
                $scope.contratante_opt = false;
              }
            }

            PersistenceFactory.set_inputs(json);
            clearInterval(interval1);
          }
        }, 1000);
      }

      //PersistenceFactory.set_inputs(json);
    }

    interval = setInterval(function () {
      if (form != undefined && PersistenceFactory.count == 0) {
        //&& PersistenceFactory.count == 0
        PersistenceFactory.inicial(
          usr.org,
          "Mensajeria",
          usr.nameFull,
          PersistenceFactory.get_dataForm(form)
        );
      }
      if (PersistenceFactory.init_return != "") {
        clearInterval(interval);
        if (PersistenceFactory.init_return.status == "data_view") {
          set_dataForm(PersistenceFactory.json_return);
        }
        PersistenceFactory.interval = setInterval(function () {
          PersistenceFactory.editado(PersistenceFactory.get_dataForm(form));
        }, PersistenceFactory.intervalTime); /* */
      }
    }, 1000);
    //-- End Peticion de persistencia--//
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("DeliveryModalCtrl", DeliveryModalCtrl);

  DeliveryModalCtrl.$inject = [
    "dataFactory",
    "$scope",
    "datesFactory",
    "SweetAlert",
    "$uibModalInstance",
    "insurance",
    "contractor",
  ];

  function DeliveryModalCtrl(
    dataFactory,
    $scope,
    datesFactory,
    SweetAlert,
    $uibModalInstance,
    insurance,
    contractor
  ) {
    var vm = this;
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    vm.form = {};
    vm.form.contratante = {};
    $scope.task = false;
    $scope.delivery = false;
    $scope.delivery_man = {};
    $scope.new_task = {};
    $scope.filters = {};
    $scope.new_task.fecha = datesFactory.convertDate(new Date());

    $scope.address_type = [
      {
        name: "Dirección Fiscal",
        id: 1,
      },
      {
        name: "Dirección de cobro",
        id: 2,
      },
      {
        name: "Dirección de paquetería",
        id: 3,
      },
      {
        name: "Dirección de riesgo",
        id: 4,
      },
    ];

    activate();

    function activate() {
      dataFactory.get("get-delivery").then(function success(responseGet) {
        if (responseGet.status == 200) {
          $scope.delivery_mans = responseGet.data;
        }
      });
      $scope.address_options = contractor.address_natural
        ? contractor.address_natural
        : contractor.address_juridical;
    }

    $scope.eraseInput = function () {
      $scope.manual_opt = true;
      $scope.contratante_opt = false;
      $scope.new_task.address = "";
    };

    $scope.saveTask = function () {
      if ($scope.new_task.address.id) {
        $scope.new_task.address =
          $scope.new_task.address.route +
          " " +
          $scope.new_task.address.street_number +
          " Int. " +
          $scope.new_task.address.street_number_int +
          " " +
          $scope.new_task.address.sublocality +
          " " +
          $scope.new_task.address.administrative_area_level_2 +
          ", " +
          $scope.new_task.address.administrative_area_level_1;
      }
      $scope.new_task.delivery = $scope.new_task.delivery_selected.url;
      $scope.new_task.date = new Date(
        datesFactory.toDate($scope.new_task.fecha)
      );
      $scope.new_task.type_address = $scope.new_task.address.tipo;
      dataFactory
        .post("tasks/", $scope.new_task)
        .then(function success(responseTask) {
          if (responseTask.status == 201 || responseTask.status == 201) {
            SweetAlert.swal("Hecho", "Se ha asigando la tarea", "success");
            vm.form = {};
            vm.form.contratante = {};
            $scope.new_task = {};
            $scope.task = false;
            vm.address = [];
            $uibModalInstance.dismiss("cancel");
          }
        });
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };

    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = 0;
      var word_data = vm.form.contratante.val;
      if (word_data) {
        if (word_data.length >= 3) {
          dataFactory
            .post("contractors-match/", { matchWord: parWord })
            .then(function (response) {
              if (
                response.status === 200 &&
                (response.data.juridicals || response.data.naturals)
              ) {
                var source = [];
                var juridicals = response.data.juridicals;
                var naturals = response.data.naturals;

                if (juridicals.length) {
                  juridicals.forEach(function (item) {
                    var obj = {
                      label: item.j_name,
                      value: item,
                    };
                    source.push(obj);
                  });
                } else if (naturals.length) {
                  naturals.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }

                    source.push(obj);
                  });
                }

                $scope.contractors_data = source;
              }
            });
        }
      } else {
        $scope.contractors_data = [];
      }
    };

    $scope.$watch("vm.form.contratante.value", function (newValue, oldValue) {
      if (vm.form.contratante.value) {
        if (vm.form.contratante.value.j_name) {
          vm.form.contratante.val = vm.form.contratante.value.j_name;
        }

        if (vm.form.contratante.value.full_name) {
          vm.form.contratante.val = vm.form.contratante.value.full_name;
        }

        if (vm.form.contratante.value.address_natural) {
          vm.address = vm.form.contratante.value.address_natural;
          toaster.warning("Seleccione la dirección del combo");
        } else {
          vm.address = vm.form.contratante.value.address_juridical;
          toaster.warning("Seleccione la dirección del combo");
        }

        try {
          if (vm.address.length == 1) {
            vm.form.address = vm.address[0];
          }
        } catch (err) {}
      }
    });
  }
})();

/* global angular */
(function () {
  "use strict";
  /* jshint devel: true */

  angular
    .module("inspinia")
    .controller(
      "MedicosCelulasConfiguracionCtrl",
      MedicosCelulasConfiguracionCtrl
    );

  MedicosCelulasConfiguracionCtrl.$inject = [
    "datesFactory",
    "dataFactory",
    "SweetAlert",
    "url",
    "ContratanteService",
    "groupService",
    "contactService",
    "generalService",
    "FileUploader",
    "toaster",
    "helpers",
    "globalVar",
    "MESSAGES",
    "$uibModal",
    "$filter",
    "$scope",
    "$rootScope",
    "$localStorage",
    "$timeout",
    "$q",
    "$state",
    "$sessionStorage",
    "$location",
    "$http",
    "$parse",
    "exportFactory",
    "PersistenceFactory",
    "appStates",
  ];

  function MedicosCelulasConfiguracionCtrl(
    datesFactory,
    dataFactory,
    SweetAlert,
    url,
    ContratanteService,
    groupService,
    contactService,
    generalService,
    FileUploader,
    toaster,
    helpers,
    globalVar,
    MESSAGES,
    $uibModal,
    $filter,
    $scope,
    $rootScope,
    $localStorage,
    $timeout,
    $q,
    $state,
    $sessionStorage,
    $location,
    $http,
    $parse,
    exportFactory,
    PersistenceFactory,
    appStates
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var orgParam = { params: { org: $localStorage.orgId } };
    var vm = this;
    vm.addConfguration = addConfguration;
    vm.org_name = usr.org;
    $scope.contractors = [];
    $scope.celulas = [];
    $scope.configuraciones = [];
    $scope.agregar_configuracion = false;
    $scope.medicoscelula = {};
    $scope.show_pagination = false;
    $scope.namesContractor = [];
    $scope.namesCelula = [];
    vm.selectedCelulas = selectedCelulas;
    vm.selectedContractors = selectedContractors;
    vm.consultaRegistros = this.consultaRegistros;

    function closeDropdown() {
      $(".hasDropdown").removeClass("open");
    }

    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });

    vm.hoy = new Date();
    vm.control = {
      closeModal: function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      },
    };
    activate();
    $(".js-example-basic-multiple").select2();
    vm.activate = activate;
    function activate() {
      $scope.showEditMedico = false;
      $scope.agregar_configuracion = false;
      $(".js-example-basic-multiple").select2();
      var url_data = "contratantes-lista/";
      $scope.obteniendoFiltros = true;
      dataFactory
        .post(url_data)
        .then(
          function success(response) {
            $scope.contractors = response.data;
            $scope.obteniendoFiltros = false;
          },
          function error(error) {
            $scope.obteniendoFiltros = false;
            console.log(error);
          }
        )
        .catch(function (e) {
          $scope.obteniendoFiltros = false;
          console.log(e);
        });
      dataFactory
        .post("celula_contractor_info/")
        .then(
          function success(response) {
            $scope.celulas = response.data;
            $scope.obteniendoFiltros = false;
          },
          function error(error) {
            $scope.obteniendoFiltros = false;
            console.log(error);
          }
        )
        .catch(function (e) {
          $scope.obteniendoFiltros = false;
          console.log(e);
        });
      // obtener lista de configuraciones
      dataFactory
        .get("medicoscelulascontractor_info/")
        .then(
          function success(response) {
            $scope.configuraciones = response.data.results;
            vm.configuraciones = response.data.results;
            if (response.data.count > 10) {
              $scope.show_pagination = true;
            }
            vm.configuration = {
              count: response.data.count,
              next: response.data.next,
              previous: response.data.previous,
            };

            $scope.testPagination("vm.configuraciones", "vm.configuration");
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
      $scope.existeDefault = false;
      //
      dataFactory
        .get("medicoscelulascontractor_default/")
        .then(
          function success(response) {
            $scope.existeDefault = response.data;
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    }
    $scope.selectCelulas = function (sel) {
      $scope.celulas_selected = [];
      $scope.celulas_IDS = [];
      $scope.namesCelula = [];
      sel.forEach(function (u) {
        if (u.url) {
          $scope.celulas_selected.push(u.url);
          $scope.celulas_IDS.push(u.id);
          $scope.namesCelula.push(u.description);
        } else {
          $scope.celulas_selected.push(u);
        }
      });
    };
    $scope.selectContractors = function (sel) {
      $scope.contractors_selected = [];
      $scope.contractors_IDS = [];
      $scope.namesContractor = [];
      sel.forEach(function (u) {
        if (u.url) {
          $scope.contractors_selected.push(u.url);
          $scope.contractors_IDS.push(u.id);
          $scope.namesContractor.push(u.full_name);
        } else {
          $scope.contractors_selected.push(u);
        }
      });
    };
    function addConfguration() {
      $scope.medicoscelula = { default: false };
      $scope.select_contractor = [];
      $scope.select_celula = [];
      $scope.namesContractor = [];
      $scope.namesCelula = [];
      $scope.contractors_IDS = [];
      $scope.celulas_IDS = [];
      $scope.agregar_configuracion = true;
    }
    $scope.cancelConfig = function (val) {
      $scope.medicoscelula = {};
      $scope.select_contractor = [];
      $scope.select_celula = [];
      $scope.namesContractor = [];
      $scope.namesCelula = [];
      $scope.contractors_IDS = [];
      $scope.celulas_IDS = [];
      $scope.agregar_configuracion = val;
      $scope.showEditMedico = val;
    };
    $scope.edit = function (param) {
      $(".js-example-basic-multiple").select2();
      $scope.agregar_configuracion = false;
      $scope.showEditMedico = true;
      $scope.showInfo = false;
      $scope.editMedico = param;
      $scope.medicoscelula = param;
      var select_contractor = [];
      $scope.namesContractor = [];
      $scope.namesCelula = [];
      $scope.celulas_IDS = [];
      $scope.contractors_IDS = [];
      $scope.contractors_selected = [];
      $scope.celulas_selected = [];
      $.each(param.clientes, function (i, e) {
        select_contractor.push(e);
        $scope.namesContractor.push(e.full_name);
        $scope.contractors_IDS.push(e.id);
      });
      selectedContractors(select_contractor);
      $scope.select_contractor = select_contractor;
      $scope.contractors_selected = select_contractor;
      var select_celula = [];
      $.each(param.celulas, function (i, ce) {
        select_celula.push(ce);
        $scope.namesCelula.push(ce.description);
        $scope.celulas_IDS.push(ce.id);
      });
      selectedCelulas(select_celula);
      $scope.select_celula = select_celula;
      $scope.celulas_selected = select_celula;
    };
    $scope.valDefault = function (def) {
      console.log("default--", def, $scope.medicoscelula, $scope.existeDefault);
    };
    function selectedCelulas(sel) {
      $scope.celulas_selected = [];
      $scope.celulas_IDS = [];
      $scope.namesCelula = [];
      sel.forEach(function (u) {
        if (u.url) {
          $scope.celulas_selected.push(u.url);
          $scope.celulas_IDS.push(u.id);
          $scope.namesCelula.push(u.description);
        } else {
          $scope.celulas_selected.push(u);
        }
      });
    }
    function selectedContractors(sel) {
      $scope.contractors_selected = [];
      $scope.contractors_IDS = [];
      $scope.namesContractor = [];
      sel.forEach(function (u) {
        if (u.url) {
          $scope.contractors_selected.push(u.url);
          $scope.contractors_IDS.push(u.id);
          $scope.namesContractor.push(u.full_name);
        } else {
          $scope.contractors_selected.push(u);
        }
      });
    }
    $scope.save = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.medicoscelula.celulas = $scope.celulas_selected
        ? $scope.celulas_selected
        : [];
      $scope.medicoscelula.clientes = $scope.contractors_selected
        ? $scope.contractors_selected
        : [];
      $scope.medicoscelula.celulas_list = $scope.celulas_IDS
        ? $scope.celulas_IDS
        : [];
      $scope.medicoscelula.clientes_list = $scope.contractors_IDS
        ? $scope.contractors_IDS
        : [];
      if ($scope.medicoscelula.default) {
        $scope.medicoscelula.celulas = [];
        $scope.medicoscelula.clientes = [];
        $scope.medicoscelula.celulas_list = [];
        $scope.medicoscelula.clientes_list = [];
      }
      $http({
        method: "POST",
        url: url.IP + "medicoscelulas/",
        data: $scope.medicoscelula,
      })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            $scope.configuraciones.push(response.data);
            $state.reload();
            activate();
          } else {
            l.stop();
            SweetAlert.swal("Error", response.data[0], "error");
            console.log("response", response);
          }
        })
        .catch(function (e) {
          l.stop();
          // $scope.agregar_configuracion = false;
          console.log("e", e);
        });
    };
    $scope.update = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.clientes_send = [];
      $scope.contractors_selected.forEach(function (u) {
        if (u.url) {
          $scope.clientes_send.push(u.url);
        } else {
          $scope.clientes_send.push(u);
        }
      });
      $scope.celulas_send = [];
      $scope.celulas_selected.forEach(function (u) {
        if (u.url) {
          $scope.celulas_send.push(u.url);
        } else {
          $scope.celulas_send.push(u);
        }
      });
      $scope.medicoscelula.celulas = $scope.celulas_send
        ? $scope.celulas_send
        : [];
      $scope.medicoscelula.clientes = $scope.clientes_send
        ? $scope.clientes_send
        : [];
      $scope.medicoscelula.celulas_list = $scope.celulas_IDS
        ? $scope.celulas_IDS
        : [];
      $scope.medicoscelula.clientes_list = $scope.contractors_IDS
        ? $scope.contractors_IDS
        : [];
      if ($scope.medicoscelula.default) {
        $scope.medicoscelula.celulas = [];
        $scope.medicoscelula.clientes = [];
        $scope.medicoscelula.celulas_list = [];
        $scope.medicoscelula.clientes_list = [];
      }
      dataFactory
        .patch($scope.medicoscelula.url, $scope.medicoscelula)
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            l.stop();
            $state.reload();
            activate();
            SweetAlert.swal(
              "Listo",
              "Configuración Actualizada \n(" +
                $scope.medicoscelula.medico +
                ").",
              "success"
            );
          } else {
            l.stop();
            SweetAlert.swal("Error", response.data[0], "error");
            console.log("response", response);
          }
        })
        .catch(function (e) {
          l.stop();
          // $scope.agregar_configuracion = false;
          console.log("e", e);
        });
    };
    $scope.delete = function (med, index, container) {
      SweetAlert.swal(
        {
          title: "Eliminar Médico",
          text: "¿Está seguro de eliminar esta Médico?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(med.url).then(function success(response) {
              if (response.status == 204) {
                SweetAlert.swal(
                  "¡Listo!",
                  "Médico eliminado: " + med.medico,
                  "success"
                );
                container.splice(container.indexOf(med), 1);
              } else if (response.status == 403) {
                SweetAlert.swal("¡Cancelado!", response.data.detail, "error");
                return;
              }
            });
          } else {
            SweetAlert.swal(
              "¡Cancelado!",
              "El médico no fue eliminado",
              "error"
            );
            return;
          }
        }
      );
    };
    function consultaRegistros(order, page) {
      var params = {
        page: page ? page : 1,
      };
      $http({
        method: "POST",
        url: url.IP + "medicoscelulascontractor_info/",
        data: params,
      })
        .then(
          function success(response) {
            if (response.status == 200 || response.status == 201) {
              vm.configuraciones = response.data.results;
              $scope.configuraciones = response.data.results;
              $scope.configuraciones_config = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };
              $scope.show_pagination = true;
              $scope.testPagination(
                "vm.configuraciones",
                "configuraciones_config"
              );
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    }
    // paginación
    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;
      var previous_array = [];
      var next_array = [];
      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;
      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }
      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        $scope.actual_page = $scope.totalPages.length;
      };
      $scope.selectPage = function (parPage) {
        consultaRegistros($scope.order, parPage);
      };
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };
      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;
        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
      function getConfigurationsPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);
              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    // Fin Configuraciones Paginación
    $(".datepicker-me input").datepicker();
    Date.prototype.isValid = function () {
      // An invalid date object returns NaN for getTime() and NaN is the only
      // object not strictly equal to itself.
      return this.getTime() === this.getTime();
    };

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";

  var app = angular.module("inspinia");
  app.controller("MainCtrl", MainCtrl);
  app.config([
    "ChartJsProvider",
    function (ChartJsProvider) {
      // Configure all charts
      ChartJsProvider.setOptions({
        colours: ["#23A91C", "#F1E223", "#DF7401", "#CF2226"],
        responsive: true,
        segmentShowStroke: false,
        animationEasing: "easeInOutQuart",
      });
      // Configure all line charts
      ChartJsProvider.setOptions("Line", {
        datasetFill: false,
      });
    },
  ]);
  app.filter("propsFilter", propsFilter);

  function propsFilter() {
    return function (items, props) {
      var out = [];

      //if (angular.isArrayF(items)) {
      if (angular.isArray(items)) {
        items.forEach(function (item) {
          var itemMatches = false;
          var keys = Object.keys(props);
          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }
          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }
      return out;
    };
  }

  $(document).ready(function () {
    if (firebase.messaging.isSupported()) {
      var messaging = firebase.messaging();
      messaging.onTokenRefresh(function () {
        messaging
          .getToken()
          .then(function (refreshedToken) {
            $http
              .post(url.IP + "guardar-firebase-token/", {
                token: refreshedToken,
                action: "save",
              })
              .then(function (response) {
                console.log("firebase get token success");
              })
              .catch(function (error) {
                console.log("error firebase get token", error);
              });
            // Indicate that the new Instance ID token has not yet been sent to the
            // app server.
            // Send Instance ID token to app server.
            // sendTokenToServer(refreshedToken);
            // ...
          })
          .catch(function (err) {
            console.log("Unable to retrieve refreshed token ", err);
            showToken("Unable to retrieve refreshed token ", err);
          });
      });
    }
  });

  app.directive("ngRightClick", function ($parse) {
    return function (scope, element, attrs) {
      var fn = $parse(attrs.ngRightClick);
      element.bind("contextmenu", function (event) {
        scope.$apply(function () {
          event.preventDefault();
          fn(scope, { $event: event });
        });
      });
    };
  });

  MainCtrl.$inject = [
    "$firebaseObject",
    "$sce",
    "curr_rate_options",
    "$scope",
    "statusPayform",
    "$state",
    "$uibModal",
    "$filter",
    "$localStorage",
    "$timeout",
    "$location",
    "Idle",
    "receiptService",
    "insuranceService",
    "ContratanteService",
    "providerService",
    "ramoService",
    "packageService",
    "MESSAGES",
    "$sessionStorage",
    "status",
    "payform",
    "url",
    "moduleInjection",
    "modalService",
    "helpers",
    "toaster",
    "endorsementService",
    "$q",
    "$http",
    "endorsement",
    "$rootScope",
    "$window",
    "SweetAlert",
    "exportFactory",
    "dataFactory",
    "appStates",
    "$interval",
    "NotificationService",
    "whatsappWebFlagService",
    "siniestroWhatsappService",
  ];

  function MainCtrl(
    $firebaseObject,
    $sce,
    curr_rate_options,
    $scope,
    statusPayform,
    $state,
    $uibModal,
    $filter,
    $localStorage,
    $timeout,
    $location,
    Idle,
    receiptService,
    insuranceService,
    ContratanteService,
    providerService,
    ramoService,
    packageService,
    MESSAGES,
    $sessionStorage,
    status,
    payform,
    url,
    moduleInjection,
    modalService,
    helpers,
    toaster,
    endorsementService,
    $q,
    $http,
    endorsement,
    $rootScope,
    $window,
    SweetAlert,
    exportFactory,
    dataFactory,
    appStates,
    $interval,
    NotificationService,
    whatsappWebFlagService,
    siniestroWhatsappService
  ) {
    // $(window).load(function() {
    //     $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    var main = this;
    main.whatsappWebEnabled = whatsappWebFlagService.isEnabled();
    whatsappWebFlagService.subscribe(function (enabled) {
      $scope.$evalAsync(function () {
        main.whatsappWebEnabled = enabled; // ✅ CORRECTO
      });
    }, $scope);
    main.sendWhatsAppWeb = openWhatsapp;

    var usr = {};
    var authCache = {
      tokenBlob: null,
      tokenValue: null,
      userBlob: null,
      userValue: null,
    };

    function debugLog(context, payload) {
      // try {
      //   console.log('[SAAM][MainCtrl] ' + context, payload || {});
      // } catch (logError) {
      //   // Evitamos que un problema de consola rompa el flujo.
      // }
    }

    function extractTokenString(candidate) {
      if (!candidate) {
        return null;
      }

      if (typeof candidate === "string") {
        return candidate;
      }

      if (angular.isObject(candidate)) {
        if (candidate.token) {
          return candidate.token;
        }

        if (candidate.access || candidate.access_token) {
          return candidate.access || candidate.access_token;
        }
      }

      try {
        return candidate.toString();
      } catch (_) {
        return null;
      }
    }

    function describeTokenCandidate(candidate) {
      var tokenString = extractTokenString(candidate);

      if (!tokenString) {
        return {
          hasToken: false,
          tokenLength: 0,
          tokenSuffix: null,
        };
      }

      var suffixLength = tokenString.length > 8 ? 8 : tokenString.length;
      return {
        hasToken: true,
        tokenLength: tokenString.length,
        tokenSuffix: tokenString.slice(tokenString.length - suffixLength),
      };
    }

    function logAuthSnapshot(context, extra) {
      var tokenInfo = describeTokenCandidate(authCache.tokenValue);
      var userInfo = authCache.userValue || {};
      var orgInfo = null;

      if (userInfo && userInfo.org) {
        orgInfo =
          userInfo.org.urlname || userInfo.org.name || userInfo.org.id || null;
      }

      var payload = {
        tokenPresent: tokenInfo.hasToken,
        tokenLength: tokenInfo.tokenLength,
        tokenSuffix: tokenInfo.tokenSuffix,
        hasUser: !!authCache.userValue,
        userOrg: orgInfo,
      };

      if (extra && typeof extra === "object") {
        Object.keys(extra).forEach(function (key) {
          try {
            payload[key] = extra[key];
          } catch (_) {
            // Ignoramos errores al copiar propiedades de depuración.
          }
        });
      }

      debugLog(context, payload);
    }

    main.emailsReminderAdd = emailsReminderAdd;
    main.notifications = {};
    $rootScope.notificationscount = 0;
    main.chat = [];
    main.chat_receive = [];
    main.user_admin = "user";
    main.user_is_staff = false;
    $scope.usr_name = "";

    refreshUserFromStorage(true);

    $scope.$watch(
      function () {
        return $sessionStorage.user;
      },
      function (newValue, oldValue) {
        if (newValue !== oldValue) {
          debugLog("watch:$sessionStorage.user", {
            hasValue: !!newValue,
          });
          refreshUserFromStorage(true);
        }
      }
    );

    $scope.$watch(
      function () {
        return $localStorage.user;
      },
      function (newValue, oldValue) {
        if (newValue !== oldValue) {
          debugLog("watch:$localStorage.user", {
            hasValue: !!newValue,
          });
          refreshUserFromStorage(true);
        }
      }
    );

    $scope.$watch(
      function () {
        return $sessionStorage.token;
      },
      function (newValue, oldValue) {
        if (newValue !== oldValue) {
          var length = 0;
          if (newValue && typeof newValue === "string") {
            length = newValue.length;
          }
          debugLog("watch:$sessionStorage.token", {
            hasValue: !!newValue,
            length: length,
          });
          getCurrentToken(true);
        }
      }
    );

    $scope.$watch(
      function () {
        return $localStorage.token;
      },
      function (newValue, oldValue) {
        if (newValue !== oldValue) {
          var length = 0;
          if (newValue && typeof newValue === "string") {
            length = newValue.length;
          }
          debugLog("watch:$localStorage.token", {
            hasValue: !!newValue,
            length: length,
          });
          getCurrentToken(true);
        }
      }
    );

    $scope.moduleName = "Célula";

    function getStoredAuthBlob(key) {
      if ($sessionStorage && $sessionStorage[key]) {
        return $sessionStorage[key];
      }

      if ($localStorage && $localStorage[key]) {
        return $localStorage[key];
      }

      return null;
    }

    function safeDecryptValue(label, encryptedValue) {
      if (!encryptedValue) {
        return null;
      }

      try {
        return sjcl.decrypt(label, encryptedValue);
      } catch (error) {
        console.warn("[SAAM] No se pudo descifrar el valor de", label, error);
        return null;
      }
    }

    function safeJsonParse(rawValue) {
      if (rawValue === null || typeof rawValue === "undefined") {
        return null;
      }

      try {
        return JSON.parse(rawValue);
      } catch (error) {
        console.warn(
          "[SAAM] No se pudo interpretar el contenido descifrado",
          error
        );
        return null;
      }
    }

    function decodeUserBlob(blob) {
      var decrypted = safeDecryptValue("User", blob);
      return safeJsonParse(decrypted);
    }

    function decodeTokenBlob(blob) {
      var decrypted = safeDecryptValue("Token", blob);
      return safeJsonParse(decrypted);
    }

    function getCurrentUser(forceRefresh) {
      var blob = getStoredAuthBlob("user");

      if (!blob) {
        authCache.userBlob = null;
        authCache.userValue = null;
        if (forceRefresh) {
          logAuthSnapshot("getCurrentUser -> sin información de usuario", {
            forceRefresh: !!forceRefresh,
          });
        }
        return null;
      }

      if (forceRefresh || blob !== authCache.userBlob) {
        authCache.userBlob = blob;
        authCache.userValue = decodeUserBlob(blob);
        logAuthSnapshot("getCurrentUser -> actualizado", {
          forceRefresh: !!forceRefresh,
        });
      }

      return authCache.userValue;
    }

    function getCurrentToken(forceRefresh) {
      var blob = getStoredAuthBlob("token");

      if (!blob) {
        authCache.tokenBlob = null;
        authCache.tokenValue = null;
        if (forceRefresh) {
          logAuthSnapshot("getCurrentToken -> sin token", {
            forceRefresh: !!forceRefresh,
          });
        }
        return null;
      }

      if (forceRefresh || blob !== authCache.tokenBlob) {
        authCache.tokenBlob = blob;
        authCache.tokenValue = decodeTokenBlob(blob);
        logAuthSnapshot("getCurrentToken -> actualizado", {
          forceRefresh: !!forceRefresh,
        });
      }

      return authCache.tokenValue;
    }

    function refreshUserFromStorage(forceRefresh) {
      var latest = getCurrentUser(forceRefresh);

      if (!latest) {
        usr = {};
        main.userLogin = null;
        main.orgName = null;
        $rootScope.usr = null;
        logAuthSnapshot("refreshUserFromStorage -> sin usuario", {
          forceRefresh: !!forceRefresh,
        });
        return;
      }

      usr = latest;
      main.userLogin = latest;
      main.orgName = latest.org;
      $rootScope.usr = latest;
      logAuthSnapshot("refreshUserFromStorage -> usuario cargado", {
        forceRefresh: !!forceRefresh,
        userName: latest.username || latest.email || latest.name || null,
      });
    }
    dataFactory.get("orginfo/").then(function success(response) {
      if (
        response &&
        response.data &&
        response.data.results &&
        response.data.results.length
      ) {
        $scope.configuracionGlobal = response.data.results[0];
        if ($scope.configuracionGlobal.moduleName) {
          $scope.moduleName = $scope.configuracionGlobal.moduleName;
        }
      }
    });

    // Pace.ignore(function() {
    // main.socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
    // })
    //initUser();
    if (firebase.messaging.isSupported()) {
      firebase.messaging().onMessage(function (payload) {
        main.notifications["count"] += 1;
        $rootScope.notificationscount += 1;
        SweetAlert.swal({
          title: payload.notification.title,
          icon: "success",
          text: payload.notification.body,
          timer: 7000,
        });
        // setTimeout(function() {
        // SweetAlert.swal({
        //   title: payload.notification.title,
        //   text: payload.notification.body,
        //   type: "success"
        // });
        toaster.success(payload.notification.title);
        // }, 1000);
      });
    }

    main.chat_text = "";
    main.user_search_text = "";
    main.active_chat = {};

    //Function
    $scope.has_sr_conf = false;
    main.logout = logout;
    main.block = block;
    main.initUser = initUser;
    // Show tables
    main.policyTable = false;
    main.endorsementTable = false;
    main.coverageTable = false;
    main.renewalTable = false;
    main.sinisterTable = false;
    main.search = false;
    main.titleID = null;
    main.title = "";
    main.pago_recibo_actual;
    main.totalReceipts = [];
    main.loaded = false;
    main.changeStatusModal = changeStatusModal;
    main.showBinnacle = showBinnacle;
    main.returnToReceipts = returnToReceipts;
    main.showBinnacle_endoso = showBinnacle_endoso;
    main.returnToEndoso = returnToEndoso;
    main.show_binnacle = false;
    // main.massiveReceipts = massiveReceipts;
    main.pagarRecibos = pagarRecibos;
    main.adminReminder = adminReminder;
    main.viewCarta = viewCarta;
    main.goToEndorsement = goToEndorsement;

    main.name = null;
    main.heading = null;
    main.route = null;

    $scope.list = {};
    $scope.ShowContextMenu = function (name, route) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;
    };

    $scope.open_in_same_tab = function (name, route) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab);
    };

    $scope.open_new_tab = function () {
      var existe = false;
      appStates.states.forEach(function (state) {
        if (
          state.route == $scope.route_for_new_tab &&
          state.id == $scope.id_for_new_tab
        ) {
          existe = true;
        }
      });
      if (appStates.states.length > 3) {
        SweetAlert.swal("Error", "No se pueden abrir más pestañas.", "error");
      } else {
        if (!existe) {
          appStates.states.push({
            id: $scope.id_for_new_tab,
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab, {
              polizaId: $scope.id_for_new_tab,
            }),
          });
          $localStorage.tab_states = appStates.states;
        }
      }
    };

    $scope.show_financiero = true;
    $scope.show_produccion = false;
    $scope.show_cotizacion = false;
    $scope.show_gastos = false;
    $scope.show_task = false;

    if ($sessionStorage.token !== undefined) {
      $http.get(url.IP + "filtros-subramos-dash/").then(function (response) {
        $scope.has_sr_conf =
          response &&
          response.data &&
          response.data.data &&
          response.data.data.length > 0
            ? true
            : false;
      });
    }

    // $scope.goToEndorsement = function(name, route, endorsement){
    //   $scope.name_for_new_tab = name;
    //   $scope.route_for_new_tab = route;

    //   var existe = false;
    //   if (name && route){
    //     $scope.route_for_new_tab = route;
    //     $scope.name_for_new_tab = name;
    //     appStates.states.forEach(function(state) {
    //       if (state.route == $scope.route_for_new_tab){
    //         existe = true;
    //       }
    //     });
    //   }

    //   if (!existe){
    //     var active_tab = appStates.states.findIndex(function(item){
    //       if (item.active){
    //         return true
    //       }
    //       return false;
    //     });

    //     appStates.states[active_tab] = {
    //       name: $scope.name_for_new_tab,
    //       heading: $scope.name_for_new_tab,
    //       route: $scope.route_for_new_tab,
    //       active: true,
    //       isVisible: true,
    //       href: $state.href($scope.route_for_new_tab),
    //     }
    //   }
    //   $localStorage.tab_states = appStates.states;

    //   var params = { 'endosoId': endorsement.id }
    //   $state.go($scope.route_for_new_tab, params);
    // }

    $scope.goToEndorsement = function (name, route, endorsement) {
      console.log(endorsement);
      var name = "Información endosos";
      var route = "endorsement.info";

      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      } else {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.route == route) {
            item.id = endorsement.id;
          }
        });
      }
      $localStorage.tab_states = appStates.states;
      $state.go("endorsement.info", { endosoId: endorsement.id });
    };

    $scope.goToSiniester = function (name, route) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;

      $state.go($scope.route_for_new_tab);
    };

    $scope.goToTask = function (item) {
      if (item.model == 26) {
        return;
      }

      if (item.involucrado_por_area == true) {
        return;
      }
      if (item.model == 22) {
        // $state.go('task.task', {id_task: item.id_reference, main_comming: true} )
        $scope.name_for_new_tab = "Tareas";
        $scope.route_for_new_tab = "task.task";
        var params = { id_task: item.id_reference, main_comming: true };
        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }

        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });

          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab, params),
          };
        }
        $localStorage.tab_states = appStates.states;
        $state.go($scope.route_for_new_tab, params);
      } else if (item.model == 31) {
        if (item.recordatorio) {
          if (item.recordatorio) {
            if (item.recordatorio.tipo == 1) {
              //atm
              $http.patch(item.url, { seen: true });
              main.notifications["count"] = main.notifications["count"] - 1;
              $rootScope.notificationscount = $rootScope.notificationscount - 1;
              $scope.name_for_new_tab = "Recordatorio Automático";
              // $scope.route_for_new_tab = 'recordatorios.table';
              $scope.route_for_new_tab = "recordatorios.automaticos_show";
              var params = { id: item.id_reference };
            } else if (item.recordatorio.tipo == 2) {
              //atm
              $http.patch(item.url, { seen: true });
              main.notifications["count"] = main.notifications["count"] - 1;
              $rootScope.notificationscount = $rootScope.notificationscount - 1;
              $scope.name_for_new_tab = "Recordatorio Libre";
              // $scope.route_for_new_tab = 'recordatorios.table';
              $scope.route_for_new_tab = "recordatorios.libres_show";
              var params = { id: item.recordatorio.id };
            } else if (item.recordatorio.tipo == 3) {
              //atm
              $http.patch(item.url, { seen: true });
              main.notifications["count"] = main.notifications["count"] - 1;
              $rootScope.notificationscount = $rootScope.notificationscount - 1;
              $scope.name_for_new_tab = "Recordatorio desde registro";
              // $scope.route_for_new_tab = 'recordatorios.table';
              $scope.route_for_new_tab = "recordatorios.desde_registro_show";
              var params = { id: item.recordatorio.id };
            }
          }
        }
        var existe = false;
        var route = $scope.route_for_new_tab;
        var name = $scope.name_for_new_tab;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }

        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });

          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab, params),
          };
        }
        $localStorage.tab_states = appStates.states;
        $state.go($scope.route_for_new_tab, params);
      } else if (item.model == 15) {
        //bitácora de algún registro
        if (item.id_reference) {
          //id del comentario / bitácora
          $scope.listo = false;
          $http({
            method: "GET",
            url: url.IP + "commentsById/" + item.id_reference,
          })
            .then(function (request) {
              if (request && request.data) {
                var bitacora = request.data;
                var model = bitacora.model;
                var idreference = bitacora.id_model;
                var params = {};
                if (model == 1 || model == 6) {
                  $http.patch(item.url, { seen: true });
                  main.notifications["count"] = main.notifications["count"] - 1;
                  $rootScope.notificationscount =
                    $rootScope.notificationscount - 1;
                  $scope.name_for_new_tab = "Información pólizas";
                  $scope.route_for_new_tab = "polizas.info";
                  params = { polizaId: idreference };
                  $scope.listo = true;
                  $scope.redireccionar(
                    $scope.route_for_new_tab,
                    $scope.name_for_new_tab,
                    params
                  );
                }
                if (model == 2) {
                  $http
                    .get(url.IP + "contractor/" + idreference + "/")
                    .then(function (response) {
                      $scope.contratante_ok = response.data;
                      $http.patch(item.url, { seen: true });
                      main.notifications["count"] =
                        main.notifications["count"] - 1;
                      $rootScope.notificationscount =
                        $rootScope.notificationscount - 1;
                      $scope.name_for_new_tab = "Información contratante";
                      $scope.route_for_new_tab = "contratantes.info";
                      params = {
                        contratanteId: idreference,
                        type:
                          $scope.contratante_ok.type_person == 1
                            ? "fisicas"
                            : "morales",
                      };
                      $scope.listo = true;
                      $scope.redireccionar(
                        $scope.route_for_new_tab,
                        $scope.name_for_new_tab,
                        params
                      );
                    });
                }
                if (model == 4) {
                  // ('Información póliza','flotillas.info',  {polizaId: insurance.id}, insurance.id);
                  $http
                    .get(url.IP + "recibos/" + idreference + "/")
                    .then(function (response) {
                      var recibo = response.data;
                      $http.patch(item.url, { seen: true });
                      main.notifications["count"] =
                        main.notifications["count"] - 1;
                      $rootScope.notificationscount =
                        $rootScope.notificationscount - 1;
                      if (
                        response.data.receipt_type == 1 &&
                        recibo.poliza_document_type == 1
                      ) {
                        $scope.name_for_new_tab = "Información póliza";
                        $scope.route_for_new_tab = "polizas.info";
                        params = { polizaId: recibo.poliza_id };
                      } else if (
                        response.data.receipt_type == 1 &&
                        recibo.poliza_document_type == 3
                      ) {
                        $scope.name_for_new_tab = "Información Póliza Grupo";
                        $scope.route_for_new_tab = "polizas.info";
                        params = { polizaId: recibo.poliza_id };
                      } else if (
                        response.data.receipt_type == 1 &&
                        recibo.poliza_document_type == 12
                      ) {
                        $scope.name_for_new_tab = "Información Póliza Flotilla";
                        $scope.route_for_new_tab = "flotillas.info";
                        params = { polizaId: recibo.poliza_parent_id };
                      } else if (
                        response.data.receipt_type == 1 &&
                        (recibo.poliza_document_type == 7 ||
                          recibo.poliza_document_type == 8)
                      ) {
                        if (insurance.document_type == 8) {
                          var name = "Información fianza";
                          var route = "fianzas.details";
                        } else {
                          var name = "Información fianza";
                          var route = "fianzas.info";
                        }
                        $scope.name_for_new_tab = name;
                        $scope.route_for_new_tab = route;
                        params = { polizaId: recibo.poliza_id };
                      } else if (
                        response.data.receipt_type == 2 ||
                        response.data.receipt_type == 3
                      ) {
                        if (document_type == 7 || document_type == 8) {
                          $scope.name_for_new_tab = "Información endoso";
                          $scope.route_for_new_tab = "endorsement.details";
                          params = { endosoId: recibo.endo_id };
                        } else {
                          $scope.name_for_new_tab = "Información endoso";
                          $scope.route_for_new_tab = "endorsement.info";
                          params = { endosoId: recibo.endo_id };
                        }
                      } else {
                        $scope.name_for_new_tab = "Información póliza";
                        $scope.route_for_new_tab = "polizas.info";
                      }
                      $scope.listo = true;
                      $scope.redireccionar(
                        $scope.route_for_new_tab,
                        $scope.name_for_new_tab,
                        params
                      );
                    });
                }
                if (model == 8) {
                  $http.patch(item.url, { seen: true });
                  main.notifications["count"] = main.notifications["count"] - 1;
                  $rootScope.notificationscount =
                    $rootScope.notificationscount - 1;
                  $scope.route_for_new_tab = "grupos.info";
                  params = { grupoId: idreference };
                  $scope.listo = true;
                  $scope.redireccionar(
                    $scope.route_for_new_tab,
                    $scope.name_for_new_tab,
                    params
                  );
                }
                if (model == 10) {
                  $http
                    .get(url.IP + "endorsement/" + idreference + "/")
                    .then(function (response) {
                      var endoso = response.data;
                      $http.patch(item.url, { seen: true });
                      main.notifications["count"] =
                        main.notifications["count"] - 1;
                      $rootScope.notificationscount =
                        $rootScope.notificationscount - 1;
                      if (
                        endoso.poliza_document_type == 7 ||
                        endoso.poliza_document_type == 8
                      ) {
                        $scope.name_for_new_tab = "Información endoso";
                        $scope.route_for_new_tab = "endorsement.details";
                        params = { endosoId: endoso.id };
                      } else {
                        $scope.name_for_new_tab = "Información endoso";
                        $scope.route_for_new_tab = "endorsement.info";
                        params = { endosoId: endoso.id };
                      }
                      $scope.listo = true;
                      $scope.redireccionar(
                        $scope.route_for_new_tab,
                        $scope.name_for_new_tab,
                        params
                      );
                    });
                }
                if (model == 12) {
                  $scope.name_for_new_tab = "Información Estado de Cuenta";
                  $scope.route_for_new_tab = "agentes.receipts";
                  $http.patch(item.url, { seen: true });
                  main.notifications["count"] = main.notifications["count"] - 1;
                  $rootScope.notificationscount =
                    $rootScope.notificationscount - 1;
                  params = { folioId: idreference };
                  $scope.listo = true;
                  $scope.redireccionar(
                    $scope.route_for_new_tab,
                    $scope.name_for_new_tab,
                    params
                  );
                }
                if (model == 13) {
                  $http
                    .get(url.IP + "polizas/" + idreference + "/")
                    .then(function (response) {
                      $http.patch(item.url, { seen: true });
                      main.notifications["count"] =
                        main.notifications["count"] - 1;
                      $rootScope.notificationscount =
                        $rootScope.notificationscount - 1;
                      if (response.data.document_type == 8) {
                        var name = "Información fianza";
                        var route = "fianzas.details";
                      } else {
                        var name = "Información fianza";
                        var route = "fianzas.info";
                      }
                      $scope.name_for_new_tab = name;
                      $scope.route_for_new_tab = route;
                      params = { polizaId: idreference };
                      $scope.listo = true;
                      $scope.redireccionar(
                        $scope.route_for_new_tab,
                        $scope.name_for_new_tab,
                        params
                      );
                    });
                }
                if (model == 18) {
                  var name = "Información Póliza Grupo";
                  var route = "colectividades.info";
                  $http.patch(item.url, { seen: true });
                  main.notifications["count"] = main.notifications["count"] - 1;
                  $rootScope.notificationscount =
                    $rootScope.notificationscount - 1;
                  $scope.name_for_new_tab = name;
                  $scope.route_for_new_tab = route;
                  params = { polizaId: idreference };
                  $scope.listo = true;
                  $scope.redireccionar(
                    $scope.route_for_new_tab,
                    $scope.name_for_new_tab,
                    params
                  );
                }
                if (model == 22) {
                  var name = "Información Tareas";
                  var route = "task.task";
                  $http.patch(item.url, { seen: true });
                  main.notifications["count"] = main.notifications["count"] - 1;
                  $rootScope.notificationscount =
                    $rootScope.notificationscount - 1;
                  $scope.name_for_new_tab = name;
                  $scope.route_for_new_tab = route;
                  params = { id_task: idreference, main_comming: true };
                  $scope.listo = true;
                  $scope.redireccionar(
                    $scope.route_for_new_tab,
                    $scope.name_for_new_tab,
                    params
                  );
                }
                if (model == 28) {
                  // 'Flotillas', 'flotillas.info', {polizaId: parseInt(polizaObj.caratula)}, polizaObj.caratula);
                  $http
                    .get(url.IP + "polizas/" + idreference + "/")
                    .then(function (response) {
                      var name = "Información Flotilla";
                      var route = "flotillas.info";
                      var polizaObj = response.data;
                      $http.patch(item.url, { seen: true });
                      main.notifications["count"] =
                        main.notifications["count"] - 1;
                      $rootScope.notificationscount =
                        $rootScope.notificationscount - 1;
                      $scope.name_for_new_tab = name;
                      $scope.route_for_new_tab = route;
                      params = { polizaId: polizaObj.caratula };
                      $scope.listo = true;
                      $scope.redireccionar(
                        $scope.route_for_new_tab,
                        $scope.name_for_new_tab,
                        params
                      );
                    });
                }
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
          // MODEL_CHOICES = ((1, u'Pólizas'),
          // (2, u'Contratantes'),
          // (4, u'Recibos'),
          // (5, u'Siniestros'),
          // (6, u'Renovaciones'),
          // (7, u'Recibos-Comisiones'),
          // (8, u'Grupos'),
          // (9, u'Paquetes'),
          // (10, u'Endosos'),
          // (11, u'Aseguradoras'),
          // (12, u'Estados de Cuenta'),
          // (13, u'Fianzas'),
          // (14, u'Afianzadoras'),
          // (15, u'Comentarios'),
          // (16, u'Logs') ,
          // (17, u'Cartas'),
          // (18, u'Colectividades'),
          // (19, u'Graphs'),
          // (20, u'Notes'),
          // (21, u'Fianzas Reclamaciones'),
          // (22, u'Tareas'),
          // (23, u'Tareas Completados'),
          // (24, u'Events'),
          // (25, u'Certificado'),
          // (26, u'Reportes'),
          // (27, u'NotificaciónApp'),
          // (28, u'Flotillas'),
          // (29, u'Plantilla Correo'),
          // (30, u'Cotizacion'),
          // (31, u'Recordatorios'),
          // (32, u'LogSystem'),
          // (33, u'Plantilla SMS'),
          // (34, u'Conceptos Generales Referenciador'),
          // )
        }
      } else {
        SweetAlert.swal({
          title: "¡Aviso!",
          text: item.description,
          type: "info",
        });
      }
    };
    $scope.redireccionar = function (
      route_for_new_tab,
      name_for_new_tab,
      params
    ) {
      var existe = false;
      var route = route_for_new_tab;
      var name = name_for_new_tab;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };
    $scope.showReminder = function (recordatorio, index) {};
    $scope.updateChat = function () {
      if ($scope.chat_user_active == true) {
        $scope.chat_user_active = false;
      } else {
        $scope.chat_user_active = true;
      }
      main.chat = [];
      main.chat_receive = [];

      $http.get(url.IP + "usuarios").then(function (data_usuarios) {
        main.users = data_usuarios.data.results;
      });
      // var ref_admin = firebase.database().ref().child('Chats').orderByChild('org').equalTo(usr.org);
      // main.chat_receive =$firebaseObject(ref_admin);

      // if (usr.name =='user'){
      //   main.user_is_staff = true
      // }

      // if(main.user_is_staff == false){
      //   var ref = firebase.database().ref().child('Chats').orderByChild('from').equalTo(usr.name);
      //   var ref_admin = firebase.database().ref().child('Chats').orderByChild('from').equalTo(main.user_admin);
      //   main.chat =$firebaseObject(ref);
      //   main.chat_receive =$firebaseObject(ref_admin);
      // }
      // else{
      //   var ref_admin = firebase.database().ref().child('Chats').orderByChild('to').equalTo(main.user_admin);
      //   main.chat_receive =$firebaseObject(ref_admin);
      // }
    };
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr_log = JSON.parse(decryptedUser);
    $scope.user_pay = {};
    if ($location.path() !== "/login/auth") {
      $http({
        method: "GET",
        url: url.IP + "get_user_by_username/",
        params: {
          username: usr_log.name,
        },
      })
        .then(function (request) {
          $scope.user_pay = request.data;
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }
    $scope.ver_select_pay = false;
    // dataFactory.get('has-add-emails-permission')
    // .then(function(req) {
    //   if(true) {
    //     $scope.add_emails = req.data;
    //   }
    // });

    function sort(a, b) {
      var nameA = a.toLowerCase(),
        nameB = b.toLowerCase();
      if (nameA > nameB) {
        return 1;
      } else {
        return 0;
      }
    }

    $scope.openChat = function (user) {
      main.active_chat["user"] = user;
      if (!main.active_chat.user.id) {
        return;
      }
      if ($scope.chat_active == true) {
        $scope.chat_active = false;
      } else {
        $scope.chat_active = true;
      }

      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.usr_name = usr.name;
      $scope.usr_org = usr.org;
      var rootRef = firebase.database().ref();
      var to_usr_name = user.username;

      if (sort($scope.usr_name, to_usr_name) != 1) {
        var id = $scope.usr_name + "_" + to_usr_name;
      } else {
        var id =
          to_usr_name.toLowerCase() + "_" + $scope.usr_name.toLowerCase();
      }

      var ref_admin = rootRef
        .child("Chats/" + $scope.usr_org)
        .orderByChild("id")
        .equalTo(id);
      main.chat_receive = $firebaseObject(ref_admin);
    };

    $scope.closeChat = function () {
      $scope.chat_active = false;
    };

    $scope.closeUsersChat = function () {
      $scope.chat_user_active = false;
    };

    $scope.showInformationQ = function (item) {
      // $state.go('task.task', {id_task: item.id_reference, main_comming: true} )
      $scope.name_for_new_tab = "Cotización";
      $scope.route_for_new_tab = "cotizacion.info";
      var params = {
        id_cotizacion: item.id,
        main_comming: true,
        polizaId: item.id,
      };
      var existe = false;
      if ($scope.name && $scope.route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.searchChatUser = function (string) {
      if (string == "") {
        return;
      }
    };

    $scope.sendChatMessage = function (text) {
      if (text == "") {
        return;
      }
      $http
        .post(url.IP + "send-push-message", {
          content: text,
          to: main.active_chat.user.id,
        })
        .then(function (response) {
          main.chat_text = "";
        });
    };

    /* -------- Inicia asistente -------- */
    $scope.assistantStart = false;
    $scope.num_message = 0;

    $scope.openAssistant = function () {
      $scope.assistantStart = true;
      main.chat_assistant = [];
      $scope.sendAssistantMessage(2, "hola");
    };

    $scope.minimizerAssistant = function (clic) {
      if (clic == 1) {
        angular
          .element(document.getElementById("box-assistant"))
          .scope()
          .getInfo();
        document.getElementById("box-assistant").style.height = "400px";
        document.getElementsByClassName(
          "header-assistant"
        )[0].style.borderBottomLeftRadius = "0px";
        document.getElementsByClassName(
          "header-assistant"
        )[0].style.borderBottomRightRadius = "0px";
        document.getElementsByClassName("content-assistant")[0].style.display =
          "block";
        document.getElementsByClassName("footer-assistant")[0].style.display =
          "block";
        $scope.minimizer = false;
        $scope.num_noti = 0;
        clic = clic + 1;
      } else {
        document.getElementById("box-assistant").style.height = "44px";
        document.getElementsByClassName(
          "header-assistant"
        )[0].style.borderBottomLeftRadius = "20px";
        document.getElementsByClassName(
          "header-assistant"
        )[0].style.borderBottomRightRadius = "20px";
        document.getElementsByClassName("content-assistant")[0].style.display =
          "none";
        document.getElementsByClassName("footer-assistant")[0].style.display =
          "none";
        $scope.minimizer = true;
        clic = 1;
      }
    };

    $scope.closeAssistant = function () {
      $scope.assistantStart = false;
      main.chat_assistant = [];
      main.message_assistant = "";
      $scope.sendAssistantMessage(0, "/restart");
    };

    var altura = 293;

    $scope.sendAssistantMessage = function (value, text) {
      if (text == "") {
        return;
      } else {
        if (isNaN(text)) {
          if (main.chat_assistant.length) {
            for (var j = 1; j <= $scope.num_message; j++) {
              main.chat_assistant[
                main.chat_assistant.length - j
              ].actual = false;
            }
          }
          if (value == 2) {
            var msj = {
              owner: "user",
              message: text,
              date: new Date(),
              actual: false,
            };
            main.chat_assistant.push(msj);
          }
          main.message_assistant = "";
          msj = {
            owner: "ia",
            message: { text: "Escribiendo..." },
            date: new Date(),
            actual: true,
          };
          main.chat_assistant.push(msj);
          altura = altura + 800;
          $(".content-assistant").animate({ scrollTop: altura + "px" });
        } else {
          $scope.minimizerAssistant(1);
          $state.go("polizas.info", { polizaId: text });
        }
      }
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr_log1 = JSON.parse(decryptedUser);

      var urlBot =
        "https://ed14-2806-268-481-77b-242d-6183-f81c-33d1.ngrok.io/webhooks/rest/webhook";
      var urlBot = "https://saam-test.ixuah.com/webhooks/rest/webhook";
      // var urlBot ='https://8437-2806-268-481-77b-acf5-f482-ec11-cd4b.ngrok.io/webhooks/rest/webhook'

      var data_ = JSON.stringify({
        sender: $scope.infoUser.token_jwt + "-org-" + usr_log1.org,
        message: text,
      });

      $http({
        method: "POST",
        url: urlBot,
        data: data_,
        headers: {
          "Access-Control-Allow-Origin:": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          "Content-Type": "multipart/form-data",
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              $scope.num_message = request.data.length;
              $scope.num_noti = request.data.length;
              main.chat_assistant.splice(main.chat_assistant.length - 1, 1);
              for (var i = 0; i < request.data.length; i++) {
                var msj = {
                  owner: "ia",
                  message: request.data[i],
                  date: new Date(),
                  actual: true,
                };
                msj["message"].text = msj["message"].text.replace(
                  /\n/g,
                  "<br>"
                );
                //msj['message'].text =$sce.trustAsHtml(msj['message'].text)
                main.chat_assistant.push(msj);
                altura = altura + 800;
                $(".content-assistant").animate({ scrollTop: altura + "px" });
              }
            } else {
              $scope.num_message = 1;
              main.chat_assistant.splice(main.chat_assistant.length - 1, 1);
              var msj = {
                owner: "ia",
                message: {
                  text: "Lo lamento, no encontré resultados, ¿tienes otra pregunta?",
                },
                date: new Date(),
                actual: true,
              };
              main.chat_assistant.push(msj);
            }
          },
          function error(error) {
            console.log("error - bot", error);
          }
        )
        .catch(function (e) {
          console.log("error - BOT - catch", e);
        });
    };
    /* -------- Termina asistente ------- */

    /* -------- Inicia KBI -------- */

    $scope.show_financiero = true;
    $scope.show_produccion = false;
    $scope.show_cotizacion = false;
    $scope.show_gastos = false;
    $scope.showLoaderKbi = false;
    main.exportDataReceiptsAll = exportDataReceiptsAll;

    function exportDataReceiptsAll(param) {
      var lrc = Ladda.create(document.querySelector(".ladda-button3"));
      lrc.start();
      main.show_cobranza = false;
      if (main.cadena) {
        var params = {
          tipo: parType,
          order: order,
          asc: asc,
          cadena: main.cadena,
          serie: main.serie ? main.serie : null,
        };
      } else {
        var params = {
          tipo: parType,
          order: order,
          asc: asc,
          serie: main.serie ? main.serie : null,
          cadena: main.cadena ? main.cadena : null,
        };
      }
      if (param == 2) {
        $http({
          method: "GET",
          url: url.IP + "excel-graficas-recibos/",
          // url: url.IP +'v2/recibos/excel-graficas-recibos/',
          params: params,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            lrc.stop();
            console.log(
              "iiaaaaai",
              $localStorage["graficas_recibos_url"],
              url.IP + "excel-graficas-recibos/"
            );
            var blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte_Cobranza.xls");
          } else {
            lrc.stop();
          }
        });
      }
    }

    $scope.convertDateMain = function (inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    };

    $scope.charts_kbi = {};
    $scope.newGoal = {
      value: null,
      model: null,
      options: [
        { id: "1", name: "MXN" },
        { id: "2", name: "USD" },
      ],
    };
    $scope.currencies = [
      { id: "1", name: "MXN" },
      { id: "2", name: "USD" },
    ];
    $scope.options = [
      { id: "1", name: "Año" },
      { id: "2", name: "Ramo" },
      { id: "3", name: "Subramo" },
    ];
    $scope.newGoal.model = $scope.newGoal.options[0].id;
    $scope.year_kbi = new Date().getFullYear();
    $scope.currency_kbi = "1";
    $scope.show_for = "1";

    $scope.show_currency_mxn = true;
    $scope.show_currency_usd = false;
    $scope.show_currency_eur = false;
    $scope.show_currency_udi = false;

    $scope.startDate_production = $scope.convertDateMain(
      new Date("01-01-" + new Date().getFullYear())
    );
    $scope.endDate_production = $scope.convertDateMain(new Date());

    $scope.data_filter = {
      since_year: new Date().getFullYear() - 1,
      until_year: new Date().getFullYear(),
      since_day: $scope.startDate_production,
      until_day: $scope.endDate_production,
    };

    $scope.concepts = [
      { concept: "Renta / Alquiler", cantidad: "", value: 1 },
      { concept: "Nómina", cantidad: "", value: 2 },
      { concept: "Servicios Públicos", cantidad: "", value: 3 },
      { concept: "Publicidad", cantidad: "", value: 4 },
      { concept: "Impuestos", cantidad: "", value: 5 },
      { concept: "Materiales de oficina", cantidad: "", value: 6 },
      { concept: "Tributos", cantidad: "", value: 7 },
      { concept: "Préstamos o hipotecas", cantidad: "", value: 8 },
      { concept: "Servicios de empresas externas", cantidad: "", value: 9 },
    ];

    if ($sessionStorage.infoUser) {
      $scope.url_kbi = "kbi/";
      // }else{
      //   $scope.url_kbi = 'v2/core/kbi/'
      // }
    } else {
      $scope.url_kbi = "kbi/";
    }

    $scope.getFilter = function (value, param, startDate, endDate) {
      $scope.year_kbi = param;
      if (value == 0) {
        $scope.year_kbi = new Date().getFullYear();
        $scope.data_filter = {
          since_year: new Date().getFullYear() - 1,
          until_year: new Date().getFullYear(),
          since_day: $scope.startDate_production,
          until_day: $scope.endDate_production,
        };
      } else {
        $scope.data_filter = {
          since_year: $scope.year_kbi - 1,
          until_year: $scope.year_kbi,
          since_day: startDate,
          until_day: endDate,
        };
      }
      $scope.getInfo();
    };

    $scope.changeCurrencyKbi = function (value) {
      if (value == "1") {
        $scope.show_currency_mxn = true;
        $scope.show_currency_usd = false;
        $scope.show_currency_eur = false;
        $scope.show_currency_udi = false;
        $scope.currency_kbi = "1";
      } else if (value == "2") {
        $scope.show_currency_mxn = false;
        $scope.show_currency_usd = true;
        $scope.show_currency_eur = false;
        $scope.show_currency_udi = false;
        $scope.currency_kbi = "2";
      } else if (value == "3") {
        $scope.show_currency_mxn = false;
        $scope.show_currency_usd = false;
        $scope.show_currency_eur = true;
        $scope.show_currency_udi = false;
      } else if (value == "4") {
        $scope.show_currency_mxn = false;
        $scope.show_currency_usd = false;
        $scope.show_currency_eur = false;
        $scope.show_currency_udi = true;
      }
    };

    $scope.getInfo = function () {
      $scope.showLoaderKbi = true;
      if ($scope.charts_kbi) {
        $scope.charts_kbi.aseguradoras = {};
        $scope.charts_kbi.aseguradorasDolar = {};
        $scope.charts_kbi.subramos = {};
        $scope.charts_kbi.subramosDolar = {};
      }
      // dataFactory.post('kbi/')
      dataFactory
        .post($scope.url_kbi, $scope.data_filter)
        .then(function success(response) {
          $scope.charts_kbi = response.data;
          $scope.now = $scope.convertDateMain(new Date());
          $scope.charts_kbi.ejecutivos = JSON.parse(response.data.ejecutivos);
          $scope.charts_kbi.ejecutivosDolar = JSON.parse(
            response.data.ejecutivosDolar
          );
          $scope.charts_kbi.aseguradoras = JSON.parse(
            response.data.aseguradoras
          );
          $scope.charts_kbi.aseguradorasDolar = JSON.parse(
            response.data.aseguradorasDolar
          );
          $scope.charts_kbi.subramos = JSON.parse(response.data.subramos);
          $scope.charts_kbi.subramosDolar = JSON.parse(
            response.data.subramosDolar
          );
          $scope.charts_kbi.goal.percentajeGoal = parseFloat(
            $scope.charts_kbi.goal.percentajeGoal
          ).toFixed(2);
          $scope.progressGoal = {
            width: $scope.charts_kbi.goal.percentajeGoal + "%",
          };

          if ($scope.charts_kbi.goal.value > 0) {
            $scope.showBtnKbi = true;
            var fin = new Date();
            var f = fin.getFullYear() - 1;
            $scope.fin = fin.getFullYear();
            $scope.range_pc =
              "De: " + $scope.now + " al " + "31/12/" + $scope.fin;
            $scope.range_cp =
              "De: " + "01/01/" + $scope.fin + " al " + $scope.now;
            $scope.range_date =
              "De: " + "01/01/" + $scope.fin + " al " + "31/12/" + $scope.fin;
            $scope.range_bar = "Años: " + f + " y " + fin.getFullYear();
          } else {
            $scope.showBtnKbi = false;
          }

          $scope.newGoal.value = parseFloat($scope.charts_kbi.goal.value);
          $scope.newGoal.model = $scope.charts_kbi.goal.currency;

          if ($scope.charts_kbi.monthsUtilidad) {
            $scope.total_utilidad = 0;
            $scope.charts_kbi.monthsUtilidad.forEach(function (item) {
              if (item.value) {
                $scope.total_utilidad = parseFloat(
                  ($scope.total_utilidad + parseFloat(item.value)).toFixed(2)
                );
              }
            });
          }
          $scope.showLoaderKbi = false;
        });
    };

    $scope.selectMonth = function (mes) {
      $scope.month_selected = mes.id;
    };

    $scope.show_tab_kbi = function (value) {
      if (value == 1) {
        $scope.show_financiero = true;
        $scope.show_produccion = false;
        $scope.show_cotizacion = false;
        $scope.show_gastos = false;
      } else if (value == 2) {
        $scope.show_financiero = false;
        $scope.show_produccion = true;
        $scope.show_cotizacion = false;
        $scope.show_gastos = false;
      } else if (value == 3) {
        $scope.show_financiero = false;
        $scope.show_produccion = false;
        $scope.show_cotizacion = true;
        $scope.show_gastos = false;
      } else if (value == 4) {
        $scope.show_financiero = false;
        $scope.show_produccion = false;
        $scope.show_cotizacion = false;
        $scope.show_gastos = true;
      }
      // if($scope.show_currency_mxn){
      //   $scope.changeCurrencyKbi("1");
      // }else if($scope.show_currency_usd){
      //   $scope.changeCurrencyKbi("2");
      // }
    };

    $scope.show_ejectivo = true;
    $scope.show_aseguradora = false;
    $scope.show_subramo = false;

    $scope.show_tab_production = function (value) {
      if (value == 1) {
        $scope.show_ejectivo = true;
        $scope.show_aseguradora = false;
        $scope.show_subramo = false;
      } else if (value == 2) {
        $scope.show_ejectivo = false;
        $scope.show_aseguradora = true;
        $scope.show_subramo = false;
      } else if (value == 3) {
        $scope.show_ejectivo = false;
        $scope.show_aseguradora = false;
        $scope.show_subramo = true;
      }
    };

    $scope.saveGoal = function () {
      dataFactory.post("goal/", { goal: $scope.newGoal.value });
      $scope.showBtnKbi = true;
    };

    $scope.editGoal = function () {
      dataFactory.post("goal/", { goal: $scope.newGoal.value });
      $scope.showBtnKbi = false;
    };

    $scope.saveGastos = function () {
      var obj = [];
      $scope.concepts.forEach(function (child, index) {
        if (child.concept && child.cantidad) {
          child.month = $scope.month_selected;
          obj.push(child);
        }
        if ($scope.concepts.length == index + 1) {
          dataFactory.post("expenses/", obj).then(function success(response) {
            if (response.status == 201) {
              $scope.concepts = [
                { concept: "Renta / Alquiler", cantidad: "", value: 1 },
                { concept: "Nómina", cantidad: "", value: 2 },
                { concept: "Servicios Públicos", cantidad: "", value: 3 },
                { concept: "Publicidad", cantidad: "", value: 4 },
                { concept: "Impuestos", cantidad: "", value: 5 },
                { concept: "Materiales de oficina", cantidad: "", value: 6 },
                { concept: "Tributos", cantidad: "", value: 7 },
                { concept: "Préstamos o hipotecas", cantidad: "", value: 8 },
                {
                  concept: "Servicios de empresas externas",
                  cantidad: "",
                  value: 9,
                },
              ];
              $scope.getInfo();
            }
          });
        }
      });
    };

    $scope.months_kbi = [
      { id: 1, month: "Enero" },
      { id: 2, month: "Febrero" },
      { id: 3, month: "Marzo" },
      { id: 4, month: "Abril" },
      { id: 5, month: "Mayo" },
      { id: 6, month: "Junio" },
      { id: 7, month: "Julio" },
      { id: 8, month: "Agosto" },
      { id: 9, month: "Septiembre" },
      { id: 10, month: "Octubre" },
      { id: 11, month: "Noviembre" },
      { id: 12, month: "Diciembre" },
    ];

    $scope.monthName = function (month) {
      switch (month) {
        case 1:
          return "Enero";
          break;
        case 2:
          return "Febrero";
          break;
        case 3:
          return "Marzo";
          break;
        case 4:
          return "Abril";
          break;
        case 5:
          return "Mayo";
          break;
        case 6:
          return "Junio";
          break;
        case 7:
          return "Julio";
          break;
        case 8:
          return "Agosto";
          break;
        case 9:
          return "Septiembre";
          break;
        case 10:
          return "Octubre";
          break;
        case 11:
          return "Noviembre";
          break;
        case 12:
          return "Diciembre";
          break;
      }
    };

    $scope.addConcept = function () {
      var concept = {
        concept: "",
        cantidad: "",
        value: 10,
      };
      $scope.concepts.push(concept);
    };

    $scope.removeConcept = function (item) {
      $scope.concepts.splice(item, 1);
    };

    $scope.validateDecimal = function (input) {
      if (input) {
        if (parseFloat(input) < 0) {
          $scope.$filternewGoal.value = 0;
        } else {
          $scope.newGoal.value = parseFloat(input.toFixed(2));
        }
      }
    };

    $scope.validateGasto = function (input) {
      if (input) {
        for (var i = 0; i < $scope.concepts.length; i++) {
          if ($scope.concepts[i].cantidad != "") {
            if (parseFloat($scope.concepts[i].cantidad) < 0) {
              $scope.concepts[i].cantidad = 0;
            } else {
              $scope.concepts[i].cantidad = parseFloat(
                $scope.concepts[i].cantidad.toFixed(2)
              );
            }
          }
        }
      }
    };

    $scope.deleteConcept = function (item, index) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text:
            "Eliminar " + item.concept + ". Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .delete(item.url)
              .then(function (request) {
                SweetAlert.swal(
                  "Listo",
                  "El concepto ha sido eliminado",
                  "success"
                );
                $scope.getInfo();
              })
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
            SweetAlert.swal(
              "Cancelado",
              "El concepto no se ha eliminado.",
              "info"
            );
          }
        }
      );
    };

    /* --------- Termina KBI ---------- */

    if ($localStorage.url_operation == "/operacion.semanal") {
      $state.go("operacion.semanal");
    }
    main.submit = function (name, route, param) {
      // param = main.cadena;
      if (param) {
        $scope.name_for_new_tab = name;
        $scope.route_for_new_tab = route;

        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }

        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });

          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab),
          };
        }
        $localStorage.tab_states = appStates.states;

        $state.go($scope.route_for_new_tab, { cadena: param });
      } else {
        SweetAlert.swal({
          title: "¡Error!",
          text: "Por favor introduzca una busqueda válida",
          type: "error",
        });
      }
    };
    main.clearInput = function (param) {
      if (param) {
        param = "";
        main.cadena = "";
        $state.go("buscador.buscador", { cadena: param });
      } else {
        SweetAlert.swal({
          title: "¡Error!",
          text: "Por favor introduzca una busqueda válida",
          type: "error",
        });
      }
    };

    main.status = [
      {
        label: "Pagado",
        value: 1,
      },
      {
        label: "Cancelado",
        value: 2,
      },
      {
        label: "Prorrogado",
        value: 3,
      },
      {
        label: "Pendiente de Pago",
        value: 4,
      },
      {
        label: "Pago parcial",
        value: 9,
      },
    ];

    if (!$rootScope.mc_permission) {
      $rootScope.mc_permission = $sessionStorage.mc_permission;
    }

    main.saveStatus = saveStatus;
    main.ChangeStatus = ChangeStatus;
    main.totalPendingOts = {};
    main.totalEndorsement = {};
    main.recibos_pagados;
    main.endorsements = [];
    main.insurances = [];
    main.endo_vida = [];
    main.endo_gm = [];
    main.endo_danos = [];
    main.endo_autos = [];
    main.receipts = [];
    main.policies = [];
    main.notascredito = [];

    main.otColors = [
      {
        fillColor: "rgba(224, 108, 112, 1)",
        strokeColor: "rgba(207,100,103,1)",
        pointColor: "rgba(220,220,220,1)",
        pointStrokeColor: "#fff",
        pointHighlightFill: "#fff",
        pointHighlightStroke: "rgba(151,187,205,0.8)",
      },
    ];

    main.editInsurance = editInsurance;
    main.editInsuranceModal = editInsuranceModal;
    main.renewPolicy = renewPolicy;
    main.editRecibo = editRecibo;
    main.showPhone = showPhone;
    main.showEmail = showEmail;
    main.NotasModal = NotasModal;
    main.getBirthdays = getBirthdays;
    main.goToPolicy = goToPolicy;
    main.changeViewed = changeViewed;
    main.getNotifications = getNotifications;

    main.endosos_data = [
      { value: 1, name: "Automóviles" },
      { value: 2, name: "Daños" },
      { value: 3, name: "Gastos Medicos" },
      { value: 4, name: "Vida" },
    ];

    /* Mejora = 1, Error = 2 */
    main.changes = [
      //Notificaciones
      // {id: 1, desc: "Correcciones menores en vista de información de contratantes", type: 2},
      // {id: 1, desc: "Se agrega visualización de recibos de fianzas en listado de cobranza", type: 1},
      // {id: 1, desc: "Se agrega visualización de recibos de fianzas en superbuscador", type: 1},
      // {id: 1, desc: "Modulo de tareas, se resaltan aquellas tareas que tengan actualizaciones en los ultimos 3 dias", type: 1},
      //{id: 1, desc: "Mejoras en validacion de decimales en siniestros de accidentes y enfermedades", type: 1},
      //{id: 1, desc: "Mejoras en validacion de decimales en siniestros de autos", type: 1},
      //{id: 1, desc: "Validacion de numeros decimales en modulo de comisiones", type: 1},
    ];

    main.type_endoso = 1;
    main.recibos_a_pagar = [];

    /* Funciones buscador */
    main.searchOTs = searchOTs;
    main.searchNotas = searchNotas;
    main.searchReceipts = searchReceipts;
    main.searchRenewals = searchRenewals;
    main.searchSinisters = searchSinisters;
    main.excel_search = excel_search;
    main.loadMoreNotifications = loadMoreNotifications;

    function goToEndorsement(insurance) {
      if (
        insurance.policy.document_type == 1 ||
        insurance.policy.document_type == 2
      ) {
        $state.go("endosos.pendingData", {
          endorsementId: insurance.id,
          endorsementType: main.checkEndorsementType(insurance),
        });
      } else {
        $state.go("endosos.pendingDataMassive", {
          endorsementId: insurance.id,
          endorsementType: main.checkEndorsementType(insurance),
          polizaId: insurance.policy.id,
        });
      }
    }
    main.seeNotification = false;

    $scope.intervalFunction = function () {
      $timeout(function () {
        loadMoreNotifications();
        // $scope.intervalFunction();
      }, 1000);
    };
    // $scope.intervalFunction();
    // ---------------
    $scope.$on("MainCtrl:getNotifications", function (event, args) {
      NotificationService.getNotifications();
    });

    // Fetch notifications on controller load to initialize the count
    NotificationService.getNotifications();
    // --------------------
    // $scope.$on('MainCtrl:getNotifications', function(event, args) {
    //   getNotifications();
    // });
    function getNotifications() {
      if ($sessionStorage.token !== undefined) {
        dataFactory.get("notifications-test").then(function success(response) {
          $timeout(function () {
            $scope.main.notifications = response.data;
            $rootScope.notificationscount = $scope.main.notifications.count;
            $rootScope.$evalAsync(function () {
              $rootScope.notificationscount = $scope.main.notifications.count;
              console.log(
                "RootScope notifications count re-updated:",
                $rootScope.notificationscount
              );
            });
            $timeout(function () {
              $rootScope.recordatorioscount =
                $scope.main.notifications["recordatorios"];
              $scope.main.notifications.results.forEach(function (notify) {
                if (notify.seen === false && notify.model !== 31) {
                  $scope.main.notifications["count"] -= 1;
                  $rootScope.notificationscount -= 1;
                  $http.patch(notify.url, { seen: true });
                }
              });
            }, 1000);
          });
        });
      }
    }
    $(document).click(function (e) {
      var config2 = $("#config2");
      if (
        !$("#configDropdown").is(e.target) &&
        !config2.is(e.target) &&
        config2.has(e.target).length == 0
      ) {
        if (main.seeNotification) {
          main.seeNotification = false;
        }
      }
    });
    $scope.seeNot = function (parS) {
      if (!parS) {
        main.seeNotification = true;
      } else {
        main.seeNotification = false;
      }
    };
    function loadMoreNotifications() {
      try {
        $http.get(main.notifications.next).then(function success(response) {
          response.data.results.forEach(function (notify) {
            if (!notify.seen) {
              $http.patch(notify.url, { seen: true });
            }
          });
          main.notifications.results = main.notifications.results.concat(
            response.data.results
          );
          main.notifications.next = response.data.next;
        });
      } catch (r) {}
    }

    function searchOTs(cadena, gtype) {
      main.ot_pagination = [];
      if (gtype == "" || gtype == null) {
        gtype = 0;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.search_ot = 'v2/generics/search-ot-dash';
      $scope.search_ot = "search-ot-dash";
      dataFactory
        .get($scope.search_ot, { cadena: cadena, tipo: gtype })
        .then(function success(response) {
          main.insurances = response.data.insurances;
          main.endo = response.data.endo;
        });
    }

    function searchNotas(cadena) {
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.search_note = 'v2/generics/search-notas-dash';
      $scope.search_note = "search-notas-dash";
      dataFactory
        .get($scope.search_note, { cadena: cadena })
        .then(function success(response) {
          main.notascredito = response.data.results;
        });
    }

    function searchReceipts(serie, cadena, gtype) {
      main.receipts = [];
      main.config_receipts = [];
      main.show_paginationReceipts = false;
      if (gtype == "" || gtype == null) {
        gtype = 0;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.search_receipt = 'v2/generics/search-receipt-dash';
      $scope.search_receipt = "search-receipt-dash";
      if (cadena) {
        dataFactory
          .get($scope.search_receipt, {
            cadena: cadena,
            tipo: gtype,
            serie: serie ? serie : 0,
          })
          .then(function success(response) {
            main.receipts = response.data.results;
            main.config_receipts = {
              count: response.data.count,
              previous: response.data.previous,
              next: response.data.next,
            };
            response.data.results.forEach(function (rec) {
              main.recibos_a_pagar.forEach(function (rec_w) {
                if (rec.id == rec_w.id) {
                  if (rec) {
                    rec.toPay = true;
                  } else {
                  }
                }
              });
            });
            main.show_paginationReceipts = true;
          });
      } else {
        if (parseInt(gtype) == 1) {
          gtype = "green";
        } else if (parseInt(gtype) == 2) {
          gtype = "yellow";
        } else if (parseInt(gtype) == 3) {
          gtype = "orange";
        } else if (parseInt(gtype) == 4) {
          gtype = "red";
        } else {
          gtype = "all";
        }
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   var return_chart_s = 'v2/recibos/graficas-recibos/';
        var return_chart_s = "graficas-recibos/";
        $http({
          method: "GET",
          url: url.IP + return_chart_s,
          params: {
            tipo: gtype,
            order: 1,
            asc: 1,
            serie: serie ? serie : 0,
          },
        }).then(function success(response) {
          main.receipts = response.data.results;
          main.config_receipts = {
            count: response.data.count,
            previous: response.data.previous,
            next: response.data.next,
          };
          response.data.results.forEach(function (rec) {
            main.recibos_a_pagar.forEach(function (rec_w) {
              if (rec.id == rec_w.id) {
                if (rec) {
                  rec.toPay = true;
                } else {
                }
              }
            });
          });
          main.show_paginationReceipts = true;
        });
      }
    }

    function searchRenewals(cadena, gtype) {
      // main.titleID = gtype
      main.policies = [];
      main.config_renovaciones = [];
      main.show_paginationRenewals = false;
      main.show_renovaciones_pagination = false;
      if (parseInt(gtype) == 1) {
        gtype = "green";
      } else if (parseInt(gtype) == 2) {
        gtype = "yellow";
      } else if (parseInt(gtype) == 3) {
        gtype = "orange";
      } else if (parseInt(gtype) == 4) {
        gtype = "red";
      } else {
        gtype = "all";
      }
      if (gtype == "" || gtype == null) {
        gtype = "all";
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.search_renew = 'v2/generics/search-renew-dash';
      $scope.search_renew = "search-renew-dash";
      if (cadena) {
        dataFactory
          .get($scope.search_renew, { cadena: cadena, tipo: gtype })
          .then(function success(response) {
            main.policies = response.data.results;
            main.config_renovaciones = {
              count: response.data.count,
              previous: response.data.previous,
              next: response.data.next,
            };
            main.show_paginationRenewals = true;
            main.show_renovaciones_pagination = true;
          });
      } else {
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   var x_renewal = 'v2/polizas/graficas-renovaciones/';
        var x_renewal = "graficas-renovaciones/";
        main.policies = [];
        main.config_renovaciones = [];
        dataFactory
          .get(x_renewal, { cadena: cadena, tipo: gtype, order: 1, asc: 1 })
          .then(function success(response) {
            main.policies = response.data.results;
            main.config_renovaciones = {
              count: response.data.count,
              previous: response.data.previous,
              next: response.data.next,
            };
            main.show_paginationRenewals = true;
            main.show_renovaciones_pagination = true;
          });
      }
    }

    function searchSinisters(cadena, gtype) {
      main.sinisters = [];
      main.search = true;
      main.show_sinisters_pagination = false;
      main.config_sinisters = [];
      if (gtype == "" || gtype == null) {
        gtype = 0;
      }

      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.search_sinister = 'v2/generics/search-sinister-dash';
      $scope.search_sinister = "search-sinister-dash";
      if (cadena) {
        dataFactory
          .get($scope.search_sinister, { cadena: cadena, tipo: gtype })
          .then(function success(response) {
            main.sinisters = response.data.results;
            if (main.show_sinisters_pagination == false) {
              main.config_sinisters = {
                count: response.data.count,
                next: response.data.next,
                previous: response.data.previous,
              };
              main.show_sinisters_pagination = true;
            }
          });
      } else {
        if (parseInt(gtype) == 1) {
          gtype = "green";
        } else if (parseInt(gtype) == 2) {
          gtype = "yellow";
        } else if (parseInt(gtype) == 3) {
          gtype = "orange";
        } else if (parseInt(gtype) == 4) {
          gtype = "red";
        } else {
          gtype = "all";
        }
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   $scope.chart_siniester = 'v2/siniestros/graficas-siniestros/';
        $scope.chart_siniester = "graficas-siniestros/";
        $http({
          method: "GET",
          url: url.IP + $scope.chart_siniester,
          params: { tipo: gtype, order: 1, asc: 1 },
        }).then(function success(response) {
          main.sinisters = response.data.results;
          if (main.show_sinisters_pagination == false) {
            main.config_sinisters = {
              count: response.data.count,
              next: response.data.next,
              previous: response.data.previous,
            };
            main.show_sinisters_pagination = true;
          }
        });
      }
    }
    function excel_search(cadena, gtype) {
      if (gtype == "" || gtype == null) {
        gtype = 0;
      }
      if (main.cadena) {
        var params = {
          order: 1,
          asc: 1,
          tipo: gtype,
          cadena: main.cadena,
        };
      } else {
        var params = {
          order: 1,
          asc: 1,
          tipo: gtype,
        };
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   // var excel_sinister = 'v2/siniestros/excel-graficas-sinister/';
      //   var excel_sinister = 'service_reporte-v2-siniestrosDash-excel';
      var excel_sinister = "service_reporte-siniestrosDash-excel";
      $http({
        method: "GET",
        url: url.IP + excel_sinister,
        params: params,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function success(data) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Siniestros_Dash.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
      // dataFactory.get('excel-graficas-sinister-search', {cadena: cadena, tipo: gtype})
      // .then(function success(response) {
      //   main.sinisters = response.data.results;
      //   if(response.status === 200 || response.status === 201) {
      //         exportFactory.excel(response.data, 'Siniestros');

      //     }
      // })
      // }
    }

    $scope.checkStatusNotes = function (parStatusNote) {
      switch (parStatusNote) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Aplicada";
          break;
        case 2:
          return "Liquidada";
          break;
      }
    };

    $scope.configGraph = function (typeGraph) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/charts/config.chart.html",
        controller: "ConfigChartModalCtrl",
        size: "md",
        resolve: {
          typeGraphic: function () {
            return typeGraph;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    $scope.status = function (parValue) {
      if (typeof parValue === "string") {
        return parValue;
      }
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 15:
          return "No renovada";
          break;
        case 17:
          return "Anulada";
          break;
        case 24:
          return "Pre-Anulada";
          break;
        default:
          return "Pendiente *";
      }
    };

    $scope.statusRecibo = function (parValue) {
      switch (parValue) {
        case 1:
          return "Pagado";
          break;
        case 2:
          return "Cancelado";
          break;
        case 3:
          return "Prorrogado";
          break;
        case 4:
          return "Pendiente de Pago";
          break;
        case 9:
          return "Pago Parcial";
          break;
        default:
          return parValue;
      }
    };
    $scope.rectype = function (parValue) {
      if (parValue.receipt_type) {
        if (parValue.fianza) {
          return "Fianza";
        } else {
          switch (parValue.receipt_type) {
            case 1:
              if (parValue.poliza) {
                if (parValue.poliza.document_type == 3) {
                  return "Póliza de Grupo";
                } else if (parValue.poliza.document_type == 1) {
                  return "Póliza";
                } else if (parValue.poliza.document_type == 4) {
                  return "Subgrupo";
                } else if (parValue.poliza.document_type == 7) {
                  return "Fianza";
                } else if (parValue.poliza.document_type == 8) {
                  return "Fianza Colectiva";
                } else if (parValue.poliza.document_type == 11) {
                  return "Colectividad";
                } else if (parValue.poliza.document_type == 12) {
                  return "Póliza de Colectividad";
                }
              } else if (parValue.fianza) {
                return "Fianza";
              }
              break;
            case 2:
              return "Endoso";
              break;
            case 3:
              return "Nota de Crédito/Endoso";
              break;

            default:
              return "Póliza";
          }
        }
      }
      if (parValue.poliza) {
        switch (parValue.poliza.document_type) {
          case 1:
            if (parValue.receipt_type == 1) {
              return "Póliza";
            } else {
              return "Endoso";
            }
            break;
          case 2:
            return "Endoso";
            break;
          case 3:
            return "Póliza de Grupo";
            break;
          case 4:
            return "Subgrupo";
            break;
          case 7:
            return "Colectividad";
            break;
          case 11:
            return "Colectividad";
            break;
          case 12:
            return "Póliza de Colectividad";
            break;
          default:
            return "Póliza";
        }
      } else if (parValue.fianza) {
        return "Fianza";
      }
    };

    $scope.statusSinister = function (parValue) {
      switch (parValue) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "En trámite";
          break;
        case 3:
          return "Completado";
          break;
        case 4:
          return "Cancelado";
          break;
        case 5:
          return "Rechazado";
          break;
        case 6:
          return "En Espera";
          break;
      }
    };
    $scope.tipoPagoSinister = function (parValue) {
      switch (parValue) {
        case 1:
          return "Reembolso";
          break;
        case 2:
          return "Programación";
          break;
        case 3:
          return "Pago directo";
          break;
        case 4:
          return "Aclaración";
          break;
        default:
          return "No aplica";
          break;
      }
    };

    var DEFAULT_CAROUSEL = [
      {
        imagen: "../../assets/images/inicio/1-banner_ok.png",
      },
    ];
    var CAROUSEL_ORG_RETRY_DELAY = 1500;
    var MAX_CAROUSEL_ORG_RETRY_ATTEMPTS = 5;
    var carouselOrgRetryTimer = null;
    var carouselOrgRetryAttempts = 0;

    if ($sessionStorage.token !== undefined) {
      getCarousel();
    }
    getCarousel(3);

    $scope.$on("$destroy", function () {
      cancelCarouselOrgRetry();
    });

    function decodeEncryptedUserCandidate(blob) {
      if (!blob || !window.safeDecrypt) {
        return null;
      }
      return window.safeDecrypt("User", blob);
    }

    function normalizeOrgValue(value) {
      if (value === null || typeof value === "undefined") {
        return "";
      }

      if (angular.isObject(value)) {
        if (value.urlname) {
          return normalizeOrgValue(value.urlname);
        }
        if (value.org && value.org.urlname) {
          return normalizeOrgValue(value.org.urlname);
        }
        if (value.orgName) {
          return normalizeOrgValue(value.orgName);
        }
        if (value.orgname) {
          return normalizeOrgValue(value.orgname);
        }
        if (value.org) {
          return normalizeOrgValue(value.org);
        }
        return "";
      }

      if (typeof value !== "string") {
        try {
          value = value.toString();
        } catch (_) {
          return "";
        }
      }

      var trimmed = value.trim();
      if (!trimmed) {
        return "";
      }

      var lower = trimmed.toLowerCase();
      if (lower === "undefined" || lower === "null") {
        return "";
      }

      return trimmed;
    }

    function extractOrgFromCandidate(candidate) {
      if (!candidate) {
        return "";
      }

      if (angular.isString(candidate)) {
        try {
          candidate = JSON.parse(candidate);
        } catch (_) {
          return normalizeOrgValue(candidate);
        }
      }

      if (angular.isObject(candidate)) {
        var keys = ["urlname", "org", "orgName", "orgname"];
        for (var idx = 0; idx < keys.length; idx++) {
          if (candidate[keys[idx]]) {
            return normalizeOrgValue(candidate[keys[idx]]);
          }
        }

        if (candidate.orgInfo && candidate.orgInfo.urlname) {
          return normalizeOrgValue(candidate.orgInfo.urlname);
        }
      }

      return "";
    }

    function readStoredOrgUrlname() {
      var candidates = [
        main.userLogin,
        $scope.infoUser,
        decodeEncryptedUserCandidate($sessionStorage.user),
        decodeEncryptedUserCandidate($localStorage.user),
        $sessionStorage.infoUser,
        $localStorage.infoUser,
      ];

      for (var i = 0; i < candidates.length; i++) {
        var extracted = extractOrgFromCandidate(candidates[i]);
        if (extracted) {
          return extracted;
        }
      }

      return "";
    }

    function cancelCarouselOrgRetry() {
      if (carouselOrgRetryTimer) {
        $timeout.cancel(carouselOrgRetryTimer);
        carouselOrgRetryTimer = null;
      }
      carouselOrgRetryAttempts = 0;
    }

    function scheduleCarouselOrgRetry() {
      if (
        carouselOrgRetryTimer ||
        carouselOrgRetryAttempts >= MAX_CAROUSEL_ORG_RETRY_ATTEMPTS
      ) {
        return;
      }

      carouselOrgRetryTimer = $timeout(function () {
        carouselOrgRetryTimer = null;
        var orgCandidate = readStoredOrgUrlname();
        if (orgCandidate) {
          console.log(
            'getCarousel main.controller.js: detected org "%s" after invalid response. Retrying load.',
            orgCandidate
          );
          getCarousel(3);
          return;
        }

        carouselOrgRetryAttempts += 1;
        scheduleCarouselOrgRetry();
      }, CAROUSEL_ORG_RETRY_DELAY);
    }

    function hasInvalidOrgParameter(error) {
      if (!error || error.status !== 403) {
        return false;
      }

      var config = error.config || {};
      var rawUrl = (config.url || "").toString();
      if (rawUrl.toLowerCase().indexOf("get-carousel-from-cas/") === -1) {
        return false;
      }

      var orgValue = "";
      if (
        config.params &&
        typeof config.params.org !== "undefined" &&
        config.params.org !== null
      ) {
        orgValue = config.params.org;
      } else {
        var match = rawUrl.match(/[?&]org=([^&#]*)/);
        orgValue = match && match[1] ? decodeURIComponent(match[1]) : "";
      }

      if (orgValue === null || typeof orgValue === "undefined") {
        orgValue = "";
      }

      if (typeof orgValue !== "string") {
        try {
          orgValue = orgValue.toString();
        } catch (_) {
          orgValue = "";
        }
      }

      var normalizedOrg = orgValue.trim().toLowerCase();
      return (
        !normalizedOrg ||
        normalizedOrg === "undefined" ||
        normalizedOrg === "null"
      );
    }

    function getCarousel(retryCount) {
      retryCount = angular.isNumber(retryCount) ? retryCount : 3;

      var orgForRequest = readStoredOrgUrlname();
      var requestParams = orgForRequest ? { org: orgForRequest } : undefined;

      dataFactory
        .get("get-carousel-from-cas/", requestParams)
        .then(function success(response) {
          cancelCarouselOrgRetry();
          var data = response.data && response.data.data;
          $scope.carousel =
            data && data.length > 0 ? data : angular.copy(DEFAULT_CAROUSEL);
        })
        .catch(function (e) {
          if (hasInvalidOrgParameter(e)) {
            console.warn(
              "Skipping carousel retry because the org parameter is missing or invalid."
            );
            console.log(
              "getCarousel main.controller.js: fallback to default banner due to invalid org parameter."
            );
            $scope.carousel = angular.copy(DEFAULT_CAROUSEL);
            var storedOrgCandidate = readStoredOrgUrlname();
            if (storedOrgCandidate) {
              console.log(
                'getCarousel main.controller.js: stored org "%s" found after fallback. Retrying immediately.',
                storedOrgCandidate
              );
              $timeout(function () {
                getCarousel(3);
              }, 500);
              return;
            }

            carouselOrgRetryAttempts = 0;
            scheduleCarouselOrgRetry();
            return;
          }

          if (retryCount > 0) {
            console.warn(
              "getCarousel failed. Retrying in 1s... Attempts left:",
              retryCount
            );
            $timeout(function () {
              getCarousel(retryCount - 1);
            }, 1000);
          } else {
            console.error(
              "Failed to fetch carousel after multiple attempts:",
              e
            );
            $scope.carousel = angular.copy(DEFAULT_CAROUSEL);
          }
        });
    }
    // function getCarousel() {
    //   dataFactory.get('get-carousel-from-cas/').then(function success(response) {
    //     $scope.carousel = response.data.data;
    //     if($scope.carousel && $scope.carousel.length ==0){
    //       $scope.carousel=[{
    //         'imagen':'../../assets/images/inicio/1-banner_ok.png'
    //       }];
    //     }
    //     })
    //   .catch(function (e) {
    //     $scope.carousel=[{
    //       'imagen':'../../assets/images/inicio/1-banner_ok.png'
    //     }];
    //   });
    // }
    function getBirthdays() {
      if (!$localStorage.persons) {
        if ($scope.infoUser) {
          if (!$scope.infoUser.staff) {
            dataFactory.get("get-birthdays/").then(function success(response) {
              main.contractors = response.data.contractors;
              main.titulares = response.data.titulares;
              main.beneficiaries = response.data.beneficiaries;
              main.relationship = response.data.relationship;

              $localStorage.persons = response.data;
              main.persons_length =
                (main.contractors && main.contractors.length
                  ? main.contractors.length
                  : 0) +
                (main.titulares && main.titulares.length
                  ? main.titulares.length
                  : 0) +
                (main.beneficiaries && main.beneficiaries.length
                  ? main.beneficiaries.length
                  : 0) +
                (main.relationship && main.relationship.length
                  ? main.relationship.length
                  : 0);

              $localStorage.viewed = false;
            });
          } else {
            main.persons = [];
            main.contractors = [];
            main.titulares = [];
            main.beneficiaries = [];
            main.relationship = [];
          }
        } else {
          main.persons = [];
          main.contractors = [];
          main.titulares = [];
          main.beneficiaries = [];
          main.relationship = [];
        }
      } else {
        if (!$scope.infoUser.staff) {
          dataFactory.get("get-birthdays/").then(function success(response) {
            main.contractors = response.data.contractors;
            main.titulares = response.data.titulares;
            main.beneficiaries = response.data.beneficiaries;
            main.relationship = response.data.relationship;

            $localStorage.persons = response.data;
            main.persons_length =
              (main.contractors && main.contractors.length
                ? main.contractors.length
                : 0) +
              (main.titulares && main.titulares.length
                ? main.titulares.length
                : 0) +
              (main.beneficiaries && main.beneficiaries.length
                ? main.beneficiaries.length
                : 0) +
              (main.relationship && main.relationship.length
                ? main.relationship.length
                : 0);

            main.viewed = $localStorage.viewed;
          });
        } else {
          main.persons = [];
          main.contractors = [];
          main.titulares = [];
          main.beneficiaries = [];
          main.relationship = [];
        }
      }

      $scope.personas = [];
      if (main.persons) {
        $scope.persona = main.persons[0];
        for (var i = 0; i < main.persons.length; i++) {
          if ($scope.check(main.persons[i].person, $scope.personas)) {
          } else {
            $scope.personas.push(main.persons[i]);
          }
        }
        main.persons = $scope.personas;
      } else {
        main.persons = [];
      }
    }

    $scope.check = function (persona, array) {
      for (var l = 0; l < array.length; l++) {
        if (array[l].person == persona) {
          return true;
        }
      }
      return false;
    };

    $scope.open_in_same_tab_natural = function (
      name,
      route,
      params,
      identifier
    ) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $state.go($scope.route_for_new_tab, params);
    };

    function goToPolicy(polizaObj) {
      if (polizaObj.id) {
        var poliza = polizaObj.id;
      } else {
        var poliza = polizaObj;
      }
      if (polizaObj.document_type == 3) {
        $scope.open_in_same_tab_natural(
          "Colectividades",
          "colectividades.info",
          { polizaId: poliza },
          poliza
        );
        // $state.go('colectividades.info', {polizaId: poliza});
      } else if (polizaObj.document_type == 1) {
        $scope.open_in_same_tab_natural(
          "Pólizas",
          "polizas.info",
          { polizaId: poliza },
          poliza
        );
        // $state.go('polizas.info', {polizaId: poliza});
      } else if (polizaObj.document_type == 6) {
        $scope.open_in_same_tab_natural(
          "Colectividades",
          "colectividades.info",
          { polizaId: polizaObj.caratula },
          polizaObj.caratula
        );
        // $state.go('colectividades.info', {polizaId: polizaObj.caratula})
      } else if (polizaObj.document_type == 7) {
        $scope.open_in_same_tab_natural(
          "Fianzas",
          "fianzas.info",
          { polizaId: polizaObj.id },
          polizaObj.id
        );
        // $state.go('fianzas.info', {polizaId: polizaObj.id})
      } else if (polizaObj.document_type == 8) {
        $scope.open_in_same_tab_natural(
          "Fianzas",
          "fianzas.details",
          { polizaId: polizaObj.id },
          polizaObj.id
        );
        // $state.go('fianzas.details',{polizaId: polizaObj.id})
      } else if (polizaObj.document_type == 11) {
        $scope.open_in_same_tab_natural(
          "Flotillas",
          "flotillas.info",
          { polizaId: parseInt(polizaObj.id) },
          polizaObj.id
        );
        // $state.go('flotillas.info',{polizaId: parseInt(polizaObj.id)})
      } else if (polizaObj.document_type == 12) {
        $scope.open_in_same_tab_natural(
          "Flotillas",
          "flotillas.info",
          { polizaId: parseInt(polizaObj.caratula) },
          polizaObj.caratula
        );
        // $state.go('flotillas.info',{polizaId: parseInt(polizaObj.caratula)})
      }
    }

    function changeViewed(param) {
      if (param == 1) {
        if (!$localStorage.viewed) {
          main.viewed = true;
          $localStorage.viewed = true;
        }
      } else {
        if (!$localStorage.viewed_changes) {
          main.viewed_changes = true;
          $localStorage.viewed_changes = true;
        }
      }
    }

    $scope.checkPerson = function (type) {
      switch (type) {
        case 1:
          return "Contratante";
          break;
        case 2:
          return "Beneficiario";
          break;
        case 3:
          return "Dependiente";
          break;
        case 4:
          return "Titular Asegurado";
          break;
      }
    };

    function NotasModal(receipt) {
      main.insurance_ = receipt;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/notaCredito.modal.html",
        controller: "NotaCreditoCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return main.insurance_;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        vm.receipts.splice(index, 1);
        activate();
      });
    }

    function saveFCMToken(token) {}

    // function massiveReceipts(receipt) {
    //   main.recibos_a_pagar.push(receipt);
    // }
    $scope.massiveReceipts = function (receipt, v) {
      if (v) {
        receipt.toPay = v;
        main.recibos_a_pagar.push(receipt);
      } else {
        main.recibos_a_pagar.forEach(function (d) {
          if (!v) {
            if (d.id == receipt.id) {
              receipt.toPay = v;
              main.recibos_a_pagar.splice(receipt, 1);
            }
          }
        });
      }
    };
    $scope.toDateMain = function (dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
      return dateObject;
    };

    function pagarRecibos(container, option) {
      var data = {
        status: 1,
        user_pay: $scope.user_pay ? $scope.user_pay.url : null,
        pay_date: new Date(),
      };
      if (option == 1) {
        $scope.folio_pago = main.recibos_a_pagar[0].id;
        // SweetAlert.swal({
        //   title: "Pagar recibo(s)",
        //   text: '¿Está seguro de pagar los recibo(s) seleccionado(s)?',
        //   type: "warning",
        //   confirmButtonText: "Si",
        //   cancelButtonText: "No",
        //   showCancelButton: true,
        //   closeOnConfirm: false,
        //   showLoaderOnConfirm: true,
        //   allowOutsideClick: true
        // },
        // function(isConfirm) {
        //   if(isConfirm) {
        //     main.recibos_a_pagar.forEach(function(receipt) {
        //       container.splice(container.indexOf(receipt), 1);
        //       $http.patch(receipt.url, data);
        //     })

        //    swal("Pagados", "Se han pagado " + main.recibos_a_pagar.length +" recibos satisfactoriamente", "success");
        //    main.recibos_a_pagar = [];
        //    if ($location.$$path == "/index/main") {
        //       $http({
        //         method: 'GET',
        //         url: url.IP + 'chart-recibos/'}).then(function(recibos) {
        //           $localStorage.receipt_count = recibos.data
        //           $state.go('index.main')
        //           $state.reload();
        //       });
        //     }
        //    var elements = document.getElementsByTagName("input");
        //    for (var i = 0;  i< elements.length; i++) {
        //        if (elements[i].type === "checkbox")
        //            elements[i].checked = false;
        //    }

        //   } else {
        //   }
        // });
        var data_alert = {
          title: "Pagar recibos seleccionados: " + main.recibos_a_pagar.length,
          text: "Escriba la fecha de Pago: *(DD/MM/AAAA)",
          type: "input",
          confirmButtonText: "Pagar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          closeOnConfirm: true,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
          inputPlaceholder: "DD/MM/AAAA",
        };

        SweetAlert.swal(data_alert, function (inputValue) {
          // console.log('inputValue',inputValue,inputValue ? inputValue.length : 0)
          if (inputValue === false) return false;
          if (
            inputValue &&
            (inputValue.length < 10 || inputValue.length > 10)
          ) {
            toaster.error(
              "Fecha de Pago incorrecta,escriba la Fecha de Pago en formato correcto (DD/MM/AAAA)"
            );
            return false;
          }
          if (inputValue === "") {
            swal("Escriba la Fecha de Pago en formato correcto (DD/MM/AAAA)");
            return false;
          } else {
            $scope.pay_date = $scope.toDateMain(inputValue);
            $scope.pay_date_view = $scope.convertDateMain($scope.pay_date);
            if (
              $scope.pay_date != "Invalid Date" &&
              $scope.pay_date != null &&
              $scope.pay_date != "NaN/NaN/NaN"
            ) {
              main.recibos_a_pagar.forEach(function (receipt, index) {
                $http({
                  // method: 'GET',
                  // url: url.IP + 'get-cobranza/',
                  // params: $scope.filtros
                  method: "PATCH",
                  url: receipt.url,
                  data: {
                    folio_pago: $scope.folio_pago,
                    pay_date: $scope.pay_date ? $scope.pay_date : new Date(),
                    status: 1,
                    user_pay: $scope.user_pay ? $scope.user_pay.url : null,
                  },
                }).then(function (response) {
                  container.splice(container.indexOf(receipt), 1);
                  swal(
                    "Pagado, folio: " + response.data.folio_pago,
                    "La selección ha sido pagada, fecha de pago: " +
                      $scope.pay_date_view,
                    "success"
                  );
                });
                main.recibos_a_pagar = [];
                if ($location.$$path == "/index/main") {
                  $http({
                    method: "GET",
                    url: url.IP + "chart-recibos/",
                  }).then(function (recibos) {
                    $localStorage.receipt_count = recibos.data;
                    $state.go("index.main");
                    $state.reload();
                  });
                }
                var elements = document.getElementsByTagName("input");
                for (var i = 0; i < elements.length; i++) {
                  if (elements[i].type === "checkbox")
                    elements[i].checked = false;
                }
              });
            } else {
              main.recibos_a_pagar = [];
              toaster.error(
                "Fecha de Pago incorrecta,escriba la Fecha de Pago en formato correcto (DD/MM/AAAA)"
              );
            }
          }
        });
      } else if (option == 2) {
        $scope.folio_pago = container[0].id;
        var data_alert = {
          title:
            "Pagar recibos de la página actual, total recibos a pagar: " +
            container.length,
          text: "Escriba la fecha de Pago: *(DD/MM/AAAA)",
          type: "input",
          confirmButtonText: "Pagar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          closeOnConfirm: true,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
          inputPlaceholder: "DD/MM/AAAA",
        };

        SweetAlert.swal(data_alert, function (inputValue) {
          if (
            inputValue &&
            (inputValue.length < 10 || inputValue.length > 10)
          ) {
            toaster.error(
              "Fecha de Pago incorrecta,escriba la Fecha de Pago en formato correcto (DD/MM/AAAA)"
            );
            return false;
          }
          if (inputValue === false) return false;
          if (inputValue === "") {
            swal("Escriba la Fecha de Pago en formato correcto (DD/MM/AAAA)");
            return false;
          } else {
            $scope.pay_date = $scope.toDateMain(inputValue);
            $scope.pay_date_view = $scope.convertDateMain($scope.pay_date);
            if (
              $scope.pay_date != "Invalid Date" &&
              $scope.pay_date != null &&
              $scope.pay_date != "NaN/NaN/NaN"
            ) {
              container.forEach(function (receipt, index) {
                $http({
                  // method: 'GET',
                  // url: url.IP + 'get-cobranza/',
                  // params: $scope.filtros
                  method: "PATCH",
                  url: receipt.url,
                  data: {
                    folio_pago: $scope.folio_pago,
                    pay_date: $scope.pay_date ? $scope.pay_date : new Date(),
                    status: 1,
                    user_pay: $scope.user_pay ? $scope.user_pay.url : null,
                  },
                }).then(function (response) {
                  swal(
                    "Pagado, folio: " + response.data.folio_pago,
                    "La selección ha sido pagada, fecha de pago: " +
                      $scope.pay_date_view,
                    "success"
                  );
                });
                if ($location.$$path == "/index/main") {
                  $http({
                    method: "GET",
                    url: url.IP + "chart-recibos/",
                  }).then(function (recibos) {
                    $localStorage.receipt_count = recibos.data;
                    $state.go("index.main");
                    $state.reload();
                  });
                }
                var elements = document.getElementsByTagName("input");
                for (var i = 0; i < elements.length; i++) {
                  if (elements[i].type === "checkbox")
                    elements[i].checked = false;
                }
              });
            } else {
              toaster.error(
                "Fecha de Pago incorrecta,escriba la Fecha de Pago en formato correcto (DD/MM/AAAA)"
              );
            }
          }
        });
        // SweetAlert.swal({
        //   title: "Pagar recibo(s)",
        //   text: '¿Está seguro de pagar los recibo(s) seleccionado(s)?',
        //   type: "warning",
        //   confirmButtonText: "Si",
        //   cancelButtonText: "No",
        //   showCancelButton: true,
        //   closeOnConfirm: false,
        //   showLoaderOnConfirm: true,
        //   allowOutsideClick: true
        // },
        // function(isConfirm) {
        //   if(isConfirm) {
        //     toaster.warning("El pago se hará sobre los recibos en la página disponible");
        //     container.forEach(function(receipt) {
        //       // container.splice(container.indexOf(receipt), 1);
        //       $http.patch(receipt.url, data);
        //     })

        //     swal("Pagados", "Se han pagado " +container.length +" recibos satisfactoriamente", "success");
        //     if ($location.$$path == "/index/main") {
        //       $http({
        //         method: 'GET',
        //         url: url.IP + 'chart-recibos/'}).then(function(recibos) {
        //           $localStorage.receipt_count = recibos.data
        //           $state.go('index.main')
        //           $state.reload();
        //       });
        //     }
        //   } else {
        //   }
        // });
      }
    }

    function adminReminder(container) {
      $http
        .post(url.IP + "admin-email-reminder/")
        .then(
          function success(request) {
            if (request.status === 200 || request.status === 201) {
              swal("Enviado", "El recordatorio ha sido enviado", "success");
            } else {
              swal(
                "Error",
                "No se envió el recordatorio. Contacte a su administrador.",
                "error"
              );
            }
          },
          function error(error) {
            console.log("error - email", error);
          }
        )
        .catch(function (e) {
          console.log("error - catch", e);
        });
    }

    // bitacotra endoso

    function showBinnacle_endoso(param) {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 10,
          id_model: param.id,
        },
      })
        .then(function (request) {
          main.comments_data_endoso = request.data.results;
          main.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      main.endosoId = param.id;
      main.show_binnacle_endoso = true;
    }
    function returnToEndoso() {
      main.show_binnacle_endoso = false;
    }
    // bitacora endoso***

    function viewCarta(poliza, carta, recibo) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-form/",
        params: {
          id_poliza: poliza,
          id_carta: carta,
          id_recibo: recibo,
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
        // $scope.pdf = response.data;
        // $http({
        //   method: 'GET',
        //   url: url.IP + 'get-pdf',
        //   params: {
        //     'pdf_name': $scope.pdf.pdf_name
        //   },
        //   responseType: 'arraybuffer'

        // }).then(function success(response) {

        //   })
      });
    }

    function returnToReceipts(param, m, t, tId) {
      if (param == 2) {
        main.show_binnacle_receipt = false;
        if (tId == 1) {
          var parType = "green";
        } else if (tId == 2) {
          var parType = "yellow";
        } else if (tId == 3) {
          var parType = "orange";
        } else if (tId == 4) {
          var parType = "red";
        }
        main.receipts = [];
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   var return_chart = 'v2/recibos/graficas-recibos/';
        var return_chart = "graficas-recibos/";
        $http({
          method: "GET",
          url: url.IP + return_chart,
          params: {
            tipo: parType,
            order: 1,
            asc: 1,
          },
        }).then(function success(data) {
          if (data.status == 200) {
            main.receipts = data.data.results;
            if (data) {
              if (data.data) {
                if (data.data.results) {
                  data.data.results.forEach(function (rec) {
                    main.recibos_a_pagar.forEach(function (rec_w) {
                      if (rec.id == rec_w.id) {
                        if (rec) {
                          rec.toPay = true;
                        } else {
                        }
                      }
                    });
                  });
                }
              }
            }
            for (var i = 0; i < main.receipts.length; i++) {
              // main.receipts[i].receipt_type = main.receipts[i].receipt_type == 1 ? "Póliza" : "Endoso";
              if (main.receipts[i].poliza) {
                main.receipts[i].poliza.status =
                  main.receipts[i].poliza.status == 1
                    ? "En trámite"
                    : main.receipts[i].poliza.status == 2
                    ? "OT Cancelada"
                    : main.receipts[i].poliza.status == 10
                    ? "Por Iniciar"
                    : main.receipts[i].poliza.status == 11
                    ? "Cancelada"
                    : main.receipts[i].poliza.status == 12
                    ? "Renovada"
                    : main.receipts[i].poliza.status == 13
                    ? "Vencida"
                    : main.receipts[i].poliza.status == 14
                    ? "Vigente"
                    : "Vigente";
              } else if (main.receipts[i].fianza) {
                main.receipts[i].fianza.status =
                  main.receipts[i].fianza.status == 1
                    ? "En trámite"
                    : main.receipts[i].fianza.status == 2
                    ? "OT Cancelada"
                    : main.receipts[i].fianza.status == 10
                    ? "Por Iniciar"
                    : main.receipts[i].fianza.status == 11
                    ? "Cancelada"
                    : main.receipts[i].fianza.status == 12
                    ? "Anulada"
                    : main.receipts[i].fianza.status == 13
                    ? "Rechazada"
                    : main.receipts[i].fianza.status == 15
                    ? "Renovada"
                    : "Vigente";
              }

              if (main.receipts[i].status == 1) {
                main.receipts[i].status = "Pagado";
              } else if (main.receipts[i].status == 2) {
                main.receipts[i].status = "Cancelado";
              } else if (main.receipts[i].status == 3) {
                main.receipts[i].status = "Prorrogado";
              } else if (main.receipts[i].status == 4) {
                main.receipts[i].status = "Pendiente de pago";
              } else if (main.receipts[i].status == 5) {
                main.receipts[i].status = "Liquidado";
              } else if (main.receipts[i].status == 6) {
                main.receipts[i].status = "Conciliado";
              } else if (main.receipts[i].status == 7) {
                main.receipts[i].status = "Cerrado";
              } else if (main.receipts[i].status == 0) {
                main.receipts[i].status = "Desactivado";
              } else if (main.receipts[i].status == 9) {
                main.receipts[i].status = "Pago Parcial";
              } else {
                main.receipts[i].status = "Sin estatus";
              }

              if (main.receipts[i].poliza) {
                if (main.receipts[i].poliza.forma_de_pago == 1) {
                  main.receipts[i].poliza.forma_de_pago = "Mensual";
                } else if (main.receipts[i].poliza.forma_de_pago == 2) {
                  main.receipts[i].poliza.forma_de_pago = "Bimestral";
                } else if (main.receipts[i].poliza.forma_de_pago == 3) {
                  main.receipts[i].poliza.forma_de_pago = "Trimestral";
                } else if (main.receipts[i].poliza.forma_de_pago == 5) {
                  main.receipts[i].poliza.forma_de_pago = "Contado";
                } else if (main.receipts[i].poliza.forma_de_pago == 6) {
                  main.receipts[i].poliza.forma_de_pago = "Semestral";
                } else if (main.receipts[i].poliza.forma_de_pago == 12) {
                  main.receipts[i].poliza.forma_de_pago = "Anual";
                } else {
                  main.receipts[i].poliza.forma_de_pago = "Sin estatus";
                }
              }
            }
            main.config_receipts = {
              count: data.data.count,
              next: data.data.next,
              previous: data.data.previous,
            };
          }
        });
      } else if (param == 3) {
        main.show_binnacle_renewal = false;
      } else {
        main.show_binnacle = false;
      }
      // if ($location.$$path == "/index/main") {
      //     $http({
      //       method: 'GET',
      //       url: url.IP + 'chart-recibos/'}).then(function(ren) {
      //         // $state.go('index.main')
      //         $state.reload();
      //     });
      // }
    }

    function showBinnacle(param, parType) {
      $scope.receiptmodel = param.url;
      main.receiptmodel = param.url;
      main.receipt = param;

      if (parType == "recibo" || parType == "recibo_modal") {
        var id_model = 4;
      } else if (parType == "renovacion") {
        var id_model = 6;
      } else {
        var id_model = 1;
      }

      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: id_model,
          id_model: param.id,
        },
      })
        .then(function (request) {
          if (id_model == 1) {
            main.comments_data = request.data.results;
            main.comments_config = {
              count: request.data.count,
              previous: request.data.previous,
              next: request.data.next,
            };
          } else if (id_model == 4) {
            main.comments_data_receipt = request.data.results;
            main.comments_config_receipt = {
              count: request.data.count,
              previous: request.data.previous,
              next: request.data.next,
            };
          } else if (id_model == 6) {
            main.comments_data_renewal = request.data.results;
            main.comments_config_renewal = {
              count: request.data.count,
              previous: request.data.previous,
              next: request.data.next,
            };
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });

      if (id_model == 1) {
        main.policy_id = param.id;
        main.show_binnacle = true;
      } else if (id_model == 4) {
        main.receipt_id = param.id;
        main.receipt_url = param.url;

        if (parType !== "recibo_modal") {
          main.show_binnacle_receipt = true;
        }
      } else if (id_model == 6) {
        main.renewal_id = param.id;
        main.show_binnacle_renewal = true;
      }
    }

    function showPhone(receipt) {
      var phones_string = "";
      var phones = [{ desc: "Principal", value: receipt.contratante.phone }];
      if (receipt.contratante.a_phones) {
        receipt.contratante.a_phones.forEach(function (a_phone) {
          if (a_phone.phone_type == 1) {
            $scope.phone_type = "Casa";
          } else if (a_phone.phone_type == 2) {
            $scope.phone_type = "Oficina";
          } else if (a_phone.phone_type == 3) {
            $scope.phone_type = "Móvil";
          } else {
            $scope.phone_type = "Otro";
          }
          phones.push({ desc: $scope.phone_type, value: a_phone.phone });
          // phones_array.push('\n')
        });
      }
      phones.forEach(function (ph) {
        if (!phones_string) {
          phones_string = format_phone(ph.desc, ph.value);
        } else {
          phones_string += "\n" + format_phone(ph.desc, ph.value);
        }
      });

      SweetAlert.swal(
        {
          title: "Teléfono",
          text: phones_string,
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "##87CEFA",
          confirmButtonText: "Se hizo llamada",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var obj = {
              track_phone: true,
            };
            $http.patch(receipt.url, obj);
            swal.close();
          }
        }
      );
    }

    function format_phone(desc, ph) {
      var number = String(ph);
      var formattedNumber = number;
      if (number[0] == "1") {
        var c = number[0] == "1" ? "1 " : "";
        number = number[0] == "1" ? number.slice(1) : number;
      } else if (number[0] == "0" && number[1] == "1") {
        var c = number[0] == "0" && number[1] == "1" ? "01 " : "";
        number =
          number[0] == "0" && number[1] == "1" ? number.slice(2) : number;
      } else var c = "";
      var area;
      var front;
      if (
        number.substring(0, 2) == 55 ||
        number.substring(0, 2) == 33 ||
        number.substring(0, 2) == 81
      ) {
        area = number.substring(0, 2);
        front = number.substring(2, 6);
      } else {
        area = number.substring(0, 3);
        front = number.substring(3, 6);
      }
      var end = number.substring(6, 10);
      var ext = number.substring(10, 15);
      if (front) {
        formattedNumber = c + "(" + area + ") " + front;
      }
      if (end) {
        formattedNumber += "-" + end;
      }
      if (ext) {
        formattedNumber += " ext. " + ext;
      }
      return desc + ": " + formattedNumber;
    }

    $scope.addEmailsConfirm = function (valueReceipt, par, rec) {
      var id_poliza = rec.poliza ? rec.poliza.id : 0;
      var id_fianza = rec.fianza ? rec.fianza.id : 0;
      if (rec) {
        dataFactory
          .get("v1/notasCredito-info", {
            status: 4,
            id_poliza: id_poliza,
            id_fianza: id_fianza,
          })
          .then(function success(nota) {
            if (nota.status === 200 || nota.status === 201) {
              $scope.notasCredito = nota.data;
              $scope.notasCredito.forEach(function (it) {
                it.sendNote = false;
              });
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }

      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        size: "lg",
        controllerAs: "vm",
        resolve: {
          valueReceipt: function () {
            return valueReceipt;
          },
          notasPolicy: function () {
            return $scope.notasCredito;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        $state.go("index.main");
      });
    };
    $scope.addPhoneWhatsapp = function (valueReceipt, par, rec) {
      // insurance.contratante = contra;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.phone.whatsappsms_reminderpay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return par;
          },
          valueReceipt: function () {
            return valueReceipt;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        $state.go("index.main");
      });
    };

    function emailsReminderAdd(receipt) {
      $scope.form = {};
      $scope.form.emails_reminder = [];
      var mail = {
        email: "",
      };
      if (receipt.contratante) {
        var cmail = {
          email: receipt.contratante.email,
        };
      }
      if (receipt.contratante) {
        $scope.form.emails_reminder.push(cmail);
      } else {
        $scope.form.emails_reminder.push(mail);
      }
      $scope.receipt_pay = receipt;
      $uibModal.receipt = receipt;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    }
    $scope.addEmails = function (type) {
      var mail = {
        email: "",
      };
      $scope.form.emails_reminder.push(mail);
    };

    $scope.deleteEmails = function (mail, type) {
      $scope.form.emails_reminder.splice(mail, 1);
    };

    $scope.cancel = function () {
      try {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      } catch (e) {
        activate();
        console.log("e", e);
      }
    };
    $scope.sendReminder = function (mails) {
      var arrayEmails = [];
      $scope.receipt_pay = $uibModal.receipt;
      if (mails) {
        mails.forEach(function (it) {
          arrayEmails.push(it.email);
        });
      }
      if ($scope.receipt_pay.contratante) {
        arrayEmails.push($scope.receipt_pay.contratante.email);
      }
      if (arrayEmails.length == 0) {
        SweetAlert.swal("Error", "Agregue correos", "error");
        return;
      } else {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      }

      if (arrayEmails) {
        SweetAlert.swal("Error", "Agregue correos__", "error");
        var data_alert = {
          title: "Correo",
          // text: arrayEmails,
          text: arrayEmails.join("\n"),
          type: "info",
          confirmButtonText: "Confirmar envio",
          cancelButtonText: "Salir",
          showCancelButton: true,
          closeOnConfirm: true,
          showLoaderOnConfirm: true,
          // showConfirmButton: $scope.add_emails
          showConfirmButton: true,
        };
      }
      if (data_alert) {
        SweetAlert.swal(data_alert, function (isConfirm) {
          if (isConfirm) {
            $http
              .post(url.IP + "payment-reminder-manual/", {
                r_id: $scope.receipt_pay.id,
                emails: arrayEmails,
              })

              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                  } else {
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
          }
        });
      }
    };
    function showEmail(receipt) {
      SweetAlert.swal(
        {
          title: "Correo",
          text: receipt.contratante.email,
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Enviar Recordatorio",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .post(url.IP + "payment-reminder-manual/", { r_id: receipt.id })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                  } else {
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
          }
        }
      );
    }
    $scope.sendMailContractor = function (receipt) {
      if (receipt.contratante) {
        if (receipt.contratante.email && !receipt.contratante.email == "") {
          var arrayEmails = [];
          arrayEmails = [receipt.contratante.email];
          $http
            .post(url.IP + "payment-reminder-manual/", {
              r_id: receipt.id,
              emails: arrayEmails,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  SweetAlert.swal(
                    "Enviado",
                    "El recordatorio ha sido enviado",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "No se envió el recordatorio. Contacte a su administrador.",
                    "error"
                  );
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          toaster.error(
            "El contratante no tiene correo, agregue correos",
            "error"
          );
        }
      }
    };
    // OT Chart
    main.labels = [
      "En tiempo",
      "Fuera de tiempo",
      "Con atraso importante",
      "Atención urgente",
    ];
    main.data = [0, 0, 0, 0];
    main.showTotalOt = showTotalOt;

    // Events
    main.onOtEvent = onOtEvent;
    main.onContractorEvent = onContractorEvent;

    // Modals
    main.otCreatorModalEvent = otCreatorModalEvent;
    main.modifyRecordsModalEvent = modifyRecordsModalEvent;
    main.ModalCreateEndorsement = ModalCreateEndorsement;
    main.payReceiptsModalEvent = payReceiptsModalEvent;
    main.crearEndoso = crearEndoso;
    main.goToCotization = goToCotization;
    main.showAndHidePanels = showAndHidePanels;
    main.updatReceiptsCount = updatReceiptsCount;
    main.siniestersMoldalReport = siniestersMoldalReport;
    main.count_recibos;
    main.count_recibos_wopay;
    main.checkEndorsementType = checkEndorsementType;
    main.activateAux = activateAux;
    main.closeMenu = closeMenu;
    $localStorage.receiptUpdated = {};
    main.idFReceiptFound;
    $localStorage.receiptModified = false;
    $localStorage.internal_number = $scope.internal_number;

    function closeMenu() {
      if ($(window).width() <= 768) {
        $(".skin-1.bg-1").removeClass("mini-navbar");
      }
    }

    refreshUserFromStorage(false);

    if (usr && Object.keys(usr).length && $location.path() !== "/login/auth") {
      if (usr.urlname == "ts") {
        main.org_pruebas = true;
      } else {
        main.org_pruebas = false;
      }
      main.permisos = usr.permiso;
      main.accesos = $rootScope.permisos;
      updatReceiptsCount();
      activate();
      helpers.getStates();
    }

    function checkEndorsementType(obj) {
      if (obj.automobile) return "automobile";
      else if (obj.life) return "life";
      else if (obj.damage) return "damage";
      else if (obj.disease) {
        return "disease";
      }
    }

    function activateAux() {
      activate();
    }

    $scope.soloInfo = true;
    function changeStatusModal(receipt, insurance) {
      $scope.soloInfo = false;
      if (!insurance) {
        insurance = receipt.poliza;
      }
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return angular.copy(receipt);
          },
          insurance: function () {
            return insurance;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(
        function (receipt) {
          // if($localStorage.graficas_recibos_page && $localStorage.graficas_recibos_url){
          main.reloadReceiptsGraphic();
          var currentPage = parseInt(
            $localStorage.graficas_recibos_page || "1",
            10
          );
          main.show_paginationReceipts = true;
          // $http({
          //   method: 'GET',
          //   url: url.IP + 'chart-recibos/'}).then(function(ren) {
          //     main.receipts = ren.data;
          //     $localStorage.receipt_count = ren.data
          //     $http.get($localStorage.graficas_recibos_url)
          //     .then(
          //       function success(response) {
          //         main.receipts = response.data.results;
          //         main.config_receipts =  {
          //           count: response.data.count,
          //           previous: response.data.previous,
          //           next: response.data.next,
          //           current_page: currentPage,    // 👈 NUEVO
          //           page: currentPage    // 👈 NUEVO
          //         }
          //         console.log('iiiiiiiiii',response,$localStorage)
          //         if(response && response.data && response.data.results && main && main.recibos_a_pagar){
          //           response.data.results.forEach(function(rec) {
          //             main.recibos_a_pagar.forEach(function(rec_w) {
          //               if(rec.id == rec_w.id){
          //                 if (rec) {
          //                   rec.toPay =true;
          //                 }else{

          //                 }
          //               }
          //             })
          //           })
          //         }
          //         main.show_paginationReceipts = true;
          //     },
          //     function error(xcxxx) {
          //       // si error, volver a intentar SIN el parámetro page
          //       var badUrl = $localStorage.graficas_recibos_url || '';
          //       var fixedUrl = badUrl;
          //       if (badUrl.indexOf('?') !== -1) {
          //         var parts = badUrl.split('?');
          //         var base = parts[0];
          //         var query = parts[1] || '';
          //         var filtered = [];
          //         query.split('&').forEach(function (pair) {
          //           if (!pair) return;
          //           // excluir page=
          //           if (pair.indexOf('page=') === 0) return;
          //           filtered.push(pair);
          //         });

          //         if (filtered.length > 0) {
          //           fixedUrl = base + '?' + filtered.join('&');
          //         } else {
          //           fixedUrl = base; // sin query
          //         }
          //       }
          //       // console.log('Reintentando sin page:', fixedUrl);
          //       // actualizar en localStorage para futuros usos
          //       $localStorage.graficas_recibos_url = fixedUrl;
          //       if(fixedUrl){
          //         main.reloadReceiptsGraphic();
          //         var currentPage = parseInt($localStorage.graficas_recibos_page || '1', 10);
          //         $http.get($localStorage.graficas_recibos_url)
          //         .then(
          //           function success(response) {
          //             main.receipts = response.data.results;
          //             main.config_receipts =  {
          //               count: response.data.count,
          //               previous: response.data.previous,
          //               next: response.data.next,
          //               current_page: currentPage,    // 👈 NUEVO
          //               page: currentPage    // 👈 NUEVO
          //             }
          //             console.log('xii',response)
          //             if(response && response.data && response.data.results && main && main.recibos_a_pagar){
          //               response.data.results.forEach(function(rec) {
          //                 main.recibos_a_pagar.forEach(function(rec_w) {
          //                   if(rec.id == rec_w.id){
          //                     if (rec) {
          //                       rec.toPay =true;
          //                     }else{

          //                     }
          //                   }
          //                 })
          //               })
          //             }
          //             main.show_paginationReceipts = true;
          //         })
          //       }
          //     })
          // });
          // }
          updatReceiptsCount();
          // var modalInstance = $uibModal.open({ //jshint ignore:line
          //     templateUrl: 'app/main/editReceiptsPago.html',
          //     controller: EditPagosCtrl,
          //     size: 'lg',
          //     resolve: {
          //         main: function () {
          //           return main; // 👈 MISMA referencia
          //         },
          //         user: function(){
          //           return usr;
          //         },
          //         recibo: function() {
          //           return receipt;
          //         },
          //         pagosModal: function() {
          //             return main.pago_recibo_actual

          //         },
          //         from: function(){
          //           return null;
          //         },
          //         poliza: function() {
          //           if (receipt.poliza)
          //           return receipt.poliza;
          //           else{
          //             return receipt.fianza
          //           }
          //         },
          //         soloInfo: function(){
          //           return false;
          //         },
          //       },
          //         backdrop: 'static', /* this prevent user interaction with the background */
          //         keyboard: false
          // });
        },
        function () {
          // var modalInstance = $uibModal.open({ //jshint ignore:line
          //     templateUrl: 'app/main/editReceiptsPago.html',
          //     controller: EditPagosCtrl,
          //     size: 'lg',
          //     resolve: {
          //       main: function () {
          //         return main; // 👈 MISMA referencia
          //       },
          //         // pagosModal: function() {
          //         //     return main.pago_recibo_actual
          //         // }
          //       user: function(){
          //         return usr;
          //       },
          //       recibo: function() {
          //         return receipt;
          //       },
          //       pagosModal: function() {
          //           return main.pago_recibo_actual
          //       },
          //       from: function(){
          //         return null;
          //       },
          //       poliza: function() {
          //         if (receipt.poliza)
          //         return receipt.poliza;
          //         else{
          //           return receipt.fianza
          //         }
          //       },
          //       soloInfo: function(){
          //         return false;
          //       },
          //     },
          //       backdrop: 'static', /* this prevent user interaction with the background */
          //       keyboard: false
          // });
        }
      );
    }

    // function updateReceiptStatus() {
    //   console.log('oooooooooooooooo', main.pago_recibo_actual[0])
    //   if(main && main.pago_recibo_actual && main.pago_recibo_actual[0] && main.pago_recibo_actual[0].url){
    //     try{
    //       $http.get(main.pago_recibo_actual[0].url)
    //           .then(
    //             function success(response) {
    //               main.pago_recibo_actual[0] = response.data;
    //               $scope.recibo = main.pago_recibo_actual[0];
    //               angular.copy(response.data, $scope.recibo);
    //               console.log('jjjjjjjj',main.pago_recibo_actual[0],response,$scope.recibo)
    //           },
    //           function error(xcxxx) {
    //           })
    //     }catch(enr){
    //       console.log('er al extraer info recibo',enr)
    //     }
    //   }
    //   receiptService.getCountReceipts().then(function(recibos) {
    //     var c = 0;
    //     var id_receipt_c = main.pago_recibo_actual[0].id;
    //     recibos.forEach(function(receipt) {
    //       c+=1;
    //       if (receipt.id == id_receipt_c) {
    //         main.idFReceiptFound = receipt.id
    //       }
    //     });
    //   });
    // }

    function updateReceiptStatus() {
      if (
        main &&
        main.pago_recibo_actual &&
        main.pago_recibo_actual[0] &&
        main.pago_recibo_actual[0].url
      ) {
        $http.get(main.pago_recibo_actual[0].url).then(
          function (response) {
            // actualiza el array principal
            $scope.$applyAsync(function () {
              main.pago_recibo_actual[0] = response.data;
              $scope.recibo = response.data;
              // 🔥 ACTUALIZA EL MODAL SIN ROMPER REFERENCIA
              if ($scope.recibo.status != response.data.status) {
                angular.copy(response.data, $scope.recibo);
              }
            });
            // ahora sí, usa el ID actualizado
            receiptService.getCountReceipts().then(function (recibos) {
              var id_receipt_c = response.data.id;
              recibos.forEach(function (receipt) {
                if (receipt.id === id_receipt_c) {
                  main.idFReceiptFound = receipt.id;
                }
              });
            });
          },
          function (error) {
            console.error("Error actualizando recibo", error);
          }
        );
      }
    }

    function updatReceiptsCount() {
      var aux = {};
      var aux_wopay = {};
      var count = 0;
      var wopay = 0;
      //var c1=0,c2=0;
      receiptService.getCountReceipts().then(function (recibos) {
        if (!angular.isArray(recibos)) {
          debugLog("updatReceiptsCount -> respuesta inválida", {
            recibos: recibos,
          });
          return;
        }

        recibos.forEach(function (receipt) {
          count = 0;
          wopay = 0;
          if (receipt.status == 1) {
            wopay = wopay + 1;
          }
          recibos.forEach(function (recibo) {
            if (receipt.id == recibo.rp_owner_id && recibo.isActive == true) {
              count = count + 1;
              if (recibo.status == 1) {
                wopay = wopay + 1;
              }
            }
          });
          aux[receipt.id] = count;
          aux_wopay[receipt.id] = wopay;
        });
      });
      main.count_recibos = aux;
      main.count_recibos_wopay = aux_wopay;
    }

    function editRecibo(receipt) {
      main.loaded = false;
      var recibos = [];
      var recibos_hijo = [];
      var endorsements = [];
      recibos_hijo.push(receipt);
      receiptService.getChildrenReceipts(receipt.id).then(function (recibos) {
        $http({
          method: "GET",
          url: url.IP + "cartas-by-model",
          params: {
            model: 4,
          },
        }).then(function success(response) {
          main.cartas = response.data;
        });
        try {
          recibos.forEach(function (recibo) {
            // if (receipt.id == recibo.rp_owner_id) {
            recibos_hijo.push(recibo);
            // }
          });
        } catch (err) {}
      });

      main.pago_recibo_actual = recibos_hijo;
      main.loaded = true;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/main/editReceiptsPago.html",
        controller: EditPagosCtrl,
        size: "lg",
        resolve: {
          main: function () {
            return main; // 👈 MISMA referencia
          },
          user: function () {
            return usr;
          },
          pagosModal: function () {
            return main.pago_recibo_actual;
          },
          poliza: function () {
            if (receipt.poliza) return receipt.poliza;
            else {
              return receipt.fianza;
            }
          },
          recibo: function () {
            return receipt;
          },
          from: function () {
            return null;
          },
          soloInfo: function () {
            return true;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result
        .then(function () {
          // activate();
          // console.log('oooooooooo',main.receipts)
        })
        .catch(function () {
          // activate();
          // console.log('oooooooooo',main.receipts)
        });
    }

    function EditPagosCtrl(
      datesFactory,
      $scope,
      $uibModalInstance,
      pagosModal,
      poliza,
      recibo,
      $sessionStorage,
      $sce,
      soloInfo
    ) {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.user = usr;
      $scope.receiptmodel = recibo.url;
      $scope.main = main;

      // Menú rapido
      main.deletePolicy = deletePolicy;
      main.cancelPolicy = cancelPolicy;
      main.getPDF = getPDF;
      main.openRenovateModal = openRenovateModal;
      main.createRecordatorio = createRecordatorio;
      main.goToEdit = goToEdit;
      main.goToPolicy = goToPolicy;
      main.update_promesa_pago = update_promesa_pago;
      main.edith_promesa_pago = false;
      $scope.recibo = recibo;
      $scope.soloInfo = soloInfo;
      function createRecordatorio(registroSelected, tipo) {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
        var insurance = registroSelected;
        var modalInstance = $uibModal.open({
          templateUrl:
            "app/recordatorios/desde-registro/desderegistro.modal.html",
          controller: "RecordatorioRegistroCtrl",
          size: "lg",
          resolve: {
            poliza: function () {
              return registroSelected;
            },
            tipoRegistro: function () {
              return tipo;
            },
            from: function () {
              return null;
            },
            parent: function () {
              return poliza;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
      }
      function getContractorId(contractor) {
        if (!contractor) return null;
        // Si viene como objeto { id: 9929, ... }
        if (angular.isObject(contractor) && contractor.id) {
          return contractor.id;
        }
        // Si viene como string
        if (angular.isString(contractor)) {
          if (contractor.indexOf("http") === 0) {
            var parts = contractor.split("/").filter(Boolean); // quita vacíos por //
            return parts[parts.length - 1]; // último segmento -> "9929"
          }
          // Si ya es un id en string, lo regresamos tal cual
          return contractor;
        }
        return contractor;
      }
      $scope.recordatoriosFlag = false;
      $scope.showRecordatorios = function () {
        $scope.recordatoriosFlag = !$scope.recordatoriosFlag;
      };
      $scope.goToRecordatorio = function (rec) {
        if (rec.recordatorio) {
          $scope.name_for_new_tab = "Recordatorio desde registro";
          $scope.route_for_new_tab = "recordatorios.desde_registro_show";
          var params = { id: rec.recordatorio.id };
        }
        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }

        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });

          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab, params),
          };
        }
        $localStorage.tab_states = appStates.states;
        $state.go($scope.route_for_new_tab, params);
      };
      $scope.createRecordatorio = function (registroSelected, tipo) {
        var insurance = registroSelected;
        var modalInstance = $uibModal.open({
          templateUrl:
            "app/recordatorios/desde-registro/desderegistro.modal.html",
          controller: "RecordatorioRegistroCtrl",
          size: "lg",
          resolve: {
            poliza: function () {
              return registroSelected;
            },
            tipoRegistro: function () {
              return tipo;
            },
            from: function () {
              return null;
            },
            parent: function () {
              return $scope.endorsement;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
      function deletePolicy(policy) {
        // dataFactory.get('has-del-policy-permission')
        // .then(function success(response) {
        //  if(response.data){
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "Los cambios no podrán revertirse",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              if (policy.document_type == 1) {
                return $http
                  .post(url.IP + "delete-policy", { id: policy.id })
                  .then(deletePolicyComplete)
                  .catch(deletePolicyFailed);

                function deletePolicyComplete(
                  response,
                  status,
                  headers,
                  config
                ) {
                  //jshint ignore:line
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.DELETEPOLICY,
                    "success"
                  );
                  setTimeout(function () {
                    $state.go("polizas.table");
                  }, 1000);
                }

                function deletePolicyFailed(response, status, headers, config) {
                  //jshint ignore:line
                  return response;
                }
              } else if (policy.document_type == 3) {
                return $http
                  .post(url.IP + "delete-colectivity/", { id: policy.id })
                  .then(deletePolicyComplete)
                  .catch(deletePolicyFailed);

                function deletePolicyComplete(
                  response,
                  status,
                  headers,
                  config
                ) {
                  //jshint ignore:line
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.DELETECOLLECTIVITY,
                    "success"
                  );
                  setTimeout(function () {
                    $state.go("polizas.table");
                  }, 1000);
                }

                function deletePolicyFailed(response, status, headers, config) {
                  //jshint ignore:line
                  return response;
                }
              } else if (policy.document_type == 4) {
                return $http
                  .post(url.IP + "delete-colectivity/", { id: policy.caratula })
                  .then(deletePolicyComplete)
                  .catch(deletePolicyFailed);

                function deletePolicyComplete(
                  response,
                  status,
                  headers,
                  config
                ) {
                  //jshint ignore:line
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.DELETECOLLECTIVITY,
                    "success"
                  );
                  setTimeout(function () {
                    $state.go("polizas.table");
                  }, 1000);
                }

                function deletePolicyFailed(response, status, headers, config) {
                  //jshint ignore:line
                  return response;
                }
              }
            } else {
              SweetAlert.swal(
                "Cancelado",
                "La póliza no se ha eliminado",
                "error"
              );
            }
          }
        );
        // } else {
        //   SweetAlert.swal('Error', 'No tienes permiso para realizar esta acción', "error")
        //  }
        // })
      }
      function cancelPolicy(id) {
        dataFactory.get().then(function success(response) {
          if (response.data) {
            SweetAlert.swal(
              {
                title: "Cancelar póliza",
                text: "Elija una opción",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#581845  ",
                confirmButtonText: "Por endoso tipo D",
                cancelButtonText: "Precancelación",
                closeOnConfirm: true,
                closeOnCancel: false,
              },
              function (isConfirm) {
                if (isConfirm) {
                  var params = {
                    myInsurance: vm.insurance,
                    contractor: $scope.contratante,
                  };
                  $state.go("endosos.endosos", params);
                } else {
                  var data = {
                    status: 4,
                  };
                  // SweetAlert.swal("Se ha enviando un correo al administrador", "info");
                  // $http.patch(url.IP + 'polizas/'+ id + '/', data).then(function success(response) {
                  // }) Manda correo
                  $scope.emails = [];
                  // $scope.emails.push("example@miurabox.com");
                  $http
                    .post(url.IP + "cancel-policy-manual/", {
                      id: id,
                      emails: $scope.emails,
                    })
                    .then(
                      function success(request) {
                        if (request.status === 200) {
                          swal(
                            "¡Listo!",
                            "Se ha enviado un correo al administrador",
                            "success"
                          );
                        } else {
                          toaster.warning(
                            "No se envió la póliza. Contacte a su administrador."
                          );
                        }
                      },
                      function error(error) {
                        console.log("error - email", error);
                      }
                    )
                    .catch(function (e) {
                      console.log("error - catch", e);
                    });
                }
              }
            );
          } else {
            SweetAlert -
              swal(
                "Error",
                "No tienes permiso para realizar esta acción",
                "error"
              );
          }
        });
      }
      // Edit Contractor
      $scope.chngDesc = false;
      $scope.changeDescriptionC = function (val) {
        $scope.chngDesc = val;
      };
      $scope.saveDescript = function (cntr) {
        $http
          .patch(cntr.url, { description: cntr.description })
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                swal("Hecho", "Las observaciones se han guardado", "success");
                $scope.chngDesc = false;
                $scope.contratante.description = cntr.description;
              } else {
                swal("Error", "No se guardo la información.", "error");
              }
              var paramsCont = {
                model: cntr.type_person == "Fisica" ? 2 : 3,
                event: "PATCH",
                associated_id: cntr.id,
                identifier:
                  " actualizo las observaciones del contratante (Observaciones: " +
                  cntr.description +
                  ".",
              };
              dataFactory
                .post("send-log/", paramsCont)
                .then(function success(response) {});
            },
            function error(error) {
              console.log("error - email", error);
            }
          )
          .catch(function (e) {
            console.log("error - catch", e);
          });
      };

      function update_promesa_pago(receipt) {
        if (!main.new_promesa_pago) {
          toaster.error("Ingresa  promesa de pago");
          return;
        }
        $http
          .post(url.IP + "promesa-pago/", {
            recibo_id: receipt.id,
            promesa_pago: datesFactory.toDate(main.new_promesa_pago),
          })
          .then(function success(response) {
            if (response.status == 500) {
              try {
                toaster.error(response.data["detail"]);
              } catch (err) {
                console.log(err, response.data);
              }
            } else if (response.status == 200) {
              receipt.promesa_pago = main.new_promesa_pago;
            }
            main.edith_promesa_pago = false;
            return;
          });
      }

      function getPDF(poliza) {
        $http({
          method: "GET",
          url: url.IP + "get-pdf-ot/",
          params: {
            id: poliza,
          },
        }).then(function success(response) {
          // $scope.pdf = response.data;
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
          // $http({
          //   method: 'GET',
          //   url: url.IP + 'get-pdf',
          //   params: {
          //     'pdf_name': $scope.pdf.pdf_name
          //   }
          // }).then(function success(response) {

          //   })
        });
      }

      function openRenovateModal(myInsurance, type) {
        if (myInsurance.document_type == 1) {
          if (myInsurance.renewed) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRENEWPOLICY, "error");
          } else {
            var params = { polizaId: myInsurance.id };
            $scope.open_in_same_tab_natural(
              "Renovación póliza",
              "renovaciones.polizas",
              params,
              myInsurance.id
            );
            // $state.go('renovaciones.polizas', params);
          }
        } else if (myInsurance.document_type == 3) {
          if (myInsurance.renewed) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRENEWPOLICY, "error");
          } else {
            if (type == 1) {
              var params = { polizaId: myInsurance.id, tipo: 1 };
              $scope.open_in_same_tab_natural(
                "Renovación colectivos",
                "colectividades.renewal",
                params,
                myInsurance.id
              );
              // $state.go('colectividades.renewal', params);
            } else if (type == "") {
              var params = { polizaId: myInsurance.id, tipo: "" };
              $scope.open_in_same_tab_natural(
                "Renovación colectivos",
                "colectividades.renewal",
                params,
                myInsurance.id
              );
              // $state.go('colectividades.renewal', params);
            }
          }
        } else if (myInsurance.document_type == 4) {
          if (myInsurance.renewed) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRENEWPOLICY, "error");
          } else {
            if (type == 1) {
              var params = { polizaId: myInsurance.caratula, tipo: 1 };
              $scope.open_in_same_tab_natural(
                "Renovación colectivos",
                "colectividades.renewal",
                params,
                myInsurance.caratula
              );
              $state.go("colectividades.renewal", params);
            } else if (type == "") {
              var params = { polizaId: myInsurance.caratula, tipo: "" };
              $scope.open_in_same_tab_natural(
                "Renovación colectivos",
                "colectividades.renewal",
                params,
                myInsurance.caratula
              );
              $state.go("colectividades.renewal", params);
            }
          }
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      }

      function goToEdit(poliza) {
        if (poliza.document_type == 7) {
          $scope.open_in_same_tab_natural(
            "Edición fianza",
            "fianzas.editar",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('fianzas.editar', {polizaId: poliza.id});
        }
        if (poliza.document_type == 1) {
          $scope.open_in_same_tab_natural(
            "Edición póliza",
            "polizas.editar",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('polizas.editar', {polizaId: poliza.id});
        } else if (poliza.document_type == 3) {
          $scope.open_in_same_tab_natural(
            "Edición colectividades",
            "colectividades.edit",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('colectividades.edit', {polizaId: poliza.id});
        } else if (poliza.document_type == 11) {
          $scope.open_in_same_tab_natural(
            "Edición colectividades",
            "flotillas.edit",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('flotillas.edit', {polizaId: poliza.id});
        } else if (poliza.document_type == 4) {
          $scope.open_in_same_tab_natural(
            "Edición colectividades",
            "colectividades.edit",
            { polizaId: poliza.caratula },
            poliza.caratula
          );
          // $state.go('colectividades.edit', {polizaId: poliza.caratula});
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      }

      $scope.open_in_same_tab_natural = function (
        name,
        route,
        params,
        identifier
      ) {
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
        }

        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
        $localStorage.tab_states = appStates.states;
        $localStorage.tab_index = $localStorage.tab_states.length - 1;
        $state.go($scope.route_for_new_tab, params);
      };

      function goToPolicy(poliza) {
        if (poliza.document_type == 1) {
          $scope.open_in_same_tab_natural(
            "Pólizas",
            "polizas.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('polizas.info', {polizaId: poliza.id});
        } else if (poliza.document_type == 3) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('colectividades.info', {polizaId: poliza.id});
        } else if (poliza.document_type == 4) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.caratula },
            poliza.caratula
          );
          // $state.go('colectividades.info', {polizaId: poliza.caratula});
        } else if (poliza.document_type == 6) {
          $scope.open_in_same_tab_natural(
            "Colectividades",
            "colectividades.info",
            { polizaId: poliza.caratula },
            poliza.caratula
          );
          // $state.go('colectividades.info', {polizaId: poliza.caratula})
        } else if (poliza.document_type == 7) {
          $scope.open_in_same_tab_natural(
            "Fianzas",
            "fianzas.info",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('fianzas.info', {polizaId: poliza.id})
        } else if (poliza.document_type == 8) {
          $scope.open_in_same_tab_natural(
            "Fianzas",
            "fianzas.details",
            { polizaId: poliza.id },
            poliza.id
          );
          // $state.go('fianzas.details',{polizaId: poliza.id})
        } else if (poliza.document_type == 12) {
          $scope.open_in_same_tab_natural(
            "Flotillas",
            "flotillas.info",
            { polizaId: parseInt(poliza.caratula) },
            poliza.id
          );
          // $state.go('flotillas.info',{polizaId: parseInt(poliza.caratula)})
        } else if (poliza.document_type == 11) {
          $scope.open_in_same_tab_natural(
            "Flotillas",
            "flotillas.info",
            { polizaId: parseInt(poliza.caratula) },
            poliza.id
          );
          // $state.go('flotillas.info',{polizaId: parseInt(poliza.id)})
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      }
      // BITACORA
      main.showBinnacle($scope.recibo, "recibo_modal");

      if (poliza.document_type == 7) {
        dataFactory.get("leer-fianzas-info/" + poliza.id).then(
          function success(data) {
            $scope.myPolicy = data.data;

            // TRAE INFORMACIÓN DEL CONTRATANTE
            var idContratante = null;
            var dat = {};
            if ($scope.myPolicy.contractor) {
              idContratante = $scope.myPolicy.contractor.id
                ? $scope.myPolicy.contractor.id
                : $scope.myPolicy.contractor;
              dat.type = "morales";
              dat.contratanteId = idContratante;
            }
            if (dat.contratanteId) {
              var id_c = getContractorId($scope.myPolicy.contractor);
              dat.contratanteId = id_c;
            }
            ContratanteService.getContratante(dat).then(
              function success(request) {
                $scope.contratante = request;
                $scope.addressContratante = request.address_contractor[0];
              },
              function error(err) {
                console.log("err - contratante");
              }
            );
          },
          function error(error) {
            console.log("Error - poliza", error);
          }
        );
      } else {
        insuranceService.getInsuranceRead(poliza).then(
          function success(data) {
            $scope.myPolicy = data;

            // TRAE INFORMACIÓN DEL CONTRATANTE
            var idContratante = null;
            var dat = {};
            if ($scope.myPolicy.contractor) {
              idContratante = $scope.myPolicy.contractor.id
                ? $scope.myPolicy.contractor.id
                : $scope.myPolicy.contractor;
              dat.type = "morales";
              dat.contratanteId = idContratante;
            }
            if (dat.contratanteId) {
              var id_c = getContractorId($scope.myPolicy.contractor);
              dat.contratanteId = id_c;
            }
            ContratanteService.getContratante(dat).then(
              function success(request) {
                $scope.contratante = request;
                if (request && request.address_contractor) {
                  $scope.addressContratante = request.address_contractor[0];
                }
                // main.reloadReceiptsGraphic();
              },
              function error(err) {
                console.log("err - contratante");
              }
            );
          },
          function error(error) {
            console.log("Error - poliza", error);
          }
        );
      }
      updateReceiptStatus();
      try {
        if (
          $localStorage.receiptUpdated.id == main.idFReceiptFound &&
          $localStorage.receiptModified == true
        ) {
          main.pago_recibo_actual[0].status =
            $localStorage.receiptUpdated.status;
        }
      } catch (err) {}
      $scope.forma_pago = function (parValue) {
        switch (parValue) {
          case 1:
            return "Mensual";
            break;
          case 2:
            return "Bimestral";
            break;
          case 3:
            return "Trimestral";
            break;
          case 5:
            return "Contado";
            break;
          case 6:
            return "Semestral";
            break;
          case 12:
            return "Anual";
            break;
          case 24:
            return "Quincenal";
            break;
          default:
            return "No especificada";
        }
      };
      $scope.status = function (parValue) {
        switch (parValue) {
          case 1:
            return "En trámite";
            break;
          case 2:
            return "OT Cancelada";
            break;
          case 4:
            return "Precancelada";
            break;
          case 10:
            return "Por iniciar";
            break;
          case 11:
            return "Cancelada";
            break;
          case 12:
            return "Renovada";
            break;
          case 13:
            return "Vencida";
            break;
          case 14:
            return "Vigente";
            break;
          case 15:
            return "No renovada";
            break;
          default:
            return "Pendiente";
        }
      };
      $scope.dismis = function (receipt, v) {
        $scope.soloInfo = false;
        $uibModalInstance.dismiss("cancel");
        changeStatusModal(receipt, $scope.myPolicy);
      };
      $scope.reloadReceipts = function () {
        if (
          $localStorage.graficas_recibos_page &&
          $localStorage.graficas_recibos_url
        ) {
          main.reloadReceiptsGraphic();
          var currentPage = parseInt(
            $localStorage.graficas_recibos_page || "1",
            10
          );
          $http({
            method: "GET",
            url: url.IP + "chart-recibos/",
          }).then(function (ren) {
            main.receipts = ren.data;
            $localStorage.receipt_count = ren.data;
            $http.get($localStorage.graficas_recibos_url).then(
              function success(response) {
                main.receipts = response.data.results;
                main.config_receipts = {
                  count: response.data.count,
                  previous: response.data.previous,
                  next: response.data.next,
                  current_page: currentPage, // 👈 NUEVO
                  page: currentPage, // 👈 NUEVO
                };
                console.log("cccccccc", response);
                if (
                  response &&
                  response.data &&
                  response.data.results &&
                  main &&
                  main.recibos_a_pagar
                ) {
                  response.data.results.forEach(function (rec) {
                    main.recibos_a_pagar.forEach(function (rec_w) {
                      if (rec.id == rec_w.id) {
                        if (rec) {
                          rec.toPay = true;
                        } else {
                        }
                      }
                    });
                  });
                }
                main.show_paginationReceipts = true;
              },
              function error(xcxxx) {
                // si error, volver a intentar SIN el parámetro page
                var badUrl = $localStorage.graficas_recibos_url || "";
                var fixedUrl = badUrl;
                if (badUrl.indexOf("?") !== -1) {
                  var parts = badUrl.split("?");
                  var base = parts[0];
                  var query = parts[1] || "";
                  var filtered = [];
                  query.split("&").forEach(function (pair) {
                    if (!pair) return;
                    // excluir page=
                    if (pair.indexOf("page=") === 0) return;
                    filtered.push(pair);
                  });

                  if (filtered.length > 0) {
                    fixedUrl = base + "?" + filtered.join("&");
                  } else {
                    fixedUrl = base; // sin query
                  }
                }
                // console.log('Reintentando sin page:', fixedUrl);
                // actualizar en localStorage para futuros usos
                $localStorage.graficas_recibos_url = fixedUrl;
                if (fixedUrl) {
                  main.reloadReceiptsGraphic();
                  var currentPage = parseInt(
                    $localStorage.graficas_recibos_page || "1",
                    10
                  );
                  $http
                    .get($localStorage.graficas_recibos_url)
                    .then(function success(response) {
                      main.receipts = response.data.results;
                      main.config_receipts = {
                        count: response.data.count,
                        previous: response.data.previous,
                        next: response.data.next,
                        current_page: currentPage, // 👈 NUEVO
                        page: currentPage, // 👈 NUEVO
                      };
                      console.log("iiiiixxxxxxxiiiii", response);
                      if (
                        response &&
                        response.data &&
                        response.data.results &&
                        main &&
                        main.recibos_a_pagar
                      ) {
                        response.data.results.forEach(function (rec) {
                          main.recibos_a_pagar.forEach(function (rec_w) {
                            if (rec.id == rec_w.id) {
                              if (rec) {
                                rec.toPay = true;
                              } else {
                              }
                            }
                          });
                        });
                      }
                      main.show_paginationReceipts = true;
                    });
                }
              }
            );
          });
        }
      };
      $scope.cancel = function (valor) {
        console.log(
          "solo vio",
          valor,
          $scope.soloInfo,
          $localStorage["graficas_recibos_url"]
        );
        if ($uibModalInstance) {
          if ($localStorage["graficas_recibos_url"] && !$scope.soloInfo) {
            $scope.reloadReceipts();
          }
          $uibModalInstance.dismiss("cancel");
          main.coverageModal = true;
        }
      };
      $localStorage.receiptModified = false;
    }

    if ($localStorage.loginInfo) {
      initUser();
    }
    // $(function(){ $('#jcrop_target').Jcrop(); });
    function initUser() {
      var x = JSON.parse($localStorage.loginInfo);
      // if($window.localStorage.loginInfo)
      //   var x = JSON.parse($window.localStorage.loginInfo);
      // else
      //   var x = usr

      main.accesos = $sessionStorage.permisos;
      $rootScope.permisos_new = $rootScope.permisos;

      if ($sessionStorage.infoUser) {
        main.acceso_adm_tas = $sessionStorage.infoUser.another_tasks;
      } else {
        main.acceso_adm_tas = false;
      }

      if (main.accesos) {
        main.accesos.forEach(function (perm) {
          if (perm.model_name == "Dashboard") {
            main.acceso_dash = perm;
            main.acceso_dash.permissions.forEach(function (acc) {
              if (acc.permission_name == "Gráfica OTs") {
                if (acc.checked == true) {
                  main.permiso_g_ot = true;
                } else {
                  main.permiso_g_ot = false;
                }
              } else if (acc.permission_name == "Gráfica cobranza") {
                if (acc.checked == true) {
                  main.permiso_g_cob = true;
                } else {
                  main.permiso_g_cob = false;
                }
              } else if (acc.permission_name == "Gráfica renovaciones") {
                if (acc.checked == true) {
                  main.permiso_g_ren = true;
                } else {
                  main.permiso_g_ren = false;
                }
              } else if (acc.permission_name == "Gráfica siniestros") {
                if (acc.checked == true) {
                  main.permiso_g_sin = true;
                } else {
                  main.permiso_g_sin = false;
                }
              } else if (acc.permission_name == "KBI's") {
                if (acc.checked == true) {
                  main.permiso_kbi = true;
                } else {
                  main.permiso_kbi = false;
                }
              } else if (acc.permission_name == "Filtrado gráfica cobranza") {
                if (acc.checked == true) {
                  main.permiso_f_cob = true;
                } else {
                  main.permiso_f_cob = false;
                }
              }
            });
          }
          if (perm.model_name == "Pólizas") {
            main.acceso_polizas = perm;
            main.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  main.acceso_adm_pol = true;
                } else {
                  main.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  main.acceso_ver_pol = true;
                } else {
                  main.acceso_ver_pol = false;
                }
              } else if (acc.permission_name == "Eliminar pólizas") {
                if (acc.checked == true) {
                  main.acceso_del_pol = true;
                } else {
                  main.acceso_del_pol = false;
                }
              }
            });
          }
          if (perm.model_name == "Endosos") {
            $scope.acceso_endosos = perm;
            $scope.acceso_endosos.permissions.forEach(function (acc) {
              if (acc.permission_name == "Registrar endosos") {
                if (acc.checked == true) {
                  $scope.acceso_adm_end = true;
                } else {
                  $scope.acceso_adm_end = false;
                }
              }
            });
          }
          if (perm.model_name == "Ordenes de trabajo") {
            main.acceso_ot = perm;
            main.acceso_ot.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar OTs") {
                if (acc.checked == true) {
                  main.acceso_adm_ot = true;
                } else {
                  main.acceso_adm_ot = false;
                }
              } else if (acc.permission_name == "Ver OTs") {
                if (acc.checked == true) {
                  main.acceso_ver_ot = true;
                } else {
                  main.acceso_ver_ot = false;
                }
              } else if (acc.permission_name == "Tablero de OTs") {
                if (acc.checked == true) {
                  main.acceso_tab_ots = true;
                } else {
                  main.acceso_tab_ots = false;
                }
              }
            });
          }
          if (perm.model_name == "Siniestros") {
            main.acceso_sin = perm;
            main.acceso_sin.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar siniestros") {
                if (acc.checked == true) {
                  main.acceso_adm_sin = true;
                } else {
                  main.acceso_adm_sin = false;
                }
              }
            });
          }
          if (perm.model_name == "Paquetes") {
            main.acceso_pack = perm;
            main.acceso_pack.permissions.forEach(function (acc) {
              if (acc.permission_name == "Crear paquete") {
                if (acc.checked == true) {
                  main.acceso_adm_pack = true;
                } else {
                  main.acceso_adm_pack = false;
                }
              }
            });
          }
          if (perm.model_name == "Configuración") {
            main.acceso_cob = perm;
            main.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Configuración") {
                if (acc.checked == true) {
                  main.acceso_configuracion = true;
                } else {
                  main.acceso_configuracion = false;
                }
              } else if (
                acc.permission_name == "Clasificación, Células y Agrupaciones"
              ) {
                if (acc.checked == true) {
                  main.acceso_clasificacion = true;
                } else {
                  main.acceso_clasificacion = false;
                }
              }
            });
          }
          if (perm.model_name == "Cobranza") {
            main.acceso_cob = perm;
            main.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  main.acceso_ver_cob = true;
                } else {
                  main.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  main.acceso_desp_cob = true;
                } else {
                  main.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  main.acceso_pag_cob = true;
                } else {
                  main.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  main.acceso_desco_cob = true;
                } else {
                  main.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  main.acceso_conc_cob = true;
                } else {
                  main.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  main.acceso_liq_cob = true;
                } else {
                  main.acceso_liq_cob = false;
                }
              }
            });
          }
          if (perm.model_name == "Correos electronicos") {
            main.acceso_correo = perm;
            main.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  main.acceso_cor = true;
                } else {
                  main.acceso_cor = false;
                }
              }
            });
          }
          if (perm.model_name == "Reportes") {
            main.acceso_reportes = perm;
            main.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  main.acceso_rep_fia = true;
                } else {
                  main.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  main.acceso_rep_sin = true;
                } else {
                  main.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  main.acceso_rep_end = true;
                } else {
                  main.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  main.acceso_rep_pol = true;
                } else {
                  main.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  main.acceso_rep_ren = true;
                } else {
                  main.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  main.acceso_rep_cob = true;
                } else {
                  main.acceso_rep_cob = false;
                }
              } else if (acc.permission_name == "Reporte de Log") {
                if (acc.checked == true) {
                  main.acceso_rep_log = true;
                } else {
                  main.acceso_rep_log = false;
                }
              } else if (acc.permission_name == "Reportes Especiales") {
                if (acc.checked == true) {
                  main.acceso_rep_esp = true;
                } else {
                  main.acceso_rep_esp = false;
                }
              } else if (acc.permission_name == "Reportes Estadísticos") {
                if (acc.checked == true) {
                  main.acceso_rep_est = true;
                } else {
                  main.acceso_rep_est = false;
                }
              }
            });
          }
          if (perm.model_name == "Formatos") {
            main.acceso_form = perm;
            main.acceso_form.permissions.forEach(function (acc) {
              if (acc.permission_name == "Formatos") {
                if (acc.checked == true) {
                  main.acceso_form = true;
                } else {
                  main.acceso_form = false;
                }
              }
            });
          }
          if (perm.model_name == "Agenda") {
            main.acceso_age = perm;
            main.acceso_age.permissions.forEach(function (acc) {
              if (acc.permission_name == "Agenda") {
                if (acc.checked == true) {
                  main.acceso_age = true;
                } else {
                  main.acceso_age = false;
                }
              }
            });
          }
          if (perm.model_name == "Notificaciones") {
            main.acceso_mns = perm;
            main.acceso_mns.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar notificaciones") {
                if (acc.checked == true) {
                  main.acceso_not = true;
                } else {
                  main.acceso_not = false;
                }
              }
            });
          }
          if (perm.model_name == "Mensajeria") {
            main.acceso_mns = perm;
            main.acceso_mns.permissions.forEach(function (acc) {
              if (acc.permission_name == "Mensajeria") {
                if (acc.checked == true) {
                  main.acceso_mns = true;
                } else {
                  main.acceso_mns = false;
                }
              }
            });
          }
          if (perm.model_name == "Campañas") {
            main.acceso_camp = perm;
            main.acceso_camp.permissions.forEach(function (acc) {
              if (acc.permission_name == "Campañas") {
                if (acc.checked == true) {
                  main.acceso_camp = true;
                } else {
                  main.acceso_camp = false;
                }
              }
            });
          }
          if (perm.model_name == "Contratantes y grupos") {
            main.acceso_contg = perm;
            main.acceso_contg.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar contratantes y grupos") {
                if (acc.checked == true) {
                  main.acceso_adm_cont = true;
                } else {
                  main.acceso_adm_cont = false;
                }
              } else if (acc.permission_name == "Ver contratantes y grupos") {
                if (acc.checked == true) {
                  main.acceso_ver_cont = true;
                } else {
                  main.acceso_ver_cont = false;
                }
              }
            });
          }
          if (perm.model_name == "Referenciadores") {
            main.acceso_ref = perm;
            main.acceso_ref.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar referenciadores") {
                if (acc.checked == true) {
                  main.acceso_adm_ref = true;
                } else {
                  main.acceso_adm_ref = false;
                }
              } else if (acc.permission_name == "Pagar a referenciadores") {
                if (acc.checked == true) {
                  main.acceso_pag_ref = true;
                } else {
                  main.acceso_pag_ref = false;
                }
              } else if (acc.permission_name == "Ver referenciadores") {
                if (acc.checked == true) {
                  main.ver_referenciador = true;
                } else {
                  main.ver_referenciador = false;
                }
              } else if (acc.permission_name == "Estados de Cuenta") {
                if (acc.checked == true) {
                  main.acceso_edo_cuenta = true;
                } else {
                  main.acceso_edo_cuenta = false;
                }
              }
            });
          }
          if (perm.model_name == "Fianzas") {
            main.acceso_fian = perm;
            main.acceso_fian.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar fianzas") {
                if (acc.checked == true) {
                  main.acceso_adm_fia = true;
                } else {
                  main.acceso_adm_fia = false;
                }
              } else if (acc.permission_name == "Ver fianzas") {
                if (acc.checked == true) {
                  main.acceso_ver_fia = true;
                } else {
                  main.acceso_ver_fia = false;
                }
              }
            });
          }
          if (perm.model_name == "Comisiones") {
            main.acceso_dash = perm;
            main.acceso_dash.permissions.forEach(function (acc) {
              if (acc.permission_name == "Comisiones") {
                if (acc.checked == true) {
                  main.permiso_comisiones = true;
                } else {
                  main.permiso_comisiones = false;
                }
              }
            });
          }
          if (perm.model_name == "Archivos") {
            main.acceso_files = perm;
            main.acceso_files.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  main.permiso_archivos = true;
                } else {
                  main.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  main.permiso_administrar_adjuntos = true;
                } else {
                  main.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
          if (perm.model_name == "Cotizaciones") {
            main.acceso_cotizaciones = perm;
            main.acceso_cotizaciones.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cotizaciones") {
                if (acc.checked == true) {
                  main.acceso_ver_cotizaciones = true;
                } else {
                  main.acceso_ver_cotizaciones = false;
                }
              }
            });
          }
        });
      }
      refreshUserFromStorage(false);
      $scope.decrptedtoken = usr;

      if (usr && usr.org) {
        main.userName = usr.name;
        main.user = usr.name;
        main.full_name = x.first_name + " " + x.last_name;
        // main.avatar = usr.avatar;
        // main.logo_mini = 'https://miurabox-public.s3.amazonaws.com/cas/'+ x.org.logo_mini;
        main.logo_mini = x.org.logo_mini;
        if (
          main.logo_mini == "https://miurabox-public.s3.amazonaws.com/cas/" ||
          main.logo_mini == "https://miurabox.s3.amazonaws.com/cas/undefined"
        ) {
          main.logo_mini = "";
        }
        main.role = usr.role[1];
        main.org = usr.org;
        main.orgname = x.org.name.toUpperCase();
        main.permisos = $localStorage.permissions;
      } else {
        main.userName = "Adrian";
        main.user = "GPI";
        main.avatar = "";
        main.logo_mini = "";
        main.role = "";
        main.org = "Test";
        main.orgname = "Test";
      }

      if ($localStorage.avatar) {
        main.avatar = $localStorage.avatar;
      }
    }

    function ChangeStatus(obj, index) {
      swal(
        {
          title: "¿Está seguro?",
          text: "¡El cambio aplicado es irreversible!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "¡Si, aplicar!",
          cancelButtonText: "¡No, cancelar!",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var modalInstance = $uibModal.open({
              //jshint ignore:line
              templateUrl: "app/main/receipt_type_Pago.html",
              controller: EditPagosCtrl,
              size: "lg",
              resolve: {
                pagosModal: function () {
                  return main.pago_recibo_actual;
                },
              },
              backdrop:
                "static" /* this prevent user interaction with the background */,
              keyboard: false,
            });

            var recibo = {
              status: obj.status.value,
            };
            $http.patch(obj.url, recibo).then(function (response) {
              main.receipts[index] = response.data;
              updatReceiptsCount();
            });

            swal("¡Hecho!", "El cambio se ha aplicado.", "success");
          } else {
            $http.get(obj.url).then(function (response) {
              main.pago_recibo_actual[index].status = response.data.status;
            });
            swal("Cancelado", "El cambio no se ha aplicado", "error");
            updatReceiptsCount();
            // window.location.reload();
          }
        }
      );
    }

    function saveStatus(obj, index) {
      obj.status = obj.status.value;
      obj.poliza = obj.poliza.url;
      receiptService.updateReceiptService(obj).then(function (data) {
        //activate();
        //toaster.success(MESSAGES.OK.CORRECTCHANGE);
        toaster.success(MESSAGES.OK.CORRECTCHANGE);
        main.receipts[index] = data.data;
      });
    }

    $scope.main.active = 0;

    $scope.showTap = function () {
      if (main.insurances.length == 0) {
        $scope.main.active = 1;
        if (main.endo_vida.length == 0) {
          $scope.main.active = 2;
          if (main.endo_gm.length == 0) {
            $scope.main.active = 3;
            if (main.endo_danos.length == 0) {
              $scope.main.active = 4;
              if (main.endo_autos.length == 0) {
                $scope.main.active = 0;
              } else {
                $scope.main.active = 4;
              }
            } else {
              $scope.main.active = 3;
            }
          } else {
            $scope.main.active = 2;
          }
        } else {
          $scope.main.active = 1;
        }
      } else {
        $scope.main.active = 0;
      }
      if ($scope.main.vida == true) {
        $scope.main.vida = true;
        $scope.main.active = 1;
        $scope.main.gastos = false;
        $scope.main.d = false;
        $scope.main.ots = false;
      }
      if ($scope.main.gastos == true) {
        $scope.main.gastos = true;
        $scope.main.active = 2;
        $scope.main.d = false;
        $scope.main.vida = false;
        $scope.main.ots = false;
      }
      if ($scope.main.d == true) {
        $scope.main.d = true;
        $scope.main.active = 3;
        $scope.main.gastos = false;
        $scope.main.vida = false;
        $scope.main.ots = false;
      }
      if ($scope.main.autos == true) {
        $scope.main.autos = true;
        $scope.main.active = 4;
        $scope.main.gastos = false;
        $scope.main.vida = false;
        $scope.main.ots = false;
        $scope.main.d = false;
      }
      if ($scope.main.ots == true) {
        $scope.main.ots = true;
        $scope.main.autos = false;
        $scope.main.active = 0;
        $scope.main.gastos = false;
        $scope.main.vida = false;
        $scope.main.d = false;
      }
    };

    /** OT Chart Controller */
    // ------------------------------------
    main.btn_all = false;
    main.oknotification = false;
    main.changePolicyDashAll = changePolicyDashAll;
    function changePolicyDashAll(par, asc) {
      main.vida = false;
      main.gastos = false;
      main.d = false;
      main.autos = false;
      main.ots = true;
      switch (par) {
        case 1:
          showTotalOt(par, asc);
          main.policy_type_asc = asc;
          main.policy_folio_asc = 0;
          main.policy_fint_asc = 0;
          main.policy_cont_asc = 0;
          main.policy_subr_asc = 0;
          main.policy_aseg_asc = 0;
          main.policy_fcre_asc = 0;
          break;
        case 2:
          showTotalOt(par, asc);
          main.policy_folio_asc = asc;
          main.policy_type_asc = 0;
          main.policy_fint_asc = 0;
          main.policy_cont_asc = 0;
          main.policy_subr_asc = 0;
          main.policy_aseg_asc = 0;
          main.policy_fcre_asc = 0;
          break;
        case 3:
          showTotalOt(par, asc);
          main.policy_fint_asc = asc;
          main.policy_type_asc = 0;
          main.policy_folio_asc = 0;
          main.policy_cont_asc = 0;
          main.policy_subr_asc = 0;
          main.policy_aseg_asc = 0;
          main.policy_fcre_asc = 0;
          break;
        case 4:
          showTotalOt(par, asc);
          main.policy_cont_asc = asc;
          main.policy_folio_asc = 0;
          main.policy_type_asc = 0;
          main.policy_fint_asc = 0;
          main.policy_subr_asc = 0;
          main.policy_aseg_asc = 0;
          main.policy_fcre_asc = 0;
          break;
        case 5:
          showTotalOt(par, asc);
          main.policy_subr_asc = asc;
          main.policy_type_asc = 0;
          main.policy_folio_asc = 0;
          main.policy_fint_asc = 0;
          main.policy_cont_asc = 0;
          main.policy_aseg_asc = 0;
          main.policy_fcre_asc = 0;
        case 6:
          showTotalOt(par, asc);
          main.policy_aseg_asc = asc;
          main.policy_type_asc = 0;
          main.policy_folio_asc = 0;
          main.policy_fint_asc = 0;
          main.policy_cont_asc = 0;
          main.policy_subr_asc = 0;
          main.policy_fcre_asc = 0;
          break;
        case 7:
          showTotalOt(par, asc);
          main.policy_type_asc = 0;
          main.policy_folio_asc = 0;
          main.policy_fint_asc = 0;
          main.policy_cont_asc = 0;
          main.policy_subr_asc = 0;
          main.policy_aseg_asc = 0;
          main.policy_fcre_asc = asc;
          break;
      }
    }
    // ----------------------------------ENDOSOS
    main.showEndV = false;
    main.changeEndDashVida = changeEndDashVida;
    function changeEndDashVida(par, asc) {
      main.vida = true;
      main.gastos = false;
      main.d = false;
      switch (par) {
        case 1:
          showTotalOt(par, asc);
          main.vida_type_asc = asc;
          main.vida_cont_asc = 0;
          main.vida_nump_asc = 0;
          main.vida_aseg_asc = 0;
          main.vida_creac_asc = 0;
          break;
        case 2:
          showTotalOt(par, asc);
          main.vida_cont_asc = asc;
          main.vida_type_asc = 0;
          main.vida_nump_asc = 0;
          main.vida_aseg_asc = 0;
          main.vida_creac_asc = 0;
          break;
        case 3:
          showTotalOt(par, asc);
          main.vida_nump_asc = asc;
          main.vida_type_asc = 0;
          main.vida_cont_asc = 0;
          main.vida_aseg_asc = 0;
          main.vida_creac_asc = 0;
          break;
        case 4:
          showTotalOt(par, asc);
          main.vida_aseg_asc = asc;
          main.vida_cont_asc = 0;
          main.vida_type_asc = 0;
          main.vida_nump_asc = 0;
          main.vida_creac_asc = 0;
          break;
        case 5:
          showTotalOt(par, asc);
          main.vida_creac_asc = asc;
          main.vida_type_asc = 0;
          main.vida_cont_asc = 0;
          main.vida_nump_asc = 0;
          main.vida_aseg_asc = 0;
          break;
      }
    }
    main.showEndG = false;
    main.changeEndDashGastos = changeEndDashGastos;
    function changeEndDashGastos(par, asc) {
      main.gastos = true;
      main.vida = false;
      main.d = false;
      switch (par) {
        case 1:
          showTotalOt(par, asc);
          main.gastos_type_asc = asc;
          main.gastos_cont_asc = 0;
          main.gastos_nump_asc = 0;
          main.gastos_aseg_asc = 0;
          main.gastos_creac_asc = 0;
          break;
        case 2:
          showTotalOt(par, asc);
          main.gastos_cont_asc = asc;
          main.gastos_type_asc = 0;
          main.gastos_nump_asc = 0;
          main.gastos_aseg_asc = 0;
          main.gastos_creac_asc = 0;
          break;
        case 3:
          showTotalOt(par, asc);
          main.gastos_nump_asc = asc;
          main.gastos_type_asc = 0;
          main.gastos_cont_asc = 0;
          main.gastos_aseg_asc = 0;
          main.gastos_creac_asc = 0;
          break;
        case 4:
          showTotalOt(par, asc);
          main.gastos_aseg_asc = asc;
          main.gastos_cont_asc = 0;
          main.gastos_type_asc = 0;
          main.gastos_nump_asc = 0;
          main.gastos_creac_asc = 0;
          break;
        case 5:
          showTotalOt(par, asc);
          main.gastos_creac_asc = asc;
          main.gastos_type_asc = 0;
          main.gastos_cont_asc = 0;
          main.gastos_nump_asc = 0;
          main.gastos_aseg_asc = 0;
          break;
      }
    }
    main.showEndD = false;
    main.changeEndDashDanos = changeEndDashDanos;
    function changeEndDashDanos(par, asc) {
      main.d = true;
      main.gastos = false;
      main.vida = false;
      switch (par) {
        case 1:
          showTotalOt(par, asc);
          main.d_type_asc = asc;
          main.d_cont_asc = 0;
          main.d_nump_asc = 0;
          main.d_aseg_asc = 0;
          main.d_creac_asc = 0;
          break;
        case 2:
          showTotalOt(par, asc);
          main.d_cont_asc = asc;
          main.d_type_asc = 0;
          main.d_nump_asc = 0;
          main.d_aseg_asc = 0;
          main.d_creac_asc = 0;
          break;
        case 3:
          showTotalOt(par, asc);
          main.d_nump_asc = asc;
          main.d_type_asc = 0;
          main.d_cont_asc = 0;
          main.d_aseg_asc = 0;
          main.d_creac_asc = 0;
          break;
        case 4:
          showTotalOt(par, asc);
          main.d_aseg_asc = asc;
          main.d_cont_asc = 0;
          main.d_type_asc = 0;
          main.d_nump_asc = 0;
          main.d_creac_asc = 0;
          break;
        case 5:
          showTotalOt(par, asc);
          main.d_creac_asc = asc;
          main.d_type_asc = 0;
          main.d_cont_asc = 0;
          main.d_nump_asc = 0;
          main.d_aseg_asc = 0;
          break;
      }
    }
    main.showEndA = false;
    main.changeEndDashAutos = changeEndDashAutos;
    function changeEndDashAutos(par, asc) {
      main.autos = true;
      main.gastos = false;
      main.vida = false;
      main.d = false;
      switch (par) {
        case 1:
          showTotalOt(par, asc);
          main.a_type_asc = asc;
          main.a_cont_asc = 0;
          main.a_nump_asc = 0;
          main.a_aseg_asc = 0;
          main.a_creac_asc = 0;
          break;
        case 2:
          showTotalOt(par, asc);
          main.a_cont_asc = asc;
          main.a_type_asc = 0;
          main.a_nump_asc = 0;
          main.a_aseg_asc = 0;
          main.a_creac_asc = 0;
          break;
        case 3:
          showTotalOt(par, asc);
          main.a_nump_asc = asc;
          main.a_type_asc = 0;
          main.a_cont_asc = 0;
          main.a_aseg_asc = 0;
          main.a_creac_asc = 0;
          break;
        case 4:
          showTotalOt(par, asc);
          main.a_aseg_asc = asc;
          main.a_cont_asc = 0;
          main.a_type_asc = 0;
          main.a_nump_asc = 0;
          main.a_creac_asc = 0;
          break;
        case 5:
          showTotalOt(par, asc);
          main.a_creac_asc = asc;
          main.a_type_asc = 0;
          main.a_cont_asc = 0;
          main.a_nump_asc = 0;
          main.a_aseg_asc = 0;
          break;
      }
    }
    // ----------------------------------ENDOSOS
    function showTotalOt(order, asc) {
      main.cadena = "";
      main.last_color = "all";
      main.orden = order;
      main.ascendente = asc;
      main.showTable = false;

      var params = { order: order, asc: asc, tipo: null };
      // $http({
      //     method: 'GET',
      //     url: url.IP + 'graficas-endosos/',
      //     params: params
      // })
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.chart_endorsement = 'v2/polizas/graficas-endosos/';
      $scope.chart_endorsement = "graficas-endosos/";
      $http({
        method: "POST",
        url: url.IP + $scope.chart_endorsement,
        data: params,
      })
        .then(
          function success(request) {
            main.endo = request.data.results;
            if (main.endo) {
              // main.show_paginationEndo = true;
              main.endo_pagination = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
            } else {
              // main.show_paginationEndo = false;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });

      insuranceService.getOTsResume(order, asc).then(function (req) {
        main.insurances.length = [];

        var data = req.data;
        // $scope.show_ots_pagination = true;
        main.otPending = data;

        var today = new Date();
        today = today.getTime();
        data.forEach(function (item) {
          var fechaInicio = new Date(item.created_at).getTime();
          var diff = today - fechaInicio;
          item.antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
          main.insurances.push(item);
          if (main.insurances.length == req.data.length) {
            $scope.showTap();
          }
        });
        main.insurances.forEach(function (value) {
          if (value.old_policies) {
            value.old_policies.forEach(function (old) {
              if (old) {
                if (value.id == old.base_policy.id) {
                  if (value.renewed) {
                    value.historic = " Renovada";
                  } else {
                    value.historic = " por renovar";
                  }
                } else if (value.id == old.new_policy.id) {
                  value.historic = "de Renovación";
                } else {
                  value.historic = " nueva";
                }
              } else {
                value.historic = " nueva";
              }
            });
            if (value.historic) {
            } else {
              value.historic = " nueva";
            }
          }
          // $http({
          //   method: 'GET',
          //   url: url.IP + 'historic-policies/',
          //   params: {
          //     actual_id: value.id
          //   }
          // }).then(function success(response) {
          //   if(response.data.results.length){
          //     response.data.results.forEach(function function_name(old) {
          //       if(old.base_policy){
          //         if(value.id == old.new_policy.id){
          //           if (old.new_policy) {
          //             value.historic ='de Renovación';
          //           }
          //         } else {
          //             value.historic = ' nueva'
          //         }
          //       }else{
          //         value = ''
          //       }
          //     })
          //   }else{
          //     value.historic = ' nueva'
          //   }
          // })
        });
        main.ot_pagination = req.config;
        // main.show_paginationOt = true;
        // main.show_ots_pagination = true;
        main.totalPendingOts = {
          size: 0,
          collection: [],
          red: [],
          orange: [],
          yellow: [],
          green: [],
        };
        main.totalEndorsement = {
          size: 0,
          collection: [],
          red: [],
          orange: [],
          yellow: [],
          green: [],
        };
        if (data) {
          data.forEach(function (elem) {
            if (elem.status === 1) {
              elem.colorDate = "1";
              main.totalPendingOts.collection.push(elem);
              var diff = moment().diff(moment(elem.created_at), "days");
              if (diff <= 6) {
                main.totalPendingOts.green.push(elem);
                main.data[0] += 1;
                main.totalPendingOts.size += 1;
              } else if (diff >= 7 && diff <= 13) {
                main.totalPendingOts.yellow.push(elem);
                main.data[1] += 1;
                main.totalPendingOts.size += 1;
              } else if (diff >= 14 && diff <= 20) {
                main.totalPendingOts.orange.push(elem);
                main.data[2] += 1;
                main.totalPendingOts.size += 1;
              } else if (diff >= 21) {
                main.totalPendingOts.red.push(elem);
                main.data[3] += 1;
                main.totalPendingOts.size += 1;
              }
            }
          });
        }
        if (main.endorsements) {
          main.endorsements.forEach(function (elem) {
            if (elem.status == 1) {
              main.totalEndorsement.collection.push(elem);
              main.totalEndorsement.size += 1;

              var diff = moment().diff(moment(elem.created_at), "days"); //jshint ignore:line
              if (diff <= 6) {
                main.totalEndorsement.green.push(elem);
                main.data[0] += 1;
              } else if (diff >= 7 && diff <= 13) {
                main.totalEndorsement.yellow.push(elem);
                main.data[1] += 1;
              } else if (diff >= 14 && diff <= 20) {
                main.totalEndorsement.orange.push(elem);
                main.data[2] += 1;
              } else if (diff >= 21) {
                main.totalEndorsement.red.push(elem);
                main.data[3] += 1;
              }
            }
          });
        }
      });

      var validPolicyNumber = [];
      main.titleID = null;
      main.title = "";
      $("html, body").animate(
        {
          scrollTop: $("#polizas").offset().top,
        },
        "slow"
      );
      showAndHidePanels(true, false, false);
    }
    main.exportDataAll = exportDataAll;
    function exportDataAll(param) {
      if (main.last_color) {
        var tiipo = main.last_color;
      } else {
        var tiipo = "all";
      }
      main.btn_all = true;
      if (main.cadena) {
        var params = {
          order: main.orden ? main.orden : 1,
          asc: main.ascendente ? main.ascendente : 1,
          tipo: tiipo,
          cadena: main.cadena,
        };
      } else {
        var params = {
          order: main.orden ? main.orden : 1,
          asc: main.ascendente ? main.ascendente : 1,
          tipo: tiipo,
        };
      }
      if (param == 1) {
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   $scope.excel_policy = 'v2/polizas/excel-graficas-polizas/';
        $scope.excel_policy = "excel-graficas-polizas/";
        $http({
          method: "GET",
          url: url.IP + $scope.excel_policy,
          params: params,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function success(data) {
          if (data.status == 200) {
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte_Dash_OTs.xls");
          } else {
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al descargar el reporte",
              "error"
            );
          }
        });
      } else if (param == 2) {
        if (main.cadena) {
          var params = {
            order: main.orden ? main.orden : 1,
            asc: main.ascendente ? main.ascendente : 1,
            tipo: tiipo,
            cadena: main.cadena,
          };
        } else {
          var params = {
            order: main.orden ? main.orden : 1,
            asc: main.ascendente ? main.ascendente : 1,
            tipo: tiipo,
          };
        }
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   $scope.excel_endorsement = 'v2/polizas/excel-graficas-endosos/';
        $scope.excel_endorsement = "excel-graficas-endosos/";
        $http({
          method: "GET",
          url: url.IP + $scope.excel_endorsement,
          params: params,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function success(data) {
          if (data.status == 200) {
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte_Dash_OTsEndosos.xls");
          } else {
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al descargar el reporte",
              "error"
            );
          }
        });
      }
    }
    main.exportDataGral = exportDataGral;
    function exportDataGral(param) {
      var lots = Ladda.create(document.querySelector(".ladda-button4"));
      lots.start();
      if (main.last_color) {
        var tiipo = main.last_color;
      } else {
        var tiipo = "all";
      }
      main.btn_all = true;
      if (main.cadena) {
        var params = {
          order: main.orden ? main.orden : 1,
          asc: main.ascendente ? main.ascendente : 1,
          tipo: tiipo,
          cadena: main.cadena,
        };
      } else {
        var params = {
          order: main.orden ? main.orden : 1,
          asc: main.ascendente ? main.ascendente : 1,
          tipo: tiipo,
        };
      }
      // if (param == 1){
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   // $scope.excel_policy_ = 'v2/polizas/excel-graficas-otsendosos/';
      //   $scope.excel_policy_ = 'service_reporte-v2-otsEndososDash-excel'
      $scope.excel_policy_ = "service_reporte-otsEndososDash-excel";
      $http({
        method: "GET",
        url: url.IP + $scope.excel_policy_,
        params: params,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function success(data) {
        if (data.status == 200) {
          lots.stop();
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Dash_OTs_Endosos.xls");
        } else {
          lots.stop();
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
      // }
    }

    $scope.exportDataGralTask = function (param) {
      if (main.last_color) {
        var tiipo = main.last_color;
      } else {
        var tiipo = "all";
      }
      var data = {
        order: main.orden ? main.orden : 1,
        asc: main.ascendente ? main.ascendente : 1,
        tipo: tiipo,
      };

      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.excel_endorsement = 'v2/polizas/service_reporte-taskdashReport-excel';
      $scope.excel_endorsement = "service_reporte-taskdashReport-excel";
      $http({
        method: "POST",
        url: url.IP + $scope.excel_endorsement,
        data: data,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function success(data) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Dash_Tareas.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
    };

    function editInsurance(insurance) {
      main.insurance = insurance;
      editPolicyModal();
    }

    function showAndHidePanels(first, second, third) {
      main.policyTable = first;
      main.endorsementTable = first;
      main.coverageTable = second;
      main.renewalTable = third;
    }

    main.$onDestroy = function () {
      main.socket.disconnect();
    };

    function renewPolicy(policy) {
      var modalInstance = $uibModal
        .open({
          templateUrl: "app/renovaciones/renovaciones.modal.html",
          controller: "RenewalModalCtrl",
          size: "lg",
          resolve: {
            user: function () {
              return usr;
            },
            myPolicy: function () {
              return policy;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        })
        .result.then(
          function (argument) {},
          function (argument) {
            if (argument != "backdrop click" && argument != "cancel") {
              main.policies.splice(main.policies.indexOf(policy), 1);
            }
          }
        );
    }

    $scope.createTask = function () {
      $scope.open_in_same_tab_natural("Crear tarea", "task.task", {}, 0);
      $state.go("task.task", { id_task: -1, main_comming: false });
    };

    $scope.showTask = function () {
      main.policyTable = false;
      main.coverageTable = false;
      main.coverageModal = false;
      main.notas = false;
      main.renewalTable = false;
      main.sinisterTable = false;

      $http({
        method: "GET",
        url: url.IP + "chart-tasks/",
      }).then(function (response) {
        $scope.chartsTasks = response.data;
      });
    };

    $scope.hide_task = false;
    $scope.hideTask = function (param) {
      $scope.hide_task = param;
    };

    $scope.showTableTasks = function (type) {
      $scope.typeGraphyc = "";
      main.showTable = true;
      main.policyTable = false;
      main.coverageTable = false;
      main.coverageModal = false;
      main.notas = false;
      main.renewalTable = false;
      main.sinisterTable = false;
      main.showTableQ = false;
      main.titleID = type;
      if (type == 1) {
        var parType = "green";
        $scope.typeGraphyc = "En tiempo";
      } else if (type == 2) {
        var parType = "yellow";
        $scope.typeGraphyc = "Atención";
      } else if (type == 3) {
        var parType = "orange";
        $scope.typeGraphyc = "Atención urgente";
      } else if (type == 4) {
        var parType = "red";
        $scope.typeGraphyc = "Urgente";
      } else {
        var parType = "total";
        $scope.typeGraphyc = "General";
      }
      main.last_color = parType;

      $scope.params = {
        asc: 1,
        order: 1,
        tipo: parType,
      };

      dataFactory
        .post("graficas-tasks/", $scope.params)
        .then(function success(response) {
          if (response.data) {
            $scope.tickets = response.data.results;
            $scope.tickets.forEach(function (item) {
              item.model = 22;
              item.id_reference = item.id;
            });
          }
        });
    };

    main.color = 0;
    $scope.getLog = function (quotation) {
      dataFactory
        .get("get-specific-log", { model: 30, associated_id: quotation.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    };
    /** Quotations Graphyc */
    $scope.showQuotations = function () {
      main.policyTable = false;
      main.coverageTable = false;
      main.coverageModal = false;
      main.notas = false;
      main.renewalTable = false;
      main.sinisterTable = false;
      main.taskTable = false;
      main.showTable = false;

      $http({
        method: "GET",
        url: url.IP + "chart-quotations/",
      }).then(function (response) {
        $scope.chartsQuotations = response.data;
      });
    };
    $scope.showpag = false;

    function unicodeToChar(text) {
      return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
        return String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16));
      });
    }
    $scope.showTableQuotations = function (type, page) {
      $scope.typeGraphyc = "";
      main.showTable = false;
      main.showTableQ = true;
      main.policyTable = false;
      main.coverageTable = false;
      main.coverageModal = false;
      main.notas = false;
      main.renewalTable = false;
      main.sinisterTable = false;
      main.taskTable = false;
      main.titleID = type;
      if (type == 1) {
        var parType = "green";
        $scope.typeGraphyc = "En tiempo";
      } else if (type == 2) {
        var parType = "yellow";
        $scope.typeGraphyc = "Atención";
      } else if (type == 3) {
        var parType = "orange";
        $scope.typeGraphyc = "Atención urgente";
      } else if (type == 4) {
        var parType = "red";
        $scope.typeGraphyc = "Urgente";
      } else {
        var parType = "total";
        $scope.typeGraphyc = "General";
      }
      main.last_color = parType;

      $scope.params = {
        asc: 1,
        order: 1,
        tipo: parType,
        page: page ? page : 1,
      };

      dataFactory
        .post("graficas-quotations/", $scope.params)
        .then(function success(response) {
          if (response.data) {
            $scope.obtenerPaginacion(response.data, page ? page : 1);
            $scope.showpag = true;
            $scope.quotations = response.data.results;
            $scope.quotations = $scope.quotations.map(function (item) {
              item.ramo = item.ramo
                ? JSON.parse(unicodeToChar(item.ramo.replaceAll("'", '"')))[
                    "name"
                  ]
                : "";
              item.subramo = item.subramo
                ? JSON.parse(unicodeToChar(item.subramo.replaceAll("'", '"')))[
                    "name"
                  ]
                : "";
              if (item.aseguradora) {
                item.aseguradora = item.aseguradora.map(function (itemAseg) {
                  itemAseg = itemAseg
                    .replaceAll('"\\', "")
                    .replaceAll('\\"', "")
                    .replaceAll("\\\\", "");
                  if (itemAseg) {
                    itemAseg = unicodeToChar(itemAseg.replaceAll("'", '"'));
                    try {
                      itemAseg = JSON.parse(itemAseg.substring(1).slice(0, -1))[
                        "alias"
                      ];
                    } catch (err) {
                      itemAseg = JSON.parse(itemAseg)["alias"];
                    }
                  }
                  return itemAseg;
                });
              }
              return item;
            });
          }
        });
    };
    $scope.exportDataGralQuotations = function (param) {
      var data = {
        tipo: main.titleID ? main.titleID : "todos",
      };
      $http({
        method: "POST",
        url: url.IP + "service-reporte-quotationsDashReport-excel",
        data: data,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function success(data) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Dash_Cotizaciones.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
    };
    $scope.obtenerPaginacion = function (pagesdata, pagina) {
      $scope.paginacion = {
        count: pagesdata["count"],
        previous: pagesdata["previous"],
        next: pagesdata["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      $scope.showTableQuotations(main.titleID, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $scope.showTableQuotations(
          main.titleID,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $scope.showTableQuotations(
          main.titleID,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };
    $scope.updatePrimaAseguradora = function (quotation) {
      $http.patch(quotation.url, quotation).then(function success(response) {
        console.log(response);
      });
    };
    /** End Graphyc */
    main.activate = activate;
    main.coverageModal = false;
    /** Fill Color charts with data */
    function activate() {
      $scope.soloInfo = true;
      /* Información de usuario */
      $scope.infoUser = $localStorage.infoUser;
      if ($localStorage.url_operation == "/operacion.semanal") {
        $state.go("operacion.semanal");
      }
      main.mc_permission_user = $localStorage.mc_permission_user;
      if (main.renewalTable) {
        main.renewalTable = false;
      }
      if (main.sinisterTable) {
        main.sinisterTable = false;
      }
      if (main.policyTable) {
        main.policyTable = false;
      }
      if (main.coverageTable) {
        main.coverageTable = false;
      }
      if (main.notas) {
        main.notas = false;
      }
      main.endorsements = [];
      main.otPending = [];
      main.totalPendingOts = [];
      // TODO:  PERMISOS DE CARTAS
      // dataFactory.get('has-view-cartas-permission')
      // .then(function(req) {
      //   if(req.status == 200) {
      //     main.view_cartas = req.data;
      //   }
      // });

      // dataFactory.get('has-add-cartas-permission')
      // .then(function(req) {
      //   if(req.status == 200) {
      //     main.add_cartas = req.data;
      //   }
      // });

      // PERMISOS SINIESTROS
      // dataFactory.get('has-view-siniestros-permission')
      // .then(function(req) {
      //   if(req.status == 200) {
      //     main.view_siniestros = req.data;
      //   }
      // });

      // dataFactory.get('has-add-siniestros-permission')
      // .then(function(req) {
      //   if(req.status == 200) {
      //     main.add_siniestros = req.data;
      //   }
      // });

      // dataFactory.get('has-add-emails-permission')
      // .then(function(req) {
      //   if(req.status == 200) {
      //     main.add_emails = req.data;
      //   }
      // });

      // Conexión a socket.io
      if ($rootScope.usr) {
        if (main.socket) {
          main.socket.emit("subscribe", $rootScope.usr["name"]);
          main.socket.on($rootScope.usr["name"], function (response) {
            try {
              response = JSON.parse(response.replace(/'/g, '"'));
              SweetAlert.swal({
                title: "RECORDATORIO PROGRAMADO - " + response.title,
                icon: "success",
                text: "Revise en la sección de notificaciones en la barra superior a la derecha",
                timer: 7000,
              });
              $scope.loadingValidate = false;
              $scope.validado = true;
            } catch (e) {
              console.error("Error processing WebSocket response:", e);
            }
          });
        }
      }
      if ($rootScope.usr) {
        if (main.socket) {
          function setupWebSocket() {
            main.socket.emit(
              "subscribe",
              "notificaciones_" + $rootScope.usr["name"]
            );
            main.socket.on(
              "notificaciones_" + $rootScope.usr["name"],
              function (response) {
                try {
                  response = JSON.parse(response.replace(/'/g, '"'));
                  main.notifications["count"] = response.count;
                  $rootScope.notificationscount = main.notifications["count"];
                  toaster.success("Nueva notificación");
                } catch (e) {
                  console.error("Error parsing response:", e);
                }
                $scope.loadingValidate = false;
                $scope.validado = true;
              }
            );
          }
          // Call the setup function
          setupWebSocket();
        }
      }

      main.getBirthdays();
      if ($location.path() == "/login/auth") {
        appStates.states = [];
      }
      dataFactory.get("notifications-count").then(function (response) {
        main.notifications["count"] = response.data.data;
        $rootScope.notificationscount = response.data.data;
        if (main.notifications["count"] == 0 && response.data.count31 > 0) {
          main.notifications["count"] = response.data.count31;
          $rootScope.notificationscount = response.data.count31;
          main.color = 1;
        }
        // $rootScope.recordatorioscount = response.data.recordatorios//notificaciones
        //recordatrios no vistos
        $http
          .get(url.IP + "recordatorios/mis-registros-automaticos", {
            params: { param: "hoy", novistos: true, page: 1 },
          })
          .then(
            function (response) {
              $rootScope.recordatorioscount = response.data.conteonovistoshoy;
            },
            function (error) {}
          )
          .catch(function (error) {});
        main.dataNotificatiosn = response.data.datos;
        if (main.dataNotificatiosn) {
          if (
            main.dataNotificatiosn.length > 0 &&
            main.oknotification == false
          ) {
            main.oknotification = true;
            SweetAlert.swal({
              title:
                "Su usuario tiene notificaciones de Recordatorios pendientes",
              icon: "success",
              text: "Revise en la sección de notificaciones en la barra superior a la derecha",
              timer: 7000,
            });
          }
        }

        getCarousel();
        // Hacer el endpoint para las notificacones del usuario no leidas y poner la cuenta en el notifications.count
      });

      if (!$localStorage.viewed_changes) {
        $localStorage.viewed_changes = false;
        main.viewed_changes = false;
      } else {
        $localStorage.viewed_changes = true;
        main.viewed_changes = true;
      }

      /* Obtiene rol del usuario para validaciones*/
      try {
        main.loginInfo = JSON.parse($localStorage.loginInfo);
      } catch (err) {}

      if ($sessionStorage.user) {
        var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
        var usr = JSON.parse(decryptedUser);
        $rootScope.usr = usr;

        if ($rootScope.usr.cobranza_pendiente) {
          $scope.licencia = $rootScope.usr.cobranza_pendiente;
        } else {
          $scope.licencia = false;
        }
      }
    }

    /**
     * Click on a section of the graph
     * @param  points
     */
    function onOtEvent(points) {
      // $scope.onOtEvent = function(points) {
      if (points.length > 0) {
        if (points[0].label === main.labels[0]) {
          main.insurances = main.totalPendingOts.green;
          // main.endorsements = main.totalEndorsement.green;
        } else if (points[0].label === main.labels[1]) {
          main.insurances = main.totalPendingOts.yellow;
        } else if (points[0].label === main.labels[2]) {
          main.insurances = main.totalPendingOts.orange;
        } else if (points[0].label === main.labels[3]) {
          main.insurances = main.totalPendingOts.red;
        }

        $("html, body").animate(
          {
            scrollTop: $("#cobranza").offset().top,
          },
          "slow"
        ); //jshint ignore:line
        showAndHidePanels(true, false, false);
      }
    }

    // points, evt
    function onContractorEvent() {
      openOtModal();
    }

    function logout() {
      $http
        .post(url.IP + "guardar-firebase-token/", {
          token: "",
          action: "delete",
        })
        .then(function (response) {})
        .catch(function (error) {
          console.log("error firebase delete token", error);
        });
      setTimeout(function () {
        reset();
      }, 100);
    }

    function reset() {
      try {
        $window.localStorage.setItem(
          "saam_auth_event",
          JSON.stringify({ type: "logout", timestamp: Date.now() })
        );
      } catch (error) {
        console.warn(
          "No se pudo notificar el cierre de sesión a otras pestañas",
          error
        );
      }
      $localStorage.$reset();
      // if($localStorage.car_info) {
      //   $window.localStorage.removeItem('car_info');
      // }

      // if($localStorage.client) {
      //    $localStorage.removeItem('client');

      // }
      // // $localStorage.removeItem('show_quote_selected');
      // // $localStorage.removeItem('emision_result');
      // // $localStorage.removeItem('insurance_selected');
      // $localStorage.removeItem('postData');
      // $localStorage.removeItem('services');
      // $localStorage.removeItem('servicesData');
      $window.localStorage.clear();
      // $localStorage.clear();

      $sessionStorage.$reset();
      $state.go("login.login");
      Idle.unwatch();
    }

    function block() {
      $state.go("block");
    }

    /******************************************************
     * Modals                                             *
     * openOtModal - Controller ModalOtInfoCtrl           *
     * ModalOtInfoCtrl - Controller PolicyModal           *
     * otCreatorModalEvent - Controller ButtonsCtrl       *
     * modifyRecordsModalEvent - Controller modifyOTCtrl  *
     * payReceiptsModalEvent - Controller PayReceiptsCtrl *
     ******************************************************/

    function openOtModal(point) {
      main.otModalPoint = point;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "templates/otInfo.html",
        controller: ModalOtInfoCtrl,
        ////windowClass: 'animated fadeIn',
        size: "lg",
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function editPolicyModal() {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "templates/editPolicy.html",
        controller: PolicyModal,
        ////windowClass: 'animated fadeIn',
        size: "lg",
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }
    //toaster.success("test");

    // Editando Orden de Trabajo ______________________
    function editInsuranceModal(insurance) {
      var data = {
        myInsurance: insurance,
        container: main.insurances,
      };

      // modalService.defaultPath(data)
      //     .then(function(msg) {
      //          activate();
      //     })
      //     .catch(function(msg) {
      //       activate();
      //     });
      var modalInstance = $uibModal.open({
        templateUrl: "app/modals/modal.overview.html",
        controller: "modalOverview",
        controllerAs: "vm",
        ////windowClass: 'animated fadeIn',
        size: "lg",
        resolve: {
          user: function () {
            return usr;
          },
          myInsurance: function () {
            return insurance;
          },
          container: function () {
            return main.insurances;
          },
          insuranceData: function () {
            // return data.myInsurance;
            return data;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    // ir a colectividades
    function goToColectivities() {}

    // modal crear OT
    function otCreatorModalEvent(param) {
      if (main.acceso_adm_ot | main.acceso_adm_pol) {
        if (param == 1) {
          $scope.open_in_same_tab_natural(
            "Creación póliza",
            "polizas.create",
            {},
            0
          );
          $state.go("polizas.create");
        } else if (param == 2) {
          $scope.open_in_same_tab_natural(
            "Creación póliza",
            "colectividades.main",
            {},
            0
          );
          $state.go("colectividades.main");
        }
        $localStorage.tab_states = appStates.states;

        var params = { endosoId: endorsement.id };
        $state.go($scope.route_for_new_tab, params);

        // if(param == 1) {
        //   $state.go('polizas.create');
        // } else if(param == 2) {
        //   $state.go('colectividades.main');
        // }
      }
    }

    function siniestersMoldalReport() {
      $state.go("siniestros.accidentes");
    }

    function ModalCreateEndorsement() {
      $state.go("endosos.endosos");
    }

    function modifyRecordsModalEvent() {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/modals/modal.modify-policy.html",
        controller: modifyOTCtrl,
        ////windowClass: 'animated fadeIn',
        size: "lg",
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function openWhatsapp(siniestro) {
      if (!main.whatsappWebEnabled || !siniestro) {
        return;
      }
      var phone =
        siniestro.contratante_phone_number ||
        (siniestro.poliza &&
          (siniestro.poliza.contractor_phone_number ||
            siniestro.poliza.contractor_phone));
      var info = {
        contratante:
          siniestro.contratante ||
          (siniestro.poliza && siniestro.poliza.contractor),
        contratante_phone_number: phone,
      };
      siniestroWhatsappService.open({
        siniestro: siniestro,
        poliza: siniestro.poliza,
        info: info,
      });
    }

    main.siniesterInfo = function (parItem) {
      if (main.acceso_adm_sin) {
        if (parItem.ramo == "Daños (Autos)") {
          $scope.open_in_same_tab_natural(
            "Información siniestros",
            "siniestros.auto_info",
            { siniestroId: parItem.id },
            parItem.id
          );
          // $state.go('siniestros.auto_info', {siniestroId: parItem.id});
        } else if (parItem.ramo == "Vida") {
          $scope.open_in_same_tab_natural(
            "Información siniestros",
            "siniestros.vida_info",
            { siniestroId: parItem.id },
            parItem.id
          );
          // $state.go('siniestros.vida_info', {siniestroId: parItem.id});
        } else if (parItem.ramo == "Accidentes y Enfermedades") {
          $scope.open_in_same_tab_natural(
            "Información siniestros",
            "siniestros.info",
            { siniestroId: parItem.id },
            parItem.id
          );
          $state.go("siniestros.info", { siniestroId: parItem.id });
        } else if (parItem.ramo == "Daños (no auto)") {
          $scope.open_in_same_tab_natural(
            "Información siniestros",
            "siniestros.danio_info",
            { siniestroId: parItem.id },
            parItem.id
          );
          $state.go("siniestros.danio_info", { siniestroId: parItem.id });
        }
      }
    };

    function payReceiptsModalEvent() {
      $scope.open_in_same_tab_natural(
        "Pagar recibos",
        "cobranzas.recibospendientes",
        {},
        0
      );
      // $state.go('cobranzas.recibospendientes');

      // var modalInstance = $uibModal.open({ //jshint ignore:line
      //     templateUrl: 'app/modals/modal.receipts.html',
      //     controller: 'CobranzasCtrl',
      //     controllerAs: 'vm',
      //     ////windowClass: 'animated fadeIn',
      //     size: 'lg'
      // });
    }

    $scope.getSelectedCodes = function (tipopolizas) {
      if (tipopolizas) {
        return tipopolizas
          .filter(function (t) {
            return t.selected;
          })
          .map(function (t) {
            return t.code;
          });
      } else {
        return [0];
      }
    };
    $scope.filtrosSubramos = function () {
      var modalInstance = $uibModal.open({
        templateUrl: "app/modals/filtros_subramos_dash.html",
        controller: FiltrosSubramosModalCtrl,
        size: "md",
        resolve: {},
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (result) {
        var payload = result["ramos"].map(function (item) {
          return item.subramo_code;
        });
        var seleccionados = $scope.getSelectedCodes(result["tipopoliza"]);
        if ($sessionStorage.token !== undefined) {
          $scope.datatosend = {
            subramos: payload,
          };
          if (seleccionados) {
            $scope.datatosend["tipopoliza_dashboard"] = seleccionados;
          }
          $http
            .post(url.IP + "filtros-subramos-dash/", $scope.datatosend)
            .then(function (response) {
              toaster.success("Información actualizada");
              // $scope.has_sr_conf = result && result.length > 0 ? true: false;
              // location.reload();
            });
        }
      });
    };

    function FiltrosSubramosModalCtrl($scope, $uibModalInstance) {
      $scope.tipopoliza_toselect = [
        {
          code: 0,
          name: "Todos",
        },
        {
          code: 1,
          name: "Individual",
        },
        {
          code: 3,
          name: "Grupo",
        },
        {
          code: 11,
          name: "Colectiva",
        },
        {
          code: 7,
          name: "Fianzas",
        },
      ];
      $scope.subramos_toselected = [
        {
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          subramo_code: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
      ];
      $scope.cancel = cancel;
      $scope.saveConfig = saveConfig;
      $scope.ramos = [];
      if ($sessionStorage.token !== undefined) {
        $http.get(url.IP + "filtros-subramos-dash/").then(function (response) {
          if (response && response.data && response.data.data) {
            response.data.data.forEach(function (item) {
              $scope.subramos_toselected.forEach(function (sr) {
                if (sr["subramo_code"] == item) {
                  $scope.ramos.push(sr);
                }
              });
            });
          }
          if (response && response.data && response.data.tipopoliza) {
            $scope.setTiposGuardados(response.data.tipopoliza);
          }
        });
      }
      $(".js-example-basic-multiple").select2();

      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });
      // asiganr los seleccionados guardados
      $scope.setTiposGuardados = function (tiposGuardados) {
        // angular.forEach($scope.tipopoliza_toselect, function (tipo) {
        //   tipo.selected = tiposGuardados.includes(tipo.code);
        // });
        // Reinicia todo
        angular.forEach($scope.tipopoliza_toselect, function (tipo) {
          tipo.selected = false;
        });

        // Marca los guardados (si existen)
        if (tiposGuardados && tiposGuardados.length) {
          angular.forEach($scope.tipopoliza_toselect, function (tipo) {
            if (tiposGuardados.includes(tipo.code)) {
              tipo.selected = true;
            }
          });
        }

        // Si no hay ninguno seleccionado, marca la opción "Todos"
        var algunaSeleccionada = $scope.tipopoliza_toselect.some(function (t) {
          return t.selected;
        });
        if (!algunaSeleccionada) {
          var todos = $scope.tipopoliza_toselect.find(function (t) {
            return t.code === 0;
          });
          if (todos) todos.selected = true;
        }
      };
      // Función que maneja el click de cada checkbox
      $scope.toggleTipo = function (item) {
        if (item.code === 0) {
          // Si selecciona "Todos", deselecciona los demás
          if (item.selected) {
            angular.forEach($scope.tipopoliza_toselect, function (t) {
              if (t.code !== 0) t.selected = false;
            });
          }
        } else {
          // Si selecciona cualquier otro, deselecciona "Todos"
          var todos = null;
          for (var i = 0; i < $scope.tipopoliza_toselect.length; i++) {
            if ($scope.tipopoliza_toselect[i].code === 0) {
              todos = $scope.tipopoliza_toselect[i];
              break;
            }
          }

          if (todos && todos.selected) {
            todos.selected = false;
          }
        }
      };
      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }

      function saveConfig() {
        $scope.data_ = {
          ramos: $scope.ramos,
          tipopoliza: $scope.tipopoliza_toselect,
        };
        $uibModalInstance.close($scope.data_);
      }
    }

    $scope.gotoCapturarSiniestro = function (param) {
      $scope.open_in_same_tab_natural("Crear siniestro", param, {}, 0);
    };

    function crearEndoso() {
      $scope.open_in_same_tab_natural(
        "Crear endoso",
        "endorsement.endorsement",
        {},
        0
      );
    }
    function goToCotization() {
      $scope.open_in_same_tab_natural(
        "Cotizaciones",
        "cotizacion.cotizacion",
        {},
        0
      );
    }

    function renewalModal(policy) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/renovaciones/renovaciones.modal.html",
        controller: "RenewalModalCtrl",
        ////windowClass: 'animated fadeIn',
        size: "lg",
        resolve: {
          myPolicy: function () {
            return policy;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    // PayReceiptsCtrl
    ///////////////////////////////////////////////
    ////////////////////////////////////////////////

    /**
     * Show insurances table and edit OT, and make a policy.
     */
    function modifyOTCtrl(
      $scope,
      $filter,
      $uibModalInstance,
      insuranceService,
      DTOptionsBuilder,
      DTColumnDefBuilder,
      modalService
    ) {
      var vmTable = this;
      $scope.insurances = [];
      $scope.insuranceTable = {};
      $scope.editPolicy = editPolicy;
      $scope.cancel = cancel;

      function editPolicy(insurance) {
        var data = {
          myInsurance: insurance,
          container: $scope.insurances,
        };

        modalService.editModal(data);
        $uibModalInstance.close(200);
      }

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }

      function activate() {
        return insuranceService.getandReadInsurances().then(function (data) {
          $scope.insurances = data;
        });
      }

      activate();

      $scope.dtOptionsInsurance = DTOptionsBuilder.newOptions()
        .withDOM("pitrfl")
        .withPaginationType("simple_numbers")
        .withDisplayLength(10)
        .withOption("responsive", true)
        .withLanguage({
          sSearch: "Buscador:",
        })
        //.withScroller()
        .withOption("deferRender", true);
      // .withOption('scrollY', 200)
      $scope.dtColumnDefsInsurance = [
        DTColumnDefBuilder.newColumnDef(0),
        DTColumnDefBuilder.newColumnDef(1),
        DTColumnDefBuilder.newColumnDef(2),
        DTColumnDefBuilder.newColumnDef(3),
        DTColumnDefBuilder.newColumnDef(4),
      ];
    }
    /**
     * Create OT modal controller - ButtonsCtrl
     */
    function ButtonsCtrl(
      $scope,
      $filter,
      $uibModalInstance,
      toaster,
      FileUploader,
      payform,
      DTOptionsBuilder,
      DTColumnDefBuilder,
      MESSAGES,
      helpers,
      ContratanteService,
      providerService,
      insuranceService,
      coverageService,
      generalService,
      groupService
    ) {
      /** Uploader files */
      $scope.userInfo = {
        id: 0,
      };
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Accept: "application/json",
        },
      }));

      function applyUploaderAuthHeader(target) {
        if (!target) {
          return;
        }

        if (!target.headers) {
          target.headers = {};
        }

        target.headers.Accept = "application/json";

        var activeToken = getCurrentToken();
        var tokenDetails = describeTokenCandidate(activeToken);
        debugLog("applyUploaderAuthHeader", {
          tokenPresent: tokenDetails.hasToken,
          tokenSuffix: tokenDetails.tokenSuffix,
        });

        if (activeToken) {
          target.headers.Authorization = "Bearer " + activeToken;
        } else if (target.headers.Authorization) {
          delete target.headers.Authorization;
        }
      }

      applyUploaderAuthHeader(uploader);

      // uploader.filters.push({
      //     name: 'customFilter',
      //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
      //         return this.queue.length < 20;
      //     }
      // });

      // ALERTA SUCCES UPLOADFILES
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        toaster.success(MESSAGES.OK.UPLOADFILES);
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });
      };

      uploader.onBeforeUploadItem = function (item) {
        applyUploaderAuthHeader(uploader);
        applyUploaderAuthHeader(item);
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
      };
      /** /Uploader files */

      // Life form funcions
      $scope.options = {
        life: {
          beneficiary: {
            add: function () {
              var beneficiary = angular.copy(
                $scope.subforms.life.beneficiaries
              );
              $scope.subforms.life.beneficiariesList.push(beneficiary);
            },
            destroy: function (index) {
              $scope.subforms.life.beneficiariesList.splice(index, 1);
            },
          },
        },
        disease: {
          relationships: {
            add: function () {
              var relationship = angular.copy(
                $scope.subforms.disease.relationships
              );
              if (relationship.relationships.relationship === 1) {
                var index = _.findIndex($scope.options.disease.types, {
                  option: "Titular",
                  relationship: 1,
                });
                $scope.options.disease.types.splice(index, 1);
              } else if (relationship.relationships.relationship === 2) {
                var index = _.findIndex($scope.options.disease.types, {
                  option: "Conyuge",
                  relationship: 2,
                });
                $scope.options.disease.types.splice(index, 1);
              }
              $scope.subforms.disease.relationshipList.push(relationship);
            },
            destroy: function (index, rel) {
              $scope.subforms.disease.relationshipList.splice(index, 1);
              if ($scope.subforms.disease.relationshipList.length === 0) {
                $scope.options.disease.types = [
                  {
                    option: "Titular",
                    relationship: 1,
                  },
                  {
                    option: "Conyuge",
                    relationship: 2,
                  },
                  {
                    option: "Hijo",
                    relationship: 3,
                  },
                ];
                toaster.info("Es obligatorio tener un titular.");
              } else if (rel.relationships.relationship === 1) {
                $scope.options.disease.types.push({
                  option: "Titular",
                  relationship: 1,
                });
                toaster.info("Es obligatorio tener un titular.");
              } else if (rel.relationships.relationship === 2) {
                $scope.options.disease.types.push({
                  option: "Conyuge",
                  relationship: 2,
                });
              }
            },
          },
          // 1-Titular, 2-Conyuge, 3-Hijo
          types: [
            {
              option: "Titular",
              relationship: 1,
            },
            {
              option: "Conyuge",
              relationship: 2,
            },
            {
              option: "Hijo",
              relationship: 3,
            },
          ],
        },
      };

      $scope.showOne = true;
      $scope.hide = hide;

      // Default values
      $scope.coverages = [];
      $scope.forms = [];
      $scope.savedOt = {};

      $scope.show = {
        ot: true,
        receipt: false,
        generateReceipts: false,
        receiptsGenerated: false,
      };

      $scope.changeProvider = changeProvider;
      $scope.changeRamo = changeRamo;
      $scope.changeSubramo = changeSubramo;
      $scope.changePackage = changePackage;
      $scope.isReceiptAvailable = isReceiptAvailable;
      $scope.deleteCoverage = deleteCoverage;

      $scope.createOTAndPreparePolicy = createOTAndPreparePolicy;
      $scope.saveOT = saveOT;
      $scope.saveChangesInOt = saveChangesInOt;
      $scope.saveInsurance = saveInsurance;

      $scope.payments = payform;

      function getContractorsByGroup() {
        groupService.getGroups().then(function (res) {
          var contractors = [];
          res.forEach(function (element, index) {
            element.natural_group.forEach(function (element1, index) {
              element1.groupName = element.group_name;
              element1.name = element1.first_name + " " + element1.last_name;
              contractors.push(element1);
            });
            element.juridical_group.forEach(function (element2, index) {
              element2.groupName = element.group_name;
              element2.name = element1.j_name;
              contractors.push(element2);
            });
          });
          $scope.contractorsByGroup = contractors;
        });
      }

      $scope.form = {
        contratante: "",
        poliza: "",
        ramo: "",
        type: "",
        subramo: "",
        aseguradora: "",
        paquete: "",
        payment: "",
        startDate: new Date(),
        endingDate: new Date(new Date().setYear(new Date().getFullYear() + 1)),
      };

      $scope.$watch("form.startDate", function (newValue, oldValue) {
        var val = angular.copy(newValue);
        $scope.form.endingDate = new Date(val.setYear(val.getFullYear() + 1));
      });

      // Subforms
      $scope.subforms = {
        auto: null, //template.formulario.automoviles
        life: {
          beneficiariesList: [],
        }, //template.formulario.vida
        disease: {
          relationshipList: [],
        }, //template.formulario.accidentes
        damage: null, //template.formulario.danios
      };

      function activate() {
        getContractorsByGroup();
        getInsurances();
        ContratanteService.getContratantes().then(function (data) {
          $scope.contratantes = data;
        });

        providerService.getProviders().then(function (data) {
          $scope.providers = data;
        });
      }

      function changeProvider(obj) {
        $scope.ramos = obj.ramo_provider;
      }

      function changeRamo(obj) {
        $scope.subramos = obj.subramo_ramo;
      }

      function changeSubramo(obj) {
        $scope.forms = obj.forms_subramo;
        $scope.packages = obj.package_subramo;
        $scope.showForms = true;
        $scope.formInfo = {
          code: obj.subramo_code,
          name: obj.subramo_name,
        };
      }

      function changePackage(obj) {
        if (obj != undefined) {
          $scope.coverages = obj.coverage_package;
          $scope.showCoverages = true;
        } else {
          $scope.showCoverages = false;
        }
      }

      function deleteCoverage(obj, index) {
        $scope.coverages.splice(index, 1);
      }

      function saveOT() {}

      function getInsurances() {
        insuranceService.getandReadInsurances().then(function (data) {
          $scope.insurances = data;
        });
      }

      activate();

      function hide(param) {
        if (param === 1) {
          $scope.showOne = true;
        } else {
          $scope.showOne = false;
        }
        return $scope.showOne;
      }

      /**
       * Keep OT and their coverages - ButtonsCtrl
       */
      function createOTAndPreparePolicy() {
        var form = getFormData($scope.form);
        form.contractor = "";
        form.aseguradora = $scope.form.aseguradora.url;
        form.old_policies = [];
        form.recibos_poliza = [];

        if (form.contratante) {
          form.contractor = form.contratante;
        }

        var subformType = helpers.subformChecker($scope.subforms);
        if (subformType) {
          subformType.urlSubramo = form.subramo;
        }

        return insuranceService.createInsurance(form).then(function (data) {
          if (helpers.isResponseAnError(data.status)) {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORCREATEOT, "error");
          } else {
            // Reload insurances
            $scope.show.ot = false;
            getInsurances();
            $scope.myInsurance = data;
            toaster.success(MESSAGES.OK.NEWOT);
            // Keep coverages
            if ($scope.coverages.length !== 0) {
              createCoverages($scope.coverages, data);
            }
            // Keep forms, past form
            // if ($scope.forms.length !== 0){createForms($scope.forms, data);}
            if (subformType) {
              ////console.log(subformType);
              subformType.policy = data.url;
              ramoService.createForm(subformType).then(function (res) {});
            }

            var formInfo = $scope.formInfo;

            $scope.userInfo = {
              id: data.id,
            };

            $scope.userInfo.url = $scope.uploader.url =
              url.IP + "polizas/" + data.id + "/archivos/";
            $scope.uploader.uploadAll();
          }
        });
      }

      function saveChangesInOt() {
        var form = getFormData($scope.form);
        form.url = $scope.myInsurance.url;
        form.contractor = "";

        if (form.contratante) {
          form.contractor = form.contratante;
        }
        $scope.show.ot = false;

        return insuranceService.updateInsurance(form).then(function (data) {
          getInsurances();
          $scope.myInsurance = data.data;
          toaster.success("Se ha modificado su orden de trabajo");

          $scope.uploader.uploadAll();

          $uibModalInstance.dismiss("cancel");
        });
      }

      /**
       * Get form data and return an obj
       * @param  {obj} form data and return
       * @return {obj} object
       */
      function getFormData(form) {
        return {
          contratante: form.contratante,
          ramo: form.ramo.url || null,
          subramo: form.subramo.url || null,
          paquete: form.paquete ? form.paquete.url : null,
          poliza_number: form.poliza || "0",
          start_of_validity: form.startDate || "",
          end_of_validity: form.endingDate || "",
          forma_de_pago: form.payment || null,
          status: 1,
        };
      }

      /**
       * Create coverages in policy
       * @param  {array} coverages
       * @param  {obj} policy
       * @return nothing
       */
      function createCoverages(coverages, policy) {
        var coverage = {};
        // TODO check deductible, sum, and prima
        //
        coverages.forEach(function (elem) {
          coverage = {
            policy: policy.url,
            package: policy.paquete,
            coverage_name: elem.coverage_name || "",
            deductible: elem.deductibleInPolicy
              ? elem.deductibleInPolicy.deductible
              : "",
            sum_insured: elem.sumInPolicy ? elem.sumInPolicy.sum_insured : "",
            prima: elem.primaInPolicy || "",
          };
          coverageService.createCoberturaPoliza(coverage);
        });
      }

      /**
       * Create forms in policy
       * @param  {array} forms
       * @param  {obj} policy
       * @return nothing
       */
      function createForms(forms, policy) {
        var myForm = {};
        if (forms.length > 0) {
          forms.forEach(function (elem) {
            myForm = {
              polizas: policy.url,
              form: elem.url,
              value: elem.answer || "Sin respuesta",
            };
            insuranceService.createForms(myForm);
          });
        }
      }

      function isReceiptAvailable() {
        if ($scope.form.payment && $scope.form.poliza) {
          toaster.success("Ya puede generar sus recibos");
        } else if ($scope.form.payment) {
          toaster.info("Favor de ingresar el número de poliza");
        }
      }

      /**
       * Keep insurance like a policy, and keep their receipts
       * TODO check if exists changes in OT and update
       */
      function saveInsurance() {
        $scope.myInsurance.status = 1;
        $scope.myInsurance.forma_de_pago = $scope.form.payment;
        $scope.myInsurance.poliza_number = $scope.form.poliza; //jshint ignore:line
        insuranceService.updateInsurance($scope.myInsurance).then(function () {
          getInsurances();
          $scope.receipts.forEach(function (elem, index) {
            var receipt = {
              poliza: $scope.myInsurance.url,
              recibo_numero: index + 1,
              prima_neta: elem.prima,
              rpf: elem.rpf,
              derecho: elem.derecho,
              iva: elem.iva,
              sub_total: elem.subTotal,
              prima_total: elem.total,
              status: 4,
              fecha_inicio: $filter("date")(elem.startDate, "yyyy-MM-dd"),
              fecha_fin: $filter("date")(elem.endingDate, "yyyy-MM-dd"),
            };
            receiptService.createReceiptService(receipt);
          });
          toaster.success("Se ha creado una póliza");
          $scope.uploader.uploadAll();
          $uibModalInstance.dismiss("cancel");
        });
      }

      // Receipts
      ///////////////////////////////////////////
      $scope.showReceipts = $scope.show.receiptsGenerated;
      $scope.amountReceipts = 0;
      $scope.poliza = {
        primaNeta: 0,
        iva: 16,
        rpf: 0,
        derecho: 0,
        subTotal: 0,
        primaTotal: 0,
      };
      // vm.receipts = [];
      $scope.receipts = [];

      // Receipt modal
      $scope.ok = ok;
      $scope.cancel = cancel;
      $scope.getNumber = getNumber;
      $scope.calculate = calculate;
      $scope.showPoliceCreator = showPoliceCreator;

      function showPoliceCreator() {
        if ($scope.showReceipts === false) {
          // && $scope.form.ramo === null && $scope.form.subramo === null && $scope.form.paquete === null
          return true;
        }
        return false;
      }

      function ok() {
        $scope.show.receipt = true;
        // $uibModalInstance.close();
      }

      function calculate() {
        if (!$scope.form.payment) {
          toaster.info(MESSAGES.ERROR.SELPAY);
        } else {
          $scope.receipts = [];
          $scope.showReceipts = true;
          var initDate = $scope.form.startDate;
          var endDate = $scope.form.endingDate;
          var months = helpers.monthDiff(initDate, endDate);
          var amountReceipts = ($scope.amountReceipts =
            months / $scope.form.payment);
          //Calculate poliza results
          $scope.poliza.subTotal = getSubtotal($scope.poliza);
          $scope.poliza.primaTotal = getTotal($scope.poliza);
          amountReceipts = Math.ceil(amountReceipts);
          var arrayLen = $scope.getNumber(amountReceipts);

          // Logic from vm
          var obj = {
            prima: $scope.poliza.primaNeta / amountReceipts,
            rpf: $scope.poliza.rpf / amountReceipts,
            derecho: $scope.poliza.derecho / amountReceipts,
            iva: $scope.poliza.iva,
            subTotal: $scope.poliza.subTotal / amountReceipts,
            primaTotal: $scope.poliza.primaTotal / amountReceipts,
          };

          for (var i = 0; i < arrayLen.length; i++) {
            // Check options
            if ($scope.configDerecho) {
              if (i === 0) {
                obj.derecho = parseFloat($scope.poliza.derecho);
              } else {
                obj.derecho = 0;
              }
            }

            if ($scope.configRPF) {
              if (i === 0) {
                obj.rpf = parseFloat($scope.poliza.rpf);
              } else {
                obj.rpf = 0;
              }
            }

            endDate = new Date(
              moment(initDate).add($scope.form.payment, "months").calendar()
            );

            var subTotal = obj.prima + obj.rpf + obj.derecho;
            var receipt = {
              prima: parseFloat(obj.prima.toFixed(2)),
              rpf: parseFloat(obj.rpf.toFixed(2)),
              derecho: parseFloat(obj.derecho.toFixed(2)),
              iva: 16,
              subTotal: parseFloat(subTotal.toFixed(2)),
              total: parseFloat((subTotal * 1.16).toFixed(2)),
              startDate: initDate,
              endingDate: endDate,
            };
            initDate = endDate;
            $scope.receipts.push(angular.copy(receipt));
          }
        }
      }

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }

      function getNumber(num) {
        var num2 = Math.ceil(num);
        return new Array(num2);
      }

      function getSubtotal(poliza) {
        var sum =
          parseFloat(poliza.primaNeta) +
          parseFloat(poliza.rpf) +
          parseFloat(poliza.derecho);
        return Number(sum.toFixed(2));
      }

      function getTotal(poliza) {
        return poliza.subTotal * 1.16;
      }
    }
    ////////////////////////////////////////////////
    /////// ModalOtInfoCtrl
    function ModalOtInfoCtrl($scope, $uibModalInstance) {
      var vmm = $scope;
      vmm.polizas = [];
      insuranceService.getandReadInsurances();
      ContratanteService.getContratantes().then(function (data) {
        data.forEach(function (elem) {
          vmm.contratantes.contractor.push(elem);
        });
      });

      vmm.ok = function () {};

      vmm.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }
    /////// ModalOtInfoCtrl
    function createInsuranceModalCtrl(
      $scope,
      $uibModalInstance,
      toaster,
      $filter
    ) {}
    /////// editInsuranceModalCtrl
    /**
     * Edits an OT -> make policy generate receips
     */
    // Moved to polizas/polizas.modal.editCtrl.js
    /////// End editInsuranceModalCtrl
    /////// PolicyModal
    function PolicyModal($scope, $uibModalInstance, toaster, $filter) {
      $scope.datas = 10;
      $scope.form = {};

      $scope.providers = [];
      $scope.ramos = [];
      $scope.subramos = [];
      $scope.paquetes = [];

      $scope.saveOT = saveOT;

      $scope.status = status;
      $scope.payform = payform;

      $scope.show = {
        receipt: false,
        // ot: false
      };

      $scope.changeProvider = changeProvider;
      $scope.changeRamos = changeRamos;
      $scope.changeSubramos = changeSubramos;

      $scope.openModal = openReceiptModal;
      $scope.saveInsurance = saveInsurance;

      function changeProvider(changeProv) {
        $scope.ramos = changeProv.ramo_provider;
      }

      function changeRamos(changeRamo) {
        $scope.subramos = changeRamo.subramo_ramo;
      }

      function changeSubramos(changeSubramo) {
        $scope.paquetes = changeSubramo.package_subramo;
      }

      var myForm = {};
      var parentScope = $scope;

      function openReceiptModal() {
        myForm = $scope.form;
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/polizas/recibos.modal.html",
          controller: ReceiptModalCtrl,
          size: "lg",
          resolve: {
            from: function () {
              return null;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
          //windowClass: 'animated fadeIn'
          // HACK remove if this doesnt works
          // resolve: {
          //     form: function(){
          //       return $scope.form;
          //     }
          // }
        });
      }

      function getInsurances() {
        insuranceService.getandReadInsurances().then(function (data) {
          main.insurances = data;
        });
      }

      function saveInsurance() {
        $scope.form.status = 4;

        insuranceService.updateInsurance($scope.form).then(function () {
          getInsurances();
          $scope.receipts.forEach(function (elem, index) {
            var receipt = {
              poliza: $scope.form.url,
              recibo_numero: index + 1,
              prima_neta: elem.prima.toString(),
              rpf: elem.rpf.toString(),
              derecho: elem.derecho.toString(),
              iva: elem.iva,
              sub_total: elem.subTotal.toString(),
              prima_total: elem.total.toString(),
              status: 4,
              fecha_inicio: $filter("date")(elem.startDate, "yyyy-MM-dd"),
              fecha_fin: $filter("date")(elem.endingDate, "yyyy-MM-dd"),
              description: null,
            };
            receiptService.createReceiptService(receipt);
          });
          toaster.success("Se ha creado una poliza");
        });
      }

      function saveOT() {
        var save = $scope.form;
        save.aseguradora = $scope.form.aseguradora.url;
        save.ramo = $scope.form.ramo.url;
        save.subramo = $scope.form.subramo.url;
        save.paquete = $scope.form.paquete.url;
        if ($scope.form.forma_de_pago.value) {
          save.forma_de_pago = $scope.form.forma_de_pago.value;
        }
        save.status = 1;
        insuranceService.updateInsurance(save).then(function (d) {
          toaster.success("Su Ot ha sido guardada");
          getInsurances();
          $uibModalInstance.dismiss("cancel");
        });
      }

      function activate() {
        var data = {};
        main.lc = "";
        data.polizaId = main.insurance.id;
        insuranceService.getInsuranceRead(data).then(function (data) {
          $scope.form = data;
        });

        providerService.getProviders().then(function (data) {
          $scope.providers = data;
          return data;
        });

        var otherData = {};
        otherData.polizaId = data.polizaId.replace("leer-", "");

        insuranceService.getInsurance(otherData).then(function (insuranceData) {
          var prov = {};
          prov.provider = insuranceData.aseguradora;
          providerService
            .getProvider(prov)
            .then(function (data) {
              $scope.ramos = data.ramo_provider;
              return insuranceData;
            })
            .then(function (insurance) {
              ramoService.getRamo(insurance).then(function (ramoData) {
                $scope.subramos = ramoData.subramo_ramo;
                ramoService.getSubramo(insurance).then(function (subramoData) {
                  $scope.paquetes = subramoData.package_subramo;
                });
              });
            });
        });
      }

      activate();

      $scope.ok = function () {};

      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };

      ///////////////// Create receipt modal
      function ReceiptModalCtrl($scope, $uibModalInstance) {
        $scope.amountReceipts = 0;
        $scope.poliza = {
          primaNeta: "",
          iva: 16,
          rpf: "",
          derecho: "",
          subTotal: "",
          primaTotal: "",
        };

        $scope.calculate = function () {
          if (!parentScope.form.forma_de_pago) {
            toaster.info(MESSAGES.ERROR.SELPAY);
          } else {
            $scope.receipts = [];
            $scope.showReceipts = true;
            var initDate = parentScope.form.start_of_validity;
            var endDate = parentScope.form.end_of_validity;
            var months = helpers.monthDiff(initDate, endDate);
            var amountReceipts = ($scope.amountReceipts =
              months / parentScope.form.forma_de_pago.value);
            //Calculate poliza results
            $scope.poliza.subTotal = getSubtotal($scope.poliza);
            $scope.poliza.primaTotal = getTotal($scope.poliza);
            var arrayLen = $scope.getNumber(amountReceipts);

            var obj = {
              prima: $scope.poliza.primaNeta / amountReceipts,
              rpf: $scope.poliza.rpf / amountReceipts,
              derecho: $scope.poliza.derecho / amountReceipts,
              iva: $scope.poliza.iva,
              subTotal: $scope.poliza.subTotal / amountReceipts,
              primaTotal: $scope.poliza.primaTotal / amountReceipts,
            };

            for (var i = 0; i < arrayLen.length; i++) {
              // Check options
              if ($scope.configDerecho) {
                if (i === 0) {
                  obj.derecho = $scope.poliza.derecho;
                } else {
                  obj.derecho = 0;
                }
              }

              if ($scope.configRPF) {
                if (i === 0) {
                  obj.rpf = $scope.poliza.rpf;
                } else {
                  obj.rpf = 0;
                }
              }
              endDate = moment(
                new Date(
                  moment(initDate)
                    .add(parentScope.form.forma_de_pago.value, "months")
                    .calendar()
                )
              ).format();

              var subTotal = obj.prima + obj.rpf + obj.derecho;
              var receipt = {
                prima: parseFloat(obj.prima.toFixed(2)),
                rpf: parseFloat(obj.rpf.toFixed(2)),
                derecho: parseFloat(obj.derecho.toFixed(2)),
                iva: 16,
                subTotal: parseFloat(subTotal.toFixed(2)),
                total: parseFloat((subTotal * 1.16).toFixed(2)),
                startDate: initDate,
                endingDate: endDate,
              };

              initDate = endDate;

              $scope.receipts.push(angular.copy(receipt));
              parentScope.receipts = $scope.receipts;
            }
          }
        };
        $scope.ok = function () {
          parentScope.show = {
            receipt: true,
            // ot: true
          };
          $uibModalInstance.dismiss("cancel");
        };

        $scope.cancel = function () {
          $uibModalInstance.dismiss("cancel");
        };

        $scope.getNumber = function (num) {
          return new Array(num);
        };

        function getSubtotal(poliza) {
          var sum =
            parseFloat(poliza.primaNeta) +
            parseFloat(poliza.rpf) +
            parseFloat(poliza.derecho);
          return Number(sum.toFixed(2));
        }

        function getTotal(poliza) {
          return poliza.subTotal * 1.16;
        }
      }
      ///////////////// Create receipt modal

      /////// PolicyModal
    }
  }
})();

(function () {
  "use strict";
  // NOTE http://jasonwatmore.com/post/2015/03/10/AngularJS-User-Registration-and-Login-Example.aspx#userservice
  // NOTE http://jasonwatmore.com/post/2014/05/26/AngularJS-Basic-HTTP-Authentication-Example.aspx
  angular.module("inspinia").factory("loginService", loginService);

  loginService.$inject = [
    "url",
    "$http",
    "$q",
    "$sessionStorage",
    "$localStorage",
    "$rootScope",
  ];

  function loginService(
    url,
    $http,
    $q,
    $sessionStorage,
    $localStorage,
    $rootScope
  ) {
    var service = {
      login: login,
    };

    return service;

    ////////////

    function login(user) {
      var dfd = $q.defer();
      dfd.resolve("");
      //$http.post(url.IP + 'token-auth/', user)
      //  .then(loginComplete)
      //  .catch(loginFailed);

      function loginComplete(response) {
        if (response.status >= 200 && response.status < 300) {
          dfd.resolve(response.data.token);
          $sessionStorage.permisos = response.data.permisos;
          $sessionStorage.infoUser = response.data;
          $rootScope.permisos = response.data.permisos;
          $localStorage.permisos = response.data.permisos;
          $localStorage.infoUser = response.data;
        } else {
          dfd.reject("Status: " + response.status);
        }
      }

      function loginFailed(error) {
        dfd.reject(error);
      }

      return dfd.promise;
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("LoginCtrl", LoginCtrl);

  LoginCtrl.$inject = [
    "$document",
    "$scope",
    "loginService",
    "VersionService",
    "toaster",
    "MESSAGES",
    "$http",
    "$localStorage",
    "$state",
    "$location",
    "$sessionStorage",
    "Idle",
    "URLS_CONFIG",
    "url",
    "mcFactory",
    "$rootScope",
    "SweetAlert",
    "dataFactory",
    "appStates",
  ];
  function get_org(host) {
    host = String(host);
    var len = host.length;
    var aux = "";
    for (var i = 0; i < len; i++) {
      if (host[i] === ".") {
        return aux;
      }
      aux += host[i];
    }
    // Solo resetea si NO existe sesión previa
    if (!$sessionStorage.token && !$localStorage.token) {
      $localStorage.$reset();
      $sessionStorage.$reset();
    }

    appStates = [];
    return "no_org";
  }
  function LoginCtrl(
    $document,
    $scope,
    loginService,
    VersionService,
    toaster,
    MESSAGES,
    $http,
    $localStorage,
    $state,
    $location,
    $sessionStorage,
    Idle,
    URLS_CONFIG,
    url,
    mcFactory,
    $rootScope,
    SweetAlert,
    dataFactory,
    appStates
  ) {
    // Solo resetea si NO existe sesión previa
    if (!$sessionStorage.token && !$localStorage.token) {
      $localStorage.$reset();
      $sessionStorage.$reset();
    }

    appStates = [];
    var host = $location.host();
    $localStorage.permissions;

    var vm = this;
    console.log("berddddddddddd", $localStorage);
    VersionService.start(60000); // cada 1 minuto SOLO en login
    $scope.$on("$destroy", function () {
      VersionService.stop(); // al salir de login, se apaga
    });
    function requestNotificationsPermissions() {
      if (firebase.messaging.isSupported()) {
        firebase
          .messaging()
          .requestPermission()
          .then(function () {
            getFirebaseToken();
            // Notification permission granted.
            // Volver a obtener el token y guardarlo
          })
          .catch(function (error) {
            firebase
              .messaging()
              .requestPermission()
              .then(function () {
                // Notification permission granted.
              });
          });
      }
    }

    function getFirebaseToken() {
      if (firebase.messaging.isSupported()) {
        firebase
          .messaging()
          .getToken()
          .then(function (currentToken) {
            if (currentToken) {
              // Saving the Device Token to the datastore.
              $http
                .post(url.IP + "guardar-firebase-token/", {
                  token: currentToken,
                  action: "save",
                })
                .then(function (response) {})
                .catch(function (error) {
                  console.log("error firebase get token", error);
                });
            } else {
              // Need to request permissions to show notifications.
              requestNotificationsPermissions();
            }
          })
          .catch(function (error) {
            console.error("Unable to get messaging token.", error);
          });
      }
    }

    vm.be_logo = true;

    var org_name = get_org(host);

    var dato = { org: org_name };
    vm.pageTitle = "";
    vm.login = login;
    vm.user = {
      username: "",
      password: "",
      org: host.split(".")[0],
    };

    var hostUrl = URLS_CONFIG.cas;
    if ($document.context.title == "Your session has expired.") {
      $document.context.title = "Miurabox";
    }

    if ($location.path() == "/login/auth") {
      $http({
        method: "GET",
        url: hostUrl + "get-image-or/" + org_name,
        headers: {
          "Content-Type": "application/json",
        },
      }).then(function (data) {
        // Solo resetea si NO existe sesión previa
        if (!$sessionStorage.token && !$localStorage.token) {
          $localStorage.$reset();
          $sessionStorage.$reset();
        }

        if (data.status == 200) {
          if (data.data.logo.length == 0) {
            vm.be_logo = false;
            var url_aux = "";
          } else {
            vm.be_logo = true;
            // var url_aux= 'https://miurabox.s3.amazonaws.com/cas/'+data.data.logo;
            var url_aux = data.data.logo;
          }
        } else {
          vm.be_logo = false;
          var url_aux = "";

          // Solo resetea si NO existe sesión previa
          if (!$sessionStorage.token && !$localStorage.token) {
            $localStorage.$reset();
            $sessionStorage.$reset();
          }
        }
        $localStorage.mainLogo = url_aux;
        vm.logo = url_aux;
        try {
          if ($location.$$search) {
            var parameter = $location.$$search;
            if (parameter.indicators) {
              if (parameter.indicators == 1) {
                $localStorage.url_operation = "/operacion.semanal";
              }
            }
          }
        } catch (error) {
          console.log("_Login normal_", error);
        }
      });
    }

    setTimeout(function () {
      if (!vm.logo) {
        $http({
          method: "GET",
          url: hostUrl + "get-image-or/" + org_name,
          headers: {
            "Content-Type": "application/json",
          },
        }).then(function (data) {
          // Solo resetea si NO existe sesión previa
          if (!$sessionStorage.token && !$localStorage.token) {
            $localStorage.$reset();
            $sessionStorage.$reset();
          }

          if (data.status == 200) {
            if (data.data.logo.length == 0) {
              vm.be_logo = false;
              var url_aux = "";
            } else {
              vm.be_logo = true;
              // var url_aux= 'https://miurabox-public.s3.amazonaws.com/cas/'+data.data.logo;
              var url_aux = data.data.logo;
            }
          } else {
            vm.be_logo = false;
            var url_aux = "";
            // Solo resetea si NO existe sesión previa
            if (!$sessionStorage.token && !$localStorage.token) {
              $localStorage.$reset();
              $sessionStorage.$reset();
            }
          }
          $localStorage.mainLogo = url_aux;
          vm.logo = url_aux;
          try {
            if ($location.$$search) {
              var parameter = $location.$$search;
              if (parameter.indicators) {
                if (parameter.indicators == 1) {
                  $localStorage.url_operation = "/operacion.semanal";
                }
              }
            }
          } catch (error) {
            console.log("_Login normal_", error);
          }
        });
      }
    }, 500);

    vm.isDisabled = function () {
      return (
        vm.user.username == "" ||
        vm.user.password == "" ||
        !vm.user.username ||
        !vm.user.password
      );
    };

    function login() {
      var data_user = {
        username: vm.user.username,
        password: vm.user.password,
        org: vm.user.org,
      };
      $http({
        method: "POST",
        //url: hostUrl+'us-login',
        url: hostUrl + "api-token-auth-saam/",
        headers: {
          //'Content-Type': 'application/x-www-form-urlencoded',
          "Content-Type": "application/json",
          //'Accept': 'application/x-www-form-urlencoded'
        },
        //data: 'username=' + encodeURIComponent(vm.user.username) + '&password=' + encodeURIComponent(vm.user.password) + '&org=' + encodeURIComponent(vm.user.org)
        data: data_user,
      })
        .then(
          function success(data) {
            if (data.status === 200) {
              appStates.states = [];
              // Iniciar firebase FCM
              // End Firebase FCM
              dataFactory.get("schedule/");

              // TODO: guardar en sessionStorage el permiso para mc
              $rootScope.mc_permission = data.data.org.active_multicotizador;
              $sessionStorage.mc_permission =
                data.data.org.active_multicotizador;
              $localStorage.mc_permission_user =
                data.data.org.active_multicotizador;
              Idle.watch();
              var avatar = data.data.avatar;
              $localStorage.loginInfo = JSON.stringify(data.data);
              if (avatar) {
                $localStorage.avatar = avatar;
              }

              var avatar = data.data.avatar;
              $localStorage.loginInfo = JSON.stringify(data.data);

              if (avatar) {
                $localStorage.avatar = avatar;
              }

              if (data.data.org.active_saam) {
                if (data.data.permissions.SAAM) {
                  var rol = [];
                  if (data.data.role == 1) {
                    rol[0] = 1;
                    rol[1] = "Sub administrador";
                  } else if (data.data.role == 2) {
                    rol[0] = 2;
                    rol[1] = "Agente";
                  } else if (data.data.role == 3) {
                    rol[0] = 3;
                    rol[1] = "Vendedor";
                  } else if (data.data.role == 4) {
                    rol[0] = 4;
                    rol[1] = "Usuario";
                  } else {
                    rol[0] = 0;
                    rol[1] = "Administrador";
                  }
                  var user = {
                    name: vm.user.username,
                    email: data.data.email,
                    avatar: data.data.avatar,
                    role: rol,
                    org: vm.user.org,
                    orgname: data.data.org.name,
                    orgInfo: data.data.org.name,
                    orgId: data.data.org.id,
                    urlname: data.data.org.urlname,
                    permiso: data.data.crud_permissions,
                    nameFull: data.data.first_name + " " + data.data.last_name,
                    orgLocation: data.data.orgAddress,
                    cobranza_pendiente: data.data.cobranza_pendiente,
                  };

                  $localStorage.permissions = user.permiso;

                  vm.user.first_name = data.data.fname;
                  vm.user.last_name = data.data.lname;
                  $scope.main.orgName = user.org;
                  $scope.main.userLogin = user;

                  return loginService
                    .login(vm.user)
                    .then(
                      function success(data2) {
                        // Se encriptan valores de token y user
                        // Se encriptan valores de token y user
                        var valueToken = JSON.stringify(data.data.token_jwt),
                          valueUser = JSON.stringify(user);
                        var encryptedToken = sjcl.encrypt("Token", valueToken),
                          encryptedUser = sjcl.encrypt("User", valueUser);

                        // Se guardan en sessionStorage
                        $sessionStorage.token = encryptedToken;
                        $sessionStorage.permisos = data.data.permissions.SAAM;
                        $sessionStorage.infoUser = data.data;
                        $sessionStorage.user = encryptedUser;

                        // *** NUEVO: también guarda en localStorage para compartir sesión entre pestañas
                        $localStorage.token = encryptedToken;
                        $localStorage.user = encryptedUser;
                        $localStorage.permisos = data.data.permissions.SAAM;
                        $localStorage.infoUser = data.data;

                        if (
                          window.saamSessionControl &&
                          typeof window.saamSessionControl.markLoginRestored ===
                            "function"
                        ) {
                          try {
                            window.saamSessionControl.markLoginRestored();
                          } catch (error) {
                            console.warn(
                              "No se pudo actualizar el estado de redirección al iniciar sesión",
                              error
                            );
                          }
                        }

                        // *** NUEVO: notifica a otras pestañas que hubo login
                        var saamAuthEvent = {
                          type: "login",
                          token: encryptedToken,
                          user: encryptedUser,
                          permisos: data.data.permissions.SAAM,
                          infoUser: data.data,
                          timestamp: Date.now(),
                        };
                        try {
                          window.localStorage.setItem(
                            "saam_auth_event",
                            JSON.stringify(saamAuthEvent)
                          );
                        } catch (error) {
                          console.warn(
                            "No se pudo notificar el inicio de sesión a otras pestañas",
                            error
                          );
                        }

                        var token_firebase = getFirebaseToken();
                        $scope.$parent.main.initUser();
                        $state.go("inicio.inicio");

                        var decryptedUser = sjcl.decrypt(
                          "User",
                          $sessionStorage.user
                        );
                        var usr = JSON.parse(decryptedUser);
                        $rootScope.usr = usr;

                        $scope.main.activate();
                      },
                      function (e) {
                        // SweetAlert.swal("ERROR",MESSAGES.ERROR.ERRORAPI ,"error");
                      }
                    )
                    .catch(function (error) {
                      // SweetAlert.swal("ERROR",MESSAGES.ERROR.ERRORAPI ,"error");
                    });
                } else {
                  SweetAlert.swal(
                    "ERROR",
                    MESSAGES.ERROR.ERRORPERMISSIONAPP,
                    "error"
                  );
                }
              } else {
                SweetAlert.swal("ERROR", MESSAGES.ERROR.APPNOTACTIVE, "error");
                return;
              }
            } else {
              // Solo resetea si NO existe sesión previa
              if (!$sessionStorage.token && !$localStorage.token) {
                $localStorage.$reset();
                $sessionStorage.$reset();
              }

              SweetAlert.swal("ERROR", MESSAGES.ERROR.LOGIN, "error");
            }
          },
          function error() {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.LOGIN, "error");
          }
        )
        .catch(function (e) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.LOGIN, "error");
        });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "LecturaDocumentosEditController",
      LecturaDocumentosEditController
    );

  LecturaDocumentosEditController.$inject = [
    "$rootScope",
    "$stateParams",
    "$sessionStorage",
    "FileUploader",
    "$state",
    "$scope",
    "dataFactory",
    "datesFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "exportFactory",
  ];

  function LecturaDocumentosEditController(
    $rootScope,
    $stateParams,
    $sessionStorage,
    FileUploader,
    $state,
    $scope,
    dataFactory,
    datesFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    exportFactory
  ) {
    var vm = this;
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var token = JSON.parse(decryptedToken);

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    $scope.lectura_id = $stateParams.id;

    $scope.archivos = [];
    $scope.archivos_cargados = false;
    $scope.lectura_object;
    $scope.log900 = [];
    vm.reset = reset;

    $scope.showQuotation = false;
    $scope.showInfoQuotation = false;
    $scope.aseguradoras = [];
    $scope.ramos = [];
    $scope.quotationNew = [
      {
        contratante: {},
      },
    ];

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    $scope.form = {};

    $scope.tipo_poliza = [
      {
        id: 1,
        name: "Individual",
      },
      {
        id: 12,
        name: "Colectiva",
      },
      {
        id: 3,
        name: "Grupo",
      },
    ];

    $scope.tipo_nombre = [
      {
        id: 1,
        name: "Folio",
      },
      {
        id: 2,
        name: "Póliza",
      },
    ];

    $scope.items_generales = [
      {
        name: "Selecciona una opción",
        id: 0,
        active: true,
      },
      {
        name: "Número de póliza",
        id: "policy_number",
        active: true,
      },
      {
        name: "Aseguradora",
        id: "insurance",
        active: true,
      },
      {
        name: "Ramo del seguro",
        id: "insurance_branch",
        active: true,
      },
      {
        name: "Tipo de moneda",
        id: "currency",
        active: true,
      },
      {
        name: "Forma de pago",
        id: "payment_method",
        active: true,
      },
      {
        name: "Paquete del contrato",
        id: "policy_package",
        active: true,
      },
      {
        name: "Nombre",
        id: "name",
        active: true,
      },
      {
        name: "Fecha de nacimiento",
        id: "dob",
        active: true,
      },
      {
        name: "Sexo",
        id: "sex",
        active: true,
      },
      {
        name: "RFC",
        id: "rfc",
        active: true,
      },
      {
        name: "Número de teléfono",
        id: "phone",
        active: true,
      },
      {
        name: "Correo electrónico",
        id: "email",
        active: true,
      },
      {
        name: "Dirección",
        id: "address",
        active: true,
      },
      {
        name: "Dirección complementaria",
        id: "address_2",
        active: true,
      },
      {
        name: "Código postal",
        id: "zip_code",
        active: true,
      },
      {
        name: "Conducto de pago",
        id: "payment_conduit",
        active: true,
      },
      {
        name: "Prima Neta",
        id: "p_neta",
        active: true,
      },
      {
        name: "Monto de Derecho",
        id: "derecho",
        active: true,
      },
      {
        name: "Monto de RPF",
        id: "rpf",
        active: true,
      },
    ];

    $scope.items_autos = [
      {
        name: "Marca del vehículo",
        id: "brand",
        active: true,
      },
      {
        name: "Descripción del vehículo",
        id: "vehicle",
        active: true,
      },
      {
        name: "Versión del vehículo",
        id: "version",
        active: true,
      },
      {
        name: "Año del vehículo",
        id: "year_model",
        active: true,
      },
      {
        name: "Número de serie",
        id: "serial",
        active: true,
      },
      {
        name: "Código del motor",
        id: "motor",
        active: true,
      },
      {
        name: "Código de placas",
        id: "plates",
        active: true,
      },
      {
        name: "Tipo de carga",
        id: "charge_type",
        active: true,
      },
      {
        name: "Estado de circulación",
        id: "circulation_state",
        active: true,
      },
      {
        name: "Color del vehículo",
        id: "vehicle_color",
        active: true,
      },
      {
        name: "Uso del vehículo",
        id: "vehicle_use",
        active: true,
      },
      {
        name: "Servicio del vehículo",
        id: "vehicle_service",
        active: true,
      },
    ];

    $scope.items_vida = [
      {
        name: "Fumador",
        id: "smoker_condition",
        active: true,
      },
      {
        name: "Tipo de suma asegurada",
        id: "type_sa",
        active: true,
      },
      {
        name: "Tipo de póliza",
        id: "policy_type",
        active: true,
      },
      {
        name: "Beneficiario",
        id: "beneficiarie_name",
        active: true,
      },
      {
        name: "Fecha nacimiento beneficiario",
        id: "beneficiarie_birthdate",
        active: true,
      },
      {
        name: "Tipo régimen",
        id: "j_name",
        active: true,
      },
      {
        name: "Tipo de relación",
        id: "relationship",
        active: true,
      },
      {
        name: "Porcentaje designado",
        id: "designation_percentage",
        active: true,
      },
      {
        name: "RFC beneficiario",
        id: "beneficiarie_rfc",
        active: true,
      },
      {
        name: "Antigüedad",
        id: "antiquity",
        active: true,
      },
      {
        name: "Sexo beneficiario",
        id: "beneficiarie_sex",
        active: true,
      },
      {
        name: "Antigüedad(Beneficiario)",
        id: "beneficiarie_antiquity",
        active: true,
      },
    ];

    $scope.items_gmm = [
      {
        name: "Nivel hospitalario",
        id: "hospital_level",
        active: true,
      },
      {
        name: "Nombre Dependiente",
        id: "relationship_name",
        active: true,
      },
      {
        name: "Fecha de nacimiento Dependiente",
        id: "relationship_birthdate",
        active: true,
      },
      {
        name: "Sexo Dependiente",
        id: "relationship_sex",
        active: true,
      },
      {
        name: "Antigüedad Dependiente",
        id: "relationship_antiquity",
        active: true,
      },
      {
        name: "Tipo de póliza",
        id: "policy_type",
        active: true,
      },
      {
        name: "Antigüedad",
        id: "antiquity",
        active: true,
      },
      {
        name: "Tipo de relación",
        id: "relationship",
        active: true,
      },
    ];

    $scope.items_danios = [
      {
        name: "Tipo de daño",
        id: "damage_type",
        active: true,
      },
      {
        name: "Dirección de la pertenencia",
        id: "item_address",
        active: true,
      },
      {
        name: "Pertenencia asegurada",
        id: "insured_item",
        active: true,
      },
      {
        name: "Detalles de la pertenencia",
        id: "item_details",
        active: true,
      },
    ];

    activate();

    function reset() {
      // var filename = 'noombre_del_archivo'
      // $http.get(url.IP + 'presigned-url?filename='+filename+'&').then(function(response){
      //   console.log(response);
      // })
    }

    function activate() {
      $scope.items = $scope.items_generales;
      $scope.item_active = $scope.items[0];
      $scope.fields900 = [];
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        $scope.aseguradoras = data.data;
      });
      if ($scope.lectura_id && $scope.lectura_id != 0) {
        $http
          .get(url.IP + "lectura-archivos-edit/" + $scope.lectura_id)
          .then(function (response) {
            $scope.lectura_object = response.data;

            $scope.lectura_object.tags_existentes_general.forEach(function (
              etiqueta
            ) {
              $scope.items.map(function (tag) {
                if (etiqueta == tag.name) {
                  tag["active"] = false;
                }
                return tag;
              });
            });

            $scope.tipo_poliza.forEach(function (tp) {
              if (tp["id"] == parseInt($scope.lectura_object["tipo_poliza"])) {
                $scope.form["tipo_poliza"] = tp;
              }
            });

            providerService.getProviderByKey(d).then(function (data) {
              $scope.aseguradoras = data.data;
              $scope.aseguradoras.forEach(function (tp) {
                if (
                  tp["id"] == parseInt($scope.lectura_object["aseguradora"])
                ) {
                  $scope.form["aseguradora"] = tp;
                  $scope.changeAseguradora();
                }
              });
            });

            $scope.form["nombre"] = $scope.lectura_object["nombre"];
            $scope.archivos_cargados = true;
            $scope.archivos = $scope.lectura_object.archivos_lectura;
            if ($scope.lectura_object.tags_lectura_archivos.length > 0) {
              $scope.items.forEach(function (item) {
                if (
                  item.name ==
                  $scope.lectura_object.tags_lectura_archivos[0].name
                ) {
                  $scope.item_active = item;
                }
              });
              $scope.name_for_new_tag =
                $scope.lectura_object.tags_lectura_archivos[0].name;
            }
            $scope.fields900 = [];
            $scope.fields900 = $scope.lectura_object.tags_lectura_archivos;
          });
      }
    }

    $scope.changeRamo = function () {
      // $scope.form.subramo = undefined;

      if ($scope.form.ramo.ramo_code == 1) {
        $scope.items = $scope.items.concat($scope.items_vida);
      }
      if (parseInt($scope.form.ramo.ramo_code) == 3) {
        $scope.items = $scope.items.concat($scope.items_autos);
      }
      if (parseInt($scope.form.ramo.ramo_code) == 2) {
        $scope.items = $scope.items.concat($scope.items_gmm);
      }
      // $scope.form.ramo.subramo_ramo.map(function(item){
      //   if ($scope.form.ramo.ramo_code == 3 && item.subramo_code != 9){
      //     item['disabled'] = true;
      //   } else {
      //     item['disabled'] = false;
      //   }
      //   return item;
      // })
      $scope.form.ramo.subramo_ramo.forEach(function (tp) {
        if (tp["id"] == parseInt($scope.lectura_object["subramo"])) {
          $scope.form["subramo"] = tp;
          if (tp["subramo_code"] != 9) {
            $scope.items = $scope.items_generales;
            $scope.items = $scope.items.concat($scope.items_danios);
          }
        }
      });
    };

    $scope.changeAseguradora = function () {
      $scope.form.ramo = undefined;
      $http
        .get(url.IP + "ramos-by-provider/" + $scope.form["aseguradora"].id)
        .then(function (ramos) {
          $scope.ramos = ramos.data;
          // $scope.ramos = $scope.ramos.map(function(ramo){
          //   if (ramo.ramo_code != 3){
          //     ramo['disabled'] = true;
          //   } else {
          //     ramo['disabled'] = false;
          //   }

          //   return ramo;
          // })
          $scope.ramos.forEach(function (tp) {
            if (tp["id"] == parseInt($scope.lectura_object["ramo"])) {
              $scope.form["ramo"] = tp;
              $scope.changeRamo();
            }
          });
        });
    };

    $scope.createQuotation = function () {
      $scope.showQuotation = true;
    };

    $scope.closeQuotation = function () {
      $scope.showQuotation = false;
      vm.form = [{}];
    };

    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      //toaster.success(MESSAGES.OK.UPLOADFILES);
      if (status == 200) {
        $scope.archivos_cargados = true;
        $scope.archivos = response["archivos_lectura"];
        $scope.lectura_object = response;
        setTimeout(function () {
          $state.go("config.edit_lectura_documentos", { id: response.id });
        }, 1500);
      }
    };

    uploader.onErrorItem = function (fileItem, response, status, headers) {};

    $scope.atras = function () {
      $scope.$broadcast("ngAreas:reset", {});
      $state.go("config.lectura_documentos");
    };

    $scope.guardar = function () {
      $scope.log900 = $scope.log900.map(function (item) {
        if (item && item["url"]) {
          return item;
        } else {
          item["owner"] = $scope.lectura_object["url"];
          item["org_name"] = usr.urlname;
        }
        return item;
      });

      var payload = {
        nombre: $scope.form.nombre,
        tipo_poliza: $scope.form.tipo_poliza ? $scope.form.tipo_poliza.id : 0,
        aseguradora: $scope.form.aseguradora ? $scope.form.aseguradora.id : 0,
        ramo: $scope.form.ramo ? $scope.form.ramo.id : $scope.form.ramo,
        subramo: $scope.form.subramo
          ? $scope.form.subramo.id
          : $scope.form.subramo,
      };
      $http.patch($scope.lectura_object.url, payload).then(function () {
        toastr.success("Datos actualizados");
      });

      var to_update = $scope.log900.filter(function (item) {
        if (!item.url) {
          return false;
        } else {
          return true;
        }
      });

      $scope.log900 = $scope.log900.filter(function (item) {
        if (!item.url) {
          return true;
        } else {
          return false;
        }
      });

      if ($scope.log900 && $scope.log900.length > 0) {
        $http
          .post(url.IP + "tag-lectura-archivos/", $scope.log900)
          .then(function (response) {
            $scope.log900 = response.data;
            toastr.success("Tags creados");
            $scope.$broadcast("ngAreas:reset", {});
            // location.reload();
          });
      }

      if (to_update && to_update.length > 0) {
        to_update.forEach(function (item) {
          $http.patch(item.url, item);
        });
        $scope.$broadcast("ngAreas:reset", {});
        toastr.success("Tags actulizados");
        $state.go("config.lectura_documentos");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      var pageNumber = prompt(
        "Ingrese el numero de hoja que desea agregar (en caso de que el PDF tenga más de una hoja)",
        "1"
      );
      if (pageNumber != null) {
        fileItem.formData = [];
        fileItem.formData.push({
          arch: fileItem._file,
          nombre: fileItem.file.name,
          nombre_entrenamiento: $scope.form.nombre,
          tipo_poliza: $scope.form.tipo_poliza ? $scope.form.tipo_poliza.id : 0,
          aseguradora: $scope.form.aseguradora ? $scope.form.aseguradora.id : 0,
          ramo: $scope.form.ramo ? $scope.form.ramo.id : $scope.form.ramo,
          subramo: $scope.form.subramo
            ? $scope.form.subramo.id
            : $scope.form.subramo,
          pageNumber: pageNumber,
        });
        $scope.specialchar = [];
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
        var str = fileItem.file.name;

        if ($scope.specialchar.length > 0) {
          $scope.uploader.queue.splice(
            $scope.uploader.queue.indexOf(fileItem),
            1
          );
          SweetAlert.swal(
            "Error",
            "El nombre de archivo: " +
              str +
              ", contiene carácteres especiales: " +
              $scope.specialchar,
            "error"
          );
        }
        if (fileItem) {
          $scope.countFile++;
        }
      }
    };

    $scope.cargarNuevaPoliza = function () {
      $scope.url_lectura = url.IP + "lectura-documentos/?org=" + usr.urlname;
      // console.log('queue', $scope.uploader.uploadAll());
      uploader.uploadAll();
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.url_lectura;
      // item.formData[0].name = item.file.name;
    };

    $scope.reset = function () {};

    $scope.itemChanged = function (name) {
      if (name == "Selecciona una opción") {
        SweetAlert.swal(
          "¡Error!",
          "Selecciona un nombre de etiqueta válido",
          "error"
        );
        $scope.items.forEach(function (item) {
          if (item.name == $scope.name_for_new_tag) {
            $scope.item_active = item;
          }
        });
        return;
      }

      $scope.name_for_new_tag = name;
    };

    $scope.onAddArea = function (ev, boxId, areas, area) {
      $scope.log900 = areas;
      console.log("areas", areas);
      $scope.$apply();
    };
    $scope.onRemoveArea = function (ev, boxId, areas, area) {
      if (boxId && boxId.url) {
        $http.delete(boxId.url);
      }
      $scope.log900 = areas;
      console.log("areas", areas);
      $scope.$apply();
    };

    $scope.onChangeAreas900 = function (ev, boxId, areas, area) {
      $scope.log900 = areas;
      $scope.$apply();
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("LecturaDocumentosController", LecturaDocumentosController);

  LecturaDocumentosController.$inject = [
    "$state",
    "$scope",
    "dataFactory",
    "datesFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "exportFactory",
  ];

  function LecturaDocumentosController(
    $state,
    $scope,
    dataFactory,
    datesFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    exportFactory
  ) {
    var vm = this;
    $scope.showQuotation = false;
    $scope.showInfoQuotation = false;
    vm.lecturas = [];

    activate();

    function activate() {
      $http.get(url.IP + "lectura-archivos/").then(function (response) {
        vm.lecturas = response.data;
        vm.lecturas = vm.lecturas.map(function (item) {
          item["selected"] = false;
          return item;
        });
      });
    }

    $scope.eliminar = function () {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este registro",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            var l = Ladda.create(document.querySelector(".ladda-button2"));
            l.start();
            vm.lecturas.forEach(function (lectura, index) {
              if (lectura.selected) {
                $http.delete(lectura.url).then(function () {
                  vm.lecturas.splice(index, 1);
                  // SweetAlert.swal("¡Eliminado!", "El registro fue eliminado.", "success");
                  l.stop();
                });
              }
            });
          }
        }
      );
    };

    $scope.quotationNew = [
      {
        contratante: {},
      },
    ];

    $scope.createQuotation = function () {
      $scope.showQuotation = true;
    };

    $scope.closeQuotation = function () {
      $scope.showQuotation = false;
      vm.form = [{}];
    };

    $scope.edit = function () {
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      $state.go("config.edit_lectura_documentos", { id: 0 });
      l.stop();
    };

    $scope.open = function (lectura) {
      $state.go("config.edit_lectura_documentos", { id: lectura.id });
    };
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("kbicontrolCtrl", kbicontrolCtrl);

  kbicontrolCtrl.$inject = [
    "$firebaseObject",
    "$sce",
    "curr_rate_options",
    "$scope",
    "statusPayform",
    "$state",
    "$uibModal",
    "$filter",
    "$localStorage",
    "$timeout",
    "$location",
    "Idle",
    "receiptService",
    "insuranceService",
    "ContratanteService",
    "providerService",
    "ramoService",
    "packageService",
    "MESSAGES",
    "$sessionStorage",
    "status",
    "payform",
    "url",
    "moduleInjection",
    "modalService",
    "helpers",
    "toaster",
    "endorsementService",
    "$q",
    "$http",
    "endorsement",
    "$rootScope",
    "$window",
    "SweetAlert",
    "exportFactory",
    "dataFactory",
    "FileUploader",
  ];

  function kbicontrolCtrl(
    $firebaseObject,
    $sce,
    curr_rate_options,
    $scope,
    statusPayform,
    $state,
    $uibModal,
    $filter,
    $localStorage,
    $timeout,
    $location,
    Idle,
    receiptService,
    insuranceService,
    ContratanteService,
    providerService,
    ramoService,
    packageService,
    MESSAGES,
    $sessionStorage,
    status,
    payform,
    url,
    moduleInjection,
    modalService,
    helpers,
    toaster,
    endorsementService,
    $q,
    $http,
    endorsement,
    $rootScope,
    $window,
    SweetAlert,
    exportFactory,
    dataFactory,
    FileUploader
  ) {
    var vm = this;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    vm.orgName = usr.org;
    vm.accesos = $sessionStorage.permisos;

    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Dashboard") {
          vm.acceso_dash = perm;
          vm.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Gráfica OTs") {
              if (acc.checked == true) {
                vm.permiso_g_ot = true;
              } else {
                vm.permiso_g_ot = false;
              }
            } else if (acc.permission_name == "Gráfica cobranza") {
              if (acc.checked == true) {
                vm.permiso_g_cob = true;
              } else {
                vm.permiso_g_cob = false;
              }
            } else if (acc.permission_name == "Gráfica renovaciones") {
              if (acc.checked == true) {
                vm.permiso_g_ren = true;
              } else {
                vm.permiso_g_ren = false;
              }
            } else if (acc.permission_name == "Gráfica siniestros") {
              if (acc.checked == true) {
                vm.permiso_g_sin = true;
              } else {
                vm.permiso_g_sin = false;
              }
            } else if (acc.permission_name == "KBI's") {
              if (acc.checked == true) {
                vm.permiso_kbi = true;
              } else {
                vm.permiso_kbi = false;
              }
            } else if (acc.permission_name == "Filtrado gráfica cobranza") {
              if (acc.checked == true) {
                vm.permiso_f_cob = true;
              } else {
                vm.permiso_f_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                vm.acceso_del_pol = true;
              } else {
                vm.acceso_del_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Siniestros") {
          vm.acceso_sin = perm;
          vm.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                vm.acceso_adm_sin = true;
              } else {
                vm.acceso_adm_sin = false;
              }
            }
          });
        } else if (perm.model_name == "Paquetes") {
          vm.acceso_pack = perm;
          vm.acceso_pack.permissions.forEach(function (acc) {
            if (acc.permission_name == "Crear paquete") {
              if (acc.checked == true) {
                vm.acceso_adm_pack = true;
              } else {
                vm.acceso_adm_pack = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Agenda") {
          vm.acceso_age = perm;
          vm.acceso_age.permissions.forEach(function (acc) {
            if (acc.permission_name == "Agenda") {
              if (acc.checked == true) {
                vm.acceso_age = true;
              } else {
                vm.acceso_age = false;
              }
            }
          });
        } else if (perm.model_name == "Notificaciones") {
          vm.acceso_mns = perm;
          vm.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar notificaciones") {
              if (acc.checked == true) {
                vm.acceso_not = true;
              } else {
                vm.acceso_not = false;
              }
            }
          });
        } else if (perm.model_name == "Mensajeria") {
          vm.acceso_mns = perm;
          vm.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                vm.acceso_mns = true;
              } else {
                vm.acceso_mns = false;
              }
            }
          });
        } else if (perm.model_name == "Campañas") {
          vm.acceso_camp = perm;
          vm.acceso_camp.permissions.forEach(function (acc) {
            if (acc.permission_name == "Campañas") {
              if (acc.checked == true) {
                vm.acceso_camp = true;
              } else {
                vm.acceso_camp = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          vm.acceso_ref = perm;
          vm.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                vm.acceso_adm_ref = true;
              } else {
                vm.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                vm.acceso_pag_ref = true;
              } else {
                vm.acceso_pag_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          vm.acceso_fian = perm;
          vm.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.acceso_dash = perm;
          vm.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }

    $scope.uploader = new FileUploader();

    if ($sessionStorage.infoUser) {
      vm.acceso_adm_tas = $sessionStorage.infoUser.another_tasks;
    } else {
      vm.acceso_adm_tas = false;
    }
    if ($sessionStorage.user) {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      if ($sessionStorage.token) {
        var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
        var token = JSON.parse(decryptedToken);
      }
    }
    /* -------- Inicia KBI -------- */

    $scope.show_financiero = true;
    $scope.show_produccion = false;
    $scope.show_cotizacion = false;
    $scope.show_gastos = false;
    $scope.showLoaderKbi = false;

    $scope.charts_kbi = {};
    $scope.newGoal = {
      value: null,
      model: null,
      options: [
        { id: "1", name: "MXN" },
        { id: "2", name: "USD" },
      ],
    };
    $scope.currencies = [
      { id: "1", name: "MXN" },
      { id: "2", name: "USD" },
    ];
    $scope.options = [
      { id: "1", name: "Año" },
      { id: "2", name: "Ramo" },
      { id: "3", name: "Subramo" },
    ];
    $scope.newGoal.model = $scope.newGoal.options[0].id;
    $scope.year_kbi = new Date().getFullYear();
    $scope.currency_kbi = "1";
    $scope.show_for = "1";

    $scope.show_currency_mxn = true;
    $scope.show_currency_usd = false;
    $scope.show_currency_eur = false;
    $scope.show_currency_udi = false;

    var currentYear = new Date().getFullYear();
    var firstDay = new Date(currentYear, 0, 1);
    var lastDay = new Date(currentYear, 11, 31);
    $scope.startDate_production = $scope.convertDateMain(firstDay);
    $scope.endDate_production = $scope.convertDateMain(lastDay);
    $scope.data_filter = {
      since_year: new Date().getFullYear() - 1,
      until_year: new Date().getFullYear(),
      since_day: $scope.startDate_production,
      until_day: $scope.endDate_production,
    };

    $scope.concepts = [
      { concept: "Renta / Alquiler", cantidad: "", value: 1 },
      { concept: "Nómina", cantidad: "", value: 2 },
      { concept: "Servicios Públicos", cantidad: "", value: 3 },
      { concept: "Publicidad", cantidad: "", value: 4 },
      { concept: "Impuestos", cantidad: "", value: 5 },
      { concept: "Materiales de oficina", cantidad: "", value: 6 },
      { concept: "Tributos", cantidad: "", value: 7 },
      { concept: "Préstamos o hipotecas", cantidad: "", value: 8 },
      { concept: "Servicios de empresas externas", cantidad: "", value: 9 },
    ];

    $scope.month_old = 0;
    $scope.year_old = 0;
    $scope.month_new = 0;
    $scope.year_new = 0;

    $scope.year_old = $scope.data_filter.until_year;
    $scope.year_new = $scope.data_filter.since_year;
    if ($sessionStorage.infoUser) {
      $scope.url_kbi = "kbi/";
      // }else{
      //   $scope.url_kbi = 'v2/core/kbi/'
      // }
    } else {
      $scope.url_kbi = "kbi/";
    }

    vm.activateKBI = activateKBI;
    vm.getInfoKBI = getInfoKBI;
    vm.getFilter = getFilter;

    function getFilter(value, param, startDate, endDate) {
      $scope.showLoaderKbi = true;
      $scope.year_kbi = param;
      var anio = parseInt(param);
      $scope.year_kbi_preview = anio - 1;
      if (value == 0) {
        $scope.year_kbi = new Date().getFullYear();
        $scope.data_filter = {
          since_year: new Date().getFullYear() - 1,
          until_year: new Date().getFullYear(),
          since_day: $scope.startDate_production,
          until_day: $scope.endDate_production,
        };
      } else {
        $scope.data_filter = {
          since_year: $scope.year_kbi - 1,
          until_year: $scope.year_kbi,
          since_day: startDate ? startDate : $scope.startDate_production,
          until_day: endDate ? endDate : $scope.endDate_production,
        };
      }

      if (!$scope.data_filter.since_day || !$scope.data_filter.until_day) {
        SweetAlert.swal(
          "Faltan fechas",
          "No se pudieron calcular las fechas desde/hasta para el filtro. Intenta cambiar el año o recargar la pantalla.",
          "warning"
        );
        $scope.showLoaderKbi = false;
        console.warn(
          "KBI request blocked: missing since_day or until_day",
          $scope.data_filter
        );
        return;
      }

      getInfoKBI();
    }

    activateKBI();

    function activateKBI() {
      dataFactory.get("configkbi/").then(function success(response) {
        if (response.data.results.length > 0) {
          $scope.tipo_cambio = response.data.results[0].tipocambio;
        } else {
          $scope.tipo_cambio = $scope.tipo_cambio ? $scope.tipo_cambio : 20;
        }
      });
      if (vm.orgName != "gpi") {
        vm.getFilter(0, new Date().getFullYear());
      }

      // vm.getFilter(0, new Date().getFullYear());
    }

    $scope.dataMonth = function (month_old, year_old, month_new, year_new) {
      $scope.month_old = month_old;
      $scope.year_old = year_old;
      $scope.month_new = month_new;
      $scope.year_new = year_new;
    };

    $scope.monthComparative = function () {
      var data = {
        month: $scope.month_old,
        year: $scope.year_old,
        month_c: $scope.month_new,
        year_c: $scope.year_new,
      };
      dataFactory.post("kbi-subramos/", data).then(function success(response) {
        $scope.charts_kbi.polarDataFinancial.data =
          response.data.polarDataFinancial.data;
        $scope.charts_kbi.polarDataFinancialDolar.data =
          response.data.polarDataFinancialDolar.data;
      });
      // vm.getFilter(0, new Date().getFullYear());
    };

    $scope.changeCurrencyKbi = function (value) {
      if (value == "1") {
        $scope.show_currency_mxn = true;
        $scope.show_currency_usd = false;
        $scope.show_currency_eur = false;
        $scope.show_currency_udi = false;
        $scope.currency_kbi = "1";
      } else if (value == "2") {
        $scope.show_currency_mxn = false;
        $scope.show_currency_usd = true;
        $scope.show_currency_eur = false;
        $scope.show_currency_udi = false;
        $scope.currency_kbi = "2";
      } else if (value == "3") {
        $scope.show_currency_mxn = false;
        $scope.show_currency_usd = false;
        $scope.show_currency_eur = true;
        $scope.show_currency_udi = false;
      } else if (value == "4") {
        $scope.show_currency_mxn = false;
        $scope.show_currency_usd = false;
        $scope.show_currency_eur = false;
        $scope.show_currency_udi = true;
      }
    };

    function getInfoKBI(tipocambio) {
      $scope.showLoaderKbi = true;
      if ($scope.charts_kbi) {
        $scope.charts_kbi.aseguradoras = {};
        $scope.charts_kbi.aseguradorasDolar = {};
        $scope.charts_kbi.subramos = {};
        $scope.charts_kbi.subramosDolar = {};
      }
      $scope.data_filter.tipocambio = $scope.tipo_cambio
        ? $scope.tipo_cambio
        : 20;
      // dataFactory.post('kbi/')
      dataFactory
        .post($scope.url_kbi, $scope.data_filter)
        .then(function success(response) {
          $scope.charts_kbi = response.data;
          $scope.now = $scope.convertDateMain(new Date());
          $scope.charts_kbi.ejecutivos = JSON.parse(response.data.ejecutivos);
          $scope.charts_kbi.ejecutivosDolar = JSON.parse(
            response.data.ejecutivosDolar
          );
          $scope.charts_kbi.aseguradoras = JSON.parse(
            response.data.aseguradoras
          );
          $scope.charts_kbi.aseguradorasDolar = JSON.parse(
            response.data.aseguradorasDolar
          );
          $scope.charts_kbi.subramos = JSON.parse(response.data.subramos);
          $scope.charts_kbi.subramosDolar = JSON.parse(
            response.data.subramosDolar
          );

          $scope.charts_kbi.anterior_ejecutivos = JSON.parse(
            response.data.anterior_ejecutivos
          );
          $scope.charts_kbi.anterior_ejecutivosDolar = JSON.parse(
            response.data.anterior_ejecutivosDolar
          );
          $scope.charts_kbi.anterior_aseguradoras = JSON.parse(
            response.data.anterior_aseguradoras
          );
          $scope.charts_kbi.anterior_aseguradorasDolar = JSON.parse(
            response.data.anterior_aseguradorasDolar
          );
          $scope.charts_kbi.anterior_subramos = JSON.parse(
            response.data.anterior_subramos
          );
          $scope.charts_kbi.anterior_subramosDolar = JSON.parse(
            response.data.anterior_subramosDolar
          );
          $scope.charts_kbi.goal.percentajeGoal = parseFloat(
            $scope.charts_kbi.goal.percentajeGoal
          ).toFixed(2);
          $scope.progressGoal = {
            width: $scope.charts_kbi.goal.percentajeGoal + "%",
          };

          if ($scope.charts_kbi.goal.value > 0) {
            $scope.showBtnKbi = true;
            var fin = new Date();
            var f = fin.getFullYear() - 1;
            $scope.fin = fin.getFullYear();
            $scope.range_pc =
              "De: " + $scope.now + " al " + "31/12/" + $scope.fin;
            $scope.range_cp =
              "De: " + "01/01/" + $scope.fin + " al " + $scope.now;
            $scope.range_date =
              "De: " + "01/01/" + $scope.fin + " al " + "31/12/" + $scope.fin;
            $scope.range_bar = "Años: " + f + " y " + fin.getFullYear();
          } else {
            $scope.showBtnKbi = false;
          }

          $scope.newGoal.value = parseFloat($scope.charts_kbi.goal.value);
          $scope.newGoal.model = $scope.charts_kbi.goal.currency;
          if ($scope.charts_kbi.monthsUtilidad) {
            $scope.total_utilidad = 0;
            $scope.charts_kbi.monthsUtilidad.forEach(function (item) {
              if (item.value) {
                $scope.total_utilidad = parseFloat(
                  ($scope.total_utilidad + parseFloat(item.value)).toFixed(2)
                );
              }
            });
          }
          if ($scope.charts_kbi.monthsUtilidad_anterior) {
            $scope.total_utilidad_ant = 0;
            $scope.charts_kbi.monthsUtilidad_anterior.forEach(function (item) {
              if (item.value) {
                $scope.total_utilidad_ant = parseFloat(
                  ($scope.total_utilidad_ant + parseFloat(item.value)).toFixed(
                    2
                  )
                );
              }
            });
          }
          $scope.showLoaderKbi = false;
        });
    }

    $scope.selectMonth = function (mes) {
      $scope.month_selected = mes.id;
    };

    $scope.show_tab_kbi = function (value) {
      if (value == 1) {
        $scope.show_financiero = true;
        $scope.show_produccion = false;
        $scope.show_cotizacion = false;
        $scope.show_gastos = false;
      } else if (value == 2) {
        $scope.show_financiero = false;
        $scope.show_produccion = true;
        $scope.show_cotizacion = false;
        $scope.show_gastos = false;
      } else if (value == 3) {
        $scope.show_financiero = false;
        $scope.show_produccion = false;
        $scope.show_cotizacion = true;
        $scope.show_gastos = false;
      } else if (value == 4) {
        $scope.show_financiero = false;
        $scope.show_produccion = false;
        $scope.show_cotizacion = false;
        $scope.show_gastos = true;
      }
      // if($scope.show_currency_mxn){
      //   $scope.changeCurrencyKbi("1");
      // }else if($scope.show_currency_usd){
      //   $scope.changeCurrencyKbi("2");
      // }
    };

    $scope.show_ejectivo = true;
    $scope.show_aseguradora = false;
    $scope.show_subramo = false;

    $scope.show_tab_production = function (value) {
      if (value == 1) {
        $scope.show_ejectivo = true;
        $scope.show_aseguradora = false;
        $scope.show_subramo = false;
      } else if (value == 2) {
        $scope.show_ejectivo = false;
        $scope.show_aseguradora = true;
        $scope.show_subramo = false;
      } else if (value == 3) {
        $scope.show_ejectivo = false;
        $scope.show_aseguradora = false;
        $scope.show_subramo = true;
      }
    };

    $scope.saveGoal = function () {
      dataFactory.post("goal/", { goal: $scope.newGoal.value });
      $scope.showBtnKbi = true;
    };

    $scope.editGoal = function () {
      dataFactory.post("goal/", { goal: $scope.newGoal.value });
      $scope.showBtnKbi = false;
    };

    $scope.saveGastos = function () {
      var obj = [];
      $scope.concepts.forEach(function (child, index) {
        if (child.concept && child.cantidad) {
          child.month = $scope.month_selected;
          obj.push(child);
        }
        if ($scope.concepts.length == index + 1) {
          dataFactory.post("expenses/", obj).then(function success(response) {
            if (response.status == 201) {
              $scope.concepts = [
                { concept: "Renta / Alquiler", cantidad: "", value: 1 },
                { concept: "Nómina", cantidad: "", value: 2 },
                { concept: "Servicios Públicos", cantidad: "", value: 3 },
                { concept: "Publicidad", cantidad: "", value: 4 },
                { concept: "Impuestos", cantidad: "", value: 5 },
                { concept: "Materiales de oficina", cantidad: "", value: 6 },
                { concept: "Tributos", cantidad: "", value: 7 },
                { concept: "Préstamos o hipotecas", cantidad: "", value: 8 },
                {
                  concept: "Servicios de empresas externas",
                  cantidad: "",
                  value: 9,
                },
              ];
              getInfoKBI();
            }
          });
        }
      });
    };

    $scope.months_kbi = [
      { id: 1, month: "Enero" },
      { id: 2, month: "Febrero" },
      { id: 3, month: "Marzo" },
      { id: 4, month: "Abril" },
      { id: 5, month: "Mayo" },
      { id: 6, month: "Junio" },
      { id: 7, month: "Julio" },
      { id: 8, month: "Agosto" },
      { id: 9, month: "Septiembre" },
      { id: 10, month: "Octubre" },
      { id: 11, month: "Noviembre" },
      { id: 12, month: "Diciembre" },
    ];

    $scope.anios_kbi = [
      { id: 2026, year: "2026" },
      { id: 2025, year: "2025" },
      { id: 2024, year: "2024" },
      { id: 2023, year: "2023" },
      { id: 2022, year: "2022" },
      { id: 2021, year: "2021" },
      { id: 2020, year: "2020" },
    ];

    $scope.monthName = function (month) {
      switch (month) {
        case 1:
          return "Enero";
          break;
        case 2:
          return "Febrero";
          break;
        case 3:
          return "Marzo";
          break;
        case 4:
          return "Abril";
          break;
        case 5:
          return "Mayo";
          break;
        case 6:
          return "Junio";
          break;
        case 7:
          return "Julio";
          break;
        case 8:
          return "Agosto";
          break;
        case 9:
          return "Septiembre";
          break;
        case 10:
          return "Octubre";
          break;
        case 11:
          return "Noviembre";
          break;
        case 12:
          return "Diciembre";
          break;
      }
    };

    $scope.addConcept = function () {
      var concept = {
        concept: "",
        cantidad: "",
        value: 10,
      };
      $scope.concepts.push(concept);
    };

    $scope.removeConcept = function (item) {
      $scope.concepts.splice(item, 1);
    };

    $scope.validateDecimal = function (input) {
      if (input) {
        if (parseFloat(input) < 0) {
          $scope.$filternewGoal.value = 0;
        } else {
          $scope.newGoal.value = parseFloat(input.toFixed(2));
        }
      }
    };
    $scope.saveTipoCambio = function (val) {
      if (val) {
        console.log("tipo cambio", val);
        $scope.changeTypeCurrency(val);
        dataFactory.post("configkbi/", {
          tipocambio: parseFloat(val).toFixed(2),
        });
      }
    };
    $scope.validateGasto = function (input) {
      if (input) {
        for (var i = 0; i < $scope.concepts.length; i++) {
          if ($scope.concepts[i].cantidad != "") {
            if (parseFloat($scope.concepts[i].cantidad) < 0) {
              $scope.concepts[i].cantidad = 0;
            } else {
              $scope.concepts[i].cantidad = parseFloat(
                $scope.concepts[i].cantidad.toFixed(2)
              );
            }
          }
        }
      }
    };

    $scope.convertDateMain = function (inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    };
    $scope.deleteConcept = function (item, index) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text:
            "Eliminar " + item.concept + ". Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .delete(item.url)
              .then(function (request) {
                SweetAlert.swal(
                  "Listo",
                  "El concepto ha sido eliminado",
                  "success"
                );
                getInfoKBI();
              })
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
            SweetAlert.swal(
              "Cancelado",
              "El concepto no se ha eliminado.",
              "info"
            );
          }
        }
      );
    };

    $scope.changeTypeCurrency = function (valur) {
      $scope.tipo_cambio = valur;
      getInfoKBI();
    };
    $scope.verpor = function (valur) {
      $scope.show_for = valur;
    };
    /* --------- Termina KBI ---------- */

    $scope.exportDataExcel = function () {
      $scope.datafil = {
        show_currency_usd: $scope.show_currency_usd
          ? $scope.show_currency_usd
          : false,
        show_currency_mxn: $scope.show_currency_mxn
          ? $scope.show_currency_mxn
          : false,
        show_for: $scope.show_for,
        tipo_cambio: $scope.tipo_cambio,
      };
      var modalInstance = $uibModal.open({
        templateUrl: "app/kbi/kbi.modal.html",
        controller: KbiModalCtrl,
        controllerAs: "vmm",
        size: "sm",
        resolve: {
          filters: function () {
            return $scope.data_filter;
          },
          datafil: function () {
            return $scope.datafil;
          },
          configSubramos: function () {
            $scope.configSubr = {
              month_old: $scope.month_old,
              year_old: $scope.year_old,
              month_new: $scope.month_new,
              year_new: $scope.year_new,
            };
            return $scope.configSubr;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };

    function KbiModalCtrl(
      $scope,
      dataFactory,
      $uibModalInstance,
      filters,
      datafil,
      configSubramos
    ) {
      var vmm = this;

      $scope.financiero = true;
      $scope.produccion = true;
      $scope.cotizaciones = true;
      $scope.gastos = true;

      $scope.downloadReport = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        var obj = {
          financiero: $scope.financiero,
          produccion: $scope.produccion,
          cotizaciones: $scope.cotizaciones,
          gastos: $scope.gastos,
          since_year: filters.since_year,
          until_year: filters.until_year,
          since_day: filters.since_day,
          until_day: filters.until_day,
          currency: datafil.show_currency_usd ? "Dolar" : "Peso",
          month_old: $scope.month_old ? $scope.month_old : $scope.month_old,
          year_old: $scope.year_old ? $scope.year_old : $scope.year_old,
          year_new: $scope.month_new ? $scope.month_new : $scope.month_new,
          show_for: datafil.show_for ? datafil.show_for : 1,
          month: configSubramos.month_old,
          year: configSubramos.year_old,
          month_c: configSubramos.month_new,
          year_c: configSubramos.year_new,
          tipocambio: filters.tipocambio,
        };
        dataFactory
          .post("service-kbi-excel", obj)
          .then(function success(response) {
            if (response.status == 200) {
              var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
              //var socket = io.connect("http://127.0.0.1:8080");
              socket.emit("subscribe", response.data);
              socket.on(response.data, function (url) {
                l.stop();
                var notificacion = {
                  title: "El reporte solicitado ha sido generado",
                  description: url,
                  model: 26,
                  id_reference: 0,
                };
                dataFactory
                  .post("notificaciones/", notificacion)
                  .then(function success(response) {
                    SweetAlert.swal({
                      title: "El reporte está listo para descargar",
                      icon: "success",
                      text: "Encuentra la liga de descarga en la sección de notificaciones",
                      timer: 20000,
                    });
                    socket.disconnect();
                    $uibModalInstance.dismiss("cancel");
                  })
                  .catch(function (err) {
                    socket.disconnect();
                  });
              });
              toaster.info(
                "Generando...",
                "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
              );
            } else {
              l.stop();
              toaster.error(
                "Aviso",
                "Ha ocurrido un error, intente nuevamente"
              );
            }
          })
          .catch(function (error) {
            l.stop();
            toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
          });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("InicioCtrl", InicioCtrl);

  InicioCtrl.$inject = [
    "$scope",
    "$localStorage",
    "$sessionStorage",
    "$state",
    "dataFactory",
    "$interval",
    "$timeout",
  ];

  function InicioCtrl(
    $scope,
    $localStorage,
    $sessionStorage,
    $state,
    dataFactory,
    $interval,
    $timeout
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    $scope.infoUser = $sessionStorage.infoUser;

    var vm = this;
    var order = this;
    $("#carousel-example-generic").carousel({ interval: 3000 });
    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          order.acceso_polizas = perm;
          order.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                order.acceso_adm_pol = true;
              } else {
                order.acceso_adm_pol = false;
              }
            }
            if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                order.acceso_ver_pol = true;
              } else {
                order.acceso_ver_pol = false;
              }
            }
            if (acc.permission_name == "Comisión no obligatoria") {
              if (acc.checked == true) {
                order.acceso_cno_pol = true;
              } else {
                order.acceso_cno_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          order.acceso_form = perm;
          order.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                order.acceso_form = true;
              } else {
                order.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          order.coms = perm;
          order.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                order.permiso_comisiones = true;
              } else {
                order.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          order.acceso_refereciador = perm;
          order.acceso_refereciador.permissions.forEach(function (acc) {
            if (acc.permission_name == "Referenciador no obligatorio") {
              if (acc.checked == true) {
                order.acc_referenciador_obligatorio = true;
              } else {
                order.acc_referenciador_obligatorio = false;
              }
            }
          });
        }
      });
    }
    $scope.carousel = [];
    vm.logo = $localStorage.mainLogo;

    var DEFAULT_CAROUSEL = [
      {
        imagen: "../../assets/images/inicio/1-banner_ok.png",
      },
    ];
    var CAROUSEL_ORG_RETRY_DELAY = 1500;
    var MAX_CAROUSEL_ORG_RETRY_ATTEMPTS = 5;
    var carouselOrgRetryTimer = null;
    var carouselOrgRetryAttempts = 0;

    getCarousel(3);

    $scope.$on("$destroy", function () {
      cancelCarouselOrgRetry();
    });

    function decodeEncryptedUserCandidate(blob) {
      if (!blob || !window.safeDecrypt) {
        return null;
      }
      return window.safeDecrypt("User", blob);
    }

    function normalizeOrgValue(value) {
      if (value === null || typeof value === "undefined") {
        return "";
      }

      if (angular.isObject(value)) {
        if (value.urlname) {
          return normalizeOrgValue(value.urlname);
        }
        if (value.org && value.org.urlname) {
          return normalizeOrgValue(value.org.urlname);
        }
        if (value.orgName) {
          return normalizeOrgValue(value.orgName);
        }
        if (value.orgname) {
          return normalizeOrgValue(value.orgname);
        }
        if (value.org) {
          return normalizeOrgValue(value.org);
        }
        return "";
      }

      if (typeof value !== "string") {
        try {
          value = value.toString();
        } catch (_) {
          return "";
        }
      }

      var trimmed = value.trim();
      if (!trimmed) {
        return "";
      }

      var lower = trimmed.toLowerCase();
      if (lower === "undefined" || lower === "null") {
        return "";
      }

      return trimmed;
    }

    function extractOrgFromCandidate(candidate) {
      if (!candidate) {
        return "";
      }

      if (angular.isString(candidate)) {
        try {
          candidate = JSON.parse(candidate);
        } catch (_) {
          return normalizeOrgValue(candidate);
        }
      }

      if (angular.isObject(candidate)) {
        var keys = ["urlname", "org", "orgName", "orgname"];
        for (var idx = 0; idx < keys.length; idx++) {
          if (candidate[keys[idx]]) {
            return normalizeOrgValue(candidate[keys[idx]]);
          }
        }

        if (candidate.orgInfo && candidate.orgInfo.urlname) {
          return normalizeOrgValue(candidate.orgInfo.urlname);
        }
      }

      return "";
    }

    function readStoredOrgUrlname() {
      var candidates = [
        decodeEncryptedUserCandidate($sessionStorage.user),
        decodeEncryptedUserCandidate($localStorage.user),
        $sessionStorage.infoUser,
        $localStorage.infoUser,
      ];

      for (var i = 0; i < candidates.length; i++) {
        var extracted = extractOrgFromCandidate(candidates[i]);
        if (extracted) {
          return extracted;
        }
      }

      return "";
    }

    function cancelCarouselOrgRetry() {
      if (carouselOrgRetryTimer) {
        $timeout.cancel(carouselOrgRetryTimer);
        carouselOrgRetryTimer = null;
      }
      carouselOrgRetryAttempts = 0;
    }

    function scheduleCarouselOrgRetry() {
      if (
        carouselOrgRetryTimer ||
        carouselOrgRetryAttempts >= MAX_CAROUSEL_ORG_RETRY_ATTEMPTS
      ) {
        return;
      }

      carouselOrgRetryTimer = $timeout(function () {
        carouselOrgRetryTimer = null;
        var orgCandidate = readStoredOrgUrlname();
        if (orgCandidate) {
          console.log(
            'getCarousel inicio.controller.js: detected org "%s" after invalid response. Retrying load.',
            orgCandidate
          );
          getCarousel(3);
          return;
        }

        carouselOrgRetryAttempts += 1;
        scheduleCarouselOrgRetry();
      }, CAROUSEL_ORG_RETRY_DELAY);
    }

    function hasInvalidOrgParameter(error) {
      if (!error || error.status !== 403) {
        return false;
      }

      var config = error.config || {};
      var rawUrl = (config.url || "").toString();
      if (rawUrl.toLowerCase().indexOf("get-carousel-from-cas/") === -1) {
        return false;
      }

      var orgValue = "";
      if (
        config.params &&
        typeof config.params.org !== "undefined" &&
        config.params.org !== null
      ) {
        orgValue = config.params.org;
      } else {
        var match = rawUrl.match(/[?&]org=([^&#]*)/);
        orgValue = match && match[1] ? decodeURIComponent(match[1]) : "";
      }

      if (orgValue === null || typeof orgValue === "undefined") {
        orgValue = "";
      }

      if (typeof orgValue !== "string") {
        try {
          orgValue = orgValue.toString();
        } catch (_) {
          orgValue = "";
        }
      }

      var normalizedOrg = orgValue.trim().toLowerCase();
      return (
        !normalizedOrg ||
        normalizedOrg === "undefined" ||
        normalizedOrg === "null"
      );
    }

    function getCarousel(retryCount) {
      retryCount = angular.isNumber(retryCount) ? retryCount : 3;

      var orgForRequest = readStoredOrgUrlname();
      var requestParams = orgForRequest ? { org: orgForRequest } : undefined;

      dataFactory
        .get("get-carousel-from-cas/", requestParams)
        .then(function success(response) {
          cancelCarouselOrgRetry();
          var data = response.data && response.data.data;
          $scope.carousel =
            data && data.length > 0 ? data : angular.copy(DEFAULT_CAROUSEL);
        })
        .catch(function (e) {
          if (hasInvalidOrgParameter(e)) {
            console.warn(
              "Skipping carousel retry because the org parameter is missing or invalid."
            );
            console.log(
              "getCarousel inicio.controller.js: fallback to default banner due to invalid org parameter."
            );
            $scope.carousel = angular.copy(DEFAULT_CAROUSEL);
            var storedOrgCandidate = readStoredOrgUrlname();
            if (storedOrgCandidate) {
              console.log(
                'getCarousel inicio.controller.js: stored org "%s" found after fallback. Retrying immediately.',
                storedOrgCandidate
              );
              $timeout(function () {
                getCarousel(3);
              }, 500);
              return;
            }

            carouselOrgRetryAttempts = 0;
            scheduleCarouselOrgRetry();
            return;
          }

          if (retryCount > 0) {
            console.warn(
              "getCarousel failed. Retrying in 1s... Attempts left:",
              retryCount
            );
            $timeout(function () {
              getCarousel(retryCount - 1);
            }, 1000);
          } else {
            console.error(
              "Failed to fetch carousel after multiple attempts:",
              e
            );
            $scope.carousel = angular.copy(DEFAULT_CAROUSEL);
          }
        });
    }

    $scope.currentIndex = 0;

    // Siguiente slide
    $scope.nextSlide = function () {
      $scope.currentIndex = ($scope.currentIndex + 1) % $scope.carousel.length;
    };

    // Anterior slide
    $scope.prevSlide = function () {
      $scope.currentIndex =
        ($scope.currentIndex - 1 + $scope.carousel.length) %
        $scope.carousel.length;
    };

    // Ir a un slide específico
    $scope.goToSlide = function (index) {
      $scope.currentIndex = index;
    };

    // Reproducción automática (opcional)
    var interval = $interval(function () {
      $scope.nextSlide();
    }, 3000);

    // Limpieza al destruir
    $scope.$on("$destroy", function () {
      $interval.cancel(interval);
    });
    // modal crear OT
    $scope.otCreatorModalEvent = function (param) {
      if (order.acceso_adm_ot || order.acceso_adm_pol) {
        if (param == 1) {
          $scope.open_in_same_tab_natural(
            "Creación póliza",
            "polizas.create",
            {},
            0
          );
          $state.go("polizas.create");
        } else if (param == 2) {
          $scope.open_in_same_tab_natural(
            "Creación póliza",
            "colectividades.main",
            {},
            0
          );
          $state.go("colectividades.main");
        }
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("IBISController", IBISController);

  IBISController.$inject = [
    "$scope",
    "dataFactory",
    "SweetAlert",
    "$sessionStorage",
    "FileUploader",
    "url",
    "MESSAGES",
  ];

  function IBISController(
    $scope,
    dataFactory,
    SweetAlert,
    $sessionStorage,
    FileUploader,
    url,
    MESSAGES
  ) {
    var vm = this;

    $scope.saveFlag = false;
    $scope.ibis = true;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    activate();

    function activate() {}

    $scope.selectExcelDirectorio = function (parData) {
      $scope.strcutureData = certStructure(parData);
      treeStructure(parData);
      $scope.id_tree = true;
      $scope.saveFlag = true;
    };

    function certStructure(parData) {
      $scope.dataToSave = [];
      for (var key in parData) {
        var data = parData[key];
        if (data.length) {
          data.forEach(function (item) {
            if (item.NOMBRE) {
              var obj = {
                nombre: item.NOMBRE,
                area: item.AREA,
                email: item.EMAIL,
                puesto: item.PUESTO,
                ramo: item.RAMO,
                sexo: item.SEXO,
                telefono: item.TELEFONO,
              };

              $scope.dataToSave.push(obj);
            }
          });
        }
      }

      return $scope.dataToSave;
    }

    function treeStructure(parData) {
      var tree = [];

      for (var key in parData) {
        var data = parData[key];
        if (data.length) {
          data.forEach(function (item) {
            if (item.NOMBRE) {
              var item_content =
                '<i class="fa fa-user"></i> ' +
                item.NOMBRE +
                " - " +
                item.TELEFONO +
                " - " +
                item.EMAIL +
                " - " +
                item.AREA +
                " - " +
                item.PUESTO;

              var element = {
                text: item_content,
              };

              tree.push(element);
            }
          });
        }

        $("#tree").treeview({ data: tree });
      }
    }

    $scope.save = function (param) {
      if (param == 1) {
        dataFactory
          .post("directorio/", $scope.strcutureData)
          .then(function success(responseDirect) {
            if (responseDirect.status == 200 || responseDirect.status == 201) {
              SweetAlert.swal(
                "Exito",
                "Se han guardado los contactos",
                "success"
              );
            }
          });
      }
    };

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.ramo == undefined) {
        item.ramo = 2;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].ramo = item.ramo;
    };

    $scope.saveFiles = function () {
      uploadFiles();
    };

    function uploadFiles() {
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "formatos/?org=" + usr.org;
      $scope.uploader.uploadAll();
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "IbisFormatosPlantillasSiniestrosCtrl",
      IbisFormatosPlantillasSiniestrosCtrl
    );

  IbisFormatosPlantillasSiniestrosCtrl.$inject = [
    "$scope",
    "$parse",
    "$sce",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "PersistenceFactory",
    "$sessionStorage",
  ];

  function IbisFormatosPlantillasSiniestrosCtrl(
    $scope,
    $parse,
    $sce,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    PersistenceFactory,
    $sessionStorage
  ) {
    $scope.showPlantilla = false;
    $scope.showInfoPlantilla = false;
    $scope.showEditInformation = false;
    $scope.plantilla = {};
    $scope.savingPlantilla = false;

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    $scope.createQuotation = function () {
      $scope.showPlantilla = true;
      $scope.showEditInformation = false;
      $scope.plantilla = {};
    };

    $scope.closeQuotation = function () {
      $scope.showEditInformation = false;
      $scope.showPlantilla = false;
      $scope.plantilla = {};
    };
    var vm = this;

    function isBlankText(value) {
      if (!value) {
        return true;
      }
      var cleaned = value
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/g, "")
        .replace(/\s/g, "");
      return cleaned.length === 0;
    }

    activate();
    $scope.page = 1;
    function activate(page) {
      $scope.page = page ? page : 1;
      $scope.actual_page = $scope.page;

      $scope.filtros = { page: $scope.page, type_message: 3 };

      $http({
        method: "GET",
        url: url.IP + "whatsappwebtemplate/",
        params: $scope.filtros, // ✅ aquí va en GET
      }).then(function success(response) {
        var payload = response.data || [];
        if (payload && payload.results && Array.isArray(payload.results)) {
          vm.templatesList = payload.results;
        } else if (Array.isArray(payload)) {
          vm.templatesList = payload;
        } else {
          vm.templatesList = [];
        }

        vm.templates = {
          count: response.data.count,
          previous: response.data.previous,
          next: response.data.next,
        };

        $scope.showTemplates =
          !!vm.templatesList && vm.templatesList.length > 0;

        testPagination("vm.templates", "vm.templates");
      });
    }

    $scope.selectProv = function (sel) {
      $scope.aseguradoras = sel;
    };

    $scope.showInformation = function (item) {
      if (item) {
        $scope.showInfoPlantilla = !$scope.showInfoPlantilla;
        $scope.plantilla = item;
      } else {
        $scope.showInfoPlantilla = !$scope.showInfoPlantilla;
      }
    };

    $scope.saveDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (!form || !form.title || !form.text) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de continuar.",
          "warning"
        );
        return;
      }

      if (isBlankText(form.title) || isBlankText(form.text)) {
        SweetAlert.swal(
          "Error",
          "El identificador y el mensaje no pueden estar vacíos.",
          "warning"
        );
        return;
      }

      form.type_message = 3;
      $scope.savingPlantilla = true;

      dataFactory
        .post("whatsappwebtemplate/", form)
        .then(function success(response) {
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla guardada correctamente.",
            "success"
          );
          $scope.closeQuotation();
          activate(1);
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.updateDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (!form || !form.title || !form.text) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de actualizar.",
          "warning"
        );
        return;
      }

      if (isBlankText(form.title) || isBlankText(form.text)) {
        SweetAlert.swal(
          "Error",
          "El identificador y el mensaje no pueden estar vacíos.",
          "warning"
        );
        return;
      }

      $scope.savingPlantilla = true;

      var data = {
        title: form.title,
        text: form.text,
      };
      $http
        .patch(form.url, data)
        .then(function success(response) {
          $scope.showEditInformation = false;

          SweetAlert.swal(
            "¡Listo!",
            "Plantilla actualizada correctamente.",
            "success"
          );
          $scope.closeQuotation();
          activate(1);
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.borrarPlantilla = function (item) {
      if (!item || !item.url) {
        return;
      }
      SweetAlert.swal(
        {
          title: "¿Confirmas la eliminación?",
          text: "La plantilla se eliminará permanentemente.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí, borrar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }
          $http
            .delete(item.url)
            .then(function success() {
              SweetAlert.swal(
                "¡Listo!",
                "Plantilla eliminada correctamente.",
                "success"
              );
              activate(1);
            })
            .catch(function () {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            });
        }
      );
    };

    $scope.editQuatation = function (form) {
      $scope.plantilla.title = form.title;
      $scope.plantilla.text = form.text;
      $scope.plantilla.url = form.url;
      $scope.showPlantilla = true;
      $scope.showEditInformation = true;
    };

    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        activate(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("HelpCtrl", HelpCtrl);

  HelpCtrl.$inject = ["$scope", "$sce"];

  function HelpCtrl($scope, $sce) {
    $scope.manuals = [
      {
        title: "Configuración inicial",
        id: 0,
        sections: [
          {
            subtitle: "Acceso al CAS",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Acceso+al+CAS.pdf"
            ),
          },
          {
            subtitle: "Crear Perfiles",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Crear+perfiles.pdf"
            ),
          },
          {
            subtitle: "Crear Usuarios",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Crear+usuarios.pdf"
            ),
          },
          {
            subtitle: "Crear Clave",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Crear+claves.pdf"
            ),
          },
        ],
      },
      {
        title: "Navegación",
        id: 0,
        sections: [
          {
            subtitle: "Indicadores de operación en tiempo real",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Indicadores+de+operaci%C3%B3n+en+tiempo+real.pdf"
            ),
          },
          {
            subtitle: "Usar el Superbuscador",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Super+Buscador.pdf"
            ),
          },
          {
            subtitle: "Usar filtros y listados",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Filtros+y+listados.pdf"
            ),
          },
          {
            subtitle: "Usar el menú rápido de opciones",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Men%C3%BA+rapido+de+opciones.pdf"
            ),
          },
        ],
      },
      {
        title: "Contratantes",
        id: 0,
        sections: [
          {
            subtitle: "Crear y editar",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Crear+y+editar+contratante.pdf"
            ),
          },
        ],
      },
      {
        title: "Grupos",
        id: 0,
        sections: [
          {
            subtitle: "Crear y editar grupo",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Crear+y+editar+grupos.pdf"
            ),
          },
        ],
      },
      {
        title: "Pólizas",
        id: 0,
        sections: [
          {
            subtitle: "Crear y editar OT/Póliza",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/P%C3%B3lizas.pdf"
            ),
          },
        ],
      },
      {
        title: "Pólizas de Grupo",
        id: 0,
        sections: [
          {
            subtitle: "Crear OT/Póliza de Grupo",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Manual+de+Colectividades+SAAM+Miurabox.pdf"
            ),
          },
        ],
      },
      {
        title: "Colectividades",
        id: 0,
        sections: [
          {
            subtitle: "Crear OT/Colectividad/Flotilla",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Manual+Flotillas+SAAM+Miurabox.pdf"
            ),
          },
        ],
      },
      {
        title: "Fianzas",
        id: 0,
        sections: [
          {
            subtitle: "Crear y editar fianza",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Manual+Fianzas+SAAM+Miurabox.pdf"
            ),
          },
        ],
      },
      {
        title: "Renovaciones",
        id: 0,
        sections: [
          {
            subtitle: "Renovar pólizas individuales",
          },
          {
            subtitle: "Renovar pólizas colectivas",
          },
        ],
      },
      {
        title: "Cobranza",
        id: 0,
        sections: [
          {
            subtitle: "Cambiar de estatus un recibo",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Estatus+Recibos.pdf"
            ),
          },
        ],
      },
      {
        title: "Aseguradoras",
        id: 0,
        sections: [
          {
            subtitle: "Crear y editar aseguradora",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Crear+y+editar+aseguradoras.pdf"
            ),
          },
        ],
      },
      {
        title: "Paquetes",
        id: 0,
        sections: [
          {
            subtitle: "Crear paquete",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Crear+paquetes.pdf"
            ),
          },
          {
            subtitle: "Asignar coberturas",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Crear+coberturas.pdf"
            ),
          },
          {
            subtitle: "Personalizar paquetes",
          },
        ],
      },
      {
        title: "Endosos",
        id: 0,
        sections: [
          {
            subtitle: "Crear y registrar endoso",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Endosos.pdf"
            ),
          },
          {
            subtitle: "Crear endoso de alta",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Fianzas+c.pdf"
            ),
          },
          {
            subtitle: "Crear endoso de baja",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Fianzas+c.pdf"
            ),
          },
          {
            subtitle: "Crear endoso manual para colectividades",
          },
        ],
      },
      {
        title: "Siniestros",
        id: 0,
        sections: [
          {
            subtitle: "Crear siniestro",
          },
          {
            subtitle: "Completar siniestro",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Completar+siniestros.pdf"
            ),
          },
        ],
      },
      {
        title: "Comisiones",
        id: 0,
        sections: [
          {
            subtitle: "Liquidar y conciliar recibos",
          },
        ],
      },
      {
        title: "Referenciadores",
        id: 0,
        sections: [
          {
            subtitle: "Configurar usuarios referenciadores",
            // "url": $sce.trustAsResourceUrl("https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Administrar+Referenciadores.pdf")
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Administrar+Referenciadores.pdf"
            ),
          },
          {
            subtitle: "Pagar a referenciadores",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Pago+referenciadores.pdf"
            ),
          },
        ],
      },
      {
        title: "Reportes",
        id: 0,
        sections: [
          {
            subtitle: "Generar reporte",
          },
        ],
      },
      {
        title: "Cartas",
        id: 0,
        sections: [
          {
            subtitle: "Crear y generar carta",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Cartas.pdf"
            ),
          },
        ],
      },
      {
        title: "Campañas",
        id: 0,
        sections: [
          {
            subtitle: "Crear campaña",
          },
        ],
      },
      {
        title: "Correos automáticos",
        id: 0,
        sections: [
          {
            subtitle: "Configurar correos automáticos",
            url: $sce.trustAsResourceUrl(
              "https://miurabox-public.s3.us-east-1.amazonaws.com/manuales/Correo+autom%C3%A1ticos.pdf"
            ),
          },
        ],
      },
    ];

    $scope.showAnswerNegative = false;
    $scope.showAnswerAfirmative = false;

    $scope.showResult = function (value) {
      if (value) {
        $scope.showAnswerNegative = false;
        $scope.showAnswerAfirmative = true;
      } else {
        $scope.showAnswerNegative = true;
        $scope.showAnswerAfirmative = false;
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").factory("groupService", groupService);

  groupService.$inject = ["url", "$http", "fileService", "$localStorage"];

  function groupService(url, $http, fileService, $localStorage) {
    var infoUser = $localStorage.infoUser;

    var service = {
      createGroup: createGroup,
      getGroups: getGroups,
      getFullGroups: getFullGroups,
      getGroup: getGroup,
      getFiles: getFiles,
      updateGroup: updateGroup,
      deleteGroup: deleteGroup,
      getTableGroups: getTableGroups,
    };

    return service;

    ////////////

    // CREATE
    function createGroup(data) {
      return $http
        .post(url.IP + "grupos/", data)
        .then(createGroupComplete)
        .catch(createGroupFailed);

      function createGroupComplete(response) {
        return response;
      }

      function createGroupFailed(error) {
        return error;
      }
    }

    //   READ
    function getFullGroups() {
      return $http
        .get(url.IP + "grupos-full/")
        .then(getGroupsComplete)
        .catch(getGroupsFailed);

      function getGroupsComplete(response) {
        return response.data.results;
      }

      function getGroupsFailed(error) {
        return error;
      }
    }

    function getTableGroups() {
      infoUser = $localStorage.infoUser;
      var search_group = "grupos-table-resume";
      return $http
        .get(url.IP + search_group)
        .then(getTableGroupsComplete)
        .catch(getTableGroupsFailed);

      function getTableGroupsComplete(response) {
        //return response.data.results;
        var results = {
          data: response.data,
          config: {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          },
        };

        return results;
      }

      function getTableGroupsFailed(error) {
        return error;
      }
    }

    function getGroups() {
      infoUser = $localStorage.infoUser;
      var show_group = "grupos-resume";
      return $http
        .get(url.IP + show_group)
        .then(getGroupsComplete)
        .catch(getGroupsFailed);

      function getGroupsComplete(response) {
        return response.data;
      }

      function getGroupsFailed(error) {
        return error;
      }
    }

    function getGroup(data) {
      if (!isNaN(Number(data.grupoId))) {
        data.grupoId = url.IP + "grupos/" + data.grupoId + "/";
      } else {
        data.grupoId = data.group;
      }
      return $http
        .get(data.grupoId)
        .then(getGroupComplete)
        .catch(getGroupFailed);

      function getGroupComplete(response) {
        return response.data;
      }

      function getGroupFailed(error) {
        return error;
      }
    }

    function getFiles(data) {
      return fileService.getFiles(data.grupoId + "archivos/");
      /*return $http.get(data.grupoId + 'archivos/')
                .then(getFilesComplete)
                .catch(getFilesFailed);

            function getFilesComplete(response) {
                return response.data.results;
            }

            function getFilesFailed(error) {
                ////console.log('getFilesFailed', error);
                return error;
            }*/
    }

    //UPDATE
    function updateGroup(data) {
      return $http
        .put(url.IP + "grupos/" + data.id + "/", data)
        .then(updateGroupComplete)
        .catch(updateGroupFailed);

      function updateGroupComplete(response) {
        return response;
      }

      function updateGroupFailed(error) {
        return error;
      }
    }

    //DELETE
    function deleteGroup(obj) {
      return $http
        .delete(obj.url)
        .then(deleteGroupComplete)
        .catch(deleteGroupFailed);

      function deleteGroupComplete(response, status, headers, config) {
        //jshint ignore:line
        return response;
      }

      function deleteGroupFailed(response, status, headers, config) {
        //jshint ignore:line
      }
    }
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("GrupoInfoCtrl", GrupoInfoCtrl);

  GrupoInfoCtrl.$inject = [
    "ContratanteService",
    "$localStorage",
    "$state",
    "$stateParams",
    "$uibModal",
    "$scope",
    "groupService",
    "$sessionStorage",
    "SweetAlert",
    "toaster",
    "helpers",
    "FileUploader",
    "generalService",
    "fileService",
    "$http",
    "url",
    "exportFactory",
  ];

  function GrupoInfoCtrl(
    ContratanteService,
    $localStorage,
    $state,
    $stateParams,
    $uibModal,
    $scope,
    groupService,
    $sessionStorage,
    SweetAlert,
    toaster,
    helpers,
    FileUploader,
    generalService,
    fileService,
    $http,
    url,
    exportFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var currentOrg =
      usr && usr.org && usr.org.urlname
        ? usr.org.urlname
        : usr.urlname || usr.orgname || "";

    $scope.deleteFile = deleteFile;
    delete $localStorage.group;
    var vm = this;
    vm.user = usr;
    /** Uploader files */
    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));
    vm.org_name = currentOrg;
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            } else if (acc.permission_name == "Eliminar grupos") {
              if (acc.checked == true) {
                vm.acceso_del_group = true;
              } else {
                vm.acceso_del_group = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }

    function exportGroupComments() {
      if (!vm.groupId || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
      };

      var params = {
        model: 8,
        id_model: vm.groupId,
      };
      if (currentOrg) {
        params.org = currentOrg;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: params,
          downloadName: "bitacora-grupo-" + vm.groupId + ".xlsx",
          token: token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }
    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        // owner: $scope.userInfo.id
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    vm.groups = [];
    vm.contact_group = []; //jshint ignore:line
    // vm.editGroup = editGroup;
    vm.openModalDeleteGroup = openModalDeleteGroup;
    vm.checkType = checkType;

    activate();

    function activate() {
      vm.groupId = $stateParams.grupoId;
      groupService.getGroup($stateParams).then(function (data) {
        vm.group = data;
        if (vm.group.responsable) {
          $http.get(vm.group.responsable).then(function success(response) {
            vm.group.responsable = response.data;
          });
        }
        ContratanteService.getContratantesByGroup(vm.group.id).then(function (
          res
        ) {
          var contractors = [];
          res.results.forEach(function (contratante, index) {
            if (contratante.phone_number) {
              var phone_number = contratante.phone_number
                .replace(/^\D+/g, "")
                .replace("'}", "");
              contratante.phone_number = phone_number;
            }
            contractors.push(contratante);
          });
          vm.groupsNatural = contractors;
          vm.config_pagination = res;
          $scope.show_pagination = true;
        });
        vm.contact_group = data.contact_group;
        return vm.groups;
      });
      getFiles();

      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 8,
          id_model: vm.groupId,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            next: request.data.next,
            previous: request.data.previous,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }

    $scope.deleteGroup = function (url) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Se eliminara la información",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            if (vm.groupsNatural == undefined) {
              vm.groupsNatural = [];
            }
            if (!vm.groupsNatural.length) {
              $http.delete(url).then(function success(response) {
                if (response.status == 204) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "Se ha eliminado el grupo",
                    "success"
                  );
                  $state.go("grupos.grupos");
                }
              });
            } else {
              SweetAlert.swal(
                "Error",
                "No se puede eliminar un grupo que contiene contratantes",
                "error"
              );
            }
          }
        }
      );
    };

    function getFiles() {
      return groupService.getFiles($stateParams).then(function (data) {
        if (!data.detail) {
          vm.files = data;
        } else {
        }
      });
    }

    // Check data and redirect to contractor editor
    function checkType(type) {
      return helpers.checkType(type);
    }

    // function editGroup(data){
    //     $localStorage.group = data;
    // }

    // Delete group
    function openModalDeleteGroup() {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "templates/delete.html",
        controller: ModalInstanceCtrl,
        //windowClass: 'animated fadeIn'
      });
    }

    function ModalInstanceCtrl($scope, $uibModalInstance) {
      $scope.name = "grupo";
      $scope.ok = function () {
        return groupService.deleteGroup(vm.group).then(function (data) {
          $uibModalInstance.close();
          $state.go("grupos.grupos");
        });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    function deleteFile(file) {
      fileService.deleteFile(file, vm.files);
    }

    $scope.editSubroup = function (param) {
      $scope.edit_subgroup = true;
      $scope.sub_group = angular.copy(param);
    };

    $scope.edit_subgroup = false;
    $scope.subgroups = [];
    $scope.sub_subgroups = [];

    $scope.addSubgroups = function () {
      var obj = { group_name: "", observations: "", sub_subgroup: [] };
      $scope.subgroups.push(obj);
    };

    $scope.deleteSubgroup = function (index) {
      $scope.subgroups.splice(index, 1);
    };

    $scope.addSubsubgroups = function () {
      var obj = { group_name: "", observations: "", sub_subgroup: [] };
      $scope.sub_group.subsubgrupos.push(obj);
    };

    $scope.deleteSubsubgroup = function (param, index) {
      if (param.url) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "Se eliminara la información",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            closeOnConfirm: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http.delete(param.url).then(function success(response) {
                if (response.status == 204) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "Se ha eliminado exitosamante.",
                    "success"
                  );
                }
              });
              $scope.sub_group.subsubgrupos.splice(index, 1);
            }
          }
        );
      } else {
        $scope.sub_group.subsubgrupos.splice(index, 1);
      }
    };

    $scope.returnSub = function () {
      $scope.edit_subgroup = false;
    };

    $scope.upgrade = function () {
      $http
        .patch($scope.sub_group.url, {
          group_name: $scope.sub_group.group_name,
        })
        .then(function success(request) {
          $scope.sub_group.subsubgrupos.forEach(function (item, index) {
            if (item.url) {
              $http
                .patch(item.url, { group_name: item.group_name })
                .then(function success(request) {})
                .catch(function (e) {
                  console.log(e);
                });
            } else {
              var datas = {
                group_name: item.group_name,
                responsable: vm.group.responsable.url,
                parent: $scope.sub_group.url,
                type_group: 3,
              };

              $http({
                method: "POST",
                url: url.IP + "grupos/",
                data: datas,
              })
                .then(function (request) {
                  if (request.status === 200 || request.status === 201) {
                  }
                })
                .catch(function (e) {
                  console.log("e", e);
                });
            }

            if ($scope.sub_group.subsubgrupos.length == index + 1) {
              $scope.returnSub();
              $state.reload();
            }
          });
        })
        .catch(function (e) {
          console.log(e);
        });
    };
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("GrupoEditCtrl", GrupoCtrl);

  GrupoCtrl.$inject = [
    "$scope",
    "$stateParams",
    "$state",
    "$uibModal",
    "$localStorage",
    "$timeout",
    "groupService",
    "contactService",
    "generalService",
    "$sessionStorage",
    "dataFactory",
    "toaster",
    "FileUploader",
    "fileService",
    "MESSAGES",
    "helpers",
    "SweetAlert",
    "$http",
  ];

  function GrupoCtrl(
    $scope,
    $stateParams,
    $state,
    $uibModal,
    $localStorage,
    $timeout,
    groupService,
    contactService,
    generalService,
    $sessionStorage,
    dataFactory,
    toaster,
    FileUploader,
    fileService,
    MESSAGES,
    helpers,
    SweetAlert,
    $http
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    var vm = this;
    vm.save = save;
    vm.cancel = cancel;
    vm.openModal = openModal;

    // Contacts
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;
    vm.user = usr;
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    /** Upload files  */
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    setTimeout(function () {
      var nums = [];
      $(".telefono").each(function () {
        var actual = $(this);
        nums.push(actual);
      });

      vm.form.contact_group.forEach(function (contacto, index) {});
    }, 500);

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) {
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
      $timeout(function () {
        $state.go("grupos.grupos");
      }, 1500);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    activate();

    function activate() {
      dataFactory.get("usuarios/").then(function (user) {
        $scope.users = user.data.results;
        $scope.show_pagination = true;

        groupService.getGroup($stateParams).then(function (group) {
          vm.form = group;
          $http.get(vm.form.responsable).then(function success(response) {
            vm.form.responsable = response.data;
          });
        });
        getFiles();
      });
    }

    function addContact() {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
      }; //jshint ignore:line
      vm.form.contact_group.push(contact); //jshint ignore:line
    }

    function deleteContacts(url, index) {
      $localStorage.indx = index;
      $localStorage.urll = url;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/grupos/grupos.deleteContact.html",
        controller: ModalInstanceCtrlDeleteContact,
        //windowClass: 'animated fadeIn'
      });
    }

    function ModalInstanceCtrlDeleteContact($scope, $uibModalInstance) {
      var index = $localStorage.indx;
      var url = $localStorage.urll;
      $scope.ok = function () {
        if ((url && index) || (url && !index)) {
          if (usr.permiso.eliminar) {
            try {
              return contactService.deleteContact(url).then(function () {
                vm.form.contact_group.splice(index, 1); //jshint ignore:line
                SweetAlert.swal("ERROR", MESSAGES.ERROR.DELETECONTACT, "error");
                $uibModalInstance.dismiss("cancel");
              });
            } catch (err) {
              throw err; // toaster.error('Agregue al menos un contacto' + err.message);
            }
            $uibModalInstance.dismiss("cancel");
          } else {
            SweetAlert.swal(
              "Oops...",
              "No tienes permiso para eliminar registros",
              "error"
            );
          }
        } else {
          vm.form.contact_group.splice(index, 1);
        }
        $uibModalInstance.dismiss("cancel");
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function openModal() {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "templates/delete.html",
        controller: ModalInstanceCtrl,
        //windowClass: 'animated fadeIn'
      });
    }

    function ModalInstanceCtrl($scope, $uibModalInstance) {
      $scope.name = "grupo";
      $scope.ok = function () {
        return groupService.deleteGroup(vm.form).then(function () {
          $uibModalInstance.close();
          $state.go("grupos.grupos");
        });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    function getFiles() {
      // return generalService.getFiles($stateParams.grupoId)
      return groupService.getFiles($stateParams).then(function (data) {
        if (data) {
        }
        vm.files = data;
      });
    }

    function save() {
      var flag = false;
      var name = vm.form.group_name;
      var bd_group_name = [];

      var form = angular.copy(vm.form);
      if (form.responsable) {
        if (form.responsable.url) {
          form.responsable = form.responsable.url;
        } else {
          form.responsable = form.responsable;
        }
      }
      // if (!helpers.hasAtLeastOneContact(vm.form.contact_group)) {
      //     toaster.error(MESSAGES.ERROR.ADDATLEASTONECONTACT);
      //     return;
      // }

      if (form.group_name.length > 70) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORGROUPMAX, "error");
      }

      return groupService.updateGroup(form).then(function (data) {
        if (data.status === 200) {
          var nums = [];
          $(".telefono").each(function (telefono) {
            var actual = $(this);
            // var valActual = $(this).val();
            nums.push(actual);
          });

          form.contact_group.forEach(function (elem, index) {
            //jshint ignore:line
            if (
              !validateEmail(elem.email) ||
              !elem.name ||
              !elem.phone_number
            ) {
              SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
              flag = true;
              return;
            }
            elem.group = data.data.url;

            if (!elem.url) {
              contactService.createContact(elem);
            } else {
              contactService.updateContact(elem);
            }
          });
          if (flag) {
            return;
          }
          $scope.userInfo = {
            id: data.data.id,
          };
          $scope.userInfo.url = $scope.uploader.url =
            data.data.url + "archivos/";
          $scope.uploader.uploadAll();
          toaster.success("Se han guardado correctamente sus cambios");
          getFiles();

          $state.go("grupos.grupos");
        }
      });
    }

    function cancel() {
      $state.go("grupos.info", { grupoId: vm.form.id });
    }

    $scope.deleteFile = deleteFile;

    function deleteFile(file) {
      fileService.deleteFile(file, vm.files);
    }

    $scope.openModalGroup = function (level) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/grupos/grupos.form.html",
        controller: ModalInstanceCtrl,
        resolve: {
          level: function () {
            return level;
          },
          group: function () {
            return level == 2 ? vm.form : {};
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    };

    function ModalInstanceCtrl($scope, $uibModalInstance, level, group, url) {
      $scope.level = level;
      $scope.groupForm = {};
      $scope.subgroupForm = {};
      $scope.subgroups = [];
      $scope.sub_subgroups = [];

      $scope.addSubgroups = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        $scope.subgroups.push(obj);
      };

      $scope.deleteSubgroup = function (index) {
        $scope.subgroups.splice(index, 1);
      };

      $scope.addSubsubgroups = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        $scope.sub_subgroups.push(obj);
      };

      $scope.deleteSubsubgroup = function (index) {
        $scope.sub_subgroups.splice(index, 1);
      };

      $http.get(url.IP + "usuarios/").then(function (user) {
        $scope.users = user.data.results;

        $scope.show_pagination = true;
      });

      $scope.changeResponsable = function (data, type) {
        $scope.responsables_natural = [];
        $scope.responsables_juridical = [];
        if (type == 1) {
          $scope.responsables_natural.push(data);
        } else {
          $scope.responsables_juridical.push(data);
        }
      };

      $scope.oksub = function () {
        if (!group.responsable) {
          SweetAlert.swal("ERROR", "Selecciona un responsable.", "error");
          return;
        }
        $scope.subgroupForm.responsable = group.responsable.url;
        $scope.subgroupForm.parent = group.url;
        $scope.subgroupForm.type_group = 2;

        $http({
          method: "POST",
          url: url.IP + "grupos/",
          data: $scope.subgroupForm,
        })
          .then(function (request) {
            if (request.status === 200 || request.status === 201) {
              if ($scope.sub_subgroups.length > 0) {
                $scope.sub_subgroups.forEach(function (item) {
                  var datas = {
                    group_name: item.group_name,
                    responsable: group.responsable.url,
                    parent: request.data.url,
                    type_group: 3,
                  };

                  $http({
                    method: "POST",
                    url: url.IP + "grupos/",
                    data: datas,
                  })
                    .then(function (request) {
                      if (request.status === 200 || request.status === 201) {
                      }
                    })
                    .catch(function (e) {
                      console.log("e", e);
                    });
                });
              }
              SweetAlert.swal(
                "¡Listo!",
                "Subgrupo creado exitosamente.",
                "success"
              );
              $scope.cancel();
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
          $("#modalContratate")
            .parent()
            .parent()
            .parent()
            .css("display", "block");
        }
      };
    }
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("GrupoCtrl", GrupoCtrl);

  GrupoCtrl.$inject = [
    "url",
    "$scope",
    "$localStorage",
    "$timeout",
    "$state",
    "$q",
    "groupService",
    "contactService",
    "helpers",
    "MESSAGES",
    "toaster",
    "FileUploader",
    "$sessionStorage",
    "$http",
    "SweetAlert",
    "exportFactory",
  ];

  function GrupoCtrl(
    url,
    $scope,
    $localStorage,
    $timeout,
    $state,
    $q,
    groupService,
    contactService,
    helpers,
    MESSAGES,
    toaster,
    FileUploader,
    $sessionStorage,
    $http,
    SweetAlert,
    exportFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    delete $localStorage.group;

    $scope.uploader = new FileUploader();

    var vm = this;
    vm.groups = [];
    vm.pageTitle = "Grupos";
    vm.submit = submit;
    vm.editGroup = editGroup;
    vm.showData = [];
    vm.showInfo = showInfo;
    vm.buttonReport = false;
    vm.form = {
      group_name: "",
      description: "",
      contact_group: [],
    };
    vm.user = usr;
    //Contacts
    vm.deleteContacts = deleteContacts;
    vm.saveLocalstorage = saveLocalstorage;
    vm.addContact = addContact;
    vm.searchGroups = searchGroups;
    vm.activate = activate;
    vm.search = search;
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    $scope.infoUser = $sessionStorage.infoUser;

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    $scope.exportData = function (group) {
      var data = {};
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      // // $scope.excel_groups = 'v2/contratantes/reporte-grupos/';
      // $scope.excel_groups = 'service_reporte-v2-grupo-excel'
      $scope.excel_groups = "service_reporte-grupo-excel";
      $http({
        method: "POST",
        url: url.IP + $scope.excel_groups,
        data: data,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte Grupos.xls");
        } else {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDOWNLOADREP, "error");
        }
      });
      // $http.get(url.IP + $scope.excel_groups)
      // .then(
      //     function success(request) {
      //         exportFactory.excel(request.data, 'Grupos')
      //     },
      //     function error(error) {
      //         console.log('error', error);
      //     }
      // )
      // .catch(function(e) {
      //     console.log(e);
      // })
    };

    // activate();

    $http.get(url.IP + "usuarios/").then(function (user) {
      $scope.users = user.data.results;

      $scope.show_pagination = true;
      activate();
    });

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function submit() {
      if (vm.groups_results.length) {
        vm.groups_results.forEach(function (item) {
          if (item.label == vm.form.group_name.val) {
            SweetAlert.swal(
              {
                title: "¡El grupo ya existe!",
                type: "warning",
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                closeOnConfirm: true,
              },
              function (isConfirm) {
                if (isConfirm) {
                  return;
                }
              }
            );
          } else {
            saveGroup();
          }
        });
      } else {
        saveGroup();
      }

      $localStorage.grupos = {};
    }

    function saveGroup() {
      if (!vm.form.responsable) {
        SweetAlert.swal("ERROR", "Selecciona un responsable.", "error");
        return;
      }
      var flag_item = false;
      $scope.subgroups.forEach(function (item, index) {
        if (!item.group_name) {
          flag_item = true;
          SweetAlert.swal(
            "ERROR",
            "Agrega el nombre del subgrupo " + (index + 1) + ".",
            "error"
          );
        }
      });
      if (flag_item) {
        return;
      }
      var name = vm.form.group_name.val;

      var bd_group_name = [];
      var flag = false;

      if (flag) {
        return;
      }

      vm.form.group_name = name;
      var form = angular.copy(vm.form);
      var arr = [];

      vm.form.contact_group.forEach(function (elem) {
        arr.push(elem);
      });

      form.contact = arr;
      if (vm.form.responsable) {
        if (vm.form.responsable.url) {
          form.responsable = vm.form.responsable.url;
        } else {
          form.responsable = vm.form.responsable;
        }
      }
      return groupService.createGroup(form).then(function (data) {
        if (!data) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORCREATEGROUP, "error");
        } else {
          form.contact.forEach(function (contact) {
            if (contact.phone_number.length > 15) {
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.MINIMUMPHONELENGTH,
                "error"
              );
              flag = true;
              return;
            }

            if (
              !validateEmail(contact.email) ||
              !contact.name ||
              !contact.phone_number
            ) {
              SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
              flag = true;
              return;
            }
            contact.group = data.data.url;
            contactService.createContact(contact);
          });

          if (flag) {
            return;
          }

          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWGROUP, "success");
          $localStorage.grupos = {};
          if (vm.acceso_ver_cont) {
            $state.go("grupos.grupos");
          } else {
            $state.go("index.main");
          }
          $scope.userInfo = {
            id: data.data.id,
          };
          $scope.userInfo.url = $scope.uploader.url =
            data.data.url + "archivos/";
          $q.when()
            .then(function () {
              var defer = $q.defer();
              defer.resolve($scope.uploader.uploadAll());
              return defer.promise;
            })
            .then(function () {
              $timeout(function () {
                // $state.go('index.main');
                if (vm.acceso_ver_cont) {
                  $state.go("grupos.grupos");
                } else {
                  $state.go("index.main");
                }
              }, 1000);
            });

          if ($scope.subgroups.length > 0) {
            $scope.subgroups.forEach(function (item) {
              var datas = {
                group_name: item.group_name,
                responsable: data.data.responsable,
                parent: data.data.url,
                type_group: 2,
              };

              $http({
                method: "POST",
                url: url.IP + "grupos/",
                data: datas,
              })
                .then(function (request) {
                  if (request.status === 200 || request.status === 201) {
                    if (item.sub_subgroup.length > 0) {
                      item.sub_subgroup.forEach(function (sub) {
                        var data_sub = {
                          group_name: sub.group_name,
                          responsable: data.data.responsable,
                          parent: request.data.url,
                          type_group: 3,
                        };

                        $http({
                          method: "POST",
                          url: url.IP + "grupos/",
                          data: data_sub,
                        })
                          .then(function (response) {
                            if (
                              response.status === 200 ||
                              response.status === 201
                            ) {
                            }
                          })
                          .catch(function (e) {
                            console.log("e", e);
                          });
                      });
                    }
                  }
                })
                .catch(function (e) {
                  console.log("e", e);
                });
            });
          }
          $state.go("grupos.info", { grupoId: data.data.id });
        }
      });

      return;
    }
    $scope.changeResponsable = function (data) {
      vm.form.responsable = data;
    };
    vm.changeResponsable1 = changeResponsable1;
    function changeResponsable1(data) {
      $scope.users.forEach(function (item) {
        if (item.url == data) {
          vm.form.responsable = item;
        }
      });
    }
    function activate() {
      vm.buttonReport = false;
      $localStorage["grupos"] = $localStorage["grupos"]
        ? $localStorage["grupos"]
        : {};
      vm.form.group_name = $localStorage["grupos"]["group_name"];
      vm.form.responsable = $localStorage["grupos"]["responsable"];
      vm.form.description = $localStorage["grupos"]["description"];
      $scope.subgroups = $localStorage["grupos"]["subgroups"]
        ? $localStorage["grupos"]["subgroups"]
        : [];
      vm.form.contact_group = $localStorage["grupos"]["contact_group"]
        ? $localStorage["grupos"]["contact_group"]
        : [];
      $scope.cadena = $localStorage["grupos"]["cadena"];
      vm.groups = $localStorage["grupos"]["groups"]
        ? $localStorage["grupos"]["groups"]
        : [];
      vm.groups_results = $localStorage["grupos"]["groups_results"]
        ? $localStorage["grupos"]["groups_results"]
        : [];
      changeResponsable1(vm.form.responsable);
      getGroups();
    }
    function saveLocalstorage() {
      $localStorage["grupos"] = $localStorage["grupos"]
        ? $localStorage["grupos"]
        : {};
      $localStorage["grupos"]["group_name"] = vm.form.group_name;
      $localStorage["grupos"]["responsable"] = vm.form.responsable;
      $localStorage["grupos"]["description"] = vm.form.description
        ? vm.form.description
        : "";
      $localStorage["grupos"]["subgroups"] = $scope.subgroups
        ? $scope.subgroups
        : [];
      $localStorage["grupos"]["contact_group"] = vm.form.contact_group
        ? vm.form.contact_group
        : [];
      $localStorage["grupos"]["cadena"] = $scope.cadena;
      $localStorage["grupos"]["groups"] = vm.groups ? vm.groups : [];
      $localStorage["grupos"]["groups_results"] = vm.groups_results;
    }
    function returnToGroup(param) {
      if (param) {
        vm.show_binnacle = false;
      } else {
        vm.show_binnacle = false;
      }
    }

    vm.showBinnacle = showBinnacle;
    vm.returnToGroup = returnToGroup;
    //-----------------------------------------------------------comments
    function showBinnacle(param) {
      vm.show_binnacle = true;
      vm.group_id = param.id;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 8,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }
    //-------------------------------------------------------------comments

    function searchGroups(param) {
      vm.show_binnacle = false;
      if (param) {
        $http
          .post(url.IP + "groups-match/", {
            word: param.val,
          })
          .then(
            function success(request) {
              vm.groups_results = [];
              if (request.status === 200) {
                request.data.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.group_name,
                  };

                  vm.groups_results.push(obj);
                });
              }
            },
            function error(error) {
              console.log("error - groups", error);
            }
          )
          .catch(function (e) {
            console.log("error - groups", e);
          });
      }
    }
    function search(cadena) {
      $scope.param_cadena = cadena;
      if (cadena.length) {
        vm.show_binnacle = false;
        $scope.show_pagination = false;
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //     $scope.search_group = 'v2/generics/seeker-groups/';
        $scope.search_group = "seeker-groups/";
        $http({
          method: "GET",
          url: url.IP + $scope.search_group,
          params: {
            cadena: cadena,
          },
        })
          .then(
            function success(request) {
              vm.groups = [];
              if (request.status === 200 && request.data.results.length) {
                vm.groups = request.data.results;
                vm.config_pagination = request.data;
                $scope.show_pagination = true;

                vm.groups.forEach(function (r) {
                  if (r.responsable) {
                    $http
                      .get(r.responsable)
                      .then(
                        function success(request) {
                          if (request.status === 200) {
                            r.responsable = request.data;
                          }
                        },
                        function error(error) {}
                      )
                      .catch(function (e) {
                        console.log(e);
                      });
                  }
                });
              } else {
                toaster.warning("No se encontraron registros");
              }
              vm.buttonReport = true;
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else {
        vm.groups = [];
      }
    }

    function getGroups() {
      vm.groups = [];
      vm.show_binnacle = false;
      return groupService.getTableGroups().then(function (data) {
        //vm.groups = data;
        vm.groups = data.data.results;
        vm.groups.forEach(function (r) {
          if (r.responsable) {
            $http
              .get(r.responsable)
              .then(
                function success(request) {
                  if (request.status === 200) {
                    r.responsable = request.data;
                  }
                },
                function error(error) {}
              )
              .catch(function (e) {
                console.log(e);
              });
          }
        });

        vm.config_pagination = data.config;
        $scope.show_pagination = true;
      });
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   var search_group = 'v2/generics/seeker-groups/';
      var search_group = "seeker-groups/";
      $http({
        method: "GET",
        url: url.IP + search_group,
        params: {
          cadena: "",
        },
      })
        .then(
          function success(data) {
            vm.groups = data.data.results;
            vm.config_pagination = data.data;
            vm.groups.forEach(function (r) {
              if (r.responsable) {
                $http
                  .get(r.responsable)
                  .then(
                    function success(request) {
                      if (request.status === 200) {
                        r.responsable = request.data;
                      }
                    },
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              }
            });
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }

    $scope.goToGroup = function (id) {
      $state.go(grupos.info({ grupoId: id }));
    };

    function editGroup(data) {
      $localStorage.group = data;
    }

    $scope.exportDataSeeker = function (param) {
      var data = { cadena: $scope.param_cadena };
      if (param == 1) {
        // naturales seeker

        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //     // $scope.excel_groups_seeker = 'v2/contratantes/reporte-seekerGrupos/';
        //     $scope.excel_groups_seeker = 'service_reporte-v2-seekerGrupos-excel';
        $scope.excel_groups_seeker = "service_reporte-seekerGrupos-excel";
        $http({
          method: "POST",
          url: url.IP + $scope.excel_groups_seeker,
          data: data,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function (data, status, headers, config) {
          if (data.status == 200) {
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte Grupos.xls");
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDOWNLOADREP, "error");
          }
        });
        // $http({
        //   method: 'GET',
        //   url: url.IP + $scope.excel_groups_seeker,
        //   params: data
        // })
        // .then(function (request) {
        //   if(request.status === 200) {
        //       exportFactory.excel(request.data, 'Grupos');
        //   }

        // })
        // .catch(function (e) {
        //   console.log('e', e);
        // });
      }
    };

    function showInfo(data) {
      var concatArr = data.natural_group.concat(data.juridical_group); //jshint ignore:line
      vm.showData = concatArr;
    }

    // Contacts
    function deleteContacts(index) {
      vm.form.contact_group.splice(index, 1); //jshint ignore:line
    }

    function addContact() {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
      }; //jshint ignore:line
      vm.form.contact_group.push(contact); //jshint ignore:line
    }

    $scope.subgroups = [];
    $scope.sub_subgroups = [];

    $scope.addSubgroups = function () {
      var obj = { group_name: "", observations: "", sub_subgroup: [] };
      $scope.subgroups.push(obj);
    };

    $scope.deleteSubgroup = function (index) {
      $scope.subgroups.splice(index, 1);
    };

    $scope.addSubsubgroups = function () {
      var obj = { group_name: "", observations: "", sub_subgroup: [] };
      $scope.sub_subgroups.push(obj);
    };

    $scope.deleteSubsubgroup = function (index) {
      $scope.sub_subgroups.splice(index, 1);
    };
  }
})();

/* global angular */
(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("FlotillasRenewalCtrl", FlotillasRenewalCtrl);

  FlotillasRenewalCtrl.$inject = [
    "$scope",
    "$http",
    "url",
    "$stateParams",
    "$sessionStorage",
    "MESSAGES",
    "SweetAlert",
    "$state",
    "providerService",
    "helpers",
    "dataFactory",
    "FileUploader",
    "formatValues",
    "$rootScope",
    "$localStorage",
    "$timeout",
    "coverageService",
    "datesFactory",
  ];

  function FlotillasRenewalCtrl(
    $scope,
    $http,
    url,
    $stateParams,
    $sessionStorage,
    MESSAGES,
    SweetAlert,
    $state,
    providerService,
    helpers,
    dataFactory,
    FileUploader,
    formatValues,
    $rootScope,
    $localStorage,
    $timeout,
    coverageService,
    datesFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    $scope.infoUser = $sessionStorage.infoUser;

    var order = this;
    $scope.showOt = true;
    $scope.showRenewal = false;
    $scope.caratula = {};
    $scope.layout = {};
    $rootScope.show_contractor = false;
    $scope.create_natural = true;
    $scope.create_juridical = true;
    $scope.claves = [];
    $scope.types = [
      { value: 1, label: "Abierta" },
      { value: 2, label: "Cerrada" },
    ];
    $scope.typeSelected = $scope.types[0];
    $scope.renewals = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.renewalSelected = $scope.renewals[0];
    $scope.currencys = [
      { value: 1, label: "Pesos" },
      { value: 2, label: "Dólares" },
      { value: 3, label: "UDI" },
      { value: 4, label: "Euros" },
    ];

    $scope.businessline = [
      { id: 1, name: "Comercial" },
      { id: 2, name: "Personal" },
      { id: 0, name: "Otro" },
    ];

    $scope.currencySelected = $scope.currencys[0].value;

    $scope.referenciadorArray = [];

    $scope.dataCaratula = [];

    $scope.contractorLayout = {};

    $scope.showTableCertificates = false;
    $scope.excelJson = [];
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certifcados = [];

    $scope.celulas = [];
    $scope.agrupaciones = [];
    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    // var myInsurance = $stateParams.myInsurance;
    // if(myInsurance.url){
    //   order  = {
    //     contratante : {}
    //   }

    //   order.contratante.value = $stateParams.myInsurance;
    //   if(order.contratante.value.email){
    //     order.contratante.value.email = $stateParams.myInsurance.email
    //   }
    // }

    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          order.acceso_polizas = perm;
          order.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                order.acceso_adm_pol = true;
              } else {
                order.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                order.acceso_ver_pol = true;
              } else {
                order.acceso_ver_pol = false;
              }
            }
          });
        }
        if (perm.model_name == "Formatos") {
          order.acceso_form = perm;
          order.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                order.acceso_form = true;
              } else {
                order.acceso_form = false;
              }
            }
          });
        }
        if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            }
          });
        }
        if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        }
        if (perm.model_name == "Comisiones") {
          order.coms = perm;
          order.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                order.permiso_comisiones = true;
              } else {
                order.permiso_comisiones = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                order.permiso_administrar_adjuntos = true;
              } else {
                order.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          order.acceso_ref = perm;
          order.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                order.acceso_ver_ref = true;
              } else {
                order.acceso_ver_ref = false;
              }
            }
          });
        }
      });
    }

    activate();

    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      $http
        .get(url.IP + "leer-polizas-info/" + $stateParams.polizaId)
        .then(function success(response) {
          if (response.status == 200) {
            if ($localStorage.save_renewal_flotilla) {
              if ($localStorage.save_renewal_flotilla.id == response.data.id) {
                $scope.caratula = $localStorage.save_renewal_flotilla;
              } else {
                $scope.copy_caratula = angular.copy(response.data);
                $scope.caratula = response.data;
              }
            } else {
              $scope.caratula = response.data;
            }
            $scope.copy_caratula = angular.copy(response.data);
            $scope.originalCaratula = angular.copy(response.data);
            $scope.caratula.poliza_number = "";
            $scope.startDate = datesFactory.convertDate(
              response.data.end_of_validity
            );
            var date_initial = datesFactory
              .convertDate(response.data.end_of_validity)
              .split("/");
            var day = date_initial[0];
            var month = date_initial[1];
            var year = parseInt(date_initial[2]);

            if ($scope.businessline && $scope.businessline.length > 0) {
              $scope.businessline.forEach(function (item) {
                if (item.id == response.data.business_line) {
                  $scope.lineaSelected = item;
                }
              });
            }

            if (day.length == 1) {
              day = "0" + day;
            }
            if (month.length == 1) {
              month = "0" + month;
            }

            $scope.endDate = datesFactory.convertDate(
              new Date(month + "/" + day + "/" + (year + 1))
            );
            // $scope.endDate = datesFactory.convertDate(response.data.end_of_validity);
            $scope.checkDate($scope.startDate);
            fillProvider();

            $scope.currencys.forEach(function (item1) {
              if (item1.value == $scope.caratula.f_currency) {
                $scope.currencySelected = item1.value;
                $scope.caratula.f_currency = item1.value;
              }
            });

            $scope.types.forEach(function (item) {
              if (item.value == $scope.caratula.type_policy) {
                $scope.typeSelected = item;
                $scope.caratula.type_policy = item.value;
              }
            });

            order.contratante = {};
            $scope.aseguradoraSelected = $scope.caratula.aseguradora;

            // if ($scope.caratula.juridical) {
            //   var url_aux = url.IP + 'morales-resume-medium/' + $scope.caratula.juridical + '/';
            // } else {
            //   var url_aux = url.IP + 'fisicas-resume-medium/' + $scope.caratula.natural + '/';
            // }
            // console.log('$scope.caratula.contractor', $scope.caratula.contractor);
            var get_contratante =
              $scope.caratula.contractor && $scope.caratula.contractor.id
                ? $scope.caratula.contractor.id
                : $scope.caratula.contractor;
            var url_aux =
              url.IP + "contractors-resume-medium/" + get_contratante + "/";
            $http({ method: "GET", url: url_aux })
              .then(
                function success(response) {
                  $scope.contratante = response.data;
                  // if ($scope.caratula.natural) {
                  //   $scope.addresses = $scope.contratante.address_natural;
                  //   $scope.contratante.address_natural.forEach(function(address){
                  //     if(address.id == $scope.caratula.address.id){
                  //       $scope.addressSelected = $scope.caratula.address;
                  //     }
                  //   });
                  //   order.contratante.val = $scope.contratante.full_name;
                  //   order.contratante.value = $scope.contratante;
                  // } else if ($scope.caratula.juridical) {
                  //   $scope.addresses = $scope.contratante.address_juridical;
                  //   $scope.contratante.address_juridical.forEach(function(address){
                  //     if(address.id == $scope.caratula.address.id){
                  //       $scope.addressSelected = $scope.caratula.address;
                  //     }
                  //   });
                  //   order.contratante.val = $scope.contratante.j_name;
                  //   order.contratante.value = $scope.contratante;
                  // }
                  if ($scope.caratula.contractor) {
                    $scope.caratula.address = $scope.copy_caratula.address;
                    $scope.addresses = $scope.contratante.address_contractor;
                    if (
                      $scope.contratante &&
                      $scope.contratante.address_contractor
                    ) {
                      $scope.contratante.address_contractor.forEach(function (
                        address
                      ) {
                        if (address.id == $scope.caratula.address.id) {
                          $scope.addressSelected = $scope.caratula.address;
                        }
                      });
                    }
                    order.contratante.val = $scope.contratante.full_name;
                    order.contratante.value = $scope.contratante;
                    $scope.contratante.direccion = $scope.caratula.address;
                  }
                },
                function error(response) {
                  console.log("error", response);
                }
              )
              .catch(function (e) {
                console.log("error", e);
              });

            // Referenciadores
            $http
              .get(url.IP + "get-vendors/")
              .then(function (user) {
                user.data.forEach(function (u) {
                  u.first_name = u.first_name.toUpperCase();
                  u.last_name = u.last_name.toUpperCase();
                  u.name =
                    u.first_name.toUpperCase() +
                    " " +
                    u.last_name.toUpperCase();
                });
                $scope.referenciadores = user.data;
                var vendedor = {
                  referenciador: "",
                  comision_vendedor: "",
                };
                $scope.referenciadorArray.push(vendedor);
              })
              .catch(function (e) {
                console.log("error", e);
              });
            if ($scope.caratula.ref_policy.length > 0) {
              $scope.caratula.ref_policy.forEach(function (refs) {
                $http
                  .get(refs.referenciador)
                  .then(function success(response_ref_plicy) {
                    if (response_ref_plicy) {
                      refs.data = response_ref_plicy.data;
                      refs.referenciador = response_ref_plicy.data.url;
                      refs.selectedRef = true;
                      $scope.referenciadorArray.push(refs);
                    }
                  });
              });
            }
            // $scope.allCertificates();
            $http
              .get(url.IP + "usuarios/")
              .then(function (user) {
                user.data.results.forEach(function (u) {
                  u.first_name = u.first_name.toUpperCase();
                  u.last_name = u.last_name.toUpperCase();
                  u.name =
                    u.first_name.toUpperCase() +
                    " " +
                    u.last_name.toUpperCase();
                });
                $scope.users = user.data.results;
                $scope.usersLay = user.data.results;
                if ($scope.caratula.responsable) {
                  $scope.users.forEach(function (item) {
                    if (item.id == $scope.caratula.responsable.id) {
                      $scope.responsableSelected = item.id;
                    }
                  });
                }
                if ($scope.caratula.collection_executive) {
                  $scope.users.forEach(function (item) {
                    if (item.id == $scope.caratula.collection_executive.id) {
                      $scope.ejecutivoCobranzaSelected = item.id;
                    }
                  });
                }

                $scope.getClaves($scope.aseguradoraSelected);
              })
              .catch(function (e) {
                console.log("error", e);
              });

            dataFactory
              .get("sucursales-to-show-unpag/")
              .then(function success(response) {
                if (response.status === 200 || response.status === 201) {
                  $scope.sucursalesLay = response.data;
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });

            dataFactory
              .post("celula_contractor_info/")
              .then(function (response) {
                $scope.celulas = response.data;
              });

            dataFactory.get("groupingLevel-resume/").then(function (response) {
              $scope.agrupaciones = response.data;
            });

            if ($scope.caratula.celula) {
              if ($scope.caratula.celula.id) {
                $http.get($scope.caratula.celula.url).then(function (response) {
                  $scope.celulaSelected = response.data;
                  $scope.changeCelula($scope.celulaSelected);
                });
              } else {
                $http.get($scope.caratula.celula).then(function (response) {
                  $scope.celulaSelected = response.data;
                  $scope.changeCelula($scope.celulaSelected);
                });
              }
            }

            if ($scope.caratula.grouping_level) {
              $http
                .get(
                  url.IP + "groupinglevel/" + $scope.caratula.grouping_level.id
                )
                .then(function (response) {
                  $scope.grouping_levelSelected = response.data;
                  $scope.info_sub = $scope.caratula;
                  $scope.changeAgrupacion($scope.grouping_levelSelected);
                });
            }
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    }

    $scope.save_info_tab = function () {
      $localStorage.save_edition_flotilla = angular.copy($scope.caratula);
    };

    function fillProvider() {
      var d = $scope.startDate;
      try {
        var day = d.getDate();
        var month = d.getMonth() + 1; //Months are zero based
        var year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var day = f.getDate();
        var month = f.getMonth() + 1; //Months are zero based
        var year = f.getFullYear();
      }

      var date = year + "-" + month + "-" + day;
      providerService.getProviderByKey(date).then(
        function success(data) {
          $scope.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    $scope.checkNumPolicy = function () {
      if ($scope.caratula.poliza_number) {
        helpers
          .existPolicyNumber($scope.caratula.poliza_number)
          .then(function (request) {
            if (request == true) {
              SweetAlert.swal("Error", MESSAGES.ERROR.POLICYEXIST, "error");
              $scope.caratula.poliza_number = "";
            }
          })
          .catch(function (err) {
            console.log("Error", err);
          });
      }
    };

    $scope.changeAddress = function (param) {
      $scope.caratula.address = param.id;
    };

    $scope.contratanteCreator = function () {
      $rootScope.show_contractor = true;
      $localStorage.orderForm = JSON.stringify($scope.caratula);
    };

    $scope.checkDate = function (param) {
      if (param.length == 10) {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.startDate = param;
        $scope.endDate = datesFactory.convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();

        if (process(param) > process($scope.endDate)) {
          SweetAlert.swal(
            "Error",
            "La fecha inicio no puede ser mayor a la fecha fin.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }
      } else {
        var day = new Date().getDate();
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();

        $scope.startDate = param;
        $scope.endDate = datesFactory.convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();
      }
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        $scope.caratula.end_of_validity = datesFactory.toDate(param);
      }
    };

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                // var juridicals = response.data.juridicals;
                // var naturals = response.data.naturals;

                // if(juridicals.length) {
                //   juridicals.forEach(function(item){
                //     var obj = {
                //       label: item.j_name,
                //       value: item
                //     };
                //     source.push(obj);
                //   });
                // }
                // if(naturals.length) {
                //   naturals.forEach(function(item){
                //     if (item.full_name) {
                //       var obj = {
                //         label: item.full_name,
                //         value: item
                //       };
                //     } else {
                //      var obj = {
                //         label: item.first_name + ' ' + item.last_name + ' ' + item.second_last_name,
                //         value: item
                //       };
                //     }
                //     source.push(obj);
                //   });
                // }
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if ($scope.referenciadores) {
          $scope.referenciadores.some(function (user) {
            if (user.url == order.contratante.value.vendor) {
              $scope.referenciadorArray[0] = {
                referenciador: user.url,
                comision_vendedor: "",
              };
            }
          });
        }
        if (order.contratante.value) {
          if (order.contratante.value.address_contractor) {
            $scope.caratula.contractor = order.contratante.value;
            $scope.addresses = order.contratante.value.address_contractor;

            if ($scope.addresses.length == 1) {
              $scope.addressSelected = $scope.addresses[0];
              $scope.caratula.address = $scope.addresses[0].url;
            }
          }
        }
      }
    });

    $scope.$watch(
      "order.searchContratante.value",
      function (newValue, oldValue) {
        if (order.searchContratante) {
          if (order.searchContratante.value.address_contractor) {
            $scope.contractorLayout.id = order.searchContratante.value.id;
            $scope.contractorLayout.name = order.searchContratante.val;
            $scope.contractorLayout.contractor = order.searchContratante.value;
            if (
              order.searchContratante.value.type_person == 1 ||
              order.searchContratante.value.type_person == "Física"
            ) {
              $scope.contractorLayout.type = 1;
              $scope.contractorLayout.address =
                order.searchContratante.value.address_contractor;
            } else {
              $scope.contractorLayout.type = 2;
              $scope.contractorLayout.address =
                order.searchContratante.value.address_contractor;
            }
          }
        }
      }
    );

    $scope.getClaves = function (param) {
      $scope.caratula.aseguradora = param;
      $scope.aseguradoraSelected = param;
      $scope.ramoSelected = null;
      $scope.subramoSelected = null;
      $scope.caratula.ramo = null;
      $scope.caratula.subramo = null;
      $http
        .get(url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id)
        .then(function success(clavesResponse) {
          $scope.claves = clavesResponse.data;
          if ($scope.claves.length == 1) {
            $scope.caratula.clave = $scope.claves[0].id;
            $scope.claveSelected = $scope.claves[0];
          } else {
            $scope.claves.forEach(function (item) {
              if (item.id == $scope.caratula.clave.id) {
                $scope.caratula.clave = item.id;
                $scope.claveSelected = item;
              }
            });
          }
        })
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      $http
        .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
        .then(
          function success(response) {
            $scope.ramos = response.data;
            $scope.ramos.forEach(function (item) {
              if (item.ramo_name == $scope.originalCaratula.ramo) {
                $scope.ramoSelected = item;
                $scope.caratula.ramo = item;
                $scope.subramos = item.subramo_ramo;
                $scope.subramos.forEach(function (subramo) {
                  if (subramo.subramo_name == $scope.originalCaratula.subramo) {
                    $scope.subramoSelected = subramo;
                    $scope.caratula.subramo = subramo;
                    $scope.layout = {
                      subramo: subramo,
                    };
                    $scope.getPackage();
                  }
                });
              }
            });
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    $scope.getPackage = function (paq) {
      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: $scope.ramoSelected.id,
          subramo: $scope.subramoSelected.id,
          provider: $scope.aseguradoraSelected.id,
        })
        .then(
          function success(response) {
            if (response.data.length) {
              $scope.paquetesLayout = response.data;
            } else {
              $scope.paquetesLayout = [];
            }
          },
          function error(e) {
            console.log("Error - paquetes-data-by-subramo", e);
            $scope.paquetesLayout = [];
          }
        )
        .catch(function (error) {
          console.log("Error - paquetes-data-by-subramo - catch", error);
          $scope.paquetesLayout = [];
        });
    };

    $scope.refreshProvider = function () {
      fillProvider();
    };

    $scope.changeClave = function (param) {
      if (param) {
        $scope.caratula.clave = param.id;
        $scope.claveSelected = param;
        if ($scope.caratula.subramo) {
          $scope.changeSubramo($scope.caratula.subramo);
        }
      }
    };

    $scope.changeRamo = function (param) {
      if (param) {
        $scope.caratula.ramo = param;
        $scope.ramoSelected = param;
        $scope.subramos = param.subramo_ramo;
        if (!$localStorage.save_renewal_flotilla) {
          $localStorage.save_renewal_flotilla = angular.copy($scope.caratula);
        }
        $localStorage.save_renewal_flotilla["ramo"] = param;
      }
    };

    $scope.changeSubramo = function (param) {
      if (param) {
        $scope.caratula.subramo = param;
        $scope.subramoSelected = param;
        $scope.layout.subramo = param;
        $scope.paqueteAll(param);
        if (!$localStorage.save_renewal_flotilla) {
          $localStorage.save_renewal_flotilla = angular.copy($scope.caratula);
        }
        $localStorage.save_renewal_flotilla["subramo"] = param;
      }
    };

    $scope.changeType = function (param) {
      $scope.caratula.type = param;
      if (!$localStorage.save_renewal_flotilla) {
        $localStorage.save_renewal_flotilla = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_flotilla["type"] = param;
    };

    $scope.changeResponsableLay = function (param) {
      $scope.responsableLay = param;
    };

    $scope.changeSucursalLay = function (param) {
      $scope.sucursalLay = param;
    };

    $scope.changeCurrency = function (param) {
      $scope.caratula.f_currency = param;
      if (!$localStorage.save_renewal_flotilla) {
        $localStorage.save_renewal_flotilla = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_flotilla["f_currency"] = param;
    };

    $scope.changeRenewal = function (param) {
      $scope.caratula.is_renewable = param.value;
      if (!$localStorage.save_renewal_flotilla) {
        $localStorage.save_renewal_flotilla = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_flotilla["is_renewable"] = param;
    };

    $scope.changeResponsable = function (param) {
      $scope.caratula.responsable = param;
      if (!$localStorage.save_renewal_flotilla) {
        $localStorage.save_renewal_flotilla = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_flotilla["responsable"] = param;
    };

    $scope.changeEjecutivoCobranza = function (param) {
      $scope.users.forEach(function (item) {
        if (item.id == param) {
          $scope.caratula.collection_executive = item;
          if (!$localStorage.save_renewal_flotilla) {
            $localStorage.save_renewal_flotilla = angular.copy($scope.caratula);
          }
          $localStorage.save_renewal_flotilla["collection_executive"] = param;
        }
      });
    };

    $scope.changeCelula = function (param) {
      $scope.caratula.celula = param.id;
      if (!$localStorage.save_renewal_flotilla) {
        $localStorage.save_renewal_flotilla = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_flotilla["celula"] = param;
    };

    $scope.changeAgrupacion = function (data) {
      $scope.sub_asignaciones = data.subgrupos;
      $scope.caratula.groupinglevel = data.id;
      if ($scope.info_sub.subgrouping_level) {
        $http
          .get(url.IP + "groupinglevel/" + $scope.info_sub.subgrouping_level.id)
          .then(function (response) {
            $scope.subgroupingSelected = response.data;
            $scope.sub_asignaciones.forEach(function (item) {
              if (item.id == $scope.subgroupingSelected.id) {
                $scope.changeSubagrupacion(item);
              }
            });
          });
      }
    };

    $scope.changeSubagrupacion = function (data) {
      if (data.subsubgrupos) {
        $scope.sub_subasignaciones = data.subsubgrupos;
        $scope.caratula.groupinglevel = data.id;
        if ($scope.info_sub.subsubgrouping_level) {
          $http
            .get(
              url.IP +
                "groupinglevel/" +
                $scope.info_sub.subsubgrouping_level.id
            )
            .then(function (response) {
              $scope.subsubgroupingSelected = response.data;
              $scope.caratula.groupinglevel = response.data.id;
            });
        }
      }
    };

    $scope.changeSubsubagrupacion = function (data) {
      $scope.caratula.groupinglevel = data.id;
    };

    $scope.addReferenciador = function () {
      var addReferenciadores = {
        referenciador: "",
        comision_vendedor: "",
      };
      $scope.referenciadorArray.push(addReferenciadores);
    };

    $scope.changeComRef = function (param, index, com) {
      $scope.referenciadorArray[index].comision_vendedor = param;
      if (com.comision_vendedor > 100) {
        com.comision_vendedor = 0;
      } else if (com.comision_vendedor < 0) {
        com.comision_vendedor = 0;
      }
      $scope.checkTotalComision(com);
    };
    $scope.checkTotalComision = function (item) {
      var totalComision = $scope.referenciadorArray.reduce(function (
        sum,
        item
      ) {
        return sum + (parseFloat(item.comision_vendedor) || 0); // Convert to number, default to 0 if undefined
      },
      0);
      if (totalComision > 100) {
        $scope.comisionError =
          "La suma de las comisiones no puede superar el 100%";
        item.comision_vendedor = 0;
      } else {
        $scope.comisionError = null; // No error if total is within limit
      }
    };
    $scope.deleteReferenciador = function (index) {
      $scope.referenciadorArray.splice(index, 1);
    };

    $scope.validityInsurance = function () {
      var lb = Ladda.create(document.querySelector(".ladda-buttoncrear"));
      lb.start();
      if (!$scope.aseguradoraSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        lb.stop();
        return;
      }
      if (!$scope.caratula.poliza_number) {
        SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
        lb.stop();
        return;
      }
      if (!$scope.caratula.identifier) {
        SweetAlert.swal("Error", MESSAGES.ERROR.IDENTIFIERREQUIRED, "error");
        lb.stop();
        return;
      }
      if (!order.contratante.val) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        lb.stop();
        return;
      }
      if (!$scope.caratula.address) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        lb.stop();
        return;
      }
      if (!$scope.caratula.clave) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        lb.stop();
        return;
      }
      if (!$scope.ramoSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        lb.stop();
        return;
      }
      if (!$scope.subramoSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        lb.stop();
        return;
      }
      $scope.saveInsurance();
    };

    $scope.saveInsurance = function () {
      var lb = Ladda.create(document.querySelector(".ladda-buttoncrear"));
      lb.start();
      if ($scope.caratula.celula) {
        if ($scope.caratula.celula.id) {
          $scope.caratula.celula = $scope.caratula.celula.id;
        }
      }
      $scope.caratula.address = $scope.addressSelected
        ? $scope.addressSelected.id
        : $scope.caratula.address.id;
      $scope.caratula.aseguradora = $scope.aseguradoraSelected
        ? $scope.aseguradoraSelected.id
        : $scope.caratula.aseguradora.id;
      $scope.caratula.ramo = $scope.ramoSelected
        ? $scope.ramoSelected.id
        : $scope.caratula.ramo.id;
      $scope.caratula.subramo = $scope.subramoSelected
        ? $scope.subramoSelected.id
        : $scope.caratula.subramo.id;
      $scope.caratula.type = $scope.caratula.type
        ? $scope.caratula.type
        : $scope.typeSelected
        ? $scope.typeSelected.value
        : 1;
      $scope.caratula.f_currency = $scope.caratula.f_currency
        ? $scope.caratula.f_currency
        : $scope.currencySelected
        ? $scope.currencySelected
        : 1;
      $scope.caratula.is_renewable = $scope.caratula.is_renewable
        ? $scope.caratula.is_renewable
        : $scope.renewalSelected
        ? $scope.renewalSelected.value
        : null;
      $scope.caratula.responsable =
        $scope.caratula.responsable && $scope.caratula.responsable.id
          ? $scope.caratula.responsable.id
          : $scope.caratula.responsable
          ? $scope.caratula.responsable
          : null;
      $scope.caratula.collection_executive = $scope.caratula
        .collection_executive
        ? $scope.caratula.collection_executive.id
        : null;
      $scope.caratula.document_type = 11;
      $scope.caratula.status = 14;
      $scope.caratula.celula = $scope.caratula.celula
        ? $scope.caratula.celula
        : null;
      $scope.caratula.groupinglevel = $scope.caratula.groupinglevel
        ? $scope.caratula.groupinglevel
        : null;
      $scope.caratula.contractor = $scope.caratula.contractor
        ? $scope.caratula.contractor.id
        : null;

      if (
        process(datesFactory.convertDate($scope.caratula.start_of_validity)) >
        process(datesFactory.convertDate(new Date()))
      ) {
        $scope.caratula.status = 10;
      } else {
        $scope.caratula.status = 14;
      }

      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }

      $scope.referenciadorArray.forEach(function (item) {
        $scope.referenciadoresSelected = [];
        if (item.referenciador != "") {
          if (item.comision_vendedor == "") {
            item.comision_vendedor = 0;
          }
          $scope.referenciadoresSelected.push(item);
        }
      });

      $scope.caratula.ref_policy = $scope.referenciadoresSelected;
      $http
        .post(url.IP + "colectividades_polizas/", $scope.caratula)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            $scope.dataCaratula = response.data;
            $scope.showCar = true;
            $scope.showPol = false;
            SweetAlert.swal(
              "¡Listo!",
              "Carátula guardada exitosamente.",
              "success"
            );
            /* Actualiza la póliza antigua */
            if (
              process(
                datesFactory.convertDate($scope.copy_caratula.start_of_validity)
              ) > process(datesFactory.convertDate(new Date()))
            ) {
              var data = {
                renewed_status: 2,
              };
            } else {
              var data = {
                status: 12,
                renewed_status: 1,
              };
            }

            $http
              .patch($scope.copy_caratula.url, data)
              .then(function (resp) {})
              .catch(function (e) {
                l.stop();
                console.log("error - caratula - catch", e);
              });

            /* Relación con la póliza original */
            if ($scope.copy_caratula.poliza_number) {
              var oldPolicy = {
                policy: $scope.copy_caratula.poliza_number,
                base_policy: $scope.copy_caratula.url,
                new_policy: $scope.dataCaratula.url,
              };
            }
            $http
              .post(url.IP + "v1/polizas/viejas/", oldPolicy)
              .then(function (res) {})
              .catch(function (e) {
                l.stop();
                console.log("error - caratula - catch", e);
              });
            lb.stop();
            $state.go("flotillas.info", { polizaId: $scope.dataCaratula.id });
          }
        })
        .catch(function (e) {
          lb.stop();
          console.log("error - caratula - catch", e);
        });
    };

    $scope.goToPolicy = function () {
      $state.go("flotillas.info", { polizaId: $scope.dataCaratula.id });
    };

    $scope.validateEmail = function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      if (!$scope.dataCaratula.id) {
        SweetAlert.swal(
          "¡Error!",
          "Debes crear la carátula primero para poder cargar certificados.",
          "error"
        );
        return;
      } else {
        var flagCertificate = false;
        if (param.FLOTILLA) {
          if ($scope.layout.subramo.subramo_name == "Automóviles") {
            $scope.allReceipts = [];
            $scope.excelJson = param.FLOTILLA;
            $scope.excelJson.forEach(function (item) {
              if (!item.CLASE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CLASE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.NO_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              // if(!item.FOLIO){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna FOLIO, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }
              if (!item.NO_POLIZA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_POLIZA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CONTRATANTE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CONTRATANTE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.TIPO_CONTRATANTE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_CONTRATANTE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.DIRECCION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DIRECCION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              // if(!item.CORREO){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna CORREO, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }else{
              //   if(!$scope.validateEmail(item.CORREO)){
              //     SweetAlert.swal('Error', 'Formato inválido de la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna CORREO, corrige el error y vuelve a subir el excel.', 'error');
              //     flagCertificate = true;
              //   }
              // }
              // if(!item.TELEFONO){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna TELEFONO, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }
              if (!item.VIGENCIA_INICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_FIN) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.FRECUENCIA_PAGO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FRECUENCIA_PAGO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.RENOVABLE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RENOVABLE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MONEDA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MONEDA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              // if(!item.LINEA_NEGOCIO){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna LINEA_NEGOCIO, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }
              // if(!item.SUCURSAL){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna SUCURSAL, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }
              if (!item.TIPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PROCEDENCIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PROCEDENCIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.PROCEDENCIA < 0 || item.PROCEDENCIA > 4) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna PROCEDENCIA no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              // if(!item.CONDUCTOR){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna CONDUCTOR, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }
              if (!item.MARCA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MODELO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.AÑO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna AÑO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.VERSION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SERIE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MOTOR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MOTYOR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.COLOR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COLOR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MATRICULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MATRICULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.USO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.USO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.USO < 1 || item.USO > 3) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.SERVICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SERVICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PRIMA_NETA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.DESCUENTO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DESCUENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.RPF) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.DERECHO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.IVA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PRIMA_TOTAL) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.COMISION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (parseFloat(item.PORCENTAJE_COMISION) > 100.0) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PORCENTAJE_COMISION, excede el 100%, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (parseFloat(item.PORCENTAJE_COMISION) < 0.0) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PORCENTAJE_COMISION, no puede ser menor a 0, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (parseInt(item.CLASE) == 2) {
                if (!item.NO_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna NO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.PRIMA_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.RPF_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.DERECHO_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.IVA_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.TOTAL_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TOTAL_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.COMISION_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.INICIO_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (!$scope.validateDate(item.INICIO_RECIBO)) {
                    SweetAlert.swal(
                      "Error",
                      "Formato inválido de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
                if (!item.FIN_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (!$scope.validateDate(item.FIN_RECIBO)) {
                    SweetAlert.swal(
                      "Error",
                      "Formato inválido de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
                if (!item.VENCIMIENTO_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (!$scope.validateDate(item.VENCIMIENTO_RECIBO)) {
                    SweetAlert.swal(
                      "Error",
                      "Formato inválido de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              var receipt = {
                comision: item.COMISION_RECIBO,
                delivered: false,
                derecho: item.DERECHO_RECIBO,
                fecha_fin: item.FIN_RECIBO,
                fecha_inicio: item.INICIO_RECIBO,
                iva: item.IVA,
                prima_neta: item.PRIMA_RECIBO,
                prima_total: item.TOTAL_RECIBO,
                recibo_numero: item.NO_RECIBO,
                rpf: item.RPF_RECIBO,
                sub_total: item.SUBTOTAL_RECIBO,
                vencimiento: item.VENCIMIENTO_RECIBO,
                poliza: item.NO_POLIZA,
                receipt_type: 1,
                conducto_de_pago: item.CONDUCTO_DE_PAGO,
              };
              $scope.allReceipts.push(receipt);
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
            "error"
          );
        }
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          if (item.AÑO_CONSTRUCCION) {
            item.ANO_CONSTRUCCION = item.AÑO_CONSTRUCCION;
            item.ANO_RECONSTRUCCION = item.AÑO_RECONSTRUCCION;
          }
          if (item.AÑO) {
            item.AÑO = item.AÑO;
          }
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.cancelCertificates = function () {
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.saveCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loader = true;
      $scope.certifcados = [];

      if ($scope.selectedCertificates.FLOTILLA) {
        $scope.selectedCertificates.FLOTILLA.forEach(function (item) {
          if (item.CLASE == 1) {
            $scope.recibosIndividuales = [];
            var dataCar = [
              {
                brand: item.MARCA,
                charge_type: 0,
                color: item.COLOR ? item.COLOR : null,
                driver: item.CONDUCTOR ? item.CONDUCTOR : null,
                email: item.CORREO,
                engine: item.MOTOR ? item.MOTOR : null,
                license_plates: item.MATRICULA ? item.MATRICULA : null,
                model: item.MODELO,
                policy_type: item.TIPO ? parseInt(item.TIPO) : null,
                procedencia: parseInt(item.PROCEDENCIA),
                serial: item.SERIE,
                service: item.SERVICIO,
                usage: parseInt(item.USO),
                version: item.VERSION,
                year: item.AÑO,
                no_employee: null,
                sum_insured: null,
                adjustment: item.ADAPTACIONES ? item.ADAPTACIONES : null,
                mont_adjustment: item.MONTO_ADAPTACIONES
                  ? item.MONTO_ADAPTACIONES
                  : null,
                special_team: item.EQUIPAMIENTO ? item.EQUIPAMIENTO : null,
                mont_special_team: item.MONTO_EQUIPAMIENTO
                  ? item.MONTO_EQUIPAMIENTO
                  : null,
                beneficiary_name: null,
                preferential_benefiaciary: item.BENEFICIARIO_PREFERENTE
                  ? item.BENEFICIARIO_PREFERENTE
                  : null,
                beneficiary_rfc: item.BENEFICIARIO_RFC
                  ? item.BENEFICIARIO_RFC
                  : null,
                beneficiary_address: item.BENEFICIARIO_DIRECCION
                  ? item.BENEFICIARIO_DIRECCION
                  : null,
              },
            ];

            $scope.allReceipts.forEach(function (receipt) {
              if (receipt.prima_neta && receipt.rpf && receipt.derecho) {
                if (receipt.poliza == item.NO_POLIZA) {
                  receipt.fecha_inicio = datesFactory.toDate(
                    receipt.fecha_inicio
                  );
                  receipt.fecha_fin = datesFactory.toDate(receipt.fecha_fin);
                  receipt.vencimiento = datesFactory.toDate(
                    receipt.vencimiento
                  );
                  receipt.conducto_de_pago = item.CONDUCTO_DE_PAGO;
                  $scope.recibosIndividuales.push(receipt);
                }
              }
            });

            $scope.obj_poliza = {
              aplicarDescuento: false,
              primaNeta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
              descuento: item.DESCUENTO ? item.DESCUENTO : 0,
              rpf: item.RPF ? item.RPF : 0,
              derecho: item.DERECHO ? item.DERECHO : 0,
              iva: item.IVA ? item.IVA : 0,
              primaTotal: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
              subTotal:
                parseFloat(item.PRIMA_NETA) +
                parseFloat(item.RPF) +
                parseFloat(item.DERECHO),
            };
            // if (parseInt(item.TIPO_CONTRATANTE) ==1) {
            //   $scope.naturalP = item.CONTRATANTE
            //   $scope.juridicalP = null
            // }else if (parseInt(item.TIPO_CONTRATANTE) ==2) {
            //   $scope.naturalP = null
            //   $scope.juridicalP = item.CONTRATANTE
            // }
            if (item.TIPO_CONTRATANTE) {
              $scope.contractorP = item.CONTRATANTE;
            }

            var certificateData = {
              accidents_policy: [],
              address: parseInt(item.DIRECCION),
              aseguradora: $scope.dataCaratula.aseguradora,
              automobiles_policy: dataCar,
              business_line: parseInt(item.LINEA_NEGOCIO),
              caratula: $scope.dataCaratula.id,
              celula: $scope.caratula.celula,
              clave: $scope.dataCaratula.clave,
              coverageInPolicy_policy: [],
              damages_policy: [],
              document_type: 12,
              end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
              endorsement: false,
              f_currency: $scope.dataCaratula.f_currency,
              folio: item.FOLIO ? item.FOLIO : "",
              forma_de_pago: parseInt(item.FRECUENCIA_PAGO),
              groupinglevel: $scope.caratula.groupinglevel,
              identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
              internal_number: null,
              is_renewable: item.RENOVABLE ? item.RENOVABLE : null,
              life_policy: [],
              // natural:$scope.naturalP,
              // juridical:$scope.juridicalP,
              contractor: $scope.contractorP,
              old_policies: [],
              paquete: parseInt(item.PAQUETE),
              parent: $scope.dataCaratula.url,
              caratula_renovada: $scope.copy_caratula.id,
              poliza_number: item.NO_POLIZA,
              ramo: $scope.dataCaratula.ramo,
              recibos_poliza: $scope.recibosIndividuales,
              responsable: item.RESPONSABLE ? parseInt(item.RESPONSABLE) : null,
              start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
              state_circulation: item.ESTADO_CIRCULACION
                ? parseInt(item.ESTADO_CIRCULACION)
                : "",
              status: 14,
              sucursal: item.SUCURSAL ? parseInt(item.SUCURSAL) : null,
              subramo: $scope.dataCaratula.subramo,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : null,
              p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
              descuento: item.DESCUENTO ? item.DESCUENTO : 0,
              rpf: item.RPF ? item.RPF : 0,
              derecho: item.DERECHO ? item.DERECHO : 0,
              iva: item.IVA ? item.IVA : 0,
              p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
              comision: item.COMISION ? item.COMISION : 0,
              comision_percent: item.PORCENTAJE_COMISION
                ? item.PORCENTAJE_COMISION
                : 0,
              sub_total: $scope.obj_poliza.subTotal
                ? parseFloat($scope.obj_poliza.subTotal).toFixed(2)
                : 0,
              conducto_de_pago: item.CONDUCTO_DE_PAGO
                ? parseInt(item.CONDUCTO_DE_PAGO)
                : 1,
            };
            $scope.certifcados.push(certificateData);
          }
        });
      }

      $http({
        method: "POST",
        url: url.IP + "save_caratula_polizas/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          l.stop();
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal(
              "¡Listo!",
              "Pólizas individuales creadas exitosamente.",
              "success"
            );
            $state.go("flotillas.info", { polizaId: $scope.dataCaratula.id });
          } else {
            l.stop();
            $scope.loader = false;
            SweetAlert.swal(
              "ERROR",
              "Ócurrio un error al cargar las pólizas.",
              "error"
            );
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
  }
})();

/* global angular */
(function () {
  "use strict";

  angular.module("inspinia").controller("FlotillasInfoCtrl", FlotillasInfoCtrl);
  FlotillasInfoCtrl.$inject = [
    "$uibModal",
    "$sessionStorage",
    "$scope",
    "$state",
    "$stateParams",
    "$http",
    "url",
    "SweetAlert",
    "MESSAGES",
    "FileUploader",
    "$timeout",
    "$parse",
    "dataFactory",
    "$rootScope",
    "datesFactory",
    "generalService",
    "$sce",
    "insuranceService",
    "toaster",
    "appStates",
    "$localStorage",
    "helpers",
    "ContratanteService",
  ];

  function FlotillasInfoCtrl(
    $uibModal,
    $sessionStorage,
    $scope,
    $state,
    $stateParams,
    $http,
    url,
    SweetAlert,
    MESSAGES,
    FileUploader,
    $timeout,
    $parse,
    dataFactory,
    $rootScope,
    datesFactory,
    generalService,
    $sce,
    insuranceService,
    toaster,
    appStates,
    $localStorage,
    helpers,
    ContratanteService
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    var order = this;
    $scope.caratula_renovada = "";
    $rootScope.show_contractor = false;
    $scope.showOt = true;
    $scope.show_caratula = true;
    $scope.show_certificado = false;
    $scope.isRenewal = false;
    $scope.show_renewal_certificate = false;
    $scope.okFile = 0;
    $scope.countFile = 0;
    $scope.incompleteOT = {
      complete: true,
      caratule: [],
      certificates: [],
    };

    $scope.categorySelected = {
      id: null,
      is_category: 0,
      certificates: [],
      config: {},
    };
    order.isCollapsed = false;
    // Function to toggle the collapse state
    order.toggleCollapse = function () {
      order.isCollapsed = !order.isCollapsed;
    };

    $scope.get_conductos = function (param) {
      param = parseInt(param);
      var conductos = {
        1: "No domiciliada",
        2: "Agente",
        3: "CAC",
        4: "CAT/Domiciliado",
        5: "Nómina",
        6: "CUT",
      };
      return conductos[param];
    };

    $scope.frequencies = [
      { value: 1, label: "Mensual" },
      { value: 2, label: "Bimestral" },
      { value: 3, label: "Trimestral" },
      { value: 6, label: "Semestral" },
      { value: 12, label: "Anual" },
      { value: 5, label: "Contado" },
      { value: 7, label: "Semanal" },
      { value: 14, label: "Catorcenal" },
      { value: 15, label: "Quincenal" },
    ];
    $scope.renewals = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.currencys = [
      { value: 1, label: "Pesos" },
      { value: 2, label: "Dólares" },
      { value: 3, label: "UDI" },
      { value: 4, label: "Euros" },
    ];
    $scope.businessline = [
      { id: 1, name: "Comercial" },
      { id: 2, name: "Personal" },
      { id: 0, name: "Otro" },
    ];
    $scope.types = [
      { id: 1, name: "Automóvil" },
      { id: 2, name: "Motocicleta" },
      { id: 3, name: "Tracto" },
      { id: 4, name: "Autobús" },
      { id: 5, name: "Pick Up" },
      { id: 6, name: "Camiones hasta 1.5 ton" },
      { id: 7, name: "Chofer app" },
      { id: 8, name: "Remolque" },
      { id: 9, name: "Camiones + 1.5 ton" },
    ];
    $scope.usages = [
      { value: 1, label: "Particular" },
      { value: 2, label: "Carga Comercial" },
      { value: 3, label: "Servicio Público" },
    ];
    $scope.procedencias = [
      { value: 0, label: "Sin especificar" },
      { value: 1, label: "Residencia" },
      { value: 2, label: "Turista" },
      { value: 3, label: "Legalizado" },
      { value: 4, label: "Fronterizo" },
    ];
    $scope.conducto_de_pagos = [
      { value: 1, label: "No domiciliada" },
      { value: 2, label: "Agente" },
      { value: 3, label: "CAC" },
      { value: 4, label: "CAT/Domiciliado" },
      { value: 5, label: "Nómina" },
      { value: 6, label: "CUT" },
    ];

    $scope.excelJson = [];
    $scope.beneficiaries_life = [];
    $scope.beneficiaries_medical = [];
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.showTableCertificates = false;
    $scope.loader = false;
    $scope.certifcados = [];

    $scope.directiveReceipts = {};
    $scope.dataToSave = {
      recalcular: true,
    };

    $scope.recibosTodos = [];
    $scope.show_binnacle_receipt = false;

    $scope.contractorLayout = {};

    $scope.statesArray = [
      { id: 1, state: "Aguascalientes" },
      { id: 2, state: "Baja California" },
      { id: 3, state: "Baja California Sur" },
      { id: 4, state: "Campeche" },
      { id: 5, state: "Chiapas" },
      { id: 6, state: "Chihuahua" },
      { id: 7, state: "Coahuila" },
      { id: 8, state: "Colima" },
      { id: 9, state: "Ciudad de México" },
      { id: 10, state: "Durango" },
      { id: 11, state: "Estado de México" },
      { id: 12, state: "Guanajuato" },
      { id: 13, state: "Guerrero" },
      { id: 14, state: "Hidalgo" },
      { id: 15, state: "Jalisco" },
      { id: 16, state: "Michoacán" },
      { id: 17, state: "Morelos" },
      { id: 18, state: "Nayarit" },
      { id: 19, state: "Nuevo León" },
      { id: 20, state: "Oaxaca" },
      { id: 21, state: "Puebla" },
      { id: 22, state: "Querétaro" },
      { id: 23, state: "Quintana Roo" },
      { id: 24, state: "San Luis Potosí" },
      { id: 25, state: "Sinaloa" },
      { id: 26, state: "Sonora" },
      { id: 27, state: "Tabasco" },
      { id: 28, state: "Tamaulipas" },
      { id: 29, state: "Tlaxcala" },
      { id: 30, state: "Veracruz" },
      { id: 31, state: "Yucatán" },
      { id: 32, state: "Zacatecas" },
    ];

    order.save_info_tab = save_info_tab;
    $scope.accesos = $sessionStorage.permisos;

    if ($scope.accesos) {
      $scope.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          $scope.acceso_polizas = perm;
          $scope.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_adm_pol = true;
              } else {
                $scope.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                $scope.acceso_ver_pol = true;
              } else {
                $scope.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_canc_pol = true;
              } else {
                $scope.acceso_canc_pol = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_elim_pol = true;
              } else {
                $scope.acceso_elim_pol = false;
              }
            } else if (acc.permission_name == "Rehabilitar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_adm_rehabilitar = true;
              } else {
                $scope.acceso_adm_rehabilitar = false;
              }
            }
          });
        }
        if (perm.model_name == "Endosos") {
          $scope.acceso_endosos = perm;
          $scope.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                $scope.acceso_adm_end = true;
              } else {
                $scope.acceso_adm_end = false;
              }
            }
          });
        }
        if (perm.model_name == "Reportes") {
          $scope.acceso_reportes = perm;
          $scope.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                $scope.acceso_rep_fia = true;
              } else {
                $scope.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                $scope.acceso_rep_sin = true;
              } else {
                $scope.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                $scope.acceso_rep_end = true;
              } else {
                $scope.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                $scope.acceso_rep_pol = true;
              } else {
                $scope.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                $scope.acceso_rep_ren = true;
              } else {
                $scope.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                $scope.acceso_rep_cob = true;
              } else {
                $scope.acceso_rep_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Ordenes de trabajo") {
          $scope.acceso_ot = perm;
          $scope.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                $scope.acceso_adm_ot = true;
              } else {
                $scope.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                $scope.acceso_ver_ot = true;
              } else {
                $scope.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_canc_ot = true;
              } else {
                $scope.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_elim_ot = true;
              } else {
                $scope.acceso_elim_ot = false;
              }
            }
          });
        }
        if (perm.model_name == "Contratantes y grupos") {
          $scope.acceso_contg = perm;
          $scope.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                $scope.acceso_adm_cont = true;
              } else {
                $scope.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                $scope.acceso_ver_cont = true;
              } else {
                $scope.acceso_ver_cont = false;
              }
            }
          });
        }
        if (perm.model_name == "Siniestros") {
          $scope.acceso_sin = perm;
          $scope.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                $scope.acceso_adm_sin = true;
              } else {
                $scope.acceso_adm_sin = false;
              }
            }
          });
        }
        if (perm.model_name == "Mensajeria") {
          $scope.acceso_mns = perm;
          $scope.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                $scope.acceso_mns = true;
              } else {
                $scope.acceso_mns = false;
              }
            }
          });
        }
        if (perm.model_name == "Formatos") {
          $scope.acceso_form = perm;
          $scope.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                $scope.acceso_form = true;
              } else {
                $scope.acceso_form = false;
              }
            }
          });
        }
        if (perm.model_name == "Correos electronicos") {
          $scope.acceso_correo = perm;
          $scope.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                $scope.acceso_cor = true;
              } else {
                $scope.acceso_cor = false;
              }
            }
          });
        }
        if (perm.model_name == "Cobranza") {
          $scope.acceso_cob = perm;
          $scope.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                $scope.acceso_ver_cob = true;
              } else {
                $scope.acceso_ver_cob = false;
              }
            }
            if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                $scope.acceso_desp_cob = true;
              } else {
                $scope.acceso_desp_cob = false;
              }
            }
            if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                $scope.acceso_pag_cob = true;
              } else {
                $scope.acceso_pag_cob = false;
              }
            }
            if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                $scope.acceso_desco_cob = true;
              } else {
                $scope.acceso_desco_cob = false;
              }
            }
            if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                $scope.acceso_conc_cob = true;
              } else {
                $scope.acceso_conc_cob = false;
              }
            }
            if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                $scope.acceso_liq_cob = true;
              } else {
                $scope.acceso_liq_cob = false;
              }
            }
            if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                $scope.acceso_elim_rec = true;
              } else {
                $scope.acceso_elim_rec = false;
              }
            }
            if (
              acc.permission_name ==
              "No permitir editar recibos Pagados/Liquidados"
            ) {
              if (acc.checked == true) {
                $scope.acceso_pl_cob = true; //no se editan
              } else {
                $scope.acceso_pl_cob = false; //se pueden editar pagados-liquidados
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          $scope.acceso_ref = perm;
          $scope.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_adm_ref = true;
              } else {
                $scope.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_pag_ref = true;
              } else {
                $scope.acceso_pag_ref = false;
              }
            } else if (
              acc.permission_name == "Cambiar refrenciador en pólizas"
            ) {
              if (acc.checked == true) {
                $scope.acceso_chg_ref = true;
              } else {
                $scope.acceso_chg_ref = false;
              }
            }
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_ver_ref = true;
              } else {
                $scope.acceso_ver_ref = false;
              }
            }
          });
        }
        if (perm.model_name == "Comisiones") {
          $scope.coms = perm;
          $scope.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                $scope.permiso_comisiones = true;
              } else {
                $scope.permiso_comisiones = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          $scope.acceso_files = perm;
          $scope.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                $scope.permiso_archivos = true;
              } else {
                $scope.permiso_archivos = false;
              }
            } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                $scope.permiso_administrar_adjuntos = true;
              } else {
                $scope.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }

    // Upload files
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        // 'Authorization': 'Token ' + token,
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    $scope.gotoEndoso = function (endoso) {
      // ui-sref="endorsement.info({endosoId: endorsement.id})"
      $scope.open_in_same_tab_natural(
        "Información endoso",
        "endorsement.info",
        { endosoId: endoso.id },
        0
      );
      // console.log(endoso);
    };

    $scope.open_in_same_tab_natural = function (
      name,
      route,
      params,
      identifier
    ) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $state.go($scope.route_for_new_tab, params);
    };
    $scope.createRecordatorio = function (registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return $scope.caratula;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };
    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };
    $scope.noshowRecordatorios = function () {
      $scope.infoFlag = true;
      $scope.recordatoriosFlag = false;
      $scope.recordatoriosFlagC = false;
    };
    $scope.showRecordatorios = function () {
      $scope.infoFlag = false;
      $scope.recordatoriosFlag = true;
    };
    $scope.showRecordatoriosC = function () {
      $scope.infoFlag = false;
      $scope.recordatoriosFlagC = true;
    };
    $scope.statusPayment = function (value) {
      switch (value) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 7:
          return "Semanal";
          break;
        case 12:
          return "Anual";
          break;
        case 14:
          return "Catorcenal";
          break;
        case 24:
          return "Quincenal";
          break;
        default:
          return value;
      }
    };
    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal(
          "¡Listo!",
          "Archivos cargados exitosamente.",
          "success"
        );
        $http
          .get(url.IP + "polizas/" + $scope.certificate.id + "/archivos/")
          .then(function (response) {
            $scope.certificate.files = [];
            $scope.certificate.files = response.data.results;
          })
          .catch(function (e) {
            console.log("error", e);
          });
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      // console.log('uploader',fileItem)
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
      fileItem.removeAfterUpload = true;
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";

      $scope.files = [];

      // $timeout(function() {
      $scope.uploader.uploadAll();
      saveLogFile($scope.countFile, polizaId);
      //   console.log('fdfsf', $scope.filesCover,$scope.files)
      // }, 1000);
    }
    function saveLogFile(num, id_p) {
      if (num > 0) {
        var params = {
          model: 1,
          event: "PATCH",
          associated_id: id_p,
          identifier: " añadio " + num + " archivos a la póliza.",
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});
      }
    }
    $scope.showFiles = function (item) {
      $http
        .get(url.IP + "polizas/" + item.id + "/archivos/")
        .then(function (response) {
          item.files = response.data.results;
          if (item.showFile) {
            item.showFile = false;
          } else {
            item.showFile = true;
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };
    $scope.saveFile = function (file) {
      var urls = file.url;
      if (urls == undefined) {
        urls = url.IP + "polizas/" + file.owner + "/archivos/" + file.id;
      }
      $http.patch(urls, { nombre: file.nombre, sensible: file.sensible });
    };
    $scope.saveFiles = function (param) {
      $scope.countFile = $scope.uploader.queue.length;
      uploadFiles(param.id);
    };
    $scope.deleteReceipts = function (receipt, index, poliz) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text:
            "No será posible recuperar este recibo: " + receipt.recibo_numero,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: receipt.id,
              id_poliza: poliz.id,
              model: 8,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {
                // console.log('.................:::::.....',req)
              });
            $http
              .patch(receipt.url, { status: 0 })
              .then(function (recibo_delete) {
                var paramsDelRec = {
                  model: 1,
                  event: "DELETE",
                  associated_id: poliz.id,
                  identifier:
                    " elimino un recibo (" +
                    receipt.recibo_numero +
                    ") de la póliza",
                };
                dataFactory
                  .post("send-log/", paramsDelRec)
                  .then(function success(response) {});
                if (recibo_delete.data.status == 0) {
                  poliz.recibos_poliza.splice(index, 1);
                }
                SweetAlert.swal("¡Hecho!", "Recibo eliminado", "success");
              });
          }
        }
      );
    };
    $scope.cancelRenovate = function (poliza) {
      $http({
        method: "POST",
        url: url.IP + "get-polizas-colectividad/",
        data: {
          caratula: $scope.dataCaratula.id,
        },
      })
        .then(function (data) {
          $scope.allCertificates = [];
          $scope.allCertificates = data.data.data;
          swal(
            {
              title: "No renovar la Colectividad completa",
              text:
                "Motivo de No Renovación de Carátula y sus Pólizas (Vencidas y Vigentes (" +
                $scope.allCertificates.length +
                ")):",
              type: "input",
              showCancelButton: true,
              closeOnConfirm: false,
            },
            function (inputValue) {
              if (inputValue === false) return false;
              if (inputValue === "") {
                swal.showInputError("Necesita especificar un motivo");
                return false;
              }
              var data = {
                reason_ren: inputValue,
                status: 15,
              };
              $http.patch(poliza.url, data).then(function (ren) {
                var params = {
                  model: 1,
                  event: "PATCH",
                  associated_id: poliza.id,
                  identifier:
                    " cambio el estatus a No Renovada por el motivo " +
                    ren.data.reason_ren +
                    " de la póliza " +
                    ren.data.poliza_number +
                    ".",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
              });
              $scope.caratula.status = 15;
              $scope.caratula.reason_ren = inputValue;
              swal(
                "Hecho",
                "La póliza se ha cerrado y no se vera más en el listado de renovaciones",
                "success"
              );
            }
          );
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };
    $scope.deleteFile = function (file, container, certificate) {
      SweetAlert.swal(
        {
          title: "Eliminar Archivo",
          text: "No será posible recuperar este archivo, ¿Estás seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "GET",
              url: url.IP + "delete-manual",
              params: {
                file_id: file.id,
              },
            })
              .then(function success(response) {
                if (response.data.status == 204) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "El archivo fue eliminado exitosamente.",
                    "success"
                  );
                  var params = {
                    model: 1,
                    event: "PATCH",
                    associated_id: certificate.id,
                    identifier:
                      " elimino 1 archivo de la póliza " + file.nombre,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  container.splice(container.indexOf(file), 1);
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
        }
      );
    };

    $scope.renameFile = function (file, vmFiles) {
      var patch = {
        nombre: file.nombre,
        sensible: file.sensible,
      };
      $http
        .patch(file.url, patch)
        .then(function (response) {
          if (response.status == 403) {
            $http
              .get(file.url)
              .then(function (response) {
                file.nombre = response.data;
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    activate();

    $scope.show_section = function (value) {
      $scope.isRenewal = false;
      $scope.show_renewal_certificate = false;
      switch (value) {
        case 1:
          $scope.show_caratula = true;
          $scope.show_subgrupo = false;
          $scope.show_paquete = false;
          $scope.show_certificado = false;
          break;
        case 2:
          $scope.show_caratula = false;
          $scope.show_certificado = true;
          if (
            $localStorage.saved_flotilla_info &&
            $localStorage.saved_flotilla_info["sucursalLay"]
          ) {
            $scope.sucursalLay =
              $localStorage.saved_flotilla_info["sucursalLay"];
          }
          if (
            $localStorage.saved_flotilla_info &&
            $localStorage.saved_flotilla_info["paqueteLay"]
          ) {
            $scope.paqueteLay = $localStorage.saved_flotilla_info["paqueteLay"];
          }
          break;
        default:
          $scope.show_caratula = true;
          $scope.show_certificado = false;
      }
    };
    $scope.shareCertificatesAPPEmail = function (caratula) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Se compartirán todas las Pólizas de Colectividad a la App",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id_poliza: caratula,
              is_owner: false,
              active: true,
            };
            dataFactory
              .post("shareToAppEmailPC/", data_email)
              .then(function success(req) {
                if (req.status == 200 || req.status == 201) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "Se han Compartido a la APP-Email",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al compartir Pólizas de Colectividad de la Carátula",
                    "error"
                  );
                }
              });
          }
        }
      );
    };
    $scope.shareCertificatesApp = function (caratula) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Se compartirán todas las Pólizas de Colectividad a los correos asignados a un usuario de la App",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id_poliza: caratula,
              is_owner: false,
              active: true,
            };
            dataFactory
              .post("shareToAppPC/", data_email)
              .then(function success(req) {
                if (req.status == 200 || req.status == 201) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "Se han Compartido a la APP",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al compartir Pólizas de Colectividad de la Carátula",
                    "error"
                  );
                }
              });
          }
        }
      );
    };

    $scope.shareCertificatesEmail = function (caratula) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Se compartirán todas las Pólizas de Colectividad al Correo Electrónico designado",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id_poliza: caratula,
              is_owner: false,
              active: true,
            };
            dataFactory
              .post("shareToEmailPC/", data_email)
              .then(function success(req) {
                if (req.status == 200 || req.status == 201) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "Se han compartodo vía Email",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al compartir Pólizas de Colectividad de la Carátula",
                    "error"
                  );
                }
              });
          }
        }
      );
    };

    $scope.getState = function (value) {
      if (value == 1) {
        return "Aguascalientes";
      } else if (value == 2) {
        return "Baja California";
      } else if (value == 3) {
        return "Baja California Sur";
      } else if (value == 4) {
        return "Campeche";
      } else if (value == 5) {
        return "Chiapas";
      } else if (value == 6) {
        return "Chihuahua";
      } else if (value == 7) {
        return "Coahuila";
      } else if (value == 8) {
        return "Colima";
      } else if (value == 9) {
        return "Ciudad de México";
      } else if (value == 10) {
        return "Durango";
      } else if (value == 11) {
        return "Estado de México";
      } else if (value == 12) {
        return "Guanajuato";
      } else if (value == 13) {
        return "Guerrero";
      } else if (value == 14) {
        return "Hidalgo";
      } else if (value == 15) {
        return "Jalisco";
      } else if (value == 16) {
        return "Michoacán";
      } else if (value == 17) {
        return "Morelos";
      } else if (value == 18) {
        return "Nayarit";
      } else if (value == 19) {
        return "Nuevo León";
      } else if (value == 20) {
        return "Oaxaca";
      } else if (value == 21) {
        return "Puebla";
      } else if (value == 22) {
        return "Querétaro";
      } else if (value == 23) {
        return "Quintana Roo";
      } else if (value == 24) {
        return "San Luis Potosí";
      } else if (value == 25) {
        return "Sinaloa";
      } else if (value == 26) {
        return "Sonora";
      } else if (value == 27) {
        return "Tabasco";
      } else if (value == 28) {
        return "Tamaulipas";
      } else if (value == 29) {
        return "Tlaxcala";
      } else if (value == 30) {
        return "Veracruz";
      } else if (value == 31) {
        return "Yucatán";
      } else if (value == 32) {
        return "Zacatecas";
      } else {
        return "";
      }
    };

    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      // var url = $location.path();
      // if(url.indexOf("editar") > -1)
      // {
      //   $scope.directiveReceipts.is_edit = true;
      // } else {
      //   $scope.directiveReceipts.is_edit = false;
      // }
      if (!$localStorage.saved_flotilla_info) {
        $localStorage.saved_flotilla_info = {};
      }
      $scope.directiveReceipts.canCreate = false;
      insuranceService.getInsuranceRead($stateParams).then(function (response) {
        $scope.caratula = response;
        $scope.dataCaratula = response;
        if ($scope.caratula.ref_policy) {
          $scope.caratula.ref_policy.forEach(function (refs) {
            $http
              .get(refs.referenciador)
              .then(function success(response_ref_plicy) {
                if (response_ref_plicy) {
                  refs.data = response_ref_plicy.data;
                }
              });
          });
        }
        $http.get(url.IP + "usuarios/").then(function (user) {
          $scope.users = user.data.results;
          $scope.usersLay = user.data.results;
        });

        dataFactory
          .get("sucursales-to-show/")
          .then(function success(response) {
            if (response.status === 200 || response.status === 201) {
              $scope.sucursales = response.data.results;
              $scope.sucursalLay = response.data.results;
            }
          })
          .catch(function (e) {
            console.log("error", e);
          });

        var url_aux =
          url.IP +
          "contractors-resume-medium/" +
          $scope.caratula.contractor +
          "/";

        $http({ method: "GET", url: url_aux })
          .then(
            function success(response) {
              $scope.contratante = response.data;
              // if ($scope.caratula.natural) {
              //   $scope.contratante.direccion = $scope.caratula.address;
              // } else if ($scope.caratula.juridical) {
              //   $scope.contratante.direccion = $scope.caratula.address;
              // }
              if ($scope.contratante.grouping_level) {
                $http
                  .get(
                    url.IP +
                      "groupinglevel/" +
                      $scope.contratante.grouping_level
                  )
                  .then(function (response) {
                    $scope.contratante.grouping_level =
                      response.data.description;
                  });
              }

              if ($scope.contratante.subgrouping) {
                $http
                  .get(
                    url.IP + "groupinglevel/" + $scope.contratante.subgrouping
                  )
                  .then(function (response) {
                    $scope.contratante.subgrouping = response.data.description;
                  });
              }

              if ($scope.contratante.subsubgrouping) {
                $http
                  .get(
                    url.IP +
                      "groupinglevel/" +
                      $scope.contratante.subsubgrouping
                  )
                  .then(function (response) {
                    $scope.contratante.subsubgrouping =
                      response.data.description;
                  });
              }
              $scope.contratante.direccion = $scope.caratula.address;
            },
            function error(response) {
              console.log("error", response);
            }
          )
          .catch(function (e) {
            console.log("error", e);
          });

        $http
          .get(url.IP + "polizas/" + $scope.caratula.id + "/archivos/")
          .then(function (response) {
            $scope.filesCover = response.data.results;
          })
          .catch(function (e) {
            console.log("error", e);
          });

        if ($scope.caratula.celula) {
          $http.get($scope.caratula.celula).then(function (response) {
            $scope.celula = response.data.celula_name;
          });
        }

        $scope.getComments();
        $scope.allCertificates(1);
        $scope.showItemCertificate(1);

        $scope.existeNueva = false;
        $http({
          method: "GET",
          url: url.IP + "historic-policies/",
          params: {
            actual_id: $scope.caratula.id,
          },
        })
          .then(function success(response) {
            $scope.policy_history = [];
            if (response.data.results.length) {
              response.data.results.forEach(function function_name(old, index) {
                if ($scope.caratula.id != old.base_policy.id) {
                  $scope.policy_history.push(old.base_policy);
                  if (index == 0) {
                    $scope.copy_policy_history = angular.copy(old.base_policy);
                    $scope.caratula_renovada = $scope.copy_policy_history.id;
                  }
                } else if (old.new_policy) {
                  $scope.policy_history.push(old.new_policy);
                  $scope.existeNueva = true;
                }
              });
            }
          })
          .catch(function (e) {
            console.log("error - caratula - catch", e);
          });
        // contratante*************
        var myInsuranceContractor = $stateParams.dataContractor;
        if (myInsuranceContractor && myInsuranceContractor.url) {
          var contrac = {};
          $scope.createIndividualCertificate();
        }
        // !!********************************+!!
      });
    }

    $scope.openModal = function (task) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/tasks/task.modal.html",
        controller: "TareasModalCtrl",
        size: "lg",
        resolve: {
          task: function () {
            return task;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          receipt: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          activate();
        },
        function () {
          console.info("modal closed");
        }
      );
    };
    $scope.incompleteCollective = function () {
      $scope.incompleteOT = {
        complete: true,
        caratule: [],
        certificates: [],
      };

      if (!$scope.caratula.poliza_number) {
        var item = {
          text: "Agregar No. de Póliza.",
        };
        $scope.incompleteOT.caratule.push(item);
        $scope.incompleteOT.complete = false;
      }

      if ($scope.categorySelected.certificates.length == 0) {
        var item = {
          text: "Agregar Pólizas.",
        };
        $scope.incompleteOT.certificates.push(item);
        $scope.incompleteOT.complete = false;
      }
    };

    $scope.editCollective = function (param) {
      $state.go("flotillas.edit", { polizaId: $scope.caratula.id });
    };
    $scope.renovarPolizaRehabilitate = function (polizareh) {
      $scope.date1 = datesFactory.convertDate(
        datesFactory.toDate(datesFactory.convertDate(polizareh.end_of_validity))
      );
      if (
        process($scope.date1) < process(datesFactory.convertDate(new Date()))
      ) {
        $scope.status_nuevo = 13;
      } else if (
        process($scope.date1) > process(datesFactory.convertDate(new Date()))
      ) {
        $scope.status_nuevo = 14;
      } else {
        $scope.status_nuevo = polizareh.status;
      }
      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }
      SweetAlert.swal(
        {
          title: "Actualización de Póliza Colectividad para Renovación",
          text:
            "Los cambios se aplicarán en la Póliza " + polizareh.poliza_number,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .patch(polizareh.url, { status: $scope.status_nuevo })
              .then(upgPolicyComplete)
              .catch(upgPolicyFailed);
            function upgPolicyComplete(response, status, headers, config) {
              if (response.status === 200 || response.status === 201) {
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.UPGRADEPOLICY,
                  "success"
                );
                var params = {
                  model: 1,
                  event: "POST",
                  associated_id: polizareh.id,
                  identifier:
                    "actualizo la Póliza Colectividad para ser renovada ",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                setTimeout(function () {
                  location.reload();
                }, 1500);
              }
            }
            function upgPolicyFailed(response, status, headers, config) {
              return response;
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La póliza no se ha afectado",
              "error"
            );
          }
        }
      );
    };
    $scope.renovarPoliza = function (polizaren) {
      if (!$scope.caratula.nueva) {
        SweetAlert.swal(
          "Error",
          "La carátula debe estar Renovada con póliza Posterior Vigente",
          "error"
        );
        return;
      }
      if ($scope.caratula.status != 12) {
        SweetAlert.swal(
          "Error",
          "La carátula debe estar Renovada con póliza posterior vigente",
          "error"
        );
        return;
      }
      $scope.show_certificado = false;
      $scope.show_showReceiptCertificate = false;
      $scope.isEdit = false;
      $scope.isRenewal = true;
      $scope.show_renewal_certificate = true;
      $scope.polizaaRenovar = polizaren;
      var item = polizaren;
      $scope.directiveReceipts.is_edit = false;
      $scope.originCertificate = [];
      $scope.newCertificate = item;
      $scope.newCertificate.poliza_number = "";
      $scope.dataToSave.recalcular = true;

      $scope.dataToSave.poliza = {
        primaNeta: 0,
        rpf: 0,
        derecho: 0,
        subTotal: 0,
        iva: 0,
        primaTotal: 0,
        // primaNeta: parseFloat(item.p_neta),
        // rpf: parseFloat(item.rpf),
        // derecho: parseFloat(item.derecho),
        // subTotal: parseFloat(item.sub_total),
        // iva: parseFloat(item.iva),
        // primaTotal: parseFloat(item.p_total)
      };
      $scope.dataToSave.receipts = [];
      // item.recibos_poliza.forEach(function(receipt){
      //   if(receipt.receipt_type == 1){
      //     receipt.fecha_inicio = datesFactory.convertDate(receipt.fecha_inicio);
      //     receipt.fecha_fin = datesFactory.convertDate(receipt.fecha_fin);
      //     receipt.vencimiento = datesFactory.convertDate(receipt.vencimiento);
      //     if(receipt.status != 'Pendiente de pago'){
      //       $scope.dataToSave.recalcular = false;
      //     }
      //     $scope.dataToSave.receipts.push(receipt);
      //   }
      // });
      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: item.ramo.id,
          subramo: item.subramo.id,
          provider: item.aseguradora
            ? item.aseguradora.id
            : $scope.caratula.aseguradora.id,
        })
        .then(function success(response) {
          if (response.status === 200) {
            $scope.packages = [];
            if (response.data.length) {
              $scope.packages = response.data;
              $scope.packages.forEach(function (pack) {
                if (pack.id == $scope.newCertificate.paquete.id) {
                  $scope.newCertificate.paquete = pack;
                }
              });
            }
          }
        })
        .catch(function (error) {
          console.log("error", e);
        });
      if ($scope.newCertificate.start_of_validity.indexOf("-") != -1) {
        $scope.newCertificate.start_of_validity = datesFactory.convertDate(
          $scope.caratula.nueva.start_of_validity
        );
      }
      if ($scope.newCertificate.end_of_validity.indexOf("-") != -1) {
        $scope.newCertificate.end_of_validity = datesFactory.convertDate(
          $scope.caratula.nueva.end_of_validity
        );
      }
      order.contratante = {};
      order.contratante.val = item.contractor.full_name;
      order.contratante.value = item.contractor;
      $scope.frequencies.forEach(function (item) {
        if (item.value == $scope.newCertificate.forma_de_pago) {
          $scope.newCertificate.forma_de_pago = item;
        }
      });
      $scope.renewals.forEach(function (item) {
        if (item.value == $scope.newCertificate.is_renewable) {
          $scope.newCertificate.is_renewable = item;
        }
      });
      $scope.businessline.forEach(function (item) {
        if (item.id == $scope.newCertificate.business_line) {
          $scope.newCertificate.business_line = item;
        }
      });
      if ($scope.newCertificate.sucursal) {
        $scope.sucursales.forEach(function (item) {
          if (item.id == $scope.newCertificate.sucursal.id) {
            $scope.newCertificate.sucursal = item;
          }
        });
      }
      if ($scope.newCertificate.responsable) {
        $scope.users.forEach(function (item) {
          if (item.id == $scope.newCertificate.responsable.id) {
            $scope.newCertificate.responsable = item;
          }
        });
      }
      if ($scope.newCertificate.automobiles_policy.length) {
        $scope.types.forEach(function (item) {
          if (item.id == $scope.newCertificate.datos.policy_type) {
            $scope.newCertificate.datos.policy_type = item;
          }
        });
        $scope.usages.forEach(function (item) {
          if (item.value == $scope.newCertificate.datos.usage) {
            $scope.newCertificate.datos.usage = item;
          }
        });
        $scope.procedencias.forEach(function (item) {
          if (item.value == $scope.newCertificate.datos.procedencia) {
            $scope.newCertificate.datos.procedencia = item;
          }
        });
      }
      if ($scope.newCertificate.state_circulation) {
        $scope.statesArray.forEach(function (item) {
          if (item.id == parseInt($scope.newCertificate.state_circulation)) {
            $scope.newCertificate.state_circulation = item;
          }
        });
      }
      $scope.directiveReceipts.payment = $scope.newCertificate.forma_de_pago;
      $scope.directiveReceipts.subramo = item.subramo;
      $scope.copy_inicio = angular.copy(
        $scope.newCertificate.start_of_validity
      );
      $scope.copy_fin = angular.copy($scope.newCertificate.end_of_validity);
      $scope.checkDate($scope.copy_inicio);
      $scope.checkEndDate($scope.copy_fin);
    };
    $scope.reActivatePolicy = function (id, poliza_number) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/polizas.rehabilitar.html",
        controller: ReActivatePolicyCtrl,
        controllerAs: "vmm",
        size: "md",
        resolve: {
          idInsurance: function () {
            return id;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (response) {
        $http
          .post(url.IP + "rehabilitar-poliza/", response)
          .then(
            function (response_rehabilitar) {
              console.log("response_rehabilitar", response_rehabilitar);

              var params = {
                model: 1,
                event: "POST",
                associated_id: id,
                identifier: poliza_number
                  ? "reactivó la póliza."
                  : "reactivó la OT.",
              };
              dataFactory.post("send-log/", params);
              toaster.success("Se rehabilitó la póliza correctamente");

              setTimeout(function () {
                location.reload();
              }, 1500);
            },
            function (error) {
              console.log("Error al rehabilitar ", error);
              toaster.error("ocurrión un error al rehabilitar la póliza");
            }
          )
          .catch(function (error) {
            console.log("Error al rehabilitar ", error);
            toaster.error("ocurrión un error al rehabilitar la póliza");
          });
      });
    };
    $scope.renovarConPolicy = function (id, poliza_number, completa) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/flotillas/renovarcon.html",
        controller: RenovarconPolicyCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          idInsurance: function () {
            return id;
          },
          completa: function () {
            return completa;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (response) {
        /* Actualiza la póliza antigua */
        var data = {
          status: 12,
          renewed_status: 1,
        };
        $http
          .patch(completa.url, data)
          .then(function (resp) {
            console.log("result-renovacion patch--", resp);
            /* Relación con la póliza original */
            if (completa.poliza_number) {
              var oldPolicy = {
                policy: completa.poliza_number,
                base_policy: completa.url,
                new_policy: response.idpoliza.url,
              };
            } else {
              var oldPolicy = {
                base_policy: completa.url,
                new_policy: response.idpoliza.url,
              };
            }
            $http
              .post(url.IP + "v1/polizas/viejas/", oldPolicy)
              .then(function (res) {
                console.log("---rsp historico--", res);
              })
              .catch(function (e) {
                l.stop();
                console.log("error - flotilla ren poliza ind- catch", e);
              });

            var params = {
              model: 1,
              event: "POST",
              associated_id: completa.id,
              identifier: completa.poliza_number
                ? " renovó la póliza."
                : " renovo la OT.",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            SweetAlert.swal(
              "¡Listo!",
              "Renovación creada exitosamente.",
              "success"
            );
          })
          .catch(function (e) {
            l.stop();
            console.log("error - flotilla rencon- catch", e);
          });
        $state.reload();
      });
    };
    function RenovarconPolicyCtrl(
      $scope,
      $uibModalInstance,
      idInsurance,
      completa
    ) {
      $scope.polizaarenovar = completa;
      $scope.buttonDisabled = true;
      $scope.mostrar_alerta = false;
      $scope.motivo_rehabilitacion = "";
      $scope.reActivatePolicy = function (polizaSelected) {
        $uibModalInstance.close({ idpoliza: polizaSelected, id: idInsurance });
      };

      $scope.findPolicy = function (parValue) {
        if (parValue) {
          if (parValue.val.length >= 3) {
            $scope.urlrc = "get-policies-ind-flotillas/";
            dataFactory
              .post($scope.urlrc, { word: parValue.val })
              .then(
                function success(request) {
                  var results = [];
                  results = _.map(request.data, function (item) {
                    var label =
                      item.poliza_number +
                      " - " +
                      datesFactory.convertDate(item.start_of_validity) +
                      " - " +
                      datesFactory.convertDate(item.end_of_validity);
                    return {
                      label: label,
                      value: item.poliza_number,
                      id: item.id,
                      url: item.url,
                    };
                  });
                  $scope.autocompleteData = results;
                },
                function error(error) {}
              )
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      };
      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }
    function ReActivatePolicyCtrl(
      $scope,
      $uibModalInstance,
      idInsurance,
      dataFactory
    ) {
      $scope.buttonDisabled = true;
      $scope.mostrar_alerta = false;
      $scope.motivo_rehabilitacion = "";
      $scope.reActivatePolicy = function () {
        $uibModalInstance.close({
          motivo_rehabilitacion: $scope.motivo_rehabilitacion,
          id: idInsurance,
        });
      };
      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.gotoRenewal = function (param) {
      $state.go("flotillas.renewal", { polizaId: $scope.caratula.id });
    };

    $scope.statusPolicy = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.getComments = function () {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 1,
          id_model: $scope.caratula.id,
        },
      })
        .then(function (response) {
          $scope.comments_data = response.data.results;
          $scope.comments_config = {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          };
          $http({
            method: "GET",
            url: url.IP + "comments/",
            params: {
              model: 28,
              id_model: $scope.caratula.id,
            },
          })
            .then(function (response) {
              if (response.data.results) {
                response.data.results.forEach(function (x) {
                  $scope.comments_data.push(x);
                });
              }
              $scope.comments_config = {
                count: response.data.count,
                next: response.data.next,
                previous: response.data.previous,
              };
            })
            .catch(function (e) {
              console.log("e", e);
            });
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.cancelPolicy = function (caratula) {
      SweetAlert.swal(
        {
          title: "Cancelar Colectividad",
          text: "Los cambios no podrán revertirse. ¿Está seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var modalInstance = $uibModal.open({
              templateUrl: "app/polizas/poliza.modal.html",
              controller: PolicyModalCtrl,
              controllerAs: "vmm",
              size: "md",
              resolve: {
                contractorModal: function () {
                  return $scope.contratante;
                },
                urlInsurance: function () {
                  return caratula.url;
                },
                receipts: function () {
                  return [];
                },
                caratula: function () {
                  return $scope.caratula;
                },
              },
              backdrop:
                "static" /* this prevent user interaction with the background */,
              keyboard: false,
            });
            modalInstance.result.then(function (receipt) {
              $state.go("flotillas.info", { polizaId: myInsurance.id });
            });
            // $http.post(url.IP + 'cancel-caratula_polizas/', {'id': $scope.caratula.id,'document_type': 11})
            // .then(function(response){
            //   var params = {
            //     'model': 18,
            //     'event': "POST",
            //     'associated_id': $scope.caratula.id,
            //     'identifier': " canceló la colectividad."
            //   }

            //   dataFactory.post('send-log/', params).then(function success(response) {

            //   });

            //   activate();
            //   SweetAlert.swal("¡Listo!", "Carátula cancelada exitosamente.", "success");
            //   // $state.go('flotillas.info', {polizaId: $scope.caratula.id});
            // })
            // .catch(function(e){
            //   console.log('error', e);
            // });
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La colectividad no se ha cancelado",
              "error"
            );
          }
        }
      );
    };
    function PolicyModalCtrl(
      $scope,
      contractorModal,
      $uibModalInstance,
      urlInsurance,
      receipts,
      caratula
    ) {
      $scope.buttonDisabled = true;
      $scope.addnotasToCancel = true;
      $scope.addnotasToCancelF = function (addnotas) {
        $scope.addnotasToCancel = addnotas;
      };
      $scope.optionsCancel = [
        // {'value': 3, 'label': 'Cancelación definitiva'}
        { value: 3, label: "Cancelación definitiva - A petición" },
        { value: 4, label: "Cancelación definitiva - Falta de pago" },
      ];
      $scope.date_cancel = datesFactory.convertDate(new Date());
      $scope.checkCancelDate = function (dat) {
        $scope.date_cancel = dat;
      };

      $scope.cancelPolicy = function (option, reason, date) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (option.value == 3 || option.value == 4) {
          if (date) {
            date = datesFactory.toDate(date);
          } else {
            date = new Date();
          }
          $http
            .patch(urlInsurance, {
              status: 11,
              reason_cancel: option.label + " // " + reason,
              date_cancel: date,
              cancelnotas: $scope.addnotasToCancel,
            })
            .then(function (data) {
              caratula.status = data.data.status;
              $http
                .post(url.IP + "cancel-caratula_polizas/", {
                  id: caratula.id,
                  document_type: caratula.document_type,
                  cancelnotas: $scope.addnotasToCancel,
                })
                .then(function (response) {
                  if (caratula.document_type == 11) {
                    var params = {
                      model: 18,
                      event: "POST",
                      associated_id: caratula.id,
                      identifier: " canceló la colectividad.",
                    };
                  } else {
                    var params = {
                      model: 1,
                      event: "POST",
                      associated_id: caratula.id,
                      identifier: " canceló la póliza individual.",
                    };
                  }

                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});

                  activate();
                  SweetAlert.swal(
                    "¡Listo!",
                    "Carátula cancelada exitosamente.",
                    "success"
                  );
                })
                .catch(function (e) {
                  console.log("error", e);
                });
              l.stop();
              activate();
              $uibModalInstance.dismiss("cancel");
              swal(
                "Hecho",
                "Se ha cancelado definitivamente la Carátula",
                "success"
              );
            });
        }
      };

      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }
    $scope.cancelPolicyC = function (polizac) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var modalInstance = $uibModal.open({
              templateUrl: "app/polizas/poliza.modal.html",
              controller: PolicyModalCtrl,
              controllerAs: "vmm",
              size: "md",
              resolve: {
                contractorModal: function () {
                  return $scope.contratante;
                },
                urlInsurance: function () {
                  return polizac.url;
                },
                receipts: function () {
                  return [];
                },
                caratula: function () {
                  return polizac;
                },
              },
              backdrop:
                "static" /* this prevent user interaction with the background */,
              keyboard: false,
            });
            modalInstance.result.then(function (receipt) {
              $state.go("flotillas.info", { polizaId: myInsurance.id });
            });
            // $http.post(url.IP + 'cancel-caratula_polizas/', {'id': polizac.id,'document_type': 12})
            // .then(function(response){

            //   var params = {
            //     'model': 1,
            //     'event': "POST",
            //     'associated_id': polizac.id,
            //     'identifier': " actualizó la póliza individual."
            //   }

            //   dataFactory.post('send-log/', params).then(function success(response) {

            //   });

            //   SweetAlert.swal("¡Listo!", "Póliza de carátula cancelada exitosamente.", "success");
            //   polizac.status = 11;
            // })
            // .catch(function(e){
            //   console.log('error', e);
            // });
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La Póliza de Carátula no se ha cancelado",
              "error"
            );
          }
        }
      );
    };

    $scope.cancelRenewal = function (poliza) {
      swal(
        {
          title: "No renovar",
          text: "Motivo:",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: false,
        },
        function (inputValue) {
          if (inputValue === false) return false;
          if (inputValue === "") {
            swal.showInputError("Necesita especificar un motivo");
            return false;
          }
          var data = {
            reason_ren: inputValue,
            status: 15,
          };
          $http.patch($scope.certificate.url, data).then(function (ren) {
            var params = {
              model: 1,
              event: "PATCH",
              associated_id: $scope.certificate.id,
              identifier:
                " cambio el estatus a no renovada por el motivo " +
                ren.data.reason_ren +
                " de la póliza " +
                ren.data.poliza_number +
                ".",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          });
          $scope.certificate.status = 15;
          $scope.certificate.reason_ren = inputValue;
          activate();
          swal(
            "Hecho",
            "La póliza se ha cerrado y no se vera más en el listado de renovaciones.",
            "success"
          );
        }
      );
    };

    $scope.assignPolicy = function (id, certificate) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/polizas.assign.html",
        controller: assignModalView,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policy_id: function () {
            return id;
          },
          contratante: function () {
            return $scope.contratante;
          },
          contractor: function () {
            return certificate.contractor;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      function assignModalView(
        $scope,
        $uibModalInstance,
        policy_id,
        url,
        contratante,
        contractor
      ) {
        $scope.email = contractor.email;
        $scope.soloEmail = true;
        $scope.tipopoliza = "Póliza";
        var vmm = this;
        var share_via_email = [];
        var share_via_email_r = [];
        vmm.is_owner = false;
        vmm.email_assign_mail = "";
        vmm.custom_email = true;
        vmm.htmlVariable = "";
        vmm.first_comment = "";
        vmm.second_comment = "";
        vmm.correos = [];
        $scope.send = true;
        $http
          .post(url.IP + "get-assign/", { poliza: id })
          .then(
            function success(response) {
              $scope.people_assigned = response.data;
              $scope.owner_exist = true;
              $scope.people_assigned.some(function (people) {
                if (people.is_owner == true) {
                  $scope.owner_exist = false;
                  return;
                }
              });
            },
            function error(err) {}
          )
          .catch(function (e) {});
        $scope.showEmailInInput = function (correo, index) {
          $scope.email_assign = correo;
        };

        $scope.emails = [];

        dataFactory
          .get("emailtemplate-unpag/", {
            template_model: 2,
            id_policy: policy_id,
          })
          .then(function success(response) {
            $scope.plantillas = response.data;
          });
        $scope.emptySubject = function (v) {
          if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
            vmm.subjectEmail = vmm.subjectDefault;
          }
        };
        $scope.changePlantilla = function (item) {
          if (item) {
            vmm.subjectEmail = item.title;
            vmm.first_comment = item.text;
            if (vmm.first_comment.includes("\n")) {
              vmm.first_comment = vmm.first_comment.replace("\n", "<br><br>");
            }
            vmm.second_comment = item.bottom_text;
            vmm.custom_email = true;
            $scope.getTemplate(true);
          } else {
            vmm.subjectEmail = "";
            vmm.first_comment = "";
            vmm.second_comment = "";
            vmm.custom_email = true;
            $scope.getTemplate(true);
          }
        };
        $scope.addEmail = function (email) {
          if (validateEmail(email) == false) {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
            return;
          } else {
            if ($scope.emails.indexOf(email) < 0) {
              $scope.emails.push(email);
            } else {
              SweetAlert.swal("ERROR", MESSAGES.ERROR.REPEATEMAIL, "error");
            }
            vmm.email_assign_mail = "";
          }
        };
        $scope.remove_email = function (index) {
          $scope.emails.splice(index, 1);
        };

        if (contratante.full_name) {
          var name_contractor = contratante.full_name;
          $http
            .post(url.IP + "contractors-contact/", {
              name: name_contractor,
            })
            .then(function (response) {
              if (response.status === 200) {
                vmm.correos = response.data.contact;
              }
            });
        }

        $scope.getTemplate = function (custom_email) {
          if (custom_email) {
            $http
              .get(url.IP + "share-policy-manual/" + policy_id)
              .then(function (response) {
                if (response.status === 200) {
                  vmm.head = response.data.head;
                  vmm.body = response.data.body;
                  vmm.footer = response.data.footer;
                  vmm.subjectDefault = response.data.subject_default;
                  if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
                    vmm.subjectEmail = vmm.subjectDefault;
                  }
                }
              })
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
            vmm.htmlVariable = "";
            vmm.first_comment = "";
            vmm.second_comment = "";
          }
        };
        $scope.emptySubject = function (v) {
          if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
            vmm.subjectEmail = vmm.subjectDefault;
          }
        };
        $scope.sendEmail = function (receipt) {
          $scope.send = false;
          var l = Ladda.create(document.querySelector(".ladda-button"));
          l.start();
          var data_shared = {
            id: policy_id,
            emails: $scope.emails,
            files: share_via_email,
            files_r: share_via_email_r,
            first_comment: vmm.first_comment,
            second_comment: vmm.second_comment,
            model: 1,
            custom_email: vmm.custom_email,
          };
          $http
            .post(url.IP + "share-policy-manual/", data_shared)
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  SweetAlert.swal("¡Listo!", MESSAGES.OK.POLICYSEND, "success");
                  $scope.send = true;
                  var params = {
                    model: 1,
                    event: "POST",
                    associated_id: policy_id,
                    identifier: "compartió la póliza por email.",
                    save_logmail: 1,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  $uibModalInstance.dismiss("cancel");
                } else {
                  $scope.send = true;
                  l.stop();
                  SweetAlert.swal("ERROR", request.data.status, "error");
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        };

        $scope.deleteEmail = function (email) {
          $http({
            method: "GET",
            url: url.IP + "delete-assign/",
            params: {
              id: email.id,
            },
          })
            .then(function (request) {
              $scope.people_assigned.splice(
                $scope.people_assigned.indexOf(email),
                1
              );
              assignModalView($scope, $uibModalInstance, vm.insurance.id, url);
            })
            .catch(function (e) {
              console.log("e", e);
            });
        };
        $scope.accesos = $sessionStorage.permisos;
        if ($scope.accesos) {
          $scope.accesos.forEach(function (perm) {
            if (perm.model_name == "Archivos") {
              $scope.acceso_files = perm;
              $scope.acceso_files.permissions.forEach(function (acc) {
                if (acc.permission_name == "Administrar archivos sensibles") {
                  if (acc.checked == true) {
                    $scope.permiso_archivos = true;
                  } else {
                    $scope.permiso_archivos = false;
                  }
                }
                if (acc.permission_name == "Administrar adjuntos") {
                  if (acc.checked == true) {
                    $scope.permiso_administrar_adjuntos = true;
                  } else {
                    $scope.permiso_administrar_adjuntos = false;
                  }
                }
              });
            }
          });
        }
        if ($scope.permiso_administrar_adjuntos) {
          $http
            .get(url.IP + "polizas/" + policy_id + "/archivos/")
            .then(function (response) {
              $scope.files = response.data.results;
              $scope.files.forEach(function (file) {
                file["to_send"] = false;
                file["origin"] = "P";
              });
              $http
                .post(url.IP + "get-recibos-files/", { poliza_id: policy_id })
                .then(function (response) {
                  $scope.recibos_file = response.data;
                  $scope.recibos_file.forEach(function (file_r) {
                    file_r["origin"] = "R";
                    $scope.files.push(file_r);
                  });
                  $scope.files.forEach(function (file) {
                    file["to_send"] = false;
                  });
                });
            });
        }

        $scope.shareFileEmail = function (file) {
          if (file.to_send) {
            file.to_send = false;
          } else {
            file.to_send = true;
          }
          share_via_email = [];
          share_via_email_r = [];
          $scope.files.forEach(function (filex) {
            if (filex.to_send && filex.origin == "P") {
              share_via_email.push(filex.id);
            }
            if (filex.to_send && filex.origin == "R") {
              share_via_email_r.push(filex.id);
            }
          });
        };

        $scope.shareFile = function (file) {
          $http
            .get(url.IP + "patch-policy-file/" + file.id)
            .then(function (response) {
              $scope.files.some(function (filex) {
                if (filex.id == response.data.id) {
                  filex.shared = response.data.shared;
                }
              });
              $scope.files[file] = response.data;
              // $scope.shared = response.data.shared;
            });
        };

        $scope.assignPolicy = function (email) {
          var l = Ladda.create(document.querySelector(".ladda-button"));
          l.start();
          if (validateEmail(email) == false) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
            return;
          }
          var assign = {
            is_owner: vmm.is_owner,
            active: true,
            poliza: policy_id,
            email: email,
          };
          $http
            .post(url.IP + "assign-pendient/", assign)
            .then(function (response) {
              if (response.status === 200 || response.status === 201) {
                if (response.data.type == 1) {
                  l.stop();
                  SweetAlert.swal(
                    "Advertencia",
                    MESSAGES.INFO.POLICYASSIGNED,
                    "warning"
                  );
                  var params = {
                    model: 1,
                    event: "POST",
                    associated_id: policy_id,
                    identifier: "compartió la póliza por app.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                } else {
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.INFO.POLICYPENDIENT,
                    "success"
                  );
                  var params = {
                    model: 1,
                    event: "POST",
                    associated_id: policy_id,
                    identifier: "compartió la póliza por app.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                }
              }
            });
          $uibModalInstance.dismiss("cancel");
        };

        function validateEmail(email) {
          var re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        }

        $scope.cancel = function () {
          if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
        };
      }
    };

    $scope.deletePolicy = function () {
      SweetAlert.swal(
        {
          title: "Eliminar Colectividad",
          text: "Los cambios no podrán revertirse, ¿Está seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .post(url.IP + "delete-colectivity/", { id: $scope.caratula.id })
              .then(function (response) {
                if ($scope.copy_policy_history) {
                  if ($scope.copy_policy_history.url) {
                    if (
                      process(
                        datesFactory.convertDate(
                          $scope.copy_policy_history.start_of_validity
                        )
                      ) > process(datesFactory.convertDate(new Date()))
                    ) {
                      var data = {
                        status: 10,
                        renewed_status: 0,
                      };
                    } else {
                      if (
                        process(
                          datesFactory.convertDate(
                            $scope.copy_policy_history.end_of_validity
                          )
                        ) > process(datesFactory.convertDate(new Date()))
                      ) {
                        var data = {
                          status: 14,
                          renewed_status: 0,
                        };
                      } else {
                        var data = {
                          status: 13,
                          renewed_status: 0,
                        };
                      }
                    }
                    function process(date) {
                      var parts = date.split("/");
                      var date = new Date(
                        parts[1] + "/" + parts[0] + "/" + parts[2]
                      );
                      return date.getTime();
                    }
                    $http
                      .patch($scope.copy_policy_history.url, data)
                      .then(function success(request) {
                        if (request.status === 200) {
                          var paramsRec = {
                            model: 18,
                            event: "PATCH",
                            associated_id: $scope.copy_policy_history.id,
                            identifier: " eliminó la renovación.",
                          };
                          dataFactory
                            .post("send-log/", paramsRec)
                            .then(function success(response) {});
                        }
                      })
                      .catch(function (e) {
                        console.log("error", e);
                      });
                  }
                }

                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.DELETECOLLECTIVITY,
                  "success"
                );
                $state.go("polizas.table");
              })
              .catch(function (e) {
                console.log("error", e);
              });
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La colectividad no se ha eliminado",
              "error"
            );
          }
        }
      );
    };

    $scope.goToPolicy = function (policy) {
      if (policy.document_type == 11) {
        $state.go("flotillas.info", { polizaId: policy.id });
      } else if (policy.document_type == 12) {
        $state.go("flotillas.info", { polizaId: parseInt(policy.caratula) });
      }
    };

    $scope.getLog = function () {
      dataFactory
        .get("get-specific-log", {
          model: 18,
          associated_id: $scope.caratula.id,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    };

    $scope.getLogCertificate = function (param) {
      dataFactory
        .get("get-specific-log", { model: 1, associated_id: param.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    };

    $scope.goToEndorsement = function (name, route, certificate) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      if (!$localStorage["save_filters_endoso_poliza"]) {
        $localStorage["save_filters_endoso_poliza"] = {};
        $localStorage["save_filters_endoso_poliza"]["poliza"] =
          certificate.poliza_number;
        $localStorage["save_filters_endoso_poliza"]["poliza_id"] =
          certificate.id;
      } else {
        $localStorage["save_filters_endoso_poliza"] = {};
      }
      var params = {
        myInsurance: $scope.certificate,
        contractor: $scope.contractorModal,
      };
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.showItemCertificate = function (value) {
      switch (value) {
        case 1:
          $scope.show_tableCertificate = true;
          $scope.show_infoCertificate = false;
          $scope.show_editCertificate = false;
          $scope.show_massCertificate = false;
          $scope.show_receiptCertificate = false;
          $scope.show_showReceiptCertificate = false;
          $scope.infoFlagCertificate = true;
          $scope.endorsementFlagCertificate = false;
          $scope.siniesterFlagCertificate = false;
          $scope.paqueteLay = undefined;
          $scope.sucursalLay = undefined;
          break;
        case 2:
          $scope.show_tableCertificate = false;
          $scope.show_infoCertificate = true;
          $scope.show_editCertificate = false;
          $scope.show_massCertificate = false;
          $scope.show_receiptCertificate = false;
          $scope.show_showReceiptCertificate = false;
          break;
        case 3:
          $scope.show_tableCertificate = false;
          $scope.show_infoCertificate = false;
          $scope.show_editCertificate = true;
          $scope.show_massCertificate = false;
          $scope.show_receiptCertificate = false;
          $scope.show_showReceiptCertificate = false;
          break;
        case 4:
          $scope.show_tableCertificate = false;
          $scope.show_infoCertificate = false;
          $scope.show_editCertificate = false;
          $scope.show_massCertificate = true;
          $scope.show_receiptCertificate = false;
          $scope.show_showReceiptCertificate = false;
          $http.get(url.IP + "sucursales-to-show/").then(function (reesp) {
            $scope.sucursalesLay = reesp.data.results;
          });
          $scope.cancelCertificates();
          $scope.paqueteAll();
          break;
        case 5:
          $scope.show_tableCertificate = false;
          $scope.show_infoCertificate = false;
          $scope.show_editCertificate = false;
          $scope.show_massCertificate = false;
          $scope.show_receiptCertificate = true;
          $scope.show_showReceiptCertificate = false;

          $scope.calculateReceipts();
          break;
        case 6:
          $scope.show_tableCertificate = false;
          $scope.show_infoCertificate = false;
          $scope.show_editCertificate = false;
          $scope.show_massCertificate = false;
          $scope.show_receiptCertificate = false;
          $scope.show_showReceiptCertificate = true;

          $scope.showReceiptsCertificate();
          break;
        default:
          $scope.show_tableCertificate = true;
          $scope.show_infoCertificate = false;
          $scope.show_editCertificate = false;
          $scope.show_massCertificate = false;
      }
    };

    $scope.allCertificates = function (parPage) {
      $scope.showItemCertificate(1);
      $scope.cadena = "";
      $scope.allExcel = true;
      $scope.categorySelected.id = $scope.caratula.id;
      $scope.categorySelected.is_category = 0;
      $scope.categorySelected.certificates = [];
      $http({
        method: "POST",
        url: url.IP + "get_caratula_polizas/",
        data: {
          caratula: $scope.caratula.id,
        },
      })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.dataCaratula = response.data.data.caratula;

            $http({
              method: "GET",
              url: url.IP + "certificados-caratula/",
              params: {
                caratula: $scope.dataCaratula.id,
                page: parPage ? parPage : 1,
              },
            }).then(function (data) {
              $scope.categorySelected.certificates = data.data.results;
              $scope.categorySelected.config = {
                count: data.data.count,
                previous: data.data.previous,
                next: data.data.next,
              };
              $scope.testPagination(
                "categorySelected.certificates",
                "categorySelected.config"
              );
              if ($scope.categorySelected.certificates.length > 0) {
                $scope.getEndorsementSiniester();
              }
              $scope.categorySelected.certificates.forEach(function (item) {
                if (item.life_policy.length) {
                  item.datos = angular.copy(item.life_policy[0]);
                } else if (item.accidents_policy.length) {
                  item.datos = angular.copy(item.accidents_policy[0]);
                } else if (item.automobiles_policy.length) {
                  item.datos = angular.copy(item.automobiles_policy[0]);
                } else if (item.damages_policy.length) {
                  item.datos = angular.copy(item.damages_policy[0]);
                }
              });
              $scope.incompleteCollective();
            });
          } else {
            SweetAlert.swal(
              "Error",
              "Ocurrió un error, por favor intenta de nuevo.",
              "Error"
            );
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };
    $scope.cambiarReferenciador = function (data, poliza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/referenciadores.modal.html",
        controller: ReferenciadorModalCtrl,
        controllerAs: "vendedor",
        size: "lg",
        resolve: {
          poliza: function () {
            return poliza;
          },
          actual: function () {
            return data.data;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(
        function (response) {
          activate();
        },
        function () {
          activate();
          console.info("modal closed");
        }
      );
    };
    function ReferenciadorModalCtrl(
      poliza,
      actual,
      $http,
      $rootScope,
      $uibModalInstance,
      dataFactory,
      SweetAlert,
      datesFactory,
      $localStorage,
      $scope
    ) {
      var vmm = this;
      $scope.referenciador_a_cambiar = actual;
      $scope.poliza_especifica = poliza;
      $scope.comisionError2 = "";
      activate();

      function activate() {
        // -------------------------Referenciadores
        dataFactory.get("get-vendors/").then(function (user) {
          user.data.forEach(function (vn) {
            vn.first_name = vn.first_name.toUpperCase();
            vn.last_name = vn.last_name.toUpperCase();
            vn.name = vn.first_name + " " + vn.last_name;
          });
          $scope.referenciadores = user.data.filter(function (vn) {
            return vn.id !== actual.id;
          });
          $scope.ref_to_patch_policy = "";
          $scope.ref_to_change_id = "";
          poliza.ref_policy.filter(function (vn) {
            if (vn.referenciador == actual.url) {
              $scope.ref_to_patch_policy = vn.url;
              $scope.ref_to_change_id = vn.id;
            }
          });
        });
      }
      $scope.validateComision = function () {
        // if ($scope.comision_vendedor > 100) {
        //   $scope.comision_vendedor = 100;
        // } else if ($scope.comision_vendedor < 0) {
        //   $scope.comision_vendedor = 0;
        // }
        $scope.checkTotalComision2($scope.comision_vendedor);
      };

      $scope.checkTotalComision2 = function (valor) {
        var totalComision = poliza.ref_policy.reduce(function (sum, item) {
          if (item.id !== $scope.ref_to_change_id) {
            return sum + (parseFloat(item.comision_vendedor) || 0);
          }
          return sum;
        }, 0);
        totalComision += parseFloat(valor);
        if (totalComision > 100) {
          $scope.comisionError2 =
            "La suma de las comisiones no puede superar el 100%";
          $scope.comision_vendedor = 0;
        } else {
          $scope.comisionError2 = "";
        }
      };
      $scope.cambiar = function (refe, comision) {
        var ref = {};
        ref.referenciador = refe.url;
        ref.comision_vendedor = comision ? comision : 0;
        ref.policy = poliza.url;
        ref.anterior = $scope.ref_to_change_id;
        ref.is_changed = false;
        if (ref.referenciador) {
          dataFactory
            .post("referenciadores-policy/", ref)
            .then(
              function success(response_ref_created) {
                $scope.ref_cambiado = response_ref_created.data;
                console.log(
                  "response to create new ref***",
                  response_ref_created
                );
                // set flat to last refer
                $http
                  .patch($scope.ref_to_patch_policy, { is_changed: true })
                  .then(function (response_patch_ref_last) {
                    var params = {
                      model: 1,
                      event: "POST",
                      associated_id: poliza.id,
                      identifier:
                        "cambio el Referenciador: " +
                        $scope.referenciador_a_cambiar.first_name +
                        " " +
                        $scope.referenciador_a_cambiar.last_name +
                        " por " +
                        $scope.ref_cambiado.ref_name,
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                    setTimeout(function () {}, 1500);
                    $uibModalInstance.dismiss("cancel");
                  })
                  .catch(function (e) {
                    console.log("error", e);
                  });
              },
              function error(error) {
                console.log(error);
              }
            )
            .catch(function (e) {
              console.log(e);
            });
        } else {
          console.log("___Sin referenciador__");
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    $scope.search = function (param) {
      if (param) {
        $scope.cadena = param;
        $scope.allExcel = false;
        $http({
          method: "GET",
          url: url.IP + "search-polizascaratula/",
          params: {
            cadena: param,
            parent: $scope.categorySelected.id,
          },
        })
          .then(function success(response) {
            if (response.status == 200) {
              $scope.categorySelected.certificates = response.data.results;
              $scope.categorySelected.config = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };
              $scope.testPagination(
                "categorySelected.certificates",
                "categorySelected.config"
              );
              if ($scope.categorySelected.certificates.length > 0) {
                $scope.getEndorsementSiniester();
              }
              $scope.categorySelected.certificates.forEach(function (item) {
                if (item.life_policy.length) {
                  item.datos = angular.copy(item.life_policy[0]);
                } else if (item.accidents_policy.length) {
                  item.datos = angular.copy(item.accidents_policy[0]);
                } else if (item.automobiles_policy.length) {
                  item.datos = angular.copy(item.automobiles_policy[0]);
                } else if (item.damages_policy.length) {
                  item.datos = angular.copy(item.damages_policy[0]);
                }
              });
            } else {
              SweetAlert.swal(
                "Error",
                "Ocurrió un error, por favor intenta de nuevo.",
                "Error"
              );
            }
          })
          .catch(function (e) {
            console.log("error", e);
          });
      } else {
        $scope.allCertificates(1);
      }
    };

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.selectPage = function (parPage) {
        var url = "";
        if (config_.next || config_.previous) {
          if (config_.next) {
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            url = config_.next.substring(0, config_.next.indexOf("&page=") + 6);
            url += parPage.toString();

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            url = "";
            var otherParameters = config_.previous.substring(
              config_.previous.indexOf("&page=") + 6
            );

            if (config_.previous.search("&page=") !== -1) {
              url = config_.previous.substring(
                0,
                config_.previous.indexOf("&page=") + 6
              );
              url += parPage.toString();
            } else {
              url = config_.previous;
            }

            if (config_.previous.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }

        getProviders(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }

        $scope.allCertificates(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;
        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      $scope.lastPage = function () {
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      function getProviders(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(response) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, response.data.results);

              var data = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };

              if ($scope.categorySelected.certificates.length) {
                $scope.categorySelected.certificates.forEach(function (
                  item,
                  index
                ) {
                  var pagesCertificates = {
                    policy: item.id,
                  };
                  dataFactory
                    .get("get-endosos-sinister/", pagesCertificates)
                    .then(function success(response) {
                      item.endosos = response.data.endosos;
                      item.siniestros = response.data.siniestros;
                    });

                  if (item.life_policy.length) {
                    item.datos = angular.copy(item.life_policy[0]);
                  } else if (item.accidents_policy.length) {
                    item.datos = angular.copy(item.accidents_policy[0]);
                  } else if (item.automobiles_policy.length) {
                    item.datos = angular.copy(item.automobiles_policy[0]);
                  } else if (item.damages_policy.length) {
                    item.datos = angular.copy(item.damages_policy[0]);
                  }
                });
              }

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    $scope.getEndorsementSiniester = function () {
      $scope.categorySelected.certificates.forEach(function (item, index) {
        $http({
          method: "GET",
          url: url.IP + "get-endosos-sinister/",
          params: {
            policy: item.id,
          },
        })
          .then(function success(response) {
            item.endosos = response.data.endosos;
            item.siniestros = response.data.siniestros;
          })
          .catch(function (e) {
            console.log("error", e);
          });

        if (item.life_policy.length) {
          item.datos = angular.copy(item.life_policy[0]);
        } else if (item.accidents_policy.length) {
          item.datos = angular.copy(item.accidents_policy[0]);
        } else if (item.automobiles_policy.length) {
          item.datos = angular.copy(item.automobiles_policy[0]);
        } else if (item.damages_policy.length) {
          item.datos = angular.copy(item.damages_policy[0]);
        }
      });
    };

    $scope.downloadExcel = function (parCategory, active) {
      $scope.filtros = {
        is_category: $scope.categorySelected
          ? $scope.categorySelected.is_category
          : 0,
        parent: parCategory ? parCategory.id : $scope.caratula.id,
        active: $scope.statusActive,
        cadena: $scope.cadena ? $scope.cadena : "",
      };
      $http({
        method: "POST",
        url: url.IP + "service_reporte-caratulapolizas-excel",
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Polizas_Individuales_Colectividad.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
    };

    $scope.downloadExcelAll = function (caratula, active) {
      $scope.filtros = {
        // parent: caratula.id,
        // active: 3
        is_category: $scope.categorySelected
          ? $scope.categorySelected.is_category
          : 0,
        parent: $scope.categorySelected
          ? $scope.categorySelected.id
          : $scope.caratula.id,
        active: $scope.statusActive,
        cadena: $scope.cadena ? $scope.cadena : "",
      };
      $http({
        method: "POST",
        url: url.IP + "service_reporte-caratulapolizas-excel",
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_PolizasCaratula.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
    };

    $scope.selectCerficate = function (item) {
      $scope.existeNuevaHijo = false;
      $scope.certificate = item;
      if ($scope.certificate.business_line) {
        if ($scope.certificate.business_line.id) {
          $scope.certificate.business_line =
            $scope.certificate.business_line.id;
        }
      }
      if ($scope.certificate.forma_de_pago.value) {
        $scope.certificate.forma_de_pago =
          $scope.certificate.forma_de_pago.value;
      }
      if ($scope.certificate.is_renewable.value) {
        $scope.certificate.is_renewable = $scope.certificate.is_renewable.value;
      }

      // if ($scope.caratula.natural) {
      //   $scope.type_url = 'fisicas-app/';
      //   $scope.id_contractror = $scope.caratula.natural;
      // } else {
      //   $scope.type_url = 'morales-app/';
      //   $scope.id_contractror = $scope.caratula.juridical;
      // }
      $scope.type_url = "contractors-app/";
      // $scope.id_contractror = $scope.caratula.contractor;
      $scope.id_contractror = item.contractor
        ? item.contractor.id
        : $scope.caratula.contractor;
      dataFactory
        .get($scope.type_url + $scope.id_contractror)
        .then(function success(response) {
          $scope.certificate.contractor = response.data;
          $scope.certificate.contractor.address =
            $scope.certificate.contractor.address_contractor;
        });

      $http({
        method: "GET",
        url: url.IP + "historic-policies/",
        params: {
          actual_id: $scope.certificate.id,
        },
      })
        .then(function success(response) {
          $scope.certificate_history = [];
          if (response.data.results.length) {
            response.data.results.forEach(function function_name(old, index) {
              // if($scope.caratula.id != old.base_policy.id){
              if ($scope.certificate.id != old.base_policy.id) {
                $scope.certificate_history.push(old.base_policy);
                if (index == 0) {
                  $scope.copy_certificate_history = angular.copy(
                    old.base_policy
                  );
                }
              } else if (old.new_policy) {
                $scope.certificate_history.push(old.new_policy);
                $scope.existeNuevaHijo = true;
              }
            });
          }
        })
        .catch(function (e) {
          console.log("error - caratula - catch", e);
        });

      $http
        .get(url.IP + "polizas/" + item.id + "/archivos/")
        .then(function (response) {
          item.files = response.data.results;
        })
        .catch(function (e) {
          console.log("error", e);
        });

      if ($scope.caratula.recibos_poliza) {
        $scope.total_prima_certificate = 0;
        $scope.total_rpf_certificate = 0;
        $scope.total_derecho_certificate = 0;
        $scope.total_iva_certificate = 0;
        $scope.total_total_certificate = 0;
        $scope.total_comision_certificate = 0;
        item.recibos_poliza.forEach(function (receipt) {
          if (receipt.receipt_type == 1) {
            $scope.total_prima_certificate =
              parseFloat($scope.total_prima_certificate) +
              parseFloat(receipt.prima_neta);
            $scope.total_rpf_certificate =
              parseFloat($scope.total_rpf_certificate) +
              parseFloat(receipt.rpf);
            $scope.total_derecho_certificate =
              parseFloat($scope.total_derecho_certificate) +
              parseFloat(receipt.derecho);
            $scope.total_iva_certificate =
              parseFloat($scope.total_iva_certificate) +
              parseFloat(receipt.iva);
            $scope.total_total_certificate =
              parseFloat($scope.total_total_certificate) +
              parseFloat(receipt.prima_total);
            $scope.total_comision_certificate =
              parseFloat($scope.total_comision_certificate) +
              parseFloat(receipt.comision);
          }
        });
      }
      $scope.showItemCertificate(2);
    };

    $scope.changeStatusModal = function (receipt, contra, insurance) {
      receipt.isDB = false;
      receipt.contratante = contra;
      var index = insurance.recibos_poliza.indexOf(receipt);
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return insurance;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (recibo) {
        switch (recibo.status) {
          case 1:
            receipt.status = "Pagado";
            break;
          case 2:
            receipt.status = "Cancelado";
            break;
          case 3:
            receipt.status = "Prorrogado";
            break;
          case 4:
            receipt.status = "Pendiente de Pago";
            break;
          case 5:
            receipt.status = "Liquidado";
            break;
          case 6:
            receipt.status = "Conciliado";
            break;
          case 7:
            receipt.status = "Cerrado";
            break;
          case 8:
            receipt.status = "Precancelado";
            break;
          default:
            receipt.status = parValue.status;
        }
        // activate();
      });
    };

    $scope.deleteCertificate = function (item) {
      SweetAlert.swal(
        {
          title: "Eliminar póliza",
          text: "Se eliminará la póliza y no se podrá recuperar después, ¿Estás Seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "¡Si, Estoy Seguro!",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(item.url).then(function (response) {
              if (response.status == 204) {
                var params = {
                  model: 18,
                  event: "POST",
                  associated_id: $scope.caratula.id,
                  identifier:
                    " eliminó la póliza individual " + item.poliza_number + ".",
                };

                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                SweetAlert.swal(
                  "¡Listo!",
                  "Póliza eliminada correctamente.",
                  "success"
                );
                activate();
              }
            });
            $scope.categorySelected.certificates.splice(
              $scope.categorySelected.certificates.indexOf(item),
              1
            );
          }
        }
      );
    };

    $scope.editCerficate = function (item) {
      $scope.directiveReceipts.is_edit = true;
      $scope.originCertificate = [];
      $scope.isEdit = true;
      if ($localStorage.save_edition_flotilla_poliza) {
        if ($localStorage.save_edition_flotilla_poliza["id"] == item.id) {
          $scope.newCertificate = $localStorage.save_edition_flotilla_poliza;
        } else {
          $scope.newCertificate = item;
        }
      } else {
        $scope.newCertificate = item;
      }
      $scope.dataToSave.recalcular = true;

      $scope.dataToSave.poliza = {
        primaNeta: parseFloat(item.p_neta),
        rpf: parseFloat(item.rpf),
        derecho: parseFloat(item.derecho),
        subTotal: parseFloat(item.sub_total),
        iva: parseFloat(item.iva),
        primaTotal: parseFloat(item.p_total),
      };
      $scope.dataToSave.receipts = [];
      item.recibos_poliza.forEach(function (receipt) {
        if (receipt.receipt_type == 1) {
          receipt.fecha_inicio = datesFactory.convertDate(receipt.fecha_inicio);
          receipt.fecha_fin = datesFactory.convertDate(receipt.fecha_fin);
          receipt.vencimiento = datesFactory.convertDate(receipt.vencimiento);
          if (receipt.status != "Pendiente de pago") {
            $scope.dataToSave.recalcular = false;
          }
          $scope.dataToSave.receipts.push(receipt);
        }
      });
      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: item.ramo.id,
          subramo: item.subramo.id,
          provider: item.aseguradora
            ? item.aseguradora.id
            : $scope.caratula.aseguradora.id,
        })
        .then(function success(response) {
          if (response.status === 200) {
            $scope.packages = [];
            if (response.data.length) {
              $scope.packages = response.data;
              $scope.packages.forEach(function (pack) {
                if (pack.id == $scope.newCertificate.paquete.id) {
                  $scope.newCertificate.paquete = pack;
                }
              });
            }
          }
        })
        .catch(function (error) {
          console.log("error", e);
        });
      if ($scope.newCertificate.start_of_validity.indexOf("-") != -1) {
        $scope.newCertificate.start_of_validity = datesFactory.convertDate(
          $scope.newCertificate.start_of_validity
        );
      }
      if ($scope.newCertificate.end_of_validity.indexOf("-") != -1) {
        $scope.newCertificate.end_of_validity = datesFactory.convertDate(
          $scope.newCertificate.end_of_validity
        );
      }
      order.contratante = {};
      // if(item.natural){
      //   order.contratante.val = item.natural.full_name;
      //   order.contratante.value = item.natural;
      // }else{
      //   order.contratante.val = item.juridical.j_name;
      //   order.contratante.value = item.juridical;
      // }
      order.contratante.val = item.contractor.full_name;
      order.contratante.value = item.contractor;
      $scope.frequencies.forEach(function (item) {
        if (item.value == $scope.newCertificate.forma_de_pago) {
          $scope.newCertificate.forma_de_pago = item;
        }
      });
      $scope.renewals.forEach(function (item) {
        if (item.value == $scope.newCertificate.is_renewable) {
          $scope.newCertificate.is_renewable = item;
        }
      });
      $scope.businessline.forEach(function (item) {
        if (item.id == $scope.newCertificate.business_line) {
          $scope.newCertificate.business_line = item;
        }
      });
      if ($scope.newCertificate.sucursal) {
        $scope.sucursales.forEach(function (item) {
          if (item.id == $scope.newCertificate.sucursal.id) {
            $scope.newCertificate.sucursal = item;
          }
        });
      }
      if ($scope.newCertificate.responsable) {
        $scope.users.forEach(function (item) {
          if (item.id == $scope.newCertificate.responsable.id) {
            $scope.newCertificate.responsable = item;
          }
        });
      }
      if ($scope.newCertificate.automobiles_policy.length) {
        $scope.types.forEach(function (item) {
          if (item.id == $scope.newCertificate.datos.policy_type) {
            $scope.newCertificate.datos.policy_type = item;
          }
        });
        $scope.usages.forEach(function (item) {
          if (item.value == $scope.newCertificate.datos.usage) {
            $scope.newCertificate.datos.usage = item;
          }
        });
        $scope.procedencias.forEach(function (item) {
          if (item.value == $scope.newCertificate.datos.procedencia) {
            $scope.newCertificate.datos.procedencia = item;
          }
        });
      }

      if ($scope.newCertificate.state_circulation) {
        $scope.statesArray.forEach(function (item) {
          if (item.id == parseInt($scope.newCertificate.state_circulation)) {
            $scope.newCertificate.state_circulation = item;
          }
        });
      }

      $scope.directiveReceipts.payment = $scope.newCertificate.forma_de_pago;
      $scope.directiveReceipts.subramo = item.subramo;
      $scope.copy_inicio = angular.copy(
        $scope.newCertificate.start_of_validity
      );
      $scope.copy_fin = angular.copy($scope.newCertificate.end_of_validity);
      $scope.checkDate($scope.copy_inicio);
      $scope.checkEndDate($scope.copy_fin);
      $scope.showItemCertificate(3);
    };
    $scope.returnInfo = function () {
      $scope.newCertificate.contractor = order.contratante.value;
      $scope.show_section(2);
      $scope.showItemCertificate(1);
    };
    $scope.return = function () {
      // if(order.contratante.value.address_natural){
      //   $scope.newCertificate.natural = order.contratante.value;
      // }else{
      //   $scope.newCertificate.juridical = order.contratante.value;
      // }
      $scope.newCertificate.contractor = order.contratante.value;
      $scope.showItemCertificate(1);
    };

    $scope.checkDate = function (param) {
      if (param) {
        if (param.length == 10) {
          // var date_initial = (param).split('/');
          // var day = date_initial[0];
          // var month = date_initial[1];
          // var year = parseInt(date_initial[2]);

          // if(day.length == 1){
          //   day = '0' + day;
          // }
          // if(month.length == 1){
          //   month = '0' + month;
          // }

          // $scope.startDate = param;
          // $scope.endDate = datesFactory.convertDate(new Date(month + '/' + day + '/' + (year + 1)));
          // $scope.newCertificate.start_of_validity = new Date(month + '/' + day + '/' + year).toISOString();
          // $scope.newCertificate.end_of_validity = new Date(month + '/' + day + '/' + (year + 1)).toISOString();

          if (process(param) > process($scope.newCertificate.end_of_validity)) {
            SweetAlert.swal(
              "Error",
              "La fecha inicio no puede ser mayor a la fecha fin.",
              "error"
            );
            return;
          }

          function process(date) {
            var parts = date.split("/");
            var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
            return date.getTime();
          }
        } else {
          // var day = new Date().getDate();
          // var month = new Date().getMonth() + 1;
          // var year = new Date().getFullYear();
          // $scope.startDate = param;
          // $scope.endDate = datesFactory.convertDate(new Date(month + '/' + day + '/' + (year + 1)));
          // $scope.newCertificate.start_of_validity = new Date(month + '/' + day + '/' + year).toISOString();
          // $scope.newCertificate.end_of_validity = new Date(month + '/' + day + '/' + (year + 1)).toISOString();
        }
        $scope.directiveReceipts.startDate =
          $scope.newCertificate.start_of_validity;
        $scope.directiveReceipts.endingDate =
          $scope.newCertificate.end_of_validity;
        var date1 = new Date(
          datesFactory.toDate($scope.newCertificate.start_of_validity)
        );
        var date2 = new Date(
          datesFactory.toDate($scope.newCertificate.end_of_validity)
        );
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        $scope.directiveReceipts.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
        $scope.directiveReceipts.domiciliado = false;
      }
    };

    $scope.checkEndDate = function (param) {
      if (param) {
        if (param.length == 10) {
          if (
            process(param) < process($scope.newCertificate.start_of_validity)
          ) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
            return;
          }

          function process(date) {
            var parts = date.split("/");
            var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
            return date.getTime();
          }

          $scope.directiveReceipts.endingDate = param;
          var date1 = new Date(
            datesFactory.toDate($scope.newCertificate.start_of_validity)
          );
          var date2 = new Date(
            datesFactory.toDate($scope.newCertificate.end_of_validity)
          );
          var timeDiff = Math.abs(date2.getTime() - date1.getTime());
          $scope.directiveReceipts.policy_days_duration = Math.ceil(
            timeDiff / (1000 * 3600 * 24)
          );
        }
      }
    };

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if ($scope.referenciadores) {
          $scope.referenciadores.some(function (user) {
            if (user.url == order.contratante.value.vendor) {
              $scope.referenciadorArray[0] = {
                referenciador: user.id,
                comision_vendedor: "",
              };
            }
          });
        }
        // if(order.contratante.value.address_natural || order.contratante.value.address_juridical){
        if (order.contratante.value.address_contractor) {
          // if(order.contratante.value.address_natural){
          //   $scope.newCertificate.natural = order.contratante.value.url;
          //   $scope.newCertificate.juridical = null;
          //   $scope.addresses = order.contratante.value.address_natural;
          // }else{
          //   $scope.newCertificate.natural = null;
          //   $scope.newCertificate.juridical = order.contratante.value.url;
          //   $scope.addresses = order.contratante.value.address_juridical;
          // }
          // if($scope.addresses.length == 1){
          //   $scope.addressSelected = $scope.addresses[0];
          //   $scope.newCertificate.address = $scope.addresses[0].url;
          // }
          if (order.contratante.value.address_contractor) {
            $scope.newCertificate.contractor = order.contratante.value.url;
            $scope.newCertificate.contractor_new = order.contratante.value.id;
            $scope.addresses = order.contratante.value.address_contractor;
          }
          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.newCertificate.address = $scope.addresses[0];
            $scope.newCertificate.address_new = $scope.addresses[0].id;
          }
          if (
            order.contratante &&
            order.contratante.value &&
            order.contratante.value.sucursal
          ) {
            dataFactory
              .get("sucursales-to-show-unpag/")
              .then(function success(response) {
                if (response.status === 200 || response.status === 201) {
                  $scope.sucursales = response.data;
                  if ($scope.sucursales && order.contratante.value) {
                    $scope.sucursales.forEach(function (item) {
                      if (item.url == order.contratante.value.sucursal) {
                        $scope.newCertificate.sucursal = item;
                      }
                    });
                  }
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
        }
      }
    });

    $scope.changeAddress = function (param) {
      // $scope.newCertificate.address = param;
      // console.log('url------',param,$scope.newCertificate.address)
    };

    $scope.changePackageLay = function (pkg) {
      $localStorage.saved_flotilla_info["paqueteLay"] = pkg;
    };

    $scope.changeSucursalLay = function (sucursal) {
      console.log(sucursal);
      $localStorage.saved_flotilla_info["sucursalLay"] = sucursal;
    };

    $scope.validateCertificate = function () {
      if (!$scope.directiveReceipts.canCreate) {
        SweetAlert.swal(
          "Error",
          "OPRIMA EL BOTON CALCULAR Y GENERAR RECIBOS",
          "error"
        );
        return;
      }
      if (!$scope.newCertificate.poliza_number) {
        SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
        return;
      }
      if (!$scope.newCertificate.start_of_validity) {
        SweetAlert.swal(
          "Error",
          "Agrega una fecha de vigencia inicio.",
          "error"
        );
        return;
      }
      // if(!$scope.newCertificate.end_of_validity){
      //   SweetAlert.swal('Error', 'Agrega una fecha de vigencia fin.', 'error');
      //   return;
      // }else{
      //   if(process($scope.newCertificate.start_of_validity) < process(datesFactory.convertDate($scope.caratula.start_of_validity)) || process($scope.newCertificate.end_of_validity) > process(datesFactory.convertDate($scope.caratula.end_of_validity))){
      //     SweetAlert.swal("Error", MESSAGES.WARNING.VALIDITYOUTRANGE, "error");
      //     return;
      //   }
      //   function process(date){
      //     var parts = date.split("/");
      //     var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
      //     return date.getTime();
      //   }
      // }
      if (!order.contratante.val) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        return;
      }
      if (!$scope.newCertificate.address) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        return;
      }
      if (!order.contratante.value.email) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORWITHOUTEMAIL, "error");
        return;
      }
      // if(!order.contratante.value.phone_number){
      //   SweetAlert.swal('Error', MESSAGES.ERROR.PHONE, 'error');
      //   return;
      // }
      if (!$scope.newCertificate.forma_de_pago) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORPAYFORM, "error");
        return;
      }
      if (!$scope.newCertificate.is_renewable) {
        SweetAlert.swal("Error", "Selecciona si es renovable", "error");
        return;
      }
      if (!$scope.newCertificate.f_currency) {
        SweetAlert.swal("Error", "Selecciona una moneda.", "error");
        return;
      }
      if (!$scope.newCertificate.paquete) {
        SweetAlert.swal("Error", "Selecciona un paquete.", "error");
        return;
      }
      if (!$scope.newCertificate.datos.policy_type) {
        SweetAlert.swal("Error", "Agrega un tipo.", "error");
        return;
      }
      if ($scope.caratula.subramo == "Automóviles") {
        if (!$scope.newCertificate.datos.brand) {
          SweetAlert.swal("Error", "Agrega una marca.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.model) {
          SweetAlert.swal("Error", "Agrega un modelo.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.year) {
          SweetAlert.swal("Error", "Agrega un año.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.version) {
          SweetAlert.swal("Error", "Agrega una versión.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.serial) {
          SweetAlert.swal("Error", "Agrega un número de serie.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.usage) {
          SweetAlert.swal("Error", "Agrega un uso.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.service) {
          SweetAlert.swal("Error", "Selecciona un servicio.", "error");
          return;
        }
      }
      if (!$scope.isEdit) {
        if (!$scope.dataToSave.recibos_poliza) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
      }

      if (!$scope.isEdit) {
        $scope.saveIndividualCertificate();
      } else {
        $scope.valueCertificate();
      }
    };
    // validatePolizaFlotilla
    $scope.validatePolizaFlotilla = function () {
      var l = Ladda.create(document.querySelector(".ladda-button-ren"));
      l.start();
      if (!$scope.directiveReceipts.canCreate) {
        l.stop();
        SweetAlert.swal(
          "Error",
          "OPRIMA EL BOTON CALCULAR Y GENERAR RECIBOS",
          "error"
        );
        return;
      }
      if (!$scope.newCertificate.poliza_number) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
        return;
      }
      if (!$scope.newCertificate.start_of_validity) {
        l.stop();
        SweetAlert.swal(
          "Error",
          "Agrega una fecha de vigencia inicio.",
          "error"
        );
        return;
      }
      if (!order.contratante.val) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        return;
      }
      if (!$scope.newCertificate.address) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        return;
      }
      if (!order.contratante.value.email) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORWITHOUTEMAIL, "error");
        return;
      }
      if (!$scope.newCertificate.forma_de_pago) {
        l.stop();
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORPAYFORM, "error");
        return;
      }
      if (!$scope.newCertificate.is_renewable) {
        l.stop();
        SweetAlert.swal("Error", "Selecciona si es renovable", "error");
        return;
      }
      if (!$scope.newCertificate.f_currency) {
        l.stop();
        SweetAlert.swal("Error", "Selecciona una moneda.", "error");
        return;
      }
      if (!$scope.newCertificate.paquete) {
        l.stop();
        SweetAlert.swal("Error", "Selecciona un paquete.", "error");
        return;
      }
      if (!$scope.newCertificate.datos.policy_type) {
        l.stop();
        SweetAlert.swal("Error", "Agrega un tipo.", "error");
        return;
      }
      if ($scope.caratula.subramo == "Automóviles") {
        if (!$scope.newCertificate.datos.brand) {
          l.stop();
          SweetAlert.swal("Error", "Agrega una marca.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.model) {
          l.stop();
          SweetAlert.swal("Error", "Agrega un modelo.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.year) {
          l.stop();
          SweetAlert.swal("Error", "Agrega un año.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.version) {
          l.stop();
          SweetAlert.swal("Error", "Agrega una versión.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.serial) {
          l.stop();
          SweetAlert.swal("Error", "Agrega un número de serie.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.usage) {
          l.stop();
          SweetAlert.swal("Error", "Agrega un uso.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.service) {
          l.stop();
          SweetAlert.swal("Error", "Selecciona un servicio.", "error");
          return;
        }
      }
      if ($scope.isRenewal) {
        if (!$scope.dataToSave.recibos_poliza) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
      }

      if ($scope.isRenewal) {
        $scope.savePolizaFlotillaRenovacion();
      }
    };
    $scope.savePolizaFlotillaRenovacion = function () {
      var l = Ladda.create(document.querySelector(".ladda-button-ren"));
      l.start();
      $scope.certifcados = [];
      if ($scope.dataCaratula.subramo.subramo_code == 9) {
        $scope.dataToSave.recibos_poliza.forEach(function (receipt) {
          receipt.fecha_inicio = datesFactory.toDate(receipt.fecha_inicio);
          receipt.fecha_fin = datesFactory.toDate(receipt.fecha_fin);
          receipt.vencimiento = datesFactory.toDate(receipt.vencimiento);
        });

        $scope.newCertificate.datos.adjustment = $scope.newCertificate.datos
          .adjustment
          ? $scope.newCertificate.datos.adjustment
          : "";
        $scope.newCertificate.datos.beneficiary_address = $scope.newCertificate
          .datos.beneficiary_address
          ? $scope.newCertificate.datos.beneficiary_address
          : "";
        $scope.newCertificate.datos.beneficiary_rfc = $scope.newCertificate
          .datos.beneficiary_rfc
          ? $scope.newCertificate.datos.beneficiary_rfc
          : "";
        $scope.newCertificate.datos.brand = $scope.newCertificate.datos.brand
          ? $scope.newCertificate.datos.brand
          : "";
        $scope.newCertificate.datos.car_owner = $scope.newCertificate.datos
          .car_owner
          ? $scope.newCertificate.datos.car_owner
          : "";
        $scope.newCertificate.datos.charge_type = $scope.newCertificate.datos
          .charge_type
          ? $scope.newCertificate.datos.charge_type.value
          : 0;
        $scope.newCertificate.datos.color = $scope.newCertificate.datos.color
          ? $scope.newCertificate.datos.color
          : "";
        $scope.newCertificate.datos.driver = $scope.newCertificate.datos.driver
          ? $scope.newCertificate.datos.driver
          : "";
        $scope.newCertificate.datos.email = $scope.newCertificate.datos.email
          ? $scope.newCertificate.datos.email
          : "";
        $scope.newCertificate.datos.engine = $scope.newCertificate.datos.engine
          ? $scope.newCertificate.datos.engine
          : "";
        $scope.newCertificate.datos.license_plates = $scope.newCertificate.datos
          .license_plates
          ? $scope.newCertificate.datos.license_plates
          : "";
        $scope.newCertificate.datos.model = $scope.newCertificate.datos.model
          ? $scope.newCertificate.datos.model
          : "";
        $scope.newCertificate.datos.mont_adjustment = $scope.newCertificate
          .datos.mont_adjustment
          ? $scope.newCertificate.datos.mont_adjustment
          : 0;
        $scope.newCertificate.datos.mont_special_team = $scope.newCertificate
          .datos.mont_special_team
          ? $scope.newCertificate.datos.mont_special_team
          : 0;
        $scope.newCertificate.datos.no_employee = $scope.newCertificate.datos
          .no_employee
          ? $scope.newCertificate.datos.no_employee
          : 0;
        $scope.newCertificate.datos.policy_type = $scope.newCertificate.datos
          .policy_type
          ? $scope.newCertificate.datos.policy_type.id
          : 0;
        $scope.newCertificate.datos.preferential_benefiaciary = $scope
          .newCertificate.datos.preferential_benefiaciary
          ? $scope.newCertificate.datos.preferential_benefiaciary
          : 0;
        $scope.newCertificate.datos.procedencia = $scope.newCertificate.datos
          .procedencia
          ? $scope.newCertificate.datos.procedencia.value
          : 0;
        $scope.newCertificate.datos.serial = $scope.newCertificate.datos.serial
          ? $scope.newCertificate.datos.serial
          : "";
        $scope.newCertificate.datos.service = $scope.newCertificate.datos
          .service
          ? $scope.newCertificate.datos.service
          : "";
        $scope.newCertificate.datos.special_team = $scope.newCertificate.datos
          .special_team
          ? $scope.newCertificate.datos.special_team
          : "";
        $scope.newCertificate.datos.sum_insured = $scope.newCertificate.datos
          .sum_insured
          ? $scope.newCertificate.datos.sum_insured
          : "";
        $scope.newCertificate.datos.usage = $scope.newCertificate.datos.usage
          ? $scope.newCertificate.datos.usage.value
          : 0;
        $scope.newCertificate.datos.version = $scope.newCertificate.datos
          .version
          ? $scope.newCertificate.datos.version
          : "";
        $scope.newCertificate.datos.year = $scope.newCertificate.datos.year
          ? $scope.newCertificate.datos.year
          : 0;
        delete $scope.newCertificate.datos.policy;
        delete $scope.newCertificate.datos.id;
        delete $scope.newCertificate.datos.org_name;
        delete $scope.newCertificate.datos.url;

        var dataCar = [];
        if ($scope.newCertificate.address_new) {
          $scope.newCertificate.address_new = parseInt(
            $scope.newCertificate.address_new
          );
        }
        if ($scope.newCertificate.address) {
          $scope.newCertificate.address_new = $scope.newCertificate.address.id;
        }
        dataCar.push($scope.newCertificate.datos);

        var certificateData = {
          accidents_policy: [],
          address: parseInt($scope.newCertificate.address_new),
          aseguradora: $scope.caratula.nueva.aseguradora,
          automobiles_policy: dataCar,
          business_line: $scope.caratula.nueva.business_line,
          conducto_de_pago: $scope.newCertificate.conducto_de_pago,
          caratula: $scope.caratula.nueva.id,
          celula: $scope.caratula.nueva.celula,
          clave: $scope.caratula.nueva.clave,
          coverageInPolicy_policy: [],
          damages_policy: [],
          document_type: 12,
          end_of_validity: datesFactory.toDate(
            $scope.newCertificate.end_of_validity
          ),
          endorsement: false,
          collection_executive: $scope.caratula.nueva.collection_executive
            ? $scope.caratula.nueva.collection_executive.id
            : null,
          f_currency: parseInt($scope.newCertificate.f_currency),
          folio: $scope.newCertificate.folio
            ? $scope.newCertificate.folio
            : null,
          forma_de_pago: parseInt($scope.newCertificate.forma_de_pago.value),
          groupinglevel: null,
          identifier:
            $scope.newCertificate.datos.brand +
            "_" +
            $scope.newCertificate.datos.model +
            "_" +
            $scope.newCertificate.datos.year,
          internal_number: null,
          is_renewable: $scope.newCertificate.is_renewable.value,
          life_policy: [],
          // natural: parseInt($scope.naturalP),
          // juridical: parseInt($scope.juridicalP),
          contractor: parseInt($scope.newCertificate.contractor_new),
          old_policies: [],
          paquete: parseInt($scope.newCertificate.paquete.id),
          parent: $scope.caratula.nueva.url,
          // poliza: $scope.obj_poliza,
          poliza_number: $scope.newCertificate.poliza_number,
          ramo: $scope.caratula.nueva.ramo,
          recibos_poliza: $scope.dataToSave.recibos_poliza,
          responsable: $scope.caratula.nueva.responsable
            ? $scope.caratula.nueva.responsable
            : null,
          start_of_validity: datesFactory.toDate(
            $scope.newCertificate.start_of_validity
          ),
          state_circulation: $scope.newCertificate.state_circulation
            ? $scope.newCertificate.state_circulation.id
            : "",
          status: 14,
          sucursal: $scope.getSucursalId(),
          subramo: $scope.caratula.nueva.subramo,
          observations: $scope.newCertificate.observations
            ? $scope.newCertificate.observations
            : null,
          p_neta: $scope.dataToSave.p_neta ? $scope.dataToSave.p_neta : 0,
          descuento: $scope.dataToSave.descuento
            ? $scope.dataToSave.descuento
            : 0,
          rpf: $scope.dataToSave.rpf ? $scope.dataToSave.rpf : 0,
          derecho: $scope.dataToSave.derecho ? $scope.dataToSave.derecho : 0,
          iva: $scope.dataToSave.iva ? $scope.dataToSave.iva : 0,
          p_total: $scope.dataToSave.p_total ? $scope.dataToSave.p_total : 0,
          comision: $scope.dataToSave.comision ? $scope.dataToSave.comision : 0,
          comision_percent: $scope.dataToSave.comision_percent
            ? $scope.dataToSave.comision_percent
            : 0,
          comision_derecho_percent: $scope.dataToSave.poliza
            .comision_derecho_percent
            ? $scope.dataToSave.poliza.comision_derecho_percent
            : 0,
          comision_rpf_percent: $scope.dataToSave.poliza.comision_rpf_percent
            ? $scope.dataToSave.poliza.comision_rpf_percent
            : 0,
          sub_total: $scope.dataToSave.subTotal
            ? $scope.dataToSave.subTotal
            : 0,
        };
        if ($scope.caratula_renovada) {
          certificateData.caratula_renovada = $scope.caratula_renovada;
        }
        $scope.certifcados.push(certificateData);
      }

      $http({
        method: "POST",
        url: url.IP + "save_caratula_polizas/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            $localStorage.save_edition_flotilla_poliza = {};
            $scope.infoNueva = response.data[0];
            $scope.certifcados = response.data;
            l.stop();
            $scope.newCertificate = {};
            SweetAlert.swal("¡Listo!", MESSAGES.OK.RENEWALPOLICY, "success");
            var logManual = {
              model: 18,
              event: "POST",
              associated_id: $scope.caratula.id,
              identifier:
                " renovo la póliza: " +
                $scope.infoNueva.poliza_number +
                " de la colectividad de forma manual.",
            };
            dataFactory
              .post("send_log_specific/", logManual)
              .then(function success(response) {});
            var logManual = {
              model: 1,
              event: "POST",
              associated_id: $scope.polizaaRenovar.id,
              identifier:
                " renovo la póliza de flotilla: " +
                $scope.polizaaRenovar.poliza_number +
                " de la carátula: " +
                $scope.caratula.poliza_number +
                ".",
            };
            dataFactory
              .post("send_log_specific/", logManual)
              .then(function success(response) {});
            /* Relación con la póliza original */
            if ($scope.infoNueva.poliza_number) {
              var oldPolicy = {
                policy: $scope.polizaaRenovar.poliza_number,
                base_policy: $scope.polizaaRenovar.url,
                new_policy: $scope.infoNueva.url,
              };
            } else {
              var oldPolicy = {
                base_policy: $scope.polizaaRenovar.url,
                new_policy: $scope.infoNueva.url,
              };
            }
            $http
              .post(url.IP + "v1/polizas/viejas/", oldPolicy)
              .then(function (res) {})
              .catch(function (e) {
                l.stop();
                console.log("error - caratula - catch", e);
              });
            // póliza a renoavr cambiar a renovada
            $http
              .patch($scope.polizaaRenovar.url, {
                status: 12,
                renewed_status: 1,
              })
              .then(function (responsepatcharen) {
                $scope.show_renewal_certificate = false;
                $scope.isRenewal = false;
                $scope.show_certificado = true;
                $scope.show_caratula = false;
                $scope.show_certificado = true;
                l.stop();
                activate();
                $scope.showItemCertificate(4);
              })
              .catch(function (e) {
                l.stop();
                console.log("error", e);
                SweetAlert.swal("ERROR", e.data.data, "error");
              });
          } else {
            l.stop();
            SweetAlert.swal("ERROR", response.data.data, "error");
            if ($scope.newCertificate.datos.procedencia) {
              $scope.usages.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.usage) {
                  $scope.newCertificate.datos.usage = item;
                }
              });
              $scope.typesCharges.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.charge_type) {
                  $scope.newCertificate.datos.charge_type = item;
                }
              });
              $scope.procedencias.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.procedencia) {
                  $scope.newCertificate.datos.procedencia = item;
                }
              });
            }
          }
        })
        .catch(function (e) {
          console.log("error", e);
          l.stop();
          try {
            $scope.dataToSave.recibos_poliza = [];
            $scope.newCertificate.recibos_poliza = [];
            if ($scope.newCertificate.datos.procedencia) {
              $scope.usages.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.usage) {
                  $scope.newCertificate.datos.usage = item;
                }
              });
              $scope.typesCharges.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.charge_type) {
                  $scope.newCertificate.datos.charge_type = item;
                }
              });
              $scope.procedencias.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.procedencia) {
                  $scope.newCertificate.datos.procedencia = item;
                }
              });
            }
            SweetAlert.swal("Verifique la información", e.data.data, "error");
            return;
          } catch (i) {}
        });
    };
    // uh---renovación fin
    $scope.getSucursalId = function () {
      if ($scope.newCertificate.sucursal) {
        return typeof $scope.newCertificate.sucursal === "number"
          ? parseInt($scope.newCertificate.sucursal)
          : $scope.newCertificate.sucursal.id
          ? parseInt($scope.newCertificate.sucursal.id)
          : null;
      }
      return null;
    };
    $scope.saveIndividualCertificate = function () {
      $scope.certifcados = [];
      if ($scope.dataCaratula.subramo.subramo_code == 9) {
        $scope.dataToSave.recibos_poliza.forEach(function (receipt) {
          receipt.fecha_inicio = datesFactory.toDate(receipt.fecha_inicio);
          receipt.fecha_fin = datesFactory.toDate(receipt.fecha_fin);
          receipt.vencimiento = datesFactory.toDate(receipt.vencimiento);
        });

        $scope.newCertificate.datos.adjustment = $scope.newCertificate.datos
          .adjustment
          ? $scope.newCertificate.datos.adjustment
          : "";
        $scope.newCertificate.datos.beneficiary_address = $scope.newCertificate
          .datos.beneficiary_address
          ? $scope.newCertificate.datos.beneficiary_address
          : "";
        $scope.newCertificate.datos.beneficiary_rfc = $scope.newCertificate
          .datos.beneficiary_rfc
          ? $scope.newCertificate.datos.beneficiary_rfc
          : "";
        $scope.newCertificate.datos.brand = $scope.newCertificate.datos.brand
          ? $scope.newCertificate.datos.brand
          : "";
        $scope.newCertificate.datos.car_owner = $scope.newCertificate.datos
          .car_owner
          ? $scope.newCertificate.datos.car_owner
          : "";
        $scope.newCertificate.datos.charge_type = $scope.newCertificate.datos
          .charge_type
          ? $scope.newCertificate.datos.charge_type.value
          : 0;
        $scope.newCertificate.datos.color = $scope.newCertificate.datos.color
          ? $scope.newCertificate.datos.color
          : "";
        $scope.newCertificate.datos.driver = $scope.newCertificate.datos.driver
          ? $scope.newCertificate.datos.driver
          : "";
        $scope.newCertificate.datos.email = $scope.newCertificate.datos.email
          ? $scope.newCertificate.datos.email
          : "";
        $scope.newCertificate.datos.engine = $scope.newCertificate.datos.engine
          ? $scope.newCertificate.datos.engine
          : "";
        $scope.newCertificate.datos.license_plates = $scope.newCertificate.datos
          .license_plates
          ? $scope.newCertificate.datos.license_plates
          : "";
        $scope.newCertificate.datos.model = $scope.newCertificate.datos.model
          ? $scope.newCertificate.datos.model
          : "";
        $scope.newCertificate.datos.mont_adjustment = $scope.newCertificate
          .datos.mont_adjustment
          ? $scope.newCertificate.datos.mont_adjustment
          : 0;
        $scope.newCertificate.datos.mont_special_team = $scope.newCertificate
          .datos.mont_special_team
          ? $scope.newCertificate.datos.mont_special_team
          : 0;
        $scope.newCertificate.datos.no_employee = $scope.newCertificate.datos
          .no_employee
          ? $scope.newCertificate.datos.no_employee
          : 0;
        $scope.newCertificate.datos.policy_type = $scope.newCertificate.datos
          .policy_type
          ? $scope.newCertificate.datos.policy_type.id
          : 0;
        $scope.newCertificate.datos.preferential_benefiaciary = $scope
          .newCertificate.datos.preferential_benefiaciary
          ? $scope.newCertificate.datos.preferential_benefiaciary
          : 0;
        $scope.newCertificate.datos.procedencia = $scope.newCertificate.datos
          .procedencia
          ? $scope.newCertificate.datos.procedencia.value
          : 0;
        $scope.newCertificate.datos.serial = $scope.newCertificate.datos.serial
          ? $scope.newCertificate.datos.serial
          : "";
        $scope.newCertificate.datos.service = $scope.newCertificate.datos
          .service
          ? $scope.newCertificate.datos.service
          : "";
        $scope.newCertificate.datos.special_team = $scope.newCertificate.datos
          .special_team
          ? $scope.newCertificate.datos.special_team
          : "";
        $scope.newCertificate.datos.sum_insured = $scope.newCertificate.datos
          .sum_insured
          ? $scope.newCertificate.datos.sum_insured
          : "";
        $scope.newCertificate.datos.usage = $scope.newCertificate.datos.usage
          ? $scope.newCertificate.datos.usage.value
          : 0;
        $scope.newCertificate.datos.version = $scope.newCertificate.datos
          .version
          ? $scope.newCertificate.datos.version
          : "";
        $scope.newCertificate.datos.year = $scope.newCertificate.datos.year
          ? $scope.newCertificate.datos.year
          : 0;

        var dataCar = [];
        if ($scope.newCertificate.address_new) {
          $scope.newCertificate.address_new = parseInt(
            $scope.newCertificate.address_new
          );
        }
        if ($scope.newCertificate.address) {
          $scope.newCertificate.address_new = $scope.newCertificate.address.id;
        }
        dataCar.push($scope.newCertificate.datos);
        var certificateData = {
          accidents_policy: [],
          address: parseInt($scope.newCertificate.address_new),
          aseguradora: $scope.dataCaratula.aseguradora.id,
          automobiles_policy: dataCar,
          business_line: $scope.caratula.business_line,
          conducto_de_pago: $scope.newCertificate.conducto_de_pago,
          from_pdf: $scope.newCertificate.from_pdf,
          caratula: $scope.dataCaratula.id,
          celula: $scope.dataCaratula.celula,
          clave: $scope.dataCaratula.clave.id,
          coverageInPolicy_policy: [],
          damages_policy: [],
          document_type: 12,
          end_of_validity: datesFactory.toDate(
            $scope.newCertificate.end_of_validity
          ),
          endorsement: false,
          collection_executive: $scope.caratula.collection_executive
            ? $scope.caratula.collection_executive.id
            : null,
          f_currency: parseInt($scope.newCertificate.f_currency),
          folio: $scope.newCertificate.folio
            ? $scope.newCertificate.folio
            : null,
          forma_de_pago: parseInt($scope.newCertificate.forma_de_pago.value),
          groupinglevel: null,
          identifier:
            $scope.newCertificate.datos.brand +
            "_" +
            $scope.newCertificate.datos.model +
            "_" +
            $scope.newCertificate.datos.year,
          internal_number: null,
          is_renewable: $scope.newCertificate.is_renewable.value,
          life_policy: [],
          // natural: parseInt($scope.naturalP),
          // juridical: parseInt($scope.juridicalP),
          contractor: parseInt($scope.newCertificate.contractor_new),
          old_policies: [],
          paquete: parseInt($scope.newCertificate.paquete.id),
          parent: $scope.dataCaratula.url,
          // poliza: $scope.obj_poliza,
          poliza_number: $scope.newCertificate.poliza_number,
          ramo: $scope.dataCaratula.ramo.id,
          recibos_poliza: $scope.dataToSave.recibos_poliza,
          responsable: $scope.caratula.responsable
            ? $scope.caratula.responsable.id
            : null,
          start_of_validity: datesFactory.toDate(
            $scope.newCertificate.start_of_validity
          ),
          state_circulation: $scope.newCertificate.state_circulation
            ? $scope.newCertificate.state_circulation.id
            : "",
          status: 14,
          sucursal: $scope.getSucursalId(),
          subramo: $scope.dataCaratula.subramo.id,
          observations: $scope.newCertificate.observations
            ? $scope.newCertificate.observations
            : null,
          p_neta: $scope.dataToSave.p_neta ? $scope.dataToSave.p_neta : 0,
          descuento: $scope.dataToSave.descuento
            ? $scope.dataToSave.descuento
            : 0,
          rpf: $scope.dataToSave.rpf ? $scope.dataToSave.rpf : 0,
          derecho: $scope.dataToSave.derecho ? $scope.dataToSave.derecho : 0,
          iva: $scope.dataToSave.iva ? $scope.dataToSave.iva : 0,
          p_total: $scope.dataToSave.p_total ? $scope.dataToSave.p_total : 0,
          comision: $scope.dataToSave.comision ? $scope.dataToSave.comision : 0,
          comision_percent: $scope.dataToSave.comision_percent
            ? $scope.dataToSave.comision_percent
            : 0,
          comision_derecho_percent: $scope.dataToSave.poliza
            .comision_derecho_percent
            ? $scope.dataToSave.poliza.comision_derecho_percent
            : 0,
          comision_rpf_percent: $scope.dataToSave.poliza.comision_rpf_percent
            ? $scope.dataToSave.poliza.comision_rpf_percent
            : 0,
          sub_total: $scope.dataToSave.subTotal
            ? $scope.dataToSave.subTotal
            : 0,
        };
        if ($scope.caratula_renovada) {
          certificateData.caratula_renovada = $scope.caratula_renovada;
        }
        $scope.certifcados.push(certificateData);
      }

      $http({
        method: "POST",
        url: url.IP + "save_caratula_polizas/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            $localStorage.save_edition_flotilla_poliza = {};
            $scope.read_pdf_pf = {};
            $stateParams["dataContractor"] = {};
            $localStorage["datos_pdf_flotilla"] = {};
            $scope.newCertificate = {};
            SweetAlert.swal("¡Listo!", MESSAGES.OK.CERTIFICATESDONE, "success");

            // $http.patch(order.searchContratante.value.url,$scope.contractorToSave)
            // .then(function(data) {
            //   if(data.status == 200 || data.status == 201){
            //     // toaster.info('Contratante Actualizado')
            //   }
            // });
            var logManual = {
              model: 18,
              event: "POST",
              associated_id: $scope.caratula.id,
              identifier:
                " agregó " +
                $scope.certifcados.length +
                " Póliza(s) individual(es) a la colectividad de forma manual.",
            };
            dataFactory
              .post("send_log_specific/", logManual)
              .then(function success(response) {});
            if ($localStorage.dataFile && $scope.read_pdf_pf) {
              try {
                $localStorage.dataFile.append("owner", response.data[0].id);
                try {
                  $http.patch(data.data.url, { from_pdf: true });
                } catch (u) {}
                var xhr_file = new XMLHttpRequest();
                // xhr_file.open("POST", url.SERVICE_PDF);
                xhr_file.open(
                  "POST",
                  url.IP +
                    "polizas/" +
                    response.data[0].id +
                    "/archivos/?org=" +
                    $scope.orgName
                );
                xhr_file.timeout = 1200000;
                xhr_file.ontimeout = function (e) {
                  console.log("error file", e);
                };
                xhr_file.setRequestHeader("Authorization", "Bearer " + token);
                xhr_file.send($localStorage.dataFile);
                xhr_file.onreadystatechange = function () {
                  if (this.readyState == 4 && this.status == 200) {
                    $scope.fileUP = JSON.parse(xhr_file.response);
                    $localStorage.dataFile = {};
                    $localStorage.archivoBase64 = {};
                    $localStorage.serieDetectada = "";
                    $scope.serieDetectada = "";
                    $scope.serieAGuardar = "";
                    $localStorage.save_edition_flotilla_poliza = {};
                    $scope.read_pdf_pf = {};
                    $localStorage["datos_pdf_flotilla"] = {};
                  }
                };
              } catch (efile) {
                console.log("nose cargo el pdf leído", efile);
              }
            }
            activate();
            $scope.showItemCertificate(1);
          } else {
            SweetAlert.swal("ERROR", response.data.data, "error");
            if ($scope.newCertificate.datos.procedencia) {
              $scope.usages.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.usage) {
                  $scope.newCertificate.datos.usage = item;
                }
              });
              $scope.typesCharges.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.charge_type) {
                  $scope.newCertificate.datos.charge_type = item;
                }
              });
              $scope.procedencias.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.procedencia) {
                  $scope.newCertificate.datos.procedencia = item;
                }
              });
            }
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.valueCertificate = function () {
      $scope.newCertificate.start_of_validity = datesFactory.toDate(
        $scope.newCertificate.start_of_validity
      );
      $scope.newCertificate.end_of_validity = datesFactory.toDate(
        $scope.newCertificate.end_of_validity
      );
      if ($scope.newCertificate.automobiles_policy.length) {
        $scope.newCertificate.automobiles_policy[0].driver =
          $scope.newCertificate.datos.driver;
        // $scope.newCertificate.automobiles_policy[0].email = $scope.newCertificate.datos.email;
        $scope.newCertificate.automobiles_policy[0].brand =
          $scope.newCertificate.datos.brand;
        $scope.newCertificate.automobiles_policy[0].model =
          $scope.newCertificate.datos.model;
        $scope.newCertificate.automobiles_policy[0].year =
          $scope.newCertificate.datos.year;
        $scope.newCertificate.automobiles_policy[0].version =
          $scope.newCertificate.datos.version;
        $scope.newCertificate.automobiles_policy[0].serial =
          $scope.newCertificate.datos.serial;
        $scope.newCertificate.automobiles_policy[0].engine =
          $scope.newCertificate.datos.engine;
        $scope.newCertificate.automobiles_policy[0].color =
          $scope.newCertificate.datos.color;
        $scope.newCertificate.automobiles_policy[0].license_plates =
          $scope.newCertificate.datos.license_plates;
        $scope.newCertificate.automobiles_policy[0].usage =
          $scope.newCertificate.datos.usage.value;
        $scope.newCertificate.automobiles_policy[0].service =
          $scope.newCertificate.datos.service;
        $scope.newCertificate.automobiles_policy[0].procedencia =
          $scope.newCertificate.datos.procedencia.value;
      }
      $scope.updateCertificate();
    };

    $scope.updateCertificate = function () {
      $scope.changes = [];
      var jsonUpdate = {
        poliza_number: $scope.newCertificate.poliza_number,
        folio: $scope.newCertificate.folio,
        start_of_validity: $scope.newCertificate.start_of_validity,
        end_of_validity: $scope.newCertificate.end_of_validity,
        status: $scope.newCertificate.status,
        // natural: $scope.newCertificate.natural,
        // juridical: $scope.newCertificate.juridical,
        contractor: $scope.newCertificate.contractor,
        address: $scope.newCertificate.address
          ? $scope.newCertificate.address.url
          : null,
        forma_de_pago: $scope.newCertificate.forma_de_pago.value,
        is_renewable: $scope.newCertificate.is_renewable.value,
        f_currency: $scope.newCertificate.f_currency,
        paquete: $scope.newCertificate.paquete.url,
        business_line: $scope.caratula.business_line
          ? $scope.caratula.business_line
          : null,
        conducto_de_pago: $scope.newCertificate.conducto_de_pago
          ? $scope.newCertificate.conducto_de_pago
          : null,
        sucursal: $scope.newCertificate.sucursal
          ? $scope.newCertificate.sucursal.url
          : null,
        responsable: $scope.caratula.responsable
          ? $scope.caratula.responsable.url
          : null,
        state_circulation: $scope.newCertificate.state_circulation
          ? $scope.newCertificate.state_circulation.id
          : "",
        collection_executive: $scope.caratula.collection_executive
          ? $scope.caratula.collection_executive.url
          : null,
        // policy_type: $scope.newCertificate.datos && $scope.newCertificate.datos.policy_type && $scope.newCertificate.datos.policy_type.id? $scope.newCertificate.datos.policy_type.id :$scope.newCertificate.policy_type,
        observations: $scope.newCertificate.observations,
        p_neta: $scope.dataToSave.p_neta
          ? $scope.dataToSave.p_neta
          : $scope.newCertificate.p_neta,
        rpf: $scope.dataToSave.rpf
          ? $scope.dataToSave.rpf
          : $scope.newCertificate.rpf,
        derecho: $scope.dataToSave.derecho
          ? $scope.dataToSave.derecho
          : $scope.newCertificate.derecho,
        iva: $scope.dataToSave.iva
          ? $scope.dataToSave.iva
          : $scope.newCertificate.iva,
        p_total: $scope.dataToSave.p_total
          ? $scope.dataToSave.p_total
          : $scope.newCertificate.p_total,
        comision:
          $scope.dataToSave.comision || $scope.dataToSave.comision == 0
            ? $scope.dataToSave.comision
            : $scope.newCertificate.comision,
        comision_percent:
          $scope.dataToSave.comision_percent ||
          $scope.dataToSave.comision_percent == 0
            ? $scope.dataToSave.comision_percent
            : $scope.newCertificate.comision_percent,
        comision_derecho_percent:
          $scope.dataToSave.poliza.comision_derecho_percent ||
          $scope.dataToSave.poliza.comision_derecho_percent == 0
            ? $scope.dataToSave.poliza.comision_derecho_percent
            : $scope.newCertificate.comision_derecho_percent,
        comision_rpf_percent:
          $scope.dataToSave.poliza.comision_rpf_percent ||
          $scope.dataToSave.poliza.comision_rpf_percent == 0
            ? $scope.dataToSave.poliza.comision_rpf_percent
            : $scope.newCertificate.comision_rpf_percent,
      };

      $http
        .patch($scope.newCertificate.url, jsonUpdate)
        .then(function success(request) {
          if (request.status === 200) {
            $localStorage.save_edition_flotilla_poliza = {};
            if ($scope.newCertificate.automobiles_policy.length) {
              var jsonAuto = {
                adjustment: $scope.newCertificate.datos.adjustment,
                beneficiary_address:
                  $scope.newCertificate.datos.beneficiary_address,
                beneficiary_name: $scope.newCertificate.datos.beneficiary_name,
                beneficiary_rfc: $scope.newCertificate.datos.beneficiary_rfc,
                brand: $scope.newCertificate.datos.brand,
                car_owner: $scope.newCertificate.datos.car_owner,
                charge_type: $scope.newCertificate.datos.charge_type
                  ? $scope.newCertificate.datos.charge_type.value
                  : 0,
                color: $scope.newCertificate.datos.color,
                document_type: 1,
                driver: $scope.newCertificate.datos.driver,
                email: $scope.newCertificate.datos.email,
                engine: $scope.newCertificate.datos.engine,
                license_plates: $scope.newCertificate.datos.license_plates,
                model: $scope.newCertificate.datos.model,
                mont_adjustment: $scope.newCertificate.datos.mont_adjustment,
                mont_special_team:
                  $scope.newCertificate.datos.mont_special_team,
                no_employee: $scope.newCertificate.datos.no_employee,
                personal: $scope.newCertificate.datos.personal,
                policy: $scope.newCertificate.url,
                policy_type: $scope.newCertificate.datos.policy_type.id,
                preferential_benefiaciary:
                  $scope.newCertificate.datos.preferential_benefiaciary,
                procedencia: $scope.newCertificate.datos.procedencia.value,
                serial: $scope.newCertificate.datos.serial,
                service: $scope.newCertificate.datos.service,
                special_team: $scope.newCertificate.datos.special_team,
                // sub_branch: $scope.newCertificate.subramo.url,
                sum_insured: $scope.newCertificate.datos.sum_insured,
                usage: $scope.newCertificate.datos.usage.value,
                version: $scope.newCertificate.datos.version,
                year: $scope.newCertificate.datos.year,
              };
              $http
                .patch(
                  $scope.newCertificate.automobiles_policy[0].url,
                  jsonAuto
                )
                .then(function success(response) {
                  if (response.status == 200) {
                    // log automobiles
                    SweetAlert.swal(
                      "¡Listo!",
                      "Póliza actualizada exitosamente.",
                      "success"
                    );
                    // var paramsC = {
                    //   'model': 18,
                    //   'event': "POST",
                    //   'associated_id': $scope.caratula.id,
                    //   'identifier': " actualizó la póliza individual."
                    // }

                    // dataFactory.post('send-log/', paramsC).then(function success(response) {

                    // });

                    // var params = {
                    //   'model': 1,
                    //   'event': "POST",
                    //   'associated_id': $scope.newCertificate.id,
                    //   'identifier': " actualizó la póliza."
                    // }
                    // $localStorage.save_edition_flotilla_poliza = {}
                    // dataFactory.post('send-log/', params).then(function success(response) {

                    // });
                  }
                })
                .catch(function (e) {
                  console.log("error", e);
                });
            } else {
              var jsonAuto = {
                adjustment: $scope.newCertificate.datos.adjustment,
                beneficiary_address:
                  $scope.newCertificate.datos.beneficiary_address,
                beneficiary_name: $scope.newCertificate.datos.beneficiary_name,
                beneficiary_rfc: $scope.newCertificate.datos.beneficiary_rfc,
                brand: $scope.newCertificate.datos.brand,
                car_owner: $scope.newCertificate.datos.car_owner,
                charge_type: $scope.newCertificate.datos.charge_type
                  ? $scope.newCertificate.datos.charge_type.value
                  : 0,
                color: $scope.newCertificate.datos.color,
                document_type: 1,
                driver: $scope.newCertificate.datos.driver,
                email: $scope.newCertificate.datos.email,
                engine: $scope.newCertificate.datos.engine,
                license_plates: $scope.newCertificate.datos.license_plates,
                model: $scope.newCertificate.datos.model,
                mont_adjustment: $scope.newCertificate.datos.mont_adjustment,
                mont_special_team:
                  $scope.newCertificate.datos.mont_special_team,
                no_employee: $scope.newCertificate.datos.no_employee,
                personal: $scope.newCertificate.datos.personal,
                policy: $scope.newCertificate.url,
                policy_type: $scope.newCertificate.datos.policy_type.id,
                preferential_benefiaciary:
                  $scope.newCertificate.datos.preferential_benefiaciary,
                procedencia: $scope.newCertificate.datos.procedencia.value,
                serial: $scope.newCertificate.datos.serial,
                service: $scope.newCertificate.datos.service,
                special_team: $scope.newCertificate.datos.special_team,
                sub_branch: $scope.newCertificate.subramo.url,
                sum_insured: $scope.newCertificate.datos.sum_insured,
                usage: $scope.newCertificate.datos.usage.value,
                version: $scope.newCertificate.datos.version,
                year: $scope.newCertificate.datos.year,
              };
              $http({
                method: "POST",
                url: url.IP + "v1/forms/automobile-damages/",
                data: jsonAuto,
              })
                .then(function success(response) {
                  $localStorage.save_edition_flotilla_poliza = {};
                  SweetAlert.swal(
                    "¡Listo!",
                    "Póliza actualizada exitosamente.",
                    "success"
                  );
                })
                .catch(function (error) {
                  console.log("Error - catch", error);
                });
            }

            if ($scope.dataToSave.recibos_poliza) {
              $scope.dataToSave.receipts.forEach(function (item, index) {
                if (
                  item.recibo_numero ==
                  $scope.dataToSave.recibos_poliza[index].recibo_numero
                ) {
                  var object = {
                    prima_neta:
                      $scope.dataToSave.recibos_poliza[index].prima_neta,
                    rpf: $scope.dataToSave.recibos_poliza[index].rpf,
                    derecho: $scope.dataToSave.recibos_poliza[index].derecho,
                    sub_total:
                      $scope.dataToSave.recibos_poliza[index].sub_total,
                    iva: $scope.dataToSave.recibos_poliza[index].iva,
                    prima_total:
                      $scope.dataToSave.recibos_poliza[index].prima_total,
                    comision: $scope.dataToSave.recibos_poliza[index].comision,
                    status: 4,
                  };
                  try {
                    object.fecha_inicio = $scope.dataToSave.recibos_poliza[
                      index
                    ].fecha_inicio
                      ? datesFactory.toDate(
                          $scope.dataToSave.recibos_poliza[index].fecha_inicio
                        )
                      : $scope.dataToSave.recibos_poliza[index].fecha_inicio;
                    object.fecha_fin = $scope.dataToSave.recibos_poliza[index]
                      .fecha_fin
                      ? datesFactory.toDate(
                          $scope.dataToSave.recibos_poliza[index].fecha_fin
                        )
                      : $scope.dataToSave.recibos_poliza[index].fecha_fin;
                    object.vencimiento = $scope.dataToSave.recibos_poliza[index]
                      .vencimiento
                      ? datesFactory.toDate(
                          $scope.dataToSave.recibos_poliza[index].vencimiento
                        )
                      : $scope.dataToSave.recibos_poliza[index].vencimiento;
                  } catch (e) {
                    console.log("--eroror fecha", e);
                  }
                  $http.patch(item.url, object).then(function (req) {});
                }
                if ($scope.dataToSave.receipts.length == index + 1) {
                  activate();
                  $scope.dataToSave = {};
                  $scope.selectCerficate($scope.newCertificate);
                }
              });
            } else {
              activate();
              $scope.selectCerficate($scope.newCertificate);
            }
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.$watch(
      "order.searchContratante.value",
      function (newValue, oldValue) {
        if (order.searchContratante) {
          if (order.searchContratante.value.address_contractor) {
            $scope.contractorLayout.id = order.searchContratante.value.id;
            $scope.contractorLayout.name = order.searchContratante.val;
            $scope.contractorLayout.contractor = order.searchContratante.value;
            if (
              order.searchContratante.value.address_contractor ||
              order.searchContratante.value.type_person == 1 ||
              order.searchContratante.value.type_person == "Física"
            ) {
              $scope.contractorLayout.type = 1;
              $scope.contractorLayout.address =
                order.searchContratante.value.address_contractor;
            } else {
              $scope.contractorLayout.type = 2;
              $scope.contractorLayout.address =
                order.searchContratante.value.address_contractor;
            }
          }
        }
      }
    );

    $scope.paqueteAll = function (paq) {
      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: $scope.dataCaratula.ramo.id,
          subramo: $scope.dataCaratula.subramo.id,
          provider: $scope.dataCaratula.aseguradora.id,
        })
        .then(
          function success(response) {
            if (response.data.length) {
              $scope.paquetesLayout = response.data;
            } else {
              $scope.paquetesLayout = [];
            }
          },
          function error(e) {
            console.log("Error - paquetes-data-by-subramo", e);
            $scope.paquetesLayout = [];
          }
        )
        .catch(function (error) {
          console.log("Error - paquetes-data-by-subramo - catch", error);
          $scope.paquetesLayout = [];
        });
    };

    $scope.validateEmail = function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };
    $scope.createIndividualCertificate = function () {
      $rootScope.show_contractor = false;
      $scope.dataToSave = {
        recalcular: true,
      };
      $scope.directiveReceipts.is_edit = false;
      $scope.isEdit = false;
      $scope.newCertificate = undefined;

      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: $scope.dataCaratula.ramo
            ? $scope.dataCaratula.ramo.id
            : $scope.dataCaratula.ramo,
          subramo: $scope.dataCaratula.subramo.id,
          provider: $scope.caratula.aseguradora.id
            ? $scope.caratula.aseguradora.id
            : $scope.caratula.aseguradora,
        })
        .then(function success(response) {
          if (response.status === 200) {
            $scope.packages = [];
            if (response.data.length) {
              $scope.packages = response.data;
            }
          }
        })
        .catch(function (error) {
          console.log("error", error);
        });
      $scope.newCertificate = {};
      $scope.newCertificate.certificate_number = "";
      $scope.newCertificate.contractor = "";
      order.contratante = {};
      $scope.newCertificate.rec_antiguedad = datesFactory.convertDate(
        new Date()
      );
      $scope.newCertificate.start_of_validity = datesFactory.convertDate(
        $scope.caratula.start_of_validity
      );
      $scope.newCertificate.end_of_validity = datesFactory.convertDate(
        $scope.caratula.end_of_validity
      );
      var date1 = new Date($scope.newCertificate.start_of_validity);
      var date2 = new Date($scope.newCertificate.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.newCertificate.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );
      $scope.newCertificate.p_neta = "";
      $scope.newCertificate.rpf = "";
      $scope.newCertificate.derecho = "";
      $scope.newCertificate.iva = "";
      $scope.newCertificate.p_total = "";
      $scope.newCertificate.comision = "";

      if ($scope.dataCaratula.subramo.subramo_code == 9) {
        $scope.newCertificate.datos = {
          adjustment: "",
          beneficiary_address: "",
          beneficiary_rfc: "",
          brand: "",
          car_owner: "",
          charge_type: $scope.types[0],
          color: "",
          driver: "",
          email: "",
          engine: "",
          license_plates: "",
          model: "",
          mont_adjustment: 0,
          mont_special_team: 0,
          no_employee: "",
          preferential_benefiaciary: "",
          procedencia: $scope.procedencias[0],
          serial: "",
          service: "",
          special_team: "",
          sum_insured: 0,
          usage: $scope.usages[0],
          version: "",
          year: "",
        };
      }
      if ($scope.dataToSave.poliza) {
        $scope.dataToSave.poliza.derecho = 0;
        $scope.dataToSave.poliza.iva = 0;
        $scope.dataToSave.poliza.primaNeta = 0;
        $scope.dataToSave.poliza.primaTotal = 0;
        $scope.dataToSave.poliza.receipts = [];
        $scope.dataToSave.poliza.derecho = 0;
        $scope.dataToSave.poliza.rpf = 0;
        $scope.dataToSave.poliza.subTotal = 0;
      }
      $scope.dataToSave.receipts = [];
      $scope.showItemCertificate(3);
      $scope.copy_inicio = angular.copy(
        $scope.newCertificate.start_of_validity
      );
      $scope.copy_fin = angular.copy($scope.newCertificate.end_of_validity);
      $scope.checkDate($scope.copy_inicio);
      $scope.checkEndDate($scope.copy_fin);
      $scope.defaults = {};
      $scope.defaults.comisiones = [];
      $scope.directiveReceipts.subramo = $scope.dataCaratula.subramo;
      if ($scope.dataCaratula) {
        if ($scope.dataCaratula.clave.clave_comision.length) {
          $scope.directiveReceipts.comisiones = $scope.defaults.comisiones;
          $scope.directiveReceipts.comisiones =
            $scope.dataCaratula.clave.clave_comision;
          if ($scope.defaults.comisiones.length == 1) {
            $scope.directiveReceipts.comision = $scope.defaults.comisiones[0];
            $scope.selectComision($scope.directiveReceipts.comision);
          }
        } else {
        }
      }
      $scope.dataToSave.poliza = {
        primaNeta: parseFloat(
          $scope.newCertificate.p_neta ? $scope.newCertificate.p_neta : 0
        ),
        rpf: parseFloat(
          $scope.newCertificate.rpf ? $scope.newCertificate.rpf : 0
        ),
        derecho: parseFloat(
          $scope.newCertificate.derecho ? $scope.newCertificate.derecho : 0
        ),
        subTotal: parseFloat(
          $scope.newCertificate.sub_total ? $scope.newCertificate.sub_total : 0
        ),
        iva: parseFloat(
          $scope.newCertificate.iva ? $scope.newCertificate.iva : 0
        ),
        primaTotal: parseFloat(
          $scope.newCertificate.p_total ? $scope.newCertificate.p_total : 0
        ),
      };
      $scope.checkDate($scope.newCertificate.end_of_validity);
      // contratante*************
      var myInsuranceContractor = $stateParams.dataContractor;
      if (myInsuranceContractor && myInsuranceContractor.url) {
        var contrac = {};
        contrac.contratanteId = myInsuranceContractor.id;
        if (myInsuranceContractor.type_person == 1) {
          contrac.type = "fisicas";
        }
        if (myInsuranceContractor.type_person == 2) {
          contrac.type = "morales";
        }
        $scope.showPol = true;
        $scope.showCar = true;
        ContratanteService.getContratanteFull(contrac).then(function (
          contractor
        ) {
          order.contratante = contractor;
          if (contractor.first_name) {
            order.contratante.val =
              contractor.first_name +
              " " +
              contractor.last_name +
              " " +
              contractor.second_last_name;
          }
          if (contractor.full_name) {
            order.contratante.val = contractor.full_name;
          }
          if (contractor.address_contractor) {
            $scope.addresses = contractor.address_contractor;
          }
          $scope.newCertificate.address = $scope.addresses[0];
          order.contratante.value = contractor;
          $scope.info_sub = order.contratante.value;
          if (
            $localStorage["datos_pdf_flotilla"] &&
            $localStorage["datos_pdf_flotilla"].data
          ) {
            $http({
              method: "POST",
              url: url.IP + "get_caratula_polizas/",
              data: {
                caratula: $scope.caratula.id,
              },
            })
              .then(function success(response) {
                if (response.status == 200) {
                  $scope.dataCaratula = response.data.data.caratula;
                  $http
                    .post(url.IP + "paquetes-data-by-subramo/", {
                      ramo: $scope.dataCaratula.ramo.id,
                      subramo: $scope.dataCaratula.subramo.id,
                      provider: $scope.dataCaratula.aseguradora
                        ? $scope.dataCaratula.aseguradora.id
                        : $scope.caratula.aseguradora.id,
                    })
                    .then(function success(response) {
                      if (response.status === 200) {
                        $scope.packages = [];
                        if (response.data.length) {
                          $scope.packages = response.data;
                          $scope.packages.forEach(function (pack) {
                            if (
                              $scope.newCertificate &&
                              $scope.newCertificate.paquete &&
                              pack.id == $scope.newCertificate.paquete.id
                            ) {
                              $scope.newCertificate.paquete = pack;
                            }
                          });
                        }
                      }
                    })
                    .catch(function (error) {
                      console.log("error paquetes", e);
                    });
                  $scope.cargarInfoPDF($localStorage["datos_pdf_flotilla"]);
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
          $scope.show_section(2);
        });
      }
      // !!********************************+!!
    };
    function extractNum(s) {
      var m = (s || "").match(/\b(\d{2,3})\b/); // 60, 70, 80, 90, 100...
      return m ? m[1] : null;
    }
    function slug(s) {
      return (s || "")
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // sin acentos
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }

    function norm(s) {
      if (!s) return "";
      return s
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // quita acentos
        .replace(/est(an|and)ar/g, "estandar") // normaliza variantes
        .replace(/[^a-z0-9 ]/g, " ") // quita signos
        .replace(/\s+/g, " ") // espacios únicos
        .trim();
    }
    function scorePackage(itemName, target) {
      var a = norm(itemName);
      var b = norm(target);
      if (!a || !b) return 0;

      var score = 0;
      if (a === b) score = 100;
      else if (a.startsWith(b) || b.startsWith(a)) score = 85;
      else if (a.includes(b) || b.includes(a)) score = 70;

      var na = extractNum(a),
        nb = extractNum(b);
      if (na && nb && na === nb) score += 15;
      if (a.includes("estandar") && b.includes("estandar")) score += 10;

      return score;
    }
    function pickBestPackageOriginal(packages, targetName) {
      if (targetName == "Responsabilidad Civil") {
        if (
          order &&
          order.form &&
          order.form.aseguradora &&
          order.form.aseguradora.alias &&
          (order.form.aseguradora.alias == "GNP" ||
            order.form.aseguradora.alias == "GNP Seguros")
        )
          targetName = "RC";
      }
      if (!Array.isArray(packages) || !packages.length)
        return { best: null, score: 0, index: -1 };

      var best = null;
      var bestScore = -1;
      var bestIdx = -1;

      for (var idx = 0; idx < packages.length; idx++) {
        var pkg = packages[idx];
        var name = pkg && pkg.package_name ? pkg.package_name : "";
        var s = scorePackage(name, targetName);

        function tieBreak() {
          var bestName = best && best.package_name ? best.package_name : "";
          var aNum = extractNum(norm(name));
          var bNum = extractNum(norm(bestName));
          var tNum = extractNum(norm(targetName));

          if (aNum && !bNum) return true; // prioriza quien tenga número
          if (aNum && bNum && tNum && aNum === tNum) return true; // número igual al target
          if ((name || "").length > (bestName || "").length) return true; // nombre más largo
          return false;
        }

        if (s > bestScore || (s === bestScore && tieBreak())) {
          best = pkg;
          bestScore = s;
          bestIdx = idx;
        }
      }
      return { best: best, score: bestScore, index: bestIdx };
    }
    $scope.asignarPaquete = function () {
      var res = pickBestPackageOriginal(
        $scope.packages,
        $scope.read_pdf_pf.data.cobertura
      );
      var best = res ? res.best : null;
      var score = res ? res.score : null;
      var cobertura = $scope.read_pdf_pf.data.cobertura;
      $scope.packages = $scope.packages;
      // ---------------
      var encontardo_paquete = false;
      if (best) {
        $scope.paqueteSelectedObject = best;
        encontardo_paquete = false;
        // console.log('✅ Mejor match:', best.package_name, 'score:', score);
      } else {
        $scope.paqueteSelectedObject = null;
        encontardo_paquete = true;
        console.warn("No hubo coincidencias");
      }
      if (!encontardo_paquete) {
        $scope.paqueteSelected = true;
        $scope.newCertificate.paquete = $scope.paqueteSelectedObject;
        $scope.yaseestableciopaquete = true;
      } else {
        $scope.packages.forEach(function (item) {
          var s = scorePackage(item.package_name, target);
          if (s > bestScore) {
            bestScore = s;
            best = item;
          }
          if (
            item.package_name.toLowerCase() &&
            $scope.read_pdf_pf.data.cobertura.toLowerCase()
          ) {
            if (
              item.package_name.toLowerCase() ==
                $scope.read_pdf_pf.data.cobertura.toLowerCase() ||
              (item.package_name
                .toLowerCase()
                .includes($scope.read_pdf_pf.data.cobertura.toLowerCase()) &&
                !$scope.paqueteSelected) ||
              (best && $scope.yaseestableciopaquete == false)
            ) {
              $scope.paqueteSelected = true;
              $scope.newCertificate.paquete = item;
              $scope.yaseestableciopaquete = true;
              $scope.newCertificate.paquete = item;
            }
          }
        });
      }
    };
    $scope.cargarInfoPDF = function (datp) {
      $scope.read_pdf_pf = $localStorage["datos_pdf_flotilla"];
      if ($scope.read_pdf_pf && $scope.read_pdf_pf.data) {
        if ($scope.read_pdf_pf.data["Numero de poliza"]) {
          $scope.newCertificate.poliza_number =
            $scope.read_pdf_pf.data["Numero de poliza"];
        }
        if ($scope.read_pdf_pf.data["Datos generales de la poliza"]["Moneda"]) {
          if (
            $scope.read_pdf_pf.data["Datos generales de la poliza"][
              "Moneda"
            ].toLowerCase() == "pesos"
          ) {
            $scope.newCertificate.f_currency = 1;
          }
          if (
            $scope.read_pdf_pf.data["Datos generales de la poliza"][
              "Moneda"
            ].toLowerCase() == "nacional"
          ) {
            $scope.newCertificate.f_currency = 1;
          }
          if (
            $scope.read_pdf_pf.data["Datos generales de la poliza"][
              "Moneda"
            ].toLowerCase() == "dolares"
          ) {
            $scope.newCertificate.f_currency = 2;
          }
          if (
            $scope.read_pdf_pf.data["Datos generales de la poliza"][
              "Moneda"
            ].toLowerCase() == "udi"
          ) {
            $scope.newCertificate.f_currency = 3;
          }
          if (
            $scope.read_pdf_pf.data["Datos generales de la poliza"][
              "Moneda"
            ].toLowerCase() == "euro"
          ) {
            $scope.newCertificate.f_currency = 4;
          }
          if (
            $scope.read_pdf_pf.data["Datos generales de la poliza"][
              "Moneda"
            ].toLowerCase() == "extranjera"
          ) {
            $scope.newCertificate.f_currency = 2;
          }
        }
        if ($scope.read_pdf_pf.data["fecha_inicio"]) {
          $scope.newCertificate.start_of_validity =
            $scope.read_pdf_pf.data["fecha_inicio"];
        }
        if ($scope.read_pdf_pf.data["fecha_fin"]) {
          $scope.newCertificate.end_of_validity =
            $scope.read_pdf_pf.data["fecha_fin"];
        }
        // if ($scope.read_pdf_pf.data['Primas']['Forma_de_Pago']){
        //   $scope.newCertificate.forma_de_pago=$scope.read_pdf_pf.data['Primas']['Forma_de_Pago'];
        // }
        if (
          $scope.read_pdf_pf.data["Datos generales de la poliza"][
            "Forma de pago"
          ]
        ) {
          $scope.newCertificate.forma_de_pago =
            $scope.read_pdf_pf.data["Datos generales de la poliza"][
              "Forma de pago"
            ];
        }
        if ($scope.newCertificate.forma_de_pago) {
          $scope.frequencies.forEach(function (item) {
            if (item.value == $scope.newCertificate.forma_de_pago) {
              $scope.newCertificate.forma_de_pago = item;
              $scope.directiveReceipts.payment =
                $scope.newCertificate.forma_de_pago;
            }
          });
        }
        if ($scope.read_pdf_pf.data["Datos del vehiculo"]) {
          $scope.newCertificate.datos = {};
          $scope.newCertificate.datos = {
            adjustment: "",
            beneficiary_address: "",
            beneficiary_rfc: "",
            brand: "",
            car_owner: "",
            charge_type: $scope.types[0],
            policy_type: $scope.types[0],
            color: "",
            driver: "",
            email: "",
            engine: "",
            license_plates: "",
            model: "",
            mont_adjustment: 0,
            mont_special_team: 0,
            no_employee: "",
            preferential_benefiaciary: "",
            procedencia: $scope.procedencias[0],
            serial: "",
            service: "",
            special_team: "",
            sum_insured: 0,
            usage: $scope.usages[0],
            version: "",
            year: "",
          };
          $scope.newCertificate.datos.policy_type = $scope.types[0];
          $scope.newCertificate.is_renewable = $scope.renewals[0];
          $scope.newCertificate.datos.procedencia = $scope.procedencias[0];
          $scope.newCertificate.datos.serial =
            $scope.read_pdf_pf.data["Datos del vehiculo"]["serie"];
          $scope.newCertificate.datos.service =
            $scope.read_pdf_pf.data["Datos del vehiculo"]["service"];
          if (!$scope.newCertificate.datos.service) {
            if ($scope.read_pdf_pf.data["Datos del vehiculo"]["tipo"]) {
              $scope.newCertificate.datos.service =
                $scope.read_pdf_pf.data["Datos del vehiculo"]["tipo"];
            }
          }
          $scope.newCertificate.datos.engine =
            $scope.read_pdf_pf.data["Datos del vehiculo"]["motor"];
          $scope.newCertificate.datos.year = parseInt(
            $scope.read_pdf_pf.data["Datos del vehiculo"]["anio"]
          );
          $scope.newCertificate.datos.brand =
            $scope.read_pdf_pf.data["Datos del vehiculo"]["marca"];
          $scope.newCertificate.datos.model =
            $scope.read_pdf_pf.data["Datos del vehiculo"]["modelo"];
          $scope.newCertificate.datos.adjustment = "";
          $scope.newCertificate.datos.license_plates =
            $scope.read_pdf_pf.data["Datos del vehiculo"]["placas"];
          $scope.newCertificate.datos.usage =
            $scope.read_pdf_pf.data["Datos del vehiculo"]["uso"];
          if ($scope.newCertificate.datos.usage) {
            $scope.usages.forEach(function (item) {
              if (item.value == $scope.newCertificate.datos.usage) {
                $scope.newCertificate.datos.usage = item;
              }
            });
          }
          $scope.newCertificate.datos.version =
            $scope.read_pdf_pf.data["Datos del vehiculo"]["version"];
          if (!$scope.newCertificate.datos.version) {
            if (
              $scope.read_pdf_pf.data["Datos del vehiculo"][
                "descripcion_vehiculo"
              ]
            ) {
              $scope.newCertificate.datos.version =
                $scope.read_pdf_pf.data["Datos del vehiculo"][
                  "descripcion_vehiculo"
                ];
            }
          }
        }
        if ($scope.read_pdf_pf.data["Primas"]) {
          $scope.directiveReceipts.from_pdf = true;
          if ($scope.read_pdf_pf.data["Primas"]["Prima total"]) {
            $scope.directiveReceipts.primaTotal = $scope.read_pdf_pf.data[
              "Primas"
            ]["Prima total"]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf_pf.data["Primas"]["Prima total"]
                  )
                )
              : $scope.read_pdf_pf.data["Primas"]["IMPORTE TOTAL"]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf_pf.data["Primas"]["IMPORTE TOTAL"]
                  )
                )
              : 0;
            $scope.directiveReceipts.subTotal = $scope.read_pdf_pf.data[
              "Primas"
            ]["Subtotal"]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf_pf.data["Primas"]["Subtotal"]
                  )
                )
              : 0;
            $scope.directiveReceipts.from_pdf = true;
            $localStorage["primas"] = $scope.directiveReceipts;
          }

          if ($scope.read_pdf_pf.data["Primas"]["Prima neta"]) {
            $scope.directiveReceipts.primaNeta = $scope.read_pdf_pf.data[
              "Primas"
            ]["Prima neta"]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf_pf.data["Primas"]["Prima neta"]
                  )
                )
              : 0;
            $scope.directiveReceipts.from_pdf = true;
            $localStorage["primas"] = $scope.directiveReceipts;
          }

          if ($scope.read_pdf_pf.data["Primas"]["Gastos de expedición"]) {
            try {
              $scope.directiveReceipts.derecho = $scope.read_pdf_pf.data[
                "Primas"
              ]["Gastos de expedición"]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_pf.data["Primas"]["Gastos de expedición"]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.directiveReceipts;
            } catch (o) {
              $scope.directiveReceipts.derecho = $scope.read_pdf_pf.data[
                "Primas"
              ]["Gastos de expedici\u00f3n"]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_pf.data["Primas"][
                        "Gastos de expedici\u00f3n"
                      ]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.directiveReceipts;
            }
          }
          if ($scope.read_pdf_pf.data["Primas"]["Gastos por Expedición."]) {
            try {
              $scope.directiveReceipts.derecho = $scope.read_pdf_pf.data[
                "Primas"
              ]["Gastos por Expedición."]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_pf.data["Primas"][
                        "Gastos por Expedición."
                      ]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.directiveReceipts;
            } catch (o) {
              $scope.directiveReceipts.derecho = $scope.read_pdf_pf.data[
                "Primas"
              ]["Gastos por Expedici\u00f3n."]
                ? parseFloat(
                    formatearNumero_calculate(
                      $scope.read_pdf_pf.data["Primas"][
                        "Gastos por Expedici\u00f3n."
                      ]
                    )
                  )
                : 0;
              $localStorage["primas"] = $scope.directiveReceipts;
            }
          }
          console.log("ccccccccc", $scope.read_pdf_pf.data["Primas"]);
          if (
            $scope.read_pdf_pf.data["Primas"][
              "Financiamiento por pago fraccionado"
            ]
          ) {
            console.log("ooooooooooo", $scope.read_pdf_pf.data["Primas"]);
            $scope.directiveReceipts.rpf = $scope.read_pdf_pf.data["Primas"][
              "Financiamiento por pago fraccionado"
            ]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf_pf.data["Primas"][
                      "Financiamiento por pago fraccionado"
                    ]
                  )
                )
              : 0;
            $localStorage["primas"] = $scope.directiveReceipts;
            console.log("xxxxxxxxxxxxxxxxx", $scope.read_pdf_pf.data["Primas"]);
          }
          if ($scope.read_pdf_pf.data["Primas"]["Derecho de Póliza"]) {
            $scope.directiveReceipts.derecho = $scope.read_pdf_pf.data[
              "Primas"
            ]["Derecho de Póliza"]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf_pf.data["Primas"]["Derecho de Póliza"]
                  )
                )
              : 0;
            $localStorage["primas"] = $scope.directiveReceipts;
          }
          if ($scope.read_pdf_pf.data["Primas"]["Descuento"]) {
            var valor =
              parseFloat(
                formatearNumero_calculate(
                  $scope.read_pdf_pf.data["Primas"]["Descuento"]
                )
              ) || 0;
            // Si el valor es negativo → convertirlo a positivo multiplicando por -1
            if (valor < 0) {
              valor = valor * -1;
            }
            $scope.directiveReceipts.descuento = valor;
            $localStorage["primas"] = $scope.directiveReceipts;
          }
          if ($scope.read_pdf_pf.data["Primas"]["IVA"]) {
            $scope.directiveReceipts.iva = $scope.read_pdf_pf.data["Primas"][
              "IVA"
            ]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf_pf.data["Primas"]["IVA"]
                  )
                )
              : 0;
            $localStorage["primas"] = $scope.directiveReceipts;
          }
          if (
            $scope.read_pdf_pf.data["Primas"] &&
            $scope.read_pdf_pf.data["Primas"]["I.V.A."]
          ) {
            $scope.directiveReceipts.iva = $scope.read_pdf_pf.data["Primas"][
              "I.V.A."
            ]
              ? parseFloat(
                  formatearNumero_calculate(
                    $scope.read_pdf_pf.data["Primas"]["I.V.A."]
                  )
                )
              : 0;
            $localStorage["primas"] = $scope.directiveReceipts;
          }
        }
        $scope.newCertificate.conducto_de_pago = 1;
        var asegurado = $scope.read_pdf_pf.data["Datos del asegurado"] || {};
        $scope.newCertificate.from_pdf = true;
        $scope.first_name =
          asegurado.propietario_contratante &&
          asegurado.propietario_contratante.trim()
            ? asegurado.propietario_contratante
            : asegurado.contratante_full_name || "";
        $scope.first_name = sinDiacriticos($scope.first_name);
        if ($scope.read_pdf_pf.data["cobertura"]) {
          $scope.asignarPaquete();
        }
        $scope.newCertificate.from_pdf = true;
        $rootScope.readPDF = {
          individual: $scope.read_pdf_pf.data["Datos del asegurado"],
          corporation: $scope.read_pdf_pf.data["Datos del asegurado"],
          address: $scope.read_pdf_pf.data["contratante_domicilio"],
          first_name: $scope.first_name,
          last_name: $scope.read_pdf_pf.data["contratante_primer_apellido"],
          second_last_name:
            $scope.read_pdf_pf.data["contratante_segundo_apellido"],
          type_person: $scope.read_pdf_pf.data["persona"],
        };
        // buscar o crear contratante
        // buscar o crear contratante fin
      }
    };
    // crear por captura | lectura PDF
    $scope.loaderPdf = false;
    $scope.fileSelected_pf = {};
    $scope.fileNameChanged = function (ele) {
      $scope.fileSelected_pf = {};
      $scope.filePdf = ele.files[0];
      $scope.fileSelected_pf = ele.files[0];
    };
    $scope.showFile = function (argument) {
      var reader = new FileReader();
      reader.readAsDataURL(argument.files[0]);
      $scope.fileSelected_pf = argument.files[0];
      // $scope.uploader.queue = argument.files[0]
      var reader_pdf = new FileReader();
      reader_pdf.readAsDataURL($scope.fileSelected_pf);
      $scope.urlsfile = URL.createObjectURL(argument.files[0]);
      reader_pdf.onload = function () {
        $scope.pdffile = reader_pdf.result;
        $scope.okxfile = new Blob([$scope.pdffile], {
          type: "application/pdf",
        });
        var fileURL = $scope.urlsfile;
        $scope.content = $sce.trustAsResourceUrl(fileURL);
        // window.open($scope.content);
      };
      reader_pdf.onerror = function (error) {
        console.log("Error: ", error);
      };
    };
    function generarRequestId() {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      var hex = Array.prototype.map
        .call(bytes, function (b) {
          return ("0" + b.toString(16)).slice(-2);
        })
        .join("");
      return [
        hex.substr(0, 8),
        hex.substr(8, 4),
        hex.substr(12, 4),
        hex.substr(16, 4),
        hex.substr(20),
      ].join("-");
    }
    function formatearNumero_calculate(nStr, campo) {
      try {
        nStr += "";
        var x = nStr.split(".");
        var x1 = x[0];
        var x2 = x.length > 1 ? "." + x[1] : "";

        var cadenas = x1.split(",");
        var cadena_sin_comas = "";
        for (i = 0; i < cadenas.length; i++) {
          cadena_sin_comas = cadena_sin_comas + cadenas[i];
        }
        if (
          cadena_sin_comas != undefined &&
          cadena_sin_comas != "undefined" &&
          cadena_sin_comas != "NaN" &&
          cadena_sin_comas != NaN
        ) {
          return cadena_sin_comas + x2;
        } else {
          return nStr;
        }
      } catch (e) {
        return 0;
      }
    }
    function sinDiacriticos(texto) {
      return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    $scope.contratanteCreator = function () {
      $scope.create_natural = true;
      $scope.create_juridical = true;
      $rootScope.show_contractor = true;
      $localStorage.orderForm = JSON.stringify($scope.newCertificate);
    };
    // lectura por pdf
    $scope.capturarPoliza = function () {
      if (!$scope.filePdf) {
        SweetAlert.swal(
          "Error",
          "Cargue un archivo pdf para capturar.",
          "error"
        );
        return;
      }
      $scope.read_pdf_pf = {};
      order.form = {};
      $localStorage["datos_pdf_flotilla"] = {};
      $localStorage["primas"] = {};
      $localStorage["defaults"] = {};
      SweetAlert.swal(
        {
          title: "🔎 Revisión de la información extraída",
          text:
            "<p style='margin:0 0 10px;'>Antes de guardar, verifique que los datos obtenidos del PDF sean <strong>correctos</strong> y estén <strong>completos</strong>.</p>" +
            "<p style='margin:0 0 6px 0;'><strong>Aspectos clave a validar:</strong></p>" +
            "<ul style='margin:0 0 0 18px; padding:0; line-height:1.5;'>" +
            "  <li><strong>Número de póliza</strong> y <strong>vigencia</strong></li>" +
            "  <li><strong>Serie</strong> (en caso de Automóviles) y <strong>Asegurados</strong></li>" +
            "  <li><strong>Coberturas</strong> y <strong>primas</strong></li>" +
            "  <li><strong>Datos del contratante</strong>: Nombre y RFC</li>" +
            "</ul>" +
            "<p style='margin:12px 0 0; font-size:12px; color:#5f6368;'>⚠️ En caso de detectar alguna discrepancia, informe a Soporte.</p>",
          type: "warning",
          html: true,
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Continuar",
          closeOnConfirm: true,
          closeOnCancel: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            console.log("continuar", isConfirm);
          }
        }
      );

      $scope.countFile = 0;
      $scope.loaderPdf = true;
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url.LECTORPDF + "upload-pdf");
      var auxRamo =
        $scope.ramoPdf && $scope.ramoPdf.ramo_id ? $scope.ramoPdf.ramo_id : 0;

      var data = new FormData();
      var dataFile = new FormData();
      dataFile.append("arch", $scope.filePdf);
      dataFile.append("nombre", $scope.fileSelected_pf.name);
      data.append("archivo", $scope.filePdf);
      // data.append("insurance", $scope.aseguradoraPdf);
      // 3) Añade tus parámetros adicionales
      data.append("nombre", $scope.fileSelected_pf.name);
      data.append("org", $scope.orgName);
      var requestId = generarRequestId();
      data.append("requestId", requestId);
      $localStorage.dataFile = dataFile;
      $scope.fileSelected_pf.formData = [];
      xhr.timeout = 1200000;
      xhr.ontimeout = function (e) {
        console.log("error", e);
        $scope.loaderPdf = true;
        SweetAlert.swal(
          "Error**",
          "A ocurrido un error al cargar el PDF, por favor intentalo de nuevo.",
          "error"
        );
      };
      xhr.send(data);
      xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          $scope.loaderPdf = false;
          $scope.read_pdf_pf = JSON.parse(xhr.response);
          if ($scope.read_pdf_pf.status != "200_OK_ACCEPTED") {
            SweetAlert.swal(
              "Error*",
              "A ocurrido un error al cargar el PDF, por favor intentalo de nuevo.",
              "error"
            );
          } else {
            if ($scope.read_pdf_pf.request_id !== requestId) {
              console.log(
                "No coincide*",
                $scope.read_pdf_pf.request_id,
                requestId
              );
            }
            $localStorage["datos_pdf_flotilla"] = $scope.read_pdf_pf;
            $scope.filePdf = {};
            if ($scope.read_pdf_pf && $scope.read_pdf_pf.data) {
              if ($scope.read_pdf_pf.data["Numero de poliza"]) {
                $scope.newCertificate.poliza_number =
                  $scope.read_pdf_pf.data["Numero de poliza"];
              }
              if (
                $scope.read_pdf_pf.data["Datos generales de la poliza"][
                  "Moneda"
                ]
              ) {
                if (
                  $scope.read_pdf_pf.data["Datos generales de la poliza"][
                    "Moneda"
                  ].toLowerCase() == "pesos"
                ) {
                  $scope.newCertificate.f_currency = 1;
                }
                if (
                  $scope.read_pdf_pf.data["Datos generales de la poliza"][
                    "Moneda"
                  ].toLowerCase() == "nacional"
                ) {
                  $scope.newCertificate.f_currency = 1;
                }
                if (
                  $scope.read_pdf_pf.data["Datos generales de la poliza"][
                    "Moneda"
                  ].toLowerCase() == "dolares"
                ) {
                  $scope.newCertificate.f_currency = 2;
                }
                if (
                  $scope.read_pdf_pf.data["Datos generales de la poliza"][
                    "Moneda"
                  ].toLowerCase() == "udi"
                ) {
                  $scope.newCertificate.f_currency = 3;
                }
                if (
                  $scope.read_pdf_pf.data["Datos generales de la poliza"][
                    "Moneda"
                  ].toLowerCase() == "euro"
                ) {
                  $scope.newCertificate.f_currency = 4;
                }
                if (
                  $scope.read_pdf_pf.data["Datos generales de la poliza"][
                    "Moneda"
                  ].toLowerCase() == "extranjera"
                ) {
                  $scope.newCertificate.f_currency = 2;
                }
              }
              if ($scope.read_pdf_pf.data["fecha_inicio"]) {
                $scope.newCertificate.start_of_validity =
                  $scope.read_pdf_pf.data["fecha_inicio"];
              }
              if ($scope.read_pdf_pf.data["fecha_fin"]) {
                $scope.newCertificate.end_of_validity =
                  $scope.read_pdf_pf.data["fecha_fin"];
              }
              if (
                $scope.read_pdf_pf.data["Datos generales de la poliza"][
                  "Forma de pago"
                ]
              ) {
                $scope.newCertificate.forma_de_pago =
                  $scope.read_pdf_pf.data["Datos generales de la poliza"][
                    "Forma de pago"
                  ];
              }
              if ($scope.newCertificate.forma_de_pago) {
                $scope.frequencies.forEach(function (item) {
                  if (item.value == $scope.newCertificate.forma_de_pago) {
                    $scope.newCertificate.forma_de_pago = item;
                    $scope.directiveReceipts.payment =
                      $scope.newCertificate.forma_de_pago;
                  }
                });
              }
              if ($scope.read_pdf_pf.data["Datos del vehiculo"]) {
                $scope.newCertificate.datos = {};
                $scope.newCertificate.datos = {
                  adjustment: "",
                  beneficiary_address: "",
                  beneficiary_rfc: "",
                  brand: "",
                  car_owner: "",
                  charge_type: $scope.types[0],
                  policy_type: $scope.types[0],
                  color: "",
                  driver: "",
                  email: "",
                  engine: "",
                  license_plates: "",
                  model: "",
                  mont_adjustment: 0,
                  mont_special_team: 0,
                  no_employee: "",
                  preferential_benefiaciary: "",
                  procedencia: $scope.procedencias[0],
                  serial: "",
                  service: "",
                  special_team: "",
                  sum_insured: 0,
                  usage: $scope.usages[0],
                  version: "",
                  year: "",
                };
                $scope.newCertificate.is_renewable = $scope.renewals[0];
                $scope.newCertificate.datos.policy_type = $scope.types[0];
                $scope.newCertificate.datos.procedencia =
                  $scope.procedencias[0];
                $scope.newCertificate.datos.serial =
                  $scope.read_pdf_pf.data["Datos del vehiculo"]["serie"];
                $scope.newCertificate.datos.service =
                  $scope.read_pdf_pf.data["Datos del vehiculo"]["service"];
                if (!$scope.newCertificate.datos.service) {
                  if ($scope.read_pdf_pf.data["Datos del vehiculo"]["tipo"]) {
                    $scope.newCertificate.datos.service =
                      $scope.read_pdf_pf.data["Datos del vehiculo"]["tipo"];
                  }
                }
                $scope.newCertificate.datos.engine =
                  $scope.read_pdf_pf.data["Datos del vehiculo"]["motor"];
                $scope.newCertificate.datos.year = parseInt(
                  $scope.read_pdf_pf.data["Datos del vehiculo"]["anio"]
                );
                $scope.newCertificate.datos.brand =
                  $scope.read_pdf_pf.data["Datos del vehiculo"]["marca"];
                $scope.newCertificate.datos.model =
                  $scope.read_pdf_pf.data["Datos del vehiculo"]["modelo"];
                $scope.newCertificate.datos.adjustment = "";
                $scope.newCertificate.datos.license_plates =
                  $scope.read_pdf_pf.data["Datos del vehiculo"]["placas"];
                $scope.newCertificate.datos.usage =
                  $scope.read_pdf_pf.data["Datos del vehiculo"]["uso"];
                if ($scope.newCertificate.datos.usage) {
                  $scope.usages.forEach(function (item) {
                    if (item.value == $scope.newCertificate.datos.usage) {
                      $scope.newCertificate.datos.usage = item;
                    }
                  });
                }
                $scope.newCertificate.datos.version =
                  $scope.read_pdf_pf.data["Datos del vehiculo"]["version"];
                if (!$scope.newCertificate.datos.version) {
                  if (
                    $scope.read_pdf_pf.data["Datos del vehiculo"][
                      "descripcion_vehiculo"
                    ]
                  ) {
                    $scope.newCertificate.datos.version =
                      $scope.read_pdf_pf.data["Datos del vehiculo"][
                        "descripcion_vehiculo"
                      ];
                  }
                }
              }
              if ($scope.read_pdf_pf.data["Primas"]) {
                $scope.directiveReceipts.from_pdf = true;
                if ($scope.read_pdf_pf.data["Primas"]["Prima total"]) {
                  $scope.directiveReceipts.primaTotal = $scope.read_pdf_pf.data[
                    "Primas"
                  ]["Prima total"]
                    ? parseFloat(
                        formatearNumero_calculate(
                          $scope.read_pdf_pf.data["Primas"]["Prima total"]
                        )
                      )
                    : $scope.read_pdf_pf.data["Primas"]["IMPORTE TOTAL"]
                    ? parseFloat(
                        formatearNumero_calculate(
                          $scope.read_pdf_pf.data["Primas"]["IMPORTE TOTAL"]
                        )
                      )
                    : 0;
                  $scope.directiveReceipts.subTotal = $scope.read_pdf_pf.data[
                    "Primas"
                  ]["Subtotal"]
                    ? parseFloat(
                        formatearNumero_calculate(
                          $scope.read_pdf_pf.data["Primas"]["Subtotal"]
                        )
                      )
                    : 0;
                  $scope.directiveReceipts.from_pdf = true;
                  $localStorage["primas"] = $scope.directiveReceipts;
                }

                if ($scope.read_pdf_pf.data["Primas"]["Prima neta"]) {
                  $scope.directiveReceipts.primaNeta = $scope.read_pdf_pf.data[
                    "Primas"
                  ]["Prima neta"]
                    ? parseFloat(
                        formatearNumero_calculate(
                          $scope.read_pdf_pf.data["Primas"]["Prima neta"]
                        )
                      )
                    : 0;
                  $scope.directiveReceipts.from_pdf = true;
                  $localStorage["primas"] = $scope.directiveReceipts;
                }

                if ($scope.read_pdf_pf.data["Primas"]["Gastos de expedición"]) {
                  try {
                    $scope.directiveReceipts.derecho = $scope.read_pdf_pf.data[
                      "Primas"
                    ]["Gastos de expedición"]
                      ? parseFloat(
                          formatearNumero_calculate(
                            $scope.read_pdf_pf.data["Primas"][
                              "Gastos de expedición"
                            ]
                          )
                        )
                      : 0;
                    $localStorage["primas"] = $scope.directiveReceipts;
                  } catch (o) {
                    $scope.directiveReceipts.derecho = $scope.read_pdf_pf.data[
                      "Primas"
                    ]["Gastos de expedici\u00f3n"]
                      ? parseFloat(
                          formatearNumero_calculate(
                            $scope.read_pdf_pf.data["Primas"][
                              "Gastos de expedici\u00f3n"
                            ]
                          )
                        )
                      : 0;
                    $localStorage["primas"] = $scope.directiveReceipts;
                  }
                }
                if (
                  $scope.read_pdf_pf.data["Primas"]["Gastos por Expedición."]
                ) {
                  try {
                    $scope.directiveReceipts.derecho = $scope.read_pdf_pf.data[
                      "Primas"
                    ]["Gastos por Expedición."]
                      ? parseFloat(
                          formatearNumero_calculate(
                            $scope.read_pdf_pf.data["Primas"][
                              "Gastos por Expedición."
                            ]
                          )
                        )
                      : 0;
                    $localStorage["primas"] = $scope.directiveReceipts;
                  } catch (o) {
                    $scope.directiveReceipts.derecho = $scope.read_pdf_pf.data[
                      "Primas"
                    ]["Gastos por Expedici\u00f3n."]
                      ? parseFloat(
                          formatearNumero_calculate(
                            $scope.read_pdf_pf.data["Primas"][
                              "Gastos por Expedici\u00f3n."
                            ]
                          )
                        )
                      : 0;
                    $localStorage["primas"] = $scope.directiveReceipts;
                  }
                }
                if (
                  $scope.read_pdf_pf.data["Primas"][
                    "Financiamiento por pago fraccionado"
                  ]
                ) {
                  $scope.directiveReceipts.rpf = $scope.read_pdf_pf.data[
                    "Primas"
                  ]["Financiamiento por pago fraccionado"]
                    ? parseFloat(
                        formatearNumero_calculate(
                          $scope.read_pdf_pf.data["Primas"][
                            "Financiamiento por pago fraccionado"
                          ]
                        )
                      )
                    : 0;
                  $localStorage["primas"] = $scope.directiveReceipts;
                }
                if ($scope.read_pdf_pf.data["Primas"]["Derecho de Póliza"]) {
                  $scope.directiveReceipts.derecho = $scope.read_pdf_pf.data[
                    "Primas"
                  ]["Derecho de Póliza"]
                    ? parseFloat(
                        formatearNumero_calculate(
                          $scope.read_pdf_pf.data["Primas"]["Derecho de Póliza"]
                        )
                      )
                    : 0;
                  $localStorage["primas"] = $scope.directiveReceipts;
                }
                if ($scope.read_pdf_pf.data["Primas"]["Descuento"]) {
                  var valor =
                    parseFloat(
                      formatearNumero_calculate(
                        $scope.read_pdf_pf.data["Primas"]["Descuento"]
                      )
                    ) || 0;
                  // Si el valor es negativo → convertirlo a positivo multiplicando por -1
                  if (valor < 0) {
                    valor = valor * -1;
                  }
                  $scope.directiveReceipts.descuento = valor;
                  $localStorage["primas"] = $scope.directiveReceipts;
                }
                if ($scope.read_pdf_pf.data["Primas"]["IVA"]) {
                  $scope.directiveReceipts.iva = $scope.read_pdf_pf.data[
                    "Primas"
                  ]["IVA"]
                    ? parseFloat(
                        formatearNumero_calculate(
                          $scope.read_pdf_pf.data["Primas"]["IVA"]
                        )
                      )
                    : 0;
                  $localStorage["primas"] = $scope.directiveReceipts;
                }
                if (
                  $scope.read_pdf_pf.data["Primas"] &&
                  $scope.read_pdf_pf.data["Primas"]["I.V.A."]
                ) {
                  $scope.directiveReceipts.iva = $scope.read_pdf_pf.data[
                    "Primas"
                  ]["I.V.A."]
                    ? parseFloat(
                        formatearNumero_calculate(
                          $scope.read_pdf_pf.data["Primas"]["I.V.A."]
                        )
                      )
                    : 0;
                  $localStorage["primas"] = $scope.directiveReceipts;
                }
              }
              var asegurado =
                $scope.read_pdf_pf.data["Datos del asegurado"] || {};
              $scope.first_name =
                asegurado.propietario_contratante &&
                asegurado.propietario_contratante.trim()
                  ? asegurado.propietario_contratante
                  : asegurado.contratante_full_name || "";
              $scope.first_name = sinDiacriticos($scope.first_name);
              $scope.newCertificate.conducto_de_pago = 1;
              $scope.newCertificate.from_pdf = true;
              $rootScope.readPDF = {
                individual: $scope.read_pdf_pf.data["Datos del asegurado"],
                corporation: $scope.read_pdf_pf.data["Datos del asegurado"],
                address: $scope.read_pdf_pf.data["contratante_domicilio"],
                first_name: $scope.first_name,
                last_name:
                  $scope.read_pdf_pf.data["contratante_primer_apellido"],
                second_last_name:
                  $scope.read_pdf_pf.data["contratante_segundo_apellido"],
                type_person: $scope.read_pdf_pf.data["persona"],
              };
              // buscar o crear contratante
              $scope.read_pdf_pf_contractor = {};
              if ($scope.read_pdf_pf.data["persona"] == 2) {
                $scope.read_pdf_pf_contractor.type = false;
                $scope.read_pdf_pf_contractor.name =
                  $scope.read_pdf_pf.data["contratante_full_name"];
              } else {
                $scope.read_pdf_pf_contractor.type = true;
                // $scope.read_pdf_pf_contractor.name = $scope.read_pdf_pf.data['Datos del asegurado']['propietario_contratante']
                $scope.read_pdf_pf_contractor.name =
                  $scope.read_pdf_pf.data["contratante_full_name"];
              }
              $scope.show_contratante = "contractors-match/";
              $http
                .post(url.IP + $scope.show_contratante, {
                  matchWord: $scope.read_pdf_pf_contractor.name,
                  poliza: true,
                })
                .then(function (response) {
                  if (response.status === 200) {
                    if (response.data != 404) {
                      if (response.data.contractors.length) {
                        if (response.data.contractors.length) {
                          for (
                            var i = 0;
                            i < response.data.contractors.length;
                            i++
                          ) {
                            var reg = /\d{,}/g;
                            var reg2 = /\d{.}/g;
                            var nombre_pdf = $scope.read_pdf_pf_contractor.name
                              .replace(reg, "")
                              .toLowerCase();
                            var nombre_pdf = nombre_pdf
                              .replace(reg2, "")
                              .toLowerCase();
                            var nombre_api = response.data.contractors[
                              i
                            ].full_name
                              .replace(reg, "")
                              .toLowerCase();
                            var nombre_api = nombre_pdf
                              .replace(reg2, "")
                              .toLowerCase();
                            if (
                              nombre_pdf
                                .replace(",", "")
                                .replace(".", "")
                                .toLowerCase() ==
                              nombre_api
                                .replace(",", "")
                                .replace(".", "")
                                .toLowerCase()
                            ) {
                              order.contratante.val =
                                response.data.contractors[i].full_name;
                              order.contratante.value =
                                response.data.contractors[i];
                              order.contratante.phone =
                                response.data.contractors[i].phone;
                              order.contratante.email =
                                response.data.contractors[i].email;
                            }
                            if (i + 1 == response.data.contractors.length) {
                              if (!order.contratante.value) {
                                $scope.objetoPoliza = $scope.newCertificate;
                                $scope.contratanteCreator();
                              }
                            }
                          }
                        } else {
                          $scope.objetoPoliza = $scope.newCertificate;
                          $scope.contratanteCreator();
                        }
                        // }
                      } else {
                        $scope.objetoPoliza = $scope.newCertificate;
                        $scope.contratanteCreator();
                      }
                    } else {
                      $scope.objetoPoliza = $scope.newCertificate;
                      $scope.contratanteCreator();
                    }
                  } else {
                    $scope.objetoPoliza = $scope.newCertificate;
                    $scope.contratanteCreator();
                  }
                });
              // buscar o crear contratante fin
              if ($scope.read_pdf_pf.data["cobertura"]) {
                $scope.asignarPaquete();
              }
            }
          }
        } else {
          // 1) Obtener cuerpo
          var body = (xhr && (xhr.responseText || xhr.response)) || null;
          // 2) Parseo seguro
          var obj = null;
          if (body && typeof body === "string") {
            try {
              obj = JSON.parse(body);
            } catch (e) {
              obj = null;
            }
          } else if (body && typeof body === "object") {
            obj = body;
          }

          // 3) Mensaje
          var fallback =
            "Ha ocurrido un error al cargar el PDF; por favor inténtalo de nuevo.";
          var msg =
            (obj && obj.data && obj.data.error) || (obj && obj.error) || "";
          var reqId = obj && (obj.request_id || obj.requestId);
          // 4) Pintar (forzar digest si estás fuera de Angular)
          if (msg) {
            $scope.$applyAsync(function () {
              $scope.loaderPdf = false;
              SweetAlert.swal({
                title: "Info",
                text: reqId ? msg : msg,
                type: "info",
                confirmButtonText: "Entendido",
              });
            });
          }
        }
      };
      xhr.onerror = function () {
        console.error("❌ Error de red / servidor");
        $scope.loaderPdf = false;
        SweetAlert.swal(
          "Info",
          "Ha ocurrido un error al cargar el PDF; por favor inténtalo de nuevo o, contacte con soporte (servidor).",
          "info"
        );
      };
    };

    // captura por PDF lectura Autos
    $scope.checkNumSerie = function () {
      if ($scope.newCertificate.datos.serial) {
        helpers
          .existSerial($scope.newCertificate.datos.serial)
          .then(function (request) {
            if (request.exist == true) {
              SweetAlert.swal(
                "Información",
                "La SERIE del AUTO ya existe en otra póliza vigente: " +
                  request.poliza,
                "info"
              );
              // newCertificate.datos.serial = '';
            }
          })
          .catch(function (err) {});
      }
    };
    function save_info_tab() {
      $localStorage.save_edition_flotilla_poliza = angular.copy(
        $scope.newCertificate
      );
      $localStorage.save_edition_flotilla_poliza["contrator"] =
        order.contratante;
    }

    $scope.changePayment = function (param) {
      $scope.directiveReceipts.payment =
        $scope.newCertificate.forma_de_pago.value;
      $scope.directiveReceipts.subramo = $scope.dataCaratula.subramo;
      $scope.directiveReceipts.comisiones = $scope.dataCaratula.clave
        ? $scope.dataCaratula.clave.clave_comision
        : [];
      $localStorage.save_edition_flotilla_poliza["forma_de_pago"] =
        $scope.newCertificate.forma_de_pago;
    };
    $scope.selectComision = function (param) {
      $scope.newCertificate.comision_percent = param.comission;
      $scope.newCertificate.udi = param.udi;
      $scope.newCertificate.comision_percent = param.comission;
      $scope.newCertificate.udi = param.udi;
    };
    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.FLOTILLA) {
        if ($scope.caratula.subramo == "Automóviles") {
          $scope.allReceipts = [];
          $scope.excelJson = param.FLOTILLA;
          $scope.excelJson.forEach(function (item) {
            if (!item.CLASE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CLASE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.NO_CARATULA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_CARATULA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            // if(!item.FOLIO){
            //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna FOLIO, corrige el error y vuelve a subir el excel.', 'error');
            //   flagCertificate = true;
            // }
            if (!item.NO_POLIZA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_POLIZA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CONTRATANTE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CONTRATANTE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.TIPO_CONTRATANTE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO_CONTRATANTE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.DIRECCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DIRECCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            // if(!item.CORREO){
            //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna CORREO, corrige el error y vuelve a subir el excel.', 'error');
            //   flagCertificate = true;
            // }else{
            //   if(!$scope.validateEmail(item.CORREO)){
            //     SweetAlert.swal('Error', 'Formato inválido de la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna CORREO, corrige el error y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            // }
            // if(!item.TELEFONO){
            //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna TELEFONO, corrige el error y vuelve a subir el excel.', 'error');
            //   flagCertificate = true;
            // }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.FRECUENCIA_PAGO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FRECUENCIA_PAGO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.RENOVABLE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RENOVABLE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MONEDA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MONEDA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            // if(!item.LINEA_NEGOCIO){
            //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna LINEA_NEGOCIO, corrige el error y vuelve a subir el excel.', 'error');
            //   flagCertificate = true;
            // }
            // if(!item.SUCURSAL){
            //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna SUCURSAL, corrige el error y vuelve a subir el excel.', 'error');
            //   flagCertificate = true;
            // }
            if (!item.TIPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.PROCEDENCIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PROCEDENCIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.PROCEDENCIA < 0 || item.PROCEDENCIA > 4) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PROCEDENCIA no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            // if(!item.CONDUCTOR){
            //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna CONDUCTOR, corrige el error y vuelve a subir el excel.', 'error');
            //   flagCertificate = true;
            // }
            if (!item.MARCA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MODELO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.AÑO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna AÑO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.AÑO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna AÑO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VERSION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SERIE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MOTOR) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MOTYOR, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            // if(!item.COLOR){
            //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna COLOR, corrige el error y vuelve a subir el excel.', 'error');
            //   flagCertificate = true;
            // }
            if (!item.MATRICULA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MATRICULA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.USO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna USO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.USO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.USO < 1 || item.USO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.SERVICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERVICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.PRIMA_NETA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PRIMA_NETA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.DESCUENTO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DESCUENTO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.RPF) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RPF, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.DERECHO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DERECHO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.IVA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna IVA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.PRIMA_TOTAL) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PRIMA_TOTAL, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.COMISION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna COMISION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.PORCENTAJE_COMISION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PORCENTAJE_COMISION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (parseFloat(item.PORCENTAJE_COMISION) > 100.0) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PORCENTAJE_COMISION, excede el 100%, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (parseFloat(item.PORCENTAJE_COMISION) < 0.0) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PORCENTAJE_COMISION, no puede ser menor a 0, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (parseInt(item.CLASE) == 2) {
              if (!item.NO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PRIMA_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.RPF_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.DERECHO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.IVA_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.TOTAL_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TOTAL_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.COMISION_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.INICIO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.INICIO_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.FIN_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.FIN_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VENCIMIENTO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VENCIMIENTO_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }

              var receipt = {
                comision: item.COMISION_RECIBO,
                delivered: false,
                derecho: item.DERECHO_RECIBO,
                fecha_fin: item.FIN_RECIBO,
                fecha_inicio: item.INICIO_RECIBO,
                iva: item.IVA_RECIBO,
                prima_neta: item.PRIMA_RECIBO,
                prima_total: item.TOTAL_RECIBO,
                recibo_numero: item.NO_RECIBO,
                rpf: item.RPF_RECIBO,
                sub_total: item.SUBTOTAL_RECIBO,
                vencimiento: item.VENCIMIENTO_RECIBO,
                poliza: item.NO_POLIZA,
                receipt_type: 1,
              };
              $scope.allReceipts.push(receipt);
            }
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      // $scope.excelJson.forEach(function(item, index){
      //   if((index + 1) >= $scope.valueInitial && index < $scope.valueFinal){
      //     $scope.excelJsonViews.push(item);
      //   }
      // });
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          if (item.AÑO_CONSTRUCCION) {
            item.ANO_CONSTRUCCION = item.AÑO_CONSTRUCCION;
            item.ANO_RECONSTRUCCION = item.AÑO_RECONSTRUCCION;
          }
          if (item.AÑO) {
            item.ANIO = item.AÑO;
          }
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };
    function get_claves() {
      var date = new Date($scope.newCertificate.startDate);
      if (isNaN(date)) {
        var date = new Date(mesDiaAnio($scope.newCertificate.startDate));
      }
      $http
        .get(url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });

            order.defaults.claves = clavesResponse.data;
            if (order.defaults.claves.length == 1) {
              try {
                order.form.comision_percent = order.form.clave.comission;
                order.form.udi = order.form.clave.udi;
              } catch (e) {}
            }
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }
    $scope.cancelCertificates = function () {
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.saveCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loader = true;
      $scope.certifcados = [];

      if ($scope.selectedCertificates.FLOTILLA) {
        $scope.selectedCertificates.FLOTILLA.forEach(function (item) {
          if (item.CLASE == 1) {
            $scope.recibosIndividuales = [];
            var dataCar = [
              {
                brand: item.MARCA,
                charge_type: 0,
                color: item.COLOR ? item.COLOR : null,
                driver: item.CONDUCTOR ? item.CONDUCTOR : null,
                email: item.CORREO ? item.CORREO : "",
                engine: item.MOTOR ? item.MOTOR : null,
                license_plates: item.MATRICULA ? item.MATRICULA : null,
                model: item.MODELO,
                policy_type: item.TIPO ? parseInt(item.TIPO) : null,
                procedencia: parseInt(item.PROCEDENCIA),
                serial: item.SERIE,
                service: item.SERVICIO,
                usage: parseInt(item.USO),
                version: item.VERSION,
                year: item.AÑO,
                no_employee: null,
                sum_insured: null,
                adjustment: item.ADAPTACIONES ? item.ADAPTACIONES : null,
                mont_adjustment: item.MONTO_ADAPTACIONES
                  ? item.MONTO_ADAPTACIONES
                  : null,
                special_team: item.EQUIPAMIENTO ? item.EQUIPAMIENTO : null,
                mont_special_team: item.MONTO_EQUIPAMIENTO
                  ? item.MONTO_EQUIPAMIENTO
                  : null,
                beneficiary_name: item.BENEFICIARIO_PREFERENTE
                  ? item.BENEFICIARIO_PREFERENTE
                  : null,
                preferential_benefiaciary: item.BENEFICIARIO_PREFERENTE
                  ? item.BENEFICIARIO_PREFERENTE
                  : null,
                beneficiary_rfc: item.BENEFICIARIO_RFC
                  ? item.BENEFICIARIO_RFC
                  : null,
                beneficiary_address: item.BENEFICIARIO_DIRECCION
                  ? item.BENEFICIARIO_DIRECCION
                  : null,
              },
            ];
            $scope.allReceipts.forEach(function (receipt, index) {
              if (receipt.prima_neta && receipt.rpf && receipt.derecho) {
                if (receipt.poliza == item.NO_POLIZA) {
                  receipt["conducto_de_pago"] = parseInt(item.CONDUCTO_DE_PAGO)
                    ? item.CONDUCTO_DE_PAGO
                    : 1;
                  if (receipt.fecha_inicio.toString().length > 10) {
                    receipt.fecha_inicio = datesFactory.convertDate(
                      receipt.fecha_inicio
                    );
                  }
                  receipt.fecha_inicio = datesFactory.toDate(
                    receipt.fecha_inicio
                  );

                  if (receipt.fecha_fin.toString().length > 10) {
                    receipt.fecha_fin = datesFactory.convertDate(
                      receipt.fecha_fin
                    );
                  }
                  receipt.fecha_fin = datesFactory.toDate(receipt.fecha_fin);
                  if (receipt.vencimiento.toString().length > 10) {
                    receipt.vencimiento = datesFactory.convertDate(
                      receipt.vencimiento
                    );
                  }
                  receipt.vencimiento = datesFactory.toDate(
                    receipt.vencimiento
                  );
                  $scope.recibosIndividuales.push(receipt);
                }
              }
            });

            $scope.obj_poliza = {
              aplicarDescuento: false,
              primaNeta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
              descuento: item.DESCUENTO ? item.DESCUENTO : 0,
              rpf: item.RPF ? item.RPF : 0,
              derecho: item.DERECHO ? item.DERECHO : 0,
              iva: item.IVA ? item.IVA : 0,
              primaTotal: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
              subTotal:
                parseFloat(item.PRIMA_NETA) +
                parseFloat(item.RPF) +
                parseFloat(item.DERECHO),
            };

            // if (parseInt(item.TIPO_CONTRATANTE) ==1) {
            //   $scope.naturalP = item.CONTRATANTE
            //   $scope.juridicalP = null
            // }else if (parseInt(item.TIPO_CONTRATANTE) ==2) {
            //   $scope.naturalP = null
            //   $scope.juridicalP = item.CONTRATANTE
            // }
            $scope.contractorP = item.CONTRATANTE;
            var certificateData = {
              accidents_policy: [],
              address: parseInt(item.DIRECCION),
              aseguradora: $scope.dataCaratula.aseguradora.id,
              automobiles_policy: dataCar,
              business_line: $scope.dataCaratula.business_line,
              caratula: $scope.dataCaratula.id,
              celula: $scope.caratula.celula_id,
              clave: $scope.dataCaratula.clave.id,
              coverageInPolicy_policy: [],
              damages_policy: [],
              document_type: 12,
              end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
              endorsement: false,
              collection_executive: $scope.dataCaratula.collection_executive
                ? $scope.dataCaratula.collection_executive.id
                : null,
              f_currency: parseInt(item.MONEDA),
              folio: item.FOLIO ? item.FOLIO : "",
              forma_de_pago: parseInt(item.FRECUENCIA_PAGO),
              groupinglevel: $scope.caratula.subsubgrouping_level
                ? $scope.caratula.subsubgrouping_level.id
                : $scope.caratula.subgrouping_level
                ? $scope.caratula.subgrouping_level.id
                : $scope.caratula.grouping_level
                ? $scope.caratula.grouping_level.id
                : null,
              identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
              internal_number: null,
              is_renewable: item.RENOVABLE ? item.RENOVABLE : null,
              // juridical: parseInt($scope.juridicalP),
              life_policy: [],
              // natural: parseInt($scope.naturalP),
              contractor: parseInt($scope.contractorP),
              old_policies: [],
              paquete: parseInt(item.PAQUETE),
              parent: $scope.dataCaratula.url,
              // poliza: $scope.obj_poliza,
              poliza_number: item.NO_POLIZA,
              ramo: $scope.dataCaratula.ramo.id,
              recibos_poliza: $scope.recibosIndividuales,
              responsable: $scope.dataCaratula.collection_executive
                ? $scope.dataCaratula.collection_executive.id
                : null,
              state_circulation: item.ESTADO_CIRCULACION
                ? parseInt(item.ESTADO_CIRCULACION)
                : "",
              start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
              status: 14,
              sucursal: item.SUCURSAL ? parseInt(item.SUCURSAL) : null,
              subramo: $scope.dataCaratula.subramo.id,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : null,
              p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
              descuento: item.DESCUENTO ? item.DESCUENTO : 0,
              rpf: item.RPF ? item.RPF : 0,
              derecho: item.DERECHO ? item.DERECHO : 0,
              sub_total: $scope.obj_poliza.subTotal
                ? parseFloat($scope.obj_poliza.subTotal).toFixed(2)
                : 0,
              iva: item.IVA ? item.IVA : 0,
              p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
              comision: item.COMISION ? item.COMISION : 0,
              comision_percent: item.PORCENTAJE_COMISION
                ? item.PORCENTAJE_COMISION
                : 0,
              conducto_de_pago: parseInt(item.CONDUCTO_DE_PAGO)
                ? item.CONDUCTO_DE_PAGO
                : 1,
            };
            if ($scope.policy_history.length > 0) {
              if ($scope.caratula_renovada) {
                certificateData.caratula_renovada = $scope.caratula_renovada;
              }
            } else {
              console.log("--no es renovación--", $scope.policy_history);
            }
            $scope.certifcados.push(certificateData);
          }
        });
      }

      $http({
        method: "POST",
        url: url.IP + "save_caratula_polizas/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          l.stop();
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            $localStorage.saved_flotilla_info = {};
            var params = {
              model: 18,
              event: "POST",
              associated_id: $scope.caratula.id,
              identifier: " agregó pólizas individuales.",
            };

            dataFactory
              .post("send-log/", params)
              .then(function success(responselog) {});
            SweetAlert.swal(
              "¡Listo!",
              "Pólizas individuales creadas exitosamente.",
              "success"
            );
            activate();
            $scope.showItemCertificate(1);
          } else {
            $scope.loader = false;
            SweetAlert.swal(
              "ERROR",
              "Ócurrio un error al cargar las pólizas.\n" + response.data.data,
              "error"
            );
            $scope.cancelCertificates();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };

    $scope.addEmailsConfirmPolicy = function (insurance, param) {
      insurance.contratante = param;
      insurance.poliza = $scope.caratula;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return insurance;
          },
          valueReceipt: function () {
            return insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    };

    $scope.returnToReceipts = function () {
      $scope.show_binnacle_receipt = false;
    };

    $scope.showBinnacleReceipt = function (receipt) {
      $scope.show_binnacle_receipt = true;
      $scope.receipt_id = receipt.id;
      $scope.comments_data_receipt = [];
      $scope.receiptmodel = receipt.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: receipt.id,
        },
      })
        .then(function (request) {
          $scope.comments_data_receipt = request.data.results;
          $scope.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.showEndorsementsCertificate = function (item) {
      $scope.infoFlagCertificate = false;
      $scope.endorsementFlagCertificate = true;
      $scope.siniesterFlagCertificate = false;

      $http({
        method: "GET",
        url: url.IP + "view-endosos",
        params: {
          policy: item.id,
        },
      })
        .then(function success(response) {
          $scope.endorsementsCertificate = response.data.endosos;
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.showSinistersCertificate = function (item) {
      $scope.infoFlagCertificate = false;
      $scope.endorsementFlagCertificate = false;
      $scope.siniesterFlagCertificate = true;

      $http({
        method: "GET",
        url: url.IP + "view-sinister",
        params: {
          policy: item.id,
        },
      })
        .then(function success(response) {
          $scope.sinistersCertificate = response.data.siniestros;
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.infoSinister = function (sinister) {
      if ($scope.caratula.ramo.ramo_name == "Accidentes y Enfermedades") {
        $scope.open_in_same_tab_natural(
          "Información siniestro",
          "siniestros.info",
          { siniestroId: sinister.id },
          0
        );
        // $state.go('siniestros.info',{siniestroId: sinister.id});
      } else if (
        ($scope.caratula.ramo.ramo_name == "Daños" &&
          $scope.caratula.subramo.subramo_name == "Automóviles") ||
        ($scope.caratula.ramo == "Daños" &&
          $scope.caratula.subramo == "Automóviles")
      ) {
        $scope.open_in_same_tab_natural(
          "Información siniestro",
          "siniestros.auto_info",
          { siniestroId: sinister.id },
          0
        );
        // $state.go('siniestros.auto_info',{siniestroId: sinister.id});
      } else if ($scope.caratula.ramo.ramo_name == "Vida") {
        $scope.open_in_same_tab_natural(
          "Información siniestro",
          "siniestros.vida_info",
          { siniestroId: sinister.id },
          0
        );
        // $state.go('siniestros.vida_info',{siniestroId: sinister.id})
      } else if (
        $scope.caratula.ramo.ramo_name == "Daños" &&
        $scope.caratula.subramo.subramo_name != "Automóviles"
      ) {
        $scope.open_in_same_tab_natural(
          "Información siniestro",
          "siniestros.danio_info",
          { siniestroId: sinister.id },
          0
        );
        // $state.go('siniestros.danio_info',{siniestroId: sinister.id})
      }
    };

    $scope.editReceipt = function (receipt, index, certif) {
      var texto =
        "No se validarán las primas y ni las fechas al editar este recibo. ¿Deseas continuar?";
      if (
        $scope.acceso_pl_cob == false &&
        (receipt.status == 1 || receipt.status == "Pagado")
      ) {
        var texto =
          "No se validarán las primas y ni las fechas al editar este recibo. \nEstas editando un recibo PAGADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      } else if (
        $scope.acceso_pl_cob == false &&
        (receipt.status == 5 || receipt.status == "Liquidado")
      ) {
        var texto =
          "No se validarán las primas y ni las fechas al editar este recibo. \nEstas editando un recibo LIQUIDADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      }
      if (
        receipt.status == 4 ||
        receipt.status == "Pendiente de pago" ||
        ($scope.acceso_pl_cob == false &&
          (receipt.status == 1 ||
            receipt.status == "Pagado" ||
            receipt.status == 5 ||
            receipt.status == "Liquidado"))
      ) {
        SweetAlert.swal(
          {
            title: "Advertencia",
            text: texto,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var modalInstance = $uibModal.open({
                templateUrl: "app/colectivos/receipt.html",
                controller: EditReceiptCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  recibo: function () {
                    return receipt;
                  },
                  index: function () {
                    return index;
                  },
                  poliza: function () {
                    return certif;
                  },
                  caratula: function () {
                    return $scope.caratula;
                  },
                  acceso_pl_cob: function () {
                    return $scope.acceso_pl_cob;
                  },
                },
                backdrop: "static",
                keyboard: false,
              });
              modalInstance.closed.then(function (receipt) {
                activate();
              });
            } else {
              SweetAlert.swal(
                "Cancelado",
                "El recibo no ha sido actualizado.",
                "error"
              );
            }
          }
        );
      } else {
        SweetAlert.swal(
          "Advertencia",
          "El recibo no se puede editar porque no esta pendiente de pago.",
          "warning"
        );
      }
    };

    function EditReceiptCtrl(
      url,
      $http,
      $rootScope,
      recibo,
      index,
      poliza,
      caratula,
      $scope,
      $uibModalInstance,
      acceso_pl_cob
    ) {
      var rec = this;
      rec.recibo = recibo;
      var fecha_inicio = recibo.fecha_inicio;
      var fecha_fin = recibo.fecha_fin;
      var fecha_venc = recibo.vencimiento;

      rec.recibo.fecha_inicio = convertDate(recibo.fecha_inicio);
      rec.recibo.fecha_fin = convertDate(recibo.fecha_fin);
      rec.recibo.vencimiento = convertDate(recibo.vencimiento);

      function convertDate(inputFormat, indicator) {
        var date = inputFormat;
        if (inputFormat.length != 10) {
          function pad(s) {
            return s < 10 ? "0" + s : s;
          }
          var d = new Date(inputFormat);
          if (indicator) {
            date = [
              pad(d.getDate() + 1),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          } else {
            date = [
              pad(d.getDate()),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          }
        }
        return date;
      }

      function toDate(dateStr) {
        if (dateStr) {
          var dateString = dateStr;
          var dateParts = dateString.split("/");
          var dateObject = new Date(
            dateParts[2],
            dateParts[1] - 1,
            dateParts[0]
          );
          return dateObject;
        }
      }
      var date1, date2, date3, dateDiff1, dateDiff2;
      $scope.validateDates_venc = function (date) {
        //Validando vacio
        if (date == undefined) {
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede estar vacia",
            "error"
          );
          return;
        }
        //Validando no menor a fecha inicio
        date1 = datesFactory.toDate(date);
        date2 = datesFactory.toDate(rec.recibo.fecha_inicio);
        date3 = datesFactory.toDate(
          convertDate(
            poliza ? poliza.end_of_validity : caratula.end_of_validity
          )
        );
        dateDiff1 = moment(date1).diff(moment(date2), "days");
        dateDiff2 = moment(date1).diff(moment(date3), "days");

        // if(dateDiff1 < 0){
        //   rec.recibo.vencimiento = convertDate(fecha_venc);
        //   SweetAlert.swal("Error", "La fecha de vencimiento no puede ser menor que la inicial", "error");
        //   return;
        // }
        //Validando a no mayor a 30 dias de fin de vigencia de Póliza de Grupo
        if (dateDiff2 > 30) {
          rec.recibo.vencimiento = convertDate(fecha_venc);
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede ser mayor a 30 días a la fecha de la vigencia de la Póliza de Grupo",
            "error"
          );
          return;
        }
      };
      $scope.validateDecimal = function (form) {
        form = String(form).replace(/[A-Za-z]/g, "");
        form = String(form).replace(/,/g, "");
        return form;
      };

      $scope.changePrimas = function (data) {
        rec.recibo.sub_total = (
          parseFloat(data.prima_neta) +
          parseFloat(data.rpf) +
          parseFloat(data.derecho)
        ).toFixed(2);
        rec.recibo.prima_total = (
          parseFloat(rec.recibo.sub_total) + parseFloat(data.iva)
        ).toFixed(2);
      };

      $scope.saveReceipt = function (receipt) {
        var texto_log = "";
        if (
          (receipt.status == 1 || receipt.status == "Pagado") &&
          acceso_pl_cob == false
        ) {
          var texto_log = " EDICION DE RECIBO PAGADO";
        }
        if (
          (receipt.status == 5 || receipt.status == "Liquidado") &&
          acceso_pl_cob == false
        ) {
          var texto_log = " EDICION DE RECIBO LIQUIDADO";
        }
        if (process(receipt.fecha_fin) < process(receipt.fecha_inicio)) {
          SweetAlert.swal(
            "Error",
            "La fecha fin del recibo no puede ser menor a la de su inicio.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }
        if (rec.recibo.vencimiento == undefined) {
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede estar vacia",
            "error"
          );
          return;
        }
        //Validando no menor a fecha inicio
        date1 = datesFactory.toDate(rec.recibo.vencimiento);
        date2 = datesFactory.toDate(rec.recibo.fecha_inicio);
        date3 = datesFactory.toDate(
          convertDate(
            poliza ? poliza.end_of_validity : caratula.end_of_validity
          )
        );
        dateDiff1 = moment(date1).diff(moment(date2), "days");
        dateDiff2 = moment(date1).diff(moment(date3), "days");

        // if(dateDiff1 < 0){
        //   SweetAlert.swal("Error", "La fecha de vencimiento no puede ser menor que la inicial", "error");
        //   return;
        // }
        //Validando a no mayor a 30 dias de fin de vigencia de poliza
        if (dateDiff2 > 30) {
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede ser mayor a 30 días a la fecha de la vigencia de la Póliza",
            "error"
          );
          return;
        }

        if (
          process(rec.recibo.fecha_inicio) <
          process(convertDate(caratula.start_of_validity))
        ) {
          SweetAlert.swal(
            "Error",
            "La fecha de inicio del recibo no puede ser menor a la fecha de inicio de la póliza.",
            "error"
          );
          return;
        }

        if (process(rec.recibo.fecha_fin) < process(rec.recibo.fecha_inicio)) {
          SweetAlert.swal(
            "Error",
            "La fecha fin del recibo no puede ser menor a la de su inicio.",
            "error"
          );
          return;
        }
        var obj = {
          fecha_inicio: new Date(toDate(receipt.fecha_inicio)),
          fecha_fin: new Date(toDate(receipt.fecha_fin)),
          prima_neta: receipt.prima_neta,
          rpf: receipt.rpf,
          derecho: receipt.derecho,
          iva: receipt.iva,
          prima_total: receipt.prima_total,
          comision: receipt.comision,
          vencimiento: new Date(toDate(receipt.vencimiento)),
          delivered: receipt.delivered,
        };

        $http.patch(receipt.url, obj).then(function (response) {
          var params = {
            model: 18,
            event: "PATCH",
            associated_id: caratula.id,
            identifier:
              "actualizó el recibo " + receipt.recibo_numero + texto_log + ".",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          var params = {
            model: 4,
            event: "POST",
            associated_id: receipt.id,
            identifier: "actualizó el recibo " + texto_log,
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          SweetAlert.swal(
            "¡Listo!",
            "El recibo ha sido actualizado.",
            "success"
          );
          $scope.cancel(true);
        });
      };

      $scope.cancel = function (v) {
        if (!v) {
          rec.recibo.fecha_inicio = fecha_inicio;
          rec.recibo.fecha_fin = fecha_fin;
          rec.recibo.vencimiento = fecha_venc;
        }
        $uibModalInstance.dismiss("cancel");
      };
    }
  }
})();

/* global angular */
(function () {
  "use strict";

  angular.module("inspinia").controller("FlotillasEditCtrl", FlotillasEditCtrl);
  FlotillasEditCtrl.$inject = [
    "$uibModal",
    "$sessionStorage",
    "$scope",
    "$state",
    "$stateParams",
    "$http",
    "url",
    "SweetAlert",
    "MESSAGES",
    "FileUploader",
    "$timeout",
    "$parse",
    "dataFactory",
    "$rootScope",
    "datesFactory",
    "generalService",
    "$sce",
    "providerService",
    "$localStorage",
  ];

  function FlotillasEditCtrl(
    $uibModal,
    $sessionStorage,
    $scope,
    $state,
    $stateParams,
    $http,
    url,
    SweetAlert,
    MESSAGES,
    FileUploader,
    $timeout,
    $parse,
    dataFactory,
    $rootScope,
    datesFactory,
    generalService,
    $sce,
    providerService,
    $localStorage
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    var order = this;
    $rootScope.show_contractor = false;
    $scope.showOt = true;
    $scope.show_caratula = true;
    $scope.show_certificado = false;
    $scope.okFile = 0;
    $scope.countFile = 0;
    $scope.incompleteOT = {
      complete: true,
      caratule: [],
      subgroups: [],
      packages: [],
      certificates: [],
    };
    $scope.renewals = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.currencys = [
      { value: 1, label: "Pesos" },
      { value: 2, label: "Dólares" },
      { value: 3, label: "UDI" },
      { value: 4, label: "Euros" },
    ];
    $scope.frequencies = [
      { value: 7, label: "Semanal" },
      { value: 14, label: "Catorcenal" },
      // {'value':24, 'label':'Quincenal'},
      { value: 1, label: "Mensual" },
      { value: 2, label: "Bimestral" },
      { value: 3, label: "Trimestral" },
      { value: 6, label: "Semestral" },
      { value: 12, label: "Anual" },
      { value: 5, label: "Contado" },
    ];
    $scope.businessline = [
      { id: 1, name: "Comercial" },
      { id: 2, name: "Personal" },
      { id: 0, name: "Otro" },
    ];
    $scope.referenciadores = [];
    $scope.referenciadorArray = [];
    $scope.referenciadoresSelected = [];
    $scope.directiveReceipts = {};
    $scope.types = [
      { value: 1, label: "Abierta" },
      { value: 2, label: "Cerrada" },
    ];
    activate();

    $scope.show_section = function (value) {
      switch (value) {
        case 1:
          $scope.show_caratula = true;
          $scope.show_subgrupo = false;
          $scope.show_paquete = false;
          $scope.show_certificado = false;
          break;
        case 2:
          $scope.show_caratula = false;
          $scope.show_certificado = true;
          break;
        default:
          $scope.show_caratula = true;
          $scope.show_certificado = false;
      }
    };

    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      $http
        .get(url.IP + "leer-polizas-info/" + $stateParams.polizaId)
        .then(function success(response) {
          if (response.status == 200) {
            if ($localStorage.save_edition_flotilla) {
              if ($localStorage.save_edition_flotilla.id == response.data.id) {
                $scope.caratula = $localStorage.save_edition_flotilla;
              } else {
                $scope.caratula = response.data;
              }
            } else {
              $scope.caratula = response.data;
            }
            $scope.originalCaratula = angular.copy(response.data);
            $scope.startDate = convertDate(response.data.start_of_validity);
            $scope.endDate = convertDate(response.data.end_of_validity);
            fillProvider();
            $scope.currencys.forEach(function (item1) {
              if (item1.value == $scope.caratula.f_currency) {
                $scope.currencySelected = item1.value;
                $scope.caratula.f_currency = item1.value;
              }
            });
            $scope.businessline.forEach(function (item) {
              if (item.id == $scope.caratula.business_line) {
                $scope.lineaSelected = item;
                $scope.caratula.business_line = item;
              }
            });
            $scope.types.forEach(function (item) {
              if ($scope.caratula.type_policy) {
                if (item.value == $scope.caratula.type_policy) {
                  $scope.typeSelected = item;
                  // $scope.caratula.type_policy = item.value;
                }
              }
            });
            if ($scope.caratula.is_renewable == 1) {
              $scope.renewalSelected = $scope.renewals[0];
            } else {
              $scope.renewalSelected = $scope.renewals[1];
            }
            order.contratante = {};
            $scope.aseguradoraSelected = $scope.caratula.aseguradora;

            $http({
              method: "POST",
              url: url.IP + "get_caratula_polizas/",
              data: {
                status: 0,
                caratula: $scope.caratula.id,
                parent: 0,
              },
            })
              .then(function success(response1) {
                if (response1.status == 200) {
                  $scope.allCerificatesCaratula = response1.data.certificates;
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });

            if ($scope.caratula.contractor.id) {
              var idC = $scope.caratula.contractor.id;
            } else {
              var idC = $scope.caratula.contractor;
            }
            // $http({method: 'GET', url: url_aux})
            $http
              .get(url.IP + "contractors-resume-medium/" + idC + "/")
              .then(
                function success(response) {
                  $scope.contratante = response.data;
                  if ($scope.caratula.contractor) {
                    $scope.addresses = $scope.contratante.address_contractor;
                    if (
                      $scope.contratante &&
                      $scope.contratante.address_contractor
                    ) {
                      $scope.contratante.address_contractor.forEach(function (
                        address
                      ) {
                        if (address.id == $scope.caratula.address.id) {
                          $scope.addressSelected = $scope.caratula.address;
                        }
                      });
                    }
                    order.contratante.val = $scope.contratante.full_name;
                    order.contratante.value = $scope.contratante;
                    $scope.contratante.direccion = $scope.caratula.address;
                  }
                },
                function error(response) {
                  console.log("error", response);
                }
              )
              .catch(function (e) {
                console.log("error", e);
              });

            $http
              .get(url.IP + "polizas/" + $scope.caratula.id + "/archivos/")
              .then(function (response) {
                $scope.filesCover = response.data.results;
              })
              .catch(function (e) {
                console.log("error", e);
              });
            // Referenciadores
            $http
              .get(url.IP + "get-vendors/")
              .then(function (user) {
                user.data.forEach(function (item) {
                  item.first_name = item.first_name.toUpperCase();
                  item.last_name = item.last_name.toUpperCase();
                  item.name =
                    item.first_name.toUpperCase() +
                    " " +
                    item.last_name.toUpperCase();
                });
                $scope.referenciadores = user.data;
                var vendedor = {
                  referenciador: "",
                  comision_vendedor: "",
                };
                $scope.referenciadorArray.push(vendedor);
              })
              .catch(function (e) {
                console.log("error", e);
              });

            if ($scope.caratula.ref_policy.length > 0) {
              $scope.caratula.ref_policy.forEach(function (refs) {
                $http
                  .get(refs.referenciador)
                  .then(function success(response_ref_plicy) {
                    if (response_ref_plicy) {
                      refs.data = response_ref_plicy.data;
                      refs.referenciador = response_ref_plicy.data.url;
                      refs.selectedRef = true;
                      $scope.referenciadorArray.push(refs);
                    }
                  });
              });
            }

            $http
              .get(url.IP + "usuarios/")
              .then(function (user) {
                user.data.results.forEach(function (item) {
                  item.first_name = item.first_name.toUpperCase();
                  item.last_name = item.last_name.toUpperCase();
                  item.name =
                    item.first_name.toUpperCase() +
                    " " +
                    item.last_name.toUpperCase();
                });
                $scope.users = user.data.results;
                if ($scope.caratula.responsable) {
                  $scope.users.forEach(function (item) {
                    item.first_name = item.first_name.toUpperCase();
                    item.last_name = item.last_name.toUpperCase();
                    item.name =
                      item.first_name.toUpperCase() +
                      " " +
                      item.last_name.toUpperCase();
                    if (item.id == $scope.caratula.responsable.id) {
                      $scope.responsableSelected = item.id;
                    }
                  });
                }
                if ($scope.caratula.collection_executive) {
                  $scope.users.forEach(function (item) {
                    if (item.id == $scope.caratula.collection_executive.id) {
                      $scope.ejecutivoCobranzaSelected = item.id;
                    }
                  });
                }

                $scope.getClaves($scope.aseguradoraSelected);
              })
              .catch(function (e) {
                console.log("error", e);
              });

            dataFactory
              .get("sucursales-to-show-unpag/")
              .then(function success(response) {
                if (response.status === 200 || response.status === 201) {
                  $scope.sucursales = response.data;
                  if ($scope.caratula.sucursal) {
                    $scope.sucursales.forEach(function (item) {
                      if (item.id == $scope.caratula.sucursal.id) {
                        $scope.sucursalSelected = item;
                      }
                    });
                  }
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });

            dataFactory
              .post("celula_contractor_info/")
              .then(function (response) {
                $scope.celulas = response.data;
              });

            dataFactory.get("groupingLevel-resume/").then(function (response) {
              $scope.agrupaciones = response.data;
            });

            $scope.paymentSelected = $scope.caratula.forma_de_pago;

            if ($scope.caratula.celula) {
              $http.get($scope.caratula.celula).then(function (response) {
                $scope.celulaSelected = response.data;
                $scope.changeCelula($scope.celulaSelected);
              });
            }

            $scope.info_sub = $scope.caratula;
            if ($scope.caratula.grouping_level) {
              $http
                .get(
                  url.IP + "groupinglevel/" + $scope.caratula.grouping_level.id
                )
                .then(function (response) {
                  $scope.grouping_levelSelected = response.data;
                  $scope.info_sub = $scope.caratula;
                  $scope.changeAgrupacion($scope.grouping_levelSelected);
                });
            }

            if ($localStorage.save_edition_flotilla) {
              if (
                $localStorage.save_edition_flotilla["id"] == $scope.caratula.id
              ) {
                $scope.caratula.poliza_number =
                  $localStorage.save_edition_flotilla &&
                  $localStorage.save_edition_flotilla["poliza_number"]
                    ? $localStorage.save_edition_flotilla["poliza_number"]
                    : "";
                $scope.caratula.identifier =
                  $localStorage.save_edition_flotilla &&
                  $localStorage.save_edition_flotilla["identifier"]
                    ? $localStorage.save_edition_flotilla["identifier"]
                    : "";
              }
            }
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
      order.accesos = $sessionStorage.permisos;
      if (order.accesos) {
        order.accesos.forEach(function (perm) {
          if (perm.model_name == "Referenciadores") {
            order.acceso_ref = perm;
            order.acceso_ref.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver referenciadores") {
                if (acc.checked == true) {
                  order.acceso_ver_ref = true;
                } else {
                  order.acceso_ver_ref = false;
                }
              }
            });
          }
          if (perm.model_name == "Archivos") {
            order.acceso_files = perm;
            order.acceso_files.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  order.permiso_archivos = true;
                } else {
                  order.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  order.permiso_administrar_adjuntos = true;
                } else {
                  order.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
        });
      }
    }

    $scope.save_info_tab = function () {
      $localStorage.save_edition_flotilla = angular.copy($scope.caratula);
    };

    $scope.changeCelula = function (param) {
      $scope.caratula.celula = param.url;
      try {
        $localStorage.save_edition_flotilla["celula"] = param.url;
      } catch (err) {}
    };

    $scope.changeAgrupacion = function (data) {
      $scope.subgroupingSelected = {};
      $scope.subsubgroupingSelected = {};
      $scope.sub_asignaciones = data.subgrupos;
      $scope.grouping_levelSelected = data;
      if ($scope.info_sub.subgrouping_level) {
        $http
          .get(url.IP + "groupinglevel/" + $scope.info_sub.subgrouping_level.id)
          .then(function (response) {
            $scope.subgroupingSelected = response.data;
            if ($scope.subgroupingSelected.parent != data.url) {
              $scope.subgroupingSelected = {};
            }
            $scope.sub_asignaciones.forEach(function (item) {
              if (item.id == $scope.subgroupingSelected.id) {
                $scope.subgroupingSelected = item;
                $scope.changeSubagrupacion(item);
              }
            });
          });
      }
    };

    $scope.changeSubagrupacion = function (data) {
      $scope.subsubgroupingSelected = {};
      if (data.subsubgrupos) {
        $scope.sub_subasignaciones = data.subsubgrupos;
        $scope.subgroupingSelected = data;
        if ($scope.info_sub.subsubgrouping_level) {
          $http
            .get(
              url.IP +
                "groupinglevel/" +
                $scope.info_sub.subsubgrouping_level.id
            )
            .then(function (response) {
              $scope.subsubgroupingSelected = response.data;
              if ($scope.subsubgroupingSelected.parent != data.url) {
                $scope.subsubgroupingSelected = {};
              }
              $scope.sub_asignaciones.forEach(function (item) {
                if (item.id == $scope.subsubgroupingSelected.id) {
                  $scope.subsubgroupingSelected = item;
                  $scope.changeSubsubagrupacion(item);
                }
              });
            });
        }
      }
    };

    $scope.changeSubsubagrupacion = function (data) {
      $scope.subsubgroupingSelected = data;
    };
    $scope.changeAgrupacion2 = function (data) {
      $scope.grouping_levelSelected = data;
      $scope.subgroupingSelected = "";
      $scope.subsubgroupingSelected = "";
      $scope.sub_asignaciones = data.subgrupos;
      $scope.sub_subasignaciones = [];
      if ($scope.info_sub.subgrouping_level) {
        $scope.sub_asignaciones.forEach(function (item) {
          if (item.id == $scope.info_sub.subgrouping_level.id) {
            $http
              .get(
                url.IP + "groupinglevel/" + $scope.info_sub.subgrouping_level.id
              )
              .then(function (response) {
                $scope.subgroupingSelected = response.data;
                $scope.changeSubagrupacion2(item);
              });
          }
        });
      }
    };

    $scope.changeSubagrupacion2 = function (data) {
      if (data.subsubgrupos) {
        $scope.sub_subasignaciones = data.subsubgrupos;
        if ($scope.info_sub.subsubgrouping_level) {
          $scope.sub_subasignaciones.forEach(function (item) {
            if (item.id == $scope.info_sub.subsubgrouping_level.id) {
              $http
                .get(
                  url.IP +
                    "groupinglevel/" +
                    $scope.info_sub.subsubgrouping_level.id
                )
                .then(function (response) {
                  $scope.subsubgroupingSelected = response.data;
                });
            }
          });
        }
      }
    };
    $scope.changeEjecutivoCobranza = function (param) {
      $scope.users.forEach(function (item) {
        if (item.id == param) {
          $scope.caratula.collection_executive = item;
          $localStorage.save_edition_flotilla["collection_executive"] = item;
        }
      });
    };
    $scope.changeBline = function (param) {
      $scope.caratula.business_line = param;
      $localStorage.save_edition_flotilla["business_line"] = param;
    };
    // Save Edicition
    $scope.validityInsurance = function () {
      if (!$scope.aseguradoraSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        return;
      }
      if (!$scope.caratula.poliza_number) {
        SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
        return;
      }
      if (!$scope.caratula.identifier) {
        SweetAlert.swal("Error", MESSAGES.ERROR.IDENTIFIERREQUIRED, "error");
        return;
      }
      if (!order.contratante.val) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        return;
      }
      if (!$scope.caratula.address) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        return;
      }
      if (!$scope.caratula.clave) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        return;
      }
      if (!$scope.ramoSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        return;
      }
      if (!$scope.subramoSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      $scope.saveInsurance();
    };

    $scope.saveInsurance = function () {
      if ($scope.subsubgroupingSelected && $scope.subsubgroupingSelected.url) {
        $scope.gLevel = $scope.subsubgroupingSelected.url;
      } else if ($scope.subgroupingSelected && $scope.subgroupingSelected.url) {
        $scope.gLevel = $scope.subgroupingSelected.url;
      } else if ($scope.grouping_levelSelected) {
        $scope.gLevel = $scope.grouping_levelSelected.url;
      }
      $scope.caratulaEdit = {};
      $scope.caratulaEdit.ref_policy = [];
      $scope.caratulaEdit.aseguradora = $scope.aseguradoraSelected.url;
      $scope.caratulaEdit.clave = $scope.claveSelected
        ? $scope.claveSelected.url
        : null;
      $scope.caratulaEdit.ramo = $scope.ramoSelected.url;
      $scope.caratulaEdit.subramo = $scope.subramoSelected.url;
      $scope.caratulaEdit.business_line = $scope.caratula.business_line
        ? $scope.caratula.business_line.id
        : 1;
      $scope.caratulaEdit.type_policy = $scope.caratula.type
        ? $scope.caratula.type.value
        : $scope.typeSelected.value;
      $scope.caratulaEdit.f_currency = $scope.caratula.f_currency;
      $scope.caratulaEdit.is_renewable = $scope.caratula.is_renewable
        ? $scope.caratula.is_renewable
        : null;
      $scope.caratulaEdit.responsable = $scope.caratula.responsable
        ? $scope.caratula.responsable.url
        : null;
      $scope.caratulaEdit.collection_executive = $scope.caratula
        .collection_executive
        ? $scope.caratula.collection_executive.url
        : null;
      $scope.caratulaEdit.address = $scope.addressSelected
        ? $scope.addressSelected.url
        : null;
      $scope.caratulaEdit.document_type = 11;
      $scope.caratulaEdit.status = $scope.caratula.status;
      $scope.caratulaEdit.poliza_number = $scope.caratula.poliza_number;
      $scope.caratulaEdit.identifier = $scope.caratula.identifier;
      $scope.caratulaEdit.contractor = $scope.caratula.contractor
        ? $scope.caratula.contractor.url
        : null;
      $scope.caratulaEdit.start_of_validity = $scope.caratula.start_of_validity;
      $scope.caratulaEdit.end_of_validity = $scope.caratula.end_of_validity;
      $scope.caratulaEdit.celula = $scope.caratula.celula
        ? $scope.caratula.celula
        : "";
      $scope.caratulaEdit.groupinglevel = $scope.gLevel ? $scope.gLevel : null;
      $scope.referenciadoresSelected = [];
      $scope.valorReferenciadores = [];
      $scope.referenciadorArray.forEach(function (item) {
        if (item.referenciador != "") {
          var ref_to_send = {
            referenciador: item.referenciador,
            comision_vendedor: 100,
          };
          var ref_to_send2 = {
            referenciador: item.referenciador,
            comision_vendedor: 100,
            ref_name: item.ref_name,
          };
          if (item.comision_vendedor == "") {
            ref_to_send.comision_vendedor = 0;
          } else {
            ref_to_send.comision_vendedor = item.comision_vendedor
              ? parseFloat(item.comision_vendedor).toFixed(2)
              : 0;
          }
          $scope.referenciadoresSelected.push(ref_to_send);
          $scope.valorReferenciadores.push(ref_to_send2);
        }
      });

      // $scope.referenciadorArray.forEach(function(referenciador){
      //   var ref = {
      //       "referenciador": referenciador.referenciador,
      //       "comision_vendedor": referenciador.comision_vendedor ? referenciador.comision_vendedor : 100,
      //   }
      //   $scope.caratulaEdit.ref_policy.push(ref);
      // });
      $scope.contractorToSave = {};

      if ($scope.caratula.contractor.email) {
        $scope.contractorToSave.email = $scope.caratula.contractor.email;
      } else {
        $scope.contractorToSave.email = "";
      }
      if ($scope.caratula.contractor.phone_number) {
        $scope.contractorToSave.phone_number =
          $scope.caratula.contractor.phone_number;
      } else {
        $scope.contractorToSave.phone_number = "";
      }
      $http
        .patch($scope.caratula.contractor.url, $scope.contractorToSave)
        .then(function (data) {
          if (data.status == 200 || data.status == 201) {
          }
        });
      $scope.caratulaEdit.ref_policy = $scope.referenciadoresSelected;
      $http
        .patch($scope.caratula.url, $scope.caratulaEdit)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            $localStorage.save_edition_flotilla = {};
            $scope.dataCaratula = response.data;
            try {
              if (
                $scope.dataCaratula.ref_policy.length ==
                $scope.originalCaratula.ref_policy.length
              ) {
                for (
                  var j = 0;
                  j < $scope.originalCaratula.ref_policy.length;
                  j++
                ) {
                  var refurl =
                    $scope.originalCaratula.ref_policy[j].referenciador;
                  var refurl2 = $scope.referenciadoresSelected[j];
                  if (
                    refurl != $scope.referenciadoresSelected[j].referenciador
                  ) {
                    $http
                      .get(refurl)
                      .then(function success(nameRef) {
                        $scope.nombreReferenciador = nameRef.data;
                        $http
                          .get(refurl2.referenciador)
                          .then(function success(nameRef2) {
                            $scope.nombreReferenciador2 = nameRef2.data;
                            var params = {
                              model: 18,
                              event: "PATCH",
                              associated_id: $scope.dataCaratula.id,
                              identifier:
                                " cambio el referenciador " +
                                $scope.nombreReferenciador.first_name +
                                " " +
                                $scope.nombreReferenciador.last_name +
                                " por: " +
                                $scope.nombreReferenciador2.first_name +
                                " " +
                                $scope.nombreReferenciador2.last_name +
                                ", al editar la carátula",
                            };
                            dataFactory
                              .post("send-log/", params)
                              .then(function success(response) {});
                          })
                          .catch(function (error) {
                            console.log(
                              "Error - al obtener urlref - catch",
                              error
                            );
                          });
                      })
                      .catch(function (error) {
                        console.log("Error - al obtener urlref - catch", error);
                      });
                  }
                }
              }
            } catch (u) {}
            $scope.showCar = true;
            $scope.showPol = false;
            SweetAlert.swal(
              "¡Listo!",
              "Carátula guardada exitosamente.",
              "success"
            );
            $state.go("flotillas.info", { polizaId: $scope.dataCaratula.id });
          }
        })
        .catch(function (e) {
          SweetAlert.swal("Error", response.data, "error");
          console.log("error - caratula - catch", e);
        });
    };
    $scope.checkDate = function (param) {
      if (param.length == 10) {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.startDate = param;
        $scope.endDate = datesFactory.convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();

        if (process(param) > process($scope.endDate)) {
          SweetAlert.swal(
            "Error",
            "La fecha inicio no puede ser mayor a la fecha fin.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }
      } else {
        var day = new Date().getDate();
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();

        $scope.startDate = param;
        $scope.endDate = datesFactory.convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();
      }
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        $scope.caratula.end_of_validity = datesFactory.toDate(param);
      }
    };
    // Saveeeeeeeeeeee
    $scope.statusPolicy = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.changeAddress = function (param) {
      $scope.caratula.address = param;
    };

    $scope.getClaves = function (param) {
      $scope.ramoSelected = null;
      $scope.subramoSelected = null;
      $scope.caratula.ramo = null;
      $scope.caratula.subramo = null;
      $scope.caratula.aseguradora = param;
      $scope.aseguradoraSelected = param;
      $http
        .get(url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id)
        .then(function success(clavesResponse) {
          $scope.claves = clavesResponse.data;
          if ($scope.claves.length == 1) {
            $scope.caratula.clave = $scope.claves[0];
            $scope.claveSelected = $scope.claves[0];
          } else {
            $scope.claves.forEach(function (item) {
              if (item.id == $scope.caratula.clave.id) {
                $scope.claveSelected = item;
              }
            });
          }
        })
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      $http
        .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
        .then(
          function success(response) {
            $scope.ramos = response.data;
            $scope.ramos.forEach(function (item) {
              if (item.ramo_name == $scope.originalCaratula.ramo) {
                $scope.ramoSelected = item;
                $scope.caratula.ramo = item;
                $scope.subramos = item.subramo_ramo;
                $scope.subramos.forEach(function (subramo) {
                  if (subramo.subramo_name == $scope.originalCaratula.subramo) {
                    $scope.subramoSelected = subramo;
                    $scope.caratula.subramo = subramo;
                  }
                });
              }
            });
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    $scope.changeRamo = function (param) {
      if (param) {
        $scope.caratula.ramo = param;
        $scope.ramoSelected = param;
        $scope.subramos = param.subramo_ramo;
        $localStorage.save_edition_flotilla["ramoSelected"] = param;
      }
    };

    $scope.changeSubramo = function (param) {
      if (param) {
        $scope.caratula.subramo = param;
        $scope.subramoSelected = param;
        $localStorage.save_edition_flotilla["subramo"] = param;
      }
    };

    $scope.changeClave = function (param) {
      if (param) {
        $scope.caratula.clave = param;
        $scope.claveSelected = param;
        $localStorage.save_edition_flotilla["clave"] = param;
      }
    };

    $scope.changeType = function (param) {
      $scope.caratula.type = param;
      $localStorage.save_edition_flotilla["type"] = param;
    };

    $scope.changeCurrency = function (param) {
      $scope.caratula.f_currency = param;
      $localStorage.save_edition_flotilla["f_currency"] = param;
    };

    $scope.changeRenewal = function (param) {
      $scope.caratula.is_renewable = param.value;
      $localStorage.save_edition_flotilla["is_renewable"] = param;
    };

    $scope.changeResponsable = function (param) {
      $scope.users.forEach(function (item) {
        item.first_name = item.first_name.toUpperCase();
        item.last_name = item.last_name.toUpperCase();
        item.name =
          item.first_name.toUpperCase() + " " + item.last_name.toUpperCase();
        if (item.id == param) {
          $scope.caratula.responsable = item;
          $localStorage.save_edition_flotilla["responsable"] = param;
        }
      });
    };

    $scope.addReferenciador = function () {
      var addReferenciadores = {
        referenciador: "",
        comision_vendedor: "",
      };
      $scope.referenciadorArray.push(addReferenciadores);
    };

    $scope.changeComRef = function (param, index, com) {
      if (com.comision_vendedor > 100) {
        com.comision_vendedor = 0;
      } else if (com.comision_vendedor < 0) {
        com.comision_vendedor = 0;
      }
      $scope.checkTotalComision(com);
    };
    $scope.checkTotalComision = function (item) {
      var totalComision = $scope.referenciadorArray.reduce(function (
        sum,
        item
      ) {
        return sum + (parseFloat(item.comision_vendedor) || 0); // Convert to number, default to 0 if undefined
      },
      0);
      if (totalComision > 100) {
        $scope.comisionError =
          "La suma de las comisiones no puede superar el 100%";
        item.comision_vendedor = 0;
      } else {
        $scope.comisionError = null; // No error if total is within limit
      }
    };
    $scope.deleteReferenciador = function (index) {
      $scope.referenciadorArray.splice(index, 1);
    };

    function fillProvider() {
      var d = $scope.startDate;
      try {
        var day = d.getDate();
        var month = d.getMonth() + 1; //Months are zero based
        var year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var day = f.getDate();
        var month = f.getMonth() + 1; //Months are zero based
        var year = f.getFullYear();
      }
      var date = year + "-" + month + "-" + day;
      providerService.getProviderByKey(date).then(
        function success(data) {
          $scope.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                // var juridicals = response.data.juridicals;
                // var naturals = response.data.naturals;

                // if(juridicals.length) {
                //   juridicals.forEach(function(item){
                //     var obj = {
                //       label: item.j_name,
                //       value: item
                //     };
                //     source.push(obj);
                //   });
                // }
                // if(naturals.length) {
                //   naturals.forEach(function(item){
                //     if(item.full_name) {
                //       var obj = {
                //         label: item.full_name,
                //         value: item
                //       };
                //     } else {
                //      var obj = {
                //         label: item.first_name+' '+ item.last_name+' '+ item.second_last_name,
                //         value: item
                //       };
                //     }
                //     source.push(obj);
                //   });
                // }
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if ($scope.referenciadores) {
          $scope.referenciadores.some(function (user) {
            if (user.url == order.contratante.value.vendor) {
              $scope.referenciadorArray[0] = {
                referenciador: user.id,
                comision_vendedor: "",
              };
            }
          });
        }
        if (
          (order.contratante.value &&
            order.contratante.value.address_natural) ||
          (order.contratante.value && order.contratante.value.address_juridical)
        ) {
          if (order.contratante.value.address_natural) {
            $scope.caratula.natural = order.contratante.value;
            $scope.caratula.juridical = null;
            $scope.addresses = order.contratante.value.address_natural;
          } else {
            $scope.caratula.natural = null;
            $scope.caratula.juridical = order.contratante.value;
            $scope.addresses = order.contratante.value.address_juridical;
          }
          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.caratula.address = $scope.addresses[0].url;
          }
        }
        if (
          order.contratante &&
          order.contratante.value &&
          order.contratante.value.address_contractor
        ) {
          $scope.caratula.contractor = order.contratante.value;
          $scope.addresses = order.contratante.value.address_contractor;

          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.caratula.address = $scope.addresses[0].url;
          }
        }
      }
    });

    $scope.changeAddress = function (param) {
      $scope.caratula.address = param;
      $scope.addressSelected = param;
    };

    $scope.contratanteCreator = function () {
      $scope.create_natural = true;
      $scope.create_juridical = true;
      $rootScope.show_contractor = true;
      $localStorage.orderForm = JSON.stringify($scope.caratula);
    };
  }
})();

/* global angular */
(function () {
  "use strict";

  angular.module("inspinia").controller("FlotillasCtrl", FlotillasCtrl);

  FlotillasCtrl.$inject = [
    "$scope",
    "$http",
    "url",
    "$stateParams",
    "$sessionStorage",
    "MESSAGES",
    "SweetAlert",
    "$state",
    "providerService",
    "helpers",
    "dataFactory",
    "FileUploader",
    "formatValues",
    "$rootScope",
    "$localStorage",
    "$timeout",
    "coverageService",
    "datesFactory",
  ];

  function FlotillasCtrl(
    $scope,
    $http,
    url,
    $stateParams,
    $sessionStorage,
    MESSAGES,
    SweetAlert,
    $state,
    providerService,
    helpers,
    dataFactory,
    FileUploader,
    formatValues,
    $rootScope,
    $localStorage,
    $timeout,
    coverageService,
    datesFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    $scope.infoUser = $sessionStorage.infoUser;

    var order = this;

    $scope.showOt = true;
    $scope.showRenewal = false;
    $scope.caratula = {};
    $scope.layout = {};
    $rootScope.show_contractor = false;
    $scope.create_natural = true;
    $scope.create_juridical = true;
    $scope.claves = [];
    $scope.types = [
      { value: 1, label: "Abierta" },
      { value: 2, label: "Cerrada" },
    ];
    $scope.businessline = [
      { id: 1, name: "Comercial" },
      { id: 2, name: "Personal" },
      { id: 0, name: "Otro" },
    ];
    $scope.typeSelected = $scope.types[0];
    $scope.renewals = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.renewalSelected = $scope.renewals[0];
    $scope.currencys = [
      { value: 1, label: "Pesos" },
      { value: 2, label: "Dólares" },
      { value: 3, label: "UDI" },
      { value: 4, label: "Euros" },
    ];
    $scope.currencySelected = $scope.currencys[0].value;

    $scope.referenciadorArray = [];

    $scope.dataCaratula = [];

    $scope.contractorLayout = {};

    $scope.showTableCertificates = false;
    $scope.excelJson = [];
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certifcados = [];

    $scope.celulas = [];
    $scope.agrupaciones = [];
    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    // var myInsurance = $stateParams.myInsurance;
    // if(myInsurance.url){
    //   order  = {
    //     contratante : {}
    //   }

    //   order.contratante.value = $stateParams.myInsurance;
    //   if(order.contratante.value.email){
    //     order.contratante.value.email = $stateParams.myInsurance.email
    //   }
    // }

    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          order.acceso_polizas = perm;
          order.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                order.acceso_adm_pol = true;
              } else {
                order.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                order.acceso_ver_pol = true;
              } else {
                order.acceso_ver_pol = false;
              }
            }
          });
        }
        if (perm.model_name == "Formatos") {
          order.acceso_form = perm;
          order.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                order.acceso_form = true;
              } else {
                order.acceso_form = false;
              }
            }
          });
        }
        if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            }
          });
        }
        if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        }
        if (perm.model_name == "Comisiones") {
          order.coms = perm;
          order.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                order.permiso_comisiones = true;
              } else {
                order.permiso_comisiones = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                order.permiso_administrar_adjuntos = true;
              } else {
                order.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          order.acceso_refereciador = perm;
          order.acceso_refereciador.permissions.forEach(function (acc) {
            if (acc.permission_name == "Referenciador no obligatorio") {
              if (acc.checked == true) {
                order.acc_referenciador_obligatorio = true;
              } else {
                order.acc_referenciador_obligatorio = false;
              }
            }
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                order.acceso_ver_ref = true;
              } else {
                order.acceso_ver_ref = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                order.permiso_administrar_adjuntos = true;
              } else {
                order.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }

    activate();

    function activate() {
      order.acceso_ver_ref = true;
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      $scope.startDate = datesFactory.convertDate(new Date());
      fillProvider();
      $http.get(url.IP + "usuarios/").then(function (user) {
        user.data.results.forEach(function (vendor1) {
          vendor1.first_name = vendor1.first_name.toUpperCase();
          vendor1.last_name = vendor1.last_name.toUpperCase();
          vendor1.name =
            vendor1.first_name.toUpperCase() +
            " " +
            vendor1.last_name.toUpperCase();
        });
        $scope.users = user.data.results;
        $scope.usersLay = user.data.results;
        $scope.checkDate($scope.startDate);
      });

      $http.get(url.IP + "sucursales-to-show-unpag/").then(function (reesp) {
        $scope.sucursalesLay = reesp.data;
      });

      // dataFactory.get('celula_contractor/')
      dataFactory.post("celula_contractor_info/").then(function (response) {
        $scope.celulas = response.data;
        if ($localStorage["save_create_flotilla"]) {
          if ($localStorage["save_create_flotilla"]["celula"]) {
            $scope.celulas.forEach(function (item) {
              if (item.id == $localStorage["save_create_flotilla"]["celula"]) {
                $scope.celulaSelected = item;
              }
            });
          }
        }
      });

      dataFactory.get("groupingLevel-resume/").then(function (response) {
        $scope.agrupaciones = response.data;
        if ($localStorage["save_create_flotilla"]) {
          if ($localStorage["save_create_flotilla"]["agrupacion"]) {
            $scope.agrupaciones.forEach(function (item) {
              if (
                item.id ==
                $localStorage["save_create_flotilla"]["agrupacion"]["id"]
              ) {
                $scope.grouping_levelSelected = item;
                $scope.sub_asignaciones = item.subgrupos;
              }
            });
          }
        }
      });

      $http
        .get(url.IP + "get-vendors/")
        .then(function (user) {
          user.data.forEach(function (vnd) {
            vnd.first_name = vnd.first_name.toUpperCase();
            vnd.last_name = vnd.last_name.toUpperCase();
            vnd.name =
              vnd.first_name.toUpperCase() + " " + vnd.last_name.toUpperCase();
          });
          $scope.referenciadores = user.data;
          var vendedor = {
            referenciador: "",
            comision_vendedor: "",
          };
          $scope.referenciadorArray.push(vendedor);
        })
        .catch(function (e) {
          console.log("error", e);
        });
      if ($localStorage.save_create_flotilla) {
        $scope.caratula = $localStorage.save_create_flotilla;
        order.contratante = $localStorage.save_create_flotilla.contratante;
        $scope.aseguradoraSelected =
          $localStorage.save_create_flotilla.aseguradora;
        $scope.grouping_levelSelected = $localStorage.save_create_flotilla
          .agrupacion
          ? $localStorage.save_create_flotilla.agrupacion
          : {};
        $scope.subgroupingSelected = $localStorage.save_create_flotilla
          .subagrupacion
          ? $localStorage.save_create_flotilla.subagrupacion
          : {};

        $scope.sub_subasignaciones =
          $scope.subgroupingSelected &&
          $scope.subgroupingSelected["subsubgrupos"]
            ? $scope.subgroupingSelected["subsubgrupos"]
            : [];
        $scope.subsubgroupingSelected =
          $localStorage.save_create_flotilla &&
          $localStorage.save_create_flotilla.subsubagrupacion
            ? $localStorage.save_create_flotilla.subsubagrupacion
            : {};
        if (
          $localStorage.save_create_flotilla["referenciadores"] &&
          $localStorage.save_create_flotilla["referenciadores"].length > 0
        ) {
          $scope.referenciadorArray =
            $localStorage.save_create_flotilla["referenciadores"];
          $scope.referenciadorArray = $scope.referenciadorArray.filter(
            function (item) {
              if (item.referenciador) {
                return true;
              } else {
                return false;
              }
            }
          );
        }

        if ($scope.aseguradoraSelected) {
          $http
            .get(
              url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id
            )
            .then(function success(clavesResponse) {
              $scope.claves = clavesResponse.data;
              if ($localStorage.save_create_flotilla) {
                $scope.claves.forEach(function (item) {
                  if (item.id == $localStorage.save_create_flotilla.clave) {
                    $scope.claveSelected = item;
                  }
                });
              }
              if ($scope.claves.length == 1) {
                $scope.caratula.clave = $scope.claves[0].id;
                $scope.claveSelected = $scope.claves[0];
              }
            })
            .catch(function (error) {
              console.log("Error - claves-by-provider - catch", error);
            });

          $http
            .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
            .then(
              function success(response) {
                $scope.ramos = response.data;
              },
              function error(e) {
                console.log("Error - ramos-by-provider", e);
              }
            )
            .catch(function (error) {
              console.log("Error - ramos-by-provider - catch", error);
            });
        }

        $scope.ramoSelected = $localStorage.save_create_flotilla.ramo;
        if ($scope.ramoSelected) {
          $scope.subramos = $scope.ramoSelected.subramo_ramo;
        }
        $scope.subramoSelected = $localStorage.save_create_flotilla.subramo;
        if ($localStorage["save_create_flotilla"]["type_policy"]) {
          $scope.types.forEach(function (item) {
            if (
              item.value ==
              $localStorage["save_create_flotilla"]["type_policy"]["value"]
            ) {
              $scope.typeSelected = item;
            }
          });
        }
        $scope.currencySelected = $localStorage.save_create_flotilla.f_currency;
        $scope.lineaSelected = $localStorage.save_create_flotilla.business_line;
        $scope.responsableSelected =
          $localStorage.save_create_flotilla.responsable;
        if ($localStorage["save_create_flotilla"]["is_renewable"]) {
          $scope.renewals.forEach(function (item) {
            if (
              item.value ==
              $localStorage["save_create_flotilla"]["is_renewable"]
            ) {
              $scope.renewalSelected = item;
            }
          });
        }
        $scope.grouping_levelSelected = $localStorage.save_create_flotilla
          .groupinglevel
          ? $localStorage.save_create_flotilla.groupinglevel
          : $localStorage.save_create_flotilla.agrupacion
          ? $localStorage.save_create_flotilla.agrupacion
          : "";
        $scope.ejecutivoCobranzaSelected =
          $localStorage.save_create_flotilla.collection_executive;
      }
    }

    if ("save_create_flotilla" in $localStorage) {
    } else {
      $localStorage["save_create_flotilla"] = {};
    }

    $scope.save_info_tab = function () {
      $localStorage.save_create_flotilla = angular.copy($scope.caratula);
      $localStorage.save_create_flotilla.contratante = order.contratante;
      $localStorage.save_create_flotilla.address = $scope.addressSelected;
      $localStorage.save_create_flotilla.grouping_levelSelected =
        $scope.grouping_levelSelected;
      $localStorage.save_create_flotilla["referenciadores"] =
        $scope.referenciadorArray;
    };

    function fillProvider() {
      var d = $scope.startDate;
      try {
        var day = d.getDate();
        var month = d.getMonth() + 1; //Months are zero based
        var year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var day = f.getDate();
        var month = f.getMonth() + 1; //Months are zero based
        var year = f.getFullYear();
      }

      var date = year + "-" + month + "-" + day;
      providerService.getProviderByKey(date).then(
        function success(data) {
          $scope.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    $scope.changeComRef = function (param, index, com) {
      if (com.comision_vendedor > 100) {
        com.comision_vendedor = 0;
      } else if (com.comision_vendedor < 0) {
        com.comision_vendedor = 0;
      }
      $scope.checkTotalComision(com);
    };
    $scope.checkTotalComision = function (item) {
      var totalComision = $scope.referenciadorArray.reduce(function (
        sum,
        item
      ) {
        return sum + (parseFloat(item.comision_vendedor) || 0); // Convert to number, default to 0 if undefined
      },
      0);
      if (totalComision > 100) {
        $scope.comisionError =
          "La suma de las comisiones no puede superar el 100%";
        item.comision_vendedor = 0;
      } else {
        $scope.comisionError = null; // No error if total is within limit
      }
    };
    $scope.checkNumPolicy = function () {
      if ($scope.caratula.poliza_number) {
        helpers
          .existPolicyNumber($scope.caratula.poliza_number)
          .then(function (request) {
            if (request == true) {
              SweetAlert.swal("Error", MESSAGES.ERROR.POLICYEXIST, "error");
              $scope.caratula.poliza_number = "";
            }
          })
          .catch(function (err) {
            console.log("Error", err);
          });
      }
    };

    $scope.changeAddress = function (param) {
      $scope.caratula.address = param.id;
    };

    $scope.contratanteCreator = function () {
      $rootScope.show_contractor = true;
      $localStorage.orderForm = JSON.stringify($scope.caratula);
    };

    $scope.checkDate = function (param) {
      if (param.length == 10) {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.startDate = param;
        $scope.endDate = datesFactory.convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();

        if (process(param) > process($scope.endDate)) {
          SweetAlert.swal(
            "Error",
            "La fecha inicio no puede ser mayor a la fecha fin.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }
      } else {
        var day = new Date().getDate();
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();

        $scope.startDate = param;
        $scope.endDate = datesFactory.convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();
      }
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        $scope.caratula.end_of_validity = datesFactory.toDate(param);
      }
    };

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                // var juridicals = response.data.juridicals;
                // var naturals = response.data.naturals;

                // if(juridicals.length) {
                //   juridicals.forEach(function(item){
                //     var obj = {
                //       label: item.j_name,
                //       value: item
                //     };
                //     source.push(obj);
                //   });
                // }
                // if(naturals.length) {
                //   naturals.forEach(function(item){
                //     if (item.full_name) {
                //       var obj = {
                //         label: item.full_name,
                //         value: item
                //       };
                //     } else {
                //      var obj = {
                //         label: item.first_name + ' ' + item.last_name + ' ' + item.second_last_name,
                //         value: item
                //       };
                //     }
                //     source.push(obj);
                //   });
                // }
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if ($scope.referenciadores) {
          $scope.referenciadores.some(function (user) {
            if (user.url == order.contratante.value.vendor) {
              $scope.referenciadorArray[0] = {
                referenciador: user.url,
                comision_vendedor: "",
              };
            }
          });
        }
        // if(order.contratante.value.address_natural || order.contratante.value.address_juridical){
        //   if(order.contratante.value.address_natural){
        //     $scope.caratula.natural = order.contratante.value.id;
        //     $scope.caratula.juridical = null;
        //     $scope.addresses = order.contratante.value.address_natural;
        //   }else{
        //     $scope.caratula.natural = null;
        //     $scope.caratula.juridical = order.contratante.value.id;
        //     $scope.addresses = order.contratante.value.address_juridical;
        //   }
        //   if($scope.addresses.length == 1){
        //     $scope.addressSelected = $scope.addresses[0];
        //     $scope.caratula.address = $scope.addresses[0].id;
        //   }
        // }
        if (order.contratante.value.address_contractor) {
          if (order.contratante.value.address_contractor) {
            $scope.caratula.contractor = order.contratante.value.id;
            $scope.addresses = order.contratante.value.address_contractor;
          }
          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.caratula.address = $scope.addresses[0].id;
          }
        }

        if (order.contratante.value.cellule) {
          $scope.celulas.forEach(function (item) {
            if (
              String(item.url) ==
              String(
                order.contratante.value.cellule.url
                  ? order.contratante.value.cellule.url
                  : order.contratante.value.cellule
              )
            ) {
              $scope.celulaSelected = item;
              $scope.changeCelula($scope.celulaSelected);
            }
          });
        }
        $scope.info_sub = order.contratante.value;
        if (order.contratante.value.groupinglevel) {
          // $scope.agrupaciones.forEach(function(item){
          //   if(String(item.url) == (order.contratante.value.groupinglevel.url ? String(order.contratante.value.groupinglevel.url) : String(order.contratante.value.groupinglevel))){
          //     $scope.grouping_levelSelected = item;
          //     $scope.changeAgrupacion($scope.grouping_levelSelected);
          //   }
          // });
          // $http.get(order.contratante.value.groupinglevel.url ? order.contratante.value.groupinglevel.url : order.contratante.value.groupinglevel)
          // .then(function success(respons) {
          //   if(respons.data.type_grouping == 3){
          //     $scope.subsubgroupingSelected = respons.data;
          //     $http.get(respons.data.parent)
          //     .then(function success(respon) {
          //       $scope.subgroupingSelected = respon.data;
          //       $http.get(respon.data.parent)
          //       .then(function success(respo) {
          //         $scope.grouping_levelSelected = respo.data;
          //         $scope.changeAgrupacion(respo.data);
          //       });
          //     });
          //   }else if(respons.data.type_grouping == 2){
          //     $scope.subgroupingSelected = respons.data;
          //     $http.get(respons.data.parent)
          //     .then(function success(respon) {
          //       $scope.grouping_levelSelected = respon.data;
          //       $scope.changeAgrupacion(respon.data);
          //     });
          //   }else if(respons.data.type_grouping == 1){
          //     $scope.grouping_levelSelected = respons.data;
          //     $scope.changeAgrupacion(respons.data);
          //   }
          // });
          if (order.contratante.value.groupinglevel) {
            $http
              .get(
                order.contratante.value.groupinglevel.url
                  ? order.contratante.value.groupinglevel.url
                  : order.contratante.value.groupinglevel
              )
              .then(function success(respons) {
                if (respons.data.type_grouping == 3) {
                  $scope.caratula.groupinglevel = respons.data.id;
                  order.grouping_level = respons.data;
                  $scope.info_sub.subsubgrouping = respons.data;
                  $scope.subsubgroupingSelected = respons.data;
                  $http.get(respons.data.parent).then(function success(respon) {
                    $scope.info_sub.subgrouping = respon.data;
                    $scope.subgroupingSelected = respon.data;
                    $http.get(respon.data.parent).then(function success(respo) {
                      order.grouping_level = respo.data;
                      $scope.grouping_levelSelected = respo.data;
                      $scope.changeAgrupacion(respo.data);
                    });
                    order.subgrouping == respon.data;
                  });
                  order.subsubgrouping == respons.data;
                } else if (respons.data.type_grouping == 2) {
                  $scope.info_sub.subgrouping = respons.data;
                  $scope.subgroupingSelected = respons.data;
                  $http.get(respons.data.parent).then(function success(respon) {
                    order.grouping_level = respon.data;
                    $scope.grouping_levelSelected = respon.data;
                    $scope.changeAgrupacion(respon.data);
                  });
                  order.subgrouping == respons.data;
                } else if (respons.data.type_grouping == 1) {
                  order.grouping_level = respons.data;
                  $scope.grouping_levelSelected = respons.data;
                  $scope.changeAgrupacion(respons.data);
                }
              });
          }
        }
      }
    });

    $scope.$watch(
      "order.searchContratante.value",
      function (newValue, oldValue) {
        if (order.searchContratante) {
          if (order.searchContratante.value.address_contractor) {
            $scope.contractorLayout.id = order.searchContratante.value.id;
            $scope.contractorLayout.name = order.searchContratante.val;
            $scope.contractorLayout.contractor = order.searchContratante.value;
            if (
              order.searchContratante.value.type_person == 1 ||
              order.searchContratante.value.type_person == "Física"
            ) {
              $scope.contractorLayout.type = 1;
              $scope.contractorLayout.address =
                order.searchContratante.value.address_contractor;
            } else {
              $scope.contractorLayout.type = 2;
              $scope.contractorLayout.address =
                order.searchContratante.value.address_contractor;
            }
          }
          // if(order.searchContratante.value.address_natural || order.searchContratante.value.address_juridical){
          //   $scope.contractorLayout.id = order.searchContratante.value.id;
          //   $scope.contractorLayout.name = order.searchContratante.val;
          //   $scope.contractorLayout.contractor = order.searchContratante.value;
          //   if(order.searchContratante.value.address_natural){
          //     $scope.contractorLayout.type = 1;
          //     $scope.contractorLayout.address = order.searchContratante.value.address_natural;
          //   }else{
          //     $scope.contractorLayout.type = 2;
          //     $scope.contractorLayout.address = order.searchContratante.value.address_juridical;
          //   }
          // }
        }
      }
    );

    $scope.paqueteAll = function (paq) {
      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: $scope.ramoSelected.id,
          subramo: $scope.subramoSelected.id,
          provider: $scope.aseguradoraSelected.id,
        })
        .then(
          function success(response) {
            if (response.data.length) {
              $scope.paquetesLayout = response.data;
            } else {
              $scope.paquetesLayout = [];
            }
          },
          function error(e) {
            console.log("Error - paquetes-data-by-subramo", e);
            $scope.paquetesLayout = [];
          }
        )
        .catch(function (error) {
          console.log("Error - paquetes-data-by-subramo - catch", error);
          $scope.paquetesLayout = [];
        });
    };

    $scope.getClaves = function (param) {
      $scope.caratula.aseguradora = param;
      $scope.aseguradoraSelected = param;
      $scope.ramoSelected = null;
      $scope.subramoSelected = null;
      $scope.caratula.ramo = null;
      $scope.caratula.subramo = null;
      if ($localStorage.save_create_flotilla) {
        $localStorage.save_create_flotilla["aseguradora"] = param;
      }
      $http
        .get(url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id)
        .then(function success(clavesResponse) {
          $scope.claves = clavesResponse.data;
          if ($scope.claves.length == 1) {
            $scope.caratula.clave = $scope.claves[0].id;
            $scope.claveSelected = $scope.claves[0];
          }
        })
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      $http
        .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
        .then(
          function success(response) {
            $scope.ramos = response.data;
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    $scope.refreshProvider = function () {
      fillProvider();
    };
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };
    $scope.changeClave = function (param) {
      if (param) {
        $scope.caratula.clave = param.id;
        $scope.claveSelected = param;
        if ($scope.caratula.subramo) {
          $scope.changeSubramo($scope.caratula.subramo);
        }
      }
    };

    $scope.changeRamo = function (param) {
      if (param) {
        $scope.caratula.ramo = param;
        $scope.ramoSelected = param;
        $scope.subramos = param.subramo_ramo;
        if (localStorage.save_create_flotilla) {
          localStorage.save_create_flotilla["ramo"] = param;
        }
      }
    };

    $scope.changeSubramo = function (param) {
      if (param) {
        $scope.caratula.subramo = param;
        $scope.subramoSelected = param;
        $scope.layout.subramo = param;
        $localStorage.save_create_flotilla.subramo = param;
        $scope.paqueteAll(param);
      }
    };

    $scope.changeBline = function (param) {
      $scope.caratula.business_line = param;
      $localStorage.save_create_flotilla.business_line = param;
    };

    $scope.changeType = function (param) {
      $scope.caratula.type = param;
      $localStorage.save_create_flotilla.type_policy = param;
    };

    $scope.changeResponsableLay = function (param) {
      $scope.responsableLay = param;
      $localStorage.save_create_flotilla.responsableLay = param;
    };

    $scope.changeSucursalLay = function (param) {
      $scope.sucursalLay = param;
      $localStorage.save_create_flotilla.sucursal = param;
    };

    $scope.changeCurrency = function (param) {
      $scope.caratula.f_currency = param;
      $localStorage.save_create_flotilla.f_currency = param;
    };

    $scope.changeRenewal = function (param) {
      $scope.caratula.is_renewable = param.value;
      $localStorage.save_create_flotilla.is_renewable = param;
    };

    $scope.changeCelula = function (param) {
      $scope.caratula.celula = param.id;
      $localStorage.save_create_flotilla.celula = param;
    };

    $scope.changeAgrupacion = function (data) {
      $localStorage.save_create_flotilla["agrupacion"] = data;
      $scope.sub_asignaciones = data.subgrupos;
      $scope.caratula.groupinglevel = data.id;
      if ($scope.info_sub.subgrouping) {
        $scope.sub_asignaciones.forEach(function (item) {
          if (parseInt(item.id) == parseInt($scope.info_sub.subgrouping.id)) {
            $scope.subgroupingSelected = item;
            $scope.changeSubagrupacion(item);
          }
        });
      }
      if ($localStorage["save_create_flotilla"]) {
        if ($localStorage["save_create_flotilla"]["subagrupacion"]) {
          $scope.agrupaciones.forEach(function (item) {
            if (
              item.id ==
              $localStorage["save_create_flotilla"]["subagrupacion"]["id"]
            ) {
              $scope.subgroupingSelected = item;
              $scope.sub_subasignaciones = item.subsubgrupos;
              $scope.changeSubagrupacion($scope.subgroupingSelected);
            }
          });
        }
      }
    };

    $scope.changeSubagrupacion = function (data) {
      if (data) {
        $localStorage.save_create_flotilla["subagrupacion"] = data;
        if (data.subsubgrupos) {
          $scope.sub_subasignaciones = data.subsubgrupos;
          $scope.caratula.groupinglevel = data.id;
          if ($scope.info_sub.subsubgrouping) {
            $scope.sub_subasignaciones.forEach(function (item) {
              if (
                parseInt(item.id) == parseInt($scope.info_sub.subsubgrouping.id)
              ) {
                $scope.subsubgroupingSelected = item;

                $scope.caratula.groupinglevel = item.id;
              }
            });
          }
        } else {
          $scope.sub_subasignaciones = [];
        }
      } else {
        $scope.sub_subasignaciones = [];
      }
    };

    $scope.changeSubsubagrupacion = function (data) {
      $localStorage.save_create_flotilla["subsubagrupacion"] = data;
      if (data) {
        $scope.caratula.groupinglevel = data.id;
      } else {
        console.log("--data", data);
      }
    };

    $scope.changeEjecutivoCobranza = function (param) {
      $scope.caratula.collection_executive = param;
      $localStorage.save_create_flotilla.collection_executive = param;
    };

    $scope.changeResponsable = function (param) {
      $scope.caratula.responsable = param;
      $localStorage.save_create_flotilla.responsable = param;
    };

    $scope.addReferenciador = function () {
      var addReferenciadores = {
        referenciador: "",
        comision_vendedor: "",
      };
      $scope.referenciadorArray.push(addReferenciadores);
    };

    $scope.deleteReferenciador = function (index) {
      $scope.referenciadorArray.splice(index, 1);
    };

    function isString(x) {
      return Object.prototype.toString.call(x) === "[object String]";
    }

    $scope.validityInsurance = function () {
      var lb = Ladda.create(document.querySelector(".ladda-button"));
      lb.start();
      $scope.referenciadores_copy = $scope.referenciadorArray.filter(function (
        item
      ) {
        return item && item.referenciador && isString(item.referenciador);
      });

      if (
        !order.acc_referenciador_obligatorio &&
        $scope.referenciadores_copy.length <= 0
      ) {
        SweetAlert.swal(
          "Error",
          "Seleccione al menos un referenciador",
          "error"
        );
        lb.stop();
        return;
      }

      // SweetAlert.swal("Succes", "Si pasa", "success");
      // lb.stop();
      // return;

      if (!$scope.aseguradoraSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        lb.stop();
        return;
      }
      if (!$scope.caratula.poliza_number) {
        SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
        lb.stop();
        return;
      }
      if (!$scope.caratula.identifier) {
        SweetAlert.swal("Error", MESSAGES.ERROR.IDENTIFIERREQUIRED, "error");
        lb.stop();
        return;
      }
      if (!order.contratante.val) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        lb.stop();
        return;
      }
      if (!$scope.caratula.address) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        lb.stop();
        return;
      }
      if (!$scope.caratula.clave) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        lb.stop();
        return;
      }
      if (!$scope.ramoSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        lb.stop();
        return;
      }
      if (!$scope.subramoSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        lb.stop();
        return;
      }
      $scope.saveInsurance();
    };

    $scope.saveInsurance = function () {
      var lb = Ladda.create(document.querySelector(".ladda-button"));
      lb.start();
      $scope.caratula.business_line = $scope.lineaSelected
        ? $scope.lineaSelected.id
        : 1;
      $scope.caratula.aseguradora = $scope.aseguradoraSelected
        ? $scope.aseguradoraSelected.id
        : $scope.caratula.aseguradora.id;
      $scope.caratula.ramo = $scope.ramoSelected
        ? $scope.ramoSelected.id
        : $scope.caratula.ramo.id;
      $scope.caratula.subramo = $scope.subramoSelected
        ? $scope.subramoSelected.id
        : $scope.caratula.subramo.id;
      $scope.caratula.type_policy = $scope.caratula.type
        ? $scope.caratula.type.value
        : $scope.typeSelected
        ? $scope.typeSelected.value
        : 1;
      $scope.caratula.f_currency = $scope.caratula.f_currency
        ? $scope.caratula.f_currency
        : $scope.currencySelected
        ? $scope.currencySelected
        : 1;
      $scope.caratula.is_renewable = $scope.caratula.is_renewable
        ? $scope.caratula.is_renewable
        : $scope.renewalSelected
        ? $scope.renewalSelected.value
        : null;
      $scope.caratula.responsable = $scope.caratula.responsable
        ? $scope.caratula.responsable
        : null;
      $scope.caratula.document_type = 11;
      $scope.caratula.status = 14;
      if (
        $scope.caratula.celula &&
        typeof $scope.caratula.celula === "object"
      ) {
        $scope.caratula.celula = $scope.caratula.celula.id || null;
      } else {
        $scope.caratula.celula = $scope.caratula.celula;
      }
      $scope.caratula.celula = $scope.caratula.celula
        ? $scope.caratula.celula
        : null;
      $scope.caratula.groupinglevel = $scope.caratula.groupinglevel
        ? $scope.caratula.groupinglevel
        : null;

      $scope.referenciadoresSelected = [];
      $scope.referenciadorArray.forEach(function (item) {
        if (item.referenciador != "" && item.referenciador != null) {
          if (item.comision_vendedor == "") {
            item.comision_vendedor = 0;
          }
          $scope.referenciadoresSelected.push(item);
        } else {
          $scope.referenciadorArray.splice(item, 1);
        }
      });
      $scope.contractorToSave = {};

      if (
        order.contratante.value.email ||
        order.contratante.value.phone_number
      ) {
        if (order.contratante.value.phone_number) {
          $scope.contractorToSave.phone_number =
            order.contratante.value.phone_number;
        }
        if (order.contratante.value.email) {
          $scope.contractorToSave.email = order.contratante.value.email;
        }
      }
      $http
        .patch(order.contratante.value.url, $scope.contractorToSave)
        .then(function (data) {});
      $scope.caratula.ref_policy = $scope.referenciadoresSelected;
      if (
        $rootScope.from_task &&
        $rootScope.task_associated &&
        $rootScope.task_associated.url
      ) {
        $scope.caratula.from_task = $rootScope.from_task;
        $scope.caratula.task_associated = $rootScope.task_associated.id;
      }
      $http
        .post(url.IP + "colectividades_polizas/", $scope.caratula)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            if (
              $rootScope.from_task &&
              $rootScope.task_associated &&
              $rootScope.task_associated.url
            ) {
              $http.patch($rootScope.task_associated.url, {
                ot_model: 1,
                ot_id_reference: response.data.id,
              });
            }
            lb.stop();
            $scope.dataCaratula = response.data;
            $scope.paqueteAll($scope.caratula);
            $scope.showCar = true;
            $scope.showPol = false;
            SweetAlert.swal(
              "¡Listo!",
              "Carátula creada exitosamente.",
              "success"
            );
            $localStorage["save_create_flotilla"] = {};
            $state.go("flotillas.info", { polizaId: $scope.dataCaratula.id });
          } else {
            lb.stop();
            SweetAlert.swal("Error", response.data, "error");
          }
        })
        .catch(function (e) {
          lb.stop();
          console.log("error - caratula - catch", e);
        });
    };

    $scope.goToPolicy = function () {
      $state.go("flotillas.info", { polizaId: $scope.dataCaratula.id });
    };

    $scope.validateEmail = function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      if (!$scope.dataCaratula.id) {
        SweetAlert.swal(
          "¡Error!",
          "Debes crear la carátula primero para poder cargar certificados.",
          "error"
        );
        return;
      } else {
        var flagCertificate = false;
        if (param.FLOTILLA) {
          if ($scope.layout.subramo.subramo_name == "Automóviles") {
            $scope.allReceipts = [];
            $scope.excelJson = param.FLOTILLA;
            $scope.excelJson.forEach(function (item) {
              if (!item.CLASE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CLASE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.NO_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              // if(!item.FOLIO){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna FOLIO, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }
              if (!item.NO_POLIZA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_POLIZA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CONTRATANTE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CONTRATANTE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.TIPO_CONTRATANTE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_CONTRATANTE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.DIRECCION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DIRECCION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              // if(!item.CORREO){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna CORREO, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }else{
              //   if(!$scope.validateEmail(item.CORREO)){
              //     SweetAlert.swal('Error', 'Formato inválido de la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna CORREO, corrige el error y vuelve a subir el excel.', 'error');
              //     flagCertificate = true;
              //   }
              // }
              // if(!item.TELEFONO){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna TELEFONO, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }
              if (!item.VIGENCIA_INICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_FIN) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.FRECUENCIA_PAGO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FRECUENCIA_PAGO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.RENOVABLE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RENOVABLE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MONEDA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MONEDA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              // if(!item.LINEA_NEGOCIO){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna LINEA_NEGOCIO, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }
              // if(!item.SUCURSAL){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna SUCURSAL, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }
              if (!item.TIPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PROCEDENCIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PROCEDENCIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.PROCEDENCIA < 0 || item.PROCEDENCIA > 4) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna PROCEDENCIA no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              // if(!item.CONDUCTOR){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna CONDUCTOR, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }
              if (!item.MARCA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MODELO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.AÑO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna AÑO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.VERSION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SERIE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MOTOR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MOTYOR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              // if(!item.COLOR){
              //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna COLOR, corrige el error y vuelve a subir el excel.', 'error');
              //   flagCertificate = true;
              // }
              if (!item.MATRICULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MATRICULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.USO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.USO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.USO < 1 || item.USO > 3) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.SERVICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SERVICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PRIMA_NETA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.DESCUENTO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DESCUENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.RPF) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.DERECHO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.IVA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PRIMA_TOTAL) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.COMISION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PORCENTAJE_COMISION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PORCENTAJE_COMISION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (parseFloat(item.PORCENTAJE_COMISION) > 100.0) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PORCENTAJE_COMISION, excede el 100%, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (parseFloat(item.PORCENTAJE_COMISION) < 0.0) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PORCENTAJE_COMISION, no puede ser menor a 0, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (parseInt(item.CLASE) == 2) {
                if (!item.NO_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna NO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.PRIMA_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.RPF_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.DERECHO_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.IVA_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.TOTAL_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TOTAL_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.COMISION_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (!item.INICIO_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (!$scope.validateDate(item.INICIO_RECIBO)) {
                    SweetAlert.swal(
                      "Error",
                      "Formato inválido de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
                if (!item.FIN_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (!$scope.validateDate(item.FIN_RECIBO)) {
                    SweetAlert.swal(
                      "Error",
                      "Formato inválido de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
                if (!item.VENCIMIENTO_RECIBO) {
                  SweetAlert.swal(
                    "Error",
                    "Esta vacía la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (!$scope.validateDate(item.VENCIMIENTO_RECIBO)) {
                    SweetAlert.swal(
                      "Error",
                      "Formato inválido de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
                var receipt = {
                  comision: item.COMISION_RECIBO,
                  delivered: false,
                  derecho: item.DERECHO_RECIBO,
                  fecha_fin: item.FIN_RECIBO,
                  fecha_inicio: item.INICIO_RECIBO,
                  iva: item.IVA_RECIBO,
                  prima_neta: item.PRIMA_RECIBO,
                  prima_total: item.TOTAL_RECIBO,
                  recibo_numero: item.NO_RECIBO,
                  rpf: item.RPF_RECIBO,
                  sub_total: item.SUBTOTAL_RECIBO,
                  vencimiento: item.VENCIMIENTO_RECIBO,
                  poliza: item.NO_POLIZA,
                  receipt_type: 1,
                };
                $scope.allReceipts.push(receipt);
              }
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
            "error"
          );
        }
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          if (item.AÑO_CONSTRUCCION) {
            item.ANO_CONSTRUCCION = item.AÑO_CONSTRUCCION;
            item.ANO_RECONSTRUCCION = item.AÑO_RECONSTRUCCION;
          }
          if (item.AÑO) {
            item.ANIO = item.AÑO;
          }
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.cancelCertificates = function () {
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.saveCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loader = true;
      $scope.certifcados = [];

      if ($scope.selectedCertificates.FLOTILLA) {
        $scope.selectedCertificates.FLOTILLA.forEach(function (item) {
          if (item.CLASE == 1) {
            $scope.recibosIndividuales = [];
            var dataCar = [
              {
                brand: item.MARCA,
                charge_type: 0,
                color: item.COLOR ? item.COLOR : null,
                driver: item.CONDUCTOR ? item.CONDUCTOR : null,
                email: item.CORREO ? item.CORREO : "",
                engine: item.MOTOR ? item.MOTOR : null,
                license_plates: item.MATRICULA ? item.MATRICULA : null,
                model: item.MODELO,
                policy_type: item.TIPO ? parseInt(item.TIPO) : null,
                procedencia: parseInt(item.PROCEDENCIA),
                serial: item.SERIE,
                service: item.SERVICIO,
                usage: parseInt(item.USO),
                version: item.VERSION,
                year: item.AÑO,
                no_employee: null,
                sum_insured: null,
                adjustment: item.ADAPTACIONES ? item.ADAPTACIONES : null,
                mont_adjustment: item.MONTO_ADAPTACIONES
                  ? item.MONTO_ADAPTACIONES
                  : null,
                special_team: item.EQUIPAMIENTO ? item.EQUIPAMIENTO : null,
                mont_special_team: item.MONTO_EQUIPAMIENTO
                  ? item.MONTO_EQUIPAMIENTO
                  : null,
                beneficiary_name: null,
                preferential_benefiaciary: item.BENEFICIARIO_PREFERENTE
                  ? item.BENEFICIARIO_PREFERENTE
                  : null,
                beneficiary_rfc: item.BENEFICIARIO_RFC
                  ? item.BENEFICIARIO_RFC
                  : null,
                beneficiary_address: item.BENEFICIARIO_DIRECCION
                  ? item.BENEFICIARIO_DIRECCION
                  : null,
              },
            ];

            $scope.allReceipts.forEach(function (receipt, index) {
              if (receipt.prima_neta && receipt.rpf && receipt.derecho) {
                if (receipt.poliza == item.NO_POLIZA) {
                  if (receipt.fecha_inicio.toString().length > 10) {
                    receipt.fecha_inicio = datesFactory.convertDate(
                      receipt.fecha_inicio
                    );
                  }
                  receipt.fecha_inicio = datesFactory.toDate(
                    receipt.fecha_inicio
                  );

                  if (receipt.fecha_fin.toString().length > 10) {
                    receipt.fecha_fin = datesFactory.convertDate(
                      receipt.fecha_fin
                    );
                  }
                  receipt.fecha_fin = datesFactory.toDate(receipt.fecha_fin);
                  if (receipt.vencimiento.toString().length > 10) {
                    receipt.vencimiento = datesFactory.convertDate(
                      receipt.vencimiento
                    );
                  }
                  receipt.vencimiento = datesFactory.toDate(
                    receipt.vencimiento
                  );
                  receipt.conducto_de_pago = item.CONDUCTO_DE_PAGO;
                  $scope.recibosIndividuales.push(receipt);
                }
              }
            });

            $scope.obj_poliza = {
              aplicarDescuento: false,
              primaNeta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
              descuento: item.DESCUENTO ? item.DESCUENTO : 0,
              rpf: item.RPF ? item.RPF : 0,
              derecho: item.DERECHO ? item.DERECHO : 0,
              iva: item.IVA ? item.IVA : 0,
              primaTotal: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
              subTotal:
                parseFloat(item.PRIMA_NETA) +
                parseFloat(item.RPF) +
                parseFloat(item.DERECHO),
            };
            if (item.TIPO_CONTRATANTE) {
              $scope.contractorP = item.CONTRATANTE;
            }
            // if (parseInt(item.TIPO_CONTRATANTE) ==1) {
            //   $scope.naturalP = item.CONTRATANTE
            //   $scope.juridicalP = null
            // }else if (parseInt(item.TIPO_CONTRATANTE) ==2) {
            //   $scope.naturalP = null
            //   $scope.juridicalP = item.CONTRATANTE
            // }

            var certificateData = {
              accidents_policy: [],
              address: parseInt(item.DIRECCION),
              aseguradora: $scope.dataCaratula.aseguradora,
              automobiles_policy: dataCar,
              business_line: $scope.dataCaratula.business_line,
              responsable: $scope.dataCaratula.responsable,
              caratula: $scope.dataCaratula.id,
              celula: $scope.dataCaratula.celula,
              clave: $scope.dataCaratula.clave,
              coverageInPolicy_policy: [],
              damages_policy: [],
              document_type: 12,
              end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
              endorsement: false,
              collection_executive: $scope.caratula.collection_executive,
              f_currency: parseInt(item.MONEDA),
              folio: item.FOLIO ? item.FOLIO : "",
              forma_de_pago: parseInt(item.FRECUENCIA_PAGO),
              groupinglevel: $scope.caratula.groupinglevel,
              identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
              internal_number: null,
              is_renewable: item.RENOVABLE ? item.RENOVABLE : null,
              life_policy: [],
              // natural: parseInt($scope.naturalP),
              // juridical: parseInt($scope.juridicalP),
              contractor: parseInt($scope.contractorP),
              old_policies: [],
              paquete: parseInt(item.PAQUETE),
              parent: $scope.dataCaratula.url,
              // poliza: $scope.obj_poliza,
              poliza_number: item.NO_POLIZA,
              ramo: $scope.dataCaratula.ramo,
              recibos_poliza: $scope.recibosIndividuales,
              start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
              state_circulation: item.ESTADO_CIRCULACION
                ? parseInt(item.ESTADO_CIRCULACION)
                : "",
              status: 14,
              sucursal: item.SUCURSAL ? parseInt(item.SUCURSAL) : null,
              subramo: $scope.dataCaratula.subramo,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : null,
              p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
              descuento: item.DESCUENTO ? item.DESCUENTO : 0,
              rpf: item.RPF ? item.RPF : 0,
              derecho: item.DERECHO ? item.DERECHO : 0,
              iva: item.IVA ? item.IVA : 0,
              p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
              comision: item.COMISION ? item.COMISION : 0,
              comision_percent: item.PORCENTAJE_COMISION
                ? item.PORCENTAJE_COMISION
                : 0,
              sub_total: $scope.obj_poliza.subTotal
                ? parseFloat($scope.obj_poliza.subTotal).toFixed(2)
                : 0,
              conducto_de_pago: item.CONDUCTO_DE_PAGO,
            };
            $scope.certifcados.push(certificateData);
          }
        });
      }

      $http({
        method: "POST",
        url: url.IP + "save_caratula_polizas/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          l.stop();
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal(
              "¡Listo!",
              "Pólizas individuales creadas exitosamente.",
              "success"
            );
            $state.go("flotillas.info", { polizaId: $scope.dataCaratula.id });
          } else {
            l.stop();
            $scope.loader = false;
            SweetAlert.swal(
              "ERROR",
              "Ócurrio un error al cargar las pólizas.",
              "error"
            );
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("filterListController", filterListController);

  filterListController.$inject = ["$scope", "$http", "url", "SweetAlert"];

  function filterListController($scope, $http, url, SweetAlert) {
    var vm = this;

    $scope.showButtonDeleteUser = false;
    $scope.showButtonDeleteShare = false;

    activate();

    function activate() {
      $scope.showGroupUser = false;
      $scope.params = {
        user: 0,
        group: 0,
      };
      $http({
        method: "GET",
        url: url.IP + "get-shared-by-group-user",
        params: $scope.params,
      }).success(function (response) {
        $scope.users = response.info.usuarios;
        $scope.groups = response.info.grupos;
      });
    }

    $scope.getInfoUser = function (item, idx) {
      $scope.user_index = idx;
      $scope.params = {
        user: item.usuario,
        group: 0,
      };
      $http({
        method: "GET",
        url: url.IP + "get-shared-by-group-user",
        params: $scope.params,
      }).success(function (response) {
        $scope.asignaciones = response;
      });
    };

    $scope.getInfoGroup = function (item, idx) {
      $scope.hideDeleteUser();
      $scope.group_index = idx;
      $http({
        method: "GET",
        url: url.IP + "get-djangousersgroups/",
        params: { group: item.grupo, action: 1 },
      }).success(function (response) {
        $scope.groupsList = response;
      });
      $scope.params = {
        user: 0,
        group: item.grupo,
      };
      $http({
        method: "GET",
        url: url.IP + "get-shared-by-group-user",
        params: $scope.params,
      }).success(function (response) {
        $scope.asignacionesGroup = response;
      });
    };

    $scope.showDeleteUser = function () {
      $scope.showButtonDeleteUser = true;
    };

    $scope.hideDeleteUser = function () {
      $scope.showButtonDeleteUser = false;
    };

    $scope.deleteUser = function (val, us) {
      swal(
        {
          title: "¿Estás seguro?",
          text: "¿Desea eliminar el usuario de este grupo?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.delUserGroup(val, us);
          } else {
            SweetAlert.swal("¡Bien!", "Usuario no se ha eliminado.", "info");
          }
        }
      );
    };

    $scope.delUserGroup = function (val, us) {
      $scope.params = {
        group: val.grupo,
        user: us.id,
        action: 2,
      };
      $http({
        method: "POST",
        url: url.IP + "djangousersgroups/",
        data: $scope.params,
      }).success(function (response1) {
        SweetAlert.swal(
          "¡Listo!",
          "Usuario eliminado correctamente.",
          "success"
        );
      });
      $http({
        method: "GET",
        url: url.IP + "get-djangousersgroups/",
        params: $scope.params,
      }).success(function (response) {
        $scope.groupsList = response;
      });
    };

    $scope.showDeleteShare = function () {
      $scope.showButtonDeleteShare = true;
    };
    $scope.showDeleteShareUser = function () {
      $scope.showButtonDeleteShareUser = true;
    };

    $scope.hideDeleteShare = function () {
      $scope.showButtonDeleteShare = false;
    };
    $scope.hideDeleteShareUser = function () {
      $scope.showButtonDeleteShareUser = false;
    };

    $scope.deleteShare = function (val, us, cat) {
      swal(
        {
          title: "¿Estás seguro?",
          text: "¿Desea eliminar esta asignación?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.delShare(val, us, cat);
          } else {
            SweetAlert.swal(
              "¡Bien!",
              "La asignación no se ha eliminado.",
              "info"
            );
          }
        }
      );
    };

    $scope.delShare = function (val, asi, cat) {
      switch (cat) {
        case 1:
          $scope.params = {
            group: val.grupo ? val.grupo : 0,
            user: val.usuario ? val.usuario : 0,
            aseguradora: asi.aseguradora,
          };
          break;
        case 2:
          $scope.params = {
            group: val.grupo ? val.grupo : 0,
            user: val.usuario ? val.usuario : 0,
            contratante_fisico: asi.contratante_fisico,
          };
          break;
        case 3:
          $scope.params = {
            group: val.grupo ? val.grupo : 0,
            user: val.usuario ? val.usuario : 0,
            contratante_moral: asi.contratante_moral,
          };
          break;
        case 4:
          $scope.params = {
            group: val.grupo ? val.grupo : 0,
            user: val.usuario ? val.usuario : 0,
            fianza: asi.fianza,
          };
          break;
        case 5:
          $scope.params = {
            group: val.grupo ? val.grupo : 0,
            user: val.usuario ? val.usuario : 0,
            grupo_de_contratantes: asi.grupo_de_contratantes,
          };
          break;
        case 6:
          $scope.params = {
            group: val.grupo ? val.grupo : 0,
            user: val.usuario ? val.usuario : 0,
            poliza: asi.poliza,
          };
          break;
        default:
          break;
      }
      $http({
        method: "POST",
        url: url.IP + "del-shared-user-group/",
        data: $scope.params,
      }).success(function (response1) {
        SweetAlert.swal(
          "¡Listo!",
          "Usuario eliminado correctamente.",
          "success"
        );
      });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("filterController", filterController);

  filterController.$inject = [
    "$scope",
    "$http",
    "url",
    "SweetAlert",
    "dataFactory",
  ];

  function filterController($scope, $http, url, SweetAlert, dataFactory) {
    var vm = this;

    vm.form = {
      name: "",
    };
    $scope.group = {
      name: "",
    };
    $scope.showGroupUser = false;
    $scope.showListGroupUser = false;
    $scope.addUsersToGroup = false;
    $scope.editGroupUser = false;
    $scope.delUsersToGroup = false;

    $scope.showChangeNameGroup = false;
    // ---select
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });

    listGroups();

    $scope.createGroupUser = function (val) {
      $scope.showGroupUser = val;
      $scope.showListGroupUser = false;
      $scope.addUsersToGroup = false;
      $scope.editGroupUser = false;
      $scope.delUsersToGroup = false;
    };

    $scope.asignUsers = function (val) {
      $scope.showGroupUser = false;
      $scope.showListGroupUser = false;
      $scope.addUsersToGroup = val;
      $scope.editGroupUser = false;
      $scope.delUsersToGroup = false;
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    };

    $scope.editGroupUsers = function (val) {
      $scope.showGroupUser = false;
      $scope.showListGroupUser = false;
      $scope.addUsersToGroup = false;
      $scope.editGroupUser = val;
      $scope.delUsersToGroup = false;

      $scope.showChangeNameGroup = false;
    };

    $scope.eliminarGroupUsers = function (val) {
      $scope.showGroupUser = false;
      $scope.showListGroupUser = false;
      $scope.addUsersToGroup = false;
      $scope.editGroupUser = false;
      $scope.delUsersToGroup = val;
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
      $http({
        method: "GET",
        url: url.IP + "get-group-user",
      }).success(function (response) {
        $scope.groupsUsersList = response.results;
      });
    };
    // Save group usuers
    $scope.saveGroupUser = function (form) {
      $scope.params = {
        name: form.name,
      };
      $http({
        method: "POST",
        url: url.IP + "djangogroups/",
        data: $scope.params,
      }).success(function (response) {
        vm.form.name = "";
        $scope.groupsUsers = response;
        $scope.showGroupUser = false;
        $scope.showListGroupUser = true;
        SweetAlert.swal(
          "¡Listo!",
          "El grupo ha sido creado correctamente.",
          "success"
        );
        listGroups();
      });
    };

    function listGroups() {
      $http({
        method: "GET",
        url: url.IP + "get-group-user",
      }).success(function (response) {
        // $scope.showListGroupUser = false;
        $scope.showGroupUser = false;
        $scope.groupsUsersList = response.results;
      });
    }

    $scope.getUsers = function (gu) {
      if (gu) {
        if (gu.name) {
          if (gu.name.id) {
            $http({
              method: "GET",
              url: url.IP + "get-djangousersgroups/",
              params: { group: gu.name.id },
            }).success(function (response) {
              $scope.groupsList = response;
            });
          }
        }
      }
    };

    $scope.selectUser = function (sel) {
      vm.usuarios_selected = [];
      sel.forEach(function (u) {
        vm.usuarios_selected.push(u.id);
      });
    };

    $scope.saveUserinGroup = function (val, num) {
      vm.usuarios_selected.forEach(function (item) {
        $scope.params = {
          group: val.name.id,
          user: item,
          action: num,
        };
        $http({
          method: "POST",
          url: url.IP + "djangousersgroups/",
          data: $scope.params,
        }).success(function (response) {
          vm.form.name = "";
          $scope.groupsUsers = response;
          $scope.showListGroupUser = true;
          $scope.showGroupUser = false;
          $scope.group.name = "";
        });
        // GET
        $http({
          method: "GET",
          url: url.IP + "get-djangousersgroups/",
          params: $scope.params,
        }).success(function (response) {
          vm.form.name = "";
          $scope.groupsUsers = response;
          $scope.showListGroupUser = true;
          $scope.showGroupUser = false;
        });
      });
    };

    $scope.delUserGroup = function (val, us, num) {
      $scope.params = {
        group: val.id,
        user: us.id,
        action: num,
      };
      $http({
        method: "POST",
        url: url.IP + "djangousersgroups/",
        data: $scope.params,
      }).success(function (response1) {
        $scope.groupsUsers = response1;
      });
      // GET
      $http({
        method: "GET",
        url: url.IP + "get-djangousersgroups/",
        params: $scope.params,
      }).success(function (response) {
        vm.form.name = "";
        $scope.groupsUsers = response;
      });
    };

    $scope.seeGroup = function (grp, num, idx) {
      $http({
        method: "GET",
        url: url.IP + "get-djangousersgroups/",
        params: { group: grp.id, action: num },
      }).success(function (response) {
        $scope.groupsList = response;
        $scope.showGroups = true;
        if (num == 1) {
          $scope.showDelUser = false;
        } else {
          $scope.showDelUser = true;
        }
      });
    };

    $scope.hideGroup = function () {
      $scope.groupsList = [];
      $scope.showGroups = false;
      $scope.showDelUser = true;
    };

    $scope.findGroup = function (parValue) {
      if (parValue) {
        if (parValue.val.length >= 3) {
          if ($scope.selectUser == "usuario") {
            dataFactory
              .get("filter-users/", { word: parValue.val })
              .then(
                function success(request) {
                  var results = [];
                  results = _.map(request.data.results, function (item) {
                    return {
                      label: item.first_name + " " + item.last_name,
                      value: item.first_name + " " + item.last_name,
                      id: item.id,
                      url: item.url,
                    };
                  });
                  $scope.autocompleteData = results;
                },
                function error(error) {}
              )
              .catch(function (e) {
                console.log("e", e);
              });
          } else {
            $scope.aurtocompleteData = [];
            dataFactory
              .get("filter-djangogroups/", { word: parValue.val })
              .then(
                function success(request) {
                  var results = [];
                  results = _.map(request.data.results, function (item) {
                    return {
                      label: item.name,
                      value: item.name,
                      id: item.id,
                      url: item.url,
                    };
                  });
                  $scope.autocompleteData = results;
                },
                function error(error) {}
              )
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      }
    };

    $scope.groupSelect = function (item) {
      $scope.showChangeNameGroup = true;
      $scope.groupName = item;
    };

    $scope.saveEditGroupName = function (name) {
      $scope.params = {
        name: name.name,
      };
      $http
        .patch(url.IP + "djangogroups/" + name.id + "/", $scope.params)
        .then(function success(response) {
          SweetAlert.swal(
            "¡Listo!",
            "El grupo ha sido actualizado correctamente.",
            "success"
          );
          // $scope.editGroupUser = false;
          $scope.group.name = "";
          $scope.groupName = [];
          listGroups();
        });
    };

    $scope.hideEdit = function () {
      $scope.showChangeNameGroup = false;
    };

    $scope.delGroupAll = function (val) {
      SweetAlert.swal(
        {
          title: "Eliminar el Grupo: " + val.name.name,
          text: "Se eliminará definitivamente el Grupo.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.delUsersToGroup = false;
            $scope.params = {
              group: val.name.id,
              user: 0,
              action: 3, //Eliminar grupo
            };
            $http({
              method: "POST",
              url: url.IP + "djangousersgroups/",
              data: $scope.params,
            }).success(function (response2) {
              $scope.groupsUsers = response2;
              SweetAlert.swal(
                "¡Listo!",
                "El grupo ha sido eliminado correctamente.",
                "success"
              );
              $scope.group.name = "";
              listGroups();
            });
            // GET
            $http({
              method: "GET",
              url: url.IP + "get-djangousersgroups/",
            }).success(function (response) {
              vm.form.name = "";
              $scope.groupsUsers = response;
            });
          }
        }
      );
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("filterSharedController", filterSharedController);

  filterSharedController.$inject = [
    "$scope",
    "$http",
    "url",
    "dataFactory",
    "providerService",
    "SweetAlert",
    "$sessionStorage",
    "$state",
  ];

  function filterSharedController(
    $scope,
    $http,
    url,
    dataFactory,
    providerService,
    SweetAlert,
    $sessionStorage,
    $state
  ) {
    var vm = this;

    $scope.selectUser = "usuario";
    $scope.userSelected = [];
    $scope.groupSelected = [];
    $scope.showTable = false;
    $scope.shareds = [
      {
        aseguradora: "",
        contratante_fisico: "",
        contratante_moral: "",
        grupo_de_contratantes: "",
        fianza: "",
        poliza: "",
      },
    ];
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.url_go = "";
    activate();
    function activate() {
      providerService.getReadListProviders().then(function (provider) {
        $scope.providers = provider;
        $scope.url_go = $scope.providers[0].org;
      });
    }

    $scope.findUser = function (parValue) {
      $scope.autocompleteData = [];
      if (parValue) {
        if (parValue.val.length >= 3) {
          if ($scope.selectUser == "usuario") {
            dataFactory
              .get("filter-users/", { word: parValue.val })
              .then(
                function success(request) {
                  var results = [];
                  results = _.map(request.data.results, function (item) {
                    return {
                      label: item.first_name + " " + item.last_name,
                      value: item.first_name + " " + item.last_name,
                      id: item.id,
                      url: item.url,
                    };
                  });
                  $scope.autocompleteData = results;
                },
                function error(error) {}
              )
              .catch(function (e) {
                console.log("e", e);
              });
          } else {
            $scope.aurtocompleteData = [];
            dataFactory
              .get("filter-djangogroups/", { word: parValue.val })
              .then(
                function success(request) {
                  var results = [];
                  results = _.map(request.data.results, function (item) {
                    return {
                      label: item.name,
                      value: item.name,
                      id: item.id,
                      url: item.url,
                    };
                  });
                  $scope.autocompleteData = results;
                },
                function error(error) {}
              )
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      }
    };

    $scope.userSelect = function (val) {
      if (val.value) {
        $scope.showTable = true;
        if ($scope.selectUser == "usuario") {
          $scope.userSelected = "";
          $scope.groupSelected = "";
          if (val) {
            $http.get(val.url).then(function (response) {
              if (response.status === 200) {
                $scope.userSelected = response.data;
                $scope.groupSelected = [];
              }
            });
          }
        } else {
          $scope.groupSelected = val;
          $scope.userSelected = [];
          $scope.seeGroup(val.id, 1);
        }
        $scope.shareds = [];
        $scope.shareds = [
          {
            aseguradora: "",
            contratante_fisico: "",
            contratante_moral: "",
            grupo_de_contratantes: "",
            fianza: "",
            poliza: "",
          },
        ];
      }
    };
    $scope.seeGroup = function (grp, num) {
      $http({
        method: "GET",
        url: url.IP + "get-djangousersgroups/",
        params: { group: grp, action: num },
      }).success(function (response) {
        $scope.groupsList = response;
      });
    };

    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = [];
      if (parWord) {
        if (parWord.val.length >= 3) {
          $http
            .post(url.IP + "contractors-match/", {
              matchWord: parWord.val,
              poliza: true,
            })
            .then(function (response) {
              if (
                response.status === 200 &&
                (response.data.juridicals || response.data.naturals)
              ) {
                var source = [];
                var juridicals = response.data.juridicals;
                var naturals = response.data.naturals;
                if (juridicals.length) {
                  juridicals.forEach(function (item) {
                    var obj = {
                      label: item.j_name,
                      value: item,
                    };
                    source.push(obj);
                  });
                } else if (naturals.length) {
                  naturals.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
        $scope.contractors_data = [];
      }
    };

    $scope.matchesGroup = function (parWord) {
      $scope.groups_data = [];
      if (parWord) {
        if (parWord.val.length >= 3) {
          $http
            .post(url.IP + "grupos-match/", {
              matchWord: parWord.val,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    };

    $scope.matchesFianzas = function (parWord) {
      $scope.fianza_data = [];
      if (parWord) {
        if (parWord.val.length >= 3) {
          $http({
            method: "GET",
            url: url.IP + "seeker-fianzas/",
            params: {
              cadena: parWord.val,
            },
          }).then(function success(request) {
            var source = [];
            var fianzas = request.data.results;
            fianzas.forEach(function (item) {
              var obj = {
                label:
                  item.fianza_number != null
                    ? item.fianza_number
                    : item.internal_number,
                value: item,
              };
              source.push(obj);
            });
            $scope.fianza_data = source;
          });
        }
      }
    };

    $scope.matchesPolicies = function (parWord) {
      $scope.policies_data = [];
      if (parWord) {
        if (parWord.val.length >= 3) {
          $http({
            method: "GET",
            url: url.IP + "seeker-policies/",
            params: {
              cadena: parWord.val,
            },
          }).then(function success(request) {
            var source = [];
            var policies = request.data.results;
            policies.forEach(function (item) {
              var obj = {
                label: item.poliza_number,
                value: item,
              };
              source.push(obj);
            });
            $scope.policies_data = source;
          });
        }
      }
    };

    $scope.addShared = function () {
      $scope.obj = {
        aseguradora: "",
        contratante_fisico: "",
        contratante_moral: "",
        grupo_de_contratantes: "",
        fianza: "",
        poliza: "",
      };
      $scope.shareds.push($scope.obj);
    };

    $scope.deleteShared = function (idx) {
      $scope.shareds.splice(idx, 1);
    };

    $scope.saveShared = function () {
      $scope.shareds.forEach(function (item) {
        $scope.params = {
          aseguradora: item.aseguradora ? item.aseguradora.url : "",
          contratante_fisico: item.contratante
            ? item.contratante.val
              ? item.contratante.value.type_person == "Fisica"
                ? item.contratante.value.url
                : ""
              : ""
            : "",
          contratante_moral: item.contratante
            ? item.contratante.val
              ? item.contratante.value.type_person == "Moral"
                ? item.contratante.value.url
                : ""
              : ""
            : "",
          fianza: item.fianza
            ? item.fianza.val
              ? item.fianza.value.url
              : ""
            : "",
          grupo: $scope.selectUser == "grupo" ? $scope.valueUser.url : "",
          grupo_de_contratantes: item.grupo
            ? item.grupo.val
              ? item.grupo.value.url
              : ""
            : "",
          poliza: item.poliza
            ? item.poliza.val
              ? item.poliza.value.url
              : ""
            : "",
          usuario:
            $scope.selectUser == "usuario" ? $scope.userSelected.url : "",
          org: $scope.url_go,
        };
        $http
          .post(url.IP + "shared/", $scope.params)
          .then(function (response) {});
      });
      SweetAlert.swal(
        "¡Listos!",
        "La asignación se ha realizado con éxito.",
        "success"
      );
      $state.go("filtro.lista");
    };
  }
})();

angular.module("inspinia").filter("reverse", function () {
  return function (items) {
    if (items) {
      return items.slice().reverse();
    }
  };
});

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("FianzasReclamacionesInfoCtrl", FianzasReclamacionesInfoCtrl);

  FianzasReclamacionesInfoCtrl.$inject = [
    "$timeout",
    "url",
    "FileUploader",
    "$stateParams",
    "dataFactory",
    "$scope",
    "$http",
    "SweetAlert",
    "$sessionStorage",
    "$uibModal",
    "$state",
  ];

  function FianzasReclamacionesInfoCtrl(
    $timeout,
    url,
    FileUploader,
    $stateParams,
    dataFactory,
    $scope,
    $http,
    SweetAlert,
    $sessionStorage,
    $uibModal,
    $state
  ) {
    var vm = this;
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    activate();

    function activate() {
      dataFactory
        .get("claims-list/" + $stateParams.claimId + "/")
        .then(function success(response) {
          vm.insurance = response.data;
          dataFactory
            .get("claims/" + vm.insurance.id + "/archivos/")
            .then(function success(response) {
              $scope.files = response.data.results;
              vm.files = response.data.results;
            });
          $http.get(response.data.poliza.url).then(function success(response1) {
            vm.insurance.poliza = response1.data;
            $http.get(response1.data.subramo).then(function success(response3) {
              vm.insurance.poliza.subramo = response3.data.subramo_name;
            });
            $http
              .get(response1.data.contractor)
              .then(function success(response4) {
                vm.insurance.poliza.contractor = response4.data;
              });
            $http
              .get(response1.data.aseguradora)
              .then(function success(response2) {
                vm.insurance.poliza.aseguradora = response2.data.alias;
              });
          });
        });
    }

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          vm.acceso_fianzas = perm;
          vm.acceso_fianzas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            } else if (acc.permission_name == "Cancelar fianzas") {
              if (acc.checked == true) {
                vm.acceso_canc_fia = true;
              } else {
                vm.acceso_canc_fia = false;
              }
            } else if (acc.permission_name == "Eliminar fianzas") {
              if (acc.checked == true) {
                vm.acceso_elim_fia = true;
              } else {
                vm.acceso_elim_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                vm.acceso_canc_ot = true;
              } else {
                vm.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar OTs") {
              if (acc.checked == true) {
                vm.acceso_elim_ot = true;
              } else {
                vm.acceso_elim_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }

    $scope.status = function (parStatus) {
      switch (parStatus) {
        case 1:
          return "Presentación";
          break;
        case 2:
          return "En integración";
          break;
        case 3:
          return "Reclamo Formal";
          break;
        case 4:
          return "Respuesta afianzadora";
          break;
        case 5:
          return "Respuesta cliente";
          break;
        case 6:
          return "Reconsideración";
          break;
        case 7:
          return "Rechazada";
          break;
        case 8:
          return "Pagada";
          break;
        case 9:
          return "Desistimiento";
          break;
        case 10:
          return "Recuperación";
          break;
        case 11:
          return "Cerrada";
          break;
        default:
          return "Pendiente";
          break;
      }
    };

    $scope.type = function (parType) {
      switch (parType) {
        case 1:
          return "Aviso Previo";
          break;
        case 2:
          return "Reclamo Formal";
          break;
        case 3:
          return "Reconsideración";
          break;
        default:
          return "Sin tipo";
      }
    };

    $scope.getLog = function () {
      dataFactory
        .get("get-specific-log", { model: 13, associated_id: vm.insurance.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
        });
    };

    $scope.changeStatus = function (parStatus) {
      $http
        .patch(vm.insurance.url, { status: parStatus })
        .then(function success(response) {
          activate();
          SweetAlert.swal("Hecho", "Se ha actualizado el estatus", "success");
        });
    };

    $scope.deleteFianza = function (item) {
      SweetAlert.swal(
        {
          title: "Eliminar Reclamo",
          text: "Se eliminará la reclamación y no se podrá recuperar después, ¿Estás Seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(item.url).then(function (response) {
              if (response.status == 204) {
                SweetAlert.swal(
                  "¡Listo!",
                  "Reclamación eliminada exitosamente.",
                  "success"
                );
                $state.go("fianzas.reclist");
              }
            });
          }
        }
      );
    };
    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });
    /* Alerta success uploadfiles */
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $state.go("fianzas.reclinf", { claimId: vm.insurance.id });
        $state.reload();
      }
    };

    /* Alerta error uploadfiles */
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };
    $scope.saveFiles = function (param) {
      $scope.countFile = $scope.uploader.queue.length;
      uploadFiles(param.id);
    };
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };
    $scope.saveFile = function (file) {
      var urls = file.url;
      if (urls == undefined) {
        urls = url.IP + "polizas/" + file.owner + "/archivos/" + file.id;
      }
      $http.patch(urls, { nombre: file.nombre, sensible: file.sensible });
    };
    function uploadFiles(reclamacionId) {
      $scope.userInfo = {
        id: reclamacionId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "claims/" + reclamacionId + "/archivos/";
      $scope.files = [];
      $scope.uploader.uploadAll();
      activate();
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("FianzasReclamacionesListCtrl", FianzasReclamacionesListCtrl);

  FianzasReclamacionesListCtrl.$inject = [
    "SweetAlert",
    "toaster",
    "$sessionStorage",
    "$scope",
    "FileUploader",
    "dataFactory",
    "$http",
    "url",
    "$parse",
    "datesFactory",
    "$localStorage",
    "appStates",
    "$state",
  ];

  function FianzasReclamacionesListCtrl(
    SweetAlert,
    toaster,
    $sessionStorage,
    $scope,
    FileUploader,
    dataFactory,
    $http,
    url,
    $parse,
    datesFactory,
    $localStorage,
    appStates,
    $state
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };

    $scope.cur_date = new Date();
    $scope.init_date = datesFactory.convertDate(new Date());
    $scope.end_date = datesFactory.convertDate(new Date());
    vm.email = "";

    $scope.countFile = 0;
    $scope.okFile = 0;
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          vm.acceso_fianzas = perm;
          vm.acceso_fianzas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    vm.show_binnacle_claim = false;
    vm.showBinnacle = showBinnacle;
    vm.returnToFianzaR = returnToFianzaR;

    $scope.statuses = [
      { id: 0, name: "Todos" },
      { id: 1, name: "Presentación" },
      { id: 2, name: "Integración" },
      { id: 3, name: "Reclamo Formal" },
      { id: 4, name: "Respuesta afianzadora" },
      { id: 5, name: "Respuesta cliente" },
      { id: 6, name: "Reconsideración" },
      { id: 7, name: "Rechazada" },
      { id: 8, name: "Pagada" },
      { id: 9, name: "Desistimiento" },
      { id: 10, name: "Recuperación" },
      { id: 11, name: "Cerrada" },
    ];

    activate();

    $scope.consultar = function () {
      activate();
    };

    function activate() {
      // dataFactory.get('claims-list')
      $http({
        method: "GET",
        url: url.IP + "claims-list/",
        params: {
          status: 0,
          init_date: datesFactory.toDate($scope.init_date),
          end_date: datesFactory.toDate($scope.end_date),
        },
      }).then(function success(response) {
        $scope.claims = response.data.results;

        $scope.search_results = {
          count: response.data.count,
          previous: response.data.previous,
          next: response.data.next,
        };
        $scope.testPagination("$scope.claims", "search_results");
        vm.show_pag_search = true;
      });

      if ($localStorage.saved_filters_reclamaciones) {
        if ($localStorage.saved_filters_reclamaciones["id"]) {
          $scope.statuses.forEach(function (item) {
            if (item.id == $localStorage.saved_filters_reclamaciones["id"]) {
              $scope.searchStatus = item;
            }
          });
          $scope.init_date =
            $localStorage.saved_filters_reclamaciones &&
            $localStorage.saved_filters_reclamaciones["init_date"]
              ? $localStorage.saved_filters_reclamaciones["init_date"]
              : datesFactory.convertDate(new Date());
          $scope.end_date =
            $localStorage.saved_filters_reclamaciones &&
            $localStorage.saved_filters_reclamaciones["end_date"]
              ? $localStorage.saved_filters_reclamaciones["end_date"]
              : datesFactory.convertDate(new Date());
        }
      }
    }

    $scope.selectSurety = function (item) {
      $state.go("fianzas.reclinf", { claimId: item.id });
    };

    $scope.ShowContextMenu = function (name, id) {
      $scope.name_for_new_tab = name;
      $scope.id_for_new_tab = id;
      $scope.route_for_new_tab = "fianzas.reclinf";
    };

    $scope.open_new_tab = function () {
      var existe = false;
      appStates.states.forEach(function (state) {
        if (
          state.route == $scope.route_for_new_tab &&
          state.id == $scope.id_for_new_tab
        ) {
          existe = true;
        }
      });
      if (appStates.states.length > 3) {
        SweetAlert.swal("Error", "No se pueden abrir más pestañas.", "error");
      } else {
        if (!existe) {
          appStates.states.push({
            id: $scope.id_for_new_tab,
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab, {
              claimId: $scope.id_for_new_tab,
            }),
          });
          $localStorage.tab_states = appStates.states;
          $localStorage.tab_index = $localStorage.tab_states.length - 1;
        }
      }
    };

    $scope.change_init_date = function (param) {
      $scope.init_date = param;
    };

    $scope.change_end_date = function (param) {
      $scope.end_date = param;
    };

    $scope.getStatus = function (param) {
      $http({
        method: "GET",
        url: url.IP + "claims-list/",
        params: {
          status: param ? param.id : 0,
          init_date: datesFactory.toDate($scope.init_date),
          end_date: datesFactory.toDate($scope.end_date),
        },
      }).then(function success(response) {
        if (response.data.count == 0) {
          toaster.warning("No se encontraron registros");
        }
        $scope.claims = response.data.results;

        $scope.search_results = {
          count: response.data.count,
          previous: response.data.previous,
          next: response.data.next,
        };
        $scope.testPagination("$scope.claims", "search_results");
        vm.show_pag_search = true;
      });

      $localStorage.saved_filters_reclamaciones = angular.copy(param);
      $localStorage.saved_filters_reclamaciones["status"] = $scope.searchStatus;
      $localStorage.saved_filters_reclamaciones["init_date"] = $scope.init_date;
      $localStorage.saved_filters_reclamaciones["end_date"] = $scope.end_date;
    };

    $scope.makeReport = function (param) {
      $http({
        method: "GET",
        url: url.IP + "claims-list-report/",
        params: {
          status: param ? param.id : 0,
          init_date: datesFactory.toDate($scope.init_date),
          end_date: datesFactory.toDate($scope.end_date),
          email: vm.email && vm.email.length > 0 ? vm.email : 0,
        },
      })
        .then(function success(response) {
          if (response.status == 200) {
            // Conexión a socket.io
            var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
            // var socket = io.connect("http://127.0.0.1:8080");
            socket.emit("subscribe", response.data);
            // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
            socket.on(response.data, function (url) {
              // vm.main.notifications['count']  +=1;
              var notificacion = {
                title: "El reporte solicitado ha sido generado",
                description: url,
                model: 26,
                id_reference: 0,
              };
              dataFactory
                .post("notificaciones/", notificacion)
                .then(function success(response) {
                  SweetAlert.swal({
                    title: "El reporte está listo para descargar",
                    icon: "success",
                    text: "Encuentra la liga de descarga en la sección de notificaciones",
                    timer: 5000,
                  });
                  socket.disconnect();
                })
                .catch(function (err) {
                  socket.disconnect();
                });
            });
            toaster.info(
              "Generando...",
              "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
            );
          } else {
            toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
          }
        })
        .catch(function (error) {
          toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
        });
    };

    function showBinnacle(param) {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 21,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_claim = request.data.results;
          vm.comments_config_claim = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      vm.reclamacion_id = param.id;
      vm.show_binnacle_claim = true;
    }
    function returnToFianzaR() {
      vm.show_binnacle_claim = false;
    }
    $scope.status = function (parStatus) {
      switch (parStatus) {
        case 1:
          return "Presentación";
          break;
        case 2:
          return "En integración";
          break;
        case 3:
          return "Reclamo Formal";
          break;
        case 4:
          return "Respuesta afianzadora";
          break;
        case 5:
          return "Respuesta cliente";
          break;
        case 6:
          return "Reconsideración";
          break;
        case 7:
          return "Rechazada";
          break;
        case 8:
          return "Pagada";
          break;
        case 9:
          return "Desistimiento";
          break;
        case 10:
          return "Pendiente";
          break;
        case 11:
          return "Cerrada";
          break;
      }
    };

    $scope.type = function (parType) {
      switch (parType) {
        case 1:
          return "Aviso Previo";
          break;
        case 2:
          return "Reclamo Formal";
          break;
        case 3:
          return "Reconsideración";
          break;
        default:
          return "Sin tipo";
      }
    };

    /* Alerta success uploadfiles */
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.uploader.queue.length) {
        if ($scope.checkRegister) {
          $scope.registerEndorsement(vm.newEndorsement);
        } else {
          SweetAlert.swal("Hecho", "Se ha creado la reclamación", "success");
        }
      }
    };

    /* Alerta error uploadfiles */
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      l.stop();
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + endorsementId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.selectPage = function (parPage) {
        var url = "";
        if (config_.next || config_.previous) {
          if (config_.next) {
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            url = config_.next.substring(0, config_.next.indexOf("&page=") + 6);
            url += parPage.toString();

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            url = "";
            var otherParameters = config_.previous.substring(
              config_.previous.indexOf("&page=") + 6
            );

            if (config_.previous.search("&page=") !== -1) {
              url = config_.previous.substring(
                0,
                config_.previous.indexOf("&page=") + 6
              );
              url += parPage.toString();
            } else {
              url = config_.previous;
            }

            if (config_.previous.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }

        getProviders(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;
        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      $scope.lastPage = function () {
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      function getProviders(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(response) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, response.data.results);

              var data = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };

              $scope.claims = response.data.results;

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ReclamacionEditCtrl", ReclamacionEditCtrl);

  ReclamacionEditCtrl.$inject = [
    "$stateParams",
    "$state",
    "$sessionStorage",
    "$scope",
    "FileUploader",
    "dataFactory",
    "$http",
    "datesFactory",
    "SweetAlert",
    "url",
    "$timeout",
    "MESSAGES",
    "$localStorage",
    "appStates",
  ];

  function ReclamacionEditCtrl(
    $stateParams,
    $state,
    $sessionStorage,
    $scope,
    FileUploader,
    dataFactory,
    $http,
    datesFactory,
    SweetAlert,
    url,
    $timeout,
    MESSAGES,
    $localStorage,
    appStates
  ) {
    var vm = this;

    $scope.types_options = [
      {
        label: "Aviso previo",
        id: 1,
      },
      {
        label: "Reclamo Formal",
        id: 2,
      },
      {
        label: "Reconsideración",
        id: 3,
      },
    ];

    $scope.status_options = [
      {
        label: "Presentación",
        id: 1,
      },
      {
        label: "En integración",
        id: 2,
      },
      {
        label: "Reclamo Formal",
        id: 3,
      },
      {
        label: "Respuesta Afianzadora",
        id: 4,
      },
      {
        label: "Respuesta Cliente",
        id: 5,
      },
      {
        label: "Reconsideración",
        id: 6,
      },
      {
        label: "Rechazada",
        id: 7,
      },
      {
        label: "Pagada",
        id: 8,
      },
      {
        label: "Desistimiento",
        id: 9,
      },
      {
        label: "Recuperación",
        id: 10,
      },
      {
        label: "Cerrada",
        id: 11,
      },
    ];
    vm.contacts = [];
    vm.form = {
      presentacion: datesFactory.convertDate(new Date()),
    };

    $scope.infoUser = $sessionStorage.infoUser;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          vm.acceso_fianzas = perm;
          vm.acceso_fianzas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    uploader.filters.push({
      name: "customFilter",
      fn: function (item, options) {
        return this.queue.length < 20;
      },
    });

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    uploader.filters.push({
      name: "customFilter",
      fn: function (item, options) {
        return this.queue.length < 20;
      },
    });

    activate();

    function activate() {
      dataFactory
        .get("claims-list/" + $stateParams.reclId + "/")
        .then(function success(response) {
          vm.form = response.data;
          dataFactory
            .get("claims/" + vm.form.id + "/archivos/")
            .then(function success(response) {
              $scope.files = response.data.results;
              vm.files = response.data.results;
            });
          dataFactory
            .get("leer-fianzas-info/" + response.data.poliza.id)
            .then(function success(response) {
              $scope.fianza = response.data;
              vm.selected_affect = {};
              vm.selected_affect.val = $scope.fianza
                .beneficiaries_poliza_many[0].j_name
                ? $scope.fianza.beneficiaries_poliza_many[0].j_name
                : $scope.fianza.beneficiaries_poliza_many[0].full_name +
                  " - Fianza: " +
                  $scope.fianza.poliza_number;
              vm.selected_affect.value = $scope.fianza
                .beneficiaries_poliza_many[0].j_name
                ? $scope.fianza.beneficiaries_poliza_many[0].j_name
                : $scope.fianza.beneficiaries_poliza_many[0].full_name +
                  " - Fianza: " +
                  $scope.fianza.poliza_number;
              var autocomplete = document.getElementById("autocomplete");
              var autocomplete2 = document.getElementById("id");
              var buttons = document.getElementById("buttonsearch");
              try {
                autocomplete.disabled = true;
                autocomplete2.disabled = true;
              } catch (u) {}
              buttons.disabled = true;
            });
          vm.form.presentacion = datesFactory.convertDate(
            vm.form.introduction_date
          );
        });
    }

    $scope.saveClaim = function () {
      vm.form.introduction_date = new Date(
        datesFactory.toDate(vm.form.presentacion)
      );
      vm.form.poliza = $scope.fianza.url;
      vm.form.benefited = $scope.benefited;

      dataFactory
        .update("claims/" + vm.form.id + "/", vm.form)
        .then(function success(response) {
          if (response.status == 200 || response.status == 201) {
            $scope.reclamacion = response.data;
            var params = {
              model: 13,
              event: "POST",
              associated_id: $scope.fianza.id,
              identifier:
                "actualizo la reclamación No." + response.data.number + ".",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            SweetAlert.swal(
              "Hecho",
              "Se ha actualizado la reclamación",
              "success"
            );
            $scope.countFile = $scope.uploader.queue.length;
            if ($scope.uploader.queue.length == 0) {
              var name = "Reclamación Fianza";
              var route = "fianzas.reclinf";

              $scope.name_for_new_tab = name;
              $scope.route_for_new_tab = route;

              var existe = false;
              if (name && route) {
                $scope.route_for_new_tab = route;
                $scope.name_for_new_tab = name;
                appStates.states.forEach(function (state) {
                  if (state.route == $scope.route_for_new_tab) {
                    existe = true;
                  }
                });
              }

              if (!existe) {
                var active_tab = appStates.states.findIndex(function (item) {
                  if (item.active) {
                    return true;
                  }
                  return false;
                });

                appStates.states[active_tab] = {
                  name: $scope.name_for_new_tab,
                  heading: $scope.name_for_new_tab,
                  route: $scope.route_for_new_tab,
                  active: true,
                  isVisible: true,
                  href: $state.href($scope.route_for_new_tab),
                };
              }
              $localStorage.tab_states = appStates.states;

              $state.go($scope.route_for_new_tab, {
                claimId: response.data.id,
              });
            } else {
              uploadFiles(response.data.id);
            }
          }
        });
    };

    /* Alerta success uploadfiles */
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $state.go("fianzas.reclinf", { claimId: $scope.reclamacion.id });
      }
    };

    /* Alerta error uploadfiles */
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(reclamacionId) {
      $scope.userInfo = {
        id: reclamacionId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "claims/" + reclamacionId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }
  }
})();

/* global angular */
(function () {
  "use strict";
  /* jshint devel: true */

  angular
    .module("inspinia")
    .controller("FianzasProgramaListCtrl", FianzasProgramaListCtrl);

  FianzasProgramaListCtrl.$inject = [
    "datesFactory",
    "dataFactory",
    "SweetAlert",
    "url",
    "ContratanteService",
    "groupService",
    "contactService",
    "generalService",
    "FileUploader",
    "toaster",
    "helpers",
    "globalVar",
    "MESSAGES",
    "$uibModal",
    "$filter",
    "$scope",
    "$rootScope",
    "$localStorage",
    "$timeout",
    "$q",
    "$state",
    "$sessionStorage",
    "$location",
    "$http",
    "$parse",
    "exportFactory",
    "PersistenceFactory",
  ];

  function FianzasProgramaListCtrl(
    datesFactory,
    dataFactory,
    SweetAlert,
    url,
    ContratanteService,
    groupService,
    contactService,
    generalService,
    FileUploader,
    toaster,
    helpers,
    globalVar,
    MESSAGES,
    $uibModal,
    $filter,
    $scope,
    $rootScope,
    $localStorage,
    $timeout,
    $q,
    $state,
    $sessionStorage,
    $location,
    $http,
    $parse,
    exportFactory,
    PersistenceFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var orgParam = { params: { org: $localStorage.orgId } };
    // show / hide buttons
    $scope.fisicas = true;
    $scope.morales = false;
    $scope.flagPhone = false;
    $scope.responsables_natural = [];
    $scope.responsables_juridical = [];

    var vm = this;
    vm.org_name = usr.org;
    vm.Consultar = Consultar;
    vm.table = {};
    vm.changeTypePerson = changeTypePerson;

    vm.closeDropdown = closeDropdown;
    vm.order_asc = false;
    vm.listDocument = [
      {
        id: 1,
        name: "Identificación Oficial",
        value: false,
        file: false,
        arch: {},
      },
      { id: 2, name: "CURP", value: false, file: false, arch: {} },
      {
        id: 3,
        name: "Comprobante de Inscripción de Firma Electrónica",
        value: false,
        file: false,
        arch: {},
      },
      {
        id: 4,
        name: "Comprobante de Domicilio",
        value: false,
        file: false,
        arch: {},
      },
      {
        id: 5,
        name: "Formato de Identificación de Cliente Firmado",
        value: false,
        file: false,
        arch: {},
      },
      { id: 6, name: "Poder", value: false, file: false, arch: {} },
    ];
    if (vm.org_name == "ancora") {
      vm.listDocument = [
        {
          id: 1,
          name: "Identificación Oficial",
          value: false,
          file: false,
          arch: {},
        },
        { id: 2, name: "CURP", value: false, file: false, arch: {} },
        {
          id: 3,
          name: "Comprobante de Inscripción de Firma Electrónica",
          value: false,
          file: false,
          arch: {},
        },
        {
          id: 4,
          name: "Comprobante de Domicilio",
          value: false,
          file: false,
          arch: {},
        },
        {
          id: 5,
          name: "Formato de Identificación de Cliente Firmado",
          value: false,
          file: false,
          arch: {},
        },
      ];
    }
    $scope.infoUser = $sessionStorage.infoUser;
    $scope.onlyFianzas = function (q) {
      if (vm.form.only_sureties || vm.juridicalForm.only_sureties) {
        if (q == 1) {
          vm.listDocument.push(
            {
              id: 7,
              name: "Carta nombramiento",
              value: false,
              file: false,
              arch: {},
            },
            { id: 8, name: "Currículo", value: false, file: false, arch: {} },
            {
              id: 9,
              name: "Contrato multiple de la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            { id: 10, name: "Carta buro", value: false, file: false, arch: {} },
            {
              id: 11,
              name: "Entrevista con la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            { id: 12, name: "RFC", value: false, file: false, arch: {} },
            {
              id: 13,
              name: "Recibos de nomina",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 14,
              name: "Declaración anual completa con cadena de los últimos dos años inmediatos anteriores",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 15,
              name: "Estados financieros anuales del año inmediato anterior",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 16,
              name: "Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 17,
              name: "Alta ante hacienda o alta electrónica",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 18,
              name: "Escritura de inmueble",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 19,
              name: "Boleta predial o avaluó",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 20,
              name: "Certificado de libertad de gravamen",
              value: false,
              file: false,
              arch: {},
            }
          );
        } else if (q == 2) {
          vm.listDocument.push(
            {
              id: 7,
              name: "Currículo reciente",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 8,
              name: "Contrato multiple de la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            { id: 9, name: "Carta Buró", value: false, file: false, arch: {} },
            {
              id: 10,
              name: "Cuestionario o entrevista",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 11,
              name: "Aviso de privacidad de la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 12,
              name: "Protocolizaciones",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 13,
              name: "Alta de empresa ante hacienda",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 14,
              name: "Cambio de domicilio ante hacienda",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 15,
              name: "Copia del comprobante de inscripción para la e.firma (firma electrónica)",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 16,
              name: "Declaración anual completa con cadena, de los últimos dos años",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 17,
              name: "Estados financieros dictaminados cuadernillo completo, del año inmediato anterior",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 18,
              name: "Estados financieros parciales los más recientes de este año con no mayor antigüedad de dos meses",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 19,
              name: "Escritura de inmueble",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 20,
              name: "Boleta predial o avaluó",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 21,
              name: "Certificado de libertad de gravamen",
              value: false,
              file: false,
              arch: {},
            }
          );
        }
      } else {
        if (q == 1) {
          vm.listDocument = [
            {
              id: 1,
              name: "Identificación Oficial",
              value: false,
              file: false,
              arch: {},
            },
            { id: 2, name: "CURP", value: false, file: false, arch: {} },
            {
              id: 3,
              name: "Comprobante de Inscripción de Firma Electrónica",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Formato de Identificación de Cliente Firmado",
              value: false,
              file: false,
              arch: {},
            },
            { id: 6, name: "Poder", value: false, file: false, arch: {} },
          ];
          if (vm.org_name == "ancora") {
            vm.listDocument = [
              {
                id: 1,
                name: "Identificación Oficial",
                value: false,
                file: false,
                arch: {},
              },
              { id: 2, name: "CURP", value: false, file: false, arch: {} },
              {
                id: 3,
                name: "Comprobante de Inscripción de Firma Electrónica",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 4,
                name: "Comprobante de Domicilio",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 5,
                name: "Formato de Identificación de Cliente Firmado",
                value: false,
                file: false,
                arch: {},
              },
            ];
          }
        } else if (q == 2) {
          vm.listDocument = [
            {
              id: 1,
              name: "Acta Constitutiva",
              value: false,
              file: false,
              arch: {},
            },
            { id: 2, name: "RFC", value: false, file: false, arch: {} },
            {
              id: 3,
              name: "Cédula de Identificación Fiscal",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio Fiscal",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Modificaciones al Acta Constitutiva",
              value: false,
              file: false,
              arch: {},
            },
            { id: 6, name: "Poder", value: false, file: false, arch: {} },
          ];
        }
      }
    };
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    $scope.sucursal = function (sc) {};

    $scope.docs = {};
    $scope.type = function (r) {
      if (r == 1) {
        vm.listDocument = [
          {
            id: 1,
            name: "Identificación Oficial",
            value: false,
            file: false,
            arch: {},
          },
          { id: 2, name: "CURP", value: false, file: false, arch: {} },
          {
            id: 3,
            name: "Comprobante de Inscripción de Firma Electrónica",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 4,
            name: "Comprobante de Domicilio",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 5,
            name: "Formato de Identificación de Cliente Firmado",
            value: false,
            file: false,
            arch: {},
          },
          { id: 6, name: "Poder", value: false, file: false, arch: {} },
        ];
        if (vm.org_name == "ancora") {
          vm.listDocument = [
            {
              id: 1,
              name: "Identificación Oficial",
              value: false,
              file: false,
              arch: {},
            },
            { id: 2, name: "CURP", value: false, file: false, arch: {} },
            {
              id: 3,
              name: "Comprobante de Inscripción de Firma Electrónica",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Formato de Identificación de Cliente Firmado",
              value: false,
              file: false,
              arch: {},
            },
          ];
        }
        $scope.type_person_selected = r;
      } else if (r == 2) {
        vm.listDocument = [
          {
            id: 1,
            name: "Acta Constitutiva",
            value: false,
            file: false,
            arch: {},
          },
          { id: 2, name: "RFC", value: false, file: false, arch: {} },
          {
            id: 3,
            name: "Cédula de Identificación Fiscal",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 4,
            name: "Comprobante de Domicilio Fiscal",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 5,
            name: "Modificaciones al Acta Constitutiva",
            value: false,
            file: false,
            arch: {},
          },
          { id: 6, name: "Poder", value: false, file: false, arch: {} },
        ];
        $scope.type_person_selected = r;
      } else {
      }
    };

    function closeDropdown() {
      $(".hasDropdown").removeClass("open");
    }

    vm.form = {
      contratante: "0",
      grupo: "",
      type_person: "0",
      rfc: "0",
      vendedor: "",
    };

    $scope.contractorNew = [];

    $scope.userInfo = {
      type_person: "",
      id: 0,
    };
    vm.user = usr;

    vm.table = {
      headers: ["Nombre", "Tipo", "Acciones"],
    };
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    vm.address_type = [
      {
        name: "Dirección Personal",
        id: 0,
      },
      {
        name: "Dirección Fiscal",
        id: 1,
      },
      {
        name: "Dirección de cobro",
        id: 2,
      },
      {
        name: "Dirección de paquetería",
        id: 3,
      },
      {
        name: "Dirección de riesgo",
        id: 4,
      },
      {
        name: "CFDI",
        id: 5,
      },
    ];

    vm.clasifications = [
      // {name: 'Pequeño', value: 1},
      // {name: 'Regular', value: 2},
      // {name: 'Grande', value: 3},
      // {name: 'Jumbo', value: 4}
    ];
    vm.celulas = [];
    vm.agrupaciones = [];

    // $(window).load(function() {
    //     $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });

    $scope.selectConditions = function (sel) {
      vm.condition_selected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.condition_selected.push(parseInt(r));
      });
    };

    function changeTypePerson(obj) {
      vm.form.type_person = obj;
      console.log("obd", obj);
    }

    function Consultar(order, parPage) {
      $localStorage.saved_filters_list_program = angular.copy(vm.form);
      $localStorage.saved_filters_list_program["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_list_program["rfc"] = vm.form.rfc;
      $localStorage.saved_filters_list_program["group"] = vm.form.group;
      $localStorage.saved_filters_list_program["type_person"] =
        vm.form.type_person;

      if (vm.order_asc) {
        vm.order_asc = false;
      } else {
        vm.order_asc = true;
      }
      if (vm.show_binnacle == true) {
        vm.show_binnacle = false;
      }
      vm.show_pagination = false;
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;
      $scope.results = true;
      vm.form.type_person = 0;
      var parUrl = url.IP + "filtros-contractor/";

      // New url fussion --
      // var parUrl = url.IP + 'filtros-contractor/';
      if (vm.form.group) {
        if (vm.form.group.val) {
          var g = vm.form.group.value;
        } else {
          var g = 0;
        }
      } else {
        var g = 0;
      }
      if (vm.form.contratante) {
        var c = vm.form.contratante;
      } else {
        var c = 0;
      }
      if (vm.form.rfc) {
        var f = vm.form.rfc;
      } else {
        var f = 0;
      }

      var params = {
        contratante: c ? c : 0,
        rfc: f ? f : 0,
        grupo: g ? g : 0,
        order: vm.order_asc ? vm.order_asc : 0,
        condicion: vm.condition_selected ? vm.condition_selected : 0,
        parPage: parPage ? parPage : 1,
        type_person: 0,
        pproveedor: true,
      };
      $http({
        method: "POST",
        url: parUrl,
        data: params,
      }).then(function success(response) {
        if (response.status == 200 && response.data.results.length) {
          vm.persons.all = response.data.results;
          // if(vm.form.type_person == 1){
          //   vm.persons.naturals = response.data.results;
          //   vm.persons.juridicals = [];
          // }
          // else if (vm.form.type_person == 2) {
          //   vm.persons.juridicals = response.data.results;
          //   vm.persons.naturals = [];
          // }
          // else {
          //   vm.persons.all = response.data.results;
          // }
          $scope.order = vm.order_asc;
          vm.persons_config = {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          };
          $scope.personn_config = {
            count: response.data.count,
            previous: parUrl,
            next: parUrl,
          };
          vm.show_pagination = true;
          $scope.testPagination("vm.persons.naturals", "personn_config");
        } else {
          toaster.warning("No se encontraron registros");
          vm.persons.naturals = [];
        }
      });
    }

    vm.exportDataE = exportDataE;
    vm.hoy = new Date();

    function exportDataE(param) {
      var parUrl = url.IP + "service_reporte-contractorpp-excel";
      if (vm.form.group) {
        var g = vm.form.group.value;
      } else {
        var g = 0;
      }
      if (vm.form.contratante) {
        var c = vm.form.contratante;
      } else {
        var c = 0;
      }
      if (vm.form.rfc) {
        var f = vm.form.rfc;
      } else {
        var f = 0;
      }
      var params = {
        contratante: c,
        rfc: f,
        grupo: g,
        order: vm.order_asc,
        condicion: vm.condition_selected ? vm.condition_selected : 0,
        type_person: 0,
        pproveedor: true,
      };
      $http({
        method: "POST",
        url: parUrl,
        data: params,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function (data, status, headers, config) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Contratantes.xls");
        })
        .catch(function (e) {
          console.log("e", e);
        });
      // }). then(function success(response) {
      //   if(response.status === 200) {
      //    exportFactory.excel(response.data, 'Contratantes');
      // }
      //  })
    }

    $scope.matchesGroup = function (parWord, parType) {
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        var word_data = vm.form.group.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    };

    $scope.selectRfc = function (rfc) {
      vm.form.rfc = rfc.replace(/-/g, "");
    };
    vm.search = search;
    function search(cadena) {
      vm.show_binnacle = false;
      vm.show_pagination = false;
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;

      if (cadena.length) {
        $http({
          method: "GET",
          url: url.IP + "seeker-contractors/",
          params: {
            cadena: cadena,
            type_person: 1,
          },
        })
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.persons.juridicals = [];
                vm.persons.naturals = [];
                vm.persons = [];
                vm.persons.naturals = request.data.results;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });

        $http({
          method: "GET",
          url: url.IP + "seeker-juridicals/",
          params: {
            cadena: cadena,
            type_person: 2,
          },
        })
          .then(
            function success(request) {
              vm.persons.naturals = [];
              vm.persons.juridicals = [];
              if (request.status === 200) {
                vm.persons.naturals = [];
                vm.persons.juridicals = [];
                vm.persons = [];
                vm.persons.juridicals = request.data.results;
                vm.juridicals_config = {
                  count: request.data.count,
                  next: request.data.next,
                  previous: request.data.previous,
                };
                vm.show_pag_juridicals = true;
                vm.buttonsJuridicals = true;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else {
        vm.persons.juridicals = [];
        vm.persons.naturals = [];
      }
    }

    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      // if ($uibModalInstance) {
      //     $uibModalInstance.dismiss('cancel');
      // }
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWCONTRACTOR, "success");
          if ($location.path() == "/contratantes/crear") {
            if (vm.acceso_ver_cont) {
              $state.go("contratantes.info", {
                type:
                  $scope.contractorNew.type_person == "Fisica"
                    ? "fisicas"
                    : "morales",
                contratanteId: $scope.contractorNew.id,
              });
            } else {
              $state.go("index.main");
            }
          } else if ($location.path() == "/colectividades/") {
            var params = { myInsurance: $scope.contractorNew };
            $state.go("colectividades.main", params);
          } else if ($location.path() == "/fianzas/") {
            $rootScope.show_contractor = false;
            // var params = { 'myInsurance': $scope.contractorNew }
            // $state.go('fianzas.fianzas', params);
          } else {
            $rootScope.show_contractor = false;
            var params = { myInsurance: $scope.contractorNew };
            $state.go("polizas.create", params);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        name: fileItem.file.name,
      });
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].name = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };
    //archivos lista documentos
    $scope.addFileList = function (index, lista, file, xy) {
      var extension = file[0].formData[0].name.split(".")[1];
      file[0].formData[0].name = vm.listDocument[index].name + "." + extension;
      vm.listDocument[index].arch = file[0];
      vm.listDocument[index].file = true;
      $scope.uploaderDocument.queue = [];
    };
    var uploaderDocument = ($scope.uploaderDocument = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploaderDocument.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploaderDocument.onSuccessItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      // if ($uibModalInstance) {
      //     $uibModalInstance.dismiss('cancel');
      // }
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWCONTRACTOR, "success");
          if ($location.path() == "/contratantes/crear") {
            if (vm.acceso_ver_cont) {
              $state.go("contratantes.info", {
                type:
                  $scope.contractorNew.type_person == "Fisica"
                    ? "fisicas"
                    : "morales",
                contratanteId: $scope.contractorNew.id,
              });
            } else {
              $state.go("index.main");
            }
          } else if ($location.path() == "/colectividades/") {
            var params = { myInsurance: $scope.contractorNew };
            $state.go("colectividades.main", params);
          } else if ($location.path() == "/fianzas/") {
            $rootScope.show_contractor = false;
            // var params = { 'myInsurance': $scope.contractorNew }
            // $state.go('fianzas.fianzas', params);
          } else {
            $rootScope.show_contractor = false;
            var params = { myInsurance: $scope.contractorNew };
            $state.go("polizas.create", params);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploaderDocument.onErrorItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploaderDocument.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        name: fileItem.file.name,
      });
    };

    uploaderDocument.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].name = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };
    //archivos lista docuemntos
    function uploadFilesList(typePerson, idPerson) {
      $scope.userInfo = {
        id: idPerson,
      };
      // $scope.userInfo.url = url.IP + checkType(typePerson) + '/' + idPerson + '/archivos/';
      $scope.userInfo.url =
        url.IP + "contractors" + "/" + idPerson + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploaderDocument.uploadAll();
      }, 1000);
    }
    //archivos lista docuemntos
    function uploadFiles(typePerson, idPerson) {
      $scope.userInfo = {
        id: idPerson,
      };
      // $scope.userInfo.url = url.IP + checkType(typePerson) + '/' + idPerson + '/archivos/';
      $scope.userInfo.url =
        url.IP + "contractors" + "/" + idPerson + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    // Contractor
    vm.persons = [];
    vm.checkRFC = checkRFC;
    vm.cancel = cancel;
    vm.submitJuridical = submitJuridical;
    vm.checkType = checkType;
    vm.goToContractorView = goToContractorView;

    vm.control = {
      closeModal: function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      },
    };

    function goToContractorView(person) {
      console.log("d", person);
      $state.go("fianzas.pprovinfo", {
        type: checkType(person.type_person),
        contratanteId: person.id,
      });
    }

    function cancel() {
      $state.go("contratantes.main");
    }

    // Groups
    vm.groups = [];
    vm.openModalGroup = openModalGroup;
    vm.openModalAsignacion = openModalAsignacion;
    vm.openModalClasification = openModalClasification;
    vm.openModalCelulaContractor = openModalCelulaContractor;

    // Contacts
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;

    // Addresses, States and cities functions
    vm.addresses = {
      add: addAddress,
      selectedState: selectedState,
      delete: deleteAddress,
    };

    vm.statesArray = [];

    // Disabled after save
    vm.disabledAfterSave = false;
    vm.showBinnacle = showBinnacle;
    vm.returnToContractors = returnToContractors;
    //-----------------------------------------------------------comments
    function showBinnacle(param) {
      vm.show_binnacle = true;
      vm.person_id = param.id;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 2,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }
    //-------------------------------------------------------------comments

    function addAddress(type) {
      // HACK remove before production
      var address = {
        raw: "",
        street_address: "",
        intersection: "",
        political: "",
        administrative_area_level_1: "",
        administrative_area_level_1_short: "",
        administrative_area_level_2: "",
        administrative_area_level_3: "",
        colloquial_area: "",
        sublocality: "",
        neighborhood: "",
        premise: "",
        subpremise: "",
        natural_feature: "",
        country: "",
        country_code: "",
        locality: "",
        postal_code: "",
        route: "",
        street_number: "",
        street_number_int: "",
        formatted: "",
        latitude: "",
        longitude: "",
        details: "",
        composed: "",
      };
      if (type === 1) {
        vm.form.userAddresses.push(address);
      } else {
        vm.juridicalForm.userAddresses.push(address);
      }
    }

    function deleteAddress(index, type) {
      if (type === 1) {
        vm.form.userAddresses.splice(index, 1);
      } else {
        vm.juridicalForm.userAddresses.splice(index, 1);
      }
    }

    function selectedState(selected, index, type) {
      if (type === 1) {
        vm.form.userAddresses[index].city = "";
        vm.form.userAddresses[index].citiesList = selected.cities;
      } else {
        vm.juridicalForm.userAddresses[index].city = "";
        vm.juridicalForm.userAddresses[index].citiesList = selected.cities;
      }
    }

    vm.form = {
      birthday: null,
      description: "",
      first_name: "",
      last_name: "",
      rfc: "",
      second_last_name: "",
      sex: null,
      emails: [{ correo: "", email_type: "" }],
      responsables: [{ responsables: "", resp_type: "" }],
      phones: [{ phone: "", phone_type: "" }],
      userAddresses: [
        {
          raw: "",
          street_address: "",
          intersection: "",
          political: "",
          administrative_area_level_1: "",
          administrative_area_level_1_short: "",
          administrative_area_level_2: "",
          administrative_area_level_3: "",
          colloquial_area: "",
          sublocality: "",
          neighborhood: "",
          premise: "",
          subpremise: "",
          natural_feature: "",
          country: "",
          country_code: "",
          locality: "",
          postal_code: "",
          route: "",
          street_number: "",
          street_number_int: "",
          formatted: "",
          latitude: "",
          longitude: "",
          details: "",
          composed: "",
        },
      ],
      contact_natural: [],
      vendedor: "",
    };

    vm.juridicalForm = {
      userAddresses: [
        {
          raw: "",
          street_address: "",
          intersection: "",
          political: "",
          administrative_area_level_1: "",
          administrative_area_level_1_short: "",
          administrative_area_level_2: "",
          administrative_area_level_3: "",
          colloquial_area: "",
          sublocality: "",
          neighborhood: "",
          premise: "",
          subpremise: "",
          natural_feature: "",
          country: "",
          country_code: "",
          locality: "",
          postal_code: "",
          route: "",
          street_number: "",
          street_number_int: "",
          formatted: "",
          latitude: "",
          longitude: "",
          details: "",
          composed: "",
        },
      ],
      date_of_establishment: null,
      description: "",
      j_name: "",
      rfc: "",
      contact_juridical: [],
      emails: [{ email: "", email_type: "" }],
      responsables: [{ responsable: "", resp_type: "" }],
      phones: [{ phone: "", phone_type: "" }],
      vendedor: "",
    };

    activate();
    $(".js-example-basic-multiple").select2();
    vm.emptyOrNull = function (item) {
      return !(item === null || item.trim().length === 0);
    };

    vm.activate = activate;
    function activate() {
      $(".js-example-basic-multiple").select2();
      vm.form.type_person = 0;
      dataFactory
        .get("sucursales-to-show-unpag/")
        .then(function success(response) {
          $scope.sucursalList = response.data;
        });
      vm.responsables = [];
      $http.get(url.IP + "get-vendors").then(function success(request) {
        vm.vendors = request.data;
        vm.vendors.forEach(function (vendor) {
          vendor.name = vendor.first_name + " " + vendor.last_name;
        });
      });
      $scope.filesContractor = true;

      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          vm.statesArray = data.data;
          $scope.readPdf();
        });

      // groupService.getGroups()
      // .then(function(groups) {
      //     vm.groups = groups;
      // });

      $http.get(url.IP + "gruposSubgrupos-resume/").then(function (response) {
        vm.groups = response.data;
      });

      $http.get(url.IP + "usuarios/").then(function (user) {
        vm.responsables = user.data.results;
      });

      $http.get(url.IP + "groupingLevel-resume/").then(function (response) {
        vm.agrupaciones = response.data;
      });

      $http.get(url.IP + "classification/").then(function (response) {
        response.data.results.forEach(function (item) {
          vm.clasifications.push(item);
        });
      });
      $http.post(url.IP + "celula_contractor_info/").then(function (response) {
        vm.celulas = response.data;
      });
      dataFactory.get("usuarios/").then(function (user) {
        $scope.usuarios_saam = user.data.results;
      });

      if ($localStorage.saved_filters_list_program) {
        vm.form.contratante = $localStorage.saved_filters_list_program[
          "contratante"
        ]
          ? $localStorage.saved_filters_list_program["contratante"]
          : "";
        vm.form.rfc = $localStorage.saved_filters_list_program["rfc"]
          ? $localStorage.saved_filters_list_program["rfc"]
          : "";
        vm.form.group = $localStorage.saved_filters_list_program["group"]
          ? $localStorage.saved_filters_list_program["group"]
          : "";
        vm.form.type_person = $localStorage.saved_filters_list_program[
          "type_person"
        ]
          ? $localStorage.saved_filters_list_program["type_person"]
          : "";
      }
    }

    $scope.readPdf = function () {
      $scope.contratante_tipo = true;
      if ($location.path() == "/polizas/") {
        if ($rootScope.readPDF.corporation.corporation_name == null) {
          $scope.contratante_tipo = true;
          vm.form.first_name = $rootScope.readPDF.individual.first_name;
          vm.form.last_name = $rootScope.readPDF.individual.first_last_name;
          vm.form.second_last_name =
            $rootScope.readPDF.individual.second_last_name;
          vm.form.rfc = $rootScope.readPDF.individual.rfc;

          if ($rootScope.readPDF.address.state) {
            vm.statesArray.forEach(function (item) {
              if (
                sinDiacriticos(
                  $rootScope.readPDF.address.state.toLowerCase()
                ) == sinDiacriticos(item.state.toLowerCase())
              ) {
                vm.form.userAddresses[0].administrative_area_level_1 = item;
                if ($rootScope.readPDF.address.city) {
                  for (var k = 0; k < item.cities.length; k++) {
                    if (
                      sinDiacriticos(
                        $rootScope.readPDF.address.city.toLowerCase()
                      ) == sinDiacriticos(item.cities[k].city.toLowerCase())
                    ) {
                      vm.form.userAddresses[0].administrative_area_level_2 =
                        item.cities[k];
                    }
                  }
                }
              }
            });
          }

          vm.form.userAddresses[0].sublocality =
            $rootScope.readPDF.address.sublocality;
          vm.form.userAddresses[0].route = $rootScope.readPDF.address.street;
          vm.form.userAddresses[0].street_number =
            $rootScope.readPDF.address.street_number;
          vm.form.userAddresses[0].street_number_int =
            $rootScope.readPDF.address.street_number_int;
          vm.form.userAddresses[0].postal_code =
            $rootScope.readPDF.address.zip_code;
        } else {
          $scope.contratante_tipo = false;
          vm.juridicalForm.j_name =
            $rootScope.readPDF.corporation.corporation_name;
          vm.juridicalForm.rfc = $rootScope.readPDF.corporation.rfc;

          if ($rootScope.readPDF.address.state) {
            vm.statesArray.forEach(function (item) {
              if (
                sinDiacriticos(
                  $rootScope.readPDF.address.state.toLowerCase()
                ) == sinDiacriticos(item.state.toLowerCase())
              ) {
                vm.juridicalForm.userAddresses[0].administrative_area_level_1 =
                  item;
                if ($rootScope.readPDF.address.city) {
                  for (var k = 0; k < item.cities.length; k++) {
                    if (
                      sinDiacriticos(
                        $rootScope.readPDF.address.city.toLowerCase()
                      ) == sinDiacriticos(item.cities[k].city.toLowerCase())
                    ) {
                      vm.juridicalForm.userAddresses[0].administrative_area_level_2 =
                        item.cities[k];
                    }
                  }
                }
              }
            });
          }

          vm.juridicalForm.userAddresses[0].sublocality =
            $rootScope.readPDF.address.sublocality;
          vm.juridicalForm.userAddresses[0].route =
            $rootScope.readPDF.address.street;
          vm.juridicalForm.userAddresses[0].street_number =
            $rootScope.readPDF.address.street_number;
          vm.juridicalForm.userAddresses[0].street_number_int =
            $rootScope.readPDF.address.street_number_int;
          vm.juridicalForm.userAddresses[0].postal_code =
            $rootScope.readPDF.address.zip_code;
        }
      }
    };

    function sinDiacriticos(texto) {
      return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    vm.getAll = getAll;

    function getAll(param) {
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;

      if (param == "naturals" || param == undefined) {
        if (param == undefined) {
          $scope.type_person = "naturals";
        }
        var orgParam = { params: { org: $localStorage.orgId, type_person: 1 } };
        $http
          .get(url.IP + "contractor-resume/", orgParam)
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.persons.naturals = [];
                vm.persons.juridicals = [];
                vm.persons.naturals = request.data.results;
                vm.naturals_config = {
                  count: request.data.count,
                  next: request.data.next,
                  previous: request.data.previous,
                };
                vm.show_pag_naturals = true;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else if (param == "juridicals") {
        var orgParam = { params: { org: $localStorage.orgId, type_person: 2 } };
        // $http.get(url.IP + 'jrudicals-resume/', orgParam)
        $http
          .get(url.IP + "contractor-resume/", orgParam)
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.persons.juridicals = [];
                vm.persons.naturals = [];
                vm.persons.juridicals = request.data.results;
                vm.juridicals_config = {
                  count: request.data.count,
                  next: request.data.next,
                  previous: request.data.previous,
                };
                vm.show_pag_juridicals = true;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    }

    //Función getContratantes
    vm.getContratantesEs = getContratantesEs;
    function getContratantesEs(param) {
      vm.buttonsJuridicals = false;
      vm.buttonsNaturals = false;
      vm.show_binnacle = false;
      vm.show_pagination = false;
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;
      if (param == 1) {
        // $http.get(url.IP + 'fisicas-resume/' )
        $http.get(url.IP + "contractor-resume/").then(function (data) {
          //vm.results = data;
          vm.persons.juridicals = [];
          vm.persons.juridicals.length = 0;
          $scope.results = {
            data: data.data.results,
            config: {
              count: data.data.count,
              next: data.data.next,
              previous: data.data.previous,
            },
          };
          vm.persons.naturals = $scope.results.data;
          $scope.testPagination("vm.persons.naturals", "results.config");
        });
        //return vm.persons.naturals;
        $scope.show_pagination = true;
        vm.persons = [];
      } else if (param == 2) {
        // $http.get(url.IP + 'morales-resume/' )
        $http.get(url.IP + "contractor-resume/").then(function (data) {
          vm.persons.naturals = [];
          vm.persons.length = 0;
          $scope.results = {
            data: data.data.results,
            config: {
              count: data.data.count,
              next: data.data.next,
              previous: data.data.previous,
            },
          };
          vm.persons.juridicals = $scope.results.data;
          $scope.testPagination("vm.persons.juridicals", "results.config");
        });
        $scope.show_pagination = true;

        vm.persons = [];
      }
      if (vm.condicion == true) {
        vm.persons.naturals = [];
        vm.persons.juridicals = [];
      }
    }
    //Fin getContratantes
    function returnToContractors(param) {
      if (param) {
        vm.show_binnacle = false;
      } else {
        vm.show_binnacle = false;
      }
    }

    function checkRFC() {
      $scope.obligados = [];
      if (vm.form.obligados) {
        vm.form.obligados.forEach(function (elem, index) {
          if (elem.val) {
            if (elem.value) {
              $scope.obligados.push(elem.value.url);
            }
          }
        });
      }
      vm.form.bound_solidarity_many = $scope.obligados ? $scope.obligados : [];
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.form.rfc == undefined) vm.form.rfc = "";
      if (vm.form.rfc) vm.form.rfc = vm.form.rfc.replace("-", "");
      $http
        .post(url.IP + "existrfc", { rfc: vm.form.rfc, selector: 1 })
        .success(function (response) {
          if (response.status == true) {
            SweetAlert.swal(
              {
                title: "¡El RFC del contratante ya existe!",
                text: "¿Deseas continuar?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                closeOnConfirm: false,
              },
              function (isConfirm) {
                if (isConfirm) {
                  $scope.arrayEmail = vm.form.emails;
                  vm.form.emails = [];
                  $scope.arrayPhone = vm.form.phones;
                  vm.form.phones = [];

                  for (var i = 0; i < $scope.arrayEmail.length; i++) {
                    if ($scope.arrayEmail[i].correo) {
                      if ($scope.arrayEmail[i].email_type == 0) {
                        $scope.arrayEmail[i].email_type = 1;
                      }
                      vm.form.emails.push($scope.arrayEmail[i]);
                    }
                  }

                  for (var i = 0; i < $scope.arrayPhone.length; i++) {
                    if ($scope.arrayPhone[i].phone) {
                      if ($scope.arrayPhone[i].phone_type == 0) {
                        $scope.arrayPhone[i].phone_type = 1;
                      }
                      vm.form.phones.push($scope.arrayPhone[i]);
                    }
                  }

                  l.stop();
                  submitFormNatural();
                  $scope.rfc_getDate(vm.form.rfc);
                } else {
                  l.stop();
                  return;
                }
              }
            );
          } else {
            $scope.arrayEmail = vm.form.emails;
            vm.form.emails = [];
            $scope.arrayPhone = vm.form.phones;
            vm.form.phones = [];

            for (var i = 0; i < $scope.arrayEmail.length; i++) {
              if ($scope.arrayEmail[i].correo) {
                if ($scope.arrayEmail[i].email_type == 0) {
                  $scope.arrayEmail[i].email_type = 1;
                }
                vm.form.emails.push($scope.arrayEmail[i]);
              }
            }

            for (var i = 0; i < $scope.arrayPhone.length; i++) {
              if ($scope.arrayPhone[i].phone) {
                if ($scope.arrayPhone[i].phone_type == 0) {
                  $scope.arrayPhone[i].phone_type = 1;
                }
                vm.form.phones.push($scope.arrayPhone[i]);
              }
            }

            l.stop();
            submitFormNatural();
            $scope.rfc_getDate(vm.form.rfc, vm.form);
          }
        });
    }

    $scope.rfc_getDate = function (rfc) {
      if (vm.form.birthday) {
        return;
      }

      vm.rfc_fec = rfc.substr(4, 6);
      vm.rfc_anio = rfc.substr(4, 2);
      vm.rfc_month = rfc.substr(6, 2);
      vm.rfc_day = rfc.substr(8, 2);

      vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
      vm.date = new Date(vm.fecha);

      vm.aniorfc = vm.date.getFullYear();
      vm.hoyA = vm.hoy.getFullYear();
      if (vm.aniorfc > vm.hoyA) {
        vm.resta = vm.aniorfc - 100;
        vm.rfc_anio = vm.resta;
        vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
        if (form.birthday == "") {
          vm.form.birthday = vm.fecha;
        } else {
          vm.form.birthday = vm.fecha;
        }
      }
      vm.aniorfc = vm.date.getFullYear();
      if (vm.form.birthday == null) {
        var fecha_rfcn = $filter("date")(new Date(vm.date), "dd/MM/yyyy");
        vm.form.birthday = fecha_rfcn;
      } else {
        vm.form.birthday = vm.form.birthday;
      }
    };

    function submitFormNatural(argument) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.form.first_name == "") {
        l.stop();
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMNAME, "error");
        return;
      }
      if (vm.form.last_name == "") {
        l.stop();
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMLASTNAME, "error");
        return;
      }
      if (vm.form.birthday == "") {
        l.stop();
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMBIRTHDAY, "error");
        return;
      }
      if (vm.form.rfc == "") {
        // l.stop();
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        if ($location.path() == "/fianzas/") {
        } else {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMRFC, "error");
          return;
        }
      } else {
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
      }
      if (!vm.form.sex) {
        l.stop();
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMSEX, "error");
        return;
      }
      if (!vm.form.group) {
        l.stop();
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.SELGROUP, "error");
        return;
      }
      if (vm.form.emailMain) {
        if (!validateEmail(vm.form.emailMain)) {
          l.stop();
          if (vm.form.emails.length == 0) {
            vm.form.emails = [{ correo: "", email_type: "" }];
          }
          if (vm.form.phones.length == 0) {
            vm.form.phones = [{ phone: "", phone_type: "" }];
          }
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
      $scope.flagEmail = false;
      if (vm.form.emails.length > 0) {
        for (var i = 0; i < vm.form.emails.length; i++) {
          if (vm.form.emails[i].correo) {
            if (!validateEmail(vm.form.emails[i].correo)) {
              $scope.flagEmail = true;
            }
          }
        }
        if ($scope.flagEmail == true) {
          l.stop();
          $scope.flagEmail = false;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }

      if (!helpers.hasAtLeastOneAddress(vm.form.userAddresses)) {
        l.stop();
        toaster.warning(MESSAGES.ERROR.ADDATLEASTONEDIRECCTION);
      } else {
        var flag = false,
          outme = false;
        vm.form.contact_natural.forEach(function (contact) {
          if (contact.name == "") {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
            flag = true;
            return;
          } else {
            if (contact.email) {
              if (!validateEmail(contact.email)) {
                l.stop();
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.INVALIDEMAILCONTACT,
                  "error"
                );
                flag = true;
                return;
              }
            }
            if (contact.phone_number) {
              if (contact.phone_number.length < 9) {
                l.stop();
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.ERRORLENGTHPHONECONTACT,
                  "error"
                );
                return;
              }
            }
          }
        });

        if (flag) {
          return;
        }

        var form = angular.copy(vm.form);
        var arr = [];
        var nums = [];

        vm.form.contact_natural.forEach(function (elem, index) {
          arr.push(elem);
        });
        // form.birthday = $filter('date')(vm.form.birthday, 'yyyy-MM-dd');
        form.birth_date = $filter("date")(vm.form.birthday, "yyyy-MM-dd");
        form.contact = arr;
        form.group = form.subsubgrupo
          ? form.subsubgrupo.url
          : form.subgroup
          ? form.subgroup.url
          : form.group
          ? form.group.url
          : "";
        // form.grouping_level = form.subsubasignaciones ? form.subsubasignaciones.url : form.subagrupaciones ? form.subagrupaciones.url : form.grouping_level ? form.grouping_level.url : '';
        form.groupinglevel = form.subsubasignaciones
          ? form.subsubasignaciones.url
          : form.subagrupaciones
          ? form.subagrupaciones.url
          : form.grouping_level
          ? form.grouping_level.url
          : null;
        // form.celula = vm.form.celula ? vm.form.celula : null;
        form.cellule = vm.form.celula ? vm.form.celula : null;
        form.userAddresses = [];
        vm.form.userAddresses.forEach(function (elem, $index) {
          $scope.elems = elem;
          if (
            elem.administrative_area_level_1 == null ||
            !elem.administrative_area_level_1 ||
            elem.administrative_area_level_1 === undefined ||
            elem.administrative_area_level_1 == "undefined" ||
            elem.administrative_area_level_2 == null ||
            !elem.administrative_area_level_2 ||
            elem.administrative_area_level_2 === undefined ||
            elem.administrative_area_level_2 == "undefined"
          ) {
            l.stop();
            if (!vm.form.birthday) {
              vm.form.birthday = "";
            }
            if (vm.form.emails.length == 0) {
              vm.form.emails = [{ correo: "", email_type: "" }];
            }
            if (vm.form.phones.length == 0) {
              vm.form.phones = [{ phone: "", phone_type: "" }];
            }
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.ADDATLEASTONEDIRECCTION,
              "error"
            );
            outme = true;
            return;
          }
          var auxElem = elem;
          elem.administrative_area_level_1 =
            auxElem.administrative_area_level_1;
          elem.administrative_area_level_2 =
            auxElem.administrative_area_level_2;
          form.userAddresses.push(elem);
        });

        if (outme == true) {
          return;
        }

        form.email = form.emailMain ? form.emailMain : "";
        form.phone_number = form.phoneMain ? form.phoneMain : "";

        if (form.email == "" && vm.form.emails.length > 0) {
          form.email = vm.form.emails[0].correo;
          vm.form.emails.splice(0, 1);
        }

        if (vm.form.phoneMain) {
          if (vm.form.phoneMain.length < 9) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
            return;
          }
        }

        // for(var i = 0; i < vm.form.phones.length; i++){
        //   if(vm.form.phones[i].phone.length < 9){
        //     $scope.flagPhone = true;
        //   }
        // }
        if (vm.form.phones.length > 0) {
          for (var i = 0; i < vm.form.phones.length; i++) {
            if (vm.form.phones[i].phone) {
              if (vm.form.phones[i].phone.length < 9) {
                $scope.flagPhone = true;
              }
            }
          }
          if ($scope.flagPhone == true) {
            l.stop();
            $scope.flagPhone = false;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
            return;
          }
        }
        if (!$scope.flagPhone) {
          if (form.phone_number == "" && vm.form.phones.length > 0) {
            form.phone_number = vm.form.phones[0].phone;
            vm.form.phones.splice(0, 1);
          }
        } else {
          $scope.flagPhone = false;
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
          return;
        }

        var since = toDate(vm.form.birthday).getTime();
        var until = toDate(convertDate(new Date())).getTime();
        var diff = until - since;
        var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
        if (antiguedad <= 0) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATEBIRTHDATE, "error");
          return;
        }

        // var date = new Date(mesDiaAnio(form.birthday));
        var date = form.birthday;
        var newdate = date.split("/").reverse().join("-");
        form.birthday = newdate;
        form.vendor = vm.form.vendedor;
        form.responsable = vm.form.responsable;
        if (form.responsable) {
          if (form.responsable.url) {
            form.responsable = form.responsable.url;
          } else {
            form.responsable = form.responsable;
          }
        }
        if (vm.org_name == "ancora") {
          form.card_official_identification = vm.listDocument[0].value;
          form.CURP = vm.listDocument[1].value;
          form.voucher_efirm = vm.listDocument[2].value;
          form.voucher_of_address = vm.listDocument[3].value;
          form.signed_format_ic = vm.listDocument[4].value;
          if (vm.form.only_sureties) {
            form.carta_nombramiento = vm.listDocument[5].value;
            form.curriculo = vm.listDocument[6].value;
            form.contrato_multiple_afianzadora = vm.listDocument[7].value;
            form.carta_buro = vm.listDocument[8].value;
            form.entrevista_afianzadora = vm.listDocument[9].value;
            form.rfc_document = vm.listDocument[10].value;
            form.recibos_nomina = vm.listDocument[11].value;
            form.declaracion_anual = vm.listDocument[12].value;
            form.estados_financieros_anuales = vm.listDocument[13].value;
            form.estados_financieros_parciales = vm.listDocument[14].value;
            form.alta_hacienda = vm.listDocument[15].value;
            form.escritura_inmueble = vm.listDocument[16].value;
            form.boleta_predial = vm.listDocument[17].value;
            form.certificado_gravamen = vm.listDocument[18].value;
          }
          //upload files repect documents
          vm.listDocument.forEach(function (ar) {
            if (ar.arch.formData) {
              var extension = ar.arch.formData[0].arch.name.split(".")[1];
              ar.arch.formData[0].name = ar.name + "." + extension;
              ar.arch.file.name = ar.name + "." + extension;
              $scope.uploaderDocument.queue.push(ar.arch);
              $scope.uploaderDocument.onAfterAddingFile(ar.arch);
            }
          });
        } else {
          form.card_official_identification = vm.listDocument[0].value;
          form.CURP = vm.listDocument[1].value;
          form.voucher_efirm = vm.listDocument[2].value;
          form.voucher_of_address = vm.listDocument[3].value;
          form.signed_format_ic = vm.listDocument[4].value;
          form.fiscal_power = vm.listDocument[5].value;
          if (vm.form.only_sureties) {
            form.carta_nombramiento = vm.listDocument[6].value;
            form.curriculo = vm.listDocument[7].value;
            form.contrato_multiple_afianzadora = vm.listDocument[8].value;
            form.carta_buro = vm.listDocument[9].value;
            form.entrevista_afianzadora = vm.listDocument[10].value;
            form.rfc_document = vm.listDocument[11].value;
            form.recibos_nomina = vm.listDocument[12].value;
            form.declaracion_anual = vm.listDocument[13].value;
            form.estados_financieros_anuales = vm.listDocument[14].value;
            form.estados_financieros_parciales = vm.listDocument[15].value;
            form.alta_hacienda = vm.listDocument[16].value;
            form.escritura_inmueble = vm.listDocument[17].value;
            form.boleta_predial = vm.listDocument[18].value;
            form.certificado_gravamen = vm.listDocument[19].value;
          }
          //upload files repect documents
          vm.listDocument.forEach(function (ar) {
            if (ar.arch.formData) {
              var extension = ar.arch.formData[0].arch.name.split(".")[1];
              ar.arch.formData[0].name = ar.name + "." + extension;
              ar.arch.file.name = ar.name + "." + extension;
              $scope.uploaderDocument.queue.push(ar.arch);
              $scope.uploaderDocument.onAfterAddingFile(ar.arch);
            }
          });
        }
        //upload documents
        vm.form.birthday = $filter("date")(vm.form.birthday, "yyyy-MM-dd");
        vm.form.birthday = $filter("date")(vm.form.birthday, "yyyy-MM-dd");
        var date = form.birthday;
        var newdate = date.split("/").reverse().join("-");
        // form.birthday = newdate;
        // form.birth_date = datesFactory.toDate(datesFactory.convertDate(newdate));
        form.birth_date = datesFactory.toDate(vm.form.birthday);
        try {
          if (form.birth_date.length <= 8) {
            l.stop();
            SweetAlert.swal("Error", MESSAGES.ERROR.DATEBIRTHDAY, "error");
            return;
          }
        } catch (e) {}
        if (vm.form.sucursal) {
          form.sucursal = vm.form.sucursal;
        } else {
          form.sucursal = "";
        }
        form.has_bound_solidarity = $scope.has_solidario ? true : false;
        vm.form.bound_solidarity_many = $scope.obligados
          ? $scope.obligados
          : [];
        ContratanteService.createContratante(form, 1).then(function (data) {
          $scope.contractorNew = data;
          if ($scope.uploaderDocument.queue.length != 0) {
            uploadFilesList(data.type_person, data.id);
          }
          if (!data.id) {
            if (data.email) {
              l.stop();
              SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROREMAILMAX, "error");
            } else {
              l.stop();
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORCREATECONTRACTOR,
                "error"
              );
            }
          } else {
            var params = {
              model: 2,
              event: "POST",
              associated_id: data.id,
              identifier: "creó el contratante.",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});

            PersistenceFactory.eliminar();
            $scope.sendEmails(data.url, 1);
            $scope.sendPhones(data.url, 1);
            $scope.sendResponsables(data.url, 1);
            // Async add contacts
            form.contact.forEach(function (contact) {
              // contact.natural = data.url;
              contact.contractor = data.url;
              contactService.createContact(contact);
            });
            // Async add addresses
            $scope.acumulate = 0;
            form.userAddresses.forEach(function (address) {
              $scope.acumulate = $scope.acumulate + 1;
              address.url = globalVar.address;
              address.administrative_area_level_1 =
                address.administrative_area_level_1.state;
              address.administrative_area_level_2 =
                address.administrative_area_level_2.city;
              // address.natural = data.url;
              address.contractor = data.url;
              address.tipo = address.tipo ? address.tipo.name : "";
              generalService.postService(address).then(function (address) {
                data["address_contractor"].push(address.data);
              });
            });

            if (flag) {
              return;
            }

            vm.disabledAfterSave = true;
            $scope.userInfo = {
              id: data.id,
              type_person: data.type_person,
            };

            $("#newContractor").val(data.id);

            // Upload files
            // $scope.userInfo.url = $scope.uploader.url = url.IP + checkType($scope.userInfo.type_person) + '/' + $scope.userInfo.id + '/archivos/';
            $scope.userInfo.url = $scope.uploader.url =
              url.IP + "contractors" + "/" + $scope.userInfo.id + "/archivos/";
            vm.persons.push(data);
            $q.when()
              .then(function () {
                var defer = $q.defer();
                // defer.resolve($scope.uploader.uploadAll());
                return defer.promise;
              })
              .then(function () {
                // $scope.uploader.uploadAll();
              });
            $timeout(function () {
              if ($scope.countFile > 0) {
                if ($scope.acumulate == form.userAddresses.length) {
                  uploadFiles(data.type_person, data.id);
                } else {
                  uploadFiles(data.type_person, data.id);
                }
              } else {
                if (!$scope.array_files) {
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.NEWCONTRACTOR,
                    "success"
                  );
                  if ($scope.acumulate == form.userAddresses.length) {
                    if ($location.path() == "/contratantes/crear") {
                      if (vm.acceso_ver_cont) {
                        $state.go("contratantes.info", {
                          type:
                            $scope.contractorNew.type_person == 1
                              ? "fisicas"
                              : "morales",
                          contratanteId: $scope.contractorNew.id,
                        });
                      } else {
                        $state.go("index.main");
                      }
                    } else if ($location.path() == "/colectividades/") {
                      var params = { myInsurance: data };
                      $state.go("colectividades.main", params);
                    } else if ($location.path() == "/fianzas/") {
                      // var params = { 'myInsurance': data }
                      // $state.go('fianzas.fianzas', params);
                      $rootScope.show_contractor = false;
                    } else if ($location.path() == "/fianzas/colectividades") {
                      $rootScope.show_contractor = false;
                      var params = { myInsurance: data };
                      $state.go("fianzas.fianzas", params);
                      $rootScope.show_contractor = false;
                    } else if ($location.path() == "/fianzas/colectividades") {
                      $rootScope.show_contractor = false;
                      var params = { myInsurance: data };
                      $state.go("fianzas.colectividades", params);
                    } else {
                      $rootScope.show_contractor = false;
                      var params = { myInsurance: data };
                      $state.go("polizas.create", params);
                    }

                    $rootScope.show_contractor = false;
                  }
                }
              }
            }, 10);
          }
        });
      }
    }
    vm.emails = {
      add: addEmail,
      delete: deleteEmail,
    };

    // vm.responsables = {
    //     add: addResponsable,
    //     delete: deleteResponsable
    // };
    function formatDate(input) {
      var datePart = input.match(/\d+/g),
        year = datePart[0].substring(2), // get only two digits
        month = datePart[1],
        day = datePart[2];

      return day + "/" + month + "/" + year;
    }
    var obligados1 = {
      obligado: vm.form.contratante,
    };
    vm.form.obligados = [];
    vm.form.obligados.push(obligados1);
    vm.juridicalForm.obligados = [];
    vm.juridicalForm.obligados.push(obligados1);

    $scope.addObligados = function (type) {
      if (type === 1) {
        var addobligadoss = {
          obligado: obligados1,
        };
        vm.form.obligados.push(addobligadoss);
      } else {
        var addobligadoss = {
          obligado: obligados1,
        };
        vm.juridicalForm.obligados.push(addobligadoss);
      }
    };
    $scope.deleteObligados = function (index, type) {
      if (type === 1) {
        vm.form.obligados.splice(index, 1);
      } else {
        vm.juridicalForm.obligados.splice(index, 1);
      }
    };
    $scope.sendResponsables = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.responsables.length; i++) {
          // vm.form.responsables[i].natural = url;
          vm.form.responsables[i].contractor = url;
        }
        vm.responsable = vm.form.responsables;
      } else {
        for (var i = 0; i < vm.juridicalForm.responsables.length; i++) {
          // vm.juridicalForm.responsables[i].juridical = url;
          vm.juridicalForm.responsables[i].contractor = url;
        }
        vm.responsable = vm.juridicalForm.responsables;
      }

      if (vm.responsable) {
        dataFactory
          .post("responsables/", vm.responsable)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };

    $scope.addResponsable = function (type) {
      if (type === 1) {
        var addresponsables = {
          responsables: vm.form.responsable,
          resp_type: 0,
        };
        vm.form.responsables.push(addresponsables);
      } else {
        var addresponsables = {
          responsables: vm.juridicalForm.responsable
            ? vm.juridicalForm.responsable
            : null,
          resp_type: 0,
        };
        vm.juridicalForm.responsables.push(addresponsables);
      }
    };
    $scope.deleteResponsable = function (index, type) {
      if (type === 1) {
        vm.form.responsables.splice(index, 1);
      } else {
        vm.juridicalForm.responsables.splice(index, 1);
      }
    };
    $scope.sendResponsables = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.responsables.length; i++) {
          // vm.form.responsables[i].natural = url;
          vm.form.responsables[i].contractor = url;
        }
        vm.responsable = vm.form.responsables;
      } else {
        for (var i = 0; i < vm.juridicalForm.responsables.length; i++) {
          // vm.juridicalForm.responsables[i].juridical = url;
          vm.juridicalForm.responsables[i].contractor = url;
        }
        vm.responsable = vm.juridicalForm.responsables;
      }

      if (vm.responsable) {
        dataFactory
          .post("responsables/", vm.responsable)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    function addEmail(type) {
      if (type === 1) {
        var addEmails = {
          correo: vm.form.correo,
        };
        vm.form.emails.push(addEmails);
      } else {
        var addEmails = {
          correo: vm.juridicalForm.correo,
        };
        vm.juridicalForm.emails.push(addEmails);
      }
    }
    function deleteEmail(index, type) {
      if (type === 1) {
        vm.form.emails.splice(index, 1);
      } else {
        vm.juridicalForm.emails.splice(index, 1);
      }
    }
    $scope.sendEmails = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.emails.length; i++) {
          // vm.form.emails[i].natural = url;
          vm.form.emails[i].contractor = url;
        }
        vm.correo = vm.form.emails;
      } else {
        for (var i = 0; i < vm.juridicalForm.emails.length; i++) {
          // vm.juridicalForm.emails[i].juridical = url;
          vm.juridicalForm.emails[i].contractor = url;
        }
        vm.correo = vm.juridicalForm.emails;
      }

      if (vm.correo) {
        dataFactory
          .post("emails/", vm.correo)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };

    vm.phones = {
      add: addPhone,
      delete: deletePhone,
    };
    function addPhone(type) {
      if (type === 1) {
        var addPhones = {
          phone: vm.form.phone,
        };
        vm.form.phones.push(addPhones);
      } else {
        var addPhones = {
          phone: vm.juridicalForm.phone,
        };
        vm.juridicalForm.phones.push(addPhones);
      }
    }
    function deletePhone(index, type) {
      if (type === 1) {
        vm.form.phones.splice(index, 1);
      } else {
        vm.juridicalForm.phones.splice(index, 1);
      }
    }
    $scope.sendPhones = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.phones.length; i++) {
          // vm.form.phones[i].natural = url;
          vm.form.phones[i].contractor = url;
        }
        vm.telefono = vm.form.phones;
      } else {
        for (var i = 0; i < vm.juridicalForm.phones.length; i++) {
          // vm.juridicalForm.phones[i].juridical = url;
          vm.juridicalForm.phones[i].contractor = url;
        }
        vm.telefono = vm.juridicalForm.phones;
      }
      if (vm.telefono) {
        dataFactory
          .post("phones/", vm.telefono)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function submitJuridical() {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.obligados = [];
      if (vm.juridicalForm.obligados) {
        vm.juridicalForm.obligados.forEach(function (elem, index) {
          if (elem.val) {
            if (elem.value) {
              $scope.obligados.push(elem.value.url);
            }
          }
        });
      }
      vm.juridicalForm.bound_solidarity_many = $scope.obligados
        ? $scope.obligados
        : [];
      if (vm.juridicalForm.rfc == undefined) {
        vm.juridicalForm.rfc = "";
      }
      $http
        .post(url.IP + "existrfc", { rfc: vm.juridicalForm.rfc, selector: 2 })
        .success(function (response) {
          if (response.status == true) {
            SweetAlert.swal(
              {
                title: "¡El RFC del contratante ya existe!",
                text: "¿Deseas continuar?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                closeOnConfirm: false,
              },
              function (isConfirm) {
                if (isConfirm) {
                  l.stop();
                  submitFormJuridical();
                  $scope.rfc_getDateJ(vm.juridicalForm.rfc);
                } else {
                  l.stop();
                  return;
                }
              }
            );
          } else {
            $scope.arrayEmail = vm.juridicalForm.emails;
            vm.juridicalForm.emails = [];
            $scope.arrayPhone = vm.juridicalForm.phones;
            vm.juridicalForm.phones = [];

            for (var i = 0; i < $scope.arrayEmail.length; i++) {
              if ($scope.arrayEmail[i].correo) {
                if ($scope.arrayEmail[i].email_type == 0) {
                  $scope.arrayEmail[i].email_type = 1;
                }
                vm.juridicalForm.emails.push($scope.arrayEmail[i]);
              }
            }

            for (var i = 0; i < $scope.arrayPhone.length; i++) {
              if ($scope.arrayPhone[i].phone) {
                if ($scope.arrayPhone[i].phone_type == 0) {
                  $scope.arrayPhone[i].phone_type = 1;
                }
                vm.juridicalForm.phones.push($scope.arrayPhone[i]);
              }
            }

            l.stop();
            submitFormJuridical();
            $scope.rfc_getDateJ(vm.juridicalForm.rfc, vm.juridicalForm);
          }
        });
    }
    Date.prototype.isValid = function () {
      // An invalid date object returns NaN for getTime() and NaN is the only
      // object not strictly equal to itself.
      return this.getTime() === this.getTime();
    };

    $scope.rfc_getDateJ = function (curp, form) {
      if (vm.juridicalForm.date_of_establishment) {
        return;
      }
      var m = curp.match(/^\w{4}(\w{2})(\w{2})(\w{2})/);
      //miFecha = new Date(año,mes,dia)
      try {
        var anyo = parseInt(m[1], 10) + 1900;
        if (anyo < 1950) anyo += 100;
        var mes = parseInt(m[2], 10) - 1;
        var dia = parseInt(m[3], 10);
        var date = new Date(anyo, mes, dia);
        if (date.isValid()) {
          vm.juridicalForm.date_of_establishment =
            datesFactory.convertDate(date);
        }
      } catch (err) {}

      // return (new Date( anyo, mes, dia ));
    };

    // $scope.rfc_getDateJ= function (rfc,form){
    //   if(vm.juridicalForm.date_of_establishment) {
    //     if ($scope.isValidDate(vm.juridicalForm.date_of_establishment)) {
    //       return;
    //     }else{
    //       vm.juridicalForm.date_of_establishment = null
    //       $scope.rfc_getDateJ(rfc,2)
    //     }
    //   }
    //   vm.rfc_fec= rfc.substr(3, 6);
    //   vm.rfc_anio = rfc.substr(3, 2);
    //   vm.rfc_month = rfc.substr(5, 2);
    //   vm.rfc_day = rfc.substr(7, 2);
    //   vm.fecha= vm.rfc_month+'/'+vm.rfc_day+'/'+vm.rfc_anio;
    //   vm.date = new Date(vm.fecha);
    //   vm.aniorfc= vm.date.getFullYear();
    //   vm.hoyA=vm.hoy.getFullYear();
    //   if(vm.aniorfc > vm.hoyA){
    //     vm.resta=vm.aniorfc-100;
    //     vm.rfc_anio = vm.resta;
    //     vm.fecha= vm.rfc_month+'/'+vm.rfc_day+'/'+vm.rfc_anio;
    //     if(vm.form.date_of_establishment == ""){
    //       var fecha_rfcJ= $filter('date')(new Date(vm.fecha), 'dd/MM/yyyy');
    //       vm.juridicalForm.date_of_establishment = fecha_rfcJ;
    //     }else{
    //       vm.juridicalForm.date_of_establishment = form.date_of_establishment;
    //     }
    //   }
    //   if(vm.juridicalForm.date_of_establishment == null || $scope.isValidDate(vm.juridicalForm.date_of_establishment) == false){
    //     var fecha_rfc= $filter('date')(new Date(vm.date), 'dd/MM/yyyy');
    //     vm.juridicalForm.date_of_establishment = fecha_rfc;
    //   }else{
    //     if ($scope.isValidDate(vm.juridicalForm.date_of_establishment)) {
    //       vm.juridicalForm.date_of_establishment = vm.juridicalForm.date_of_establishment;
    //     }else{
    //       var fecha_rfcJ= $filter('date')(new Date(vm.fecha), 'dd/MM/yyyy');
    //       vm.juridicalForm.date_of_establishment = fecha_rfcJ;
    //       // $scope.rfc_getDateJ(rfc,2)
    //     }
    //   }
    // }

    $scope.isValidDate = function (d) {
      return d instanceof Date && !isNaN(d);
    };
    function submitFormJuridical() {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.juridicalForm.j_name == "") {
        l.stop();
        if (!vm.juridicalForm.date_of_establishment) {
          vm.juridicalForm.date_of_establishment = "";
        }
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMJNAME, "error");
        return;
      }
      if (vm.juridicalForm.date_of_establishment == "") {
        l.stop();
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMESTABLISHMENT, "error");
        return;
      }
      if (vm.juridicalForm.rfc == "") {
        l.stop();
        if (!vm.juridicalForm.date_of_establishment) {
          vm.juridicalForm.date_of_establishment = "";
        }
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMRFC, "error");
        return;
      }
      if (!vm.juridicalForm.group) {
        l.stop();
        if (!vm.juridicalForm.date_of_establishment) {
          vm.juridicalForm.date_of_establishment = "";
        }
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.SELGROUP, "error");
        return;
      }
      if (vm.juridicalForm.emailMain) {
        if (!validateEmail(vm.juridicalForm.emailMain)) {
          l.stop();
          if (vm.juridicalForm.emails.length == 0) {
            vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
          }
          if (vm.juridicalForm.phones.length == 0) {
            vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
          }
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
      $scope.flagEmail = false;
      if (vm.juridicalForm.emails.length > 0) {
        for (var i = 0; i < vm.juridicalForm.emails.length; i++) {
          if (!validateEmail(vm.juridicalForm.emails[i].correo)) {
            $scope.flagEmail = true;
          }
        }
        if ($scope.flagEmail == true) {
          l.stop();
          $scope.flagEmail = false;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }

      if (!helpers.hasAtLeastOneAddress(vm.juridicalForm.userAddresses)) {
        l.stop();
        toaster.info(MESSAGES.ERROR.ADDATLEASTONEDIRECCTION);
      } else {
        var flag = false,
          outme = false;
        vm.juridicalForm.contact_juridical.forEach(function (contact) {
          if (contact.name == "") {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
            flag = true;
            return;
          } else {
            if (contact.email) {
              if (!validateEmail(contact.email)) {
                l.stop();
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.INVALIDEMAILCONTACT,
                  "error"
                );
                flag = true;
                return;
              }
            }
            if (contact.phone_number) {
              if (contact.phone_number.length < 9) {
                l.stop();
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.ERRORLENGTHPHONECONTACT,
                  "error"
                );
                return;
              }
            }
          }
        });

        var since = toDate(vm.juridicalForm.date_of_establishment).getTime();
        var until = toDate(convertDate(new Date())).getTime();
        var diff = until - since;
        var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
        if (antiguedad <= 0) {
          l.stop();
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORDATEFORMESTABLISHMENT,
            "error"
          );
          return;
        }

        if (flag) {
          return;
        }

        var form = angular.copy(vm.juridicalForm);
        var juridicalForm = angular.copy(vm.juridicalForm);
        var arr = [];
        var nums = [];
        vm.juridicalForm.contact_juridical.forEach(function (elem, index) {
          arr.push(elem);
        });

        form.constitutive_act = vm.listDocument[0].value;
        form.rfc_document = vm.listDocument[1].value;
        form.card_official_identification = vm.listDocument[2].value;
        form.voucher_of_address = vm.listDocument[3].value;
        form.modifications_constitutive_act = vm.listDocument[4].value;
        form.fiscal_power = vm.listDocument[5].value;
        if (vm.juridicalForm.only_sureties) {
          form.curriculo = vm.listDocument[6].value;
          form.contrato_multiple_afianzadora = vm.listDocument[7].value;
          form.carta_buro = vm.listDocument[8].value;
          form.entrevista_afianzadora = vm.listDocument[9].value;
          form.aviso_privacidad = vm.listDocument[10].value;
          form.protocolizaciones = vm.listDocument[11].value;
          form.alta_hacienda = vm.listDocument[12].value;
          form.cambio_domicilio_hacienda = vm.listDocument[13].value;
          form.voucher_efirm = vm.listDocument[14].value;
          form.declaracion_anual = vm.listDocument[15].value;
          form.estados_financieros_anuales = vm.listDocument[16].value;
          form.estados_financieros_parciales = vm.listDocument[17].value;
          form.escritura_inmueble = vm.listDocument[18].value;
          form.boleta_predial = vm.listDocument[19].value;
          form.certificado_gravamen = vm.listDocument[20].value;
        }
        //upload files repect documents
        vm.listDocument.forEach(function (ar) {
          if (ar.arch.formData) {
            var extension = ar.arch.formData[0].arch.name.split(".")[1];
            ar.arch.formData[0].name = ar.name + "." + extension;
            ar.arch.file.name = ar.name + "." + extension;
            $scope.uploaderDocument.queue.push(ar.arch);
            $scope.uploaderDocument.onAfterAddingFile(ar.arch);
          }
        });
        //upload documents
        form.date_of_establishment = $filter("date")(
          vm.juridicalForm.date_of_establishment,
          "yyyy-MM-dd"
        ); //jshint ignore:line
        form.contact = arr;
        form.group = form.group ? form.group.url : "";
        juridicalForm.userAddresses = [];
        form.userAddresses.forEach(function (elem) {
          if (
            elem.administrative_area_level_1 == null ||
            !elem.administrative_area_level_1 ||
            elem.administrative_area_level_1 === undefined ||
            elem.administrative_area_level_1 == "undefined" ||
            elem.administrative_area_level_2 == null ||
            !elem.administrative_area_level_2 ||
            elem.administrative_area_level_2 === undefined ||
            elem.administrative_area_level_2 == "undefined"
          ) {
            l.stop();
            if (!vm.juridicalForm.date_of_establishment) {
              vm.juridicalForm.date_of_establishment = "";
            }
            if (vm.juridicalForm.emails.length == 0) {
              vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
            }
            if (vm.juridicalForm.phones.length == 0) {
              vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
            }
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.DATAADDRESSREQUIRED,
              "error"
            );
            outme = true;
            return;
          }
          var auxElem = elem;
          elem.administrative_area_level_1 =
            auxElem.administrative_area_level_1;
          elem.administrative_area_level_2 =
            auxElem.administrative_area_level_2;
          juridicalForm.userAddresses.push(elem);
        });

        if (outme == true) {
          return;
        }

        // if(form.group == '' || juridicalForm.group == ''){
        //   l.stop();
        //   SweetAlert.swal("ERROR",MESSAGES.ERROR.SELGROUP ,"error");
        //   flag = true;
        //   return;
        // }

        var date = form.date_of_establishment;
        var newdate = date.split("/").reverse().join("-");
        form.date_of_establishment = newdate;

        form.email = juridicalForm.emailMain ? juridicalForm.emailMain : "";
        form.phone_number = juridicalForm.phoneMain
          ? juridicalForm.phoneMain
          : "";
        form.vendor = vm.juridicalForm.vendedor;
        form.responsable = vm.juridicalForm.responsable;
        if (form.responsable) {
          if (form.responsable.url) {
            form.responsable = form.responsable.url;
          } else {
            form.responsable = form.responsable;
          }
        }

        if (juridicalForm.email == "" && vm.juridicalForm.emails.length > 0) {
          juridicalForm.email = vm.juridicalForm.emails[0].correo;
          vm.juridicalForm.emails.splice(0, 1);
        }

        if (vm.juridicalForm.phoneMain) {
          if (vm.juridicalForm.phoneMain.length < 9) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
            return;
          }
        }

        for (var i = 0; i < vm.juridicalForm.phones.length; i++) {
          if (vm.juridicalForm.phones[i].phone.length < 9) {
            $scope.flagPhone = true;
          }
        }
        if (!$scope.flagPhone) {
          if (
            juridicalForm.phone_number == "" &&
            vm.juridicalForm.phones.length > 0
          ) {
            juridicalForm.phone_number = vm.juridicalForm.phones[0].phone;
            vm.juridicalForm.phones.splice(0, 1);
          }
        } else {
          $scope.flagPhone = false;
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
          return;
        }
        try {
          if (form.date_of_establishment.length <= 8) {
            l.stop();
            SweetAlert.swal("Error", MESSAGES.ERROR.DATEESTABLISHMENT, "error");
            return;
          }
        } catch (e) {}
        if (vm.juridicalForm.sucursal) {
          form.sucursal = vm.juridicalForm.sucursal;
        } else {
          form.sucursal = "";
        }
        // form.birth_date = datesFactory.toDate(form.date_of_establishment ? convertDate(new Date(form.date_of_establishment)) : convertDate(new Date(m.juridicalForm.date_of_establishment)));
        form.birth_date = datesFactory.toDate(
          vm.juridicalForm.date_of_establishment
        );
        form.type_person = 2;
        form.group = vm.juridicalForm.subsubgrupo
          ? vm.juridicalForm.subsubgrupo.url
          : vm.juridicalForm.subgroup
          ? vm.juridicalForm.subgroup.url
          : vm.juridicalForm.group
          ? vm.juridicalForm.group.url
          : "";
        // form.grouping_level = form.subsubasignaciones ? form.subsubasignaciones.url : form.subagrupaciones ? form.subagrupaciones.url : form.grouping_level ? form.grouping_level.url : '';
        form.groupinglevel = form.subsubasignaciones
          ? form.subsubasignaciones.url
          : form.subagrupaciones
          ? form.subagrupaciones.url
          : form.grouping_level
          ? form.grouping_level.url
          : null;
        // form.celula = vm.juridicalForm.celula ? vm.juridicalForm.celula : null;
        form.cellule = vm.juridicalForm.celula ? vm.juridicalForm.celula : null;
        form.full_name = vm.juridicalForm.j_name;
        vm.form.bound_solidarity_many = $scope.obligados
          ? $scope.obligados
          : [];
        form.has_bound_solidarity = $scope.has_solidario ? true : false;
        ContratanteService.createContratante(form, 2).then(function (data) {
          $scope.contractorNew = data;
          if ($scope.uploaderDocument.queue.length != 0) {
            uploadFilesList(data.type_person, data.id);
          }
          if (data.type_person == "Moral") data["address_contractor"] = [];
          else data["address_natural"] = [];

          if (!data.id) {
            if (data.email) {
              l.stop();
              SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROREMAILMAX, "error");
            } else {
              l.stop();
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORCREATECONTRACTOR,
                "error"
              );
            }
          } else {
            $scope.sendEmails(data.url, 2);
            $scope.sendPhones(data.url, 2);
            $scope.sendResponsables(data.url, 2);
            form.contact.forEach(function (contact) {
              // contact.juridical = data.url;
              contact.contractor = data.url;
              contactService.createContact(contact);
            });
            // var address = {};
            $scope.acumulate = 0;
            juridicalForm.userAddresses.forEach(function (address) {
              $scope.acumulate = $scope.acumulate + 1;
              address.url = globalVar.address;
              // address.juridical = data.url;
              address.contractor = data.url;
              address.administrative_area_level_1 =
                address.administrative_area_level_1.state;
              address.administrative_area_level_2 =
                address.administrative_area_level_2.city;
              address.tipo = address.tipo ? address.tipo.name : "";
              generalService.postService(address).then(function (address) {
                if (data.type_person == "Moral") {
                  data["address_contractor"].push(address.data);
                } else {
                  data["address_contractor"].push(address.data);
                }
              });
            });
            if (flag) {
              return;
            }
            // toaster.success(MESSAGES.OK.NEWCONTRACTOR);

            vm.disabledAfterSave = true;

            $scope.userInfo = {
              id: data.id,
              type_person: data.type_person,
            };

            $("#newContractor").val(data.id);

            // Upload files
            // $scope.userInfo.url = $scope.uploader.url = url.IP + checkType($scope.userInfo.type_person) + '/' + $scope.userInfo.id + '/archivos/';
            $scope.userInfo.url = $scope.uploader.url =
              url.IP + "contractors/" + $scope.userInfo.id + "/archivos/";
            vm.persons.push(data);
            $q.when()
              .then(function () {
                var defer = $q.defer();
                defer.resolve($scope.uploader.uploadAll());
                return defer.promise;
              })
              .then(function () {
                $scope.uploader.uploadAll();
              });

            $timeout(function () {
              if ($scope.countFile > 0) {
                if ($scope.acumulate == juridicalForm.userAddresses.length) {
                  uploadFiles(data.type_person, data.id);
                } else {
                  uploadFiles(data.type_person, data.id);
                }
              } else {
                if (!$scope.array_files) {
                  if (vm.acceso_ver_cont) {
                    if (
                      $scope.acumulate == juridicalForm.userAddresses.length
                    ) {
                      SweetAlert.swal(
                        "¡Listo!",
                        MESSAGES.OK.NEWCONTRACTOR,
                        "success"
                      );
                      if ($location.path() == "/contratantes/crear") {
                        $state.go("contratantes.info", {
                          type:
                            $scope.contractorNew.type_person == 1
                              ? "fisicas"
                              : "morales",
                          contratanteId: $scope.contractorNew.id,
                        });
                      } else if ($location.path() == "/colectividades/") {
                        var params = { myInsurance: data };
                        $state.go("colectividades.main", params);
                      } else if ($location.path() == "/fianzas/") {
                        var params = { myInsurance: data };
                        $state.go("fianzas.fianzas", params);
                        $rootScope.show_contractor = false;
                      } else {
                        $rootScope.show_contractor = false;
                        var params = { myInsurance: data };
                        $state.go("polizas.create", params);
                      }
                      $rootScope.show_contractor = false;
                    }
                  } else {
                    $state.go("index.main", params);
                  }
                }
              }
            }, 10);
          }
        });
      }
    }

    function insert(form) {}

    function checkType(type) {
      //jshint ignore:line
      // return (type === 'Fisica') ? 'fisicas' : 'morales';
      return type === "Física" ? "fisicas" : "morales";
    }

    function addContact(type) {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
      };
      if (type === 1) {
        vm.form.contact_natural.push(contact);
      } else {
        vm.juridicalForm.contact_juridical.push(contact);
      }
    }

    function deleteContacts(contact, type) {
      if (type === 1) {
        vm.form.contact_natural.splice(contact, 1);
      } else {
        vm.juridicalForm.contact_juridical.splice(contact, 1);
      }
    }

    function openModalGroup(level, type, parent) {
      $("#modalContratate").parent().parent().parent().css("display", "none");
      $(".modal-backdrop").click(function () {
        $("#modalContratate")
          .parent()
          .parent()
          .parent()
          .css("display", "block");
      });
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/grupos/grupos.form.html",
        controller: ModalInstanceCtrl,
        resolve: {
          padre: function () {
            return parent;
          },
          parent: function () {
            return vm;
          },
          type: function () {
            return type;
          },
          level: function () {
            return level;
          },
          group: function () {
            return level == 2 ? vm.form.group : {};
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }
    vm.subgroups = [];
    vm.sub_subgroups = [];

    function ModalInstanceCtrl(
      $scope,
      $uibModalInstance,
      parent,
      level,
      group,
      type,
      padre
    ) {
      $scope.level = level;
      $scope.groupForm = {};
      $scope.subgroupForm = {};
      $scope.subsubgroupForm = {};
      $scope.subgroups = [];
      $scope.sub_subgroups = [];

      $scope.addSubgroups = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        $scope.subgroups.push(obj);
      };

      $scope.deleteSubgroup = function (index) {
        $scope.subgroups.splice(index, 1);
      };

      $scope.addSubsubgroups = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        $scope.sub_subgroups.push(obj);
      };

      $scope.deleteSubsubgroup = function (index) {
        $scope.sub_subgroups.splice(index, 1);
      };

      $http.get(url.IP + "usuarios/").then(function (user) {
        $scope.users = user.data.results;

        $scope.show_pagination = true;
      });

      $scope.changeResponsable = function (data, type) {
        // $scope.responsables_natural = [];
        // $scope.responsables_juridical = [];
        if (type == 1) {
          $scope.responsables_natural.push(data);
        } else {
          $scope.responsables_juridical.push(data);
        }
      };

      $scope.ok = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (!$scope.groupForm.responsable) {
          l.stop();
          SweetAlert.swal("ERROR", "Selecciona un responsable.", "error");
          return;
        }

        var flag = false;
        var form = angular.copy($scope.groupForm);
        var name = form.group_name;
        var bd_group_name = [];
        groupService.getGroups().then(function (res) {
          res.forEach(function (group, i) {
            bd_group_name.push(String(group.group_name));
          });

          for (var i = 0; i < bd_group_name.length; i++) {
            if (name == bd_group_name[i]) {
              flag = true;
            }
          }

          form.type_group = 1;

          if (flag == false) {
            return groupService
              .createGroup(form)
              .then(function (data) {
                if (data.status === 201) {
                  vm.groups.push(data.data);
                  $rootScope.changeGroup(data.data);
                  if (vm.form.email) {
                    vm.form.group = data.data;
                  } else if (vm.juridicalForm.email) {
                    vm.juridicalForm.group = data.data;
                  }

                  if ($uibModalInstance) {
                    $uibModalInstance.close();
                    $("#modalContratate")
                      .parent()
                      .parent()
                      .parent()
                      .css("display", "block");
                  }

                  if ($scope.subgroups.length > 0) {
                    $scope.subgroups.forEach(function (item) {
                      var datas = {
                        group_name: item.group_name,
                        responsable: data.data.responsable,
                        parent: data.data.url,
                        type_group: 2,
                      };

                      $http({
                        method: "POST",
                        url: url.IP + "grupos/",
                        data: datas,
                      })
                        .then(function (request) {
                          if (
                            request.status === 200 ||
                            request.status === 201
                          ) {
                            // vm.subgroups.push(request.data);
                            if (type === 1) {
                              vm.form.group.subgrupos.push(request.data);
                            } else {
                              vm.juridicalForm.group.subgrupos.push(
                                request.data
                              );
                            }
                          }
                        })
                        .catch(function (e) {
                          l.stop();
                          console.log("e", e);
                        });
                    });
                  }
                } else if (data.status === 403) {
                  toaster.warning("Usted no tiene permisos para crear grupos");
                  // return;
                  l.stop();
                  $uibModalInstance.close();
                  $("#modalContratate")
                    .parent()
                    .parent()
                    .parent()
                    .css("display", "block");
                }
              })
              .catch(function () {
                l.stop();
                return;
              });
          } else {
            l.stop();
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.THISNAMEALREADYEXIST,
              "error"
            );
            return;
          }
        });
      };

      $scope.oksub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.subgroupForm.responsable = group.responsable;
        $scope.subgroupForm.parent = padre.url;
        $scope.subgroupForm.type_group = 2;

        if (!$scope.subgroupForm.group_name) {
          l.stop();
          SweetAlert.swal("Error", "Agrega un nombre de subgrupo.", "error");
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "grupos/",
          data: $scope.subgroupForm,
        })
          .then(function (request) {
            if (request.status === 200 || request.status === 201) {
              try {
                vm.subgroups.push(request.data);
              } catch (e) {
                vm.subgroups = [];
                vm.subgroups.push(request.data);
              }

              if ($scope.sub_subgroups.length > 0) {
                vm.subgroups[vm.subgroups.length - 1].subsubgrupos = [];
                $scope.sub_subgroups.forEach(function (item) {
                  var datas = {
                    group_name: item.group_name,
                    responsable: group.responsable,
                    parent: request.data.url,
                    type_group: 3,
                  };

                  $http({
                    method: "POST",
                    url: url.IP + "grupos/",
                    data: datas,
                  })
                    .then(function (response) {
                      if (response.status === 200 || response.status === 201) {
                        vm.subgroups[vm.subgroups.length - 1].subsubgrupos.push(
                          response.data
                        );
                      }
                    })
                    .catch(function (e) {
                      l.stop();
                      console.log("e", e);
                    });
                });
              }
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.oksubsub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.subsubgroupForm.responsable = group.responsable;
        $scope.subsubgroupForm.parent = padre.url;
        $scope.subsubgroupForm.type_group = 3;

        if (!$scope.subsubgroupForm.group_name) {
          l.stop();
          SweetAlert.swal("Error", "Agrega un nombre de subsubgrupo.", "error");
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "grupos/",
          data: $scope.subsubgroupForm,
        })
          .then(function (request_sub) {
            if (request_sub.status === 200 || request_sub.status === 201) {
              if (vm.sub_subgroups == undefined) {
                vm.sub_subgroups = [];
              }
              vm.sub_subgroups.push(request_sub.data);
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
          $("#modalContratate")
            .parent()
            .parent()
            .parent()
            .css("display", "block");
        }
      };
    }

    function openModalAsignacion(level, parent) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/contratantes/contratantes.agrupacion.html",
        controller: ModalGroupCtrl,
        resolve: {
          padre: function () {
            return parent;
          },
          parent: function () {
            return vm;
          },
          level: function () {
            return level;
          },
          group: function () {
            return level == 2
              ? vm.form.grouping_level
              : vm.form.subagrupaciones;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }

    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    function ModalGroupCtrl(
      $scope,
      $uibModalInstance,
      parent,
      level,
      group,
      padre
    ) {
      $scope.level = level;
      $scope.group_modal = group;
      $scope.grupo = {};
      // $scope.subasignaciones = [];
      $scope.subsubasignacion = [];

      $scope.addSubasignaciones = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        vm.subasignaciones.push(obj);
      };

      $scope.deleteSubasignaciones = function (index) {
        vm.subasignaciones.splice(index, 1);
      };

      $scope.addSubsubasignaciones = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        $scope.subsubasignacion.push(obj);
      };

      $scope.deleteSubsubasignaciones = function (index) {
        $scope.subsubasignacion.splice(index, 1);
      };

      $http.get(url.IP + "usuarios/").then(function (user) {
        $scope.users = user.data.results;

        $scope.show_pagination = true;
      });

      $scope.saveSub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.grupo.level_grouping = padre.level_grouping;
        $scope.grupo.parent = padre.url;
        $scope.grupo.type_grouping = 2;

        if (!$scope.grupo.description) {
          l.stop();
          SweetAlert.swal(
            "Error",
            "Agrega un nombre de subagrupación.",
            "error"
          );
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "groupinglevel/",
          data: $scope.grupo,
        })
          .then(function (request_sub) {
            if (request_sub.status === 200 || request_sub.status === 201) {
              $rootScope.changeAgrupacion2(padre);
              $scope.sub_subasignaciones = padre.subsubgrupos;
              if ($scope.subsubasignacion.length > 0) {
                $scope.subsubasignacion.forEach(function (item, index) {
                  var datas = {
                    description: item.description,
                    responsable: $scope.grupo.responsable,
                    parent: request_sub.data.url,
                    type_grouping: 3,
                    level_grouping: group.level_grouping,
                  };

                  $http({
                    method: "POST",
                    url: url.IP + "groupinglevel/",
                    data: datas,
                  })
                    .then(function (response) {
                      if (response.status === 200 || response.status === 201) {
                        $rootScope.changeAgrupacion2(padre);
                        $scope.sub_subasignaciones.push(response.data);
                        $scope.agrupaciones.subgrupos.forEach(function (
                          sub,
                          index
                        ) {
                          if (sub.id == request_sub.data.id) {
                            vm.agrupaciones.subgrupos[index].subsubgrupos.push(
                              response.data
                            );
                          }
                        });
                      }
                    })
                    .catch(function (e) {
                      l.stop();
                      console.log("e", e);
                    });

                  if ($scope.subsubasignacion.length == index + 1) {
                    vm.agrupaciones.forEach(function (gpo) {
                      if (
                        gpo.description == vm.form.grouping_level.description
                      ) {
                        vm.form.grouping_level = gpo;
                      }
                    });
                  }
                });
              }
              try {
                $scope.sub_asignaciones.push(request_sub.data);
              } catch (e) {
                $scope.sub_asignaciones = request_sub.data;
              }
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.saveSubsub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.grupo.level_grouping = padre.level_grouping;
        $scope.grupo.parent = padre.url;
        $scope.grupo.type_grouping = 3;

        if (!$scope.grupo.description) {
          l.stop();
          SweetAlert.swal(
            "Error",
            "Agrega un nombre de subsubagrupación.",
            "error"
          );
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "groupinglevel/",
          data: $scope.grupo,
        })
          .then(function (request_sub) {
            if (request_sub.status === 200 || request_sub.status === 201) {
              // $scope.sub_subasignaciones.push(request_sub.data);
              $scope.sub_subasignaciones = padre.subsubgrupos;
              try {
                $scope.sub_subasignaciones.push(request_sub.data);
              } catch (e) {
                $scope.sub_subasignaciones = request_sub.data;
              }
              $rootScope.changeAgrupacion2(padre);
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    function openModalClasification(level) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/contratantes/contratantes.clasificacion.html",
        controller: ModaClasificationCtrl,
        resolve: {
          parent: function () {
            return vm;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }
    function openModalCelulaContractor(level) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/contratantes/contratantes.celulas.html",
        controller: ModalCelulasCtrl,
        resolve: {
          parent: function () {
            return vm;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }
    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    function ModaClasificationCtrl($scope, $uibModalInstance, parent) {
      $scope.classification = {};

      $scope.save = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        ($scope.classification.classification_name =
          $scope.classification.classification_name),
          ($scope.classification.description =
            $scope.classification.description),
          $http({
            method: "POST",
            url: url.IP + "classification/",
            data: $scope.classification,
          })
            .then(function (response) {
              if (response.status === 200 || response.status === 201) {
                l.stop();
                vm.clasifications.push(response.data);
                $scope.cancel();
              }
            })
            .catch(function (e) {
              l.stop();
              console.log("e", e);
            });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    function ModalCelulasCtrl($scope, $uibModalInstance, parent) {
      $scope.celula = {};
      dataFactory.get("usuarios/").then(function (user) {
        $scope.usuarios_saam = user.data.results;
      });
      $scope.save_celula = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();

        $scope.celula.celula_name = $scope.celula.celula_name;
        $scope.celula.description = $scope.celula.description;
        $scope.celula.users_many = $scope.usuarios_selected
          ? $scope.usuarios_selected
          : [];
        $http({
          method: "POST",
          url: url.IP + "celula_contractor/",
          data: $scope.celula,
        })
          .then(function (response) {
            if (response.status === 200 || response.status === 201) {
              vm.celulas.push(response.data);
              $scope.cancel_celula();
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };

      $scope.cancel_celula = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.selectUsuarios = function (sel) {
        $scope.usuarios_selected = [];
        sel.forEach(function (u) {
          if (u.url) {
            $scope.usuarios_selected.push(u.url);
          } else {
            $scope.usuarios_selected.push(u);
          }
        });
      };
    }
    // vm.changeGroup = changeGroup;
    $rootScope.changeGroup = function (data) {
      if (data) {
        if (data.id) {
          dataFactory
            .post("subgrupos-match/", { parent: data.id })
            .then(function (subgrupos_) {
              vm.subgroups = subgrupos_.data;
            });
        } else {
          if (data) {
            if (data.subgrupos) {
              vm.subgroups = data.subgrupos;
            } else {
              vm.subgroups = [];
            }
          } else {
            vm.subgroups = [];
          }
        }
      } else {
        vm.subgroups = [];
      }
      // vm.subgroups = data.subgrupos;
      vm.juridicalForm.group = data;
      vm.form.group = data;
      if (data.responsable) {
        $http
          .get(data.responsable)
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.form.responsable = request.data;
                vm.juridicalForm.responsable = request.data;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else {
        vm.form.responsable = "";
        vm.juridicalForm.responsable = "";
      }
    };

    $rootScope.changeSubGroup = function (data) {
      // vm.sub_subgroups = data.subsubgrupos;
      // $rootScope.changeGroup(vm.juridicalForm.group ? vm.juridicalForm.group : vm.form.group)
      if (data) {
        if (data.subsubgrupos) {
          vm.sub_subgroups = data.subsubgrupos;
        } else {
          vm.sub_subgroups = [];
        }
      } else {
        vm.sub_subgroups = [];
      }
    };

    $rootScope.changeAgrupacion2 = function (data) {
      if (data) {
        if (data.id && data.type_grouping == 1) {
          dataFactory
            .post("subagrupaciones-match/", { parent: data.id })
            .then(function (subgrupos_) {
              $scope.sub_asignaciones = subgrupos_.data;
              // $scope.sub_subasignaciones = [];
            });
        } else {
          if (data) {
            if (data.subgrupos) {
              $scope.sub_asignaciones = data.subgrupos;
            } else if (data.subsubgrupos) {
              $scope.sub_subasignaciones = data.subsubgrupos;
            }
          } else {
            $scope.sub_asignaciones = [];
          }
        }
      } else {
        $scope.sub_asignaciones = [];
      }
      // $scope.sub_asignaciones = data.subgrupos;
    };

    $rootScope.changeSubagrupacion2 = function (data) {
      // if(data.subsubgrupos){
      //   vm.sub_subasignaciones = data.subsubgrupos;
      // }
      if (data) {
        if (data.subsubgrupos) {
          $scope.sub_subasignaciones = data.subsubgrupos;
        } else {
          $scope.sub_subasignaciones = [];
        }
      } else {
        $scope.sub_subasignaciones = [];
      }
    };

    $rootScope.changeVendedor = function (data) {
      vm.juridicalForm.vendedor = data;
      vm.form.vendedor = data;
    };

    $scope.changeResponsable_single = function (data) {
      vm.form.responsable = data;
    };
    $scope.exportData = function (type_person) {
      // var header = '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      // var blob = new Blob([header + document.getElementById('exportable').innerHTML], {
      //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
      // });
      // saveAs(blob, "Reporte_" + aseguradoras + ".xls");
      // fisicas y morales

      var data = { cadena: $scope.param_cadena };
      if (type_person == 1) {
        // naturales
        $http
          .get(url.IP + "reporte-fisicas/")
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "ContratantesFisicos");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      } else if (type_person == 2) {
        $http
          .get(url.IP + "reporte-morales/")
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "ContratantesMorales");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
      if (type_person == 3) {
        // naturales seeker
        $http({
          method: "GET",
          url: url.IP + "reporte-seekerNaturals/",
          params: data,
        })
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "Contratantes_Naturales");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
      if (type_person == 4) {
        // juridicals seeker

        $http({
          method: "GET",
          url: url.IP + "reporte-seekerJuridicals/",
          params: data,
        })
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "Contratantes_Morales");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    $scope.filterValue = function ($event) {
      if (isNaN(String.fromCharCode($event.charCode))) {
        $event.preventDefault();
      }
    };

    $rootScope.show_contractor = true;
    $scope.returnToPolicy = function () {
      $rootScope.show_contractor = false;
    };

    // show / hide buttons personaFisica personaMoral
    $scope.showButtonFisica = function () {
      $scope.fisicas = true;
      $scope.morales = false;
      $("#saveButtonMoralModal").css("display", "none");
      $("#saveButtonFisicaModal").css("display", "block");
    };

    $scope.showButtonMoral = function () {
      $scope.fisicas = false;
      $scope.morales = true;
      $("#saveButtonFisicaModal").css("display", "none");
      $("#saveButtonMoralModal").css("display", "block");
    };

    $scope.cancelChanges = function () {
      $rootScope.show_contractor = false;
      // if($("#modalContratate")){
      //   if( $uibModalInstance.dismiss('cancel')){
      //     $timeout(function () {
      //       $("#createOTS").click();
      //         }, 1);
      //   }
      // }
    };

    $scope.selectDate = function (parDate) {};

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");

      return date;
    }

    function mesDiaAnio(parDate) {
      var d = new Date(toDate(parDate));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      return date;
    }

    // TEST pagination contrantes
    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      // $scope.selectPage = function (parPage) {
      //   vm.Consultar($scope.order, parPage);
      // };

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        vm.Consultar($scope.order, parPage);
      };
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getContratantesPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    //Pagination----

    // configuración del datepicker
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
    //-- Peticion de persistencia--//

    var json_data = {};
    var form = document.getElementsByTagName("form");
    var elementos = {};
    //Valores reutilizables
    var interval, interval1, dt, valor;
    var count = 0;

    function set_dataForm(json) {
      PersistenceFactory.set_inputs(json);
      if (json["vm.form.first_name"] != "") {
        vm.form.first_name = json["vm.form.first_name"];
      }
      if (json["vm.form.last_name"] != "") {
        vm.form.last_name = json["vm.form.last_name"];
      }
      if (json["vm.form.second_last_name"] != "") {
        vm.form.second_last_name = json["vm.form.second_last_name"];
      }
      if (json["vm.form.rfc"] != "") {
        vm.form.rfc = json["vm.form.rfc"];
      }
      if (json["vm.form.birthday"] != "") {
        vm.form.birthday = json["vm.form.birthday"];
      }
      if (json["vm.form.sex"] != "") {
        vm.form.sex = json["vm.form.sex"];
      }
      if (json["vm.form.emailMain"] != "") {
        vm.form.emailMain = json["vm.form.emailMain"];
      }
      if (json["inputValue"][0] != "") {
        vm.form.phoneMain = json["inputValue"][0].valor;
      }
      if (json["vm.form.group"] != "") {
        valor = PersistenceFactory.find_index(
          vm.groups,
          json["vm.form.group"][0].valor,
          "url"
        );
        vm.form.group = vm.groups[valor];
      }
      //vm.address_type
      if (json["address.tipo"]) {
        if (json["address.tipo"][0].valor != "") {
          valor = PersistenceFactory.find_index(
            vm.address_type,
            json["address.tipo"][0].valor,
            "name"
          );
          vm.form.userAddresses[0].tipo = vm.address_type[valor];
        }
        if (json["address.tipo"][1].valor != "") {
          valor = PersistenceFactory.find_index(
            vm.address_type,
            json["address.tipo"][1].valor,
            "name"
          );
          vm.juridicalForm.userAddresses[0].tipo = vm.address_type[valor];
        }
      }
      if (json["address.administrative_area_level_1"]) {
        if (json["address.administrative_area_level_1"][0].valor != "") {
          valor = PersistenceFactory.find_index(
            vm.statesArray,
            json["address.administrative_area_level_1"][0].valor,
            "url"
          );
          vm.form.userAddresses[0].administrative_area_level_1 =
            vm.statesArray[valor];

          if (json["address.administrative_area_level_2"][0].valor != "") {
            valor = PersistenceFactory.find_index(
              vm.form.userAddresses[0].administrative_area_level_1.cities,
              json["address.administrative_area_level_2"][0].valor,
              "url"
            );
            vm.form.userAddresses[0].administrative_area_level_2 =
              vm.form.userAddresses[0].administrative_area_level_1.cities[
                valor
              ];
          }
        }
        //Falta segundo vm.juridicalForm
        if (json["address.administrative_area_level_1"][1].valor != "") {
          valor = PersistenceFactory.find_index(
            vm.statesArray,
            json["address.administrative_area_level_1"][1].valor,
            "url"
          );
          vm.juridicalForm.userAddresses[0].administrative_area_level_1 =
            vm.statesArray[valor];

          if (json["address.administrative_area_level_2"][1].valor != "") {
            console.log(vm.juridicalForm.userAddresses);
            valor = PersistenceFactory.find_index(
              vm.juridicalForm.userAddresses[0].administrative_area_level_1
                .cities,
              json["address.administrative_area_level_2"][1].valor,
              "url"
            );
            vm.juridicalForm.userAddresses[0].administrative_area_level_2 =
              vm.juridicalForm.userAddresses[0].administrative_area_level_1.cities[
                valor
              ];
          } /**/
        }
      }

      if (json["address.route"]) {
        if (json["address.route"][0].valor != "text") {
          vm.form.userAddresses[0].route = json["address.route"][0].valor;
        }
        if (json["address.route"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].route =
            json["address.route"][1].valor;
        }
      }
      if (json["address.street_number"]) {
        if (json["address.street_number"][0].valor != "text") {
          vm.form.userAddresses[0].street_number =
            json["address.street_number"][0].valor;
        }
        if (json["address.street_number"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].street_number =
            json["address.street_number"][1].valor;
        }
      }
      if (json["address.street_number_int"]) {
        if (json["address.street_number_int"][0].valor != "text") {
          vm.form.userAddresses[0].street_number_int =
            json["address.street_number_int"][0].valor;
        }
        if (json["address.street_number_int"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].street_number_int =
            json["address.street_number_int"][1].valor;
        }
      }
      if (json["address.sublocality"]) {
        if (json["address.sublocality"][0].valor != "text") {
          vm.form.userAddresses[0].sublocality =
            json["address.sublocality"][0].valor;
        }
        if (json["address.sublocality"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].sublocality =
            json["address.sublocality"][1].valor;
        }
      }
      if (json["address.postal_code"]) {
        if (json["address.postal_code"][0].valor != "text") {
          vm.form.userAddresses[0].postal_code =
            json["address.postal_code"][0].valor;
        }
        if (json["address.postal_code"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].postal_code =
            json["address.postal_code"][1].valor;
        }
      }
      if (json["address.details"]) {
        if (json["address.details"][0].valor != "text") {
          vm.form.userAddresses[0].details = json["address.details"][0].valor;
        }
        if (json["address.details"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].details =
            json["address.details"][1].valor;
        }
      }
      if (json["vm.form.responsable"][0].valor != "") {
        valor = PersistenceFactory.find_index(
          vm.statesArray,
          json["vm.form.responsable"][0].valor,
          "url"
        );
        vm.form.responsable = vm.responsables[valor];
      }
      if (json["vm.form.responsable"][1].valor != "") {
        valor = PersistenceFactory.find_index(
          vm.statesArray,
          json["vm.form.responsable"][1].valor,
          "url"
        );
        vm.juridicalForm.responsable = vm.responsables[valor];
      }
      if (json["listaD.value"]) {
      }
      //Morales
      if (
        json["vm.juridicalForm.j_name"] != "" &&
        json["vm.juridicalForm.j_name"] != "text"
      ) {
        vm.juridicalForm.j_name = json["vm.juridicalForm.j_name"];
      }
      if (
        json["vm.juridicalForm.date_of_establishment"] != "" &&
        json["vm.juridicalForm.date_of_establishment"] != "text"
      ) {
        vm.juridicalForm.date_of_establishment =
          json["vm.juridicalForm.date_of_establishment"];
      }
      if (
        json["vm.juridicalForm.rfc"] != "" &&
        json["vm.juridicalForm.date_of_establishment"] != "text"
      ) {
        vm.juridicalForm.rfc = json["vm.juridicalForm.rfc"];
      }
      if (
        json["vm.juridicalForm.emailMain"] != "" &&
        json["vm.juridicalForm.emailMain"] != "text"
      ) {
        vm.juridicalForm.emailMain = json["vm.juridicalForm.emailMain"];
      }
      if (
        json["vm.juridicalForm.description"] != "" &&
        json["vm.juridicalForm.description"] != "text"
      ) {
        vm.juridicalForm.description = json["vm.juridicalForm.description"];
      }
      if (
        (json["inputValue"][4] != "") != "" &&
        json["inputValue"][4] != "text"
      ) {
        vm.juridicalForm.phoneMain = json["inputValue"][4].valor;
      }

      valor = angular.element('[ng-model="inputValue"]');
      angular.forEach(valor, function (v, a) {
        if (a == 3 || a == 7) {
          v.value = "";
        }
      });
      valor = angular.element('[ng-model="item.correo"]');
      angular.forEach(valor, function (v, a) {
        v.value = "";
      });
      valor = angular.element('[ng-model="listaD.value"]');
      angular.forEach(valor, function (v, a) {
        valor[a].checked = false;
        valor[a].setAttribute("aria-checked", "false");
      });
    }

    interval = setInterval(function () {
      if (form != undefined && PersistenceFactory.count == 0) {
        //&& PersistenceFactory.count == 0
        PersistenceFactory.inicial(
          vm.user.org,
          "Contratantes",
          vm.user.nameFull,
          PersistenceFactory.get_dataForm(form)
        );
      }
      if (PersistenceFactory.init_return != "") {
        clearInterval(interval);
        if (PersistenceFactory.init_return.status == "data_view") {
          set_dataForm(PersistenceFactory.json_return);
        }
        PersistenceFactory.interval = setInterval(function () {
          PersistenceFactory.editado(PersistenceFactory.get_dataForm(form));
        }, PersistenceFactory.intervalTime); /* /* */
      }
    }, 2000);
    //-- End Peticion de persistencia--//

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.length >= 3) {
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: false,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("vm.contratante.value", function (newValue, oldValue) {
      if (vm.contratante) {
        if (vm.contratante.value.address_contractor) {
          if (vm.contratante.value.address_contractor) {
            $scope.bound_solidarity = vm.contratante.value.url;
            $scope.has_solidario = true;
          }
        }
      }
    });
  }
})();

function closeContr() {
  $("#closeModalContr").click();
  $("#createOTS").click();
}

function saveContrFisica() {
  $("#saveButtonFisica").click();
}

function saveContrMoral() {
  $("#saveButtonMoral").click();
}

// function showButtonFisica() {
//     // $scope.fisicas = true;
//     // $scope.morales = false;
//     $("#saveButtonMoralModal").css("display", "none");
//     $("#saveButtonFisicaModal").css("display", "block");
// }
//
// function showButtonMoral() {
//     // $scope.fisicas = false;
//     // $scope.morales = true;
//
//     $("#saveButtonFisicaModal").css("display", "none");
//     $("#saveButtonMoralModal").css("display", "block");
// }

/* global angular */
(function () {
  "use strict";
  /* jshint devel: true */

  angular
    .module("inspinia")
    .controller("FianzasProgramaNewCtrl", FianzasProgramaNewCtrl);

  FianzasProgramaNewCtrl.$inject = [
    "appStates",
    "datesFactory",
    "dataFactory",
    "SweetAlert",
    "url",
    "ContratanteService",
    "groupService",
    "contactService",
    "generalService",
    "FileUploader",
    "toaster",
    "helpers",
    "globalVar",
    "MESSAGES",
    "$uibModal",
    "$filter",
    "$scope",
    "$rootScope",
    "$localStorage",
    "$timeout",
    "$q",
    "$state",
    "$sessionStorage",
    "$location",
    "$http",
    "$parse",
    "exportFactory",
    "PersistenceFactory",
  ];

  function FianzasProgramaNewCtrl(
    appStates,
    datesFactory,
    dataFactory,
    SweetAlert,
    url,
    ContratanteService,
    groupService,
    contactService,
    generalService,
    FileUploader,
    toaster,
    helpers,
    globalVar,
    MESSAGES,
    $uibModal,
    $filter,
    $scope,
    $rootScope,
    $localStorage,
    $timeout,
    $q,
    $state,
    $sessionStorage,
    $location,
    $http,
    $parse,
    exportFactory,
    PersistenceFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var orgParam = { params: { org: $localStorage.orgId } };
    // show / hide buttons
    $scope.fisicas = true;
    $scope.morales = false;
    $scope.flagPhone = false;
    $scope.responsables_natural = [];
    $scope.responsables_juridical = [];

    var vm = this;
    vm.org_name = usr.org;
    vm.Consultar = Consultar;
    vm.table = {};
    vm.changeTypePerson = changeTypePerson;
    vm.closeDropdown = closeDropdown;
    vm.order_asc = false;
    vm.listDocument = [
      {
        id: 1,
        name: "Identificación Oficial",
        value: false,
        file: false,
        arch: {},
      },
      { id: 2, name: "CURP", value: false, file: false, arch: {} },
      {
        id: 3,
        name: "Comprobante de Inscripción de Firma Electrónica",
        value: false,
        file: false,
        arch: {},
      },
      {
        id: 4,
        name: "Comprobante de Domicilio",
        value: false,
        file: false,
        arch: {},
      },
      {
        id: 5,
        name: "Formato de Identificación de Cliente Firmado",
        value: false,
        file: false,
        arch: {},
      },
      { id: 6, name: "Poder", value: false, file: false, arch: {} },
    ];
    if (vm.org_name == "ancora") {
      vm.listDocument = [
        {
          id: 1,
          name: "Identificación Oficial",
          value: false,
          file: false,
          arch: {},
        },
        { id: 2, name: "CURP", value: false, file: false, arch: {} },
        {
          id: 3,
          name: "Comprobante de Inscripción de Firma Electrónica",
          value: false,
          file: false,
          arch: {},
        },
        {
          id: 4,
          name: "Comprobante de Domicilio",
          value: false,
          file: false,
          arch: {},
        },
        {
          id: 5,
          name: "Formato de Identificación de Cliente Firmado",
          value: false,
          file: false,
          arch: {},
        },
      ];
    }
    $scope.infoUser = $sessionStorage.infoUser;
    $scope.onlyFianzas = function (q) {
      if (vm.form.only_sureties || vm.juridicalForm.only_sureties) {
        if (q == 1) {
          vm.listDocument.push(
            {
              id: 7,
              name: "Carta nombramiento",
              value: false,
              file: false,
              arch: {},
            },
            { id: 8, name: "Currículo", value: false, file: false, arch: {} },
            {
              id: 9,
              name: "Contrato multiple de la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            { id: 10, name: "Carta buro", value: false, file: false, arch: {} },
            {
              id: 11,
              name: "Entrevista con la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            { id: 12, name: "RFC", value: false, file: false, arch: {} },
            {
              id: 13,
              name: "Recibos de nomina",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 14,
              name: "Declaración anual completa con cadena de los últimos dos años inmediatos anteriores",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 15,
              name: "Estados financieros anuales del año inmediato anterior",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 16,
              name: "Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 17,
              name: "Alta ante hacienda o alta electrónica",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 18,
              name: "Escritura de inmueble",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 19,
              name: "Boleta predial o avaluó",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 20,
              name: "Certificado de libertad de gravamen",
              value: false,
              file: false,
              arch: {},
            }
          );
        } else if (q == 2) {
          vm.listDocument.push(
            {
              id: 7,
              name: "Currículo reciente",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 8,
              name: "Contrato multiple de la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            { id: 9, name: "Carta Buró", value: false, file: false, arch: {} },
            {
              id: 10,
              name: "Cuestionario o entrevista",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 11,
              name: "Aviso de privacidad de la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 12,
              name: "Protocolizaciones",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 13,
              name: "Alta de empresa ante hacienda",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 14,
              name: "Cambio de domicilio ante hacienda",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 15,
              name: "Copia del comprobante de inscripción para la e.firma (firma electrónica)",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 16,
              name: "Declaración anual completa con cadena, de los últimos dos años",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 17,
              name: "Estados financieros dictaminados cuadernillo completo, del año inmediato anterior",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 18,
              name: "Estados financieros parciales los más recientes de este año con no mayor antigüedad de dos meses",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 19,
              name: "Escritura de inmueble",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 20,
              name: "Boleta predial o avaluó",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 21,
              name: "Certificado de libertad de gravamen",
              value: false,
              file: false,
              arch: {},
            }
          );
        }
      } else {
        if (q == 1) {
          vm.listDocument = [
            {
              id: 1,
              name: "Identificación Oficial",
              value: false,
              file: false,
              arch: {},
            },
            { id: 2, name: "CURP", value: false, file: false, arch: {} },
            {
              id: 3,
              name: "Comprobante de Inscripción de Firma Electrónica",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Formato de Identificación de Cliente Firmado",
              value: false,
              file: false,
              arch: {},
            },
            { id: 6, name: "Poder", value: false, file: false, arch: {} },
          ];
          if (vm.org_name == "ancora") {
            vm.listDocument = [
              {
                id: 1,
                name: "Identificación Oficial",
                value: false,
                file: false,
                arch: {},
              },
              { id: 2, name: "CURP", value: false, file: false, arch: {} },
              {
                id: 3,
                name: "Comprobante de Inscripción de Firma Electrónica",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 4,
                name: "Comprobante de Domicilio",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 5,
                name: "Formato de Identificación de Cliente Firmado",
                value: false,
                file: false,
                arch: {},
              },
            ];
          }
        } else if (q == 2) {
          vm.listDocument = [
            {
              id: 1,
              name: "Acta Constitutiva",
              value: false,
              file: false,
              arch: {},
            },
            { id: 2, name: "RFC", value: false, file: false, arch: {} },
            {
              id: 3,
              name: "Cédula de Identificación Fiscal",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio Fiscal",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Modificaciones al Acta Constitutiva",
              value: false,
              file: false,
              arch: {},
            },
            { id: 6, name: "Poder", value: false, file: false, arch: {} },
          ];
        }
      }
    };
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    $scope.sucursal = function (sc) {};

    $scope.docs = {};
    $scope.type = function (r) {
      if (r == 1) {
        vm.listDocument = [
          {
            id: 1,
            name: "Identificación Oficial",
            value: false,
            file: false,
            arch: {},
          },
          { id: 2, name: "CURP", value: false, file: false, arch: {} },
          {
            id: 3,
            name: "Comprobante de Inscripción de Firma Electrónica",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 4,
            name: "Comprobante de Domicilio",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 5,
            name: "Formato de Identificación de Cliente Firmado",
            value: false,
            file: false,
            arch: {},
          },
          { id: 6, name: "Poder", value: false, file: false, arch: {} },
        ];
        if (vm.org_name == "ancora") {
          vm.listDocument = [
            {
              id: 1,
              name: "Identificación Oficial",
              value: false,
              file: false,
              arch: {},
            },
            { id: 2, name: "CURP", value: false, file: false, arch: {} },
            {
              id: 3,
              name: "Comprobante de Inscripción de Firma Electrónica",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Formato de Identificación de Cliente Firmado",
              value: false,
              file: false,
              arch: {},
            },
          ];
        }
        $scope.type_person_selected = r;
      } else if (r == 2) {
        vm.listDocument = [
          {
            id: 1,
            name: "Acta Constitutiva",
            value: false,
            file: false,
            arch: {},
          },
          { id: 2, name: "RFC", value: false, file: false, arch: {} },
          {
            id: 3,
            name: "Cédula de Identificación Fiscal",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 4,
            name: "Comprobante de Domicilio Fiscal",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 5,
            name: "Modificaciones al Acta Constitutiva",
            value: false,
            file: false,
            arch: {},
          },
          { id: 6, name: "Poder", value: false, file: false, arch: {} },
        ];
        $scope.type_person_selected = r;
      } else {
      }
    };

    function closeDropdown() {
      $(".hasDropdown").removeClass("open");
    }

    vm.form = {
      contratante: "0",
      grupo: "",
      type_person: 0,
      rfc: "0",
      vendedor: "",
      only_sureties: true,
      has_programa_de_proveedores: true,
    };

    $scope.contractorNew = [];

    $scope.userInfo = {
      type_person: "",
      id: 0,
    };
    vm.user = usr;

    vm.table = {
      headers: ["Nombre", "Tipo", "Acciones"],
    };
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    vm.address_type = [
      {
        name: "Dirección Personal",
        id: 0,
      },
      {
        name: "Dirección Fiscal",
        id: 1,
      },
      {
        name: "Dirección de cobro",
        id: 2,
      },
      {
        name: "Dirección de paquetería",
        id: 3,
      },
      {
        name: "Dirección de riesgo",
        id: 4,
      },
      {
        name: "CFDI",
        id: 5,
      },
    ];

    vm.clasifications = [
      // {name: 'Pequeño', value: 1},
      // {name: 'Regular', value: 2},
      // {name: 'Grande', value: 3},
      // {name: 'Jumbo', value: 4}
    ];
    vm.celulas = [];
    vm.agrupaciones = [];

    // $(window).load(function() {
    //     $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });

    $scope.selectConditions = function (sel) {
      vm.condition_selected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.condition_selected.push(parseInt(r));
      });
    };

    function changeTypePerson(obj) {
      vm.form.type_person = obj;
    }

    function Consultar(order, parPage) {
      if (vm.order_asc) {
        vm.order_asc = false;
      } else {
        vm.order_asc = true;
      }
      if (vm.show_binnacle == true) {
        vm.show_binnacle = false;
      }
      vm.show_pagination = false;
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;
      $scope.results = true;
      if (vm.form.type_person) {
        var parUrl = url.IP + "filtros-contractor/";
      } else {
        toaster.info("Debe seleccionar un tipo de contratante");
        return;
      }
      // New url fussion --
      // var parUrl = url.IP + 'filtros-contractor/';
      if (vm.form.group) {
        if (vm.form.group.val) {
          var g = vm.form.group.value;
        } else {
          var g = 0;
        }
      } else {
        var g = 0;
      }
      if (vm.form.contratante) {
        var c = vm.form.contratante;
      } else {
        var c = 0;
      }
      if (vm.form.rfc) {
        var f = vm.form.rfc;
      } else {
        var f = 0;
      }

      var params = {
        contratante: c ? c : 0,
        rfc: f ? f : 0,
        grupo: g ? g : 0,
        order: vm.order_asc ? vm.order_asc : 0,
        condicion: vm.condition_selected ? vm.condition_selected : 0,
        parPage: parPage ? parPage : 1,
        type_person: vm.form.type_person ? vm.form.type_person : 1,
      };
      $http({
        method: "POST",
        url: parUrl,
        data: params,
      }).then(function success(response) {
        if (response.status == 200 && response.data.results.length) {
          vm.persons.all = response.data.results;
          // if(vm.form.type_person == 1){
          //   vm.persons.naturals = response.data.results;
          //   vm.persons.juridicals = [];
          // }
          // else if (vm.form.type_person == 2) {
          //   vm.persons.juridicals = response.data.results;
          //   vm.persons.naturals = [];
          // }
          // else {
          //   vm.persons.all = response.data.results;
          // }
          $scope.order = vm.order_asc;
          vm.persons_config = {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          };
          $scope.personn_config = {
            count: response.data.count,
            previous: parUrl,
            next: parUrl,
          };
          vm.show_pagination = true;
          $scope.testPagination("vm.persons.naturals", "personn_config");
        } else {
          toaster.warning("No se encontraron registros");
          vm.persons.naturals = [];
        }
      });
    }

    vm.exportDataE = exportDataE;
    vm.hoy = new Date();

    function exportDataE(param) {
      if (vm.form.type_person) {
        var parUrl = url.IP + "service_reporte-contractor-excel";
      } else {
        toaster.info("Debe seleccionar un tipo de contratante");
        return;
      }
      var parUrl = url.IP + "service_reporte-contractor-excel";
      if (vm.form.group) {
        var g = vm.form.group.value;
      } else {
        var g = 0;
      }
      if (vm.form.contratante) {
        var c = vm.form.contratante;
      } else {
        var c = 0;
      }
      if (vm.form.rfc) {
        var f = vm.form.rfc;
      } else {
        var f = 0;
      }
      var params = {
        contratante: c,
        rfc: f,
        grupo: g,
        order: vm.order_asc,
        condicion: vm.condition_selected ? vm.condition_selected : 0,
        type_person: 0,
      };
      $http({
        method: "POST",
        url: parUrl,
        data: params,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function (data, status, headers, config) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Contratantes.xls");
        })
        .catch(function (e) {
          console.log("e", e);
        });
      // }). then(function success(response) {
      //   if(response.status === 200) {
      //    exportFactory.excel(response.data, 'Contratantes');
      // }
      //  })
    }

    $scope.matchesGroup = function (parWord, parType) {
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        var word_data = vm.form.group.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    };

    $scope.selectRfc = function (rfc) {
      vm.form.rfc = rfc.replace(/-/g, "");
    };
    vm.search = search;
    function search(cadena) {
      vm.show_binnacle = false;
      vm.show_pagination = false;
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;

      if (cadena.length) {
        $http({
          method: "GET",
          url: url.IP + "seeker-contractors/",
          params: {
            cadena: cadena,
            type_person: 1,
          },
        })
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.persons.juridicals = [];
                vm.persons.naturals = [];
                vm.persons = [];
                vm.persons.naturals = request.data.results;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });

        $http({
          method: "GET",
          url: url.IP + "seeker-juridicals/",
          params: {
            cadena: cadena,
            type_person: 2,
          },
        })
          .then(
            function success(request) {
              vm.persons.naturals = [];
              vm.persons.juridicals = [];
              if (request.status === 200) {
                vm.persons.naturals = [];
                vm.persons.juridicals = [];
                vm.persons = [];
                vm.persons.juridicals = request.data.results;
                vm.juridicals_config = {
                  count: request.data.count,
                  next: request.data.next,
                  previous: request.data.previous,
                };
                vm.show_pag_juridicals = true;
                vm.buttonsJuridicals = true;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else {
        vm.persons.juridicals = [];
        vm.persons.naturals = [];
      }
    }

    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      // if ($uibModalInstance) {
      //     $uibModalInstance.dismiss('cancel');
      // }
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWCONTRACTOR, "success");
        if (vm.acceso_ver_cont) {
          $state.go("fianzas.pprovnew", {
            type:
              $scope.contractorNew.type_person == "Fisica"
                ? "fisicas"
                : "morales",
            contratanteId: $scope.contractorNew.id,
          });
        } else {
          $state.go("fianzas.pprovlist");
        }
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        name: fileItem.file.name,
      });
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].name = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };
    //archivos lista documentos
    $scope.addFileList = function (index, lista, file, xy) {
      var extension = file[0].formData[0].name.split(".")[1];
      file[0].formData[0].name = vm.listDocument[index].name + "." + extension;
      vm.listDocument[index].arch = file[0];
      vm.listDocument[index].file = true;
      $scope.uploaderDocument.queue = [];
    };
    var uploaderDocument = ($scope.uploaderDocument = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploaderDocument.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploaderDocument.onSuccessItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      // if ($uibModalInstance) {
      //     $uibModalInstance.dismiss('cancel');
      // }
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWCONTRACTOR, "success");
        if (vm.acceso_ver_cont) {
          $state.go("fianzas.pprovnew", {
            type:
              $scope.contractorNew.type_person == "Fisica"
                ? "fisicas"
                : "morales",
            contratanteId: $scope.contractorNew.id,
          });
        } else {
          $state.go("fianzas.pprovlist");
        }
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploaderDocument.onErrorItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploaderDocument.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        name: fileItem.file.name,
      });
    };

    uploaderDocument.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].name = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };
    //archivos lista docuemntos
    function uploadFilesList(typePerson, idPerson) {
      $scope.userInfo = {
        id: idPerson,
      };
      // $scope.userInfo.url = url.IP + checkType(typePerson) + '/' + idPerson + '/archivos/';
      $scope.userInfo.url =
        url.IP + "contractors" + "/" + idPerson + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploaderDocument.uploadAll();
      }, 1000);
    }
    //archivos lista docuemntos
    function uploadFiles(typePerson, idPerson) {
      $scope.userInfo = {
        id: idPerson,
      };
      // $scope.userInfo.url = url.IP + checkType(typePerson) + '/' + idPerson + '/archivos/';
      $scope.userInfo.url =
        url.IP + "contractors" + "/" + idPerson + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
        $state.go("fianzas.pprovnew", {
          type: $scope.contractorNew.type_person == 1 ? "fisicas" : "morales",
          contratanteId: $scope.contractorNew.id,
        });
      }, 1000);
    }

    // Contractor
    vm.persons = [];
    vm.checkRFC = checkRFC;
    vm.cancel = cancel;
    vm.submitJuridical = submitJuridical;
    vm.submitFormJuridical1 = submitFormJuridical1;
    vm.checkType = checkType;
    vm.goToContractorView = goToContractorView;

    vm.control = {
      closeModal: function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      },
    };

    function goToContractorView(person) {
      // if($scope.edit_natural || $scope.edit_juridical) {
      $state.go("contratantes.edit", {
        // develop
        // $state.go('contratantes.info', {
        type: checkType(person.type_person),
        contratanteId: person.id,
      });
      // }
    }

    function cancel() {
      $state.go("fianzas.pprovlist");
    }

    // function goToContractorView(person) {
    //   $state.go('contratantes.edit', {
    //       type: checkType(person.type_person),
    //       contratanteId: person.id
    //   });
    // }

    // Groups
    vm.groups = [];
    vm.openModalGroup = openModalGroup;
    vm.openModalAsignacion = openModalAsignacion;
    vm.openModalClasification = openModalClasification;
    vm.openModalCelulaContractor = openModalCelulaContractor;

    // Contacts
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;

    // Addresses, States and cities functions
    vm.addresses = {
      add: addAddress,
      selectedState: selectedState,
      delete: deleteAddress,
    };

    vm.statesArray = [];

    // Disabled after save
    vm.disabledAfterSave = false;
    vm.showBinnacle = showBinnacle;
    vm.returnToContractors = returnToContractors;
    //-----------------------------------------------------------comments
    function showBinnacle(param) {
      vm.show_binnacle = true;
      vm.person_id = param.id;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 2,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }
    //-------------------------------------------------------------comments

    function addAddress(type) {
      // HACK remove before production
      var address = {
        raw: "",
        street_address: "",
        intersection: "",
        political: "",
        administrative_area_level_1: "",
        administrative_area_level_1_short: "",
        administrative_area_level_2: "",
        administrative_area_level_3: "",
        colloquial_area: "",
        sublocality: "",
        neighborhood: "",
        premise: "",
        subpremise: "",
        natural_feature: "",
        country: "",
        country_code: "",
        locality: "",
        postal_code: "",
        route: "",
        street_number: "",
        street_number_int: "",
        formatted: "",
        latitude: "",
        longitude: "",
        details: "",
        composed: "",
      };
      if (type === 1) {
        vm.form.userAddresses.push(address);
      } else {
        vm.juridicalForm.userAddresses.push(address);
      }
    }

    function deleteAddress(index, type) {
      if (type === 1) {
        vm.form.userAddresses.splice(index, 1);
      } else {
        vm.juridicalForm.userAddresses.splice(index, 1);
      }
    }

    function selectedState(selected, index, type) {
      if (type === 1) {
        vm.form.userAddresses[index].city = "";
        vm.form.userAddresses[index].citiesList = selected.cities;
      } else {
        vm.juridicalForm.userAddresses[index].city = "";
        vm.juridicalForm.userAddresses[index].citiesList = selected.cities;
      }
    }

    vm.form = {
      birthday: null,
      description: "",
      first_name: "",
      last_name: "",
      rfc: "",
      second_last_name: "",
      sex: null,
      emails: [{ correo: "", email_type: "" }],
      responsables: [{ responsables: "", resp_type: "" }],
      phones: [{ phone: "", phone_type: "" }],
      userAddresses: [
        {
          raw: "",
          street_address: "",
          intersection: "",
          political: "",
          administrative_area_level_1: "",
          administrative_area_level_1_short: "",
          administrative_area_level_2: "",
          administrative_area_level_3: "",
          colloquial_area: "",
          sublocality: "",
          neighborhood: "",
          premise: "",
          subpremise: "",
          natural_feature: "",
          country: "",
          country_code: "",
          locality: "",
          postal_code: "",
          route: "",
          street_number: "",
          street_number_int: "",
          formatted: "",
          latitude: "",
          longitude: "",
          details: "",
          composed: "",
        },
      ],
      contact_natural: [],
      vendedor: "",
    };

    vm.juridicalForm = {
      userAddresses: [
        {
          raw: "",
          street_address: "",
          intersection: "",
          political: "",
          administrative_area_level_1: "",
          administrative_area_level_1_short: "",
          administrative_area_level_2: "",
          administrative_area_level_3: "",
          colloquial_area: "",
          sublocality: "",
          neighborhood: "",
          premise: "",
          subpremise: "",
          natural_feature: "",
          country: "",
          country_code: "",
          locality: "",
          postal_code: "",
          route: "",
          street_number: "",
          street_number_int: "",
          formatted: "",
          latitude: "",
          longitude: "",
          details: "",
          composed: "",
        },
      ],
      date_of_establishment: null,
      description: "",
      j_name: "",
      rfc: "",
      contact_juridical: [],
      emails: [{ email: "", email_type: "" }],
      responsables: [{ responsable: "", resp_type: "" }],
      phones: [{ phone: "", phone_type: "" }],
      vendedor: "",
    };

    activate();
    $(".js-example-basic-multiple").select2();
    vm.emptyOrNull = function (item) {
      return !(item === null || item.trim().length === 0);
    };

    vm.activate = activate;
    function activate() {
      $(".js-example-basic-multiple").select2();
      dataFactory
        .get("sucursales-to-show-unpag/")
        .then(function success(response) {
          $scope.sucursalList = response.data;
          if ($localStorage["save_filters_new_program"]) {
            $scope.sucursalList.forEach(function (item) {
              if (
                item.id == $localStorage["save_filters_new_program"]["sucursal"]
              ) {
                vm.form.sucursal = item;
              }
              if (
                item.id ==
                $localStorage["save_filters_new_program"]["j_sucursal"]
              ) {
                vm.juridicalForm.sucursal = item;
              }
            });
          }
        });
      vm.responsables = [];
      $http.get(url.IP + "get-vendors").then(function success(request) {
        vm.vendors = request.data;
        vm.vendors.forEach(function (vendor) {
          vendor.name = vendor.first_name + " " + vendor.last_name;
        });
      });
      $scope.filesContractor = true;

      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          vm.statesArray = data.data;
          $scope.readPdf();
        });

      // groupService.getGroups()
      // .then(function(groups) {
      //     vm.groups = groups;
      // });

      $http.get(url.IP + "gruposSubgrupos-resume/").then(function (response) {
        vm.groups = response.data;
        if ($localStorage["save_filters_new_program"]) {
          vm.groups.forEach(function (item) {
            if (item.id == $localStorage["save_filters_new_program"]["grupo"]) {
              vm.form.group = item;
            }
            if (
              item.id == $localStorage["save_filters_new_program"]["j_group"]
            ) {
              vm.juridicalForm.group = item;
            }
          });
        }
      });

      $http.get(url.IP + "usuarios/").then(function (user) {
        vm.responsables = user.data.results;
      });

      $http.get(url.IP + "groupingLevel-resume/").then(function (response) {
        vm.agrupaciones = response.data;
        if ($localStorage["save_filters_new_program"]) {
          vm.agrupaciones.forEach(function (item) {
            if (
              item.id ==
              $localStorage["save_filters_new_program"]["grouping_level"]
            ) {
              vm.form.celula = item;
            }
            if (
              item.id ==
              $localStorage["save_filters_new_program"]["j_grouping_level"]
            ) {
              vm.juridicalForm.celula = item;
            }
          });
        }
      });

      $http.get(url.IP + "classification/").then(function (response) {
        response.data.results.forEach(function (item) {
          vm.clasifications.push(item);
        });
      });
      $http.post(url.IP + "celula_contractor_info/").then(function (response) {
        vm.celulas = response.data;
        if ($localStorage["save_filters_new_program"]) {
          vm.celulas.forEach(function (item) {
            if (
              item.id == $localStorage["save_filters_new_program"]["celula"]
            ) {
              vm.form.celula = item;
            }
            if (
              item.id == $localStorage["save_filters_new_program"]["j_celula"]
            ) {
              vm.juridicalForm.celula = item;
            }
          });
        }
      });
      dataFactory.get("usuarios/").then(function (user) {
        $scope.usuarios_saam = user.data.results;
      });

      vm.form.first_name = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["first_name"]
        : "";
      vm.form.last_name = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["last_name"]
        : "";
      vm.form.second_last_name = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["second_last_name"]
        : "";
      vm.form.rfc = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["rfc"]
        : "";
      vm.form.sex = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["sex"]
        : "";
      vm.form.birthday = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["birthday"]
        : "";
      vm.form.celula = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["celula"]
        : "";
      vm.form.sucursal = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["sucursal"]
        : "";
      vm.form.grouping_level = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["grouping_level"]
        : "";
      vm.form.type_person = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["type_person"]
        : 1;
      vm.juridicalForm.j_name = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["j_name"]
        : "";
      vm.juridicalForm.date_of_establishment = $localStorage[
        "save_filters_new_program"
      ]
        ? $localStorage["save_filters_new_program"]["date_of_establishment"]
        : "";
      vm.juridicalForm.rfc = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["j_rfc"]
        : "";
      vm.juridicalForm.group = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["j_group"]
        : "";
      vm.juridicalForm.celula = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["j_celula"]
        : "";
      vm.juridicalForm.sucursal = $localStorage["save_filters_new_program"]
        ? $localStorage["save_filters_new_program"]["j_sucursal"]
        : "";
      vm.juridicalForm.grouping_level = $localStorage[
        "save_filters_new_program"
      ]
        ? $localStorage["save_filters_new_program"]["j_grouping_level"]
        : "";
    }

    if ("save_filters_new_program" in $localStorage) {
    } else {
      $localStorage["save_filters_new_program"] = {};
    }

    $scope.saveLocalstorange = function () {
      $localStorage["save_filters_new_program"]["first_name"] = vm.form
        .first_name
        ? vm.form.first_name
        : "";
      $localStorage["save_filters_new_program"]["last_name"] = vm.form.last_name
        ? vm.form.last_name
        : "";
      $localStorage["save_filters_new_program"]["second_last_name"] = vm.form
        .second_last_name
        ? vm.form.second_last_name
        : "";
      $localStorage["save_filters_new_program"]["grupo"] = vm.form.group
        ? vm.form.group.id
        : "";
      $localStorage["save_filters_new_program"]["birthday"] = vm.form.birthday
        ? vm.form.birthday
        : "";
      $localStorage["save_filters_new_program"]["sex"] = vm.form.sex
        ? vm.form.sex
        : "";
      $localStorage["save_filters_new_program"]["sucursal"] = vm.form.sucursal
        ? vm.form.sucursal
        : "";
      $localStorage["save_filters_new_program"]["celula"] = vm.form.celula
        ? vm.form.celula
        : "";
      $localStorage["save_filters_new_program"]["type_person"] = vm.form
        .type_person
        ? vm.form.type_person
        : "";
      $localStorage["save_filters_new_program"]["j_name"] = vm.juridicalForm
        .j_name
        ? vm.juridicalForm.j_name
        : "";
      $localStorage["save_filters_new_program"]["date_of_establishment"] = vm
        .juridicalForm.date_of_establishment
        ? vm.juridicalForm.date_of_establishment
        : "";
      $localStorage["save_filters_new_program"]["j_rfc"] = vm.juridicalForm.rfc
        ? vm.juridicalForm.rfc
        : "";
      $localStorage["save_filters_new_program"]["j_group"] = vm.juridicalForm
        .group
        ? vm.juridicalForm.group.id
        : "";
      $localStorage["save_filters_new_program"]["j_sucursal"] = vm.juridicalForm
        .sucursal
        ? vm.juridicalForm.sucursal
        : "";
      $localStorage["save_filters_new_program"]["j_celula"] = vm.juridicalForm
        .celula
        ? vm.juridicalForm.celula
        : "";
      $localStorage["save_filters_new_program"]["j_grouping_level"] = vm
        .juridicalForm.grouping_level
        ? vm.juridicalForm.grouping_level
        : "";
    };

    $scope.readPdf = function () {
      $scope.contratante_tipo = true;
      if ($location.path() == "/polizas/") {
        if ($rootScope.readPDF.corporation.corporation_name == null) {
          $scope.contratante_tipo = true;
          vm.form.first_name = $rootScope.readPDF.individual.first_name;
          vm.form.last_name = $rootScope.readPDF.individual.first_last_name;
          vm.form.second_last_name =
            $rootScope.readPDF.individual.second_last_name;
          vm.form.rfc = $rootScope.readPDF.individual.rfc;

          if ($rootScope.readPDF.address.state) {
            vm.statesArray.forEach(function (item) {
              if (
                sinDiacriticos(
                  $rootScope.readPDF.address.state.toLowerCase()
                ) == sinDiacriticos(item.state.toLowerCase())
              ) {
                vm.form.userAddresses[0].administrative_area_level_1 = item;
                if ($rootScope.readPDF.address.city) {
                  for (var k = 0; k < item.cities.length; k++) {
                    if (
                      sinDiacriticos(
                        $rootScope.readPDF.address.city.toLowerCase()
                      ) == sinDiacriticos(item.cities[k].city.toLowerCase())
                    ) {
                      vm.form.userAddresses[0].administrative_area_level_2 =
                        item.cities[k];
                    }
                  }
                }
              }
            });
          }

          vm.form.userAddresses[0].sublocality =
            $rootScope.readPDF.address.sublocality;
          vm.form.userAddresses[0].route = $rootScope.readPDF.address.street;
          vm.form.userAddresses[0].street_number =
            $rootScope.readPDF.address.street_number;
          vm.form.userAddresses[0].street_number_int =
            $rootScope.readPDF.address.street_number_int;
          vm.form.userAddresses[0].postal_code =
            $rootScope.readPDF.address.zip_code;
        } else {
          $scope.contratante_tipo = false;
          vm.juridicalForm.j_name =
            $rootScope.readPDF.corporation.corporation_name;
          vm.juridicalForm.rfc = $rootScope.readPDF.corporation.rfc;

          if ($rootScope.readPDF.address.state) {
            vm.statesArray.forEach(function (item) {
              if (
                sinDiacriticos(
                  $rootScope.readPDF.address.state.toLowerCase()
                ) == sinDiacriticos(item.state.toLowerCase())
              ) {
                vm.juridicalForm.userAddresses[0].administrative_area_level_1 =
                  item;
                if ($rootScope.readPDF.address.city) {
                  for (var k = 0; k < item.cities.length; k++) {
                    if (
                      sinDiacriticos(
                        $rootScope.readPDF.address.city.toLowerCase()
                      ) == sinDiacriticos(item.cities[k].city.toLowerCase())
                    ) {
                      vm.juridicalForm.userAddresses[0].administrative_area_level_2 =
                        item.cities[k];
                    }
                  }
                }
              }
            });
          }

          vm.juridicalForm.userAddresses[0].sublocality =
            $rootScope.readPDF.address.sublocality;
          vm.juridicalForm.userAddresses[0].route =
            $rootScope.readPDF.address.street;
          vm.juridicalForm.userAddresses[0].street_number =
            $rootScope.readPDF.address.street_number;
          vm.juridicalForm.userAddresses[0].street_number_int =
            $rootScope.readPDF.address.street_number_int;
          vm.juridicalForm.userAddresses[0].postal_code =
            $rootScope.readPDF.address.zip_code;
        }
      }
    };

    function sinDiacriticos(texto) {
      return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    vm.getAll = getAll;

    function getAll(param) {
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;

      if (param == "naturals" || param == undefined) {
        if (param == undefined) {
          $scope.type_person = "naturals";
        }
        var orgParam = { params: { org: $localStorage.orgId, type_person: 1 } };
        $http
          .get(url.IP + "contractor-resume/", orgParam)
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.persons.naturals = [];
                vm.persons.juridicals = [];
                vm.persons.naturals = request.data.results;
                vm.naturals_config = {
                  count: request.data.count,
                  next: request.data.next,
                  previous: request.data.previous,
                };
                vm.show_pag_naturals = true;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else if (param == "juridicals") {
        var orgParam = { params: { org: $localStorage.orgId, type_person: 2 } };
        // $http.get(url.IP + 'jrudicals-resume/', orgParam)
        $http
          .get(url.IP + "contractor-resume/", orgParam)
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.persons.juridicals = [];
                vm.persons.naturals = [];
                vm.persons.juridicals = request.data.results;
                vm.juridicals_config = {
                  count: request.data.count,
                  next: request.data.next,
                  previous: request.data.previous,
                };
                vm.show_pag_juridicals = true;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    }

    //Función getContratantes
    vm.getContratantesEs = getContratantesEs;
    function getContratantesEs(param) {
      vm.buttonsJuridicals = false;
      vm.buttonsNaturals = false;
      vm.show_binnacle = false;
      vm.show_pagination = false;
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;
      if (param == 1) {
        // $http.get(url.IP + 'fisicas-resume/' )
        $http.get(url.IP + "contractor-resume/").then(function (data) {
          //vm.results = data;
          vm.persons.juridicals = [];
          vm.persons.juridicals.length = 0;
          $scope.results = {
            data: data.data.results,
            config: {
              count: data.data.count,
              next: data.data.next,
              previous: data.data.previous,
            },
          };
          vm.persons.naturals = $scope.results.data;
          $scope.testPagination("vm.persons.naturals", "results.config");
        });
        //return vm.persons.naturals;
        $scope.show_pagination = true;
        vm.persons = [];
      } else if (param == 2) {
        // $http.get(url.IP + 'morales-resume/' )
        $http.get(url.IP + "contractor-resume/").then(function (data) {
          vm.persons.naturals = [];
          vm.persons.length = 0;
          $scope.results = {
            data: data.data.results,
            config: {
              count: data.data.count,
              next: data.data.next,
              previous: data.data.previous,
            },
          };
          vm.persons.juridicals = $scope.results.data;
          $scope.testPagination("vm.persons.juridicals", "results.config");
        });
        $scope.show_pagination = true;

        vm.persons = [];
      }
      if (vm.condicion == true) {
        vm.persons.naturals = [];
        vm.persons.juridicals = [];
      }
    }
    //Fin getContratantes
    function returnToContractors(param) {
      if (param) {
        vm.show_binnacle = false;
      } else {
        vm.show_binnacle = false;
      }
    }

    function checkRFC() {
      $scope.obligados = [];
      if (vm.form.obligados) {
        vm.form.obligados.forEach(function (elem, index) {
          if (elem.val) {
            if (elem.value) {
              $scope.obligados.push(elem.value.url);
            }
          }
        });
      }
      vm.form.bound_solidarity_many = $scope.obligados ? $scope.obligados : [];
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.form.rfc == undefined) vm.form.rfc = "";
      if (vm.form.rfc) vm.form.rfc = vm.form.rfc.replace("-", "");
      $http
        .post(url.IP + "existrfc", { rfc: vm.form.rfc, selector: 1 })
        .success(function (response) {
          if (response.status == true) {
            SweetAlert.swal(
              {
                title: "¡El RFC del contratante ya existe!",
                text: "¿Deseas continuar?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                closeOnConfirm: false,
              },
              function (isConfirm) {
                if (isConfirm) {
                  $scope.arrayEmail = vm.form.emails;
                  vm.form.emails = [];
                  $scope.arrayPhone = vm.form.phones;
                  vm.form.phones = [];

                  for (var i = 0; i < $scope.arrayEmail.length; i++) {
                    if ($scope.arrayEmail[i].correo) {
                      if ($scope.arrayEmail[i].email_type == 0) {
                        $scope.arrayEmail[i].email_type = 1;
                      }
                      vm.form.emails.push($scope.arrayEmail[i]);
                    }
                  }

                  for (var i = 0; i < $scope.arrayPhone.length; i++) {
                    if ($scope.arrayPhone[i].phone) {
                      if ($scope.arrayPhone[i].phone_type == 0) {
                        $scope.arrayPhone[i].phone_type = 1;
                      }
                      vm.form.phones.push($scope.arrayPhone[i]);
                    }
                  }

                  l.stop();
                  submitFormNatural();
                  $scope.rfc_getDate(vm.form.rfc);
                } else {
                  l.stop();
                  return;
                }
              }
            );
          } else {
            $scope.arrayEmail = vm.form.emails;
            vm.form.emails = [];
            $scope.arrayPhone = vm.form.phones;
            vm.form.phones = [];

            for (var i = 0; i < $scope.arrayEmail.length; i++) {
              if ($scope.arrayEmail[i].correo) {
                if ($scope.arrayEmail[i].email_type == 0) {
                  $scope.arrayEmail[i].email_type = 1;
                }
                vm.form.emails.push($scope.arrayEmail[i]);
              }
            }

            for (var i = 0; i < $scope.arrayPhone.length; i++) {
              if ($scope.arrayPhone[i].phone) {
                if ($scope.arrayPhone[i].phone_type == 0) {
                  $scope.arrayPhone[i].phone_type = 1;
                }
                vm.form.phones.push($scope.arrayPhone[i]);
              }
            }

            l.stop();
            submitFormNatural();
            $scope.rfc_getDate(vm.form.rfc, vm.form);
          }
        });
    }

    $scope.rfc_getDate = function (rfc) {
      if (vm.form.birthday) {
        return;
      }

      vm.rfc_fec = rfc.substr(4, 6);
      vm.rfc_anio = rfc.substr(4, 2);
      vm.rfc_month = rfc.substr(6, 2);
      vm.rfc_day = rfc.substr(8, 2);

      vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
      vm.date = new Date(vm.fecha);

      vm.aniorfc = vm.date.getFullYear();
      vm.hoyA = vm.hoy.getFullYear();
      if (vm.aniorfc > vm.hoyA) {
        vm.resta = vm.aniorfc - 100;
        vm.rfc_anio = vm.resta;
        vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
        if (form.birthday == "") {
          vm.form.birthday = vm.fecha;
        } else {
          vm.form.birthday = vm.fecha;
        }
      }
      vm.aniorfc = vm.date.getFullYear();
      if (vm.form.birthday == null) {
        var fecha_rfcn = $filter("date")(new Date(vm.date), "dd/MM/yyyy");
        vm.form.birthday = fecha_rfcn;
      } else {
        vm.form.birthday = vm.form.birthday;
      }
    };

    function submitFormNatural(argument) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.form.first_name == "") {
        l.stop();
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMNAME, "error");
        return;
      }
      if (vm.form.last_name == "") {
        l.stop();
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMLASTNAME, "error");
        return;
      }
      if (vm.form.birthday == "") {
        l.stop();
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMBIRTHDAY, "error");
        return;
      }
      if (vm.form.rfc == "") {
        // l.stop();
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        if ($location.path() == "/fianzas/") {
        } else {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMRFC, "error");
          return;
        }
      } else {
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
      }
      if (!vm.form.sex) {
        l.stop();
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMSEX, "error");
        return;
      }
      if (!vm.form.group) {
        l.stop();
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.SELGROUP, "error");
        return;
      }
      if (vm.form.emailMain) {
        if (!validateEmail(vm.form.emailMain)) {
          l.stop();
          if (vm.form.emails.length == 0) {
            vm.form.emails = [{ correo: "", email_type: "" }];
          }
          if (vm.form.phones.length == 0) {
            vm.form.phones = [{ phone: "", phone_type: "" }];
          }
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
      $scope.flagEmail = false;
      if (vm.form.emails.length > 0) {
        for (var i = 0; i < vm.form.emails.length; i++) {
          if (vm.form.emails[i].correo) {
            if (!validateEmail(vm.form.emails[i].correo)) {
              $scope.flagEmail = true;
            }
          }
        }
        if ($scope.flagEmail == true) {
          l.stop();
          $scope.flagEmail = false;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }

      if (!helpers.hasAtLeastOneAddress(vm.form.userAddresses)) {
        l.stop();
        toaster.warning(MESSAGES.ERROR.ADDATLEASTONEDIRECCTION);
      } else {
        var flag = false,
          outme = false;
        vm.form.contact_natural.forEach(function (contact) {
          if (contact.name == "") {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
            flag = true;
            return;
          } else {
            if (contact.email) {
              if (!validateEmail(contact.email)) {
                l.stop();
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.INVALIDEMAILCONTACT,
                  "error"
                );
                flag = true;
                return;
              }
            }
            if (contact.phone_number) {
              if (contact.phone_number.length < 9) {
                l.stop();
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.ERRORLENGTHPHONECONTACT,
                  "error"
                );
                return;
              }
            }
          }
        });

        if (flag) {
          return;
        }

        var form = angular.copy(vm.form);
        var arr = [];
        var nums = [];

        vm.form.contact_natural.forEach(function (elem, index) {
          arr.push(elem);
        });
        // form.birthday = $filter('date')(vm.form.birthday, 'yyyy-MM-dd');
        form.birth_date = $filter("date")(vm.form.birthday, "yyyy-MM-dd");
        form.contact = arr;
        form.group = form.subsubgrupo
          ? form.subsubgrupo.url
          : form.subgroup
          ? form.subgroup.url
          : form.group
          ? form.group.url
          : "";
        // form.grouping_level = form.subsubasignaciones ? form.subsubasignaciones.url : form.subagrupaciones ? form.subagrupaciones.url : form.grouping_level ? form.grouping_level.url : '';
        form.groupinglevel = form.subsubasignaciones
          ? form.subsubasignaciones.url
          : form.subagrupaciones
          ? form.subagrupaciones.url
          : form.grouping_level
          ? form.grouping_level.url
          : null;
        // form.celula = vm.form.celula ? vm.form.celula : null;
        form.cellule = vm.form.celula ? vm.form.celula : null;
        form.userAddresses = [];
        vm.form.userAddresses.forEach(function (elem, $index) {
          $scope.elems = elem;
          if (
            elem.administrative_area_level_1 == null ||
            !elem.administrative_area_level_1 ||
            elem.administrative_area_level_1 === undefined ||
            elem.administrative_area_level_1 == "undefined" ||
            elem.administrative_area_level_2 == null ||
            !elem.administrative_area_level_2 ||
            elem.administrative_area_level_2 === undefined ||
            elem.administrative_area_level_2 == "undefined"
          ) {
            l.stop();
            if (!vm.form.birthday) {
              vm.form.birthday = "";
            }
            if (vm.form.emails.length == 0) {
              vm.form.emails = [{ correo: "", email_type: "" }];
            }
            if (vm.form.phones.length == 0) {
              vm.form.phones = [{ phone: "", phone_type: "" }];
            }
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.ADDATLEASTONEDIRECCTION,
              "error"
            );
            outme = true;
            return;
          }
          var auxElem = elem;
          elem.administrative_area_level_1 =
            auxElem.administrative_area_level_1;
          elem.administrative_area_level_2 =
            auxElem.administrative_area_level_2;
          form.userAddresses.push(elem);
        });

        if (outme == true) {
          return;
        }

        form.email = form.emailMain ? form.emailMain : "";
        form.phone_number = form.phoneMain ? form.phoneMain : "";

        if (form.email == "" && vm.form.emails.length > 0) {
          form.email = vm.form.emails[0].correo;
          vm.form.emails.splice(0, 1);
        }

        if (vm.form.phoneMain) {
          if (vm.form.phoneMain.length < 9) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
            return;
          }
        }

        // for(var i = 0; i < vm.form.phones.length; i++){
        //   if(vm.form.phones[i].phone.length < 9){
        //     $scope.flagPhone = true;
        //   }
        // }
        if (vm.form.phones.length > 0) {
          for (var i = 0; i < vm.form.phones.length; i++) {
            if (vm.form.phones[i].phone) {
              if (vm.form.phones[i].phone.length < 9) {
                $scope.flagPhone = true;
              }
            }
          }
          if ($scope.flagPhone == true) {
            l.stop();
            $scope.flagPhone = false;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
            return;
          }
        }
        if (!$scope.flagPhone) {
          if (form.phone_number == "" && vm.form.phones.length > 0) {
            form.phone_number = vm.form.phones[0].phone;
            vm.form.phones.splice(0, 1);
          }
        } else {
          $scope.flagPhone = false;
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
          return;
        }

        var since = toDate(vm.form.birthday).getTime();
        var until = toDate(convertDate(new Date())).getTime();
        var diff = until - since;
        var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
        if (antiguedad <= 0) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATEBIRTHDATE, "error");
          return;
        }

        // var date = new Date(mesDiaAnio(form.birthday));
        var date = form.birthday;
        var newdate = date.split("/").reverse().join("-");
        form.birthday = newdate;
        form.vendor = vm.form.vendedor;
        form.responsable = vm.form.responsable;
        if (form.responsable) {
          if (form.responsable.url) {
            form.responsable = form.responsable.url;
          } else {
            form.responsable = form.responsable;
          }
        }
        if (vm.org_name == "ancora") {
          form.card_official_identification = vm.listDocument[0].value;
          form.CURP = vm.listDocument[1].value;
          form.voucher_efirm = vm.listDocument[2].value;
          form.voucher_of_address = vm.listDocument[3].value;
          form.signed_format_ic = vm.listDocument[4].value;
          if (vm.form.only_sureties) {
            form.carta_nombramiento = vm.listDocument[5].value;
            form.curriculo = vm.listDocument[6].value;
            form.contrato_multiple_afianzadora = vm.listDocument[7].value;
            form.carta_buro = vm.listDocument[8].value;
            form.entrevista_afianzadora = vm.listDocument[9].value;
            form.rfc_document = vm.listDocument[10].value;
            form.recibos_nomina = vm.listDocument[11].value;
            form.declaracion_anual = vm.listDocument[12].value;
            form.estados_financieros_anuales = vm.listDocument[13].value;
            form.estados_financieros_parciales = vm.listDocument[14].value;
            form.alta_hacienda = vm.listDocument[15].value;
            form.escritura_inmueble = vm.listDocument[16].value;
            form.boleta_predial = vm.listDocument[17].value;
            form.certificado_gravamen = vm.listDocument[18].value;
          }
          //upload files repect documents
          vm.listDocument.forEach(function (ar) {
            if (ar.arch.formData) {
              var extension = ar.arch.formData[0].arch.name.split(".")[1];
              ar.arch.formData[0].name = ar.name + "." + extension;
              ar.arch.file.name = ar.name + "." + extension;
              $scope.uploaderDocument.queue.push(ar.arch);
              $scope.uploaderDocument.onAfterAddingFile(ar.arch);
            }
          });
        } else {
          form.card_official_identification = vm.listDocument[0].value;
          form.CURP = vm.listDocument[1].value;
          form.voucher_efirm = vm.listDocument[2].value;
          form.voucher_of_address = vm.listDocument[3].value;
          form.signed_format_ic = vm.listDocument[4].value;
          form.fiscal_power = vm.listDocument[5].value;
          if (vm.form.only_sureties) {
            form.carta_nombramiento = vm.listDocument[6].value;
            form.curriculo = vm.listDocument[7].value;
            form.contrato_multiple_afianzadora = vm.listDocument[8].value;
            form.carta_buro = vm.listDocument[9].value;
            form.entrevista_afianzadora = vm.listDocument[10].value;
            form.rfc_document = vm.listDocument[11].value;
            form.recibos_nomina = vm.listDocument[12].value;
            form.declaracion_anual = vm.listDocument[13].value;
            form.estados_financieros_anuales = vm.listDocument[14].value;
            form.estados_financieros_parciales = vm.listDocument[15].value;
            form.alta_hacienda = vm.listDocument[16].value;
            form.escritura_inmueble = vm.listDocument[17].value;
            form.boleta_predial = vm.listDocument[18].value;
            form.certificado_gravamen = vm.listDocument[19].value;
          }
          //upload files repect documents
          vm.listDocument.forEach(function (ar) {
            if (ar.arch.formData) {
              var extension = ar.arch.formData[0].arch.name.split(".")[1];
              ar.arch.formData[0].name = ar.name + "." + extension;
              ar.arch.file.name = ar.name + "." + extension;
              $scope.uploaderDocument.queue.push(ar.arch);
              $scope.uploaderDocument.onAfterAddingFile(ar.arch);
            }
          });
        }
        //upload documents
        vm.form.birthday = $filter("date")(vm.form.birthday, "yyyy-MM-dd");
        vm.form.birthday = $filter("date")(vm.form.birthday, "yyyy-MM-dd");
        var date = form.birthday;
        var newdate = date.split("/").reverse().join("-");
        // form.birthday = newdate;
        // form.birth_date = datesFactory.toDate(datesFactory.convertDate(newdate));
        form.birth_date = datesFactory.toDate(vm.form.birthday);
        try {
          if (form.birth_date.length <= 8) {
            l.stop();
            SweetAlert.swal("Error", MESSAGES.ERROR.DATEBIRTHDAY, "error");
            return;
          }
        } catch (e) {}
        if (vm.form.sucursal) {
          form.sucursal = vm.form.sucursal;
        } else {
          form.sucursal = "";
        }
        form.has_bound_solidarity = $scope.has_solidario ? true : false;
        vm.form.bound_solidarity_many = $scope.obligados
          ? $scope.obligados
          : [];

        form.only_sureties = true;
        form.has_programa_de_proveedores = true;
        ContratanteService.createContratante(form, 1).then(function (data) {
          $scope.contractorNew = data;
          if ($scope.uploaderDocument.queue.length != 0) {
            uploadFilesList(data.type_person, data.id);
          }
          if (!data.id) {
            if (data.email) {
              l.stop();
              SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROREMAILMAX, "error");
            } else {
              l.stop();
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORCREATECONTRACTOR,
                "error"
              );
            }
          } else {
            var params = {
              model: 2,
              event: "POST",
              associated_id: data.id,
              identifier: "creó el contratante.",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});

            PersistenceFactory.eliminar();
            $scope.sendEmails(data.url, 1);
            $scope.sendPhones(data.url, 1);
            $scope.sendResponsables(data.url, 1);
            // Async add contacts
            form.contact.forEach(function (contact) {
              // contact.natural = data.url;
              contact.contractor = data.url;
              contactService.createContact(contact);
            });
            // Async add addresses
            $scope.acumulate = 0;
            form.userAddresses.forEach(function (address) {
              $scope.acumulate = $scope.acumulate + 1;
              address.url = globalVar.address;
              address.administrative_area_level_1 =
                address.administrative_area_level_1.state;
              address.administrative_area_level_2 =
                address.administrative_area_level_2.city;
              // address.natural = data.url;
              address.contractor = data.url;
              address.tipo = address.tipo ? address.tipo.name : "";
              generalService.postService(address).then(function (address) {
                data["address_contractor"].push(address.data);
              });
            });

            if (flag) {
              return;
            }

            vm.disabledAfterSave = true;
            $scope.userInfo = {
              id: data.id,
              type_person: data.type_person,
            };

            $("#newContractor").val(data.id);

            // Upload files
            // $scope.userInfo.url = $scope.uploader.url = url.IP + checkType($scope.userInfo.type_person) + '/' + $scope.userInfo.id + '/archivos/';
            $scope.userInfo.url = $scope.uploader.url =
              url.IP + "contractors" + "/" + $scope.userInfo.id + "/archivos/";
            vm.persons.push(data);
            $q.when()
              .then(function () {
                var defer = $q.defer();
                // defer.resolve($scope.uploader.uploadAll());
                return defer.promise;
              })
              .then(function () {
                // $scope.uploader.uploadAll();
              });
            $timeout(function () {
              if ($scope.countFile > 0) {
                if ($scope.acumulate == form.userAddresses.length) {
                  uploadFiles(data.type_person, data.id);
                } else {
                  uploadFiles(data.type_person, data.id);
                }
              } else {
                if (!$scope.array_files) {
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.NEWCONTRACTOR,
                    "success"
                  );
                  if ($scope.acumulate == form.userAddresses.length) {
                    if (vm.acceso_ver_cont) {
                      $state.go("fianzas.pprovnew", {
                        type:
                          $scope.contractorNew.type_person == 1
                            ? "fisicas"
                            : "morales",
                        contratanteId: $scope.contractorNew.id,
                      });
                    } else {
                      $state.go("index.main");
                    }
                    $rootScope.show_contractor = false;
                  }
                }
              }
            }, 10);
          }
        });
      }
    }
    vm.emails = {
      add: addEmail,
      delete: deleteEmail,
    };

    // vm.responsables = {
    //     add: addResponsable,
    //     delete: deleteResponsable
    // };
    function formatDate(input) {
      var datePart = input.match(/\d+/g),
        year = datePart[0].substring(2), // get only two digits
        month = datePart[1],
        day = datePart[2];

      return day + "/" + month + "/" + year;
    }
    var obligados1 = {
      obligado: vm.form.contratante,
    };
    vm.form.obligados = [];
    vm.form.obligados.push(obligados1);
    vm.juridicalForm.obligados = [];
    vm.juridicalForm.obligados.push(obligados1);

    $scope.addObligados = function (type) {
      if (type === 1) {
        var addobligadoss = {
          obligado: obligados1,
        };
        vm.form.obligados.push(addobligadoss);
      } else {
        var addobligadoss = {
          obligado: obligados1,
        };
        vm.juridicalForm.obligados.push(addobligadoss);
      }
    };
    $scope.deleteObligados = function (index, type) {
      if (type === 1) {
        vm.form.obligados.splice(index, 1);
      } else {
        vm.juridicalForm.obligados.splice(index, 1);
      }
    };
    $scope.sendResponsables = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.responsables.length; i++) {
          // vm.form.responsables[i].natural = url;
          vm.form.responsables[i].contractor = url;
        }
        vm.responsable = vm.form.responsables;
      } else {
        for (var i = 0; i < vm.juridicalForm.responsables.length; i++) {
          // vm.juridicalForm.responsables[i].juridical = url;
          vm.juridicalForm.responsables[i].contractor = url;
        }
        vm.responsable = vm.juridicalForm.responsables;
      }

      if (vm.responsable) {
        dataFactory
          .post("responsables/", vm.responsable)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };

    $scope.addResponsable = function (type) {
      if (type === 1) {
        var addresponsables = {
          responsables: vm.form.responsable,
          resp_type: 0,
        };
        vm.form.responsables.push(addresponsables);
      } else {
        var addresponsables = {
          responsables: vm.juridicalForm.responsable
            ? vm.juridicalForm.responsable
            : null,
          resp_type: 0,
        };
        vm.juridicalForm.responsables.push(addresponsables);
      }
    };
    $scope.deleteResponsable = function (index, type) {
      if (type === 1) {
        vm.form.responsables.splice(index, 1);
      } else {
        vm.juridicalForm.responsables.splice(index, 1);
      }
    };
    $scope.sendResponsables = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.responsables.length; i++) {
          // vm.form.responsables[i].natural = url;
          vm.form.responsables[i].contractor = url;
        }
        vm.responsable = vm.form.responsables;
      } else {
        for (var i = 0; i < vm.juridicalForm.responsables.length; i++) {
          // vm.juridicalForm.responsables[i].juridical = url;
          vm.juridicalForm.responsables[i].contractor = url;
        }
        vm.responsable = vm.juridicalForm.responsables;
      }

      if (vm.responsable) {
        dataFactory
          .post("responsables/", vm.responsable)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    function addEmail(type) {
      if (type === 1) {
        var addEmails = {
          correo: vm.form.correo,
        };
        vm.form.emails.push(addEmails);
      } else {
        var addEmails = {
          correo: vm.juridicalForm.correo,
        };
        vm.juridicalForm.emails.push(addEmails);
      }
    }
    function deleteEmail(index, type) {
      if (type === 1) {
        vm.form.emails.splice(index, 1);
      } else {
        vm.juridicalForm.emails.splice(index, 1);
      }
    }
    $scope.sendEmails = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.emails.length; i++) {
          // vm.form.emails[i].natural = url;
          vm.form.emails[i].contractor = url;
        }
        vm.correo = vm.form.emails;
      } else {
        for (var i = 0; i < vm.juridicalForm.emails.length; i++) {
          // vm.juridicalForm.emails[i].juridical = url;
          vm.juridicalForm.emails[i].contractor = url;
        }
        vm.correo = vm.juridicalForm.emails;
      }

      if (vm.correo) {
        dataFactory
          .post("emails/", vm.correo)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };

    vm.phones = {
      add: addPhone,
      delete: deletePhone,
    };
    function addPhone(type) {
      if (type === 1) {
        var addPhones = {
          phone: vm.form.phone,
        };
        vm.form.phones.push(addPhones);
      } else {
        var addPhones = {
          phone: vm.juridicalForm.phone,
        };
        vm.juridicalForm.phones.push(addPhones);
      }
    }
    function deletePhone(index, type) {
      if (type === 1) {
        vm.form.phones.splice(index, 1);
      } else {
        vm.juridicalForm.phones.splice(index, 1);
      }
    }
    $scope.sendPhones = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.phones.length; i++) {
          // vm.form.phones[i].natural = url;
          vm.form.phones[i].contractor = url;
        }
        vm.telefono = vm.form.phones;
      } else {
        for (var i = 0; i < vm.juridicalForm.phones.length; i++) {
          // vm.juridicalForm.phones[i].juridical = url;
          vm.juridicalForm.phones[i].contractor = url;
        }
        vm.telefono = vm.juridicalForm.phones;
      }
      if (vm.telefono) {
        dataFactory
          .post("phones/", vm.telefono)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function submitJuridical() {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.obligados = [];
      if (vm.juridicalForm.obligados) {
        vm.juridicalForm.obligados.forEach(function (elem, index) {
          if (elem.val) {
            if (elem.value) {
              $scope.obligados.push(elem.value.url);
            }
          }
        });
      }
      vm.juridicalForm.bound_solidarity_many = $scope.obligados
        ? $scope.obligados
        : [];
      if (vm.juridicalForm.rfc == undefined) {
        vm.juridicalForm.rfc = "";
      }
      $http
        .post(url.IP + "existrfc", { rfc: vm.juridicalForm.rfc, selector: 2 })
        .success(function (response) {
          if (response.status == true) {
            SweetAlert.swal(
              {
                title: "¡El RFC del contratante ya existe!",
                text: "¿Deseas continuar?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                closeOnConfirm: false,
              },
              function (isConfirm) {
                if (isConfirm) {
                  l.stop();
                  submitFormJuridical();
                  $scope.rfc_getDateJ(vm.juridicalForm.rfc);
                } else {
                  l.stop();
                  return;
                }
              }
            );
          } else {
            $scope.arrayEmail = vm.juridicalForm.emails;
            vm.juridicalForm.emails = [];
            $scope.arrayPhone = vm.juridicalForm.phones;
            vm.juridicalForm.phones = [];

            for (var i = 0; i < $scope.arrayEmail.length; i++) {
              if ($scope.arrayEmail[i].correo) {
                if ($scope.arrayEmail[i].email_type == 0) {
                  $scope.arrayEmail[i].email_type = 1;
                }
                vm.juridicalForm.emails.push($scope.arrayEmail[i]);
              }
            }

            for (var i = 0; i < $scope.arrayPhone.length; i++) {
              if ($scope.arrayPhone[i].phone) {
                if ($scope.arrayPhone[i].phone_type == 0) {
                  $scope.arrayPhone[i].phone_type = 1;
                }
                vm.juridicalForm.phones.push($scope.arrayPhone[i]);
              }
            }

            l.stop();
            submitFormJuridical();
            $scope.rfc_getDateJ(vm.juridicalForm.rfc, vm.juridicalForm);
          }
        });
    }
    Date.prototype.isValid = function () {
      // An invalid date object returns NaN for getTime() and NaN is the only
      // object not strictly equal to itself.
      return this.getTime() === this.getTime();
    };

    $scope.rfc_getDateJ = function (curp, form) {
      if (vm.juridicalForm.date_of_establishment) {
        return;
      }
      var m = curp.match(/^\w{4}(\w{2})(\w{2})(\w{2})/);
      //miFecha = new Date(año,mes,dia)
      try {
        var anyo = parseInt(m[1], 10) + 1900;
        if (anyo < 1950) anyo += 100;
        var mes = parseInt(m[2], 10) - 1;
        var dia = parseInt(m[3], 10);
        var date = new Date(anyo, mes, dia);
        if (date.isValid()) {
          vm.juridicalForm.date_of_establishment =
            datesFactory.convertDate(date);
        }
      } catch (err) {}

      // return (new Date( anyo, mes, dia ));
    };

    // $scope.rfc_getDateJ= function (rfc,form){
    //   if(vm.juridicalForm.date_of_establishment) {
    //     if ($scope.isValidDate(vm.juridicalForm.date_of_establishment)) {
    //       return;
    //     }else{
    //       vm.juridicalForm.date_of_establishment = null
    //       $scope.rfc_getDateJ(rfc,2)
    //     }
    //   }
    //   vm.rfc_fec= rfc.substr(3, 6);
    //   vm.rfc_anio = rfc.substr(3, 2);
    //   vm.rfc_month = rfc.substr(5, 2);
    //   vm.rfc_day = rfc.substr(7, 2);
    //   vm.fecha= vm.rfc_month+'/'+vm.rfc_day+'/'+vm.rfc_anio;
    //   vm.date = new Date(vm.fecha);
    //   vm.aniorfc= vm.date.getFullYear();
    //   vm.hoyA=vm.hoy.getFullYear();
    //   if(vm.aniorfc > vm.hoyA){
    //     vm.resta=vm.aniorfc-100;
    //     vm.rfc_anio = vm.resta;
    //     vm.fecha= vm.rfc_month+'/'+vm.rfc_day+'/'+vm.rfc_anio;
    //     if(vm.form.date_of_establishment == ""){
    //       var fecha_rfcJ= $filter('date')(new Date(vm.fecha), 'dd/MM/yyyy');
    //       vm.juridicalForm.date_of_establishment = fecha_rfcJ;
    //     }else{
    //       vm.juridicalForm.date_of_establishment = form.date_of_establishment;
    //     }
    //   }
    //   if(vm.juridicalForm.date_of_establishment == null || $scope.isValidDate(vm.juridicalForm.date_of_establishment) == false){
    //     var fecha_rfc= $filter('date')(new Date(vm.date), 'dd/MM/yyyy');
    //     vm.juridicalForm.date_of_establishment = fecha_rfc;
    //   }else{
    //     if ($scope.isValidDate(vm.juridicalForm.date_of_establishment)) {
    //       vm.juridicalForm.date_of_establishment = vm.juridicalForm.date_of_establishment;
    //     }else{
    //       var fecha_rfcJ= $filter('date')(new Date(vm.fecha), 'dd/MM/yyyy');
    //       vm.juridicalForm.date_of_establishment = fecha_rfcJ;
    //       // $scope.rfc_getDateJ(rfc,2)
    //     }
    //   }
    // }

    $scope.isValidDate = function (d) {
      return d instanceof Date && !isNaN(d);
    };
    function submitFormJuridical() {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.juridicalForm.j_name == "") {
        l.stop();
        if (!vm.juridicalForm.date_of_establishment) {
          vm.juridicalForm.date_of_establishment = "";
        }
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMJNAME, "error");
        return;
      }
      if (vm.juridicalForm.date_of_establishment == "") {
        l.stop();
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMESTABLISHMENT, "error");
        return;
      }
      if (vm.juridicalForm.rfc == "") {
        l.stop();
        if (!vm.juridicalForm.date_of_establishment) {
          vm.juridicalForm.date_of_establishment = "";
        }
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMRFC, "error");
        return;
      }
      if (!vm.juridicalForm.group) {
        l.stop();
        if (!vm.juridicalForm.date_of_establishment) {
          vm.juridicalForm.date_of_establishment = "";
        }
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.SELGROUP, "error");
        return;
      }
      if (vm.juridicalForm.emailMain) {
        if (!validateEmail(vm.juridicalForm.emailMain)) {
          l.stop();
          if (vm.juridicalForm.emails.length == 0) {
            vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
          }
          if (vm.juridicalForm.phones.length == 0) {
            vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
          }
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
      $scope.flagEmail = false;
      if (vm.juridicalForm.emails.length > 0) {
        for (var i = 0; i < vm.juridicalForm.emails.length; i++) {
          if (!validateEmail(vm.juridicalForm.emails[i].correo)) {
            $scope.flagEmail = true;
          }
        }
        if ($scope.flagEmail == true) {
          l.stop();
          $scope.flagEmail = false;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }

      if (!helpers.hasAtLeastOneAddress(vm.juridicalForm.userAddresses)) {
        l.stop();
        toaster.info(MESSAGES.ERROR.ADDATLEASTONEDIRECCTION);
      } else {
        var flag = false,
          outme = false;
        vm.juridicalForm.contact_juridical.forEach(function (contact) {
          if (contact.name == "") {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
            flag = true;
            return;
          } else {
            if (contact.email) {
              if (!validateEmail(contact.email)) {
                l.stop();
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.INVALIDEMAILCONTACT,
                  "error"
                );
                flag = true;
                return;
              }
            }
            if (contact.phone_number) {
              if (contact.phone_number.length < 9) {
                l.stop();
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.ERRORLENGTHPHONECONTACT,
                  "error"
                );
                return;
              }
            }
          }
        });

        var since = toDate(vm.juridicalForm.date_of_establishment).getTime();
        var until = toDate(convertDate(new Date())).getTime();
        var diff = until - since;
        var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
        if (antiguedad <= 0) {
          l.stop();
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORDATEFORMESTABLISHMENT,
            "error"
          );
          return;
        }

        if (flag) {
          return;
        }

        var form = angular.copy(vm.juridicalForm);
        var juridicalForm = angular.copy(vm.juridicalForm);
        var arr = [];
        var nums = [];
        vm.juridicalForm.contact_juridical.forEach(function (elem, index) {
          arr.push(elem);
        });

        form.constitutive_act = vm.listDocument[0].value;
        form.rfc_document = vm.listDocument[1].value;
        form.card_official_identification = vm.listDocument[2].value;
        form.voucher_of_address = vm.listDocument[3].value;
        form.modifications_constitutive_act = vm.listDocument[4].value;
        form.fiscal_power = vm.listDocument[5].value;
        if (vm.juridicalForm.only_sureties) {
          form.curriculo = vm.listDocument[6].value;
          form.contrato_multiple_afianzadora = vm.listDocument[7].value;
          form.carta_buro = vm.listDocument[8].value;
          form.entrevista_afianzadora = vm.listDocument[9].value;
          form.aviso_privacidad = vm.listDocument[10].value;
          form.protocolizaciones = vm.listDocument[11].value;
          form.alta_hacienda = vm.listDocument[12].value;
          form.cambio_domicilio_hacienda = vm.listDocument[13].value;
          form.voucher_efirm = vm.listDocument[14].value;
          form.declaracion_anual = vm.listDocument[15].value;
          form.estados_financieros_anuales = vm.listDocument[16].value;
          form.estados_financieros_parciales = vm.listDocument[17].value;
          form.escritura_inmueble = vm.listDocument[18].value;
          form.boleta_predial = vm.listDocument[19].value;
          form.certificado_gravamen = vm.listDocument[20].value;
        }
        //upload files repect documents
        vm.listDocument.forEach(function (ar) {
          if (ar.arch.formData) {
            var extension = ar.arch.formData[0].arch.name.split(".")[1];
            ar.arch.formData[0].name = ar.name + "." + extension;
            ar.arch.file.name = ar.name + "." + extension;
            $scope.uploaderDocument.queue.push(ar.arch);
            $scope.uploaderDocument.onAfterAddingFile(ar.arch);
          }
        });
        //upload documents
        form.date_of_establishment = $filter("date")(
          vm.juridicalForm.date_of_establishment,
          "yyyy-MM-dd"
        ); //jshint ignore:line
        form.contact = arr;
        form.group = form.group ? form.group.url : "";
        juridicalForm.userAddresses = [];
        form.userAddresses.forEach(function (elem) {
          if (
            elem.administrative_area_level_1 == null ||
            !elem.administrative_area_level_1 ||
            elem.administrative_area_level_1 === undefined ||
            elem.administrative_area_level_1 == "undefined" ||
            elem.administrative_area_level_2 == null ||
            !elem.administrative_area_level_2 ||
            elem.administrative_area_level_2 === undefined ||
            elem.administrative_area_level_2 == "undefined"
          ) {
            l.stop();
            if (!vm.juridicalForm.date_of_establishment) {
              vm.juridicalForm.date_of_establishment = "";
            }
            if (vm.juridicalForm.emails.length == 0) {
              vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
            }
            if (vm.juridicalForm.phones.length == 0) {
              vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
            }
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.DATAADDRESSREQUIRED,
              "error"
            );
            outme = true;
            return;
          }
          var auxElem = elem;
          elem.administrative_area_level_1 =
            auxElem.administrative_area_level_1;
          elem.administrative_area_level_2 =
            auxElem.administrative_area_level_2;
          juridicalForm.userAddresses.push(elem);
        });

        if (outme == true) {
          return;
        }

        // if(form.group == '' || juridicalForm.group == ''){
        //   l.stop();
        //   SweetAlert.swal("ERROR",MESSAGES.ERROR.SELGROUP ,"error");
        //   flag = true;
        //   return;
        // }

        var date = form.date_of_establishment;
        var newdate = date.split("/").reverse().join("-");
        form.date_of_establishment = newdate;

        form.email = juridicalForm.emailMain ? juridicalForm.emailMain : "";
        form.phone_number = juridicalForm.phoneMain
          ? juridicalForm.phoneMain
          : "";
        form.vendor = vm.juridicalForm.vendedor;
        form.responsable = vm.juridicalForm.responsable;
        if (form.responsable) {
          if (form.responsable.url) {
            form.responsable = form.responsable.url;
          } else {
            form.responsable = form.responsable;
          }
        }

        if (juridicalForm.email == "" && vm.juridicalForm.emails.length > 0) {
          juridicalForm.email = vm.juridicalForm.emails[0].correo;
          vm.juridicalForm.emails.splice(0, 1);
        }

        if (vm.juridicalForm.phoneMain) {
          if (vm.juridicalForm.phoneMain.length < 9) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
            return;
          }
        }

        for (var i = 0; i < vm.juridicalForm.phones.length; i++) {
          if (vm.juridicalForm.phones[i].phone.length < 9) {
            $scope.flagPhone = true;
          }
        }
        if (!$scope.flagPhone) {
          if (
            juridicalForm.phone_number == "" &&
            vm.juridicalForm.phones.length > 0
          ) {
            juridicalForm.phone_number = vm.juridicalForm.phones[0].phone;
            vm.juridicalForm.phones.splice(0, 1);
          }
        } else {
          $scope.flagPhone = false;
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
          return;
        }
        try {
          if (form.date_of_establishment.length <= 8) {
            l.stop();
            SweetAlert.swal("Error", MESSAGES.ERROR.DATEESTABLISHMENT, "error");
            return;
          }
        } catch (e) {}
        if (vm.juridicalForm.sucursal) {
          form.sucursal = vm.juridicalForm.sucursal;
        } else {
          form.sucursal = "";
        }
        // form.birth_date = datesFactory.toDate(form.date_of_establishment ? convertDate(new Date(form.date_of_establishment)) : convertDate(new Date(m.juridicalForm.date_of_establishment)));
        form.birth_date = datesFactory.toDate(
          vm.juridicalForm.date_of_establishment
        );
        form.type_person = 2;
        form.group = vm.juridicalForm.subsubgrupo
          ? vm.juridicalForm.subsubgrupo.url
          : vm.juridicalForm.subgroup
          ? vm.juridicalForm.subgroup.url
          : vm.juridicalForm.group
          ? vm.juridicalForm.group.url
          : "";
        // form.grouping_level = form.subsubasignaciones ? form.subsubasignaciones.url : form.subagrupaciones ? form.subagrupaciones.url : form.grouping_level ? form.grouping_level.url : '';
        form.groupinglevel = form.subsubasignaciones
          ? form.subsubasignaciones.url
          : form.subagrupaciones
          ? form.subagrupaciones.url
          : form.grouping_level
          ? form.grouping_level.url
          : null;
        // form.celula = vm.juridicalForm.celula ? vm.juridicalForm.celula : null;
        form.cellule = vm.juridicalForm.celula ? vm.juridicalForm.celula : null;
        form.full_name = vm.juridicalForm.j_name;
        vm.form.bound_solidarity_many = $scope.obligados
          ? $scope.obligados
          : [];
        form.has_bound_solidarity = $scope.has_solidario ? true : false;

        form.only_sureties = true;
        form.has_programa_de_proveedores = true;
        ContratanteService.createContratante(form, 2).then(function (data) {
          $scope.contractorNew = data;
          if ($scope.uploaderDocument.queue.length != 0) {
            uploadFilesList(data.type_person, data.id);
          }
          if (data.type_person == "Moral") data["address_contractor"] = [];
          else data["address_natural"] = [];

          if (!data.id) {
            if (data.email) {
              l.stop();
              SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROREMAILMAX, "error");
            } else {
              l.stop();
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORCREATECONTRACTOR,
                "error"
              );
            }
          } else {
            $scope.sendEmails(data.url, 2);
            $scope.sendPhones(data.url, 2);
            $scope.sendResponsables(data.url, 2);
            form.contact.forEach(function (contact) {
              // contact.juridical = data.url;
              contact.contractor = data.url;
              contactService.createContact(contact);
            });
            // var address = {};
            $scope.acumulate = 0;
            juridicalForm.userAddresses.forEach(function (address) {
              $scope.acumulate = $scope.acumulate + 1;
              address.url = globalVar.address;
              // address.juridical = data.url;
              address.contractor = data.url;
              address.administrative_area_level_1 =
                address.administrative_area_level_1.state;
              address.administrative_area_level_2 =
                address.administrative_area_level_2.city;
              address.tipo = address.tipo ? address.tipo.name : "";
              generalService.postService(address).then(function (address) {
                if (data.type_person == "Moral") {
                  data["address_contractor"].push(address.data);
                } else {
                  data["address_contractor"].push(address.data);
                }
              });
            });
            if (flag) {
              return;
            }
            // toaster.success(MESSAGES.OK.NEWCONTRACTOR);

            vm.disabledAfterSave = true;

            $scope.userInfo = {
              id: data.id,
              type_person: data.type_person,
            };

            $("#newContractor").val(data.id);

            // Upload files
            // $scope.userInfo.url = $scope.uploader.url = url.IP + checkType($scope.userInfo.type_person) + '/' + $scope.userInfo.id + '/archivos/';
            $scope.userInfo.url = $scope.uploader.url =
              url.IP + "contractors/" + $scope.userInfo.id + "/archivos/";
            vm.persons.push(data);
            $q.when()
              .then(function () {
                var defer = $q.defer();
                defer.resolve($scope.uploader.uploadAll());
                return defer.promise;
              })
              .then(function () {
                $scope.uploader.uploadAll();
              });

            $timeout(function () {
              if ($scope.countFile > 0) {
                if ($scope.acumulate == vm.juridicalForm.userAddresses.length) {
                  uploadFiles(data.type_person, data.id);
                } else {
                  uploadFiles(data.type_person, data.id);
                }
              } else {
                if (!$scope.array_files) {
                  if (vm.acceso_ver_cont) {
                    if (
                      $scope.acumulate == vm.juridicalForm.userAddresses.length
                    ) {
                      SweetAlert.swal(
                        "¡Listo!",
                        MESSAGES.OK.NEWCONTRACTOR,
                        "success"
                      );
                      $state.go("fianzas.pprovnew", {
                        type:
                          $scope.contractorNew.type_person == 1
                            ? "fisicas"
                            : "morales",
                        contratanteId: $scope.contractorNew.id,
                      });
                      $rootScope.show_contractor = false;
                    }
                  } else {
                    $state.go("index.main", params);
                  }
                }
              }
            }, 10);
          }
        });
      }
    }

    function submitFormJuridical1() {
      var form = {};
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.juridicalForm.j_name == "") {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMJNAME, "error");
        return;
      }
      form.type_person = 2;
      form.full_name = vm.juridicalForm.j_name;
      form.only_sureties = true;
      form.has_programa_de_proveedores = true;
      form.rfc = "PPROVEEDORES";
      ContratanteService.createContratante(form, 2).then(function (data) {
        l.stop();
        $scope.contractorNew.id = data.id;
        if ($scope.countFile > 0) {
          uploadFiles(data.type_person, data.id);
        }
        var payload = {
          type: data.type_person == 1 ? "fisicas" : "morales",
          contratanteId: data.id,
        };
        console.log(payload);
        // $scope.open_in_same_tab('Información Programa', 'fianzas.pprovnew',payload, payload['contratanteId'] , payload['type']);
        SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWCONTRACTOR, "success");

        var name = "Información Programa";
        var route = "fianzas.pprovedit";

        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }

        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });

          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab),
          };
        }
        $localStorage.tab_states = appStates.states;

        $state.go($scope.route_for_new_tab, payload);
      });
    }
    function insert(form) {}

    function checkType(type) {
      //jshint ignore:line
      // return (type === 'Fisica') ? 'fisicas' : 'morales';
      return type === "Física" ? "fisicas" : "morales";
    }

    function addContact(type) {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
      };
      if (type === 1) {
        vm.form.contact_natural.push(contact);
      } else {
        vm.juridicalForm.contact_juridical.push(contact);
      }
    }

    function deleteContacts(contact, type) {
      if (type === 1) {
        vm.form.contact_natural.splice(contact, 1);
      } else {
        vm.juridicalForm.contact_juridical.splice(contact, 1);
      }
    }

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        // appStates.states.forEach(function(state) {
        //   if (state.route == $scope.route_for_new_tab){
        //     existe = true;
        //   }
        // });
      }

      // if (!existe){
      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    function openModalGroup(level, type, parent) {
      $("#modalContratate").parent().parent().parent().css("display", "none");
      $(".modal-backdrop").click(function () {
        $("#modalContratate")
          .parent()
          .parent()
          .parent()
          .css("display", "block");
      });
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/grupos/grupos.form.html",
        controller: ModalInstanceCtrl,
        resolve: {
          padre: function () {
            return parent;
          },
          parent: function () {
            return vm;
          },
          type: function () {
            return type;
          },
          level: function () {
            return level;
          },
          group: function () {
            return level == 2 ? vm.form.group : {};
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }
    vm.subgroups = [];
    vm.sub_subgroups = [];

    function ModalInstanceCtrl(
      $scope,
      $uibModalInstance,
      parent,
      level,
      group,
      type,
      padre
    ) {
      $scope.level = level;
      $scope.groupForm = {};
      $scope.subgroupForm = {};
      $scope.subsubgroupForm = {};
      $scope.subgroups = [];
      $scope.sub_subgroups = [];

      $scope.addSubgroups = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        $scope.subgroups.push(obj);
      };

      $scope.deleteSubgroup = function (index) {
        $scope.subgroups.splice(index, 1);
      };

      $scope.addSubsubgroups = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        $scope.sub_subgroups.push(obj);
      };

      $scope.deleteSubsubgroup = function (index) {
        $scope.sub_subgroups.splice(index, 1);
      };

      $http.get(url.IP + "usuarios/").then(function (user) {
        $scope.users = user.data.results;

        $scope.show_pagination = true;
      });

      $scope.changeResponsable = function (data, type) {
        // $scope.responsables_natural = [];
        // $scope.responsables_juridical = [];
        if (type == 1) {
          $scope.responsables_natural.push(data);
        } else {
          $scope.responsables_juridical.push(data);
        }
      };

      $scope.ok = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (!$scope.groupForm.responsable) {
          l.stop();
          SweetAlert.swal("ERROR", "Selecciona un responsable.", "error");
          return;
        }

        var flag = false;
        var form = angular.copy($scope.groupForm);
        var name = form.group_name;
        var bd_group_name = [];
        groupService.getGroups().then(function (res) {
          res.forEach(function (group, i) {
            bd_group_name.push(String(group.group_name));
          });

          for (var i = 0; i < bd_group_name.length; i++) {
            if (name == bd_group_name[i]) {
              flag = true;
            }
          }

          form.type_group = 1;

          if (flag == false) {
            return groupService
              .createGroup(form)
              .then(function (data) {
                if (data.status === 201) {
                  vm.groups.push(data.data);
                  $rootScope.changeGroup(data.data);
                  if (vm.form.email) {
                    vm.form.group = data.data;
                  } else if (vm.juridicalForm.email) {
                    vm.juridicalForm.group = data.data;
                  }

                  if ($uibModalInstance) {
                    $uibModalInstance.close();
                    $("#modalContratate")
                      .parent()
                      .parent()
                      .parent()
                      .css("display", "block");
                  }

                  if ($scope.subgroups.length > 0) {
                    $scope.subgroups.forEach(function (item) {
                      var datas = {
                        group_name: item.group_name,
                        responsable: data.data.responsable,
                        parent: data.data.url,
                        type_group: 2,
                      };

                      $http({
                        method: "POST",
                        url: url.IP + "grupos/",
                        data: datas,
                      })
                        .then(function (request) {
                          if (
                            request.status === 200 ||
                            request.status === 201
                          ) {
                            // vm.subgroups.push(request.data);
                            if (type === 1) {
                              vm.form.group.subgrupos.push(request.data);
                            } else {
                              vm.juridicalForm.group.subgrupos.push(
                                request.data
                              );
                            }
                          }
                        })
                        .catch(function (e) {
                          l.stop();
                          console.log("e", e);
                        });
                    });
                  }
                } else if (data.status === 403) {
                  toaster.warning("Usted no tiene permisos para crear grupos");
                  // return;
                  l.stop();
                  $uibModalInstance.close();
                  $("#modalContratate")
                    .parent()
                    .parent()
                    .parent()
                    .css("display", "block");
                }
              })
              .catch(function () {
                l.stop();
                return;
              });
          } else {
            l.stop();
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.THISNAMEALREADYEXIST,
              "error"
            );
            return;
          }
        });
      };

      $scope.oksub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.subgroupForm.responsable = group.responsable;
        $scope.subgroupForm.parent = padre.url;
        $scope.subgroupForm.type_group = 2;

        if (!$scope.subgroupForm.group_name) {
          l.stop();
          SweetAlert.swal("Error", "Agrega un nombre de subgrupo.", "error");
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "grupos/",
          data: $scope.subgroupForm,
        })
          .then(function (request) {
            if (request.status === 200 || request.status === 201) {
              try {
                vm.subgroups.push(request.data);
              } catch (e) {
                vm.subgroups = [];
                vm.subgroups.push(request.data);
              }

              if ($scope.sub_subgroups.length > 0) {
                vm.subgroups[vm.subgroups.length - 1].subsubgrupos = [];
                $scope.sub_subgroups.forEach(function (item) {
                  var datas = {
                    group_name: item.group_name,
                    responsable: group.responsable,
                    parent: request.data.url,
                    type_group: 3,
                  };

                  $http({
                    method: "POST",
                    url: url.IP + "grupos/",
                    data: datas,
                  })
                    .then(function (response) {
                      if (response.status === 200 || response.status === 201) {
                        vm.subgroups[vm.subgroups.length - 1].subsubgrupos.push(
                          response.data
                        );
                      }
                    })
                    .catch(function (e) {
                      l.stop();
                      console.log("e", e);
                    });
                });
              }
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.oksubsub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.subsubgroupForm.responsable = group.responsable;
        $scope.subsubgroupForm.parent = padre.url;
        $scope.subsubgroupForm.type_group = 3;

        if (!$scope.subsubgroupForm.group_name) {
          l.stop();
          SweetAlert.swal("Error", "Agrega un nombre de subsubgrupo.", "error");
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "grupos/",
          data: $scope.subsubgroupForm,
        })
          .then(function (request_sub) {
            if (request_sub.status === 200 || request_sub.status === 201) {
              if (vm.sub_subgroups == undefined) {
                vm.sub_subgroups = [];
              }
              vm.sub_subgroups.push(request_sub.data);
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
          $("#modalContratate")
            .parent()
            .parent()
            .parent()
            .css("display", "block");
        }
      };
    }

    function openModalAsignacion(level, parent) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/contratantes/contratantes.agrupacion.html",
        controller: ModalGroupCtrl,
        resolve: {
          padre: function () {
            return parent;
          },
          parent: function () {
            return vm;
          },
          level: function () {
            return level;
          },
          group: function () {
            return level == 2
              ? vm.form.grouping_level
              : vm.form.subagrupaciones;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }

    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    function ModalGroupCtrl(
      $scope,
      $uibModalInstance,
      parent,
      level,
      group,
      padre
    ) {
      $scope.level = level;
      $scope.group_modal = group;
      $scope.grupo = {};
      // $scope.subasignaciones = [];
      $scope.subsubasignacion = [];

      $scope.addSubasignaciones = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        vm.subasignaciones.push(obj);
      };

      $scope.deleteSubasignaciones = function (index) {
        vm.subasignaciones.splice(index, 1);
      };

      $scope.addSubsubasignaciones = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        $scope.subsubasignacion.push(obj);
      };

      $scope.deleteSubsubasignaciones = function (index) {
        $scope.subsubasignacion.splice(index, 1);
      };

      $http.get(url.IP + "usuarios/").then(function (user) {
        $scope.users = user.data.results;

        $scope.show_pagination = true;
      });

      $scope.saveSub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.grupo.level_grouping = padre.level_grouping;
        $scope.grupo.parent = padre.url;
        $scope.grupo.type_grouping = 2;

        if (!$scope.grupo.description) {
          l.stop();
          SweetAlert.swal(
            "Error",
            "Agrega un nombre de subagrupación.",
            "error"
          );
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "groupinglevel/",
          data: $scope.grupo,
        })
          .then(function (request_sub) {
            if (request_sub.status === 200 || request_sub.status === 201) {
              $rootScope.changeAgrupacion2(padre);
              $scope.sub_subasignaciones = padre.subsubgrupos;
              if ($scope.subsubasignacion.length > 0) {
                $scope.subsubasignacion.forEach(function (item, index) {
                  var datas = {
                    description: item.description,
                    responsable: $scope.grupo.responsable,
                    parent: request_sub.data.url,
                    type_grouping: 3,
                    level_grouping: group.level_grouping,
                  };

                  $http({
                    method: "POST",
                    url: url.IP + "groupinglevel/",
                    data: datas,
                  })
                    .then(function (response) {
                      if (response.status === 200 || response.status === 201) {
                        $rootScope.changeAgrupacion2(padre);
                        $scope.sub_subasignaciones.push(response.data);
                        $scope.agrupaciones.subgrupos.forEach(function (
                          sub,
                          index
                        ) {
                          if (sub.id == request_sub.data.id) {
                            vm.agrupaciones.subgrupos[index].subsubgrupos.push(
                              response.data
                            );
                          }
                        });
                      }
                    })
                    .catch(function (e) {
                      l.stop();
                      console.log("e", e);
                    });

                  if ($scope.subsubasignacion.length == index + 1) {
                    vm.agrupaciones.forEach(function (gpo) {
                      if (
                        gpo.description == vm.form.grouping_level.description
                      ) {
                        vm.form.grouping_level = gpo;
                      }
                    });
                  }
                });
              }
              try {
                $scope.sub_asignaciones.push(request_sub.data);
              } catch (e) {
                $scope.sub_asignaciones = request_sub.data;
              }
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.saveSubsub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.grupo.level_grouping = padre.level_grouping;
        $scope.grupo.parent = padre.url;
        $scope.grupo.type_grouping = 3;

        if (!$scope.grupo.description) {
          l.stop();
          SweetAlert.swal(
            "Error",
            "Agrega un nombre de subsubagrupación.",
            "error"
          );
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "groupinglevel/",
          data: $scope.grupo,
        })
          .then(function (request_sub) {
            if (request_sub.status === 200 || request_sub.status === 201) {
              // $scope.sub_subasignaciones.push(request_sub.data);
              $scope.sub_subasignaciones = padre.subsubgrupos;
              try {
                $scope.sub_subasignaciones.push(request_sub.data);
              } catch (e) {
                $scope.sub_subasignaciones = request_sub.data;
              }
              $rootScope.changeAgrupacion2(padre);
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    function openModalClasification(level) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/contratantes/contratantes.clasificacion.html",
        controller: ModaClasificationCtrl,
        resolve: {
          parent: function () {
            return vm;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }
    function openModalCelulaContractor(level) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/contratantes/contratantes.celulas.html",
        controller: ModalCelulasCtrl,
        resolve: {
          parent: function () {
            return vm;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }
    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    function ModaClasificationCtrl($scope, $uibModalInstance, parent) {
      $scope.classification = {};

      $scope.save = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        ($scope.classification.classification_name =
          $scope.classification.classification_name),
          ($scope.classification.description =
            $scope.classification.description),
          $http({
            method: "POST",
            url: url.IP + "classification/",
            data: $scope.classification,
          })
            .then(function (response) {
              if (response.status === 200 || response.status === 201) {
                l.stop();
                vm.clasifications.push(response.data);
                $scope.cancel();
              }
            })
            .catch(function (e) {
              l.stop();
              console.log("e", e);
            });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    function ModalCelulasCtrl($scope, $uibModalInstance, parent) {
      $scope.celula = {};
      dataFactory.get("usuarios/").then(function (user) {
        $scope.usuarios_saam = user.data.results;
      });
      $scope.save_celula = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();

        $scope.celula.celula_name = $scope.celula.celula_name;
        $scope.celula.description = $scope.celula.description;
        $scope.celula.users_many = $scope.usuarios_selected
          ? $scope.usuarios_selected
          : [];
        $http({
          method: "POST",
          url: url.IP + "celula_contractor/",
          data: $scope.celula,
        })
          .then(function (response) {
            if (response.status === 200 || response.status === 201) {
              vm.celulas.push(response.data);
              $scope.cancel_celula();
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };

      $scope.cancel_celula = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.selectUsuarios = function (sel) {
        $scope.usuarios_selected = [];
        sel.forEach(function (u) {
          if (u.url) {
            $scope.usuarios_selected.push(u.url);
          } else {
            $scope.usuarios_selected.push(u);
          }
        });
      };
    }
    // vm.changeGroup = changeGroup;
    $rootScope.changeGroup = function (data) {
      if (data) {
        if (data.id) {
          dataFactory
            .post("subgrupos-match/", { parent: data.id })
            .then(function (subgrupos_) {
              vm.subgroups = subgrupos_.data;
            });
        } else {
          if (data) {
            if (data.subgrupos) {
              vm.subgroups = data.subgrupos;
            } else {
              vm.subgroups = [];
            }
          } else {
            vm.subgroups = [];
          }
        }
      } else {
        vm.subgroups = [];
      }
      // vm.subgroups = data.subgrupos;
      vm.juridicalForm.group = data;
      vm.form.group = data;
      if (data.responsable) {
        $http
          .get(data.responsable)
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.form.responsable = request.data;
                vm.juridicalForm.responsable = request.data;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else {
        vm.form.responsable = "";
        vm.juridicalForm.responsable = "";
      }
    };

    $rootScope.changeSubGroup = function (data) {
      // vm.sub_subgroups = data.subsubgrupos;
      // $rootScope.changeGroup(vm.juridicalForm.group ? vm.juridicalForm.group : vm.form.group)
      if (data) {
        if (data.subsubgrupos) {
          vm.sub_subgroups = data.subsubgrupos;
        } else {
          vm.sub_subgroups = [];
        }
      } else {
        vm.sub_subgroups = [];
      }
    };

    $rootScope.changeAgrupacion2 = function (data) {
      if (data) {
        if (data.id && data.type_grouping == 1) {
          dataFactory
            .post("subagrupaciones-match/", { parent: data.id })
            .then(function (subgrupos_) {
              $scope.sub_asignaciones = subgrupos_.data;
              // $scope.sub_subasignaciones = [];
            });
        } else {
          if (data) {
            if (data.subgrupos) {
              $scope.sub_asignaciones = data.subgrupos;
            } else if (data.subsubgrupos) {
              $scope.sub_subasignaciones = data.subsubgrupos;
            }
          } else {
            $scope.sub_asignaciones = [];
          }
        }
      } else {
        $scope.sub_asignaciones = [];
      }
      // $scope.sub_asignaciones = data.subgrupos;
    };

    $rootScope.changeSubagrupacion2 = function (data) {
      // if(data.subsubgrupos){
      //   vm.sub_subasignaciones = data.subsubgrupos;
      // }
      if (data) {
        if (data.subsubgrupos) {
          $scope.sub_subasignaciones = data.subsubgrupos;
        } else {
          $scope.sub_subasignaciones = [];
        }
      } else {
        $scope.sub_subasignaciones = [];
      }
    };

    $rootScope.changeVendedor = function (data) {
      vm.juridicalForm.vendedor = data;
      vm.form.vendedor = data;
    };

    $scope.changeResponsable_single = function (data) {
      vm.form.responsable = data;
    };
    $scope.exportData = function (type_person) {
      // var header = '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      // var blob = new Blob([header + document.getElementById('exportable').innerHTML], {
      //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
      // });
      // saveAs(blob, "Reporte_" + aseguradoras + ".xls");
      // fisicas y morales

      var data = { cadena: $scope.param_cadena };
      if (type_person == 1) {
        // naturales
        $http
          .get(url.IP + "reporte-fisicas/")
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "ContratantesFisicos");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      } else if (type_person == 2) {
        $http
          .get(url.IP + "reporte-morales/")
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "ContratantesMorales");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
      if (type_person == 3) {
        // naturales seeker
        $http({
          method: "GET",
          url: url.IP + "reporte-seekerNaturals/",
          params: data,
        })
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "Contratantes_Naturales");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
      if (type_person == 4) {
        // juridicals seeker

        $http({
          method: "GET",
          url: url.IP + "reporte-seekerJuridicals/",
          params: data,
        })
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "Contratantes_Morales");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    $scope.filterValue = function ($event) {
      if (isNaN(String.fromCharCode($event.charCode))) {
        $event.preventDefault();
      }
    };

    $rootScope.show_contractor = true;
    $scope.returnToPolicy = function () {
      $rootScope.show_contractor = false;
    };

    // show / hide buttons personaFisica personaMoral
    $scope.showButtonFisica = function () {
      $scope.fisicas = true;
      $scope.morales = false;
      $("#saveButtonMoralModal").css("display", "none");
      $("#saveButtonFisicaModal").css("display", "block");
    };

    $scope.showButtonMoral = function () {
      $scope.fisicas = false;
      $scope.morales = true;
      $("#saveButtonFisicaModal").css("display", "none");
      $("#saveButtonMoralModal").css("display", "block");
    };

    $scope.cancelChanges = function () {
      $rootScope.show_contractor = false;
      // if($("#modalContratate")){
      //   if( $uibModalInstance.dismiss('cancel')){
      //     $timeout(function () {
      //       $("#createOTS").click();
      //         }, 1);
      //   }
      // }
    };

    $scope.selectDate = function (parDate) {};

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");

      return date;
    }

    function mesDiaAnio(parDate) {
      var d = new Date(toDate(parDate));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      return date;
    }

    // TEST pagination contrantes
    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      // $scope.selectPage = function (parPage) {
      //   vm.Consultar($scope.order, parPage);
      // };

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        vm.Consultar($scope.order, parPage);
      };
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getContratantesPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    //Pagination----

    // configuración del datepicker
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
    //-- Peticion de persistencia--//

    var json_data = {};
    var form = document.getElementsByTagName("form");
    var elementos = {};
    //Valores reutilizables
    var interval, interval1, dt, valor;
    var count = 0;

    function set_dataForm(json) {
      PersistenceFactory.set_inputs(json);
      if (json["vm.form.first_name"] != "") {
        vm.form.first_name = json["vm.form.first_name"];
      }
      if (json["vm.form.last_name"] != "") {
        vm.form.last_name = json["vm.form.last_name"];
      }
      if (json["vm.form.second_last_name"] != "") {
        vm.form.second_last_name = json["vm.form.second_last_name"];
      }
      if (json["vm.form.rfc"] != "") {
        vm.form.rfc = json["vm.form.rfc"];
      }
      if (json["vm.form.birthday"] != "") {
        vm.form.birthday = json["vm.form.birthday"];
      }
      if (json["vm.form.sex"] != "") {
        vm.form.sex = json["vm.form.sex"];
      }
      if (json["vm.form.emailMain"] != "") {
        vm.form.emailMain = json["vm.form.emailMain"];
      }
      if (json["inputValue"][0] != "") {
        vm.form.phoneMain = json["inputValue"][0].valor;
      }
      if (json["vm.form.group"] != "") {
        valor = PersistenceFactory.find_index(
          vm.groups,
          json["vm.form.group"][0].valor,
          "url"
        );
        vm.form.group = vm.groups[valor];
      }
      //vm.address_type
      if (json["address.tipo"]) {
        if (json["address.tipo"][0].valor != "") {
          valor = PersistenceFactory.find_index(
            vm.address_type,
            json["address.tipo"][0].valor,
            "name"
          );
          vm.form.userAddresses[0].tipo = vm.address_type[valor];
        }
        if (json["address.tipo"][1].valor != "") {
          valor = PersistenceFactory.find_index(
            vm.address_type,
            json["address.tipo"][1].valor,
            "name"
          );
          vm.juridicalForm.userAddresses[0].tipo = vm.address_type[valor];
        }
      }
      if (json["address.administrative_area_level_1"]) {
        if (json["address.administrative_area_level_1"][0].valor != "") {
          valor = PersistenceFactory.find_index(
            vm.statesArray,
            json["address.administrative_area_level_1"][0].valor,
            "url"
          );
          vm.form.userAddresses[0].administrative_area_level_1 =
            vm.statesArray[valor];

          if (json["address.administrative_area_level_2"][0].valor != "") {
            valor = PersistenceFactory.find_index(
              vm.form.userAddresses[0].administrative_area_level_1.cities,
              json["address.administrative_area_level_2"][0].valor,
              "url"
            );
            vm.form.userAddresses[0].administrative_area_level_2 =
              vm.form.userAddresses[0].administrative_area_level_1.cities[
                valor
              ];
          }
        }
        //Falta segundo vm.juridicalForm
        if (json["address.administrative_area_level_1"][1].valor != "") {
          valor = PersistenceFactory.find_index(
            vm.statesArray,
            json["address.administrative_area_level_1"][1].valor,
            "url"
          );
          vm.juridicalForm.userAddresses[0].administrative_area_level_1 =
            vm.statesArray[valor];

          if (json["address.administrative_area_level_2"][1].valor != "") {
            console.log(vm.juridicalForm.userAddresses);
            valor = PersistenceFactory.find_index(
              vm.juridicalForm.userAddresses[0].administrative_area_level_1
                .cities,
              json["address.administrative_area_level_2"][1].valor,
              "url"
            );
            vm.juridicalForm.userAddresses[0].administrative_area_level_2 =
              vm.juridicalForm.userAddresses[0].administrative_area_level_1.cities[
                valor
              ];
          } /**/
        }
      }

      if (json["address.route"]) {
        if (json["address.route"][0].valor != "text") {
          vm.form.userAddresses[0].route = json["address.route"][0].valor;
        }
        if (json["address.route"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].route =
            json["address.route"][1].valor;
        }
      }
      if (json["address.street_number"]) {
        if (json["address.street_number"][0].valor != "text") {
          vm.form.userAddresses[0].street_number =
            json["address.street_number"][0].valor;
        }
        if (json["address.street_number"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].street_number =
            json["address.street_number"][1].valor;
        }
      }
      if (json["address.street_number_int"]) {
        if (json["address.street_number_int"][0].valor != "text") {
          vm.form.userAddresses[0].street_number_int =
            json["address.street_number_int"][0].valor;
        }
        if (json["address.street_number_int"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].street_number_int =
            json["address.street_number_int"][1].valor;
        }
      }
      if (json["address.sublocality"]) {
        if (json["address.sublocality"][0].valor != "text") {
          vm.form.userAddresses[0].sublocality =
            json["address.sublocality"][0].valor;
        }
        if (json["address.sublocality"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].sublocality =
            json["address.sublocality"][1].valor;
        }
      }
      if (json["address.postal_code"]) {
        if (json["address.postal_code"][0].valor != "text") {
          vm.form.userAddresses[0].postal_code =
            json["address.postal_code"][0].valor;
        }
        if (json["address.postal_code"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].postal_code =
            json["address.postal_code"][1].valor;
        }
      }
      if (json["address.details"]) {
        if (json["address.details"][0].valor != "text") {
          vm.form.userAddresses[0].details = json["address.details"][0].valor;
        }
        if (json["address.details"][1].valor != "text") {
          vm.juridicalForm.userAddresses[0].details =
            json["address.details"][1].valor;
        }
      }
      if (json["vm.form.responsable"][0].valor != "") {
        valor = PersistenceFactory.find_index(
          vm.statesArray,
          json["vm.form.responsable"][0].valor,
          "url"
        );
        vm.form.responsable = vm.responsables[valor];
      }
      if (json["vm.form.responsable"][1].valor != "") {
        valor = PersistenceFactory.find_index(
          vm.statesArray,
          json["vm.form.responsable"][1].valor,
          "url"
        );
        vm.juridicalForm.responsable = vm.responsables[valor];
      }
      if (json["listaD.value"]) {
      }
      //Morales
      if (
        json["vm.juridicalForm.j_name"] != "" &&
        json["vm.juridicalForm.j_name"] != "text"
      ) {
        vm.juridicalForm.j_name = json["vm.juridicalForm.j_name"];
      }
      if (
        json["vm.juridicalForm.date_of_establishment"] != "" &&
        json["vm.juridicalForm.date_of_establishment"] != "text"
      ) {
        vm.juridicalForm.date_of_establishment =
          json["vm.juridicalForm.date_of_establishment"];
      }
      if (
        json["vm.juridicalForm.rfc"] != "" &&
        json["vm.juridicalForm.date_of_establishment"] != "text"
      ) {
        vm.juridicalForm.rfc = json["vm.juridicalForm.rfc"];
      }
      if (
        json["vm.juridicalForm.emailMain"] != "" &&
        json["vm.juridicalForm.emailMain"] != "text"
      ) {
        vm.juridicalForm.emailMain = json["vm.juridicalForm.emailMain"];
      }
      if (
        json["vm.juridicalForm.description"] != "" &&
        json["vm.juridicalForm.description"] != "text"
      ) {
        vm.juridicalForm.description = json["vm.juridicalForm.description"];
      }
      if (
        (json["inputValue"][4] != "") != "" &&
        json["inputValue"][4] != "text"
      ) {
        vm.juridicalForm.phoneMain = json["inputValue"][4].valor;
      }

      valor = angular.element('[ng-model="inputValue"]');
      angular.forEach(valor, function (v, a) {
        if (a == 3 || a == 7) {
          v.value = "";
        }
      });
      valor = angular.element('[ng-model="item.correo"]');
      angular.forEach(valor, function (v, a) {
        v.value = "";
      });
      valor = angular.element('[ng-model="listaD.value"]');
      angular.forEach(valor, function (v, a) {
        valor[a].checked = false;
        valor[a].setAttribute("aria-checked", "false");
      });
    }

    interval = setInterval(function () {
      if (form != undefined && PersistenceFactory.count == 0) {
        //&& PersistenceFactory.count == 0
        PersistenceFactory.inicial(
          vm.user.org,
          "Contratantes",
          vm.user.nameFull,
          PersistenceFactory.get_dataForm(form)
        );
      }
      if (PersistenceFactory.init_return != "") {
        clearInterval(interval);
        if (PersistenceFactory.init_return.status == "data_view") {
          set_dataForm(PersistenceFactory.json_return);
        }
        PersistenceFactory.interval = setInterval(function () {
          PersistenceFactory.editado(PersistenceFactory.get_dataForm(form));
        }, PersistenceFactory.intervalTime); /* /* */
      }
    }, 2000);
    //-- End Peticion de persistencia--//

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.length >= 3) {
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: false,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("vm.contratante.value", function (newValue, oldValue) {
      if (vm.contratante) {
        if (vm.contratante.value.address_contractor) {
          if (vm.contratante.value.address_contractor) {
            $scope.bound_solidarity = vm.contratante.value.url;
            $scope.has_solidario = true;
          }
        }
      }
    });
  }
})();

function closeContr() {
  $("#closeModalContr").click();
  $("#createOTS").click();
}

function saveContrFisica() {
  $("#saveButtonFisica").click();
}

function saveContrMoral() {
  $("#saveButtonMoral").click();
}

// function showButtonFisica() {
//     // $scope.fisicas = true;
//     // $scope.morales = false;
//     $("#saveButtonMoralModal").css("display", "none");
//     $("#saveButtonFisicaModal").css("display", "block");
// }
//
// function showButtonMoral() {
//     // $scope.fisicas = false;
//     // $scope.morales = true;
//
//     $("#saveButtonFisicaModal").css("display", "none");
//     $("#saveButtonMoralModal").css("display", "block");
// }

"use strict";

angular
  .module("inspinia")
  .controller("ContratantesPPEditCtrl", ContratantesPPEditCtrl);
ContratantesPPEditCtrl.$inject = [
  "datesFactory",
  "dataFactory",
  "$parse",
  "SweetAlert",
  "$http",
  "$scope",
  "$stateParams",
  "$state",
  "$uibModal",
  "$localStorage",
  "$q",
  "$timeout",
  "ContratanteService",
  "groupService",
  "contactService",
  "generalService",
  "globalVar",
  "$rootScope",
  "toaster",
  "FileUploader",
  "url",
  "helpers",
  "MESSAGES",
  "fileService",
  "$sessionStorage",
  "$window",
  "$filter",
  "$sce",
];

function ContratantesPPEditCtrl(
  datesFactory,
  dataFactory,
  $parse,
  SweetAlert,
  $http,
  $scope,
  $stateParams,
  $state,
  $uibModal,
  $localStorage,
  $q,
  $timeout,
  ContratanteService,
  groupService,
  contactService,
  generalService,
  globalVar,
  $rootScope,

  toaster,
  FileUploader,
  url,
  helpers,
  MESSAGES,
  fileService,
  $sessionStorage,
  $window,
  $filter,
  $sce
) {
  var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
  var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
  var usr = JSON.parse(decryptedUser);
  var token = JSON.parse(decryptedToken);
  var vm = this;
  vm.org_name = usr.org;
  vm.showInfo = true;
  // configuración del datepicker
  $(".datepicker-me input").datepicker();

  $.fn.datepicker.defaults.format = "dd/mm/yyyy";
  $.fn.datepicker.defaults.startView = 0;
  $.fn.datepicker.defaults.autoclose = true;
  $.fn.datepicker.defaults.language = "es";

  vm.showComments = false;
  vm.showBackButton = true;

  vm.editForm = [];
  vm.celulas = [];
  vm.clasifications = [];
  vm.agrupaciones = [];

  vm.user = usr;
  vm.accesos = $sessionStorage.permisos;
  if (vm.accesos) {
    vm.accesos.forEach(function (perm) {
      if (perm.model_name == "Pólizas") {
        vm.acceso_polizas = perm;
        vm.acceso_polizas.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar pólizas") {
            if (acc.checked == true) {
              vm.acceso_adm_pol = true;
            } else {
              vm.acceso_adm_pol = false;
            }
          } else if (acc.permission_name == "Ver pólizas") {
            if (acc.checked == true) {
              vm.acceso_ver_pol = true;
            } else {
              vm.acceso_ver_pol = false;
            }
          }
        });
      } else if (perm.model_name == "Siniestros") {
        vm.acceso_sin = perm;
        vm.acceso_sin.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar siniestros") {
            if (acc.checked == true) {
              vm.acceso_adm_sin = true;
            } else {
              vm.acceso_adm_sin = false;
            }
          }
        });
      } else if (perm.model_name == "Cobranza") {
        vm.acceso_cob = perm;
        vm.acceso_cob.permissions.forEach(function (acc) {
          if (acc.permission_name == "Ver cobranza") {
            if (acc.checked == true) {
              vm.acceso_ver_cob = true;
            } else {
              vm.acceso_ver_cob = false;
            }
          } else if (acc.permission_name == "Despagar recibos") {
            if (acc.checked == true) {
              vm.acceso_desp_cob = true;
            } else {
              vm.acceso_desp_cob = false;
            }
          } else if (acc.permission_name == "Pagar y prorrogar") {
            if (acc.checked == true) {
              vm.acceso_pag_cob = true;
            } else {
              vm.acceso_pag_cob = false;
            }
          } else if (acc.permission_name == "Desconciliación de recibos") {
            if (acc.checked == true) {
              vm.acceso_desco_cob = true;
            } else {
              vm.acceso_desco_cob = false;
            }
          } else if (acc.permission_name == "Conciliar recibos") {
            if (acc.checked == true) {
              vm.acceso_conc_cob = true;
            } else {
              vm.acceso_conc_cob = false;
            }
          } else if (acc.permission_name == "Liquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_liq_cob = true;
            } else {
              vm.acceso_liq_cob = false;
            }
          }
        });
      } else if (perm.model_name == "Reportes") {
        vm.acceso_reportes = perm;
        vm.acceso_reportes.permissions.forEach(function (acc) {
          if (acc.permission_name == "Reporte fianzas") {
            if (acc.checked == true) {
              vm.acceso_rep_fia = true;
            } else {
              vm.acceso_rep_fia = false;
            }
          } else if (acc.permission_name == "Reporte Siniestros") {
            if (acc.checked == true) {
              vm.acceso_rep_sin = true;
            } else {
              vm.acceso_rep_sin = false;
            }
          } else if (acc.permission_name == "Reporte Endosos") {
            if (acc.checked == true) {
              vm.acceso_rep_end = true;
            } else {
              vm.acceso_rep_end = false;
            }
          } else if (acc.permission_name == "Reporte pólizas") {
            if (acc.checked == true) {
              vm.acceso_rep_pol = true;
            } else {
              vm.acceso_rep_pol = false;
            }
          } else if (acc.permission_name == "Reporte renovaciones") {
            if (acc.checked == true) {
              vm.acceso_rep_ren = true;
            } else {
              vm.acceso_rep_ren = false;
            }
          } else if (acc.permission_name == "Reporte cobranza") {
            if (acc.checked == true) {
              vm.acceso_rep_cob = true;
            } else {
              vm.acceso_rep_cob = false;
            }
          }
        });
      } else if (perm.model_name == "Contratantes y grupos") {
        vm.acceso_contg = perm;
        vm.acceso_contg.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar contratantes y grupos") {
            if (acc.checked == true) {
              vm.acceso_adm_cont = true;
            } else {
              vm.acceso_adm_cont = false;
            }
          } else if (acc.permission_name == "Ver contratantes y grupos") {
            if (acc.checked == true) {
              vm.acceso_ver_cont = true;
            } else {
              vm.acceso_ver_cont = false;
            }
          }
        });
      } else if (perm.model_name == "Fianzas") {
        vm.acceso_fian = perm;
        vm.acceso_fian.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar fianzas") {
            if (acc.checked == true) {
              vm.acceso_adm_fia = true;
            } else {
              vm.acceso_adm_fia = false;
            }
          } else if (acc.permission_name == "Ver fianzas") {
            if (acc.checked == true) {
              vm.acceso_ver_fia = true;
            } else {
              vm.acceso_ver_fia = false;
            }
          }
        });
      } else if (perm.model_name == "Archivos") {
        vm.acceso_files = perm;
        vm.acceso_files.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar archivos sensibles") {
            if (acc.checked == true) {
              vm.permiso_archivos = true;
            } else {
              vm.permiso_archivos = false;
            }
          }
        });
      }
    });
  }
  /** Uploader files */
  vm.goToContractorEdit = goToContractorEdit;
  vm.uploadImages = uploadImages;
  vm.verCobranza = verCobranza;
  vm.verPolizas = verPolizas;
  vm.verSiniestros = verSiniestros;
  vm.getSinister = getSinister;
  vm.ramo_changed = ramo_changed;
  vm.ramos = {};
  vm.ramos.ramo_selected = 2;
  vm.deleteAddress = deleteAddress;
  vm.ramos.options = [
    { id: 2, label: "Accidentes y Enfermedades" },
    { id: 3, label: "Daños" },
    { id: 1, label: "Vida" },
  ];

  vm.address_type = [
    {
      name: "Dirección Personal",
      id: 0,
    },
    {
      name: "Dirección Fiscal",
      id: 1,
    },
    {
      name: "Dirección de cobro",
      id: 2,
    },
    {
      name: "Dirección de paquetería",
      id: 3,
    },
    {
      name: "Dirección de riesgo",
      id: 4,
    },
    {
      name: "CFDI",
      id: 5,
    },
  ];

  vm.showPendientes = showPendientes;
  vm.showPagados = showPagados;
  vm.showLiquidados = showLiquidados;
  vm.showCancelados = showCancelados;
  vm.showNotas = showNotas;
  $scope.contractor = [];

  vm.cPendientes = true;
  vm.cPagados = false;
  vm.cLiquidados = false;
  vm.cCancelados = false;
  $scope.flagPhone = false;

  $scope.contractorEdit = [];
  vm.getPDFEdo = getPDFEdo;

  $scope.change_vip = function (url, vip) {
    $http.patch(url, { vip: vip }).then(function (response) {
      if (response.status == 200) {
        toaster.success("Cambio exitoso", "El cambio se ha aplicado con éxito");
      } else {
        toaster.warning("Ha ocurrido un problema", "Intente nuevamente");
        vm.form.vip = !vip;
      }
    });
  };

  function getPDFEdo(contr) {
    $http({
      method: "GET",
      url: url.IP + "get-pdf-edocuenta/",
      params: {
        id: contr.id,
        tipo: contr.type_person,
      },
    }).then(function success(response) {
      if (response.status === 200 || response.status === 201) {
        toaster.info("Se generó el PDF");
        $scope.pdf = response.data;

        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
        var params = {
          // 'model': contr.type_person == "Fisica" ? 2 : 3,
          model: contr.type_person == "Fisica" ? 26 : 26,
          event: "POST",
          associated_id: contr.id,
          identifier: "generó el PDF.",
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});
      } else {
        toaster.warning("Ocurrió Un problema, Intenta nuevamente");
      }
    });
  }
  $scope.changeSensible = function (sensible, index) {
    uploader.queue[index].formData[0].sensible = sensible;
  };

  $scope.saveFile = function (file) {
    $http.patch(file.url, {
      nombre: file.nombre,
      sensible: file.sensible,
      name: file.nombre,
    });
  };

  $scope.status = function (value) {
    switch (value) {
      case 1:
        return "En trámite";
        break;
      case 2:
        return "OT Cancelada";
        break;
      case 4:
        return "Precancelada";
        break;
      case 10:
        return "Por iniciar";
        break;
      case 11:
        return "Cancelada";
        break;
      case 12:
        return "Renovada";
        break;
      case 13:
        return "Vencida";
        break;
      case 14:
        return "Vigente";
        break;
      case 15:
        return "No renovada";
        break;
      default:
        return "Pendiente";
    }
  };

  $scope.payment = function (value) {
    switch (value) {
      case 1:
        return "Mensual";
        break;
      case 2:
        return "Bimestral";
        break;
      case 3:
        return "Trimestral";
        break;
      case 4:
        return "Cuatrimestral";
        break;
      case 5:
        return "Contado";
        break;
      case 6:
        return "Semestral";
        break;
      case 12:
        return "Anual";
        break;
      case 24:
        return "Quincenal";
        break;
      default:
        return "No especificada";
    }
  };

  $scope.goToPolicyInfo = function (insurance) {
    if (insurance.document_type == 1) {
      $state.go("polizas.info", { polizaId: insurance.id });
    } else if (insurance.document_type == 3) {
      $state.go("colectividades.info", { polizaId: insurance.id });
    }
  };

  function showPendientes() {
    vm.cPendientes = true;
    vm.cPagados = false;
    vm.cLiquidados = false;
    vm.cCancelados = false;
  }

  function showPagados() {
    vm.cPendientes = false;
    vm.cPagados = true;
    vm.cLiquidados = false;
    vm.cCancelados = false;
  }

  function showLiquidados() {
    vm.cPendientes = false;
    vm.cPagados = false;
    vm.cLiquidados = true;
    vm.cCancelados = false;
  }

  function showCancelados() {
    vm.cPendientes = false;
    vm.cPagados = false;
    vm.cLiquidados = false;
    vm.cCancelados = true;
  }

  vm.showSinPendientes = showSinPendientes;
  vm.showSinTramites = showSinTramites;
  vm.showSinCancelados = showSinCancelados;
  vm.showSinRechazados = showSinRechazados;
  vm.showSinCompletados = showSinCompletados;
  vm.NotasModal = NotasModal;

  vm.sinPendientes = true;
  vm.sinTramites = false;
  vm.sinCancelados = false;
  vm.sinRechazados = false;
  vm.sinCompletados = false;

  function showSinPendientes() {
    vm.sinPendientes = true;
    vm.sinTramites = false;
    vm.sinCancelados = false;
    vm.sinRechazados = false;
    vm.sinCompletados = false;
  }

  function showSinTramites() {
    vm.sinPendientes = false;
    vm.sinTramites = true;
    vm.sinCancelados = false;
    vm.sinRechazados = false;
    vm.sinCompletados = false;
  }

  function showSinCancelados() {
    vm.sinPendientes = false;
    vm.sinTramites = false;
    vm.sinCancelados = true;
    vm.sinRechazados = false;
    vm.sinCompletados = false;
  }

  function showSinRechazados() {
    vm.sinPendientes = false;
    vm.sinTramites = false;
    vm.sinCancelados = false;
    vm.sinRechazados = true;
    vm.sinCompletados = false;
  }

  function showSinCompletados() {
    vm.sinPendientes = false;
    vm.sinTramites = false;
    vm.sinCancelados = false;
    vm.sinRechazados = true;
    vm.sinCompletados = false;
  }

  vm.table = {
    headers: [
      "Afectado",
      "Contratante",
      "Aseguradora",
      "Número de siniestro",
      "Padecimiento",
      "Reclamado",
      "Subramo",
      "Acciones",
      "Número de póliza",
      "Razón",
    ],
  };
  vm.verEndosos = verEndosos;
  $scope.deleteFile = deleteFile;
  $window.localStorage.editCont = false;

  /*Crear Poliza*/
  $scope.goToPolicy = function (data) {
    var params = { myInsurance: data };
    $state.go("polizas.create", params);
  };

  $scope.goToSurety = function (data) {
    var params = { myInsurance: data };
    $state.go("fianzas.fianzas", params);
  };

  $scope.archivos = {};
  $scope.archivos = {
    headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
  };

  $scope.filterValue = function ($event) {
    if (isNaN(String.fromCharCode($event.charCode))) {
      $event.preventDefault();
    }
  };

  /* Cobranza */
  function verCobranza(param, status) {
    // if($scope.infoUser.staff && !$scope.infoUser.superuser){
    //     // var parUrl = url.IP + 'v2/contratantes/get-cobranza-natural/';
    //     var parUrl = url.IP + 'v2/contratantes/get-cobranza-contractor/';
    var parUrl = url.IP + "get-cobranza-contractor/";
    vm.polizas = false;
    vm.cobranza = true;
    vm.siniestros = false;
    vm.showInfo = false;
    $http({
      method: "GET",
      url: parUrl,
      params: {
        status: status,
        contratante: param.id,
      },
    }).then(function success(response) {
      if (response.status === 200 && response.data.results.length) {
        $scope.results = response.data.results;

        vm.receipts = [];
        vm.receipt = {};
        vm.receipts = response.data.results;
        vm.receipt = {
          count: response.data.count,
          previous: response.data.previous,
          next: response.data.next,
        };
        vm.show_pag_policy = true;
        testPagination("vm.receipts", "vm.receipt");
      } else {
        toaster.warning("No se encontraron registro");
      }
    });
  }

  $rootScope.changeVendedor = function (data) {
    if (vm.form) {
      vm.form.vendor = data.url;
    } else {
      vm.juridicalForm.vendor = data.url;
    }
  };

  /* Siniestros */
  function verSiniestros(param, status, ramo) {
    $http({
      method: "GET",
      url: url.IP + "siniestros-conteos-contractor/",
      params: {
        contractor: param.id,
      },
    }).then(function success(response) {
      vm.conteos = response.data;
    });

    // if($scope.infoUser.staff && !$scope.infoUser.superuser){
    //     // var parUrl = url.IP + 'v2/contratantes/get-siniestros-natural/';
    //     var parUrl = url.IP + 'v2/contratantes/get-siniestros-contractor/';
    var parUrl = url.IP + "get-siniestros-contractor/";

    vm.polizas = false;
    vm.cobranza = false;
    vm.siniestros = true;
    vm.showInfo = false;

    $http({
      method: "GET",
      url: parUrl,
      params: {
        status: status,
        contratante: param.id,
        ramo_number: ramo,
      },
    }).then(function success(request) {
      if (request.status === 200 && request.data.results.length) {
        vm.loading = false;
        vm.siniestros = [];
        vm.siniestros_config = {};
        vm.siniestros = request.data.results;
        vm.siniestros_config = {
          count: request.data.count,
          previous: request.data.previous,
          next: request.data.next,
        };
        vm.show_pag_policy = true;

        testPagination("vm.siniestros", "vm.siniestros_config");
      } else {
        toaster.warning("No se encontraron registro");
      }
    });
  }
  vm.changePoliza = changePoliza;
  function changePoliza(par, asc) {
    switch (par) {
      case 1:
        vm.verPolizas($scope.contratante_selected, par, asc);
        vm.pol_number_asc = asc;
        vm.aseguradora_asc = 0;
        vm.subramo_asc = 0;
        vm.estatus_asc = 0;
        vm.vigencia_asc = 0;
        break;
      case 2:
        vm.verPolizas($scope.contratante_selected, par, asc);
        vm.pol_number_asc = 0;
        vm.aseguradora_asc = asc;
        vm.subramo_asc = 0;
        vm.estatus_asc = 0;
        vm.vigencia_asc = 0;
        break;
      case 3:
        vm.verPolizas($scope.contratante_selected, par, asc);
        vm.pol_number_asc = 0;
        vm.aseguradora_asc = 0;
        vm.subramo_asc = asc;
        vm.estatus_asc = 0;
        vm.vigencia_asc = 0;
        break;
      case 4:
        vm.verPolizas($scope.contratante_selected, par, asc);
        vm.pol_number_asc = 0;
        vm.aseguradora_asc = 0;
        vm.subramo_asc = 0;
        vm.estatus_asc = asc;
        vm.vigencia_asc = 0;
        break;
      case 5:
        vm.verPolizas($scope.contratante_selected, par, asc);
        vm.pol_number_asc = 0;
        vm.aseguradora_asc = 0;
        vm.subramo_asc = 0;
        vm.estatus_asc = 0;
        vm.vigencia_asc = asc;
        break;
    }
  }
  /* Polizas */
  function verPolizas(param, order, asc) {
    $scope.contratante_selected = param;
    // if($scope.infoUser.staff && !$scope.infoUser.superuser){
    //     // var parUrl = url.IP + 'v2/contratantes/get-polizas-natural/';
    //     var parUrl = url.IP + 'v2/contratantes/get-polizas-contractor/';
    var parUrl = url.IP + "get-polizas-contractor/";
    vm.polizas = true;
    vm.cobranza = false;
    vm.siniestros = false;
    vm.showInfo = false;
    $http({
      method: "GET",
      url: parUrl,
      params: {
        contratante: param.id,
        order: order,
        asc: asc,
      },
    }).then(function success(request) {
      vm.search_results = [];
      vm.ot_results = [];

      if (
        (request.status === 200 || request.status === 201) &&
        request.data.results.length
      ) {
        vm.show_results = true;
        vm.show_policy = false;
        var data = request.data.results;
        data.forEach(function (item) {
          // if(item.status == 1 || item.status == 2) {
          //   vm.ot_results.push(item);
          // }
          // else{
          //   vm.search_results.push(item);
          // }
          vm.search_results.push(item);
        });
        vm.search_config = {
          count: request.data.count,
          previous: request.data.previous,
          next: request.data.next,
        };
        vm.show_pag_search = true;
        testPagination("vm.search_results", "vm.search_config");
      } else {
        toaster.warning("No se encontraron registros");
      }
    });
  }
  /* Notas de credito */
  function NotasModal(receipt) {
    var insurance = receipt;
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/cobranzas/notaCredito.modal.html",
      controller: "NotaCreditoCtrl",
      size: "lg",
      resolve: {
        receipt: function () {
          return receipt;
        },
        insurance: function () {
          return insurance;
        },
        from: function () {
          return null;
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
    });
    modalInstance.result.then(function (receipt) {
      vm.receipts.splice(index, 1);
      activate();
    });
  }

  function ramo_changed() {
    if (vm.form) {
      verSiniestros(vm.form, 1, vm.ramos.ramo_selected);
    } else {
      verSiniestros(vm.juridicalForm, 1, vm.ramos.ramo_selected);
    }
  }

  function getSinister(ramo, status) {
    if (vm.form) {
      verSiniestros(vm.form, status, ramo);
    } else {
      verSiniestros(vm.juridicalForm, status, ramo);
    }
  }

  /* Endosos */
  function verEndosos(param, status, ramo) {
    // body...
  }

  vm.activityLog = false;
  $scope.log_data = [];

  $scope.goToLog = function () {
    if (vm.form) {
      $scope.log_data.id = vm.form.id;
      $scope.log_data.type_person = 26;
    } else {
      $scope.log_data.id = vm.juridicalForm.id;
      $scope.log_data.type_person = 26;
    }

    vm.showInfo = false;
    vm.activityLog = true;

    $http({
      method: "GET",
      url: url.IP + "get-specific-log/",
      params: {
        associated_id: $scope.log_data.id,
        model: $scope.log_data.type_person,
      },
    })
      .then(function (request) {
        $scope.log_info = request.data;
      })
      .catch(function (e) {
        console.log("e", e);
      });
  };

  function testPagination(parModel, parConfig) {
    var config_ = $parse(parConfig)($scope);
    if (config_) {
      var pages = Math.ceil(config_.count / 10);
    }
    $scope.totalPages = [];
    var count_items = 0;
    var count_pages = 0;

    var previous_array = [];
    var next_array = [];

    $scope.start = 0;
    $scope.end = 5;
    $scope.actual_page = 1;
    $scope.not_prev = true;

    for (var i = 0; i < pages; i++) {
      $scope.totalPages.push(i + 1);
    }

    $scope.lastPage = function () {
      // TODO: ultimo bloque
      if ($scope.totalPages.length > 5) {
        $scope.end = $scope.totalPages.length;
        $scope.start = $scope.totalPages.length - 5;
        $scope.show_prev_block = true;
      }

      $scope.selectPage($scope.totalPages.length);

      $scope.actual_page = $scope.totalPages.length;
    };

    $scope.selectPage = function (parPage) {
      if (config_.next || config_.previous) {
        if (config_.next) {
          var next_ = config_.next;

          var otherParameters = config_.next.substring(
            config_.next.indexOf("&page=") + 6
          );

          if (next_.search("&status=") !== -1) {
            var status = next_.substring(next_.indexOf("&status=") + 1);
          } else {
            var status = "";
          }

          var url = config_.next.substring(
            0,
            config_.next.indexOf("&page=") + 6
          );
          url += parPage.toString();
          url += "&" + status;

          if (config_.next.search("&") !== -1) {
            var params = otherParameters.substring(
              2,
              otherParameters.indexOf("&") + 1000
            );
            url += "&" + params;
          }
        } else {
          var prev_ = config_.previous;
          var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
          if (prev_.search("&status=") !== -1) {
            var status = prev_.substring(prev_.indexOf("&status=") + 1);
          } else {
            var status = "";
          }

          if (prev_.search("&page=") !== -1) {
            var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
            url += parPage.toString();
            url += "&" + status;
          } else {
            var url = config_.previous;
          }
          if (config_.prev_.search("&") !== -1) {
            var params = otherParameters.substring(
              2,
              otherParameters.indexOf("&") + 1000
            );
            url += "&" + params;
          }
        }
      }

      // url += '&status=1'
      getCobranzaPag(url);
      $scope.actual_page = parPage;
      if ($scope.actual_page > 1) {
        $scope.not_prev = false;
      }

      if ($scope.actual_page == $scope.totalPages.length - 1) {
        $scope.not_next = true;
      }
    };

    $scope.previousBlockPages = function (param) {
      if (param) {
        if ($scope.start < $scope.actual_page) {
          $scope.start = $scope.start - 1;
          $scope.end = $scope.end - 1;
        }
      } else {
        $scope.start = $scope.start - 5;
        $scope.end = $scope.end - 5;

        if ($scope.end < $scope.totalPages.length) {
          $scope.not_next = false;
        }
      }

      if ($scope.end <= 5) {
        $scope.start = 0;
        $scope.end = 5;
        $scope.show_prev_block = false;
      }
    };

    $scope.nextBlockPages = function (param) {
      $scope.show_prev_block = true;

      if (param) {
        if ($scope.end > $scope.actual_page) {
          $scope.start = $scope.start + 1;
          $scope.end = $scope.end + 1;
        }
      } else {
        if ($scope.end < $scope.totalPages.length) {
          $scope.start = $scope.start + 5;
          $scope.end = $scope.end + 5;

          if ($scope.end == $scope.totalPages.length) {
            $scope.not_next = true;
          }
        } else {
          $scope.not_next = true;
        }
      }
    };

    function getCobranzaPag(parUrl) {
      $http
        .get(parUrl)
        .then(
          function success(request) {
            var source = $parse(parModel);
            source.assign($scope, []);
            source.assign($scope, request.data.results);

            var data = {
              count: request.data.count,
              previous: request.data.previous,
              next: request.data.next,
            };
            var config = $parse(parConfig);
            config.assign($scope, []);
            config.assign($scope, data);
          },
          function error(error) {
            console.log("error", error);
          }
        )
        .catch(function (e) {
          console.log("e", e);
        });
    }
  }

  function goToContractorEdit(person) {
    $state.go("fianzas.pprovedit", {
      type: checkType(person.type_person),
      contratanteId: person.id,
    });
  }

  function showNotas() {
    vm.notasFlag = true;
  }

  function checkType(type) {
    //jshint ignore:line
    return type === 1 ? "fisicas" : "morales";
  }

  function uploadImages() {
    // if ($stateParams.type === 'fisicas') {
    //     $scope.userInfo = {
    //         id: vm.form.id,
    //         type_person: 'contractors'
    //     };
    // } else {
    //     $scope.userInfo = {
    //         id: vm.juridicalForm.id,
    //         type_person: 'contractors'
    //     };
    // }
    $scope.userInfo = {
      id: vm.form ? vm.form.id : vm.juridicalForm.id,
      type_person: "contractors",
    };
    // Upload files
    // $scope.userInfo.url = $scope.uploader.url = url.IP + helpers.checkType($scope.userInfo.type_person) + '/' + $scope.userInfo.id + '/archivos/';
    $scope.userInfo.url = $scope.uploader.url =
      url.IP + "contractors/" + $scope.userInfo.id + "/archivos/";

    $scope.uploader.uploadAll();
    // toaster.success(MESSAGES.OK.UPLOADFILES);
  }

  var uploader = ($scope.uploader = new FileUploader({
    headers: {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    },
  }));

  // uploader.filters.push({
  //     name: 'customFilter',
  //     fn: function(item /*{File|FileLikeObject}*/ , options) {
  //         return this.queue.length < 20;
  //     }
  // });

  // ALERTA SUCCES UPLOADFILES
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    toaster.success(MESSAGES.OK.UPLOADFILES);
  };

  // ALERTA ERROR UPLOADFILES
  uploader.onErrorItem = function (fileItem, response, status, headers) {
    SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
  };

  uploader.onAfterAddingFile = function (item) {
    //var fl = new FileUploader.FileItem();
    /*
        Object.defineProperty(item._file, 'name',{
            value : item.file.name,
            writable : true
        });

        var fileExtension = '.' + item.file.name.split('.').pop();

        item.file.name = Math.random().toString(36).substring(7) + new Date().getTime() + fileExtension;*/
    item.formData.push({
      arch: item._file,
      name: "",
      // owner: $scope.userInfo.id
    });
  };

  uploader.onBeforeUploadItem = function (item) {
    item.url = $scope.userInfo.url;
    item.formData[0].name = item.file.name;
    item.alias = "";
    item.formData[0].owner = $scope.userInfo.id;
  };

  vm.person = {};
  vm.cancel = cancel;
  vm.save = save;
  vm.save_moral = save_moral;

  // Modals
  vm.openModalDeleteContratantes = openModalDeleteContratantes;
  vm.deleteContractor = deleteContractor;

  // Groups
  vm.groups = [];
  vm.openModalGroup = openModalGroup;
  vm.openModalClasification = openModalClasification;
  vm.openModalCelulaContractor = openModalCelulaContractor;
  vm.openModalAsignacion = openModalAsignacion;

  // Contacts
  vm.addContact = addContact;
  vm.deleteContacts = deleteContacts;

  // Addresses
  vm.addresses = {
    add: addAddress,
    selectedState: selectedState,
    delete: deleteAddress,
  };

  function deleteFile(file) {
    var url = vm.form ? vm.form.url : vm.juridicalForm.url;
    fileService.deleteFile(file, vm.files);
  }

  function addAddress(type) {
    // HACK remove before production
    var address = {
      raw: "",
      street_address: "",
      intersection: "",
      political: "",
      administrative_area_level_1: "",
      administrative_area_level_1_short: "",
      administrative_area_level_2: "",
      administrative_area_level_3: "",
      colloquial_area: "",
      sublocality: "",
      neighborhood: "",
      premise: "",
      subpremise: "",
      natural_feature: "",
      country: "",
      country_code: "",
      locality: "",
      postal_code: "",
      route: "",
      street_number: "",
      street_number_int: "",
      formatted: "",
      latitude: "",
      longitude: "",
      details: "",
      composed: "",
    };
    if (type === 1) {
      vm.form.userAddresses.push(address);
    } else {
      vm.juridicalForm.userAddresses.push(address);
    }
  }

  function deleteContractor(id, selector) {
    swal(
      {
        title: "¿Estás seguro?",
        text: "¿Desea eliminar el contratante?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Si, estoy seguro.",
        cancelButtonText: "Cancelar",
        closeOnConfirm: false,
        closeOnCancel: false,
      },
      function (isConfirm) {
        if (isConfirm) {
          var data_email = {
            id: id,
            model: 3,
            type_person: selector,
          };
          $http
            .post(url.IP + "delete-contractor/", { id: id, selector: selector })
            .then(function (response) {
              if (response.data.status === "error") {
                SweetAlert.swal(
                  "No se puede eliminar",
                  MESSAGES.WARNING.WARNINGCONTRACTOR,
                  "info"
                );
                return;
              } else {
                $http
                  .patch($scope.contractor.url, { is_active: false })
                  .then(function (response) {
                    if (response.status === 200 || response.status === 201) {
                      var params = {
                        model: $scope.contractor.type_person == 1 ? 26 : 26,
                        event: "POST",
                        associated_id: $scope.contractor.id,
                        identifier: "elimino el contratante",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                      dataFactory
                        .post("send-email-admins-deletes/", data_email)
                        .then(function success(req) {});
                      SweetAlert.swal(
                        "¡Listo!",
                        MESSAGES.OK.DELETECONTRATANTE,
                        "success"
                      );
                      $state.go("fianzas.pprovlist");
                    }
                  });
              }
            });
        } else {
          SweetAlert.swal("Cancelado", MESSAGES.INFO.CANCELCONTRACTOR, "error");
        }
      }
    );
  }

  function deleteAddress(index, type) {
    $localStorage.aindex = index;
    $localStorage.atype = type;
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/contratantes/contratantes.deleteAddress.html",
      controller: ModalInstanceCtrlDeleteAddress,
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
      //windowClass: 'animated fadeIn'
    });
  }

  vm.emails = {
    add: addEmail,
    delete: deleteEmail,
  };

  vm.emailToSend = [];
  vm.toDeleteEmails = [];

  function addEmail(type) {
    if (type === 1) {
      vm.form.correo = "";
      var addEmails = {
        correo: vm.form.correo,
        email_type: 0,
      };
      vm.form.email_natural.push(addEmails);
    } else {
      vm.juridicalForm.correo = "";
      var addEmails = {
        correo: vm.juridicalForm.correo,
        email_type: 0,
      };
      vm.juridicalForm.email_juridical.push(addEmails);
    }
  }
  function deleteEmail(index, type, item) {
    if (type === 1) {
      vm.form.email_natural.splice(index, 1);
      vm.toDeleteEmails.push(item);
    } else {
      vm.juridicalForm.email_juridical.splice(index, 1);
      vm.toDeleteEmails.push(item);
    }
  }
  $scope.sendEmails = function (id, typePerson) {
    if (typePerson == 1) {
      $scope.origin_email = angular.copy(vm.form.email_natural);
      if (vm.form.email_natural) {
        for (var i = 0; i < vm.form.email_natural.length; i++) {
          if (!vm.form.email_natural[i].url) {
            vm.correo = {
              correo: vm.form.email_natural[i].correo,
              juridical: null,
              // natural: vm.form.url,
              contractor: vm.form.url,
              email_type: vm.form.email_natural[i].email_type
                ? vm.form.email_natural[i].email_type
                : 1,
            };
            vm.emailToSend.push(vm.correo);
          } else {
            $http
              .patch(vm.form.email_natural[i].url, vm.form.email_natural[i])
              .then(function success(request) {})
              .catch(function (e) {
                console.log(e);
              });
          }
        }
      }
    } else {
      if (vm.juridicalForm.email_juridical) {
        for (var i = 0; i < vm.juridicalForm.email_juridical.length; i++) {
          if (!vm.juridicalForm.email_juridical[i].url) {
            vm.correo = {
              correo: vm.juridicalForm.email_juridical[i].correo,
              // juridical: vm.juridicalForm.url,
              contractor: vm.juridicalForm.url,
              natural: null,
              email_type: vm.juridicalForm.email_juridical[i].email_type
                ? vm.juridicalForm.email_juridical[i].email_type
                : 1,
            };
            vm.emailToSend.push(vm.correo);
          } else {
            $http
              .patch(
                vm.juridicalForm.email_juridical[i].url,
                vm.juridicalForm.email_juridical[i]
              )
              .then(function success(request) {})
              .catch(function (e) {
                console.log(e);
              });
          }
        }
      }
    }

    vm.toDeleteEmails.forEach(function (del) {
      if (del.url) {
        $http.delete(del.url);

        $scope.changes = [];

        var change_log = {
          name: "Correos Electrónicos",
          origin: del.correo,
          change: "",
        };
        $scope.changes.push(change_log);

        var paramsRec = {
          model: 26,
          event: "PATCH",
          associated_id: $scope.origin_contractor.id,
          identifier: " actualizó el contratante.",
          change: $scope.changes,
        };

        if ($scope.changes.length > 0) {
          dataFactory
            .post("send_log_specific/", paramsRec)
            .then(function success(response) {});
        }
      }
    });

    $http
      .post(url.IP + "emails/", vm.emailToSend)
      .then(
        function success(request) {
          vm.form = {
            email: "",
            phone: "",
          };
          vm.form.email = request.data;
          $scope.changes = [];

          for (var i = 0; i < request.data.length; i++) {
            var change_log = {
              name: "Correos Electrónicos",
              origin: "",
              change: request.data[i].correo,
            };
            $scope.changes.push(change_log);
            if (i + 1 == request.data.length) {
              var paramsRec = {
                model: 26,
                event: "PATCH",
                associated_id: $scope.origin_contractor.id,
                identifier: " actualizó el contratante.",
                change: $scope.changes,
              };

              if ($scope.changes.length > 0) {
                dataFactory
                  .post("send_log_specific/", paramsRec)
                  .then(function success(response) {});
              }
            }
          }
        },
        function error(error) {
          console.log(error);
        }
      )
      .catch(function (e) {
        console.log(e);
      });
  };

  $rootScope.changeGroup = function (data) {
    if (data) {
      if (data.id) {
        dataFactory
          .post("subgrupos-match/", { parent: data.id })
          .then(function (subgrupos_) {
            vm.subgroups = subgrupos_.data;
          });
      } else {
        if (data) {
          if (data.subgrupos) {
            vm.subgroups = data.subgrupos;
          } else {
            vm.subgroups = [];
          }
        } else {
          vm.subgroups = [];
        }
      }
    } else {
      vm.subgroups = [];
    }
  };

  $rootScope.changeSubGroup = function (data) {
    // if (data) {
    //   if (data.id) {
    //     dataFactory.post('subsubgrupos-match/', { parent: data.id })
    //     .then(function(subgrupos_2) {
    //         $scope.sub_subgroups = subgrupos_2.data;
    //     });
    //   }else{
    if (data) {
      if (data.subsubgrupos) {
        vm.sub_subgroups = data.subsubgrupos;
      } else {
        vm.sub_subgroups = [];
      }
    } else {
      vm.sub_subgroups = [];
    }
    //   }
    // }else{$scope.sub_subgroups = [];}
  };

  $rootScope.changeAgrupacion2 = function (data) {
    // $scope.sub_asignaciones = data.subgrupos;
    if (data) {
      if (data.id) {
        dataFactory
          .post("subagrupaciones-match/", { parent: data.id })
          .then(function (subgrupos_) {
            $scope.sub_asignaciones = subgrupos_.data;
          });
        $scope.sub_subasignaciones = [];
      } else {
        if (data) {
          if (data.subgrupos) {
            $scope.sub_asignaciones = data.subgrupos;
          } else {
            $scope.sub_asignaciones = [];
          }
        } else {
          $scope.sub_asignaciones = [];
        }
      }
    } else {
      $scope.sub_asignaciones = [];
    }
  };

  $rootScope.changeSubagrupacion2 = function (data) {
    if (data) {
      if (data.subsubgrupos) {
        $scope.sub_subasignaciones = data.subsubgrupos;
      } else {
        if (data.subgrupos) {
          $scope.sub_subasignaciones = data.subgrupos;
        } else {
          $scope.sub_subasignaciones = [];
        }
      }
    } else {
      $scope.sub_subasignaciones = [];
    }
  };

  vm.phones = {
    add: addPhone,
    delete: deletePhone,
  };

  vm.phoneToSend = [];
  vm.toDeletePhones = [];

  function addPhone(type) {
    if (type === 1) {
      var addPhones = {
        phone: vm.form.phone,
        phone_type: 0,
      };
      vm.form.phone_natural.push(addPhones);
    } else {
      var addPhones = {
        phone: vm.juridicalForm.phone,
        phone_type: 0,
      };
      vm.juridicalForm.phone_juridical.push(addPhones);
    }
  }
  function deletePhone(index, type, item) {
    if (type === 1) {
      vm.form.phone_natural.splice(index, 1);
      vm.toDeletePhones.push(item);
    } else {
      vm.juridicalForm.phone_juridical.splice(index, 1);
      vm.toDeletePhones.push(item);
    }
  }
  $scope.sendPhones = function (id, typePerson) {
    if (typePerson == 1) {
      if (vm.form.phone_natural) {
        for (var i = 0; i < vm.form.phone_natural.length; i++) {
          if (!vm.form.phone_natural[i].url) {
            vm.telefono = {
              phone: vm.form.phone_natural[i].phone,
              juridical: null,
              // natural: vm.form.url,
              contractor: vm.form.url,
              phone_type: vm.form.phone_natural[i].phone_type
                ? vm.form.phone_natural[i].phone_type
                : 1,
            };
            vm.phoneToSend.push(vm.telefono);
          } else {
            $http
              .patch(vm.form.phone_natural[i].url, vm.form.phone_natural[i])
              .then(function success(request) {})
              .catch(function (e) {
                console.log(e);
              });
          }
        }
      }
    } else {
      if (vm.juridicalForm.phone_juridical) {
        for (var i = 0; i < vm.juridicalForm.phone_juridical.length; i++) {
          if (!vm.juridicalForm.phone_juridical[i].url) {
            vm.telefono = {
              phone: vm.juridicalForm.phone_juridical[i].phone,
              // juridical: vm.juridicalForm.url,
              contractor: vm.juridicalForm.url,
              natural: null,
              phone_type: vm.juridicalForm.phone_juridical[i].phone_type
                ? vm.juridicalForm.phone_juridical[i].phone_type
                : 1,
            };
            vm.phoneToSend.push(vm.telefono);
          } else {
            $http
              .patch(
                vm.juridicalForm.phone_juridical[i].url,
                vm.juridicalForm.phone_juridical[i]
              )
              .then(function success(request) {})
              .catch(function (e) {
                console.log(e);
              });
          }
        }
      }
    }

    vm.toDeletePhones.forEach(function (phone) {
      if (phone.url) {
        $http.delete(phone.url);
      }
    });

    $http
      .post(url.IP + "phones/", vm.phoneToSend)
      .then(
        function success(request) {
          vm.form = {
            phone: request.data,
          };
        },
        function error(error) {
          console.log(error);
        }
      )
      .catch(function (e) {
        console.log(e);
      });
  };

  vm.closeDropdown = closeDropdown;

  function closeDropdown() {
    $(".hasDropdown").removeClass("open");
  }

  function ModalInstanceCtrlDeleteAddress($scope, $uibModalInstance) {
    var index = $localStorage.aindex;
    var type = $localStorage.atype;
    $scope.ok = function () {
      if (!index && index != 0) {
        if (type === 1) {
          vm.form.userAddresses.splice(index, 1);
        } else {
          vm.juridicalForm.userAddresses.splice(index, 1);
        }
      } else {
        try {
          if (type === 1) {
            if (vm.form) {
              var obj = vm.form.userAddresses[index];
              generalService.deleteService(obj);
              vm.form.userAddresses.splice(index, 1);
            } else {
              generalService.deleteService(
                vm.juridicalForm.userAddresses[index]
              );
              vm.juridicalForm.userAddresses.splice(index, 1);
            }
          } else {
            generalService.deleteService(vm.juridicalForm.userAddresses[index]);
            vm.juridicalForm.userAddresses.splice(index, 1);
          }
          toaster.success(MESSAGES.OK.DELETEADDRESS);
          $uibModalInstance.dismiss("cancel");
        } catch (err) {
          if (type === 1) {
            if (vm.form) {
              vm.form.userAddresses.splice(index, 1);
            } else {
              vm.juridicalForm.userAddresses.splice(index, 1);
            }
          } else {
            vm.juridicalForm.userAddresses.splice(index, 1);
          }
        }
      }
      $uibModalInstance.dismiss("cancel");
    };

    $scope.cancel = function () {
      if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
    };
  }

  var obligados1 = {
    obligado: {},
  };
  $scope.addObligados = function (type) {
    if (type === 1) {
      var addobligadoss = {
        obligado: obligados1,
      };
      if (vm.form) {
        vm.form.obligados.push(addobligadoss);
      }
    } else {
      var addobligadoss = {
        obligado: obligados1,
      };
      if (vm.juridicalForm) {
        vm.juridicalForm.obligados.push(addobligadoss);
      }
    }
  };
  $scope.deleteObligados = function (index, type) {
    if (type === 1) {
      vm.form.obligados.splice(index, 1);
    } else {
      vm.juridicalForm.obligados.splice(index, 1);
    }
  };
  $scope.addResponsable = function (type) {
    if (type === 1) {
      var addresponsables = {
        responsables: vm.form.responsable,
        resp_type: 0,
      };
      vm.form.resp_contractor.push(addresponsables);
    } else {
      var addresponsables = {
        responsables: vm.juridicalForm.responsable
          ? vm.juridicalForm.responsable
          : null,
        resp_type: 0,
      };
      vm.juridicalForm.resp_contractor.push(addresponsables);
    }
  };

  $scope.deleteResponsable = function (index, type) {
    if (type === 1) {
      if (vm.form.resp_contractor[index].url) {
        $http.delete(vm.form.resp_contractor[index].url);
      }

      vm.form.resp_contractor.splice(index, 1);
    } else {
      if (vm.juridicalForm.resp_contractor[index].url) {
        $http.delete(vm.juridicalForm.resp_contractor[index].url);
      }
      vm.juridicalForm.resp_contractor.splice(index, 1);
    }
  };

  function selectedState(selected, index, type) {
    if (type === 1) {
      vm.form.userAddresses[index].city = "";
      vm.form.userAddresses[index].citiesList = selected.cities;
    } else {
      vm.juridicalForm.userAddresses[index].city = "";
      vm.juridicalForm.userAddresses[index].citiesList = selected.cities;
    }
  }

  if ($stateParams.type === "fisicas") vm.form = {};
  else vm.juridicalForm = {};

  vm.emptyOrNull = function (item) {
    return !(item === null || item.trim().length === 0);
  };
  vm.contratanteId = $stateParams.contratanteId;

  activate();
  $scope.sucursal = function (sc) {};
  function activate() {
    dataFactory
      .get("sucursales-to-show-unpag/")
      .then(function success(response) {
        $scope.sucursalList = response.data;
      });

    $http.get(url.IP + "get-vendors").then(function success(request) {
      vm.vendors = request.data;
      vm.vendors.forEach(function (vendor) {
        vendor.name = vendor.first_name + " " + vendor.last_name;
      });
    });

    $http.get(url.IP + "usuarios/").then(function (user) {
      vm.responsables = user.data.results;
    });

    $http({
      method: "GET",
      url: url.IP + "comments/",
      params: {
        model: 2,
        id_model: vm.contratanteId,
      },
    })
      .then(function (request) {
        vm.comments_data = request.data.results;
        vm.comments_config = {
          count: request.data.count,
          next: request.data.next,
          previous: request.data.previous,
        };
      })
      .catch(function (e) {
        console.log("e", e);
      });

    $http.get(url.IP + "classification/").then(function (response) {
      vm.clasifications = response.data.results;
    });
    $http.post(url.IP + "celula_contractor_info/").then(function (response) {
      vm.celulas = response.data;
    });

    $http.get(url.IP + "groupingLevel-resume/").then(function (response) {
      vm.agrupaciones = response.data;
    });

    $window.localStorage.editCont = true;
    groupService.getGroups().then(function (groups) {
      vm.groups = groups;
    });

    $scope.view_siniestros = true;

    ContratanteService.getContratanteFull($stateParams)
      .then(function (contractor) {
        $scope.origin_contractor = angular.copy(contractor);
        console.log("1683", contractor);
        $scope.contractor = contractor;
        $stateParams.contractor = contractor;
        var contractor = $scope.contractor;
        if (contractor.type_person == 2) {
          $scope.infoMoral = contractor;
          vm.listDocument = [
            {
              id: 1,
              name: "Acta Constitutiva",
              value: contractor.constitutive_act,
              file: false,
              arch: {},
            },
            {
              id: 2,
              name: "RFC",
              value: contractor.rfc_document,
              file: false,
              arch: {},
            },
            {
              id: 3,
              name: "Cédula de Identificación Fiscal",
              value: contractor.card_official_identification,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio Fiscal",
              value: contractor.voucher_of_address,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Modificaciones al Acta Constitutiva",
              value: contractor.modifications_constitutive_act,
              file: false,
              arch: {},
            },
            {
              id: 6,
              name: "Poder",
              value: contractor.fiscal_power,
              file: false,
              arch: {},
            },
          ];
          if (contractor.only_sureties) {
            vm.listDocument.push(
              {
                id: 7,
                name: "Currículo reciente",
                value: contractor.curriculo,
                file: false,
                arch: {},
              },
              {
                id: 8,
                name: "Contrato multiple de la afianzadora",
                value: contractor.contrato_multiple_afianzadora,
                file: false,
                arch: {},
              },
              {
                id: 9,
                name: "Carta Buró",
                value: contractor.carta_buro,
                file: false,
                arch: {},
              },
              {
                id: 10,
                name: "Cuestionario o entrevista",
                value: contractor.entrevista_afianzadora,
                file: false,
                arch: {},
              },
              {
                id: 11,
                name: "Aviso de privacidad de la afianzadora",
                value: contractor.aviso_privacidad,
                file: false,
                arch: {},
              },
              {
                id: 12,
                name: "Protocolizaciones",
                value: contractor.protocolizaciones,
                file: false,
                arch: {},
              },
              {
                id: 13,
                name: "Alta de empresa ante hacienda",
                value: contractor.alta_hacienda,
                file: false,
                arch: {},
              },
              {
                id: 14,
                name: "Cambio de domicilio ante hacienda",
                value: contractor.cambio_domicilio_hacienda,
                file: false,
                arch: {},
              },
              {
                id: 15,
                name: "Copia del comprobante de inscripción para la e.firma (firma electrónica)",
                value: contractor.cambio_domicilio_hacienda,
                file: false,
                arch: {},
              },
              {
                id: 16,
                name: "Declaración anual completa con cadena, de los últimos dos años",
                value: contractor.declaracion_anual,
                file: false,
                arch: {},
              },
              {
                id: 17,
                name: "Estados financieros dictaminados cuadernillo completo, del año inmediato anterior",
                value: contractor.estados_financieros_anuales,
                file: false,
                arch: {},
              },
              {
                id: 18,
                name: "Estados financieros parciales los más recientes de este año con no mayor antigüedad de dos meses",
                value: contractor.estados_financieros_parciales,
                file: false,
                arch: {},
              },
              {
                id: 19,
                name: "Escritura de inmueble",
                value: contractor.escritura_inmueble,
                file: false,
                arch: {},
              },
              {
                id: 20,
                name: "Boleta predial o avaluó",
                value: contractor.boleta_predial,
                file: false,
                arch: {},
              },
              {
                id: 21,
                name: "Certificado de libertad de gravamen",
                value: contractor.certificado_gravamen,
                file: false,
                arch: {},
              }
            );
          }
        }
        if (contractor.type_person == 1) {
          $scope.infoFisico = contractor;
          if (vm.org_name == "ancora") {
            vm.listDocument = [
              {
                id: 1,
                name: "Identificación Oficial",
                value: contractor.card_official_identification,
                file: false,
                arch: {},
              },
              {
                id: 2,
                name: "CURP",
                value: contractor.CURP,
                file: false,
                arch: {},
              },
              {
                id: 3,
                name: "Comprobante de Inscripción de Firma Electrónica",
                value: contractor.voucher_efirm,
                file: false,
                arch: {},
              },
              {
                id: 4,
                name: "Comprobante de Domicilio",
                value: contractor.voucher_of_address,
                file: false,
                arch: {},
              },
              {
                id: 5,
                name: "Formato de Identificación de Cliente Firmado",
                value: contractor.signed_format_ic,
                file: false,
                arch: {},
              },
            ];
            if (contractor.only_sureties) {
              vm.listDocument.push(
                {
                  id: 7,
                  name: "Carta nombramiento",
                  value: contractor.carta_nombramiento,
                  file: false,
                  arch: {},
                },
                {
                  id: 8,
                  name: "Currículo",
                  value: contractor.curriculo,
                  file: false,
                  arch: {},
                },
                {
                  id: 9,
                  name: "Contrato multiple de la afianzadora",
                  value: contractor.contrato_multiple_afianzadora,
                  file: false,
                  arch: {},
                },
                {
                  id: 10,
                  name: "Carta buro",
                  value: contractor.carta_buro,
                  file: false,
                  arch: {},
                },
                {
                  id: 11,
                  name: "Entrevista con la afianzadora",
                  value: contractor.entrevista_afianzadora,
                  file: false,
                  arch: {},
                },
                {
                  id: 12,
                  name: "RFC",
                  value: contractor.rfc_document,
                  file: false,
                  arch: {},
                },
                {
                  id: 13,
                  name: "Recibos de nomina",
                  value: contractor.recibos_nomina,
                  file: false,
                  arch: {},
                },
                {
                  id: 14,
                  name: "Declaración anual completa con cadena de los últimos dos años inmediatos anteriores",
                  value: contractor.declaracion_anual,
                  file: false,
                  arch: {},
                },
                {
                  id: 15,
                  name: "Estados financieros anuales del año inmediato anterior",
                  value: contractor.estados_financieros_anuales,
                  file: false,
                  arch: {},
                },
                {
                  id: 16,
                  name: "Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años",
                  value: contractor.estados_financieros_parciales,
                  file: false,
                  arch: {},
                },
                {
                  id: 17,
                  name: "Alta ante hacienda o alta electrónica",
                  value: contractor.alta_hacienda,
                  file: false,
                  arch: {},
                },
                {
                  id: 18,
                  name: "Escritura de inmueble",
                  value: contractor.escritura_inmueble,
                  file: false,
                  arch: {},
                },
                {
                  id: 19,
                  name: "Boleta predial o avaluó",
                  value: contractor.boleta_predial,
                  file: false,
                  arch: {},
                },
                {
                  id: 20,
                  name: "Certificado de libertad de gravamen",
                  value: contractor.certificado_gravamen,
                  file: false,
                  arch: {},
                }
              );
            }
          } else {
            vm.listDocument = [
              {
                id: 1,
                name: "Identificación Oficial",
                value: contractor.card_official_identification,
                file: false,
                arch: {},
              },
              {
                id: 2,
                name: "CURP",
                value: contractor.CURP,
                file: false,
                arch: {},
              },
              {
                id: 3,
                name: "Comprobante de Inscripción de Firma Electrónica",
                value: contractor.voucher_efirm,
                file: false,
                arch: {},
              },
              {
                id: 4,
                name: "Comprobante de Domicilio",
                value: contractor.voucher_of_address,
                file: false,
                arch: {},
              },
              {
                id: 5,
                name: "Formato de Identificación de Cliente Firmado",
                value: contractor.signed_format_ic,
                file: false,
                arch: {},
              },
              {
                id: 6,
                name: "Poder",
                value: contractor.fiscal_power,
                file: false,
                arch: {},
              },
            ];
            if (contractor.only_sureties) {
              vm.listDocument.push(
                {
                  id: 7,
                  name: "Carta nombramiento",
                  value: contractor.carta_nombramiento,
                  file: false,
                  arch: {},
                },
                {
                  id: 8,
                  name: "Currículo",
                  value: contractor.curriculo,
                  file: false,
                  arch: {},
                },
                {
                  id: 9,
                  name: "Contrato multiple de la afianzadora",
                  value: contractor.contrato_multiple_afianzadora,
                  file: false,
                  arch: {},
                },
                {
                  id: 10,
                  name: "Carta buro",
                  value: contractor.carta_buro,
                  file: false,
                  arch: {},
                },
                {
                  id: 11,
                  name: "Entrevista con la afianzadora",
                  value: contractor.entrevista_afianzadora,
                  file: false,
                  arch: {},
                },
                {
                  id: 12,
                  name: "RFC",
                  value: contractor.rfc_document,
                  file: false,
                  arch: {},
                },
                {
                  id: 13,
                  name: "Recibos de nomina",
                  value: contractor.recibos_nomina,
                  file: false,
                  arch: {},
                },
                {
                  id: 14,
                  name: "Declaración anual completa con cadena de los últimos dos años inmediatos anteriores",
                  value: contractor.declaracion_anual,
                  file: false,
                  arch: {},
                },
                {
                  id: 15,
                  name: "Estados financieros anuales del año inmediato anterior",
                  value: contractor.estados_financieros_anuales,
                  file: false,
                  arch: {},
                },
                {
                  id: 16,
                  name: "Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años",
                  value: contractor.estados_financieros_parciales,
                  file: false,
                  arch: {},
                },
                {
                  id: 17,
                  name: "Alta ante hacienda o alta electrónica",
                  value: contractor.alta_hacienda,
                  file: false,
                  arch: {},
                },
                {
                  id: 18,
                  name: "Escritura de inmueble",
                  value: contractor.escritura_inmueble,
                  file: false,
                  arch: {},
                },
                {
                  id: 19,
                  name: "Boleta predial o avaluó",
                  value: contractor.boleta_predial,
                  file: false,
                  arch: {},
                },
                {
                  id: 20,
                  name: "Certificado de libertad de gravamen",
                  value: contractor.certificado_gravamen,
                  file: false,
                  arch: {},
                }
              );
            }
          }
        }

        $http({
          method: "GET",
          url: url.IP + "notas-by-contractor/",
          params: {
            contractor: contractor.id,
            type_contractor:
              contractor.type_person === 1 ? "natural" : "juridical",
          },
        }).then(function success(response) {
          vm.notas = response.data;
        });
        if (contractor.bound_solidarity_many) {
          if (contractor.bound_solidarity_many.length > 0) {
            $scope.solidarios = [];
            contractor.bound_solidarity_many.forEach(function (cons) {
              $http.get(cons).then(function (request) {
                $scope.solidarios.push(angular.copy(request.data));
              });
            });
          }
        }
        if (contractor.bound_solidarity) {
          if (contractor.bound_solidarity) {
            $scope.url_solidario = contractor.bound_solidarity;
          }
          $http.get($scope.url_solidario).then(function (request) {
            $scope.solidario = angular.copy(request.data);

            vm.contratante = {};
            if (request.data.address_contractor) {
              vm.contratante.val = request.data.full_name;
              vm.contratante.value = request.data;
            } else {
              vm.contratante.val = request.data.full_name;
              vm.contratante.value = request.data;
            }
          });
        }
        if (contractor.classification) {
          $http.get(contractor.classification).then(function (request) {
            if (contractor.type_person === 1) {
              vm.form.classification = request.data.url;
              // $scope.infoFisico.classification = request.data;
              $scope.infoFisicoc = request.data;
            } else {
              vm.juridicalForm.classification = request.data.url;
              $scope.infoMoralc = request.data;
              // vm.juridicalForm.clasification = request.data;
              // vm.clasifications.forEach(function(item){
              //   if(item.url == vm.juridicalForm.classification.url){
              //   }
              // });
            }
          });
        }

        contractor.cellule = contractor.cellule;
        if (contractor.cellule) {
          $http.get(contractor.cellule).then(function (request) {
            if (contractor.type_person === 1) {
              vm.form.celula = request.data.url;
              $scope.infoFisicocel = request.data;
            } else {
              vm.juridicalForm.cellule = request.data;
              vm.celulas.forEach(function (item) {
                if (item.url == vm.juridicalForm.cellule.url) {
                  vm.juridicalForm.cellule = item.url;
                  $scope.infoMoralcel = request.data;
                }
              });
            }
          });
        }
        contractor.groupinglevel = contractor.groupinglevel;
        if (contractor.groupinglevel) {
          $http.get(contractor.groupinglevel).then(function (data) {
            if (data.data.type_grouping == 3) {
              $http.get(data.data.parent).then(function (subgroup) {
                if (subgroup.data.type_grouping == 2) {
                  $http.get(subgroup.data.parent).then(function (group) {
                    var groupInfo = {
                      group_name: group.data.description,
                      subgroup_name: subgroup.data.description,
                      subsubgroup_name: data.data.description,
                    };
                    if (contractor.type_person === 1) {
                      vm.form.grouping_level = groupInfo;
                    } else {
                      vm.juridicalForm.grouping_level = groupInfo;
                    }
                    $http
                      .get(url.IP + "groupingLevel-resume/")
                      .then(function (response) {
                        vm.agrupaciones = response.data;
                        vm.agrupaciones.forEach(function (item) {
                          if (item.url == group.data.url) {
                            vm.editForm.grouping_level = item;
                            $rootScope.changeAgrupacion2(item);
                            item.subgrupos.forEach(function (sub) {
                              if (sub.url == subgroup.data.url) {
                                vm.editForm.subagrupaciones = sub;
                                $rootScope.changeSubagrupacion2(sub);
                                sub.subsubgrupos.forEach(function (subsub) {
                                  if (subsub.url == data.data.url) {
                                    vm.editForm.subsubasignaciones = subsub;
                                  }
                                });
                              }
                            });
                          }
                        });
                      });
                  });
                }
              });
            } else {
              if (data.data.type_grouping == 2) {
                $http.get(data.data.parent).then(function (group) {
                  var groupInfo = {
                    group_name: group.data.description,
                    subgroup_name: data.data.description,
                  };
                  if (contractor.type_person === 1) {
                    vm.form.grouping_level = groupInfo;
                  } else {
                    vm.juridicalForm.grouping_level = groupInfo;
                  }
                  $http
                    .get(url.IP + "groupingLevel-resume/")
                    .then(function (response) {
                      vm.agrupaciones = response.data;
                      vm.agrupaciones.forEach(function (item) {
                        if (item.url == group.data.url) {
                          vm.editForm.grouping_level = item;
                          $rootScope.changeAgrupacion2(item);
                          item.subgrupos.forEach(function (sub) {
                            if (sub.url == data.data.url) {
                              vm.editForm.subagrupaciones = sub;
                              $rootScope.changeSubagrupacion2(sub);
                            }
                          });
                        }
                      });
                    });
                });
              } else {
                var groupInfo = {
                  group_name: data.data.description,
                };
                if (contractor.type_person === 1) {
                  vm.form.grouping_level = groupInfo;
                } else {
                  vm.juridicalForm.grouping_level = groupInfo;
                }
                $http
                  .get(url.IP + "groupingLevel-resume/")
                  .then(function (response) {
                    vm.agrupaciones = response.data;
                    vm.agrupaciones.forEach(function (item) {
                      if (item.url == data.data.url) {
                        vm.editForm.grouping_level = item;
                        $rootScope.changeAgrupacion2(item);
                      }
                    });
                  });
              }
            }
          });
        }
        if (contractor.type_person === 1) {
          try {
            // var date = contractor.birthday;
            var date = contractor.birth_date;
            var newdate = date.split("-").reverse().join("/");
            contractor.birthday = newdate;
          } catch (e) {}
          vm.form = contractor;
          vm.form.birthday = datesFactory.convertDate(contractor.birth_date);
          vm.form.contact_natural = contractor.contact_contractor;
          // if(vm.form.address_natural){
          //   if(vm.form.address_natural.length == 0){
          //     vm.form.address_natural = [{
          //       raw: '',
          //     }];
          //   }
          // }
          if (contractor.vendor) {
            vm.form.vendedor = contractor.vendor;
          }
          if (contractor.sucursal) {
            vm.form.sucursal = contractor.sucursal;
          }
          if (contractor.responsable) {
            if (contractor.responsable) {
              if (contractor.responsable.url) {
                $http
                  .get(contractor.responsable.url)
                  .then(
                    function success(request) {
                      if (request.status === 200) {
                        vm.form.responsable = request.data;
                      }
                    },
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              } else {
                $http
                  .get(contractor.responsable)
                  .then(
                    function success(request) {
                      if (request.status === 200) {
                        vm.form.responsable = request.data;
                      }
                    },
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              }
            } else {
              $http.get(url.IP + "usuarios/").then(function (user) {
                vm.responsables = user.data.results;
              });
            }
          }
          vm.form.contact_natural = contractor.contact_contractor;
          vm.form.email_natural = vm.form.email_contractor;
          vm.form.phone_natural = vm.form.phone_contractor;
          vm.form.address_natural = vm.form.address_contractor;
          if (!vm.form.email_natural.length) {
            // vm.form.email_natural.push({
            //   email: "",
            //   email_type: 0
            // });
          } else {
            vm.form.email_natural.forEach(function (data, index) {
              if (data.correo == vm.form.email) {
                vm.form.email_natural.splice(index, 1);
              }
            });
            // if(vm.form.email_natural.length == 0){
            //   vm.form.email_natural.push({
            //     email: "",
            //     email_type: 0
            //   });
            // }
          }
          if (!vm.form.phone_natural.length) {
            // vm.form.phone_natural.push({
            //   phone: "",
            //   phone_type: 0
            // });
          } else {
            vm.form.phone_natural.forEach(function (data, index) {
              if (data.phone == vm.form.phone_number) {
                vm.form.phone_natural.splice(index, 1);
              }
            });
            // if(vm.form.phone_natural.length == 0){
            //   vm.form.phone_natural.push({
            //     phone: "",
            //     phone_type: 0
            //   });
            // }
          }

          contractor.userAddresses = contractor.address_contractor;
          if (contractor.userAddresses.length == 0) {
            addAddress(1);
          }
          if (contractor.bound_solidarity_many) {
            if (contractor.bound_solidarity_many.length > 0) {
              vm.form.obligados = [];
              contractor.bound_solidarity_many.forEach(function (cons) {
                $http.get(cons).then(function (request) {
                  var obligados1 = {
                    obligado: request.data,
                  };
                  var obj1 = {
                    label: request.data.full_name,
                    value: request.data,
                    val: request.data.full_name,
                  };
                  vm.form.obligados.push(obj1);
                });
              });
            } else {
              vm.form.obligados = [];
              $scope.addObligados(1);
            }
          } else {
            vm.form.obligados = [];
            $scope.addObligados(1);
          }
        } else {
          vm.juridicalForm.contact_juridical = contractor.contact_contractor;
          vm.juridicalForm.email_juridical = contractor.email_contractor;
          vm.juridicalForm.phone_juridical = contractor.phone_contractor;
          vm.juridicalForm.address_juridical = contractor.address_contractor;
          vm.juridicalForm.j_name = contractor.full_name;
          try {
            // var date = contractor.date_of_establishment;
            var date = contractor.birth_date;
            var newdate = date.split("-").reverse().join("/");
            contractor.date_of_establishment = newdate;
          } catch (e) {}
          vm.juridicalForm = contractor;
          vm.juridicalForm.j_name = contractor.full_name;
          vm.juridicalForm.contact_juridical = contractor.contact_contractor;
          vm.juridicalForm.email_juridical = contractor.email_contractor;
          vm.juridicalForm.phone_juridical = contractor.phone_contractor;
          vm.juridicalForm.address_juridical = contractor.address_contractor;
          vm.juridicalForm.date_of_establishment = datesFactory.convertDate(
            contractor.birth_date
          );
          if (vm.juridicalForm.address_juridical) {
            if (vm.juridicalForm.address_juridical.length == 0) {
              vm.juridicalForm.address_juridical = [
                {
                  raw: "",
                  street_address: "",
                  intersection: "",
                  political: "",
                  administrative_area_level_1: "",
                  administrative_area_level_1_short: "",
                  administrative_area_level_2: "",
                  administrative_area_level_3: "",
                  colloquial_area: "",
                  sublocality: "",
                  neighborhood: "",
                  premise: "",
                  subpremise: "",
                  natural_feature: "",
                  country: "",
                  country_code: "",
                  locality: "",
                  postal_code: "",
                  route: "",
                  street_number: "",
                  street_number_int: "",
                  formatted: "",
                  latitude: "",
                  longitude: "",
                  details: "",
                  composed: "",
                },
              ];
            }
          }
          if (contractor.vendor) {
            vm.juridicalForm.vendedor = contractor.vendor;
          }
          if (contractor.sucursal) {
            vm.juridicalForm.sucursal = contractor.sucursal;
          }
          if (contractor.responsable) {
            // vm.juridicalForm.responsable = contractor.responsable
            if (contractor.responsable) {
              if (contractor.responsable.url) {
                $http
                  .get(contractor.responsable.url)
                  .then(
                    function success(request) {
                      if (request.status === 200) {
                        vm.juridicalForm.responsable = request.data;
                      }
                    },
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              } else {
                // vm.juridicalForm.responsable = contractor.responsable
                $http
                  .get(contractor.responsable)
                  .then(
                    function success(request) {
                      if (request.status === 200) {
                        vm.juridicalForm.responsable = request.data;
                      }
                    },
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              }
            } else {
            }
          } else {
            $http.get(url.IP + "usuarios/").then(function (user) {
              vm.responsables = user.data.results;
            });
          }
          if (!vm.juridicalForm.email_juridical.length) {
            // vm.juridicalForm.email_juridical.push({
            //   email: "",
            //   email_type: 0
            // });
          } else {
            vm.juridicalForm.email_juridical.forEach(function (data, index) {
              if (data.correo == vm.juridicalForm.email) {
                vm.juridicalForm.email_juridical.splice(index, 1);
              }
            });
            // if(vm.juridicalForm.email_juridical.length == 0){
            //   vm.juridicalForm.email_juridical.push({
            //     email: "",
            //     email_type: 0
            //   });
            // }
          }
          if (!vm.juridicalForm.phone_juridical.length) {
            // vm.juridicalForm.phone_contractor.push({
            //   phone: "",
            //   phone_type: 0
            // });
          } else {
            vm.juridicalForm.phone_juridical.forEach(function (data, index) {
              if (data.phone == vm.juridicalForm.phone_number) {
                vm.juridicalForm.phone_juridical.splice(index, 1);
              }
            });
            // if(vm.juridicalForm.phone_contractor.length == 0){
            //   vm.juridicalForm.phone_contractor.push({
            //     phone: "",
            //     phone_type: 0
            //   });
            // }
          }

          contractor.userAddresses = contractor.address_contractor;
          if (contractor.userAddresses.length == 0) {
            addAddress(2);
          }
          if (contractor.bound_solidarity_many.length > 0) {
            vm.juridicalForm.obligados = [];
            contractor.bound_solidarity_many.forEach(function (cons) {
              $http.get(cons).then(function (request) {
                var obligados1 = {
                  obligado: request.data,
                };
                var obj1 = {
                  label: request.data.full_name,
                  value: request.data,
                  val: request.data.full_name,
                };
                vm.juridicalForm.obligados.push(obj1);
              });
            });
          } else {
            vm.juridicalForm.obligados = [];
            $scope.addObligados(2);
          }
        }

        if (
          contractor.resp_contractor &&
          contractor.resp_contractor.length == 0
        ) {
          if (contractor.type_person === 1) {
            var addresponsables = {
              responsable: 0,
              resp_type: 0,
            };
            vm.form.resp_contractor = [addresponsables];
          } else {
            var addresponsables = {
              responsable: 0,
              resp_type: 0,
            };
            vm.juridicalForm.resp_contractor = [addresponsables];
          }
        }

        contractor.userAddresses.forEach(function (address) {
          $http
            .get(url.IP + "ok-to-delete/" + address.id + "/")
            .then(function success(response) {
              if (response.data) {
                address.can_delete = true;
              } else {
                address.can_delete = false;
              }
            });
          if (vm.statesArray) {
            vm.statesArray.some(function (state) {
              if (state.state == address.administrative_area_level_1) {
                address.administrative_area_level_1 = state;
                state.cities.some(function (city) {
                  if (city.city == address.administrative_area_level_2) {
                    address.administrative_area_level_2 = city;
                  }
                });
              }
            });
          }
        });
        return contractor;
      })
      .then(function (contractor) {
        return groupService.getGroup(contractor).then(function (data) {
          vm.aux_contractor = contractor;
          if (data.type_group == 3) {
            $http.get(data.parent).then(function (subgroup) {
              if (subgroup.data.type_group == 2) {
                $http.get(subgroup.data.parent).then(function (group) {
                  var groupInfo = {
                    url: data.url,
                    id: data.id,
                    group_name: group.data.group_name,
                    subgroup_name: subgroup.data.group_name,
                    subsubgroup_name: data.group_name,
                  };
                  if (contractor.type_person === 1) {
                    vm.form.group = groupInfo;
                  } else {
                    vm.juridicalForm.group = groupInfo;
                  }

                  if (vm.groups.length > 0) {
                    vm.groups.forEach(function (item) {
                      if (item.url == group.data.url) {
                        vm.editForm.group = item;
                        $rootScope.changeGroup(item);
                        item.subgrupos.forEach(function (sub) {
                          if (sub.url == subgroup.data.url) {
                            vm.editForm.subgroup = sub;
                            $rootScope.changeSubGroup(sub);
                            sub.subsubgrupos.forEach(function (subsub) {
                              if (subsub.url == data.url) {
                                vm.editForm.subsubgrupo = subsub;
                              }
                            });
                          }
                        });
                      }
                    });
                  } else {
                    groupService.getGroups().then(function (groups) {
                      vm.groups = groups;
                      vm.groups.forEach(function (item) {
                        if (item.url == group.data.url) {
                          vm.editForm.group = item;
                          $rootScope.changeGroup(item);
                          item.subgrupos.forEach(function (sub) {
                            if (sub.url == subgroup.data.url) {
                              vm.editForm.subgroup = sub;
                              $rootScope.changeSubGroup(sub);
                              sub.subsubgrupos.forEach(function (subsub) {
                                if (subsub.url == data.url) {
                                  vm.editForm.subsubgrupo = subsub;
                                }
                              });
                            }
                          });
                        }
                      });
                    });
                  }
                });
              }
            });
          } else {
            if (data.type_group == 2) {
              $http.get(data.parent).then(function (group) {
                var groupInfo = {
                  url: data.url,
                  id: data.id,
                  group_name: group.data.group_name,
                  subgroup_name: data.group_name,
                };
                if (contractor.type_person === 1) {
                  vm.form.group = groupInfo;
                } else {
                  vm.juridicalForm.group = groupInfo;
                }
                if (vm.groups.length > 0) {
                  vm.groups.forEach(function (item) {
                    if (item.url == group.data.url) {
                      vm.editForm.group = item;
                      $rootScope.changeGroup(item);
                      item.subgrupos.forEach(function (sub) {
                        if (sub.url == data.url) {
                          vm.editForm.subgroup = sub;
                        }
                      });
                    }
                  });
                } else {
                  groupService.getGroups().then(function (groups) {
                    vm.groups = groups;
                    vm.groups.forEach(function (item) {
                      if (item.url == group.data.url) {
                        vm.editForm.group = item;
                        $rootScope.changeGroup(item);
                        item.subgrupos.forEach(function (sub) {
                          if (sub.url == data.url) {
                            vm.editForm.subgroup = sub;
                          }
                        });
                      }
                    });
                  });
                }
              });
            } else {
              var groupInfo = {
                url: data.url,
                id: data.id,
                group_name: data.group_name,
              };
              if (contractor.type_person === 1) {
                vm.form.group = groupInfo;
              } else {
                vm.juridicalForm.group = groupInfo;
              }

              if (vm.groups.length > 0) {
                vm.groups.forEach(function (item) {
                  if (item.url == data.url) {
                    vm.editForm.group = item;
                    $rootScope.changeGroup(item);
                  }
                });
              } else {
                groupService.getGroups().then(function (groups) {
                  vm.groups = groups;
                  vm.groups.forEach(function (item) {
                    if (item.url == data.url) {
                      vm.editForm.group = item;
                      $rootScope.changeGroup(item);
                    }
                  });
                });
              }
            }
          }
        });
      });

    $q.when()
      .then(function () {
        var defer = $q.defer();
        defer.resolve(helpers.getStates());
        return defer.promise;
      })
      .then(function (data) {
        vm.statesArray = data.data;
        $timeout(function () {
          var nums = [];
          var typePerson;

          $(".telefono").each(function (telefono) {
            var actual = $(this);
            nums.push(actual);
          });
          try {
            if (
              $stateParams.type === "fisicas" ||
              $scope.contractor.type_person == 1
            ) {
              typePerson = vm.form.contact_contractor;
            } else {
              typePerson = vm.juridicalForm.contact_contractor;
            }
          } catch (e) {
            console.log("eee--", e);
          }
        }, 1000);
      });
    if (vm.form) {
      if (!vm.form.userAddresses) {
        vm.form.userAddresses = [];
        addAddress(1);
      }
    } else if (vm.juridicalForm) {
      if (!vm.juridicalForm.userAddresses) {
        vm.juridicalForm.userAddresses = [];
        addAddress(2);
      }
    }
    if (vm.permiso_archivos) {
      getFiles();
    }
  }
  $scope.onlyFianzas = function (q) {
    if ($scope.contractor.only_sureties) {
      if (q == 1) {
        vm.listDocument.push(
          {
            id: 7,
            name: "Carta nombramiento",
            value: $scope.contractor.carta_nombramiento,
            file: false,
            arch: {},
          },
          {
            id: 8,
            name: "Currículo",
            value: $scope.contractor.curriculo,
            file: false,
            arch: {},
          },
          {
            id: 9,
            name: "Contrato multiple de la afianzadora",
            value: $scope.contractor.contrato_multiple_afianzadora,
            file: false,
            arch: {},
          },
          {
            id: 10,
            name: "Carta buro",
            value: $scope.contractor.carta_buro,
            file: false,
            arch: {},
          },
          {
            id: 11,
            name: "Entrevista con la afianzadora",
            value: $scope.contractor.entrevista_afianzadora,
            file: false,
            arch: {},
          },
          {
            id: 12,
            name: "RFC",
            value: $scope.contractor.rfc_document,
            file: false,
            arch: {},
          },
          {
            id: 13,
            name: "Recibos de nomina",
            value: $scope.contractor.recibos_nomina,
            file: false,
            arch: {},
          },
          {
            id: 14,
            name: "Declaración anual completa con cadena de los últimos dos años inmediatos anteriores",
            value: $scope.contractor.declaracion_anual,
            file: false,
            arch: {},
          },
          {
            id: 15,
            name: "Estados financieros anuales del año inmediato anterior",
            value: $scope.contractor.estados_financieros_anuales,
            file: false,
            arch: {},
          },
          {
            id: 16,
            name: "Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años",
            value: $scope.contractor.estados_financieros_parciales,
            file: false,
            arch: {},
          },
          {
            id: 17,
            name: "Alta ante hacienda o alta electrónica",
            value: $scope.contractor.alta_hacienda,
            file: false,
            arch: {},
          },
          {
            id: 18,
            name: "Escritura de inmueble",
            value: $scope.contractor.escritura_inmueble,
            file: false,
            arch: {},
          },
          {
            id: 19,
            name: "Boleta predial o avaluó",
            value: $scope.contractor.boleta_predial,
            file: false,
            arch: {},
          },
          {
            id: 20,
            name: "Certificado de libertad de gravamen",
            value: $scope.contractor.certificado_gravamen,
            file: false,
            arch: {},
          }
        );
      } else if (q == 2) {
        vm.listDocument.push(
          {
            id: 7,
            name: "Currículo reciente",
            value: $scope.contractor.curriculo,
            file: false,
            arch: {},
          },
          {
            id: 8,
            name: "Contrato multiple de la afianzadora",
            value: $scope.contractor.contrato_multiple_afianzadora,
            file: false,
            arch: {},
          },
          {
            id: 9,
            name: "Carta Buró",
            value: $scope.contractor.carta_buro,
            file: false,
            arch: {},
          },
          {
            id: 10,
            name: "Cuestionario o entrevista",
            value: $scope.contractor.entrevista_afianzadora,
            file: false,
            arch: {},
          },
          {
            id: 11,
            name: "Aviso de privacidad de la afianzadora",
            value: $scope.contractor.aviso_privacidad,
            file: false,
            arch: {},
          },
          {
            id: 12,
            name: "Protocolizaciones",
            value: $scope.contractor.protocolizaciones,
            file: false,
            arch: {},
          },
          {
            id: 13,
            name: "Alta de empresa ante hacienda",
            value: $scope.contractor.alta_hacienda,
            file: false,
            arch: {},
          },
          {
            id: 14,
            name: "Cambio de domicilio ante hacienda",
            value: $scope.contractor.cambio_domicilio_hacienda,
            file: false,
            arch: {},
          },
          {
            id: 15,
            name: "Copia del comprobante de inscripción para la e.firma (firma electrónica)",
            value: $scope.contractor.cambio_domicilio_hacienda,
            file: false,
            arch: {},
          },
          {
            id: 16,
            name: "Declaración anual completa con cadena, de los últimos dos años",
            value: $scope.contractor.declaracion_anual,
            file: false,
            arch: {},
          },
          {
            id: 17,
            name: "Estados financieros dictaminados cuadernillo completo, del año inmediato anterior",
            value: $scope.contractor.estados_financieros_anuales,
            file: false,
            arch: {},
          },
          {
            id: 18,
            name: "Estados financieros parciales los más recientes de este año con no mayor antigüedad de dos meses",
            value: $scope.contractor.estados_financieros_parciales,
            file: false,
            arch: {},
          },
          {
            id: 19,
            name: "Escritura de inmueble",
            value: $scope.contractor.escritura_inmueble,
            file: false,
            arch: {},
          },
          {
            id: 20,
            name: "Boleta predial o avaluó",
            value: $scope.contractor.boleta_predial,
            file: false,
            arch: {},
          },
          {
            id: 21,
            name: "Certificado de libertad de gravamen",
            value: $scope.contractor.certificado_gravamen,
            file: false,
            arch: {},
          }
        );
      }
    } else {
      if (q == 1) {
        if (vm.org_name == "ancora") {
          vm.listDocument = [
            {
              id: 1,
              name: "Identificación Oficial",
              value: $scope.contractor.card_official_identification,
              file: false,
              arch: {},
            },
            {
              id: 2,
              name: "CURP",
              value: $scope.contractor.CURP,
              file: false,
              arch: {},
            },
            {
              id: 3,
              name: "Comprobante de Inscripción de Firma Electrónica",
              value: $scope.contractor.voucher_efirm,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio",
              value: $scope.contractor.voucher_of_address,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Formato de Identificación de Cliente Firmado",
              value: $scope.contractor.signed_format_ic,
              file: false,
              arch: {},
            },
          ];
        } else {
          vm.listDocument = [
            {
              id: 1,
              name: "Identificación Oficial",
              value: $scope.contractor.card_official_identification,
              file: false,
              arch: {},
            },
            {
              id: 2,
              name: "CURP",
              value: $scope.contractor.CURP,
              file: false,
              arch: {},
            },
            {
              id: 3,
              name: "Comprobante de Inscripción de Firma Electrónica",
              value: $scope.contractor.voucher_efirm,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio",
              value: $scope.contractor.voucher_of_address,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Formato de Identificación de Cliente Firmado",
              value: $scope.contractor.signed_format_ic,
              file: false,
              arch: {},
            },
            {
              id: 6,
              name: "Poder",
              value: $scope.contractor.fiscal_power,
              file: false,
              arch: {},
            },
          ];
        }
      } else if (q == 2) {
        vm.listDocument = [
          {
            id: 1,
            name: "Acta Constitutiva",
            value: $scope.contractor.constitutive_act,
            file: false,
            arch: {},
          },
          {
            id: 2,
            name: "RFC",
            value: $scope.contractor.rfc_document,
            file: false,
            arch: {},
          },
          {
            id: 3,
            name: "Cédula de Identificación Fiscal",
            value: $scope.contractor.card_official_identification,
            file: false,
            arch: {},
          },
          {
            id: 4,
            name: "Comprobante de Domicilio Fiscal",
            value: $scope.contractor.voucher_of_address,
            file: false,
            arch: {},
          },
          {
            id: 5,
            name: "Modificaciones al Acta Constitutiva",
            value: $scope.contractor.modifications_constitutive_act,
            file: false,
            arch: {},
          },
          {
            id: 6,
            name: "Poder",
            value: $scope.contractor.fiscal_power,
            file: false,
            arch: {},
          },
        ];
      }
    }
  };
  function getFiles() {
    $stateParams.type = "contractors";
    $stateParams.type_person = $scope.contractor.type_person;
    return ContratanteService.getFiles($stateParams).then(function (data) {
      if (data.detail) {
        vm.show_files = false;
      } else {
        vm.files = data;
      }
    });
  }
  //archivos lista documentos
  $scope.addFileList = function (index, lista, file, xy) {
    var extension = file[0].formData[0].name.split(".")[1];
    file[0].formData[0].name = vm.listDocument[index].name + "." + extension;
    vm.listDocument[index].arch = file[0];
    vm.listDocument[index].file = true;
    $scope.uploaderDocument.queue = [];
  };
  var uploaderDocument = ($scope.uploaderDocument = new FileUploader({
    headers: {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    },
  }));

  // uploaderDocument.filters.push({
  //     name: 'customFilter',
  //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
  //         return this.queue.length < 20;
  //     }
  // });

  // ALERTA SUCCES UPLOADFILES
  uploaderDocument.onSuccessItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    // if ($uibModalInstance) {
    //     $uibModalInstance.dismiss('cancel');
    // }
    $scope.okFile++;
    if ($scope.okFile == $scope.countFile) {
      $timeout(function () {
        SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWCONTRACTOR, "success");
        if ($location.path() == "/contratantes/crear") {
          if (vm.acceso_ver_cont) {
            $state.go("fianzas.pprovinfo", {
              type:
                $scope.contractorNew.type_person == "Fisica"
                  ? "fisicas"
                  : "morales",
              contratanteId: $scope.contractorNew.id,
            });
          } else {
            $state.go("fianzas.pprovlist");
          }
        } else if ($location.path() == "/colectividades/") {
          var params = { myInsurance: $scope.contractorNew };
          $state.go("colectividades.main", params);
        } else if ($location.path() == "/fianzas/") {
          $rootScope.show_contractor = false;
          // var params = { 'myInsurance': $scope.contractorNew }
          // $state.go('fianzas.fianzas', params);
        } else {
          $rootScope.show_contractor = false;
          var params = { myInsurance: $scope.contractorNew };
          $state.go("fianzas.pprovlist");
        }
      }, 1000);
    }
  };

  // ALERTA ERROR UPLOADFILES
  uploaderDocument.onErrorItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    if (response.status == 413) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
    } else {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    }
  };

  uploaderDocument.onAfterAddingFile = function (fileItem) {
    fileItem.formData.push({
      arch: fileItem._file,
      name: fileItem.file.name,
    });
  };

  uploaderDocument.onBeforeUploadItem = function (item) {
    if (item.file.sensible != undefined) {
      item.formData[0].sensible = item.file.sensible;
    }
    item.url = $scope.userInfo.url;
    item.formData[0].name = item.file.name;
    item.alias = "";
    item.formData[0].owner = $scope.userInfo.id;
  };
  //archivos lista docuemntos
  function uploadFilesList(typePerson, idPerson) {
    $scope.userInfo = {
      id: idPerson,
    };
    // $scope.userInfo.url = url.IP + checkType(typePerson) + '/' + idPerson + '/archivos/';
    $scope.userInfo.url =
      url.IP + "contractors" + "/" + idPerson + "/archivos/";

    $scope.files = [];

    $timeout(function () {
      $scope.uploaderDocument.uploadAll();
    }, 1000);
  }
  // Add group popup
  function openModalGroup(level, type, parent) {
    // var modalInstance = $uibModal.open({ //jshint ignore:line
    //     templateUrl: 'app/grupos/grupos.form.html',
    //     controller: ModalGroupCtrl,
    //     //windowClass: 'animated fadeIn'
    // });
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/grupos/grupos.form.html",
      controller: ModalInstanceGroupCtrl,
      resolve: {
        padre: function () {
          return parent;
        },
        parent: function () {
          return vm;
        },
        level: function () {
          return level;
        },
        type: function () {
          return type;
        },
        group: function () {
          return type == 1 ? vm.form.group : vm.juridicalForm.group;
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
      // windowClass: 'animated fadeIn'
    });
  }

  function ModalInstanceGroupCtrl(
    $scope,
    $uibModalInstance,
    parent,
    level,
    group,
    type,
    padre
  ) {
    $scope.level = level;
    $scope.groupForm = {};
    $scope.subgroupForm = {};
    $scope.subsubgroupForm = {};
    $scope.subgroups = [];
    $scope.sub_subgroups = [];

    $scope.addSubgroups = function () {
      var obj = { name: "", observations: "", sub_subgroup: [] };
      $scope.subgroups.push(obj);
    };

    $scope.deleteSubgroup = function (index) {
      $scope.subgroups.splice(index, 1);
    };

    $scope.addSubsubgroups = function () {
      var obj = { name: "", observations: "", sub_subgroup: [] };
      $scope.sub_subgroups.push(obj);
    };

    $scope.deleteSubsubgroup = function (index) {
      $scope.sub_subgroups.splice(index, 1);
    };

    $http.get(url.IP + "usuarios/").then(function (user) {
      $scope.users = user.data.results;

      $scope.show_pagination = true;
    });

    $scope.changeResponsable = function (data, type) {
      $scope.responsables_natural = [];
      $scope.responsables_juridical = [];
      if (type == 1) {
        $scope.responsables_natural.push(data);
      } else {
        $scope.responsables_juridical.push(data);
      }
    };

    $scope.ok = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var flag = false;
      var form = angular.copy($scope.groupForm);
      var name = form.group_name;
      var bd_group_name = [];
      groupService.getGroups().then(function (res) {
        res.forEach(function (group, i) {
          bd_group_name.push(String(group.group_name));
        });

        for (var i = 0; i < bd_group_name.length; i++) {
          if (name == bd_group_name[i]) {
            flag = true;
          }
        }
        form.type_group = 1;

        if (flag == false) {
          return groupService
            .createGroup(form)
            .then(function (data) {
              if (data.status === 201) {
                vm.groups.push(data.data);
                $rootScope.changeGroup(data.data);
                if (vm.form) {
                  vm.form.group = data.data;
                } else if (vm.juridicalForm) {
                  vm.juridicalForm.group = data.data;
                }

                if ($uibModalInstance) {
                  $uibModalInstance.close();
                  $("#modalContratate")
                    .parent()
                    .parent()
                    .parent()
                    .css("display", "block");
                }

                if ($scope.subgroups.length > 0) {
                  $scope.subgroups.forEach(function (item) {
                    var datas = {
                      group_name: item.group_name,
                      responsable: data.data.responsable,
                      parent: data.data.url,
                      type_group: 2,
                    };

                    $http({
                      method: "POST",
                      url: url.IP + "grupos/",
                      data: datas,
                    })
                      .then(function (request) {
                        if (request.status === 200 || request.status === 201) {
                          // vm.subgroups.push(request.data);
                          if (type === 1) {
                            vm.form.group.subgrupos.push(request.data);
                          } else {
                            vm.juridicalForm.group.subgrupos.push(request.data);
                          }
                        }
                      })
                      .catch(function (e) {
                        l.stop();
                        console.log("e", e);
                      });
                  });
                }
              } else if (data.status === 403) {
                toaster.warning("Usted no tiene permisos para crear grupos");
                // return;
                $uibModalInstance.close();
                $("#modalContratate")
                  .parent()
                  .parent()
                  .parent()
                  .css("display", "block");
              }
            })
            .catch(function () {
              l.stop();
              return;
            });
        } else {
          SweetAlert.swal(
            "ERROR",
            MESSAGES.ERROR.THISNAMEALREADYEXIST,
            "error"
          );
          return;
        }
      });
    };

    $scope.oksub = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.subgroupForm.responsable = group.responsable;
      $scope.subgroupForm.parent = padre.url;
      $scope.subgroupForm.type_group = 2;

      if (!$scope.subgroupForm.group_name) {
        l.stop();
        SweetAlert.swal("Error", "Agrega un nombre de subgrupo.", "error");
        return;
      }

      $http({
        method: "POST",
        url: url.IP + "grupos/",
        data: $scope.subgroupForm,
      })
        .then(function (request) {
          if (request.status === 200 || request.status === 201) {
            try {
              vm.subgroups.push(request.data);
            } catch (e) {
              vm.subgroups = [];
              vm.subgroups.push(request.data);
            }
            if ($scope.sub_subgroups.length > 0) {
              vm.subgroups[vm.subgroups.length - 1].subsubgrupos = [];
              $scope.sub_subgroups.forEach(function (item) {
                var datas = {
                  group_name: item.group_name,
                  responsable: padre.responsable,
                  parent: request.data.url,
                  type_group: 3,
                };

                $http({
                  method: "POST",
                  url: url.IP + "grupos/",
                  data: datas,
                })
                  .then(function (response) {
                    if (response.status === 200 || response.status === 201) {
                      vm.subgroups[vm.subgroups.length - 1].subsubgrupos.push(
                        response.data
                      );
                    }
                  })
                  .catch(function (e) {
                    l.stop();
                    console.log("e", e);
                  });
              });
            }
            $scope.cancel();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.oksubsub = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.subsubgroupForm.responsable = group.responsable;
      $scope.subsubgroupForm.parent = padre.url;
      $scope.subsubgroupForm.type_group = 3;

      if (!$scope.subsubgroupForm.group_name) {
        l.stop();
        SweetAlert.swal("Error", "Agrega un nombre de subsubgrupo.", "error");
        return;
      }

      $http({
        method: "POST",
        url: url.IP + "grupos/",
        data: $scope.subsubgroupForm,
      })
        .then(function (request_sub) {
          if (request_sub.status === 200 || request_sub.status === 201) {
            if (vm.sub_subgroups == undefined) {
              $scope.sub_subgroups = [];
            }
            // vm.sub_subgroups.push(request_sub.data);
            try {
              $scope.sub_subgroups.push(request_sub.data);
            } catch (e) {
              $scope.sub_subgroups = [];
              $scope.sub_subgroups.push(request_sub.data);
            }
            $scope.cancel();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
        $("#modalContratate")
          .parent()
          .parent()
          .parent()
          .css("display", "block");
      }
    };
  }

  function openModalClasification(level) {
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/contratantes/contratantes.clasificacion.html",
      controller: ModaClasificationCtrl,
      resolve: {
        parent: function () {
          return vm;
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
      // windowClass: 'animated fadeIn'
    });
  }

  $scope.sub_asignaciones = [];
  $scope.sub_subasignaciones = [];

  function ModaClasificationCtrl($scope, $uibModalInstance, parent) {
    $scope.classification = {};

    $scope.save = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      $scope.classification.classification_name =
        $scope.classification.classification_name;
      $scope.classification.description = $scope.classification.description;

      $http({
        method: "POST",
        url: url.IP + "classification/",
        data: $scope.classification,
      })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            l.stop();
            vm.clasifications.push(response.data);
            $scope.cancel();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };
  }

  $scope.matchesContractors = function (parWord) {
    if (parWord) {
      if (parWord.length >= 3) {
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
        $scope.show_contratante = "contractors-match/";
        $http
          .post(url.IP + $scope.show_contratante, {
            matchWord: parWord,
            poliza: false,
          })
          .then(function (response) {
            if (response.status === 200 && response.data != 404) {
              var source = [];
              var contratactorsFound = response.data.contractors;
              if (contratactorsFound.length) {
                contratactorsFound.forEach(function (item) {
                  if (item.full_name) {
                    var obj = {
                      label: item.full_name,
                      value: item,
                    };
                  } else {
                    var obj = {
                      label:
                        item.first_name +
                        " " +
                        item.last_name +
                        " " +
                        item.second_last_name,
                      value: item,
                    };
                  }
                  source.push(obj);
                });
              }
              $scope.contractors_data = source;
            }
          });
      }
    }
  };

  $scope.$watch("vm.contratante.value", function (newValue, oldValue) {
    if (vm.contratante) {
      if (vm.contratante.value.address_contractor) {
        if (vm.contratante.value.address_contractor) {
          $scope.bound_solidarity = vm.contratante.value.url;
          $scope.has_solidario = true;
        }
      }
    }
  });

  function openModalCelulaContractor(level) {
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/contratantes/contratantes.celulas.html",
      controller: ModalCelulasCtrl,
      resolve: {
        parent: function () {
          return vm;
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
      // windowClass: 'animated fadeIn'
    });
  }
  function ModalCelulasCtrl($scope, $uibModalInstance, parent) {
    $scope.celula = {};
    dataFactory.get("usuarios/").then(function (user) {
      $scope.usuarios_saam = user.data.results;
    });
    $scope.selectUsuarios = function (sel) {
      $scope.usuarios_selected = [];
      sel.forEach(function (u) {
        if (u.url) {
          $scope.usuarios_selected.push(u.url);
        } else {
          $scope.usuarios_selected.push(u);
        }
      });
    };
    $scope.save_celula = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      $scope.celula.celula_name = $scope.celula.celula_name;
      $scope.celula.description = $scope.celula.description;
      $scope.celula.users_many = $scope.usuarios_selected
        ? $scope.usuarios_selected
        : [];

      $http({
        method: "POST",
        url: url.IP + "celula_contractor/",
        data: $scope.celula,
      })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            vm.celulas.push(response.data);
            $scope.cancel_celula();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.cancel_celula = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };
  }
  function openModalAsignacion(level, padre) {
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/contratantes/contratantes.agrupacion.html",
      controller: ModalAsignacionCtrl,
      resolve: {
        padre: function () {
          return padre;
        },
        parent: function () {
          return vm;
        },
        level: function () {
          return level;
        },
        group: function () {
          return level == 2
            ? vm.editForm.grouping_level
            : vm.editForm.subagrupaciones;
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
      // windowClass: 'animated fadeIn'
    });
  }

  $scope.sub_asignaciones = [];
  $scope.sub_subasignaciones = [];

  function ModalAsignacionCtrl(
    $scope,
    $uibModalInstance,
    parent,
    level,
    group,
    padre
  ) {
    $scope.level = level;
    $scope.group_modal = group;
    $scope.grupo = {};
    // $scope.subasignaciones = [];
    $scope.subsubasignacion = [];

    $scope.addSubasignaciones = function () {
      var obj = { name: "", observations: "", sub_subgroup: [] };
      vm.subasignaciones.push(obj);
    };

    $scope.deleteSubasignaciones = function (index) {
      vm.subasignaciones.splice(index, 1);
    };

    $scope.addSubsubasignaciones = function () {
      var obj = { name: "", observations: "", sub_subgroup: [] };
      $scope.subsubasignacion.push(obj);
    };

    $scope.deleteSubsubasignaciones = function (index) {
      vm.subsubasignaciones.splice(index, 1);
    };

    $http.get(url.IP + "usuarios/").then(function (user) {
      $scope.users = user.data.results;

      $scope.show_pagination = true;
    });

    $scope.changeResponsable = function (data, type) {
      $scope.responsables_natural = [];
      $scope.responsables_juridical = [];
      if (type == 1) {
        $scope.responsables_natural.push(data);
      } else {
        $scope.responsables_juridical.push(data);
      }
    };

    $scope.saveSub = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.sub_asignaciones = [];
      $scope.grupo.level_grouping = padre.level_grouping;
      $scope.grupo.parent = padre.url;
      $scope.grupo.type_grouping = 2;
      if (!$scope.grupo.description) {
        l.stop();
        SweetAlert.swal("Error", "Agrega un nombre de subagrupación.", "error");
        return;
      }

      $http({
        method: "POST",
        url: url.IP + "groupinglevel/",
        data: $scope.grupo,
      })
        .then(function (request_sub) {
          if (request_sub.status === 200 || request_sub.status === 201) {
            $scope.sub_subasignaciones = [];
            $scope.sub_asignaciones = padre.subgrupos;
            $rootScope.changeAgrupacion2(padre);
            try {
              $scope.sub_asignaciones.push(request_sub.data);
            } catch (e) {
              $scope.sub_asignaciones = request_sub.data;
            }
            if ($scope.subsubasignacion.length > 0) {
              $scope.subsubasignacion.forEach(function (item, index) {
                var datas = {
                  description: item.description,
                  responsable: $scope.grupo.responsable,
                  parent: request_sub.data.url,
                  type_grouping: 3,
                };

                if (item.description) {
                  $http({
                    method: "POST",
                    url: url.IP + "groupinglevel/",
                    data: datas,
                  })
                    .then(function (response) {
                      if (response.status === 200 || response.status === 201) {
                        $scope.sub_subasignaciones = [];
                        $scope.sub_subasignaciones.push(response.data);
                        $rootScope.changeAgrupacion2(padre);
                        if ($scope.subsubasignacion.length == index + 1) {
                          vm.agrupaciones.forEach(function (gpo) {
                            if (
                              gpo.description ==
                              vm.editForm.grouping_level.subgroup_name
                            ) {
                              vm.editForm.grouping_level = gpo;
                              // gpo.subgrupos.forEach(function(sub){
                              //   if(vm.editForm.grouping_level.url == sub.parent){
                              //     vm.editForm.subagrupaciones = sub;
                              //   }
                              // });
                            }
                          });
                        }
                      }
                    })
                    .catch(function (e) {
                      l.stop();
                      console.log("e", e);
                    });
                }
              });
            }
            vm.editForm.subagrupaciones = request_sub.data;
            $scope.cancel();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.saveSubsub = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.grupo.level_grouping = padre.level_grouping;
      $scope.grupo.parent = padre.url;
      $scope.grupo.type_grouping = 3;

      if (!$scope.grupo.description) {
        l.stop();
        SweetAlert.swal(
          "Error",
          "Agrega un nombre de subsubagrupación.",
          "error"
        );
        return;
      }

      $http({
        method: "POST",
        url: url.IP + "groupinglevel/",
        data: $scope.grupo,
      })
        .then(function (request_sub) {
          if (request_sub.status === 200 || request_sub.status === 201) {
            // $scope.sub_subasignaciones = padre.subgrupos;
            // $scope.sub_subasignaciones.push(request_sub.data);
            // $rootScope.changeAgrupacion2(vm.editForm.grouping_level);
            // $scope.cancel();
            $scope.sub_subasignaciones = padre.subgrupos;
            try {
              $scope.sub_subasignaciones.push(request_sub.data);
            } catch (e) {
              $scope.sub_subasignaciones = request_sub.data;
            }
            // $rootScope.changeAgrupacion2(padre);
            $rootScope.changeSubagrupacion2(padre);
            $scope.cancel();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };
  }

  function ModalGroupCtrl($scope, $uibModalInstance) {
    $scope.ok = function () {
      var flag = false;
      var form = angular.copy($scope.groupForm);
      var name = form.group_name;
      var bd_group_name = [];
      $scope.changeResponsable = function (data) {
        $scope.groupForm.responsable = data;
      };

      groupService.getGroups().then(function (res) {
        res.forEach(function (group, i) {
          bd_group_name.push(String(group.group_name));
        });

        for (var i = 0; i < bd_group_name.length; i++) {
          if (name == bd_group_name[i]) {
            flag = true;
          }
        }
        if (flag == false) {
          return groupService
            .createGroup(form)
            .then(function (data) {
              vm.groups.push(data.data);
              if ($uibModalInstance) $uibModalInstance.close();
            })
            .catch(function () {
              return;
            });
        } else {
          SweetAlert.swal(
            "ERROR",
            MESSAGES.ERROR.THISNAMEALREADYEXIST,
            "error"
          );
          return;
        }
      });
    };

    $scope.cancel = function () {
      if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
    };
  }

  // Delete contratantes popup
  function openModalDeleteContratantes() {
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/contratantes/contratantes.delete.html",
      controller: ModalInstanceCtrl,
      //windowClass: 'animated fadeIn'
    });
  }

  function ModalInstanceCtrl($scope, $uibModalInstance) {
    var data = returnType();
    $scope.ok = function () {
      return ContratanteService.deleteContratante(data).then(function () {
        if ($uibModalInstance) $uibModalInstance.close();
        $state.go("fianzas.pprovlist");
      });
    };

    $scope.cancel = function () {
      if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
    };
  }

  function cancel() {
    $window.location.reload();
  }

  function validateEmail(email) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  $scope.sendResponsables = function (url, typePerson) {
    if (typePerson == 1) {
      for (var i = 0; i < vm.form.resp_contractor.length; i++) {
        // vm.form.responsables[i].natural = url;
        vm.form.resp_contractor[i].contractor = url;
      }
      vm.responsable = vm.form.resp_contractor;
    } else {
      for (var i = 0; i < vm.juridicalForm.resp_contractor.length; i++) {
        // vm.juridicalForm.responsables[i].juridical = url;
        vm.juridicalForm.resp_contractor[i].contractor = url;
      }
      vm.responsable = vm.juridicalForm.resp_contractor;
    }

    vm.responsable.forEach(function (r) {
      if (r.url) {
        $http.patch(r.url, {
          resp_type: r.resp_type,
          responsable: r.responsable,
        });
      }
    });

    vm.responsable = vm.responsable.filter(function (r) {
      if (!r.url) {
        return true;
      } else return false;
    });

    if (vm.responsable) {
      dataFactory
        .post("responsables/", vm.responsable)
        .then(
          function success(request) {},
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    }
  };

  function save() {
    var l = Ladda.create(document.querySelector(".ladda-button"));
    l.start();

    if (vm.form) {
      $scope.obligados = [];
      if (vm.form.obligados) {
        vm.form.obligados.forEach(function (elem, index) {
          if (elem.val) {
            if (elem.value) {
              $scope.obligados.push(elem.value.url);
            }
          }
        });
      }
      vm.form.bound_solidarity_many = $scope.obligados ? $scope.obligados : [];
      if (vm.form.first_name == "" || vm.form.first_name == undefined) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMNAME, "error");
        return;
      }
      if (vm.form.last_name == "" || vm.form.last_name == undefined) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMLASTNAME, "error");
        return;
      }
      if (vm.form.birthday == "" || vm.form.birthday == undefined) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMBIRTHDAY, "error");
        return;
      }
      if (vm.form.rfc == "" || vm.form.rfc == undefined) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMRFC, "error");
        return;
      }
      if (vm.form.email) {
        if (
          vm.form.email != "" ||
          !vm.form.email ||
          vm.form.email != null ||
          !(vm.form.email == "")
        ) {
          if (!validateEmail(vm.form.email)) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
            return;
          }
        }
      }
      $scope.flagEmail = false;
      if (vm.form.email_natural.length > 0) {
        for (var i = 0; i < vm.form.email_natural.length; i++) {
          if (!validateEmail(vm.form.email_natural[i].correo)) {
            $scope.flagEmail = true;
          }
        }
        if ($scope.flagEmail == true) {
          l.stop();
          $scope.flagEmail = false;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
    } else {
      $scope.obligados = [];
      if (vm.juridicalForm.obligados) {
        vm.juridicalForm.obligados.forEach(function (elem, index) {
          if (elem.val) {
            if (elem.value) {
              $scope.obligados.push(elem.value.url);
            }
          }
        });
      }
      if (
        vm.juridicalForm.j_name == "" ||
        vm.juridicalForm.j_name == undefined
      ) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMJNAME, "error");
        return;
      }
      if (
        vm.juridicalForm.date_of_establishment == "" ||
        vm.juridicalForm.date_of_establishment == undefined
      ) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMESTABLISHMENT, "error");
        return;
      }
      if (vm.juridicalForm.rfc == "" || vm.juridicalForm.rfc == undefined) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMRFC, "error");
        return;
      }
      if (vm.juridicalForm.email != "") {
        if (!validateEmail(vm.juridicalForm.email)) {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
      $scope.flagEmail = false;
      if (vm.juridicalForm.email_juridical.length > 0) {
        for (var i = 0; i < vm.juridicalForm.email_juridical.length; i++) {
          if (!validateEmail(vm.juridicalForm.email_juridical[i].correo)) {
            $scope.flagEmail = true;
          }
        }
        if ($scope.flagEmail == true) {
          l.stop();
          $scope.flagEmail = false;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
    }

    var flag = false;
    var type = returnType();
    if (!type.group.url) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.SELGROUP, "error");
      flag = true;
      return;
    }

    var dataToSave = angular.copy(type);
    $scope.group_obj = type.group;
    dataToSave.group = type.group.url;

    if (dataToSave.birthday) {
      var date = dataToSave.birthday;
      var newdate = date.split("/").reverse().join("-");
      // dataToSave.birthday = newdate;
      dataToSave.birth_date = newdate;
      try {
        if (dataToSave.birthday.length <= 8) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.DATEBIRTHDAY, "error");
          return;
        }
      } catch (e) {}
    } else if (dataToSave.date_of_establishment) {
      if (isNaN(dataToSave.date_of_establishment)) {
        var date = dataToSave.date_of_establishment;
        var newdate = date.split("/").reverse().join("-");
        // dataToSave.date_of_establishment = newdate;
        dataToSave.birth_date = newdate;
      } else {
        vm.juridicalForm.group = $scope.group_obj;
        vm.juridicalForm.date_of_establishment = "";
        toaster.warning("Ingrese una fecha valida");
        return;
      }
      try {
        if (dataToSave.date_of_establishment.length <= 8) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.DATEESTABLISHMENT, "error");
          return;
        }
      } catch (e) {}
    } else {
      vm.form.group = $scope.group_obj;
      toaster.warning("Ingrese una fecha valida");
      return;
    }

    if (vm.form) {
      dataToSave.email = vm.form.email ? vm.form.email : "";
      dataToSave.phone_number = vm.form.phone_number
        ? vm.form.phone_number
        : "";
      dataToSave.sucursal = vm.form.sucursal ? vm.form.sucursal.url : "";
      if (dataToSave.email == "" && vm.form.email_natural.length > 0) {
        dataToSave.email = vm.form.email_natural[0].correo;
        vm.form.email_natural.splice(0, 1);
      }
      // Documents
      if (vm.org_name == "ancora") {
        dataToSave.card_official_identification = vm.listDocument[0].value;
        dataToSave.CURP = vm.listDocument[1].value;
        dataToSave.voucher_efirm = vm.listDocument[2].value;
        dataToSave.voucher_of_address = vm.listDocument[3].value;
        dataToSave.signed_format_ic = vm.listDocument[4].value;
        if (vm.form.only_sureties) {
          dataToSave.carta_nombramiento = vm.listDocument[5].value;
          dataToSave.curriculo = vm.listDocument[6].value;
          dataToSave.contrato_multiple_afianzadora = vm.listDocument[7].value;
          dataToSave.carta_buro = vm.listDocument[8].value;
          dataToSave.entrevista_afianzadora = vm.listDocument[9].value;
          dataToSave.rfc_document = vm.listDocument[10].value;
          dataToSave.recibos_nomina = vm.listDocument[11].value;
          dataToSave.declaracion_anual = vm.listDocument[11].value;
          dataToSave.estados_financieros_anuales = vm.listDocument[13].value;
          dataToSave.estados_financieros_parciales = vm.listDocument[14].value;
          dataToSave.alta_hacienda = vm.listDocument[15].value;
          dataToSave.escritura_inmueble = vm.listDocument[16].value;
          dataToSave.boleta_predial = vm.listDocument[17].value;
          dataToSave.certificado_gravamen = vm.listDocument[18].value;
        }
      } else {
        dataToSave.card_official_identification = vm.listDocument[0].value;
        dataToSave.CURP = vm.listDocument[1].value;
        dataToSave.voucher_efirm = vm.listDocument[2].value;
        dataToSave.voucher_of_address = vm.listDocument[3].value;
        dataToSave.signed_format_ic = vm.listDocument[4].value;
        dataToSave.fiscal_power = vm.listDocument[5].value;
        if (vm.form.only_sureties) {
          dataToSave.carta_nombramiento = vm.listDocument[6].value;
          dataToSave.curriculo = vm.listDocument[7].value;
          dataToSave.contrato_multiple_afianzadora = vm.listDocument[8].value;
          dataToSave.carta_buro = vm.listDocument[9].value;
          dataToSave.entrevista_afianzadora = vm.listDocument[10].value;
          dataToSave.rfc_document = vm.listDocument[11].value;
          dataToSave.recibos_nomina = vm.listDocument[12].value;
          dataToSave.declaracion_anual = vm.listDocument[13].value;
          dataToSave.estados_financieros_anuales = vm.listDocument[14].value;
          dataToSave.estados_financieros_parciales = vm.listDocument[15].value;
          dataToSave.alta_hacienda = vm.listDocument[16].value;
          dataToSave.escritura_inmueble = vm.listDocument[17].value;
          dataToSave.boleta_predial = vm.listDocument[18].value;
          dataToSave.certificado_gravamen = vm.listDocument[19].value;
        }
      }
      //upload files repect documents
      vm.listDocument.forEach(function (ar) {
        if (ar.arch.formData) {
          var extension = ar.arch.formData[0].arch.name.split(".")[1];
          ar.arch.formData[0].name = ar.name + "." + extension;
          ar.arch.file.name = ar.name + "." + extension;
          $scope.uploaderDocument.queue.push(ar.arch);
          $scope.uploaderDocument.onAfterAddingFile(ar.arch);
        }
      });
      for (var i = 0; i < vm.form.phone_natural.length; i++) {
        if (vm.form.phone_natural[i].phone.length < 9) {
          $scope.flagPhone = true;
        }
      }
      if (!$scope.flagPhone) {
        if (dataToSave.phone_number == "" && vm.form.phone_natural.length > 0) {
          dataToSave.phone_number = vm.form.phone_natural[0].phone;
          vm.form.phone_natural.splice(0, 1);
        }
      } else {
        $scope.flagPhone = false;
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
        return;
      }

      try {
        dataToSave.vendor = vm.form.vendedor.url;
      } catch (e) {
        dataToSave.vendor = "";
      }
      try {
        dataToSave.sucursal = vm.form.sucursal.url;
      } catch (e) {
        dataToSave.sucursal = "";
      }

      try {
        dataToSave.responsable = vm.form.responsable.url;
      } catch (e) {
        dataToSave.responsable = "";
      }
    }

    if (vm.juridicalForm) {
      dataToSave.email = vm.juridicalForm.email ? vm.juridicalForm.email : "";
      dataToSave.phone_number = vm.juridicalForm.phone_number
        ? vm.juridicalForm.phone_number
        : "";
      dataToSave.sucursal = vm.juridicalForm.sucursal
        ? vm.juridicalForm.sucursal.url
        : "";
      if (
        dataToSave.email == "" &&
        vm.juridicalForm.email_juridical.length > 0
      ) {
        dataToSave.email = vm.juridicalForm.email_juridical[0].correo;
        vm.juridicalForm.email_juridical.splice(0, 1);
      }

      if (dataToSave.phone_number) {
        if (dataToSave.phone_number.length < 9) {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
          return;
        }
      }

      try {
        dataToSave.vendor = vm.juridicalForm.vendedor.url;
      } catch (e) {
        dataToSave.vendor = "";
      }

      try {
        dataToSave.sucursal = vm.juridicalForm.sucursal.url;
      } catch (e) {
        dataToSave.sucursal = "";
      }

      try {
        dataToSave.responsable = vm.juridicalForm.responsable.url;
      } catch (e) {
        dataToSave.responsable = "";
      }

      for (var i = 0; i < vm.juridicalForm.phone_juridical.length; i++) {
        if (vm.juridicalForm.phone_juridical[i].phone.length < 9) {
          $scope.flagPhone = true;
        }
      }
      if (!$scope.flagPhone) {
        if (
          dataToSave.phone_number == "" &&
          vm.juridicalForm.phone_juridical.length > 0
        ) {
          dataToSave.phone_number = vm.juridicalForm.phone_juridical[0].phone;
          vm.juridicalForm.phone_juridical.splice(0, 1);
        }
      } else {
        $scope.flagPhone = false;
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
        return;
      }
      // Documents

      dataToSave.constitutive_act = vm.listDocument[0].value;
      dataToSave.rfc_document = vm.listDocument[1].value;
      dataToSave.card_official_identification = vm.listDocument[2].value;
      dataToSave.voucher_of_address = vm.listDocument[3].value;
      dataToSave.modifications_constitutive_act = vm.listDocument[4].value;
      dataToSave.fiscal_power = vm.listDocument[5].value;
      if (vm.juridicalForm.only_sureties) {
        dataToSave.curriculo = vm.listDocument[6].value;
        dataToSave.contrato_multiple_afianzadora = vm.listDocument[7].value;
        dataToSave.carta_buro = vm.listDocument[8].value;
        dataToSave.entrevista_afianzadora = vm.listDocument[9].value;
        dataToSave.aviso_privacidad = vm.listDocument[10].value;
        dataToSave.protocolizaciones = vm.listDocument[11].value;
        dataToSave.alta_hacienda = vm.listDocument[12].value;
        dataToSave.cambio_domicilio_hacienda = vm.listDocument[13].value;
        dataToSave.voucher_efirm = vm.listDocument[14].value;
        dataToSave.declaracion_anual = vm.listDocument[15].value;
        dataToSave.estados_financieros_anuales = vm.listDocument[16].value;
        dataToSave.estados_financieros_parciales = vm.listDocument[17].value;
        dataToSave.escritura_inmueble = vm.listDocument[18].value;
        dataToSave.boleta_predial = vm.listDocument[19].value;
        dataToSave.certificado_gravamen = vm.listDocument[20].value;
      }
      //upload files repect documents
      vm.listDocument.forEach(function (ar) {
        if (ar.arch.formData) {
          var extension = ar.arch.formData[0].arch.name.split(".")[1];
          ar.arch.formData[0].name = ar.name + "." + extension;
          ar.arch.file.name = ar.name + "." + extension;
          $scope.uploaderDocument.queue.push(ar.arch);
          $scope.uploaderDocument.onAfterAddingFile(ar.arch);
        }
      });
      //upload documents
    }

    if (dataToSave.contact_natural) {
      dataToSave.contact_natural.forEach(function (contact) {
        if (contact.name == "") {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.SELADDRES, "error");
          flag = true;
          return;
        } else {
          if (contact.email) {
            if (!validateEmail(contact.email)) {
              l.stop();
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.INVALIDEMAILCONTACT,
                "error"
              );
              flag = true;
              return;
            }
          }
          if (contact.phone_number) {
            if (contact.phone_number.length < 9) {
              l.stop();
              flag = true;
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORLENGTHPHONECONTACT,
                "error"
              );
              return;
            }
          }
        }
      });
    } else {
      dataToSave.contact_juridical.forEach(function (contact) {
        if (contact.name == "") {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.SELADDRES, "error");
          flag = true;
          return;
        } else {
          if (contact.email) {
            if (!validateEmail(contact.email)) {
              l.stop();
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.INVALIDEMAILCONTACT,
                "error"
              );
              flag = true;
              return;
            }
          }
          if (contact.phone_number) {
            if (contact.phone_number.length < 9) {
              l.stop();
              flag = true;
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORLENGTHPHONECONTACT,
                "error"
              );
              return;
            }
          }
        }
      });
    }

    // dataToSave.group = vm.editForm.subsubgrupo ? vm.editForm.subsubgrupo.url : vm.editForm.subgroup ? vm.editForm.subgroup.url : vm.editForm.group ? vm.editForm.group.url : '';
    if (vm.editForm.group) {
      dataToSave.group = vm.editForm.group.url;
      if (vm.editForm.subgroup) {
        dataToSave.group = vm.editForm.subgroup.url;
        if (vm.editForm.subsubgrupo) {
          dataToSave.group = vm.editForm.subsubgrupo.url;
        }
      }
    }
    // dataToSave.grouping_level = vm.editForm.subsubasignaciones ? vm.editForm.subsubasignaciones.url : vm.editForm.subagrupaciones ? vm.editForm.subagrupaciones.url : vm.editForm.grouping_level ? vm.editForm.grouping_level.url : '';
    dataToSave.groupinglevel = vm.editForm.subsubasignaciones
      ? vm.editForm.subsubasignaciones.url
      : vm.editForm.subagrupaciones
      ? vm.editForm.subagrupaciones.url
      : vm.editForm.grouping_level
      ? vm.editForm.grouping_level.url
      : null;
    dataToSave.cellule = vm.juridicalForm
      ? vm.juridicalForm.celula
      : vm.form
      ? vm.form.celula
      : null;

    if (flag) {
      return;
    }
    dataToSave.birth_date = datesFactory.toDate(
      vm.form ? vm.form.birthday : vm.juridicalForm.date_of_establishment
    );
    dataToSave.bound_solidarity_many = $scope.obligados ? $scope.obligados : [];
    dataToSave.has_bound_solidarity = $scope.has_solidario ? true : false;
    return ContratanteService.updateContratante(dataToSave).then(function (
      data
    ) {
      if (data.status === 200 || data.status === 201) {
        // var params = {
        //   'model': 26,
        //   'event': "POST",
        //   'associated_id': data.data.id,
        //   'identifier': "actualizó el contratante."
        // }
        // dataFactory.post('send-log/', params).then(function success(response) {

        // });
        console.log("3797", $scope.origin_contractor);
        console.log("3798", data.data);
        $scope.changes = [];
        if ($scope.origin_contractor.first_name !== data.data.first_name) {
          var change_log = {
            name: "Nombre",
            origin: $scope.origin_contractor.first_name,
            change: data.data.first_name,
          };
          $scope.changes.push(change_log);
        }
        if ($scope.origin_contractor.last_name !== data.data.last_name) {
          var change_log = {
            name: "Apellido Paterno",
            origin: $scope.origin_contractor.last_name,
            change: data.data.last_name,
          };
          $scope.changes.push(change_log);
        }
        if ($scope.origin_contractor.j_name !== data.data.j_name) {
          var change_log = {
            name: "Nombre",
            origin: $scope.origin_contractor.j_name,
            change: data.data.j_name,
          };
          $scope.changes.push(change_log);
        }
        if ($scope.origin_contractor.birth_date !== data.data.birth_date) {
          var change_log = {
            name: "Fecha Cumpleaños",
            origin: datesFactory.convertDate(
              $scope.origin_contractor.birth_date
            ),
            change: datesFactory.convertDate(data.data.birth_date),
          };
          $scope.changes.push(change_log);
        }
        if (
          $scope.origin_contractor.date_of_establishment !==
          data.data.date_of_establishment
        ) {
          var change_log = {
            name: "Fecha Constitutiva",
            origin: $scope.origin_contractor.date_of_establishment,
            change: data.data.date_of_establishment,
          };
          $scope.changes.push(change_log);
        }
        if ($scope.origin_contractor.email !== data.data.email) {
          var change_log = {
            name: "Correo Electrónico",
            origin: $scope.origin_contractor.email,
            change: data.data.email,
          };
          $scope.changes.push(change_log);
        }

        var paramsRec = {
          model: 26,
          event: "PATCH",
          associated_id: data.data.id,
          identifier: " actualizó la el contratante.",
          change: $scope.changes,
        };

        dataFactory
          .post("send_log_specific/", paramsRec)
          .then(function success(response) {});

        if (data.data.email && !data.data.id) {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROREMAILMAX, "error");
          return;
        }

        $scope.contractorEdit = data.data;

        if (data) {
          if (data.data.type_person == 1) {
            if ($scope.uploaderDocument.queue.length != 0) {
              uploadFilesList(data.data.type_person, data.data.id);
            }
            $scope.sendEmails(data.data.id, 1);
            $scope.sendPhones(data.data.id, 1);
            $scope.sendResponsables(data.data.url, 1);
          } else if (data.data.type_person == 2) {
            if ($scope.uploaderDocument.queue.length != 0) {
              uploadFilesList(data.data.type_person, data.data.id);
            }
            $scope.sendEmails(data.data.id, 2);
            $scope.sendPhones(data.data.id, 2);
            $scope.sendResponsables(data.data.url, 2);
          }
        }
        if (helpers.isResponseOk(data.status)) {
          var contacts =
            $stateParams.type === "fisicas" ||
            $stateParams.contractor.type_person === 1
              ? type.contact_natural
              : type.contact_juridical;

          contacts.forEach(function (elem) {
            if (
              $stateParams.type === "fisicas" ||
              $stateParams.contractor.type_person === 1
            ) {
              // elem.natural = data.data.url;
              elem.contractor = data.data.url;
            } else {
              // elem.juridical = data.data.url;
              elem.contractor = data.data.url;
            }

            var nums = [];

            $(".telefono").each(function (telefono) {
              var actual = $(this);
              nums.push(actual);
            });
            var typePerson;
            if (
              $stateParams.type === "fisicas" ||
              $stateParams.contractor.type_person === 1
            ) {
              typePerson = vm.form.contact_natural;
            } else {
              typePerson = vm.juridicalForm.contact_juridical;
            }

            if (!elem.url) {
              contactService.createContact(elem);
            } else {
              contactService.updateContact(elem);
            }

            if (elem.email) {
              if (!validateEmail(elem.email)) {
                toaster.warning(
                  "Favor de revisar el formato del correo de el contacto"
                );
                flag = true;
              }
              if (!elem.name) {
                toaster.warning("Favor de añadir nombre en el contacto");
                flag = true;
              }
            }
          });
          var address = type.address_natural
            ? type.address_natural
            : type.address_juridical;
          if (!helpers.hasAtLeastOneAddress(address)) {
            l.stop();
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.ADDATLEASTONEDIRECCTION,
              "error"
            );
            flag = true;
            return;
          }
          address.forEach(function (elem) {
            if (flag) {
              return;
            }

            elem = {
              raw: elem.raw,
              street_address: elem.street_address,
              intersection: elem.intersection,
              political: elem.political,
              administrative_area_level_1:
                elem.administrative_area_level_1.state,
              administrative_area_level_1_short:
                elem.administrative_area_level_1_short,
              administrative_area_level_2:
                elem.administrative_area_level_2.city,
              administrative_area_level_3: elem.administrative_area_level_3,
              colloquial_area: elem.colloquial_area,
              sublocality: elem.sublocality,
              neighborhood: elem.neighborhood,
              premise: elem.premise,
              subpremise: elem.subpremise,
              natural_feature: elem.natural_feature,
              country: elem.country,
              country_code: elem.country_code,
              locality: elem.locality,
              postal_code: elem.postal_code,
              route: elem.route,
              street_number: elem.street_number,
              street_number_int: elem.street_number_int,
              formatted: elem.formatted,
              latitude: elem.latitude,
              longitude: elem.longitude,
              details: elem.details,
              composed: elem.composed,
              address: elem.address,
              url: globalVar.address,
              tipo: elem.tipo ? elem.tipo.name : elem.tipo,
              id: elem.id || null,
            };

            if (
              $stateParams.type === "fisicas" ||
              $stateParams.contractor.type_person === 1
            ) {
              // elem.natural = data.data.url;
              elem.contractor = data.data.url;
            } else {
              // elem.juridical = data.data.url;
              elem.contractor = data.data.url;
            }
            if (!elem.id) {
              generalService.postService(elem).then(function (data) {
                if (!helpers.isResponseOk(data.status)) {
                  l.stop();
                  SweetAlert.swal(
                    "ERROR",
                    MESSAGES.ERROR.UPDATECONTRACTOR,
                    "error"
                  );
                  return;
                }
              });
            } else {
              generalService.updateAddressService(elem).then(function (data) {
                if (!helpers.isResponseOk(data.status)) {
                  l.stop();
                  SweetAlert.swal(
                    "ERROR",
                    MESSAGES.ERROR.UPDATECONTRACTOR,
                    "error"
                  );
                  return;
                }
              });
            }
          });

          if (flag) {
            return;
          }
          SweetAlert.swal("¡Listo!", MESSAGES.OK.UPDATECONTRACTOR, "success");
          $timeout(function () {
            $state.reload();
            $state.go("fianzas.pprovinfo", {
              type:
                $scope.contractorEdit.type_person == 1 ? "fisicas" : "morales",
              contratanteId: $scope.contractorEdit.id,
            });
          }, 1000);
        } else {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.UPDATECONTRACTOR, "error");
          return;
          vm.form.group = $scope.group_obj;
        }
      }
    });
  }
  function save_moral() {
    var l = Ladda.create(document.querySelector(".ladda-button"));
    l.start();
    if (vm.juridicalForm.j_name == "" || vm.juridicalForm.j_name == undefined) {
      l.stop();
      SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMJNAME, "error");
      return;
    }

    var flag = false;
    var dataToSave = vm.juridicalForm;

    if (vm.juridicalForm) {
      try {
        dataToSave.vendor = vm.juridicalForm.vendedor.url;
      } catch (e) {
        dataToSave.vendor = "";
      }

      try {
        dataToSave.sucursal = vm.juridicalForm.sucursal.url;
      } catch (e) {
        dataToSave.sucursal = "";
      }

      try {
        dataToSave.responsable = vm.juridicalForm.responsable.url;
      } catch (e) {
        dataToSave.responsable = "";
      }
    }

    // dataToSave.group = vm.editForm.subsubgrupo ? vm.editForm.subsubgrupo.url : vm.editForm.subgroup ? vm.editForm.subgroup.url : vm.editForm.group ? vm.editForm.group.url : '';
    if (vm.editForm.group) {
      dataToSave.group = vm.editForm.group.url;
      if (vm.editForm.subgroup) {
        dataToSave.group = vm.editForm.subgroup.url;
        if (vm.editForm.subsubgrupo) {
          dataToSave.group = vm.editForm.subsubgrupo.url;
        }
      }
    }
    dataToSave.full_name = vm.juridicalForm.j_name;
    return ContratanteService.updateContratante(dataToSave).then(function (
      data
    ) {
      if (data.status === 200 || data.status === 201) {
        $scope.changes = [];

        $scope.contractorEdit = data.data;
        if (helpers.isResponseOk(data.status)) {
          SweetAlert.swal("¡Listo!", MESSAGES.OK.UPDATECONTRACTOR, "success");
          $timeout(function () {
            $state.reload();
            $state.go("fianzas.pprovinfo", {
              type:
                $scope.contractorEdit.type_person == 1 ? "fisicas" : "morales",
              contratanteId: $scope.contractorEdit.id,
            });
          }, 1000);
        } else {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.UPDATECONTRACTOR, "error");
          return;
          vm.form.group = $scope.group_obj;
        }
      }
    });
  }
  $scope.getLog = function () {
    dataFactory
      .get("get-specific-log", {
        model: 26,
        associated_id: vm.form ? vm.form.id : vm.juridicalForm.id,
      })
      .then(function success(response) {
        var modalInstance = $uibModal.open({
          templateUrl: "app/colectivos/log.modal.html",
          controller: "LogCtrl",
          size: "lg",
          resolve: {
            log: function () {
              return response.data;
            },
          },
          backdrop: "static",
          keyboard: false,
        });
        modalInstance.result.then(function (receipt) {
          vm.receipts.splice(index, 1);
          activate();
        });
      })
      .catch(function (e) {
        console.log("error", e);
      });
  };

  vm.hoy = new Date();

  function returnType() {
    if (
      $stateParams.type === "fisicas" ||
      $stateParams.contractor.type_person === 1
    ) {
      rfc_getDateEn(vm.form.rfc, vm.form);
      function rfc_getDateEn(rfc, form) {
        vm.rfc_fec = rfc.substr(4, 6);
        vm.rfc_anio = rfc.substr(4, 2);
        vm.rfc_month = rfc.substr(6, 2);
        vm.rfc_day = rfc.substr(8, 2);
        vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
        vm.date = new Date(vm.fecha);
        vm.aniorfc = vm.date.getFullYear();
        vm.hoyA = vm.hoy.getFullYear();
        if (vm.aniorfc > vm.hoyA) {
          vm.resta = vm.aniorfc - 100;
          vm.rfc_anio = vm.resta;
          vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
          if (form.birthday == "") {
            vm.form.birthday = vm.fecha;
          } else {
            vm.form.birthday = form.birthday;
          }
        }
        if (form.birthday == "") {
          var fecha_rfcn = $filter("date")(new Date(vm.date), "dd/MM/yyyy");
          vm.form.birthday = fecha_rfcn;
        } else {
          vm.form.birthday = form.birthday;
        }
      }
      return vm.form;
    } else {
      rfc_getDateEj(vm.juridicalForm.rfc, vm.juridicalForm);
      function rfc_getDateEj(rfc, form) {
        vm.rfc_fec = rfc.substr(3, 6);
        vm.rfc_anio = rfc.substr(3, 2);
        vm.rfc_month = rfc.substr(5, 2);
        vm.rfc_day = rfc.substr(7, 2);
        vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
        vm.date = new Date(vm.fecha);
        vm.aniorfc = vm.date.getFullYear();
        vm.hoyA = vm.hoy.getFullYear();
        if (vm.aniorfc > vm.hoyA) {
          vm.resta = vm.aniorfc - 100;
          vm.rfc_anio = vm.resta;
          vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
          if (form.date_of_establishment == "") {
            var fecha_rfcJ = $filter("date")(new Date(vm.fecha), "dd/MM/yyyy");
            vm.juridicalForm.date_of_establishment = fecha_rfcJ;
          } else {
            vm.juridicalForm.date_of_establishment = form.date_of_establishment;
          }
        }
        if (form.date_of_establishment == "") {
          var fecha_rfcJ = $filter("date")(new Date(vm.date), "dd/MM/yyyy");
          vm.juridicalForm.date_of_establishment = fecha_rfcJ;
        } else {
          vm.juridicalForm.date_of_establishment = form.date_of_establishment;
        }
      }
      return vm.juridicalForm;
    }
  }

  function deleteContacts(index, type, contact) {
    $localStorage.indx = index;
    $localStorage.urll = contact.url;
    // var modalInstance = $uibModal.open({
    //   templateUrl: 'app/contratantes/contratantes.deleteContact.html',
    //   controller: ModalInstanceCtrlDeleteContact,
    // });
    SweetAlert.swal(
      {
        title: "¿Estás seguro?",
        text: "Los cambios no podrán revertirse",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Si",
        cancelButtonText: "No",
      },
      function () {
        var index = $localStorage.indx;
        var url = $localStorage.urll;
        if ((url && index) || (url && !index)) {
          try {
            return contactService.deleteContact(url).then(function () {
              toaster.success(MESSAGES.OK.DELETECONTRACTOR);

              if (
                $stateParams.type === "fisicas" ||
                $stateParams.contractor.type_person === 1
              ) {
                vm.form.contact_natural.splice(index, 1);
              } else {
                vm.juridicalForm.contact_juridical.splice(index, 1);
              }
            });
          } catch (err) {
            throw err;
          }
        } else {
          if (
            $stateParams.type === "fisicas" ||
            $stateParams.contractor.type_person === 1
          ) {
            vm.form.contact_natural.splice(index, 1);
          } else {
            vm.juridicalForm.contact_juridical.splice(index, 1);
          }
        }
      }
    );
  }

  function ModalInstanceCtrlDeleteContact($scope, $uibModalInstance) {
    var index = $localStorage.indx;
    var url = $localStorage.urll;
    $scope.ok = function () {
      if ((url && index) || (url && !index)) {
        try {
          return contactService.deleteContact(url).then(function () {
            toaster.success(MESSAGES.OK.DELETECONTRACTOR);
            $uibModalInstance.dismiss("cancel");
            if (
              $stateParams.type === "fisicas" ||
              $stateParams.contractor.type_person === 1
            ) {
              vm.form.contact_natural.splice(index, 1);
            } else {
              vm.juridicalForm.contact_juridical.splice(index, 1);
            }
          });
        } catch (err) {
          throw err; // toaster.error('Agregue al menos un contacto' + err.message);
        }
        $uibModalInstance.dismiss("cancel");
      } else {
        if (
          $stateParams.type === "fisicas" ||
          $stateParams.contractor.type_person === 1
        ) {
          vm.form.contact_natural.splice(index, 1);
        } else {
          vm.juridicalForm.contact_juridical.splice(index, 1);
        }
      }
      $uibModalInstance.dismiss("cancel");
    };

    $scope.cancel = function () {
      if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
    };
  }

  function addContact() {
    var contact = {
      name: "",
      phone_number: "",
      email: "",
    }; //jshint ignore:line
    if (
      $stateParams.type === "fisicas" ||
      $stateParams.contractor.type_person === 1
    ) {
      vm.form.contact_natural.push(contact);
    } else {
      vm.juridicalForm.contact_juridical.push(contact);
    }
  }
  $window.localStorage.editCont = false;
}

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("FianzasReclamacionesCtrl", FianzasReclamacionesCtrl);

  FianzasReclamacionesCtrl.$inject = [
    "appStates",
    "$state",
    "$sessionStorage",
    "$scope",
    "FileUploader",
    "dataFactory",
    "$http",
    "datesFactory",
    "SweetAlert",
    "url",
    "$timeout",
    "MESSAGES",
    "$localStorage",
  ];

  function FianzasReclamacionesCtrl(
    appStates,
    $state,
    $sessionStorage,
    $scope,
    FileUploader,
    dataFactory,
    $http,
    datesFactory,
    SweetAlert,
    url,
    $timeout,
    MESSAGES,
    $localStorage
  ) {
    var vm = this;

    $scope.types_options = [
      {
        label: "Aviso previo",
        id: 1,
      },
      {
        label: "Reclamo Formal",
        id: 2,
      },
      {
        label: "Reconsideración",
        id: 3,
      },
    ];

    $scope.status_options = [
      {
        label: "Presentación",
        id: 1,
      },
      {
        label: "En integración",
        id: 2,
      },
      {
        label: "Reclamo Formal",
        id: 3,
      },
      {
        label: "Respuesta Afianzadora",
        id: 4,
      },
      {
        label: "Respuesta Cliente",
        id: 5,
      },
      {
        label: "Reconsideración",
        id: 6,
      },
      {
        label: "Rechazada",
        id: 7,
      },
      {
        label: "Pagada",
        id: 8,
      },
      {
        label: "Desistimiento",
        id: 9,
      },
      {
        label: "Recuperación",
        id: 10,
      },
      {
        label: "Cerrada",
        id: 11,
      },
    ];
    vm.contacts = [];
    vm.form = {
      presentacion: datesFactory.convertDate(new Date()),
    };

    $scope.infoUser = $sessionStorage.infoUser;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          vm.acceso_fianzas = perm;
          vm.acceso_fianzas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    activate();

    function activate() {
      vm.selected_affect = $localStorage["save_create_reclamacion"]
        ? $localStorage["save_create_reclamacion"]["selected_affect"]
        : "";
      vm.form.number = $localStorage["save_create_reclamacion"]
        ? $localStorage["save_create_reclamacion"]["number"]
        : "";
      vm.form.claim_type = $localStorage["save_create_reclamacion"]
        ? $localStorage["save_create_reclamacion"]["claim_type"]
        : "";
      vm.form.status = $localStorage["save_create_reclamacion"]
        ? $localStorage["save_create_reclamacion"]["status"]
        : "";
      vm.form.reason = $localStorage["save_create_reclamacion"]
        ? $localStorage["save_create_reclamacion"]["reason"]
        : "";
      vm.form.observations = $localStorage["save_create_reclamacion"]
        ? $localStorage["save_create_reclamacion"]["observations"]
        : "";
      if (vm.selected_affect) {
        getInfoFianza(vm.selected_affect);
      }
    }

    if ("save_create_reclamacion" in $localStorage) {
    } else {
      $localStorage["save_create_reclamacion"] = {};
    }

    $scope.saveLocalstorange = function () {
      $localStorage["save_create_reclamacion"]["selected_affect"] =
        vm.selected_affect ? vm.selected_affect : "";
      $localStorage["save_create_reclamacion"]["number"] = vm.form.number
        ? vm.form.number
        : "";
      $localStorage["save_create_reclamacion"]["claim_type"] = vm.form
        .claim_type
        ? vm.form.claim_type
        : "";
      $localStorage["save_create_reclamacion"]["status"] = vm.form.status
        ? vm.form.status
        : "";
      $localStorage["save_create_reclamacion"]["reason"] = vm.form.reason
        ? vm.form.reason
        : "";
      $localStorage["save_create_reclamacion"]["observations"] = vm.form
        .observations
        ? vm.form.observations
        : "";
    };

    $scope.matchBeneficiares = function (word) {
      var source = [];
      if (word) {
        if (word.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_bens = 'v2/fianzas/bens-match/';
          $scope.show_bens = "bens-match/";
          dataFactory
            .post($scope.show_bens, { matchWord: word })
            .then(function success(response) {
              if (response.data == []) {
                $scope.bens_data = [];
              }
              $scope.bens = response.data;
              if ($scope.bens.length > 0) {
                var fianza = "";
                $scope.fianza_ben = {};

                $scope.bens.forEach(function (item) {
                  if (item.first_name) {
                    if (item.fianza != null) {
                      fianza = item.fianza;
                    } else {
                      fianza = "";
                    }
                    var obj = {
                      label:
                        item.full_name + " - Fianza: " + item.poliza_number,
                      value: item.poliza,
                      id_fianza: item.poliza,
                      url: item.poliza,
                    };
                    // if (item.poliza_many.length >0) {
                    //   // dataFactory.get(item.poliza_many[0])
                    //   $http.get(item.poliza_many[0])
                    //   .then(function success(responseF) {
                    //     $scope.fianza_ben = responseF.data;
                    //     fianza = $scope.fianza_ben.poliza_number
                    //     obj.value = responseF.data.id;
                    //     obj.id_fianza = responseF.data.id;
                    //     obj.label= item.first_name + ' ' + item.last_name + ' ' + item.second_last_name + ' - Fianza: ' + responseF.data.poliza_number;
                    //   })
                    // }else if (item.poliza) {
                    //   // dataFactory.get(item.poliza_many[0])
                    //   $http.get(item.poliza)
                    //   .then(function success(responseF) {
                    //     $scope.fianza_ben = responseF.data;
                    //     fianza = $scope.fianza_ben.poliza_number
                    //     obj.value = responseF.data.id;
                    //     obj.id_fianza = responseF.data.id;
                    //     obj.label= item.first_name + ' ' + item.last_name + ' ' + item.second_last_name + ' - Fianza: ' + responseF.data.poliza_number;
                    //   })
                    // }
                  } else {
                    if (item.fianza != null) {
                      fianza = item.fianza;
                    } else {
                      fianza = "";
                    }
                    var obj = {
                      label: item.j_name + "- Fianza: " + fianza,
                      value: $scope.fianza_ben.id,
                      id_fianza: $scope.fianza_ben.id,
                      url: item.url,
                    };
                    if (
                      item &&
                      item.poliza_many &&
                      item.poliza_many.length > 0
                    ) {
                      $http
                        .get(item.poliza_many[0])
                        .then(function success(responseF) {
                          $scope.fianza_ben = responseF.data;
                          fianza = $scope.fianza_ben.poliza_number;
                          obj.value = responseF.data.id;
                          obj.id_fianza = responseF.data.id;
                          obj.label =
                            (item.first_name
                              ? item.first_name +
                                " " +
                                item.last_name +
                                " " +
                                item.second_last_name
                              : item.full_name) +
                            " - Fianza: " +
                            responseF.data.poliza_number;
                        });
                    } else if (item.poliza) {
                      try {
                        $http
                          .get(item.poliza)
                          .then(function success(responseF) {
                            $scope.fianza_ben = responseF.data;
                            fianza = $scope.fianza_ben.poliza_number;
                            obj.value = responseF.data.id;
                            obj.id_fianza = responseF.data.id;
                            obj.label =
                              (item.first_name
                                ? item.first_name +
                                  " " +
                                  item.last_name +
                                  " " +
                                  item.second_last_name
                                : item.full_name) +
                              " - Fianza: " +
                              responseF.data.poliza_number;
                          });
                      } catch (i) {
                        dataFactory
                          .get("polizas/" + item.poliza)
                          .then(function success(polizaData) {
                            if (polizaData) {
                              $scope.fianza_ben = polizaData.data;
                              fianza = $scope.fianza_ben.poliza_number;
                              obj.value = polizaData.data.id;
                              obj.id_fianza = polizaData.data.id;
                              if (item.first_name) {
                                var fullName = "";
                                if (item.first_name)
                                  fullName += item.first_name + " ";
                                if (item.last_name)
                                  fullName += item.last_name + " ";
                                if (item.second_last_name)
                                  fullName += item.second_last_name + " ";
                                // Si no hay apellidos, usa full_name
                                if (
                                  !item.last_name &&
                                  !item.second_last_name &&
                                  item.full_name
                                ) {
                                  fullName = item.full_name + " ";
                                }
                                obj.label =
                                  fullName.trim() +
                                  " - Fianza: " +
                                  polizaData.data.poliza_number +
                                  " - Vigencia: " +
                                  datesFactory.convertDate(
                                    polizaData.data.start_of_validity
                                  ) +
                                  " " +
                                  datesFactory.convertDate(
                                    polizaData.data.end_of_validity
                                  );
                              } else {
                                var fn = item.full_name
                                  ? item.full_name + " - "
                                  : "";
                                obj.label =
                                  fn +
                                  polizaData.data.poliza_number +
                                  " - Vigencia: " +
                                  datesFactory.convertDate(
                                    polizaData.data.start_of_validity
                                  ) +
                                  " " +
                                  datesFactory.convertDate(
                                    polizaData.data.end_of_validity
                                  );
                              }
                            }
                          })
                          .catch(function (error) {
                            console.log(
                              "Error - claves-by-provider - catch",
                              error
                            );
                          });
                      }
                    }
                  }

                  source.push(obj);
                });
                $scope.bens_data = source;
              } else {
                // SweetAlert.swal('Advertencia','Intente nuevamente','warning')
                // $scope.bens_data = [];
              }
            });
        } else {
          $scope.bens_data = [];
        }
      }
    };

    vm.getInfoFianza = getInfoFianza;

    function getInfoFianza(parInfo) {
      $scope.benefited = parInfo.url;
      dataFactory
        .get("leer-fianzas-info/" + parInfo.value)
        .then(function success(response) {
          $scope.fianza = response.data;
        });
    }

    $scope.getInfo = function (parInfo) {
      $scope.benefited = parInfo.url;
      dataFactory
        .get("leer-fianzas-info/" + parInfo.value)
        .then(function success(response) {
          $scope.fianza = response.data;
        });
    };

    $scope.addContact = function () {
      $scope.count_contact = false;
      var contact = {
        first_name: "",
        phone: "",
        email: "",
        references: "",
      };
      vm.contacts.push(contact);
    };
    $scope.saveClaim = function () {
      vm.form.introduction_date = new Date(
        datesFactory.toDate(vm.form.presentacion)
      );
      vm.form.poliza = $scope.fianza.url;
      vm.form.benefited = $scope.benefited;
      dataFactory.post("claims/", vm.form).then(function success(response) {
        console.log(response);
        if (response.status == 200 || response.status == 201) {
          $scope.reclamacion = response.data;
          var params = {
            model: 13,
            event: "POST",
            associated_id: $scope.fianza.id,
            identifier: "creó la reclamación No." + response.data.number + ".",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          SweetAlert.swal("Hecho", "Se ha creado la reclamación", "success");
          $scope.countFile = $scope.uploader.queue.length;
          if ($scope.uploader.queue.length == 0) {
            $localStorage.save_create_reclamacion = {};

            var name = "Reclamación Fianza";
            var route = "fianzas.reclinf";

            $scope.name_for_new_tab = name;
            $scope.route_for_new_tab = route;

            var existe = false;
            if (name && route) {
              $scope.route_for_new_tab = route;
              $scope.name_for_new_tab = name;
              appStates.states.forEach(function (state) {
                if (state.route == $scope.route_for_new_tab) {
                  existe = true;
                }
              });
            }

            if (!existe) {
              var active_tab = appStates.states.findIndex(function (item) {
                if (item.active) {
                  return true;
                }
                return false;
              });

              appStates.states[active_tab] = {
                name: $scope.name_for_new_tab,
                heading: $scope.name_for_new_tab,
                route: $scope.route_for_new_tab,
                active: true,
                isVisible: true,
                href: $state.href($scope.route_for_new_tab),
              };
            }
            $localStorage.tab_states = appStates.states;

            $state.go($scope.route_for_new_tab, { claimId: response.data.id });
          } else {
            uploadFiles(response.data.id);
          }
        }
      });
    };

    /* Alerta success uploadfiles */
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        var name = "Reclamación Fianza";
        var route = "fianzas.reclinf";

        $scope.name_for_new_tab = name;
        $scope.route_for_new_tab = route;

        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }

        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });

          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab),
          };
        }
        $localStorage.tab_states = appStates.states;
        $state.go($scope.route_for_new_tab, { claimId: $scope.reclamacion.id });
        // $state.go('fianzas.reclinf', {claimId: $scope.reclamacion.id});
      }
    };

    /* Alerta error uploadfiles */
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(reclamacionId) {
      $scope.userInfo = {
        id: reclamacionId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "claims/" + reclamacionId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    vm.cancel = cancel;

    function cancel() {
      $state.go("fianzas.reclist");
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("FianzasListCtrl", FianzasListCtrl);

  FianzasListCtrl.$inject = [
    "$rootScope",
    "toaster",
    "dataFactory",
    "datesFactory",
    "providerService",
    "$scope",
    "$http",
    "url",
    "$parse",
    "$sessionStorage",
    "$state",
    "appStates",
    "$localStorage",
  ];
  function FianzasListCtrl(
    $rootScope,
    toaster,
    dataFactory,
    datesFactory,
    providerService,
    $scope,
    $http,
    url,
    $parse,
    $sessionStorage,
    $state,
    appStates,
    $localStorage
  ) {
    var vm = this;
    /* Variables */
    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: datesFactory.convertDate(new Date()),
      until: datesFactory.convertDate(new Date()),
      status: 0,
      contratante: 0,
      group: 0,
      num_poliza: "",
      inicio_fin: true,
      classification: 0,
      subgroup: 0,
      subsubgroup: 0,
      groupinglevel: 0,
      subgrouping: 0,
      subsubgrouping: 0,
      celula: 0,
    };
    vm.subgroup = 0;
    vm.subsubgroup = 0;
    $scope.subsubgroups = [];
    $scope.subgroups = [];
    vm.groupinglevel = 0;
    vm.subgroupinglevel = 0;
    $scope.groupinglevel = [];
    $scope.subgroupinglevel = [];
    vm.subsubgroupinglevel = 0;
    $scope.subsubgroupinglevels = [];
    $scope.subgrouping = [];
    $scope.subsubgrouping = [];
    vm.status = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
      {
        id: 17,
        name: "Anulada",
      },
    ];
    /* Funciones */
    vm.changeOrder = changeOrder;
    vm.changeOrderOT = changeOrderOT;
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.matchesGroupinglevel = matchesGroupinglevel;
    vm.matchesClassification = matchesClassification;
    vm.search = search;
    vm.searchOT = searchOT;
    vm.testPagination = testPagination;
    vm.show_pag_search = false;
    vm.show_binnacle_fianza = false;
    vm.show_binnacle_fianza_ot = false;
    vm.showBinnacle = showBinnacle;
    vm.showBinnacle_ot = showBinnacle_ot;
    vm.returnToFianza = returnToFianza;
    vm.changeProvider = changeProvider;
    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;
    vm.changeSubgrouping = changeSubgrouping;
    vm.changeSubsubgrouping = changeSubsubgrouping;
    $scope.infoUser = $sessionStorage.infoUser;
    $scope.campo_agrupacion = false;
    $scope.campo_celula = false;
    $scope.campo_lineanegocio = false;
    $scope.moduleName = "Célula";
    dataFactory.get("orginfo/").then(function success(response) {
      if (response.data.results.length) {
        $scope.configuracionGlobal = response.data.results[0];
        $scope.campo_agrupacion = $scope.configuracionGlobal.filtros_agrupacion;
        $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
        $scope.campo_lineanegocio =
          $scope.configuracionGlobal.filtros_lineanegocio;
        if ($scope.configuracionGlobal.moduleName) {
          $scope.moduleName = $scope.configuracionGlobal.moduleName;
        }
      }
    });
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          vm.acceso_fianza = perm;
          vm.acceso_fianza.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        }
      });
    }
    $scope.pageSelected = 0;
    $scope.infoUser = $sessionStorage.infoUser;

    function showBinnacle(param) {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 13,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_fianza = request.data.results;
          vm.comments_config_fianza = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      vm.fianza_id = param.id;
      vm.show_binnacle_fianza = true;
    }
    function changeSubgroup(subg) {
      vm.form.subgroup = subg;
      vm.subgroup = subg;
      $scope.subsubgroups = subg.subsubgrupos ? subg.subsubgrupos : [];
    }
    function changeSubsubgroup(subg) {
      vm.form.subsubgroup = subg;
      vm.subsubgroup = subg;
    }
    function changeSubgrouping(subgl) {
      vm.form.subgrouping = subgl;
      vm.subgrouping = subgl;
      $scope.subsubgrouping = subgl.subsubgrupos ? subgl.subsubgrupos : [];
    }
    function changeSubsubgrouping(subgl) {
      vm.form.subsubgrouping = subgl;
      vm.subsubgrouping = subgl;
    }
    function showBinnacle_ot(param) {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 13,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_fianza_ot = request.data.results;
          vm.comments_config_fianza_ot = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      vm.fianza_id = param.id;
      vm.show_binnacle_fianza_ot = true;
    }
    function returnToFianza() {
      vm.show_binnacle_fianza = false;
      vm.show_binnacle_fianza_ot = false;
    }
    activate();
    function activate() {
      getCelulasContractor();
      var now = new Date();
      var curr_date = now.getDate();
      var curr_month = now.getMonth() + 1;
      var curr_year = now.getFullYear();
      providerService
        .getProviderFiByKey(curr_year + "-" + curr_month + "-" + curr_date)
        .then(
          function success(data) {
            vm.providers = data.data;
          },
          function error(err) {
            console.log("error", err);
          }
        );
      $scope.pageSelected = 0;
    }
    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    function changeOrder(par, asc) {
      switch (par) {
        case 1:
          search(par, asc, 1);
          vm.order_type_asc = 0;
          vm.order_poliza_asc = asc;
          vm.order_contractor_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          vm.order_ramo_asc = 0;
          break;
        case 2:
          search(par, asc, 1);
          vm.order_poliza_asc = 0;
          vm.order_type_asc = 0;
          vm.order_contractor_asc = asc;
          vm.order_provider_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          vm.order_ramo_asc = 0;
          break;
        case 3:
          search(par, asc, 1);
          vm.order_contractor_asc = 0;
          vm.order_type_asc = 0;
          vm.order_poliza_asc = 0;
          vm.order_provider_asc = asc;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          vm.order_ramo_asc = 0;
          break;
        case 4:
          search(par, asc, 1);
          vm.order_provider_asc = 0;
          vm.order_type_asc = 0;
          vm.order_poliza_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          vm.order_ramo_asc = asc;
          break;
        case 5:
          search(par, asc, 1);
          vm.order_subramo_asc = asc;
          vm.order_type_asc = 0;
          vm.order_poliza_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          vm.order_ramo_asc = 0;
          break;
        case 6:
          search(par, asc, 1);
          vm.order_pay_asc = 0;
          vm.order_type_asc = asc;
          vm.order_poliza_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_status_asc = 0;
          vm.order_vigencia_asc = 0;
          vm.order_ramo_asc = 0;
          break;
        case 7:
          search(par, asc, 1);
          vm.order_status_asc = asc;
          vm.order_type_asc = 0;
          vm.order_poliza_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_vigencia_asc = 0;
          vm.order_ramo_asc = 0;
          break;
        case 8:
          search(par, asc, 1);
          vm.order_vigencia_asc = asc;
          vm.order_type_asc = 0;
          vm.order_poliza_asc = 0;
          vm.order_contractor_asc = 0;
          vm.order_provider_asc = 0;
          vm.order_subramo_asc = 0;
          vm.order_pay_asc = 0;
          vm.order_status_asc = 0;
          vm.order_ramo_asc = 0;
          break;
      }
    }

    function changeOrderOT(par, asc) {
      switch (par) {
        case 1:
          searchOT(par, asc);
          vm.order_otype_asc = 0;
          vm.order_opoliza_asc = asc;
          vm.order_ocontractor_asc = 0;
          vm.order_oprovider_asc = 0;
          vm.order_osubramo_asc = 0;
          vm.order_opay_asc = 0;
          vm.order_ostatus_asc = 0;
          vm.order_ovigencia_asc = 0;
          vm.order_oramo_asc = 0;
          break;
        case 2:
          searchOT(par, asc);
          vm.order_opoliza_asc = 0;
          vm.order_otype_asc = 0;
          vm.order_ocontractor_asc = asc;
          vm.order_oprovider_asc = 0;
          vm.order_osubramo_asc = 0;
          vm.order_opay_asc = 0;
          vm.order_ostatus_asc = 0;
          vm.order_ovigencia_asc = 0;
          vm.order_oramo_asc = 0;
          break;
        case 3:
          searchOT(par, asc);
          vm.order_ocontractor_asc = 0;
          vm.order_otype_asc = 0;
          vm.order_opoliza_asc = 0;
          vm.order_oprovider_asc = asc;
          vm.order_osubramo_asc = 0;
          vm.order_opay_asc = 0;
          vm.order_ostatus_asc = 0;
          vm.order_ovigencia_asc = 0;
          vm.order_oramo_asc = 0;
          break;
        case 4:
          searchOT(par, asc);
          vm.order_oprovider_asc = 0;
          vm.order_otype_asc = 0;
          vm.order_opoliza_asc = 0;
          vm.order_ocontractor_asc = 0;
          vm.order_osubramo_asc = 0;
          vm.order_opay_asc = 0;
          vm.order_ostatus_asc = 0;
          vm.order_ovigencia_asc = 0;
          vm.order_oramo_asc = asc;
          break;
        case 5:
          searchOT(par, asc);
          vm.order_osubramo_asc = asc;
          vm.order_otype_asc = 0;
          vm.order_opoliza_asc = 0;
          vm.order_ocontractor_asc = 0;
          vm.order_oprovider_asc = 0;
          vm.order_opay_asc = 0;
          vm.order_ostatus_asc = 0;
          vm.order_ovigencia_asc = 0;
          vm.order_oramo_asc = 0;
          break;
        case 6:
          searchOT(par, asc);
          vm.order_opay_asc = 0;
          vm.order_otype_asc = asc;
          vm.order_opoliza_asc = 0;
          vm.order_ocontractor_asc = 0;
          vm.order_oprovider_asc = 0;
          vm.order_osubramo_asc = 0;
          vm.order_ostatus_asc = 0;
          vm.order_ovigencia_asc = 0;
          vm.order_oramo_asc = 0;
          break;
        case 7:
          searchOT(par, asc);
          vm.order_ostatus_asc = asc;
          vm.order_otype_asc = 0;
          vm.order_opoliza_asc = 0;
          vm.order_ocontractor_asc = 0;
          vm.order_oprovider_asc = 0;
          vm.order_osubramo_asc = 0;
          vm.order_opay_asc = 0;
          vm.order_ovigencia_asc = 0;
          vm.order_oramo_asc = 0;
          break;
        case 8:
          searchOT(par, asc);
          vm.order_ovigencia_asc = asc;
          vm.order_otype_asc = 0;
          vm.order_opoliza_asc = 0;
          vm.order_ocontractor_asc = 0;
          vm.order_oprovider_asc = 0;
          vm.order_osubramo_asc = 0;
          vm.order_opay_asc = 0;
          vm.order_ostatus_asc = 0;
          vm.order_oramo_asc = 0;
          break;
      }
    }
    $scope.status = function (value) {
      switch (value) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 17:
          return "Anulada";
          break;
        default:
          return "Pendiente";
      }
    };
    function search(order, asc, page) {
      vm.show_pag_search = false;
      vm.search_config = [];
      vm.search_results = [];
      vm.buttonReport = true;
      $scope.busqueda = true;
      var params = {};
      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }

      params = {
        provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider,
        ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
        subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        status: vm.form.status.id ? vm.form.status.id : vm.form.status,
        contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
        classification: vm.form.classification.value
          ? vm.form.classification.value
          : vm.form.classification,
        grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
        subgrupo: vm.form.subgroup.id ? vm.form.subgroup.id : 0,
        subsubgrupo: vm.form.subsubgroup ? vm.form.subsubgroup.id : 0,
        groupinglevel: vm.form.groupinglevel.value
          ? vm.form.groupinglevel.value
          : vm.form.groupinglevel,
        subgrupinglevel: vm.form.subgrouping ? vm.form.subgrouping.id : 0,
        subsubgrupinglevel: vm.form.subsubgrouping
          ? vm.form.subsubgrouping.id
          : 0,
        type_contractor: vm.form.contratante.type
          ? vm.form.contratante.type
          : 0,
        fianza: vm.form.num_poliza ? vm.form.num_poliza : 0,
        celula: cel ? cel : 0,
        inicio_fin: vm.form.inicio_fin,
        order: order,
        asc: asc,
        page: page ? page : 1,
      };
      $scope.actual_page = page ? page : 1;
      if (vm.form.group.val == "") {
        params.grupo = 0;
        vm.form.group.value = "";
        vm.form.group.type = "";
      }
      if (
        vm.form.classification.val == "" ||
        vm.form.classification.val == null ||
        vm.form.classification == undefined
      ) {
        params.classification = 0;
      }
      if (
        $scope.subgroups.length == 0 ||
        vm.form.subgroup.id == "" ||
        vm.form.subgroup.id == null ||
        vm.form.subgroup == undefined
      ) {
        params.subgrupo = 0;
      }
      if (
        $scope.subsubgroups.length == 0 ||
        vm.form.subsubgroup.id == "" ||
        vm.form.subsubgroup.id == null ||
        vm.form.subsubgroup == undefined
      ) {
        params.subsubgrupo = 0;
      }
      if (
        vm.form.groupinglevel.val == "" ||
        vm.form.groupinglevel.val == null ||
        vm.form.groupinglevel == undefined
      ) {
        params.groupinglevel = 0;
      }
      if (
        $scope.subgrouping.length == 0 ||
        vm.form.subgrouping.id == "" ||
        vm.form.subgrouping.id == null ||
        vm.form.subgrouping == undefined
      ) {
        params.subgrupinglevel = 0;
      }
      if (
        $scope.subsubgrouping.length == 0 ||
        vm.form.subsubgrouping.id == "" ||
        vm.form.subsubgrouping.id == null ||
        vm.form.subsubgrouping == undefined
      ) {
        params.subsubgrupinglevel = 0;
      }
      if (vm.form.contratante.val == "") {
        params.contratante = 0;
        vm.form.contratante.value = "";
        vm.form.contratante.type = "";
      }

      params.since = params.since + " " + "00:00:00";
      params.until = params.until + " " + "23:59:59";
      $scope.filtros = params;
      $scope.filtros.page = page ? page : 1;
      $scope.filtros.order = order ? order : 1;
      $scope.filtros.asc = asc ? asc : 1;
      var filter_fianza = "filtros-fianza/";
      $http({
        method: "GET",
        url: url.IP + filter_fianza,
        params: $scope.filtros,
      })
        .then(
          function success(request) {
            if (
              (request.status === 200 || request.status === 201) &&
              request.data.results.length
            ) {
              vm.fianzas = request.data.results;
              vm.search_results = [];
              vm.search_results_ot = [];
              vm.show_results = true;
              vm.show_policy = false;
              var data = request.data.results;
              data.forEach(function (item) {
                if (item.status == 1 || item.status == 2) {
                  vm.search_results_ot.push(item);
                  vm.show_pag_search = false;
                } else {
                  vm.search_results.push(item);
                }
              });
              vm.search_config = {
                count: request.data.count,
                previous: url.IP + filter_fianza,
                next: url.IP + filter_fianza,
              };
              vm.show_pag_search = true;
              $scope.obtenerPaginacion(request.data, page ? page : 1);
              // testPagination('vm.fianzas', 'vm.search_config');
            } else {
              vm.search_results = [];
              vm.fianzas = [];
              toaster.warning("No se encontraron registros de Fianza");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }
    function searchOT(order, asc, page) {
      $scope.actual_pageOT = page ? page : 1;
      $scope.filtrosOT = $scope.filtros;
      $scope.filtrosOT.order = order;
      $scope.filtrosOT.asc = asc;
      $scope.filtrosOT.page = page ? page : 1;
      var filter_fianza_ot = "filtros-fianza-ot/";
      $http({
        method: "GET",
        url: url.IP + filter_fianza_ot,
        params: $scope.filtrosOT,
      })
        .then(
          function success(request) {
            if (
              (request.status === 200 || request.status === 201) &&
              request.data.results.length
            ) {
              vm.fianzas_ot = request.data.results;
              vm.search_results = [];
              vm.search_results_ot = [];
              vm.show_results = true;
              vm.show_policy = false;
              var data = request.data.results;
              data.forEach(function (item) {
                if (item.status == 1 || item.status == 2) {
                  vm.search_results_ot.push(item);
                } else {
                  vm.search_results.push(item);
                }
              });
              vm.search_config_ot = {
                count: request.data.count,
                previous: url.IP + filter_fianza_ot,
                next: url.IP + filter_fianza_ot,
              };
              vm.show_pag_search_ot = true;
              $scope.obtenerPaginacionOT(request.data, page ? page : 1);
              //   testPaginationOT('vm.fianzas_ot', 'vm.search_config_ot');
            } else {
              vm.search_results_ot = [];
              vm.fianzas_ot = [];
              toaster.warning("No se encontraron registros de OTs");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }
    function matchesGroup(parWord, parType) {
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group.val) {
        var word_data = vm.form.group.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, { matchWord: parWord })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  $scope.subgroups = item.subgrupos;
                  $scope.subsubgroups = [];
                  $scope.subgroups.forEach(function (itm) {
                    $scope.subsubgroups = itm.subsubgrupos;
                  });
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }
    function matchesGroupinglevel(parWord, parType) {
      $scope.subgrouping = [];
      $scope.subsubgrouping = [];
      $scope.groupunglevels_data = 0;
      vm.form.subgrouping = 0;
      vm.form.subsubgrouping = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.groupinglevel.val) {
        var word_data = vm.form.groupinglevel.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_grouping = "groupinglevel-match/";
          $http
            .post(url.IP + $scope.show_grouping, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groupinglevels = response.data ? response.data : [];
                groupinglevels.forEach(function (item) {
                  $scope.subsubgrouping = [];
                  $scope.subgrouping.forEach(function (itm) {
                    $scope.subsubgrouping = itm.subsubgrupos;
                  });
                  var obj = {
                    label: item.description,
                    value: item.id,
                    url: item.url,
                    subgrupos: item.subgrupos,
                  };
                  source.push(obj);
                });
                $scope.groupinglevels_data = source;
              }
            });
        }
      }
    }
    function matchesClassification(parWord, parType) {
      $scope.classification_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.classification.val) {
        var word_data = vm.form.classification.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_claass = "classification-match/";
          $http
            .post(url.IP + $scope.show_claass, { matchWord: parWord })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var classifica = response.data;
                classifica.forEach(function (item) {
                  var obj = {
                    label: item.classification_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.classification_data = source;
              }
            });
        }
      }
    }
    $scope.ShowContextMenu = function (name, insurence) {
      $scope.name_for_new_tab = name;
      var route = "fianzas.info";
      if (insurence.document_type == 8) {
        route = "fianzas.details";
      } else {
        route = "fianzas.info";
      }
      $scope.route_for_new_tab = route;
      $scope.id_for_new_tab = insurence.id;
    };
    $scope.open_new_tab = function () {
      var existe = false;
      appStates.states.forEach(function (state) {
        if (
          state.route == $scope.route_for_new_tab &&
          state.id == $scope.id_for_new_tab
        ) {
          existe = true;
        }
      });
      if (appStates.states.length > 3) {
        SweetAlert.swal("Error", "No se pueden abrir más pestañas.", "error");
      } else {
        if (!existe) {
          appStates.states.push({
            id: $scope.id_for_new_tab,
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab, {
              polizaId: $scope.id_for_new_tab,
            }),
          });
          $localStorage.tab_states = appStates.states;
          // $localStorage.tab_index = $localStorage.tab_states.length -1;
        }
      }
    };
    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, { matchWord: parWord })
            .then(function (response) {
              if (response.status === 200 && response.data.contractors) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type: item.type_person == "Física" ? 1 : 2,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type: item.type_person == "Física" ? 1 : 2,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    }
    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      }
      $http.get(url.IP + "ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.ramos = ramos.data;
      });
    }
    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      }
      try {
        vm.subramos = obj.subramo_ramo;
      } catch (e) {}
    }
    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      vm.search(1, 1, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        vm.search(1, 1, $scope.paginacion["paginaActual"] - 1);
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        vm.search(1, 1, $scope.paginacion["paginaActual"] + 1);
      }
    };
    // OTs
    $scope.obtenerPaginacionOT = function (clasificacionOT, pagina) {
      $scope.paginacionOT = {
        count: clasificacionOT["count"],
        previous: clasificacionOT["previous"],
        next: clasificacionOT["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginasOT = Math.ceil($scope.paginacionOT["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginasOT; i++) {
        if ($scope.paginacionOT["totalPaginas"].length <= 5) {
          $scope.paginacionOT["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacionOT["totalPaginas"].length > 5) {
        $scope.paginacionOT["paginaInicio"] =
          $scope.paginacionOT["totalPaginas"] - 5;
      } else {
        $scope.paginacionOT["paginaInicio"] = 1;
      }
      if ($scope.paginacionOT["totalPaginas"].length > 5) {
        $scope.paginacionOT["paginaFin"] = 5;
      } else {
        $scope.paginacionOT["paginaFin"] =
          $scope.paginacionOT["totalPaginas"].length;
      }
    };

    $scope.selecionPaginaOT = function (pagina) {
      vm.searchOT(1, 1, pagina);
    };

    $scope.anteriorPaginaOT = function () {
      if ($scope.paginacionOT["paginaActual"] > 1) {
        vm.searchOT(1, 1, $scope.paginacionOT["paginaActual"] - 1);
      }
    };

    $scope.siguientePaginaOT = function () {
      var numeroPaginasOT = Math.ceil($scope.paginacionOT["count"] / 10);
      if (numeroPaginasOT > $scope.paginacionOT["paginaActual"]) {
        vm.searchOT(1, 1, $scope.paginacionOT["paginaActual"] + 1);
      }
    };
    // fin nueva paginación
    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPagesP = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesP.push(i + 1);
      }
      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesP.length > 5) {
          $scope.end = $scope.totalPagesP.length;
          $scope.start = $scope.totalPagesP.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPageP($scope.totalPagesP.length);
        // $scope.actual_page = $scope.totalPagesP.length;
        // $scope.page = $scope.totalPagesP.length;
      };

      $scope.selectPageP = function (parPage) {
        $scope.actual_page = parPage;
        vm.search($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPagesP = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesP.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesP = function (param) {
        console.log("para", param);
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesP.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesP.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
    function testPaginationOT(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPagesPOT = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesPOT.push(i + 1);
      }
      $scope.lastPagePOT = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesPOT.length > 5) {
          $scope.end = $scope.totalPagesPOT.length;
          $scope.start = $scope.totalPagesPOT.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPagePOT($scope.totalPagesPOT.length);
        // $scope.actual_page = $scope.totalPagesPOT.length;
        // $scope.page = $scope.totalPagesPOT.length;
      };

      $scope.selectPagePOT = function (parPage) {
        $scope.actual_pageOT = parPage;
        vm.searchOT($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPagesPOT = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_pageOT) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesPOT.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesPOT = function (param) {
        $scope.show_prev_block = true;
        if (param) {
          if ($scope.end > $scope.actual_pageOT) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesPOT.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesPOT.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }

    $scope.selectSurety = function (item) {
      if (item.document_type == 8) {
        var name = "Información fianza";
        var route = "fianzas.details";
      } else {
        var name = "Información fianza";
        var route = "fianzas.info";
      }
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }
      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });
        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      if (item.document_type == 8) {
        $state.go("fianzas.details", { polizaId: item.id });
      } else {
        $state.go("fianzas.info", { polizaId: item.id });
      }
    };
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("FianzasInfoCtrl", FianzasInfoCtrl);

  FianzasInfoCtrl.$inject = [
    "$rootScope",
    "datesFactory",
    "toaster",
    "$q",
    "url",
    "dataFactory",
    "$stateParams",
    "$scope",
    "$http",
    "FileUploader",
    "SweetAlert",
    "$sessionStorage",
    "$uibModal",
    "$state",
    "statusReceiptsFactory",
    "$localStorage",
    "emailService",
    "appStates",
    "exportFactory",
  ];

  function FianzasInfoCtrl(
    $rootScope,
    datesFactory,
    toaster,
    $q,
    url,
    dataFactory,
    $stateParams,
    $scope,
    $http,
    FileUploader,
    SweetAlert,
    $sessionStorage,
    $uibModal,
    $state,
    statusReceiptsFactory,
    $localStorage,
    emailService,
    appStates,
    exportFactory
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    vm.getLog = getLog;
    vm.createRecordatorio = createRecordatorio;
    vm.showRecordatorios = showRecordatorios;
    vm.deleteFile = deleteFile;
    vm.viewContractor = viewContractor;

    /* Variables */
    vm.table = {
      headers: [
        "Serie",
        "Prima primera",
        "Derecho",
        "Gastos",
        "Iva",
        "Prima Total",
        "Estatus",
        "Acciones",
        "Vigencia",
      ],
    };

    vm.isCollapsed = false;

    // Function to toggle the collapse state
    vm.toggleCollapse = function () {
      vm.isCollapsed = !vm.isCollapsed;
    };
    // function showEndorsements(insurance) {

    $scope.showEndorsements = function (insurance) {
      vm.infoFlag = false;
      vm.endoFlag = true;

      $http({
        method: "GET",
        url: url.IP + "view-endosos",
        params: {
          policy: insurance.id,
        },
      }).then(function success(response) {
        $scope.endososFianza = response.data.endosos;
      });
    };
    $scope.concept = function (parConcept) {
      switch (parConcept) {
        case 34:
          return "CAMBIOS EN EL BENEFICIARIO";
          break;
        case 53:
          return "DETALLE DE GARANTÍA";
          break;
        case 54:
          return "PRORROGA DE VIGENCIA";
          break;
        case 55:
          return "ANUENCIA";
          break;
        case 58:
          return "AUMENTO";
          break;
        case 59:
          return "DISMINUCIÓN";
          break;
        case 60:
          return "ANULACIÓN";
          break;
        case 61:
          return "CANCELACIÓN";
          break;
        case 58:
          return "AUMENTO";
          break;
        case 24:
          return "ALTA DE CERTIFICADOS";
          break;
        case 25:
          return "BAJA DE CERTIFICADOS";
          break;
        case 56:
          return "CORRECCIÓN DE CERTIFICADOS";
          break;
        case 4:
          return "ENDOSOS TEXTO/OTRO";
          break;
        default:
          return "OTRO";
      }
    };
    $scope.monthEmision = function (parConcept) {
      switch (parConcept) {
        case 0:
          return "";
          break;
        case 1:
          return "Enero";
          break;
        case 2:
          return "Febrero";
          break;
        case 3:
          return "Marzo";
          break;
        case 4:
          return "Abril";
          break;
        case 5:
          return "Mayo";
          break;
        case 6:
          return "Junio";
          break;
        case 7:
          return "Julio";
          break;
        case 8:
          return "Agosto";
          break;
        case 9:
          return "Septiembre";
          break;
        case 10:
          return "Octubre";
          break;
        case 11:
          return "Noviembre";
          break;
        case 12:
          return "Diciembre";
          break;
        default:
          return "";
      }
    };
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          vm.acceso_fianzas = perm;
          vm.acceso_fianzas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            } else if (acc.permission_name == "Cancelar fianzas") {
              if (acc.checked == true) {
                vm.acceso_canc_fia = true;
              } else {
                vm.acceso_canc_fia = false;
              }
            } else if (acc.permission_name == "Eliminar fianzas") {
              if (acc.checked == true) {
                vm.acceso_elim_fia = true;
              } else {
                vm.acceso_elim_fia = false;
              }
            }
          });
        }
        if (perm.model_name == "Endosos") {
          $scope.acceso_endosos = perm;
          $scope.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                $scope.acceso_adm_end = true;
              } else {
                $scope.acceso_adm_end = false;
              }
            }
          });
        }
        if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                vm.acceso_canc_ot = true;
              } else {
                vm.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar OTs") {
              if (acc.checked == true) {
                vm.acceso_elim_ot = true;
              } else {
                vm.acceso_elim_ot = false;
              }
            }
          });
        }
        if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        }
        if (perm.model_name == "Comisiones") {
          vm.acceso_dash = perm;
          vm.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                vm.permiso_administrar_adjuntos = true;
              } else {
                vm.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
        if (perm.model_name == "Cobranza") {
          vm.acceso_cobranza = perm;
          vm.acceso_cobranza.permissions.forEach(function (acc) {
            if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                vm.permiso_delete_cobranza = true;
              } else {
                vm.permiso_delete_cobranza = false;
              }
            }
            if (
              acc.permission_name ==
              "No permitir editar recibos Pagados/Liquidados"
            ) {
              if (acc.checked == true) {
                vm.acceso_pl_cob = true; //no se editan
              } else {
                vm.acceso_pl_cob = false; //se pueden editar pagados-liquidados
              }
            }
          });
        }
        if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.permiso_correo = true;
              } else {
                vm.permiso_correo = false;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          vm.acceso_ref = perm;
          vm.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                vm.acceso_ver_ref = true;
              } else {
                vm.acceso_ver_ref = false;
              }
            }
          });
        }
      });
    }
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };
    function deleteFile(file, container) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este archivo.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            // deleteIT(url, file.id)
            var urls = file.url;
            if (urls == undefined) {
              urls = url.IP + "fianzas-cancel/" + file.id + "/archivos/";
            }
            $http.delete(urls).then(function (response) {
              container.splice(container.indexOf(file), 1);
              SweetAlert.swal(
                "¡Eliminado!",
                "El archivo fue eliminado.",
                "success"
              );
            });
          }
        }
      );
    }
    $scope.saveFile = function (file) {
      var urls = file.url;
      if (urls == undefined) {
        urls = url.IP + "fianzas-cancel/" + file.owner + "/archivos/" + file.id;
      }
      $http.patch(urls, { nombre: file.nombre, sensible: file.sensible });
    };

    /* Funciones */
    vm.changeStatusModal = changeStatusModal;
    vm.cancelFianza = cancelFianza;
    vm.anularFianza = anularFianza;
    vm.rehabilitarFianza = rehabilitarFianza;
    vm.reexpedicion = reexpedicion;
    vm.renovacion = renovacion;
    vm.crearEndoso = crearEndoso;
    vm.deleteFianza = deleteFianza;
    vm.showBinnacleReceipt = showBinnacleReceipt;
    vm.showBinnacleReceiptEndorsement = showBinnacleReceiptEndorsement;

    vm.returnToReceipts = returnToReceipts;
    vm.returnToReceiptsEnd = returnToReceiptsEnd;
    vm.changeEndorsement = changeEndorsement;
    vm.saveAsInsurance = saveAsInsurance;
    vm.checkStatusReceipts = checkStatusReceipts;
    vm.showChange = showChange;
    vm.cancelPolicy = cancelPolicy;
    vm.recordatoriosFlag = false;
    /* Uploader files */
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    function showBinnacleReceipt(param) {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_receipt = request.data.results;
          vm.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      vm.receipt_id = param.id;
      vm.show_binnacle_receipt = true;
    }

    function viewContractor(name, route) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;

      $stateParams.contractor = $scope.contratante;
      if ($scope.contratante.type_person == "Física") {
        $state.go($scope.route_for_new_tab, {
          type: "fisicas",
          contratanteId: vm.insurance.contractor.id,
          contractor: $scope.contratante,
        });
      } else if ($scope.contratante.type_person == "Moral") {
        $state.go($scope.route_for_new_tab, {
          type: "morales",
          contratanteId: vm.insurance.contractor.id,
          contractor: $scope.contratante,
        });
      }
    }

    function showBinnacleReceiptEndorsement(param) {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_receipt_endoso = request.data.results;
          vm.comments_config_endoso = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      vm.receipt_id = param.id;
      vm.show_binnacle_receipt_end = true;
    }

    function createRecordatorio(registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return vm.insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }
    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };
    function showRecordatorios() {
      vm.recordatoriosFlag = true;
    }
    function getLog() {
      dataFactory
        .get("get-specific-log", { model: 13, associated_id: vm.insurance.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    }

    function returnToReceipts() {
      vm.show_binnacle_receipt = false;
    }

    function returnToReceiptsEnd() {
      vm.show_binnacle_receipt_end = false;
    }

    activate();

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 17:
          return "Anulada";
          break;
        case 24:
          return "Pre-anulada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Anulada";
          break;
        case 14:
          return "Vigente";
          break;
        case 13:
          return "Vencida";
          break;
        case 15:
          return "No Renovada";
          break;
        case 0:
          return "Eliminada";
          break;
        default:
          return "Vigente";
      }
    };

    function showChange(endoso) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/infoChange.modal.html",
        controller: "InfoChangeCtrl",
        size: "lg",
        resolve: {
          endoso: function () {
            return endoso;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function activate() {
      vm.infoFlag = true;
      vm.endorsement_receipts_show = [];
      dataFactory
        .get("leer-fianzas-info/" + $stateParams.polizaId)
        .then(function success(response) {
          if (response.status == 200) {
            $http({
              method: "GET",
              url: url.IP + "view-endosos",
              params: {
                policy: response.data.id,
              },
            })
              .then(function success(response_endosos) {
                $scope.endososFianza = response_endosos.data.endosos;
                $scope.endososFianza.forEach(function (endoso) {
                  endoso.endorsement_receipt.forEach(function (recibo) {
                    if (vm.endorsement_receipts_show.indexOf(recibo) == -1) {
                      vm.endorsement_receipts_show.push(recibo);
                    }
                  });
                });
              })
              .catch(function (e) {
                console.log("error", e);
              });
            vm.insurance = response.data;
            $scope.getComments();
            if (vm.insurance.recibos_fianza) {
              vm.insurance.recibos_fianza.forEach(function (r_f, index) {
                if (r_f.status == 1) {
                  r_f.status = "Pagado";
                } else if (r_f.status == 2) {
                  vm.insurance.recibos_fianza[index].status = "Cancelado";
                } else if (r_f.status == 3) {
                  vm.insurance.recibos_fianza[index].status = "Prorrogado";
                } else if (r_f.status == 4) {
                  vm.insurance.recibos_fianza[index].status =
                    "Pendiente de pago";
                } else if (r_f.status == 5) {
                  vm.insurance.recibos_fianza[index].status = "Liquidado";
                } else if (r_f.status == 6) {
                  vm.insurance.recibos_fianza[index].status = "Conciliado";
                } else if (r_f.status == 7) {
                  vm.insurance.recibos_fianza[index].status = "Cerrado";
                } else if (r_f.status == 0) {
                  vm.insurance.recibos_fianza[index].status = "Desactivado";
                } else if (r_f.status == 8) {
                  vm.insurance.recibos_fianza[index].status = "Precancelado";
                } else if (r_f.status == 9) {
                  vm.insurance.recibos_fianza[index].status = "Pago parcial";
                }
              });
            }

            // if(vm.insurance.natural){
            //  $scope.contratante = vm.insurance.natural;
            // } else {
            //   $scope.contratante = vm.insurance.juridical;
            // }
            $scope.contratante = vm.insurance.contractor;

            if (vm.insurance.address) {
              $http.get(vm.insurance.address).then(function success(response) {
                $scope.addressContratante = response.data;
              });
            }

            if (vm.insurance.programa_de_proveedores_contractor) {
              if (vm.insurance.programa_de_proveedores_contractor) {
                $scope.url_programa =
                  vm.insurance.programa_de_proveedores_contractor;
              }
              $http.get($scope.url_programa).then(function (request) {
                $scope.programa = angular.copy(request.data);
              });
            }

            $scope.contrato = vm.insurance.contract_poliza;

            vm.receipts = [];
            for (var i = 0; i < vm.insurance.recibos_poliza.length; i++) {
              for (var j = 0; j < vm.insurance.recibos_poliza.length; j++) {
                if (i + 1 == vm.insurance.recibos_poliza[j].recibo_numero) {
                  if (vm.insurance.recibos_poliza[j].receipt_type == 2) {
                    $scope.show_endosos_receipt = true;
                  }

                  vm.receipts.push(vm.insurance.recibos_poliza[j]);
                }
              }
            }

            if (vm.insurance.recibos_poliza) {
              vm.policy_receipts_show = [];

              vm.insurance.recibos_poliza.forEach(function (receipt) {
                if (
                  receipt.status == 0 ||
                  receipt.status == "0" ||
                  receipt.status == "Desactivado"
                ) {
                  return;
                }
                if (receipt.receipt_type == 1) {
                  vm.policy_receipts_show.push(receipt);
                }
                // else{
                //   if(receipt.receipt_type == 2){
                //     vm.endoso_receipts_show.push(receipt);
                //   }
                //   else{
                //     vm.notes_receipts_show.push(receipt);
                //   }
                //     function findCoincidences(argument) {
                //       return argument === receipt.endo_aux;
                //     }
                //     if(!vm.endosos_options.find(findCoincidences)){
                //       $http.get(receipt.url).then(function success(data) {
                //         receipt = data.data;
                //         vm.endorsement_receipts_show.push(receipt);
                //         vm.endorsement_receipts_show_bak.push(receipt);
                //         if(vm.endosos_options.length == 0){
                //           vm.endosos_options.push(receipt.endo_aux);
                //         }
                //         else{
                //           if(vm.endosos_options.indexOf(receipt.endo_aux) == -1){
                //             vm.endosos_options.push(receipt.endo_aux);
                //           }
                //         }
                //       })
                //     }
                // }
              });
            }

            var params = {
              actual_id: vm.insurance.id,
            };
            dataFactory
              .get("historic-policies/", params)
              .then(function success(response) {
                if (response.data.results.length) {
                  vm.showHistoric = true;
                }
                vm.fianza_history = [];
                response.data.results.forEach(function function_name(old) {
                  if (vm.insurance.id != old.base_policy.id) {
                    vm.fianza_history.push(old.base_policy);
                  } else {
                    vm.fianza_history.push(old.new_policy);
                  }
                });
              });
            $http({
              method: "GET",
              url: url.IP + "comments/",
              params: {
                model: 13,
                id_model: vm.insurance.id,
              },
            })
              .then(function (request) {
                vm.comments_data = request.data.results;
                vm.comments_config = {
                  count: request.data.count,
                  previous: request.data.previous,
                  next: request.data.next,
                };
              })
              .catch(function (e) {
                console.log("e", e);
              });
            vm.insurance.id = vm.insurance.id;
            vm.show_binnacle = true;

            dataFactory
              .get("polizas/" + response.data.id + "/archivos/")
              .then(function success(response) {
                $scope.files = response.data.results;
              });

            dataFactory
              .get("fianzas-cancel/" + response.data.id + "/archivos/")
              .then(function success(response) {
                $scope.filesCancel = response.data.results;
              });
            $scope.getFilesFianza(vm.insurance);
          }
        });
    }

    $scope.openModal = function (task) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/tasks/task.modal.html",
        controller: "TareasModalCtrl",
        size: "lg",
        resolve: {
          task: function () {
            return task;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          receipt: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          activate();
        },
        function () {
          console.info("modal closed");
        }
      );
    };
    $scope.getComments = function () {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 13,
          id_model: vm.insurance.id,
        },
      })
        .then(function (response) {
          $scope.comments_data = response.data.results;
          $scope.comments_config = {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    function exportFianzaComments() {
      if (!vm.insurance || !vm.insurance.id || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
      };

      var params = {
        model: 13,
        id_model: vm.insurance.id,
      };
      if (vm.org_name) {
        params.org = vm.org_name;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: params,
          downloadName: "bitacora-fianzas.xlsx",
          token: token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }

    $scope.getFilesFianza = function (val) {
      dataFactory
        .get("polizas/" + val.id + "/archivos/")
        .then(function success(response) {
          $scope.files = response.data.results;
        });

      dataFactory
        .get("fianzas-cancel/" + val.id + "/archivos/")
        .then(function success(response) {
          $scope.filesCancel = response.data.results;
        });
    };

    function checkStatusReceipts(parStatus) {
      return statusReceiptsFactory.receipts(parStatus);
    }

    function changeEndorsement(endorsement) {
      if (endorsement) {
        vm.endorsement_receipts_show = [];
        vm.endorsement_receipts_show_bak.forEach(function (child) {
          if (child.endo_aux == endorsement) {
            vm.endorsement_receipts_show.push(child);
          }
        });
      } else {
        vm.endorsement_receipts_show = vm.endorsement_receipts_show_bak;
      }
    }
    $scope.goToEndorsementInfo = function (endorsement) {
      // ui-sref="endorsement.details({endosoId: endorsement.id})"
      $scope.open_in_same_tab(
        "Información Endoso",
        "endorsement.details",
        { endosoId: endorsement.id },
        endorsement.id,
        null
      );
    };

    function cancelPolicy(suret) {
      $rootScope.suretyInfo = suret;
      var modalInstance = $uibModal.open({
        templateUrl: "app/fianzas/cancel.fianzas.html",
        controller: FianzaCancelModalCtrl,
        controllerAs: "vmm",
        size: "md",
        resolve: {
          suretyInfo: function () {
            return suret;
          },
          endosos: function () {
            return $scope.endososFianza;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
      // SweetAlert.swal({
      //   title: "Cancelar",
      //   text: "Se cancelará la fianza, ¿Está seguro?",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#DD6B55",
      //   confirmButtonText: "¡Si!",
      //   cancelButtonText: "No",
      //   closeOnConfirm: true,
      //   closeOnCancel: false
      // },
      // function(isConfirm){
      //   if (isConfirm) {
      //     $http.patch(vm.insurance.url,{'status':11})
      //     .then(function(response){
      //       if(response.status == 200 || response.status == 201){
      //         var paramsE = {
      //           'model': 13,
      //           'event': "PATCH",
      //           'associated_id': vm.insurance.id,
      //           'identifier': " canceló la fianza."
      //         }
      //         dataFactory.post('send-log', paramsE);
      //         activate();
      //       }
      //     })
      //     .catch(function(e){
      //       console.log('e', e);
      //     });
      //   }
      // });
    }

    function FianzaCancelModalCtrl(
      url,
      $http,
      $rootScope,
      suretyInfo,
      $scope,
      $uibModalInstance,
      datesFactory,
      endosos
    ) {
      var vmm = this;
      vmm.surety = {
        fecha_cancelacion: datesFactory.convertDate(new Date()),
        monto_cancelacion: 0,
        status: 11,
      };
      console.log("---e", endosos);
      $scope.cancelSurety = function () {
        vmm.surety.fecha_cancelacion = datesFactory.toDate(
          vmm.surety.fecha_cancelacion
        );
        $http.patch(suretyInfo.url, vmm.surety).then(function (data) {
          if (endosos) {
            endosos.forEach(function (end) {
              if (end.status == 2) {
                $http.patch(end.url, { status: 4 }).then(function (dataend) {
                  console.log("patch endo reg to cancel", dataend);
                });
              }
            });
          }
          var paramsE = {
            model: 13,
            event: "PATCH",
            associated_id: suretyInfo.id,
            identifier: " canceló la fianza.",
          };
          dataFactory.post("send-log", paramsE);
          activate();
          $uibModalInstance.dismiss("cancel");
          swal(
            "¡Listo!",
            "Se ha cancelado definitivamente la Fianza",
            "success"
          );
        });
      };

      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.uploader.queue.length) {
        $timeout(function () {
          if ($scope.param == "poliza") {
            SweetAlert.swal("Listo", "Fianza Actualizada", "", "success");
          }
          if ($scope.param == "ot") {
            SweetAlert.swal(
              "¡Listo!",
              "Proyecto de Fianza Actualizada",
              "success"
            );
          }
          $state.go("fianzas.info", { polizaId: polizaId });
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
        order.options.checkDate("initial");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
        order.options.checkDate("initial");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales, renombre y, vuelva a cargarlo. " +
            $scope.specialchar,
          "error"
        );
      }
    };
    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    $scope.saveFiles = function (poliza) {
      $q.all([uploadFiles(poliza)]).then(function () {
        toaster.success("Archivo cargado correctamente");
      });
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $scope.uploader.uploadAll();
    }

    function checkStatusReceipts(parStatus) {
      return statusReceiptsFactory.receipts(parStatus);
    }

    function changeStatusModal(receipt, fianza) {
      receipt.poliza = fianza.fianza_number;
      fianza.poliza = fianza.fianza_number;
      if (fianza.contractor) {
        receipt.contratante = fianza.contractor;
      } else {
        receipt.contratante = "";
      }
      if (vm.insurance.document_type == 7 || vm.insurance.document_type == 8) {
        fianza.document_type = vm.insurance.document_type;
      }
      var index = vm.insurance.recibos_poliza.indexOf(receipt);
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return fianza;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    }

    //---guardar como poliza
    function saveAsInsurance(myInsurance) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/fianzas/otAsFianzaModal.html",
        controller: FianzaPendingModalCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policyModal: function () {
            return vm.insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    }

    //------modal conversion
    function FianzaPendingModalCtrl(
      datesFactory,
      $localStorage,
      $scope,
      toaster,
      MESSAGES,
      policyModal,
      $uibModalInstance,
      dataFactory,
      SweetAlert,
      $state,
      insuranceService,
      receiptService,
      url,
      $http,
      $rootScope,
      emailService,
      helpers
    ) {
      var vmm = this;

      vmm.form = {
        folio: "",
        comisiones: [],
        document_type: policyModal.document_type,
      };

      vmm.options = {
        save: save,
        cancel: cancel,
      };
      vmm.policyInfo = policyModal;
      //
      vmm.id_fianza = policyModal.id;
      $scope.cansamenumberpolicy = false;
      $http({
        method: "GET",
        url: url.IP + "historic-policies/",
        params: {
          actual_id: policyModal.id,
        },
      }).then(function success(response) {
        if (response.data.results.length) {
          vmm.showHistoric = true;
        }
        vmm.policy_history = [];
        vmm.policy_history.renovada = [];
        response.data.results.forEach(function (old) {
          if (old.new_policy.id == vmm.id_fianza) {
            $scope.cansamenumberpolicy = true;
          }
          if (vmm.id_fianza != old.base_policy.id) {
            vmm.policy_history.push(old.base_policy);
          } else {
            vmm.policy_history.push(old.new_policy);
          }
          if (vmm.id_fianza == old.base_policy.id) {
            vmm.policy_history.renovada.push(old.base_policy);
          }
        });
      });
      $scope.changeNoPoliza = function () {
        if (vmm.form.fianza && $scope.cansamenumberpolicy == false) {
          helpers
            .existPolicyNumber(vmm.form.fianza)
            .then(function (request) {
              if (request == true) {
                SweetAlert.swal(
                  "Error",
                  "El número de fianza ya existe.",
                  "error"
                );
                vmm.form.fianza = "";
              }
            })
            .catch(function (err) {});
        }
      };

      $scope.checkFechaFactura = function (date) {
        var date_initial = date.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);
        vmm.form.month.month_selected = parseInt(month);
        vmm.form.year_factura = year;
      };
      $scope.years = [];
      var actualYear = new Date().getFullYear();
      var oldYear = actualYear - 80;
      for (var i = actualYear + 10; i >= oldYear; i--) {
        $scope.years.push(i);
      }

      vmm.form.month = {};
      vmm.form.month.month_selected = 1;
      vmm.form.month.options = [
        { value: 0, label: "" },
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Septiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" },
      ];
      $http
        .get(url.IP + "claves-by-provider/" + vmm.policyInfo.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
                if (vmm.policyInfo.subramo == item.subramo) {
                  vmm.form.comisiones.push(item);
                }
              });
            });
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      vmm.form.startDate = convertDate(vmm.policyInfo.start_of_validity);
      vmm.form.emision_date = datesFactory.convertDate(new Date());
      vmm.form.endingDate = convertDate(vmm.policyInfo.end_of_validity);
      vmm.form.subramo = vmm.policyInfo.subramo;
      vmm.form.subramo = vmm.policyInfo.subramo;
      vmm.form.policy_days_duration = 365;

      function save() {
        var sd = new Date(
          datesFactory.toDate(vmm.policyInfo.recibos_poliza[0].startDate)
        );
        var ed = new Date(
          datesFactory.toDate(vmm.policyInfo.recibos_poliza[0].endingDate)
        );
        var psd = new Date(vmm.policyInfo.start_of_validity);
        var ped = new Date(vmm.policyInfo.end_of_validity);
        if (sd < psd || sd > ped) {
          toaster.error(
            "La fecha de inicio del recibo esta fuera de la fecha de la fianza"
          );
          return;
        }
        if (ed < psd || ed > ped) {
          toaster.error(
            "La fecha de fin del recibo esta fuera de la fecha de la fianza"
          );
          return;
        }
        vmm.form.emision_date = datesFactory.toDate(vmm.form.emision_date);
        $scope.dataFianza = {
          folio: vmm.form.folio,
          poliza_number: vmm.form.fianza,
          status: 14,
          p_neta: vmm.policyInfo.poliza.primaNeta,
          rpf: vmm.policyInfo.poliza.rpf,
          derecho: vmm.policyInfo.poliza.derecho,
          iva: vmm.policyInfo.poliza.iva,
          p_total: vmm.policyInfo.poliza.primaTotal,
          comision: vmm.policyInfo.comision,
          comision_percent: vmm.policyInfo.comision_percent,
          emision_date: vmm.form.emision_date,
          fecha_cancelacion: vmm.policyInfo.fecha_cancelacion,
          monto_cancelacion: vmm.policyInfo.monto_cancelacion,
          date_emision_factura: vmm.form.date_emision_factura
            ? datesFactory.toDate(vmm.form.date_emision_factura)
            : null,
          date_maquila: vmm.form.date_maquila
            ? datesFactory.toDate(vmm.form.date_maquila)
            : null,
          year_factura: vmm.form.year_factura ? vmm.form.year_factura : 0,
          month_factura: vmm.form.month ? vmm.form.month.month_selected : 0,
          folio_factura: vmm.form.folio_factura ? vmm.form.folio_factura : "",
          maquila: vmm.form.maquila
            ? parseFloat(vmm.form.maquila).toFixed(2)
            : 0,
          exchange_rate: vmm.form.exchange_rate
            ? parseFloat(vmm.form.exchange_rate).toFixed(2)
            : 0,
        };

        $http
          .patch(vmm.policyInfo.url, $scope.dataFianza)
          .then(function (response) {
            if (response.status == 200) {
              vmm.policyInfo.recibos_poliza.forEach(function (item) {
                item.fecha_inicio = new Date(
                  datesFactory.toDate(
                    vmm.policyInfo.recibos_poliza[0].startDate
                  )
                );
                item.fecha_fin = new Date(
                  datesFactory.toDate(
                    vmm.policyInfo.recibos_poliza[0].endingDate
                  )
                );
                item.vencimiento = new Date(
                  datesFactory.toDate(
                    vmm.policyInfo.recibos_poliza[0].vencimiento
                  )
                );

                item.poliza = response.data.url;

                dataFactory.post("recibos/", item).then(
                  function success(req) {},
                  function error(error) {
                    console.log(error);
                  }
                );
              });

              $state.go("fianzas.info", { polizaId: response.data.id });
              activate();
              vmm.options.cancel();
              SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWFIANZAOK, "success");
              // location.reload();

              var params = {
                model: 13,
                event: "POST",
                associated_id: response.data.id,
                identifier: "convirtió la OT en fianza.",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }
          });
      }

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }

      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        var date = inputFormat;
        if (inputFormat.length != 10) {
          function pad(s) {
            return s < 10 ? "0" + s : s;
          }
          var d = new Date(inputFormat);
          if (indicator) {
            date = [
              pad(d.getDate() + 1),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          } else {
            date = [
              pad(d.getDate()),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          }
        }
        return date;
      }
    }

    function cancelFianza(fianza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/fianzas/cancel.fianzas.html",
        controller: cancelFianzaModalView,
        controllerAs: "vm",
        size: "lg",
        resolve: {
          fianza: function () {
            return fianza;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (fianza) {
        vm.insurance = fianza;
      });
    }

    $scope.changeFechaCancelacion = function () {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Fecha de cancelación",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              beneficiaries_poliza_many: $scope.benmany,
              monto_cancelacion: vm.insurance.monto_cancelacion,
              fecha_cancelacion: datesFactory.toDate(inputValue),
              status: 11,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la fecha de cancelación.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeMontoCancelacion = function () {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Monto de cancelación",
        text: "Este cambio se aplicará en la fianza.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              beneficiaries_poliza_many: $scope.benmany,
              monto_cancelacion: parseFloat(inputValue).toFixed(2),
              fecha_cancelacion: vm.insurance.fecha_cancelacion,
              status: 11,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó el monto de cancelación.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeFechaComision = function () {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Fecha de Pago de Comisión",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: vm.insurance.status,
              fecha_pago_comision: datesFactory.toDate(inputValue),
              fecha_cancelacion: vm.insurance.fecha_cancelacion,
              monto_cancelacion: vm.insurance.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la fecha de pago de comisión.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeFechaEmisionF = function () {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Fecha Emisión factura",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: vm.insurance.status,
              date_emision_factura: datesFactory.toDate(inputValue),
              fecha_cancelacion: vm.insurance.fecha_cancelacion,
              monto_cancelacion: vm.insurance.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la fecha emisión de factura de comisión.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeFechaMaquila = function () {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Fecha Maquila",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: vm.insurance.status,
              date_maquila: datesFactory.toDate(inputValue),
              fecha_cancelacion: vm.insurance.fecha_cancelacion,
              monto_cancelacion: vm.insurance.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la fecha maquila de fianza.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeFechaEntrega = function () {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Fecha Entrega",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              fecha_entrega: datesFactory.toDate(inputValue),
            })
            .then(function (response) {
              vm.insurance.fecha_entrega = datesFactory.toDate(inputValue);
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la fecha entrega de fianza.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeFechaBono = function () {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Fecha de Bono",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: vm.insurance.status,
              date_bono: datesFactory.toDate(inputValue),
              fecha_cancelacion: vm.insurance.fecha_cancelacion,
              monto_cancelacion: vm.insurance.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la fecha de bono de fianza.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeBono = function () {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Bono Afianzadora",
        text: "Escribe monto del Bono.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: vm.insurance.status,
              bono_variable: parseFloat(inputValue).toFixed(2),
              fecha_cancelacion: vm.insurance.fecha_cancelacion,
              monto_cancelacion: vm.insurance.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la cantidad del bono de fianza.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 10; i >= oldYear; i--) {
      $scope.years.push(i);
    }
    $scope.changeFolioF = function () {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Folio factura",
        text: "Escribe el folio de la factura.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: vm.insurance.status,
              folio_factura: inputValue,
              fecha_cancelacion: vm.insurance.fecha_cancelacion,
              monto_cancelacion: vm.insurance.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó el folio de la factura.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeMaquila = function () {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Maquila",
        text: "Escribe el monto de la Maquila",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: vm.insurance.status,
              maquila: parseFloat(inputValue).toFixed(2),
              fecha_cancelacion: vm.insurance.fecha_cancelacion,
              monto_cancelacion: vm.insurance.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó el monto de la maquila.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeTipoC = function () {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Tipo de Cambio(captura)",
        text: "Escribe el monto de la Tipo de Cambio(captura)",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: vm.insurance.status,
              exchange_rate: parseFloat(inputValue).toFixed(2),
              fecha_cancelacion: vm.insurance.fecha_cancelacion,
              monto_cancelacion: vm.insurance.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó el monto de la Tipo de Cambio(captura).",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.month = {};
    $scope.month.month_selected = 1;
    $scope.month.options = [
      { value: 0, label: "" },
      { value: 1, label: "Enero" },
      { value: 2, label: "Febrero" },
      { value: 3, label: "Marzo" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Mayo" },
      { value: 6, label: "Junio" },
      { value: 7, label: "Julio" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Septiembre" },
      { value: 10, label: "Octubre" },
      { value: 11, label: "Noviembre" },
      { value: 12, label: "Diciembre" },
    ];
    $scope.openMonth = false;
    $scope.changeMesF = function () {
      $scope.openMonth = true;
    };
    $scope.changeMesF1 = function (mes) {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      $scope.openMonth = false;
      $http
        .patch(vm.insurance.url, {
          beneficiaries_poliza_many: $scope.benmany,
          status: vm.insurance.status,
          month_factura: mes,
          fecha_cancelacion: vm.insurance.fecha_cancelacion,
          monto_cancelacion: vm.insurance.monto_cancelacion,
        })
        .then(function (response) {
          SweetAlert.swal(
            "¡Listo!",
            "Fianza actualizada exitosamente.",
            "success"
          );
          activate();
        });
      var paramsRec = {
        model: 13,
        event: "PATCH",
        associated_id: vm.insurance.id,
        identifier: " actualizó el mes emisión de la factura.",
      };
      dataFactory
        .post("send-log/", paramsRec)
        .then(function success(response) {});
    };
    $scope.openYear = false;
    $scope.changYearF = function () {
      $scope.openYear = true;
    };
    $scope.changeYearF1 = function (year) {
      $scope.benmany = vm.insurance.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      $scope.openYear = false;
      $http
        .patch(vm.insurance.url, {
          beneficiaries_poliza_many: $scope.benmany,
          status: vm.insurance.status,
          year_factura: year,
          fecha_cancelacion: vm.insurance.fecha_cancelacion,
          monto_cancelacion: vm.insurance.monto_cancelacion,
        })
        .then(function (response) {
          SweetAlert.swal(
            "¡Listo!",
            "Fianza actualizada exitosamente.",
            "success"
          );
          activate();
        });
      var paramsRec = {
        model: 13,
        event: "PATCH",
        associated_id: vm.insurance.id,
        identifier: " actualizó el año emisión de la factura.",
      };
      dataFactory
        .post("send-log/", paramsRec)
        .then(function success(response) {});
    };
    $scope.changecomission = function (value) {
      var data_alert = {
        title: value == 1 ? "Comisión" : "Porcentaje Comisión",
        text: "Este cambio se aplicará en el recibo y la fianza.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };

      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          if (value == 1) {
            var data = {
              comision: parseFloat(inputValue).toFixed(2),
              comision_percent: (
                (parseFloat(inputValue).toFixed(2) * 100) /
                vm.insurance.p_neta
              ).toFixed(2),
            };
          } else {
            if (parseFloat(inputValue) > 100) {
              SweetAlert.swal(
                "Error",
                "El porcentaje no puede ser mayor a 100%.",
                "error"
              );
              return;
            }
            var data = {
              comision: (
                (vm.insurance.p_neta * parseFloat(inputValue).toFixed(2)) /
                100
              ).toFixed(2),
              comision_percent: parseFloat(inputValue).toFixed(2),
            };
          }
          $scope.benmany = vm.insurance.beneficiaries_poliza_many;
          $scope.benmany.forEach(function (item) {
            try {
              delete item["poliza_many"];
            } catch (e) {}
          });
          data.beneficiaries_poliza_many = $scope.benmany;
          data.monto_cancelacion = vm.insurance.monto_cancelacion;
          data.fecha_cancelacion = vm.insurance.fecha_cancelacion;

          $http.patch(vm.insurance.url, data).then(function (response) {
            SweetAlert.swal(
              "¡Listo!",
              "Comisiones actualizadas exitosamente.",
              "success"
            );
            activate();
          });
          vm.insurance.recibos_poliza.forEach(function (receipt) {
            $http
              .patch(receipt.url, { comision: data.comision })
              .then(function (response) {});
          });
          var paramsRec = {
            model: 18,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la comisión del recibo.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.conducto_de_pago = {};
    $scope.conducto_de_pago.options = [
      { value: 1, label: "No domiciliada" },
      { value: 2, label: "Agente" },
      { value: 3, label: "CAC" },
      { value: 4, label: "CAT/Domiciliado" },
      { value: 5, label: "Nómina" },
      { value: 6, label: "CUT" },
    ];
    $scope.changeDom = false;
    $scope.changedomiciliado = function () {
      $scope.changeDom = true;
    };
    $scope.changedomiciliado1 = function (val) {
      $scope.changeDom = false;
      if (val) {
        var data = {
          conducto_de_pago: val,
        };
        $scope.benmany = vm.insurance.beneficiaries_poliza_many;
        $scope.benmany.forEach(function (item) {
          try {
            delete item["poliza_many"];
          } catch (e) {}
        });
        data.beneficiaries_poliza_many = $scope.benmany;
        data.monto_cancelacion = vm.insurance.monto_cancelacion;
        data.fecha_cancelacion = vm.insurance.fecha_cancelacion;

        $http.patch(vm.insurance.url, data).then(function (response) {
          SweetAlert.swal(
            "¡Listo!",
            "Domiciliación(Conducto de Pago) actualizado exitosamente.",
            "success"
          );
          activate();
        });
        vm.insurance.recibos_poliza.forEach(function (receipt) {
          $http
            .patch(receipt.url, { conducto_de_pago: data.conducto_de_pago })
            .then(function (response) {});
        });
        var paramsRec = {
          model: 18,
          event: "PATCH",
          associated_id: vm.insurance.id,
          identifier:
            " actualizó el conducto de pago(domiciliación) del recibo.",
        };
        dataFactory
          .post("send-log/", paramsRec)
          .then(function success(response) {});
      } else {
        SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
      }
    };
    function reexpedicion(fianza_id) {
      $scope.reexpedir = 1;
      // $state.go('polizas.info', { polizaId: myInsurance.id });
      $state.go("fianzas.reexpedir", {
        polizaId: fianza_id,
        reexpedir: $scope.reexpedir,
      });
    }

    function renovacion(fianza_id) {
      $scope.renovar = 2;
      // $state.go('polizas.info', { polizaId: myInsurance.id });
      $state.go("fianzas.renovar", {
        polizaId: fianza_id,
        renovacion: $scope.renovar,
      });
    }

    function crearEndoso(name, route, fianza_id) {
      $scope.renovar = 2;
      // $state.go('polizas.info', { polizaId: myInsurance.id });

      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      if (route == "endorsement.fianza") {
        $localStorage["save_created_endoso_fianza"] = {};
      }
      $state.go($scope.route_for_new_tab, { fianzaId: fianza_id });
    }

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        // appStates.states.forEach(function(state) {
        //   if (state.route == $scope.route_for_new_tab){
        //     existe = true;
        //   }
        // });
      }

      // if (!existe){
      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    function rehabilitarFianza(suret) {
      $rootScope.suretyInfo = suret;
      var modalInstance = $uibModal.open({
        templateUrl: "app/fianzas/fianza_rehabilitar_modal.html",
        controller: FianzaRehabilitateModalCtrl,
        controllerAs: "ann",
        size: "lg",
        resolve: {
          suretyInfo: function () {
            return suret;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    }

    function FianzaRehabilitateModalCtrl(
      $q,
      url,
      $http,
      $rootScope,
      suretyInfo,
      $scope,
      $uibModalInstance,
      datesFactory,
      toaster
    ) {
      var ann = this;
      ann.suretyInfo = suretyInfo;
      ann.suretyInfo.startValidity = datesFactory.convertDate(
        suretyInfo.start_of_validity
      );
      ann.suretyInfo.endValidity = datesFactory.convertDate(
        suretyInfo.end_of_validity
      );
      ann.suretyInfo.polizaNumber = suretyInfo.poliza_number;

      $http({
        method: "GET",
        url: url.IP + "view-endosos",
        params: {
          policy: ann.suretyInfo.id,
        },
      })
        .then(function success(response) {
          $scope.endososFianza = response.data.endosos;
        })
        .catch(function (e) {
          console.log("error", e);
        });
      // ((1, 'Preanulada'),(2, 'Por error de captura'),(3, 'Por reexpedición'),(4, 'Por falta de pago'), (5, 'Otro(Anulación)'), (0, 'No aplica'))

      $scope.conceptAnnSelection = function (val) {};

      $scope.savesuretyAnnulment = function (suretyA) {
        if (!ann.suretyInfo.reason_rehabilitate) {
          toaster.error("Agrega la razón de rehabilitación");
          return;
        }

        var obj = {
          reason_rehabilitate: ann.suretyInfo.reason_rehabilitate,
          status: 14,
        };

        $q.all([
          $http
            .patch(suretyA.url, obj)
            .then(function (response) {
              if (response.status == 200) {
                var params = {
                  model: 13,
                  event: "PATCH",
                  associated_id: suretyA.id,
                  identifier: " rehabilitó la fianza a un estatus vigente",
                };
                dataFactory.post("send-log/", params);
              }

              if (ann.suretyInfo.recibos_poliza.length > 0) {
                if (
                  ann.suretyInfo.recibos_poliza[0].status == 11 ||
                  ann.suretyInfo.recibos_poliza[0].status == 10
                ) {
                  // Actualizar recibo de fianza a pendiente de pago
                  $http({
                    method: "PATCH",
                    url: ann.suretyInfo.recibos_poliza[0].url,
                    data: {
                      status: 4,
                    },
                  }).then(function success(response) {
                    if (response.status == 200) {
                      var params = {
                        model: 4,
                        event: "PATCH",
                        associated_id: ann.suretyInfo.recibos_poliza[0].id,
                        identifier: " actualizó el recibo a Pre-anulado.",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                      toaster.success(
                        "Recibo de fianza actualizado exitosamente"
                      );
                      // activate();
                    }
                  });
                }
              }

              $scope.endososFianza.forEach(function (endoso) {
                if (endoso.status == 6 || endoso.status == 2) {
                  $http
                    .patch(endoso.url, { status: 2, endorsement_receipt: [] })
                    .then(function (endorsement_updated) {
                      toaster.success("Endoso actualizado");
                    });
                  if (
                    endoso.endorsement_receipt &&
                    endoso.endorsement_receipt[0] &&
                    endoso.endorsement_receipt[0].url
                  ) {
                    if (
                      endoso.endorsement_receipt[0].status == 10 ||
                      endoso.endorsement_receipt[0].status == 11
                    ) {
                      $http({
                        method: "PATCH",
                        url: endoso.endorsement_receipt[0].url,
                        data: { status: 4 },
                      }).then(function (response_endosos_fianza) {
                        if (response_endosos_fianza.status == 200) {
                          var params = {
                            model: 4,
                            event: "PATCH",
                            associated_id: endoso.endorsement_receipt[0].id,
                            identifier: " actualizó el recibo a Pre-anulado.",
                          };
                          dataFactory.post("send-log/", params);
                          toaster.success(
                            "Recibo de endoso actualizado exitosamente."
                          );
                        }
                      });
                    }
                  }
                }
              });
              $uibModalInstance.dismiss("cancel");
            })
            .catch(function (e) {
              console.log("error", e);
            }),
        ]).then(function () {
          activate();
        });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    function anularFianza(suret) {
      $rootScope.suretyInfo = suret;
      var modalInstance = $uibModal.open({
        templateUrl: "app/fianzaGpo/annulment.ChangeModal.html",
        controller: FianzaAnnulmentModalCtrl,
        controllerAs: "ann",
        size: "lg",
        resolve: {
          suretyInfo: function () {
            return suret;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    }

    function FianzaAnnulmentModalCtrl(
      url,
      $http,
      $rootScope,
      suretyInfo,
      $scope,
      $uibModalInstance,
      datesFactory,
      toaster
    ) {
      var ann = this;
      ann.suretyInfo = suretyInfo;
      ann.suretyInfo.startValidity = datesFactory.convertDate(
        suretyInfo.start_of_validity
      );
      ann.suretyInfo.endValidity = datesFactory.convertDate(
        suretyInfo.end_of_validity
      );
      ann.suretyInfo.polizaNumber = suretyInfo.poliza_number;

      $http({
        method: "GET",
        url: url.IP + "view-endosos",
        params: {
          policy: ann.suretyInfo.id,
        },
      })
        .then(function success(response) {
          $scope.endososFianza = response.data.endosos;
        })
        .catch(function (e) {
          console.log("error", e);
        });

      if (ann.suretyInfo.status == 14) {
        ann.conceptAnn = [
          { value: 1, label: "PreAnulada" },
          { value: 2, label: "Por error de captura" },
          { value: 3, label: "Por reexpedición" },
          { value: 4, label: "Por falta de pago" },
          { value: 5, label: "Otro (sólo anular)" },
        ];
      } else {
        ann.conceptAnn = [
          { value: 2, label: "Por error de captura" },
          { value: 3, label: "Por Reexpedición" },
          { value: 4, label: "Por falta de Pago" },
          { value: 5, label: "Otro (Sólo anular)" },
        ];
      }
      // ((1, 'Preanulada'),(2, 'Por error de captura'),(3, 'Por reexpedición'),(4, 'Por falta de pago'), (5, 'Otro(Anulación)'), (0, 'No aplica'))
      ann.conceptAnnulment = ann.conceptAnn[0].value;

      $scope.conceptAnnSelection = function (val) {};

      $scope.savesuretyAnnulment = function (suretyA) {
        if (!ann.suretyInfo.reason_cancel) {
          toaster.error("Agrega la razón de anulación");
          return;
        }

        if (ann.conceptAnnulment == 1) {
          var obj = {
            reason_rehabilitate: null,
            reason_cancel: ann.suretyInfo.reason_cancel,
            concept_annulment: ann.conceptAnnulment,
            status: 24, //PreAnulada
          };

          $http
            .patch(suretyA.url, obj) //Actualizar la fianza a preanulado
            .then(function (response) {
              if (response.status == 200) {
                var params = {
                  model: 13,
                  event: "PATCH",
                  associated_id: suretyA.id,
                  identifier: " actualizó la fianza a Pre-anulado.",
                };
                dataFactory.post("send-log/", params);
              }

              if (ann.suretyInfo.recibos_poliza.length > 0) {
                if (ann.suretyInfo.recibos_poliza[0].status == 4) {
                  // Actualizar recibo de fianza a preanulado
                  $http({
                    method: "PATCH",
                    url: ann.suretyInfo.recibos_poliza[0].url,
                    data: {
                      status: 11,
                    },
                  }).then(function success(response) {
                    if (response.status == 200) {
                      var params = {
                        model: 4,
                        event: "PATCH",
                        associated_id: ann.suretyInfo.recibos_poliza[0].id,
                        identifier: " actualizó el recibo a Pre-anulado.",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                      toaster.success(
                        "Recibo de fianza actualizado exitosamente"
                      );
                      activate();
                    }
                  });
                }
              }

              $scope.endososFianza.forEach(function (endoso) {
                if (endoso.status == 2) {
                  if (endoso.endorsement_receipt[0].status == 4) {
                    // Actualizar recibo de endoso a preanulado
                    $http({
                      method: "PATCH",
                      url: endoso.endorsement_receipt[0].url,
                      data: { status: 11 },
                    }).then(function (response_endosos_fianza) {
                      if (response_endosos_fianza.status == 200) {
                        var params = {
                          model: 4,
                          event: "PATCH",
                          associated_id: endoso.endorsement_receipt[0].id,
                          identifier: " actualizó el recibo a Pre-anulado.",
                        };
                        dataFactory.post("send-log/", params);
                        toaster.success(
                          "Recibo de endoso actualizado exitosamente."
                        );
                      }
                    });
                  }
                }
              });
            })
            .catch(function (e) {
              console.log("error", e);
            });
        } else if (ann.conceptAnnulment == 4) {
          var recibos_pagados_flag = false;
          suretyA.recibos_poliza.forEach(function (rec) {
            if (rec.status == 1) {
              recibos_pagados_flag = true;
            }
          });

          if (recibos_pagados_flag) {
            SweetAlert.swal(
              {
                title: "Anular fianza",
                text: "¿Esta fianza contiene recibos pagados, solo se veran afectados los recibos pendientes de pago, desea continuar?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Anular",
                cancelButtonText: "Cancelar",
                closeOnConfirm: true,
                closeOnCancel: false,
              },
              function (isConfirm) {
                if (isConfirm) {
                  var obj = {
                    reason_rehabilitate: null,
                    reason_cancel: ann.suretyInfo.reason_cancel,
                    concept_annulment: ann.conceptAnnulment,
                    status: 17, //Anulada
                  };

                  $q.all([
                    $http
                      .patch(suretyA.url, obj) //Actualizar la fianza a preanulado
                      .then(function (response) {
                        if (response.status == 200) {
                          var params = {
                            model: 13,
                            event: "PATCH",
                            associated_id: suretyA.id,
                            identifier: " actualizó la fianza a Anulado.",
                          };
                          dataFactory.post("send-log/", params);
                        }

                        if (ann.suretyInfo.recibos_poliza.length > 0) {
                          if (
                            ann.suretyInfo.recibos_poliza[0].status == 4 ||
                            ann.suretyInfo.recibos_poliza[0].status == 11
                          ) {
                            // Actualizar recibo de fianza a preanulado
                            $http({
                              method: "PATCH",
                              url: ann.suretyInfo.recibos_poliza[0].url,
                              data: {
                                status: 10,
                              },
                            }).then(function success(response) {
                              if (response.status == 200) {
                                var params = {
                                  model: 4,
                                  event: "PATCH",
                                  associated_id: response.data.id,
                                  identifier: " actualizó el recibo a Anulado.",
                                };
                                dataFactory
                                  .post("send-log/", params)
                                  .then(function success(response) {});
                                toaster.success(
                                  "Recibo de fianza actualizado exitosamente"
                                );
                                activate();
                              }
                            });
                          }
                        }

                        $scope.endososFianza.forEach(function (endoso) {
                          if (endoso.status == 2) {
                            // Actualizar recibo de endoso a preanulado
                            $http
                              .patch(endoso.url, { status: 6 })
                              .then(function (response_endoso_updated) {
                                if (response.status == 200) {
                                  var params = {
                                    model: 10,
                                    event: "PATCH",
                                    associated_id:
                                      response_endoso_updated.data.id,
                                    identifier:
                                      " actualizó la fianza a Anulado.",
                                  };
                                  dataFactory.post("send-log/", params);
                                  if (
                                    endoso.endorsement_receipt[0].status == 4 ||
                                    ann.suretyInfo.recibos_poliza[0].status ==
                                      11
                                  ) {
                                    $http({
                                      method: "PATCH",
                                      url: endoso.endorsement_receipt[0].url,
                                      data: { status: 10 },
                                    }).then(function (response_endosos_fianza) {
                                      if (
                                        response_endosos_fianza.status == 200
                                      ) {
                                        var params = {
                                          model: 4,
                                          event: "PATCH",
                                          associated_id:
                                            endoso.endorsement_receipt[0].id,
                                          identifier:
                                            " actualizó el recibo a Anulado.",
                                        };
                                        dataFactory.post("send-log/", params);
                                        toaster.success(
                                          "Recibo de endoso actualizado exitosamente."
                                        );
                                      }
                                    });
                                  }
                                }
                              });
                          }
                        });
                      })
                      .catch(function (e) {
                        console.log("error", e);
                      }),
                  ]).then(function () {
                    activate();
                  });
                } else {
                  SweetAlert.swal(
                    "¡Cancelado!",
                    "La fianza no fue anulada",
                    "error"
                  );
                  return;
                }
              }
            );
          } else {
            var obj = {
              reason_rehabilitate: null,
              reason_cancel: ann.suretyInfo.reason_cancel,
              concept_annulment: ann.conceptAnnulment,
              status: 17, //Anulada
            };

            $q.all([
              $http
                .patch(suretyA.url, obj) //Actualizar la fianza a preanulado
                .then(function (response) {
                  if (response.status == 200) {
                    var params = {
                      model: 13,
                      event: "PATCH",
                      associated_id: suretyA.id,
                      identifier: " actualizó la fianza a Anulado.",
                    };
                    dataFactory.post("send-log/", params);
                  }

                  if (ann.suretyInfo.recibos_poliza.length > 0) {
                    if (
                      ann.suretyInfo.recibos_poliza[0].status == 4 ||
                      ann.suretyInfo.recibos_poliza[0].status == 11
                    ) {
                      // Actualizar recibo de fianza a preanulado
                      $http({
                        method: "PATCH",
                        url: ann.suretyInfo.recibos_poliza[0].url,
                        data: {
                          status: 10,
                        },
                      }).then(function success(response) {
                        if (response.status == 200) {
                          var params = {
                            model: 4,
                            event: "PATCH",
                            associated_id: response.data.id,
                            identifier: " actualizó el recibo a Anulado.",
                          };
                          dataFactory
                            .post("send-log/", params)
                            .then(function success(response) {});
                          toaster.success(
                            "Recibo de fianza actualizado exitosamente"
                          );
                          activate();
                        }
                      });
                    }
                  }

                  $scope.endososFianza.forEach(function (endoso) {
                    if (endoso.status == 2) {
                      // Actualizar recibo de endoso a preanulado
                      $http
                        .patch(endoso.url, { status: 6 })
                        .then(function (response_endoso_updated) {
                          if (response.status == 200) {
                            var params = {
                              model: 10,
                              event: "PATCH",
                              associated_id: response_endoso_updated.data.id,
                              identifier: " actualizó la fianza a Anulado.",
                            };
                            dataFactory.post("send-log/", params);
                            if (
                              endoso.endorsement_receipt[0].status == 4 ||
                              ann.suretyInfo.recibos_poliza[0].status == 11
                            ) {
                              $http({
                                method: "PATCH",
                                url: endoso.endorsement_receipt[0].url,
                                data: { status: 10 },
                              }).then(function (response_endosos_fianza) {
                                if (response_endosos_fianza.status == 200) {
                                  var params = {
                                    model: 4,
                                    event: "PATCH",
                                    associated_id:
                                      endoso.endorsement_receipt[0].id,
                                    identifier:
                                      " actualizó el recibo a Anulado.",
                                  };
                                  dataFactory.post("send-log/", params);
                                  toaster.success(
                                    "Recibo de endoso actualizado exitosamente."
                                  );
                                }
                              });
                            }
                          }
                        });
                    }
                  });
                })
                .catch(function (e) {
                  console.log("error", e);
                }),
            ]).then(function () {
              activate();
            });
          }
        } else if (ann.conceptAnnulment == 5) {
          var recibos_pagados_flag = false;
          suretyA.recibos_poliza.forEach(function (rec) {
            if (rec.status == 1) {
              recibos_pagados_flag = true;
            }
          });

          if (recibos_pagados_flag) {
            SweetAlert.swal(
              {
                title: "Anular fianza",
                text: "¿Esta fianza contiene recibos pagados, solo se veran afectados los recibos pendientes de pago, desea continuar?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Anular",
                cancelButtonText: "Cancelar",
                closeOnConfirm: true,
                closeOnCancel: false,
              },
              function (isConfirm) {
                if (isConfirm) {
                  var obj = {
                    reason_rehabilitate: null,
                    reason_cancel: ann.suretyInfo.reason_cancel,
                    concept_annulment: ann.conceptAnnulment,
                    status: 17, //Anulada
                  };

                  $q.all([
                    $http
                      .patch(suretyA.url, obj) //Actualizar la fianza a preanulado
                      .then(function (response) {
                        if (response.status == 200) {
                          var params = {
                            model: 13,
                            event: "PATCH",
                            associated_id: suretyA.id,
                            identifier: " actualizó la fianza a Anulado.",
                          };
                          dataFactory.post("send-log/", params);
                        }

                        if (ann.suretyInfo.recibos_poliza.length > 0) {
                          if (
                            ann.suretyInfo.recibos_poliza[0].status == 4 ||
                            ann.suretyInfo.recibos_poliza[0].status == 11
                          ) {
                            // Actualizar recibo de fianza a preanulado
                            $http({
                              method: "PATCH",
                              url: ann.suretyInfo.recibos_poliza[0].url,
                              data: {
                                status: 10,
                              },
                            }).then(function success(response) {
                              if (response.status == 200) {
                                var params = {
                                  model: 4,
                                  event: "PATCH",
                                  associated_id: response.data.id,
                                  identifier: " actualizó el recibo a Anulado.",
                                };
                                dataFactory
                                  .post("send-log/", params)
                                  .then(function success(response) {});
                                toaster.success(
                                  "Recibo de fianza actualizado exitosamente"
                                );
                                activate();
                              }
                            });
                          }
                        }

                        $scope.endososFianza.forEach(function (endoso) {
                          if (endoso.status == 2) {
                            // Actualizar recibo de endoso a preanulado
                            $http
                              .patch(endoso.url, { status: 6 })
                              .then(function (response_endoso_updated) {
                                if (response.status == 200) {
                                  var params = {
                                    model: 10,
                                    event: "PATCH",
                                    associated_id:
                                      response_endoso_updated.data.id,
                                    identifier:
                                      " actualizó la fianza a Anulado.",
                                  };
                                  dataFactory.post("send-log/", params);
                                  if (
                                    endoso.endorsement_receipt[0].status == 4 ||
                                    ann.suretyInfo.recibos_poliza[0].status ==
                                      11
                                  ) {
                                    $http({
                                      method: "PATCH",
                                      url: endoso.endorsement_receipt[0].url,
                                      data: { status: 10 },
                                    }).then(function (response_endosos_fianza) {
                                      if (
                                        response_endosos_fianza.status == 200
                                      ) {
                                        var params = {
                                          model: 4,
                                          event: "PATCH",
                                          associated_id:
                                            endoso.endorsement_receipt[0].id,
                                          identifier:
                                            " actualizó el recibo a Anulado.",
                                        };
                                        dataFactory.post("send-log/", params);
                                        toaster.success(
                                          "Recibo de endoso actualizado exitosamente."
                                        );
                                      }
                                    });
                                  }
                                }
                              });
                          }
                        });
                      })
                      .catch(function (e) {
                        console.log("error", e);
                      }),
                  ]).then(function () {
                    activate();
                  });
                } else {
                  SweetAlert.swal(
                    "¡Cancelado!",
                    "La fianza no fue anulada",
                    "error"
                  );
                  return;
                }
              }
            );
          } else {
            var obj = {
              reason_rehabilitate: null,
              reason_cancel: ann.suretyInfo.reason_cancel,
              concept_annulment: ann.conceptAnnulment,
              status: 17, //Anulada
            };

            $q.all([
              $http
                .patch(suretyA.url, obj) //Actualizar la fianza a preanulado
                .then(function (response) {
                  if (response.status == 200) {
                    var params = {
                      model: 13,
                      event: "PATCH",
                      associated_id: suretyA.id,
                      identifier: " actualizó la fianza a Anulado.",
                    };
                    dataFactory.post("send-log/", params);
                  }

                  if (ann.suretyInfo.recibos_poliza.length > 0) {
                    if (
                      ann.suretyInfo.recibos_poliza[0].status == 4 ||
                      ann.suretyInfo.recibos_poliza[0].status == 11
                    ) {
                      // Actualizar recibo de fianza a preanulado
                      $http({
                        method: "PATCH",
                        url: ann.suretyInfo.recibos_poliza[0].url,
                        data: {
                          status: 10,
                        },
                      }).then(function success(response) {
                        if (response.status == 200) {
                          var params = {
                            model: 4,
                            event: "PATCH",
                            associated_id: response.data.id,
                            identifier: " actualizó el recibo a Anulado.",
                          };
                          dataFactory
                            .post("send-log/", params)
                            .then(function success(response) {});
                          toaster.success(
                            "Recibo de fianza actualizado exitosamente"
                          );
                          activate();
                        }
                      });
                    }
                  }

                  $scope.endososFianza.forEach(function (endoso) {
                    if (endoso.status == 2) {
                      // Actualizar recibo de endoso a preanulado
                      $http
                        .patch(endoso.url, { status: 6 })
                        .then(function (response_endoso_updated) {
                          if (response.status == 200) {
                            var params = {
                              model: 10,
                              event: "PATCH",
                              associated_id: response_endoso_updated.data.id,
                              identifier: " actualizó la fianza a Anulado.",
                            };
                            dataFactory.post("send-log/", params);
                            if (
                              endoso.endorsement_receipt[0].status == 4 ||
                              ann.suretyInfo.recibos_poliza[0].status == 11
                            ) {
                              $http({
                                method: "PATCH",
                                url: endoso.endorsement_receipt[0].url,
                                data: { status: 10 },
                              }).then(function (response_endosos_fianza) {
                                if (response_endosos_fianza.status == 200) {
                                  var params = {
                                    model: 4,
                                    event: "PATCH",
                                    associated_id:
                                      endoso.endorsement_receipt[0].id,
                                    identifier:
                                      " actualizó el recibo a Anulado.",
                                  };
                                  dataFactory.post("send-log/", params);
                                  toaster.success(
                                    "Recibo de endoso actualizado exitosamente."
                                  );
                                }
                              });
                            }
                          }
                        });
                    }
                  });
                })
                .catch(function (e) {
                  console.log("error", e);
                }),
            ]).then(function () {
              activate();
            });
          }
        } else if (ann.conceptAnnulment == 3 || ann.conceptAnnulment == 2) {
          var obj = {
            reason_rehabilitate: null,
            reason_cancel: ann.suretyInfo.reason_cancel,
            concept_annulment: ann.conceptAnnulment,
          };
          $http.patch(suretyA.url, obj).then(function (response) {
            reexpedicion(suretyA.id);
          });
        }
        $uibModalInstance.dismiss("cancel");
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.addEmailsConfirmPolicy = function (
      insurance,
      natural,
      juridical,
      contractor
    ) {
      // if(natural){
      //   insurance.contratante = natural;
      // }else if(juridical){
      //   insurance.contratante = juridical;
      // }
      insurance.contratante = contractor;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return insurance;
          },
          valueReceipt: function () {
            return insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };

    function cancelFianzaModalView(
      $scope,
      $uibModalInstance,
      fianza,
      url,
      $http,
      toaster,
      MESSAGES
    ) {
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);

      /* Uploader files */
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      //     name: 'customFilter',
      //     fn: function(item, options) {
      //         return this.queue.length < 20;
      //     }
      // });

      $scope.close = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };

      $scope.cancelFianza = function () {
        $scope.userInfo = {
          id: fianza.id,
        };
        $scope.userInfo.url = $scope.uploader.url =
          url.IP + "fianzas-cancel/" + fianza.id + "/archivos/";
        $scope.uploader.uploadAll();

        $http({
          method: "GET",
          url: url.IP + "cancel-fianza/",
          params: {
            status: 11,
            id: fianza.id,
          },
        }).then(function success(response) {
          if (response) {
            var paramsE = {
              model: 13,
              event: "PATCH",
              associated_id: fianza.id,
              identifier: "cancelo la fianza : " + fianza.fianza_number,
            };
            dataFactory.post("send-log", paramsE);
          }
          if ($uibModalInstance) $uibModalInstance.close(response.data);
          if ($localStorage.email_config) {
            emailService.sendEmailAtm(17, vm.insurance.id);
          }
        });
      };

      // ALERTA SUCCES UPLOADFILES
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        toaster.success(MESSAGES.OK.UPLOADFILES);
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        toaster.error(MESSAGES.ERROR.ERRORONUPLOADFILES);
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
          nombre: "",
          // owner: $scope.userInfo.id
        });
        // toaster.success('Archivo cargado correctamente')
      };

      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
      };
    }

    function deleteFianza(id) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "¡Si!",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            // $http.delete(vm.insurance.url)
            $http
              .patch(vm.insurance.url, { status: 0 })
              .then(deleteFianzaComplete)
              .catch(deleteFianzaFailed);

            function deleteFianzaComplete(response, status, headers, config) {
              var paramsE = {
                model: 13,
                event: "PATCH",
                associated_id: id,
                identifier: "elimino la fianza: " + vm.insurance.fianza_number,
              };
              dataFactory.post("send-log", paramsE);
              var data_email = {
                id: vm.insurance.id,
                model: 4,
                type_person: 0,
              };
              dataFactory
                .post("send-email-admins-deletes/", data_email)
                .then(function success(req) {});
              SweetAlert.swal(
                "¡Listo!",
                "La fianza ha sido eliminada",
                "success"
              );

              $state.go("fianzas.list");
            }

            function deleteFianzaFailed(response, status, headers, config) {
              return response;
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La fianza no se ha eliminado",
              "error"
            );
          }
        }
      );
    }

    $scope.editReceipt = function (receipt, index) {
      var texto =
        "Esta es una alternativa de emergencia, No se validarán las primas y ni las fechas al editar este recibo. ¿Deseas continuar?";
      if (
        vm.acceso_pl_cob == false &&
        (receipt.status == 1 || receipt.status == "Pagado")
      ) {
        var texto =
          "Esta es una alternativa de emergencia, No se validarán las primas y ni las fechas al editar este recibo.  \nEstas editando un recibo PAGADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      } else if (
        vm.acceso_pl_cob == false &&
        (receipt.status == 5 || receipt.status == "Liquidado")
      ) {
        var texto =
          "Esta es una alternativa de emergencia, No se validarán las primas y ni las fechas al editar este recibo.  \nEstas editando un recibo LIQUIDADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      }
      if (
        receipt.status == 4 ||
        receipt.status == "Pendiente de pago" ||
        (vm.acceso_pl_cob == false &&
          (receipt.status == 5 ||
            receipt.status == "Liquidado" ||
            receipt.status == 1 ||
            receipt.status == "Pagado"))
      ) {
        SweetAlert.swal(
          {
            title: "Advertencia",
            text: texto,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var modalInstance = $uibModal.open({
                templateUrl: "app/fianzas/receipt-modal.html",
                controller: EditReceiptModalCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  recibo: function () {
                    return receipt;
                  },
                  index: function () {
                    return index;
                  },
                  endoso: function () {
                    return vm.insurance;
                  },
                  acceso_pl_cob: function () {
                    return vm.acceso_pl_cob;
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });
            } else {
              SweetAlert.swal(
                "Cancelado",
                "El recibo no ha sido actualizado",
                "error"
              );
            }
          }
        );
      } else {
        SweetAlert.swal(
          "Advertencia",
          "El recibo no se puede editar porque no esta pendiente de pago.",
          "warning"
        );
      }
    };

    function EditReceiptModalCtrl(
      url,
      $http,
      $rootScope,
      recibo,
      index,
      endoso,
      $scope,
      $uibModalInstance,
      acceso_pl_cob
    ) {
      var rec = this;
      rec.recibo = recibo;
      rec.recibo.fecha_inicio = convertDate(recibo.fecha_inicio);
      rec.recibo.fecha_fin = convertDate(recibo.fecha_fin);
      rec.recibo.vencimiento = convertDate(recibo.vencimiento);
      // $scope.recibo.sub_total = (parseFloat(recibo.prima_neta) + parseFloat(recibo.rpf) + parseFloat(recibo.derecho)).toFixed(2);

      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          var date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          var date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }

        return date;
      }

      function toDate(dateStr) {
        if (dateStr) {
          var dateString = dateStr; // Oct 23
          var dateParts = dateString.split("/");
          var dateObject = new Date(
            dateParts[2],
            dateParts[1] - 1,
            dateParts[0]
          ); // month is 0-based
          return dateObject;
        }
      }

      $scope.validateDecimal = function (form) {
        form = String(form).replace(/[A-Za-z]/g, "");
        form = String(form).replace(/,/g, "");
        return form;
      };

      $scope.changePrimas = function (data) {
        rec.recibo.sub_total = (
          parseFloat(data.prima_neta) +
          parseFloat(data.rpf) +
          parseFloat(data.derecho)
        ).toFixed(2);
        rec.recibo.prima_total = (
          parseFloat(rec.recibo.sub_total) + parseFloat(data.iva)
        ).toFixed(2);
      };
      $scope.habilitate = true;
      $scope.saveReceipt = function (receipt) {
        var obj = {
          fecha_inicio: new Date(toDate(receipt.fecha_inicio)),
          fecha_fin: new Date(toDate(receipt.fecha_fin)),
          prima_neta: receipt.prima_neta,
          rpf: receipt.rpf,
          derecho: receipt.derecho,
          iva: receipt.iva,
          prima_total: receipt.prima_total,
          comision: receipt.comision,
          vencimiento: new Date(toDate(receipt.vencimiento)),
          delivered: receipt.delivered,
        };

        $http.patch(receipt.url, obj).then(function (response) {
          var update_poliza = {
            p_neta: obj.prima_neta,
            p_total: obj.prima_total,
            derecho: obj.derecho,
            rpf: obj.rpf,
            sub_total: response.sub_total,
            iva: obj.iva,
            comision: obj.comision,
          };
          $http.patch(endoso.url, update_poliza).then(function (response) {
            endoso["p_neta"] = response.data["p_neta"];
            endoso["p_total"] = response.data["p_total"];
            endoso["derecho"] = response.data["derecho"];
            endoso["rpf"] = response.data["rpf"];
            endoso["sub_total"] = response.data["sub_total"];
            endoso["iva"] = response.data["iva"];
            endoso["comision"] = response.data["comision"];
          });
          var texto_log = "edito el recibo ";
          if (
            (receipt.status == 1 || receipt.status == "Pagado") &&
            acceso_pl_cob == false
          ) {
            var texto_log = " EDICION DE RECIBO PAGADO";
          }
          if (
            (receipt.status == 5 || receipt.status == "Liquidado") &&
            acceso_pl_cob == false
          ) {
            var texto_log = " EDICION DE RECIBO LIQUIDADO";
          }
          var params = {
            model: 13,
            event: "PATCH",
            associated_id: endoso.id,
            identifier:
              "actualizó el recibo " +
              receipt.recibo_numero +
              texto_log +
              " " +
              ".",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          var params = {
            model: 4,
            event: "POST",
            associated_id: receipt.id,
            identifier: "actualizó el recibo, " + texto_log ? texto_log : ".",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          SweetAlert.swal("Listo", "El recibo ha sido actualizado", "success");
          $scope.cancel();
        });
      };
      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.calculatePrima = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].prima_neta);
        }
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateDerecho = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].rpf);
        }
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateRpf = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].derecho);
        }
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateIva = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].iva);
        }
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateComision = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].comision);
        }
      }
      return total_comision.toFixed(2);
    };
    $scope.calculatePrimaTotal = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          total_comision =
            parseFloat(total_comision) + parseFloat(receipts[i].prima_total);
        }
      }
      return total_comision.toFixed(2);
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("FianzasEditCtrl", FianzasEditCtrl);

  FianzasEditCtrl.$inject = [
    "$q",
    "$rootScope",
    "SweetAlert",
    "insuranceService",
    "$parse",
    "MESSAGES",
    "$state",
    "toaster",
    "url",
    "$http",
    "dataFactory",
    "$stateParams",
    "$sessionStorage",
    "$scope",
    "FileUploader",
    "datesFactory",
    "providerService",
    "$localStorage",
    "emailService",
    "$location",
    "helpers",
    "$uibModal",
  ];

  function FianzasEditCtrl(
    $q,
    $rootScope,
    SweetAlert,
    insuranceService,
    $parse,
    MESSAGES,
    $state,
    toaster,
    url,
    $http,
    dataFactory,
    $stateParams,
    $sessionStorage,
    $scope,
    FileUploader,
    datesFactory,
    providerService,
    $localStorage,
    emailService,
    $location,
    helpers,
    $uibModal
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    // varibles
    vm.show = {
      firstTab: true,
      ot: true,
    };

    vm.org_name = usr.org;
    $scope.create_natural = true;
    $scope.create_juridical = true;

    var dateOffset = 24 * 60 * 60 * 1000 * 1; //1 days
    var now = new Date();
    var endDate = now.setFullYear(now.getFullYear() + 1);
    endDate = new Date(endDate).setTime(
      new Date(endDate).getTime() - dateOffset
    );
    vm.defaults = {};
    vm.form = {
      contratante: "",
      folio: "",
      afianzadora: "",
      start_of_validity: datesFactory.convertDate(new Date()),
      end_of_validity: datesFactory.convertDate(endDate),
      emision: datesFactory.convertDate(new Date()),
      date_emision_factura: "",
      date_maquila: "",
      year_factura: "",
      date_bono: "",
      ceder_comision: false,
      comision_percent: 0.0,
      udi: 0.0,
      vendor: "",
      benefiaciario_seleccionado: "",
      status: 1,
      identifier: "",
    };

    $rootScope.show_contractor = false;

    $scope.dataToSave = {};
    vm.form.referenciadores = [{ referenciador: "" }];
    vm.fianza_history = null;
    vm.fianza_info = null;
    // funciones
    vm.contratanteCreatorModalEvent = contratanteCreatorModalEvent;
    vm.aseguradoraSelection = aseguradoraSelection;
    vm.changeRamo = changeRamo;
    vm.changeSubramo = changeSubramo;
    vm.changeTipo = changeTipo;
    vm.addBene = addBene;
    vm.deleteBene = deleteBene;
    vm.cancel = cancel;
    vm.checkDate = checkDate;
    // diccionarios //
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          vm.acceso_fianzas = perm;
          vm.acceso_fianzas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          vm.acceso_refereciador = perm;
          vm.acceso_refereciador.permissions.forEach(function (acc) {
            if (acc.permission_name == "Cambiar refrenciador en pólizas") {
              if (acc.checked == true) {
                vm.acceso_chng_ref = true;
              } else {
                vm.acceso_chng_ref = false;
              }
            }
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                vm.acceso_ver_ref = true;
              } else {
                vm.acceso_ver_ref = false;
              }
            }
          });
        }
        if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.acceso_dash = perm;
          vm.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }

    /* Watchs */
    $scope.$watch("vm.form.contratante.value", function (newValue, oldValue) {
      if (vm.form.contratante) {
        if (vm.vendors) {
          vm.vendors.some(function (user) {
            if (user.url == vm.form.contratante.value.vendor) {
              if (true) {
                vm.form.vendor = user.id;
                user.name = user.first_name + " " + user.last_name;
                vm.form.vendor = user;
              }
            }
          });
        }

        if (vm.form.contratante.value.j_name) {
          vm.form.contratante.val = vm.form.contratante.value.j_name;
        }

        if (vm.form.contratante.value.full_name) {
          vm.form.contratante.val = vm.form.contratante.value.full_name;
        }

        // if (vm.form.contratante.value.address_natural){
        //     vm.defaults.address = vm.form.contratante.value.address_natural
        // } else{
        //     vm.defaults.address = vm.form.contratante.value.address_juridical
        // }
        vm.defaults.address = vm.form.contratante.value.address_contractor;

        if (vm.form.contratante.value.phone_number) {
          vm.form.contratante.phone_number =
            vm.form.contratante.value.phone_number;
        }

        if (vm.form.contratante.value.email) {
          vm.form.contratante.email = vm.form.contratante.value.email;
        }

        try {
          if (vm.defaults.address.length == 1) {
            vm.form.address = vm.defaults.address[0];
          } else if (vm.defaults.address.length > 1) {
            vm.form.address = vm.defaults.address[0];
          }
        } catch (err) {}
      }
    });

    $scope.checkFechaFactura = function (date) {
      var date_initial = date.split("/");
      var day = date_initial[0];
      var month = date_initial[1];
      var year = parseInt(date_initial[2]);
      vm.form.month.month_selected = parseInt(month);
      vm.form.year_factura = year;
    };

    // funciones iniciales
    var curr_date = now.getDate();
    var curr_month = now.getMonth() + 1;
    var curr_year = now.getFullYear();

    $http.get(url.IP + "usuarios/").then(function (users) {
      $scope.usuarios = users.data.results;
    });

    $scope.renewalSelection = function (ren) {
      $scope.dataToSave.is_renewable = vm.form.renewal.is_renewable;
      if (!$localStorage.save_edition_fianza) {
        $localStorage.save_edition_fianza = angular.copy(vm.form);
      }
      $localStorage.save_edition_fianza["is_renewable"] =
        vm.form.renewal.is_renewable;
    };

    $scope.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 10; i >= oldYear; i--) {
      $scope.years.push(i);
    }
    activate();
    function activate() {
      $scope.esrenovacion = false;
      $scope.reexpedir = 0;
      if ($location.path().indexOf("renovacion") != -1) {
        $scope.titulo_vista = "Renovación";
        $scope.esrenovacion = true;
      } else {
        $scope.titulo_vista = "Edición";
      }

      dataFactory
        .get("leer-fianzas-edit/" + $stateParams.polizaId)
        .then(function success(response) {
          vm.id_fianza = response.data.id;
          $scope.cansamenumberpolicy = false;
          $http({
            method: "GET",
            url: url.IP + "historic-policies/",
            params: {
              actual_id: vm.id_fianza,
            },
          }).then(function success(response) {
            if (response.data.results.length) {
              vm.showHistoric = true;
            }
            vm.policy_history = [];
            vm.policy_history.renovada = [];
            response.data.results.forEach(function (old) {
              if (old.new_policy.id == vm.id_fianza) {
                $scope.cansamenumberpolicy = true;
              }
              if (vm.id_fianza != old.base_policy.id) {
                vm.policy_history.push(old.base_policy);
              } else {
                vm.policy_history.push(old.new_policy);
              }
              if (vm.id_fianza == old.base_policy.id) {
                vm.policy_history.renovada.push(old.base_policy);
              }
            });
          });
          if ($localStorage.save_edition_fianza) {
            if ($localStorage.save_edition_fianza["id"] == response.data.id) {
              vm.form = $localStorage.save_edition_fianza;
              $scope.copy_form = angular.copy(
                $localStorage.save_edition_fianza
              );
            } else {
              vm.form = response.data;
              $scope.copy_form = angular.copy(response.data);
            }
          } else {
            vm.form = response.data;
            $scope.copy_form = angular.copy(response.data);
          }
          vm.form = response.data;
          vm.form.start_of_validity = datesFactory.convertDate(
            response.data["start_of_validity"]
          );
          vm.form.end_of_validity = datesFactory.convertDate(
            response.data["end_of_validity"]
          );
          vm.form.date_emision_factura = response.data["date_emision_factura"]
            ? datesFactory.convertDate(response.data["date_emision_factura"])
            : "";
          vm.form.date_bono = response.data["date_bono"]
            ? datesFactory.convertDate(response.data["date_bono"])
            : "";
          vm.form.date_maquila = response.data["date_maquila"]
            ? datesFactory.convertDate(response.data["date_maquila"])
            : "";
          vm.form.renewal = {};
          if (
            $localStorage.save_edition_fianza &&
            $localStorage.save_edition_fianza["id"] == vm.form.id
          ) {
            vm.form.renewal.is_renewable =
              $localStorage.save_edition_fianza["is_renewable"];
          } else {
            vm.form.renewal.is_renewable = vm.form.is_renewable
              ? vm.form.is_renewable
              : 2;
          }
          vm.form.renewal.options = [
            { value: 1, label: "Renovable" },
            { value: 2, label: "No Renovable" },
          ];
          if ($stateParams.renovacion && $stateParams.renovacion == 2) {
            var end_date_aux = datesFactory.toDate(vm.form.end_of_validity);
            vm.form.start_of_validity = vm.form.end_of_validity;

            var end_date_aux = end_date_aux.setFullYear(
              end_date_aux.getFullYear() + 1
            );

            var dateOffset = 24 * 60 * 60 * 1000 * 1; //1 days
            end_date_aux = new Date(end_date_aux).setTime(
              new Date(end_date_aux).getTime() - dateOffset
            );

            var endDate = end_date_aux;

            vm.form.end_of_validity = datesFactory.convertDate(end_date_aux);
            vm.form.status = 1;
            vm.form.internal_number = "";
          }
          if (
            $localStorage.save_edition_fianza &&
            $localStorage.save_edition_fianza["id"] == vm.form.id
          ) {
            vm.form.bono_variable =
              $localStorage.save_edition_fianza["bono_variable"];
          } else {
            vm.form.bono_variable = response.data.bono_variable;
          }

          $scope.showPrograma = vm.form.has_programa_de_proveedores;
          if (vm.form.programa_de_proveedores_contractor) {
            if (vm.form.programa_de_proveedores_contractor) {
              $scope.url_solidario = vm.form.programa_de_proveedores_contractor;
            }
            $http.get($scope.url_solidario).then(function (request) {
              vm.contratante = {};
              if (request.data.address_contractor) {
                vm.contratante.val = request.data.full_name;
                vm.contratante.value = request.data;
              }
            });
          }

          if ($stateParams.reexpedir && $stateParams.reexpedir == 1) {
            $scope.reexpedir = $stateParams.reexpedir;
            dataFactory
              .get("leer-fianzas-info/" + $stateParams.polizaId)
              .then(function success(response) {
                vm.fianza_info = response.data;
                if (response.status == 200) {
                  $http({
                    method: "GET",
                    url: url.IP + "view-endosos",
                    params: {
                      policy: response.data.id,
                    },
                  })
                    .then(function success(response_endosos) {
                      $scope.endososFianza = response_endosos.data.endosos;
                    })
                    .catch(function (e) {
                      console.log("error", e);
                    });

                  dataFactory
                    .get("historic-policies/", { actual_id: response.data.id })
                    .then(function success(response_historic) {
                      response_historic.data.results.forEach(
                        function function_name(old) {
                          if (response.data.id == old.new_policy.id) {
                            vm.fianza_history = old.base_policy;
                          }
                        }
                      );
                    });
                }
              });
          }

          // vm.form.emision_date = datesFactory.convertDate(new Date());
          vm.form.emision_date = response.data["emision_date"]
            ? datesFactory.convertDate(response.data["emision_date"])
            : datesFactory.convertDate(new Date());
          if (
            $localStorage.save_edition_fianza &&
            $localStorage.save_edition_fianza["id"] == vm.form.id
          ) {
            vm.form.tipo = $localStorage.save_edition_fianza["tipo"];
          } else {
            vm.form.tipo = vm.form.fianza_type;
          }
          delete vm.form.fianza_type;
          vm.form.currency = {};
          vm.form.currency.options = [
            { value: 1, label: "PESOS" },
            { value: 2, label: "DOLARES" },
          ];

          vm.form.month = {};
          vm.form.month.options = [
            { value: 0, label: "" },
            { value: 1, label: "Enero" },
            { value: 2, label: "Febrero" },
            { value: 3, label: "Marzo" },
            { value: 4, label: "Abril" },
            { value: 5, label: "Mayo" },
            { value: 6, label: "Junio" },
            { value: 7, label: "Julio" },
            { value: 8, label: "Agosto" },
            { value: 9, label: "Septiembre" },
            { value: 10, label: "Octubre" },
            { value: 11, label: "Noviembre" },
            { value: 12, label: "Diciembre" },
          ];

          vm.form.month.month_selected = response.data["month_factura"];

          if ($localStorage.save_edition_fianza) {
            if (
              $localStorage.save_edition_fianza &&
              $localStorage.save_edition_fianza["id"] == vm.form.id
            ) {
              vm.form.currency.currency_selected =
                $localStorage.save_edition_fianza["currency"][
                  "currency_selected"
                ];
            } else {
              vm.form.currency.currency_selected = response.data["f_currency"];
            }
          } else {
            vm.form.currency.currency_selected = response.data["f_currency"];
          }

          vm.form.contratante = {};
          vm.defaults.address = vm.form.contractor.address_contractor;
          vm.form.contratante.value = vm.form.contractor;
          vm.form.contratante.val = vm.form.contractor.full_name;
          // }
          if (vm.form.address) {
            $http.get(vm.form.address).then(function (addressResponse) {
              vm.form.address = addressResponse.data;
            });
          } else {
            toaster.error(
              "Sin dirección en la Fianza, se tomará la primera del Fiado"
            );
          }

          // vm.form.referenciadores = vm.form.ref_policy ? vm.form.ref_policy : $scope.usuarios;
          vm.form.referenciadores = [];
          vm.form.subforms = {};
          $http
            .get(url.IP + "get-vendors/")
            .then(function (user) {
              $scope.referenciadores = user.data;
              var vendedor = {
                referenciador: "",
                comision_vendedor: "",
              };
              $scope.referenciador = vendedor;
              // vm.form.referenciadores.push(vendedor);
            })
            .catch(function (e) {
              console.log("error", e);
            });
          // Referenciadores
          if (vm.form.ref_policy) {
            if (vm.form.ref_policy.length > 0) {
              vm.form.ref_policy.forEach(function (refs) {
                $http
                  .get(refs.referenciador)
                  .then(function success(response_ref_plicy) {
                    if (response_ref_plicy) {
                      refs.data = response_ref_plicy.data;
                      refs.referenciador = response_ref_plicy.data.url;
                      refs.selectedRef = true;
                      vm.form.referenciadores.push(refs);
                    }
                  });
              });
            } else {
              vm.form.referenciadores.push($scope.referenciador);
            }
          } else {
            vm.form.referenciadores.push($scope.referenciador);
          }
          // Referenciadores---
          if ($localStorage.save_edition_fianza) {
            if (
              $localStorage.save_edition_fianza &&
              $localStorage.save_edition_fianza["id"] == vm.form.id
            ) {
              vm.form.subforms.contract =
                $localStorage.save_edition_fianza["contract_poliza"];
            } else {
              vm.form.subforms.contract = vm.form.contract_poliza;
            }
          } else {
            vm.form.subforms.contract = vm.form.contract_poliza;
          }
          // vm.form.renewal.is_renewable = vm.form.is_renewable;
          try {
            vm.form.subforms.contract.amount = parseFloat(
              vm.form.subforms.contract.amount
                ? vm.form.subforms.contract.amount
                : 0
            );
          } catch (err) {}
          try {
            vm.form.subforms.contract.amount_iva = parseFloat(
              vm.form.subforms.contract.amount_iva
            );
          } catch (err) {}
          try {
            vm.form.subforms.contract.guarantee_amount = parseFloat(
              vm.form.subforms.contract.guarantee_amount
                ? vm.form.subforms.contract.guarantee_amount
                : 0
            );
          } catch (err) {}
          try {
            vm.form.subforms.contract.guarantee_percentage = parseFloat(
              vm.form.subforms.contract.guarantee_percentage
            );
          } catch (err) {}
          try {
            vm.form.subforms.contract.no_employees = parseFloat(
              vm.form.subforms.contract.no_employees
            );
          } catch (err) {}
          try {
            vm.form.subforms.contract.number_inclusion = parseFloat(
              vm.form.subforms.contract.number_inclusion
            );
          } catch (err) {}
          try {
            vm.form.subforms.contract.rate = parseFloat(
              vm.form.subforms.contract.rate
            );
          } catch (err) {}
          try {
            vm.form.subforms.contract.deductible_percentage = parseFloat(
              vm.form.subforms.contract.deductible_percentage
            );
          } catch (err) {}

          try {
            vm.form.subforms.contract.start = datesFactory.convertDate(
              vm.form.subforms.contract.start
            );
            vm.form.subforms.contract.end = datesFactory.convertDate(
              vm.form.subforms.contract.end
            );
            vm.form.subforms.contract.sign_date = datesFactory.convertDate(
              vm.form.subforms.contract.sign_date
            );
          } catch (err) {
            console.log("***********", vm.form.subforms.contract);
          }
          vm.form.subforms.beneficiaries_fianza =
            vm.form.beneficiaries_poliza_many;
          if (vm.form.subforms.beneficiaries_fianza.length == 0) {
            vm.form.subforms.beneficiaries_fianza = [
              {
                first_name: "",
                last_name: "",
                second_last_name: "",
                j_name: "",
                rfc: "",
                email: "",
                phone_number: "",
                type_person: 1,
              },
            ];
          }

          dataFactory
            .get("polizas/" + $stateParams.polizaId + "/archivos/")
            .then(function success(response) {
              if ($stateParams.renovacion && $stateParams.renovacion == 2) {
                $scope.files = [];
              } else {
                $scope.files = response.data.results;
              }
            });

          dataFactory
            .get("ramos-by-provider/" + vm.form.aseguradora)
            .then(
              function success(response) {
                vm.defaults.ramos = response.data;
                vm.defaults.ramos.forEach(function (ramo) {
                  if (ramo.id == vm.form.ramo.id) {
                    vm.defaults.subramos = ramo.subramo_ramo;
                    vm.changeSubramo();
                    vm.defaults.subramos.forEach(function (subramo) {
                      if (subramo.id == vm.form.subramo.id) {
                        vm.defaults.types = subramo.type_subramo;
                      }
                    });
                  }
                });
              },
              function error(e) {
                console.log("Error - ramos-by-provider", e);
              }
            )
            .catch(function (error) {
              console.log("Error - ramos-by-provider - catch", error);
            });

          dataFactory
            .get("afianzadoras/" + vm.form.aseguradora)
            .then(function success(response) {
              vm.form.aseguradora = response.data;
              get_claves();
            });
        });

      insuranceService.getVendors().then(
        function success(data) {
          vm.vendors = data.data;
          vm.vendors.forEach(function (vendor) {
            vendor.name = vendor.first_name + " " + vendor.last_name;
          });
        },
        function error(error) {
          SweetAlert.swal(
            "No pudieron ser cargados referenciadores",
            "",
            "error"
          );
        }
      );

      var curr_date = now.getDate();
      var curr_month = now.getMonth() + 1;
      var curr_year = now.getFullYear();
      providerService
        .getProviderFiByKey(curr_year + "-" + curr_month + "-" + curr_date)
        .then(
          function success(data) {
            vm.defaults.providers = data.data;
          },
          function error(err) {
            console.log("error", err);
          }
        );
    }

    $scope.save_info_tab = function () {
      if (!$localStorage.save_edition_fianza) {
        $localStorage.save_edition_fianza = angular.copy(vm.form);
      }
      $localStorage.save_edition_fianza["contract_poliza"] =
        vm.form.subforms.contract;
    };

    $scope.changeFolio = function () {
      if (!$localStorage.save_edition_fianza) {
        $localStorage.save_edition_fianza = angular.copy(vm.form);
      }
      $localStorage.save_edition_fianza["internal_number"] =
        $scope.surety.internal_number;
    };

    $scope.changeProgram = function (param) {
      $scope.showPrograma = param;
    };

    $scope.checkNumFianza = function () {
      if (vm.form.poliza_number) {
        if ($scope.copy_form.poliza_number != vm.form.poliza_number) {
          if ($scope.cansamenumberpolicy) {
            console.log("viene de renovación", $scope.cansamenumberpolicy);
          } else {
            helpers
              .existPolicyNumber(vm.form.poliza_number)
              .then(function (request) {
                if (request == true) {
                  SweetAlert.swal(
                    "Error",
                    "El número de fianza ya existe.",
                    "error"
                  );
                  vm.form.poliza_number = "";
                }
              })
              .catch(function (err) {});
          }
        } else {
          if (!$localStorage.save_edition_fianza) {
            $localStorage.save_edition_fianza = angular.copy(vm.form);
          }
          $localStorage.save_edition_fianza["poliza_number"] =
            vm.form.poliza_number;
        }
      }
    };

    $scope.agregarBeneficiario = function (parWord) {
      var beneficiario = parWord.value;
      if (vm.form.subforms.beneficiaries_fianza.length == 1) {
        if (
          vm.form.subforms.beneficiaries_fianza[0].first_name == "" &&
          vm.form.subforms.beneficiaries_fianza[0].j_name == "" &&
          vm.form.subforms.beneficiaries_fianza[0].rfc == "" &&
          vm.form.subforms.beneficiaries_fianza[0].email == ""
        ) {
          vm.form.subforms.beneficiaries_fianza[0] = beneficiario;
        } else {
          vm.form.subforms.beneficiaries_fianza.push({
            first_name: beneficiario.first_name,
            last_name: beneficiario.last_name,
            second_last_name: beneficiario.second_last_name,
            j_name: beneficiario.j_name,
            rfc: beneficiario.rfc,
            email: beneficiario.email,
            phone_number: beneficiario.phone_number,
            type_person: beneficiario.type_person,
            url: beneficiario.url,
            id: beneficiario.id,
          });
        }

        // vm.form.subforms.beneficiaries_fianza[0] = beneficiario;
      } else {
        vm.form.subforms.beneficiaries_fianza.push({
          first_name: beneficiario.first_name,
          last_name: beneficiario.last_name,
          second_last_name: beneficiario.second_last_name,
          j_name: beneficiario.j_name,
          rfc: beneficiario.rfc,
          email: beneficiario.email,
          phone_number: beneficiario.phone_number,
          type_person: beneficiario.type_person,
          url: beneficiario.url,
          id: beneficiario.id,
        });
      }
    };

    function checkDate(parDate) {
      if (parDate == "initial") {
        var dateOffset = 24 * 60 * 60 * 1000 * 1; //1 days
        var now = datesFactory.toDate(vm.form.start_of_validity);
        var endDate = now.setFullYear(now.getFullYear() + 1);
        vm.form.end_of_validity = datesFactory.convertDate(
          new Date(endDate).setTime(new Date(endDate).getTime() - dateOffset)
        );
      }
    }

    function contratanteCreatorModalEvent() {
      $rootScope.show_contractor = true;
      $scope.orderInfo = vm;
      $localStorage.orderForm = JSON.stringify(vm.form);
    }

    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = 0;
      var word_data = vm.form.contratante.val;
      if (word_data) {
        if (word_data.length >= 3) {
          if (vm.org_name == "ancora") {
            $scope.show_contratante = "contractors-match-fianzas/";
          } else {
            $scope.show_contratante = "contractors-match/";
          }
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
            })
            .then(function (response) {
              // if(response.status === 200 && (response.data.juridicals || response.data.naturals)) {
              if (response.status === 200 && response.data.contractors) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
        $scope.contractors_data = [];
      }
    };

    $scope.matchesBeneficiary = function (parWord) {
      $scope.beneficiaries_data = [];
      var word_data = parWord;
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_contratante = "BeneficiariesExistentes/";
          // $http.post(url.IP + $scope.show_contratante,
          //   {
          //     'matchWord': parWord
          //   })
          $http({
            method: "GET",
            url: url.IP + $scope.show_contratante,
            params: {
              matchWord: parWord,
            },
          }).then(function (response) {
            if (response.status === 200) {
              response.data.results.forEach(function (item) {
                $scope.beneficiaries_data.push({
                  label: item.type_person == 1 ? item.full_name : item.j_name,
                  value: item,
                });
              });
            }
          });
        }
      }
    };

    function aseguradoraSelection() {
      if (vm.form.aseguradora) {
        get_claves();
      }

      $http
        .get(url.IP + "ramos-by-provider/" + vm.form.aseguradora.id)
        .then(
          function success(response) {
            vm.defaults.ramos = response.data;
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    }

    function get_claves() {
      var date = new Date(vm.form.start_of_validity);
      if (isNaN(date)) {
        var date = new Date(datesFactory.mesDiaAnio(vm.form.start_of_validity));
      }
      if (vm.form.aseguradora && vm.form.aseguradora.id) {
        $http
          .get(url.IP + "claves-by-provider/" + vm.form.aseguradora.id)
          .then(
            function success(clavesResponse) {
              clavesResponse.data.forEach(function (clave) {
                clave.clave_comision.forEach(function (item) {
                  item.efective_date = new Date(item.efective_date)
                    .toISOString()
                    .split("T")[0];
                });
              });

              vm.defaults.claves = clavesResponse.data;
              if (vm.defaults.claves.length == 1) {
                vm.form.clave = vm.defaults.claves[0];
                try {
                  vm.form.comision_percent = vm.form.clave.comission;
                  vm.form.udi = vm.form.clave.udi;
                } catch (e) {}
              }
            },
            function error(e) {
              console.log("Error - claves-by-provider", e);
            }
          )
          .catch(function (error) {
            console.log("Error - claves-by-provider - catch", error);
          });
      }
    }

    function changeRamo() {
      vm.defaults.subramos = vm.form.ramo.subramo_ramo;
      vm.defaults.subramos.forEach(function (subramo, index) {
        if (subramo.subramo_name == "Colectivas") {
          vm.defaults.subramos.splice(index, 1);
        }
      });
    }

    function changeSubramo(s) {
      if (vm.form.subramo) {
        vm.defaults.types = vm.form.subramo.type_subramo;
        get_claves();
      }

      vm.defaults.formInfo = {
        code: vm.form.subramo.subramo_code,
        name: vm.form.subramo.subramo_name,
      };
      vm.defaults.comisiones = [];

      if (vm.form.clave) {
        if (vm.form.clave.clave_comision.length) {
          vm.form.clave.clave_comision.forEach(function (item) {
            if (vm.form.subramo.subramo_name == item.subramo) {
              vm.defaults.comisiones.push(item);
            }
          });

          if (vm.defaults.comisiones) {
            if (!vm.defaults.comisiones.length) {
              SweetAlert.swal(
                {
                  title: "Error",
                  text: "Debe tener al menos una comisión capturada para la clave seleccionada",
                  type: "error",
                  showCancelButton: false,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Aceptar",
                  cancelButtonText: "Cancelar",
                  closeOnConfirm: true,
                },
                function (isConfirm) {
                  if (isConfirm) {
                  }
                }
              );
            }
          }

          if (vm.defaults.comisiones.length == 1) {
            vm.form.comision = vm.defaults.comisiones[0];
          }
        }
      }
    }

    function changeTipo(tipo) {
      if (!$localStorage.save_edition_fianza) {
        $localStorage.save_edition_fianza = angular.copy(vm.form);
      }
      $localStorage.save_edition_fianza["tipo"] = tipo;
    }

    $scope.changeCurrency = function () {
      if (!$localStorage.save_edition_fianza) {
        $localStorage.save_edition_fianza = angular.copy(vm.form);
      }
      $localStorage.save_edition_fianza["currency"] = vm.form.currency;
    };

    $scope.changeBono = function (param) {
      if (!$localStorage.save_edition_fianza) {
        $localStorage.save_edition_fianza = angular.copy(vm.form);
      }
      $localStorage.save_edition_fianza["bono_variable"] = param;
    };

    $scope.addReferenciador = function (type) {
      var addReferenciadores = {
        referenciador: "",
      };
      vm.form.referenciadores.push(addReferenciadores);
    };

    $scope.deleteReferenciador = function (index, type) {
      vm.form.referenciadores.splice(index, 1);
    };

    function addBene() {
      var beneficiario = {
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        type_person: 1,
      };
      vm.form.subforms.beneficiaries_fianza.push(beneficiario);
    }

    function deleteBene(index) {
      if (vm.form.subforms.beneficiaries_fianza.length > 1) {
        vm.form.subforms.beneficiaries_fianza.splice(index, 1);
      }
    }
    $scope.formatearNumero = function (nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";

      var cadenas = x1.split(",");
      var cadena_sin_comas = "";
      for (i = 0; i < cadenas.length; i++) {
        cadena_sin_comas = cadena_sin_comas + cadenas[i];
      }
      if (
        cadena_sin_comas != undefined &&
        cadena_sin_comas != "undefined" &&
        cadena_sin_comas != "NaN" &&
        cadena_sin_comas != NaN
      ) {
        return cadena_sin_comas + x2;
      } else {
        return nStr;
      }
    };
    $scope.validateDecimalMontoTotal = function (input) {
      if (parseFloat(input) < 0) {
        vm.form.subforms.contract.value = 0;
        vm.form.subforms.contract.amount_iva = 0;
      } else {
        vm.form.subforms.contract.value = parseFloat(input).toFixed(2);
        var valor_am = parseFloat(
          $scope.formatearNumero(vm.form.subforms.contract.amount)
        ).toFixed(2);
        if (vm.form.subforms.contract.amount) {
          if (valor_am == "NaN") {
            toaster.error("Revise el formato del Monto del Contrato.");
            vm.form.subforms.contract.amount_iva = parseFloat(0).toFixed(2);
            return;
          } else if (valor_am) {
            vm.form.subforms.contract.amount_iva = parseFloat(
              parseFloat(parseFloat(valor_am) * 0.16) + parseFloat(valor_am)
            ).toFixed(2);
          }
        }
      }

      if (!$localStorage.save_edition_fianza) {
        $localStorage.save_edition_fianza = angular.copy(vm.form);
      }
      $localStorage.save_edition_fianza["contract_poliza"] =
        vm.form.subforms.contract;
    };

    $scope.percentageRange = function (input) {
      if (parseFloat(input) < 0) {
        vm.form.tarifa = 0;
      }
      if (parseFloat(input) > 100) {
        vm.form.tarifa = 100;
      }
      if (input.toString().length > 5) {
        vm.form.tarifa = parseFloat(input.toFixed(2));
      }
      if (!$localStorage.save_edition_fianza) {
        $localStorage.save_edition_fianza = angular.copy(vm.form);
      }
      $localStorage.save_edition_fianza["contract_poliza"] =
        vm.form.subforms.contract;
    };

    $scope.matchesShows = function (parWord) {
      if (parWord) {
        if (parWord.length >= 3) {
          if (vm.org_name == "ancora") {
            $scope.show_contratante = "contractors-match-fianzas/";
          } else {
            $scope.show_contratante = "contractors-match/";
          }
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: false,
              pp: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("vm.contratante.value", function (newValue, oldValue) {
      if (vm.contratante) {
        if (vm.contratante.value.address_contractor) {
          if (vm.contratante.value.address_contractor) {
            $scope.programa_contractor = vm.contratante.value.url;
            $scope.has_programa_de_proveedores = true;
          }
        }
      }
    });

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.uploader.queue.length) {
        $timeout(function () {
          if ($scope.param == "poliza") {
            SweetAlert.swal(MESSAGES.OK.UPGRADEPOLICY, "", "success");
          }
          if ($scope.param == "ot") {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.UPGRADEOT, "success");
          }
          $state.go("fianzas.info", { polizaId: polizaId });
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
        order.options.checkDate("initial");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
        order.options.checkDate("initial");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      // var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      // fileItem.file.name = fileItem.file.name.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '')
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales, renombre y, vuelva a cargarlo. " +
            $scope.specialchar,
          "error"
        );
      }
    };
    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    $scope.saveFiles = function (poliza) {
      uploadFiles(poliza);
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $scope.uploader.uploadAll();
    }
    // save
    $scope.save = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.form.recibos_poliza.length > 0) {
        if (!vm.form.poliza_number) {
          SweetAlert.swal("Agrega un número de fianza", "", "error");
          l.stop();
          return;
        }
      }
      if (!vm.form.aseguradora && !vm.form.aseguradora.url) {
        SweetAlert.swal("Seleccione una afianzadora", "", "error");
        l.stop();
        return;
      }
      if (!vm.form.ramo) {
        SweetAlert.swal("Seleccione un ramo", "", "error");
        l.stop();
        return;
      }
      if (!vm.form.subramo) {
        SweetAlert.swal("Seleccione un subramo", "", "error");
        l.stop();
        return;
      }
      if (!vm.form.clave) {
        SweetAlert.swal("Seleccione una clave", "", "error");
        l.stop();
        return;
      }
      if (!vm.form.tipo && vm.defaults.types.length > 0) {
        SweetAlert.swal("Seleccione un tipo", "", "error");
        l.stop();
        return;
      }
      if (!vm.form.contratante.value) {
        SweetAlert.swal("Seleccione un contratante", "", "error");
        l.stop();
        return;
      }
      if (!vm.form.address) {
        SweetAlert.swal("Seleccione una direccion", "", "error");
        l.stop();
        return;
      }

      // var flag = false;
      // if (vm.form.referenciadores.length > 0){
      //   vm.form.referenciadores.forEach(function(ref){
      //     if(!ref.referenciador){
      //       SweetAlert.swal('Seleccione un referenciador', '' ,"error");

      //       flag  = true;
      //     }

      //     if(!ref.comision_vendedor && vm.form.referenciadores.length != 1){
      //       SweetAlert.swal('Todos los referenciadores deben tener porcentaje de comision', '', "error");

      //       flag  = true;
      //     }
      //   });
      // }

      // if (flag){
      l.stop();
      //   return;
      // }

      if (!vm.form.subforms.contract.description) {
        l.stop();
        toaster.error("Agrega la descripción en el Detalle de Garantía");
        return;
      }
      if (vm.form.subforms.contract.guarantee_amount != "0") {
        if (!vm.form.subforms.contract.guarantee_amount) {
          l.stop();
          toaster.error(
            "Agrega el monto a garantizar en el Detalle de Garantía, número"
          );
          return;
        }
      }
      if (vm.form.subforms.contract.rate != 0) {
        if (!vm.form.subforms.contract.rate) {
          l.stop();
          toaster.error("Agrega la tarifa en el Detalle de Garantía");
          return;
        }
      }

      var ben_flag = false;
      vm.form.subforms.beneficiaries_fianza.forEach(function (beneficiario) {
        if (beneficiario.type_person == 1) {
          if (beneficiario.first_name == "") {
            SweetAlert.swal("Ingrese campo de nombre", "", "error");
            l.stop();
            ben_flag = true;
          }
          if (beneficiario.last_name == "") {
            SweetAlert.swal("Ingrese campo de apellido", "", "error");
            l.stop();
            ben_flag = true;
          }
          // if (beneficiario.rfc  == '' ){
          //   SweetAlert.swal('Ingrese campo de RFC', '', "error");

          //   ben_flag = true;
          // }
          // if (beneficiario.email  == '' ){
          //   SweetAlert.swal('Ingrese campo de email ', '', "error");

          //   ben_flag = true;
          // }
          // if (beneficiario.phone_number  == '' ){
          //   SweetAlert.swal('Ingrese campo de teléfono', '', "error");

          //   ben_flag = true;
          // }
          beneficiario.j_name = "";
        } else {
          if (beneficiario.j_name == "") {
            SweetAlert.swal("Ingrese campo de razon social", "", "error");
            l.stop();
            ben_flag = true;
          }
          // if (beneficiario.rfc  == '' ){
          //   SweetAlert.swal('Ingrese campo de RFC', '', "error");

          //   ben_flag = true;
          // }
          // if (beneficiario.email  == '' ){
          //   SweetAlert.swal('Ingrese campo de email ', '', "error");

          //   ben_flag = true;
          // }
          // if (beneficiario.phone_number  == '' ){
          //   SweetAlert.swal('Ingrese campo de teléfono', '', "error");

          //   ben_flag = true;
          // }
          beneficiario.first_name = "";
          beneficiario.last_name = "";
        }
      });

      if (ben_flag) {
        l.stop();
        return;
      }
      try {
        var val = $scope.formatearNumero(vm.form.subforms.contract.amount);
        if (val == "NaN") {
          SweetAlert.swal("Error", "Revise el monto de garantía", "error");
          l.stop();
          return;
        } else {
          console.log("--------", val);
        }
      } catch (err) {
        console.log("idddddddd", err);
      }
      try {
        var val = parseFloat(
          $scope.formatearNumero(vm.form.subforms.contract.guarantee_amount)
        ).toFixed(2);
        if (val == "NaN") {
          // toaster.error('Revise el formato del Monto a Garantizar.');
          SweetAlert.swal(
            "Revise el formato del Monto a Garantizar",
            "",
            "error"
          );
          l.stop();
          return;
        }
      } catch (err) {
        console.log("idddddddd", err);
      }
      var payload = {
        address: vm.form.address.url,
        aseguradora: vm.form.aseguradora.url,
        clave: vm.form.clave.url,
        contract_poliza: {
          start:
            vm.form.subforms.contract && vm.form.subforms.contract.start
              ? vm.form.subforms.contract.start
              : null,
          end:
            vm.form.subforms.contract && vm.form.subforms.contract.end
              ? vm.form.subforms.contract.end
              : null,
          number:
            vm.form.subforms.contract && vm.form.subforms.contract.number
              ? vm.form.subforms.contract.number
              : null,
          contract_object:
            vm.form.subforms.contract &&
            vm.form.subforms.contract.contract_object
              ? vm.form.subforms.contract.contract_object
              : null,
          amount:
            vm.form.subforms.contract && vm.form.subforms.contract.amount
              ? parseFloat(
                  $scope.formatearNumero(vm.form.subforms.contract.amount)
                ).toFixed(2)
              : null,
          amount_iva:
            vm.form.subforms.contract && vm.form.subforms.contract.amount_iva
              ? vm.form.subforms.contract.amount_iva
              : null,
          guarantee_percentage:
            vm.form.subforms.contract &&
            vm.form.subforms.contract.guarantee_percentage
              ? vm.form.subforms.contract.guarantee_percentage
              : null,
          guarantee_amount:
            vm.form.subforms.contract &&
            vm.form.subforms.contract.guarantee_amount
              ? parseFloat(
                  $scope.formatearNumero(
                    vm.form.subforms.contract.guarantee_amount
                  )
                ).toFixed(2)
              : null,
          rate:
            vm.form.subforms.contract && vm.form.subforms.contract.rate
              ? vm.form.subforms.contract.rate
              : 0,
          sign_date:
            vm.form.subforms.contract && vm.form.subforms.contract.sign_date
              ? vm.form.subforms.contract.sign_date
              : null,
          activity:
            vm.form.subforms.contract && vm.form.subforms.contract.activity
              ? vm.form.subforms.contract.activity
              : null,
          business_activity:
            vm.form.subforms.contract &&
            vm.form.subforms.contract.business_activity
              ? vm.form.subforms.contract.business_activity
              : null,
          employee_name:
            vm.form.subforms.contract && vm.form.subforms.contract.employee_name
              ? vm.form.subforms.contract.employee_name
              : null,
          no_employees:
            vm.form.subforms.contract && vm.form.subforms.contract.no_employees
              ? vm.form.subforms.contract.no_employees
              : null,
          description:
            vm.form.subforms.contract && vm.form.subforms.contract.description
              ? vm.form.subforms.contract.description
              : null,
          deductible_percentage:
            vm.form.subforms.contract &&
            vm.form.subforms.contract.deductible_percentage
              ? vm.form.subforms.contract.deductible_percentage
              : null,
        },
        emision_status: 1,
        end_of_validity: vm.form.end_of_validity,
        fianza_type: vm.form.tipo ? vm.form.tipo.url : null,
        folio: vm.form.folio,
        // "natural":( vm.form.contratante && vm.form.contratante.value.type_person && vm.form.contratante.value.type_person == 'Fisica' ) ? vm.form.contratante.value.url : null ,
        // "juridical":( vm.form.contratante && vm.form.contratante.value.type_person && vm.form.contratante.value.type_person == 'Moral' ) ? vm.form.contratante.value.url : null ,
        contractor: vm.form.contratante.value.url,
        ramo: vm.form.ramo.url,
        start_of_validity: vm.form.end_of_validity,
        subramo: vm.form.subramo.url,
        beneficiaries_poliza_many: [],
        beneficiaries_poliza: [],
        ref_policy: [],
        observations: vm.form.observations,
        status: vm.form.status,
        is_renewable: vm.form.renewal ? $scope.dataToSave.is_renewable : 2,
        f_currency: vm.form.currency ? vm.form.currency.currency_selected : 1,
        bono_variable: vm.form.bono_variable
          ? parseFloat(vm.form.bono_variable).toFixed(2)
          : 0,
        emision_date: vm.form.date_emision_factura
          ? datesFactory.toDate(vm.form.date_emision_factura)
          : null,
        month_factura: vm.form.month ? vm.form.month.month_selected : 0,
        folio_factura: vm.form.folio_factura ? vm.form.folio_factura : "",
        maquila: vm.form.maquila ? parseFloat(vm.form.maquila).toFixed(2) : 0,
        exchange_rate: vm.form.exchange_rate
          ? parseFloat(vm.form.exchange_rate).toFixed(2)
          : 0,
        date_maquila: vm.form.date_maquila
          ? datesFactory.toDate(vm.form.date_maquila)
          : null,
        date_bono: vm.form.date_bono
          ? datesFactory.toDate(vm.form.date_bono)
          : null,
        year_factura: vm.form.year_factura ? vm.form.year_factura : 0,
      };

      try {
        payload.start_of_validity = datesFactory.toDate(
          vm.form.start_of_validity
        );
      } catch (err) {
        SweetAlert.swal("Revise la fecha de inicio", "", "error");
        l.stop();
        return;
      }
      try {
        payload.end_of_validity = datesFactory.toDate(vm.form.end_of_validity);
      } catch (err) {
        SweetAlert.swal("Revise la fecha de inicio", "", "error");
        l.stop();
        return;
      }
      // if (vm.form.status != 1 && new Date() >= payload.start_of_validity && new Date() < payload.end_of_validity){
      //   payload.status = 14;
      // }

      // if (new Date() > payload.end_of_validity){
      //   payload.status = 13;
      // }
      // if (new Date() < payload.start_of_validity){
      //   payload.status = 10;
      // }
      if (
        vm.form.subramo.subramo_code == 20 ||
        vm.form.subramo.subramo_code == 21
      ) {
        try {
          payload.contract_poliza["end"] = datesFactory.toDate(
            vm.form.subforms.contract["end"]
          );
          payload.contract_poliza["start"] = datesFactory.toDate(
            vm.form.subforms.contract["start"]
          );
          payload.contract_poliza["sign_date"] = datesFactory.toDate(
            vm.form.subforms.contract["sign_date"]
          );
        } catch (err) {
          SweetAlert.swal("Revise las fechas del contrato", "", "error");
          l.stop();
          return;
        }
      } else {
        payload.contract_poliza["end"] = new Date();
        payload.contract_poliza["start"] = new Date();
        payload.contract_poliza["sign_date"] = new Date();
      }

      var nombres = [];
      vm.form.subforms.beneficiaries_fianza.forEach(function (beneficiario) {
        var ref = {
          email: beneficiario.email,
          first_name: beneficiario.first_name,
          full_name:
            beneficiario.first_name +
            " " +
            beneficiario.last_name +
            " " +
            beneficiario.second_last_name,
          j_name: beneficiario.j_name,
          last_name: beneficiario.last_name,
          type_person: beneficiario.type_person,
          phone_number: beneficiario.phone_number,
          rfc: beneficiario.rfc,
          second_last_name: beneficiario.second_last_name,
          url: beneficiario.url ? beneficiario.url : null,
          id: beneficiario.id ? beneficiario.id : null,
        };
        payload["beneficiaries_poliza_many"].push(ref);
        if (beneficiario.type_person == 2) {
          nombres.push(beneficiario.j_name);
        } else {
          nombres.push(
            beneficiario.first_name +
              "_" +
              beneficiario.last_name +
              "_" +
              beneficiario.second_last_name
          );
        }
      });

      var bname = vm.form.ramo.ramo_name;

      if (nombres.length > 0) bname = nombres[0];
      if (vm.form.identifier) {
        payload["identifier"] = vm.form.identifier;
      } else {
        payload["identifier"] =
          vm.form.subramo.subramo_name +
          "_" +
          bname +
          "_" +
          payload["contract_poliza"]["description"];
      }

      vm.form.referenciadores.forEach(function (referenciador) {
        if (referenciador.referenciador) {
          var ref = {
            referenciador: referenciador.referenciador,
            comision_vendedor: referenciador.comision_vendedor
              ? referenciador.comision_vendedor
              : 0,
          };
          payload["ref_policy"].push(ref);
        }
      });

      if (vm.form.status != 1) {
        payload["poliza_number"] = vm.form.poliza_number;
        payload["folio"] = vm.form.folio;
        payload["emision_date"] = datesFactory.toDate(vm.form.emision_date);
      }

      if ($scope.showPrograma) {
        payload.has_programa_de_proveedores = true;
        payload.programa_de_proveedores_contractor = $scope.programa_contractor
          ? $scope.programa_contractor
          : null;
      } else {
        payload.has_programa_de_proveedores = false;
        payload.programa_de_proveedores_contractor = null;
      }

      if (!$stateParams.renovacion && !$stateParams.reexpedir) {
        $http.patch(vm.form.url.replace("polizas", "fianzas"), payload).then(
          function success(response) {
            if (response.status == 200 || response.status == 201) {
              var paramsE = {
                model: 13,
                event: "PATCH",
                associated_id: vm.form.id,
                identifier:
                  vm.form.status == 1
                    ? "actualizó la fianza : " + vm.form.internal_number
                    : "actualizó la fianza : " + vm.form.poliza_number,
              };
              dataFactory.post("send-log", paramsE);
              $state.go("fianzas.info", { polizaId: $stateParams.polizaId });
            } else {
              if (
                response.data &&
                response.data.contract_poliza &&
                response.data.contract_poliza.rate
              ) {
                SweetAlert.swal(
                  "Ocurrió un error",
                  "Revise la información (Tarifa aplicable), no sé guardaron cambios ",
                  "error"
                );
              } else {
                SweetAlert.swal(
                  "Ocurrió un error",
                  "Revise la información, no sé guardaron cambios ",
                  "error"
                );
              }
            }
          },
          function error(err) {
            SweetAlert.swal(
              "Ocurrió un error",
              "Revise la información " + err,
              "error"
            );
            console.log("error", err);
          }
        );
      }

      if ($stateParams.renovacion && $stateParams.renovacion == 2) {
        payload.status = 1;
        $http.post(url.IP + "fianzas/", payload).then(function (response) {
          if (response.status == 201) {
            var data = {
              // renewed: true,
              // status: 12,
              renewed_status: 1,
              fecha_cancelacion: null,
              monto_cancelacion: null,
            };
            $http.patch(vm.form.url, data);

            /* Relación con la póliza original */
            if (vm.form.poliza_number) {
              var oldPolicy = {
                policy: vm.form.poliza_number,
                base_policy: vm.form.url,
                new_policy: response.data.url,
              };
            } else {
              var oldPolicy = {
                base_policy: vm.form.url,
                new_policy: response.data.url,
              };
            }
            $http
              .post(url.IP + "v1/polizas/viejas/", oldPolicy)
              .then(function (res) {
                // SweetAlert.swal('Fianza renovada', "", "success");
                var paramsE = {
                  model: 13,
                  event: "POST",
                  associated_id: vm.form.id,
                  identifier:
                    vm.form.status == 1
                      ? "renovó la fianza : " + vm.form.internal_number
                      : "renovó la fianza : " + vm.form.poliza_number,
                };
                dataFactory.post("send-log", paramsE);

                var modalInstance = $uibModal.open({
                  templateUrl: "app/fianzas/otAsFianzaModal.html",
                  controller: FianzaPendingModalCtrl,
                  controllerAs: "vmm",
                  size: "lg",
                  resolve: {
                    policyModal: function () {
                      return response.data;
                    },
                    ren: function () {
                      return $scope.esrenovacion;
                    },
                  },
                  backdrop:
                    "static" /* this prevent user interaction with the background */,
                  keyboard: false,
                });
                modalInstance.result.then(function (receipt) {
                  activate();
                });

                // $state.go('fianzas.info',{polizaId:response.data.id});
              })
              .catch(function (e) {
                SweetAlert.swal("Ocurrió un error", "", "error");
                return;
              });
          }
        });
      }

      if ($stateParams.reexpedir && $stateParams.reexpedir == 1) {
        payload["poliza_number"] = "";
        payload.poliza_number = "";
        var recibos_pagados_flag = false;
        vm.fianza_info.recibos_poliza.forEach(function (rec) {
          if (rec.status == 1) {
            recibos_pagados_flag = true;
          }
        });

        if (recibos_pagados_flag) {
          SweetAlert.swal(
            {
              title: "Anular fianza",
              text: "¿Esta fianza contiene recibos pagados, solo se verán afectados los recibos pendientes de pago, desea continuar?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Anular",
              cancelButtonText: "Cancelar",
              closeOnConfirm: true,
              closeOnCancel: false,
            },
            function (isConfirm) {
              if (isConfirm) {
                var obj = {
                  status: 17, //Anulada
                };

                $q.all([
                  $http
                    .patch(vm.form.url, obj) //Actualizar la fianza a preanulado
                    .then(function (response) {
                      if (response.status == 200) {
                        var params = {
                          model: 13,
                          event: "PATCH",
                          associated_id: vm.form.id,
                          identifier: " actualizó la fianza a Anulado.",
                        };
                        dataFactory.post("send-log/", params);
                      }

                      if (vm.form.recibos_poliza.length > 0) {
                        if (
                          vm.form.recibos_poliza[0].status == 4 ||
                          vm.form.recibos_poliza[0].status == 11
                        ) {
                          // Actualizar recibo de fianza a preanulado
                          $http({
                            method: "PATCH",
                            url: vm.form.recibos_poliza[0].url,
                            data: {
                              status: 10,
                            },
                          }).then(function success(response) {
                            if (response.status == 200) {
                              var params = {
                                model: 4,
                                event: "PATCH",
                                associated_id: response.data.id,
                                identifier: " actualizó el recibo a Anulado.",
                              };
                              dataFactory
                                .post("send-log/", params)
                                .then(function success(response) {});
                              toaster.success(
                                "Recibo de fianza actualizado exitosamente"
                              );
                              activate();
                            }
                          });
                        }
                      }

                      $scope.endososFianza.forEach(function (endoso) {
                        if (endoso.status == 2) {
                          // Actualizar recibo de endoso a anulado
                          $http
                            .patch(endoso.url, { status: 6 })
                            .then(function (response_endoso_updated) {
                              if (response.status == 200) {
                                var params = {
                                  model: 10,
                                  event: "PATCH",
                                  associated_id:
                                    response_endoso_updated.data.id,
                                  identifier: " actualizó la fianza a Anulado.",
                                };
                                dataFactory.post("send-log/", params);
                                if (endoso.endorsement_receipt) {
                                  if (
                                    endoso.endorsement_receipt[0].status == 4 ||
                                    vm.form.recibos_poliza[0].status == 11
                                  ) {
                                    $http({
                                      method: "PATCH",
                                      url: endoso.endorsement_receipt[0].url,
                                      data: { status: 10 },
                                    }).then(function (response_endosos_fianza) {
                                      if (
                                        response_endosos_fianza.status == 200
                                      ) {
                                        var params = {
                                          model: 4,
                                          event: "PATCH",
                                          associated_id:
                                            endoso.endorsement_receipt[0].id,
                                          identifier:
                                            " actualizó el recibo a Anulado.",
                                        };
                                        dataFactory.post("send-log/", params);
                                        toaster.success(
                                          "Recibo de endoso actualizado exitosamente."
                                        );
                                      }
                                    });
                                  }
                                }
                              }
                            });
                        }
                      });
                    })
                    .catch(function (e) {
                      console.log("error", e);
                    }),
                ]).then(function () {
                  // Crear la reexpedicion de la finaza
                  $http
                    .post(url.IP + "fianzas/", payload)
                    .then(function (response) {
                      if (response.status == 201) {
                        /* Relación con la póliza original */
                        if (vm.fianza_history) {
                          var oldPolicy = {
                            policy: vm.fianza_history.poliza_number,
                            base_policy: vm.fianza_history.url,
                            new_policy: response.data.url,
                          };
                        } else {
                          var oldPolicy = {
                            policy: vm.form.poliza_number,
                            base_policy: vm.form.url,
                            new_policy: response.data.url,
                          };
                        }
                        $http
                          .post(url.IP + "v1/polizas/viejas/", oldPolicy)
                          .then(function (res) {
                            SweetAlert.swal("Fianza reexpedida", "", "success");
                            var paramsE = {
                              model: 13,
                              event: "POST",
                              associated_id: vm.form.id,
                              identifier:
                                vm.form.status == 1
                                  ? "reexpidió la fianza : " +
                                    vm.form.internal_number
                                  : "reexpidió la fianza : " +
                                    vm.form.poliza_number,
                            };
                            dataFactory.post("send-log", paramsE);
                            $state.go("fianzas.info", {
                              polizaId: response.data.id,
                            });
                          })
                          .catch(function (e) {
                            SweetAlert.swal("Ocurrió un error", "", "error");
                            return;
                          });
                      }
                    });
                });
              } else {
                SweetAlert.swal(
                  "¡Cancelado!",
                  "La fianza no fue anulada",
                  "error"
                );
                return;
              }
            }
          );
        } else {
          var obj = {
            status: 17, //Anulada
          };

          $q.all([
            $http
              .patch(vm.form.url, obj) //Actualizar la fianza a preanulado
              .then(function (response) {
                if (response.status == 200) {
                  var params = {
                    model: 13,
                    event: "PATCH",
                    associated_id: vm.form.id,
                    identifier: " actualizó la fianza a Anulado.",
                  };
                  dataFactory.post("send-log/", params);
                }

                if (vm.form.recibos_poliza.length > 0) {
                  if (
                    vm.form.recibos_poliza[0].status == 4 ||
                    vm.form.recibos_poliza[0].status == 11
                  ) {
                    // Actualizar recibo de fianza a preanulado
                    $http({
                      method: "PATCH",
                      url: vm.form.recibos_poliza[0].url,
                      data: {
                        status: 10,
                      },
                    }).then(function success(response) {
                      if (response.status == 200) {
                        var params = {
                          model: 4,
                          event: "PATCH",
                          associated_id: response.data.id,
                          identifier: " actualizó el recibo a Anulado.",
                        };
                        dataFactory
                          .post("send-log/", params)
                          .then(function success(response) {});
                        toaster.success(
                          "Recibo de fianza actualizado exitosamente"
                        );
                      }
                    });
                  }
                }

                $scope.endososFianza.forEach(function (endoso) {
                  if (endoso.status == 2) {
                    // Actualizar recibo de endoso a preanulado
                    $http
                      .patch(endoso.url, { status: 6 })
                      .then(function (response_endoso_updated) {
                        if (response.status == 200) {
                          var params = {
                            model: 10,
                            event: "PATCH",
                            associated_id: response_endoso_updated.data.id,
                            identifier: " actualizó la fianza a Anulado.",
                          };
                          dataFactory.post("send-log/", params);
                          if (endoso.endorsement_receipt) {
                            if (
                              endoso.endorsement_receipt[0].status == 4 ||
                              vm.form.recibos_poliza[0].status == 11
                            ) {
                              $http({
                                method: "PATCH",
                                url: endoso.endorsement_receipt[0].url,
                                data: { status: 10 },
                              }).then(function (response_endosos_fianza) {
                                if (response_endosos_fianza.status == 200) {
                                  var params = {
                                    model: 4,
                                    event: "PATCH",
                                    associated_id:
                                      endoso.endorsement_receipt[0].id,
                                    identifier:
                                      " actualizó el recibo a Anulado.",
                                  };
                                  dataFactory.post("send-log/", params);
                                  toaster.success(
                                    "Recibo de endoso actualizado exitosamente."
                                  );
                                }
                              });
                            }
                          }
                        }
                      });
                  }
                });
              })
              .catch(function (e) {
                console.log("error", e);
              }),
          ]).then(function () {
            payload["status"] = 1;
            $http.post(url.IP + "fianzas/", payload).then(function (response) {
              if (response.status == 201) {
                /* Relación con la póliza original */
                if (vm.fianza_history) {
                  var oldPolicy = {
                    policy: vm.fianza_history.poliza_number,
                    base_policy: vm.fianza_history.url,
                    new_policy: response.data.url,
                  };
                } else {
                  var oldPolicy = {
                    policy: vm.form.poliza_number,
                    base_policy: vm.form.url,
                    new_policy: response.data.url,
                  };
                }
                $http
                  .post(url.IP + "v1/polizas/viejas/", oldPolicy)
                  .then(function (res) {
                    SweetAlert.swal("Fianza reexpedida", "", "success");
                    var paramsE = {
                      model: 13,
                      event: "POST",
                      associated_id: vm.form.id,
                      identifier:
                        vm.form.status == 1
                          ? "reexpidió la fianza : " + vm.form.internal_number
                          : "reexpidió la fianza : " + vm.form.poliza_number,
                    };
                    dataFactory.post("send-log", paramsE);
                    $state.go("fianzas.info", { polizaId: response.data.id });
                  })
                  .catch(function (e) {
                    SweetAlert.swal("Ocurrió un error", "", "error");
                    return;
                  });
              }
            });
          });
        }
      }
    };

    function FianzaPendingModalCtrl(
      datesFactory,
      $localStorage,
      $scope,
      toaster,
      MESSAGES,
      policyModal,
      $uibModalInstance,
      dataFactory,
      SweetAlert,
      $state,
      insuranceService,
      receiptService,
      url,
      $http,
      $rootScope,
      emailService,
      helpers,
      ren
    ) {
      var vmm = this;

      vmm.form = {
        folio: "",
        comisiones: [],
        document_type: policyModal.document_type,
      };

      vmm.options = {
        cancel: cancel,
        save: save,
      };
      vmm.policyInfo = policyModal;
      $scope.changeNoPoliza = function () {
        if (vmm.form.fianza) {
          if (ren == false) {
            helpers
              .existPolicyNumber(vmm.form.fianza)
              .then(function (request) {
                if (request == true) {
                  SweetAlert.swal(
                    "Error",
                    "El número de fianza ya existe.",
                    "error"
                  );
                  vmm.form.fianza = "";
                }
              })
              .catch(function (err) {});
          }
        }
      };

      $scope.checkFechaFactura = function (date) {
        var date_initial = date.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);
        vmm.form.month.month_selected = parseInt(month);
        vmm.form.year_factura = year;
      };
      $scope.years = [];
      var actualYear = new Date().getFullYear();
      var oldYear = actualYear - 80;
      for (var i = actualYear + 10; i >= oldYear; i--) {
        $scope.years.push(i);
      }

      vmm.form.month = {};
      vmm.form.month.month_selected = 1;
      vmm.form.month.options = [
        { value: 0, label: "" },
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Septiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" },
      ];
      $http
        .get(url.IP + "claves-by-provider/" + vmm.policyInfo.aseguradoradata.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
                if (vmm.policyInfo.subramo == item.subramo) {
                  vmm.form.comisiones.push(item);
                }
              });
            });
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      vmm.form.startDate = convertDate(vmm.policyInfo.start_of_validity);
      vmm.form.emision_date = datesFactory.convertDate(new Date());
      vmm.form.endingDate = convertDate(vmm.policyInfo.end_of_validity);
      vmm.form.subramo = vmm.policyInfo.subramo;
      vmm.form.subramo = vmm.policyInfo.subramo;
      vmm.form.policy_days_duration = 365;
      function normalizeDate(date) {
        var d = new Date(date);
        d.setHours(0, 0, 0, 0); // Elimina hora, minutos, segundos, ms
        return d;
      }
      function save() {
        var sd = normalizeDate(
          datesFactory.toDate(vmm.policyInfo.recibos_poliza[0].startDate)
        );
        var ed = normalizeDate(
          datesFactory.toDate(vmm.policyInfo.recibos_poliza[0].endingDate)
        );
        var psd = normalizeDate(vmm.policyInfo.start_of_validity);
        var ped = normalizeDate(vmm.policyInfo.end_of_validity);
        if (sd < psd || sd > ped) {
          // toaster.error('La fecha de inicio del recibo esta fuera de la fecha de la fianza');
          SweetAlert.swal(
            "Error",
            "La fecha de inicio del recibo esta fuera de la fecha de la fianza",
            "error"
          );
          return;
        }
        if (ed < psd || ed > ped) {
          // toaster.error('La fecha de fin del recibo esta fuera de la fecha de la fianza');
          SweetAlert.swal(
            "Error",
            "La fecha de fin del recibo esta fuera de la fecha de la fianza",
            "error"
          );
          return;
        }
        vmm.form.emision_date = datesFactory.toDate(vmm.form.emision_date);
        $scope.dataFianza = {
          folio: vmm.form.folio,
          poliza_number: vmm.form.fianza,
          status: 14,
          p_neta: vmm.policyInfo.poliza.primaNeta,
          rpf: vmm.policyInfo.poliza.rpf,
          derecho: vmm.policyInfo.poliza.derecho,
          iva: vmm.policyInfo.poliza.iva,
          p_total: vmm.policyInfo.poliza.primaTotal,
          comision: vmm.policyInfo.comision,
          comision_percent: vmm.policyInfo.comision_percent,
          emision_date: vmm.form.emision_date,
          fecha_cancelacion: vmm.policyInfo.fecha_cancelacion,
          monto_cancelacion: vmm.policyInfo.monto_cancelacion,
          date_emision_factura: vmm.form.date_emision_factura
            ? datesFactory.toDate(vmm.form.date_emision_factura)
            : null,
          date_maquila: vmm.form.date_maquila
            ? datesFactory.toDate(vmm.form.date_maquila)
            : null,
          year_factura: vmm.form.year_factura ? vmm.form.year_factura : 0,
          month_factura: vmm.form.month ? vmm.form.month.month_selected : 0,
          folio_factura: vmm.form.folio_factura ? vmm.form.folio_factura : "",
          maquila: vmm.form.maquila
            ? parseFloat(vmm.form.maquila).toFixed(2)
            : 0,
          exchange_rate: vmm.form.exchange_rate
            ? parseFloat(vmm.form.exchange_rate).toFixed(2)
            : 0,
        };
        $http
          .patch(vmm.policyInfo.url, $scope.dataFianza)
          .then(function (response) {
            if (response.status == 200) {
              vmm.policyInfo.recibos_poliza.forEach(function (item) {
                item.fecha_inicio = new Date(
                  datesFactory.toDate(
                    vmm.policyInfo.recibos_poliza[0].startDate
                  )
                );
                item.fecha_fin = new Date(
                  datesFactory.toDate(
                    vmm.policyInfo.recibos_poliza[0].endingDate
                  )
                );
                item.vencimiento = new Date(
                  datesFactory.toDate(
                    vmm.policyInfo.recibos_poliza[0].vencimiento
                  )
                );

                item.poliza = response.data.url;

                dataFactory.post("recibos/", item).then(
                  function success(req) {},
                  function error(error) {
                    console.log(error);
                  }
                );
              });

              $state.go("fianzas.info", { polizaId: response.data.id });
              activate();
              vmm.options.cancel();
              SweetAlert.swal("¡Listo!", MESSAGES.OK.RENEWALFIANZA, "success");
              // location.reload();
              $uibModalInstance.dismiss("cancel");
              var params = {
                model: 13,
                event: "POST",
                associated_id: response.data.id,
                identifier: "convirtió la OT en fianza.",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }
          });
      }

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }

      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        var date = inputFormat;
        if (inputFormat.length != 10) {
          function pad(s) {
            return s < 10 ? "0" + s : s;
          }
          var d = new Date(inputFormat);
          if (indicator) {
            date = [
              pad(d.getDate() + 1),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          } else {
            date = [
              pad(d.getDate()),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          }
        }
        return date;
      }
    }

    function cancel() {
      $state.go("fianzas.info", { polizaId: $stateParams.polizaId });
    }
    function deleteBene(index, item, all) {
      if (vm.form.subforms.beneficiaries_fianza.length > 1) {
        // vm.subforms.beneficiaries_fianza_many.splice(1, 1);
        if (item.id) {
          SweetAlert.swal(
            {
              title: "Información",
              text: "El Beneficiario se eliminará de esta Fianza",
              type: "warning",
              showCancelButton: false,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar",
              closeOnConfirm: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                vm.subforms.beneficiaries_fianza_many.splice(index, 1);
                $scope.beneficiarie_to_delete.push(
                  vm.subforms.beneficiaries_fianza_many[index]
                );
              }
            }
          );
        } else {
          vm.form.subforms.beneficiaries_fianza.splice(index, 1);
        }
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("FianzasCtrl", FianzasCtrl);

  FianzasCtrl.$inject = [
    "$parse",
    "insuranceService",
    "toaster",
    "MESSAGES",
    "$stateParams",
    "ContratanteService",
    "dataFactory",
    "SweetAlert",
    "providerService",
    "datesFactory",
    "$scope",
    "$sessionStorage",
    "FileUploader",
    "$state",
    "$http",
    "url",
    "$localStorage",
    "$rootScope",
    "emailService",
    "helpers",
    "$timeout",
  ];

  function FianzasCtrl(
    $parse,
    insuranceService,
    toaster,
    MESSAGES,
    $stateParams,
    ContratanteService,
    dataFactory,
    SweetAlert,
    providerService,
    datesFactory,
    $scope,
    $sessionStorage,
    FileUploader,
    $state,
    $http,
    url,
    $localStorage,
    $rootScope,
    emailService,
    helpers,
    $timeout
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.infoUser = $sessionStorage.infoUser;

    // varibles
    vm.show = {
      firstTab: true,
      ot: true,
    };
    $scope.activeJustified = 0;
    vm.org_name = usr.org;
    $scope.create_natural = true;
    $scope.create_juridical = true;
    $scope.showPrograma = false;
    $rootScope.show_contractor = false;
    var dateOffset = 24 * 60 * 60 * 1000 * 1; //1 days
    var now = new Date();
    var endDate = now.setFullYear(now.getFullYear() + 1);
    endDate = new Date(endDate).setTime(
      new Date(endDate).getTime() - dateOffset
    );
    vm.defaults = {};
    vm.form = {
      contratante: {},
      folio: "",
      afianzadora: "",
      emision_date: datesFactory.convertDate(new Date()),
      start_of_validity: datesFactory.convertDate(new Date()),
      end_of_validity: datesFactory.convertDate(endDate),
      emision: datesFactory.convertDate(new Date()),
      date_emision_factura: "",
      date_maquila: "",
      year_factura: "",
      date_bono: "",
      mes_emision: "",
      folio_captura: "",
      ceder_comision: false,
      comision_percent: 0.0,
      udi: 0.0,
      vendor: "",
      benefiaciario_seleccionado: "",
      status: 1,
      identifier: "",
      is_fianza: true,
    };
    $scope.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 10; i >= oldYear; i--) {
      $scope.years.push(i);
    }
    vm.form.renewal = {};
    vm.form.renewal.is_renewable = 2;
    vm.form.renewal.options = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.dataToSave = {};
    vm.form.referenciadores = [{ referenciador: "" }];

    if ($stateParams.myInsurance && $stateParams.myInsurance != "") {
      vm.form.contratante["value"] = $stateParams.myInsurance;
      console.log("vmform", vm.form.contratante, $scope.vendors);
      if ($scope.vendors) {
        $scope.vendors.some(function (user) {
          if (user.url == vm.form.contratante.value.vendor) {
            if (true) {
              vm.form.vendor = user.id;
              user.name = user.first_name + " " + user.last_name;
              vm.form.vendor = user;
            }
          }
        });
      }

      if (vm.form.contratante.value.j_name) {
        vm.form.contratante.val = vm.form.contratante.value.j_name;
      }

      if (vm.form.contratante.value.full_name) {
        vm.form.contratante.val = vm.form.contratante.value.full_name;
      }

      // if (vm.form.contratante.value.address_natural){
      //     vm.defaults.address = vm.form.contratante.value.address_natural
      // } else{
      //     vm.defaults.address = vm.form.contratante.value.address_juridical
      // }
      vm.defaults.address = vm.form.contratante.value.address_contractor;
      if (vm.form.contratante.value.phone_number) {
        vm.form.contratante.phone_number =
          vm.form.contratante.value.phone_number;
      }

      if (vm.form.contratante.value.email) {
        vm.form.contratante.email = vm.form.contratante.value.email;
      }
      try {
        vm.form.address = vm.defaults.address[0];
      } catch (err) {}
      try {
        vm.form.referenciadores = [
          { referenciador: vm.form.contratante["value"].vendor },
        ];
      } catch (err) {}
    }

    // funciones
    vm.contratanteCreatorModalEvent = contratanteCreatorModalEvent;
    vm.aseguradoraSelection = aseguradoraSelection;
    vm.changeRamo = changeRamo;
    vm.changeSubramo = changeSubramo;
    vm.changeTipo = changeTipo;
    vm.addBene = addBene;
    vm.deleteBene = deleteBene;
    vm.checkDate = checkDate;
    vm.checkEndDate = checkEndDate;
    vm.cancel = cancel;

    // diccionarios //
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          vm.acceso_fianzas = perm;
          vm.acceso_fianzas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            } else if (acc.permission_name == "Proyecto de fianza") {
              if (acc.checked == true) {
                vm.acceso_proy_fia = true;
              } else {
                vm.acceso_proy_fia = false;
                vm.form.status = 10;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          vm.acceso_refereciador = perm;
          vm.acceso_refereciador.permissions.forEach(function (acc) {
            if (acc.permission_name == "Cambiar refrenciador en pólizas") {
              if (acc.checked == true) {
                vm.acceso_chng_ref = true;
              } else {
                vm.acceso_chng_ref = false;
              }
            }
            if (acc.permission_name == "Referenciador no obligatorio") {
              if (acc.checked == true) {
                vm.acceso_obligatorio_ref = false;
              } else {
                vm.acceso_obligatorio_ref = true;
              }
            }
          });
        }
        if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        }
        if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        }
        if (perm.model_name == "Comisiones") {
          vm.acceso_dash = perm;
          vm.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }

    vm.form.subforms = {
      contract: {
        start: vm.form.start_of_validity,
        end: vm.form.end_of_validity,
        sign_date: datesFactory.convertDate(new Date()),
        number: "",
        value: "",
        contract_object: "",
        guarantee_percentage: 0,
      },
      beneficiaries_fianza: [
        {
          first_name: "",
          last_name: "",
          second_last_name: "",
          full_name: "",
          j_name: "",
          rfc: "",
          email: "",
          phone_number: "",
          type_person: 1,
        },
      ],
    };

    vm.form.currency = {};
    vm.form.currency.currency_selected = 1;
    vm.form.currency.options = [
      { value: 1, label: "PESOS" },
      { value: 2, label: "DOLARES" },
    ];
    vm.form.month = {};
    // vm.form.month_selected = 1;
    vm.form.month.options = [
      { value: 0, label: "" },
      { value: 1, label: "Enero" },
      { value: 2, label: "Febrero" },
      { value: 3, label: "Marzo" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Mayo" },
      { value: 6, label: "Junio" },
      { value: 7, label: "Julio" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Septiembre" },
      { value: 10, label: "Octubre" },
      { value: 11, label: "Noviembre" },
      { value: 12, label: "Diciembre" },
    ];

    $scope.checkFechaFactura = function (date) {
      var date_initial = date.split("/");
      var day = date_initial[0];
      var month = date_initial[1];
      var year = parseInt(date_initial[2]);
      vm.form.month_selected = parseInt(month);
      vm.form.year_factura = year;
    };
    $scope.convertDate = function (inputFormat) {
      function inputDate(days) {
        return days < 10 ? "0" + days : days;
      }
      var dateFormat = new Date(inputFormat);
      var date = [
        inputDate(dateFormat.getDate()),
        inputDate(dateFormat.getMonth() + 1),
        dateFormat.getFullYear(),
      ].join("/");
      return date;
    };

    $scope.fechas_upd = function (date, val, event) {
      // 3-11-2022
      var clipboardData =
        event.originalEvent.clipboardData || window.clipboardData;
      var pastedText = clipboardData.getData("text");
      var date_initial = pastedText.split("-");
      var day = date_initial[0];
      var month = date_initial[1];
      var year = parseInt(date_initial[2]);
      if (parseInt(month) > 12) {
        var day2 = month;
        var month2 = day;
        day = day2;
        month = month2;
      }
      if (day.length == 1) {
        day = "0" + day.toString();
      }
      if (month.length == 1) {
        month = "0" + month.toString();
      }
      var fecha_to_date = day + "/" + month + "/" + year;
      if (fecha_to_date) {
        var date2 = fecha_to_date;
      } else {
        var date2 = datesFactory.convertDate(fecha_to_date);
      }
      console.log(".....", fecha_to_date, date2);
      if (val == 1) {
        if (vm.form.subforms) {
          if (vm.form.subforms.contract) {
            vm.form.subforms.contract.start = date2
              ? date2
              : datesFactory.convertDate(new Date());
          } else {
            vm.form.subforms.contract = {};
            vm.form.subforms.contract.start = date2
              ? date2
              : datesFactory.convertDate(new Date());
          }
        }
      }
      if (val == 2) {
        if (vm.form.subforms) {
          if (vm.form.subforms.contract) {
            vm.form.subforms.contract.end = date2
              ? date2
              : datesFactory.convertDate(new Date());
          } else {
            vm.form.subforms.contract = {};
            vm.form.subforms.contract.end = date2
              ? date2
              : datesFactory.convertDate(new Date());
          }
        }
      }
      if (val == 3) {
        if (vm.form.subforms) {
          if (vm.form.subforms.contract) {
            vm.form.subforms.contract.sign_date = date2
              ? date2
              : datesFactory.convertDate(new Date());
          } else {
            vm.form.subforms.contract = {};
            vm.form.subforms.contract.sign_date = date2
              ? date2
              : datesFactory.convertDate(new Date());
          }
        }
      }
      console.log("-date---------", vm.form.subforms.contract.start);
      $scope.saveLocalstorange();
    };
    $http.get(url.IP + "userslist_admin/").then(function (users) {
      $scope.vendors = users.data;
      console.log("iiiiiiii", $scope.vendors);
    });
    activate();

    function activate() {
      if (
        $localStorage["save_created_fianza"] &&
        $localStorage["save_created_fianza"]["type_fianza"] &&
        $localStorage["save_created_fianza"]["type_fianza"] == 0
      ) {
        $scope.activeJustified = 0;
        vm.form.status = 1;
        var tab = "ot";
      } else if (
        $localStorage["save_created_fianza"] &&
        $localStorage["save_created_fianza"]["type_fianza"] &&
        $localStorage["save_created_fianza"]["type_fianza"] == 1
      ) {
        $scope.activeJustified = 1;
        vm.form.status = 10;
        var tab = "fianza";
      }
      $scope.active = {}; //reset
      $scope.active[tab] = true;

      vm.form.emision_date = datesFactory.convertDate(new Date());
      vm.form.start_of_validity = datesFactory.convertDate(new Date());
      vm.form.end_of_validity = datesFactory.convertDate(new Date());
      if (vm.form.afianzadora) {
        get_claves();
        $http
          .get(url.IP + "ramos-by-provider/" + vm.form.afianzadora.id)
          .then(
            function success(response) {
              vm.defaults.ramos = response.data;
            },
            function error(e) {
              console.log("Error - ramos-by-provider", e);
            }
          )
          .catch(function (error) {
            console.log("Error - ramos-by-provider - catch", error);
          });
      }
      if (vm.form.ramo) {
        vm.changeRamo();
      }

      vm.form.renewal.selected = 2;
      vm.form.referenciadores = [{ referenciador: "" }];
      vm.form.subforms = {};
      vm.form.subforms.beneficiaries_fianza = [
        {
          first_name: "",
          last_name: "",
          second_last_name: "",
          full_name: "",
          j_name: "",
          rfc: "",
          email: "",
          phone_number: "",
          type_person: 1,
        },
      ];

      // vm.show = {
      //   firstTab: true,
      //   ot: true
      // };
    }

    if ("save_created_fianza" in $localStorage) {
    } else {
      $localStorage["save_created_fianza"] = {};
    }

    $scope.testCheck = function (showPrograma) {};
    $scope.saveLocalstorange = function () {};
    $scope.activateTab = function (tab) {
      $scope.active = {}; //reset
      $scope.active[tab] = true;
      $localStorage["save_created_fianza"]["active"] = $scope.active;
      if (tab == "ot") {
        $localStorage["save_created_fianza"]["type_fianza"] = 0;
      } else {
        $localStorage["save_created_fianza"]["type_fianza"] = 1;
      }
    };
    /* Watchs */
    $scope.$watch("vm.form.contratante.value", function (newValue, oldValue) {
      $rootScope.show_contractor = false;
      if (vm.form.contratante) {
        if ($scope.vendors) {
          $scope.vendors.some(function (user) {
            if (user.url == vm.form.contratante.value.vendor) {
              vm.form.vendor = user.id;
              user.name = user.first_name + " " + user.last_name;
              vm.form.vendor = user;
              vm.form.referenciadores.push({ referenciador: user.url });
            }
          });
        }

        if (
          vm.form.contratante &&
          vm.form.contratante.value &&
          vm.form.contratante.value.j_name
        ) {
          vm.form.contratante.val = vm.form.contratante.value.j_name;
        }

        if (
          vm.form.contratante &&
          vm.form.contratante.value &&
          vm.form.contratante.value.first_name
        ) {
          vm.form.contratante.val =
            vm.form.contratante.value.first_name +
            " " +
            vm.form.contratante.value.last_name +
            " " +
            vm.form.contratante.value.second_last_name;
        }

        // if (vm.form.contratante.value.address_natural){
        //     vm.defaults.address = vm.form.contratante.value.address_natural;
        // } else{
        //     vm.defaults.address = vm.form.contratante.value.address_juridical;
        // }
        vm.defaults.address =
          vm.form.contratante &&
          vm.form.contratante.value &&
          vm.form.contratante.value.address_contractor;

        if (vm.form.contratante.value.phone_number) {
          vm.form.contratante.phone_number =
            vm.form.contratante.value.phone_number;
        }

        if (vm.form.contratante.value.email) {
          vm.form.contratante.email = vm.form.contratante.value.email;
        }

        try {
          if (vm.defaults.address.length == 1) {
            vm.form.address = vm.defaults.address[0];
            if (vm.form.address.administrative_area_level_1.state) {
              vm.form.address.administrative_area_level_1 =
                vm.form.address.administrative_area_level_1.state;
            }
            if (vm.form.address.administrative_area_level_2.city) {
              vm.form.address.administrative_area_level_2 =
                vm.form.address.administrative_area_level_2.city;
            }
          } else if (vm.defaults.address.length > 1) {
            vm.form.address = vm.defaults.address[0];
            if (vm.form.address.administrative_area_level_1.state) {
              vm.form.address.administrative_area_level_1 =
                vm.form.address.administrative_area_level_1.state;
            }
            if (vm.form.address.administrative_area_level_2.city) {
              vm.form.address.administrative_area_level_2 =
                vm.form.address.administrative_area_level_2.city;
            }
          }
        } catch (err) {}
      }
    });

    $scope.checkNumFianza = function () {
      if (vm.form.poliza_number) {
        helpers
          .existPolicyNumber(vm.form.poliza_number)
          .then(function (request) {
            if (request == true) {
              SweetAlert.swal(
                "Error",
                "El número de fianza ya existe.",
                "error"
              );
              vm.form.poliza_number = "";
            }
          })
          .catch(function (err) {});
      }
    };

    // funciones iniciales
    var curr_date = now.getDate();
    var curr_month = now.getMonth() + 1;
    var curr_year = now.getFullYear();
    providerService
      .getProviderFiByKey(curr_year + "-" + curr_month + "-" + curr_date)
      .then(
        function success(data) {
          vm.defaults.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );

    function checkDate(param) {
      if (!param) {
        return;
      }
      if (param.length == 10) {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        day = day - 1;
        if (day < 1) {
          month = month - 1;
          if (month < 1) {
            month = 12;
            year = year - 1;
          }
          if (month == 4 || month == 6 || month == 9 || month == 11) {
            day = 30;
          } else if (month == 2) {
            day = 28;
          } else {
            day = 31;
          }
        }
        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.endDate = datesFactory.convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        vm.form.start_of_validity = param;
        vm.form.end_of_validity = $scope.endDate;
      } else {
        var day = new Date().getDate();
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();

        day = day - 1;
        if (day < 1) {
          month = month - 1;
          if (month < 1) {
            month = 12;
            year = year - 1;
          }
          if (month == 4 || month == 6 || month == 9 || month == 11) {
            day = 30;
          } else if (month == 2) {
            day = 28;
          } else {
            day = 31;
          }
        }
        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.endDate = datesFactory.convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        vm.form.start_of_validity = param;
        vm.form.end_of_validity = $scope.endDate;
      }
      vm.form.startDate = param;
      var date1 = datesFactory.toDate(vm.form.start_of_validity);
      var date2 = datesFactory.toDate(vm.form.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      vm.form.policy_days_duration = Math.ceil(timeDiff / (1000 * 3600 * 24));

      if (vm.form.policy_days_duration > 365) {
        vm.form.endingDate = $scope.endDate;
      } else {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);
        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        vm.form.endingDate = datesFactory.convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
      }
    }

    function checkEndDate(param) {
      if (!param) {
        return;
      }
      if (param.length == 10) {
        if (process(param) < process(vm.form.start_of_validity)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }
        vm.form.end_of_validity = param;
      }
      var date1 = datesFactory.toDate(vm.form.start_of_validity);
      var date2 = datesFactory.toDate(vm.form.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      vm.form.policy_days_duration = Math.ceil(timeDiff / (1000 * 3600 * 24));

      if (vm.form.policy_days_duration > 365) {
        vm.form.endingDate = param;
      } else {
        var date_initial = vm.form.start_of_validity.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        vm.form.endingDate = datesFactory.convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
      }
    }

    $scope.$watch($stateParams, function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
    });

    function contratanteCreatorModalEvent() {
      console.log(vm.form);
      $rootScope.show_contractor = true;
      $scope.orderInfo = vm;
      $localStorage.orderForm = JSON.stringify(vm.form);
      $localStorage.save_created_fianza.show_contractor = true;
    }
    var myInsurance = $stateParams.myInsurance;
    if (myInsurance.url) {
      var contrac = {};
      contrac.contratanteId = myInsurance.id;
      if (myInsurance.type_person == "Fisica") {
        contrac.type = "fisicas";
      }
      if (myInsurance.type_person == "Moral") {
        contrac.type = "morales";
      }
      ContratanteService.getContratanteFull(contrac).then(function (
        contractor
      ) {
        vm.form.contratante = {};
        $scope.vm.form.contratante = {};
        if (contractor.cellule) {
          // $http.get(contractor.cellule)
          $http
            .get(
              contractor.cellule.url
                ? contractor.cellule.url
                : contractor.cellule
            )
            .then(function success(respo) {
              $scope.celulaSelected = respo.data;
            });
        }
        if (contractor) {
          if ($scope.referenciadores) {
            $scope.referenciadores.some(function (user) {
              if (user.url == contractor.vendor) {
                $scope.referenciadorArray[0] = {
                  referenciador: user.id,
                  comision_vendedor: "",
                };
              }
            });
          }
          if (contractor.address_contractor) {
            if (contractor.address_contractor) {
              // $scope.caratula.contractor = contractor.id;
              $scope.addresses = contractor.address_contractor;
              $scope.vm.form.address = $scope.addresses;
              vm.form.address = $scope.addresses;
            }
            if ($scope.addresses.length == 1) {
              vm.form.address = $scope.addresses;
              $scope.vm.form.address = $scope.addresses;
              $scope.addressSelected = $scope.addresses[0];
              // $scope.caratula.address = $scope.addresses[0].id;
            }
          }
        }

        if (contractor.first_name) {
          vm.form.contratante.val =
            contractor.first_name +
            " " +
            contractor.last_name +
            " " +
            contractor.second_last_name;
          vm.form.contratante.label =
            contractor.first_name +
            " " +
            contractor.last_name +
            " " +
            contractor.second_last_name;
        }
        if (contractor.full_name) {
          vm.form.contratante.val = contractor.full_name;
          vm.form.contratante.label = contractor.full_name;
        }
        if (contractor.address_contractor) {
          vm.form.address = contractor.address_contractor;
          $scope.addresses = contractor.address_contractor;
        }
        $scope.addressSelected = $scope.addresses[0];
        vm.form.contratante.value = contractor;
        vm.form.contratante.value.email = contractor.email;
        $scope.vm.form.contratante = vm.form.contratante;
      });
    }
    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = 0;
      var word_data = vm.form.contratante.val;
      if (word_data) {
        if (word_data.length >= 3) {
          if (vm.org_name == "ancora") {
            $scope.show_contratante = "contractors-match-fianzas/";
          } else {
            $scope.show_contratante = "contractors-match/";
          }
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
            })
            .then(function (response) {
              // if(response.status === 200 && (response.data.juridicals || response.data.naturals)) {
              if (response.status === 200 && response.data.contractors) {
                var source = [];
                // var juridicals = response.data.juridicals;
                // var naturals = response.data.naturals;

                // if(juridicals.length) {
                //   juridicals.forEach(function(item) {
                //     var obj = {
                //       label: item.j_name,
                //       value: item
                //     };
                //     source.push(obj)
                //   });
                // } else if(naturals.length) {
                //   naturals.forEach(function(item) {
                //     if(item.full_name) {
                //       var obj = {
                //         label: item.full_name,
                //         value: item
                //       };
                //     } else {
                //      var obj = {
                //         label: item.first_name+' '+ item.last_name+' '+ item.second_last_name,
                //         value: item
                //       };
                //     }

                //   source.push(obj)
                // });
                // }
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
        $scope.contractors_data = [];
      }
    };

    $scope.agregarBeneficiario = function (parWord) {
      var beneficiario = parWord.value;
      if (parWord.value) {
        if (vm.form.subforms.beneficiaries_fianza.length == 1) {
          if (
            vm.form.subforms.beneficiaries_fianza[0].first_name == "" &&
            vm.form.subforms.beneficiaries_fianza[0].j_name == "" &&
            vm.form.subforms.beneficiaries_fianza[0].rfc == "" &&
            vm.form.subforms.beneficiaries_fianza[0].email == ""
          ) {
            vm.form.subforms.beneficiaries_fianza[0] = beneficiario;
          } else {
            vm.form.subforms.beneficiaries_fianza.push({
              first_name: beneficiario.first_name,
              last_name: beneficiario.last_name,
              second_last_name: beneficiario.second_last_name,
              j_name: beneficiario.j_name,
              rfc: beneficiario.rfc,
              email: beneficiario.email,
              phone_number: beneficiario.phone_number,
              type_person: beneficiario.type_person,
              url: beneficiario.url,
              id: beneficiario.id,
            });
          }

          // vm.form.subforms.beneficiaries_fianza[0] = beneficiario;
        } else {
          vm.form.subforms.beneficiaries_fianza.push({
            first_name: beneficiario.first_name,
            last_name: beneficiario.last_name,
            second_last_name: beneficiario.second_last_name,
            j_name: beneficiario.j_name,
            rfc: beneficiario.rfc,
            email: beneficiario.email,
            phone_number: beneficiario.phone_number,
            type_person: beneficiario.type_person,
            url: beneficiario.url,
            id: beneficiario.id,
          });
        }
      }
    };

    $scope.matchesBeneficiary = function (parWord) {
      $scope.beneficiaries_data = [];
      var word_data = parWord;
      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_contratante = "BeneficiariesExistentes/";
          // $http.get(url.IP + $scope.show_contratante+'&'+'matchWord='+parWord)
          $http({
            method: "GET",
            url: url.IP + $scope.show_contratante,
            params: {
              matchWord: parWord,
            },
          }).then(function (response) {
            if (response.status === 200) {
              $timeout(function () {
                $scope.beneficiaries_data = [];
                response.data.results.forEach(function (item) {
                  $scope.beneficiaries_data.push({
                    label: item.type_person == 1 ? item.full_name : item.j_name,
                    value: item,
                  });
                });
              }, 1000);
            } else {
              $scope.beneficiaries_data = [];
            }
          });
        }
      }
    };

    function aseguradoraSelection() {
      if (vm.form.afianzadora) {
        get_claves();
      }

      $http
        .get(url.IP + "ramos-by-provider/" + vm.form.afianzadora.id)
        .then(
          function success(response) {
            vm.defaults.ramos = response.data;
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    }

    function get_claves() {
      var date = new Date(vm.form.start_of_validity);
      if (isNaN(date)) {
        var date = new Date(datesFactory.mesDiaAnio(vm.form.start_of_validity));
      }

      $http
        .get(url.IP + "claves-by-provider/" + vm.form.afianzadora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
              });
            });

            vm.defaults.claves = clavesResponse.data;
            if (vm.defaults.claves.length == 1) {
              vm.form.clave = vm.defaults.claves[0];
              try {
                vm.form.comision_percent = vm.form.clave.comission;
                vm.form.udi = vm.form.clave.udi;
              } catch (e) {}
            }
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }

    function changeRamo() {
      vm.defaults.subramos = vm.form.ramo.subramo_ramo;
      vm.defaults.subramos.forEach(function (subramo, index) {
        if (subramo.subramo_name == "Colectivas") {
          vm.defaults.subramos.splice(index, 1);
        }
        if (vm.form.ramo.subramo_ramo.length == index + 1) {
          if ($localStorage["save_created_fianza"]["subramo"]) {
            vm.form.subramo = $localStorage["save_created_fianza"]["subramo"];
          }
        }
      });
    }

    function changeSubramo(s) {
      if (vm.form.subramo) {
        vm.defaults.types = vm.form.subramo.type_subramo;
        get_claves();
      }

      vm.defaults.formInfo = {
        code: vm.form.subramo.subramo_code,
        name: vm.form.subramo.subramo_name,
      };
      vm.defaults.comisiones = [];

      if (vm.form.clave) {
        if (vm.form.clave.clave_comision.length) {
          vm.form.clave.clave_comision.forEach(function (item) {
            if (vm.form.subramo.subramo_name == item.subramo) {
              vm.defaults.comisiones.push(item);
            }
          });

          if (vm.defaults.comisiones) {
            if (!vm.defaults.comisiones.length) {
              SweetAlert.swal(
                {
                  title: "Error",
                  text: "Debe tener al menos una comisión capturada para la clave seleccionada",
                  type: "error",
                  showCancelButton: false,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Aceptar",
                  cancelButtonText: "Cancelar",
                  closeOnConfirm: true,
                },
                function (isConfirm) {
                  if (isConfirm) {
                  }
                }
              );
            }
          }

          if (vm.defaults.comisiones.length == 1) {
            vm.form.comision = vm.defaults.comisiones[0];
          }
        }
      }
    }

    function changeTipo(tipo) {}

    $scope.addReferenciador = function (type) {
      var addReferenciadores = {
        referenciador: "",
      };
      vm.form.referenciadores.push(addReferenciadores);
    };

    $scope.deleteReferenciador = function (index, type) {
      vm.form.referenciadores.splice(index, 1);
    };

    function addBene() {
      var beneficiario = {
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        type_person: 1,
      };
      vm.form.subforms.beneficiaries_fianza.push(beneficiario);
    }

    function deleteBene(index) {
      if (vm.form.subforms.beneficiaries_fianza.length > 1) {
        vm.form.subforms.beneficiaries_fianza.splice(index, 1);
      }
    }

    $scope.validateDecimalMontoTotal = function (input) {
      if (parseFloat(input) <= 0 || input == "") {
        vm.form.subforms.contract.value = 0;
        vm.form.subforms.contract.amount_iva = 0;
      } else {
        vm.form.subforms.contract.value = parseFloat(input).toFixed(2);
        var valor_am = parseFloat(
          $scope.formatearNumero_calculate(vm.form.subforms.contract.amount)
        ).toFixed(2);
        if (vm.form.subforms.contract.amount) {
          if (valor_am == "NaN") {
            toaster.error("Revise el formato del Monto del Contrato.");
            vm.form.subforms.contract.amount_iva = parseFloat(0).toFixed(2);
            return;
          } else if (valor_am) {
            vm.form.subforms.contract.amount_iva = parseFloat(
              parseFloat(parseFloat(valor_am) * 0.16) + parseFloat(valor_am)
            ).toFixed(2);
          }
        }
      }
    };

    $scope.formatNumber = function (valor) {
      var nums = new Array();
      var simb = ",";

      if (!valor) {
        return;
      }

      if (typeof valor == "number") {
        return valor;
      } else {
        valor = valor.toString();
        nums = valor.split("");
        var long = nums.length - 1;
        var patron = 3;
        var prox = 2;
        var res = "";

        while (long > prox) {
          if (prox == 2) {
          } else {
            nums.splice(long - prox, 0, simb);
          }
          prox += patron;
        }
        nums.splice(0, 0);

        for (var i = 0; i <= nums.length - 1; i++) {
          res += nums[i];
        }

        return valor;
      }
    };
    $scope.formatearNumero_calculate = function (nStr, campo) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";

      var cadenas = x1.split(",");
      var cadena_sin_comas = "";
      for (i = 0; i < cadenas.length; i++) {
        cadena_sin_comas = cadena_sin_comas + cadenas[i];
      }
      if (
        cadena_sin_comas != undefined &&
        cadena_sin_comas != "undefined" &&
        cadena_sin_comas != "NaN" &&
        cadena_sin_comas != NaN
      ) {
        return cadena_sin_comas + x2;
      } else {
        return nStr;
      }
    };
    $scope.formatearNumero = function (nStr, campo) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";

      var cadenas = x1.split(",");
      var cadena_sin_comas = "";
      for (i = 0; i < cadenas.length; i++) {
        cadena_sin_comas = cadena_sin_comas + cadenas[i];
      }
      if (
        cadena_sin_comas != undefined &&
        cadena_sin_comas != "undefined" &&
        cadena_sin_comas != "NaN" &&
        cadena_sin_comas != NaN
      ) {
        var value = cadena_sin_comas + x2.replace(/,/g, "");
        value = parseFloat(value).toLocaleString("en-US", {
          style: "decimal",
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });
        if (value == "NaN") {
          value = 0;
        }
        if (campo == 1) {
          vm.form.subforms.contract.amount = value;
        }
        if (campo == 2) {
          vm.form.subforms.contract.guarantee_amount = value;
        }
        return value;
      } else {
        var value = nStr.replace(/,/g, "");
        value = parseFloat(value).toLocaleString("en-US", {
          style: "decimal",
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });
        if (value == "NaN") {
          value = 0;
        }
        if (campo == 1) {
          vm.form.subforms.contract.amount = value;
        }
        if (campo == 2) {
          vm.form.subforms.contract.guarantee_amount = value;
        }
        return value;
      }
    };

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    $scope.renewalSelection = function (ren) {
      vm.form.renewal.is_renewable = ren;
    };

    $scope.save = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.form.subforms.contract) {
        if (vm.form.subforms.contract.description) {
          if (vm.form.subforms.contract.description.length >= 500) {
            l.stop();
            toaster.error(
              "La descripción del detalle de garantía no puede ser mayor o igual de 500 caracteres"
            );
            return;
          }
        }
      }
      if (vm.form.status != 1) {
        if (
          !vm.form.poliza_number ||
          vm.form.poliza_number == undefined ||
          vm.form.poliza_number == ""
        ) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.FIANZANOREQUIRED, "error");
          return;
        }
      }
      if (
        vm.form.subforms.contract.rate &&
        parseInt(vm.form.subforms.contract.rate) > 100
      ) {
        l.stop();
        toaster.error(
          "El valor de la tarifa aplicable no puede ser mayor de 100"
        );
        return;
      }

      if (
        vm.form.subforms.contract.guarantee_percentage &&
        parseInt(vm.form.subforms.contract.guarantee_percentage) > 100
      ) {
        l.stop();
        toaster.error(
          "El valor del Porcentaje a garantizar no puede ser mayor de 100"
        );
        return;
      }

      if (vm.form.subforms.contract) {
        if (vm.form.subforms.contract.description) {
          if (vm.form.subforms.contract.description.length >= 500) {
            l.stop();
            toaster.error(
              "La descripción del detalle de garantía no puede ser mayor o igual de 500 caracteres"
            );
            return;
          }
        }
      }

      if (!vm.form.afianzadora && !vm.form.afianzadora.url) {
        l.stop();
        toaster.error("Seleccione una afianzadora");
        return;
      }
      if (!vm.form.ramo) {
        l.stop();
        toaster.error("Seleccione un ramo");
        return;
      }
      if (!vm.form.subramo) {
        l.stop();
        toaster.error("Seleccione un subramo");
        return;
      }
      if (!vm.form.clave) {
        l.stop();
        toaster.error("Seleccione una clave");
        return;
      }
      if (
        !vm.form.tipo &&
        (vm.defaults && vm.defaults.types
          ? vm.defaults.types.length > 0
          : false)
      ) {
        l.stop();
        toaster.error("Seleccione un tipo");
        return;
      }
      if (!vm.form.contratante.value) {
        l.stop();
        toaster.error("Seleccione un contratante");
        return;
      }
      if (!vm.form.address) {
        l.stop();
        toaster.error("Seleccione una direccion");
        return;
      }

      // var flag = false;
      // if (vm.form.referenciadores.length > 0){
      //   vm.form.referenciadores.forEach(function(ref){
      //     if(!ref.referenciador){
      //       toaster.error('Seleccione un referenciador');
      //       flag  = true;
      //     }

      //     if(!ref.comision_vendedor && vm.form.referenciadores.length != 1){
      //       toaster.error('Todos los referenciadores deben tener porcentaje de comisión');
      //       flag  = true;
      //     }
      //   });
      // }

      // if (flag){
      //   return;
      // }

      if (!vm.form.subforms.contract.description) {
        l.stop();
        toaster.error("Agrega la descripción en el Detalle de Garantía");
        return;
      }
      if (vm.form.subforms.contract.guarantee_amount != "0") {
        if (!vm.form.subforms.contract.guarantee_amount) {
          l.stop();
          toaster.error(
            "Agrega el monto a garantizar en el Detalle de Garantía, número"
          );
          return;
        }
      }
      if (vm.form.subforms.contract.rate != 0) {
        if (!vm.form.subforms.contract.rate) {
          l.stop();
          toaster.error("Agrega la tarifa en el Detalle de Garantía");
          return;
        }
      }

      if (
        vm.form.subramo.subramo_code == 20 ||
        vm.form.subramo.subramo_code == 21
      ) {
        if (
          !vm.form.subforms.contract.number ||
          !vm.form.subforms.contract.start ||
          !vm.form.subforms.contract.end ||
          !vm.form.subforms.contract.sign_date
        ) {
          l.stop();
          toaster.error(
            "Llene todos los campos del detalle de garantía para subramo obra o proveeduria"
          );
          return;
        }

        if (vm.form.subforms.contract.amount != "0") {
          if (!vm.form.subforms.contract.amount) {
            l.stop();
            toaster.error("Agrega el monto de contrato, número");
            return;
          }
        }
        if (vm.form.subforms.contract.amount_iva != 0) {
          if (!vm.form.subforms.contract.amount_iva) {
            l.stop();
            toaster.error("Agrega el monto de contrato con iva");
            return;
          }
        }
        // if (vm.form.subforms.contract.guarantee_percentage != 0){
        //   if (!vm.form.subforms.contract.guarantee_percentage){
        //     l.stop();
        //     toaster.error('Agrega el porcentaje a garantizar');
        //     return;
        //   }
        // }
      }

      if (vm.form.ramo.ramo_code == 4 && vm.form.subramo.subramo_code == 15) {
        if (!vm.form.subforms.contract.business_activity) {
          l.stop();
          toaster.error("Agrega el giro de la empresa");
          return;
        }
        if (!vm.form.subforms.contract.employee_name) {
          l.stop();
          toaster.error("Agrega el nombre del empleado");
          return;
        }
        if (!vm.form.subforms.contract.activity) {
          l.stop();
          toaster.error("Agrega la actividad");
          return;
        }
        if (vm.form.subforms.contract.deductible_percentage != 0) {
          if (!vm.form.subforms.contract.deductible_percentage) {
            l.stop();
            toaster.error("Agrega el deducible");
            return;
          }
        }
      }

      var ben_flag = false;
      vm.form.subforms.beneficiaries_fianza.forEach(function (beneficiario) {
        if (beneficiario.type_person == 1) {
          if (beneficiario.first_name == "") {
            l.stop();
            toaster.error("Ingrese campo de nombre");
            ben_flag = true;
          }

          // if (beneficiario.rfc  == '' ){
          //   toaster.error('Ingrese campo de RFC')
          //   ben_flag = true;
          // }

          beneficiario.last_name;
          beneficiario.email;
          beneficiario.phone_number == "";
          beneficiario.j_name = "";
        } else {
          if (beneficiario.j_name == "") {
            l.stop();
            toaster.error("Ingrese campo de razon social");
            ben_flag = true;
          }
          // if (beneficiario.rfc  == '' ){
          //   toaster.error('Ingrese campo de RFC')
          //   ben_flag = true;
          // }
          beneficiario.first_name = "";
          beneficiario.last_name = "";
          beneficiario.email == "";
          beneficiario.phone_number == "";
        }
      });

      if (ben_flag) return;

      try {
        if (vm.form.subforms.contract.amount) {
          var val = parseFloat(
            $scope.formatearNumero_calculate(vm.form.subforms.contract.amount)
          ).toFixed(2);

          if (val == "NaN") {
            l.stop();
            toaster.error("Revise el formato del Monto del Contrato.");
            return;
          }
        }
      } catch (err) {
        console.log("idddddddd", err);
      }
      try {
        var val = parseFloat(
          $scope.formatearNumero_calculate(
            vm.form.subforms.contract.guarantee_amount
          )
        ).toFixed(2);
        if (val == "NaN") {
          l.stop();
          toaster.error("Revise el formato del Monto a Garantizar.");
          return;
        }
      } catch (err) {
        console.log("idddddddd", err);
      }
      var payload = {
        address: vm.form.address.url,
        aseguradora: vm.form.afianzadora.url,
        clave: vm.form.clave.url,
        comision: 0,
        comision_percent: 0,
        contract_poliza: {
          start:
            vm.form.subforms.contract.start != ""
              ? vm.form.subforms.contract.start
              : null,
          end:
            vm.form.subforms.contract.end != ""
              ? vm.form.subforms.contract.end
              : null,
          number:
            vm.form.subforms.contract.number != ""
              ? vm.form.subforms.contract.number
              : 0,
          contract_object:
            vm.form.subforms.contract.contract_object != ""
              ? vm.form.subforms.contract.contract_object
              : 0,
          amount: vm.form.subforms.contract.amount
            ? parseFloat(
                $scope.formatearNumero_calculate(
                  vm.form.subforms.contract.amount
                )
              ).toFixed(2)
            : 0,
          amount_iva:
            vm.form.subforms.contract.amount_iva != ""
              ? vm.form.subforms.contract.amount_iva
              : null,
          guarantee_percentage: vm.form.subforms.contract.guarantee_percentage
            ? vm.form.subforms.contract.guarantee_percentage
            : 0,
          guarantee_amount: vm.form.subforms.contract.guarantee_amount
            ? parseFloat(
                $scope.formatearNumero_calculate(
                  vm.form.subforms.contract.guarantee_amount
                )
              ).toFixed(2)
            : 0,
          rate: vm.form.subforms.contract.rate
            ? vm.form.subforms.contract.rate
            : 0,
          sign_date:
            vm.form.subforms.contract.sign_date != ""
              ? vm.form.subforms.contract.sign_date
              : null,
          activity:
            vm.form.subforms.contract.activity != ""
              ? vm.form.subforms.contract.activity
              : null,
          business_activity:
            vm.form.subforms.contract.business_activity != ""
              ? vm.form.subforms.contract.business_activity
              : null,
          employee_name:
            vm.form.subforms.contract.employee_name != ""
              ? vm.form.subforms.contract.employee_name
              : null,
          no_employees:
            vm.form.subforms.contract.no_employees != ""
              ? vm.form.subforms.contract.no_employees
              : null,
          description:
            vm.form.subforms.contract.description != ""
              ? vm.form.subforms.contract.description
              : null,
          deductible_percentage: vm.form.subforms.contract.deductible_percentage
            ? vm.form.subforms.contract.deductible_percentage
            : 0,
        },
        emision_status: 1,
        end_of_validity: vm.form.end_of_validity,
        fianza_type: vm.form.tipo ? vm.form.tipo.url : null,
        folio: vm.form.folio,
        // "natural":( vm.form.contratante && vm.form.contratante.value.type_person && vm.form.contratante.value.type_person == 'Fisica' ) ? vm.form.contratante.value.url : null ,
        // "juridical":( vm.form.contratante && vm.form.contratante.value.type_person && vm.form.contratante.value.type_person == 'Moral' ) ? vm.form.contratante.value.url : null ,
        contractor: vm.form.contratante.value.url,
        ramo: vm.form.ramo.url,
        recibos_poliza: [],
        start_of_validity: vm.form.start_of_validity,
        status: vm.form.status,
        subramo: vm.form.subramo.url,
        beneficiaries_poliza: [],
        beneficiaries_poliza_many: [],
        ref_policy: [],
        observations: vm.form.observations,
        is_renewable: vm.form.renewal ? vm.form.renewal.selected : 2,
        f_currency: vm.form.currency ? vm.form.currency.currency_selected : 1,
        bono_variable: vm.form.bono_variable ? vm.form.bono_variable : 0,
        date_emision_factura: vm.form.date_emision_factura
          ? datesFactory.toDate(vm.form.date_emision_factura)
          : null,
        date_maquila: vm.form.date_maquila
          ? datesFactory.toDate(vm.form.date_maquila)
          : null,
        date_bono: vm.form.date_bono
          ? datesFactory.toDate(vm.form.date_bono)
          : null,
        year_factura: vm.form.year_factura ? vm.form.year_factura : 0,
        month_factura: vm.form.month_selected ? vm.form.month_selected : 0,
        folio_factura: vm.form.folio_factura ? vm.form.folio_factura : "",
        maquila: vm.form.maquila ? parseFloat(vm.form.maquila).toFixed(2) : 0,
        exchange_rate: vm.form.exchange_rate
          ? parseFloat(vm.form.exchange_rate).toFixed(2)
          : 0,
        fecha_entrega: vm.form.fecha_entrega
          ? datesFactory.toDate(vm.form.fecha_entrega)
          : null,
      };
      try {
        payload.start_of_validity = datesFactory.toDate(
          vm.form.start_of_validity
        );
      } catch (err) {
        l.stop();
        toaster.error("Revise la fecha de inicio");
        return;
      }
      try {
        payload.end_of_validity = datesFactory.toDate(vm.form.end_of_validity);
      } catch (err) {
        l.stop();
        toaster.error("Revise la fecha de inicio");
        return;
      }

      if (
        vm.form.subramo.subramo_code == 20 ||
        vm.form.subramo.subramo_code == 21
      ) {
        try {
          payload.contract_poliza["end"] = datesFactory.toDate(
            vm.form.subforms.contract["end"]
          );
          payload.contract_poliza["start"] = datesFactory.toDate(
            vm.form.subforms.contract["start"]
          );
          payload.contract_poliza["sign_date"] = datesFactory.toDate(
            vm.form.subforms.contract["sign_date"]
          );
        } catch (err) {
          l.stop();
          toaster.error("Revise las fechas del contrato");
          return;
        }
      } else {
        payload.contract_poliza["end"] = new Date();
        payload.contract_poliza["start"] = new Date();
        payload.contract_poliza["sign_date"] = new Date();
      }

      var nombres = [];
      vm.form.subforms.beneficiaries_fianza.forEach(function (beneficiario) {
        var ref = {
          email: beneficiario.email,
          first_name: beneficiario.first_name,
          full_name:
            beneficiario.first_name +
            " " +
            beneficiario.last_name +
            " " +
            beneficiario.second_last_name,
          j_name: beneficiario.j_name,
          last_name: beneficiario.last_name,
          type_person: beneficiario.type_person,
          phone_number: beneficiario.phone_number,
          rfc: beneficiario.rfc,
          second_last_name: beneficiario.second_last_name,
          id: beneficiario.id ? beneficiario.id : null,
          url: beneficiario.url ? beneficiario.url : null,
        };
        payload["beneficiaries_poliza_many"].push(ref);
        if (beneficiario.type_person == 1) {
          nombres.push(
            beneficiario.first_name +
              "_" +
              beneficiario.last_name +
              "_" +
              beneficiario.second_last_name
          );
        } else {
          nombres.push(beneficiario.j_name);
        }
      });

      var bname = vm.form.ramo.ramo_name;
      if (nombres.length > 0) bname = nombres[0];
      payload["identifier"] =
        vm.form.subramo.subramo_name +
        "_" +
        bname +
        "_" +
        payload["contract_poliza"]["description"];
      if (payload["identifier"].length >= 500) {
        payload["identifier"] = payload["identifier"].substring(0, 500);
      }

      if (vm.form.referenciadores) {
        vm.form.referenciadores.forEach(function (referenciador) {
          if (referenciador.referenciador) {
            var ref = {
              referenciador: referenciador.referenciador,
              comision_vendedor: referenciador.comision_vendedor
                ? referenciador.comision_vendedor
                : 0,
            };
            payload["ref_policy"].push(ref);
          }
        });
      }
      if (payload["ref_policy"].length == 0 && vm.acceso_obligatorio_ref) {
        l.stop();
        SweetAlert.swal(
          "Error",
          "Seleccione al menos un referenciador",
          "error"
        );
        return;
      }

      var recibo = {};
      if (vm.form.status != 1) {
        try {
          recibo = angular.copy($scope.dataToSave.recibos_poliza[0]);
        } catch (err) {
          console.log(err);
          l.stop();
          SweetAlert.swal("Error", "Genere el recibo de la fianza", "error");
          return;
        }
        payload["poliza_number"] = vm.form.poliza_number;
        payload["folio"] = vm.form.folio;
        payload["emision_date"] = datesFactory.toDate(vm.form.emision_date);

        try {
          recibo["vencimiento"] = datesFactory.toDate(recibo["vencimiento"]);
          recibo["fecha_inicio"] = datesFactory.toDate(recibo["startDate"]);
          recibo["fecha_fin"] = datesFactory.toDate(recibo["endingDate"]);
        } catch (err) {}

        payload["recibos_poliza"] = [recibo];

        payload["comision"] = recibo.comision;
        payload["derecho"] = recibo.derecho;
        payload["iva"] = recibo.iva;
        payload["p_neta"] = recibo.prima_neta;
        payload["p_total"] = recibo.prima_total;
        payload["rpf"] = recibo.rpf;
        payload["sub_total"] = recibo.sub_total;
        payload["comision_percent"] = $scope.dataToSave.comision_percent;
      }

      // if(recibo.fecha_inicio < payload.start_of_validity || recibo.fecha_inicio > payload.end_of_validity){
      //   toaster.error('La fecha de inicio del recibo está fuera de la vigencia de la fianza');
      //   return;
      // }

      // if(recibo.fecha_fin < payload.start_of_validity || recibo.fecha_fin > payload.end_of_validity){
      //   toaster.error('La fecha de fin del recibo está fuera de la vigencia de la fianza');
      //   return;
      // }

      if (
        vm.form.status != 1 &&
        payload["recibos_poliza"] &&
        payload["recibos_poliza"].length <= 0
      ) {
        l.stop();
        SweetAlert.swal("Error", "Debe generar primer recibo", "error");
        return;
      }

      if (
        vm.form.status != 1 &&
        new Date() >= payload["start_of_validity"] &&
        new Date() < payload["end_of_validity"]
      ) {
        payload["status"] = 14;
      }

      if (new Date() > payload["end_of_validity"]) {
        payload["status"] = 13;
      }

      payload.programa_de_proveedores_contractor = $scope.programa_contractor
        ? $scope.programa_contractor
        : null;
      payload.has_programa_de_proveedores = $scope.has_programa_de_proveedores
        ? true
        : false;

      if (
        $rootScope.from_task &&
        $rootScope.task_associated &&
        $rootScope.task_associated.url
      ) {
        payload.from_task = $rootScope.from_task;
        payload.task_associated = $rootScope.task_associated.id;
      }
      $http.post(url.IP + "fianzas/", payload).then(function (response) {
        if (response.status == 201) {
          if (
            $rootScope.from_task &&
            $rootScope.task_associated &&
            $rootScope.task_associated.url
          ) {
            $http.patch($rootScope.task_associated.url, {
              ot_model: 1,
              ot_id_reference: response.data.id,
            });
          }
          if ($scope.countFile > 0) {
            $scope.param = response.data;
            uploadFiles(response.data["id"]);
          } else {
            if (response.data.poliza_number) {
              l.stop();
              SweetAlert.swal(
                "¡Listo!",
                "Fianza creada exitosamente.",
                "success"
              );
              $localStorage["save_created_fianza"] = {};
              $state.go("fianzas.info", { polizaId: response.data["id"] });
            }
            if (!response.data.poliza_number) {
              l.stop();
              SweetAlert.swal(
                "¡Listo!",
                "Proyecto de fianza creado exitosamente.",
                "success"
              );
              $localStorage["save_created_fianza"] = {};
              $state.go("fianzas.info", { polizaId: response.data["id"] });
            }
          }
        } else {
          l.stop();
          SweetAlert.swal("Error", "Ocurrio un problema", "error");
          return;
        }
      });
      // $http.patch(vm.form.contratante.value.url, {'email':vm.form.contratante.email, 'phone_number': vm.form.contratante.phone_number});
    };

    function cancel() {
      $localStorage["save_created_fianza"] = {};
      $state.go("fianzas.list");
    }

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });
    $scope.countFile = 0;
    $scope.okFile = 0;
    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.uploader.queue.length) {
        $timeout(function () {
          if ($scope.param.poliza_number) {
            SweetAlert.swal(
              "¡Listo!",
              "Fianza creada exitosamente.",
              "success"
            );
          }
          if (!$scope.param.poliza_number) {
            SweetAlert.swal(
              "¡Listo!",
              "Proyecto de Fianza creado exitosamente.",
              "success"
            );
          }
          $state.go("fianzas.info", { polizaId: $scope.param.id });
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
        order.options.checkDate("initial");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
        order.options.checkDate("initial");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      // fileItem.file.name = fileItem.file.name.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '')
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales, renombre y, vuelva a cargarlo. " +
            $scope.specialchar,
          "error"
        );
      }
    };
    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    $scope.saveFiles = function (poliza) {
      if ($scope.uploader.queue.length == 0) {
        $state.go("fianzas.info", { polizaId: poliza });
      } else {
        uploadFiles(poliza);
      }
    };

    function uploadFiles(polizaId) {
      $scope.polizaId = polizaId;
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $timeout(function () {
        $scope.uploader.uploadAll();
        $localStorage["save_created_fianza"] = {};
      }, 1000);
    }

    $scope.matchesShows = function (parWord) {
      if (parWord) {
        if (parWord.length >= 3) {
          if (vm.org_name == "ancora") {
            $scope.show_contratante = "contractors-match-fianzas/";
          } else {
            $scope.show_contratante = "contractors-match/";
          }
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: false,
              pp: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("vm.contratante.value", function (newValue, oldValue) {
      if (vm.contratante) {
        if (vm.contratante.value.address_contractor) {
          if (vm.contratante.value.address_contractor) {
            $scope.programa_contractor = vm.contratante.value.url;
            $scope.has_programa_de_proveedores = true;
          }
        }
      }
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("FianzasColectividadesCtrl", FianzasColectividadesCtrl);

  FianzasColectividadesCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "FileUploader",
    "providerService",
    "$http",
    "url",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "$uibModalInstance",
    "$timeout",
    "$rootScope",
    "$localStorage",
    "$stateParams",
    "helpers",
    "datesFactory",
  ];

  function FianzasColectividadesCtrl(
    $sessionStorage,
    $scope,
    FileUploader,
    providerService,
    $http,
    url,
    $state,
    SweetAlert,
    MESSAGES,
    $uibModalInstance,
    $timeout,
    $rootScope,
    $localStorage,
    $stateParams,
    helpers,
    datesFactory
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var order = this;
    var vm = this;
    order.org_name = usr.org;
    order.renewal = {};
    order.renewal.is_renewable = 2;
    order.renewal.options = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.surety = {};
    $scope.showPF = true;
    $scope.providers = [];
    $scope.claves = [];
    $scope.ramos = [];
    $scope.subramos = [];
    $scope.currencys = [
      { value: 1, label: "Pesos" },
      { value: 2, label: "Dólares" },
    ];
    $scope.month = {};
    $scope.month.month_selected = 0;
    $scope.month.options = [
      { value: 0, label: "" },
      { value: 1, label: "Enero" },
      { value: 2, label: "Febrero" },
      { value: 3, label: "Marzo" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Mayo" },
      { value: 6, label: "Junio" },
      { value: 7, label: "Julio" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Septiembre" },
      { value: 10, label: "Octubre" },
      { value: 11, label: "Noviembre" },
      { value: 12, label: "Diciembre" },
    ];
    $scope.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 10; i >= oldYear; i--) {
      $scope.years.push(i);
    }
    $scope.currencySelected = $scope.currencys[0].value;
    $rootScope.show_contractor = false;
    $scope.create_natural = true;
    $scope.create_juridical = true;
    $scope.referenciadores = [];
    $scope.referenciadorArray = [];
    $scope.referenciadoresSelected = [];
    $scope.categories = [
      {
        name: "",
        deductible: "",
        observations: "",
        document_type: 5,
      },
    ];
    $scope.beneficiaries = [
      {
        type_person: 1,
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        full_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        poliza: null,
        usuario: null,
      },
    ];
    $scope.directiveReceipts = [];
    $scope.dataToSave = [];

    $scope.dataSurety = [];
    $scope.dataCategories = [];

    $scope.show_certificates = false;
    $scope.showTableCertificates = false;
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certificates = [];

    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          order.acceso_fianzas = perm;
          order.acceso_fianzas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                order.acceso_adm_fia = true;
              } else {
                order.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                order.acceso_ver_fia = true;
              } else {
                order.acceso_ver_fia = false;
              }
            } else if (acc.permission_name == "Proyecto de fianza") {
              if (acc.checked == true) {
                order.acceso_proy_fia = true;
              } else {
                order.acceso_proy_fia = false;
                $scope.showPF = false;
              }
            }
          });
        }
        if (perm.model_name == "Reportes") {
          order.acceso_reportes = perm;
          order.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                order.acceso_rep_fia = true;
              } else {
                order.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                order.acceso_rep_sin = true;
              } else {
                order.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                order.acceso_rep_end = true;
              } else {
                order.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                order.acceso_rep_pol = true;
              } else {
                order.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                order.acceso_rep_ren = true;
              } else {
                order.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                order.acceso_rep_cob = true;
              } else {
                order.acceso_rep_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            }
          });
        }
        if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          order.acceso_refereciador = perm;
          order.acceso_refereciador.permissions.forEach(function (acc) {
            if (acc.permission_name == "Cambiar refrenciador en pólizas") {
              if (acc.checked == true) {
                order.acceso_chng_ref = true;
              } else {
                order.acceso_chng_ref = false;
              }
            }
            if (acc.permission_name == "Referenciador no obligatorio") {
              if (acc.checked == true) {
                order.acceso_obligatorio_ref = false;
              } else {
                order.acceso_obligatorio_ref = true;
              }
            }
          });
        }
      });
    }

    activate();

    $scope.hideButtonOT = function () {
      $scope.showPF = true;
    };

    $scope.hideButtonSurety = function () {
      $scope.showPF = false;
    };

    $scope.returnToPolicy = function () {
      $rootScope.show_contractor = false;
    };
    $scope.checkFechaBono = function (date) {
      $scope.date_bono = date;
    };
    $scope.checkFechaFactura = function (date) {
      var date_initial = date.split("/");
      var day = date_initial[0];
      var month = date_initial[1];
      var year = parseInt(date_initial[2]);
      $scope.month.month_selected = parseInt(month);
      $scope.year_factura = parseInt(year);
      $scope.date_emision_factura = date;
      $scope.month.options.forEach(function (item) {
        if (item.value == $scope.month.month_selected) {
          item.month_selected = item.value;
          $scope.month.month_selected = item.month_selected;
        }
      });
    };
    $scope.checkFechaMaquila = function (date) {
      $scope.date_maquila = date;
    };
    $scope.changeFolio = function (param) {
      $scope.folio_factura = param;
    };
    $scope.changeMaquila = function (param) {
      $scope.maquila = param;
    };
    order.changemonth = changemonth;
    function changemonth(param) {
      $scope.month.month_selected = param.month_selected;
    }
    $scope.changeyaer = function (param) {
      $scope.year_factura = param;
    };
    $scope.changeExchange = function (param) {
      $scope.exchange_rate = param;
    };
    $scope.checkDate = function (param) {
      if (param.length == 10) {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        day = day - 1;
        if (day < 1) {
          month = month - 1;
          if (month < 1) {
            month = 12;
            year = year - 1;
          }
          if (month == 4 || month == 6 || month == 9 || month == 11) {
            day = 30;
          } else if (month == 2) {
            day = 28;
          } else {
            day = 31;
          }
        }
        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.startDate = param;
        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.surety.start_of_validity = toDate(param);
        $scope.surety.end_of_validity = toDate($scope.endDate);
      } else {
        var day = new Date().getDate();
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();

        day = day - 1;
        if (day < 1) {
          month = month - 1;
          if (month < 1) {
            month = 12;
            year = year - 1;
          }
          if (month == 4 || month == 6 || month == 9 || month == 11) {
            day = 30;
          } else if (month == 2) {
            day = 28;
          } else {
            day = 31;
          }
        }
        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.surety.start_of_validity = toDate(param);
        $scope.surety.end_of_validity = toDate($scope.endDate);
      }
      $scope.directiveReceipts.startDate = param;
      var date1 = new Date($scope.surety.start_of_validity);
      var date2 = new Date($scope.surety.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );

      if ($scope.directiveReceipts.policy_days_duration > 365) {
        $scope.directiveReceipts.endingDate = $scope.endDate;
      } else {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.directiveReceipts.endingDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
      }
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }
        $scope.surety.end_of_validity = toDate(param);
      }
      var date1 = new Date($scope.surety.start_of_validity);
      var date2 = new Date($scope.surety.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );

      if ($scope.directiveReceipts.policy_days_duration > 365) {
        $scope.directiveReceipts.endingDate = param;
      } else {
        var date_initial = $scope.startDate.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.directiveReceipts.endingDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.directiveReceipts.startDate = convertDate($scope.startDate);
      }
    };

    function activate() {
      $scope.dataToSave.is_renewable = 2;
      getInternalNumber();
      $scope.startDate = convertDate(new Date());
      $scope.surety.emision_date = convertDate(new Date());
      // $scope.checkDate($scope.startDate);

      fillProvider();

      $http
        .get(url.IP + "get-vendors/")
        .then(function (user) {
          user.data.forEach(function (u) {
            u.first_name = u.first_name.toUpperCase();
            u.last_name = u.last_name.toUpperCase();
            u.name =
              u.first_name.toUpperCase() + " " + u.last_name.toUpperCase();
          });
          $scope.referenciadores = user.data;
          var vendedor = {
            referenciador: "",
            comision_vendedor: "",
          };
          $scope.referenciadorArray.push(vendedor);
          $scope.checkDate($scope.startDate);
        })
        .catch(function (e) {
          console.log("error", e);
        });
      $scope.dataToSave.startDate = $scope.startDate;
      $scope.dataToSave.endingDate = $scope.endDate;
      $scope.directiveReceipts.endingDate = $scope.endDate;
      $scope.directiveReceipts.startDate = $scope.startDate;
      if ($scope.aseguradoraSelected) {
        $http
          .get(url.IP + "claves-by-provider/" + $scope.aseguradoraSelected.id)
          .then(function success(clavesResponse) {
            $scope.claves = clavesResponse.data;
            if ($scope.claves.length == 1) {
              $scope.surety.clave = $scope.claves[0].url;
              $scope.claveSelected = $scope.claves[0];
            }
          })
          .catch(function (error) {
            console.log("Error - claves-by-provider - catch", error);
          });

        $http
          .get(url.IP + "ramos-by-provider/" + $scope.aseguradoraSelected.id)
          .then(
            function success(response) {
              $scope.ramos = response.data;
              $scope.ramos.forEach(function (item) {
                if (item.ramo_name == "Fidelidad") {
                  $scope.ramoSelected = item;
                  $scope.surety.ramo = item.url;
                  $scope.subramos = item.subramo_ramo;
                  $scope.subramos.forEach(function (subramo) {
                    if (subramo.subramo_name == "Colectivas") {
                      $scope.subramoSelected = subramo;
                      $scope.surety.subramo = subramo.url;
                      $scope.subramosTypes = subramo.type_subramo;
                      $scope.directiveReceipts.subramo = subramo;

                      var comisiones = [];
                      if ($scope.claveSelected.clave_comision.length) {
                        $scope.claveSelected.clave_comision.forEach(function (
                          item
                        ) {
                          if (
                            $scope.subramoSelected.subramo_name == item.subramo
                          ) {
                            comisiones.push(item);
                          }
                        });
                      }

                      $scope.directiveReceipts.comisiones = comisiones;
                      $scope.directiveReceipts.domiciliado = false;
                      $scope.directiveReceipts.payment = 5;
                    }
                  });
                }
              });
            },
            function error(e) {
              console.log("Error - ramos-by-provider", e);
            }
          )
          .catch(function (error) {
            console.log("Error - ramos-by-provider - catch", error);
          });
      }
      $scope.referenciadorArray = $scope.referenciadorArray;
      $scope.categories = [
        {
          name: "",
          deductible: "",
          observations: "",
          document_type: 5,
        },
      ];
      $scope.beneficiaries = [
        {
          type_person: 1,
          first_name: "",
          last_name: "",
          second_last_name: "",
          j_name: "",
          full_name: "",
          rfc: "",
          email: "",
          phone_number: "",
          poliza: null,
          usuario: null,
        },
      ];
    }

    $scope.saveLocalstorange = function () {
      // $localStorage['save_created_fianza_coletiva']['internal_number'] =  $scope.surety.internal_number;
      // $localStorage['save_created_fianza_coletiva']['poliza_number'] =  $scope.surety.poliza_number;
      // $localStorage['save_created_fianza_coletiva']['emision_date'] =  $scope.surety.emision_date;
      // $localStorage['save_created_fianza_coletiva']['startDate'] =  $scope.startDate;
      // $localStorage['save_created_fianza_coletiva']['endDate'] =  $scope.endDate;
      // $localStorage['save_created_fianza_coletiva']['contacto'] =  order.contacto;
      // $localStorage['save_created_fianza_coletiva']['addressSelected'] =  $scope.addressSelected;
      // $localStorage['save_created_fianza_coletiva']['bono_variable'] =  $scope.surety.bono_variable;
      // $localStorage['save_created_fianza_coletiva']['date_bono'] =  $scope.date_bono;
      // $localStorage['save_created_fianza_coletiva']['referenciadores'] =  $scope.referenciadorArray;
      // $localStorage['save_created_fianza_coletiva']['contract_poliza'] =  $scope.surety.contract_poliza;
      // $localStorage['save_created_fianza_coletiva']['categories'] =  $scope.categories;
      // $localStorage['save_created_fianza_coletiva']['beneficiaries'] =  $scope.beneficiaries;
      // $localStorage['save_created_fianza_coletiva']['date_emision_factura'] =  $scope.date_emision_factura;
      // $localStorage['save_created_fianza_coletiva']['month'] =  $scope.month.month_selected;
      // $localStorage['save_created_fianza_coletiva']['year_factura'] =  $scope.year_factura;
      // $localStorage['save_created_fianza_coletiva']['folio_factura'] =  $scope.folio_factura;
      // $localStorage['save_created_fianza_coletiva']['maquila'] =  $scope.maquila;
      // $localStorage['save_created_fianza_coletiva']['date_maquila'] =  $scope.date_maquila;
      // $localStorage['save_created_fianza_coletiva']['exchange_rate'] =  $scope.exchange_rate;
    };

    function getInternalNumber() {
      $http({
        method: "POST",
        url: url.IP + "internal-number/",
      })
        .then(
          function success(response) {
            if (response.status === 200 || response.status === 201) {
              $scope.surety.internal_number = "OT000" + response.data.id;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log("error", e);
        });
    }

    function fillProvider() {
      var d = $scope.startDate;
      try {
        var day = d.getDate();
        var month = d.getMonth() + 1;
        var year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var day = f.getDate();
        var month = f.getMonth() + 1;
        var year = f.getFullYear();
      }

      var date = year + "-" + month + "-" + day;
      providerService.getProviderFiByKey(date).then(
        function success(data) {
          $scope.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function toDate(dateStr) {
      if (dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(
          dateParts[2],
          dateParts[1] - 1,
          dateParts[0]
        ).toISOString(); // month is 0-based
        return dateObject;
      }
    }

    $scope.checkNumPolicy = function () {
      if ($scope.surety.poliza_number) {
        helpers
          .existPolicyNumber($scope.surety.poliza_number)
          .then(function (request) {
            if (request == true) {
              SweetAlert.swal(
                "Error",
                "El número de fianza ya existe.",
                "error"
              );
              $scope.surety.poliza_number = "";
            }
          })
          .catch(function (err) {});
      }
    };

    $scope.getClaves = function (param) {
      $scope.surety.aseguradora = param;
      $http
        .get(url.IP + "claves-by-provider/" + $scope.surety.aseguradora.id)
        .then(function success(clavesResponse) {
          $scope.claves = clavesResponse.data;
          if ($scope.claves.length == 1) {
            $scope.surety.clave = $scope.claves[0].url;
            $scope.claveSelected = $scope.claves[0];
          }
        })
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      $http
        .get(url.IP + "ramos-by-provider/" + $scope.surety.aseguradora.id)
        .then(
          function success(response) {
            $scope.ramos = response.data;
            $scope.ramos.forEach(function (item) {
              if (item.ramo_name == "Fidelidad") {
                $scope.ramoSelected = item;
                $scope.surety.ramo = item.url;
                $scope.subramos = item.subramo_ramo;
                $scope.subramos.forEach(function (subramo) {
                  if (subramo.subramo_name == "Colectivas") {
                    $scope.subramoSelected = subramo;
                    $scope.surety.subramo = subramo.url;
                    $scope.subramosTypes = subramo.type_subramo;

                    $scope.directiveReceipts.subramo = subramo;

                    var comisiones = [];
                    if ($scope.claveSelected.clave_comision.length) {
                      $scope.claveSelected.clave_comision.forEach(function (
                        item
                      ) {
                        if (param.subramo_name == item.subramo) {
                          comisiones.push(item);
                        }
                      });
                    }

                    $scope.directiveReceipts.comisiones = comisiones;
                    $scope.directiveReceipts.domiciliado = false;
                    $scope.directiveReceipts.payment = 5;
                  }
                });
              }
            });
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    $scope.refreshProvider = function () {
      fillProvider();
    };

    var myInsurance = $stateParams.myInsurance;
    if (myInsurance.url) {
      if (!order.contacto) {
        order.contacto = {};
      }
      order.contacto.value = $stateParams.myInsurance;
    }

    $scope.changeClave = function (param) {
      if (param) {
        $scope.surety.clave = param.url;
        $scope.claveSelected = param;
      }
    };

    $scope.changeSubramoType = function (param) {
      $scope.fianza_type = param;
      console.log("param", param);
      $scope.surety.fianza_type = param.url;
    };

    $scope.changeCurrency = function (param) {
      $scope.currencySelected = param;
      $scope.surety.f_currency = param;
    };

    $scope.contratanteCreatorModalEvent = function () {
      $rootScope.show_contractor = true;
      $scope.orderInfo = vm;
      $localStorage.orderForm = JSON.stringify($scope.surety);
    };

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          if (order.org_name == "ancora") {
            $scope.show_contratante = "contractors-match-fianzas/";
          } else {
            $scope.show_contratante = "contractors-match/";
          }
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: false,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                // var juridicals = response.data.juridicals;
                // var naturals = response.data.naturals;

                // if(juridicals.length) {
                //   juridicals.forEach(function(item){
                //     var obj = {
                //       label: item.j_name,
                //       value: item
                //     };
                //     source.push(obj);
                //   });
                // }
                // if(naturals.length) {
                //   naturals.forEach(function(item){
                //     if(item.full_name) {
                //       var obj = {
                //         label: item.full_name,
                //         value: item
                //       };
                //     } else {
                //      var obj = {
                //         label: item.first_name+' '+ item.last_name+' '+ item.second_last_name,
                //         value: item
                //       };
                //     }
                //     source.push(obj);
                //   });
                // }
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contacto.value", function (newValue, oldValue) {
      if (order.contacto) {
        if ($scope.referenciadores) {
          $scope.referenciadores.some(function (user) {
            if (user.url == order.contacto.value.vendor) {
              if (true) {
                $scope.referenciadorArray[0] = {
                  referenciador: user.url,
                };
              }
            }
          });
        }
        // if(order.contacto.value.address_natural || order.contacto.value.address_juridical){
        if (order.contacto.value.address_contractor) {
          // if(order.contacto.value.address_natural){
          //   $scope.surety.natural = order.contacto.value.url;
          //   $scope.surety.juridical = null;
          //   $scope.addresses = order.contacto.value.address_natural;
          // }else{
          //   $scope.surety.natural = null;
          //   $scope.surety.juridical = order.contacto.value.url;
          //   $scope.addresses = order.contacto.value.address_juridical;
          // }
          $scope.surety.contractor = order.contacto.value.url;
          $scope.addresses = order.contacto.value.address_contractor;
          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.surety.address = $scope.addresses[0].url;
          }
        }
      }
    });

    $scope.changeAddress = function (param) {
      $scope.surety.address = param.url;
    };

    $scope.addReferenciador = function () {
      var addReferenciadores = {
        referenciador: "",
        comision_vendedor: "",
      };
      $scope.referenciadorArray.push(addReferenciadores);
    };

    $scope.deleteReferenciador = function (index) {
      $scope.referenciadorArray.splice(index, 1);
    };

    $scope.changeComRef = function (param, index) {
      $scope.referenciadorArray[index].comision_vendedor = param;
    };

    $scope.valueGuarante = function (item) {
      if (item) {
        item = item.replace(/[^0-9.]/g, "");
        $scope.surety.contract_poliza.guarantee_amount = item;
      }
    };
    $scope.valuePercentageRate = function (item) {
      if (item) {
        item = item.replace(/[^0-9.]/g, "");
        $scope.surety.contract_poliza.rate = item;
      }
      if (item < 0) {
        $scope.surety.contract_poliza.rate = 0;
      } else if (item > 100) {
        $scope.surety.contract_poliza.rate = 100;
      }
    };

    $scope.addCategorie = function () {
      var category = {
        name: "",
        deductible: "",
        observations: "",
        document_type: 9,
      };
      $scope.categories.push(category);
    };

    $scope.deleteCategorie = function (index) {
      $scope.categories.splice(index, 1);
    };

    $scope.valuePercentage = function (item, index) {
      if (item < 0) {
        $scope.categories[index].deductible = 0;
      } else if (item > 100) {
        $scope.categories[index].deductible = 100;
      }
    };

    $scope.createIdentifier = function () {
      $scope.surety.identifier = "";
      $scope.surety.identifier =
        $scope.subramoSelected.subramo_name + "_" + $scope.categories[0].name;
    };

    $scope.matchesBeneficiary = function (parWord) {
      $scope.beneficiaries_data = [];
      var word_data = parWord;
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/BeneficiariesExistentes/';
          $scope.show_contratante = "BeneficiariesExistentes/";
          // $http.post(url.IP + $scope.show_contratante,
          //   {
          //     'matchWord': parWord
          //   })
          $http({
            method: "GET",
            url: url.IP + $scope.show_contratante,
            params: {
              matchWord: parWord,
            },
          }).then(function (response) {
            if (response.status === 200) {
              response.data.results.forEach(function (item) {
                $scope.beneficiaries_data.push({
                  label: item.type_person == 1 ? item.full_name : item.j_name,
                  value: item,
                });
              });
            }
          });
        }
      }
    };

    $scope.addBeneficiaries = function (item) {
      if (item) {
        if ($scope.beneficiaries.length == 1) {
          if (
            $scope.beneficiaries[0].first_name == "" &&
            $scope.beneficiaries[0].last_name == "" &&
            $scope.beneficiaries[0].j_name == "" &&
            $scope.beneficiaries[0].rfc == ""
          ) {
            $scope.beneficiaries[0] = item;
          } else {
            var beneficiary = {
              type_person: item.type_person,
              first_name: item.first_name,
              last_name: item.last_name,
              second_last_name: item.second_last_name,
              j_name: item.j_name,
              full_name: "",
              rfc: item.rfc,
              email: item.email,
              phone_number: item.phone_number,
              id: item.id,
              url: item.url,
              poliza: null,
              usuario: null,
            };
            $scope.beneficiaries.push(beneficiary);
          }
        } else {
          var beneficiary = {
            type_person: item.type_person,
            first_name: item.first_name,
            last_name: item.last_name,
            second_last_name: item.second_last_name,
            j_name: item.j_name,
            full_name: "",
            rfc: item.rfc,
            email: item.email,
            phone_number: item.phone_number,
            id: item.id,
            url: item.url,
            poliza: null,
            usuario: null,
          };
          $scope.beneficiaries.push(beneficiary);
        }
      }
    };

    $scope.addBeneficiary = function () {
      var beneficiary = {
        type_person: 1,
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        full_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        poliza: null,
        usuario: null,
      };
      $scope.beneficiaries.push(beneficiary);
    };

    $scope.deleteBeneficiary = function (index) {
      $scope.beneficiaries.splice(index, 1);
    };

    $scope.typePerson = function (param, index) {
      $scope.beneficiaries[index].type_person = param;
    };

    $scope.matchesShows = function (parWord, pp) {
      if (parWord) {
        if (parWord.length >= 3) {
          if (order.org_name == "ancora") {
            $scope.show_contratante = "contractors-match-fianzas/";
          } else {
            $scope.show_contratante = "contractors-match/";
          }
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: false,
              pp: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if (order.contratante.value.address_contractor) {
          if (order.contratante.value.address_contractor) {
            $scope.programa_contractor = order.contratante.value.url;
            $scope.has_programa_de_proveedores = true;
          }
        }
      }
    });

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item, options){
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
      $scope.okFile++;
      if ($scope.okFile == $scope.uploader.queue.length) {
        $timeout(function () {
          if ($scope.dataSurety.poliza_number) {
            SweetAlert.swal(
              "¡Listo!",
              "Fianza colectiva creada exitosamente.",
              "success"
            );
            $scope.show_certificates = true;
          }
          if (!$scope.dataSurety.poliza_number) {
            SweetAlert.swal(
              "¡Listo!",
              "Proyecto de fianza colectiva creado exitosamente.",
              "success"
            );
            $scope.show_certificates = true;
          }

          if ($uibModalInstance) {
            $uibModalInstance.close(200);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {};

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $scope.files = [];
      $scope.files_ = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.validityInsurance = function () {
      console.log("sureeeeeee", $scope.surety);
      if (!$scope.showPF) {
        if (!$scope.surety.poliza_number) {
          SweetAlert.swal("Error", MESSAGES.ERROR.FIANZANOREQUIRED, "error");
          return;
        }
        if (!$scope.dataToSave.recibos_poliza) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
      }
      if (!$scope.surety.aseguradora) {
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        return;
      }
      if (!$scope.surety.clave) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        return;
      }
      if (!$scope.surety.ramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        return;
      }
      if (!$scope.surety.subramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (!$scope.surety.fianza_type) {
        SweetAlert.swal(
          "Error",
          "Agrega un tipo de subramo de fidelidad colectiva.",
          "error"
        );
        return;
      }
      if (!order.contacto.val) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        return;
      }
      if (!$scope.surety.address) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        return;
      }
      if (!$scope.surety.contract_poliza.guarantee_amount) {
        SweetAlert.swal("Error", "Agrega el monto a garantizar.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.rate) {
        SweetAlert.swal("Error", "Agrega el monto a garantizar.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.activity) {
        SweetAlert.swal("Error", "Agrega el giro de la empresa.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.no_employees) {
        SweetAlert.swal("Error", "Agrega el número de empleados.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.description) {
        SweetAlert.swal(
          "Error",
          "Agrega el detalle adicional de garantía.",
          "error"
        );
        return;
      }
      var categoryFlag = false;
      $scope.categories.forEach(function (item, index) {
        if (item.name == "") {
          SweetAlert.swal(
            "Error",
            "Agrega un nombre a la carátula " + (index + 1) + ".",
            "error"
          );
          categoryFlag = true;
        }
        if (item.deductible == "") {
          SweetAlert.swal(
            "Error",
            "Agrega un porcentaje del deducible a la carátula " +
              (index + 1) +
              ".",
            "error"
          );
          categoryFlag = true;
        }
      });
      var beneficiaryFlag = false;
      $scope.beneficiaries.forEach(function (item, index) {
        if (item.type_person == 1) {
          if (item.name == "") {
            SweetAlert.swal(
              "Error",
              "Agrega un nombre al beneficiario " + (index + 1) + ".",
              "error"
            );
            beneficiaryFlag = true;
          }
          if (item.last_name == "") {
            SweetAlert.swal(
              "Error",
              "Agrega un apellido paterno al beneficiario " + (index + 1) + ".",
              "error"
            );
            beneficiaryFlag = true;
          }
          // if(item.second_last_name == ''){
          //   SweetAlert.swal('Error', 'Agrega un apellio materno al beneficiario ' + (index + 1) + '.', 'error');
          //   beneficiaryFlag = true;
          // }
        } else {
          if (item.j_name == "") {
            SweetAlert.swal(
              "Error",
              "Agrega una razón social al beneficiario " + (index + 1) + ".",
              "error"
            );
            beneficiaryFlag = true;
          }
        }
        // if(item.rfc == ''){
        //     SweetAlert.swal('Error', 'Agrega un rfc al beneficiario ' + (index + 1) + '.', 'error');
        //     beneficiaryFlag = true;
        //   }
      });
      if (!$scope.surety.identifier) {
        SweetAlert.swal("Error", MESSAGES.ERROR.IDENTIFIERREQUIRED, "error");
        return;
      }
      $scope.referenciadoresSelected = [];
      $scope.referenciadorArray.forEach(function (item) {
        if (item.referenciador != "") {
          if (item.comision_vendedor == "") {
            item.comision_vendedor = 0;
          }
          $scope.referenciadoresSelected.push(item);
        }
      });
      if (beneficiaryFlag || categoryFlag) {
        return;
      } else {
        $scope.saveSurety();
      }
    };
    $scope.renewalSelection = function () {
      $scope.dataToSave.is_renewable = order.renewal.selected;
    };

    $scope.saveSurety = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (
        $scope.referenciadoresSelected.length == 0 &&
        order.acceso_obligatorio_ref
      ) {
        l.stop();
        SweetAlert.swal(
          "Error",
          "Agrega al menos un referenciador para la fidelidad colectiva.",
          "error"
        );
        return;
      }

      if ($scope.dataToSave.recibos_poliza) {
        $scope.dataToSave.recibos_poliza.forEach(function (item) {
          item.fecha_inicio = toDate(item.startDate);
          item.fecha_fin = toDate(item.endingDate);
          item.vencimiento = toDate(item.vencimiento);
        });
      }
      $scope.surety.poliza_number = $scope.surety.poliza_number
        ? $scope.surety.poliza_number
        : null;
      $scope.surety.document_type = 8;
      $scope.surety.forma_de_pago = 5;
      if ($scope.aseguradoraSelected && $scope.aseguradoraSelected.url) {
        $scope.surety.aseguradora = $scope.aseguradoraSelected.url;
      } else if ($scope.surety.aseguradora && $scope.surety.aseguradora.url) {
        $scope.surety.aseguradora = $scope.surety.aseguradora.url;
      }
      $scope.surety.folio = "";
      $scope.surety.emision_date = $scope.surety.emision_date
        ? toDate($scope.surety.emision_date)
        : null;
      $scope.surety.fecha_anuencia = null;
      $scope.surety.is_renewable = 1;
      $scope.surety.status = $scope.showPF ? 1 : 14;
      $scope.surety.status_emision = 1;
      $scope.surety.monto_afianzado = null;
      $scope.surety.tarifa_afianzada = null;
      $scope.surety.p_neta = $scope.dataToSave.p_neta
        ? $scope.dataToSave.p_neta
        : 0;
      $scope.surety.descuento = $scope.dataToSave.descuento
        ? $scope.dataToSave.descuento
        : 0;
      $scope.surety.rpf = $scope.dataToSave.rpf ? $scope.dataToSave.rpf : 0;
      $scope.surety.derecho = $scope.dataToSave.derecho
        ? $scope.dataToSave.derecho
        : 0;
      $scope.surety.sub_total = $scope.dataToSave.sub_total
        ? $scope.dataToSave.sub_total
        : 0;
      $scope.surety.iva = $scope.dataToSave.iva ? $scope.dataToSave.iva : 0;
      $scope.surety.p_total = $scope.dataToSave.p_total
        ? $scope.dataToSave.p_total
        : 0;
      $scope.surety.comision = $scope.dataToSave.comision
        ? $scope.dataToSave.comision
        : 0;
      $scope.surety.comision_percent = $scope.dataToSave.comision_percent
        ? $scope.dataToSave.comision_percent
        : 0;
      $scope.surety.recibos_poliza = $scope.dataToSave.recibos_poliza
        ? $scope.dataToSave.recibos_poliza
        : [];
      $scope.surety.total_receipts = $scope.dataToSave.recibos_poliza
        ? $scope.dataToSave.recibos_poliza.length
        : 0;
      $scope.surety.is_renewable = $scope.dataToSave.is_renewable
        ? $scope.dataToSave.is_renewable
        : 2;
      $scope.surety.ref_policy = $scope.referenciadoresSelected;
      $scope.surety.beneficiaries_poliza = $scope.beneficiaries;
      ($scope.surety.bono_variable = $scope.surety.bono_variable
        ? $scope.surety.bono_variable
        : 0),
        // $scope.surety.beneficiaries_poliza_many = $scope.beneficiaries_old;
        ($scope.surety.f_currency = $scope.currencySelected
          ? $scope.currencySelected
          : 1);
      ($scope.surety.date_emision_factura = $scope.date_emision_factura
        ? toDate($scope.date_emision_factura)
        : null),
        ($scope.surety.date_bono = $scope.date_bono
          ? toDate($scope.date_bono)
          : null),
        ($scope.surety.date_maquila = $scope.date_maquila
          ? toDate($scope.date_maquila)
          : null),
        ($scope.surety.month_factura = $scope.month
          ? $scope.month.month_selected
          : 0),
        ($scope.surety.year_factura = $scope.year_factura
          ? $scope.year_factura
          : 0),
        ($scope.surety.maquila = $scope.maquila ? $scope.maquila : 0),
        ($scope.surety.folio_factura = $scope.folio_factura
          ? $scope.folio_factura
          : ""),
        ($scope.surety.exchange_rate = $scope.exchange_rate
          ? parseFloat($scope.exchange_rate).toFixed(2)
          : 0),
        ($scope.surety.programa_de_proveedores_contractor =
          $scope.programa_contractor ? $scope.programa_contractor : null);
      $scope.surety.has_programa_de_proveedores =
        $scope.has_programa_de_proveedores ? true : false;
      if (
        $scope.surety &&
        $scope.surety.contract_poliza &&
        $scope.surety.contract_poliza.guarantee_amount
      ) {
        $scope.surety.contract_poliza.guarantee_amount = $scope.surety
          .contract_poliza.guarantee_amount
          ? parseFloat($scope.surety.contract_poliza.guarantee_amount).toFixed(
              2
            )
          : 0;
      }
      if (
        $rootScope.from_task &&
        $rootScope.task_associated &&
        $rootScope.task_associated.url
      ) {
        $scope.surety.from_task = $rootScope.from_task;
        $scope.surety.task_associated = $rootScope.task_associated.id;
      }
      $http
        .post(url.IP + "fianzas_collective/", $scope.surety)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            $scope.dataSurety = response.data;
            if (
              $rootScope.from_task &&
              $rootScope.task_associated &&
              $rootScope.task_associated.url
            ) {
              $http.patch($rootScope.task_associated.url, {
                ot_model: 1,
                ot_id_reference: $scope.dataSurety.id,
              });
            }
            $scope.categories.forEach(function (item, index) {
              item.parent = response.data.id;
              item.caratula = response.data.id;
            });
            $localStorage.save_created_fianza_coletiva = {};
            $http
              .post(url.IP + "categories_collectivesurety/", $scope.categories)
              .then(function (request) {
                if (request.status == 200 || request.status == 201) {
                  $scope.dataCategories = request.data.data;
                  if ($scope.countFile > 0) {
                    l.stop();
                    uploadFiles($scope.dataSurety.id);
                  } else {
                    if ($scope.dataSurety.poliza_number) {
                      l.stop();
                      SweetAlert.swal(
                        "¡Listo!",
                        "Fianza colectiva creada exitosamente.",
                        "success"
                      );
                      $scope.goToInformation();
                      // $scope.show_certificates = true;
                    }
                    if (!$scope.dataSurety.poliza_number) {
                      l.stop();
                      SweetAlert.swal(
                        "¡Listo!",
                        "Proyecto de fianza colectiva creado exitosamente.",
                        "success"
                      );
                      $scope.goToInformation();
                      // $scope.show_certificates = true;
                    }
                  }
                } else {
                  l.stop();
                }
              })
              .catch(function (e) {
                l.stop();
                console.log("error - caratula - catch", e);
              });
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };

    $scope.cancel = function () {
      $state.go("fianzas.list");
    };

    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.TITULARES) {
        $scope.excelJson = param.TITULARES;
        $scope.excelJson.forEach(function (item) {
          if (!item.CERTIFICADO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.NOMBRE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.APELLIDO_PATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.APELLIDO_MATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.PUESTO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna PUESTO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.ACTIVIDAD) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ACTIVIDAD, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CATEGORIA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
        });
        if (!flagCertificate) {
          $scope.selectedCertificates = param;
          $scope.addViews(0);
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.cancelCertificates = function () {
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.saveCertificates = function () {
      $scope.loader = true;
      $scope.certificates = [];

      if ($scope.selectedCertificates.TITULARES) {
        $scope.selectedCertificates.TITULARES.forEach(function (item) {
          var personal = {
            certificate_number: parseInt(item.CERTIFICADO),
            email: item.CORREO ? item.CORREO : null,
            first_name: item.NOMBRE,
            last_name: item.APELLIDO_PATERNO,
            second_last_name: item.APELLIDO_MATERNO,
            rfc: item.RFC ? item.RFC : null,
            workstation: item.PUESTO ? item.PUESTO : null,
          };
          var certificateData = {
            caratula: $scope.dataSurety.id,
            certificate_number: parseInt(item.CERTIFICADO),
            parent: item.CATEGORIA,
            poliza_number:
              $scope.dataSurety.poliza_number + " - INC. " + item.CERTIFICADO,
            start_of_validity: $scope.dataSurety.start_of_validity,
            end_of_validity: $scope.dataSurety.end_of_validity,
            status: $scope.dataSurety.status,
            beneficiaries_poliza: personal,
            contract_poliza: {
              activity: item.ACTIVIDAD,
              amount: item.MONTO_A_GARANTIZAR ? item.MONTO_A_GARANTIZAR : null,
            },
            observations: item.OBSERVACIONES ? item.OBSERVACIONES : null,
            document_type: 10,
            identifier:
              item.NOMBRE +
              "_" +
              item.APELLIDO_PATERNO +
              "_" +
              item.APELLIDO_MATERNO,
          };
          $scope.certificates.push(certificateData);
        });
      }

      $http({
        method: "POST",
        url: url.IP + "certificates_collectivesurety/",
        data: $scope.certificates,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal("¡Listo!", MESSAGES.OK.CERTIFICATESDONE, "success");
            $state.go("fianzas.details", { polizaId: $scope.dataSurety.id });
          } else {
            $scope.loader = false;
            // SweetAlert.swal("ERROR",MESSAGES.ERROR.ERRORCERTIFICATES ,"error");
            SweetAlert.swal("ERROR", response.data, "error");
          }
        })
        .catch(function (e) {
          console.log("error - caratula - catch", e);
        });
    };

    $scope.goToInformation = function () {
      $state.go("fianzas.details", { polizaId: $scope.dataSurety.id });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "FianzasColectividadesRenewalCtrl",
      FianzasColectividadesRenewalCtrl
    );

  FianzasColectividadesRenewalCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "FileUploader",
    "providerService",
    "$http",
    "url",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "$uibModalInstance",
    "$timeout",
    "$rootScope",
    "$localStorage",
    "dataFactory",
    "$stateParams",
    "$location",
  ];

  function FianzasColectividadesRenewalCtrl(
    $sessionStorage,
    $scope,
    FileUploader,
    providerService,
    $http,
    url,
    $state,
    SweetAlert,
    MESSAGES,
    $uibModalInstance,
    $timeout,
    $rootScope,
    $localStorage,
    dataFactory,
    $stateParams,
    $location
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var order = this;
    order.renewal = {};
    order.renewal.is_renewable = 1;
    order.renewal.options = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.surety = {};
    $scope.showPF = true;
    $scope.origin_renewable = false;
    $scope.providers = [];
    $scope.claves = [];
    $scope.ramos = [];
    $scope.subramos = [];
    $scope.currencys = [
      { value: 1, label: "Pesos" },
      { value: 2, label: "Dólares" },
    ];

    $scope.month = {};
    $scope.month.month_selected = 1;
    $scope.month.options = [
      { value: 0, label: "" },
      { value: 1, label: "Enero" },
      { value: 2, label: "Febrero" },
      { value: 3, label: "Marzo" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Mayo" },
      { value: 6, label: "Junio" },
      { value: 7, label: "Julio" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Septiembre" },
      { value: 10, label: "Octubre" },
      { value: 11, label: "Noviembre" },
      { value: 12, label: "Diciembre" },
    ];
    $scope.currencySelected = $scope.currencys[0].value;
    $rootScope.show_contractor = false;
    $scope.create_natural = true;
    $scope.create_juridical = true;
    $scope.referenciadores = [];
    $scope.referenciadorArray = [];
    $scope.referenciadoresSelected = [];
    $scope.categories = [
      {
        name: "",
        deductible: "",
        observations: "",
        document_type: 5,
      },
    ];
    $scope.beneficiaries = [
      {
        type_person: 1,
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        full_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        poliza: null,
        usuario: null,
      },
    ];
    $scope.directiveReceipts = [];
    $scope.dataToSave = [];

    $scope.all_certificate = [];
    $scope.dataSurety = [];
    $scope.dataCategories = [];

    $scope.show_certificates = false;
    $scope.showTableCertificates = false;
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certificates = [];

    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          order.acceso_fianzas = perm;
          order.acceso_fianzas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                order.acceso_adm_fia = true;
              } else {
                order.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                order.acceso_ver_fia = true;
              } else {
                order.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          order.acceso_reportes = perm;
          order.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                order.acceso_rep_fia = true;
              } else {
                order.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                order.acceso_rep_sin = true;
              } else {
                order.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                order.acceso_rep_end = true;
              } else {
                order.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                order.acceso_rep_pol = true;
              } else {
                order.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                order.acceso_rep_ren = true;
              } else {
                order.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                order.acceso_rep_cob = true;
              } else {
                order.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            }
          });
        }
      });
    }

    if ($location.path().indexOf("reexpedir") != -1) {
      $scope.reexpedir = true;
    } else {
      $scope.reexpedir = false;
    }

    activate();

    $scope.hideButtonOT = function () {
      $scope.showPF = true;
    };

    $scope.hideButtonSurety = function () {
      $scope.showPF = false;
    };

    $scope.checkDate = function (param) {
      if (param.length == 10) {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        day = day - 1;
        if (day < 1) {
          month = month - 1;
          if (month < 1) {
            month = 12;
            year = year - 1;
          }
          if (month == 4 || month == 6 || month == 9 || month == 11) {
            day = 30;
          } else if (month == 2) {
            day = 28;
          } else {
            day = 31;
          }
        }
        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.startDate = param;
        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.surety.start_of_validity = toDate(param);
        $scope.surety.end_of_validity = toDate($scope.endDate);
      } else {
        var day = new Date().getDate();
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();

        day = day - 1;
        if (day < 1) {
          month = month - 1;
          if (month < 1) {
            month = 12;
            year = year - 1;
          }
          if (month == 4 || month == 6 || month == 9 || month == 11) {
            day = 30;
          } else if (month == 2) {
            day = 28;
          } else {
            day = 31;
          }
        }
        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.surety.start_of_validity = toDate(param);
        $scope.surety.end_of_validity = toDate($scope.endDate);
      }
      $scope.directiveReceipts.startDate = param;
      var date1 = new Date($scope.surety.start_of_validity);
      var date2 = new Date($scope.surety.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );

      if ($scope.directiveReceipts.policy_days_duration > 365) {
        $scope.directiveReceipts.endingDate = $scope.endDate;
      } else {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.directiveReceipts.endingDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
      }
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }
        $scope.surety.end_of_validity = toDate(param);
      }
      var date1 = new Date($scope.surety.start_of_validity);
      var date2 = new Date($scope.surety.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );

      if ($scope.directiveReceipts.policy_days_duration > 365) {
        $scope.directiveReceipts.endingDate = param;
      } else {
        var date_initial = $scope.startDate.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.directiveReceipts.endingDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
      }
    };

    function activate() {
      dataFactory
        .post("information_collectivesurety/", {
          caratula: $stateParams.polizaId,
        })
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            $scope.surety = response.data.data.collectivitySurety;
            $scope.original_surety = angular.copy(
              response.data.data.collectivitySurety
            );
            response.data.data.childs.forEach(function function_name(ct) {
              ct.deductible = ct.deductible ? parseFloat(ct.deductible) : 0;
            });
            $scope.categories = response.data.data.childs;
            $scope.beneficiaries =
              response.data.data.collectivitySurety.beneficiaries_poliza_many;
            $scope.startDate = convertDate($scope.surety.end_of_validity);
            $scope.aseguradoraSelected = $scope.surety.aseguradora;
            $scope.getClaves($scope.aseguradoraSelected, 1);
            $scope.currencySelected = $scope.surety.f_currency;

            // if($scope.surety.natural){
            //   order.contacto.value = $scope.surety.natural;
            //   order.contacto.val = $scope.surety.natural.full_name;
            // }else{
            //   order.contacto.value = $scope.surety.juridical;
            //   order.contacto.val = $scope.surety.juridical.j_name;
            // }
            order.contacto.value = $scope.surety.contractor;
            order.contacto.val = $scope.surety.contractor.full_name;
            $scope.addressSelected = $scope.surety.address;

            $scope.copy_contract_poliza = $scope.surety.contract_poliza;
            $scope.surety.contract_poliza = {};
            $scope.surety.contract_poliza.guarantee_amount = parseFloat(
              $scope.copy_contract_poliza.guarantee_amount
            );
            $scope.surety.bono_variable = $scope.surety.bono_variable
              ? parseFloat($scope.surety.bono_variable)
              : 0;
            $scope.surety.contract_poliza.rate = parseFloat(
              $scope.copy_contract_poliza.rate
            );
            $scope.surety.contract_poliza.activity =
              $scope.copy_contract_poliza.activity;
            $scope.surety.contract_poliza.no_employees =
              $scope.copy_contract_poliza.no_employees;
            $scope.surety.contract_poliza.description =
              $scope.copy_contract_poliza.description;
            order.renewal.is_renewable = $scope.surety.is_renewable;
            $scope.dataToSave.is_renewable = $scope.surety.is_renewable;
          }
          fillProvider();

          $scope.showPrograma = false;

          $http
            .get(url.IP + "get-vendors/")
            .then(function (user) {
              user.data.forEach(function (u) {
                u.first_name = u.first_name.toUpperCase();
                u.last_name = u.last_name.toUpperCase();
                u.name =
                  u.first_name.toUpperCase() + " " + u.last_name.toUpperCase();
              });
              $scope.referenciadores = user.data;
              var vendedor = {
                referenciador: "",
                comision_vendedor: "",
              };
              $scope.referenciadorArray.push(vendedor);
              $scope.checkDate($scope.startDate);
            })
            .catch(function (e) {
              console.log("error", e);
            });

          $scope.policy_history = {};
          $http({
            method: "GET",
            url: url.IP + "historic-policies/",
            params: {
              actual_id: $scope.surety.id,
            },
          })
            .then(function success(response) {
              if (response.data.results.length) {
                $scope.showHistoric = true;
              }
              $scope.policy_history = [];
              response.data.results.forEach(function function_name(old) {
                if ($scope.surety.id != old.base_policy.id) {
                  $scope.origin_renewable = true;
                  $scope.policy_history = old.base_policy;
                }
              });
            })
            .catch(function (e) {
              console.log("error - caratula - catch", e);
            });
        })
        .catch(function (e) {
          console.log("error", e);
        });

      getInternalNumber();
    }

    function getInternalNumber() {
      $http({
        method: "POST",
        url: url.IP + "internal-number/",
      })
        .then(
          function success(response) {
            if (response.status === 200 || response.status === 201) {
              $scope.surety.internal_number = "OT000" + response.data.id;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log("error", e);
        });
    }

    function fillProvider() {
      var d = $scope.startDate;
      try {
        var day = d.getDate();
        var month = d.getMonth() + 1;
        var year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var day = f.getDate();
        var month = f.getMonth() + 1;
        var year = f.getFullYear();
      }

      var date = year + "-" + month + "-" + day;
      providerService.getProviderFiByKey(date).then(
        function success(data) {
          $scope.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function toDate(dateStr) {
      if (dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(
          dateParts[2],
          dateParts[1] - 1,
          dateParts[0]
        ).toISOString(); // month is 0-based
        return dateObject;
      }
    }

    $scope.getClaves = function (param, value) {
      $scope.surety.aseguradora = param;
      $http
        .get(url.IP + "claves-by-provider/" + $scope.surety.aseguradora.id)
        .then(function success(clavesResponse) {
          $scope.claves = clavesResponse.data;
          if ($scope.claves.length == 1) {
            $scope.surety.clave = $scope.claves[0].url;
            $scope.claveSelected = $scope.claves[0];
          }
        })
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      $http
        .get(url.IP + "ramos-by-provider/" + $scope.surety.aseguradora.id)
        .then(
          function success(response) {
            $scope.ramos = response.data;
            $scope.ramos.forEach(function (item) {
              if (item.ramo_name == "Fidelidad") {
                $scope.ramoSelected = item;
                $scope.surety.ramo = item.url;
                $scope.subramos = item.subramo_ramo;
                $scope.subramos.forEach(function (subramo) {
                  if (subramo.subramo_name == "Colectivas") {
                    $scope.subramoSelected = subramo;
                    $scope.surety.subramo = subramo.url;
                    $scope.subramosTypes = subramo.type_subramo;

                    if (value == 1) {
                      $scope.subramosTypes.forEach(function (item) {
                        if (item.url == $scope.surety.fianza_type.url) {
                          $scope.subramoTypeSelected = item;
                        }
                      });
                    }

                    $scope.directiveReceipts.subramo = subramo;

                    var comisiones = [];
                    if ($scope.claveSelected.clave_comision.length) {
                      $scope.claveSelected.clave_comision.forEach(function (
                        item
                      ) {
                        if (param.subramo_name == item.subramo) {
                          comisiones.push(item);
                        }
                      });
                    }

                    $scope.directiveReceipts.comisiones = comisiones;
                    $scope.directiveReceipts.domiciliado = false;
                    $scope.directiveReceipts.payment = 5;

                    var data = {
                      caratula: $scope.surety.id,
                      status: 0,
                      parent: 0,
                      page: 1,
                    };
                    $http
                      .post(url.IP + "information_certCollSurety/", data)
                      .then(function (response) {
                        if (response.status == 200 || response.status == 201) {
                          $scope.all_certificate = response.data.results;
                          if (response.data.count > 10) {
                            var total = response.data.count / 10;
                            var array_certificate = total.toString().split(".");
                            var integer = parseFloat(array_certificate[0]);
                            var float = parseFloat(array_certificate[1]);

                            if (float > 0) {
                              integer++;
                            }
                            for (var i = 2; i <= integer; i++) {
                              var data = {
                                caratula: $scope.surety.id,
                                status: 0,
                                parent: 0,
                                page: i,
                              };
                              $http
                                .post(
                                  url.IP + "information_certCollSurety/",
                                  data
                                )
                                .then(function (response) {
                                  response.data.results.forEach(function (
                                    certificate
                                  ) {
                                    $scope.all_certificate.push(certificate);
                                  });
                                })
                                .catch(function (e) {
                                  console.log("error - caratula - catch", e);
                                });
                            }
                          }
                        }
                      })
                      .catch(function (e) {
                        console.log("error - caratula - catch", e);
                      });
                  }
                });
              }
            });
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    $scope.refreshProvider = function () {
      fillProvider();
    };

    $scope.changeClave = function (param) {
      if (param) {
        $scope.surety.clave = param.url;
        $scope.claveSelected = param;
      }
    };

    $scope.changeSubramoType = function (param) {
      $scope.surety.fianza_type = param.url;
    };

    $scope.changeCurrency = function (param) {
      $scope.surety.f_currency = param;
    };

    $scope.contratanteCreatorModalEvent = function () {
      $rootScope.show_contractor = true;
      $scope.orderInfo = vm;
      $localStorage.orderForm = JSON.stringify($scope.surety);
    };

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match-fianzas/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: false,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                // var juridicals = response.data.juridicals;
                // var naturals = response.data.naturals;

                // if(juridicals.length) {
                //   juridicals.forEach(function(item){
                //     var obj = {
                //       label: item.j_name,
                //       value: item
                //     };
                //     source.push(obj);
                //   });
                // }
                // if(naturals.length) {
                //   naturals.forEach(function(item){
                //     if(item.full_name) {
                //       var obj = {
                //         label: item.full_name,
                //         value: item
                //       };
                //     } else {
                //      var obj = {
                //         label: item.first_name+' '+ item.last_name+' '+ item.second_last_name,
                //         value: item
                //       };
                //     }
                //     source.push(obj);
                //   });
                // }
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contacto.value", function (newValue, oldValue) {
      if (order.contacto) {
        $scope.addresses = [];
        // if(order.contacto.value.address_natural || order.contacto.value.address_juridical){
        if (order.contacto.value.address_contractor) {
          // if(order.contacto.value.address_natural){
          //   $scope.surety.natural = order.contacto.value.url;
          //   $scope.surety.juridical = null;
          //   if(order.contacto.value.address_natural[0].id){
          //     $scope.addresses = order.contacto.value.address_natural;
          //   }else{
          //     order.contacto.value.address_natural.forEach(function(address){
          //       $http.get(address).then(function(addressResponse){
          //         $scope.addresses.push(addressResponse.data);
          //       });
          //     });
          //   }
          // }else{
          //   $scope.surety.natural = null;
          //   $scope.surety.juridical = order.contacto.value.url;
          //   if(order.contacto.value.address_juridical[0].id){
          //     $scope.addresses = order.contacto.value.address_juridical;
          //   }else{
          //     order.contacto.value.address_juridical.forEach(function(address){
          //       $http.get(address).then(function(addressResponse){
          //         $scope.addresses.push(addressResponse.data);
          //       });
          //     });
          //   }
          // }
          $scope.surety.contractor = order.contacto.value.url;
          if (order.contacto.value.address_contractor[0].id) {
            $scope.addresses = order.contacto.value.address_contractor;
          } else {
            order.contacto.value.address_contractor.forEach(function (address) {
              $http.get(address).then(function (addressResponse) {
                $scope.addresses.push(addressResponse.data);
              });
            });
          }
          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.surety.address = $scope.addresses[0].url;
          }
        }
      }
    });

    $scope.changeAddress = function (param) {
      if (param) {
        $scope.surety.address = param.url;
      }
    };

    $scope.addReferenciador = function () {
      var addReferenciadores = {
        referenciador: "",
        comision_vendedor: "",
      };
      $scope.referenciadorArray.push(addReferenciadores);
    };

    $scope.deleteReferenciador = function (index) {
      $scope.referenciadorArray.splice(index, 1);
    };

    $scope.changeComRef = function (param, index) {
      $scope.referenciadorArray[index].comision_vendedor = param;
    };

    $scope.valuePercentageRate = function (item) {
      if (item < 0) {
        $scope.surety.contract_poliza.rate = 0;
      } else if (item > 100) {
        $scope.surety.contract_poliza.rate = 100;
      }
    };

    $scope.addCategorie = function () {
      var category = {
        name: "",
        deductible: "",
        observations: "",
        document_type: 9,
      };
      $scope.categories.push(category);
    };

    $scope.deleteCategorie = function (index) {
      $scope.categories.splice(index, 1);
    };

    $scope.valuePercentage = function (item, index) {
      if (item < 0) {
        $scope.categories[index].deductible = 0;
      } else if (item > 100) {
        $scope.categories[index].deductible = 100;
      }
    };

    $scope.createIdentifier = function () {
      $scope.surety.identifier = "";
      $scope.surety.identifier =
        $scope.subramoSelected.subramo_name + "_" + $scope.categories[0].name;
    };

    $scope.matchesBeneficiary = function (parWord) {
      $scope.beneficiaries_data = [];
      var word_data = parWord;
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/BeneficiariesExistentes/';
          $scope.show_contratante = "BeneficiariesExistentes/";
          // $http.post(url.IP + $scope.show_contratante,
          //   {
          //     'matchWord': parWord
          //   })
          $http({
            method: "GET",
            url: url.IP + $scope.show_contratante,
            params: {
              matchWord: parWord,
            },
          }).then(function (response) {
            if (response.status === 200) {
              response.data.results.forEach(function (item) {
                $scope.beneficiaries_data.push({
                  label: item.type_person == 1 ? item.full_name : item.j_name,
                  value: item,
                });
              });
            }
          });
        }
      }
    };

    $scope.addBeneficiaries = function (item) {
      if ($scope.beneficiaries.length == 1) {
        if (
          $scope.beneficiaries[0].first_name == "" &&
          $scope.beneficiaries[0].last_name == "" &&
          $scope.beneficiaries[0].j_name == "" &&
          $scope.beneficiaries[0].rfc == ""
        ) {
          $scope.beneficiaries[0] = item;
        } else {
          var beneficiary = {
            type_person: item.type_person,
            first_name: item.first_name,
            last_name: item.last_name,
            second_last_name: item.second_last_name,
            j_name: item.j_name,
            full_name: "",
            rfc: item.rfc,
            email: item.email,
            phone_number: item.phone_number,
            id: item.id,
            url: item.url,
            poliza: null,
            usuario: null,
          };
          $scope.beneficiaries.push(beneficiary);
        }
      } else {
        var beneficiary = {
          type_person: item.type_person,
          first_name: item.first_name,
          last_name: item.last_name,
          second_last_name: item.second_last_name,
          j_name: item.j_name,
          full_name: "",
          rfc: item.rfc,
          email: item.email,
          phone_number: item.phone_number,
          id: item.id,
          url: item.url,
          poliza: null,
          usuario: null,
        };
        $scope.beneficiaries.push(beneficiary);
      }
    };

    $scope.addBeneficiary = function () {
      var beneficiary = {
        type_person: 1,
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        full_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        poliza: null,
        usuario: null,
      };
      $scope.beneficiaries.push(beneficiary);
    };

    $scope.deleteBeneficiary = function (index) {
      $scope.beneficiaries.splice(index, 1);
    };

    $scope.typePerson = function (param, index) {
      $scope.beneficiaries[index].type_person = param;
    };

    $scope.matchesShows = function (parWord) {
      if (parWord) {
        if (parWord.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match-fianzas/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var juridicals = response.data.juridicals;
                var naturals = response.data.naturals;

                if (juridicals.length) {
                  juridicals.forEach(function (item) {
                    var obj = {
                      label: item.j_name,
                      value: item,
                    };
                    source.push(obj);
                  });
                }
                if (naturals.length) {
                  naturals.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if (order.contratante.value.address_contractor) {
          if (order.contratante.value.address_contractor) {
            $scope.programa_contractor = order.contratante.value.url;
            $scope.has_programa_de_proveedores = true;
          }
        }
      }
    });

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item, options){
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
      $scope.okFile++;
      if ($scope.okFile == $scope.uploader.queue.length) {
        $timeout(function () {
          SweetAlert.swal(
            "¡Listo!",
            "Renovación creada exitosamente.",
            "success"
          );
          $scope.show_certificates = true;

          if ($uibModalInstance) {
            $uibModalInstance.close(200);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {};

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $scope.files = [];
      $scope.files_ = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.validityInsurance = function () {
      if (!$scope.showPF) {
        if (!$scope.surety.poliza_number) {
          SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
          return;
        }
        if (!$scope.dataToSave.recibos_poliza) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
      }
      if (!$scope.surety.aseguradora) {
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        return;
      }
      if (!$scope.surety.clave) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        return;
      }
      if (!$scope.surety.ramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        return;
      }
      if (!$scope.surety.subramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (!$scope.surety.fianza_type) {
        SweetAlert.swal(
          "Error",
          "Agrega un tipo de subramo de fidelidad colectiva.",
          "error"
        );
        return;
      }
      if (!order.contacto.val) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        return;
      }
      if (!$scope.surety.address) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        return;
      }
      if (!$scope.surety.contract_poliza.guarantee_amount) {
        SweetAlert.swal("Error", "Agrega el monto a garantizar.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.rate) {
        SweetAlert.swal("Error", "Agrega el monto a garantizar.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.activity) {
        SweetAlert.swal("Error", "Agrega el giro de la empresa.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.no_employees) {
        SweetAlert.swal("Error", "Agrega el número de empleados.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.description) {
        SweetAlert.swal(
          "Error",
          "Agrega el detalle adicional de garantía.",
          "error"
        );
        return;
      }
      var categoryFlag = false;
      $scope.categories.forEach(function (item, index) {
        if (item.name == "") {
          SweetAlert.swal(
            "Error",
            "Agrega un nombre a la carátula " + (index + 1) + ".",
            "error"
          );
          categoryFlag = true;
        }
        if (item.deductible == "") {
          SweetAlert.swal(
            "Error",
            "Agrega un porcentaje del deducible a la carátula " +
              (index + 1) +
              ".",
            "error"
          );
          categoryFlag = true;
        }
      });
      var beneficiaryFlag = false;
      $scope.beneficiaries.forEach(function (item, index) {
        if (item.type_person == 1) {
          if (item.name == "") {
            SweetAlert.swal(
              "Error",
              "Agrega un nombre al beneficiario " + (index + 1) + ".",
              "error"
            );
            beneficiaryFlag = true;
          }
          if (item.last_name == "") {
            SweetAlert.swal(
              "Error",
              "Agrega un apellido paterno al beneficiario " + (index + 1) + ".",
              "error"
            );
            beneficiaryFlag = true;
          }
          if (item.second_last_name == "") {
            SweetAlert.swal(
              "Error",
              "Agrega un apellio materno al beneficiario " + (index + 1) + ".",
              "error"
            );
            beneficiaryFlag = true;
          }
        } else {
          if (item.j_name == "") {
            SweetAlert.swal(
              "Error",
              "Agrega una razón social al beneficiario " + (index + 1) + ".",
              "error"
            );
            beneficiaryFlag = true;
          }
        }
        // if(item.rfc == ''){
        //     SweetAlert.swal('Error', 'Agrega un rfc al beneficiario ' + (index + 1) + '.', 'error');
        //     beneficiaryFlag = true;
        //   }
      });
      if (!$scope.surety.identifier) {
        SweetAlert.swal("Error", MESSAGES.ERROR.IDENTIFIERREQUIRED, "error");
        return;
      }
      $scope.referenciadorArray.forEach(function (item) {
        $scope.referenciadoresSelected = [];
        if (item.referenciador != "") {
          if (item.comision_vendedor == "") {
            item.comision_vendedor = 0;
          }
          $scope.referenciadoresSelected.push(item);
        }
      });
      if (beneficiaryFlag || categoryFlag) {
        return;
      } else {
        $scope.saveSurety();
      }
    };

    $scope.renewalSelection = function (ren) {
      $scope.dataToSave.is_renewable = order.renewal.selected;
    };
    $scope.saveSurety = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      if ($scope.referenciadoresSelected.length == 0) {
        l.stop();
        SweetAlert.swal(
          "Error",
          "Agrega un referenciador para la fidelidad colectiva.",
          "error"
        );
        return;
      }

      if ($scope.dataToSave.recibos_poliza) {
        $scope.dataToSave.recibos_poliza.forEach(function (item) {
          item.fecha_inicio = toDate(item.startDate);
          item.fecha_fin = toDate(item.endingDate);
          item.vencimiento = toDate(item.vencimiento);
        });
      }

      $scope.surety.poliza_number = null;
      $scope.surety.document_type = 8;
      $scope.surety.forma_de_pago = 5;
      $scope.surety.aseguradora = $scope.surety.aseguradora.url;
      $scope.surety.folio = "";
      $scope.surety.fianza_type = $scope.subramoTypeSelected.url;
      $scope.surety.address = $scope.surety.address.url;
      $scope.surety.emision_date = null;
      $scope.surety.fecha_anuencia = null;
      $scope.surety.status = $scope.showPF ? 1 : 14;
      $scope.surety.status_emision = 1;
      $scope.surety.monto_afianzado = null;
      $scope.surety.tarifa_afianzada = null;
      $scope.surety.p_neta = $scope.dataToSave.p_neta
        ? $scope.dataToSave.p_neta
        : 0;
      $scope.surety.descuento = $scope.dataToSave.descuento
        ? $scope.dataToSave.descuento
        : 0;
      $scope.surety.rpf = $scope.dataToSave.rpf ? $scope.dataToSave.rpf : 0;
      $scope.surety.derecho = $scope.dataToSave.derecho
        ? $scope.dataToSave.derecho
        : 0;
      $scope.surety.sub_total = $scope.dataToSave.sub_total
        ? $scope.dataToSave.sub_total
        : 0;
      $scope.surety.iva = $scope.dataToSave.iva ? $scope.dataToSave.iva : 0;
      $scope.surety.p_total = $scope.dataToSave.p_total
        ? $scope.dataToSave.p_total
        : 0;
      $scope.surety.comision = $scope.dataToSave.comision
        ? $scope.dataToSave.comision
        : 0;
      $scope.surety.comision_percent = $scope.dataToSave.comision_percent
        ? $scope.dataToSave.comision_percent
        : 0;
      $scope.surety.recibos_poliza = $scope.dataToSave.recibos_poliza
        ? $scope.dataToSave.recibos_poliza
        : [];
      $scope.surety.total_receipts = $scope.dataToSave.recibos_poliza
        ? $scope.dataToSave.recibos_poliza.length
        : 0;
      $scope.surety.ref_policy = $scope.referenciadoresSelected;
      $scope.surety.beneficiaries_poliza = $scope.beneficiaries;
      $scope.surety.is_renewable = order.renewal
        ? $scope.dataToSave.is_renewable
        : 2;
      $scope.surety.bono_variable = $scope.surety.bono_variable
        ? $scope.surety.bono_variable
        : 0;

      $scope.surety.programa_de_proveedores_contractor =
        $scope.programa_contractor ? $scope.programa_contractor : null;
      $scope.surety.has_programa_de_proveedores =
        $scope.has_programa_de_proveedores ? true : false;

      ($scope.surety.date_emision_factura = $scope.surety.date_emision_factura
        ? datesFactory.toDate($scope.surety.date_emision_factura)
        : null),
        ($scope.surety.month_factura = $scope.surety.month
          ? $scope.surety.month.month_selected
          : 0),
        ($scope.surety.folio_factura = $scope.surety.folio_factura
          ? $scope.surety.folio_factura
          : ""),
        $http
          .post(url.IP + "fianzas_collective/", $scope.surety)
          .then(function (response) {
            if (response.status == 200 || response.status == 201) {
              $scope.dataSurety = response.data;
              $scope.categories.forEach(function (item, index) {
                item.parent = response.data.id;
                item.caratula = response.data.id;
              });
              $http
                .post(
                  url.IP + "categories_collectivesurety/",
                  $scope.categories
                )
                .then(function (request) {
                  if (request.status == 200 || request.status == 201) {
                    $scope.dataCategories = request.data.data;
                    uploadFiles($scope.dataSurety.id);

                    if ($scope.reexpedir) {
                      if ($scope.origin_renewable) {
                        var obj = {
                          reason_rehabilitate: null,
                          reason_cancel: $rootScope.reason_cancel,
                          concept_annulment: $rootScope.concept_annulment,
                          status: 17,
                          renewed_status: 1,
                        };
                        $http
                          .patch($scope.policy_history.url, obj)
                          .then(function (respuesta) {
                            if (respuesta.status == 200) {
                              // Log fianza
                              var params = {
                                model: 13,
                                event: "PATCH",
                                associated_id: $scope.policy_history.id,
                                identifier:
                                  respuesta.data.status == 24
                                    ? "actualizó la fianza colectiva por preanulacion"
                                    : "actualizó la fianza colectiva por anulación.",
                              };
                              dataFactory
                                .post("send-log/", params)
                                .then(function success(response) {});
                            } //response patch
                          })
                          .catch(function (e) {
                            console.log("error", e);
                          });
                      }
                      var obj = {
                        reason_rehabilitate: null,
                        reason_cancel: $rootScope.reason_cancel,
                        concept_annulment: $rootScope.concept_annulment,
                        status: 17,
                        renewed_status: 1,
                      };
                      $http
                        .patch($scope.original_surety.url, obj)
                        .then(function (respuesta) {
                          if (respuesta.status == 200) {
                            // Log fianza
                            var params = {
                              model: 13,
                              event: "PATCH",
                              associated_id: $scope.original_surety.id,
                              identifier:
                                respuesta.data.status == 24
                                  ? "actualizó la fianza colectiva por preanulacion"
                                  : "actualizó la fianza colectiva por anulación.",
                            };
                            dataFactory
                              .post("send-log/", params)
                              .then(function success(response) {});
                          } //response patch
                        })
                        .catch(function (e) {
                          console.log("error", e);
                        });
                    } else {
                      /* Actualiza la póliza antigua */
                      var data = {
                        status: 12,
                        renewed_status: 1,
                        fecha_cancelacion:
                          $scope.original_surety.fecha_cancelacion,
                      };
                      $http
                        .patch($scope.original_surety.url, data)
                        .then(function (resp) {})
                        .catch(function (e) {
                          l.stop();
                          console.log("error - caratula - catch", e);
                        });
                    }

                    /* Relación con la póliza original */
                    if ($scope.original_surety.poliza_number) {
                      var oldPolicy = {
                        policy: $scope.original_surety.poliza_number,
                        base_policy: $scope.original_surety.url,
                        new_policy: $scope.dataSurety.url,
                      };
                    } else {
                      var oldPolicy = {
                        base_policy: $scope.original_surety.url,
                        new_policy: $scope.dataSurety.url,
                      };
                    }
                    $http
                      .post(url.IP + "v1/polizas/viejas/", oldPolicy)
                      .then(function (res) {})
                      .catch(function (e) {
                        l.stop();
                        console.log("error - caratula - catch", e);
                      });

                    var params = {
                      model: 13,
                      event: "POST",
                      associated_id: $scope.original_surety.id,
                      identifier: $scope.original_surety.poliza_number
                        ? " renovó la fianza colectiva."
                        : " renovó el proyecto de fianza.",
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});

                    SweetAlert.swal(
                      "¡Listo!",
                      "Renovación creada exitosamente.",
                      "success"
                    );
                    $scope.show_certificates = true;
                  }
                })
                .catch(function (e) {
                  l.stop();
                  console.log("error - caratula - catch", e);
                });
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("error - caratula - catch", e);
          });
    };

    $scope.cancel = function () {
      $state.go("fianzas.list");
    };

    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.TITULARES) {
        $scope.excelJson = param.TITULARES;
        $scope.excelJson.forEach(function (item) {
          if (!item.CERTIFICADO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.NOMBRE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.APELLIDO_PATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.APELLIDO_MATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.PUESTO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna PUESTO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.ACTIVIDAD) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ACTIVIDAD, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CATEGORIA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
        });
        if (!flagCertificate) {
          $scope.selectedCertificates = param;
          $scope.addViews(0);
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.cancelCertificates = function () {
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.saveCertificates = function () {
      $scope.loader = true;
      $scope.certificates = [];

      if ($scope.selectedCertificates.TITULARES) {
        $scope.selectedCertificates.TITULARES.forEach(function (item) {
          var personal = {
            certificate_number: parseInt(item.CERTIFICADO),
            email: item.CORREO ? item.CORREO : null,
            first_name: item.NOMBRE,
            last_name: item.APELLIDO_PATERNO,
            second_last_name: item.APELLIDO_MATERNO,
            rfc: item.RFC ? item.RFC : null,
            workstation: item.PUESTO ? item.PUESTO : null,
          };
          var certificateData = {
            caratula: $scope.dataSurety.id,
            certificate_number: parseInt(item.CERTIFICADO),
            parent: item.CATEGORIA,
            poliza_number:
              $scope.dataSurety.poliza_number + " - INC. " + item.CERTIFICADO,
            start_of_validity: $scope.dataSurety.start_of_validity,
            end_of_validity: $scope.dataSurety.end_of_validity,
            status: $scope.dataSurety.status,
            beneficiaries_poliza: personal,
            contract_poliza: {
              activity: item.ACTIVIDAD,
              amount: item.MONTO_A_GARANTIZAR ? item.MONTO_A_GARANTIZAR : null,
            },
            observations: item.OBSERVACIONES ? item.OBSERVACIONES : null,
            document_type: 10,
            identifier:
              item.NOMBRE +
              "_" +
              item.APELLIDO_PATERNO +
              "_" +
              item.APELLIDO_MATERNO,
          };
          $scope.certificates.push(certificateData);
        });
      }

      $http({
        method: "POST",
        url: url.IP + "certificates_collectivesurety/",
        data: $scope.certificates,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal("¡Listo!", MESSAGES.OK.CERTIFICATESDONE, "success");
            $state.go("fianzas.details", { polizaId: $scope.dataSurety.id });
          } else {
            $scope.loader = false;
            // SweetAlert.swal("ERROR",MESSAGES.ERROR.ERRORCERTIFICATES ,"error");
            SweetAlert.swal("ERROR", response.data, "error");
          }
        })
        .catch(function (e) {
          console.log("error - caratula - catch", e);
        });
    };

    $scope.goToInformation = function () {
      $state.go("fianzas.details", { polizaId: $scope.dataSurety.id });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("FianzasInfoColectividadesCtrl", FianzasInfoColectividadesCtrl);

  FianzasInfoColectividadesCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "FileUploader",
    "$stateParams",
    "$http",
    "url",
    "datesFactory",
    "$state",
    "SweetAlert",
    "MESSAGES",
    "dataFactory",
    "$uibModal",
    "$timeout",
    "$parse",
    "$rootScope",
    "appStates",
    "$localStorage",
  ];

  function FianzasInfoColectividadesCtrl(
    $sessionStorage,
    $scope,
    FileUploader,
    $stateParams,
    $http,
    url,
    datesFactory,
    $state,
    SweetAlert,
    MESSAGES,
    dataFactory,
    $uibModal,
    $timeout,
    $parse,
    $rootScope,
    appStates,
    $localStorage
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;

    $scope.surety = {};
    $scope.show_surety = true;
    $scope.show_categorie = false;
    $scope.show_certificate = false;

    $scope.certificate_table = true;
    $scope.certificate_info = false;
    $scope.certificate_edit = false;
    $scope.certificate_mass = false;

    $scope.show_notes = false;
    $scope.show_endorsement = false;

    $scope.categorySelected = {
      id: null,
      value: 0,
      category: 0,
      search: "",
      is_category: 0,
      certificates: [],
      config: {},
    };

    $scope.showTableCertificates = false;
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certificates = [];
    vm.createRecordatorio = createRecordatorio;
    vm.showRecordatorios = showRecordatorios;

    vm.isCollapsed = false;

    // Function to toggle the collapse state
    vm.toggleCollapse = function () {
      vm.isCollapsed = !vm.isCollapsed;
    };
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          vm.acceso_fianzas = perm;
          vm.acceso_fianzas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            } else if (acc.permission_name == "Cancelar fianzas") {
              if (acc.checked == true) {
                vm.acceso_canc_fia = true;
              } else {
                vm.acceso_canc_fia = false;
              }
            } else if (acc.permission_name == "Eliminar fianzas") {
              if (acc.checked == true) {
                vm.acceso_elim_fia = true;
              } else {
                vm.acceso_elim_fia = false;
              }
            }
          });
        }
        if (perm.model_name == "Endosos") {
          $scope.acceso_endosos = perm;
          $scope.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                $scope.acceso_adm_end = true;
              } else {
                $scope.acceso_adm_end = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                vm.acceso_canc_ot = true;
              } else {
                vm.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar OTs") {
              if (acc.checked == true) {
                vm.acceso_elim_ot = true;
              } else {
                vm.acceso_elim_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.acceso_dash = perm;
          vm.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cobranza = perm;
          vm.acceso_cobranza.permissions.forEach(function (acc) {
            if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                vm.permiso_delete_cobranza = true;
              } else {
                vm.permiso_delete_cobranza = false;
              }
            }
            if (
              acc.permission_name ==
              "No permitir editar recibos Pagados/Liquidados"
            ) {
              if (acc.checked == true) {
                vm.acceso_pl_cob = true; //no se editan
              } else {
                vm.acceso_pl_cob = false; //se pueden editar pagados-liquidados
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.permiso_correo = true;
              } else {
                vm.permiso_correo = false;
              }
            }
          });
        }
      });
    }

    activate();
    $scope.month = {};
    $scope.month.month_selected = 1;
    $scope.month.options = [
      { value: 0, label: "" },
      { value: 1, label: "Enero" },
      { value: 2, label: "Febrero" },
      { value: 3, label: "Marzo" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Mayo" },
      { value: 6, label: "Junio" },
      { value: 7, label: "Julio" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Septiembre" },
      { value: 10, label: "Octubre" },
      { value: 11, label: "Noviembre" },
      { value: 12, label: "Diciembre" },
    ];

    $scope.changeFechaEmisionF = function () {
      $scope.benmany = $scope.surety.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        delete item["poliza_many"];
      });
      var data_alert = {
        title: "Fecha Emisión factura",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch($scope.surety.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: $scope.surety.status,
              date_emision_factura: datesFactory.toDate(inputValue),
              fecha_cancelacion: $scope.surety.fecha_cancelacion,
              monto_cancelacion: $scope.surety.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 18,
            event: "PATCH",
            associated_id: $scope.surety.id,
            identifier: " actualizó la fecha emisión de factura.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeFolioF = function () {
      $scope.benmany = $scope.surety.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Folio factura",
        text: "Escribe el folio de la factura.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch($scope.surety.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: $scope.surety.status,
              folio_factura: inputValue,
              fecha_cancelacion: $scope.surety.fecha_cancelacion,
              monto_cancelacion: $scope.surety.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 18,
            event: "PATCH",
            associated_id: $scope.surety.id,
            identifier: " actualizó el folio de la factura.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };

    $scope.changeMaquila = function () {
      $scope.benmany = $scope.surety.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Maquila",
        text: "Escribe el monto de la Maquila",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch($scope.surety.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: $scope.surety.status,
              maquila: parseFloat(inputValue).toFixed(2),
              fecha_cancelacion: $scope.surety.fecha_cancelacion,
              monto_cancelacion: $scope.surety.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 18,
            event: "PATCH",
            associated_id: $scope.surety.id,
            identifier: " actualizó el monto de la maquila.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeTipoC = function () {
      $scope.benmany = $scope.surety.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Tipo de Cambio(captura)",
        text: "Escribe el monto de la Tipo de Cambio(captura)",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch($scope.surety.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: $scope.surety.status,
              exchange_rate: parseFloat(inputValue).toFixed(2),
              fecha_cancelacion: $scope.surety.fecha_cancelacion,
              monto_cancelacion: $scope.surety.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 18,
            event: "PATCH",
            associated_id: $scope.surety.id,
            identifier: " actualizó el monto de la Tipo de Cambio(captura).",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.openMonth = false;
    $scope.changeMesF = function () {
      $scope.openMonth = true;
    };
    $scope.changeMesF1 = function (mes) {
      $scope.benmany = $scope.surety.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      $scope.openMonth = false;
      $http
        .patch($scope.surety.url, {
          beneficiaries_poliza_many: $scope.benmany,
          status: $scope.surety.status,
          month_factura: mes,
          fecha_cancelacion: $scope.surety.fecha_cancelacion,
          monto_cancelacion: $scope.surety.monto_cancelacion,
        })
        .then(function (response) {
          SweetAlert.swal(
            "¡Listo!",
            "Fianza actualizada exitosamente.",
            "success"
          );
          activate();
        });
      var paramsRec = {
        model: 18,
        event: "PATCH",
        associated_id: $scope.surety.id,
        identifier: " actualizó el mes emisión de la factura.",
      };
      dataFactory
        .post("send-log/", paramsRec)
        .then(function success(response) {});
    };

    if ("endorsement_surety" in $localStorage) {
    } else {
      $localStorage["endorsement_surety"] = {};
    }

    $scope.goEndorsement = function (name, route, endorsement) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $localStorage.endorsement_surety.id = endorsement;
      var params = { endosoId: endorsement.id };
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.show_section = function (value) {
      switch (value) {
        case 1:
          $scope.show_surety = true;
          $scope.show_categorie = false;
          $scope.show_certificate = false;
          break;
        case 2:
          $scope.show_surety = false;
          $scope.show_categorie = true;
          $scope.show_certificate = false;
          break;
        case 3:
          $scope.show_surety = false;
          $scope.show_categorie = false;
          $scope.show_certificate = true;
          break;
        default:
          $scope.show_surety = true;
          $scope.show_categorie = false;
          $scope.show_certificate = false;
      }
    };
    $scope.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 10; i >= oldYear; i--) {
      $scope.years.push(i);
    }

    $scope.changeFechaComision = function () {
      $scope.benmany = $scope.surety.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Fecha de Pago de Comisión",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch($scope.surety.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: $scope.surety.status,
              fecha_pago_comision: datesFactory.toDate(inputValue),
              fecha_cancelacion: $scope.surety.fecha_cancelacion,
              monto_cancelacion: $scope.surety.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 18,
            event: "PATCH",
            associated_id: $scope.surety.id,
            identifier: " actualizó la fecha de pago de comisión.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeFechaMaquila = function () {
      $scope.benmany = $scope.surety.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Fecha Maquila",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch($scope.surety.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: $scope.surety.status,
              date_maquila: datesFactory.toDate(inputValue),
              fecha_cancelacion: $scope.surety.fecha_cancelacion,
              monto_cancelacion: $scope.surety.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 18,
            event: "PATCH",
            associated_id: $scope.surety.id,
            identifier: " actualizó la fecha maquila de fianza.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeBono = function () {
      $scope.benmany = $scope.surety.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Bono Afianzadora",
        text: "Escribe el monto del Bono",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch($scope.surety.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: $scope.surety.status,
              bono_variable: parseFloat(inputValue).toFixed(2),
              fecha_cancelacion: $scope.surety.fecha_cancelacion,
              monto_cancelacion: $scope.surety.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 18,
            event: "PATCH",
            associated_id: $scope.surety.id,
            identifier: " actualizó bono de fianza.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeFechaBono = function () {
      $scope.benmany = $scope.surety.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Fecha de Bono",
        text: "Escribe en formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch($scope.surety.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: $scope.surety.status,
              date_bono: datesFactory.toDate(inputValue),
              fecha_cancelacion: $scope.surety.fecha_cancelacion,
              monto_cancelacion: $scope.surety.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 18,
            event: "PATCH",
            associated_id: $scope.surety.id,
            identifier: " actualizó la fecha de bono de fianza.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.openYear = false;
    $scope.changYearF = function () {
      $scope.openYear = true;
    };
    $scope.changeFechaBono = function () {
      $scope.benmany = $scope.surety.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      var data_alert = {
        title: "Fecha de Bono",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch($scope.surety.url, {
              beneficiaries_poliza_many: $scope.benmany,
              status: $scope.surety.status,
              date_bono: datesFactory.toDate(inputValue),
              fecha_cancelacion: $scope.surety.fecha_cancelacion,
              monto_cancelacion: $scope.surety.monto_cancelacion,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: $scope.surety.id,
            identifier: " actualizó la fecha de bono de fianza.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeYearF1 = function (year) {
      $scope.benmany = $scope.surety.beneficiaries_poliza_many;
      $scope.benmany.forEach(function (item) {
        try {
          delete item["poliza_many"];
        } catch (e) {}
      });
      $scope.openYear = false;
      $http
        .patch($scope.surety.url, {
          beneficiaries_poliza_many: $scope.benmany,
          status: $scope.surety.status,
          year_factura: year,
          fecha_cancelacion: $scope.surety.fecha_cancelacion,
          monto_cancelacion: $scope.surety.monto_cancelacion,
        })
        .then(function (response) {
          SweetAlert.swal(
            "¡Listo!",
            "Fianza actualizada exitosamente.",
            "success"
          );
          activate();
        });
      var paramsRec = {
        model: 18,
        event: "PATCH",
        associated_id: $scope.surety.id,
        identifier: " actualizó el año emisión de la factura.",
      };
      dataFactory
        .post("send-log/", paramsRec)
        .then(function success(response) {});
    };
    function activate() {
      $http
        .post(url.IP + "information_collectivesurety/", {
          caratula: $stateParams.polizaId,
        })
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            $scope.surety = response.data.data.collectivitySurety;
            $scope.calculatePrimas($scope.surety.recibos_poliza);
            $scope.showFiles($scope.surety);
            $scope.getComments();
            $scope.categories = response.data.data.childs;
            $scope.categories.forEach(function (item) {
              $scope.showFiles(item);
            });
            $scope.getAllCertificate();

            if ($scope.surety.programa_de_proveedores_contractor) {
              if ($scope.surety.programa_de_proveedores_contractor) {
                $scope.url_programa =
                  $scope.surety.programa_de_proveedores_contractor;
              }
              $http.get($scope.url_programa).then(function (request) {
                $scope.programa = angular.copy(request.data);
              });
            }

            $http({
              method: "GET",
              url: url.IP + "historic-policies/",
              params: {
                actual_id: $scope.surety.id,
              },
            })
              .then(function success(response) {
                if (response.data.results.length) {
                  $scope.showHistoric = true;
                }
                $scope.policy_history = [];
                response.data.results.forEach(function function_name(old) {
                  if ($scope.surety.id != old.base_policy.id) {
                    $scope.policy_history.push(old.base_policy);
                  } else if (old.new_policy) {
                    $scope.policy_history.push(old.new_policy);
                  }
                });
              })
              .catch(function (e) {
                console.log("error - caratula - catch", e);
              });

            $scope.endorsements = [];
            $scope.receipts_endorsement = [];
            $scope.notes = [];

            $http({
              method: "GET",
              url: url.IP + "view-endosos",
              params: {
                policy: $scope.surety.id,
              },
            })
              .then(function success(response) {
                $scope.endorsements = response.data.endosos;
                $scope.endorsements.forEach(function (endoso) {
                  if (endoso.endorsement_receipt[0]) {
                    $scope.receipts_endorsement.push(
                      endoso.endorsement_receipt[0]
                    );
                    if (endoso.endorsement_receipt[0].receipt_type == 3) {
                      $scope.notes.push(endoso.endorsement_receipt[0]);
                    }
                  }
                });
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
        })
        .catch(function (e) {
          console.log("error - caratula - catch", e);
        });
    }

    $scope.openModal = function (task) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/tasks/task.modal.html",
        controller: "TareasModalCtrl",
        size: "lg",
        resolve: {
          task: function () {
            return task;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          receipt: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          activate();
        },
        function () {
          console.info("modal closed");
        }
      );
    };
    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 14:
          return "Vigente";
          break;
        case 17:
          return "Anulada";
          break;
        case 24:
          return "Preanulada";
          break;
        case 0:
          return "Eliminada";
          break;
        default:
          return "Vigente";
      }
    };
    $scope.monthEmision = function (mf) {
      switch (mf) {
        case 0:
          return "";
          break;
        case 1:
          return "Enero";
          break;
        case 2:
          return "Febrero";
          break;
        case 3:
          return "Marzo";
          break;
        case 4:
          return "Abril";
          break;
        case 5:
          return "Mayo";
          break;
        case 6:
          return "Junio";
          break;
        case 7:
          return "Julio";
          break;
        case 8:
          return "Agosto";
          break;
        case 9:
          return "Septiembre";
          break;
        case 10:
          return "Octubre";
          break;
        case 11:
          return "Noviembre";
          break;
        case 12:
          return "Diciembre";
          break;
        default:
          return "";
      }
    };

    $scope.concept = function (parConcept) {
      switch (parConcept) {
        case 34:
          return "CAMBIOS EN EL BENEFICIARIO";
          break;
        case 53:
          return "DETALLE DE GARANTÍA";
          break;
        case 54:
          return "PRORROGA DE VIGENCIA";
          break;
        case 55:
          return "ANUENCIA";
          break;
        case 24:
          return "ALTA DE CERTIFICADOS";
          break;
        case 25:
          return "BAJA DE CERTIFICADOS";
          break;
        case 56:
          return "CORRECCIÓN DE CERTIFICADOS";
          break;
        case 4:
          return "OTRO";
          break;
        default:
          return "OTRO";
      }
    };

    $scope.changedomiciliado = function () {
      SweetAlert.swal(
        {
          title: "¿Domiciliar fianza?",
          text: "Este cambio se aplicará a todos los recibos, ¿desea domiciliar?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, domiciliar",
          cancelButtonText: "No, no domiciliar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.surety.recibos_poliza.forEach(function (receipt) {
              $http
                .patch(receipt.url, { is_cat: true })
                .then(function (response) {
                  SweetAlert.swal(
                    "¡Hecho!",
                    "Recibo(s) actualizado(s)",
                    "success"
                  );
                  activate();
                });
            });
            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.suretyA.id,
              identifier:
                " cambio el estatus del cargo Automático(Domiciliado) a SI de los recibos.",
            };
            dataFactory
              .post("send-log/", paramsRec)
              .then(function success(response) {});
          } else {
            $scope.surety.recibos_poliza.forEach(function (receipt) {
              $http
                .patch(receipt.url, { is_cat: false })
                .then(function (response) {
                  SweetAlert.swal(
                    "¡Hecho!",
                    "Recibo(s) actualizado(s)",
                    "success"
                  );
                  activate();
                });
            });
            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.surety.id,
              identifier:
                " cambio el estatus del cargo Automático(Domiciliado) a NO de los recibos.",
            };
            dataFactory
              .post("send-log/", paramsRec)
              .then(function success(response) {});
          }
        }
      );
    };
    function createRecordatorio(registroSelected, tipo) {
      var insurance = registroSelected;
      console.log("dddddd", registroSelected);
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return $scope.surety;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }
    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };
    function showRecordatorios() {
      vm.recordatoriosFlag = true;
    }
    $scope.getLog = function () {
      dataFactory
        .get("get-specific-log", { model: 13, associated_id: $scope.surety.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop: "static",
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    // $scope.cancelFianza = function(){
    //   SweetAlert.swal({
    //     title: "Cancelar",
    //     text: "Se cancelará la fianza colectiva, ¿Está seguro?",
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#DD6B55",
    //     confirmButtonText: "¡Si!",
    //     cancelButtonText: "No",
    //     closeOnConfirm: true,
    //     closeOnCancel: false
    //   },
    //   function(isConfirm){
    //     if (isConfirm) {
    //       $scope.beneficiaries = [];
    //       $scope.surety.beneficiaries_poliza_many.forEach(function(item, index){
    //         var beneficiary = {
    //           type_person: item.type_person,
    //           first_name: item.first_name,
    //           last_name: item.last_name,
    //           second_last_name: item.second_last_name,
    //           j_name: item.j_name,
    //           full_name: '',
    //           rfc: item.rfc,
    //           email: item.email,
    //           phone_number: item.phone_number,
    //           id: item.id,
    //           url: item.url
    //         }
    //         $scope.beneficiaries.push(beneficiary);

    //         if((index + 1) == $scope.surety.beneficiaries_poliza_many.length){
    //           var data = {
    //             'status': 11,
    //             'beneficiaries_poliza_many': $scope.beneficiaries
    //           }
    //           $http.patch($scope.surety.url, data)
    //           .then(function(response){
    //             if(response.status == 200 || response.status == 201){
    //               var paramsE = {
    //                 'model': 13,
    //                 'event': "PATCH",
    //                 'associated_id': $scope.surety.id,
    //                 'identifier': " canceló la fianza colectiva."
    //               }
    //               dataFactory.post('send-log', paramsE);
    //               activate();
    //             }
    //           })
    //           .catch(function(e){
    //             console.log('e', e);
    //           });
    //         }
    //       });
    //     }
    //   });
    // };

    $scope.cancelFianza = function (suret) {
      $rootScope.suretyInfo = suret;
      var modalInstance = $uibModal.open({
        templateUrl: "app/fianzas/cancel.fianzas.html",
        controller: FianzaCancelModalCtrl,
        controllerAs: "vmm",
        size: "md",
        resolve: {
          suretyInfo: function () {
            return suret;
          },
          endosos: function () {
            return $scope.endorsements;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };

    function FianzaCancelModalCtrl(
      url,
      $http,
      $rootScope,
      suretyInfo,
      $scope,
      $uibModalInstance,
      datesFactory,
      endosos
    ) {
      var vmm = this;
      vmm.surety = {
        fecha_cancelacion: datesFactory.convertDate(new Date()),
        monto_cancelacion: 0,
        status: 11,
      };

      $scope.cancelSurety = function () {
        $scope.beneficiaries = [];
        suretyInfo.beneficiaries_poliza_many.forEach(function (item, index) {
          var beneficiary = {
            type_person: item.type_person,
            first_name: item.first_name,
            last_name: item.last_name,
            second_last_name: item.second_last_name,
            j_name: item.j_name,
            full_name: "",
            rfc: item.rfc,
            email: item.email,
            phone_number: item.phone_number,
            id: item.id,
            url: item.url,
          };
          $scope.beneficiaries.push(beneficiary);

          if (index + 1 == suretyInfo.beneficiaries_poliza_many.length) {
            var data = {
              fecha_cancelacion: datesFactory.toDate(
                vmm.surety.fecha_cancelacion
              ),
              monto_cancelacion: vmm.surety.monto_cancelacion,
              status: 11,
              beneficiaries_poliza_many: $scope.beneficiaries,
            };
            $http
              .patch(suretyInfo.url, data)
              .then(function (response) {
                if (response.status == 200 || response.status == 201) {
                  if (endosos) {
                    endosos.forEach(function (end) {
                      if (end.status == 2) {
                        $http
                          .patch(end.url, { status: 4 })
                          .then(function (dataend) {
                            console.log("patch endo reg to cancel", dataend);
                          });
                      }
                    });
                  }
                  var paramsE = {
                    model: 13,
                    event: "PATCH",
                    associated_id: suretyInfo.id,
                    identifier: " canceló la fianza colectiva.",
                  };
                  dataFactory.post("send-log", paramsE);
                  activate();
                  $uibModalInstance.dismiss("cancel");
                  swal(
                    "¡Listo!",
                    "Se ha cancelado definitivamente la Fianza",
                    "success"
                  );
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        });
      };

      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.deleteFianza = function () {
      SweetAlert.swal(
        {
          title: "Eliminar Fianza",
          text: "Se eliminarán también el recibo, los cambios no podrán revertirse. ¿Está seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data = {
              status: 0,
              beneficiaries_poliza_many: $scope.surety.beneficiaries_poliza_many
                ? $scope.surety.beneficiaries_poliza_many
                : $scope.surety.beneficiaries_poliza,
            };
            $http
              .patch($scope.surety.url, data)
              .then(function (response) {
                if (response.status == 200) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "La fianza fue eliminada exitosamente.",
                    "success"
                  );
                  $state.go("fianzas.list");
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La fianza no se ha eliminado.",
              "error"
            );
          }
        }
      );
    };

    $scope.showNotes = function (value) {
      $scope.show_notes = value;
    };

    $scope.showEndorsement = function (value) {
      $scope.show_endorsement = value;
    };

    $scope.statusReceipt = function (parValue) {
      switch (parValue) {
        case 1:
          return "Pagado";
          break;
        case 2:
          return "Cancelado";
          break;
        case 3:
          return "Prorrogado";
          break;
        case 4:
          return "Pendiente de Pago";
          break;
        case 5:
          return "Liquidado";
          break;
        case 6:
          return "Conciliado";
          break;
        case 7:
          return "Cerrado";
          break;
        case 8:
          return "Precancelado";
          break;
        case 9:
          return "Pago Parcial";
          break;
        case 10:
          return "Anulado";
          break;
        case 11:
          return "Preanulado";
          break;
        default:
          return parValue;
      }
    };

    $scope.changeFechaCancelacion = function () {
      var data_alert = {
        title: "Monto de cancelación",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch($scope.surety.url, {
              monto_cancelacion: $scope.surety.monto_cancelacion,
              fecha_cancelacion: datesFactory.toDate(inputValue),
              status: 11,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: $scope.surety.id,
            identifier: " actualizó la fecha de cancelación.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };

    $scope.changeMontoCancelacion = function () {
      var data_alert = {
        title: "Monto de cancelación",
        text: "Este cambio se aplicará en la fianza.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };

      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch($scope.surety.url, {
              monto_cancelacion: parseFloat(inputValue).toFixed(2),
              fecha_cancelacion: $scope.surety.fecha_cancelacion,
              status: 11,
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 13,
            event: "PATCH",
            associated_id: $scope.surety.id,
            identifier: " actualizó el monto de cancelación.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };

    $scope.calculatePrimas = function (receipts) {
      $scope.total_prima = 0;
      $scope.total_rpf = 0;
      $scope.total_derecho = 0;
      $scope.total_iva = 0;
      $scope.total_total = 0;
      $scope.total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1) {
          $scope.total_prima =
            parseFloat($scope.total_prima) + parseFloat(receipts[i].prima_neta);
          $scope.total_rpf =
            parseFloat($scope.total_rpf) + parseFloat(receipts[i].rpf);
          $scope.total_derecho =
            parseFloat($scope.total_derecho) + parseFloat(receipts[i].derecho);
          $scope.total_iva =
            parseFloat($scope.total_iva) + parseFloat(receipts[i].iva);
          $scope.total_total =
            parseFloat($scope.total_total) +
            parseFloat(receipts[i].prima_total);
          $scope.total_comision =
            parseFloat($scope.total_comision) +
            parseFloat(receipts[i].comision);
        }
      }
    };

    $scope.deliveredReceipt = function (receipt) {
      SweetAlert.swal(
        {
          title: "Entregado",
          text: "Este recibo se marcara como entregado, ¿Estás seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "PATCH",
              url: receipt.url,
              data: {
                delivered: true,
              },
            }).then(function success(response) {
              if (response.status == 200) {
                var params = {
                  model: 4,
                  event: "PATCH",
                  associated_id: receipt.id,
                  identifier: " actualizó el recibo a Entregado.",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                SweetAlert.swal(
                  "¡Listo!",
                  "Recibo actualizado exitosamente.",
                  "success"
                );
                activate();
              }
            });
          }
        }
      );
    };

    $scope.addEmailsConfirmPolicy = function (
      insurance,
      natural,
      juridical,
      contractor
    ) {
      // if(natural){
      //   insurance.contratante = natural;
      // }else if(juridical){
      //   insurance.contratante = juridical;
      // }
      insurance.contratante = contractor;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return insurance;
          },
          valueReceipt: function () {
            return insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };

    $scope.changeStatusModal = function (receipt, fianza) {
      receipt.poliza = fianza.fianza_number;
      fianza.poliza = fianza.fianza_number;
      // if(fianza.natural){
      //   receipt.contratante = fianza.natural;
      // }else if (fianza.juridical){
      //   receipt.contratante = fianza.juridical;
      // }
      receipt.contratante = fianza.contractor;
      var index = $scope.surety.recibos_poliza.indexOf(receipt);
      var modalInstance = $uibModal.open({
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return fianza;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    };

    $scope.editReceipt = function (receipt, index) {
      var texto =
        "Esta es una alternativa de emergencia, No se validarán las primas y ni las fechas al editar este recibo. ¿Deseas continuar?";
      if (
        vm.acceso_pl_cob == false &&
        (receipt.status == 1 || receipt.status == "Pagado")
      ) {
        var texto =
          "Esta es una alternativa de emergencia, No se validarán las primas y ni las fechas al editar este recibo.  \nEstas editando un recibo PAGADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      } else if (
        vm.acceso_pl_cob == false &&
        (receipt.status == 5 || receipt.status == "Liquidado")
      ) {
        var texto =
          "Esta es una alternativa de emergencia, No se validarán las primas y ni las fechas al editar este recibo.  \nEstas editando un recibo LIQUIDADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      }
      if (
        receipt.status == 4 ||
        receipt.status == "Pendiente de pago" ||
        (vm.acceso_pl_cob == false &&
          (receipt.status == 5 ||
            receipt.status == "Liquidado" ||
            receipt.status == 1 ||
            receipt.status == "Pagado"))
      ) {
        SweetAlert.swal(
          {
            title: "Advertencia",
            text: texto,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var modalInstance = $uibModal.open({
                templateUrl: "app/fianzas/receipt-modal.html",
                controller: EditReceiptModalCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  recibo: function () {
                    return receipt;
                  },
                  index: function () {
                    return index;
                  },
                  endoso: function () {
                    return $scope.surety;
                  },
                  acceso_pl_cob: function () {
                    return vm.acceso_pl_cob;
                  },
                },
                backdrop: "static",
                keyboard: false,
              });
            } else {
              SweetAlert.swal(
                "Cancelado",
                "El recibo no ha sido actualizado.",
                "error"
              );
            }
          }
        );
      } else {
        SweetAlert.swal(
          "Advertencia",
          "El recibo no se puede editar porque no está pendiente de pago.",
          "warning"
        );
      }
    };

    function EditReceiptModalCtrl(
      url,
      $http,
      $rootScope,
      recibo,
      index,
      endoso,
      $scope,
      $uibModalInstance,
      acceso_pl_cob
    ) {
      var rec = this;
      rec.recibo = recibo;
      if (recibo.fecha_inicio.indexOf("-") != -1) {
        rec.recibo.fecha_inicio = convertDate(recibo.fecha_inicio);
      }
      if (recibo.fecha_fin.indexOf("-") != -1) {
        rec.recibo.fecha_fin = convertDate(recibo.fecha_fin);
      }
      if (recibo.vencimiento.indexOf("-") != -1) {
        rec.recibo.vencimiento = convertDate(recibo.vencimiento);
      }

      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          var date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          var date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }

        return date;
      }

      function toDate(dateStr) {
        if (dateStr) {
          var dateString = dateStr;
          var dateParts = dateString.split("/");
          var dateObject = new Date(
            dateParts[2],
            dateParts[1] - 1,
            dateParts[0]
          );
          return dateObject;
        }
      }

      $scope.validateDecimal = function (form) {
        form = String(form).replace(/[A-Za-z]/g, "");
        form = String(form).replace(/,/g, "");
        return form;
      };

      $scope.changePrimas = function (data) {
        rec.recibo.sub_total = (
          parseFloat(data.prima_neta) +
          parseFloat(data.rpf) +
          parseFloat(data.derecho)
        ).toFixed(2);
        rec.recibo.prima_total = (
          parseFloat(rec.recibo.sub_total) + parseFloat(data.iva)
        ).toFixed(2);
      };

      $scope.saveReceipt = function (receipt) {
        if (
          process(rec.recibo.fecha_inicio) <
          process(convertDate(endoso.start_of_validity))
        ) {
          SweetAlert.swal(
            "Error",
            "La fecha de inicio del recibo no puede ser menor a la fecha de inicio de la póliza.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        var obj = {
          fecha_inicio: new Date(toDate(receipt.fecha_inicio)),
          fecha_fin: new Date(toDate(receipt.fecha_fin)),
          prima_neta: receipt.prima_neta,
          rpf: receipt.rpf,
          derecho: receipt.derecho,
          iva: receipt.iva,
          prima_total: receipt.prima_total,
          comision: receipt.comision,
          vencimiento: new Date(toDate(receipt.vencimiento)),
          delivered: receipt.delivered,
        };

        $http
          .patch(receipt.url, obj)
          .then(function (response) {
            if (response.status == 200) {
              var data_primas = {
                p_neta: receipt.prima_neta,
                rpf: receipt.rpf,
                derecho: receipt.derecho,
                sub_total: receipt.sub_total,
                iva: receipt.iva,
                p_total: receipt.prima_total,
                comision: receipt.comision,
                comision_percent: 0,
              };
              data_primas.comision_percent = (
                (parseFloat(receipt.comision) * 100) /
                parseFloat(data_primas.p_neta)
              ).toFixed(2);
              $http
                .patch(endoso.url, data_primas)
                .then(function (response) {})
                .catch(function (e) {
                  console.log("error", e);
                });
              var texto_log = "";
              if (
                (receipt.status == 1 || receipt.status == "Pagado") &&
                acceso_pl_cob == false
              ) {
                var texto_log = " EDICION DE RECIBO PAGADO";
              }
              if (
                (receipt.status == 5 || receipt.status == "Liquidado") &&
                acceso_pl_cob == false
              ) {
                var texto_log = " EDICION DE RECIBO LIQUIDADO";
              }
              var params = {
                model: 13,
                event: "PATCH",
                associated_id: endoso.id,
                identifier:
                  "actualizó el recibo " +
                  receipt.recibo_numero +
                  texto_log +
                  ".",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              var params = {
                model: 4,
                event: "POST",
                associated_id: receipt.id,
                identifier: "actualizó el recibo, " + texto_log + ".",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              SweetAlert.swal(
                "Listo",
                "El recibo ha sido actualizado",
                "success"
              );
              $scope.cancel();
            }
          })
          .catch(function (e) {
            console.log("error", e);
          });
      };
      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.anularFianza = function (suret) {
      $rootScope.suretyInfo = suret;
      var modalInstance = $uibModal.open({
        templateUrl: "app/fianzaGpo/annulment.ChangeModal.html",
        controller: FianzaAnnulmentModalCtrl,
        controllerAs: "ann",
        size: "lg",
        resolve: {
          suretyInfo: function () {
            return suret;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };

    function FianzaAnnulmentModalCtrl(
      url,
      $http,
      $rootScope,
      suretyInfo,
      $scope,
      $uibModalInstance
    ) {
      var ann = this;
      ann.suretyInfo = suretyInfo;
      ann.suretyInfo.startValidity = convertDate(suretyInfo.start_of_validity);
      ann.suretyInfo.endValidity = convertDate(suretyInfo.end_of_validity);
      ann.suretyInfo.polizaNumber = suretyInfo.poliza_number;

      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          var date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          var date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }
        return date;
      }

      function toDate(dateStr) {
        if (dateStr) {
          var dateString = dateStr;
          var dateParts = dateString.split("/");
          var dateObject = new Date(
            dateParts[2],
            dateParts[1] - 1,
            dateParts[0]
          );
          return dateObject;
        }
      }

      if (ann.suretyInfo.status == 14) {
        ann.conceptAnn = [
          { value: 1, label: "PreAnulada" },
          { value: 2, label: "Por error de captura" },
          { value: 3, label: "Por reexpedición" },
          { value: 4, label: "Por falta de pago" },
          { value: 5, label: "Otro (sólo anular)" },
        ];
      } else {
        ann.conceptAnn = [
          { value: 2, label: "Por error de captura" },
          { value: 3, label: "Por Reexpedición" },
          { value: 4, label: "Por falta de Pago" },
          { value: 5, label: "Otro (Sólo anular)" },
        ];
      }
      // ((1, 'Preanulada'),(2, 'Por error de captura'),(3, 'Por reexpedición'),(4, 'Por falta de pago'), (5, 'Otro(Anulación)'), (0, 'No aplica'))
      ann.conceptAnnulment = ann.conceptAnn[0].value;

      $scope.conceptAnnSelection = function (val) {};

      $scope.savesuretyAnnulment = function (suretyA) {
        if (!ann.suretyInfo.reason_cancel) {
          SweetAlert.swal("Error", "Agrega la razón de anulación.", "error");
          return;
        }

        if (ann.conceptAnnulment == 1) {
          var obj = {
            reason_rehabilitate: null,
            reason_cancel: ann.suretyInfo.reason_cancel,
            concept_annulment: ann.conceptAnnulment,
            status: 24, //PreAnulada
          };

          $scope.annulmentSurety(obj);
        } else {
          var obj = {
            reason_rehabilitate: null,
            reason_cancel: ann.suretyInfo.reason_cancel,
            concept_annulment: ann.conceptAnnulment,
            status: 17, //Anulada
          };

          if (ann.suretyInfo.recibos_poliza.length > 0) {
            if (
              ann.suretyInfo.recibos_poliza[0].status != 4 ||
              ann.suretyInfo.recibos_poliza[0].status != 11
            ) {
              SweetAlert.swal(
                {
                  title: "Anular Fianza Colectiva",
                  text: "Existen recibos que no están como pendientes de pago, ¿Estás seguro de continuar?",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Si",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                },
                function (isConfirm) {
                  if (isConfirm) {
                    if (
                      ann.conceptAnnulment == 2 ||
                      ann.conceptAnnulment == 3
                    ) {
                      $rootScope.reason_cancel = ann.suretyInfo.reason_cancel;
                      $rootScope.concept_annulment = ann.conceptAnnulment;
                      $scope.cancel();
                      swal.close();
                      $state.go("fianzas.reissue", { polizaId: suretyA.id });
                    } else {
                      $scope.annulmentSurety(obj);
                    }
                  } else {
                    $scope.cancel();
                  }
                }
              );
            } else {
              if (ann.conceptAnnulment == 2 || ann.conceptAnnulment == 3) {
                $rootScope.reason_cancel = ann.suretyInfo.reason_cancel;
                $rootScope.concept_annulment = ann.conceptAnnulment;
                $scope.cancel();
                swal.close();
                $state.go("fianzas.reissue", { polizaId: suretyA.id });
              } else {
                $scope.annulmentSurety(obj);
              }
            }
          } else {
            if (ann.conceptAnnulment == 2 || ann.conceptAnnulment == 3) {
              $rootScope.reason_cancel = ann.suretyInfo.reason_cancel;
              $rootScope.concept_annulment = ann.conceptAnnulment;
              $scope.cancel();
              swal.close();
              $state.go("fianzas.reissue", { polizaId: suretyA.id });
            } else {
              $scope.annulmentSurety(obj);
            }
          }
        }
      };

      $scope.annulmentSurety = function (object) {
        $http
          .patch(ann.suretyInfo.url, object)
          .then(function (response) {
            if (response.status == 200) {
              // Log fianza
              var params = {
                model: 13,
                event: "PATCH",
                associated_id: ann.suretyInfo.id,
                identifier:
                  response.data.status == 24
                    ? "actualizó la fianza colectiva por preanulacion"
                    : "actualizó la fianza colectiva por anulación.",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});

              SweetAlert.swal(
                "¡Listo!",
                "La fianza colectiva ha sido actualizada exitosamente.",
                "success"
              );
              activate();
              $scope.cancel();
            } //response patch
          })
          .catch(function (e) {
            console.log("error", e);
          });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.rehabilitarFianza = function (surety) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/fianzaGpo/rehabilitate.modal.html",
        controller: FianzaRehabilitateModalCtrl,
        controllerAs: "ann",
        size: "md",
        resolve: {
          suretyInfo: function () {
            return surety;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };

    function FianzaRehabilitateModalCtrl(
      url,
      $http,
      suretyInfo,
      $scope,
      $uibModalInstance,
      dataFactory
    ) {
      var ann = this;

      ann.suretyInfo = suretyInfo;

      $scope.saveSuretyRehabilitate = function () {
        if (!ann.suretyInfo.reason_rehabilitate) {
          SweetAlert.swal(
            "Error",
            "Agrega el motivo de la rehabilitación.",
            "error"
          );
          return;
        }

        if (ann.suretyInfo.status == 24 || ann.suretyInfo.status == 17) {
          if (
            ann.suretyInfo.concept_annulment == 2 ||
            ann.suretyInfo.concept_annulment == 3
          ) {
            SweetAlert.swal(
              "Error",
              "No se puede rehabilitar la fianza. Solo los conceptos forma de pago y otro.",
              "error"
            );
            return;
          }
        }

        var obj = {
          reason_cancel: null,
          concept_annulment: null,
          reason_rehabilitate: ann.suretyInfo.reason_rehabilitate,
          status: 14, //Vigente
          beneficiaries_poliza_many: ann.suretyInfo.beneficiaries_poliza_many,
        };

        $http
          .patch(ann.suretyInfo.url, obj)
          .then(function (response) {
            if (response.status == 200) {
              var params = {
                model: 13,
                event: "PATCH",
                associated_id: ann.suretyInfo.id,
                identifier: " rehabilitó la fianza colectiva.",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              SweetAlert.swal(
                "¡Listo!",
                "La fianza colectiva ha sido actualizada exitosamente.",
                "success"
              );
              activate();
              $scope.cancel();
            }
          })
          .catch(function (e) {
            console.log("error", e);
          });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.goToPolicy = function (policy) {
      $state.go("fianzas.details", { polizaId: policy.id });
    };

    $scope.showFiles = function (item) {
      $http
        .get(url.IP + "polizas/" + item.id + "/archivos/")
        .then(function (response) {
          item.files = response.data.results;
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    // Upload files
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item, options){
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.uploader.queue.length) {
        SweetAlert.swal(
          "¡Listo!",
          "Archivos cargados exitosamente.",
          "success"
        );
        activate();
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      fileItem.removeAfterUpload = true;

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.showFiles = function (item) {
      $http
        .get(url.IP + "polizas/" + item.id + "/archivos/")
        .then(function (response) {
          item.files = response.data.results;
          if (item.showFile) {
            item.showFile = false;
          } else {
            item.showFile = true;
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.saveFiles = function (param) {
      uploadFiles(param.id);
    };

    $scope.deleteFile = function (file, container) {
      SweetAlert.swal(
        {
          title: "Eliminar Archivo",
          text: "No será posible recuperar este archivo, ¿Estás seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "GET",
              url: url.IP + "delete-manual",
              params: {
                file_id: file.id,
              },
            })
              .then(function success(response) {
                if (response.data.status == 204) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "El archivo fue eliminado exitosamente.",
                    "success"
                  );
                  container.splice(container.indexOf(file), 1);
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
        }
      );
    };

    $scope.renameFile = function (file, vmFiles) {
      var patch = {
        nombre: file.nombre,
        sensible: file.sensible,
      };
      $http
        .patch(file.url, patch)
        .then(function (response) {
          if (response.status == 403) {
            $http
              .get(file.url)
              .then(function (response) {
                file.nombre = response.data;
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.getComments = function () {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 13,
          id_model: $scope.surety.id,
        },
      })
        .then(function (response) {
          $scope.comments_data = response.data.results;
          $scope.comments_config = {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.show_binnacle_receipt = false;

    $scope.returnToReceipts = function () {
      $scope.show_binnacle_receipt = false;
    };

    $scope.showBinnacleReceipt = function (receipt) {
      $scope.show_binnacle_receipt = true;
      $scope.receipt_id = receipt.id;
      $scope.comments_data_receipt = [];
      $scope.receiptmodel = receipt.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: receipt.id,
        },
      })
        .then(function (request) {
          $scope.comments_data_receipt = request.data.results;
          $scope.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.deleteCategorie = function (item) {
      SweetAlert.swal(
        {
          title: "Eliminar Subgrupo",
          text: "Se eliminará la categoría y todos sus certificados, ¿Estás Seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            if ($scope.categories.length > 1) {
              $http
                .delete(item.url)
                .then(function success(response) {
                  if (response.status == 204) {
                    $scope.categories.splice(item, 1);
                    SweetAlert.swal(
                      "¡Listo!",
                      "Se ha eliminado la categoría, con todas sus certificados.",
                      "success"
                    );
                  }
                })
                .catch(function (e) {
                  console.log("e", e);
                });
            } else {
              SweetAlert.swal(
                "Error",
                "No se eliminó la categoría porque la carátula no puede quedarse sin categorías.",
                "error"
              );
            }
          }
        }
      );
    };

    $scope.showSectionCertificate = function (value) {
      switch (value) {
        case 1:
          $scope.certificate_table = true;
          $scope.certificate_info = false;
          $scope.certificate_edit = false;
          $scope.certificate_mass = false;
          break;
        case 2:
          $scope.certificate_table = false;
          $scope.certificate_info = true;
          $scope.certificate_edit = false;
          $scope.certificate_mass = false;
          break;
        case 3:
          $scope.certificate_table = false;
          $scope.certificate_info = false;
          $scope.certificate_edit = true;
          $scope.certificate_mass = false;
          break;
        case 4:
          $scope.certificate_table = false;
          $scope.certificate_info = false;
          $scope.certificate_edit = false;
          $scope.certificate_mass = true;
          break;
        default:
          $scope.certificate_table = true;
          $scope.certificate_info = false;
          $scope.certificate_edit = false;
          $scope.certificate_mass = false;
      }
    };

    $scope.getAllCertificate = function () {
      $scope.status_cert = 0;
      $scope.categorySelected.id = $scope.surety.id;
      $scope.categorySelected.value = 0;
      $scope.categorySelected.category = 0;
      $scope.categorySelected.is_category = 0;
      $scope.categorySelected.certificates = [];
      $scope.showSectionCertificate(1);
      var data = {
        caratula: $scope.surety.id,
        status: 0,
        parent: 0,
        page: 1,
      };
      $http
        .post(url.IP + "information_certCollSurety/", data)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            $scope.categorySelected.certificates = response.data.results;
            $scope.categorySelected.is_category = 0;
            $scope.categorySelected.config = {
              count: response.data.count,
              previous: response.data.previous,
              next: response.data.next,
            };
            testPagination(
              "categorySelected.certificates",
              "categorySelected.config"
            );
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };

    $scope.getCertificate = function (param, value) {
      $scope.categorySelected.id = param.id;
      $scope.categorySelected.value = value;
      $scope.categorySelected.category = param.id;
      $scope.categorySelected.is_category = 1;
      $scope.categorySelected.certificates = [];
      $scope.status_cert = value;
      $scope.show_section(3);
      $scope.showSectionCertificate(1);
      var data = {
        caratula: $scope.surety.id,
        status: value,
        parent: param.id,
      };
      $http
        .post(url.IP + "information_certCollSurety/", data)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            $scope.categorySelected.certificates = response.data.results;
            $scope.categorySelected.config = {
              count: response.data.count,
              previous: response.data.previous,
              next: response.data.next,
            };
            testPagination(
              "categorySelected.certificates",
              "categorySelected.config"
            );
          }
        })
        .catch(function (e) {
          console.log("error - caratula - catch", e);
        });
    };

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        var data = {
          caratula: $scope.surety.id,
          status: $scope.categorySelected.value,
          parent: $scope.categorySelected.is_category,
          page: parPage,
        };

        $http
          .post(url.IP + "information_certCollSurety/", data)
          .then(function (response) {
            if (response.status == 200 || response.status == 201) {
              $scope.categorySelected.certificates = response.data.results;
            }
          })
          .catch(function (e) {
            console.log("error - caratula - catch", e);
          });
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }

    $scope.search = function (param) {
      $scope.categorySelected.search = param;
      if (param) {
        $http({
          method: "GET",
          url: url.IP + "search_certs_collectivfianza/",
          params: {
            cadena: $scope.categorySelected.search,
            org: usr.org,
            parent: $scope.categorySelected.id
              ? $scope.categorySelected.id
              : $scope.surety.id,
            is_category: $scope.categorySelected.is_category
              ? $scope.categorySelected.is_category
              : 0,
            status: $scope.status_cert ? $scope.status_cert : 0,
          },
        })
          .then(function success(response) {
            if (response.status == 200) {
              $scope.categorySelected.certificates = response.data.results;
              $scope.categorySelected.config = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };
              testPagination(
                "categorySelected.certificates",
                "categorySelected.config"
              );
            } else {
              SweetAlert.swal(
                "Error",
                "Ocurrió un error, por favor intenta de nuevo.",
                "Error"
              );
            }
          })
          .catch(function (e) {
            console.log("error", e);
          });
      } else {
        var data = {
          caratula: $scope.surety.id,
          status: $scope.categorySelected.value,
          parent: $scope.categorySelected.is_category,
          page: 1,
        };

        $http
          .post(url.IP + "information_certCollSurety/", data)
          .then(function (response) {
            if (response.status == 200 || response.status == 201) {
              $scope.categorySelected.certificates = response.data.results;
              $scope.categorySelected.config = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };
              testPagination(
                "categorySelected.certificates",
                "categorySelected.config"
              );
            } else {
              SweetAlert.swal(
                "Error",
                "Ocurrió un error, por favor intenta de nuevo.",
                "Error"
              );
            }
          });
      }
    };

    $scope.selectCerficate = function (item) {
      $scope.showSectionCertificate(2);
      $scope.certificate = item;

      $http
        .get(url.IP + "polizas/" + item.id + "/archivos/")
        .then(function (response) {
          item.files = response.data.results;
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.editCerficate = function (item) {
      console.log("ite,---", item);
      $scope.pkActual = item.id;
      $scope.parentCertificate = item.parent.id;
      $scope.newCertificate = {};
      $scope.newBeneficiary = {};
      $scope.newContract = {};
      $scope.newCertificate.url = item.url;
      $scope.newCertificate.certificate_number = item.certificate_number;
      $scope.newBeneficiary.url = item.beneficiaries_poliza[0].url;
      $scope.newBeneficiary.email = item.beneficiaries_poliza[0].email;
      $scope.newBeneficiary.first_name =
        item.beneficiaries_poliza[0].first_name;
      $scope.newBeneficiary.last_name = item.beneficiaries_poliza[0].last_name;
      $scope.newBeneficiary.second_last_name =
        item.beneficiaries_poliza[0].second_last_name;
      $scope.newBeneficiary.rfc = item.beneficiaries_poliza[0].rfc;
      $scope.newBeneficiary.workstation =
        item.beneficiaries_poliza[0].workstation;
      $scope.newContract.url = item.contract_poliza.url;
      $scope.newContract.activity = item.contract_poliza.activity;
      $scope.newContract.amount = item.contract_poliza.amount;
      $scope.showSectionCertificate(3);
    };

    $scope.updateCertificate = function () {
      var item = {
        pkActual: $scope.pkActual,
        certificate: $scope.newCertificate.certificate_number,
        caratula: $scope.surety.id,
        parent: $scope.parentCertificate,
      };
      dataFactory
        .post("fianzacollectiveValidateCertificate/", item)
        .then(function success(req) {
          $scope.existeCertificate = false;
          if (req.data.exist) {
            $scope.existeCertificate = req.data.exist;
            SweetAlert.swal(
              "¡Información!",
              "El Número de Certificado ya existe.",
              "error"
            );
            return;
          } else {
            $scope.existeCertificate = false;
            $http
              .patch($scope.newCertificate.url, $scope.newCertificate)
              .then(function (response) {
                if (response.status == 200 || response.status == 201) {
                  $http
                    .patch($scope.newBeneficiary.url, $scope.newBeneficiary)
                    .then(function (response) {
                      if (response.status == 200 || response.status == 201) {
                        $http
                          .patch($scope.newContract.url, $scope.newContract)
                          .then(function (response) {
                            if (
                              response.status == 200 ||
                              response.status == 201
                            ) {
                              SweetAlert.swal(
                                "¡Listo!",
                                "El certificado se actualizó exitosamente.",
                                "success"
                              );
                              activate();
                            } else {
                              SweetAlert.swal(
                                "Error",
                                "Ócurrio un error.",
                                "error"
                              );
                            }
                          })
                          .catch(function (e) {
                            console.log("error", e);
                          });
                      } else {
                        SweetAlert.swal("Error", "Ócurrio un error.", "error");
                      }
                    })
                    .catch(function (e) {
                      console.log("error", e);
                    });
                } else {
                  SweetAlert.swal("Error", "Ócurrio un error.", "error");
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.deleteCertificate = function (item) {
      SweetAlert.swal(
        {
          title: "Eliminar Certificado",
          text: "Se eliminará el Certificado y no se podrá recuperar después, ¿Estás Seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(item.url).then(function (response) {
              if (response.status == 204) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.DELETECERT, "success");
                activate();
              }
            });
            $scope.categorySelected.certificates.splice(
              $scope.categorySelected.certificates.indexOf(item),
              1
            );
          } else {
            swal("Cancelado", MESSAGES.OK.CANCELCERT, "error");
            return;
          }
        }
      );
    };

    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.TITULARES) {
        $scope.excelJson = param.TITULARES;
        $scope.excelJson.forEach(function (item) {
          if (!item.CERTIFICADO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.NOMBRE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.APELLIDO_PATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.APELLIDO_MATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.PUESTO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna PUESTO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.ACTIVIDAD) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ACTIVIDAD, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CATEGORIA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
        });
        if (!flagCertificate) {
          $scope.selectedCertificates = param;
          $scope.addViews(0);
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.cancelCertificates = function () {
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.saveCertificates = function () {
      $scope.loader = true;
      $scope.certificates = [];

      if ($scope.selectedCertificates.TITULARES) {
        $scope.selectedCertificates.TITULARES.forEach(function (item) {
          var personal = {
            certificate_number: item.CERTIFICADO,
            email: item.CORREO ? item.CORREO : null,
            first_name: item.NOMBRE,
            last_name: item.APELLIDO_PATERNO,
            second_last_name: item.APELLIDO_MATERNO,
            rfc: item.RFC ? item.RFC : null,
            workstation: item.PUESTO ? item.PUESTO : null,
          };
          var certificateData = {
            caratula: $scope.surety.id,
            certificate_number: item.CERTIFICADO,
            parent: item.CATEGORIA,
            poliza_number:
              $scope.surety.poliza_number + " - INC. " + item.CERTIFICADO,
            start_of_validity: $scope.surety.start_of_validity,
            end_of_validity: $scope.surety.end_of_validity,
            status: $scope.surety.status,
            beneficiaries_poliza: personal,
            contract_poliza: {
              activity: item.ACTIVIDAD,
              amount: item.MONTO_A_GARANTIZAR ? item.MONTO_A_GARANTIZAR : null,
            },
            observations: item.OBSERVACIONES ? item.OBSERVACIONES : null,
            document_type: 10,
            identifier:
              item.NOMBRE +
              "_" +
              item.APELLIDO_PATERNO +
              "_" +
              item.APELLIDO_MATERNO,
          };
          $scope.certificates.push(certificateData);
        });
      }

      $http({
        method: "POST",
        url: url.IP + "certificates_collectivesurety/",
        data: $scope.certificates,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal("Listo!", MESSAGES.OK.CERTIFICATESDONE, "success");
            $scope.cancelCertificates();
            activate();
            $scope.showSectionCertificate(1);
          } else {
            $scope.loader = false;
            // SweetAlert.swal("ERROR",MESSAGES.ERROR.ERRORCERTIFICATES ,"error");
            SweetAlert.swal("ERROR", response.data, "error");
          }
        })
        .catch(function (e) {
          console.log("error - caratula - catch", e);
        });
    };

    $scope.downloadExcel = function () {
      $http({
        method: "POST",
        url: url.IP + "service_reporte-certificatesFianza-excel",
        data: {
          cadena: $scope.categorySelected.search,
          org: usr.org,
          parent: $scope.categorySelected.id
            ? $scope.categorySelected.id
            : $scope.surety.id,
          is_category: $scope.categorySelected.is_category
            ? $scope.categorySelected.is_category
            : 0,
          status: $scope.status_cert ? $scope.status_cert : 0,
        },
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function success(response) {
          if (response.status === 200) {
            var blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte_CertificadosFianza.xls");
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.saveAsSurety = function () {
      var modalInstance = $uibModal.open({
        templateUrl: "app/fianzas/otAsFianzaModal.html",
        controller: FianzaPendingModalCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policyModal: function () {
            return $scope.surety;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    };

    function FianzaPendingModalCtrl(
      datesFactory,
      $localStorage,
      $scope,
      toaster,
      MESSAGES,
      policyModal,
      $uibModalInstance,
      dataFactory,
      SweetAlert,
      $state,
      insuranceService,
      receiptService,
      url,
      $http,
      $rootScope,
      emailService,
      helpers
    ) {
      var vmm = this;

      vmm.form = {
        folio: "",
        comisiones: [],
      };

      vmm.options = {
        save: save,
        cancel: cancel,
      };
      vmm.policyInfo = policyModal;

      $scope.years = [];
      var actualYear = new Date().getFullYear();
      var oldYear = actualYear - 80;
      for (var i = actualYear + 10; i >= oldYear; i--) {
        $scope.years.push(i);
      }

      vmm.form.month = {};
      vmm.form.month.month_selected = 1;
      vmm.form.month.options = [
        { value: 0, label: "" },
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Septiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" },
      ];

      $scope.checkFechaFactura = function (date) {
        var date_initial = date.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);
        vmm.form.month.month_selected = parseInt(month);
        vmm.form.year_factura = year;
      };
      $scope.changeNoPoliza = function () {
        if (vmm.form.fianza) {
          helpers
            .existPolicyNumber(vmm.form.fianza)
            .then(function (request) {
              if (request == true) {
                SweetAlert.swal(
                  "Error",
                  "El número de fianza ya existe.",
                  "error"
                );
                vmm.form.fianza = "";
              }
            })
            .catch(function (err) {});
        }
      };

      $http
        .get(url.IP + "claves-by-provider/" + vmm.policyInfo.aseguradora.id)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
                if (vmm.policyInfo.subramo == item.subramo) {
                  vmm.form.comisiones.push(item);
                }
              });
            });
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      vmm.form.startDate = convertDate(vmm.policyInfo.start_of_validity);
      vmm.form.endingDate = convertDate(vmm.policyInfo.end_of_validity);
      vmm.form.document_type = vmm.policyInfo.document_type;
      vmm.form.subramo = vmm.policyInfo.subramo;
      vmm.form.policy_days_duration = 365;
      vmm.policyInfo.beneficiaries_poliza_many.forEach(function (item) {
        delete item["poliza_many"];
      });
      function save() {
        $scope.dataFianza = {
          folio: vmm.form.folio,
          poliza_number: vmm.form.fianza,
          emision_date: vmm.form.emision_date
            ? datesFactory.toDate(vmm.form.emision_date)
            : null,
          status: 14,
          p_neta: vmm.policyInfo.poliza.primaNeta,
          rpf: vmm.policyInfo.poliza.rpf,
          derecho: vmm.policyInfo.poliza.derecho,
          iva: vmm.policyInfo.poliza.iva,
          p_total: vmm.policyInfo.poliza.primaTotal,
          comision: vmm.policyInfo.comision,
          comision_percent: vmm.policyInfo.comision_percent,
          fecha_cancelacion: vmm.policyInfo.fecha_cancelacion,
          monto_cancelacion: vmm.policyInfo.monto_cancelacion,
          beneficiaries_poliza_many: vmm.policyInfo.beneficiaries_poliza_many
            ? vmm.policyInfo.beneficiaries_poliza_many
            : vmm.policyInfo.beneficiaries_poliza,
          date_emision_factura: vmm.form.date_emision_factura
            ? datesFactory.toDate(vmm.form.date_emision_factura)
            : null,
          date_maquila: vmm.form.date_maquila
            ? datesFactory.toDate(vmm.form.date_maquila)
            : null,
          year_factura: vmm.form.year_factura ? vmm.form.year_factura : 0,
          month_factura: vmm.form.month ? vmm.form.month.month_selected : 0,
          folio_factura: vmm.form.folio_factura ? vmm.form.folio_factura : "",
          maquila: vmm.form.maquila
            ? parseFloat(vmm.form.maquila).toFixed(2)
            : 0,
          exchange_rate: vmm.form.exchange_rate
            ? parseFloat(vmm.form.exchange_rate).toFixed(2)
            : 0,
        };
        $http
          .patch(vmm.policyInfo.url, $scope.dataFianza)
          .then(function (response) {
            if (response.status == 200) {
              vmm.policyInfo.recibos_poliza.forEach(function (item) {
                item.fecha_inicio = new Date(
                  datesFactory.toDate(
                    vmm.policyInfo.recibos_poliza[0].startDate
                  )
                );
                item.fecha_fin = new Date(
                  datesFactory.toDate(
                    vmm.policyInfo.recibos_poliza[0].endingDate
                  )
                );
                item.vencimiento = new Date(
                  datesFactory.toDate(
                    vmm.policyInfo.recibos_poliza[0].vencimiento
                  )
                );

                item.poliza = response.data.url;

                dataFactory.post("recibos/", item).then(
                  function success(req) {},
                  function error(error) {
                    console.log(error);
                  }
                );
              });

              $state.go("fianzas.details", { polizaId: response.data.id });
              activate();
              vmm.options.cancel();
              SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWFIANZAOK, "success");

              var params = {
                model: 13,
                event: "POST",
                associated_id: response.data.id,
                identifier: "convirtió la PT en fianza.",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            }
          });
      }

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }

      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        var date = inputFormat;
        if (inputFormat.length != 10) {
          function pad(s) {
            return s < 10 ? "0" + s : s;
          }
          var d = new Date(inputFormat);
          if (indicator) {
            date = [
              pad(d.getDate() + 1),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          } else {
            date = [
              pad(d.getDate()),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          }
        }
        return date;
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("FianzasColectividadesEditCtrl", FianzasColectividadesEditCtrl);

  FianzasColectividadesEditCtrl.$inject = [
    "$localStorage",
    "$sessionStorage",
    "$scope",
    "FileUploader",
    "providerService",
    "$http",
    "url",
    "$state",
    "dataFactory",
    "SweetAlert",
    "MESSAGES",
    "$stateParams",
    "helpers",
    "datesFactory",
  ];

  function FianzasColectividadesEditCtrl(
    $localStorage,
    $sessionStorage,
    $scope,
    FileUploader,
    providerService,
    $http,
    url,
    $state,
    dataFactory,
    SweetAlert,
    MESSAGES,
    $stateParams,
    helpers,
    datesFactory
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var order = this;
    $scope.dataToSave = {
      recalcular: true,
    };
    order.org_name = usr.org;
    order.renewal = {};
    order.renewal.options = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.currencys = [
      { value: 1, label: "Pesos" },
      { value: 2, label: "Dólares" },
    ];
    $scope.month = {};
    $scope.month.options = [
      { value: 0, label: "" },
      { value: 1, label: "Enero" },
      { value: 2, label: "Febrero" },
      { value: 3, label: "Marzo" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Mayo" },
      { value: 6, label: "Junio" },
      { value: 7, label: "Julio" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Septiembre" },
      { value: 10, label: "Octubre" },
      { value: 11, label: "Noviembre" },
      { value: 12, label: "Diciembre" },
    ];

    $scope.surety = {};
    $scope.showPF = true;
    $scope.claveSelected = {};
    $scope.addresses = [];
    $scope.categories_delete = [];
    $scope.create_natural = true;
    $scope.create_juridical = true;

    $scope.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 10; i >= oldYear; i--) {
      $scope.years.push(i);
    }
    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Fianzas") {
          order.acceso_fianzas = perm;
          order.acceso_fianzas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                order.acceso_adm_fia = true;
              } else {
                order.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                order.acceso_ver_fia = true;
              } else {
                order.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          order.acceso_reportes = perm;
          order.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                order.acceso_rep_fia = true;
              } else {
                order.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                order.acceso_rep_sin = true;
              } else {
                order.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                order.acceso_rep_end = true;
              } else {
                order.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                order.acceso_rep_pol = true;
              } else {
                order.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                order.acceso_rep_ren = true;
              } else {
                order.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                order.acceso_rep_cob = true;
              } else {
                order.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    $scope.options = {};
    var d = new Date();
    var curr_date = d.getDate();
    var curr_month = d.getMonth() + 1; //Months are zero based
    var curr_year = d.getFullYear();
    var date = curr_year + "-" + curr_month + "-" + curr_date;
    providerService.getProviderFiByKey(date).then(function (data) {
      $scope.providers = data.data;
    });

    $scope.referenciadorArray = [];
    $scope.directiveReceipts = [];
    $scope.beneficiaries = [];

    activate();

    $scope.checkFechaFactura = function (date) {
      var date_initial = date.split("/");
      var day = date_initial[0];
      var month = date_initial[1];
      var year = parseInt(date_initial[2]);
      $scope.month.month_selected = parseInt(month);
      $scope.surety.year_factura = year;
    };
    function activate() {
      dataFactory
        .post("information_collectivesurety/", {
          caratula: $stateParams.polizaId,
        })
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            if ($localStorage.save_edition_fianza_coletiva) {
              if (
                $localStorage.save_edition_fianza_coletiva["id"] ==
                response.data.data.collectivitySurety.id
              ) {
                $scope.surety = $localStorage.save_edition_fianza_coletiva;
              } else {
                $scope.surety = response.data.data.collectivitySurety;
              }
            } else {
              $scope.surety = response.data.data.collectivitySurety;
            }
            $scope.copy_surety = angular.copy($scope.surety);
            if ($scope.copy_surety.poliza_number) {
              $scope.showPF = false;
            }

            $scope.receipts_surety = [];
            $scope.copy_surety.recibos_poliza.forEach(function (receipt) {
              if (receipt.receipt_type == 1) {
                $scope.receipts_surety.push(receipt);
              }
            });

            $scope.surety.contract_poliza.guarantee_amount = parseFloat(
              $scope.surety.contract_poliza.guarantee_amount
            );
            $scope.surety.contract_poliza.rate = parseFloat(
              $scope.surety.contract_poliza.rate
            );
            $scope.surety.contract_poliza.poliza = $scope.surety.id;

            if (
              $localStorage.save_edition_fianza_coletiva &&
              $localStorage.save_edition_fianza_coletiva["categories"]
            ) {
              if (
                $localStorage.save_edition_fianza_coletiva["id"] ==
                response.data.data.collectivitySurety.id
              ) {
                $scope.categories =
                  $localStorage.save_edition_fianza_coletiva["categories"];
              } else {
                $scope.categories = response.data.data.childs;
              }
            } else {
              $scope.categories = response.data.data.childs;
            }
            $scope.categories.forEach(function (f) {
              f.deductible = parseInt(f.deductible);
            });

            order.renewal.is_renewable = $scope.surety.is_renewable;
            $scope.dataToSave.is_renewable = $scope.surety.is_renewable;
            $scope.startDate = convertDate($scope.surety.start_of_validity);
            $scope.endDate = convertDate($scope.surety.end_of_validity);
            if (
              $scope.surety.emision_date == null ||
              $scope.surety.emision_date == "NaN/NaN/NaN"
            ) {
              $scope.surety.emision_date = convertDate(new Date());
            } else {
              $scope.surety.emision_date = convertDate(
                $scope.surety.emision_date
              );
            }
            fillProvider();

            $scope.aseguradoraSelected = $scope.surety.aseguradora;
            $scope.getClaves($scope.aseguradoraSelected, 1);
            $scope.currencySelected = $scope.surety.f_currency;
            $scope.month.month_selected = $scope.surety.month_factura;
            $scope.year_factura = $scope.surety.year_factura;
            $scope.surety.date_emision_factura = $scope.surety
              .date_emision_factura
              ? convertDate($scope.surety.date_emision_factura)
              : "";
            $scope.surety.date_bono = $scope.surety.date_bono
              ? convertDate($scope.surety.date_bono)
              : "";
            $scope.surety.date_maquila = $scope.surety.date_maquila
              ? convertDate($scope.surety.date_maquila)
              : "";
            // Contacto
            var json_address = [];
            order.contacto.value = $scope.surety.contractor;
            order.contacto.val = $scope.surety.contractor.full_name;
            $scope.addressSelected = $scope.surety.address;
            // contacto end

            $http
              .get(url.IP + "get-vendors/")
              .then(function (user) {
                user.data.forEach(function (u) {
                  u.first_name = u.first_name.toUpperCase();
                  u.last_name = u.last_name.toUpperCase();
                  u.name =
                    u.first_name.toUpperCase() +
                    " " +
                    u.last_name.toUpperCase();
                });
                $scope.referenciadores = user.data;
                var vendedor = {
                  referenciador: "",
                  comision_vendedor: "",
                };
                $scope.referenciadorArray.push(vendedor);
              })
              .catch(function (e) {
                console.log("error", e);
              });
            // Referenciadores
            if ($scope.surety.ref_policy) {
              if ($scope.surety.ref_policy.length > 0) {
                $scope.surety.ref_policy.forEach(function (refs) {
                  $http
                    .get(refs.referenciador.url)
                    .then(function success(response_ref_plicy) {
                      if (response_ref_plicy) {
                        refs.data = response_ref_plicy.data;
                        refs.referenciador = response_ref_plicy.data.url;
                        refs.selectedRef = true;
                        $scope.referenciadorArray.push(refs);
                      }
                    });
                });
              }
            } else {
              $scope.referenciadorArray.push($scope.referenciador);
            }
            // Referenciadores---

            // Recibos
            $scope.directiveReceipts.domiciliado = false;
            $scope.directiveReceipts.payment = 5;
            $scope.directiveReceipts.startDate = $scope.startDate;
            $scope.directiveReceipts.endingDate = $scope.endDate;
            $scope.dataToSave.receipts = $scope.receipts_surety;
            $scope.dataToSave.receipts.forEach(function (receipt) {
              receipt.startDate = convertDate(receipt.fecha_inicio);
              receipt.endingDate = convertDate(receipt.fecha_fin);
              receipt.vencimiento = convertDate(receipt.vencimiento);
              if (receipt.status != 4) {
                $scope.dataToSave.recalcular = false;
              } else {
              }
            });
            $scope.dataToSave.numeroRecibos = $scope.dataToSave.receipts.length;
            $scope.dataToSave.subramo = $scope.surety.subramo;
            $scope.dataToSave.poliza = {
              primaNeta: parseFloat($scope.surety.p_neta),
              rpf: parseFloat($scope.surety.rpf),
              derecho: parseFloat($scope.surety.derecho),
              iva: parseFloat($scope.surety.iva),
              subTotal: $scope.surety.sub_total,
              primaTotal: $scope.surety.p_total,
            };
            var date1 = new Date($scope.surety.start_of_validity);
            var date2 = new Date($scope.surety.end_of_validity);
            var timeDiff = Math.abs(date2.getTime() - date1.getTime());
            $scope.directiveReceipts.policy_days_duration = Math.ceil(
              timeDiff / (1000 * 3600 * 24)
            );

            // $scope.beneficiaries = $scope.surety.beneficiaries_poliza_many;
            $scope.surety.beneficiaries_poliza_many.forEach(function (item) {
              var data = {
                email: item.email,
                first_name: item.first_name,
                full_name: item.full_name,
                id: item.id,
                j_name: item.j_name,
                last_name: item.last_name,
                owner: item.owner,
                phone_number: item.phone_number,
                // poliza: item.poliza,
                rfc: item.rfc,
                second_last_name: item.second_last_name,
                type_person: item.type_person,
                url: item.url,
                workstation: item.workstation,
              };
              $scope.beneficiaries.push(data);
            });

            $scope.showPrograma = $scope.surety.has_programa_de_proveedores;
            if ($scope.surety.programa_de_proveedores_contractor) {
              if ($scope.surety.programa_de_proveedores_contractor) {
                $scope.url_solidario =
                  $scope.surety.programa_de_proveedores_contractor;
              }
              $http.get($scope.url_solidario).then(function (request) {
                order.contratante = {};
                if (request.data.address_contractor) {
                  order.contratante.val = request.data.full_name;
                  order.contratante.value = request.data;
                }
              });
            }
          }
        })
        .catch(function (e) {
          console.log("error - colectivo fianza - catch", e);
        });
    }

    $scope.save_info_tab = function () {
      $localStorage.save_edition_fianza_coletiva = angular.copy($scope.surety);
    };

    function fillProvider() {
      var d = $scope.startDate;
      try {
        var day = d.getDate();
        var month = d.getMonth() + 1;
        var year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var day = f.getDate();
        var month = f.getMonth() + 1;
        var year = f.getFullYear();
      }

      var date = year + "-" + month + "-" + day;
      providerService.getProviderFiByKey(date).then(
        function success(data) {
          $scope.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    $scope.checkNumPolicy = function () {
      if ($scope.surety.poliza_number) {
        if ($scope.copy_surety.poliza_number != $scope.surety.poliza_number) {
          helpers
            .existPolicyNumber($scope.surety.poliza_number)
            .then(function (request) {
              if (request == true) {
                SweetAlert.swal(
                  "Error",
                  "El número de fianza ya existe.",
                  "error"
                );
                $scope.surety.poliza_number = "";
              }
            })
            .catch(function (err) {});
        }
      }
    };

    $scope.checkDate = function (param) {
      if (param.length == 10) {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        day = day - 1;
        if (day < 1) {
          month = month - 1;
          if (month < 1) {
            month = 12;
            year = year - 1;
          }
          if (month == 4 || month == 6 || month == 9 || month == 11) {
            day = 30;
          } else if (month == 2) {
            day = 28;
          } else {
            day = 31;
          }
        }
        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.startDate = param;
        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.surety.start_of_validity = toDate(param);
        $scope.surety.end_of_validity = toDate($scope.endDate);
      } else {
        var day = new Date().getDate();
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();

        day = day - 1;
        if (day < 1) {
          month = month - 1;
          if (month < 1) {
            month = 12;
            year = year - 1;
          }
          if (month == 4 || month == 6 || month == 9 || month == 11) {
            day = 30;
          } else if (month == 2) {
            day = 28;
          } else {
            day = 31;
          }
        }
        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.surety.start_of_validity = toDate(param);
        $scope.surety.end_of_validity = toDate($scope.endDate);
      }
      $scope.directiveReceipts.startDate = param;
      var date1 = new Date($scope.surety.start_of_validity);
      var date2 = new Date($scope.surety.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );

      if ($scope.directiveReceipts.policy_days_duration > 365) {
        $scope.directiveReceipts.endingDate = $scope.endDate;
      } else {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.directiveReceipts.endingDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
      }
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }
        $scope.surety.end_of_validity = toDate(param);
      }
      var date1 = new Date($scope.surety.start_of_validity);
      var date2 = new Date($scope.surety.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );

      if ($scope.directiveReceipts.policy_days_duration > 365) {
        $scope.directiveReceipts.endingDate = param;
      } else {
        var date_initial = $scope.startDate.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.directiveReceipts.endingDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
      }
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function toDate(dateStr) {
      if (dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(
          dateParts[2],
          dateParts[1] - 1,
          dateParts[0]
        ).toISOString(); // month is 0-based
        return dateObject;
      }
    }

    $scope.getClaves = function (param, value) {
      $scope.surety.aseguradora = param;
      $http
        .get(url.IP + "claves-by-provider/" + $scope.surety.aseguradora.id)
        .then(function success(clavesResponse) {
          $scope.claves = clavesResponse.data;
          if ($scope.claves.length == 1) {
            $scope.surety.clave = $scope.claves[0].url;
            $scope.claveSelected = $scope.claves[0];
          }
        })
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      $http
        .get(url.IP + "ramos-by-provider/" + $scope.surety.aseguradora.id)
        .then(
          function success(response) {
            $scope.ramos = response.data;
            $scope.ramos.forEach(function (item) {
              if (item.ramo_name == "Fidelidad") {
                $scope.ramoSelected = item;
                $scope.surety.ramo = item.url;
                $scope.subramos = item.subramo_ramo;
                $scope.subramos.forEach(function (subramo) {
                  if (subramo.subramo_name == "Colectivas") {
                    $scope.subramoSelected = subramo;
                    $scope.surety.subramo = subramo.url;
                    $scope.subramosTypes = subramo.type_subramo;

                    if (value == 1) {
                      $scope.subramosTypes.forEach(function (item) {
                        if (item.url == $scope.surety.fianza_type.url) {
                          $scope.subramoTypeSelected = item;
                        }
                      });
                    }

                    $scope.directiveReceipts.subramo = subramo;
                    $scope.dataToSave.subramo = subramo;

                    var comisiones = [];
                    if ($scope.claveSelected.clave_comision) {
                      if ($scope.claveSelected.clave_comision.length) {
                        $scope.claveSelected.clave_comision.forEach(function (
                          item
                        ) {
                          if (param.subramo_name == item.subramo) {
                            comisiones.push(item);
                          }
                        });
                      }
                    }

                    $scope.directiveReceipts.comisiones = comisiones;
                    $scope.directiveReceipts.domiciliado = false;
                    $scope.directiveReceipts.payment = 5;
                  }
                });
              }
            });
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    $scope.refreshProvider = function () {
      fillProvider();
    };

    $scope.changeClave = function (param) {
      if (param) {
        $scope.surety.clave = param.url;
        $scope.claveSelected = param;
      }
    };

    $scope.changeSubramoType = function (param) {
      if (param) {
        $scope.surety.fianza_type = param.url;
        if (!$localStorage.save_edition_fianza_coletiva) {
          $localStorage.save_edition_fianza_coletiva = angular.copy(
            $scope.surety
          );
        }
        $localStorage.save_edition_fianza_coletiva["fianza_type"] = param;
      }
    };

    $scope.changeCurrency = function (param) {
      $scope.surety.f_currency = param;
      if (!$localStorage.save_edition_fianza_coletiva) {
        $localStorage.save_edition_fianza_coletiva = angular.copy(
          $scope.surety
        );
      }
      $localStorage.save_edition_fianza_coletiva["f_currency"] = param;
    };

    // Contacto contratante
    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          if (order.org_name == "ancora") {
            $scope.show_contratante = "contractors-match-fianzas/";
          } else {
            $scope.show_contratante = "contractors-match/";
          }
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: false,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contacto.value", function (newValue, oldValue) {
      if (order.contacto) {
        // if(order.contacto.value.address_natural || order.contacto.value.address_juridical){
        if (order.contacto.value.address_contractor) {
          $scope.surety.contractor = order.contacto.value.url;
          if (order.contacto.value.address_contractor[0].id) {
            $scope.addresses = order.contacto.value.address_contractor;
          } else {
            order.contacto.value.address_contractor.forEach(function (address) {
              $http.get(address).then(function (addressResponse) {
                $scope.addresses.push(addressResponse.data);
              });
            });
          }
          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.surety.address = $scope.addresses[0];
          }
        }
      }
    });

    $scope.changeAddress = function (param) {
      $scope.surety.address = param;
    };

    $scope.valuePercentageRate = function (item) {
      if (item < 0) {
        $scope.surety.contract_poliza.rate = 0;
      } else if (item > 100) {
        $scope.surety.contract_poliza.rate = 100;
      }
    };

    $scope.addCategorie = function () {
      var category = {
        name: "",
        deductible: "",
        observations: "",
        document_type: 9,
      };
      $scope.categories.push(category);
    };

    $scope.deleteCategorie = function (index, item) {
      if (item.id) {
        SweetAlert.swal(
          {
            title: "Información",
            text: "La Categoría y sus Certificados se eliminarán por completo",
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              $scope.categories.splice($scope.categories.indexOf(item), 1);
              $scope.categories_delete.push(item);
            }
          }
        );
      } else {
        $scope.categories.splice($scope.categories.indexOf(item), 1);
      }
    };

    $scope.valuePercentage = function (item, index) {
      if (item < 0) {
        $scope.categories[index].deductible = 0;
      } else if (item > 100) {
        $scope.categories[index].deductible = 100;
      }
    };

    $scope.createIdentifier = function () {
      $scope.surety.identifier = "";
      $scope.surety.identifier =
        $scope.subramoSelected.subramo_name + "_" + $scope.categories[0].name;
      if (!$localStorage.save_edition_fianza_coletiva) {
        $localStorage.save_edition_fianza_coletiva = angular.copy(
          $scope.surety
        );
      }
      $localStorage.save_edition_fianza_coletiva["categories"] =
        $scope.categories;
    };

    $scope.matchesBeneficiary = function (parWord) {
      $scope.beneficiaries_data = [];
      var word_data = parWord;
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/BeneficiariesExistentes/';
          $scope.show_contratante = "BeneficiariesExistentes/";
          // $http.post(url.IP + $scope.show_contratante,
          //   {
          //     'matchWord': parWord
          //   })
          $http({
            method: "GET",
            url: url.IP + $scope.show_contratante,
            params: {
              matchWord: parWord,
            },
          }).then(function (response) {
            if (response.status === 200) {
              response.data.results.forEach(function (item) {
                $scope.beneficiaries_data.push({
                  label: item.type_person == 1 ? item.full_name : item.j_name,
                  value: item,
                });
              });
            }
          });
        }
      }
    };

    $scope.addBeneficiaries = function (item) {
      if ($scope.beneficiaries.length == 1) {
        if (
          $scope.beneficiaries[0].first_name == "" &&
          $scope.beneficiaries[0].last_name == "" &&
          $scope.beneficiaries[0].j_name == "" &&
          $scope.beneficiaries[0].rfc == ""
        ) {
          $scope.beneficiaries[0] = item;
        } else {
          var beneficiary = {
            type_person: item.type_person,
            first_name: item.first_name,
            last_name: item.last_name,
            second_last_name: item.second_last_name,
            j_name: item.j_name,
            full_name: "",
            rfc: item.rfc,
            email: item.email,
            phone_number: item.phone_number,
            id: item.id,
            url: item.url,
            poliza: null,
            usuario: null,
          };
          $scope.beneficiaries.push(beneficiary);
          $scope.benecifiarieSelected = {};
        }
      } else {
        var beneficiary = {
          type_person: item.type_person,
          first_name: item.first_name,
          last_name: item.last_name,
          second_last_name: item.second_last_name,
          j_name: item.j_name,
          full_name: "",
          rfc: item.rfc,
          email: item.email,
          phone_number: item.phone_number,
          id: item.id,
          url: item.url,
          poliza: null,
          usuario: null,
        };
        $scope.beneficiaries.push(beneficiary);
        $scope.benecifiarieSelected = {};
      }
    };

    $scope.addBeneficiary = function () {
      var beneficiary = {
        type_person: 1,
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        full_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        // poliza: null,
        usuario: null,
      };
      $scope.beneficiaries.push(beneficiary);
    };

    $scope.deleteBeneficiary = function (index) {
      $scope.beneficiaries.splice(index, 1);
    };

    $scope.typePerson = function (param, index) {
      $scope.beneficiaries[index].type_person = param;
    };

    $scope.matchesShows = function (parWord) {
      if (parWord) {
        if (parWord.length >= 3) {
          if (order.org_name == "ancora") {
            $scope.show_contratante = "contractors-match-fianzas/";
          } else {
            $scope.show_contratante = "contractors-match/";
          }
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: true,
              pp: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if (order.contratante.value.address_contractor) {
          if (order.contratante.value.address_contractor) {
            $scope.programa_contractor = order.contratante.value.url;
            $scope.has_programa_de_proveedores = true;
          }
        }
      }
    });

    $scope.changeProgram = function (param) {
      $scope.showPrograma = param;
    };

    $scope.validityInsurance = function () {
      if (!$scope.showPF) {
        if (!$scope.surety.poliza_number) {
          SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
          return;
        }
        if (!$scope.dataToSave.receipts) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
      }
      if (!$scope.aseguradoraSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        return;
      }
      if (!$scope.claveSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        return;
      }
      if (!$scope.ramoSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        return;
      }
      if (!$scope.subramoSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (!$scope.subramoTypeSelected) {
        SweetAlert.swal(
          "Error",
          "Agrega un tipo de subramo de fidelidad colectiva.",
          "error"
        );
        return;
      }
      if (!order.contacto.val) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        return;
      }
      if (!$scope.surety.address) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        return;
      }
      if (!$scope.surety.contract_poliza.guarantee_amount) {
        SweetAlert.swal("Error", "Agrega el monto a garantizar.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.rate) {
        SweetAlert.swal("Error", "Agrega la tarifa.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.activity) {
        SweetAlert.swal("Error", "Agrega el giro de la empresa.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.no_employees) {
        SweetAlert.swal("Error", "Agrega el número de empleados.", "error");
        return;
      }
      if (!$scope.surety.contract_poliza.description) {
        SweetAlert.swal(
          "Error",
          "Agrega el detalle adicional de garantía.",
          "error"
        );
        return;
      }
      var categoryFlag = false;
      $scope.categories.forEach(function (item, index) {
        if (item.name == "") {
          SweetAlert.swal(
            "Error",
            "Agrega un nombre a la carátula " + (index + 1) + ".",
            "error"
          );
          categoryFlag = true;
        }
        if (item.deductible == "") {
          SweetAlert.swal(
            "Error",
            "Agrega un porcentaje del deducible a la carátula " +
              (index + 1) +
              ".",
            "error"
          );
          categoryFlag = true;
        }
      });
      var beneficiaryFlag = false;
      $scope.surety.beneficiaries_poliza_many.forEach(function (item, index) {
        if (item.type_person == 1) {
          if (item.name == "") {
            SweetAlert.swal(
              "Error",
              "Agrega un nombre al beneficiario " + (index + 1) + ".",
              "error"
            );
            beneficiaryFlag = true;
          }
          if (item.last_name == "") {
            SweetAlert.swal(
              "Error",
              "Agrega un apellido paterno al beneficiario " + (index + 1) + ".",
              "error"
            );
            beneficiaryFlag = true;
          }
          // if(item.second_last_name == ''){
          //   SweetAlert.swal('Error', 'Agrega un apellio materno al beneficiario ' + (index + 1) + '.', 'error');
          //   beneficiaryFlag = true;
          // }
        } else {
          if (item.j_name == "") {
            SweetAlert.swal(
              "Error",
              "Agrega una razón social al beneficiario " + (index + 1) + ".",
              "error"
            );
            beneficiaryFlag = true;
          }
        }
        // if(item.rfc == ''){
        //     SweetAlert.swal('Error', 'Agrega un rfc al beneficiario ' + (index + 1) + '.', 'error');
        //     beneficiaryFlag = true;
        //   }
      });
      if (!$scope.surety.identifier) {
        SweetAlert.swal("Error", MESSAGES.ERROR.IDENTIFIERREQUIRED, "error");
        return;
      }
      $scope.referenciadorArray.forEach(function (item) {
        $scope.referenciadoresSelected = [];
        if (item.referenciador != "") {
          if (item.comision_vendedor == "") {
            item.comision_vendedor = 0;
          }
          $scope.referenciadoresSelected.push(item);
        }
      });
      if (beneficiaryFlag || categoryFlag) {
        return;
      } else {
        $scope.saveEditionSurety();
      }
    };

    $scope.renewalSelection = function (ren) {
      $scope.dataToSave.is_renewable = order.renewal.is_renewable;
      if (!$localStorage.save_edition_fianza_coletiva) {
        $localStorage.save_edition_fianza_coletiva = angular.copy(
          $scope.surety
        );
      }
      $localStorage.save_edition_fianza_coletiva["is_renewable"] = ren;
    };

    $scope.saveEditionSurety = function () {
      $scope.suretyEdition = {};
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      $scope.referenciadorArrayNew = [];
      $scope.referenciadorArray.forEach(function (item, index) {
        if (item.referenciador != "") {
          $scope.referenciadorArrayNew.push(item);
        }
      });

      $scope.suretyEdition.poliza_number = $scope.surety.poliza_number
        ? $scope.surety.poliza_number
        : null;
      $scope.suretyEdition.start_of_validity = $scope.startDate
        ? toDate($scope.startDate)
        : null;
      $scope.suretyEdition.end_of_validity = $scope.endDate
        ? toDate($scope.endDate)
        : null;
      $scope.suretyEdition.emision_date = $scope.surety.emision_date
        ? toDate($scope.surety.emision_date)
        : null;
      $scope.suretyEdition.aseguradora = $scope.aseguradoraSelected.url;
      $scope.suretyEdition.clave = $scope.claveSelected.url;
      $scope.suretyEdition.fianza_type = $scope.subramoTypeSelected.url;
      $scope.suretyEdition.fecha_cancelacion = $scope.surety.fecha_cancelacion
        ? $scope.surety.fecha_cancelacion
        : null;
      $scope.suretyEdition.monto_cancelacion = $scope.surety.monto_cancelacion
        ? $scope.surety.monto_cancelacion
        : 0;
      $scope.suretyEdition.f_currency = $scope.surety.f_currency;
      $scope.suretyEdition.contractor = order.contacto.value.full_name
        ? order.contacto.value.url
        : null;
      $scope.suretyEdition.address = $scope.surety.address.url;
      $scope.suretyEdition.document_type = 8;
      $scope.suretyEdition.forma_de_pago = 5;
      $scope.suretyEdition.identifier = $scope.surety.identifier;
      $scope.suretyEdition.status = $scope.surety.status;
      $scope.suretyEdition.bono_variable = $scope.surety.bono_variable
        ? parseFloat($scope.surety.bono_variable).toFixed(2)
        : 0;
      if ($scope.dataToSave.recibos_poliza) {
        $scope.suretyEdition.p_neta = $scope.dataToSave.p_neta
          ? $scope.dataToSave.p_neta
          : 0;
        $scope.suretyEdition.rpf = $scope.dataToSave.rpf
          ? $scope.dataToSave.rpf
          : 0;
        $scope.suretyEdition.derecho = $scope.dataToSave.derecho
          ? $scope.dataToSave.derecho
          : 0;
        $scope.suretyEdition.sub_total = $scope.dataToSave.sub_total
          ? $scope.dataToSave.sub_total
          : 0;
        $scope.suretyEdition.iva = $scope.dataToSave.iva
          ? $scope.dataToSave.iva
          : 0;
        $scope.suretyEdition.p_total = $scope.dataToSave.p_total
          ? $scope.dataToSave.p_total
          : 0;
        $scope.suretyEdition.comision = $scope.dataToSave.comision
          ? $scope.dataToSave.comision
          : 0;
        $scope.suretyEdition.comision_percent = $scope.dataToSave
          .comision_percent
          ? $scope.dataToSave.comision_percent
          : 0;
      } else if ($scope.dataToSave.poliza.num_receipts) {
        $scope.suretyEdition.p_neta = $scope.dataToSave.poliza.primaNeta
          ? $scope.dataToSave.poliza.primaNeta
          : 0;
        $scope.suretyEdition.rpf = $scope.dataToSave.poliza.rpf
          ? $scope.dataToSave.poliza.rpf
          : 0;
        $scope.suretyEdition.derecho = $scope.dataToSave.poliza.derecho
          ? $scope.dataToSave.poliza.derecho
          : 0;
        $scope.suretyEdition.sub_total = $scope.dataToSave.poliza.subTotal
          ? $scope.dataToSave.poliza.subTotal
          : 0;
        $scope.suretyEdition.iva = $scope.dataToSave.poliza.iva
          ? $scope.dataToSave.poliza.iva
          : 0;
        $scope.suretyEdition.p_total = $scope.dataToSave.poliza.primaTotal
          ? $scope.dataToSave.poliza.primaTotal
          : 0;
        $scope.suretyEdition.comision = $scope.dataToSave.comision
          ? $scope.dataToSave.comision
          : 0;
        $scope.suretyEdition.comision_percent = $scope.dataToSave
          .comision_percent
          ? $scope.dataToSave.comision_percent
          : 0;
      }
      $scope.suretyEdition.total_receipts = $scope.dataToSave.recibos_poliza
        ? $scope.dataToSave.recibos_poliza.length
        : 0;
      $scope.suretyEdition.beneficiaries_poliza = $scope.beneficiaries;
      $scope.suretyEdition.beneficiaries_poliza_many = $scope.beneficiaries;
      $scope.suretyEdition.contract_poliza = $scope.surety.contract_poliza;
      $scope.suretyEdition.ref_policy = $scope.referenciadorArrayNew;
      $scope.suretyEdition.is_renewable = order.renewal
        ? $scope.dataToSave.is_renewable
        : order.renewal.selected;

      // $scope.suretyEdition.programa_de_proveedores_contractor = $scope.programa_contractor ? $scope.programa_contractor : null;
      // $scope.suretyEdition.has_programa_de_proveedores = $scope.has_programa_de_proveedores ? true : false;

      if ($scope.showPrograma) {
        $scope.suretyEdition.has_programa_de_proveedores = true;
        $scope.suretyEdition.programa_de_proveedores_contractor =
          $scope.programa_contractor ? $scope.programa_contractor : null;
      } else {
        $scope.suretyEdition.has_programa_de_proveedores = false;
        $scope.suretyEdition.programa_de_proveedores_contractor = null;
      }

      ($scope.suretyEdition.date_emision_factura = $scope.surety
        .date_emision_factura
        ? datesFactory.toDate($scope.surety.date_emision_factura)
        : null),
        ($scope.suretyEdition.date_bono = $scope.surety.date_bono
          ? datesFactory.toDate($scope.surety.date_bono)
          : null),
        ($scope.suretyEdition.date_maquila = $scope.surety.date_maquila
          ? datesFactory.toDate($scope.surety.date_maquila)
          : null),
        ($scope.suretyEdition.year_factura = $scope.surety.year_factura
          ? $scope.surety.year_factura
          : 0),
        ($scope.suretyEdition.month_factura = $scope.month
          ? $scope.month.month_selected
          : 0),
        ($scope.suretyEdition.folio_factura = $scope.surety.folio_factura
          ? $scope.surety.folio_factura
          : ""),
        ($scope.suretyEdition.maquila = $scope.surety.maquila
          ? parseFloat($scope.surety.maquila).toFixed(2)
          : 0),
        ($scope.suretyEdition.exchange_rate = $scope.surety.exchange_rate
          ? parseFloat($scope.surety.exchange_rate).toFixed(2)
          : 0),
        $http
          .patch($scope.surety.url, $scope.suretyEdition)
          .then(function (response) {
            if (response.status == 200 || response.status == 201) {
              $scope.dataSurety = response.data;
              //recibos
              if ($scope.dataToSave.recibos_poliza) {
                $scope.dataToSave.receipts.forEach(function (item, index) {
                  if (
                    item.recibo_numero ==
                    $scope.dataToSave.recibos_poliza[index].recibo_numero
                  ) {
                    var object = {
                      prima_neta:
                        $scope.dataToSave.recibos_poliza[index].prima_neta,
                      rpf: $scope.dataToSave.recibos_poliza[index].rpf,
                      derecho: $scope.dataToSave.recibos_poliza[index].derecho,
                      sub_total:
                        $scope.dataToSave.recibos_poliza[index].sub_total,
                      iva: $scope.dataToSave.recibos_poliza[index].iva,
                      prima_total:
                        $scope.dataToSave.recibos_poliza[index].prima_total,
                      comision:
                        $scope.dataToSave.recibos_poliza[index].comision,
                      status: 4,
                      fecha_inicio: toDate(
                        $scope.dataToSave.recibos_poliza[index].startDate
                      ),
                      fecha_fin: toDate(
                        $scope.dataToSave.recibos_poliza[index].endingDate
                      ),
                      vencimiento: toDate(
                        $scope.dataToSave.recibos_poliza[index].vencimiento
                      ),
                    };

                    $http.patch(item.url, object).then(function (req) {});
                  }
                });
              }
              //contrato
              if ($scope.surety.contract_poliza) {
                var contract = {
                  guarantee_amount:
                    $scope.surety.contract_poliza.guarantee_amount,
                  rate: $scope.surety.contract_poliza.rate,
                  activity: $scope.surety.contract_poliza.activity,
                  no_employees: $scope.surety.contract_poliza.no_employees,
                  description: $scope.surety.contract_poliza.description,
                };
                $http
                  .patch($scope.surety.contract_poliza.url, contract)
                  .then(function (req) {});
              }
              // Referenciadores
              for (var i = 0; i < $scope.referenciadorArray.length; i++) {
                var dataRef = {
                  referenciador: $scope.referenciadorArray[i].url,
                  policy: $scope.dataSurety.url,
                  comision_vendedor: $scope.referenciadorArray[i]
                    .comision_vendedor
                    ? $scope.referenciadorArray[i].comision_vendedor
                    : 0,
                };
                if ($scope.referenciadorArray[i].url) {
                  $scope.referenciador_a_cambiar =
                    $scope.referenciadorArray[i].data;
                  var dataRef11 = {
                    comision_vendedor: $scope.referenciadorArray[i]
                      .comision_vendedor
                      ? parseFloat(
                          $scope.referenciadorArray[i].comision_vendedor
                        ).toFixed(2)
                      : 0,
                    referenciador: $scope.referenciadorArray[i].referenciador,
                  };
                  $http
                    .patch($scope.referenciadorArray[i].url, dataRef11)
                    .then(
                      function success(request) {},
                      function error(error) {
                        if (dataRef11.referenciador) {
                          var ref = dataRef11;
                          ref.policy = $scope.dataSurety.url;
                          dataFactory
                            .post("referenciadores-involved/", ref)
                            .then(
                              function success(request) {
                                $scope.ref_cambiado = request.data;
                                var params = {
                                  model: 13,
                                  event: "POST",
                                  associated_id: $scope.dataSurety.id,
                                  identifier:
                                    "cambio el Referenciador: " +
                                    $scope.referenciador_a_cambiar.first_name +
                                    " " +
                                    $scope.referenciador_a_cambiar.last_name +
                                    " por " +
                                    $scope.ref_cambiado.ref_name,
                                };
                                dataFactory
                                  .post("send-log/", params)
                                  .then(function success(response) {});
                              },
                              function error(error) {
                                console.log("6*", error);
                              }
                            )
                            .catch(function (e) {
                              console.log("7*", e);
                            });
                        }
                      }
                    )
                    .catch(function (e) {
                      console.log("2", e);
                    });
                } else {
                  if ($scope.referenciadorArray[i].referenciador) {
                    var ref = {};
                    ref.referenciador =
                      $scope.referenciadorArray[i].referenciador;
                    ref.comision_vendedor = $scope.referenciadorArray[i]
                      .comision_vendedor
                      ? parseFloat(
                          $scope.referenciadorArray[i].comision_vendedor
                        ).toFixed(2)
                      : 0;
                    ref.policy = $scope.dataSurety.url;
                    dataFactory
                      .post("referenciadores-involved/", ref)
                      .then(
                        function success(request) {},
                        function error(error) {
                          console.log("3", error);
                        }
                      )
                      .catch(function (e) {
                        console.log("4", e);
                      });
                  }
                }
              }
              //categorias
              $scope.categories.forEach(function (item, index) {
                if (item.url) {
                  var category = {
                    name: item.name,
                    deductible: item.deductible,
                    observations: item.observations,
                  };
                  $http
                    .patch(item.url, category)
                    .then(function (request) {
                      if (request.status == 200 || request.status == 201) {
                      }
                    })
                    .catch(function (e) {
                      l.stop();
                      console.log("error - caratula -cats catch", e);
                    });
                } else {
                  var json_category = [];
                  var category = {
                    caratula: $scope.surety.id,
                    name: $scope.categories[index].name,
                    deductible: $scope.categories[index].deductible,
                    observations: $scope.categories[index].observations,
                    document_type: 9,
                    parent: $scope.surety.id,
                  };
                  json_category.push(category);
                  $http
                    .post(
                      url.IP + "categories_collectivesurety/",
                      json_category
                    )
                    .then(function (request) {
                      if (request.status == 200 || request.status == 201) {
                      }
                    })
                    .catch(function (e) {
                      l.stop();
                      console.log("error - caratula -cats post catch", e);
                    });
                }
                if ($scope.categories_delete.length > 0) {
                  $scope.categories_delete.forEach(function (it) {
                    var cat1 = {
                      status: 0,
                    };
                    $http
                      .patch(it.url, cat1)
                      .then(function (responseC) {
                        if (
                          responseC.status == 200 ||
                          responseC.status == 201
                        ) {
                          it.certificados.forEach(function (cc) {
                            var cat1 = {
                              status: 0,
                              certificado_inciso_activo: false,
                            };
                            $http
                              .patch(cc.url, cat1)
                              .then(function (resp) {
                                if (resp.status == 200 || resp.status == 201) {
                                }
                              })
                              .catch(function (e) {
                                l.stop();
                                console.log("error - caratula -cats catch", e);
                              });
                          });
                        }
                      })
                      .catch(function (e) {
                        l.stop();
                        console.log("error - caratula -cats catch", e);
                      });
                  });
                }
              });
              // Beneficiarios
              if ($scope.surety.beneficiaries_poliza_many) {
                $scope.beneficiaries.forEach(function (item, index) {
                  if (item.url) {
                    item.poliza = $scope.dataSurety.url;
                    $http
                      .patch(item.url, item)
                      .then(function (request) {
                        if (request.status == 200 || request.status == 201) {
                        }
                      })
                      .catch(function (e) {
                        l.stop();
                        console.log("error - caratula ben- catch", e);
                      });
                  }
                  // else{
                  //   item.poliza = $scope.dataSurety.url;
                  //   item.poliza_many = $scope.dataSurety.id;
                  //   $http.post(url.IP + 'beneficiaries_contract_policy/', item)
                  //   .then(function(beneficiariess){
                  //     if(beneficiariess.status == 200 || beneficiariess.status == 201){

                  //     }
                  //   })
                  //   .catch(function (e) {
                  //     l.stop();
                  //     console.log('error - caratula - ben postcatch', e);
                  //   });
                  // }
                });
              }
              var params = {
                model: 13,
                event: "POST",
                associated_id: $scope.dataSurety.id,
                identifier: $scope.dataSurety.poliza_number
                  ? " actualizó la fianza colectiva."
                  : " actualizó el proyecto de fianza.",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              SweetAlert.swal(
                "¡Listo!",
                "La fianza se actualizó correctamente.",
                "success"
              );
              $state.go("fianzas.details", { polizaId: $scope.dataSurety.id });
            } else {
              l.stop();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("error - caratula -gral catch", e);
          });
    };

    // Referenciadores
    $scope.addReferenciador = function (type) {
      var addReferenciadores = {
        referenciador: $scope.referenciador ? $scope.referenciador : "",
      };
      $scope.referenciadores.push(addReferenciadores);
    };

    $scope.changeReferenciador = function (ref) {
      if (ref) {
        if (ref.data) {
          if (ref.data.url != ref.referenciador) {
            $http.get(ref.referenciador).then(function success(c) {
              var subBranchsComisions =
                c.data.user_info.info_vendedor[0].vendedor_subramos;
              subBranchsComisions.forEach(function (sr) {
                if (
                  (sr.subramo == order.form.subramo.subramo_code &&
                    sr.provider == order.form.aseguradora.id) ||
                  (sr.subramo == 0 && sr.provider == 0)
                ) {
                  ref.comision_vendedor = sr.comision;
                } else {
                  ref.comision_vendedor = 0;
                }
              });
            });
          }
          if (ref.data.url == ref.referenciador) {
            $http.get(ref.referenciador).then(function success(c) {
              var subBranchsComisions =
                c.data.user_info.info_vendedor[0].vendedor_subramos;
              subBranchsComisions.forEach(function (sr) {
                if (
                  (sr.subramo == order.form.subramo.subramo_code &&
                    sr.provider == order.form.aseguradora.id) ||
                  (sr.subramo == 0 && sr.provider == 0)
                ) {
                  ref.comision_vendedor = sr.comision;
                } else {
                  ref.comision_vendedor = ref.data.comision_policy;
                }
              });
            });
          }
        }
      }
      if (ref.referenciador) {
        ref.selectedRef = true;
      } else {
        ref.selectedRef = false;
      }
    };

    $scope.deleteReferenciador = function (param, index) {
      if (param.url) {
        SweetAlert.swal(
          {
            title: "Eliminar Referenciador",
            text: "Los cambios no podrán revertirse, ¿Estás seguro?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
          },
          function (isConfirm) {
            if (isConfirm) {
              $scope.referenciadorArray.forEach(function (item) {
                if (item.url) {
                  if (param.url == item.url) {
                    $http.delete(param.url);
                    $scope.referenciadorArray.splice(index, 1);
                    $scope.referenciadoresSelected.splice(index, 1);
                  }
                }
              });
            }
          }
        );
      } else {
        $scope.referenciadorArray.splice(index, 1);
      }
    };

    $scope.cancel = function () {
      $state.go("fianzas.details", { polizaId: $scope.surety.id });
    };
  }
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");
  app.factory(
    "VersionService_",
    function ($http, $interval, $window, $localStorage) {
      var currentVersion = null;

      function checkVersion() {
        return $http
          .get("/version.json", {
            cache: false,
            params: { t: Date.now() }, // cache-buster para evitar cache del navegador/proxy
          })
          .then(function (res) {
            var newVersion = res.data && res.data.version;
            $localStorage.versionNueva = newVersion;
            $localStorage.versionAnterior = currentVersion;
            console.log(
              "cureentVersion:",
              currentVersion,
              "newVersion:",
              newVersion
            );
            console.log(
              "versionserviceinitial",
              newVersion,
              "cersion newVersion:",
              res.data,
              "actual versión:",
              currentVersion
            );
            if (!currentVersion) {
              currentVersion = newVersion; // primera vez solo guardas
              return;
            }
            if (newVersion && currentVersion !== newVersion) {
              // Mejor que reload(true): forzar nueva carga con query
              $window.location.href =
                $window.location.pathname +
                "?_v=" +
                encodeURIComponent(newVersion);
              $window.location.reload(true); // fuerza reload (en algunos navegadores se ignora, pero ayuda)
            }
          });
      }

      function start(intervalMs) {
        checkVersion();
        $interval(checkVersion, intervalMs || 60000); // cada 60s por default
      }

      // 👇 ESTO ES LO QUE TE FALTABA
      return {
        start: start,
        checkVersion: checkVersion,
      };
    }
  );

  app.run(function (VersionService_) {
    VersionService_.start(60000); // por ejemplo cada 30s
  });
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");

  app.factory(
    "VersionService",
    function ($http, $interval, $window, $localStorage) {
      var currentVersion = null;
      var timer = null;

      function checkVersion() {
        return $http
          .get("/version.json", {
            cache: false,
            params: { t: Date.now() }, // cache-buster
          })
          .then(function (res) {
            var newVersion = res.data && res.data.version;
            $localStorage.versionNueva = newVersion;
            $localStorage.versionAnterior = currentVersion;
            console.log(
              "cureentVersion:",
              currentVersion,
              "newVersion:",
              newVersion
            );
            if (!currentVersion) {
              currentVersion = newVersion;
              return;
            }

            if (newVersion && currentVersion !== newVersion) {
              // Mejor que reload(true): forzar nueva carga con query
              $window.location.href =
                $window.location.pathname +
                "?_v=" +
                encodeURIComponent(newVersion);
            }
          })
          .catch(function () {});
      }

      function start(intervalMs) {
        if (timer) return; // ya está corriendo
        checkVersion();
        timer = $interval(checkVersion, intervalMs || 60000);
      }

      function stop() {
        if (timer) {
          $interval.cancel(timer);
          timer = null;
        }
      }

      return {
        start: start,
        stop: stop,
        checkVersion: checkVersion,
      };
    }
  );
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");

  app.factory("statusReceiptsFactory", [
    function () {
      var status = {};

      status.receipts = function (parStatus) {
        switch (parseInt(parStatus)) {
          case 1:
            return "Pagado";
            break;
          case 2:
            return "Cancelado";
            break;
          case 3:
            return "Prorrogado";
            break;
          case 4:
            return "Pendiente de pago";
            break;
          case 5:
            return "Liquidado";
            break;
          case 6:
            return "Conciliado";
            break;
          case 7:
            return "Cerrado";
            break;
          case 8:
            return "Precancelado";
            break;
          case 9:
            return "Pago Parcial";
            break;
          case 10:
            return "Anulado";
            break;
          case 11:
            return "Pre-anulado";
            break;
          default:
            return "Pendiente de pago";
        }
      };

      return status;
    },
  ]);
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");

  app.factory("priceFactory", [
    function () {
      var valor = {};

      valor.decimales = function (value) {
        var RE = /^\d*(\.\d{1})?\d{0,1}$/;
        if (RE.test(value)) {
          return false;
        } else {
          return true;
        }
      };

      valor.comas = function (value) {
        value = value.toString();
        if (value.indexOf(",") != -1) {
          return true;
        } else {
          return false;
        }
      };

      return valor;
    },
  ]);
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");

  app.factory("PersistenceFactory", [
    "$http",
    "url",
    "SweetAlert",
    "$sessionStorage",
    function ($http, url, SweetAlert, $sessionStorage) {
      var PersistenceFactory = {};
      var jsonform = "";
      var token,
        decryptedToken,
        json_basic,
        json_return,
        valido,
        validador,
        dato,
        v;
      var dt = [];

      var json_data = {};
      //var form = document.getElementsByTagName("form");
      var elementos = {};
      //Valores reutilizables
      var inputValue,
        selectValue,
        txtareaValue,
        checkboxValue,
        type,
        attr,
        valor;

      var url = "http://system-persistence.ixulabs.com/";

      dt.urlP = url + "saam/persistence/";
      dt.urlP2 = url + "saam/persistenceEdit/";
      dt.id_module = 0;
      dt.params = {
        org: "",
        module: "",
        token: "",
        user: "",
        status: false,
        data: "",
      };

      PersistenceFactory.interval = "";
      PersistenceFactory.init_return = "";
      PersistenceFactory.json_return = "";
      PersistenceFactory.json_basic = "";
      PersistenceFactory.json_init = "";
      PersistenceFactory.intervalTime = 20000;
      PersistenceFactory.count = 0;
      //clearInterval(PersistenceFactory.interval);

      PersistenceFactory.alert = function () {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "Cuenta con información en está sección. ¿Desea continuar?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Continuar",
            cancelButtonText: "Comenzar de nuevo",
            closeOnConfirm: false,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              SweetAlert.swal(
                "Cargando!",
                "Los datos se están cargando.",
                "success"
              );
              PersistenceFactory.init_return = { status: "data_view" };
            } else {
              SweetAlert.swal("Eliminada!", "Datos eliminados.", "error");
              PersistenceFactory.init_return = { status: "data_delete" };
              PersistenceFactory.editado(PersistenceFactory.json_basic);
            }
          }
        );
      };

      PersistenceFactory.inicial = function (org, module, user, jsonform) {
        PersistenceFactory.json_init = jsonform;
        PersistenceFactory.json_basic = jsonform;
        PersistenceFactory.init_return = "";

        if (PersistenceFactory.interval != "") {
          clearInterval(PersistenceFactory.interval);
          PersistenceFactory.interval = "";
        }

        decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
        token = JSON.parse(decryptedToken);

        dt.params.org = org;
        dt.params.module = module;
        dt.params.user = user;
        dt.params.token = token;

        $http
          .get(dt.urlP, {
            params: dt.params,
          })
          .success(function (data, headers) {
            if (data) {
              if (data.count == 0) {
                PersistenceFactory.guardado();
              } else {
                dt.id_module = data.results[0].id;
                PersistenceFactory.json_return = JSON.parse(
                  data.results[0].data
                );

                if (
                  PersistenceFactory.validar(
                    undefined,
                    PersistenceFactory.json_return
                  ) == true
                ) {
                  PersistenceFactory.alert();
                } else {
                  PersistenceFactory.init_return = {
                    status: "data_view_equal",
                  };
                }
              }
            }
          })
          .error(function (err) {
            console.log("Error" + err);
          });

        PersistenceFactory.count++;
      };

      PersistenceFactory.guardado = function () {
        dt.params.data = JSON.stringify(PersistenceFactory.json_basic);

        $http
          .post(dt.urlP, dt.params)
          .success(function (data, headers) {
            dt.id_module = data.id;
          })
          .success(function (data) {
            PersistenceFactory.json_return = JSON.parse(data.data);
            PersistenceFactory.init_return = { status: "data_new" };
          })
          .error(function (err) {
            console.log("Error: " + err);
          });
      };

      PersistenceFactory.editado = function (jsondt) {
        validador = PersistenceFactory.validar(
          jsondt,
          PersistenceFactory.json_return
        );

        dt.params.data = JSON.stringify(jsondt);

        if (validador == false) {
          dt.params.data = JSON.stringify(jsondt);

          $http
            .put(dt.urlP2 + dt.id_module + "/", dt.params)
            .success(function (data, headers) {})
            .success(function (data) {
              PersistenceFactory.json_return = JSON.parse(data.data);
            })
            .error(function (err) {
              console.log("Error: " + err);
            });
        }
      };

      PersistenceFactory.eliminar = function () {
        //validador = PersistenceFactory.validar(jsondt,PersistenceFactory.json_return);
        dt.params.data = JSON.stringify(PersistenceFactory.json_init);

        $http
          .put(dt.urlP2 + dt.id_module + "/", dt.params)
          .success(function (data, headers) {})
          .success(function (data) {
            PersistenceFactory.json_return = JSON.parse(data.data);
          })
          .error(function (err) {
            console.log("Error: " + err);
          });
      };

      PersistenceFactory.valid = function valid(obj) {
        if (typeof obj == "undefined" || obj == "text") {
          obj = "";
        } else {
          if (obj.id) {
            obj = obj.id;
          }
        }

        return obj;
      };

      PersistenceFactory.validar = function (json_basic, json_return) {
        //json_return = Object.values(json_return);
        valido = false;

        if (json_basic != undefined) {
          json_return = Object.values(json_return);
          json_basic = Object.values(json_basic);
          if (json_basic.length == json_return.length) {
            if (JSON.stringify(json_basic) == JSON.stringify(json_return)) {
              valido = true;
            }
          }
        } else {
          angular.forEach(json_return, function (values, data) {
            if (
              data != "cantidades" &&
              data != "bell" &&
              data != "address.country" &&
              data != "address.country_code" &&
              data != "listaD.value" &&
              data != "vm.form.fianzas_only" &&
              data != "vm.juridicalForm.fianzas_only" &&
              data != "new_task.fecha" &&
              data != "end_type" &&
              data != "campaign.repeatEmail" &&
              data != "campaign.sendingDate" &&
              data != "show_tags" &&
              data != "null" &&
              data != "new_siniestro.fecha" &&
              data != "new_siniestro.fechaIngreso" &&
              data != "new_siniestro.fechaSiniestro" &&
              data != "vm.show_state_city" &&
              data != "new_siniestro.numero_siniestro" &&
              data != "vm.siniester_type" &&
              data != "vm.siniester_pay_form" &&
              data != "vm.siniester_data.tipo_de_cambio" &&
              data != "vm.bono.cantidad" &&
              data != "vm.bono.end_validity" &&
              data != "vm.bono.start_validity" &&
              data != "vm.bono.tipo_de_cambio" &&
              data != "select_provider" &&
              data != "checkRegister" &&
              data != "endorsement_type_manual"
            ) {
              /*Validacion datos que se llenan por default -
          Cartas, Contratantes, Paquetes, Mensajeria, Siniestros (Vida, Accidente, Auto, Daños), Bonos



          && data != '' */
              if (
                values != "" &&
                values != " " &&
                values != "false" &&
                values != "?"
              ) {
                if (typeof values == "object") {
                  angular.forEach(values, function (val, dat) {
                    if (val.valor != "" && val.valor != " ") {
                      if (data == "html" && elementos.html[0].valor) {
                        if (elementos.html[0].valor != val.valor) {
                          valido = true;
                        }
                      } else {
                        valido = true;
                      }
                      //valido = true;
                    }
                  });
                } else {
                  valido = true;
                }
              }
            }
          });
        }

        return valido;
      };

      PersistenceFactory.find_index = function (obj, datos, tipo) {
        dato = "";

        angular.forEach(obj, function (values, data) {
          //dato = '';

          if (tipo == "id" && values.id == datos) {
            dato = data;
          }
          if (tipo == "name" && values.name == datos) {
            dato = data;
          }
          if (tipo == "url" && values.url == datos) {
            dato = data;
          }
          if (tipo == undefined && values.url == datos) {
            dato = data;
          }
          /*
        if(tipo == undefined && values.url == datos){
          dato = data;
        }*/
        });
        return dato;
      };

      PersistenceFactory.get_dataForm = function (form, adiccional) {
        var cnt = 0;
        var cant;

        elementos = {
          cantidades: {},
        };

        function forEach_value(array) {
          angular.forEach(
            array,
            function (value) {
              type = value.getAttribute("type");
              attr = value.getAttribute("ng-model");
              valor = PersistenceFactory.valid(value.value);
              cant = angular.element('[ng-model="' + attr + '"]');

              if (attr != "main.cadena" && type != "file") {
                if (type == "radio") {
                  if (value.getAttribute("aria-checked") == "true") {
                    this[attr] = valor;
                  }
                } else if (
                  attr == "vm.selected_affect" ||
                  attr == "quotationNew.ramo" ||
                  attr == "quotationNew.subramo"
                ) {
                  // Solo para Siniestro y Cotizacion  ya q lo guarda como objeto:00
                  if (valor != "") {
                    angular.forEach(
                      cant[0],
                      function (v, a) {
                        if (v.value == valor) {
                          this[attr] = a;
                        }
                      },
                      elementos
                    );
                  }
                } else {
                  this.cantidades[attr] = cant.length;
                  //Valor cambia si es checkbox
                  if (type == "checkbox") {
                    valor = value.getAttribute("aria-checked");
                  }

                  if (this.cantidades[attr] > 1) {
                    if (this[attr] == undefined) {
                      this[attr] = [{ valor: valor }];
                    } else {
                      this[attr][this[attr].length] = { valor: valor };
                    }
                  } else {
                    this[attr] = valor;
                  }
                }
              }
            },
            elementos
          );
        }
        //Tomar el autocompetar
        if (
          dt.params.module == "Siniestro_Vida" ||
          dt.params.module == "Siniestro_Auto" ||
          dt.params.module == "Siniestro_Danio"
        ) {
          if (adiccional != "" && adiccional != undefined) {
            elementos["vm.selected_affect.val"] = {
              id: adiccional.value.id,
              nombre: adiccional.val,
            };
          }
        }
        /*
      if(dt.params.module == 'Siniestro_Danio'){
        if( adiccional1 != '' && adiccional1 != undefined){
          elementos['vm.selected_affect.val']={'id':adiccional1.id,'nombre':adiccional1.val};
        }
      }*/

        angular.forEach(form, function (value, key, name) {
          inputValue = value.getElementsByTagName("input");
          selectValue = value.getElementsByTagName("select");
          txtareaValue = value.getElementsByTagName("textarea");
          checkboxValue = value.getElementsByTagName("checkbox");

          forEach_value(inputValue);
          forEach_value(selectValue);
          forEach_value(txtareaValue);
          forEach_value(checkboxValue);
        });

        return elementos;
      };

      PersistenceFactory.set_inputs = function (json) {
        console.log("set_inputs: ");
        angular.forEach(json, function (values, data) {
          if (
            data != "bell" &&
            data != "letter.model" &&
            data != "cantidades" &&
            data != "null" &&
            data != "vm.selected_affect" &&
            data != "endorsement_type_manual"
          ) {
            valor = angular.element('[ng-model="' + data + '"]');
            if (valor.length > 0) {
              type = valor[0].type;
            } else {
              type = "Error de Type!!";
            }

            valor.val(type);
            if (type == "radio") {
              valor = angular.element(
                '[ng-model="' + data + '"]',
                '[value="' + values + '"]'
              );
              valor.prevObject[0].checked = true;
              valor.prevObject[0].setAttribute("aria-checked", "true");
            } else if (data == "html") {
              document.getElementById(valor[0].id).innerHTML = values[0].valor;
              document.getElementById(valor[1].id).innerHTML = values[0].valor;

              document.getElementById(valor[0].id).value = values[0].valor;
              document.getElementById(valor[1].id).value = values[0].valor;
            } else if (valor.length > 1) {
              angular.forEach(valor, function (vale, dat) {
                if (
                  values[dat].valor != "text" &&
                  values[dat].valor != "textarea" &&
                  values[dat].valor != "tel"
                ) {
                  type = vale.getAttribute("type");

                  if (type == "checkbox") {
                    if (values[dat].valor == "true") {
                      valor[dat].checked = values[dat].valor;
                      valor[dat].setAttribute(
                        "aria-checked",
                        values[dat].valor
                      );
                    }
                  } else {
                    if (values[dat] != undefined && values[dat].valor != "") {
                      vale.value = values[dat].valor;
                    }
                  }
                }
              });
            } else {
              //type = values.getAttribute('type');
              if (type == "checkbox") {
                if (values == "true") {
                  valor[0].checked = values;
                  valor[0].setAttribute("aria-checked", values);
                }
              } else {
                valor.val(values);
              }
            }
          }
        });
      };

      PersistenceFactory.val_botons = function (data) {
        v = angular.element('[ng-disabled="' + data + '"]');
        v[0].disabled = false;
      };

      PersistenceFactory.changeInt = function (int) {
        var a_int = int;
        a_int = parseInt(a_int.substr(7, a_int.length));
        return a_int;
      };

      return PersistenceFactory;
    },
  ]);
})();

// app/services/paquetes-matcher.factory.js
(function () {
  "use strict";

  angular
    .module("inspinia") // usa tu módulo raíz
    .factory("PaquetesMatcher", PaquetesMatcher);

  function PaquetesMatcher() {
    // ==== Utils ====
    function _normalize(s) {
      if (!s) return "";
      var r = String(s);
      try {
        r = r.normalize("NFD");
      } catch (e) {}
      // quita diacríticos, mayúsculas, compacta espacios
      r = r
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .replace(/\s+/g, " ")
        .trim();
      return r;
    }

    function _tokenize(s) {
      s = _normalize(s);
      return s.split(/[^A-Z0-9\+]+/).filter(Boolean);
    }

    // “9 ESTAN” → { base:'ESTANDAR', numero:90 }
    function _parseEstandarTarget(pdfText) {
      var n = _normalize(pdfText);
      var m1 = n.match(/([4-9])\s*E?STAN/);
      if (m1) return { base: "ESTANDAR", numero: parseInt(m1[1], 10) * 10 };
      var m2 = n.match(/ESTAN(?:DAR)?\s*(\d{2})/);
      if (m2) return { base: "ESTANDAR", numero: parseInt(m2[1], 10) };
      if (/ESTAN/.test(n)) return { base: "ESTANDAR", numero: null };
      return null;
    }

    function _buildTargetNameFromPDF(pdfText, despacho) {
      var t = _parseEstandarTarget(pdfText);
      if (t) {
        if (_normalize(despacho) === "CES") return "ESTANDAR"; // genérico
        return t.numero ? "ESTANDAR " + t.numero : "ESTANDAR";
      }
      return _normalize(pdfText); // otros productos
    }

    function _buildTargetNameAxa(planTipo, gamaHospitalaria) {
      var base = _normalize(planTipo || "");
      var gama = _normalize(gamaHospitalaria || "");
      return base && gama ? base + " " + gama : base;
    }

    function _scorePackage(pkgName, targetName) {
      var pkgN = _normalize(pkgName),
        tgtN = _normalize(targetName);
      if (!pkgN || !tgtN) return -1;
      if (pkgN === tgtN) return 1000; // match exacto

      var pkgT = _tokenize(pkgN);
      var tgtT = _tokenize(tgtN);
      var setPkg = {};
      for (var i = 0; i < pkgT.length; i++) setPkg[pkgT[i]] = true;

      var hits = 0;
      for (var j = 0; j < tgtT.length; j++) if (setPkg[tgtT[j]]) hits++;

      if (hits === 0) return 0;

      var score = 500 * (hits / tgtT.length);
      var extras = Math.max(pkgT.length - tgtT.length, 0);
      score -= extras * 15;

      var numTgt = (tgtN.match(/\b\d+\b/) || [null])[0];
      var numPkg = (pkgN.match(/\b\d+\b/) || [null])[0];
      if (numTgt) {
        if (numPkg && numPkg === numTgt) score += 120;
        else if (numPkg && numPkg !== numTgt) score -= 120;
      } else {
        if (numPkg) score -= 60; // target sin número, evita específicos
      }

      if (pkgN.indexOf(tgtN) === 0) score += 60; // buen prefijo

      return score;
    }

    function _selectBestPackage(targetName, availablePackages) {
      var best = null,
        bestScore = -Infinity;
      for (var i = 0; i < (availablePackages || []).length; i++) {
        var name = availablePackages[i];
        var s = _scorePackage(name, targetName);
        if (s > bestScore) {
          bestScore = s;
          best = name;
        }
      }
      return { name: best, score: bestScore, target: targetName };
    }

    // ==== API pública ====
    function pickGmmEstandar(pdfText, despacho, availablePackages) {
      var target = _buildTargetNameFromPDF(pdfText, despacho);
      return _selectBestPackage(target, availablePackages);
    }

    function pickAxaFlexPlus(planTipo, gamaHospitalaria, availablePackages) {
      var target = _buildTargetNameAxa(planTipo, gamaHospitalaria);
      return _selectBestPackage(target, availablePackages);
    }

    // opcional: exponer helpers para debug/testing
    return {
      pickGmmEstandar: pickGmmEstandar,
      pickAxaFlexPlus: pickAxaFlexPlus,
      _debug: {
        normalize: _normalize,
        tokenize: _tokenize,
        scorePackage: _scorePackage,
      },
    };
  }
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");
  // --------------------------------------------------
  app.factory("NotificationService", [
    "$http",
    "url",
    "$rootScope",
    "$timeout",
    "dataFactory",
    "$sessionStorage",
    function ($http, url, $rootScope, $timeout, dataFactory, $sessionStorage) {
      var service = {};
      service.getNotifications = function () {
        if ($sessionStorage.token !== undefined) {
          return dataFactory
            .get("notifications-test")
            .then(function success(response) {
              $timeout(function () {
                $rootScope.notificationscount = response.data.count;
                $rootScope.$evalAsync(function () {
                  $rootScope.notificationscount = response.data.count;
                });
              });
            });
        }
      };
      return service;
    },
  ]);
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");

  app.factory("notesFactory", [
    "$http",
    "datesFactory",
    "helpers",
    "SweetAlert",
    "MESSAGES",
    function ($http, datesFactory, helpers, SweetAlert, MESSAGES) {
      var notesFactory = {};

      notesFactory.updateFieldD = function (policy, infoNotes, actual_receipt) {
        var credit_notes = [];
        var initDate = new Date(policy.init_date);
        var endDate = new Date(policy.end_date);
        var prima_neta = parseFloat(infoNotes.p_neta);
        var prima_total = parseFloat(infoNotes.p_total);
        var rpf = parseFloat(infoNotes.rpf);
        var gastos_expedicion = parseFloat(infoNotes.gastos_expedicion);
        var sub_total_ = (
          parseFloat(prima_neta) +
          parseFloat(rpf) +
          parseFloat(gastos_expedicion)
        ).toFixed(2);
        if (policy.subramo.subramo_name == "Vida") {
          var iva = 0;
        } else {
          if (infoNotes.iva) {
            var iva = parseFloat(infoNotes.iva).toFixed(2);
          } else {
            // var iva = parseFloat((parseFloat(infoNotes.p_neta) * 0.16)).toFixed(2)
            var iva = parseFloat(subtotal_) * 0.16;
          }
        }

        if (policy.comision_percent) {
          var comision = parseFloat(
            parseFloat(infoNotes.p_neta) *
              (parseFloat(policy.comision_percent) / 100)
          ).toFixed(2);
          if (
            isNaN(comision) ||
            comision == undefined ||
            comision == "" ||
            comision == ""
          ) {
            var comision = 0;
          }
        } else {
          var comision = 0;
        }
        if (comision == "") {
          comision = 0;
        }
        // var iva = parseFloat(infoNotes.iva);
        // ------------------------------
        var init_poliza = new Date(policy.start_of_validity);
        var end_poliza = new Date(policy.end_of_validity);

        var init_endoso = new Date(policy.init_date);
        var end_endoso = new Date(policy.end_date);

        if (!actual_receipt) {
          for (var i = 0; i < infoNotes.num_notas; i++) {
            var obj = {
              folio: (i + 1).toString(),
              prima_neta: -(prima_neta / infoNotes.num_notas).toFixed(2),
              gastos_expedicion: -(
                gastos_expedicion / infoNotes.num_notas
              ).toFixed(2),
              rpf: -(rpf / infoNotes.num_notas).toFixed(2),
              iva: -(iva / infoNotes.num_notas).toFixed(2),
              comision: -(comision / infoNotes.num_notas).toFixed(2),
              sub_total: -(
                (prima_neta + rpf + gastos_expedicion) /
                infoNotes.num_notas
              ).toFixed(2),
              prima_total: -(prima_total / infoNotes.num_notas).toFixed(2),
              fecha_inicio: new Date(infoNotes.fecha_inicio),
              fecha_fin: new Date(infoNotes.endDate),
              initDate: new Date(infoNotes.fecha_inicio),
              endDate: new Date(infoNotes.endDate),
            };

            credit_notes.push(obj);
          }
          var init_poliza = convertDate(policy.start_of_validity);
          if (infoNotes.num_notas != 0) {
            if (policy.aseguradora) {
              if (
                datesFactory.toDate(policy.init_date) <
                datesFactory.toDate(convertDate(policy.start_of_validity))
              ) {
                SweetAlert.swal(
                  "Vigencia de Endoso",
                  "Fechas de endoso no están en el rango de vigencia de la póliza",
                  "info"
                );
                return;
              } else if (
                datesFactory.toDate(policy.init_date) <
                datesFactory.toDate(init_poliza)
              ) {
                SweetAlert.swal(
                  "Fechas de vigencia de Endoso",
                  "Fechas de endoso no están en el rango de vigencia de la póliza",
                  "info"
                );
                return;
              }
            }
          }

          var m = 0;
          var c = 0;
          if (policy.recibos_poliza) {
            for (var i = 0; i < policy.recibos_poliza.length; i++) {
              if (policy.recibos_poliza[i].receipt_type == 1) {
                if (
                  datesFactory.toDate(policy.init_date) >=
                    datesFactory.toDate(
                      convertDate(policy.recibos_poliza[i].fecha_inicio)
                    ) &&
                  datesFactory.toDate(policy.init_date) <
                    datesFactory.toDate(
                      convertDate(policy.recibos_poliza[i].fecha_fin)
                    )
                ) {
                  if (m == 0) {
                    credit_notes[m].fecha_inicio = datesFactory.toDate(
                      policy.init_date
                    );
                    credit_notes[m].fecha_fin =
                      policy.recibos_poliza[i].fecha_fin;
                    credit_notes[m].initDate = datesFactory.toDate(
                      policy.init_date
                    );
                    credit_notes[m].endDate =
                      policy.recibos_poliza[i].fecha_fin;
                    credit_notes[m].vencimiento =
                      policy.recibos_poliza[i].vencimiento;
                    credit_notes[m].recibo_numero = m + 1;
                    m = m + 1;
                    c = i + 1;
                  }
                } else if (m > 0 && credit_notes[m]) {
                  credit_notes[m].fecha_inicio =
                    policy.recibos_poliza[i].fecha_inicio;
                  credit_notes[m].fecha_fin =
                    policy.recibos_poliza[i].fecha_fin;
                  credit_notes[m].initDate =
                    policy.recibos_poliza[i].fecha_inicio;
                  credit_notes[m].endDate = policy.recibos_poliza[i].fecha_fin;
                  credit_notes[m].vencimiento =
                    policy.recibos_poliza[i].vencimiento;
                  credit_notes[m].recibo_numero = m + 1;
                  m = m + 1;
                  c = i + 1;
                }
              }
            }
          }
          if (credit_notes) {
            credit_notes.forEach(function (cred, cred_index) {
              if (cred.fecha_inicio == "Invalid Date") {
                cred.fecha_inicio = "";
                cred.fecha_fin = "";
                cred.initDate = "";
                cred.endDate = "";
                SweetAlert.swal(
                  "Fechas de vigencia: Notas de Crédito",
                  MESSAGES.INFO.VIGENCYNOTECREDITWRITE,
                  "info"
                );
              } else {
                cred.fecha_inicio = cred.fecha_inicio;
                cred.fecha_fin = cred.fecha_fin;
                cred.initDate = convertDate(cred.fecha_inicio);
                cred.endDate = convertDate(cred.fecha_fin);
              }
            });
          }

          return credit_notes;
        } else {
          credit_notes.push(actual_receipt);
          var endDate = datesFactory.toDate(policy.end_date);
          var initDate = datesFactory.toDate(policy.init_date);
          var prima_neta = parseFloat(
            infoNotes.p_neta - -actual_receipt.prima_neta
          );
          var rpf = parseFloat(infoNotes.rpf - -actual_receipt.rpf);
          var gastos_expedicion = parseFloat(
            infoNotes.gastos_expedicion - -actual_receipt.gastos_expedicion
          );
          var iva = parseFloat(infoNotes.iva - -actual_receipt.iva);

          var num_notas = infoNotes.num_notas - 1;
          for (var i = 0; i < num_notas; i++) {
            var obj = {
              folio: (i + 1).toString(),
              prima_neta: -(prima_neta / num_notas),
              gastos_expedicion: -(gastos_expedicion / num_notas),
              rpf: -(rpf / num_notas).toFixed(2),
              iva: -(iva / num_notas).toFixed(2),
              sub_total: -(
                (prima_neta + rpf + gastos_expedicion) /
                num_notas
              ).toFixed(2),
              prima_total: -(
                (prima_neta + rpf + iva + gastos_expedicion) /
                num_notas
              ).toFixed(2),
            };
            obj.fecha_inicio = datesFactory.convertDate(initDate);
            obj.vencimiento = datesFactory.convertDate(initDate)
              ? datesFactory.convertDate(initDate)
              : null;
            // obj.vencimiento = datesFactory.convertDate(vencimiento_date) ? datesFactory.convertDate(vencimiento_date) : null;

            obj.startDate = datesFactory.convertDate(initDate);
            obj.endingDate = datesFactory.convertDate(endDate);
            obj.fecha_fin = datesFactory.convertDate(endDate);

            initDate = new Date(endDate);

            credit_notes.push(obj);
          }
          var m = 0;
          var c = 0;
          if (policy.recibos_poliza) {
            for (var i = 0; i < policy.recibos_poliza.length; i++) {
              if (policy.recibos_poliza[i].receipt_type == 1) {
                if (
                  datesFactory.toDate(policy.init_date) >=
                    datesFactory.toDate(
                      convertDate(policy.recibos_poliza[i].fecha_inicio)
                    ) &&
                  datesFactory.toDate(policy.init_date) <
                    datesFactory.toDate(
                      convertDate(policy.recibos_poliza[i].fecha_fin)
                    )
                ) {
                  // if((policy.init_date )>= (convertDate(policy.recibos_poliza[i].fecha_inicio) )&& ((policy.init_date )< (convertDate(policy.recibos_poliza[i].fecha_fin)))){
                  if (m == 0) {
                    credit_notes[m].fecha_inicio = datesFactory.toDate(
                      policy.init_date
                    );
                    credit_notes[m].fecha_fin =
                      policy.recibos_poliza[i].fecha_fin;
                    credit_notes[m].initDate = datesFactory.toDate(
                      policy.init_date
                    );
                    credit_notes[m].endDate =
                      policy.recibos_poliza[i].fecha_fin;
                    credit_notes[m].vencimiento =
                      policy.recibos_poliza[i].vencimiento;
                    credit_notes[m].recibo_numero = m + 1;
                    m = m + 1;
                    c = i + 1;
                  } else {
                  }
                } else if (m > 0 && credit_notes[m]) {
                  credit_notes[m].fecha_inicio =
                    policy.recibos_poliza[i].fecha_inicio;
                  credit_notes[m].fecha_fin =
                    policy.recibos_poliza[i].fecha_fin;
                  credit_notes[m].initDate =
                    policy.recibos_poliza[i].fecha_inicio;
                  credit_notes[m].endDate = policy.recibos_poliza[i].fecha_fin;
                  credit_notes[m].vencimiento =
                    policy.recibos_poliza[i].vencimiento;
                  credit_notes[m].recibo_numero = m + 1;
                  m = m + 1;
                  c = i + 1;
                }
              }
            }
          }
          if (credit_notes) {
            credit_notes.forEach(function (cred, cred_index) {
              if (cred.fecha_inicio == "Invalid Date" || !cred.initDate) {
                cred.fecha_inicio = "";
                cred.fecha_fin = "";
                cred.initDate = "";
                cred.endDate = "";
                SweetAlert.swal(
                  "Fechas de vigencia: Notas de Crédito",
                  "Agregue manualmente",
                  "info"
                );
              } else {
                cred.fecha_inicio = cred.fecha_inicio;
                cred.fecha_fin = cred.fecha_fin;
                cred.initDate = convertDate(cred.fecha_inicio);
                cred.endDate = convertDate(cred.fecha_fin);
              }
            });
          }

          return credit_notes;
        }
      };
      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          var date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          var date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }

        return date;
      }
      function toDate(dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

        return dateObject;
      }

      return notesFactory;
    },
  ]);
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");

  app.factory("mcFactory", [
    "$http",
    "url",
    "$localStorage",
    function ($http, url, $localStorage) {
      if ($localStorage.loginInfo) {
        var user_info = JSON.parse($localStorage.loginInfo);

        return {
          urlname: user_info.org.urlname + "mc",
        };
      } else {
        return null;
      }

      // return {
      //   urlname: 'local',
      //   user: 'angy',
      //   password: '123'
      // };

      // return {
      //    'username': 'testing',
      //    'password': 'testing',
      //    'urlname': 'testing'
      //  };
      // return {
      //   urlname: 'grupoasapi',
      //   user: 'superuser_prevex',
      //   password: 'superuser_prevex'
      // }
    },
  ]);
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");

  app.factory("formatValues", [
    function () {
      var values = {};

      values.currency = function (parValue) {
        if (parValue) {
          parValue = parValue.toString();

          if (
            parValue.search(/[A-Za-z]/g) > -1 ||
            parValue.search(/[0-9]%/g) > -1
          ) {
            return parValue;
          } else {
            var num = parseFloat(parValue);
            var num_format =
              "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");

            return num_format;
            // return parValue;
          }
        }
      };

      return values;
    },
  ]);
})();

app.directive("fileChange", function () {
  return {
    restrict: "A",
    scope: { fileChange: "&" },
    link: function (scope, element) {
      element.bind("change", function (event) {
        var files = event.target.files;
        scope.$apply(function () {
          scope.fileChange({ files: files });
        });
      });
    },
  };
});

(function () {
  "use-strict";

  var app = angular.module("inspinia");

  app.factory("exportFactory", [
    "$http",
    "url",
    "$q",
    "$sessionStorage",
    "SweetAlert",
    function ($http, url, $q, $sessionStorage, SweetAlert) {
      var exportFactory = {};

      exportFactory.excel = function (parData, parName) {
        var wb = XLSX.utils.json_to_sheet(parData);

        var workbook = {
          SheetNames: ["Plough &amp; Stars"],
          Sheets: {
            "Plough &amp; Stars": wb,
            "!ref": wb["!ref"],
          },
        };

        var wbout = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        function s2ab(s) {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);

          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
          return buf;
        }

        saveAs(
          new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
          "Reporte_" + parName + ".xlsx"
        );

        return "ok";
      };

      function buildQueryParams(params) {
        params = params || {};
        return Object.keys(params)
          .filter(function (key) {
            return (
              params[key] !== undefined &&
              params[key] !== null &&
              params[key] !== ""
            );
          })
          .map(function (key) {
            return key + "=" + encodeURIComponent(params[key]);
          })
          .join("&");
      }

      function decryptToken() {
        var tokenValue = "";
        try {
          var storedToken = $sessionStorage.token
            ? JSON.parse(sjcl.decrypt("Token", $sessionStorage.token))
            : "";
          if (
            storedToken &&
            typeof storedToken === "object" &&
            storedToken.token
          ) {
            tokenValue = storedToken.token;
          } else if (storedToken) {
            tokenValue = storedToken;
          }
        } catch (e) {
          console.warn("exportFactory: no token available", e);
        }
        return tokenValue;
      }

      function defaultChannelMapper(responseData) {
        if (!responseData) {
          return "";
        }
        if (typeof responseData === "string") {
          return responseData;
        }
        return (
          responseData.channel ||
          responseData.task ||
          responseData.id ||
          responseData.name ||
          ""
        );
      }

      function normalizeUrl(u) {
        return u || "";
      }

      function extractUrl(payload) {
        if (!payload) return "";

        // Si el socket ya manda el signed URL como string, úsalo tal cual
        if (typeof payload === "string") {
          try {
            var parsed = JSON.parse(payload);
            return extractUrl(parsed);
          } catch (e) {
            return payload;
          }
        }

        // Si manda objeto, toma el campo que traiga la URL completa
        var full =
          payload.url ||
          payload.download_url ||
          payload.signed_url ||
          payload.path ||
          "";

        // Si por alguna razón el backend manda params separados, reconstrúyelos
        // (esto evita que se pierda el querystring)
        if (full && full.indexOf("?") === -1) {
          var qs = payload.query || payload.qs || "";
          if (!qs) {
            var parts = [];
            if (payload.AWSAccessKeyId)
              parts.push(
                "AWSAccessKeyId=" + encodeURIComponent(payload.AWSAccessKeyId)
              );
            if (payload.Signature)
              parts.push("Signature=" + encodeURIComponent(payload.Signature));
            if (payload.Expires)
              parts.push("Expires=" + encodeURIComponent(payload.Expires));
            if (parts.length) qs = parts.join("&");
          }
          if (qs) full = full + "?" + qs;
        }

        return full;
      }

      function triggerDownload(downloadUrl, payload, options) {
        if (!downloadUrl) {
          return $q.reject(new Error("No se proporcionó URL de descarga"));
        }
        return $q(function (resolve) {
          if (typeof options.onDownload === "function") {
            options.onDownload(downloadUrl, payload);
            resolve(payload);
            return;
          }
          var bodyHtml = "<p>Tu bitacora está lista, haz clic en descargar</p>";

          SweetAlert.swal(
            {
              title: "Archivo listo",
              text: bodyHtml, // <-- en v1 es "text"
              html: true, // <-- habilita HTML en el texto
              type: "success",
              showCancelButton: false,
              confirmButtonText: "Descargar",
            },
            function (isConfirm) {
              if (isConfirm) {
                window.open(downloadUrl, "_blank");
              }
              resolve(payload);
            }
          );

          // Forzar HTML en el botón confirm (porque v1 lo escapa)
          setTimeout(function () {
            var btn = document.querySelector(".sweet-alert button.confirm");
            if (btn) {
              btn.innerHTML =
                '<i class="fa fa-download" aria-hidden="true" style="margin-right:8px;"></i> Descargar';
            }
          }, 0);
        }).then(function (result) {
          if (typeof options.onReady === "function") {
            options.onReady(result);
          }
          return result;
        });
      }

      function defaultDownloadUrl(payload) {
        return extractUrl(payload);
      }

      function subscribeToChannel(channel, options) {
        var deferred = $q.defer();
        var socketUrl = options.socketUrl || url.REPORT_SERVICE_NODE_SOCKET;
        console.log(
          "exportFactory subscribing to channel",
          channel,
          "via",
          socketUrl
        );
        var socket = io.connect(socketUrl);

        var cleanup = function () {
          if (socket) {
            socket.disconnect();
            socket = null;
          }
        };

        socket.emit("subscribe", channel);

        socket.on(channel, function (payload) {
          var downloadUrl = (options.downloadUrlResolver || defaultDownloadUrl)(
            payload
          );
          if (!downloadUrl) {
            deferred.reject(new Error("No se recibió una URL de descarga"));
            cleanup();
            return;
          }
          triggerDownload(downloadUrl, payload, options)
            .then(function (result) {
              deferred.resolve(result);
            })
            .catch(function (err) {
              deferred.reject(err);
            })
            .finally(function () {
              cleanup();
            });
        });

        socket.on("error", function (err) {
          cleanup();
          deferred.reject(err);
        });

        return deferred.promise;
      }

      exportFactory.commentsExport = function (options) {
        options = options || {};
        var params = options.params || {};
        var query = buildQueryParams(params);
        if (!query) {
          return $q.reject(new Error("No se proporcionaron parámetros"));
        }

        var exportUrl = url.IP + "comments-export/?" + query;
        var headers = {};
        var bearerToken = options.token || decryptToken();
        if (bearerToken) {
          headers.Authorization = "Bearer " + bearerToken;
        }

        return $http({
          method: "GET",
          url: exportUrl,
          headers: headers,
        }).then(function (response) {
          console.log("Es una prueba response", response);
          if (
            !response ||
            response.status < 200 ||
            response.status >= 300 ||
            !response.data
          ) {
            throw new Error("La descarga falló");
          }
          var payload = response.data;
          var directUrl = (options.directUrlResolver || defaultDownloadUrl)(
            payload
          );
          if (directUrl) {
            return triggerDownload(directUrl, payload, options);
          }
          var channel = (options.channelMapper || defaultChannelMapper)(
            payload
          );
          if (!channel) {
            throw new Error("No se pudo determinar el canal de exportación");
          }
          return subscribeToChannel(channel, options);
        });
      };

      return exportFactory;
    },
  ]);
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");

  app.factory("esFactory", [
    "$http",
    "url",
    function ($http, url) {
      var esFactory = {};
      esFactory.get = function (parUrl, parData) {
        return $http({
          method: "GET",
          url: parUrl,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
          data: parData,
        });
      };
      return esFactory;
      // app.service('es', function (esFactory) {
      //     return esFactory({
      //         host: url.SUPERBUSCADOR_ANCORA,
      //         // ...
      //     });
      // });
    },
  ]);
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");

  app.factory("datesFactory", [
    function () {
      var dates = {};

      dates.mesDiaAnio = function (parDate) {
        var d = new Date(dates.toDate(parDate));
        var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
        return date;
      };

      dates.toDate = function (dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

        return dateObject;
      };
      dates.convertDate = function (inputFormat) {
        // console.log('fecha original',inputFormat)
        // function pad(s) { return (s < 10) ? '0' + s : s; }
        // var d_uno = new Date(inputFormat);
        // var fecha = new Date(inputFormat);
        // if (fecha.getUTCHours() <=11){
        //   fecha.setHours(fecha.getHours()+12);
        // }else{
        //   fecha.setHours(fecha.getHours()+5);
        // }
        // var d = fecha
        // // var d = new Date(inputFormat).toISOString()//prueba
        // // console.log('-fecha 2',d,new Date(d.toLocaleString()))
        // var date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
        // return date;
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
        return date;
      };

      dates.getAge = function (dateString) {
        var today = new Date();
        var birthDate = new Date(dates.toDate(dateString));
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }

        return age;
      };

      return dates;
    },
  ]);
})();

(function () {
  "use-strict";

  var app = angular.module("inspinia");

  app.factory("dataFactory", [
    "$http",
    "url",
    function ($http, url) {
      var dataFactory = {};

      dataFactory.get = function (parUrl, parData) {
        if (parUrl == "get-pdf") {
          return $http({
            method: "GET",
            url: url.IP + parUrl,
            params: parData,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/x-www-form-urlencoded",
            },
            data: parData,
            responseType: "arraybuffer",
          });
        } else {
          return $http({
            method: "GET",
            url: url.IP + parUrl,
            params: parData,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/x-www-form-urlencoded",
            },
            data: parData,
          });
        }
      };

      dataFactory.post = function (parUrl, parData) {
        return $http({
          method: "POST",
          url: url.IP + parUrl,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/x-www-form-urlencoded",
          },
          data: parData,
        });
      };

      dataFactory.update = function (parUrl, parData) {
        return $http({
          method: "PATCH",
          url: url.IP + parUrl,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/x-www-form-urlencoded",
          },
          data: parData,
        });
      };

      dataFactory.patch = function (parUrl, parData) {
        return $http({
          method: "PATCH",
          url: parUrl,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/x-www-form-urlencoded",
          },
          data: parData,
        });
      };
      dataFactory.postCas = function (parUrl, parData) {
        return $http({
          method: "POST",
          url: url.casIp + parUrl,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/x-www-form-urlencoded",
          },
          data: parData,
        });
      };

      return dataFactory;
    },
  ]);
})();


(function () {
  "use strict";

  angular.module("inspinia").factory("endorsementService", endorsementService);

  endorsementService.$inject = ["url", "helpers", "globalVar", "$http", "$q"];

  function endorsementService(url, helpers, globalVar, $http, $q) {
    var service = {
      createAutomobileEndorsement: createAutomobileEndorsement,
      createDamageEndorsement: createDamageEndorsement,
      createDiseaseEndorsement: createDiseaseEndorsement,
      createLifeEndorsement: createLifeEndorsement,
      updateEndorsement: updateEndorsement,
      existEndorsement: existEndorsement,
    };

    return service;

    function getAllEndorsements(parStatus) {
      var auto = $http({
        method: "GET",
        url: globalVar.automobileInfoEndorsement,
        params: {
          status: parStatus,
        },
      });
      var damage = $http({
        method: "GET",
        url: globalVar.damageInfoEndorsement,
        params: {
          status: parStatus,
        },
      });
      var disease = $http({
        method: "GET",
        url: globalVar.diseaseInfoEndorsement,
        params: {
          status: parStatus,
        },
      });
      var life = $http({
        method: "GET",
        url: globalVar.lifeInfoEndorsement,
        params: {
          status: parStatus,
        },
      });

      // TODO add disease and life to q.all

      return $q.all([auto, damage, life, disease]).then(function (res) {
        var endorsements = [];
        var defered = $q.defer();

        res.forEach(function (element, index) {
          try {
            element.data.results.forEach(function (element2) {
              endorsements.push(element2);
            });
          } catch (error) {}
        });
        defered.resolve(endorsements);
        return defered.promise;
      });
    }

    function getAllResumeEndorsements() {
      var auto = $http.get(globalVar.automobileMinEndorsement);
      var damage = $http.get(globalVar.damageMinEndorsement);
      var disease = $http.get(globalVar.diseaseMinEndorsement);
      var life = $http.get(globalVar.lifeMinEndorsement);

      // TODO add disease and life to q.all

      return $q.all([auto, damage, life, disease]).then(function (res) {
        var endorsements = [];
        var defered = $q.defer();
        // console.log('res', res);
        res.forEach(function (element, index) {
          element.data.results.forEach(function (element2) {
            endorsements.push(element2);
          });
        });
        defered.resolve(endorsements);
        return defered.promise;
      });
    }

    function getEndorsement(req) {
      var url;
      if (req.endorsementType === "automobile") {
        url = globalVar.automobileMoreInfoEndorsement + req.endorsementId + "/";
      } else if (req.endorsementType === "damage") {
        url = globalVar.damageMoreInfoEndorsement + req.endorsementId + "/";
      } else if (req.endorsementType === "disease") {
        url = globalVar.diseaseMoreInfoEndorsement + req.endorsementId + "/";
      } else if (req.endorsementType === "life") {
        url = globalVar.lifeMoreInfoEndorsement + req.endorsementId + "/";
      }
      // console.log('url',url)
      return $http
        .get(url)
        .then(getEndorsementComplete)
        .catch(getEndorsementFailed);

      function getEndorsementComplete(res) {
        // console.log('resService',res)
        if (!helpers.isResponseOk(res)) {
          getEndorsementFailed(res);
        }
        //TODO change serializer

        // return $http.get(res.data.policy.url)
        //   .then(function(policy){
        //     res.data.policyRead = policy.data;
        return res;
        //   });
      }

      function getEndorsementFailed(error) {
        return error;
      }
    }

    function createAutomobileEndorsement(req) {
      return $http
        .post(globalVar.automobileEndorsement, req)
        .then(createAutomobileEndorsementComplete)
        .catch(createAutomobileEndorsementFailed);

      function createAutomobileEndorsementComplete(res) {
        if (!helpers.isResponseOk(res)) {
          return createAutomobileEndorsementFailed(res);
        }
      }

      function createAutomobileEndorsementFailed(error) {
        return error;
      }
    }

    function createDamageEndorsement(req) {
      return $http
        .post(globalVar.damageEndorsement, req)
        .then(createDamageEndorsementComplete)
        .catch(createDamageEndorsementFailed);

      function createDamageEndorsementComplete(res) {
        if (!helpers.isResponseOk(res)) {
          return createDamageEndorsementFailed(res);
        }
      }

      function createDamageEndorsementFailed(error) {
        return error;
      }
    }

    function createDiseaseEndorsement(req) {
      return $http
        .post(globalVar.diseaseEndorsement, req)
        .then(createDiseaseEndorsementComplete)
        .catch(createDiseaseEndorsementFailed);

      function createDiseaseEndorsementComplete(res) {
        if (!helpers.isResponseOk(res)) {
          return createDiseaseEndorsementFailed(res);
        }
      }

      function createDiseaseEndorsementFailed(error) {
        return error;
      }
    }

    function createLifeEndorsement(req) {
      return $http
        .post(globalVar.lifeEndorsement, req)
        .then(createLifeEndorsementComplete)
        .catch(createLifeEndorsementFailed);

      function createLifeEndorsementComplete(res) {
        if (!helpers.isResponseOk(res)) {
          return createLifeEndorsementFailed(res);
        }
      }

      function createLifeEndorsementFailed(error) {
        return error;
      }
    }

    function updateEndorsement(req) {
      if (req.id_policy_original) {
        if (req.id_policy_original.url) {
          req.id_policy_original = req.id_policy_original.url;
        }
      }
      return $http
        .put(req.url, req)
        .then(function (res) {
          return res;
        })
        .catch(function (error) {
          return error;
        });
    }

    function existEndorsement(req) {
      return $http
        .get(globalVar.existEndorsement.replace(":id", req))
        .then(function (res) {
          return res.data;
        });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndososPlantillasCtrl", EndososPlantillasCtrl);

  EndososPlantillasCtrl.$inject = [
    "$uibModal",
    "$scope",
    "$sce",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "$sessionStorage",
    "textAngularManager",
    "FileUploader",
    "$rootScope",
  ];

  function EndososPlantillasCtrl(
    $uibModal,
    $scope,
    $sce,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    $sessionStorage,
    textAngularManager,
    FileUploader,
    $rootScope
  ) {
    var vm = this;
    $scope.showQuotation = false;
    $scope.showInfoQuotation = false;
    $scope.showEditInformation = false;
    $scope.plantilla = {};
    $scope.savingPlantilla = false;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;
    $scope.configurar = false;
    $scope.createQuotation = function () {
      $scope.showQuotation = true;
    };
    $scope.cambiarCampos = function () {
      $scope.configuracionGlobal = {};
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
        }
      });
      $scope.configurar = !$scope.configurar;
    };
    $scope.closeQuotation = function () {
      $scope.showQuotation = false;
      $scope.plantilla = {};
    };
    $scope.cambiarDato = function (dato, valor) {
      var data = {};
      data[dato.toString()] = valor;
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, data)
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory.post("orginfo/", data).then(function success(response) {
            if (response.status == 201) {
              $scope.configuracionGlobal = response.data;
              SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
              return;
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
            } else {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            }
          });
        }
      }
    };
    activate();

    function activate() {
      $scope.configuracionGlobal = {};
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
        }
      });
      dataFactory
        .get("emailtemplate/", { template_model: 6 })
        .then(function success(response) {
          vm.quotations = response.data.results;
          vm.config_pagination = response.data;
          $scope.show_pagination = true;
        });
    }

    $scope.selectProv = function (sel) {
      $scope.aseguradoras = sel;
    };

    $scope.showInformation = function (item) {
      if (item) {
        $scope.showInfoQuotation = !$scope.showInfoQuotation;
        $scope.quotation = item;
      } else {
        $scope.showInfoQuotation = !$scope.showInfoQuotation;
      }
    };

    $scope.saveDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (
        !form ||
        !form.name ||
        !form.title ||
        !form.text ||
        !form.bottom_text
      ) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de continuar.",
          "warning"
        );
        return;
      }

      var payload = angular.copy(form);
      payload.template_model = 6;
      payload.dato_casegurado = false;
      $scope.savingPlantilla = true;

      dataFactory
        .post("emailtemplate/", payload)
        .then(function success(response) {
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla guardada correctamente.",
            "success"
          );
          $scope.closeQuotation();
          activate();
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.updateDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (
        !form ||
        !form.name ||
        !form.title ||
        !form.text ||
        !form.bottom_text
      ) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de actualizar.",
          "warning"
        );
        return;
      }

      $scope.savingPlantilla = true;

      var data = {
        name: form.name,
        title: form.title,
        text: form.text,
        bottom_text: form.bottom_text,
      };
      $http
        .patch(form.url, data)
        .then(function success(response) {
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla actualizada correctamente.",
            "success"
          );
          $scope.closeQuotation();
          activate();
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.borrarPlantilla = function (item) {
      if (!item || !item.url) {
        return;
      }
      SweetAlert.swal(
        {
          title: "¿Confirmas la eliminación?",
          text: "La plantilla se eliminará permanentemente.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí, borrar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }
          $http
            .delete(item.url)
            .then(function success() {
              SweetAlert.swal(
                "¡Listo!",
                "Plantilla eliminada correctamente.",
                "success"
              );
              activate();
            })
            .catch(function () {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            });
        }
      );
    };

    $scope.changeFechaLimiteEmail = function (val) {
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, {
              fecha_limite_email_cobranza:
                $scope.configuracionGlobal.fecha_limite_email_cobranza,
            })
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory
            .post("orginfo/", {
              fecha_limite_email_cobranza:
                $scope.configuracionGlobal.fecha_limite_email_cobranza,
            })
            .then(function success(response) {
              if (response.status == 201) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
      }
    };

    $scope.changeButtonSegumovilEmail = function (val) {
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, {
              boton_segumovil: $scope.configuracionGlobal.boton_segumovil,
            })
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory
            .post("orginfo/", {
              boton_segumovil: $scope.configuracionGlobal.boton_segumovil,
            })
            .then(function success(response) {
              if (response.status == 201) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
      }
    };
    $scope.editQuatation = function (form) {
      $scope.plantilla.name = form.name;
      $scope.plantilla.title = form.title;
      $scope.plantilla.text = form.text;
      $scope.plantilla.bottom_text = form.bottom_text;
      $scope.plantilla.url = form.url;
      $scope.showQuotation = true;
      $scope.showEditInformation = true;
    };
    $scope.focusEditor = function () {
      $scope.editor_focus = true;
    };

    $scope.unfocusEditor = function () {};

    $scope.getFile = function () {
      var editor = textAngularManager.retrieveEditor("myEditorCreate").scope;
      editor.displayElements.text.trigger("focus");

      var modalInstance = $uibModal.open({
        template:
          '<label class="col-xs-12 btn btn-info">Agregar Imagen desde PC' +
          '<input multiple nv-file-select="" type="file" name="xyz" uploader="uploader" accept=".jpg" class="display-none"/>' +
          "</label>",
        // size: 'sm',
        controller: ModalInstanceFileCtrl,
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (imgUrl) {
        var imageLink;
        imageLink = $rootScope.image_url;
        var embed = '<img src="' + imageLink + ' ">';
        // return textAngular.$editor().wrapSelection('insertHTML', embed, true);

        var editor = textAngularManager.retrieveEditor("myEditorCreate");
        editor.scope.wrapSelection("insertHTML", embed, true);
      });
    };
    function ModalInstanceFileCtrl($scope, $rootScope, $uibModalInstance) {
      $scope.userInfo = {
        id: 0,
      };
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        allowedFileType: ["png", "jpg", "jpeg"],
      }));

      $scope.userInfo.url = $scope.uploader.url = url.IP + "plantillas-html/";
      $scope.uploader.autoUpload = true;
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $rootScope.image_url = response.arch;
        if ($uibModalInstance) {
          $uibModalInstance.close();
        }
      };
      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };
      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });
      };
      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = usr.org;
      };
      $scope.validateFiles = function () {
        var input = document.getElementById("fileInput");
        var files = input.files;
        var totalSize = 0;
        var errorMessageElement = document.getElementById("error-message");
        for (var i = 0; i < files.length; i++) {
          totalSize += files[i].size;
        }
        var totalSizeMB = totalSize / (1024 * 1024);
        if (totalSizeMB > 25) {
          errorMessageElement.style.display = "block";
          errorMessageElement.textContent =
            "La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.";
        } else {
          errorMessageElement.style.display = "none"; // Hide error message if files are valid
        }
      };
      function uploadFiles() {
        $scope.userInfo.url = $scope.uploader.url = url.IP + "plantillas-html/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndososPendingMassiveCtrl", EndososPendingMassiveCtrl);

  EndososPendingMassiveCtrl.$inject = [
    "SweetAlert",
    "$scope",
    "$http",
    "url",
    "toaster",
    "$state",
    "$stateParams",
    "$uibModal",
    "providerService",
    "ramoService",
    "packageService",
    "insuranceService",
    "endorsementService",
    "dataFactory",
  ];

  function EndososPendingMassiveCtrl(
    SweetAlert,
    $scope,
    $http,
    url,
    toaster,
    $state,
    $stateParams,
    $uibModal,
    providerService,
    ramoService,
    packageService,
    insuranceService,
    endorsementService,
    dataFactory
  ) {
    var vm = (vm2 = this);
    vm.endorsement = [];
    vm.subforms = [];
    vm.receipts = [];

    vm.changeStatusModal = changeStatusModal;
    vm.goToPolicy = goToPolicy;
    vm.alta_ben_only = false;
    vm.subforms_alta = [];

    activate();

    function goToPolicy(poliza) {
      $state.go("colectividades.info", { polizaId: vm.endorsement.policy.id });
    }
    function activate() {
      $scope.certificate_number_save = false;
      var aux_array = [];
      var aux_array1 = [];

      dataFactory.get("has-view-cartas-permission").then(function (req) {
        if (req.status == 200) {
          $scope.view_cartas = req.data;
        }
      });

      dataFactory
        .get("get-endo-notas/", $stateParams)
        .then(function success(response) {
          vm.notas = response.data.results;
        });

      endorsementService.getEndorsement($stateParams).then(function (res) {
        vm.subforms = [];
        vm.endorsement = res.data;
        $scope.getCover($stateParams.polizaId);

        $http({
          method: "POST",
          url: url.IP + "get-relation/",
          data: {
            ramo: vm.endorsement.policy.subramo.subramo_code,
            id_endoso: vm.endorsement.id,
          },
        }).then(function success(request) {
          for (var i = 0; i < request.data.length; i++) {
            if (request.data[i].certificate.life_policy) {
              request.data[i].certificate.life_policy.forEach(function (
                certificate
              ) {
                vm.subforms.push(certificate);
                vm.subforms[i].certificate_number =
                  request.data[i].certificate.certificate_number;
                vm.subforms[i].proceed = request.data[i].proceed;
                if (
                  vm.subforms[i].certificate_number == "" ||
                  vm.subforms[i].certificate_number == undefined
                ) {
                  vm.endorsement.c = true;
                }
              });
            }
            if (request.data[i].certificate.accidents_policy) {
              request.data[i].certificate.accidents_policy.forEach(function (
                certificate
              ) {
                vm.subforms.push(certificate);
                vm.subforms[i].certificate_number =
                  request.data[i].certificate.certificate_number;
                vm.subforms[i].proceed = request.data[i].proceed;
                if (
                  vm.subforms[i].certificate_number == "" ||
                  vm.subforms[i].certificate_number == undefined
                ) {
                  vm.endorsement.c = true;
                }
              });
            }
            if (request.data[i].certificate.damages_policy) {
              request.data[i].certificate.damages_policy.forEach(function (
                certificate
              ) {
                vm.subforms.push(certificate);
                vm.subforms[i].certificate_number =
                  request.data[i].certificate.certificate_number;
                vm.subforms[i].proceed = request.data[i].proceed;
              });
              $http
                .get(
                  url.IP +
                    "endosos/" +
                    vm.endorsement.id +
                    "/archivos/?type_endoso=2"
                )
                .then(function success(response) {
                  if (response.data.results.length) {
                    vm.files = response.data.results;
                  }
                });
            }
            if (request.data[i].certificate.automobiles_policy) {
              request.data[i].certificate.automobiles_policy.forEach(function (
                certificate
              ) {
                vm.subforms.push(certificate);
                vm.subforms[i].certificate_number =
                  request.data[i].certificate.certificate_number;
                vm.subforms[i].proceed = request.data[i].proceed;
                if (
                  vm.subforms[i].certificate_number == "" ||
                  vm.subforms[i].certificate_number == undefined
                ) {
                  vm.endorsement.c = true;
                }
              });

              $http
                .get(
                  url.IP +
                    "endosos/" +
                    vm.endorsement.id +
                    "/archivos/?type_endoso=4"
                )
                .then(function success(response) {
                  if (response.data.results.length) {
                    vm.files = response.data.results;
                  }
                });
            }
          }
          if (request.data.length > 0 && !vm.subforms) {
            for (var i = 0; i < request.data.length; i++) {
              if (request.data[i].certificate.life_policy) {
                request.data[i].certificate.life_policy.forEach(function (
                  certificate
                ) {
                  vm.subforms.push(certificate);
                  vm.subforms[i].certificate_number =
                    request.data[i].certificate.certificate_number;
                  vm.subforms[i].proceed = request.data[i].proceed;
                });
              }
              if (request.data[i].certificate.accidents_policy) {
                request.data[i].certificate.accidents_policy.forEach(function (
                  certificate
                ) {
                  vm.subforms.push(certificate);
                  vm.subforms[i].certificate_number =
                    request.data[i].certificate.certificate_number;
                  vm.subforms[i].proceed = request.data[i].proceed;
                  if (
                    vm.subforms[i].certificate_number == "" ||
                    vm.subforms[i].certificate_number == undefined
                  ) {
                    vm.endorsement.c = true;
                  }
                });
              }
              if (request.data[i].certificate.damages_policy) {
                request.data[i].certificate.damages_policy.forEach(function (
                  certificate
                ) {
                  vm.subforms.push(certificate);
                  vm.subforms[i].certificate_number =
                    request.data[i].certificate.certificate_number;
                  vm.subforms[i].proceed = request.data[i].proceed;
                  if (
                    vm.subforms[i].certificate_number == "" ||
                    vm.subforms[i].certificate_number == undefined
                  ) {
                    vm.endorsement.c = true;
                  }
                });
                $http
                  .get(
                    url.IP +
                      "endosos/" +
                      vm.endorsement.id +
                      "/archivos/?type_endoso=2"
                  )
                  .then(function success(response) {
                    if (response.data.results.length) {
                      vm.files = response.data.results;
                    }
                  });
              }
              if (request.data[i].certificate.automobiles_policy) {
                request.data[i].certificate.automobiles_policy.forEach(
                  function (certificate) {
                    vm.subforms.push(certificate);
                    vm.subforms[i].certificate_number =
                      request.data[i].certificate.certificate_number;
                    vm.subforms[i].proceed = request.data[i].proceed;
                    if (
                      vm.subforms[i].certificate_number == "" ||
                      vm.subforms[i].certificate_number == undefined
                    ) {
                      vm.endorsement.c = true;
                    }
                  }
                );

                $http
                  .get(
                    url.IP +
                      "endosos/" +
                      vm.endorsement.id +
                      "/archivos/?type_endoso=4"
                  )
                  .then(function success(response) {
                    if (response.data.results.length) {
                      vm.files = response.data.results;
                    }
                  });
              }
            }
          }
          if (request.data.length == 0 || !vm.subforms) {
            if (vm.endorsement.disease) {
              vm.dep_is_active = [];
              vm.dep_isnot_active = [];
              vm.endorsement.policy.accidents_policy[0].personal =
                vm.endorsement.disease.personal;
              for (
                var i = 0;
                i < vm.endorsement.policy.accidents_policy.length;
                i++
              ) {
                vm.endorsement.policy.accidents_policy.forEach(function (
                  dependientes
                ) {
                  dependientes.relationship_accident.forEach(function (
                    dep_not
                  ) {
                    if (dep_not.is_active == true) {
                      vm.dep_is_active.push(dep_not);
                    } else {
                      vm.dep_isnot_active.push(dep_not);
                      dependientes.relationship_accident = vm.dep_isnot_active;
                      // vm.subforms[i] = vm.endorsement.policy.accidents_policy
                      vm.subforms = vm.endorsement.policy.accidents_policy;
                    }
                  });
                });
              }
            } else if (vm.endorsement.damages) {
              vm.endorsement.policy.damages_policy[0].personal =
                vm.endorsement.damages.personal;
              vm.subforms = vm.endorsement.policy.damages_policy;
            } else if (vm.endorsement.life) {
              vm.ben_is_active = [];
              vm.ben_isnot_active = [];
              for (
                var i = 0;
                i < vm.endorsement.policy.life_policy.length;
                i++
              ) {
                vm.endorsement.policy.life_policy.forEach(function (
                  beneficiaries
                ) {
                  beneficiaries.beneficiaries_life.forEach(function (ben_not) {
                    if (ben_not.is_active == true) {
                      vm.ben_is_active.push(ben_not);
                    } else {
                      vm.ben_isnot_active.push(ben_not);
                      beneficiaries.beneficiaries_life = vm.ben_isnot_active;
                      // vm.subforms[i] = vm.endorsement.policy.accidents_policy
                      vm.subforms = vm.endorsement.policy.life_policy;
                    }
                  });
                });
              }
            } else if (vm.endorsement.automobiles) {
              // vm.endorsement.policy.automobile_policy[0].personal = vm.endorsement.life.personal
              vm.subforms = vm.endorsement.policy.automobiles_policy;
            }
          }
        });
      });
    }

    $scope.getCover = function (parId) {
      $http({
        method: "GET",
        url: url.IP + "get-caratula/" + parId + "/",
      })
        .then(
          function success(request) {
            vm.policy = request.data;
            if (request.status === 200) {
              if (vm.policy.contractor) {
                $scope.direccion_contratante = [];
                vm.contractor = vm.policy.contractor;
                vm.contractor.name = vm.policy.contractor.full_name;
                vm.contractor.type_person = vm.policy.contractor.type_person;
                vm.contractor.emall = vm.policy.contractor.emall;
                vm.contractor.phone_number = vm.policy.contractor.phone_number;
                vm.contractor.address =
                  vm.policy.contractor.address_contractor[0].route +
                  " " +
                  vm.policy.contractor.address_contractor[0].street_number +
                  " " +
                  vm.policy.contractor.address_contractor[0].street_number_int +
                  " " +
                  vm.policy.contractor.address_contractor[0]
                    .administrative_area_level_2 +
                  ", " +
                  vm.policy.contractor.address_contractor[0]
                    .administrative_area_level_1;
              }
              vm.receipts = vm.policy.recibos_poliza;
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    vm.goToReceipt = goToReceipt;
    function goToReceipt(receipt) {
      var vmmm = receipt;
      var modalInstance = $uibModal.open({
        templateUrl: "app/endosos/endosos.receipts.html",
        controller: EndososPendingModalCtrl,
        controllerAs: "vmmm",
        size: "lg",
        resolve: {
          endosoModal: function () {
            return vmmm;
          },
        },
      });
    }

    var arrayCertificate = [];
    var selectedCertificate = [];
    var certificate = [];

    vm.NotasModal = NotasModal;
    function NotasModal(receipt) {
      vm.insuranceNote_ = receipt.policy;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/notaCredito.modal.html",
        controller: "NotaCreditoCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return vm.insuranceNote_;
          },
          from: function () {
            return null;
          },
        },
      });
    }

    $scope.addCertificate = function (id) {
      var idx = selectedCertificate.indexOf(id);
      if (idx == -1) {
        selectedCertificate.push(id);
        var obj = {
          id: id,
        };
        certificate.push(obj);
        $scope.cert_ev = certificate;
        vm.endorsement.cert = $scope.cert_ev;
      } else {
        var idx = selectedCertificate.indexOf(id);
        selectedCertificate.splice(idx, 1);
        certificate.splice(idx, 1);
      }
    };

    $scope.checkSelected = function (id) {
      return selectedCertificate.indexOf(id) > -1;
    };

    $scope.changeStatusColectivity = function () {
      arrayCertificate = [];
      var certs = {};
      certs.certificados = certificate;
      certs.caratula = vm.policy.id;
      //certs.id_endoso = vm.endorsement.id;
      //certs.status_endoso = vm.endorsement.status;
      arrayCertificate.push(certs);
      changeStatus();
    };

    function changeStatus() {
      if (
        vm.endorsement.status === 2 ||
        vm.endorsement.status === 3 ||
        vm.endorsement.status === 4
      ) {
        toaster.info("No es posible modificar este endoso.");
      } else {
        var modalInstance = $uibModal.open({
          templateUrl: "app/endosos/endosos.status.html",
          controller: EndososPendingModalCtrl,
          controllerAs: "vmm",
          size: "lg",
          resolve: {
            endosoModal: function () {
              return vm.endorsement;
            },
            policy_endorsement: function () {
              return vm.policy;
            },
          },
        });
      }
    }

    function changeStatusModal(receipt, contra) {
      receipt.contratante = contra;
      var index = vm.receipts.indexOf(receipt);
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(function (receipt) {
        activate();
        vm.receipts = receipt;
      });
    }

    function EndososPendingModalCtrl(
      $sessionStorage,
      FileUploader,
      SweetAlert,
      $scope,
      toaster,
      MESSAGES,
      endosoModal,
      endorsement,
      $uibModalInstance,
      $state,
      policy_endorsement,
      datesFactory,
      $http
    ) {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);

      var vmm = this;
      vmm.selectedType = "";
      vmm.status = [];
      vmm.prima_total = 0;
      vmm.iva = 16;
      vmm.sub_total = 0;
      vmm.folio = false;
      vmm.statusIva = true;
      var sumaEndosoRecibo = 0.0;
      vmm.form = {
        folio: "",
      };

      vmm.createdNote = false;

      vmm.options = {
        save: save,
        cancel: cancel,
      };

      vmm.endorsement = endosoModal;
      vmm.enableSave = enableSave;
      vmm.updateField = updateField;
      vmm.updateFieldD = updateFieldD;
      vmm.changeIva = changeIva;
      vmm.policy = policy_endorsement;

      vmm.form.num_receipts = vmm.policy.forma_de_pago;

      vmm.creditNotes = {
        fecha_emision: datesFactory.convertDate(new Date()),
        payform: vmm.policy.forma_de_pago,
        f_currency: 1,
        life_endorsement: null,
        disease_endorsement: null,
        damages_endorsement: null,
        auto_endorsement: null,
        // policy: vmm.endorsement.policy.id,
      };
      vmm.credit_notes = [];

      /** Uploader files */
      $scope.userInfo = {
        id: 0,
      };
      $scope.countFile = 0;
      $scope.okFile = 0;

      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      //     name: 'customFilter',
      //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
      //         return this.queue.length < 20;
      //     }
      // });

      // ALERTA SUCCES UPLOADFILES
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $scope.okFile++;
        if ($scope.okFile == $scope.countFile) {
          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
          $state.go("endosos.pending");
        }
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
          nombre: fileItem.file.name,
        });

        if (fileItem) {
          $scope.countFile++;
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
      };

      function uploadFiles(endorsementId, type_endoso) {
        $scope.userInfo = {
          id: endorsementId,
        };
        $scope.userInfo.url = $scope.uploader.url =
          url.IP +
          "endosos/" +
          endorsementId +
          "/archivos/?type_endoso=" +
          type_endoso;

        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }

      if (endosoModal.policy.ramo.ramo_code != 1) {
        vmm.creditNotes.iva_percentage = 16;
      } else {
        vmm.creditNotes.iva_percentage = 0;
      }

      if (vmm.endorsement.status === 1) {
        vmm.status.push(endorsement[2], endorsement[4]);
      } else if (vmm.endorsement.status === 5) {
        vmm.status.push(endorsement[1], endorsement[2], endorsement[3]);
      }

      $('input[id="calcularB"]').prop("disabled", true);

      function enableSave() {
        vmm.folio = false;
        vmm.form.folio = endosoModal.endorsement.folio_endorsement;

        // if (vmm.selectedType.value === 5) {
        //     vmm.folio = true;
        //     toaster.info('Favor de agregar su folio.');
        // } else {
        //     vmm.folio = false;
        // }
        vmm.endorsement.certif = false;
        if (vmm.endorsement.c && vmm.selectedType.value == 2) {
          vmm.endorsement.certif = true;
        }
        if (vmm.endorsement.endorsement_type != "D") {
          vmm.createdNote = true;
        }
      }

      function checkReceipts() {
        suma = 0.0;
        var prima_total = vmm.prima_total;
        vm.endorsement.policy.recibos_poliza.forEach(function (recibo) {
          suma += parseFloat(recibo.prima_total);
        });
        if (suma != prima_total) {
          return false;
        } else {
          return true;
        }
      }

      function changeIva(parValue) {
        if (!parValue) {
          swal("La póliza se creará sin IVA.");
          vmm.iva = 0;
        } else {
          vmm.iva = 16;
        }
      }

      function updateField() {
        if (vmm.iva == 0) {
          var ivaOperation = 0.0;
          var totalIva = 0;
        } else if (vmm.iva == 16) {
          var ivaOperation = 0.16;
        }

        sumaEndosoRecibo = 0.0;
        var rpf = parseFloat(vmm.rpf);
        var derecho = parseFloat(vmm.derecho);
        var sub_total = parseFloat(vmm.sub_total);
        var iva = parseFloat(parseFloat(vmm.sub_total) * ivaOperation);
        var prima_neta = parseFloat(vmm.prima_neta);

        vmm.sub_total = prima_neta + rpf + derecho;
        vmm.prima_total = vmm.sub_total + vmm.sub_total * ivaOperation;

        try {
          var recibos = vm.endorsement.policy.recibos_poliza;
        } catch (e) {
          toaster.warning("Ha ocurrido un error");
          return;
        }

        for (var i = 0; i < recibos.length; i++) {
          if (recibos[i].receipt_type == 2) {
            var minDate = new Date(
              new Date(recibos[i].fecha_inicio).setHours(12, 0, 0, 0)
            );
            var maxDate = new Date(
              new Date(recibos[i].fecha_fin).setHours(12, 0, 0, 0)
            );
            break;
          }
        }
        for (var i = 0; i < recibos.length; i++) {
          if (recibos[i].receipt_type == 2) {
            if (
              minDate >
              new Date(new Date(recibos[i].fecha_inicio).setHours(12, 0, 0, 0))
            ) {
              minDate = new Date(
                new Date(recibos[i].fecha_inicio).setHours(12, 0, 0, 0)
              );
            }
            if (
              maxDate <
              new Date(new Date(recibos[i].fecha_fin).setHours(12, 0, 0, 0))
            ) {
              maxDate = new Date(
                new Date(recibos[i].fecha_fin).setHours(12, 0, 0, 0)
              );
            }
          }
        }

        var diffDays =
          parseInt((maxDate - minDate) / (1000 * 60 * 60 * 24)) + 1;

        var cost_per_day = prima_neta / diffDays;
        var cost_rpf_per_day = rpf / diffDays;
        var cost_derecho_per_day = derecho / diffDays;
        var days_left = 0;
        var receipts_left = 0;
        var sub = 0.0;
        var total = 0.0;

        for (var i = 0; i < recibos.length; i++) {
          if (recibos[i].receipt_type == 2) {
            if (recibos[i].recibo_numero == 1) {
              var diffReceiptDays =
                1 +
                parseInt(
                  new Date(
                    new Date(recibos[i].fecha_fin).setHours(12, 0, 0, 0) -
                      new Date(
                        new Date(recibos[i].fecha_inicio).setHours(12, 0, 0, 0)
                      )
                  ) /
                    (1000 * 60 * 60 * 24)
                );
              recibos[i].prima_neta = (cost_per_day * diffReceiptDays).toFixed(
                2
              );
              if ($("#configRPFEndoso").prop("checked")) {
                recibos[i].rpf = rpf;
              } else {
                var round = Number(
                  (cost_rpf_per_day * diffReceiptDays).toFixed(2)
                );
                recibos[i].rpf = round;
              }
              if ($("#configDerechoEndoso").prop("checked")) {
                recibos[i].derecho = derecho;
              } else {
                recibos[i].derecho = Number(
                  (cost_derecho_per_day * diffReceiptDays).toFixed(2)
                );
              }

              sub =
                parseFloat(recibos[i].prima_neta) +
                parseFloat(recibos[i].rpf) +
                parseFloat(recibos[i].derecho);
              recibos[i].sub_total = parseFloat(sub).toFixed(2);
              var ivaReceipt = parseFloat(recibos[i].sub_total) * ivaOperation;
              recibos[i].iva = parseFloat(ivaReceipt).toFixed(2);
              total = sub + parseFloat(recibos[i].iva);
              recibos[i].prima_total = parseFloat(total).toFixed(2);
            } else {
              receipts_left++;
            }
          }
        }
        days_left = diffDays - diffReceiptDays;

        for (var i = 0; i < recibos.length; i++) {
          if (recibos[i].receipt_type == 2) {
            if (recibos[i].recibo_numero != 1) {
              recibos[i].prima_neta = (
                (cost_per_day * days_left) /
                receipts_left
              ).toFixed(2);

              if ($("#configDerechoEndoso").prop("checked")) {
                recibos[i].derecho = 0;
              } else {
                recibos[i].derecho = Number(
                  ((cost_derecho_per_day * days_left) / receipts_left).toFixed(
                    2
                  )
                );
              }
              if ($("#configRPFEndoso").prop("checked")) {
                recibos[i].rpf = 0;
              } else {
                recibos[i].rpf = Number(
                  ((cost_rpf_per_day * days_left) / receipts_left).toFixed(2)
                );
              }

              sub =
                parseFloat(recibos[i].prima_neta) +
                parseFloat(recibos[i].rpf) +
                parseFloat(recibos[i].derecho);
              recibos[i].sub_total = parseFloat(sub).toFixed(2);
              var ivaReceipt = parseFloat(recibos[i].sub_total) * ivaOperation;
              recibos[i].iva = parseFloat(ivaReceipt).toFixed(2);
              total = sub + parseFloat(recibos[i].iva);
              recibos[i].prima_total = parseFloat(total).toFixed(2);
            }
          }
        }
      }
      vmm.f_currency = {};
      vmm.f_currency.options = [
        { value: 1, label: "PESOS" },
        { value: 2, label: "DOLARES" },
      ];

      $scope.dataPayform = [
        { value: 1, name: "MENSUAL" },
        { value: 2, name: "BIMESTRAL" },
        { value: 3, name: "TRIMESTRAL" },
        { value: 4, name: "CUATRIMESTRAL" },
        { value: 5, name: "CONTADO" },
        { value: 6, name: "SEMESTRAL" },
        { value: 12, name: "ANUAL" },
      ];

      vmm.creditNotes = {
        fecha_emision: datesFactory.convertDate(new Date()),
        payform: "",
      };

      function updateFieldD() {
        if (vmm.creditNotes.iva_percentage > 100) {
          toaster.error(MESSAGES.ERROR.GREATERTHAN100);
        }

        if (vmm.creditNotes.rpf_percentage) {
          toaster.error(MESSAGES.ERROR.GREATERTHAN100);
        }

        vmm.credit_notes = [];
        var prima_neta = parseFloat(vmm.creditNotes.prima_neta);
        var rpf =
          prima_neta * parseFloat(vmm.creditNotes.rpf_percentage * 0.01);
        var gastos_expedicion = parseFloat(vmm.creditNotes.gastos_expedicion);
        var iva =
          (prima_neta + rpf + gastos_expedicion) *
          parseFloat(vmm.creditNotes.iva_percentage * 0.01);

        for (var i = 0; i < vmm.num_notes_data; i++) {
          var obj = {
            folio: vmm.creditNotes.folio + "-" + (i + 1).toString(),
            prima_neta: -(prima_neta / vmm.num_notes_data),
            gastos_expedicion: -(gastos_expedicion / vmm.num_notes_data),
            rpf: -(rpf / vmm.num_notes_data).toFixed(2),
            iva: -(iva / vmm.num_notes_data).toFixed(2),
            sub_total: -(
              (prima_neta + rpf + gastos_expedicion) /
              vmm.num_notes_data
            ).toFixed(2),
            prima_total: -(
              (prima_neta + rpf + iva + gastos_expedicion) /
              vmm.num_notes_data
            ).toFixed(2),
            fecha_emision: new Date(
              datesFactory.toDate(vmm.creditNotes.fecha_emision)
            ),
            payform: vmm.policy.forma_de_pago,
            policy: vmm.endorsement.policy.id,
          };

          if (vmm.endorsement.policy.ramo.ramo_code == 1) {
            obj.life_endorsement = vmm.endorsement.id;
          } else if (vmm.endorsement.policy.ramo.ramo_code == 2) {
            obj.disease_endorsement = vmm.endorsement.id;
          } else if (vmm.endorsement.policy.ramo.ramo_code == 3) {
            if (vmm.endorsement.policy.subramo.subramo_code == 9) {
              obj.auto_endorsement = vmm.endorsement.id;
            } else {
              obj.damages_endorsement = vmm.endorsement.id;
            }
          }

          vmm.credit_notes.push(obj);
        }

        vmm.createdNote = true;
      }

      function save() {
        toaster.success(MESSAGES.OK.APPLIEDENDORSEMENT);

        var policy = angular.copy(vmm.endorsement.policy);

        vmm.endorsement.status = vmm.selectedType.value;
        vmm.endorsement.automobile = vmm.endorsement.automobile
          ? angular.copy(vmm.endorsement.automobile.url)
          : undefined;
        vmm.endorsement.damage = vmm.endorsement.damage
          ? angular.copy(vmm.endorsement.damage.url)
          : undefined;
        vmm.endorsement.life = vmm.endorsement.life
          ? angular.copy(vmm.endorsement.life.url)
          : undefined;
        vmm.endorsement.disease = vmm.endorsement.disease
          ? angular.copy(vmm.endorsement.disease.url)
          : undefined;
        vmm.endorsement.policy = angular.copy(vmm.endorsement.policy.url);
        vmm.endorsement.folio_endorsement = vmm.form.folio;
        vmm.endorsement.number_endorsement = vmm.number_endorsement;
        policy.clave = policy.clave.url;

        if (vmm.form.recibos_poliza) {
          var new_p_neta =
            parseFloat(policy.p_neta) + parseFloat(vmm.form.p_neta);
          var new_p_total =
            parseFloat(policy.p_total) + parseFloat(vmm.form.p_total);
          var new_rpf = parseFloat(policy.rpf) + parseFloat(vmm.form.rpf);
          var new_derecho =
            parseFloat(policy.derecho) + parseFloat(vmm.form.derecho);
          var new_iva = parseFloat(policy.iva) + parseFloat(vmm.form.iva);

          vmm.form.recibos_poliza.forEach(function (recp) {
            recp.poliza = policy.url;

            // LAS CANTIDADES SE REDUCEN A 2 DECIMALES
            recp.derecho = parseFloat(recp.derecho).toFixed(2);
            recp.iva = parseFloat(recp.iva).toFixed(2);
            recp.rpf = parseFloat(recp.rpf).toFixed(2);
            recp.primaTotal = parseFloat(recp.primaTotal).toFixed(2);
            recp.subTotal = parseFloat(recp.subTotal).toFixed(2);
            recp.total = parseFloat(recp.total).toFixed(2);
            recp.comision = parseFloat(recp.comision).toFixed(2);

            // FORMATO DE FECHAS
            recp.endingDate = datesFactory.toDate(recp.endingDate);
            recp.startDate = datesFactory.toDate(recp.startDate);
            recp.fecha_inicio = datesFactory.toDate(recp.fecha_inicio);
            recp.fecha_fin = datesFactory.toDate(recp.fecha_fin);
            recp.vencimiento = datesFactory.toDate(recp.vencimiento);

            dataFactory.post("recibos/", recp).then(function (req) {
              // console.log('receipt 2 - ok', req);
            });
          });

          $http
            .patch(policy.url, {
              p_neta: new_p_neta.toFixed(2),
              p_total: new_p_total.toFixed(2),
              rpf: new_rpf.toFixed(2),
              derecho: new_derecho.toFixed(2),
              iva: new_iva.toFixed(2),
            })
            .then(function (res) {
              // console.log('res', res);
            });
          // return;
        }

        providerService
          .getProviderById(policy.aseguradora)
          .then(function (providerResponse) {
            policy.aseguradora = providerResponse.url;

            ramoService
              .getRamoById(policy.ramo.id)
              .then(function (ramoResponse) {
                policy.ramo = ramoResponse.url;

                ramoService
                  .getSubramoById(policy.subramo.id)
                  .then(function (subramoResponse) {
                    policy.subramo = subramoResponse.url;

                    endorsementService
                      .updateEndorsement(vmm.endorsement)
                      .then(function (res) {
                        if (
                          vmm.selectedType.value === 2 &&
                          vmm.endorsement.endorsement_type == "A"
                        ) {
                          $http({
                            method: "GET",
                            url: url.IP + "get-new-certs",
                            params: {
                              poliza: policy.id,
                            },
                          }).then(function success(response) {
                            if (response.data.length) {
                              response.data.forEach(function (certificado) {
                                var data = {
                                  certificado_inciso_activo: true,
                                };
                                if (vmm.endorsement.certif) {
                                  var data = {
                                    certificate_number: vmm.form.num_certificate
                                      ? vmm.form.num_certificate
                                      : "",
                                    certificado_inciso_activo: true,
                                  };
                                }
                                $http
                                  .patch(certificado.url, data)
                                  .then(function success(request) {
                                    /*aqui el patch*/
                                    // console.log('patch, A-GM',request)
                                  });
                              });
                            }
                            // here
                            else if (response.data.length == 0) {
                              if (vmm.endorsement.cert) {
                                // life
                                if (vmm.endorsement.life) {
                                  $http({
                                    method: "GET",
                                    url: vmm.endorsement.life,
                                  }).then(function success(response) {
                                    vmm.life = response.data;
                                    // console.log(vmm.life)
                                    if (vmm.life) {
                                      vmm.life.beneficiaries_life.forEach(
                                        function (ben) {
                                          // $http.patch(ben.url, data);
                                          $http
                                            .patch(ben.url, { is_active: true })
                                            .then(function (response) {});
                                          //
                                        }
                                      );
                                    }
                                  });
                                } else if (vmm.endorsement.disease) {
                                  $http({
                                    method: "GET",
                                    url: vmm.endorsement.disease,
                                  }).then(function success(response) {
                                    vmm.accident = response.data;
                                    if (vmm.accident) {
                                      vmm.accident.relationship_accident.forEach(
                                        function (dep) {
                                          // $http.patch(dep.url, data);
                                          $http
                                            .patch(dep.url, { is_active: true })
                                            .then(function (response) {
                                              // console.log('response-cpatchs',response,dep)
                                            });
                                          //
                                        }
                                      );
                                    }
                                  });
                                }
                                // accident
                              }
                            }
                            // here -
                          });

                          /* Aqui va la funcionalidad de recibos de endoso*/
                        } else if (
                          vmm.selectedType.value === 2 &&
                          vmm.endorsement.endorsement_type == "D"
                        ) {
                          $http({
                            method: "GET",
                            url: url.IP + "endorsement-certs/",
                            params: {
                              ramo: subramoResponse.data.subramo_code,
                              id_endoso: vmm.endorsement.id,
                            },
                          }).then(function success(response) {
                            if (response.data.results.length) {
                              response.data.results.forEach(function (
                                certificado
                              ) {
                                var data = {
                                  certificado_inciso_activo: false,
                                };
                                $http
                                  .patch(certificado.certificate, data)
                                  .then(function success(request) {
                                    /*aqui el patch*/
                                    console.log("patch, D", request);
                                  });
                              });
                            }
                          });
                          $http
                            .post(url.IP + "nota-credito/", vmm.credit_notes)
                            .then(
                              function success(request) {
                                /*aqui el patch*/
                              },
                              function error(error) {
                                console.log(error);
                              }
                            )
                            .catch(function (e) {
                              console.log(e);
                            });
                        } else {
                        }
                        SweetAlert.swal(
                          "Listo",
                          MESSAGES.OK.UPDATEENDORSEMENT,
                          "success"
                        );
                      });
                  });
              });
          });
        $uibModalInstance.dismiss("cancel");
      }

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndososPendingInfoCtrl", EndososPendingInfoCtrl);

  EndososPendingInfoCtrl.$inject = [
    "$q",
    "url",
    "helpers",
    "$localStorage",
    "$state",
    "receiptService",
    "$http",
    "packageService",
    "ramoService",
    "insuranceService",
    "ContratanteService",
    "providerService",
    "endorsementService",
    "toaster",
    "$stateParams",
    "$uibModal",
    "SweetAlert",
    "$sessionStorage",
    "$scope",
    "$sce",
    "$rootScope",
    "dataFactory",
    "MESSAGES",
    "emailService",
    "exportFactory",
  ];

  function EndososPendingInfoCtrl(
    $q,
    url,
    helpers,
    $localStorage,
    $state,
    receiptService,
    $http,
    packageService,
    ramoService,
    insuranceService,
    ContratanteService,
    providerService,
    endorsementService,
    toaster,
    $stateParams,
    $uibModal,
    SweetAlert,
    $sessionStorage,
    $scope,
    $sce,
    $rootScope,
    dataFactory,
    MESSAGES,
    emailService,
    exportFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var vm = this;

    vm.actions = {
      openPdf: openPdf,
      downloadPdf: downloadPdf,
    };

    var vm1;
    // Variables and constants
    vm.subforms = {};
    vm.data = {};
    vm.receipts = [];
    vm.user = usr;
    vm.configDerecho;
    vm.configRPF;
    vm.configIVA = true;
    vm.changeStatusModal = changeStatusModal;
    vm.NotasModal = NotasModal;

    // Functions
    vm.goToReceipt = goToReceipt;
    vm.viewCarta = viewCarta;
    vm.getPDF = getPDF;
    vm.goToPolicy = goToPolicy;
    vm.goToEdit = goToEdit;
    vm.saveEdit = saveEdit;
    vm.cancelEdit = cancelEdit;
    vm.options = {
      changeStatus: changeStatus,
    };

    vm.defaults = {
      coverages: [],
      coverageList: [],
    };

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    function goToPolicy(poliza) {
      if (vm.endorsement.status != 2) {
        $state.go("polizas.info", {
          polizaId: vm.endorsement.id_policy_original.id,
        });
      } else {
        $state.go("polizas.info", { polizaId: vm.policy.id });
      }
    }
    //   $state.go('polizas.info', {polizaId: vm.policy.id});
    // }
    vm.edit_endorsement = false;

    function goToEdit(poliza, form) {
      // ------------------------------
      if (form.policy_type == 1) {
        var type_endoso = "";
        if (form.automobile) type_endoso = "automobile";
        else if (form.life) type_endoso = "life";
        else if (form.damage) type_endoso = "damage";
        else if (form.disease) {
          type_endoso = "disease";
        }
        $state.go("endosos.pendingData", {
          endorsementId: form.id,
          endorsementType: type_endoso,
          polizaId: form.policy.id,
        });
        vm.edit_endorsement = true;
        vm.form.start_of_validity = convertDate(
          new Date(vm.form.start_of_validity)
        );
        vm.form.end_of_validity = convertDate(
          new Date(vm.form.end_of_validity)
        );
      }
      // ----------------------
      else if (form.policy_type == 2) {
        if (form.endorsement_type == "D") {
          if (form.policy.subramo == 1) var type = "life";
          else if (form.policy.subramo == 3) var type = "disease";
          else var type = "automobile";
          // ----
          var type_endoso = "";
          if (form.automobile) type_endoso = "automobile";
          else if (form.life) type_endoso = "life";
          else if (form.damage) type_endoso = "damage";
          else if (form.disease) {
            type_endoso = "disease";
          }
          // ----
        }
        $state.go("endosos.pendingDataMassive", {
          endorsementId: form.id,
          endorsementType: type_endoso ? type_endoso : type,
          polizaId: form.policy.id,
        });
      }
      // ----------------------
    }

    $scope.changeUntil = function () {
      var since = toDate(vm.form.start_of_validity).getTime();
      var until = toDate(vm.form.end_of_validity).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        vm.form.start_of_validity = convertDate(new Date());
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORDATERANGE, "error");
      }
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
      return dateObject;
    }
    function mesDiaAnio(parDate) {
      var d = new Date(toDate(parDate));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      return date;
    }

    function saveEdit(form) {
      var type_endoso = "";
      var url_endosos = "";
      if (form.automobile) {
        type_endoso = "automobile";
        var url_endosos = form.url;
      } else if (form.life) {
        type_endoso = "life";
        var url_endosos = form.url;
      } else if (form.damage) {
        type_endoso = "damage";
        var url_endosos = form.url;
      } else if (form.disease) {
        type_endoso = "disease";
        var url_endosos = form.url;
      }

      if (url_endosos) {
        var data = {
          init_date: new Date(mesDiaAnio(vm.form.start_of_validity)),
          end_date: new Date(mesDiaAnio(vm.form.end_of_validity)),
        };
        $http.patch(url_endosos, data).then(function success(response) {
          if (response.status == 200) {
            vm.edit_endorsement = false;
          }
        });
      }
    }
    function cancelEdit() {
      vm.edit_endorsement = false;
      vm.form.start_of_validity = vm.endorsement.init_date;
      vm.form.end_of_validity = vm.endorsement.end_date;
    }

    function viewCarta(poliza, carta) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-form/",
        params: {
          id_poliza: vm.policy.id,
          id_carta: carta,
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
        // $scope.pdf = response.data;
        // $http({
        //   method: 'GET',
        //   url: url.IP + 'get-pdf',
        //   params: {
        //     'pdf_name': $scope.pdf.pdf_name
        //   },
        //   responseType: 'arraybuffer'

        // }).then(function success(response) {

        //   })
      });
    }
    $scope.forma_pago = function (parValue) {
      switch (parValue) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 4:
          return "Cuatrimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        case 24:
          return "Quincenal";
          break;
        default:
          return "No especificada";
      }
    };

    function getPDF(endoso, poliza) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-endorsement/",
        params: {
          poliza: poliza,
          endoso: endoso,
        },
      }).then(function success(response) {
        $scope.pdf = response.data;

        $http({
          method: "GET",
          url: url.IP + "get-pdf",
          params: {
            pdf_name: $scope.pdf.pdf_name,
          },
        }).then(function success(response) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
        });
      });
    }

    // TODO: quitar
    // vm.user.permiso.editar = true;

    vm.changeStatusModal = changeStatusModal;
    function changeStatusModal(receipt, contra, insurance) {
      receipt.contractor = contra;
      if (insurance.policy.natural) {
        $http.get(insurance.policy.natural).then(function success(response) {
          var contratante = response.data;
          receipt.contratante = contratante;
        });
      } else if (insurance.policy.juridical) {
        $http.get(insurance.policy.juridical).then(function success(response) {
          var contratante = response.data;
          receipt.contratante = contratante;
        });
      }
      var index = vm.receipts.indexOf(receipt);
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return insurance;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    }

    activate();
    function activate() {
      // console.log('$stateParams}',$stateParams)
      vm.endorsementId = $stateParams.endorsementId;
      var aux_array = [];
      var aux_array1 = [];

      dataFactory
        .get("get-endo-notas/", $stateParams)
        .then(function success(response) {
          vm.notas = response.data.results;
        });

      dataFactory.get("has-view-cartas-permission").then(function (req) {
        if (req.status == 200) {
          $scope.view_cartas = req.data;
        }
      });

      endorsementService.getEndorsement($stateParams).then(function (res) {
        $http({
          method: "GET",
          url: url.IP + "cartas-by-model",
          params: {
            model: 2,
          },
        }).then(function success(response) {
          vm.cartas = response.data;
        });
        $rootScope.receipt1 = [];
        vm.receipts2 = [];
        vm.endorsement = res.data;
        vm.policy = vm.endorsement.policy;
        vm.coverages = vm.policy.coverageInPolicy_policy;
        $scope.getCoverages(vm.coverages);

        if (vm.endorsement.status == 2) {
          vm.receipts1 = vm.policy.recibos_poliza;
        } else {
          vm.receipts1 = vm.endorsement.id_policy_original.recibos_poliza;
        }

        if (vm.endorsement.status == 2 && !vm.receipts1.length) {
          vm.receipts1 = vm.endorsement.id_policy_original.recibos_poliza;
        }

        if (vm.receipts1) {
          vm.receipts1.forEach(function (v) {
            var ur = v.url;
            $http({
              method: "GET",
              url: ur,
            }).then(function success(res) {
              $rootScope.receipt1 = res.data;
              vm.receipts2.push($rootScope.receipt1);
            });
          });
          vm.receipts = vm.receipts2;
        }

        vm.form.start_of_validity = vm.endorsement.init_date;
        vm.form.end_of_validity = vm.endorsement.end_date;
        if (vm.endorsement.automobile) {
          vm.certs = vm.endorsement.automobile;
          vm.certs.show = 1;
          vm.subforms = vm.certs;
          $http
            .get(
              url.IP +
                "endosos/" +
                vm.endorsement.id +
                "/archivos/?type_endoso=4"
            )
            .then(function success(response) {
              // console.log('endoso', response);
              if (response.status === 200 || response.status == 201) {
                if (response.data.results.length) {
                  vm.files = response.data.results;
                  // console.log('vm.files',vm.files)
                }
              } else {
                vm.files = [];
              }
            });
        }
        if (vm.endorsement.damage) {
          vm.certs = vm.endorsement.damage;
          vm.certs.show = 2;
          vm.subforms = vm.certs;
          $http
            .get(
              url.IP +
                "endosos/" +
                vm.endorsement.id +
                "/archivos/?type_endoso=2"
            )
            .then(function success(response) {
              if (response.data.results.length) {
                vm.files = response.data.results;
              }
            });
        }
        if (vm.endorsement.disease) {
          vm.certs = vm.endorsement.disease;
          vm.certs.relationshipList =
            vm.endorsement.disease.relationship_accident;
          vm.certs.show = 0;
          vm.subforms = vm.certs;
          $http
            .get(
              url.IP +
                "endosos/" +
                vm.endorsement.id +
                "/archivos/?type_endoso=3"
            )
            .then(function success(response) {
              if (response.data.results.length) {
                vm.files = response.data.results;
              }
            });
        }
        if (vm.endorsement.life) {
          vm.certs = vm.endorsement.life;
          vm.certs.show = 3;
          vm.subforms = vm.certs;
          $http
            .get(
              url.IP +
                "endosos/" +
                vm.endorsement.id +
                "/archivos/?type_endoso=1"
            )
            .then(function success(response) {
              if (response.data.results.length) {
                vm.files = response.data.results;
              }
            });

          //vm.subforms.life = vm.endorsement.life;
          //vm.subforms.life.show = 3;
        }

        $http({
          method: "GET",
          url:
            url.IP +
            "proveedores-for-endorsement/" +
            vm.policy.aseguradora +
            "/",
        }).then(
          function mySuccess(response) {
            vm.policy_aseguradora = response.data.alias;
          },
          function myError(response) {}
        );

        if (vm.policy.natural) {
          $http({
            method: "GET",
            url: vm.policy.natural,
          }).then(
            function mySuccess(response) {
              vm.contractor_name = response.data.full_name;
            },
            function myError(response) {}
          );
        } else if (vm.policy.juridical) {
          $http({
            method: "GET",
            url: vm.policy.juridical,
          }).then(
            function mySuccess(response) {
              vm.contractor_name = response.data.j_name;
            },
            function myError(response) {}
          );
        }
      });
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 10,
          id_model: vm.endorsementId,
        },
      })
        .then(function (request) {
          // console.log('-------', request);
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            next: request.data.next,
            previous: request.data.previous,
          };
          // console.log('comments_data', vm.comments_data);
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }

    function exportEndosoComments() {
      if (!vm.endorsementId || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
      };

      var params = {
        model: 10,
        id_model: vm.endorsementId,
      };
      if (vm.org_name) {
        params.org = vm.org_name;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: params,
          downloadName: "bitacora-endoso.xlsx",
          token: vm.token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }

    var sumInPolicy = {
      label: "",
      value: "",
    };
    var deductibleInPolicy = {
      label: "",
      value: "",
    };

    $scope.getCoverages = function (param) {
      vm.defaults.coverages = [];
      vm.defaults.coverageList = [];
      vm.defaults.coverages = param;
      for (var i = 0; i < vm.defaults.coverages.length; i++) {
        sumInPolicy = {
          label: vm.defaults.coverages[i].sum_insured,
          value: vm.defaults.coverages[i].sum_insured,
        };
        deductibleInPolicy = {
          label: vm.defaults.coverages[i].deductible,
          value: vm.defaults.coverages[i].deductible,
        };
        vm.defaults.coverages[i].sumInPolicy = sumInPolicy;
        vm.defaults.coverages[i].deductibleInPolicy = deductibleInPolicy;
      }
    };

    function NotasModal(receipt) {
      vm.insuranceNote_ = receipt.policy;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/notaCredito.modal.html",
        controller: "NotaCreditoCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return vm.insuranceNote_;
          },
          from: function () {
            return null;
          },
        },
      });
    }

    function changeStatus() {
      if (
        vm.endorsement.status === 2 ||
        vm.endorsement.status === 3 ||
        vm.endorsement.status === 4
      ) {
        toaster.info("No es posible modificar este endoso.");
      } else {
        // console.log('asasasdsd', vm.form);
        var modalInstance = $uibModal.open({
          templateUrl: "app/endosos/endosos.status.html",
          controller: EndososPendingModalCtrl,
          controllerAs: "vmm",
          size: "lg",
          resolve: {
            endosoModal: function () {
              return vm.endorsement;
            },
            policy_endorsement: function () {
              return vm.policy;
            },
            form_endorsement: function () {
              return vm.form;
            },
          },
        });
      }
    }

    function goToReceipt(receipt) {
      var vmmm = receipt;
      var modalInstance = $uibModal.open({
        templateUrl: "app/endosos/endosos.receipts.html",
        controller: EndososPendingModalCtrl,
        controllerAs: "vmmm",
        size: "lg",
        resolve: {
          endosoModal: function () {
            return vmmm;
          },
        },
      });
    }

    function openPdf() {
      var wait = [];

      var url = vm.endorsement.url;
      var arr = url.split("/");
      var endorsementData = {
        endorsementId: arr[6],
        endorsementType: arr[5],
      };

      //var result = url.substr(url.indexOf("/") - 1);
      wait.push(endorsementService.getEndorsement(endorsementData));
      $q.all(wait).then(function (response) {
        // return;
        pdfEndorsment.getPdf({ endorsementData: response[0], open: true });
      });

      // var insurance = angular.copy(insuranceData);
      // pdfService.getPdf({ insuranceData : insurance , open : true});
    }

    function downloadPdf() {
      var wait = [];
      wait.push(endorsementService.getInsuranceData(insuranceData.myInsurance));
      $q.all(wait).then(function (response) {
        pdfService.getPdf({ insuranceData: response[0], open: false });
      });
    }

    vm.form = {};
    function getPolicy(parId) {
      if (!id) {
        toaster.warning("Ingrese un número de póliza");
        vm.loading = false;
        return;
      } else {
        vm.loading = true;
        vm.selectedType = vm.types[0];
        vm.selectTypeStatus = true;

        setTimeout(function () {
          $http({
            method: "GET",
            url: url.IP + "get-policy-endorsement/",
            params: {
              id: parId.id,
            },
          }).then(function success(response) {
            if (!helpers.isResponseOk(response.status)) {
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORSEARCHPOLICY,
                "error"
              );
              vm.loading = false;
              return;
            }

            vm.policy = response.data.results[0];
            if (vm.policy.natural) {
              $scope.direccion_contratante = [];
              vm.contractor = vm.policy.natural;
              vm.contractor.address_natural.forEach(function (address) {
                var direc =
                  address.route +
                  " " +
                  address.street_number +
                  " " +
                  address.street_number_int +
                  " " +
                  address.administrative_area_level_2 +
                  " " +
                  address.administrative_area_level_1;
                $scope.direccion_contratante.push(direc);
              });
            } else if (vm.policy.juridical) {
              $scope.direccion_contratante = [];
              vm.contractor = vm.policy.juridical;
              vm.contractor.address_juridical.forEach(function (address) {
                var direc =
                  address.route +
                  " " +
                  address.street_number +
                  " " +
                  address.street_number_int +
                  " " +
                  address.administrative_area_level_2 +
                  " " +
                  address.administrative_area_level_1;
                $scope.direccion_contratante.push(direc);
              });
            }

            vm.defaults.coverageList = angular.copy(
              vm.policy.paquete.coverage_package
            );

            $http
              .post(url.IP + "paquetes-by-subramo/", {
                ramo: vm.policy.ramo.id,
                subramo: vm.policy.subramo.id,
                provider: vm.policy.aseguradora.id,
              })
              .then(function (paquetes) {
                vm.packages = paquetes.data;
              });

            vm.subforms = {};
            if (vm.policy.accidents_policy.length) {
              vm.subforms.show = 0;
              vm.subforms.disease = vm.policy.accidents_policy[0];
            } else if (vm.policy.automobiles_policy.length) {
              vm.subforms.show = 1;
              vm.subforms.auto = vm.policy.automobiles_policy[0];
            } else if (vm.policy.life_policy.length) {
              vm.subforms.show = 3;
              vm.subforms.life = vm.policy.life_policy[0];
            } else if (vm.policy.damages_policy.length) {
              vm.subforms.show = 2;
              vm.subforms.damage = vm.policy.damages_policy[0];
            }

            vm.form.end_of_validity = angular.copy(vm.policy.end_of_validity);
            vm.form.start_of_validity = new Date();
            vm.limit = {
              start: angular.copy(vm.form.start_of_validity),
              end: angular.copy(vm.form.end_of_validity),
            };

            var sub = 0;
            var ttl = 0;
            var prn = 0;
            var rpf = 0;
            var der = 0;
            var data = {};
            vm.receipts = [];
            var sortedReceipts = vm.policy.recibos_poliza.sort();
            sortedReceipts.forEach(function (recibo) {
              var receipt = {
                poliza: vm.policy.url,
                recibo_numero: recibo.recibo_numero,
                rpf: recibo.rpf,
                derecho: recibo.derecho,
                iva: recibo.iva,
                prima: recibo.prima_neta,
                subTotal: recibo.sub_total,
                total: recibo.prima_total,
                status: recibo.status,
                startDate: recibo.fecha_inicio,
                endingDate: recibo.fecha_fin,
                description: recibo.description,
                endorsement_auto: null,
                id: recibo.id,
                endorsement_damage: null,
              };

              prn += parseFloat(receipt.prima);
              sub += parseFloat(receipt.subTotal);
              ttl += parseFloat(receipt.total);
              rpf += parseFloat(receipt.rpf);
              der += parseFloat(receipt.derecho);

              vm.receipts.push(receipt);
              vm.receipts = _.sortBy(vm.receipts, "recibo_numero");
              vm.defaults.receipt.subTotal = sub;
              vm.defaults.receipt.primaTotal = ttl;
              vm.defaults.receipt.primaNeta = prn;

              vm.defaults.receipt.rpf = rpf;
              vm.defaults.receipt.derecho = der;
              vm.defaults.receipt.iva = vm.receipts[0].iva;
            });

            toaster.success("Póliza existente");
            vm.selectTypeStatus = false;
            vm.loading = false;
          });
        }, 100);
      }
    }

    /////////////////////////////////////////Controlador del modal de status!!

    function EndososPendingModalCtrl(
      $scope,
      toaster,
      MESSAGES,
      FileUploader,
      endosoModal,
      endorsement,
      $uibModalInstance,
      $state,
      policy_endorsement,
      datesFactory,
      dataFactory,
      $rootScope,
      $timeout,
      form_endorsement
    ) {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);

      var vmm = this;
      vmm.selectedType = "";
      vmm.status = [];
      vmm.prima_total = 0;
      vmm.iva = 16;
      vmm.sub_total = 0;
      vmm.folio = false;
      vmm.statusIva = true;
      var sumaEndosoRecibo = 0.0;
      vmm.form = {
        folio: "",
        type: "INDIVIDUAL",
        start_of_validity: form_endorsement.start_of_validity,
        description: endosoModal.description,
      };
      vmm.createdNote = false;

      vmm.policy = policy_endorsement;

      vmm.options = {
        save: save,
        cancel: cancel,
      };

      // name: número de recibos
      // value: forma de pago
      vmm.num_receipts_data = [
        { name: 1, value: 12 },
        { name: 2, value: 6 },
        { name: 4, value: 3 },
        { name: 6, value: 2 },
        { name: 12, value: 1 },
      ];

      vmm.creditNotes = {
        fecha_emision: convertDate(new Date()),
        payform: vmm.policy.forma_de_pago,
        f_currency: 1,
        life_endorsement: null,
        disease_endorsement: null,
        damages_endorsement: null,
        auto_endorsement: null,
        // policy: vmm.endorsement.policy.id,
      };

      /** Uploader files */
      $scope.userInfo = {
        id: 0,
      };
      $scope.countFile = 0;
      $scope.okFile = 0;

      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      //     name: 'customFilter',
      //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
      //         return this.queue.length < 20;
      //     }
      // });

      // ALERTA SUCCES UPLOADFILES
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $scope.okFile++;
        if ($scope.okFile == $scope.countFile) {
          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
          $state.go("endosos.pending");
        }
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
          nombre: fileItem.file.name,
        });

        if (fileItem) {
          $scope.countFile++;
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        if (item.file.sensible != undefined) {
          item.formData[0].sensible = item.file.sensible;
        }

        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
      };

      function uploadFiles(endorsementId, type_endoso) {
        $scope.userInfo = {
          id: endorsementId,
        };
        $scope.userInfo.url = $scope.uploader.url =
          url.IP +
          "endosos/" +
          endorsementId +
          "/archivos/?type_endoso=" +
          type_endoso;

        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }

      /*--------------*/

      vmm.credit_notes = [];

      vmm.endorsement = endosoModal;
      vmm.enableSave = enableSave;
      vmm.updateField = updateField;
      vmm.updateFieldD = updateFieldD;
      vmm.changeIva = changeIva;
      vmm.selectNumNotes = selectNumNotes;

      if (endosoModal.policy.ramo.ramo_code != 1) {
        vmm.creditNotes.iva_percentage = 16;
      } else {
        vmm.creditNotes.iva_percentage = 0;
      }

      if (vmm.endorsement.status === 1) {
        vmm.status.push(endorsement[2], endorsement[4]);
      } else if (vmm.endorsement.status === 5) {
        vmm.status.push(endorsement[1], endorsement[2], endorsement[3]);
      }

      $('input[id="calcularB"]').prop("disabled", true);

      function enableSave() {
        vmm.folio = false;
        vmm.form.folio = endosoModal.endorsement.folio_endorsement;

        if (vmm.endorsement.endorsement_type != "D") {
          vmm.createdNote = true;
        }

        // if(vmm.selectedType.value === 5){
        //   vmm.folio = true;
        //   toaster.info('Favor de agregar su folio.');
        // }
        // else{
        //   vmm.folio = false;
        // }
      }
      function checkReceipts() {
        suma = 0.0;
        var prima_total = vmm.prima_total;
        vm.endorsement.policy.recibos_poliza.forEach(function (recibo) {
          suma += parseFloat(recibo.prima_total);
        });
        if (suma != prima_total) {
          return false;
        } else {
          return true;
        }
      }

      function changeIva(parValue) {
        if (!parValue) {
          swal("La póliza se creará sin IVA.");
          vmm.iva = 0;
        } else {
          vmm.iva = 16;
        }
      }

      if (vm.endorsement.policy.recibos_poliza) {
        vmm.endorsementNew = vm.endorsement.policy.recibos_poliza;
      } else {
        vmm.endorsementNew = [];
      }

      for (var i = 0; i < vmm.endorsementNew.length; i++) {
        if (vmm.endorsementNew[i].receipt_type == 2) {
          vmm.endorsementNew[i].comision = 0.0;
          vmm.endorsementNew[i].derecho = 0.0;
          vmm.endorsementNew[i].iva = 0.0;
          vmm.endorsementNew[i].prima_neta = 0.0;
          vmm.endorsementNew[i].prima_total = 0.0;
          vmm.endorsementNew[i].rpf = 0.0;
          vmm.endorsementNew[i].sub_total = 0.0;
        }
      }

      function updateField() {
        var prima_neta = parseFloat(vmm.prima_neta);
        var rpf = parseFloat(vmm.rpf);
        var derecho = parseFloat(vmm.derecho);
        var iva = parseFloat((prima_neta + rpf + derecho) * 0.16).toFixed(2);

        vmm.sub_total = prima_neta + rpf + derecho;
        vmm.prima_total = ((prima_neta + rpf + derecho) * 1.16).toFixed(2);

        for (var i = 0; i < vmm.endorsementNew.length; i++) {
          if (vmm.endorsementNew[i].receipt_type == 2) {
            vmm.endorsementNew[i].derecho = (
              derecho / vmm.endorsementNew.length
            ).toFixed(2);
            vmm.endorsementNew[i].iva = (
              iva / vmm.endorsementNew.length
            ).toFixed(2);
            vmm.endorsementNew[i].prima_neta = (
              prima_neta / vmm.endorsementNew.length
            ).toFixed(2);
            vmm.endorsementNew[i].rpf = (
              rpf / vmm.endorsementNew.length
            ).toFixed(2);
            vmm.endorsementNew[i].sub_total = (
              (prima_neta + rpf + derecho) /
              vmm.endorsementNew.length
            ).toFixed(2);
            vmm.endorsementNew[i].prima_total = (
              ((prima_neta + rpf + derecho) * 1.16) /
              vmm.endorsementNew.length
            ).toFixed(2);
          }
        }

        if (vmm.iva == 0) {
          var ivaOperation = 0.0;
          var totalIva = 0;
        } else if (vmm.iva == 16) {
          var ivaOperation = 0.16;
        }

        // sumaEndosoRecibo =0.0;
        // var rpf=parseFloat(vmm.rpf);
        // var derecho=parseFloat(vmm.derecho);
        // var sub_total=parseFloat(vmm.sub_total);
        // var iva=parseFloat(parseFloat(vmm.sub_total) * ivaOperation);
        // var prima_neta = parseFloat(vmm.prima_neta);

        // vmm.sub_total = prima_neta + rpf + derecho;
        // vmm.prima_total = vmm.sub_total + (vmm.sub_total * ivaOperation)

        try {
          // var recibos = vm.endorsement.policy.recibos_poliza;
          var recibos = vmm.endorsementNew;
        } catch (e) {
          toaster.warning("Ha ocurrido un error");
          return;
        }

        for (var i = 0; i < recibos.length; i++) {
          if (recibos[i].receipt_type == 2) {
            var minDate = new Date(
              new Date(recibos[i].fecha_inicio).setHours(12, 0, 0, 0)
            );
            var maxDate = new Date(
              new Date(recibos[i].fecha_fin).setHours(12, 0, 0, 0)
            );
            break;
          }
        }

        for (var i = 0; i < recibos.length; i++) {
          if (recibos[i].receipt_type == 2) {
            if (
              minDate >
              new Date(new Date(recibos[i].fecha_inicio).setHours(12, 0, 0, 0))
            ) {
              minDate = new Date(
                new Date(recibos[i].fecha_inicio).setHours(12, 0, 0, 0)
              );
            }
            if (
              maxDate <
              new Date(new Date(recibos[i].fecha_fin).setHours(12, 0, 0, 0))
            ) {
              maxDate = new Date(
                new Date(recibos[i].fecha_fin).setHours(12, 0, 0, 0)
              );
            }
          }
        }

        var diffDays =
          parseInt((maxDate - minDate) / (1000 * 60 * 60 * 24)) + 1;

        var cost_per_day = prima_neta / diffDays;
        var cost_rpf_per_day = rpf / diffDays;
        var cost_derecho_per_day = derecho / diffDays;
        var days_left = 0;
        var receipts_left = 0;
        var sub = 0.0;
        var total = 0.0;

        for (var i = 0; i < recibos.length; i++) {
          if (recibos[i].receipt_type == 2) {
            if (recibos[i].recibo_numero == 1) {
              var diffReceiptDays =
                1 +
                parseInt(
                  new Date(
                    new Date(recibos[i].fecha_fin).setHours(12, 0, 0, 0) -
                      new Date(
                        new Date(recibos[i].fecha_inicio).setHours(12, 0, 0, 0)
                      )
                  ) /
                    (1000 * 60 * 60 * 24)
                );
              recibos[i].prima_neta = (cost_per_day * diffReceiptDays).toFixed(
                2
              );
              if ($("#configRPFEndoso").prop("checked")) {
                recibos[i].rpf = rpf;
              } else {
                var round = Number(
                  (cost_rpf_per_day * diffReceiptDays).toFixed(2)
                );
                recibos[i].rpf = round;
              }
              if ($("#configDerechoEndoso").prop("checked")) {
                recibos[i].derecho = derecho;
              } else {
                recibos[i].derecho = Number(
                  (cost_derecho_per_day * diffReceiptDays).toFixed(2)
                );
              }
              sub =
                parseFloat(recibos[i].prima_neta) +
                parseFloat(recibos[i].rpf) +
                parseFloat(recibos[i].derecho);
              recibos[i].sub_total = parseFloat(sub).toFixed(2);
              var ivaReceipt = parseFloat(recibos[i].sub_total) * ivaOperation;
              recibos[i].iva = parseFloat(ivaReceipt).toFixed(2);
              total = sub + parseFloat(recibos[i].iva);
              recibos[i].prima_total = parseFloat(total).toFixed(2);
            } else {
              receipts_left++;
            }
          }
        }

        days_left = diffDays - diffReceiptDays;

        for (var i = 0; i < recibos.length; i++) {
          if (recibos[i].receipt_type == 2) {
            if (recibos[i].recibo_numero != 1) {
              recibos[i].prima_neta = (
                (cost_per_day * days_left) /
                receipts_left
              ).toFixed(2);
              if ($("#configDerechoEndoso").prop("checked")) {
                recibos[i].derecho = 0;
              } else {
                recibos[i].derecho = Number(
                  ((cost_derecho_per_day * days_left) / receipts_left).toFixed(
                    2
                  )
                );
              }
              if ($("#configRPFEndoso").prop("checked")) {
                recibos[i].rpf = 0;
              } else {
                recibos[i].rpf = Number(
                  ((cost_rpf_per_day * days_left) / receipts_left).toFixed(2)
                );
              }
              sub =
                parseFloat(recibos[i].prima_neta) +
                parseFloat(recibos[i].rpf) +
                parseFloat(recibos[i].derecho);
              recibos[i].sub_total = parseFloat(sub).toFixed(2);
              var ivaReceipt = parseFloat(recibos[i].sub_total) * ivaOperation;
              recibos[i].iva = parseFloat(ivaReceipt).toFixed(2);
              total = sub + parseFloat(recibos[i].iva);
              recibos[i].prima_total = parseFloat(total).toFixed(2);
            }
          }
        }
      }

      vmm.f_currency = {};
      vmm.f_currency.f_currency_selected = 1;
      vmm.f_currency.options = [
        { value: 1, label: "PESOS" },
        { value: 2, label: "DOLARES" },
      ];

      vmm.creditNotes.policy = vmm.endorsement.policy.id;

      $scope.dataPayform = [
        { value: 1, name: "MENSUAL" },
        { value: 2, name: "BIMESTRAL" },
        { value: 3, name: "TRIMESTRAL" },
        { value: 5, name: "CONTADO" },
        { value: 6, name: "SEMESTRAL" },
        { value: 12, name: "ANUAL" },
      ];

      function selectNumNotes(parValue) {}

      function convertDate(inputFormat) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
        return date;
      }

      $(".datepicker-me input").datepicker();

      $.fn.datepicker.defaults.format = "dd/mm/yyyy";
      $.fn.datepicker.defaults.startView = 0;
      $.fn.datepicker.defaults.autoclose = true;
      $.fn.datepicker.defaults.language = "es";

      function updateFieldD() {
        if (vmm.creditNotes.iva_percentage > 100) {
          toaster.error(MESSAGES.ERROR.GREATERTHAN100);
          return;
        }

        if (vmm.creditNotes.rpf_percentage > 100) {
          toaster.error(MESSAGES.ERROR.GREATERTHAN100);
          return;
        }

        var prima_neta = parseFloat(vmm.creditNotes.prima_neta);
        var rpf =
          prima_neta * parseFloat(vmm.creditNotes.rpf_percentage * 0.01);
        var gastos_expedicion = parseFloat(vmm.creditNotes.gastos_expedicion);
        var iva =
          (prima_neta + rpf + gastos_expedicion) *
          parseFloat(vmm.creditNotes.iva_percentage * 0.01);

        for (var i = 0; i < vmm.num_notes_data; i++) {
          var obj = {
            folio: vmm.creditNotes.folio + "-" + (i + 1).toString(),
            prima_neta: -(prima_neta / vmm.num_notes_data),
            gastos_expedicion: -(gastos_expedicion / vmm.num_notes_data),
            rpf: -(rpf / vmm.num_notes_data).toFixed(2),
            iva: -(iva / vmm.num_notes_data).toFixed(2),
            sub_total: -(
              (prima_neta + rpf + gastos_expedicion) /
              vmm.num_notes_data
            ).toFixed(2),
            prima_total: -(
              (prima_neta + rpf + iva + gastos_expedicion) /
              vmm.num_notes_data
            ).toFixed(2),
            fecha_emision: new Date(toDate(vmm.creditNotes.fecha_emision)),
            payform: vmm.policy.forma_de_pago,
            policy: vmm.endorsement.policy.id,
          };

          if (vmm.endorsement.policy.ramo.ramo_code == 1) {
            obj.life_endorsement = vmm.endorsement.id;
          } else if (vmm.endorsement.policy.ramo.ramo_code == 2) {
            obj.disease_endorsement = vmm.endorsement.id;
          } else if (vmm.endorsement.policy.ramo.ramo_code == 3) {
            if (vmm.endorsement.policy.subramo.subramo_code == 9) {
              obj.auto_endorsement = vmm.endorsement.id;
            } else {
              obj.damages_endorsement = vmm.endorsement.id;
            }
          }

          vmm.credit_notes.push(obj);
        }

        vmm.createdNote = true;
      }

      function toDate(dateStr) {
        var dateString = dateStr;
        var dateParts = dateString.split("/");
        var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
        return dateObject;
      }

      function save() {
        if (
          vmm.selectedType.value === 2 &&
          vmm.endorsement.endorsement_type == "A"
        ) {
          vmm.endorsement.policy.recibos_poliza = vmm.endorsementNew;
        }

        if (
          vmm.selectedType.value === 2 &&
          vmm.endorsement.endorsement_type == "D"
        ) {
          $http
            .post(url.IP + "nota-credito/", vmm.credit_notes)
            .then(
              function success(request) {
                dataFactory
                  .get("polizas/" + request.data[0].policy)
                  .then(function success(response) {
                    $scope.policy = response.data;
                    // Send Email
                    if ($scope.policy.natural) {
                      $http
                        .get($scope.policy.natural)
                        .then(function (response) {
                          // if(response.data.email){
                          //     //Send Email
                          //     if($localStorage.email_config){
                          //         if($localStorage.email_config.create_nota == true){
                          //           request.data.forEach(function(id) {
                          //               $scope.idNota = id.id;
                          //               var model = 7;
                          //               emailService.sendEmailAtm(model,$scope.idNota)
                          //             })
                          //         }
                          //     }
                          //     //Send Email
                          // }
                        });
                    } else if ($scope.policy.juridical) {
                      $http
                        .get($scope.policy.juridical)
                        .then(function (response) {
                          // if(response.data.email){
                          //     //Send Email
                          //     if($localStorage.email_config){
                          //         if($localStorage.email_config.create_nota == true){
                          //           request.data.forEach(function(id) {
                          //             $scope.idNota = id.id;
                          //             var model = 7;
                          //             emailService.sendEmailAtm(model,$scope.idNota)
                          //           })
                          //         }
                          //     }
                          //     //Send Email
                          // }
                        });
                    }
                  });
              },
              function error(error) {
                console.log(error);
              }
            )
            .catch(function (e) {
              console.log(e);
            });
        }

        toaster.success(MESSAGES.OK.APPLIEDENDORSEMENT);
        vmm.recibos_data = angular.copy(vmm.endorsementNew);
        vmm.endorsement.policy.recibos_poliza.forEach(function (
          receipt,
          index
        ) {
          vmm.endorsement.policy.recibos_poliza[index] = receipt.url;
        });

        var policy = angular.copy(vmm.endorsement.policy);
        vmm.endorsement.status = vmm.selectedType.value;
        vmm.endorsement.automobile = vmm.endorsement.automobile
          ? angular.copy(vmm.endorsement.automobile.url)
          : undefined;
        vmm.endorsement.damage = vmm.endorsement.damage
          ? angular.copy(vmm.endorsement.damage.url)
          : undefined;
        vmm.endorsement.life = vmm.endorsement.life
          ? angular.copy(vmm.endorsement.life.url)
          : undefined;
        vmm.endorsement.disease = vmm.endorsement.disease
          ? angular.copy(vmm.endorsement.disease.url)
          : undefined;
        vmm.endorsement.policy = angular.copy(vmm.endorsement.policy.url);
        if (vmm.selectedType.value == 5) {
          vmm.endorsement.folio_endorsement = vmm.form.folio;
        } else {
          vmm.endorsement.folio_endorsement = vm.endorsement.folio_endorsement;
        }
        vmm.endorsement.number_endorsement = vmm.number_endorsement;
        policy.clave = policy.clave.url;

        providerService
          .getProviderById(policy.aseguradora)
          .then(function (providerResponse) {
            policy.aseguradora = providerResponse.url;

            ramoService
              .getRamoById(policy.ramo.id)
              .then(function (ramoResponse) {
                policy.ramo = ramoResponse.url;

                ramoService
                  .getSubramoById(policy.subramo.id)
                  .then(function (subramoResponse) {
                    policy.subramo = subramoResponse.url;

                    packageService
                      .getPackageById(policy.paquete.id)
                      .then(function (paqueteResponse) {
                        policy.paquete = paqueteResponse.url;

                        endorsementService
                          .updateEndorsement(vmm.endorsement)
                          .then(function (res) {
                            if (res.status == 200) {
                              if (res.data.status == 2) {
                                $scope.data_endorsement =
                                  "actualizó el endoso a registrado";
                              } else if (res.data.status == 3) {
                                $scope.data_endorsement =
                                  "actualizó el endoso a rechazado";
                              } else if (res.data.status == 4) {
                                $scope.data_endorsement =
                                  "actualizó el endoso a cancelado";
                              } else if (res.data.status == 5) {
                                $scope.data_endorsement =
                                  "actualizó el endoso a en trámite";
                              }

                              var params = {
                                model: 10,
                                event: "POST",
                                associated_id: res.data.id,
                                identifier: $scope.data_endorsement,
                              };
                              dataFactory
                                .post("send-log/", params)
                                .then(function success(response) {});
                            }

                            if (vmm.selectedType.value === 2) {
                              var getPolicy = {
                                req: vmm.endorsement.policy,
                                endo: vmm.endorsement.id_policy_original,
                              };
                              insuranceService
                                .getPolicyAndEndorsement(getPolicy)
                                .then(function (response) {
                                  // console.log('response', response);
                                  if ($scope.countFile > 0) {
                                    // uploadFiles(vm.endorsement.id, vmm.endorsement.endorsement_type);
                                    if (vm.endorsement.life) {
                                      uploadFiles(vm.endorsement.id, 1);
                                    } else if (vm.endorsement.damage) {
                                      uploadFiles(vm.endorsement.id, 2);
                                    } else if (vm.endorsement.disease) {
                                      uploadFiles(vm.endorsement.id, 3);
                                    } else if (vm.endorsement.automobile) {
                                      uploadFiles(vm.endorsement.id, 4);
                                    }
                                  }

                                  if (
                                    vm.endorsement.description ==
                                      "CANCELACIÓN DE PÓLIZA POR PETICIÓN" ||
                                    vm.endorsement.description ==
                                      "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO"
                                  ) {
                                    for (
                                      var i = 0;
                                      i <
                                      response.original.recibos_poliza.length;
                                      i++
                                    ) {
                                      var auxUrl = angular.copy(
                                        response.original.recibos_poliza[i]
                                      );
                                      $http
                                        .get(
                                          response.original.recibos_poliza[i]
                                        )
                                        .then(function success(responseGet) {
                                          if (
                                            responseGet.data.status == 4 ||
                                            responseGet.data.status == 3
                                          ) {
                                            $http.patch(auxUrl, { status: 2 });
                                          }
                                        });
                                    }
                                    $http.patch(
                                      vm.endorsement.id_policy_original.url,
                                      { status: 11 }
                                    );
                                  } else {
                                    var aux_endo = response.endorsement.url;
                                    var aux_orig = response.original.url;

                                    response.original.coverageInPolicy_policy.forEach(
                                      function (cob) {
                                        cob.policy = aux_endo;
                                      }
                                    );
                                    response.endorsement.coverageInPolicy_policy.forEach(
                                      function (cob) {
                                        cob.policy = aux_orig;
                                      }
                                    );

                                    var data = {
                                      document_type: 1,
                                    };

                                    var data_or = {
                                      document_type: 2,
                                    };

                                    $http.patch(response.endorsement.url, data);
                                    $http.patch(response.original.url, data_or);

                                    insuranceService.copyInsuranceData(
                                      response.endorsement.id,
                                      response.original.id,
                                      vm.endorsement.description
                                    );

                                    response.endorsement.recibos_poliza.forEach(
                                      function (receipt_end) {
                                        if (
                                          vm.endorsement.description ==
                                          "CAMBIO DE FORMA DE PAGO"
                                        ) {
                                          $http.delete(receipt_end.url);
                                        }
                                      }
                                    );

                                    response.original.recibos_poliza.forEach(
                                      function (receipt_orn) {
                                        if (
                                          vm.endorsement.description ==
                                          "CAMBIO DE FORMA DE PAGO"
                                        ) {
                                          if (receipt_orn.url) {
                                            $http.delete(receipt_orn.url);
                                          } else {
                                            $http.delete(receipt_orn);
                                          }
                                        }
                                      }
                                    );

                                    // POST RECIBOS
                                    if (
                                      vmm.selectedType.value === 2 &&
                                      vmm.endorsement.endorsement_type == "A"
                                    ) {
                                      if (vmm.form.recibos_poliza) {
                                        var success_receipts = 0;

                                        vmm.form.recibos_poliza.forEach(
                                          function (receipt, receipt_index) {
                                            if (receipt.fecha_inicio) {
                                              receipt.fecha_inicio = new Date(
                                                datesFactory.toDate(
                                                  receipt.fecha_inicio
                                                )
                                              );
                                            }
                                            if (receipt.fecha_fin) {
                                              receipt.fecha_fin = new Date(
                                                datesFactory.toDate(
                                                  receipt.fecha_fin
                                                )
                                              );
                                            }
                                            if (receipt.vencimiento) {
                                              receipt.vencimiento = new Date(
                                                datesFactory.toDate(
                                                  receipt.vencimiento
                                                )
                                              );
                                            }

                                            if (
                                              vm.endorsement.description ==
                                              "CAMBIO DE FORMA DE PAGO"
                                            ) {
                                              receipt.receipt_type = 1;
                                            }

                                            receipt.poliza =
                                              response.endorsement.url;

                                            if (
                                              ramoResponse.data.ramo_code == 1
                                            ) {
                                              receipt.endorsement_life =
                                                vm.endorsement.url;
                                            } else if (
                                              ramoResponse.data.ramo_code == 2
                                            ) {
                                              receipt.endorsement_disease =
                                                vm.endorsement.url;
                                            } else if (
                                              ramoResponse.data.ramo_code == 3
                                            ) {
                                              if (
                                                subramoResponse.data
                                                  .subramo_code == 9
                                              ) {
                                                receipt.endorsement_auto =
                                                  vm.endorsement.url;
                                              } else {
                                                receipt.endorsement_damage =
                                                  vm.endorsement.url;
                                              }
                                            }

                                            dataFactory
                                              .post("recibos/", receipt)
                                              .then(function (req) {
                                                if (
                                                  req.status == 200 ||
                                                  req.status == 201
                                                ) {
                                                  success_receipts += 1;
                                                }
                                              });
                                          }
                                        );
                                      }
                                    }
                                  }
                                });
                            }
                            SweetAlert.swal(
                              "Listo",
                              MESSAGES.OK.UPDATEENDORSEMENT,
                              "success"
                            );
                            activate();
                          });
                      });
                  });
              });
          });
        $uibModalInstance.dismiss("cancel");
      }

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndososPendingCtrl", EndososPendingCtrl);

  EndososPendingCtrl.$inject = [
    "endorsementService",
    "$http",
    "url",
    "$scope",
    "$state",
    "$sessionStorage",
    "globalVar",
    "$parse",
    "dataFactory",
  ];

  function EndososPendingCtrl(
    endorsementService,
    $http,
    url,
    $scope,
    $state,
    $sessionStorage,
    globalVar,
    $parse,
    dataFactory
  ) {
    var vm = this;
    // Variables and constants
    vm.endorsements = [];
    $scope.responsiv = function () {
      $("#enpendientes").trigger("resize");
      $("#entramite").trigger("resize");
      $("#registrados").trigger("resize");
      $("#rechazados").trigger("resize");
      $("#endcancelados").trigger("resize");
    };
    // Functions
    //activate();

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.checkEndorsementType = function checkType(obj) {
      if (obj.automobile) return "automobile";
      else if (obj.life) return "life";
      else if (obj.damage) return "damage";
      else if (obj.disease) {
        return "disease";
      }
    };
    $scope.exportData = function (aseguradoras) {
      var header =
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      var blob = new Blob(
        [header + document.getElementById("exportable").innerHTML],
        {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        }
      );
      saveAs(blob, "Reporte_" + aseguradoras + ".xls");
    };

    vm.search = search;

    function search(cadena) {
      vm.show_binnacle = false;
      $http({
        method: "GET",
        url: url.IP + "search-endorsments/",
        params: {
          cadena: cadena,
        },
      })
        .then(
          function success(request) {
            $scope.tableEndosos = false;
            vm.endorsements = [];
            if (request.status == 200) {
              if (request.data.cars) {
                request.data.cars.forEach(function (endoso) {
                  vm.endorsements.push(endoso);
                });
              }
              if (request.data.damages) {
                request.data.damages.forEach(function (endoso) {
                  vm.endorsements.push(endoso);
                });
              }
              if (request.data.disease) {
                request.data.disease.forEach(function (endoso) {
                  vm.endorsements.push(endoso);
                });
              }
              if (request.data.life) {
                request.data.life.forEach(function (endoso) {
                  vm.endorsements.push(endoso);
                });
              }
              $scope.tableEndosos = true;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }

    $scope.tableEndosos = false;
    vm.changeEndosoP = changeEndosoP;
    vm.changeEndosoT = changeEndosoT;
    vm.changeEndosoR = changeEndosoR;
    vm.changeEndosoRec = changeEndosoRec;
    vm.changeEndosoC = changeEndosoC;
    //Pendientes
    function changeEndosoP(par, asc) {
      switch (par) {
        case 1:
          change_tab(par, asc, 1);
          vm.endosop_type_asc = asc;
          vm.endosop_conc_asc = 0;
          vm.endosop_nend_asc = 0;
          vm.endosop_form_asc = 0;
          vm.endosop_npol_asc = 0;
          vm.endosop_cont_asc = 0;
          vm.endosop_folio_asc = 0;
          vm.endosop_fecha_asc = 0;
          break;
        case 2:
          change_tab(par, asc, 1);
          vm.endosop_type_asc = 0;
          vm.endosop_conc_asc = asc;
          vm.endosop_nend_asc = 0;
          vm.endosop_form_asc = 0;
          vm.endosop_npol_asc = 0;
          vm.endosop_cont_asc = 0;
          vm.endosop_folio_asc = 0;
          vm.endosop_fecha_asc = 0;
          break;
        case 3:
          change_tab(par, asc, 1);
          vm.endosop_nend_asc = asc;
          vm.endosop_conc_asc = 0;
          vm.endosop_type_asc = 0;
          vm.endosop_form_asc = 0;
          vm.endosop_npol_asc = 0;
          vm.endosop_cont_asc = 0;
          vm.endosop_folio_asc = 0;
          vm.endosop_fecha_asc = 0;
          break;
        case 4:
          change_tab(par, asc, 1);
          vm.endosop_form_asc = asc;
          vm.endosop_conc_asc = 0;
          vm.endosop_type_asc = 0;
          vm.endosop_nend_asc = 0;
          vm.endosop_npol_asc = 0;
          vm.endosop_cont_asc = 0;
          vm.endosop_folio_asc = 0;
          vm.endosop_fecha_asc = 0;
          break;
        case 5:
          change_tab(par, asc, 1);
          vm.endosop_npol_asc = asc;
          vm.endosop_conc_asc = 0;
          vm.endosop_type_asc = 0;
          vm.endosop_nend_asc = 0;
          vm.endosop_form_asc = 0;
          vm.endosop_cont_asc = 0;
          vm.endosop_folio_asc = 0;
          vm.endosop_fecha_asc = 0;
          break;
        case 6:
          change_tab(par, asc, 1);
          vm.endosop_cont_asc = asc;
          vm.endosop_conc_asc = 0;
          vm.endosop_type_asc = 0;
          vm.endosop_nend_asc = 0;
          vm.endosop_form_asc = 0;
          vm.endosop_npol_asc = 0;
          vm.endosop_folio_asc = 0;
          vm.endosop_fecha_asc = 0;
          break;
        case 7:
          change_tab(par, asc, 1);
          vm.endosop_folio_asc = asc;
          vm.endosop_conc_asc = 0;
          vm.endosop_type_asc = 0;
          vm.endosop_nend_asc = 0;
          vm.endosop_form_asc = 0;
          vm.endosop_npol_asc = 0;
          vm.endosop_cont_asc = 0;
          vm.endosop_fecha_asc = 0;
          break;
        case 8:
          change_tab(par, asc, 1);
          vm.endosop_folio_asc = 0;
          vm.endosop_conc_asc = 0;
          vm.endosop_type_asc = 0;
          vm.endosop_nend_asc = 0;
          vm.endosop_form_asc = 0;
          vm.endosop_npol_asc = 0;
          vm.endosop_cont_asc = 0;
          vm.endosop_fecha_asc = asc;
          break;
      }
    }
    // En Trámite
    function changeEndosoT(par, asc) {
      switch (par) {
        case 1:
          change_tab(par, asc, 2);
          vm.endosot_type_asc = asc;
          vm.endosot_conc_asc = 0;
          vm.endosot_nend_asc = 0;
          vm.endosot_form_asc = 0;
          vm.endosot_npol_asc = 0;
          vm.endosot_cont_asc = 0;
          vm.endosot_folio_asc = 0;
          vm.endosot_fecha_asc = 0;
          break;
        case 2:
          change_tab(par, asc, 2);
          vm.endosot_type_asc = 0;
          vm.endosot_conc_asc = asc;
          vm.endosot_nend_asc = 0;
          vm.endosot_form_asc = 0;
          vm.endosot_npol_asc = 0;
          vm.endosot_cont_asc = 0;
          vm.endosot_folio_asc = 0;
          vm.endosot_fecha_asc = 0;
          break;
        case 3:
          change_tab(par, asc, 2);
          vm.endosot_nend_asc = asc;
          vm.endosot_conc_asc = 0;
          vm.endosot_type_asc = 0;
          vm.endosot_form_asc = 0;
          vm.endosot_npol_asc = 0;
          vm.endosot_cont_asc = 0;
          vm.endosot_folio_asc = 0;
          vm.endosot_fecha_asc = 0;
          break;
        case 4:
          change_tab(par, asc, 2);
          vm.endosot_form_asc = asc;
          vm.endosot_conc_asc = 0;
          vm.endosot_type_asc = 0;
          vm.endosot_nend_asc = 0;
          vm.endosot_npol_asc = 0;
          vm.endosot_cont_asc = 0;
          vm.endosot_folio_asc = 0;
          vm.endosot_fecha_asc = 0;
          break;
        case 5:
          change_tab(par, asc, 2);
          vm.endosot_npol_asc = asc;
          vm.endosot_conc_asc = 0;
          vm.endosot_type_asc = 0;
          vm.endosot_nend_asc = 0;
          vm.endosot_form_asc = 0;
          vm.endosot_cont_asc = 0;
          vm.endosot_folio_asc = 0;
          vm.endosot_fecha_asc = 0;
          break;
        case 6:
          change_tab(par, asc, 2);
          vm.endosot_cont_asc = asc;
          vm.endosot_conc_asc = 0;
          vm.endosot_type_asc = 0;
          vm.endosot_nend_asc = 0;
          vm.endosot_form_asc = 0;
          vm.endosot_npol_asc = 0;
          vm.endosot_folio_asc = 0;
          vm.endosot_fecha_asc = 0;
          break;
        case 7:
          change_tab(par, asc, 2);
          vm.endosot_folio_asc = asc;
          vm.endosot_conc_asc = 0;
          vm.endosot_type_asc = 0;
          vm.endosot_nend_asc = 0;
          vm.endosot_form_asc = 0;
          vm.endosot_npol_asc = 0;
          vm.endosot_cont_asc = 0;
          vm.endosot_fecha_asc = 0;
          break;
        case 8:
          change_tab(par, asc, 2);
          vm.endosot_folio_asc = 0;
          vm.endosot_conc_asc = 0;
          vm.endosot_type_asc = 0;
          vm.endosot_nend_asc = 0;
          vm.endosot_form_asc = 0;
          vm.endosot_npol_asc = 0;
          vm.endosot_cont_asc = 0;
          vm.endosot_fecha_asc = asc;
          break;
      }
    }
    //Registrados
    function changeEndosoR(par, asc) {
      switch (par) {
        case 1:
          change_tab(par, asc, 3);
          vm.endosor_type_asc = asc;
          vm.endosor_conc_asc = 0;
          vm.endosor_nend_asc = 0;
          vm.endosor_form_asc = 0;
          vm.endosor_npol_asc = 0;
          vm.endosor_cont_asc = 0;
          vm.endosor_folio_asc = 0;
          vm.endosor_fecha_asc = 0;
          break;
        case 2:
          change_tab(par, asc, 3);
          vm.endosor_type_asc = 0;
          vm.endosor_conc_asc = asc;
          vm.endosor_nend_asc = 0;
          vm.endosor_form_asc = 0;
          vm.endosor_npol_asc = 0;
          vm.endosor_cont_asc = 0;
          vm.endosor_folio_asc = 0;
          vm.endosor_fecha_asc = 0;
          break;
        case 3:
          change_tab(par, asc, 3);
          vm.endosor_nend_asc = asc;
          vm.endosor_conc_asc = 0;
          vm.endosor_type_asc = 0;
          vm.endosor_form_asc = 0;
          vm.endosor_npol_asc = 0;
          vm.endosor_cont_asc = 0;
          vm.endosor_folio_asc = 0;
          vm.endosor_fecha_asc = 0;
          break;
        case 4:
          change_tab(par, asc, 3);
          vm.endosor_form_asc = asc;
          vm.endosor_conc_asc = 0;
          vm.endosor_type_asc = 0;
          vm.endosor_nend_asc = 0;
          vm.endosor_npol_asc = 0;
          vm.endosor_cont_asc = 0;
          vm.endosor_folio_asc = 0;
          vm.endosor_fecha_asc = 0;
          break;
        case 5:
          change_tab(par, asc, 3);
          vm.endosor_npol_asc = asc;
          vm.endosor_conc_asc = 0;
          vm.endosor_type_asc = 0;
          vm.endosor_nend_asc = 0;
          vm.endosor_form_asc = 0;
          vm.endosor_cont_asc = 0;
          vm.endosor_folio_asc = 0;
          vm.endosor_fecha_asc = 0;
          break;
        case 6:
          change_tab(par, asc, 3);
          vm.endosor_cont_asc = asc;
          vm.endosor_conc_asc = 0;
          vm.endosor_type_asc = 0;
          vm.endosor_nend_asc = 0;
          vm.endosor_form_asc = 0;
          vm.endosor_npol_asc = 0;
          vm.endosor_folio_asc = 0;
          vm.endosor_fecha_asc = 0;
          break;
        case 7:
          change_tab(par, asc, 3);
          vm.endosor_folio_asc = asc;
          vm.endosor_conc_asc = 0;
          vm.endosor_type_asc = 0;
          vm.endosor_nend_asc = 0;
          vm.endosor_form_asc = 0;
          vm.endosor_npol_asc = 0;
          vm.endosor_cont_asc = 0;
          vm.endosor_fecha_asc = 0;
          break;
        case 8:
          change_tab(par, asc, 3);
          vm.endosor_folio_asc = 0;
          vm.endosor_conc_asc = 0;
          vm.endosor_type_asc = 0;
          vm.endosor_nend_asc = 0;
          vm.endosor_form_asc = 0;
          vm.endosor_npol_asc = 0;
          vm.endosor_cont_asc = 0;
          vm.endosor_fecha_asc = asc;
          break;
      }
    }
    // Rechazados
    function changeEndosoRec(par, asc) {
      switch (par) {
        case 1:
          change_tab(par, asc, 4);
          vm.endosorec_type_asc = asc;
          vm.endosorec_conc_asc = 0;
          vm.endosorec_nend_asc = 0;
          vm.endosorec_form_asc = 0;
          vm.endosorec_npol_asc = 0;
          vm.endosorec_cont_asc = 0;
          vm.endosorec_folio_asc = 0;
          vm.endosorec_fecha_asc = 0;
          break;
        case 2:
          change_tab(par, asc, 4);
          vm.endosorec_type_asc = 0;
          vm.endosorec_conc_asc = asc;
          vm.endosorec_nend_asc = 0;
          vm.endosorec_form_asc = 0;
          vm.endosorec_npol_asc = 0;
          vm.endosorec_cont_asc = 0;
          vm.endosorec_folio_asc = 0;
          vm.endosorec_fecha_asc = 0;
          break;
        case 3:
          change_tab(par, asc, 4);
          vm.endosorec_nend_asc = asc;
          vm.endosorec_conc_asc = 0;
          vm.endosorec_type_asc = 0;
          vm.endosorec_form_asc = 0;
          vm.endosorec_npol_asc = 0;
          vm.endosorec_cont_asc = 0;
          vm.endosorec_folio_asc = 0;
          vm.endosorec_fecha_asc = 0;
          break;
        case 4:
          change_tab(par, asc, 4);
          vm.endosorec_form_asc = asc;
          vm.endosorec_conc_asc = 0;
          vm.endosorec_type_asc = 0;
          vm.endosorec_nend_asc = 0;
          vm.endosorec_npol_asc = 0;
          vm.endosorec_cont_asc = 0;
          vm.endosorec_folio_asc = 0;
          vm.endosorec_fecha_asc = 0;
          break;
        case 5:
          change_tab(par, asc, 4);
          vm.endosorec_npol_asc = asc;
          vm.endosorec_conc_asc = 0;
          vm.endosorec_type_asc = 0;
          vm.endosorec_nend_asc = 0;
          vm.endosorec_form_asc = 0;
          vm.endosorec_cont_asc = 0;
          vm.endosorec_folio_asc = 0;
          vm.endosorec_fecha_asc = 0;
          break;
        case 6:
          change_tab(par, asc, 4);
          vm.endosorec_cont_asc = asc;
          vm.endosorec_conc_asc = 0;
          vm.endosorec_type_asc = 0;
          vm.endosorec_nend_asc = 0;
          vm.endosorec_form_asc = 0;
          vm.endosorec_npol_asc = 0;
          vm.endosorec_folio_asc = 0;
          vm.endosorec_fecha_asc = 0;
          break;
        case 7:
          change_tab(par, asc, 4);
          vm.endosorec_folio_asc = asc;
          vm.endosorec_conc_asc = 0;
          vm.endosorec_type_asc = 0;
          vm.endosorec_nend_asc = 0;
          vm.endosorec_form_asc = 0;
          vm.endosorec_npol_asc = 0;
          vm.endosorec_cont_asc = 0;
          vm.endosorec_fecha_asc = 0;
          break;
        case 8:
          change_tab(par, asc, 4);
          vm.endosorec_folio_asc = 0;
          vm.endosorec_conc_asc = 0;
          vm.endosorec_type_asc = 0;
          vm.endosorec_nend_asc = 0;
          vm.endosorec_form_asc = 0;
          vm.endosorec_npol_asc = 0;
          vm.endosorec_cont_asc = 0;
          vm.endosorec_fecha_asc = asc;
          break;
      }
    }
    //Cancelados
    function changeEndosoC(par, asc) {
      switch (par) {
        case 1:
          change_tab(par, asc, 5);
          vm.endosoc_type_asc = asc;
          vm.endosoc_conc_asc = 0;
          vm.endosoc_nend_asc = 0;
          vm.endosoc_form_asc = 0;
          vm.endosoc_npol_asc = 0;
          vm.endosoc_cont_asc = 0;
          vm.endosoc_folio_asc = 0;
          vm.endosoc_fecha_asc = 0;
          break;
        case 2:
          change_tab(par, asc, 5);
          vm.endosoc_type_asc = 0;
          vm.endosoc_conc_asc = asc;
          vm.endosoc_nend_asc = 0;
          vm.endosoc_form_asc = 0;
          vm.endosoc_npol_asc = 0;
          vm.endosoc_cont_asc = 0;
          vm.endosoc_folio_asc = 0;
          vm.endosoc_fecha_asc = 0;
          break;
        case 3:
          change_tab(par, asc, 5);
          vm.endosoc_nend_asc = asc;
          vm.endosoc_conc_asc = 0;
          vm.endosoc_type_asc = 0;
          vm.endosoc_form_asc = 0;
          vm.endosoc_npol_asc = 0;
          vm.endosoc_cont_asc = 0;
          vm.endosoc_folio_asc = 0;
          vm.endosoc_fecha_asc = 0;
          break;
        case 4:
          change_tab(par, asc, 5);
          vm.endosoc_form_asc = asc;
          vm.endosoc_conc_asc = 0;
          vm.endosoc_type_asc = 0;
          vm.endosoc_nend_asc = 0;
          vm.endosoc_npol_asc = 0;
          vm.endosoc_cont_asc = 0;
          vm.endosoc_folio_asc = 0;
          vm.endosoc_fecha_asc = 0;
          break;
        case 5:
          change_tab(par, asc, 5);
          vm.endosoc_npol_asc = asc;
          vm.endosoc_conc_asc = 0;
          vm.endosoc_type_asc = 0;
          vm.endosoc_nend_asc = 0;
          vm.endosoc_form_asc = 0;
          vm.endosoc_cont_asc = 0;
          vm.endosoc_folio_asc = 0;
          vm.endosoc_fecha_asc = 0;
          break;
        case 6:
          change_tab(par, asc, 5);
          vm.endosoc_cont_asc = asc;
          vm.endosoc_conc_asc = 0;
          vm.endosoc_type_asc = 0;
          vm.endosoc_nend_asc = 0;
          vm.endosoc_form_asc = 0;
          vm.endosoc_npol_asc = 0;
          vm.endosoc_folio_asc = 0;
          vm.endosoc_fecha_asc = 0;
          break;
        case 7:
          change_tab(par, asc, 5);
          vm.endosoc_folio_asc = asc;
          vm.endosoc_conc_asc = 0;
          vm.endosoc_type_asc = 0;
          vm.endosoc_nend_asc = 0;
          vm.endosoc_form_asc = 0;
          vm.endosoc_npol_asc = 0;
          vm.endosoc_cont_asc = 0;
          vm.endosoc_fecha_asc = 0;
          break;
        case 8:
          change_tab(par, asc, 5);
          vm.endosoc_folio_asc = 0;
          vm.endosoc_conc_asc = 0;
          vm.endosoc_type_asc = 0;
          vm.endosoc_nend_asc = 0;
          vm.endosoc_form_asc = 0;
          vm.endosoc_npol_asc = 0;
          vm.endosoc_cont_asc = 0;
          vm.endosoc_fecha_asc = asc;
          break;
      }
    }

    vm.activate = activate;
    vm.returnToEndorsement = returnToEndorsement;
    function activate(order, asc) {
      dataFactory.get("has-view-cartas-permission").then(function (req) {
        if (req.status == 200) {
          $scope.view_cartas = req.data;
        }
      });

      vm.show_binnacle = false;
      endorsementService.getAllEndorsements(1, 1, 1).then(function (res) {
        //console.log(res);
        vm.endorsements = res;
        $scope.tableEndosos = true;
      });
    }
    function returnToEndorsement() {
      // console.log('sa')
      vm.show_binnacle = false;
    }
    vm.change_tab = change_tab;
    function change_tab(order, asc, status) {
      endorsementService
        .getAllEndorsements(order, asc, status)
        .then(function (res) {
          vm.endorsements = res;
        });
    }

    $scope.showInformationEndoso = function (endoso) {
      if (endoso.policy_type == 1) {
        $state.go("endosos.pendingData", {
          endorsementId: endoso.id,
          endorsementType: vm.checkEndorsementType(endoso),
          polizaId: endoso.policy.id,
        });
      } else if (endoso.policy_type == 2) {
        if (endoso.endorsement_type == "D") {
          if (endoso.policy.subramo == 1) var type = "life";
          else if (endoso.policy.subramo == 3) var type = "disease";
          else var type = "automobile";
        }
        $state.go("endosos.pendingDataMassive", {
          endorsementId: endoso.id,
          endorsementType: vm.checkEndorsementType(endoso)
            ? vm.checkEndorsementType(endoso)
            : type,
          polizaId: endoso.policy.id,
        });
      }
    };

    vm.showBinnacle = showBinnacle;
    //-----------------------------------------------------------comments
    function showBinnacle(param) {
      vm.show_binnacle = true;
      // console.log('dsada',param)
      vm.endorsement_id = param.id;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 10,
          id_model: param.id,
        },
      })
        .then(function (request) {
          // console.log('requestkñlñkñl', request);
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }
    //-------------------------------------------------------------comments
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndososInformationCtrl", EndososInformationCtrl);

  EndososInformationCtrl.$inject = [];

  function EndososInformationCtrl() {
    var vm = this;

    activate();

    function activate() {}
  }
})();

var vm2 = null;
(function () {
  "use strict";

  angular.module("inspinia").controller("EndososCtrl", EndososCtrl);

  EndososCtrl.$inject = [
    "$q",
    "url",
    "$http",
    "SweetAlert",
    "$localStorage",
    "sex",
    "$scope",
    "$log",
    "$uibModal",
    "$timeout",
    "formService",
    "tiposBeneficiarios",
    "endorsementService",
    "generalService",
    "ContratanteService",
    "coverageService",
    "receiptService",
    "insuranceService",
    "packageService",
    "ramoService",
    "forms",
    "endorsement",
    "helpers",
    "toaster",
    "MESSAGES",
    "payform",
    "datesFactory",
    "globalVar",
    "$state",
    "$rootScope",
    "formatValues",
    "$sessionStorage",
    "$stateParams",
    "FileUploader",
    "providerService",
    "dataFactory",
  ];

  function EndososCtrl(
    $q,
    url,
    $http,
    SweetAlert,
    $localStorage,
    sex,
    $scope,
    $log,
    $uibModal,
    $timeout,
    formService,
    tiposBeneficiarios,
    endorsementService,
    generalService,
    ContratanteService,
    coverageService,
    receiptService,
    insuranceService,
    packageService,
    ramoService,
    forms,
    endorsement,
    helpers,
    toaster,
    MESSAGES,
    payform,
    datesFactory,
    globalVar,
    $state,
    $rootScope,
    formatValues,
    $sessionStorage,
    $stateParams,
    FileUploader,
    providerService,
    dataFactory
  ) {
    var vm = (vm2 = this);
    //var order = vm;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    // Variables
    vm.policy = [];
    vm.flags = {};
    vm.loading = false;
    vm.activar = activar;
    vm.cancel = cancel;
    $scope.direccion_contratante = [];
    $scope.direccion_endoso;
    $scope.flagB1 = false;
    $scope.contractorNew;
    $scope.vflag = false;
    $scope.cancel_policy = false;

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    $scope.validate = function (contra) {
      $scope.vflag = true;
    };

    vm.subforms = {
      auto: {},
      life: {
        beneficiariesList: [],
      },
      disease: {
        relationshipList: [],
      },
      damage: {
        coinsurance: "",
        insured_item: "",
        item_address: "",
        item_details: "",
      },
      observations: "",
    };

    $scope.checkRegister = false;

    vm.types = [
      {
        id: 0,
        name: "Selecciona un tipo de endoso",
      },
      {
        id: 1,
        name: "A",
      },
      {
        id: 2,
        name: "B",
      },
      {
        id: 3,
        name: "D",
      },
    ];

    // order.defaults = {
    //   coverages: [],
    //   coverageList: []
    // }

    vm.defaults = {
      coverages: [], // Coverage in form
      coverageList: [], // Coverage in package
      sex: sex,
      formInfo: {},
      years: helpers.getAutoYears(),
      payform: payform,
      contractors: [],
      originalPayForm: "",
      receipt: {},
      config: {
        derecho: false,
        rpf: false,
      },
      createEndorsementButtonDisabled: false,
      insurances: null,
      insurancesIds: [],
      descriptions: {},
    };
    $scope.myPolicy = $stateParams.myInsurance;
    try {
      if ($scope.myPolicy) {
        if ($scope.myPolicy.url) {
          vm.poliza_number_data = {
            val: $scope.myPolicy.poliza_number,
            id: $scope.myPolicy.id,
          };
          var parValue = {
            label: $scope.myPolicy.poliza_number,
            value: $scope.myPolicy.poliza_number,
            id: $scope.myPolicy.id,
          };
          getPolicy(parValue, true);
        }
      }
    } catch (error) {
      activate();
    }

    $scope.showFields = function (concept) {
      vm.form.description.label = concept.label;
      $scope.valueConcept = concept.val;
    };

    $scope.changeUntil = function () {
      var since = toDate(vm.form.start_of_validity).getTime();
      var until = toDate(vm.form.end_of_validity).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        vm.form.start_of_validity = convertDate(new Date());
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORDATERANGE, "error");
      }
    };

    $scope.changebirthdate = function (birthdate) {
      var since = toDate(birthdate).getTime();
      var date = convertDate(new Date());
      var until = toDate(date).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        // vm.form.start_of_validity = convertDate(new Date());
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORDATEBIRTHDATE, "error");
      }
    };

    $scope.$watch("vm.defaults.coverages", function (newValue, oldValue) {
      // console.log('--------------------------');
      if (newValue) {
        newValue.forEach(function (coverage) {
          // console.log('coverage', coverage);
          coverage.deductible_coverage_parsed = [];
          coverage.sums_coverage_parsed = [];
          coverage.deductible_coverage_parsed.forEach(function (deductible) {
            var obj = {
              label: deductible.deductible,
              value: deductible.deductible,
            };
            coverage.deductible_coverage_parsed.push(obj);
          });

          coverage.sums_coverage_parsed.forEach(function (suma) {
            var obj = {
              label: suma.sum_insured,
              value: suma.sum_insured,
            };
            coverage.sums_coverage_parsed.push(obj);
          });
        });
      }
    });

    // Order stuff

    function disabledDefaults() {
      vm.disabled = {
        payform: true,
        contractor: true,
        ramo: true,
        subramo: true,
        package: true,
        addCoverage: true,
        deleteCoverage: true,
        sum: true,
        deductible: true,
        addPeople: true,
        sex: true,
        bday: true,
        risk: true,
        names: true,
        address: true,
      };
    }

    disabledDefaults();

    function disableA() {
      // or D
      var sf = vm.subforms.show;
      if (sf === 1) {
        // auto
        vm.disabled.payform = false;
        vm.disabled.sum = false;
        vm.disabled.deductible = false;
        vm.disabled.addCoverage = false;
        vm.disabled.deleteCoverage = false;
        vm.disabled.package = false;
      } else if (sf === 2) {
        // dmgs
        vm.disabled.payform = false;

        vm.disabled.addpeople = false;
        vm.disabled.sex = false;
        vm.disabled.bday = false;
        vm.disabled.package = false;
        vm.disabled.sum = false;
        vm.disabled.deductible = false;
        vm.disabled.addCoverage = false;
        vm.disabled.deleteCoverage = false;
      } else if (sf === 3) {
        // life
        vm.disabled.bday = false;
        vm.disabled.payform = false;
        vm.disabled.sum = false;
        vm.disabled.deductible = false;
        vm.disabled.addCoverage = false;
        vm.disabled.deleteCoverage = false;
        vm.disabled.package = false;
      } else {
        // disease (0)
        vm.disabled.sum = false;
        vm.disabled.deductible = false;
        vm.disabled.payform = false;

        vm.disabled.addCoverage = false;
        vm.disabled.deleteCoverage = false;
        vm.disabled.risk = false;
        vm.disabled.package = false;
      }
      vm.disabled.calculateReceipt = false;
    }

    function disableB() {
      var sf = vm.subforms.show;
      vm.disabled.calculateReceipt = true;
      if (sf === 1) {
        // auto
        vm.disabled.contractor = false;
      } else if (sf === 2) {
        // dmgs
        vm.disabled.names = false;
      } else if (sf === 3) {
        // life
        vm.disabled.names = false;
        vm.disabled.percent = false;
        vm.disabled.addPeople = false;
      } else {
        // disease (0)
        vm.disabled.names = false;
        vm.disabled.address = false;
      }
    }
    /* Functions*/

    vm.cambioPago = false;
    $scope.inptuDisabled = true;

    $scope.changePayform = function () {
      swal(
        {
          title: "Cambiar forma de pago",
          text: MESSAGES.WARNING.CHANGEPAYFORM,
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.inptuDisabled = false;
            swal.close();
          } else {
            swal.close();
            vm.form.description = vm.defaults.descriptions[6];
          }
        }
      );
    };

    vm.options = {
      deleteCoverage: function (obj, index) {
        if (usr.permiso.eliminar) {
          vm.coverages.splice(index, 1);
          var cl = vm.defaults.coverageList;
          var flag = false;
          for (var i = 0; i < cl.length; i++) {
            if (cl[i].id == obj.id) {
              flag = true;
            }
            if (obj.coverage_name == cl[i].coverage_name) {
              var flag2 = true;
            } else {
              var flag2 = false;
            }
          }
          if (!flag) {
            if (!flag2) {
              vm.defaults.coverageList.push(obj);
            }
          }
        } else {
          SweetAlert.swal(
            "Oops...",
            "No tienes permiso para eliminar registros",
            "error"
          );
        }
      },
      addCoverage: function (obj, index) {
        var delCoverage = false;
        if (vm.defaults.coverages.length == 0) {
          delCoverage = true;
        }

        for (var i = vm.defaults.coverages.length - 1; i >= 0; i--) {
          if (vm.defaults.coverages[i].coverage_name === obj.coverage_name) {
            toaster.info("Ya existe esta cobertura.");
            vm.defaults.coverageList.forEach(function (coverage) {
              if (coverage.coverage_name == obj.coverage_name) {
                vm.defaults.coverageList.splice(
                  vm.defaults.coverageList.indexOf(coverage),
                  1
                );
              }
            });
            return;
          } else {
            delCoverage = true;
          }
        }

        if (delCoverage) {
          vm.defaults.coverages.push(obj);
          vm.defaults.coverageList.forEach(function (coverage) {
            if (coverage.coverage_name == obj.coverage_name) {
              vm.defaults.coverageList.splice(
                vm.defaults.coverageList.indexOf(coverage),
                1
              );
            }
          });
        }
        vm.defaults.coverageInPackage = "";
      },
      getPolicy: getPolicy,
      fillData: fillData,
      changePackage: changePackage,
      primaryTab: true,
      life: {
        beneficiaries: {
          add: function (ben) {
            //var beneficiary = angular.copy(ben);
            //vm.subforms.life.beneficiariesList.push(ben);
            if (ben) {
              vm.options.life.relationships.selectType(ben.beneficiary, null);
              vm.subforms.beneficiaries_life.push(ben);
            } else {
              var ben = {
                first_name: "",
                last_name: "",
                second_last_name: "",
                optional_relationship: "",
                birthdate: null,
                sex: null,
                percentage: "",
              };
              vm.subforms.beneficiaries_life.push(ben);
            }
          },
          destroy: function (index) {
            vm.subforms.beneficiaries_life.splice(index, 1);
          },
        },
      },
      disease: {
        relationships: {
          add: function (relacion) {
            if (relacion) {
              vm.options.disease.relationships.selectType(
                relacion.relationship,
                null
              );
              vm.subforms.relationshipList.push(relacion);
            } else {
              var relacion = {
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: null,
                sex: null,
                relationship: null,
                accident: null,
              };
              vm.subforms.relationshipList.push(relacion);
            }
          },
          destroy: function (index, rel) {
            vm.subforms.relationshipList.splice(index, 1);
          },
          selectType: function (newValue, old) {
            var oldValue = old != "" ? JSON.parse(old) : null;
            var newIndex = -1;
            vm.options.disease.types.some(function (valueData, index) {
              if (valueData.relationship == newValue.relationship) {
                newIndex = index;
                return true;
              }
            });
            var oldIndex = -1;

            if (newValue.relationship == 1 || newValue.relationship == 2) {
              // titular y conyugue
              vm.options.disease.types[newIndex].disabled = true;
            }

            if (oldValue) {
              vm.options.disease.types.some(function (val, index) {
                if (val.relationship == oldValue.relationship) {
                  oldIndex = index;
                  return true;
                }
              });

              if (oldValue.relationship == 1 || oldValue.relationship == 2) {
                // titular y conyugue
                vm.options.disease.types[oldIndex].disabled = false;
              }
            }
          },
        },
        // 1-Titular, 2-Conyuge, 3-Hijo
        types: angular.copy(tiposBeneficiarios),
      },
      createEndorsement: function (value) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();

        if (value == 2 && $scope.checkRegister) {
          if (!vm.number_endorsement) {
            l.stop();
            SweetAlert.swal(
              "Error",
              MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
              "error"
            );
            return;
          }

          if (vm.selectedType.name === "A") {
            if (!vm.form.num_receipts) {
              l.stop();
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.ERRORRECEIPTSENDORSEMENT,
                "error"
              );
              return;
            }

            if (!vm.form.recibos_poliza) {
              l.stop();
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.RECEIPTSREQUIRED,
                "error"
              );
              return;
            }
          }

          if (vm.selectedType.name === "D") {
            if ($scope.creditNotes.prima_total == 0) {
              l.stop();
              SweetAlert.swal("Error", MESSAGES.ERROR.NOTESREQUIRED, "error");
              return;
            }
          }
        }

        var today;
        if (vm.form || vm.form != null) {
          today = new Date(vm.form.start_of_validity).setHours(0, 0, 0, 0);
        } else {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
          return;
        }

        if (vm.selectedType.name == "Selecciona un tipo de endoso") {
          l.stop();
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORTYPEENDORSEMENT,
            "error"
          );
          return;
        }

        if (!vm.form.description) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONCEPT, "error");
          return;
        }

        var left_receipts = [];
        var cur_receipt;

        // console.log('form', vm.form);

        vm.policy.recibos_poliza.forEach(function (element, index) {
          var start = new Date(element.fecha_inicio).setHours(0, 0, 0, 0);
          var end = new Date(element.fecha_fin).setHours(0, 0, 0, 0);

          if (start >= today && end > today) {
            left_receipts.push(element);
          }
          if (index == 0) {
            cur_receipt = element;
          }
        });

        if (vm.defaults.coverages.length == 0) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
        } else {
          if (vm.form.folio_endorsement == undefined) {
            vm.form.folio_endorsement = 0;
          }
          endorsementService
            .existEndorsement(vm.form.folio_endorsement)
            .then(function (res) {
              if (res === true || res === null || res === undefined) {
                l.stop();
                SweetAlert.swal(
                  "Error",
                  MESSAGES.ERROR.ERRORFOLIOENDORSEMENT,
                  "error"
                );
              } else {
                if (vm.policy.contractor) {
                  vm.policy.address =
                    vm.policy.contractor.address_contractor[0].url;
                  if (vm.policy.juridical) {
                    vm.policy.juridical.url = undefined;
                  }
                }

                var newP = {
                  folio: vm.policy.folio,
                  org: vm.policy.org,
                  poliza_number: vm.policy.poliza_number,
                  contractor: vm.policy.contractor
                    ? vm.policy.contractor.url
                    : undefined,
                  aseguradora: vm.policy.aseguradora.url,
                  ramo: vm.policy.ramo.url,
                  subramo: vm.policy.subramo.url,
                  paquete: vm.policy.paquete.url,
                  observations: vm.policy.observations,
                  old_policies: [],
                  start_of_validity: vm.policy.start_of_validity,
                  end_of_validity: vm.policy.end_of_validity,
                  forma_de_pago: vm.form.payment
                    ? vm.form.payment.value
                    : vm.policy.forma_de_pago,
                  status: vm.policy.status ? vm.policy.status : null,
                  recibos_poliza: [],
                  // "recibos_poliza": vm.form.recibos_poliza,
                  document_type: 2,
                  address: vm.policy.address,
                  clave: vm.policy.clave.url,
                  comision: vm.policy.comision,
                  comision_percent: vm.policy.comision_percent,
                  "derecho ": vm.policy.derecho,
                  descuento: vm.policy.descuento,
                  iva: vm.policy.iva,
                  p_neta: vm.policy.p_neta,
                  p_total: vm.policy.p_total,
                  rpf: vm.policy.rpf,
                  identifier: vm.policy.identifier,
                  owner: vm.policy.owner,
                };

                insuranceService
                  .createInsurance(newP)
                  .catch(function (error) {
                    toaster.error(error);
                  })
                  .then(function (thePolicy) {
                    var waitForAll = [];

                    if (vm.defaults.coverages.length > 0) {
                      for (var i = 0; i < vm.defaults.coverages.length; i++) {
                        if (!vm.defaults.coverages.deductible) {
                          vm.defaults.coverages[i].deductible =
                            vm.defaults.coverages[i].deductibleInPolicy.value;
                          vm.defaults.coverages[i].sum_insured =
                            vm.defaults.coverages[i].sumInPolicy.value;
                          if (vm.defaults.coverages[i].coinsurance) {
                            vm.defaults.coverages[i].coinsurance = vm.defaults
                              .coverages[i].coinsurance
                              ? vm.defaults.coverages[i].coinsurance
                              : 0;
                          }
                        }
                      }
                      helpers.createCoverages(vm.defaults.coverages, thePolicy);
                    }

                    if (vm.subforms.show === 0) {
                      vm.subforms.show = 0;
                      var accident = vm.subforms;
                      accident.policy = thePolicy.url;
                      var personal = {
                        first_name: accident.personal.first_name
                          ? accident.personal.first_name
                          : "",
                        last_name: accident.personal.last_name
                          ? accident.personal.last_name
                          : "",
                        second_last_name: accident.personal.second_last_name
                          ? accident.personal.second_last_name
                          : "",
                        birthdate: new Date(
                          accident.personal.birthdate
                        ).toISOString(),
                        sex: accident.personal.sex ? accident.personal.sex : "",
                      };

                      generalService
                        .createPersonalInformation(personal)
                        .then(function (res) {
                          var diseaseForm = {
                            sub_branch: null,
                            policy: accident.policy,
                            personal: res.data.url,
                            disease_type: 0,
                            coinsurance: accident.coinsurance
                              ? accident.coinsurance
                              : "",
                            document_type: 2,
                          };

                          generalService
                            .diseaseForm(diseaseForm)
                            .then(function (diseaseRes) {
                              endorsement = {
                                disease: diseaseRes.data.url,
                                endorsement_type: vm.selectedType.name,
                                policy: accident.policy,
                                status: 5,
                                init_date: new Date(
                                  toDate(vm.form.start_of_validity)
                                ),
                                end_date: new Date(
                                  toDate(vm.form.end_of_validity)
                                ),
                                id_policy_original: vm.policy.url,
                                description: vm.form.description.label,
                                other_desc: vm.form.others
                                  ? vm.form.others
                                  : "",
                                observations: vm.form.observations,
                              };
                              endorsementService
                                .createDiseaseEndorsement(endorsement)
                                .then(function (diseaseEndoRes) {
                                  if (diseaseEndoRes.status == 201) {
                                    if ($scope.countFile > 0) {
                                      uploadFiles(diseaseEndoRes.data.id, 3);
                                    } else {
                                      endorsementDone(
                                        value,
                                        diseaseEndoRes.data
                                      );
                                    }
                                  }
                                });

                              accident.relationshipList.forEach(function (
                                element,
                                index
                              ) {
                                element.accident = diseaseRes.data.url;
                                element.birthdate = new Date(element.birthdate);
                                element.relationship =
                                  element.relationship.relationship;
                                element.sex = element.sex.value;
                                generalService
                                  .createRelationship(element)
                                  .then(function (benefRes) {});
                              });
                            });
                        });
                    } else if (vm.subforms.show === 1) {
                      vm.subforms.show = 1;
                      var auto = vm.subforms;
                      auto.policy = thePolicy.url;
                      auto.document_type = 2;

                      generalService
                        .automobileForm(auto)
                        .then(function (autoRes) {
                          endorsement = {
                            automobile: autoRes.data.url,
                            endorsement_type: vm.selectedType.name,
                            policy: thePolicy.url,
                            status: 5,
                            init_date: new Date(
                              toDate(vm.form.start_of_validity)
                            ),
                            end_date: new Date(toDate(vm.form.end_of_validity)),
                            id_policy_original: vm.policy.url,
                            description: vm.form.description.label,
                            other_desc: vm.form.others ? vm.form.others : "",
                            observations: vm.form.observations,
                          };

                          endorsementService
                            .createAutomobileEndorsement(endorsement)
                            .then(function (autoEndoRes) {
                              if (autoEndoRes.status == 201) {
                                if ($scope.countFile > 0) {
                                  uploadFiles(autoEndoRes.data.id, 4);
                                } else {
                                  endorsementDone(value, autoEndoRes.data);
                                }
                              }
                            });
                        });
                      // DONE
                    } else if (vm.subforms.show === 2) {
                      vm.subforms.show = 2;
                      var damage = vm.subforms;
                      damage.policy = thePolicy.url;
                      damage.document_type = 2;

                      generalService
                        .damageForm(damage)
                        .then(function (damageRes) {
                          endorsement = {
                            damage: damageRes.data.url,
                            endorsement_type: vm.selectedType.name,
                            policy: thePolicy.url,
                            status: 5,
                            init_date: new Date(
                              toDate(vm.form.start_of_validity)
                            ),
                            end_date: new Date(toDate(vm.form.end_of_validity)),
                            id_policy_original: vm.policy.url,
                            description: vm.form.description.label,
                            other_desc: vm.form.others ? vm.form.others : "",
                            observations: vm.form.observations,
                          };

                          endorsementService
                            .createDamageEndorsement(endorsement)
                            .then(function (damageEndoRes) {
                              if (damageEndoRes.status == 201) {
                                if ($scope.countFile > 0) {
                                  uploadFiles(damageEndoRes.data.id, 2);
                                } else {
                                  endorsementDone(value, damageEndoRes.data);
                                }
                              }
                            });
                        });
                      // Done
                    } else if (vm.subforms.show === 3) {
                      //life_policy
                      vm.subforms.show = 3;

                      var life = vm.subforms;
                      var beneficiariesLife = vm.subforms.beneficiaries_life;

                      // Personal model
                      var personal = {
                        first_name: life.personal.first_name
                          ? life.personal.first_name
                          : "",
                        last_name: life.personal.last_name
                          ? life.personal.last_name
                          : "",
                        second_last_name: life.personal.second_last_name
                          ? life.personal.second_last_name
                          : "",
                        birthdate: new Date(life.personal.birthdate),
                        sex: life.personal.sex ? life.personal.sex : "",
                      };

                      generalService
                        .createPersonalInformation(personal)
                        .then(function (personalRes) {
                          var lifeForm = {
                            sub_branch: null,
                            policy: thePolicy.url,
                            personal: personalRes.data.url,
                            smoker: life.smoker,
                            document_type: 2,
                          };

                          generalService
                            .lifeForm(lifeForm)
                            .then(function (lifeRes) {
                              beneficiariesLife.forEach(function (
                                element,
                                index
                              ) {
                                element.birthdate = new Date(element.birthdate);
                                element.life = lifeRes.data.url;
                                waitForAll.push(
                                  generalService.createBeneficiaries(element)
                                );
                              });

                              endorsement = {
                                life: lifeRes.data.url,
                                endorsement_type: vm.selectedType.name,
                                policy: thePolicy.url,
                                status: 5,
                                init_date: new Date(
                                  toDate(vm.form.start_of_validity)
                                ),
                                end_date: new Date(
                                  toDate(vm.form.end_of_validity)
                                ),
                                id_policy_original: vm.policy.url,
                                description: vm.form.description.label,
                                other_desc: vm.form.others
                                  ? vm.form.others
                                  : "",
                                observations: vm.form.observations,
                              };

                              endorsementService
                                .createLifeEndorsement(endorsement)
                                .then(function (lifeEndoRes) {
                                  if (lifeEndoRes.status == 201) {
                                    if ($scope.countFile > 0) {
                                      uploadFiles(lifeEndoRes.data.id, 1);
                                    } else {
                                      endorsementDone(value, lifeEndoRes.data);
                                    }
                                  }
                                });
                            });
                        });
                    }
                    var params = {
                      model: 1,
                      event: "POST",
                      associated_id: vm.policy.id,
                      identifier:
                        "creó un endoso tipo " +
                        vm.selectedType.name +
                        " con concepto " +
                        vm.form.description.label,
                    };
                    dataFactory.post("send-log", params);
                  });

                vm.defaults.createEndorsementButtonDisabled = true;

                // TODO: guardar los recibos
                if (vm.selectedType.name == "A") {
                  if (vm.form.recibos_poliza) {
                    //   var success_receipts = 0;

                    vm.form.recibos_poliza.forEach(function (
                      receipt,
                      receipt_index
                    ) {
                      if (receipt.fecha_inicio) {
                        // receipt.fecha_inicio = new Date(datesFactory.toDate(receipt.fecha_inicio));
                        // receipt.startDate = new Date(datesFactory.toDate(receipt.startDate));

                        receipt.fecha_inicio = new Date(receipt.fecha_inicio);
                        receipt.startDate = new Date(receipt.startDate);
                      }
                      if (receipt.fecha_fin) {
                        // receipt.fecha_fin = new Date(datesFactory.toDate(receipt.fecha_fin));
                        // receipt.endingDate = new Date(datesFactory.toDate(receipt.endingDate));
                        receipt.fecha_fin = new Date(receipt.fecha_fin);
                        receipt.endingDate = new Date(receipt.endingDate);
                      }
                      if (receipt.vencimiento) {
                        receipt.vencimiento = new Date(receipt.vencimiento);
                        // receipt.vencimiento = new Date(datesFactory.toDate(receipt.vencimiento));
                      }

                      //     if(endoso.description == 'CAMBIO DE FORMA DE PAGO') {
                      receipt.receipt_type = 2;
                      //     }

                      receipt.poliza = vm.policy.url;
                      // if(vmm.endorsement.policy.ramo.ramo_code == 1){
                      //   receipt.endorsement_life = aux_endo;
                      // } else if(vmm.endorsement.policy.ramo.ramo_code == 2){
                      //   receipt.endorsement_disease = aux_endo;
                      // } else if(vmm.endorsement.policy.ramo.ramo_code == 3){
                      //   if(vmm.endorsement.policy.subramo.subramo_code == 9){
                      //     receipt.endorsement_auto = aux_endo;
                      //   } else {
                      //     receipt.endorsement_damage = aux_endo;
                      //   }
                      // }

                      dataFactory
                        .post("recibos/", receipt)
                        .then(function (req) {
                          // console.log('AAAAAAAAAAAAAAAAAAA');
                          if (req.status == 200 || req.status == 201) {
                            // success_receipts += 1;
                          }
                        });
                    });
                  }
                }
              }
            });
        }
      },
      changeTab: function (param) {
        if (param === 1) {
          return (vm.options.primaryTab = true);
        } else {
          return (vm.options.primaryTab = false);
        }
      },
      // Receipt tabview
      calculateReceipt: function () {
        var receipt = {
          derecho: Number(vm.defaults.receipt.derecho),
          primaNeta: Number(vm.defaults.receipt.primaNeta),
          rpf: Number(vm.defaults.receipt.rpf),
          subTotal: Number(vm.defaults.receipt.subTotal),
          primaTotal: Number(vm.defaults.receipt.primaTotal),
        };

        vm.defaults.receipt.subTotal = receipt.subTotal = Number(
          (receipt.primaNeta + receipt.rpf + receipt.derecho).toFixed(2)
        );
        vm.defaults.receipt.primaTotal = receipt.primaTotal =
          receipt.subTotal * 1.16;
        /* Receipt values, new payform, policy */
        vm.receipts = helpers.calculateReceiptsValue(
          vm.defaults,
          vm.form.payment.value,
          vm.policy
        );
      },
    };

    activate();
    function activar() {
      activate();
    }

    function Exist(list, obj) {
      for (var i = 0; i < list.length; i++) {
        if (obj.value == list[i].value) {
          return true;
        }
      }
      return false;
    }

    function activate() {
      vm.defaults.insurancesIds = [];
      vm.contractorData = true;
      vm.selectedType = null;
      vm.showUploader = false;
      vm.showCoverages = false;
      vm.selectTypeStatus = true;
    }

    function fillData(type) {
      vm.cambioPago = false;
      vm.selectTypeStatus = true;
      if (type) {
        vm.showUploader = true;
        vm.showCoverages = true;
      } else {
        vm.showUploader = false;
        vm.showCoverages = false;
        return;
      }

      // manage Disabled
      if (type.id == 1) {
        // tipo A
        disableA();
        vm.defaults.descriptions = [
          {
            val: 1,
            label: "CAMBIO DE FORMA DE PAGO",
          },
          {
            val: 2,
            label: "CAMBIO DE SUMA ASEGURADA",
          },
          {
            val: 3,
            label: "CAMBIO DE DEDUCIBLE Y/O COASEGURO",
          },
          {
            val: 4,
            label: "AGREGAR ASEGURADO",
          },
          {
            val: 5,
            label: "AGREGAR COBERTURAS",
          },
          {
            val: 6,
            label: "DECLARACIÓN MENSUAL",
          },
          {
            val: 7,
            label: "OTRO",
          },
        ];
      } else if (type.id == 2) {
        // tipo B
        $scope.flagB1 = true;
        disableB();
        vm.defaults.descriptions = [
          {
            val: 8,
            label: "CAMBIO DATOS FISCALES",
          },
          {
            val: 9,
            label: "ESPECIFICACIONES",
          },
          {
            val: 10,
            label: "OTRO",
          },
        ];
      } else if (type.id == 3) {
        // tipo D
        disableA();
        vm.defaults.descriptions = [
          {
            val: 11,
            label: "CAMBIO DE FORMA DE PAGO",
          },
          {
            val: 12,
            label: "DISMINUCIÓN EN LA SUMA ASEGURADA",
          },
          {
            val: 13,
            label: "BAJA DE COBERTURA",
          },
          {
            val: 14,
            label: "CAMBIO DE DEDUCIBLE Y/O COASEGURO",
          },
          {
            val: 15,
            label: "BAJA DE ASEGURADO",
          },
          {
            val: 16,
            label: "CANCELACIÓN DE PÓLIZA POR PETICIÓN",
          },
          {
            val: 17,
            label: "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO",
          },
          {
            val: 18,
            label: "OTRO",
          },
        ];
      } else {
        disabledDefaults();
      }

      $scope.coveragePackage(vm.policy.paquete);
      // ngChange -> Tipo de endoso
      if (vm.selectedType.name === vm.types[0].name) {
        vm.contractorData = true;
      } else if (vm.selectedType.name === vm.types[1].name) {
        vm.contractor = vm.policy.contractor;
        vm.contractorData = false;
      } else if (vm.selectedType.name === vm.types[2].name) {
        vm.coverages = vm.policy.coverageInPolicy_policy;
        vm.contractorData = true;
      } else if (vm.selectedType.name === vm.types[3].name) {
        vm.contractorData = true;
      } else {
        toaster.info("Favor de seleccionar un tipo de endoso.");
      }
    }

    var sumInPolicy = {
      label: "",
      value: "",
    };
    var deductibleInPolicy = {
      label: "",
      value: "",
    };
    $scope.coveragePackage = function (param) {
      vm.defaults.coverages = [];
      vm.defaults.coverageList = [];
      vm.defaults.coverages = vm.policy.coverageInPolicy_policy;
      for (var i = 0; i < vm.defaults.coverages.length; i++) {
        sumInPolicy = {
          label: vm.defaults.coverages[i].sum_insured,
          value: vm.defaults.coverages[i].sum_insured,
        };
        deductibleInPolicy = {
          label: vm.defaults.coverages[i].deductible,
          value: vm.defaults.coverages[i].deductible,
        };
        vm.defaults.coverages[i].sumInPolicy = sumInPolicy;
        vm.defaults.coverages[i].deductibleInPolicy = deductibleInPolicy;
      }

      param.coverage_package.forEach(function (element, index) {
        vm.defaults.coverageList.push(angular.copy(element));
      });

      var arrayCoverages = angular.copy(vm.defaults.coverageList);

      for (var i = 0; i < arrayCoverages.length; i++) {
        for (var j = 0; j < vm.defaults.coverages.length; j++) {
          if (
            arrayCoverages[i].coverage_name ==
            vm.defaults.coverages[j].coverage_name
          ) {
            vm.defaults.coverageList.splice(
              vm.defaults.coverageList.indexOf(vm.defaults.coverages[j]),
              1
            );
          }
        }
      }
    };

    $scope.demo = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    function changePackage(newValue, old) {
      var oldValue = old ? JSON.parse(old) : "";
      swal(
        {
          title: "¿Esta seguro?",
          text: "Si cambia de paquete sus coberturas seran eliminadas",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "No, cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
          } else {
            vm.packages.some(function (pqt) {
              if (pqt.id == oldValue.id) {
                vm.selectPackage = pqt;
                return true;
              }
            });
          }
        }
      );
    }

    $scope.$watch(
      "vm.contractors.contractorNew",
      function (newValue, oldValue) {
        $scope.direccion_contratante = [];
        try {
          if (vm.contractors.contractorNew.address_contractor) {
            $scope.direccion_contratante =
              vm.contractors.contractorNew.address_contractor;
            vm.policy.contractor = vm.contractors.contractorNew;
          }
          $scope.contractorNew = vm.contractors.contractorNew.full_name
            ? vm.contractors.contractorNew.full_name
            : vm.contractors.contractorNew.first_name +
              " " +
              vm.contractors.contractorNew.last_name;
          try {
            if ($scope.direccion_contratante.length == 1) {
              $scope.direccion_endoso = $scope.direccion_contratante[0];
            }
          } catch (exception) {}
        } catch (exception) {}
      }
    );

    function endorsementDone(value, endoso) {
      if (value == 1) {
        SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
        if (endoso.policy_type == 1) {
          $state.go("endosos.pendingData", {
            endorsementId: endoso.id,
            endorsementType: vm.checkEndorsementType(endoso),
            polizaId: endoso.policy.id,
          });
        } else if (endoso.policy_type == 2) {
          if (endoso.endorsement_type == "D") {
            if (endoso.policy.subramo == 1) var type = "life";
            else if (endoso.policy.subramo == 3) var type = "disease";
            else var type = "automobile";
          }
          $state.go("endosos.pendingDataMassive", {
            endorsementId: endoso.id,
            endorsementType: vm.checkEndorsementType(endoso)
              ? vm.checkEndorsementType(endoso)
              : type,
            polizaId: endoso.policy.id,
          });
        }
      } else if (value == 2) {
        $scope.registerEndorsement(endoso);
      }

      $scope.data_endorsement = [];
      if ($scope.cancel_policy) {
        if (value == 2) {
          $scope.data_endorsement.identifier =
            "canceló la póliza por endoso tipo D y se registro el endoso";
        } else {
          $scope.data_endorsement.identifier =
            "canceló la póliza por endoso tipo D";
        }
        $scope.data_endorsement.associated = vm.policy.id;
      } else {
        if (value == 2) {
          $scope.data_endorsement.identifier = "creó el endoso y se registró";
        } else {
          $scope.data_endorsement.identifier = "creó el endoso";
        }
        $scope.data_endorsement.associated = endoso.id;
      }

      var params = {
        model: 10,
        event: "POST",
        associated_id: $scope.data_endorsement.associated,
        identifier: $scope.data_endorsement.identifier,
      };
      dataFactory.post("send-log/", params).then(function success(response) {
        $scope.cancel_policy = false;
      });
    }

    vm.checkEndorsementType = function checkType(obj) {
      if (obj.automobile) return "automobile";
      else if (obj.life) return "life";
      else if (obj.damage) return "damage";
      else if (obj.disease) {
        return "disease";
      }
    };

    function assingValue(value) {
      $scope.objectPolicy = JSON.parse(value);
      vm.poliza_number_data = { val: $scope.objectPolicy.label };
    }

    function getPolicy(parId, value) {
      // console.log('parId',parId)
      if (!id) {
        toaster.warning("Ingrese un número de póliza");
        vm.loading = false;
        return;
      } else {
        vm.loading = true;
        vm.selectedType = vm.types[0];
        vm.selectTypeStatus = true;
        vm.form = {
          type: "INDIVIDUAL",
        };
        vm.form.description = "";

        setTimeout(function () {
          $http({
            method: "GET",
            url: url.IP + "get-policy-endorsement/",
            params: {
              id: parId.id,
            },
          }).then(function success(response) {
            if (!helpers.isResponseOk(response.status)) {
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORSEARCHPOLICY,
                "error"
              );
              vm.loading = false;
              return;
            }

            vm.policy = response.data.results[0];
            if (vm.policy.contractor) {
              $scope.direccion_contratante = [];
              vm.contractor = vm.policy.contractor;
              vm.contractor.name = vm.policy.contractor.full_name;
              vm.contractor.rfc = vm.policy.contractor.rfc;
              vm.contractor.address_contractor.forEach(function (address) {
                var direc =
                  address.route +
                  " " +
                  address.street_number +
                  ", " +
                  address.street_number_int +
                  " " +
                  address.administrative_area_level_2 +
                  ", " +
                  address.administrative_area_level_1;
                $scope.direccion_contratante.push(direc);
              });
            }
            vm.coverages = vm.policy.coverageInPolicy_policy;

            vm.defaults.coverages = vm.policy.coverageInPolicy_policy;

            vm.defaults.coverageList = angular.copy(
              vm.policy.paquete.coverage_package
            );

            $http
              .post(url.IP + "paquetes-by-subramo/", {
                ramo: vm.policy.ramo.id,
                subramo: vm.policy.subramo.id,
                provider: vm.policy.aseguradora.id,
              })
              .then(function (paquetes) {
                vm.packages = paquetes.data;
              });

            vm.subforms = {};
            if (vm.policy.accidents_policy.length) {
              vm.certs = vm.policy.accidents_policy[0];
              vm.certs.relationshipList =
                vm.policy.accidents_policy[0].relationship_accident;
              vm.certs.show = 0;
              vm.subforms = vm.certs;
              for (var i = 0; i < vm.subforms.relationshipList.length; i++) {
                if (vm.subforms.relationshipList[i].sex == "M") {
                  vm.subforms.relationshipList[i].sex = vm.defaults.sex[0];
                } else {
                  vm.subforms.relationshipList[i].sex = vm.defaults.sex[1];
                }
                if (vm.subforms.relationshipList[i].relationship == 1) {
                  vm.subforms.relationshipList[i].relationship =
                    vm.options.disease.types[0];
                } else if (vm.subforms.relationshipList[i].relationship == 2) {
                  vm.subforms.relationshipList[i].relationship =
                    vm.options.disease.types[1];
                } else if (vm.subforms.relationshipList[i].relationship == 3) {
                  vm.subforms.relationshipList[i].relationship =
                    vm.options.disease.types[2];
                } else {
                  vm.subforms.relationshipList[i].relationship =
                    vm.options.disease.types[3];
                }
                vm.subforms.relationshipList[i].birthdate = convertDate(
                  vm.subforms.relationshipList[i].birthdate
                );
              }
            } else if (vm.policy.automobiles_policy.length) {
              vm.certs = vm.policy.automobiles_policy[0];
              vm.certs.show = 1;
              vm.subforms = vm.certs;
            } else if (vm.policy.life_policy.length) {
              vm.certs = vm.policy.life_policy[0];
              vm.certs.show = 3;
              vm.subforms = vm.certs;
              //vm.subforms.life = vm.policy.life_policy[0];
              //vm.subforms.show = 3;
            } else if (vm.policy.damages_policy.length) {
              vm.certs = vm.policy.damages_policy[0];
              vm.certs.show = 2;
              vm.subforms = vm.certs;
            }

            vm.form.end_of_validity = convertDate(
              angular.copy(vm.policy.end_of_validity)
            );
            vm.form.start_of_validity = convertDate(new Date());
            vm.limit = {
              start: angular.copy(vm.form.start_of_validity),
              end: angular.copy(vm.form.end_of_validity),
            };

            var sub = 0;
            var ttl = 0;
            var prn = 0;
            var rpf = 0;
            var der = 0;
            var data = {};
            vm.receipts = [];
            var sortedReceipts = vm.policy.recibos_poliza.sort();
            sortedReceipts.forEach(function (recibo) {
              var receipt = {
                poliza: vm.policy.url,
                recibo_numero: recibo.recibo_numero,
                rpf: recibo.rpf,
                derecho: recibo.derecho,
                iva: recibo.iva,
                prima: recibo.prima_neta,
                subTotal: recibo.sub_total,
                total: recibo.prima_total,
                status: recibo.status,
                startDate: recibo.fecha_inicio,
                endingDate: recibo.fecha_fin,
                description: recibo.description,
                endorsement_auto: null,
                endorsement_damage: null,
              };

              prn += parseFloat(receipt.prima);
              sub += parseFloat(receipt.subTotal);
              ttl += parseFloat(receipt.total);
              rpf += parseFloat(receipt.rpf);
              der += parseFloat(receipt.derecho);

              vm.receipts.push(receipt);
              vm.receipts = _.sortBy(vm.receipts, "recibo_numero");
              vm.defaults.receipt.subTotal = sub;
              vm.defaults.receipt.primaTotal = ttl;
              vm.defaults.receipt.primaNeta = prn;

              vm.defaults.receipt.rpf = rpf;
              vm.defaults.receipt.derecho = der;
              vm.defaults.receipt.iva = vm.receipts[0].iva;
            });

            toaster.success("Póliza existente");
            if (value) {
              vm.selectTypeStatus = false;
            } else {
              vm.options.fillData({ id: 3, name: "D" });
              vm.form.description = vm.defaults.descriptions[5];
              vm.selectTypeStatus = true;
            }
            vm.loading = false;
          });
        }, 100);
      }
    }

    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = 0;
      if (parWord) {
        var word_data = vm.form.contratante.val;
        if (word_data) {
          if (word_data.length >= 3) {
            $http
              .post(url.IP + "contractors-match/", {
                matchWord: parWord,
              })
              .then(function (response) {
                if (response.status === 200) {
                  var source = [];
                  var juridicals = response.data.juridicals;
                  var contratactorsFound = response.data.contractors;
                  if (contratactorsFound.length) {
                    contratactorsFound.forEach(function (item) {
                      if (item.full_name) {
                        var obj = {
                          label: item.full_name,
                          value: item,
                        };
                      } else {
                        var obj = {
                          label:
                            item.first_name +
                            " " +
                            item.last_name +
                            " " +
                            item.second_last_name,
                          value: item,
                        };
                      }
                      source.push(obj);
                    });
                  }
                  $scope.contractors_data = source;
                }
              });
          }
        } else {
          $scope.contractors_data.length = 0;
        }
      }
    };

    $scope.findContractor = function (parValue) {
      if (parValue) {
        if (parValue.val.length >= 3) {
          $http({
            method: "POST",
            url: url.IP + "get-endorsements-policies/",
            data: {
              word: parValue.val,
            },
          })
            .then(
              function success(request) {
                // console.log(request);
                var results = [];
                results = _.map(request.data, function (item) {
                  if (item.contractor) {
                    var label = item.contractor + " - " + item.poliza_number;
                  } else {
                    var label = " - " + item.poliza_number;
                  }
                  return {
                    label: label,
                    value: item.poliza_number,
                    id: item.id,
                  };
                });
                $scope.autocompleteData = results;
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };

    vm.myInsuranceDate = $stateParams;
    if ($stateParams.contractor.type_person) {
      $http({
        method: "POST",
        url: url.IP + "get-endorsements-policies/",
        data: {
          word: $stateParams.myInsurance.poliza_number,
        },
      })
        .then(
          function success(request) {
            if (request.status == 200) {
              if (request.data[0].contractor) {
                for (var i = 0; i < request.data.length; i++) {
                  if (
                    $stateParams.contractor.full_name ==
                    request.data[i].contractor
                  ) {
                    var parId = {
                      id: request.data[i].id,
                      val:
                        request.data[i].contractor +
                        " - " +
                        request.data[i].poliza_number,
                      value: request.data[i].poliza_number,
                    };
                  }
                }
              }
              vm.poliza_number_data = {
                id: parId.id,
                val: parId.val,
                value: parId.value,
              };
              vm.options.getPolicy(parId, false);
              vm.selectedType = vm.types[3];
              $scope.cancel_policy = true;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log("e", e);
        });
    }

    function cancel() {
      $state.go("endosos.pending");
      if ($rootScope.modalInstanceEndosos) {
        $rootScope.modalInstanceEndosos.dismiss("cancel");
      }
    }

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
        $state.go("endosos.pending");
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      l.stop();
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId, type_endoso) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP +
        "endosos/" +
        endorsementId +
        "/archivos/?type_endoso=" +
        type_endoso;

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    /*--------------*/

    vm.num_receipts_data = [
      { name: 1, value: 12 },
      { name: 2, value: 6 },
      { name: 4, value: 3 },
      { name: 6, value: 2 },
      { name: 12, value: 1 },
    ];

    vm.f_currency = {};
    vm.f_currency.f_currency_selected = 1;
    vm.f_currency.options = [
      { value: 1, label: "PESOS" },
      { value: 2, label: "DOLARES" },
    ];

    $scope.dataPayform = [
      { value: 1, name: "MENSUAL" },
      { value: 2, name: "BIMESTRAL" },
      { value: 3, name: "TRIMESTRAL" },
      { value: 5, name: "CONTADO" },
      { value: 6, name: "SEMESTRAL" },
      { value: 12, name: "ANUAL" },
    ];

    $scope.creditNotes = {
      fecha_emision: convertDate(new Date()),
      gastos_expedicion: "",
      f_currency: 1,
      folio: "",
      iva: 0.0,
      policy: null,
      payform: 12,
      prima_neta: "",
      sub_total: 0.0,
      prima_total: 0.0,
      rpf: 0.0,
      life_endorsement: null,
      disease_endorsement: null,
      damages_endorsement: null,
      auto_endorsement: null,
    };

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    $scope.updateFieldD = function () {
      var prima_neta = parseFloat($scope.creditNotes.prima_neta);
      var rpf =
        prima_neta * parseFloat($scope.creditNotes.rpf_percentage * 0.01);
      var gastos_expedicion = parseFloat($scope.creditNotes.gastos_expedicion);
      var iva =
        (prima_neta + rpf + gastos_expedicion) *
        parseFloat($scope.creditNotes.iva_percentage * 0.01);

      $scope.creditNotes.prima_neta = prima_neta;
      $scope.creditNotes.gastos_expedicion = gastos_expedicion;
      $scope.creditNotes.rpf = rpf.toFixed(2);
      $scope.creditNotes.iva = iva.toFixed(2);
      $scope.creditNotes.sub_total = (
        prima_neta +
        rpf +
        gastos_expedicion
      ).toFixed(2);
      $scope.creditNotes.prima_total = (
        prima_neta +
        rpf +
        iva +
        gastos_expedicion
      ).toFixed(2);
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
      return dateObject;
    }

    $scope.registerEndorsement = function (endoso) {
      var vmm = this;
      endoso.policy = vm.policy;

      if (endoso.policy.recibos_poliza) {
        $scope.endorsementNew = endoso.policy.recibos_poliza;
      } else {
        $scope.endorsementNew = [];
      }

      if (endoso.endorsement_type == "A") {
        endoso.policy.recibos_poliza = $scope.endorsementNew;
      }

      if (endoso.endorsement_type == "D") {
        $scope.creditNotes.policy = angular.copy(endoso.policy.id);
        $scope.creditNotes.fecha_emision = toDate(
          $scope.creditNotes.fecha_emision
        );
        $scope.creditNotes.payform = $scope.creditNotes.payform.value;
        if (endoso.life) {
          $scope.creditNotes.life_endorsement = endoso.id;
        } else if (endoso.disease) {
          $scope.creditNotes.disease_endorsement = endoso.id;
        } else if (endoso.damage) {
          $scope.creditNotes.damages_endorsement = endoso.id;
        } else if (endoso.automobile) {
          $scope.creditNotes.auto_endorsement = endoso.id;
        }
        $http
          .post(url.IP + "nota-credito/", $scope.creditNotes)
          .then(
            function success(request) {
              var params = {
                model: 19,
                event: "POST",
                associated_id: request.data.id,
                identifier: "creó la nota de crédito",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            },
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }

      $scope.recibos_data = angular.copy($scope.endorsementNew);
      endoso.policy.recibos_poliza.forEach(function (receipt, index) {
        endoso.policy.recibos_poliza[index] = receipt.url;
      });

      var policy = angular.copy(vm.policy);
      endoso.status = 2;
      endoso.automobile = endoso.automobile
        ? angular.copy(endoso.automobile.url)
        : undefined;
      endoso.damage = endoso.damage
        ? angular.copy(endoso.damage.url)
        : undefined;
      endoso.life = endoso.life ? angular.copy(endoso.life.url) : undefined;
      endoso.disease = endoso.disease
        ? angular.copy(endoso.disease.url)
        : undefined;
      endoso.policy = angular.copy(endoso.policy.url);
      endoso.folio_endorsement = vm.form.folio;
      endoso.number_endorsement = vm.number_endorsement;
      policy.clave = policy.clave.url;

      providerService
        .getProviderById(vm.policy.aseguradora.id)
        .then(function (providerResponse) {
          policy.aseguradora = providerResponse.url;

          ramoService.getRamoById(policy.ramo.id).then(function (ramoResponse) {
            policy.ramo = ramoResponse.url;

            ramoService
              .getSubramoById(policy.subramo.id)
              .then(function (subramoResponse) {
                policy.subramo = subramoResponse.url;

                packageService
                  .getPackageById(policy.paquete.id)
                  .then(function (paqueteResponse) {
                    policy.paquete = paqueteResponse.url;

                    endorsementService
                      .updateEndorsement(endoso)
                      .then(function (res) {
                        var getPolicy = {
                          req: endoso.policy,
                          endo: vm.policy.url,
                        };

                        insuranceService
                          .getPolicyAndEndorsement(getPolicy)
                          .then(function (response) {
                            if (
                              endoso.description ==
                                "CANCELACIÓN DE PÓLIZA POR PETICIÓN" ||
                              endoso.description ==
                                "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO"
                            ) {
                              for (
                                var i = 0;
                                i < response.original.recibos_poliza.length;
                                i++
                              ) {
                                $http.patch(
                                  response.original.recibos_poliza[i],
                                  { status: 2 }
                                );
                              }
                              $http.patch(vm.policy.id, { status: 11 });
                            } else {
                              var aux_endo = response.endorsement.url;
                              var aux_orig = response.original.url;

                              response.original.coverageInPolicy_policy.forEach(
                                function (cob) {
                                  cob.policy = aux_endo;
                                }
                              );

                              response.endorsement.coverageInPolicy_policy.forEach(
                                function (cob) {
                                  cob.policy = aux_orig;
                                }
                              );

                              var data = {
                                document_type: 1,
                              };

                              var data_or = {
                                document_type: 2,
                              };

                              $http.patch(response.endorsement.url, data);
                              $http.patch(response.original.url, data_or);

                              insuranceService.copyInsuranceData(
                                response.endorsement.id,
                                response.original.id,
                                endoso.description
                              );

                              response.endorsement.recibos_poliza.forEach(
                                function (receipt_end) {
                                  if (
                                    endoso.description ==
                                    "CAMBIO DE FORMA DE PAGO"
                                  ) {
                                    $http.delete(receipt_end.url);
                                  }
                                }
                              );

                              response.original.recibos_poliza.forEach(
                                function (receipt_orn) {
                                  if (
                                    endoso.description ==
                                    "CAMBIO DE FORMA DE PAGO"
                                  ) {
                                    if (receipt_orn.url) {
                                      $http.delete(receipt_orn.url);
                                    } else {
                                      $http.delete(receipt_orn);
                                    }
                                  }
                                }
                              );

                              if (endoso.endorsement_type == "A") {
                                if (vm.form.recibos_poliza) {
                                  var success_receipts = 0;

                                  vm.form.recibos_poliza.forEach(function (
                                    receipt,
                                    receipt_index
                                  ) {
                                    console.log("receipt", receipt);
                                    // console.log('receipt');
                                    if (receipt.fecha_inicio) {
                                      // receipt.fecha_inicio = new Date(datesFactory.toDate(receipt.fecha_inicio));
                                      // receipt.startDate = new Date(datesFactory.toDate(receipt.startDate));
                                      receipt.fecha_inicio = new Date(
                                        receipt.fecha_inicio
                                      );
                                      receipt.startDate = new Date(
                                        receipt.startDate
                                      );
                                    }
                                    if (receipt.fecha_fin) {
                                      // receipt.fecha_fin = new Date(datesFactory.toDate(receipt.fecha_fin));
                                      // receipt.endingDate = new Date(datesFactory.toDate(receipt.endingDate));
                                      receipt.fecha_fin = new Date(
                                        receipt.fecha_fin
                                      );
                                      receipt.endingDate = new Date(
                                        receipt.endingDate
                                      );
                                    }
                                    if (receipt.vencimiento) {
                                      // receipt.vencimiento = new Date(datesFactory.toDate(receipt.vencimiento));
                                      receipt.vencimiento = new Date(
                                        receipt.vencimiento
                                      );
                                    }

                                    if (
                                      endoso.description ==
                                      "CAMBIO DE FORMA DE PAGO"
                                    ) {
                                      receipt.receipt_type = 1;
                                    }

                                    receipt.poliza = response.endorsement.url;

                                    // if(ramoResponse.data.ramo_code == 1){
                                    //   receipt.endorsement_life = vm.endorsement.url;
                                    // } else if(ramoResponse.data.ramo_code == 2){
                                    //   receipt.endorsement_disease = vm.endorsement.url;
                                    // } else if(ramoResponse.data.ramo_code == 3){
                                    //   if(subramoResponse.data.subramo_code == 9){
                                    //     receipt.endorsement_auto = vm.endorsement.url;
                                    //   } else {
                                    //     receipt.endorsement_damage = vm.endorsement.url;
                                    //   }
                                    // }

                                    dataFactory
                                      .post("recibos/", receipt)
                                      .then(function (req) {
                                        console.log("receipt - ok", req);
                                        if (
                                          req.status == 200 ||
                                          req.status == 201
                                        ) {
                                          success_receipts += 1;
                                        }
                                      });
                                  });
                                }
                              }
                            }
                          });
                        SweetAlert.swal(
                          "¡Listo!",
                          MESSAGES.OK.NEWENDORSEMENT,
                          "success"
                        );
                        $state.go("endosos.pending");
                      });
                  });
              });
          });
        });
    };
    /*--------------*/
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndososCollectivityCtrl", EndososCollectivityCtrl);

  EndososCollectivityCtrl.$inject = [
    "MESSAGES",
    "SweetAlert",
    "$scope",
    "$rootScope",
    "$http",
    "url",
    "toaster",
    "$state",
    "FileUploader",
    "$timeout",
    "$stateParams",
    "$sessionStorage",
    "endorsementService",
    "dataFactory",
  ];

  function EndososCollectivityCtrl(
    MESSAGES,
    SweetAlert,
    $scope,
    $rootScope,
    $http,
    url,
    toaster,
    $state,
    FileUploader,
    $timeout,
    $stateParams,
    $sessionStorage,
    endorsementService,
    dataFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = (vm2 = this);
    vm.massive = massive;

    $scope.inputFileDisabled = true;
    $scope.endorsementLoad = [];

    $scope.valueRadio = function (val) {
      $scope.inputFileDisabled = false;
      if (val == "altas") {
        $scope.is_register = true;
      } else {
        $scope.is_register = false;
      }
    };

    $scope.selectExcel = function (parData) {
      vm.word = "";
      vm.certificate = "";
      vm.typeForm = "masivoEndorsement";
      $scope.certs_json = certStructure(parData);
      treeStructure($scope.dataToShow);
    };

    function massive() {
      if ($scope.is_register) {
        var parUrl = url.IP + "massive-endorsements-altas/";
      } else {
        var parUrl = url.IP + "massive-endorsements-bajas/";
      }
      // console.log('certs_json___',$scope.certs_json,parUrl)
      $http({
        method: "POST",
        url: parUrl,
        data: $scope.certs_json,
      }).then(function success(response) {
        // console.log('response__',response)
        var params = {
          model: 10,
          event: "POST",
          associated_id: response.data.id,
          identifier: "creó el endoso colectivos",
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});

        if (response.status == 200 || response.status == 201) {
          var value = 1;
        } else {
          var value = 2;
        }
        endorsementDone(value, response.data.data);
        $scope.endorsementLoad = response.data.data;
      });
    }

    function endorsementDone(value, endoso) {
      if (value == 1) {
        if ($scope.countFile > 0) {
          if (endoso.life != null) {
            uploadFiles(endoso.id, 1);
          } else if (endoso.damage != null) {
            uploadFiles(endoso.id, 2);
          } else if (endoso.disease != null) {
            uploadFiles(endoso.id, 3);
          } else if (endoso.automobile == null) {
            uploadFiles(endoso.id, 4);
          }
        } else {
          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
          if (endoso.policy_type == 1) {
            $state.go("endosos.pendingData", {
              endorsementId: endoso.id,
              endorsementType: $scope.checkEndorsementType(endoso),
              polizaId: endoso.policy.id,
            });
          } else if (endoso.policy_type == 2) {
            if (endoso.endorsement_type == "D") {
              if (endoso.policy.subramo == 1) var type = "life";
              else if (endoso.policy.subramo == 3) var type = "disease";
              else var type = "automobile";
            }
            $state.go("endosos.pendingDataMassive", {
              endorsementId: endoso.id,
              endorsementType: $scope.checkEndorsementType(endoso)
                ? $scope.checkEndorsementType(endoso)
                : type,
              polizaId: endoso.policy.id,
            });
          }
        }
      } else {
        SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
      }
    }

    $scope.checkEndorsementType = function checkType(obj) {
      if (obj.automobile) return "automobile";
      else if (obj.life) return "life";
      else if (obj.damage) return "damage";
      else if (obj.disease) {
        return "disease";
      }
    };

    function certStructure(parData) {
      var strcuture_data = [];
      $scope.dataToShow = [];
      for (var key in parData) {
        var data = parData[key];
        if (data.length) {
          data.forEach(function (item) {
            // if(item.CERTIFICADO){
            if (item.SEXO) {
              var itemtoShow = angular.copy(item);
              $scope.dataToShow.push(itemtoShow);
              item.FEC_NAC = toDate(item.FEC_NAC);
              strcuture_data.push(item);
            } else if (item.INCISO) {
              var itemtoShow = angular.copy(item);
              $scope.dataToShow.push(itemtoShow);
              item.FEC_MOVIMIENTO = toDate(item.FEC_MOVIMIENTO);
              strcuture_data.push(item);
            } else if (item.MARCA || item.MATRICULA || item.SERIAL) {
              var itemtoShow = angular.copy(item);
              $scope.dataToShow.push(itemtoShow);
              item.FEC_MOVIMIENTO = toDate(item.FEC_MOVIMIENTO);
              strcuture_data.push(item);
            }
          });
        }
      }
      // console.log('strcuture_data___',strcuture_data)
      return strcuture_data;
    }

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
      return dateObject;
    }

    function treeStructure(parJson) {
      var tree = [];
      parJson.forEach(function (item) {
        if (!item.CERTIFICADO) {
          item.CERTIFICADO = "Sin # certificado";
        }
        if (!item.INCISO) {
          item.CERTIFICADO = "Sin # certificado";
          item.INCISO = "Sin # certificado";
        } else {
          item.CERTIFICADO = item.INCISO;
        }
        if (item.MARCA || item.SERIAL || item.MODELO || item.MATRICULA) {
          //AUTOS
          var parent_content =
            "<strong>Póliza: </strong> " +
            item.NUM_POLIZA +
            " - " +
            "<strong>Certificado: </strong> " +
            item.INCISO +
            " - " +
            // '<strong>Certificado: </strong> '+ item.INCISO ? item.INCISO : '' + ' - ' +
            "<strong>Marca: </strong> " +
            item.MARCA +
            " - " +
            "<strong>Modelo: </strong>" +
            item.MODELO +
            " - " +
            "<strong>Año: </strong>" +
            item.AÑO +
            " - " +
            "<strong>Color: </strong>" +
            item.COLOR +
            " - " +
            "<strong>Matricula: </strong>" +
            item.MATRICULA +
            " - " +
            "<strong>Motor: </strong>" +
            item.MOTOR +
            " - " +
            "<strong>Serial: </strong>" +
            item.SERIAL +
            " - " +
            "<strong>Email: </strong>" +
            item.EMAIL +
            " - " +
            "<strong>Fecha movimiento: </strong>" +
            item.FEC_MOVIMIENTO;
          var element = {
            text: parent_content,
          };
          tree.push(element);
        } else if (item.SMOKER) {
          //VIDA
          // console.log('cer',item['CERTIFICADO'])
          var smoker = item.SMOKER == 0 ? "No" : "Si";
          var parent_content =
            "<strong>Póliza: </strong> " +
            item.NUM_POLIZA +
            " - " +
            "<strong>Certificado: </strong> " +
            item.CERTIFICADO +
            " - " +
            // '<strong>Certificado: </strong> '+ item.CERTIFICADO ? item.CERTIFICADO  : 'Sin # certificado' +' - ' +
            "<strong>Nombre: </strong> " +
            item.NOMBRE +
            "  " +
            item.AP_PAT +
            "  " +
            item.AP_MAT +
            " - " +
            "<strong>Fecha de nacimiento: </strong>" +
            item.FEC_NAC +
            " - " +
            "<strong>Sexo: </strong>" +
            item.SEXO +
            " - " +
            "<strong>Email: </strong>" +
            item.EMAIL +
            " - " +
            "<strong>Fumador: </strong>" +
            smoker +
            " - " +
            "<strong>Fecha movimiento: </strong>" +
            item.FEC_MOVIMIENTO;
          var element = {
            text: parent_content,
          };
          tree.push(element);
        } else if (!item.SMOKER) {
          //GASTOS
          var parent_content =
            "<strong>Póliza: </strong> " +
            item.NUM_POLIZA +
            " - " +
            "<strong>Certificado: </strong> " +
            item.CERTIFICADO +
            " - " +
            // '<strong>Certificado: </strong> '+ item.CERTIFICADO ? item.CERTIFICADO : 'Sin # certificado'  + ' - ' +
            "<strong>Nombre: </strong> " +
            item.NOMBRE +
            "  " +
            item.AP_PAT +
            "  " +
            item.AP_MAT +
            " - " +
            "<strong>Fecha de nacimiento: </strong>" +
            item.FEC_NAC +
            " - " +
            "<strong>Sexo: </strong>" +
            item.SEXO +
            " - " +
            "<strong>Email: </strong>" +
            item.EMAIL +
            " - " +
            "<strong>Fecha movimiento: </strong>" +
            item.FEC_MOVIMIENTO;
          var element = {
            text: parent_content,
          };
          tree.push(element);
        }
        // else if(item.MARCA || item.SERIAL) {//AUTOS
        //   var parent_content =  '<strong>Póliza: </strong> '+ item.NUM_POLIZA + ' - ' +
        //                         '<strong>Certificado: </strong> '+ item.INCISO + ' - ' +
        //                         // '<strong>Certificado: </strong> '+ item.INCISO ? item.INCISO : '' + ' - ' +
        //                         '<strong>Marca: </strong> '+ item.MARCA + ' - ' +
        //                         '<strong>Modelo: </strong>'+item.MODELO + ' - ' +
        //                         '<strong>Año: </strong>'+item.AÑO + ' - ' +
        //                         '<strong>Color: </strong>'+item.COLOR + ' - ' +
        //                         '<strong>Matricula: </strong>'+item.MATRICULA + ' - ' +
        //                         '<strong>Motor: </strong>'+item.MOTOR + ' - ' +
        //                         '<strong>Serial: </strong>'+ item.SERIAL + ' - ' +
        //                         '<strong>Email: </strong>'+item.EMAIL + ' - ' +
        //                         '<strong>Fecha movimiento: </strong>'+item.FEC_MOVIMIENTO;
        //   var element = {
        //     text: parent_content
        //   };
        //   tree.push(element);
        // }
        // console.log('tree___',tree)
      });
      $("#endorsemented_tree").treeview({ data: tree });
    }

    $scope.btnSearchDisabled = true;

    vm.getCollet = getCollet;
    function getCollet(parId) {
      // console.log(parId);
      if (parId) {
        if (parId.val.length >= 3) {
          $http({
            method: "POST",
            url: url.IP + "get-endorsements-collect/",
            data: {
              word: parId.val,
            },
          })
            .then(
              function success(request) {
                //console.log(request);
                var results = [];
                var mapeo = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    $scope.btnSearchDisabled = true;
                    toaster.warning("Póliza no encontrada");
                  } else {
                    $scope.btnSearchDisabled = false;
                    toaster.success("Póliza existente");
                    request.data.forEach(function (poliza) {
                      if (poliza.document_type == 3) {
                        mapeo.push(poliza);
                      }
                    });
                    results = _.map(mapeo, function (item) {
                      if (item.juridical) {
                        var label = item.juridical + " - " + item.poliza_number;
                      } else {
                        var label = item.natural + " - " + item.poliza_number;
                      }
                      return {
                        label: label,
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                      };
                    });
                    $scope.autocompleteData = results;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    }

    vm.policy = [];
    vm.collect = [];
    $scope.noData = false;
    vm.selectedType = [];

    vm.getType = getType;
    function getType(collect) {
      vm.collect = collect;
      vm.selectTypeStatus = false;
      vm.typeEndoso = "";
      vm.selectedType = vm.types[0];
      vm.typeForm = "manualEndorsement";
      $scope.closeCertificate();
    }

    vm.types = [
      {
        id: 0,
        name: "Selecciona un tipo de endoso",
      },
      {
        id: 1,
        name: "A",
      },
      {
        id: 2,
        name: "B",
      },
      {
        id: 3,
        name: "D",
      },
    ];

    vm.selectedTypeStatus = false;
    vm.covers = [];
    vm.certificates = [];

    $scope.typeEndoso = function (type) {
      $scope.certificate = [];
      vm.typeEndoso = type.name;
      vm.selectTypeStatus = true;
      angular.element("input[type='file']").val(null);

      $http({
        method: "GET",
        url: url.IP + "get-caratula/" + vm.collect.id + "/",
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              vm.policy = request.data;
              if (vm.policy.natural) {
                $scope.direccion_contratante = [];
                vm.contractor = vm.policy.natural;
                vm.contractor.name =
                  vm.policy.natural.first_name +
                  " " +
                  vm.policy.natural.last_name;
                vm.contractor.type_person = vm.policy.natural.type_person;
                vm.contractor.emall = vm.policy.natural.emall;
                vm.contractor.phone_number = vm.policy.natural.phone_number;
                vm.contractor.address =
                  vm.policy.natural.address_natural[0].route +
                  " " +
                  vm.policy.natural.address_natural[0].street_number +
                  " " +
                  vm.policy.natural.address_natural[0].street_number_int +
                  " " +
                  vm.policy.natural.address_natural[0]
                    .administrative_area_level_2 +
                  ", " +
                  vm.policy.natural.address_natural[0]
                    .administrative_area_level_1;
              }
              if (vm.policy.juridical) {
                $scope.direccion_contratante = [];
                vm.contractor = vm.policy.juridical;
                vm.contractor.name = vm.policy.juridical.j_name;
                vm.contractor.type_person = vm.policy.juridical.type_person;
                vm.contractor.emall = vm.policy.juridical.emall;
                vm.contractor.phone_number = vm.policy.juridical.phone_number;
                vm.contractor.address =
                  vm.policy.juridical.address_juridical[0].route +
                  " " +
                  vm.policy.juridical.address_juridical[0].street_number +
                  " " +
                  vm.policy.juridical.address_juridical[0].street_number_int +
                  " " +
                  vm.policy.juridical.address_juridical[0]
                    .administrative_area_level_2 +
                  ", " +
                  vm.policy.juridical.address_juridical[0]
                    .administrative_area_level_1;
              }
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });

      if (
        vm.collect.document_type === 3 ||
        vm.collect.document_type === 4 ||
        vm.collect.document_type === 5
      ) {
        vm.typeForm = "manualEndorsement";
        switch (vm.collect.document_type) {
          case 3:
            vm.titleTable = "Carátula";
            break;
          case 4:
            vm.titleTable = "Subgrupo";
            break;
          case 5:
            vm.titleTable = "Categoría";
            break;
          default:
            vm.titleTable = "Endosos colectivos";
        }

        $http({
          method: "GET",
          url: url.IP + "get-endorsements-certificates/",
          params: {
            caratula: vm.collect.id,
          },
        }).then(function success(request) {
          //console.log(request);
          vm.certificates = [];
          vm.infoCertificate = request.data.results[0];
          $scope.noData = false;
          if (request.status == 200) {
            if (request.data.results.length == 0) {
              $scope.noData = true;
            }
            for (var i = 0; i < request.data.results.length; i++) {
              if (request.data.results[i].automobiles_policy) {
                request.data.results[i].automobiles_policy.forEach(function (
                  endoso
                ) {
                  if (request.data.results[i].certificado_inciso_activo) {
                    endoso.status = "REGISTRADO";
                    endoso.certificate_number =
                      request.data.results[i].certificate_number;
                    endoso.id = request.data.results[i].id;
                    vm.certificates.push(endoso);
                  }
                });
              }
              if (request.data.results[i].damages_policy) {
                request.data.results[i].damages_policy.forEach(function (
                  endoso
                ) {
                  if (request.data.results[i].certificado_inciso_activo) {
                    endoso.status = "REGISTRADO";
                    endoso.certificate_number =
                      request.data.results[i].certificate_number;
                    endoso.id = request.data.results[i].id;
                    vm.certificates.push(endoso);
                  }
                });
              }
              if (request.data.results[i].accidents_policy) {
                request.data.results[i].accidents_policy.forEach(function (
                  endoso
                ) {
                  if (request.data.results[i].certificado_inciso_activo) {
                    endoso.status = "REGISTRADO";
                    endoso.certificate_number =
                      request.data.results[i].certificate_number;
                    endoso.id = request.data.results[i].id;
                    vm.certificates.push(endoso);
                  }
                });
              }
              if (request.data.results[i].life_policy) {
                request.data.results[i].life_policy.forEach(function (endoso) {
                  if (request.data.results[i].certificado_inciso_activo) {
                    endoso.status = "REGISTRADO";
                    endoso.certificate_number =
                      request.data.results[i].certificate_number;
                    endoso.id = request.data.results[i].id;
                    vm.certificates.push(endoso);
                  }
                });
              }
            }
          }
        });
      }
    };

    $scope.search = function (cadena) {
      vm.certificates = [];
      $http({
        method: "GET",
        url: url.IP + "get-endorsement-certificates",
        params: {
          cadena: cadena,
          caratula: vm.collect.id,
        },
      }).then(function success(request) {
        for (var i = 0; i < request.data.length; i++) {
          if (request.data[i].automobiles_policy) {
            request.data[i].automobiles_policy.forEach(function (endoso) {
              if (request.data[i].certificado_inciso_activo) {
                endoso.status = "REGISTRADO";
                endoso.certificate_number = request.data[i].certificate_number;
                endoso.id = request.data[i].id;
                vm.certificates.push(endoso);
              }
            });
          }
          if (request.data[i].damages_policy) {
            request.data[i].damages_policy.forEach(function (endoso) {
              if (request.data[i].certificado_inciso_activo) {
                endoso.status = "REGISTRADO";
                endoso.certificate_number = request.data[i].certificate_number;
                endoso.id = request.data[i].id;
                vm.certificates.push(endoso);
              }
            });
          }
          if (request.data[i].accidents_policy) {
            request.data[i].accidents_policy.forEach(function (endoso) {
              if (request.data[i].certificado_inciso_activo) {
                endoso.status = "REGISTRADO";
                endoso.certificate_number = request.data[i].certificate_number;
                endoso.id = request.data[i].id;
                vm.certificates.push(endoso);
              }
            });
          }
          if (request.data[i].life_policy) {
            request.data[i].life_policy.forEach(function (endoso) {
              if (request.data[i].certificado_inciso_activo) {
                endoso.status = "REGISTRADO";
                endoso.certificate_number = request.data[i].certificate_number;
                endoso.id = request.data[i].id;
                vm.certificates.push(endoso);
              }
            });
          }
        }
      });
    };

    $scope.inputDisabledCert = true;
    $scope.inputDisabled = true;
    $scope.viewCertificate = function (certificate) {
      $scope.closeCertificate();
      vm.covers = certificate;
      $scope.showCertificate = false;
      $scope.show_form_life = true;
    };

    $scope.showCertificate = true;
    $scope.show_form_life = false;
    $scope.newEndoso = false;
    $scope.btnAddDisabled = false;
    $scope.fontColor = { color: "#676a6c" };

    $scope.addCertificate = function () {
      $scope.showCertificate = false;
      $scope.show_form_life = true;
      $scope.btnAddDisabled = true;
      $scope.inputDisabledCert = false;
      $scope.inputDisabled = false;
      $scope.comboboxDisabled = false;
      $scope.createCertificate();
      $scope.getPack(vm.policy.id);
      $scope.getChilds(vm.policy.id);
    };

    $scope.createCertificate = function () {
      if (vm.policy.ramo.ramo_code == 1) {
        //vida
        vm.covers = $scope.createNewCertificateLife();
      } else if (vm.policy.ramo.ramo_code == 2) {
        //accidentes y enfermedades
        vm.covers = $scope.createNewCertificateAccident();
      } else if (vm.policy.ramo.ramo_code == 3) {
        // daños
        vm.covers = $scope.createNewCertificateAuto();
      }
      $scope.newEndoso = true;
      $scope.fontColor = "blue-color";
    };

    $scope.createNewCertificateLife = function () {
      return {
        beneficiaries_life: [],
      };
    };

    $scope.createNewCertificateAccident = function () {
      return {
        relationship_accident: [],
      };
    };

    $scope.createNewCertificateAuto = function () {
      return {
        brand: "",
      };
    };

    vm.options = {
      life: {
        beneficiaries: {
          add: function (ben) {
            if (ben) {
              vm.covers.beneficiaries_life.push(ben);
            } else {
              var ben = {
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: null,
                sex: null,
                optional_relationship: "",
                percentage: "",
              };
              vm.covers.beneficiaries_life.push(ben);
            }
          },
          destroy: function (index) {
            vm.covers.beneficiaries_life.splice(index, 1);
          },
        },
      },
      disease: {
        relationships: {
          add: function (relacion) {
            if (relacion) {
              vm.covers.disease.relationship_accident.push(relacion);
            } else {
              var relacion = {
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: null,
                sex: null,
                relationship: null,
              };
              vm.covers.relationship_accident.push(relacion);
            }
          },
          destroy: function (index, rel) {
            vm.covers.relationship_accident.splice(index, 1);
          },
        },
      },
    };

    vm.configuration = {};

    vm.pack = [];
    $scope.getPack = function (idPolicy) {
      $http({
        method: "GET",
        url: url.IP + "caratula-pack/",
        params: {
          id: idPolicy,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              vm.pack = request.data.results;
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.getChilds = function (idPolicy) {
      $http({
        method: "GET",
        url: url.IP + "caratula-childs/" + idPolicy + "/",
      }).then(function success(request) {
        if (request.status === 200) {
          var results = request.data;
          $scope.subgroups = [];
          $scope.categories = [];
          if (results.length) {
            results.forEach(function (child) {
              if (child.document_type == 4) {
                $scope.subgroups.push(child);
                child.categories = [];
              } else if (child.document_type == 5) {
                $scope.categories.push(child);
              }
            });
            if ($scope.categories.length == 0) {
              $scope.noCategories = true;
            }
            $scope.subgroups.forEach(function (group) {
              $scope.categories.forEach(function (category) {
                if (group.url == category.parent) {
                  group.categories.push(category);
                }
              });
            });
          }
        }
      });
    };

    $scope.comboboxDisabled = false;
    $scope.selectGroup = function (obj) {
      if (obj != null) {
        if (obj.name == "Default") {
          $scope.comboboxDisabled = true;
        } else {
          $scope.comboboxDisabled = false;
        }
        $scope.group_selected = obj;
        vm.configuration.group = obj;
      }
    };

    $scope.arrayCertificates = [];
    $scope.closeCertificate = function () {
      vm.covers = [];
      $scope.showCertificate = true;
      $scope.show_form_life = false;
      $scope.newEndoso = false;
      $scope.fontColor = { color: "#676a6c" };
      $scope.btnAddDisabled = false;
      $scope.inputDisabledCert = true;
      $scope.inputDisabled = true;
      $scope.comboboxDisabled = true;
    };

    $scope.arrayCertificates = [];
    $scope.saveCertificate = function (certificate) {
      /*console.log(certificate);
      console.log(vm.configuration);
      if(certificate.brand){
        certificate.caratula = vm.policy.id;
        certificate.subgrupo = vm.configuration.group.id;
        certificate.category = vm.configuration.group.categories[0].id;
        certificate.pack = vm.configuration[0].pack.id;
        certificate.automobile = certificate;
      }
      else{
        certificate.caratula = vm.policy.id;
        certificate.subgrupo = vm.configuration.group.id;
        certificate.category = vm.configuration.group.categories[0].id;
        certificate.pack = vm.configuration.pack.id;
      }*/

      //$scope.arrayCertificates.push(certificate);
      $scope.arrayCertificates = certificate;
      //console.log($scope.arrayCertificates);
      certificate.status = "PENDIENTE";
      vm.certificates.push(certificate);
      $scope.closeCertificate();
    };

    $scope.editCertificate = function (certificate) {
      $scope.arrayCertificates = certificate;
      $scope.closeCertificate();
    };

    $scope.arrayCertificateSave = [];
    $scope.saveEndosoA = function () {
      var obj = {};
      if ($scope.arrayCertificates.beneficiaries_life) {
        obj.caratula = vm.policy.id;
        obj.subgrupo = vm.configuration.group.id;
        obj.category = vm.configuration.group.categories[0].id;
        obj.pack = vm.configuration.pack.id;
        obj.titular = $scope.arrayCertificates.personal;
        obj.beneficiaries = $scope.arrayCertificates.beneficiaries_life;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      } else if ($scope.arrayCertificates.relationship_accident) {
        obj.caratula = vm.policy.id;
        obj.subgrupo = vm.configuration.group.id;
        obj.category = vm.configuration.group.categories[0].id;
        obj.pack = vm.configuration.pack.id;
        obj.titular = $scope.arrayCertificates.personal;
        obj.relationships = $scope.arrayCertificates.relationship_accident;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      } else if ($scope.arrayCertificates.brand) {
        obj.caratula = vm.policy.id;
        obj.subgrupo = vm.configuration.group.id;
        obj.category = vm.configuration.group.categories[0].id;
        obj.pack = vm.configuration.pack.id;
        obj.automobile = $scope.arrayCertificates;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      }
      $scope.arrayCertificateSave.push(obj);

      var data = {
        certificados: $scope.arrayCertificateSave,
      };
      $http
        .post(url.IP + "added-certs/", data)
        .then(
          function success(request) {
            if (request.status === 200) {
              $scope.closeCertificate();
              toaster.success("Certificado Creado Exitosamente");
              $state.go("endosos.pending");
            } else {
              SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROR, "error");
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.showInputDisabled = function () {
      $scope.inputDisabled = false;
      $scope.comboboxDisabled = false;
      $scope.newEndoso = true;
      $scope.fontColor = "blue-color";
      $scope.getPack(vm.policy.id);
      $scope.getChilds(vm.policy.id);
    };

    $scope.arrayCertificateEdit = [];
    $scope.saveEndosoB = function () {
      var obj = {};
      if ($scope.arrayCertificates.beneficiaries_life) {
        obj.caratula = vm.policy.id;
        obj.titular = $scope.arrayCertificates.personal;
        obj.beneficiaries = $scope.arrayCertificates.beneficiaries_life;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      } else if ($scope.arrayCertificates.relationship_accident) {
        obj.caratula = vm.policy.id;
        obj.titular = $scope.arrayCertificates.personal;
        obj.relationships = $scope.arrayCertificates.relationship_accident;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      } else if ($scope.arrayCertificates.brand) {
        obj.caratula = vm.policy.id;
        obj.automobile = $scope.arrayCertificates;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      }
      $scope.arrayCertificateEdit.push(obj);

      var data = {
        certificados: $scope.arrayCertificateEdit,
      };

      $http({
        method: "POST",
        url: url.IP + "edited-certs/",
        data: data,
      })
        .then(
          function success(request) {
            //console.log(request);
            if (request.status === 200) {
              $scope.arrayCertificates = [];
              $scope.arrayCertificateSave = [];
              $scope.arrayCertificateEdit = [];
              $scope.arrayCertificateDelete = [];
              $scope.closeCertificate();
              toaster.success("Certificado se Actualizó");
              $state.go("endosos.pending");
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    var selectedCertificate = [];
    var certificate = [];

    $scope.checkCertificate = function (id) {
      var idx = selectedCertificate.indexOf(id);
      if (idx == -1) {
        selectedCertificate.push(id);
        var obj = {
          id: id,
        };
        certificate.push(obj);
      } else {
        var idx = selectedCertificate.indexOf(id);
        selectedCertificate.splice(idx, 1);
        certificate.splice(idx, 1);
      }
    };

    $scope.checkDelete = function (id) {
      return selectedCertificate.indexOf(id) > -1;
    };

    $scope.saveEndosoD = function () {
      deleteCertificate();
    };

    vm.deleteCertificate = deleteCertificate;
    function deleteCertificate() {
      $scope.arrayCertificateDelete = [];
      var obj = {};
      obj.certificados = certificate;
      obj.caratula = vm.collect.id;
      $scope.arrayCertificateDelete.push(obj);
      var data = {
        certificados: $scope.arrayCertificateDelete,
      };
      $http({
        method: "POST",
        url: url.IP + "deleted-certs/",
        data: data,
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              toaster.success("Se ha creado el endoso");
            } else {
              SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROR, "error");
            }
            $state.go("endosos.pending");
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    }

    $scope.arrayPolicy = {};
    $scope.deletePoliza = function () {
      $scope.arrayPolicy.delete_Poliza = true;
      $scope.arrayPolicy.id = vm.policy.id;
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
        if ($scope.endorsementLoad.policy_type == 1) {
          $state.go("endosos.pendingData", {
            endorsementId: $scope.endorsementLoad.id,
            endorsementType: $scope.checkEndorsementType(
              $scope.endorsementLoad
            ),
            polizaId: $scope.endorsementLoad.policy.id,
          });
        } else if ($scope.endorsementLoad.policy_type == 2) {
          if ($scope.endorsementLoad.endorsement_type == "D") {
            if ($scope.endorsementLoad.policy.subramo == 1) var type = "life";
            else if ($scope.endorsementLoad.policy.subramo == 3)
              var type = "disease";
            else var type = "automobile";
          }
          $state.go("endosos.pendingDataMassive", {
            endorsementId: $scope.endorsementLoad.id,
            endorsementType: $scope.checkEndorsementType($scope.endorsementLoad)
              ? $scope.checkEndorsementType($scope.endorsementLoad)
              : type,
            polizaId: $scope.endorsementLoad.policy.id,
          });
        }
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId, type_endoso) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP +
        "endosos/" +
        endorsementId +
        "/archivos/?type_endoso=" +
        type_endoso;

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    /*--------------*/
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndososCertificateCtrl", EndososCertificateCtrl);

  EndososCertificateCtrl.$inject = [
    "$scope",
    "$rootScope",
    "$http",
    "url",
    "$stateParams",
    "$state",
    "toaster",
    "endorsementService",
    "$location",
    "SweetAlert",
  ];

  function EndososCertificateCtrl(
    $scope,
    $rootScope,
    $http,
    url,
    $stateParams,
    $state,
    toaster,
    endorsementService,
    $location,
    SweetAlert
  ) {
    var vm = (vm2 = this);
    $scope.inputDisabled = true;
    $scope.inputDisabledCert = true;
    $scope.newEndoso = false;

    $scope.showInputDisabled = function () {
      $scope.inputDisabled = false;
      $scope.inputDisabledCert = true;
      $scope.newEndoso = true;
      $scope.fontColor = { color: "#0494d0" };
    };

    $scope.closeCertificate = function () {
      $scope.inputDisabled = true;
      $scope.newEndoso = false;
      $scope.fontColor = { color: "#676a6c" };
    };

    vm.policy = [];

    getPolicy($rootScope.userId);
    function getPolicy(parId) {
      $http({
        method: "GET",
        url: url.IP + "get-caratula/" + parId + "/",
      })
        .then(
          function success(request) {
            //console.log(request);
            if (request.status === 200) {
              vm.policy = request.data;
              if (vm.policy.contractor) {
                $scope.direccion_contratante = [];
                vm.contractor = vm.policy.contractor;
                vm.contractor.name =
                  vm.policy.contractor.first_name +
                  " " +
                  vm.policy.contractor.last_name;
                vm.contractor.address_contractor.forEach(function (address) {
                  var direc =
                    address.route +
                    " " +
                    address.street_number +
                    " " +
                    address.street_number_int +
                    " " +
                    address.administrative_area_level_2 +
                    " " +
                    address.administrative_area_level_1;
                  $scope.direccion_contratante.push(direc);
                });
              }
              $scope.inputDisabledCert = true;
              $scope.createCertificate();
              $scope.getPack(request.data.id);
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    }

    vm.covers = $stateParams.myInsurance;
    console.log(vm.covers);

    vm.pack = [];
    $scope.getPack = function (idPolicy) {
      $http({
        method: "GET",
        url: url.IP + "caratula-pack/",
        params: {
          id: idPolicy,
        },
      })
        .then(
          function success(request) {
            //console.log(request);
            if (request.status === 200) {
              vm.pack = request.data.results;
              vm.covers.pack = vm.pack[0];
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.createNewCertificateLife = function () {
      return {
        beneficiaries_life: [],
      };
    };

    $scope.createNewCertificateAccident = function () {
      return {
        relationship_accident: [],
      };
    };

    $scope.createNewCertificateAuto = function () {
      return {
        auto: [],
      };
    };

    vm.options = {
      life: {
        beneficiaries: {
          add: function (ben) {
            if (ben) {
              vm.covers.beneficiaries_life.push(ben);
            } else {
              var ben = {
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: null,
                sex: null,
                optional_relationship: "",
                percentage: "",
              };
              vm.covers.beneficiaries_life.push(ben);
            }
          },
          destroy: function (index) {
            vm.covers.beneficiaries_life.splice(index, 1);
          },
        },
      },
      disease: {
        relationships: {
          add: function (relacion) {
            if (relacion) {
              vm.covers.disease.relationship_accident.push(relacion);
            } else {
              var relacion = {
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: null,
                sex: null,
                relationship: null,
              };
              vm.covers.relationship_accident.push(relacion);
            }
          },
          destroy: function (index, rel) {
            vm.covers.relationship_accident.splice(index, 1);
          },
        },
      },
    };

    $scope.createCertificate = function () {
      var infoUrl = $location.url();
      var idUrl = infoUrl.slice(32);

      if (idUrl == "") {
        if (vm.policy.ramo.ramo_code == 1) {
          //vida
          vm.covers = $scope.createNewCertificateLife();
        } else if (vm.policy.ramo.ramo_code == 2) {
          //accidentes y enfermedades
          vm.covers = $scope.createNewCertificateAccident();
        } else if (vm.policy.ramo.ramo_code == 3) {
          // daños
          vm.covers = $scope.createNewCertificateAuto();
        }
        $scope.newEndoso = true;
        vm.covers.endorsement_type = "A";
        $scope.inputDisabled = false;
        $scope.inputDisabledCert = false;
        $scope.fontColor = { color: "#0494d0" };
      } else {
        $scope.newEndoso = false;
      }
    };

    $scope.arrayCertificateSave = [];
    $scope.saveCertificate = function (certificate) {
      //console.log(certificate);
      var obj = {};
      if (certificate.beneficiaries_life) {
        obj.caratula = vm.policy.id;
        obj.titular = certificate.personal;
        obj.beneficiaries = certificate.beneficiaries_life;
        obj.certificate_number = certificate.certificate_number;
      } else if (certificate.relationship_accident) {
        obj.caratula = vm.policy.id;
        obj.titular = certificate.personal;
        obj.relationships = certificate.relationship_accident;
        obj.certificate_number = certificate.certificate_number;
      } else if (certificate.brand) {
        obj.caratula = vm.policy.id;
        obj.automobile = certificate;
        obj.certificate_number = certificate.certificate_number;
      }
      $scope.arrayCertificateSave.push(obj);
      console.log($scope.arrayCertificateSave);

      var data = {
        certificados: $scope.arrayCertificateSave,
      };

      $http
        .post(url.IP + "added-certs/", data)
        .then(
          function success(request) {
            console.log(request);
            if (request.status === 200) {
              $state.go("endosos.collectivity");
              toaster.success("Endoso Creado Exitosamente");
            } else {
              SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROR, "error");
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.arrayCertificateEdit = [];
    $scope.editCertificate = function (certificate) {
      var obj = {};
      if (certificate.beneficiaries_life) {
        obj.caratula = vm.policy.id;
        obj.titular = certificate.personal;
        obj.beneficiaries = certificate.beneficiaries_life;
        obj.certificate_number = certificate.certificate_number;
      } else if (certificate.relationship_accident) {
        obj.caratula = vm.policy.id;
        obj.titular = certificate.personal;
        obj.relationships = certificate.relationship_accident;
        obj.certificate_number = certificate.certificate_number;
      } else if (certificate.brand) {
        obj.caratula = vm.policy.id;
        obj.automobile = certificate;
        obj.certificate_number = certificate.certificate_number;
      }
      $scope.arrayCertificateEdit.push(obj);

      var data = {
        certificados: $scope.arrayCertificateEdit,
      };

      $http({
        method: "POST",
        url: url.IP + "edited-certs/",
        data: data,
      })
        .then(
          function success(request) {
            console.log(request);
            if (request.status === 200) {
              $state.go("endosos.collectivity");
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndosoGpoController", EndosoGpoController);

  EndosoGpoController.$inject = [
    "dataFactory",
    "$scope",
    "MESSAGES",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$http",
    "$state",
    "$stateParams",
    "url",
    "$localStorage",
    "$sessionStorage",
    "$timeout",
    "$rootScope",
  ];

  function EndosoGpoController(
    dataFactory,
    $scope,
    MESSAGES,
    SweetAlert,
    FileUploader,
    datesFactory,
    $http,
    $state,
    $stateParams,
    url,
    $localStorage,
    $sessionStorage,
    $timeout,
    $rootScope
  ) {
    var order = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.certificates_selected = [];
    $scope.caratula = {};
    $scope.endorsement = {};
    $scope.newCertificate = {};
    $scope.newCertificates = [];
    $scope.subgrupos = [];
    $scope.paquetes = [];
    $scope.categoriesJson = [];
    $scope.checkRegister = false;
    $scope.directiveReceipts = [];
    $scope.dataToSave = [];

    $scope.types = [
      { id: 0, name: "Selecciona un tipo de endoso" },
      { id: 1, name: "A" },
      { id: 2, name: "B" },
      { id: 3, name: "D" },
    ];
    $scope.typeSelected = $scope.types[0];

    $scope.descriptions = [];
    $scope.payments = [];

    $scope.checkCertificate = false;
    $scope.generarRecibosExcepcional = false;

    $scope.sexs = [
      { value: "F", label: "Femenino" },
      { value: "M", label: "Masculino" },
    ];
    $scope.typesInsureds = [
      { value: 1, label: "Fija" },
      { value: 2, label: "Regla" },
    ];
    $scope.smokers = [
      { value: false, label: "No" },
      { value: true, label: "Si" },
    ];
    $scope.relationships = [
      { value: 1, label: "Titular" },
      { value: 2, label: "Cónyuge" },
      { value: 3, label: "Hijo" },
      { value: 4, label: "Otro" },
    ];
    $scope.usages = [
      { value: 1, label: "Particular" },
      { value: 2, label: "Carga Comercial" },
      { value: 3, label: "Servicio Público" },
    ];
    $scope.procedencias = [
      { value: 0, label: "Sin especificar" },
      { value: 1, label: "Residencia" },
      { value: 2, label: "Turista" },
      { value: 3, label: "Legalizado" },
      { value: 4, label: "Fronterizo" },
    ];
    $scope.typesCharges = [
      { value: 0, label: "Sin especificar" },
      { value: 1, label: "A" },
      { value: 2, label: "B" },
      { value: 3, label: "C" },
    ];
    $scope.typesConstruction = [
      { value: 1, label: "Macizo" },
      { value: 2, label: "Madera" },
      { value: 3, label: "Lámina" },
    ];

    $scope.movements = [
      { id: 24, value: 40, name: "ALTA DE CERTIFICADOS" },
      { id: 25, value: 41, name: "BAJA DE CERTIFICADOS-DEPENDIENTES" },
      // {'id': 26, 'value': 42, 'name': 'ALTA DE DEPENDIENTES/BENEFICIARIOS'},
      // {'id': 27, 'value': 43, 'name': 'BAJA DE DEPENDIENTES/BENEFICIARIOS'}
    ];

    $scope.certificates_selected_alta = [];
    $scope.checkBeneficiaries = false;
    $scope.checkDependients = false;

    $scope.excelJson = [];
    $scope.beneficiaries_life = [];
    $scope.beneficiaries_medical = [];
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.showTableCertificates = false;
    $scope.loader = false;
    $scope.certificados = [];

    $scope.btnNoRegister = {
      color: "#ffffff",
      "background-color": "#1c84c4",
    };
    $scope.btnRegister = {
      color: "#707877",
      "background-color": "#ffffff",
      "border-top": "1px solid #1c84c4",
      "border-right": "1px solid #1c84c4",
      "border-bottom": "1px solid #1c84c4",
    };
    $scope.dependientes_add = [];
    $scope.edit_certificate = false;
    order.changePayment = changePayment;

    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          order.acceso_polizas = perm;
          order.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                order.acceso_adm_pol = true;
              } else {
                order.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                order.acceso_ver_pol = true;
              } else {
                order.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                order.acceso_canc_pol = true;
              } else {
                order.acceso_canc_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          order.acceso_form = perm;
          order.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                order.acceso_form = true;
              } else {
                order.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          order.acceso_fian = perm;
          order.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                order.acceso_adm_fia = true;
              } else {
                order.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                order.acceso_ver_fia = true;
              } else {
                order.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          order.acceso_endosos = perm;
          order.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                order.acceso_reg_end = true;
              } else {
                order.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            }
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                order.permiso_administrar_adjuntos = true;
              } else {
                order.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }

    activate();

    function activate() {
      if ($localStorage["save_created_endoso_grupo"]) {
        order.policy_number = $localStorage["save_created_endoso_grupo"]
          ? $localStorage["save_created_endoso_grupo"]["policy_number"]
          : $localStorage["save_created_endoso_grupo"]["poliza"]
          ? $localStorage["save_created_endoso_grupo"]["poliza"]
          : "";
        $scope.typeSelected = $localStorage["save_created_endoso_grupo"]
          ? $localStorage["save_created_endoso_grupo"]["type"]
          : "";
        $scope.paySelected = $localStorage["save_created_endoso_grupo"]
          ? $localStorage["save_created_endoso_grupo"]["paySelected"]
          : "";
        $scope.endorsement.other_desc = $localStorage[
          "save_created_endoso_grupo"
        ]
          ? $localStorage["save_created_endoso_grupo"]["other_desc"]
          : "";
        $scope.endorsement.observations = $localStorage[
          "save_created_endoso_grupo"
        ]
          ? $localStorage["save_created_endoso_grupo"]["observations"]
          : "";
        $scope.certificates_selected_alta = $localStorage[
          "save_created_endoso_grupo"
        ]
          ? $localStorage["save_created_endoso_grupo"][
              "certificates_selected_alta"
            ]
          : [];
        if (
          $localStorage["save_created_endoso_grupo"]["certificates_selected"]
        ) {
          $scope.certificates_selected =
            $localStorage["save_created_endoso_grupo"]["certificates_selected"];
        } else {
          $scope.certificates_selected = [];
        }
        $scope.endorsement.number_endorsement = $localStorage[
          "save_created_endoso_grupo"
        ]
          ? $localStorage["save_created_endoso_grupo"]["number_endorsement"]
          : "";
        $scope.oldPay = $localStorage["save_created_endoso_grupo"]
          ? $localStorage["save_created_endoso_grupo"]["oldPay"]
          : "";
        if ($localStorage["save_created_endoso_grupo"]) {
          if (
            $localStorage["save_created_endoso_grupo"] &&
            $localStorage["save_created_endoso_grupo"]["movimiento"]
          ) {
            $scope.descriptions.forEach(function (item) {
              if (
                item.value ==
                $localStorage["save_created_endoso_grupo"]["movimiento"][
                  "value"
                ]
              ) {
                $scope.movementSelected = item;
              }
            });
          }
        }
        if ($scope.descriptionSelected && $scope.descriptionSelected.id) {
          showFieldsNew($scope.descriptionSelected);
        }
      }
      if ($rootScope.from_task) {
        if ($localStorage["save_created_endoso_grupo"]) {
          $localStorage["save_created_endoso_grupo"]["type"] =
            $rootScope.type_endorsement;
        } else {
          $localStorage["save_created_endoso_grupo"] = {};
          $localStorage["save_created_endoso_grupo"]["type"] =
            $rootScope.type_endorsement;
        }
        $scope.types.forEach(function (item) {
          if (item.id == $rootScope.type_endorsement) {
            $scope.typeSelected = item;
          }
        });
      }
    }

    $scope.validateAntiguedad = function (date) {
      if (!date) return;
      var datePattern =
        /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
      var match = date.match(datePattern);

      if (!match) {
        SweetAlert.swal(
          "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
          "error"
        );
        $scope.newCertificates.rec_antiguedad = datesFactory.convertDate(
          new Date()
        ); // Reset input
        return;
      }
      var day = match[1];
      var month = match[2];
      var year = match[3];
      if (year.length === 5) {
        year = year.substring(0, 4);
      }
      year = parseInt(year, 10);
      var currentYear = new Date().getFullYear();

      var correctedDate = day + "/" + month + "/" + year;
      $scope.newCertificates.rec_antiguedad = correctedDate;
    };
    $scope.validateInicio = function (date, tipo) {
      if (!date) return;
      if (tipo == 1) {
        //inicio vigencia
        var datePattern =
          /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
        var match = date.match(datePattern);

        if (!match) {
          SweetAlert.swal(
            "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
            "error"
          );
          $scope.newCertificates.start_of_validity = datesFactory.convertDate(
            new Date()
          ); // Reset input
          return;
        }
        var day = match[1];
        var month = match[2];
        var year = match[3];
        if (year.length === 5) {
          year = year.substring(0, 4);
        }
        year = parseInt(year, 10);
        var currentYear = new Date().getFullYear();

        var correctedDate = day + "/" + month + "/" + year;
        $scope.newCertificates.start_of_validity = correctedDate;
      }
      if (tipo == 2) {
        //fecha alta
        var datePattern =
          /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
        var match = date.match(datePattern);

        if (!match) {
          SweetAlert.swal(
            "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
            "error"
          );
          $scope.newCertificates.end_of_validity = datesFactory.convertDate(
            new Date()
          ); // Reset input
          return;
        }
        var day = match[1];
        var month = match[2];
        var year = match[3];
        if (year.length === 5) {
          year = year.substring(0, 4);
        }
        year = parseInt(year, 10);
        var currentYear = new Date().getFullYear();

        var correctedDate = day + "/" + month + "/" + year;
        $scope.newCertificates.end_of_validity = correctedDate;
      }
      if (tipo == 3) {
        //fecha alta
        var datePattern =
          /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
        var match = date.match(datePattern);

        if (!match) {
          SweetAlert.swal(
            "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
            "error"
          );
          $scope.newCertificates.personal.charge_date =
            datesFactory.convertDate(new Date()); // Reset input
          return;
        }
        var day = match[1];
        var month = match[2];
        var year = match[3];
        if (year.length === 5) {
          year = year.substring(0, 4);
        }
        year = parseInt(year, 10);
        var currentYear = new Date().getFullYear();

        var correctedDate = day + "/" + month + "/" + year;
        $scope.newCertificates.personal.charge_date = correctedDate;
      }
    };
    $scope.validateDates = function (item, date, tipo) {
      if (!date) return;
      if (tipo == 1) {
        //inicio vigencia
        var datePattern =
          /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
        var match = date.match(datePattern);

        if (!match) {
          SweetAlert.swal(
            "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
            "error"
          );
          item.charge_date = datesFactory.convertDate(new Date()); // Reset input
          return;
        }
        var day = match[1];
        var month = match[2];
        var year = match[3];
        if (year.length === 5) {
          year = year.substring(0, 4);
        }
        year = parseInt(year, 10);
        var currentYear = new Date().getFullYear();

        var correctedDate = day + "/" + month + "/" + year;
        item.charge_date = correctedDate;
      }
      if (tipo == 2) {
        //inicio vigencia
        var datePattern =
          /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
        var match = date.match(datePattern);

        if (!match) {
          SweetAlert.swal(
            "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
            "error"
          );
          item.birthdate = datesFactory.convertDate(new Date()); // Reset input
          return;
        }
        var day = match[1];
        var month = match[2];
        var year = match[3];
        if (year.length === 5) {
          year = year.substring(0, 4);
        }
        year = parseInt(year, 10);
        var currentYear = new Date().getFullYear();

        var correctedDate = day + "/" + month + "/" + year;
        item.birthdate = correctedDate;
      }
      if (tipo == 3) {
        //discharge
        var datePattern =
          /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
        var match = date.match(datePattern);

        if (!match) {
          SweetAlert.swal(
            "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
            "error"
          );
          item.discharge_date = datesFactory.convertDate(new Date()); // Reset input
          return;
        }
        var day = match[1];
        var month = match[2];
        var year = match[3];
        if (year.length === 5) {
          year = year.substring(0, 4);
        }
        year = parseInt(year, 10);
        var currentYear = new Date().getFullYear();

        var correctedDate = day + "/" + month + "/" + year;
        item.discharge_date = correctedDate;
      }
    };
    $scope.validateBirthdate = function (date) {
      if (!date) return;
      var datePattern =
        /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
      var match = date.match(datePattern);

      if (!match) {
        SweetAlert.swal(
          "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
          "error"
        );
        $scope.newCertificates.personal.birthdate = datesFactory.convertDate(
          new Date()
        ); // Reset input
        return;
      }
      var day = match[1];
      var month = match[2];
      var year = match[3];
      if (year.length === 5) {
        year = year.substring(0, 4);
      }
      year = parseInt(year, 10);
      var currentYear = new Date().getFullYear();
      if (year < 1900 || year > currentYear) {
        SweetAlert.swal(
          "El año debe estar entre 1900 y " + currentYear,
          "error"
        );
        $scope.newCertificates.personal.birthdate = datesFactory.convertDate(
          new Date()
        ); // Reset input
        return;
      }

      var correctedDate = day + "/" + month + "/" + year;
      $scope.newCertificates.personal.birthdate = correctedDate;
    };
    if ("save_created_endoso_grupo" in $localStorage) {
    } else {
      $localStorage["save_created_endoso_grupo"] = {};
    }
    angular.element(document).ready(function () {
      $("#recAntiguedadPicker")
        .datepicker({
          autoclose: true,
          format: "dd/mm/yyyy",
        })
        .on("changeDate", function () {
          var scope = angular.element(this).scope();
          scope.$apply(function () {
            scope.validateAntiguedad(scope.newCertificates.rec_antiguedad);
          });
        });
    });
    $scope.saveLocalstorange = function () {
      $localStorage["save_created_endoso_grupo"]["policy_number"] =
        order.policy_number ? order.policy_number : "";
      $localStorage["save_created_endoso_grupo"]["other_desc"] = $scope
        .endorsement.other_desc
        ? $scope.endorsement.other_desc
        : "";
      $localStorage["save_created_endoso_grupo"]["observations"] = $scope
        .endorsement.observations
        ? $scope.endorsement.observations
        : "";
      $localStorage["save_created_endoso_grupo"]["certificates_selected_alta"] =
        $scope.certificates_selected_alta
          ? $scope.certificates_selected_alta
          : [];
      $localStorage["save_created_endoso_grupo"]["certificates_selected"] =
        $scope.certificates_selected ? $scope.certificates_selected : [];
      $localStorage["save_created_endoso_grupo"]["number_endorsement"] = $scope
        .endorsement.number_endorsement
        ? $scope.endorsement.number_endorsement
        : "";
      $localStorage["save_created_endoso_grupo"]["oldPay"] = $scope.oldPay
        ? $scope.oldPay
        : "";
      $localStorage["save_created_endoso_grupo"]["type"] = $scope.typeSelected
        ? $scope.typeSelected
        : "";
      $localStorage["save_created_endoso_grupo"]["movimiento"] =
        $scope.descriptionSelected ? $scope.descriptionSelected : "";
    };

    $scope.checkLength = function (value) {
      if (value && value.length > 500) {
        SweetAlert.swal(
          "Error",
          "El Número de Endoso no puede tener más de 500 caracteres.\n Se ha limitado a 500 caracteres.",
          "error"
        );
        $scope.endorsement.number_endorsement = value.substring(0, 500); // Trim extra characters
      }
    };
    $scope.checkLengthOtherdesc = function (value) {
      if (value && value.length > 500) {
        SweetAlert.swal(
          "Error",
          "Concepto no puede tener más de 500 caracteres.\n Se ha limitado a 500 caracteres.",
          "error"
        );
        $scope.endorsement.other_desc = value.substring(0, 500); // Trim extra characters
      }
    };
    $scope.findPolicy = function (parValue) {
      if (parValue) {
        if (parValue.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.url_filter = 'v2/polizas/get-endorsements-collect/';
          $scope.url_filter = "get-endorsements-collect/";
          $http({
            method: "POST",
            url: url.IP + $scope.url_filter,
            data: {
              word: parValue.val,
              mode: "caratula",
            },
          })
            .then(
              function success(request) {
                var results = [];
                results = _.map(request.data, function (item) {
                  if (item.contractor) {
                    var label =
                      item.poliza_number +
                      " - " +
                      item.contractor +
                      " - " +
                      datesFactory.convertDate(item.start_of_validity) +
                      " - " +
                      datesFactory.convertDate(item.end_of_validity);
                  }
                  return {
                    label: label,
                    value: item.poliza_number,
                    id: item.id,
                  };
                });
                $scope.autocompleteData = results;
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
      $scope.saveLocalstorange();
    };

    $scope.$watch("order.policy_number.value", function (newValue, oldValue) {
      if (order.policy_number) {
        $scope.getPolicy(order.policy_number.id);
      }
    });

    if ($stateParams.myInsurance != "some default") {
      // order.policy_number= $stateParams.myInsurance;
      if ($stateParams.myInsurance.contractor) {
        var label =
          $stateParams.myInsurance.poliza_number +
          " - " +
          $stateParams.myInsurance.contractor.full_name +
          " - " +
          datesFactory.convertDate($stateParams.myInsurance.start_of_validity) +
          " - " +
          datesFactory.convertDate($stateParams.myInsurance.end_of_validity);
      }
      order.policy_number = {
        label: label,
        value: $stateParams.myInsurance.poliza_number,
        id: $stateParams.myInsurance.id,
        val: label,
      };
    }
    $scope.getPolicy = function (param) {
      $http
        .post(url.IP + "get_caratula_complete/", { caratula: param })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.caratula = response.data.data.caratula;
            if ($scope.paySelected) {
              if ($scope.caratula.forma_de_pago == 12) {
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
              }
              if ($scope.caratula.forma_de_pago == 2) {
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
              }
              if ($scope.caratula.forma_de_pago == 3) {
                $scope.payments = [
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
              }
              if ($scope.caratula.forma_de_pago == 6) {
                $scope.payments = [
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
              }
              if ($scope.caratula.forma_de_pago == 1) {
                $scope.payments = [{ id: 5, name: "Contado" }];
              }
              if ($scope.caratula.forma_de_pago == 5) {
                $scope.payments = [];
                SweetAlert.swal(
                  "Error",
                  "No puedes cambiar la forma de pago Mensual a una forma de pago menor.",
                  "error"
                );
              }
            }
            $scope.subgrupos = response.data.data.childs;
            $scope.paquetes = response.data.data.paquetes;

            $scope.subgrupos.forEach(function (item) {
              for (var i = 0; i < item.categorias.length; i++) {
                var category = {
                  subgroup: item.name,
                  category: item.categorias[i].name,
                  category_id: item.categorias[i].id,
                };
                $scope.categoriesJson.push(category);
              }
            });

            $scope.startDate = datesFactory.convertDate(
              $scope.caratula.start_of_validity
            );
            $scope.endDate = datesFactory.convertDate(
              $scope.caratula.end_of_validity
            );
            $scope.checkDate($scope.startDate);
            $scope.checkEndDate($scope.endDate);
            $scope.getClaves();
            $scope.changePayment();
            $scope.typeSelected = $scope.typeSelected
              ? $scope.typeSelected
              : $scope.types[1];
            $scope.fillData($scope.typeSelected);
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORSEARCHPOLICY, "error");
          }
        })
        .catch(function (e) {
          // console.log('e', e);
        });
    };

    $scope.getClaves = function () {
      $http
        .get(url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id)
        .then(function success(clavesResponse) {
          $scope.claves = clavesResponse.data;
          if ($scope.claves.length == 1) {
            $scope.caratula.clave = $scope.claves[0];
            $scope.claveSelected = $scope.claves[0];
          } else {
            $scope.claves.forEach(function (item) {
              if (item.id == $scope.caratula.clave.id) {
                $scope.claveSelected = item;
              }
            });
          }
        })
        .catch(function (error) {
          // console.log('Error - claves-by-provider - catch', error);
        });

      $http
        .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
        .then(
          function success(response) {
            $scope.ramos = response.data;
            $scope.ramos.forEach(function (item) {
              if (item.ramo_name == $scope.caratula.ramo.ramo_name) {
                $scope.ramoSelected = item;
                $scope.subramos = item.subramo_ramo;
                $scope.subramos.forEach(function (subramo) {
                  if (
                    subramo.subramo_name == $scope.caratula.subramo.subramo_name
                  ) {
                    $scope.subramoSelected = subramo;
                    $scope.directiveReceipts.subramo = subramo;
                    $scope.dataToSave.subramo = subramo;
                    $scope.directiveReceipts.comision_percent =
                      $scope.caratula.comision_percent;

                    var comisiones = [];
                    if ($scope.claveSelected) {
                      if ($scope.claveSelected.clave_comision) {
                        if ($scope.claveSelected.clave_comision.length) {
                          $scope.claveSelected.clave_comision.forEach(function (
                            item
                          ) {
                            if (
                              $scope.subramoSelected.subramo_name ==
                              item.subramo
                            ) {
                              comisiones.push(item);
                            }
                          });
                        }
                      }
                    }
                    $scope.directiveReceipts.comisiones = comisiones;
                  }
                });
              }
            });
          },
          function error(e) {
            // console.log('Error - ramos-by-provider', e);
          }
        )
        .catch(function (error) {
          // console.log('Error - ramos-by-provider - catch', error);
        });
    };

    $scope.checkDate = function (param) {
      if (param.length == 10) {
        if (process(param) > process($scope.endDate)) {
          SweetAlert.swal(
            "Error",
            "La fecha inicio no puede ser mayor a la fecha fin.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        $scope.startDate = param;
        $scope.directiveReceipts.startDate = $scope.startDate;
        $scope.directiveReceipts.endingDate = $scope.endDate;
        var date1 = new Date(
          datesFactory.toDate($scope.directiveReceipts.startDate)
        );
        var date2 = new Date(
          datesFactory.toDate($scope.directiveReceipts.endingDate)
        );
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        $scope.directiveReceipts.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
        $scope.directiveReceipts.domiciliado = false;
        $scope.directiveReceipts.comision_percent =
          $scope.caratula.comision_percent;

        changePayment();
      }
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        $scope.endDate = param;
        $scope.directiveReceipts.startDate = $scope.startDate;
        $scope.directiveReceipts.endingDate = param;
        var date1 = new Date(
          datesFactory.toDate($scope.directiveReceipts.startDate)
        );
        var date2 = new Date(
          datesFactory.toDate($scope.directiveReceipts.endingDate)
        );
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        $scope.directiveReceipts.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
        $scope.directiveReceipts.comision_percent =
          $scope.caratula.comision_percent;

        $scope.changePayment();
      }
    };

    $scope.findCertificate = function (parValue) {
      if (parValue) {
        if (parValue.val.length >= 3) {
          $http({
            method: "POST",
            url: url.IP + "get-certificatesforendoso/",
            data: {
              word: parValue.val,
              id_collect: $scope.caratula.id,
              mode: "certifcado",
            },
          })
            .then(
              function success(request) {
                $scope.autocompleteDataCertificate = [];
                $scope.certificados_todos = [];
                var results_cert = [];
                var mapeo_cert = [];
                if (request.status == 200) {
                  request.data.forEach(function (poliza) {
                    if (poliza.document_type == 6) {
                      mapeo_cert.push(poliza);
                    }
                  });
                  results_cert = _.map(mapeo_cert, function (item) {
                    if (item.accidents_policy.length) {
                      var label =
                        "Certificado: " +
                        item.certificate_number +
                        " - Titular: " +
                        item.accidents_policy[0].personal.first_name +
                        " " +
                        item.accidents_policy[0].personal.last_name;
                    } else if (item.life_policy.length) {
                      var label =
                        "Certificado: " +
                        item.certificate_number +
                        " - Titular: " +
                        item.life_policy[0].personal.first_name +
                        " " +
                        item.life_policy[0].personal.last_name;
                    } else if (item.automobiles_policy.length) {
                      var label =
                        "Certificado: " +
                        item.certificate_number +
                        " - Serie: " +
                        item.automobiles_policy[0].serial;
                    } else if (item.damages_policy.length) {
                      var label =
                        "Certificado: " +
                        item.certificate_number +
                        " - Giro: " +
                        item.damages_policy[0].giro;
                    }
                    return {
                      label: label ? label : "",
                      value: item.poliza_number,
                      id: item.id,
                      document_type: item.document_type,
                      url: item.url,
                      contacto: item.contacto,
                      certificate_number: item.certificate_number,
                    };
                  });
                  $scope.autocompleteDataCertificate = results_cert;
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              // console.log('e', e);
            });
        }
      }
    };
    $scope.findCertificate_b = function (parValue) {
      if (parValue) {
        if (parValue.length >= 3) {
          $http({
            method: "POST",
            url: url.IP + "get-certificatesforendoso/",
            data: {
              word: parValue,
              id_collect: $scope.caratula.id,
              mode: "certifcado",
            },
          })
            .then(
              function success(request) {
                $scope.autocompleteDataCertificate = [];
                $scope.certificados_todos = [];
                var results_cert = [];
                var mapeo_cert = [];
                if (request.status == 200) {
                  request.data.forEach(function (poliza) {
                    if (poliza.document_type == 6) {
                      mapeo_cert.push(poliza);
                    }
                  });
                  results_cert = _.map(mapeo_cert, function (item) {
                    if (item.accidents_policy.length) {
                      var label =
                        "Certificado: " +
                        item.certificate_number +
                        " - Titular: " +
                        item.accidents_policy[0].personal.first_name +
                        " " +
                        item.accidents_policy[0].personal.last_name;
                    } else if (item.life_policy.length) {
                      var label =
                        "Certificado: " +
                        item.certificate_number +
                        " - Titular: " +
                        item.life_policy[0].personal.first_name +
                        " " +
                        item.life_policy[0].personal.last_name;
                    } else if (item.automobiles_policy.length) {
                      var label =
                        "Certificado: " +
                        item.certificate_number +
                        " - Serie: " +
                        item.automobiles_policy[0].serial;
                    } else if (item.damages_policy.length) {
                      var label =
                        "Certificado: " +
                        item.certificate_number +
                        " - Giro: " +
                        item.damages_policy[0].giro;
                    }
                    return {
                      label: label ? label : "",
                      value: item.poliza_number,
                      id: item.id,
                      document_type: item.document_type,
                      url: item.url,
                      contacto: item.contacto,
                      certificate_number: item.certificate_number,
                    };
                  });
                  $scope.autocompleteDataCertificate = results_cert;
                  console.log("ddddd", $scope.autocompleteDataCertificate);
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              // console.log('e', e);
            });
        }
      }
    };
    $scope.$watch(
      "order.certificate_number.value",
      function (newValue, oldValue) {
        if (order.certificate_number) {
          $scope.getCertificate(order.certificate_number.id);
        }
      }
    );

    $scope.getCertificate = function (param) {
      $http
        .post(
          url.IP + "info_certificados_Collective/?id_certificado=" + param + "&"
        )
        .then(function success(response) {
          if (response.status == 200) {
            $scope.newCertificates = response.data;
            $http
              .post(url.IP + "get_caratula_complete/", {
                caratula: $scope.caratula.id,
              })
              .then(function success(response) {
                if (response.status == 200) {
                  $scope.caratula = response.data.data.caratula;
                  $scope.subgrupos = response.data.data.childs;

                  $scope.subgrupos.forEach(function (item) {
                    for (var i = 0; i < item.categorias.length; i++) {
                      var category = {
                        subgroup: item.name,
                        category: item.categorias[i].name,
                        category_id: item.categorias[i].id,
                      };
                      $scope.categoriesJson.push(category);
                      if (i == item.categorias.length - 1) {
                        $scope.categoriesJson.forEach(function (item) {
                          if (
                            item.category_id == $scope.newCertificates.parent.id
                          ) {
                            $scope.newCertificates.parent = item;
                          }
                        });
                      }
                    }
                  });

                  $scope.paquetes = response.data.data.paquetes;

                  $scope.paquetes.forEach(function (item) {
                    if (item.id == $scope.newCertificates.paquete) {
                      $scope.newCertificates.paquete = item;
                    }
                  });
                }
              })
              .catch(function (e) {
                // console.log('e', e);
              });

            if ($scope.newCertificates.life_policy.length) {
              $scope.newCertificates.personal = angular.copy(
                $scope.newCertificates.life_policy[0].personal
              );
              $scope.newCertificates.beneficiaries_life = angular.copy(
                $scope.newCertificates.life_policy[0].beneficiaries_life
              );
            } else if ($scope.newCertificates.accidents_policy.length) {
              $scope.newCertificates.personal = angular.copy(
                $scope.newCertificates.accidents_policy[0].personal
              );
              $scope.newCertificates.personal.charge_date = $scope
                .newCertificates.accidents_policy[0].personal.charge_date
                ? datesFactory.convertDate(
                    $scope.newCertificates.accidents_policy[0].personal
                      .charge_date
                  )
                : datesFactory.convertDate(new Date());
              $scope.newCertificates.relationship_accident = angular.copy(
                $scope.newCertificates.accidents_policy[0].relationship_accident
              );
            } else if ($scope.newCertificates.automobiles_policy.length) {
              $scope.newCertificates.automobiles_policy[0].sum_insured =
                parseFloat(
                  $scope.newCertificates.automobiles_policy[0].sum_insured
                );
              $scope.newCertificates.auto = angular.copy(
                $scope.newCertificates.automobiles_policy[0]
              );
            } else if ($scope.newCertificates.damages_policy.length) {
              $scope.newCertificates.auto = angular.copy(
                $scope.newCertificates.damages_policy[0]
              );
            }

            $scope.newCertificates.p_neta = parseFloat(
              $scope.newCertificates.p_neta
            );
            $scope.newCertificates.rpf = parseFloat($scope.newCertificates.rpf);
            $scope.newCertificates.derecho = parseFloat(
              $scope.newCertificates.derecho
            );
            $scope.newCertificates.iva = parseFloat($scope.newCertificates.iva);
            $scope.newCertificates.p_total = parseFloat(
              $scope.newCertificates.p_total
            );
            $scope.newCertificates.comision = parseFloat(
              $scope.newCertificates.comision
            );

            $scope.fillData($scope.typeSelected);
            $scope.editCertificate();
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORSEARCHPOLICY, "error");
          }
        })
        .catch(function (e) {
          // console.log('e', e);
        });
    };

    $scope.payment = function (parValue) {
      switch (parValue) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        default:
          return parValue;
      }
    };

    $scope.checkSelected = function (param) {
      $scope.checkCertificate = param;
    };

    $scope.fillData = function (type) {
      $scope.typeSelected = type;
      $scope.directiveReceipts.endorsement_type = type.name;
      $scope.directiveReceipts.administration_type =
        $scope.caratula.administration_type;
      $scope.directiveReceipts.comision_percent =
        $scope.caratula.comision_percent;
      $localStorage["save_created_endoso_grupo"]["type"] = $scope.typeSelected;
      $scope.descriptions = [];

      if ($scope.checkCertificate) {
        $scope.descriptions.push({
          id: 35,
          value: 40,
          name: "CAMBIO EN CERTIFICADO",
        });
      } else {
        if (type.id == 1) {
          if ($scope.caratula.receipts_by == 1) {
            $scope.descriptions.push({
              id: 1,
              value: 1,
              name: "CAMBIO DE FORMA DE PAGO",
            });
          }
          $scope.descriptions.push({
            id: 4,
            value: 3,
            name: "PRÓRROGA DE VIGENCIA",
          });
          $scope.descriptions.push({
            id: 24,
            value: 38,
            name: "ALTA DE CERTIFICADO",
          });
          if ($scope.caratula.administration_type == "Autoadministrada") {
            $scope.descriptions.push({
              id: 36,
              value: 41,
              name: "AJUSTE ANUAL",
            });
          }
        } else if (type.id == 2) {
        } else if (type.id == 3) {
          if ($scope.caratula.receipts_by == 1) {
            $scope.descriptions.push({
              id: 1,
              value: 6,
              name: "CAMBIO DE FORMA DE PAGO",
            });
          }
          $scope.descriptions.push({
            id: 25,
            value: 39,
            name: "BAJA DE CERTIFICADOS",
          });
          if ($scope.caratula.administration_type == "Autoadministrada") {
            $scope.descriptions.push({
              id: 36,
              value: 42,
              name: "AJUSTE ANUAL",
            });
          }
        }
        $scope.descriptions.push({ id: 3, value: 37, name: "OTRO" });
      }
      if ($localStorage["save_created_endoso_grupo"]) {
        if ($localStorage["save_created_endoso_grupo"]["concept"]) {
          $scope.descriptions.forEach(function (item) {
            if (
              item.value ==
              $localStorage["save_created_endoso_grupo"]["concept"]["value"]
            ) {
              $scope.descriptionSelected = item;
            }
          });
        }
      }
      if (
        ($scope.newCertificates == [] || $scope.newCertificates.length == 0) &&
        $scope.descriptionSelected &&
        $scope.descriptionSelected.value == 38
      ) {
        $scope.createIndividualCertificate();
      }
    };
    order.showFieldsNew = showFieldsNew;
    function showFieldsNew(concept) {
      $scope.change_endorsement = {};
      $scope.caratula.concept = concept;
      $scope.origin_endorsement = angular.copy($scope.caratula);
      $scope.descriptionSelected = concept;
      $localStorage["save_created_endoso_grupo"]["concept"] =
        $scope.descriptionSelected ? $scope.descriptionSelected : "";
      $localStorage["save_created_endoso_grupo"]["movimiento"] =
        $scope.descriptionSelected ? $scope.descriptionSelected : "";

      if (concept) {
        if (concept.value == 1 || concept.value == 6) {
          //cambio forma pago
          $scope.oldPay = $scope.payment($scope.caratula.forma_de_pago);
          $scope.directiveReceipts.endorsement_type = "A";
          $scope.directiveReceipts.administration_type =
            $scope.caratula.administration_type;
          $scope.directiveReceipts.concept = concept;
          $scope.directiveReceipts.comision_percent =
            $scope.caratula.comision_percent;
          if ($scope.typeSelected.id == 1) {
            switch ($scope.caratula.forma_de_pago) {
              case 5:
                $scope.payments = [
                  { id: 12, name: "Anual" },
                  { id: 6, name: "Semestral" },
                  { id: 3, name: "Trimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 12:
                $scope.payments = [
                  { id: 6, name: "Semestral" },
                  { id: 3, name: "Trimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 6:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 3:
                $scope.payments = [{ id: 1, name: "Mensual" }];
                break;
              case 2:
                $scope.payments = [{ id: 1, name: "Mensual" }];
                break;
              case 1:
                $scope.payments = [];
                SweetAlert.swal(
                  "Error",
                  "No puedes cambiar la forma de pago Mensual a una forma de pago menor.",
                  "error"
                );
                break;
              default:
                break;
            }
          } else if ($scope.typeSelected.id == 3) {
            switch ($scope.caratula.forma_de_pago) {
              case 1:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 2:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 3:
                $scope.payments = [
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 6:
                $scope.payments = [
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 12:
                $scope.payments = [{ id: 5, name: "Contado" }];
                break;
              case 5:
                $scope.payments = [];
                SweetAlert.swal(
                  "Error",
                  "No puedes cambiar la forma de pago Mensual a una forma de pago menor.",
                  "error"
                );
                break;
              default:
                break;
            }
          }
        } else if (concept.value == 38) {
          $scope.createIndividualCertificate();
        } else if (concept.value == 39) {
          $scope.newCertificates = {
            certificate_number: "",
            parent: null,
            dependientes: [],
            prima_neta: 0,
            rpf: 0,
            derecho: 0,
            iva: 0,
            prima_total: 0,
            comision: 0,
            comision_percent: 0,
            relationship_accident: [],
          };
        } else if (concept.value == 40) {
          if ($scope.newCertificates.personal) {
            $scope.newCertificates.personal.p_neta =
              parseFloat($scope.newCertificates.personal.p_neta) || 0;
            $scope.newCertificates.personal.rpf =
              parseFloat($scope.newCertificates.personal.rpf) || 0;
            $scope.newCertificates.personal.derecho =
              parseFloat($scope.newCertificates.personal.derecho) || 0;
            $scope.newCertificates.personal.iva =
              parseFloat($scope.newCertificates.personal.iva) || 0;
            $scope.newCertificates.personal.p_total =
              parseFloat($scope.newCertificates.personal.p_total) || 0;
            $scope.newCertificates.personal.comision =
              parseFloat($scope.newCertificates.personal.comision) || 0;

            $scope.newCertificates.relationship_accident.map(function (item) {
              item.p_neta = parseFloat(item.p_neta) || 0;
              item.rpf = parseFloat(item.rpf) || 0;
              item.derecho = parseFloat(item.derecho) || 0;
              item.iva = parseFloat(item.iva) || 0;
              item.p_total = parseFloat(item.p_total) || 0;
              item.comision = parseFloat(item.comision) || 0;
              return item;
            });
          }
        }

        if ($scope.descriptionSelected) {
          if ($scope.descriptionSelected.id != 1) {
            if (
              $scope.caratula.administration_type == "Autoadministrada" ||
              $scope.caratula.administration_type == 2
            ) {
              if ($scope.descriptionSelected.id == 36) {
                $scope.totalReceipts = [{ id: 1, name: 1 }];
              } else {
                $scope.totalReceipts = [{ id: 0, name: 0 }];
              }
            }
          }
        }
      }
    }
    $scope.showFields = function (concept) {
      $scope.change_endorsement = {};
      $scope.caratula.concept = concept;
      $scope.origin_endorsement = angular.copy($scope.caratula);
      $scope.descriptionSelected = concept;
      $localStorage["save_created_endoso_grupo"]["concept"] =
        $scope.descriptionSelected ? $scope.descriptionSelected : "";
      $localStorage["save_created_endoso_grupo"]["movimiento"] =
        $scope.descriptionSelected ? $scope.descriptionSelected : "";
      if (concept) {
        if (concept.value == 1 || concept.value == 6) {
          //cambio forma pago
          $scope.oldPay = $scope.payment($scope.caratula.forma_de_pago);
          $scope.directiveReceipts.endorsement_type = "A";
          $scope.directiveReceipts.administration_type =
            $scope.caratula.administration_type;
          $scope.directiveReceipts.concept = concept;
          $scope.directiveReceipts.comision_percent =
            $scope.caratula.comision_percent;
          if ($scope.typeSelected.id == 1) {
            switch ($scope.caratula.forma_de_pago) {
              case 5:
                $scope.payments = [
                  { id: 12, name: "Anual" },
                  { id: 6, name: "Semestral" },
                  { id: 3, name: "Trimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 12:
                $scope.payments = [
                  { id: 6, name: "Semestral" },
                  { id: 3, name: "Trimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 6:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 3:
                $scope.payments = [{ id: 1, name: "Mensual" }];
                break;
              case 2:
                $scope.payments = [{ id: 1, name: "Mensual" }];
                break;
              case 1:
                $scope.payments = [];
                SweetAlert.swal(
                  "Error",
                  "No puedes cambiar la forma de pago Mensual a una forma de pago menor.",
                  "error"
                );
                break;
              default:
                break;
            }
          } else if ($scope.typeSelected.id == 3) {
            switch ($scope.caratula.forma_de_pago) {
              case 1:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 2:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 3:
                $scope.payments = [
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 6:
                $scope.payments = [
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 12:
                $scope.payments = [{ id: 5, name: "Contado" }];
                break;
              case 5:
                $scope.payments = [];
                SweetAlert.swal(
                  "Error",
                  "No puedes cambiar la forma de pago Mensual a una forma de pago menor.",
                  "error"
                );
                break;
              default:
                break;
            }
          }
        } else if (concept.value == 1) {
        } else if (concept.value == 38) {
          $scope.createIndividualCertificate();
        } else if (concept.value == 39) {
          $scope.newCertificates = {
            certificate_number: "",
            parent: null,
            dependientes: [],
            prima_neta: 0,
            rpf: 0,
            derecho: 0,
            iva: 0,
            prima_total: 0,
            comision: 0,
            comision_percent: 0,
          };
        } else if (concept.value == 40) {
          if ($scope.newCertificates.personal) {
            $scope.newCertificates.personal.p_neta =
              parseFloat($scope.newCertificates.personal.p_neta) || 0;
            $scope.newCertificates.personal.rpf =
              parseFloat($scope.newCertificates.personal.rpf) || 0;
            $scope.newCertificates.personal.derecho =
              parseFloat($scope.newCertificates.personal.derecho) || 0;
            $scope.newCertificates.personal.iva =
              parseFloat($scope.newCertificates.personal.iva) || 0;
            $scope.newCertificates.personal.p_total =
              parseFloat($scope.newCertificates.personal.p_total) || 0;
            $scope.newCertificates.personal.comision =
              parseFloat($scope.newCertificates.personal.comision) || 0;

            $scope.newCertificates.relationship_accident.map(function (item) {
              item.p_neta = parseFloat(item.p_neta) || 0;
              item.rpf = parseFloat(item.rpf) || 0;
              item.derecho = parseFloat(item.derecho) || 0;
              item.iva = parseFloat(item.iva) || 0;
              item.p_total = parseFloat(item.p_total) || 0;
              item.comision = parseFloat(item.comision) || 0;
              return item;
            });
          }
        }

        if ($scope.descriptionSelected) {
          if ($scope.descriptionSelected.id != 1) {
            if (
              $scope.caratula.administration_type == "Autoadministrada" ||
              $scope.caratula.administration_type == 2
            ) {
              if ($scope.descriptionSelected.id == 36) {
                $scope.totalReceipts = [{ id: 1, name: 1 }];
              } else {
                $scope.totalReceipts = [{ id: 0, name: 0 }];
              }
            }
          }
        }
      }
      if (
        esAutoadministrada(
          $scope.caratula && $scope.caratula.administration_type
        )
      ) {
        addReceipts(
          $scope.generarRecibosExcepcional
            ? $scope.generarRecibosExcepcional
            : false
        );
      }
    };

    function changePayment(param) {
      $scope.totalReceipts = [];
      $localStorage["save_created_endoso_grupo"]["paySelected"] = param;
      if (param) {
        $scope.directiveReceipts.payment = param.id;
        $scope.change_endorsement.forma_de_pago = param.id;
        $scope.directiveReceipts.administration_type =
          $scope.caratula.administration_type;
        $scope.directiveReceipts.comision_percent =
          $scope.caratula.comision_percent;
        $scope.number_receipts = 0;
        switch (parseFloat(param.id)) {
          case 1:
            $scope.numberReceipts = 12;
            break;
          case 2:
            $scope.numberReceipts = 6;
            break;
          case 3:
            $scope.numberReceipts = 4;
            break;
          case 5:
            $scope.numberReceipts = 1; //contado
            break;
          case 6:
            $scope.numberReceipts = 2;
            break;
          case 12:
            $scope.numberReceipts = 1; //anual
            break;
          default:
            break;
        }

        var recibos_fracionados =
          ($scope.directiveReceipts.policy_days_duration *
            $scope.numberReceipts) /
          365;
        var arreglo_recibos = recibos_fracionados.toString().split(".");
        var recibos_completos = parseFloat(arreglo_recibos[0]);
        var recibos_incompletos = "0." + arreglo_recibos[1];
        recibos_incompletos = parseFloat(recibos_incompletos);
        $scope.directiveReceipts.comision_percent =
          $scope.caratula.comision_percent;
        if (recibos_incompletos < 1 && recibos_incompletos > 0) {
          $scope.number_receipts = recibos_completos + 1;
        } else {
          $scope.number_receipts = recibos_completos;
        }

        for (var i = 1; i <= $scope.number_receipts; i++) {
          $scope.totalReceipts.push({ id: i, name: i });
        }
      } else {
        $scope.directiveReceipts.payment = $scope.caratula.forma_de_pago;
        for (var i = 1; i <= 12; i++) {
          $scope.totalReceipts.push({ id: i, name: i });
        }
      }
      if (
        !$scope.descriptionSelected ||
        $scope.descriptionSelected == null ||
        $scope.descriptionSelected == undefined
      ) {
        $scope.descriptionSelected = $scope.copy_description;
      }
      if ($scope.descriptionSelected) {
        if ($scope.descriptionSelected.id != 1) {
          if (
            $scope.caratula.administration_type == "Autoadministrada" ||
            $scope.caratula.administration_type == 2
          ) {
            if ($scope.descriptionSelected.id == 36) {
              $scope.totalReceipts = [{ id: 1, name: 1 }];
            } else {
              $scope.totalReceipts = [{ id: 0, name: 0 }];
            }
          }
        }
      }
    }

    $scope.changePayment = function (param) {
      $scope.totalReceipts = [];
      $localStorage["save_created_endoso_grupo"]["paySelected"] =
        $scope.paySelected;
      if (param) {
        $scope.directiveReceipts.payment = param.id;
        $scope.change_endorsement.forma_de_pago = param.id;
        $scope.directiveReceipts.administration_type =
          $scope.caratula.administration_type;
        $scope.directiveReceipts.comision_percent =
          $scope.caratula.comision_percent;
        $scope.number_receipts = 0;
        switch (parseFloat(param.id)) {
          case 1:
            $scope.numberReceipts = 12;
            break;
          case 2:
            $scope.numberReceipts = 6;
            break;
          case 3:
            $scope.numberReceipts = 4;
            break;
          case 5:
            $scope.numberReceipts = 1; //contado
            break;
          case 6:
            $scope.numberReceipts = 2;
            break;
          case 12:
            $scope.numberReceipts = 1; //anual
            break;
          default:
            break;
        }

        var recibos_fracionados =
          ($scope.directiveReceipts.policy_days_duration *
            $scope.numberReceipts) /
          365;
        $scope.directiveReceipts.comision_percent =
          $scope.caratula.comision_percent;
        var arreglo_recibos = recibos_fracionados.toString().split(".");
        var recibos_completos = parseFloat(arreglo_recibos[0]);
        var recibos_incompletos = "0." + arreglo_recibos[1];
        recibos_incompletos = parseFloat(recibos_incompletos);
        if (recibos_incompletos < 1 && recibos_incompletos > 0) {
          $scope.number_receipts = recibos_completos + 1;
        } else {
          $scope.number_receipts = recibos_completos;
        }

        for (var i = 1; i <= $scope.number_receipts; i++) {
          $scope.totalReceipts.push({ id: i, name: i });
        }
      } else {
        $scope.directiveReceipts.payment = $scope.caratula.forma_de_pago;
        $scope.directiveReceipts.comision_percent =
          $scope.caratula.comision_percent;
        for (var i = 1; i <= 12; i++) {
          $scope.totalReceipts.push({ id: i, name: i });
        }
      }
      if (
        !$scope.descriptionSelected ||
        $scope.descriptionSelected == null ||
        $scope.descriptionSelected == undefined
      ) {
        $scope.descriptionSelected = $scope.copy_description;
      }
      if ($scope.descriptionSelected) {
        if ($scope.descriptionSelected.id != 1) {
          if (
            $scope.caratula.administration_type == "Autoadministrada" ||
            $scope.caratula.administration_type == 2
          ) {
            if ($scope.descriptionSelected.id == 36) {
              $scope.totalReceipts = [{ id: 1, name: 1 }];
            } else {
              $scope.totalReceipts = [{ id: 0, name: 0 }];
            }
          }
        }
      }
    };

    $scope.createIndividualCertificate = function () {
      $scope.newCertificates = {};
      console.log("-d-dd", $scope.caratula, $scope.newCertificates);
      if ($scope.caratula.ramo.ramo_code == 1) {
        $scope.newCertificates = {
          personal: {
            certificate: "",
            first_name: "",
            last_name: "",
            second_last_name: "",
            birthdate: datesFactory.convertDate(new Date()),
            antiguedad: datesFactory.convertDate(new Date()),
            sex: $scope.sexs[0],
            email: "",
            salary: "",
            sum_assured: "",
            type_sa: $scope.typesInsureds[0],
          },
          smoker: $scope.smokers[0],
          beneficiaries_life: [
            // {
            //   familia: '',
            //   certificate: '',
            //   first_name: '',
            //   last_name: '',
            //   second_last_name: '',
            //   birthdate: datesFactory.convertDate(new Date()),
            //   antiguedad: '',
            //   optional_relationship: $scope.relationships[3],
            //   sex: $scope.sexs[0],
            //   percentage: 0
            // }
          ],
        };
        $scope.newCertificates.p_neta = 0;
        $scope.newCertificates.rpf = 0;
        $scope.newCertificates.derecho = 0;
        $scope.newCertificates.iva = 0;
        $scope.newCertificates.p_total = 0;
        $scope.newCertificates.comision = 0;
      } else if ($scope.caratula.ramo.ramo_code == 2) {
        $scope.newCertificates = {
          personal: {
            certificate: "",
            first_name: "",
            last_name: "",
            second_last_name: "",
            birthdate: datesFactory.convertDate(new Date()),
            antiguedad: datesFactory.convertDate(new Date()),
            sex: $scope.sexs[0],
            charge_date: $scope.startDate,
            email: "",
            p_neta: 0,
            rpf: 0,
            derecho: 0,
            iva: 0,
            p_total: 0,
            comision: 0,
          },
          relationship_accident: [
            // {
            //   familia: '',
            //   certificate: '',
            //   first_name: '',
            //   last_name: '',
            //   second_last_name: '',
            //   birthdate: datesFactory.convertDate(new Date()),
            //   antiguedad: '',
            //   relationship: $scope.relationships[3],
            //   sex: $scope.sexs[0],
            // }
          ],
        };
      } else if ($scope.caratula.subramo.subramo_code == 9) {
        $scope.newCertificates.auto = {
          adjustment: "",
          beneficiary_address: "",
          beneficiary_rfc: "",
          brand: "",
          car_owner: "",
          charge_type: $scope.typesCharges[0],
          color: "",
          driver: "",
          email: "",
          engine: "",
          license_plates: "",
          model: "",
          mont_adjustment: 0,
          mont_special_team: 0,
          no_employee: "",
          preferential_benefiaciary: "",
          procedencia: $scope.procedencias[0],
          serial: "",
          service: "",
          special_team: "",
          sum_insured: 0,
          usage: $scope.usages[0],
          version: "",
          year: "",
        };
        $scope.newCertificates.p_neta = 0;
        $scope.newCertificates.rpf = 0;
        $scope.newCertificates.derecho = 0;
        $scope.newCertificates.iva = 0;
        $scope.newCertificates.p_total = 0;
        $scope.newCertificates.comision = 0;
      } else if ($scope.caratula.subramo.subramo_code == 13) {
        $scope.newCertificates.auto = {
          brand: "",
          dam_owner: "",
          color: "",
          email: "",
          engine: "",
          item_address: "",
          model: "",
          construction_year: 0,
          reconstruction_year: 0,
          no_employee: "",
          permiso: "",
          serial: "",
          usage: $scope.usages[0],
          version: "",
          item_details: "",
          purchase_value: 0,
        };
        $scope.newCertificates.p_neta = 0;
        $scope.newCertificates.rpf = 0;
        $scope.newCertificates.derecho = 0;
        $scope.newCertificates.iva = 0;
        $scope.newCertificates.p_total = 0;
        $scope.newCertificates.comision = 0;
      } else if ($scope.caratula.subramo.subramo_code == 7) {
        $scope.newCertificates.auto = {
          email: "",
          item_address: "",
          no_levels: 0,
          giro: "",
          fhm_zone: "",
          type_construction: $scope.typesConstruction[0],
          tyev_zone: "",
          sucursal: "",
        };
        $scope.newCertificates.p_neta = 0;
        $scope.newCertificates.rpf = 0;
        $scope.newCertificates.derecho = 0;
        $scope.newCertificates.iva = 0;
        $scope.newCertificates.p_total = 0;
        $scope.newCertificates.comision = 0;
      }
      $scope.newCertificates.certificate_number = "";
      $scope.newCertificates.rec_antiguedad = datesFactory.convertDate(
        new Date()
      );
      $scope.newCertificates.start_of_validity = datesFactory.convertDate(
        $scope.caratula.start_of_validity
      );
      $scope.newCertificates.end_of_validity = datesFactory.convertDate(
        $scope.caratula.end_of_validity
      );
      $scope.newCertificates.p_neta = 0;
      $scope.newCertificates.rpf = 0;
      $scope.newCertificates.derecho = 0;
      $scope.newCertificates.iva = 0;
      $scope.newCertificates.p_total = 0;
      $scope.newCertificates.comision = 0;
      $scope.newCertificates.contributory = false;
    };

    $scope.addBeneficiarie = function () {
      if ($scope.newCertificates.relationship_accident) {
        var beneficiarie = {
          first_name: "",
          last_name: "",
          second_last_name: "",
          birthdate: datesFactory.convertDate(new Date()),
          sex: $scope.sexs[0],
          charge_date: $scope.startDate,
          familia: "",
          certificate: "",
          relationship: $scope.relationships[3],
          antiguedad: "",
          p_neta: 0,
          rpf: 0,
          derecho: 0,
          iva: 0,
          p_total: 0,
          comision: 0,
          contributory: $scope.newCertificates.contributory,
        };
        $scope.newCertificates.relationship_accident.push(beneficiarie);
      } else {
        var beneficiarie = {
          first_name: "",
          last_name: "",
          second_last_name: "",
          birthdate: datesFactory.convertDate(new Date()),
          sex: $scope.sexs[0],
          familia: "",
          certificate: "",
          optional_relationship: $scope.relationships[3],
          antiguedad: "",
        };
        $scope.newCertificates.beneficiaries_life.push(beneficiarie);
      }
      $scope.copy_iva.push(0);
    };

    $scope.deleteBeneficiarie = function (index) {
      if ($scope.newCertificates.relationship_accident) {
        $scope.newCertificates.relationship_accident.splice(index, 1);
      } else {
        $scope.newCertificates.beneficiaries_life.splice(index, 1);
      }
      $scope.copy_iva.splice(index, 1);
    };

    $scope.editCertificate = function () {
      if ($scope.newCertificates.start_of_validity.indexOf("-") != -1) {
        $scope.newCertificates.start_of_validity = datesFactory.convertDate(
          $scope.newCertificates.start_of_validity
        );
      }
      if ($scope.newCertificates.end_of_validity.indexOf("-") != -1) {
        $scope.newCertificates.end_of_validity = datesFactory.convertDate(
          $scope.newCertificates.end_of_validity
        );
      }
      if ($scope.newCertificates.life_policy.length) {
        if ($scope.newCertificates.rec_antiguedad) {
          if ($scope.newCertificates.rec_antiguedad.indexOf("-") != -1) {
            $scope.newCertificates.rec_antiguedad = datesFactory.convertDate(
              $scope.newCertificates.rec_antiguedad
            );
          }
        } else {
          $scope.newCertificates.rec_antiguedad = datesFactory.convertDate(
            new Date()
          );
        }
        if ($scope.newCertificates.personal.birthdate) {
          if ($scope.newCertificates.personal.birthdate.indexOf("-") != -1) {
            $scope.newCertificates.personal.birthdate =
              datesFactory.convertDate(
                $scope.newCertificates.personal.birthdate
              );
          }
        }
        $scope.sexs.forEach(function (item) {
          if (item.value == $scope.newCertificates.personal.sex) {
            $scope.newCertificates.personal.sex = item;
          }
        });
        $scope.typesInsureds.forEach(function (item) {
          if (item.value == $scope.newCertificates.personal.type_sa) {
            $scope.newCertificates.personal.type_sa = item;
          }
        });
        $scope.smokers.forEach(function (item) {
          if (item.value == $scope.newCertificates.life_policy[0].smoker) {
            $scope.newCertificates.smoker = item;
          }
        });
        $scope.newCertificates.sum_assured = parseFloat(
          $scope.newCertificates.sum_assured
        );
        $scope.newCertificates.salary = parseFloat(
          $scope.newCertificates.salary
        );
        $scope.newCertificates.beneficiaries_life.forEach(function (
          beneficiarie
        ) {
          if (beneficiarie.birthdate) {
            if (beneficiarie.birthdate.indexOf("-") != -1) {
              beneficiarie.birthdate = datesFactory.convertDate(
                beneficiarie.birthdate
              );
            }
          }
          $scope.sexs.forEach(function (item) {
            if (item.value == beneficiarie.sex) {
              beneficiarie.sex = item;
            }
          });
          $scope.relationships.forEach(function (item) {
            if (item.value == beneficiarie.optional_relationship) {
              beneficiarie.optional_relationship = item;
            }
          });
        });
      } else if ($scope.newCertificates.accidents_policy.length) {
        if ($scope.newCertificates.rec_antiguedad) {
          if ($scope.newCertificates.rec_antiguedad.indexOf("-") != -1) {
            $scope.newCertificates.rec_antiguedad = datesFactory.convertDate(
              $scope.newCertificates.rec_antiguedad
            );
          }
        } else {
          $scope.newCertificates.rec_antiguedad = datesFactory.convertDate(
            new Date()
          );
        }
        if ($scope.newCertificates.personal.birthdate) {
          if ($scope.newCertificates.personal.birthdate.indexOf("-") != -1) {
            $scope.newCertificates.personal.birthdate =
              datesFactory.convertDate(
                $scope.newCertificates.personal.birthdate
              );
          }
        }
        $scope.sexs.forEach(function (item) {
          if (item.value == $scope.newCertificates.personal.sex) {
            $scope.newCertificates.personal.sex = item;
          }
        });
        $scope.newCertificates.relationship_accident.forEach(function (
          beneficiarie
        ) {
          if (beneficiarie.birthdate) {
            if (beneficiarie.birthdate.indexOf("-") != -1) {
              beneficiarie.birthdate = datesFactory.convertDate(
                beneficiarie.birthdate
              );
            }
          }
          $scope.sexs.forEach(function (item) {
            if (item.value == beneficiarie.sex) {
              beneficiarie.sex = item;
            }
          });
          $scope.relationships.forEach(function (item) {
            if (item.value == beneficiarie.relationship) {
              beneficiarie.relationship = item;
            }
          });
        });
      } else if ($scope.newCertificates.automobiles_policy.length) {
        $scope.usages.forEach(function (item) {
          if (item.value == $scope.newCertificates.auto.usage) {
            $scope.newCertificates.auto.usage = item;
          }
        });
        $scope.typesCharges.forEach(function (item) {
          if (item.value == $scope.newCertificates.auto.charge_type) {
            $scope.newCertificates.auto.charge_type = item;
          }
        });
        $scope.procedencias.forEach(function (item) {
          if (item.value == $scope.newCertificates.auto.procedencia) {
            $scope.newCertificates.auto.procedencia = item;
          }
        });
        $scope.newCertificates.auto.mont_adjustment = parseFloat(
          $scope.newCertificates.auto.mont_adjustment
        );
        $scope.newCertificates.auto.mont_special_team = parseFloat(
          $scope.newCertificates.auto.mont_special_team
        );
      } else if ($scope.newCertificates.damages_policy.length) {
        $scope.typesConstruction.forEach(function (item) {
          if (
            item.value ==
            $scope.newCertificates.damages_policy[0].type_construction
          ) {
            $scope.newCertificates.auto.type_construction = item;
          }
        });
        $scope.usages.forEach(function (item) {
          if (item.value == $scope.newCertificates.auto.usage) {
            $scope.newCertificates.auto.usage = item;
          }
        });
        $scope.newCertificates.auto.no_levels = parseFloat(
          $scope.newCertificates.auto.no_levels
        );
        $scope.newCertificates.auto.purchase_value = parseFloat(
          $scope.newCertificates.auto.purchase_value
        );
      }

      $scope.newCertificates.p_neta = parseFloat($scope.newCertificates.p_neta);
      $scope.newCertificates.rpf = parseFloat($scope.newCertificates.rpf);
      $scope.newCertificates.derecho = parseFloat(
        $scope.newCertificates.derecho
      );
      $scope.newCertificates.iva = parseFloat($scope.newCertificates.iva);
      $scope.newCertificates.p_total = parseFloat(
        $scope.newCertificates.p_total
      );
      $scope.newCertificates.comision = parseFloat(
        $scope.newCertificates.comision
      );
    };

    $scope.showBeneficiaries = function (param) {
      $scope.checkDep = param;
      $scope.checkBeneficiaries = angular.copy(param);
      $rootScope.checkBeneficiaries = param;
      $scope.checkDependients = false;
    };

    $scope.addcertificates = function (param, chk) {
      $scope.certificates_selected_alta = $scope.certificates_selected_alta
        ? $scope.certificates_selected_alta
        : [];
      $scope.certificates_selected_alta.push(param);
      $scope.checkDependients = false;
      // $scope.showBeneficiaries(false);
      if ($scope.checkBeneficiaries) {
        var checkA = document.getElementById("checkB");
        checkA.click();
      }
      $scope.checkBeneficiaries = false;
      order.titular = [];
      $scope.newCertificates = [];
      $scope.createIndividualCertificate();
      $scope.sumatoria();
    };

    $scope.sumatoria = function () {
      $scope.suma_p_total = 0;
      $scope.certificates_selected_alta.forEach(function (item) {
        if ($scope.caratula.ramo.ramo_code == 2) {
          if (!item.personal.url) {
            $scope.suma_p_total = parseFloat(
              ($scope.suma_p_total + parseFloat(item.personal.p_total)).toFixed(
                2
              )
            );
          }

          if (item.relationship_accident.length) {
            item.relationship_accident.forEach(function (dep) {
              if (!dep.url) {
                $scope.suma_p_total = parseFloat(
                  ($scope.suma_p_total + parseFloat(dep.p_total)).toFixed(2)
                );
              }
            });
          }
        } else {
          if (!item.url) {
            $scope.suma_p_total = parseFloat(
              ($scope.suma_p_total + parseFloat(item.p_total)).toFixed(2)
            );
          }
        }
      });
      $scope.copy_iva = [0];
      $scope.copy_iva_ = 0;
      $scope.copy_iva_titular = 0;
      $scope.copy_iva_earned_titular = 0;
      $scope.copy_comision_earned_titular = 0;
      $scope.copy_comision_percent_earned_titular = 0;
      $scope.copy_iva_earned = [0];
      $scope.copy_comision_earned = [0];
      $scope.copy_comision_percent_earned = [0];
    };

    $scope.sumatoria_baja = function () {
      $scope.suma_p_total_baja = 0;
      $scope.certificates_selected.forEach(function (item) {
        if ($scope.caratula.ramo.ramo_code == 2) {
          if (!item.url) {
            $scope.suma_p_total_baja = parseFloat(
              (
                parseFloat($scope.suma_p_total_baja) +
                parseFloat(item.personal.p_total_earned)
              ).toFixed(2)
            );
          }
          if (item.personal.dependientes.length) {
            item.personal.dependientes.forEach(function (dep) {
              if (!dep.url) {
                $scope.suma_p_total_baja = parseFloat(
                  (
                    parseFloat($scope.suma_p_total_baja) +
                    parseFloat(dep.p_total_earned)
                  ).toFixed(2)
                );
              }
            });
          }
        } else {
          if (!item.url) {
            $scope.suma_p_total_baja = parseFloat(
              (
                parseFloat($scope.suma_p_total_baja) +
                parseFloat(item.p_total_earned)
              ).toFixed(2)
            );
          }
        }
      });
      $scope.copy_iva = [0];
      $scope.copy_iva_ = 0;
      $scope.copy_iva_titular = 0;
      $scope.copy_iva_earned_titular = 0;
      $scope.copy_comision_earned_titular = 0;
      $scope.copy_comision_percent_earned_titular = 0;
      $scope.copy_iva_earned = [0];
      $scope.copy_comision_earned = [0];
      $scope.copy_comision_percent_earned = [0];
    };

    $scope.getCertificates = function (parId) {
      $scope.autocompleteDataCertificate = [];
      if (!$scope.newCertificates.parent) {
        SweetAlert.swal("Error", "Selecciona una categoría.", "error");
        return;
      }
      if (parId) {
        if (parId.val.length >= 1) {
          $http({
            method: "POST",
            url: url.IP + "get-certificates-for-endoso/",
            data: {
              word: parId.val,
              id_collect: $scope.caratula.id,
              parent: $scope.newCertificates.parent.category_id,
            },
          })
            .then(
              function success(request) {
                if (request.status == 200) {
                  console.log("--newc", $scope.newCertificates);
                  if (request.data.length == 0) {
                    var source = [];
                    // SweetAlert.swal("Error", "Certificado no encontrado", "error");var source = [];
                  } else {
                    var source = [];
                    var titularFound = request.data;
                    if (titularFound.length) {
                      titularFound.forEach(function (item) {
                        var label;
                        if (item.accidents_policy.length) {
                          label =
                            "Certificado: " +
                            item.certificate_number +
                            " - Titular: " +
                            item.accidents_policy[0].personal.first_name +
                            " " +
                            item.accidents_policy[0].personal.last_name;
                        } else if (item.life_policy.length) {
                          label =
                            "Certificado: " +
                            item.certificate_number +
                            " - Titular: " +
                            item.life_policy[0].personal.first_name +
                            " " +
                            item.life_policy[0].personal.last_name;
                        } else if (item.automobiles_policy.length) {
                          label =
                            "Certificado: " +
                            item.certificate_number +
                            " - Marca: " +
                            item.automobiles_policy[0].brand +
                            " " +
                            item.automobiles_policy[0].model;
                        } else if (item.damages_policy.length) {
                          label =
                            "Certificado: " +
                            item.certificate_number +
                            " - Marca: " +
                            item.damages_policy[0].brand +
                            " " +
                            item.damages_policy[0].model;
                        }
                        var obj = {
                          label: label,
                          value: item,
                        };
                        source.push(obj);
                      });
                    }
                    $scope.autocompleteDataCertificate = source;
                    console.log("..", $scope.autocompleteDataCertificate);
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              // console.log('e', e);
            });
        }
      }
    };

    $scope.copy_iva = [0];
    $scope.copy_iva_earned = [0];
    $scope.copy_comision_earned = [0];
    $scope.copy_comision_percent_earned = [0];

    $scope.$watch("order.titular.value", function (newValue, oldValue) {
      if (order.titular) {
        if (order.titular.value) {
          if ($scope.edit_certificate) {
            $scope.newCertificates.personal = $scope.edit_dependient.personal;
            $scope.newCertificates.personal.p_neta =
              $scope.edit_dependient.personal.p_neta;
            $scope.newCertificates.personal.rpf =
              $scope.edit_dependient.personal.rpf;
            $scope.newCertificates.personal.derecho =
              $scope.edit_dependient.personal.derecho;
            $scope.newCertificates.personal.iva =
              $scope.edit_dependient.personal.iva;
            $scope.newCertificates.personal.p_total =
              $scope.edit_dependient.personal.p_total;
            $scope.newCertificates.personal.comision =
              $scope.edit_dependient.personal.comision;
            $scope.newCertificates.personal.comision_percent =
              $scope.edit_dependient.personal.comision_percent;
          } else {
            if ($scope.caratula.ramo.ramo_code == 2) {
              $scope.newCertificates.id = order.titular.value.id;
              $scope.newCertificates.certificate_number =
                order.titular.value.certificate_number;
              $scope.newCertificates.paquete = order.titular.value.paquete;
              $scope.newCertificates.contributory =
                order.titular.value.contributory;
              $scope.newCertificates.folio = order.titular.value.folio;
              $scope.newCertificates.rec_antiguedad = datesFactory.convertDate(
                order.titular.value.rec_antiguedad
              );
              $scope.newCertificates.start_of_validity =
                datesFactory.convertDate(new Date());
              $scope.newCertificates.end_of_validity = datesFactory.convertDate(
                $scope.caratula.end_of_validity
              );
              $scope.newCertificates.personal =
                order.titular.value.accidents_policy[0].personal;
              $scope.newCertificates.personal.birthdate =
                datesFactory.convertDate(
                  order.titular.value.accidents_policy[0].personal.birthdate
                );
              $scope.newCertificates.personal.charge_date = $scope
                .newCertificates.personal.charge_date
                ? datesFactory.convertDate(
                    order.titular.value.accidents_policy[0].personal.charge_date
                  )
                : datesFactory.convertDate(new Date());
              $scope.newCertificates.personal.p_neta = parseFloat(
                $scope.newCertificates.personal.p_neta
              );
              $scope.newCertificates.personal.rpf = parseFloat(
                $scope.newCertificates.personal.rpf
              );
              $scope.newCertificates.personal.derecho = parseFloat(
                $scope.newCertificates.personal.derecho
              );
              $scope.newCertificates.personal.iva = parseFloat(
                $scope.newCertificates.personal.iva
              );
              $scope.newCertificates.personal.p_total = parseFloat(
                $scope.newCertificates.personal.p_total
              );
              $scope.newCertificates.personal.comision = parseFloat(
                $scope.newCertificates.personal.comision
              );
              $scope.newCertificates.relationship_accident =
                order.titular.value.accidents_policy[0].relationship_accident;
              $scope.sexs.forEach(function (item) {
                if (item.value == $scope.newCertificates.personal.sex) {
                  $scope.newCertificates.personal.sex = item;
                }
              });
              $scope.newCertificates.personal.discharge_date = $scope.startDate;
              $scope.newCertificates.personal.p_neta_earned = 0;
              $scope.newCertificates.personal.descuento_earned = 0;
              $scope.newCertificates.personal.rpf_earned = 0;
              $scope.newCertificates.personal.derecho_earned = 0;
              $scope.newCertificates.personal.sub_total_earned = 0;
              $scope.newCertificates.personal.iva_earned = 0;
              $scope.newCertificates.personal.p_total_earned = 0;
              $scope.newCertificates.personal.comision_earned = 0;
              $scope.newCertificates.personal.comision_percent_earned = 0;

              $scope.newCertificates.dependientes =
                order.titular.value.accidents_policy[0].relationship_accident;
              $scope.newCertificates.dependientes.forEach(function (item) {
                item.certificate_number =
                  item.certificate +
                  " - " +
                  item.first_name +
                  " " +
                  item.last_name +
                  " " +
                  item.second_last_name;
                item.selected = false;
                item.birthdate = datesFactory.convertDate(item.birthdate);
                item.charge_date = item.charge_date
                  ? datesFactory.convertDate(item.charge_date)
                  : datesFactory.convertDate(new Date());
                item.p_neta = parseFloat(item.p_neta);
                item.rpf = parseFloat(item.rpf);
                item.derecho = parseFloat(item.derecho);
                item.iva = parseFloat(item.iva);
                item.p_total = parseFloat(item.p_total);
                item.comision = parseFloat(item.comision);
                $scope.sexs.forEach(function (sex) {
                  if (sex.value == item.sex) {
                    item.sex = sex;
                  }
                });
                $scope.relationships.forEach(function (rel) {
                  if (rel.value == item.relationship) {
                    item.relationship = rel;
                  }
                });
                item.discharge_date = $scope.startDate;
                item.p_neta_earned = 0;
                item.descuento_earned = 0;
                item.rpf_earned = 0;
                item.derecho_earned = 0;
                item.sub_total_earned = 0;
                item.iva_earned = 0;
                item.p_total_earned = 0;
                item.comision_earned = 0;
                item.comision_percent_earned = 0;

                $scope.copy_iva.push(0);
                $scope.copy_iva_earned.push(0);
                $scope.copy_comision_earned.push(0);
                $scope.copy_comision_percent_earned.push(0);
              });
            } else if ($scope.caratula.ramo.ramo_code == 1) {
              $scope.newCertificates.id = order.titular.value.id;
              $scope.newCertificates.certificate_number =
                order.titular.value.certificate_number;
              $scope.newCertificates.paquete = order.titular.value.paquete;
              $scope.newCertificates.folio = order.titular.value.folio;
              $scope.newCertificates.rec_antiguedad = datesFactory.convertDate(
                order.titular.value.rec_antiguedad
              );
              $scope.newCertificates.start_of_validity =
                datesFactory.convertDate(new Date());
              $scope.newCertificates.end_of_validity = datesFactory.convertDate(
                $scope.caratula.end_of_validity
              );
              $scope.newCertificates.personal =
                order.titular.value.life_policy[0].personal;
              $scope.newCertificates.personal.birthdate =
                datesFactory.convertDate(
                  order.titular.value.life_policy[0].personal.birthdate
                );
              $scope.newCertificates.smoker =
                order.titular.value.life_policy[0].smoker;
              $scope.newCertificates.p_neta = 0;
              $scope.newCertificates.rpf = 0;
              $scope.newCertificates.derecho = 0;
              $scope.newCertificates.iva = 0;
              $scope.newCertificates.p_total = 0;
              $scope.newCertificates.comision = 0;
              $scope.newCertificates.beneficiaries_life =
                order.titular.value.life_policy[0].beneficiaries_life;
              $scope.sexs.forEach(function (item) {
                if (item.value == $scope.newCertificates.personal.sex) {
                  $scope.newCertificates.personal.sex = item;
                }
              });
              $scope.typesInsureds.forEach(function (item) {
                if (item.value == $scope.newCertificates.personal.type_sa) {
                  $scope.newCertificates.personal.type_sa = item;
                }
              });
              $scope.smokers.forEach(function (item) {
                if (item.value == $scope.newCertificates.smoker) {
                  $scope.newCertificates.smoker = item;
                }
              });
              $scope.newCertificates.personal.discharge_date = $scope.startDate;
              $scope.newCertificates.personal.p_neta_earned = 0;
              $scope.newCertificates.personal.descuento_earned = 0;
              $scope.newCertificates.personal.rpf_earned = 0;
              $scope.newCertificates.personal.derecho_earned = 0;
              $scope.newCertificates.personal.sub_total_earned = 0;
              $scope.newCertificates.personal.iva_earned = 0;
              $scope.newCertificates.personal.p_total_earned = 0;
              $scope.newCertificates.personal.comision_earned = 0;
              $scope.newCertificates.personal.comision_percent_earned = 0;

              $scope.newCertificates.dependientes =
                order.titular.value.life_policy[0].beneficiaries_life;
              $scope.newCertificates.dependientes.forEach(function (item) {
                item.certificate_number =
                  item.certificate +
                  " - " +
                  item.first_name +
                  " " +
                  item.last_name +
                  " " +
                  item.second_last_name;
                item.selected = false;
                item.birthdate = datesFactory.convertDate(item.birthdate);
                $scope.sexs.forEach(function (sex) {
                  if (sex.value == item.sex) {
                    item.sex = sex;
                  }
                });
                $scope.relationships.forEach(function (rel) {
                  if (rel.value == item.relationship) {
                    item.relationship = rel;
                  }
                });
                item.discharge_date = $scope.startDate;
                item.p_neta_earned = 0;
                item.descuento_earned = 0;
                item.rpf_earned = 0;
                item.derecho_earned = 0;
                item.sub_total_earned = 0;
                item.iva_earned = 0;
                item.p_total_earned = 0;
                item.comision_earned = 0;
                item.comision_percent_earned = 0;
              });
            } else if ($scope.caratula.subramo.subramo_code == 9) {
              $scope.newCertificates.id = order.titular.value.id;
              $scope.newCertificates.auto =
                order.titular.value.automobiles_policy[0];
              $scope.newCertificates.discharge_date = $scope.startDate;
              $scope.newCertificates.p_neta = 0;
              $scope.newCertificates.rpf = 0;
              $scope.newCertificates.derecho = 0;
              $scope.newCertificates.iva = 0;
              $scope.newCertificates.p_total = 0;
              $scope.newCertificates.comision = 0;
              $scope.newCertificates.p_neta_earned = 0;
              $scope.newCertificates.descuento_earned = 0;
              $scope.newCertificates.rpf_earned = 0;
              $scope.newCertificates.derecho_earned = 0;
              $scope.newCertificates.sub_total_earned = 0;
              $scope.newCertificates.iva_earned = 0;
              $scope.newCertificates.p_total_earned = 0;
              $scope.newCertificates.comision_earned = 0;
              $scope.newCertificates.comision_percent_earned = 0;
            } else if (
              $scope.caratula.subramo.subramo_code == 7 ||
              $scope.caratula.subramo.subramo_code == 13
            ) {
              $scope.newCertificates.id = order.titular.value.id;
              $scope.newCertificates.auto =
                order.titular.value.damages_policy[0];
              $scope.newCertificates.discharge_date = $scope.startDate;
              $scope.newCertificates.p_neta = 0;
              $scope.newCertificates.rpf = 0;
              $scope.newCertificates.derecho = 0;
              $scope.newCertificates.iva = 0;
              $scope.newCertificates.p_total = 0;
              $scope.newCertificates.comision = 0;
              $scope.newCertificates.p_neta_earned = 0;
              $scope.newCertificates.descuento_earned = 0;
              $scope.newCertificates.rpf_earned = 0;
              $scope.newCertificates.derecho_earned = 0;
              $scope.newCertificates.sub_total_earned = 0;
              $scope.newCertificates.iva_earned = 0;
              $scope.newCertificates.p_total_earned = 0;
              $scope.newCertificates.comision_earned = 0;
              $scope.newCertificates.comision_percent_earned = 0;
            }
          }
        }
      }
    });

    $scope.showDependients = function (param) {
      $scope.checkDependients = param;
      $scope.newCertificates.dependientes.forEach(function (item) {
        item.selected = param;
      });
    };

    $scope.checkcert = function (param, value) {
      param.selected = value;
    };

    $scope.copy_iva_titular = 0;
    $scope.changePrima = function (param) {
      param.p_neta = String(String(param.p_neta).split("..").join("."))
        .split(",")
        .join("");
      param.rpf = String(String(param.rpf).split("..").join("."))
        .split(",")
        .join("");
      param.derecho = String(String(param.derecho).split("..").join("."))
        .split(",")
        .join("");
      param.iva = String(String(param.iva).split("..").join("."))
        .split(",")
        .join("");
      param.p_total = String(String(param.p_total).split("..").join("."))
        .split(",")
        .join("");
      param.comision = String(String(param.comision).split("..").join("."))
        .split(",")
        .join("");
      var p_neta = parseFloat(param.p_neta ? param.p_neta : 0).toFixed(2);
      var rpf = parseFloat(param.rpf ? param.rpf : 0).toFixed(2);
      var derecho = parseFloat(param.derecho ? param.derecho : 0).toFixed(2);
      // param.sub_total = parseFloat(param.sub_total).toFixed(2);
      var iva = parseFloat(param.iva ? param.iva : 0).toFixed(2);
      var p_total = parseFloat(param.p_total ? param.p_total : 0).toFixed(2);
      var comision = parseFloat(param.comision ? param.comision : 0).toFixed(2);

      var sub_total = parseFloat(
        parseFloat(
          parseFloat(p_neta) + parseFloat(rpf) + parseFloat(derecho)
        ).toFixed(2)
      );

      if ($scope.caratula.ramo.ramo_code == 1) {
        param.iva = 0;
      } else {
        var iva = parseFloat(
          parseFloat(parseFloat(sub_total) * 0.16).toFixed(2)
        );
        param.iva = iva;
        $scope.copy_iva_titular = angular.copy(iva);
      }
      var p_total = parseFloat(
        parseFloat(parseFloat(sub_total) + parseFloat(iva)).toFixed(2)
      );
      param.p_total = parseFloat(p_total);
    };
    $scope.changePrimaIva = function (param) {
      param.p_neta = String(String(param.p_neta).split("..").join("."))
        .split(",")
        .join("");
      param.rpf = String(String(param.rpf).split("..").join("."))
        .split(",")
        .join("");
      param.derecho = String(String(param.derecho).split("..").join("."))
        .split(",")
        .join("");
      param.iva = String(String(param.iva).split("..").join("."))
        .split(",")
        .join("");
      param.p_total = String(String(param.p_total).split("..").join("."))
        .split(",")
        .join("");
      param.comision = String(String(param.comision).split("..").join("."))
        .split(",")
        .join("");
      var p_neta = parseFloat(param.p_neta ? param.p_neta : 0).toFixed(2);
      var rpf = parseFloat(param.rpf ? param.rpf : 0).toFixed(2);
      var derecho = parseFloat(param.derecho ? param.derecho : 0).toFixed(2);
      // param.sub_total = parseFloat(param.sub_total).toFixed(2);
      var iva = parseFloat(param.iva ? param.iva : 0).toFixed(2);
      var p_total = parseFloat(param.p_total ? param.p_total : 0).toFixed(2);
      var comision = parseFloat(param.comision ? param.comision : 0).toFixed(2);

      var sub_total = parseFloat(
        parseFloat(
          parseFloat(p_neta) + parseFloat(rpf) + parseFloat(derecho)
        ).toFixed(2)
      );

      if ($scope.caratula.ramo.ramo_code == 1) {
        param.iva = 0;
      }

      var p_total = parseFloat(
        parseFloat(parseFloat(sub_total) + parseFloat(iva)).toFixed(2)
      );
      param.p_total = parseFloat(p_total);
    };

    $scope.copy_iva = [0];
    $scope.changePrimaBeneficiarie = function (param, index) {
      if (!param.url) {
        $scope.newCertificates.relationship_accident[index].p_neta = parseFloat(
          $scope.newCertificates.relationship_accident[index].p_neta
        ).toFixed(2);
        $scope.newCertificates.relationship_accident[index].rpf = parseFloat(
          $scope.newCertificates.relationship_accident[index].rpf
        ).toFixed(2);
        $scope.newCertificates.relationship_accident[index].derecho =
          parseFloat(
            $scope.newCertificates.relationship_accident[index].derecho
          ).toFixed(2);
        // param.sub_total = parseFloat(param.sub_total).toFixed(2);
        $scope.newCertificates.relationship_accident[index].iva = parseFloat(
          $scope.newCertificates.relationship_accident[index].iva
        ).toFixed(2);
        $scope.newCertificates.relationship_accident[index].p_total =
          parseFloat(
            $scope.newCertificates.relationship_accident[index].p_total
          ).toFixed(2);
        $scope.newCertificates.relationship_accident[index].comision =
          parseFloat(
            $scope.newCertificates.relationship_accident[index].comision
          ).toFixed(2);

        $scope.newCertificates.relationship_accident[index].sub_total =
          parseFloat(
            parseFloat(
              parseFloat(
                $scope.newCertificates.relationship_accident[index].p_neta
              ) +
                parseFloat(
                  $scope.newCertificates.relationship_accident[index].rpf
                ) +
                parseFloat(
                  $scope.newCertificates.relationship_accident[index].derecho
                )
            ).toFixed(2)
          );
        if (
          $scope.copy_iva[index] ==
          $scope.newCertificates.relationship_accident[index].iva
        ) {
          $scope.newCertificates.relationship_accident[index].iva = parseFloat(
            (
              parseFloat(
                $scope.newCertificates.relationship_accident[index].sub_total
              ) * 0.16
            ).toFixed(2)
          );
          $scope.copy_iva[index] = angular.copy(
            $scope.newCertificates.relationship_accident[index].iva
          );
        }

        $scope.newCertificates.relationship_accident[index].p_total =
          parseFloat(
            parseFloat(
              parseFloat(
                $scope.newCertificates.relationship_accident[index].sub_total
              ) +
                parseFloat(
                  $scope.newCertificates.relationship_accident[index].iva
                )
            ).toFixed(2)
          );
      }
    };

    $scope.copy_iva_earned_titular = 0;
    $scope.copy_comision_earned_titular = 0;
    $scope.copy_comision_percent_earned_titular = 0;
    $scope.changePrimaTutular = function (param) {
      var p_neta_earned = parseFloat(
        param.p_neta_earned ? param.p_neta_earned : 0
      ).toFixed(2);
      var rpf_earned = parseFloat(
        param.rpf_earned ? param.rpf_earned : 0
      ).toFixed(2);
      var derecho_earned = parseFloat(
        param.derecho_earned ? param.derecho_earned : 0
      ).toFixed(2);
      // param.sub_total = parseFloat(param.sub_total).toFixed(2);
      var iva_earned = parseFloat(
        param.iva_earned ? param.iva_earned : 0
      ).toFixed(2);
      var p_total_earned = parseFloat(
        param.p_total_earned ? param.p_total_earned : 0
      ).toFixed(2);
      var comision_earned = parseFloat(
        param.comision_earned ? param.comision_earned : 0
      ).toFixed(2);

      var sub_total = parseFloat(
        parseFloat(
          parseFloat(p_neta_earned) +
            parseFloat(rpf_earned) +
            parseFloat(derecho_earned)
        ).toFixed(2)
      );

      if ($scope.caratula.ramo.ramo_code == 1) {
        param.iva_earned = 0;
      } else {
        var iva_earned = parseFloat(
          parseFloat(parseFloat(sub_total) * 0.16).toFixed(2)
        );
        param.iva_earned = iva_earned;
        $scope.copy_iva_titular = angular.copy(iva_earned);
      }
      var p_total_earned = parseFloat(
        parseFloat(parseFloat(sub_total) + parseFloat(iva_earned)).toFixed(2)
      );
      param.p_total_earned = parseFloat(p_total_earned);
      if ($scope.copy_comision_earned_titular != param.comision_earned) {
        param.comision_percent_earned = parseFloat(
          (
            parseFloat(param.comision_earned * 100) / param.p_total_earned
          ).toFixed(2)
        );
        $scope.copy_comision_percent_earned_titular = angular.copy(
          param.comision_percent_earned
        );
        $scope.copy_comision_earned_titular = angular.copy(
          param.comision_earned
        );
      } else {
        if (
          $scope.copy_comision_percent_earned_titular !=
          param.comision_percent_earned
        ) {
          param.comision_earned = parseFloat(
            (
              parseFloat(param.comision_percent_earned * param.p_total_earned) /
              100
            ).toFixed(2)
          );
          $scope.copy_comision_earned_titular = angular.copy(
            param.comision_earned
          );
        } else {
          $scope.copy_comision_percent_earned_titular = angular.copy(
            param.comision_percent_earned
          );
        }
      }
    };
    $scope.changePrimaTutularIva = function (param) {
      var p_neta_earned = parseFloat(
        param.p_neta_earned ? param.p_neta_earned : 0
      ).toFixed(2);
      var rpf_earned = parseFloat(
        param.rpf_earned ? param.rpf_earned : 0
      ).toFixed(2);
      var derecho_earned = parseFloat(
        param.derecho_earned ? param.derecho_earned : 0
      ).toFixed(2);
      // param.sub_total = parseFloat(param.sub_total).toFixed(2);
      var iva_earned = parseFloat(
        param.iva_earned ? param.iva_earned : 0
      ).toFixed(2);
      var p_total_earned = parseFloat(
        param.p_total_earned ? param.p_total_earned : 0
      ).toFixed(2);
      var comision_earned = parseFloat(
        param.comision_earned ? param.comision_earned : 0
      ).toFixed(2);

      var sub_total = parseFloat(
        parseFloat(
          parseFloat(p_neta_earned) +
            parseFloat(rpf_earned) +
            parseFloat(derecho_earned)
        ).toFixed(2)
      );

      if ($scope.caratula.ramo.ramo_code == 1) {
        param.iva_earned = 0;
      } else {
        var iva_earned = parseFloat(
          parseFloat(parseFloat(sub_total) + parseFloat(iva_earned)).toFixed(2)
        );
        var sub_total = parseFloat(iva_earned).toFixed(2);
        // param.iva_earned = iva_earned
        $scope.copy_iva_titular = angular.copy(iva_earned);
      }
      var p_total_earned = parseFloat(
        parseFloat(parseFloat(sub_total)).toFixed(2)
      );
      console.log("---dddd", p_total_earned, iva_earned, sub_total);
      param.p_total_earned = parseFloat(p_total_earned);
      if ($scope.copy_comision_earned_titular != param.comision_earned) {
        param.comision_percent_earned = parseFloat(
          (
            parseFloat(param.comision_earned * 100) / param.p_total_earned
          ).toFixed(2)
        );
        $scope.copy_comision_percent_earned_titular = angular.copy(
          param.comision_percent_earned
        );
        $scope.copy_comision_earned_titular = angular.copy(
          param.comision_earned
        );
      } else {
        if (
          $scope.copy_comision_percent_earned_titular !=
          param.comision_percent_earned
        ) {
          param.comision_earned = parseFloat(
            (
              parseFloat(param.comision_percent_earned * param.p_total_earned) /
              100
            ).toFixed(2)
          );
          $scope.copy_comision_earned_titular = angular.copy(
            param.comision_earned
          );
        } else {
          $scope.copy_comision_percent_earned_titular = angular.copy(
            param.comision_percent_earned
          );
        }
      }
    };
    $scope.copy_iva_earned = [0];
    $scope.copy_comision_earned = [0];
    $scope.copy_comision_percent_earned = [0];
    $scope.changePrimaDependient = function (param, index) {
      if ($scope.newCertificates) {
        if ($scope.newCertificates.dependientes) {
          if ($scope.newCertificates.dependientes.length) {
            $scope.newCertificates.dependientes[index].p_neta_earned =
              parseFloat(
                $scope.newCertificates.dependientes[
                  index
                ].p_neta_earned.toFixed(2)
              );
            $scope.newCertificates.dependientes[index].rpf_earned = parseFloat(
              $scope.newCertificates.dependientes[index].rpf_earned.toFixed(2)
            );
            $scope.newCertificates.dependientes[index].derecho_earned =
              parseFloat(
                $scope.newCertificates.dependientes[
                  index
                ].derecho_earned.toFixed(2)
              );
            $scope.newCertificates.dependientes[index].sub_total_earned =
              parseFloat(
                $scope.newCertificates.dependientes[
                  index
                ].sub_total_earned.toFixed(2)
              );
            $scope.newCertificates.dependientes[index].iva_earned = parseFloat(
              $scope.newCertificates.dependientes[index].iva_earned.toFixed(2)
            );
            $scope.newCertificates.dependientes[index].p_total_earned =
              parseFloat(
                $scope.newCertificates.dependientes[
                  index
                ].p_total_earned.toFixed(2)
              );
            $scope.newCertificates.dependientes[index].comision_earned =
              parseFloat(
                $scope.newCertificates.dependientes[
                  index
                ].comision_earned.toFixed(2)
              );
            $scope.newCertificates.dependientes[index].comision_percent_earned =
              parseFloat(
                $scope.newCertificates.dependientes[
                  index
                ].comision_percent_earned.toFixed(2)
              );

            $scope.newCertificates.dependientes[index].sub_total_earned =
              parseFloat(
                parseFloat(
                  $scope.newCertificates.dependientes[index].p_neta_earned +
                    $scope.newCertificates.dependientes[index].rpf_earned +
                    $scope.newCertificates.dependientes[index].derecho_earned
                ).toFixed(2)
              );

            if (
              $scope.copy_iva_earned[index] ==
              $scope.newCertificates.dependientes[index].iva_earned
            ) {
              $scope.newCertificates.dependientes[index].iva_earned =
                parseFloat(
                  parseFloat(
                    $scope.newCertificates.dependientes[index]
                      .sub_total_earned * 0.16
                  ).toFixed(2)
                );
              $scope.copy_iva_earned[index] = angular.copy(
                $scope.newCertificates.dependientes[index].iva_earned
              );
            }

            $scope.newCertificates.dependientes[index].p_total_earned =
              parseFloat(
                parseFloat(
                  $scope.newCertificates.dependientes[index].sub_total_earned +
                    $scope.newCertificates.dependientes[index].iva_earned
                ).toFixed(2)
              );

            if (
              $scope.copy_comision_earned[index] !=
              $scope.newCertificates.dependientes[index].comision_earned
            ) {
              $scope.newCertificates.dependientes[
                index
              ].comision_percent_earned = parseFloat(
                (
                  parseFloat(
                    $scope.newCertificates.dependientes[index].comision_earned *
                      100
                  ) / $scope.newCertificates.dependientes[index].p_total_earned
                ).toFixed(2)
              );
              $scope.copy_comision_percent_earned[index] = angular.copy(
                $scope.newCertificates.dependientes[index]
                  .comision_percent_earned
              );
              $scope.copy_comision_earned[index] = angular.copy(
                $scope.newCertificates.dependientes[index].comision_earned
              );
            } else {
              if (
                $scope.copy_comision_percent_earned[index] !=
                $scope.newCertificates.dependientes[index]
                  .comision_percent_earned
              ) {
                $scope.newCertificates.dependientes[index].comision_earned =
                  parseFloat(
                    (
                      parseFloat(
                        $scope.newCertificates.dependientes[index]
                          .comision_percent_earned *
                          $scope.newCertificates.dependientes[index]
                            .p_total_earned
                      ) / 100
                    ).toFixed(2)
                  );
                $scope.copy_comision_earned[index] = angular.copy(
                  $scope.newCertificates.dependientes[index].comision_earned
                );
              } else {
                $scope.copy_comision_percent_earned[index] = angular.copy(
                  $scope.newCertificates.dependientes[index]
                    .comision_percent_earned
                );
              }
            }
          } else {
            param.p_neta_earned = parseFloat(
              parseFloat(param.p_neta_earned).toFixed(2)
            );
            param.rpf_earned = parseFloat(
              parseFloat(param.rpf_earned).toFixed(2)
            );
            param.derecho_earned = parseFloat(
              parseFloat(param.derecho_earned).toFixed(2)
            );
            param.iva_earned = parseFloat(
              parseFloat(param.iva_earned).toFixed(2)
            );
            param.p_total_earned = parseFloat(
              parseFloat(param.p_total_earned).toFixed(2)
            );
            param.comision_earned = parseFloat(
              parseFloat(param.comision_earned).toFixed(2)
            );

            param.sub_total_earned = parseFloat(
              parseFloat(
                parseFloat(param.p_neta_earned) +
                  parseFloat(param.rpf_earned) +
                  parseFloat(param.derecho_earned)
              ).toFixed(2)
            );

            if ($scope.copy_iva_ == param.iva_earned) {
              param.iva_earned = parseFloat(
                parseFloat(param.sub_total_earned * 0.16).toFixed(2)
              );
              $scope.copy_iva_ = angular.copy(param.iva_earned);
            }

            param.p_total_earned = parseFloat(
              parseFloat(param.sub_total_earned + param.iva_earned).toFixed(2)
            );
          }
        } else {
          param.p_neta_earned = parseFloat(
            parseFloat(param.p_neta_earned).toFixed(2)
          );
          param.rpf_earned = parseFloat(
            parseFloat(param.rpf_earned).toFixed(2)
          );
          param.derecho_earned = parseFloat(
            parseFloat(param.derecho_earned).toFixed(2)
          );
          param.iva_earned = parseFloat(
            parseFloat(param.iva_earned).toFixed(2)
          );
          param.p_total_earned = parseFloat(
            parseFloat(param.p_total_earned).toFixed(2)
          );
          param.comision_earned = parseFloat(
            parseFloat(param.comision_earned).toFixed(2)
          );

          param.sub_total_earned = parseFloat(
            parseFloat(
              param.p_neta_earned + param.rpf_earned + param.derecho_earned
            ).toFixed(2)
          );

          if ($scope.copy_iva_ == param.iva_earned) {
            param.iva_earned = parseFloat(
              parseFloat(param.sub_total_earned * 0.16).toFixed(2)
            );
            $scope.copy_iva_ = angular.copy(param.iva_earned);
          }

          param.p_total_earned = parseFloat(
            parseFloat(param.sub_total_earned + param.iva_earned).toFixed(2)
          );
        }
      } else {
        param.p_neta_earned = parseFloat(
          parseFloat(param.p_neta_earned).toFixed(2)
        );
        param.rpf_earned = parseFloat(parseFloat(param.rpf_earned).toFixed(2));
        param.derecho_earned = parseFloat(
          parseFloat(param.derecho_earned).toFixed(2)
        );
        param.iva_earned = parseFloat(parseFloat(param.iva_earned).toFixed(2));
        param.p_total_earned = parseFloat(
          parseFloat(param.p_total_earned).toFixed(2)
        );
        param.comision_earned = parseFloat(
          parseFloat(param.comision_earned).toFixed(2)
        );

        param.sub_total_earned = parseFloat(
          parseFloat(
            param.p_neta_earned + param.rpf_earned + param.derecho_earned
          ).toFixed(2)
        );

        if ($scope.copy_iva_ == param.iva_earned) {
          param.iva_earned = parseFloat(
            parseFloat(param.sub_total_earned * 0.16).toFixed(2)
          );
          $scope.copy_iva_ = angular.copy(param.iva_earned);
        }

        param.p_total_earned = parseFloat(
          parseFloat(param.sub_total_earned + param.iva_earned).toFixed(2)
        );
      }
    };

    $scope.copy_iva_ = 0;
    $scope.changePrimaCertificate = function (param) {
      param.p_neta = parseFloat(param.p_neta).toFixed(2);
      param.rpf = parseFloat(param.rpf).toFixed(2);
      param.derecho = parseFloat(param.derecho).toFixed(2);
      param.iva = parseFloat(param.iva).toFixed(2);
      param.p_total = parseFloat(param.p_total).toFixed(2);
      param.comision = parseFloat(param.comision).toFixed(2);

      param.sub_total = parseFloat(
        parseFloat(
          parseFloat(param.p_neta) +
            parseFloat(param.rpf) +
            parseFloat(param.derecho)
        ).toFixed(2)
      );
      console.log(param.sub_total);
      if ($scope.copy_iva_ == param.iva) {
        param.iva = parseFloat(parseFloat(param.sub_total * 0.16).toFixed(2));
        $scope.copy_iva_ = angular.copy(param.iva);
      }

      param.p_total = parseFloat(
        parseFloat(param.sub_total + parseFloat(param.iva)).toFixed(2)
      );
    };

    $scope.addcertificate = function () {
      $scope.selectedOnlyDepsBen = false;
      if ($scope.newCertificates) {
        if ($scope.newCertificates.dependientes) {
          if ($scope.newCertificates.dependientes.length) {
            $scope.newCertificates.dependientes.forEach(function (item, index) {
              if (item.selected) {
                $scope.selectedOnlyDepsBen = true;
              }
            });
          }
        }
      }
      if (
        !$scope.checkDependients &&
        $scope.typeSelected.name == "D" &&
        $scope.descriptionSelected.id == 25 &&
        $scope.caratula.ramo.ramo_code == 2 &&
        !$scope.selectedOnlyDepsBen
      ) {
        SweetAlert.swal(
          {
            title: "Baja Certificado",
            text: "Si no selecciona el check de: Baja a titular y dependientes, no se dará de Baja el Certificado.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, continuar.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              // continuar
              var dep = [];
              if ($scope.caratula.ramo.ramo_code == 2) {
                if ($scope.newCertificates.dependientes.length > 0) {
                  $scope.newCertificates.dependientes.forEach(function (
                    item,
                    index
                  ) {
                    if (item.selected) {
                      var obj_d = {
                        certificate: item.certificate,
                        first_name: item.first_name,
                        last_name: item.last_name,
                        second_last_name: item.second_last_name,
                        p_neta_earned: item.p_neta_earned,
                        descuento_earned: item.descuento_earned,
                        rpf_earned: item.rpf_earned,
                        derecho_earned: item.derecho_earned,
                        sub_total_earned: item.sub_total_earned,
                        iva_earned: item.iva_earned,
                        p_total_earned: item.p_total_earned,
                        comision_earned: item.comision_earned,
                        comision_percent_earned: item.comision_percent_earned,
                        discharge_date: datesFactory.toDate(
                          item.discharge_date
                        ),
                        id: item.id,
                      };
                      dep.push(obj_d);
                    }
                    if (
                      $scope.newCertificates.dependientes.length ==
                      index + 1
                    ) {
                      var obj_p = {
                        first_name: $scope.newCertificates.personal.first_name,
                        last_name: $scope.newCertificates.personal.last_name,
                        second_last_name:
                          $scope.newCertificates.personal.second_last_name,
                        certificate_number:
                          $scope.newCertificates.personal.certificate,
                        parent: $scope.newCertificates.id,
                        p_neta_earned:
                          $scope.newCertificates.personal.p_neta_earned,
                        descuento_earned:
                          $scope.newCertificates.personal.descuento_earned,
                        rpf_earned: $scope.newCertificates.personal.rpf_earned,
                        derecho_earned:
                          $scope.newCertificates.personal.derecho_earned,
                        sub_total_earned:
                          $scope.newCertificates.personal.sub_total_earned,
                        iva_earned: $scope.newCertificates.personal.iva_earned,
                        p_total_earned:
                          $scope.newCertificates.personal.p_total_earned,
                        comision_earned:
                          $scope.newCertificates.personal.comision_earned,
                        comision_percent_earned:
                          $scope.newCertificates.personal
                            .comision_percent_earned,
                        discharge_date: datesFactory.toDate(
                          $scope.newCertificates.personal.discharge_date
                        ),
                        dependientes: dep,
                        is_active: $scope.checkDependients ? true : false,
                        id: $scope.newCertificates.personal.id,
                      };
                      $scope.newCertificates.personal = obj_p;
                      if (!$scope.checkDependients) {
                        $scope.newCertificates.personal.discharge_date = null;
                      }
                      var obj = {
                        categoria: $scope.newCertificates.parent,
                        personal: $scope.newCertificates.personal,
                        certificate_number:
                          $scope.newCertificates.personal.certificate,
                        id: $scope.newCertificates.id,
                      };
                      $scope.certificates_selected.push(obj);
                      $scope.certificados.push(obj);
                      $scope.checkDependients = false;
                      order.titular = [];
                      $scope.newCertificates = [];

                      $scope.sumatoria_baja();
                    }
                  });
                } else {
                  $scope.newCertificates.personal.dependientes = dep;
                  $scope.newCertificates.personal.is_active =
                    $scope.checkDependients ? true : false;
                  if (!$scope.checkDependients) {
                    $scope.newCertificates.personal.discharge_date = null;
                  }
                  var obj = {
                    categoria: $scope.newCertificates.parent,
                    personal: $scope.newCertificates.personal,
                    certificate_number:
                      $scope.newCertificates.personal.certificate,
                    id: $scope.newCertificates.id,
                  };
                  $scope.certificates_selected.push(obj);
                  $scope.certificados.push(obj);
                  $scope.checkDependients = false;
                  order.titular = [];
                  $scope.newCertificates = [];

                  $scope.sumatoria_baja();
                }
              } else if ($scope.caratula.ramo.ramo_code == 1) {
                if ($scope.newCertificates.dependientes.length > 0) {
                  $scope.newCertificates.dependientes.forEach(function (
                    item,
                    index
                  ) {
                    if (item.selected) {
                      var obj_d = {
                        certificate: item.certificate,
                        first_name: item.first_name,
                        last_name: item.last_name,
                        second_last_name: item.second_last_name,
                        p_neta_earned: item.p_neta_earned,
                        descuento_earned: item.descuento_earned,
                        rpf_earned: item.rpf_earned,
                        derecho_earned: item.derecho_earned,
                        sub_total_earned: item.sub_total_earned,
                        iva_earned: item.iva_earned,
                        p_total_earned: item.p_total_earned,
                        comision_earned: item.comision_earned,
                        comision_percent_earned: item.comision_percent_earned,
                        discharge_date: datesFactory.toDate(
                          item.discharge_date
                        ),
                        id: item.id,
                      };
                      dep.push(obj_d);
                    }
                    if (
                      $scope.newCertificates.dependientes.length ==
                      index + 1
                    ) {
                      var obj_p = {
                        first_name: $scope.newCertificates.personal.first_name,
                        last_name: $scope.newCertificates.personal.last_name,
                        second_last_name:
                          $scope.newCertificates.personal.second_last_name,
                        certificate_number:
                          $scope.newCertificates.personal.certificate,
                        parent: $scope.newCertificates.id,
                        p_neta_earned:
                          $scope.newCertificates.personal.p_neta_earned,
                        descuento_earned:
                          $scope.newCertificates.personal.descuento_earned,
                        rpf_earned: $scope.newCertificates.personal.rpf_earned,
                        derecho_earned:
                          $scope.newCertificates.personal.derecho_earned,
                        sub_total_earned:
                          $scope.newCertificates.personal.sub_total_earned,
                        iva_earned: $scope.newCertificates.personal.iva_earned,
                        p_total_earned:
                          $scope.newCertificates.personal.p_total_earned,
                        comision_earned:
                          $scope.newCertificates.personal.comision_earned,
                        comision_percent_earned:
                          $scope.newCertificates.personal
                            .comision_percent_earned,
                        discharge_date: datesFactory.toDate(
                          $scope.newCertificates.personal.discharge_date
                        ),
                        dependientes: dep,
                        id: $scope.newCertificates.id,
                      };
                      $scope.newCertificates.personal = obj_p;
                      if (!$scope.checkDependients) {
                        $scope.newCertificates.personal.discharge_date = null;
                      }
                      var obj = {
                        categoria: $scope.newCertificates.parent,
                        personal: $scope.newCertificates.personal,
                        certificate_number:
                          $scope.newCertificates.certificate_number,
                        id: $scope.newCertificates.id,
                        parent: $scope.newCertificates.id,
                      };
                      $scope.certificates_selected.push(obj);
                      $scope.certificados.push(obj);
                      $scope.checkDependients = false;
                      order.titular = [];
                      $scope.newCertificates = [];
                    }
                  });
                } else {
                  $scope.newCertificates.personal.dependientes = dep;
                  if (!$scope.checkDependients) {
                    $scope.newCertificates.personal.discharge_date = null;
                  }
                  var obj = {
                    categoria: $scope.newCertificates.parent,
                    personal: $scope.newCertificates.personal,
                    certificate_number:
                      $scope.newCertificates.certificate_number,
                    id: $scope.newCertificates.id,
                    parent: $scope.newCertificates.id,
                  };
                  $scope.certificates_selected.push(obj);
                  $scope.certificados.push(obj);
                  $scope.checkDependients = false;
                  order.titular = [];
                  $scope.newCertificates = [];
                }
              } else if ($scope.caratula.subramo.subramo_code == 9) {
                var obj_p = {
                  brand: $scope.newCertificates.auto.brand,
                  model: $scope.newCertificates.auto.model,
                  serial: $scope.newCertificates.auto.serial,
                  certificate_number: $scope.newCertificates.certificate,
                  parent: $scope.newCertificates.id,
                  p_neta_earned: $scope.newCertificates.p_neta_earned,
                  descuento_earned: $scope.newCertificates.descuento_earned,
                  rpf_earned: $scope.newCertificates.rpf_earned,
                  derecho_earned: $scope.newCertificates.derecho_earned,
                  sub_total_earned: $scope.newCertificates.sub_total_earned,
                  iva_earned: $scope.newCertificates.iva_earned,
                  p_total_earned: $scope.newCertificates.p_total_earned,
                  comision_earned: $scope.newCertificates.comision_earned,
                  comision_percent_earned:
                    $scope.newCertificates.comision_percent_earned,
                  discharge_date: datesFactory.toDate(
                    $scope.newCertificates.discharge_date
                  ),
                  dependientes: dep,
                  id: $scope.newCertificates.id,
                };
                $scope.newCertificates.auto = obj_p;
                var obj = {
                  categoria: $scope.newCertificates.parent,
                  personal: $scope.newCertificates.auto,
                  certificate_number: $scope.newCertificates.certificate_number,
                  id: $scope.newCertificates.id,
                  parent: $scope.newCertificates.id,
                };
                $scope.certificates_selected.push(obj);
                $scope.certificados.push(obj);
                order.titular = [];
                $scope.newCertificates = [];
              } else if (
                $scope.caratula.subramo.subramo_code == 7 ||
                $scope.caratula.subramo.subramo_code == 13
              ) {
                var obj_p = {
                  brand: $scope.newCertificates.auto.brand,
                  model: $scope.newCertificates.auto.model,
                  serial: $scope.newCertificates.auto.serial,
                  certificate_number: $scope.newCertificates.certificate,
                  parent: $scope.newCertificates.id,
                  p_neta_earned: $scope.newCertificates.p_neta_earned,
                  descuento_earned: $scope.newCertificates.descuento_earned,
                  rpf_earned: $scope.newCertificates.rpf_earned,
                  derecho_earned: $scope.newCertificates.derecho_earned,
                  sub_total_earned: $scope.newCertificates.sub_total_earned,
                  iva_earned: $scope.newCertificates.iva_earned,
                  p_total_earned: $scope.newCertificates.p_total_earned,
                  comision_earned: $scope.newCertificates.comision_earned,
                  comision_percent_earned:
                    $scope.newCertificates.comision_percent_earned,
                  discharge_date: datesFactory.toDate(
                    $scope.newCertificates.discharge_date
                  ),
                  dependientes: dep,
                  id: $scope.newCertificates.id,
                };
                $scope.newCertificates.auto = obj_p;
                var obj = {
                  categoria: $scope.newCertificates.parent,
                  personal: $scope.newCertificates.auto,
                  certificate_number: $scope.newCertificates.certificate_number,
                  id: $scope.newCertificates.id,
                  parent: $scope.newCertificates.id,
                };
                $scope.certificates_selected.push(obj);
                $scope.certificados.push(obj);
                order.titular = [];
                $scope.newCertificates = [];
              }
            } else {
              return;
            }
          }
        );
      } else {
        var dep = [];
        if ($scope.caratula.ramo.ramo_code == 2) {
          if ($scope.newCertificates.dependientes.length > 0) {
            $scope.newCertificates.dependientes.forEach(function (item, index) {
              if (item.selected) {
                var obj_d = {
                  certificate: item.certificate,
                  first_name: item.first_name,
                  last_name: item.last_name,
                  second_last_name: item.second_last_name,
                  p_neta_earned: item.p_neta_earned,
                  descuento_earned: item.descuento_earned,
                  rpf_earned: item.rpf_earned,
                  derecho_earned: item.derecho_earned,
                  sub_total_earned: item.sub_total_earned,
                  iva_earned: item.iva_earned,
                  p_total_earned: item.p_total_earned,
                  comision_earned: item.comision_earned,
                  comision_percent_earned: item.comision_percent_earned,
                  discharge_date: datesFactory.toDate(item.discharge_date),
                  id: item.id,
                };
                dep.push(obj_d);
              }
              if ($scope.newCertificates.dependientes.length == index + 1) {
                var obj_p = {
                  first_name: $scope.newCertificates.personal.first_name,
                  last_name: $scope.newCertificates.personal.last_name,
                  second_last_name:
                    $scope.newCertificates.personal.second_last_name,
                  certificate_number:
                    $scope.newCertificates.personal.certificate,
                  parent: $scope.newCertificates.id,
                  p_neta_earned: $scope.newCertificates.personal.p_neta_earned,
                  descuento_earned:
                    $scope.newCertificates.personal.descuento_earned,
                  rpf_earned: $scope.newCertificates.personal.rpf_earned,
                  derecho_earned:
                    $scope.newCertificates.personal.derecho_earned,
                  sub_total_earned:
                    $scope.newCertificates.personal.sub_total_earned,
                  iva_earned: $scope.newCertificates.personal.iva_earned,
                  p_total_earned:
                    $scope.newCertificates.personal.p_total_earned,
                  comision_earned:
                    $scope.newCertificates.personal.comision_earned,
                  comision_percent_earned:
                    $scope.newCertificates.personal.comision_percent_earned,
                  discharge_date: datesFactory.toDate(
                    $scope.newCertificates.personal.discharge_date
                  ),
                  dependientes: dep,
                  is_active: $scope.checkDependients ? true : false,
                  id: $scope.newCertificates.personal.id,
                };
                $scope.newCertificates.personal = obj_p;
                if (!$scope.checkDependients) {
                  $scope.newCertificates.personal.discharge_date = null;
                }
                var obj = {
                  categoria: $scope.newCertificates.parent,
                  personal: $scope.newCertificates.personal,
                  certificate_number:
                    $scope.newCertificates.personal.certificate,
                  id: $scope.newCertificates.id,
                };
                $scope.certificates_selected.push(obj);
                $scope.certificados.push(obj);
                $scope.checkDependients = false;
                order.titular = [];
                $scope.newCertificates = [];

                $scope.sumatoria_baja();
              }
            });
          } else {
            $scope.newCertificates.personal.dependientes = dep;
            $scope.newCertificates.personal.is_active = $scope.checkDependients
              ? true
              : false;
            if (!$scope.checkDependients) {
              $scope.newCertificates.personal.discharge_date = null;
            }
            var obj = {
              categoria: $scope.newCertificates.parent,
              personal: $scope.newCertificates.personal,
              certificate_number: $scope.newCertificates.personal.certificate,
              id: $scope.newCertificates.id,
            };
            $scope.certificates_selected.push(obj);
            $scope.certificados.push(obj);
            $scope.checkDependients = false;
            order.titular = [];
            $scope.newCertificates = [];

            $scope.sumatoria_baja();
          }
        } else if ($scope.caratula.ramo.ramo_code == 1) {
          if ($scope.newCertificates.dependientes.length > 0) {
            $scope.newCertificates.dependientes.forEach(function (item, index) {
              if (item.selected) {
                var obj_d = {
                  certificate: item.certificate,
                  first_name: item.first_name,
                  last_name: item.last_name,
                  second_last_name: item.second_last_name,
                  p_neta_earned: item.p_neta_earned,
                  descuento_earned: item.descuento_earned,
                  rpf_earned: item.rpf_earned,
                  derecho_earned: item.derecho_earned,
                  sub_total_earned: item.sub_total_earned,
                  iva_earned: item.iva_earned,
                  p_total_earned: item.p_total_earned,
                  comision_earned: item.comision_earned,
                  comision_percent_earned: item.comision_percent_earned,
                  discharge_date: datesFactory.toDate(item.discharge_date),
                  id: item.id,
                };
                dep.push(obj_d);
              }
              if ($scope.newCertificates.dependientes.length == index + 1) {
                var obj_p = {
                  first_name: $scope.newCertificates.personal.first_name,
                  last_name: $scope.newCertificates.personal.last_name,
                  second_last_name:
                    $scope.newCertificates.personal.second_last_name,
                  certificate_number:
                    $scope.newCertificates.personal.certificate,
                  parent: $scope.newCertificates.id,
                  p_neta_earned: $scope.newCertificates.personal.p_neta_earned,
                  descuento_earned:
                    $scope.newCertificates.personal.descuento_earned,
                  rpf_earned: $scope.newCertificates.personal.rpf_earned,
                  derecho_earned:
                    $scope.newCertificates.personal.derecho_earned,
                  sub_total_earned:
                    $scope.newCertificates.personal.sub_total_earned,
                  iva_earned: $scope.newCertificates.personal.iva_earned,
                  p_total_earned:
                    $scope.newCertificates.personal.p_total_earned,
                  comision_earned:
                    $scope.newCertificates.personal.comision_earned,
                  comision_percent_earned:
                    $scope.newCertificates.personal.comision_percent_earned,
                  discharge_date: datesFactory.toDate(
                    $scope.newCertificates.personal.discharge_date
                  ),
                  dependientes: dep,
                  id: $scope.newCertificates.id,
                };
                $scope.newCertificates.personal = obj_p;
                if (!$scope.checkDependients) {
                  $scope.newCertificates.personal.discharge_date = null;
                }
                var obj = {
                  categoria: $scope.newCertificates.parent,
                  personal: $scope.newCertificates.personal,
                  certificate_number: $scope.newCertificates.certificate_number,
                  id: $scope.newCertificates.id,
                  parent: $scope.newCertificates.id,
                };
                $scope.certificates_selected.push(obj);
                $scope.certificados.push(obj);
                $scope.checkDependients = false;
                order.titular = [];
                $scope.newCertificates = [];
              }
            });
          } else {
            $scope.newCertificates.personal.dependientes = dep;
            if (!$scope.checkDependients) {
              $scope.newCertificates.personal.discharge_date = null;
            }
            var obj = {
              categoria: $scope.newCertificates.parent,
              personal: $scope.newCertificates.personal,
              certificate_number: $scope.newCertificates.certificate_number,
              id: $scope.newCertificates.id,
              parent: $scope.newCertificates.id,
            };
            $scope.certificates_selected.push(obj);
            $scope.certificados.push(obj);
            $scope.checkDependients = false;
            order.titular = [];
            $scope.newCertificates = [];
          }
        } else if ($scope.caratula.subramo.subramo_code == 9) {
          var obj_p = {
            brand: $scope.newCertificates.auto.brand,
            model: $scope.newCertificates.auto.model,
            serial: $scope.newCertificates.auto.serial,
            certificate_number: $scope.newCertificates.certificate,
            parent: $scope.newCertificates.id,
            p_neta_earned: $scope.newCertificates.p_neta_earned,
            descuento_earned: $scope.newCertificates.descuento_earned,
            rpf_earned: $scope.newCertificates.rpf_earned,
            derecho_earned: $scope.newCertificates.derecho_earned,
            sub_total_earned: $scope.newCertificates.sub_total_earned,
            iva_earned: $scope.newCertificates.iva_earned,
            p_total_earned: $scope.newCertificates.p_total_earned,
            comision_earned: $scope.newCertificates.comision_earned,
            comision_percent_earned:
              $scope.newCertificates.comision_percent_earned,
            discharge_date: datesFactory.toDate(
              $scope.newCertificates.discharge_date
            ),
            dependientes: dep,
            id: $scope.newCertificates.id,
          };
          $scope.newCertificates.auto = obj_p;
          var obj = {
            categoria: $scope.newCertificates.parent,
            personal: $scope.newCertificates.auto,
            certificate_number: $scope.newCertificates.certificate_number,
            id: $scope.newCertificates.id,
            parent: $scope.newCertificates.id,
          };
          $scope.certificates_selected.push(obj);
          $scope.certificados.push(obj);
          order.titular = [];
          $scope.newCertificates = [];
        } else if (
          $scope.caratula.subramo.subramo_code == 7 ||
          $scope.caratula.subramo.subramo_code == 13
        ) {
          var obj_p = {
            brand: $scope.newCertificates.auto.brand,
            model: $scope.newCertificates.auto.model,
            serial: $scope.newCertificates.auto.serial,
            certificate_number: $scope.newCertificates.certificate,
            parent: $scope.newCertificates.id,
            p_neta_earned: $scope.newCertificates.p_neta_earned,
            descuento_earned: $scope.newCertificates.descuento_earned,
            rpf_earned: $scope.newCertificates.rpf_earned,
            derecho_earned: $scope.newCertificates.derecho_earned,
            sub_total_earned: $scope.newCertificates.sub_total_earned,
            iva_earned: $scope.newCertificates.iva_earned,
            p_total_earned: $scope.newCertificates.p_total_earned,
            comision_earned: $scope.newCertificates.comision_earned,
            comision_percent_earned:
              $scope.newCertificates.comision_percent_earned,
            discharge_date: datesFactory.toDate(
              $scope.newCertificates.discharge_date
            ),
            dependientes: dep,
            id: $scope.newCertificates.id,
          };
          $scope.newCertificates.auto = obj_p;
          var obj = {
            categoria: $scope.newCertificates.parent,
            personal: $scope.newCertificates.auto,
            certificate_number: $scope.newCertificates.certificate_number,
            id: $scope.newCertificates.id,
            parent: $scope.newCertificates.id,
          };
          $scope.certificates_selected.push(obj);
          $scope.certificados.push(obj);
          order.titular = [];
          $scope.newCertificates = [];
        }
      }
      SweetAlert.swal(
        "¡Listo!",
        "Se agregó un certificado a la lista del endoso.",
        "success"
      );
      $scope.saveLocalstorange();
    };

    $scope.cancelDependient = function (chk) {
      $scope.checkBeneficiaries = false;
      $scope.showBeneficiaries(false);
      $scope.checkDependients = false;
      order.titular = [];
      $scope.createIndividualCertificate();
    };

    $scope.editDependient = function (param, index) {
      $scope.edit_certificate = true;
      $scope.edit_dependient = param;
      $scope.index_dependient = index;
      $http
        .get(param.personal.policy)
        .then(function success(response) {
          order.titular.val =
            "Certificado: " +
            param.personal.certificate +
            " - Titular: " +
            param.personal.first_name +
            " " +
            param.personal.last_name;
          order.titular.value = response.data;
          $scope.checkDependients = true;
          $scope.showDependients($scope.checkDependients);
        })
        .catch(function (error) {
          // console.log('Error - claves-by-provider - catch', error);
        });
    };

    $scope.deleteDependient = function (index) {
      if ($scope.certificates_selected.length) {
        $scope.certificates_selected.splice(index, 1);
        $scope.sumatoria_baja();
      } else {
        $scope.certificates_selected_alta.splice(index, 1);
        $scope.sumatoria();
      }
      $scope.certificados.splice(index, 1);
    };

    $scope.uptadeCertificate = function (param) {
      var obj = {
        categoria: param.parent,
        personal: param.personal,
        dependientes: param.dependientes,
      };
      $scope.certificates_selected[$scope.index_dependient] = obj;
    };

    $scope.validateEmail = function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.changeMovement = function (param) {
      $scope.movementSelected = param;
      $scope.copy_description = angular.copy(param);
      $scope.descriptionSelected = param;
      $localStorage.save_created_endoso_grupo.movimiento = param;
      if (param.id == 24) {
        $scope.fillData($scope.types[1]);
        $scope.typeSelected = $scope.types[1];
      } else if (param.id == 25) {
        $scope.fillData($scope.types[3]);
        $scope.typeSelected = $scope.types[3];
      }
      $scope.showFields($scope.descriptionSelected);
    };
    function esAutoadministrada(val) {
      return (
        val === "Autoadministrada" || val === 2 || val === "2" || val === true
      );
    }
    order.addReceipts = addReceipts;
    function addReceipts(valor) {
      $scope.directiveReceipts.generarRecibosExcepcional = valor;
      $scope.generarRecibosExcepcional = valor;
      if ($scope.descriptionSelected) {
        if ($scope.descriptionSelected.id != 1) {
          $scope.totalReceipts = [{ id: 0, name: 0 }];
          var isAuto = esAutoadministrada(
            $scope.caratula && $scope.caratula.administration_type
          );
          var exc = !!$scope.generarRecibosExcepcional;
          var is36 = $scope.descriptionSelected.id === 36;

          if (isAuto && !exc) {
            $scope.totalReceipts = is36
              ? [{ id: 1, name: 1 }]
              : [{ id: 0, name: 0 }];
          } else {
            if (is36) {
              $scope.totalReceipts = [{ id: 1, name: 1 }];
            } else {
              if (valor) {
                for (var i = 1; i <= 12; i++) {
                  $scope.totalReceipts.push({ id: i, name: i });
                }
              }
            }
          }
        }
      } else {
        console.log("iiiiiiiii", $scope.descriptionSelected);
      }
    }
    $scope.validateExcel = function (param) {
      $scope.descriptionSelected = $scope.movementSelected;
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.VIDA) {
        if ($scope.caratula.ramo.ramo_code == 1) {
          $scope.beneficiaries_life = [];
          $scope.dependientes_add = [];
          $scope.excelJson = param.VIDA;
          $scope.excelJson.forEach(function (item) {
            if (!item.FAMILIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FAMILIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if ($scope.checkRegister) {
              if (!item.CERTIFICADO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.TIPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.TIPO < 1 || item.TIPO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.PARENTESCO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PARENTESCO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.PARENTESCO < 1 || item.PARENTESCO > 4) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PARENTESCO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.NOMBRE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_PATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_MATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.FECHA_NACIMIENTO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SEXO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SEXO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (item.SEXO.length > 1) {
                SweetAlert.swal(
                  "Error",
                  "Los valores de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO no son válidos, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.FECHA_ANTIGUEDAD) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_ANTIGUEDAD)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.TIPO_SUMA_ASEGURADA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO_SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO_SUMA_ASEGURADA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (
                  item.TIPO_SUMA_ASEGURADA < 1 ||
                  item.TIPO_SUMA_ASEGURADA > 2
                ) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO_SUMA_ASEGURADA no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.SUMA_ASEGURADA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SUELDO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUELDO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.FUMADOR) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FUMADOR, corrige el error y vuelve a subir el excel..",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.FUMADOR)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FUMADOR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.FUMADOR < 0 || item.FUMADOR > 1) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FUMADOR no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
            try {
              if (item.PRIMA_NETA_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DESCUENTO_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DESCUENTO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION_PORCENTAJE_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_PORCENTAJE_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}

            if (item.TIPO == 2) {
              var dataBeneficiary = {
                familia: item.FAMILIA,
                certificate: item.CERTIFICADO,
                optional_relationship: item.PARENTESCO,
                first_name: item.NOMBRE,
                last_name: item.APELLIDO_PATERNO,
                second_last_name: item.APELLIDO_MATERNO,
                birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                sex: item.SEXO,
                antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                percentage: 0,
              };
              $scope.beneficiaries_life.push(dataBeneficiary);
            }
            // Solo dependientes
            if (item.TIPO == 3) {
              var dataBensExistCerts = {
                familia: item.FAMILIA,
                certificate: item.CERTIFICADO,
                optional_relationship: item.PARENTESCO,
                first_name: item.NOMBRE,
                last_name: item.APELLIDO_PATERNO,
                second_last_name: item.APELLIDO_MATERNO,
                birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                sex: item.SEXO,
                antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                percentage: 0,
                tipo: item.TIPO,
                parent: item.CATEGORIA,
                ramo_code: $scope.caratula.ramo.ramo_code,
                caratula: $scope.caratula.id,
              };
              $scope.dependientes_add.push(dataBensExistCerts);
            }
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.ASEGURADOS) {
        if ($scope.caratula.ramo.ramo_code == 2) {
          $scope.contributory = false;
          $scope.beneficiaries_medical = [];
          $scope.dependientes_add = [];
          $scope.excelJson = param.ASEGURADOS;
          $scope.excelJson.forEach(function (item) {
            if ("RFC_CVE" in item) {
              $scope.contributory = true;
            }
            if (!item.FAMILIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FAMILIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if ($scope.checkRegister) {
              if (!item.CERTIFICADO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.TIPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.TIPO < 1 || item.TIPO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.PARENTESCO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PARENTESCO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.PARENTESCO < 1 || item.PARENTESCO > 4) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PARENTESCO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.NOMBRE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_PATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_MATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.FECHA_NACIMIENTO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            // if (item.TIPO == 3) {
            //   if(!item.FECHA_BAJA){
            //     SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna FECHA_BAJA, corrige el error y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            //   else{
            //     if(!$scope.validateDate(item.FECHA_BAJA)){
            //       SweetAlert.swal('Error', 'Formato inválido de la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna FECHA_BAJA, corrige el error y vuelve a subir el excel.', 'error');
            //       flagCertificate = true;
            //     }
            //   }
            // }
            if (!item.SEXO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SEXO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (item.SEXO.length > 1) {
                SweetAlert.swal(
                  "Error",
                  "Los valores de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO no son válidos, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.FECHA_ANTIGUEDAD) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_ANTIGUEDAD)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
            // try{
            //   if(item.PRIMA_NETA_NO_DEV.indexOf(',') > -1){
            //     SweetAlert.swal('Error', 'Esta linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna PRIMA_NETA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            //   if(item.RPF_NO_DEV.indexOf(',') > -1){
            //     SweetAlert.swal('Error', 'Esta linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna RPF_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            //   if(item.DERECHO_NO_DEV.indexOf(',') > -1){
            //     SweetAlert.swal('Error', 'Esta linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna DERECHO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            //   if(item.IVA_NO_DEV.indexOf(',') > -1){
            //     SweetAlert.swal('Error', 'Esta linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna IVA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            //   if(item.PRIMA_TOTAL_NO_DEV.indexOf(',') > -1){
            //     SweetAlert.swal('Error', 'Esta linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna PRIMA_TOTAL_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            //   if(item.COMISION_NO_DEV.indexOf(',') > -1){
            //     SweetAlert.swal('Error', 'Esta linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna COMISION_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            //   if(item.DESCUENTO_NO_DEV.indexOf(',') > -1){
            //     SweetAlert.swal('Error', 'Esta linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna DESCUENTO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            //   if(item.COMISION_PORCENTAJE_NO_DEV.indexOf(',') > -1){
            //     SweetAlert.swal('Error', 'Esta linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna COMISION_PORCENTAJE_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            // }catch(e){}
            if (item.TIPO == 2) {
              var dataBeneficiary = {
                familia: item.FAMILIA,
                certificate: item.CERTIFICADO,
                relationship: item.PARENTESCO,
                first_name: item.NOMBRE,
                last_name: item.APELLIDO_PATERNO,
                second_last_name: item.APELLIDO_MATERNO,
                birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                sex: item.SEXO,
                antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                clause: item.FAMILIA,
                p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                rpf: item.RPF ? item.RPF : 0,
                derecho: item.DERECHO ? item.DERECHO : 0,
                iva: item.IVA ? item.IVA : 0,
                p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
                comision: item.COMISION ? item.COMISION : 0,
                comision_earned: item.COMISION_NO_DEV
                  ? item.COMISION_NO_DEV
                  : 0,
                p_neta_earned: item.PRIMA_NETA_NO_DEV
                  ? item.PRIMA_NETA_NO_DEV
                  : 0,
                p_total_earned: item.PRIMA_TOTAL_NO_DEV
                  ? item.PRIMA_TOTAL_NO_DEV
                  : 0,
                iva_earned: item.IVA_NO_DEV ? item.IVA_NO_DEV : 0,
                rpf_earned: item.RPF_NO_DEV ? item.RPF_NO_DEV : 0,
                derecho_earned: item.DERECHO_NO_DEV ? item.DERECHO_NO_DEV : 0,
                descuento_earned: item.DESCUENTO_NO_DEV
                  ? item.DESCUENTO_NO_DEV
                  : 0,
                comision_percent_earned: item.COMISION_PORCENTAJE_NO_DEV
                  ? item.COMISION_PORCENTAJE_NO_DEV
                  : 0,
                discharge_date: item.FECHA_BAJA
                  ? datesFactory.toDate(item.FECHA_BAJA)
                  : null,
                contributory: $scope.contributory ? $scope.contributory : false,
                rfc_cve: item.RFC_CVE ? item.RFC_CVE : "",
                rfc_homocve: item.RFC_HOMOCVE ? item.RFC_HOMOCVE : "",
                dom_callenum: item.DOM_CALLE_NUM ? item.DOM_CALLE_NUM : "",
                dom_colonia: item.DOM_COLONIA ? item.DOM_COLONIA : "",
                dom_cp: item.DOM_CP ? item.DOM_CP : "",
                dom_poblacion: item.DOM_POBLACION ? item.DOM_POBLACION : "",
                dom_estado: item.DOM_ESTADO ? item.DOM_ESTADO : "",
              };
              $scope.beneficiaries_medical.push(dataBeneficiary);
            }
            // Solo dependientes
            if (item.TIPO == 3) {
              var dataDepsExistCerts = {
                familia: item.FAMILIA,
                certificate: item.CERTIFICADO,
                relationship: item.PARENTESCO,
                first_name: item.NOMBRE,
                last_name: item.APELLIDO_PATERNO,
                second_last_name: item.APELLIDO_MATERNO,
                birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                sex: item.SEXO,
                antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                rpf: item.RPF ? item.RPF : 0,
                derecho: item.DERECHO ? item.DERECHO : 0,
                iva: item.IVA ? item.IVA : 0,
                p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
                comision: item.COMISION ? item.COMISION : 0,
                tipo: item.TIPO,
                parent: item.CATEGORIA,
                ramo_code: $scope.caratula.ramo.ramo_code,
                caratula: $scope.caratula.id,
                comision_earned: item.COMISION_NO_DEV
                  ? item.COMISION_NO_DEV
                  : 0,
                p_neta_earned: item.PRIMA_NETA_NO_DEV
                  ? item.PRIMA_NETA_NO_DEV
                  : 0,
                p_total_earned: item.PRIMA_TOTAL_NO_DEV
                  ? item.PRIMA_TOTAL_NO_DEV
                  : 0,
                iva_earned: item.IVA_NO_DEV ? item.IVA_NO_DEV : 0,
                rpf_earned: item.RPF_NO_DEV ? item.RPF_NO_DEV : 0,
                derecho_earned: item.DERECHO_NO_DEV ? item.DERECHO_NO_DEV : 0,
                descuento_earned: item.DESCUENTO_NO_DEV
                  ? item.DESCUENTO_NO_DEV
                  : 0,
                comision_percent_earned: item.COMISION_PORCENTAJE_NO_DEV
                  ? item.COMISION_PORCENTAJE_NO_DEV
                  : 0,
                discharge_date: item.FECHA_BAJA
                  ? datesFactory.toDate(item.FECHA_BAJA)
                  : null,
                contributory: $scope.contributory ? $scope.contributory : false,
                rfc_cve: item.RFC_CVE ? item.RFC_CVE : "",
                rfc_homocve: item.RFC_HOMOCVE ? item.RFC_HOMOCVE : "",
                dom_callenum: item.DOM_CALLE_NUM ? item.DOM_CALLE_NUM : "",
                dom_colonia: item.DOM_COLONIA ? item.DOM_COLONIA : "",
                dom_cp: item.DOM_CP ? item.DOM_CP : "",
                dom_poblacion: item.DOM_POBLACION ? item.DOM_POBLACION : "",
                dom_estado: item.DOM_ESTADO ? item.DOM_ESTADO : "",
              };
              $scope.dependientes_add.push(dataDepsExistCerts);
            }
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.FLOTILLA) {
        if ($scope.caratula.subramo.subramo_code == 9) {
          $scope.excelJson = param.FLOTILLA;
          $scope.excelJson.forEach(function (item) {
            if (!item.INCISO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.MARCA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MODELO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.AÑO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna AÑO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SERVICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERVICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.PROCEDENCIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PROCEDENCIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.PROCEDENCIA < 0 || item.PROCEDENCIA > 4) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PROCEDENCIA no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.USO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna USO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.USO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.USO < 1 || item.USO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.VERSION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SERIE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
            try {
              if (item.PRIMA_NETA_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DESCUENTO_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DESCUENTO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION_PORCENTAJE_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_PORCENTAJE_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.DANIOS_DIVERSO) {
        if ($scope.caratula.subramo.subramo_code == 13) {
          $scope.excelJson = param.DANIOS_DIVERSO;
          $scope.excelJson.forEach(function (item) {
            if (!item.INCISO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.MARCA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MODELO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.DESCRIPCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DESCRIPCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.AÑO_CONSTRUCCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna AÑO_CONSTRUCCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.AÑO_RECONSTRUCCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna AÑO_RECONSTRUCCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.VALOR_COMPRA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VALOR_COMPRA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.USO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna USO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.USO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.USO < 1 || item.USO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.VERSION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SERIE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
            try {
              if (item.PRIMA_NETA_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DESCUENTO_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DESCUENTO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION_PORCENTAJE_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_PORCENTAJE_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.DANIOS_IRC) {
        if ($scope.caratula.subramo.subramo_code == 7) {
          $scope.excelJson = param.DANIOS_IRC;
          $scope.excelJson.forEach(function (item) {
            if (!item.INCISO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUCURSAL) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUCURSAL, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.GIRO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna GIRO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.TIPO_CONSTRUCTIVO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO_CONSTRUCTIVO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO_CONSTRUCTIVO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_CONSTRUCTIVO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.TIPO_CONSTRUCTIVO < 1 || item.TIPO_CONSTRUCTIVO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO_CONSTRUCTIVO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.NO_NIVELES) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_NIVELES, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.ZONA_FHM) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ZONA_FHM, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.ZONA_TYEV) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ZONA_TYEV, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CALLE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CALLE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.NO_INTERIOR) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_INTERIOR, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.NO_EXTERIOR) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_EXTERIOR, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MUNICIPIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MUNICIPIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.COLONIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna COLONIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CIUDAD) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CIUDAD, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.ESTADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ESTADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CP) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CP, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
            try {
              if (item.PRIMA_NETA_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DESCUENTO_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DESCUENTO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION_PORCENTAJE_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_PORCENTAJE_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.BAJA_DB) {
        $scope.excelJson = param.BAJA_DB;
        $scope.excelJson.forEach(function (item) {
          if (!item.INCISO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna INCISO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CATEGORIA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (isNaN(item.CATEGORIA)) {
              SweetAlert.swal(
                "Error",
                "Formato inválido de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          }
          if (!item.NOMBRE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.AP_PATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna AP_PATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.AP_MATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna AP_MATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
        });
        if (!flagCertificate) {
          $scope.selectedCertificates = param;
          $scope.addViews(0);
        }
      } else if (param.BAJA) {
        $scope.excelJson = param.BAJA;
        $scope.excelJson.forEach(function (item) {
          if (!item.INCISO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna INCISO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CATEGORIA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (isNaN(item.CATEGORIA)) {
              SweetAlert.swal(
                "Error",
                "Formato inválido de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          }
          if (!item.TIPO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna TIPO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (isNaN(item.TIPO)) {
              SweetAlert.swal(
                "Error",
                "Formato inválido de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (item.TIPO < 1 || item.TIPO > 3) {
                SweetAlert.swal(
                  "Error",
                  "Los valores de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
          }
          if (item.TIPO == 2 || item.TIPO == "2") {
            if (!item.NOMBRE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.AP_PATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna AP_PATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.AP_MATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna AP_MATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.TIPO == 3) {
              if (!item.FECHA_BAJA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_BAJA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.FECHA_BAJA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FECHA_BAJA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            try {
              if (item.PRIMA_NETA_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DESCUENTO_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DESCUENTO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION_PORCENTAJE_NO_DEV.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_PORCENTAJE_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
          }
        });
        if (!flagCertificate) {
          $scope.selectedCertificates = param;
          $scope.addViews(0);
        }
      } else if (param.ALTA_DB) {
        $scope.excelJson = param.ALTA_DB;
        $scope.excelJson.forEach(function (item) {
          if (!item.INCISO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna INCISO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CATEGORIA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (isNaN(item.CATEGORIA)) {
              SweetAlert.swal(
                "Error",
                "Formato inválido de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          }
          if (!item.NOMBRE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.AP_PATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna AP_PATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.AP_MATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna AP_MATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.FECHA_NACIMIENTO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
              SweetAlert.swal(
                "Error",
                "Formato inválido de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          }
          if (!item.SEXO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna SEXO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (item.SEXO.length > 1) {
              SweetAlert.swal(
                "Error",
                "Los valores de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SEXO no son válidos, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          }
          // if ($scope.caratula.ramo.ramo_code ==1) {
          //   if(item.PORCENTAJE){
          //     SweetAlert.swal('Error', 'Los valores de la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna PORCENTAJE no son válidos, corrige el error y vuelve a subir el excel.', 'error');
          //     flagCertificate = true;
          //   }
          // }
          try {
            if (item.PRIMA_NETA.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.RPF.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.DERECHO.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.IVA.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.PRIMA_TOTAL.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.COMISION.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          } catch (e) {}
          try {
            if (item.PRIMA_NETA_NO_DEV.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PRIMA_NETA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.RPF_NO_DEV.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RPF_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.DERECHO_NO_DEV.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DERECHO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.IVA_NO_DEV.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna IVA_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.PRIMA_TOTAL_NO_DEV.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PRIMA_TOTAL_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.COMISION_NO_DEV.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna COMISION_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.DESCUENTO_NO_DEV.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DESCUENTO_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.COMISION_PORCENTAJE_NO_DEV.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna COMISION_PORCENTAJE_NO_DEV contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          } catch (e) {}
        });
        if (!flagCertificate) {
          $scope.selectedCertificates = param;
          $scope.addViews(0);
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          if (item.AÑO_CONSTRUCCION) {
            item.ANO_CONSTRUCCION = item.AÑO_CONSTRUCCION;
            item.ANO_RECONSTRUCCION = item.AÑO_RECONSTRUCCION;
          }
          if (item.AÑO) {
            item.ANO = item.AÑO;
          }
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.cancelCertificates = function () {
      $scope.showTableCertificates = false;
      $scope.loader = false;
      $scope.selectedCertificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.saveCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      $scope.loader = true;
      $scope.certificados = [];
      $scope.certificates_selected_alta = [];
      if ($scope.selectedCertificates.VIDA) {
        $scope.selectedCertificates.VIDA.forEach(function (item) {
          $scope.tipoUpload = item.TIPO;
          $scope.item = item;
          if (item.TIPO == 1) {
            var dataLife = [
              {
                personal: {
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                  antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  salary: item.SUELDO ? parseInt(item.SUELDO) : 0,
                  sum_assured: item.SUMA_ASEGURADA
                    ? parseInt(item.SUMA_ASEGURADA)
                    : 0,
                  type_sa: item.TIPO_SUMA_ASEGURADA
                    ? parseInt(item.TIPO_SUMA_ASEGURADA)
                    : 0,
                },
                smoker: item.FUMADOR
                  ? item.FUMADOR == 0
                    ? false
                    : true
                  : null,
                beneficiaries_life: [],
              },
            ];

            $scope.beneficiaries_life.forEach(function (beneficiarie) {
              if (beneficiarie.familia == item.FAMILIA) {
                dataLife[0].beneficiaries_life.push(beneficiarie);
              }
            });

            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            if (item.SUBGRUPO) {
              $scope.subgrupos.forEach(function (itemSubgrupo) {
                if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                  if (itemSubgrupo.address) {
                    contractor_certificate = itemSubgrupo.contractor
                      ? itemSubgrupo.contractor.id
                      : null;
                  } else {
                    contractor_certificate = $scope.caratula.contractor
                      ? $scope.caratula.contractor
                      : null;
                  }
                }
              });
            } else {
              contractor_certificate = $scope.caratula.contractor
                ? $scope.caratula.contractor
                : null;
            }

            var certificateData = {
              caratula: $scope.caratula.id,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number:
                $scope.caratula.poliza_number + " - INC. " + item.CERTIFICADO,
              contractor: contractor_certificate,
              ramo: $scope.caratula.ramo.id,
              subramo: $scope.caratula.subramo.id,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
              end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
              status: $scope.caratula.status == "Vigente" ? 14 : 1,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: [],
              life_policy: dataLife,
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "VIDA_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
              rpf: item.RPF ? item.RPF : 0,
              derecho: item.DERECHO ? item.DERECHO : 0,
              iva: item.IVA ? item.IVA : 0,
              p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
              comision: item.COMISION ? item.COMISION : 0,
              rec_antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
              comision_earned: item.COMISION_NO_DEV ? item.COMISION_NO_DEV : 0,
              p_neta_earned: item.PRIMA_NETA_NO_DEV
                ? item.PRIMA_NETA_NO_DEV
                : 0,
              p_total_earned: item.PRIMA_TOTAL_NO_DEV
                ? item.PRIMA_TOTAL_NO_DEV
                : 0,
              iva_earned: item.IVA_NO_DEV ? item.IVA_NO_DEV : 0,
              rpf_earned: item.RPF_NO_DEV ? item.RPF_NO_DEV : 0,
              derecho_earned: item.DERECHO_NO_DEV ? item.DERECHO_NO_DEV : 0,
              descuento_earned: item.DESCUENTO_NO_DEV
                ? item.DESCUENTO_NO_DEV
                : 0,
              comision_percent_earned: item.COMISION_PORCENTAJE_NO_DEV
                ? item.COMISION_PORCENTAJE_NO_DEV
                : 0,
              fecha_baja_inciso: item.FECHA_BAJA
                ? datesFactory.toDate(item.FECHA_BAJA)
                : null,
            };

            $scope.certificados.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.ASEGURADOS) {
        $scope.contributory = false;
        $scope.selectedCertificates.ASEGURADOS.forEach(function (item) {
          if ("RFC_CVE" in item) {
            $scope.contributory = true;
          }
          $scope.tipoUpload = item.TIPO;
          $scope.sum_neta = 0;
          $scope.sum_rpf = 0;
          $scope.sum_derecho = 0;
          $scope.sum_iva = 0;
          $scope.sum_total = 0;
          $scope.sum_comision = 0;
          $scope.certificates_ind = [];
          if (item.TIPO == 1) {
            var dataMedical = [
              {
                personal: {
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                  antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                  rpf: item.RPF ? item.RPF : 0,
                  derecho: item.DERECHO ? item.DERECHO : 0,
                  iva: item.IVA ? item.IVA : 0,
                  p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
                  comision: item.COMISION ? item.COMISION : 0,
                  comision_earned: item.COMISION_NO_DEV
                    ? item.COMISION_NO_DEV
                    : 0,
                  p_neta_earned: item.PRIMA_NETA_NO_DEV
                    ? item.PRIMA_NETA_NO_DEV
                    : 0,
                  p_total_earned: item.PRIMA_TOTAL_NO_DEV
                    ? item.PRIMA_TOTAL_NO_DEV
                    : 0,
                  iva_earned: item.IVA_NO_DEV ? item.IVA_NO_DEV : 0,
                  rpf_earned: item.RPF_NO_DEV ? item.RPF_NO_DEV : 0,
                  derecho_earned: item.DERECHO_NO_DEV ? item.DERECHO_NO_DEV : 0,
                  descuento_earned: item.DESCUENTO_NO_DEV
                    ? item.DESCUENTO_NO_DEV
                    : 0,
                  comision_percent_earned: item.COMISION_PORCENTAJE_NO_DEV
                    ? item.COMISION_PORCENTAJE_NO_DEV
                    : 0,
                  discharge_date: item.FECHA_BAJA
                    ? datesFactory.toDate(item.FECHA_BAJA)
                    : null,
                  contributory: $scope.contributory
                    ? $scope.contributory
                    : false,
                  rfc_cve: item.RFC_CVE ? item.RFC_CVE : "",
                  rfc_homocve: item.RFC_HOMOCVE ? item.RFC_HOMOCVE : "",
                  dom_callenum: item.DOM_CALLE_NUM ? item.DOM_CALLE_NUM : "",
                  dom_colonia: item.DOM_COLONIA ? item.DOM_COLONIA : "",
                  dom_cp: item.DOM_CP ? item.DOM_CP : "",
                  dom_poblacion: item.DOM_POBLACION ? item.DOM_POBLACION : "",
                  dom_estado: item.DOM_ESTADO ? item.DOM_ESTADO : "",
                },
                disease_type: 0,
                relationship_accident: [],
                contributory: $scope.contributory ? $scope.contributory : false,
              },
            ];

            $scope.sum_neta = dataMedical[0].personal.p_neta;
            $scope.sum_rpf = dataMedical[0].personal.rpf;
            $scope.sum_derecho = dataMedical[0].personal.derecho;
            $scope.sum_iva = dataMedical[0].personal.iva;
            $scope.sum_total = dataMedical[0].personal.p_total;
            $scope.sum_comision = dataMedical[0].personal.comision;

            $scope.beneficiaries_medical.forEach(function (beneficiarie) {
              if (beneficiarie.familia == item.FAMILIA) {
                dataMedical[0].relationship_accident.push(beneficiarie);
                $scope.sum_neta = parseFloat(
                  parseFloat($scope.sum_neta) + parseFloat(beneficiarie.p_neta)
                ).toFixed(2);
                $scope.sum_rpf = parseFloat(
                  parseFloat($scope.sum_rpf) + parseFloat(beneficiarie.rpf)
                ).toFixed(2);
                $scope.sum_derecho = parseFloat(
                  parseFloat($scope.sum_derecho) +
                    parseFloat(beneficiarie.derecho)
                ).toFixed(2);
                $scope.sum_iva = parseFloat(
                  parseFloat($scope.sum_iva) + parseFloat(beneficiarie.iva)
                ).toFixed(2);
                $scope.sum_total = parseFloat(
                  parseFloat($scope.sum_total) +
                    parseFloat(beneficiarie.p_total)
                ).toFixed(2);
                $scope.sum_comision = parseFloat(
                  parseFloat($scope.sum_comision) +
                    parseFloat(beneficiarie.comision)
                ).toFixed(2);
              }
            });
            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            if (item.SUBGRUPO) {
              $scope.subgrupos.forEach(function (itemSubgrupo) {
                if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                  if (itemSubgrupo.address) {
                    contractor_certificate = itemSubgrupo.contractor
                      ? itemSubgrupo.contractor.id
                      : null;
                  } else {
                    contractor_certificate = $scope.caratula.contractor
                      ? $scope.caratula.contractor
                      : null;
                  }
                }
              });
            } else {
              contractor_certificate = $scope.caratula.contractor
                ? $scope.caratula.contractor
                : null;
            }

            var certificateData = {
              caratula: $scope.caratula.id,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number:
                $scope.caratula.poliza_number + " - INC. " + item.CERTIFICADO,
              contractor: contractor_certificate,
              ramo: $scope.caratula.ramo.id,
              subramo: $scope.caratula.subramo.id,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
              end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
              status: $scope.caratula.status == "Vigente" ? 14 : 1,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: dataMedical,
              life_policy: [],
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "GASTOS_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: $scope.sum_neta
                ? parseFloat($scope.sum_neta).toFixed(2)
                : item.PRIMA_NETA
                ? parseFloat(item.PRIMA_NETA).toFixed(2)
                : 0,
              rpf: $scope.sum_rpf
                ? parseFloat($scope.sum_rpf).toFixed(2)
                : item.RPF
                ? parseFloat(item.RPF).toFixed(2)
                : 0,
              derecho: $scope.sum_derecho
                ? parseFloat($scope.sum_derecho).toFixed(2)
                : item.DERECHO
                ? parseFloat(item.DERECHO).toFixed(2)
                : 0,
              iva: $scope.sum_iva
                ? parseFloat($scope.sum_iva).toFixed(2)
                : item.IVA
                ? parseFloat(item.IVA).toFixed(2)
                : 0,
              p_total: $scope.sum_total
                ? parseFloat($scope.sum_total).toFixed(2)
                : item.PRIMA_TOTAL
                ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                : 0,
              comision: $scope.sum_comision
                ? parseFloat($scope.sum_comision).toFixed(2)
                : item.COMISION
                ? parseFloat(item.COMISION).toFixed(2)
                : 0,
              rec_antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
              comision_earned: item.COMISION_NO_DEV ? item.COMISION_NO_DEV : 0,
              p_neta_earned: item.PRIMA_NETA_NO_DEV
                ? item.PRIMA_NETA_NO_DEV
                : 0,
              p_total_earned: item.PRIMA_TOTAL_NO_DEV
                ? item.PRIMA_TOTAL_NO_DEV
                : 0,
              iva_earned: item.IVA_NO_DEV ? item.IVA_NO_DEV : 0,
              rpf_earned: item.RPF_NO_DEV ? item.RPF_NO_DEV : 0,
              derecho_earned: item.DERECHO_NO_DEV ? item.DERECHO_NO_DEV : 0,
              descuento_earned: item.DESCUENTO_NO_DEV
                ? item.DESCUENTO_NO_DEV
                : 0,
              comision_percent_earned: item.COMISION_PORCENTAJE_NO_DEV
                ? item.COMISION_PORCENTAJE_NO_DEV
                : 0,
              contributory: $scope.contributory ? $scope.contributory : false,
            };
            $scope.certificados.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.FLOTILLA) {
        $scope.selectedCertificates.FLOTILLA.forEach(function (item) {
          var dataCar = [
            {
              car_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              driver: item.CONDUCTOR ? item.CONDUCTOR : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              brand: item.MARCA,
              model: item.MODELO,
              year: item.AÑO,
              version: item.VERSION,
              serial: item.SERIE,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              license_plates: item.MATRICULA ? item.MATRICULA : null,
              usage: parseInt(item.USO),
              service: item.SERVICIO,
              procedencia: parseInt(item.PROCEDENCIA),
              sum_insured: item.VALOR_O_SUMA_ASEGURADA
                ? item.VALOR_O_SUMA_ASEGURADA
                : null,
              charge_type: item.TIPO_CARGA ? parseInt(item.TIPO_CARGA) : null,
              adjustment: item.ADAPTACIONES ? item.ADAPTACIONES : null,
              mont_adjustment: item.MONTO_ADAPTACIONES
                ? item.MONTO_ADAPTACIONES
                : null,
              special_team: item.EQUIPAMIENTO ? item.EQUIPAMIENTO : null,
              mont_special_team: item.MONTO_EQUIPAMIENTO
                ? item.MONTO_EQUIPAMIENTO
                : null,
              beneficiary_name: null,
              preferential_benefiaciary: item.BENEFICIARIO_PREFERENTE
                ? item.BENEFICIARIO_PREFERENTE
                : null,
              beneficiary_rfc: item.BENEFICIARIO_RFC
                ? item.BENEFICIARIO_RFC
                : null,
              beneficiary_address: item.BENEFICIARIO_DIRECCION
                ? item.BENEFICIARIO_DIRECCION
                : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.subgrupos.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractorid
                    : null;
                } else {
                  contractor_certificate = $scope.caratula.contractor
                    ? $scope.caratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.caratula.juridical
              ? $scope.caratula.juridical
              : null;
          }

          var certificateData = {
            caratula: $scope.caratula.id,
            certificate_number: item.INCISO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number:
              $scope.caratula.poliza_number + " - INC. " + item.INCISO,
            contractor: contractor_certificate,
            ramo: $scope.caratula.ramo.id,
            subramo: $scope.caratula.subramo.id,
            paquete: item.PAQUETE,
            observations: "",
            old_policies: [],
            start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
            end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
            status: $scope.caratula.status == "Vigente" ? 14 : 1,
            automobiles_policy: dataCar,
            damages_policy: [],
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
            rpf: item.RPF ? item.RPF : 0,
            derecho: item.DERECHO ? item.DERECHO : 0,
            iva: item.IVA ? item.IVA : 0,
            p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
            comision: item.COMISION ? item.COMISION : 0,
            rec_antiguedad: null,
            contacto: "",
            comision_earned: item.COMISION_NO_DEV ? item.COMISION_NO_DEV : 0,
            p_neta_earned: item.PRIMA_NETA_NO_DEV ? item.PRIMA_NETA_NO_DEV : 0,
            p_total_earned: item.PRIMA_TOTAL_NO_DEV
              ? item.PRIMA_TOTAL_NO_DEV
              : 0,
            iva_earned: item.IVA_NO_DEV ? item.IVA_NO_DEV : 0,
            rpf_earned: item.RPF_NO_DEV ? item.RPF_NO_DEV : 0,
            derecho_earned: item.DERECHO_NO_DEV ? item.DERECHO_NO_DEV : 0,
            descuento_earned: item.DESCUENTO_NO_DEV ? item.DESCUENTO_NO_DEV : 0,
            comision_percent_earned: item.COMISION_PORCENTAJE_NO_DEV
              ? item.COMISION_PORCENTAJE_NO_DEV
              : 0,
            fecha_baja_inciso: item.FECHA_BAJA
              ? datesFactory.toDate(item.FECHA_BAJA)
              : null,
          };
          $scope.certificados.push(certificateData);
        });
      } else if (
        $scope.selectedCertificates.DANIOS_DIVERSO ||
        $scope.selectedCertificates.DANIOS_IRC
      ) {
        var excelJson = [];
        if ($scope.selectedCertificates.DANIOS_DIVERSO) {
          excelJson = $scope.selectedCertificates.DANIOS_DIVERSO;
        } else if ($scope.selectedCertificates.DANIOS_IRC) {
          excelJson = $scope.selectedCertificates.DANIOS_IRC;
        }
        excelJson.forEach(function (item) {
          var dataDamage = [
            {
              dam_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              item_details: item.OBSERVACIONES,
              usage: item.USO ? parseInt(item.USO) : 0,
              brand: item.MARCA ? item.MARCA : null,
              model: item.MODELO ? item.MODELO : null,
              construction_year: item.AÑO_CONSTRUCCION
                ? item.AÑO_CONSTRUCCION
                : null,
              reconstruction_year: item.AÑO_RECONSTRUCCION
                ? item.AÑO_RECONSTRUCCION
                : null,
              version: item.VERSION ? item.VERSION : null,
              serial: item.SERIE ? item.SERIE : null,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              matricula: item.MATRICULA ? item.MATRICULA : null,
              permiso: item.PERMISO ? item.PERMISO : null,
              purchase_value: item.VALOR_COMPRA
                ? parseInt(item.VALOR_COMPRA)
                : 0,
              item_address:
                item.CALLE +
                " " +
                item.NO_INTERIOR +
                " Ext." +
                item.NO_EXTERIOR +
                " " +
                item.COLONIA +
                " " +
                item.CIUDAD +
                " " +
                item.ESTADO +
                " C.P." +
                item.CP,
              sucursal: item.SUCURSAL ? item.SUCURSAL : null,
              giro: item.GIRO ? item.GIRO : null,
              type_construction: item.TIPO_CONSTRUCTIVO
                ? parseInt(item.TIPO_CONSTRUCTIVO)
                : 0,
              no_levels: item.NO_NIVELES ? item.NO_NIVELES : null,
              fhm_zone: item.ZONA_FHM ? item.ZONA_FHM : null,
              tyev_zone: item.ZONA_TYEV ? item.ZONA_TYEV : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.subgrupos.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.caratula.contractor
                    ? $scope.caratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.caratula.contractor
              ? $scope.caratula.contractor
              : null;
          }

          var certificateData = {
            caratula: $scope.caratula.id,
            certificate_number: item.INCISO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number:
              $scope.caratula.poliza_number + " - INC. " + item.INCISO,
            contractor: contractor_certificate,
            ramo: $scope.caratula.ramo.id,
            subramo: $scope.caratula.subramo.id,
            paquete: item.PAQUETE,
            observations: "",
            old_policies: [],
            start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
            end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
            status: $scope.caratula.status == "Vigente" ? 14 : 1,
            automobiles_policy: [],
            damages_policy: dataDamage,
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
            rpf: item.RPF ? item.RPF : 0,
            derecho: item.DERECHO ? item.DERECHO : 0,
            iva: item.IVA ? item.IVA : 0,
            p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
            comision: item.COMISION ? item.COMISION : 0,
            rec_antiguedad: null,
            contacto: "",
            comision_earned: item.COMISION_NO_DEV ? item.COMISION_NO_DEV : 0,
            prima_neta_earned: item.PRIMA_NETA_NO_DEV
              ? item.PRIMA_NETA_NO_DEV
              : 0,
            prima_total_earned: item.PRIMA_TOTAL_NO_DEV
              ? item.PRIMA_TOTAL_NO_DEV
              : 0,
            iva_earned: item.IVA_NO_DEV ? item.IVA_NO_DEV : 0,
            rpf_earned: item.RPF_NO_DEV ? item.RPF_NO_DEV : 0,
            derecho_earned: item.DERECHO_NO_DEV ? item.DERECHO_NO_DEV : 0,
            descuento_earned: item.DESCUENTO_NO_DEV ? item.DESCUENTO_NO_DEV : 0,
            comision_percent_earned: item.COMISION_PORCENTAJE_NO_DEV
              ? item.COMISION_PORCENTAJE_NO_DEV
              : 0,
          };
          $scope.certificados.push(certificateData);
        });
      } else if ($scope.selectedCertificates.BAJA_DB) {
        if ($scope.movementSelected.id == 27) {
          // Baja de Dependiente/Bendeficiario
          $scope.selectedCertificates.BAJA_DB.forEach(function (item) {
            var certificateData = {
              certificate_number: item.INCISO,
              parent: item.CATEGORIA,
              ramo_code: $scope.caratula.ramo.ramo_code,
              first_name: item.NOMBRE,
              last_name: item.AP_PATERNO,
              second_last_name: item.AP_MATERNO,
              comision_earned: item.COMISION_NO_DEV ? item.COMISION_NO_DEV : 0,
              prima_neta_earned: item.PRIMA_NETA_NO_DEV
                ? item.PRIMA_NETA_NO_DEV
                : 0,
              prima_total_earned: item.PRIMA_TOTAL_NO_DEV
                ? item.PRIMA_TOTAL_NO_DEV
                : 0,
              iva_earned: item.IVA_NO_DEV ? item.IVA_NO_DEV : 0,
              rpf_earned: item.RPF_NO_DEV ? item.RPF_NO_DEV : 0,
              derecho_earned: item.DERECHO_NO_DEV ? item.DERECHO_NO_DEV : 0,
              descuento_earned: item.DESCUENTO_NO_DEV
                ? item.DESCUENTO_NO_DEV
                : 0,
              comision_percent_earned: item.COMISION_PORCENTAJE_NO_DEV
                ? item.COMISION_PORCENTAJE_NO_DEV
                : 0,
            };
            $scope.certificados.push(certificateData);
          });
        }
      } else if ($scope.selectedCertificates.ALTA_DB) {
        if ($scope.movementSelected.id == 26) {
          // Alta de Dependiente/Bendeficiario
          $scope.selectedCertificates.ALTA_DB.forEach(function (item) {
            if ($scope.caratula.ramo.ramo_code == 1) {
              //vida
              var certificateData = {
                certificate_number: item.INCISO,
                parent: item.CATEGORIA,
                ramo_code: $scope.caratula.ramo.ramo_code,
                first_name: item.NOMBRE,
                last_name: item.AP_PATERNO,
                second_last_name: item.AP_MATERNO,
                certificate: item.CERTIFICADO,
                optional_relationship: item.PARENTESCO ? item.PARENTESCO : 4,
                birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                sex: item.SEXO,
                antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                percentage: item.PORCENTAJE ? item.PORCENTAJE : 0,
              };
            }
            if ($scope.caratula.ramo.ramo_code == 2) {
              //Accidentes
              var certificateData = {
                certificate_number: item.INCISO,
                parent: item.CATEGORIA,
                ramo_code: $scope.caratula.ramo.ramo_code,
                relationship: item.PARENTESCO,
                first_name: item.NOMBRE,
                last_name: item.AP_PATERNO,
                second_last_name: item.AP_MATERNO,
                birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                sex: item.SEXO,
                antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                certificate: item.CERTIFICADO,
                p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                rpf: item.RPF ? item.RPF : 0,
                derecho: item.DERECHO ? item.DERECHO : 0,
                iva: item.IVA ? item.IVA : 0,
                p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
                comision: item.COMISION ? item.COMISION : 0,
              };
            }
            $scope.certificados.push(certificateData);
          });
        }
      } else if ($scope.selectedCertificates.BAJA) {
        if ($scope.movementSelected.id == 25) {
          // Baja de Dependiente-Certificado
          $scope.selectedCertificates.BAJA.forEach(function (item) {
            var certificateData = {
              certificate_number: item.INCISO,
              parent: item.CATEGORIA,
              ramo_code: $scope.caratula.ramo.ramo_code,
              first_name: item.NOMBRE,
              last_name: item.AP_PATERNO,
              second_last_name: item.AP_MATERNO,
              tipo: item.TIPO ? item.TIPO : 3,
              comision_earned: item.COMISION_NO_DEV ? item.COMISION_NO_DEV : 0,
              prima_neta_earned: item.PRIMA_NETA_NO_DEV
                ? item.PRIMA_NETA_NO_DEV
                : 0,
              prima_total_earned: item.PRIMA_TOTAL_NO_DEV
                ? item.PRIMA_TOTAL_NO_DEV
                : 0,
              iva_earned: item.IVA_NO_DEV ? item.IVA_NO_DEV : 0,
              rpf_earned: item.RPF_NO_DEV ? item.RPF_NO_DEV : 0,
              derecho_earned: item.DERECHO_NO_DEV ? item.DERECHO_NO_DEV : 0,
              descuento_earned: item.DESCUENTO_NO_DEV
                ? item.DESCUENTO_NO_DEV
                : 0,
              comision_percent_earned: item.COMISION_PORCENTAJE_NO_DEV
                ? item.COMISION_PORCENTAJE_NO_DEV
                : 0,
              discharge_date: item.FECHA_BAJA
                ? datesFactory.toDate(item.FECHA_BAJA)
                : null,
            };
            certificateData.sub_total_earned = parseFloat(
              certificateData.prima_neta_earned +
                certificateData.rpf_earned +
                certificateData.derecho_earned +
                certificateData.iva_earned +
                certificateData.comision_earned
            ).toFixed(2);
            $scope.certificados.push(certificateData);
          });
        }
      }
      $scope.certificates_selected_alta = $scope.certificados;
      if ($scope.checkRegister) {
        $scope.checkNumberEndorsement();
      } else {
        $scope.createEndorsement();
      }
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item, options){
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          if ($scope.endoso.number_endorsement) {
            SweetAlert.swal(
              "¡Listo!",
              "Endoso creado exitosamente.",
              "success"
            );
            $state.go("endorsement.info", { endosoId: $scope.endoso.id });
          }
          if (!$scope.endoso.number_endorsement) {
            SweetAlert.swal(
              "¡Listo!",
              "Orden de Trabajo creada exitosamente.",
              "success"
            );
            $state.go("endorsement.info", { endosoId: $scope.endoso.id });
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 2 });
      } else {
        checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 1 });
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
      fileItem.removeAfterUpload = true;
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + endorsementId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.changeRegister = function (param) {
      $scope.checkRegister = param;
      if (!param) {
        $scope.btnNoRegister = {
          color: "#ffffff",
          "background-color": "#1c84c4",
        };
        $scope.btnRegister = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-right": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
        };
        $scope.dataToSave.recibos_poliza = [];
        $scope.endorsement.number_endorsement = "";
      } else {
        $scope.btnNoRegister = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
        };
        $scope.btnRegister = {
          color: "#ffffff",
          "background-color": "#1c84c4",
        };

        if ($scope.descriptionSelected.id == 24) {
          $scope.certificates_selected_alta.forEach(function (item, index) {
            if (!item.certificate_number) {
              $scope.changeRegister(false);
              SweetAlert.swal(
                "Error",
                "Todos los certificados deben tener numero de certificado.",
                "error"
              );
              return;
            }
          });
        }
      }
      if (
        esAutoadministrada(
          $scope.caratula && $scope.caratula.administration_type
        )
      ) {
        addReceipts(
          $scope.generarRecibosExcepcional
            ? $scope.generarRecibosExcepcional
            : false
        );
      }
    };

    $scope.changeNumberReceipts = function (param) {
      $scope.directiveReceipts.num_receipts = param.id;
      $scope.directiveReceipts.concept = $scope.descriptionSelected
        ? $scope.descriptionSelected.id
        : $scope.movementSelected.id;
      $scope.directiveReceipts.administration_type =
        $scope.caratula.administration_type;
      $scope.directiveReceipts.comision_percent =
        $scope.caratula.comision_percent;
      $localStorage["save_created_endoso_grupo"]["total_receipts"] =
        $scope.total_receipts;
    };

    $scope.checkNumberEndorsement = function () {
      if (
        $scope.descriptionSelected &&
        $scope.descriptionSelected.id == 35 &&
        $scope.checkCertificate
      ) {
        if ($scope.certificados.length == 0) {
          $scope.disableCreate = false;
          SweetAlert.swal("Error", "Debes agregar el certificado.", "error");
          return;
        }
      }
      try {
        var l = Ladda.create(document.querySelector(".ladda-button"));
      } catch (e) {
        var l = Ladda.create(document.querySelector(".ladda-button2"));
      }
      // var l = Ladda.create( document.querySelector( '.ladda-button2' ) );
      l.start();
      if ($scope.endorsement.number_endorsement) {
        dataFactory
          .get("exist-number-endorsement/", {
            number: $scope.endorsement.number_endorsement,
            poliza: $scope.caratula.poliza_number,
          })
          .then(function (request) {
            if (request.data.status == true) {
              l.stop();
              $scope.endorsement.number_endorsement = "";
              SweetAlert.swal(
                "Error",
                "El número de endoso ya existe.",
                "error"
              );
              return;
            } else {
              l.stop();
              $scope.createEndorsement();
            }
          })
          .catch(function (err) {
            l.stop();
          });
      } else {
        l.stop();
        SweetAlert.swal(
          "Error",
          MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
          "error"
        );
        return;
      }
    };
    $scope.disableCreate = false;
    $scope.validityEndorsement = function (deps) {
      $scope.disableCreate = true;
      try {
        var l = Ladda.create(document.querySelector(".ladda-button2"));
      } catch (r) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
      }
      l.start();
      if (!order.policy_number) {
        SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
        $scope.disableCreate = false;
        l.stop();
        return;
      }
      if (!$scope.endorsement.observations) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ENDOSOBS, "error");
        $scope.disableCreate = false;
        l.stop();
        return;
      }
      if (!$scope.movementSelected) {
        if (!$scope.typeSelected) {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORTYPEENDORSEMENT,
            "error"
          );
          $scope.disableCreate = false;
          l.stop();
          return;
        }
        if (!$scope.descriptionSelected) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONCEPT, "error");
          $scope.disableCreate = false;
          l.stop();
          return;
        }
        if ($scope.descriptionSelected.value == 1) {
          if (!$scope.change_endorsement.forma_de_pago) {
            SweetAlert.swal("Error", MESSAGES.ERROR.SELPAY, "error");
            $scope.disableCreate = false;
            l.stop();
            return;
          }
        }
        if ($scope.descriptionSelected.value == 38) {
          if (!$scope.newCertificates.parent) {
            SweetAlert.swal("Error", "Selecciona una categoría.", "error");
            $scope.disableCreate = false;
            l.stop();
            return;
          }
          if (!$scope.checkBeneficiaries) {
            if (!$scope.newCertificates.paquete) {
              SweetAlert.swal("Error", "Selecciona un paquete.", "error");
              $scope.disableCreate = false;
              l.stop();
              return;
            }
          }
          // if(!$scope.newCertificates.certificate_number){
          //   SweetAlert.swal('Error', 'Agrega un número de certificado.', 'error');
          //   $scope.disableCreate = false;
          // l.stop();
          //   return;
          // }

          var flagBeneficiarie = false;
          if ($scope.caratula.ramo.ramo_code == 1) {
            if (!$scope.newCertificates.rec_antiguedad) {
              SweetAlert.swal(
                "Error",
                "Agrega una fecha de antigüedad.",
                "error"
              );
              $scope.disableCreate = false;
              l.stop();
              return;
            }
            if (!$scope.newCertificates.personal.url) {
              if (!$scope.newCertificates.personal.email) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un correo electrónico.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              } else {
                if (
                  !$scope.validateEmail($scope.newCertificates.personal.email)
                ) {
                  SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
                  $scope.disableCreate = false;
                  l.stop();
                  return;
                }
              }
              if (!$scope.newCertificates.personal.first_name) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un nombre al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.personal.last_name) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un apellido paterno al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.personal.second_last_name) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un apellido materno al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.personal.birthdate) {
                SweetAlert.swal(
                  "Error",
                  "Agrega una fecha de nacimiento al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.personal.sex) {
                SweetAlert.swal(
                  "Error",
                  "Selecciona un sexo al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.personal.type_sa) {
                SweetAlert.swal(
                  "Error",
                  "Selecciona un tipo de suma asegurada al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.personal.sum_assured) {
                SweetAlert.swal(
                  "Error",
                  "Agrega una suma asegurada al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.personal.salary) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un sueldo al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
            }
            if (!$scope.newCertificates.smoker) {
              SweetAlert.swal(
                "Error",
                "Selecciona si fuma el titular.",
                "error"
              );
              $scope.disableCreate = false;
              l.stop();
              return;
            }
            if ($scope.newCertificates.beneficiaries_life.length > 0) {
              var flagBeneficiarie = false;
              $scope.newCertificates.beneficiaries_life.forEach(function (
                beneficiarie,
                index
              ) {
                if (!beneficiarie.first_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega un nombre al beneficiario " + (index + 1) + ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                  l.stop();
                }
                if (!beneficiarie.last_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega un apellido paterno al beneficiario " +
                      (index + 1) +
                      ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                  l.stop();
                }
                if (!beneficiarie.second_last_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega un apellido materno al beneficiario " +
                      (index + 1) +
                      ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                  l.stop();
                }
                if (!beneficiarie.birthdate) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega un nombre al beneficiario " + (index + 1) + ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                  l.stop();
                }
                if (!beneficiarie.optional_relationship) {
                  SweetAlert.swal(
                    "Error",
                    "Selecciona un parentesco al beneficiario " +
                      (index + 1) +
                      ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                  l.stop();
                }
                if (!beneficiarie.sex) {
                  SweetAlert.swal(
                    "Error",
                    "Selecciona un sexo al beneficiario " + (index + 1) + ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                  l.stop();
                }
              });
            }
          } else if ($scope.caratula.ramo.ramo_code == 2) {
            if (!$scope.checkBeneficiaries) {
              if (!$scope.newCertificates.personal.email) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un correo electrónico.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              } else {
                if (
                  !$scope.validateEmail($scope.newCertificates.personal.email)
                ) {
                  SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
                  $scope.disableCreate = false;
                  l.stop();
                  return;
                }
              }
              if (!$scope.newCertificates.personal.first_name) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un nombre al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.personal.last_name) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un apellido paterno al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.personal.second_last_name) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un apellido materno al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.personal.birthdate) {
                SweetAlert.swal(
                  "Error",
                  "Agrega una fecha de nacimiento al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.personal.sex) {
                SweetAlert.swal(
                  "Error",
                  "Selecciona un sexo al titular.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
            } else {
              $scope.disableCreate = false;
              l.stop();
            }
            if (
              $scope.newCertificates.relationship_accident &&
              $scope.newCertificates.relationship_accident.length > 0
            ) {
              $scope.newCertificates.relationship_accident.forEach(function (
                beneficiarie,
                index
              ) {
                if (beneficiarie.url) {
                  if (!beneficiarie.first_name) {
                    SweetAlert.swal(
                      "Error",
                      "Agrega un nombre al dependiente " + (index + 1) + ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                  if (!beneficiarie.last_name) {
                    SweetAlert.swal(
                      "Error",
                      "Agrega un apellido paterno al dependiente " +
                        (index + 1) +
                        ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                  if (!beneficiarie.second_last_name) {
                    SweetAlert.swal(
                      "Error",
                      "Agrega un apellido materno al dependiente " +
                        (index + 1) +
                        ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                  if (!beneficiarie.birthdate) {
                    SweetAlert.swal(
                      "Error",
                      "Agrega un fecha nacimiento al dependiente " +
                        (index + 1) +
                        ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                  if (!beneficiarie.relationship) {
                    SweetAlert.swal(
                      "Error",
                      "Selecciona un parentesco al dependiente " +
                        (index + 1) +
                        ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                  if (!beneficiarie.sex) {
                    SweetAlert.swal(
                      "Error",
                      "Selecciona un sexo al dependiente " + (index + 1) + ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                } else {
                  $scope.disableCreate = false;
                  l.stop();
                }
              });
            }
            if (flagBeneficiarie) {
              $scope.disableCreate = false;
              l.stop();
              return;
            }
          } else if ($scope.caratula.subramo.subramo_code == 9) {
            if (!$scope.newCertificates.auto.email) {
              SweetAlert.swal(
                "Error",
                "Agrega un correo electrónico.",
                "error"
              );
              $scope.disableCreate = false;
              l.stop();
              return;
            } else {
              if (!$scope.validateEmail($scope.newCertificates.auto.email)) {
                SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
            }
            if (!$scope.newCertificates.auto.brand) {
              SweetAlert.swal("Error", "Agrega una marca.", "error");
              $scope.disableCreate = false;
              l.stop();
              return;
            }
            if (!$scope.newCertificates.auto.model) {
              SweetAlert.swal("Error", "Agrega un modelo.", "error");
              $scope.disableCreate = false;
              l.stop();
              return;
            }
            if (!$scope.newCertificates.auto.year) {
              SweetAlert.swal("Error", "Agrega un año.", "error");
              $scope.disableCreate = false;
              l.stop();
              return;
            }
            if (!$scope.newCertificates.auto.version) {
              SweetAlert.swal("Error", "Agrega una versión.", "error");
              $scope.disableCreate = false;
              l.stop();
              return;
            }
            if (!$scope.newCertificates.auto.serial) {
              SweetAlert.swal("Error", "Agrega un número de serie.", "error");
              $scope.disableCreate = false;
              l.stop();
              return;
            }
            if (!$scope.newCertificates.auto.usage) {
              SweetAlert.swal("Error", "Agrega un uso.", "error");
              $scope.disableCreate = false;
              l.stop();
              return;
            }
            if (!$scope.newCertificates.auto.service) {
              SweetAlert.swal("Error", "Selecciona un serivicio.", "error");
              $scope.disableCreate = false;
              l.stop();
              return;
            }
            if (!$scope.newCertificates.auto.procedencia) {
              SweetAlert.swal("Error", "Selecciona una procedencia.", "error");
              $scope.disableCreate = false;
              l.stop();
              return;
            }
          } else if (
            $scope.caratula.subramo.subramo_name == 7 ||
            $scope.caratula.subramo.subramo_name == 13
          ) {
            if (!$scope.newCertificates.auto.email) {
              SweetAlert.swal(
                "Error",
                "Agrega un correo electrónico.",
                "error"
              );
              $scope.disableCreate = false;
              l.stop();
              return;
            } else {
              if (!$scope.validateEmail($scope.newCertificates.auto.email)) {
                SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
            }
            if ($scope.caratula.subramo.subramo_name == "Incendio") {
              if (!$scope.newCertificates.auto.sucursal) {
                SweetAlert.swal("Error", "Agrega una sucursal.", "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.giro) {
                SweetAlert.swal("Error", "Agrega un giro.", "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.type_construction) {
                SweetAlert.swal(
                  "Error",
                  "Selecciona un tipo de contrucción.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.no_levels) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un número de niveles.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.fhm_zone) {
                SweetAlert.swal("Error", "Agrega una zona FHM.", "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.tyev_zone) {
                SweetAlert.swal("Error", "Agrega una zona TYEV.", "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
            } else if ($scope.caratula.subramo.subramo_name == "Diversos") {
              if (!$scope.newCertificates.auto.item_details) {
                SweetAlert.swal("Error", "Agrega una descripción.", "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.usage) {
                SweetAlert.swal("Error", "Selecciona un uso.", "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.brand) {
                SweetAlert.swal("Error", "Agrega una marca.", "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.model) {
                SweetAlert.swal("Error", "Agrega un modelo.", "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.construction_year) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un año de contrucción.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.reconstruction_year) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un año de recontrucción.",
                  "error"
                );
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.version) {
                SweetAlert.swal("Error", "Agrega una versión.", "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.serial) {
                SweetAlert.swal("Error", "Agrega un número de serie.", "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
              if (!$scope.newCertificates.auto.permiso) {
                SweetAlert.swal("Error", "Agrega un permiso.", "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
            }
          }
        }
        if ($scope.descriptionSelected.value == 39) {
          if (!$scope.certificates_selected) {
            SweetAlert.swal("Error", "Agrega un certificado.", "error");
            $scope.disableCreate = false;
            l.stop();
            return;
          }
          // if(!$scope.newCertificate.parent){
          //   SweetAlert.swal('Error', 'Selecciona una categoría.', 'error');
          $scope.disableCreate = false;
          l.stop();
          return;
          // }
          // if(!$scope.newCertificate.certificate_number){
          //   SweetAlert.swal('Error', 'Agrega un número de certificado.', 'error');
          $scope.disableCreate = false;
          l.stop();
          return;
          // }

          // $scope.certificados = [];
          // var certificateData = {
          //   certificate_number: $scope.newCertificate.certificate_number,
          //   parent: $scope.newCertificate.parent.category_id
          // };
          // $scope.certificados.push(certificateData);
          $scope.certificados = $scope.certificates_selected;
        }
        if (
          $scope.descriptionSelected.id == 24 ||
          $scope.descriptionSelected.id == 35
        ) {
          var flagBeneficiarie = false;
          if ($scope.newCertificates.relationship_accident) {
            if ($scope.newCertificates.relationship_accident.length > 0) {
              $scope.newCertificates.relationship_accident.forEach(function (
                beneficiarie,
                index
              ) {
                if (!beneficiarie.url) {
                  if (!beneficiarie.first_name) {
                    SweetAlert.swal(
                      "Error",
                      "Agrega un nombre al dependiente " + (index + 1) + ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                  if (!beneficiarie.last_name) {
                    SweetAlert.swal(
                      "Error",
                      "Agrega un apellido paterno al dependiente " +
                        (index + 1) +
                        ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                  if (!beneficiarie.second_last_name) {
                    SweetAlert.swal(
                      "Error",
                      "Agrega un apellido materno al dependiente " +
                        (index + 1) +
                        ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                  if (!beneficiarie.birthdate) {
                    SweetAlert.swal(
                      "Error",
                      "Agrega un fecha nacimiento al dependiente " +
                        (index + 1) +
                        ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                  if (!beneficiarie.relationship) {
                    SweetAlert.swal(
                      "Error",
                      "Selecciona un parentesco al dependiente " +
                        (index + 1) +
                        ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                  if (!beneficiarie.sex) {
                    SweetAlert.swal(
                      "Error",
                      "Selecciona un sexo al dependiente " + (index + 1) + ".",
                      "error"
                    );
                    flagBeneficiarie = true;
                    l.stop();
                  }
                }
              });
            }
            if (flagBeneficiarie) {
              $scope.disableCreate = false;
              return;
            }
          }
          if ($scope.checkRegister) {
            if (!$scope.endorsement.number_endorsement) {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
                "error"
              );
              $scope.disableCreate = false;
              l.stop();
              return;
            }
            if (
              ($scope.typeSelected.name == "A" ||
                $scope.typeSelected.name == "D") &&
              $scope.totalReceipts.length > 0
            ) {
              if (!$scope.dataToSave.recibos_poliza) {
                SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
                $scope.disableCreate = false;
                return;
              }
            }
          }
          $scope.saveIndividualCertificate(deps);
        } else {
          $scope.createEndorsement();
          if ($scope.checkRegister) {
            if (!$scope.endorsement.number_endorsement) {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
                "error"
              );
              $scope.disableCreate = false;
              l.stop();
              return;
            }
            if (
              ($scope.typeSelected.name == "A" ||
                $scope.typeSelected.name == "D") &&
              $scope.totalReceipts.length > 0
            ) {
              if (!$scope.dataToSave.recibos_poliza) {
                SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
            }
          }
        }
      } else {
        if (!$scope.descriptionSelected) {
          SweetAlert.swal("Error", "Selecciona un movimiento.", "error");
          $scope.disableCreate = false;
          l.stop();
          return;
        }
        if ($scope.excelJson.length == 0) {
          SweetAlert.swal("Error", "Carga al menos un certificado.", "error");
          $scope.disableCreate = false;
          l.stop();
          return;
        }
        if ($scope.checkRegister) {
          if (!$scope.endorsement.number_endorsement) {
            SweetAlert.swal(
              "Error",
              MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
              "error"
            );
            $scope.disableCreate = false;
            l.stop();
            return;
          }
          if (
            ($scope.typeSelected.name == "A" ||
              $scope.typeSelected.name == "D") &&
            $scope.totalReceipts.length > 0
          ) {
            if (
              $scope.caratula.administration_type == "Autoadministrada" ||
              $scope.caratula.administration_type == 2
            ) {
              if ($scope.descriptionSelected.id == 36) {
                $scope.totalReceipts = [{ id: 1, name: 1 }];
              } else {
                $scope.totalReceipts = [{ id: 0, name: 0 }];
              }
            } else {
              if (!$scope.dataToSave.recibos_poliza) {
                SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
                $scope.disableCreate = false;
                l.stop();
                return;
              }
            }
          }
        }
        $scope.saveCertificates();
      }
      SweetAlert.swal(
        "¡Listo!",
        "Se agregó un certificado a la lista del endoso.",
        "success"
      );
      l.stop();
      $scope.saveLocalstorange();
    };

    $scope.certificados = [];
    $scope.saveIndividualCertificate = function (deps) {
      if ($scope.caratula.ramo.ramo_code == 1) {
        $scope.newCertificates.personal.certificate =
          $scope.newCertificates.certificate_number;
        $scope.newCertificates.personal.sex =
          $scope.newCertificates.personal.sex.value;
        $scope.newCertificates.personal.type_sa =
          $scope.newCertificates.personal.type_sa.value;
        $scope.newCertificates.personal.birthdate = datesFactory.toDate(
          $scope.newCertificates.personal.birthdate
        );
        $scope.newCertificates.personal.antiguedad = datesFactory.toDate(
          $scope.newCertificates.rec_antiguedad
        );
        $scope.newCertificates.smoker = $scope.newCertificates.smoker.value;
        $scope.newCertificates.beneficiaries_life.forEach(function (
          beneficiarie
        ) {
          beneficiarie.birthdate = datesFactory.toDate(beneficiarie.birthdate);
          beneficiarie.antiguedad = datesFactory.toDate(
            $scope.newCertificates.rec_antiguedad
          );
          beneficiarie.sex = beneficiarie.sex.value;
          beneficiarie.optional_relationship =
            beneficiarie.optional_relationship.value;
        });
        var certificateData = {
          caratula: $scope.caratula.id,
          certificate_number: $scope.newCertificates.certificate_number,
          folio: $scope.newCertificates.folio
            ? $scope.newCertificates.folio
            : "",
          parent: $scope.newCertificates.parent.category_id,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC. " +
            $scope.newCertificates.certificate_number,
          contractor: $scope.caratula.contractor,
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          paquete: $scope.newCertificates.paquete.id,
          observations: $scope.newCertificates.observations,
          old_policies: [],
          start_of_validity: datesFactory.toDate(
            $scope.newCertificates.start_of_validity
          ),
          end_of_validity: datesFactory.toDate(
            $scope.newCertificates.end_of_validity
          ),
          status: $scope.caratula.status,
          automobiles_policy: [],
          damages_policy: [],
          accidents_policy: [],
          life_policy: [$scope.newCertificates],
          document_type: 6,
          coverageInPolicy_policy: [],
          identifier:
            "VIDA_" +
            $scope.newCertificates.personal.first_name +
            "_" +
            $scope.newCertificates.personal.first_name,
          p_neta: $scope.newCertificates.p_neta
            ? $scope.newCertificates.p_neta
            : 0,
          rpf: $scope.newCertificates.rpf ? $scope.newCertificates.rpf : 0,
          derecho: $scope.newCertificates.derecho
            ? $scope.newCertificates.derecho
            : 0,
          iva: $scope.newCertificates.iva ? $scope.newCertificates.iva : 0,
          p_total: $scope.newCertificates.p_total
            ? $scope.newCertificates.p_total
            : 0,
          comision: $scope.newCertificates.comision
            ? $scope.newCertificates.comision
            : 0,
          rec_antiguedad: datesFactory.toDate(
            $scope.newCertificates.rec_antiguedad
          ),
          contacto: "",
        };
        $scope.certificados.push(certificateData);
      } else if ($scope.caratula.ramo.ramo_code == 2) {
        $scope.sum_neta = 0;
        $scope.sum_rpf = 0;
        $scope.sum_derecho = 0;
        $scope.sum_iva = 0;
        $scope.sum_total = 0;
        $scope.sum_comision = 0;
        $scope.newCertificates.personal.contributory =
          $scope.newCertificates.contributory;
        $scope.newCertificates.personal.is_active = $scope.checkDependients
          ? true
          : false;
        $scope.newCertificates.personal.sex =
          $scope.newCertificates.personal.sex.value;
        $scope.newCertificates.personal.birthdate = datesFactory.toDate(
          $scope.newCertificates.personal.birthdate
        );
        $scope.newCertificates.personal.antiguedad = datesFactory.toDate(
          $scope.newCertificates.rec_antiguedad
        );
        $scope.newCertificates.personal.charge_date = $scope.newCertificates
          .personal.charge_date
          ? datesFactory.toDate($scope.newCertificates.personal.charge_date)
          : null;
        $scope.newCertificates.personal.p_neta = $scope.newCertificates.personal
          .p_neta
          ? parseFloat($scope.newCertificates.personal.p_neta).toFixed(2)
          : 0;
        $scope.newCertificates.personal.rpf = $scope.newCertificates.personal
          .rpf
          ? parseFloat($scope.newCertificates.personal.rpf).toFixed(2)
          : 0;
        $scope.newCertificates.personal.derecho = $scope.newCertificates
          .personal.derecho
          ? parseFloat($scope.newCertificates.personal.derecho).toFixed(2)
          : 0;
        $scope.newCertificates.personal.iva = $scope.newCertificates.personal
          .iva
          ? parseFloat($scope.newCertificates.personal.iva).toFixed(2)
          : 0;
        $scope.newCertificates.personal.p_total = $scope.newCertificates
          .personal.p_total
          ? parseFloat($scope.newCertificates.personal.p_total).toFixed(2)
          : 0;
        $scope.newCertificates.personal.comision = $scope.newCertificates
          .personal.comision
          ? parseFloat($scope.newCertificates.personal.comision).toFixed(2)
          : 0;
        // Titular primas
        if ($scope.newCertificates.personal.is_active) {
          $scope.sum_neta = $scope.newCertificates.personal.p_neta;
          $scope.sum_rpf = $scope.newCertificates.personal.rpf;
          $scope.sum_derecho = $scope.newCertificates.personal.derecho;
          $scope.sum_iva = $scope.newCertificates.personal.iva;
          $scope.sum_total = $scope.newCertificates.personal.p_total;
          $scope.sum_comision = $scope.newCertificates.personal.comision;
        }

        $scope.newCertificates.relationship_accident.forEach(function (
          beneficiarie
        ) {
          beneficiarie.birthdate = datesFactory.toDate(beneficiarie.birthdate);
          beneficiarie.antiguedad = datesFactory.toDate(
            $scope.newCertificates.rec_antiguedad
          );
          beneficiarie.charge_date = beneficiarie.charge_date
            ? datesFactory.toDate(beneficiarie.charge_date)
            : null;
          beneficiarie.sex = beneficiarie.sex ? beneficiarie.sex.value : null;
          beneficiarie.relationship = beneficiarie.relationship.value;
          beneficiarie.p_neta = beneficiarie.p_neta
            ? parseFloat(beneficiarie.p_neta).toFixed(2)
            : 0;
          beneficiarie.rpf = beneficiarie.rpf
            ? parseFloat(beneficiarie.rpf).toFixed(2)
            : 0;
          beneficiarie.derecho = beneficiarie.derecho
            ? parseFloat(beneficiarie.derecho).toFixed(2)
            : 0;
          beneficiarie.iva = beneficiarie.iva
            ? parseFloat(beneficiarie.iva).toFixed(2)
            : 0;
          beneficiarie.p_total = beneficiarie.p_total
            ? parseFloat(beneficiarie.p_total).toFixed(2)
            : 0;
          beneficiarie.comision = beneficiarie.comision
            ? parseFloat(beneficiarie.comision).toFixed(2)
            : 0;
          beneficiarie.contributory = $scope.newCertificates.contributory;
          // Add sumas titular add dependientes primas
          if (!beneficiarie.url) {
            $scope.sum_neta = parseFloat(
              parseFloat($scope.sum_neta) + parseFloat(beneficiarie.p_neta)
            ).toFixed(2);
            $scope.sum_rpf = parseFloat(
              parseFloat($scope.sum_rpf) + parseFloat(beneficiarie.rpf)
            ).toFixed(2);
            $scope.sum_derecho = parseFloat(
              parseFloat($scope.sum_derecho) + parseFloat(beneficiarie.derecho)
            ).toFixed(2);
            $scope.sum_iva = parseFloat(
              parseFloat($scope.sum_iva) + parseFloat(beneficiarie.iva)
            ).toFixed(2);
            $scope.sum_total = parseFloat(
              parseFloat($scope.sum_total) + parseFloat(beneficiarie.p_total)
            ).toFixed(2);
            $scope.sum_comision = parseFloat(
              parseFloat($scope.sum_comision) +
                parseFloat(beneficiarie.comision)
            ).toFixed(2);
          }
        });
        var certificateData = {
          caratula: $scope.caratula.id,
          certificate_number: $scope.newCertificates.certificate_number,
          folio: $scope.newCertificates.folio
            ? $scope.newCertificates.folio
            : "",
          parent: $scope.newCertificates.parent.category_id,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC. " +
            $scope.newCertificates.certificate_number,
          contractor: $scope.caratula.contractor,
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          paquete: $scope.newCertificates.paquete.id,
          contributory: $scope.newCertificates.contributory,
          observations: $scope.newCertificates.observations,
          old_policies: [],
          start_of_validity: datesFactory.toDate(
            $scope.newCertificates.start_of_validity
          ),
          end_of_validity: datesFactory.toDate(
            $scope.newCertificates.end_of_validity
          ),
          status: $scope.caratula.status,
          automobiles_policy: [],
          damages_policy: [],
          accidents_policy: [$scope.newCertificates],
          life_policy: [],
          document_type: 6,
          coverageInPolicy_policy: [],
          identifier:
            "AEGM_" +
            $scope.newCertificates.personal.first_name +
            "_" +
            $scope.newCertificates.personal.first_name,
          p_neta: $scope.sum_neta
            ? parseFloat($scope.sum_neta).toFixed(2)
            : $scope.newCertificates.p_neta
            ? $scope.newCertificates.p_neta
            : 0,
          rpf: $scope.sum_rpf
            ? parseFloat($scope.sum_rpf).toFixed(2)
            : $scope.newCertificates.rpf
            ? $scope.newCertificates.rpf
            : 0,
          derecho: $scope.sum_derecho
            ? parseFloat($scope.sum_derecho).toFixed(2)
            : $scope.newCertificates.derecho
            ? $scope.newCertificates.derecho
            : 0,
          iva: $scope.sum_iva
            ? parseFloat($scope.sum_iva).toFixed(2)
            : $scope.newCertificates.iva
            ? $scope.newCertificates.iva
            : 0,
          p_total: $scope.sum_total
            ? parseFloat($scope.sum_total).toFixed(2)
            : $scope.newCertificates.p_total
            ? $scope.newCertificates.p_total
            : 0,
          comision: $scope.sum_comision
            ? parseFloat($scope.sum_comision).toFixed(2)
            : $scope.newCertificates.comision
            ? $scope.newCertificates.comision
            : 0,
          rec_antiguedad: datesFactory.toDate(
            $scope.newCertificates.rec_antiguedad
          ),
          contacto: "",
        };
        $scope.certificados.push(certificateData);
      } else if ($scope.caratula.subramo.subramo_code == 9) {
        $scope.newCertificates.auto.adjustment = $scope.newCertificates.auto
          .adjustment
          ? $scope.newCertificates.auto.adjustment
          : "";
        $scope.newCertificates.auto.beneficiary_address = $scope.newCertificates
          .auto.beneficiary_address
          ? $scope.newCertificates.auto.beneficiary_address
          : "";
        $scope.newCertificates.auto.beneficiary_rfc = $scope.newCertificates
          .auto.beneficiary_rfc
          ? $scope.newCertificates.auto.beneficiary_rfc
          : "";
        $scope.newCertificates.auto.brand = $scope.newCertificates.auto.brand
          ? $scope.newCertificates.auto.brand
          : "";
        $scope.newCertificates.auto.car_owner = $scope.newCertificates.auto
          .car_owner
          ? $scope.newCertificates.auto.car_owner
          : "";
        $scope.newCertificates.auto.charge_type = $scope.newCertificates.auto
          .charge_type
          ? $scope.newCertificates.auto.charge_type.value
          : 0;
        $scope.newCertificates.auto.color = $scope.newCertificates.auto.color
          ? $scope.newCertificates.auto.color
          : "";
        $scope.newCertificates.auto.driver = $scope.newCertificates.auto.driver
          ? $scope.newCertificates.auto.driver
          : "";
        $scope.newCertificates.auto.email = $scope.newCertificates.auto.email
          ? $scope.newCertificates.auto.email
          : "";
        $scope.newCertificates.auto.engine = $scope.newCertificates.auto.engine
          ? $scope.newCertificates.auto.engine
          : "";
        $scope.newCertificates.auto.license_plates = $scope.newCertificates.auto
          .license_plates
          ? $scope.newCertificates.auto.license_plates
          : "";
        $scope.newCertificates.auto.model = $scope.newCertificates.auto.model
          ? $scope.newCertificates.auto.model
          : "";
        $scope.newCertificates.auto.mont_adjustment = $scope.newCertificates
          .auto.mont_adjustment
          ? $scope.newCertificates.auto.mont_adjustment
          : 0;
        $scope.newCertificates.auto.mont_special_team = $scope.newCertificates
          .auto.mont_special_team
          ? $scope.newCertificates.auto.mont_special_team
          : 0;
        $scope.newCertificates.auto.no_employee = $scope.newCertificates.auto
          .no_employee
          ? $scope.newCertificates.auto.no_employee
          : 0;
        $scope.newCertificates.auto.preferential_benefiaciary = $scope
          .newCertificates.auto.preferential_benefiaciary
          ? $scope.newCertificates.autopreferential_benefiaciary
          : 0;
        $scope.newCertificates.auto.procedencia = $scope.newCertificates.auto
          .procedencia
          ? $scope.newCertificates.auto.procedencia.value
          : 0;
        $scope.newCertificates.auto.serial = $scope.newCertificates.auto.serial
          ? $scope.newCertificates.auto.serial
          : "";
        $scope.newCertificates.auto.service = $scope.newCertificates.auto
          .service
          ? $scope.newCertificates.auto.service
          : "";
        $scope.newCertificates.auto.special_team = $scope.newCertificates.auto
          .special_team
          ? $scope.newCertificates.auto.special_team
          : "";
        $scope.newCertificates.auto.sum_insured = $scope.newCertificates.auto
          .sum_insured
          ? $scope.newCertificates.auto.sum_insured
          : "";
        $scope.newCertificates.auto.usage = $scope.newCertificates.auto.usage
          ? $scope.newCertificates.auto.usage.value
          : 0;
        $scope.newCertificates.auto.version = $scope.newCertificates.auto
          .version
          ? $scope.newCertificates.auto.version
          : "";
        $scope.newCertificates.auto.year = $scope.newCertificates.auto.year
          ? $scope.newCertificates.auto.year
          : 0;

        var certificateData = {
          caratula: $scope.caratula.id,
          certificate_number: $scope.newCertificates.certificate_number,
          folio: $scope.newCertificates.folio
            ? $scope.newCertificates.folio
            : "",
          parent: $scope.newCertificates.parent.category_id,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC. " +
            $scope.newCertificates.certificate_number,
          contractor: $scope.caratula.contractor,
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          paquete: $scope.newCertificates.paquete.id,
          observations: $scope.newCertificates.observations,
          old_policies: [],
          start_of_validity: datesFactory.toDate(
            $scope.newCertificates.start_of_validity
          ),
          end_of_validity: datesFactory.toDate(
            $scope.newCertificates.end_of_validity
          ),
          status: $scope.caratula.status,
          automobiles_policy: [$scope.newCertificates.auto],
          damages_policy: [],
          accidents_policy: [],
          life_policy: [],
          document_type: 6,
          coverageInPolicy_policy: [],
          identifier:
            "AUTO_" +
            $scope.newCertificates.auto.serial +
            "_" +
            $scope.newCertificates.auto.version +
            "_" +
            $scope.newCertificates.auto.year,
          p_neta: $scope.newCertificates.p_neta
            ? $scope.newCertificates.p_neta
            : 0,
          rpf: $scope.newCertificates.rpf ? $scope.newCertificates.rpf : 0,
          derecho: $scope.newCertificates.derecho
            ? $scope.newCertificates.derecho
            : 0,
          iva: $scope.newCertificates.iva ? $scope.newCertificates.iva : 0,
          p_total: $scope.newCertificates.p_total
            ? $scope.newCertificates.p_total
            : 0,
          comision: $scope.newCertificates.comision
            ? $scope.newCertificates.comision
            : 0,
          rec_antiguedad: $scope.newCertificates.rec_antiguedad
            ? datesFactory.toDate($scope.newCertificates.rec_antiguedad)
            : datesFactory.toDate(datesFactory.convertDate(new Date())),
          contacto: "",
        };
        $scope.certificados.push(certificateData);
      } else if ($scope.caratula.subramo.subramo_code == 13) {
        //diversos
        $scope.newCertificates.auto.brand = $scope.newCertificates.auto.brand
          ? $scope.newCertificates.auto.brand
          : "";
        $scope.newCertificates.auto.color = $scope.newCertificates.auto.color
          ? $scope.newCertificates.auto.color
          : "";
        $scope.newCertificates.auto.construction_year = $scope.newCertificates
          .auto.construction_year
          ? $scope.newCertificates.auto.construction_year
          : "";
        $scope.newCertificates.auto.email = $scope.newCertificates.auto.email
          ? $scope.newCertificates.auto.email
          : "";
        $scope.newCertificates.auto.engine = $scope.newCertificates.auto.engine
          ? $scope.newCertificates.auto.engine
          : "";
        $scope.newCertificates.auto.dam_owner = $scope.newCertificates.auto
          .dam_owner
          ? $scope.newCertificates.auto.dam_owner
          : "";
        $scope.newCertificates.auto.model = $scope.newCertificates.auto.model
          ? $scope.newCertificates.auto.model
          : "";
        $scope.newCertificates.auto.no_employee = $scope.newCertificates.auto
          .no_employee
          ? $scope.newCertificates.auto.no_employee
          : 0;
        $scope.newCertificates.auto.permiso = $scope.newCertificates.auto
          .permiso
          ? $scope.newCertificates.auto.permiso
          : 0;
        $scope.newCertificates.auto.serial = $scope.newCertificates.auto.serial
          ? $scope.newCertificates.auto.serial
          : "";
        $scope.newCertificates.auto.purchase_value = $scope.newCertificates.auto
          .purchase_value
          ? $scope.newCertificates.auto.purchase_value
          : 0;
        $scope.newCertificates.auto.reconstruction_year = $scope.newCertificates
          .auto.reconstruction_year
          ? $scope.newCertificates.auto.reconstruction_year
          : "";
        $scope.newCertificates.auto.usage = $scope.newCertificates.auto.usage
          ? $scope.newCertificates.auto.usage.value
          : 0;
        $scope.newCertificates.auto.version = $scope.newCertificates.auto
          .version
          ? $scope.newCertificates.auto.version
          : "";

        var certificateData = {
          caratula: $scope.caratula.id,
          certificate_number: $scope.newCertificates.certificate_number,
          folio: $scope.newCertificates.folio
            ? $scope.newCertificates.folio
            : "",
          parent: $scope.newCertificates.parent.category_id,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC. " +
            $scope.newCertificates.certificate_number,
          contractor: $scope.caratula.contractor,
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          paquete: $scope.newCertificates.paquete.id,
          observations: $scope.newCertificates.observations,
          old_policies: [],
          start_of_validity: datesFactory.toDate(
            $scope.newCertificates.start_of_validity
          ),
          end_of_validity: datesFactory.toDate(
            $scope.newCertificates.end_of_validity
          ),
          status: $scope.caratula.status,
          automobiles_policy: [],
          damages_policy: [$scope.newCertificates.auto],
          accidents_policy: [],
          life_policy: [],
          document_type: 6,
          coverageInPolicy_policy: [],
          identifier:
            "DIV_" +
            $scope.newCertificates.auto.serial +
            "_" +
            $scope.newCertificates.auto.version +
            "_" +
            $scope.newCertificates.auto.brand,
          p_neta: $scope.newCertificates.p_neta
            ? $scope.newCertificates.p_neta
            : 0,
          rpf: $scope.newCertificates.rpf ? $scope.newCertificates.rpf : 0,
          derecho: $scope.newCertificates.derecho
            ? $scope.newCertificates.derecho
            : 0,
          iva: $scope.newCertificates.iva ? $scope.newCertificates.iva : 0,
          p_total: $scope.newCertificates.p_total
            ? $scope.newCertificates.p_total
            : 0,
          comision: $scope.newCertificates.comision
            ? $scope.newCertificates.comision
            : 0,
          rec_antiguedad: $scope.newCertificates.rec_antiguedad
            ? datesFactory.toDate($scope.newCertificates.rec_antiguedad)
            : datesFactory.toDate(datesFactory.convertDate(new Date())),
          contacto: "",
        };
        $scope.certificados.push(certificateData);
      } else if ($scope.caratula.subramo.subramo_code == 7) {
        $scope.newCertificates.auto.fhm_zone = $scope.newCertificates.auto
          .fhm_zone
          ? $scope.newCertificates.auto.fhm_zone
          : "";
        $scope.newCertificates.auto.giro = $scope.newCertificates.auto.giro
          ? $scope.newCertificates.auto.giro
          : "";
        $scope.newCertificates.auto.item_address = $scope.newCertificates.auto
          .item_address
          ? $scope.newCertificates.auto.item_address
          : "";
        $scope.newCertificates.auto.email = $scope.newCertificates.auto.email
          ? $scope.newCertificates.auto.email
          : "";
        $scope.newCertificates.auto.no_levels = $scope.newCertificates.auto
          .no_levels
          ? $scope.newCertificates.auto.no_levels
          : 0;
        $scope.newCertificates.auto.sucursal = $scope.newCertificates.auto
          .sucursal
          ? $scope.newCertificates.auto.sucursal
          : "";
        $scope.newCertificates.auto.tyev_zone = $scope.newCertificates.auto
          .tyev_zone
          ? $scope.newCertificates.auto.tyev_zone
          : "";
        $scope.newCertificates.auto.type_construction = $scope.newCertificates
          .auto.type_construction
          ? $scope.newCertificates.auto.type_construction.value
          : 0;

        var certificateData = {
          caratula: $scope.caratula.id,
          certificate_number: $scope.newCertificates.certificate_number,
          folio: $scope.newCertificates.folio
            ? $scope.newCertificate.sfolio
            : "",
          parent: $scope.newCertificates.parent.category_id,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC. " +
            $scope.newCertificates.certificate_number,
          contractor: $scope.caratula.contractor,
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          paquete: $scope.newCertificates.paquete.id,
          observations: $scope.newCertificates.observations
            ? $scope.newCertificates.observations
            : "",
          old_policies: [],
          start_of_validity: datesFactory.toDate(
            $scope.newCertificates.start_of_validity
          ),
          end_of_validity: datesFactory.toDate(
            $scope.newCertificates.end_of_validity
          ),
          status: $scope.caratula.status,
          automobiles_policy: [],
          damages_policy: [$scope.newCertificates.auto],
          accidents_policy: [],
          life_policy: [],
          document_type: 6,
          coverageInPolicy_policy: [],
          identifier:
            "D_INC_" +
            $scope.newCertificates.auto.serial +
            "_" +
            $scope.newCertificates.auto.version +
            "_" +
            $scope.newCertificates.auto.brand,
          p_neta: $scope.newCertificates.p_neta
            ? $scope.newCertificates.p_neta
            : 0,
          rpf: $scope.newCertificates.rpf ? $scope.newCertificates.rpf : 0,
          derecho: $scope.newCertificates.derecho
            ? $scope.newCertificates.derecho
            : 0,
          iva: $scope.newCertificates.iva ? $scope.newCertificates.iva : 0,
          p_total: $scope.newCertificates.p_total
            ? $scope.newCertificates.p_total
            : 0,
          comision: $scope.newCertificates.comision
            ? $scope.newCertificates.comision
            : 0,
          rec_antiguedad: $scope.newCertificates.rec_antiguedad
            ? datesFactory.toDate($scope.newCertificates.rec_antiguedad)
            : datesFactory.toDate(datesFactory.convertDate(new Date())),
          contacto: "",
        };
        $scope.certificados.push(certificateData);
      }

      if ($scope.descriptionSelected.id == 35) {
        $scope.certificados[0].id = $scope.newCertificates.id;
      }

      $scope.addcertificates($scope.newCertificates, deps);
      // $scope.createEndorsement();
    };

    $scope.createEndorsement = function () {
      if (
        $scope.descriptionSelected &&
        $scope.descriptionSelected.id == 35 &&
        $scope.checkCertificate
      ) {
        if ($scope.certificados.length == 0) {
          $scope.disableCreate = false;
          SweetAlert.swal("Error", "Debes agregar el certificado.", "error");
          return;
        }
      }
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      if (!$scope.movementSelected) {
        if (
          $scope.descriptionSelected.id == 24 ||
          $scope.descriptionSelected.id == 25
        ) {
          if ($scope.typeSelected.name == "A") {
            if ($scope.certificates_selected_alta.length == 0) {
              l.stop();
              $scope.disableCreate = false;
              SweetAlert.swal(
                "Error",
                "Debes agregar al menos un certificado.",
                "error"
              );
              return;
            }
          }
          if ($scope.typeSelected.name == "D") {
            if ($scope.certificates_selected.length == 0) {
              l.stop();
              $scope.disableCreate = false;
              SweetAlert.swal(
                "Error",
                "Debes agregar al menos un certificado.",
                "error"
              );
              return;
            }
          }
        }
      }
      if ($scope.dataToSave.recibos_poliza) {
        $scope.dataToSave.recibos_poliza.forEach(function (item) {
          item.fecha_inicio = datesFactory.toDate(item.fecha_inicio);
          item.fecha_fin = datesFactory.toDate(item.fecha_fin);
          item.vencimiento = datesFactory.toDate(item.vencimiento);
          if (!$scope.movementSelected) {
            if ($scope.descriptionSelected.id == 1) {
              item.receipt_type = 1;
            }
          }
        });
      }

      if ($scope.dependientes_add.length > 0) {
        $scope.certificados = $scope.certificados.concat(
          $scope.dependientes_add
        );
      }
      if ($scope.descriptionSelected) {
        if ($scope.descriptionSelected.id != 1) {
          if (
            $scope.caratula.administration_type == "Autoadministrada" ||
            $scope.caratula.administration_type == 2
          ) {
            if ($scope.descriptionSelected.id == 36) {
            } else {
              if ($scope.generarRecibosExcepcional) {
                $scope.dataToSave.recibos_poliza =
                  $scope.dataToSave.recibos_poliza;
              } else {
                $scope.dataToSave.recibos_poliza = [];
              }
            }
            if ($scope.generarRecibosExcepcional) {
              $scope.dataToSave.recibos_poliza =
                $scope.dataToSave.recibos_poliza;
            }
          } else if ($scope.checkRegister) {
            if (!$scope.endorsement.number_endorsement) {
              l.stop();
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
                "error"
              );
              $scope.disableCreate = false;
              return;
            }
            if (
              ($scope.typeSelected.name == "A" ||
                $scope.typeSelected.name == "D") &&
              $scope.totalReceipts.length > 0
            ) {
              if (
                $scope.caratula.administration_type == "Autoadministrada" ||
                $scope.caratula.administration_type == 2
              ) {
                if ($scope.descriptionSelected.id == 36) {
                  $scope.totalReceipts = [{ id: 1, name: 1 }];
                } else {
                  $scope.totalReceipts = [{ id: 0, name: 0 }];
                }
              } else {
                if (!$scope.dataToSave.recibos_poliza) {
                  l.stop();
                  SweetAlert.swal(
                    "Error",
                    MESSAGES.ERROR.ERRORRECEIPTS,
                    "error"
                  );
                  $scope.disableCreate = false;
                  return;
                }
              }
            }
          }
        }
      }
      if ($scope.descriptionSelected.id == 4) {
        $scope.change_endorsement = {
          end_date: datesFactory.toDate($scope.endDate),
        };
      }
      if ($scope.descriptionSelected.id == 24) {
        $scope.typeSelected = { id: 1, name: "A" };
      } else if ($scope.descriptionSelected.id == 25) {
        $scope.typeSelected = { id: 3, name: "D" };
      }

      ($scope.endorsement.number_endorsement = $scope.endorsement
        .number_endorsement
        ? $scope.endorsement.number_endorsement
        : ""),
        ($scope.endorsement.concept = $scope.descriptionSelected
          ? $scope.descriptionSelected.id
          : 3);
      $scope.endorsement.other_desc = $scope.endorsement.other_desc
        ? $scope.endorsement.other_desc
        : "";
      $scope.endorsement.original = JSON.stringify($scope.origin_endorsement);
      $scope.endorsement.change =
        $scope.certificados.length > 0
          ? JSON.stringify($scope.certificados)
          : JSON.stringify($scope.change_endorsement);
      $scope.endorsement.status = $scope.checkRegister ? 2 : 5;
      $scope.endorsement.endorsement_type = $scope.typeSelected.name;
      $scope.endorsement.init_date = datesFactory.toDate($scope.startDate);
      $scope.endorsement.end_date = datesFactory.toDate($scope.endDate);
      $scope.endorsement.observations = $scope.endorsement.observations;
      $scope.endorsement.p_neta = $scope.dataToSave.p_neta
        ? $scope.dataToSave.p_neta
        : 0;
      $scope.endorsement.rpf = $scope.dataToSave.rpf
        ? $scope.dataToSave.rpf
        : 0;
      $scope.endorsement.derecho = $scope.dataToSave.derecho
        ? $scope.dataToSave.derecho
        : 0;
      $scope.endorsement.sub_total = $scope.dataToSave.sub_total
        ? $scope.dataToSave.sub_total
        : 0;
      $scope.endorsement.iva = $scope.dataToSave.iva
        ? $scope.dataToSave.iva
        : 0;
      $scope.endorsement.p_total = $scope.dataToSave.p_total
        ? $scope.dataToSave.p_total
        : 0;
      $scope.endorsement.comision = $scope.dataToSave.comision
        ? $scope.dataToSave.comision
        : 0;
      ($scope.endorsement.comision_percent = $scope.dataToSave.comision_percent
        ? $scope.dataToSave.comision_percent
        : 0),
        ($scope.endorsement.endorsement_receipt = $scope.dataToSave
          .recibos_poliza
          ? $scope.dataToSave.recibos_poliza
          : []);
      $scope.endorsement.total_receipts = $scope.dataToSave.recibos_poliza
        ? $scope.dataToSave.recibos_poliza.length
        : 0;
      $scope.endorsement.insurancefolio = $scope.endorsement.insurancefolio
        ? $scope.endorsement.insurancefolio
        : "";
      $scope.endorsement.policy = $scope.newCertificate.url
        ? $scope.newCertificate.url
        : $scope.caratula.url;
      if (
        $scope.endorsement.endorsement_type == "D" &&
        $scope.endorsement.concept != 1
      ) {
        $scope.endorsement.p_neta = parseFloat($scope.endorsement.p_neta) * -1;
        $scope.endorsement.rpf = parseFloat($scope.endorsement.rpf) * -1;
        $scope.endorsement.derecho =
          parseFloat($scope.endorsement.derecho) * -1;
        $scope.endorsement.sub_total =
          parseFloat($scope.endorsement.sub_total) * -1;
        $scope.endorsement.iva = parseFloat($scope.endorsement.iva) * -1;
        $scope.endorsement.p_total =
          parseFloat($scope.endorsement.p_total) * -1;
      }
      if ($scope.checkCertificate) {
        if (order.certificate_number && order.certificate_number.url) {
          $scope.endorsement.policy = order.certificate_number.url;
        } else {
          SweetAlert.swal("Error", "Debes elegir el certificado.", "error");
          l.stop();
          return;
        }
      }
      if (
        $rootScope.from_task &&
        $rootScope.task_associated &&
        $rootScope.task_associated.url
      ) {
        $scope.endorsement.from_task = $rootScope.from_task;
        $scope.endorsement.task_associated = $rootScope.task_associated.id;
      }
      $http({
        method: "POST",
        url: url.IP + "endorsement/",
        data: $scope.endorsement,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            if (
              $rootScope.from_task &&
              $rootScope.task_associated &&
              $rootScope.task_associated.url
            ) {
              $http.patch($rootScope.task_associated.url, {
                ot_model: 2,
                ot_id_reference: response.data.id,
              });
            }
            if ($scope.countFile > 0) {
              $scope.endoso = response.data;
              uploadFiles(response.data.id);
            } else {
              l.stop();
              SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
              $localStorage.save_created_endoso_grupo = {};
              $state.go("endorsement.info", { endosoId: response.data.id });
            }
          } else {
            l.stop();
            if ($scope.dataToSave.recibos_poliza) {
              $scope.dataToSave.recibos_poliza.forEach(function (item) {
                item.fecha_inicio = datesFactory.convertDate(item.fecha_inicio);
                item.fecha_fin = datesFactory.convertDate(item.fecha_fin);
                item.vencimiento = datesFactory.convertDate(item.vencimiento);
              });
            }
            $scope.showFields($scope.descriptionSelected);
            if (response.data) {
              if (response.data[0]) {
                $scope.disableCreate = false;
                l.stop();
                SweetAlert.swal(
                  "ERROR",
                  "Ocurrio un error\n" + response.data[0],
                  "error"
                );
              }
            } else {
              $scope.disableCreate = false;
              l.stop();
              SweetAlert.swal("ERROR", "Ocurrio un error\n", "error");
            }
          }
        })
        .catch(function (e) {
          console.log("errorr", e);
          try {
            l.stop();
            SweetAlert.swal(
              "ERROR",
              "Ocurrio un error\n" +
                (e && e.data
                  ? e.data[0]
                  : "Revise los datos del endoso, ocurrio error al gaurdar."),
              "error"
            );
          } catch (iuee) {}
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndosoFullInfoController", EndosoFullInfoController);

  EndosoFullInfoController.$inject = [
    "dataFactory",
    "$scope",
    "MESSAGES",
    "SweetAlert",
    "toaster",
    "FileUploader",
    "datesFactory",
    "$http",
    "$state",
    "$stateParams",
    "url",
    "exportFactory",
    "$localStorage",
    "$sessionStorage",
    "$uibModal",
    "$sce",
    "appStates",
    "whatsappWebFlagService",
  ];

  function EndosoFullInfoController(
    dataFactory,
    $scope,
    MESSAGES,
    SweetAlert,
    toaster,
    FileUploader,
    datesFactory,
    $http,
    $state,
    $stateParams,
    url,
    exportFactory,
    $localStorage,
    $sessionStorage,
    $uibModal,
    $sce,
    appStates,
    whatsappWebFlagService
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    var order = this;
    $scope.usuarioorg = usr.org;
    var currentOrg =
      usr && usr.org && usr.org.urlname
        ? usr.org.urlname
        : usr.urlname || usr.orgname || "";
    order.commentsExportLoading = false;
    order.exportEndosoComments = function exportEndosoComments() {
      if (
        !$scope.endorsement.id ||
        order.commentsExportLoading ||
        !($scope.comments_data && $scope.comments_data.length)
      ) {
        return;
      }

      order.commentsExportLoading = true;

      var resetLoading = function () {
        order.commentsExportLoading = false;
      };

      var params = {
        model: 10,
        id_model: $scope.endorsement.id,
      };
      if (currentOrg) {
        params.org = currentOrg;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: params,
          downloadName: "bitacora-endoso.xlsx",
          token: token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    };
    $scope.whatsappWebEnabled = whatsappWebFlagService.isEnabled();
    whatsappWebFlagService.subscribe(function (enabled) {
      $scope.$evalAsync(function () {
        order.whatsappWebEnabled = enabled;
      });
    }, $scope);
    $scope.editChanges = false;
    order.shareEndorsementOk = shareEndorsementOk;
    $scope.endorsement = {};
    $scope.contractor = {};
    $scope.show_binnacle_receipt = false;
    $scope.show_binnacle_receipt_endorsement = false;
    $scope.files = [];
    $scope.okFile = 0;
    $scope.countFile = 0;

    $scope.recordatoriosFlag = false;

    $scope.showRecordatorios = function () {
      $scope.recordatoriosFlag = !$scope.recordatoriosFlag;
    };
    $scope.endososOtros = false;

    $scope.showEndosos = function () {
      $scope.endososOtros = !$scope.endososOtros;
    };
    $scope.goToInfo = function (endo, index) {
      $scope.endososOtros = false;
      var id = endo.id;
      $scope.name_for_new_tab = "Información Endoso";
      $scope.route_for_new_tab = "endorsement.info";
      var name = "Información Endoso";
      var route = "endorsement.info";
      var params = { myInsurance: endo.policy, endosoId: id };
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      appStates.states.forEach(function (item) {
        if (item.name == "endorsement.info") {
          item.id = id;
          item.name = $scope.name_for_new_tab;
          item.heading = $scope.name_for_new_tab;
          item.route = $scope.route_for_new_tab;
          item.active = true;
          item.isVisible = true;
          item.href = $state.href($scope.route_for_new_tab);
        }
        $localStorage.tab_states = appStates.states;
        $localStorage.tab_index = $localStorage.tab_states.length - 1;
        $state.go($scope.route_for_new_tab, params);
      });
    };

    order.isCollapsed = false;
    // Function to toggle the collapse state
    order.toggleCollapse = function () {
      order.isCollapsed = !order.isCollapsed;
    };
    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };

    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          order.acceso_polizas = perm;
          order.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                order.acceso_adm_pol = true;
              } else {
                order.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                order.acceso_ver_pol = true;
              } else {
                order.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          order.acceso_endosos = perm;
          order.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                order.acceso_reg_end = true;
              } else {
                order.acceso_reg_end = false;
              }
            }
            if (acc.permission_name == "Eliminar endosos") {
              if (acc.checked == true) {
                order.acceso_elim_end = true;
              } else {
                order.acceso_elim_end = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Eliminar OTs") {
              if (acc.checked == true) {
                order.acceso_elim_ot = true;
              } else {
                order.acceso_elim_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                order.acceso_canc_ot = true;
              } else {
                order.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Tablero de OTs") {
              if (acc.checked == true) {
                order.acceso_tab = true;
              } else {
                order.acceso_tab = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          order.acceso_correo = perm;
          order.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                order.acceso_cor = true;
              } else {
                order.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          order.acceso_reportes = perm;
          order.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                order.acceso_rep_fia = true;
              } else {
                order.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                order.acceso_rep_sin = true;
              } else {
                order.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                order.acceso_rep_end = true;
              } else {
                order.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                order.acceso_rep_pol = true;
              } else {
                order.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                order.acceso_rep_ren = true;
              } else {
                order.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                order.acceso_rep_cob = true;
              } else {
                order.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          order.acceso_form = perm;
          order.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                order.acceso_form = true;
              } else {
                order.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          order.acceso_ref = perm;
          order.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                order.acceso_adm_ref = true;
              } else {
                order.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                order.acceso_pag_ref = true;
              } else {
                order.acceso_pag_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          order.coms = perm;
          order.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                order.permiso_comisiones = true;
              } else {
                order.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            }
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                order.permiso_administrar_adjuntos = true;
              } else {
                order.permiso_administrar_adjuntos = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          order.acceso_cobranza = perm;
          order.acceso_cobranza.permissions.forEach(function (acc) {
            if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                order.permiso_delete_cobranza = true;
              } else {
                order.permiso_delete_cobranza = false;
              }
            }
            if (
              acc.permission_name ==
              "No permitir editar recibos Pagados/Liquidados"
            ) {
              if (acc.checked == true) {
                order.acceso_pl_cob = true; //no se editan
              } else {
                order.acceso_pl_cob = false; //se pueden editar pagados-liquidados
              }
            }
          });
        }
      });
    }

    $scope.createRecordatorio = function (registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return $scope.endorsement;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    activate();

    $scope.moveOTState = function (newcontainer, principal, seguimiento, tipo) {
      SweetAlert.swal(
        {
          title: "Mover Registro",
          text:
            "Se moverá " +
            $scope.endorsement.internal_number +
            " de: " +
            $scope.endorsement.seguimiento +
            ", al Contenedor: " +
            newcontainer.tablero,
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
            if (principal.contenedores && principal.contenedores.length > 0) {
              principal.contenedores.forEach(function (r, i) {
                if (r.tablero == seguimiento) {
                  if (tipo == 2) {
                    r.endoso.splice(r.endoso.indexOf($scope.endorsement.id), 1);
                  }
                }
                if (r.tablero == newcontainer.tablero) {
                  r.endoso.push($scope.endorsement.id);
                }
                if (r) {
                  if (r["details_endoso"]) {
                    r["details_endoso"] = [];
                  }
                  if (r["details_polizas"]) {
                    r["details_polizas"] = [];
                  }
                }
              });
            }
            var payload = {
              polizas_ots: principal.contenedores,
              name: principal.name,
              color: principal.color,
              url: $scope.principal.url ? $scope.principal.url : "",
            };
            if ($scope.principal.url && $scope.principal.url != "") {
              $http
                .patch($scope.principal.url, payload)
                .then(
                  function success(response) {
                    $scope.endorsement.seguimiento = newcontainer.tablero;
                    activate();
                  },
                  function error(e) {
                    console.log("Error - promotorias--", e);
                  }
                )
                .catch(function (error) {
                  console.log("Error - promotablero - catch", error);
                });
            }
          }
        }
      );
    };
    function activate() {
      $scope.guardandolay = false;
      $http
        .post(url.IP + "get-data-promotoria-initial/")
        .then(
          function success(response) {
            if (response.data.results.length > 0) {
              $scope.principal = response.data.original;
              $scope.principal.contenedores =
                response.data.original.data_details;
              $scope.principal.url = response.data.original.url;
              $scope.principal.id = response.data.original.id;
            }
          },
          function error(e) {
            console.log("Error - promotorias--", e);
          }
        )
        .catch(function (error) {
          $scope.principal.contenedores = [];
          console.log("Error - promotablero - catch", error);
        });
      var lie = Ladda.create(document.querySelector(".ladda-button-initial-e"));
      lie.start();
      dataFactory
        .get("endorsement-info/" + $stateParams.endosoId + "/")
        .then(function success(response) {
          $scope.endorsement = response.data;
          lie.stop();
          if ($scope.endorsement.policy.contractor) {
            $scope.contractor.contractor = $scope.endorsement.policy.contractor;
            $scope.contractor.juridical = null;
          }
          $scope.endorsement.change = $scope.endorsement.change
            .split("'")
            .join('"');
          $scope.endorsement.change = $scope.endorsement.change
            .split("None")
            .join('""');
          if ($scope.endorsement.change != "") {
            if (typeof $scope.endorsement.change == "string") {
              try {
                try {
                  var rawChange = $scope.endorsement.change;
                  if (typeof rawChange === "string") {
                    rawChange = rawChange
                      .replace(/'/g, '"') // Replace single quotes
                      .replace(/,(\s*[}\]])/g, "$1") // Remove trailing commas
                      .replace(/:\s*"([^"]*)"/g, function (match, p1) {
                        // Escape quotes
                        return ': "' + p1.replace(/"/g, '\\"') + '"'; // Replace template literals with string concatenation
                      });
                  }
                  $scope.endorsement.change = JSON.parse(rawChange);
                } catch (e) {
                  $scope.endorsement.change = [];
                  console.error("Failed to parse and clean JSON:", e);
                }

                // try{
                //   $scope.endorsement.change = JSON.parse($scope.endorsement.change);
                // }catch(e){
                //   console.log('-e-e-e-eee',e,$scope.endorsement)
                // }
                if ($scope.endorsement.concept == 24) {
                  $scope.suma_p_total = 0;
                  $scope.endorsement.change.forEach(function (item) {
                    if ($scope.endorsement.policy.ramo.ramo_code == 2) {
                      if (!item.accidents_policy[0].personal.url) {
                        $scope.suma_p_total = parseFloat(
                          (
                            $scope.suma_p_total +
                            parseFloat(
                              item.accidents_policy[0].personal.p_total
                            )
                          ).toFixed(2)
                        );
                      }
                      if (
                        item.accidents_policy[0].relationship_accident.length
                      ) {
                        item.accidents_policy[0].relationship_accident.forEach(
                          function (dep) {
                            if (!dep.url) {
                              $scope.suma_p_total = parseFloat(
                                (
                                  $scope.suma_p_total + parseFloat(dep.p_total)
                                ).toFixed(2)
                              );
                            }
                          }
                        );
                      }
                    } else {
                      $scope.suma_p_total = parseFloat(
                        (
                          $scope.suma_p_total + parseFloat(item.p_total)
                        ).toFixed(2)
                      );
                    }
                  });
                } else if ($scope.endorsement.concept == 25) {
                  $scope.suma_p_total_baja = 0;
                  if (!$scope.endorsement.change[0].certificate_number) {
                    $scope.endorsement.change.forEach(function (item) {
                      try {
                        item.certificate_number = item.certificate_number
                          ? item.certificate_number
                          : item.personal.certificate_number
                          ? item.personal.certificate_number
                          : item.personal.dependientes[0].certificate;
                      } catch (e) {
                        item.certificate_number = "";
                      }
                      item.parent = item.categoria.category;

                      if ($scope.endorsement.policy.ramo.ramo_code == 2) {
                        if (item.personal) {
                          if (item.personal.dependientes) {
                            if (item.personal.dependientes.length) {
                              item.personal.dependientes.forEach(function (
                                dep
                              ) {
                                if (!dep.url) {
                                  if (dep.p_total_earned) {
                                    $scope.suma_p_total_baja = parseFloat(
                                      (
                                        $scope.suma_p_total_baja +
                                        parseFloat(dep.p_total_earned)
                                      ).toFixed(2)
                                    );
                                  } else {
                                    $scope.suma_p_total_baja = parseFloat(
                                      (
                                        $scope.suma_p_total_baja +
                                        parseFloat(dep.prima_total_earned)
                                      ).toFixed(2)
                                    );
                                  }
                                }
                              });
                            }
                          }
                          if (item.personal.p_total_earned) {
                            $scope.suma_p_total_baja = parseFloat(
                              (
                                $scope.suma_p_total_baja +
                                parseFloat(item.personal.p_total_earned)
                              ).toFixed(2)
                            );
                          } else {
                            $scope.suma_p_total_baja = parseFloat(
                              (
                                $scope.suma_p_total_baja +
                                parseFloat(item.personal.prima_total_earned)
                              ).toFixed(2)
                            );
                          }
                        } else {
                          if (item.p_total_earned) {
                            $scope.suma_p_total_baja = parseFloat(
                              (
                                $scope.suma_p_total_baja +
                                parseFloat(item.p_total_earned)
                              ).toFixed(2)
                            );
                          } else {
                            $scope.suma_p_total_baja = parseFloat(
                              (
                                $scope.suma_p_total_baja +
                                parseFloat(item.prima_total_earned)
                              ).toFixed(2)
                            );
                          }
                        }
                      } else {
                        if (item.p_total_earned) {
                          $scope.suma_p_total_baja = parseFloat(
                            (
                              $scope.suma_p_total_baja +
                              parseFloat(item.p_total_earned)
                            ).toFixed(2)
                          );
                        } else {
                          $scope.suma_p_total_baja = parseFloat(
                            (
                              $scope.suma_p_total_baja +
                              parseFloat(item.prima_total_earned)
                            ).toFixed(2)
                          );
                        }
                      }
                    });
                  } else {
                    $scope.endorsement.change.forEach(function (item) {
                      if ($scope.endorsement.policy.ramo.ramo_code == 2) {
                        if (item.personal) {
                          if (item.personal.dependientes) {
                            if (item.personal.dependientes.length) {
                              item.personal.dependientes.forEach(function (
                                dep
                              ) {
                                if (!dep.url) {
                                  if (dep.p_total_earned) {
                                    $scope.suma_p_total_baja = parseFloat(
                                      (
                                        $scope.suma_p_total_baja +
                                        parseFloat(dep.p_total_earned)
                                      ).toFixed(2)
                                    );
                                  } else {
                                    $scope.suma_p_total_baja = parseFloat(
                                      (
                                        $scope.suma_p_total_baja +
                                        parseFloat(dep.prima_total_earned)
                                      ).toFixed(2)
                                    );
                                  }
                                }
                              });
                            }
                          }
                          if (item.personal.p_total_earned) {
                            $scope.suma_p_total_baja = parseFloat(
                              (
                                $scope.suma_p_total_baja +
                                parseFloat(item.personal.p_total_earned)
                              ).toFixed(2)
                            );
                          } else {
                            $scope.suma_p_total_baja = parseFloat(
                              (
                                $scope.suma_p_total_baja +
                                parseFloat(item.personal.prima_total_earned)
                              ).toFixed(2)
                            );
                          }
                        } else {
                          if (item.p_total_earned) {
                            $scope.suma_p_total_baja = parseFloat(
                              (
                                $scope.suma_p_total_baja +
                                parseFloat(item.p_total_earned)
                              ).toFixed(2)
                            );
                          } else {
                            $scope.suma_p_total_baja = parseFloat(
                              (
                                $scope.suma_p_total_baja +
                                parseFloat(item.prima_total_earned)
                              ).toFixed(2)
                            );
                          }
                        }
                      } else {
                        if (item.p_total_earned) {
                          $scope.suma_p_total_baja = parseFloat(
                            (
                              $scope.suma_p_total_baja +
                              parseFloat(item.p_total_earned)
                            ).toFixed(2)
                          );
                        } else {
                          $scope.suma_p_total_baja = parseFloat(
                            (
                              $scope.suma_p_total_baja +
                              parseFloat(item.prima_total_earned)
                            ).toFixed(2)
                          );
                        }
                      }
                    });
                  }
                }
              } catch (err) {
                $scope.endorsement.change = $scope.endorsement.change;
                console.log("error--270", err);
              }
            }
          }
          $scope.endorsement.original = $scope.endorsement.original
            .split("'")
            .join('"');
          $scope.endorsement.original = $scope.endorsement.original
            .split("None")
            .join('""');
          if ($scope.endorsement.original != "") {
            if (typeof $scope.endorsement.original == "string") {
              try {
                $scope.endorsement.original = JSON.parse(
                  $scope.endorsement.original
                );
              } catch (err) {}
            }
          }

          dataFactory
            .get("endosos/" + $scope.endorsement.id + "/archivos/")
            .then(function success(response) {
              if (response.status === 200 || response.status == 201) {
                if (response.data.results.length) {
                  $scope.files = response.data.results;
                }
              }
            });

          var date_start = new Date($scope.endorsement.start_of_validity);
          var date_end = new Date($scope.endorsement.end_of_validity);

          var year_start = date_start.getFullYear();
          var year_end = date_end.getFullYear();

          var vigencia = parseInt(year_end) - parseInt(year_start);

          $scope.aniosPoliza = [];

          if (vigencia > 1) {
            $scope.poliza_multianual = true;
            for (var i = 1; i <= vigencia; i++) {
              $scope.aniosPoliza.push(i);
            }
            $scope.anioPoliza = $scope.aniosPoliza[0];
            // $scope.showReceiptsYear($scope.anioPoliza);
          } else {
            $scope.poliza_multianual = false;
          }

          // $scope.calculatePrimas($scope.endorsement.policy.recibos_poliza);
          if ($scope.endorsement.endorsement_receipt.length > 0) {
            $scope.calculatePrimasEndorsement(
              $scope.endorsement.endorsement_receipt
            );
          }

          if ($scope.endorsement.document_type == 6) {
            dataFactory
              .get("polizas/" + $scope.endorsement.policy.caratula)
              .then(function success(response) {
                if (response.status === 200 || response.status == 201) {
                  $scope.certificado = response.data;
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }

          // comments
          $http({
            method: "GET",
            url: url.IP + "comments/",
            params: {
              model: 10,
              id_model: $scope.endorsement.id,
            },
          })
            .then(function (request) {
              $scope.comments_data = request.data.results;
              $scope.comments_config = {
                count: request.data.count,
                next: request.data.next,
                previous: request.data.previous,
              };
            })
            .catch(function (e) {
              console.log("e", e);
            });

          $http({
            method: "GET",
            url: url.IP + "cartas-by-model",
            params: {
              model: 2,
            },
          }).then(function success(response) {
            $scope.cartas = response.data;
          });

          if ($scope.endorsement.concept == 7) {
            if ($scope.endorsement.change) {
              $scope.type_url = "contractors-app/";
            }
            dataFactory
              .get($scope.type_url + $scope.endorsement.change.id)
              .then(function success(response) {
                $scope.contractor_change = response.data;
              });
          }
        });
    }

    $scope.openModal = function (task) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/tasks/task.modal.html",
        controller: "TareasModalCtrl",
        size: "lg",
        resolve: {
          task: function () {
            return task;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          receipt: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          activate();
        },
        function () {
          console.info("modal closed");
        }
      );
    };
    $scope.getLog = function () {
      dataFactory
        .get("get-specific-log", {
          model: 10,
          associated_id: $stateParams.endosoId,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
        });
    };

    $scope.concept = function (parConcept) {
      if ($scope.endorsement.policy) {
        if (
          $scope.endorsement.policy.document_type != 7 &&
          $scope.endorsement.policy.document_type != 8
        ) {
          switch (parConcept) {
            case 1:
              return "CAMBIO DE FORMA DE PAGO";
              break;
            case 2:
              return "CAMBIO DE SUMA ASEGURADA";
              break;
            case 3:
              return "OTRO";
              break;
            case 4:
              return "AGREGAR ASEGURADO";
              break;
            case 5:
              return "AGREGAR COBERTURAS";
              break;
            case 6:
              return "ALTA/BAJA DE DEPENDIENTES";
              break;
            case 8:
              return "CAMBIO DATOS FISCALES";
              break;
            case 9:
              return "ESPECIFICACIONES ";
              break;
            case 11:
              return "CAMBIO DE FORMA DE PAGO";
              break;
            case 12:
              return "DISMINUCIÓN EN LA SUMA ASEGURADA";
              break;
            // case 13: return 'BAJA DE COBERTURA';
            case 13:
              return "CANCELACION DEFINITIVA A PETICION";
              break;
            case 14:
              return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
              break;
            case 15:
              return "BAJA DE ASEGURADO";
              break;
            case 16:
              return "CANCELACIÓN DE PÓLIZA POR PETICIÓN";
              break;
            case 17:
              return "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO";
              break;
            case 23:
              return "ANTIGÜEDAD RECONOCIDA";
              break;
            case 24:
              return "ALTA DE ASEGURADOS";
              break;
            case 25:
              return "BAJA DE ASEGURADOS";
              break;
            case 26:
              return "AJUSTE ANUAL (A)";
              break;
            case 27:
              return "RECONOCIMIENTO DE ANTIGUEDAD";
              break;
            case 28:
              return "AJUSTE ANUAL (D)";
              break;
            case 29:
              return "OTRO";
              break;
            case 30:
              return "Declaración";
              break;
            case 31:
              return "Agregar asegurado o dependiente";
              break;
            case 32:
              return "Cancelación";
              break;
            case 33:
              return "CORRECCION DE DATOS";
              break;
            case 34:
              return "CORRECCION DE DATOS BENEFICIARIO";
              break;
            default:
              return "OTRO";
          }
        } else if (
          $scope.endorsement.policy.document_type == 7 ||
          $scope.endorsement.policy.document_type == 8
        ) {
          switch (parConcept) {
            case 1:
              return "AUMENTO MONTO AFIANZADO";
              break;
            case 2:
              return "DECREMENTO MONTO AFIANZADO";
              break;
            case 3:
              return "CAMBIO DE PORCENTAJE DE GARANTÍA";
              break;
            case 5:
              return "CAMBIO DE DATOS";
              break;
            case 4:
              return "OTRO";
              break;
            case 6:
              return "DECLARACIÓN MENSUAL";
              break;
            case 8:
              return "CAMBIO DATOS FISCALES";
              break;
            case 34:
              return "CAMBIOS EN EL BENEFICIARIO";
              break;
            case 53:
              return "DETALLE DE GARANTÍA";
              break;
            case 54:
              return "PRORROGA DE VIGENCIA";
              break;
            case 55:
              return "ANUENCIA";
              break;
            case 24:
              return "ALTA DE CERTIFICADOS";
              break;
            case 25:
              return "BAJA DE CERTIFICADOS";
              break;
            case 56:
              return "CORRECCIÓN DE CERTIFICADOS";
              break;
            case 57:
              return "Aumento y Prórroga";
              break;
            case 58:
              return "Aumento";
              break;
            default:
              return "OTRO";
          }
        }
      }
    };

    $scope.conceptCollectivity = function (parConcept) {
      if (parConcept) {
        switch (parConcept) {
          case 41:
            return "ALTA DE UNIDAD";
            break;
          case 42:
            return "AGREGAR COBERTURA";
            break;
          case 43:
            return "CAMBIO DE FORMA DE PAGO";
            break;
          case 44:
            return "AGREGAR CARGA";
            break;
          case 45:
            return "AGREGAR ADAPTACIONES Y CONVERSIONES";
            break;
          case 46:
            return "INCLUIR BP";
            break;
          case 47:
            return "CORREGIR DESCRIPCIÓN";
            break;
          case 48:
            return "AGREGAR TEXTOS ACLARATORIOS";
            break;
          case 49:
            return "ADAPTACIONES SOLO PARA EFECTOS DE RC";
            break;
          case 50:
            return "AGREGAR PLACAS, MOTOR O CORREGIR SERIE";
            break;
          case 51:
            return "CANCELACIONES";
            break;
          case 52:
            return "ELIMINACIÓN DE COBERTURAS";
            break;
          case 31:
            return "Agregar asegurado o dependiente";
            break;
          case 24:
            return "ALTA DE ASEGURADOS";
            break;
          case 25:
            return "BAJA DE ASEGURADOS";
            break;
          case 26:
            return "AJUSTE ANUAL A";
            break;
          case 28:
            return "AJUSTE ANUAL D";
            break;
          default:
            return "OTRO";
        }
      }
    };

    $scope.status = function (param) {
      switch (param) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Registrado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado";
          break;
        case 5:
          return "En trámite";
          break;
        case 6:
          return "Anulado";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.goToPolicy = function (id) {
      if ($scope.endorsement.policy) {
        if ($scope.endorsement.policy.document_type == 1) {
          var name = "Información polizas";
          var route = "polizas.info";
        } else if ($scope.endorsement.policy.document_type == 3) {
          var name = "Información colectividades";
          var route = "colectividades.info";
        } else if ($scope.endorsement.policy.document_type == 6) {
          var name = "Información colectividades";
          var route = "colectividades.info";
        } else if ($scope.endorsement.policy.document_type == 7) {
          var name = "Información fianzas";
          var route = "fianzas.info";
        } else if ($scope.endorsement.policy.document_type == 8) {
          var name = "Información fianzas";
          var route = "fianzas.details";
        } else if ($scope.endorsement.policy.document_type == 12) {
          var name = "Información flotillas";
          var route = "flotillas.info";
        }
      }
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      } else {
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            state.active = true;
            state.isVisible = true;
            state.id = id;
          }
          if (state.route == "endorsement.info") {
            state.active = false;
            state.isVisible = false;
          }
        });
      }

      $localStorage.tab_states = appStates.states;
      // $localStorage.tab_index = $localStorage.tab_states.length -1;
      if ($scope.endorsement.policy) {
        if ($scope.endorsement.policy.document_type == 1) {
          $state.go("polizas.info", { polizaId: id });
        } else if ($scope.endorsement.policy.document_type == 3) {
          $state.go("colectividades.info", { polizaId: id });
        } else if ($scope.endorsement.policy.document_type == 6) {
          $state.go("colectividades.info", {
            polizaId: $scope.endorsement.policy.caratula,
          });
        } else if ($scope.endorsement.policy.document_type == 7) {
          $state.go("fianzas.info", { polizaId: id });
        } else if ($scope.endorsement.policy.document_type == 8) {
          $state.go("fianzas.details", { polizaId: id });
        } else if ($scope.endorsement.policy.document_type == 12) {
          $state.go("flotillas.info", {
            polizaId: $scope.endorsement.policy.caratula,
          });
        }
      }
    };

    $scope.cancelEndorsement = function () {
      SweetAlert.swal(
        {
          title: "Cancelar Endoso",
          text: "Los recibos pendientes se cancelarán. ¿Estas seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .patch($scope.endorsement.url, { status: 4 })
              .then(function success(response) {
                if (response.status === 200 || response.status === 201) {
                  $scope.endorsement.endorsement_receipt.forEach(function (
                    recibo
                  ) {
                    if (recibo.status == 4) {
                      $http
                        .patch(recibo.url, { status: 2 })
                        .then(function () {});
                    }
                  });
                  if ($scope.certificates) {
                    $scope.certificates.forEach(function (inciso) {
                      if (inciso.certificate.certificado_inciso_activo) {
                        $http
                          .patch(inciso.certificate.url, {
                            certificado_inciso_activo: false,
                          })
                          .then(function () {});
                      } else {
                        $http
                          .patch(inciso.certificate.url, {
                            certificado_inciso_activo: true,
                          })
                          .then(function () {});
                      }
                    });
                  }

                  var paramsE = {
                    model: 10,
                    event: "POST",
                    associated_id: $scope.endorsement.id,
                    identifier: " canceló el endoso.",
                  };
                  dataFactory.post("send-log", paramsE);
                }
                SweetAlert.swal(
                  "¡Listo!",
                  "El endoso se ha cancelado.",
                  "success"
                );
              });
            swal.close();
            $state.go("endorsement.lista");
          }
        }
      );
    };

    $scope.deleteEndorsment = function () {
      if ($scope.endorsement.status == 2) {
        $scope.regEnd =
          "los cambios ya realizados por el endoso registrado no se revertirán";
      } else {
        $scope.regEnd = "";
      }
      SweetAlert.swal(
        {
          title: "Eliminar Endoso",
          text: MESSAGES.WARNING.DELETENDO + ", " + $scope.regEnd,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var paramsE = {
              model: 10,
              event: "PATCH",
              associated_id: $scope.endorsement.id,
              identifier: " elimino el endoso.",
            };
            var paramsP = {
              model: 1,
              event: "PATCH",
              associated_id: $scope.endorsement.policy.id,
              identifier:
                " elimino el endoso: " + $scope.endorsement.internal_number,
            };
            dataFactory.post("send-log", paramsE);
            dataFactory.post("send-log", paramsP);
            $http.patch($scope.endorsement.url, { status: 0 });
            SweetAlert.swal(
              "¡Listo!",
              "Endoso eliminado correctamente.",
              "success"
            );
            $state.go("endorsement.lista");
          } else {
            swal.close();
          }
        }
      );
    };

    $scope.initChanges = function (changes) {
      $scope.editChanges = true;
      if (
        $scope.endorsement.endorsement_type == "A" &&
        $scope.endorsement.policy.ramo.ramo_code == 2
      ) {
        $scope.endorsement.changes = changes.map(function (item) {
          if (item.accidents_policy) {
            // item.accidents_policy[0].certificate_number = item.accidents_policy[0].personal.certificate;
          }
          if (item && item.tipo) {
            item.antiguedad = datesFactory.convertDate(item.antiguedad);
            item.charge_date = item.charge_date
              ? datesFactory.convertDate(item.charge_date)
              : datesFactory.convertDate($scope.endorsement.init_date);
          } else {
            item.accidents_policy[0].personal.antiguedad =
              datesFactory.convertDate(
                item.accidents_policy[0].personal.antiguedad
              );
            item.accidents_policy[0].personal.birthdate =
              datesFactory.convertDate(
                item.accidents_policy[0].personal.birthdate
              );
            try {
              item.accidents_policy[0].personal.p_neta = isNaN(
                parseFloat(item.accidents_policy[0].personal.p_neta)
              )
                ? 0
                : Number(
                    parseFloat(
                      item.accidents_policy[0].personal.p_neta
                    ).toFixed(2)
                  );
              item.accidents_policy[0].personal.derecho = isNaN(
                parseFloat(item.accidents_policy[0].personal.derecho)
              )
                ? 0
                : Number(
                    parseFloat(
                      item.accidents_policy[0].personal.derecho
                    ).toFixed(2)
                  );
              item.accidents_policy[0].personal.rpf = isNaN(
                parseFloat(item.accidents_policy[0].personal.rpf)
              )
                ? 0
                : Number(
                    parseFloat(item.accidents_policy[0].personal.rpf).toFixed(2)
                  );
              item.accidents_policy[0].personal.iva = isNaN(
                parseFloat(item.accidents_policy[0].personal.iva)
              )
                ? 0
                : Number(
                    parseFloat(item.accidents_policy[0].personal.iva).toFixed(2)
                  );
              item.accidents_policy[0].personal.comision = isNaN(
                parseFloat(item.accidents_policy[0].personal.comision)
              )
                ? 0
                : Number(
                    parseFloat(
                      item.accidents_policy[0].personal.comision
                    ).toFixed(2)
                  );
            } catch (u) {}
            item.accidents_policy[0].personal.charge_date = item
              .accidents_policy[0].personal.charge_date
              ? datesFactory.convertDate(
                  item.accidents_policy[0].personal.charge_date
                )
              : datesFactory.convertDate($scope.endorsement.init_date);
            item.accidents_policy[0].relationship_accident =
              item.accidents_policy[0].relationship_accident.map(function (
                itemRelation
              ) {
                itemRelation.antiguedad = datesFactory.convertDate(
                  itemRelation.antiguedad
                );
                itemRelation.birthdate = datesFactory.convertDate(
                  itemRelation.birthdate
                );
                itemRelation.p_neta = isNaN(parseFloat(itemRelation.p_neta))
                  ? 0
                  : Number(parseFloat(itemRelation.p_neta).toFixed(2));
                itemRelation.derecho = isNaN(parseFloat(itemRelation.derecho))
                  ? 0
                  : Number(parseFloat(itemRelation.derecho).toFixed(2));
                itemRelation.rpf = isNaN(parseFloat(itemRelation.rpf))
                  ? 0
                  : Number(parseFloat(itemRelation.rpf).toFixed(2));
                itemRelation.iva = isNaN(parseFloat(itemRelation.iva))
                  ? 0
                  : Number(parseFloat(itemRelation.iva).toFixed(2));
                itemRelation.comision = isNaN(parseFloat(itemRelation.comision))
                  ? 0
                  : Number(parseFloat(itemRelation.comision).toFixed(2));

                try {
                  dataFactory
                    .get("v1/relationships/" + itemRelation.id)
                    .then(function success(rels) {
                      if (rels) {
                        itemRelation.is_active = rels.data.is_active;
                      }
                    })
                    .catch(function (error) {
                      console.log("Error - claves-by-provider - catch", error);
                    });
                } catch (i) {}
                itemRelation.charge_date = itemRelation.charge_date
                  ? datesFactory.convertDate(itemRelation.charge_date)
                  : datesFactory.convertDate($scope.endorsement.init_date);
                return itemRelation;
              });
          }
          return item;
        });
      } else if (
        $scope.endorsement.endorsement_type == "A" &&
        $scope.endorsement.policy.ramo.ramo_code == 1
      ) {
        $scope.endorsement.changes = changes.map(function (item) {
          item.life_policy[0].personal.antiguedad = datesFactory.convertDate(
            item.life_policy[0].personal.antiguedad
          );
          item.life_policy[0].personal.birthdate = datesFactory.convertDate(
            item.life_policy[0].personal.birthdate
          );
          return item;
        });
      } else {
        $scope.endorsement.changes = changes.map(function (item) {
          if (item && item.tipo) {
            if (item.discharge_date) {
              try {
                item.discharge_date = datesFactory.convertDate(
                  item.discharge_date
                );
              } catch (e) {
                item.discharge_date = item.discharge_date;
              }
            } else {
              item.discharge_date = datesFactory.convertDate(new Date());
            }
          } else {
            if ($scope.endorsement.policy.ramo.ramo_code != 3) {
              if (item.personal.discharge_date) {
                try {
                  if (
                    datesFactory.convertDate(item.personal.discharge_date) ==
                    "NaN/NaN/NaN"
                  ) {
                    item.personal.discharge_date = item.personal.discharge_date;
                  } else {
                    item.personal.discharge_date = datesFactory.convertDate(
                      item.personal.discharge_date
                    );
                  }
                } catch (e) {
                  item.personal.discharge_date = item.personal.discharge_date;
                }
              } else {
                item.discharge_date = datesFactory.convertDate(new Date());
              }
              // console.log('item', item.personal);
              item.personal.dependientes = item.personal.dependientes.map(
                function (itemRelation) {
                  try {
                    dataFactory
                      .get("v1/relationships/" + itemRelation.id)
                      .then(function success(rels) {
                        if (rels) {
                          itemRelation.is_active = rels.data.is_active;
                        }
                      })
                      .catch(function (error) {
                        console.log(
                          "Error - claves-by-provider - catch",
                          error
                        );
                      });
                  } catch (i) {}
                  if (itemRelation.discharge_date) {
                    try {
                      itemRelation.discharge_date = datesFactory.convertDate(
                        itemRelation.discharge_date
                      );
                    } catch (e) {
                      itemRelation.discharge_date = itemRelation.discharge_date;
                    }
                  }
                  return itemRelation;
                }
              );
            }
          }
          return item;
        });
      }
      $scope.updateTotal();
    };
    function isValidDate(dateObject) {
      return new Date(dateObject).toString() !== "Invalid Date";
    }
    $scope.validateDates = function (item, date, tipo) {
      if (!date) return;
      if (tipo == 1) {
        //charge
        var datePattern =
          /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
        var match = date.match(datePattern);

        if (!match) {
          SweetAlert.swal(
            "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
            "error"
          );
          item.charge_date = datesFactory.convertDate(new Date()); // Reset input
          return;
        }
        var day = match[1];
        var month = match[2];
        var year = match[3];
        if (year.length === 5) {
          year = year.substring(0, 4);
        }
        year = parseInt(year, 10);
        var currentYear = new Date().getFullYear();
        var correctedDate = day + "/" + month + "/" + year;
        item.charge_date = correctedDate;
      }
      if (tipo == 2) {
        //antoguedad
        var datePattern =
          /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
        var match = date.match(datePattern);

        if (!match) {
          SweetAlert.swal(
            "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
            "error"
          );
          item.antiguedad = datesFactory.convertDate(new Date()); // Reset input
          return;
        }
        var day = match[1];
        var month = match[2];
        var year = match[3];
        if (year.length === 5) {
          year = year.substring(0, 4);
        }
        year = parseInt(year, 10);
        var currentYear = new Date().getFullYear();
        var correctedDate = day + "/" + month + "/" + year;
        item.antiguedad = correctedDate;
      }
      if (tipo == 3) {
        //birthdtae
        var datePattern =
          /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
        var match = date.match(datePattern);

        if (!match) {
          SweetAlert.swal(
            "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
            "error"
          );
          item.birthdate = datesFactory.convertDate(new Date()); // Reset input
          return;
        }
        var day = match[1];
        var month = match[2];
        var year = match[3];
        if (year.length === 5) {
          year = year.substring(0, 4);
        }
        year = parseInt(year, 10);
        var currentYear = new Date().getFullYear();
        var currentYear = new Date().getFullYear();
        if (year < 1900 || year > currentYear) {
          SweetAlert.swal(
            "El año debe estar entre 1900 y " + currentYear,
            "error"
          );
          $scope.newCertificates.personal.birthdate = datesFactory.convertDate(
            new Date()
          ); // Reset input
          return;
        }
        var correctedDate = day + "/" + month + "/" + year;
        item.birthdate = correctedDate;
      }
      if (tipo == 4) {
        //discharge
        var datePattern =
          /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
        var match = date.match(datePattern);

        if (!match) {
          SweetAlert.swal(
            "Fecha inválida. Usa el formato DD/MM/YYYY con un año de 4 dígitos.",
            "error"
          );
          item.discharge_date = datesFactory.convertDate(new Date()); // Reset input
          return;
        }
        var day = match[1];
        var month = match[2];
        var year = match[3];
        if (year.length === 5) {
          year = year.substring(0, 4);
        }
        year = parseInt(year, 10);
        var currentYear = new Date().getFullYear();
        var correctedDate = day + "/" + month + "/" + year;
        item.discharge_date = correctedDate;
      }
    };
    $scope.updateTotal = function () {
      if (
        $scope.endorsement.endorsement_type == "A" &&
        $scope.endorsement.policy.ramo.ramo_code == 2
      ) {
        $scope.suma_p_total = 0;
        $scope.endorsement.changes.forEach(function (item) {
          if (item && item.tipo) {
            $scope.suma_p_total =
              $scope.suma_p_total + parseFloat(item.p_total);
          } else {
            if (!item.accidents_policy[0].personal.url) {
              $scope.suma_p_total =
                $scope.suma_p_total +
                parseFloat(item.accidents_policy[0].personal.p_total);
            }

            item.accidents_policy[0].relationship_accident.forEach(function (
              itemRelation
            ) {
              if (!itemRelation.url) {
                $scope.suma_p_total =
                  $scope.suma_p_total + parseFloat(itemRelation.p_total);
              }
            });
          }
        });
        $scope.suma_p_total = parseFloat($scope.suma_p_total.toFixed(2));
      } else if (
        $scope.endorsement.endorsement_type == "A" &&
        $scope.endorsement.policy.ramo.ramo_code == 1
      ) {
        $scope.suma_p_total = 0;
        $scope.endorsement.changes.forEach(function (item) {
          if (!item.life_policy[0].personal.url) {
            $scope.suma_p_total =
              $scope.suma_p_total +
              parseFloat(item.life_policy[0].personal.p_total);
          }
        });
        $scope.suma_p_total = parseFloat($scope.suma_p_total.toFixed(2));
      } else if (
        $scope.endorsement.endorsement_type == "A" &&
        $scope.endorsement.policy.subramo.subramo_code == 9
      ) {
        $scope.suma_p_total = 0;
        $scope.endorsement.changes.forEach(function (item) {
          $scope.suma_p_total =
            $scope.suma_p_total +
            parseFloat(item.automobiles_policy[0].p_total);
        });
        $scope.suma_p_total = parseFloat($scope.suma_p_total.toFixed(2));
      } else if ($scope.endorsement.endorsement_type == "D") {
        $scope.suma_p_total = 0;
        $scope.endorsement.changes.forEach(function (item) {
          if (item && item.tipo) {
            $scope.suma_p_total =
              $scope.suma_p_total + parseFloat(item.prima_total_earned);
          } else {
            $scope.suma_p_total =
              $scope.suma_p_total + parseFloat(item.personal.p_total_earned);
            item.personal.dependientes.forEach(function (itemDependientes) {
              $scope.suma_p_total =
                $scope.suma_p_total +
                parseFloat(itemDependientes.p_total_earned);
            });
          }
        });
        $scope.suma_p_total_baja = parseFloat($scope.suma_p_total.toFixed(2));
      }
      // $scope.updatePrimaTotal();
    };

    $scope.updatePrimaTotal = function () {
      $scope.endorsement.change = $scope.endorsement.change.map(function (
        item
      ) {
        if (
          $scope.endorsement.policy.ramo.ramo_code == 2 &&
          $scope.endorsement.endorsement_type == "D"
        ) {
          item.prima_neta_earned = parseFloat(item.prima_neta_earned) || 0;
          item.rpf_earned = parseFloat(item.rpf_earned) || 0;
          item.derecho_earned = parseFloat(item.derecho_earned) || 0;
          item.iva_earned = parseFloat(item.iva_earned) || 0;
          if (item && item.tipo) {
            var _subtotal =
              parseFloat(item.prima_neta_earned) +
              parseFloat(item.rpf_earned) +
              parseFloat(item.derecho_earned);
            item.iva_earned = parseFloat(
              (_subtotal * 0.16).toFixed(2)
            ).toString();
            item.prima_total_earned = (item.iva_earned + _subtotal).toFixed(2);
          } else {
            var subtotal =
              parseFloat(item.personal.p_neta_earned) +
              parseFloat(item.personal.rpf_earned) +
              parseFloat(item.personal.derecho_earned);
            item.personal.iva_earned = parseFloat((subtotal * 0.16).toFixed(2));
            item.personal.p_total_earned = (
              item.personal.iva_earned + subtotal
            ).toFixed(2);

            item.personal.dependientes = item.personal.dependientes.map(
              function (itemDependientes) {
                var subtotal_ =
                  parseFloat(itemDependientes.p_neta_earned) +
                  parseFloat(itemDependientes.rpf_earned) +
                  parseFloat(itemDependientes.derecho_earned);
                itemDependientes.iva_earned = parseFloat(
                  (subtotal_ * 0.16).toFixed(2)
                );
                itemDependientes.p_total_earned = (
                  itemDependientes.iva_earned + subtotal_
                ).toFixed(2);
              }
            );
          }
        } else if (
          $scope.endorsement.policy.ramo.ramo_code == 1 &&
          $scope.endorsement.endorsement_type == "D"
        ) {
          item.personal.p_neta_earned =
            parseFloat(item.personal.p_neta_earned) || 0;
          item.personal.rpf_earned = parseFloat(item.personal.rpf_earned) || 0;
          item.personal.derecho_earned =
            parseFloat(item.personal.derecho_earned) || 0;
          item.personal.iva_earned = parseFloat(item.personal.iva_earned) || 0;
          var subtotal =
            parseFloat(item.personal.p_neta_earned) +
            parseFloat(item.personal.rpf_earned) +
            parseFloat(item.personal.derecho_earned);
          item.personal.iva_earned = parseFloat((subtotal * 0.16).toFixed(2));
          item.personal.p_total_earned = (
            item.personal.iva_earned + subtotal
          ).toFixed(2);
        } else if (
          $scope.endorsement.policy.subramo.subramo_code == 9 &&
          $scope.endorsement.endorsement_type == "D"
        ) {
          item.personal.p_neta_earned =
            parseFloat(item.personal.p_neta_earned) || 0;
          item.personal.rpf_earned = parseFloat(item.personal.rpf_earned) || 0;
          item.personal.derecho_earned =
            parseFloat(item.personal.derecho_earned) || 0;
          item.personal.iva_earned = parseFloat(item.personal.iva_earned) || 0;
          var subtotal =
            parseFloat(item.personal.p_neta_earned) +
            parseFloat(item.personal.rpf_earned) +
            parseFloat(item.personal.derecho_earned);
          item.personal.iva_earned = parseFloat((subtotal * 0.16).toFixed(2));
          item.personal.p_total_earned = (
            item.personal.iva_earned + subtotal
          ).toFixed(2);
        } else if (
          $scope.endorsement.policy.ramo.ramo_code == 2 &&
          $scope.endorsement.endorsement_type == "A"
        ) {
          if (item && item.tipo) {
            item.p_neta = parseFloat(item.p_neta) || 0;
            item.rpf = parseFloat(item.rpf) || 0;
            item.derecho = parseFloat(item.derecho) || 0;
            item.iva = parseFloat(item.iva) || 0;
            var _subtotal =
              parseFloat(item.p_neta) +
              parseFloat(item.rpf) +
              parseFloat(item.derecho);
            item.iva = parseFloat((_subtotal * 0.16).toFixed(2));
            item.p_total = parseFloat(item.iva + _subtotal).toFixed(2);
          } else {
            item.accidents_policy[0].personal.p_neta =
              parseFloat(item.accidents_policy[0].personal.p_neta) || 0;
            item.accidents_policy[0].personal.rpf =
              parseFloat(item.accidents_policy[0].personal.rpf) || 0;
            item.accidents_policy[0].personal.derecho =
              parseFloat(item.accidents_policy[0].personal.derecho) || 0;
            item.accidents_policy[0].personal.iva =
              parseFloat(item.accidents_policy[0].personal.iva) || 0;
            var subtotal =
              parseFloat(item.accidents_policy[0].personal.p_neta) +
              parseFloat(item.accidents_policy[0].personal.rpf) +
              parseFloat(item.accidents_policy[0].personal.derecho);
            item.accidents_policy[0].personal.iva = parseFloat(
              (subtotal * 0.16).toFixed(2)
            );
            item.accidents_policy[0].personal.p_total = (
              item.accidents_policy[0].personal.iva + subtotal
            ).toFixed(2);
            item.accidents_policy[0].relationship_accident =
              item.accidents_policy[0].relationship_accident.map(function (
                itemDependientes
              ) {
                // console.log('item', itemDependientes);
                itemDependientes.p_neta =
                  parseFloat(itemDependientes.p_neta) || 0;
                itemDependientes.rpf = parseFloat(itemDependientes.rpf) || 0;
                itemDependientes.derecho =
                  parseFloat(itemDependientes.derecho) || 0;
                itemDependientes.iva = parseFloat(itemDependientes.iva) || 0;
                var subtotal_ =
                  parseFloat(itemDependientes.p_neta) +
                  parseFloat(itemDependientes.rpf) +
                  parseFloat(itemDependientes.derecho);
                itemDependientes.iva = parseFloat(
                  (subtotal_ * 0.16).toFixed(2)
                );
                itemDependientes.p_total = parseFloat(
                  itemDependientes.iva + subtotal_
                ).toFixed(2);
                return itemDependientes;
              });
          }
        } else if (
          $scope.endorsement.policy.ramo.ramo_code == 1 &&
          $scope.endorsement.endorsement_type == "A"
        ) {
          item.life_policy[0].personal.p_neta =
            parseFloat(item.life_policy[0].personal.p_neta) || 0;
          item.life_policy[0].personal.rpf =
            parseFloat(item.life_policy[0].personal.rpf) || 0;
          item.life_policy[0].personal.derecho =
            parseFloat(item.life_policy[0].personal.derecho) || 0;
          item.life_policy[0].personal.iva =
            parseFloat(item.life_policy[0].personal.iva) || 0;
          var subtotal =
            parseFloat(item.life_policy[0].personal.p_neta) +
            parseFloat(item.life_policy[0].personal.rpf) +
            parseFloat(item.life_policy[0].personal.derecho);
          item.life_policy[0].personal.iva = parseFloat(
            (subtotal * 0.16).toFixed(2)
          );
          item.life_policy[0].personal.p_total = (
            item.life_policy[0].personal.iva + subtotal
          ).toFixed(2);
        } else if (
          $scope.endorsement.policy.subramo.subramo_code == 9 &&
          $scope.endorsement.endorsement_type == "A"
        ) {
          item.p_neta = parseFloat(item.p_neta) || 0;
          item.rpf = parseFloat(item.rpf) || 0;
          item.derecho = parseFloat(item.derecho) || 0;
          item.iva = parseFloat(item.iva) || 0;
          var subtotal =
            parseFloat(item.p_neta) +
            parseFloat(item.rpf) +
            parseFloat(item.derecho);
          item.iva = parseFloat((subtotal * 0.16).toFixed(2));
          item.p_total = parseFloat(item.iva + subtotal).toFixed(2);
        }
        return item;
      });
      $scope.updateTotal();
    };

    $scope.hideButtons = function () {
      $scope.endorsement.change.forEach(function (item) {
        if (item && item.tipo) {
          item.antiguedad = datesFactory.toDate(item.antiguedad);
          item.charge_date = item.charge_date
            ? datesFactory.toDate(item.charge_date)
            : datesFactory.toDate($scope.endorsement.init_date);
        } else {
          item.accidents_policy[0].personal.antiguedad = datesFactory.toDate(
            item.accidents_policy[0].personal.antiguedad
          );
          item.accidents_policy[0].personal.charge_date = item
            .accidents_policy[0].personal.charge_date
            ? datesFactory.toDate(item.accidents_policy[0].personal.charge_date)
            : datesFactory.toDate($scope.endorsement.init_date);
          item.accidents_policy[0].relationship_accident =
            item.accidents_policy[0].relationship_accident.map(function (
              itemRelation
            ) {
              itemRelation.antiguedad = datesFactory.toDate(
                itemRelation.antiguedad
              );
              itemRelation.charge_date = itemRelation.charge_date
                ? datesFactory.toDate(itemRelation.charge_date)
                : datesFactory.toDate($scope.endorsement.init_date);
              return itemRelation;
            });
        }
      });
      $scope.editChanges = false;
    };
    $scope.changePrimaIva = function (param) {
      var p_neta = parseFloat(param.p_neta ? param.p_neta : 0).toFixed(2);
      var rpf = parseFloat(param.rpf ? param.rpf : 0).toFixed(2);
      var derecho = parseFloat(param.derecho ? param.derecho : 0).toFixed(2);
      // param.sub_total = parseFloat(param.sub_total).toFixed(2);
      var iva = parseFloat(param.iva ? param.iva : 0).toFixed(2);
      var p_total = parseFloat(param.p_total ? param.p_total : 0).toFixed(2);
      var comision = parseFloat(param.comision ? param.comision : 0).toFixed(2);

      var sub_total = parseFloat(
        parseFloat(
          parseFloat(p_neta) + parseFloat(rpf) + parseFloat(derecho)
        ).toFixed(2)
      );

      if ($scope.endorsement.policy.ramo.ramo_code == 1) {
        param.iva = 0;
      }

      var p_total = parseFloat(
        parseFloat(parseFloat(sub_total) + parseFloat(iva)).toFixed(2)
      );
      param.p_total = parseFloat(p_total);
    };
    $scope.saveChangesUpdates = function (change) {
      $scope.editChanges = false;
      if (
        $scope.endorsement.endorsement_type == "A" &&
        $scope.endorsement.policy.ramo.ramo_code == 2
      ) {
        change = change.map(function (item) {
          if (item && item.tipo) {
            item.antiguedad = datesFactory.toDate(item.antiguedad);
            item.charge_date = datesFactory.toDate(item.charge_date);
          } else {
            item.certificate_number =
              item.accidents_policy[0].certificate_number;
            item.accidents_policy[0].personal.antiguedad = datesFactory.toDate(
              item.accidents_policy[0].personal.antiguedad
            );
            item.accidents_policy[0].personal.charge_date = datesFactory.toDate(
              item.accidents_policy[0].personal.charge_date
            );
            item.accidents_policy[0].personal.birthdate = datesFactory.toDate(
              item.accidents_policy[0].personal.birthdate
            );
            item.accidents_policy[0].personal.contributory = item.contributory
              ? item.contributory
              : false;

            item.p_neta = parseFloat(
              (
                parseFloat(item.p_neta) +
                parseFloat(item.accidents_policy[0].personal.p_neta)
              ).toFixed(2)
            );
            item.iva = parseFloat(
              (
                parseFloat(item.iva) +
                parseFloat(item.accidents_policy[0].personal.iva)
              ).toFixed(2)
            );
            item.rpf = parseFloat(
              (
                parseFloat(item.rpf) +
                parseFloat(item.accidents_policy[0].personal.rpf)
              ).toFixed(2)
            );
            item.derecho = parseFloat(
              (
                parseFloat(item.derecho) +
                parseFloat(item.accidents_policy[0].personal.derecho)
              ).toFixed(2)
            );
            item.p_total = parseFloat(
              (
                parseFloat(item.p_total) +
                parseFloat(item.accidents_policy[0].personal.p_total)
              ).toFixed(2)
            );
            item.comision = parseFloat(
              (
                parseFloat(item.comision) +
                parseFloat(item.accidents_policy[0].personal.comision)
              ).toFixed(2)
            );

            item.accidents_policy[0].relationship_accident =
              item.accidents_policy[0].relationship_accident.map(function (
                itemRelation
              ) {
                itemRelation.antiguedad = datesFactory.toDate(
                  itemRelation.antiguedad
                );
                itemRelation.charge_date = datesFactory.toDate(
                  itemRelation.charge_date
                );
                itemRelation.birthdate = datesFactory.toDate(
                  itemRelation.birthdate
                );
                item.p_neta = parseFloat(
                  (
                    parseFloat(item.p_neta) + parseFloat(itemRelation.p_neta)
                  ).toFixed(2)
                );
                item.iva = parseFloat(
                  (parseFloat(item.iva) + parseFloat(itemRelation.iva)).toFixed(
                    2
                  )
                );
                item.rpf = parseFloat(
                  (parseFloat(item.rpf) + parseFloat(itemRelation.rpf)).toFixed(
                    2
                  )
                );
                item.derecho = parseFloat(
                  (
                    parseFloat(item.derecho) + parseFloat(itemRelation.derecho)
                  ).toFixed(2)
                );
                item.p_total = parseFloat(
                  (
                    parseFloat(item.p_total) + parseFloat(itemRelation.p_total)
                  ).toFixed(2)
                );
                item.comision = parseFloat(
                  (
                    parseFloat(item.comision) +
                    parseFloat(itemRelation.comision)
                  ).toFixed(2)
                );
                itemRelation.contributory = item.contributory
                  ? item.contributory
                  : false;
                return itemRelation;
              });
          }
          return item;
        });
      }
      if (
        $scope.endorsement.endorsement_type == "A" &&
        $scope.endorsement.policy.ramo.ramo_code == 1
      ) {
        change = change.map(function (item) {
          item.certificate_number = item.life_policy[0].certificate_number;
          item.life_policy[0].personal.antiguedad = datesFactory.toDate(
            item.life_policy[0].personal.antiguedad
          );
          item.life_policy[0].personal.birthdate = datesFactory.toDate(
            item.life_policy[0].personal.birthdate
          );
          item.p_neta = parseFloat(
            parseFloat(item.life_policy[0].personal.p_neta).toFixed(2)
          );
          item.iva = parseFloat(
            parseFloat(item.life_policy[0].personal.iva).toFixed(2)
          );
          item.rpf = parseFloat(
            parseFloat(item.life_policy[0].personal.rpf).toFixed(2)
          );
          item.derecho = parseFloat(
            parseFloat(item.life_policy[0].personal.derecho).toFixed(2)
          );
          item.p_total = parseFloat(
            parseFloat(item.life_policy[0].personal.p_total).toFixed(2)
          );
          item.comision = parseFloat(
            parseFloat(item.life_policy[0].personal.comision).toFixed(2)
          );
          return item;
        });
      }

      if ($scope.endorsement.endorsement_type == "D") {
        change = change.map(function (item) {
          if (item && item.tipo) {
            item.discharge_date = datesFactory.toDate(item.discharge_date);
          } else {
            try {
              delete item.personal.is_active;
            } catch (err) {}
            item.personal.discharge_date = datesFactory.toDate(
              item.personal.discharge_date
            );
            item.personal.dependientes = item.personal.dependientes.map(
              function (itemRelation) {
                itemRelation.discharge_date = datesFactory.toDate(
                  itemRelation.discharge_date
                );
                return itemRelation;
              }
            );
          }
          return item;
        });
      }
      $http({
        method: "PATCH",
        url: $scope.endorsement.url,
        data: { change: JSON.stringify(change) },
      })
        .then(
          function (response) {
            SweetAlert.swal(
              "Actualizado",
              "Los datos han sido actualizados",
              "success"
            );
            $scope.editChanges = false;
          },
          function (error) {
            console.log(error);
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al actualizar los datos",
              "error"
            );
          }
        )
        .catch(function (error) {
          console.log(error);
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al actualizar los datos",
            "error"
          );
        });
    };
    $scope.guardandolay = false;
    $scope.saveChangesUpdatesLayout = function (change, data) {
      $scope.editChanges = false;
      $scope.guardandolay = true;
      if ($scope.endorsement.endorsement_type == "D") {
        if ($scope.endorsement.policy.ramo.ramo_code == 2) {
          change = change.map(function (item) {
            if (item.personal) {
              data.forEach(function (dato, index) {
                if (item.personal.id) {
                  if (dato.TIPO == "Titular" && dato.ID == item.personal.id) {
                    item.personal.discharge_date = datesFactory.toDate(
                      dato.FECHA_BAJA ? dato.FECHA_BAJA : new Date()
                    );
                    item.personal.p_neta_earned = parseFloat(
                      dato.PRIMA_NETA_NO_DEVENGADA
                        ? dato.PRIMA_NETA_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.personal.p_total_earned = parseFloat(
                      dato.PRIMA_TOTAL_NO_DEVENGADA
                        ? dato.PRIMA_TOTAL_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.personal.prima_neta_earned = parseFloat(
                      dato.PRIMA_NETA_NO_DEVENGADA
                        ? dato.PRIMA_NETA_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.personal.prima_total_earned = parseFloat(
                      dato.PRIMA_TOTAL_NO_DEVENGADA
                        ? dato.PRIMA_TOTAL_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.personal.rpf_earned = parseFloat(
                      dato.RPF_NO_DEVENGADA ? dato.RPF_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.personal.iva_earned = parseFloat(
                      dato.IVA_NO_DEVENGADA ? dato.IVA_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.personal.derecho_earned = parseFloat(
                      dato.DERECHO_NO_DEVENGADA ? dato.DERECHO_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.personal.comision_earned = parseFloat(
                      dato.COMISION_NO_DEVENGADA
                        ? dato.COMISION_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    // item.personal.comision_percent_earned = parseFloat(dato.COMISION_PORCENTAJE_NO_DEVENGADA ? dato.COMISION_PORCENTAJE_NO_DEVENGADA : 0).toFixed(2)
                    // item.personal.descuento_earned = parseFloat(dato.DESCUENTO_NO_DEVENGADA ? dato.DESCUENTO_NO_DEVENGADA : 0).toFixed(2)
                  }
                }
                if (item.personal.dependientes) {
                  item.personal.dependientes.forEach(function (itemRelation) {
                    data.forEach(function (dato2, index) {
                      if (itemRelation) {
                        if (
                          dato2.TIPO == "Dependiente" &&
                          dato2.ID == itemRelation.id
                        ) {
                          itemRelation.discharge_date = datesFactory.toDate(
                            dato2.FECHA_BAJA ? dato2.FECHA_BAJA : new Date()
                          );
                          itemRelation.p_neta_earned = parseFloat(
                            dato2.PRIMA_NETA_NO_DEVENGADA
                              ? dato2.PRIMA_NETA_NO_DEVENGADA
                              : 0
                          ).toFixed(2);
                          itemRelation.p_total_earned = parseFloat(
                            dato2.PRIMA_TOTAL_NO_DEVENGADA
                              ? dato2.PRIMA_TOTAL_NO_DEVENGADA
                              : 0
                          ).toFixed(2);
                          itemRelation.prima_neta_earned = parseFloat(
                            dato2.PRIMA_NETA_NO_DEVENGADA
                              ? dato2.PRIMA_NETA_NO_DEVENGADA
                              : 0
                          ).toFixed(2);
                          itemRelation.prima_total_earned = parseFloat(
                            dato2.PRIMA_TOTAL_NO_DEVENGADA
                              ? dato2.PRIMA_TOTAL_NO_DEVENGADA
                              : 0
                          ).toFixed(2);
                          itemRelation.rpf_earned = parseFloat(
                            dato2.RPF_NO_DEVENGADA ? dato2.RPF_NO_DEVENGADA : 0
                          ).toFixed(2);
                          itemRelation.iva_earned = parseFloat(
                            dato2.IVA_NO_DEVENGADA ? dato2.IVA_NO_DEVENGADA : 0
                          ).toFixed(2);
                          itemRelation.derecho_earned = parseFloat(
                            dato2.DERECHO_NO_DEVENGADA
                              ? dato2.DERECHO_NO_DEVENGADA
                              : 0
                          ).toFixed(2);
                          itemRelation.comision_earned = parseFloat(
                            dato2.COMISION_NO_DEVENGADA
                              ? dato2.COMISION_NO_DEVENGADA
                              : 0
                          ).toFixed(2);
                          // itemRelation.comision_percent_earned = parseFloat(dato2.COMISION_PORCENTAJE_NO_DEVENGADA ? dato2.COMISION_PORCENTAJE_NO_DEVENGADA : 0).toFixed(2)
                          // itemRelation.descuento_earned = parseFloat(dato2.DESCUENTO_NO_DEVENGADA ? dato2.DESCUENTO_NO_DEVENGADA : 0).toFixed(2)
                          // return itemRelation;
                        }
                      }
                    });
                  });
                }
              });
            }
            if (item.tipo) {
              if (item.tipo == 1 || item.tipo == "1") {
                data.forEach(function (dato, index) {
                  if (
                    dato.TIPO == "Titular" &&
                    dato.NOMBRE == item.first_name &&
                    dato.APELLIDO_PATERNO == item.last_name &&
                    dato.APELLIDO_MATERNO == item.second_last_name
                  ) {
                    item.discharge_date = datesFactory.toDate(
                      dato.FECHA_BAJA ? dato.FECHA_BAJA : new Date()
                    );
                    item.p_neta_earned = parseFloat(
                      dato.PRIMA_NETA_NO_DEVENGADA
                        ? dato.PRIMA_NETA_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.p_total_earned = parseFloat(
                      dato.PRIMA_TOTAL_NO_DEVENGADA
                        ? dato.PRIMA_TOTAL_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.prima_neta_earned = parseFloat(
                      dato.PRIMA_NETA_NO_DEVENGADA
                        ? dato.PRIMA_NETA_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.prima_total_earned = parseFloat(
                      dato.PRIMA_TOTAL_NO_DEVENGADA
                        ? dato.PRIMA_TOTAL_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.rpf_earned = parseFloat(
                      dato.RPF_NO_DEVENGADA ? dato.RPF_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.iva_earned = parseFloat(
                      dato.IVA_NO_DEVENGADA ? dato.IVA_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.derecho_earned = parseFloat(
                      dato.DERECHO_NO_DEVENGADA ? dato.DERECHO_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.comision_earned = parseFloat(
                      dato.COMISION_NO_DEVENGADA
                        ? dato.COMISION_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    // item.comision_percent_earned = parseFloat(dato.COMISION_PORCENTAJE_NO_DEVENGADA ? dato.COMISION_PORCENTAJE_NO_DEVENGADA : 0).toFixed(2)
                    // item.descuento_earned = parseFloat(dato.DESCUENTO_NO_DEVENGADA ? dato.DESCUENTO_NO_DEVENGADA : 0).toFixed(2)
                  }
                });
              }
              if (
                item.tipo == 2 ||
                item.tipo == "2" ||
                item.tipo == 3 ||
                item.tipo == "3"
              ) {
                data.forEach(function (dato, index) {
                  if (
                    dato.TIPO == "Dependiente" &&
                    dato.NOMBRE == item.first_name &&
                    dato.APELLIDO_PATERNO == item.last_name &&
                    dato.APELLIDO_MATERNO == item.second_last_name
                  ) {
                    item.discharge_date = datesFactory.toDate(
                      dato.FECHA_BAJA ? dato.FECHA_BAJA : new Date()
                    );
                    item.p_neta_earned = parseFloat(
                      dato.PRIMA_NETA_NO_DEVENGADA
                        ? dato.PRIMA_NETA_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.p_total_earned = parseFloat(
                      dato.PRIMA_TOTAL_NO_DEVENGADA
                        ? dato.PRIMA_TOTAL_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.prima_neta_earned = parseFloat(
                      dato.PRIMA_NETA_NO_DEVENGADA
                        ? dato.PRIMA_NETA_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.prima_total_earned = parseFloat(
                      dato.PRIMA_TOTAL_NO_DEVENGADA
                        ? dato.PRIMA_TOTAL_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.rpf_earned = parseFloat(
                      dato.RPF_NO_DEVENGADA ? dato.RPF_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.iva_earned = parseFloat(
                      dato.IVA_NO_DEVENGADA ? dato.IVA_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.derecho_earned = parseFloat(
                      dato.DERECHO_NO_DEVENGADA ? dato.DERECHO_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.comision_earned = parseFloat(
                      dato.COMISION_NO_DEVENGADA
                        ? dato.COMISION_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    // item.comision_percent_earned = parseFloat(dato.COMISION_PORCENTAJE_NO_DEVENGADA ? dato.COMISION_PORCENTAJE_NO_DEVENGADA : 0).toFixed(2)
                    // item.descuento_earned = parseFloat(dato.DESCUENTO_NO_DEVENGADA ? dato.DESCUENTO_NO_DEVENGADA : 0).toFixed(2)
                  }
                });
              }
            }
            return item;
          });
        } else if ($scope.endorsement.policy.ramo.ramo_code == 1) {
          change = change.map(function (item) {
            if (item.tipo) {
              if (item.tipo == 1 || item.tipo == "1") {
                data.forEach(function (dato, index) {
                  if (
                    dato.TIPO == "Titular" &&
                    dato.NOMBRE == item.first_name &&
                    dato.APELLIDO_PATERNO == item.last_name &&
                    dato.APELLIDO_MATERNO == item.second_last_name
                  ) {
                    item.discharge_date = datesFactory.toDate(
                      dato.FECHA_BAJA ? dato.FECHA_BAJA : new Date()
                    );
                    item.p_neta_earned = parseFloat(
                      dato.PRIMA_NETA_NO_DEVENGADA
                        ? dato.PRIMA_NETA_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.p_total_earned = parseFloat(
                      dato.PRIMA_TOTAL_NO_DEVENGADA
                        ? dato.PRIMA_TOTAL_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.prima_neta_earned = parseFloat(
                      dato.PRIMA_NETA_NO_DEVENGADA
                        ? dato.PRIMA_NETA_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.prima_total_earned = parseFloat(
                      dato.PRIMA_TOTAL_NO_DEVENGADA
                        ? dato.PRIMA_TOTAL_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.rpf_earned = parseFloat(
                      dato.RPF_NO_DEVENGADA ? dato.RPF_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.iva_earned = parseFloat(
                      dato.IVA_NO_DEVENGADA ? dato.IVA_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.derecho_earned = parseFloat(
                      dato.DERECHO_NO_DEVENGADA ? dato.DERECHO_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.comision_earned = parseFloat(
                      dato.COMISION_NO_DEVENGADA
                        ? dato.COMISION_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    // item.comision_percent_earned = parseFloat(dato.COMISION_PORCENTAJE_NO_DEVENGADA ? dato.COMISION_PORCENTAJE_NO_DEVENGADA : 0).toFixed(2)
                    // item.descuento_earned = parseFloat(dato.DESCUENTO_NO_DEVENGADA ? dato.DESCUENTO_NO_DEVENGADA : 0).toFixed(2)
                  }
                });
              }
            }
            if (item.personal) {
              data.forEach(function (dato, index) {
                if (item.personal.id) {
                  if (
                    (dato.TIPO == "Titular" &&
                      item.certificate_number == dato.CERTIFICADO) ||
                    (dato.NOMBRE == item.first_name &&
                      dato.APELLIDO_PATERNO == item.last_name &&
                      dato.APELLIDO_MATERNO == item.second_last_name)
                  ) {
                    item.personal.discharge_date = datesFactory.toDate(
                      dato.FECHA_BAJA ? dato.FECHA_BAJA : new Date()
                    );
                    item.personal.p_neta_earned = parseFloat(
                      dato.PRIMA_NETA_NO_DEVENGADA
                        ? dato.PRIMA_NETA_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.personal.p_total_earned = parseFloat(
                      dato.PRIMA_TOTAL_NO_DEVENGADA
                        ? dato.PRIMA_TOTAL_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.personal.prima_neta_earned = parseFloat(
                      dato.PRIMA_NETA_NO_DEVENGADA
                        ? dato.PRIMA_NETA_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.personal.prima_total_earned = parseFloat(
                      dato.PRIMA_TOTAL_NO_DEVENGADA
                        ? dato.PRIMA_TOTAL_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    item.personal.rpf_earned = parseFloat(
                      dato.RPF_NO_DEVENGADA ? dato.RPF_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.personal.iva_earned = parseFloat(
                      dato.IVA_NO_DEVENGADA ? dato.IVA_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.personal.derecho_earned = parseFloat(
                      dato.DERECHO_NO_DEVENGADA ? dato.DERECHO_NO_DEVENGADA : 0
                    ).toFixed(2);
                    item.personal.comision_earned = parseFloat(
                      dato.COMISION_NO_DEVENGADA
                        ? dato.COMISION_NO_DEVENGADA
                        : 0
                    ).toFixed(2);
                    // item.personal.comision_percent_earned = parseFloat(dato.COMISION_PORCENTAJE_NO_DEVENGADA ? dato.COMISION_PORCENTAJE_NO_DEVENGADA : 0).toFixed(2)
                    // item.personal.descuento_earned = parseFloat(dato.DESCUENTO_NO_DEVENGADA ? dato.DESCUENTO_NO_DEVENGADA : 0).toFixed(2)
                  }
                }
              });
            }
            return item;
          });
        }
      }

      $http({
        method: "PATCH",
        url: $scope.endorsement.url,
        data: { change: JSON.stringify(change) },
      })
        .then(
          function (response) {
            $scope.cargarLayout = false;
            $scope.excelJson = [];
            $scope.excelJsonViews = [];
            $scope.showTableCertificates = false;
            $scope.flagCertificate = true;
            $scope.guardandolay = false;

            SweetAlert.swal(
              "Actualizado",
              "Los datos han sido actualizados",
              "success"
            );
            $scope.editChanges = false;
          },
          function (error) {
            console.log(error);

            $scope.guardandolay = false;
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al actualizar los datos",
              "error"
            );
          }
        )
        .catch(function (error) {
          console.log(error);

          $scope.guardandolay = false;
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al actualizar los datos",
            "error"
          );
        });
    };
    $scope.getPDF = function () {
      var params = {
        poliza: $scope.endorsement.policy ? $scope.endorsement.policy.id : 0,
        fianza: 0,
        endoso: $scope.endorsement.id,
      };
      $http({
        method: "GET",
        url: url.IP + "get-pdf-endorsement-new/",
        responseType: "arraybuffer",
        params: params,
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });

        var fileURL = URL.createObjectURL(file);
        $scope.content = $sce.trustAsResourceUrl(fileURL);
        window.open($scope.content);
      });
    };

    $scope.sendProvider = function (provider) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/aseguradoras/send.modal.html",
        controller: "SendPDFModalCtrl",
        size: "lg",
        resolve: {
          provider: function () {
            return provider;
          },
          typeOT: function () {
            return 2;
          },
          from: function () {
            return null;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };

    $scope.statusPolicy = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.payment = function (parValue) {
      switch (parValue) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 4:
          return "Cuatrimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        default:
          return parValue;
      }
    };

    $scope.statusNote = function (param) {
      switch (param) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Aplicada";
          break;
        case 3:
          return "Liquidada";
          break;
        case 4:
          return "Cancelada";
          break;
        case 5:
          return "Liquidada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.statusReceipt = function (param) {
      switch (param) {
        case 1:
          return "Pagado";
          break;
        case 2:
          return "Cancelado";
          break;
        case 3:
          return "Prorrogado";
          break;
        case 4:
          return "Pendiente de pago";
          break;
        case 5:
          return "Liquidado";
          break;
        case 6:
          return "Conciliado";
          break;
        case 7:
          return "Cerrado";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.returnToReceipts = function () {
      $scope.show_binnacle_receipt = false;
    };
    //primas calculate
    $scope.copy_iva_earned_titular = 0;
    $scope.copy_comision_earned_titular = 0;
    $scope.copy_comision_percent_earned_titular = 0;
    $scope.changePrimaTutular = function (param) {
      param.sub_total_earned = parseFloat(
        parseFloat(
          parseFloat(param.p_neta_earned) +
            parseFloat(param.rpf_earned) +
            parseFloat(param.derecho_earned)
        ).toFixed(2)
      ).toString();

      if ($scope.endorsement.policy.ramo.ramo_code != 1) {
        param.iva_earned = parseFloat(
          parseFloat(parseFloat(param.sub_total_earned) * 0.16).toFixed(2)
        ).toString();
        $scope.copy_iva_earned_titular = angular.copy(param.iva_earned);
      } else {
        param.iva_earned = "0";
      }
      param.p_total_earned = parseFloat(
        parseFloat(
          parseFloat(param.sub_total_earned) + parseFloat(param.iva_earned)
        ).toFixed(2)
      ).toString();
      $scope.updateTotal();
    };

    $scope.copy_iva_earned = [0];
    $scope.copy_comision_earned = [0];
    $scope.copy_comision_percent_earned = [0];
    $scope.changePrimaDependient = function (paramrel, index) {
      paramrel.sub_total_earned = parseFloat(
        parseFloat(
          parseFloat(paramrel.p_neta_earned) +
            parseFloat(paramrel.rpf_earned) +
            parseFloat(paramrel.derecho_earned)
        ).toFixed(2)
      );
      if ($scope.endorsement.policy.ramo.ramo_code != 1) {
        paramrel.iva_earned = parseFloat(
          parseFloat(parseFloat(paramrel.sub_total_earned) * 0.16).toFixed(2)
        ).toString();
        $scope.copy_iva_earned_dependient = angular.copy(paramrel.iva_earned);
      } else {
        paramrel.iva_earned = "0";
      }
      paramrel.p_total_earned = parseFloat(
        parseFloat(
          parseFloat(paramrel.sub_total_earned) +
            parseFloat(paramrel.iva_earned)
        ).toFixed(2)
      ).toString();
      $scope.updateTotal();
    };
    //primas calculate end
    $scope.showBinnacleReceipt = function (receipt) {
      $scope.show_binnacle_receipt = true;
      $scope.receipt_id = receipt.id;
      $scope.comments_data_receipt = [];
      $scope.receiptmodel = receipt.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: receipt.id,
        },
      })
        .then(function (request) {
          $scope.comments_data_receipt = request.data.results;
          $scope.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.returnToReceiptsEndorsement = function () {
      $scope.show_binnacle_receipt_endorsement = false;
    };

    $scope.showBinnacleReceiptEndorsement = function (receipt) {
      $scope.show_binnacle_receipt_endorsement = true;
      $scope.comments_data_receipt = [];
      $scope.receipt_id = receipt.id;
      $scope.receiptmodel = receipt.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: receipt.id,
        },
      })
        .then(function (request) {
          $scope.comments_data_receipt = request.data.results;
          $scope.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.calculatePrimas = function (receipts) {
      $scope.total_prima = 0;
      $scope.total_rpf = 0;
      $scope.total_derecho = 0;
      $scope.total_iva = 0;
      $scope.total_total = 0;
      $scope.total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1 && receipts[i].status != 0) {
          $scope.total_prima =
            parseFloat($scope.total_prima) + parseFloat(receipts[i].prima_neta);
          $scope.total_rpf =
            parseFloat($scope.total_rpf) + parseFloat(receipts[i].rpf);
          $scope.total_derecho =
            parseFloat($scope.total_derecho) + parseFloat(receipts[i].derecho);
          $scope.total_iva =
            parseFloat($scope.total_iva) + parseFloat(receipts[i].iva);
          $scope.total_total =
            parseFloat($scope.total_total) +
            parseFloat(receipts[i].prima_total);
          $scope.total_comision =
            parseFloat($scope.total_comision) +
            parseFloat(receipts[i].comision);
        }
      }
    };

    function createReminderPayload(receipt, contractor) {
      var payload = angular.copy(receipt) || {};
      payload.contratante = contractor;
      payload.number_endorsement = $scope.endorsement.number_endorsement;
      if (!payload.poliza && $scope.endorsement && $scope.endorsement.policy) {
        payload.poliza = angular.copy($scope.endorsement.policy);
      }

      payload.reminder_info = buildReminderInfo(payload, contractor);

      return payload;
    }

    function buildReminderInfo(receipt, contractor) {
      var policy =
        $scope.endorsement && $scope.endorsement.policy
          ? $scope.endorsement.policy
          : {};
      var info = {};

      if ($scope.endorsement && $scope.endorsement.number_endorsement) {
        info.endorsementNumber = $scope.endorsement.number_endorsement;
      }

      return info;
    }

    $scope.addEmailsConfirmPolicy = function (insurance, param) {
      var reminderPayload = createReminderPayload(insurance, param);
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return reminderPayload;
          },
          valueReceipt: function () {
            return reminderPayload;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    };

    $scope.addPhoneWhatsapp = function (insurance, contra) {
      var reminderPayload = createReminderPayload(insurance, contra);
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.phone.whatsappsms_reminderpay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return reminderPayload;
          },
          valueReceipt: function () {
            return reminderPayload;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    };

    $scope.calculatePrimasEndorsement = function (receipts) {
      $scope.endorsement_total_prima = 0;
      $scope.endorsement_total_rpf = 0;
      $scope.endorsement_total_derecho = 0;
      $scope.endorsement_total_iva = 0;
      $scope.endorsement_total_total = 0;
      $scope.endorsement_total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (
          (receipts[i].receipt_type == 2 || receipts[i].receipt_type == 3) &&
          receipts[i].status != 0
        ) {
          $scope.endorsement_total_prima =
            parseFloat($scope.endorsement_total_prima) +
            parseFloat(receipts[i].prima_neta);
          $scope.endorsement_total_rpf =
            parseFloat($scope.endorsement_total_rpf) +
            parseFloat(receipts[i].rpf);
          $scope.endorsement_total_derecho =
            parseFloat($scope.endorsement_total_derecho) +
            parseFloat(receipts[i].derecho);
          $scope.endorsement_total_iva =
            parseFloat($scope.endorsement_total_iva) +
            parseFloat(receipts[i].iva);
          $scope.endorsement_total_total =
            parseFloat($scope.endorsement_total_total) +
            parseFloat(receipts[i].prima_total);
          $scope.endorsement_total_comision =
            parseFloat($scope.endorsement_total_comision) +
            parseFloat(receipts[i].comision);
        }
      }
    };
    $scope.cargarLayout = false;
    $scope.activarSubida = function (pa) {
      $scope.cargarLayout = true;
    };
    $scope.desactivarSubida = function (pa) {
      $scope.cargarLayout = false;
    };
    $scope.exportIncisos = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var data = { endoso: $scope.endorsement.id };
      var url_rep = "export-bajas-certificados/";
      $http({
        method: "POST",
        url: url.IP + url_rep,
        data: data,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function success(request) {
          if (request.status === 200) {
            var blob = new Blob([request.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "LayoutCertificadosComplementoPrimas.xls");
          }
          l.stop();
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };
    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      $scope.cargarLayout = true;
      var flagCertificate = false;
      $scope.showTableCertificates = true;
      $scope.changeOriginal = $scope.endorsement.change;
      if (param.certificados_baja) {
        $scope.excelJson = param.certificados_baja;
        $scope.excelJson.forEach(function (item) {
          if (!item.ID) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna INCISO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          try {
            if (item.PRIMA_NETA_NO_DEVENGADA) {
              if (item.PRIMA_NETA_NO_DEVENGADA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA_NO_DEVENGADA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (item.RPF_NO_DEVENGADA) {
              if (item.RPF_NO_DEVENGADA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF_NO_DEVENGADA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (item.DERECHO_NO_DEVENGADA) {
              if (item.DERECHO_NO_DEVENGADA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO_NO_DEVENGADA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (item.IVA_NO_DEVENGADA) {
              if (item.IVA_NO_DEVENGADA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA_NO_DEVENGADA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (item.PRIMA_TOTAL_NO_DEVENGADA) {
              if (item.PRIMA_TOTAL_NO_DEVENGADA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL_NO_DEVENGADA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (item.COMISION_NO_DEVENGADA) {
              if (item.COMISION_NO_DEVENGADA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_NO_DEVENGADA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            // if(item.DESCUENTO_NO_DEVENGADA){
            //   if(item.DESCUENTO_NO_DEVENGADA.indexOf(',') > -1){
            //     SweetAlert.swal('Error', 'Esta linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna DESCUENTO_NO_DEVENGADA contiene coma (,), elimina y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            // }
            // if(item.COMISION_PORCENTAJE_NO_DEVENGADA){
            //   if(item.COMISION_PORCENTAJE_NO_DEVENGADA.indexOf(',') > -1){
            //     SweetAlert.swal('Error', 'Esta linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna COMISION_PORCENTAJE_NO_DEVENGADA contiene coma (,), elimina y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }
            // }
            if (!item.FECHA_BAJA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_BAJA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_BAJA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
          } catch (e) {
            console.log("errrrrr", e);
          }
        });
        if (!flagCertificate) {
          $scope.selectedCertificates = param;
          $scope.addViews(0);
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };
    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      $scope.changeViews();
    };
    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        // if((index + 1) >= $scope.valueInitial && index < $scope.valueFinal){
        $scope.excelJsonViews.push(item);
        // }
      });
    };
    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.editReceipt = function (receipt, index) {
      var texto =
        "Esta es una alternativa de emergencia, por el momento no se validarán las primas y ni las fechas al editar este recibo. ¿Deseas continuar?";
      if (
        order.acceso_pl_cob == false &&
        (receipt.status == 1 || receipt.status == "Pagado")
      ) {
        var texto =
          "Esta es una alternativa de emergencia, por el momento no se validarán las primas y ni las fechas al editar este recibo.  \nEstas editando un recibo PAGADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      } else if (
        order.acceso_pl_cob == false &&
        (receipt.status == 5 || receipt.status == "Liquidado")
      ) {
        var texto =
          "Esta es una alternativa de emergencia, por el momento no se validarán las primas y ni las fechas al editar este recibo.  \nEstas editando un recibo LIQUIDADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      }
      if (
        receipt.status == 4 ||
        (order.acceso_pl_cob == false &&
          (receipt.status == 1 ||
            receipt.status == "Pagado" ||
            receipt.status == 5 ||
            receipt.status == "Liquidado"))
      ) {
        SweetAlert.swal(
          {
            title: "Advertencia",
            text: texto,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var modalInstance = $uibModal.open({
                templateUrl: "app/colectivos/receipt.html",
                controller: EditReceiptCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  recibo: function () {
                    return receipt;
                  },
                  index: function () {
                    return index;
                  },
                  endoso: function () {
                    return $scope.endorsement;
                  },
                  acceso_pl_cob: function () {
                    return order.acceso_pl_cob;
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });
            } else {
              SweetAlert.swal(
                "Cancelado",
                "El recibo no ha sido actualizado",
                "error"
              );
            }
          }
        );
      } else {
        SweetAlert.swal(
          "Advertencia",
          "El recibo no se puede editar porque no esta pendiente de pago.",
          "warning"
        );
      }
    };

    function EditReceiptCtrl(
      url,
      $http,
      $rootScope,
      recibo,
      index,
      endoso,
      $scope,
      $uibModalInstance,
      acceso_pl_cob
    ) {
      var rec = this;
      rec.recibo = recibo;
      var fecha_inicio = recibo.fecha_inicio;
      var fecha_fin = recibo.fecha_fin;
      var fecha_venc = recibo.vencimiento;

      rec.recibo.fecha_inicio = convertDate(recibo.fecha_inicio);
      rec.recibo.fecha_fin = convertDate(recibo.fecha_fin);
      rec.recibo.vencimiento = convertDate(recibo.vencimiento);

      function convertDate(inputFormat, indicator) {
        var date = inputFormat;
        if (inputFormat.length != 10) {
          function pad(s) {
            return s < 10 ? "0" + s : s;
          }
          var d = new Date(inputFormat);
          if (indicator) {
            date = [
              pad(d.getDate() + 1),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          } else {
            date = [
              pad(d.getDate()),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          }
        }
        return date;
      }

      function toDate(dateStr) {
        if (dateStr) {
          var dateString = dateStr;
          var dateParts = dateString.split("/");
          var dateObject = new Date(
            dateParts[2],
            dateParts[1] - 1,
            dateParts[0]
          );
          return dateObject;
        }
      }

      $scope.validateDecimal = function (form) {
        form = String(form).replace(/[A-Za-z]/g, "");
        form = String(form).replace(/,/g, "");
        return form;
      };

      $scope.changePrimas = function (data) {
        rec.recibo.sub_total = (
          parseFloat(data.prima_neta) +
          parseFloat(data.rpf) +
          parseFloat(data.derecho)
        ).toFixed(2);
        rec.recibo.prima_total = (
          parseFloat(rec.recibo.sub_total) + parseFloat(data.iva)
        ).toFixed(2);
      };

      $scope.saveReceipt = function (receipt) {
        var texto_log = "";
        if (process(receipt.fecha_fin) < process(receipt.fecha_inicio)) {
          SweetAlert.swal(
            "Error",
            "La fecha fin del recibo no puede ser menor a la de su inicio.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        var obj = {
          fecha_inicio: new Date(datesFactory.toDate(receipt.fecha_inicio)),
          fecha_fin: new Date(datesFactory.toDate(receipt.fecha_fin)),
          prima_neta: receipt.prima_neta,
          rpf: receipt.rpf,
          derecho: receipt.derecho,
          iva: receipt.iva,
          prima_total: receipt.prima_total,
          comision: receipt.comision,
          vencimiento: new Date(toDate(receipt.vencimiento)),
          delivered: receipt.delivered,
        };
        if (
          (receipt.status == 1 || receipt.status == "Pagado") &&
          acceso_pl_cob == false
        ) {
          var texto_log = " EDICION DE RECIBO PAGADO";
        }
        if (
          (receipt.status == 5 || receipt.status == "Liquidado") &&
          acceso_pl_cob == false
        ) {
          var texto_log = " EDICION DE RECIBO LIQUIDADO";
        }
        $http.patch(receipt.url, obj).then(function (response) {
          var params = {
            model: 10,
            event: "PATCH",
            associated_id: endoso.id,
            identifier:
              "actualizó el recibo " +
              receipt.recibo_numero +
              " " +
              texto_log +
              ".",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          var params = {
            model: 4,
            event: "POST",
            associated_id: receipt.id,
            identifier: "actualizó el recibo, " + texto_log + ".",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          SweetAlert.swal(
            "¡Listo!",
            "El recibo ha sido actualizado.",
            "success"
          );
          $scope.cancel(true);
        });
      };

      $scope.cancel = function (v) {
        if (!v) {
          rec.recibo.fecha_inicio = fecha_inicio;
          rec.recibo.fecha_fin = fecha_fin;
          rec.recibo.vencimiento = fecha_venc;
        }
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.changeStatusModal = function (receipt, contra, insurance) {
      receipt.contratante = contra.contractor
        ? contra.contractor
        : contra.contractor;
      var modalInstance = $uibModal.open({
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return insurance;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function () {
        activate();
      });
    };

    $scope.deleteReceipts = function (receipt, index) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text:
            "No será posible recuperar este recibo: " + receipt.recibo_numero,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: receipt.id,
              id_poliza: $scope.endorsement.policy.id,
              model: 8,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {});
            $http
              .patch(receipt.url, { status: 0 })
              .then(function (recibo_delete) {
                var paramsDelRec = {
                  model: 1,
                  event: "DELETE",
                  associated_id: $scope.endorsement.policy.id,
                  identifier:
                    " elimino un recibo (" +
                    receipt.recibo_numero +
                    ") de la póliza",
                };
                dataFactory
                  .post("send-log/", paramsDelRec)
                  .then(function success(response) {});
                if (recibo_delete.data.status == 0) {
                  $scope.endorsement.endorsement_receipt.splice(index, 1);
                }
                SweetAlert.swal("¡Hecho!", "Recibo eliminado.", "success");
              });
          }
        }
      );
    };

    // Upload files
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //      return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal(
          "¡Listo!",
          "Archivos cargados exitosamente.",
          "success"
        );
        $state.reload();
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
      fileItem.removeAfterUpload = true;
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + $scope.endorsement.id + "/archivos/";

      $scope.files = [];

      $scope.uploader.uploadAll();
    }

    $scope.saveFiles = function (param) {
      uploadFiles(param.id);
    };

    $scope.checkNumEndoso = function () {
      if (vmm.number_endorsement) {
        dataFactory
          .get("exist-number-endorsement/", { number: vmm.number_endorsement })
          .then(function (request) {
            if (request.data.status == true) {
              SweetAlert.swal("Error", "Número de Endoso existente", "error");
              vmm.number_endorsement = "";
            }
          })
          .catch(function (err) {});
      }
    };

    $scope.deleteFile = function (file, container) {
      SweetAlert.swal(
        {
          title: "Eliminar Archivo",
          text: "No será posible recuperar este archivo, ¿Está seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: file.id,
              id_poliza: $scope.endorsement.policy.id,
              model: 6,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {});
            $http({
              method: "GET",
              url: url.IP + "delete-manual",
              params: {
                file_id: file.id,
                typeFile: 2,
              },
            }).then(function success(response) {
              if (response.data.status == 204) {
                SweetAlert.swal(
                  "¡Listo!",
                  "El archivo fue eliminado.",
                  "success"
                );
                container.splice(container.indexOf(file), 1);
              }
            });
          }
        }
      );
    };

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    $scope.changeStatus = function () {
      $scope.no_certificate = false;
      if ($scope.endorsement.policy.document_type == 3) {
        if ($scope.endorsement.change) {
          try {
            $scope.endorsement.change.forEach(function (item, index) {
              if (
                !(item.certificate_number || item.certificate) &&
                $scope.endorsement.concept != 25
              ) {
                $scope.no_certificate = true;
                SweetAlert.swal(
                  "Error",
                  "Todos los certificados deben tener numero de certificado.",
                  "error"
                );
                return;
              }
            });
          } catch (e) {}
        }
      }
      if (!$scope.no_certificate) {
        var modalInstance = $uibModal.open({
          templateUrl: "app/endosoFull/endoso.full.status.html",
          controller: EndososStatusController,
          controllerAs: "vmm",
          size: "lg",
          resolve: {
            endorsement: function () {
              return $scope.endorsement;
            },
            policy: function () {
              return $scope.endorsement.policy;
            },
            certificates: function () {
              return $scope.certificates;
            },
            certificates_bd: function () {
              return $scope.certificatesBd;
            },
            comments: function () {
              return $scope.comments_data;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        modalInstance.result.then(function () {
          $state.go("endorsement.info", { endosoId: vm.insurance.id });
        });
      }
    };

    function EndososStatusController(
      $scope,
      endorsement,
      FileUploader,
      $sessionStorage,
      url,
      policy,
      helpers,
      datesFactory,
      $state,
      $uibModalInstance,
      SweetAlert,
      MESSAGES,
      certificates,
      certificates_bd,
      comments
    ) {
      var vmm = this;

      vmm.endorsement = endorsement;
      vmm.policy = policy;

      $scope.directiveReceipts = [];
      $scope.dataToSave = [];

      if (vmm.endorsement.concept == 1) {
        $scope.directiveReceipts.payment = vmm.endorsement.change.forma_de_pago;
        $scope.directiveReceipts.endorsement_type = "A";
      } else {
        $scope.directiveReceipts.payment = vmm.endorsement.policy.forma_de_pago;
        $scope.directiveReceipts.endorsement_type =
          vmm.endorsement.endorsement_type;
      }

      $scope.directiveReceipts.subramo =
        vmm.endorsement.policy.subramo.subramo_name;
      $scope.directiveReceipts.concept = vmm.endorsement.concept;
      if (vmm.endorsement.policy.document_type == 3) {
        $scope.directiveReceipts.administration_type =
          vmm.endorsement.policy.administration_type;
      } else {
        $scope.directiveReceipts.administration_type = "Otro";
      }
      $scope.directiveReceipts.startDate = datesFactory.convertDate(
        vmm.endorsement.init_date
      );
      $scope.directiveReceipts.endingDate = datesFactory.convertDate(
        vmm.endorsement.end_date
      );
      $scope.directiveReceipts.comision_percent =
        vmm.endorsement.policy.comision_percent;
      var date1 = new Date(vmm.endorsement.init_date);
      var date2 = new Date(vmm.endorsement.end_date);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );
      $scope.directiveReceipts.domiciliado = false;
      if (vmm.endorsement.status == 1) {
        vmm.status = [
          { value: 2, label: "REGISTRADO" },
          { value: 3, label: "RECHAZADO" },
          { value: 4, label: "CANCELADO" },
          { value: 5, label: "EN TRÁMITE" },
        ];
      } else if (vmm.endorsement.status == 5) {
        vmm.status = [
          { value: 2, label: "REGISTRADO" },
          { value: 3, label: "RECHAZADO" },
          { value: 4, label: "CANCELADO" },
          { value: 1, label: "PENDIENTE" },
        ];
      } else if (vmm.endorsement.status == 2) {
        vmm.status = [];
      } else {
        vmm.status = [
          { value: 1, label: "PENDIENTE" },
          { value: 2, label: "REGISTRADO" },
          { value: 3, label: "RECHAZADO" },
          { value: 4, label: "CANCELADO" },
          { value: 5, label: "EN TRÁMITE" },
        ];
      }

      vmm.accesos = $sessionStorage.permisos;
      vmm.accesos.forEach(function (acceso) {
        if (acceso.model_name == "Endosos") {
          vmm.acceso_endosos = acceso;
          vmm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == "true") {
                vmm.acceso_reg_end = true;
              } else {
                vmm.acceso_reg_end = false;
              }
            }
          });
        }
      });

      if (vmm.endorsement.policy) {
        if (vmm.endorsement.policy.caratula && vmm.endorsement.concept == 35) {
          dataFactory
            .get("leer-polizas-info/" + vmm.endorsement.policy.caratula)
            .then(function success(response) {
              if (response.data) {
                if (response.data.aseguradora) {
                  get_claves(response.data.aseguradora.id);
                }
              }
            })
            .catch(function (error) {
              console.log("Error - claves-by-provider - catch", error);
            });
        }
      }
      if (vmm.endorsement.policy.aseguradora) {
        get_claves(vmm.endorsement.policy.aseguradora.id);
      } else {
        $http
          .get(vmm.endorsement.policy.clave.aseguradora)
          .then(function success(response) {
            if (response.data) {
              get_claves(response.data.id);
            }
          })
          .catch(function (error) {
            console.log("Error - claves-by-provider - catch", error);
          });
      }

      vmm.addReceipts = addReceipts;
      function esAutoadministrada(val) {
        return (
          val === "Autoadministrada" || val === 2 || val === "2" || val === true
        );
      }
      function addReceipts(valor) {
        $scope.directiveReceipts.generarRecibosExcepcional = valor;
        $scope.generarRecibosExcepcional = valor;
        if (vmm.endorsement) {
          if (vmm.endorsement.concept != 1) {
            vmm.totalReceipts = [{ id: 0, name: 0 }];
            var isAuto = esAutoadministrada(
              vmm.policy && vmm.policy.administration_type
            );
            var exc = !!$scope.generarRecibosExcepcional;
            var is36 = vmm.endorsement.concept === 36;

            if (isAuto && !exc) {
              vmm.totalReceipts = is36
                ? [{ id: 1, name: 1 }]
                : [{ id: 0, name: 0 }];
            } else {
              if (is36) {
                vmm.totalReceipts = [{ id: 1, name: 1 }];
              } else {
                if (valor) {
                  vmm.totalReceipts = [];
                  for (var i = 1; i <= 12; i++) {
                    vmm.totalReceipts.push({ id: i, name: i });
                  }
                }
              }
            }
          }
        } else {
          console.log("iiiiiiiii", vmm.endorsement.concept);
        }
      }
      function get_claves(value) {
        $scope.directiveReceipts.comisiones = [];
        $http
          .get(url.IP + "claves-by-provider/" + value)
          .then(
            function success(clavesResponse) {
              clavesResponse.data.forEach(function (clave) {
                clave.clave_comision.forEach(function (item) {
                  item.efective_date = new Date(item.efective_date)
                    .toISOString()
                    .split("T")[0];
                  if (vmm.endorsement.policy.aseguradora) {
                    if ($scope.directiveReceipts.subramo == item.subramo) {
                      $scope.directiveReceipts.comisiones.push(item);
                    }
                  } else {
                    if ($scope.directiveReceipts.subramo == item.subramo) {
                      $scope.directiveReceipts.comisiones.push(item);
                    }
                  }
                });
              });
            },
            function error(e) {
              console.log("Error - claves-by-provider", e);
            }
          )
          .catch(function (error) {
            console.log("Error - claves-by-provider - catch", error);
          });
      }
      $scope.checkLength = function (value) {
        if (value && value.length > 500) {
          SweetAlert.swal(
            "Error",
            "El Número de Endoso no puede tener más de 500 caracteres.\n Se ha limitado a 500 caracteres.",
            "error"
          );
          $scope.vmm.endorsement.number_endorsement = value.substring(0, 500); // Trim extra characters
        }
      };

      $scope.checkNumberEndorsement = function () {
        if (vmm.endorsement.number_endorsement) {
          dataFactory
            .get("exist-number-endorsement/", {
              number: vmm.endorsement.number_endorsement,
              poliza: vmm.policy.poliza_number,
            })
            .then(function (request) {
              if (request.data.status == true) {
                vmm.endorsement.number_endorsement = "";
                SweetAlert.swal(
                  "Error",
                  "El número de endoso ya existe.",
                  "error"
                );
                return;
              } else {
                $scope.registerEndorsement();
              }
            })
            .catch(function (err) {
              console.log("error", err);
            });
        } else {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
            "error"
          );
          return;
        }
      };

      $scope.status = function (parConcept) {
        switch (parConcept) {
          case 1:
            return "Pendiente";
            break;
          case 2:
            return "Registrado";
            break;
          case 3:
            return "Rechazado";
            break;
          case 4:
            return "Cancelado";
            break;
          case 5:
            return "En trámite";
            break;
          default:
            return "Pendiente";
        }
      };

      $scope.changePayment = function () {
        $scope.number_receipts = 0;
        vmm.totalReceipts = [];
        if (vmm.endorsement.concept == 1) {
          switch (parseFloat($scope.directiveReceipts.payment)) {
            case 1:
              $scope.numberReceipts = 12;
              break;
            case 2:
              $scope.numberReceipts = 6;
              break;
            case 3:
              $scope.numberReceipts = 4;
              break;
            case 5:
              $scope.numberReceipts = 1; //contado
              break;
            case 6:
              $scope.numberReceipts = 2;
              break;
            case 12:
              $scope.numberReceipts = 1; //anual
              break;
            default:
              break;
          }

          var recibos_fracionados =
            ($scope.directiveReceipts.policy_days_duration *
              $scope.numberReceipts) /
            365;
          var arreglo_recibos = recibos_fracionados.toString().split(".");
          var recibos_completos = parseFloat(arreglo_recibos[0]);
          var recibos_incompletos = "0." + arreglo_recibos[1];
          recibos_incompletos = parseFloat(recibos_incompletos);
          if (recibos_incompletos < 1 && recibos_incompletos > 0) {
            $scope.number_receipts = recibos_completos + 1;
          } else {
            $scope.number_receipts = recibos_completos;
          }

          for (var i = 1; i <= $scope.number_receipts; i++) {
            vmm.totalReceipts.push({ id: i, name: i });
          }
        } else {
          for (var i = 1; i <= 12; i++) {
            vmm.totalReceipts.push({ id: i, name: i });
          }
        }
        if (vmm.endorsement) {
          if (vmm.endorsement.concept != 1) {
            if (vmm.endorsement.policy.document_type == 3) {
              if (
                vmm.endorsement.policy.administration_type ==
                  "Autoadministrada" ||
                vmm.endorsement.policy.administration_type == 2
              ) {
                if (vmm.endorsement.concept == 36) {
                  vmm.totalReceipts = [{ id: 1, name: 1 }];
                } else {
                  if (
                    $scope.generarRecibosExcepcional &&
                    $scope.generarRecibosExcepcional == true
                  ) {
                    vmm.total_receipts = [];
                    for (var i = 1; i <= 12; i++) {
                      vmm.totalReceipts.push({ id: i, name: i });
                    }
                  } else {
                    vmm.totalReceipts = [{ id: 0, name: 0 }];
                  }
                }
                addReceipts($scope.generarRecibosExcepcional);
              }
            }
          }
        }
      };

      $scope.changeNumberReceipts = function (param) {
        $scope.directiveReceipts.num_receipts = param.id;
        if (vmm.endorsement.policy.document_type == 3) {
          $scope.directiveReceipts.administration_type =
            vmm.endorsement.policy.administration_type;
        } else {
          $scope.directiveReceipts.administration_type = "Otro";
        }
        $scope.directiveReceipts.concept = vmm.endorsement.concept;
      };

      $scope.registerEndorsement = function () {
        if (!vmm.endorsement.number_endorsement) {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
            "error"
          );
          return;
        }
        if (vmm.endorsement.policy.document_type == 3) {
          if (vmm.endorsement.policy.administration_type != 2) {
            if (
              !vmm.total_receipts &&
              vmm.endorsement.endorsement_type != "B" &&
              vmm.endorsement.concept != 1 &&
              vmm.endorsement.concept != 6
            ) {
              SweetAlert.swal(
                "Error",
                "Selecciona un número de recibos.",
                "error"
              );
              return;
            }
            if (vmm.total_receipts && vmm.total_receipts.id) {
              if (
                (vmm.endorsement.endorsement_type == "A" ||
                  vmm.endorsement.endorsement_type == "D") &&
                vmm.total_receipts.id > 0
              ) {
                if (!$scope.dataToSave.recibos_poliza) {
                  SweetAlert.swal(
                    "Error",
                    MESSAGES.ERROR.RECEIPTSREQUIRED,
                    "error"
                  );
                  return;
                }
              }
            } else {
              if (
                vmm.endorsement.endorsement_type == "A" ||
                vmm.endorsement.endorsement_type == "D"
              ) {
                if (!$scope.dataToSave.recibos_poliza) {
                  SweetAlert.swal(
                    "Error",
                    MESSAGES.ERROR.RECEIPTSREQUIRED,
                    "error"
                  );
                  return;
                }
              }
            }
          } else {
            if (
              !vmm.total_receipts &&
              vmm.endorsement.endorsement_type != "B" &&
              vmm.endorsement.concept != 1 &&
              vmm.endorsement.concept != 6
            ) {
              SweetAlert.swal(
                "Error",
                "Selecciona un número de recibos.",
                "error"
              );
              return;
            }
            if (!$scope.dataToSave.p_neta) {
              if (vmm.endorsement.policy.document_type == 3) {
                if (
                  vmm.endorsement.policy.administration_type != 2 &&
                  vmm.endorsement.endorsement_type != "B"
                ) {
                  SweetAlert.swal("Error", "Ingresa las primas.", "error");
                  return;
                }
              }
            }
          }
        } else {
          if (
            !vmm.total_receipts &&
            vmm.endorsement.endorsement_type != "B" &&
            vmm.endorsement.concept != 1 &&
            vmm.endorsement.concept != 6
          ) {
            SweetAlert.swal(
              "Error",
              "Selecciona un número de recibos.",
              "error"
            );
            return;
          }
          if (
            (vmm.endorsement.endorsement_type == "A" ||
              vmm.endorsement.endorsement_type == "D") &&
            vmm.endorsement.concept != 1 &&
            vmm.endorsement.concept != 6
          ) {
            if (
              vmm.totalReceipts &&
              vmm.total_receipts.id > 0 &&
              !$scope.dataToSave.recibos_poliza
            ) {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.RECEIPTSREQUIRED,
                "error"
              );
              return;
            }
          }
          if (
            (vmm.endorsement.endorsement_type == "A" ||
              vmm.endorsement.endorsement_type == "D") &&
            vmm.endorsement.concept == 1 &&
            vmm.endorsement.concept == 6
          ) {
            if (!$scope.dataToSave.recibos_poliza) {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.RECEIPTSREQUIRED,
                "error"
              );
              return;
            }
          }
        }

        if ($scope.dataToSave.recibos_poliza) {
          $scope.dataToSave.recibos_poliza.forEach(function (item) {
            item.fecha_inicio = datesFactory.toDate(item.fecha_inicio);
            item.fecha_fin = datesFactory.toDate(item.fecha_fin);
            item.vencimiento = datesFactory.toDate(item.vencimiento);
            item.poliza = vmm.endorsement.policy.id;
            if (vmm.endorsement.concept == 1) {
              item.receipt_type = 1;
            }
          });
        }

        if ($scope.dataToSave.recibos_poliza) {
          if (vmm.endorsement.endorsement_type == "A") {
            $scope.dataToPatch = {
              p_neta: $scope.dataToSave.poliza.primaNeta,
              descuento: $scope.dataToSave.poliza.descuento,
              rpf: $scope.dataToSave.poliza.rpf,
              derecho: $scope.dataToSave.poliza.derecho,
              sub_total: $scope.dataToSave.poliza.SubTotal,
              iva: $scope.dataToSave.poliza.iva,
              p_total: $scope.dataToSave.poliza.primaTotal,
              comision: $scope.dataToSave.comision,
              comision_percent: $scope.dataToSave.comision_percent,
              status: 2,
              number_endorsement: vmm.endorsement.number_endorsement,
              endorsement_receipt: $scope.dataToSave.recibos_poliza,
              concept: vmm.endorsement.concept,
            };
          } else if (vmm.endorsement.endorsement_type == "D") {
            $scope.dataToPatch = {
              p_neta: $scope.dataToSave.poliza.primaNeta * -1,
              descuento: $scope.dataToSave.poliza.descuento,
              rpf: $scope.dataToSave.poliza.rpf * -1,
              derecho: $scope.dataToSave.poliza.derecho * -1,
              sub_total: $scope.dataToSave.poliza.SubTotal * -1,
              iva: $scope.dataToSave.poliza.iva * -1,
              p_total: $scope.dataToSave.poliza.primaTotal * -1,
              comision: $scope.dataToSave.comision * -1,
              comision_percent: $scope.dataToSave.comision_percent,
              status: 2,
              number_endorsement: vmm.endorsement.number_endorsement,
              endorsement_receipt: $scope.dataToSave.recibos_poliza,
              concept: vmm.endorsement.concept,
            };
          }
        } else if ($scope.dataToSave.poliza) {
          if (vmm.endorsement.endorsement_type == "A") {
            $scope.dataToPatch = {
              p_neta: $scope.dataToSave.poliza.primaNeta,
              descuento: $scope.dataToSave.poliza.descuento,
              rpf: $scope.dataToSave.poliza.rpf,
              derecho: $scope.dataToSave.poliza.derecho,
              sub_total: $scope.dataToSave.poliza.SubTotal,
              iva: $scope.dataToSave.poliza.iva,
              p_total: $scope.dataToSave.poliza.primaTotal,
              comision: $scope.dataToSave.comision,
              comision_percent: $scope.dataToSave.comision_percent,
              status: 2,
              number_endorsement: vmm.endorsement.number_endorsement,
              endorsement_receipt: $scope.dataToSave.recibos_poliza,
              concept: vmm.endorsement.concept,
            };
          } else if (vmm.endorsement.endorsement_type == "D") {
            $scope.dataToPatch = {
              p_neta: $scope.dataToSave.poliza.primaNeta * -1,
              descuento: $scope.dataToSave.poliza.descuento,
              rpf: $scope.dataToSave.poliza.rpf * -1,
              derecho: $scope.dataToSave.poliza.derecho * -1,
              sub_total: $scope.dataToSave.poliza.SubTotal * -1,
              iva: $scope.dataToSave.poliza.iva * -1,
              p_total: $scope.dataToSave.poliza.primaTotal * -1,
              comision: $scope.dataToSave.comision * -1,
              comision_percent: $scope.dataToSave.comision_percent,
              status: 2,
              number_endorsement: vmm.endorsement.number_endorsement,
              endorsement_receipt: $scope.dataToSave.recibos_poliza,
              concept: vmm.endorsement.concept,
            };
          }
        } else {
          $scope.dataToPatch = {
            p_neta: 0,
            rpf: 0,
            derecho: 0,
            iva: 0,
            p_total: 0,
            comision: 0,
            descuento: 0,
            comision_percent: 0,
            status: 2,
            number_endorsement: vmm.endorsement.number_endorsement,
            endorsement_receipt: [],
            concept: vmm.endorsement.concept,
          };
        }
        if (vmm.endorsement) {
          if (vmm.endorsement.concept != 1) {
            if (vmm.endorsement.policy.document_type == 3) {
              if (
                vmm.endorsement.policy.administration_type ==
                  "Autoadministrada" ||
                vmm.endorsement.policy.administration_type == 2
              ) {
                if (vmm.endorsement.concept == 36) {
                } else {
                  if (
                    $scope.generarRecibosExcepcional &&
                    $scope.generarRecibosExcepcional == true
                  ) {
                    $scope.dataToPatch.endorsement_receipt =
                      $scope.dataToSave.recibos_poliza;
                  } else {
                    $scope.dataToPatch.endorsement_receipt = [];
                  }
                }
              }
            }
          }
        }
        $scope.dataToPatch.insurancefolio = vmm.endorsement.insurancefolio
          ? vmm.endorsement.insurancefolio
          : "";

        $http
          .patch(vmm.endorsement.url, $scope.dataToPatch)
          .then(function success(response) {
            vmm.patchEndoso = response.data;
            if (
              helpers.isResponseOk(response.status) &&
              !vmm.patchEndoso.migrated
            ) {
              var paramsE = {
                model: 10,
                event: "POST",
                associated_id: vmm.patchEndoso.id,
                identifier: "registró el endoso.",
              };
              dataFactory.post("send-log", paramsE);

              comments.forEach(function (comment) {
                if (comment.comment_tasks && comment.comment_tasks.length > 0) {
                  comment.comment_tasks.forEach(function (task) {
                    var data = {
                      model: 22,
                      id_model: task.id,
                      content: "Se ha Concluido el Endoso",
                      parent: null,
                      create_task: false,
                      user_assigned: 0,
                      modelo_tareas: 1,
                    };

                    $http.post(url.IP + "comments/", data);
                    var data1 = {
                      id: task.id,
                    };
                    $http
                      .post(url.IP + "complete-task/", data1)
                      .then(function (response) {
                        var params = {
                          model: 22,
                          event: "POST",
                          associated_id: task.id,
                          identifier: "cerró la tarea.",
                        };
                        dataFactory
                          .post("send-log/", params)
                          .then(function success(response) {});
                      });
                  });
                }
              });

              if ($scope.countFile > 0) {
                uploadFiles(vmm.patchEndoso.id);
              } else {
                $uibModalInstance.dismiss("cancel");
                activate();
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.REGISTERENDOSO,
                  "success"
                );
              }
            } else {
              SweetAlert.swal(
                "ERROR",
                "Ocurrio un error\n" + response.data[0],
                "error"
              );
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };

      $scope.rejectEndorsement = function () {
        if (vmm.selectedType.value == 3) {
          $scope.lg = "rechazo";
        } else if (vmm.selectedType.value == 4) {
          $scope.lg = "cancelo";
        } else {
          $scope.lg = vmm.selectedType.label;
        }
        $scope.dataToPatch = {
          status: vmm.selectedType.value,
        };

        $http
          .patch(vmm.endorsement.url, $scope.dataToPatch)
          .then(function success(response) {
            vmm.patchEndoso = response.data;
            if (
              helpers.isResponseOk(response.status) &&
              !vmm.patchEndoso.migrated
            ) {
              var paramsE = {
                model: 10,
                event: "POST",
                associated_id: vmm.patchEndoso.id,
                identifier: $scope.lg + " el endoso.",
              };
              dataFactory.post("send-log", paramsE);
              var paramsP = {
                model: 1,
                event: "PATCH",
                associated_id: vmm.endorsement.policy.id,
                identifier:
                  $scope.lg + " el endoso: " + vmm.endorsement.internal_number,
              };

              dataFactory.post("send-log", paramsP);
              $uibModalInstance.dismiss("cancel");
              $state.reload();
              SweetAlert.swal("¡Listo!", "Se actualizo el Endoso", "success");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }
    // ----------------compartir endoso
    function shareEndorsementOk(endoso) {
      var id = endoso.id;
      var modalInstance = $uibModal.open({
        templateUrl: "app/endosoFull/endoso.share.html",
        controller: compartirEndosoContoller,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          endoso_id: function () {
            return id;
          },
          endoso: function () {
            return endoso;
          },
          contratante: function () {
            return $scope.contractor;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    function compartirEndosoContoller(
      $scope,
      $uibModalInstance,
      endoso,
      endoso_id,
      url,
      contratante,
      dataFactory
    ) {
      $scope.email =
        contratante.contractor && contratante.contractor.email
          ? contratante.contractor.email
          : "";
      if (contratante.contractor && contratante.contractor.email_contractor) {
        $scope.emailsContractor = contratante.contractor.email_contractor.map(
          function (item) {
            return item.correo;
          }
        );
      } else {
        $scope.emailsContractor = [];
      }

      var vmm = this;
      var share_via_email = [];
      var share_via_email_r = [];
      vmm.is_owner = false;
      vmm.email_assign_mail = "";
      vmm.custom_email = true;
      vmm.htmlVariable = "";
      vmm.first_comment = "";
      vmm.second_comment = "";
      vmm.correos = [];
      $scope.send = true;
      $http
        .get(url.IP + "share-endoso-manual/" + endoso_id)
        .then(function (response) {
          if (response.status === 200) {
            vmm.head = response.data.head;
            vmm.body = response.data.body;
            vmm.footer = response.data.footer;
            vmm.subjectEmail = response.data.subject_default;
            vmm.first_comment = response.data.first_comment;
          }
        })
        .catch(function (e) {
          console.log("error - catch", e);
        });
      $scope.showEmailInInput = function (email) {
        $scope.email_assign = email;
      };
      $scope.emails = [];
      $scope.addEmail = function (email) {
        if (validateEmail(email) == false) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        } else {
          if ($scope.emails.indexOf(email) < 0) {
            $scope.emails.push(email);
          } else {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.REPEATEMAIL, "error");
          }
          vmm.email_assign_mail = "";
        }
      };
      $scope.remove_email = function (index) {
        $scope.emails.splice(index, 1);
      };
      if (contratante.contractor.full_name) {
        var name_contractor = contratante.contractor.full_name;
        vmm.correos = $scope.emailsContractor ? $scope.emailsContractor : [];
        vmm.correos.push($scope.email);
        // $http.post(url.IP + 'contractors-contact/',
        // {
        //     'name': name_contractor
        // }).then(function(response) {
        //     if(response.status === 200 ) {
        //       vmm.correos = response.data.contact
        //     }
        // });
      }
      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      $scope.sendEmail = function (receipt) {
        $scope.send = false;
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        var data_shared = {
          id: endoso.id,
          emails: $scope.emails,
          files: share_via_email,
          files_r: share_via_email_r,
          subject: vmm.subjectEmail,
          first_comment: vmm.first_comment,
          second_comment: vmm.second_comment,
          model: 1,
          custom_email: vmm.custom_email,
        };
        $http
          .post(url.IP + "share-endoso-manual/", data_shared)
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.ENDOSOSEND, "success");
                $scope.send = true;
                var params = {
                  model: 10,
                  event: "POST",
                  associated_id: endoso.id,
                  identifier: "compartió el endoso por correo electrónico.",
                  save_logmail: 1,
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                $uibModalInstance.dismiss("cancel");
              } else {
                $scope.send = true;
                l.stop();
                SweetAlert.swal("ERROR", request.data.status, "error");
              }
            },
            function error(error) {
              console.log("error - email", error);
            }
          )
          .catch(function (e) {
            console.log("error - catch", e);
          });
      };

      $scope.emptySubject = function (v) {
        if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
          vmm.subjectEmail = vmm.subjectDefault;
        }
      };
      if (order.permiso_administrar_adjuntos) {
        $scope.recibos_file = [];
        $http
          .get(url.IP + "endosos/" + endoso_id + "/archivos/")
          .then(function (response) {
            $scope.files = response.data.results;
            $scope.files.forEach(function (file) {
              file["to_send"] = false;
              file["origin"] = "P";
            });
            $http
              .post(url.IP + "get-recibos-files/", {
                poliza_id: endoso.policy.id,
              })
              .then(function (response) {
                $scope.recibos_file = response.data;
                // $scope.recibos_file.forEach(function(file_r) {
                //   file_r['origin'] = 'R';
                //   $scope.files.push(file_r);
                // })
                $scope.files.forEach(function (file) {
                  file["to_send"] = false;
                });
              });
          });
      }

      $scope.shareFileEmail = function (file) {
        if (file.to_send) {
          file.to_send = false;
        } else {
          file.to_send = true;
        }
        share_via_email = [];
        share_via_email_r = [];
        $scope.files.forEach(function (filex) {
          if (filex.to_send && filex.origin == "P") {
            share_via_email.push(filex.id);
          }
          if (filex.to_send && filex.origin == "R") {
            share_via_email_r.push(filex.id);
          }
        });
      };

      $scope.shareFile = function (file) {
        $http
          .get(url.IP + "patch-policy-file/" + file.id)
          .then(function (response) {
            if (file.shared) {
              $scope.fileshared = true;
            } else {
              $scope.fileshared = false;
            }
            $scope.files.some(function (filex) {
              if (filex.id == response.data.id) {
                filex.shared = response.data.shared;
              }
            });
            $scope.files[file] = response.data;
            // $scope.shared = response.data.shared;
          });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }
    // ----------------------
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndosoFullEditCtrl", EndosoFullEditCtrl);

  EndosoFullEditCtrl.$inject = [
    "dataFactory",
    "$scope",
    "MESSAGES",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$http",
    "$state",
    "$stateParams",
    "url",
    "$localStorage",
    "$sessionStorage",
    "$timeout",
  ];

  function EndosoFullEditCtrl(
    dataFactory,
    $scope,
    MESSAGES,
    SweetAlert,
    FileUploader,
    datesFactory,
    $http,
    $state,
    $stateParams,
    url,
    $localStorage,
    $sessionStorage,
    $timeout
  ) {
    var order = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    $scope.types = [
      { id: 0, name: "Selecciona un tipo de endoso" },
      { id: 1, name: "A" },
      { id: 2, name: "B" },
      { id: 3, name: "D" },
    ];

    $scope.sexs = [
      { value: "F", label: "Femenino" },
      { value: "M", label: "Masculino" },
    ];
    $scope.typesInsureds = [
      { value: 1, label: "Fija" },
      { value: 2, label: "Regla" },
    ];
    $scope.smokers = [
      { value: false, label: "No" },
      { value: true, label: "Si" },
    ];
    $scope.relationships = [
      { value: 1, label: "Titular" },
      { value: 2, label: "Cónyuge" },
      { value: 3, label: "Hijo" },
      { value: 4, label: "Otro" },
    ];
    $scope.types_auto = [
      { id: 1, name: "Automóvil" },
      { id: 2, name: "Motocicleta" },
      { id: 3, name: "Tracto" },
      { id: 4, name: "Autobús" },
      { id: 5, name: "Pick Up" },
      { id: 6, name: "Camiones hasta 1.5 ton" },
      { id: 7, name: "Chofer app" },
      { id: 8, name: "Remolque" },
      { id: 9, name: "Camiones + 1.5 ton" },
    ];
    $scope.usages = [
      { value: 1, label: "Particular" },
      { value: 2, label: "Carga Comercial" },
      { value: 3, label: "Servicio Público" },
    ];
    $scope.procedencias = [
      { value: 0, label: "Sin especificar" },
      { value: 1, label: "Residencia" },
      { value: 2, label: "Turista" },
      { value: 3, label: "Legalizado" },
      { value: 4, label: "Fronterizo" },
    ];
    $scope.typesCharges = [
      { value: 0, label: "Sin especificar" },
      { value: 1, label: "A" },
      { value: 2, label: "B" },
      { value: 3, label: "C" },
    ];
    $scope.typesConstruction = [
      { value: 1, label: "Macizo" },
      { value: 2, label: "Madera" },
      { value: 3, label: "Lámina" },
    ];

    $scope.directiveReceipts = [];
    $scope.caratula = {};
    $scope.newCertificate = {};
    $scope.categoriesJson = [];

    activate();

    function activate() {
      dataFactory
        .get("endorsement-info/" + $stateParams.endosoId + "/")
        .then(function success(response) {
          $scope.endorsement = response.data;
          $scope.originalEndorsement = angular.copy($scope.endorsement);
          $scope.policy = response.data.policy;

          $scope.startDate = datesFactory.convertDate(
            $scope.endorsement.init_date
          );
          $scope.endDate = datesFactory.convertDate(
            $scope.endorsement.end_date
          );

          $scope.types.forEach(function (item) {
            if ($scope.endorsement.endorsement_type == item.name) {
              $scope.typeSelected = item;
            }
          });

          if ($localStorage.save_edition_endoso) {
            if (
              $localStorage.save_edition_endoso["id"] == $scope.endorsement.id
            ) {
              $scope.endorsement.observations =
                $localStorage.save_edition_endoso &&
                $localStorage.save_edition_endoso["observations"]
                  ? $localStorage.save_edition_endoso["observations"]
                  : "";
            }
          }
          $scope.endorsement.change = $scope.endorsement.change
            .split("'")
            .join('"');
          $scope.endorsement.change = $scope.endorsement.change
            .split("None")
            .join('""');
          if ($scope.endorsement.change != "") {
            if (typeof $scope.endorsement.change == "string") {
              try {
                $scope.endorsement.change = JSON.parse(
                  $scope.endorsement.change
                );
              } catch (err) {}
            }
          }
          $scope.endorsement.original = $scope.endorsement.original
            .split("'")
            .join('"');
          $scope.endorsement.original = $scope.endorsement.original
            .split("None")
            .join('""');
          if ($scope.endorsement.original != "") {
            if (typeof $scope.endorsement.original == "string") {
              try {
                $scope.endorsement.original = JSON.parse(
                  $scope.endorsement.original
                );
              } catch (err) {}
            }
          }

          if ($scope.endorsement.change) {
            $scope.change_endorsement = $scope.endorsement.change;
          }

          if ($scope.endorsement.original) {
            if ($scope.endorsement.original.concept) {
              $scope.descriptionSelected = $scope.endorsement.original.concept;
            }
          } else {
            $scope.descriptionSelected = $scope.endorsement.concept;
          }
          if (
            ($scope.descriptionSelected =
              null || $scope.descriptionSelected == undefined)
          ) {
            $scope.descriptionSelected = $scope.endorsement.concept;
          }
          $scope.showFields($scope.descriptionSelected);

          if ($scope.endorsement.concept == 1) {
            switch ($scope.endorsement.change.forma_de_pago) {
              case 12:
                $scope.paySelected = { id: 12, name: "Anual" };
                break;
              case 6:
                $scope.paySelected = { id: 6, name: "Semestral" };
                break;
              case 5:
                $scope.paySelected = { id: 5, name: "Contado" };
                break;
              case 3:
                $scope.paySelected = { id: 3, name: "Trimestral" };
                break;
              case 1:
                $scope.paySelected = { id: 1, name: "Mensual" };
                break;
              default:
                break;
            }
          }
        });
    }

    $scope.save_info_tab = function () {
      $localStorage.save_edition_endoso = angular.copy($scope.endorsement);
      $localStorage.save_edition_endoso["observations"] =
        $scope.endorsement.observations;
    };

    $scope.payment = function (parValue) {
      switch (parValue) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        default:
          return parValue;
      }
    };

    $scope.statusPolicy = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.status = function (param) {
      switch (param) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Registrado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado";
          break;
        case 5:
          return "En trámite";
          break;
        default:
          return "Pendiente";
      }
    };
    // $scope.concept = function(cnc){
    //   if (cnc) {
    //     switch(cnc){
    //       case 41: return 'ALTA DE UNIDAD';
    //         break;
    //       case 42: return 'AGREGAR COBERTURA';
    //         break;
    //       case 43: return 'CAMBIO DE FORMA DE PAGO';
    //         break;
    //       case 44: return 'AGREGAR CARGA';
    //         break;
    //       case 45: return 'AGREGAR ADAPTACIONES Y CONVERSIONES';
    //         break;
    //       case 46: return 'INCLUIR BP';
    //         break;
    //       case 47: return 'CORREGIR DESCRIPCIÓN';
    //         break;
    //       case 48: return 'AGREGAR TEXTOS ACLARATORIOS';
    //         break;
    //       case 49: return 'ADAPTACIONES SOLO PARA EFECTOS DE RC';
    //         break;
    //       case 50: return 'AGREGAR PLACAS, MOTOR O CORREGIR SERIE';
    //         break;
    //       case 51: return 'CANCELACIONES';
    //         break;
    //       case 52: return 'ELIMINACIÓN DE COBERTURAS';
    //         break;
    //       case 31: return 'Agregar asegurado o dependiente';
    //         break;
    //       case 24: return 'ALTA DE ASEGURADOS';
    //         break;
    //       case 25: return 'BAJA DE ASEGURADOS';
    //         break;
    //       case 26: return 'AJUSTE ANUAL A';
    //         break;
    //       case 28: return 'AJUSTE ANUAL D';
    //         break;
    //       case 34:
    //         return 'CAMBIOS EN EL BENEFICIARIO';
    //         break;
    //       case 53:
    //         return 'DETALLE DE GARANTÍA';
    //         break;
    //       case 54:
    //         return 'PRORROGA DE VIGENCIA';
    //         break;
    //       case 55:
    //         return 'ANUENCIA';
    //         break;
    //       case 24:
    //         return 'ALTA DE CERTIFICADOS';
    //         break;
    //       case 25:
    //         return 'BAJA DE CERTIFICADOS';
    //         break;
    //       case 56:
    //         return 'CORRECCIÓN DE CERTIFICADOS';
    //         break;
    //       case 34:
    //         return 'CAMBIOS EN EL BENEFICIARIO';
    //         break;
    //       case 53:
    //         return 'DETALLE DE GARANTÍA';
    //         break;
    //       case 54:
    //         return 'PRORROGA DE VIGENCIA';
    //         break;
    //       case 55:
    //         return 'ANUENCIA';
    //         break;
    //       case 24:
    //         return 'ALTA DE CERTIFICADOS';
    //         break;
    //       case 25:
    //         return 'BAJA DE CERTIFICADOS';
    //         break;
    //       case 56:
    //         return 'CORRECCIÓN DE CERTIFICADOS';
    //         break;
    //       case 4:
    //         return 'OTRO';
    //         break;
    //       default:
    //         return 'OTRO';
    //     }
    //   }
    // }
    $scope.concept = function (parConcept) {
      if ($scope.policy) {
        if (
          $scope.policy.document_type != 7 &&
          $scope.policy.document_type != 8
        ) {
          switch (parConcept) {
            case 1:
              return "CAMBIO DE FORMA DE PAGO";
              break;
            case 2:
              return "CAMBIO DE SUMA ASEGURADA";
              break;
            case 3:
              return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
              break;
            case 4:
              return "AGREGAR ASEGURADO";
              break;
            case 5:
              return "AGREGAR COBERTURAS";
              break;
            case 6:
              return "DECLARACIÓN MENSUAL";
              break;
            case 8:
              return "CAMBIO DATOS FISCALES";
              break;
            case 9:
              return "ESPECIFICACIONES";
              break;
            case 11:
              return "CAMBIO DE FORMA DE PAGO";
              break;
            case 12:
              return "DISMINUCIÓN EN LA SUMA ASEGURADA";
              break;
            case 13:
              return "BAJA DE COBERTURA";
              break;
            case 14:
              return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
              break;
            case 15:
              return "BAJA DE ASEGURADO";
              break;
            case 16:
              return "CANCELACIÓN DE PÓLIZA POR PETICIÓN";
              break;
            case 17:
              return "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO";
              break;
            case 23:
              return "ANTIGÜEDAD RECONOCIDA";
              break;
            case 24:
              return "ALTA DE ASEGURADOS";
              break;
            case 25:
              return "BAJA DE ASEGURADOS";
              break;
            case 26:
              return "AJUSTE ANUAL (A)";
              break;
            case 27:
              return "RECONOCIMIENTO DE ANTIGUEDAD";
              break;
            case 28:
              return "AJUSTE ANUAL (D)";
              break;
            case 29:
              return "OTRO";
              break;
            case 30:
              return "Declaración";
              break;
            case 31:
              return "Agregar asegurado o dependiente";
              break;
            case 32:
              return "Cancelación";
              break;
            case 33:
              return "CORRECCION DE DATOS";
              break;
            case 34:
              return "CORRECCION DE DATOS BENEFICIARIO";
              break;
            default:
              return "OTRO";
          }
        } else if (
          $scope.policy.document_type == 7 ||
          $scope.policy.document_type == 8
        ) {
          switch (parConcept) {
            case 1:
              return "AUMENTO MONTO AFIANZADO";
              break;
            case 2:
              return "DECREMENTO MONTO AFIANZADO";
              break;
            case 3:
              return "CAMBIO DE PORCENTAJE DE GARANTÍA";
              break;
            case 5:
              return "CAMBIO DE DATOS";
              break;
            case 4:
              return "OTRO";
              break;
            case 34:
              return "CAMBIOS EN EL BENEFICIARIO";
              break;
            case 53:
              return "DETALLE DE GARANTÍA";
              break;
            case 54:
              return "PRORROGA DE VIGENCIA";
              break;
            case 55:
              return "ANUENCIA";
              break;
            case 24:
              return "ALTA DE CERTIFICADOS";
              break;
            case 25:
              return "BAJA DE CERTIFICADOS";
              break;
            case 56:
              return "CORRECCIÓN DE CERTIFICADOS";
              break;
            case 57:
              return "Aumento y Prórroga";
              break;
            case 58:
              return "Aumento";
              break;
            default:
              return "OTRO";
          }
        }
      }
    };
    $scope.showFields = function (concept) {
      $scope.change_endorsement = {};
      if (concept) {
        if (concept.value == 1 || concept.value == 6) {
          //cambio forma pago
          $scope.oldPay = $scope.payment($scope.policy.forma_de_pago);
          $scope.directiveReceipts.endorsement_type = "A";
          if ($scope.typeSelected.id == 1) {
            switch ($scope.policy.forma_de_pago) {
              case 5:
                $scope.payments = [
                  { id: 12, name: "Anual" },
                  { id: 6, name: "Semestral" },
                  { id: 3, name: "Trimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 12:
                $scope.payments = [
                  { id: 6, name: "Semestral" },
                  { id: 3, name: "Trimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 6:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 3:
                $scope.payments = [{ id: 1, name: "Mensual" }];
                break;
              case 2:
                $scope.payments = [{ id: 1, name: "Mensual" }];
                break;
              case 1:
                $scope.payments = [];
                SweetAlert.swal(
                  "Error",
                  "No puedes cambiar la forma de pago Mensual a una forma de pago menor.",
                  "error"
                );
                break;
              default:
                break;
            }
          } else if ($scope.typeSelected.id == 3) {
            switch ($scope.policy.forma_de_pago) {
              case 1:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 2:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 3:
                $scope.payments = [
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 6:
                $scope.payments = [
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 12:
                $scope.payments = [{ id: 5, name: "Contado" }];
                break;
              case 5:
                $scope.payments = [];
                SweetAlert.swal(
                  "Error",
                  "No puedes cambiar la forma de pago Mensual a una forma de pago menor.",
                  "error"
                );
                break;
              default:
                break;
            }
          }
        } else if (concept.value == 2 || concept.value == 7) {
          //cambio paquetes
          $http
            .post(url.IP + "paquetes-data-by-subramo/", {
              ramo: $scope.policy.ramo.id,
              subramo: $scope.policy.subramo.id,
              provider: $scope.policy.aseguradora.id,
            })
            .then(
              function success(response) {
                if (response.data.length) {
                  $scope.packages = response.data;
                  $scope.packages.forEach(function (item) {
                    if (
                      item.package_name == $scope.policy.paquete.package_name
                    ) {
                      $scope.packageSelected = item;
                    }
                  });
                }
              },
              function error(e) {
                console.log("Error - paquetes-data-by-subramo", e);
                $scope.packages = [];
              }
            )
            .catch(function (error) {
              console.log("Error - paquetes-data-by-subramo - catch", error);
              $scope.packages = [];
            });

          order.defaults = {
            coverages: [],
            coverageList: [],
          };

          $scope.policy.paquete.coverage_package.forEach(function (element) {
            $scope.flag_coverage = false;
            $scope.endorsement.change.coverages.forEach(function (item, index) {
              if (item.coverage_name == element.coverage_name) {
                element = item;
                element.sums_coverage = [{ sum_insured: item.sum_insured }];
                element.deductible_coverage = [{ deductible: item.deductible }];
                if (item.coinsurance || item.topecoinsurance) {
                  element.coinsurance_coverage = [
                    { coinsurance: item.coinsurance },
                  ];
                  element.topecoinsurance_coverage = [
                    { topecoinsurance: item.topecoinsurance },
                  ];
                }
                $scope.flag_coverage = true;
              }
              if (index + 1 == $scope.endorsement.change.coverages.length) {
                if ($scope.flag_coverage) {
                  order.defaults.coverages.push(angular.copy(element));
                } else {
                  order.defaults.coverageList.push(angular.copy(element));
                }
              }
            });
          });
        } else if (concept.value == 4) {
          //contratante
          order.contratante = {};

          // if ($scope.endorsement.change.type == 1) {
          //   $scope.type_url = 'fisicas-app/';
          // } else {
          //   $scope.type_url = 'morales-app/';
          // }
          $scope.type_url = "contractors-app/";

          dataFactory
            .get($scope.type_url + $scope.endorsement.change.id)
            .then(function success(response) {
              order.contratante.val =
                $scope.endorsement.change.type == 1
                  ? response.data.full_name
                  : response.data.full_name;
              order.contratante.value = response.data;

              if ($scope.endorsement.change.type == 1) {
                $scope.address_contractor = response.data.address_contractor;
              } else {
                $scope.address_contractor = response.data.address_contractor;
              }

              $scope.address_contractor.forEach(function (item) {
                if (item.id == $scope.endorsement.change.address) {
                  $scope.addressSelected = item;
                }
              });
            });
        } else if (concept.value == 37) {
          //otro
        } else if (concept.value == 3) {
          //prorroga
        } else if (concept.value == 8) {
          //cancelación
          $scope.change_endorsement.status = 11;
        } else if (
          concept.value == 9 ||
          concept.value == 11 ||
          concept.value == 13 ||
          concept.value == 17 ||
          concept.value == 21 ||
          concept.value == 25
        ) {
          //asegurado
          if ($scope.policy.life_policy.length > 0) {
            $scope.change_endorsement.antiguedad = datesFactory.convertDate(
              $scope.endorsement.change.antiguedad
            );
            $scope.change_endorsement.birthdate = datesFactory.convertDate(
              $scope.endorsement.change.birthdate
            );
            $scope.change_endorsement.first_name =
              $scope.endorsement.change.first_name;
            $scope.change_endorsement.last_name =
              $scope.endorsement.change.last_name;
            $scope.change_endorsement.second_last_name =
              $scope.endorsement.change.second_last_name;
            $scope.sexs.forEach(function (item) {
              if (item.value == $scope.endorsement.change.sex) {
                $scope.change_endorsement.sex = item;
              }
            });
            $scope.smokers.forEach(function (item) {
              if (item.value == $scope.endorsement.change.smoker.value) {
                $scope.change_endorsement.smoker = item;
              }
            });
          } else {
            $scope.change_endorsement.antiguedad = datesFactory.convertDate(
              $scope.endorsement.change.antiguedad
            );
            $scope.change_endorsement.birthdate = datesFactory.convertDate(
              $scope.endorsement.change.birthdate
            );
            $scope.change_endorsement.first_name =
              $scope.endorsement.change.first_name;
            $scope.change_endorsement.last_name =
              $scope.endorsement.change.last_name;
            $scope.change_endorsement.second_last_name =
              $scope.endorsement.change.second_last_name;
            $scope.sexs.forEach(function (item) {
              if (item.value == $scope.endorsement.change.sex) {
                $scope.change_endorsement.sex = item;
              }
            });
          }
        } else if (
          concept.value == 10 ||
          concept.value == 12 ||
          concept.value == 14 ||
          concept.value == 18 ||
          concept.value == 22 ||
          concept.value == 26
        ) {
          if ($scope.policy.life_policy[0]) {
            $scope.change_endorsement = $scope.endorsement.change;
            if ($scope.change_endorsement.length == 0) {
              $scope.change_endorsement = [
                {
                  first_name: "",
                  last_name: "",
                  second_last_name: "",
                  birthdate: datesFactory.convertDate(new Date()),
                  optional_relationship: "",
                  sex: $scope.sexs[3],
                  antiguedad: datesFactory.convertDate(new Date()),
                  percentage: "",
                  type_person: 1,
                },
              ];
            } else {
              $scope.change_endorsement.forEach(function (item) {
                item.antiguedad = datesFactory.convertDate(item.antiguedad);
                item.birthdate = datesFactory.convertDate(item.birthdate);
                $scope.sexs.forEach(function (sexo) {
                  if (item.sex == sexo.value) {
                    item.sex = sexo;
                  }
                });
                item.type_person = item.j_name ? 2 : 1;
              });
            }
          } else {
            $scope.change_endorsement = $scope.endorsement.change;
            if ($scope.change_endorsement.length == 0) {
              $scope.change_endorsement = [
                {
                  first_name: "",
                  last_name: "",
                  second_last_name: "",
                  antiguedad: datesFactory.convertDate(new Date()),
                  birthdate: datesFactory.convertDate(new Date()),
                  relationship: $scope.relationships[3],
                  sex: $scope.sexs[0],
                },
              ];
            } else {
              $scope.change_endorsement.forEach(function (item) {
                item.antiguedad = datesFactory.convertDate(item.antiguedad);
                item.birthdate = datesFactory.convertDate(item.birthdate);
                $scope.sexs.forEach(function (sexo) {
                  if (item.sex == sexo.value) {
                    item.sex = sexo;
                  }
                });
                $scope.relationships.forEach(function (relationship) {
                  if (item.relationship == relationship.value) {
                    item.relationship = relationship;
                  }
                });
              });
            }
          }
        } else if (
          concept.value == 15 ||
          concept.value == 19 ||
          concept.value == 23
        ) {
          //hospitalario
          $scope.change_endorsement = $scope.endorsement.change;
        } else if (
          concept.value == 16 ||
          concept.value == 20 ||
          concept.value == 24
        ) {
          //tabulador
          $scope.change_endorsement = $scope.endorsement.change;
        } else if (concept.value == 27 || concept.value == 32) {
          //riesgo asegurado
          $scope.change_endorsement = $scope.endorsement.change;
          $scope.types_auto.forEach(function (item) {
            if (item.id == $scope.endorsement.change.policy_type) {
              $scope.change_endorsement.policy_type = item;
            }
          });
          $scope.usages.forEach(function (item) {
            if (item.value == $scope.endorsement.change.usage) {
              $scope.change_endorsement.usage = item;
            }
          });
          $scope.change_endorsement.service = $scope.endorsement.change.service;
          $scope.procedencias.forEach(function (item) {
            if (item.value == $scope.endorsement.change.procedencia) {
              $scope.change_endorsement.procedencia = item;
            }
          });
        } else if (concept.value == 28 || concept.value == 33) {
          //conductor
          $scope.change_endorsement = $scope.endorsement.change;
        } else if (concept.value == 29 || concept.value == 34) {
          //equipo
          $scope.change_endorsement = $scope.endorsement.change;
        } else if (concept.value == 30 || concept.value == 35) {
          //adaptaciones
          $scope.change_endorsement = $scope.endorsement.change;
        } else if (concept.value == 31) {
          //beneficiario
          $scope.change_endorsement = $scope.endorsement.change;
        } else if (concept.value == 36) {
          //danios
          $scope.change_endorsement = $scope.endorsement.change;
        } else if (concept.value == 38) {
          //alta
          $http
            .post(url.IP + "get_caratula_complete/", {
              caratula: $scope.policy.id,
            })
            .then(function success(response) {
              if (response.status == 200) {
                $scope.caratula = response.data.data.caratula;
                $scope.subgrupos = response.data.data.childs;

                $scope.subgrupos.forEach(function (item) {
                  for (var i = 0; i < item.categorias.length; i++) {
                    var category = {
                      subgroup: item.name,
                      category: item.categorias[i].name,
                      category_id: item.categorias[i].id,
                    };
                    $scope.categoriesJson.push(category);
                    if (i == item.categorias.length - 1) {
                      $scope.categoriesJson.forEach(function (item) {
                        if (item.category_id == $scope.newCertificate.parent) {
                          $scope.newCertificate.parent = item;
                        }
                      });
                    }
                  }
                });

                $scope.paquetes = response.data.data.paquetes;

                $scope.paquetes.forEach(function (item) {
                  if (item.id == $scope.newCertificate.paquete) {
                    $scope.newCertificate.paquete = item;
                  }
                });
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
          $scope.newCertificate = $scope.endorsement.change[0];

          if ($scope.newCertificate.life_policy.length) {
            $scope.newCertificate.personal = angular.copy(
              $scope.newCertificate.life_policy[0]
            );
          } else if ($scope.newCertificate.accidents_policy.length) {
            $scope.newCertificate.personal = angular.copy(
              $scope.newCertificate.accidents_policy[0]
            );
          } else if ($scope.newCertificate.automobiles_policy.length) {
            $scope.newCertificate.auto = angular.copy(
              $scope.newCertificate.automobiles_policy[0]
            );
          } else if ($scope.newCertificate.damages_policy.length) {
            $scope.newCertificate.auto = angular.copy(
              $scope.newCertificate.damages_policy[0]
            );
          }

          $scope.editCertificate();
        }
      }
    };

    $scope.changePayment = function (param) {
      $scope.totalReceipts = [];
      if (param) {
        $scope.paySelected = param;
        $scope.change_endorsement.forma_de_pago = param.id;
        $scope.directiveReceipts.payment = param.id;
        $scope.number_receipts = 0;
        if (
          $scope.descriptionSelected.value == 1 ||
          $scope.descriptionSelected.value == 6
        ) {
          switch (parseFloat(param.id)) {
            case 1:
              $scope.numberReceipts = 12;
              break;
            case 2:
              $scope.numberReceipts = 6;
              break;
            case 3:
              $scope.numberReceipts = 4;
              break;
            case 5:
              $scope.numberReceipts = 1; //contado
              break;
            case 6:
              $scope.numberReceipts = 2;
              break;
            case 12:
              $scope.numberReceipts = 1; //anual
              break;
            default:
              break;
          }
        }

        var recibos_fracionados =
          ($scope.directiveReceipts.policy_days_duration *
            $scope.numberReceipts) /
          365;
        var arreglo_recibos = recibos_fracionados.toString().split(".");
        var recibos_completos = parseFloat(arreglo_recibos[0]);
        var recibos_incompletos = "0." + arreglo_recibos[1];
        recibos_incompletos = parseFloat(recibos_incompletos);

        if (recibos_incompletos < 1 && recibos_incompletos > 0) {
          $scope.number_receipts = recibos_completos + 1;
        } else {
          $scope.number_receipts = recibos_completos;
        }

        for (var i = 1; i <= $scope.number_receipts; i++) {
          $scope.totalReceipts.push({ id: i, name: i });
        }
      } else {
        $scope.directiveReceipts.payment = $scope.policy.forma_de_pago;
        for (var i = 1; i <= 12; i++) {
          $scope.totalReceipts.push({ id: i, name: i });
        }
      }
    };

    order.options = {
      deleteCoverage: function (obj, index) {
        order.defaults.coverages.splice(index, 1);
        order.defaults.coverageList.push(obj);
      },
      addCoverage: function (obj) {
        if (obj) {
          order.defaults.coverages.push(obj);

          order.defaults.coverageList.forEach(function (coverage) {
            if (coverage.coverage_name == obj.coverage_name) {
              order.defaults.coverageList.splice(
                order.defaults.coverageList.indexOf(coverage),
                1
              );
            }
          });
        }
      },
    };

    $scope.changePackage = function (param) {
      if (param) {
        order.defaults = {
          package_name: param.package_name,
          formInfo: { code: $scope.policy.subramo.subramo_code },
          coverages: [],
          coverageList: [],
        };
        $scope.packageSelected = param;
        param.coverage_package.forEach(function (element) {
          if (element.default) {
            order.defaults.coverages.push(angular.copy(element));
          } else {
            order.defaults.coverageList.push(angular.copy(element));
          }
        });
      } else {
        $scope.coveragesPackages = [];
      }
    };

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if (order.contratante.value.address_contractor) {
          if (order.contratante.value.address_contractor) {
            $scope.addresses = order.contratante.value.address_contractor;
            $scope.change_endorsement = {
              id: order.contratante.value.id,
              type: order.contratante.type_person,
              address: 0,
            };
          }
          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.change_endorsement.address = $scope.addresses[0].id;
          }
        }
      }
    });

    $scope.changeAddress = function (param) {
      if (param) {
        $scope.change_endorsement.address = param.id;
      }
    };

    $scope.addBeneficiarie = function () {
      if ($scope.policy.subramo.subramo_name == "Vida") {
        var beneficiarie = {
          antiguedad: datesFactory.convertDate(new Date()),
          birthdate: datesFactory.convertDate(new Date()),
          first_name: "",
          last_name: "",
          second_last_name: "",
          sex: $scope.sexs[0],
          optional_relationship: "",
          percentage: "",
          type_person: 1,
        };
        $scope.change_endorsement.push(beneficiarie);
      } else {
        var beneficiarie = {
          first_name: "",
          last_name: "",
          second_last_name: "",
          birthdate: datesFactory.convertDate(new Date()),
          sex: $scope.sexs[0],
          relationship: $scope.relationships[3],
          antiguedad: datesFactory.convertDate(new Date()),
        };
        $scope.change_endorsement.push(beneficiarie);
      }
    };

    $scope.deleteBeneficiarie = function (index) {
      if ($scope.change_endorsement) {
        $scope.change_endorsement.splice(index, 1);
      } else {
        $scope.change_endorsement.splice(index, 1);
      }
    };

    $scope.typePerson = function (param, index) {
      $scope.change_endorsement[index].type_person = param;
      $scope.change_endorsement[index].antiguedad = datesFactory.convertDate(
        new Date()
      );
      $scope.change_endorsement[index].birthdate = datesFactory.convertDate(
        new Date()
      );
      $scope.change_endorsement[index].first_name = "";
      $scope.change_endorsement[index].last_name = "";
      $scope.change_endorsement[index].second_last_name = "";
      $scope.change_endorsement[index].sex =
        $scope.change_endorsement[index].type_person == 1 ? $scope.sexs[0] : "";
      $scope.change_endorsement[index].optional_relationship = "";
      $scope.change_endorsement[index].percentage = 0;
    };

    $scope.validateBirthdate = function (param) {
      if (process(param) > process(datesFactory.convertDate(new Date()))) {
        SweetAlert.swal(
          "Error",
          "La fecha de nacimiento no puede ser mayor a la fecha de hoy.",
          "error"
        );
        return;
      }

      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }
    };

    $scope.editCertificate = function () {
      if ($scope.newCertificate.start_of_validity.indexOf("-") != -1) {
        $scope.newCertificate.start_of_validity = datesFactory.convertDate(
          $scope.newCertificate.start_of_validity
        );
      }
      if ($scope.newCertificate.end_of_validity.indexOf("-") != -1) {
        $scope.newCertificate.end_of_validity = datesFactory.convertDate(
          $scope.newCertificate.end_of_validity
        );
      }
      if ($scope.newCertificate.life_policy.length) {
        if ($scope.newCertificate.rec_antiguedad) {
          if ($scope.newCertificate.rec_antiguedad.indexOf("-") != -1) {
            $scope.newCertificate.rec_antiguedad = datesFactory.convertDate(
              $scope.newCertificate.rec_antiguedad
            );
          }
        } else {
          $scope.newCertificate.rec_antiguedad = datesFactory.convertDate(
            new Date()
          );
        }
        if ($scope.newCertificate.personal.birthdate) {
          if ($scope.newCertificate.personal.birthdate.indexOf("-") != -1) {
            $scope.newCertificate.personal.birthdate = datesFactory.convertDate(
              $scope.newCertificate.personal.birthdate
            );
          }
        }
        $scope.sexs.forEach(function (item) {
          if (item.value == $scope.newCertificate.personal.sex) {
            $scope.newCertificate.personal.sex = item;
          }
        });
        $scope.typesInsureds.forEach(function (item) {
          if (item.value == $scope.newCertificate.personal.type_sa) {
            $scope.newCertificate.personal.type_sa = item;
          }
        });
        $scope.smokers.forEach(function (item) {
          if (item.value == $scope.newCertificate.life_policy[0].smoker) {
            $scope.newCertificate.smoker = item;
          }
        });
        $scope.newCertificate.sum_assured = parseFloat(
          $scope.newCertificate.sum_assured
        );
        $scope.newCertificate.salary = parseFloat($scope.newCertificate.salary);
        $scope.newCertificate.beneficiaries_life.forEach(function (
          beneficiarie
        ) {
          if (beneficiarie.birthdate) {
            if (beneficiarie.birthdate.indexOf("-") != -1) {
              beneficiarie.birthdate = datesFactory.convertDate(
                beneficiarie.birthdate
              );
            }
          }
          $scope.sexs.forEach(function (item) {
            if (item.value == beneficiarie.sex) {
              beneficiarie.sex = item;
            }
          });
          $scope.relationships.forEach(function (item) {
            if (item.value == beneficiarie.optional_relationship) {
              beneficiarie.optional_relationship = item;
            }
          });
        });
      } else if ($scope.newCertificate.accidents_policy.length) {
        if ($scope.newCertificate.rec_antiguedad) {
          if ($scope.newCertificate.rec_antiguedad.indexOf("-") != -1) {
            $scope.newCertificate.rec_antiguedad = datesFactory.convertDate(
              $scope.newCertificate.rec_antiguedad
            );
          }
        } else {
          $scope.newCertificate.rec_antiguedad = datesFactory.convertDate(
            new Date()
          );
        }
        if ($scope.newCertificate.personal.birthdate) {
          if ($scope.newCertificate.personal.birthdate.indexOf("-") != -1) {
            $scope.newCertificate.personal.birthdate = datesFactory.convertDate(
              $scope.newCertificate.personal.birthdate
            );
          }
        }
        $scope.sexs.forEach(function (item) {
          if (item.value == $scope.newCertificate.personal.sex) {
            $scope.newCertificate.personal.sex = item;
          }
        });
        $scope.newCertificate.relationship_accident.forEach(function (
          beneficiarie
        ) {
          if (beneficiarie.birthdate) {
            if (beneficiarie.birthdate.indexOf("-") != -1) {
              beneficiarie.birthdate = datesFactory.convertDate(
                beneficiarie.birthdate
              );
            }
          }
          $scope.sexs.forEach(function (item) {
            if (item.value == beneficiarie.sex) {
              beneficiarie.sex = item;
            }
          });
          $scope.relationships.forEach(function (item) {
            if (item.value == beneficiarie.relationship) {
              beneficiarie.relationship = item;
            }
          });
        });
      } else if ($scope.newCertificate.automobiles_policy.length) {
        $scope.usages.forEach(function (item) {
          if (item.value == $scope.newCertificate.auto.usage) {
            $scope.newCertificate.auto.usage = item;
          }
        });
        $scope.typesCharges.forEach(function (item) {
          if (item.value == $scope.newCertificate.auto.charge_type) {
            $scope.newCertificate.auto.charge_type = item;
          }
        });
        $scope.procedencias.forEach(function (item) {
          if (item.value == $scope.newCertificate.auto.procedencia) {
            $scope.newCertificate.auto.procedencia = item;
          }
        });
        $scope.newCertificate.auto.mont_adjustment = parseFloat(
          $scope.newCertificate.auto.mont_adjustment
        );
        $scope.newCertificate.auto.mont_special_team = parseFloat(
          $scope.newCertificate.auto.mont_special_team
        );
      } else if ($scope.newCertificate.damages_policy.length) {
        $scope.typesConstruction.forEach(function (item) {
          if (
            item.value ==
            $scope.newCertificate.damages_policy[0].type_construction
          ) {
            $scope.newCertificate.auto.type_construction = item;
          }
        });
        $scope.usages.forEach(function (item) {
          if (item.value == $scope.newCertificate.auto.usage) {
            $scope.newCertificate.auto.usage = item;
          }
        });
        $scope.newCertificate.auto.no_levels = parseFloat(
          $scope.newCertificate.auto.no_levels
        );
        $scope.newCertificate.auto.purchase_value = parseFloat(
          $scope.newCertificate.auto.purchase_value
        );
      }

      $scope.newCertificate.p_neta = parseFloat($scope.newCertificate.p_neta);
      $scope.newCertificate.rpf = parseFloat($scope.newCertificate.rpf);
      $scope.newCertificate.derecho = parseFloat($scope.newCertificate.derecho);
      $scope.newCertificate.iva = parseFloat($scope.newCertificate.iva);
      $scope.newCertificate.p_total = parseFloat($scope.newCertificate.p_total);
      $scope.newCertificate.comision = parseFloat(
        $scope.newCertificate.comision
      );
    };

    $scope.addBeneficiarie = function () {
      if ($scope.newCertificate.relationship_accident) {
        var beneficiarie = {
          first_name: "",
          last_name: "",
          second_last_name: "",
          birthdate: "",
          sex: $scope.sexs[0],
          familia: "",
          certificate: "",
          relationship: $scope.relationships[3],
          antiguedad: "",
        };
        $scope.newCertificate.relationship_accident.push(beneficiarie);
      } else {
        var beneficiarie = {
          first_name: "",
          last_name: "",
          second_last_name: "",
          birthdate: "",
          sex: $scope.sexs[0],
          familia: "",
          certificate: "",
          optional_relationship: $scope.relationships[3],
          antiguedad: "",
        };
        $scope.newCertificate.beneficiaries_life.push(beneficiarie);
      }
    };

    $scope.deleteBeneficiarie = function (index) {
      if ($scope.newCertificate.relationship_accident) {
        $scope.newCertificate.relationship_accident.splice(index, 1);
      } else {
        $scope.newCertificate.beneficiaries_life.splice(index, 1);
      }
    };

    $scope.validateEmail = function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.editEndorsement = function () {
      var changedFields,
        logSpecific = $scope.getChangedFields();
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      if (!$scope.endorsement.observations) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ENDOSOBS, "error");
        return;
      }
      if (!$scope.endorsement.number_endorsement) {
        SweetAlert.swal(
          "Error",
          MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
          "error"
        );
        return;
      }

      var endorsement_data = {
        init_date: datesFactory.toDate($scope.startDate),
        end_date: datesFactory.toDate($scope.endDate),
        observations: $scope.endorsement.observations,
        number_endorsement: $scope.endorsement.number_endorsement,
        endorsement_receipt: [],
      };

      $http
        .patch($scope.endorsement.url, endorsement_data)
        .then(function (response) {
          if (response.status === 201 || response.status === 200) {
            l.stop();
            SweetAlert.swal(
              "¡Listo!",
              MESSAGES.OK.UPDATEENDORSEMENT,
              "success"
            );
            $state.go("endorsement.info", { endosoId: response.data.id });
          } else {
            l.stop();
            $scope.showFields($scope.descriptionSelected);
            SweetAlert.swal("ERROR", "Ócurrio un error", "error");
          }
          var params = {
            model: 10,
            event: "POST",
            associated_id: response.data.id,
            identifier: logSpecific ? logSpecific : "actualizó el endoso.",
          };
          dataFactory.post("send-log/", params);
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };

    $scope.validityEndorsement = function () {
      if (!$scope.endorsement.observations) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ENDOSOBS, "error");
        return;
      }
      if ($scope.descriptionSelected.value == 1) {
        if (!$scope.change_endorsement.forma_de_pago) {
          SweetAlert.swal("Error", MESSAGES.ERROR.SELPAY, "error");
          return;
        }
      }
      if ($scope.descriptionSelected.value == 4) {
        if (!order.contratante.val) {
          SweetAlert.swal("Error", MESSAGES.ERROR.CONTRACTORERROR, "error");
          return;
        }
        if (!$scope.endorsement.change.address) {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ADDATLEASTONEDIRECCTION,
            "error"
          );
          return;
        }
      }
      if ($scope.descriptionSelected.id == 10) {
        if (!$scope.change_endorsement.first_name) {
          SweetAlert.swal("Error", "Agrega un nombre al titular.", "error");
          return;
        }
        if (!$scope.change_endorsement.last_name) {
          SweetAlert.swal(
            "Error",
            "Agrega un apellido paterno al titular.",
            "error"
          );
          return;
        }
        if (!$scope.change_endorsement.birthdate) {
          SweetAlert.swal(
            "Error",
            "Agrega una fecha de nacimiento al titular.",
            "error"
          );
          return;
        }
        if (!$scope.change_endorsement.sex) {
          SweetAlert.swal("Error", "Selecciona un sexo al titular.", "error");
          return;
        }
        if ($scope.policy.subramo.subramo_name == "Vida") {
          if (!$scope.change_endorsement.smoker) {
            SweetAlert.swal(
              "Error",
              "Selecciona si fuma o no el titular.",
              "error"
            );
            return;
          }
        }
      }
      if (
        $scope.descriptionSelected.id == 6 ||
        $scope.descriptionSelected.id == 11
      ) {
        if (
          $scope.typeSelected.name == "A" ||
          $scope.typeSelected.name == "B"
        ) {
          var flagNewBeneficiarie = false;
          $scope.change_endorsement.forEach(function (item, index) {
            if (item.type_person) {
              if (item.type_person == 1) {
                if (!item.first_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el nombre del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.last_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el apellido paterno del beneficiario #" +
                      (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.birthdate) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega la fecha de nacimiento del beneficiario #" +
                      (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.optional_relationship) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el parentesco del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.sex) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el sexo del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.antiguedad) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega la fecha de antigüedad del beneficiario #" +
                      (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.percentage) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el porcentaje del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
              } else {
                if (!item.j_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega la razón social del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.rfc) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el rfc del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.antiguedad) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega la fecha de antigüedad del beneficiario #" +
                      (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
              }
            } else {
              if (!item.first_name) {
                SweetAlert.swal(
                  "Error",
                  "Agrega el nombre del dependiente #" + (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
              if (!item.last_name) {
                SweetAlert.swal(
                  "Error",
                  "Agrega el apellido paterno del dependiente #" + (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
              if (!item.birthdate) {
                SweetAlert.swal(
                  "Error",
                  "Agrega la fecha de nacimiento del dependiente #" +
                    (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
              if (!item.relationship) {
                SweetAlert.swal(
                  "Error",
                  "Agrega el parentesco del dependiente #" + (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
              if (!item.sex) {
                SweetAlert.swal(
                  "Error",
                  "Agrega el sexo del dependiente #" + (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
              if (!item.antiguedad) {
                SweetAlert.swal(
                  "Error",
                  "Agrega la fecha de antigüedad del dependiente #" +
                    (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
            }
          });
          if (flagNewBeneficiarie) {
            return;
          }
        }
      }
      if (
        $scope.descriptionSelected.value == 27 ||
        $scope.descriptionSelected.value == 32
      ) {
        if ($scope.policy.subramo.subramo_name == "Automóviles") {
          if (!$scope.change_endorsement.brand) {
            SweetAlert.swal("Error", "Agrega una marca.", "error");
            return;
          }
          if (!$scope.change_endorsement.model) {
            SweetAlert.swal("Error", "Agrega un modelo.", "error");
            return;
          }
          if (!$scope.change_endorsement.year) {
            SweetAlert.swal("Error", "Agrega un año.", "error");
            return;
          }
          if (!$scope.change_endorsement.version) {
            SweetAlert.swal("Error", "Agrega una versión.", "error");
            return;
          }
          if (!$scope.change_endorsement.serial) {
            SweetAlert.swal("Error", "Agrega un número de serie.", "error");
            return;
          }
          if (!$scope.change_endorsement.usage) {
            SweetAlert.swal("Error", "Agrega un uso.", "error");
            return;
          }
          if (!$scope.change_endorsement.service) {
            SweetAlert.swal("Error", "Selecciona un serivicio.", "error");
            return;
          }
          if (!$scope.change_endorsement.procedencia) {
            SweetAlert.swal("Error", "Selecciona una procedencia.", "error");
            return;
          }
        }
      }
      if ($scope.descriptionSelected.value == 38) {
        var flagBeneficiarie = false;
        if (!$scope.newCertificate.start_of_validity) {
          SweetAlert.swal(
            "Error",
            "Agrega una fecha de vigencia inicio.",
            "error"
          );
          return;
        }
        if (!$scope.newCertificate.end_of_validity) {
          SweetAlert.swal(
            "Error",
            "Agrega una fecha de vigencia fin.",
            "error"
          );
          return;
        } else {
          if (
            process($scope.newCertificate.start_of_validity) <
              process(
                datesFactory.convertDate($scope.caratula.start_of_validity)
              ) ||
            process($scope.newCertificate.end_of_validity) >
              process(datesFactory.convertDate($scope.caratula.end_of_validity))
          ) {
            SweetAlert.swal(
              "Error",
              MESSAGES.WARNING.VALIDITYOUTRANGE,
              "error"
            );
            return;
          }
        }
        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        if (!$scope.newCertificate.parent) {
          SweetAlert.swal("Error", "Selecciona una categoría.", "error");
          return;
        }
        if (!$scope.newCertificate.paquete) {
          SweetAlert.swal("Error", "Selecciona un paquete.", "error");
          return;
        }
        if (!$scope.newCertificate.certificate_number) {
          SweetAlert.swal("Error", "Agrega un número de certificado.", "error");
          return;
        }
        if (
          $scope.endorsement.concept != 24 &&
          $scope.endorsement.concept != 25
        ) {
          if ($scope.caratula.subramo.subramo_code == 1) {
            if (!$scope.newCertificate.rec_antiguedad) {
              SweetAlert.swal(
                "Error",
                "Agrega una fecha de antigüedad.",
                "error"
              );
              return;
            }
            if (!$scope.newCertificate.personal.email) {
              SweetAlert.swal(
                "Error",
                "Agrega un correo electrónico.",
                "error"
              );
              return;
            } else {
              if (!$scope.validateEmail($scope.newCertificate.personal.email)) {
                SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
                return;
              }
            }
            if (!$scope.newCertificate.personal.first_name) {
              SweetAlert.swal("Error", "Agrega un nombre al titular.", "error");
              return;
            }
            if (!$scope.newCertificate.personal.last_name) {
              SweetAlert.swal(
                "Error",
                "Agrega un apellido paterno al titular.",
                "error"
              );
              return;
            }
            if (!$scope.newCertificate.personal.second_last_name) {
              SweetAlert.swal(
                "Error",
                "Agrega un apellido materno al titular.",
                "error"
              );
              return;
            }
            if (!$scope.newCertificate.personal.birthdate) {
              SweetAlert.swal(
                "Error",
                "Agrega una fecha de nacimiento al titular.",
                "error"
              );
              return;
            }
            if (!$scope.newCertificate.personal.sex) {
              SweetAlert.swal(
                "Error",
                "Selecciona un sexo al titular.",
                "error"
              );
              return;
            }
            if (!$scope.newCertificate.personal.type_sa) {
              SweetAlert.swal(
                "Error",
                "Selecciona un tipo de suma asegurada al titular.",
                "error"
              );
              return;
            }
            if (!$scope.newCertificate.personal.sum_assured) {
              SweetAlert.swal(
                "Error",
                "Agrega una suma asegurada al titular.",
                "error"
              );
              return;
            }
            if (!$scope.newCertificate.personal.salary) {
              SweetAlert.swal("Error", "Agrega un sueldo al titular.", "error");
              return;
            }
            if (!$scope.newCertificate.smoker) {
              SweetAlert.swal(
                "Error",
                "Selecciona si fuma el titular.",
                "error"
              );
              return;
            }
            // if($scope.newCertificate.datos.beneficiaries_life.length > 0){
            //   var flagBeneficiarie = false;
            //   $scope.newCertificate.datos.beneficiaries_life.forEach(function(beneficiarie, index){
            //     if(!beneficiarie.first_name){
            //       SweetAlert.swal('Error', 'Agrega un nombre al beneficiario ' + (index + 1) + '.', 'error');
            //       flagBeneficiarie = true;
            //     }
            //     if(!beneficiarie.last_name){
            //       SweetAlert.swal('Error', 'Agrega un apellido paterno al beneficiario ' + (index + 1) + '.', 'error');
            //       flagBeneficiarie = true;
            //     }
            //     if(!beneficiarie.second_last_name){
            //       SweetAlert.swal('Error', 'Agrega un apellido materno al beneficiario ' + (index + 1) + '.', 'error');
            //       flagBeneficiarie = true;
            //     }
            //     if(!beneficiarie.birthdate){
            //       SweetAlert.swal('Error', 'Agrega un nombre al beneficiario ' + (index + 1) + '.', 'error');
            //       flagBeneficiarie = true;
            //     }
            //     if(!beneficiarie.optional_relationship){
            //       SweetAlert.swal('Error', 'Selecciona un parentesco al beneficiario ' + (index + 1) + '.', 'error');
            //       flagBeneficiarie = true;
            //     }
            //     if(!beneficiarie.sex){
            //       SweetAlert.swal('Error', 'Selecciona un sexo al beneficiario ' + (index + 1) + '.', 'error');
            //       flagBeneficiarie = true;
            //     }
            //   });
            // }
          } else if ($scope.caratula.ramo.ramo_code == 2) {
            if (!$scope.newCertificate.personal.email) {
              SweetAlert.swal(
                "Error",
                "Agrega un correo electrónico.",
                "error"
              );
              return;
            } else {
              if (!$scope.validateEmail($scope.newCertificate.personal.email)) {
                SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
                return;
              }
            }
            if (!$scope.newCertificate.personal.first_name) {
              SweetAlert.swal("Error", "Agrega un nombre al titular.", "error");
              return;
            }
            if (!$scope.newCertificate.personal.last_name) {
              SweetAlert.swal(
                "Error",
                "Agrega un apellido paterno al titular.",
                "error"
              );
              return;
            }
            if (!$scope.newCertificate.personal.second_last_name) {
              SweetAlert.swal(
                "Error",
                "Agrega un apellido materno al titular.",
                "error"
              );
              return;
            }
            if (!$scope.newCertificate.personal.birthdate) {
              SweetAlert.swal(
                "Error",
                "Agrega una fecha de nacimiento al titular.",
                "error"
              );
              return;
            }
            if (!$scope.newCertificate.personal.sex) {
              SweetAlert.swal(
                "Error",
                "Selecciona un sexo al titular.",
                "error"
              );
              return;
            }
            if ($scope.newCertificate.relationship_accident.length > 0) {
              $scope.newCertificate.relationship_accident.forEach(function (
                beneficiarie,
                index
              ) {
                if (!beneficiarie.first_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega un nombre al dependiente " + (index + 1) + ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                }
                if (!beneficiarie.last_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega un apellido paterno al dependiente " +
                      (index + 1) +
                      ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                }
                if (!beneficiarie.second_last_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega un apellido materno al dependiente " +
                      (index + 1) +
                      ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                }
                if (!beneficiarie.birthdate) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega un nombre al dependiente " + (index + 1) + ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                }
                if (!beneficiarie.relationship) {
                  SweetAlert.swal(
                    "Error",
                    "Selecciona un parentesco al dependiente " +
                      (index + 1) +
                      ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                }
                if (!beneficiarie.sex) {
                  SweetAlert.swal(
                    "Error",
                    "Selecciona un sexo al dependiente " + (index + 1) + ".",
                    "error"
                  );
                  flagBeneficiarie = true;
                }
              });
            }
            if (flagBeneficiarie) {
              return;
            }
          } else if ($scope.caratula.subramo.subramo_code == 9) {
            if (!$scope.newCertificate.email) {
              SweetAlert.swal(
                "Error",
                "Agrega un correo electrónico.",
                "error"
              );
              return;
            } else {
              if (!$scope.validateEmail($scope.newCertificate.auto.email)) {
                SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
                return;
              }
            }
            if (!$scope.newCertificate.auto.brand) {
              SweetAlert.swal("Error", "Agrega una marca.", "error");
              return;
            }
            if (!$scope.newCertificate.auto.model) {
              SweetAlert.swal("Error", "Agrega un modelo.", "error");
              return;
            }
            if (!$scope.newCertificate.auto.year) {
              SweetAlert.swal("Error", "Agrega un año.", "error");
              return;
            }
            if (!$scope.newCertificate.auto.version) {
              SweetAlert.swal("Error", "Agrega una versión.", "error");
              return;
            }
            if (!$scope.newCertificate.auto.serial) {
              SweetAlert.swal("Error", "Agrega un número de serie.", "error");
              return;
            }
            if (!$scope.newCertificate.auto.usage) {
              SweetAlert.swal("Error", "Agrega un uso.", "error");
              return;
            }
            if (!$scope.newCertificate.auto.service) {
              SweetAlert.swal("Error", "Selecciona un serivicio.", "error");
              return;
            }
            if (!$scope.newCertificate.auto.procedencia) {
              SweetAlert.swal("Error", "Selecciona una procedencia.", "error");
              return;
            }
          } else if (
            $scope.caratula.subramo.subramo_code == 7 ||
            $scope.caratula.subramo.subramo_code == 13
          ) {
            if (!$scope.newCertificate.auto.email) {
              SweetAlert.swal(
                "Error",
                "Agrega un correo electrónico.",
                "error"
              );
              return;
            } else {
              if (!$scope.validateEmail($scope.newCertificate.auto.email)) {
                SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
                return;
              }
            }
            if ($scope.caratula.subramo.subramo_name == "Incendio") {
              if (!$scope.newCertificate.auto.sucursal) {
                SweetAlert.swal("Error", "Agrega una sucursal.", "error");
                return;
              }
              if (!$scope.newCertificate.auto.giro) {
                SweetAlert.swal("Error", "Agrega un giro.", "error");
                return;
              }
              if (!$scope.newCertificate.auto.type_construction) {
                SweetAlert.swal(
                  "Error",
                  "Selecciona un tipo de contrucción.",
                  "error"
                );
                return;
              }
              if (!$scope.newCertificate.auto.no_levels) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un número de niveles.",
                  "error"
                );
                return;
              }
              if (!$scope.newCertificate.auto.fhm_zone) {
                SweetAlert.swal("Error", "Agrega una zona FHM.", "error");
                return;
              }
              if (!$scope.newCertificate.auto.tyev_zone) {
                SweetAlert.swal("Error", "Agrega una zona TYEV.", "error");
                return;
              }
            } else if ($scope.caratula.subramo.subramo_name == "Diversos") {
              if (!$scope.newCertificate.auto.item_details) {
                SweetAlert.swal("Error", "Agrega una descripción.", "error");
                return;
              }
              if (!$scope.newCertificate.auto.usage) {
                SweetAlert.swal("Error", "Selecciona un uso.", "error");
                return;
              }
              if (!$scope.newCertificate.auto.brand) {
                SweetAlert.swal("Error", "Agrega una marca.", "error");
                return;
              }
              if (!$scope.newCertificate.auto.model) {
                SweetAlert.swal("Error", "Agrega un modelo.", "error");
                return;
              }
              if (!$scope.newCertificate.auto.construction_year) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un año de contrucción.",
                  "error"
                );
                return;
              }
              if (!$scope.newCertificate.auto.reconstruction_year) {
                SweetAlert.swal(
                  "Error",
                  "Agrega un año de recontrucción.",
                  "error"
                );
                return;
              }
              if (!$scope.newCertificate.auto.version) {
                SweetAlert.swal("Error", "Agrega una versión.", "error");
                return;
              }
              if (!$scope.newCertificate.auto.serial) {
                SweetAlert.swal("Error", "Agrega un número de serie.", "error");
                return;
              }
              if (!$scope.newCertificate.auto.permiso) {
                SweetAlert.swal("Error", "Agrega un permiso.", "error");
                return;
              }
            }
          }
        }
      }

      if (
        $scope.descriptionSelected.id == 2 ||
        $scope.descriptionSelected.id == 12
      ) {
        $scope.array_coverages = [];
        order.defaults.coverages.forEach(function (item) {
          if (!item.policy) {
            $scope.coverage_json = {
              coinsurance_coverage: item.coinsurance_coverage,
              coverage_name: item.coverage_name,
              deductible_coverage: item.deductible_coverage,
              deductibleInPolicy: item.deductibleInPolicy,
              default: item.default,
              priority: item.priority,
              sums_coverage: item.sums_coverage,
              sumInPolicy: item.sumInPolicy,
              topecoinsurance_coverage: item.topecoinsurance_coverage,
              typeCoverage: item.typeCoverage,
              url: item.url,
            };
            $scope.array_coverages.push($scope.coverage_json);
          } else {
            $scope.array_coverages.push(item);
          }
        });
        $scope.change_endorsement = {
          package: $scope.packageSelected.id,
          coverages: $scope.array_coverages,
        };
      } else if ($scope.descriptionSelected.id == 4) {
        $scope.change_endorsement = {
          end_date: datesFactory.toDate($scope.endDate),
        };
      } else if ($scope.descriptionSelected.id == 10) {
        if (
          $scope.descriptionSelected.value == 9 ||
          $scope.descriptionSelected.value == 11 ||
          $scope.descriptionSelected.value == 13 ||
          $scope.descriptionSelected.value == 17 ||
          $scope.descriptionSelected.value == 21 ||
          $scope.descriptionSelected.value == 25
        ) {
          $scope.change_endorsement.antiguedad = datesFactory.toDate(
            $scope.change_endorsement.antiguedad
          );
          $scope.change_endorsement.birthdate = datesFactory.toDate(
            $scope.change_endorsement.birthdate
          );
          $scope.change_endorsement.sex = $scope.change_endorsement.sex.value;
        }
      } else if ($scope.descriptionSelected.id == 6) {
        $scope.change_endorsement.forEach(function (item) {
          item.antiguedad = datesFactory.toDate(item.antiguedad);
          if (item.birthdate) {
            item.birthdate = datesFactory.toDate(item.birthdate);
          }
          if (item.sex) {
            item.sex = item.sex.value;
          }
          if (item.relationship) {
            item.relationship = item.relationship.value;
          }
        });
      } else if ($scope.descriptionSelected.id == 9) {
        if ($scope.change_endorsement.policy_type) {
          $scope.change_endorsement.policy_type =
            $scope.change_endorsement.policy_type.id;
        }
        if ($scope.change_endorsement.usage) {
          $scope.change_endorsement.usage =
            $scope.change_endorsement.usage.value;
        }
        if ($scope.change_endorsement.procedencia) {
          $scope.change_endorsement.procedencia =
            $scope.change_endorsement.procedencia.value;
        }
      } else if ($scope.descriptionSelected.value == 38) {
        $scope.valueCertificate();
      }
      $scope.updateEndorsement();
    };

    $scope.valueCertificate = function () {
      $scope.newCertificate.start_of_validity = datesFactory.toDate(
        $scope.newCertificate.start_of_validity
      );
      $scope.newCertificate.end_of_validity = datesFactory.toDate(
        $scope.newCertificate.end_of_validity
      );
      if (
        $scope.endorsement.concept != 24 &&
        $scope.endorsement.concept != 25
      ) {
        if ($scope.newCertificate.life_policy.length) {
          $scope.newCertificate.rec_antiguedad = datesFactory.toDate(
            $scope.newCertificate.rec_antiguedad
          );
          $scope.newCertificate.life_policy[0].personal.email =
            $scope.newCertificate.personal.email;
          $scope.newCertificate.life_policy[0].personal.first_name =
            $scope.newCertificate.personal.first_name;
          $scope.newCertificate.life_policy[0].personal.last_name =
            $scope.newCertificate.personal.last_name;
          $scope.newCertificate.life_policy[0].personal.second_last_name =
            $scope.newCertificate.personal.second_last_name;
          $scope.newCertificate.life_policy[0].personal.birthdate =
            datesFactory.toDate($scope.newCertificate.personal.birthdate);
          $scope.newCertificate.life_policy[0].personal.sex =
            $scope.newCertificate.personal.sex.value;
          $scope.newCertificate.life_policy[0].personal.type_sa =
            $scope.newCertificate.personal.type_sa.value;
          $scope.newCertificate.life_policy[0].personal.sum_assured =
            $scope.newCertificate.personal.sum_assured;
          $scope.newCertificate.life_policy[0].personal.salary =
            $scope.newCertificate.personal.salary;
          $scope.newCertificate.life_policy[0].smoker =
            $scope.newCertificate.smoker.value;
          $scope.newCertificate.life_policy[0].beneficiaries_life.forEach(
            function (beneficiarie, index) {
              beneficiarie.birthdate = datesFactory.toDate(
                $scope.newCertificate.beneficiaries_life[index].birthdate
              );
              beneficiarie.first_name =
                $scope.newCertificate.beneficiaries_life[index].first_name;
              beneficiarie.last_name =
                $scope.newCertificate.beneficiaries_life[index].last_name;
              beneficiarie.second_last_name =
                $scope.newCertificate.beneficiaries_life[
                  index
                ].second_last_name;
              beneficiarie.optional_relationship =
                $scope.newCertificate.beneficiaries_life[
                  index
                ].optional_relationship.value;
              beneficiarie.sex =
                $scope.newCertificate.beneficiaries_life[index].sex.value;
              beneficiarie.antiguedad = $scope.newCertificate.rec_antiguedad;
            }
          );
        } else if ($scope.newCertificate.accidents_policy.length) {
          $scope.newCertificate.rec_antiguedad = datesFactory.toDate(
            $scope.newCertificate.rec_antiguedad
          );
          $scope.newCertificate.accidents_policy[0].personal.email =
            $scope.newCertificate.personal.email;
          $scope.newCertificate.accidents_policy[0].personal.first_name =
            $scope.newCertificate.personal.first_name;
          $scope.newCertificate.accidents_policy[0].personal.last_name =
            $scope.newCertificate.personal.last_name;
          $scope.newCertificate.accidents_policy[0].personal.second_last_name =
            $scope.newCertificate.personal.second_last_name;
          $scope.newCertificate.accidents_policy[0].personal.birthdate =
            datesFactory.toDate($scope.newCertificate.personal.birthdate);
          $scope.newCertificate.accidents_policy[0].personal.sex =
            $scope.newCertificate.personal.sex.value;
          $scope.newCertificate.accidents_policy[0].relationship_accident.forEach(
            function (beneficiarie, index) {
              beneficiarie.birthdate = datesFactory.toDate(
                $scope.newCertificate.relationship_accident[index].birthdate
              );
              beneficiarie.first_name =
                $scope.newCertificate.relationship_accident[index].first_name;
              beneficiarie.last_name =
                $scope.newCertificate.relationship_accident[index].last_name;
              beneficiarie.second_last_name =
                $scope.newCertificate.relationship_accident[
                  index
                ].second_last_name;
              beneficiarie.relationship =
                $scope.newCertificate.relationship_accident[
                  index
                ].relationship.value;
              beneficiarie.sex =
                $scope.newCertificate.relationship_accident[index].sex.value;
              beneficiarie.antiguedad = $scope.newCertificate.rec_antiguedad;
            }
          );
        } else if ($scope.newCertificate.automobiles_policy.length) {
          $scope.newCertificate.automobiles_policy[0].car_owner =
            $scope.newCertificate.auto.car_owner;
          $scope.newCertificate.automobiles_policy[0].driver =
            $scope.newCertificate.auto.driver;
          $scope.newCertificate.automobiles_policy[0].email =
            $scope.newCertificate.auto.email;
          $scope.newCertificate.automobiles_policy[0].no_employee =
            $scope.newCertificate.auto.no_employee;
          $scope.newCertificate.automobiles_policy[0].brand =
            $scope.newCertificate.auto.brand;
          $scope.newCertificate.automobiles_policy[0].model =
            $scope.newCertificate.auto.model;
          $scope.newCertificate.automobiles_policy[0].year =
            $scope.newCertificate.auto.year;
          $scope.newCertificate.automobiles_policy[0].version =
            $scope.newCertificate.auto.version;
          $scope.newCertificate.automobiles_policy[0].serial =
            $scope.newCertificate.auto.serial;
          $scope.newCertificate.automobiles_policy[0].engine =
            $scope.newCertificate.auto.engine;
          $scope.newCertificate.automobiles_policy[0].color =
            $scope.newCertificate.auto.color;
          $scope.newCertificate.automobiles_policy[0].license_plates =
            $scope.newCertificate.auto.license_plates;
          $scope.newCertificate.automobiles_policy[0].usage =
            $scope.newCertificate.auto.usage.value;
          $scope.newCertificate.automobiles_policy[0].service =
            $scope.newCertificate.auto.service;
          $scope.newCertificate.automobiles_policy[0].procedencia =
            $scope.newCertificate.auto.procedencia.value;
          $scope.newCertificate.automobiles_policy[0].sum_insured =
            $scope.newCertificate.auto.sum_insured;
          $scope.newCertificate.automobiles_policy[0].charge_type =
            $scope.newCertificate.auto.charge_type.value;
          $scope.newCertificate.automobiles_policy[0].adjustment =
            $scope.newCertificate.auto.adjustment;
          $scope.newCertificate.automobiles_policy[0].mont_adjustment =
            $scope.newCertificate.auto.mont_adjustment;
          $scope.newCertificate.automobiles_policy[0].special_team =
            $scope.newCertificate.auto.special_team;
          $scope.newCertificate.automobiles_policy[0].mont_special_team =
            $scope.newCertificate.auto.mont_special_team;
          $scope.newCertificate.automobiles_policy[0].preferential_benefiaciary =
            $scope.newCertificate.auto.preferential_benefiaciary;
          $scope.newCertificate.automobiles_policy[0].beneficiary_rfc =
            $scope.newCertificate.auto.beneficiary_rfc;
          $scope.newCertificate.automobiles_policy[0].beneficiary_address =
            $scope.newCertificate.auto.beneficiary_address;
        } else if ($scope.newCertificate.damages_policy.length) {
          $scope.newCertificate.damages_policy[0].email =
            $scope.newCertificate.auto.email;
          if ($scope.caratula.subramo.subramo_name == "Incendio") {
            $scope.newCertificate.damages_policy[0].sucursal =
              $scope.newCertificate.auto.sucursal;
            $scope.newCertificate.damages_policy[0].giro =
              $scope.newCertificate.auto.giro;
            $scope.newCertificate.damages_policy[0].type_construction =
              $scope.newCertificate.auto.type_construction.value;
            $scope.newCertificate.damages_policy[0].no_levels =
              $scope.newCertificate.auto.no_levels;
            $scope.newCertificate.damages_policy[0].fhm_zone =
              $scope.newCertificate.auto.fhm_zone;
            $scope.newCertificate.damages_policy[0].tyev_zone =
              $scope.newCertificate.auto.tyev_zone;
            $scope.newCertificate.damages_policy[0].item_address =
              $scope.newCertificate.auto.item_address;
          } else if ($scope.caratula.subramo.subramo_name == "Diversos") {
            $scope.newCertificate.damages_policy[0].dam_owner =
              $scope.newCertificate.auto.dam_owner;
            $scope.newCertificate.damages_policy[0].no_employee =
              $scope.newCertificate.auto.no_employee;
            $scope.newCertificate.damages_policy[0].item_details =
              $scope.newCertificate.auto.item_details;
            $scope.newCertificate.damages_policy[0].usage =
              $scope.newCertificate.auto.usage.value;
            $scope.newCertificate.damages_policy[0].brand =
              $scope.newCertificate.auto.brand;
            $scope.newCertificate.damages_policy[0].model =
              $scope.newCertificate.auto.model;
            $scope.newCertificate.damages_policy[0].construction_year =
              $scope.newCertificate.auto.construction_year;
            $scope.newCertificate.damages_policy[0].reconstruction_year =
              $scope.newCertificate.auto.reconstruction_year;
            $scope.newCertificate.damages_policy[0].version =
              $scope.newCertificate.auto.version;
            $scope.newCertificate.damages_policy[0].serial =
              $scope.newCertificate.auto.serial;
            $scope.newCertificate.damages_policy[0].engine =
              $scope.newCertificate.auto.engine;
            $scope.newCertificate.damages_policy[0].color =
              $scope.newCertificate.auto.color;
            $scope.newCertificate.damages_policy[0].matricula =
              $scope.newCertificate.auto.matricula;
            $scope.newCertificate.damages_policy[0].permiso =
              $scope.newCertificate.auto.permiso;
            $scope.newCertificate.damages_policy[0].purchase_value =
              $scope.newCertificate.auto.purchase_value;
            $scope.newCertificate.damages_policy[0].item_address =
              $scope.newCertificate.auto.item_address;
          }
        }
      }
      var obj = [];
      obj.push($scope.newCertificate);
      $scope.change_endorsement = obj;
    };
    $scope.hasChanges = function () {
      return !angular.equals($scope.endorsement, $scope.originalEndorsement);
    };
    $scope.getChangedFields = function () {
      var changedFields = {};
      var logSpecific = "";
      if (
        $scope.endorsement.number_endorsement !=
        $scope.originalEndorsement.number_endorsement
      ) {
        changedFields.startDate = {
          antes: $scope.originalEndorsement.number_endorsement,
          después: $scope.endorsement.number_endorsement,
        };
        logSpecific =
          logSpecific +
          "Número Endoso de: " +
          String($scope.originalEndorsement.number_endorsement) +
          " a: " +
          String($scope.endorsement.number_endorsement) +
          ". ";
      }
      if (
        $scope.startDate !=
        datesFactory.convertDate($scope.originalEndorsement.init_date)
      ) {
        changedFields.startDate = {
          antes: datesFactory.convertDate($scope.originalEndorsement.init_date),
          después: $scope.startDate,
        };
        logSpecific =
          logSpecific +
          "Fecha inicial de: " +
          String(
            datesFactory.convertDate($scope.originalEndorsement.init_date)
          ) +
          " a: " +
          String($scope.startDate) +
          ". ";
      }

      if (
        $scope.endDate !=
        datesFactory.convertDate($scope.originalEndorsement.end_date)
      ) {
        changedFields.endDate = {
          antes: datesFactory.convertDate($scope.originalEndorsement.endDate),
          después: $scope.endDate,
        };
        logSpecific =
          logSpecific +
          "Fecha final de: " +
          String(
            datesFactory.convertDate($scope.originalEndorsement.end_date)
          ) +
          " a: " +
          String($scope.endDate) +
          ". ";
      }

      if (
        $scope.originalEndorsement.observations !==
        $scope.endorsement.observations
      ) {
        changedFields.observations = {
          antes: $scope.originalEndorsement.observations,
          después: $scope.endorsement.observations,
        };
        logSpecific =
          logSpecific +
          " Observaciones de: " +
          String($scope.originalEndorsement.observations) +
          " a: " +
          String($scope.endorsement.observations) +
          ". ";
      }

      return changedFields, logSpecific; // Return the fields that have changed
    };
    $scope.checkLength = function (value) {
      if (value && value.length > 500) {
        SweetAlert.swal(
          "Error",
          "El Número de Endoso no puede tener más de 500 caracteres.\n Se ha limitado a 500 caracteres.",
          "error"
        );
        $scope.endorsement.number_endorsement = value.substring(0, 500); // Trim extra characters
      }
    };
    $scope.updateEndorsement = function () {
      var changedFields,
        logSpecific = $scope.getChangedFields();
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      if (
        $scope.endorsement.concept == 24 ||
        $scope.endorsement.concept == 25
      ) {
        var endorsement_data = {
          other_desc: $scope.endorsement.other_desc,
          init_date: datesFactory.toDate($scope.startDate),
          end_date: datesFactory.toDate($scope.endDate),
          observations: $scope.endorsement.observations,
        };
      } else if ($scope.endorsement.concept == 4) {
        //prorroga
        $scope.change_endorsement = {
          end_date: datesFactory.toDate($scope.endDate),
        };
        var endorsement_data = {
          other_desc: $scope.endorsement.other_desc,
          init_date: datesFactory.toDate($scope.startDate),
          end_date: datesFactory.toDate($scope.endDate),
          observations: $scope.endorsement.observations,
          change: JSON.stringify($scope.change_endorsement),
        };
      } else {
        var endorsement_data = {
          other_desc: $scope.endorsement.other_desc,
          init_date: datesFactory.toDate($scope.startDate),
          end_date: datesFactory.toDate($scope.endDate),
          observations: $scope.endorsement.observations,
          change: JSON.stringify($scope.change_endorsement),
        };
      }
      if (endorsement_data) {
        if (
          endorsement_data.change == "{}" ||
          endorsement_data.change == {} ||
          endorsement_data.change == "" ||
          !endorsement_data.change
        ) {
          if (typeof $scope.endorsement.change == "object") {
            endorsement_data.change = JSON.stringify($scope.endorsement.change);
          } else {
            endorsement_data.change = $scope.endorsement.change;
          }
        }
      }
      // Check if changes were made
      if ($scope.hasChanges()) {
        // Proceed with the update if there are changes
        $http
          .patch($scope.endorsement.url, endorsement_data)
          .then(function (response) {
            if (response.status === 201 || response.status === 200) {
              l.stop();
              SweetAlert.swal(
                "¡Listo!",
                MESSAGES.OK.UPDATEENDORSEMENT,
                "success"
              );
              $state.go("endorsement.info", { endosoId: response.data.id });
            } else {
              l.stop();
              $scope.showFields($scope.descriptionSelected);
              SweetAlert.swal("ERROR", "Ocurrió un error", "error");
            }

            var params = {
              model: 10,
              event: "POST",
              associated_id: response.data.id,
              identifier: logSpecific ? logSpecific : "actualizó el endoso.",
            };
            dataFactory.post("send-log/", params);
          })
          .catch(function (e) {
            l.stop();
            console.log("error - caratula - catch", e);
          });
      } else {
        SweetAlert.swal("No hay cambios", "No No se han hecho cambios", "info");
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndosoFullController", EndosoFullController);

  EndosoFullController.$inject = [
    "dataFactory",
    "$scope",
    "MESSAGES",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$http",
    "$state",
    "$stateParams",
    "url",
    "$localStorage",
    "$sessionStorage",
    "$timeout",
    "coverageService",
    "toaster",
    "$rootScope",
  ];

  function EndosoFullController(
    dataFactory,
    $scope,
    MESSAGES,
    SweetAlert,
    FileUploader,
    datesFactory,
    $http,
    $state,
    $stateParams,
    url,
    $localStorage,
    $sessionStorage,
    $timeout,
    coverageService,
    toaster,
    $rootScope
  ) {
    var order = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    $scope.policy = {};
    $scope.endorsement = {};
    $scope.origin_endorsement = [];
    $scope.change_endorsement = [];
    $scope.add_new_coverage = false;
    $scope.recibosIndividuales = false;
    $scope.new_coverage = {
      coverage_name: "",
      sums_coverage: "",
      deductible: "",
    };
    $scope.types = [
      { id: 0, name: "Selecciona un tipo de endoso" },
      { id: 1, name: "A" },
      { id: 2, name: "B" },
      { id: 3, name: "D" },
    ];
    $scope.typeSelected = $scope.types[0];

    $scope.descriptions = [];

    $scope.checkRegister = false;
    $scope.directiveReceipts = [];
    $scope.dataToSave = [];

    order.defaults = [];

    $scope.sexs = [
      { value: "F", label: "Femenino" },
      { value: "M", label: "Masculino" },
    ];
    $scope.typesInsureds = [
      { value: 1, label: "Fija" },
      { value: 2, label: "Regla" },
    ];
    $scope.smokers = [
      { value: false, label: "No" },
      { value: true, label: "Si" },
    ];
    $scope.relationships = [
      { value: 1, label: "Titular" },
      { value: 2, label: "Cónyuge" },
      { value: 3, label: "Hijo" },
      { value: 4, label: "Otro" },
    ];
    $scope.types_auto = [
      { id: 1, name: "Automóvil" },
      { id: 2, name: "Motocicleta" },
      { id: 3, name: "Tracto" },
      { id: 4, name: "Autobús" },
      { id: 5, name: "Pick Up" },
      { id: 6, name: "Camiones hasta 1.5 ton" },
      { id: 7, name: "Chofer app" },
      { id: 8, name: "Remolque" },
      { id: 9, name: "Camiones + 1.5 ton" },
    ];
    $scope.usages = [
      { value: 1, label: "Particular" },
      { value: 2, label: "Carga Comercial" },
      { value: 3, label: "Servicio Público" },
    ];
    $scope.procedencias = [
      { value: 0, label: "Sin especificar" },
      { value: 1, label: "Residencia" },
      { value: 2, label: "Turista" },
      { value: 3, label: "Legalizado" },
      { value: 4, label: "Fronterizo" },
    ];

    $scope.btnNoRegister = {
      color: "#ffffff",
      "background-color": "#1c84c4",
    };
    $scope.btnRegister = {
      color: "#707877",
      "background-color": "#ffffff",
      "border-top": "1px solid #1c84c4",
      "border-right": "1px solid #1c84c4",
      "border-bottom": "1px solid #1c84c4",
    };

    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          order.acceso_polizas = perm;
          order.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                order.acceso_adm_pol = true;
              } else {
                order.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                order.acceso_ver_pol = true;
              } else {
                order.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                order.acceso_canc_pol = true;
              } else {
                order.acceso_canc_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          order.acceso_form = perm;
          order.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                order.acceso_form = true;
              } else {
                order.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          order.acceso_fian = perm;
          order.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                order.acceso_adm_fia = true;
              } else {
                order.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                order.acceso_ver_fia = true;
              } else {
                order.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          order.acceso_endosos = perm;
          order.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                order.acceso_reg_end = true;
              } else {
                order.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            }
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                order.permiso_administrar_adjuntos = true;
              } else {
                order.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }

    if ($stateParams.myInsurance != "some default") {
      $scope.policy = $stateParams.myInsurance;
      order.policy_number = {
        val: $scope.policy.poliza_number,
        id: $scope.policy.id,
      };
    }

    if ("save_filters_endoso_poliza" in $localStorage) {
      if ($localStorage["save_filters_endoso_poliza"]) {
        order.policy_number = order.policy_number ? order.policy_number : {};
        order.policy_number.value =
          $localStorage["save_filters_endoso_poliza"] &&
          $localStorage["save_filters_endoso_poliza"]["poliza"]
            ? $localStorage["save_filters_endoso_poliza"]["poliza"]
            : order.policy_number.value
            ? order.policy_number.value
            : "";
        order.policy_number.val =
          $localStorage["save_filters_endoso_poliza"] &&
          $localStorage["save_filters_endoso_poliza"]["poliza"]
            ? $localStorage["save_filters_endoso_poliza"]["poliza"]
            : order.policy_number.val
            ? order.policy_number.val
            : "";
        order.policy_number.id =
          $localStorage["save_filters_endoso_poliza"] &&
          $localStorage["save_filters_endoso_poliza"]["poliza_id"]
            ? $localStorage["save_filters_endoso_poliza"]["poliza_id"]
            : order.policy_number.id
            ? order.policy_number.id
            : "";

        $scope.packages =
          $localStorage["save_filters_endoso_poliza"]["packages"];

        $scope.add_new_coverage =
          $localStorage["save_filters_endoso_poliza"]["add_new_coverage"];
        $scope.new_coverage.coverage_name = $localStorage[
          "save_filters_endoso_poliza"
        ]
          ? $localStorage["save_filters_endoso_poliza"]["coverage_name"]
          : "";
        $scope.new_coverage.sums_coverage = $localStorage[
          "save_filters_endoso_poliza"
        ]
          ? $localStorage["save_filters_endoso_poliza"]["sums_coverage"]
          : "";
        $scope.new_coverage.deductible = $localStorage[
          "save_filters_endoso_poliza"
        ]
          ? $localStorage["save_filters_endoso_poliza"]["deductible"]
          : "";

        if ($localStorage["save_filters_endoso_poliza"]["origin_endorsement"]) {
          $scope.oldPay_copy = angular.copy(
            $localStorage["save_filters_endoso_poliza"]["origin_endorsement"][
              "forma_de_pago"
            ]
          );
          $scope.oldPay =
            $localStorage["save_filters_endoso_poliza"]["origin_endorsement"][
              "forma_de_pago"
            ];
        }
        if ($scope.oldPay) {
          switch ($scope.oldPay) {
            case 1:
              $scope.oldPay = "Mensual";
              break;
            case 2:
              $scope.oldPay = "Bimestral";
              break;
            case 3:
              $scope.oldPay = "Trimestral";
              break;
            case 4:
              $scope.oldPay = "Cuatrimestral";
              break;
            case 5:
              $scope.oldPay = "Contado";
              break;
            case 6:
              $scope.oldPay = "Semestral";
              break;
            case 12:
              $scope.oldPay = "Anual";
              break;
            default:
              $scope.oldPay = $scope.oldPay;
          }
        }
        if ($localStorage["save_filters_endoso_poliza"]["other_desc"]) {
          $scope.endorsement.other_desc = $localStorage[
            "save_filters_endoso_poliza"
          ]["other_desc"]
            ? $localStorage["save_filters_endoso_poliza"]["other_desc"]
            : "";
        }
        $scope.change_endorsement =
          $localStorage["save_filters_endoso_poliza"]["change_endorsement"];
        if ($localStorage["save_filters_endoso_poliza"]["change_endorsement"]) {
          if (
            $localStorage["save_filters_endoso_poliza"]["change_endorsement"][
              "usage"
            ]
          ) {
            $scope.types_auto.forEach(function (item) {
              if (
                item.id ==
                $localStorage["save_filters_endoso_poliza"][
                  "change_endorsement"
                ]["policy_type"]["id"]
              ) {
                $scope.change_endorsement.policy_type = item;
              }
            });
            $scope.usages.forEach(function (item) {
              if (
                item.id ==
                $localStorage["save_filters_endoso_poliza"][
                  "change_endorsement"
                ]["usage"]["id"]
              ) {
                $scope.change_endorsement.usage = item;
              }
            });
            $scope.procedencias.forEach(function (item) {
              if (
                item.id ==
                $localStorage["save_filters_endoso_poliza"][
                  "change_endorsement"
                ]["procedencia"]["id"]
              ) {
                $scope.change_endorsement.procedencia = item;
              }
            });
          }
          if (
            $localStorage["save_filters_endoso_poliza"]["change_endorsement"][
              "sex"
            ]
          ) {
            $scope.sexs.forEach(function (item) {
              if (
                item.value ==
                $localStorage["save_filters_endoso_poliza"][
                  "change_endorsement"
                ]["sex"]["value"]
              ) {
                $scope.change_endorsement.sex = item;
              }
            });
          }
          if (
            $localStorage["save_filters_endoso_poliza"]["change_endorsement"][
              "smoker"
            ]
          ) {
            $scope.smokers.forEach(function (item) {
              if (
                item.id ==
                $localStorage["save_filters_endoso_poliza"][
                  "change_endorsement"
                ]["smoker"]["id"]
              ) {
                $scope.change_endorsement.smoker = item;
              }
            });
          }
          if (
            $localStorage["save_filters_endoso_poliza"]["change_endorsement"][
              "address"
            ]
          ) {
            dataFactory
              .get(
                "contractors-app/" +
                  $localStorage["save_filters_endoso_poliza"][
                    "change_endorsement"
                  ]["id"]
              )
              .then(function success(response) {
                order.contratante = {};
                order.contratante.val = response.data.full_name;
                order.contratante.value = response.data;
                response.data.address_contractor.forEach(function (item) {
                  if (
                    item.id ==
                    $localStorage["save_filters_endoso_poliza"][
                      "change_endorsement"
                    ]["address"]
                  ) {
                    $scope.addressSelected = item;
                  }
                });
              });
          }
        }
        order.defaults.coverages =
          $localStorage["save_filters_endoso_poliza"]["coverages"];
        $scope.endorsement.observations =
          $localStorage["save_filters_endoso_poliza"]["observations"];
        if (
          $localStorage &&
          $localStorage["save_filters_endoso_poliza"] &&
          $localStorage["save_filters_endoso_poliza"]["concept"]
        ) {
          if (
            $localStorage["save_filters_endoso_poliza"]["concept"] == 7 ||
            ($localStorage["save_filters_endoso_poliza"]["concept"] == 2 &&
              $localStorage["save_filters_endoso_poliza"][
                "origin_endorsement"
              ] &&
              $localStorage["save_filters_endoso_poliza"]["origin_endorsement"]
                .ramo)
          ) {
            $http
              .post(url.IP + "paquetes-data-by-subramo/", {
                ramo: $localStorage["save_filters_endoso_poliza"][
                  "origin_endorsement"
                ].ramo.id,
                subramo:
                  $localStorage["save_filters_endoso_poliza"][
                    "origin_endorsement"
                  ].subramo.id,
                provider:
                  $localStorage["save_filters_endoso_poliza"][
                    "origin_endorsement"
                  ].aseguradora.id,
              })
              .then(
                function success(response) {
                  if (response.data.length) {
                    $scope.packages = response.data;
                    $scope.packages.forEach(function (item) {
                      if (
                        item.package_name.toLowerCase() ==
                        $localStorage["save_filters_endoso_poliza"][
                          "origin_endorsement"
                        ].paquete.package_name.toLowerCase()
                      ) {
                        $scope.packageSelected = item;
                      }
                    });
                  }
                },
                function error(e) {
                  console.log("Error - paquetes-data-by-subramo", e);
                  $scope.packages = [];
                }
              )
              .catch(function (error) {
                console.log("Error - paquetes-data-by-subramo - catch", error);
                $scope.packages = [];
              });

            order.defaults = {
              coverages: [],
              coverageList: [],
            };

            var lista_coberturas = [];
            var origin =
              $localStorage["save_filters_endoso_poliza"][
                "origin_endorsement"
              ] || {};
            var from_pdf = !!origin.from_pdf;
            var paquete =
              (origin.paquete && origin.paquete.coverage_package) || [];
            var coverageInPolicy = origin.coverageInPolicy_policy || [];

            var lista_coberturas = [];
            order.defaults.coverages = order.defaults.coverages || [];
            order.defaults.coverageList = order.defaults.coverageList || [];

            // ─────────────────────────────────────────────
            // CASO 1: VIENE DE PDF → usamos coverageInPolicy tal cual
            // ─────────────────────────────────────────────
            if (from_pdf && coverageInPolicy && coverageInPolicy.length != 0) {
              coverageInPolicy.forEach(function (item) {
                if (!item) return;

                var cov = angular.copy(item);

                // normalizamos estructura a la esperada por el front
                cov.sums_coverage = [{ sum_insured: item.sum_insured }];
                cov.deductible_coverage = [{ deductible: item.deductible }];

                if (item.coinsurance || item.topecoinsurance) {
                  cov.coinsurance_coverage = [
                    { coinsurance: item.coinsurance },
                  ];
                  cov.topecoinsurance_coverage = [
                    { topecoinsurance: item.topecoinsurance },
                  ];
                }

                // evitar duplicados por id (si no tiene id, puedes usar coverage_name)
                var key = cov.id || cov.coverage_name;
                if (key && lista_coberturas.indexOf(key) === -1) {
                  lista_coberturas.push(key);
                  order.defaults.coverages.push(cov);
                }
              });
            } else {
              // ─────────────────────────────────────────────
              // CASO 2: NO VIENE DE PDF → usamos paquete + match por nombre
              // ─────────────────────────────────────────────
              paquete.forEach(function (element) {
                var encontrada = false;
                var covBase = angular.copy(element);

                coverageInPolicy.forEach(function (item, index) {
                  if (!item || !item.coverage_name || !element.coverage_name)
                    return;

                  if (
                    item.coverage_name.toLowerCase() ===
                    element.coverage_name.toLowerCase()
                  ) {
                    var cov = angular.copy(covBase);

                    cov.sums_coverage = [{ sum_insured: item.sum_insured }];
                    cov.deductible_coverage = [{ deductible: item.deductible }];

                    if (item.coinsurance || item.topecoinsurance) {
                      cov.coinsurance_coverage = [
                        { coinsurance: item.coinsurance },
                      ];
                      cov.topecoinsurance_coverage = [
                        { topecoinsurance: item.topecoinsurance },
                      ];
                    }

                    var key = cov.id || cov.coverage_name;
                    if (key && lista_coberturas.indexOf(key) === -1) {
                      lista_coberturas.push(key);
                      order.defaults.coverages.push(cov);
                    }

                    encontrada = true;
                  }

                  // último item del inner loop
                  if (index + 1 === coverageInPolicy.length && !encontrada) {
                    // no hubo match por nombre → se va a coverageList
                    order.defaults.coverageList.push(angular.copy(covBase));
                  }
                });
              });
              if (order.defaults.coverageList.length == 0) {
                order.defaults.coverageList = paquete;
              }
            }

            // indexar coverages
            order.defaults.coverages = order.defaults.coverages.map(function (
              item,
              index
            ) {
              item.index = index;
              return item;
            });

            // $localStorage['save_filters_endoso_poliza']['origin_endorsement'].paquete.coverage_package.forEach(function(element){
            //   $scope.flag_coverage = false;
            //   $localStorage['save_filters_endoso_poliza']['origin_endorsement'].coverageInPolicy_policy.forEach(function(item, index){
            //     console.log('zzzzzzzzzzz',item,index,$scope.policy,item.coverage_name,element.coverage_name,$localStorage['save_filters_endoso_poliza']['origin_endorsement'])
            //     if($localStorage['save_filters_endoso_poliza']['origin_endorsement'] && $localStorage['save_filters_endoso_poliza']['origin_endorsement'].from_pdf){
            //         element = item;
            //         element.sums_coverage = [{sum_insured: item.sum_insured}];
            //         element.deductible_coverage = [{deductible: item.deductible}];
            //         if(item.coinsurance || item.topecoinsurance){
            //           element.coinsurance_coverage = [{coinsurance: item.coinsurance}];
            //           element.topecoinsurance_coverage = [{topecoinsurance: item.topecoinsurance}];
            //         }
            //         $scope.flag_coverage = true;
            //     }else{
            //       if((item.coverage_name).toLowerCase() == (element.coverage_name).toLowerCase()){
            //         element = item;
            //         element.sums_coverage = [{sum_insured: item.sum_insured}];
            //         element.deductible_coverage = [{deductible: item.deductible}];
            //         if(item.coinsurance || item.topecoinsurance){
            //           element.coinsurance_coverage = [{coinsurance: item.coinsurance}];
            //           element.topecoinsurance_coverage = [{topecoinsurance: item.topecoinsurance}];
            //         }
            //         $scope.flag_coverage = true;
            //       }
            //     }
            //     if((index + 1) == $localStorage['save_filters_endoso_poliza']['origin_endorsement'].coverageInPolicy_policy.length){
            //       if($scope.flag_coverage){
            //         if (!lista_coberturas.includes(element.id)){
            //           lista_coberturas.push(element.id);
            //           order.defaults.coverages.push(angular.copy(element));
            //         }

            //       } else {
            //         order.defaults.coverageList.push(angular.copy(element));
            //       }
            //     }
            //   });
            // });
            // order.defaults.coverages.map(function(item,index){
            //   item['index'] = index;
            //   return item
            // })
          }
        }
      }
    } else {
      $localStorage["save_filters_endoso_poliza"] = {};
    }

    $scope.saveLocalstorange = function () {
      $localStorage["save_filters_endoso_poliza"]["coverage_name"] =
        $scope.new_coverage ? $scope.new_coverage.coverage_name : "";
      $localStorage["save_filters_endoso_poliza"]["sums_coverage"] =
        $scope.new_coverage ? $scope.new_coverage.sums_coverage : "";
      $localStorage["save_filters_endoso_poliza"]["deductible"] =
        $scope.new_coverage ? $scope.new_coverage.deductible : "";

      $localStorage["save_filters_endoso_poliza"]["poliza"] =
        order.policy_number ? order.policy_number.value : "";
      $localStorage["save_filters_endoso_poliza"]["poliza_id"] =
        order.policy_number ? order.policy_number.id : "";
      $localStorage["save_filters_endoso_poliza"]["type"] = $scope.typeSelected
        ? $scope.typeSelected.id
        : 1;
      $localStorage["save_filters_endoso_poliza"]["concept"] =
        $scope.descriptionSelected ? $scope.descriptionSelected.value : 0;
      $localStorage["save_filters_endoso_poliza"]["other_desc"] = $scope
        .endorsement.other_desc
        ? $scope.endorsement.other_desc
        : "";
      $localStorage["save_filters_endoso_poliza"]["observations"] = $scope
        .endorsement.observations
        ? $scope.endorsement.observations
        : "";
      $localStorage["save_filters_endoso_poliza"]["change_endorsement"] =
        $scope.change_endorsement ? $scope.change_endorsement : "";
      $localStorage["save_filters_endoso_poliza"]["origin_endorsement"] =
        $scope.origin_endorsement ? $scope.origin_endorsement : "";
      $localStorage["save_filters_endoso_poliza"]["coverages"] = order.defaults
        .coverages
        ? order.defaults.coverages
        : "";
    };
    $scope.cadenaBusq = function (v) {
      $scope.cadena_a_buscar = v;
    };
    $scope.habuscado = false;
    $scope.findPolicy = function (parValue) {
      $scope.habuscado = true;
      if (parValue) {
        if (parValue && parValue.val) {
          var cadena = parValue.val;
        } else {
          var cadena = parValue;
        }
        if (cadena.length >= 3) {
          // if ($scope.infoUser.staff && !$scope.infoUser.superuser) {
          //   $scope.show_contractor = 'v2/polizas/get-endorsements-policies/';
          $scope.show_contractor = "get-endorsements-policies/";
          dataFactory
            .post($scope.show_contractor, { word: cadena })
            .then(
              function success(request) {
                var results = [];
                results = _.map(request.data, function (item) {
                  var label =
                    item.poliza_number +
                    " - " +
                    item.contractor +
                    " - " +
                    datesFactory.convertDate(item.start_of_validity) +
                    " - " +
                    datesFactory.convertDate(item.end_of_validity);
                  return {
                    label: label,
                    value: item.poliza_number,
                    id: item.id,
                  };
                  // $scope.saveLocalstorange();
                });
                $scope.autocompleteData = results;
                if ($scope.autocompleteData.length == 0) {
                  $scope.habuscado = false;
                } else {
                  $scope.habuscado = true;
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };
    if ($rootScope.from_task) {
      $localStorage["save_filters_endoso_poliza"]["type"] =
        $rootScope.type_endorsement;
      $scope.types.forEach(function (item) {
        if (item.id == $rootScope.type_endorsement) {
          $scope.typeSelected = item;
        }
      });
    }
    $scope.$watch("order.policy_number.value", function (newValue, oldValue) {
      if (order.policy_number) {
        if (order.policy_number.id) {
          $scope.getPolicy(order.policy_number.id);
        }
      }
    });

    $scope.getPolicy = function (param) {
      dataFactory
        .get("get-policy-endorsement/", { id: param })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.policy = response.data.results[0];
            try {
              $localStorage["save_filters_endoso_poliza"][
                "origin_endorsement"
              ] = $scope.policy;
            } catch (u) {}
            $scope.startDate = datesFactory.convertDate(
              $scope.policy.start_of_validity
            );
            $scope.endDate = datesFactory.convertDate(
              $scope.policy.end_of_validity
            );
            $scope.checkDate($scope.startDate);
            $scope.checkEndDate($scope.endDate);
            $scope.getClaves();
            // console.log('policccccccc',$scope.policy,$scope.descriptionSelected)
            // if($scope.descriptionSelected && $scope.policy){
            //   $scope.showFields($scope.descriptionSelected)
            // }
            // if($localStorage['save_filters_endoso_poliza'] && $localStorage['save_filters_endoso_poliza']['type']){
            //   $scope.types.forEach(function(item){
            //     if(item.id == $localStorage['save_filters_endoso_poliza']['type']){
            //       $scope.typeSelected = item;
            //     }
            //   });
            // }else{
            $scope.typeSelected = $scope.types[1];
            // }
            $scope.fillData($scope.typeSelected);
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORSEARCHPOLICY, "error");
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };
    $scope.cancelarCreacion = function (ui) {
      $localStorage["save_filters_endoso_poliza"] = {};
      $state.go("endorsement.lista");
    };
    $scope.getClaves = function () {
      $http
        .get(url.IP + "claves-by-provider/" + $scope.policy.aseguradora.id)
        .then(function success(clavesResponse) {
          $scope.claves = clavesResponse.data;
          if ($scope.claves.length == 1) {
            $scope.policy.clave = $scope.claves[0];
            $scope.claveSelected = $scope.claves[0];
          } else {
            $scope.claves.forEach(function (item) {
              if (item.id == $scope.policy.clave.id) {
                $scope.claveSelected = item;
              }
            });
          }
        })
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      $http
        .get(url.IP + "ramos-by-provider/" + $scope.policy.aseguradora.id)
        .then(
          function success(response) {
            $scope.ramos = response.data;
            $scope.ramos.forEach(function (item) {
              if (item.ramo_name == $scope.policy.ramo.ramo_name) {
                $scope.ramoSelected = item;
                $scope.subramos = item.subramo_ramo;
                $scope.subramos.forEach(function (subramo) {
                  if (
                    subramo.subramo_name == $scope.policy.subramo.subramo_name
                  ) {
                    $scope.subramoSelected = subramo;
                    $scope.directiveReceipts.subramo = subramo;
                    $scope.directiveReceipts.comision_percent =
                      $scope.policy.comision_percent;
                    $scope.dataToSave.subramo = subramo;

                    var comisiones = [];
                    if ($scope.claveSelected) {
                      if ($scope.claveSelected.clave_comision) {
                        if ($scope.claveSelected.clave_comision.length) {
                          $scope.claveSelected.clave_comision.forEach(function (
                            item
                          ) {
                            if (
                              $scope.subramoSelected.subramo_name ==
                              item.subramo
                            ) {
                              comisiones.push(item);
                            }
                          });
                        }
                      }
                    }
                    $scope.directiveReceipts.comisiones = comisiones;
                  }
                });
              }
            });
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    $scope.payment = function (parValue) {
      switch (parValue) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 4:
          return "Cuatrimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        default:
          return parValue;
      }
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.checkLength = function (value) {
      if (value && value.length > 500) {
        SweetAlert.swal(
          "Error",
          "El Número de Endoso no puede tener más de 500 caracteres.\n Se ha limitado a 500 caracteres.",
          "error"
        );
        $scope.endorsement.number_endorsement = value.substring(0, 500); // Trim extra characters
      }
    };
    $scope.checkLengthOtherdesc = function (value) {
      if (value && value.length > 500) {
        SweetAlert.swal(
          "Error",
          "Concepto no puede tener más de 500 caracteres.\n Se ha limitado a 500 caracteres.",
          "error"
        );
        $scope.endorsement.other_desc = value.substring(0, 500); // Trim extra characters
      }
    };
    $scope.fillData = function (type) {
      $scope.paySelected = undefined;
      $scope.directiveReceipts.endorsement_type = type.name;
      $scope.descriptions = [];
      if (type.id == 1) {
        $scope.descriptions.push({
          id: 1,
          value: 1,
          name: "CAMBIO DE FORMA DE PAGO",
        });
        $scope.descriptions.push({
          id: 2,
          value: 2,
          name: "CAMBIO DE PAQUETES EN COBERTURAS",
        });
        $scope.descriptions.push({
          id: 4,
          value: 3,
          name: "PRÓRROGA DE VIGENCIA",
        });
      } else if (type.id == 2) {
        $scope.descriptions.push({
          id: 7,
          value: 4,
          name: "CAMBIO DE CONTRATANTE",
        });
      } else if (type.id == 3) {
        $scope.descriptions.push({
          id: 1,
          value: 6,
          name: "CAMBIO DE FORMA DE PAGO",
        });
        $scope.descriptions.push({
          id: 2,
          value: 7,
          name: "CAMBIO DE PAQUETES EN COBERTURAS",
        });
        if (order.acceso_canc_pol) {
          $scope.descriptions.push({
            id: 13,
            value: 8,
            name: "CANCELACION DEFINITIVA A PETICION",
          });
        }
      } else {
        SweetAlert.swal("Error", "Selecciona una opción valida.", "error");
      }
      $scope.addDescriptions();
      if ($localStorage["save_filters_endoso_poliza"]["change_endorsement"]) {
        if ($scope.typeSelected.id == 1) {
          switch ($scope.oldPay_copy) {
            case 5:
              $scope.payments = [
                { id: 12, name: "Anual" },
                { id: 6, name: "Semestral" },
                { id: 3, name: "Trimestral" },
                { id: 4, name: "Cuatrimestral" },
                { id: 1, name: "Mensual" },
              ];
              break;
            case 12:
              $scope.payments = [
                { id: 6, name: "Semestral" },
                { id: 3, name: "Trimestral" },
                { id: 4, name: "Cuatrimestral" },
                { id: 1, name: "Mensual" },
              ];
              break;
            case 4:
              $scope.payments = [
                { id: 1, name: "Mensual" },
                { id: 3, name: "Trimestral" },
              ];
              break;
            case 6:
              $scope.payments = [
                { id: 3, name: "Trimestral" },
                { id: 4, name: "Cuatrimestral" },
                { id: 1, name: "Mensual" },
              ];
              break;
            case 3:
              $scope.payments = [{ id: 1, name: "Mensual" }];
              break;
            case 2:
              $scope.payments = [{ id: 1, name: "Mensual" }];
              break;
            case 1:
              $scope.payments = [];
              SweetAlert.swal(
                "Error",
                "No puedes cambiar la forma de pago Mensual a una forma de pago menor.",
                "error"
              );
              break;
            default:
              break;
          }
        } else if ($scope.typeSelected.id == 3) {
          switch ($scope.oldPay_copy) {
            case 1:
              $scope.payments = [
                { id: 3, name: "Trimestral" },
                { id: 4, name: "Cuatrimestral" },
                { id: 6, name: "Semestral" },
                { id: 12, name: "Anual" },
                { id: 5, name: "Contado" },
              ];
              break;
            case 2:
              $scope.payments = [
                { id: 3, name: "Trimestral" },
                { id: 4, name: "Cuatrimestral" },
                { id: 6, name: "Semestral" },
                { id: 12, name: "Anual" },
                { id: 5, name: "Contado" },
              ];
              break;
            case 3:
              $scope.payments = [
                { id: 6, name: "Semestral" },
                { id: 12, name: "Anual" },
                { id: 5, name: "Contado" },
              ];
              break;
            case 4:
              $scope.payments = [
                { id: 6, name: "Semestral" },
                { id: 5, name: "Contado" },
              ];
              break;
            case 6:
              $scope.payments = [
                { id: 12, name: "Anual" },
                { id: 5, name: "Contado" },
              ];
              break;
            case 12:
              $scope.payments = [{ id: 5, name: "Contado" }];
              break;
            case 5:
              $scope.payments = [];
              SweetAlert.swal(
                "Error",
                "No puedes cambiar la forma de pago Mensual a una forma de pago menor.",
                "error"
              );
              break;
            default:
              break;
          }
        }
        if ($scope.payments) {
          $scope.payments.forEach(function (item) {
            if (
              item.id ==
              $localStorage["save_filters_endoso_poliza"]["change_endorsement"][
                "forma_de_pago"
              ]
            ) {
              $scope.paySelected = item;
            }
          });
        }
      }
    };

    $scope.addDescriptions = function () {
      if ($scope.policy.subramo.subramo_name == "Vida") {
        if ($scope.typeSelected.id == 1) {
          $scope.descriptions.push({
            id: 10,
            value: 9,
            name: "EDICIÓN DE ASEGURADO",
          });
          $scope.descriptions.push({
            id: 6,
            value: 10,
            name: "ALTA DE BENEFICIARIOS",
          });
        } else if ($scope.typeSelected.id == 2) {
          $scope.descriptions.push({
            id: 10,
            value: 11,
            name: "EDICIÓN DE ASEGURADO",
          });
          $scope.descriptions.push({
            id: 6,
            value: 12,
            name: "EDICIÓN DE BENEFICIARIOS",
          });
        } else if ($scope.typeSelected.id == 3) {
          $scope.descriptions.push({
            id: 10,
            value: 13,
            name: "EDICIÓN DE ASEGURADO",
          });
          $scope.descriptions.push({
            id: 6,
            value: 14,
            name: "BAJA DE BENEFICIARIOS",
          });
        }
      } else if ($scope.policy.subramo.subramo_name == "Gastos Médicos") {
        if ($scope.typeSelected.id == 1) {
          $scope.descriptions.push({
            id: 9,
            value: 15,
            name: "CAMBIO DE NIVEL HOSPITALARIO",
          });
          $scope.descriptions.push({
            id: 9,
            value: 16,
            name: "CAMBIO DE TABULADOR",
          });
          $scope.descriptions.push({
            id: 10,
            value: 17,
            name: "EDICIÓN DE ASEGURADO",
          });
          $scope.descriptions.push({
            id: 6,
            value: 18,
            name: "ALTA DE DEPENDIENTES",
          });
        } else if ($scope.typeSelected.id == 2) {
          $scope.descriptions.push({
            id: 9,
            value: 19,
            name: "CAMBIO DE NIVEL HOSPITALARIO",
          });
          $scope.descriptions.push({
            id: 9,
            value: 20,
            name: "CAMBIO DE TABULADOR",
          });
          $scope.descriptions.push({
            id: 10,
            value: 21,
            name: "EDICIÓN DE ASEGURADO",
          });
          $scope.descriptions.push({
            id: 6,
            value: 22,
            name: "EDICIÓN DE DEPENDIENTES",
          });
        } else if ($scope.typeSelected.id == 3) {
          $scope.descriptions.push({
            id: 9,
            value: 23,
            name: "CAMBIO DE NIVEL HOSPITALARIO",
          });
          $scope.descriptions.push({
            id: 9,
            value: 24,
            name: "CAMBIO DE TABULADOR",
          });
          $scope.descriptions.push({
            id: 10,
            value: 25,
            name: "EDICIÓN DE ASEGURADO",
          });
          $scope.descriptions.push({
            id: 6,
            value: 26,
            name: "BAJA DE DEPENDIENTES",
          });
        }
      } else if ($scope.policy.subramo.subramo_name == "Automóviles") {
        if ($scope.typeSelected.id == 1) {
          $scope.descriptions.push({
            id: 9,
            value: 27,
            name: "CAMBIO DE RIESGO ASEGURADO",
          });
          $scope.descriptions.push({
            id: 9,
            value: 28,
            name: "CAMBIO DE CONDUCTOR",
          });
          $scope.descriptions.push({
            id: 9,
            value: 29,
            name: "CAMBIO DE EQUIPO ESPECIAL",
          });
          $scope.descriptions.push({
            id: 9,
            value: 30,
            name: "CAMBIO DE ADAPTACIONES",
          });
        } else if ($scope.typeSelected.id == 2) {
          $scope.descriptions.push({
            id: 9,
            value: 31,
            name: "EDICIÓN DE BENEFICIARIO",
          });
        } else if ($scope.typeSelected.id == 3) {
          $scope.descriptions.push({
            id: 9,
            value: 32,
            name: "CAMBIO DE RIESGO ASEGURADO",
          });
          $scope.descriptions.push({
            id: 9,
            value: 33,
            name: "CAMBIO DE CONDUCTOR",
          });
          $scope.descriptions.push({
            id: 9,
            value: 34,
            name: "CAMBIO DE EQUIPO ESPECIAL",
          });
          $scope.descriptions.push({
            id: 9,
            value: 35,
            name: "CAMBIO DE ADAPTACIONES",
          });
        }
      }
      if ($scope.policy.ramo.ramo_name == "Daños") {
        if ($scope.policy.subramo.subramo_name != "Automóviles") {
          $scope.descriptions.push({
            id: 9,
            value: 36,
            name: "CAMBIO DE RIESGO ASEGURADO",
          });
        }
      }
      $scope.descriptions.push({ id: 3, value: 37, name: "OTRO" });

      if ($localStorage.save_filters_endoso_poliza) {
        if ($localStorage.save_filters_endoso_poliza.concept) {
          $scope.descriptions.forEach(function (item) {
            if (
              item.value == $localStorage.save_filters_endoso_poliza.concept
            ) {
              $scope.descriptionSelected = item;
              if ($scope.descriptionSelected && $scope.policy) {
                $scope.showFields($scope.descriptionSelected);
              }
            }
          });
        }
      }
    };

    $scope.checkDate = function (param) {
      if (param.length == 10) {
        if (process(param) > process($scope.endDate)) {
          SweetAlert.swal(
            "Error",
            "La fecha inicio no puede ser mayor a la fecha fin.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        $scope.startDate = param;
        $scope.directiveReceipts.startDate = $scope.startDate;
        $scope.directiveReceipts.endingDate = $scope.endDate;
        var date1 = new Date(
          datesFactory.toDate($scope.directiveReceipts.startDate)
        );
        var date2 = new Date(
          datesFactory.toDate($scope.directiveReceipts.endingDate)
        );
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        $scope.directiveReceipts.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
        $scope.directiveReceipts.domiciliado = false;
        if (
          $scope.descriptionSelected &&
          $scope.descriptionSelected.value == 8
        ) {
          $scope.change_endorsement.fecha_cancelacion = $scope.startDate
            ? $scope.startDate
            : datesFactory.convertDate(new Date());
        }
        $scope.changePayment();
      }
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        $scope.endDate = param;
        $scope.directiveReceipts.startDate = $scope.startDate;
        $scope.directiveReceipts.endingDate = param;
        var date1 = new Date(
          datesFactory.toDate($scope.directiveReceipts.startDate)
        );
        var date2 = new Date(
          datesFactory.toDate($scope.directiveReceipts.endingDate)
        );
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        $scope.directiveReceipts.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
        $scope.directiveReceipts.comision_percent =
          $scope.policy.comision_percent;
        $scope.changePayment();
      }
    };

    $scope.trigger_add_coverage = function (add_new_coverage) {
      $localStorage["save_filters_endoso_poliza"]["add_new_coverage"] =
        add_new_coverage;
      $localStorage["save_filters_endoso_poliza"]["packages"] = $scope.packages;
    };

    $scope.addNewPackageCoverage = function (paramCov) {
      $scope.new_coverage = paramCov;
      // console.log($scope.policy.aseguradora);
      // console.log($scope.packageSelected);

      if (!$scope.packageSelected) {
        toaster.error("Error", "Seleccione un paquete");
        return;
      }
      var coverage = {
        coverage_name: $scope.new_coverage.coverage_name,
        priority: 0,
        provider: $scope.policy.aseguradora.url,
        package: $scope.packageSelected.url,
        deductible_coverage: $scope.new_coverage.deductible
          ? $scope.new_coverage.deductible
          : "0",
        sums_coverage: $scope.new_coverage.sums_coverage
          ? $scope.new_coverage.sums_coverage
          : "0",
      };
      coverageService.createCoverage(coverage).then(function (response) {
        $localStorage["save_filters_endoso_poliza"]["coverage_name"] = "";
        $scope.new_coverage.coverage_name = "";
        $http({
          method: "POST",
          url: url.IP + "sumas-aseguradas/",
          data: {
            coverage_sum: response.url,
            sum_insured: $scope.new_coverage.sums_coverage
              ? $scope.new_coverage.sums_coverage
              : "",
          },
        }).then(function (data) {
          $localStorage["save_filters_endoso_poliza"]["sums_coverage"] = "";
          $scope.new_coverage.sums_coverage = "";
          response.sums_coverage = data;
          $http({
            method: "POST",
            url: url.IP + "deducibles/",
            data: {
              coverage_deductible: response.url,
              deductible: $scope.new_coverage.deductible
                ? $scope.new_coverage.deductible
                : "",
            },
          }).then(function (datas) {
            $localStorage["save_filters_endoso_poliza"]["deductible"] = "";
            $scope.new_coverage.deductible = "";
            response.deductible_coverage = datas;
            order.defaults.coverages.push(response);
          });
        });
        $scope.add_new_coverage = false;
        toaster.success("Se ha agregado correctamente una nueva cobertura");
      });
    };
    $scope.anotherPolicy = function () {
      $localStorage["save_filters_endoso_poliza"]["coverages"] = [];
      $localStorage["save_filters_endoso_poliza"]["packages"] = [];
      $localStorage["save_filters_endoso_poliza"] = {};
      $localStorage["save_filters_endoso_poliza"]["origin_endorsement"] = {};
      $scope.policy = {};
      $scope.packages = [];
      order.policy_number = {};
      order.defaults = {
        coverages: [],
        coverageList: [],
      };
    };
    $scope.showFields = function (concept) {
      $scope.change_endorsement = {};
      $scope.policy.concept = concept;
      $scope.origin_endorsement = angular.copy($scope.policy);
      $scope.descriptionSelected = concept;
      if (concept) {
        if (concept.value == 1 || concept.value == 6) {
          //cambio forma pago
          $scope.oldPay = $scope.payment($scope.policy.forma_de_pago);
          $scope.directiveReceipts.endorsement_type = "A";
          if ($scope.typeSelected.id == 1) {
            switch ($scope.policy.forma_de_pago) {
              case 5:
                $scope.payments = [
                  { id: 12, name: "Anual" },
                  { id: 6, name: "Semestral" },
                  { id: 4, name: "Cuatrimestral" },
                  { id: 3, name: "Trimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 12:
                $scope.payments = [
                  { id: 6, name: "Semestral" },
                  { id: 3, name: "Trimestral" },
                  { id: 4, name: "Cuatrimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 6:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 4, name: "Cuatrimestral" },
                  { id: 1, name: "Mensual" },
                ];
                break;
              case 3:
                $scope.payments = [{ id: 1, name: "Mensual" }];
                break;
              case 2:
                $scope.payments = [{ id: 1, name: "Mensual" }];
                break;
              case 1:
                $scope.payments = [];
                SweetAlert.swal(
                  "Error",
                  "No puedes cambiar la forma de pago Mensual a una forma de pago menor.",
                  "error"
                );
                break;
              default:
                break;
            }
          } else if ($scope.typeSelected.id == 3) {
            switch ($scope.policy.forma_de_pago) {
              case 1:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 4, name: "Cuatrimestral" },
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 2:
                $scope.payments = [
                  { id: 3, name: "Trimestral" },
                  { id: 4, name: "Cuatrimestral" },
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 3:
                $scope.payments = [
                  { id: 6, name: "Semestral" },
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 6:
                $scope.payments = [
                  { id: 12, name: "Anual" },
                  { id: 5, name: "Contado" },
                ];
                break;
              case 12:
                $scope.payments = [{ id: 5, name: "Contado" }];
                break;
              case 5:
                $scope.payments = [];
                SweetAlert.swal(
                  "Error",
                  "No puedes cambiar la forma de pago Mensual a una forma de pago menor.",
                  "error"
                );
                break;
              default:
                break;
            }
          }
        } else if (concept.value == 2 || concept.value == 7) {
          //cambio paquetes
          if ($scope.policy && $scope.policy.ramo && $scope.policy.ramo.id) {
            $http
              .post(url.IP + "paquetes-data-by-subramo/", {
                ramo: $scope.policy.ramo.id,
                subramo: $scope.policy.subramo.id,
                provider: $scope.policy.aseguradora.id,
              })
              .then(
                function success(response) {
                  if (response.data.length) {
                    $scope.packages = response.data;
                    $scope.packages.forEach(function (item) {
                      if (
                        item.package_name.toLowerCase() ==
                        $scope.policy.paquete.package_name.toLowerCase()
                      ) {
                        $scope.packageSelected = item;
                      }
                    });
                  }
                },
                function error(e) {
                  console.log("Error - paquetes-data-by-subramo", e);
                  $scope.packages = [];
                }
              )
              .catch(function (error) {
                console.log("Error - paquetes-data-by-subramo - catch", error);
                $scope.packages = [];
              });
          }
          order.defaults = {
            coverages: [],
            coverageList: [],
          };

          // var lista_coberturas = [];
          // $scope.policy.paquete.coverage_package.forEach(function(element){
          //   $scope.flag_coverage = false;
          //   $scope.policy.coverageInPolicy_policy.forEach(function(item, index){
          //     console.log('ooooxooo',item,index,$scope.policy.from_pdf,item.coverage_name,element.coverage_name)
          //     if($scope.policy.from_pdf){
          //         element = item;
          //         element.sums_coverage = [{sum_insured: item.sum_insured}];
          //         element.deductible_coverage = [{deductible: item.deductible}];
          //         if(item.coinsurance || item.topecoinsurance){
          //           element.coinsurance_coverage = [{coinsurance: item.coinsurance}];
          //           element.topecoinsurance_coverage = [{topecoinsurance: item.topecoinsurance}];
          //         }
          //         $scope.flag_coverage = true;
          //     }else{
          //       if((item.coverage_name).toLowerCase() == (element.coverage_name).toLowerCase()){
          //         element = item;
          //         element.sums_coverage = [{sum_insured: item.sum_insured}];
          //         element.deductible_coverage = [{deductible: item.deductible}];
          //         if(item.coinsurance || item.topecoinsurance){
          //           element.coinsurance_coverage = [{coinsurance: item.coinsurance}];
          //           element.topecoinsurance_coverage = [{topecoinsurance: item.topecoinsurance}];
          //         }
          //         $scope.flag_coverage = true;
          //       }
          //     }
          //     if((index + 1) == $scope.policy.coverageInPolicy_policy.length){
          //       if($scope.flag_coverage){
          //         if (!lista_coberturas.includes(element.id)){
          //           lista_coberturas.push(element.id);
          //           order.defaults.coverages.push(angular.copy(element));
          //         }

          //       } else {
          //         console.log('iiiiiiiiiiiii',order.defaults.coverageList)
          //         order.defaults.coverageList.push(angular.copy(element));
          //       }
          //     }
          //   });
          // });
          // order.defaults.coverages.map(function(item,index){
          //   item['index'] = index;
          //   return item
          // })
          var origin = $scope.policy || {};
          var from_pdf = !!origin.from_pdf;
          var paquete =
            (origin.paquete && origin.paquete.coverage_package) || [];
          var coverageInPolicy = origin.coverageInPolicy_policy || [];

          var lista_coberturas = [];
          order.defaults.coverages = order.defaults.coverages || [];
          order.defaults.coverageList = order.defaults.coverageList || [];

          // ─────────────────────────────────────────────
          // CASO 1: VIENE DE PDF → usamos coverageInPolicy tal cual
          // ─────────────────────────────────────────────
          if (from_pdf && coverageInPolicy && coverageInPolicy.length != 0) {
            coverageInPolicy.forEach(function (item) {
              if (!item) return;
              var cov = angular.copy(item);
              // normalizamos estructura a la esperada por el front
              cov.sums_coverage = [{ sum_insured: item.sum_insured }];
              cov.deductible_coverage = [{ deductible: item.deductible }];
              if (item.coinsurance || item.topecoinsurance) {
                cov.coinsurance_coverage = [{ coinsurance: item.coinsurance }];
                cov.topecoinsurance_coverage = [
                  { topecoinsurance: item.topecoinsurance },
                ];
              }

              // evitar duplicados por id (si no tiene id, puedes usar coverage_name)
              var key = cov.id || cov.coverage_name;
              if (key && lista_coberturas.indexOf(key) === -1) {
                lista_coberturas.push(key);
                order.defaults.coverages.push(cov);
              }
            });
          } else {
            // ─────────────────────────────────────────────
            // CASO 2: NO VIENE DE PDF → usamos paquete + match por nombre
            // ─────────────────────────────────────────────
            paquete.forEach(function (element) {
              var encontrada = false;
              var covBase = angular.copy(element);

              coverageInPolicy.forEach(function (item, index) {
                if (!item || !item.coverage_name || !element.coverage_name)
                  return;

                if (
                  item.coverage_name.toLowerCase() ===
                  element.coverage_name.toLowerCase()
                ) {
                  var cov = angular.copy(covBase);

                  cov.sums_coverage = [{ sum_insured: item.sum_insured }];
                  cov.deductible_coverage = [{ deductible: item.deductible }];

                  if (item.coinsurance || item.topecoinsurance) {
                    cov.coinsurance_coverage = [
                      { coinsurance: item.coinsurance },
                    ];
                    cov.topecoinsurance_coverage = [
                      { topecoinsurance: item.topecoinsurance },
                    ];
                  }

                  var key = cov.id || cov.coverage_name;
                  if (key && lista_coberturas.indexOf(key) === -1) {
                    lista_coberturas.push(key);
                    order.defaults.coverages.push(cov);
                  }

                  encontrada = true;
                }

                // último item del inner loop
                if (index + 1 === coverageInPolicy.length && !encontrada) {
                  // no hubo match por nombre → se va a coverageList
                  order.defaults.coverageList.push(angular.copy(covBase));
                }
              });
            });
            if (order.defaults.coverageList.length == 0) {
              order.defaults.coverageList = paquete;
            }
          }
          // indexar coverages
          order.defaults.coverages = order.defaults.coverages.map(function (
            item,
            index
          ) {
            item.index = index;
            return item;
          });
        } else if (concept.value == 4) {
          //contratante
          order.contratante = {};
          order.contratante.val = $scope.policy.contractor
            ? $scope.policy.contractor.full_name
            : $scope.policy.contractor.full_name;
          order.contratante.value = $scope.policy.contractor
            ? $scope.policy.contractor
            : $scope.policy.contractor;
        } else if (concept.value == 37) {
          //otro
        } else if (concept.value == 3) {
          //prorroga
        } else if (concept.value == 8) {
          //cancelación
          $scope.change_endorsement.status = 11;
          // $scope.change_endorsement.fecha_cancelacion = datesFactory.convertDate(new Date());
          $scope.change_endorsement.fecha_cancelacion = $scope.startDate
            ? $scope.startDate
            : datesFactory.convertDate(new Date());
        } else if (
          concept.value == 9 ||
          concept.value == 11 ||
          concept.value == 13 ||
          concept.value == 17 ||
          concept.value == 21 ||
          concept.value == 25
        ) {
          //asegurado
          if ($scope.policy.life_policy.length > 0) {
            if ($scope.policy.life_policy[0].personal) {
              $scope.policy.life_policy[0].personal =
                $scope.policy.life_policy[0].personal;
            } else if ($scope.policy.personal_life_policy) {
              $scope.policy.life_policy[0].personal =
                $scope.policy.personal_life_policy[0];
            } else {
              $scope.policy.life_policy[0].personal =
                $scope.policy.life_policy[0].personal;
            }
            try {
              $scope.change_endorsement.antiguedad = datesFactory.convertDate(
                $scope.policy.life_policy[0].personal.antiguedad
              );
            } catch (e) {
              $scope.change_endorsement.antiguedad = datesFactory.convertDate(
                new Date()
              );
            }
            try {
              $scope.change_endorsement.birthdate = datesFactory.convertDate(
                $scope.policy.life_policy[0].personal.birthdate
              );
            } catch (e) {
              $scope.change_endorsement.birthdate = datesFactory.convertDate(
                new Date()
              );
            }
            $scope.change_endorsement.first_name =
              $scope.policy.life_policy[0].personal.first_name;
            $scope.change_endorsement.last_name =
              $scope.policy.life_policy[0].personal.last_name;
            $scope.change_endorsement.second_last_name =
              $scope.policy.life_policy[0].personal.second_last_name;
            $scope.change_endorsement.smoker =
              $scope.policy.life_policy[0].personal.smoker;
            $scope.change_endorsement.id =
              $scope.policy.life_policy[0].personal.id;
            $scope.sexs.forEach(function (item) {
              if (item.value == $scope.policy.life_policy[0].personal.sex) {
                $scope.change_endorsement.sex = item;
              }
            });
            $scope.smokers.forEach(function (item) {
              if (item.value == $scope.change_endorsement.smoker) {
                $scope.change_endorsement.smoker = item;
              }
            });
          } else {
            $scope.change_endorsement.antiguedad = datesFactory.convertDate(
              $scope.policy.accidents_policy[0].personal.antiguedad
            );
            $scope.change_endorsement.birthdate = datesFactory.convertDate(
              $scope.policy.accidents_policy[0].personal.birthdate
            );
            $scope.change_endorsement.first_name =
              $scope.policy.accidents_policy[0].personal.first_name;
            $scope.change_endorsement.last_name =
              $scope.policy.accidents_policy[0].personal.last_name;
            $scope.change_endorsement.second_last_name =
              $scope.policy.accidents_policy[0].personal.second_last_name;
            $scope.change_endorsement.id =
              $scope.policy.accidents_policy[0].personal.id;
            $scope.sexs.forEach(function (item) {
              if (
                item.value == $scope.policy.accidents_policy[0].personal.sex
              ) {
                $scope.change_endorsement.sex = item;
              }
            });
          }
        } else if (
          concept.value == 10 ||
          concept.value == 12 ||
          concept.value == 14 ||
          concept.value == 18 ||
          concept.value == 22 ||
          concept.value == 26
        ) {
          if ($scope.policy.life_policy[0]) {
            $scope.change_endorsement =
              $scope.policy.life_policy[0].beneficiaries_life;
            if ($scope.change_endorsement.length == 0) {
              $scope.change_endorsement = [
                {
                  first_name: "",
                  last_name: "",
                  second_last_name: "",
                  birthdate: datesFactory.convertDate(new Date()),
                  optional_relationship: "",
                  sex: $scope.sexs[3],
                  antiguedad: datesFactory.convertDate(new Date()),
                  percentage: "",
                  type_person: 1,
                },
              ];
            } else {
              $scope.change_endorsement.forEach(function (item) {
                item.antiguedad = datesFactory.convertDate(item.antiguedad);
                item.birthdate = datesFactory.convertDate(item.birthdate);
                $scope.sexs.forEach(function (sexo) {
                  if (item.sex == sexo.value) {
                    item.sex = sexo;
                  }
                });
                item.type_person = item.j_name ? 2 : 1;
              });
            }
          } else {
            $scope.change_endorsement =
              $scope.policy.accidents_policy[0].relationship_accident;
            if ($scope.change_endorsement.length == 0) {
              $scope.change_endorsement = [
                {
                  first_name: "",
                  last_name: "",
                  second_last_name: "",
                  antiguedad: datesFactory.convertDate(new Date()),
                  birthdate: datesFactory.convertDate(new Date()),
                  relationship: $scope.relationships[3],
                  sex: $scope.sexs[0],
                },
              ];
            } else {
              $scope.change_endorsement.forEach(function (item) {
                item.antiguedad = datesFactory.convertDate(item.antiguedad);
                item.birthdate = datesFactory.convertDate(item.birthdate);
                $scope.sexs.forEach(function (sexo) {
                  if (item.sex == sexo.value) {
                    item.sex = sexo;
                  }
                });
                $scope.relationships.forEach(function (relationship) {
                  if (item.relationship == relationship.value) {
                    item.relationship = relationship;
                  }
                });
              });
            }
          }
        } else if (
          concept.value == 15 ||
          concept.value == 19 ||
          concept.value == 23
        ) {
          //hospitalario
          $scope.change_endorsement.hospital_level =
            $scope.policy.hospital_level;
        } else if (
          concept.value == 16 ||
          concept.value == 20 ||
          concept.value == 24
        ) {
          //tabulador
          $scope.change_endorsement.tabulator = $scope.policy.tabulator;
        } else if (concept.value == 27 || concept.value == 32) {
          //riesgo asegurado
          $scope.types_auto.forEach(function (item) {
            if (item.id == $scope.policy.automobiles_policy[0].policy_type) {
              $scope.change_endorsement.policy_type = item;
            }
          });
          $scope.usages.forEach(function (item) {
            if (item.value == $scope.policy.automobiles_policy[0].usage) {
              $scope.change_endorsement.usage = item;
            }
          });
          $scope.change_endorsement.brand =
            $scope.policy.automobiles_policy[0].brand;
          $scope.change_endorsement.model =
            $scope.policy.automobiles_policy[0].model;
          $scope.change_endorsement.year =
            $scope.policy.automobiles_policy[0].year;
          $scope.change_endorsement.version =
            $scope.policy.automobiles_policy[0].version;
          $scope.change_endorsement.serial =
            $scope.policy.automobiles_policy[0].serial;
          $scope.change_endorsement.engine =
            $scope.policy.automobiles_policy[0].engine;
          $scope.change_endorsement.color =
            $scope.policy.automobiles_policy[0].color;
          $scope.change_endorsement.license_plates =
            $scope.policy.automobiles_policy[0].license_plates;
          $scope.usages.forEach(function (item) {
            if (item.value == $scope.policy.automobiles_policy[0].usage) {
              $scope.change_endorsement.usage = item;
            }
          });
          $scope.change_endorsement.service =
            $scope.policy.automobiles_policy[0].service;
          $scope.procedencias.forEach(function (item) {
            if (item.value == $scope.policy.automobiles_policy[0].procedencia) {
              $scope.change_endorsement.procedencia = item;
            }
          });
          $scope.change_endorsement.id = $scope.policy.automobiles_policy[0].id;
        } else if (concept.value == 28 || concept.value == 33) {
          //conductor
          $scope.change_endorsement.driver =
            $scope.policy.automobiles_policy[0].driver;
          $scope.change_endorsement.id = $scope.policy.automobiles_policy[0].id;
        } else if (concept.value == 29 || concept.value == 34) {
          //equipo
          $scope.change_endorsement.special_team =
            $scope.policy.automobiles_policy[0].special_team;
          $scope.change_endorsement.mont_special_team = parseFloat(
            $scope.policy.automobiles_policy[0].mont_special_team
          );
          $scope.change_endorsement.id = $scope.policy.automobiles_policy[0].id;
        } else if (concept.value == 30 || concept.value == 35) {
          //adaptaciones
          $scope.change_endorsement.adjustment =
            $scope.policy.automobiles_policy[0].adjustment;
          $scope.change_endorsement.mont_adjustment = parseFloat(
            $scope.policy.automobiles_policy[0].mont_adjustment
          );
          $scope.change_endorsement.id = $scope.policy.automobiles_policy[0].id;
        } else if (concept.value == 31) {
          //beneficiario
          $scope.change_endorsement.beneficiary_address =
            $scope.policy.automobiles_policy[0].beneficiary_address;
          $scope.change_endorsement.beneficiary_name =
            $scope.policy.automobiles_policy[0].beneficiary_name;
          $scope.change_endorsement.beneficiary_rfc =
            $scope.policy.automobiles_policy[0].beneficiary_rfc;
          $scope.change_endorsement.id = $scope.policy.automobiles_policy[0].id;
        } else if (concept.value == 36) {
          //danios
          $scope.change_endorsement.insured_item =
            $scope.policy.damages_policy[0].insured_item;
          $scope.change_endorsement.item_details =
            $scope.policy.damages_policy[0].item_details;
          $scope.change_endorsement.item_address =
            $scope.policy.damages_policy[0].item_address;
          $scope.change_endorsement.id = $scope.policy.damages_policy[0].id;
        }
      }
    };

    $scope.changePayment = function (param) {
      $scope.totalReceipts = [];
      if (param) {
        $scope.paySelected = param;
        $scope.change_endorsement.forma_de_pago = param.id;
        $scope.directiveReceipts.payment = param.id;
        $scope.directiveReceipts.comision_percent =
          $scope.policy.comision_percent;
        $scope.number_receipts = 0;
        if (
          $scope.descriptionSelected.value == 1 ||
          $scope.descriptionSelected.value == 6
        ) {
          switch (parseFloat(param.id)) {
            case 1:
              $scope.numberReceipts = 12;
              break;
            case 2:
              $scope.numberReceipts = 6;
              break;
            case 3:
              $scope.numberReceipts = 4;
              break;
            case 5:
              $scope.numberReceipts = 1; //contado
              break;
            case 6:
              $scope.numberReceipts = 2;
              break;
            case 12:
              $scope.numberReceipts = 1; //anual
              break;
            default:
              break;
          }
        }

        var recibos_fracionados =
          ($scope.directiveReceipts.policy_days_duration *
            $scope.numberReceipts) /
          365;
        var arreglo_recibos = recibos_fracionados.toString().split(".");
        var recibos_completos = parseFloat(arreglo_recibos[0]);
        var recibos_incompletos = "0." + arreglo_recibos[1];
        recibos_incompletos = parseFloat(recibos_incompletos);

        if (recibos_incompletos < 1 && recibos_incompletos > 0) {
          $scope.number_receipts = recibos_completos + 1;
        } else {
          $scope.number_receipts = recibos_completos;
        }

        for (var i = 1; i <= $scope.number_receipts; i++) {
          $scope.totalReceipts.push({ id: i, name: i });
        }
      } else {
        $scope.directiveReceipts.payment = $scope.policy.forma_de_pago;
        $scope.directiveReceipts.comision_percent =
          $scope.policy.comision_percent;
        for (var i = 1; i <= 12; i++) {
          $scope.totalReceipts.push({ id: i, name: i });
        }
      }
      if (
        $scope.directiveReceipts.policy_days_duration > 366 &&
        $scope.descriptionSelected &&
        $scope.descriptionSelected.id != 1
      ) {
        $scope.totalReceipts = [];
        $scope.recibosIndividuales = true;
        var numMonths = Math.floor(
          $scope.directiveReceipts.policy_days_duration / 30
        );
        for (var i = 1; i <= numMonths; i++) {
          $scope.totalReceipts.push({ id: i, name: i });
        }
      } else {
        $scope.recibosIndividuales = false;
      }
    };

    $scope.calculateReceipts_ = function (fechaInicio, fechaFin, dias) {
      var startDate = datesFactory.toDate(
        datesFactory.convertDate(fechaInicio)
      );
      var endDate = datesFactory.toDate(fechaFin);
      var daysBetween = Math.floor(
        (endDate - startDate) / (1000 * 60 * 60 * 24)
      );
      console.log(
        "daysBetween",
        daysBetween,
        startDate,
        endDate,
        fechaInicio,
        fechaFin
      );
      if (daysBetween > 365) {
        var totalYears = endDate.getFullYear() - startDate.getFullYear();
        var leapYearDays = 0;
        for (
          var year = startDate.getFullYear();
          year <= endDate.getFullYear();
          year++
        ) {
          if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
            leapYearDays++;
          }
        }
        var totalDays = daysBetween + leapYearDays;
        var calcularNumeroRecibos = Math.ceil(totalDays / 30); // número aproximado de meses
        for (var i = 1; i <= calcularNumeroRecibos; i++) {
          $scope.totalReceipts.push({ id: i, name: i, totalDays: totalDays });
        }
      } else {
        console.log(
          "El rango entre fechas es menor o igual a 365 días.",
          daysBetween
        );
      }
    };
    order.options = {
      deleteCoverage: function (obj, index) {
        order.defaults.coverages.splice(index, 1);
        order.defaults.coverageList.push(obj);
      },
      // addCoverage: function(obj){
      //   if(obj){

      //     // obj['deductibleInPolicy'] = obj.deductible_coverage && obj.deductible_coverage[0]['deductible'] ? {value: obj.deductible_coverage[0]['deductible']} : {value:'0'}
      //     // obj['sumInPolicy'] = obj.sums_coverage && obj.sums_coverage[0]['sum_insured'] ? {value: obj.sums_coverage[0]['sum_insured']} : {value:'0'}
      //     obj.deductibleInPolicy = {
      //       value: obj.deductible_coverage?.[0]?.deductible ?? '0'
      //     };

      //     obj.sumInPolicy = {
      //       value: obj.sums_coverage?.[0]?.sum_insured ?? '0'
      //     };

      //     order.defaults.coverages.push(obj);

      //     order.defaults.coverageList.forEach(function(coverage){
      //       if(coverage.coverage_name == obj.coverage_name){
      //         order.defaults.coverageList.splice(order.defaults.coverageList.indexOf(coverage), 1);
      //       }
      //     });
      //   }
      // }
      addCoverage: function (obj) {
        if (obj) {
          obj.deductibleInPolicy = {
            value:
              obj.deductible_coverage &&
              obj.deductible_coverage.length > 0 &&
              obj.deductible_coverage[0].deductible !== undefined &&
              obj.deductible_coverage[0].deductible !== null
                ? obj.deductible_coverage[0].deductible
                : "0",
          };

          obj.sumInPolicy = {
            value:
              obj.sums_coverage &&
              obj.sums_coverage.length > 0 &&
              obj.sums_coverage[0].sum_insured !== undefined &&
              obj.sums_coverage[0].sum_insured !== null
                ? obj.sums_coverage[0].sum_insured
                : "0",
          };

          order.defaults.coverages.push(obj);

          order.defaults.coverageList = order.defaults.coverageList.filter(
            function (coverage) {
              return coverage.coverage_name !== obj.coverage_name;
            }
          );
        }
      },
    };

    $scope.changePackage = function (param) {
      if (param) {
        order.defaults = {
          package_name: param.package_name,
          formInfo: { code: $scope.policy.subramo.subramo_code },
          coverages: [],
          coverageList: [],
        };
        $scope.packageSelected = param;
        param.coverage_package.forEach(function (element) {
          if (element.default) {
            order.defaults.coverages.push(angular.copy(element));
          } else {
            order.defaults.coverageList.push(angular.copy(element));
          }
        });
      } else {
        $scope.coveragesPackages = [];
      }
    };

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if (order.contratante.value.address_contractor) {
          if (order.contratante.value.address_contractor) {
            $scope.addresses = order.contratante.value.address_contractor;
            $scope.change_endorsement = {
              id: order.contratante.value.id,
              type: order.contratante.type_person,
              address: 0,
            };
          }
          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.change_endorsement.address = $scope.addresses[0].id;
          }
          $scope.saveLocalstorange();
        }
      }
    });

    $scope.changeAddress = function (param) {
      if (param) {
        $scope.change_endorsement.address = param.id;
      }
    };

    $scope.addBeneficiarie = function () {
      if ($scope.policy.subramo.subramo_name == "Vida") {
        var beneficiarie = {
          antiguedad: datesFactory.convertDate(new Date()),
          birthdate: datesFactory.convertDate(new Date()),
          first_name: "",
          last_name: "",
          second_last_name: "",
          sex: $scope.sexs[0],
          optional_relationship: "",
          percentage: "",
          type_person: 1,
        };
        $scope.change_endorsement.push(beneficiarie);
      } else {
        var beneficiarie = {
          first_name: "",
          last_name: "",
          second_last_name: "",
          birthdate: datesFactory.convertDate(new Date()),
          sex: $scope.sexs[0],
          relationship: $scope.relationships[3],
          antiguedad: datesFactory.convertDate(new Date()),
        };
        $scope.change_endorsement.push(beneficiarie);
      }
    };

    $scope.deleteBeneficiarie = function (index) {
      if ($scope.change_endorsement) {
        $scope.change_endorsement.splice(index, 1);
      } else {
        $scope.change_endorsement.splice(index, 1);
      }
    };

    $scope.typePerson = function (param, index) {
      $scope.change_endorsement[index].type_person = param;
      $scope.change_endorsement[index].antiguedad = datesFactory.convertDate(
        new Date()
      );
      $scope.change_endorsement[index].birthdate = datesFactory.convertDate(
        new Date()
      );
      $scope.change_endorsement[index].first_name = "";
      $scope.change_endorsement[index].last_name = "";
      $scope.change_endorsement[index].second_last_name = "";
      $scope.change_endorsement[index].sex =
        $scope.change_endorsement[index].type_person == 1 ? $scope.sexs[0] : "";
      $scope.change_endorsement[index].optional_relationship = "";
      $scope.change_endorsement[index].percentage = 0;
    };

    $scope.validateBirthdate = function (param) {
      if (process(param) > process(datesFactory.convertDate(new Date()))) {
        SweetAlert.swal(
          "Error",
          "La fecha de nacimiento no puede ser mayor a la fecha de hoy.",
          "error"
        );
        return;
      }

      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }
    };

    $scope.changeRegister = function (param) {
      $scope.checkRegister = param;
      if (!param) {
        $scope.btnNoRegister = {
          color: "#ffffff",
          "background-color": "#1c84c4",
        };
        $scope.btnRegister = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-right": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
        };
        $scope.dataToSave.recibos_poliza = [];
        $scope.endorsement.number_endorsement = "";
      } else {
        $scope.btnNoRegister = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
        };
        $scope.btnRegister = {
          color: "#ffffff",
          "background-color": "#1c84c4",
        };
        if ($scope.paySelected) {
          $scope.changePayment($scope.paySelected);
        } else {
          $scope.changePayment();
        }
      }
    };

    $scope.changeNumberReceipts = function (param) {
      $scope.directiveReceipts.num_receipts = param.id;
      $scope.directiveReceipts.concept = $scope.descriptionSelected.id;
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item, options){
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          if ($scope.endoso.number_endorsement) {
            SweetAlert.swal(
              "¡Listo!",
              "Endoso creado exitosamente.",
              "success"
            );
            $state.go("endorsement.info", { endosoId: $scope.endoso.id });
          }
          if (!$scope.endoso.number_endorsement) {
            SweetAlert.swal(
              "¡Listo!",
              "Orden de Trabajo creada exitosamente.",
              "success"
            );
            $state.go("endorsement.info", { endosoId: $scope.endoso.id });
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        order.options.checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 2 });
      } else {
        order.options.checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 1 });
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
      fileItem.removeAfterUpload = true;
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + endorsementId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.checkNumberEndorsement = function () {
      if ($scope.endorsement.number_endorsement) {
        dataFactory
          .get("exist-number-endorsement/", {
            number: $scope.endorsement.number_endorsement,
            poliza: $scope.policy.poliza_number,
          })
          .then(function (request) {
            if (request.data.status == true) {
              $scope.endorsement.number_endorsement = "";
              SweetAlert.swal(
                "Error",
                "El número de endoso ya existe.",
                "error"
              );
              return;
            } else {
              $scope.validityEndorsement();
            }
          })
          .catch(function (err) {
            console.log("error", err);
          });
      } else {
        SweetAlert.swal(
          "Error",
          MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
          "error"
        );
        return;
      }
    };

    $scope.validityEndorsement = function () {
      if (!order.policy_number) {
        SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
        return;
      }
      if (!$scope.typeSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORTYPEENDORSEMENT, "error");
        return;
      }
      if (!$scope.descriptionSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONCEPT, "error");
        return;
      }
      if (!$scope.endorsement.observations) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ENDOSOBS, "error");
        return;
      }
      if (
        $scope.descriptionSelected.value == 1 ||
        $scope.descriptionSelected.value == 6
      ) {
        if (!$scope.change_endorsement.forma_de_pago) {
          SweetAlert.swal("Error", MESSAGES.ERROR.SELPAY, "error");
          return;
        }
      }
      if ($scope.descriptionSelected.value == 4) {
        if (!order.contratante.val) {
          SweetAlert.swal("Error", MESSAGES.ERROR.CONTRACTORERROR, "error");
          return;
        }
        if (!$scope.change_endorsement.address) {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ADDATLEASTONEDIRECCTION,
            "error"
          );
          return;
        }
      }
      if ($scope.descriptionSelected.id == 10) {
        if (!$scope.change_endorsement.first_name) {
          SweetAlert.swal("Error", "Agrega un nombre al titular.", "error");
          return;
        }
        if (!$scope.change_endorsement.last_name) {
          SweetAlert.swal(
            "Error",
            "Agrega un apellido paterno al titular.",
            "error"
          );
          return;
        }
        if (!$scope.change_endorsement.birthdate) {
          SweetAlert.swal(
            "Error",
            "Agrega una fecha de nacimiento al titular.",
            "error"
          );
          return;
        }
        if (!$scope.change_endorsement.sex) {
          SweetAlert.swal("Error", "Selecciona un sexo al titular.", "error");
          return;
        }
        if ($scope.policy.subramo.subramo_name == "Vida") {
          if (!$scope.change_endorsement.smoker) {
            SweetAlert.swal(
              "Error",
              "Selecciona si fuma o no el titular.",
              "error"
            );
            return;
          }
        }
      }
      if (
        $scope.descriptionSelected.id == 6 ||
        $scope.descriptionSelected.id == 11
      ) {
        if (
          $scope.typeSelected.name == "A" ||
          $scope.typeSelected.name == "B"
        ) {
          var flagNewBeneficiarie = false;
          $scope.change_endorsement.forEach(function (item, index) {
            if (item.type_person) {
              if (item.type_person == 1) {
                if (!item.first_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el nombre del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.last_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el apellido paterno del beneficiario #" +
                      (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.birthdate) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega la fecha de nacimiento del beneficiario #" +
                      (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.optional_relationship) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el parentesco del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.sex) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el sexo del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.antiguedad) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega la fecha de antigüedad del beneficiario #" +
                      (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.percentage) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el porcentaje del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
              } else {
                if (!item.j_name) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega la razón social del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.rfc) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega el rfc del beneficiario #" + (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
                if (!item.antiguedad) {
                  SweetAlert.swal(
                    "Error",
                    "Agrega la fecha de antigüedad del beneficiario #" +
                      (index + 1),
                    "error"
                  );
                  flagNewBeneficiarie = true;
                }
              }
            } else {
              if (!item.first_name) {
                SweetAlert.swal(
                  "Error",
                  "Agrega el nombre del dependiente #" + (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
              if (!item.last_name) {
                SweetAlert.swal(
                  "Error",
                  "Agrega el apellido paterno del dependiente #" + (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
              if (!item.birthdate) {
                SweetAlert.swal(
                  "Error",
                  "Agrega la fecha de nacimiento del dependiente #" +
                    (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
              if (!item.relationship) {
                SweetAlert.swal(
                  "Error",
                  "Agrega el parentesco del dependiente #" + (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
              if (!item.sex) {
                SweetAlert.swal(
                  "Error",
                  "Agrega el sexo del dependiente #" + (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
              if (!item.antiguedad) {
                SweetAlert.swal(
                  "Error",
                  "Agrega la fecha de antigüedad del dependiente #" +
                    (index + 1),
                  "error"
                );
                flagNewBeneficiarie = true;
              }
            }
          });
          if (flagNewBeneficiarie) {
            return;
          }
        }
      }
      if (
        $scope.descriptionSelected.value == 27 ||
        $scope.descriptionSelected.value == 32
      ) {
        if ($scope.policy.subramo.subramo_name == "Automóviles") {
          if (!$scope.change_endorsement.brand) {
            SweetAlert.swal("Error", "Agrega una marca.", "error");
            return;
          }
          if (!$scope.change_endorsement.model) {
            SweetAlert.swal("Error", "Agrega un modelo.", "error");
            return;
          }
          if (!$scope.change_endorsement.year) {
            SweetAlert.swal("Error", "Agrega un año.", "error");
            return;
          }
          if (!$scope.change_endorsement.version) {
            SweetAlert.swal("Error", "Agrega una versión.", "error");
            return;
          }
          if (!$scope.change_endorsement.serial) {
            SweetAlert.swal("Error", "Agrega un número de serie.", "error");
            return;
          }
          if (!$scope.change_endorsement.usage) {
            SweetAlert.swal("Error", "Agrega un uso.", "error");
            return;
          }
          if (!$scope.change_endorsement.service) {
            SweetAlert.swal("Error", "Selecciona un serivicio.", "error");
            return;
          }
          if (!$scope.change_endorsement.procedencia) {
            SweetAlert.swal("Error", "Selecciona una procedencia.", "error");
            return;
          }
        }
      }
      if ($scope.checkRegister) {
        if (!$scope.endorsement.number_endorsement) {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
            "error"
          );
          return;
        }
        if (
          $scope.typeSelected.name == "A" ||
          $scope.typeSelected.name == "D"
        ) {
          if (!$scope.dataToSave.recibos_poliza) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
            return;
          }
        }
      }
      if (
        $scope.descriptionSelected.id == 2 ||
        $scope.descriptionSelected.id == 12
      ) {
        $scope.array_coverages = [];
        order.defaults.coverages.forEach(function (item) {
          if (!item.policy) {
            $scope.coverage_json = {
              coinsurance_coverage: item.coinsurance_coverage,
              coverage_name: item.coverage_name,
              deductible_coverage: item.deductible_coverage,
              deductibleInPolicy: item.deductibleInPolicy
                ? item.deductibleInPolicy
                : { value: "" },
              default: item.default,
              priority: item.priority,
              sums_coverage: item.sums_coverage,
              sumInPolicy: item.sumInPolicy ? item.sumInPolicy : { value: "" },
              topecoinsurance_coverage: item.topecoinsurance_coverage,
              typeCoverage: item.typeCoverage,
              url: item.url,
            };
            $scope.array_coverages.push($scope.coverage_json);
          } else {
            item.deductibleInPolicy = item.deductibleInPolicy
              ? item.deductibleInPolicy
              : { value: "" };
            $scope.array_coverages.push(item);
          }
        });
        $scope.change_endorsement = {
          package: $scope.packageSelected.id,
          coverages: $scope.array_coverages,
        };
      } else if ($scope.descriptionSelected.id == 4) {
        $scope.change_endorsement = {
          end_date: datesFactory.toDate($scope.endDate),
        };
      } else if ($scope.descriptionSelected.id == 10) {
        if (
          $scope.descriptionSelected.value == 9 ||
          $scope.descriptionSelected.value == 11 ||
          $scope.descriptionSelected.value == 13 ||
          $scope.descriptionSelected.value == 17 ||
          $scope.descriptionSelected.value == 21 ||
          $scope.descriptionSelected.value == 25
        ) {
          $scope.change_endorsement.antiguedad = datesFactory.toDate(
            $scope.change_endorsement.antiguedad
          );
          $scope.change_endorsement.birthdate = datesFactory.toDate(
            $scope.change_endorsement.birthdate
          );
          $scope.change_endorsement.sex = $scope.change_endorsement.sex.value;
        }
      } else if ($scope.descriptionSelected.id == 6) {
        $scope.change_endorsement.forEach(function (item) {
          item.antiguedad = datesFactory.toDate(item.antiguedad);
          if (item.birthdate) {
            item.birthdate = datesFactory.toDate(item.birthdate);
          }
          if (item.sex) {
            item.sex = item.sex.value;
          }
          if (item.relationship) {
            item.relationship = item.relationship.value;
          }
        });
      } else if ($scope.descriptionSelected.id == 9) {
        if ($scope.change_endorsement.policy_type) {
          $scope.change_endorsement.policy_type =
            $scope.change_endorsement.policy_type.id;
        }
        if ($scope.change_endorsement.usage) {
          $scope.change_endorsement.usage =
            $scope.change_endorsement.usage.value;
        }
        if ($scope.change_endorsement.procedencia) {
          $scope.change_endorsement.procedencia =
            $scope.change_endorsement.procedencia.value;
        }
      }
      $scope.createEndorsement();
    };

    $scope.createEndorsement = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      if ($scope.dataToSave.recibos_poliza) {
        $scope.dataToSave.recibos_poliza.forEach(function (item) {
          item.fecha_inicio = datesFactory.toDate(item.fecha_inicio);
          item.fecha_fin = datesFactory.toDate(item.fecha_fin);
          item.vencimiento = datesFactory.toDate(item.vencimiento);
          if ($scope.descriptionSelected.id == 1) {
            item.receipt_type = 1;
          }
          if (
            $scope.recibosIndividuales &&
            $scope.descriptionSelected.id != 1
          ) {
            item.receipt_type = 2;
          }
        });
      }
      if ($scope.descriptionSelected.id == 13) {
        $scope.change_endorsement.fecha_cancelacion = datesFactory.toDate(
          $scope.change_endorsement.fecha_cancelacion
        );
      }
      ($scope.endorsement.number_endorsement = $scope.endorsement
        .number_endorsement
        ? $scope.endorsement.number_endorsement
        : ""),
        ($scope.endorsement.concept = $scope.descriptionSelected.id);
      $scope.endorsement.other_desc = $scope.endorsement.other_desc
        ? $scope.endorsement.other_desc
        : "";
      $scope.endorsement.original = JSON.stringify($scope.origin_endorsement);
      $scope.endorsement.change = JSON.stringify($scope.change_endorsement);
      $scope.endorsement.status = $scope.checkRegister ? 2 : 5;
      $scope.endorsement.endorsement_type = $scope.typeSelected.name;
      $scope.endorsement.init_date = datesFactory.toDate($scope.startDate);
      $scope.endorsement.end_date = datesFactory.toDate($scope.endDate);
      $scope.endorsement.observations = $scope.endorsement.observations;
      $scope.endorsement.p_neta = $scope.dataToSave.p_neta
        ? $scope.dataToSave.p_neta
        : 0;
      $scope.endorsement.rpf = $scope.dataToSave.rpf
        ? $scope.dataToSave.rpf
        : 0;
      $scope.endorsement.derecho = $scope.dataToSave.derecho
        ? $scope.dataToSave.derecho
        : 0;
      $scope.endorsement.sub_total = $scope.dataToSave.sub_total
        ? $scope.dataToSave.sub_total
        : 0;
      $scope.endorsement.iva = $scope.dataToSave.iva
        ? $scope.dataToSave.iva
        : 0;
      $scope.endorsement.p_total = $scope.dataToSave.p_total
        ? $scope.dataToSave.p_total
        : 0;
      $scope.endorsement.descuento = $scope.dataToSave.descuento
        ? $scope.dataToSave.descuento
        : 0;
      $scope.endorsement.comision = $scope.dataToSave.comision
        ? $scope.dataToSave.comision
        : 0;
      ($scope.endorsement.comision_percent = $scope.dataToSave.comision_percent
        ? $scope.dataToSave.comision_percent
        : 0),
        ($scope.endorsement.endorsement_receipt = $scope.dataToSave
          .recibos_poliza
          ? $scope.dataToSave.recibos_poliza
          : []);
      $scope.endorsement.total_receipts = $scope.dataToSave.recibos_poliza
        ? $scope.dataToSave.recibos_poliza.length
        : 0;
      $scope.endorsement.insurancefolio = $scope.endorsement.insurancefolio
        ? $scope.endorsement.insurancefolio
        : "";
      $scope.endorsement.policy = $scope.policy.url;
      if (
        $scope.endorsement.endorsement_type == "D" &&
        $scope.endorsement.concept != 1
      ) {
        $scope.endorsement.p_neta = parseFloat($scope.endorsement.p_neta) * -1;
        $scope.endorsement.rpf = parseFloat($scope.endorsement.rpf) * -1;
        $scope.endorsement.derecho =
          parseFloat($scope.endorsement.derecho) * -1;
        $scope.endorsement.sub_total =
          parseFloat($scope.endorsement.sub_total) * -1;
        $scope.endorsement.iva = parseFloat($scope.endorsement.iva) * -1;
        $scope.endorsement.p_total =
          parseFloat($scope.endorsement.p_total) * -1;
      }
      if (
        $rootScope.from_task &&
        $rootScope.task_associated &&
        $rootScope.task_associated.url
      ) {
        $scope.endorsement.from_task = $rootScope.from_task;
        $scope.endorsement.task_associated = $rootScope.task_associated.id;
      }
      $http({
        method: "POST",
        url: url.IP + "endorsement/",
        data: $scope.endorsement,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            if (
              $rootScope.from_task &&
              $rootScope.task_associated &&
              $rootScope.task_associated.url
            ) {
              $http.patch($rootScope.task_associated.url, {
                ot_model: 2,
                ot_id_reference: response.data.id,
              });
            }
            if ($scope.countFile > 0) {
              $scope.endoso = response.data;
              $localStorage.save_filters_endoso_poliza = {};
              $localStorage["save_filters_endoso_poliza"] = {};
              uploadFiles(response.data.id);
            } else {
              l.stop();
              SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
              $state.go("endorsement.info", { endosoId: response.data.id });
              $localStorage.save_filters_endoso_poliza = {};
              $localStorage["save_filters_endoso_poliza"] = {};
            }
          } else {
            l.stop();
            if ($scope.dataToSave.recibos_poliza) {
              $scope.dataToSave.recibos_poliza.forEach(function (item) {
                item.fecha_inicio = datesFactory.convertDate(item.fecha_inicio);
                item.fecha_fin = datesFactory.convertDate(item.fecha_fin);
                item.vencimiento = datesFactory.convertDate(item.vencimiento);
              });
            }
            $scope.showFields($scope.descriptionSelected);
            SweetAlert.swal("ERROR", "Ócurrio un error", "error");
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("EndososTableCtrl", EndososTableCtrl);

  EndososTableCtrl.$inject = [
    "$state",
    "url",
    "$sessionStorage",
    "dataFactory",
    "$scope",
    "$parse",
    "$http",
    "datesFactory",
    "providerService",
    "toaster",
    "$localStorage",
    "appStates",
    "SweetAlert",
  ];

  function EndososTableCtrl(
    $state,
    url,
    $sessionStorage,
    dataFactory,
    $scope,
    $parse,
    $http,
    datesFactory,
    providerService,
    toaster,
    $localStorage,
    appStates,
    SweetAlert
  ) {
    var vm = this;
    $scope.infoUser = $sessionStorage.infoUser;

    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeStatus = changeStatus;
    vm.matchesContractors = matchesContractors;
    vm.isdates == false;
    $scope.busqueda = false;

    // vm.form = {
    //   provider: 0,
    //   ramo: 0,
    //   subramo: 0,
    //   since: datesFactory.convertDate(new Date()),
    //   until: datesFactory.convertDate(new Date()),
    //   payment: 0,
    //   status: 0,
    //   contratante: 0,
    //   group: 0,
    //   num_poliza: "",
    //   inicio_fin: true,
    //   //dates: 2
    //   dates:0,
    //   businessLine:0,
    //   celula: 0
    // };

    vm.businesLine = [
      {
        id: 1,
        name: "Comercial",
      },
      {
        id: 2,
        name: "Personal",
      },
      {
        id: 0,
        name: "Otro",
      },
    ];

    vm.status = [
      {
        id: 2,
        name: "Registrados",
      },
      {
        id: 3,
        name: "Rechazados",
      },
      {
        id: 4,
        name: "Cancelados",
      },
      {
        id: 5,
        name: "En trámite",
      },
    ];

    vm.types = [
      {
        id: "A",
        name: "A",
      },
      {
        id: "B",
        name: "B",
      },
      {
        id: "D",
        name: "D",
      },
    ];

    $scope.infoUser = $sessionStorage.infoUser;
    vm.changeBLine = changeBLine;

    var date = new Date();
    var curr_date = date.getDate();
    var curr_month = date.getMonth() + 1; //Months are zero based
    var curr_year = date.getFullYear();
    var d = curr_year + "-" + curr_month + "-" + curr_date;
    providerService.getProviderByKey(d).then(function (data) {
      vm.providers = data.data;
    });

    $scope.moduleName = "Célula";
    dataFactory.get("orginfo/").then(function success(response) {
      if (response.data.results.length) {
        $scope.configuracionGlobal = response.data.results[0];
        if ($scope.configuracionGlobal.moduleName) {
          $scope.moduleName = $scope.configuracionGlobal.moduleName;
        }
      }
    });
    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: datesFactory.convertDate(new Date()),
      until: datesFactory.convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: 0,
      group: 0,
      poliza: "",
      inicio_fin: true,
      dates: 0,
      businessLine: 0,
      celula: 0,
      type: 0,
    };

    function changeBLine(obj) {
      $scope.bLine = obj;
      if (obj) {
        vm.form.businesLine = obj;
      } else {
        vm.form.businesLine = 0;
      }
    }
    getCelulasContractor();
    activate();

    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    function activate() {
      $scope.actual_page = 1;
    }
    function cargaData(page) {
      $scope.busqueda = true;

      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }

      var data = {
        provider: vm.form.provider ? vm.form.provider : 0,
        ramo: vm.form.ramo ? vm.form.ramo : 0,
        subramo: vm.form.subramo ? vm.form.subramo : 0,
        since: vm.form.since ? vm.form.since : 0,
        until: vm.form.until ? vm.form.until : 0,
        status: vm.form.status ? vm.form.status.id : 0,
        contratante: vm.form.contratante.val ? vm.form.contratante.value : 0,
        poliza: vm.form.poliza ? vm.form.poliza : 0,
        type_contractor: vm.form.contratante.val ? vm.form.contratante.type : 0,
        order: 0,
        asc: 0,
        dates: 0,
        page: page ? page : 1,
        type: vm.form.type ? vm.form.type.id : "",
        businessLine: $scope.bLine ? $scope.bLine.id : 0,
        celula: cel ? cel : 0,
      };

      data.since = data.since + " " + "00:00:00";
      data.until = data.until + " " + "23:59:59";

      if (vm.isdates == true) {
        data.dates = 1;
      } else if (vm.isdates == false) {
        data.dates = 0;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   var url_fpu = 'v2/endosos/endorsement-list/';
      var url_fpu = "endorsement-list/";
      dataFactory.get(url_fpu, data).then(function success(response) {
        if (response.data.results.length) {
          vm.endorsements = response.data.results;
          vm.endosos_config = {
            count: response.data.count,
            previous: response.data.previous,
            next: response.data.next,
          };
          vm.show_pag_endosos = true;
          $scope.obtenerPaginacion(response.data, page ? page : 1);
          // $scope.testPagination('vm.endorsements', 'vm.endosos_config');

          vm.endorsements.forEach(function (item) {
            item.original = item.original.split("'").join('"');
            item.original = item.original.split("None").join('""');
            if (item != "") {
              if (typeof item == "object" || typeof item == "string") {
                try {
                  item.original = JSON.parse(item.original);
                } catch (err) {}
              }
            }
          });
        } else {
          vm.endorsements = [];
          vm.show_pag_endosos = false;
          toaster.warning("No se encontrarón registros");
        }
      });
    }
    $scope.selectProv = function (sel) {
      vm.form.provider = [];
      sel.forEach(function (cl) {
        vm.form.provider.push(cl.id);
      });
    };

    $scope.goTo = function (document_type, id) {
      if (document_type == 7 || document_type == 8) {
        var name = "Informacion Endoso";
        var route = "endorsement.details";
      } else {
        var name = "Informacion Endoso";
        var route = "endorsement.info";
      }

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      var params = { endosoId: id };
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.selectRamos = function (sel) {
      vm.subramos_toselected = [];
      vm.form.ramo = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.form.ramo.push(parseInt(r));
        $http.get(url.IP + "subramos-by-ramo_code/" + r).then(function (data) {
          data.data.forEach(function (sr) {
            vm.subramos_toselected.push(sr);
          });
        });
      });
      // if (sel.length == 1) {
      // if (vm.id) {

      // }
      // }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        // getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.form.subramo = [];
      sel.forEach(function (sr) {
        if (sr.subramo_code) var code = sr.subramo_code;
        else var code = sr.id;
        vm.form.subramo.push(code);
      });
    };

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      }
      dataFactory.get("ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.ramos = ramos.data;
      });
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      }
      try {
        vm.subramos = obj.subramo_ramo;
      } catch (e) {}
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }

    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (pagesdata, pagina) {
      $scope.paginacion = {
        count: pagesdata["count"],
        previous: pagesdata["previous"],
        next: pagesdata["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      $scope.Consultar(pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $scope.Consultar($scope.paginacion["paginaActual"] - 1);
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $scope.Consultar($scope.paginacion["paginaActual"] + 1);
      }
    };
    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          dataFactory
            .post($scope.show_contratante, { matchWord: parWord })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                // var juridicals = response.data.juridicals;
                // var naturals = response.data.naturals;
                // if(juridicals.length) {
                //   juridicals.forEach(function(item) {
                //     var obj = {
                //       label: item.j_name,
                //       value: item.id,
                //       type: 2
                //     };
                //     source.push(obj)
                //   });
                // } else if(naturals.length) {
                //   naturals.forEach(function(item) {

                //     if(item.full_name) {
                //       var obj = {
                //         label: item.full_name,
                //         value: item.id,
                //         type: 1
                //       };

                //     } else {
                //      var obj = {
                //         label: item.first_name+' '+ item.last_name+' '+ item.second_last_name,
                //         value: item.id,
                //         type: 1
                //       };
                //     }

                //     source.push(obj)
                //   });
                // }
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (
                      item.full_name &&
                      (item.type_person == 1 || item.type_person == "Física")
                    ) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type: 1,
                      };
                    } else if (
                      item.type_person == 2 ||
                      item.type_person == "Moral"
                    ) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type: 2,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    $scope.ShowContextMenu = function (name, insurence) {
      $scope.name_for_new_tab = name;
      $scope.id_for_new_tab = id;
      $scope.route_for_new_tab = "endorsement.info";

      $scope.name_for_new_tab = name;
      var route = "endorsement.info";
      if (insurence.policy.document_type == 8) {
        route = "endorsement.details";
      } else {
        route = "endorsement.info";
      }
      $scope.route_for_new_tab = route;
      $scope.id_for_new_tab = insurence.id;
    };

    $scope.open_new_tab = function () {
      var existe = false;
      appStates.states.forEach(function (state) {
        if (
          state.route == $scope.route_for_new_tab &&
          state.id == $scope.id_for_new_tab
        ) {
          existe = true;
        }
      });
      if (appStates.states.length > 3) {
        SweetAlert.swal("Error", "No se pueden abrir más pestañas.", "error");
      } else {
        if (!existe) {
          appStates.states.push({
            id: $scope.id_for_new_tab,
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab, {
              endosoId: $scope.id_for_new_tab,
            }),
          });
          $localStorage.tab_states = appStates.states;
          // $localStorage.tab_index = $localStorage.tab_states.length -1;
        }
      }
    };

    $scope.Consultar = function (page) {
      $scope.busqueda = true;

      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }

      var data = {
        provider: vm.form.provider ? vm.form.provider : 0,
        ramo: vm.form.ramo ? vm.form.ramo : 0,
        subramo: vm.form.subramo ? vm.form.subramo : 0,
        since: vm.form.since ? vm.form.since : 0,
        until: vm.form.until ? vm.form.until : 0,
        status: vm.form.status ? vm.form.status.id : 0,
        contratante: vm.form.contratante.val ? vm.form.contratante.value : 0,
        poliza: vm.form.poliza ? vm.form.poliza : 0,
        type_contractor: vm.form.contratante.val ? vm.form.contratante.type : 0,
        order: 0,
        asc: 0,
        dates: 0,
        page: page ? page : 1,
        type: vm.form.type ? vm.form.type.id : "",
        businessLine: $scope.bLine ? $scope.bLine.id : 0,
        celula: cel ? cel : 0,
      };

      data.since = data.since + " " + "00:00:00";
      data.until = data.until + " " + "23:59:59";

      if (vm.isdates == true) {
        data.dates = 1;
      } else if (vm.isdates == false) {
        data.dates = 0;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   var url_fpu = 'v2/endosos/endorsement-list/';
      var url_fpu = "endorsement-list/";
      dataFactory.get(url_fpu, data).then(function success(response) {
        if (response.data.results.length) {
          vm.endorsements = response.data.results;
          vm.endosos_config = {
            count: response.data.count,
            previous: response.data.previous,
            next: response.data.next,
          };
          vm.show_pag_endosos = true;
          // $scope.testPagination('vm.endorsements', 'vm.endosos_config');
          $scope.obtenerPaginacion(response.data, page ? page : 1);

          vm.endorsements.forEach(function (item) {
            item.original = item.original.split("'").join('"');
            item.original = item.original.split("None").join('""');
            if (item != "") {
              if (typeof item == "object" || typeof item == "string") {
                try {
                  item.original = JSON.parse(item.original);
                } catch (err) {}
              }
            }
          });
        } else {
          vm.endorsements = [];
          vm.show_pag_endosos = false;
          toaster.warning("No se encontrarón registros");
        }
      });
    };

    $scope.status = function (parStatus) {
      switch (parStatus) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Registrado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado";
          break;
        case 5:
          return "En trámite";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.concept = function (parConcept, endoso) {
      if (endoso.policy) {
        if (
          endoso.policy.document_type != 7 &&
          endoso.policy.document_type != 8
        ) {
          switch (parConcept) {
            case 1:
              return "CAMBIO DE FORMA DE PAGO";
              break;
            case 2:
              return "CAMBIO DE SUMA ASEGURADA";
              break;
            case 3:
              return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
              break;
            case 4:
              return "AGREGAR ASEGURADO";
              break;
            case 5:
              return "AGREGAR COBERTURAS";
              break;
            case 6:
              return "DECLARACIÓN MENSUAL";
              break;
            case 8:
              return "CAMBIO DATOS FISCALES";
              break;
            case 9:
              return "ESPECIFICACIONES";
              break;
            case 11:
              return "CAMBIO DE FORMA DE PAGO";
              break;
            case 12:
              return "DISMINUCIÓN EN LA SUMA ASEGURADA";
              break;
            case 13:
              return "BAJA DE COBERTURA";
              break;
            case 14:
              return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
              break;
            case 15:
              return "BAJA DE ASEGURADO";
              break;
            case 16:
              return "CANCELACIÓN DE PÓLIZA POR PETICIÓN";
              break;
            case 17:
              return "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO";
              break;
            case 23:
              return "ANTIGÜEDAD RECONOCIDA";
              break;
            case 24:
              return "ALTA DE ASEGURADOS";
              break;
            case 25:
              return "BAJA DE ASEGURADOS";
              break;
            case 26:
              return "AJUSTE ANUAL (A)";
              break;
            case 27:
              return "RECONOCIMIENTO DE ANTIGUEDAD";
              break;
            case 28:
              return "AJUSTE ANUAL (D)";
              break;
            case 29:
              return "OTRO";
              break;
            case 30:
              return "Declaración";
              break;
            case 31:
              return "Agregar asegurado o dependiente";
              break;
            case 32:
              return "Cancelación";
              break;
            case 33:
              return "CORRECCION DE DATOS";
              break;
            case 34:
              return "CORRECCION DE DATOS BENEFICIARIO";
              break;
            default:
              return "OTRO";
          }
        } else if (
          endoso.policy.document_type == 7 ||
          endoso.policy.document_type == 8
        ) {
          switch (parConcept) {
            case 1:
              return "AUMENTO MONTO AFIANZADO";
              break;
            case 2:
              return "DECREMENTO MONTO AFIANZADO";
              break;
            case 3:
              return "CAMBIO DE PORCENTAJE DE GARANTÍA";
              break;
            case 5:
              return "CAMBIO DE DATOS";
              break;
            case 4:
              return "OTRO";
              break;
            case 34:
              return "CAMBIOS EN EL BENEFICIARIO";
              break;
            case 53:
              return "DETALLE DE GARANTÍA";
              break;
            case 54:
              return "PRORROGA DE VIGENCIA";
              break;
            case 55:
              return "ANUENCIA";
              break;
            case 24:
              return "ALTA DE CERTIFICADOS";
              break;
            case 25:
              return "BAJA DE CERTIFICADOS";
              break;
            case 56:
              return "CORRECCIÓN DE CERTIFICADOS";
              break;
            case 57:
              return "Aumento y Prórroga";
              break;
            default:
              return "OTRO";
          }
        }
      }
    };

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getData(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    /* Configuracion del datepicker */
    $(".datepicker-me input").datepicker();
    $(".js-example-basic-multiple").select2();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("EndososInfoCtrl", EndososInfoCtrl);

  EndososInfoCtrl.$inject = [
    "dataFactory",
    "$stateParams",
    "$scope",
    "formatValues",
    "$uibModal",
    "$http",
    "FileUploader",
    "SweetAlert",
    "MESSAGES",
    "$state",
    "$sce",
    "url",
    "$localStorage",
    "emailService",
    "$sessionStorage",
  ];

  function EndososInfoCtrl(
    dataFactory,
    $stateParams,
    $scope,
    formatValues,
    $uibModal,
    $http,
    FileUploader,
    SweetAlert,
    MESSAGES,
    $state,
    $sce,
    url,
    $localStorage,
    emailService,
    $sessionStorage,
    $uibModalInstance
  ) {
    var vm = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.decrptedtoken = usr;

    $scope.deshabilitar = false;
    if (usr) {
      if (usr.role) {
        if (usr.role[1]) {
          $scope.perfilUser = usr.role[1];
        }
      }
    }
    $scope.coberturas = [2, 3, 5, 19, 12, 13, 14, 21];
    $scope.asegurado = [4, 20, 8, 15, 22];
    vm.policy_receipts = [];
    vm.endorsement_receipts = [];
    vm.getPDF = getPDF;
    vm.showBinnacleReceipt = showBinnacleReceipt;
    vm.showBinnacleNotes = showBinnacleNotes;
    vm.showBinnacleReceipt_Endoso = showBinnacleReceipt_Endoso;
    vm.showBinnacle = showBinnacle;
    vm.returnToReceipts = returnToReceipts;
    vm.returnToReceipts_End = returnToReceipts_End;
    vm.returnToNotes = returnToNotes;
    vm.viewCarta = viewCarta;
    $scope.cfp = false;
    vm.table = {
      headers: [
        "Serie",
        "Prima neta",
        "Derecho",
        "RPF",
        "Iva",
        "Prima Total",
        "Estatus",
        "Acciones",
        "Vigencia",
        "Vencimiento",
      ],
    };
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
            if (acc.permission_name == "Eliminar endosos") {
              if (acc.checked == true) {
                vm.acceso_elim_end = true;
              } else {
                vm.acceso_elim_end = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Eliminar OTs") {
              if (acc.checked == true) {
                vm.acceso_elim_ot = true;
              } else {
                vm.acceso_elim_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                vm.acceso_canc_ot = true;
              } else {
                vm.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Tablero de OTs") {
              if (acc.checked == true) {
                vm.acceso_tab = true;
              } else {
                vm.acceso_tab = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          vm.acceso_ref = perm;
          vm.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                vm.acceso_adm_ref = true;
              } else {
                vm.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                vm.acceso_pag_ref = true;
              } else {
                vm.acceso_pag_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          vm.acceso_fian = perm;
          vm.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                vm.permiso_administrar_adjuntos = true;
              } else {
                vm.permiso_administrar_adjuntos = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cobranza = perm;
          vm.acceso_cobranza.permissions.forEach(function (acc) {
            if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                vm.permiso_delete_cobranza = true;
              } else {
                vm.permiso_delete_cobranza = false;
              }
            }
          });
        }
      });
    }
    /* Configuracion del datepicker */
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    $scope.okFile = 0;
    $scope.countFile = 0;

    // Upload files
    $scope.userInfo = {
      id: 0,
    };

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        //'Authorization': 'Token ' + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal(
          "¡Listo!",
          "Archivos cargados exitosamente.",
          "success"
        );
        $state.go("endorsement.info", { endosoId: vm.insurance.id });
        activate();
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      // console.log('uploader',fileItem)
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
      fileItem.removeAfterUpload = true;
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId) {
      $scope.userInfo = {
        id: endorsementId,
      };

      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + endorsementId + "/archivos/";

      $scope.files = [];

      // $timeout(function() {
      $scope.uploader.uploadAll();
      //   console.log('fdfsf', $scope.filesCover,$scope.files)
      // }, 1000);
    }

    $scope.moveOTState = function (newcontainer, principal, seguimiento, tipo) {
      SweetAlert.swal(
        {
          title: "Mover Registro",
          text:
            "Se moverá " +
            vm.insurance.internal_number +
            " de: " +
            vm.insurance.seguimiento +
            ", al Contenedor: " +
            newcontainer.tablero,
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
            if (principal.contenedores && principal.contenedores.length > 0) {
              principal.contenedores.forEach(function (r, i) {
                if (r.tablero == seguimiento) {
                  if (tipo == 2) {
                    r.endoso.splice(r.endoso.indexOf(vm.insurance.id), 1);
                  }
                }
                if (r.tablero == newcontainer.tablero) {
                  r.endoso.push(vm.insurance.id);
                }
                if (r) {
                  if (r["details_endoso"]) {
                    r["details_endoso"] = [];
                  }
                  if (r["details_polizas"]) {
                    r["details_polizas"] = [];
                  }
                }
              });
            }
            var payload = {
              polizas_ots: principal.contenedores,
              name: principal.name,
              color: principal.color,
              url: $scope.principal.url ? $scope.principal.url : "",
            };
            if ($scope.principal.url && $scope.principal.url != "") {
              $http
                .patch($scope.principal.url, payload)
                .then(
                  function success(response) {
                    vm.insurance.seguimiento = newcontainer.tablero;
                    activate();
                  },
                  function error(e) {
                    console.log("Error - promotorias--", e);
                  }
                )
                .catch(function (error) {
                  console.log("Error - promotablero - catch", error);
                });
            }
          }
        }
      );
    };
    $scope.showFiles = function (item) {
      $http
        .get(url.IP + "endosos/" + item.id + "/archivos/")
        .then(function (response) {
          item.files = response.data.results;
          if (item.showFile) {
            item.showFile = false;
          } else {
            item.showFile = true;
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.saveFiles = function (param) {
      uploadFiles(param.id);
    };

    activate();

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    activate();
    function activate() {
      $http
        .post(url.IP + "get-data-promotoria-initial/")
        .then(
          function success(response) {
            if (response.data.results.length > 0) {
              $scope.principal = response.data.original;
              $scope.principal.contenedores =
                response.data.original.data_details;
              $scope.principal.url = response.data.original.url;
              $scope.principal.id = response.data.original.id;
            }
          },
          function error(e) {
            console.log("Error - promotorias--", e);
          }
        )
        .catch(function (error) {
          $scope.principal.contenedores = [];
          console.log("Error - promotablero - catch", error);
        });
      var data = {
        id_endoso: $stateParams.endosoId,
      };
      dataFactory.post("get-relation/", data).then(function success(response) {
        vm.certificates = response.data;
      });
      dataFactory
        .get("endorsement-info/" + $stateParams.endosoId + "/")
        .then(function success(response) {
          vm.insurance = response.data;
          vm.endosoId = vm.insurance.id;
          dataFactory
            .get("endosos/" + vm.insurance.id + "/archivos/")
            .then(function success(response) {
              if (response.status === 200 || response.status == 201) {
                if (response.data.results.length) {
                  vm.files = response.data.results;
                }
              }
            });

          var d_start = new Date(vm.insurance.policy.start_of_validity);
          var d_end = new Date(vm.insurance.policy.end_of_validity);

          var year_start = d_start.getFullYear();
          var year_end = d_end.getFullYear();

          var vigencia_ = parseInt(year_end) - parseInt(year_start);

          $scope.aniosPoliza = [];

          if (vigencia_ > 1) {
            $scope.poliza_multianual = true;
            for (var i = 1; i <= vigencia_; i++) {
              $scope.aniosPoliza.push(i);
            }
            $scope.anioPoliza = $scope.aniosPoliza[0];
            // $scope.showReceiptsYear($scope.anioPoliza);
          } else {
            $scope.poliza_multianual = false;
          }

          if (vm.insurance.policy) {
            if (vm.insurance.policy.aseguradora) {
              $http({
                method: "GET",
                url: url.IP + "get-allcertificates/",
                params: {
                  caratula: vm.insurance.policy.id,
                  active: true,
                },
              }).then(function success(request) {
                $scope.cert = request.data.results;
                $scope.certificates = [];
                $scope.cert.forEach(function (relationship) {
                  if (relationship.accidents_policy) {
                    if (relationship.accidents_policy[0]) {
                      var dependientes =
                        relationship.accidents_policy[0].relationship_accident;
                      dependientes.forEach(function (deps) {
                        if (
                          deps.is_active == false &&
                          deps.endorsement == vm.insurance.url
                        ) {
                          deps.certificate_number =
                            relationship.certificate_number;
                          $scope.certificates.push(deps);
                        }
                      });
                    }
                  }
                  if (relationship.life_policy) {
                    if (relationship.life_policy[0]) {
                      var beneficiarie =
                        relationship.life_policy[0].beneficiaries_life;
                      if (beneficiarie) {
                        beneficiarie.forEach(function (bens) {
                          if (
                            bens.is_active == false &&
                            bens.endorsement == vm.insurance.url
                          ) {
                            bens.certificate_number =
                              relationship.certificate_number;
                            $scope.certificates.push(bens);
                          }
                        });
                      }
                    }
                  }
                });
              });
            }
            // dependientes
            $scope.dependientes = [];
            if (vm.insurance.concept == 25) {
              if (vm.insurance.policy.subramo.subramo_code == 3) {
                var data = {
                  id_endoso: vm.insurance.id,
                };
                dataFactory
                  .post("relationDependiente/", data)
                  .then(function success(responseRel) {
                    $scope.dependientes = responseRel.data;
                  });
              } else if (vm.insurance.policy.subramo.subramo_code == 1) {
                var data = {
                  id_endoso: vm.insurance.id,
                };
                dataFactory
                  .post("relationBeneficiarios/", data)
                  .then(function success(responseRel) {
                    $scope.dependientes = responseRel.data;
                  });
              }
            }
          }

          if (vm.insurance.status == 2) {
            // dataFactory.get('notas-endorsement/', {endoso: vm.insurance.id})
            // .then(function success(resNotas) {
            //   vm.notas = resNotas.data.results;
            // })
            if (vm.insurance.policy) {
              dataFactory
                .get("policy-endorsements", {
                  poliza: vm.insurance.policy.poliza_number,
                })
                .then(function success(resEndoso) {
                  vm.endoToSelect = resEndoso.data;
                });
            } else if (vm.insurance.fianza) {
              dataFactory
                .get("fianza-endorsements", {
                  poliza: vm.insurance.fianza.fianza_number,
                })
                .then(function success(resEndoso) {
                  vm.endoToSelect = resEndoso.data;
                  // console.log('____-endoToSelect-__-',vm.endoToSelect)
                });
            }
          }
          vm.policy_receipts = [];
          if (vm.insurance.policy) {
            vm.recibosPor1 = vm.insurance.policy.receipts_by;
            if (vm.insurance.policy.document_type == 6) {
              // -----------
              dataFactory
                .get("polizas/" + vm.insurance.policy.caratula)
                .then(function success(response) {
                  if (response.status === 200 || response.status == 201) {
                    vm.recibosPor = response.data;
                    vm.recibosPor1 = response.data.receipts_by;
                    $http
                      .get(vm.insurance.policy.parent)
                      .then(function success(certEndoso) {
                        vm.certificadoEndoso = certEndoso.data;
                        if (vm.certificadoEndoso.parent) {
                          $http
                            .get(vm.certificadoEndoso.parent)
                            .then(function success(subCert) {
                              vm.subCertificadoEndoso = subCert.data;
                              if (
                                vm.insurance.policy.document_type == 6 &&
                                vm.recibosPor1 == 2
                              ) {
                                vm.subCertificadoEndoso.recibos_poliza.forEach(
                                  function (i) {
                                    $http.get(i).then(function success(rec) {
                                      if (vigencia_ > 1) {
                                        $scope.showReceiptsYear(
                                          $scope.anioPoliza
                                        );
                                      } else {
                                        if (rec.data.receipt_type == 1) {
                                          vm.policy_receipts.push(rec.data);
                                        }
                                      }
                                    });
                                  }
                                );
                              }
                            });
                        }
                      });
                  }
                });
              // ---------------
            }
          }

          if (vm.insurance.policy && vm.insurance.policy.receipts_by == 1) {
            vm.insurance.policy.recibos_poliza.forEach(function (recibo) {
              if (vigencia_ > 1) {
                $scope.showReceiptsYear($scope.anioPoliza);
              } else {
                if (recibo.receipt_type == 1) {
                  vm.policy_receipts.push(recibo);
                }
              }
            });
          } else if (vm.insurance.fianza) {
            vm.insurance.fianza.recibos_fianza.forEach(function (recibo) {
              if (recibo.receipt_type == 1) {
                vm.policy_receipts.push(recibo);
              }
            });
          }

          vm.endorsement_receipts = vm.insurance.endorsement_receipt;

          if (!vm.insurance.migrated) {
            if (
              (vm.insurance.concept == 1 ||
                vm.insurance.concept == 11 ||
                vm.insurance.concept == 43) &&
              !vm.insurance.fianza
            ) {
              $scope.cfp = true;
            } else if (
              vm.insurance.concept == 16 ||
              vm.insurance.concept == 17
            ) {
              $scope.cancelacion = true;
            } else if ($scope.coberturas.indexOf(vm.insurance.concept) >= 0) {
              var None = "";
              var True = true;
              var False = false;
              var json = JSON.stringify(eval("(" + vm.insurance.change + ")"));
              vm.coverages = JSON.parse(json);
            } else if ($scope.asegurado.indexOf(vm.insurance.concept) >= 0) {
              $scope.aseguradotype = true;
              if (vm.insurance.concept == 4) {
                var None = "";
                var True = true;
                var False = false;
                var json = JSON.stringify(
                  eval("(" + vm.insurance.change + ")")
                );
                if (vm.insurance.policy) {
                  if (vm.insurance.policy.accidents_policy.length) {
                    vm.newRelationship = JSON.parse(json);
                  } else if (vm.insurance.policy.life_policy.length) {
                    vm.newBeneficiaries = JSON.parse(json);
                  }
                }
              } else if (
                vm.insurance.concept == 20 ||
                vm.insurance.concept == 8 ||
                vm.insurance.concept == 9 ||
                vm.insurance.concept == 22
              ) {
                var None = "";
                var True = true;
                var False = false;
                var json = JSON.stringify(
                  eval("(" + vm.insurance.change + ")")
                );
                vm.subforms = JSON.parse(json);
              } else if (vm.insurance.concept == 15) {
                var None = "";
                var True = true;
                var False = false;
                if (!vm.insurance.change) {
                  vm.insurance.change = JSON.stringify({});
                }
                var json = JSON.stringify(
                  eval("(" + vm.insurance.change + ")")
                );
                if (vm.insurance.policy) {
                  if (vm.insurance.policy.accidents_policy.length) {
                    vm.toDelRelationship = JSON.parse(json);
                  } else if (vm.insurance.policy.life_policy.length) {
                    vm.toDelBeneficiarie = JSON.parse(json);
                  }
                }
              }
            } else if (
              vm.insurance.concept == 24 ||
              vm.insurance.concept == 25
            ) {
              var data = {
                id_endoso: vm.insurance.id,
              };
              dataFactory
                .post("get-relation/", data)
                .then(function success(response) {
                  vm.certificates = response.data;
                });
            } else if (vm.insurance.concept == 27) {
              var json = JSON.stringify(eval("(" + vm.insurance.change + ")"));
              vm.reconocimiento = JSON.parse(json);
            }
          }
          // comments
          $http({
            method: "GET",
            url: url.IP + "comments/",
            params: {
              model: 10,
              id_model: vm.endosoId,
            },
          })
            .then(function (request) {
              // console.log('-------', request);
              vm.comments_data = request.data.results;
              vm.comments_config = {
                count: request.data.count,
                next: request.data.next,
                previous: request.data.previous,
              };
              // console.log('comments_data', vm.comments_data);
            })
            .catch(function (e) {
              console.log("e", e);
            });

          $http({
            method: "GET",
            url: url.IP + "cartas-by-model",
            params: {
              model: 2,
            },
          }).then(function success(response) {
            vm.cartas = response.data;
          });
        });
    }
    $scope.checkNumEndoso = function () {
      if (vmm.number_endorsement) {
        dataFactory
          .get("exist-number-endorsement/", { number: vmm.number_endorsement })
          .then(function (request) {
            if (request.data.status == true) {
              SweetAlert.swal("Error", "Número de Endoso existente", "error");
              vmm.number_endorsement = "";
            }
          })
          .catch(function (err) {});
      }
    };

    $scope.showReceiptsYear = function (value) {
      $scope.receipts_policy = [];
      vm.insurance.policy.recibos_poliza.forEach(function (item) {
        if (item.receipt_type == 1) {
          $scope.receipts_policy.push(item);
        }
      });
      var fechaPrincipal = convertDate(vm.insurance.policy.start_of_validity);
      var arrayFecha = fechaPrincipal.split("/");
      var dia = parseFloat(arrayFecha[0]);
      var mes = parseFloat(arrayFecha[1]);
      var anioInicial = parseFloat(arrayFecha[2]) + (value - 1);
      var anioFinal = parseFloat(arrayFecha[2]) + value;
      var fechaInicial = mes + "/" + dia + "/" + anioInicial;
      var fechaTerminacion = mes + "/" + dia + "/" + anioFinal;

      vm.policy_receipts = [];

      $scope.receipts_policy.forEach(function (item, index) {
        if (
          item.fecha_inicio >= new Date(fechaInicial).toISOString() &&
          item.fecha_inicio < new Date(fechaTerminacion).toISOString()
        ) {
          vm.policy_receipts.push(item);
        }
      });
    };
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }

    function showBinnacleReceipt(param) {
      $scope.receiptmodel = param.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_receipt = request.data.results;
          vm.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.receipt_id = param.id;
      vm.show_binnacle_receipt = true;
    }
    function returnToReceipts() {
      vm.show_binnacle_receipt = false;
    }

    function showBinnacle(param) {
      $scope.receiptmodel = param.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 1,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.polizaId = param.id;
      vm.show_binnacle = true;
    }

    function showBinnacleNotes(param) {
      $scope.receiptmodel = param.url;
      vm.comments_data_notes = [];
      // $http({
      //   method: 'GET',
      //   url: url.IP+'comments/',
      //   params: {
      //     'model': 20,
      //   'id_model': param.id
      //   }
      // })
      // .then(function(request) {

      //   vm.comments_data_notes = request.data.results;
      //   vm.comments_config_receipt = {
      //     count: request.data.count,
      //     previous: request.data.previous,
      //     next: request.data.next
      //   }
      // })
      // .catch(function(e) {
      //   console.log('e', e);
      // });

      // vm.receipt_id = param.id;
      // vm.show_binnacle_notes = true;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_notes = request.data.results;
          vm.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      vm.receipt_id = param.id;
      vm.show_binnacle_notes = true;
    }
    function returnToNotes() {
      vm.show_binnacle_notes = false;
    }
    // recibo endoso
    function showBinnacleReceipt_Endoso(param) {
      $scope.receiptmodel = param.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_receipt_endoso = request.data.results;
          vm.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.receipt_id = param.id;
      vm.show_binnacle_receipt_end = true;
    }
    function returnToReceipts_End() {
      vm.show_binnacle_receipt_end = false;
    }

    function viewCarta(endoso, poliza, carta) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-form/",
        params: {
          id_endoso: endoso,
          id_poliza: poliza,
          id_carta: carta,
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
        // $scope.pdf = response.data;
        // $http({
        //   method: 'GET',
        //   url: url.IP + 'get-pdf',
        //   params: {
        //     'pdf_name': $scope.pdf.pdf_name
        //   },
        //   responseType: 'arraybuffer'

        // }).then(function success(response) {

        //   })
      });
    }

    $scope.goToPolicy = function (id) {
      if (vm.insurance.policy) {
        if (vm.insurance.policy.document_type == 1) {
          $state.go("polizas.info", { polizaId: id });
        } else if (vm.insurance.policy.document_type == 3) {
          $state.go("colectividades.info", { polizaId: id });
        } else if (vm.insurance.policy.document_type == 6) {
          $state.go("colectividades.info", { polizaId: vm.recibosPor.id });
        } else if (vm.insurance.policy.document_type == 7) {
          $state.go("fianzas.info", { polizaId: id });
        } else if (vm.insurance.policy.document_type == 8) {
          $state.go("fianzas.details", { polizaId: id });
        }
      } else if (vm.insurance.policy.document_type == 7) {
        $state.go("fianzas.info", { polizaId: id });
      }
    };

    $scope.deliveredReceipt = function (receipt) {
      SweetAlert.swal(
        {
          title: "Entregado",
          text: "Este recibo se marcara como entregado",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "PATCH",
              url: receipt.url,
              data: {
                delivered: true,
              },
            }).then(function success(response) {
              if (response.status == 200) {
                var params = {
                  model: 4,
                  event: "PATCH",
                  associated_id: response.data.id,
                  identifier: " actualizo el recibo a Entregado ",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {
                    console.log("-------5 recdeliv-----", response);
                  });
                SweetAlert.swal("¡Listo!", "", "success");
                $state.go("endorsement.info", { endosoId: vm.insurance.id });
              }
            });
          }
        }
      );
    };

    $scope.cancelEndorsement = function () {
      SweetAlert.swal(
        {
          title: "¿Estas seguro?",
          text: "Los recibos pendientes se cancelarán.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .patch(vm.insurance.url, { status: 4 })
              .then(function success(response) {
                if (response.status === 200 || response.status === 201) {
                  vm.insurance.endorsement_receipt.forEach(function (recibo) {
                    if (recibo.status == 4) {
                      $http
                        .patch(recibo.url, { status: 2 })
                        .then(function () {});
                    }
                  });
                  if (vm.certificates) {
                    vm.certificates.forEach(function (inciso) {
                      if (inciso.certificate.certificado_inciso_activo) {
                        $http
                          .patch(inciso.certificate.url, {
                            certificado_inciso_activo: false,
                          })
                          .then(function () {});
                      } else {
                        $http
                          .patch(inciso.certificate.url, {
                            certificado_inciso_activo: true,
                          })
                          .then(function () {});
                      }
                    });
                  }
                  vm.patchEndoso = response.data;
                  var paramsE = {
                    model: 10,
                    event: "POST",
                    associated_id: vm.patchEndoso.id,
                    identifier: " canceló el endoso.",
                  };
                  dataFactory.post("send-log", paramsE);
                }
                SweetAlert.swal(
                  "¡Listo!",
                  "El endoso se ha actualizado.",
                  "success"
                );
              });
            swal.close();
            $state.go("endorsement.lista");
          }
        }
      );
    };

    $scope.sendProvider = function (provider) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/aseguradoras/send.modal.html",
        controller: "SendPDFModalCtrl",
        size: "md",
        resolve: {
          provider: function () {
            return provider;
          },
          typeOT: function () {
            return 2;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    $scope.deleteEndorsment = function (endoso) {
      SweetAlert.swal(
        {
          title: "Eliminar endoso",
          text: MESSAGES.WARNING.DELETENDO,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .patch(endoso.url, { status: 0 })
              // $http.patch(endoso.url)
              .then(deletePolicyComplete)
              .catch(deletePolicyFailed);

            function deletePolicyComplete(response, status, headers, config) {
              if (response.status === 200 || response.status === 201) {
                var data_email = {
                  id: endoso.id,
                  model: 1,
                  type_person: 0,
                };
                dataFactory
                  .post("send-email-admins-deletes/", data_email)
                  .then(function success(req) {
                    // console.log('..........emailadmin<.......:::::.....',req)
                  });

                vm.insurance.endorsement_receipt.forEach(function (receipt) {
                  var params = {
                    model: 4,
                    event: "PATCH",
                    associated_id: receipt.id,
                    identifier:
                      " actualizo el recibo a desactivado por eliminación de endoso ",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  $http.patch(receipt.url, { status: 0 });
                });

                if (vm.certificates) {
                  if (vm.certificates.length > 0) {
                    vm.certificates.forEach(function (child) {
                      if (vm.insurance.concept == 24) {
                        // $scope.endoso_baja = true;
                        // console.log('-------------',child)
                        $http
                          .delete(child.certificate.url)
                          .then(function success(response) {});
                      } else {
                        if (endoso.status == 2) {
                          if (
                            child.certificate.certificado_inciso_activo == false
                          ) {
                            $http
                              .patch(child.certificate.url, {
                                certificado_inciso_activo: true,
                              })
                              .then(function success(response) {});
                          } else {
                            $http
                              .patch(child.certificate.url, {
                                certificado_inciso_activo: false,
                              })
                              .then(function success(response) {});
                          }
                        }
                      }
                    });
                  }
                }
                if (endoso.status == 2) {
                  if (vm.certificates) {
                    if (vm.certificates.length > 0) {
                      var params = {
                        model: 10,
                        event: "POST",
                        associated_id: endoso.id,
                        identifier:
                          "eliminó el endoso " + endoso.number_endorsement
                            ? endoso.number_endorsement
                            : "" + " y los certificados asociados",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                    } else {
                      var params = {
                        model: 10,
                        event: "POST",
                        associated_id: endoso.id,
                        identifier: "eliminó el endoso.",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                    }
                  }
                } else {
                  var params = {
                    model: 10,
                    event: "POST",
                    associated_id: endoso.id,
                    identifier: "eliminó el endoso.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                }

                SweetAlert.swal("¡Listo!", MESSAGES.OK.DELETEENDOSO, "success");
                $state.go("endorsement.lista");
              }
            }

            function deletePolicyFailed(response, status, headers, config) {
              return response;
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "El endoso no se ha eliminado",
              "error"
            );
          }
        }
      );
    };
    function getPDF(endoso) {
      var params = {
        poliza: vm.insurance.policy ? vm.insurance.policy.id : 0,
        fianza: vm.insurance.fianza ? vm.insurance.fianza.id : 0,
        endoso: vm.insurance.id,
      };
      dataFactory
        .get("get-pdf-endorsement-new/", params)
        .then(function success(response) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
          $scope.pdf = response.data;
          var par_pdf = {
            pdf_name: $scope.pdf.pdf_name,
          };
          // if ($scope.pdf.pdf_name){
          //   dataFactory.get('get-pdf/',par_pdf)
          //   .then(function success(response) {

          //   })
          // }
        });
    }

    $scope.concept = function (parConcept) {
      if (vm.insurance) {
        if (vm.insurance.policy) {
          switch (parConcept) {
            case 1:
              return "CAMBIO DE FORMA DE PAGO";
              break;
            case 2:
              return "CAMBIO DE SUMA ASEGURADA";
              break;
            case 3:
              return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
              break;
            case 4:
              return "AGREGAR ASEGURADO";
              break;
            case 5:
              return "AGREGAR COBERTURAS";
              break;
            case 6:
              return "DECLARACIÓN MENSUAL";
              break;
            case 8:
              return "CAMBIO DATOS FISCALES";
              break;
            case 9:
              return "ESPECIFICACIONES";
              break;
            case 11:
              return "CAMBIO DE FORMA DE PAGO";
              break;
            case 12:
              return "DISMINUCIÓN EN LA SUMA ASEGURADA";
              break;
            case 13:
              return "BAJA DE COBERTURA";
              break;
            case 14:
              return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
              break;
            case 15:
              return "BAJA DE ASEGURADO";
              break;
            case 16:
              return "CANCELACIÓN DE PÓLIZA POR PETICIÓN";
              break;
            case 17:
              return "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO";
              break;
            case 23:
              return "ANTIGÜEDAD RECONOCIDA";
              break;
            case 24:
              return "ALTA DE ASEGURADOS";
              break;
            case 25:
              return "BAJA DE ASEGURADOS";
              break;
            case 26:
              return "AJUSTE ANUAL (A)";
              break;
            case 27:
              return "RECONOCIMIENTO DE ANTIGUEDAD";
              break;
            case 28:
              return "AJUSTE ANUAL (D)";
              break;
            case 29:
              return "OTRO";
              break;
            case 30:
              return "Declaración";
              break;
            case 31:
              return "Agregar asegurado o dependiente";
              break;
            case 32:
              return "Cancelación";
              break;
            case 33:
              return "CORRECCION DE DATOS";
              break;
            case 34:
              return "CORRECCION DE DATOS BENEFICIARIO";
              break;
            default:
              return "OTRO";
          }
        } else if (vm.insurance.fianza) {
          switch (parConcept) {
            case 1:
              return "AUMENTO MONTO AFIANZADO";
              break;
            case 2:
              return "DECREMENTO MONTO AFIANZADO";
              break;
            case 3:
              return "CAMBIO DE PORCENTAJE DE GARANTÍA";
              break;
            case 5:
              return "CAMBIO DE DATOS";
              break;
            case 4:
              return "OTRO";
              break;
            default:
              return "OTRO";
          }
        }
      }
    };

    $scope.conceptCollectivity = function (parConcept) {
      if (vm.insurance) {
        if (vm.insurance.policy) {
          switch (parConcept) {
            case 41:
              return "ALTA DE UNIDAD";
              break;
            case 42:
              return "AGREGAR COBERTURA";
              break;
            case 43:
              return "CAMBIO DE FORMA DE PAGO";
              break;
            case 44:
              return "AGREGAR CARGA";
              break;
            case 45:
              return "AGREGAR ADAPTACIONES Y CONVERSIONES";
              break;
            case 46:
              return "INCLUIR BP";
              break;
            case 47:
              return "CORREGIR DESCRIPCIÓN";
              break;
            case 48:
              return "AGREGAR TEXTOS ACLARATORIOS";
              break;
            case 49:
              return "ADAPTACIONES SOLO PARA EFECTOS DE RC";
              break;
            case 50:
              return "AGREGAR PLACAS, MOTOR O CORREGIR SERIE";
              break;
            case 51:
              return "CANCELACIONES";
              break;
            case 52:
              return "ELIMINACIÓN DE COBERTURAS";
              break;
            case 31:
              return "Agregar asegurado o dependiente";
              break;
            case 24:
              return "ALTA DE ASEGURADOS";
              break;
            case 25:
              return "BAJA DE ASEGURADOS";
              break;
            case 26:
              return "AJUSTE ANUAL A";
              break;
            case 28:
              return "AJUSTE ANUAL D";
              break;
            case 58:
              return "AUMENTO";
              break;
            default:
              return "OTRO";
          }
        }
      }
    };

    $scope.status = function (parConcept) {
      switch (parConcept) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Registrado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado";
          break;
        case 5:
          return "En trámite";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.statusNotes = function (parStatus) {
      switch (parStatus) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Aplicada";
          break;
        case 3:
          return "Liquidada";
          break;
        case 4:
          return "Cancelada";
          break;
        case 5:
          return "Liquidada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.statusReceipts = function (parStatus) {
      switch (parStatus) {
        case 1:
          return "Pagado";
          break;
        case 2:
          return "Cancelado";
          break;
        case 3:
          return "Prorrogado";
          break;
        case 4:
          return "Pendiente de pago";
          break;
        case 5:
          return "Liquidado";
          break;
        case 6:
          return "Conciliado";
          break;
        case 7:
          return "Cerrado";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.formatCoverage = function (parValue) {
      var res = parValue.replace("$", "");
      if (res) {
        var model = formatValues.currency(res);
        return model;
      } else {
        return "";
      }
    };

    $scope.selectEndoso = function (receipt, parEndoso) {
      $http.patch(receipt.url, { endorsement: parEndoso.url });
    };

    $scope.payform = function (parPayform) {
      if (parPayform) {
        var json = JSON.stringify(eval("(" + parPayform + ")"));
        var parSwitch = JSON.parse(json);
        switch (parSwitch.forma_de_pago) {
          case 1:
            return "Mensual";
            break;
          case 2:
            return "Bimestral";
            break;
          case 3:
            return "Trimestral";
            break;
          case 4:
            return "Cuatrimestral";
            break;
          case 5:
            return "Contado";
            break;
          case 6:
            return "Semestral";
            break;
          case 12:
            return "Anual";
            break;
          case 24:
            return "Quincenal";
            break;
          default:
            return "No especificada";
        }
      }
    };

    $scope.changeStatusModal = function (receipt, contra, insurance) {
      // receipt.contratante = contra.natural ? contra.natural : contra.juridical;
      receipt.contratante = contra.contractor ? contra.contractor : null;
      var modalInstance = $uibModal.open({
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return insurance;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function () {
        $state.go("endorsement.info", { endosoId: vm.insurance.id });
      });
    };

    $scope.NotasModal = function (receipt) {
      var insurance = receipt;
      var modalInstance = $uibModal.open({
        templateUrl: "app/cobranzas/notaCredito.modal.html",
        controller: "NotaCreditoCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return insurance;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        vm.receipts.splice(index, 1);
        activate();
      });
    };

    $scope.changeStatus = function () {
      var modalInstance = $uibModal.open({
        templateUrl: "app/endoso/endosos.status.html",
        controller: EndososPendingModalCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          endosoModal: function () {
            return vm.insurance;
          },
          policy_endorsement: function () {
            return vm.insurance.policy
              ? vm.insurance.policy
              : vm.insurance.fianza;
          },
          form_endorsement: function () {
            return vm.insurance.policy
              ? vm.insurance.policy
              : vm.insurance.fianza;
          },
          certificates: function () {
            return vm.certificates;
          },
          certificates_bd: function () {
            return $scope.certificates;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function () {
        $state.go("endorsement.info", { endosoId: vm.insurance.id });
      });
    };

    $scope.getLog = function () {
      dataFactory
        .get("get-specific-log", { model: 10, associated_id: vm.insurance.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
        });
    };

    $scope.deleteReceipt = function (receipt, index) {
      if (receipt.status == 4) {
        SweetAlert.swal(
          {
            title: "¿Estás seguro?",
            text: "El recibo será eliminado y no se podrá recuperar",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var data_email = {
                id: receipt.id,
                id_poliza: vm.insurance.id,
                model: 1,
                type_person: 0,
              };
              dataFactory
                .post("send-email-admins-deletes/", data_email)
                .then(function success(req) {});
              $http
                .patch(receipt.url, { status: 0 })
                .then(function (recibo_delete) {
                  var paramsDelRec = {
                    model: 10,
                    event: "DELETE",
                    associated_id: vm.insurance.id,
                    identifier:
                      " eliminó un recibo (" +
                      receipt.recibo_numero +
                      ") del endoso.",
                  };
                  vm.endorsement_receipts.splice(index, 1);
                  dataFactory
                    .post("send-log/", paramsDelRec)
                    .then(function success(response) {});
                  SweetAlert.swal(
                    "¡Hecho!",
                    "El recibo ha sido eliminado exitosamente",
                    "success"
                  );
                });
            } else {
              SweetAlert.swal(
                "Cancelado",
                "El recibo no ha sido eliminado",
                "error"
              );
            }
          }
        );
      } else {
        SweetAlert.swal(
          "Advertencia",
          "El recibo no se puede eliminar porque no esta pendiente de pago.",
          "warning"
        );
      }
    };

    $scope.editReceipt = function (receipt, index) {
      if (receipt.status == 4) {
        SweetAlert.swal(
          {
            title: "Advertencia",
            text: "Esta es una alternativa de emergencia, por el momento no se validarán las primas y ni las fechas al editar este recibo. ¿Deseas continuar?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var modalInstance = $uibModal.open({
                templateUrl: "app/colectividades/receipt.modal.html",
                controller: EditReceiptModalCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  recibo: function () {
                    return receipt;
                  },
                  index: function () {
                    return index;
                  },
                  endoso: function () {
                    return vm.insurance;
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });
            } else {
              SweetAlert.swal(
                "Cancelado",
                "El recibo no ha sido actualizado",
                "error"
              );
            }
          }
        );
      } else {
        SweetAlert.swal(
          "Advertencia",
          "El recibo no se puede editar porque no esta pendiente de pago.",
          "warning"
        );
      }
    };

    function EditReceiptModalCtrl(
      url,
      $http,
      $rootScope,
      recibo,
      index,
      endoso,
      $scope,
      $uibModalInstance
    ) {
      var rec = this;
      rec.recibo = recibo;
      rec.recibo.fecha_inicio = convertDate(recibo.fecha_inicio);
      rec.recibo.fecha_fin = convertDate(recibo.fecha_fin);
      rec.recibo.vencimiento = convertDate(recibo.vencimiento);
      // $scope.recibo.sub_total = (parseFloat(recibo.prima_neta) + parseFloat(recibo.rpf) + parseFloat(recibo.derecho)).toFixed(2);

      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          var date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          var date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }

        return date;
      }

      function toDate(dateStr) {
        if (dateStr) {
          var dateString = dateStr; // Oct 23
          var dateParts = dateString.split("/");
          var dateObject = new Date(
            dateParts[2],
            dateParts[1] - 1,
            dateParts[0]
          ); // month is 0-based
          return dateObject;
        }
      }

      $scope.validateDecimal = function (form) {
        form = String(form).replace(/[A-Za-z]/g, "");
        form = String(form).replace(/,/g, "");
        return form;
      };

      $scope.changePrimas = function (data) {
        rec.recibo.sub_total = (
          parseFloat(data.prima_neta) +
          parseFloat(data.rpf) +
          parseFloat(data.derecho)
        ).toFixed(2);
        rec.recibo.prima_total = (
          parseFloat(rec.recibo.sub_total) + parseFloat(data.iva)
        ).toFixed(2);
      };

      $scope.saveReceipt = function (receipt) {
        if (
          process(rec.recibo.fecha_inicio) <
          process(convertDate(endoso.init_date))
        ) {
          SweetAlert.swal(
            "Error",
            "La fecha de inicio del recibo no puede ser menor a la fecha de inicio de la póliza.",
            "error"
          );
          return;
        }

        if (process(rec.recibo.fecha_fin) < process(rec.recibo.fecha_inicio)) {
          SweetAlert.swal(
            "Error",
            "La fecha fin del recibo no puede ser menor a la de su inicio.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        var obj = {
          fecha_inicio: new Date(toDate(receipt.fecha_inicio)),
          fecha_fin: new Date(toDate(receipt.fecha_fin)),
          prima_neta: receipt.prima_neta,
          rpf: receipt.rpf,
          derecho: receipt.derecho,
          iva: receipt.iva,
          prima_total: receipt.prima_total,
          comision: receipt.comision,
          vencimiento: new Date(toDate(receipt.vencimiento)),
          delivered: receipt.delivered,
        };

        $http.patch(receipt.url, obj).then(function (response) {
          var params = {
            model: 10,
            event: "PATCH",
            associated_id: endoso.id,
            identifier: "actualizó el recibo " + receipt.recibo_numero + ".",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          var params = {
            model: 4,
            event: "POST",
            associated_id: receipt.id,
            identifier: "actualizó el recibo.",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          SweetAlert.swal("Listo", "El recibo ha sido actualizado", "success");
          $scope.cancel();
        });
      };
      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.calculatePrima = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        total_comision =
          parseFloat(total_comision) + parseFloat(receipts[i].prima_neta);
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateDerecho = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        total_comision =
          parseFloat(total_comision) + parseFloat(receipts[i].derecho);
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateRpf = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        total_comision =
          parseFloat(total_comision) + parseFloat(receipts[i].rpf);
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateIva = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        total_comision =
          parseFloat(total_comision) + parseFloat(receipts[i].iva);
      }
      return total_comision.toFixed(2);
    };
    $scope.calculateComision = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        total_comision =
          parseFloat(total_comision) + parseFloat(receipts[i].comision);
      }
      return total_comision.toFixed(2);
    };
    $scope.calculatePrimaTotal = function (receipts) {
      var total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        total_comision =
          parseFloat(total_comision) + parseFloat(receipts[i].prima_total);
      }
      return total_comision.toFixed(2);
    };

    // MODAL ENDOSOS
    function EndososPendingModalCtrl(
      $scope,
      endorsement,
      endosoModal,
      FileUploader,
      $sessionStorage,
      url,
      policy_endorsement,
      form_endorsement,
      helpers,
      datesFactory,
      notesFactory,
      $state,
      $uibModalInstance,
      $timeout,
      SweetAlert,
      MESSAGES,
      certificates,
      certificates_bd
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);

      /* Uploader files */
      $scope.userInfo = {
        id: 0,
      };
      $scope.countFile = 0;
      $scope.okFile = 0;
      vmm.accesos = $sessionStorage.permisos;
      vmm.accesos.forEach(function (acceso) {
        if (acceso.model_name == "Endosos") {
          vmm.acceso_endosos = acceso;
          vmm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vmm.acceso_reg_end = true;
              } else {
                vmm.acceso_reg_end = false;
              }
            }
          });
        } else if (acceso.model_name == "Ordenes de trabajo") {
          vmm.acceso_ots = acceso;
          vmm.acceso_ots.permissions.forEach(function (acc) {
            if (acc.permission_name == "Tablero de OTs") {
              if (acc.checked == true) {
                vmm.acceso_tab = true;
              } else {
                vmm.acceso_tab = false;
              }
            }
          });
        }
      });

      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      //     name: 'customFilter',
      //     fn: function(item, options) {
      //         return this.queue.length < 20;
      //     }
      // });
      $scope.checkNumEndoso = function (poliza) {
        if (poliza) {
          if (poliza.poliza_number) {
            var npoliza = poliza.poliza_number;
          }
          if (poliza.fianza_number) {
            var npoliza = poliza.fianza_number;
          }
        }
        if (vmm.number_endorsement) {
          dataFactory
            .get("exist-number-endorsement/", {
              number: vmm.number_endorsement,
              poliza: npoliza,
            })
            .then(function (request) {
              if (request.data.status == true) {
                SweetAlert.swal("Error", "Número de Endoso existente", "error");
                vmm.number_endorsement = "";
              }
            })
            .catch(function (err) {});
        }
      };
      $scope.coberturas = [2, 3, 5, 19, 12, 13, 14, 21];
      $scope.asegurado = [4, 20, 8, 15, 22];
      vmm.num_receipts_data = [
        { name: 1, value: 12 },
        { name: 2, value: 6 },
        { name: 3, value: 4 },
        { name: 4, value: 3 },
        { name: 5, value: 5.5 },
        { name: 6, value: 2 },
        { name: 7, value: 7 },
        { name: 8, value: 8 },
        { name: 9, value: 9 },
        { name: 10, value: 10 },
        { name: 11, value: 11 },
        { name: 12, value: 1 },
      ];

      vmm.num_notes_data = [
        { name: 1, value: 1 },
        { name: 2, value: 2 },
        { name: 3, value: 3 },
        { name: 4, value: 4 },
        { name: 5, value: 5 },
        { name: 6, value: 6 },
        { name: 7, value: 7 },
        { name: 8, value: 9 },
        { name: 10, value: 10 },
        { name: 11, value: 11 },
        { name: 12, value: 12 },
      ];

      $scope.numberReceipts = function () {
        if (policy_endorsement.administration_type) {
          if (policy_endorsement.administration_type == 2) {
            vmm.num_receipts_data = [{ name: 0, value: 0 }];
            if (vmm.form) {
              vmm.form.num_receipts = 0;
            }

            vmm.num_notes_data = [{ name: 0, value: 0 }];
            if (vmm.infoNote) {
              vmm.infoNote.num_notas = 0;
            }
          }
        }
      };

      vmm.status = endorsement;
      $scope.endoso = endosoModal;
      vmm.form = form_endorsement;
      vmm.form.type = "INDIVIDUAL";

      // console.log('aaa', vmm.form);
      vmm.form.policy_starting_date = angular.copy(vmm.form.start_of_validity);
      if (vmm.form.afianzadora) {
        vmm.form.tipo_endoso = 2;
      } else if (vmm.form.aseguradora) {
        vmm.form.tipo_endoso = 1;
      }
      // vmm.form.start_of_validity = datesFactory.convertDate($scope.endoso.init_date);
      vmm.policy = policy_endorsement;
      vmm.policy.end_date = datesFactory.convertDate($scope.endoso.end_date);
      vmm.policy.init_date = datesFactory.convertDate($scope.endoso.init_date);
      vmm.backupPolicy = angular.copy(policy_endorsement);
      vmm.infoReceipt = {};
      vmm.certificates = certificates;
      vmm.infoNote = {
        fecha_emision: datesFactory.convertDate(new Date()),
        fecha_vigencia: datesFactory.convertDate(new Date()),
      };
      if ($scope.endoso.endorsement_type == "A") {
        vmm.createdNote = true;
      }
      $scope.status = function (parConcept) {
        switch (parConcept) {
          case 1:
            return "Pendiente";
            break;
          case 2:
            return "Registrado";
            break;
          case 3:
            return "Rechazado";
            break;
          case 4:
            return "Cancelado";
            break;
          case 5:
            return "En trámite";
            break;
          default:
            return "Pendiente";
        }
      };
      if (!vmm.acceso_reg_end) {
        vmm.status = [
          { value: 1, label: "PENDIENTE" },
          { value: 3, label: "RECHAZADO" },
          { value: 4, label: "CANCELADO" },
          { value: 5, label: "EN TRÁMITE" }, //
        ];
      }

      $scope.rejectEndorsement = function () {
        $http
          .patch($scope.endoso.url, { status: vmm.selectedType.value })
          .then(function success(response) {
            if (response.status === 200 || response.status === 201) {
              vm.patchEndoso = response.data;
              if (vmm.selectedType.value == 3) {
                var parIdentifier = "rechazó el endoso.";
              } else if (vmm.selectedType.value == 4) {
                var parIdentifier = "canceló el endoso.";
              } else {
                var parIdentifier = " modifico endoso";
              }
              var paramsE = {
                model: 10,
                event: "POST",
                associated_id: vm.patchEndoso.id,
                identifier: parIdentifier,
              };
              dataFactory.post("send-log", paramsE);
            }
          });
        $uibModalInstance.dismiss("cancel");
        $state.go("endorsement.lista");
      };

      $scope.calculateIVA = function () {
        var p_neta = vmm.infoNote.p_neta ? parseFloat(vmm.infoNote.p_neta) : 0;
        var rpf = vmm.infoNote.rpf ? parseFloat(vmm.infoNote.rpf) : 0;
        var derecho = vmm.infoNote.derecho
          ? parseFloat(vmm.infoNote.derecho)
          : 0;
        if (vmm.policy.subramo.subramo_name == "Vida") {
          var iva = 0;
          vmm.infoNote.iva = 0;
        } else {
          vmm.infoNote.iva = (
            (parseFloat(p_neta) + parseFloat(rpf) + parseFloat(derecho)) *
            0.16
          ).toFixed(2);
          var iva = vmm.infoNote.iva
            ? parseFloat(vmm.infoNote.iva).toFixed(2)
            : 0;
        }

        var gastos = vmm.infoNote.gastos_expedicion
          ? parseFloat(vmm.infoNote.gastos_expedicion)
          : 0;
        vmm.infoNote.p_total = parseFloat(
          p_neta + rpf + parseFloat(iva) + gastos
        ).toFixed(2);
        vmm.infoNote.p_total = vmm.infoNote.p_total;
      };

      $scope.calculatePT = function () {
        var p_neta = vmm.infoNote.p_neta ? parseFloat(vmm.infoNote.p_neta) : 0;
        var rpf = vmm.infoNote.rpf ? parseFloat(vmm.infoNote.rpf) : 0;
        var iva = vmm.infoNote.iva ? parseFloat(vmm.infoNote.iva) : 0;

        var gastos = vmm.infoNote.gastos_expedicion
          ? parseFloat(vmm.infoNote.gastos_expedicion)
          : 0;
        vmm.infoNote.p_total = parseFloat(
          p_neta + rpf + parseFloat(iva) + gastos
        ).toFixed(2);
        vmm.infoNote.p_total = vmm.infoNote.p_total;
      };
      vmm.certificates_bd = certificates_bd;

      $scope.registerEndorsement = function () {
        $scope.deshabilitar = true;
        if (vmm.form.num_receipts) {
          if (vmm.infoReceipt) {
            if (!vmm.infoReceipt.receipts) {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.RECEIPTSREQUIRED,
                "error"
              );
              $scope.deshabilitar = false;
              return;
            }
          }
          for (var i = 0; i < vmm.infoReceipt.receipts.length; i++) {
            if (
              (vmm.infoReceipt.receipts[i].startDate =
                "" || vmm.infoReceipt.receipts[i].endingDate == "")
            ) {
              SweetAlert.swal("Error", MESSAGES.INFO.MANUALLYDATES, "error");
              vmm.editNotes = true;
              $scope.showInput = true;
              $scope.editedReceipts = true;
              $scope.deshabilitar = false;
              return;
            }
          }
        }
        // console.log('--vmm.form.num_receipts',vmm.form.num_receipts,vmm.form,$scope.dataToPatch,vmm.infoNote)
        if (vmm.form.num_receipts != 0) {
          $scope.dataToPatch = {
            p_neta: vmm.infoReceipt.p_neta
              ? vmm.infoReceipt.p_neta
              : -vmm.infoNote.p_neta,
            rpf: vmm.infoReceipt.rpf ? vmm.infoReceipt.rpf : -vmm.infoNote.rpf,
            derecho: vmm.infoReceipt.derecho ? vmm.infoReceipt.derecho : 0,
            iva: vmm.infoReceipt.iva ? vmm.infoReceipt.iva : -vmm.infoNote.iva,
            p_total: vmm.infoReceipt.p_total
              ? vmm.infoReceipt.p_total
              : -vmm.infoNote.p_total,
            status: 2,
            number_endorsement: vmm.number_endorsement,
          };
          $scope.dataToPatch.comision = (
            parseFloat($scope.dataToPatch.p_neta) *
            (parseFloat(vmm.policy.comision_percent) / 100)
          ).toFixed(2);
          $scope.dataToPatch.comision_percent = vmm.policy.comision_percent;

          if (isNaN($scope.dataToPatch.comision)) {
            $scope.dataToPatch.comision = 0;
          }
        } else {
          $scope.dataToPatch = {
            p_neta: 0,
            rpf: 0,
            derecho: 0,
            iva: 0,
            p_total: 0,
            status: 2,
            number_endorsement: vmm.number_endorsement,
          };
          $scope.dataToPatch.comision = 0;
          $scope.dataToPatch.comision_percent = 0;
        }

        if (vmm.form.num_notas != 0) {
          $scope.dataToPatch = {
            p_neta: vmm.infoReceipt.p_neta
              ? vmm.infoReceipt.p_neta
              : -vmm.infoNote.p_neta,
            rpf: vmm.infoReceipt.rpf ? vmm.infoReceipt.rpf : -vmm.infoNote.rpf,
            derecho: vmm.infoReceipt.derecho
              ? vmm.infoReceipt.derecho
              : -vmm.infoNote.gastos_expedicion,
            iva: vmm.infoReceipt.iva ? vmm.infoReceipt.iva : -vmm.infoNote.iva,
            p_total: vmm.infoReceipt.p_total
              ? vmm.infoReceipt.p_total
              : -vmm.infoNote.p_total,
            status: 2,
            number_endorsement: vmm.number_endorsement,
          };
          $scope.dataToPatch.comision = (
            parseFloat($scope.dataToPatch.p_neta) *
            (parseFloat(vmm.policy.comision_percent) / 100)
          ).toFixed(2);
          $scope.dataToPatch.comision_percent = vmm.policy.comision_percent;

          if (isNaN($scope.dataToPatch.comision)) {
            $scope.dataToPatch.comision = 0;
          }
        } else {
          $scope.dataToPatch = {
            p_neta: 0,
            rpf: 0,
            derecho: 0,
            iva: 0,
            p_total: 0,
            status: 2,
            number_endorsement: vmm.number_endorsement,
          };
          $scope.dataToPatch.comision = 0;
          $scope.dataToPatch.comision_percent = 0;
        }

        /* Objeto original en la póliza*/
        if (
          $scope.endoso.concept == 1 ||
          $scope.endoso.concept == 11 ||
          $scope.endoso.concept == 43
        ) {
          $scope.dataToPatch.original = {
            forma_de_pago: vmm.policy.forma_de_pago,
          };
        } else if ($scope.endoso.concept == 16 || $scope.endoso.concept == 17) {
          $scope.dataToPatch.original = { status: vmm.policy.status };
        } else if ($scope.asegurado.indexOf($scope.endoso.concept) >= 0) {
          if (vmm.policy) {
            if (vmm.policy.automobiles_policy) {
              if (vmm.policy.automobiles_policy.length) {
                $scope.dataToPatch.original = vmm.policy.automobiles_policy;
              }
            } else if (vmm.policy.accidents_policy) {
              if (vmm.policy.accidents_policy.length) {
                $scope.dataToPatch.original = vmm.policy.accidents_policy;
              }
            } else if (vmm.policy.damages_policy) {
              if (vmm.policy.damages_policy.length) {
                $scope.dataToPatch.original = vmm.policy.damages_policy;
              }
            } else if (vmm.policy.life_policy) {
              if (vmm.policy.life_policy.length) {
                $scope.dataToPatch.original = vmm.policy.life_policy;
              }
            }
          }
        }
        $scope.dataToPatch.endorsement_receipt = [];
        // $scope.dataToPatch.status = 5
        $http
          .patch($scope.endoso.url, $scope.dataToPatch)
          .then(function success(response) {
            $scope.deshabilitar = false;
            vm.patchEndoso = response.data;
            if (
              helpers.isResponseOk(response.status) &&
              !vm.patchEndoso.migrated
            ) {
              var paramsE = {
                model: 10,
                event: "POST",
                associated_id: vm.patchEndoso.id,
                identifier: "registró el endoso",
              };
              dataFactory.post("send-log", paramsE);

              if ($scope.countFile > 0) {
                uploadFiles(vm.patchEndoso.id);
              }
              // if ($scope.endoso.endorsement_type == 'B' && $scope.endoso.concept == 24) {
              //   $uibModalInstance.dismiss('cancel');
              //   SweetAlert.swal("¡Listo!", MESSAGES.OK.REGISTERENDOSO, "success");
              //   $state.go('endorsement.info', {endosoId: vm.patchEndoso.id});
              // }
              /* Cambio de forma de pago */
              if (
                $scope.endoso.endorsement_type == "D" &&
                $scope.endoso.fianza
              ) {
                postRecibosNotas(
                  vmm.credit_notes,
                  vmm.infoNote,
                  vmm.policy,
                  vm.patchEndoso
                );
              } else if (
                $scope.endoso.endorsement_type == "A" &&
                $scope.endoso.fianza
              ) {
                postRecibos(vm.patchEndoso, vmm.backupPolicy);
              } else if (
                $scope.endoso.concept == 1 ||
                $scope.endoso.concept == 11 ||
                $scope.endoso.concept == 43
              ) {
                var json = JSON.stringify(
                  eval(
                    "(" +
                      $scope.endoso.change
                        .replace("None", "''")
                        .replace("True", "true") +
                      ")"
                  )
                );
                var data = JSON.parse(json);
                $http
                  .patch(vmm.policy.url, data)
                  .then(function success(response) {
                    if (helpers.isResponseOk(response.status)) {
                      vmm.backupPolicy.recibos_poliza.forEach(function (
                        receipt
                      ) {
                        if (receipt.receipt_type == 1) {
                          $http.delete(receipt.url);
                        }
                      });
                      if (vm.patchEndoso.endorsement_type == "A") {
                        postRecibos(vm.patchEndoso, vmm.backupPolicy);
                      } else if (vm.patchEndoso.endorsement_type == "D") {
                        postRecibosNotas(
                          vmm.credit_notes,
                          vmm.infoNote,
                          vmm.policy,
                          vm.patchEndoso
                        );
                      } else {
                        $uibModalInstance.dismiss("cancel");
                        SweetAlert.swal(
                          "¡Listo!",
                          MESSAGES.OK.REGISTERENDOSO,
                          "success"
                        );
                        $state.go("endorsement.info", {
                          endosoId: vm.patchEndoso.id,
                        });
                      }
                    }
                  });

                /* Reconocimiento de Antigüedad */
              } else if ($scope.endoso.concept == 27) {
                var json = JSON.stringify(
                  eval("(" + $scope.endoso.change + ")")
                );
                var data = JSON.parse(json);
                // $scope.data.change = {fecha_antiguedad: $scope.antiguedad,certificado: $scope.certificate_to_antig}
                if (data.certificado) {
                  $http
                    .patch(data.certificado.url, data)
                    .then(function success(response) {});
                } else {
                  $http
                    .patch(vmm.policy.url, data)
                    .then(function success(response) {});
                }
                if ($scope.endoso.endorsement_type == "A") {
                  postRecibos(vm.patchEndoso, vmm.backupPolicy);
                } else {
                  postRecibosNotas(
                    vmm.credit_notes,
                    vmm.infoNote,
                    vmm.policy,
                    vm.patchEndoso
                  );
                }

                /* Cancelación */
              } else if (
                $scope.endoso.concept == 16 ||
                $scope.endoso.concept == 17
              ) {
                var json = JSON.stringify(
                  eval("(" + $scope.endoso.change + ")")
                );
                var data = JSON.parse(json);
                $http
                  .patch(vmm.policy.url, data)
                  .then(function success(response) {
                    vmm.backupPolicy.recibos_poliza.forEach(function (recibo) {
                      if (
                        recibo.status != 1 &&
                        recibo.status != 5 &&
                        recibo.status != 6
                      ) {
                        $http.patch(recibo.url, { status: 2 });
                      }
                    });
                    postRecibosNotas(
                      vmm.credit_notes,
                      vmm.infoNote,
                      vmm.policy,
                      vm.patchEndoso
                    );
                  });

                /* Cambio en las coberturas*/
              } else if (
                $scope.coberturas.indexOf($scope.endoso.concept) >= 0
              ) {
                var None = "";
                var True = true;
                var json = JSON.stringify(
                  eval("(" + $scope.endoso.change + ")")
                );
                vmm.coverages = JSON.parse(json);
                if (vmm.coverages && !$scope.endoso.fianza) {
                  vmm.coverages.forEach(function (cobertura) {
                    if ($scope.endoso.concept == 13) {
                      $http.delete(cobertura.url);
                    } else {
                      if (cobertura.owner) {
                        $http.patch(cobertura.url, cobertura);
                      } else {
                        cobertura.policy = vmm.policy.url;
                        dataFactory.post("coberturas-polizas/", cobertura);
                      }
                    }
                  });
                }
                if ($scope.endoso.endorsement_type == "A") {
                  postRecibos(vm.patchEndoso, vmm.backupPolicy);
                } else if ($scope.endoso.endorsement_type == "D") {
                  postRecibosNotas(
                    vmm.credit_notes,
                    vmm.infoNote,
                    vmm.policy,
                    vm.patchEndoso
                  );
                } else {
                  $uibModalInstance.dismiss("cancel");
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.REGISTERENDOSO,
                    "success"
                  );
                  $state.go("endorsement.info", {
                    endosoId: vm.patchEndoso.id,
                  });
                }

                /* Cambio en asegurado */
              } else if (
                $scope.endoso.endorsement_type == "A" &&
                $scope.endoso.concept == 31
              ) {
                // $scope.dataToPatch.original = vmm.policy.accidents_policy;
                vmm.certificates_bd.forEach(function (relationship) {
                  if (relationship.is_active == false) {
                    if (
                      relationship.is_active == false &&
                      relationship.endorsement == $scope.endoso.url
                    ) {
                      $http
                        .patch(relationship.url, { is_active: true })
                        .then(function (data) {});
                    }
                  }
                });
                postRecibos(vm.patchEndoso, vmm.backupPolicy);
              } else if ($scope.asegurado.indexOf($scope.endoso.concept) >= 0) {
                if (
                  $scope.endoso.concept == 4 &&
                  vm.patchEndoso.endorsement_type != "D"
                ) {
                  if (
                    $scope.endoso.concept == 4 &&
                    vm.patchEndoso.endorsement_type != "D"
                  ) {
                    var None = "";
                    var True = true;
                    var json = JSON.stringify(
                      eval("(" + $scope.endoso.change + ")")
                    );
                    if (vmm.policy.accidents_policy) {
                      if (vmm.policy.accidents_policy.length) {
                        vmm.newRelationship = JSON.parse(json);
                        vmm.newRelationship.forEach(function (asegurado) {
                          asegurado.accident =
                            vmm.policy.accidents_policy[0].url;
                          asegurado.birthdate = new Date(
                            datesFactory.toDate(asegurado.birthdate)
                          );
                          dataFactory.post("v1/relationships/", asegurado);
                        });
                      } else if (vmm.policy.life_policy.length) {
                        vmm.newBeneficiaries = JSON.parse(json);
                        vmm.newBeneficiaries.forEach(function (asegurado) {
                          asegurado.life = vmm.policy.life_policy[0].url;
                          asegurado.birthdate = new Date(
                            datesFactory.toDate(asegurado.birthdate)
                          );
                          dataFactory.post("v1/beneficiaries/", asegurado);
                        });
                      }
                    }
                    postRecibos(vm.patchEndoso, vmm.backupPolicy);
                  }
                } else if (
                  $scope.endoso.concept == 20 ||
                  $scope.endoso.concept == 8 ||
                  $scope.endoso.concept == 22
                ) {
                  var None = "";
                  var True = true;
                  var False = false;
                  var json = JSON.stringify(
                    eval("(" + $scope.endoso.change + ")")
                  );
                  vmm.subforms = JSON.parse(json);
                  if (vmm.policy.accidents_policy.length) {
                    vmm.subforms.personal.birthdate = new Date(
                      datesFactory.toDate(vmm.subforms.personal.birthdate)
                    );
                    vmm.subforms.personal.salary = 0;
                    vmm.subforms.personal.sum_assured = 0;
                    $http.patch(
                      vmm.subforms.personal.url,
                      vmm.subforms.personal
                    );
                    vmm.subforms.relationship_accident.forEach(function (
                      asegurado
                    ) {
                      asegurado.birthdate = new Date(
                        datesFactory.toDate(asegurado.birthdate)
                      );
                      $http.patch(asegurado.url, asegurado);
                    });
                  } else if (vmm.policy.automobiles_policy) {
                    if (vmm.policy.automobiles_policy.length) {
                      $http.patch(vm.subforms.url, vm.subforms);
                    }
                  } else if (vmm.policy.damages_policy) {
                    if (vmm.policy.damages_policy.length) {
                      $http.patch(vm.subforms.url, vm.subforms);
                    }
                  } else if (vmm.policy.life_policy) {
                    if (vmm.policy.life_policy.length) {
                      vmm.subforms.personal.birthdate = new Date(
                        datesFactory.toDate(vmm.subforms.personal.birthdate)
                      );
                      vmm.subforms.personal.salary = 0;
                      vmm.subforms.personal.sum_assured = 0;
                      $http.patch(
                        vmm.subforms.personal.url,
                        vmm.subforms.personal
                      );
                      vmm.subforms.beneficiaries_life.forEach(function (
                        asegurado
                      ) {
                        asegurado.birthdate = new Date(
                          datesFactory.toDate(asegurado.birthdate)
                        );
                        $http.patch(asegurado.url, asegurado);
                      });
                    }
                  }

                  if ($scope.endoso.endorsement_type == "A") {
                    postRecibos(vm.patchEndoso, vmm.backupPolicy);
                  } else if ($scope.endoso.endorsement_type == "D") {
                    postRecibosNotas(
                      vmm.credit_notes,
                      vmm.infoNote,
                      vmm.policy,
                      vm.patchEndoso
                    );
                  } else {
                    $uibModalInstance.dismiss("cancel");
                    SweetAlert.swal(
                      "¡Listo!",
                      MESSAGES.OK.REGISTERENDOSO,
                      "success"
                    );
                    $state.go("endorsement.info", {
                      endosoId: vm.patchEndoso.id,
                    });
                  }
                } else if ($scope.endoso.concept == 15) {
                  var None = "";
                  var True = true;
                  if (vmm.policy.accidents_policy) {
                    try {
                      var json = JSON.stringify(
                        eval("(" + $scope.endoso.change + ")")
                      );
                      vmm.toDelRelationship = JSON.parse(json);
                      if (vmm.toDelRelationship) {
                        vmm.toDelRelationship.forEach(function (asegurado) {
                          $http.delete(asegurado.url);
                        });
                      }
                    } catch (err) {
                      console.log("catch");
                    }
                  } else if (vmm.policy.life_policy) {
                    var json = JSON.stringify(
                      eval("(" + $scope.endoso.change + ")")
                    );
                    vmm.toDelBeneficiarie = JSON.parse(json);
                    if (vmm.toDelBeneficiarie) {
                      vmm.toDelBeneficiarie.forEach(function (asegurado) {
                        $http.delete(asegurado.url);
                      });
                    }
                  }
                  postRecibosNotas(
                    vmm.credit_notes,
                    vmm.infoNote,
                    vmm.policy,
                    vm.patchEndoso
                  );
                }
              } else if (
                vm.insurance.concept == 24 ||
                vm.insurance.concept == 25
              ) {
                if ($scope.endoso.endorsement_type == "A") {
                  vmm.certificates.forEach(function (certificado) {
                    var data = {
                      certificate: certificado.certificate.id,
                      certificate_number:
                        certificado.certificate.certificate_number_patch,
                    };
                    dataFactory.post("activate-cert", data);
                    var datab = { is_active: true };
                    if (vmm.policy.subramo.subramo_code == 3) {
                      if (certificado.certificate.accidents_policy.length > 0) {
                        if (
                          certificado.certificate.accidents_policy[0]
                            .relationship_accident.length > 0
                        ) {
                          certificado.certificate.accidents_policy[0].relationship_accident.forEach(
                            function (relas) {
                              if (relas.endorsement == vm.patchEndoso.url) {
                                if (relas.is_active == false) {
                                  $http
                                    .patch(relas.url, datab)
                                    .then(function (dataBen) {
                                      console.log(
                                        "-------alta--B-dependiente accidente-",
                                        dataBen
                                      );
                                    });
                                }
                              }
                            }
                          );
                        }
                      }
                    } else if (vmm.policy.subramo.subramo_code == 1) {
                      if (certificado.certificate.life_policy.length > 0) {
                        if (
                          certificado.certificate.life_policy[0]
                            .beneficiaries_life.length > 0
                        ) {
                          certificado.certificate.life_policy[0].beneficiaries_life.forEach(
                            function (relas) {
                              if (relas.endorsement == vm.patchEndoso.url) {
                                if (relas.is_active == false) {
                                  $http
                                    .patch(relas.url, datab)
                                    .then(function (dataBen) {
                                      console.log(
                                        "-------alta--B-beneficirio vida-",
                                        dataBen
                                      );
                                    });
                                }
                              }
                            }
                          );
                        }
                      }
                    }
                  });
                  postRecibos(vm.patchEndoso, vmm.backupPolicy);
                } else if ($scope.endoso.endorsement_type == "D") {
                  dataFactory
                    .get("endorsement-certs/", { id_endoso: vm.patchEndoso.id })
                    .then(function success(response) {
                      if (response.data.results.length) {
                        response.data.results.forEach(function (certificado) {
                          var data = {
                            certificado_inciso_activo: false,
                          };
                          $http
                            .patch(certificado.certificate.url, data)
                            .then(function (data) {
                              console.log("-------baja--D--", data);
                            });
                        });
                      }
                      var datab = { is_active: false };
                      if (vm.insurance.concept == 25) {
                        if (vmm.policy.subramo.subramo_code == 3) {
                          var data = {
                            id_endoso: vm.patchEndoso.id,
                          };
                          dataFactory
                            .post("relationDependiente/", data)
                            .then(function success(responseRel) {
                              responseRel.data.forEach(function (relas) {
                                if (relas.endorsement == vm.patchEndoso.url) {
                                  if (relas.is_active == true) {
                                    $http
                                      .patch(relas.url, datab)
                                      .then(function (dataBen) {
                                        console.log(
                                          "-------baja--B-dependiente accidente-",
                                          dataBen
                                        );
                                      });
                                  }
                                }
                              });
                            });
                        } else if (vmm.policy.subramo.subramo_code == 1) {
                          // dataFactory.get('get-relationBeneficiarios/', {id_endoso: vm.patchEndoso.id})
                          var data = {
                            id_endoso: vm.patchEndoso.id,
                          };
                          dataFactory
                            .post("relationBeneficiarios/", data)
                            .then(function success(responseRel) {
                              responseRel.data.forEach(function (relas) {
                                if (relas.endorsement == vm.patchEndoso.url) {
                                  if (relas.is_active == true) {
                                    $http
                                      .patch(relas.url, datab)
                                      .then(function (dataBen) {
                                        console.log(
                                          "-------baja--D benefnicairio baja-",
                                          dataBen
                                        );
                                      });
                                  }
                                }
                              });
                            });
                        }
                      }
                    });
                  postRecibosNotas(
                    vmm.credit_notes,
                    vmm.infoNote,
                    vmm.policy,
                    vm.patchEndoso
                  );
                } else if (
                  $scope.endoso.endorsement_type == "B" &&
                  vm.insurance.concept == 24
                ) {
                  dataFactory
                    .get("endorsement-certs/", { id_endoso: vm.patchEndoso.id })
                    .then(function success(response) {
                      if (response.data.results.length) {
                        response.data.results.forEach(function (certificado) {
                          var data = {
                            certificado_inciso_activo: true,
                          };
                          // $http.patch(certificado.certificate, data);
                          $http
                            .patch(certificado.certificate.url, data)
                            .then(function (data) {
                              // console.log('-----------',data)
                              var datab = { is_active: true };
                              if (vmm.policy.subramo.subramo_code == 3) {
                                if (
                                  certificado.certificate.accidents_policy
                                    .length > 0
                                ) {
                                  if (
                                    certificado.certificate.accidents_policy[0]
                                      .relationship_accident.length > 0
                                  ) {
                                    certificado.certificate.accidents_policy[0].relationship_accident.forEach(
                                      function (relas) {
                                        if (
                                          relas.endorsement ==
                                          vm.patchEndoso.url
                                        ) {
                                          if (relas.is_active == false) {
                                            $http
                                              .patch(relas.url, datab)
                                              .then(function (dataBen) {
                                                console.log(
                                                  "-------alta--B-dependiente accidente-",
                                                  dataBen
                                                );
                                              });
                                          }
                                        }
                                      }
                                    );
                                  }
                                }
                              } else if (vmm.policy.subramo.subramo_code == 1) {
                                if (
                                  certificado.certificate.life_policy.length > 0
                                ) {
                                  if (
                                    certificado.certificate.life_policy[0]
                                      .beneficiaries_life.length > 0
                                  ) {
                                    certificado.certificate.life_policy[0].beneficiaries_life.forEach(
                                      function (relas) {
                                        if (
                                          relas.endorsement ==
                                          vm.patchEndoso.url
                                        ) {
                                          if (relas.is_active == false) {
                                            $http
                                              .patch(relas.url, datab)
                                              .then(function (dataBen) {
                                                console.log(
                                                  "-------alta--B-beneficirio vida-",
                                                  dataBen
                                                );
                                              });
                                          }
                                        }
                                      }
                                    );
                                  }
                                }
                              }
                            });
                        });
                      }
                    });
                  activate();
                  $uibModalInstance.dismiss("cancel");
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.REGISTERENDOSO,
                    "success"
                  );
                  $state.go("endorsement.info", {
                    endosoId: vm.patchEndoso.id,
                  });
                } else if (
                  $scope.endoso.endorsement_type == "B" &&
                  vm.insurance.concept == 25
                ) {
                  dataFactory
                    .get("endorsement-certs/", { id_endoso: vm.patchEndoso.id })
                    .then(function success(response) {
                      if (response.data.results.length) {
                        response.data.results.forEach(function (certificado) {
                          var data = {
                            certificado_inciso_activo: false,
                          };
                          // $http.patch(certificado.certificate, data);
                          $http
                            .patch(certificado.certificate.url, data)
                            .then(function (data) {
                              // console.log('-----------',data)
                            });
                        });
                      }
                      // get bajas solo dependiente o beneficiario
                      if (response.data.results.length == 0) {
                        var datab = { is_active: false };
                        if (vm.insurance.concept == 25) {
                          if (vmm.policy.subramo.subramo_code == 3) {
                            var data = {
                              id_endoso: vm.patchEndoso.id,
                            };
                            dataFactory
                              .post("relationDependiente/", data)
                              .then(function success(responseRel) {
                                responseRel.data.forEach(function (relas) {
                                  if (relas.endorsement == vm.patchEndoso.url) {
                                    if (relas.is_active == true) {
                                      $http
                                        .patch(relas.url, datab)
                                        .then(function (dataBen) {
                                          console.log(
                                            "-------baja--D benefnicairio baja-",
                                            dataBen
                                          );
                                        });
                                    }
                                  }
                                });
                              });
                          } else if (vmm.policy.subramo.subramo_code == 1) {
                            var data = {
                              id_endoso: vm.patchEndoso.id,
                            };
                            dataFactory
                              .post("relationBeneficiarios/", data)
                              .then(function success(responseRel) {
                                console.log("------relats", responseRel);
                                responseRel.data.forEach(function (relas) {
                                  if (relas.endorsement == vm.patchEndoso.url) {
                                    if (relas.is_active == true) {
                                      $http
                                        .patch(relas.url, datab)
                                        .then(function (dataBen) {
                                          console.log(
                                            "-------baja--D benefnicairio baja-",
                                            dataBen
                                          );
                                        });
                                    }
                                  }
                                });
                              });
                          }
                        }
                      }
                    });
                  activate();
                  $uibModalInstance.dismiss("cancel");
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.REGISTERENDOSO,
                    "success"
                  );
                  $state.go("endorsement.info", {
                    endosoId: vm.patchEndoso.id,
                  });
                }
              } else {
                if ($scope.endoso.endorsement_type == "A") {
                  postRecibos(vm.patchEndoso, vmm.backupPolicy);
                } else if ($scope.endoso.endorsement_type == "D") {
                  postRecibosNotas(
                    vmm.credit_notes,
                    vmm.infoNote,
                    vmm.policy,
                    vm.patchEndoso
                  );
                } else {
                  // $uibModalInstance.dismiss('cancel');
                  activate();
                  $uibModalInstance.dismiss("cancel");
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.REGISTERENDOSO,
                    "success"
                  );
                  // $state.go('endorsement.info', {endosoId: vm.patchEndoso.id});
                }
              }
            } else if (
              helpers.isResponseOk(response.status) &&
              vm.patchEndoso.migrated
            ) {
              if (vm.patchEndoso.endorsement_type == "A") {
                postRecibos(vm.patchEndoso, vmm.backupPolicy);
              } else if (vm.patchEndoso.endorsement_type == "D") {
                postRecibosNotas(
                  vmm.credit_notes,
                  vmm.infoNote,
                  vmm.policy,
                  vm.patchEndoso
                );
              } else {
                $uibModalInstance.dismiss("cancel");
                $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
              }
            } else {
              $scope.deshabilitar = false;
              $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
            }
          });
      };

      /* Guarda recibos */
      function postRecibos(endoso, policy) {
        if (vmm.form.num_receipts != 0) {
          if (vmm.infoReceipt.recibos_poliza) {
            var paramsE = {
              model: 10,
              event: "POST",
              associated_id: endoso.id,
              identifier:
                "creó " +
                vmm.infoReceipt.recibos_poliza.length +
                " recibos de endoso.",
            };
          }
          dataFactory.post("send-log", paramsE);
          if (!vm.patchEndoso.fianza) {
            $scope.is_cat = false;
            if (policy) {
              if (policy.recibos_poliza) {
                if (policy.recibos_poliza.length > 0) {
                  $scope.is_cat = policy.recibos_poliza[0].is_cat;
                } else {
                  $scope.is_cat = false;
                }
              } else {
                $scope.is_cat = false;
              }
            } else {
              $scope.is_cat = false;
            }
            vmm.infoReceipt.recibos_poliza.forEach(function (recibo) {
              if (
                endoso.concept == 1 ||
                endoso.concept == 11 ||
                endoso.concept == 43
              ) {
                recibo.receipt_type = 1;
              }
              recibo.poliza = policy.url;
              recibo.is_cat = $scope.is_cat;
              recibo.endorsement = endoso.url;
              recibo.fecha_inicio = new Date(
                datesFactory.toDate(recibo.fecha_inicio)
              );
              recibo.fecha_fin = new Date(
                datesFactory.toDate(recibo.fecha_fin)
              );
              recibo.vencimiento = new Date(
                datesFactory.toDate(recibo.vencimiento)
              );
              dataFactory.post("recibos/", recibo);
              if (endoso.concept == 1 || endoso.concept == 43) {
                if (isNaN(vm.patchEndoso.p_total)) {
                  vm.patchEndoso.p_total = 0;
                }
                console.log(vm.patchEndoso);
                console.log($scope.dataToPatch);
                var dataToPol = {
                  p_neta: $scope.dataToPatch.p_neta,
                  rpf: $scope.dataToPatch.rpf,
                  derecho: $scope.dataToPatch.derecho,
                  iva: $scope.dataToPatch.iva,
                  p_total: $scope.dataToPatch.p_total,
                };
                dataToPol.comision = (
                  parseFloat($scope.dataToPatch.p_neta) *
                  (parseFloat(vmm.policy.comision_percent) / 100)
                ).toFixed(2);
                dataToPol.comision_percent = vmm.policy.comision_percent;

                $http
                  .patch(policy.url, dataToPol)
                  .then(function success(response_) {
                    if (policy.document_type == 1) {
                      var model = 1;
                      var mens =
                        "actualizó Primas Generales de la Póliza por cambio de Forma de Pago (Endoso A).";
                    } else if (policy.document_type == 3) {
                      var model = 18;
                      var mens =
                        "actualizó Primas Generales de la Carátula por cambio de Forma de Pago (Endoso A).";
                    } else {
                      var model = 1;
                      var mens = "actualizó Primas Generales (Endoso A).";
                    }
                    var paramsC = {
                      model: model,
                      event: "POST",
                      associated_id: policy.id,
                      identifier: mens,
                    };
                    dataFactory
                      .post("send-log/", paramsC)
                      .then(function success(response) {});
                  });
              }
            });
            $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
          } else if (vmm.infoReceipt) {
            $scope.is_cat = false;
            if (policy) {
              if (policy.recibos_fianza) {
                $scope.is_cat = policy.recibos_fianza[0].is_cat;
              } else {
                $scope.is_cat = false;
              }
            } else {
              $scope.is_cat = false;
            }
            if (vmm.infoReceipt.recibos_poliza) {
              vmm.infoReceipt.recibos_poliza.forEach(function (recibo) {
                recibo.receipt_type = 2;
                recibo.fianza = policy.url;
                recibo.is_cat = $scope.is_cat;
                recibo.endorsement = endoso.url;
                recibo.fecha_inicio = new Date(
                  datesFactory.toDate(recibo.fecha_inicio)
                );
                recibo.fecha_fin = new Date(
                  datesFactory.toDate(recibo.fecha_fin)
                );
                recibo.vencimiento = new Date(
                  datesFactory.toDate(recibo.vencimiento)
                );
                dataFactory.post("recibos/", recibo);
              });
            }
          }
          $uibModalInstance.dismiss("cancel");
          SweetAlert.swal("¡Listo!", MESSAGES.OK.REGISTERENDOSO, "success");
          $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
        } else {
          $uibModalInstance.dismiss("cancel");
          SweetAlert.swal("¡Listo!", MESSAGES.OK.REGISTERENDOSO, "success");
          $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
        }
        $uibModalInstance.dismiss("cancel");
        SweetAlert.swal("¡Listo!", MESSAGES.OK.REGISTERENDOSO, "success");
        $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
        activate();
      }

      $scope.calculateNote = function (form, actual_receipt, x, c) {
        form.rpf = form.rpf ? form.rpf : 0;
        form.comision = form.comision ? form.comision : 0;
        form.gastos_expedicion = form.gastos_expedicion
          ? form.gastos_expedicion
          : 0;
        form.fecha_inicio = "";
        form.fecha_fin = "";
        form.initDate = "";
        form.endDate = "";
        vmm.createdNote = true;
        if (!actual_receipt) {
          vmm.credit_notes = notesFactory.updateFieldD(
            vmm.policy,
            form,
            actual_receipt
          );
        } else {
          vmm.credit_notes = notesFactory.updateFieldD(
            vmm.policy,
            form,
            actual_receipt
          );
        }
        vmm.credit_notes.forEach(function (nota, index) {
          vmm.credit_notes[index].vencimiento = nota.fecha_inicio;
          console.log(vmm.credit_notes[index].vencimiento);
        });
      };
      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          var date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          var date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }

        return date;
      }
      function toDate(dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

        return dateObject;
      }
      /* fechas de vigencia*/
      $scope.changeUntil = function (note, index) {
        note.fecha_fin = new Date(datesFactory.toDate(note.endDate));
      };
      $scope.changeSince = function (note, index) {
        note.fecha_inicio = new Date(datesFactory.toDate(note.initDate));
      };

      /* Guarda notas */
      function postRecibosNotas(notas, infoNotes, policy, endoso) {
        if (notas) {
          var paramsE = {
            model: 10,
            event: "POST",
            associated_id: endoso.id,
            identifier:
              "creó " + notas.length + " notas de credito del endoso.",
          };
          dataFactory.post("send-log", paramsE);
          if (policy.aseguradora) {
            $scope.is_cat = false;
            if (policy) {
              if (policy.recibos_poliza) {
                if (policy.recibos_poliza.length > 0) {
                  $scope.is_cat = policy.recibos_poliza[0].is_cat;
                } else {
                  $scope.is_cat = false;
                }
              } else {
                $scope.is_cat = false;
              }
            } else {
              $scope.is_cat = false;
            }
            notas.forEach(function (note, index) {
              if (note.comision) {
                if (
                  isNaN(parseFloat(note.comision).toFixed(2)) ||
                  note.comision == undefined ||
                  note.comision == "" ||
                  note.comision == ""
                ) {
                  note.comision = 0.0;
                } else {
                  note.comision = parseFloat(note.comision).toFixed(2);
                }
              } else {
                note.comision = 0.0;
              }
              note.prima_neta = parseFloat(note.prima_neta).toFixed(2);
              note.rpf = parseFloat(note.rpf).toFixed(2);
              note.iva = parseFloat(note.iva).toFixed(2);
              note.sub_total = parseFloat(note.sub_total).toFixed(2);
              note.comision = note.comision ? note.comision : 0;
              note.derecho = parseFloat(note.gastos_expedicion).toFixed(2);
              note.prima_total = parseFloat(note.prima_total).toFixed(2);
              note.receipt_type = 3;
              note.poliza = policy.url;
              note.is_cat = $scope.is_cat;
              note.endorsement = endoso.url;
              note.fecha_emision = new Date(
                datesFactory.toDate(infoNotes.fecha_emision)
              );
              note.recibo_numero = note.recibo_numero
                ? note.recibo_numero
                : parseInt(index) + 1;
              note.vencimiento = note.vencimiento
                ? note.vencimiento
                : note.fecha_inicio;
              if (note.vencimiento.length == 10) {
                note.vencimiento = new Date(
                  datesFactory.toDate(note.vencimiento)
                );
              }
              if (isNaN(note.derecho) || note.derecho == "isNaN") {
                note.derecho = 0;
              }

              // dataFactory.post('notas-credito/', note).then(
              dataFactory
                .post("recibos/", note)
                .then(
                  function success(request) {
                    if (endoso) {
                      if (endoso.status == 2) {
                        if (endoso.concept == 16 || endoso.concept == 17) {
                          if (request.data) {
                            if (request.data.status == 1) {
                              $http
                                .patch(request.data.url, { status: 4 })
                                .then(function success(response) {
                                  if (
                                    response.status == 200 ||
                                    response.status == 201
                                  ) {
                                  }
                                });
                            }
                          }
                        }
                      }
                    }
                    $http
                      .get(request.data.poliza)
                      .then(
                        function success(poliza) {
                          // if (poliza.data.natural) {
                          //   $http.get(poliza.data.natural).then(
                          //     function success(natural) {
                          //       if (natural.data.email) {
                          //           //Send Email
                          //         if($localStorage.email_config){
                          //             if($localStorage.email_config.create_nota == true){
                          //               $scope.idNota = request.data.id;
                          //               var model = 7;
                          //               emailService.sendEmailAtm(model,$scope.idNota)
                          //             }
                          //         }
                          //       }
                          //     },
                          //     function error (error) {
                          //     }
                          //   )
                          //   .catch(function(e) {
                          //     console.log('e', e);
                          //   });
                          // }else if (poliza.data.juridical) {
                          //   $http.get(poliza.data.juridical).then(
                          //     function success(juridical) {
                          //       if (juridical.data.email) {
                          //            //Send Email
                          //         if($localStorage.email_config){
                          //             if($localStorage.email_config.create_nota == true){
                          //               $scope.idNota = request.data.id;
                          //               var model = 7;
                          //               emailService.sendEmailAtm(model,$scope.idNota)
                          //             }
                          //         }
                          //       }
                          //     },
                          //     function error (error) {
                          //     }
                          //   )
                          //   .catch(function(e) {
                          //     console.log('e', e);
                          //   });
                          // }
                        },
                        function error(error) {}
                      )
                      .catch(function (e) {
                        console.log("e", e);
                      });
                  },
                  function error(error) {}
                )
                .catch(function (e) {
                  console.log("e", e);
                });
            });
          } else if (policy.afianzadora) {
            $scope.is_cat = false;
            if (policy) {
              if (policy.recibos_fianza) {
                $scope.is_cat = policy.recibos_fianza[0].is_cat;
              } else {
                $scope.is_cat = false;
              }
            } else {
              $scope.is_cat = false;
            }
            notas.forEach(function (note, index) {
              note.prima_neta = parseFloat(note.prima_neta).toFixed(2);
              note.rpf = parseFloat(note.rpf).toFixed(2);
              note.iva = parseFloat(note.iva).toFixed(2);
              note.sub_total = parseFloat(note.sub_total).toFixed(2);
              note.derecho = parseFloat(note.gastos_expedicion).toFixed(2);
              note.prima_total = parseFloat(note.prima_total).toFixed(2);
              note.fianza = policy.url;
              note.receipt_type = 3;
              note.is_cat = $scope.is_cat;
              note.endorsement = endoso.url;
              note.fecha_emision = new Date(
                datesFactory.toDate(infoNotes.fecha_emision)
              );
              note.recibo_numero = note.recibo_numero
                ? note.recibo_numero
                : parseInt(index) + 1;
              note.vencimiento = note.vencimiento
                ? note.vencimiento
                : note.fecha_inicio;
              dataFactory
                .post("recibos/", note)
                .then(
                  function success(request) {
                    if (endoso) {
                      if (endoso.status == 2) {
                        if (endoso.concept == 16 || endoso.concept == 17) {
                          if (request.data) {
                            if (request.data.status == 1) {
                              $http
                                .patch(request.data.url, { status: 4 })
                                .then(function success(response) {
                                  if (
                                    response.status == 200 ||
                                    response.status == 201
                                  ) {
                                  }
                                });
                            }
                          }
                        }
                      }
                    }
                    $http
                      .get(request.data.fianza)
                      .then(
                        function success(poliza) {
                          // if (poliza.data.natural) {
                          //   $http.get(poliza.data.natural).then(
                          //     function success(natural) {
                          //       if (natural.data.email) {
                          //           //Send Email
                          //         if($localStorage.email_config){
                          //             if($localStorage.email_config.create_nota == true){
                          //               $scope.idNota = request.data.id;
                          //               var model = 7;
                          //               emailService.sendEmailAtm(model,$scope.idNota)
                          //             }
                          //         }
                          //       }
                          //     },
                          //     function error (error) {
                          //     }
                          //   )
                          //   .catch(function(e) {
                          //     console.log('e', e);
                          //   });
                          // }else if (poliza.data.juridical) {
                          //   $http.get(poliza.data.juridical).then(
                          //     function success(juridical) {
                          //       if (juridical.data.email) {
                          //            //Send Email
                          //         if($localStorage.email_config){
                          //             if($localStorage.email_config.create_nota == true){
                          //               $scope.idNota = request.data.id;
                          //               var model = 7;
                          //               emailService.sendEmailAtm(model,$scope.idNota)
                          //             }
                          //         }
                          //       }
                          //     },
                          //     function error (error) {
                          //     }
                          //   )
                          //   .catch(function(e) {
                          //     console.log('e', e);
                          //   });
                          // }
                        },
                        function error(error) {}
                      )
                      .catch(function (e) {
                        console.log("e", e);
                      });
                  },
                  function error(error) {}
                )
                .catch(function (e) {
                  console.log("e", e);
                });
            });
          }
        } else {
          var paramsE = {
            model: 10,
            event: "POST",
            associated_id: endoso.id,
            identifier: "creó " + 0 + " notas de credito del endoso.",
          };
          dataFactory.post("send-log", paramsE);
        }
        $uibModalInstance.dismiss("cancel");
        SweetAlert.swal("¡Listo!", MESSAGES.OK.REGISTERENDOSO, "success");
        $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
        activate();
      }

      $scope.cancel = function () {
        vmm.form.num_receipts = "";
        vmm.infoReceipt = {};
        $uibModalInstance.dismiss("cancel");
      };

      /* Configuracion del datepicker */

      $(".datepicker-me input").datepicker();

      $.fn.datepicker.defaults.format = "dd/mm/yyyy";
      $.fn.datepicker.defaults.startView = 0;
      $.fn.datepicker.defaults.autoclose = true;
      $.fn.datepicker.defaults.language = "es";
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndososSuretyEditCtrl", EndososSuretyEditCtrl);

  EndososSuretyEditCtrl.$inject = [
    "url",
    "$sessionStorage",
    "dataFactory",
    "$scope",
    "$parse",
    "$http",
    "datesFactory",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "$state",
    "$stateParams",
    "FileUploader",
    "$timeout",
  ];

  function EndososSuretyEditCtrl(
    url,
    $sessionStorage,
    dataFactory,
    $scope,
    $parse,
    $http,
    datesFactory,
    providerService,
    SweetAlert,
    MESSAGES,
    $state,
    $stateParams,
    FileUploader,
    $timeout,
    $uibModalInstance
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    $scope.concepts = [
      { label: "Detalle de Garantía", value: 53 },
      { label: "Cambio de Beneficiario", value: 34 },
      { label: "Otro", value: 4 },
      { label: "Alta de Certificados", value: 24 },
      { label: "Baja de Certificados", value: 25 },
      { label: "Correcciones de Certificados", value: 56 },
      { label: "Aumento", value: 4 },
    ];

    $scope.typesMassive = [
      { label: "A", value: "A" },
      { label: "B", value: "B" },
      { label: "D", value: "D" },
    ];

    $scope.massive_type = {};

    $scope.startDate = "";
    $scope.endingDate = "";

    vm.poliza_number_data = "";
    $scope.surety = {};
    $scope.endorsement = {
      caratula: null,
      concept: "",
      endorsement_type: "",
      init_date: "",
      end_date: "",
      observations: "",
      change: {},
      number_endorsement: "",
      prima_neta: 0,
      rpf: 0,
      derecho: 0,
      sub_total: 0,
      iva: 0,
      prima_total: 0,
      comision: 0,
      comision_percent: 0,
      recibos_poliza: [],
    };

    $scope.beneficiaries = [];

    $scope.directiveReceipts = {};
    $scope.dataToSave = {
      comision: 0,
      comision_percent: 0,
    };

    $scope.show_certificates = false;
    $scope.showTableCertificates = false;
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.selectedCertificates = [];
    $scope.certificates = [];
    $scope.data_endorsement = [];

    $scope.checkRegister = false;

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          vm.acceso_fian = perm;
          vm.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                vm.permiso_administrar_adjuntos = true;
              } else {
                vm.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }

    activate();

    function activate() {
      dataFactory
        .get("endorsement-info/" + $stateParams.endosoId + "/")
        .then(function success(response) {
          $scope.endorsement = response.data;
          $scope.surety = response.data.policy;
          $scope.endorsement.change = $scope.endorsement.change
            .split("'")
            .join('"');
          $scope.endorsement.change = $scope.endorsement.change
            .split("None")
            .join('""');
          if ($scope.endorsement.change != "") {
            if (typeof $scope.endorsement.change == "string") {
              try {
                $scope.endorsement.change = JSON.parse(
                  $scope.endorsement.change
                );
              } catch (err) {}
            }
          }
          if ($scope.endorsement.original != "") {
            if (typeof $scope.endorsement.original == "string") {
              try {
                $scope.endorsement.original = JSON.parse(
                  $scope.endorsement.original
                );
              } catch (err) {}
            }
          }

          $scope.concepts.forEach(function (item) {
            if (item.value == $scope.endorsement.concept) {
              $scope.endorsement.concept = item;
            }
          });

          $scope.typesMassive.forEach(function (item) {
            if (item.value == $scope.endorsement.endorsement_type) {
              $scope.endorsement_type = item;
            }
          });

          $scope.startDate = convertDate($scope.endorsement.init_date);
          $scope.endDate = convertDate($scope.endorsement.end_date);

          dataFactory
            .get("endosos/" + $scope.endorsement.id + "/archivos/")
            .then(function success(response) {
              if (response.status === 200 || response.status == 201) {
                if (response.data.results.length) {
                  vm.files = response.data.results;
                }
              }
            });
        });
    }

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 14:
          return "Vigente";
          break;
        case 17:
          return "Anulada";
          break;
        case 24:
          return "Preanulada";
          break;
        case 0:
          return "Eliminada";
          break;
        default:
          return "Vigente";
      }
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function toDate(dateStr) {
      if (dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(
          dateParts[2],
          dateParts[1] - 1,
          dateParts[0]
        ).toISOString(); // month is 0-based
        return dateObject;
      }
    }

    $scope.valuePercentageRate = function (item) {
      if (item < 0) {
        $scope.endorsement.change.rate = 0;
      } else if (item > 100) {
        $scope.endorsement.change.rate = 100;
      }
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.matchesBeneficiary = function (parWord) {
      $scope.beneficiaries_data = [];
      var word_data = parWord;
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/BeneficiariesExistentes/';
          $scope.show_contratante = "BeneficiariesExistentes/";
          // $http.post(url.IP + $scope.show_contratante,
          //   {
          //     'matchWord': parWord
          //   })
          $http({
            method: "GET",
            url: url.IP + $scope.show_contratante,
            params: {
              matchWord: parWord,
            },
          }).then(function (response) {
            if (response.status === 200) {
              response.data.results.forEach(function (item) {
                $scope.beneficiaries_data.push({
                  label: item.type_person == 1 ? item.full_name : item.j_name,
                  value: item,
                });
              });
            }
          });
        }
      }
    };

    $scope.addBeneficiaries = function (item) {
      if ($scope.beneficiaries.length == 1) {
        if (
          $scope.beneficiaries[0].first_name == "" &&
          $scope.beneficiaries[0].last_name == "" &&
          $scope.beneficiaries[0].j_name == "" &&
          $scope.beneficiaries[0].rfc == ""
        ) {
          $scope.beneficiaries[0] = item;
        } else {
          var beneficiary = {
            type_person: item.type_person,
            first_name: item.first_name,
            last_name: item.last_name,
            second_last_name: item.second_last_name,
            j_name: item.j_name,
            full_name: "",
            rfc: item.rfc,
            email: item.email,
            phone_number: item.phone_number,
            id: item.id,
            url: item.url,
            poliza: null,
            usuario: null,
          };
          $scope.beneficiaries.push(beneficiary);
          $scope.benecifiarieSelected = {};
        }
      } else {
        var beneficiary = {
          type_person: item.type_person,
          first_name: item.first_name,
          last_name: item.last_name,
          second_last_name: item.second_last_name,
          j_name: item.j_name,
          full_name: "",
          rfc: item.rfc,
          email: item.email,
          phone_number: item.phone_number,
          id: item.id,
          url: item.url,
          poliza: null,
          usuario: null,
        };
        $scope.beneficiaries.push(beneficiary);
        $scope.benecifiarieSelected = {};
      }
    };

    $scope.addBeneficiary = function () {
      var beneficiary = {
        type_person: 1,
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        full_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        poliza: null,
        usuario: null,
      };
      $scope.beneficiaries.push(beneficiary);
    };

    $scope.deleteBeneficiary = function (index) {
      $scope.beneficiaries.splice(index, 1);
    };

    $scope.typePerson = function (param, index) {
      $scope.beneficiaries[index].type_person = param;
    };

    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      $scope.certificates = [];
      var flagCertificate = false;
      if (param.TITULARES) {
        $scope.excelJson = param.TITULARES;
        $scope.excelJson.forEach(function (item) {
          if (!item.FECHA_MOVIMIENTO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna FECHA_MOVIMIENTO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (!$scope.validateDate(item.FECHA_MOVIMIENTO)) {
              SweetAlert.swal(
                "Error",
                "Formato inválido de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_MOVIMIENTO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          }
          if (!item.NO_FIANZA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NO_FIANZA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CERTIFICADO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.NOMBRE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.APELLIDO_PATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.APELLIDO_MATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.PUESTO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna PUESTO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.ACTIVIDAD) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ACTIVIDAD, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CATEGORIA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
        });
        if (!flagCertificate) {
          $scope.selectedCertificates = param.TITULARES;
          $scope.selectedCertificates.forEach(function (item) {
            var personal = {
              certificate_number: parseInt(item.CERTIFICADO),
              email: item.CORREO ? item.CORREO : null,
              first_name: item.NOMBRE,
              last_name: item.APELLIDO_PATERNO,
              second_last_name: item.APELLIDO_MATERNO,
              rfc: item.RFC ? item.RFC : null,
              workstation: item.PUESTO ? item.PUESTO : null,
            };
            var certificateData = {
              caratula: $scope.surety.id,
              certificate_number: parseInt(item.CERTIFICADO),
              parent: item.CATEGORIA,
              poliza_number:
                $scope.surety.poliza_number + " - INC. " + item.CERTIFICADO,
              start_of_validity: $scope.endorsement.init_date,
              end_of_validity: $scope.endorsement.end_date,
              status: $scope.surety.status,
              fecha_baja_inciso:
                $scope.endorsement.endorsement_type == "B"
                  ? null
                  : toDate(item.FECHA_MOVIMIENTO),
              emision_date:
                $scope.endorsement.endorsement_type == "B"
                  ? toDate(item.FECHA_MOVIMIENTO)
                  : null,
              beneficiaries_poliza: personal,
              contract_poliza: {
                activity: item.ACTIVIDAD,
                amount: item.MONTO_A_GARANTIZAR
                  ? item.MONTO_A_GARANTIZAR
                  : null,
              },
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : null,
              document_type: 10,
              identifier:
                item.NOMBRE +
                "_" +
                item.APELLIDO_PATERNO +
                "_" +
                item.APELLIDO_MATERNO,
            };
            $scope.certificates.push(certificateData);
          });
          $scope.addViews(0);
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.cancelCertificates = function () {
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.certificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item, options){
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
          $state.go("endorsement.details", { endosoId: $scope.endosoId });

          if ($uibModalInstance) {
            $uibModalInstance.close(200);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {};

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + endorsementId + "/archivos/";
      $scope.files = [];
      $scope.files_ = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.checkNumEndoso = function () {
      if ($scope.endorsement.number_endorsement) {
        dataFactory
          .get("exist-number-endorsement/", {
            number: $scope.endorsement.number_endorsement,
            poliza: $scope.surety.poliza_number,
          })
          .then(function (request) {
            if (request.data.status == true) {
              SweetAlert.swal(
                "Error",
                "El número de endoso ya existe.",
                "error"
              );
              $scope.endorsement.number_endorsement = "";
            }
          })
          .catch(function (err) {});
      }
    };

    $scope.validitySurety = function () {
      if (!$scope.endorsement.concept) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONCEPT, "error");
        return;
      }
      if ($scope.endorsement.concept == 1) {
        if (!$scope.endorsement.change.guarantee_amount) {
          SweetAlert.swal("Error", "Agregue el monto a garantizar.", "error");
          return;
        }
        if (!$scope.endorsement.change.rate) {
          SweetAlert.swal("Error", "Agregue la tarifa.", "error");
          return;
        }
        if (!$scope.endorsement.change.activity) {
          SweetAlert.swal("Error", "Agregue el giro de la empresa.", "error");
          return;
        }
        if (!$scope.endorsement.change.no_employees) {
          SweetAlert.swal("Error", "Agregue el número de empleados.", "error");
          return;
        }
        if (!$scope.endorsement.change.description) {
          SweetAlert.swal(
            "Error",
            "Agregue el detalle adicional de garantía.",
            "error"
          );
          return;
        }
      }
      if ($scope.endorsement.concept == 3) {
        if (!$scope.endorsement.other_desc) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONCEPT, "error");
          return;
        }
      }
      if ($scope.endorsement.concept == 5) {
        if (!$scope.endorsement.endorsement_type) {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORTYPEENDORSEMENT,
            "error"
          );
          return;
        }
        if ($scope.selectedCertificates.length == 0) {
          SweetAlert.swal(
            "Error",
            "Carga el layout con los cetificados.",
            "error"
          );
          return;
        }
      }
      if (!$scope.endorsement.observations) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ENDOSOBS, "error");
        return;
      }
      if ($scope.checkRegister) {
        if (!$scope.endorsement.number_endorsement) {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
            "error"
          );
          return;
        }
        if ($scope.endorsement_type == "A" || $scope.endorsement_type == "D") {
          if (!$scope.dataToSave.recibos_poliza) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
            return;
          }
        }
      }
      $scope.createEndorsement();
    };

    $scope.createEndorsement = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      if ($scope.dataToSave.recibos_poliza) {
        $scope.dataToSave.recibos_poliza.forEach(function (item) {
          item.fecha_inicio = toDate(item.startDate);
          item.fecha_fin = toDate(item.endingDate);
          item.vencimiento = toDate(item.vencimiento);
        });
      }

      $scope.endorsement.number_endorsemen = $scope.endorsement
        .number_endorsement
        ? $scope.endorsement.number_endorsement
        : "";
      ($scope.endorsement.caratula = $scope.surety.id),
        ($scope.endorsement.prima_neta = $scope.dataToSave.p_neta
          ? $scope.dataToSave.p_neta
          : 0);
      $scope.endorsement.rpf = $scope.dataToSave.rpf
        ? $scope.dataToSave.rpf
        : 0;
      $scope.endorsement.derecho = $scope.dataToSave.derecho
        ? $scope.dataToSave.derecho
        : 0;
      $scope.endorsement.sub_total = $scope.dataToSave.sub_total
        ? $scope.dataToSave.sub_total
        : 0;
      $scope.endorsement.iva = $scope.dataToSave.iva
        ? $scope.dataToSave.iva
        : 0;
      $scope.endorsement.prima_total = $scope.dataToSave.p_total
        ? $scope.dataToSave.p_total
        : 0;
      $scope.endorsement.comision = $scope.dataToSave.comision
        ? $scope.dataToSave.comision
        : 0;
      $scope.endorsement.comision_percent = $scope.dataToSave.comision_percent
        ? $scope.dataToSave.comision_percent
        : 0;
      $scope.endorsement.recibos_poliza = $scope.dataToSave.recibos_poliza
        ? $scope.dataToSave.recibos_poliza
        : [];

      if ($scope.endorsement.endorsement_type == "D") {
        $scope.endorsement.prima_neta =
          parseFloat($scope.endorsement.prima_neta) * -1;
        $scope.endorsement.rpf = parseFloat($scope.endorsement.rpf) * -1;
        $scope.endorsement.derecho =
          parseFloat($scope.endorsement.derecho) * -1;
        $scope.endorsement.sub_total =
          parseFloat($scope.endorsement.sub_total) * -1;
        $scope.endorsement.iva = parseFloat($scope.endorsement.iva) * -1;
        $scope.endorsement.prima_total =
          parseFloat($scope.endorsement.prima_total) * -1;
      }

      $scope.data_endorsement = {
        certificados: $scope.certificates,
        endoso: $scope.endorsement,
      };

      if ($scope.endorsement.concept == 24) {
        $http({
          method: "POST",
          url: url.IP + "massive_upCertsByEndoso_fianza/",
          data: $scope.data_endorsement,
        })
          .then(function success(response) {
            if (response.status === 201 || response.status === 200) {
              if ($scope.countFile > 0) {
                $scope.endosoId = response.data.id;
                uploadFiles(response.data.id);
              } else {
                l.stop();
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.NEWENDORSEMENT,
                  "success"
                );
                $state.go("endorsement.details", {
                  endosoId: response.data.id,
                });
              }
            } else {
              l.stop();
              SweetAlert.swal("ERROR", "Ócurrio un error", "error");
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("error - caratula - catch", e);
          });
      } else if ($scope.endorsement.concept == 25) {
        $http({
          method: "POST",
          url: url.IP + "massive_downCertsByEndoso_fianza/",
          data: $scope.data_endorsement,
        })
          .then(function success(response) {
            if (response.status === 201 || response.status === 200) {
              if ($scope.countFile > 0) {
                $scope.endosoId = response.data.id;
                uploadFiles(response.data.id);
              } else {
                l.stop();
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.NEWENDORSEMENT,
                  "success"
                );
                $state.go("endorsement.details", {
                  endosoId: response.data.id,
                });
              }
            } else {
              l.stop();
              SweetAlert.swal("ERROR", "Ócurrio un error", "error");
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("error - caratula - catch", e);
          });
      } else {
        var endorsement_data = {
          other_desc: $scope.endorsement.other_desc,
          change: JSON.stringify($scope.endorsement.change),
          observations: $scope.endorsement.observations,
        };

        $http
          .patch($scope.endorsement.url, endorsement_data)
          .then(function (response) {
            if (response.status === 201 || response.status === 200) {
              if ($scope.countFile > 0) {
                $scope.endosoId = response.data.id;
                uploadFiles(response.data.id);
              } else {
                l.stop();
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.NEWENDORSEMENT,
                  "success"
                );
                $state.go("endorsement.details", {
                  endosoId: response.data.id,
                });
              }
            } else {
              l.stop();
              SweetAlert.swal("ERROR", "Ócurrio un error", "error");
            }
            var params = {
              model: 10,
              event: "POST",
              associated_id: response.data.id,
              identifier: "actualizó el endoso colectivo.",
            };
            dataFactory.post("send-log/", params);
          })
          .catch(function (e) {
            l.stop();
            console.log("error - caratula - catch", e);
          });
      }
    };

    /* Configuracion del datepicker */
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndososSuretyCollectiveCtrl", EndososSuretyCollectiveCtrl);

  EndososSuretyCollectiveCtrl.$inject = [
    "url",
    "$sessionStorage",
    "dataFactory",
    "$scope",
    "$parse",
    "$http",
    "datesFactory",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "$state",
    "$stateParams",
    "FileUploader",
    "$localStorage",
    "$timeout",
    "$rootScope",
  ];

  function EndososSuretyCollectiveCtrl(
    url,
    $sessionStorage,
    dataFactory,
    $scope,
    $parse,
    $http,
    datesFactory,
    providerService,
    SweetAlert,
    MESSAGES,
    $state,
    $stateParams,
    FileUploader,
    $localStorage,
    $timeout,
    $rootScope,
    $uibModalInstance
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    $scope.concepts = [
      { label: "Detalle de Garantía", value: 53 },
      { label: "Cambio de Beneficiario", value: 34 },
      { label: "Aumento", value: 58 },
      { label: "Disminución", value: 59 },
      { label: "Anulación", value: 60 }, //D
      { label: "Cancelación", value: 61 }, //B
      { label: "Anuencia", value: 55 }, //B
      { label: "Endoso de texto / Otro", value: 4 }, //B
      { label: "Alta de Certificados", value: 24 },
      { label: "Baja de Certificados", value: 25 },
      { label: "Correcciones de Certificados", value: 56 },
    ];

    $scope.typesMassive = [
      { label: "A (CON RECIBOS)", value: "A" },
      { label: "B (SIN RECIBOS)", value: "B" },
      { label: "D (CON NOTAS DE CRÉDITO)", value: "D" },
    ];

    $scope.massive_type = {};
    $scope.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 10; i >= oldYear; i--) {
      $scope.years.push(i);
    }

    $scope.month = {};
    $scope.month.month_selected = 1;
    $scope.month.options = [
      { value: 0, label: "" },
      { value: 1, label: "Enero" },
      { value: 2, label: "Febrero" },
      { value: 3, label: "Marzo" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Mayo" },
      { value: 6, label: "Junio" },
      { value: 7, label: "Julio" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Septiembre" },
      { value: 10, label: "Octubre" },
      { value: 11, label: "Noviembre" },
      { value: 12, label: "Diciembre" },
    ];
    $scope.checkFechaFactura = function (date) {
      var date_initial = date.split("/");
      var day = date_initial[0];
      var month = date_initial[1];
      var year = parseInt(date_initial[2]);
      $scope.endorsement.month.month_selected = parseInt(month);
      $scope.endorsement.year_factura = year;
    };
    $scope.startDate = "";
    $scope.endingDate = "";

    vm.poliza_number_data = "";
    $scope.surety = {};
    $scope.endorsement = {
      caratula: null,
      concept: "",
      endorsement_type: "",
      init_date: "",
      end_date: "",
      observations: "",
      change: {},
      number_endorsement: "",
      prima_neta: 0,
      rpf: 0,
      derecho: 0,
      sub_total: 0,
      iva: 0,
      prima_total: 0,
      comision: 0,
      comision_percent: 0,
      recibos_poliza: [],
    };

    $scope.beneficiaries = [];

    $scope.directiveReceipts = {
      is_fianza: true,
    };
    $scope.dataToSave = {
      comision: 0,
      comision_percent: 0,
    };

    $scope.show_certificates = false;
    $scope.showTableCertificates = false;
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.selectedCertificates = [];
    $scope.certificates = [];
    $scope.data_endorsement = [];

    $scope.checkRegister = true;
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          vm.acceso_fian = perm;
          vm.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                vm.permiso_administrar_adjuntos = true;
              } else {
                vm.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }

    if ($stateParams.endosoId) {
      $http
        .get(url.IP + "leer-fianzas-info/" + $stateParams.endosoId)
        .then(function (response) {
          if (response.status == 200) {
            $scope.myPolicy = response.data;
            vm.poliza_number_data = {
              value: $scope.myPolicy,
              val: $scope.myPolicy.poliza_number,
              id: $scope.myPolicy.id,
            };
          }
        });
    } else {
      if ($localStorage.endorsement_surety) {
        $http
          .get(
            url.IP + "leer-fianzas-info/" + $localStorage.endorsement_surety.id
          )
          .then(function (response) {
            if (response.status == 200) {
              $scope.myPolicy = response.data;
              vm.poliza_number_data = {
                value: $scope.myPolicy,
                val: $scope.myPolicy.poliza_number,
                id: $scope.myPolicy.id,
              };
            }
          });
      }
    }

    activate();

    function changeTypeLocal() {
      $scope.endorsement.endorsement_type = $scope.endorsement_type.value;
      $scope.directiveReceipts.type_endorsement = $scope.endorsement_type.value;
    }

    function activate() {
      $scope.checkRegister = true;
      vm.poliza_number_data = $localStorage[
        "save_created_endoso_fianza_colectiva"
      ]
        ? $localStorage["save_created_endoso_fianza_colectiva"][
            "poliza_number_data"
          ]
        : "";
      if ($localStorage["save_created_endoso_fianza_colectiva"]) {
        if ($localStorage["save_created_endoso_fianza_colectiva"]["concept"]) {
          $scope.concepts.forEach(function (item) {
            if (
              item.value ==
              $localStorage["save_created_endoso_fianza_colectiva"]["concept"]
            ) {
              $scope.endorsement.concept = item;
              $scope.massive_type = {};
              $scope.endorsement_type = "";
              $scope.endorsement.other_desc = "";
              $scope.endorsement.change = {};
              $scope.endorsement.original = [];
              $scope.origin_endorsement = [];
              if ($scope.endorsement.concept == 53) {
                $scope.origin_endorsement = angular.copy(
                  $scope.surety.contract_poliza
                );
                $scope.endorsement.change.guarantee_amount = parseFloat(
                  $scope.surety.contract_poliza.guarantee_amount
                );
                $scope.endorsement.change.rate = parseFloat(
                  $scope.surety.contract_poliza.rate
                );
                $scope.endorsement.change.activity =
                  $scope.surety.contract_poliza.activity;
                $scope.endorsement.change.no_employees =
                  $scope.surety.contract_poliza.no_employees;
                $scope.endorsement.change.description =
                  $scope.surety.contract_poliza.description;
              } else if ($scope.endorsement.concept == 34) {
                $scope.origin_endorsement = angular.copy(
                  $scope.surety.beneficiaries_poliza_many
                );
                $scope.endorsement.change =
                  $scope.surety.beneficiaries_poliza_many;
                $scope.endorsement_type = $scope.typesMassive[1];
                changeTypeLocal();
              } else if ($scope.endorsement.concept == 58) {
                $scope.origin_endorsement = angular.copy(
                  $scope.surety.contract_poliza
                );
                $scope.endorsement.change = $scope.surety.contract_poliza;
                $scope.endorsement_type = $scope.typesMassive[0];
                changeTypeLocal();
              } else if ($scope.endorsement.concept == 59) {
                $scope.origin_endorsement = angular.copy(
                  $scope.surety.contract_poliza
                );
                $scope.endorsement.change = $scope.surety.contract_poliza;
                $scope.endorsement_type = $scope.typesMassive[2];
                changeTypeLocal();
              } else if ($scope.endorsement.concept == 60) {
                $scope.origin_endorsement = {
                  reason_cancel: $scope.surety.reason_cancel,
                  concept_annulment: $scope.surety.concept_annulment,
                };
                $scope.endorsement.change = {
                  reason_cancel: vm.reason_cancel,
                  concept_annulment: vm.conceptAnnulment,
                };
                if ($scope.surety.status == 14) {
                  vm.concept_anulacion = [
                    { value: 1, label: "PreAnulada" },
                    { value: 2, label: "Por error de captura" },
                    { value: 3, label: "Por reexpedición" },
                    { value: 4, label: "Por falta de pago" },
                    { value: 5, label: "Otro (sólo anular)" },
                  ];
                } else {
                  vm.concept_anulacion = [
                    { value: 2, label: "Por error de captura" },
                    { value: 3, label: "Por Reexpedición" },
                    { value: 4, label: "Por falta de Pago" },
                    { value: 5, label: "Otro (Sólo anular)" },
                  ];
                }
                vm.conceptAnnulment = vm.concept_anulacion[0].value;
                vm.reason_cancel = "";
                $scope.endorsement_type = $scope.typesMassive[2];
                changeTypeLocal();
              } else if ($scope.endorsement.concept == 61) {
                $scope.origin_endorsement = {
                  status: $scope.surety.status,
                  fecha_cancelacion: $scope.surety.fecha_cancelacion,
                  monto_cancelacion: $scope.surety.monto_cancelacion,
                };
                $scope.endorsement.change = {
                  status: 11,
                  monto_cancelacion: vm.monto_cancelacion,
                  fecha_cancelacion: vm.fecha_cancelacion,
                };
                $scope.endorsement_type = $scope.typesMassive[1];
                changeTypeLocal();
              } else if ($scope.endorsement.concept == 55) {
                $scope.anuency = datesFactory.convertDate(new Date());
                $scope.origin_endorsement = {
                  status: $scope.surety.status,
                  fecha_anuencia: $scope.surety.fecha_anuencia,
                };
                $scope.to_change = {
                  fecha_anuencia: $scope.anuency,
                  status: $scope.surety.status,
                };
                $scope.endorsement_type = $scope.typesMassive[1];
                changeTypeLocal();
              } else if ($scope.endorsement.concept == 24) {
                $scope.endorsement_type = $scope.typesMassive[0];
                changeTypeLocal();
              } else if ($scope.endorsement.concept == 25) {
                $scope.endorsement_type = $scope.typesMassive[2];
                changeTypeLocal();
              } else if ($scope.endorsement.concept == 56) {
                $scope.endorsement_type = $scope.typesMassive[1];
                changeTypeLocal();
                var data = {
                  caratula: $scope.surety.id,
                  status: 0,
                  parent: 0,
                  page: 0,
                };
                $http
                  .post(url.IP + "information_certCollSurety_info/", data)
                  .then(function (response) {
                    if (response.status == 200 || response.status == 201) {
                      $scope.origin_endorsement = response.data.certificates;
                    }
                  })
                  .catch(function (e) {
                    l.stop();
                    console.log("error - caratula - catch", e);
                  });
              }
            }
          });
        }
      }

      $scope.endorsement_type = $localStorage[
        "save_created_endoso_fianza_colectiva"
      ]
        ? $localStorage["save_created_endoso_fianza_colectiva"][
            "endorsement_type"
          ]
        : "";
      $scope.endorsement.observations = $localStorage[
        "save_created_endoso_fianza_colectiva"
      ]
        ? $localStorage["save_created_endoso_fianza_colectiva"]["observations"]
        : "";
      vm.conceptAnnulment = $localStorage[
        "save_created_endoso_fianza_colectiva"
      ]
        ? $localStorage["save_created_endoso_fianza_colectiva"][
            "conceptAnnulment"
          ]
        : "";
      vm.reason_cancel = $localStorage["save_created_endoso_fianza_colectiva"]
        ? $localStorage["save_created_endoso_fianza_colectiva"]["reason_cancel"]
        : "";
      vm.fecha_cancelacion = $localStorage[
        "save_created_endoso_fianza_colectiva"
      ]
        ? $localStorage["save_created_endoso_fianza_colectiva"][
            "fecha_cancelacion"
          ]
        : "";
      vm.monto_cancelacion = $localStorage[
        "save_created_endoso_fianza_colectiva"
      ]
        ? $localStorage["save_created_endoso_fianza_colectiva"][
            "monto_cancelacion"
          ]
        : "";
      $scope.anuency = $localStorage["save_created_endoso_fianza_colectiva"]
        ? $localStorage["save_created_endoso_fianza_colectiva"]["anuency"]
        : "";
      $scope.endorsement.change = $localStorage[
        "save_created_endoso_fianza_colectiva"
      ]
        ? $localStorage["save_created_endoso_fianza_colectiva"]["change"]
        : "";
      if ($rootScope && $rootScope.from_task) {
        if ($localStorage["save_created_endoso_fianza_colectiva"]) {
          $localStorage["save_created_endoso_fianza_colectiva"]["type"] =
            $rootScope.type_endorsement;
        } else {
          $localStorage["save_created_endoso_fianza_colectiva"] = {};
          $localStorage["save_created_endoso_fianza_colectiva"]["type"] =
            $rootScope.type_endorsement;
        }
        $scope.typesMassive.forEach(function (item) {
          if (item.value == $rootScope.type_endorsement) {
            $scope.endorsement_type = item;
          }
        });
      }
    }

    if ("save_created_endoso_fianza_colectiva" in $localStorage) {
    } else {
      $localStorage["save_created_endoso_fianza_colectiva"] = {};
    }

    $scope.saveLocalstorange = function () {
      $localStorage["save_created_endoso_fianza_colectiva"][
        "poliza_number_data"
      ] = vm.poliza_number_data ? vm.poliza_number_data : "";
      $localStorage["save_created_endoso_fianza_colectiva"]["concept"] = $scope
        .endorsement.concept.value
        ? $scope.endorsement.concept.value
        : $scope.endorsement.concept
        ? $scope.endorsement.concept
        : "";
      $localStorage["save_created_endoso_fianza_colectiva"][
        "endorsement_type"
      ] = $scope.endorsement_type ? $scope.endorsement_type : "";
      $localStorage["save_created_endoso_fianza_colectiva"]["observations"] =
        $scope.endorsement.observations ? $scope.endorsement.observations : "";
      $localStorage["save_created_endoso_fianza_colectiva"][
        "conceptAnnulment"
      ] = vm.conceptAnnulment ? vm.conceptAnnulment : "";
      $localStorage["save_created_endoso_fianza_colectiva"]["reason_cancel"] =
        vm.reason_cancel ? vm.reason_cancel : "";
      $localStorage["save_created_endoso_fianza_colectiva"][
        "fecha_cancelacion"
      ] = vm.fecha_cancelacion ? vm.fecha_cancelacion : "";
      $localStorage["save_created_endoso_fianza_colectiva"][
        "monto_cancelacion"
      ] = vm.monto_cancelacion ? vm.monto_cancelacion : "";
      $localStorage["save_created_endoso_fianza_colectiva"]["anuency"] =
        $scope.anuency ? $scope.anuency : "";
      $localStorage["save_created_endoso_fianza_colectiva"]["change"] = $scope
        .endorsement.change
        ? $scope.endorsement.change
        : "";
      $localStorage["save_created_endoso_fianza_colectiva"]["beneficiaries"] =
        $scope.beneficiaries ? $scope.beneficiaries : "";
    };

    $scope.findContractor = function (parValue) {
      if (parValue) {
        if (parValue.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_surety = 'v2/fianzas/get-endorsements-fianzas/';
          $scope.show_surety = "get-endorsements-fianzas/";
          dataFactory
            .post($scope.show_surety, { word: parValue.val, document_type: 8 })
            .then(
              function success(request) {
                var results = [];
                results = _.map(request.data, function (item) {
                  // if(item.juridical){
                  //   var label = item.poliza_number + ' - ' + item.juridical.j_name;
                  // }else{
                  //   var label = item.poliza_number + ' - ' + item.natural.full_name;
                  // }
                  if (item.contractor) {
                    var label =
                      item.poliza_number + " - " + item.contractor.full_name;
                  }
                  return {
                    label: label,
                    value: item,
                    id: item.id,
                  };
                });
                $scope.autocompleteData = results;
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };

    $scope.$watch("vm.poliza_number_data.value", function (newValue, oldValue) {
      if (vm.poliza_number_data) {
        $scope.getPolicy(vm.poliza_number_data.value);
      }
    });

    $scope.getPolicy = function (param) {
      if (param) {
        if (param.id == "") {
          SweetAlert.swal("Error", "Ingrese un número de fianza.", "error");
          return;
        }
      }

      $http
        .post(url.IP + "information_collectivesurety/", { caratula: param.id })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.surety = response.data.data.collectivitySurety;
            $scope.startDate = convertDate(new Date());
            $scope.endDate = convertDate($scope.surety.end_of_validity);
            $scope.checkDate($scope.startDate);
            // $scope.beneficiaries = $scope.surety.beneficiaries_poliza_many;
            $scope.beneficiaries = angular.copy(
              $scope.surety.beneficiaries_poliza_many
            );
            if ($localStorage["save_created_endoso_fianza_colectiva"]) {
              $scope.beneficiaries = $localStorage[
                "save_created_endoso_fianza_colectiva"
              ]
                ? $localStorage["save_created_endoso_fianza_colectiva"][
                    "beneficiaries"
                  ]
                : "";
            }
            $scope.categories = response.data.data.childs;
            $scope.get_claves($scope.surety.aseguradora.id);
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORSEARCHFIANZA, "error");
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 14:
          return "Vigente";
          break;
        case 17:
          return "Anulada";
          break;
        case 24:
          return "Preanulada";
          break;
        case 0:
          return "Eliminada";
          break;
        default:
          return "Vigente";
      }
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function toDate(dateStr) {
      if (dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(
          dateParts[2],
          dateParts[1] - 1,
          dateParts[0]
        ).toISOString(); // month is 0-based
        return dateObject;
      }
    }

    $scope.checkDate = function (param) {
      if (param.length == 10) {
        if (
          process(param) < process(convertDate($scope.surety.start_of_validity))
        ) {
          SweetAlert.swal(
            "Error",
            "La fecha inicial del endoso no puede ser menor a la fecha inicial de la fianza.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }
        $scope.endorsement.init_date = toDate($scope.startDate);
        $scope.endorsement.end_date = toDate($scope.endingDate);
      } else {
        if (
          process(param) < process(convertDate($scope.surety.start_of_validity))
        ) {
          SweetAlert.swal(
            "Error",
            "La fecha inicial del endoso no puede ser menor a la fecha inicial de la fianza.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }
        $scope.endorsement.init_date = toDate($scope.startDate);
        $scope.endorsement.end_date = toDate($scope.endingDate);
      }
      $scope.directiveReceipts.start_of_validity = $scope.startDate;
      $scope.directiveReceipts.end_of_validity = $scope.endDate;
      $scope.directiveReceipts.policy_days_duration = 365;
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }
        $scope.directiveReceipts.start_of_validity = $scope.startDate;
        $scope.directiveReceipts.end_of_validity = $scope.endDate;
        $scope.endorsement.end_date = toDate($scope.endDate);
        $scope.directiveReceipts.policy_days_duration = 365;
      }
    };

    $scope.get_claves = function (value) {
      $scope.directiveReceipts.comisiones = [];
      $http
        .get(url.IP + "claves-by-provider/" + value)
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
                if ($scope.surety.aseguradora) {
                  if ($scope.surety.subramo.subramo_name == item.subramo) {
                    $scope.directiveReceipts.comisiones.push(item);
                  }
                } else {
                  if ($scope.surety.subramo == item.subramo) {
                    $scope.directiveReceipts.comisiones.push(item);
                  }
                }
              });
            });
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      $scope.directiveReceipts.subramo = $scope.surety.subramo;
      $scope.directiveReceipts.payment = 5;
      $scope.directiveReceipts.num_receipts = 1;
    };

    $scope.changeConcept = function () {
      $scope.massive_type = {};
      $scope.endorsement_type = "";
      $scope.endorsement.other_desc = "";
      $scope.endorsement.change = {};
      $scope.endorsement.original = [];
      $scope.origin_endorsement = [];
      if ($scope.endorsement.concept == 53) {
        $scope.origin_endorsement = angular.copy($scope.surety.contract_poliza);
        $scope.endorsement.change.guarantee_amount = parseFloat(
          $scope.surety.contract_poliza.guarantee_amount
        );
        $scope.endorsement.change.rate = parseFloat(
          $scope.surety.contract_poliza.rate
        );
        $scope.endorsement.change.activity =
          $scope.surety.contract_poliza.activity;
        $scope.endorsement.change.no_employees =
          $scope.surety.contract_poliza.no_employees;
        $scope.endorsement.change.description =
          $scope.surety.contract_poliza.description;
      } else if ($scope.endorsement.concept == 34) {
        $scope.origin_endorsement = angular.copy(
          $scope.surety.beneficiaries_poliza_many
        );
        $scope.endorsement.change = $scope.surety.beneficiaries_poliza_many;
        $scope.endorsement_type = $scope.typesMassive[1];
        $scope.changeType();
        $scope.beneficiaries = $localStorage[
          "save_created_endoso_fianza_colectiva"
        ]
          ? $localStorage["save_created_endoso_fianza_colectiva"][
              "beneficiaries"
            ]
          : "";
      } else if ($scope.endorsement.concept == 58) {
        $scope.origin_endorsement = angular.copy($scope.surety.contract_poliza);
        $scope.endorsement.change = $scope.surety.contract_poliza;
        $scope.endorsement_type = $scope.typesMassive[0];
        $scope.changeType();
      } else if ($scope.endorsement.concept == 59) {
        $scope.origin_endorsement = angular.copy($scope.surety.contract_poliza);
        $scope.endorsement.change = $scope.surety.contract_poliza;
        $scope.endorsement_type = $scope.typesMassive[2];
        $scope.changeType();
      } else if ($scope.endorsement.concept == 60) {
        $scope.origin_endorsement = {
          reason_cancel: $scope.surety.reason_cancel,
          concept_annulment: $scope.surety.concept_annulment,
        };
        $scope.endorsement.change = {
          reason_cancel: vm.reason_cancel,
          concept_annulment: vm.conceptAnnulment,
        };
        if ($scope.surety.status == 14) {
          vm.concept_anulacion = [
            { value: 1, label: "PreAnulada" },
            { value: 2, label: "Por error de captura" },
            { value: 3, label: "Por reexpedición" },
            { value: 4, label: "Por falta de pago" },
            { value: 5, label: "Otro (sólo anular)" },
          ];
        } else {
          vm.concept_anulacion = [
            { value: 2, label: "Por error de captura" },
            { value: 3, label: "Por Reexpedición" },
            { value: 4, label: "Por falta de Pago" },
            { value: 5, label: "Otro (Sólo anular)" },
          ];
        }
        vm.conceptAnnulment = vm.concept_anulacion[0].value;
        vm.reason_cancel = "";
        $scope.endorsement_type = $scope.typesMassive[2];
        $scope.changeType();
      } else if ($scope.endorsement.concept == 61) {
        $scope.origin_endorsement = {
          status: $scope.surety.status,
          fecha_cancelacion: $scope.surety.fecha_cancelacion,
          monto_cancelacion: $scope.surety.monto_cancelacion,
        };
        $scope.endorsement.change = {
          status: 11,
          monto_cancelacion: vm.monto_cancelacion,
          fecha_cancelacion: vm.fecha_cancelacion,
        };
        $scope.endorsement_type = $scope.typesMassive[1];
        $scope.changeType();
      } else if ($scope.endorsement.concept == 55) {
        $scope.anuency = datesFactory.convertDate(new Date());
        $scope.origin_endorsement = {
          status: $scope.surety.status,
          fecha_anuencia: $scope.surety.fecha_anuencia,
        };
        $scope.to_change = {
          fecha_anuencia: $scope.anuency,
          status: $scope.surety.status,
        };
        $scope.endorsement_type = $scope.typesMassive[1];
        $scope.changeType();
      } else if ($scope.endorsement.concept == 24) {
        $scope.endorsement_type = $scope.typesMassive[0];
        $scope.changeType();
      } else if ($scope.endorsement.concept == 25) {
        $scope.endorsement_type = $scope.typesMassive[2];
        $scope.changeType();
      } else if ($scope.endorsement.concept == 56) {
        $scope.endorsement_type = $scope.typesMassive[1];
        $scope.changeType();
        var data = {
          caratula: $scope.surety.id,
          status: 0,
          parent: 0,
          page: 0,
        };
        $http
          .post(url.IP + "information_certCollSurety_info/", data)
          .then(function (response) {
            if (response.status == 200 || response.status == 201) {
              $scope.origin_endorsement = response.data.certificates;
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("error - caratula - catch", e);
          });
      }
    };

    $scope.changeType = function () {
      $scope.endorsement.endorsement_type = $scope.endorsement_type.value;
      $scope.directiveReceipts.type_endorsement = $scope.endorsement_type.value;
    };

    $scope.valuePercentageRate = function (item) {
      if (item < 0) {
        $scope.endorsement.change.rate = 0;
      } else if (item > 100) {
        $scope.endorsement.change.rate = 100;
      }
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.matchesBeneficiary = function (parWord) {
      $scope.beneficiaries_data = [];
      var word_data = parWord;
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/BeneficiariesExistentes/';
          $scope.show_contratante = "BeneficiariesExistentes/";
          // $http.get(url.IP + $scope.show_contratante,
          //   params:{
          //     'matchWord': parWord
          //   })
          $http({
            method: "GET",
            url: url.IP + $scope.show_contratante,
            params: {
              matchWord: parWord,
            },
          }).then(function (response) {
            if (response.status === 200) {
              response.data.results.forEach(function (item) {
                $scope.beneficiaries_data.push({
                  label: item.type_person == 1 ? item.full_name : item.j_name,
                  value: item,
                });
              });
            }
          });
        }
      }
    };

    $scope.addBeneficiaries = function (item) {
      if ($scope.beneficiaries.length == 1) {
        if (
          $scope.beneficiaries[0].first_name == "" &&
          $scope.beneficiaries[0].last_name == "" &&
          $scope.beneficiaries[0].j_name == "" &&
          $scope.beneficiaries[0].rfc == ""
        ) {
          $scope.beneficiaries[0] = item;
        } else {
          var beneficiary = {
            type_person: item.type_person,
            first_name: item.first_name,
            last_name: item.last_name,
            second_last_name: item.second_last_name,
            j_name: item.j_name,
            full_name: "",
            rfc: item.rfc,
            email: item.email,
            phone_number: item.phone_number,
            id: item.id,
            url: item.url,
            poliza: null,
            usuario: null,
          };
          $scope.beneficiaries.push(beneficiary);
          $scope.benecifiarieSelected = {};
        }
      } else {
        var beneficiary = {
          type_person: item.type_person,
          first_name: item.first_name,
          last_name: item.last_name,
          second_last_name: item.second_last_name,
          j_name: item.j_name,
          full_name: "",
          rfc: item.rfc,
          email: item.email,
          phone_number: item.phone_number,
          id: item.id,
          url: item.url,
          poliza: null,
          usuario: null,
        };
        $scope.beneficiaries.push(beneficiary);
        $scope.benecifiarieSelected = {};
      }
    };

    // $scope.addBeneficiary = function(){
    //   var beneficiary = {
    //     type_person: 1,
    //     first_name: '',
    //     last_name: '',
    //     second_last_name: '',
    //     j_name: '',
    //     full_name: '',
    //     rfc: '',
    //     email: '',
    //     phone_number: '',
    //     poliza: null,
    //     usuario: null
    //   }
    //   $scope.beneficiaries.push(beneficiary);
    // };

    // $scope.deleteBeneficiary = function(index){
    //   $scope.beneficiaries.splice(index, 1);
    // };
    $scope.addBeneficiary = function () {
      var beneficiario = {
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        type_person: 1,
      };
      $scope.beneficiaries.push(beneficiario);
    };

    $scope.deleteBeneficiary = function (index) {
      if ($scope.beneficiaries.length > 1) {
        $scope.beneficiaries.splice(index, 1);
      }
    };

    $scope.typePerson = function (param, index) {
      $scope.beneficiaries[index].type_person = param;
    };

    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      $scope.certificates = [];
      var flagCertificate = false;
      if (param.TITULARES) {
        $scope.excelJson = param.TITULARES;
        $scope.excelJson.forEach(function (item) {
          if (!item.FECHA_MOVIMIENTO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna FECHA_MOVIMIENTO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (!$scope.validateDate(item.FECHA_MOVIMIENTO)) {
              SweetAlert.swal(
                "Error",
                "Formato inválido de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_MOVIMIENTO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          }
          if (!item.NO_FIANZA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NO_FIANZA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CERTIFICADO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.NOMBRE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.APELLIDO_PATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.APELLIDO_MATERNO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.PUESTO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna PUESTO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.ACTIVIDAD) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ACTIVIDAD, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CATEGORIA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
        });
        if (!flagCertificate) {
          $scope.selectedCertificates = param.TITULARES;
          $scope.selectedCertificates.forEach(function (item) {
            var personal = {
              certificate_number: parseInt(item.CERTIFICADO),
              email: item.CORREO ? item.CORREO : null,
              first_name: item.NOMBRE,
              last_name: item.APELLIDO_PATERNO,
              second_last_name: item.APELLIDO_MATERNO,
              rfc: item.RFC ? item.RFC : null,
              workstation: item.PUESTO ? item.PUESTO : null,
            };
            var certificateData = {
              caratula: $scope.surety.id,
              certificate_number: parseInt(item.CERTIFICADO),
              parent: item.CATEGORIA,
              poliza_number:
                $scope.surety.poliza_number + " - INC. " + item.CERTIFICADO,
              start_of_validity: $scope.endorsement.init_date,
              end_of_validity: $scope.endorsement.end_date,
              status: $scope.surety.status,
              fecha_baja_inciso:
                $scope.endorsement.endorsement_type == "B"
                  ? null
                  : toDate(item.FECHA_MOVIMIENTO),
              emision_date:
                $scope.endorsement.endorsement_type == "B"
                  ? toDate(item.FECHA_MOVIMIENTO)
                  : null,
              beneficiaries_poliza: personal,
              contract_poliza: {
                activity: item.ACTIVIDAD,
                amount: item.MONTO_A_GARANTIZAR
                  ? item.MONTO_A_GARANTIZAR
                  : null,
              },
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : null,
              document_type: 10,
              identifier:
                item.NOMBRE +
                "_" +
                item.APELLIDO_PATERNO +
                "_" +
                item.APELLIDO_MATERNO,
            };
            $scope.certificates.push(certificateData);
          });
          $scope.addViews(0);
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.cancelCertificates = function () {
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.certificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item, options){
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
          $state.go("endorsement.details", { endosoId: $scope.endosoId });

          if ($uibModalInstance) {
            $uibModalInstance.close(200);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {};

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + endorsementId + "/archivos/";
      $scope.files = [];
      $scope.files_ = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.checkNumEndoso = function () {
      if ($scope.endorsement.number_endorsement) {
        dataFactory
          .get("exist-number-endorsement/", {
            number: $scope.endorsement.number_endorsement,
            poliza: $scope.surety.poliza_number,
          })
          .then(function (request) {
            if (request.data.status == true) {
              $scope.endorsement.number_endorsement = "";
              SweetAlert.swal(
                "Error",
                "El número de endoso ya existe.",
                "error"
              );
              return;
            } else {
              $scope.validitySurety();
            }
          })
          .catch(function (err) {});
      } else {
        SweetAlert.swal("Error", "Agrega un número de endoso.", "error");
        return;
      }
    };

    $scope.validitySurety = function () {
      if (!vm.poliza_number_data) {
        SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
        return;
      }
      if (!$scope.endorsement.concept) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONCEPT, "error");
        return;
      }
      if ($scope.endorsement.concept == 1) {
        if (!$scope.endorsement.change.guarantee_amount) {
          SweetAlert.swal("Error", "Agregue el monto a garantizar.", "error");
          return;
        }
        if (!$scope.endorsement.change.rate) {
          SweetAlert.swal("Error", "Agregue la tarifa.", "error");
          return;
        }
        if (!$scope.endorsement.change.activity) {
          SweetAlert.swal("Error", "Agregue el giro de la empresa.", "error");
          return;
        }
        if (!$scope.endorsement.change.no_employees) {
          SweetAlert.swal("Error", "Agregue el número de empleados.", "error");
          return;
        }
        if (!$scope.endorsement.change.description) {
          SweetAlert.swal(
            "Error",
            "Agregue el detalle adicional de garantía.",
            "error"
          );
          return;
        }
      }
      if ($scope.endorsement.concept == 3) {
        if (!$scope.endorsement.other_desc) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONCEPT, "error");
          return;
        }
      }
      if ($scope.endorsement.concept == 5) {
        if (!$scope.endorsement.endorsement_type) {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORTYPEENDORSEMENT,
            "error"
          );
          return;
        }
        if ($scope.selectedCertificates.length == 0) {
          SweetAlert.swal(
            "Error",
            "Carga el layout con los cetificados.",
            "error"
          );
          return;
        }
      }
      if (!$scope.endorsement.observations) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ENDOSOBS, "error");
        return;
      }
      if ($scope.checkRegister) {
        if (!$scope.endorsement.number_endorsement) {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
            "error"
          );
          return;
        }
        if ($scope.endorsement_type == "A" || $scope.endorsement_type == "D") {
          if (!$scope.dataToSave.recibos_poliza) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
            return;
          }
        }
      }
      $scope.createEndorsement();
    };

    $scope.createEndorsement = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if ($scope.endorsement.concept == 60) {
        $scope.to_change = {
          reason_cancel: vm.reason_cancel,
          concept_annulment: vm.conceptAnnulment,
        };
        $scope.endorsement.change = $scope.to_change;
        $scope.origin_endorsement = {
          reason_cancel: angular.copy($scope.surety.reason_cancel),
          concept_annulment: angular.copy($scope.surety.concept_annulment),
        };
      }
      if ($scope.endorsement.concept == 61) {
        $scope.to_change = {
          status: 11,
          monto_cancelacion: vm.monto_cancelacion,
          fecha_cancelacion: datesFactory.toDate(vm.fecha_cancelacion),
        };
        $scope.endorsement.change = $scope.to_change;
        $scope.origin_endorsement = {
          status: angular.copy($scope.surety.status),
          fecha_cancelacion: angular.copy($scope.surety.fecha_cancelacion),
          monto_cancelacion: angular.copy($scope.surety.monto_cancelacion),
        };
      }
      if ($scope.endorsement.concept == 55) {
        $scope.to_change = {
          fecha_anuencia: datesFactory.toDate($scope.anuency),
        };
        $scope.endorsement.change = $scope.to_change;
        $scope.origin_endorsement = {
          status: angular.copy($scope.surety.status),
          fecha_anuencia: angular.copy($scope.surety.fecha_anuencia),
        };
      }
      if ($scope.endorsement.concept == 34) {
        $scope.to_change = $scope.beneficiaries;
        $scope.endorsement.change = $scope.to_change;
        $scope.origin_endorsement = angular.copy(
          $scope.surety.beneficiaries_poliza_many
        );
      }
      if ($scope.dataToSave.recibos_poliza) {
        $scope.dataToSave.recibos_poliza.forEach(function (item) {
          item.fecha_inicio = toDate(item.startDate);
          item.fecha_fin = toDate(item.endingDate);
          item.vencimiento = toDate(item.vencimiento);
        });
      }

      $scope.endorsement.number_endorsemen = $scope.endorsement
        .number_endorsement
        ? $scope.endorsement.number_endorsement
        : "";
      ($scope.endorsement.caratula = $scope.surety.id),
        ($scope.endorsement.init_date = $scope.endorsement.init_date
          ? $scope.endorsement.init_date
          : toDate($scope.startDate)),
        ($scope.endorsement.end_date = $scope.endorsement.end_date
          ? $scope.endorsement.end_date
          : toDate($scope.endDate)),
        ($scope.endorsement.status = $scope.checkRegister ? 2 : 5),
        ($scope.endorsement.prima_neta = $scope.dataToSave.p_neta
          ? $scope.dataToSave.p_neta
          : 0);
      $scope.endorsement.rpf = $scope.dataToSave.rpf
        ? $scope.dataToSave.rpf
        : 0;
      $scope.endorsement.derecho = $scope.dataToSave.derecho
        ? $scope.dataToSave.derecho
        : 0;
      $scope.endorsement.sub_total = $scope.dataToSave.sub_total
        ? $scope.dataToSave.sub_total
        : 0;
      $scope.endorsement.iva = $scope.dataToSave.iva
        ? $scope.dataToSave.iva
        : 0;
      $scope.endorsement.prima_total = $scope.dataToSave.p_total
        ? $scope.dataToSave.p_total
        : 0;
      $scope.endorsement.comision = $scope.dataToSave.comision
        ? $scope.dataToSave.comision
        : 0;
      $scope.endorsement.comision_percent = $scope.dataToSave.comision_percent
        ? $scope.dataToSave.comision_percent
        : 0;
      $scope.endorsement.endorsement_receipt = $scope.dataToSave.recibos_poliza
        ? $scope.dataToSave.recibos_poliza
        : [];
      $scope.endorsement.bono_variable = $scope.endorsement.bono_variable
        ? $scope.endorsement.bono_variable
        : 0;
      $scope.endorsement.date_bono = $scope.endorsement.date_bono
        ? datesFactory.toDate($scope.endorsement.date_bono)
        : null;
      $scope.endorsement.date_emision_factura = $scope.endorsement
        .date_emision_factura
        ? datesFactory.toDate($scope.endorsement.date_emision_factura)
        : null;
      $scope.endorsement.date_maquila = $scope.endorsement.date_maquila
        ? datesFactory.toDate($scope.endorsement.date_maquila)
        : null;
      $scope.endorsement.year_factura = $scope.endorsement.year_factura
        ? $scope.endorsement.year_factura
        : 0;
      $scope.endorsement.month_factura = $scope.endorsement.month
        ? $scope.endorsement.month.month_selected
        : 0;
      $scope.endorsement.folio_factura = $scope.endorsement.folio_factura
        ? $scope.endorsement.folio_factura
        : "";
      $scope.endorsement.maquila = $scope.endorsement.maquila
        ? parseFloat($scope.endorsement.maquila).toFixed(2)
        : 0;
      if ($scope.endorsement.endorsement_type == "D") {
        $scope.endorsement.prima_neta =
          parseFloat($scope.endorsement.prima_neta) * -1;
        $scope.endorsement.rpf = parseFloat($scope.endorsement.rpf) * -1;
        $scope.endorsement.derecho =
          parseFloat($scope.endorsement.derecho) * -1;
        $scope.endorsement.sub_total =
          parseFloat($scope.endorsement.sub_total) * -1;
        $scope.endorsement.iva = parseFloat($scope.endorsement.iva) * -1;
        $scope.endorsement.prima_total =
          parseFloat($scope.endorsement.prima_total) * -1;
      }

      $scope.data_endorsement = {
        certificados: $scope.certificates,
        endoso: $scope.endorsement,
      };

      if ($scope.endorsement.concept == 24) {
        $http({
          method: "POST",
          url: url.IP + "massive_upCertsByEndoso_fianza/",
          data: $scope.data_endorsement,
        })
          .then(function success(response) {
            if (response.status === 201 || response.status === 200) {
              if ($scope.countFile > 0) {
                $scope.endosoId = response.data.id;
                uploadFiles(response.data.id);
              } else {
                l.stop();
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.NEWENDORSEMENT,
                  "success"
                );
                $state.go("endorsement.details", {
                  endosoId: response.data.id,
                });
              }
            } else {
              l.stop();
              SweetAlert.swal("ERROR", "Ócurrio un error", "error");
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("error - caratula - catch", e);
          });
      } else if ($scope.endorsement.concept == 25) {
        $http({
          method: "POST",
          url: url.IP + "massive_downCertsByEndoso_fianza/",
          data: $scope.data_endorsement,
        })
          .then(function success(response) {
            if (response.status === 201 || response.status === 200) {
              if ($scope.countFile > 0) {
                $scope.endosoId = response.data.id;
                uploadFiles(response.data.id);
              } else {
                l.stop();
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.NEWENDORSEMENT,
                  "success"
                );
                $state.go("endorsement.details", {
                  endosoId: response.data.id,
                });
              }
            } else {
              l.stop();
              SweetAlert.swal("ERROR", "Ócurrio un error", "error");
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("error - caratula - catch", e);
          });
      } else {
        var endorsement_data = {
          number_endorsement: $scope.endorsement.number_endorsement
            ? $scope.endorsement.number_endorsement
            : "",
          concept: $scope.endorsement.concept,
          other_desc: $scope.endorsement.other_desc,
          original: JSON.stringify($scope.origin_endorsement),
          change: JSON.stringify($scope.endorsement.change),
          status: $scope.checkRegister ? 2 : 1,
          endorsement_type: $scope.endorsement.endorsement_type,
          init_date: $scope.endorsement.init_date,
          end_date: $scope.endorsement.end_date,
          observations: $scope.endorsement.observations,
          p_neta: $scope.dataToSave.p_neta ? $scope.dataToSave.p_neta : 0,
          rpf: $scope.dataToSave.rpf ? $scope.dataToSave.rpf : 0,
          derecho: $scope.dataToSave.derecho ? $scope.dataToSave.derecho : 0,
          sub_total: $scope.dataToSave.sub_total
            ? $scope.dataToSave.sub_total
            : 0,
          iva: $scope.dataToSave.iva ? $scope.dataToSave.iva : 0,
          p_total: $scope.dataToSave.p_total ? $scope.dataToSave.p_total : 0,
          comision: $scope.dataToSave.comision ? $scope.dataToSave.comision : 0,
          comision_percent: $scope.dataToSave.comision_percent
            ? $scope.dataToSave.comision_percent
            : 0,
          endorsement_receipt: $scope.dataToSave.recibos_poliza
            ? $scope.dataToSave.recibos_poliza
            : [],
          policy: $scope.surety.url,
        };
        endorsement_data.bono_variable = $scope.endorsement.bono_variable
          ? $scope.endorsement.bono_variable
          : 0;
        endorsement_data.date_bono = $scope.endorsement.date_bono
          ? $scope.endorsement.date_bono
          : null;
        endorsement_data.date_emision_factura = $scope.endorsement
          .date_emision_factura
          ? $scope.endorsement.date_emision_factura
          : null;
        endorsement_data.date_maquila = $scope.endorsement.date_maquila
          ? $scope.endorsement.date_maquila
          : null;
        endorsement_data.year_factura = $scope.endorsement.year_factura
          ? $scope.endorsement.year_factura
          : 0;
        endorsement_data.month_factura = $scope.endorsement.month
          ? $scope.endorsement.month.month_selected
          : 0;
        endorsement_data.folio_factura = $scope.endorsement.folio_factura
          ? $scope.endorsement.folio_factura
          : "";
        endorsement_data.maquila = $scope.endorsement.maquila
          ? parseFloat($scope.endorsement.maquila).toFixed(2)
          : 0;

        if ($scope.endorsement.endorsement_type == "D") {
          endorsement_data.p_neta = parseFloat(endorsement_data.p_neta) * -1;
          endorsement_data.rpf = parseFloat(endorsement_data.rpf) * -1;
          endorsement_data.derecho = parseFloat(endorsement_data.derecho) * -1;
          endorsement_data.sub_total =
            parseFloat(endorsement_data.sub_total) * -1;
          endorsement_data.iva = parseFloat(endorsement_data.iva) * -1;
          endorsement_data.p_total = parseFloat(endorsement_data.p_total) * -1;
        }

        if ($scope.endorsement.concept == 56) {
          endorsement_data.original = JSON.stringify($scope.origin_endorsement);
          endorsement_data.change = JSON.stringify($scope.certificates);
        }

        $http({
          method: "POST",
          url: url.IP + "endorsement/",
          data: endorsement_data,
        })
          .then(function success(response) {
            if (response.status === 201 || response.status === 200) {
              if (
                $scope.endorsement.concept == 34 &&
                response.data.status == 2
              ) {
                var x = [];
                $scope.surety.ref_policy.forEach(function (item) {
                  item.referenciador = item.referenciador.url;
                });
                $scope.payload_insurance = {
                  beneficiaries_poliza_many: $scope.beneficiaries,
                };
                $scope.surety.contract_poliza.deductible_percentage = $scope
                  .surety.contract_poliza.deductible_percentage
                  ? $scope.surety.contract_poliza.deductible_percentage
                  : 100;
                $scope.payload_insurance["contract_poliza"] =
                  $scope.surety.contract_poliza;
                $scope.payload_insurance["contract_poliza"]["poliza"] = null;
                $scope.payload_insurance["ref_policy"] =
                  $scope.surety.ref_policy;
                $scope.payload_insurance[""] =
                  $scope.surety.beneficiaries_poliza_many;
                console.log("fdsf", $scope.payload_insurance);
                $http
                  .patch(
                    $scope.surety.url.replace("polizas", "fianzas"),
                    $scope.payload_insurance
                  )
                  .then(function (responseInsurance) {
                    console.log("--d-sfs", responseInsurance);
                  });
              }
              if ($scope.countFile > 0) {
                $scope.endosoId = response.data.id;
                uploadFiles(response.data.id);
              } else {
                l.stop();
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.NEWENDORSEMENT,
                  "success"
                );
                $state.go("endorsement.details", {
                  endosoId: response.data.id,
                });
              }
            } else {
              l.stop();
              SweetAlert.swal("ERROR", "Ócurrio un error", "error");
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("error - caratula - catch", e);
          });
      }
      $localStorage.save_created_endoso_fianza_colectiva = {};
    };

    /* Configuracion del datepicker */
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndososFianzaInfoCtrl", EndososFianzaInfoCtrl);

  EndososFianzaInfoCtrl.$inject = [
    "datesFactory",
    "dataFactory",
    "$stateParams",
    "$scope",
    "formatValues",
    "$uibModal",
    "$http",
    "SweetAlert",
    "MESSAGES",
    "$state",
    "$sce",
    "url",
    "$localStorage",
    "emailService",
    "$sessionStorage",
    "FileUploader",
    "$timeout",
    "appStates",
  ];

  function EndososFianzaInfoCtrl(
    datesFactory,
    dataFactory,
    $stateParams,
    $scope,
    formatValues,
    $uibModal,
    $http,
    SweetAlert,
    MESSAGES,
    $state,
    $sce,
    url,
    $localStorage,
    emailService,
    $sessionStorage,
    FileUploader,
    $timeout,
    appStates,
    $uibModalInstance
  ) {
    var vm = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    if (usr) {
      if (usr.role) {
        if (usr.role[1]) {
          $scope.perfilUser = usr.role[1];
        }
      }
    }
    vm.policy_receipts = [];
    vm.createRecordatorio = createRecordatorio;
    vm.showRecordatorios = showRecordatorios;
    vm.endorsement_receipts = [];
    vm.getPDF = getPDF;
    vm.showBinnacleReceipt = showBinnacleReceipt;
    vm.showBinnacleNotes = showBinnacleNotes;
    vm.showBinnacleReceipt_Endoso = showBinnacleReceipt_Endoso;
    vm.showBinnacle = showBinnacle;
    vm.returnToReceipts = returnToReceipts;
    vm.returnToReceipts_End = returnToReceipts_End;
    vm.returnToNotes = returnToNotes;
    vm.viewCarta = viewCarta;
    $scope.end_obs_dis = true;
    vm.recordatoriosFlag = false;

    function showRecordatorios() {
      vm.recordatoriosFlag = true;
    }

    vm.table = {
      headers: [
        "Serie",
        "Prima neta",
        "Derecho",
        "RPF",
        "Iva",
        "Prima Total",
        "Estatus",
        "Acciones",
        "Vigencia",
        "Vencimiento",
      ],
    };

    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];

    vm.isCollapsed = false;
    // Function to toggle the collapse state
    vm.toggleCollapse = function () {
      vm.isCollapsed = !vm.isCollapsed;
    };
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
            if (acc.permission_name == "Eliminar endosos") {
              if (acc.checked == true) {
                vm.acceso_elim_end = true;
              } else {
                vm.acceso_elim_end = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Eliminar OTs") {
              if (acc.checked == true) {
                vm.acceso_elim_ot = true;
              } else {
                vm.acceso_elim_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                vm.acceso_canc_ot = true;
              } else {
                vm.acceso_canc_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          vm.acceso_ref = perm;
          vm.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                vm.acceso_adm_ref = true;
              } else {
                vm.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                vm.acceso_pag_ref = true;
              } else {
                vm.acceso_pag_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          vm.acceso_fian = perm;
          vm.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                vm.permiso_administrar_adjuntos = true;
              } else {
                vm.permiso_administrar_adjuntos = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cobranza = perm;
          vm.acceso_cobranza.permissions.forEach(function (acc) {
            if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                vm.permiso_delete_cobranza = true;
              } else {
                vm.permiso_delete_cobranza = false;
              }
            }
          });
        }
      });
    }

    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };

    function createRecordatorio(registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return vm.insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }

    $scope.monthEmision = function (parConcept) {
      switch (parConcept) {
        case 0:
          return "";
          break;
        case 1:
          return "Enero";
          break;
        case 2:
          return "Febrero";
          break;
        case 3:
          return "Marzo";
          break;
        case 4:
          return "Abril";
          break;
        case 5:
          return "Mayo";
          break;
        case 6:
          return "Junio";
          break;
        case 7:
          return "Julio";
          break;
        case 8:
          return "Agosto";
          break;
        case 9:
          return "Septiembre";
          break;
        case 10:
          return "Octubre";
          break;
        case 11:
          return "Noviembre";
          break;
        case 12:
          return "Diciembre";
          break;
        default:
          return "";
      }
    };
    /* Configuracion del datepicker */
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    $scope.concept = function (parConcept) {
      switch (parConcept) {
        case 34:
          return "CAMBIOS EN EL BENEFICIARIO";
          break;
        case 53:
          return "DETALLE DE GARANTÍA";
          break;
        case 54:
          return "PRORROGA DE VIGENCIA";
          break;
        case 55:
          return "ANUENCIA";
          break;
        case 24:
          return "ALTA DE CERTIFICADOS";
          break;
        case 25:
          return "BAJA DE CERTIFICADOS";
          break;
        case 56:
          return "CORRECCIÓN DE CERTIFICADOS";
          break;
        case 58:
          return "AUMENTO";
          break;
        case 59:
          return "DISMINUCIÓN";
          break;
        case 60:
          return "Anulación";
          break;
        case 61:
          return "Cancelación";
          break;
        case 62:
          return "Disminución y Prórroga";
          break;
        case 4:
          return "Endoso de texto / OTRO";
          break;
        default:
          return "OTRO";
      }
    };

    $scope.status = function (parConcept) {
      switch (parConcept) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Registrado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado";
          break;
        case 5:
          return "En trámite";
          break;
        case 6:
          return "Anulado";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.statusNotes = function (parStatus) {
      switch (parStatus) {
        case 1:
          return "Pendiente";
          break;
        case 2:
          return "Aplicada";
          break;
        case 3:
          return "Liquidada";
          break;
        case 4:
          return "Cancelada";
          break;
        case 5:
          return "Liquidada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.statusReceipts = function (parStatus) {
      switch (parStatus) {
        case 1:
          return "Pagado";
          break;
        case 2:
          return "Cancelado";
          break;
        case 3:
          return "Prorrogado";
          break;
        case 4:
          return "Pendiente de Pago";
          break;
        case 5:
          return "Liquidado";
          break;
        case 6:
          return "Conciliado";
          break;
        case 7:
          return "Cerrado";
          break;
        case 11:
          return "Preanulado";
        case 10:
          return "Anulado";
          break;
        default:
          return "Pendiente";
      }
    };

    activate();

    function activate() {
      dataFactory
        .get("endorsement-info/" + $stateParams.endosoId + "/")
        .then(function success(response) {
          vm.insurance = response.data;
          vm.insurance.change = vm.insurance.change.split("'").join('"');
          vm.insurance.change = vm.insurance.change.split("None").join('""');
          if (vm.insurance.change != "") {
            if (typeof vm.insurance.change == "string") {
              try {
                vm.insurance.change = JSON.parse(vm.insurance.change);
              } catch (err) {}
            }
          }
          if (vm.insurance.original != "") {
            if (typeof vm.insurance.original == "string") {
              try {
                vm.insurance.original = JSON.parse(vm.insurance.original);
              } catch (err) {}
            }
          }

          vm.endosoId = vm.insurance.id;
          dataFactory
            .get("endosos/" + vm.insurance.id + "/archivos/")
            .then(function success(response) {
              if (response.status === 200 || response.status == 201) {
                if (response.data.results.length) {
                  vm.files = response.data.results;
                }
              }
            });

          vm.policy_receipts = [];
          if (
            vm.insurance &&
            vm.insurance.policy &&
            vm.insurance.policy.recibos_poliza
          ) {
            vm.insurance.policy.recibos_poliza.forEach(function (recibo) {
              if (recibo.receipt_type == 1) {
                vm.policy_receipts.push(recibo);
              }
            });
          }
          vm.endorsement_receipts = vm.insurance.endorsement_receipt;

          $scope.calculatePrimas(vm.insurance.endorsement_receipt);

          if (!vm.insurance.migrated) {
            if (
              vm.insurance.concept == 24 ||
              vm.insurance.concept == 25 ||
              vm.insurance.concept == 56
            ) {
              vm.certificates = [];
              var data = {
                id_endoso: vm.insurance.id,
              };
              dataFactory
                .post("get-relation/", data)
                .then(function success(response) {
                  response.data.forEach(function (item) {
                    vm.certificates.push(item.certificate);
                  });
                  $scope.excelJson = vm.certificates;
                  $scope.addViews(0);
                });
            }
          }

          // comments
          $http({
            method: "GET",
            url: url.IP + "comments/",
            params: {
              model: 10,
              id_model: vm.endosoId,
            },
          })
            .then(function (request) {
              vm.comments_data = request.data.results;
              vm.comments_config = {
                count: request.data.count,
                next: request.data.next,
                previous: request.data.previous,
              };
            })
            .catch(function (e) {
              console.log("e", e);
            });

          $http({
            method: "GET",
            url: url.IP + "cartas-by-model",
            params: {
              model: 2,
            },
          }).then(function success(response) {
            vm.cartas = response.data;
          });
        });
    }

    $scope.openModal = function (task) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/tasks/task.modal.html",
        controller: "TareasModalCtrl",
        size: "lg",
        resolve: {
          task: function () {
            return task;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          receipt: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          activate();
        },
        function () {
          console.info("modal closed");
        }
      );
    };
    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item, options){
    //     return this.queue.length < 20;
    //   }
    // });
    $scope.changecomission = function (value) {
      var data_alert = {
        title: value == 1 ? "Comisión" : "Porcentaje Comisión",
        text: "Este cambio se aplicará en el recibo y la fianza.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };

      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          if (value == 2) {
            if (parseFloat(inputValue) > 100) {
              SweetAlert.swal(
                "Error",
                "El porcentaje no puede ser mayor a 100%.",
                "error"
              );
              return;
            }
            var data = {
              comision: (
                (vm.insurance.p_neta * parseFloat(inputValue).toFixed(2)) /
                100
              ).toFixed(2),
              comision_percent: parseFloat(inputValue).toFixed(2),
              endorsement_receipt: [],
            };
          }

          $http.patch(vm.insurance.url, data).then(function (response) {
            SweetAlert.swal(
              "¡Listo!",
              "Comisiones actualizadas exitosamente.",
              "success"
            );
            activate();
          });
          vm.insurance.endorsement_receipt.forEach(function (receipt) {
            $http
              .patch(receipt.url, { comision: data.comision })
              .then(function (response) {});
          });
          var paramsRec = {
            model: 10,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la comisión del recibo.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeFechaComision = function () {
      var data_alert = {
        title: "Fecha de Pago de Comisión",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              fecha_pago_comision: datesFactory.toDate(inputValue),
              endorsement_receipt: [],
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Endoso actualizado exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 10,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la fecha de pago de comisión.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.updateEndObs = function (insurance) {
      $http
        .patch(insurance.url, {
          observations: insurance.observations,
          endorsement_receipt: [],
        })
        .then(function (response) {
          SweetAlert.swal(
            "¡Listo!",
            "Endoso actualizado exitosamente.",
            "success"
          );
          activate();
        });
      var paramsRec = {
        model: 10,
        event: "PATCH",
        associated_id: insurance.id,
        identifier: " actualizó las observaciones del endoso.",
      };
      dataFactory
        .post("send-log/", paramsRec)
        .then(function success(response) {});
    };

    $scope.deleteFile = function (file, container, param) {
      $scope.model_log = 10;
      SweetAlert.swal(
        {
          title: "Eliminar Archivo",
          text: "No será posible recuperar este archivo, ¿Estás seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "GET",
              url: url.IP + "delete-manual",
              params: {
                file_id: file.id,
                typeFile: 2,
              },
            })
              .then(function success(response) {
                if (response.data.status == 204) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "El archivo fue eliminado exitosamente.",
                    "success"
                  );
                  var params = {
                    model: $scope.model_log,
                    event: "PATCH",
                    associated_id: param.id,
                    identifier: " elimino 1 archivo del endoso " + file.nombre,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  container.splice(container.indexOf(file), 1);
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
        }
      );
    };

    $scope.changeFechaEmisionF = function () {
      var data_alert = {
        title: "Fecha Emisión factura",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              date_emision_factura: datesFactory.toDate(inputValue),
              endorsement_receipt: [],
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Endoso de fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 10,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la fecha emisión de factura.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };

    $scope.changeFechaEntrega = function () {
      var data_alert = {
        title: "Fecha de Entrega",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              fecha_entrega: datesFactory.toDate(inputValue),
              endorsement_receipt: [],
            })
            .then(function (response) {
              vm.insurance.fecha_entrega = datesFactory.toDate(inputValue);
              SweetAlert.swal(
                "¡Listo!",
                "Endoso de fianza actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 10,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la fecha de entrega.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeFolioF = function () {
      var data_alert = {
        title: "Folio factura",
        text: "Escribe el folio de la factura.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              folio_factura: inputValue,
              endorsement_receipt: [],
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Endoso actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 10,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó el folio de la factura.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeMaquila = function () {
      var data_alert = {
        title: "Maquila",
        text: "Escribe el monto de la Maquila",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              maquila: parseFloat(inputValue).toFixed(2),
              endorsement_receipt: [],
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Endoso actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 10,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó el monto de la maquila.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };

    $scope.changeFechaMaquila = function () {
      var data_alert = {
        title: "Fecha Maquila",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              date_maquila: datesFactory.toDate(inputValue),
              endorsement_receipt: [],
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Endoso actualizada exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 10,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la fecha maquila de fianza.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeFechaBono = function () {
      var data_alert = {
        title: "Fecha de Bono",
        text: "Escribe el formato de fecha como DD/MM/AAAA.",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              date_bono: datesFactory.toDate(inputValue),
              endorsement_receipt: [],
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Endoso actualizado exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 10,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la fecha de bono de endoso.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.changeBono = function () {
      var data_alert = {
        title: "Bono Afianzadora",
        text: "Escribe el monto del Bono",
        type: "input",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (inputValue) {
        if (inputValue) {
          $http
            .patch(vm.insurance.url, {
              bono_variable: parseFloat(inputValue).toFixed(2),
              endorsement_receipt: [],
            })
            .then(function (response) {
              SweetAlert.swal(
                "¡Listo!",
                "Endoso actualizado exitosamente.",
                "success"
              );
              activate();
            });
          var paramsRec = {
            model: 10,
            event: "PATCH",
            associated_id: vm.insurance.id,
            identifier: " actualizó la cantidad del bono del endoso.",
          };
          dataFactory
            .post("send-log/", paramsRec)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Cancelado", "Se ha cancelado la acción.", "info");
        }
      });
    };
    $scope.month = {};
    $scope.month.month_selected = 1;
    $scope.month.options = [
      { value: 0, label: "" },
      { value: 1, label: "Enero" },
      { value: 2, label: "Febrero" },
      { value: 3, label: "Marzo" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Mayo" },
      { value: 6, label: "Junio" },
      { value: 7, label: "Julio" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Septiembre" },
      { value: 10, label: "Octubre" },
      { value: 11, label: "Noviembre" },
      { value: 12, label: "Diciembre" },
    ];
    $scope.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 10; i >= oldYear; i--) {
      $scope.years.push(i);
    }
    //--------------------------------
    $scope.openMonth = false;
    $scope.changeMesF = function () {
      $scope.openMonth = true;
    };
    $scope.changeMesF1 = function (mes) {
      $scope.openMonth = false;
      $http
        .patch(vm.insurance.url, {
          month_factura: mes,
          endorsement_receipt: [],
        })
        .then(function (response) {
          SweetAlert.swal(
            "¡Listo!",
            "Endoso actualizada exitosamente.",
            "success"
          );
          activate();
        });
      var paramsRec = {
        model: 10,
        event: "PATCH",
        associated_id: vm.insurance.id,
        identifier: " actualizó el mes emisión de la factura.",
      };
      dataFactory
        .post("send-log/", paramsRec)
        .then(function success(response) {});
    };
    $scope.openYear = false;
    $scope.changYearF = function () {
      $scope.openYear = true;
    };
    $scope.changeYearF1 = function (year) {
      $scope.openYear = false;
      $http
        .patch(vm.insurance.url, {
          year_factura: year,
          endorsement_receipt: [],
        })
        .then(function (response) {
          SweetAlert.swal(
            "¡Listo!",
            "Endoso actualizada exitosamente.",
            "success"
          );
          activate();
        });
      var paramsRec = {
        model: 10,
        event: "PATCH",
        associated_id: vm.insurance.id,
        identifier: " actualizó el año emisión de la factura.",
      };
      dataFactory
        .post("send-log/", paramsRec)
        .then(function success(response) {});
    };
    //*************************************
    $scope.addEmailsConfirmPolicy = function (insurance) {
      console.log(insurance);
      insurance.poliza = vm.insurance.policy;

      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return insurance;
          },
          valueReceipt: function () {
            return insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          activate();
          if ($uibModalInstance) {
            $uibModalInstance.close(200);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {};

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + endorsementId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.saveFiles = function (param) {
      uploadFiles(param.id);
    };

    $scope.checkNumEndoso = function () {
      if (vmm.number_endorsement) {
        dataFactory
          .get("exist-number-endorsement/", { number: vmm.number_endorsement })
          .then(function (request) {
            if (request.data.status == true) {
              SweetAlert.swal("Error", "Número de Endoso existente.", "error");
              vmm.number_endorsement = "";
            } else {
              $scope.registerEndorsement();
            }
          })
          .catch(function (err) {});
      }
    };

    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }

    function showBinnacleReceipt(param) {
      $scope.receiptmodel = param.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_receipt = request.data.results;
          vm.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.receipt_id = param.id;
      vm.show_binnacle_receipt = true;
    }

    function returnToReceipts() {
      vm.show_binnacle_receipt = false;
    }

    function showBinnacle(param) {
      $scope.receiptmodel = param.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 1,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.polizaId = param.id;
      vm.show_binnacle = true;
    }

    function showBinnacleNotes(param) {
      $scope.receiptmodel = param.url;
      vm.comments_data_notes = [];
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_notes = request.data.results;
          vm.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
      vm.receipt_id = param.id;
      vm.show_binnacle_notes = true;
    }

    function returnToNotes() {
      vm.show_binnacle_notes = false;
    }

    // recibo endoso
    function showBinnacleReceipt_Endoso(param) {
      $scope.receiptmodel = param.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data_receipt_endoso = request.data.results;
          vm.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.receipt_id = param.id;
      vm.show_binnacle_receipt_end = true;
    }

    function returnToReceipts_End() {
      vm.show_binnacle_receipt_end = false;
    }

    function viewCarta(endoso, poliza, carta) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-form/",
        params: {
          id_endoso: endoso,
          id_poliza: poliza,
          id_carta: carta,
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
      });
    }

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.goToPolicy = function (name, route, id) {
      if (vm.insurance.policy.document_type == 8) {
        var route = "fianzas.details";
      }
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, { polizaId: id });
    };

    $scope.goToEdit = function (id) {
      if (vm.insurance.policy.document_type == 7) {
        $state.go("endorsement.edit", { endosoId: id });
      } else if (vm.insurance.policy.document_type == 8) {
        $state.go("endorsement.update", { endosoId: id });
      }
    };

    $scope.deliveredReceipt = function (receipt) {
      SweetAlert.swal(
        {
          title: "Entregado",
          text: "Este recibo se marcara como entregado",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "PATCH",
              url: receipt.url,
              data: {
                delivered: true,
              },
            }).then(function success(response) {
              if (response.status == 200) {
                var params = {
                  model: 4,
                  event: "PATCH",
                  associated_id: response.data.id,
                  identifier: " actualizó el recibo a Entregado.",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                SweetAlert.swal("¡Listo!", "", "success");
                $state.go("endorsement.details", { endosoId: vm.insurance.id });
              }
            });
          }
        }
      );
    };

    $scope.cancelEndorsement = function () {
      SweetAlert.swal(
        {
          title: "¿Estas seguro?",
          text: "Los recibos pendientes se cancelarán.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .patch(vm.insurance.url, { status: 4 })
              .then(function success(response) {
                if (response.status === 200 || response.status === 201) {
                  vm.insurance.endorsement_receipt.forEach(function (recibo) {
                    if (recibo.status == 4) {
                      $http
                        .patch(recibo.url, { status: 2 })
                        .then(function () {});
                    }
                  });
                  if (vm.certificates) {
                    vm.certificates.forEach(function (inciso) {
                      if (inciso.certificate.certificado_inciso_activo) {
                        $http
                          .patch(inciso.certificate.url, {
                            certificado_inciso_activo: false,
                          })
                          .then(function () {});
                      } else {
                        $http
                          .patch(inciso.certificate.url, {
                            certificado_inciso_activo: true,
                          })
                          .then(function () {});
                      }
                    });
                  }
                  vm.patchEndoso = response.data;
                  var paramsE = {
                    model: 10,
                    event: "POST",
                    associated_id: vm.patchEndoso.id,
                    identifier: " canceló el endoso.",
                  };
                  dataFactory.post("send-log", paramsE);
                }
                SweetAlert.swal(
                  "¡Listo!",
                  "El endoso se ha actualizado.",
                  "success"
                );
              });
            swal.close();
            $state.go("endorsement.lista");
          }
        }
      );
    };

    $scope.sendProvider = function (provider) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/aseguradoras/send.modal.html",
        controller: "SendPDFModalCtrl",
        size: "md",
        resolve: {
          provider: function () {
            return provider;
          },
          typeOT: function () {
            return 2;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    $scope.deleteEndorsment = function (endoso) {
      SweetAlert.swal(
        {
          title: "Eliminar endoso",
          text: MESSAGES.WARNING.DELETENDO,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .patch(endoso.url, { status: 0 })
              .then(deletePolicyComplete)
              .catch(deletePolicyFailed);

            function deletePolicyComplete(response, status, headers, config) {
              if (response.status === 200 || response.status === 201) {
                vm.insurance.endorsement_receipt.forEach(function (receipt) {
                  var params = {
                    model: 4,
                    event: "PATCH",
                    associated_id: receipt.id,
                    identifier:
                      " actualizo el recibo a desactivado por eliminación de endoso.",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                });

                // if (endoso.status == 2) {
                //   if(vm.certificates){
                //     if (vm.certificates.length > 0) {
                //       var params = {
                //         'model': 10,
                //         'event': "POST",
                //         'associated_id': endoso.id,
                //         'identifier': " eliminó el endoso "+endoso.number_endorsement ? endoso.number_endorsement : '' + " y los certificados asociados"
                //         }
                //       dataFactory.post('send-log/', params).then(function success(response) {

                //       });
                //     }else{
                //       var params = {
                //         'model': 10,
                //         'event': "POST",
                //         'associated_id': endoso.id,
                //         'identifier': "eliminó el endoso."
                //         }
                //       dataFactory.post('send-log/', params).then(function success(response) {

                //       });
                //     }
                //   }
                // }else{
                //   var params = {
                //     'model': 10,
                //     'event': "POST",
                //     'associated_id': endoso.id,
                //     'identifier': "eliminó el endoso."
                //   }
                //   dataFactory.post('send-log/', params).then(function success(response) {

                //   });
                // }

                SweetAlert.swal("¡Listo!", MESSAGES.OK.DELETEENDOSO, "success");
                $state.go("endorsement.lista");
              }
            }

            function deletePolicyFailed(response, status, headers, config) {
              return response;
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "El endoso no se ha eliminado.",
              "error"
            );
          }
        }
      );
    };

    $scope.convertEndorsment = function (endoso) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/endoso/endosos.fianza.status.html",
        controller: EndososFianzaModalCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          endosoModal: function () {
            return vm.insurance;
          },
          certificates: function () {
            return vm.certificates;
          },
          endoso_status: function () {
            return 2;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function () {
        $state.go("endorsement.details", { endosoId: vm.insurance.id });
      });
    };

    $scope.anulateEndorsment = function (endoso) {
      SweetAlert.swal(
        {
          title: "Anular endoso",
          text: "¿Desea anular el endoso?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .patch(endoso.url, { status: 6 })
              .then(deletePolicyComplete)
              .catch(deletePolicyFailed);

            function deletePolicyComplete(response, status, headers, config) {
              if (response.status === 200 || response.status === 201) {
                endoso.status = 6;
                endoso.endorsement_receipt.forEach(function (receipt, index) {
                  if (receipt.status == 4) {
                    $http.patch(receipt.url, { status: 10 });
                    endoso.endorsement_receipt[index].status = 10;
                  }
                });
                SweetAlert.swal("¡Listo!", "Endoso anulado", "success");
                $state.go("endorsement.details", { endosoId: endoso.id });
              }
            }
            function deletePolicyFailed(response, status, headers, config) {
              return response;
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "El endoso no se ha anulado.",
              "error"
            );
          }
        }
      );
    };

    function getPDF(endoso) {
      var params = {
        poliza: vm.insurance.policy ? vm.insurance.policy.id : 0,
        fianza: vm.insurance.fianza ? vm.insurance.fianza.id : 0,
        endoso: vm.insurance.id,
      };

      $http({
        method: "GET",
        url: url.IP + "get-pdf-endorsement-new/",
        responseType: "arraybuffer",
        params: params,
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });

        var fileURL = URL.createObjectURL(file);
        $scope.content = $sce.trustAsResourceUrl(fileURL);
        window.open($scope.content);
      });
    }

    $scope.formatCoverage = function (parValue) {
      var res = parValue.replace("$", "");
      if (res) {
        var model = formatValues.currency(res);
        return model;
      } else {
        return "";
      }
    };

    $scope.selectEndoso = function (receipt, parEndoso) {
      $http.patch(receipt.url, { endorsement: parEndoso.url });
    };

    $scope.changeStatusModal = function (receipt, contra, insurance) {
      // receipt.contratante = contra.natural ? contra.natural : contra.juridical;
      receipt.contratante = contra.contractor ? contra.contractor : null;
      var modalInstance = $uibModal.open({
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return insurance;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function () {
        activate();
        $state.go("endorsement.details", { endosoId: vm.insurance.id });
      });
    };

    $scope.NotasModal = function (receipt) {
      var insurance = receipt;
      var modalInstance = $uibModal.open({
        templateUrl: "app/cobranzas/notaCredito.modal.html",
        controller: "NotaCreditoCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return insurance;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        vm.receipts.splice(index, 1);
        activate();
      });
    };

    $scope.changeStatus = function () {
      var modalInstance = $uibModal.open({
        templateUrl: "app/endoso/endosos.fianza.status.html",
        controller: EndososFianzaModalCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          endosoModal: function () {
            return vm.insurance;
          },
          certificates: function () {
            return vm.certificates;
          },
          endoso_status: function () {
            return 0;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function () {
        console.log("result2", result);
        activate();
      });
    };

    $scope.getLog = function () {
      dataFactory
        .get("get-specific-log", { model: 10, associated_id: vm.insurance.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
        });
    };

    $scope.editReceipt = function (receipt, index) {
      if (receipt.status == 4) {
        SweetAlert.swal(
          {
            title: "Advertencia",
            text: "Esta es una alternativa de emergencia, por el momento no se validarán las primas y ni las fechas al editar este recibo. ¿Deseas continuar?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var modalInstance = $uibModal.open({
                templateUrl: "app/colectividades/receipt.modal.html",
                controller: EditReceiptModalCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  recibo: function () {
                    return receipt;
                  },
                  index: function () {
                    return index;
                  },
                  endoso: function () {
                    return vm.insurance;
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });
            } else {
              SweetAlert.swal(
                "Cancelado",
                "El recibo no ha sido actualizado",
                "error"
              );
            }
          }
        );
      } else {
        SweetAlert.swal(
          "Advertencia",
          "El recibo no se puede editar porque no esta pendiente de pago.",
          "warning"
        );
      }
    };

    function EditReceiptModalCtrl(
      url,
      $http,
      $rootScope,
      recibo,
      index,
      endoso,
      $scope,
      $uibModalInstance
    ) {
      var rec = this;
      rec.recibo = recibo;
      rec.recibo.fecha_inicio = convertDate(recibo.fecha_inicio);
      rec.recibo.fecha_fin = convertDate(recibo.fecha_fin);
      rec.recibo.vencimiento = convertDate(recibo.vencimiento);

      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          var date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          var date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }
        return date;
      }

      function toDate(dateStr) {
        if (dateStr) {
          var dateString = dateStr; // Oct 23
          var dateParts = dateString.split("/");
          var dateObject = new Date(
            dateParts[2],
            dateParts[1] - 1,
            dateParts[0]
          ); // month is 0-based
          return dateObject;
        }
      }

      $scope.validateDecimal = function (form) {
        form = String(form).replace(/[A-Za-z]/g, "");
        form = String(form).replace(/,/g, "");
        return form;
      };

      $scope.changePrimas = function (data) {
        rec.recibo.sub_total = (
          parseFloat(data.prima_neta) +
          parseFloat(data.rpf) +
          parseFloat(data.derecho)
        ).toFixed(2);
        rec.recibo.prima_total = (
          parseFloat(rec.recibo.sub_total) + parseFloat(data.iva)
        ).toFixed(2);
      };

      $scope.saveReceipt = function (receipt) {
        if (process(receipt.fecha_fin) < process(receipt.fecha_inicio)) {
          SweetAlert.swal(
            "Error",
            "La fecha fin del recibo no puede ser menor a la de su inicio.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        var obj = {
          fecha_inicio: new Date(toDate(receipt.fecha_inicio)),
          fecha_fin: new Date(toDate(receipt.fecha_fin)),
          prima_neta: receipt.prima_neta,
          rpf: receipt.rpf,
          derecho: receipt.derecho,
          iva: receipt.iva,
          prima_total: receipt.prima_total,
          comision: receipt.comision,
          vencimiento: new Date(toDate(receipt.vencimiento)),
          delivered: receipt.delivered,
        };

        $http.patch(receipt.url, obj).then(function (response) {
          var params = {
            model: 10,
            event: "PATCH",
            associated_id: endoso.id,
            identifier: "actualizó el recibo " + receipt.recibo_numero + ".",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          var params = {
            model: 4,
            event: "POST",
            associated_id: receipt.id,
            identifier: "actualizó el recibo.",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          SweetAlert.swal("Listo", "El recibo ha sido actualizado", "success");
          $scope.cancel();
        });
      };
      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.calculatePrimas = function (receipts) {
      $scope.total_prima = 0;
      $scope.total_rpf = 0;
      $scope.total_derecho = 0;
      $scope.total_iva = 0;
      $scope.total_total = 0;
      $scope.total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 2 || receipts[i].receipt_type == 3) {
          $scope.total_prima =
            parseFloat($scope.total_prima) + parseFloat(receipts[i].prima_neta);
          $scope.total_rpf =
            parseFloat($scope.total_rpf) + parseFloat(receipts[i].rpf);
          $scope.total_derecho =
            parseFloat($scope.total_derecho) + parseFloat(receipts[i].derecho);
          $scope.total_iva =
            parseFloat($scope.total_iva) + parseFloat(receipts[i].iva);
          $scope.total_total =
            parseFloat($scope.total_total) +
            parseFloat(receipts[i].prima_total);
          $scope.total_comision =
            parseFloat($scope.total_comision) +
            parseFloat(receipts[i].comision);
        }
      }
    };

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    // MODAL ENDOSOS
    function EndososFianzaModalCtrl(
      $scope,
      endorsement,
      endosoModal,
      FileUploader,
      $sessionStorage,
      url,
      datesFactory,
      $state,
      $uibModalInstance,
      $timeout,
      SweetAlert,
      MESSAGES,
      certificates,
      endoso_status
    ) {
      var vmm = this;
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.years = [];
      var actualYear = new Date().getFullYear();
      var oldYear = actualYear - 80;
      for (var i = actualYear + 10; i >= oldYear; i--) {
        $scope.years.push(i);
      }

      vmm.month = {};
      vmm.month.month_selected = 1;
      vmm.month.options = [
        { value: 0, label: "" },
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Septiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" },
      ];
      $scope.countFile = 0;
      $scope.okFile = 0;
      vmm.accesos = $sessionStorage.permisos;
      vmm.accesos.forEach(function (acceso) {
        if (acceso.model_name == "Endosos") {
          vmm.acceso_endosos = acceso;
          vmm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vmm.acceso_reg_end = true;
              } else {
                vmm.acceso_reg_end = false;
              }
            }
          });
        }
      });

      $scope.checkNumEndoso = function () {
        if (vmm.number_endorsement) {
          dataFactory
            .get("exist-number-endorsement/", {
              number: vmm.number_endorsement,
              poliza: vmm.endorsement.policy.poliza_number,
            })
            .then(function (request) {
              if (request.data.status == true) {
                SweetAlert.swal("Error", "Número de Endoso existente", "error");
                vmm.number_endorsement = "";
              } else {
                $scope.registerEndorsement();
              }
            })
            .catch(function (err) {});
        }
      };

      vmm.status = [
        { value: 1, label: "PENDIENTE" },
        { value: 2, label: "REGISTRADO" },
        { value: 3, label: "RECHAZADO" },
        { value: 4, label: "CANCELADO" },
        { value: 5, label: "EN TRÁMITE" },
      ];
      vmm.endorsement = endosoModal;
      vmm.endoso_status = endoso_status;

      $scope.directiveReceipts = {
        comisiones: [],
        end_of_validity: convertDate(vmm.endorsement.end_date),
        endingDate: convertDate(vmm.endorsement.end_date),
        num_receipts: 1,
        payment: 5,
        policy_days_duration: 365,
        start_of_validity: convertDate(vmm.endorsement.init_date),
        startDate: convertDate(vmm.endorsement.init_date),
        subramo: vmm.endorsement.policy.subramo,
        type_endorsement: vmm.endorsement.endorsement_type,
      };

      $scope.dataToSave = {
        comision: 0,
        comision_percent: 0,
      };
      $scope.checkFechaFactura = function (date) {
        var date_initial = date.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);
        vmm.month.month_selected = parseInt(month);
        vmm.year_factura = year;
      };
      $http
        .get(
          url.IP + "claves-by-provider/" + vmm.endorsement.policy.aseguradora.id
        )
        .then(
          function success(clavesResponse) {
            clavesResponse.data.forEach(function (clave) {
              clave.clave_comision.forEach(function (item) {
                item.efective_date = new Date(item.efective_date)
                  .toISOString()
                  .split("T")[0];
                if (vmm.endorsement.policy.aseguradora) {
                  if (
                    vmm.endorsement.policy.subramo.subramo_name == item.subramo
                  ) {
                    $scope.directiveReceipts.comisiones.push(item);
                  }
                } else {
                  if (vmm.endorsement.policy.subramo == item.subramo) {
                    $scope.directiveReceipts.comisiones.push(item);
                  }
                }
              });
            });
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      $scope.status = function (parConcept) {
        switch (parConcept) {
          case 1:
            return "Pendiente";
            break;
          case 3:
            return "Rechazado";
            break;
          case 4:
            return "Cancelado";
            break;
          case 5:
            return "En trámite";
            break;
          default:
            return "Pendiente";
        }
      };

      $scope.rejectEndorsement = function () {
        $http
          .patch(vmm.endorsement.url, { status: vmm.selectedType.value })
          .then(function success(response) {
            if (response.status === 200 || response.status === 201) {
              vm.patchEndoso = response.data;
              if (vmm.selectedType.value == 3) {
                var parIdentifier = "rechazó el endoso.";
              } else if (vmm.selectedType.value == 4) {
                var parIdentifier = "canceló el endoso.";
              } else {
                var parIdentifier = " modifico endoso";
              }
              var paramsE = {
                model: 10,
                event: "POST",
                associated_id: vm.patchEndoso.id,
                identifier: parIdentifier,
              };
              dataFactory.post("send-log", paramsE);
            }
          });
        $uibModalInstance.dismiss("cancel");
        $state.go("endorsement.lista");
      };

      $scope.registerEndorsement = function () {
        if (!vmm.number_endorsement) {
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORNUMBERENDORSEMENT,
            "error"
          );
          return;
        }
        if (
          vmm.endorsement.endorsement_type == "A" ||
          vmm.endorsement.endorsement_type == "D"
        ) {
          if (!$scope.dataToSave.recibos_poliza) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
            return;
          }
        }

        if ($scope.dataToSave.recibos_poliza) {
          $scope.dataToSave.recibos_poliza.forEach(function (item) {
            try {
              item.fecha_inicio = toDate(item.startDate);
              item.fecha_fin = toDate(item.endingDate);
              item.vencimiento = toDate(item.vencimiento);
            } catch (err) {}
          });
        }

        $scope.dataToPatch = {
          status: 2,
          number_endorsement: vmm.number_endorsement,
          p_neta: $scope.dataToSave.p_neta ? $scope.dataToSave.p_neta : 0,
          rpf: $scope.dataToSave.rpf ? $scope.dataToSave.rpf : 0,
          derecho: $scope.dataToSave.derecho ? $scope.dataToSave.derecho : 0,
          sub_total: $scope.dataToSave.sub_total
            ? $scope.dataToSave.sub_total
            : 0,
          iva: $scope.dataToSave.iva ? $scope.dataToSave.iva : 0,
          p_total: $scope.dataToSave.p_total ? $scope.dataToSave.p_total : 0,
          comision: $scope.dataToSave.comision ? $scope.dataToSave.comision : 0,
          comision_percent: $scope.dataToSave.comision_percent
            ? $scope.dataToSave.comision_percent
            : 0,
          endorsement_receipt: $scope.dataToSave.recibos_poliza
            ? $scope.dataToSave.recibos_poliza
            : [],
          date_emision_factura: vmm.date_emision_factura
            ? datesFactory.toDate(vmm.date_emision_factura)
            : null,
          date_maquila: vmm.date_maquila
            ? datesFactory.toDate(vmm.date_maquila)
            : null,
          year_factura: vmm.year_factura ? vmm.year_factura : 0,
          month_factura: vmm.month ? vmm.month.month_selected : 0,
          folio_factura: vmm.folio_factura ? vmm.folio_factura : "",
          maquila: vmm.maquila ? parseFloat(vmm.maquila).toFixed(2) : 0,
          bono_variable: vmm.bono_variable ? vmm.bono_variable : "",
          date_bono: vmm.date_bono ? datesFactory.toDate(vmm.date_bono) : null,
        };

        if (vmm.endorsement.endorsement_type == "D") {
          $scope.dataToPatch.p_neta =
            parseFloat($scope.dataToPatch.p_neta) * -1;
          $scope.dataToPatch.rpf = parseFloat($scope.dataToPatch.rpf) * -1;
          $scope.dataToPatch.derecho =
            parseFloat($scope.dataToPatch.derecho) * -1;
          $scope.dataToPatch.sub_total =
            parseFloat($scope.dataToPatch.sub_total) * -1;
          $scope.dataToPatch.iva = parseFloat($scope.dataToPatch.iva) * -1;
          $scope.dataToPatch.p_total =
            parseFloat($scope.dataToPatch.p_total) * -1;
        }

        if (
          vmm.endorsement.concept == 53 &&
          vmm.endorsement.policy.document_type != 8
        ) {
          $scope.dataToPatch.original = JSON.stringify(
            angular.copy(vmm.endorsement.policy.contract_poliza)
          );
        }

        if (
          vmm.endorsement.concept == 34 &&
          vmm.endorsement.policy.document_type != 8
        ) {
          $scope.dataToPatch.original = JSON.stringify(
            angular.copy(vmm.endorsement.policy.beneficiaries_poliza_many)
          );
        }
        if (
          vmm.endorsement.concept == 54 &&
          vmm.endorsement.policy.document_type != 8
        ) {
          $scope.dataToPatch.original = vmm.endorsement.policy.end_of_validity;
        }

        $http
          .patch(vmm.endorsement.url, $scope.dataToPatch)
          .then(function success(response) {
            vm.patchEndoso = response.data;

            var to_change = {};
            // if(vmm.endorsement.concept != 55 && vmm.endorsement.concept != 4 && vmm.endorsement.policy.document_type != 8){
            if (vmm.endorsement.concept != 55 && vmm.endorsement.concept != 4) {
              var payload_insurance = {};
              if (vmm.endorsement.concept == 53) {
                to_change = JSON.parse(vm.patchEndoso.change);
                payload_insurance = {
                  contract_poliza: to_change,
                };
                payload_insurance["contract_poliza"]["poliza"] = null;
                payload_insurance["ref_policy"] =
                  vmm.endorsement.policy.ref_policy;
                payload_insurance["beneficiaries_poliza_many"] =
                  vmm.endorsement.policy.beneficiaries_poliza_many;
              }
              if (vmm.endorsement.concept == 34) {
                to_change = JSON.parse(vm.patchEndoso.change);
                payload_insurance = {
                  beneficiaries_poliza_many: to_change,
                };
                payload_insurance["contract_poliza"] =
                  vmm.endorsement.policy.contract_poliza;
                payload_insurance["contract_poliza"]["poliza"] = null;
                payload_insurance["ref_policy"] =
                  vmm.endorsement.policy.ref_policy;
                payload_insurance[""] =
                  vmm.endorsement.policy.beneficiaries_poliza_many;
              }
              if (vmm.endorsement.concept == 54) {
                to_change = JSON.parse(vm.patchEndoso.change);
                payload_insurance = {
                  end_of_validity: to_change,
                };
                payload_insurance["ref_policy"] =
                  vmm.endorsement.policy.ref_policy;
                payload_insurance["beneficiaries_poliza_many"] =
                  vmm.endorsement.policy.beneficiaries_poliza_many;
                payload_insurance["contract_poliza"] =
                  vmm.endorsement.policy.contract_poliza;
                payload_insurance["contract_poliza"]["poliza"] = null;
                try {
                  payload_insurance["contract_poliza"].end =
                    datesFactory.toDate(payload_insurance.contract_poliza.end);
                  payload_insurance["contract_poliza"].start =
                    datesFactory.toDate(
                      payload_insurance.contract_poliza.start
                    );
                  payload_insurance["contract_poliza"].sign_date =
                    datesFactory.toDate(
                      payload_insurance.contract_poliza.sign_date
                    );
                } catch (err) {}
              }
              try {
                payload_insurance["contract_poliza"].end = datesFactory.toDate(
                  payload_insurance.contract_poliza.end
                );
                payload_insurance["contract_poliza"].start =
                  datesFactory.toDate(payload_insurance.contract_poliza.start);
                payload_insurance["contract_poliza"].sign_date =
                  datesFactory.toDate(
                    payload_insurance.contract_poliza.sign_date
                  );
              } catch (err) {}
              if (payload_insurance.contract_poliza == undefined) {
                payload_insurance.contract_poliza = {};
              }
              if (payload_insurance.ref_policy == undefined) {
                payload_insurance.ref_policy = {};
              }

              $http
                .patch(
                  vmm.endorsement.policy.url.replace("polizas", "fianzas"),
                  payload_insurance
                )
                .then(function (responseInsurance) {
                  dataFactory.post("send-log/", {
                    model: 10,
                    event: "POST",
                    associated_id: response.data.id,
                    identifier:
                      "Registró el endoso tipo " +
                      vm.patchEndoso.endorsement_type,
                  });
                  $state.go("endorsement.details", {
                    endosoId: response.data.id,
                  });
                });
            }

            var params = {
              model: 10,
              event: "POST",
              associated_id: response.data.id,
              identifier: "actualizó el endoso a registrado.",
            };
            dataFactory.post("send-log/", params);

            if ($scope.countFile > 0) {
              $scope.endosoId = response.data.id;
              uploadFiles(response.data.id);
            } else {
              $state.go("endorsement.details", { endosoId: vm.patchEndoso.id });
              SweetAlert.swal(
                "¡Listo!",
                "Endoso registrado exitosamente.",
                "success"
              );
              activate();
              $scope.cancel();
            }
          });
      };

      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        if (indicator) {
          var date = [
            pad(d.getDate() + 1),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        } else {
          var date = [
            pad(d.getDate()),
            pad(d.getMonth() + 1),
            d.getFullYear(),
          ].join("/");
        }

        return date;
      }

      function toDate(dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

        return dateObject;
      }
      $scope.concepAn = function (r) {
        switch (r) {
          case 1:
            return "PreAnulada";
            break;
          case 2:
            return "Pr error de captura";
            break;
          case 3:
            return "Por reexpedición";
            break;
          case 4:
            return "Por falta de pago";
            break;
          case 5:
            return "Solo anular";
            break;
          default:
            return "OTRO";
        }
      };
      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };

      /** Uploader files */
      $scope.userInfo = {
        id: 0,
      };
      $scope.countFile = 0;
      $scope.okFile = 0;

      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      //   name: 'customFilter',
      //   fn: function(item, options){
      //     return this.queue.length < 20;
      //   }
      // });

      // ALERTA SUCCES UPLOADFILES
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
        $scope.okFile++;
        if ($scope.okFile == $scope.countFile) {
          $timeout(function () {
            $state.go("endorsement.details", { endosoId: vm.patchEndoso.id });
            SweetAlert.swal(
              "¡Listo!",
              "Endoso registrado exitosamente.",
              "success"
            );
            activate();
            if ($uibModalInstance) {
              $uibModalInstance.close(200);
            }
          }, 1000);
        }
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {};

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
          nombre: fileItem.file.name,
        });

        if (fileItem) {
          $scope.countFile++;
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        if (item.file.sensible != undefined) {
          item.formData[0].sensible = item.file.sensible;
        }
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
      };

      function uploadFiles(endorsementId) {
        $scope.userInfo = {
          id: endorsementId,
        };
        $scope.userInfo.url = $scope.uploader.url =
          url.IP + "endosos/" + endorsementId + "/archivos/";

        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }

      /* Configuracion del datepicker */

      $(".datepicker-me input").datepicker();

      $.fn.datepicker.defaults.format = "dd/mm/yyyy";
      $.fn.datepicker.defaults.startView = 0;
      $.fn.datepicker.defaults.autoclose = true;
      $.fn.datepicker.defaults.language = "es";
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("EndososSuretyCtrl", EndososSuretyCtrl);

  EndososSuretyCtrl.$inject = [
    "SweetAlert",
    "MESSAGES",
    "$state",
    "FileUploader",
    "$stateParams",
    "url",
    "$sessionStorage",
    "dataFactory",
    "$scope",
    "$parse",
    "$http",
    "datesFactory",
    "providerService",
    "toaster",
    "$localStorage",
    "$rootScope",
  ];

  function EndososSuretyCtrl(
    SweetAlert,
    MESSAGES,
    $state,
    FileUploader,
    $stateParams,
    url,
    $sessionStorage,
    dataFactory,
    $scope,
    $parse,
    $http,
    datesFactory,
    providerService,
    toaster,
    $localStorage,
    $rootScope
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    $scope.endorsement = {
      concept: "",
    };
    vm.to_search = { val: "" };

    // vm.checkRegister = false;
    vm.checkRegister = true;
    vm.form = {
      contract_poliza: {},
      anuency: datesFactory.convertDate(new Date()),
    };
    // vm.to_receipts = {}
    vm.showFinder = true;
    activate();

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          vm.acceso_fian = perm;
          vm.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                vm.permiso_administrar_adjuntos = true;
              } else {
                vm.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }
    vm.types = [
      {
        id: "A",
        name: "A (CON RECIBOS)",
      },
      {
        id: "B",
        name: "B (SIN RECIBOS)",
      },
      {
        id: "D",
        name: "D (CON NOTAS DE CRÉDITO)",
      },
    ];
    $scope.concepts = [
      { label: "Detalle de Garantía", value: 53 },
      { label: "Prórroga de vigencia", value: 54 },
      { label: "Aumento", value: 58 }, //A
      { label: "Disminución", value: 59 }, //B
      { label: "Anulación", value: 60 }, //D
      { label: "Cancelación", value: 61 }, //B
      { label: "Anuencia", value: 55 }, //B
      { label: "Endoso de texto / Otro", value: 4 }, //B
      { label: "Aumento y Prórroga", value: 57 },
      { label: "Disminución y Prórroga", value: 62 },
      { label: "Cambios en el Beneficiario ", value: 34 },
      //{label: 'Otro', value: 4},
    ];

    // {label: 'Detalle de Garantía', value: 1},
    //   {label: 'Prorroga de vigencia', value: 2},
    //   {label: 'Cambios en el Beneficiario ', value: 5},
    //   {label: 'Otro', value: 4},
    vm.findContractor = findContractor;
    vm.getPolicy = getPolicy;
    vm.save = save;
    vm.changeConcept = changeConcept;
    vm.registry_endorsement = registry_endorsement;
    vm.changeTipo = changeTipo;
    vm.addBene = addBene;
    vm.deleteBene = deleteBene;
    vm.getComisions = getComisions;
    function changeTipo(tipo) {
      // vm.checkRegister = false;
      getComisions(tipo);
    }

    function addBene() {
      var beneficiario = {
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        type_person: 1,
      };
      if (vm.form.beneficiaries_fianza) {
        vm.form.beneficiaries_fianza.push(beneficiario);
      } else {
        vm.form.beneficiaries_fianza = [];
        vm.form.beneficiaries_fianza.push(beneficiario);
      }
    }

    function deleteBene(index) {
      if (vm.form.beneficiaries_fianza.length > 1) {
        vm.form.beneficiaries_fianza.splice(index, 1);
      }
    }

    function getComisions(tipo) {
      if (vm.fianzacomplete) {
        $http
          .get(url.IP + "ramos-by-provider/" + vm.fianzacomplete.aseguradora.id)
          .then(
            function success(response) {
              $scope.ramos = response.data;
              $scope.ramos.forEach(function (item) {
                if (item.ramo_name == vm.fianzacomplete.ramo) {
                  $scope.ramoSelected = item;
                  $scope.subramos = item.subramo_ramo;
                  $scope.subramos.forEach(function (subramo) {
                    if (subramo.subramo_name == vm.fianzacomplete.subramo) {
                      $scope.subramoSelected = subramo;
                      if (vm.to_receipts) {
                        vm.to_receipts.subramo = subramo;
                        vm.to_receipts.comision_percent =
                          vm.fianzacomplete.comision_percent;
                        vm.to_receipts.subramo = subramo;
                        vm.to_receipts.num_receipts = 1;
                        vm.to_receipts.startDate = datesFactory.convertDate(
                          datesFactory.toDate(vm.form.start_of_validity)
                        );
                        vm.to_receipts.endingDate = datesFactory.convertDate(
                          datesFactory.toDate(vm.form.end_of_validity)
                        );
                      } else {
                        vm.to_receipts = {
                          type_endorsement:
                            vm.insurance.type_endorsement &&
                            vm.insurance.type_endorsement.id
                              ? vm.insurance.type_endorsement.id
                              : vm.insurance.type_endorsement,
                          start_of_validity: datesFactory.convertDate(
                            datesFactory.toDate(vm.form.start_of_validity)
                          ),
                          end_of_validity: datesFactory.convertDate(
                            datesFactory.toDate(vm.form.end_of_validity)
                          ),
                          num_receipts: 1,
                          payment: 5,
                          policy_days_duration: 365,
                          is_fianza: true,
                          comisiones: vm.insurance.comisiones,
                          subramo: {
                            id: "",
                            subramo_name: vm.insurance.subramo,
                          },
                          startDate: datesFactory.convertDate(
                            datesFactory.toDate(vm.form.start_of_validity)
                          ),
                          endingDate: datesFactory.convertDate(
                            datesFactory.toDate(vm.form.end_of_validity)
                          ),
                        };
                      }
                      var comisiones = [];
                      if ($scope.claveSelected) {
                        if ($scope.claveSelected.clave_comision) {
                          if ($scope.claveSelected.clave_comision.length) {
                            $scope.claveSelected.clave_comision.forEach(
                              function (item2) {
                                if (
                                  $scope.subramoSelected.subramo_name ==
                                  item2.subramo
                                ) {
                                  comisiones.push(item2);
                                }
                              }
                            );
                          }
                        }
                      }
                      vm.to_receipts.comisiones = comisiones;
                      vm.to_receipts.num_receipts = 1;
                      if (tipo) {
                        vm.to_receipts.type_endorsement = tipo;
                      }
                      $localStorage["save_created_endoso_fianza"] = {};
                    }
                  });
                }
              });
            },
            function error(e) {
              console.log("Error - ramos-by-provider", e);
            }
          )
          .catch(function (error) {
            console.log("Error - ramos-by-provider - catch", error);
          });
        console.log("=========", vm.to_receipts);
      }
    }
    function registry_endorsement() {
      if (
        vm.insurance.type_endorsement == "" ||
        !vm.insurance.type_endorsement
      ) {
        toaster.error("Seleccione un tipo de endoso");
        vm.checkRegister = true;
        vm.to_receipts = {
          type_endorsement:
            vm.insurance.type_endorsement && vm.insurance.type_endorsement.id
              ? vm.insurance.type_endorsement.id
              : vm.insurance.type_endorsement,
          start_of_validity: datesFactory.convertDate(
            datesFactory.toDate(vm.form.start_of_validity)
          ),
          end_of_validity: datesFactory.convertDate(
            datesFactory.toDate(vm.form.end_of_validity)
          ),
          num_receipts: 1,
          payment: 5,
          policy_days_duration: 365,
          is_fianza: true,
          comisiones: vm.insurance.comisiones,
          subramo: { id: "", subramo_name: vm.insurance.subramo },
          startDate: datesFactory.convertDate(
            datesFactory.toDate(vm.form.start_of_validity)
          ),
          endingDate: datesFactory.convertDate(
            datesFactory.toDate(vm.form.end_of_validity)
          ),
        };
        getComisions(vm.fianzacomplete);
        return;
      }
      vm.to_receipts = {
        type_endorsement:
          vm.insurance.type_endorsement && vm.insurance.type_endorsement.id
            ? vm.insurance.type_endorsement.id
            : vm.insurance.type_endorsement,
        start_of_validity: datesFactory.convertDate(
          datesFactory.toDate(vm.form.start_of_validity)
        ),
        end_of_validity: datesFactory.convertDate(
          datesFactory.toDate(vm.form.end_of_validity)
        ),
        num_receipts: 1,
        payment: 5,
        policy_days_duration: 365,
        is_fianza: true,
        comisiones: vm.insurance.comisiones,
        subramo: { id: "", subramo_name: vm.insurance.subramo },
      };
    }

    function changeConcept(param) {
      vm.insurance.concept = param.value;
      $scope.conceptSelected = param;
      if (vm.insurance.concept == 53) {
        vm.insurance.type_endorsement = {
          id: "A",
          name: "A (CON RECIBOS)",
        };
      } else if (vm.insurance.concept == 4) {
        vm.insurance.type_endorsement = {
          id: "B",
          name: "B (SIN RECIBOS)",
        };
      } else if (vm.insurance.concept == 54) {
        vm.form.start_of_validity = datesFactory.convertDate(
          vm.insurance.end_of_validity
        );
        vm.insurance.type_endorsement = {
          id: "A",
          name: "A (CON RECIBOS)",
        };
      } else if (vm.insurance.concept == 57) {
        vm.insurance.type_endorsement = {
          id: "A",
          name: "A (CON RECIBOS)",
        };
      } else if (vm.insurance.concept == 62) {
        vm.insurance.type_endorsement = {
          id: "B",
          name: "B (SIN RECIBOS)",
        };
      } else if (vm.insurance.concept == 58) {
        vm.insurance.type_endorsement = {
          id: "A",
          name: "A (CON RECIBOS)",
        };
      } else if (vm.insurance.concept == 59) {
        vm.insurance.type_endorsement = {
          id: "B",
          name: "B (SIN RECIBOS)",
        };
      } else if (vm.insurance.concept == 60) {
        if (vm.insurance.status == 14) {
          vm.concept_anulacion = [
            { value: 1, label: "PreAnulada" },
            { value: 2, label: "Por error de captura" },
            { value: 3, label: "Por reexpedición" },
            { value: 4, label: "Por falta de pago" },
            { value: 5, label: "Otro (sólo anular)" },
          ];
        } else {
          vm.concept_anulacion = [
            { value: 2, label: "Por error de captura" },
            { value: 3, label: "Por Reexpedición" },
            { value: 4, label: "Por falta de Pago" },
            { value: 5, label: "Otro (Sólo anular)" },
          ];
        }
        vm.conceptAnnulment = vm.concept_anulacion[0].value;
        vm.reason_cancel = vm.insurance.reason_cancel;
        vm.insurance.type_endorsement = {
          id: "D",
          name: "D (CON NOTAS DE CRÉDITO)",
        };
      } else if (vm.insurance.concept == 61) {
        vm.insurance.type_endorsement = {
          id: "B",
          name: "B (SIN RECIBOS)",
        };
      } else if (vm.insurance.concept == 55 || vm.insurance.concept == 34) {
        vm.insurance.type_endorsement = {
          id: "B",
          name: "B (SIN RECIBOS)",
        };
      } else {
        vm.insurance.type_endorsement = "";
      }
      if (vm.insurance.concept == 34) {
        if (
          vm.insurance.beneficiaries_poliza_many &&
          vm.insurance.beneficiaries_poliza_many.length > 0
        ) {
          vm.form.beneficiaries_fianza = angular.copy(
            vm.insurance.beneficiaries_poliza_many
          );
        } else {
          addBene();
        }
      }
      // vm.to_receipts = {};
      // vm.checkRegister = false;
      vm.checkRegister = true;
      if (vm.insurance) {
        if (vm.insurance.type_endorsement) {
          if (vm.insurance.type_endorsement.id) {
            getComisions(vm.insurance.type_endorsement.id);
          }
        }
      }
    }

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Anulada";
          break;
        case 14:
          return "Vigente";
          break;
        case 0:
          return "Eliminada";
          break;
        default:
          return "Vigente";
      }
    };

    function activate_end() {
      vm.checkRegister = true;
      if (
        vm.insurance.subramo == "Obra" ||
        vm.insurance.subramo == "Proveeduria"
      ) {
        if ($scope.concepts.length == 4) {
          $scope.concepts.push({ label: "Anuencia", value: 55 });
        }
      }
      vm.form.start_of_validity = datesFactory.convertDate(new Date());
      vm.form.end_of_validity = datesFactory.convertDate(
        vm.insurance.end_of_validity
      );

      vm.form.contract_poliza = angular.copy(vm.insurance.contract_poliza);

      try {
        vm.form.contract_poliza.guarantee_amount = parseFloat(
          vm.insurance.contract_poliza.guarantee_amount
        );
        vm.form.contract_poliza.rate = parseFloat(
          vm.insurance.contract_poliza.rate
        );
        vm.form.contract_poliza.description =
          vm.insurance.contract_poliza.description;

        vm.form.contract_poliza.business_activity =
          vm.insurance.contract_poliza.business_activity;
        vm.form.contract_poliza.activity =
          vm.insurance.contract_poliza.activity;
        vm.form.contract_poliza.employee_name =
          vm.insurance.contract_poliza.employee_name;
        vm.form.contract_poliza.deductible_percentage = parseFloat(
          vm.insurance.contract_poliza.deductible_percentage
        );
        vm.form.contract_poliza.number = vm.insurance.contract_poliza.number;
        vm.form.contract_poliza.start = datesFactory.convertDate(
          vm.insurance.contract_poliza.start
        );
        vm.form.contract_poliza.end = datesFactory.convertDate(
          vm.insurance.contract_poliza.end
        );
        vm.form.contract_poliza.sign_date = datesFactory.convertDate(
          vm.insurance.contract_poliza.sign_date
        );
        vm.form.contract_poliza.amount = parseFloat(
          vm.insurance.contract_poliza.amount
        );
        vm.form.contract_poliza.amount_iva = parseFloat(
          vm.insurance.contract_poliza.amount_iva
        );
        vm.form.contract_poliza.guarantee_percentage = parseFloat(
          vm.insurance.contract_poliza.guarantee_percentage
        );
        vm.form.contract_poliza.id = parseFloat(
          vm.insurance.contract_poliza.id
        );
      } catch (err) {}
      vm.form.beneficiaries_fianza = angular.copy(
        vm.insurance.beneficiaries_poliza_many
      );
      vm.to_receipts = {
        type_endorsement:
          vm.insurance.type_endorsement && vm.insurance.type_endorsement.id
            ? vm.insurance.type_endorsement.id
            : vm.insurance.type_endorsement,
        start_of_validity: datesFactory.convertDate(
          datesFactory.toDate(vm.form.start_of_validity)
        ),
        end_of_validity: datesFactory.convertDate(
          datesFactory.toDate(vm.form.end_of_validity)
        ),
        num_receipts: 1,
        payment: 5,
        policy_days_duration: 365,
        is_fianza: true,
        comisiones: vm.insurance.comisiones,
        subramo: { id: "", subramo_name: vm.insurance.subramo },
      };

      if ($rootScope && $rootScope.from_task) {
        if ($localStorage["save_created_endoso_fianza"]) {
          $localStorage["save_created_endoso_fianza"]["type_endorsement"] =
            $rootScope.type_endorsement;
        } else {
          $localStorage["save_created_endoso_fianza"] = {};
          $localStorage["save_created_endoso_fianza"]["type_endorsement"] =
            $rootScope.type_endorsement;
        }
        vm.types.forEach(function (item) {
          if (item.id == $rootScope.type_endorsement) {
            vm.insurance.type_endorsement = item;
            changeTipo(item);
          }
        });
      }
      registry_endorsement();
    }

    function activate() {
      vm.types = [
        {
          id: "A",
          name: "A (CON RECIBOS)",
        },
        {
          id: "B",
          name: "B (SIN RECIBOS)",
        },
        {
          id: "D",
          name: "D (CON NOTAS DE CRÉDITO)",
        },
      ];
      if ($stateParams.fianzaId && $stateParams.fianzaId > 0) {
        vm.showFinder = false;
        $http
          .get(url.IP + "leer-fianzas-info/" + $stateParams.fianzaId)
          .then(function (response) {
            if (response.status == 200) {
              vm.insurance = response.data;
              vm.fianzacomplete = response.data;
              $scope.saveLocalstorange();
              vm.checkRegister = true;

              //if(vm.insurance.subramo == 'Obra' || vm.insurance.subramo == 'Proveeduria'){
              //$scope.concepts.push( {label: 'Anuencia', value: 55});
              //}

              activate_end();
            }
          });
      } else {
        vm.showFinder = true;
      }
      vm.insurance = {};
      vm.to_search = $localStorage["save_created_endoso_fianza"]
        ? $localStorage["save_created_endoso_fianza"]["to_search"]
        : "";
      if ($localStorage["save_created_endoso_fianza"]) {
        if ($localStorage["save_created_endoso_fianza"]["to_search"]) {
          var id = vm.to_search["value"];
          if (id && id.id) {
            id = id.id;
          }
          if (id && id > 0) {
            $http
              .get(url.IP + "leer-fianzas-info/" + id)
              .then(function (response) {
                if (response.status == 200) {
                  vm.insurance = response.data;
                  vm.fianzacomplete = response.data;
                  if ($localStorage["save_created_endoso_fianza"]) {
                    if (
                      $localStorage["save_created_endoso_fianza"]["concept"]
                    ) {
                      $scope.concepts = [
                        { label: "Detalle de Garantía", value: 53 },
                        { label: "Prórroga de vigencia", value: 54 },
                        { label: "Aumento", value: 58 }, //A
                        { label: "Disminución", value: 59 }, //B
                        { label: "Anulación", value: 60 }, //D
                        { label: "Cancelación", value: 61 }, //B
                        { label: "Anuencia", value: 55 }, //B
                        { label: "Endoso de texto / Otro", value: 4 }, //B
                        { label: "Aumento y Prórroga", value: 57 },
                        { label: "Cambios en el Beneficiario ", value: 34 },
                      ];
                      $scope.concepts.forEach(function (item) {
                        if (
                          item.value ==
                          $localStorage["save_created_endoso_fianza"]["concept"]
                            .value
                        ) {
                          changeConcept(item);
                        }
                      });
                    }
                    vm.insurance.type_endorsement = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "type_endorsement"
                        ]
                      : "";
                    vm.form.other_desc = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "other_desc"
                        ]
                      : "";
                    vm.form.start_of_validity = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "start_of_validity"
                        ]
                      : "";
                    vm.form.end_of_validity = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "end_of_validity"
                        ]
                      : "";
                    vm.form.observations = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "observations"
                        ]
                      : "";
                    vm.anuency = $localStorage["save_created_endoso_fianza"]
                      ? $localStorage["save_created_endoso_fianza"]["anuency"]
                      : "";
                    vm.conceptAnnulment = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "conceptAnnulment"
                        ]
                      : "";
                    vm.reason_cancel = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "reason_cancel"
                        ]
                      : "";
                    vm.monto_cancelacion = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "monto_cancelacion"
                        ]
                      : "";
                    vm.form.contract_poliza = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "contract_poliza"
                        ]
                      : "";
                    vm.form.beneficiaries_fianza = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "beneficiaries_fianza"
                        ]
                      : "";
                    vm.form.number_endorsement = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "number_endorsement"
                        ]
                      : "";
                    vm.form.bono_variable = $localStorage[
                      "save_created_endoso_fianza"
                    ]
                      ? $localStorage["save_created_endoso_fianza"][
                          "bono_variable"
                        ]
                      : "";
                  }
                }
              });
          }
        }
      }

      if ($localStorage["save_created_endoso_fianza"]) {
        if ($localStorage["save_created_endoso_fianza"]["concept"]) {
          $scope.concepts = [
            { label: "Detalle de Garantía", value: 53 },
            { label: "Prórroga de vigencia", value: 54 },
            { label: "Aumento", value: 58 }, //A
            { label: "Disminución", value: 59 }, //B
            { label: "Anulación", value: 60 }, //D
            { label: "Cancelación", value: 61 }, //B
            { label: "Anuencia", value: 55 }, //B
            { label: "Endoso de texto / Otro", value: 4 }, //B
            { label: "Aumento y Prórroga", value: 57 },
            { label: "Cambios en el Beneficiario ", value: 34 },
          ];
          vm.insurance.concept =
            $localStorage["save_created_endoso_fianza"]["concept"];
          $scope.concepts.forEach(function (item) {
            if (
              item.value ==
              $localStorage["save_created_endoso_fianza"]["concept"].value
            ) {
              vm.insurance.concept = item.value;
              changeConcept(item);
            }
          });
        }
        vm.insurance.type_endorsement = $localStorage[
          "save_created_endoso_fianza"
        ]
          ? $localStorage["save_created_endoso_fianza"]["type_endorsement"]
          : "";
        vm.form.other_desc = $localStorage["save_created_endoso_fianza"]
          ? $localStorage["save_created_endoso_fianza"]["other_desc"]
          : "";
        vm.form.start_of_validity = $localStorage["save_created_endoso_fianza"]
          ? $localStorage["save_created_endoso_fianza"]["start_of_validity"]
          : "";
        vm.form.end_of_validity = $localStorage["save_created_endoso_fianza"]
          ? $localStorage["save_created_endoso_fianza"]["end_of_validity"]
          : "";
        vm.form.observations = $localStorage["save_created_endoso_fianza"]
          ? $localStorage["save_created_endoso_fianza"]["observations"]
          : "";
        vm.anuency = $localStorage["save_created_endoso_fianza"]
          ? $localStorage["save_created_endoso_fianza"]["anuency"]
          : "";
        vm.conceptAnnulment = $localStorage["save_created_endoso_fianza"]
          ? $localStorage["save_created_endoso_fianza"]["conceptAnnulment"]
          : "";
        vm.reason_cancel = $localStorage["save_created_endoso_fianza"]
          ? $localStorage["save_created_endoso_fianza"]["reason_cancel"]
          : "";
        vm.monto_cancelacion = $localStorage["save_created_endoso_fianza"]
          ? $localStorage["save_created_endoso_fianza"]["monto_cancelacion"]
          : "";
        vm.form.contract_poliza = $localStorage["save_created_endoso_fianza"]
          ? $localStorage["save_created_endoso_fianza"]["contract_poliza"]
          : "";
        vm.form.beneficiaries_fianza = $localStorage[
          "save_created_endoso_fianza"
        ]
          ? $localStorage["save_created_endoso_fianza"]["beneficiaries_fianza"]
          : "";
        vm.form.number_endorsement = $localStorage["save_created_endoso_fianza"]
          ? $localStorage["save_created_endoso_fianza"]["number_endorsement"]
          : "";
        vm.form.bono_variable = $localStorage["save_created_endoso_fianza"]
          ? $localStorage["save_created_endoso_fianza"]["bono_variable"]
          : "";
      }
      if ($rootScope && $rootScope.from_task) {
        if ($localStorage["save_created_endoso_fianza"]) {
          $localStorage["save_created_endoso_fianza"]["type_endorsement"] =
            $rootScope.type_endorsement;
        } else {
          $localStorage["save_created_endoso_fianza"] = {};
          $localStorage["save_created_endoso_fianza"]["type_endorsement"] =
            $rootScope.type_endorsement;
        }
        vm.types.forEach(function (item) {
          if (item.id == $rootScope.type_endorsement) {
            vm.insurance.type_endorsement = item;
            changeTipo(item);
          }
        });
      }
    }

    if ("save_created_endoso_fianza" in $localStorage) {
    } else {
      $localStorage["save_created_endoso_fianza"] = {};
    }

    $scope.saveLocalstorange = function () {
      if ($stateParams.fianzaId) {
        var obj = {
          val:
            vm.insurance.contractor.full_name +
            " - " +
            vm.insurance.poliza_number,
          value: vm.insurance,
        };
      }
      $localStorage["save_created_endoso_fianza"]["to_search"] = vm.to_search
        ? vm.to_search
        : obj;
      $localStorage["save_created_endoso_fianza"]["concept"] =
        $scope.conceptSelected ? $scope.conceptSelected : "";
      $localStorage["save_created_endoso_fianza"]["type_endorsement"] = vm
        .insurance.type_endorsement
        ? vm.insurance.type_endorsement
        : "";
      $localStorage["save_created_endoso_fianza"]["other_desc"] = vm.form
        .other_desc
        ? vm.form.other_desc
        : "";
      $localStorage["save_created_endoso_fianza"]["start_of_validity"] = vm.form
        .start_of_validity
        ? vm.form.start_of_validity
        : "";
      $localStorage["save_created_endoso_fianza"]["end_of_validity"] = vm.form
        .end_of_validity
        ? vm.form.end_of_validity
        : "";
      $localStorage["save_created_endoso_fianza"]["observations"] = vm.form
        .observations
        ? vm.form.observations
        : "";
      $localStorage["save_created_endoso_fianza"]["anuency"] = vm.form.anuency
        ? vm.form.anuency
        : "";
      $localStorage["save_created_endoso_fianza"]["conceptAnnulment"] =
        vm.conceptAnnulment ? vm.conceptAnnulment : "";
      $localStorage["save_created_endoso_fianza"]["reason_cancel"] =
        vm.reason_cancel ? vm.reason_cancel : "";
      $localStorage["save_created_endoso_fianza"]["monto_cancelacion"] =
        vm.monto_cancelacion ? vm.monto_cancelacion : "";
      $localStorage["save_created_endoso_fianza"]["contract_poliza"] = vm.form
        .contract_poliza
        ? vm.form.contract_poliza
        : "";
      $localStorage["save_created_endoso_fianza"]["beneficiaries_fianza"] = vm
        .form.beneficiaries_fianza
        ? vm.form.beneficiaries_fianza
        : "";
      $localStorage["save_created_endoso_fianza"]["number_endorsement"] = vm
        .form.number_endorsement
        ? vm.form.number_endorsement
        : "";
      $localStorage["save_created_endoso_fianza"]["bono_variable"] = vm.form
        .bono_variable
        ? vm.form.bono_variable
        : "";
    };

    function findContractor() {
      var results = [];
      if (vm.to_search["val"]) {
        if (vm.to_search["val"].length > 3) {
          $http
            .post(url.IP + "get-endorsements-fianzas/", {
              word: vm.to_search["val"],
              document_type: 7,
            })
            .then(function (response) {
              results = _.map(response.data, function (item) {
                // if(item.juridical) {
                //   var label = item.juridical.j_name + ' - '+ item.poliza_number;
                // } else {
                //   var label = item.natural.full_name + ' - '+ item.poliza_number;
                // }
                if (item.contractor) {
                  var label =
                    item.contractor.full_name + " - " + item.poliza_number;
                }
                return {
                  label: label,
                  value: item.id,
                };
              });
              $scope.autocompleteData = results;
            });
        }
      }
      if ($rootScope && $rootScope.from_task) {
        if ($localStorage["save_created_endoso_fianza"]) {
          $localStorage["save_created_endoso_fianza"]["type_endorsement"] =
            $rootScope.type_endorsement;
        } else {
          $localStorage["save_created_endoso_fianza"] = {};
          $localStorage["save_created_endoso_fianza"]["type_endorsement"] =
            $rootScope.type_endorsement;
        }
        vm.types.forEach(function (item) {
          if (item.id == $rootScope.type_endorsement) {
            vm.insurance.type_endorsement = item;
            changeTipo(item);
          }
        });
      }
      $scope.saveLocalstorange();
    }

    $scope.percentageRange = function () {
      $scope.saveLocalstorange();
    };

    function getPolicy() {
      var id = vm.to_search["value"];
      if (id && id > 0) {
        $http.get(url.IP + "leer-fianzas-info/" + id).then(function (response) {
          if (response.status == 200) {
            vm.insurance = response.data;
            toaster.success("Fianza encontrada");
            $scope.saveLocalstorange();
            activate_end();
          }
        });
      }
    }

    $scope.checkFechaFactura = function (date) {
      var date_initial = date.split("/");
      var day = date_initial[0];
      var month = date_initial[1];
      var year = parseInt(date_initial[2]);
      vm.form.month.month_selected = parseInt(month);
      vm.form.year_factura = year;
    };
    $scope.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 10; i >= oldYear; i--) {
      $scope.years.push(i);
    }

    $scope.month = {};
    $scope.month.month_selected = 1;
    $scope.month.options = [
      { value: 0, label: "" },
      { value: 1, label: "Enero" },
      { value: 2, label: "Febrero" },
      { value: 3, label: "Marzo" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Mayo" },
      { value: 6, label: "Junio" },
      { value: 7, label: "Julio" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Septiembre" },
      { value: 10, label: "Octubre" },
      { value: 11, label: "Noviembre" },
      { value: 12, label: "Diciembre" },
    ];
    function save() {
      if (vm.insurance.type_endorsement) {
        var type_endorsement = vm.insurance.type_endorsement.id
          ? vm.insurance.type_endorsement.id
          : vm.insurance.type_endorsement;
      } else {
        toaster.error("Seleccione un tipo de endoso");
        return;
      }

      var to_change = "";
      if (vm.insurance.concept == 53) {
        to_change = vm.form.contract_poliza;
      }

      if (vm.insurance.concept == 34) {
        to_change = vm.form.beneficiaries_fianza;
      }

      if (vm.insurance.concept == 54) {
        to_change = datesFactory.toDate(vm.form.end_of_validity);
      }

      if (vm.insurance.concept == 57 || vm.insurance.concept == 62) {
        vm.form.contract_poliza.end_date = datesFactory.toDate(
          vm.form.end_of_validity
        );
        to_change = vm.form.contract_poliza;
      }
      if (vm.insurance.concept == 58) {
        vm.form.contract_poliza.guarantee_amount = parseFloat(
          vm.form.contract_poliza.guarantee_amount
        ).toFixed(2);
        to_change = vm.form.contract_poliza;
      }
      if (vm.insurance.concept == 59) {
        vm.form.contract_poliza.guarantee_amount = parseFloat(
          vm.form.contract_poliza.guarantee_amount
        ).toFixed(2);
        to_change = vm.form.contract_poliza;
      }
      if (vm.insurance.concept == 60) {
        vm.form.reason_cancel = vm.reason_cancel;
        to_change = {
          reason_cancel: vm.reason_cancel,
          concept_annulment: vm.conceptAnnulment,
        };
      }
      if (vm.insurance.concept == 61) {
        to_change = {
          status: 11,
          monto_cancelacion: vm.monto_cancelacion,
          fecha_cancelacion: datesFactory.toDate(vm.fecha_cancelacion),
        };
      }
      if (vm.insurance.concept == 55) {
        to_change = {
          fecha_anuencia: vm.form.anuency,
          status: vm.insurance.status,
        };
      }

      if (vm.form.recibos_poliza && vm.form.recibos_poliza.length > 0) {
        try {
          vm.form.recibos_poliza[0].vencimiento = datesFactory.toDate(
            vm.form.recibos_poliza[0].vencimiento
          );
          vm.form.recibos_poliza[0].init_date = datesFactory.toDate(
            vm.form.recibos_poliza[0].startDate
          );
          vm.form.recibos_poliza[0].end_date = datesFactory.toDate(
            vm.form.recibos_poliza[0].endingDate
          );
        } catch (err) {}
      }

      var payload = {
        anuency: datesFactory.toDate(vm.form.anuency),
        endorsement_type: type_endorsement,
        policy: vm.insurance.url,
        policy_type: 3,
        status: 5,
        init_date: datesFactory.toDate(vm.form.start_of_validity),
        end_date: datesFactory.toDate(vm.form.end_of_validity),
        number_endorsement: vm.form.number_endorsement,
        concept: vm.insurance.concept,
        observations: vm.form.observations,
        change: JSON.stringify(to_change),
        other_desc: vm.form.other_desc,
        endorsement_receipt: [],
      };

      if (vm.form.recibos_poliza && vm.form.recibos_poliza.length > 0) {
        payload["p_neta"] = vm.form.recibos_poliza[0].prima_neta;
        payload["p_total"] = vm.form.recibos_poliza[0].prima_total;
        payload["rpf"] = vm.form.recibos_poliza[0].rpf;
        payload["iva"] = vm.form.recibos_poliza[0].iva;
        payload["derecho"] = vm.form.recibos_poliza[0].derecho;
        payload["comision"] = vm.form.recibos_poliza[0].comision;
        payload["comision_percent"] = vm.form.comision_percent;
      }

      if (vm.checkRegister) {
        payload.status = 2;
        if (payload.endorsement_type != "B") {
          payload.endorsement_receipt = vm.form.recibos_poliza;
          payload.endorsement_receipt.forEach(function (recibo, index) {
            payload.endorsement_receipt[index].fecha_inicio =
              datesFactory.toDate(recibo.startDate);
            payload.endorsement_receipt[index].fecha_fin = datesFactory.toDate(
              recibo.endingDate
            );
          });
        }
      }

      if (vm.insurance.concept == 53) {
        payload.original = JSON.stringify(
          angular.copy(vm.insurance.contract_poliza)
        );
      }
      if (vm.insurance.concept == 57 || vm.insurance.concept == 62) {
        vm.insurance.contract_poliza.end_of_validity =
          vm.insurance.end_of_validity;
        payload.original = JSON.stringify(
          angular.copy(vm.insurance.contract_poliza)
        );
      }
      if (vm.insurance.concept == 58) {
        payload.original = JSON.stringify(
          angular.copy(vm.insurance.contract_poliza)
        );
      }
      if (vm.insurance.concept == 59) {
        payload.original = JSON.stringify(
          angular.copy(vm.insurance.contract_poliza)
        );
      }
      if (vm.insurance.concept == 60) {
        payload.original = {
          status: vm.insurance.status,
          reason_cancel: angular.copy(vm.insurance.reason_cancel),
          concept_annulment: angular.copy(vm.insurance.concept_annulment),
        };
      }
      if (vm.insurance.concept == 61) {
        payload.original = {
          status: vm.insurance.status,
          monto_cancelacion: vm.insurance.monto_cancelacion,
          fecha_cancelacion: vm.insurance.fecha_cancelacion,
        };
      }
      if (vm.insurance.concept == 55) {
        payload.original = {
          fecha_anuencia: vm.insurance.fecha_anuencia,
          status: vm.insurance.status,
        };
      }
      if (vm.insurance.concept == 34) {
        payload.original = JSON.stringify(
          angular.copy(vm.insurance.beneficiaries_poliza_many)
        );
      }
      if (vm.insurance.concept == 54) {
        payload.original = vm.insurance.end_of_validity;
      }
      payload.bono_variable = vm.form.bono_variable ? vm.form.bono_variable : 0;
      payload.date_bono = vm.form.date_bono
        ? datesFactory.toDate(vm.form.date_bono)
        : null;
      payload.date_emision_factura = vm.form.date_emision_factura
        ? datesFactory.toDate(vm.form.date_emision_factura)
        : null;
      payload.date_maquila = vm.form.date_maquila
        ? datesFactory.toDate(vm.form.date_maquila)
        : null;
      payload.year_factura = vm.form.year_factura ? vm.form.year_factura : 0;
      payload.month_factura = vm.form.month ? vm.form.month.month_selected : 0;
      payload.folio_factura = vm.form.folio_factura
        ? vm.form.folio_factura
        : "";
      payload.maquila = vm.form.maquila
        ? parseFloat(vm.form.maquila).toFixed(2)
        : 0;

      if (
        $rootScope.from_task &&
        $rootScope.task_associated &&
        $rootScope.task_associated.url
      ) {
        payload.from_task = $rootScope.from_task;
        payload.task_associated = $rootScope.task_associated.id;
      }
      $http.post(url.IP + "endorsement/", payload).then(function (response) {
        if (response.status == 201) {
          if (
            $rootScope.from_task &&
            $rootScope.task_associated &&
            $rootScope.task_associated.url
          ) {
            $http.patch($rootScope.task_associated.url, {
              ot_model: 2,
              ot_id_reference: response.data.id,
            });
          }
          $scope.saveFiles(response.data.id);

          if (vm.checkRegister && vm.insurance.concept != 55) {
            var payload_insurance = {};
            if (vm.insurance.concept == 53) {
              payload_insurance = {
                contract_poliza: vm.form.contract_poliza
                  ? vm.form.contract_poliza
                  : {},
              };
              payload_insurance["contract_poliza"]["poliza"] = null;
              payload_insurance["ref_policy"] = vm.insurance.ref_policy;
              payload_insurance["beneficiaries_poliza_many"] =
                vm.insurance.beneficiaries_poliza_many;
            }
            if (vm.insurance.concept == 34) {
              payload_insurance = {
                beneficiaries_poliza_many: vm.form.beneficiaries_fianza,
              };
              payload_insurance["contract_poliza"] =
                vm.insurance.contract_poliza;
              payload_insurance["contract_poliza"]["poliza"] = null;
              payload_insurance["ref_policy"] = vm.insurance.ref_policy;
              payload_insurance[""] = vm.insurance.beneficiaries_poliza_many;
            }
            if (vm.insurance.concept == 54) {
              payload_insurance = {
                end_of_validity: datesFactory.toDate(vm.form.end_of_validity),
              };
              payload_insurance["ref_policy"] = vm.insurance.ref_policy;
              payload_insurance["beneficiaries_poliza_many"] =
                vm.insurance.beneficiaries_poliza_many;
              payload_insurance["contract_poliza"] =
                vm.insurance.contract_poliza;
              payload_insurance["contract_poliza"]["poliza"] = null;
              try {
                payload_insurance["contract_poliza"].end = datesFactory.toDate(
                  vm.form.contract_poliza.end
                );
                payload_insurance["contract_poliza"].start =
                  datesFactory.toDate(vm.form.contract_poliza.start);
                payload_insurance["contract_poliza"].sign_date =
                  datesFactory.toDate(vm.form.contract_poliza.sign_date);
              } catch (err) {
                console.log(".gege", err);
              }
            }
            try {
              payload_insurance["contract_poliza"].end = datesFactory.toDate(
                vm.form.contract_poliza.end
              );
              payload_insurance["contract_poliza"].start = datesFactory.toDate(
                vm.form.contract_poliza.start
              );
              payload_insurance["contract_poliza"].sign_date =
                datesFactory.toDate(vm.form.contract_poliza.sign_date);
            } catch (err) {
              console.log(".gege", err);
            }
            if (payload_insurance.contract_poliza == undefined) {
              payload_insurance.contract_poliza = {};
            }
            if (payload_insurance.ref_policy == undefined) {
              payload_insurance.ref_policy = [];
            }
            // $http.patch(vm.insurance.url.replace('polizas','fianzas'), payload_insurance).then(function(responseInsurance) {
            //   dataFactory.post('send-log/', {
            //     'model': 10,
            //     'event': "POST",
            //     'associated_id': response.data.id,
            //     'identifier': 'Creó y registró el endoso tipo ' + payload.endorsement_type
            //   });
            //   dataFactory.post('send-log/', {
            //     'model': 13,
            //     'event': "POST",
            //     'associated_id': vm.insurance.id,
            //     'identifier': 'Creó y registró el endoso tipo ' + payload.endorsement_type
            //   });
            // });
            SweetAlert.swal("Hecho", MESSAGES.OK.NEWENDORSEMENT, "success");
            $state.go("endorsement.details", { endosoId: response.data.id });
          } else {
            SweetAlert.swal("Hecho", MESSAGES.OK.NEWENDORSEMENT, "success");
            dataFactory.post("send-log/", {
              model: 10,
              event: "POST",
              associated_id: response.data.id,
              identifier: "Creó el endoso tipo " + payload.endorsement_type,
            });
            // $state.go('endorsement.details',{'endosoId':response.data.id});
            dataFactory.post("send-log/", {
              model: 13,
              event: "POST",
              associated_id: vm.insurance.id,
              identifier: "Creó el endoso tipo " + payload.endorsement_type,
            });
            $state.go("endorsement.details", { endosoId: response.data.id });
          }
        }
      });
    }

    $scope.validateDecimalMontoTotal = function (input) {
      if (parseFloat(input) < 0) {
        vm.form.contract_poliza.value = 0;
        vm.form.contract_poliza.amount_iva = 0;
      } else {
        vm.form.contract_poliza.value = parseFloat(input).toFixed(2);
        var valor_am = parseFloat(
          $scope.formatearNumero(vm.form.contract_poliza.amount)
        ).toFixed(2);
        if (vm.form.contract_poliza.amount) {
          if (valor_am == "NaN") {
            toaster.error("Revise el formato del Monto del Contrato.");
            vm.form.contract_poliza.amount_iva = parseFloat(0).toFixed(2);
            return;
          } else if (valor_am) {
            vm.form.contract_poliza.amount_iva = parseFloat(
              parseFloat(parseFloat(valor_am) * 0.16) + parseFloat(valor_am)
            ).toFixed(2);
          }
        }
      }
    };
    $scope.formatearNumero = function (nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";

      var cadenas = x1.split(",");
      var cadena_sin_comas = "";
      for (i = 0; i < cadenas.length; i++) {
        cadena_sin_comas = cadena_sin_comas + cadenas[i];
      }
      if (
        cadena_sin_comas != undefined &&
        cadena_sin_comas != "undefined" &&
        cadena_sin_comas != "NaN" &&
        cadena_sin_comas != NaN
      ) {
        return cadena_sin_comas + x2;
      } else {
        return nStr;
      }
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          if ($scope.param == "poliza") {
            SweetAlert.swal(MESSAGES.OK.UPGRADEPOLICY, "", "success");
          }
          if ($scope.param == "ot") {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.UPGRADEOT, "success");
          }
          $state.go("fianzas.info", { polizaId: polizaId });
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
        order.options.checkDate("initial");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
        order.options.checkDate("initial");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
      toaster.success("Archivo cargado correctamente");
    };
    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    $scope.saveFiles = function (poliza) {
      uploadFiles(poliza);
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + polizaId + "/archivos/";
      $scope.uploader.uploadAll();
    }

    /* Configuracion del datepicker */
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("EndososEditCtrl", EndososEditCtrl);

  EndososEditCtrl.$inject = [
    "toaster",
    "dataFactory",
    "$stateParams",
    "FileUploader",
    "conceptA",
    "conceptB",
    "conceptD",
    "$scope",
    "$sessionStorage",
    "datesFactory",
    "payform",
    "$http",
    "$state",
    "url",
    "$timeout",
    "conceptFianza",
  ];

  function EndososEditCtrl(
    toaster,
    dataFactory,
    $stateParams,
    FileUploader,
    conceptA,
    conceptB,
    conceptD,
    $scope,
    $sessionStorage,
    datesFactory,
    payform,
    $http,
    $state,
    url,
    $timeout,
    conceptFianza
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    uploader.filters.push({
      name: "customFilter",
      fn: function (item, options) {
        return this.queue.length < 10;
      },
    });

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    uploader.filters.push({
      name: "customFilter",
      fn: function (item, options) {
        return this.queue.length < 10;
      },
    });

    /* Configuracion del datepicker */
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          vm.acceso_fian = perm;
          vm.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                vm.permiso_administrar_adjuntos = true;
              } else {
                vm.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }

    $scope.concepts = [
      { label: "Detalle de Garantía", value: 53 },
      { label: "Prorroga de vigencia", value: 54 },
      { label: "Aumento", value: 58 },
      { label: "Cambios en el Beneficiario ", value: 34 },
      { label: "Otro", value: 4 },
    ];

    // {label: 'Detalle de Garantía', value: 1},
    //   {label: 'Prorroga de vigencia', value: 2},
    //   {label: 'Cambios en el Beneficiario ', value: 5},
    //   {label: 'Otro', value: 4},

    function changeConcept() {
      if (vm.form.concept == 54) {
        vm.form.type_endorsement = {
          id: "A",
          name: "A",
        };
      } else if (vm.form.concept == 55 || vm.form.concept == 34) {
        vm.form.type_endorsement = {
          id: "B",
          name: "B",
        };
      } else {
        vm.form.type_endorsement = "";
      }
      vm.to_receipts = {};
      vm.checkRegister = false;
    }

    vm.types = [
      {
        id: "A",
        name: "A",
      },
      {
        id: "B",
        name: "B",
      },
      {
        id: "D",
        name: "D",
      },
    ];

    $scope.dataToSave = {
      receipts: [],
      delete_receitps: [],
    };
    vm.form = {
      type: "INDIVIDUAL",
    };
    vm.poliza_number_data = {};
    vm.selectedType = {};
    vm.description = {};
    vm.payform = payform;

    $scope.array_receipts = [];

    activate();

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    function activate() {
      vm.subforms = {};
      dataFactory
        .get("endorsement-info/" + $stateParams.endosoId + "/")
        .then(function success(response) {
          // console.log('response - endosos', response);
          vm.form = response.data;
          vm.insurance = vm.form.policy;
          if (
            vm.insurance.subramo.subramo_name == "Obra" ||
            vm.insurance.subramo.subramo_name == "Proveeduria"
          ) {
            if ($scope.concepts.length == 4) {
              $scope.concepts.push({ label: "Anuencia", value: 55 });
            }
          }
          $scope.concepts.some(function (concepto) {
            if (concepto.value == vm.form.concept) {
              vm.form.concept = concepto;
            }
          });
          vm.types.some(function (tipo) {
            if (tipo.name == vm.form.endorsement_type) {
              vm.form.endorsement_type = tipo;
            }
          });
          vm.form.init_date = datesFactory.convertDate(vm.form.init_date);
          vm.form.end_date = datesFactory.convertDate(vm.form.end_date);
          vm.form.anuency = datesFactory.convertDate(vm.form.anuency);

          vm.form.change = vm.form.change.split("'").join('"');
          vm.form.change = vm.form.change.split("None").join('""');
          if (typeof vm.form.change == "string") {
            try {
              vm.form.change = JSON.parse(vm.form.change);
            } catch (err) {}
          }
          if (vm.form.concept.value == 53) {
            vm.form.change.start = datesFactory.convertDate(vm.form.init_date);
            vm.form.change.end = datesFactory.convertDate(vm.form.end_date);
            vm.form.change.sign_date = datesFactory.convertDate(
              vm.form.change.sign_date
            );
          }

          console.log(vm.form);
          console.log(vm.insurance);
        });
    }

    $scope.addBene = function () {
      var beneficiario = {
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        type_person: 1,
      };
      vm.form.change.push(beneficiario);
    };

    $scope.deleteBene = function (index) {
      if (vm.form.change.length > 1) {
        vm.form.change.splice(index, 1);
      }
    };

    $scope.fillData = function (type) {
      vm.form.start_of_validity = datesFactory.convertDate(vm.form.init_date);
      vm.form.end_of_validity = datesFactory.convertDate(vm.form.end_date);
      vm.description.label = concept(vm.form.concept);
      if (type.id == 1) {
        vm.descriptions = conceptA;
      } else if (type.id == 2) {
        vm.descriptions = conceptB;
      } else if (type.id == 3) {
        vm.descriptions = conceptD;
      }
      if (vm.form.fianza) {
        vm.descriptions = conceptFianza;
      }
      $scope.showFields(vm.form.concept);
    };

    $scope.showFields = function (concept) {
      vm.form.concept = concept;
      $scope.valueConcept = concept;
      if ((concept == 7 || concept == 10 || concept >= 18) && concept != 23) {
        $scope.otros = true;
      } else {
        $scope.otros = false;
      }
    };

    $scope.save = function () {
      console.log(vm.form);
      var payload = {};
      if (vm.form.concept.value == 53 || vm.form.concept.value == 34) {
        try {
          vm.form.change.sign_date = datesFactory.toDate(
            vm.form.change.sign_date
          );
        } catch (err) {}
        try {
          vm.form.change.start = datesFactory.toDate(vm.form.change.start);
        } catch (err) {}
        try {
          vm.form.change.end = datesFactory.toDate(vm.form.change.end);
        } catch (err) {}
        payload = {
          change: JSON.stringify(vm.form.change),
          observations: vm.form.observations,
        };
      }
      if (vm.form.concept.value == 55) {
        payload = {
          anuency: datesFactory.toDate(vm.form.anuency),
          observations: vm.form.observations,
        };
      }
      if (vm.form.concept.value == 54) {
        payload = {
          end_date: datesFactory.toDate(vm.form.end_date),
          observations: vm.form.observations,
        };
      }
      payload.observations = vm.form.observations;
      payload.endorsement_receipt = [];
      $http.patch(vm.form.url, payload).then(function (response) {
        toaster.success("Endoso editado corectamente");
        if (
          vm.form.policy.document_type == 1 ||
          vm.form.policy.document_type == 3
        ) {
          $state.go("endorsement.info", { endosoId: vm.form.id });
        } else {
          $state.go("endorsement.details", { endosoId: vm.form.id });
        }
      });
    };

    $scope.cancel = function () {
      $state.go("endorsement.details", { endosoId: vm.form.id });
    };

    /* Alerta success uploadfiles */
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        if ($scope.checkRegister) {
          $scope.registerEndorsement(vm.newEndorsement);
        } else {
          $state.go("endorsement.info", { endosoId: vm.newEndorsement.id });
        }
      }
    };

    /* Alerta error uploadfiles */
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      l.stop();
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + endorsementId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("EndososController", EndososController);

  EndososController.$inject = [
    "dataFactory",
    "$scope",
    "$sessionStorage",
    "helpers",
    "toaster",
    "MESSAGES",
    "SweetAlert",
    "conceptA",
    "conceptB",
    "conceptD",
    "payform",
    "FileUploader",
    "datesFactory",
    "$http",
    "$state",
    "notesFactory",
    "models",
    "$stateParams",
    "url",
    "$timeout",
    "$localStorage",
    "emailService",
    "conceptFianza",
  ];

  function EndososController(
    dataFactory,
    $scope,
    $sessionStorage,
    helpers,
    toaster,
    MESSAGES,
    SweetAlert,
    conceptA,
    conceptB,
    conceptD,
    payform,
    FileUploader,
    datesFactory,
    $http,
    $state,
    notesFactory,
    models,
    $stateParams,
    url,
    $timeout,
    $localStorage,
    emailService,
    conceptFianza
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    /* Uploader files */
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          vm.acceso_fian = perm;
          vm.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                vm.permiso_administrar_adjuntos = true;
              } else {
                vm.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;
    SweetAlert.swal(
      "Módulo Endosos en mantenimiento",
      "Sólo se podrá utilizar: \n•  Endosos Masivos (Altas o Bajas) en Colectivos y, \n•  Opción de concepto: Otro.\nCualquier cambio o ajuste descrito en el endoso deberá realizarlo manualmente en la póliza.",
      "warning"
    );
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    /* Variables */
    $scope.coberturas = [2, 3, 5, 19, 12, 13, 14, 21];
    $scope.asegurado = [4, 20, 8, 15, 22];
    vm.selectTypeStatus = true;
    vm.form = {
      type: "INDIVIDUAL",
    };
    vm.subforms = {};
    vm.newRelationship = [
      {
        first_name: "",
        last_name: "",
        second_last_name: "",
        birthdate: null,
        sex: null,
        relationship: null,
        accident: null,
      },
    ];
    vm.newBeneficiarie = [
      {
        first_name: "",
        last_name: "",
        second_last_name: "",
        birthdate: null,
        sex: "",
        optional_relationship: "",
        percentage: 0,
        person: 1,
      },
    ];
    vm.deleteCoverages = [];
    vm.toDelRelationship = [];
    vm.payform = payform;
    vm.editNotes = false;
    vm.types = [
      {
        id: 0,
        name: "Selecciona un tipo de endoso",
      },
      {
        id: 1,
        name: "A",
      },
      {
        id: 2,
        name: "B",
      },
      {
        id: 3,
        name: "D",
      },
    ];

    vm.num_receipts_data = [
      { name: 1, value: 12 }, //
      { name: 2, value: 6 }, //
      { name: 3, value: 4 },
      { name: 4, value: 3 },
      { name: 5, value: 5.5 },
      { name: 6, value: 2 }, //
      { name: 7, value: 7 },
      { name: 8, value: 8 },
      { name: 9, value: 9 },
      { name: 10, value: 10 },
      { name: 11, value: 11 },
      { name: 12, value: 1 }, //
    ];

    vm.num_notes_data = [
      { name: 1, value: 1 },
      { name: 2, value: 2 },
      { name: 3, value: 3 },
      { name: 4, value: 4 },
      { name: 5, value: 5 },
      { name: 6, value: 6 },
      { name: 7, value: 7 },
      { name: 8, value: 8 },
      { name: 9, value: 9 },
      { name: 10, value: 10 },
      { name: 11, value: 11 },
      { name: 12, value: 12 },
    ];

    vm.typesRelation = [
      { name: "Titular", value: 1 },
      { name: "Conyuge", value: 2 },
      { name: "Hijo", value: 3 },
      { name: "Otro", value: 4 },
    ];

    vm.sex = [
      { label: "Masculino", value: "M" },
      { label: "Femenino", value: "F" },
    ];
    vm.defaults = {};
    vm.defaults.years = [];
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 1; i >= oldYear; i--) {
      vm.defaults.years.push(i);
    }

    /* Funciones */
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    function concept(parConcept) {
      switch (parConcept) {
        case 1:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 2:
          return "CAMBIO DE SUMA ASEGURADA";
          break;
        case 3:
          return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
          break;
        case 4:
          return "AGREGAR ASEGURADO";
          break;
        case 5:
          return "AGREGAR COBERTURAS";
          break;
        case 6:
          return "DECLARACIÓN MENSUAL";
          break;
        case 8:
          return "CAMBIO DATOS FISCALES";
          break;
        case 9:
          return "ESPECIFICACIONES";
          break;
        case 11:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 12:
          return "DISMINUCIÓN EN LA SUMA ASEGURADA";
          break;
        case 13:
          return "BAJA DE COBERTURA";
          break;
        case 14:
          return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
          break;
        case 15:
          return "BAJA DE ASEGURADO";
          break;
        case 16:
          return "CANCELACIÓN DE PÓLIZA POR PETICIÓN";
          break;
        case 17:
          return "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO";
          break;
        case 23:
          return "ANTIGÜEDAD RECONOCIDA";
          break;
        case 24:
          return "ALTA DE ASEGURADOS";
          break;
        case 25:
          return "BAJA DE ASEGURADOS";
          break;
        case 26:
          return "AJUSTE ANUAL A";
          break;
        case 27:
          return "RECONOCIMIENTO DE ANTIGÜEDAD";
          break;
        case 28:
          return "AJUSTE ANUAL D";
          break;
        default:
          return "OTRO";
      }
    }

    function conceptF(parConcept) {
      switch (parConcept) {
        case 1:
          return "AUMENTO MONTO AFIANZADO";
          break;
        case 2:
          return "DECREMENTO MONTO AFIANZADO";
          break;
        case 3:
          return "CAMBIO DE PORCENTAJE DE GARANTÍA";
          break;
        case 4:
          return "OTRO";
          break;
        case 5:
          return "CAMBIO DE DATOS";
          break;
        default:
          return "OTRO";
      }
    }
    $scope.fianza_for_endoso = "Póliza";
    if (!vm.acceso_adm_fia && vm.acceso_adm_pol) {
      $scope.fianza_for_endoso = "Póliza";
    } else if (vm.acceso_adm_fia && !vm.acceso_adm_pol) {
      $scope.fianza_for_endoso = "Fianza";
    }
    $scope.f_p = function (f_p) {
      if (f_p) {
        if (vm.poliza_number_data) {
          if (vm.poliza_number_data.id) {
            vm.poliza_number_data.id = "";
            vm.poliza_number_data.val = "";
            vm.poliza_number_data.value = "";
          }
        }
      }
    };
    $scope.checkNumEndoso = function (poliza) {
      if (poliza) {
        var npoliza = poliza.value ? poliza.value : poliza.val;
      }
      if (vm.form.number_endorsement) {
        dataFactory
          .get("exist-number-endorsement/", {
            number: vm.form.number_endorsement,
            poliza: npoliza,
          })
          .then(function (request) {
            if (request.data.status == true) {
              SweetAlert.swal("Error", "Número de Endoso existente", "error");
              vm.form.number_endorsement = "";
            }
          })
          .catch(function (err) {});
      }
    };
    $scope.findContractor = function (parValue) {
      if (parValue) {
        if (parValue.val.length >= 3) {
          if ($scope.fianza_for_endoso == "Póliza") {
            // if($scope.infoUser.staff && !$scope.infoUser.superuser){
            //   $scope.show_contractor = 'v2/polizas/get-endorsements-policies/';
            $scope.show_contractor = "get-endorsements-policies/";
            dataFactory
              .post($scope.show_contractor, { word: parValue.val })
              .then(
                function success(request) {
                  var results = [];
                  results = _.map(request.data, function (item) {
                    // if(item.juridical) {
                    //   var label = item.juridical + ' - '+ item.poliza_number;
                    // } else {
                    //   var label = item.natural + ' - '+ item.poliza_number;
                    // }
                    if (item.contractor) {
                      var label = item.contractor + " - " + item.poliza_number;
                    }
                    return {
                      label: label,
                      value: item.poliza_number,
                      id: item.id,
                    };
                  });
                  $scope.autocompleteData = results;
                },
                function error(error) {}
              )
              .catch(function (e) {
                console.log("e", e);
              });
          }
          if ($scope.fianza_for_endoso == "Fianza") {
            // if($scope.infoUser.staff && !$scope.infoUser.superuser){
            //   $scope.show_contractor_f = 'v2/fianzas/get-endorsements-fianzas/';
            $scope.show_contractor_f = "get-endorsements-fianzas/";
            dataFactory
              .post($scope.show_contractor_f, { word: parValue.val })
              .then(
                function success(request) {
                  var results = [];
                  results = _.map(request.data, function (item) {
                    // if(item.juridical) {
                    //   var label = item.juridical.j_name + ' - '+ item.fianza_number;
                    // } else {
                    //   var label = item.natural.full_name + ' - '+ item.fianza_number;
                    // }
                    if (item.contractor) {
                      var label =
                        item.contractor.full_name + " - " + item.poliza_number;
                    }
                    return {
                      label: label,
                      value: item.fianza_number,
                      id: item.id,
                    };
                  });
                  $scope.autocompleteData = results;
                },
                function error(error) {}
              )
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      }
    };

    // $scope.clearPolicy = function() {
    //   vm.loading = true;
    //   vm.selectTypeStatus = true;
    //   vm.policy = null;
    //   vm.form.policy_starting_date = null;
    //   vm.policy.end_date = null;
    //   vm.policy.init_date = null;
    //   vm.coverages = [];
    //   vm.coverageList = [];
    //   vm.policy.automobiles_policy = [];
    //   vm.policy.accidents_policy = [];
    //   vm.policy.damages_policy = [];
    //   vm.policy.life_policy = [];
    // }

    $scope.addBene = function () {
      var beneficiario = {
        first_name: "",
        last_name: "",
        second_last_name: "",
        j_name: "",
        rfc: "",
        email: "",
        phone_number: "",
        type_person: 1,
      };
      vm.form.beneficiaries_fianza.push(beneficiario);
    };

    $scope.deleteBene = function (index) {
      if (vm.form.beneficiaries_fianza.length > 1) {
        vm.form.beneficiaries_fianza.splice(index, 1);
      }
    };

    $scope.getPolicy = function (parId, value, number) {
      if (parId) {
        if (parId.id == "") {
          toaster.warning("Ingrese un número de válido");
          vm.loading = false;
          return;
        }
      }
      if (!parId) {
        if ($scope.fianza_for_endoso == "Póliza") {
          toaster.warning("Ingrese un número de póliza");
          vm.loading = false;
          return;
        } else if ($scope.fianza_for_endoso == "Fianza") {
          toaster.warning("Ingrese un número de fianza");
          vm.loading = false;
          return;
        }
      } else {
        vm.loading = true;
        vm.selectedType = vm.types[0];
        if ($scope.fianza_for_endoso == "Póliza") {
          setTimeout(function () {
            dataFactory
              .get("get-policy-endorsement/", { id: parId.id })
              .then(function success(response) {
                if (!helpers.isResponseOk(response.status)) {
                  SweetAlert.swal(
                    "ERROR",
                    MESSAGES.ERROR.ERRORSEARCHPOLICY,
                    "error"
                  );
                  vm.loading = false;
                  return;
                } else {
                  vm.loading = false;
                  vm.selectTypeStatus = false;
                  vm.policy = response.data.results[0];
                  vm.form.tipo_endoso = 1;
                  vm.form.policy_starting_date = angular.copy(
                    vm.policy.start_of_validity
                  );
                  vm.policy.end_date = vm.form.end_of_validity;
                  vm.policy.init_date = vm.form.start_of_validity;
                  vm.coverages = vm.policy.coverageInPolicy_policy;
                  vm.coverageList = angular.copy(
                    vm.policy.paquete.coverage_package
                  );

                  if (vm.policy.automobiles_policy.length) {
                    vm.subforms = vm.policy.automobiles_policy[0];
                    vm.subforms.show = 1;
                  } else if (vm.policy.accidents_policy.length) {
                    vm.subforms = vm.policy.accidents_policy[0];
                    vm.subforms.personal.birthdate = datesFactory.convertDate(
                      vm.subforms.personal.birthdate
                    );
                    vm.subforms.relationship_accident.forEach(function (
                      asegurado
                    ) {
                      asegurado.birthdate = datesFactory.convertDate(
                        asegurado.birthdate
                      );
                    });
                    vm.subforms.show = 0;
                  } else if (vm.policy.damages_policy.length) {
                    vm.subforms = vm.policy.damages_policy[0];
                    vm.subforms.show = 2;
                  } else if (vm.policy.life_policy.length) {
                    vm.subforms = vm.policy.life_policy[0];
                    vm.subforms.personal.birthdate = datesFactory.convertDate(
                      vm.subforms.personal.birthdate
                    );
                    vm.subforms.beneficiaries_life.forEach(function (
                      asegurado
                    ) {
                      asegurado.birthdate = datesFactory.convertDate(
                        asegurado.birthdate
                      );
                    });
                    vm.subforms.show = 3;
                  }
                  if (number == 2) {
                    $scope.fillData(vm.selectedType);
                  }
                }
              });
          }, 100);
        } else if ($scope.fianza_for_endoso == "Fianza") {
          setTimeout(function () {
            dataFactory
              .get("get-fianza-endorsement/", { id: parId.id })
              .then(function success(response) {
                if (!helpers.isResponseOk(response.status)) {
                  SweetAlert.swal(
                    "ERROR",
                    MESSAGES.ERROR.ERRORSEARCHFIANZA,
                    "error"
                  );
                  vm.loading = false;
                  return;
                } else {
                  vm.loading = false;
                  vm.selectTypeStatus = false;
                  vm.policy = response.data.results[0];
                  vm.form.policy_starting_date = angular.copy(
                    vm.policy.start_of_validity
                  );
                  vm.form.tipo_endoso = 2;
                  vm.policy.end_date = vm.form.end_of_validity;
                  vm.policy.init_date = vm.form.start_of_validity;
                  vm.coverages = vm.policy.coverageInPolicy_policy;

                  if (vm.policy.automobiles_policy) {
                    vm.subforms = vm.policy.automobiles_policy[0];
                    vm.subforms.show = 1;
                  }
                  // if(number == 2){
                  //   $scope.fillData(vm.selectedType);
                  // }
                }
              });
          }, 100);
        }
      }
    };

    $scope.fillData = function (type) {
      vm.form.start_of_validity = datesFactory.convertDate(new Date());
      vm.form.end_of_validity = datesFactory.convertDate(
        vm.policy.end_of_validity
      );
      $scope.totalRecs = vm.policy.recibos_poliza.length;
      $scope.numRecs = 0;
      if (type.id == 1) {
        vm.descriptions = conceptA;
        vm.policy.recibos_poliza.forEach(function (x, c) {
          if (x.status == 4) {
            $scope.numRecs += 1;
          }
        });
        if ($scope.totalRecs == $scope.numRecs) {
          vm.descriptions = [
            { value: 1, label: "CAMBIO DE FORMA DE PAGO" },
            { value: 7, label: "OTRO" },
          ];
          console.log("--accede--", $scope.totalRecs, $scope.numRecs);
        } else {
          vm.descriptions = [{ value: 7, label: "OTRO" }];
          console.log(
            "---tiene reibos pagados--",
            vm.policy.recibos_poliza,
            $scope.totalRecs,
            $scope.numRecs
          );
          // SweetAlert.swal("Información", 'Si requiere Cambio Forma de Pago debe contactar con Soporte', "info");
          SweetAlert.swal(
            "Información",
            "Existen Recibos Pagados \nSi requiere Cambio Forma de Pago debe contactar con Soporte",
            "info"
          );
        }
      } else if (type.id == 2) {
        vm.descriptions = conceptB;
      } else if (type.id == 3) {
        vm.descriptions = conceptD;
        vm.form.fecha_emision = datesFactory.convertDate(new Date());
      } else {
        toaster.warning("Seleccione una opción valida");
      }
      if ($scope.fianza_for_endoso == "Fianza") {
        vm.descriptions = conceptFianza;
      }
    };

    $scope.formatQ = function (param) {
      if (param) {
        var model = formatValues.currency(param);
        return model;
      }
    };

    $scope.showFields = function (concept) {
      vm.form.concept = concept.value;
      $scope.valueConcept = concept.value;
      if (
        (concept.value == 7 || concept.value == 10 || concept.value >= 18) &&
        concept.value != 23 &&
        concept.value != 33 &&
        concept.value != 34
      ) {
        $scope.otros = true;
      } else {
        $scope.otros = false;
      }
    };

    $scope.deleteCoverage = function (obj, index) {
      vm.deleteCoverages.push(obj);
      vm.coverages.splice(index, 1);
      var cl = vm.coverageList;
      var flag = false;
      for (var i = 0; i < cl.length; i++) {
        if (cl[i].id == obj.id) {
          flag = true;
        }
        if (obj.coverage_name == cl[i].coverage_name) {
          var flag2 = true;
        } else {
          var flag2 = false;
        }
      }
      if (!flag) {
        if (!flag2) {
          vm.coverageList.push(obj);
        }
      }
    };

    $scope.addCoverage = function (obj, index) {
      var delCoverage = false;
      if (vm.coverages.length == 0) {
        delCoverage = true;
      }

      for (var i = vm.coverages.length - 1; i >= 0; i--) {
        if (vm.coverages[i].coverage_name === obj.coverage_name) {
          SweetAlert.swal("", "Ya existe esta cobertura", "warning");
          vm.coverageList.forEach(function (coverage) {
            if (coverage.coverage_name == obj.coverage_name) {
              vm.coverageList.splice(vm.coverageList.indexOf(coverage), 1);
            }
          });
          return;
        } else {
          delCoverage = true;
        }
      }

      if (delCoverage) {
        vm.coverages.push(obj);
        vm.coverageList.forEach(function (coverage) {
          if (coverage.coverage_name == obj.coverage_name) {
            vm.coverageList.splice(vm.coverageList.indexOf(coverage), 1);
          }
        });
      }
      vm.coverageInPackage = "";
    };

    $scope.addRelationship = function () {
      vm.newRelationship.push(models.relationships());
    };

    $scope.deleteRelationship = function (index, obj) {
      if (vm.selectedType.name == "A") {
        vm.newRelationship.splice(index, 1);
      } else {
        vm.toDelRelationship.push(obj);
        vm.subforms.relationship_accident.splice(index, 1);
      }
    };

    $scope.addBeneficiarie = function () {
      vm.newBeneficiarie.push(models.beneficiary());
    };

    $scope.deleteBeneficiarie = function (index, obj) {
      if (vm.selectedType.name == "A") {
        vm.newBeneficiarie.splice(index, 1);
      } else {
        vm.toDelBeneficiarie.push(obj);
        vm.subforms.beneficiaries_life.splice(index, 1);
      }
    };
    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }
    $scope.changeUntilE = function (note, index) {
      note.fecha_fin = new Date(datesFactory.toDate(note.endDate));
    };
    $scope.changeSinceE = function (note, index) {
      note.fecha_inicio = new Date(datesFactory.toDate(note.initDate));
    };
    function mesDiaAnio(parDate) {
      // console.log('parDate', parDate);
      var d = new Date(toDate(parDate));
      // console.log('d', d);
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      // console.log('date', date);
      return date;
    }
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    /* Creación del endoso */
    $scope.createEndorsement = function (param) {
      if (
        vm.form.num_notas > 0 &&
        vm.form.num_notas != undefined &&
        vm.selectedType.name == "D"
      ) {
        if ($scope.checkRegister) {
          if (!vm.credit_notes) {
            SweetAlert.swal(
              "-Notas de Crédito-",
              "Debe calcular las Notas de Crédito",
              "warning"
            );

            return;
          }
        }
      }
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (!vm.description) {
        SweetAlert.swal(
          "Error",
          MESSAGES.ERROR.ERRORENDORSEMENTCONCEPT,
          "error"
        );
        l.stop();
        return;
      }
      if (!vm.form.observations) {
        SweetAlert.swal("Información", MESSAGES.ERROR.ENDOSOBS, "error");
        l.stop();
        return;
      }
      if ($scope.fianza_for_endoso == "Póliza") {
        $scope.dataToSave = {
          endorsement_type: vm.selectedType.name,
          policy: vm.policy.url,
          init_date: new Date(datesFactory.toDate(vm.form.start_of_validity)),
          end_date: new Date(datesFactory.toDate(vm.form.end_of_validity)),
          concept: vm.form.concept,
          observations: vm.form.observations,
          other_desc: vm.form.other_desc,
        };
      } else if ($scope.fianza_for_endoso == "Fianza") {
        $scope.dataToSave = {
          endorsement_type: vm.selectedType.name,
          policy: "",
          fianza: vm.policy.url,
          init_date: new Date(datesFactory.toDate(vm.form.start_of_validity)),
          end_date: new Date(datesFactory.toDate(vm.form.end_of_validity)),
          concept: vm.form.concept,
          observations: vm.form.observations,
          other_desc: vm.form.other_desc,
          policy_type: 3,
        };
      }
      var init_poliza = convertDate(vm.policy.start_of_validity);
      var end_poliza = convertDate(vm.policy.end_of_validity);
      if ($scope.fianza_for_endoso == "Póliza") {
        if (
          datesFactory.toDate(vm.form.start_of_validity) <
            datesFactory.toDate(init_poliza) ||
          datesFactory.toDate(vm.form.start_of_validity) >
            datesFactory.toDate(end_poliza)
        ) {
          SweetAlert.swal(
            "Fechas de vigencia de Endoso",
            "Fechas de endoso no están en el rango de vigencia de la póliza",
            "info"
          );
          l.stop();
          return;
        }
      } else {
        if (
          datesFactory.toDate(vm.form.start_of_validity) >
          datesFactory.toDate(vm.form.end_of_validity)
        ) {
          SweetAlert.swal(
            "Fechas de vigencia de Endoso",
            "Fecha final no puede ser menor que la inicial",
            "info"
          );
          l.stop();
          return;
        }
      }

      if (
        (vm.form.concept == 1 || vm.form.concept == 11) &&
        $scope.fianza_for_endoso == "Póliza"
      ) {
        $scope.dataToSave.change = { forma_de_pago: vm.form.payment.value };
      } else if (vm.form.concept == 16 || vm.form.concept == 17) {
        $scope.dataToSave.change = { status: 11 };
      } else if ($scope.coberturas.indexOf(vm.form.concept) >= 0) {
        if (vm.form.concept == 13) {
          $scope.dataToSave.change = vm.deleteCoverages;
        } else {
          $scope.dataToSave.change = vm.coverages;
        }
      } else if (
        $scope.asegurado.indexOf(vm.form.concept) >= 0 &&
        $scope.fianza_for_endoso == "Póliza"
      ) {
        if (vm.form.concept == 4) {
          if (vm.subforms.show == 0) {
            $scope.dataToSave.change = vm.newRelationship;
          } else if (vm.subforms.show == 3) {
            $scope.dataToSave.change = vm.newBeneficiarie;
          } else {
            $scope.dataToSave.change = {
              data: "Agregar asegurado en autos o daños no esta permitido actualmente",
            };
          }
        } else if (
          vm.form.concept == 20 ||
          vm.form.concept == 8 ||
          vm.form.concept == 22
        ) {
          $scope.dataToSave.change = vm.subforms;
        } else if (vm.form.concept == 15) {
          if (vm.subforms.show == 0) {
            $scope.dataToSave.change = vm.toDelRelationship;
          } else if (vm.subforms.show == 3) {
            $scope.dataToSave.change = vm.toDelBeneficiarie;
          } else {
            $scope.dataToSave.change = {
              data: "Baja de asegurado en autos o daños no esta permitido actualmente",
            };
          }
        }
      }
      if ($scope.fianza_for_endoso == "Fianza") {
        $scope.dataToSave.change = { data: "Endoso de Fianza" };
      }

      $scope.dataToSave.endorsement_receipt = [];
      $scope.dataToSave.status = 1;

      dataFactory
        .post("endorsement/", $scope.dataToSave)
        .then(function success(response) {
          if (helpers.isResponseOk(response.status)) {
            vm.newEndorsement = response.data;
            var params = {
              model: 1,
              event: "POST",
              associated_id: vm.policy.id,
              identifier:
                "creó un endoso tipo " +
                vm.newEndorsement.endorsement_type +
                " con concepto " +
                concept(vm.newEndorsement.concept),
            };

            var paramsF = {
              model: 13,
              event: "POST",
              associated_id: vm.policy.id,
              identifier:
                "creó un endoso tipo " +
                vm.newEndorsement.endorsement_type +
                " con concepto " +
                conceptF(vm.newEndorsement.concept),
            };

            var paramsE = {
              model: 10,
              event: "POST",
              associated_id: vm.newEndorsement.id,
              identifier: "creó el endoso",
            };
            if ($scope.fianza_for_endoso == "Póliza") {
              dataFactory.post("send-log", params);
            } else if ($scope.fianza_for_endoso == "Fianza") {
              dataFactory.post("send-log", paramsF);
            }
            dataFactory.post("send-log", paramsE);

            if ($scope.countFile > 0) {
              uploadFiles(vm.newEndorsement.id);
            } else {
              if ($scope.checkRegister) {
                $scope.registerEndorsement(vm.newEndorsement);
                // l.stop();
              } else {
                SweetAlert.swal("Hecho", MESSAGES.OK.NEWENDORSEMENT, "success");
                l.stop();
                $state.go("endorsement.info", { endosoId: response.data.id });
              }
            }
          } else {
            SweetAlert.swal(
              "Error",
              MESSAGES.ERROR.ERRORCREATEENDORSEMENT,
              "error"
            );
            l.stop();
          }
        });
    };

    /* Registro inicial */
    $scope.registerEndorsement = function (endoso) {
      var comision = (
        parseFloat(vm.form.p_neta) *
        (parseFloat(vm.policy.comision_percent) / 100)
      ).toFixed(2);
      if (isNaN(comision)) {
        var comision_final = 0;
      } else {
        var comision_final = comision;
      }
      $scope.dataToPatch = {
        p_neta: vm.form.p_neta,
        rpf: vm.form.rpf,
        derecho: vm.form.derecho,
        descuento: vm.form.descuento,
        iva: vm.form.iva,
        p_total: vm.form.p_total,
        status: 2,
        number_endorsement: vm.form.number_endorsement,
        comision: comision_final,
        comision_percent: vm.policy.comision_percent,
      };

      if (vm.form.start_of_validity && vm.form.end_of_validity) {
        if (
          datesFactory.toDate(vm.form.start_of_validity) >
          datesFactory.toDate(vm.form.end_of_validity)
        ) {
          SweetAlert.swal(
            "Fechas de vigencia de Endoso",
            "Fecha final no puede ser menor que la inicial",
            "info"
          );
          return;
        }
      }

      /* Objeto original en la póliza*/
      if (vm.form.concept == 1 || vm.form.concept == 11) {
        $scope.dataToPatch.original = {
          forma_de_pago: vm.policy.forma_de_pago,
        };
      } else if (vm.form.concept == 16 || vm.form.concept == 17) {
        $scope.dataToPatch.original = { status: vm.policy.status };
      } else if ($scope.coberturas.indexOf(vm.form.concept) >= 0) {
        $scope.dataToPatch.original = vm.policy.coverageInPolicy_policy;
      } else if ($scope.asegurado.indexOf(vm.form.concept) >= 0) {
        if (vm.policy.automobiles_policy) {
          if (vm.policy.automobiles_policy.length) {
            $scope.dataToPatch.original = vm.policy.automobiles_policy;
          }
        } else if (vm.policy.accidents_policy) {
          if (vm.policy.accidents_policy.length) {
            $scope.dataToPatch.original = vm.policy.accidents_policy;
          }
        } else if (vm.policy.damages_policy) {
          if (vm.policy.damages_policy.length) {
            $scope.dataToPatch.original = vm.policy.damages_policy;
          }
        } else if (vm.policy.life_policy) {
          if (vm.policy.life_policy.length) {
            $scope.dataToPatch.original = vm.policy.life_policy;
          }
        }
      }
      $scope.dataToPatch.endorsement_receipt = [];
      $http
        .patch(endoso.url, $scope.dataToPatch)
        .then(function success(response) {
          if (helpers.isResponseOk(response.status)) {
            vm.patchEndoso = response.data;
            var paramsE = {
              model: 10,
              event: "POST",
              associated_id: vm.newEndorsement.id,
              identifier: "registró el endoso.",
            };
            dataFactory.post("send-log", paramsE);
            /*Fianza*/
            if (
              vm.newEndorsement.endorsement_type == "D" &&
              $scope.fianza_for_endoso == "Fianza"
            ) {
              postRecibosNotas(
                vm.credit_notes,
                vm.form,
                vm.policy,
                vm.patchEndoso
              );
            } else if (
              vm.newEndorsement.endorsement_type == "A" &&
              $scope.fianza_for_endoso == "Fianza"
            ) {
              postRecibos(vm.patchEndoso, vm.policy);
            }
            // $state.go('endorsement.info', {endosoId: vm.patchEndoso.id});
            /* Cambio de forma de pago */
            else if (vm.form.concept == 1 || vm.form.concept == 11) {
              var json = JSON.stringify(eval("(" + endoso.change + ")"));
              var data = JSON.parse(json);
              $http.patch(vm.policy.url, data).then(function success(response) {
                if (helpers.isResponseOk(response.status)) {
                  vm.policy.recibos_poliza.forEach(function (receipt) {
                    if (receipt.receipt_type == 1) {
                      $http.delete(receipt.url);
                    }
                  });
                  if (vm.form.concept == 1) {
                    postRecibos(vm.patchEndoso, vm.policy);
                  } else if (vm.form.concept == 11) {
                    postRecibosNotas(vm.credit_notes, vm.form);
                  }
                }
              });

              /* Cancelación */
            } else if (vm.form.concept == 16 || vm.form.concept == 17) {
              var json = JSON.stringify(eval("(" + endoso.change + ")"));
              var data = JSON.parse(json);
              $http.patch(vm.policy.url, data).then(function success(response) {
                if (vm.patchEndoso.endorsement_type == "D") {
                  postRecibosNotas(
                    vm.credit_notes,
                    vm.form,
                    vm.policy,
                    vm.patchEndoso
                  );
                }
                vm.policy.recibos_poliza.forEach(function (recibo) {
                  if (
                    recibo.status != 1 &&
                    recibo.status != 5 &&
                    recibo.status != 6
                  ) {
                    $http.patch(recibo.url, { status: 2 });
                  }
                });
                // vm.infoNote
              });

              /* Cambio en las coberturas*/
            } else if (
              $scope.coberturas.indexOf(vm.form.concept) >= 0 &&
              $scope.fianza_for_endoso == "Póliza"
            ) {
              var None = "";
              var True = true;
              var json = JSON.stringify(
                eval("(" + vm.patchEndoso.change + ")")
              );
              vm.coveragesToSave = JSON.parse(json);
              vm.coveragesToSave.forEach(function (cobertura) {
                if (endoso.concept == 13) {
                  $http.delete(cobertura.url);
                } else {
                  if (cobertura.owner) {
                    $http.patch(cobertura.url, cobertura);
                  } else {
                    cobertura.policy = vm.policy.url;
                    dataFactory.post("coberturas-polizas/", cobertura);
                  }
                }
              });
              if (vm.patchEndoso.endorsement_type == "A") {
                postRecibos(vm.patchEndoso, vm.policy);
              } else if (vm.patchEndoso.endorsement_type == "D") {
                postRecibosNotas(
                  vm.credit_notes,
                  vm.form,
                  vm.policy,
                  vm.patchEndoso
                );
              }

              /* Cambio en asegurado */
            } else if ($scope.asegurado.indexOf(vm.form.concept) >= 0) {
              if (endoso.concept == 4 && $scope.fianza_for_endoso == "Póliza") {
                var None = "";
                var True = true;
                var False = false;
                var json = JSON.stringify(
                  eval("(" + vm.patchEndoso.change + ")")
                );
                if (vm.policy.accidents_policy.length) {
                  vm.newRelationship = JSON.parse(json);
                  vm.newRelationship.forEach(function (asegurado) {
                    asegurado.accident = vm.policy.accidents_policy[0].url;
                    asegurado.birthdate = new Date(
                      datesFactory.toDate(asegurado.birthdate)
                    );
                    dataFactory.post("v1/relationships/", asegurado);
                  });
                } else if (vm.policy.life_policy.length) {
                  vm.newBeneficiaries = JSON.parse(json);
                  vm.newBeneficiaries.forEach(function (asegurado) {
                    asegurado.life = vm.policy.life_policy[0].url;
                    asegurado.birthdate = new Date(
                      datesFactory.toDate(asegurado.birthdate)
                    );
                    dataFactory.post("v1/beneficiaries/", asegurado);
                  });
                }
                postRecibos(vm.patchEndoso, vm.policy);
              } else if (
                endoso.concept == 20 ||
                endoso.concept == 8 ||
                endoso.concept == 22
              ) {
                var None = "";
                var True = true;
                var False = false;
                var json = JSON.stringify(
                  eval("(" + vm.patchEndoso.change + ")")
                );
                vm.subforms = JSON.parse(json);
                if (vm.policy.accidents_policy.length) {
                  vm.subforms.personal.birthdate = new Date(
                    datesFactory.toDate(vm.subforms.personal.birthdate)
                  );
                  vm.subforms.personal.salary = 0;
                  vm.subforms.personal.sum_assured = 0;
                  $http.patch(vm.subforms.personal.url, vm.subforms.personal);
                  vm.subforms.relationship_accident.forEach(function (
                    asegurado
                  ) {
                    asegurado.birthdate = new Date(
                      datesFactory.toDate(asegurado.birthdate)
                    );
                    $http.patch(asegurado.url, asegurado);
                  });
                } else if (vm.policy.automobiles_policy.length) {
                  $http.patch(vm.subforms.url, vm.subforms);
                } else if (vm.policy.damages_policy.length) {
                  $http.patch(vm.subforms.url, vm.subforms);
                } else if (vm.policy.life_policy.length) {
                  vm.subforms.personal.birthdate = new Date(
                    datesFactory.toDate(vm.subforms.personal.birthdate)
                  );
                  vm.subforms.personal.salary = 0;
                  vm.subforms.personal.sum_assured = 0;
                  $http.patch(vm.subforms.personal.url, vm.subforms.personal);
                  vm.subforms.beneficiaries_life.forEach(function (asegurado) {
                    asegurado.birthdate = new Date(
                      datesFactory.toDate(asegurado.birthdate)
                    );
                    $http.patch(asegurado.url, asegurado);
                  });
                }

                if (vm.patchEndoso.endorsement_type == "A") {
                  postRecibos(vm.patchEndoso, vm.policy);
                } else if (vm.patchEndoso.endorsement_type == "D") {
                  postRecibosNotas(
                    vm.credit_notes,
                    vm.form,
                    vm.policy,
                    vm.patchEndoso
                  );
                } else {
                  $state.go("endorsement.info", {
                    endosoId: vm.patchEndoso.id,
                  });
                }
              } else if (endoso.concept == 15) {
                var None = "";
                var True = true;
                var json = JSON.stringify(
                  eval("(" + vm.patchEndoso.change + ")")
                );

                if (vm.policy.accidents_policy) {
                  //console.log("entra este if")
                  try {
                    vm.toDelRelationship = JSON.parse(json);
                    vm.toDelRelationship.forEach(function (asegurado) {
                      $http.delete(asegurado.url);
                    });
                  } catch (err) {
                    console.log("catch");
                  }
                } else if (vm.policy.life_policy) {
                  vm.toDelBeneficiarie = JSON.parse(json);
                  vm.toDelBeneficiarie.forEach(function (asegurado) {
                    $http.delete(asegurado.url);
                  });
                }
                postRecibosNotas(
                  vm.credit_notes,
                  vm.form,
                  vm.policy,
                  vm.patchEndoso
                );
              }
            } else {
              if (vm.patchEndoso.endorsement_type == "A") {
                postRecibos(vm.patchEndoso, vm.policy);
              } else if (vm.patchEndoso.endorsement_type == "D") {
                postRecibosNotas(
                  vm.credit_notes,
                  vm.form,
                  vm.policy,
                  vm.patchEndoso
                );
              } else {
                $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
              }
            }
            $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
          }
        });
      $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
      SweetAlert.swal("Hecho", MESSAGES.OK.APPLIEDENDORSEMENT, "success");
    };

    /* Alerta success uploadfiles */
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        if ($scope.checkRegister) {
          $scope.registerEndorsement(vm.newEndorsement);
        } else {
          SweetAlert.swal("Hecho", MESSAGES.OK.NEWENDORSEMENT, "success");
          $state.go("endorsement.info", { endosoId: vm.newEndorsement.id });
        }
      }
    };

    /* Alerta error uploadfiles */
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      l.stop();
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + endorsementId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    /* Guarda recibos */
    function postRecibos(endoso, policy) {
      if (vm.form.recibos_poliza) {
        var paramsE = {
          model: 10,
          event: "POST",
          associated_id: endoso.id,
          identifier:
            "creó " + vm.form.recibos_poliza.length + " recibo(s) de endoso",
        };
      } else if (vm.form.recibos_fianza) {
        var paramsE = {
          model: 10,
          event: "POST",
          associated_id: endoso.id,
          identifier:
            "creó " + vm.form.recibos_fianza.length + " recibos de endoso",
        };
      }
      $scope.is_cat = false;
      dataFactory.post("send-log", paramsE);
      if (vm.form.recibos_poliza && $scope.fianza_for_endoso == "Póliza") {
        if (policy) {
          if (policy.recibos_poliza) {
            if (vm.form.recibos_poliza.length > 0) {
              $scope.is_cat = policy.recibos_poliza[0].is_cat;
            } else {
              $scope.is_cat = false;
            }
          } else {
            $scope.is_cat = false;
          }
        } else {
          $scope.is_cat = false;
        }
        vm.form.recibos_poliza.forEach(function (recibo) {
          if (endoso.concept == 1 || endoso.concept == 11) {
            recibo.receipt_type = 1;
          }
          recibo.poliza = policy.url;
          recibo.endorsement = endoso.url;
          recibo.is_cat = $scope.is_cat;
          recibo.fecha_inicio = new Date(
            datesFactory.toDate(recibo.fecha_inicio)
          );
          recibo.fecha_fin = new Date(datesFactory.toDate(recibo.fecha_fin));
          recibo.vencimiento = new Date(
            datesFactory.toDate(recibo.vencimiento)
          );
          dataFactory.post("recibos/", recibo);
          if (endoso.concept == 1) {
            if (isNaN(vm.form.p_total)) {
              vm.form.p_total = 0;
            }
            var data_ = {
              p_neta: vm.form.p_neta,
              rpf: vm.form.rpf,
              derecho: vm.form.derecho,
              iva: vm.form.iva,
              p_total: vm.form.p_total,
              comision_percent: vm.policy.comision_percent,
            };
            $http.patch(policy.url, data_).then(function success(response_) {
              var paramsC = {
                model: 1,
                event: "POST",
                associated_id: policy.id,
                identifier:
                  "actualizó Primas Generales de la Póliza por cambio de Forma de Pago (Endoso A).",
              };
              dataFactory
                .post("send-log/", paramsC)
                .then(function success(response) {});
            });
          }
        });
      } else if (
        vm.form.recibos_poliza &&
        $scope.fianza_for_endoso == "Fianza"
      ) {
        if (policy) {
          if (policy.recibos_poliza) {
            $scope.is_cat = policy.recibos_fianza[0].is_cat;
          } else {
            $scope.is_cat = false;
          }
        } else {
          $scope.is_cat = false;
        }
        vm.form.recibos_poliza.forEach(function (recibo) {
          recibo.receipt_type = 2;
          recibo.poliza = "";
          recibo.is_cat = $scope.is_cat;
          recibo.fianza = policy.url;
          recibo.endorsement = endoso.url;
          recibo.fecha_inicio = new Date(datesFactory.toDate(recibo.startDate));
          recibo.fecha_fin = new Date(datesFactory.toDate(recibo.endingDate));
          recibo.vencimiento = new Date(
            datesFactory.toDate(recibo.vencimiento)
          );
          dataFactory.post("recibos/", recibo);
        });
      }
      $state.go("endorsement.info", { endosoId: endoso.id });
    }

    $scope.calculatePTotal = function () {
      $scope.calculatePT();
    };

    $scope.calculatePT = function () {
      var p_neta = vm.form.p_neta ? parseFloat(vm.form.p_neta) : 0;
      var rpf = vm.form.rpf ? parseFloat(vm.form.rpf) : 0;
      // var iva = vm.form.iva ? parseFloat(vm.form.iva) : 0;
      var gastos = vm.form.gastos_expedicion
        ? parseFloat(vm.form.gastos_expedicion)
        : 0;
      if (vm.policy.subramo.subramo_name == "Vida") {
        var iva = 0;
        vm.form.iva = 0;
      } else {
        // vm.form.iva = 16
        // var iva = vm.form.iva ? parseFloat(vm.form.iva) : 0;
        if ($scope.edited_iva) {
          var iva = vm.form.iva;
        } else {
          // vm.form.iva = 16
          var iva = parseFloat(
            (parseFloat(p_neta) +
              parseFloat(rpf) +
              parseFloat(gastos) * parseFloat(16)) /
              100
          ).toFixed(2);
          var iva = vm.form.iva ? parseFloat(vm.form.iva) : 0;
        }
      }
      // var iva_final = parseFloat((parseFloat(p_neta) * parseFloat(iva)) /100).toFixed(2)
      if ($scope.edited_iva) {
        var iva = vm.form.iva;
        var iva_final = parseFloat(iva).toFixed(2);
        vm.form.iva = iva_final;
      } else {
        // vm.form.iva = 16
        var iva = parseFloat(
          (parseFloat(p_neta) +
            parseFloat(rpf) +
            parseFloat(gastos) * parseFloat(16)) /
            100
        ).toFixed(2);
        var iva = vm.form.iva ? parseFloat(vm.form.iva) : 0;
        var iva_final = parseFloat(iva).toFixed(2);
        vm.form.iva = iva_final;
        console.log("-------", iva);
      }
      // vm.form.iva = iva_final;
      // vm.form.p_total = p_neta + rpf + iva + gastos;
      vm.form.p_total = (
        parseFloat(p_neta) +
        parseFloat(rpf) +
        parseFloat(iva_final) +
        parseFloat(gastos)
      ).toFixed(2);
    };
    $scope.editIva = function (param) {
      console.log("gggggg", param);
      vm.form[param] = String(vm.form[param]).replace(/^[A-Za-z]+$/, "");

      $scope.edited_iva = true;
      if (vm.form.iva) {
        var iva_edited = vm.form.iva;
      } else {
        var iva_edited = 0;
      }
      vm.form.primaTotal = (
        parseFloat(vm.form.subTotal) + parseFloat(iva_edited)
      ).toFixed(2);
    };
    /* Factory para calcular notas*/
    $scope.calculateNote = function (form, actual_receipt) {
      vm.policy.end_date = vm.form.end_of_validity;
      vm.policy.init_date = vm.form.start_of_validity;
      form.rpf = form.rpf ? form.rpf : 0;
      form.gastos_expedicion = form.gastos_expedicion
        ? form.gastos_expedicion
        : 0;
      if (!actual_receipt) {
        vm.credit_notes = notesFactory.updateFieldD(vm.policy, form);
      } else {
        vm.credit_notes = notesFactory.updateFieldD(
          vm.policy,
          form,
          actual_receipt
        );
      }
    };
    $scope.updateFieldD = function () {
      var prima_neta = parseFloat($scope.creditNotes.prima_neta);
      var rpf =
        prima_neta * parseFloat($scope.creditNotes.rpf_percentage * 0.01);
      var gastos_expedicion = parseFloat($scope.creditNotes.gastos_expedicion);
      // var iva = (prima_neta + rpf + gastos_expedicion) * parseFloat($scope.creditNotes.iva_percentage * 0.01);
      if ($scope.edited_iva) {
        var iva = vm.form.iva;
      } else {
        var iva =
          (prima_neta + rpf + gastos_expedicion) *
          parseFloat($scope.creditNotes.iva_percentage * 0.01);
      }
      $scope.creditNotes.prima_neta = prima_neta;
      $scope.creditNotes.gastos_expedicion = gastos_expedicion;
      $scope.creditNotes.vencimiento = vencimiento;
      $scope.creditNotes.rpf = rpf.toFixed(2);
      $scope.creditNotes.iva = iva.toFixed(2);
      $scope.creditNotes.sub_total = (
        prima_neta +
        rpf +
        gastos_expedicion
      ).toFixed(2);
      $scope.creditNotes.prima_total = (
        prima_neta +
        rpf +
        iva +
        gastos_expedicion
      ).toFixed(2);
    };

    /* Guarda notas */
    function postRecibosNotas(notas, infoNotes, policy, endoso) {
      var paramsE = {
        model: 10,
        event: "POST",
        associated_id: endoso.id,
        identifier: "creó " + notas.length + " nota(s) de credito del endoso",
      };
      dataFactory.post("send-log", paramsE);
      $scope.is_cat = false;
      if ($scope.fianza_for_endoso == "Póliza") {
        if (policy) {
          if (policy.recibos_poliza) {
            $scope.is_cat = policy.recibos_poliza[0].is_cat;
          } else {
            $scope.is_cat = false;
          }
        } else {
          $scope.is_cat = false;
        }
        notas.forEach(function (note, index) {
          // note.policy = policy.url;
          if (note.comision) {
            if (
              isNaN(parseFloat(note.comision).toFixed(2)) ||
              note.comision == undefined ||
              note.comision == "" ||
              note.comision == ""
            ) {
              note.comision = 0.0;
            } else {
              note.comision = parseFloat(note.comision).toFixed(2);
            }
          } else {
            note.comision = 0.0;
          }
          note.poliza = policy.url;
          note.is_cat = $scope.is_cat;
          note.receipt_type = 3;
          note.prima_neta = parseFloat(note.prima_neta).toFixed(2);
          note.rpf = parseFloat(note.rpf).toFixed(2);
          note.iva = parseFloat(note.iva).toFixed(2);
          note.comision = parseFloat(note.comision).toFixed(2);
          note.sub_total = parseFloat(note.sub_total).toFixed(2);
          note.derecho = parseFloat(note.gastos_expedicion).toFixed(2);
          note.prima_total = parseFloat(note.prima_total).toFixed(2);
          note.endorsement = endoso.url;
          note.vencimiento = note.vencimiento
            ? note.vencimiento
            : note.fecha_inicio;
          note.recibo_numero = note.recibo_numero
            ? note.recibo_numero
            : parseInt(index) + 1;
          if (note.vencimiento.length == 10) {
            note.vencimiento = new Date(datesFactory.toDate(note.vencimiento));
          }
          // dataFactory.post('notas-credito/', note).then(
          dataFactory
            .post("recibos/", note)
            .then(
              function success(request) {
                if (endoso) {
                  if (endoso.status == 2) {
                    if (
                      endoso.concept == 16 ||
                      endoso.concept == 17 ||
                      vm.description.value == 16 ||
                      vm.description.value == 17
                    ) {
                      if (request.data) {
                        if (request.data.status == 1) {
                          $http
                            .patch(request.data.url, { status: 4 })
                            .then(function success(response) {
                              if (
                                response.status == 200 ||
                                response.status == 201
                              ) {
                              }
                            });
                        }
                      }
                    }
                  }
                }
                $http
                  .get(request.data.poliza)
                  .then(
                    function success(poliza) {
                      // if (poliza.data.natural) {
                      //   $http.get(poliza.data.natural).then(
                      //     function success(natural) {
                      //       if (natural.data.email) {
                      //           //Send Email
                      //         if($localStorage.email_config){
                      //             if($localStorage.email_config.apply_nota == true){
                      //               $scope.idNota = request.data.id;
                      //               var model = 7;
                      //               emailService.sendEmailAtm(model,$scope.idNota)
                      //             }
                      //         }
                      //       }
                      //     },
                      //     function error (error) {
                      //     }
                      //   )
                      //   .catch(function(e) {
                      //     console.log('e', e);
                      //   });
                      // }else if (poliza.data.juridical) {
                      //   $http.get(poliza.data.juridical).then(
                      //     function success(juridical) {
                      //       if (juridical.data.email) {
                      //            //Send Email
                      //         if($localStorage.email_config){
                      //             if($localStorage.email_config.apply_nota == true){
                      //               $scope.idNota = request.data.id;
                      //               var model = 7;
                      //               emailService.sendEmailAtm(model,$scope.idNota)
                      //             }
                      //         }
                      //       }
                      //     },
                      //     function error (error) {
                      //     }
                      //   )
                      //   .catch(function(e) {
                      //     console.log('e', e);
                      //   });
                      // }
                      if (poliza.data.contractor) {
                        $http
                          .get(poliza.data.contractor)
                          .then(
                            function success(contractor) {
                              if (contractor.data.email) {
                                //Send Email
                                if ($localStorage.email_config) {
                                  if (
                                    $localStorage.email_config.apply_nota ==
                                    true
                                  ) {
                                    $scope.idNota = request.data.id;
                                    var model = 7;
                                    emailService.sendEmailAtm(
                                      model,
                                      $scope.idNota
                                    );
                                  }
                                }
                              }
                            },
                            function error(error) {}
                          )
                          .catch(function (e) {
                            console.log("e", e);
                          });
                      }
                    },
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log("e", e);
                  });
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        });
      } else if ($scope.fianza_for_endoso == "Fianza") {
        if (policy) {
          if (policy.recibos_fianza) {
            $scope.is_cat = policy.recibos_fianza[0].is_cat;
          } else {
            $scope.is_cat = false;
          }
        } else {
          $scope.is_cat = false;
        }
        notas.forEach(function (note, index) {
          if (infoNotes.fecha_emision) {
            var fecha_e = new Date(
              datesFactory.toDate(infoNotes.fecha_emision)
            );
          } else {
            var fecha_e = new Date();
          }
          note.poliza = "";
          note.is_cat = $scope.is_cat;
          note.fianza = policy.url;
          note.receipt_type = 3;
          note.prima_neta = parseFloat(note.prima_neta).toFixed(2);
          note.rpf = parseFloat(note.rpf).toFixed(2);
          note.iva = parseFloat(note.iva).toFixed(2);
          note.sub_total = parseFloat(note.sub_total).toFixed(2);
          note.vencimiento = note.vencimiento
            ? note.vencimiento
            : note.fecha_inicio;
          // note.gastos_expedicion = parseFloat(note.gastos_expedicion).toFixed(2)
          note.derecho = parseFloat(note.gastos_expedicion).toFixed(2);
          note.prima_total = parseFloat(note.prima_total).toFixed(2);
          note.endorsement = endoso.url;
          note.recibo_numero = note.recibo_numero
            ? note.recibo_numero
            : parseInt(index) + 1;
          // note.fecha_emision = fecha_e ? fecha_e : new Date();
          // dataFactory.post('notas-credito/', note).then(
          dataFactory
            .post("recibos/", note)
            .then(
              function success(request) {
                if (endoso) {
                  if (endoso.status == 2) {
                    if (
                      endoso.concept == 16 ||
                      endoso.concept == 17 ||
                      vm.description.value == 16 ||
                      vm.description.value == 17
                    ) {
                      if (request.data) {
                        if (request.data.status == 1) {
                          $http
                            .patch(request.data.url, { status: 4 })
                            .then(function success(response) {
                              if (
                                response.status == 200 ||
                                response.status == 201
                              ) {
                              }
                            });
                        }
                      }
                    }
                  }
                }
                $http
                  .get(request.data.fianza)
                  .then(
                    function success(poliza) {
                      // if (poliza.data.natural) {
                      //   $http.get(poliza.data.natural).then(
                      //     function success(natural) {
                      //       if (natural.data.email) {
                      //           //Send Email
                      //         if($localStorage.email_config){
                      //             if($localStorage.email_config.apply_nota == true){
                      //               $scope.idNota = request.data.id;
                      //               var model = 7;
                      //               emailService.sendEmailAtm(model,$scope.idNota)
                      //             }
                      //         }
                      //       }
                      //     },
                      //     function error (error) {
                      //     }
                      //   )
                      //   .catch(function(e) {
                      //     console.log('e', e);
                      //   });
                      // }else if (poliza.data.juridical) {
                      //   $http.get(poliza.data.juridical).then(
                      //     function success(juridical) {
                      //       if (juridical.data.email) {
                      //            //Send Email
                      //         if($localStorage.email_config){
                      //             if($localStorage.email_config.apply_nota == true){
                      //               $scope.idNota = request.data.id;
                      //               var model = 7;
                      //               emailService.sendEmailAtm(model,$scope.idNota)
                      //             }
                      //         }
                      //       }
                      //     },
                      //     function error (error) {
                      //     }
                      //   )
                      //   .catch(function(e) {
                      //     console.log('e', e);
                      //   });
                      // }
                      if (poliza.data.contractor) {
                        $http
                          .get(poliza.data.contractor)
                          .then(
                            function success(contractor) {
                              if (contractor.data.email) {
                                //Send Email
                                if ($localStorage.email_config) {
                                  if (
                                    $localStorage.email_config.apply_nota ==
                                    true
                                  ) {
                                    $scope.idNota = request.data.id;
                                    var model = 7;
                                    emailService.sendEmailAtm(
                                      model,
                                      $scope.idNota
                                    );
                                  }
                                }
                              }
                            },
                            function error(error) {}
                          )
                          .catch(function (e) {
                            console.log("e", e);
                          });
                      }
                    },
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log("e", e);
                  });
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        });
      }
      SweetAlert.swal("¡Listo!", MESSAGES.OK.REGISTERENDOSO, "success");
      $state.go("endorsement.info", { endosoId: endoso.id });
    }

    if ($stateParams.myInsurance != "some default") {
      $scope.myPolicy = $stateParams.myInsurance;
      vm.poliza_number_data = {
        val: $scope.myPolicy.poliza_number,
        id: $scope.myPolicy.id,
      };

      if ($stateParams.contractor.id) {
        $scope.getPolicy($scope.myPolicy, false, 2);
        vm.selectedType = { id: 3, name: "D" };
        vm.descriptions = conceptD;
        SweetAlert.swal(
          "ADVERTENCIA",
          MESSAGES.WARNING.CHOOSECONCEPT,
          "warning"
        );
      }
    }

    /* Configuracion del datepicker */
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    $scope.checkSelected = function (val) {
      if (val == true) {
        $scope.checkRegister = true;
      } else {
        $scope.checkRegister = false;
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EndososCollectivityCtrl", EndososCollectivityCtrl);

  EndososCollectivityCtrl.$inject = [
    "helpers",
    "MESSAGES",
    "SweetAlert",
    "$scope",
    "$rootScope",
    "$http",
    "url",
    "toaster",
    "$state",
    "FileUploader",
    "$timeout",
    "$stateParams",
    "$sessionStorage",
    "endorsementService",
    "dataFactory",
    "notesFactory",
    "datesFactory",
    "models",
    "generalService",
    "collectivityConceptA",
    "collectivityConceptB",
    "collectivityConceptD",
    "payform",
  ];

  function EndososCollectivityCtrl(
    helpers,
    MESSAGES,
    SweetAlert,
    $scope,
    $rootScope,
    $http,
    url,
    toaster,
    $state,
    FileUploader,
    $timeout,
    $stateParams,
    $sessionStorage,
    endorsementService,
    dataFactory,
    notesFactory,
    datesFactory,
    models,
    generalService,
    collectivityConceptA,
    collectivityConceptB,
    collectivityConceptD,
    payform
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = (vm2 = this);
    vm.massive = massive;
    vm.selectNumReceipts = selectNumReceipts;
    vm.num_receipts_data = [
      { name: 1, value: 12 },
      { name: 2, value: 6 },
      { name: 4, value: 3 },
      { name: 6, value: 2 },
      { name: 12, value: 1 },
    ];

    vm.num_notes_data = [
      { name: 0, value: 0 },
      { name: 1, value: 1 },
      { name: 2, value: 2 },
      { name: 3, value: 3 },
      { name: 4, value: 4 },
      { name: 5, value: 5 },
      { name: 6, value: 6 },
      { name: 7, value: 7 },
      { name: 8, value: 8 },
      { name: 9, value: 9 },
      { name: 10, value: 10 },
      { name: 11, value: 11 },
      { name: 12, value: 12 },
    ];

    $scope.subforms = {
      selectedCar: {},
      beneficiariesList: [],
      relationshipList: [],
      damage: {
        coinsurance: "",
        insured_item: "",
        item_address: "",
        item_details: "",
      }, //template.formulario.danios
    };
    $scope.end_type = "manual";
    vm.payform = payform;
    $scope.infoUser = $sessionStorage.infoUser;
    $scope.conceptosA = collectivityConceptA;
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };
    SweetAlert.swal(
      "Módulo Endosos en mantenimiento",
      "Sólo se podrá utilizar: \n•  Endosos Masivos (Altas o Bajas) en Colectivos y, \n•  Opción de concepto: Otro.\nCualquier cambio o ajuste descrito en el endoso deberá realizarlo manualmente en la póliza.",
      "warning"
    );
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          vm.acceso_fian = perm;
          vm.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                vm.acceso_adm_fia = true;
              } else {
                vm.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                vm.acceso_ver_fia = true;
              } else {
                vm.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          vm.acceso_endosos = perm;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }

    $scope.sex = [
      { name: "FEMENINO", value: "F" },
      { name: "MASCULINO", value: "M" },
    ];

    vm.types = [
      {
        id: 0,
        name: "Selecciona un tipo de endoso",
      },
      {
        id: 1,
        name: "A",
      },
      {
        id: 2,
        name: "B",
      },
      {
        id: 3,
        name: "D",
      },
    ];

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 16:
          return "Siniestrada";
          break;
        default:
          return "Pendiente";
      }
    };
    vm.selectedTypeStatus = false;
    vm.covers = [];

    vm.certificates = [];
    $scope.relation = [
      { option: "TITULAR", id: 1 },
      { option: "CÓNYUGE", id: 2 },
      { option: "HIJO", id: 3 },
      { option: "OTRO", id: 4 },
    ];

    vm.form = {};
    vm.form.start_of_validity = datesFactory.convertDate(new Date());
    vm.form.end_of_validity = datesFactory.convertDate(new Date());
    $scope.inputFileDisabled = true;
    $scope.endorsementLoad = [];

    if ($stateParams.myInsurance != "some default") {
      vm.policy = $stateParams.myInsurance;
      vm.word = {
        document_type: 3,
        id: vm.policy.id,
        // val: vm.policy.natural ? vm.policy.natural.full_name + " - " + vm.policy.poliza_number : vm.policy.juridical.j_name + " - " + vm.policy.poliza_number,
        val: vm.policy.contractor
          ? vm.policy.contractor.full_name + " - " + vm.policy.poliza_number
          : " - " + vm.policy.poliza_number,
        value: vm.policy.poliza_number,
      };
      vm.policy.init_date = convertDate(new Date());
      vm.policy.end_date = convertDate(vm.policy.end_of_validity);
      vm.policy.startDate = vm.policy.init_date;
      vm.policy.endingDate = vm.policy.end_date;
      vm.form.startDate = vm.policy.init_date;
      vm.form.endingDate = vm.policy.end_date;
      vm.policy.num_receipts = vm.form.num_receipts;
      vm.collect = vm.word;
      vm.selectTypeStatus = false;
      vm.typeEndoso = "";
      vm.typeForm = "manualEndorsement";

      if ($stateParams.myInsurance.doEndorsement) {
        vm.selectedType = vm.types[0];
        vm.mexicanada = false;
        // vm.selectedConcept = vm.manualConcept[0];
      } else {
        vm.selectedType = vm.types[3];
        vm.mexicanada = true;
        // vm.selectedConcept = vm.manualConcept[6];
      }
    }

    function selectNumReceipts(num) {
      if (vm.policy) {
        // vm.policy.init_date = convertDate(new Date());
        vm.policy.init_date = convertDate(vm.policy.start_of_validity);
        vm.policy.end_date = convertDate(vm.policy.end_of_validity);
        vm.policy.startDate = vm.policy.init_date;
        vm.policy.endingDate = vm.policy.end_date;
      } else {
        vm.policy = $scope.policy;
        vm.policy.init_date = convertDate(vm.policy.start_of_validity);
        vm.policy.end_date = convertDate(vm.policy.end_of_validity);
        vm.policy.startDate = vm.policy.init_date;
        vm.policy.endingDate = vm.policy.end_date;
      }
      vm.form.startDate = vm.policy.init_date;
      vm.form.endingDate = vm.policy.end_date;
      vm.form.start_of_validity = convertDate(vm.policy.start_of_validity);
      vm.form.end_of_validity = convertDate(vm.policy.end_of_validity);
      vm.policy.start_of_validity = vm.policy.start_of_validity;
      vm.form.comision = vm.policy.comision;
      vm.policy.comision = vm.policy.comision;
      // vm.form.policy_starting_date = vm.policy.start_of_validity;
      vm.form.policy_starting_date = new Date();
    }

    $scope.endorsement_type_manual = "caratula";
    $scope.endosoBy = "caratula";
    $scope.valueRadioManual = function (endosoBy) {
      $scope.end_type = "manual";
      $scope.certs_json = [];
      $scope.endosoBy = endosoBy;
      $scope.endorsement_type_manual = endosoBy;
      vm.typeForm = "manualEndorsement";
    };

    $scope.valueRadio = function (val) {
      $scope.endorsement_type_manual = "";
      $scope.inputFileDisabled = false;
      if (val == "altas") {
        $scope.is_register = true;
        vm.selectedType.name = "A";
      } else if (val == "bajas") {
        $scope.is_register = false;
        vm.selectedType.name = "B";
      } else if (val == "manual") {
        $scope.certs_json = [];
      }
      $scope.endorsement_type_manual = "";
      vm.typeForm = "masivoEndorsement";
    };
    $scope.certs_json = [];
    $scope.selectExcel = function (parData, vmWord) {
      vm.word = "";
      vm.certificate = "";
      vm.form = "";
      vm.typeForm = "masivoEndorsement";
      $scope.certs_json = certStructure(parData, vmWord);
      treeStructure($scope.dataToShow, vmWord);
    };
    // Manual form
    $scope.subformRamo = function (cert, subramoCode, poliza) {
      if (vm.manualForm == 1) {
        $scope.subforms.relationshipList = [];
        $scope.subforms.beneficiariesList = [];
      } else {
        $scope.subforms.relationshipList = [];
        $scope.subforms.beneficiariesList = [];
        $scope.addBeneficiarios(cert, subramoCode, poliza);
      }
    };
    $scope.addBeneficiarios = function (cert, subramoCode, poliza) {
      if (subramoCode == 3) {
        $scope.manual = true;
        $scope.manual_life = false;
        $scope.num_certificate = cert.certificate_number;
        $scope.certificado_add = cert;
        $scope.sramo = subramoCode;
        var relacion = angular.copy(models.relationships());
        $scope.subforms.relationshipList.push(relacion);
      } else if (subramoCode == 1) {
        $scope.manual_life = true;
        $scope.manual = false;
        $scope.num_certificate = cert.certificate_number;
        $scope.certificado_add = cert;
        $scope.sramo = subramoCode;
        $scope.subforms.beneficiariesList.push(models.beneficiary());
      }
    };
    $scope.saveBeneficiarios = function (subform, endoso) {
      $scope.endorsementCreate = endoso;
      if ($scope.subramoCode == 3) {
        var disease = $scope.certificado_add;
        var relationships = $scope.subforms.relationshipList;
        var type = helpers.diseaseType($scope.subramoCode);

        var submitObject = {
          code: $scope.subramoCode,
          personal: disease.accidents_policy[0].personal,
          relationships: relationships,
          coinsurance: disease.coinsurance,
          insurance: $scope.caratula,
          accident: disease.accidents_policy[0].url,
          endorsement: endoso.url,
        };
        $scope.crearRelationship(submitObject);
      } else if ($scope.subramoCode == 1) {
        var life = $scope.certificado_add;
        var beneficiarios = $scope.subforms.beneficiariesList;
        var type = helpers.diseaseType($scope.subramoCode);
        var submitObject = {
          code: $scope.subramoCode,
          personal: life.life_policy[0].personal,
          beneficiarios: beneficiarios,
          coinsurance: life.coinsurance,
          insurance: $scope.caratula,
          life: life.life_policy[0].url,
          endorsement: endoso.url,
        };
        $scope.crearRelationship(submitObject);
      }
    };
    $scope.crearRelationship = function (x) {
      if ($scope.checkRegister == undefined || $scope.checkRegister == false) {
        $scope.active = false;
      } else if ($scope.checkRegister == true) {
        $scope.active = true;
      }
      $scope.responseFromThis = {
        personalInfo: null,
        diseaseForm: null,
        relationships: [],
        beneficiarios: [],
      };
      if ($scope.subramoCode == 3) {
        x.relationships.forEach(function (relationship) {
          relationship.birthdate = relationship.birthdate
            ? toDate(relationship.birthdate)
            : null;
          relationship.accident = x.accident;
          relationship.relationship = relationship.relationship
            ? relationship.relationship.id
            : 0;
          relationship.sex = relationship.sex.value;
          relationship.is_active = $scope.active;
          relationship.endorsement = relationship.endorsement
            ? relationship.endoso
            : $scope.endorsementCreate.url;
          generalService
            .createRelationship(relationship)
            .then(function (relationshipData) {
              $scope.responseFromThis.relationships.push(relationship);
              // $scope.selectCategory($scope.parCategory,1)
            });
        });
        $scope.subforms.relationshipList = [];
      } else if ($scope.subramoCode == 1) {
        x.beneficiarios.forEach(function (element, index) {
          element.life = x.life;
          element.birthdate = element.birthdate
            ? toDate(element.birthdate)
            : null;
          element.optional_relationship = element.optional_relationship
            ? element.optional_relationship.id
            : 0;
          element.full_name =
            element.first_name +
            " " +
            element.last_name +
            " " +
            element.second_last_name;
          element.is_active = $scope.active;
          element.endorsement = element.endorsement
            ? element.endorsement
            : $scope.endorsementCreate.url;
          generalService
            .createBeneficiaries(element)
            .then(function (beneficiarie) {
              $scope.responseFromThis.beneficiarios.push(beneficiarie);
            });
        });
        $scope.subforms.beneficiariesList = [];
      }
      $state.go("endorsement.info", { endosoId: vm.newEndorsement.id });
    };
    $scope.options = {
      relationshipList: {
        add: function (rel) {
          var relacion = angular.copy(models.relationships());
          // order.hidden = false;
          $scope.subforms.relationshipList.push(relacion);
        },
        destroy: function (index, rel) {
          $scope.subforms.relationshipList.splice(index, 1);
        },
        selectType: function (newValue, old) {
          var oldValue = old != "" ? JSON.parse(old) : null;
          var newIndex = -1;
          $scope.options.types.some(function (valueData, index) {
            if (valueData.relationship == newValue.relationship) {
              newIndex = index;
              return true;
            }
          });
          var oldIndex = -1;

          if (newValue.relationship == 1 || newValue.relationship == 2) {
            // titular y conyugue
            $scope.options.types[newIndex].disabled = true;
          }

          if (oldValue) {
            $scope.options.types.some(function (val, index) {
              if (val.relationship == oldValue.relationship) {
                oldIndex = index;
                return true;
              }
            });

            if (oldValue.relationship == 1 || oldValue.relationship == 2) {
              // titular y conyugue
              $scope.options.types[oldIndex].disabled = false;
            }
          }
        },
      },
      beneficiary: {
        add: function () {
          // var beneficiary = angular.copy(order.subforms.life.beneficiaries);
          if (
            helpers.beneficiariesPercentageGreaterThanZero(
              $scope.subforms.beneficiariesList
            )
          ) {
            SweetAlert.swal("Error", MESSAGES.ERROR.GREATERTHAN100, "error");
            // toaster.info('No puede tener un porcentaje mayor a 100%.');
            return;
          } else {
            $scope.subforms.beneficiariesList.push(models.beneficiary());
          }
        },
        destroy: function (index) {
          $scope.subforms.beneficiariesList.splice(index, 1);
        },
      },
    };
    function massive() {
      if (!vm.observations) {
        SweetAlert.swal(
          "Error",
          "Escribe una descripción del endoso.",
          "error"
        );
        return;
      }
      vm.policy = $scope.colectivityAlta;
      // return
      if ($scope.is_register) {
        var parUrl = "massive-endorsements-altas/";
      } else {
        var parUrl = "massive-endorsements-bajas/";
      }
      dataFactory
        .post(parUrl, $scope.certs_json)
        .then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            var value = 1;
            var params = {
              model: 10,
              event: "POST",
              associated_id: response.data.id,
              identifier: "creó el endoso colectivo.",
            };
            dataFactory.post("send-log/", params);
            if (vm.observations) {
              var data = {
                observations: vm.observations,
              };
              $http
                .patch(response.data.data.url, data)
                .then(function success(response) {});
            }
          } else {
            var value = 2;
          }
          endorsementDone(value, response.data);
          $scope.endorsementLoad = response.data.data;
          if ($scope.checkRegister) {
            vm.newEndorsement = $scope.endorsementLoad;
            $scope.registerEndorsementColectivo($scope.endorsementLoad);
          }
        });
    }
    $scope.registerEndorsementColectivo = function (endoso) {
      if (isNaN(vm.form.p_total)) {
        vm.form.p_total = 0;
      }
      if (vm.form.num_receipts != 0) {
        $scope.dataToPatch = {
          p_neta: vm.form.p_neta,
          rpf: vm.form.rpf,
          derecho: vm.form.derecho,
          iva: vm.form.iva ? parseFloat(vm.form.iva).toFixed(2) : 0,
          p_total: vm.form.p_total ? vm.form.p_total : 0,
          status: 2,
          number_endorsement: vm.form.number_endorsement,
          comision: 0,
          comision_percent: $scope.colectivityAlta
            ? $scope.colectivityAlta.comision_percent
            : $scope.policy
            ? $scope.policy.comision_percent
            : 0,
        };
        $scope.comision_n = (
          parseFloat(vm.form.p_neta) *
          (parseFloat(
            $scope.colectivityAlta
              ? $scope.colectivityAlta.comision_percent
              : $scope.policy
              ? $scope.policy.comision_percent
              : 0
          ) /
            100)
        ).toFixed(2);
        if (isNaN($scope.comision_n)) {
          $scope.dataToPatch.comision = 0;
        } else {
          $scope.dataToPatch.comision = $scope.comision_n;
        }
      } else {
        vm.form.p_total = (
          parseFloat(vm.form.p_neta) +
          parseFloat(vm.form.rpf) +
          parseFloat(vm.form.iva) +
          parseFloat(vm.form.derecho)
        ).toFixed(2);
        if (vm.policy.administration_type == 2) {
          $scope.dataToPatch = {
            p_neta: vm.form.p_neta ? vm.form.p_neta : 0,
            rpf: vm.form.rpf ? vm.form.rpf : 0,
            derecho: vm.form.derecho ? vm.form.derecho : 0,
            iva: vm.form.iva ? parseFloat(vm.form.iva).toFixed(2) : 0,
            p_total: vm.form.p_total ? vm.form.p_total : 0,
            status: 2,
            number_endorsement: vm.form.number_endorsement,
            comision: 0,
            comision_percent: $scope.colectivityAlta
              ? $scope.colectivityAlta.comision_percent
              : $scope.policy
              ? $scope.policy.comision_percent
              : 0,
          };
          $scope.comision_n = (
            parseFloat(vm.form.p_neta) *
            (parseFloat(
              $scope.colectivityAlta
                ? $scope.colectivityAlta.comision_percent
                : $scope.policy
                ? $scope.policy.comision_percent
                : 0
            ) /
              100)
          ).toFixed(2);
          if (isNaN($scope.comision_n)) {
            $scope.dataToPatch.comision = 0;
          } else {
            $scope.dataToPatch.comision = $scope.comision_n;
          }
        } else {
          $scope.dataToPatch = {
            p_neta: vm.form.p_neta ? vm.form.p_neta : 0,
            rpf: vm.form.rpf ? vm.form.rpf : 0,
            derecho: vm.form.derecho ? vm.form.derecho : 0,
            iva: vm.form.iva ? parseFloat(vm.form.iva).toFixed(2) : 0,
            p_total: vm.form.p_total ? vm.form.p_total : 0,
            status: 2,
            number_endorsement: vm.form.number_endorsement,
            comision: 0,
            comision_percent: $scope.colectivityAlta
              ? $scope.colectivityAlta.comision_percent
              : $scope.policy
              ? $scope.policy.comision_percent
              : 0,
          };
          $scope.dataToPatch.comision = 0;
        }
      }

      if (vm.form.num_notas != 0) {
        if (isNaN(vm.form.p_total)) {
          vm.form.p_total = 0;
        }
        $scope.dataToPatch = {
          p_neta: vm.form.p_neta,
          rpf: vm.form.rpf,
          derecho: vm.form.derecho,
          iva: vm.form.iva ? parseFloat(vm.form.iva).toFixed(2) : 0,
          p_total: vm.form.p_total ? vm.form.p_total : 0,
          status: 2,
          number_endorsement: vm.form.number_endorsement,
          comision: 0,
          comision_percent: $scope.colectivityAlta
            ? $scope.colectivityAlta.comision_percent
            : $scope.policy
            ? $scope.policy.comision_percent
            : 0,
        };
        $scope.comision_n = (
          parseFloat(vm.form.p_neta) *
          (parseFloat(
            $scope.colectivityAlta
              ? $scope.colectivityAlta.comision_percent
              : $scope.policy
              ? $scope.policy.comision_percent
              : 0
          ) /
            100)
        ).toFixed(2);
        if (isNaN($scope.comision_n)) {
          $scope.dataToPatch.comision = 0;
        } else {
          $scope.dataToPatch.comision = $scope.comision_n;
        }
      } else {
        vm.form.p_total = (
          parseFloat(vm.form.p_neta) +
          parseFloat(vm.form.rpf) +
          parseFloat(vm.form.iva) +
          parseFloat(vm.form.gastos_expedicion)
        ).toFixed(2);
        if (vm.policy.administration_type == 2) {
          $scope.dataToPatch = {
            p_neta: vm.form.p_neta ? vm.form.p_neta : 0,
            rpf: vm.form.rpf ? vm.form.rpf : 0,
            derecho: vm.form.gastos_expedicion ? vm.form.gastos_expedicion : 0,
            iva: vm.form.iva ? parseFloat(vm.form.iva).toFixed(2) : 0,
            p_total: vm.form.p_total ? vm.form.p_total : 0,
            status: 2,
            number_endorsement: vm.form.number_endorsement,
            comision: 0,
            comision_percent: $scope.colectivityAlta
              ? $scope.colectivityAlta.comision_percent
              : $scope.policy
              ? $scope.policy.comision_percent
              : 0,
          };
          $scope.comision_n = (
            parseFloat(vm.form.p_neta) *
            (parseFloat(
              $scope.colectivityAlta
                ? $scope.colectivityAlta.comision_percent
                : $scope.policy
                ? $scope.policy.comision_percent
                : 0
            ) /
              100)
          ).toFixed(2);
          if (isNaN($scope.comision_n)) {
            $scope.dataToPatch.comision = 0;
          } else {
            $scope.dataToPatch.comision = $scope.comision_n;
          }

          $scope.dataToPatch.p_neta = $scope.dataToPatch.p_neta * -1;
          $scope.dataToPatch.rpf = $scope.dataToPatch.rpf * -1;
          $scope.dataToPatch.derecho = $scope.dataToPatch.derecho * -1;
          $scope.dataToPatch.iva = $scope.dataToPatch.iva * -1;
          $scope.dataToPatch.p_total =
            parseFloat($scope.dataToPatch.p_total) * -1;
        } else {
          $scope.dataToPatch = {
            p_neta: vm.form.p_neta ? vm.form.p_neta : 0,
            rpf: vm.form.rpf ? vm.form.rpf : 0,
            derecho: vm.form.derecho ? vm.form.derecho : 0,
            iva: vm.form.iva ? parseFloat(vm.form.iva).toFixed(2) : 0,
            p_total: vm.form.p_total ? vm.form.p_total : 0,
            status: 2,
            number_endorsement: vm.form.number_endorsement,
            comision: 0,
            comision_percent: $scope.colectivityAlta
              ? $scope.colectivityAlta.comision_percent
              : $scope.policy
              ? $scope.policy.comision_percent
              : 0,
          };
          $scope.dataToPatch.comision = 0;
        }
      }

      $http
        .patch(endoso.url, $scope.dataToPatch)
        .then(function success(response) {
          if (helpers.isResponseOk(response.status)) {
            vm.patchEndoso = response.data;
            var data = {
              id_endoso: vm.patchEndoso.id,
            };
            dataFactory
              .post("get-relation/", data)
              .then(function success(response) {
                vm.certificates = response.data;
              });
            var paramsE = {
              model: 10,
              event: "POST",
              associated_id: vm.newEndorsement.id,
              identifier: "registró el endoso.",
            };
            dataFactory.post("send-log", paramsE);
            // ALTAS Y BAJAS COLECTIVIDAD
            if (vm.patchEndoso.concept == 24 || vm.patchEndoso.concept == 25) {
              if (
                vm.patchEndoso.endorsement_type == "A" &&
                vm.patchEndoso.concept == 24
              ) {
                dataFactory
                  .post("get-relation/", data)
                  .then(function success(response) {
                    vm.certificates = response.data;
                    vm.certificates.forEach(function (certificado) {
                      var data = {
                        certificate: certificado.certificate.id,
                        certificate_number:
                          certificado.certificate.certificate_number_patch,
                      };
                      dataFactory
                        .post("activate-cert", data)
                        .then(function (data_) {
                          var datab = { is_active: true };
                          if (
                            $scope.colectivityAlta.subramo.subramo_code == 3
                          ) {
                            if (
                              certificado.certificate.accidents_policy.length >
                              0
                            ) {
                              if (
                                certificado.certificate.accidents_policy[0]
                                  .relationship_accident.length > 0
                              ) {
                                certificado.certificate.accidents_policy[0].relationship_accident.forEach(
                                  function (relas) {
                                    if (
                                      relas.endorsement == vm.patchEndoso.url
                                    ) {
                                      if (relas.is_active == false) {
                                        $http
                                          .patch(relas.url, datab)
                                          .then(function (dataBen) {
                                            console.log(
                                              "-------alta--A-dependiente accidente-",
                                              dataBen
                                            );
                                          });
                                      }
                                    }
                                  }
                                );
                              }
                            }
                          } else if (
                            $scope.colectivityAlta.subramo.subramo_code == 1
                          ) {
                            if (
                              certificado.certificate.life_policy.length > 0
                            ) {
                              if (
                                certificado.certificate.life_policy[0]
                                  .beneficiaries_life.length > 0
                              ) {
                                certificado.certificate.life_policy[0].beneficiaries_life.forEach(
                                  function (relas) {
                                    if (
                                      relas.endorsement == vm.patchEndoso.url
                                    ) {
                                      if (relas.is_active == false) {
                                        $http
                                          .patch(relas.url, datab)
                                          .then(function (dataBen) {
                                            console.log(
                                              "-------alta--A-beneficirio vida-",
                                              dataBen
                                            );
                                          });
                                      }
                                    }
                                  }
                                );
                              }
                            }
                          }
                        });
                    });
                  });
                if ($scope.colectivityAlta) {
                  postRecibos(vm.patchEndoso, $scope.colectivityAlta);
                } else if ($scope.policy) {
                  postRecibos(vm.patchEndoso, $scope.policy);
                }
              } else if (
                vm.patchEndoso.endorsement_type == "B" &&
                vm.patchEndoso.concept == 24
              ) {
                dataFactory
                  .get("endorsement-certs/", { id_endoso: vm.patchEndoso.id })
                  .then(function success(response) {
                    if (response.data.results.length) {
                      response.data.results.forEach(function (certificado) {
                        var data = {
                          certificado_inciso_activo: true,
                        };
                        // $http.patch(certificado.certificate, data);
                        $http
                          .patch(certificado.certificate.url, data)
                          .then(function (data) {
                            // console.log('-------alta--B--',data)
                            var datab = { is_active: true };
                            if (
                              $scope.colectivityAlta.subramo.subramo_code == 3
                            ) {
                              if (
                                certificado.certificate.accidents_policy
                                  .length > 0
                              ) {
                                if (
                                  certificado.certificate.accidents_policy[0]
                                    .relationship_accident.length > 0
                                ) {
                                  certificado.certificate.accidents_policy[0].relationship_accident.forEach(
                                    function (relas) {
                                      if (
                                        relas.endorsement == vm.patchEndoso.url
                                      ) {
                                        if (relas.is_active == false) {
                                          $http
                                            .patch(relas.url, datab)
                                            .then(function (dataBen) {
                                              console.log(
                                                "-------alta--B-dependiente accidente-",
                                                dataBen
                                              );
                                            });
                                        }
                                      }
                                    }
                                  );
                                }
                              }
                            } else if (
                              $scope.colectivityAlta.subramo.subramo_code == 1
                            ) {
                              if (
                                certificado.certificate.life_policy.length > 0
                              ) {
                                if (
                                  certificado.certificate.life_policy[0]
                                    .beneficiaries_life.length > 0
                                ) {
                                  certificado.certificate.life_policy[0].beneficiaries_life.forEach(
                                    function (relas) {
                                      if (
                                        relas.endorsement == vm.patchEndoso.url
                                      ) {
                                        if (relas.is_active == false) {
                                          $http
                                            .patch(relas.url, datab)
                                            .then(function (dataBen) {
                                              console.log(
                                                "-------alta--B-beneficirio vida-",
                                                dataBen
                                              );
                                            });
                                        }
                                      }
                                    }
                                  );
                                }
                              }
                            }
                          });
                      });
                    }
                  });
                // activate();
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.REGISTERENDOSO,
                  "success"
                );
                $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
              } else if (
                vm.patchEndoso.endorsement_type == "B" &&
                vm.patchEndoso.concept == 25
              ) {
                dataFactory
                  .get("endorsement-certs/", { id_endoso: vm.patchEndoso.id })
                  .then(function success(response) {
                    if (response.data.results.length) {
                      response.data.results.forEach(function (certificado) {
                        var data = {
                          certificado_inciso_activo: false,
                        };
                        // $http.patch(certificado.certificate, data);
                        $http
                          .patch(certificado.certificate.url, data)
                          .then(function (data) {
                            // console.log('-------baja---B-',data)
                          });
                      });
                    }
                    if (response.data.results.length == 0) {
                      var datab = { is_active: false };
                      if ($scope.colectivityAlta.concept == 25) {
                        if ($scope.colectivityAlta.subramo.subramo_code == 3) {
                          var data = {
                            id_endoso: vm.patchEndoso.id,
                          };
                          dataFactory
                            .post("relationDependiente/", data)
                            .then(function success(responseRel) {
                              responseRel.data.forEach(function (relas) {
                                if (relas.endorsement == vm.patchEndoso.url) {
                                  if (relas.is_active == true) {
                                    $http
                                      .patch(relas.url, datab)
                                      .then(function (dataBen) {
                                        console.log(
                                          "-------baja--D benefnicairio baja-",
                                          dataBen
                                        );
                                      });
                                  }
                                }
                              });
                            });
                        } else if (
                          $scope.colectivityAlta.subramo.subramo_code == 1
                        ) {
                          var data = {
                            id_endoso: vm.patchEndoso.id,
                          };
                          dataFactory
                            .post("relationBeneficiarios/", data)
                            .then(function success(responseRel) {
                              console.log("------relats", responseRel);
                              responseRel.data.forEach(function (relas) {
                                if (relas.endorsement == vm.patchEndoso.url) {
                                  if (relas.is_active == true) {
                                    $http
                                      .patch(relas.url, datab)
                                      .then(function (dataBen) {
                                        console.log(
                                          "-------baja--D benefnicairio baja-",
                                          dataBen
                                        );
                                      });
                                  }
                                }
                              });
                            });
                        }
                      }
                    }
                  });
                // activate();
                // $uibModalInstance.dismiss('cancel');
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.REGISTERENDOSO,
                  "success"
                );
                $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
              } else if (
                vm.patchEndoso.endorsement_type == "D" &&
                vm.patchEndoso.concept == 25
              ) {
                // console.log('----',vm.patchEndoso.endorsement_type,vm.patchEndoso,$scope.end_type)
                dataFactory
                  .get("endorsement-certs/", { id_endoso: vm.patchEndoso.id })
                  .then(function success(response) {
                    if (response.data.results.length) {
                      // console.log('-fdsssssssss-------------',response.data)
                      response.data.results.forEach(function (certificado) {
                        var data = {
                          certificado_inciso_activo: false,
                        };
                        // $http.patch(certificado.certificate, data);
                        $http
                          .patch(certificado.certificate.url, data)
                          .then(function (data) {
                            // console.log('-------baja--D--',data)
                          });
                      });
                    }
                    if (response.data.results.length == 0) {
                      var datab = { is_active: false };
                      if (vm.patchEndoso.concept == 25) {
                        if ($scope.colectivityAlta.subramo.subramo_code == 3) {
                          var data = {
                            id_endoso: vm.patchEndoso.id,
                          };
                          dataFactory
                            .post("relationDependiente/", data)
                            .then(function success(responseRel) {
                              responseRel.data.forEach(function (relas) {
                                if (relas.endorsement == vm.patchEndoso.url) {
                                  if (relas.is_active == true) {
                                    $http
                                      .patch(relas.url, datab)
                                      .then(function (dataBen) {
                                        console.log(
                                          "-------baja--D benefnicairio baja-",
                                          dataBen
                                        );
                                      });
                                  }
                                }
                              });
                            });
                        } else if (
                          $scope.colectivityAlta.subramo.subramo_code == 1
                        ) {
                          var data = {
                            id_endoso: vm.patchEndoso.id,
                          };
                          dataFactory
                            .post("relationBeneficiarios/", data)
                            .then(function success(responseRel) {
                              console.log("------relats", responseRel);
                              responseRel.data.forEach(function (relas) {
                                if (relas.endorsement == vm.patchEndoso.url) {
                                  if (relas.is_active == true) {
                                    $http
                                      .patch(relas.url, datab)
                                      .then(function (dataBen) {
                                        console.log(
                                          "-------baja--D benefnicairio baja-",
                                          dataBen
                                        );
                                      });
                                  }
                                }
                              });
                            });
                        }
                      }
                    }
                  });
                // activate();
                postNotas(vm.credit_notes, vm.form, vm.policy, vm.patchEndoso);
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.REGISTERENDOSO,
                  "success"
                );
                $state.go("endorsement.info", { endosoId: vm.patchEndoso.id });
              }
            }
          }
        });
      SweetAlert.swal("Hecho", MESSAGES.OK.APPLIEDENDORSEMENT, "success");
    };
    // -------exist
    $scope.checkNumEndoso = function (poliza, number) {
      if ($scope.collectSelected) {
        var npoliza = $scope.collectSelected
          ? $scope.collectSelected.value
          : $scope.collectSelected.id;
      }
      if (vm.form.number_endorsement) {
        dataFactory
          .get("exist-number-endorsement/", {
            number: vm.form.number_endorsement,
            poliza: npoliza,
          })
          .then(function (request) {
            if (request.data.status == true) {
              SweetAlert.swal("Error", "Número de Endoso existente", "error");
              vm.form.number_endorsement = "";
            }
          })
          .catch(function (err) {});
      }
    };
    function endorsementDone(value, endoso) {
      if (value == 1) {
        if ($scope.countFile > 0) {
          uploadFiles(endoso.data.id, 1);
        } else {
          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
          $state.go("endorsement.info", { endosoId: endoso.data.id });
        }
      } else {
        if (
          endoso == "No se encontró la póliza" ||
          endoso == "Existe mas de un objeto con el mismo número de certificado"
        ) {
          SweetAlert.swal("Error", endoso, "error");
        } else {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        }
      }
    }

    function certStructure(parData, v) {
      var strcuture_data = [];
      $scope.dataToShow = [];
      vm.selectedConcept = {};
      if ($scope.end_type == "altas") {
        vm.selectedConcept.id = 24;
        vm.selectedType = {
          name: "A",
        };
      }
      if ($scope.end_type == "bajas") {
        vm.selectedConcept.id = 25;
        vm.selectedType = {
          name: "D",
        };
      }
      if (parData.ASEGURADOS) {
        if (parData.ASEGURADOS[0].NUM_POLIZA) {
          $scope.numPoliza = parData.ASEGURADOS[0].NUM_POLIZA;
        } else if (parData.ASEGURADOS[0].SUBGRUPO) {
          $http
            .get(url.IP + "polizas/" + parData.ASEGURADOS[0].SUBGRUPO)
            .then(function (pl) {
              if (pl.status == 200 || plstatus == 201) {
                $http
                  .get(url.IP + "polizas/" + pl.data.caratula)
                  .then(function (xc) {
                    if (xc.status == 200 || plstatus == 201) {
                      $scope.numPoliza = xc.data.poliza_number;
                      $scope.policy = xc.data;
                      vm.policy = xc.data;
                      $scope.colectivityAlta = xc.data;
                      parData.ASEGURADOS[0].NUM_POLIZA = xc.data.poliza_number;
                      console.log("-ds", $scope.numPoliza);
                    }
                  });
              }
            });
        } else if (parData.ASEGURADOS[0].CATEGORIA) {
          $http
            .get(url.IP + "polizas/" + parData.ASEGURADOS[0].CATEGORIA)
            .then(function (pl) {
              if (pl.status == 200 || plstatus == 201) {
                $http
                  .get(url.IP + "polizas/" + pl.data.caratula)
                  .then(function (xc) {
                    if (xc.status == 200 || plstatus == 201) {
                      $scope.numPoliza = xc.data.poliza_number;
                      $scope.policy = xc.data;
                      vm.policy = xc.data;
                      $scope.colectivityAlta = xc.data;
                      parData.ASEGURADOS[0].NUM_POLIZA = xc.data.poliza_number;
                      console.log("-ds", $scope.numPoliza);
                    }
                  });
              }
            });
        }
      } else if (parData.INCISOS) {
        if (parData.INCISOS[0].NUM_POLIZA) {
          $scope.numPoliza = parData.INCISOS[0].NUM_POLIZA;
        } else if (parData.INCISOS[0].SUBGRUPO) {
          $http
            .get(url.IP + "polizas/" + parData.INCISOS[0].SUBGRUPO)
            .then(function (pl) {
              if (pl.status == 200 || plstatus == 201) {
                $http
                  .get(url.IP + "polizas/" + pl.data.caratula)
                  .then(function (xc) {
                    if (xc.status == 200 || plstatus == 201) {
                      $scope.numPoliza = xc.data.poliza_number;
                      $scope.policy = xc.data;
                      vm.policy = xc.data;
                      $scope.colectivityAlta = xc.data;
                      parData.INCISOS[0].NUM_POLIZA = xc.data.poliza_number;
                    }
                  });
              }
            });
        } else if (parData.INCISOS[0].CATEGORIA) {
          $http
            .get(url.IP + "polizas/" + parData.INCISOS[0].CATEGORIA)
            .then(function (pl) {
              if (pl.status == 200 || plstatus == 201) {
                $http
                  .get(url.IP + "polizas/" + pl.data.caratula)
                  .then(function (xc) {
                    if (xc.status == 200 || plstatus == 201) {
                      $scope.numPoliza = xc.data.poliza_number;
                      $scope.policy = xc.data;
                      vm.policy = xc.data;
                      $scope.colectivityAlta = xc.data;
                      parData.INCISOS[0].NUM_POLIZA = xc.data.poliza_number;
                    }
                  });
              }
            });
        }
      }
      dataFactory
        .get("colectivityByNumber/", { pk: $scope.numPoliza })
        .then(function success(response) {
          if (response.status == 200 || response.status == 201) {
            $scope.colectivityAlta = response.data;
            $scope.policy = response.data;
            vm.policy = response.data;
            if ($scope.end_type == "altas") {
              vm.selectedConcept.id = 24;
              vm.selectedType = {
                name: "A",
              };
            }
            if ($scope.end_type == "bajas") {
              vm.selectedConcept.id = 25;
              vm.selectedType = {
                name: "D",
              };
            }
          } else {
            SweetAlert.swal(
              "Error",
              "No se encontro el número de póliza.",
              "error"
            );
          }
        });
      for (var key in parData) {
        var data = parData[key];
        if (data.length) {
          data.forEach(function (item) {
            // console.log('------s-----',item)
            if (item.SEXO) {
              $scope.INI_VIGENCIA = new Date(convertDate(item.INI_VIGENCIA));
              $scope.FIN_VIGENCIA = new Date(convertDate(item.FIN_VIGENCIA));
              $scope.FEC_MOVIMIENTO = new Date(
                convertDate(item.FEC_MOVIMIENTO)
              );

              if (item.ANTIGUEDAD) {
                // item.ANTIGUEDAD = (item.ANTIGUEDAD) ? new Date(convertDate(item.ANTIGUEDAD)) : '';
                $scope.ANTIGUEDAD = item.ANTIGUEDAD
                  ? new Date(convertDate(item.ANTIGUEDAD))
                  : "";
              }
              var itemtoShow = angular.copy(item);
              $scope.dataToShow.push(itemtoShow);
              if (item.FEC_NAC) {
                item.FEC_NAC = new Date(convertDate(item.FEC_NAC));
              } else {
              }
              strcuture_data.push(item);
            } else if (item.SMOKER) {
              $scope.INI_VIGENCIA = new Date(convertDate(item.INI_VIGENCIA));
              $scope.FIN_VIGENCIA = new Date(convertDate(item.FIN_VIGENCIA));
              if ($scope.ANTIGUEDAD) {
                $scope.ANTIGUEDAD = item.ANTIGUEDAD
                  ? new Date(convertDate(item.ANTIGUEDAD))
                  : "";
              }
              var itemtoShow = angular.copy(item);
              $scope.dataToShow.push(itemtoShow);
              $scope.FEC_MOVIMIENTO = new Date(
                convertDate(item.FEC_MOVIMIENTO)
              );
              strcuture_data.push(item);
            } else if (item.MARCA || item.MATRICULA || item.SERIAL) {
              $scope.INI_VIGENCIA = new Date(convertDate(item.INI_VIGENCIA));
              $scope.FIN_VIGENCIA = new Date(convertDate(item.FIN_VIGENCIA));
              var itemtoShow = angular.copy(item);
              $scope.dataToShow.push(itemtoShow);
              $scope.FEC_MOVIMIENTO = new Date(
                convertDate(item.FEC_MOVIMIENTO)
              );
              if (item.ANTIGUEDAD) {
                $scope.ANTIGUEDAD = item.ANTIGUEDAD
                  ? new Date(convertDate(item.ANTIGUEDAD))
                  : "";
              }
              strcuture_data.push(item);
            } else if (item.CIUDAD || item.ESTADO || item.CP) {
              $scope.INI_VIGENCIA = new Date(convertDate(item.INI_VIGENCIA));
              $scope.FIN_VIGENCIA = new Date(convertDate(item.FIN_VIGENCIA));
              var itemtoShow = angular.copy(item);
              $scope.dataToShow.push(itemtoShow);
              $scope.FEC_MOVIMIENTO = new Date(
                convertDate(item.FEC_MOVIMIENTO)
              );
              if (item.ANTIGUEDAD) {
                $scope.ANTIGUEDAD = item.ANTIGUEDAD
                  ? new Date(convertDate(item.ANTIGUEDAD))
                  : "";
              }
              strcuture_data.push(item);
            }
            if ($scope.FEC_MOVIMIENTO == "Invalid Date") {
              $scope.FEC_MOVIMIENTO = item.FEC_MOVIMIENTO
                ? toDate(item.FEC_MOVIMIENTO)
                : "";
            } else {
              $scope.FEC_MOVIMIENTO = $scope.FEC_MOVIMIENTO;
            }
            if ($scope.INI_VIGENCIA == "Invalid Date") {
              $scope.INI_VIGENCIA = item.INI_VIGENCIA
                ? toDate(item.INI_VIGENCIA)
                : "";
            } else {
              $scope.INI_VIGENCIA = $scope.INI_VIGENCIA;
            }
            if ($scope.FIN_VIGENCIA == "Invalid Date") {
              $scope.FIN_VIGENCIA = item.FIN_VIGENCIA
                ? toDate(item.FIN_VIGENCIA)
                : "";
            } else {
              $scope.FIN_VIGENCIA = $scope.FIN_VIGENCIA;
            }
            if ($scope.INI_VIGENCIA == "Invalid Date") {
              $scope.INI_VIGENCIA = item.INI_VIGENCIA
                ? toDate(item.INI_VIGENCIA)
                : "";
            } else {
              $scope.INI_VIGENCIA = $scope.INI_VIGENCIA;
            }
            if ($scope.FIN_VIGENCIA == "Invalid Date") {
              $scope.FIN_VIGENCIA = item.FIN_VIGENCIA
                ? toDate(item.FIN_VIGENCIA)
                : "";
            } else {
              $scope.FIN_VIGENCIA = $scope.FIN_VIGENCIA;
            }

            if ($scope.ANTIGUEDAD == "Invalid Date") {
              $scope.ANTIGUEDAD = item.ANTIGUEDAD
                ? toDate(item.ANTIGUEDAD)
                : "";
            } else {
              $scope.ANTIGUEDAD = $scope.ANTIGUEDAD;
            }
            item.ANTIGUEDAD = $scope.ANTIGUEDAD;
            item.FEC_MOVIMIENTO = $scope.FEC_MOVIMIENTO;
            item.INI_VIGENCIA = $scope.INI_VIGENCIA;
            item.FIN_VIGENCIA = $scope.FIN_VIGENCIA;
          });
        }
      }
      return strcuture_data;
    }
    /* Guarda recibos */
    function postRecibos(endoso, policy) {
      if (vm.patchEndoso.policy && $scope.endosoBy == "certificado") {
        if (vm.form.num_receipts != 0) {
          var paramsE = {
            model: 10,
            event: "POST",
            associated_id: endoso.id,
            identifier:
              "creó " + vm.form.recibos_poliza.length + " recibo(s) de endoso.",
          };
          dataFactory.post("send-log", paramsE);

          vm.form.recibos_poliza.forEach(function (recibo) {
            if (endoso.concept == 43) {
              recibo.receipt_type = 1;
            }
            console.log("ddddddd", $scope.endosoBy);
            recibo.poliza = policy.url;
            recibo.endorsement = endoso.url;
            if (isNaN(recibo.fecha_inicio) || recibo.fecha_inicio == "") {
              recibo.fecha_inicio = endoso.init_date;
            } else {
              recibo.fecha_inicio = new Date(
                datesFactory.toDate(endoso.start_of_validity)
              );
            }

            if (isNaN(recibo.fecha_fin) || recibo.fecha_fin == "") {
              recibo.fecha_fin = endoso.end_date;
            } else {
              recibo.fecha_fin = new Date(
                datesFactory.toDate(recibo.endingDate)
              );
            }

            if (isNaN(recibo.vencimiento) || recibo.vencimiento == "") {
              recibo.vencimiento = endoso.init_date;
            } else {
              recibo.vencimiento = new Date(
                datesFactory.toDate(recibo.vencimiento)
              );
            }

            recibo.prima_total = parseFloat(recibo.prima_total).toFixed(2);
            if (policy) {
              if (policy.recibos_poliza) {
                recibo.is_cat = policy.recibos_poliza[0]
                  ? policy.recibos_poliza[0].is_cat
                  : false;
              }
            }
            dataFactory.post("recibos/", recibo);
          });

          $state.go("endorsement.info", { endosoId: endoso.id });
        } else {
          $state.go("endorsement.info", { endosoId: endoso.id });
        }
      } else {
        if (vm.form.num_receipts != 0) {
          var paramsE = {
            model: 10,
            event: "POST",
            associated_id: endoso.id,
            identifier:
              "creó " + vm.form.recibos_poliza.length + " recibo(s) de endoso.",
          };
          dataFactory.post("send-log", paramsE);
          vm.form.recibos_poliza.forEach(function (recibo) {
            if (endoso.concept == 43) {
              recibo.receipt_type = 1;
            }
            recibo.poliza = policy.url;
            recibo.endorsement = endoso.url;
            if (recibo.fecha_inicio) {
              try {
                recibo.fecha_inicio = new Date(
                  datesFactory.toDate(recibo.fecha_inicio)
                );
              } catch (err) {
                recibo.fecha_inicio = new Date(recibo.fecha_inicio);
              }
            } else if (
              isNaN(recibo.fecha_inicio) ||
              recibo.fecha_inicio == ""
            ) {
              recibo.fecha_inicio = endoso.init_date;
            } else {
              recibo.fecha_inicio = new Date(
                datesFactory.toDate(recibo.fecha_inicio)
              );
            }
            // Fecha Fin
            if (recibo.fecha_fin) {
              try {
                recibo.fecha_fin = new Date(
                  datesFactory.toDate(recibo.fecha_fin)
                );
              } catch (err) {
                recibo.fecha_fin = new Date(recibo.fecha_fin);
              }
            } else if (isNaN(recibo.fecha_fin) || recibo.fecha_fin == "") {
              recibo.fecha_fin = endoso.end_date;
            } else {
              recibo.fecha_fin = new Date(
                datesFactory.toDate(recibo.fecha_fin)
              );
            }

            if (recibo.vencimiento) {
              try {
                recibo.vencimiento = new Date(
                  datesFactory.toDate(recibo.vencimiento)
                );
              } catch (err) {
                recibo.vencimiento = new Date(recibo.vencimiento);
              }
            } else if (isNaN(recibo.vencimiento) || recibo.vencimiento == "") {
              recibo.vencimiento = endoso.init_date;
            } else {
              recibo.vencimiento = new Date(
                datesFactory.toDate(recibo.vencimiento)
              );
            }

            recibo.prima_total = parseFloat(recibo.prima_total).toFixed(2);
            if (policy) {
              if (policy.recibos_poliza) {
                recibo.is_cat = policy.recibos_poliza[0]
                  ? policy.recibos_poliza[0].is_cat
                  : false;
              }
            }
            dataFactory.post("recibos/", recibo);
          });
          if (vm.form.num_receipts != 0) {
            if (isNaN(vm.form.p_total)) {
              vm.form.p_total = 0;
            }
            var data_ = {
              p_neta: vm.form.p_neta,
              rpf: vm.form.rpf,
              derecho: vm.form.derecho,
              iva: vm.form.iva ? parseFloat(vm.form.iva).toFixed(2) : 0,
              p_total: vm.form.p_total,
              status: 2,
              number_endorsement: vm.form.number_endorsement,
              comision: 0,
              comision_percent: $scope.colectivityAlta
                ? $scope.colectivityAlta.comision_percent
                : $scope.policy
                ? $scope.policy.comision_percent
                : 0,
            };
            $scope.comision_n = (
              parseFloat(vm.form.p_neta) *
              (parseFloat(
                $scope.colectivityAlta
                  ? $scope.colectivityAlta.comision_percent
                  : $scope.policy
                  ? $scope.policy.comision_percent
                  : 0
              ) /
                100)
            ).toFixed(2);
            if (isNaN($scope.comision_n)) {
              data_.comision = 0;
            } else {
              data_.comision = $scope.comision_n;
            }
          } else {
            var data_ = {
              p_neta: 0,
              rpf: 0,
              derecho: 0,
              iva: 0,
              p_total: 0,
              status: 2,
              number_endorsement: vm.form.number_endorsement,
              comision: 0,
              comision_percent: 0,
            };
            $scope.data_.comision = 0;
          }
          $http.patch(endoso.url, data_).then(function success(response__) {
            if (endoso.concept == 43) {
              if (isNaN(vm.form.p_total)) {
                vm.form.p_total = 0;
              }
              var data_ = {
                p_neta: vm.form.p_neta,
                rpf: vm.form.rpf,
                derecho: vm.form.derecho,
                iva: vm.form.iva ? parseFloat(vm.form.iva).toFixed(2) : 0,
                p_total: vm.form.p_total,
                comision_percent: $scope.colectivityAlta
                  ? $scope.colectivityAlta.comision_percent
                  : $scope.policy
                  ? $scope.policy.comision_percent
                  : 0,
              };
              $http.patch(policy.url, data_).then(function success(response_) {
                var paramsC = {
                  model: 18,
                  event: "POST",
                  associated_id: policy.id,
                  identifier:
                    "actualizó Primas Generales de la Carátula por cambio de Forma de Pago (Endoso A).",
                };
                dataFactory
                  .post("send-log/", paramsC)
                  .then(function success(response) {});
              });
            }
          });
          $state.go("endorsement.info", { endosoId: endoso.id });
        } else {
          $state.go("endorsement.info", { endosoId: endoso.id });
        }
      }
    }

    $scope.calculatePT = function () {
      if (vm.form.p_neta != undefined || !isNaN(vm.form.p_neta)) {
        var p_neta = parseFloat(vm.form.p_neta);
      } else {
        var p_neta = 0;
      }
      if (vm.form.rpf != undefined || !isNaN(vm.form.rpf)) {
        var rpf = parseFloat(vm.form.rpf);
      } else {
        var rpf = 0;
      }
      if (vm.form.iva != undefined || !isNaN(vm.form.iva)) {
        var iva = parseFloat(vm.form.iva).toFixed(2);
      } else {
        var iva = 0;
      }
      if (vm.policy.subramo.subramo_name == "Vida") {
        var iva = 0;
        vm.form.iva = 0;
      } else {
        // vmm.infoNote.iva = 16
        vm.form.iva = parseFloat(p_neta) * 0.16;
        // var iva = vm.form.iva ? parseFloat(vm.form.iva) : 0;
        // vm.form.iva = 16
        // var iva = vm.form.iva ? parseFloat(vm.form.iva) : 0;
        if ($scope.edited_iva) {
          var iva = vm.form.iva;
        } else {
          // vm.form.iva = 16
          var iva = parseFloat(
            (parseFloat(p_neta) +
              parseFloat(rpf) +
              parseFloat(gastos) * parseFloat(16)) /
              100
          ).toFixed(2);
          var iva = vm.form.iva ? parseFloat(vm.form.iva) : 0;
        }
      }
      // var iva_final = parseFloat((parseFloat(p_neta) * parseFloat(iva)) /100).toFixed(2)
      if ($scope.edited_iva) {
        var iva = vm.form.iva;
        var iva_final = parseFloat(iva).toFixed(2);
        vm.form.iva = iva_final;
      } else {
        // vm.form.iva = 16
        var iva = parseFloat(
          (parseFloat(p_neta) +
            parseFloat(rpf) +
            parseFloat(gastos) * parseFloat(16)) /
            100
        ).toFixed(2);
        var iva = vm.form.iva ? parseFloat(vm.form.iva) : 0;
        var iva_final = parseFloat(iva).toFixed(2);
        vm.form.iva = iva_final;
      }
      if (
        vm.form.gastos_expedicion != undefined ||
        !isNaN(vm.form.gastos_expedicion)
      ) {
        var gastos = parseFloat(vm.form.gastos_expedicion);
      } else {
        var gastos = 0;
      }
      vm.form.p_total = parseFloat(
        parseFloat(p_neta) +
          parseFloat(rpf) +
          parseFloat(iva) +
          parseFloat(gastos)
      ).toFixed(2);
    };
    $scope.editIva = function (param) {
      vm.form[param] = String(vm.form[param]).replace(/^[A-Za-z]+$/, "");

      $scope.edited_iva = true;
      if (vm.form.iva) {
        var iva_edited = vm.form.iva;
      } else {
        var iva_edited = 0;
      }
      vm.form.primaTotal = (
        parseFloat(vm.form.subTotal) + parseFloat(iva_edited)
      ).toFixed(2);
    };
    /* Factory para calcular notas*/
    $scope.calculateNote = function (form, actual_receipt) {
      if ($scope.endosoBy == "caratula") {
        vm.policy.init_date = new Date();
        vm.policy.end_date = vm.policy.end_of_validity;
        vm.policy.init_date = convertDate(vm.policy.init_date);
        vm.policy.end_date = convertDate(vm.policy.end_date);

        if (!actual_receipt) {
          vm.credit_notes = notesFactory.updateFieldD(vm.policy, form);
        } else {
          vm.credit_notes = notesFactory.updateFieldD(
            vm.policy,
            form,
            actual_receipt
          );
        }
      } else if ($scope.endosoBy == "certificado") {
        vm.policy.init_date = new Date();
        vm.policy.end_date = vm.policy.end_date;
        vm.policy.init_date = convertDate(vm.policy.init_date);
        vm.policy.end_date = convertDate(vm.policy.end_date);

        if (!actual_receipt) {
          vm.credit_notes = notesFactory.updateFieldD(vm.policy, form);
        } else {
          vm.credit_notes = notesFactory.updateFieldD(
            vm.policy,
            form,
            actual_receipt
          );
        }
      }
    };

    /* Guarda notas */
    function postNotas(notas, infoNotes, policy, endoso) {
      if (!notas) {
        notas = [];
      }
      var paramsE = {
        model: 10,
        event: "POST",
        associated_id: endoso.id,
        identifier: "creó " + notas.length + " nota(s) de crédito del endoso.",
      };
      $scope.is_cat = false;
      if (policy) {
        if (policy.recibos_poliza) {
          $scope.is_cat = policy.recibos_poliza[0]
            ? policy.recibos_poliza[0].is_cat
            : false;
        } else {
          $scope.is_cat = false;
        }
      } else {
        $scope.is_cat = false;
      }
      if (notas.length != 0) {
        dataFactory.post("send-log", paramsE);
        notas.forEach(function (note, index) {
          note.poliza = policy.url;
          note.receipt_type = 3;
          note.is_cat = $scope.is_cat;
          note.prima_neta = parseFloat(note.prima_neta).toFixed(2);
          note.rpf = parseFloat(note.rpf).toFixed(2);
          note.iva = parseFloat(note.iva).toFixed(2);
          note.sub_total = parseFloat(note.sub_total).toFixed(2);
          note.derecho = parseFloat(note.gastos_expedicion).toFixed(2);
          note.prima_total = parseFloat(note.prima_total).toFixed(2);
          note.endorsement = endoso.url;
          note.vencimiento = note.vencimiento
            ? note.vencimiento
            : note.fecha_inicio;
          note.recibo_numero = note.recibo_numero
            ? note.recibo_numero
            : parseInt(index) + 1;
          // dataFactory.post('notas-credito/', note);
          dataFactory.post("recibos/", note);
        });
        var data_ = {
          status: 2,
        };
        $http.patch(endoso.url, data_).then(function success(response__) {});
        $state.go("endorsement.info", { endosoId: endoso.id });
      } else {
        dataFactory.post("send-log", paramsE);
        $state.go("endorsement.info", { endosoId: endoso.id });
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
      return dateObject;
    }

    function treeStructure(parJson) {
      var tree = [];
      parJson.forEach(function (item) {
        if (!item.CERTIFICADO) {
          item.CERTIFICADO = "Sin # certificado";
        }

        if (!item.INCISO) {
          item.INCISO = "Sin # certificado";
        } else {
          item.CERTIFICADO = item.INCISO;
        }

        if (item.SMOKER) {
          var smoker = item.SMOKER == 0 ? "No" : "Si";
          var parent_content =
            "<strong>Póliza: </strong> " +
            item.NUM_POLIZA +
            " - " +
            "<strong>Certificado: </strong> " +
            item.CERTIFICADO +
            " - " +
            "<strong>Nombre: </strong> " +
            item.NOMBRE +
            "  " +
            item.AP_PAT +
            "  " +
            item.AP_MAT +
            " - " +
            "<strong>Fecha de nacimiento: </strong>" +
            item.FEC_NAC +
            " - " +
            "<strong>Sexo: </strong>" +
            item.SEXO +
            " - " +
            "<strong>Email: </strong>" +
            item.EMAIL +
            " - " +
            "<strong>Fumador: </strong>" +
            smoker +
            " - " +
            "<strong>Fecha movimiento: </strong>" +
            item.FEC_MOVIMIENTO;
          var element = {
            text: parent_content,
          };
          tree.push(element);
        } else if (item.CERTIFICADO && (!item.MARCA || !item.MATRICULA)) {
          var parent_content =
            "<strong>Póliza: </strong> " +
            item.NUM_POLIZA +
            " - " +
            "<strong>Certificado: </strong> " +
            item.CERTIFICADO +
            " - " +
            "<strong>Nombre: </strong> " +
            item.NOMBRE +
            "  " +
            item.AP_PAT +
            "  " +
            item.AP_MAT +
            " - " +
            "<strong>Fecha de nacimiento: </strong>" +
            item.FEC_NAC +
            " - " +
            "<strong>Sexo: </strong>" +
            item.SEXO +
            " - " +
            "<strong>Email: </strong>" +
            item.EMAIL +
            " - " +
            "<strong>Fecha movimiento: </strong>" +
            item.FEC_MOVIMIENTO;
          var element = {
            text: parent_content,
          };
          tree.push(element);
        } else if (item.MARCA || item.MATRICULA || item.SERIAL) {
          var parent_content =
            "<strong>Póliza: </strong> " +
            item.NUM_POLIZA +
            " - " +
            "<strong>Certificado: </strong> " +
            item.CERTIFICADO +
            " - " +
            "<strong>Marca: </strong>" +
            item.MARCA +
            " - " +
            "<strong>Modelo: </strong>" +
            item.MODELO +
            " - " +
            "<strong>Año: </strong>" +
            item.AÑO +
            " - " +
            "<strong>Color: </strong>" +
            item.COLOR +
            " - " +
            "<strong>Matrícula: </strong>" +
            item.MATRICULA +
            " - " +
            "<strong>Motor: </strong>" +
            item.MOTOR +
            " - " +
            "<strong>Serial: </strong>" +
            item.SERIAL +
            " - " +
            "<strong>Email: </strong>" +
            item.EMAIL +
            " - " +
            "<strong>Fecha movimiento: </strong>" +
            item.FEC_MOVIMIENTO;
          var element = {
            text: parent_content,
          };
          tree.push(element);
        }
      });
      $("#endorsemented_tree").treeview({ data: tree });
    }

    vm.getCollet = getCollet;
    function getCollet(parId) {
      if (parId) {
        if (parId.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contractor = 'v2/polizas/get-endorsements-collect/';
          $scope.show_contractor = "get-endorsements-collect/";
          $http({
            method: "POST",
            url: url.IP + $scope.show_contractor,
            data: {
              word: parId.val,
              mode: $scope.endorsement_type_manual,
            },
          })
            .then(
              function success(request) {
                //console.log(request);
                var results = [];
                var mapeo = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    // $scope.btnSearchDisabled = true;
                    toaster.warning("Póliza no encontrada");
                  } else {
                    // $scope.btnSearchDisabled = false;
                    toaster.success("Póliza existente");
                    request.data.forEach(function (poliza) {
                      vm.policy = poliza;
                      vm.policy.init_date = convertDate(new Date());
                      vm.policy.end_date = convertDate(
                        vm.policy.end_of_validity
                      );
                      vm.policy.startDate = vm.policy.init_date;
                      vm.policy.endingDate = vm.policy.end_date;
                      vm.form.startDate = vm.policy.init_date;
                      vm.form.endingDate = vm.policy.end_date;
                      // vm.form.num_receipts = vm.form.num_receipts;
                      vm.policy.num_receipts = vm.form.num_receipts;
                      if (poliza.document_type == 3) {
                        mapeo.push(poliza);
                      }
                    });
                    results = _.map(mapeo, function (item) {
                      if (item.contractor) {
                        var label =
                          item.contractor + " - " + item.poliza_number;
                      }
                      // if(item.juridical) {
                      //   var label = item.juridical + ' - '+ item.poliza_number;
                      // }
                      // else{
                      //   var label = item.natural + ' - '+ item.poliza_number;
                      // }
                      return {
                        label: label,
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                      };
                    });
                    $scope.autocompleteData = results;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    }

    // endos por Certificado
    vm.getCertificate = getCertificate;
    function getCertificate(parId) {
      if (parId) {
        if (parId.val.length >= 3) {
          $http({
            method: "POST",
            url: url.IP + "get-certificatesforendoso/",
            data: {
              word: parId.val,
              id_collect: $scope.collectSelected.id,
              mode: $scope.endorsement_type_manual,
            },
          })
            .then(
              function success(request) {
                $scope.autocompleteDataCertificate = [];
                $scope.certificados_todos = [];
                var results_cert = [];
                var mapeo_cert = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    // $scope.btnSearchDisabled = true;
                    toaster.warning("Certificado no encontrado");
                  } else {
                    // $scope.btnSearchDisabled = false;
                    // toaster.success("Certificado existente");
                    request.data.forEach(function (poliza) {
                      $scope.certificados_todos.push(poliza);
                      vm.certificado_for_endoso = poliza;
                      vm.certificado_for_endoso.init_date = convertDate(
                        new Date()
                      );
                      vm.certificado_for_endoso.end_date = convertDate(
                        vm.certificado_for_endoso.end_of_validity
                      );
                      vm.certificado_for_endoso.startDate =
                        vm.certificado_for_endoso.init_date;
                      vm.certificado_for_endoso.endingDate =
                        vm.certificado_for_endoso.end_date;
                      vm.form.startDate = vm.certificado_for_endoso.init_date;
                      vm.form.endingDate = vm.certificado_for_endoso.end_date;
                      // vm.form.num_receipts = vm.form.num_receipts;
                      vm.certificado_for_endoso.num_receipts =
                        vm.form.num_receipts;
                      if (poliza.document_type == 6) {
                        mapeo_cert.push(poliza);
                      }
                    });
                    results_cert = _.map(mapeo_cert, function (item) {
                      if (item.accidents_policy.length) {
                        var label =
                          "Carátula: " +
                          item.poliza_number +
                          " - Certificado: " +
                          item.certificate_number +
                          " - Titular: " +
                          item.accidents_policy[0].personal.first_name +
                          " " +
                          item.accidents_policy[0].personal.last_name;
                      } else if (item.life_policy.length) {
                        var label =
                          "Carátula: " +
                          item.poliza_number +
                          " - Certificado: " +
                          item.certificate_number +
                          " - Titular: " +
                          item.life_policy[0].personal.first_name +
                          " " +
                          item.life_policy[0].personal.last_name;
                      } else if (item.automobiles_policy.length) {
                        var label =
                          "Carátula: " +
                          item.poliza_number +
                          " - Certificado: " +
                          item.certificate_number +
                          " - Serie: " +
                          item.automobiles_policy[0].serial +
                          " " +
                          item.automobiles_policy[0].serial;
                      }
                      return {
                        label: label ? label : "",
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                        url: item.url,
                        contacto: item.contacto,
                        certificate_number: item.certificate_number,
                      };
                    });
                    $scope.autocompleteDataCertificate = results_cert;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    }
    // Endoso por certificado
    vm.policy = [];
    vm.collect = [];
    $scope.noData = false;
    vm.selectedType = [];

    vm.getType = getType;
    function getType(collect) {
      $scope.collectSelected = collect;
      $scope.certs_json = [];
      // vm.policy = collect;
      vm.policy.init_date = convertDate(new Date());
      vm.policy.end_date = convertDate(vm.policy.end_of_validity);
      vm.policy.startDate = vm.policy.init_date;
      vm.policy.endingDate = vm.policy.end_date;
      vm.form.startDate = vm.policy.init_date;
      vm.form.endingDate = vm.policy.end_date;
      vm.form.num_receipts = vm.form.num_receipts;
      vm.policy.num_receipts = vm.form.num_receipts;
      vm.collect = collect;
      vm.selectTypeStatus = false;
      vm.typeEndoso = "";
      vm.selectedType = vm.types[0];
      // vm.selectedConcept = vm.manualConcept[0];
      vm.typeForm = "manualEndorsement";
      $scope.closeCertificate();
      // ------------------
      if ($scope.endosoBy == "certificado") {
        $http({
          method: "GET",
          url: url.IP + "get-endorsements-certificates/",
          params: {
            caratula: vm.collect.id,
          },
        }).then(function success(request) {
          vm.certificates_for_endo = request.data.results;
          vm.infoCertificateEndoso = request.data.results[0];
          $scope.existCertificates = false;
          if (request.status == 200) {
            if (request.data.results.length > 0) {
              $scope.existCertificates = true;
            } else {
              SweetAlert.swal(
                "Sin Certificados",
                MESSAGES.WARNING.WITHOUTCERTS,
                "warning"
              );
              $scope.existCertificates = false;
              $scope.endosoBy = "caratula";
              $scope.endorsement_type_manual = "caratula";
              $scope.valueRadioManual("caratula");
            }
          }
        });
      }
    }
    // Endoso por certificado-------
    vm.getTypeCertificate = getTypeCertificate;
    $scope.subgrupoReceipts = {};
    function getTypeCertificate(certificado) {
      for (var i = 0; i < $scope.certificados_todos.length; i++) {
        if ($scope.certificados_todos[i].id == certificado.id) {
          vm.certificado_for_endoso = $scope.certificados_todos[i];
        }
      }

      $scope.certificateForEndoso = certificado;
      // vm.selectedConcept = vm.manualConcept[0];
      vm.typeForm = "manualEndorsement";
      $scope.closeCertificate();
      // ------------------
      if ($scope.endosoBy == "certificado") {
        // console.log('----pol,cert,collseleted -----',vm.policy,$scope.certificateForEndoso,$scope.collectSelected)
        $scope.certificadoEndoso = certificado;
        $scope.subgrupoReceipts = {};
        dataFactory
          .get("polizas/" + $scope.collectSelected.id)
          .then(function success(polizaSelected) {
            if (polizaSelected.status == 200 || polizaSelected.status == 201) {
              vm.policy = polizaSelected.data;
              vm.policy.init_date = convertDate(new Date());
              vm.policy.end_date = convertDate(vm.policy.end_of_validity);
              vm.policy.startDate = vm.policy.init_date;
              vm.policy.endingDate = vm.policy.end_date;
              vm.form.startDate = vm.policy.init_date;
              vm.form.endingDate = vm.policy.end_date;
              // vm.form.num_receipts = vm.form.num_receipts;
              vm.policy.num_receipts = vm.form.num_receipts;
              vm.policy.receipts_by = polizaSelected.data.receipts_by;
              if (vm.policy.receipts_by == 2) {
                $http
                  .get(vm.certificado_for_endoso.parent)
                  .then(function success(respponse) {
                    $http
                      .get(respponse.data.parent)
                      .then(function success(response) {
                        if (response.data.document_type == 4) {
                          $scope.subgrupoReceipts = response.data;
                        }
                      });
                  });
              } else {
                $scope.subgrupoReceipts = {};
              }
            }
          });
        // if (vm.policy.receipts_by == 2) {
        //   console.log('----recibos ṕor subgrupos-----',vm.policy)
        //   $http.get(vm.certificado_for_endoso.parent).then(function success(respponse) {
        //     $http.get(respponse.data.parent).then(function success(response) {
        //       if(response.data.document_type == 4){
        //         $scope.subgrupoReceipts = response.data;
        //         console.log('------------subgrupoReceipts-------',$scope.subgrupoReceipts)
        //       }
        //     })
        //   })
        // }else{
        //   $scope.subgrupoReceipts ={};
        // }
      }
    }
    // Endoso certificado------------

    $scope.typeEndosos = function (type) {
      $scope.certificate = [];
      vm.typeEndoso = type.name;
      vm.selectTypeStatus = true;
      angular.element("input[type='file']").val(null);
      var id = vm.collect.id ? vm.collect.id : vm.word.id;
      $http({
        method: "GET",
        url: url.IP + "get-caratula/" + id + "/",
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              vm.policy = request.data;
              $scope.changeConcept(type);
              if (vm.policy.administration_type == "Autoadministrada") {
                vm.num_receipts_data = [
                  { name: 0, value: 0 },
                  { name: 1, value: 12 },
                  { name: 2, value: 6 },
                  { name: 3, value: 4 },
                  { name: 4, value: 3 },
                  { name: 5, value: 5.5 },
                  { name: 6, value: 2 },
                  { name: 7, value: 7 },
                  { name: 8, value: 8 },
                  { name: 9, value: 9 },
                  { name: 10, value: 10 },
                  { name: 11, value: 11 },
                  { name: 12, value: 1 },
                ];
              } else {
                vm.num_receipts_data = [
                  { name: 0, value: 0 },
                  { name: 1, value: 12 },
                  { name: 2, value: 6 },
                  { name: 3, value: 4 },
                  { name: 4, value: 3 },
                  { name: 5, value: 5.5 },
                  { name: 6, value: 2 },
                  { name: 7, value: 7 },
                  { name: 8, value: 8 },
                  { name: 9, value: 9 },
                  { name: 10, value: 10 },
                  { name: 11, value: 11 },
                  { name: 12, value: 1 },
                ];
              }
              vm.form.tipo_endoso = 1;
              vm.form.start_of_validity = datesFactory.convertDate(new Date());
              vm.form.end_of_validity = datesFactory.convertDate(
                vm.policy.end_of_validity
              );
              // if(vm.policy.natural){
              //   $scope.direccion_contratante=[];
              //   vm.contractor = vm.policy.natural;
              //   vm.contractor.name = vm.policy.natural.first_name + " " + vm.policy.natural.last_name;
              //   vm.contractor.type_person = vm.policy.natural.type_person;
              //   vm.contractor.emall = vm.policy.natural.emall;
              //   vm.contractor.phone_number = vm.policy.natural.phone_number;

              //   vm.contractor.address = vm.policy.natural.address_natural[0].route + " " +
              //                           vm.policy.natural.address_natural[0].street_number + " " +
              //                           vm.policy.natural.address_natural[0].street_number_int + " " +
              //                           vm.policy.natural.address_natural[0].administrative_area_level_2 + ", " +
              //                           vm.policy.natural.address_natural[0].administrative_area_level_1;
              // }
              // if(vm.policy.juridical){
              //   $scope.direccion_contratante=[];
              //   vm.contractor = vm.policy.juridical;
              //   vm.contractor.name = vm.policy.juridical.j_name;
              //   vm.contractor.type_person = vm.policy.juridical.type_person;
              //   vm.contractor.emall = vm.policy.juridical.emall;
              //   vm.contractor.phone_number = vm.policy.juridical.phone_number;
              //   vm.contractor.address = vm.policy.juridical.address_juridical[0].route + " " +
              //                           vm.policy.juridical.address_juridical[0].street_number + " " +
              //                           vm.policy.juridical.address_juridical[0].street_number_int + " " +
              //                           vm.policy.juridical.address_juridical[0].administrative_area_level_2 + ", " +
              //                           vm.policy.juridical.address_juridical[0].administrative_area_level_1;
              // }
              if (vm.policy.contractor) {
                $scope.direccion_contratante = [];
                vm.contractor = vm.policy.contractor;
                vm.contractor.name =
                  vm.policy.contractor.first_name +
                  " " +
                  vm.policy.contractor.last_name;
                vm.contractor.type_person = vm.policy.contractor.type_person;
                vm.contractor.emall = vm.policy.contractor.emall;
                vm.contractor.phone_number = vm.policy.contractor.phone_number;

                vm.contractor.address =
                  vm.policy.contractor.address_contractor[0].route +
                  " " +
                  vm.policy.contractor.address_contractor[0].street_number +
                  " " +
                  vm.policy.contractor.address_contractor[0].street_number_int +
                  " " +
                  vm.policy.contractor.address_contractor[0]
                    .administrative_area_level_2 +
                  ", " +
                  vm.policy.contractor.address_contractor[0]
                    .administrative_area_level_1;
              }
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
      if (
        vm.collect.document_type === 3 ||
        vm.collect.document_type === 4 ||
        vm.collect.document_type === 5
      ) {
        vm.typeForm = "manualEndorsement";
        switch (vm.collect.document_type) {
          case 3:
            vm.titleTable = "Carátula";
            break;
          case 4:
            vm.titleTable = "Subgrupo";
            break;
          case 5:
            vm.titleTable = "Categoría";
            break;
          default:
            vm.titleTable = "Endosos colectivos";
        }

        $http({
          method: "GET",
          url: url.IP + "get-endorsements-certificates/",
          params: {
            caratula: vm.collect.id,
          },
        }).then(function success(request) {
          vm.certificates = request.data.results;
          vm.infoCertificate = request.data.results[0];
          $scope.noData = false;
          if (request.status == 200) {
            if (request.data.results.length == 0) {
              $scope.noData = true;
            }
          }
        });
      }
    };

    $scope.changeConcept = function (type) {
      if (type.name == "A") {
        vm.manualConcept = collectivityConceptA;
        vm.manualConcept.forEach(function (x, c) {
          if (vm.policy.receipts_by == 1) {
            vm.manualConcept = [
              { id: 43, name: "CAMBIO DE FORMA DE PAGO" },
              { id: 29, name: "OTRO" },
            ];
          } else {
            if (x.id == 43) {
              vm.manualConcept.splice(vm.manualConcept.indexOf(x), 1);
            }
          }
        });
        $scope.totalRecs = vm.policy.recibos_poliza.length;
        $scope.numRecs = 0;
        vm.policy.recibos_poliza.forEach(function (x, c) {
          if (x.status == 4) {
            $scope.numRecs += 1;
          }
        });
        if ($scope.totalRecs == $scope.numRecs && vm.policy.receipts_by == 1) {
          vm.manualConcept = [
            { id: 43, name: "CAMBIO DE FORMA DE PAGO" },
            { id: 29, name: "OTRO" },
          ];
        } else {
          vm.manualConcept = [{ id: 29, name: "OTRO" }];
          if (vm.policy.receipts_by == 1) {
            SweetAlert.swal(
              "Información",
              "Existen Recibos Pagados \nSi requiere Cambio Forma de Pago debe contactar con Soporte",
              "info"
            );
          }
        }
      }
      if (type.name == "B") {
        vm.manualConcept = collectivityConceptB;
      } else if (type.name == "D") {
        vm.manualConcept = collectivityConceptD;
      }
    };

    $scope.conceptEndoso = function (cadena) {
      vm.certsCollect = [];
      vm.conceptSel = cadena.id;
      if (cadena.id == 29) {
        $scope.otros = true;
      }
      if (vm.conceptSel == 31) {
        vm.certificates.forEach(function (cert) {
          vm.certsCollect.push({
            id: cert.id,
            certificate_number: cert.certificate_number,
            accidents_policy: cert.accidents_policy,
            life_policy: cert.life_policy,
          });
        });
      } else {
        vm.manualForm = 1;
        $scope.subramoCode = 0;
      }
    };
    $scope.certificateSelected = function (cert) {
      vm.manualForm = 2;
      $scope.caratula = vm.policy;
      $scope.numCertificado = cert.certificate_number;
      if (cert.accidents_policy) {
        if (cert.accidents_policy.length != 0) {
          $scope.subramoCode = 3;
          $scope.subformRamo(cert, $scope.subramoCode, vm.policy);
        }
      }
      if (cert.life_policy) {
        if (cert.life_policy.length != 0) {
          $scope.subramoCode = 1;
          $scope.subformRamo(cert, $scope.subramoCode, vm.policy);
        }
      }
      if (!(cert.accidents_policy || cert.life_policy)) {
        $scope.subramoCode = "";
      }
    };

    $scope.search = function (cadena) {
      vm.certificates = [];
      $http({
        method: "GET",
        url: url.IP + "get-endorsement-certificates",
        params: {
          cadena: cadena,
          caratula: vm.collect.id,
        },
      }).then(function success(request) {
        vm.certificates = request.data.results;
      });
    };

    $scope.createEndorsement = function (param) {
      if (
        vm.form.num_notas > 0 &&
        vm.form.num_notas != undefined &&
        vm.selectedType.name == "D"
      ) {
        if ($scope.checkRegister) {
          if (!vm.credit_notes) {
            SweetAlert.swal(
              "-Notas de Crédito-",
              "Debe calcular las Notas de Crédito",
              "warning"
            );
            return;
          }
        }
      }

      if ($scope.endosoBy == "caratula") {
        if ($scope.subramoCode == 1) {
          if (
            $scope.subforms.beneficiariesList.length == 0 ||
            !$scope.numCertificado
          ) {
            SweetAlert.swal("Información", "Ingrese beneficiarios", "warning");
            return;
          }
        } else if ($scope.subramoCode == 3) {
          if (
            $scope.subforms.relationshipList.length == 0 ||
            !$scope.numCertificado
          ) {
            SweetAlert.swal("Información", "Ingrese dependientes", "warning");
            return;
          }
        }
      }
      if ($scope.endosoBy == "caratula") {
        $scope.dataToSave = {
          endorsement_type: vm.selectedType.name,
          policy: vm.policy.url,
          init_date: new Date(datesFactory.toDate(vm.form.start_of_validity)),
          end_date: new Date(datesFactory.toDate(vm.form.end_of_validity)),
          concept: vm.selectedConcept.id,
          observations: vm.observations,
          policy_type: 2,
          other_desc: vm.form.other_desc ? vm.form.other_desc : "",
        };
      } else if ($scope.endosoBy == "certificado") {
        if ($scope.certificateForEndoso == undefined) {
          SweetAlert.swal("Error", MESSAGES.ERROR.SELECTCERTTOEND, "error");
          vm.credit_notes = [];
          return;
        }
        $scope.dataToSave = {
          endorsement_type: vm.selectedType.name,
          policy: $scope.certificateForEndoso.url,
          init_date: new Date(datesFactory.toDate(vm.form.start_of_validity)),
          end_date: new Date(datesFactory.toDate(vm.form.end_of_validity)),
          concept: vm.selectedConcept.id,
          observations: vm.observations,
          policy_type: 2,
          other_desc: vm.form.other_desc ? vm.form.other_desc : "",
        };
        if ($scope.endosoBy == "certificado" && !$scope.certificateForEndoso) {
          if ($scope.certificateForEndoso == undefined) {
            vm.credit_notes = [];
            SweetAlert.swal("Error", MESSAGES.ERROR.SELECTCERTTOEND, "error");
            return;
          }
        }
      }
      if (
        $scope.dataToSave.observations == null ||
        $scope.dataToSave.observations == undefined ||
        !$scope.dataToSave.observations
      ) {
        SweetAlert.swal("Información", MESSAGES.ERROR.ENDOSOBS, "warning");
        return;
      }
      if ($scope.endosoBy == "caratula") {
        if (vm.selectedConcept.id == 27) {
          $scope.dataToSave.change = {
            rec_antiguedad: $scope.antiguedad,
            certificado: $scope.certificate_to_antig,
          };
        }
        if (vm.selectedConcept.id == 32) {
          $scope.dataToSave.change = { status: 11 };
        }
      }
      if (vm.selectedConcept.id == 43 && $scope.endosoBy == "caratula") {
        $scope.dataToSave.change = { forma_de_pago: vm.form.payment.value };
        $scope.dataToSave.original = { forma_de_pago: vm.policy.forma_de_pago };
      }
      $scope.dataToSave.endorsement_receipt = [];
      $scope.dataToSave.status = 1;
      dataFactory
        .post("endorsement/", $scope.dataToSave)
        .then(function success(response) {
          if (helpers.isResponseOk(response.status)) {
            vm.newEndorsement = response.data;
            if ($scope.endosoBy == "caratula") {
              if ($scope.subramoCode == 1) {
                $scope.saveBeneficiarios(
                  $scope.subforms.beneficiariesList,
                  vm.newEndorsement
                );
              } else if ($scope.subramoCode == 3) {
                $scope.saveBeneficiarios(
                  $scope.subforms.relationshipList,
                  vm.newEndorsement
                );
              }
            }
            if ($scope.endosoBy == "caratula") {
              var paramsC = {
                model: 18,
                event: "POST",
                associated_id: vm.policy.id,
                identifier:
                  "creó un endoso tipo " +
                  vm.newEndorsement.endorsement_type +
                  " con concepto " +
                  $scope.concept(vm.newEndorsement.concept),
              };

              var paramsE = {
                model: 10,
                event: "POST",
                associated_id: vm.newEndorsement.id,
                identifier: "creó el endoso.",
              };
            } else {
              var paramsC = {
                model: 18,
                event: "POST",
                associated_id: vm.certificado_for_endoso.id,
                identifier:
                  "creó un endoso (certificado) tipo " +
                  vm.newEndorsement.endorsement_type +
                  " con concepto " +
                  $scope.concept(vm.newEndorsement.concept),
              };

              var paramsE = {
                model: 10,
                event: "POST",
                associated_id: vm.newEndorsement.id,
                identifier: "creó el endoso (certificado).",
              };
            }
            dataFactory.post("send-log", paramsC);
            dataFactory.post("send-log", paramsE);

            if ($scope.countFile > 0) {
              uploadFiles(vm.newEndorsement.id);
            } else {
              if ($scope.checkRegister) {
                $scope.registerEndorsement(response.data);
              } else {
                SweetAlert.swal("Hecho", MESSAGES.OK.NEWENDORSEMENT, "success");
                $state.go("endorsement.info", { endosoId: response.data.id });
              }
            }
            if (vm.selectedConcept.id == 27) {
              console.log("Reconocimiento de antiguedad");
            }
          } else {
            SweetAlert.swal(
              "Error",
              MESSAGES.ERROR.ERRORCREATEENDORSEMENT,
              "error"
            );
          }
        });
    };

    $scope.coberturas = [2, 3, 5, 19, 12, 13, 14, 21];
    $scope.asegurado = [4, 20, 8, 15, 22];

    /* Registro inicial */
    $scope.registerEndorsement = function (endoso) {
      if ($scope.endosoBy == "caratula") {
        if (vm.form.num_receipts != 0) {
          if (isNaN(vm.form.p_total)) {
            vm.form.p_total = 0;
          }
          $scope.dataToPatch = {
            p_neta: vm.form.p_neta,
            rpf: vm.form.rpf,
            derecho: vm.form.derecho,
            iva: vm.form.iva,
            p_total: vm.form.p_total,
            status: 2,
            number_endorsement: vm.form.number_endorsement,
            comision: 0,
            comision_percent: vm.policy.comision_percent,
          };
          $scope.comision_n = (
            parseFloat(vm.form.p_neta) *
            (parseFloat(vm.policy.comision_percent) / 100)
          ).toFixed(2);
          if (isNaN($scope.comision_n)) {
            $scope.dataToPatch.comision = 0;
          } else {
            $scope.dataToPatch.comision = $scope.comision_n;
          }
        } else {
          $scope.dataToPatch = {
            p_neta: 0,
            rpf: 0,
            derecho: 0,
            iva: 0,
            p_total: 0,
            status: 2,
            number_endorsement: vm.form.number_endorsement,
            comision: 0,
            comision_percent: 0,
          };
        }
      } else if ($scope.endosoBy == "certificado") {
        if (vm.form.num_receipts != 0) {
          if (isNaN(vm.form.p_total)) {
            vm.form.p_total = 0;
          }
          $scope.dataToPatch = {
            p_neta: vm.form.p_neta,
            rpf: vm.form.rpf,
            derecho: vm.form.derecho,
            iva: vm.form.iva ? parseFloat(vm.form.iva).toFixed(2) : 0,
            p_total: vm.form.p_total,
            status: 2,
            number_endorsement: vm.form.number_endorsement,
            comision: 0,
            comision_percent: $scope.subgrupoReceipts.comision_percent
              ? $scope.subgrupoReceipts.comision_percent
              : 0,
          };
          $scope.comision_n = (
            parseFloat(vm.form.p_neta) *
            (parseFloat(
              $scope.subgrupoReceipts.comision_percent
                ? $scope.subgrupoReceipts.comision_percent
                : 0
            ) /
              100)
          ).toFixed(2);
          if (isNaN($scope.comision_n)) {
            $scope.dataToPatch.comision = 0;
          } else {
            $scope.dataToPatch.comision = $scope.comision_n;
          }
        } else {
          $scope.dataToPatch = {
            p_neta: 0,
            rpf: 0,
            derecho: 0,
            iva: 0,
            p_total: 0,
            status: 2,
            number_endorsement: vm.form.number_endorsement,
            comision: 0,
            comision_percent: 0,
          };
        }
      } else if ($scope.endosoBy == "certificado") {
        if (vm.form.num_receipts != 0) {
          if (isNaN(vm.form.p_total)) {
            vm.form.p_total = 0;
          }
          $scope.dataToPatch = {
            p_neta: vm.form.p_neta,
            rpf: vm.form.rpf,
            derecho: vm.form.derecho,
            iva: vm.form.iva ? parseFloat(vm.form.iva).toFixed(2) : 0,
            p_total: vm.form.p_total,
            status: 2,
            number_endorsement: vm.form.number_endorsement,
            comision: 0,
            comision_percent: $scope.colectivityAlta.comision_percent
              ? $scope.colectivityAlta.comision_percent
              : 0,
          };
          $scope.comision_n = (
            parseFloat(vm.form.p_neta) *
            (parseFloat(
              $scope.colectivityAlta.comision_percent
                ? $scope.colectivityAlta.comision_percent
                : 0
            ) /
              100)
          ).toFixed(2);
          if (isNaN($scope.comision_n)) {
            $scope.dataToPatch.comision = 0;
          } else {
            $scope.dataToPatch.comision = $scope.comision_n;
          }
        }
      }

      /* Objeto original en la póliza*/
      if ($scope.endosoBy == "caratula") {
        if (vm.form.concept == 43) {
          $scope.dataToPatch.original = {
            forma_de_pago: vm.policy.forma_de_pago,
          };
        } else if (vm.form.concept == 32) {
          $scope.dataToPatch.original = { status: vm.policy.status };
        } else if ($scope.coberturas.indexOf(vm.form.concept) >= 0) {
          $scope.dataToPatch.original = vm.policy.coverageInPolicy_policy;
        } else if (vm.form.concept == 27) {
          $scope.dataToPatch.original = {};
          $scope.dataToPatch.original.fecha_antiguedad =
            vm.policy.rec_antiguedad;
          $scope.dataToPatch.original.certificado = $scope.certificate_to_antig;
        } else if ($scope.asegurado.indexOf(vm.form.concept) >= 0) {
          if (vm.policy.automobiles_policy.length) {
            $scope.dataToPatch.original = vm.policy.automobiles_policy;
          } else if (vm.policy.accidents_policy.length) {
            $scope.dataToPatch.original = vm.policy.accidents_policy;
          } else if (vm.policy.damages_policy.length) {
            $scope.dataToPatch.original = vm.policy.damages_policy;
          } else if (vm.policy.life_policy.length) {
            $scope.dataToPatch.original = vm.policy.life_policy;
          }
        }
        if (vm.conceptSel == 43) {
          $scope.dataToPatch.original = {
            forma_de_pago: vm.policy.forma_de_pago,
          };
        }
      }
      $scope.dataToPatch.endorsement_receipt = [];
      $http
        .patch(endoso.url, $scope.dataToPatch)
        .then(function success(response) {
          if (helpers.isResponseOk(response.status)) {
            vm.patchEndoso = response.data;
            var data = {
              id_endoso: vm.patchEndoso.id,
            };
            dataFactory
              .post("get-relation/", data)
              .then(function success(response) {
                vm.certificates = response.data;
              });
            var paramsE = {
              model: 10,
              event: "POST",
              associated_id: vm.newEndorsement.id,
              identifier: "registró el endoso.",
            };
            dataFactory.post("send-log", paramsE);

            /* Cambio de forma de pago */
            if ($scope.endosoBy == "caratula") {
              if (
                vm.conceptSel == 43 ||
                endoso.concept == 43 ||
                vm.form.concept == 43
              ) {
                var json = JSON.stringify(eval("(" + endoso.change + ")"));
                var data = JSON.parse(json);
                $http
                  .patch(vm.policy.url, data)
                  .then(function success(response) {
                    if (helpers.isResponseOk(response.status)) {
                      vm.policy.recibos_poliza.forEach(function (receipt) {
                        if (receipt.receipt_type == 1) {
                          $http.delete(receipt.url);
                        }
                      });
                      if (
                        vm.conceptSel == 43 ||
                        endoso.concept == 43 ||
                        vm.form.concept == 43
                      ) {
                        postRecibos(vm.patchEndoso, vm.policy);
                      } else if (vm.form.concept == 11) {
                        if (vm.credit_notes.length > 0) {
                          postNotas(vm.credit_notes, vm.form);
                        } else {
                          SweetAlert.swal(
                            "Notas",
                            "Deberá generar las Notas de crédito",
                            "warning"
                          );
                        }
                      }
                    }
                  });

                /* Reconocimiento de Antigüedad */
              } else if (response.data.concept == 27) {
                var json = JSON.stringify(eval("(" + endoso.change + ")"));
                var data = JSON.parse(json);
                // $scope.data.change = {fecha_antiguedad: $scope.antiguedad,certificado: $scope.certificate_to_antig}
                if ($scope.certificate_to_antig) {
                  $http
                    .patch($scope.certificate_to_antig.url, data)
                    .then(function success(response) {});
                } else {
                  $http
                    .patch(vm.policy.url, data)
                    .then(function success(response) {});
                }
                if (vm.patchEndoso.endorsement_type == "A") {
                  postRecibos(vm.patchEndoso, vm.policy);
                } else if (vm.patchEndoso.endorsement_type == "D") {
                  // postNotas(vm.credit_notes, vm.form, vm.policy, vm.patchEndoso)
                  if (vm.credit_notes.length > 0) {
                    postNotas(
                      vm.credit_notes,
                      vm.form,
                      vm.policy,
                      vm.patchEndoso
                    );
                  } else {
                    SweetAlert.swal(
                      "Notas",
                      "Deberá generar las Notas de crédito",
                      "warning"
                    );
                  }
                } else {
                  $state.go("endorsement.info", {
                    endosoId: vm.patchEndoso.id,
                  });
                }

                /* Cancelación */
              }
              if (vm.selectedConcept.id == 32) {
                var json = JSON.stringify(eval("(" + endoso.change + ")"));
                var data = JSON.parse(json);
                $http
                  .patch(vm.policy.url, data)
                  .then(function success(response) {
                    vm.policy.recibos_poliza.forEach(function (recibo) {
                      if (
                        recibo.status != 1 &&
                        recibo.status != 5 &&
                        recibo.status != 6
                      ) {
                        $http.patch(recibo.url, { status: 2 });
                      }
                    });
                    // postNotas(vm.credit_notes, vm.form, vm.policy, vm.patchEndoso)
                    if (vm.credit_notes.length > 0) {
                      postNotas(
                        vm.credit_notes,
                        vm.form,
                        vm.policy,
                        vm.patchEndoso
                      );
                    } else {
                      SweetAlert.swal(
                        "Notas",
                        "Deberá generar las Notas de crédito",
                        "warning"
                      );
                    }
                    $state.go("endorsement.info", {
                      endosoId: vm.patchEndoso.id,
                    });
                  });

                /* Cambio en las coberturas*/
              } else if ($scope.coberturas.indexOf(vm.form.concept) >= 0) {
                var None = "";
                var True = true;
                var json = JSON.stringify(
                  eval("(" + vm.patchEndoso.change + ")")
                );
                vm.coveragesToSave = JSON.parse(json);
                vm.coveragesToSave.forEach(function (cobertura) {
                  if (endoso.concept == 13) {
                    $http.delete(cobertura.url);
                  } else {
                    if (cobertura.owner) {
                      $http.patch(cobertura.url, cobertura);
                    } else {
                      cobertura.policy = vm.policy.url;
                      dataFactory.post("coberturas-polizas/", cobertura);
                    }
                  }
                  $state.go("endorsement.info", {
                    endosoId: vm.patchEndoso.id,
                  });
                });
                if (vm.patchEndoso.endorsement_type == "A") {
                  postRecibos(vm.patchEndoso, vm.policy);
                } else if (vm.patchEndoso.endorsement_type == "D") {
                  postNotas(
                    vm.credit_notes,
                    vm.form,
                    vm.policy,
                    vm.patchEndoso
                  );
                }

                /* Cambio en asegurado */
              } else if (
                ($scope.subramoCode == 1 || $scope.subramoCode == 3) &&
                $scope.typeEndoso == "A" &&
                $scope.conceptSel == 31
              ) {
                if ($scope.subramoCode == 1) {
                  $scope.saveBeneficiarios(
                    $scope.subforms.beneficiariesList,
                    vm.patchEndoso
                  );
                } else if ($scope.subramoCode == 3) {
                  $scope.saveBeneficiarios(
                    $scope.subforms.relationshipList,
                    vm.patchEndoso
                  );
                }
              } else if ($scope.asegurado.indexOf(vm.form.concept) >= 0) {
                if (endoso.concept == 4) {
                  var None = "";
                  var True = true;
                  var False = false;
                  var json = JSON.stringify(
                    eval("(" + vm.patchEndoso.change + ")")
                  );
                  if (vm.policy.accidents_policy.length) {
                    vm.newRelationship = JSON.parse(json);
                    vm.newRelationship.forEach(function (asegurado) {
                      asegurado.accident = vm.policy.accidents_policy[0].url;
                      asegurado.birthdate = new Date(
                        datesFactory.toDate(asegurado.birthdate)
                      );
                      dataFactory.post("v1/relationships/", asegurado);
                    });
                  } else if (vm.policy.life_policy.length) {
                    vm.newBeneficiaries = JSON.parse(json);
                    vm.newBeneficiaries.forEach(function (asegurado) {
                      asegurado.life = vm.policy.life_policy[0].url;
                      asegurado.birthdate = new Date(
                        datesFactory.toDate(asegurado.birthdate)
                      );
                      dataFactory.post("v1/beneficiaries/", asegurado);
                    });
                  }
                  postRecibos(vm.patchEndoso, vm.policy);
                } else if (
                  endoso.concept == 20 ||
                  endoso.concept == 8 ||
                  endoso.concept == 22
                ) {
                  var None = "";
                  var True = true;
                  var False = false;
                  var json = JSON.stringify(
                    eval("(" + vm.patchEndoso.change + ")")
                  );
                  vm.subforms = JSON.parse(json);
                  if (vm.policy.accidents_policy.length) {
                    vm.subforms.personal.birthdate = new Date(
                      datesFactory.toDate(vm.subforms.personal.birthdate)
                    );
                    vm.subforms.personal.salary = 0;
                    vm.subforms.personal.sum_assured = 0;
                    $http.patch(vm.subforms.personal.url, vm.subforms.personal);
                    vm.subforms.relationship_accident.forEach(function (
                      asegurado
                    ) {
                      asegurado.birthdate = new Date(
                        datesFactory.toDate(asegurado.birthdate)
                      );
                      $http.patch(asegurado.url, asegurado);
                    });
                  } else if (vm.policy.automobiles_policy.length) {
                    $http.patch(vm.subforms.url, vm.subforms);
                  } else if (vm.policy.damages_policy.length) {
                    $http.patch(vm.subforms.url, vm.subforms);
                  } else if (vm.policy.life_policy.length) {
                    vm.subforms.personal.birthdate = new Date(
                      datesFactory.toDate(vm.subforms.personal.birthdate)
                    );
                    vm.subforms.personal.salary = 0;
                    vm.subforms.personal.sum_assured = 0;
                    $http.patch(vm.subforms.personal.url, vm.subforms.personal);
                    vm.subforms.beneficiaries_life.forEach(function (
                      asegurado
                    ) {
                      asegurado.birthdate = new Date(
                        datesFactory.toDate(asegurado.birthdate)
                      );
                      $http.patch(asegurado.url, asegurado);
                    });
                  }

                  if (vm.patchEndoso.endorsement_type == "A") {
                    postRecibos(vm.patchEndoso, vm.policy);
                  } else if (vm.patchEndoso.endorsement_type == "D") {
                    postNotas(
                      vm.credit_notes,
                      vm.form,
                      vm.policy,
                      vm.patchEndoso
                    );
                  } else {
                    $state.go("endorsement.info", {
                      endosoId: vm.patchEndoso.id,
                    });
                  }
                } else if (endoso.concept == 15) {
                  var None = "";
                  var True = true;
                  if (vm.patchEndoso.change) {
                    var json = JSON.stringify(
                      eval("(" + vm.patchEndoso.change + ")")
                    );
                    if (vm.policy.accidents_policy) {
                      vm.toDelRelationship = JSON.parse(json);
                      vm.toDelRelationship.forEach(function (asegurado) {
                        $http.delete(asegurado.url);
                      });
                    } else if (vm.policy.life_policy) {
                      vm.toDelBeneficiarie = JSON.parse(json);
                      vm.toDelBeneficiarie.forEach(function (asegurado) {
                        $http.delete(asegurado.url);
                      });
                    }
                  }
                  postNotas(
                    vm.credit_notes,
                    vm.form,
                    vm.policy,
                    vm.patchEndoso
                  );
                }
              } else {
                if (
                  vm.patchEndoso.endorsement_type == "A" &&
                  vm.patchEndoso.concept != 43
                ) {
                  console.log("---otro recinos", vm.patchEndoso);
                  postRecibos(vm.patchEndoso, vm.policy);
                } else if (vm.patchEndoso.endorsement_type == "D") {
                  postNotas(
                    vm.credit_notes,
                    vm.form,
                    vm.policy,
                    vm.patchEndoso
                  );
                } else {
                  $state.go("endorsement.info", {
                    endosoId: vm.patchEndoso.id,
                  });
                }
              }
            } else if ($scope.endosoBy == "certificado") {
              if (vm.patchEndoso.endorsement_type == "A") {
                postRecibos(vm.patchEndoso, $scope.certificateForEndoso);
              } else if (vm.patchEndoso.endorsement_type == "D") {
                postNotas(
                  vm.credit_notes,
                  vm.form,
                  $scope.certificateForEndoso,
                  vm.patchEndoso
                );
              }
              //  else {
              //   $state.go('endorsement.info', {endosoId: vm.patchEndoso.id});
              // }
            }
          }
        });
      SweetAlert.swal("Hecho", MESSAGES.OK.APPLIEDENDORSEMENT, "success");
    };
    $scope.changeUntilE = function (note, index) {
      note.fecha_fin = new Date(datesFactory.toDate(note.endDate));
    };
    $scope.changeAntig = function (antiguedad, index) {
      $scope.antiguedad = new Date(datesFactory.toDate(antiguedad));
    };
    $scope.certif_selected_ant = function (certificate, index) {
      $scope.certificate_to_antig = {};
      $scope.certificate_to_antig.certificate_number =
        certificate.certificate_number;
      $scope.certificate_to_antig.id = certificate.id;
      $scope.certificate_to_antig.url = certificate.url;
    };
    $scope.changeSinceE = function (note, index) {
      note.fecha_inicio = new Date(datesFactory.toDate(note.initDate));
    };
    // Registrar endosos fin
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    $scope.inputDisabledCert = true;
    $scope.inputDisabled = true;
    $scope.viewCertificate = function (certificate) {
      $scope.closeCertificate();
      vm.covers = certificate;
      $scope.showCertificate = false;
      $scope.show_form_life = true;
      $scope.getChilds(vm.policy.id);
    };

    $scope.showCertificate = true;
    $scope.show_form_life = false;
    $scope.newEndoso = false;
    $scope.btnAddDisabled = false;
    $scope.fontColor = { color: "#676a6c" };

    $scope.addCertificate = function () {
      $scope.showCertificate = false;
      $scope.show_form_life = true;
      $scope.btnAddDisabled = true;
      $scope.inputDisabledCert = false;
      $scope.inputDisabled = false;
      $scope.comboboxDisabled = false;
      $scope.createCertificate();
      $scope.getPack(vm.policy.id);
      $scope.getChilds(vm.policy.id);
    };

    $scope.createCertificate = function () {
      if (vm.policy.ramo.ramo_code == 1) {
        //vida
        vm.covers = $scope.createNewCertificateLife();
      } else if (vm.policy.ramo.ramo_code == 2) {
        //accidentes y enfermedades
        vm.covers = $scope.createNewCertificateAccident();
      } else if (vm.policy.ramo.ramo_code == 3) {
        // daños
        vm.covers = $scope.createNewCertificateAuto();
      }
      $scope.newEndoso = true;
      $scope.fontColor = "blue-color";
    };

    $scope.createNewCertificateLife = function () {
      return {
        beneficiaries_life: [],
      };
    };

    $scope.createNewCertificateAccident = function () {
      return {
        relationship_accident: [],
      };
    };

    $scope.createNewCertificateAuto = function () {
      return {
        brand: "",
      };
    };

    vm.options = {
      life: {
        beneficiaries: {
          add: function (ben) {
            if (ben) {
              vm.covers.beneficiaries_life.push(ben);
            } else {
              var ben = {
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: null,
                sex: null,
                optional_relationship: "",
                percentage: "",
              };
              vm.covers.life_policy[0].beneficiaries_life.push(ben);
            }
          },
          destroy: function (index) {
            vm.covers.life_policy[0].beneficiaries_life.splice(index, 1);
          },
        },
      },
      disease: {
        relationships: {
          add: function (relacion) {
            if (relacion) {
              vm.covers.disease.relationship_accident.push(relacion);
            } else {
              var relacion = {
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: null,
                sex: null,
                relationship: null,
              };
              vm.covers.relationship_accident.push(relacion);
            }
          },
          destroy: function (index, rel) {
            vm.covers.relationship_accident.splice(index, 1);
          },
        },
      },
    };

    vm.configuration = {};

    vm.pack = [];
    $scope.getPack = function (idPolicy) {
      $http({
        method: "GET",
        url: url.IP + "caratula-pack/",
        params: {
          id: idPolicy,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              vm.pack = request.data.results;
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.checkSelected = function (val) {
      if (val == true) {
        $scope.checkRegister = true;
        vm.policy = $scope.colectivityAlta;
      } else {
        $scope.checkRegister = false;
      }
    };

    $scope.checkSelected_caratula = function (val) {
      if (val == true) {
        $scope.checkRegister = true;
      } else {
        $scope.checkRegister = false;
      }
    };

    $scope.numberReceipts = function () {
      vm.form = {};
      if (vm.selectedType.name == "A") {
        if (vm.policy.administration_type == 2) {
          vm.num_receipts_data = [{ name: 0, value: 0 }];
          vm.form.num_receipts = 0;
        } else {
          vm.num_receipts_data = [
            { name: 0, value: 0 },
            { name: 1, value: 12 },
            { name: 2, value: 6 },
            { name: 3, value: 4 },
            { name: 4, value: 3 },
            { name: 5, value: 5.5 },
            { name: 6, value: 2 },
            { name: 7, value: 7 },
            { name: 8, value: 8 },
            { name: 9, value: 9 },
            { name: 10, value: 10 },
            { name: 11, value: 11 },
            { name: 12, value: 1 },
          ];
        }
      } else if (vm.selectedType.name == "D") {
        if (vm.policy.administration_type == 2) {
          vm.num_notes_data = [{ name: 0, value: 0 }];
          vm.form.num_notas = 0;
        } else {
          vm.num_notes_data = [
            { name: 0, value: 0 },
            { name: 1, value: 1 },
            { name: 2, value: 2 },
            { name: 3, value: 3 },
            { name: 4, value: 4 },
            { name: 5, value: 5 },
            { name: 6, value: 6 },
            { name: 7, value: 7 },
            { name: 8, value: 8 },
            { name: 9, value: 9 },
            { name: 10, value: 10 },
            { name: 11, value: 11 },
            { name: 12, value: 12 },
          ];
        }
      }
    };

    $scope.getChilds = function (idPolicy) {
      $http({
        method: "GET",
        url: url.IP + "caratula-childs/" + idPolicy + "/",
      }).then(function success(request) {
        if (request.status === 200) {
          var results = request.data;
          $scope.subgroups = [];
          $scope.categories = [];
          if (results.length) {
            results.forEach(function (child) {
              if (child.document_type == 4) {
                $scope.subgroups.push(child);
                child.categories = [];
              } else if (child.document_type == 5) {
                $scope.categories.push(child);
              }
            });
            // vm.configuration.group = $scope.subgroups
            if ($scope.categories.length == 0) {
              $scope.noCategories = true;
            }
            $scope.subgroups.forEach(function (group) {
              $scope.categories.forEach(function (category) {
                if (group.url == category.parent) {
                  group.categories.push(category);
                }
              });
            });
          }
        }
      });
    };

    $scope.comboboxDisabled = false;
    $scope.selectGroup = function (obj) {
      if (obj != null) {
        if (obj.name == "Default") {
          $scope.comboboxDisabled = true;
        } else {
          $scope.comboboxDisabled = false;
        }
        $scope.group_selected = obj;
        vm.configuration.group = obj;
      }
    };

    $scope.arrayCertificates = [];
    $scope.closeCertificate = function () {
      vm.covers = [];
      $scope.showCertificate = true;
      $scope.show_form_life = false;
      $scope.newEndoso = false;
      $scope.fontColor = { color: "#676a6c" };
      $scope.btnAddDisabled = false;
      $scope.inputDisabledCert = true;
      $scope.inputDisabled = true;
      $scope.comboboxDisabled = true;
    };

    $scope.arrayCertificates = [];
    vm.certificates = [];
    $scope.saveCertificate = function (certificate) {
      /*console.log(certificate);
      console.log(vm.configuration);
      if(certificate.brand){
        certificate.caratula = vm.policy.id;
        certificate.subgrupo = vm.configuration.group.id;
        certificate.category = vm.configuration.group.categories[0].id;
        certificate.pack = vm.configuration[0].pack.id;
        certificate.automobile = certificate;
      }
      else{
        certificate.caratula = vm.policy.id;
        certificate.subgrupo = vm.configuration.group.id;
        certificate.category = vm.configuration.group.categories[0].id;
        certificate.pack = vm.configuration.pack.id;
      }*/

      //$scope.arrayCertificates.push(certificate);
      $scope.arrayCertificates = certificate;
      //console.log($scope.arrayCertificates);
      certificate.status = "PENDIENTE";
      vm.certificates.push(certificate);
      $scope.closeCertificate();
    };

    $scope.editCertificate = function (certificate) {
      $scope.arrayCertificates = certificate;
      $scope.closeCertificate();
    };

    $scope.arrayCertificateSave = [];
    $scope.saveEndosoA = function () {
      var obj = {};
      if ($scope.arrayCertificates.beneficiaries_life) {
        obj.caratula = vm.policy.id;
        obj.subgrupo = vm.configuration.group.id;
        obj.category = vm.configuration.group.categories[0].id;
        obj.pack = vm.configuration.pack.id;
        obj.titular = $scope.arrayCertificates.personal;
        obj.beneficiaries = $scope.arrayCertificates.beneficiaries_life;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      } else if ($scope.arrayCertificates.relationship_accident) {
        obj.caratula = vm.policy.id;
        obj.subgrupo = vm.configuration.group.id;
        obj.category = vm.configuration.group.categories[0].id;
        obj.pack = vm.configuration.pack.id;
        obj.titular = $scope.arrayCertificates.personal;
        obj.relationships = $scope.arrayCertificates.relationship_accident;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      } else if ($scope.arrayCertificates.brand) {
        obj.caratula = vm.policy.id;
        obj.subgrupo = vm.configuration.group.id;
        obj.category = vm.configuration.group.categories[0].id;
        obj.pack = vm.configuration.pack.id;
        obj.automobile = $scope.arrayCertificates;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      }
      $scope.arrayCertificateSave.push(obj);

      var data = {
        certificados: $scope.arrayCertificateSave,
      };
      $http
        .post(url.IP + "added-certs/", data)
        .then(
          function success(request) {
            if (request.status === 200) {
              $scope.closeCertificate();
              toaster.success("Certificado Creado Exitosamente");
              $state.go("endorsement.lista");
            } else {
              SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROR, "error");
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.showInputDisabled = function () {
      $scope.inputDisabled = false;
      $scope.comboboxDisabled = false;
      $scope.newEndoso = true;
      $scope.fontColor = "blue-color";
      $scope.getPack(vm.policy.id);
      $scope.getChilds(vm.policy.id);
    };

    $scope.arrayCertificateEdit = [];
    $scope.saveEndosoB = function () {
      var obj = {};
      if ($scope.arrayCertificates.beneficiaries_life) {
        obj.caratula = vm.policy.id;
        obj.titular = $scope.arrayCertificates.personal;
        obj.beneficiaries = $scope.arrayCertificates.beneficiaries_life;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      } else if ($scope.arrayCertificates.relationship_accident) {
        obj.caratula = vm.policy.id;
        obj.titular = $scope.arrayCertificates.personal;
        obj.relationships = $scope.arrayCertificates.relationship_accident;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      } else if ($scope.arrayCertificates.brand) {
        obj.caratula = vm.policy.id;
        obj.automobile = $scope.arrayCertificates;
        obj.certificate_number = $scope.arrayCertificates.certificate_number;
      }
      $scope.arrayCertificateEdit.push(obj);

      var data = {
        certificados: $scope.arrayCertificateEdit,
      };

      $http({
        method: "POST",
        url: url.IP + "edited-certs/",
        data: data,
      })
        .then(
          function success(request) {
            //console.log(request);
            if (request.status === 200) {
              $scope.arrayCertificates = [];
              $scope.arrayCertificateSave = [];
              $scope.arrayCertificateEdit = [];
              $scope.arrayCertificateDelete = [];
              $scope.closeCertificate();
              toaster.success("Certificado se Actualizó");
              $state.go("endorsement.lista");
            }
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    var selectedCertificate = [];
    var certificate = [];

    $scope.checkCertificate = function (id) {
      var idx = selectedCertificate.indexOf(id);
      if (idx == -1) {
        selectedCertificate.push(id);
        var obj = {
          id: id,
        };
        certificate.push(obj);
      } else {
        var idx = selectedCertificate.indexOf(id);
        selectedCertificate.splice(idx, 1);
        certificate.splice(idx, 1);
      }
    };

    $scope.checkDelete = function (id) {
      return selectedCertificate.indexOf(id) > -1;
    };

    $scope.saveEndosoD = function () {
      deleteCertificate();
    };

    $scope.concept = function (parConcept) {
      switch (parConcept) {
        case 24:
          return "ALTA DE CERTIFICADOS";
          break;
        case 26:
          return "AJUSTE ANUAL A";
          break;
        case 30:
          return "DECLARACIÓN";
          break;
        case 31:
          return "AGREGAR DEPENDIENTE/BENEFICIARIO";
          break;
        case 41:
          return "ALTA DE UNIDAD";
          break;
        case 42:
          return "AGREGAR COBERTURA";
          break;
        case 43:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 44:
          return "AGREGAR CARGA";
          break;
        case 45:
          return "AGREGAR ADAPTACIONES Y CONVERSIONES";
          break;
        case 24:
          return "ALTA DE CERTIFICADOS";
          break;
        case 25:
          return "BAJA DE CERTIFICADOS";
          break;
        case 27:
          return "RECONOCIMIENTO DE ANTIGÜEDAD";
          break;
        case 46:
          return "INCLUIR BP";
          break;
        case 47:
          return "CORREGIR DESCRIPCIÓN";
          break;
        case 48:
          return "AGREGAR TEXTOS ACLARATORIOS";
          break;
        case 49:
          return "ADAPTACIONES SOLO PARA EFECTOS DE RC";
          break;
        case 50:
          return "AGREGAR PLACAS, MOTOR O CORREGIR SERIE";
          break;
        case 25:
          return "BAJA DE CERTIFICADOS";
          break;
        case 26:
          return "AJUSTE ANUAL D";
          break;
        case 30:
          return "DECLARACIÓN";
          break;
        case 32:
          return "CANCELACIÓN";
          break;
        case 51:
          return "CANCELACIONES";
          break;
        case 52:
          return "ELIMINACIÓN DE COBERTURAS";
          break;
        default:
          return "OTRO";
      }
    };

    vm.deleteCertificate = deleteCertificate;
    function deleteCertificate() {
      $scope.arrayCertificateDelete = [];
      var obj = {};
      obj.certificados = certificate;
      obj.caratula = vm.collect.id;
      $scope.arrayCertificateDelete.push(obj);
      var data = {
        certificados: $scope.arrayCertificateDelete,
      };
      $http({
        method: "POST",
        url: url.IP + "deleted-certs/",
        data: data,
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              toaster.success("Se ha creado el endoso");
            } else {
              SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROR, "error");
            }
            $state.go("endorsement.lista");
          },
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    }

    $scope.arrayPolicy = {};
    $scope.deletePoliza = function () {
      $scope.arrayPolicy.delete_Poliza = true;
      $scope.arrayPolicy.id = vm.policy.id;
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWENDORSEMENT, "success");
        if ($scope.endorsementLoad.policy_type == 1) {
          $state.go("endorsement.info", {
            endosoId: $scope.endorsementLoad.id,
          });
        } else if ($scope.endorsementLoad.policy_type == 2) {
          if ($scope.endorsementLoad.endorsement_type == "D") {
            if ($scope.endorsementLoad.policy.subramo == 1) var type = "life";
            else if ($scope.endorsementLoad.policy.subramo == 3)
              var type = "disease";
            else var type = "automobile";
          }
          $state.go("endorsement.info", {
            endosoId: $scope.endorsementLoad.id,
          });
        }
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(endorsementId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "endosos/" + endorsementId + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
      $state.go("endorsement.info", { endosoId: endorsementId });
    }

    /*--------------*/
    /* Configuracion del datepicker */
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("WhatsappConfigController", WhatsappConfigController);

  WhatsappConfigController.$inject = [
    "$localStorage",
    "emailService",
    "url",
    "dataFactory",
    "toaster",
    "$sessionStorage",
    "$http",
    "$rootScope",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "providerService",
  ];

  function WhatsappConfigController(
    $localStorage,
    emailService,
    url,
    dataFactory,
    toaster,
    $sessionStorage,
    $http,
    $rootScope,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    providerService
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    vm.org_name = usr.urlname;
    /* Variables */
    vm.flagEmail = false;
    vm.flagEmailCumple = false;
    vm.reminder = false;
    vm.reminder_edith = false;
    vm.rec = false;
    vm.ren = false;
    $scope.change_filter = true;
    $scope.reminders_payments = [];
    $scope.contacto_dudas = "";

    /* Funciones */
    vm.saveConfig = saveConfig;
    vm.saveEmail = saveEmail;
    vm.sendEmail = sendEmail;
    vm.selectModel = selectModel;
    vm.edithReminder = edithReminder;
    vm.deleteReminder = deleteReminder;
    vm.addReminder = addReminder;
    vm.saveEmailR = saveEmailR;
    vm.saveEmailBirth = saveEmailBirth;
    vm.edithMailBirth = edithMailBirth;
    vm.sendEmailRPol = sendEmailRPol;
    vm.sendEmail_Data = sendEmail_Data;
    vm.sendEmailRWhatsapp = sendEmailRWhatsapp;
    vm.changeRamo = changeRamo;
    vm.changeTipo = changeTipo;
    vm.changeFrecuency = changeFrecuency;
    vm.saveContacto = saveContacto;
    activate();

    function activate_underground() {
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          vm.form = response.data.results[0];
        }
      });
    }
    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          dataFactory.get("subramos-by-ramo/" + vm.id).then(function (data) {
            vm.subramos_toselected = data.data;
          });
        }
      }
    };

    function changeFrecuency() {
      $scope.change_filter = false;
    }

    function changeRamo(obj) {
      $scope.change_filter = false;
      if (!obj) {
        vm.form.ramo = "";
        return;
      }
      try {
        vm.subramos = obj.subramo_ramo;
      } catch (e) {}
    }

    function changeTipo(obj) {
      $scope.change_filter = false;
      if (!obj) {
        vm.form.tipo = "";
        return;
      }
    }

    function activate() {
      $(".js-example-basic-multiple").select2();
      getSubramos();
      getProviders();
      if (!$localStorage.email_config) {
        dataFactory.get("orginfo/").then(function success(response) {
          if (response.data.results.length) {
            vm.form = response.data.results[0];
            $scope.contacto_dudas = vm.form.contacto_dudas;
          }
        });
      } else {
        vm.form = $localStorage.email_config;
        $scope.contacto_dudas = vm.form.contacto_dudas;
      }
    }
    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(parseInt(sr.subramo_code));
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(parseInt(cl.id));
      });
    };
    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        vm.providers = data.data;
      });
    }
    function saveContacto(dato) {
      if (vm.form && vm.form.url) {
        $http
          .patch(vm.form.url, { contacto_dudas: dato })
          .then(function success(response) {
            if (response.status == 200) {
              $localStorage.email_config = response.data;
              SweetAlert.swal(
                "Actualizado",
                "Dato Actualizado a: " + dato,
                "success"
              );
              vm.flagEmail = false;
              return;
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
              activate_underground();
            } else {
              SweetAlert.swal("Error", "Error revise la información", "error");
              activate_underground();
            }
          });
      } else {
        dataFactory
          .post("orginfo/", { contacto_dudas: dato })
          .then(function success(response) {
            if (response.status == 201) {
              $scope.contacto_dudas = response.data.contacto_dudas;
              SweetAlert.swal("Guardado", "Listo", "success");
              vm.flagEmail = false;
              return;
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
              activate_underground();
            } else {
              SweetAlert.swal(
                "Error",
                "Ha ocurrido un error, válide la información",
                "error"
              );
              activate_underground();
            }
          });
        // SweetAlert.swal("Error", "Guarde una configuración en correos automáticos, para agregar el Dato", "error");
      }
    }
    function saveConfig() {
      if (vm.form) {
        // Asegurar que activar_contacto_dudas exista aunque sea false
        if (
          vm.form.activar_contacto_dudas === undefined ||
          vm.form.activar_contacto_dudas === null
        ) {
          vm.form.activar_contacto_dudas = false;
        }

        if (vm.form.url) {
          $http.patch(vm.form.url, vm.form).then(function success(response) {
            if (response.status == 200) {
              $scope.contacto_dudas = response.data.contacto_dudas;
              SweetAlert.swal(
                "Actualizado",
                "Configuración SMS guardada correctamente",
                "success"
              );
              vm.flagEmail = false;
              return;
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
              activate_underground();
            } else {
              SweetAlert.swal("Error", "Error revise la información", "error");
              activate_underground();
            }
          });
        } else {
          dataFactory
            .post("orginfo/", vm.form)
            .then(function success(response) {
              if (response.status == 201) {
                $scope.contacto_dudas = response.data.contacto_dudas;
                SweetAlert.swal(
                  "Guardado",
                  "Configuración creada correctamente",
                  "success"
                );
                vm.flagEmail = false;
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
                activate_underground();
              } else {
                SweetAlert.swal(
                  "Error",
                  "Ha ocurrido un error, valide la información",
                  "error"
                );
                activate_underground();
              }
            });
        }
      }
    }

    function saveEmail(email) {
      // if(!vm.email.text){
      //     SweetAlert.swal("Completa los datos", 'Información incompleta', "error");
      //     return
      // }
      if (vm.email.url) {
        if (
          vm.email.text == undefined ||
          vm.email.text == null ||
          vm.email.text == ""
        ) {
          vm.email.text = "";
        } else {
          vm.email.text;
        }
        $http
          .patch(vm.email.url + "?model=" + vm.model + "&", vm.email)
          .then(function success(response) {
            if (response.status == 200) {
              SweetAlert.swal(
                "Actualizado",
                "Se ha actualizado el registro",
                "success"
              );
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
              vm.flagEmail = false;
              vm.reminder = false;
            } else {
              SweetAlert.swal("Error", "Ha ocurrido un error", "error");
            }
            vm.flagEmail = false;
          });
        vm.email = {};
      } else {
        vm.email.model = vm.model;
        dataFactory
          .post("emailinfo/", vm.email)
          .then(function success(response) {
            if (response.status == 201) {
              SweetAlert.swal(
                "Guardado",
                "Seha guardado el registro",
                "success"
              );
              vm.flagEmail = false;
              vm.reminder = false;
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
              vm.flagEmail = false;
              vm.reminder = false;
            } else {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            }
          });
        vm.email = {};
      }
    }

    function saveEmailR(email, text, model, f) {
      if (model != 10) {
        if (
          !email.text ||
          model == undefined ||
          email.frequency == undefined ||
          !email.tipo_fecha ||
          (model == 5 && email.tipo_cobro == undefined)
        ) {
          SweetAlert.swal(
            "Completa los datos",
            "Información incompleta",
            "error"
          );
          return;
        }
      } else {
        if (!email.text || model == undefined || email.frequency == undefined) {
          SweetAlert.swal(
            "Completa los datos",
            "Información incompleta Recordatorio renovación",
            "error"
          );
          return;
        }
        // select_sramo
        // select_provider
      }
      vm.email.frequency = email.frequency;
      vm.email.type_policy = vm.email.tipo ? parseInt(vm.email.tipo) : 0;
      vm.email.ramo_code = email.ramo ? parseInt(email.ramo) : 0;
      if (vm.email.url) {
        if (model != 10) {
          if (vm.rec || vm.recsms) {
            vm.email.aseguradoras = vm.providers_selected;
          }
          $http
            .patch(vm.email.url + "?model=" + vm.model + "&", vm.email)
            .then(function success(response) {
              if (response.status == 200) {
                SweetAlert.swal(
                  "Actualizado",
                  "Se ha actualizado el registro",
                  "success"
                );
                vm.flagEmail = false;
                vm.reminder = false;
                $scope.change_filter = true;
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          //Renovación
          vm.email.aseguradoras = vm.providers_selected;
          vm.email.subramos = vm.subramos_selected;
          vm.email.tipo_fecha = 1;
          $http
            .patch(vm.email.url + "?model=" + vm.model + "&", vm.email)
            .then(function success(response) {
              if (response.status == 200) {
                SweetAlert.swal(
                  "Actualizado",
                  "Se ha actualizado el registro",
                  "success"
                );
                vm.flagEmail = false;
                vm.reminder = false;
                $scope.change_filter = true;
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
        vm.email = {};
      } else {
        vm.email.model = vm.model;
        if (model != 10) {
          if (
            !email.text ||
            model == undefined ||
            email.frequency == undefined ||
            !email.tipo_fecha ||
            (model == 5 && email.tipo_cobro == undefined)
          ) {
            SweetAlert.swal(
              "Completa los datos",
              "Información incompleta",
              "error"
            );
            return;
          }
        } else {
          if (
            !email.text ||
            model == undefined ||
            email.frequency == undefined
          ) {
            SweetAlert.swal(
              "Completa los datos",
              "Información incompleta Recordatorio renovación*",
              "error"
            );
            return;
          }
          // select_sramo
          // select_provider
        }
        if (model != 10) {
          if (vm.rec || model == 5) {
            vm.email.aseguradoras = vm.providers_selected;
          }
          dataFactory
            .post("emailinforeminder/", vm.email)
            .then(function success(response) {
              if (response.status == 201) {
                SweetAlert.swal("Guardado", "Listo", "success");
                vm.flagEmail = false;
                vm.reminder = false;
                vm.reminder_edith = false;
                $scope.frecuencia_ = null;
                vm.frecuencia = {};
                vm.frecuencia.id = null;
                vm.form.ramo = null;
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
              vm.flagEmail = false;
            });
        } else {
          //Renovación
          vm.email.aseguradoras = vm.providers_selected;
          vm.email.subramos = vm.subramos_selected;
          vm.email.tipo_fecha = 1;
          // return;
          dataFactory
            .post("emailinforeminder/", vm.email)
            .then(function success(response) {
              if (response.status == 201) {
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDEMAIL, "success");
                vm.flagEmail = false;
                vm.reminder = false;
                vm.reminder_edith = false;
                $scope.frecuencia_ = null;
                vm.frecuencia = {};
                vm.frecuencia.id = null;
                vm.form.ramo = null;
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
              vm.flagEmail = false;
            });
        }
        vm.email = {};
      }
    }

    function saveEmailBirth(email) {
      if (!email || !email.text || !email.subject) {
        SweetAlert.swal(
          "Completa los datos",
          "Información incompleta",
          "error"
        );
        return;
      }
      dataFactory
        .post("birthdate-template/", email)
        .then(function success(response) {
          if (response.status == 201) {
            SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDEMAIL, "success");
            vm.flagEmailCumple = false;
          } else if (response.status == 403) {
            SweetAlert.swal("Error", response.data.detail, "error");
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
          }
        });
    }

    function edithMailBirth(show) {
      if (show) {
        vm.flagEmailCumple = true;
        dataFactory.get("birthdate-template/").then(function success(response) {
          if (response.status == 200) {
            vm.emailCumple = response.data.results[0];
          }
        });
      } else {
        vm.flagEmailCumple = false;
      }
    }

    $scope.plantillasWhatsapp = [
      {
        id: 1,
        mensaje:
          "Estimado Asegurado, su recibo esta cercano a vencer, le recordamos realizar su pago para que no quede sin cobertura, quedamos a sus ordenes para cualquier duda",
      },
      {
        id: 2,
        mensaje:
          "Estimado asegurado, es un placer saludarle, el motivo de este mensaje es para informarle que su recibo está próximo a vencer. Quedamos disponibles para cualquier duda o aclaración al respecto.",
      },
      {
        id: 3,
        mensaje:
          "Estimado Asegurado le informamos que su recibo ha vencido el día de hoy, contacte a su ejecutivo para que le aclare dudas sobre como realizar el pago",
      },
      {
        id: 4,
        mensaje:
          "Estimado asegurado, es un placer saludarle de parte de " +
          vm.org_name.toUpperCase() +
          ", le recordamos que su recibo está próximo a vencer.",
      },
      {
        id: 5,
        mensaje:
          "Estimado(a) Asegurado, le recordamos que su recibo está próximo a vencer, quedamos al pendiente para cualquier duda o aclaración al respecto.",
      },
      {
        id: 6,
        mensaje:
          "Estimado Asegurado, le recodamos que su recibo esta por vencer, si tiene dudas referente a su pago, puede contactar a su ejecutivo",
      },
      {
        id: 7,
        mensaje:
          "Estimado Asegurado, su recibo esta cercano a vencer, le recordamos realizar su pago para que no quede sin cobertura, quedamos a sus ordenes para cualquier duda",
      },
    ];
    //obtener plantillas de SMS
    dataFactory.get("smstemplate-unpag/").then(function success(response) {
      $scope.plantillaSMS = response.data;
    });
    vm.frecuencias = [
      { id: 1, value: 1, name: "Vigencia de 30 días" },
      { id: 2, value: 2, name: "Vigencia de 15 días" },
      { id: 3, value: 3, name: "Vigencia de 5 días" },
      { id: 4, value: 4, name: "Vencido" },
    ];

    $scope.frecuencies_dict = {
      1: "-30 DIAS ANTES DEL",
      2: "-15 DIAS ANTES DEL",
      3: "-5 DIAS ANTES DEL",
      4: "Vencido",
      5: "+5 DIAS POSTERIORES A",
      6: "+10 DIAS POSTERIORES A",
      7: "+15 DIAS POSTERIORES A",
      8: "-10 DIAS ANTES DEL",
      9: "-20 DIAS ANTES DEL",
      10: "+20 DIAS POSTERIORES A",
    };
    $scope.frecuencies_ren = {
      1: "30 días antes de Fecha Fin",
      2: "15 días antes de Fecha Fin",
      3: "10 días antes de Fecha Fin",
      4: "5 días antes de Fecha Fin",
      8: "Vencidas",
    };
    $scope.ramos = {
      0: "Todos los ramos",
      1: "Vida",
      2: "Accidentes y Enfermedades",
      3: "Daños",
    };
    $scope.tipos = {
      0: "Todos los tipos",
      1: "Poliza",
      2: "Colectividad",
    };
    $scope.tipos_ren = {
      0: "Todos los tipos",
      1: "Poliza",
      2: "Póliza Ind de Colectividad",
      3: "Póliza Grupo",
    };
    $scope.tipos_recsms = {
      0: "Póliza/Endoso",
      1: "Poliza",
      2: "Endoso",
    };
    $scope.tipos_message = {
      0: "Whatsapp/SMS",
      1: "Whatsapp",
      2: "SMS",
    };

    $scope.cobro = {
      0: "No Domiciliado",
      1: "Domiciliado y Otros",
      2: "Todos",
      3: "Domiciliado",
      4: "No domiciliado y Agente",
    };
    $scope.fechas = {
      1: "Inicio de Vigencia",
      2: "Vencimiento",
    };
    $scope.aseguradoras = [];
    $scope.aseguradoras_dict = {
      null: "Todas",
    };

    function selectModel(param, frequency) {
      vm.email = {};
      vm.flagEmail = true;
      if (param == 5 || param == 10 || param == 15) {
        vm.flagEmail = false;
        vm.reminder = true;
        $scope.aseguradoras = [];
        var d = new Date();
        var curr_date = d.getDate();
        var curr_month = d.getMonth() + 1; //Months are zero based
        var curr_year = d.getFullYear();
        var date = curr_year + "-" + curr_month + "-" + curr_date;
        providerService.getProviderByKey(date).then(function (provider) {
          $scope.providers = provider.data;
          for (i in $scope.providers) {
            $scope.aseguradoras.push({
              id: $scope.providers[i].url,
              value: $scope.providers[i].alias,
            });
            $scope.aseguradoras_dict[$scope.providers[i].url] =
              $scope.providers[i].alias;
          }
        });
      }
      var params = {
        model: param,
      };
      vm.email = {};
      if (frequency) {
        var freq = frequency.value;
      }
      switch (param) {
        case 1:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Solicitud de orden de trabajo";
          vm.model = param;
          break;
        case 2:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Registro de orden de trabajo (Póliza y Endoso)";
          vm.model = param;
          break;
        case 3:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Solicitud de siniestro";
          vm.model = param;
          break;
        case 4:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Finalización de siniestro";
          vm.model = param;
          break;
        case 5:
          vm.rec = true;
          vm.ren = false;
          vm.recsms = false;
          vm.reminder_edith = false;
          dataFactory
            .get("emailinforeminder/", params)
            // dataFactory.get('emailinfo/', params)
            .then(function success(response) {
              if (response.data.results.length) {
                $scope.reminders_payments = response.data.results;
                $scope.aseguradorasRec = [];
                $scope.reminders_payments.forEach(function (i) {
                  i.aseguradorasRec = [];
                  vm.providers.forEach(function (pr) {
                    i.aseguradoras.forEach(function (ra) {
                      if (pr.id == ra) {
                        $scope.aseguradorasRec.push({
                          alias: pr.alias,
                          id: pr.id,
                        });
                        i.aseguradorasRec.push({ alias: pr.alias, id: pr.id });
                      }
                    });
                  });
                });
              }
            });
          vm.title = "Recordatorio de pago";
          vm.model = param;
          break;
        case 6:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Aviso de pago realizado";
          vm.model = param;
          break;
        case 7:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Creación de nota de crédito";
          vm.model = param;
          break;
        case 8:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Al aplicar una nota de crédito";
          vm.model = param;
          break;
        case 9:
          // TODO: Consideraciones especiales, varios formatos
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Al renovar la póliza";
          vm.model = param;
          break;
        case 10:
          // TODO: Consideraciones especiales, varios formatos
          vm.reminder_edith = false;
          vm.ren = true;
          vm.rec = false;
          vm.recsms = false;
          dataFactory
            .get("emailinforeminder/", params)
            // dataFactory.get('emailinfo/', params)
            .then(function success(response) {
              if (response.data.results.length) {
                $scope.aseguradorasRen = [];
                $scope.subramosRen = [];
                $scope.reminders_payments = response.data.results;
                $scope.reminders_payments.forEach(function (i) {
                  i.subramosRen = [];
                  i.aseguradorasRen = [];
                  vm.subramos_toselected.forEach(function (b) {
                    i.subramos.forEach(function (rs) {
                      if (b.subramo_code == rs) {
                        $scope.subramosRen.push({
                          subramo_name: b.subramo_name,
                          subramo_code: b.subramo_code,
                        });
                        i.subramosRen.push({
                          subramo_name: b.subramo_name,
                          subramo_code: b.subramo_code,
                        });
                      }
                    });
                  });
                  vm.providers.forEach(function (pr) {
                    i.aseguradoras.forEach(function (ra) {
                      if (pr.id == ra) {
                        $scope.aseguradorasRen.push({
                          alias: pr.alias,
                          id: pr.id,
                        });
                        i.aseguradorasRen.push({ alias: pr.alias, id: pr.id });
                      }
                    });
                  });
                });
              }
            });
          vm.title = "Recordatorio de renovación";
          vm.model = param;
          break;
        case 11:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Trámite de siniestro";
          vm.model = param;
          break;
        case 12:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Cancelación de siniestro";
          vm.model = param;
          break;
        case 13:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Rechazo de siniestro";
          vm.model = param;
          break;
        case 14:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Espera de siniestro";
          vm.model = param;
          break;
        case 15:
          vm.rec = false;
          vm.recsms = true;
          vm.ren = false;
          vm.reminder_edith = false;
          dataFactory
            .get("emailinforeminder/", params)
            // dataFactory.get('emailinfo/', params)
            .then(function success(response) {
              if (response.data.results.length) {
                $scope.reminders_payments = response.data.results;
                $scope.aseguradorasRecWhatsapp = [];
                $scope.reminders_payments.forEach(function (i) {
                  i.aseguradorasRecWhatsapp = [];
                  vm.providers.forEach(function (pr) {
                    i.aseguradoras.forEach(function (ra) {
                      if (pr.id == ra) {
                        $scope.aseguradorasRecWhatsapp.push({
                          alias: pr.alias,
                          id: pr.id,
                        });
                        i.aseguradorasRecWhatsapp.push({
                          alias: pr.alias,
                          id: pr.id,
                        });
                      }
                    });
                  });
                });
              }
            });
          vm.title = "Recordatorio de pago Vía Whatsapp/SMS";
          vm.model = param;
          break;
      }
    }
    function edithReminder(reminder) {
      vm.subramos_selected = [];
      vm.providers_selected = [];
      $scope.select_sramo = [];
      $scope.select_provider = [];
      $scope.aseguradoras = [];
      var d = new Date();
      var curr_date = d.getDate();
      var curr_month = d.getMonth() + 1; //Months are zero based
      var curr_year = d.getFullYear();
      var date = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(date).then(function (provider) {
        $scope.providers = provider.data;
        for (i in $scope.providers) {
          $scope.aseguradoras.push({
            id: $scope.providers[i].url,
            value: $scope.providers[i].alias,
          });
          $scope.aseguradoras_dict[$scope.providers[i].url] =
            $scope.providers[i].alias;
        }
      });
      if (reminder.subramos || reminder.aseguradoras) {
        vm.subramos_toselected.forEach(function (b) {
          reminder.subramos.forEach(function (rs) {
            if (b.subramo_code == rs) {
              $scope.select_sramo.push(b);
              vm.subramos_selected.push(parseInt(b.subramo_code));
            }
          });
        });
        vm.providers.forEach(function (pr) {
          reminder.aseguradoras.forEach(function (ra) {
            if (pr.id == ra) {
              $scope.select_provider.push(pr);
              $scope.selectProv($scope.select_provider);
              vm.providers_selected.push(parseInt(pr.id));
            }
          });
        });
      }
      vm.reminder_edith = true;
      vm.email = reminder;
      //$scope.frecuencia_ = reminder.frequency;
      vm.frecuencia = {};
      vm.frecuencia.id = reminder.frequency;
      vm.email.ramo = reminder.ramo_code.toString();
      vm.email.tipo_cobro = reminder.tipo_cobro.toString();
      vm.email.tipo_fecha = reminder.tipo_fecha.toString();
      vm.email.tipo = reminder.type_policy.toString();
      vm.email.frequency = reminder.frequency.toString();
    }
    function addReminder(reminder) {
      $(".js-example-basic-multiple").select2();
      vm.reminder_edith = true;
      vm.email = reminder ? reminder : {};
      // vm.email.type_message = 0
      vm.email.type_message = 2;
      vm.email.receipt_type = 0;
      $scope.frecuencia_ = null;
      vm.frecuencia = {};
      vm.form = vm.form ? vm.form : {};
      vm.frecuencia.id = null;
      vm.form.ramo = null;
      $scope.select_provider = [];
    }
    $scope.changePlantillaSMS = function (item) {
      console.log("itee", item);
      if (item) {
        vm.email.text = item.text;
        $scope.custom_email = true;
      } else {
        vm.email.text = "";
        $scope.custom_email = false;
      }
    };
    $scope.changePlantillaWha = function (item) {
      if (item) {
        if (item.mensaje.includes("\n")) {
          item.mensaje = item.mensaje.replace("\n", "<br><br>");
        }
        vm.email.text = item.mensaje;
        $scope.custom_email = true;
      } else {
        vm.messageEmail = "";
        $scope.custom_email = false;
      }
    };
    $scope.tipoMensaje = function (typ) {
      if (typ == 1) {
        vm.email.text = $scope.plantillasWhatsapp[0].mensaje;
        $scope.plantilla = $scope.plantillasWhatsapp[0];
      }
      if (typ == 2 && $scope.plantillaSMS && $scope.plantillaSMS.length) {
        vm.email.text = $scope.plantillaSMS[0].text;
        $scope.plantilla = $scope.plantillaSMS[0];
      }
    };
    function deleteReminder(reminder) {
      var params = {
        model: reminder.model,
      };
      SweetAlert.swal(
        {
          title: "Advertencia",
          text: "Se eliminará la configuración con el ID: " + reminder.id,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(reminder.url).then(function success(response) {
              dataFactory
                .get("emailinforeminder/", params)
                .then(function success(response) {
                  if (response.data.results.length) {
                    $scope.reminders_payments = response.data.results;
                  }
                });
            });
          }
        }
      );
    }
    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function sendEmail(email, txt, model) {
      emailService.sendEmail(model, 1, email).then(function (response) {
        toaster.success(MESSAGES.OK.EMAILSENDED);
      });
    }

    function sendEmail_Data(subject, text, model) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/emails/email_data_modal.html",
        controller: ModalInstanceCtrlEmailData,
        resolve: {
          vm: function () {
            return vm;
          },
          model: function () {
            return model;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 6,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }
    function ModalInstanceCtrlEmailData(
      $scope,
      $uibModal,
      status,
      $uibModalInstance,
      vm,
      model
    ) {
      $scope.ok = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if ($scope.email || $scope.email == undefined) {
          if (!validateEmail($scope.email)) {
            l.stop();
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.INVALIDEMAILCONTACT,
              "error"
            );
            return;
          }
        }

        emailService.sendEmail(model, $scope.email);
        l.stop();
        $uibModalInstance.dismiss("cancel");
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
        l.stop();
        return;
      };
    }

    function sendEmailRWhatsapp(email, txt, model, freq, ramo) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (freq == undefined || !email) {
        l.stop();
        SweetAlert.swal(
          "Advertencia",
          MESSAGES.WARNING.NOSAVEDEMAIL,
          "warning"
        );
        return;
      }
      var response = emailService.sendEmailRWhatsapp(
        model,
        freq,
        ramo,
        email.id
      );

      l.stop();
    }

    function sendEmailRPol(
      email,
      txt,
      model,
      freq,
      tipo,
      subramos,
      aseguradoras
    ) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (freq == undefined || model == undefined || tipo == undefined) {
        l.stop();
        SweetAlert.swal(
          "Advertencia",
          MESSAGES.WARNING.NOSAVEDEMAIL,
          "warning"
        );
        return;
      }
      emailService.sendEmailRPol(
        model,
        freq,
        tipo,
        subramos,
        aseguradoras,
        email.id
      );
      l.stop();
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("SmtpConfigController", SmtpConfigController);

  SmtpConfigController.$inject = [
    "$localStorage",
    "emailService",
    "dataFactory",
    "toaster",
    "$sessionStorage",
    "$http",
    "$rootScope",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "url",
  ];

  function SmtpConfigController(
    $localStorage,
    emailService,
    dataFactory,
    toaster,
    $sessionStorage,
    $http,
    $rootScope,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    url
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    vm.orgname = usr.urlname;
    // $(window).load(function() {
    //   $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    /* Variables */
    vm.form = {};
    vm.form_org = vm.form;

    /* Funciones */
    vm.saveConfig = saveConfig;
    vm.saveConfigOrg = saveConfigOrg;

    activate();
    activate_org();
    var formdata = new FormData();

    function activate() {
      dataFactory.get("config-smtp/").then(function success(response) {
        if (response.status == 200) {
          vm.form = response.data;
          return;
        } else {
          SweetAlert.swal(
            "Error",
            "Error al obtener la Información del usuario",
            "error"
          );
          activate_underground();
        }
      });
    }
    function activate_org() {
      dataFactory.get("config-smtp2/").then(function success(response) {
        if (response.status == 200) {
          vm.form_org = response.data;
          return;
        } else {
          SweetAlert.swal(
            "Error",
            "Error al obtener la Información del usuario",
            "error"
          );
          activate_underground();
        }
      });
    }

    function saveConfig() {
      if (vm.form) {
        if (
          !vm.form.name ||
          !vm.form.username ||
          !vm.form.password ||
          !vm.form.host ||
          !vm.form.port
        ) {
          SweetAlert.swal("Error", "Existen campos vacios ", "error");
          return;
        }

        dataFactory
          .post("config-smtp/", vm.form)
          .then(function success(response) {
            if (response.status == 200) {
              SweetAlert.swal(
                "Actualizado",
                MESSAGES.OK.SAVEDCONFIG,
                "success"
              );
              return;
            } else {
              SweetAlert.swal(
                "Error",
                "No fue posible actualizar verifique que los datos sean correctos",
                "error"
              );
              activate_underground();
            }
          });
      }
    }

    function saveConfigOrg() {
      if (vm.form_org) {
        if (
          !vm.form_org.name ||
          !vm.form_org.username ||
          !vm.form_org.password ||
          !vm.form_org.host ||
          !vm.form_org.port
        ) {
          SweetAlert.swal("Error", "Existen campos vacios ", "error");
          return;
        }
        if (!validateEmail(vm.form_org.username)) {
          SweetAlert.swal("Error", "Formato de correo no valido", "error");
          return;
        }

        dataFactory
          .post("config-smtp2/", vm.form_org)
          .then(function success(response) {
            if (response.status == 200) {
              SweetAlert.swal(
                "Actualizado",
                MESSAGES.OK.SAVEDCONFIG,
                "success"
              );
              return;
            } else {
              SweetAlert.swal(
                "Error",
                "No fue posible actualizar verifique que los datos sean correctos",
                "error"
              );
              activate_underground();
            }
          });
      }
    }

    $scope.edithBanner = function () {
      $scope.banner_edith = true;
    };
    $scope.CancelEdithBanner = function () {
      $scope.banner_edith = false;
    };
    $scope.addFile = function (key, files) {
      if (
        files[0].name.indexOf(".jpg") < 0 &&
        files[0].name.indexOf(".png") < 0 &&
        files[0].name.indexOf(".jpeg") < 0
      ) {
        swal("Error", "Archivo no valido, deber(.jpg, .png, .jpeg)", "error");
        files = null;
        return;
      }
      if (key == "header" && files.length) {
        $scope.b_header = true;
      } else if (key == "header" && !files.length) {
        $scope.b_header = false;
      } else if (key == "footer" && files.length) {
        $scope.b_footer = true;
      } else if (key == "footer" && !files.length) {
        $scope.b_footer = true;
      }
      formdata.append(key, files[0]);
    };
    $scope.saveFilesHF = function () {
      if (!$scope.b_header || !$scope.b_footer) {
        swal("Error", "Error  banner vacio o archivos no validos", "error");
        return;
      }

      var settings = {
        async: true,
        crossDomain: true,
        url: url.IP + "banner/?org=" + vm.orgname,
        method: "POST",
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", "Bearer " + token);
        },
        processData: false,
        contentType: false,
        mimeType: "multipart/form-data",
        data: formdata,
      };
      $.ajax(settings)
        .done(function (response) {
          $scope.banner_edith = false;
          swal("Actualizado", "Valores actualizados", "success");
        })
        .error(function (response) {
          $scope.banner_edith = false;
          swal("Error", "Error al actualizar ", "error");
        });
      $scope.in_process = false;
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("EmailConfigController", EmailConfigController);

  EmailConfigController.$inject = [
    "$localStorage",
    "emailService",
    "dataFactory",
    "toaster",
    "$sessionStorage",
    "$http",
    "$rootScope",
    "SweetAlert",
    "MESSAGES",
    "$scope",
    "$uibModal",
    "providerService",
    "$sce",
    "textAngularManager",
    "FileUploader",
    "url",
  ];

  function EmailConfigController(
    $localStorage,
    emailService,
    dataFactory,
    toaster,
    $sessionStorage,
    $http,
    $rootScope,
    SweetAlert,
    MESSAGES,
    $scope,
    $uibModal,
    providerService,
    $sce,
    textAngularManager,
    FileUploader,
    url
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    /* Variables */
    vm.flagEmail = false;
    vm.flagEmailCumple = false;
    vm.reminder = false;
    vm.reminder_edith = false;
    vm.rec = false;
    vm.ren = false;
    $scope.change_filter = true;
    vm.reminders_payments = [];

    /* Funciones */
    vm.saveConfig = saveConfig;
    vm.saveEmail = saveEmail;
    vm.sendEmail = sendEmail;
    vm.sendEmailR = sendEmailR;
    vm.selectModel = selectModel;
    vm.edithReminder = edithReminder;
    vm.deleteReminder = deleteReminder;
    vm.addReminder = addReminder;
    vm.saveEmailR = saveEmailR;
    vm.saveEmailBirth = saveEmailBirth;
    vm.edithMailBirth = edithMailBirth;
    vm.sendEmailRPol = sendEmailRPol;
    vm.sendEmail_Data = sendEmail_Data;
    vm.changeRamo = changeRamo;
    vm.changeTipo = changeTipo;
    vm.changeFrecuency = changeFrecuency;
    $scope.focusEditorTemplate = function () {
      $scope.editor_focusTemplate = true;
    };
    $scope.unfocusEditorTemplate = function () {};
    activate();
    activate_underground();
    function activate_underground() {
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          vm.form = response.data.results[0];
        }
      });
    }
    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          dataFactory.get("subramos-by-ramo/" + vm.id).then(function (data) {
            vm.subramos_toselected = data.data;
          });
        }
      }
    };

    function changeFrecuency() {
      $scope.change_filter = false;
    }

    function changeRamo(obj) {
      $scope.change_filter = false;
      if (!obj) {
        vm.form.ramo = "";
        return;
      }
      try {
        vm.subramos = obj.subramo_ramo;
      } catch (e) {}
    }

    function changeTipo(obj) {
      $scope.change_filter = false;
      if (!obj) {
        vm.form.tipo = "";
        return;
      }
    }

    function activate() {
      $(".js-example-basic-multiple").select2();
      getSubramos();
      getProviders();
      if (!$localStorage.email_config) {
        dataFactory.get("orginfo/").then(function success(response) {
          if (response.data.results.length) {
            vm.form = response.data.results[0];
          }
        });
      } else {
        vm.form = $localStorage.email_config;
      }
    }
    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(parseInt(sr.subramo_code));
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(parseInt(cl.id));
      });
    };
    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        vm.providers = data.data;
      });
    }
    function saveConfig() {
      if (vm.form) {
        if (vm.form.url) {
          vm.form.editconfiguracion = true;
          $http.patch(vm.form.url, vm.form).then(function success(response) {
            if (response.status == 200) {
              SweetAlert.swal(
                "Actualizado",
                MESSAGES.OK.SAVEDCONFIG,
                "success"
              );
              vm.flagEmail = false;
              return;
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
              activate_underground();
            } else {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              activate_underground();
            }
          });
        } else {
          dataFactory
            .post("orginfo/", vm.form)
            .then(function success(response) {
              if (response.status == 201) {
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
                vm.flagEmail = false;
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
                activate_underground();
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
                activate_underground();
              }
            });
        }
      }
    }
    $scope.getLog = function () {
      dataFactory
        .get("get-specific-log", { model: 34, associated_id: vm.form.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
        });
    };
    function saveEmail(email) {
      // if(!vm.email.text){
      //     SweetAlert.swal("Completa los datos", 'Información incompleta', "error");
      //     return
      // }
      if (vm.email.url) {
        if (
          vm.email.text == undefined ||
          vm.email.text == null ||
          vm.email.text == ""
        ) {
          vm.email.text = "";
        } else {
          vm.email.text;
        }
        $http
          .patch(vm.email.url + "?model=" + vm.model + "&", vm.email)
          .then(function success(response) {
            if (response.status == 200) {
              SweetAlert.swal("Actualizado", MESSAGES.OK.SAVEDEMAIL, "success");
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
              vm.flagEmail = false;
              vm.reminder = false;
            } else {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            }
            vm.flagEmail = false;
          });
        vm.email = {};
      } else {
        vm.email.model = vm.model;
        dataFactory
          .post("emailinfo/", vm.email)
          .then(function success(response) {
            if (response.status == 201) {
              SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDEMAIL, "success");
              vm.flagEmail = false;
              vm.reminder = false;
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
              vm.flagEmail = false;
              vm.reminder = false;
            } else {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            }
          });
        vm.email = {};
      }
    }
    $scope.updateVencimiento = function () {
      if ($scope.vm.email.relative_time == 3) {
        $scope.vm.email.days = 0;
      }
    };

    function saveEmailR(email, text, model, f) {
      if (model != 10) {
        if (
          !email.text ||
          model == undefined ||
          (model == 5 && email.tipo_cobro == undefined)
        ) {
          SweetAlert.swal(
            "Completa los datos",
            "Información incompleta",
            "error"
          );
          return;
        }
      } else {
        if (!email.text || model == undefined) {
          SweetAlert.swal(
            "Completa los datos",
            "Información incompleta Recordatorio renovación",
            "error"
          );
          return;
        }
      }
      vm.email.frequency = null;
      vm.email.type_policy = vm.email.tipo ? parseInt(vm.email.tipo) : 0;
      vm.email.ramo_code = email.ramo ? parseInt(email.ramo) : 0;
      vm.email.days = email.days ? parseInt(email.days) : 0;
      if (vm.email.relative_date) {
        vm.email.relative_date = email.relative_date
          ? parseInt(email.relative_date)
          : 1;
      }
      vm.email.relative_time = email.relative_time;

      if (vm.email.url) {
        if (model != 10) {
          if (vm.rec) {
            vm.email.aseguradoras = vm.providers_selected;
          }
          vm.email.text = $scope.textEmail ? $scope.textEmail : text;
          $http
            .patch(vm.email.url + "?model=" + vm.model + "&", vm.email)
            .then(function success(response) {
              if (response.status == 200) {
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDEMAIL,
                  "success"
                );
                vm.flagEmail = false;
                vm.reminder = false;
                $scope.change_filter = true;
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          //Renovación
          vm.email.aseguradoras = vm.providers_selected;
          vm.email.subramos = vm.subramos_selected;
          vm.email.tipo_fecha = 1;
          vm.email.relative_date = 1;
          $http
            .patch(vm.email.url + "?model=" + vm.model + "&", vm.email)
            .then(function success(response) {
              if (response.status == 200) {
                if (response.data.validate) {
                  $scope.okemail = "Correo válido";
                } else {
                  $scope.okemail = response.data.error;
                }
                var msj = MESSAGES.OK.SAVEDCONFIG + " \n" + $scope.okemail;
                SweetAlert.swal("Actualizado", msj, "success");
                vm.flagEmail = false;
                vm.reminder = false;
                $scope.change_filter = true;
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
        vm.email = {};
      } else {
        vm.email.model = vm.model;
        if (model != 10) {
          if (
            !email.text ||
            model == undefined ||
            (model == 5 && email.tipo_cobro == undefined)
          ) {
            SweetAlert.swal(
              "Completa los datos",
              "Información incompleta",
              "error"
            );
            return;
          }
        } else {
          if (!email.text || model == undefined) {
            SweetAlert.swal(
              "Completa los datos",
              "Información incompleta Recordatorio renovación*",
              "error"
            );
            return;
          }
          // select_sramo
          // select_provider
        }
        if (model != 10) {
          if (vm.rec || model == 5) {
            vm.email.aseguradoras = vm.providers_selected;
          }

          dataFactory
            .post("emailinforeminder/", vm.email)
            .then(function success(response) {
              if (response.status == 201) {
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDEMAIL, "success");
                vm.flagEmail = false;
                vm.reminder = false;
                vm.reminder_edith = false;
                $scope.frecuencia_ = null;
                vm.frecuencia = {};
                vm.frecuencia.id = null;
                vm.form.ramo = null;
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
              vm.flagEmail = false;
            });
        } else {
          //Renovación
          vm.email.aseguradoras = vm.providers_selected;
          vm.email.subramos = vm.subramos_selected;
          vm.email.tipo_fecha = 1;
          dataFactory
            .post("emailinforeminder/", vm.email)
            .then(function success(response) {
              if (response.status == 201) {
                if (response.data.validate) {
                  $scope.okemail = "Correo válido";
                  $scope.okemail = response.data.error;
                } else {
                  $scope.okemail = response.data.error;
                }
                var msj = MESSAGES.OK.SAVEDCONFIG + " \n" + $scope.okemail;
                SweetAlert.swal("Actualizado", msj, "success");
                vm.flagEmail = false;
                vm.reminder = false;
                vm.reminder_edith = false;
                $scope.frecuencia_ = null;
                vm.frecuencia = {};
                vm.frecuencia.id = null;
                vm.form.ramo = null;
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
              vm.flagEmail = false;
            });
        }
        vm.email = {};
      }
    }

    function saveEmailBirth(email) {
      if (!email || !email.text || !email.subject) {
        SweetAlert.swal(
          "Completa los datos",
          "Información incompleta",
          "error"
        );
        return;
      }
      dataFactory
        .post("birthdate-template/", email)
        .then(function success(response) {
          if (response.status == 201) {
            // SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDEMAIL, "success");
            if (response.data.validate) {
              $scope.okemail = "Correo válido";
            } else {
              $scope.okemail = response.data.error;
            }
            var msj = MESSAGES.OK.SAVEDCONFIG + " \n" + $scope.okemail;
            SweetAlert.swal("Actualizado", msj, "success");
            vm.flagEmailCumple = false;
          } else if (response.status == 403) {
            SweetAlert.swal("Error", response.data.detail, "error");
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
          }
        });
    }

    function edithMailBirth(show) {
      if (show) {
        vm.flagEmailCumple = true;
        dataFactory.get("birthdate-template/").then(function success(response) {
          if (response.status == 200) {
            vm.emailCumple = response.data.results[0];
            if (!vm.emailCumple.remitente) {
              vm.emailCumple.remitente = vm.emailCumple.useremail;
            }
          }
        });
      } else {
        vm.flagEmailCumple = false;
      }
    }
    $scope.relative_times = {
      1: "Antes de",
      2: "Después de",
      3: "Al vencer",
    };
    $scope.relative_times_rec = {
      1: "Antes de",
      2: "Después de",
      3: "Día 0",
    };
    $scope.relative_dates = {
      1: "Fecha fin de vigencia",
      2: "Fecha inicio de vigencia",
      3: "Vencido",
    };
    $scope.relative_dates_ren = {
      1: " fin de vigencia",
      2: " vencimiento",
      3: " Vencido",
    };
    $scope.relative_dates_rec = {
      1: " inicio de vigencia",
      2: " vencimiento",
      3: " Vencido",
    };

    vm.frecuencias = [
      { id: 1, value: 1, name: "Vigencia de 30 días" },
      { id: 2, value: 2, name: "Vigencia de 15 días" },
      { id: 3, value: 3, name: "Vigencia de 5 días" },
      { id: 4, value: 4, name: "Vencido" },
    ];

    $scope.frecuencies_dict = {
      1: "-30 DIAS ANTES DEL",
      2: "-15 DIAS ANTES DEL",
      3: "-5 DIAS ANTES DEL",
      4: "Vencido",
      5: "+5 DIAS POSTERIORES A",
      6: "+10 DIAS POSTERIORES A",
      7: "+15 DIAS POSTERIORES A",
      8: "-10 DIAS ANTES DEL",
      9: "-20 DIAS ANTES DEL",
      10: "+20 DIAS POSTERIORES A",
    };
    $scope.frecuencies_ren = {
      1: "30 días antes de Fecha Fin",
      2: "15 días antes de Fecha Fin",
      3: "10 días antes de Fecha Fin",
      4: "5 días antes de Fecha Fin",
      8: "Vencidas",
    };
    $scope.ramos = {
      0: "Todos los ramos",
      1: "Vida",
      2: "Accidentes y Enfermedades",
      3: "Daños",
    };
    $scope.tipos = {
      0: "Todos los tipos",
      1: "Poliza",
      2: "Colectividad",
    };
    $scope.tipos_ren = {
      0: "Todos los tipos",
      1: "Poliza",
      2: "Póliza Ind de Colectividad",
      3: "Póliza Grupo",
    };

    $scope.cobro = {
      0: "No Domiciliado",
      1: "Domiciliado y Otros",
      2: "Todos",
      3: "Domiciliado",
      4: "No domiciliado y Agente",
    };
    $scope.fechas = {
      1: "Inicio de Vigencia",
      2: "Vencimiento",
    };
    $scope.aseguradoras = [];
    $scope.aseguradoras_dict = {
      null: "Todas",
    };

    function selectModel(param, frequency, page) {
      $scope.param_ok = param;
      $scope.frequency = frequency;
      $scope.page_ok = page;
      vm.email = {};
      vm.flagEmail = true;
      if (param == 5 || param == 10) {
        vm.flagEmail = false;
        vm.reminder = true;
        $scope.aseguradoras = [];
        var d = new Date();
        var curr_date = d.getDate();
        var curr_month = d.getMonth() + 1; //Months are zero based
        var curr_year = d.getFullYear();
        var date = curr_year + "-" + curr_month + "-" + curr_date;
        providerService.getProviderByKey(date).then(function (provider) {
          $scope.providers = provider.data;
          for (i in $scope.providers) {
            $scope.aseguradoras.push({
              id: $scope.providers[i].url,
              value: $scope.providers[i].alias,
            });
            $scope.aseguradoras_dict[$scope.providers[i].url] =
              $scope.providers[i].alias;
          }
        });
      }
      var params = {
        model: param,
        page: page ? page : 1,
      };
      $scope.params = params;
      vm.email = {};
      if (frequency) {
        var freq = frequency.value;
      }
      switch (param) {
        case 1:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Solicitud de orden de trabajo";
          vm.model = param;
          break;
        case 2:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Registro de orden de trabajo (Póliza y Endoso)";
          vm.model = param;
          break;
        case 3:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Solicitud de siniestro";
          vm.model = param;
          break;
        case 4:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Finalización de siniestro";
          vm.model = param;
          break;
        case 5:
          var filter_fianza = "emailinforeminder/";
          vm.rec = true;
          vm.ren = false;
          vm.reminder_edith = false;
          dataFactory
            .get("emailinforeminder/", params)
            // dataFactory.get('emailinfo/', params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.reminders_payments = response.data.results;
                $scope.aseguradorasRec = [];
                vm.reminders_payments.forEach(function (i) {
                  i.aseguradorasRec = [];

                  vm.providers.forEach(function (pr) {
                    i.aseguradoras.forEach(function (ra) {
                      if (pr.id == ra) {
                        if (
                          !$scope.aseguradorasRec.some(function (item) {
                            return item.id === pr.id;
                          })
                        ) {
                          $scope.aseguradorasRec.push({
                            alias: pr.alias,
                            id: pr.id,
                          });
                        }
                        if (
                          !i.aseguradorasRec.some(function (item) {
                            return item.id === pr.id;
                          })
                        ) {
                          i.aseguradorasRec.push({
                            alias: pr.alias,
                            id: pr.id,
                          });
                        }
                      }
                    });
                  });
                });
                vm.search_config = {
                  count: response.data.count,
                  previous: url.IP + filter_fianza,
                  next: url.IP + filter_fianza,
                };
                vm.show_pag_search = true;
                $scope.obtenerPaginacion(response.data, 1);
              }
            });
          vm.title = "Recordatorio de pago";
          vm.model = param;
          break;
        case 6:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Aviso de pago realizado";
          vm.model = param;
          break;
        case 7:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Creación de nota de crédito";
          vm.model = param;
          break;
        case 8:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Al aplicar una nota de crédito";
          vm.model = param;
          break;
        case 9:
          // TODO: Consideraciones especiales, varios formatos
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Al renovar la póliza";
          vm.model = param;
          break;
        case 10:
          var filter_fianza = "emailinforeminder/";
          // TODO: Consideraciones especiales, varios formatos
          vm.reminder_edith = false;
          vm.ren = true;
          vm.rec = false;
          dataFactory
            .get("emailinforeminder/", params)
            // dataFactory.get('emailinfo/', params)
            .then(function success(response) {
              if (response.data.results.length) {
                $scope.aseguradorasRen = [];
                $scope.subramosRen = [];
                vm.reminders_payments = response.data.results;
                vm.reminders_payments.forEach(function (i) {
                  i.subramosRen = [];
                  i.aseguradorasRen = [];
                  vm.subramos_toselected.forEach(function (b) {
                    i.subramos.forEach(function (rs) {
                      if (b.subramo_code == rs) {
                        $scope.subramosRen.push({
                          subramo_name: b.subramo_name,
                          subramo_code: b.subramo_code,
                        });
                        i.subramosRen.push({
                          subramo_name: b.subramo_name,
                          subramo_code: b.subramo_code,
                        });
                      }
                    });
                  });
                  vm.providers.forEach(function (pr) {
                    i.aseguradoras.forEach(function (ra) {
                      if (pr.id == ra) {
                        $scope.aseguradorasRen.push({
                          alias: pr.alias,
                          id: pr.id,
                        });
                        i.aseguradorasRen.push({ alias: pr.alias, id: pr.id });
                      }
                    });
                  });
                });
                vm.search_config = {
                  count: response.data.count,
                  previous: url.IP + filter_fianza,
                  next: url.IP + filter_fianza,
                };
                vm.show_pag_search = true;
                $scope.obtenerPaginacion(response.data, 1);
              }
            });
          vm.title = "Recordatorio de renovación";
          vm.model = param;
          break;
        case 11:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Trámite de siniestro";
          vm.model = param;
          break;
        case 12:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Cancelación de siniestro";
          vm.model = param;
          break;
        case 13:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Rechazo de siniestro";
          vm.model = param;
          break;
        case 14:
          dataFactory
            .get("emailinfo/", params)
            .then(function success(response) {
              if (response.data.results.length) {
                vm.email = response.data.results[0];
              }
            });
          vm.title = "Espera de siniestro";
          vm.model = param;
          break;
      }
    }
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (clasificacion, pagina) {
      $scope.paginacion = {
        count: clasificacion["count"],
        previous: clasificacion["previous"],
        next: clasificacion["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      $scope.params["page"] = pagina;
      vm.selectModel($scope.param_ok, $scope.frequency, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $scope.params["page"] = $scope.paginacion["paginaActual"] - 1;
        vm.selectModel(
          $scope.param_ok,
          $scope.frequency,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $scope.params["page"] = $scope.paginacion["paginaActual"] + 1;
        vm.selectModel(
          $scope.param_ok,
          $scope.frequency,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };
    function edithReminder(reminder) {
      vm.subramos_selected = [];
      vm.providers_selected = [];
      $scope.select_sramo = [];
      $scope.select_provider = [];
      $scope.aseguradoras = [];
      var d = new Date();
      var curr_date = d.getDate();
      var curr_month = d.getMonth() + 1; //Months are zero based
      var curr_year = d.getFullYear();
      var date = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(date).then(function (provider) {
        $scope.providers = provider.data;
        for (i in $scope.providers) {
          $scope.aseguradoras.push({
            id: $scope.providers[i].url,
            value: $scope.providers[i].alias,
          });
          $scope.aseguradoras_dict[$scope.providers[i].url] =
            $scope.providers[i].alias;
        }
      });
      if (reminder.subramos || reminder.aseguradoras) {
        vm.subramos_toselected.forEach(function (b) {
          reminder.subramos.forEach(function (rs) {
            if (b.subramo_code == rs) {
              $scope.select_sramo.push(b);
              vm.subramos_selected.push(parseInt(b.subramo_code));
            }
          });
        });
        vm.providers.forEach(function (pr) {
          reminder.aseguradoras.forEach(function (ra) {
            if (pr.id == ra) {
              $scope.select_provider.push(pr);
              $scope.selectProv($scope.select_provider);
              vm.providers_selected.push(parseInt(pr.id));
            }
          });
        });
      }
      vm.reminder_edith = true;
      vm.email = reminder;
      //$scope.frecuencia_ = reminder.frequency;
      vm.frecuencia = {};
      vm.frecuencia.id = reminder.frequency;
      vm.email.ramo = reminder.ramo_code.toString();
      vm.email.tipo_cobro = reminder.tipo_cobro.toString();
      vm.email.receipt_type = reminder.receipt_type.toString();
      vm.email.tipo_fecha = reminder.tipo_fecha.toString();
      vm.email.tipo = reminder.type_policy.toString();
      vm.email.text = String(reminder.text);
      vm.renderedEmailText = $sce.trustAsHtml(vm.email.text);
      if (reminder.frequency) {
        vm.email.frequency = reminder.frequency.toString();
      }
      vm.email.days = reminder.days;
      if (reminder.relative_date) {
        vm.email.relative_date = reminder.relative_date.toString();
      }
      if (reminder.relative_time) {
        vm.email.relative_time = reminder.relative_time.toString();
      }
      if (reminder.model == 10) {
        if (!vm.email.remitente) {
          vm.email.remitente = vm.email.useremail;
        }
      }
      // console.log(reminder.relative_date)
      // if (reminder.relative_date == 3) {
      //     console.log("ingreso")
      //     console.log(vm.email)
      //     vm.email.vencimiento.checked = true;
      // }
    }
    $scope.$watch("vm.email.text", function (newVal, oldVal) {
      if (newVal !== oldVal) {
        $scope.textEmail = newVal;
      }
    });
    function addReminder(reminder) {
      $(".js-example-basic-multiple").select2();
      vm.reminder_edith = true;
      vm.email = reminder ? reminder : {};
      $scope.frecuencia_ = null;
      vm.frecuencia = {};
      vm.frecuencia.id = null;
      vm.form.ramo = null;
      vm.form.receipt_type = 0;
      vm.email.receipt_type = 0;
      $scope.select_provider = [];
      if (vm.ren && vm.form) {
        vm.email.remitente = vm.form.correoorg;
      }
    }
    function deleteReminder(reminder) {
      var params = {
        model: reminder.model,
      };
      $http.delete(reminder.url).then(function success(response) {
        dataFactory
          .get("emailinforeminder/", params)
          .then(function success(response) {
            if (response.data.results.length) {
              vm.reminders_payments = response.data.results;
            }
          });
      });
    }
    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function sendEmail(email, txt, model) {
      emailService.sendEmail(model, 1, email).then(function (response) {
        toaster.success(MESSAGES.OK.EMAILSENDED);
      });
    }

    function sendEmail_Data(subject, text, model, dataemail) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/emails/email_data_modal.html",
        controller: ModalInstanceCtrlEmailData,
        resolve: {
          vm: function () {
            return vm;
          },
          model: function () {
            return model;
          },
          dataemail: function () {
            return dataemail;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_code: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_code: 6,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_code: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }
    // -------------

    $scope.focusEditor = function () {
      $scope.editor_focus = true;
    };

    $scope.unfocusEditor = function () {
      // if(!$scope.get_file) {
      //   $scope.editor_focus = false;
      // }
    };
    $scope.getFile = function () {
      var editor = textAngularManager.retrieveEditor("myEditorCreate").scope;
      editor.displayElements.text.trigger("focus");

      var modalInstance = $uibModal.open({
        template:
          '<label class="col-xs-12 btn btn-info">Agregar Imagen desde PC' +
          '<input multiple nv-file-select="" type="file" name="xyz" uploader="uploader" accept=".jpg" class="display-none"/>' +
          "</label>",
        // size: 'sm',
        controller: ModalInstanceFileCtrl,
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (imgUrl) {
        var imageLink;
        imageLink = $rootScope.image_url;
        var embed = '<img src="' + imageLink + ' ">';
        // return textAngular.$editor().wrapSelection('insertHTML', embed, true);

        var editor = textAngularManager.retrieveEditor("myEditorCreate");
        editor.scope.wrapSelection("insertHTML", embed, true);
      });
    };
    function ModalInstanceFileCtrl($scope, $rootScope, $uibModalInstance) {
      $scope.userInfo = {
        id: 0,
      };
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        allowedFileType: ["png", "jpg", "jpeg"],
      }));
      $scope.userInfo.url = $scope.uploader.url = url.IP + "birthdates-html/";
      $scope.uploader.autoUpload = true;
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        // el url del archivo cargado esta en response.arch
        $rootScope.image_url = response.arch;
        if ($uibModalInstance) {
          $uibModalInstance.close();
        }
      };
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };
      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });
      };
      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = usr.org;
      };
      $scope.validateFiles = function () {
        var input = document.getElementById("fileInput");
        var files = input.files;
        var totalSize = 0;
        var errorMessageElement = document.getElementById("error-message");
        for (var i = 0; i < files.length; i++) {
          totalSize += files[i].size;
        }
        var totalSizeMB = totalSize / (1024 * 1024);
        if (totalSizeMB > 25) {
          errorMessageElement.style.display = "block";
          errorMessageElement.textContent =
            "La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.";
        } else {
          errorMessageElement.style.display = "none"; // Hide error message if files are valid
        }
      };
      function uploadFiles() {
        $scope.userInfo.url = $scope.uploader.url = url.IP + "birthdates-html/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }
    }
    // ******************
    function ModalInstanceCtrlEmailData(
      $scope,
      $uibModal,
      status,
      $uibModalInstance,
      vm,
      model,
      dataemail
    ) {
      $scope.ok = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if ($scope.email || $scope.email == undefined) {
          if (!validateEmail($scope.email)) {
            l.stop();
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.INVALIDEMAILCONTACT,
              "error"
            );
            return;
          }
        }
        emailService.sendEmail(model, $scope.email, dataemail);
        l.stop();
        $uibModalInstance.dismiss("cancel");
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
        l.stop();
        return;
      };
    }

    function sendEmailR(email, txt, model, ramo) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (!email) {
        l.stop();
        SweetAlert.swal(
          "Advertencia",
          MESSAGES.WARNING.NOSAVEDEMAIL,
          "warning"
        );
        return;
      }
      var response = emailService.sendEmailR(
        model,
        ramo,
        email.id,
        email.days,
        email.relative_date,
        email.relative_time
      );

      l.stop();
    }

    function sendEmailRPol(email, txt, model, tipo, subramos, aseguradoras) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      if (model == undefined || tipo == undefined) {
        l.stop();
        SweetAlert.swal(
          "Advertencia",
          MESSAGES.WARNING.NOSAVEDEMAIL,
          "warning"
        );
        return;
      }
      emailService.sendEmailRPol(
        model,
        tipo,
        subramos,
        aseguradoras,
        email.id,
        email.days,
        email.relative_date,
        email.relative_time
      );
      l.stop();
    }

    $scope.getFileTemplate = function () {
      var editor = textAngularManager.retrieveEditor(
        "myEditorCreateTemplate"
      ).scope;
      editor.displayElements.text.trigger("focus");

      var modalInstance = $uibModal.open({
        template:
          '<label class="col-xs-12 btn btn-info">Agregar Imagen desde PC' +
          '<input multiple nv-file-select="" type="file" name="xyz" uploader="uploader" accept=".jpg, .png" class="display-none"/>' +
          "</label>",
        // size: 'sm',
        controller: ModalInstanceFileTemplateCtrl,
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (imgUrl) {
        var imageLink;
        imageLink = $rootScope.image_url;
        var embed = '<img src="' + imageLink + ' ">';
        // return textAngular.$editor().wrapSelection('insertHTML', embed, true);

        var editor = textAngularManager.retrieveEditor(
          "myEditorCreateTemplate"
        );
        editor.scope.wrapSelection("insertHTML", embed, true);
      });
    };
    function ModalInstanceFileTemplateCtrl(
      $scope,
      $rootScope,
      $uibModalInstance
    ) {
      $scope.userInfo = {
        id: 0,
      };
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        allowedFileType: ["png", "jpg", "jpeg"],
      }));
      $scope.userInfo.url = $scope.uploader.url = url.IP + "emailsatm-html/";
      $scope.uploader.autoUpload = true;
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        // el url del archivo cargado esta en response.arch
        $rootScope.image_url = response.arch;
        if ($uibModalInstance) {
          $uibModalInstance.close();
        }
      };
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };
      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });
      };
      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = usr.org;
      };
      $scope.validateFiles = function () {
        var input = document.getElementById("fileInput");
        var files = input.files;
        var totalSize = 0;
        var errorMessageElement = document.getElementById("error-message");
        for (var i = 0; i < files.length; i++) {
          totalSize += files[i].size;
        }
        var totalSizeMB = totalSize / (1024 * 1024);
        if (totalSizeMB > 25) {
          errorMessageElement.style.display = "block";
          errorMessageElement.textContent =
            "La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.";
        } else {
          errorMessageElement.style.display = "none"; // Hide error message if files are valid
        }
      };
      function uploadFilesTemplate() {
        $scope.userInfo.url = $scope.uploader.url = url.IP + "emailsatm-html/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").factory("emailService", emailService);

  emailService.$inject = [
    "dataFactory",
    "$http",
    "$q",
    "$sessionStorage",
    "MESSAGES",
    "SweetAlert",
    "toaster",
  ];
  function emailService(
    dataFactory,
    $http,
    $q,
    $sessionStorage,
    MESSAGES,
    SweetAlert,
    toaster
  ) {
    var service = {
      sendEmail: sendEmail,
      sendEmailR: sendEmailR,
      sendEmailRPol: sendEmailRPol,
      sendEmailRWhatsapp: sendEmailRWhatsapp,
      sendEmailAtm: sendEmailAtm,
      sendEmailFilter: sendEmailFilter,
    };

    return service;
    function sendEmail(model, email, datae) {
      var dfd = $q.defer();

      var data = {
        model: model,
        email: email,
        data: datae ? datae : "",
      };
      var accesos = $sessionStorage.permisos;
      if (accesos) {
        accesos.forEach(function (perm) {
          if (perm.model_name == "Correos electronicos") {
            var acceso_correo = perm;
            acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  var acceso_cor = true;
                  if (acceso_cor) {
                    return dataFactory
                      .post("send-email-prueba/", data)
                      .then(getEmailServiceComplete)
                      .catch(getEmailServiceFailed);

                    function getEmailServiceComplete(response) {
                      if (response.status == 200 || response.status == "sent") {
                        SweetAlert.swal(
                          "Correo enviado",
                          "Revise el correo",
                          "success"
                        );
                      }
                      dfd.resolve(response.data);
                      return dfd.promise;
                    }

                    function getEmailServiceFailed(error) {
                      toaster.warning("Ha ocurrido un error");
                    }
                  }
                } else {
                  var acceso_cor = false;
                }
              }
            });
          }
        });
      }
    }
    function sendEmailRWhatsapp(model, freq, ramo, id) {
      var dfd = $q.defer();
      var data = {
        model: model,
        frecuencia: freq,
        ramo_code: ramo,
        id: id,
      };
      return dataFactory
        .post("send-email-reminder-recibos-whatsappsms/", data)
        .then(getWhatsappSMSServiceComplete)
        .catch(getWhatsappSMSServiceFailed);
      function getWhatsappSMSServiceComplete(response) {
        if (response.status == 200 || response.status == 201) {
          if (response.data.status == "sent") {
            if (response.data.status == "sent") {
              SweetAlert.swal(
                "¡Listo!",
                "Recordatorio de Pago Whatsapp/SMS enviado",
                "success"
              );
            } else {
              SweetAlert.swal(
                "Error",
                "No se ha enviado el Recordatorio de Pago Whatsapp/SMS",
                "error"
              );
            }
          }
        } else if (response.status == 304) {
          SweetAlert.swal(
            "Info",
            "Sin recibos dentro de los filtros",
            "warning"
          );
        } else if (response.status == 400) {
          SweetAlert.swal(
            "Error",
            "No se ha enviado el Recordatorio de Pago Whatsapp/SMS",
            "error"
          );
        }
        dfd.resolve(response.data);
        return dfd.promise;
      }

      function getWhatsappSMSServiceFailed(error) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORSENDEMAIL, "error");
      }
    }

    function sendEmailR(model, ramo, id, days, relative_date, relative_time) {
      var dfd = $q.defer();
      var data = {
        model: model,
        // frecuencia: freq,
        days: days,
        relative_date: relative_date,
        relative_time: relative_time,
        ramo_code: ramo,
        id: id,
      };
      var accesos = $sessionStorage.permisos;
      if (accesos) {
        accesos.forEach(function (perm) {
          if (perm.model_name == "Correos electronicos") {
            var acceso_correo = perm;
            acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  var acceso_cor = true;
                  if (acceso_cor) {
                    // return dataFactory.post('send-email-reminder/', data)
                    return dataFactory
                      .post("send-email-reminder-recibos/", data)
                      .then(getEmailServiceComplete)
                      .catch(getEmailServiceFailed);

                    function getEmailServiceComplete(response) {
                      if (response.status == 200 || response.status == 201) {
                        if (response.data.status == "sent") {
                          if (response.data.status == "sent") {
                            SweetAlert.swal(
                              "¡Listo!",
                              MESSAGES.OK.EMAILSENDED,
                              "success"
                            );
                          } else {
                            SweetAlert.swal(
                              "Error",
                              MESSAGES.ERROR.ERRORSENDEMAIL,
                              "error"
                            );
                          }
                        }
                      } else if (response.status == 304) {
                        SweetAlert.swal(
                          "Info",
                          "Sin recibos dentro de los filtros",
                          "warning"
                        );
                      } else if (response.status == 400) {
                        SweetAlert.swal(
                          "Error",
                          MESSAGES.ERROR.ERRORSENDEMAIL,
                          "error"
                        );
                      }
                      dfd.resolve(response.data);
                      return dfd.promise;
                    }

                    function getEmailServiceFailed(error) {
                      SweetAlert.swal(
                        "Error",
                        MESSAGES.ERROR.ERRORSENDEMAIL,
                        "error"
                      );
                    }
                  }
                } else {
                  var acceso_cor = false;
                }
              }
            });
          }
        });
      }
    }

    function sendEmailRPol(
      model,
      tipo,
      subramos,
      aseguradoras,
      id,
      days,
      relative_date,
      relative_time
    ) {
      var dfd = $q.defer();

      var data = {
        model: model,
        days: days,
        relative_date: relative_date,
        relative_time: relative_time,
        subramos: subramos,
        aseguradoras: aseguradoras,
        tipo: tipo,
        id: id,
      };
      // ----------d
      var accesos = $sessionStorage.permisos;
      if (accesos) {
        accesos.forEach(function (perm) {
          if (perm.model_name == "Correos electronicos") {
            var acceso_correo = perm;
            acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  var acceso_cor = true;
                  if (acceso_cor) {
                    // return dataFactory.post('send-email-reminder/', data)
                    return dataFactory
                      .post("send-email-reminder-policy/", data)
                      .then(getEmailServiceComplete)
                      .catch(getEmailServiceFailed);

                    function getEmailServiceComplete(response) {
                      if (response.status == 200 || response.status == 201) {
                        if (response.data.status == "sent") {
                          if (response.data.status == "sent") {
                            SweetAlert.swal(
                              "¡Listo!",
                              MESSAGES.OK.EMAILSENDED,
                              "success"
                            );
                          } else {
                            SweetAlert.swal(
                              "Error",
                              MESSAGES.ERROR.ERRORSENDEMAIL,
                              "error"
                            );
                          }
                        }
                      } else if (response.status == 304) {
                        SweetAlert.swal(
                          "Info",
                          "Sin Pólizas dentro de los filtros",
                          "warning"
                        );
                      }
                      dfd.resolve(response.data);
                      return dfd.promise;
                    }

                    function getEmailServiceFailed(error) {
                      SweetAlert.swal(
                        "Error",
                        MESSAGES.ERROR.ERRORSENDEMAIL,
                        "error"
                      );
                    }
                  }
                } else {
                  var acceso_cor = false;
                }
              }
            });
          }
        });
      }
      // -----------------d
    }
    // ---SEND EMAIL ATM
    function sendEmailAtm(model, id) {
      var dfd = $q.defer();

      var data = {
        model: model,
        id: id,
      };
      var accesos = $sessionStorage.permisos;
      if (accesos) {
        accesos.forEach(function (perm) {
          if (perm.model_name == "Correos electronicos") {
            var acceso_correo = perm;
            acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  var acceso_cor = true;
                  if (acceso_cor) {
                    return dataFactory
                      .post("send-email/", data)
                      .then(getEmailServiceComplete)
                      .catch(getEmailServiceFailed);

                    function getEmailServiceComplete(response) {
                      dfd.resolve(response.data);
                      return dfd.promise;
                    }

                    function getEmailServiceFailed(error) {}
                  }
                } else {
                  var acceso_cor = false;
                }
              }
            });
          }
        });
      }
    }

    function sendEmailFilter(model, id) {
      var dfd = $q.defer();

      var data = {
        model: model,
        id: id,
      };

      return dataFactory
        .post("email-to-admin-filter/", data)
        .then(getEmailServiceComplete)
        .catch(getEmailServiceFailed);

      function getEmailServiceComplete(response) {
        dfd.resolve(response.data);
        return dfd.promise;
      }

      function getEmailServiceFailed(error) {}
    }
  }
})();

(function () {
  "use strict";

  var app = angular.module("inspinia");

  app.controller("TabsCtrl", [
    "$scope",
    "appStates",
    "$state",
    "$rootScope",
    "$localStorage",
    function ($scope, appStates, $state, $rootScope, $localStorage, toaster) {
      var initialize = function () {
        $localStorage["tab_index"] = $localStorage.tab_index
          ? $localStorage.tab_index
          : 0;
        $scope.appStates = appStates.states;
        appStates.states.forEach(function (appstate, index) {
          if (appstate.active) {
            $scope.active_tab = index;
          }
        });
      };
      initialize();

      $scope.active = function (route) {
        return $state.is(route);
      };

      $scope.tabSelected = function (route, index_tracked) {
        if ($localStorage.tab_index == index_tracked) {
          appStates.states.forEach(function (tab) {
            if (
              tab.route == "colectividades.masivos" ||
              tab.route.indexOf("carga.") != -1
            ) {
              tab.active = true;
              $state.go(tab.route);
            }
          });
          // toaster("Información","No puede cambiar de pestaña si esta abierta alguna de carga masiva","info");
          // return;
          if (
            route.indexOf("info") != -1 ||
            route.indexOf("editar") != -1 ||
            route.indexOf("edit") != -1
          ) {
            if (appStates.states[index_tracked].id != 0) {
              $state.go(route);
            }
          }
          return;
        }
        $localStorage.tab_index = index_tracked;
        appStates.states.forEach(function (tab) {
          if (
            tab.route == "colectividades.masivos" ||
            tab.route.indexOf("carga.") != -1
          ) {
            tab.active = true;
            $state.go(tab.route);
            // toaster("Información","No puede cambiar de pestaña si esta abierta alguna de carga masiva","info");
            return;
          } else {
            tab.active = false;
          }
          console.log("--tab", tab);
          return tab;
        });
        appStates.states[index_tracked].active = true;

        $localStorage.tab_states = appStates.states;
        if (
          appStates.states[index_tracked] &&
          appStates.states[index_tracked].id
        ) {
          switch (route) {
            case "inicio.inicio":
              $state.go(route);
              break;
            case "index.main":
              $state.go(route);
              break;
            case "contratantes.list":
              $state.go(route);
              break;
            case "contratantes.main":
              $state.go(route);
              break;
            case "contratantes.create":
              $state.go(route);
              break;
            case "contratantes.info":
              $state.go(route, {
                contratanteId: appStates.states[index_tracked].id,
                type: appStates.states[index_tracked].type,
              });

              break;
            case "contratantes.edit":
              $state.go(route, {
                contratanteId: appStates.states[index_tracked].id,
                type: appStates.states[index_tracked].type,
              });

              break;

            case "grupos.grupos":
              $state.go(route);
              break;
            case "grupos.info":
              $state.go(route, {
                grupoId: appStates.states[index_tracked].id,
              });

              break;
            case "grupos.edit":
              $state.go(route, {
                grupoId: appStates.states[index_tracked].id,
              });

              break;

            case "clasificacion.clasificacion":
              $state.go(route);
              break;

            case "celulacontractor.celulacontractor":
              $state.go(route);
              break;

            case "grupinglevel.grupinglevel":
              $state.go(route);
              break;

            case "polizas.table":
              $state.go(route);
              break;
            case "polizas.plantillas":
              $state.go(route);
              break;
            case "adjuntosinternos.list":
              $state.go(route);
              break;
            case "recordatorios.automaticos":
              $state.go(route);
              break;
            case "recordatorios.libres":
              $state.go(route);
              break;
            case "recordatorios.desde_registros":
              $state.go(route);
              break;
            case "polizas.create":
              $state.go(route);
              break;
            case "polizas.info":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "polizas.editar":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "compartir.create":
              $state.go(route, {
                shareId: appStates.states[index_tracked].id,
              });
              break;

            case "colectividades.main":
              $state.go(route);
              break;
            case "colectividades.table":
              $state.go(route);
              break;
            case "colectividades.info":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "colectividades.edit":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "colectividades.convertirPoliza":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
                status: appStates.states[index_tracked].status,
              });

            case "recordatorios.automaticos_detalle":
              $state.go(route, {
                id: appStates.states[index_tracked].id,
              });
              break;
            case "colectividades.renewal":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });
              break;
            case "colectividades.masivos":
              $state.go(route);
              break;

            case "flotillas.flotillas":
              $state.go(route);
              break;
            case "flotillas.info":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "flotillas.edit":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "flotillas.renewal":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "flotillas.details":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;

            case "fianzas.fianzas":
              $state.go(route);
              break;
            case "fianzas.reclist":
              $state.go(route);
              break;
            case "fianzas.reclinf":
              $state.go(route, {
                claimId: appStates.states[index_tracked].id,
              });
              break;
            case "fianzas.colectividades":
              $state.go(route);
              break;
            case "fianzas.edit":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "fianzas.renewal":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
                renovacion: appStates.states[index_tracked].renovacion,
              });

              break;
            case "fianzas.reissue":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "fianzas.details":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "fianzas.reclamaciones":
              $state.go(route);
              break;
            case "fianzas.list":
              $state.go(route);
              break;
            case "fianzas.info":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "fianzas.pprovlist":
              $state.go(route);
              break;
            case "fianzas.pprovnew":
              $state.go(route);
              break;
            case "fianzas.editar":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;
            case "fianzas.renovar":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
                renovacion: appStates.states[index_tracked].renovacion,
              });

              break;
            case "fianzas.reexpedir":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
                reexpedir: appStates.states[index_tracked].reexpedir,
              });

              break;
            case "reclamacion.edit":
              $state.go(route, {
                reclId: appStates.states[index_tracked].id,
              });

              break;
            case "fianzas.pprovinfo":
              $state.go(route, {
                contratanteId: appStates.states[index_tracked].id,
                type: appStates.states[index_tracked].type,
              });

              break;
            case "fianzas.pprovedit":
              $state.go(route, {
                contratanteId: appStates.states[index_tracked].id,
                type: appStates.states[index_tracked].type,
              });

              break;

            case "endorsement.endorsement":
              $state.go(route);
              break;
            case "endorsement.lista":
              $state.go(route);
              break;
            case "endorsement.collectivity":
              $state.go(route);
              break;
            case "endorsement.info":
              $state.go(route, {
                endosoId: appStates.states[index_tracked].id,
              });

              break;
            case "endorsement.details":
              $state.go(route, {
                endosoId: appStates.states[index_tracked].id,
              });

              break;
            case "endorsement.edit":
              $state.go(route, {
                endosoId: appStates.states[index_tracked].id,
              });

              break;
            case "endorsement.collective":
              $state.go(route);
              break;
            case "endorsement.update":
              $state.go(route, {
                endosoId: appStates.states[index_tracked].id,
              });

              break;
            case "endorsement.fianza":
              $state.go(route, {
                fianzaId: appStates.states[index_tracked].id,
              });

              break;

            case "renovaciones.renovaciones":
              $state.go(route);
              break;
            case "renovaciones.polizas":
              $state.go(route, {
                polizaId: appStates.states[index_tracked].id,
              });

              break;

            case "cobranzas.cobranzas":
              $state.go(route);
              break;
            case "cobranzas.recibospendientes":
              $state.go(route);
              break;
            case "cobranzas.folios":
              $state.go(route);
              break;
            case "cobranzas.bonos":
              $state.go(route);
              break;
            case "cobranzas.cobranzasmasivo":
              $state.go(route);
              break;
            case "cobranzas.repositorio":
              $state.go(route);
              break;

            case "aseguradoras.aseguradoras":
              $state.go(route);
              break;
            case "aseguradoras.edit":
              $state.go(route, {
                aseguradoraId: appStates.states[index_tracked].id,
              });

              break;
            case "aseguradoras.info":
              $state.go(route, {
                aseguradoraId: appStates.states[index_tracked].id,
              });

              break;
            case "aseguradoras.ramos":
              $state.go(route, {
                aseguradoraId: appStates.states[index_tracked].id,
              });

              break;
            case "aseguradoras.subramos":
              $state.go(route, {
                aseguradoraId: appStates.states[index_tracked].id,
                ramosId: appStates.states[index_tracked].ramosId,
              });

              break;

            case "carga.contractor":
              $state.go(route);
              break;
            case "carga.poliza":
              $state.go(route);
              break;
            case "carga.norenovacion":
              $state.go(route);
              break;
            case "carga.pgrupo":
              $state.go(route);
              break;
            case "carga.certificado":
              $state.go(route);
              break;
            case "carga.flotilla":
              $state.go(route);
              break;
            case "carga.recibos":
              $state.go(route);
              break;
            case "carga.catalogo":
              $state.go(route);
              break;
            case "carga.cancelacion":
              $state.go(route);
              break;
            case "carga.infocontributoria":
              $state.go(route);
              break;

            case "paquetes.paquetes":
              $state.go(route);
              break;
            case "paquetes.edit":
              $state.go(route, {
                paqueteId: appStates.states[index_tracked].id,
              });

              break;

            case "coberturas.coberturas":
              $state.go(route);
              break;

            case "cotizacion.cotizacion":
              $state.go(route);
              break;

            case "siniestros.lista":
              $state.go(route);
              break;
            case "siniestros.plantillas":
              $state.go(route);
              break;
            case "siniestros.accidentes":
              $state.go(route);
              break;
            case "siniestros.create_accidentes":
              $state.go(route);
              break;
            case "siniestros.damage":
              $state.go(route);
              break;
            case "siniestros.vida":
              $state.go(route);
              break;
            case "siniestros.create_vida":
              $state.go(route);
              break;
            case "siniestros.info":
              $state.go(route, {
                siniestroId: appStates.states[index_tracked].id,
              });

              break;
            case "siniestros.vida_info":
              $state.go(route, {
                siniestroId: appStates.states[index_tracked].id,
              });

              break;
            case "siniestros.edit":
              $state.go(route, {
                siniestroId: appStates.states[index_tracked].id,
              });

              break;
            case "siniestros.accidentesInfo":
              $state.go(route, {
                siniestroId: appStates.states[index_tracked].id,
              });

              break;
            case "siniestros.vida_info":
              $state.go(route, {
                siniestroId: appStates.states[index_tracked].id,
              });

              break;
            case "siniestros.autos":
              $state.go(route);
              break;
            case "siniestros.danios":
              $state.go(route);
              break;
            case "siniestros.create_autos":
              $state.go(route);
              break;
            case "siniestros.create_danios":
              $state.go(route);
              break;
            case "siniestros.auto_info":
              $state.go(route, {
                siniestroId: appStates.states[index_tracked].id,
              });

              break;
            case "siniestros.danio_info":
              $state.go(route, {
                siniestroId: appStates.states[index_tracked].id,
              });

              break;

            case "comisiones.comisiones":
              $state.go(route);
              break;
            case "comisiones.consulta":
              $state.go(route);
              break;
            case "comisiones.conciliarid":
              $state.go(route);
              break;

            case "agentes.agentes":
              $state.go(route);
              break;
            case "agentes.administration":
              $state.go(route);
              break;
            case "agentes.receipts":
              $state.go(route);
              break;
            case "agentes.estadoscuenta":
              $state.go(route);
              break;

            case "reportes.auditoria":
              $state.go(route);
              break;
            case "reportes.cobranza":
              $state.go(route);
              break;
            case "reportes.cotizaciones":
              $state.go(route);
              break;
            case "reportes.renovaciones":
              $state.go(route);
              break;
            case "reportes.endosos":
              $state.go(route);
              break;
            case "reportes.polizas":
              $state.go(route);
              break;
            case "reportes.polizas_contributorias":
              $state.go(route);
              break;
            case "reportes.siniestros":
              $state.go(route);
              break;
            case "reportes.fianzas":
              $state.go(route);
              break;
            case "reportes.fianzas_ben":
              $state.go(route);
              break;
            case "reportes.log":
              $state.go(route);
              break;
            case "reportes.task":
              $state.go(route);
              break;
            case "reportes.certificates":
              $state.go(route);
              break;
            case "reportes.cumple":
              $state.go(route);
              break;
            case "reportes.cobranzafianzas":
              $state.go(route);
              break;
            case "reportes.edoclientes":
              $state.go(route);
              break;
            case "reportes.cobranza_liq":
              $state.go(route);
              break;
            case "reportes.cobranza_subsec":
              $state.go(route);
              break;
            case "reportes.cobranzapendiente":
              $state.go(route);
              break;
            case "reportes.renovacionespendientes":
              $state.go(route);
              break;
            case "reportes.otsendosos":
              $state.go(route);
              break;
            case "reportes.polizasTitularesConyuges":
              $state.go(route);
              break;
            case "reportes.conservacion":
              $state.go(route);
              break;
            case "reportes.ventacruzada":
              $state.go(route);
              break;
            case "reportes.adjuntos":
              $state.go(route);
              break;
            case "reportes.asegurados":
              $state.go(route);
              break;

            case "bibliotecas.list":
              $state.go(route);
              break;
            case "bibliotecas.bibliotecas":
              $state.go(route);
              break;
            case "bibliotecas.edit":
              $state.go(route);
              break;
            case "bibliotecas.layouts":
              $state.go(route);
              break;
            case "bibliotecas.editables":
              $state.go(route);
              break;

            case "campaign.list":
              $state.go(route);
              break;
            case "campaign.create":
              $state.go(route);
              break;
            case "campaign.edit":
              $state.go(route, {
                campaignId: appStates.states[index_tracked].id,
              });

              break;

            case "mensajeria.principal":
              $state.go(route);
              break;

            case "multicotizador.multicotizador":
              $state.go(route);
              break;
            case "multicotizador.emision":
              $state.go(route);
              break;
            case "multicotizador.administrador":
              $state.go(route);
              break;

            case "task.task":
              $state.go(route);
              break;
            case "task.admin":
              $state.go(route);
              break;

            case "kbi.principal":
              $state.go(route);
              break;

            case "config.configuracion_filtros":
              $state.go(route);
              break;
            case "config.lectura_documentos":
              $state.go(route);
              break;
            case "config.edit_lectura_documentos":
              $state.go(route, {
                id: appStates.states[index_tracked].id,
              });

              break;

            case "cedula.cedula":
              $state.go(route);
              break;

            case "emails.smtp":
              $state.go(route);
              break;
            case "emails.config":
              $state.go(route);
              break;
            case "emails.whatsapp":
              $state.go(route);
              break;

            case "agenda.agenda":
              $state.go(route);
              break;

            case "ibis.usuarios":
              $state.go(route);
              break;
            case "ibis.formatos":
              $state.go(route);
              break;
            case "ibis.directorio":
              $state.go(route);
              break;
            case "ibis.red":
              $state.go(route);
              break;

            case "sucursal.config":
              $state.go(route);
              break;

            case "help.manual":
              $state.go(route);
              break;
            case "help.policy":
              $state.go(route);
              break;

            case "buscador.buscador":
              $state.go(route, {
                cadena: appStates.states[index_tracked].id,
              });
              break;
            case "buscador.modal":
              $state.go(route, {
                cadena: appStates.states[index_tracked].id,
              });
              break;
            case "medicoscelulas.configuracion":
              $state.go(route);
              break;

            default:
              $state.go("index.main");
              break;
          }
        } else {
          $state.go(route);
        }
      };

      $scope.deleteTab = function (index) {
        if (appStates.states.length == 1) return;
        if (index || index == 0) {
          appStates.states.splice(index, 1);
          console.log(
            "------x-x-x-----",
            index,
            appStates.states[appStates.states.length - 1],
            appStates
          );
          $state.go(appStates.states[appStates.states.length - 1].route);
        }
      };

      $scope.addTab = function () {
        appStates.states.push({
          name: "Dashboard",
          heading: "Dashboard",
          route: "index.main",
          active: true,
          isVisible: true,
          href: $state.href("index.main"),
        });
      };
    },
  ]);

  app.directive("ngRightClick", function ($parse) {
    return function (scope, element, attrs) {
      var fn = $parse(attrs.ngRightClick);
      element.bind("contextmenu", function (event) {
        scope.$apply(function () {
          event.preventDefault();
          fn(scope, { $event: event });
        });
      });
    };
  });
})();

(function (angular) {
  "use strict";
  var app = angular.module("inspinia");
  app.directive("limitToDecimals", function () {
    return {
      restrict: "A",
      require: "ngModel",
      link: function (scope, element, attrs, ngModelCtrl) {
        function fromUser(text) {
          if (text) {
            var transformedInput = text.toString().match(/^\d+(\.\d{0,4})?/);
            if (transformedInput) {
              transformedInput = transformedInput[0];
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }
            return parseFloat(transformedInput || 0);
          }
          return undefined;
        }
        ngModelCtrl.$parsers.push(fromUser);
      },
    };
  });
})(window.angular);

(function (angular) {
  "use strict";

  var app = angular.module("inspinia");

  app.directive("cellHighlight", function () {
    return {
      restrict: "C",
      link: function postLink(scope, iElement, iAttrs) {
        iElement
          .find("td")
          .mouseover(function () {
            $(this).parent("tr").css("opacity", "0.7");
          })
          .mouseout(function () {
            $(this).parent("tr").css("opacity", "1.0");
          });
      },
    };
  });

  app.directive("context", [
    function () {
      return {
        restrict: "A",
        scope: "@&",
        compile: function compile(tElement, tAttrs, transclude) {
          return {
            post: function postLink(scope, iElement, iAttrs, controller) {
              var ul = $("#" + iAttrs.context),
                last = null;

              ul.css({
                display: "none",
              });
              $(iElement).bind("contextmenu", function (event) {
                event.preventDefault();
                ul.css({
                  position: "fixed",
                  display: "block",
                  left: event.clientX + "px",
                  top: event.clientY + "px",
                });
                last = event.timeStamp;
              });
              //$(iElement).click(function(event) {
              //  ul.css({
              //    position: "fixed",
              //    display: "block",
              //    left: event.clientX + 'px',
              //    top: event.clientY + 'px'
              //  });
              //  last = event.timeStamp;
              //});

              $(document).click(function (event) {
                var target = $(event.target);
                if (
                  !target.is(".popover") &&
                  !target.parents().is(".popover")
                ) {
                  if (last === event.timeStamp) return;
                  ul.css({
                    display: "none",
                  });
                }
              });
            },
          };
        },
      };
    },
  ]);
})(window.angular);

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("cotizacionController", cotizacionController);

  cotizacionController.$inject = [
    "$state",
    "$localStorage",
    "$parse",
    "$uibModal",
    "FileUploader",
    "$q",
    "helpers",
    "toaster",
    "$scope",
    "$sce",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "PersistenceFactory",
    "$sessionStorage",
    "appStates",
    "$stateParams",
    "$rootScope",
    "datesFactory",
  ];

  function cotizacionController(
    $state,
    $localStorage,
    $parse,
    $uibModal,
    FileUploader,
    $q,
    helpers,
    toaster,
    $scope,
    $sce,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    PersistenceFactory,
    $sessionStorage,
    appStates,
    $stateParams,
    $rootScope,
    datesFactory
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.showQuotation = false;
    $scope.showInfoQuotation = false;
    $scope.showEditInformation = false;
    $scope.life = {};
    $scope.aseguradoras = [];
    $scope.dataToSave = {};
    $scope.autocompleteCarsData = [];
    $scope.years = [];
    $scope.statesArray = [];
    $scope.tipos = [];
    $scope.comments_data_receipt = [];
    $scope.comments_config = {};
    $scope.showBinnacle = false;
    $scope.okFile = 0;
    $scope.sendPdf = 0;
    $scope.filters = {};
    $scope.filters.cadena = "";
    $scope.filters.status = {
      id: 0,
      name: "En trámite/Emitidas",
    };
    $scope.main_comming = $stateParams.main_comming;

    $(".js-example-basic-multiple").select2();

    var vm = this;
    vm.obtenerPaginacion = obtenerPaginacion;
    $scope.userInfo = {
      id: 0,
    };

    vm.isCollapsed = false;

    // Function to toggle the collapse state
    vm.toggleCollapse = function () {
      vm.isCollapsed = !vm.isCollapsed;
    };
    $scope.parentescos = [
      {
        option: "Titular",
        relationship: 1,
      },
      {
        option: "Conyuge",
        relationship: 2,
      },
      {
        option: "Hijo",
        relationship: 3,
      },
    ];

    $scope.sexos = [
      { name: "MASCULINO", value: "M" },
      { name: "FEMENINO", value: "F" },
    ];

    $scope.statuses = {
      Desactivado: 0,
      "En trámite": 1,
      "Emitida.": 2,
      Bateada: 3,
    };
    $scope.statusOptions = [
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "Emitidas",
      },
      {
        id: 3,
        name: "Bateadas",
      },
      {
        id: 0,
        name: "En trámite/Emitidas",
      },
      {
        id: 4,
        name: "Todos",
      },
    ];

    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });
    if ($scope.main_comming) {
      dataFactory.get("ticket/" + vm.id_task).then(function success(response) {
        $scope.ticket = response.data;
        $scope.tickets = [$scope.ticket];
        $scope.openModal($scope.ticket);
        $scope.show_pag_task = false;
        $scope.ticket.involved_task.forEach(function (item) {
          $http.get(item.person).then(function success(respo) {
            item.person = respo.data;
            item.person_info = respo.data;
          });
        });
      });
    }
    $scope.saveFile = function (file) {
      var urls = file.url;
      if (urls == undefined) {
        urls = url.IP + "cotizaciones/" + file.owner + "/archivos/" + file.id;
      }
      $http.patch(urls, { nombre: file.nombre, sensible: file.sensible });
    };

    $scope.tipos_auto = [
      {
        value: 1,
        descr: "Auto",
      },
      {
        value: 2,
        descr: "Moto",
      },
      {
        value: 3,
        descr: "Tracto",
      },
      {
        value: 4,
        descr: "Autobus",
      },
      {
        value: 5,
        descr: "Pick Up",
      },
      {
        value: 6,
        descr: "Camiones hasta 1.5 ton",
      },
      {
        value: 7,
        descr: "Chofer app",
      },
      {
        value: 8,
        descr: "Remolque",
      },
      {
        value: 9,
        descr: "Camiones + 1.5 ton",
      },
    ];

    $scope.tipos_accidentes = [
      {
        value: 46,
        descr: "Familiar",
      },
    ];
    $scope.tipos_vida = [
      {
        descr: "Ahorro",
        value: 47,
      },
      {
        descr: "Vitalicia",
        value: 48,
      },
      {
        descr: "Temporal/Protección",
        value: 49,
      },
    ];

    //Subramo incendio
    $scope.tipos_incendio = [
      {
        value: 1,
        descr: "Familiar",
      },
      {
        value: 2,
        descr: "Casa Habitación",
      },
      {
        value: 3,
        descr: "Condominio",
      },
      {
        value: 4,
        descr: "Edificio",
      },
      {
        value: 5,
        descr: "Empresarial",
      },
      {
        value: 6,
        descr: "Múltiple Empresarial",
      },
      {
        value: 10,
        descr: "Sólo Incendio",
      },
    ];
    //Subramo MYT
    $scope.tipos_maritimo = [
      {
        value: 46,
        descr: "Avión",
      },
      {
        value: 47,
        descr: "Avioneta",
      },
      {
        value: 48,
        descr: "Barco",
      },
      {
        value: 49,
        descr: "Buque",
      },
      {
        value: 9,
        descr: "Declaración",
      },
      {
        value: 50,
        descr: "Dron",
      },
      {
        value: 51,
        descr: "Embarcación de Placer",
      },
      {
        value: 7,
        descr: "Específica",
      },
      {
        value: 52,
        descr: "Helicóptero",
      },
      {
        value: 35,
        descr: "Otro",
      },
      {
        value: 8,
        descr: "Pronóstico",
      },
    ];
    //Subramo AyC
    $scope.tipos_agricola = [
      {
        value: 11,
        descr: "Animales",
      },
      {
        value: 12,
        descr: "Cultivo",
      },
    ];
    //Subramo Credito
    $scope.tipos_credito = [
      {
        value: 13,
        descr: "Crédito General",
      },
    ];
    //Subramo Credito Vivienda
    $scope.tipos_vivienda = [
      {
        value: 14,
        descr: "Crédito a la Vivienda",
      },
    ];
    $scope.tipos_garantia_financiera = [
      {
        value: 15,
        descr:
          "Documentos que sean objeto de oferta pública o de intermediación en mercados de valores",
      },
      {
        value: 16,
        descr: "Emisores de Valores",
      },
      {
        value: 17,
        descr: "Títulos de Crédito",
      },
    ];
    //Subramo RC
    $scope.tipos_rc = [
      {
        value: 18,
        descr: "Administración",
      },
      {
        value: 19,
        descr: "Arquitectos",
      },
      {
        value: 20,
        descr: "Aviones",
      },
      {
        value: 21,
        descr: "Barcos",
      },
      {
        value: 22,
        descr: "Contratista",
      },
      {
        value: 23,
        descr: "Crime",
      },
      {
        value: 24,
        descr: "Cyber Protección de datos)",
      },
      {
        value: 25,
        descr: "D&O Consejeros y Funcionarios)",
      },
      {
        value: 26,
        descr: "E&O Miscelaneos",
      },
      {
        value: 27,
        descr: "Empresarial",
      },
      {
        value: 28,
        descr: "Eventos",
      },
      {
        value: 29,
        descr: "Familiar/Condominal",
      },
      {
        value: 30,
        descr: "Hole in One",
      },
      {
        value: 31,
        descr: "Ingeniería",
      },
      {
        value: 32,
        descr: "Instituciones Financieras",
      },
      {
        value: 33,
        descr: "Lineas Financieras",
      },
      {
        value: 34,
        descr: "Médicos",
      },
      {
        value: 35,
        descr: "Otro",
      },
    ];
    //Subramo riesgos cat
    $scope.tipos_catastroficos = [
      {
        value: 36,
        descr: "Riesgos Catastróficos",
      },
    ];
    //Subramo diversos
    $scope.tipos_diversos = [
      {
        value: 37,
        descr: "Calderas y Recipientes Sujetos a Presión",
      },
      {
        value: 38,
        descr: "Dinero y Valores",
      },
      {
        value: 39,
        descr: "Eq. Contratistas y Maquinaria pesada",
      },
      {
        value: 40,
        descr: "Eq. Electrónico",
      },
      {
        value: 41,
        descr: "Montaje de Maquinaria",
      },
      {
        value: 42,
        descr: "Obra Civil en Contrucción",
      },
      {
        value: 43,
        descr: "Obra Civil Terminada",
      },
      {
        value: 44,
        descr: "Rotura de Cristales",
      },
      {
        value: 45,
        descr: "Rotura de Maquinaria",
      },
      {
        value: 35,
        descr: "Otro",
      },
      {
        value: 63,
        descr: "Terrorismo y Sabotaje",
      },
    ];
    //Subramo LF
    $scope.tipos_lineas = [
      {
        value: 53,
        descr: "CRIME/BBB",
      },
      {
        value: 54,
        descr: "D&O",
      },
      {
        value: 55,
        descr: "FIPI",
      },
      {
        value: 56,
        descr: "CYBER",
      },
      {
        value: 57,
        descr: "VCAPS",
      },
      {
        value: 58,
        descr: "RCP MÉDICA",
      },
      {
        value: 59,
        descr: "E&O MISCELANEO",
      },
      {
        value: 60,
        descr: "RIESGO POLITICO",
      },
      {
        value: 61,
        descr: "RC SERVIDORES PUBLICOS",
      },
      {
        value: 62,
        descr: "RCP",
      },
    ];
    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    // $(window).load(function() {
    //   $('.js-example-basic-multiple').select2();
    // });
    $scope.setQuotation = function () {
      $scope.contractorpreSelected = $stateParams
        ? $stateParams.myContractor
        : "";
      $scope.allProviders = [];
      $scope.quotationNew = {
        contratante: {},
        prospecto: 1,
        document_type: 1,
        autos_cotizados: 0,
        inmuebles_cotizados: 0,
        personas_cotizadas: 0,
        type_person: 1,
        life: {
          beneficiariesList: [],
          aseguradosList: [
            {
              first_name: "",
              last_name: "",
              second_last_name: "",
              birthdate: "",
              sex: "",
              antiguedad: "",
              smoker: false,
            },
          ],
        },
        accidents: {
          relationshipList: [],
          first_name: "",
          last_name: "",
          second_last_name: "",
          birthdate: "",
          sex: "",
          antiguedad: "",
          relationships: "",
        },
        danios: {
          coinsurance: "",
          insured_item: "",
          item_details: "",
          item_address: "",
        },
        auto: {
          selectedCar: "",
          driver: "",
          brand: "",
          model: "",
          year: "",
          version: "",
          serial: "",
          engine: "",
          color: "",
          license_plates: "",
          usage: "",
          charge_type: "",
          service: "",
          mont_adjustment: "",
          adjustment: "",
          mont_special_team: "",
          special_team: "",
          beneficiary_name: "",
          beneficiary_address: "",
          beneficiary_rfc: "",
        },
        first_name: "",
        last_name: "",
        second_last_name: "",
        email: "",
        phone: "",
        ramo: "",
        subramo: "",
        tipo: "",
        aseguradora: [],
      };
      if (
        $scope.contractorpreSelected &&
        $scope.contractorpreSelected != "some default"
      ) {
        if ($scope.contractorpreSelected.states) {
          delete $scope.contractorpreSelected.states;
        }
        $scope.quotationNew.contratante.value = $scope.contractorpreSelected;
        $scope.quotationNew.contratante.val =
          $scope.contractorpreSelected.full_name;
        $scope.quotationNew.prospecto = 2;
        $scope.quotationNew.type_person =
          $scope.contractorpreSelected.type_person;
      }
    };
    $scope.setQuotation();
    var actualYear = new Date().getFullYear();
    var oldYear = actualYear - 80;
    for (var i = actualYear + 1; i >= oldYear; i--) {
      $scope.years.push(i);
    }

    $q.when()
      .then(function () {
        var defer = $q.defer();
        defer.resolve(helpers.getStates());
        return defer.promise;
      })
      .then(function (data) {
        $scope.statesArray = data.data;
      });

    $scope.$watch(
      "quotationNew.auto.selectedCar.value",
      function (newValue, oldValue) {
        try {
          $scope.quotationNew.auto.brand =
            $scope.quotationNew.auto.selectedCar.value.car_brand;
          $scope.quotationNew.auto.model =
            $scope.quotationNew.auto.selectedCar.value.car_model;
          $scope.quotationNew.auto.version =
            $scope.quotationNew.auto.selectedCar.value.short_description.replace(
              $scope.quotationNew.auto.selectedCar.value.car_model,
              ""
            );
        } catch (e) {}
      }
    );

    $scope.getmatches = function (word) {
      word = word["val"];
      if (word && word.length >= 3) {
        $http
          .post(url.IP + "cars-match/", { matchWord: word })
          .then(function (response) {
            var source = [];
            if (response.data.length) {
              response.data.forEach(function (cars) {
                var obj = {
                  label: cars.car_search,
                  value: cars,
                };
                source.push(obj);
              });
            } else {
              source.length = 0;
            }
            $scope.autocompleteCarsData = source;
          });
      }
    };

    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    $scope.createQuotation = function () {
      $scope.showQuotation = !$scope.showQuotation;
      $scope.setQuotation();
    };

    $scope.closeQuotation = function () {
      $scope.showQuotation = false;
      console.log($scope.quotationNew);
      if ($scope.quotationNew && $scope.quotationNew.url) {
        $scope.quotation = $scope.quotationNew;
        try {
          $scope.quotation.ramo = $scope.quotation.ramo
            ? JSON.parse(
                unicodeToChar($scope.quotation.ramo.replaceAll("'", '"'))
              )["name"]
            : "";
          $scope.quotation.subramo = $scope.quotation.subramo
            ? JSON.parse(
                unicodeToChar($scope.quotation.subramo.replaceAll("'", '"'))
              )["name"]
            : "";

          // $scope.quotation.ramo = $scope.quotation.ramo['name'];
          // $scope.quotation.subramo = $scope.quotation.subramo['name'];
        } catch (e) {}

        $scope.quotation.aseguradora = $scope.quotation.aseguradora.map(
          function (itemAseg) {
            itemAseg = itemAseg
              .replaceAll('"\\', "")
              .replaceAll('\\"', "")
              .replaceAll("\\\\", "");
            if (itemAseg) {
              itemAseg = unicodeToChar(itemAseg.replaceAll("'", '"'));
              try {
                itemAseg = JSON.parse(itemAseg.substring(1).slice(0, -1))[
                  "alias"
                ];
              } catch (err) {
                itemAseg = JSON.parse(itemAseg)["alias"];
              }
            }
            return itemAseg;
          }
        );
        // var filter_quatation = 'cotizacion-to-show/';

        // dataFactory.get(filter_quatation)
        // .then(function success(response) {
        //     $scope.quotations = response.data.results;
        //     $scope.quotations = $scope.quotations.map(function(item){
        //         item.ramo = item.ramo ? JSON.parse(unicodeToChar(item.ramo.replaceAll('\'','"')))['name'] : '';
        //         item.subramo = item.subramo ? JSON.parse(unicodeToChar(item.subramo.replaceAll('\'','"')))['name'] : '';
        //         item.aseguradora = item.aseguradora.map(function(itemAseg){
        //             itemAseg = itemAseg.replaceAll('"\\','').replaceAll('\\"','').replaceAll('\\\\','')
        //             if (itemAseg){
        //                 itemAseg = unicodeToChar(itemAseg.replaceAll('\'','"'));
        //                 try{
        //                     itemAseg = JSON.parse(itemAseg.substring(1).slice(0, -1))['alias'];
        //                 } catch(err){
        //                     itemAseg = JSON.parse(itemAseg)['alias'];
        //                 }
        //             }
        //             return itemAseg;
        //         })

        //         try{
        //             item.danios = JSON.parse(item.danios);
        //         } catch(err){
        //             try{
        //                 item.danios = JSON.parse(item.danios.replaceAll('\'','"'));
        //             } catch(err){}
        //         }

        //         try{
        //             item.auto = JSON.parse(item.auto);
        //         } catch(err){
        //             try{
        //                 item.auto = JSON.parse(item.auto.replaceAll('\'','"'));
        //             } catch(err){}
        //         }
        //         try{
        //             item.accidents = JSON.parse(item.accidents);
        //         } catch(err){
        //             try{
        //                 item.accidents = JSON.parse(item.accidents.replaceAll('\'','"'));
        //             } catch(err){}
        //         }
        //         try{
        //             item.life = JSON.parse(item.life);
        //         } catch(err){
        //             try{
        //                 item.life = JSON.parse(item.life.replaceAll('\'','"'));
        //             } catch(err){}
        //         }
        //         console.log('item', item);
        //         return item;
        //     });
        //     $scope.quotations.forEach(function(quotation, index){
        //         if (quotation.url == $scope.quotationNew.url){
        //             $scope.quotation = quotation;
        //         }
        //     })
        // })
      } else {
        $scope.setQuotation();
      }
    };

    $scope.addDependiente = function () {
      $scope.quotationNew.accidents["relationshipList"].push({
        first_name: "",
        last_name: "",
        second_last_name: "",
        relationship: "",
        birthdate: "",
        sex: "",
        antiguedad: "",
      });
    };

    $scope.removeDependiente = function (index) {
      $scope.quotationNew.accidents["relationshipList"].splice(index, 1);
    };

    $scope.addAsegurado = function () {
      $scope.quotationNew.life["aseguradosList"].push({
        first_name: "",
        last_name: "",
        second_last_name: "",
        birthdate: "",
        sex: "",
        antiguedad: "",
        smoker: false,
      });
    };

    $scope.removeAsegurado = function (index) {
      $scope.quotationNew.life["aseguradosList"].splice(index, 1);
    };

    $scope.addBeneficiario = function () {
      $scope.quotationNew.life["beneficiariesList"].push({
        person: 1,
        first_name: "",
        last_name: "",
        second_last_name: "",
        optional_relationship: "",
        birthdate: "",
        sex: "",
        antiguedad: "",
        percentage: "",
        j_name: "",
        rfc: "",
      });
    };

    $scope.removeBeneficiario = function (index) {
      $scope.quotationNew.life["beneficiariesList"].splice(index, 1);
    };

    $scope.updateProviders = function () {
      var subramo =
        $scope.quotationNew && $scope.quotationNew.subramo
          ? $scope.quotationNew.subramo.value
          : 0;
      $http
        .get(url.IP + "provider-by-subramo/" + subramo)
        .then(function (response) {
          $scope.allProviders = response.data;
          if (response.data.length == 0) {
            toaster.error("No se encontraron aseguradoras con ese subramo");
          }
        });

      if (
        $scope.quotationNew.ramo.value == 3 &&
        $scope.quotationNew.subramo &&
        $scope.quotationNew.subramo.value == 9
      ) {
        $scope.tipos = $scope.tipos_auto;
      }
      if (
        $scope.quotationNew.ramo.value == 3 &&
        $scope.quotationNew.subramo &&
        $scope.quotationNew.subramo.value == 5
      ) {
        $scope.tipos = $scope.tipos_rc;
      }
      if (
        $scope.quotationNew.ramo.value == 3 &&
        $scope.quotationNew.subramo &&
        $scope.quotationNew.subramo.value == 6
      ) {
        $scope.tipos = $scope.tipos_maritimo;
      }
      if (
        $scope.quotationNew.ramo.value == 3 &&
        $scope.quotationNew.subramo &&
        $scope.quotationNew.subramo.value == 7
      ) {
        $scope.tipos = $scope.tipos_incendio;
      }

      if (
        $scope.quotationNew.ramo.value == 3 &&
        $scope.quotationNew.subramo &&
        $scope.quotationNew.subramo.value == 8
      ) {
        $scope.tipos = $scope.tipos_agricola;
      }

      if (
        $scope.quotationNew.ramo.value == 3 &&
        $scope.quotationNew.subramo &&
        $scope.quotationNew.subramo.value == 10
      ) {
        $scope.tipos = $scope.tipos_credito;
      }

      if (
        $scope.quotationNew.ramo.value == 3 &&
        $scope.quotationNew.subramo &&
        $scope.quotationNew.subramo.value == 11
      ) {
        $scope.tipos = $scope.tipos_vivienda;
      }
      if (
        $scope.quotationNew.ramo.value == 3 &&
        $scope.quotationNew.subramo &&
        $scope.quotationNew.subramo.value == 12
      ) {
        $scope.tipos = $scope.tipos_garantia_financiera;
      }
      if (
        $scope.quotationNew.ramo.value == 3 &&
        $scope.quotationNew.subramo &&
        $scope.quotationNew.subramo.value == 13
      ) {
        $scope.tipos = $scope.tipos_diversos;
      }
      if (
        $scope.quotationNew.ramo.value == 3 &&
        $scope.quotationNew.subramo &&
        $scope.quotationNew.subramo.value == 13
      ) {
        $scope.tipos = $scope.tipos_diversos;
      }
      if (
        $scope.quotationNew.ramo.value == 3 &&
        $scope.quotationNew.subramo &&
        $scope.quotationNew.subramo.value == 14
      ) {
        $scope.tipos = $scope.tipos_catastroficos;
      }

      if ($scope.quotationNew.ramo.value == 1) {
        $scope.tipos = $scope.tipos_vida;
      }

      if ($scope.quotationNew.ramo.value == 2) {
        $scope.tipos = $scope.tipos_accidentes;
        $scope.quotationNew.tipo = $scope.tipos[0];
      }
    };

    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = 0;
      if ($scope.quotationNew.contratante) {
        var word_data = $scope.quotationNew.contratante.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   var filter_contractor = 'v2/contratantes/contractors-match/';
          var filter_contractor = "contractors-match/";
          dataFactory
            .post(filter_contractor, { matchWord: parWord })
            .then(function (response) {
              if (response.status === 200 && response.data.contractors) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
              var matchesContractors_go = true;
            });
        }
      } else {
        $scope.contractors_data = [];
      }
    };

    $scope.ramos = [
      { value: 2, name: "Accidentes y Enfermedades" },
      { value: 3, name: "Daños" },
      { value: 1, name: "Vida" },
    ];

    $scope.changeRamo = function () {
      switch ($scope.quotationNew.ramo.value) {
        case 2:
          $scope.subramos = [
            { value: 2, name: "Accidentes Personales" },
            { value: 3, name: "Gastos Médicos" },
            { value: 4, name: "Salud" },
          ];
          break;
        case 3:
          $scope.subramos = [
            { value: 5, name: "Responsabilidad Civil y Riesgos Profesionales" },
            { value: 6, name: "Marítimo y Trasportes" },
            { value: 7, name: "Incendio" },
            { value: 8, name: "Agricola y Animales" },
            { value: 9, name: "Automóviles" },
            { value: 10, name: "Crédito" },
            { value: 11, name: "Crédito a la Vivienda" },
            { value: 12, name: "Garantía Financiera" },
            { value: 13, name: "Diversos" },
            { value: 14, name: "Terremoto y Otros Riesgos Catastróficos" },
          ];
          break;
        case 1:
          $scope.subramos = [{ value: 1, name: "Vida" }];
          break;
        default:
          $scope.subramos = [];
      }
    };

    function unicodeToChar(text) {
      return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
        return String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16));
      });
    }

    activate();
    function activate(o, a, page) {
      // $scope.filters = {'since':datesFactory.convertDate(new Date()),'until':datesFactory.convertDate(new Date())}
      $scope.quotation = null;
      $scope.countFile = 0;
      $scope.okFile = 0;

      if ($stateParams && $stateParams.polizaId) {
        dataFactory
          .get("leer-cotizacion-info/" + $stateParams.polizaId)
          .then(function (request) {
            $scope.quotationNew = request.data;
            $scope.showInfoQuotation = true;
            $scope.showQuotation = false;
            $scope.quotationNew.ramo = $scope.quotationNew.ramo
              ? JSON.parse(
                  unicodeToChar($scope.quotationNew.ramo.replaceAll("'", '"'))
                )["name"]
              : "";
            $scope.quotationNew.subramo = $scope.quotationNew.subramo
              ? JSON.parse(
                  unicodeToChar(
                    $scope.quotationNew.subramo.replaceAll("'", '"')
                  )
                )["name"]
              : "";
            if ($scope.quotationNew.aseguradora) {
              $scope.quotationNew.aseguradora =
                $scope.quotationNew.aseguradora.map(function (itemAseg) {
                  itemAseg = itemAseg
                    .replaceAll('"\\', "")
                    .replaceAll('\\"', "")
                    .replaceAll("\\\\", "");
                  if (itemAseg) {
                    itemAseg = unicodeToChar(itemAseg.replaceAll("'", '"'));
                    try {
                      itemAseg = JSON.parse(itemAseg.substring(1).slice(0, -1))[
                        "alias"
                      ];
                    } catch (err) {
                      itemAseg = JSON.parse(itemAseg)["alias"];
                    }
                  }
                  return itemAseg;
                });
            }
            $scope.showInformation($scope.quotationNew);
          });
        // showInformation()
      }
      if ($stateParams && $stateParams.myContractor) {
        $scope.createQuotation();
      }
      $scope.data_page = {
        page: page ? page : 1,
      };
      var filter_quatation = "cotizacion-to-show/";
      if (
        $scope.filters &&
        ($scope.filters.since ||
          $scope.filters.until ||
          $scope.filters.cadena ||
          $scope.filters.status)
      ) {
        $scope.quotations = [];
        vm.quotations = $scope.quotations;
        var filter_quatation = "cotizacion-to-show/";
        // var page = 1;
        if ($scope.filters && $scope.filters.status) {
          $scope.filters.status_ok = $scope.filters.status.id;
        }
        if (page) {
          $scope.filters.page = page;
        } else {
          $scope.filters.page = 1;
        }
        dataFactory
          .get("cotizacion-to-show/", $scope.filters)
          .then(function success(response) {
            $scope.filtrosAplicados = true;
            $scope.quotations = response.data.results;
            vm.quotations = $scope.quotations;
            $scope.search_results = {
              count: response.data.count,
              previous: url.IP + filter_quatation,
              next: url.IP + filter_quatation,
            };
            vm.showpag = true;
            vm.obtenerPaginacion(response.data, page ? page : 1);
            //   testPagination('vm.quotations', 'search_results');
            $scope.quotations = $scope.quotations.map(function (item) {
              item.ramo = item.ramo
                ? JSON.parse(unicodeToChar(item.ramo.replaceAll("'", '"')))[
                    "name"
                  ]
                : "";
              item.subramo = item.subramo
                ? JSON.parse(unicodeToChar(item.subramo.replaceAll("'", '"')))[
                    "name"
                  ]
                : "";
              if (item.aseguradora) {
                item.aseguradora = item.aseguradora.map(function (itemAseg) {
                  itemAseg = itemAseg
                    .replaceAll('"\\', "")
                    .replaceAll('\\"', "")
                    .replaceAll("\\\\", "");
                  if (itemAseg) {
                    itemAseg = unicodeToChar(itemAseg.replaceAll("'", '"'));
                    try {
                      itemAseg = JSON.parse(itemAseg.substring(1).slice(0, -1))[
                        "alias"
                      ];
                    } catch (err) {
                      itemAseg = JSON.parse(itemAseg)["alias"];
                    }
                  }
                  return itemAseg;
                });
              }
              return item;
            });
          });
      } else {
        dataFactory
          .post(filter_quatation, $scope.data_page)
          .then(function success(response) {
            $scope.quotations = response.data.results;
            vm.quotations = $scope.quotations;
            $scope.search_results = {
              count: response.data.count,
              previous: url.IP + filter_quatation,
              next: url.IP + filter_quatation,
            };
            vm.showpag = true;
            vm.obtenerPaginacion(response.data, page ? page : 1);
            //   testPagination('vm.quotations', 'search_results');
            $scope.quotations = $scope.quotations.map(function (item) {
              item.ramo = item.ramo
                ? JSON.parse(unicodeToChar(item.ramo.replaceAll("'", '"')))[
                    "name"
                  ]
                : "";
              item.subramo = item.subramo
                ? JSON.parse(unicodeToChar(item.subramo.replaceAll("'", '"')))[
                    "name"
                  ]
                : "";
              if (item.aseguradora) {
                item.aseguradora = item.aseguradora.map(function (itemAseg) {
                  itemAseg = itemAseg
                    .replaceAll('"\\', "")
                    .replaceAll('\\"', "")
                    .replaceAll("\\\\", "");
                  if (itemAseg) {
                    itemAseg = unicodeToChar(itemAseg.replaceAll("'", '"'));
                    try {
                      itemAseg = JSON.parse(itemAseg.substring(1).slice(0, -1))[
                        "alias"
                      ];
                    } catch (err) {
                      itemAseg = JSON.parse(itemAseg)["alias"];
                    }
                  }
                  return itemAseg;
                });
              }
              return item;
            });
          });
      }
      // $scope.getCotizaciones();
      if ($rootScope.from_task) {
        $scope.createQuotation();
      }

      $scope.accesos = $sessionStorage.permisos;
      if ($scope.accesos) {
        $scope.accesos.forEach(function (perm) {
          if (perm.model_name == "Archivos") {
            $scope.permarch = perm;
            $scope.permarch.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  $scope.permiso_archivos = true;
                } else {
                  $scope.permiso_archivos = false;
                }
              } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
              if (acc.permission_name == "Administrar adjuntos") {
                if (acc.checked == true) {
                  $scope.permiso_administrar_adjuntos = true;
                } else {
                  $scope.permiso_administrar_adjuntos = false;
                }
              }
            });
          }
        });
      }
    }

    $scope.openModal = function (task) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/tasks/task.modal.html",
        controller: "TareasModalCtrl",
        size: "lg",
        resolve: {
          task: function () {
            return task;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          receipt: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          //   activate()
        },
        function () {
          console.info("modal closed");
        }
      );
    };
    // nueva paginación inicial
    function obtenerPaginacion(pagesdata, pagina) {
      $scope.paginacion = {
        count: pagesdata["count"],
        previous: pagesdata["previous"],
        next: pagesdata["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    }

    $scope.selecionPagina = function (pagina) {
      activate(1, 1, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        activate(1, 1, $scope.paginacion["paginaActual"] - 1);
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        activate(1, 1, $scope.paginacion["paginaActual"] + 1);
      }
    };
    $scope.updatePrimaAseguradora = function (quotation) {
      $http.patch(quotation.url, quotation).then(function success(response) {
        console.log(response);
      });
    };

    $scope.selectProv = function (sel) {
      $scope.aseguradoras = sel;
    };
    $scope.editar = function () {};

    $scope.saveFiles = function (cotizacion) {
      $scope.okFile = 0;
      $scope.countFile = $scope.uploader.queue.length;
      uploadFiles(cotizacion);
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      // console.log(item);
      item.url = $scope.uploader.url;
      var formData = new FormData();
      formData.append("arch", item._file);
      formData.append("nombre", item.file.name);
      formData.append("owner", $scope.userInfo.id);
      item.formData.push(formData);
    };
    $http.get(url.IP + "get-vendors/").then(function (user) {
      $scope.referenciador = user.data;
      $scope.referenciador.forEach(function (user) {
        user.first_name = user.first_name.toUpperCase();
        user.last_name = user.last_name.toUpperCase();
      });
    });
    $scope.deleteQuatation = function (url, index) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este registro\n (Eliminación permanente)",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "DELETE",
              url: url,
            }).then(function success(response) {
              if (response.status == 204) {
                SweetAlert.swal(
                  "¡Eliminado!",
                  "El registro fue eliminado.",
                  "success"
                );
                $scope.quotations.splice(index, 1);
                activate();
              }
            });
          }
        }
      );
    };

    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.files.push(response);
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal(
          "¡Listo!",
          "Archivos cargados exitosamente.",
          "success"
        );
        $scope.uploader.queue = [];
        $state.reload();
      }
    };

    function uploadFiles(cotizacionId) {
      $scope.userInfo = {
        id: cotizacionId,
      };
      $scope.countFile = $scope.uploader.queue.length;
      $scope.uploader.url =
        url.IP + "cotizaciones/" + cotizacionId + "/archivos/";
      $scope.uploader.removeAfterUpload = true;
      $scope.uploader.onCompleteAll = function () {
        $scope.uploader.clearQueue();
      };
      $scope.uploader.uploadAll();
    }

    $scope.deleteFile = function (file, container) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este archivo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "DELETE",
              url: file.url,
            }).then(function success(response) {
              if (response.status == 204) {
                SweetAlert.swal(
                  "¡Eliminado!",
                  "El archivo fue eliminado.",
                  "success"
                );
                container.splice(container.indexOf(file), 1);
              }
            });
          }
        }
      );
    };

    $scope.showInformation = function (item) {
      $scope.okFile = 0;
      $scope.files = [];
      $scope.quotation = null;
      if (item) {
        $scope.showQuotation = false;
        $scope.showInfoQuotation = true;
        $scope.quotation = item;
        if (
          item.ramo == "Accidentes y Enfermedades" &&
          item.document_type == 1
        ) {
          try {
            $scope.quotation.accidents = JSON.parse(
              item.accidents.replaceAll("'", '"')
            );
          } catch (u) {}
        }
        if (item.ramo == "Vida" && item.document_type == 1) {
          try {
            $scope.quotation.life = JSON.parse(item.life.replaceAll("'", '"'));
          } catch (u) {}
        }
        if (item.ramo == "Daños" && item.document_type == 1) {
          if (item.subramo == "Automóviles") {
            try {
              $scope.quotation.auto = JSON.parse(
                item.auto.replaceAll("'", '"')
              );
            } catch (u) {}
          } else {
            try {
              $scope.quotation.danios = JSON.parse(
                item.danios.replaceAll("'", '"')
              );
            } catch (u) {}
          }
        }
        $scope.show_binnacle = true;
        $scope.files = [];
        $http
          .get(url.IP + "cotizaciones/" + item.id + "/archivos/")
          .then(function (response) {
            if (response.status === 200) {
              $scope.files = response.data.results;
              $scope.files = response.data.results;
              $scope.show_files_policy = true;
            } else if (response.status === 403) {
              $scope.show_files_policy = false;
            }
          });

        $http({
          method: "GET",
          url: url.IP + "comments/",
          params: {
            model: 30,
            id_model: item.id,
          },
        })
          .then(function (request) {
            $scope.comments_data = request.data.results;
            $scope.comments_config = {
              count: request.data.count,
              previous: request.data.previous,
              next: request.data.next,
            };
          })
          .catch(function (e) {
            console.log("e", e);
          });
      } else {
        $stateParams = {};
        $state.reload();
        $state.go("cotizacion.cotizacion", { polizaId: "" });
        dataFactory.get("cotizacion-to-show/").then(function success(response) {
          activate(0, 0, 1);
          $scope.showInfoQuotation = !$scope.showInfoQuotation;
        });
      }
    };
    $scope.changeSince = function () {
      $scope.filtrosAplicados = false;
    };
    $scope.changeUntil = function () {
      $scope.filtrosAplicados = false;
    };
    $scope.filtrosAplicados = false;
    $scope.getCotizaciones = function () {
      if (
        $scope.filters &&
        ($scope.filters.since ||
          $scope.filters.until ||
          $scope.filters.cadena ||
          $scope.filters.status)
      ) {
        $scope.quotations = [];
        vm.quotations = $scope.quotations;
        var filter_quatation = "cotizacion-to-show/";
        var page = 1;
        if ($scope.filters && $scope.filters.status) {
          $scope.filters.status_ok = $scope.filters.status.id;
        }
        dataFactory
          .get("cotizacion-to-show/", $scope.filters)
          .then(function success(response) {
            $scope.filtrosAplicados = true;
            $scope.quotations = response.data.results;
            vm.quotations = $scope.quotations;
            $scope.search_results = {
              count: response.data.count,
              previous: url.IP + filter_quatation,
              next: url.IP + filter_quatation,
            };
            vm.showpag = true;
            vm.obtenerPaginacion(response.data, page ? page : 1);
            //   testPagination('vm.quotations', 'search_results');
            $scope.quotations = $scope.quotations.map(function (item) {
              item.ramo = item.ramo
                ? JSON.parse(unicodeToChar(item.ramo.replaceAll("'", '"')))[
                    "name"
                  ]
                : "";
              item.subramo = item.subramo
                ? JSON.parse(unicodeToChar(item.subramo.replaceAll("'", '"')))[
                    "name"
                  ]
                : "";
              if (item.aseguradora) {
                item.aseguradora = item.aseguradora.map(function (itemAseg) {
                  itemAseg = itemAseg
                    .replaceAll('"\\', "")
                    .replaceAll('\\"', "")
                    .replaceAll("\\\\", "");
                  if (itemAseg) {
                    itemAseg = unicodeToChar(itemAseg.replaceAll("'", '"'));
                    try {
                      itemAseg = JSON.parse(itemAseg.substring(1).slice(0, -1))[
                        "alias"
                      ];
                    } catch (err) {
                      itemAseg = JSON.parse(itemAseg)["alias"];
                    }
                  }
                  return itemAseg;
                });
              }
              return item;
            });
          });
      } else {
        activate();
      }
    };

    $scope.has_sr_conf = false;
    $scope.filtrosSubramos = function () {
      var modalInstance = $uibModal.open({
        templateUrl: "app/modals/filtro_subramos_cotizaciones.html",
        controller: FiltrosSubramosCotizacionesModalCtrl,
        size: "md",
        resolve: {},
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (result) {
        var payload = result.map(function (item) {
          return item.subramo_code;
        });

        if ($sessionStorage.token !== undefined) {
          $http
            .post(url.IP + "filtros-subramos-cotizaciones/", {
              subramos: payload,
            })
            .then(function (response) {
              toaster.success("Información actualizada");
            });
        }
      });
    };

    function FiltrosSubramosCotizacionesModalCtrl($scope, $uibModalInstance) {
      $scope.subramos_toselected = [
        {
          subramo_code: 9,
          subramo_name: "Automóviles",
        },
        {
          subramo_code: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          subramo_code: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          subramo_code: 1,
          subramo_name: "Vida",
        },
        {
          subramo_code: 7,
          subramo_name: "Incendio",
        },
        {
          subramo_code: 4,
          subramo_name: "Salud",
        },
        {
          subramo_code: 10,
          subramo_name: "Crédito",
        },
        {
          subramo_code: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          subramo_code: 13,
          subramo_name: "Diversos",
        },
        {
          subramo_code: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          subramo_code: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          subramo_code: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          subramo_code: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          subramo_code: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
      ];
      $scope.cancel = cancel;
      $scope.saveConfig = saveConfig;
      $scope.ramos = [];
      if ($sessionStorage.token !== undefined) {
        $http
          .get(url.IP + "filtros-subramos-cotizaciones/")
          .then(function (response) {
            response.data.data.forEach(function (item) {
              $scope.subramos_toselected.forEach(function (sr) {
                if (sr["subramo_code"] == item) {
                  $scope.ramos.push(sr);
                }
              });
            });
          });
      }
      $(".js-example-basic-multiple").select2();

      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }

      function saveConfig() {
        $uibModalInstance.close($scope.ramos);
      }
    }
    $scope.llenarAsegurado = function (quotation) {
      if (
        !$scope.quotationNew.contratante &&
        $scope.quotationNew.prospecto == "2"
      ) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CONTRACTORERROR, "error");
        return;
      }
      if (
        !$scope.quotationNew.first_name &&
        $scope.quotationNew.prospecto == "1"
      ) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CONTRACTORERROR, "error");
        return;
      }
      if (
        $scope.quotationNew.contratante &&
        $scope.quotationNew.contratante.val &&
        $scope.quotationNew.contratante.value &&
        $scope.quotationNew.prospecto == "2"
      ) {
        $scope.quotationNew.life.aseguradosList[0].first_name =
          $scope.quotationNew.contratante.value.first_name;
        $scope.quotationNew.life.aseguradosList[0].last_name =
          $scope.quotationNew.contratante.value.last_name;
        $scope.quotationNew.life.aseguradosList[0].second_last_name =
          $scope.quotationNew.contratante.value.second_last_name;
        $scope.quotationNew.life.aseguradosList[0].birthdate = $scope
          .quotationNew.contratante.value.birth_date
          ? datesFactory.convertDate(
              $scope.quotationNew.contratante.value.birth_date
            )
          : datesFactory.convertDate(new Date());
        $scope.quotationNew.life.aseguradosList[0].sex =
          $scope.quotationNew.contratante.value.sex;
      } else {
        $scope.quotationNew.life.aseguradosList[0].first_name =
          $scope.quotationNew.first_name;
        $scope.quotationNew.life.aseguradosList[0].last_name =
          $scope.quotationNew.last_name;
        $scope.quotationNew.life.aseguradosList[0].second_last_name =
          $scope.quotationNew.second_last_name;
      }
    };
    $scope.fillContractorData = function (quotation) {
      if (
        !$scope.quotationNew.contratante &&
        $scope.quotationNew.prospecto == "2"
      ) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CONTRACTORERROR, "error");
        return;
      }
      if (
        !$scope.quotationNew.first_name &&
        $scope.quotationNew.prospecto == "1"
      ) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CONTRACTORERROR, "error");
        return;
      }
      if (
        $scope.quotationNew.contratante &&
        $scope.quotationNew.contratante.val &&
        $scope.quotationNew.contratante.value &&
        $scope.quotationNew.prospecto == "2"
      ) {
        $scope.quotationNew.accidents.first_name =
          $scope.quotationNew.contratante.value.first_name;
        $scope.quotationNew.accidents.last_name =
          $scope.quotationNew.contratante.value.last_name;
        $scope.quotationNew.accidents.second_last_name =
          $scope.quotationNew.contratante.value.second_last_name;
        $scope.quotationNew.accidents.birthdate = $scope.quotationNew
          .contratante.value.birth_date
          ? datesFactory.convertDate(
              $scope.quotationNew.contratante.value.birth_date
            )
          : datesFactory.convertDate(new Date());
        $scope.quotationNew.accidents.sex =
          $scope.quotationNew.contratante.value.sex;
      } else {
        $scope.quotationNew.accidents.first_name =
          $scope.quotationNew.first_name;
        $scope.quotationNew.accidents.last_name = $scope.quotationNew.last_name;
        $scope.quotationNew.accidents.second_last_name =
          $scope.quotationNew.second_last_name;
      }
    };
    $scope.getLog = function (id) {
      dataFactory
        .get("get-specific-log", { model: 30, associated_id: id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {});
        });
    };

    $scope.saveDelivery = function (form) {
      if ($scope.quotationNew.prospecto == 1) {
        if ($scope.quotationNew.first_name == "") {
          SweetAlert.swal(
            "¡Error!",
            "El campo 'nombre' es obligatorio ",
            "error"
          );
          return;
        }
        if (
          $scope.quotationNew.last_name == "" &&
          $scope.quotationNew.type_person == 1
        ) {
          SweetAlert.swal(
            "¡Error!",
            "El campo 'apellido paterno' es obligatorio",
            "error"
          );
          return;
        }
      } else if ($scope.quotationNew.prospecto == 2) {
        if (
          $scope.quotationNew.contratante &&
          !$scope.quotationNew.contratante["value"]
        ) {
          SweetAlert.swal(
            "¡Error!",
            "El campo 'contratante' es obligatorio",
            "error"
          );
          return;
        }
      } else {
        return;
      }

      if ($scope.quotationNew.ramo == "") {
        SweetAlert.swal("¡Error!", "El campo 'ramo' es obligatorio", "error");
        return;
      }
      if ($scope.quotationNew.subramo == "") {
        SweetAlert.swal(
          "¡Error!",
          "El campo 'subramo' es obligatorio",
          "error"
        );
        return;
      }

      if ($scope.quotationNew.aseguradora.length == 0) {
        SweetAlert.swal(
          "¡Error!",
          "El campo 'aseguradora(s)' es obligatorio",
          "error"
        );
        return;
      }

      if ($scope.quotationNew.tipo == "") {
        SweetAlert.swal("¡Error!", "El campo 'tipo' es obligatorio", "error");
        return;
      }
      $scope.aseguradora_nueva = [];
      var aux_aseguradoras = [];
      $scope.quotationNew.aseguradora.forEach(function (item) {
        var response = {
          id: item.id,
          compania: item.compania,
          alias: item.alias,
        };
        aux_aseguradoras.push(item.alias);
        $scope.aseguradora_nueva.push(response);
      });
      $scope.quotationNew.aseguradora = $scope.aseguradora_nueva;
      $scope.quotationNew.referenciador = $scope.quotationNew.referenciador;
      if ($scope.quotationNew.prospecto == 2) {
        $scope.quotationNew["contractor"] = $scope.quotationNew.contratante
          ? $scope.quotationNew.contratante.value.url
          : undefined;
        $scope.quotationNew["last_name"] = "";
        $scope.quotationNew["first_name"] = "";
        $scope.quotationNew["second_last_name"] = "";
        $scope.quotationNew["email"] = "";
        $scope.quotationNew["phone"] = "";
      } else if ($scope.quotationNew.prospecto == 1) {
        $scope.quotationNew["contractor"] = null;
        $scope.quotationNew["contratante"] = {};
        if ($scope.quotationNew["type_person"] == 2) {
          $scope.quotationNew["full_name"] = $scope.quotationNew["first_name"];
        }
      }
      if ($scope.quotationNew && $scope.quotationNew.url) {
        $scope.quotationNew["is_complete"] = true;
        $scope.quotationNew.status =
          $scope.statuses[$scope.quotationNew.status];
        $http
          .patch($scope.quotationNew.url, $scope.quotationNew)
          .then(function success(response) {
            // SweetAlert.swal("¡Listo!", MESSAGES.OK.QUOTATIONCREATE, "success");
            // // $scope.closeQuotation();
            // $scope.showInfoQuotation = true;
            // $scope.showQuotation =false;
            // // activate();
            // $scope.quotationNew = response.data
            // $scope.showInformation(response.data);
            dataFactory
              .get("leer-cotizacion-info/" + response.data.id)
              .then(function (request) {
                $scope.quotationNew = request.data;
                $scope.showInfoQuotation = false;
                $scope.showQuotation = false;
                $scope.closeQuotation();
                $scope.showInformation($scope.quotationNew);
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.QUOTATIONCREATE,
                  "success"
                );
                // activate();
              });
          });
      } else {
        $scope.quotationNew["is_complete"] = true;
        if (
          $rootScope.from_task &&
          $rootScope.task_associated &&
          $rootScope.task_associated.url
        ) {
          $scope.quotationNew.from_task = $rootScope.from_task;
          $scope.quotationNew.task_associated = $rootScope.task_associated.id;
        }
        dataFactory
          .post("cotizacion/", $scope.quotationNew)
          .then(
            function success(response) {
              uploadFiles(response.data.id);
              if (
                $rootScope.from_task &&
                $rootScope.task_associated &&
                $rootScope.task_associated.url
              ) {
                $http.patch($rootScope.task_associated.url, {
                  ot_model: 3,
                  ot_id_reference: response.data.id,
                });
                $rootScope.from_task = false;
              }
              var lenauxa = 0;
              aux_aseguradoras.forEach(function (aseguradora_nueva) {
                dataFactory.post("primas-cotizacion/", {
                  aseguradora: aseguradora_nueva,
                  cotizacion: response.data.url,
                });
                lenauxa = lenauxa + 1;
              });
              if (lenauxa == aux_aseguradoras.length) {
                dataFactory
                  .get("leer-cotizacion-info/" + response.data.id)
                  .then(function (request) {
                    $scope.quotationNew = request.data;
                    $scope.showInfoQuotation = true;
                    $scope.showQuotation = false;
                    $scope.closeQuotation();
                    $scope.showInformation($scope.quotationNew);
                    SweetAlert.swal(
                      "¡Listo!",
                      MESSAGES.OK.QUOTATIONCREATE,
                      "success"
                    );
                  });
              }
            },
            function (error) {
              SweetAlert.swal("¡Error!", "Ha ocurrido un error", "error");
              return;
            }
          )
          .catch(function (error) {
            SweetAlert.swal("¡Error!", "Ha ocurrido un error", "error");
            return;
          });
      }
    };

    $scope.loadMail = function (item) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/cotizacion/modal.email.html",
        controller: assignModalView,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          quote: function () {
            return item;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };
    function assignModalView(
      $scope,
      $uibModalInstance,
      quote,
      url,
      FileUploader,
      $q
    ) {
      var vmm = this;
      var share_via_email = [];
      var share_via_email_r = [];
      vmm.is_owner = false;
      vmm.email_assign_mail = "";
      vmm.custom_email = false;
      vmm.htmlVariable = "";
      vmm.first_comment = "";
      vmm.second_comment = "";
      vmm.correos = [];
      $scope.send = true;
      vmm.quote = quote;
      vmm.aseguradoras = [];

      vmm.quote.aseguradora.forEach(function (item, index) {
        vmm.aseguradoras.push({
          aseguradora: item,
          contactos: [],
        });
      });
      /* Uploader files */
      $scope.userInfo = {
        id: 0,
      };
      $scope.countFile = 0;
      $scope.okFile = 0;

      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      //     name: 'customFilter',
      //     fn: function(item, options) {
      //         return this.queue.length < 20;
      //     }
      // });
      uploader.onBeforeUploadItem = function (item) {
        if (item.file.sensible != undefined) {
          item.formData[0].sensible = item.file.sensible;
        }

        // console.log(item);
        item.url = $scope.uploader.url;
        var formData = new FormData();
        formData.append("arch", item._file);
        formData.append("nombre", item.file.name);
        formData.append("owner", $scope.userInfo.id);
        item.formData.push(formData);
      };
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $scope.files.push(response);
        $scope.okFile++;
        if ($scope.okFile == $scope.uploader.queue.length) {
          SweetAlert.swal(
            "¡Listo!",
            "Archivos cargados exitosamente.",
            "success"
          );
          $scope.uploader.queue = [];
        }
      };
      $scope.saveFile = function (file) {
        var urls = file.url;
        if (urls == undefined) {
          urls = url.IP + "cotizaciones/" + file.owner + "/archivos/" + file.id;
        }
        $http.patch(urls, { nombre: file.nombre, sensible: file.sensible });
      };
      function uploadFilesEmail(cotizacionId) {
        $scope.userInfo = {
          id: cotizacionId,
        };
        $scope.userInfo.url = $scope.uploader.url =
          url.IP + "cotizaciones/" + cotizacionId + "/archivos/";
        $scope.uploader.url =
          url.IP + "cotizaciones/" + cotizacionId + "/archivos/";
        $scope.uploader.removeAfterUpload = true;
        // $scope.uploader.uploadAll();
        $q.when()
          .then(function () {
            var defer = $q.defer();
            defer.resolve($scope.uploader.uploadAll());
            return defer.promise;
          })
          .then(function () {
            toaster.success("Se han subido sus archivos correctamente");
          });
      }
      $scope.saveFilesEmail = function (id) {
        $scope.idquote = vmm.quote.id;
        $scope.countFile = $scope.uploader.queue.length;
        uploadFilesEmail($scope.idquote);
      };

      $scope.load_provider_contacts = function (flag) {
        if (flag) {
          vmm.aseguradoras.forEach(function (item) {
            $http({
              method: "GET",
              url: url.IP + "provider-contact",
              params: {
                provider: item.aseguradora,
                ramo: vmm.quote.ramo,
                subramo: vmm.quote.subramo,
              },
            }).then(function (response) {
              item["contactos"] = response.data;
            });
          });
        } else {
          vmm.aseguradoras.map(function (item) {
            if (item && item.contactos) {
              item.contactos.map(function (item_contacto) {
                item_contacto.checked_email = false;
                return item_contacto;
              });
            }
            return item;
          });
          console.log(vmm.aseguradoras);
        }
      };
      $scope.showEmailInInput = function () {};

      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      $scope.emails = [];

      $scope.addEmail = function (email) {
        if (validateEmail(email) == false) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        } else {
          if ($scope.emails.indexOf(email) < 0) {
            $scope.emails.push(email);
          } else {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.REPEATEMAIL, "error");
          }
          vmm.email_assign_mail = "";
        }
      };
      $scope.remove_email = function (index) {
        $scope.emails.splice(index, 1);
      };

      $scope.check = function (item) {
        $scope.sendPdf = item;
      };
      $scope.sendEmail = function (receipt) {
        $scope.send = false;
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        var emails_aseguradora = [];
        vmm.aseguradoras.forEach(function (item_aseguradora) {
          if (item_aseguradora && item_aseguradora.contactos) {
            item_aseguradora.contactos.forEach(function (item_contacto) {
              if (item_contacto && item_contacto.checked_email) {
                emails_aseguradora.push(item_contacto.email);
              }
            });
          }
        });

        $http({
          method: "POST",
          url: url.IP + "get-pdf-cotizacion/",
          data: {
            cotizacion: quote.id,
          },
        }).then(function success(response) {
          $scope.pdf = response.data;
          var data_shared = {
            id: quote.id,
            emails: $scope.emails,
            emails_aseguradora: emails_aseguradora,
            files: share_via_email,
            files_r: share_via_email_r,
            first_comment: vmm.first_comment,
            second_comment: vmm.second_comment,
            model: 30,
            custom_email: vmm.custom_email,
            pdf_name: $scope.pdf["pdf_name"],
            sendPdf: $scope.sendPdf ? $scope.sendPdf : false,
          };

          $http
            .post(url.IP + "share-cotizacion-manual/", data_shared)
            .then(
              function success(request) {
                l.stop();
                SweetAlert.swal(
                  "¡Listo!",
                  "Se ha compartido la cotización satisfactoriamente.",
                  "success"
                );
                $scope.send = true;
                var params = {
                  model: 30,
                  event: "POST",
                  associated_id: quote.id,
                  identifier: "compartió la cotización por email.",
                  save_logmail: 1,
                };
                dataFactory.post("send-log/", params);
                $scope.send = true;
                $uibModalInstance.dismiss("cancel");
              },
              function error(error) {
                l.stop();
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
              l.stop();
            });
        });
      };

      $scope.getTemplate = function (custom_email) {
        if (custom_email) {
          $http
            .get(url.IP + "share-policy-manual/" + vm.insurance.id)
            .then(function (response) {
              if (response.status === 200) {
                vmm.head = response.data.head;
                vmm.body = response.data.body;
                vmm.footer = response.data.footer;
              }
            })
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          vmm.htmlVariable = "";
          vmm.first_comment = "";
          vmm.second_comment = "";
        }
      };

      $scope.deleteEmail = function (email) {
        $http({
          method: "GET",
          url: url.IP + "delete-assign/",
          params: {
            id: email.id,
          },
        })
          .then(function (request) {
            $scope.people_assigned.splice(
              $scope.people_assigned.indexOf(email),
              1
            );
            assignModalView($scope, $uibModalInstance, vm.insurance.id, url);
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };
      $http
        .get(url.IP + "cotizaciones/" + quote.id + "/archivos/")
        .then(function (response) {
          $scope.files = response.data.results;
          $scope.files.forEach(function (file) {
            file["to_send"] = false;
            file["origin"] = "P";
          });
        });
      $scope.shareFileEmail = function (file) {
        if (file.to_send) {
          file.to_send = false;
        } else {
          file.to_send = true;
        }
        share_via_email = [];
        share_via_email_r = [];
        $scope.files.forEach(function (filex) {
          if (filex.to_send && filex.origin == "P") {
            share_via_email.push(filex.id);
          }
          if (filex.to_send && filex.origin == "R") {
            share_via_email_r.push(filex.id);
          }
        });
      };

      $scope.shareFile = function (file) {
        $http
          .get(url.IP + "patch-policy-file/" + file.id)
          .then(function (response) {
            $scope.files.some(function (filex) {
              if (filex.id == response.data.id) {
                filex.shared = response.data.shared;
              }
            });
            $scope.files[file] = response.data;
            // $scope.shared = response.data.shared;
          });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.changeStatus = function (item, parStat) {
      if (parStat == 2) {
        var modalInstance = $uibModal.open({
          templateUrl: "app/cotizacion/modal.emitir.html",
          controller: EmitirCotizacion,
          controllerAs: "vmm",
          size: "sm",
          resolve: {
            aseguradoras: function () {
              return item.aseguradora;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        modalInstance.result.then(function (result) {
          $http
            .patch(item.url, {
              aseguradora_seleccionada: result["aseguradora"],
              status: parStat,
            })
            .then(function success(response) {
              if (response.status == 200) {
                SweetAlert.swal(
                  "Hecho",
                  MESSAGES.OK.QUOTATIONCHANGE,
                  "success"
                );
              }
            });
          activate();
          $scope.showInformation(item);
        });
        modalInstance.result.catch(function (result) {
          console.log("result catch", result);
        });
        function EmitirCotizacion(
          aseguradoras,
          $scope,
          $uibModalInstance,
          toaster
        ) {
          var vmm = this;

          vmm.aseguradoras = aseguradoras;
          vmm.aseguradora_seleccionada = "";

          function guardar(comision) {
            $uibModalInstance.close({
              aseguradora: vmm.aseguradora_seleccionada.toString(),
            });
          }
          vmm.guardar = guardar;

          function close() {
            $uibModalInstance.dismiss("cancel");
          }
          vmm.close = close;
        }
      } else if (parStat == 1) {
        SweetAlert.swal(
          {
            title: "Desbatear",
            text:
              "La cotización con ID: " +
              item.id +
              " será restablecida al estado 'En Trámite'.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Hecho",
            cancelButtonText: "Cancelar",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http
                .patch(item.url, { status: parStat })
                .then(function success(response) {
                  if (response.status == 200) {
                    SweetAlert.swal(
                      "Hecho",
                      MESSAGES.OK.QUOTATIONCHANGE,
                      "success"
                    );
                    activate();
                  }
                })
                .catch(function error(error) {
                  SweetAlert.swal(
                    "Error",
                    "No se pudo actualizar la cotización.",
                    "error"
                  );
                });
            }
          }
        );
      } else {
        $http
          .patch(item.url, { status: parStat })
          .then(function success(response) {
            if (response.status == 200) {
              SweetAlert.swal("Hecho", MESSAGES.OK.QUOTATIONCHANGE, "success");
              activate();
            }
          });
        activate();
        // $scope.showInformation(null);
      }
    };

    $scope.getCotizacionPDF = function (quotation) {
      $http({
        method: "POST",
        url: url.IP + "get-pdf-cotizacion/",
        data: {
          cotizacion: quotation.id,
        },
      }).then(function success(response) {
        $scope.pdf = response.data;

        $http({
          method: "GET",
          url: url.IP + "get-pdf",
          params: {
            pdf_name: $scope.pdf.pdf_name,
          },
        }).then(function success(response) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
        });
      });
    };

    $scope.editQuatation = function (quote) {
      $scope.quotationNew = quote;
      $scope.ramos.forEach(function (ramo) {
        if (ramo.name === $scope.quotationNew.ramo) {
          $scope.quotationNew.ramo = ramo;
          $scope.changeRamo();
          $scope.subramos.forEach(function (subramo) {
            if (subramo.name === $scope.quotationNew.subramo) {
              $scope.quotationNew.subramo = subramo;
              var subramo_ =
                $scope.quotationNew && $scope.quotationNew.subramo
                  ? $scope.quotationNew.subramo.value
                  : 0;
              $http
                .get(url.IP + "provider-by-subramo/" + subramo_)
                .then(function (response) {
                  $scope.allProviders = response.data;
                  var aux_asegs = [];
                  $scope.allProviders.forEach(function (aseg) {
                    $scope.quotationNew.aseguradora.forEach(function (
                      saved_aseg
                    ) {
                      if (saved_aseg == aseg.alias) {
                        aux_asegs.push(aseg);
                      }
                    });
                  });
                  $scope.quotationNew.aseguradora = aux_asegs;
                });
              if (
                $scope.quotationNew.ramo.value == 3 &&
                $scope.quotationNew.subramo &&
                $scope.quotationNew.subramo.value == 9
              ) {
                $scope.tipos = $scope.tipos_auto;
              }
              if (
                $scope.quotationNew.ramo.value == 3 &&
                $scope.quotationNew.subramo &&
                $scope.quotationNew.subramo.value == 5
              ) {
                $scope.tipos = $scope.tipos_rc;
              }
              if (
                $scope.quotationNew.ramo.value == 3 &&
                $scope.quotationNew.subramo &&
                $scope.quotationNew.subramo.value == 6
              ) {
                $scope.tipos = $scope.tipos_maritimo;
              }
              if (
                $scope.quotationNew.ramo.value == 3 &&
                $scope.quotationNew.subramo &&
                $scope.quotationNew.subramo.value == 7
              ) {
                $scope.tipos = $scope.tipos_incendio;
              }

              if (
                $scope.quotationNew.ramo.value == 3 &&
                $scope.quotationNew.subramo &&
                $scope.quotationNew.subramo.value == 8
              ) {
                $scope.tipos = $scope.tipos_agricola;
              }

              if (
                $scope.quotationNew.ramo.value == 3 &&
                $scope.quotationNew.subramo &&
                $scope.quotationNew.subramo.value == 10
              ) {
                $scope.tipos = $scope.tipos_credito;
              }

              if (
                $scope.quotationNew.ramo.value == 3 &&
                $scope.quotationNew.subramo &&
                $scope.quotationNew.subramo.value == 11
              ) {
                $scope.tipos = $scope.tipos_vivienda;
              }
              if (
                $scope.quotationNew.ramo.value == 3 &&
                $scope.quotationNew.subramo &&
                $scope.quotationNew.subramo.value == 12
              ) {
                $scope.tipos = $scope.tipos_garantia_financiera;
              }
              if (
                $scope.quotationNew.ramo.value == 3 &&
                $scope.quotationNew.subramo &&
                $scope.quotationNew.subramo.value == 13
              ) {
                $scope.tipos = $scope.tipos_diversos;
              }
              if (
                $scope.quotationNew.ramo.value == 3 &&
                $scope.quotationNew.subramo &&
                $scope.quotationNew.subramo.value == 13
              ) {
                $scope.tipos = $scope.tipos_diversos;
              }
              if (
                $scope.quotationNew.ramo.value == 3 &&
                $scope.quotationNew.subramo &&
                $scope.quotationNew.subramo.value == 14
              ) {
                $scope.tipos = $scope.tipos_catastroficos;
              }

              if ($scope.quotationNew.ramo.value == 1) {
                $scope.tipos = $scope.tipos_vida;
              }

              if ($scope.quotationNew.ramo.value == 2) {
                $scope.tipos = $scope.tipos_accidentes;
              }
              if ($scope.quotationNew.tipo) {
                try {
                  $scope.quotationNew.tipo = JSON.parse(
                    $scope.quotationNew.tipo
                  );
                } catch (err) {
                  $scope.quotationNew.tipo = JSON.parse(
                    $scope.quotationNew.tipo.replaceAll("'", '"')
                  );
                }
              }
              $scope.tipos.forEach(function (tipo) {
                if (tipo.value == $scope.quotationNew.tipo.value) {
                  $scope.quotationNew.tipo = tipo;
                }
              });
            }
          });
        }
      });

      try {
        $scope.quotationNew.ramo = JSON.parse($scope.quotationNew.ramo);
      } catch (err) {
        try {
          $scope.quotationNew.ramo = JSON.parse(
            $scope.quotationNew.ramo.replaceAll("'", '"')
          );
        } catch (err) {}
      }

      try {
        $scope.quotationNew.auto = JSON.parse($scope.quotationNew.auto);
      } catch (err) {
        try {
          $scope.quotationNew.auto = JSON.parse(
            $scope.quotationNew.auto.replaceAll("'", '"')
          );
        } catch (err) {}
      }
      try {
        $scope.quotationNew.accidents = JSON.parse(
          $scope.quotationNew.accidents
        );
      } catch (err) {
        try {
          $scope.quotationNew.accidents = JSON.parse(
            $scope.quotationNew.accidents.replaceAll("'", '"')
          );
        } catch (err) {}
      }
      try {
        $scope.quotationNew.life = JSON.parse($scope.quotationNew.life);
      } catch (err) {
        try {
          $scope.quotationNew.life = JSON.parse(
            $scope.quotationNew.life.replaceAll("'", '"')
          );
        } catch (err) {}
      }
      try {
        $scope.quotationNew.danios = JSON.parse($scope.quotationNew.danios);
      } catch (err) {
        try {
          $scope.quotationNew.danios = JSON.parse(
            $scope.quotationNew.danios.replaceAll("'", '"')
          );
        } catch (err) {}
      }

      $scope.showQuotation = true;
      var filter_contractor = "contractors-match/";
      dataFactory
        .post(filter_contractor, { matchWord: $scope.quotationNew.contractor })
        .then(function (response) {
          if (response.status === 200 && response.data.contractors) {
            var source = [];
            var contratactorsFound = response.data.contractors;
            if (contratactorsFound.length) {
              contratactorsFound.forEach(function (item) {
                if (item.full_name) {
                  var obj = {
                    label: item.full_name,
                    value: item,
                    val: item.full_name,
                  };
                } else {
                  var obj = {
                    label:
                      item.first_name +
                      " " +
                      item.last_name +
                      " " +
                      item.second_last_name,
                    value: item,
                    val:
                      item.first_name +
                      " " +
                      item.last_name +
                      " " +
                      item.second_last_name,
                  };
                }
                source.push(obj);
              });
            }
            $scope.contractors_data = source;
            $scope.contractors_data.forEach(function (c_item) {
              if (c_item.label == $scope.quotationNew.contractor) {
                $scope.quotationNew.contratante = c_item;
              }
            });
          }
          var matchesContractors_go = true;
        });
    };
    $scope.goToPolicyInfo = function (poliza) {
      if (poliza && poliza.id) {
        $state.go("polizas.info", { polizaId: poliza.id });
      }
    };
    $scope.createPolicy = function (quote) {
      console.log("ooooooooo", quote);
      if (quote && quote.document_type == 1) {
        $scope.name_for_new_tab = "Creación póliza";
        var route = "polizas.create";
        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }
        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });
          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab),
          };
        }
        $localStorage.tab_states = appStates.states;
        $localStorage.orderForm = quote;
        $localStorage.orderFormCotizacion = quote;
        $scope.open_in_same_tab_natural(
          "Creación póliza",
          "polizas.create",
          {},
          0
        );
      } else {
        $scope.name_for_new_tab = "Póliza de Frupo";
        var route = "colectividades.main";
        var existe = false;
        if (name && route) {
          $scope.route_for_new_tab = route;
          $scope.name_for_new_tab = name;
          appStates.states.forEach(function (state) {
            if (state.route == $scope.route_for_new_tab) {
              existe = true;
            }
          });
        }
        if (!existe) {
          var active_tab = appStates.states.findIndex(function (item) {
            if (item.active) {
              return true;
            }
            return false;
          });
          appStates.states[active_tab] = {
            name: $scope.name_for_new_tab,
            heading: $scope.name_for_new_tab,
            route: $scope.route_for_new_tab,
            active: true,
            isVisible: true,
            href: $state.href($scope.route_for_new_tab),
          };
        }
        $localStorage.tab_states = appStates.states;
        $localStorage.orderForm = quote;
        $localStorage.orderFormCotizacion = quote;
        $scope.open_in_same_tab_natural(
          "Pólizas de Grupo",
          "colectividades.main",
          {},
          0
        );
      }
    };
    $scope.addBitacora = false;
    $scope.addcomentario = function () {
      $scope.addBitacora = !$scope.addBitacora;
    };
    $scope.open_in_same_tab_natural = function (
      name,
      route,
      params,
      identifier
    ) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.cancelQuatation = function () {
      $scope.showEditInformation = false;
    };

    $scope.exprtExcelCotizacion = function (param) {
      var excel_quatation = "service_reporte-quotations-excel";
      $http({
        method: "POST",
        url: url.IP + excel_quatation,
        data: $scope.filters,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function success(request) {
          if (request.status === 200) {
            var blob = new Blob([request.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte Cotizaciones.xls");
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };
    //-- Peticion de persistencia--//
    // var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    // var usr = JSON.parse(decryptedUser);
    // var json_data = {};
    // //var form = document.getElementsByClassName('ibox-content col-md-12');
    // var form = document.getElementsByTagName("form");
    // var elementos ={};
    // //Valores reutilizables
    // var interval,interval1,valor;
    // var matchesContractors_go = false;
    // var count = 0;

    // function set_dataForm(json){
    //     PersistenceFactory.set_inputs(json);

    //     if(json['model.val'] != ''){
    //       $scope.quotationNew.contratante = {val: json['model.val']}
    //       $scope.matchesContractors(json['model.val'])

    //       interval1 = setInterval(function(){
    //           if(matchesContractors_go == true){
    //             clearInterval(interval1);
    //             if($scope.contractors_data.length>0){
    //               valor = [{
    //                 val  : $scope.contractors_data[0].label,
    //                 label: $scope.contractors_data[0].label,
    //                 value: $scope.contractors_data[0].value
    //               }];
    //               $scope.quotationNew.contratante = valor[0];
    //             }
    //           }
    //       }, 1000);
    //     }
    //     if(json['quotationNew.ramo'] != '' && json['quotationNew.ramo'] > 0){
    //       valor = angular.element('[ng-model="quotationNew.ramo"]');
    //       $scope.quotationNew.ramo = $scope.ramos[json['quotationNew.ramo']-1]
    //       $scope.changeRamo();
    //     }
    //     if(json['quotationNew.subramo'] != '' && json['quotationNew.subramo'] > 0){
    //       valor = angular.element('[ng-model="quotationNew.ramo"]');
    //       $scope.quotationNew.subramo = $scope.subramos[json['quotationNew.subramo']-1]
    //     }
    // }

    // interval = setInterval(function(){
    // if(form != undefined && PersistenceFactory.count == 0){
    //   PersistenceFactory.inicial(usr.org,'Cotizacion',usr.nameFull,PersistenceFactory.get_dataForm(form));
    // }
    // if(PersistenceFactory.init_return != '' && PersistenceFactory.init_return != undefined){
    //   clearInterval(interval);
    //   if(PersistenceFactory.init_return.status == 'data_view' ){
    //     set_dataForm(PersistenceFactory.json_return);
    //   }
    //   PersistenceFactory.interval = setInterval(function(){
    //       PersistenceFactory.editado(PersistenceFactory.get_dataForm(form));
    //     }, PersistenceFactory.intervalTime);/* /* */
    //   }
    // }, 1000);
    //-- End Peticion de persistencia--//
    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPagesP = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesP.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesP.length > 5) {
          $scope.end = $scope.totalPagesP.length;
          $scope.start = $scope.totalPagesP.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPageP($scope.totalPagesP.length);
        // $scope.actual_page = $scope.totalPagesP.length;
        // $scope.page = $scope.totalPagesP.length;
      };

      $scope.selectPageP = function (parPage) {
        $scope.actual_page = parPage;

        activate($scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPagesP = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesP.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesP = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesP.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesP.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
  }
})();

"use strict";

angular.module("inspinia").factory("ContratanteService", ContratanteService);

ContratanteService.$inject = ["url", "$http", "fileService", "$localStorage"];

function ContratanteService(url, $http, fileService, $localStorage) {
  return {
    createContratante: createContratante,
    getMediumLevelContratantes: getMediumLevelContratantes,
    getContratantes: getContratantes,
    getContratante: getContratante,
    getContratanteByUri: getContratanteByUri,
    getFiles: getFiles,
    updateContratante: updateContratante,
    deleteContratante: deleteContratante,
    getContratantesNaturalByGroup: getContratantesNaturalByGroup,
    getContratantesJuridicalByGroup: getContratantesJuridicalByGroup,
    getContratantesByGroup: getContratantesByGroup,
    getContratanteFull: getContratanteFull,
  };
  var orgParam = { params: { org: $localStorage.orgId } };

  // READ
  function getContratantes() {
    var temporal = [];
    return $http
      .get(url.IP + "contractor-resume/", orgParam)
      .then(getContratantesComplete)
      .catch(getContratantesFailed);

    function getContratantesComplete(response) {
      function contratantesArray(element, index, array) {
        //jshint ignore:line
        temporal.push(element);
      }

      response.data.results.forEach(contratantesArray);

      return $http
        .get(url.IP + "contractor-resume/", orgParam)
        .then(getContratantesMoralesComplete)
        .catch(getContratantesMoralesFailed);

      function getContratantesMoralesComplete(response) {
        response.data.results.forEach(contratantesArray);
        return temporal;
      }

      function getContratantesMoralesFailed(error) {
        return error;
      }
    }

    function getContratantesFailed(error) {
      return error;
    }
  }

  function getMediumLevelContratantes() {
    var temporal = [];
    return $http
      .get(url.IP + "fisicas-listwop/", orgParam)
      .then(getContratantesComplete)
      .catch(getContratantesFailed);

    function getContratantesComplete(response) {
      function contratantesArray(element, index, array) {
        //jshint ignore:line
        temporal.push(element);
      }

      response.data.forEach(contratantesArray);

      return $http
        .get(url.IP + "morales-listwop/", orgParam)
        .then(getContratantesMoralesComplete)
        .catch(getContratantesMoralesFailed);

      function getContratantesMoralesComplete(response) {
        response.data.forEach(contratantesArray);
        return temporal;
      }

      function getContratantesMoralesFailed(error) {
        return error;
      }
    }

    function getContratantesFailed(error) {
      return error;
    }
  }
  // getContratantesByGroup

  function getContratantesNaturalByGroup(group_id) {
    var temporal = [];
    return $http
      .get(
        url.IP + "fisicas-resume-by-group/?group_id=" + group_id + "&",
        orgParam
      )
      .then(getContratantesNaturalComplete)
      .catch(getContratantesNaturalFailed);

    function getContratantesNaturalComplete(response) {
      return response.data.results;
    }

    function getContratantesNaturalFailed(error) {
      return error;
    }
  }
  function getContratantesByGroup(group_id) {
    var temporal = [];
    return $http
      .get(
        url.IP + "contractor-resume-by-group/?group_id=" + group_id + "&",
        orgParam
      )
      .then(getContratantesContractorsComplete)
      .catch(getContratantesContractorsFailed);

    function getContratantesContractorsComplete(response) {
      return response.data;
    }

    function getContratantesContractorsFailed(error) {
      return error;
    }
  }

  function getContratantesJuridicalByGroup(group_id) {
    var temporal = [];
    return $http
      .get(
        url.IP + "morales-resume-by-group/?group_id=" + group_id + "&",
        orgParam
      )
      .then(getContratantesComplete)
      .catch(getContratantesFailed);

    function getContratantesComplete(response) {
      return response.data.results;
    }

    function getContratantesFailed(error) {
      return error;
    }
  }

  function getContratanteByUri(uri) {
    return $http
      .get(uri, orgParam)
      .then(getContratanteComplete)
      .catch(getContratanteFailed);

    function getContratanteComplete(response) {
      return response;
    }

    function getContratanteFailed(error) {
      return error;
    }
  }

  function getContratanteFull(data) {
    var dataReq;
    if (data.url) {
      dataReq = data.url;
    } else {
      // dataReq = url.IP + data.type + '/' + data.contratanteId + '/';
      dataReq = url.IP + "contractor/" + data.contratanteId + "/";
    }
    return $http
      .get(dataReq, orgParam)
      .then(getContratanteComplete)
      .catch(getContratanteFailed);

    function getContratanteComplete(response) {
      return response.data;
    }

    function getContratanteFailed(error) {
      return error;
    }
  }

  function getContratante(data) {
    var dataReq;
    if (data.url) {
      dataReq = data.url;
    } else {
      // dataReq = url.IP + data.type + '-resume-dash/' + data.contratanteId + '/';
      dataReq = url.IP + "contractor-resume-dash/" + data.contratanteId + "/";
    }
    return $http
      .get(dataReq, orgParam)
      .then(getContratanteComplete)
      .catch(getContratanteFailed);

    function getContratanteComplete(response) {
      return response.data;
    }

    function getContratanteFailed(error) {
      return error;
    }
  }

  function getFiles(data) {
    // return fileService.getFiles(url.IP + data.type + '/' + data.contratanteId + '/archivos/');
    return fileService.getFiles(
      url.IP + "contractors/" + data.contratanteId + "/archivos/"
    );
  }

  // CREATE
  function createContratante(data, typePerson) {
    if (data.phone_number) {
      var phone = data.phone_number;
      data.phone_number = phone;
    }

    var myType;
    // if (typePerson === 1) { myType = 'fisicas/'; } else { myType = 'morales/'; }
    if (typePerson === 1) {
      myType = "contractor/";
    } else {
      myType = "contractor/";
    }
    return $http
      .post(url.IP + myType, data)
      .then(createContratanteComplete)
      .catch(createContratanteFailed);

    function createContratanteComplete(response, status, headers, config) {
      //jshint ignore:line
      if (response.status == 200 || response.status == 201) {
        return response.data;
      } else {
        return response;
      }
    }

    function createContratanteFailed(response, status, headers, config) {
      //jshint ignore:line
      return status;
    }
  }

  // DELETE
  function deleteContratante(obj) {
    return $http
      .delete(obj.url)
      .then(deleteContratanteComplete)
      .catch(deleteContratanteFailed);

    function deleteContratanteComplete(response, status, headers, config) {
      //jshint ignore:line
      return response;
    }

    function deleteContratanteFailed(response, status, headers, config) {
      //jshint ignore:line
      return status;
    }
  }

  // UPDATE
  function updateContratante(editedObj) {
    if (!editedObj.j_name) {
      editedObj.full_name =
        editedObj.first_name +
        " " +
        editedObj.last_name +
        " " +
        editedObj.second_last_name;
    } else {
      editedObj.full_name = editedObj.j_name;
    }
    return $http
      .put(editedObj.url, editedObj)
      .then(updateContratanteComplete)
      .catch(updateContratanteFailed);

    function updateContratanteComplete(response) {
      return response;
    }

    function updateContratanteFailed(error) {
      return error;
    }
  }
}

"use strict";

angular
  .module("inspinia")
  .controller("ContratantesEditCtrl", ContratantesEditCtrl);
ContratantesEditCtrl.$inject = [
  "$location",
  "datesFactory",
  "dataFactory",
  "$parse",
  "SweetAlert",
  "$http",
  "$scope",
  "$stateParams",
  "$state",
  "$uibModal",
  "$localStorage",
  "$q",
  "$timeout",
  "ContratanteService",
  "groupService",
  "contactService",
  "generalService",
  "globalVar",
  "$rootScope",
  "appStates",
  "toaster",
  "FileUploader",
  "url",
  "helpers",
  "MESSAGES",
  "fileService",
  "exportFactory",
  "$sessionStorage",
  "$window",
  "$filter",
  "$sce",
];

function ContratantesEditCtrl(
  $location,
  datesFactory,
  dataFactory,
  $parse,
  SweetAlert,
  $http,
  $scope,
  $stateParams,
  $state,
  $uibModal,
  $localStorage,
  $q,
  $timeout,
  ContratanteService,
  groupService,
  contactService,
  generalService,
  globalVar,
  $rootScope,
  appStates,
  toaster,
  FileUploader,
  url,
  helpers,
  MESSAGES,
  fileService,
  exportFactory,
  $sessionStorage,
  $window,
  $filter,
  $sce
) {
  var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
  var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
  var usr = JSON.parse(decryptedUser);
  var token = JSON.parse(decryptedToken);
  var vm = this;
  var savedEditions = {
    natural: null,
    juridical: null,
  };
  vm.org_name = usr.org;
  vm.showInfo = true;
  // configuración del datepicker
  $(".datepicker-me input").datepicker();

  $.fn.datepicker.defaults.format = "dd/mm/yyyy";
  $.fn.datepicker.defaults.startView = 0;
  $.fn.datepicker.defaults.autoclose = true;
  $.fn.datepicker.defaults.language = "es";

  vm.showComments = false;
  vm.showBackButton = true;
  vm.recordatoriosFlag = false;

  vm.editForm = [];
  vm.celulas = [];
  vm.clasifications = [];
  vm.agrupaciones = [];
  vm.createRecordatorio = createRecordatorio;
  vm.user = usr;
  vm.accesos = $sessionStorage.permisos;
  if (vm.accesos) {
    vm.accesos.forEach(function (perm) {
      if (perm.model_name == "Pólizas") {
        vm.acceso_polizas = perm;
        vm.acceso_polizas.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar pólizas") {
            if (acc.checked == true) {
              vm.acceso_adm_pol = true;
            } else {
              vm.acceso_adm_pol = false;
            }
          } else if (acc.permission_name == "Ver pólizas") {
            if (acc.checked == true) {
              vm.acceso_ver_pol = true;
            } else {
              vm.acceso_ver_pol = false;
            }
          }
        });
      }
      if (perm.model_name == "Siniestros") {
        vm.acceso_sin = perm;
        vm.acceso_sin.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar siniestros") {
            if (acc.checked == true) {
              vm.acceso_adm_sin = true;
            } else {
              vm.acceso_adm_sin = false;
            }
          }
        });
      }
      if (perm.model_name == "Cobranza") {
        vm.acceso_cob = perm;
        vm.acceso_cob.permissions.forEach(function (acc) {
          if (acc.permission_name == "Ver cobranza") {
            if (acc.checked == true) {
              vm.acceso_ver_cob = true;
            } else {
              vm.acceso_ver_cob = false;
            }
          } else if (acc.permission_name == "Despagar recibos") {
            if (acc.checked == true) {
              vm.acceso_desp_cob = true;
            } else {
              vm.acceso_desp_cob = false;
            }
          } else if (acc.permission_name == "Pagar y prorrogar") {
            if (acc.checked == true) {
              vm.acceso_pag_cob = true;
            } else {
              vm.acceso_pag_cob = false;
            }
          } else if (acc.permission_name == "Desconciliación de recibos") {
            if (acc.checked == true) {
              vm.acceso_desco_cob = true;
            } else {
              vm.acceso_desco_cob = false;
            }
          } else if (acc.permission_name == "Conciliar recibos") {
            if (acc.checked == true) {
              vm.acceso_conc_cob = true;
            } else {
              vm.acceso_conc_cob = false;
            }
          } else if (acc.permission_name == "Liquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_liq_cob = true;
            } else {
              vm.acceso_liq_cob = false;
            }
          }
        });
      }
      if (perm.model_name == "Reportes") {
        vm.acceso_reportes = perm;
        vm.acceso_reportes.permissions.forEach(function (acc) {
          if (acc.permission_name == "Reporte fianzas") {
            if (acc.checked == true) {
              vm.acceso_rep_fia = true;
            } else {
              vm.acceso_rep_fia = false;
            }
          } else if (acc.permission_name == "Reporte Siniestros") {
            if (acc.checked == true) {
              vm.acceso_rep_sin = true;
            } else {
              vm.acceso_rep_sin = false;
            }
          } else if (acc.permission_name == "Reporte Endosos") {
            if (acc.checked == true) {
              vm.acceso_rep_end = true;
            } else {
              vm.acceso_rep_end = false;
            }
          } else if (acc.permission_name == "Reporte pólizas") {
            if (acc.checked == true) {
              vm.acceso_rep_pol = true;
            } else {
              vm.acceso_rep_pol = false;
            }
          } else if (acc.permission_name == "Reporte renovaciones") {
            if (acc.checked == true) {
              vm.acceso_rep_ren = true;
            } else {
              vm.acceso_rep_ren = false;
            }
          } else if (acc.permission_name == "Reporte cobranza") {
            if (acc.checked == true) {
              vm.acceso_rep_cob = true;
            } else {
              vm.acceso_rep_cob = false;
            }
          }
        });
      }
      if (perm.model_name == "Contratantes y grupos") {
        vm.acceso_contg = perm;
        vm.acceso_contg.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar contratantes y grupos") {
            if (acc.checked == true) {
              vm.acceso_adm_cont = true;
            } else {
              vm.acceso_adm_cont = false;
            }
          } else if (acc.permission_name == "Ver contratantes y grupos") {
            if (acc.checked == true) {
              vm.acceso_ver_cont = true;
            } else {
              vm.acceso_ver_cont = false;
            }
          }
        });
      }
      if (perm.model_name == "Fianzas") {
        vm.acceso_fian = perm;
        vm.acceso_fian.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar fianzas") {
            if (acc.checked == true) {
              vm.acceso_adm_fia = true;
            } else {
              vm.acceso_adm_fia = false;
            }
          } else if (acc.permission_name == "Ver fianzas") {
            if (acc.checked == true) {
              vm.acceso_ver_fia = true;
            } else {
              vm.acceso_ver_fia = false;
            }
          }
        });
      }
      if (perm.model_name == "Archivos") {
        vm.acceso_files = perm;
        vm.acceso_files.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar archivos sensibles") {
            if (acc.checked == true) {
              vm.permiso_archivos = true;
            } else {
              vm.permiso_archivos = false;
            }
          } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
          if (acc.permission_name == "Administrar adjuntos") {
            if (acc.checked == true) {
              vm.permiso_administrar_adjuntos = true;
            } else {
              vm.permiso_administrar_adjuntos = false;
            }
          }
        });
      }
      if (perm.model_name == "Referenciadores") {
        vm.accesoRef = perm;
        vm.accesoRef.permissions.forEach(function (acc) {
          if (acc.permission_name == "Ver referenciadores") {
            if (acc.checked == true) {
              vm.verReferenciadores = true;
            } else {
              vm.verReferenciadores = false;
            }
          }
        });
      }
    });
  }

  function exportCommentsExcel() {
    if (!vm.contratanteId || vm.commentsExportLoading) {
      return;
    }
    vm.commentsExportLoading = true;

    var paramsObj = {
      model: 2,
      id_model: vm.contratanteId,
    };
    if (vm.org_name) {
      paramsObj.org = vm.org_name;
    }

    var resetLoading = function () {
      vm.commentsExportLoading = false;
      if (!$scope.$$phase && !$scope.$root.$$phase) {
        $scope.$applyAsync();
      }
    };

    toaster.info(
      "Generando...",
      "El archivo se está generando, espera un momento."
    );

    exportFactory
      .commentsExport({
        params: paramsObj,
        downloadName: "bitacora-contratante.xlsx",
        token: token,
      })
      .then(function () {
        SweetAlert.swal({
          title: "Listo",
          icon: "success",
          text: "La bitacora se descargo exitosamente",
          timer: 5000,
        });
      })
      .catch(function (error) {
        console.error("Error exportando comentarios", error);
        SweetAlert.swal(
          "Error",
          "No se pudo exportar los comentarios. Intenta nuevamente.",
          "error"
        );
      })
      .finally(function () {
        resetLoading();
      });
  }
  /** Uploader files */
  vm.goToContractorEdit = goToContractorEdit;
  vm.uploadImages = uploadImages;
  vm.verCobranza = verCobranza;
  vm.verPolizas = verPolizas;
  vm.verSiniestros = verSiniestros;
  vm.getSinister = getSinister;
  vm.ramo_changed = ramo_changed;
  vm.ramos = {};
  vm.ramos.ramo_selected = 2;
  vm.deleteAddress = deleteAddress;
  vm.ramos.options = [
    { id: 2, label: "Accidentes y Enfermedades" },
    { id: 3, label: "Daños" },
    { id: 1, label: "Vida" },
  ];

  vm.address_type = [
    {
      name: "Dirección Personal",
      id: 0,
    },
    {
      name: "Dirección Fiscal",
      id: 1,
    },
    {
      name: "Dirección de cobro",
      id: 2,
    },
    {
      name: "Dirección de paquetería",
      id: 3,
    },
    {
      name: "Dirección de riesgo",
      id: 4,
    },
    {
      name: "CFDI",
      id: 5,
    },
  ];

  vm.showPendientes = showPendientes;
  vm.showPagados = showPagados;
  vm.showLiquidados = showLiquidados;
  vm.showCancelados = showCancelados;
  vm.showNotas = showNotas;
  vm.showRecordatorios = showRecordatorios;
  $scope.contractor = [];

  vm.cPendientes = true;
  vm.cPagados = false;
  vm.cLiquidados = false;
  vm.cCancelados = false;
  $scope.flagPhone = false;

  $scope.contractorEdit = [];
  vm.getPDFEdo = getPDFEdo;

  $scope.goBack = function () {
    if ($localStorage && $localStorage["last_state_visited"]) {
      // $localStorage.tab_states[$localStorage.tab_index] = $localStorage['last_state_visited'];
      $scope.open_in_same_tab(
        "Información Póliza",
        $localStorage["last_state_visited"]["route"],
        { polizaId: $localStorage["last_state_visited"]["id"] },
        null
      );
    }
  };

  $scope.change_vip = function (url, vip) {
    $http.patch(url, { vip: vip }).then(function (response) {
      if (response.status == 200) {
        toaster.success("Cambio exitoso", "El cambio se ha aplicado con éxito");
      } else {
        toaster.warning("Ha ocurrido un problema", "Intente nuevamente");
        vm.form.vip = !vip;
      }
    });
  };
  $scope.saveBaja = false;
  $scope.changeBaja = function (url_c, valor, motivo_baja) {
    $scope.saveBaja = true;
    if (url_c) {
      $http
        .patch(url_c, { baja: valor, motivo_baja: motivo_baja })
        .then(function (response) {
          $scope.saveBaja = false;
          if (response.status == 200) {
            toaster.success(
              "Cambio exitoso",
              "El cambio se ha aplicado con éxito"
            );
          } else {
            $scope.saveBaja = false;
            toaster.warning("Ha ocurrido un problema", "Intente nuevamente");
            vm.form.baja = !valor;
            vm.form.motivo_baja = "";
          }
        });
    }
  };
  function showRecordatorios() {
    vm.infoFlag = false;
    vm.recordatoriosFlag = true;
  }
  function getPDFEdo(contr) {
    $http({
      method: "GET",
      url: url.IP + "get-pdf-edocuenta/",
      params: {
        id: contr.id,
        tipo: contr.type_person,
      },
    }).then(function success(response) {
      if (response.status === 200 || response.status === 201) {
        toaster.info("Se generó el PDF");
        $scope.pdf = response.data;

        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
        var params = {
          // 'model': contr.type_person == "Fisica" ? 2 : 3,
          model: contr.type_person == "Fisica" ? 26 : 26,
          event: "POST",
          associated_id: contr.id,
          identifier: "generó el PDF.",
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});
      } else {
        toaster.warning("Ocurrió Un problema, Intenta nuevamente");
      }
    });
  }
  function createRecordatorio(registroSelected, tipo) {
    var insurance = registroSelected;
    var modalInstance = $uibModal.open({
      templateUrl: "app/recordatorios/desde-registro/desderegistro.modal.html",
      controller: "RecordatorioRegistroCtrl",
      size: "lg",
      resolve: {
        poliza: function () {
          return registroSelected;
        },
        tipoRegistro: function () {
          return tipo;
        },
        from: function () {
          return null;
        },
        parent: function () {
          return vm.form;
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
    });
  }
  $scope.goToRecordatorio = function (rec) {
    if (rec.recordatorio) {
      $scope.name_for_new_tab = "Recordatorio desde registro";
      $scope.route_for_new_tab = "recordatorios.desde_registro_show";
      var params = { id: rec.recordatorio.id };
    }
    var existe = false;
    if (name && route) {
      $scope.route_for_new_tab = route;
      $scope.name_for_new_tab = name;
      appStates.states.forEach(function (state) {
        if (state.route == $scope.route_for_new_tab) {
          existe = true;
        }
      });
    }

    if (!existe) {
      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });

      appStates.states[active_tab] = {
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab, params),
      };
    }
    $localStorage.tab_states = appStates.states;
    $state.go($scope.route_for_new_tab, params);
  };
  $scope.changeSensible = function (sensible, index) {
    uploader.queue[index].formData[0].sensible = sensible;
  };

  $scope.saveFile = function (file) {
    $http.patch(file.url, {
      nombre: file.nombre,
      sensible: file.sensible,
      name: file.nombre,
    });
  };

  $scope.status = function (value) {
    switch (value) {
      case 1:
        return "En trámite";
        break;
      case 2:
        return "OT Cancelada";
        break;
      case 4:
        return "Precancelada";
        break;
      case 10:
        return "Por iniciar";
        break;
      case 11:
        return "Cancelada";
        break;
      case 12:
        return "Renovada";
        break;
      case 13:
        return "Vencida";
        break;
      case 14:
        return "Vigente";
        break;
      case 15:
        return "No renovada";
        break;
      default:
        return "Pendiente";
    }
  };

  $scope.payment = function (value) {
    switch (value) {
      case 1:
        return "Mensual";
        break;
      case 2:
        return "Bimestral";
        break;
      case 3:
        return "Trimestral";
        break;
      case 4:
        return "Cuatrimestral";
        break;
      case 5:
        return "Contado";
        break;
      case 6:
        return "Semestral";
        break;
      case 12:
        return "Anual";
        break;
      case 24:
        return "Quincenal";
        break;
      default:
        return "No especificada";
    }
  };

  $scope.goToPolicyInfo = function (insurance) {
    if (insurance.document_type == 1) {
      var name = "Información póliza";
      var route = "polizas.info";
    } else if (insurance.document_type == 3) {
      var name = "Información póliza grupo";
      var route = "colectividades.info";
    }
    $scope.name_for_new_tab = name;
    $scope.route_for_new_tab = route;

    var existe = false;
    if (name && route) {
      $scope.route_for_new_tab = route;
      $scope.name_for_new_tab = name;
      appStates.states.forEach(function (state) {
        if (state.route == $scope.route_for_new_tab) {
          existe = true;
        }
      });
    }

    if (!existe) {
      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });

      appStates.states[active_tab] = {
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
    }
    $localStorage.tab_states = appStates.states;
    $localStorage.tab_index = $localStorage.tab_states.length - 1;

    if (insurance.document_type == 1) {
      $state.go("polizas.info", { polizaId: insurance.id });
    } else if (insurance.document_type == 3) {
      $state.go("colectividades.info", { polizaId: insurance.id });
    }
  };

  function showPendientes() {
    vm.cPendientes = true;
    vm.cPagados = false;
    vm.cLiquidados = false;
    vm.cCancelados = false;
  }

  function showPagados() {
    vm.cPendientes = false;
    vm.cPagados = true;
    vm.cLiquidados = false;
    vm.cCancelados = false;
  }

  function showLiquidados() {
    vm.cPendientes = false;
    vm.cPagados = false;
    vm.cLiquidados = true;
    vm.cCancelados = false;
  }

  function showCancelados() {
    vm.cPendientes = false;
    vm.cPagados = false;
    vm.cLiquidados = false;
    vm.cCancelados = true;
  }

  vm.showSinPendientes = showSinPendientes;
  vm.showSinTramites = showSinTramites;
  vm.showSinCancelados = showSinCancelados;
  vm.showSinRechazados = showSinRechazados;
  vm.showSinCompletados = showSinCompletados;
  vm.NotasModal = NotasModal;

  vm.sinPendientes = true;
  vm.sinTramites = false;
  vm.sinCancelados = false;
  vm.sinRechazados = false;
  vm.sinCompletados = false;

  function showSinPendientes() {
    vm.sinPendientes = true;
    vm.sinTramites = false;
    vm.sinCancelados = false;
    vm.sinRechazados = false;
    vm.sinCompletados = false;
  }

  function showSinTramites() {
    vm.sinPendientes = false;
    vm.sinTramites = true;
    vm.sinCancelados = false;
    vm.sinRechazados = false;
    vm.sinCompletados = false;
  }

  function showSinCancelados() {
    vm.sinPendientes = false;
    vm.sinTramites = false;
    vm.sinCancelados = true;
    vm.sinRechazados = false;
    vm.sinCompletados = false;
  }

  function showSinRechazados() {
    vm.sinPendientes = false;
    vm.sinTramites = false;
    vm.sinCancelados = false;
    vm.sinRechazados = true;
    vm.sinCompletados = false;
  }

  function showSinCompletados() {
    vm.sinPendientes = false;
    vm.sinTramites = false;
    vm.sinCancelados = false;
    vm.sinRechazados = true;
    vm.sinCompletados = false;
  }

  vm.table = {
    headers: [
      "Afectado",
      "Contratante",
      "Aseguradora",
      "Número de siniestro",
      "Padecimiento",
      "Reclamado",
      "Subramo",
      "Acciones",
      "Número de póliza",
      "Razón",
    ],
  };
  vm.verEndosos = verEndosos;
  $scope.deleteFile = deleteFile;
  $window.localStorage.editCont = false;

  $scope.open_in_same_tab = function (name, route, params, identifier) {
    if (name && route) {
      $scope.route_for_new_tab = route;
      $scope.name_for_new_tab = name;
    }

    var active_tab = appStates.states.findIndex(function (item) {
      if (item.active) {
        return true;
      }
      return false;
    });
    appStates.states[active_tab] = {
      id: identifier,
      name: $scope.name_for_new_tab,
      heading: $scope.name_for_new_tab,
      route: $scope.route_for_new_tab,
      active: true,
      isVisible: true,
      href: $state.href($scope.route_for_new_tab),
    };
    $localStorage.tab_states = appStates.states;
    $localStorage.tab_index = $localStorage.tab_states.length - 1;
    $state.go($scope.route_for_new_tab, params);
  };
  function removeCircularReferences(obj) {
    var seen = new WeakSet();
    return JSON.parse(
      JSON.stringify(obj, function (key, value) {
        if (typeof value === "object" && value !== null) {
          if (seen.has(value)) {
            return; // Skip circular reference
          }
          seen.add(value);
        }
        return value;
      })
    );
  }
  /*Crear Poliza*/
  $scope.goToPolicyNueva = function (data) {
    $scope.name_for_new_tab = "Crear Póliza";
    $scope.route_for_new_tab = "polizas.create";
    // $scope.open_in_same_tab('Nueva Póliza', 'polizas.create', params, null);

    var active_tab = appStates.states.findIndex(function (item) {
      if (item.active) {
        return true;
      }
      return false;
    });
    appStates.states[active_tab] = {
      id: 0,
      name: $scope.name_for_new_tab,
      heading: $scope.name_for_new_tab,
      route: $scope.route_for_new_tab,
      active: true,
      isVisible: true,
      href: $state.href($scope.route_for_new_tab),
    };
    var cleanedData = removeCircularReferences(data);
    var params = { myInsurance: cleanedData };
    $localStorage.tab_states = appStates.states;
    $localStorage.tab_index = $localStorage.tab_states.length - 1;
    $state.go($scope.route_for_new_tab, params);
    // $state.go($scope.route_for_new_tab, {'myInsurance': cleanedData});
    // $state.go('polizas.create', params);
  };
  /*Crear cotización*/
  $scope.goToQuotation = function (data) {
    $scope.name_for_new_tab = "Crear cotización";
    $scope.route_for_new_tab = "cotizacion.cotizacion";
    var cleanedData = removeCircularReferences(data);
    var params = { myContractor: cleanedData };
    $state.go($scope.route_for_new_tab, params);
  };

  $scope.goToSurety = function (data) {
    var params = { myInsurance: data };
    $scope.open_in_same_tab("Nueva Fianza", "fianzas.fianzas", params, null);
    // $state.go('fianzas.fianzas', params);
  };

  $scope.archivos = {};
  $scope.archivos = {
    headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
  };

  $scope.filterValue = function ($event) {
    if (isNaN(String.fromCharCode($event.charCode))) {
      $event.preventDefault();
    }
  };

  /* Cobranza */
  function verCobranza(param, status) {
    $scope.statusc = status;
    var parUrl = url.IP + "get-cobranza-contractor/";
    vm.polizas = false;
    vm.cobranza = true;
    vm.siniestros = false;
    vm.showInfo = false;
    $http({
      method: "GET",
      url: parUrl,
      params: {
        status: status,
        contratante: param.id,
        verpolizas: vm.acceso_ver_pol,
        verfianzas: vm.acceso_adm_fia,
      },
    }).then(function success(response) {
      if (response.status === 200 && response.data.results.length) {
        $scope.results = response.data.results;

        vm.receipts = [];
        vm.receipt = {};
        vm.receipts = response.data.results;
        vm.receipt = {
          count: response.data.count,
          previous: response.data.previous,
          next: response.data.next,
        };
        vm.show_pag_policy = true;
        testPagination("vm.receipts", "vm.receipt");
      } else {
        toaster.warning("No se encontraron registro");
      }
    });
  }
  $scope.exportData = function (param, tipo) {
    $scope.filtros = {};
    var l = Ladda.create(document.querySelector(".ladda-button"));
    l.start();
    if (tipo == 1) {
      var namef = "Reporte_Cobranza_" + param.full_name.trim() + ".xls";
      $scope.filtros.contractor = param.id;
      $scope.filtros.status = $scope.statusc;
      var url_rep = "service-cobranzacontractor-excel";
      $http({
        method: "POST",
        url: url.IP + url_rep,
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function success(request) {
          if (request.status === 200) {
            var blob = new Blob([request.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, namef);
          }
          l.stop();
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    } else {
      var namef = "Reporte_Polizas" + param.full_name.trim() + ".xls";
      $scope.filtros.contractor = param.id;
      var url_rep = "service-polizascontractor-excel";
      $http({
        method: "POST",
        url: url.IP + url_rep,
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function success(request) {
          if (request.status === 200) {
            var blob = new Blob([request.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, namef);
          }
          l.stop();
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    }
  };
  $rootScope.changeVendedor = function (data) {
    if (vm.form) {
      vm.form.vendor = data.url;
    } else {
      vm.juridicalForm.vendor = data.url;
    }
  };

  /* Siniestros */
  function verSiniestros(param, status, ramo) {
    $http({
      method: "GET",
      url: url.IP + "siniestros-conteos-contractor/",
      params: {
        contractor: param.id,
      },
    }).then(function success(response) {
      vm.conteos = response.data;
    });

    // if($scope.infoUser.staff && !$scope.infoUser.superuser){
    //     // var parUrl = url.IP + 'v2/contratantes/get-siniestros-natural/';
    //     var parUrl = url.IP + 'v2/contratantes/get-siniestros-contractor/';
    var parUrl = url.IP + "get-siniestros-contractor/";

    vm.polizas = false;
    vm.cobranza = false;
    vm.siniestros = true;
    vm.showInfo = false;

    $http({
      method: "GET",
      url: parUrl,
      params: {
        status: status,
        contratante: param.id,
        ramo_number: ramo,
      },
    }).then(function success(request) {
      if (request.status === 200 && request.data.results.length) {
        vm.loading = false;
        vm.siniestros = [];
        vm.siniestros_config = {};
        vm.siniestros = request.data.results;
        vm.siniestros_config = {
          count: request.data.count,
          previous: request.data.previous,
          next: request.data.next,
        };
        vm.show_pag_policy = true;

        testPagination("vm.siniestros", "vm.siniestros_config");
      } else {
        toaster.warning("No se encontraron registro");
      }
    });
  }
  vm.changePoliza = changePoliza;
  function changePoliza(par, asc) {
    switch (par) {
      case 1:
        vm.verPolizas($scope.contratante_selected, par, asc);
        vm.pol_number_asc = asc;
        vm.aseguradora_asc = 0;
        vm.subramo_asc = 0;
        vm.estatus_asc = 0;
        vm.vigencia_asc = 0;
        break;
      case 2:
        vm.verPolizas($scope.contratante_selected, par, asc);
        vm.pol_number_asc = 0;
        vm.aseguradora_asc = asc;
        vm.subramo_asc = 0;
        vm.estatus_asc = 0;
        vm.vigencia_asc = 0;
        break;
      case 3:
        vm.verPolizas($scope.contratante_selected, par, asc);
        vm.pol_number_asc = 0;
        vm.aseguradora_asc = 0;
        vm.subramo_asc = asc;
        vm.estatus_asc = 0;
        vm.vigencia_asc = 0;
        break;
      case 4:
        vm.verPolizas($scope.contratante_selected, par, asc);
        vm.pol_number_asc = 0;
        vm.aseguradora_asc = 0;
        vm.subramo_asc = 0;
        vm.estatus_asc = asc;
        vm.vigencia_asc = 0;
        break;
      case 5:
        vm.verPolizas($scope.contratante_selected, par, asc);
        vm.pol_number_asc = 0;
        vm.aseguradora_asc = 0;
        vm.subramo_asc = 0;
        vm.estatus_asc = 0;
        vm.vigencia_asc = asc;
        break;
    }
  }
  /* Polizas */
  function verPolizas(param, order, asc) {
    $scope.contratante_selected = param;
    // if($scope.infoUser.staff && !$scope.infoUser.superuser){
    //     // var parUrl = url.IP + 'v2/contratantes/get-polizas-natural/';
    //     var parUrl = url.IP + 'v2/contratantes/get-polizas-contractor/';
    var parUrl = url.IP + "get-polizas-contractor/";
    vm.polizas = true;
    vm.cobranza = false;
    vm.siniestros = false;
    vm.showInfo = false;
    $http({
      method: "GET",
      url: parUrl,
      params: {
        contratante: param.id,
        order: order,
        asc: asc,
        verpolizas: vm.acceso_ver_pol,
        verfianzas: vm.acceso_adm_fia,
      },
    }).then(function success(request) {
      vm.search_results = [];
      vm.ot_results = [];

      if (
        (request.status === 200 || request.status === 201) &&
        request.data.results.length
      ) {
        vm.show_results = true;
        vm.show_policy = false;
        var data = request.data.results;
        data.forEach(function (item) {
          // if(item.status == 1 || item.status == 2) {
          //   vm.ot_results.push(item);
          // }
          // else{
          //   vm.search_results.push(item);
          // }
          vm.search_results.push(item);
        });
        vm.search_config = {
          count: request.data.count,
          previous: request.data.previous,
          next: request.data.next,
        };
        vm.show_pag_search = true;
        testPagination("vm.search_results", "vm.search_config");
      } else {
        toaster.warning("No se encontraron registros");
      }
    });
  }
  /* Notas de credito */
  function NotasModal(receipt) {
    var insurance = receipt;
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/cobranzas/notaCredito.modal.html",
      controller: "NotaCreditoCtrl",
      size: "lg",
      resolve: {
        receipt: function () {
          return receipt;
        },
        insurance: function () {
          return insurance;
        },
        from: function () {
          return null;
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
    });
    modalInstance.result.then(function (receipt) {
      vm.receipts.splice(index, 1);
      activate();
    });
  }

  function ramo_changed() {
    if (vm.form) {
      verSiniestros(vm.form, 1, vm.ramos.ramo_selected);
    } else {
      verSiniestros(vm.juridicalForm, 1, vm.ramos.ramo_selected);
    }
  }

  function getSinister(ramo, status) {
    if (vm.form) {
      verSiniestros(vm.form, status, ramo);
    } else {
      verSiniestros(vm.juridicalForm, status, ramo);
    }
  }

  /* Endosos */
  function verEndosos(param, status, ramo) {
    // body...
  }

  vm.activityLog = false;
  $scope.log_data = [];

  $scope.goToLog = function () {
    if (vm.form) {
      $scope.log_data.id = vm.form.id;
      $scope.log_data.type_person = 26;
    } else {
      $scope.log_data.id = vm.juridicalForm.id;
      $scope.log_data.type_person = 26;
    }

    vm.showInfo = false;
    vm.activityLog = true;

    $http({
      method: "GET",
      url: url.IP + "get-specific-log/",
      params: {
        associated_id: $scope.log_data.id,
        model: $scope.log_data.type_person,
      },
    })
      .then(function (request) {
        $scope.log_info = request.data;
      })
      .catch(function (e) {
        console.log("e", e);
      });
  };

  function testPagination(parModel, parConfig) {
    var config_ = $parse(parConfig)($scope);
    if (config_) {
      var pages = Math.ceil(config_.count / 10);
    }
    $scope.totalPages = [];
    var count_items = 0;
    var count_pages = 0;

    var previous_array = [];
    var next_array = [];

    $scope.start = 0;
    $scope.end = 5;
    $scope.actual_page = 1;
    $scope.not_prev = true;

    for (var i = 0; i < pages; i++) {
      $scope.totalPages.push(i + 1);
    }

    $scope.lastPage = function () {
      // TODO: ultimo bloque
      if ($scope.totalPages.length > 5) {
        $scope.end = $scope.totalPages.length;
        $scope.start = $scope.totalPages.length - 5;
        $scope.show_prev_block = true;
      }

      $scope.selectPage($scope.totalPages.length);

      $scope.actual_page = $scope.totalPages.length;
    };

    $scope.selectPage = function (parPage) {
      if (config_.next || config_.previous) {
        if (config_.next) {
          var next_ = config_.next;

          var otherParameters = config_.next.substring(
            config_.next.indexOf("&page=") + 6
          );

          if (next_.search("&status=") !== -1) {
            var status = next_.substring(next_.indexOf("&status=") + 1);
          } else {
            var status = "";
          }

          var url = config_.next.substring(
            0,
            config_.next.indexOf("&page=") + 6
          );
          url += parPage.toString();
          url += "&" + status;

          if (config_.next.search("&") !== -1) {
            var params = otherParameters.substring(
              2,
              otherParameters.indexOf("&") + 1000
            );
            url += "&" + params;
          }
        } else {
          var prev_ = config_.previous;
          var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
          if (prev_.search("&status=") !== -1) {
            var status = prev_.substring(prev_.indexOf("&status=") + 1);
          } else {
            var status = "";
          }

          if (prev_.search("&page=") !== -1) {
            var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
            url += parPage.toString();
            url += "&" + status;
          } else {
            var url = config_.previous;
          }
          if (config_.prev_.search("&") !== -1) {
            var params = otherParameters.substring(
              2,
              otherParameters.indexOf("&") + 1000
            );
            url += "&" + params;
          }
        }
      }

      // url += '&status=1'
      getCobranzaPag(url);
      $scope.actual_page = parPage;
      if ($scope.actual_page > 1) {
        $scope.not_prev = false;
      }

      if ($scope.actual_page == $scope.totalPages.length - 1) {
        $scope.not_next = true;
      }
    };

    $scope.previousBlockPages = function (param) {
      if (param) {
        if ($scope.start < $scope.actual_page) {
          $scope.start = $scope.start - 1;
          $scope.end = $scope.end - 1;
        }
      } else {
        $scope.start = $scope.start - 5;
        $scope.end = $scope.end - 5;

        if ($scope.end < $scope.totalPages.length) {
          $scope.not_next = false;
        }
      }

      if ($scope.end <= 5) {
        $scope.start = 0;
        $scope.end = 5;
        $scope.show_prev_block = false;
      }
    };

    $scope.nextBlockPages = function (param) {
      $scope.show_prev_block = true;

      if (param) {
        if ($scope.end > $scope.actual_page) {
          $scope.start = $scope.start + 1;
          $scope.end = $scope.end + 1;
        }
      } else {
        if ($scope.end < $scope.totalPages.length) {
          $scope.start = $scope.start + 5;
          $scope.end = $scope.end + 5;

          if ($scope.end == $scope.totalPages.length) {
            $scope.not_next = true;
          }
        } else {
          $scope.not_next = true;
        }
      }
    };

    function getCobranzaPag(parUrl) {
      $http
        .get(parUrl)
        .then(
          function success(request) {
            var source = $parse(parModel);
            source.assign($scope, []);
            source.assign($scope, request.data.results);

            var data = {
              count: request.data.count,
              previous: request.data.previous,
              next: request.data.next,
            };
            var config = $parse(parConfig);
            config.assign($scope, []);
            config.assign($scope, data);
          },
          function error(error) {
            console.log("error", error);
          }
        )
        .catch(function (e) {
          console.log("e", e);
        });
    }
  }
  $scope.goToPolicy = function (poliza, name, route) {
    if (poliza.document_type == 1) {
      $scope.name_for_new_tab = "Información Pólizas";
      $scope.route_for_new_tab = "polizas.info";
      var params = { polizaId: poliza.id };
    } else if (poliza.document_type == 3) {
      $scope.name_for_new_tab = "Información Póliza de Grupo";
      $scope.route_for_new_tab = "colectividades.info";
      // $state.go('colectividades.info', {polizaId: poliza.policy.id})
      var params = { polizaId: poliza.id };
    } else if (poliza.document_type == 7) {
      $scope.name_for_new_tab = "Información Fianza";
      $scope.route_for_new_tab = "fianzas.info";
      // $state.go('colectividades.info', {polizaId: poliza.policy.id})
      var params = { polizaId: poliza.id };
    } else if (poliza.document_type == 8) {
      $scope.name_for_new_tab = "Información Fianza Colectiva";
      $scope.route_for_new_tab = "fianzas.details";
      // $state.go('colectividades.info', {polizaId: poliza.policy.id})
      var params = { polizaId: poliza.id };
    } else if (poliza.document_type == 11) {
      $scope.name_for_new_tab = "Información Flotilla";
      $scope.route_for_new_tab = "flotillas.info";
      // $state.go('colectividades.info', {polizaId: poliza.policy.id})
      var params = { polizaId: poliza.id };
    } else if (poliza.document_type == 12) {
      $scope.name_for_new_tab = "Información Flotilla";
      $scope.route_for_new_tab = "flotillas.info";
      // $state.go('colectividades.info', {polizaId: poliza.policy.id})
      var params = { polizaId: poliza.parent.id };
    } else {
      $scope.name_for_new_tab = "Información Pólizas";
      $scope.route_for_new_tab = "polizas.info";
      var params = { polizaId: poliza.id };
    }
    var existe = false;
    var active_tab = appStates.states.findIndex(function (item) {
      if (item.active) {
        return true;
      }
      return false;
    });

    appStates.states[active_tab] = {
      name: $scope.name_for_new_tab,
      heading: $scope.name_for_new_tab,
      route: $scope.route_for_new_tab,
      active: true,
      isVisible: true,
      href: $state.href($scope.route_for_new_tab, params),
    };
    $localStorage.tab_states = appStates.states;
    $state.go($scope.route_for_new_tab, params);
  };
  function goToContractorEdit(person) {
    $state.go("contratantes.edit", {
      type: checkType(person.type_person),
      contratanteId: person.id,
    });
  }

  function showNotas() {
    vm.notasFlag = true;
  }

  function checkType(type) {
    //jshint ignore:line
    return type === 1 ? "fisicas" : "morales";
  }

  function uploadImages() {
    // if ($stateParams.type === 'fisicas') {
    //     $scope.userInfo = {
    //         id: vm.form.id,
    //         type_person: 'contractors'
    //     };
    // } else {
    //     $scope.userInfo = {
    //         id: vm.juridicalForm.id,
    //         type_person: 'contractors'
    //     };
    // }
    $scope.userInfo = {
      id: vm.form ? vm.form.id : vm.juridicalForm.id,
      type_person: "contractors",
    };
    // Upload files
    // $scope.userInfo.url = $scope.uploader.url = url.IP + helpers.checkType($scope.userInfo.type_person) + '/' + $scope.userInfo.id + '/archivos/';
    $scope.userInfo.url = $scope.uploader.url =
      url.IP + "contractors/" + $scope.userInfo.id + "/archivos/";

    $scope.uploader.uploadAll();
    // toaster.success(MESSAGES.OK.UPLOADFILES);
  }

  var uploader = ($scope.uploader = new FileUploader({
    headers: {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    },
  }));

  // uploader.filters.push({
  //     name: 'customFilter',
  //     fn: function(item /*{File|FileLikeObject}*/ , options) {
  //         return this.queue.length < 20;
  //     }
  // });

  // ALERTA SUCCES UPLOADFILES
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    toaster.success(MESSAGES.OK.UPLOADFILES);
  };

  // ALERTA ERROR UPLOADFILES
  uploader.onErrorItem = function (fileItem, response, status, headers) {
    SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
  };

  uploader.onAfterAddingFile = function (item) {
    //var fl = new FileUploader.FileItem();
    /*
        Object.defineProperty(item._file, 'name',{
            value : item.file.name,
            writable : true
        });

        var fileExtension = '.' + item.file.name.split('.').pop();

        item.file.name = Math.random().toString(36).substring(7) + new Date().getTime() + fileExtension;*/
    item.formData.push({
      arch: item._file,
      name: "",
      // owner: $scope.userInfo.id
    });
  };

  uploader.onBeforeUploadItem = function (item) {
    item.url = $scope.userInfo.url;
    item.formData[0].name = item.file.name;
    item.alias = "";
    item.formData[0].owner = $scope.userInfo.id;
  };

  vm.person = {};
  vm.cancel = cancel;
  vm.save = save;

  // Modals
  vm.openModalDeleteContratantes = openModalDeleteContratantes;
  vm.deleteContractor = deleteContractor;

  // Groups
  vm.groups = [];
  vm.openModalGroup = openModalGroup;
  vm.openModalClasification = openModalClasification;
  vm.openModalCelulaContractor = openModalCelulaContractor;
  vm.openModalAsignacion = openModalAsignacion;

  // Contacts
  vm.addContact = addContact;
  vm.deleteContacts = deleteContacts;

  // Addresses
  vm.addresses = {
    add: addAddress,
    selectedState: selectedState,
    delete: deleteAddress,
  };

  function deleteFile(file) {
    var url = vm.form ? vm.form.url : vm.juridicalForm.url;
    fileService.deleteFile(file, vm.files);
  }

  function addAddress(type) {
    // HACK remove before production
    var address = {
      raw: "",
      street_address: "",
      intersection: "",
      political: "",
      administrative_area_level_1: "",
      administrative_area_level_1_short: "",
      administrative_area_level_2: "",
      administrative_area_level_3: "",
      colloquial_area: "",
      sublocality: "",
      neighborhood: "",
      premise: "",
      subpremise: "",
      natural_feature: "",
      country: "",
      country_code: "",
      locality: "",
      postal_code: "",
      route: "",
      street_number: "",
      street_number_int: "",
      formatted: "",
      latitude: "",
      longitude: "",
      details: "",
      composed: "",
    };
    if (type === 1) {
      vm.form.userAddresses.push(address);
    } else {
      vm.juridicalForm.userAddresses.push(address);
    }
  }

  function deleteContractor(id, selector) {
    swal(
      {
        title: "¿Estás seguro?",
        text: "¿Desea eliminar el contratante?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Si, estoy seguro.",
        cancelButtonText: "Cancelar",
        closeOnConfirm: false,
        closeOnCancel: false,
      },
      function (isConfirm) {
        if (isConfirm) {
          var data_email = {
            id: id,
            model: 3,
            type_person: selector,
          };
          $http
            .post(url.IP + "delete-contractor/", { id: id, selector: selector })
            .then(function (response) {
              if (response.data.status === "error") {
                SweetAlert.swal(
                  "No se puede eliminar",
                  MESSAGES.WARNING.WARNINGCONTRACTOR,
                  "info"
                );
                return;
              } else {
                $http
                  .patch($scope.contractor.url, { is_active: false })
                  .then(function (response) {
                    if (response.status === 200 || response.status === 201) {
                      var params = {
                        model: $scope.contractor.type_person == 1 ? 26 : 26,
                        event: "POST",
                        associated_id: $scope.contractor.id,
                        identifier: "elimino el contratante",
                      };
                      dataFactory
                        .post("send-log/", params)
                        .then(function success(response) {});
                      dataFactory
                        .post("send-email-admins-deletes/", data_email)
                        .then(function success(req) {});
                      SweetAlert.swal(
                        "¡Listo!",
                        MESSAGES.OK.DELETECONTRATANTE,
                        "success"
                      );
                      $state.go("contratantes.main");
                    }
                  });
              }
            });
        } else {
          SweetAlert.swal("Cancelado", MESSAGES.INFO.CANCELCONTRACTOR, "error");
        }
      }
    );
  }
  // function deleteContractor(id, selector) {
  //   $http.post(url.IP + 'delete-contractor/',{'id':id, 'selector': selector}).then(function(response) {
  //     if (response.data.status == 'error'){
  //       SweetAlert.swal("Error", "El contratante tiene pólizas asignadas", "error");
  //     }
  //     else{
  //       if (response.data.status == 'success'){
  //         SweetAlert.swal("¡Listo!", "El contratante ha sido eliminado", "success");
  //       }
  //       setTimeout(function() {$state.go('contratantes.main');}, 1000);
  //     }
  //   });
  // }

  function deleteAddress(index, type) {
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/contratantes/contratantes.deleteAddress.html",
      controller: ModalInstanceCtrlDeleteAddress,
      resolve: {
        addressContext: function () {
          return {
            index: index,
            type: type,
          };
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
      //windowClass: 'animated fadeIn'
    });
  }

  vm.emails = {
    add: addEmail,
    delete: deleteEmail,
  };

  vm.emailToSend = [];
  vm.toDeleteEmails = [];

  function addEmail(type) {
    if (type === 1) {
      vm.form.correo = "";
      var addEmails = {
        correo: vm.form.correo,
        email_type: 0,
      };
      vm.form.email_natural.push(addEmails);
    } else {
      vm.juridicalForm.correo = "";
      var addEmails = {
        correo: vm.juridicalForm.correo,
        email_type: 0,
      };
      vm.juridicalForm.email_juridical.push(addEmails);
    }
  }
  function deleteEmail(index, type, item) {
    if (type === 1) {
      vm.form.email_natural.splice(index, 1);
      vm.toDeleteEmails.push(item);
    } else {
      vm.juridicalForm.email_juridical.splice(index, 1);
      vm.toDeleteEmails.push(item);
    }
  }
  $scope.sendEmails = function (id, typePerson) {
    if (typePerson == 1) {
      $scope.origin_email = angular.copy(vm.form.email_natural);
      if (vm.form.email_natural) {
        for (var i = 0; i < vm.form.email_natural.length; i++) {
          if (!vm.form.email_natural[i].url) {
            vm.correo = {
              correo: vm.form.email_natural[i].correo,
              juridical: null,
              // natural: vm.form.url,
              contractor: vm.form.url,
              email_type: vm.form.email_natural[i].email_type
                ? vm.form.email_natural[i].email_type
                : 1,
            };
            vm.emailToSend.push(vm.correo);
          } else {
            $http
              .patch(vm.form.email_natural[i].url, vm.form.email_natural[i])
              .then(function success(request) {})
              .catch(function (e) {
                console.log(e);
              });
          }
        }
      }
    } else {
      if (vm.juridicalForm.email_juridical) {
        for (var i = 0; i < vm.juridicalForm.email_juridical.length; i++) {
          if (!vm.juridicalForm.email_juridical[i].url) {
            vm.correo = {
              correo: vm.juridicalForm.email_juridical[i].correo,
              // juridical: vm.juridicalForm.url,
              contractor: vm.juridicalForm.url,
              natural: null,
              email_type: vm.juridicalForm.email_juridical[i].email_type
                ? vm.juridicalForm.email_juridical[i].email_type
                : 1,
            };
            vm.emailToSend.push(vm.correo);
          } else {
            $http
              .patch(
                vm.juridicalForm.email_juridical[i].url,
                vm.juridicalForm.email_juridical[i]
              )
              .then(function success(request) {})
              .catch(function (e) {
                console.log(e);
              });
          }
        }
      }
    }

    vm.toDeleteEmails.forEach(function (del) {
      if (del.url) {
        $http.delete(del.url);

        $scope.changes = [];

        var change_log = {
          name: "Correos Electrónicos",
          origin: del.correo,
          change: "",
        };
        $scope.changes.push(change_log);

        var paramsRec = {
          model: 26,
          event: "PATCH",
          associated_id: $scope.origin_contractor.id,
          identifier: " actualizó el contratante.",
          change: $scope.changes,
        };

        if ($scope.changes.length > 0) {
          dataFactory
            .post("send_log_specific/", paramsRec)
            .then(function success(response) {});
        }
      }
    });

    $http
      .post(url.IP + "emails/", vm.emailToSend)
      .then(
        function success(request) {
          vm.form = {
            email: "",
            phone: "",
          };
          vm.form.email = request.data;
          $scope.changes = [];

          for (var i = 0; i < request.data.length; i++) {
            var change_log = {
              name: "Correos Electrónicos",
              origin: "",
              change: request.data[i].correo,
            };
            $scope.changes.push(change_log);
            if (i + 1 == request.data.length) {
              var paramsRec = {
                model: 26,
                event: "PATCH",
                associated_id: $scope.origin_contractor.id,
                identifier: " actualizó el contratante.",
                change: $scope.changes,
              };

              if ($scope.changes.length > 0) {
                dataFactory
                  .post("send_log_specific/", paramsRec)
                  .then(function success(response) {});
              }
            }
          }
        },
        function error(error) {
          console.log(error);
        }
      )
      .catch(function (e) {
        console.log(e);
      });
  };

  $rootScope.changeGroup = function (data) {
    if (data) {
      if (data.id) {
        dataFactory
          .post("subgrupos-match/", { parent: data.id })
          .then(function (subgrupos_) {
            vm.subgroups = subgrupos_.data;
          });
      } else {
        if (data) {
          if (data.subgrupos) {
            vm.subgroups = data.subgrupos;
          } else {
            vm.subgroups = [];
          }
        } else {
          vm.subgroups = [];
        }
      }
    } else {
      vm.subgroups = [];
    }
  };

  $rootScope.changeSubGroup = function (data) {
    // if (data) {
    //   if (data.id) {
    //     dataFactory.post('subsubgrupos-match/', { parent: data.id })
    //     .then(function(subgrupos_2) {
    //         $scope.sub_subgroups = subgrupos_2.data;
    //     });
    //   }else{
    if (data) {
      if (data.subsubgrupos) {
        vm.sub_subgroups = data.subsubgrupos;
      } else {
        vm.sub_subgroups = [];
      }
    } else {
      vm.sub_subgroups = [];
    }
    //   }
    // }else{$scope.sub_subgroups = [];}
  };

  $rootScope.changeAgrupacion2 = function (data) {
    // $scope.sub_asignaciones = data.subgrupos;
    if (data) {
      if (data.id) {
        dataFactory
          .post("subagrupaciones-match/", { parent: data.id })
          .then(function (subgrupos_) {
            $scope.sub_asignaciones = subgrupos_.data;
          });
        $scope.sub_subasignaciones = [];
      } else {
        if (data) {
          if (data.subgrupos) {
            $scope.sub_asignaciones = data.subgrupos;
          } else {
            $scope.sub_asignaciones = [];
          }
        } else {
          $scope.sub_asignaciones = [];
        }
      }
    } else {
      $scope.sub_asignaciones = [];
    }
  };

  $rootScope.changeSubagrupacion2 = function (data) {
    if (data) {
      if (data.subsubgrupos) {
        $scope.sub_subasignaciones = data.subsubgrupos;
      } else {
        if (data.subgrupos) {
          $scope.sub_subasignaciones = data.subgrupos;
        } else {
          $scope.sub_subasignaciones = [];
        }
      }
    } else {
      $scope.sub_subasignaciones = [];
    }
  };

  vm.phones = {
    add: addPhone,
    delete: deletePhone,
  };

  vm.phoneToSend = [];
  vm.toDeletePhones = [];

  function addPhone(type) {
    if (type === 1) {
      var addPhones = {
        phone: vm.form.phone,
        phone_type: 0,
      };
      vm.form.phone_natural.push(addPhones);
    } else {
      var addPhones = {
        phone: vm.juridicalForm.phone,
        phone_type: 0,
      };
      vm.juridicalForm.phone_juridical.push(addPhones);
    }
  }
  function deletePhone(index, type, item) {
    if (type === 1) {
      vm.form.phone_natural.splice(index, 1);
      vm.toDeletePhones.push(item);
    } else {
      vm.juridicalForm.phone_juridical.splice(index, 1);
      vm.toDeletePhones.push(item);
    }
  }
  $scope.sendPhones = function (id, typePerson) {
    if (typePerson == 1) {
      if (vm.form.phone_natural) {
        for (var i = 0; i < vm.form.phone_natural.length; i++) {
          if (!vm.form.phone_natural[i].url) {
            vm.telefono = {
              phone: vm.form.phone_natural[i].phone,
              juridical: null,
              // natural: vm.form.url,
              contractor: vm.form.url,
              phone_type: vm.form.phone_natural[i].phone_type
                ? vm.form.phone_natural[i].phone_type
                : 1,
            };
            vm.phoneToSend.push(vm.telefono);
          } else {
            $http
              .patch(vm.form.phone_natural[i].url, vm.form.phone_natural[i])
              .then(function success(request) {})
              .catch(function (e) {
                console.log(e);
              });
          }
        }
      }
    } else {
      if (vm.juridicalForm.phone_juridical) {
        for (var i = 0; i < vm.juridicalForm.phone_juridical.length; i++) {
          if (!vm.juridicalForm.phone_juridical[i].url) {
            vm.telefono = {
              phone: vm.juridicalForm.phone_juridical[i].phone,
              // juridical: vm.juridicalForm.url,
              contractor: vm.juridicalForm.url,
              natural: null,
              phone_type: vm.juridicalForm.phone_juridical[i].phone_type
                ? vm.juridicalForm.phone_juridical[i].phone_type
                : 1,
            };
            vm.phoneToSend.push(vm.telefono);
          } else {
            $http
              .patch(
                vm.juridicalForm.phone_juridical[i].url,
                vm.juridicalForm.phone_juridical[i]
              )
              .then(function success(request) {})
              .catch(function (e) {
                console.log(e);
              });
          }
        }
      }
    }

    vm.toDeletePhones.forEach(function (phone) {
      if (phone.url) {
        $http.delete(phone.url);
      }
    });

    $http
      .post(url.IP + "phones/", vm.phoneToSend)
      .then(
        function success(request) {
          vm.form = {
            phone: request.data,
          };
        },
        function error(error) {
          console.log(error);
        }
      )
      .catch(function (e) {
        console.log(e);
      });
  };

  vm.closeDropdown = closeDropdown;

  function closeDropdown() {
    $(".hasDropdown").removeClass("open");
  }

  function ModalInstanceCtrlDeleteAddress(
    $scope,
    $uibModalInstance,
    addressContext
  ) {
    var index = addressContext.index;
    var type = addressContext.type;
    $scope.ok = function () {
      if (!index && index != 0) {
        if (type === 1) {
          vm.form.userAddresses.splice(index, 1);
        } else {
          vm.juridicalForm.userAddresses.splice(index, 1);
        }
      } else {
        try {
          if (type === 1) {
            if (vm.form) {
              var obj = vm.form.userAddresses[index];
              generalService.deleteService(obj);
              vm.form.userAddresses.splice(index, 1);
            } else {
              generalService.deleteService(
                vm.juridicalForm.userAddresses[index]
              );
              vm.juridicalForm.userAddresses.splice(index, 1);
            }
          } else {
            generalService.deleteService(vm.juridicalForm.userAddresses[index]);
            vm.juridicalForm.userAddresses.splice(index, 1);
          }
          toaster.success(MESSAGES.OK.DELETEADDRESS);
          $uibModalInstance.dismiss("cancel");
        } catch (err) {
          if (type === 1) {
            if (vm.form) {
              vm.form.userAddresses.splice(index, 1);
            } else {
              vm.juridicalForm.userAddresses.splice(index, 1);
            }
          } else {
            vm.juridicalForm.userAddresses.splice(index, 1);
          }
        }
      }
      $uibModalInstance.dismiss("cancel");
    };

    $scope.cancel = function () {
      if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
    };
  }

  var obligados1 = {
    obligado: {},
  };
  $scope.addObligados = function (type) {
    if (type === 1) {
      var addobligadoss = {
        obligado: obligados1,
      };
      if (vm.form) {
        vm.form.obligados.push(addobligadoss);
      }
    } else {
      var addobligadoss = {
        obligado: obligados1,
      };
      if (vm.juridicalForm) {
        vm.juridicalForm.obligados.push(addobligadoss);
      }
    }
  };
  $scope.deleteObligados = function (index, type) {
    if (type === 1) {
      vm.form.obligados.splice(index, 1);
    } else {
      vm.juridicalForm.obligados.splice(index, 1);
    }
  };
  $scope.addResponsable = function (type) {
    if (type === 1) {
      var addresponsables = {
        responsables: vm.form.responsable,
        resp_type: 0,
      };
      vm.form.resp_contractor.push(addresponsables);
    } else {
      var addresponsables = {
        responsables: vm.juridicalForm.responsable
          ? vm.juridicalForm.responsable
          : null,
        resp_type: 0,
      };
      vm.juridicalForm.resp_contractor.push(addresponsables);
    }
  };

  $scope.deleteResponsable = function (index, type) {
    if (type === 1) {
      if (vm.form.resp_contractor[index].url) {
        $http.delete(vm.form.resp_contractor[index].url);
      }

      vm.form.resp_contractor.splice(index, 1);
    } else {
      if (vm.juridicalForm.resp_contractor[index].url) {
        $http.delete(vm.juridicalForm.resp_contractor[index].url);
      }
      vm.juridicalForm.resp_contractor.splice(index, 1);
    }
  };

  function selectedState(selected, index, type) {
    if (type === 1) {
      vm.form.userAddresses[index].city = "";
      vm.form.userAddresses[index].citiesList = selected.cities;
    } else {
      vm.juridicalForm.userAddresses[index].city = "";
      vm.juridicalForm.userAddresses[index].citiesList = selected.cities;
    }
  }

  if ($stateParams.type === "fisicas") vm.form = {};
  else vm.juridicalForm = {};

  vm.emptyOrNull = function (item) {
    return !(item === null || item.trim().length === 0);
  };
  vm.contratanteId = $stateParams.contratanteId;

  activate();
  $scope.sucursal = function (sc) {};
  function activate() {
    $scope.moduleName = "Célula";
    $scope.campo_agrupacion = false;
    $scope.campo_celula = false;
    $scope.campo_lineanegocio = false;
    dataFactory.get("orginfo/").then(function success(response) {
      if (response.data.results.length) {
        $scope.configuracionGlobal = response.data.results[0];
        if ($scope.configuracionGlobal.moduleName) {
          $scope.moduleName = $scope.configuracionGlobal.moduleName;
        }
        $scope.campo_agrupacion = $scope.configuracionGlobal.filtros_agrupacion;
        $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
        $scope.campo_lineanegocio =
          $scope.configuracionGlobal.filtros_lineanegocio;
      }
    });
    $scope.extraFields = false;
    if ($localStorage["last_state_visited"]) {
      $scope.last_state_visited = true;
    } else {
      $scope.last_state_visited = false;
    }
    dataFactory
      .get("sucursales-to-show-unpag/")
      .then(function success(response) {
        $scope.sucursalList = response.data;
      });

    $http.get(url.IP + "get-vendors").then(function success(request) {
      vm.vendors = request.data;
      vm.vendors.forEach(function (vendor) {
        vendor.name = vendor.first_name + " " + vendor.last_name;
      });
    });

    $http.get(url.IP + "usuarios/").then(function (user) {
      vm.responsables = user.data.results;
    });

    $http({
      method: "GET",
      url: url.IP + "comments/",
      params: {
        model: 2,
        id_model: vm.contratanteId,
      },
    })
      .then(function (request) {
        vm.comments_data = request.data.results;
        vm.comments_config = {
          count: request.data.count,
          next: request.data.next,
          previous: request.data.previous,
        };
      })
      .catch(function (e) {
        console.log("e", e);
      });

    $http.get(url.IP + "classification/").then(function (response) {
      vm.clasifications = response.data.results;
    });
    $http.post(url.IP + "celula_contractor_info/").then(function (response) {
      vm.celulas = response.data;
    });

    $http.get(url.IP + "groupingLevel-resume/").then(function (response) {
      vm.agrupaciones = response.data;
    });

    $window.localStorage.editCont = true;
    groupService.getGroups().then(function (groups) {
      vm.groups = groups;
    });

    $scope.view_siniestros = true;

    ContratanteService.getContratanteFull($stateParams)
      .then(function (contractor) {
        $scope.contractorId = contractor.id;
        $scope.origin_contractor = angular.copy(contractor);
        $scope.contractor = contractor;
        $stateParams.contractor = contractor;
        var contractor = $scope.contractor;
        if (contractor.type_person == 2) {
          vm.juridicalForm.recordatorios = $scope.contractor.recordatorios;
          $scope.infoMoral = contractor;
          vm.listDocument = [
            {
              id: 1,
              name: "Acta Constitutiva",
              value: contractor.constitutive_act,
              file: false,
              arch: {},
            },
            {
              id: 2,
              name: "Constancia Situación Fiscal",
              value: contractor.rfc_document,
              file: false,
              arch: {},
            },
            {
              id: 3,
              name: "Cédula de Identificación Fiscal",
              value: contractor.card_official_identification,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio Fiscal",
              value: contractor.voucher_of_address,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Modificaciones al Acta Constitutiva",
              value: contractor.modifications_constitutive_act,
              file: false,
              arch: {},
            },
            {
              id: 6,
              name: "Poder",
              value: contractor.fiscal_power,
              file: false,
              arch: {},
            },
            {
              id: 7,
              name: "INE Representante Legal",
              value: contractor.ine_representante,
              file: false,
              arch: {},
            },
          ];
          if (contractor.only_sureties) {
            vm.listDocument.push(
              {
                id: 7,
                name: "Currículo reciente",
                value: contractor.curriculo,
                file: false,
                arch: {},
              },
              {
                id: 8,
                name: "Contrato multiple de la afianzadora",
                value: contractor.contrato_multiple_afianzadora,
                file: false,
                arch: {},
              },
              {
                id: 9,
                name: "Carta Buró",
                value: contractor.carta_buro,
                file: false,
                arch: {},
              },
              {
                id: 10,
                name: "Cuestionario o entrevista",
                value: contractor.entrevista_afianzadora,
                file: false,
                arch: {},
              },
              {
                id: 11,
                name: "Aviso de privacidad de la afianzadora",
                value: contractor.aviso_privacidad,
                file: false,
                arch: {},
              },
              {
                id: 12,
                name: "Protocolizaciones",
                value: contractor.protocolizaciones,
                file: false,
                arch: {},
              },
              {
                id: 13,
                name: "Alta de empresa ante hacienda",
                value: contractor.alta_hacienda,
                file: false,
                arch: {},
              },
              {
                id: 14,
                name: "Cambio de domicilio ante hacienda",
                value: contractor.cambio_domicilio_hacienda,
                file: false,
                arch: {},
              },
              {
                id: 15,
                name: "Copia del comprobante de inscripción para la e.firma (firma electrónica)",
                value: contractor.cambio_domicilio_hacienda,
                file: false,
                arch: {},
              },
              {
                id: 16,
                name: "Declaración anual completa con cadena, de los últimos dos años",
                value: contractor.declaracion_anual,
                file: false,
                arch: {},
              },
              {
                id: 17,
                name: "Estados financieros dictaminados cuadernillo completo, del año inmediato anterior",
                value: contractor.estados_financieros_anuales,
                file: false,
                arch: {},
              },
              {
                id: 18,
                name: "Estados financieros parciales los más recientes de este año con no mayor antigüedad de dos meses",
                value: contractor.estados_financieros_parciales,
                file: false,
                arch: {},
              },
              {
                id: 19,
                name: "Escritura de inmueble",
                value: contractor.escritura_inmueble,
                file: false,
                arch: {},
              },
              {
                id: 20,
                name: "Boleta predial o avaluó",
                value: contractor.boleta_predial,
                file: false,
                arch: {},
              },
              {
                id: 21,
                name: "Certificado de libertad de gravamen",
                value: contractor.certificado_gravamen,
                file: false,
                arch: {},
              }
            );
          }
        }
        if (contractor.type_person == 1) {
          if ($scope.contractor && $scope.contractor.recordatorios && vm.form) {
            vm.form.recordatorios = $scope.contractor.recordatorios;
          }
          $scope.infoFisico = contractor;
          if (vm.org_name == "ancora") {
            vm.listDocument = [
              {
                id: 1,
                name: "Identificación Oficial",
                value: contractor.card_official_identification,
                file: false,
                arch: {},
              },
              {
                id: 2,
                name: "CURP",
                value: contractor.CURP,
                file: false,
                arch: {},
              },
              {
                id: 3,
                name: "Comprobante de Inscripción de Firma Electrónica",
                value: contractor.voucher_efirm,
                file: false,
                arch: {},
              },
              {
                id: 4,
                name: "Comprobante de Domicilio",
                value: contractor.voucher_of_address,
                file: false,
                arch: {},
              },
              {
                id: 5,
                name: "Formato de Identificación de Cliente Firmado",
                value: contractor.signed_format_ic,
                file: false,
                arch: {},
              },
            ];
            if (contractor.only_sureties) {
              vm.listDocument.push(
                {
                  id: 7,
                  name: "Carta nombramiento",
                  value: contractor.carta_nombramiento,
                  file: false,
                  arch: {},
                },
                {
                  id: 8,
                  name: "Currículo",
                  value: contractor.curriculo,
                  file: false,
                  arch: {},
                },
                {
                  id: 9,
                  name: "Contrato multiple de la afianzadora",
                  value: contractor.contrato_multiple_afianzadora,
                  file: false,
                  arch: {},
                },
                {
                  id: 10,
                  name: "Carta buro",
                  value: contractor.carta_buro,
                  file: false,
                  arch: {},
                },
                {
                  id: 11,
                  name: "Entrevista con la afianzadora",
                  value: contractor.entrevista_afianzadora,
                  file: false,
                  arch: {},
                },
                {
                  id: 12,
                  name: "RFC",
                  value: contractor.rfc_document,
                  file: false,
                  arch: {},
                },
                {
                  id: 13,
                  name: "Recibos de nomina",
                  value: contractor.recibos_nomina,
                  file: false,
                  arch: {},
                },
                {
                  id: 14,
                  name: "Declaración anual completa con cadena de los últimos dos años inmediatos anteriores",
                  value: contractor.declaracion_anual,
                  file: false,
                  arch: {},
                },
                {
                  id: 15,
                  name: "Estados financieros anuales del año inmediato anterior",
                  value: contractor.estados_financieros_anuales,
                  file: false,
                  arch: {},
                },
                {
                  id: 16,
                  name: "Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años",
                  value: contractor.estados_financieros_parciales,
                  file: false,
                  arch: {},
                },
                {
                  id: 17,
                  name: "Alta ante hacienda o alta electrónica",
                  value: contractor.alta_hacienda,
                  file: false,
                  arch: {},
                },
                {
                  id: 18,
                  name: "Escritura de inmueble",
                  value: contractor.escritura_inmueble,
                  file: false,
                  arch: {},
                },
                {
                  id: 19,
                  name: "Boleta predial o avaluó",
                  value: contractor.boleta_predial,
                  file: false,
                  arch: {},
                },
                {
                  id: 20,
                  name: "Certificado de libertad de gravamen",
                  value: contractor.certificado_gravamen,
                  file: false,
                  arch: {},
                }
              );
            }
          } else {
            vm.listDocument = [
              {
                id: 1,
                name: "Identificación Oficial",
                value: contractor.card_official_identification,
                file: false,
                arch: {},
              },
              {
                id: 2,
                name: "CURP",
                value: contractor.CURP,
                file: false,
                arch: {},
              },
              {
                id: 3,
                name: "Comprobante de Inscripción de Firma Electrónica",
                value: contractor.voucher_efirm,
                file: false,
                arch: {},
              },
              {
                id: 4,
                name: "Comprobante de Domicilio",
                value: contractor.voucher_of_address,
                file: false,
                arch: {},
              },
              {
                id: 5,
                name: "Formato de Identificación de Cliente Firmado",
                value: contractor.signed_format_ic,
                file: false,
                arch: {},
              },
              {
                id: 6,
                name: "Poder",
                value: contractor.fiscal_power,
                file: false,
                arch: {},
              },
              {
                id: 7,
                name: "Constancia Situacion Fiscal",
                value: contractor.constancia_situacion_fiscal,
                file: false,
                arch: {},
              },
            ];
            if (contractor.only_sureties) {
              vm.listDocument.push(
                {
                  id: 7,
                  name: "Carta nombramiento",
                  value: contractor.carta_nombramiento,
                  file: false,
                  arch: {},
                },
                {
                  id: 8,
                  name: "Currículo",
                  value: contractor.curriculo,
                  file: false,
                  arch: {},
                },
                {
                  id: 9,
                  name: "Contrato multiple de la afianzadora",
                  value: contractor.contrato_multiple_afianzadora,
                  file: false,
                  arch: {},
                },
                {
                  id: 10,
                  name: "Carta buro",
                  value: contractor.carta_buro,
                  file: false,
                  arch: {},
                },
                {
                  id: 11,
                  name: "Entrevista con la afianzadora",
                  value: contractor.entrevista_afianzadora,
                  file: false,
                  arch: {},
                },
                {
                  id: 12,
                  name: "RFC",
                  value: contractor.rfc_document,
                  file: false,
                  arch: {},
                },
                {
                  id: 13,
                  name: "Recibos de nomina",
                  value: contractor.recibos_nomina,
                  file: false,
                  arch: {},
                },
                {
                  id: 14,
                  name: "Declaración anual completa con cadena de los últimos dos años inmediatos anteriores",
                  value: contractor.declaracion_anual,
                  file: false,
                  arch: {},
                },
                {
                  id: 15,
                  name: "Estados financieros anuales del año inmediato anterior",
                  value: contractor.estados_financieros_anuales,
                  file: false,
                  arch: {},
                },
                {
                  id: 16,
                  name: "Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años",
                  value: contractor.estados_financieros_parciales,
                  file: false,
                  arch: {},
                },
                {
                  id: 17,
                  name: "Alta ante hacienda o alta electrónica",
                  value: contractor.alta_hacienda,
                  file: false,
                  arch: {},
                },
                {
                  id: 18,
                  name: "Escritura de inmueble",
                  value: contractor.escritura_inmueble,
                  file: false,
                  arch: {},
                },
                {
                  id: 19,
                  name: "Boleta predial o avaluó",
                  value: contractor.boleta_predial,
                  file: false,
                  arch: {},
                },
                {
                  id: 20,
                  name: "Certificado de libertad de gravamen",
                  value: contractor.certificado_gravamen,
                  file: false,
                  arch: {},
                }
              );
            }
          }
        }

        $http({
          method: "GET",
          url: url.IP + "notas-by-contractor/",
          params: {
            contractor: contractor.id,
            type_contractor:
              contractor.type_person === 1 ? "natural" : "juridical",
          },
        }).then(function success(response) {
          vm.notas = response.data;
        });
        if (contractor.bound_solidarity_many) {
          if (contractor.bound_solidarity_many.length > 0) {
            $scope.solidarios = [];
            contractor.bound_solidarity_many.forEach(function (cons) {
              $http.get(cons).then(function (request) {
                $scope.solidarios.push(angular.copy(request.data));
              });
            });
          }
        }
        if (contractor.bound_solidarity) {
          if (contractor.bound_solidarity) {
            $scope.url_solidario = contractor.bound_solidarity;
          }
          $http.get($scope.url_solidario).then(function (request) {
            $scope.solidario = angular.copy(request.data);

            vm.contratante = {};
            if (request.data.address_contractor) {
              vm.contratante.val = request.data.full_name;
              vm.contratante.value = request.data;
            } else {
              vm.contratante.val = request.data.full_name;
              vm.contratante.value = request.data;
            }
          });
        }
        if (contractor.classification) {
          $http.get(contractor.classification).then(function (request) {
            if (contractor.type_person === 1) {
              vm.form.classification = request.data.url;
              // $scope.infoFisico.classification = request.data;
              $scope.infoFisicoc = request.data;
            } else {
              vm.juridicalForm.classification = request.data.url;
              $scope.infoMoralc = request.data;
              // vm.juridicalForm.clasification = request.data;
              // vm.clasifications.forEach(function(item){
              //   if(item.url == vm.juridicalForm.classification.url){
              //   }
              // });
            }
          });
        }

        contractor.cellule = contractor.cellule;
        if (contractor.cellule) {
          $http.get(contractor.cellule).then(function (request) {
            if (contractor.type_person === 1) {
              vm.form.celula = request.data.url;
              $scope.infoFisicocel = request.data;
            } else {
              vm.juridicalForm.cellule = request.data;
              if (vm.juridicalForm.cellule.url) {
                vm.celulas.forEach(function (item) {
                  if (item.url == vm.juridicalForm.cellule.url) {
                    vm.juridicalForm.celula = item.url;
                    vm.juridicalForm.cellule = item.url;
                    $scope.infoMoralcel = request.data;
                  }
                });
              } else {
                vm.celulas.forEach(function (item) {
                  if (item.url == vm.juridicalForm.cellule) {
                    vm.juridicalForm.celula = item.url;
                    vm.juridicalForm.cellule = item.url;
                    $scope.infoMoralcel = request.data;
                  }
                });
              }
            }
          });
        }
        contractor.groupinglevel = contractor.groupinglevel;
        if (contractor.groupinglevel) {
          $http.get(contractor.groupinglevel).then(function (data) {
            if (data.data.type_grouping == 3) {
              $http.get(data.data.parent).then(function (subgroup) {
                if (subgroup.data.type_grouping == 2) {
                  $http.get(subgroup.data.parent).then(function (group) {
                    var groupInfo = {
                      group_name: group.data.description,
                      subgroup_name: subgroup.data.description,
                      subsubgroup_name: data.data.description,
                    };
                    if (contractor.type_person === 1) {
                      vm.form.grouping_level = groupInfo;
                    } else {
                      vm.juridicalForm.grouping_level = groupInfo;
                    }
                    $http
                      .get(url.IP + "groupingLevel-resume/")
                      .then(function (response) {
                        vm.agrupaciones = response.data;
                        vm.agrupaciones.forEach(function (item) {
                          if (item.url == group.data.url) {
                            vm.editForm.grouping_level = item;
                            $rootScope.changeAgrupacion2(item);
                            item.subgrupos.forEach(function (sub) {
                              if (sub.url == subgroup.data.url) {
                                vm.editForm.subagrupaciones = sub;
                                $rootScope.changeSubagrupacion2(sub);
                                sub.subsubgrupos.forEach(function (subsub) {
                                  if (subsub.url == data.data.url) {
                                    vm.editForm.subsubasignaciones = subsub;
                                  }
                                });
                              }
                            });
                          }
                        });
                      });
                  });
                }
              });
            } else {
              if (data.data.type_grouping == 2) {
                $http.get(data.data.parent).then(function (group) {
                  var groupInfo = {
                    group_name: group.data.description,
                    subgroup_name: data.data.description,
                  };
                  if (contractor.type_person === 1) {
                    vm.form.grouping_level = groupInfo;
                  } else {
                    vm.juridicalForm.grouping_level = groupInfo;
                  }
                  $http
                    .get(url.IP + "groupingLevel-resume/")
                    .then(function (response) {
                      vm.agrupaciones = response.data;
                      vm.agrupaciones.forEach(function (item) {
                        if (item.url == group.data.url) {
                          vm.editForm.grouping_level = item;
                          $rootScope.changeAgrupacion2(item);
                          item.subgrupos.forEach(function (sub) {
                            if (sub.url == data.data.url) {
                              vm.editForm.subagrupaciones = sub;
                              $rootScope.changeSubagrupacion2(sub);
                            }
                          });
                        }
                      });
                    });
                });
              } else {
                var groupInfo = {
                  group_name: data.data.description,
                };
                if (contractor.type_person === 1) {
                  vm.form.grouping_level = groupInfo;
                } else {
                  vm.juridicalForm.grouping_level = groupInfo;
                }
                $http
                  .get(url.IP + "groupingLevel-resume/")
                  .then(function (response) {
                    vm.agrupaciones = response.data;
                    vm.agrupaciones.forEach(function (item) {
                      if (item.url == data.data.url) {
                        vm.editForm.grouping_level = item;
                        $rootScope.changeAgrupacion2(item);
                      }
                    });
                  });
              }
            }
          });
        }
        if (contractor.type_person === 1) {
          try {
            // var date = contractor.birthday;
            var date = contractor.birth_date;
            var newdate = date.split("-").reverse().join("/");
            contractor.birthday = newdate;
          } catch (e) {}
          var naturalDraft = savedEditions.natural;
          if (naturalDraft && naturalDraft.id === contractor.id) {
            vm.form = angular.copy(naturalDraft);
          } else {
            vm.form = $scope.origin_contractor;
            vm.form.userAddresses = $scope.origin_contractor.address_contractor;
            vm.form.userAddresses.forEach(function (address) {
              $http
                .get(url.IP + "ok-to-delete/" + address.id + "/")
                .then(function success(response) {
                  if (response.data) {
                    address.can_delete = true;
                  } else {
                    address.can_delete = false;
                  }
                });
              if (vm.statesArray) {
                vm.statesArray.some(function (state) {
                  if (state.state == address.administrative_area_level_1) {
                    address.administrative_area_level_1 = state;
                    state.cities.some(function (city) {
                      if (city.city == address.administrative_area_level_2) {
                        address.administrative_area_level_2 = city;
                      }
                    });
                  }
                });
              }
              vm.address_type.forEach(function (item) {
                if (item.name == address.tipo) {
                  address.tipo = item;
                }
              });
            });
          }
          vm.form.birthday = datesFactory.convertDate(contractor.birth_date);
          vm.form.contact_natural = contractor.contact_contractor;
          // if(vm.form.address_natural){
          //   if(vm.form.address_natural.length == 0){
          //     vm.form.address_natural = [{
          //       raw: '',
          //     }];
          //   }
          // }
          if (contractor.vendor) {
            vm.form.vendedor = contractor.vendor;
          }
          if (contractor.sucursal) {
            vm.form.sucursal = contractor.sucursal;
          }
          if (contractor.responsable) {
            if (contractor.responsable) {
              if (contractor.responsable.url) {
                $http
                  .get(contractor.responsable.url)
                  .then(
                    function success(request) {
                      if (request.status === 200) {
                        vm.form.responsable = request.data;
                      }
                    },
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              } else {
                $http
                  .get(contractor.responsable)
                  .then(
                    function success(request) {
                      if (request.status === 200) {
                        vm.form.responsable = request.data;
                      }
                    },
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              }
            } else {
              $http.get(url.IP + "usuarios/").then(function (user) {
                vm.responsables = user.data.results;
              });
            }
          }
          vm.form.contact_natural = contractor.contact_contractor;
          vm.form.email_natural = vm.form.email_contractor;
          vm.form.phone_natural = vm.form.phone_contractor;
          vm.form.address_natural = vm.form.address_contractor;
          if (!vm.form.email_natural.length) {
            // vm.form.email_natural.push({
            //   email: "",
            //   email_type: 0
            // });
          } else {
            vm.form.email_natural.forEach(function (data, index) {
              if (data.correo == vm.form.email) {
                vm.form.email_natural.splice(index, 1);
              }
            });
            // if(vm.form.email_natural.length == 0){
            //   vm.form.email_natural.push({
            //     email: "",
            //     email_type: 0
            //   });
            // }
          }
          if (!vm.form.phone_natural.length) {
            // vm.form.phone_natural.push({
            //   phone: "",
            //   phone_type: 0
            // });
          } else {
            vm.form.phone_natural.forEach(function (data, index) {
              if (data.phone == vm.form.phone_number) {
                vm.form.phone_natural.splice(index, 1);
              }
            });
            // if(vm.form.phone_natural.length == 0){
            //   vm.form.phone_natural.push({
            //     phone: "",
            //     phone_type: 0
            //   });
            // }
          }

          contractor.userAddresses = contractor.address_contractor;
          if (contractor.userAddresses.length == 0) {
            addAddress(1);
          }
          if (contractor.bound_solidarity_many) {
            if (contractor.bound_solidarity_many.length > 0) {
              vm.form.obligados = [];
              contractor.bound_solidarity_many.forEach(function (cons) {
                $http.get(cons).then(function (request) {
                  var obligados1 = {
                    obligado: request.data,
                  };
                  var obj1 = {
                    label: request.data.full_name,
                    value: request.data,
                    val: request.data.full_name,
                  };
                  vm.form.obligados.push(obj1);
                });
              });
            } else {
              vm.form.obligados = [];
              $scope.addObligados(1);
            }
          } else {
            vm.form.obligados = [];
            $scope.addObligados(1);
          }
        } else {
          vm.juridicalForm.contact_juridical = contractor.contact_contractor;
          vm.juridicalForm.email_juridical = contractor.email_contractor;
          vm.juridicalForm.phone_juridical = contractor.phone_contractor;
          vm.juridicalForm.address_juridical = contractor.address_contractor;
          vm.juridicalForm.j_name = contractor.full_name;
          try {
            // var date = contractor.date_of_establishment;
            var date = contractor.birth_date;
            var newdate = date.split("-").reverse().join("/");
            contractor.date_of_establishment = newdate;
          } catch (e) {}
          var juridicalDraft = savedEditions.juridical;
          var hasJuridicalDraft =
            juridicalDraft && juridicalDraft.id === contractor.id;
          if (hasJuridicalDraft) {
            vm.juridicalForm = angular.copy(juridicalDraft);
          } else {
            vm.juridicalForm = $scope.origin_contractor;
            vm.juridicalForm.userAddresses =
              $scope.origin_contractor.address_contractor;
            vm.juridicalForm.userAddresses.forEach(function (address) {
              $http
                .get(url.IP + "ok-to-delete/" + address.id + "/")
                .then(function success(response) {
                  if (response.data) {
                    address.can_delete = true;
                  } else {
                    address.can_delete = false;
                  }
                });
              if (vm.statesArray) {
                vm.statesArray.some(function (state) {
                  if (state.state == address.administrative_area_level_1) {
                    address.administrative_area_level_1 = state;
                    state.cities.some(function (city) {
                      if (city.city == address.administrative_area_level_2) {
                        address.administrative_area_level_2 = city;
                      }
                    });
                  }
                });
              }
              vm.address_type.forEach(function (item) {
                if (item.name == address.tipo) {
                  address.tipo = item;
                }
              });
            });
          }
          if (!hasJuridicalDraft) {
            vm.juridicalForm.j_name = contractor.full_name;
          } else if (juridicalDraft.j_name) {
            vm.juridicalForm.j_name = juridicalDraft.j_name;
          }
          vm.juridicalForm.contact_juridical = contractor.contact_contractor;
          vm.juridicalForm.email_juridical = contractor.email_contractor;
          vm.juridicalForm.phone_juridical = contractor.phone_contractor;
          vm.juridicalForm.address_juridical = contractor.address_contractor;
          vm.juridicalForm.date_of_establishment = datesFactory.convertDate(
            contractor.birth_date
          );
          if (vm.juridicalForm.address_juridical) {
            if (vm.juridicalForm.address_juridical.length == 0) {
              vm.juridicalForm.address_juridical = [
                {
                  raw: "",
                  street_address: "",
                  intersection: "",
                  political: "",
                  administrative_area_level_1: "",
                  administrative_area_level_1_short: "",
                  administrative_area_level_2: "",
                  administrative_area_level_3: "",
                  colloquial_area: "",
                  sublocality: "",
                  neighborhood: "",
                  premise: "",
                  subpremise: "",
                  natural_feature: "",
                  country: "",
                  country_code: "",
                  locality: "",
                  postal_code: "",
                  route: "",
                  street_number: "",
                  street_number_int: "",
                  formatted: "",
                  latitude: "",
                  longitude: "",
                  details: "",
                  composed: "",
                },
              ];
            }
          }
          if (contractor.vendor) {
            vm.juridicalForm.vendedor = contractor.vendor;
          }
          if (contractor.sucursal) {
            vm.juridicalForm.sucursal = contractor.sucursal;
          }
          if (contractor.responsable) {
            // vm.juridicalForm.responsable = contractor.responsable
            if (contractor.responsable) {
              if (contractor.responsable.url) {
                $http
                  .get(contractor.responsable.url)
                  .then(
                    function success(request) {
                      if (request.status === 200) {
                        vm.juridicalForm.responsable = request.data;
                      }
                    },
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              } else {
                // vm.juridicalForm.responsable = contractor.responsable
                $http
                  .get(contractor.responsable)
                  .then(
                    function success(request) {
                      if (request.status === 200) {
                        vm.juridicalForm.responsable = request.data;
                      }
                    },
                    function error(error) {}
                  )
                  .catch(function (e) {
                    console.log(e);
                  });
              }
            } else {
            }
          } else {
            $http.get(url.IP + "usuarios/").then(function (user) {
              vm.responsables = user.data.results;
            });
          }
          if (!vm.juridicalForm.email_juridical.length) {
            // vm.juridicalForm.email_juridical.push({
            //   email: "",
            //   email_type: 0
            // });
          } else {
            vm.juridicalForm.email_juridical.forEach(function (data, index) {
              if (data.correo == vm.juridicalForm.email) {
                vm.juridicalForm.email_juridical.splice(index, 1);
              }
            });
            // if(vm.juridicalForm.email_juridical.length == 0){
            //   vm.juridicalForm.email_juridical.push({
            //     email: "",
            //     email_type: 0
            //   });
            // }
          }
          if (!vm.juridicalForm.phone_juridical.length) {
            // vm.juridicalForm.phone_contractor.push({
            //   phone: "",
            //   phone_type: 0
            // });
          } else {
            vm.juridicalForm.phone_juridical.forEach(function (data, index) {
              if (data.phone == vm.juridicalForm.phone_number) {
                vm.juridicalForm.phone_juridical.splice(index, 1);
              }
            });
            // if(vm.juridicalForm.phone_contractor.length == 0){
            //   vm.juridicalForm.phone_contractor.push({
            //     phone: "",
            //     phone_type: 0
            //   });
            // }
          }

          contractor.userAddresses = contractor.address_contractor;
          if (contractor.userAddresses.length == 0) {
            addAddress(2);
          }
          if (contractor.bound_solidarity_many.length > 0) {
            vm.juridicalForm.obligados = [];
            contractor.bound_solidarity_many.forEach(function (cons) {
              $http.get(cons).then(function (request) {
                var obligados1 = {
                  obligado: request.data,
                };
                var obj1 = {
                  label: request.data.full_name,
                  value: request.data,
                  val: request.data.full_name,
                };
                vm.juridicalForm.obligados.push(obj1);
              });
            });
          } else {
            vm.juridicalForm.obligados = [];
            $scope.addObligados(2);
          }
        }

        if (
          contractor.resp_contractor &&
          contractor.resp_contractor.length == 0
        ) {
          if (contractor.type_person === 1) {
            var addresponsables = {
              responsable: 0,
              resp_type: 0,
            };
            vm.form.resp_contractor = [addresponsables];
          } else {
            var addresponsables = {
              responsable: 0,
              resp_type: 0,
            };
            vm.juridicalForm.resp_contractor = [addresponsables];
          }
        }

        contractor.userAddresses.forEach(function (address) {
          $http
            .get(url.IP + "ok-to-delete/" + address.id + "/")
            .then(function success(response) {
              if (response.data) {
                address.can_delete = true;
              } else {
                address.can_delete = false;
              }
            });
          if (vm.statesArray) {
            vm.statesArray.some(function (state) {
              if (state.state == address.administrative_area_level_1) {
                address.administrative_area_level_1 = state;
                state.cities.some(function (city) {
                  if (city.city == address.administrative_area_level_2) {
                    address.administrative_area_level_2 = city;
                  }
                });
              }
            });
          }
          vm.address_type.forEach(function (item) {
            if (item.name == address.tipo) {
              address.tipo = item;
            }
          });
        });
        return contractor;
      })
      .then(function (contractor) {
        return groupService.getGroup(contractor).then(function (data) {
          vm.aux_contractor = contractor;
          if (data.type_group == 3) {
            $http.get(data.parent).then(function (subgroup) {
              if (subgroup.data.type_group == 2) {
                $http.get(subgroup.data.parent).then(function (group) {
                  var groupInfo = {
                    url: data.url,
                    id: data.id,
                    group_name: group.data.group_name,
                    subgroup_name: subgroup.data.group_name,
                    subsubgroup_name: data.group_name,
                  };
                  if (contractor.type_person === 1) {
                    vm.form.group = groupInfo;
                  } else {
                    vm.juridicalForm.group = groupInfo;
                  }

                  if (vm.groups.length > 0) {
                    vm.groups.forEach(function (item) {
                      if (item.url == group.data.url) {
                        vm.editForm.group = item;
                        $rootScope.changeGroup(item);
                        item.subgrupos.forEach(function (sub) {
                          if (sub.url == subgroup.data.url) {
                            vm.editForm.subgroup = sub;
                            $rootScope.changeSubGroup(sub);
                            sub.subsubgrupos.forEach(function (subsub) {
                              if (subsub.url == data.url) {
                                vm.editForm.subsubgrupo = subsub;
                              }
                            });
                          }
                        });
                      }
                    });
                  } else {
                    groupService.getGroups().then(function (groups) {
                      vm.groups = groups;
                      vm.groups.forEach(function (item) {
                        if (item.url == group.data.url) {
                          vm.editForm.group = item;
                          $rootScope.changeGroup(item);
                          item.subgrupos.forEach(function (sub) {
                            if (sub.url == subgroup.data.url) {
                              vm.editForm.subgroup = sub;
                              $rootScope.changeSubGroup(sub);
                              sub.subsubgrupos.forEach(function (subsub) {
                                if (subsub.url == data.url) {
                                  vm.editForm.subsubgrupo = subsub;
                                }
                              });
                            }
                          });
                        }
                      });
                    });
                  }
                });
              }
            });
          } else {
            if (data.type_group == 2) {
              $http.get(data.parent).then(function (group) {
                var groupInfo = {
                  url: data.url,
                  id: data.id,
                  group_name: group.data.group_name,
                  subgroup_name: data.group_name,
                };
                if (contractor.type_person === 1) {
                  vm.form.group = groupInfo;
                } else {
                  vm.juridicalForm.group = groupInfo;
                }
                if (vm.groups.length > 0) {
                  vm.groups.forEach(function (item) {
                    if (item.url == group.data.url) {
                      vm.editForm.group = item;
                      $rootScope.changeGroup(item);
                      item.subgrupos.forEach(function (sub) {
                        if (sub.url == data.url) {
                          vm.editForm.subgroup = sub;
                        }
                      });
                    }
                  });
                } else {
                  groupService.getGroups().then(function (groups) {
                    vm.groups = groups;
                    vm.groups.forEach(function (item) {
                      if (item.url == group.data.url) {
                        vm.editForm.group = item;
                        $rootScope.changeGroup(item);
                        item.subgrupos.forEach(function (sub) {
                          if (sub.url == data.url) {
                            vm.editForm.subgroup = sub;
                          }
                        });
                      }
                    });
                  });
                }
              });
            } else {
              var groupInfo = {
                url: data.url,
                id: data.id,
                group_name: data.group_name,
              };
              if (contractor.type_person === 1) {
                vm.form.group = groupInfo;
              } else {
                vm.juridicalForm.group = groupInfo;
              }

              if (vm.groups.length > 0) {
                vm.groups.forEach(function (item) {
                  if (item.url == data.url) {
                    vm.editForm.group = item;
                    $rootScope.changeGroup(item);
                  }
                });
              } else {
                groupService.getGroups().then(function (groups) {
                  vm.groups = groups;
                  vm.groups.forEach(function (item) {
                    if (item.url == data.url) {
                      vm.editForm.group = item;
                      $rootScope.changeGroup(item);
                    }
                  });
                });
              }
            }
          }
        });
      });

    $scope.save_info_tab = function () {
      savedEditions.natural = angular.copy(vm.form);
      savedEditions.juridical = angular.copy(vm.juridicalForm);
    };

    $scope.rememberDraft = function () {
      $scope.save_info_tab();
    };

    $q.when()
      .then(function () {
        var defer = $q.defer();
        defer.resolve(helpers.getStates());
        return defer.promise;
      })
      .then(function (data) {
        vm.statesArray = data.data;
        $timeout(function () {
          var nums = [];
          var typePerson;

          $(".telefono").each(function (telefono) {
            var actual = $(this);
            nums.push(actual);
          });
          try {
            if (
              $stateParams.type === "fisicas" ||
              $scope.contractor.type_person == 1
            ) {
              typePerson = vm.form ? vm.form.contact_contractor : 1;
            } else {
              typePerson = vm.juridicalForm
                ? vm.juridicalForm.contact_contractor
                : 2;
            }
          } catch (e) {
            console.log("eee--", e);
          }
        }, 1000);
      });
    if (vm.form) {
      if (!vm.form.userAddresses) {
        vm.form.userAddresses = [];
        addAddress(1);
      }
    } else if (vm.juridicalForm) {
      if (!vm.juridicalForm.userAddresses) {
        vm.juridicalForm.userAddresses = [];
        addAddress(2);
      }
    }
    // if(vm.permiso_archivos){
    getFiles();
    // }
  }
  $scope.onlyFianzas = function (q) {
    $scope.contractor.only_sureties = vm.juridicalForm
      ? vm.juridicalForm.only_sureties
      : vm.form
      ? vm.form.only_sureties
      : false;
    if ($scope.contractor.only_sureties) {
      if (q == 1) {
        vm.listDocument.push(
          {
            id: 7,
            name: "Carta nombramiento",
            value: $scope.contractor.carta_nombramiento,
            file: false,
            arch: {},
          },
          {
            id: 8,
            name: "Currículo",
            value: $scope.contractor.curriculo,
            file: false,
            arch: {},
          },
          {
            id: 9,
            name: "Contrato multiple de la afianzadora",
            value: $scope.contractor.contrato_multiple_afianzadora,
            file: false,
            arch: {},
          },
          {
            id: 10,
            name: "Carta buro",
            value: $scope.contractor.carta_buro,
            file: false,
            arch: {},
          },
          {
            id: 11,
            name: "Entrevista con la afianzadora",
            value: $scope.contractor.entrevista_afianzadora,
            file: false,
            arch: {},
          },
          {
            id: 12,
            name: "RFC",
            value: $scope.contractor.rfc_document,
            file: false,
            arch: {},
          },
          {
            id: 13,
            name: "Recibos de nomina",
            value: $scope.contractor.recibos_nomina,
            file: false,
            arch: {},
          },
          {
            id: 14,
            name: "Declaración anual completa con cadena de los últimos dos años inmediatos anteriores",
            value: $scope.contractor.declaracion_anual,
            file: false,
            arch: {},
          },
          {
            id: 15,
            name: "Estados financieros anuales del año inmediato anterior",
            value: $scope.contractor.estados_financieros_anuales,
            file: false,
            arch: {},
          },
          {
            id: 16,
            name: "Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años",
            value: $scope.contractor.estados_financieros_parciales,
            file: false,
            arch: {},
          },
          {
            id: 17,
            name: "Alta ante hacienda o alta electrónica",
            value: $scope.contractor.alta_hacienda,
            file: false,
            arch: {},
          },
          {
            id: 18,
            name: "Escritura de inmueble",
            value: $scope.contractor.escritura_inmueble,
            file: false,
            arch: {},
          },
          {
            id: 19,
            name: "Boleta predial o avaluó",
            value: $scope.contractor.boleta_predial,
            file: false,
            arch: {},
          },
          {
            id: 20,
            name: "Certificado de libertad de gravamen",
            value: $scope.contractor.certificado_gravamen,
            file: false,
            arch: {},
          }
        );
      } else if (q == 2) {
        vm.listDocument.push(
          {
            id: 7,
            name: "Currículo reciente",
            value: $scope.contractor.curriculo,
            file: false,
            arch: {},
          },
          {
            id: 8,
            name: "Contrato multiple de la afianzadora",
            value: $scope.contractor.contrato_multiple_afianzadora,
            file: false,
            arch: {},
          },
          {
            id: 9,
            name: "Carta Buró",
            value: $scope.contractor.carta_buro,
            file: false,
            arch: {},
          },
          {
            id: 10,
            name: "Cuestionario o entrevista",
            value: $scope.contractor.entrevista_afianzadora,
            file: false,
            arch: {},
          },
          {
            id: 11,
            name: "Aviso de privacidad de la afianzadora",
            value: $scope.contractor.aviso_privacidad,
            file: false,
            arch: {},
          },
          {
            id: 12,
            name: "Protocolizaciones",
            value: $scope.contractor.protocolizaciones,
            file: false,
            arch: {},
          },
          {
            id: 13,
            name: "Alta de empresa ante hacienda",
            value: $scope.contractor.alta_hacienda,
            file: false,
            arch: {},
          },
          {
            id: 14,
            name: "Cambio de domicilio ante hacienda",
            value: $scope.contractor.cambio_domicilio_hacienda,
            file: false,
            arch: {},
          },
          {
            id: 15,
            name: "Copia del comprobante de inscripción para la e.firma (firma electrónica)",
            value: $scope.contractor.cambio_domicilio_hacienda,
            file: false,
            arch: {},
          },
          {
            id: 16,
            name: "Declaración anual completa con cadena, de los últimos dos años",
            value: $scope.contractor.declaracion_anual,
            file: false,
            arch: {},
          },
          {
            id: 17,
            name: "Estados financieros dictaminados cuadernillo completo, del año inmediato anterior",
            value: $scope.contractor.estados_financieros_anuales,
            file: false,
            arch: {},
          },
          {
            id: 18,
            name: "Estados financieros parciales los más recientes de este año con no mayor antigüedad de dos meses",
            value: $scope.contractor.estados_financieros_parciales,
            file: false,
            arch: {},
          },
          {
            id: 19,
            name: "Escritura de inmueble",
            value: $scope.contractor.escritura_inmueble,
            file: false,
            arch: {},
          },
          {
            id: 20,
            name: "Boleta predial o avaluó",
            value: $scope.contractor.boleta_predial,
            file: false,
            arch: {},
          },
          {
            id: 21,
            name: "Certificado de libertad de gravamen",
            value: $scope.contractor.certificado_gravamen,
            file: false,
            arch: {},
          }
        );
      }
    } else {
      if (q == 1) {
        if (vm.org_name == "ancora") {
          vm.listDocument = [
            {
              id: 1,
              name: "Identificación Oficial",
              value: $scope.contractor.card_official_identification,
              file: false,
              arch: {},
            },
            {
              id: 2,
              name: "CURP",
              value: $scope.contractor.CURP,
              file: false,
              arch: {},
            },
            {
              id: 3,
              name: "Comprobante de Inscripción de Firma Electrónica",
              value: $scope.contractor.voucher_efirm,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio",
              value: $scope.contractor.voucher_of_address,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Formato de Identificación de Cliente Firmado",
              value: $scope.contractor.signed_format_ic,
              file: false,
              arch: {},
            },
          ];
        } else {
          vm.listDocument = [
            {
              id: 1,
              name: "Identificación Oficial",
              value: $scope.contractor.card_official_identification,
              file: false,
              arch: {},
            },
            {
              id: 2,
              name: "CURP",
              value: $scope.contractor.CURP,
              file: false,
              arch: {},
            },
            {
              id: 3,
              name: "Comprobante de Inscripción de Firma Electrónica",
              value: $scope.contractor.voucher_efirm,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio",
              value: $scope.contractor.voucher_of_address,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Formato de Identificación de Cliente Firmado",
              value: $scope.contractor.signed_format_ic,
              file: false,
              arch: {},
            },
            {
              id: 6,
              name: "Poder",
              value: $scope.contractor.fiscal_power,
              file: false,
              arch: {},
            },
            {
              id: 7,
              name: "Constancia Situación Fiscal",
              value: $scope.contractor.constancia_situacion_fiscal,
              file: false,
              arch: {},
            },
          ];
        }
      } else if (q == 2) {
        vm.listDocument = [
          {
            id: 1,
            name: "Acta Constitutiva",
            value: $scope.contractor.constitutive_act,
            file: false,
            arch: {},
          },
          {
            id: 2,
            name: "Constancia Situación Fiscal",
            value: $scope.contractor.rfc_document,
            file: false,
            arch: {},
          },
          {
            id: 3,
            name: "Cédula de Identificación Fiscal",
            value: $scope.contractor.card_official_identification,
            file: false,
            arch: {},
          },
          {
            id: 4,
            name: "Comprobante de Domicilio Fiscal",
            value: $scope.contractor.voucher_of_address,
            file: false,
            arch: {},
          },
          {
            id: 5,
            name: "Modificaciones al Acta Constitutiva",
            value: $scope.contractor.modifications_constitutive_act,
            file: false,
            arch: {},
          },
          {
            id: 6,
            name: "Poder",
            value: $scope.contractor.fiscal_power,
            file: false,
            arch: {},
          },
          {
            id: 7,
            name: "INE Representante Legal",
            value: $scope.contractor.ine_representante,
            file: false,
            arch: {},
          },
        ];
      }
    }
  };
  function getFiles() {
    $stateParams.type = "contractors";
    $stateParams.type_person = $scope.contractor.type_person;
    return ContratanteService.getFiles($stateParams).then(function (data) {
      if (data.detail) {
        vm.show_files = false;
      } else {
        vm.files = data;
      }
    });
  }
  //archivos lista documentos
  $scope.addFileList = function (index, lista, file, xy) {
    var extension = file[0].formData[0].name.split(".")[1];
    file[0].formData[0].name = vm.listDocument[index].name + "." + extension;
    vm.listDocument[index].arch = file[0];
    vm.listDocument[index].file = true;
    $scope.uploaderDocument.queue = [];
  };
  var uploaderDocument = ($scope.uploaderDocument = new FileUploader({
    headers: {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    },
  }));

  // uploaderDocument.filters.push({
  //     name: 'customFilter',
  //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
  //         return this.queue.length < 20;
  //     }
  // });

  // ALERTA SUCCES UPLOADFILES
  uploaderDocument.onSuccessItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    // if ($uibModalInstance) {
    //     $uibModalInstance.dismiss('cancel');
    // }
    $scope.okFile++;
    if ($scope.okFile == $scope.countFile) {
      $timeout(function () {
        SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWCONTRACTOR, "success");
        if ($location.path() == "/contratantes/crear") {
          if (vm.acceso_ver_cont) {
            $state.go("contratantes.info", {
              type:
                $scope.contractorNew.type_person == "Fisica"
                  ? "fisicas"
                  : "morales",
              contratanteId: $scope.contractorNew.id,
            });
          } else {
            $state.go("index.main");
          }
        } else if ($location.path() == "/colectividades/") {
          var params = { myInsurance: $scope.contractorNew };
          $state.go("colectividades.main", params);
        } else if ($location.path() == "/fianzas/") {
          $rootScope.show_contractor = false;
          // var params = { 'myInsurance': $scope.contractorNew }
          // $state.go('fianzas.fianzas', params);
        } else {
          $rootScope.show_contractor = false;
          var params = { myInsurance: $scope.contractorNew };
          $state.go("polizas.create", params);
        }
      }, 1000);
    }
  };

  // ALERTA ERROR UPLOADFILES
  uploaderDocument.onErrorItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    if (response.status == 413) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
    } else {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    }
  };

  uploaderDocument.onAfterAddingFile = function (fileItem) {
    fileItem.formData.push({
      arch: fileItem._file,
      name: fileItem.file.name,
    });
  };

  uploaderDocument.onBeforeUploadItem = function (item) {
    if (item.file.sensible != undefined) {
      item.formData[0].sensible = item.file.sensible;
    }
    item.url = $scope.userInfo.url;
    item.formData[0].name = item.file.name;
    item.alias = "";
    item.formData[0].owner = $scope.userInfo.id;
  };
  //archivos lista docuemntos
  function uploadFilesList(typePerson, idPerson) {
    $scope.userInfo = {
      id: idPerson,
    };
    // $scope.userInfo.url = url.IP + checkType(typePerson) + '/' + idPerson + '/archivos/';
    $scope.userInfo.url =
      url.IP + "contractors" + "/" + idPerson + "/archivos/";

    $scope.files = [];

    $timeout(function () {
      $scope.uploaderDocument.uploadAll();
    }, 1000);
  }
  // Add group popup
  function openModalGroup(level, type, parent) {
    // var modalInstance = $uibModal.open({ //jshint ignore:line
    //     templateUrl: 'app/grupos/grupos.form.html',
    //     controller: ModalGroupCtrl,
    //     //windowClass: 'animated fadeIn'
    // });
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/grupos/grupos.form.html",
      controller: ModalInstanceGroupCtrl,
      resolve: {
        padre: function () {
          return parent;
        },
        parent: function () {
          return vm;
        },
        level: function () {
          return level;
        },
        type: function () {
          return type;
        },
        group: function () {
          return type == 1 ? vm.form.group : vm.juridicalForm.group;
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
      // windowClass: 'animated fadeIn'
    });
  }

  function ModalInstanceGroupCtrl(
    $scope,
    $uibModalInstance,
    parent,
    level,
    group,
    type,
    padre
  ) {
    $scope.level = level;
    $scope.groupForm = {};
    $scope.subgroupForm = {};
    $scope.subsubgroupForm = {};
    $scope.subgroups = [];
    $scope.sub_subgroups = [];

    $scope.addSubgroups = function () {
      var obj = { name: "", observations: "", sub_subgroup: [] };
      $scope.subgroups.push(obj);
    };

    $scope.deleteSubgroup = function (index) {
      $scope.subgroups.splice(index, 1);
    };

    $scope.addSubsubgroups = function () {
      var obj = { name: "", observations: "", sub_subgroup: [] };
      $scope.sub_subgroups.push(obj);
    };

    $scope.deleteSubsubgroup = function (index) {
      $scope.sub_subgroups.splice(index, 1);
    };

    $http.get(url.IP + "usuarios/").then(function (user) {
      $scope.users = user.data.results;

      $scope.show_pagination = true;
    });

    $scope.changeResponsable = function (data, type) {
      $scope.responsables_natural = [];
      $scope.responsables_juridical = [];
      if (type == 1) {
        $scope.responsables_natural.push(data);
      } else {
        $scope.responsables_juridical.push(data);
      }
    };

    $scope.ok = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var flag = false;
      var form = angular.copy($scope.groupForm);
      var name = form.group_name;
      var bd_group_name = [];
      groupService.getGroups().then(function (res) {
        res.forEach(function (group, i) {
          bd_group_name.push(String(group.group_name));
        });

        for (var i = 0; i < bd_group_name.length; i++) {
          if (name == bd_group_name[i]) {
            flag = true;
          }
        }
        form.type_group = 1;

        if (flag == false) {
          return groupService
            .createGroup(form)
            .then(function (data) {
              if (data.status === 201) {
                vm.groups.push(data.data);
                $rootScope.changeGroup(data.data);
                if (vm.form) {
                  vm.form.group = data.data;
                } else if (vm.juridicalForm) {
                  vm.juridicalForm.group = data.data;
                }

                if ($uibModalInstance) {
                  $uibModalInstance.close();
                  $("#modalContratate")
                    .parent()
                    .parent()
                    .parent()
                    .css("display", "block");
                }

                if ($scope.subgroups.length > 0) {
                  $scope.subgroups.forEach(function (item) {
                    var datas = {
                      group_name: item.group_name,
                      responsable: data.data.responsable,
                      parent: data.data.url,
                      type_group: 2,
                    };

                    $http({
                      method: "POST",
                      url: url.IP + "grupos/",
                      data: datas,
                    })
                      .then(function (request) {
                        if (request.status === 200 || request.status === 201) {
                          // vm.subgroups.push(request.data);
                          if (type === 1) {
                            vm.form.group.subgrupos.push(request.data);
                          } else {
                            vm.juridicalForm.group.subgrupos.push(request.data);
                          }
                        }
                      })
                      .catch(function (e) {
                        l.stop();
                        console.log("e", e);
                      });
                  });
                }
              } else if (data.status === 403) {
                toaster.warning("Usted no tiene permisos para crear grupos");
                // return;
                $uibModalInstance.close();
                $("#modalContratate")
                  .parent()
                  .parent()
                  .parent()
                  .css("display", "block");
              }
            })
            .catch(function () {
              l.stop();
              return;
            });
        } else {
          SweetAlert.swal(
            "ERROR",
            MESSAGES.ERROR.THISNAMEALREADYEXIST,
            "error"
          );
          return;
        }
      });
    };

    $scope.oksub = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.subgroupForm.responsable = group.responsable;
      $scope.subgroupForm.parent = padre.url;
      $scope.subgroupForm.type_group = 2;

      if (!$scope.subgroupForm.group_name) {
        l.stop();
        SweetAlert.swal("Error", "Agrega un nombre de subgrupo.", "error");
        return;
      }

      $http({
        method: "POST",
        url: url.IP + "grupos/",
        data: $scope.subgroupForm,
      })
        .then(function (request) {
          if (request.status === 200 || request.status === 201) {
            try {
              vm.subgroups.push(request.data);
            } catch (e) {
              vm.subgroups = [];
              vm.subgroups.push(request.data);
            }
            if ($scope.sub_subgroups.length > 0) {
              vm.subgroups[vm.subgroups.length - 1].subsubgrupos = [];
              $scope.sub_subgroups.forEach(function (item) {
                var datas = {
                  group_name: item.group_name,
                  responsable: padre.responsable,
                  parent: request.data.url,
                  type_group: 3,
                };

                $http({
                  method: "POST",
                  url: url.IP + "grupos/",
                  data: datas,
                })
                  .then(function (response) {
                    if (response.status === 200 || response.status === 201) {
                      vm.subgroups[vm.subgroups.length - 1].subsubgrupos.push(
                        response.data
                      );
                    }
                  })
                  .catch(function (e) {
                    l.stop();
                    console.log("e", e);
                  });
              });
            }
            $scope.cancel();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.oksubsub = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.subsubgroupForm.responsable = group.responsable;
      $scope.subsubgroupForm.parent = padre.url;
      $scope.subsubgroupForm.type_group = 3;

      if (!$scope.subsubgroupForm.group_name) {
        l.stop();
        SweetAlert.swal("Error", "Agrega un nombre de subsubgrupo.", "error");
        return;
      }

      $http({
        method: "POST",
        url: url.IP + "grupos/",
        data: $scope.subsubgroupForm,
      })
        .then(function (request_sub) {
          if (request_sub.status === 200 || request_sub.status === 201) {
            if (vm.sub_subgroups == undefined) {
              $scope.sub_subgroups = [];
            }
            // vm.sub_subgroups.push(request_sub.data);
            try {
              $scope.sub_subgroups.push(request_sub.data);
            } catch (e) {
              $scope.sub_subgroups = [];
              $scope.sub_subgroups.push(request_sub.data);
            }
            $scope.cancel();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
        $("#modalContratate")
          .parent()
          .parent()
          .parent()
          .css("display", "block");
      }
    };
  }

  function openModalClasification(level) {
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/contratantes/contratantes.clasificacion.html",
      controller: ModaClasificationCtrl,
      resolve: {
        parent: function () {
          return vm;
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
      // windowClass: 'animated fadeIn'
    });
  }

  $scope.sub_asignaciones = [];
  $scope.sub_subasignaciones = [];

  function ModaClasificationCtrl($scope, $uibModalInstance, parent) {
    $scope.classification = {};

    $scope.save = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      $scope.classification.classification_name =
        $scope.classification.classification_name;
      $scope.classification.description = $scope.classification.description;

      $http({
        method: "POST",
        url: url.IP + "classification/",
        data: $scope.classification,
      })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            l.stop();
            vm.clasifications.push(response.data);
            $scope.cancel();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };
  }

  $scope.matchesContractors = function (parWord) {
    if (parWord) {
      if (parWord.length >= 3) {
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
        $scope.show_contratante = "contractors-match/";
        $http
          .post(url.IP + $scope.show_contratante, {
            matchWord: parWord,
            poliza: false,
          })
          .then(function (response) {
            if (response.status === 200 && response.data != 404) {
              var source = [];
              var contratactorsFound = response.data.contractors;
              if (contratactorsFound.length) {
                contratactorsFound.forEach(function (item) {
                  if (item.full_name) {
                    var obj = {
                      label: item.full_name,
                      value: item,
                    };
                  } else {
                    var obj = {
                      label:
                        item.first_name +
                        " " +
                        item.last_name +
                        " " +
                        item.second_last_name,
                      value: item,
                    };
                  }
                  source.push(obj);
                });
              }
              $scope.contractors_data = source;
            }
          });
      }
    }
  };

  $scope.$watch("vm.contratante.value", function (newValue, oldValue) {
    if (vm.contratante) {
      if (vm.contratante.value.address_contractor) {
        if (vm.contratante.value.address_contractor) {
          $scope.bound_solidarity = vm.contratante.value.url;
          $scope.has_solidario = true;
        }
      }
    }
  });

  function openModalCelulaContractor(level) {
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/contratantes/contratantes.celulas.html",
      controller: ModalCelulasCtrl,
      resolve: {
        parent: function () {
          return vm;
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
      // windowClass: 'animated fadeIn'
    });
  }
  function ModalCelulasCtrl($scope, $uibModalInstance, parent) {
    $scope.moduleName = "Célula";
    dataFactory.get("orginfo/").then(function success(response) {
      if (response.data.results.length) {
        $scope.configuracionGlobal = response.data.results[0];
        if ($scope.configuracionGlobal.moduleName) {
          $scope.moduleName = $scope.configuracionGlobal.moduleName;
        }
      }
    });
    $scope.celula = {};
    dataFactory.get("usuarios/").then(function (user) {
      $scope.usuarios_saam = user.data.results;
    });
    $scope.selectUsuarios = function (sel) {
      $scope.usuarios_selected = [];
      sel.forEach(function (u) {
        if (u.url) {
          $scope.usuarios_selected.push(u.url);
        } else {
          $scope.usuarios_selected.push(u);
        }
      });
    };
    $scope.save_celula = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      $scope.celula.celula_name = $scope.celula.celula_name;
      $scope.celula.description = $scope.celula.description;
      $scope.celula.users_many = $scope.usuarios_selected
        ? $scope.usuarios_selected
        : [];

      $http({
        method: "POST",
        url: url.IP + "celula_contractor/",
        data: $scope.celula,
      })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            vm.celulas.push(response.data);
            $scope.cancel_celula();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.cancel_celula = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };
  }
  function openModalAsignacion(level, padre) {
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/contratantes/contratantes.agrupacion.html",
      controller: ModalAsignacionCtrl,
      resolve: {
        padre: function () {
          return padre;
        },
        parent: function () {
          return vm;
        },
        level: function () {
          return level;
        },
        group: function () {
          return level == 2
            ? vm.editForm.grouping_level
            : vm.editForm.subagrupaciones;
        },
      },
      backdrop:
        "static" /* this prevent user interaction with the background */,
      keyboard: false,
      // windowClass: 'animated fadeIn'
    });
  }

  $scope.sub_asignaciones = [];
  $scope.sub_subasignaciones = [];

  function ModalAsignacionCtrl(
    $scope,
    $uibModalInstance,
    parent,
    level,
    group,
    padre
  ) {
    $scope.level = level;
    $scope.group_modal = group;
    $scope.grupo = {};
    // $scope.subasignaciones = [];
    $scope.subsubasignacion = [];

    $scope.addSubasignaciones = function () {
      var obj = { name: "", observations: "", sub_subgroup: [] };
      vm.subasignaciones.push(obj);
    };

    $scope.deleteSubasignaciones = function (index) {
      vm.subasignaciones.splice(index, 1);
    };

    $scope.addSubsubasignaciones = function () {
      var obj = { name: "", observations: "", sub_subgroup: [] };
      $scope.subsubasignacion.push(obj);
    };

    $scope.deleteSubsubasignaciones = function (index) {
      vm.subsubasignaciones.splice(index, 1);
    };

    $http.get(url.IP + "usuarios/").then(function (user) {
      $scope.users = user.data.results;

      $scope.show_pagination = true;
    });

    $scope.changeResponsable = function (data, type) {
      $scope.responsables_natural = [];
      $scope.responsables_juridical = [];
      if (type == 1) {
        $scope.responsables_natural.push(data);
      } else {
        $scope.responsables_juridical.push(data);
      }
    };

    $scope.saveSub = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.sub_asignaciones = [];
      $scope.grupo.level_grouping = padre.level_grouping;
      $scope.grupo.parent = padre.url;
      $scope.grupo.type_grouping = 2;
      if (!$scope.grupo.description) {
        l.stop();
        SweetAlert.swal("Error", "Agrega un nombre de subagrupación.", "error");
        return;
      }

      $http({
        method: "POST",
        url: url.IP + "groupinglevel/",
        data: $scope.grupo,
      })
        .then(function (request_sub) {
          if (request_sub.status === 200 || request_sub.status === 201) {
            $scope.sub_subasignaciones = [];
            $scope.sub_asignaciones = padre.subgrupos;
            $rootScope.changeAgrupacion2(padre);
            try {
              $scope.sub_asignaciones.push(request_sub.data);
            } catch (e) {
              $scope.sub_asignaciones = request_sub.data;
            }
            if ($scope.subsubasignacion.length > 0) {
              $scope.subsubasignacion.forEach(function (item, index) {
                var datas = {
                  description: item.description,
                  responsable: $scope.grupo.responsable,
                  parent: request_sub.data.url,
                  type_grouping: 3,
                };

                if (item.description) {
                  $http({
                    method: "POST",
                    url: url.IP + "groupinglevel/",
                    data: datas,
                  })
                    .then(function (response) {
                      if (response.status === 200 || response.status === 201) {
                        $scope.sub_subasignaciones = [];
                        $scope.sub_subasignaciones.push(response.data);
                        $rootScope.changeAgrupacion2(padre);
                        if ($scope.subsubasignacion.length == index + 1) {
                          vm.agrupaciones.forEach(function (gpo) {
                            if (
                              gpo.description ==
                              vm.editForm.grouping_level.subgroup_name
                            ) {
                              vm.editForm.grouping_level = gpo;
                              // gpo.subgrupos.forEach(function(sub){
                              //   if(vm.editForm.grouping_level.url == sub.parent){
                              //     vm.editForm.subagrupaciones = sub;
                              //   }
                              // });
                            }
                          });
                        }
                      }
                    })
                    .catch(function (e) {
                      l.stop();
                      console.log("e", e);
                    });
                }
              });
            }
            vm.editForm.subagrupaciones = request_sub.data;
            $scope.cancel();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.saveSubsub = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.grupo.level_grouping = padre.level_grouping;
      $scope.grupo.parent = padre.url;
      $scope.grupo.type_grouping = 3;

      if (!$scope.grupo.description) {
        l.stop();
        SweetAlert.swal(
          "Error",
          "Agrega un nombre de subsubagrupación.",
          "error"
        );
        return;
      }

      $http({
        method: "POST",
        url: url.IP + "groupinglevel/",
        data: $scope.grupo,
      })
        .then(function (request_sub) {
          if (request_sub.status === 200 || request_sub.status === 201) {
            // $scope.sub_subasignaciones = padre.subgrupos;
            // $scope.sub_subasignaciones.push(request_sub.data);
            // $rootScope.changeAgrupacion2(vm.editForm.grouping_level);
            // $scope.cancel();
            $scope.sub_subasignaciones = padre.subgrupos;
            try {
              $scope.sub_subasignaciones.push(request_sub.data);
            } catch (e) {
              $scope.sub_subasignaciones = request_sub.data;
            }
            // $rootScope.changeAgrupacion2(padre);
            $rootScope.changeSubagrupacion2(padre);
            $scope.cancel();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e", e);
        });
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };
  }

  function ModalGroupCtrl($scope, $uibModalInstance) {
    $scope.ok = function () {
      var flag = false;
      var form = angular.copy($scope.groupForm);
      var name = form.group_name;
      var bd_group_name = [];
      $scope.changeResponsable = function (data) {
        $scope.groupForm.responsable = data;
      };

      groupService.getGroups().then(function (res) {
        res.forEach(function (group, i) {
          bd_group_name.push(String(group.group_name));
        });

        for (var i = 0; i < bd_group_name.length; i++) {
          if (name == bd_group_name[i]) {
            flag = true;
          }
        }
        if (flag == false) {
          return groupService
            .createGroup(form)
            .then(function (data) {
              vm.groups.push(data.data);
              if ($uibModalInstance) $uibModalInstance.close();
            })
            .catch(function () {
              return;
            });
        } else {
          SweetAlert.swal(
            "ERROR",
            MESSAGES.ERROR.THISNAMEALREADYEXIST,
            "error"
          );
          return;
        }
      });
    };

    $scope.cancel = function () {
      if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
    };
  }

  // Delete contratantes popup
  function openModalDeleteContratantes() {
    var modalInstance = $uibModal.open({
      //jshint ignore:line
      templateUrl: "app/contratantes/contratantes.delete.html",
      controller: ModalInstanceCtrl,
      //windowClass: 'animated fadeIn'
    });
  }

  function ModalInstanceCtrl($scope, $uibModalInstance) {
    var data = returnType();
    $scope.ok = function () {
      return ContratanteService.deleteContratante(data).then(function () {
        if ($uibModalInstance) $uibModalInstance.close();
        $state.go("contratantes.main");
      });
    };

    $scope.cancel = function () {
      if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
    };
  }

  function cancel() {
    $state.go("contratantes.info", {
      type: $scope.contractorEdit.type_person == 1 ? "fisicas" : "morales",
      contratanteId: $scope.contractorId,
    });
  }

  function validateEmail(email) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  $scope.sendResponsables = function (url, typePerson) {
    if (typePerson == 1) {
      for (var i = 0; i < vm.form.resp_contractor.length; i++) {
        // vm.form.responsables[i].natural = url;
        vm.form.resp_contractor[i].contractor = url;
      }
      vm.responsable = vm.form.resp_contractor;
    } else {
      for (var i = 0; i < vm.juridicalForm.resp_contractor.length; i++) {
        // vm.juridicalForm.responsables[i].juridical = url;
        vm.juridicalForm.resp_contractor[i].contractor = url;
      }
      vm.responsable = vm.juridicalForm.resp_contractor;
    }

    vm.responsable.forEach(function (r) {
      if (r.url) {
        $http.patch(r.url, {
          resp_type: r.resp_type,
          responsable: r.responsable,
        });
      }
    });

    vm.responsable = vm.responsable.filter(function (r) {
      if (!r.url) {
        return true;
      } else return false;
    });

    if (vm.responsable) {
      dataFactory
        .post("responsables/", vm.responsable)
        .then(
          function success(request) {},
          function error(error) {
            console.log(error);
          }
        )
        .catch(function (e) {
          console.log(e);
        });
    }
  };

  function save() {
    var l = Ladda.create(document.querySelector(".ladda-button"));
    l.start();

    if (vm.form) {
      $scope.obligados = [];
      if (vm.form.obligados) {
        vm.form.obligados.forEach(function (elem, index) {
          if (elem.val) {
            if (elem.value) {
              $scope.obligados.push(elem.value.url);
            }
          }
        });
      }
      vm.form.bound_solidarity_many = $scope.obligados ? $scope.obligados : [];
      if (vm.form.first_name == "" || vm.form.first_name == undefined) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMNAME, "error");
        return;
      }
      if (vm.form.last_name == "" || vm.form.last_name == undefined) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMLASTNAME, "error");
        return;
      }
      if (vm.form.birthday == "" || vm.form.birthday == undefined) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMBIRTHDAY, "error");
        return;
      }
      if (vm.form.rfc == "" || vm.form.rfc == undefined) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMRFC, "error");
        return;
      }
      if (vm.form.email) {
        if (
          vm.form.email != "" ||
          !vm.form.email ||
          vm.form.email != null ||
          !(vm.form.email == "")
        ) {
          if (!validateEmail(vm.form.email)) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
            return;
          }
        }
      }
      $scope.flagEmail = false;
      if (vm.form.email_natural.length > 0) {
        for (var i = 0; i < vm.form.email_natural.length; i++) {
          if (!validateEmail(vm.form.email_natural[i].correo)) {
            $scope.flagEmail = true;
          }
        }
        if ($scope.flagEmail == true) {
          l.stop();
          $scope.flagEmail = false;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
    } else {
      $scope.obligados = [];
      if (vm.juridicalForm.obligados) {
        vm.juridicalForm.obligados.forEach(function (elem, index) {
          if (elem.val) {
            if (elem.value) {
              $scope.obligados.push(elem.value.url);
            }
          }
        });
      }
      if (
        vm.juridicalForm.j_name == "" ||
        vm.juridicalForm.j_name == undefined
      ) {
        if (vm.juridicalForm && vm.juridicalForm.full_name) {
          vm.juridicalForm.j_name = vm.juridicalForm.full_name;
        } else {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMJNAME, "error");
          return;
        }
      }
      if (
        vm.juridicalForm.date_of_establishment == "" ||
        vm.juridicalForm.date_of_establishment == undefined
      ) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMESTABLISHMENT, "error");
        return;
      }
      if (vm.juridicalForm.rfc == "" || vm.juridicalForm.rfc == undefined) {
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMRFC, "error");
        return;
      }
      if (vm.juridicalForm.email != "") {
        if (!validateEmail(vm.juridicalForm.email)) {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
      $scope.flagEmail = false;
      if (vm.juridicalForm.email_juridical.length > 0) {
        for (var i = 0; i < vm.juridicalForm.email_juridical.length; i++) {
          if (!validateEmail(vm.juridicalForm.email_juridical[i].correo)) {
            $scope.flagEmail = true;
          }
        }
        if ($scope.flagEmail == true) {
          l.stop();
          $scope.flagEmail = false;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
    }

    var flag = false;
    var type = returnType();
    if (!type.group.url) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.SELGROUP, "error");
      flag = true;
      return;
    }

    var dataToSave = angular.copy(type);
    $scope.group_obj = type.group;
    dataToSave.group = type.group.url;

    if (dataToSave.birthday) {
      var date = dataToSave.birthday;
      var newdate = date.split("/").reverse().join("-");
      // dataToSave.birthday = newdate;
      dataToSave.birth_date = newdate;
      try {
        if (dataToSave.birthday.length <= 8) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.DATEBIRTHDAY, "error");
          return;
        }
      } catch (e) {}
    } else if (dataToSave.date_of_establishment) {
      if (isNaN(dataToSave.date_of_establishment)) {
        var date = dataToSave.date_of_establishment;
        var newdate = date.split("/").reverse().join("-");
        // dataToSave.date_of_establishment = newdate;
        dataToSave.birth_date = newdate;
      } else {
        vm.juridicalForm.group = $scope.group_obj;
        vm.juridicalForm.date_of_establishment = "";
        toaster.warning("Ingrese una fecha valida");
        return;
      }
      try {
        if (dataToSave.date_of_establishment.length <= 8) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.DATEESTABLISHMENT, "error");
          return;
        }
      } catch (e) {}
    } else {
      vm.form.group = $scope.group_obj;
      toaster.warning("Ingrese una fecha valida");
      return;
    }

    if (vm.form) {
      dataToSave.email = vm.form.email ? vm.form.email : "";
      dataToSave.phone_number = vm.form.phone_number
        ? vm.form.phone_number
        : "";
      dataToSave.sucursal = vm.form.sucursal ? vm.form.sucursal.url : "";
      if (dataToSave.email == "" && vm.form.email_natural.length > 0) {
        dataToSave.email = vm.form.email_natural[0].correo;
        vm.form.email_natural.splice(0, 1);
      }
      // Documents
      if (vm.org_name == "ancora") {
        dataToSave.card_official_identification = vm.listDocument[0].value;
        dataToSave.CURP = vm.listDocument[1].value;
        dataToSave.voucher_efirm = vm.listDocument[2].value;
        dataToSave.voucher_of_address = vm.listDocument[3].value;
        dataToSave.signed_format_ic = vm.listDocument[4].value;
        if (vm.form.only_sureties) {
          dataToSave.carta_nombramiento = vm.listDocument[5].value;
          dataToSave.curriculo = vm.listDocument[6].value;
          dataToSave.contrato_multiple_afianzadora = vm.listDocument[7].value;
          dataToSave.carta_buro = vm.listDocument[8].value;
          dataToSave.entrevista_afianzadora = vm.listDocument[9].value;
          dataToSave.rfc_document = vm.listDocument[10].value;
          dataToSave.recibos_nomina = vm.listDocument[11].value;
          dataToSave.declaracion_anual = vm.listDocument[11].value;
          dataToSave.estados_financieros_anuales = vm.listDocument[13].value;
          dataToSave.estados_financieros_parciales = vm.listDocument[14].value;
          dataToSave.alta_hacienda = vm.listDocument[15].value;
          dataToSave.escritura_inmueble = vm.listDocument[16].value;
          dataToSave.boleta_predial = vm.listDocument[17].value;
          dataToSave.certificado_gravamen = vm.listDocument[18].value;
        }
      } else {
        dataToSave.card_official_identification = vm.listDocument[0].value;
        dataToSave.CURP = vm.listDocument[1].value;
        dataToSave.voucher_efirm = vm.listDocument[2].value;
        dataToSave.voucher_of_address = vm.listDocument[3].value;
        dataToSave.signed_format_ic = vm.listDocument[4].value;
        dataToSave.fiscal_power = vm.listDocument[5].value;
        dataToSave.constancia_situacion_fiscal = vm.listDocument[6].value;
        if (vm.form.only_sureties) {
          dataToSave.carta_nombramiento = vm.listDocument[6].value;
          dataToSave.curriculo = vm.listDocument[7].value;
          dataToSave.contrato_multiple_afianzadora = vm.listDocument[8].value;
          dataToSave.carta_buro = vm.listDocument[9].value;
          dataToSave.entrevista_afianzadora = vm.listDocument[10].value;
          dataToSave.rfc_document = vm.listDocument[11].value;
          dataToSave.recibos_nomina = vm.listDocument[12].value;
          dataToSave.declaracion_anual = vm.listDocument[13].value;
          dataToSave.estados_financieros_anuales = vm.listDocument[14].value;
          dataToSave.estados_financieros_parciales = vm.listDocument[15].value;
          dataToSave.alta_hacienda = vm.listDocument[16].value;
          dataToSave.escritura_inmueble = vm.listDocument[17].value;
          dataToSave.boleta_predial = vm.listDocument[18].value;
          dataToSave.certificado_gravamen = vm.listDocument[19].value;
        }
      }
      //upload files repect documents
      vm.listDocument.forEach(function (ar) {
        if (ar.arch.formData) {
          var extension = ar.arch.formData[0].arch.name.split(".")[1];
          ar.arch.formData[0].name = ar.name + "." + extension;
          ar.arch.file.name = ar.name + "." + extension;
          $scope.uploaderDocument.queue.push(ar.arch);
          $scope.uploaderDocument.onAfterAddingFile(ar.arch);
        }
      });
      for (var i = 0; i < vm.form.phone_natural.length; i++) {
        if (vm.form.phone_natural[i].phone.length < 9) {
          $scope.flagPhone = true;
        }
      }
      if (!$scope.flagPhone) {
        if (dataToSave.phone_number == "" && vm.form.phone_natural.length > 0) {
          dataToSave.phone_number = vm.form.phone_natural[0].phone;
          vm.form.phone_natural.splice(0, 1);
        }
      } else {
        $scope.flagPhone = false;
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
        return;
      }

      try {
        dataToSave.vendor = vm.form.vendedor.url;
      } catch (e) {
        dataToSave.vendor = "";
      }
      try {
        dataToSave.sucursal = vm.form.sucursal.url;
      } catch (e) {
        dataToSave.sucursal = "";
      }

      try {
        dataToSave.responsable = vm.form.responsable.url;
      } catch (e) {
        dataToSave.responsable = "";
      }
    }

    if (vm.juridicalForm) {
      dataToSave.email = vm.juridicalForm.email ? vm.juridicalForm.email : "";
      dataToSave.phone_number = vm.juridicalForm.phone_number
        ? vm.juridicalForm.phone_number
        : "";
      dataToSave.sucursal = vm.juridicalForm.sucursal
        ? vm.juridicalForm.sucursal.url
        : "";
      if (
        dataToSave.email == "" &&
        vm.juridicalForm.email_juridical.length > 0
      ) {
        dataToSave.email = vm.juridicalForm.email_juridical[0].correo;
        vm.juridicalForm.email_juridical.splice(0, 1);
      }

      if (dataToSave.phone_number) {
        if (dataToSave.phone_number.length < 9) {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
          return;
        }
      }

      try {
        dataToSave.vendor = vm.juridicalForm.vendedor.url;
      } catch (e) {
        dataToSave.vendor = "";
      }

      try {
        dataToSave.sucursal = vm.juridicalForm.sucursal.url;
      } catch (e) {
        dataToSave.sucursal = "";
      }

      try {
        dataToSave.responsable = vm.juridicalForm.responsable.url;
      } catch (e) {
        dataToSave.responsable = "";
      }

      for (var i = 0; i < vm.juridicalForm.phone_juridical.length; i++) {
        if (vm.juridicalForm.phone_juridical[i].phone.length < 9) {
          $scope.flagPhone = true;
        }
      }
      if (!$scope.flagPhone) {
        if (
          dataToSave.phone_number == "" &&
          vm.juridicalForm.phone_juridical.length > 0
        ) {
          dataToSave.phone_number = vm.juridicalForm.phone_juridical[0].phone;
          vm.juridicalForm.phone_juridical.splice(0, 1);
        }
      } else {
        $scope.flagPhone = false;
        l.stop();
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
        return;
      }
      // Documents

      dataToSave.constitutive_act = vm.listDocument[0].value;
      dataToSave.rfc_document = vm.listDocument[1].value;
      dataToSave.card_official_identification = vm.listDocument[2].value;
      dataToSave.voucher_of_address = vm.listDocument[3].value;
      dataToSave.modifications_constitutive_act = vm.listDocument[4].value;
      dataToSave.fiscal_power = vm.listDocument[5].value;
      dataToSave.ine_representante = vm.listDocument[6].value;
      if (vm.juridicalForm.only_sureties) {
        dataToSave.curriculo = vm.listDocument[6].value;
        dataToSave.contrato_multiple_afianzadora = vm.listDocument[7].value;
        dataToSave.carta_buro = vm.listDocument[8].value;
        dataToSave.entrevista_afianzadora = vm.listDocument[9].value;
        dataToSave.aviso_privacidad = vm.listDocument[10].value;
        dataToSave.protocolizaciones = vm.listDocument[11].value;
        dataToSave.alta_hacienda = vm.listDocument[12].value;
        dataToSave.cambio_domicilio_hacienda = vm.listDocument[13].value;
        dataToSave.voucher_efirm = vm.listDocument[14].value;
        dataToSave.declaracion_anual = vm.listDocument[15].value;
        dataToSave.estados_financieros_anuales = vm.listDocument[16].value;
        dataToSave.estados_financieros_parciales = vm.listDocument[17].value;
        dataToSave.escritura_inmueble = vm.listDocument[18].value;
        dataToSave.boleta_predial = vm.listDocument[19].value;
        dataToSave.certificado_gravamen = vm.listDocument[20].value;
      }
      //upload files repect documents
      vm.listDocument.forEach(function (ar) {
        if (ar.arch.formData) {
          var extension = ar.arch.formData[0].arch.name.split(".")[1];
          ar.arch.formData[0].name = ar.name + "." + extension;
          ar.arch.file.name = ar.name + "." + extension;
          $scope.uploaderDocument.queue.push(ar.arch);
          $scope.uploaderDocument.onAfterAddingFile(ar.arch);
        }
      });
      //upload documents
    }

    if (dataToSave.contact_natural) {
      dataToSave.contact_natural.forEach(function (contact) {
        if (contact.name == "") {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.SELADDRES, "error");
          flag = true;
          return;
        } else {
          if (contact.email) {
            if (!validateEmail(contact.email)) {
              l.stop();
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.INVALIDEMAILCONTACT,
                "error"
              );
              flag = true;
              return;
            }
          }
          if (contact.phone_number) {
            if (contact.phone_number.length < 9) {
              l.stop();
              flag = true;
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORLENGTHPHONECONTACT,
                "error"
              );
              return;
            }
          }
        }
      });
    } else {
      dataToSave.contact_juridical.forEach(function (contact) {
        if (contact.name == "") {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.SELADDRES, "error");
          flag = true;
          return;
        } else {
          if (contact.email) {
            if (!validateEmail(contact.email)) {
              l.stop();
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.INVALIDEMAILCONTACT,
                "error"
              );
              flag = true;
              return;
            }
          }
          if (contact.phone_number) {
            if (contact.phone_number.length < 9) {
              l.stop();
              flag = true;
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORLENGTHPHONECONTACT,
                "error"
              );
              return;
            }
          }
        }
      });
    }

    // dataToSave.group = vm.editForm.subsubgrupo ? vm.editForm.subsubgrupo.url : vm.editForm.subgroup ? vm.editForm.subgroup.url : vm.editForm.group ? vm.editForm.group.url : '';
    if (vm.editForm.group) {
      dataToSave.group = vm.editForm.group.url;
      if (vm.editForm.subgroup) {
        dataToSave.group = vm.editForm.subgroup.url;
        if (vm.editForm.subsubgrupo) {
          dataToSave.group = vm.editForm.subsubgrupo.url;
        }
      }
    }
    // dataToSave.grouping_level = vm.editForm.subsubasignaciones ? vm.editForm.subsubasignaciones.url : vm.editForm.subagrupaciones ? vm.editForm.subagrupaciones.url : vm.editForm.grouping_level ? vm.editForm.grouping_level.url : '';
    dataToSave.groupinglevel = vm.editForm.subsubasignaciones
      ? vm.editForm.subsubasignaciones.url
      : vm.editForm.subagrupaciones
      ? vm.editForm.subagrupaciones.url
      : vm.editForm.grouping_level
      ? vm.editForm.grouping_level.url
      : null;
    dataToSave.cellule = vm.juridicalForm
      ? vm.juridicalForm.celula
      : vm.form
      ? vm.form.celula
      : null;

    if (flag) {
      return;
    }
    dataToSave.birth_date = datesFactory.toDate(
      vm.form ? vm.form.birthday : vm.juridicalForm.date_of_establishment
    );
    dataToSave.bound_solidarity_many = $scope.obligados ? $scope.obligados : [];
    dataToSave.has_bound_solidarity = $scope.has_solidario ? true : false;
    if (vm.juridicalForm) {
      if (vm.juridicalForm.full_name) {
        dataToSave.full_name = vm.juridicalForm.full_name;
        dataToSave.j_name = vm.juridicalForm.full_name;
      }
    }
    if (vm.form) {
      if (vm.form.full_name) {
        dataToSave.full_name = vm.form.full_name;
      }
    }
    return ContratanteService.updateContratante(dataToSave).then(function (
      data
    ) {
      if (data.status === 200 || data.status === 201) {
        // var params = {
        //   'model': 26,
        //   'event': "POST",
        //   'associated_id': data.data.id,
        //   'identifier': "actualizó el contratante."
        // }
        // dataFactory.post('send-log/', params).then(function success(response) {

        // });
        savedEditions.natural = null;
        savedEditions.juridical = null;
        $scope.changes = [];
        if ($scope.origin_contractor.first_name !== data.data.first_name) {
          var change_log = {
            name: "Nombre",
            origin: $scope.origin_contractor.first_name,
            change: data.data.first_name,
          };
          $scope.changes.push(change_log);
        }
        if ($scope.origin_contractor.last_name !== data.data.last_name) {
          var change_log = {
            name: "Apellido Paterno",
            origin: $scope.origin_contractor.last_name,
            change: data.data.last_name,
          };
          $scope.changes.push(change_log);
        }
        if ($scope.origin_contractor.j_name !== data.data.j_name) {
          var change_log = {
            name: "Nombre",
            origin: $scope.origin_contractor.j_name,
            change: data.data.j_name,
          };
          $scope.changes.push(change_log);
        }
        if ($scope.origin_contractor.birth_date !== data.data.birth_date) {
          var change_log = {
            name: "Fecha Cumpleaños",
            origin: datesFactory.convertDate(
              $scope.origin_contractor.birth_date
            ),
            change: datesFactory.convertDate(data.data.birth_date),
          };
          $scope.changes.push(change_log);
        }
        if (
          $scope.origin_contractor.date_of_establishment !==
          data.data.date_of_establishment
        ) {
          var change_log = {
            name: "Fecha Constitutiva",
            origin: $scope.origin_contractor.date_of_establishment,
            change: data.data.date_of_establishment,
          };
          $scope.changes.push(change_log);
        }
        if ($scope.origin_contractor.email !== data.data.email) {
          var change_log = {
            name: "Correo Electrónico",
            origin: $scope.origin_contractor.email,
            change: data.data.email,
          };
          $scope.changes.push(change_log);
        }

        var paramsRec = {
          model: 26,
          event: "PATCH",
          associated_id: data.data.id,
          identifier: " actualizó la el contratante.",
          change: $scope.changes,
        };

        dataFactory
          .post("send_log_specific/", paramsRec)
          .then(function success(response) {});

        if (data.data.email && !data.data.id) {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROREMAILMAX, "error");
          return;
        }

        $scope.contractorEdit = data.data;

        if (data) {
          if (data.data.type_person == 1) {
            if ($scope.uploaderDocument.queue.length != 0) {
              uploadFilesList(data.data.type_person, data.data.id);
            }
            $scope.sendEmails(data.data.id, 1);
            $scope.sendPhones(data.data.id, 1);
            $scope.sendResponsables(data.data.url, 1);
          } else if (data.data.type_person == 2) {
            if ($scope.uploaderDocument.queue.length != 0) {
              uploadFilesList(data.data.type_person, data.data.id);
            }
            $scope.sendEmails(data.data.id, 2);
            $scope.sendPhones(data.data.id, 2);
            $scope.sendResponsables(data.data.url, 2);
          }
        }
        if (helpers.isResponseOk(data.status)) {
          var contacts =
            $stateParams.type === "fisicas" ||
            $stateParams.contractor.type_person === 1
              ? type.contact_natural
              : type.contact_juridical;

          contacts.forEach(function (elem) {
            if (
              $stateParams.type === "fisicas" ||
              $stateParams.contractor.type_person === 1
            ) {
              // elem.natural = data.data.url;
              elem.contractor = data.data.url;
            } else {
              // elem.juridical = data.data.url;
              elem.contractor = data.data.url;
            }

            var nums = [];

            $(".telefono").each(function (telefono) {
              var actual = $(this);
              nums.push(actual);
            });
            var typePerson;
            if (
              $stateParams.type === "fisicas" ||
              $stateParams.contractor.type_person === 1
            ) {
              typePerson = vm.form.contact_natural;
            } else {
              typePerson = vm.juridicalForm.contact_juridical;
            }

            if (!elem.url) {
              contactService.createContact(elem);
            } else {
              contactService.updateContact(elem);
            }

            if (elem.email) {
              if (!validateEmail(elem.email)) {
                toaster.warning(
                  "Favor de revisar el formato del correo de el contacto"
                );
                flag = true;
              }
              if (!elem.name) {
                toaster.warning("Favor de añadir nombre en el contacto");
                flag = true;
              }
            }
          });
          var address = type.userAddresses
            ? type.userAddresses
            : type.address_natural
            ? type.address_natural
            : type.address_juridical;
          if (!helpers.hasAtLeastOneAddress(address)) {
            l.stop();
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.ADDATLEASTONEDIRECCTION,
              "error"
            );
            flag = true;
            return;
          }
          address.forEach(function (elem) {
            if (flag) {
              return;
            }

            elem = {
              raw: elem.raw,
              street_address: elem.street_address,
              intersection: elem.intersection,
              political: elem.political,
              administrative_area_level_1:
                elem.administrative_area_level_1.state,
              administrative_area_level_1_short:
                elem.administrative_area_level_1_short,
              administrative_area_level_2:
                elem.administrative_area_level_2.city,
              administrative_area_level_3: elem.administrative_area_level_3,
              colloquial_area: elem.colloquial_area,
              sublocality: elem.sublocality,
              neighborhood: elem.neighborhood,
              premise: elem.premise,
              subpremise: elem.subpremise,
              natural_feature: elem.natural_feature,
              country: elem.country,
              country_code: elem.country_code,
              locality: elem.locality,
              postal_code: elem.postal_code,
              route: elem.route,
              street_number: elem.street_number,
              street_number_int: elem.street_number_int,
              formatted: elem.formatted,
              latitude: elem.latitude,
              longitude: elem.longitude,
              details: elem.details,
              composed: elem.composed,
              address: elem.address,
              url: globalVar.address,
              tipo: elem.tipo ? elem.tipo.name : elem.tipo,
              id: elem.id || null,
            };

            if (
              $stateParams.type === "fisicas" ||
              $stateParams.contractor.type_person === 1
            ) {
              // elem.natural = data.data.url;
              elem.contractor = data.data.url;
            } else {
              // elem.juridical = data.data.url;
              elem.contractor = data.data.url;
            }
            if (!elem.id) {
              generalService.postService(elem).then(function (data) {
                if (!helpers.isResponseOk(data.status)) {
                  l.stop();
                  SweetAlert.swal(
                    "ERROR",
                    MESSAGES.ERROR.UPDATECONTRACTOR,
                    "error"
                  );
                  return;
                }
              });
            } else {
              generalService.updateAddressService(elem).then(function (data) {
                if (!helpers.isResponseOk(data.status)) {
                  l.stop();
                  SweetAlert.swal(
                    "ERROR",
                    MESSAGES.ERROR.UPDATECONTRACTOR,
                    "error"
                  );
                  return;
                }
              });
            }
          });

          if (flag) {
            return;
          }
          SweetAlert.swal("¡Listo!", MESSAGES.OK.UPDATECONTRACTOR, "success");
          $timeout(function () {
            $state.reload();
            $state.go("contratantes.info", {
              type:
                $scope.contractorEdit.type_person == 1 ? "fisicas" : "morales",
              contratanteId: $scope.contractorEdit.id,
            });
          }, 1000);
        } else {
          l.stop();
          SweetAlert.swal("ERROR", MESSAGES.ERROR.UPDATECONTRACTOR, "error");
          return;
          vm.form.group = $scope.group_obj;
        }
      }
    });
  }

  $scope.getLog = function () {
    dataFactory
      .get("get-specific-log", {
        model: 26,
        associated_id: vm.form ? vm.form.id : vm.juridicalForm.id,
      })
      .then(function success(response) {
        var modalInstance = $uibModal.open({
          templateUrl: "app/colectivos/log.modal.html",
          controller: "LogCtrl",
          size: "lg",
          resolve: {
            log: function () {
              return response.data;
            },
          },
          backdrop: "static",
          keyboard: false,
        });
        modalInstance.result.then(function (receipt) {
          vm.receipts.splice(index, 1);
          activate();
        });
      })
      .catch(function (e) {
        console.log("error", e);
      });
  };

  vm.hoy = new Date();

  function returnType() {
    if (
      $stateParams.type === "fisicas" ||
      $stateParams.contractor.type_person === 1
    ) {
      rfc_getDateEn(vm.form.rfc, vm.form);
      function rfc_getDateEn(rfc, form) {
        vm.rfc_fec = rfc.substr(4, 6);
        vm.rfc_anio = rfc.substr(4, 2);
        vm.rfc_month = rfc.substr(6, 2);
        vm.rfc_day = rfc.substr(8, 2);
        vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
        vm.date = new Date(vm.fecha);
        vm.aniorfc = vm.date.getFullYear();
        vm.hoyA = vm.hoy.getFullYear();
        if (vm.aniorfc > vm.hoyA) {
          vm.resta = vm.aniorfc - 100;
          vm.rfc_anio = vm.resta;
          vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
          if (form.birthday == "") {
            vm.form.birthday = vm.fecha;
          } else {
            vm.form.birthday = form.birthday;
          }
        }
        if (form.birthday == "") {
          var fecha_rfcn = $filter("date")(new Date(vm.date), "dd/MM/yyyy");
          vm.form.birthday = fecha_rfcn;
        } else {
          vm.form.birthday = form.birthday;
        }
      }
      return vm.form;
    } else {
      rfc_getDateEj(vm.juridicalForm.rfc, vm.juridicalForm);
      function rfc_getDateEj(rfc, form) {
        vm.rfc_fec = rfc.substr(3, 6);
        vm.rfc_anio = rfc.substr(3, 2);
        vm.rfc_month = rfc.substr(5, 2);
        vm.rfc_day = rfc.substr(7, 2);
        vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
        vm.date = new Date(vm.fecha);
        vm.aniorfc = vm.date.getFullYear();
        vm.hoyA = vm.hoy.getFullYear();
        if (vm.aniorfc > vm.hoyA) {
          vm.resta = vm.aniorfc - 100;
          vm.rfc_anio = vm.resta;
          vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
          if (form.date_of_establishment == "") {
            var fecha_rfcJ = $filter("date")(new Date(vm.fecha), "dd/MM/yyyy");
            vm.juridicalForm.date_of_establishment = fecha_rfcJ;
          } else {
            vm.juridicalForm.date_of_establishment = form.date_of_establishment;
          }
        }
        if (form.date_of_establishment == "") {
          var fecha_rfcJ = $filter("date")(new Date(vm.date), "dd/MM/yyyy");
          vm.juridicalForm.date_of_establishment = fecha_rfcJ;
        } else {
          vm.juridicalForm.date_of_establishment = form.date_of_establishment;
        }
      }
      return vm.juridicalForm;
    }
  }

  function deleteContacts(index, type, contact) {
    var contactIndex = index;
    var contactUrl = contact ? contact.url : null;
    var hasIndex = contactIndex || contactIndex === 0;
    SweetAlert.swal(
      {
        title: "¿Estás seguro?",
        text: "Los cambios no podrán revertirse",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Si",
        cancelButtonText: "No",
      },
      function () {
        if (contactUrl && hasIndex) {
          try {
            return contactService.deleteContact(contactUrl).then(function () {
              toaster.success(MESSAGES.OK.DELETECONTRACTOR);

              if (
                $stateParams.type === "fisicas" ||
                $stateParams.contractor.type_person === 1
              ) {
                vm.form.contact_natural.splice(contactIndex, 1);
              } else {
                vm.juridicalForm.contact_juridical.splice(contactIndex, 1);
              }
            });
          } catch (err) {
            throw err;
          }
        } else {
          if (
            $stateParams.type === "fisicas" ||
            $stateParams.contractor.type_person === 1
          ) {
            vm.form.contact_natural.splice(contactIndex, 1);
          } else {
            vm.juridicalForm.contact_juridical.splice(contactIndex, 1);
          }
        }
      }
    );
  }

  function addContact() {
    var contact = {
      name: "",
      phone_number: "",
      email: "",
    }; //jshint ignore:line
    if (
      $stateParams.type === "fisicas" ||
      $stateParams.contractor.type_person === 1
    ) {
      vm.form.contact_natural.push(contact);
    } else {
      vm.juridicalForm.contact_juridical.push(contact);
    }
  }
  $window.localStorage.editCont = false;
}

/* global angular */
(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("ContratantesCtrl", ContratantesCtrl);

  ContratantesCtrl.$inject = [
    "datesFactory",
    "dataFactory",
    "SweetAlert",
    "url",
    "ContratanteService",
    "groupService",
    "contactService",
    "generalService",
    "FileUploader",
    "toaster",
    "helpers",
    "globalVar",
    "MESSAGES",
    "$uibModal",
    "$filter",
    "$scope",
    "$rootScope",
    "$localStorage",
    "$timeout",
    "$q",
    "$state",
    "$sessionStorage",
    "$location",
    "$http",
    "$parse",
    "exportFactory",
    "PersistenceFactory",
    "appStates",
  ];

  function ContratantesCtrl(
    datesFactory,
    dataFactory,
    SweetAlert,
    url,
    ContratanteService,
    groupService,
    contactService,
    generalService,
    FileUploader,
    toaster,
    helpers,
    globalVar,
    MESSAGES,
    $uibModal,
    $filter,
    $scope,
    $rootScope,
    $localStorage,
    $timeout,
    $q,
    $state,
    $sessionStorage,
    $location,
    $http,
    $parse,
    exportFactory,
    PersistenceFactory,
    appStates
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var orgParam = { params: { org: $localStorage.orgId } };
    // show / hide buttons
    $scope.fisicas = true;
    $scope.morales = false;
    $scope.flagPhone = false;
    $scope.responsables_natural = [];
    $scope.responsables_juridical = [];
    $scope.isValidRFCN = false;

    var vm = this;
    vm.org_name = usr.org;
    vm.Consultar = Consultar;
    vm.table = {};
    vm.changeTypePerson = changeTypePerson;
    vm.onlySureties = onlySureties;

    vm.closeDropdown = closeDropdown;
    vm.order_asc = false;
    vm.listDocument = [
      {
        id: 1,
        name: "Identificación Oficial",
        value: false,
        file: false,
        arch: {},
      },
      { id: 2, name: "CURP", value: false, file: false, arch: {} },
      {
        id: 3,
        name: "Comprobante de Inscripción de Firma Electrónica",
        value: false,
        file: false,
        arch: {},
      },
      {
        id: 4,
        name: "Comprobante de Domicilio",
        value: false,
        file: false,
        arch: {},
      },
      {
        id: 5,
        name: "Formato de Identificación de Cliente Firmado",
        value: false,
        file: false,
        arch: {},
      },
      { id: 6, name: "Poder", value: false, file: false, arch: {} },
      {
        id: 7,
        name: "Constancia Situación Fiscal",
        value: false,
        file: false,
        arch: {},
      },
    ];
    if (vm.org_name == "ancora") {
      vm.listDocument = [
        {
          id: 1,
          name: "Identificación Oficial",
          value: false,
          file: false,
          arch: {},
        },
        { id: 2, name: "CURP", value: false, file: false, arch: {} },
        {
          id: 3,
          name: "Comprobante de Inscripción de Firma Electrónica",
          value: false,
          file: false,
          arch: {},
        },
        {
          id: 4,
          name: "Comprobante de Domicilio",
          value: false,
          file: false,
          arch: {},
        },
        {
          id: 5,
          name: "Formato de Identificación de Cliente Firmado",
          value: false,
          file: false,
          arch: {},
        },
      ];
    }

    $scope.campo_agrupacion = false;
    $scope.campo_celula = false;
    $scope.campo_lineanegocio = false;
    dataFactory.get("orginfo/").then(function success(response) {
      if (response.data.results.length) {
        $scope.configuracionGlobal = response.data.results[0];
        if ($scope.configuracionGlobal.moduleName) {
          $scope.moduleName = $scope.configuracionGlobal.moduleName;
        }
        $scope.campo_agrupacion = $scope.configuracionGlobal.filtros_agrupacion;
        $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
        $scope.campo_lineanegocio =
          $scope.configuracionGlobal.filtros_lineanegocio;
      }
    });
    $scope.infoUser = $sessionStorage.infoUser;
    $scope.onlyFianzas = function (q) {
      if (vm.form.only_sureties || vm.juridicalForm.only_sureties) {
        if (q == 1) {
          vm.listDocument = [
            {
              id: 1,
              name: "Identificación Oficial",
              value: false,
              file: false,
              arch: {},
            },
            { id: 2, name: "CURP", value: false, file: false, arch: {} },
            {
              id: 3,
              name: "Comprobante de Inscripción de Firma Electrónica",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Formato de Identificación de Cliente Firmado",
              value: false,
              file: false,
              arch: {},
            },
            { id: 6, name: "Poder", value: false, file: false, arch: {} },
            {
              id: 7,
              name: "Carta nombramiento",
              value: false,
              file: false,
              arch: {},
            },
            { id: 8, name: "Currículo", value: false, file: false, arch: {} },
            {
              id: 9,
              name: "Contrato multiple de la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            { id: 10, name: "Carta buro", value: false, file: false, arch: {} },
            {
              id: 11,
              name: "Entrevista con la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            { id: 12, name: "RFC", value: false, file: false, arch: {} },
            {
              id: 13,
              name: "Recibos de nomina",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 14,
              name: "Declaración anual completa con cadena de los últimos dos años inmediatos anteriores",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 15,
              name: "Estados financieros anuales del año inmediato anterior",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 16,
              name: "Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 17,
              name: "Alta ante hacienda o alta electrónica",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 18,
              name: "Escritura de inmueble",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 19,
              name: "Boleta predial o avaluó",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 20,
              name: "Certificado de libertad de gravamen",
              value: false,
              file: false,
              arch: {},
            },
          ];
          if (vm.org_name == "ancora") {
            vm.listDocument = [
              {
                id: 1,
                name: "Identificación Oficial",
                value: false,
                file: false,
                arch: {},
              },
              { id: 2, name: "CURP", value: false, file: false, arch: {} },
              {
                id: 3,
                name: "Comprobante de Inscripción de Firma Electrónica",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 4,
                name: "Comprobante de Domicilio",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 5,
                name: "Formato de Identificación de Cliente Firmado",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 6,
                name: "Carta nombramiento",
                value: false,
                file: false,
                arch: {},
              },
              { id: 7, name: "Currículo", value: false, file: false, arch: {} },
              {
                id: 8,
                name: "Contrato multiple de la afianzadora",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 9,
                name: "Carta buro",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 10,
                name: "Entrevista con la afianzadora",
                value: false,
                file: false,
                arch: {},
              },
              { id: 11, name: "RFC", value: false, file: false, arch: {} },
              {
                id: 12,
                name: "Recibos de nomina",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 13,
                name: "Declaración anual completa con cadena de los últimos dos años inmediatos anteriores",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 14,
                name: "Estados financieros anuales del año inmediato anterior",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 15,
                name: "Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 16,
                name: "Alta ante hacienda o alta electrónica",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 17,
                name: "Escritura de inmueble",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 18,
                name: "Boleta predial o avaluó",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 19,
                name: "Certificado de libertad de gravamen",
                value: false,
                file: false,
                arch: {},
              },
            ];
          }
        } else if (q == 2) {
          vm.listDocument = [
            {
              id: 1,
              name: "Acta Constitutiva",
              value: false,
              file: false,
              arch: {},
            },
            { id: 2, name: "RFC", value: false, file: false, arch: {} },
            {
              id: 3,
              name: "Cédula de Identificación Fiscal",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio Fiscal",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Modificaciones al Acta Constitutiva",
              value: false,
              file: false,
              arch: {},
            },
            { id: 6, name: "Poder", value: false, file: false, arch: {} },
            {
              id: 7,
              name: "Currículo reciente",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 8,
              name: "Contrato multiple de la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            { id: 9, name: "Carta Buró", value: false, file: false, arch: {} },
            {
              id: 10,
              name: "Cuestionario o entrevista",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 11,
              name: "Aviso de privacidad de la afianzadora",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 12,
              name: "Protocolizaciones",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 13,
              name: "Alta de empresa ante hacienda",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 14,
              name: "Cambio de domicilio ante hacienda",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 15,
              name: "Copia del comprobante de inscripción para la e.firma (firma electrónica)",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 16,
              name: "Declaración anual completa con cadena, de los últimos dos años",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 17,
              name: "Estados financieros dictaminados cuadernillo completo, del año inmediato anterior",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 18,
              name: "Estados financieros parciales los más recientes de este año con no mayor antigüedad de dos meses",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 19,
              name: "Escritura de inmueble",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 20,
              name: "Boleta predial o avaluó",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 21,
              name: "Certificado de libertad de gravamen",
              value: false,
              file: false,
              arch: {},
            },
          ];
        }
      } else {
        if (q == 1) {
          vm.listDocument = [
            {
              id: 1,
              name: "Identificación Oficial",
              value: false,
              file: false,
              arch: {},
            },
            { id: 2, name: "CURP", value: false, file: false, arch: {} },
            {
              id: 3,
              name: "Comprobante de Inscripción de Firma Electrónica",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Formato de Identificación de Cliente Firmado",
              value: false,
              file: false,
              arch: {},
            },
            { id: 6, name: "Poder", value: false, file: false, arch: {} },
            {
              id: 7,
              name: "Constancia Situación Fiscal",
              value: false,
              file: false,
              arch: {},
            },
          ];
          if (vm.org_name == "ancora") {
            vm.listDocument = [
              {
                id: 1,
                name: "Identificación Oficial",
                value: false,
                file: false,
                arch: {},
              },
              { id: 2, name: "CURP", value: false, file: false, arch: {} },
              {
                id: 3,
                name: "Comprobante de Inscripción de Firma Electrónica",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 4,
                name: "Comprobante de Domicilio",
                value: false,
                file: false,
                arch: {},
              },
              {
                id: 5,
                name: "Formato de Identificación de Cliente Firmado",
                value: false,
                file: false,
                arch: {},
              },
            ];
          }
        } else if (q == 2) {
          vm.listDocument = [
            {
              id: 1,
              name: "Acta Constitutiva",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 2,
              name: "Constancia Situación Fiscal",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 3,
              name: "Cédula de Identificación Fiscal",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio Fiscal",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Modificaciones al Acta Constitutiva",
              value: false,
              file: false,
              arch: {},
            },
            { id: 6, name: "Poder", value: false, file: false, arch: {} },
            {
              id: 7,
              name: "INE Representante Legal",
              value: false,
              file: false,
              arch: {},
            },
          ];
        }
      }
    };
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };
    $scope.docs = {};
    $scope.type = function (r) {
      if (r === 1) {
        vm.form.type_person = 1;
      }

      if (r === 2) {
        vm.form.type_person = 2;
      }

      if (vm.form.only_sureties || vm.juridicalForm.only_sureties) {
        $scope.onlyFianzas(r);
      } else if (r === 1) {
        vm.listDocument = [
          {
            id: 1,
            name: "Identificación Oficial",
            value: false,
            file: false,
            arch: {},
          },
          { id: 2, name: "CURP", value: false, file: false, arch: {} },
          {
            id: 3,
            name: "Comprobante de Inscripción de Firma Electrónica",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 4,
            name: "Comprobante de Domicilio",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 5,
            name: "Formato de Identificación de Cliente Firmado",
            value: false,
            file: false,
            arch: {},
          },
          { id: 6, name: "Poder", value: false, file: false, arch: {} },
          {
            id: 7,
            name: "Constancia Situación Fiscal",
            value: false,
            file: false,
            arch: {},
          },
        ];
        if (vm.org_name === "ancora") {
          vm.listDocument = [
            {
              id: 1,
              name: "Identificación Oficial",
              value: false,
              file: false,
              arch: {},
            },
            { id: 2, name: "CURP", value: false, file: false, arch: {} },
            {
              id: 3,
              name: "Comprobante de Inscripción de Firma Electrónica",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 4,
              name: "Comprobante de Domicilio",
              value: false,
              file: false,
              arch: {},
            },
            {
              id: 5,
              name: "Formato de Identificación de Cliente Firmado",
              value: false,
              file: false,
              arch: {},
            },
          ];
        }
      } else if (r === 2) {
        vm.listDocument = [
          {
            id: 1,
            name: "Acta Constitutiva",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 2,
            name: "Constancia Situación Fiscal",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 3,
            name: "Cédula de Identificación Fiscal",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 4,
            name: "Comprobante de Domicilio Fiscal",
            value: false,
            file: false,
            arch: {},
          },
          {
            id: 5,
            name: "Modificaciones al Acta Constitutiva",
            value: false,
            file: false,
            arch: {},
          },
          { id: 6, name: "Poder", value: false, file: false, arch: {} },
          {
            id: 7,
            name: "INE Representante Legal",
            value: false,
            file: false,
            arch: {},
          },
        ];
      }

      $scope.type_person_selected = r;
    };

    function closeDropdown() {
      $(".hasDropdown").removeClass("open");
    }

    vm.form = {
      contratante: "0",
      grupo: "",
      type_person: 0,
      rfc: "",
      vendedor: "",
      onlySureties: false,
      onlyVIP: false,
    };

    $scope.contractorNew = [];

    $scope.userInfo = {
      type_person: "",
      id: 0,
    };
    vm.user = usr;

    vm.table = {
      headers: ["Nombre", "Tipo", "Acciones"],
    };
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    vm.address_type = [
      {
        name: "Dirección Personal",
        id: 0,
      },
      {
        name: "Dirección Fiscal",
        id: 1,
      },
      {
        name: "Dirección de cobro",
        id: 2,
      },
      {
        name: "Dirección de paquetería",
        id: 3,
      },
      {
        name: "Dirección de riesgo",
        id: 4,
      },
      {
        name: "CFDI",
        id: 5,
      },
    ];

    vm.clasifications = [
      // {name: 'Pequeño', value: 1},
      // {name: 'Regular', value: 2},
      // {name: 'Grande', value: 3},
      // {name: 'Jumbo', value: 4}
    ];
    vm.celulas = [];
    vm.agrupaciones = [];

    // $(window).load(function() {
    //     $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });

    $scope.selectConditions = function (sel) {
      vm.condition_selected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.condition_selected.push(parseInt(r));
      });
    };

    function changeTypePerson(obj) {
      vm.form.type_person = obj;
    }

    function onlySureties(obj) {
      vm.form.onlySureties = obj;
    }

    $scope.changeVIP = function (obj) {
      vm.form.onlyVIP = obj;
    };

    $scope.moduleName = "Célula";
    function Consultar(order, parPage) {
      if (vm.order_asc) {
        vm.order_asc = false;
      } else {
        vm.order_asc = true;
      }
      if (vm.show_binnacle == true) {
        vm.show_binnacle = false;
      }
      vm.show_pagination = false;
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;
      $scope.results = true;
      var parUrl = url.IP + "filtros-contractor/";

      // New url fussion --
      // var parUrl = url.IP + 'filtros-contractor/';
      if (vm.form_list && vm.form_list.group) {
        if (vm.form_list.group.val) {
          var g = vm.form_list.group.value;
        } else {
          var g = 0;
        }
      } else {
        var g = 0;
      }
      if (vm.form_list && vm.form_list.contratante) {
        var c = vm.form_list.contratante;
      } else {
        var c = 0;
      }
      if (vm.form_list && vm.form_list.rfc) {
        var f = vm.form_list.rfc;
      } else {
        var f = 0;
      }

      var params = {
        contratante: c ? c : 0,
        rfc: f ? f : 0,
        grupo: g ? g : 0,
        order: vm.order_asc ? vm.order_asc : 0,
        condicion: vm.condition_selected ? vm.condition_selected : 0,
        parPage: parPage ? parPage : 1,
        type_person: vm.form.type_person ? vm.form.type_person : 0,
        onlyS: vm.form.onlySureties ? vm.form.onlySureties : false,
        onlyVIP: vm.form.onlyVIP ? vm.form.onlyVIP : false,
      };
      $http({
        method: "POST",
        url: parUrl,
        data: params,
      }).then(function success(response) {
        if (response.status == 200 && response.data.results.length) {
          vm.persons.all = response.data.results;
          // if(vm.form.type_person == 1){
          //   vm.persons.naturals = response.data.results;
          //   vm.persons.juridicals = [];
          // }
          // else if (vm.form.type_person == 2) {
          //   vm.persons.juridicals = response.data.results;
          //   vm.persons.naturals = [];
          // }
          // else {
          //   vm.persons.all = response.data.results;
          // }
          $scope.order = vm.order_asc;
          vm.persons_config = {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          };
          $scope.personn_config = {
            count: response.data.count,
            previous: parUrl,
            next: parUrl,
          };
          vm.show_pagination = true;
          if (vm.form_list) {
            vm.form_list.type_person =
              vm.form_list.type_person != 0 ? vm.form_list.type_person : 0;
          }
          $scope.obtenerPaginacion(response.data, parPage ? parPage : 1);
          // $scope.testPagination('vm.persons.naturals', 'personn_config');
        } else {
          toaster.warning("No se encontraron registros");
          vm.persons.all = [];
          vm.persons.naturals = [];
        }
      });
    }
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (pagesdata, pagina) {
      $scope.paginacion = {
        count: pagesdata["count"],
        previous: pagesdata["previous"],
        next: pagesdata["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      vm.Consultar(1, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        vm.Consultar(1, $scope.paginacion["paginaActual"] - 1);
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        vm.Consultar(1, $scope.paginacion["paginaActual"] + 1);
      }
    };
    vm.exportDataE = exportDataE;
    vm.hoy = new Date();

    function exportDataE(param) {
      var rex = Ladda.create(document.querySelector(".ladda-button-excel"));
      rex.start();
      if (vm.form.type_person) {
        var parUrl = url.IP + "service_reporte-contractor-excel";
      } else {
        toaster.info("Debe seleccionar un tipo de contratante");
        return;
      }
      var parUrl = url.IP + "service_reporte-contractor-excel";
      if (vm.form.group) {
        var g = vm.form.group.value;
      } else {
        var g = 0;
      }
      if (vm.form.contratante) {
        var c = vm.form.contratante;
      } else {
        var c = 0;
      }
      if (vm.form_list && vm.form_list.rfc) {
        var f = vm && vm.form_list ? vm.form_list.rfc : 0;
      } else {
        var f = 0;
      }

      var params = {
        contratante: c,
        rfc: f,
        grupo: g,
        order: vm.order_asc,
        condicion: vm.condition_selected ? vm.condition_selected : 0,
        type_person: vm.form.type_person ? vm.form.type_person : 1,
        onlyS: vm.form.onlySureties ? vm.form.onlySureties : false,
        onlyVIP: vm.form.onlyVIP ? vm.form.onlyVIP : false,
      };
      $http({
        method: "POST",
        url: parUrl,
        data: params,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function (data, status, headers, config) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Contratantes.xls");
          rex.stop();
        })
        .catch(function (e) {
          console.log("e", e);
          rex.stop();
        });
      // }). then(function success(response) {
      //   if(response.status === 200) {
      //    exportFactory.excel(response.data, 'Contratantes');
      // }
      //  })
    }

    $scope.matchesGroup = function (parWord, parType) {
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        var word_data = vm.form.group.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    };

    $scope.selectRfc = function (rfc) {
      vm.form.rfc = rfc.replace(/-/g, "");
    };
    vm.search = search;
    function search(cadena) {
      vm.show_binnacle = false;
      vm.show_pagination = false;
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;

      if (cadena.length) {
        $http({
          method: "GET",
          url: url.IP + "seeker-contractors/",
          params: {
            cadena: cadena,
            type_person: 1,
          },
        })
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.persons.juridicals = [];
                vm.persons.naturals = [];
                vm.persons = [];
                vm.persons.naturals = request.data.results;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });

        $http({
          method: "GET",
          url: url.IP + "seeker-juridicals/",
          params: {
            cadena: cadena,
            type_person: 2,
          },
        })
          .then(
            function success(request) {
              vm.persons.naturals = [];
              vm.persons.juridicals = [];
              if (request.status === 200) {
                vm.persons.naturals = [];
                vm.persons.juridicals = [];
                vm.persons = [];
                vm.persons.juridicals = request.data.results;
                vm.juridicals_config = {
                  count: request.data.count,
                  next: request.data.next,
                  previous: request.data.previous,
                };
                vm.show_pag_juridicals = true;
                vm.buttonsJuridicals = true;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else {
        vm.persons.juridicals = [];
        vm.persons.naturals = [];
      }
    }

    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      // if ($uibModalInstance) {
      //     $uibModalInstance.dismiss('cancel');
      // }
      $scope.enviado = true;
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          $scope.enviado = false;
          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWCONTRACTOR, "success");
          console.log("$location.path()", $location.path());
          if ($location.path() == "/contratantes/crear") {
            if (vm.acceso_ver_cont) {
              $state.go("contratantes.info", {
                type:
                  $scope.contractorNew.type_person == "Fisica"
                    ? "fisicas"
                    : "morales",
                contratanteId: $scope.contractorNew.id,
              });
            } else {
              $state.go("index.main");
            }
          } else if ($location.path() == "/colectividades/") {
            var params = { myInsurance: $scope.contractorNew };
            $state.go("colectividades.main", params);
          } else if ($location.path() == "/fianzas/") {
            $rootScope.show_contractor = false;
            // var params = { 'myInsurance': $scope.contractorNew }
            // $state.go('fianzas.fianzas', params);
          } else if ($location.path() == "/fianzas/colectividades") {
            $rootScope.show_contractor = false;
            var params = { myInsurance: data };
            $state.go("fianzas.colectividades", params);
          } else if ($location.path().includes("flotilla")) {
            var path = $location.path();
            // Detectar patrón: /flotillas/{id_numérico}
            var regex = /^\/flotillas\/(\d+)$/;
            var match = path.match(regex);
            if (match) {
              var flotillaId = match[1]; // el número capturado
              console.log("Detectado flotilla:", flotillaId);
              // Redirige a donde tú quieras:
              $rootScope.show_contractor = false;
              var params = { myInsurance: data, polizaId: flotillaId };
              $rootScope.myInsurance = params;
              if (flotillaId) {
                $state.go("flotillas.info", {
                  polizaId: flotillaId,
                  dataContractor: data,
                });
              } else {
                $state.go("flotillas.flotillas", { dataContractor: data });
              }
            }
          } else {
            $rootScope.show_contractor = false;
            var params = { myInsurance: $scope.contractorNew };
            $state.go("polizas.create", params);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      $scope.enviado = false;
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        name: fileItem.file.name,
      });
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].name = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };
    //archivos lista documentos
    $scope.addFileList = function (index, lista, file, xy) {
      var extension = file[0].formData[0].name.split(".")[1];
      file[0].formData[0].name = vm.listDocument[index].name + "." + extension;
      vm.listDocument[index].arch = file[0];
      vm.listDocument[index].file = true;
      $scope.uploaderDocument.queue = [];
    };
    var uploaderDocument = ($scope.uploaderDocument = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploaderDocument.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploaderDocument.onSuccessItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      // if ($uibModalInstance) {
      //     $uibModalInstance.dismiss('cancel');
      // }

      $scope.enviado = true;
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $scope.enviado = false;
        $timeout(function () {
          SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWCONTRACTOR, "success");
          console.log("$location2.path()", $location.path());
          if ($location.path() == "/contratantes/crear") {
            if (vm.acceso_ver_cont) {
              $state.go("contratantes.info", {
                type:
                  $scope.contractorNew.type_person == "Fisica"
                    ? "fisicas"
                    : "morales",
                contratanteId: $scope.contractorNew.id,
              });
            } else {
              $state.go("index.main");
            }
          } else if ($location.path() == "/colectividades/") {
            var params = { myInsurance: $scope.contractorNew };
            $state.go("colectividades.main", params);
          } else if ($location.path() == "/fianzas/colectividades") {
            $rootScope.show_contractor = false;
            var params = { myInsurance: data };
            $state.go("fianzas.colectividades", params);
          } else if ($location.path().includes("flotilla")) {
            var path = $location.path();
            // Detectar patrón: /flotillas/{id_numérico}
            var regex = /^\/flotillas\/(\d+)$/;
            var match = path.match(regex);
            if (match) {
              var flotillaId = match[1]; // el número capturado
              console.log("Detectado flotilla:", flotillaId);
              // Redirige a donde tú quieras:
              $rootScope.show_contractor = false;
              var params = { myInsurance: data, polizaId: flotillaId };
              $rootScope.myInsurance = params;
              if (flotillaId) {
                $state.go("flotillas.info", {
                  polizaId: flotillaId,
                  dataContractor: data,
                });
              } else {
                $state.go("flotillas.flotillas", { dataContractor: data });
              }
            }
          } else if ($location.path() == "/fianzas/") {
            $rootScope.show_contractor = false;
            // var params = { 'myInsurance': $scope.contractorNew }
            // $state.go('fianzas.fianzas', params);
          } else {
            $rootScope.show_contractor = false;
            var params = { myInsurance: $scope.contractorNew };
            $state.go("polizas.create", params);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploaderDocument.onErrorItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      $scope.enviado = false;
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploaderDocument.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        name: fileItem.file.name,
      });
    };

    uploaderDocument.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].name = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };
    //archivos lista docuemntos
    function uploadFilesList(typePerson, idPerson) {
      var lm = Ladda.create(document.querySelector(".ladda-button"));
      lm.start();
      $scope.habilitado = false;
      $scope.userInfo = {
        id: idPerson,
      };
      // $scope.userInfo.url = url.IP + checkType(typePerson) + '/' + idPerson + '/archivos/';
      $scope.userInfo.url =
        url.IP + "contractors" + "/" + idPerson + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploaderDocument.uploadAll();
        lm.stop();
      }, 1000);
    }
    //archivos lista docuemntos
    function uploadFiles(typePerson, idPerson) {
      $scope.habilitado = false;
      var lm = Ladda.create(document.querySelector(".ladda-button"));
      lm.start();
      $scope.userInfo = {
        id: idPerson,
      };
      // $scope.userInfo.url = url.IP + checkType(typePerson) + '/' + idPerson + '/archivos/';
      $scope.userInfo.url =
        url.IP + "contractors" + "/" + idPerson + "/archivos/";

      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
        lm.stop();
        $scope.habilitado = true;
      }, 1000);
    }

    // Contractor
    vm.persons = [];
    vm.checkRFC = checkRFC;
    vm.cancel = cancel;
    vm.submitJuridical = submitJuridical;
    vm.checkType = checkType;
    vm.goToContractorView = goToContractorView;

    vm.control = {
      closeModal: function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      },
    };

    function goToContractorView(person) {
      // if($scope.edit_natural || $scope.edit_juridical) {
      $state.go("contratantes.info", {
        // develop
        // $state.go('contratantes.info', {
        type: checkType(person.type_person),
        contratanteId: person.id,
      });
      // }
    }

    function cancel() {
      $scope.habilitado = true;
      $state.reload();
      var name = "Lista contratantes";
      var route = "contratantes.main";
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.reload();
      $state.go($scope.route_for_new_tab);
    }

    // function goToContractorView(person) {
    //   $state.go('contratantes.edit', {
    //       type: checkType(person.type_person),
    //       contratanteId: person.id
    //   });
    // }

    // Groups
    vm.groups = [];
    vm.openModalGroup = openModalGroup;
    vm.openModalAsignacion = openModalAsignacion;
    vm.openModalClasification = openModalClasification;
    vm.openModalCelulaContractor = openModalCelulaContractor;

    // Contacts
    vm.addContact = addContact;
    vm.deleteContacts = deleteContacts;

    // Addresses, States and cities functions
    vm.addresses = {
      add: addAddress,
      selectedState: selectedState,
      delete: deleteAddress,
    };

    vm.statesArray = [];

    // Disabled after save
    vm.disabledAfterSave = false;
    vm.showBinnacle = showBinnacle;
    vm.returnToContractors = returnToContractors;
    //-----------------------------------------------------------comments
    function showBinnacle(param) {
      vm.show_binnacle = true;
      vm.person_id = param.id;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 2,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }
    //-------------------------------------------------------------comments

    function addAddress(type) {
      // HACK remove before production
      var address = {
        raw: "",
        street_address: "",
        intersection: "",
        political: "",
        administrative_area_level_1: "",
        administrative_area_level_1_short: "",
        administrative_area_level_2: "",
        administrative_area_level_3: "",
        colloquial_area: "",
        sublocality: "",
        neighborhood: "",
        premise: "",
        subpremise: "",
        natural_feature: "",
        country: "",
        country_code: "",
        locality: "",
        postal_code: "",
        route: "",
        street_number: "",
        street_number_int: "",
        formatted: "",
        latitude: "",
        longitude: "",
        details: "",
        composed: "",
      };
      if (type === 1) {
        vm.form.userAddresses.push(address);
      } else {
        vm.juridicalForm.userAddresses.push(address);
      }
    }

    function deleteAddress(index, type) {
      if (type === 1) {
        vm.form.userAddresses.splice(index, 1);
      } else {
        vm.juridicalForm.userAddresses.splice(index, 1);
      }
    }

    function selectedState(selected, index, type) {
      if (type === 1) {
        vm.form.userAddresses[index].city = "";
        vm.form.userAddresses[index].citiesList = selected.cities;
      } else {
        vm.juridicalForm.userAddresses[index].city = "";
        vm.juridicalForm.userAddresses[index].citiesList = selected.cities;
      }
    }

    vm.form = {
      birthday: datesFactory.convertDate(new Date()),
      description: "",
      first_name: "",
      last_name: "",
      rfc: "",
      second_last_name: "",
      sex: null,
      vip: false,
      baja: false,
      motivo_baja: "",
      only_sureties: false,
      emails: [{ correo: "", email_type: "" }],
      responsables: [{ responsables: "", resp_type: "" }],
      phones: [{ phone: "", phone_type: "" }],
      obligados: [],
      userAddresses: [
        {
          raw: "",
          street_address: "",
          intersection: "",
          political: "",
          administrative_area_level_1: "",
          administrative_area_level_1_short: "",
          administrative_area_level_2: "",
          administrative_area_level_3: "",
          colloquial_area: "",
          sublocality: "",
          neighborhood: "",
          premise: "",
          subpremise: "",
          natural_feature: "",
          country: "",
          country_code: "",
          locality: "",
          postal_code: "",
          route: "",
          street_number: "",
          street_number_int: "",
          formatted: "",
          latitude: "",
          longitude: "",
          details: "",
          composed: "",
        },
      ],
      contact_natural: [],
      vendedor: "",
    };

    vm.juridicalForm = {
      userAddresses: [
        {
          raw: "",
          street_address: "",
          intersection: "",
          political: "",
          administrative_area_level_1: "",
          administrative_area_level_1_short: "",
          administrative_area_level_2: "",
          administrative_area_level_3: "",
          colloquial_area: "",
          sublocality: "",
          neighborhood: "",
          premise: "",
          subpremise: "",
          natural_feature: "",
          country: "",
          country_code: "",
          locality: "",
          postal_code: "",
          route: "",
          street_number: "",
          street_number_int: "",
          formatted: "",
          latitude: "",
          longitude: "",
          details: "",
          composed: "",
        },
      ],
      date_of_establishment: null,
      description: "",
      j_name: "",
      rfc: "",
      contact_juridical: [],
      emails: [{ email: "", email_type: "" }],
      responsables: [{ responsable: "", resp_type: "" }],
      phones: [{ phone: "", phone_type: "" }],
      obligados: [],
      vip: false,
      baja: false,
      motivo_baja: "",
      only_sureties: false,
      vendedor: "",
    };

    activate();
    $(".js-example-basic-multiple").select2();
    vm.emptyOrNull = function (item) {
      return !(item === null || item.trim().length === 0);
    };
    vm.showButtonFisica_1 = showButtonFisica_1;
    vm.showButtonMoral_1 = showButtonMoral_1;
    // show / hide buttons personaFisica personaMoral
    function showButtonFisica_1() {
      $scope.fisicas = true;
      $scope.morales = false;
      $("#saveButtonMoralModal").css("display", "none");
      $("#saveButtonFisicaModal").css("display", "block");
    }

    function showButtonMoral_1() {
      $scope.fisicas = false;
      $scope.morales = true;
      $("#saveButtonFisicaModal").css("display", "none");
      $("#saveButtonMoralModal").css("display", "block");
    }

    function readPdf() {
      if ($rootScope.readPDF.type_person == 1) {
        $scope.activeJustified = 0;
        showButtonFisica_1();
        $scope.type(1);
      } else if ($rootScope.readPDF.type_person == 2) {
        $scope.activeJustified = 1;
        showButtonMoral_1();
        $scope.type(2);
      } else {
        $scope.activeJustified = 0;
        showButtonFisica_1();
        $scope.type(1);
      }
      $scope.contratante_tipo = true;
      if ($location.path() == "/polizas/crear") {
        if ($rootScope.readPDF.type_person == 1) {
          $scope.type_person_selected = 1;
          // $scope.contratante_tipo = false;
          $scope.activeJustified = 0;
          vm.form.first_name = $rootScope.readPDF.first_name;
          // vm.form.birthday = $rootScope.readPDF.individual.dob;
          vm.form.last_name = $rootScope.readPDF.last_name;
          vm.form.second_last_name = $rootScope.readPDF.second_last_name;
          vm.form.rfc = $rootScope.readPDF.individual.rfc;
          if (vm.form.rfc && vm.form.rfc.length == 13) {
            $scope.isValidRFCN = true;
            console.log("----true");
          } else {
            console.log("----false");
            $scope.isValidRFCN = false;
          }
          console.log("ingreso");
          // si viene del cotizador
          var quote = localStorage.getItem("quote");

          if (quote) {
            quote = JSON.parse(quote);
            console.log("quote", quote);
            var fecha = new Date(quote.fecha_nacimiento);
            var day = String(fecha.getUTCDate()).padStart(2, "0");
            var month = String(fecha.getUTCMonth() + 1).padStart(2, "0"); // Meses inician en 0
            var year = fecha.getUTCFullYear();

            // Formato dd,mm.yyyy
            vm.form.birthday = day + "/" + month + "/" + year;
            vm.form.sex = quote.sexo;
            vm.form.emailMain = quote.correo;
            vm.form.phoneMain = quote.telefono;
          }
          // vm.form.emailMain = $rootScope.readPDF.individual.email;
          // vm.form.phoneMain = $rootScope.readPDF.individual.phone_number;
          // vm.form.sex = $rootScope.readPDF.individual.sex;
          $q.when()
            .then(function () {
              var defer = $q.defer();
              defer.resolve(helpers.getStates());
              return defer.promise;
            })
            .then(function (data) {
              vm.statesArray = data.data;
              // console.log('$rootScope.readPDF.address', $rootScope.readPDF.address);
              if ($rootScope.readPDF.address) {
                if ($rootScope.readPDF.address["Estado"]) {
                  vm.statesArray.forEach(function (item) {
                    // console.log('item', item);
                    if (
                      sinDiacriticos(
                        $rootScope.readPDF.address["Estado"].toLowerCase()
                      ) == sinDiacriticos(item.state.toLowerCase())
                    ) {
                      vm.form.userAddresses[0].administrative_area_level_1 =
                        item;
                      if ($rootScope.readPDF.address["Municipio"]) {
                        for (var k = 0; k < item.cities.length; k++) {
                          if (
                            sinDiacriticos(
                              $rootScope.readPDF.address[
                                "Municipio"
                              ].toLowerCase()
                            ) ==
                            sinDiacriticos(item.cities[k].city.toLowerCase())
                          ) {
                            vm.form.userAddresses[0].administrative_area_level_2 =
                              item.cities[k];
                          }
                        }
                      }
                    }
                  });
                  // console.log('userAddresses',vm.form.userAddresses[0]);
                }
              }
            });
          if ($rootScope.readPDF) {
            if ($rootScope.readPDF["address"]) {
              vm.form.userAddresses[0].sublocality = $rootScope.readPDF[
                "address"
              ]["Colonia"]
                ? $rootScope.readPDF["address"]["Colonia"]
                : "";
              vm.form.userAddresses[0].route = $rootScope.readPDF["address"][
                "Calle"
              ]
                ? $rootScope.readPDF["address"]["Calle"]
                : "";
              vm.form.userAddresses[0].street_number = $rootScope.readPDF[
                "address"
              ]["Número EXT"]
                ? $rootScope.readPDF["address"]["Número EXT"]
                : "";
              vm.form.userAddresses[0].street_number_int = $rootScope.readPDF[
                "address"
              ]["Número INT"]
                ? $rootScope.readPDF["address"]["Número INT"]
                : "";
              vm.form.userAddresses[0].postal_code = $rootScope.readPDF[
                "address"
              ]["CP"]
                ? $rootScope.readPDF["address"]["CP"]
                : "";
            }
          }
        } else {
          // $scope.contratante_tipo = false;
          $scope.type_person_selected = 2;
          $scope.activeJustified = 1;
          vm.juridicalForm.rfc = $rootScope.readPDF.corporation.rfc;
          vm.juridicalForm.j_name = $rootScope.readPDF.first_name;
          // vm.juridicalForm.rfc = $rootScope.readPDF.corporation.rfc;
          // vm.juridicalForm.emailMain = $rootScope.readPDF.corporation.email;
          // vm.juridicalForm.phoneMain = $rootScope.readPDF.corporation.phone_number;
          // vm.form.sex = $rootScope.readPDF.individual.sex;
          if ($rootScope.readPDF.address["Estado"]) {
            $q.when()
              .then(function () {
                var defer = $q.defer();
                defer.resolve(helpers.getStates());
                return defer.promise;
              })
              .then(function (data) {
                vm.statesArray = data.data;
                // console.log('$rootScope.readPDF.address', $rootScope.readPDF.address);
                if ($rootScope.readPDF.address) {
                  if ($rootScope.readPDF.address["Estado"]) {
                    vm.statesArray.forEach(function (item) {
                      // console.log('item', item);
                      if (
                        sinDiacriticos(
                          $rootScope.readPDF.address["Estado"].toLowerCase()
                        ) == sinDiacriticos(item.state.toLowerCase())
                      ) {
                        vm.juridicalForm.userAddresses[0].administrative_area_level_1 =
                          item;
                        if ($rootScope.readPDF.address["Municipio"]) {
                          for (var k = 0; k < item.cities.length; k++) {
                            if (
                              sinDiacriticos(
                                $rootScope.readPDF.address[
                                  "Municipio"
                                ].toLowerCase()
                              ) ==
                              sinDiacriticos(item.cities[k].city.toLowerCase())
                            ) {
                              vm.juridicalForm.userAddresses[0].administrative_area_level_2 =
                                item.cities[k];
                            }
                          }
                        }
                      }
                    });
                    // console.log('userAddresses',vm.juridicalForm.userAddresses[0]);
                  }
                }
              });
            // console.log('userAddresses',vm.juridicalForm.userAddresses[0]);
          }
          if ($rootScope.readPDF) {
            if ($rootScope.readPDF["address"]) {
              vm.juridicalForm.userAddresses[0].sublocality = $rootScope
                .readPDF["address"]["Colonia"]
                ? $rootScope.readPDF["address"]["Colonia"]
                : "";
              vm.juridicalForm.userAddresses[0].route = $rootScope.readPDF[
                "address"
              ]["Calle"]
                ? $rootScope.readPDF["address"]["Calle"]
                : "";
              vm.juridicalForm.userAddresses[0].street_number = $rootScope
                .readPDF["address"]["Número EXT"]
                ? $rootScope.readPDF["address"]["Número EXT"]
                : "";
              vm.juridicalForm.userAddresses[0].street_number_int = $rootScope
                .readPDF["address"]["Número INT"]
                ? $rootScope.readPDF["address"]["Número INT"]
                : "";
              vm.juridicalForm.userAddresses[0].postal_code = $rootScope
                .readPDF["address"]["CP"]
                ? $rootScope.readPDF["address"]["CP"]
                : "";
            }
          }
        }
      }
      if ($location.path().includes("flotilla")) {
        asignarValoresPDF($rootScope.readPDF);
      }
    }
    vm.asignarValoresPDF = this.asignarValoresPDF;
    function asignarValoresPDF(dataPDF) {
      console.log("dataPDFdataPDF", dataPDF, $rootScope.readPDF);
      if ($rootScope.readPDF.type_person == 1) {
        $scope.type_person_selected = 1;
        // $scope.contratante_tipo = false;
        $scope.activeJustified = 0;
        vm.form.first_name = $rootScope.readPDF.first_name;
        // vm.form.birthday = $rootScope.readPDF.individual.dob;
        vm.form.last_name = $rootScope.readPDF.last_name;
        vm.form.second_last_name = $rootScope.readPDF.second_last_name;
        vm.form.rfc = $rootScope.readPDF.individual.rfc;
        if (vm.form.rfc && vm.form.rfc.length == 13) {
          $scope.isValidRFCN = true;
          console.log("----true");
        } else {
          console.log("----false");
          $scope.isValidRFCN = false;
        }
        console.log("ingreso");
        // si viene del cotizador
        var quote = localStorage.getItem("quote");
        if (quote) {
          quote = JSON.parse(quote);
          console.log("quote", quote);
          var fecha = new Date(quote.fecha_nacimiento);
          var day = String(fecha.getUTCDate()).padStart(2, "0");
          var month = String(fecha.getUTCMonth() + 1).padStart(2, "0"); // Meses inician en 0
          var year = fecha.getUTCFullYear();

          // Formato dd,mm.yyyy
          vm.form.birthday = day + "/" + month + "/" + year;
          vm.form.sex = quote.sexo;
          vm.form.emailMain = quote.correo;
          vm.form.phoneMain = quote.telefono;
        }
        $q.when()
          .then(function () {
            var defer = $q.defer();
            defer.resolve(helpers.getStates());
            return defer.promise;
          })
          .then(function (data) {
            vm.statesArray = data.data;
            // console.log('$rootScope.readPDF.address', $rootScope.readPDF.address);
            if ($rootScope.readPDF.address) {
              if ($rootScope.readPDF.address["Estado"]) {
                vm.statesArray.forEach(function (item) {
                  // console.log('item', item);
                  if (
                    sinDiacriticos(
                      $rootScope.readPDF.address["Estado"].toLowerCase()
                    ) == sinDiacriticos(item.state.toLowerCase())
                  ) {
                    vm.form.userAddresses[0].administrative_area_level_1 = item;
                    if ($rootScope.readPDF.address["Municipio"]) {
                      for (var k = 0; k < item.cities.length; k++) {
                        if (
                          sinDiacriticos(
                            $rootScope.readPDF.address[
                              "Municipio"
                            ].toLowerCase()
                          ) == sinDiacriticos(item.cities[k].city.toLowerCase())
                        ) {
                          vm.form.userAddresses[0].administrative_area_level_2 =
                            item.cities[k];
                        }
                      }
                    }
                  }
                });
                // console.log('userAddresses',vm.form.userAddresses[0]);
              }
            }
          });
        if ($rootScope.readPDF) {
          if ($rootScope.readPDF["address"]) {
            vm.form.userAddresses[0].sublocality = $rootScope.readPDF[
              "address"
            ]["Colonia"]
              ? $rootScope.readPDF["address"]["Colonia"]
              : "";
            vm.form.userAddresses[0].route = $rootScope.readPDF["address"][
              "Calle"
            ]
              ? $rootScope.readPDF["address"]["Calle"]
              : "";
            vm.form.userAddresses[0].street_number = $rootScope.readPDF[
              "address"
            ]["Número EXT"]
              ? $rootScope.readPDF["address"]["Número EXT"]
              : "";
            vm.form.userAddresses[0].street_number_int = $rootScope.readPDF[
              "address"
            ]["Número INT"]
              ? $rootScope.readPDF["address"]["Número INT"]
              : "";
            vm.form.userAddresses[0].postal_code = $rootScope.readPDF[
              "address"
            ]["CP"]
              ? $rootScope.readPDF["address"]["CP"]
              : "";
          }
        }
      } else {
        // $scope.contratante_tipo = false;
        $scope.type_person_selected = 2;
        $scope.activeJustified = 1;
        vm.juridicalForm.rfc = $rootScope.readPDF.corporation.rfc;
        vm.juridicalForm.j_name = $rootScope.readPDF.first_name;
        // vm.juridicalForm.rfc = $rootScope.readPDF.corporation.rfc;
        // vm.juridicalForm.emailMain = $rootScope.readPDF.corporation.email;
        // vm.juridicalForm.phoneMain = $rootScope.readPDF.corporation.phone_number;
        // vm.form.sex = $rootScope.readPDF.individual.sex;
        if ($rootScope.readPDF.address["Estado"]) {
          $q.when()
            .then(function () {
              var defer = $q.defer();
              defer.resolve(helpers.getStates());
              return defer.promise;
            })
            .then(function (data) {
              vm.statesArray = data.data;
              // console.log('$rootScope.readPDF.address', $rootScope.readPDF.address);
              if ($rootScope.readPDF.address) {
                if ($rootScope.readPDF.address["Estado"]) {
                  vm.statesArray.forEach(function (item) {
                    // console.log('item', item);
                    if (
                      sinDiacriticos(
                        $rootScope.readPDF.address["Estado"].toLowerCase()
                      ) == sinDiacriticos(item.state.toLowerCase())
                    ) {
                      vm.juridicalForm.userAddresses[0].administrative_area_level_1 =
                        item;
                      if ($rootScope.readPDF.address["Municipio"]) {
                        for (var k = 0; k < item.cities.length; k++) {
                          if (
                            sinDiacriticos(
                              $rootScope.readPDF.address[
                                "Municipio"
                              ].toLowerCase()
                            ) ==
                            sinDiacriticos(item.cities[k].city.toLowerCase())
                          ) {
                            vm.juridicalForm.userAddresses[0].administrative_area_level_2 =
                              item.cities[k];
                          }
                        }
                      }
                    }
                  });
                  // console.log('userAddresses',vm.juridicalForm.userAddresses[0]);
                }
              }
            });
          // console.log('userAddresses',vm.juridicalForm.userAddresses[0]);
        }
        if ($rootScope.readPDF) {
          if ($rootScope.readPDF["address"]) {
            vm.juridicalForm.userAddresses[0].sublocality = $rootScope.readPDF[
              "address"
            ]["Colonia"]
              ? $rootScope.readPDF["address"]["Colonia"]
              : "";
            vm.juridicalForm.userAddresses[0].route = $rootScope.readPDF[
              "address"
            ]["Calle"]
              ? $rootScope.readPDF["address"]["Calle"]
              : "";
            vm.juridicalForm.userAddresses[0].street_number = $rootScope
              .readPDF["address"]["Número EXT"]
              ? $rootScope.readPDF["address"]["Número EXT"]
              : "";
            vm.juridicalForm.userAddresses[0].street_number_int = $rootScope
              .readPDF["address"]["Número INT"]
              ? $rootScope.readPDF["address"]["Número INT"]
              : "";
            vm.juridicalForm.userAddresses[0].postal_code = $rootScope.readPDF[
              "address"
            ]["CP"]
              ? $rootScope.readPDF["address"]["CP"]
              : "";
          }
        }
      }
    }
    vm.activate = activate;
    function activate() {
      $scope.activeJustified = 0;
      showButtonFisica_1();
      $scope.type(1);

      $(".js-example-basic-multiple").select2();
      dataFactory
        .get("sucursales-to-show-unpag/")
        .then(function success(response) {
          $scope.sucursalList = response.data;
        });
      vm.responsables = [];
      $http.get(url.IP + "get-vendors").then(function success(request) {
        vm.vendors = request.data;
        vm.vendors.forEach(function (vendor) {
          vendor.name = vendor.first_name + " " + vendor.last_name;
        });
      });
      $scope.filesContractor = true;

      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          vm.statesArray = data.data;
        });

      // groupService.getGroups()
      // .then(function(groups) {
      //     vm.groups = groups;
      // });

      $http.get(url.IP + "gruposSubgrupos-resume/").then(function (response) {
        vm.groups = response.data;
      });

      $http.get(url.IP + "usuarios/").then(function (user) {
        vm.responsables = user.data.results;
      });

      $http.get(url.IP + "groupingLevel-resume/").then(function (response) {
        vm.agrupaciones = response.data;
      });

      $http.get(url.IP + "classification/").then(function (response) {
        response.data.results.forEach(function (item) {
          vm.clasifications.push(item);
        });
      });
      $http.post(url.IP + "celula_contractor_info/").then(function (response) {
        vm.celulas = response.data;
      });
      dataFactory.get("usuarios/").then(function (user) {
        $scope.usuarios_saam = user.data.results;
      });
      if ($rootScope.readPDF) {
        readPdf();
      }
    }
    function sinDiacriticos(texto) {
      return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    vm.getAll = getAll;

    function getAll(param) {
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;

      if (param == "naturals" || param == undefined) {
        if (param == undefined) {
          $scope.type_person = "naturals";
        }
        var orgParam = { params: { org: $localStorage.orgId, type_person: 1 } };
        $http
          .get(url.IP + "contractor-resume/", orgParam)
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.persons.naturals = [];
                vm.persons.juridicals = [];
                vm.persons.naturals = request.data.results;
                vm.naturals_config = {
                  count: request.data.count,
                  next: request.data.next,
                  previous: request.data.previous,
                };
                vm.show_pag_naturals = true;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else if (param == "juridicals") {
        var orgParam = { params: { org: $localStorage.orgId, type_person: 2 } };
        // $http.get(url.IP + 'jrudicals-resume/', orgParam)
        $http
          .get(url.IP + "contractor-resume/", orgParam)
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.persons.juridicals = [];
                vm.persons.naturals = [];
                vm.persons.juridicals = request.data.results;
                vm.juridicals_config = {
                  count: request.data.count,
                  next: request.data.next,
                  previous: request.data.previous,
                };
                vm.show_pag_juridicals = true;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    }

    //Función getContratantes
    vm.getContratantesEs = getContratantesEs;
    function getContratantesEs(param) {
      vm.buttonsJuridicals = false;
      vm.buttonsNaturals = false;
      vm.show_binnacle = false;
      vm.show_pagination = false;
      vm.show_pag_naturals = false;
      vm.show_pag_juridicals = false;
      if (param == 1) {
        // $http.get(url.IP + 'fisicas-resume/' )
        $http.get(url.IP + "contractor-resume/").then(function (data) {
          //vm.results = data;
          vm.persons.juridicals = [];
          vm.persons.juridicals.length = 0;
          $scope.results = {
            data: data.data.results,
            config: {
              count: data.data.count,
              next: data.data.next,
              previous: data.data.previous,
            },
          };
          vm.persons.naturals = $scope.results.data;
          $scope.testPagination("vm.persons.naturals", "results.config");
        });
        //return vm.persons.naturals;
        $scope.show_pagination = true;
        vm.persons = [];
      } else if (param == 2) {
        // $http.get(url.IP + 'morales-resume/' )
        $http.get(url.IP + "contractor-resume/").then(function (data) {
          vm.persons.naturals = [];
          vm.persons.length = 0;
          $scope.results = {
            data: data.data.results,
            config: {
              count: data.data.count,
              next: data.data.next,
              previous: data.data.previous,
            },
          };
          vm.persons.juridicals = $scope.results.data;
          $scope.testPagination("vm.persons.juridicals", "results.config");
        });
        $scope.show_pagination = true;

        vm.persons = [];
      }
      if (vm.condicion == true) {
        vm.persons.naturals = [];
        vm.persons.juridicals = [];
      }
    }
    //Fin getContratantes
    function returnToContractors(param) {
      if (param) {
        vm.show_binnacle = false;
      } else {
        vm.show_binnacle = false;
      }
    }

    function checkRFC() {
      $scope.habilitado = false;
      $scope.obligados = [];
      if (vm.form.obligados) {
        vm.form.obligados.forEach(function (elem, index) {
          if (elem.val) {
            if (elem.value) {
              $scope.obligados.push(elem.value.url);
            }
          }
        });
      }
      vm.form.bound_solidarity_many = $scope.obligados ? $scope.obligados : [];
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.form.rfc == undefined) {
        vm.form.rfc = "";
      }
      if (vm.form.rfc) vm.form.rfc = vm.form.rfc.replace("-", "");
      $http
        .post(url.IP + "existrfc", { rfc: vm.form.rfc, selector: 1 })
        .success(function (response) {
          if (response.status == true) {
            SweetAlert.swal(
              {
                title: "El RFC del contratante ya existe",
                text: "¿Deseas continuar?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                closeOnConfirm: true,
              },
              function (isConfirm) {
                if (isConfirm) {
                  $scope.arrayEmail = vm.form.emails;
                  vm.form.emails = [];
                  $scope.arrayPhone = vm.form.phones;
                  vm.form.phones = [];

                  for (var i = 0; i < $scope.arrayEmail.length; i++) {
                    if ($scope.arrayEmail[i].correo) {
                      if ($scope.arrayEmail[i].email_type == 0) {
                        $scope.arrayEmail[i].email_type = 1;
                      }
                      vm.form.emails.push($scope.arrayEmail[i]);
                    }
                  }

                  for (var i = 0; i < $scope.arrayPhone.length; i++) {
                    if ($scope.arrayPhone[i].phone) {
                      if ($scope.arrayPhone[i].phone_type == 0) {
                        $scope.arrayPhone[i].phone_type = 1;
                      }
                      vm.form.phones.push($scope.arrayPhone[i]);
                    }
                  }

                  l.stop();
                  submitFormNatural();
                  $scope.rfc_getDate(vm.form.rfc);
                } else {
                  l.stop();
                  return;
                }
              }
            );
          } else {
            $scope.arrayEmail = vm.form.emails;
            vm.form.emails = [];
            $scope.arrayPhone = vm.form.phones;
            vm.form.phones = [];

            for (var i = 0; i < $scope.arrayEmail.length; i++) {
              if ($scope.arrayEmail[i].correo) {
                if ($scope.arrayEmail[i].email_type == 0) {
                  $scope.arrayEmail[i].email_type = 1;
                }
                vm.form.emails.push($scope.arrayEmail[i]);
              }
            }

            for (var i = 0; i < $scope.arrayPhone.length; i++) {
              if ($scope.arrayPhone[i].phone) {
                if ($scope.arrayPhone[i].phone_type == 0) {
                  $scope.arrayPhone[i].phone_type = 1;
                }
                vm.form.phones.push($scope.arrayPhone[i]);
              }
            }
            l.stop();
            submitFormNatural();
            $scope.rfc_getDate(vm.form.rfc, vm.form);
          }
        });
    }

    $scope.rfc_getDate = function (rfc) {
      if (vm.form.birthday) {
        return;
      }
      vm.rfc_fec = rfc.substr(4, 6);
      vm.rfc_anio = rfc.substr(4, 2);
      vm.rfc_month = rfc.substr(6, 2);
      vm.rfc_day = rfc.substr(8, 2);

      vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
      vm.date = new Date(vm.fecha);

      vm.aniorfc = vm.date.getFullYear();
      vm.hoyA = vm.hoy.getFullYear();
      if (vm.aniorfc > vm.hoyA) {
        vm.resta = vm.aniorfc - 100;
        vm.rfc_anio = vm.resta;
        vm.fecha = vm.rfc_month + "/" + vm.rfc_day + "/" + vm.rfc_anio;
        if (form.birthday == "") {
          vm.form.birthday = vm.fecha;
        } else {
          vm.form.birthday = vm.fecha;
        }
      }
      vm.aniorfc = vm.date.getFullYear();
      if (vm.form.birthday == null) {
        var fecha_rfcn = $filter("date")(new Date(vm.date), "dd/MM/yyyy");
        vm.form.birthday = fecha_rfcn;
      } else {
        vm.form.birthday = vm.form.birthday;
      }
    };
    $scope.extraFields = false;
    $scope.habilitado = true;
    $scope.isValidRFC = false;

    $scope.validateRFC = function (rfc) {
      if (rfc && rfc.length == 12) {
        $scope.isValidRFC = true;
      } else {
        $scope.isValidRFC = false;
      }
    };

    $scope.validateRFCN = function (rfc) {
      if (rfc && rfc.length == 13) {
        $scope.isValidRFCN = true;
      } else {
        $scope.isValidRFCN = false;
      }
    };
    function submitFormNatural(argument) {
      $scope.habilitado = false;
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.form.rfc && vm.form.rfc.length != 13) {
        $scope.isValidRFCN = false;
        toaster.info("Debe agregar un RFC de 13 caracteres");
        $scope.enviado = false;
        l.stop();
        $scope.habilitado = true;
        return;
      }
      if (vm.form.first_name == "") {
        l.stop();
        $scope.habilitado = true;
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMNAME, "error");
        return;
      }
      if (vm.form.last_name == "") {
        l.stop();
        $scope.habilitado = true;
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMLASTNAME, "error");
        return;
      }
      if (vm.form.birthday == "") {
        l.stop();
        $scope.habilitado = true;
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMBIRTHDAY, "error");
        return;
      }
      if (vm.form.rfc == "") {
        // l.stop();
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        if ($location.path() == "/fianzas/") {
        } else {
          l.stop();
          $scope.habilitado = true;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMRFC, "error");
          return;
        }
      } else {
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
      }
      if (!vm.form.sex) {
        l.stop();
        $scope.habilitado = true;
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMSEX, "error");
        return;
      }
      if (!vm.form.group) {
        l.stop();
        $scope.habilitado = true;
        if (!vm.form.birthday) {
          vm.form.birthday = "";
        }
        if (vm.form.emails.length == 0) {
          vm.form.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.form.phones.length == 0) {
          vm.form.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.SELGROUP, "error");
        return;
      }
      if (vm.form.emailMain) {
        if (vm.form.emailMain && !validateEmail(vm.form.emailMain)) {
          l.stop();
          $scope.habilitado = true;
          if (vm.form.emails.length == 0) {
            vm.form.emails = [{ correo: "", email_type: "" }];
          }
          if (vm.form.phones.length == 0) {
            vm.form.phones = [{ phone: "", phone_type: "" }];
          }
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
      $scope.flagEmail = false;
      if (vm.form.emails.length > 0) {
        for (var i = 0; i < vm.form.emails.length; i++) {
          if (
            vm.form.emails[i].correo &&
            !validateEmail(vm.form.emails[i].correo)
          ) {
            l.stop();
            $scope.habilitado = true;
            $scope.flagEmail = false;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
            return;
          }
        }
      }
      if (!helpers.hasAtLeastOneAddress(vm.form.userAddresses)) {
        l.stop();
        toaster.warning(MESSAGES.ERROR.ADDATLEASTONEDIRECCTION);
      } else {
        var flag = false,
          outme = false;
        vm.form.contact_natural.forEach(function (contact) {
          if (contact.name == "") {
            l.stop();
            $scope.habilitado = true;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
            flag = true;
            return;
          } else {
            if (contact.email) {
              if (!validateEmail(contact.email)) {
                l.stop();
                $scope.habilitado = true;
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.INVALIDEMAILCONTACT,
                  "error"
                );
                flag = true;
                return;
              }
            }
            if (contact.phone_number && contact.phone_number != "") {
              if (contact.phone_number.length < 9) {
                l.stop();
                $scope.habilitado = true;
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.ERRORLENGTHPHONECONTACT,
                  "error"
                );
                return;
              }
            }
          }
        });

        if (flag) {
          return;
        }

        var form = angular.copy(vm.form);
        var arr = [];
        var nums = [];

        vm.form.contact_natural.forEach(function (elem, index) {
          arr.push(elem);
        });
        // form.birthday = $filter('date')(vm.form.birthday, 'yyyy-MM-dd');
        form.birth_date = $filter("date")(vm.form.birthday, "yyyy-MM-dd");
        form.contact = arr;
        form.group = form.subsubgrupo
          ? form.subsubgrupo.url
          : form.subgroup
          ? form.subgroup.url
          : form.group
          ? form.group.url
          : "";
        // form.grouping_level = form.subsubasignaciones ? form.subsubasignaciones.url : form.subagrupaciones ? form.subagrupaciones.url : form.grouping_level ? form.grouping_level.url : '';
        form.groupinglevel = form.subsubasignaciones
          ? form.subsubasignaciones.url
          : form.subagrupaciones
          ? form.subagrupaciones.url
          : form.grouping_level
          ? form.grouping_level.url
          : null;
        // form.celula = vm.form.celula ? vm.form.celula : null;
        form.cellule = vm.form.celula ? vm.form.celula : null;
        form.userAddresses = [];

        vm.form.userAddresses.forEach(function (elem, $index) {
          $scope.elems = elem;
          if (
            elem.administrative_area_level_1 == null ||
            !elem.administrative_area_level_1 ||
            elem.administrative_area_level_1 === undefined ||
            elem.administrative_area_level_1 == "undefined" ||
            elem.administrative_area_level_2 == null ||
            !elem.administrative_area_level_2 ||
            elem.administrative_area_level_2 === undefined ||
            elem.administrative_area_level_2 == "undefined"
          ) {
            l.stop();
            $scope.habilitado = true;
            if (!vm.form.birthday) {
              vm.form.birthday = "";
            }
            if (vm.form.emails.length == 0) {
              vm.form.emails = [{ correo: "", email_type: "" }];
            }
            if (vm.form.phones.length == 0) {
              vm.form.phones = [{ phone: "", phone_type: "" }];
            }
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.ADDATLEASTONEDIRECCTION,
              "error"
            );
            outme = true;
            return;
          }
          var auxElem = elem;
          elem.administrative_area_level_1 =
            auxElem.administrative_area_level_1;
          elem.administrative_area_level_2 =
            auxElem.administrative_area_level_2;
          form.userAddresses.push(elem);
        });

        if (outme == true) {
          return;
        }

        form.email = form.emailMain ? form.emailMain : "";
        form.phone_number = form.phoneMain ? form.phoneMain : "";

        if (form.email == "" && vm.form.emails.length > 0) {
          form.email = vm.form.emails[0].correo;
          vm.form.emails.splice(0, 1);
        }

        if (vm.form.phoneMain) {
          if (vm.form.phoneMain.length < 9) {
            l.stop();
            $scope.habilitado = true;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
            return;
          }
        }

        // for(var i = 0; i < vm.form.phones.length; i++){
        //   if(vm.form.phones[i].phone.length < 9){
        //     $scope.flagPhone = true;
        //   }
        // }
        if (vm.form.phones.length > 0) {
          for (var i = 0; i < vm.form.phones.length; i++) {
            if (vm.form.phones[i].phone) {
              if (vm.form.phones[i].phone.length < 9) {
                $scope.flagPhone = true;
              }
            }
          }
          if ($scope.flagPhone == true) {
            l.stop();
            $scope.habilitado = true;
            $scope.flagPhone = false;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
            return;
          }
        }
        if (!$scope.flagPhone) {
          if (form.phone_number == "" && vm.form.phones.length > 0) {
            form.phone_number = vm.form.phones[0].phone;
            vm.form.phones.splice(0, 1);
          }
        } else {
          $scope.flagPhone = false;
          l.stop();
          $scope.habilitado = true;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
          return;
        }
        var since = toDate(vm.form.birthday).getTime();
        var until = toDate(convertDate(new Date())).getTime();
        var diff = until - since;
        var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
        if (antiguedad <= 0) {
          l.stop();
          $scope.habilitado = true;
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATEBIRTHDATE, "error");
          return;
        }

        // var date = new Date(mesDiaAnio(form.birthday));
        var date = form.birthday;
        var newdate = date.split("/").reverse().join("-");
        form.birthday = newdate;
        form.vendor = vm.form.vendedor;
        form.responsable = vm.form.responsable;
        if (form.responsable) {
          if (form.responsable.url) {
            form.responsable = form.responsable.url;
          } else {
            form.responsable = form.responsable;
          }
        }
        if (vm.org_name == "ancora") {
          form.card_official_identification = vm.listDocument[0].value;
          form.CURP = vm.listDocument[1].value;
          form.voucher_efirm = vm.listDocument[2].value;
          form.voucher_of_address = vm.listDocument[3].value;
          form.signed_format_ic = vm.listDocument[4].value;
          if (vm.form.only_sureties) {
            form.carta_nombramiento = vm.listDocument[5].value;
            form.curriculo = vm.listDocument[6].value;
            form.contrato_multiple_afianzadora = vm.listDocument[7].value;
            form.carta_buro = vm.listDocument[8].value;
            form.entrevista_afianzadora = vm.listDocument[9].value;
            form.rfc_document = vm.listDocument[10].value;
            form.recibos_nomina = vm.listDocument[11].value;
            form.declaracion_anual = vm.listDocument[12].value;
            form.estados_financieros_anuales = vm.listDocument[13].value;
            form.estados_financieros_parciales = vm.listDocument[14].value;
            form.alta_hacienda = vm.listDocument[15].value;
            form.escritura_inmueble = vm.listDocument[16].value;
            form.boleta_predial = vm.listDocument[17].value;
            try {
              form.certificado_gravamen = vm.listDocument[18].value;
            } catch (e) {
              console.log(
                "error m2049.certificado_gravamen = ",
                vm.listDocument
              );
            }
          }
          //upload files repect documents
          vm.listDocument.forEach(function (ar) {
            if (ar.arch.formData) {
              var extension = ar.arch.formData[0].arch.name.split(".")[1];
              ar.arch.formData[0].name = ar.name + "." + extension;
              ar.arch.file.name = ar.name + "." + extension;
              $scope.uploaderDocument.queue.push(ar.arch);
              $scope.uploaderDocument.onAfterAddingFile(ar.arch);
            }
          });
        } else {
          form.card_official_identification = vm.listDocument[0].value;
          form.CURP = vm.listDocument[1].value;
          form.voucher_efirm = vm.listDocument[2].value;
          form.voucher_of_address = vm.listDocument[3].value;
          form.signed_format_ic = vm.listDocument[4].value;
          form.constancia_situacion_fiscal = vm.listDocument[6].value;
          try {
            form.fiscal_power = vm.listDocument[5].value;
          } catch (e) {
            console.log("error m.fiscal_power2071 = ", vm.listDocument);
          }
          if (vm.form.only_sureties) {
            form.carta_nombramiento = vm.listDocument[6].value;
            form.curriculo = vm.listDocument[7].value;
            form.contrato_multiple_afianzadora = vm.listDocument[8].value;
            form.carta_buro = vm.listDocument[9].value;
            form.entrevista_afianzadora = vm.listDocument[10].value;
            form.rfc_document = vm.listDocument[11].value;
            form.recibos_nomina = vm.listDocument[12].value;
            form.declaracion_anual = vm.listDocument[13].value;
            form.estados_financieros_anuales = vm.listDocument[14].value;
            form.estados_financieros_parciales = vm.listDocument[15].value;
            form.alta_hacienda = vm.listDocument[16].value;
            form.escritura_inmueble = vm.listDocument[17].value;
            form.boleta_predial = vm.listDocument[18].value;
            try {
              form.certificado_gravamen = vm.listDocument[19].value;
            } catch (e) {
              console.log(
                "error m2090.certificado_gravamen = ",
                vm.listDocument
              );
            }
          }
          //upload files repect documents
          vm.listDocument.forEach(function (ar) {
            if (ar.arch.formData) {
              var extension = ar.arch.formData[0].arch.name.split(".")[1];
              ar.arch.formData[0].name = ar.name + "." + extension;
              ar.arch.file.name = ar.name + "." + extension;
              $scope.uploaderDocument.queue.push(ar.arch);
              $scope.uploaderDocument.onAfterAddingFile(ar.arch);
            }
          });
        }
        //upload documents
        vm.form.birthday = $filter("date")(vm.form.birthday, "yyyy-MM-dd");
        vm.form.birthday = $filter("date")(vm.form.birthday, "yyyy-MM-dd");
        var date = form.birthday;
        var newdate = date.split("/").reverse().join("-");
        // form.birthday = newdate;
        // form.birth_date = datesFactory.toDate(datesFactory.convertDate(newdate));
        form.birth_date = datesFactory.toDate(vm.form.birthday);
        try {
          if (form.birth_date.length <= 8) {
            l.stop();
            $scope.habilitado = true;
            SweetAlert.swal("Error", MESSAGES.ERROR.DATEBIRTHDAY, "error");
            return;
          }
        } catch (e) {}
        if (vm.form.sucursal) {
          form.sucursal = vm.form.sucursal;
        } else {
          form.sucursal = "";
        }
        form.has_bound_solidarity = $scope.has_solidario ? true : false;
        vm.form.bound_solidarity_many = $scope.obligados
          ? $scope.obligados
          : [];
        form.type_person = 1;
        form.phone_mensajeria = vm.form.phone_mensajeria;
        if (!validateEmail(form.email)) {
          $scope.enviado = false;
          l.stop();
          $scope.habilitado = true;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROREMAIL, "error");
          return;
        }
        form.email = form.email.replace(/\s+/g, "");
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.habilitado = false;
        $scope.enviado = true;
        ContratanteService.createContratante(form, 1).then(function (data) {
          $scope.habilitado = false;
          if (data.status) {
            if (data.status == 200 || data.status == 201) {
              console.log("---continua", data);
            } else {
              l.stop();
              $scope.habilitado = true;
              $scope.enviado = false;
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORCREATECONTRACTOR + " \n" + data.data.email,
                "error"
              );
              return;
            }
          }
          $scope.contractorNew = data;
          $state.reload();
          $rootScope["id_contractor"] = data.id;
          if ($scope.uploaderDocument.queue.length != 0) {
            uploadFilesList(data.type_person, data.id);
          }
          if (!data.id) {
            if (data.email) {
              l.stop();
              $scope.habilitado = true;
              SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROREMAILMAX, "error");
            } else {
              l.stop();
              $scope.habilitado = true;
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORCREATECONTRACTOR,
                "error"
              );
            }
          } else {
            var params = {
              model: 2,
              event: "POST",
              associated_id: data.id,
              identifier: "creó el contratante.",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});

            PersistenceFactory.eliminar();
            $scope.sendEmails(data.url, 1);
            $scope.sendPhones(data.url, 1);
            $scope.sendResponsables(data.url, 1);
            // Async add contacts
            form.contact.forEach(function (contact) {
              // contact.natural = data.url;
              contact.contractor = data.url;
              contactService.createContact(contact);
            });
            // Async add addresses
            $scope.acumulate = 0;
            form.userAddresses.forEach(function (address) {
              $scope.acumulate = $scope.acumulate + 1;
              address.url = globalVar.address;
              address.administrative_area_level_1 =
                address.administrative_area_level_1.state;
              address.administrative_area_level_2 =
                address.administrative_area_level_2.city;
              // address.natural = data.url;
              address.contractor = data.url;
              address.tipo = address.tipo ? address.tipo.name : "";
              generalService.postService(address).then(function (address) {
                data["address_contractor"].push(address.data);
              });
            });

            if (flag) {
              return;
            }

            vm.disabledAfterSave = true;
            $scope.userInfo = {
              id: data.id,
              type_person: data.type_person,
            };

            $("#newContractor").val(data.id);

            // Upload files
            // $scope.userInfo.url = $scope.uploader.url = url.IP + checkType($scope.userInfo.type_person) + '/' + $scope.userInfo.id + '/archivos/';
            $scope.userInfo.url = $scope.uploader.url =
              url.IP + "contractors" + "/" + $scope.userInfo.id + "/archivos/";
            vm.persons.push(data);
            $q.when()
              .then(function () {
                var defer = $q.defer();
                // defer.resolve($scope.uploader.uploadAll());
                return defer.promise;
              })
              .then(function () {
                // $scope.uploader.uploadAll();
              });
            $timeout(function () {
              if ($scope.countFile > 0) {
                if ($scope.acumulate == form.userAddresses.length) {
                  uploadFiles(data.type_person, data.id);
                } else {
                  uploadFiles(data.type_person, data.id);
                }
              } else {
                if (!$scope.array_files) {
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.NEWCONTRACTOR,
                    "success"
                  );
                  if ($scope.acumulate == form.userAddresses.length) {
                    console.log(
                      "$location.pat3h()",
                      $location.path(),
                      $location.path().includes("flotilla")
                    );
                    if ($location.path() == "/contratantes/crear") {
                      if (vm.acceso_ver_cont) {
                        $state.reload();
                        $state.go("contratantes.info", {
                          type:
                            $scope.contractorNew.type_person == 1
                              ? "fisicas"
                              : "morales",
                          contratanteId: $scope.contractorNew.id,
                        });
                      } else {
                        $state.reload();
                        $state.go("index.main");
                      }
                    } else if ($location.path() == "/colectividades/") {
                      var params = { myInsurance: data };
                      $state.go("colectividades.main", params);
                    } else if ($location.path() == "/fianzas/") {
                      var params = { myInsurance: data };
                      $state.go("fianzas.fianzas", params);
                      // var params = { 'myInsurance': data }
                      $rootScope.show_contractor = false;
                    } else if ($location.path() == "/fianzas/colectividades") {
                      $rootScope.show_contractor = false;
                      var params = { myInsurance: data };
                      $state.go("fianzas.colectividades", params);
                      $rootScope.show_contractor = false;
                    } else if ($location.path().includes("flotilla")) {
                      var path = $location.path();
                      // Detectar patrón: /flotillas/{id_numérico}
                      var regex = /^\/flotillas\/(\d+)$/;
                      var match = path.match(regex);
                      if (match) {
                        var flotillaId = match[1]; // el número capturado
                        console.log("Detectado flotilla:", flotillaId);
                        // Redirige a donde tú quieras:
                        $rootScope.show_contractor = false;
                        var params = {
                          myInsurance: data,
                          polizaId: flotillaId,
                        };
                        $rootScope.myInsurance = params;
                        if (flotillaId) {
                          $state.go("flotillas.info", {
                            polizaId: flotillaId,
                            dataContractor: data,
                          });
                        } else {
                          $state.go("flotillas.flotillas", {
                            dataContractor: data,
                          });
                        }
                      }
                    } else {
                      // if ($uibModalInstance) {
                      //   $uibModalInstance.dismiss('cancel');
                      //   $("#modalContratate").parent().parent().parent().css("display", "block");
                      // }
                      $rootScope.show_contractor = false;
                      var params = { myInsurance: data };
                      $rootScope.myInsurance = params;
                      $scope.open_in_same_tab(
                        "Crear póliza",
                        "polizas.create",
                        params,
                        0
                      );

                      // $state.go('polizas.create', params);
                    }

                    $rootScope.show_contractor = false;
                  }
                }
              }
            }, 10);
          }
        });
      }
    }
    vm.emails = {
      add: addEmail,
      delete: deleteEmail,
    };
    $scope.open_in_same_tab = function (name, route, params, identifier) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $rootScope.myInsurance = params;
      $state.go($scope.route_for_new_tab, params);
    };
    // vm.responsables = {
    //     add: addResponsable,
    //     delete: deleteResponsable
    // };
    function formatDate(input) {
      var datePart = input.match(/\d+/g),
        year = datePart[0].substring(2), // get only two digits
        month = datePart[1],
        day = datePart[2];

      return day + "/" + month + "/" + year;
    }
    var obligados1 = {
      obligado: vm.form.contratante,
    };
    vm.form.obligados = vm.form.obligados ? vm.form.obligados : [];
    if (vm.form.obligados.length === 0) {
      vm.form.obligados.push(obligados1);
    }
    var obligados2 = {
      obligado: vm.juridicalForm.contratante,
    };
    vm.juridicalForm.obligados = vm.juridicalForm.obligados
      ? vm.juridicalForm.obligados
      : [];
    if (vm.juridicalForm.obligados.length === 0) {
      vm.juridicalForm.obligados.push(obligados2);
    }

    $scope.addObligados = function (type) {
      if (type === 1) {
        var addobligadoss = {
          obligado: obligados1,
        };
        vm.form.obligados.push(addobligadoss);
      } else {
        var addobligadoss = {
          obligado: obligados2,
        };
        vm.juridicalForm.obligados.push(addobligadoss);
      }
    };
    $scope.deleteObligados = function (index, type) {
      if (type === 1) {
        vm.form.obligados.splice(index, 1);
      } else {
        vm.juridicalForm.obligados.splice(index, 1);
      }
    };
    $scope.sendResponsables = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.responsables.length; i++) {
          // vm.form.responsables[i].natural = url;
          if (!vm.form.responsables[i].responsable) {
            vm.form.responsables.splice(i, 1);
          }
          vm.form.responsables[i].contractor = url;
          if (vm.form.responsables[i].responsable) {
            if (vm.form.responsables[i].responsable.id) {
              vm.form.responsables[i].responsable =
                vm.form.responsables[i].responsable.url;
            }
          }
        }
        vm.responsable = vm.form.responsables;
      } else {
        for (var i = 0; i < vm.juridicalForm.responsables.length; i++) {
          // vm.juridicalForm.responsables[i].juridical = url;
          if (!vm.juridicalForm.responsables[i].responsable) {
            vm.juridicalForm.responsables.splice(i, 1);
          }
          vm.juridicalForm.responsables[i].contractor = url;
          if (vm.juridicalForm.responsables[i].responsable) {
            if (vm.juridicalForm.responsables[i].responsable.id) {
              vm.juridicalForm.responsables[i].responsable =
                vm.juridicalForm.responsables[i].responsable.url;
            }
          }
        }
        vm.responsable = vm.juridicalForm.responsables;
      }

      if (vm.responsable) {
        dataFactory
          .post("responsables/", vm.responsable)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };

    $scope.addResponsable = function (type) {
      if (type === 1) {
        var addresponsables = {
          responsables: vm.form.responsable,
          resp_type: 0,
        };
        vm.form.responsables.push(addresponsables);
      } else {
        var addresponsables = {
          responsables: vm.juridicalForm.responsable
            ? vm.juridicalForm.responsable
            : null,
          resp_type: 0,
        };
        vm.juridicalForm.responsables.push(addresponsables);
      }
    };
    $scope.deleteResponsable = function (index, type) {
      if (type === 1) {
        vm.form.responsables.splice(index, 1);
      } else {
        vm.juridicalForm.responsables.splice(index, 1);
      }
    };
    $scope.sendResponsables = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.responsables.length; i++) {
          // vm.form.responsables[i].natural = url;
          if (!vm.form.responsables[i].responsable) {
            vm.form.responsables.splice(i, 1);
          }
          try {
            vm.form.responsables[i].contractor = url;
            if (vm.form.responsables[i].responsable) {
              if (vm.form.responsables[i].responsable.id) {
                vm.form.responsables[i].responsable =
                  vm.form.responsables[i].responsable.url;
              }
            }
          } catch (e) {}
        }
        vm.responsable = vm.form.responsables;
      } else {
        if (
          vm.juridicalForm.responsables &&
          vm.juridicalForm.responsables.length != 0
        ) {
          for (var i = 0; i < vm.juridicalForm.responsables.length; i++) {
            // vm.juridicalForm.responsables[i].juridical = url;
            if (!vm.juridicalForm.responsables[i].responsable) {
              vm.juridicalForm.responsables.splice(i, 1);
            }
            try {
              vm.juridicalForm.responsables[i].contractor = url;
              if (vm.juridicalForm.responsables[i].responsable) {
                if (vm.juridicalForm.responsables[i].responsable.id) {
                  vm.juridicalForm.responsables[i].responsable =
                    vm.juridicalForm.responsables[i].responsable.url;
                }
              }
            } catch (e) {}
          }
          vm.responsable = vm.juridicalForm.responsables;
        }
      }
      if (vm.responsable) {
        dataFactory
          .post("responsables/", vm.responsable)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                vm.permiso_administrar_adjuntos = true;
              } else {
                vm.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          vm.accesoRef = perm;
          vm.accesoRef.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                vm.verReferenciadores = true;
              } else {
                vm.verReferenciadores = false;
              }
            }
          });
        }
      });
    }
    function addEmail(type) {
      if (type === 1) {
        var addEmails = {
          correo: vm.form.correo,
        };
        vm.form.emails.push(addEmails);
      } else {
        var addEmails = {
          correo: vm.juridicalForm.correo,
        };
        vm.juridicalForm.emails.push(addEmails);
      }
    }
    function deleteEmail(index, type) {
      if (type === 1) {
        vm.form.emails.splice(index, 1);
      } else {
        vm.juridicalForm.emails.splice(index, 1);
      }
    }
    $scope.sendEmails = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.emails.length; i++) {
          // vm.form.emails[i].natural = url;
          vm.form.emails[i].contractor = url;
        }
        vm.correo = vm.form.emails;
      } else {
        for (var i = 0; i < vm.juridicalForm.emails.length; i++) {
          // vm.juridicalForm.emails[i].juridical = url;
          vm.juridicalForm.emails[i].contractor = url;
        }
        vm.correo = vm.juridicalForm.emails;
      }

      if (vm.correo) {
        dataFactory
          .post("emails/", vm.correo)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };

    vm.phones = {
      add: addPhone,
      delete: deletePhone,
    };
    function addPhone(type) {
      if (type === 1) {
        var addPhones = {
          phone: vm.form.phone,
        };
        vm.form.phones.push(addPhones);
      } else {
        var addPhones = {
          phone: vm.juridicalForm.phone,
        };
        vm.juridicalForm.phones.push(addPhones);
      }
    }
    function deletePhone(index, type) {
      if (type === 1) {
        vm.form.phones.splice(index, 1);
      } else {
        vm.juridicalForm.phones.splice(index, 1);
      }
    }
    $scope.sendPhones = function (url, typePerson) {
      if (typePerson == 1) {
        for (var i = 0; i < vm.form.phones.length; i++) {
          // vm.form.phones[i].natural = url;
          vm.form.phones[i].contractor = url;
        }
        vm.telefono = vm.form.phones;
      } else {
        for (var i = 0; i < vm.juridicalForm.phones.length; i++) {
          // vm.juridicalForm.phones[i].juridical = url;
          vm.juridicalForm.phones[i].contractor = url;
        }
        vm.telefono = vm.juridicalForm.phones;
      }
      if (vm.telefono) {
        dataFactory
          .post("phones/", vm.telefono)
          .then(
            function success(request) {},
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      }
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
    function submitJuridical() {
      $scope.enviado = true;
      var lm = Ladda.create(document.querySelector(".ladda-button"));
      lm.start();
      $scope.obligados = [];
      if (vm.juridicalForm.obligados) {
        vm.juridicalForm.obligados.forEach(function (elem, index) {
          if (elem.val) {
            if (elem.value) {
              $scope.obligados.push(elem.value.url);
            }
          }
        });
      }
      vm.juridicalForm.bound_solidarity_many = $scope.obligados
        ? $scope.obligados
        : [];
      if (vm.juridicalForm.rfc == undefined) {
        vm.juridicalForm.rfc = "";
      }
      if (vm.juridicalForm.rfc && vm.juridicalForm.rfc.length != 12) {
        $scope.isValidRFC = false;
        toaster.info("Debe agregar un RFC de 12 caracteres");
        $scope.enviado = false;
        lm.stop();
        $scope.habilitado = true;
        return;
      }
      $http
        .post(url.IP + "existrfc", { rfc: vm.juridicalForm.rfc, selector: 2 })
        .success(function (response) {
          if (response.status == true) {
            SweetAlert.swal(
              {
                title: "El RFC del contratante ya existe",
                text: "¿Deseas continuar?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                closeOnConfirm: true,
              },
              function (isConfirm) {
                if (isConfirm) {
                  submitFormJuridical();
                  $scope.enviado = true;
                  $scope.rfc_getDateJ(vm.juridicalForm.rfc);
                } else {
                  $scope.enviado = false;
                  lm.stop();
                  return;
                }
              }
            );
          } else {
            $scope.arrayEmail = vm.juridicalForm.emails;
            vm.juridicalForm.emails = [];
            $scope.arrayPhone = vm.juridicalForm.phones;
            vm.juridicalForm.phones = [];

            for (var i = 0; i < $scope.arrayEmail.length; i++) {
              if ($scope.arrayEmail[i].correo) {
                if ($scope.arrayEmail[i].email_type == 0) {
                  $scope.arrayEmail[i].email_type = 1;
                }
                vm.juridicalForm.emails.push($scope.arrayEmail[i]);
              }
            }

            for (var i = 0; i < $scope.arrayPhone.length; i++) {
              if ($scope.arrayPhone[i].phone) {
                if ($scope.arrayPhone[i].phone_type == 0) {
                  $scope.arrayPhone[i].phone_type = 1;
                }
                vm.juridicalForm.phones.push($scope.arrayPhone[i]);
              }
            }
            submitFormJuridical();
            $scope.rfc_getDateJ2(vm.juridicalForm.rfc, vm.juridicalForm);
          }
        });
    }
    Date.prototype.isValid = function () {
      // An invalid date object returns NaN for getTime() and NaN is the only
      // object not strictly equal to itself.
      return this.getTime() === this.getTime();
    };
    $scope.rfc_getDateJ2 = function (curp, form) {
      $scope.enviado = true;
      if (vm.juridicalForm.date_of_establishment) {
        $scope.enviado = true;
        return;
      }
      var m = curp.match(/^\w{3}(\w{2})(\w{2})(\w{2})/);
      //miFecha = new Date(año,mes,dia)
      try {
        var anyo = parseInt(m[1], 10) + 1900;
        if (anyo < 1950) anyo += 100;
        var mes = parseInt(m[2], 10) - 1;
        var dia = parseInt(m[3], 10);
        var date = new Date(anyo, mes, dia);
        if (date.isValid()) {
          vm.juridicalForm.date_of_establishment =
            datesFactory.convertDate(date);
          $scope.enviado = faltruese;
        }
        $scope.enviado = true;
      } catch (err) {
        $scope.enviado = true;
      }
    };
    $scope.rfc_getDateJ = function (curp, form) {
      $scope.enviado = true;
      if (vm.juridicalForm.date_of_establishment) {
        $scope.enviado = false;
        return;
      }
      if (curp) {
        var m = curp.match(/^\w{3}(\w{2})(\w{2})(\w{2})/);
      }
      //miFecha = new Date(año,mes,dia)
      try {
        var anyo = parseInt(m[1], 10) + 1900;
        if (anyo < 1950) anyo += 100;
        var mes = parseInt(m[2], 10) - 1;
        var dia = parseInt(m[3], 10);
        var date = new Date(anyo, mes, dia);
        if (date.isValid()) {
          vm.juridicalForm.date_of_establishment =
            datesFactory.convertDate(date);
          $scope.enviado = false;
        }
        $scope.enviado = false;
      } catch (err) {
        $scope.enviado = false;
      }
    };

    $scope.isValidDate = function (d) {
      return d instanceof Date && !isNaN(d);
    };
    function submitFormJuridical() {
      $scope.habilitado = false;
      var lm = Ladda.create(document.querySelector(".ladda-button"));
      lm.start();
      $scope.enviado = true;
      if (vm.juridicalForm.j_name == "") {
        $scope.enviado = false;
        lm.stop();
        $scope.habilitado = true;
        if (!vm.juridicalForm.date_of_establishment) {
          vm.juridicalForm.date_of_establishment = "";
        }
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMJNAME, "error");
        return;
      }
      if (vm.juridicalForm.date_of_establishment == "") {
        $scope.enviado = false;
        lm.stop();
        $scope.habilitado = true;
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMESTABLISHMENT, "error");
        return;
      }
      if (vm.juridicalForm.rfc == "") {
        $scope.enviado = false;
        lm.stop();
        $scope.habilitado = true;
        if (!vm.juridicalForm.date_of_establishment) {
          vm.juridicalForm.date_of_establishment = "";
        }
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.DATAFORMRFC, "error");
        return;
      }
      if (!vm.juridicalForm.group) {
        $scope.enviado = false;
        lm.stop();
        $scope.habilitado = true;
        if (!vm.juridicalForm.date_of_establishment) {
          vm.juridicalForm.date_of_establishment = "";
        }
        if (vm.juridicalForm.emails.length == 0) {
          vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
        }
        if (vm.juridicalForm.phones.length == 0) {
          vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
        }
        SweetAlert.swal("ERROR", MESSAGES.ERROR.SELGROUP, "error");
        return;
      }
      if (vm.juridicalForm.emailMain) {
        if (!validateEmail(vm.juridicalForm.emailMain)) {
          $scope.enviado = false;
          lm.stop();
          $scope.habilitado = true;
          if (vm.juridicalForm.emails.length == 0) {
            vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
          }
          if (vm.juridicalForm.phones.length == 0) {
            vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
          }
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }
      $scope.flagEmail = false;
      if (vm.juridicalForm.emails.length > 0) {
        for (var i = 0; i < vm.juridicalForm.emails.length; i++) {
          if (
            vm.juridicalForm.emails[i].correo &&
            !validateEmail(vm.juridicalForm.emails[i].correo)
          ) {
            $scope.flagEmail = true;
          }
        }
        if ($scope.flagEmail == true) {
          $scope.enviado = false;
          lm.stop();
          $scope.habilitado = true;
          $scope.flagEmail = false;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        }
      }

      if (!helpers.hasAtLeastOneAddress(vm.juridicalForm.userAddresses)) {
        $scope.enviado = false;
        lm.stop();
        $scope.habilitado = true;
        toaster.info(MESSAGES.ERROR.ADDATLEASTONEDIRECCTION);
      } else {
        var flag = false,
          outme = false;
        $scope.enviado = true;
        vm.juridicalForm.contact_juridical.forEach(function (contact) {
          if (contact.name == "") {
            $scope.enviado = false;
            lm.stop();
            $scope.habilitado = true;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
            flag = true;
            return;
          } else {
            if (contact.email) {
              if (!validateEmail(contact.email)) {
                $scope.enviado = false;
                lm.stop();
                $scope.habilitado = true;
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.INVALIDEMAILCONTACT,
                  "error"
                );
                flag = true;
                return;
              }
            }
            if (contact.phone_number && contact.phone_number != "") {
              if (contact.phone_number.length < 9) {
                $scope.enviado = false;
                lm.stop();
                $scope.habilitado = true;
                SweetAlert.swal(
                  "ERROR",
                  MESSAGES.ERROR.ERRORLENGTHPHONECONTACT,
                  "error"
                );
                return;
              }
            }
          }
        });

        var since = toDate(vm.juridicalForm.date_of_establishment).getTime();
        var until = toDate(convertDate(new Date())).getTime();
        var diff = until - since;
        var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
        if (antiguedad < 0) {
          $rootScope.enviado = false;
          $scope.enviado = false;
          lm.stop();
          $scope.habilitado = true;
          flag = false;
          SweetAlert.swal(
            "Error",
            MESSAGES.ERROR.ERRORDATEFORMESTABLISHMENT,
            "error"
          );
          $rootScope.enviado = false;
          $scope.enviado = false;
          return;
        }

        if (flag) {
          $scope.enviado = false;
          return;
        }

        var form = angular.copy(vm.juridicalForm);
        var juridicalForm = angular.copy(vm.juridicalForm);
        var arr = [];
        var nums = [];
        vm.juridicalForm.contact_juridical.forEach(function (elem, index) {
          arr.push(elem);
        });
        form.constitutive_act = vm.listDocument[0].value;
        form.rfc_document = vm.listDocument[1].value;
        form.card_official_identification = vm.listDocument[2].value;
        form.voucher_of_address = vm.listDocument[3].value;
        form.modifications_constitutive_act = vm.listDocument[4].value;
        form.ine_representante = vm.listDocument[6].value;
        try {
          form.fiscal_power = vm.listDocument[5].value;
        } catch (i) {}
        if (vm.juridicalForm.only_sureties) {
          form.curriculo = vm.listDocument[6].value;
          form.contrato_multiple_afianzadora = vm.listDocument[7].value;
          form.carta_buro = vm.listDocument[8].value;
          form.entrevista_afianzadora = vm.listDocument[9].value;
          form.aviso_privacidad = vm.listDocument[10].value;
          form.protocolizaciones = vm.listDocument[11].value;
          form.alta_hacienda = vm.listDocument[12].value;
          form.cambio_domicilio_hacienda = vm.listDocument[13].value;
          form.voucher_efirm = vm.listDocument[14].value;
          form.declaracion_anual = vm.listDocument[15].value;
          form.estados_financieros_anuales = vm.listDocument[16].value;
          form.estados_financieros_parciales = vm.listDocument[17].value;
          form.escritura_inmueble = vm.listDocument[18].value;
          form.boleta_predial = vm.listDocument[19].value;
          try {
            form.certificado_gravamen = vm.listDocument[20].value;
          } catch (e) {
            try {
              form.certificado_gravamen = vm.listDocument[19].value;
            } catch (otro) {
              console.log("otrp 2896", vm.listDocument);
            }
            console.log("error m.certificado_gravamen = ", vm.listDocument);
          }
        }
        //upload files repect documents
        vm.listDocument.forEach(function (ar) {
          if (ar.arch.formData) {
            var extension = ar.arch.formData[0].arch.name.split(".")[1];
            ar.arch.formData[0].name = ar.name + "." + extension;
            ar.arch.file.name = ar.name + "." + extension;
            $scope.uploaderDocument.queue.push(ar.arch);
            $scope.uploaderDocument.onAfterAddingFile(ar.arch);
          }
        });
        //upload documents
        form.date_of_establishment = $filter("date")(
          vm.juridicalForm.date_of_establishment,
          "yyyy-MM-dd"
        ); //jshint ignore:line
        form.contact = arr;
        form.group = form.group ? form.group.url : "";
        juridicalForm.userAddresses = [];
        form.userAddresses.forEach(function (elem) {
          if (
            elem.administrative_area_level_1 == null ||
            !elem.administrative_area_level_1 ||
            elem.administrative_area_level_1 === undefined ||
            elem.administrative_area_level_1 == "undefined" ||
            elem.administrative_area_level_2 == null ||
            !elem.administrative_area_level_2 ||
            elem.administrative_area_level_2 === undefined ||
            elem.administrative_area_level_2 == "undefined"
          ) {
            $scope.enviado = false;
            lm.stop();
            $scope.habilitado = true;
            if (!vm.juridicalForm.date_of_establishment) {
              vm.juridicalForm.date_of_establishment = "";
            }
            if (vm.juridicalForm.emails.length == 0) {
              vm.juridicalForm.emails = [{ correo: "", email_type: "" }];
            }
            if (vm.juridicalForm.phones.length == 0) {
              vm.juridicalForm.phones = [{ phone: "", phone_type: "" }];
            }
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.DATAADDRESSREQUIRED,
              "error"
            );
            $scope.enviado = false;
            outme = true;
            return;
          }
          var auxElem = elem;
          elem.administrative_area_level_1 =
            auxElem.administrative_area_level_1;
          elem.administrative_area_level_2 =
            auxElem.administrative_area_level_2;
          juridicalForm.userAddresses.push(elem);
        });

        if (outme == true) {
          return;
        }

        // if(form.group == '' || juridicalForm.group == ''){
        //   lm.stop();
        //   SweetAlert.swal("ERROR",MESSAGES.ERROR.SELGROUP ,"error");
        //   flag = true;
        //   return;
        // }

        var date = form.date_of_establishment;
        var newdate = date.split("/").reverse().join("-");
        form.date_of_establishment = newdate;

        form.email = juridicalForm.emailMain ? juridicalForm.emailMain : "";
        form.phone_number = juridicalForm.phoneMain
          ? juridicalForm.phoneMain
          : "";
        form.vendor = vm.juridicalForm.vendedor;
        form.responsable = vm.juridicalForm.responsable;
        if (form.responsable) {
          if (form.responsable.url) {
            form.responsable = form.responsable.url;
          } else {
            form.responsable = form.responsable;
          }
        }

        if (juridicalForm.email == "" && vm.juridicalForm.emails.length > 0) {
          juridicalForm.email = vm.juridicalForm.emails[0].correo;
          vm.juridicalForm.emails.splice(0, 1);
        }

        if (vm.juridicalForm.phoneMain && vm.juridicalForm.phoneMain != "") {
          if (vm.juridicalForm.phoneMain.length < 9) {
            $scope.enviado = false;
            lm.stop();
            $scope.habilitado = true;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
            return;
          }
        }

        for (var i = 0; i < vm.juridicalForm.phones.length; i++) {
          if (vm.juridicalForm.phones[i].phone.length < 9) {
            $scope.flagPhone = true;
          }
        }
        if (!$scope.flagPhone) {
          if (
            juridicalForm.phone_number == "" &&
            vm.juridicalForm.phones.length > 0
          ) {
            juridicalForm.phone_number = vm.juridicalForm.phones[0].phone;
            vm.juridicalForm.phones.splice(0, 1);
          }
        }
        // else{
        //   $scope.flagPhone = false;
        //   $scope.enviado = false;
        //   lm.stop();
        //   $scope.habilitado = true;
        //   console.log('scscscsca',vm.juridicalForm.phoneMain)
        //   SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
        //   return;
        // }
        try {
          if (form.date_of_establishment.length <= 8) {
            $scope.enviado = false;
            lm.stop();
            $scope.habilitado = true;
            SweetAlert.swal("Error", MESSAGES.ERROR.DATEESTABLISHMENT, "error");
            return;
          }
        } catch (e) {}
        if (vm.juridicalForm.sucursal) {
          form.sucursal = vm.juridicalForm.sucursal;
        } else {
          form.sucursal = "";
        }
        // form.birth_date = datesFactory.toDate(form.date_of_establishment ? convertDate(new Date(form.date_of_establishment)) : convertDate(new Date(m.juridicalForm.date_of_establishment)));
        form.birth_date = datesFactory.toDate(
          vm.juridicalForm.date_of_establishment
        );
        form.type_person = 2;
        form.group = vm.juridicalForm.subsubgrupo
          ? vm.juridicalForm.subsubgrupo.url
          : vm.juridicalForm.subgroup
          ? vm.juridicalForm.subgroup.url
          : vm.juridicalForm.group
          ? vm.juridicalForm.group.url
          : "";
        // form.grouping_level = form.subsubasignaciones ? form.subsubasignaciones.url : form.subagrupaciones ? form.subagrupaciones.url : form.grouping_level ? form.grouping_level.url : '';
        form.groupinglevel = form.subsubasignaciones
          ? form.subsubasignaciones.url
          : form.subagrupaciones
          ? form.subagrupaciones.url
          : form.grouping_level
          ? form.grouping_level.url
          : null;
        // form.celula = vm.juridicalForm.celula ? vm.juridicalForm.celula : null;
        form.cellule = vm.juridicalForm.celula ? vm.juridicalForm.celula : null;
        form.full_name = vm.juridicalForm.j_name;
        vm.form.bound_solidarity_many = $scope.obligados
          ? $scope.obligados
          : [];
        form.has_bound_solidarity = $scope.has_solidario ? true : false;
        form.phone_mensajeria = vm.juridicalForm.phone_mensajeria;
        if (!validateEmail(form.email)) {
          $scope.enviado = false;
          lm.stop();
          $scope.habilitado = true;
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROREMAIL, "error");
          return;
        }
        form.email = form.email.replace(/\s+/g, "");
        ContratanteService.createContratante(form, 2).then(function (data) {
          $scope.habilitado = false;
          if (data.status) {
            if (data.status == 200 || data.status == 201) {
              console.log("---continua", data);
            } else {
              lm.stop();
              $scope.habilitado = true;
              $scope.enviado = false;
              console.log("---data", data);
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORCREATECONTRACTOR + " \n" + data.data.email,
                "error"
              );
              return;
            }
          }
          $scope.contractorNew = data;
          $rootScope["id_contractor"] = data.id;
          $state.reload();
          if ($scope.uploaderDocument.queue.length != 0) {
            $scope.enviado = true;
            uploadFilesList(data.type_person, data.id);
          }
          if (data.type_person == "Moral") data["address_contractor"] = [];
          else data["address_natural"] = [];

          if (!data.id) {
            if (data.email) {
              $scope.enviado = false;
              lm.stop();
              SweetAlert.swal("ERROR", MESSAGES.ERROR.ERROREMAILMAX, "error");
            } else {
              lm.stop();
              $scope.enviado = false;
              SweetAlert.swal(
                "ERROR",
                MESSAGES.ERROR.ERRORCREATECONTRACTOR,
                "error"
              );
            }
          } else {
            $scope.sendEmails(data.url, 2);
            $scope.sendPhones(data.url, 2);
            $scope.sendResponsables(data.url, 2);
            form.contact.forEach(function (contact) {
              // contact.juridical = data.url;
              contact.contractor = data.url;
              $scope.enviado = true;
              contactService.createContact(contact);
            });
            // var address = {};
            $scope.acumulate = 0;
            juridicalForm.userAddresses.forEach(function (address) {
              $scope.acumulate = $scope.acumulate + 1;
              address.url = globalVar.address;
              // address.juridical = data.url;
              address.contractor = data.url;
              address.administrative_area_level_1 =
                address.administrative_area_level_1.state;
              address.administrative_area_level_2 =
                address.administrative_area_level_2.city;
              address.tipo = address.tipo ? address.tipo.name : "";
              $scope.enviado = true;
              generalService.postService(address).then(function (address) {
                if (data.type_person == "Moral") {
                  data["address_contractor"].push(address.data);
                } else {
                  data["address_contractor"].push(address.data);
                }
              });
            });
            if (flag) {
              $scope.enviado = false;
              return;
            }
            // toaster.success(MESSAGES.OK.NEWCONTRACTOR);

            vm.disabledAfterSave = true;

            $scope.userInfo = {
              id: data.id,
              type_person: data.type_person,
            };

            $("#newContractor").val(data.id);

            // Upload files
            // $scope.userInfo.url = $scope.uploader.url = url.IP + checkType($scope.userInfo.type_person) + '/' + $scope.userInfo.id + '/archivos/';
            $scope.userInfo.url = $scope.uploader.url =
              url.IP + "contractors/" + $scope.userInfo.id + "/archivos/";
            vm.persons.push(data);
            $q.when()
              .then(function () {
                var defer = $q.defer();
                defer.resolve($scope.uploader.uploadAll());
                return defer.promise;
              })
              .then(function () {
                $scope.uploader.uploadAll();
              });

            $timeout(function () {
              if ($scope.countFile > 0) {
                if ($scope.acumulate == juridicalForm.userAddresses.length) {
                  $scope.enviado = true;
                  $scope.habilitado = false;
                  uploadFiles(data.type_person, data.id);
                } else {
                  $scope.enviado = true;
                  $scope.habilitado = false;
                  uploadFiles(data.type_person, data.id);
                }
              } else {
                if (!$scope.array_files) {
                  if (vm.acceso_ver_cont) {
                    if (
                      $scope.acumulate == juridicalForm.userAddresses.length
                    ) {
                      console.log("$locat4ion.path()", $location.path());
                      SweetAlert.swal(
                        "¡Listo!",
                        MESSAGES.OK.NEWCONTRACTOR,
                        "success"
                      );
                      if ($location.path() == "/contratantes/crear") {
                        $state.reload();
                        $state.go("contratantes.info", {
                          type:
                            $scope.contractorNew.type_person == 1
                              ? "fisicas"
                              : "morales",
                          contratanteId: $scope.contractorNew.id,
                        });
                      } else if ($location.path() == "/colectividades/") {
                        var params = { myInsurance: data };
                        $state.go("colectividades.main", params);
                      } else if ($location.path() == "/fianzas/") {
                        var params = { myInsurance: data };
                        $state.go("fianzas.fianzas", params);
                        // var params = { 'myInsurance': data }
                        $rootScope.show_contractor = false;
                      } else if (
                        $location.path() == "/fianzas/colectividades"
                      ) {
                        $rootScope.show_contractor = false;
                        var params = { myInsurance: data };
                        $state.go("fianzas.colectividades", params);
                        $rootScope.show_contractor = false;
                      } else if ($location.path().includes("flotilla")) {
                        var path = $location.path();
                        // Detectar patrón: /flotillas/{id_numérico}
                        var regex = /^\/flotillas\/(\d+)$/;
                        var match = path.match(regex);
                        if (match) {
                          var flotillaId = match[1]; // el número capturado
                          console.log("Detectado flotilla:", flotillaId);
                          // Redirige a donde tú quieras:
                          $rootScope.show_contractor = false;
                          var params = {
                            myInsurance: data,
                            polizaId: flotillaId,
                          };
                          $rootScope.myInsurance = params;
                          if (flotillaId) {
                            $state.go("flotillas.info", {
                              polizaId: flotillaId,
                              dataContractor: data,
                            });
                          } else {
                            $state.go("flotillas.flotillas", {
                              dataContractor: data,
                            });
                          }
                        }
                      } else {
                        $rootScope.show_contractor = false;
                        var params = { myInsurance: data };
                        $rootScope.myInsurance = params;
                        $scope.open_in_same_tab(
                          "Crear póliza",
                          "polizas.create",
                          params,
                          0
                        );
                        // $state.go('polizas.create', params);
                      }
                      $rootScope.show_contractor = false;
                    }
                  } else {
                    $state.go("index.main", params);
                  }
                }
              }
            }, 10);
          }
        });
      }
    }

    function insert(form) {}

    function checkType(type) {
      //jshint ignore:line
      // return (type === 'Fisica') ? 'fisicas' : 'morales';
      return type === "Física" ? "fisicas" : "morales";
    }

    function addContact(type) {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
      };
      if (type === 1) {
        vm.form.contact_natural.push(contact);
      } else {
        vm.juridicalForm.contact_juridical.push(contact);
      }
    }

    function deleteContacts(contact, type) {
      if (type === 1) {
        vm.form.contact_natural.splice(contact, 1);
      } else {
        vm.juridicalForm.contact_juridical.splice(contact, 1);
      }
    }

    function openModalGroup(level, type, parent) {
      $("#modalContratate").parent().parent().parent().css("display", "none");
      $(".modal-backdrop").click(function () {
        $("#modalContratate")
          .parent()
          .parent()
          .parent()
          .css("display", "block");
      });
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/grupos/grupos.form.html",
        controller: ModalInstanceCtrl,
        resolve: {
          padre: function () {
            return parent;
          },
          parent: function () {
            return vm;
          },
          type: function () {
            return type;
          },
          level: function () {
            return level;
          },
          group: function () {
            return level == 2 ? vm.form.group : {};
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }
    vm.subgroups = [];
    vm.sub_subgroups = [];

    function ModalInstanceCtrl(
      $scope,
      $uibModalInstance,
      parent,
      level,
      group,
      type,
      padre
    ) {
      $scope.level = level;
      $scope.groupForm = {};
      $scope.subgroupForm = {};
      $scope.subsubgroupForm = {};
      $scope.subgroups = [];
      $scope.sub_subgroups = [];

      $scope.addSubgroups = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        $scope.subgroups.push(obj);
      };

      $scope.deleteSubgroup = function (index) {
        $scope.subgroups.splice(index, 1);
      };

      $scope.addSubsubgroups = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        $scope.sub_subgroups.push(obj);
      };

      $scope.deleteSubsubgroup = function (index) {
        $scope.sub_subgroups.splice(index, 1);
      };

      $http.get(url.IP + "usuarios/").then(function (user) {
        $scope.users = user.data.results;

        $scope.show_pagination = true;
      });

      $scope.changeResponsable = function (data, type) {
        // $scope.responsables_natural = [];
        // $scope.responsables_juridical = [];
        if (type == 1) {
          $scope.responsables_natural.push(data);
        } else {
          $scope.responsables_juridical.push(data);
        }
      };

      $scope.ok = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (!$scope.groupForm.responsable) {
          l.stop();
          SweetAlert.swal("ERROR", "Selecciona un responsable.", "error");
          return;
        }

        var flag = false;
        var form = angular.copy($scope.groupForm);
        var name = form.group_name;
        var bd_group_name = [];
        groupService.getGroups().then(function (res) {
          res.forEach(function (group, i) {
            bd_group_name.push(String(group.group_name));
          });

          for (var i = 0; i < bd_group_name.length; i++) {
            if (name == bd_group_name[i]) {
              flag = true;
            }
          }

          form.type_group = 1;

          if (flag == false) {
            return groupService
              .createGroup(form)
              .then(function (data) {
                if (data.status === 201) {
                  vm.groups.push(data.data);
                  $rootScope.changeGroup(data.data);
                  if (vm.form.email) {
                    vm.form.group = data.data;
                  } else if (vm.juridicalForm.email) {
                    vm.juridicalForm.group = data.data;
                  }

                  if ($uibModalInstance) {
                    $uibModalInstance.close();
                    $("#modalContratate")
                      .parent()
                      .parent()
                      .parent()
                      .css("display", "block");
                  }

                  if ($scope.subgroups.length > 0) {
                    $scope.subgroups.forEach(function (item) {
                      var datas = {
                        group_name: item.group_name,
                        responsable: data.data.responsable,
                        parent: data.data.url,
                        type_group: 2,
                      };

                      $http({
                        method: "POST",
                        url: url.IP + "grupos/",
                        data: datas,
                      })
                        .then(function (request) {
                          if (
                            request.status === 200 ||
                            request.status === 201
                          ) {
                            // vm.subgroups.push(request.data);
                            if (type === 1) {
                              vm.form.group.subgrupos.push(request.data);
                            } else {
                              vm.juridicalForm.group.subgrupos.push(
                                request.data
                              );
                            }
                          }
                        })
                        .catch(function (e) {
                          l.stop();
                          console.log("e", e);
                        });
                    });
                  }
                } else if (data.status === 403) {
                  toaster.warning("Usted no tiene permisos para crear grupos");
                  // return;
                  l.stop();
                  $uibModalInstance.close();
                  $("#modalContratate")
                    .parent()
                    .parent()
                    .parent()
                    .css("display", "block");
                }
              })
              .catch(function () {
                l.stop();
                return;
              });
          } else {
            l.stop();
            SweetAlert.swal(
              "ERROR",
              MESSAGES.ERROR.THISNAMEALREADYEXIST,
              "error"
            );
            return;
          }
        });
      };

      $scope.oksub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.subgroupForm.responsable = group.responsable;
        $scope.subgroupForm.parent = padre.url;
        $scope.subgroupForm.type_group = 2;

        if (!$scope.subgroupForm.group_name) {
          l.stop();
          SweetAlert.swal("Error", "Agrega un nombre de subgrupo.", "error");
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "grupos/",
          data: $scope.subgroupForm,
        })
          .then(function (request) {
            if (request.status === 200 || request.status === 201) {
              try {
                vm.subgroups.push(request.data);
              } catch (e) {
                vm.subgroups = [];
                vm.subgroups.push(request.data);
              }

              if ($scope.sub_subgroups.length > 0) {
                vm.subgroups[vm.subgroups.length - 1].subsubgrupos = [];
                $scope.sub_subgroups.forEach(function (item) {
                  var datas = {
                    group_name: item.group_name,
                    responsable: group.responsable,
                    parent: request.data.url,
                    type_group: 3,
                  };

                  $http({
                    method: "POST",
                    url: url.IP + "grupos/",
                    data: datas,
                  })
                    .then(function (response) {
                      if (response.status === 200 || response.status === 201) {
                        vm.subgroups[vm.subgroups.length - 1].subsubgrupos.push(
                          response.data
                        );
                      }
                    })
                    .catch(function (e) {
                      l.stop();
                      console.log("e", e);
                    });
                });
              }
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.oksubsub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.subsubgroupForm.responsable = group.responsable;
        $scope.subsubgroupForm.parent = padre.url;
        $scope.subsubgroupForm.type_group = 3;

        if (!$scope.subsubgroupForm.group_name) {
          l.stop();
          SweetAlert.swal("Error", "Agrega un nombre de subsubgrupo.", "error");
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "grupos/",
          data: $scope.subsubgroupForm,
        })
          .then(function (request_sub) {
            if (request_sub.status === 200 || request_sub.status === 201) {
              if (vm.sub_subgroups == undefined) {
                vm.sub_subgroups = [];
              }
              vm.sub_subgroups.push(request_sub.data);
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
          $("#modalContratate")
            .parent()
            .parent()
            .parent()
            .css("display", "block");
        }
      };
    }

    function openModalAsignacion(level, parent) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/contratantes/contratantes.agrupacion.html",
        controller: ModalGroupCtrl,
        resolve: {
          padre: function () {
            return parent;
          },
          parent: function () {
            return vm;
          },
          level: function () {
            return level;
          },
          group: function () {
            return level == 2
              ? vm.form.grouping_level
              : vm.form.subagrupaciones;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }

    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    function ModalGroupCtrl(
      $scope,
      $uibModalInstance,
      parent,
      level,
      group,
      padre
    ) {
      $scope.level = level;
      $scope.group_modal = group;
      $scope.grupo = {};
      // $scope.subasignaciones = [];
      $scope.subsubasignacion = [];

      $scope.addSubasignaciones = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        vm.subasignaciones.push(obj);
      };

      $scope.deleteSubasignaciones = function (index) {
        vm.subasignaciones.splice(index, 1);
      };

      $scope.addSubsubasignaciones = function () {
        var obj = { name: "", observations: "", sub_subgroup: [] };
        $scope.subsubasignacion.push(obj);
      };

      $scope.deleteSubsubasignaciones = function (index) {
        $scope.subsubasignacion.splice(index, 1);
      };

      $http.get(url.IP + "usuarios/").then(function (user) {
        $scope.users = user.data.results;

        $scope.show_pagination = true;
      });

      $scope.saveSub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.grupo.level_grouping = padre.level_grouping;
        $scope.grupo.parent = padre.url;
        $scope.grupo.type_grouping = 2;

        if (!$scope.grupo.description) {
          l.stop();
          SweetAlert.swal(
            "Error",
            "Agrega un nombre de subagrupación.",
            "error"
          );
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "groupinglevel/",
          data: $scope.grupo,
        })
          .then(function (request_sub) {
            if (request_sub.status === 200 || request_sub.status === 201) {
              $rootScope.changeAgrupacion2(padre);
              $scope.sub_subasignaciones = padre.subsubgrupos;
              if ($scope.subsubasignacion.length > 0) {
                $scope.subsubasignacion.forEach(function (item, index) {
                  var datas = {
                    description: item.description,
                    responsable: $scope.grupo.responsable,
                    parent: request_sub.data.url,
                    type_grouping: 3,
                    level_grouping: group.level_grouping,
                  };

                  $http({
                    method: "POST",
                    url: url.IP + "groupinglevel/",
                    data: datas,
                  })
                    .then(function (response) {
                      if (response.status === 200 || response.status === 201) {
                        $rootScope.changeAgrupacion2(padre);
                        $scope.sub_subasignaciones.push(response.data);
                        $scope.agrupaciones.subgrupos.forEach(function (
                          sub,
                          index
                        ) {
                          if (sub.id == request_sub.data.id) {
                            vm.agrupaciones.subgrupos[index].subsubgrupos.push(
                              response.data
                            );
                          }
                        });
                      }
                    })
                    .catch(function (e) {
                      l.stop();
                      console.log("e", e);
                    });

                  if ($scope.subsubasignacion.length == index + 1) {
                    vm.agrupaciones.forEach(function (gpo) {
                      if (
                        gpo.description == vm.form.grouping_level.description
                      ) {
                        vm.form.grouping_level = gpo;
                      }
                    });
                  }
                });
              }
              try {
                $scope.sub_asignaciones.push(request_sub.data);
              } catch (e) {
                $scope.sub_asignaciones = request_sub.data;
              }
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.saveSubsub = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.grupo.level_grouping = padre.level_grouping;
        $scope.grupo.parent = padre.url;
        $scope.grupo.type_grouping = 3;

        if (!$scope.grupo.description) {
          l.stop();
          SweetAlert.swal(
            "Error",
            "Agrega un nombre de subsubagrupación.",
            "error"
          );
          return;
        }

        $http({
          method: "POST",
          url: url.IP + "groupinglevel/",
          data: $scope.grupo,
        })
          .then(function (request_sub) {
            if (request_sub.status === 200 || request_sub.status === 201) {
              // $scope.sub_subasignaciones.push(request_sub.data);
              $scope.sub_subasignaciones = padre.subsubgrupos;
              try {
                $scope.sub_subasignaciones.push(request_sub.data);
              } catch (e) {
                $scope.sub_subasignaciones = request_sub.data;
              }
              $rootScope.changeAgrupacion2(padre);
              $scope.cancel();
            }
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    function openModalClasification(level) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/contratantes/contratantes.clasificacion.html",
        controller: ModaClasificationCtrl,
        resolve: {
          parent: function () {
            return vm;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }
    function openModalCelulaContractor(level) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/contratantes/contratantes.celulas.html",
        controller: ModalCelulasCtrl,
        resolve: {
          parent: function () {
            return vm;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
        // windowClass: 'animated fadeIn'
      });
    }
    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    function ModaClasificationCtrl($scope, $uibModalInstance, parent) {
      $scope.classification = {};

      $scope.save = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        ($scope.classification.classification_name =
          $scope.classification.classification_name),
          ($scope.classification.description =
            $scope.classification.description),
          $http({
            method: "POST",
            url: url.IP + "classification/",
            data: $scope.classification,
          })
            .then(function (response) {
              if (response.status === 200 || response.status === 201) {
                l.stop();
                vm.clasifications.push(response.data);
                $scope.cancel();
              }
            })
            .catch(function (e) {
              l.stop();
              console.log("e", e);
            });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    function ModalCelulasCtrl($scope, $uibModalInstance, parent) {
      $scope.celula = {};
      dataFactory.get("usuarios/").then(function (user) {
        $scope.usuarios_saam = user.data.results;
      });
      $scope.save_celula = function () {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();

        $scope.celula.celula_name = $scope.celula.celula_name;
        $scope.celula.description = $scope.celula.description;
        $scope.celula.users_many = $scope.usuarios_selected
          ? $scope.usuarios_selected
          : [];
        $http({
          method: "POST",
          url: url.IP + "celula_contractor/",
          data: $scope.celula,
        })
          .then(function (response) {
            if (response.status === 200 || response.status === 201) {
              vm.celulas.push(response.data);
              $scope.cancel_celula();
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };

      $scope.cancel_celula = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.selectUsuarios = function (sel) {
        $scope.usuarios_selected = [];
        sel.forEach(function (u) {
          if (u.url) {
            $scope.usuarios_selected.push(u.url);
          } else {
            $scope.usuarios_selected.push(u);
          }
        });
      };
    }
    // vm.changeGroup = changeGroup;
    $rootScope.changeGroup = function (data) {
      if (data) {
        if (data.id) {
          dataFactory
            .post("subgrupos-match/", { parent: data.id })
            .then(function (subgrupos_) {
              vm.subgroups = subgrupos_.data;
            });
        } else {
          if (data) {
            if (data.subgrupos) {
              vm.subgroups = data.subgrupos;
            } else {
              vm.subgroups = [];
            }
          } else {
            vm.subgroups = [];
          }
        }
      } else {
        vm.subgroups = [];
      }
      // vm.subgroups = data.subgrupos;
      vm.juridicalForm.group = data;
      vm.form.group = data;
      if (data.responsable) {
        $http
          .get(data.responsable)
          .then(
            function success(request) {
              if (request.status === 200) {
                vm.form.responsable = request.data;
                vm.juridicalForm.responsable = request.data;
              }
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else {
        vm.form.responsable = "";
        vm.juridicalForm.responsable = "";
      }
    };

    $rootScope.changeSubGroup = function (data) {
      // vm.sub_subgroups = data.subsubgrupos;
      // $rootScope.changeGroup(vm.juridicalForm.group ? vm.juridicalForm.group : vm.form.group)
      if (data) {
        if (data.subsubgrupos) {
          vm.sub_subgroups = data.subsubgrupos;
        } else {
          vm.sub_subgroups = [];
        }
      } else {
        vm.sub_subgroups = [];
      }
    };

    $rootScope.changeAgrupacion2 = function (data) {
      if (data) {
        if (data.id && data.type_grouping == 1) {
          dataFactory
            .post("subagrupaciones-match/", { parent: data.id })
            .then(function (subgrupos_) {
              $scope.sub_asignaciones = subgrupos_.data;
              // $scope.sub_subasignaciones = [];
            });
        } else {
          if (data) {
            if (data.subgrupos) {
              $scope.sub_asignaciones = data.subgrupos;
            } else if (data.subsubgrupos) {
              $scope.sub_subasignaciones = data.subsubgrupos;
            }
          } else {
            $scope.sub_asignaciones = [];
          }
        }
      } else {
        $scope.sub_asignaciones = [];
      }
      // $scope.sub_asignaciones = data.subgrupos;
    };

    $rootScope.changeSubagrupacion2 = function (data) {
      // if(data.subsubgrupos){
      //   vm.sub_subasignaciones = data.subsubgrupos;
      // }
      if (data) {
        if (data.subsubgrupos) {
          $scope.sub_subasignaciones = data.subsubgrupos;
        } else {
          $scope.sub_subasignaciones = [];
        }
      } else {
        $scope.sub_subasignaciones = [];
      }
    };

    $rootScope.changeSubsubagrupacion2 = function (data) {};

    $rootScope.changeVendedor = function (data) {
      vm.juridicalForm.vendedor = data;
      vm.form.vendedor = data;
    };

    $scope.changeResponsable_single = function (data) {
      vm.form.responsable = data;
    };
    $scope.exportData = function (type_person) {
      // var header = '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      // var blob = new Blob([header + document.getElementById('exportable').innerHTML], {
      //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
      // });
      // saveAs(blob, "Reporte_" + aseguradoras + ".xls");
      // fisicas y morales

      var data = { cadena: $scope.param_cadena };
      if (type_person == 1) {
        // naturales
        $http
          .get(url.IP + "reporte-fisicas/")
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "ContratantesFisicos");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      } else if (type_person == 2) {
        $http
          .get(url.IP + "reporte-morales/")
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "ContratantesMorales");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
      if (type_person == 3) {
        // naturales seeker
        $http({
          method: "GET",
          url: url.IP + "reporte-seekerNaturals/",
          params: data,
        })
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "Contratantes_Naturales");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
      if (type_person == 4) {
        // juridicals seeker

        $http({
          method: "GET",
          url: url.IP + "reporte-seekerJuridicals/",
          params: data,
        })
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "Contratantes_Morales");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    $scope.filterValue = function ($event) {
      if (isNaN(String.fromCharCode($event.charCode))) {
        $event.preventDefault();
      }
    };

    $rootScope.show_contractor = true;
    $scope.returnToPolicy = function () {
      $rootScope.show_contractor = false;
    };

    $scope.showButtonFisica = function () {
      $scope.fisicas = true;
      $scope.morales = false;
      $("#saveButtonMoralModal").css("display", "none");
      $("#saveButtonFisicaModal").css("display", "block");
    };

    $scope.showButtonMoral = function () {
      $scope.fisicas = false;
      $scope.morales = true;
      $("#saveButtonFisicaModal").css("display", "none");
      $("#saveButtonMoralModal").css("display", "block");
    };

    $scope.cancelChanges = function () {
      $rootScope.show_contractor = false;
      // if($("#modalContratate")){
      //   if( $uibModalInstance.dismiss('cancel')){
      //     $timeout(function () {
      //       $("#createOTS").click();
      //         }, 1);
      //   }
      // }
    };

    $scope.selectDate = function (parDate) {
      $scope.enviado = false;
      try {
        if (parDate && parDate.length <= 8) {
          if (vm.form) vm.form.birthday = "";
          if (vm.juridicalForm) vm.juridicalForm.date_of_establishment = "";
          SweetAlert.swal("Error", MESSAGES.ERROR.DATEESTABLISHMENT, "error");
          return;
        }
      } catch (e) {}
    };
    $scope.changePhosne = function (parDate) {
      $scope.enviado = false;
    };

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");

      return date;
    }

    function mesDiaAnio(parDate) {
      var d = new Date(toDate(parDate));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      return date;
    }

    // TEST pagination contrantes
    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      // $scope.selectPage = function (parPage) {
      //   vm.Consultar($scope.order, parPage);
      // };

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        vm.Consultar($scope.order, parPage);
      };
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getContratantesPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    //Pagination----

    // configuración del datepicker
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
    //-- Peticion de persistencia--//

    var json_data = {};
    var form = document.getElementsByTagName("form");
    var elementos = {};
    //Valores reutilizables
    var interval, interval1, dt, valor;
    var count = 0;

    // function set_dataForm(json){
    //   PersistenceFactory.set_inputs(json);
    //   if(json['vm.form.first_name']!= ""){
    //     vm.form.first_name = json['vm.form.first_name'];
    //   }
    //   if(json['vm.form.last_name']!= ""){
    //     vm.form.last_name = json['vm.form.last_name'];
    //   }
    //   if(json['vm.form.second_last_name']!= ""){
    //     vm.form.second_last_name = json['vm.form.second_last_name'];
    //   }
    //   if(json['vm.form.rfc']!= ""){
    //     vm.form.rfc = json['vm.form.rfc'];
    //   }
    //   if(json['vm.form.birthday']!= ""){
    //     vm.form.birthday = json['vm.form.birthday'];
    //   }
    //   if(json['vm.form.sex']!= ""){
    //     vm.form.sex = json['vm.form.sex'];
    //   }
    //   if(json['vm.form.emailMain'] != ''){
    //     vm.form.emailMain = json['vm.form.emailMain']
    //   }
    //   if(json['inputValue'][0] != ''){
    //     vm.form.phoneMain = json['inputValue'][0].valor
    //   }
    //   if(json['vm.form.group'] != ""){
    //     valor = PersistenceFactory.find_index(vm.groups, json['vm.form.group'][0].valor, 'url');
    //     vm.form.group = vm.groups[valor]
    //   }
    //   //vm.address_type
    //   if(json['address.tipo']){
    //     if(json['address.tipo'][0].valor != ''){
    //       valor = PersistenceFactory.find_index(vm.address_type, json['address.tipo'][0].valor, 'name');
    //       vm.form.userAddresses[0].tipo = vm.address_type[valor]
    //     }
    //     if(json['address.tipo'][1].valor != ''){
    //       valor = PersistenceFactory.find_index(vm.address_type, json['address.tipo'][1].valor, 'name');
    //       vm.juridicalForm.userAddresses[0].tipo = vm.address_type[valor]
    //     }
    //   }
    //   if(json['address.administrative_area_level_1']){

    //     if(json['address.administrative_area_level_1'][0].valor != ''){
    //       valor = PersistenceFactory.find_index(vm.statesArray, json['address.administrative_area_level_1'][0].valor, 'url');
    //       vm.form.userAddresses[0].administrative_area_level_1 = vm.statesArray[valor]

    //       if(json['address.administrative_area_level_2'][0].valor != ''){
    //         valor = PersistenceFactory.find_index(vm.form.userAddresses[0].administrative_area_level_1.cities, json['address.administrative_area_level_2'][0].valor, 'url');
    //         vm.form.userAddresses[0].administrative_area_level_2 = vm.form.userAddresses[0].administrative_area_level_1.cities[valor]
    //       }
    //     }
    //     //Falta segundo vm.juridicalForm
    //     if(json['address.administrative_area_level_1'][1].valor != ''){
    //       valor = PersistenceFactory.find_index(vm.statesArray, json['address.administrative_area_level_1'][1].valor, 'url');
    //       vm.juridicalForm.userAddresses[0].administrative_area_level_1 = vm.statesArray[valor]

    //       if(json['address.administrative_area_level_2'][1].valor != ''){
    //       console.log(vm.juridicalForm.userAddresses)
    //         valor = PersistenceFactory.find_index(vm.juridicalForm.userAddresses[0].administrative_area_level_1.cities, json['address.administrative_area_level_2'][1].valor, 'url');
    //         vm.juridicalForm.userAddresses[0].administrative_area_level_2 = vm.juridicalForm.userAddresses[0].administrative_area_level_1.cities[valor]
    //       }/**/
    //     }

    //   }

    //   if(json['address.route']){

    //     if(json['address.route'][0].valor != 'text'){
    //       vm.form.userAddresses[0].route = json['address.route'][0].valor
    //     }
    //     if(json['address.route'][1].valor != 'text'){
    //       vm.juridicalForm.userAddresses[0].route = json['address.route'][1].valor
    //     }

    //   }
    //   if(json['address.street_number']){

    //     if(json['address.street_number'][0].valor != 'text'){
    //       vm.form.userAddresses[0].street_number = json['address.street_number'][0].valor
    //     }
    //     if(json['address.street_number'][1].valor != 'text'){
    //       vm.juridicalForm.userAddresses[0].street_number = json['address.street_number'][1].valor
    //     }
    //   }
    //   if(json['address.street_number_int']){

    //     if(json['address.street_number_int'][0].valor != 'text'){
    //       vm.form.userAddresses[0].street_number_int = json['address.street_number_int'][0].valor
    //     }
    //     if(json['address.street_number_int'][1].valor != 'text'){
    //       vm.juridicalForm.userAddresses[0].street_number_int = json['address.street_number_int'][1].valor
    //     }

    //   }
    //   if(json['address.sublocality']){

    //     if(json['address.sublocality'][0].valor != 'text'){
    //       vm.form.userAddresses[0].sublocality = json['address.sublocality'][0].valor
    //     }
    //     if(json['address.sublocality'][1].valor != 'text'){
    //       vm.juridicalForm.userAddresses[0].sublocality = json['address.sublocality'][1].valor
    //     }

    //   }
    //   if(json['address.postal_code']){

    //     if(json['address.postal_code'][0].valor != 'text'){
    //       vm.form.userAddresses[0].postal_code = json['address.postal_code'][0].valor
    //     }
    //     if(json['address.postal_code'][1].valor != 'text'){
    //       vm.juridicalForm.userAddresses[0].postal_code = json['address.postal_code'][1].valor
    //     }

    //   }
    //   if(json['address.details']){

    //     if(json['address.details'][0].valor != 'text'){
    //       vm.form.userAddresses[0].details = json['address.details'][0].valor
    //     }
    //     if(json['address.details'][1].valor != 'text'){
    //       vm.juridicalForm.userAddresses[0].details = json['address.details'][1].valor
    //     }

    //   }
    //   if(json['vm.form.responsable'][0].valor!= ""){
    //     valor = PersistenceFactory.find_index(vm.statesArray, json['vm.form.responsable'][0].valor, 'url');
    //     vm.form.responsable = vm.responsables[valor];
    //   }
    //   if(json['vm.form.responsable'][1].valor!= ""){
    //     valor = PersistenceFactory.find_index(vm.statesArray, json['vm.form.responsable'][1].valor, 'url');
    //     vm.juridicalForm.responsable = vm.responsables[valor];
    //   }
    //   if(json['listaD.value']){

    //   }
    //   //Morales
    //   if(json['vm.juridicalForm.j_name'] != '' && json['vm.juridicalForm.j_name'] != 'text'){
    //     vm.juridicalForm.j_name = json['vm.juridicalForm.j_name']
    //   }
    //   if(json['vm.juridicalForm.date_of_establishment']!= "" && json['vm.juridicalForm.date_of_establishment']!= "text"){
    //     vm.juridicalForm.date_of_establishment = json['vm.juridicalForm.date_of_establishment'];
    //   }
    //   if(json['vm.juridicalForm.rfc']!= "" && json['vm.juridicalForm.date_of_establishment']!= "text"){
    //     vm.juridicalForm.rfc = json['vm.juridicalForm.rfc']
    //   }
    //   if(json['vm.juridicalForm.emailMain']!= "" && json['vm.juridicalForm.emailMain']!= "text" ){
    //     vm.juridicalForm.emailMain = json['vm.juridicalForm.emailMain']
    //   }
    //   if(json['vm.juridicalForm.description']!= "" && json['vm.juridicalForm.description']!= "text"){
    //     vm.juridicalForm.description = json['vm.juridicalForm.description']
    //   }
    //   if(json['inputValue'][4] != '' != "" && json['inputValue'][4]!= "text"){
    //     vm.juridicalForm.phoneMain = json['inputValue'][4].valor
    //   }

    //   valor = angular.element('[ng-model="inputValue"]');
    //   angular.forEach(valor,function(v,a){
    //       if(a == 3 || a == 7){
    //         v.value = '';
    //       }
    //   })
    //   valor = angular.element('[ng-model="item.correo"]');
    //   angular.forEach(valor,function(v,a){
    //     v.value = '';
    //   })
    //   valor = angular.element('[ng-model="listaD.value"]');
    //   angular.forEach(valor,function(v,a){
    //      valor[a].checked = false;
    //      valor[a].setAttribute('aria-checked', 'false');
    //   })
    // }

    // interval = setInterval(function(){
    //   if(form != undefined && PersistenceFactory.count == 0){//&& PersistenceFactory.count == 0
    //     PersistenceFactory.inicial(vm.user.org,'Contratantes',vm.user.nameFull,PersistenceFactory.get_dataForm(form));
    //   }
    //   if(PersistenceFactory.init_return != ''){
    //     clearInterval(interval);
    //     if(PersistenceFactory.init_return.status == 'data_view' ){
    //       set_dataForm(PersistenceFactory.json_return);
    //     }
    //     PersistenceFactory.interval = setInterval(function(){
    //       PersistenceFactory.editado(PersistenceFactory.get_dataForm(form));
    //     }, PersistenceFactory.intervalTime);/* /* */
    //   }
    // }, 2000);
    //-- End Peticion de persistencia--//

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.length >= 3) {
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
              poliza: false,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("vm.contratante.value", function (newValue, oldValue) {
      if (vm.contratante) {
        if (vm.contratante.value.address_contractor) {
          if (vm.contratante.value.address_contractor) {
            $scope.bound_solidarity = vm.contratante.value.url;
            $scope.has_solidario = true;
          }
        }
      }
    });
  }
})();

function closeContr() {
  $("#closeModalContr").click();
  $("#createOTS").click();
}

function saveContrFisica() {
  $("#saveButtonFisica").click();
}

function saveContrMoral() {
  $("#saveButtonMoral").click();
}

// function showButtonFisica() {
//     // $scope.fisicas = true;
//     // $scope.morales = false;
//     $("#saveButtonMoralModal").css("display", "none");
//     $("#saveButtonFisicaModal").css("display", "block");
// }
//
// function showButtonMoral() {
//     // $scope.fisicas = false;
//     // $scope.morales = true;
//
//     $("#saveButtonFisicaModal").css("display", "none");
//     $("#saveButtonMoralModal").css("display", "block");
// }

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("celulacontractorController", celulacontractorController);

  celulacontractorController.$inject = [
    "$scope",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "$q",
    "helpers",
    "globalVar",
    "generalService",
    "$uibModal",
    "$sessionStorage",
  ];

  function celulacontractorController(
    $scope,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    $q,
    helpers,
    globalVar,
    generalService,
    $uibModal,
    $sessionStorage
  ) {
    $scope.vm = this;
    $scope.showCelula = false;
    $scope.showEditCelula = false;
    $scope.showInfo = false;
    $scope.celulacontractor = {};
    var savedCelulaDraft = {
      celula_name: "",
      description: "",
    };

    $scope.createCelula = function () {
      $scope.showCelula = true;
    };

    $(".js-example-basic-multiple").select2();

    activate();

    function activate() {
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      dataFactory
        .post("celula_contractor_info/")
        .then(function success(response) {
          $scope.celulaList = response.data;
        });
      dataFactory.get("usuarios/").then(function (user) {
        $scope.usuarios_saam = user.data.results;
      });
      $scope.celulacontractor.celula_name = savedCelulaDraft.celula_name || "";
      $scope.celulacontractor.description = savedCelulaDraft.description || "";
    }

    $scope.rememberCelulaDraft = function () {
      savedCelulaDraft.celula_name = $scope.celulacontractor.celula_name || "";
      savedCelulaDraft.description = $scope.celulacontractor.description || "";
    };
    $scope.cambiarModulo = function () {
      var modalInstance = $uibModal.open({
        templateUrl: "app/modals/module_name.html",
        controller: ChangeModuleNameModalCtrl,
        size: "md",
        resolve: {},
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (result) {
        dataFactory
          .patch(result.url, { moduleName: result.moduleName })
          .then(function success(response) {
            $scope.configuracionGlobal = response.data;
            if ($scope.configuracionGlobal.moduleName) {
              $scope.moduleName = $scope.configuracionGlobal.moduleName;
            }
          });
      });
    };

    function ChangeModuleNameModalCtrl($scope, $uibModalInstance, dataFactory) {
      $scope.cancel = cancel;
      $scope.saveConfig = saveConfig;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      $(".js-example-basic-multiple").select2();

      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }

      function saveConfig(moduleName) {
        $scope.configuracionGlobal.moduleName = moduleName;
        $uibModalInstance.close($scope.configuracionGlobal);
      }
    }
    $scope.save = function (form) {
      $scope.dataToSave = {};
      $scope.dataToSave.celula_name = form.celula_name;
      $scope.dataToSave.description = form.description;
      $scope.dataToSave.users_many = $scope.usuarios_selected
        ? $scope.usuarios_selected
        : [];

      dataFactory
        .post("celula_contractor/", $scope.dataToSave)
        .then(function success(response) {
          if (response.status == 200 || response.status == 201) {
            SweetAlert.swal(
              "¡Listo!",
              $scope.moduleName + " creada exitosamente.",
              "success"
            );
            savedCelulaDraft.celula_name = "";
            savedCelulaDraft.description = "";
            $scope.close();
            activate();
          } else {
            $scope.close();
            activate();
          }
          savedCelulaDraft.celula_name = "";
          savedCelulaDraft.description = "";
        });
    };
    $scope.selectUsuarios = function (sel) {
      $scope.usuarios_selected = [];
      sel.forEach(function (u) {
        if (u.url) {
          $scope.usuarios_selected.push(u.url);
        } else {
          $scope.usuarios_selected.push(u);
        }
      });
    };
    $scope.close = function () {
      $scope.showCelula = false;
    };

    $scope.edit = function (param) {
      $(".js-example-basic-multiple").select2();
      $scope.showCelula = false;
      $scope.showEditCelula = true;
      $scope.showInfo = false;
      $scope.celulacontractor = [];
      $scope.editCelula = param;
      var selected_user = [];
      $.each($scope.editCelula.users_many, function (i, e) {
        selected_user.push(e.id);
      });
      $scope.selected_user = selected_user;
      if ($scope.selected_user) {
        var selected_user = [];
        dataFactory.get("usuarios/").then(function (data) {
          $scope.usuarios_saam = data.data.results;
          $.each(data.data.results, function (i, e) {
            if ($scope.selected_user.includes(e.id)) {
              selected_user.push(e);
            }
          });
          $scope.select_user = selected_user;
        });
      }
    };

    $scope.cancelEdit = function (param) {
      $scope.showCelula = false;
      $scope.showEditCelula = false;
      $scope.showInfo = false;
      $scope.celulacontractor = [];
      $scope.editCelula = [];
      activate();
    };
    $scope.cancelInfo = function (param) {
      $scope.showCelula = false;
      $scope.showEditCelula = false;
      $scope.showInfo = false;
      $scope.celulacontractor = [];
      $scope.editCelula = [];
      activate();
    };

    $scope.update = function (param) {
      $http
        .patch(param.url, {
          celula_name: param.celula_name,
          description: param.description,
          users_many: $scope.usuarios_selected,
        })
        .then(function (data) {
          if (data.status == 200) {
            SweetAlert.swal(
              "¡Listo!",
              "Célula de Contratante actualizada correctamente.",
              "success"
            );
            $scope.cancelEdit();
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.delete = function (url) {
      SweetAlert.swal(
        {
          title: "Eliminar Célula de Contratante",
          text: "Se eliminara la información, ¿Está seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(url).then(function success(response) {
              if (response.status == 204) {
                SweetAlert.swal(
                  "¡Listo!",
                  "Se ha eliminado la célula exitosamente.",
                  "success"
                );
                activate();
              }
            });
          }
        }
      );
    };
    // Info
    $scope.verInfo = function (param) {
      $scope.showCelula = false;
      $scope.showEditCelula = false;
      $scope.showInfo = true;
      $scope.contractors = [];
      param.naturales.forEach(function (u) {
        $scope.contractors.push(u);
      });
      param.morales.forEach(function (u) {
        $scope.contractors.push(u);
      });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").factory("contactService", contactService);

  contactService.$inject = ["url", "$http"];

  function contactService(url, $http) {
    var service = {
      createContact: createContact,
      getContacts: getContacts,
      getContact: getContact,
      updateContact: updateContact,
      deleteContact: deleteContact,
    };

    return service;

    ////////////

    // CREATE
    function createContact(data) {
      return $http
        .post(url.IP + "contactos/", data)
        .then(createContactComplete)
        .catch(createContactFailed);

      function createContactComplete(response) {
        return response.data;
      }

      function createContactFailed(error) {
        return error;
      }
    }

    // READ
    function getContacts() {}
    function getContact() {}

    function updateContact(editedObj) {
      return $http
        .put(editedObj.url, editedObj)
        .then(updateContactComplete)
        .catch(updateContactFailed);

      function updateContactComplete(response) {
        return response;
      }

      function updateContactFailed(error) {
        return error;
      }
    }
    function deleteContact(url) {
      return $http
        .delete(url)
        .then(deleteContactComplete)
        .catch(deleteContactFailed);

      function deleteContactComplete(response, status, headers, config) {
        //jshint ignore:line
        return response;
      }

      function deleteContactFailed(response, status, headers, config) {
        //jshint ignore:line
        return response;
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "ConfiguracionFiltrosController",
      ConfiguracionFiltrosController
    );

  ConfiguracionFiltrosController.$inject = [
    "$state",
    "$scope",
    "dataFactory",
    "datesFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "exportFactory",
    "$sessionStorage",
  ];

  function ConfiguracionFiltrosController(
    $state,
    $scope,
    dataFactory,
    datesFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    exportFactory,
    $sessionStorage
  ) {
    var vm = this;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    vm.lecturas = [];
    $scope.moduleName = "Célula";
    $scope.filtrosACL = false;
    $scope.filtrosCPR = false;
    $scope.listaCobranza = [
      "No.Póliza/Fianza",
      "Tipo Recibo",
      "No.Endoso",
      "Endoso Descripción",
      "Estatus Póliza/Endoso",
      "Grupo",
      "Contratante",
      "Correo electrónico",
      "Teléfono",
      "Alías Aseguradora/Afianzadora",
      "Ramo",
      "Subramo",
      "Identificador",
      "Riesgo/Asegurado",
      "Forma de Pago",
      "Moneda",
      "Serie No.Recibo",
      "Fecha Inicio recibo",
      "Fecha Fin recibo",
      "Vencimiento",
      "Antigüedad",
      "Promesa Pago",
      "Prima Neta",
      "RPF",
      "Derecho",
      "IVA",
      "Prima Total",
      "Comisión",
      "Estatus recibo",
      "Conducto de Pago",
      "Metodo de Pago",
      "Documento de Pago",
      "Fecha Pago",
      "Fecha Liquidación",
      "Folio de Liquidación",
      "Folio de Pago",
      "Fecha de conciliación",
      "Comisión conciliada",
      "Fecha Inicio Póliza/Fianza",
      "Fecha Fin Póliza/Fianza",
      "Clave de Agente",
      "Referenciador",
      "Sucursal",
      "Responsable",
      "Creado por",
      "Fecha Creación",
      "Importe Pesos",
      "Ej. Cobranza",
      "Pagado por",
      "Bitacora",
      "Subgrupo",
      "Subsubgrupo",
      "Agrupación",
      "Subagrupación",
      "Subsubagrupación",
      "Clasificación",
      "Línea de Negocio",
      "Número de Carátula",
      "Carátula Contratante",
      "Célula",
      "Año(Automovil)",
      "Serie(Automovil)",
      "Contacto(nombre)",
      "Contacto(telefono)",
      "Contacto(email)",
      "Tipo Póliza",
      "Tipo de Cambio",
      "Póliza del Recibo con Endoso(s) en Trámite",

      "FechaInicioEndoso",
      "%Comisión Estimada",
      "%Comisión Conciliada",
      "Liquidado por",
      "Adjuntos",
      "Porcentaje de descuento",
      "Origen Póliza",
      "Póliza Anterior",
      "Póliza Siguiente",
      "Pérdida Total",
      "Fecha de Cancelación de Póliza",
    ];
    $scope.listaPolizas = [
      "Tipo",
      "No.Póliza",
      "Contratante",
      "Grupo",
      "Proveedor",
      "Ramo",
      "Subramo",
      "Tipo(por subramo)",
      "Identificador",
      "Paquete",
      "Prima Neta",
      "Descuento",
      "RPF",
      "Derecho",
      "IVA",
      "Prima Total",
      "Comisión",
      "Comisión Porcentaje",
      "Forma de Pago",
      "Asegurado/Serial",
      "Estatus",
      "Inicio Póliza",
      "Fin Póliza",
      "Referenciador",
      "Folio",
      "Moneda",
      "Fecha creación",
      "Observaciones",
      "Creado por",
      "Clave",
      "Marca",
      "Modelo",
      "Año",
      "Versión",
      "Placas",
      "Motor",
      "Adaptaciones",
      "Dirección",
      "Ejecutivo Cobranza",
      "Responsable",
      "Sucursal",
      "Renovable",
      "OT/Póliza asociada",
      "Origen Póliza",
      "Agrupación",
      "Subagrupación",
      "Subsubagrupación",
      "Clasificación",
      "Línea de Negocio",
      "Célula",
      "Contacto(nombre)",
      "Contacto(telefono)",
      "Contacto(email)",
      "Carátula",
      "Póliza Siguiente",
      "Fecha Cancelación",
      "Adjuntos",
      "Colectividad/PG completa",
      "Estado Circulación",
      "Tipo Administración",
      "No.Interno",
      "Serie",
      "Póliza Anterior",
      "Conducto de Pago",
      "Bitacora",
      "Email",
      "Contributoria",
      "RFC de Cliente",
      "Seguimiento",
    ];
    $scope.listaRenovaciones = [
      "Tipo",
      "No.Póliza",
      "Contratante",
      "Email",
      "Teléfono",
      "Proveedor",
      "Ramo",
      "Subramo",
      "Forma de Pago",
      "Estatus Póliza",
      "Inicio Póliza",
      "Fin Póliza",
      "Moneda",
      "Prima Neta",
      "RPF",
      "Derecho",
      "IVA",
      "Prima Total",
      "Comisión",
      "Clave",
      "Asegurado",
      "Observaciones",
      "Referenciador",
      "Folio",
      "Fecha de Creación",
      "Creado por",
      "Fecha renovación",
      "Estatus de la Renovación",
      "Sucursal",
      "Póliza Anterior",
      "Responsable",
      "Paquete",
      "C.P.",
      "Identificador",
      "Grupo",
      "Agrupación",
      "Subagrupación",
      "Subsubagrupación",
      "Clasificación",
      "Línea de Negocio",
      "Célula",
      "Contacto(nombre)",
      "Contacto(telefono)",
      "Contacto(email)",
      "N.Carátula",
      "CaratulaContratante",
      "Serie(Automovil)",
      "Conducto de Pago",
      "Póliza Siguiente",
    ];

    // Remove duplicates using Set
    // $scope.listaRenovaciones = Array.from(new Set($scope.listaRenovaciones));

    $scope.settingsList = 1;
    activate();
    $scope.configuracionGlobal = {};
    function activate() {
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
    }
    $scope.settingsTab = 1; // Default to first tab
    $scope.showSettings = function (tab) {
      $scope.settingsTab = tab;
      if (tab == 1) {
        $scope.filtrosACL = true;
        $scope.filtrosCPR = false;
      }
      if (tab == 2) {
        $scope.filtrosACL = false;
        $scope.filtrosCPR = true;
        $scope.loadSettings(1);
      }
    };
    $scope.showList = function (y) {
      $scope.loadSettings(y);
      $scope.settingsList = y;
    };
    $scope.loadSettings = function (tipo) {
      if (tipo == 1) {
        $scope.selectedHeaders = {};
        angular.forEach($scope.listaCobranza, function (header) {
          $scope.selectedHeaders[header] = true;
        });
      }
      if (tipo == 2) {
        $scope.selectedHeadersP = {};
        angular.forEach($scope.listaPolizas, function (header) {
          $scope.selectedHeadersP[header] = true;
        });
      }
      if (tipo == 3) {
        $scope.selectedHeadersR = {};
        angular.forEach($scope.listaRenovaciones, function (header) {
          $scope.selectedHeadersR[header] = true;
        });
      }
      var params = {};
      var url_send = url.IP + "save-config-fields-reports/";
      if (tipo) {
        params = {
          tipo: tipo,
        };
      }
      $http
        .get(url_send, { params: params })
        .then(function (response) {
          if (response.data && response.data.data) {
            if (tipo == 1) {
              $scope.selectedHeaders = response.data.data;
            }
            if (tipo == 2) {
              $scope.selectedHeadersP = response.data.data;
            }
            if (tipo == 3) {
              $scope.selectedHeadersR = response.data.data;
            }
          }
        })
        .catch(function (error) {
          console.error("Error loading settings", error);
        });
    };
    $scope.allChecked = false;

    $scope.toggleAll = function () {
      $scope.allChecked = !$scope.allChecked;
      if ($scope.settingsList == 1) {
        angular.forEach($scope.listaCobranza, function (header) {
          $scope.selectedHeaders[header] = $scope.allChecked;
        });
      }
      if ($scope.settingsList == 2) {
        angular.forEach($scope.listaPolizas, function (header) {
          $scope.selectedHeadersP[header] = $scope.allChecked;
        });
      }
      if ($scope.settingsList == 3) {
        angular.forEach($scope.listaRenovaciones, function (header) {
          $scope.selectedHeadersR[header] = $scope.allChecked;
        });
      }
    };
    // Save Config to API
    $scope.saveSettings = function () {
      if ($sessionStorage.token !== undefined && $scope.settingsList == 1) {
        $http
          .post(url.IP + "save-config-fields-reports/", {
            configDataCobranza: $scope.selectedHeaders,
            tipo: $scope.settingsList,
          })
          .then(function (response) {
            $scope.loadSettings(1);
          });
      }
      if ($sessionStorage.token !== undefined && $scope.settingsList == 2) {
        $http
          .post(url.IP + "save-config-fields-reports/", {
            configDataPolizas: $scope.selectedHeadersP,
            tipo: $scope.settingsList,
          })
          .then(function (response) {
            $scope.loadSettings(2);
          });
      }
      if ($sessionStorage.token !== undefined && $scope.settingsList == 3) {
        $http
          .post(url.IP + "save-config-fields-reports/", {
            configDataRenovaciones: $scope.selectedHeadersR,
            tipo: $scope.settingsList,
          })
          .then(function (response) {
            $scope.loadSettings(3);
          });
      }
    };

    $scope.changeFiltros = function (val) {
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, {
              filtros_agrupacion: $scope.configuracionGlobal.filtros_agrupacion,
            })
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory
            .post("orginfo/", {
              filtros_agrupacion: $scope.configuracionGlobal.filtros_agrupacion,
            })
            .then(function success(response) {
              if (response.status == 201) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
      }
    };
    $scope.changeFiltros2 = function (val) {
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, {
              filtros_celula: $scope.configuracionGlobal.filtros_celula,
            })
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory
            .post("orginfo/", {
              filtros_celula: $scope.configuracionGlobal.filtros_celula,
            })
            .then(function success(response) {
              if (response.status == 201) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
      }
    };
    $scope.changeFiltros3 = function (val) {
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, {
              filtros_lineanegocio:
                $scope.configuracionGlobal.filtros_lineanegocio,
            })
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory
            .post("orginfo/", {
              filtros_lineanegocio:
                $scope.configuracionGlobal.filtros_lineanegocio,
            })
            .then(function success(response) {
              if (response.status == 201) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ConexionAgentesCtrl", ConexionAgentesCtrl);

  ConexionAgentesCtrl.$inject = [
    "$timeout",
    "FileUploader",
    "providerService",
    "dataFactory",
    "SweetAlert",
    "$scope",
    "$rootScope",
    "MESSAGES",
    "toaster",
    "endorsementService",
    "insuranceService",
    "receiptService",
    "$stateParams",
    "$state",
    "helpers",
    "formService",
    "$http",
    "url",
    "$uibModal",
    "datesFactory",
    "$q",
    "$localStorage",
    "$sessionStorage",
    "statusReceiptsFactory",
    "$sce",
    "$parse",
    "formatValues",
    "fileService",
    "emailService",
    "appStates",
  ];

  function ConexionAgentesCtrl(
    $timeout,
    FileUploader,
    providerService,
    dataFactory,
    SweetAlert,
    $scope,
    $rootScope,
    MESSAGES,
    toaster,
    endorsementService,
    insuranceService,
    receiptService,
    $stateParams,
    $state,
    helpers,
    formService,
    $http,
    url,
    $uibModal,
    datesFactory,
    $q,
    $localStorage,
    $sessionStorage,
    statusReceiptsFactory,
    $sce,
    $parse,
    formatValues,
    fileService,
    emailService,
    appStates
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });
    var vm = this;
    $scope.fechasFilter = false;
    vm.pageTitle = "Pólizas";
    vm.insurance = {};
    vm.receipts = [];
    vm.search = search;
    vm.goToInfo = goToInfo;
    vm.verpassword = verpassword;
    vm.polizaId = $stateParams.polizaId;
    $scope.periodo = [
      { value: 1, label: "Por día" },
      { value: 2, label: "Cada 2 días" },
      { value: 3, label: "Cada 3 días" },
      { value: 4, label: "Cada 5 días" },
      { value: 5, label: "Cada 10 días" },
      { value: 6, label: "Cada 15 días" },
      { value: 7, label: "Cada mes" },
    ];
    vm.form = {
      since: convertDate(
        new Date(new Date().setMonth(new Date().getMonth() - 1))
      ),
      until: convertDate(new Date()),
      password: "",
      usuario: "",
      aseguradora: "",
      startDate: convertDate(new Date()),
      periodicidad: $scope.periodo[0],
    };
    vm.defaults = {};
    $scope.loader = false;
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                vm.acceso_canc_pol = true;
              } else {
                vm.acceso_canc_pol = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                vm.acceso_elim_pol = true;
              } else {
                vm.acceso_elim_pol = false;
              }
            } else if (acc.permission_name == "Rehabilitar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_rehabilitar = true;
              } else {
                vm.acceso_adm_rehabilitar = false;
              }
            }
          });
        }
        if (perm.model_name == "Endosos") {
          $scope.acceso_endosos = perm;
          $scope.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                $scope.acceso_adm_end = true;
              } else {
                $scope.acceso_adm_end = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                vm.acceso_canc_ot = true;
              } else {
                vm.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar OTs") {
              if (acc.checked == true) {
                vm.acceso_elim_ot = true;
              } else {
                vm.acceso_elim_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Siniestros") {
          vm.acceso_sin = perm;
          vm.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                vm.acceso_adm_sin = true;
              } else {
                vm.acceso_adm_sin = false;
              }
            }
          });
        } else if (perm.model_name == "Mensajeria") {
          vm.acceso_mns = perm;
          vm.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                vm.acceso_mns = true;
              } else {
                vm.acceso_mns = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            } else if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                vm.acceso_del_cob = true;
              } else {
                vm.acceso_del_cob = false;
              }
            } else if (
              acc.permission_name ==
              "No permitir editar recibos Pagados/Liquidados"
            ) {
              if (acc.checked == true) {
                vm.acceso_pl_cob = true; //no se editan
              } else {
                vm.acceso_pl_cob = false; //se pueden editar pagados-liquidados
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          vm.acceso_ref = perm;
          vm.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                vm.acceso_adm_ref = true;
              } else {
                vm.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                vm.acceso_pag_ref = true;
              } else {
                vm.acceso_pag_ref = false;
              }
            } else if (
              acc.permission_name == "Cambiar refrenciador en pólizas"
            ) {
              if (acc.checked == true) {
                vm.acceso_chg_ref = true;
              } else {
                vm.acceso_chg_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.acceso_dash = perm;
          vm.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    vm.repeat = [];
    $scope.compartidas = false;
    activate();
    $(".js-example-basic-multiple").select2();
    // functions
    vm.infoFlag = false;
    vm.show_pag_cn = false;
    $scope.consultashow = false;
    function activate(page) {
      vm.form = {
        since: convertDate(
          new Date(new Date().setMonth(new Date().getMonth() - 1))
        ),
        until: convertDate(new Date()),
        password: "",
        usuario: "",
        aseguradora: "",
        startDate: convertDate(new Date()),
        startDate_scraper: convertDate(new Date()),
        endDate_scraper: convertDate(new Date()),
        periodicidad: $scope.periodo[0],
      };
      $scope.listaConfigs = true;
      $scope.registrosobtenidos = [];
      fillProvider();
      var data = { page: page ? page : 1 };
      dataFactory
        .post("getConfigsProviderScrapper/", data)
        .then(function success(response) {
          $scope.configuraciones = response.data.results;
          $scope.search_results = {
            count: response.data.count,
            previous: url.IP + "getConfigsProviderScrapper/",
            next: url.IP + "getConfigsProviderScrapper/",
          };
          vm.show_pag_cn = true;
          testPagination("configs", "search_results");
        });
    }
    $scope.editConfig = function (obj) {
      $scope.listaConfigs = false;
      $(".js-example-basic-multiple2").select2();
      $scope.show_addconfig = true;
      $scope.consultashow = false;
      vm.form = obj;
      vm.form.usuario = obj.username;
      $scope.select_ramo = vm.form.ramos_sel;
      $scope.select_sramo = vm.form.subramos_sel;
      vm.form.startDate = convertDate(vm.form.startDate);
      vm.form.startDate_scraper = vm.form.startDate_scraper
        ? convertDate(vm.form.startDate_scraper)
        : convertDate(new Date());
      vm.form.endDate_scraper = vm.form.endDate_scraper
        ? convertDate(vm.form.endDate_scraper)
        : convertDate(new Date());
      console.log("-obj--------", obj);
    };
    $scope.consultarInformacion = function (obj) {
      $scope.consultashow = true;
      $scope.show_addconfig = false;
      $scope.listaConfigs = false;
    };
    function fillProvider() {
      var d = vm.form.startDate;
      try {
        var curr_date = d.getDate();
        var curr_month = d.getMonth() + 1; //Months are zero based
        var curr_year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var curr_date = f.getDate();
        var curr_month = f.getMonth() + 1; //Months are zero based
        var curr_year = f.getFullYear();
      }

      var date = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(date).then(
        function success(data) {
          vm.defaults.providers = data.data;
          vm.defaults.providers.forEach(function (x) {
            if (
              x.alias == "Chubb" ||
              x.alias == "chubb" ||
              x.alias == "Aba" ||
              x.alias == "ABA"
            ) {
              vm.form.aseguradora = x;
            }
          });
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }
    function search(pkc) {
      $scope.consultashow = true;
      $scope.show_addconfig = false;
      $scope.listaConfigs = true;
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.params = {
        since: vm.form.since ? vm.form.since : vm.form.si,
        until: vm.form.until ? vm.form.until : vm.form.un,
        usuario: vm.form.usuario,
        clave: vm.form.password,
        provider: vm.form.aseguradora.id,
      };
      $scope.params.since = $scope.params.since + " " + "00:00:00";
      $scope.params.until = $scope.params.until + " " + "23:59:59";
      $scope.filtros = $scope.params;
      $http({
        method: "POST",
        url: url.IP + "get-registros-from-agent/",
        data: $scope.filtros,
      })
        .then(
          function success(request) {
            if (request.status === 200 || request.status === 201) {
              var data = request.data;
              vm.infoFlag = true;
              $scope.registrosobtenidos = data;
              console.log("===>>", data);
              l.stop();
            } else {
              toaster.warning("No se encontraron registros");
              l.stop();
            }
          },
          function error(error) {
            l.stop();
          }
        )
        .catch(function (e) {
          console.log(e);
          l.stop();
        });
    }
    function verpassword() {
      var x = document.getElementById("myInput");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    }
    $scope.dataShare = [];
    function goToInfo(insurance) {
      if (insurance.document_type == 1) {
        $scope.route_for_new_tab = "polizas.info";
        var name = "Información Póliza";
        var route = "polizas.info";
      } else if (insurance.document_type == 3) {
        $scope.route_for_new_tab = "colectividades.info";
        var name = "Información Colectividad";
        var route = "colectividades.info";
      } else if (insurance.document_type == 11) {
        $scope.route_for_new_tab = "flotillas.info";
        var name = "Información Flotilla";
        var route = "flotillas.info";
      } else if (insurance.document_type == 12) {
        $scope.route_for_new_tab = "flotillas.info";
        var name = "Información Flotilla";
        var route = "flotillas.info";
      }
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      // var index_tab = appStates.states.findIndex(function(state){return state.active === true});
      if (insurance.document_type == 1) {
        // appStates.states[index_tab] = {
        //   id: insurance.id,
        //   name: 'Info póliza '+ insurance.poliza_number,
        //   heading: 'Info póliza '+ insurance.poliza_number,
        //   route: 'polizas.info',
        //   active: appStates.states[index_tab].active,
        //   isVisible: appStates.states[index_tab].isVisible,
        //   href: $state.href('polizas.info', {polizaId: insurance.id})
        // }
        // $localStorage.tab_states = appStates.states;
        $state.go("polizas.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 3) {
        $state.go("colectividades.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 11) {
        $state.go("flotillas.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 12) {
        $state.go("flotillas.info", { polizaId: insurance.caratula });
      }
    }
    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }
    $scope.cargarRegistros = function (polizas) {
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      $scope.dataShare = [];
      try {
        polizas.forEach(function (index, contrac) {
          if (index.polizasshare) {
            index.polizasshare.forEach(function (x, pl) {
              x[x.id].id = x.id;
              if ($scope.dataShare) {
                $scope.dataShare.push(x[x.id]);
              }
            });
          }
        });
      } catch (e) {
        console.log("-eeeroror--", e);
        l.stop();
      }
    };
    $scope.periodo_selected = function (v) {
      switch (v) {
        case 1:
          return "Por día";
          break;
        case 2:
          return "Cada 2 días";
          break;
        case 3:
          return "Cada 3 días";
          break;
        case 4:
          return "Cada 5 días";
          break;
        case 5:
          return "Cada 10 días";
          break;
        case 6:
          return "Cada 15 días";
          break;
        case 7:
          return "Cada mes";
          break;
        default:
          return "Cada mes";
          break;
      }
    };
    // -----------------------------------
    $scope.addConfigProviderOK = function (obj) {
      $(".js-example-basic-multiple2").select2();
      $scope.show_addconfig = true;
    };
    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http
            .get(url.IP + "subramos-by-ramo_code/" + vm.id)
            .then(function (data) {
              vm.subramos_toselected = data.data;
            });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    // -----------PAGINACIÓN
    $scope.checkDateValues = function (values) {
      var date1 = datesFactory.toDate(vm.form.endDate_scraper);
      var date2 = datesFactory.toDate(values);
      $scope.dateOut = false;
      if (date2 > date1) {
        SweetAlert.swal(
          "Error",
          "La fecha inicial no puede ser mayor a la fecha final",
          "error"
        );
        $scope.dateOut = true;
        return;
      } else {
        $scope.dateOut = false;
      }
    };
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPagesP = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesP.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesP.length > 5) {
          $scope.end = $scope.totalPagesP.length;
          $scope.start = $scope.totalPagesP.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPageP($scope.totalPagesP.length);
      };

      $scope.selectPageP = function (parPage) {
        $scope.actual_page = parPage;
        activate(parPage);
      };

      $scope.previousBlockPagesP = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesP.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesP = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesP.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesP.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.subramo_code);
      });
    };
    $scope.saveConfig = function () {
      var data_send = {
        username: vm.form.usuario,
        password: vm.form.password,
        title: vm.form.title,
        descrip: vm.form.descrip,
        periodicidad: vm.form.periodicidad,
        startDate: vm.form.startDate
          ? datesFactory.toDate(vm.form.startDate)
          : new Date(),
        startDate_scraper: vm.form.startDate_scraper
          ? datesFactory.toDate(vm.form.startDate_scraper)
          : new Date(),
        endDate_scraper: vm.form.endDate_scraper
          ? datesFactory.toDate(vm.form.endDate_scraper)
          : new Date(),
        provider: vm.form.provider.url,
        ramos: vm.ramos_selected ? vm.ramos_selected : [],
        subramos: vm.subramos_selected ? vm.subramos_selected : [],
      };
      if (vm.form.url) {
        $http.patch(vm.form.url, data_send).then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            console.log("---confg saved----", response);
            $scope.show_addconfig = false;
          }
        });
      } else {
        dataFactory
          .post("config-provider-scrapper/", data_send)
          .then(function success(response) {
            if (response.status === 200 || response.status === 201) {
              console.log("---confg saved----", response);
              $scope.show_addconfig = false;
            }
          });
      }
      activate();
    };
    // -----------------------------------
    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function mesDiaAnio(parDate) {
      var d = new Date(toDate(parDate));
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      return date;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ConciliarMasivoCtrl", ConciliarMasivoCtrl);
  ConciliarMasivoCtrl.$inject = [
    "$q",
    "$sce",
    "$timeout",
    "FileUploader",
    "datesFactory",
    "MESSAGES",
    "providerService",
    "curr_rate_options",
    "$localStorage",
    "receiptService",
    "statusPayform",
    "toaster",
    "$uibModal",
    "statusReceipt",
    "SweetAlert",
    "$uibModalInstance",
    "modalService",
    "valueReceipt",
    "$sessionStorage",
    "$http",
    "url",
    "$parse",
    "$scope",
    "$state",
    "exportFactory",
    "$location",
    "dataFactory",
    "$rootScope",
  ];

  function ConciliarMasivoCtrl(
    $q,
    $sce,
    $timeout,
    FileUploader,
    datesFactory,
    MESSAGES,
    providerService,
    curr_rate_options,
    $localStorage,
    receiptService,
    statusPayform,
    toaster,
    $uibModal,
    statusReceipt,
    SweetAlert,
    $uibModalInstance,
    modalService,
    valueReceipt,
    $sessionStorage,
    $http,
    url,
    $parse,
    $scope,
    $state,
    exportFactory,
    $location,
    dataFactory,
    $rootScope
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.org_name = usr.urlname;
    vm.accesos = $sessionStorage.permisos;
    vm.pageTitle = "Conciliar Masivo por ID";
    vm.paidReceipts = [];
    vm.close = close;
    vm.liquidar_is_posible = false;

    vm.carga_masiva = false;
    vm.errores_carga_masiva = [];
    vm.lista_carga_masiva = [];
    vm.lista_carga_masivapago = [];
    vm.fecha_conciliacion = datesFactory.convertDate(new Date());
    var formdata = new FormData();

    vm.accesos.forEach(function (acceso) {
      if (acceso.model_name == "Cobranza") {
        vm.acceso_cob = acceso;
        vm.acceso_cob.permissions.forEach(function (acc) {
          if (acc.permission_name == "Pagar y prorrogar") {
            if (acc.checked == true) {
              vm.acceso_pag_rec = true;
            } else {
              vm.acceso_pag_rec = false;
            }
          } else if (acc.permission_name == "Desconciliación de recibos") {
            if (acc.checked == true) {
              vm.acceso_desconc_rec = true;
            } else {
              vm.acceso_desconc_rec = false;
            }
          } else if (acc.permission_name == "Desliquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_desliq_rec = true;
            } else {
              vm.acceso_desliq_rec = false;
            }
          } else if (acc.permission_name == "Conciliar recibos") {
            if (acc.checked == true) {
              vm.acceso_conc_rec = true;
            } else {
              vm.acceso_conc_rec = false;
            }
          } else if (acc.permission_name == "Liquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_liq_rec = true;
            } else {
              vm.acceso_liq_rec = false;
            }
          } else if (acc.permission_name == "Ver cobranza") {
            if (acc.checked == true) {
              vm.acceso_ver_cob = true;
            } else {
              vm.acceso_ver_cob = false;
            }
          } else if (acc.model_name == "Archivos") {
            vm.acceso_files = acc;
            vm.acceso_files.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              }
            });
          }
        });
      } else if (acceso.model_name == "Correos electronicos") {
        vm.acceso_correo = acceso;
        vm.acceso_correo.permissions.forEach(function (acc) {
          if (acc.permission_name == "Correos") {
            if (acc.checked == true) {
              vm.acceso_cor = true;
            } else {
              vm.acceso_cor = false;
            }
          }
        });
      } else if (acceso.model_name == "Pólizas") {
        vm.acceso_polizas = acceso;
        vm.acceso_polizas.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar pólizas") {
            if (acc.checked == true) {
              vm.acceso_adm_pol = true;
            } else {
              vm.acceso_adm_pol = false;
            }
          } else if (acc.permission_name == "Ver pólizas") {
            if (acc.checked == true) {
              vm.acceso_ver_pol = true;
            } else {
              vm.acceso_ver_pol = false;
            }
          }
        });
      } else if (acceso.model_name == "Reportes") {
        vm.acceso_reportes = acceso;
        vm.acceso_reportes.permissions.forEach(function (acc) {
          if (acc.permission_name == "Reporte fianzas") {
            if (acc.checked == true) {
              vm.acceso_rep_fia = true;
            } else {
              vm.acceso_rep_fia = false;
            }
          } else if (acc.permission_name == "Reporte Siniestros") {
            if (acc.checked == true) {
              vm.acceso_rep_sin = true;
            } else {
              vm.acceso_rep_sin = false;
            }
          } else if (acc.permission_name == "Reporte Endosos") {
            if (acc.checked == true) {
              vm.acceso_rep_end = true;
            } else {
              vm.acceso_rep_end = false;
            }
          } else if (acc.permission_name == "Reporte pólizas") {
            if (acc.checked == true) {
              vm.acceso_rep_pol = true;
            } else {
              vm.acceso_rep_pol = false;
            }
          } else if (acc.permission_name == "Reporte renovaciones") {
            if (acc.checked == true) {
              vm.acceso_rep_ren = true;
            } else {
              vm.acceso_rep_ren = false;
            }
          } else if (acc.permission_name == "Reporte cobranza") {
            if (acc.checked == true) {
              vm.acceso_rep_cob = true;
            } else {
              vm.acceso_rep_cob = false;
            }
          }
        });
      }
    });

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });
    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
      }
    };
    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          $scope.specialchar.push(specialChars[i]);
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };

    $scope.open_in_same_tab = function (name, route) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };

        $localStorage.tab_states = appStates.states;
        // $localStorage.tab_index = $localStorage.tab_states.length -1;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.ramo == undefined) {
        item.ramo = 2;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].ramo = item.ramo;
    };

    function uploadFiles(ticketId) {
      $scope.userInfo = {
        id: ticketId.id,
      };
      $scope.userInfo.url = url.IP + "ticket/" + ticketId.id + "/archivos/";
      $scope.uploader.uploadAll();
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function getBase64(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        console.log(reader.result);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    }

    $scope.fileNameChanged = function (ele) {
      $scope.filePdf = ele.files[0];
      var file = ele.files[0];

      var r = new FileReader();
      $scope.data = {};
      r.onloadend = function (e) {
        $scope.data.b64 = e.target.result;
        $scope.$apply();
        $scope.blod = $scope.data.b64.replace(
          /^data:application\/vnd.ms-excel;base64,/,
          ""
        );
      };
      r.readAsDataURL(file); //once defined all callbacks, begin reading the file
    };

    // Pago
    $scope.validarLayoutCargaMasivaId = function () {
      var pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
      if (!pattern.test(vm.fecha_conciliacion)) {
        vm.errores_carga_masivapago.push(
          "La fecha de Conciliación esta errónea, verifique el Formato sea DD/MM/AAAA."
        );
      }
      if (vm.cuenta == undefined || vm.cuenta.length == 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SELECTACCOUNT, "error");
        return;
      }
      // $scope.loadingConciliacionId = true;
      $http({
        method: "POST",
        url: url.IP + "check-cobranza-id-conciliacion-masivo",
        data: {
          recibos: vm.lista_carga_masiva_conciliacion_id,
          fecha_conciliacion: vm.fecha_conciliacion,
          account: vm.cuenta.id,
          validar: true,
        },
      })
        .then(
          function (response) {
            $scope.loadingConciliacionId = false;
            if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length > 0
            ) {
              $scope.modalInstance = $uibModal.open({
                templateUrl: "app/cobranzas/cobranzas.modal.errores.html",
                controller: CobranzaErroresCtrl,
                controllerAs: "vmm",
                size: "md",
                resolve: {
                  errores: function () {
                    return response["data"];
                  },
                  folioconciliacion: function () {
                    return "";
                  },
                  titulo: function () {
                    return "Errores de validación de layout";
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });
            } else if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length == 0
            ) {
              SweetAlert.swal(
                "Cargado",
                "Archivo validado exitosamente",
                "success"
              );
            } else {
              SweetAlert.swal(
                "Error",
                "Ocurrieron errores en el proceso",
                "error"
              );
            }
          },
          function (error) {
            $scope.loadingConciliacionId = false;
          }
        )
        .catch(function (error) {
          $scope.loadingConciliacionId = false;
        });
    };
    $scope.cargarLayoutCargaMasivaId = function () {
      SweetAlert.swal(
        {
          title: "¡Aviso!",
          text: "Se conciliarán todos los recibos cargados y válidos. ¿Desea continuar?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        },
        function (isConfirm) {
          $scope.loadingConciliacionId = true;
          if (isConfirm) {
            $http({
              method: "POST",
              url: url.IP + "cobranza-conciliacion-masiva-id",
              data: {
                recibos: vm.lista_carga_masiva_conciliacion_id,
                fecha_conciliacion: vm.fecha_conciliacion,
                account: vm.cuenta.id,
                validar: false,
                owner: usr.name,
                org: vm.org_name,
                source: "Conciliar por Carga Masiva (MEDIANTE ID)",
              },
            })
              .then(
                function (response) {
                  $scope.loadingConciliacionId = false;
                  if (
                    response &&
                    response["status"] == 200 &&
                    response["data"].errores &&
                    response["data"].errores.length > 0
                  ) {
                    $scope.modalInstance = $uibModal.open({
                      templateUrl: "app/cobranzas/cobranzas.modal.errores.html",
                      controller: CobranzaErroresCtrl,
                      controllerAs: "vmm",
                      size: "md",
                      resolve: {
                        errores: function () {
                          return response["data"].errores;
                        },
                        folioconciliacion: function () {
                          return response["data"].folioconciliacion;
                        },
                        titulo: function () {
                          return "Reporte de carga de layout Conciliación Masiva ID";
                        },
                      },
                      backdrop:
                        "static" /* this prevent user interaction with the background */,
                      keyboard: false,
                    });
                  } else if (
                    response &&
                    response["status"] == 200 &&
                    response["data"].errores &&
                    response["data"].errores.length == 0
                  ) {
                    SweetAlert.swal(
                      "Cargado",
                      "Archivo validado exitosamente",
                      "success"
                    );
                    $scope.loading = false;
                  } else {
                    SweetAlert.swal(
                      "Error",
                      "Ocurrieron errores en el proceso",
                      "error"
                    );
                    $scope.loading = false;
                  }
                },
                function (error) {
                  $scope.loadingConciliacionId = false;
                }
              )
              .catch(function (error) {
                $scope.loadingConciliacionId = false;
              });
          } else {
          }
        }
      );
    };
    // *************************
    $scope.validateExcelIdConciliar = function (param) {
      var flag_errores = false;
      $scope.excelFilePago = [];
      if (param && param["datos"] && param["datos"].length > 0) {
        var flag_errores = false;
        vm.errores_carga_masivapago = [];
        param["datos"].forEach(function (dato) {
          if (!isNumeric(dato.ID_SAAM)) {
            vm.errores_carga_masivapago.push(
              "En la columna ID_SAAM en la fila " +
                (parseInt(dato.__rowNum__) + 1) +
                " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
            );
            flag_errores = true;
          }
          if (!dato.Comision_conciliada) {
            vm.errores_carga_masivapago.push(
              "En la columna Comision_conciliada en la fila " +
                (parseInt(dato.__rowNum__) + 1) +
                " el campo está vacío"
            );
            flag_errores = true;
          }
        });
        if (flag_errores) {
          vm.carga_masivapago = false;
          $scope.modalInstance = $uibModal.open({
            templateUrl: "app/cobranzas/cobranzas.modal.errores.html",
            controller: CobranzaErroresPagoCtrl,
            controllerAs: "vmm",
            size: "lg",
            resolve: {
              errores: function () {
                return vm.errores_carga_masivapago;
              },
              titulo: function () {
                return "Errores Recibos Carga Masiva";
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
        } else {
          param["datos"] = param["datos"].map(function (dato) {
            dato["rowNum"] = parseInt(dato.__rowNum__) + 1;
            return dato;
          });
          vm.lista_carga_masiva_conciliacion_id = param["datos"];
          vm.carga_masiva_conciliacion_id = true;
          SweetAlert.swal("Cargado", "Archivo cargado exitosamente", "success");
        }
      } else {
        SweetAlert.swal("ERROR", "El layout está vacío", "error");
        return;
        vm.carga_masivapago = false;
      }
    };

    function CobranzaErroresCtrl(
      $q,
      $scope,
      $sessionStorage,
      $uibModalInstance,
      $http,
      MESSAGES,
      errores,
      datesFactory,
      titulo,
      folioconciliacion
    ) {
      var vmm = this;

      vmm.errores = errores;
      vmm.titulo = titulo;

      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);

      $scope.cancel = function () {
        if (folioconciliacion) {
          SweetAlert.swal(
            "Hecho",
            "Se han conciliado los recibos con el folio: " +
              folioconciliacion +
              "\n Se esta generando el PDF de Conciliación",
            "success"
          );
          $http({
            method: "POST",
            url: url.IP + "get-pdf-conciliacion/",
            data: {
              conciliacion_folio: folioconciliacion,
            },
          }).then(function success(response) {
            var file = new Blob([response.data], { type: "application/pdf" });
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file);
            } else {
              var fileURL = URL.createObjectURL(file);
              $scope.content = $sce.trustAsResourceUrl(fileURL);
              window.open($scope.content);
            }
          });
        }
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    function CobranzaErroresPagoCtrl(
      $q,
      $scope,
      $sessionStorage,
      $uibModalInstance,
      $http,
      MESSAGES,
      errores,
      datesFactory,
      titulo
    ) {
      var vmm = this;

      vmm.errores = errores;
      vmm.titulo = titulo;

      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    $scope.remove_email = function (index) {
      $scope.mails.splice(index, 1);
    };
    $scope.remove_email_cc = function (index) {
      $scope.mails_cc.splice(index, 1);
    };
    $scope.remove_email_cco = function (index) {
      $scope.mails_cco.splice(index, 1);
    };

    vm.form = {};

    activate();
    function activate(x) {
      $rootScope.banco_selected = 0;
      $rootScope.name = "";
      $rootScope.account = "";
      $rootScope.observation = "";
      $rootScope.addAccount = false;
      $http.get(url.IP + "bancos/").then(function (bank) {
        $rootScope.bancos = bank.data;
      });
      $http.get(url.IP + "accounts/").then(function (response) {
        vm.accounts = response.data.results;
        $rootScope.acounts_data = response.data.results;
        vm.cuenta = $rootScope.acounts_data[0];
      });
      vm.form.conciliate_date = convertDate(new Date());
    }
    $scope.add_account = function () {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/comisiones/add_account_modal.html",
        controller: assignModalView,
        controllerAs: "vm",
        ////windowClass: 'animated fadeIn',
        size: "lg",
        // resolve:{'rn':receipt.recibo_numero,'recibo':receipt},
        resolve: {
          accounts: function () {
            return vm.accounts;
          },
          form_data: function () {
            return vm.form;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(
        function () {},
        function () {
          if ($rootScope.new_account) {
            $rootScope.acounts_data.push($rootScope.new_account);
            $scope.vm.cuenta = $rootScope.new_account;
            change_account($rootScope.new_account);
            vm.conciliar = true;
          }
          vm.form = $rootScope.form_data;
        }
      );
    };

    function change_account(param) {
      if (param) {
        vm.cuenta = param;
      }
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    vm.show_nota = false;

    // Conciliar conculta
    $scope.conciliar_masivo = function (flag, order, asc, parPage) {
      $rootScope.banco_selected = 0;
      $rootScope.name = "";
      $rootScope.account = "";
      $rootScope.observation = "";
      $rootScope.addAccount = false;
      $http.get(url.IP + "bancos/").then(function (bank) {
        $rootScope.bancos = bank.data;
      });
      $http.get(url.IP + "accounts/").then(function (response) {
        vm.accounts = response.data.results;
        $rootScope.acounts_data = response.data.results;
        vm.cuenta = $rootScope.acounts_data[0];
      });
      vm.form.conciliate_date = convertDate(new Date());
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/conciliar_masivo_modal.html",
        controller: "ConciliarMasivoCtrl",
        size: "md",
        resolve: {
          flag: function () {
            return flag;
          },
          order: function () {
            return order;
          },
          asc: function () {
            return asc;
          },
          parPage: function () {
            return parPage;
          },
          valueReceipt: function () {
            return "";
          },
        },
      });
    };
    // $scope.add_account = function() {
    //   $rootScope.addAccount = true;
    // };
    function assignModalView(
      $rootScope,
      $scope,
      $uibModalInstance,
      url,
      toaster,
      MESSAGES,
      accounts,
      form_data
    ) {
      $rootScope.form_data = form_data;
      vm = this;
      $http.get(url.IP + "bancos/").then(function (bank) {
        $scope.bancos = bank.data;
      });
      vm.banco_selected = 0;
      vm.name = "";
      vm.account = "";
      vm.observation = "";

      $scope.saveAccount = function () {
        if (vm.banco_selected) {
          $http
            .post(url.IP + "accounts/", {
              name: vm.name,
              account: vm.account,
              observation: vm.observation,
              bank: vm.banco_selected,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  $rootScope.new_account = request.data;
                  // accounts.push(request.data);
                  toaster.success("Cuenta creada exitosamente");
                  $uibModalInstance.dismiss("cancel");
                } else {
                  toaster.warning("Error al crear cuenta");
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          toaster.warning(MESSAGES.WARNING.EMPTYBANK);
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }
    $scope.conciliar_consulta = function (cc, fa, acc, consulta, filtros) {
      if (!cc || !fa || !acc) {
        toaster.error("Complete todos los campos");
        return;
      }
      var _text =
        "Confirmar la Conciliación de la consulta (" +
        consulta.count +
        " recibo)";
      $scope.filtros_conciliacion = filtros;
      var data_alert = {
        title: "Conciliar selección",
        text: _text,
        type: "warning",
        confirmButtonText: "Conciliar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: false,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (isConfirm) {
        if (isConfirm) {
          $scope.filtros_conciliacion.comision_conciliada =
            parseFloat(cc).toFixed(2);
          $scope.filtros_conciliacion.conciliacion_date =
            datesFactory.toDate(fa);
          $scope.filtros_conciliacion.account = acc.id;
          // $scope.filtros_conciliacion.only_caratula = vm.only_caratula_poliza ? vm.only_caratula_poliza : 0
          $scope.url_go_conc = "conciliar-cobranza-massive/";
          $http({
            // method: 'GET',
            // url: url.IP + 'get-cobranza/',
            // params: $scope.filtros
            method: "POST",
            url: url.IP + $scope.url_go_conc,
            data: $scope.filtros_conciliacion,
          }).then(function (response) {
            if (response.status == 200 || response.status == 201) {
              swal("Conciliada, folio de conciliación: " + response.data.folio);
              vm.receipts = [];
              getCobranza(1, 1, 1, 1);
              activate();
            } else {
              swal("Error: La consulta NO ha sido conciliada", "error");
            }
            $uibModalInstance.dismiss("cancel");
            vm.receipts = [];
            getCobranza(1, 1, 1, 1);
            activate();
          });
        } else {
          $uibModalInstance.dismiss("cancel");
        }
      });
    };
    // Log de registro de pago y/o liquidación recibos masivo
    function log_liq_and_pay_massive(rec) {
      if (rec.status == 1) {
        $scope.status_receipt =
          "actualizó recibo a pagado( con el folio de pago: " + rec.folio;
      } else if (rec.status == 5) {
        $scope.status_receipt =
          "actualizó reciboa liquidado con el folio de liquidación: " +
          rec.folio;
      }

      var params = {
        model: 4,
        event: "POST",
        associated_id: rec.id,
        identifier: $scope.status_receipt,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
    }
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular.module("inspinia").controller("ComisionesCtrl", ComisionesCtrl);

  ComisionesCtrl.$inject = [
    "MESSAGES",
    "$scope",
    "SweetAlert",
    "ContratanteService",
    "insuranceService",
    "$uibModal",
    "receiptService",
    "url",
    "$http",
    "$q",
    "$localStorage",
    "packageService",
    "ramoService",
    "providerService",
    "groupService",
    "coverageService",
    "toaster",
    "dataFactory",
    "$state",
    "$sessionStorage",
    "exportFactory",
    "$rootScope",
    "$sce",
    "datesFactory",
  ];

  function ComisionesCtrl(
    MESSAGES,
    $scope,
    SweetAlert,
    ContratanteService,
    insuranceService,
    $uibModal,
    receiptService,
    url,
    $http,
    $q,
    $localStorage,
    packageService,
    ramoService,
    providerService,
    groupService,
    coverageService,
    toaster,
    dataFactory,
    $state,
    $sessionStorage,
    exportFactory,
    $rootScope,
    $sce,
    datesFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    // configuraciÃ³n del datepicker
    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    var vm = this;
    // vm.user = usr.permiso;
    vm.pack = [];
    vm.user = usr;

    // vm.providers = [];
    vm.ramos = [];
    vm.subramos = [];
    vm.coverage_ramos = [];
    vm.coverage_subramos = [];
    vm.coverage_paquetes = [];
    vm.editRecibo = editRecibo;

    vm.process_comission = process_comission;
    vm.pago_recibo_actual = [];
    vm.conciliar = false;
    vm.getPendientes = getPendientes;
    $scope.show_providers = false;

    vm.prima_total_conciliada = "";
    vm.comision_conciliada = "";
    vm.addToClose = addToClose;
    vm.DeleteToClose = DeleteToClose;
    vm.matchesContractors = matchesContractors;
    vm.accesos = $sessionStorage.permisos;
    vm.accesos.forEach(function (acceso) {
      if (acceso.model_name == "Cobranza") {
        vm.acceso_cob = acceso;
        vm.acceso_cob.permissions.forEach(function (acc) {
          if (acc.permission_name == "Pagar y prorrogar") {
            if (acc.checked == true) {
              vm.acceso_pag_rec = true;
            } else {
              vm.acceso_pag_rec = false;
            }
          } else if (acc.permission_name == "Desconciliación de recibos") {
            if (acc.checked == true) {
              vm.acceso_desconc_rec = true;
            } else {
              vm.acceso_desconc_rec = false;
            }
          } else if (acc.permission_name == "Despagar recibos") {
            if (acc.checked == true) {
              vm.acceso_despag_rec = true;
            } else {
              vm.acceso_despag_rec = false;
            }
          } else if (acc.permission_name == "Desliquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_desliq_rec = true;
            } else {
              vm.acceso_desliq_rec = false;
            }
          } else if (acc.permission_name == "Conciliar recibos") {
            if (acc.checked == true) {
              vm.acceso_conc_rec = true;
            } else {
              vm.acceso_conc_rec = false;
            }
          } else if (acc.permission_name == "Liquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_liq_rec = true;
            } else {
              vm.acceso_liq_rec = false;
            }
          } else if (acc.permission_name == "Ver cobranza") {
            if (acc.checked == true) {
              vm.acceso_ver_cob = true;
            } else {
              vm.acceso_ver_cob = false;
            }
          }
        });
      } else if (acceso.model_name == "Correos electronicos") {
        vm.acceso_correo = acceso;
        vm.acceso_correo.permissions.forEach(function (acc) {
          if (acc.permission_name == "Correos") {
            if (acc.checked == true) {
              vm.acceso_cor = true;
            } else {
              vm.acceso_cor = false;
            }
          }
        });
      } else if (acceso.model_name == "Pólizas") {
        vm.acceso_polizas = acceso;
        vm.acceso_polizas.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar pólizas") {
            if (acc.checked == true) {
              vm.acceso_adm_pol = true;
            } else {
              vm.acceso_adm_pol = false;
            }
          } else if (acc.permission_name == "Ver pólizas") {
            if (acc.checked == true) {
              vm.acceso_ver_pol = true;
            } else {
              vm.acceso_ver_pol = false;
            }
          }
        });
      } else if (acceso.model_name == "Reportes") {
        vm.acceso_reportes = acceso;
        vm.acceso_reportes.permissions.forEach(function (acc) {
          if (acc.permission_name == "Reporte fianzas") {
            if (acc.checked == true) {
              vm.acceso_rep_fia = true;
            } else {
              vm.acceso_rep_fia = false;
            }
          } else if (acc.permission_name == "Reporte Siniestros") {
            if (acc.checked == true) {
              vm.acceso_rep_sin = true;
            } else {
              vm.acceso_rep_sin = false;
            }
          } else if (acc.permission_name == "Reporte Endosos") {
            if (acc.checked == true) {
              vm.acceso_rep_end = true;
            } else {
              vm.acceso_rep_end = false;
            }
          } else if (acc.permission_name == "Reporte pólizas") {
            if (acc.checked == true) {
              vm.acceso_rep_pol = true;
            } else {
              vm.acceso_rep_pol = false;
            }
          } else if (acc.permission_name == "Reporte renovaciones") {
            if (acc.checked == true) {
              vm.acceso_rep_ren = true;
            } else {
              vm.acceso_rep_ren = false;
            }
          } else if (acc.permission_name == "Reporte cobranza") {
            if (acc.checked == true) {
              vm.acceso_rep_cob = true;
            } else {
              vm.acceso_rep_cob = false;
            }
          }
        });
      } else if (acceso.model_name == "Archivos") {
        vm.acceso_files = acceso;
        vm.acceso_files.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar archivos sensibles") {
            if (acc.checked == true) {
              vm.permiso_archivos = true;
            } else {
              vm.permiso_archivos = false;
            }
          }
        });
      }
    });
    $scope.ajustar_conciliacion = false;
    $scope.liquidarTodos = true;
    $scope.conciliateTodos = false;

    vm.option_policy = [
      {
        id: 1,
        name: "Inicio de vigencia",
      },
      {
        id: 2,
        name: "Vencimiento",
      },
      {
        id: 3,
        name: "Fecha de pago",
      },
      {
        id: 4,
        name: "Fecha de liquidación",
      },
    ];

    // Changes
    $scope.conciliar_masivos = false;
    vm.changeProvider = changeProvider;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.returnToList = returnToList;
    vm.forma_pago = forma_pago;
    vm.status = status;
    vm.table = {};
    vm.enableConciliacion = enableConciliacion;
    vm.conciliarRecibo = conciliarRecibo;
    vm.liquidarRecibo = liquidarRecibo;
    vm.change_account = change_account;
    vm.packageArray = [];
    vm.cuenta = [];
    vm.form = {
      provider: null,
      ramo: null,
      subramo: null,
      polizas_iniciales: true,
      polizas_renovadas: true,
      recibos_pagados: false,
      recibos_no_pagados: false,
      since: convertDate(
        new Date(new Date().setMonth(new Date().getMonth() - 3))
      ),
      until: convertDate(new Date()),
      cve_agente: "",
      recibos_listos: [],
      total: 0,
      total_conciliado: 0,
      recibos_liquidados: true,
      recibos_conciliados: false,
      conciliate_date: convertDate(new Date()),
      liquidation_date: convertDate(new Date()),
      massive_observation: "",
      comision_conciliada: "",
    };
    vm.form.comision_conciliada = 1000;
    vm.table = {
      headers: [
        "Liquidar",
        "Contratante",
        "Póliza/Fianza",
        "Serie",
        "Tipo",
        "Vigencia",
        "Fecha liquidación",
        "Fecha pago",
        "Prima Neta",
        "Comisión",
        "Moneda",
        "Estatus",
        "Comisión Conciliada",
        "Clave Agente",
        "Remover",
      ],
    };
    $scope.toClose = [];
    $scope.banco = "";

    activate();
    vm.form.until = convertDate(new Date());
    // var endingDate =  convertDate(new Date().setYear(new Date().getFullYear() + 1));
    var endingDate = convertDate(new Date());
    vm.form.until = endingDate;
    // $scope.changeCuenta = function(item) {
    //
    // }

    $scope.changeReport = function (param) {
      $scope.dates_selected = true;
    };
    vm.changeRecibos = changeRecibos;
    function changeRecibos(par, asc) {
      switch (par) {
        case 1:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = asc;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 2:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = asc;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 3:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = asc;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 4:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = asc;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 5:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = asc;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 6:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = asc;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 7:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = asc;
          vm.prima_neta_asc = 0;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 8:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = asc;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 9:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.comision_asc = asc;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 10:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.comision_asc = 0;
          vm.moneda_asc = asc;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 11:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = asc;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 12:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = asc;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 13:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = asc;
          vm.provider_asc = 0;
          vm.prima_total_asc = 0;
          break;
        case 14:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.prima_total_asc = asc;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          vm.provider_asc = 0;
          break;
        case 15:
          $scope.selectProvider(
            $scope.aseg_selected,
            $scope.idx_selected,
            par,
            asc
          );
          vm.contratante_asc = 0;
          vm.poliza_asc = 0;
          vm.serie_asc = 0;
          vm.tipo_asc = 0;
          vm.vigencia_asc = 0;
          vm.fecha_liq_asc = 0;
          vm.fecha_pago_asc = 0;
          vm.prima_neta_asc = 0;
          vm.prima_total_asc = 0;
          vm.provider_asc = asc;
          vm.comision_asc = 0;
          vm.moneda_asc = 0;
          vm.estatus_asc = 0;
          vm.comision_conc_asc = 0;
          vm.clave_asc = 0;
          break;
      }
    }
    $scope.add_account = function () {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/comisiones/add_account_modal.html",
        controller: assignModalView,
        controllerAs: "vm",
        ////windowClass: 'animated fadeIn',
        size: "lg",
        // resolve:{'rn':receipt.recibo_numero,'recibo':receipt},
        resolve: {
          accounts: function () {
            return vm.accounts;
          },
          form_data: function () {
            return vm.form;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(
        function () {},
        function () {
          if ($rootScope.new_account) {
            $rootScope.acounts_data.push($rootScope.new_account);
            $scope.vm.cuenta = $rootScope.new_account;
            change_account($rootScope.new_account);
            vm.conciliar = true;
          }
          vm.form = $rootScope.form_data;
        }
      );
    };

    function change_account(param) {
      if (param) {
        vm.cuenta = param;
      }
    }

    function assignModalView(
      $rootScope,
      $scope,
      $uibModalInstance,
      url,
      toaster,
      MESSAGES,
      accounts,
      form_data
    ) {
      $rootScope.form_data = form_data;

      vm = this;
      $http.get(url.IP + "bancos/").then(function (bank) {
        $scope.bancos = bank.data;
      });
      vm.banco_selected = 0;
      vm.name = "";
      vm.account = "";
      vm.observation = "";

      $scope.saveAccount = function () {
        if (vm.banco_selected) {
          $http
            .post(url.IP + "accounts/", {
              name: vm.name,
              account: vm.account,
              observation: vm.observation,
              bank: vm.banco_selected,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  $rootScope.new_account = request.data;
                  // accounts.push(request.data);
                  toaster.success("Cuenta creada exitosamente");
                  $uibModalInstance.dismiss("cancel");
                } else {
                  toaster.warning("Error al crear cuenta");
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          toaster.warning(MESSAGES.WARNING.EMPTYBANK);
        }
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }
    // $scope.CloseMassives = function() {
    //   SweetAlert.swal({
    //     title: "Liquidar recibo(s)",
    //     text: '¿Está seguro de liquidar los recibo(s)?',
    //     type: "warning",
    //     confirmButtonText: "Si",
    //     cancelButtonText: "No",
    //     showCancelButton: true,
    //     closeOnConfirm: false,
    //     showLoaderOnConfirm: true,
    //     allowOutsideClick: true
    //   },
    //   function(isConfirm) {
    //     if(isConfirm) {
    //       $scope.liquidacion_folio=$scope.toClose[0].id
    //       $scope.toClose.forEach(function(recibo){
    //         if (recibo.bono) {
    //           recibo.bono = recibo.bono.url
    //         }
    //         patchRecibo(recibo.url,{liquidacion_date: new Date(), status : 5, liquidacion_folio: $scope.toClose[0].id })
    //       })
    //       SweetAlert.swal({
    //           title: "Hecho",
    //           text: "Los recibos se han liquidado, folio de liquidacion: " + $scope.toClose[0].id,
    //           type: "success",
    //           showCancelButton: false,
    //           confirmButtonColor: "#DD6B55",
    //           confirmButtonText: "Ok",
    //           cancelButtonText: "No",
    //           closeOnConfirm: true,
    //           closeOnCancel: false
    //       }, function(isConfirm) {
    //         var folio = $scope.liquidacion_folio
    //         $scope.toClose= []
    //         $http({
    //             method: 'POST',
    //             url: url.IP + 'get-pdf-liquidacion/',
    //             data: {
    //                 'liquidacion_folio': folio,
    //             }
    //             }).then(function success(response) {
    //                 $scope.pdf = response.data;

    //                 $http({
    //                     method: 'GET',
    //                     url: url.IP + 'get-pdf',
    //                     params: {
    //                         'pdf_name': $scope.pdf.pdf_name
    //                     }
    //                     }).then(function success(response) {
    //                         var file = new Blob([response.data], {type: 'application/pdf'});
    //                         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //                             window.navigator.msSaveOrOpenBlob(file);
    //                         }
    //                         else{

    //                           var fileURL = URL.createObjectURL(file);
    //                           $scope.content = $sce.trustAsResourceUrl(fileURL);
    //                           window.open($scope.content);
    //                         }
    //                     })
    //             })
    //       });
    //     } else {
    //     }
    //   });

    // }

    $scope.liquidarTodosF = function (recibos, ase) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/comisiones/liquidate_massive.html",
        controller: liquidateMassiveModal,
        controllerAs: "vm",
        ////windowClass: 'animated fadeIn',
        size: "lg",
        // resolve:{'rn':receipt.recibo_numero,'recibo':receipt},
        resolve: {
          recibos: function () {
            return $scope.recibos_todos;
          },
          form_data: function () {
            return ase;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(
        function () {},
        function () {}
      );
    };
    $scope.CloseMassives = function (recibos, ase) {
      $scope.liquidacion_folio = $scope.toClose[0].id;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/comisiones/liquidate_massive.html",
        controller: liquidateMassiveSelectedModal,
        controllerAs: "vm",
        ////windowClass: 'animated fadeIn',
        size: "lg",
        // resolve:{'rn':receipt.recibo_numero,'recibo':receipt},
        resolve: {
          recibos: function () {
            return $scope.toClose;
          },
          form_data: function () {
            return $scope.liquidacion_folio;
          },
          formito: function () {
            return vm.form;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(
        function () {
          vm.aseguradoras = [];
          $scope.recibos_todos = [];
          $scope.toClose = [];
        },
        function () {
          $scope.show_providers = false;
          vm.aseguradoras = [];
          $scope.recibos_todos = [];
          $scope.toClose = [];
        }
      );
    };

    function liquidateMassiveModal(
      $timeout,
      $rootScope,
      $scope,
      $uibModalInstance,
      url,
      toaster,
      MESSAGES,
      recibos,
      form_data,
      FileUploader,
      $sessionStorage
    ) {
      $rootScope.form_data = form_data;
      $scope.recibos_todo_liq = recibos;
      var ase = form_data;
      vm = this;
      $rootScope.recibos = [];
      $scope.recibos_todo_liq.forEach(function (rec) {
        if (rec.poliza) {
          if (rec.poliza.aseguradora.id == ase.id) {
            $rootScope.recibos.push(rec);
          }
        } else if (rec.fianza) {
          if (rec.fianza.afianzadora.id == ase.id) {
            $rootScope.recibos.push(rec);
          }
        }
      });
      /** Uploader files **/
      $scope.userInfo = {
        id: 0,
      };
      $scope.countFile = 0;
      $scope.okFile = 0;
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      //     name: 'customFilter',
      //     fn: function(item, options) {
      //         return this.queue.length < 20;
      //     }
      // });
      // ALERTA SUCCES UPLOADFILES
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $scope.okFile++;
        if ($scope.okFile == $scope.countFile) {
          toaster.success("Se han adjuntado archivos a la liquidación");
          $scope.cancel();

          var params = {
            model: 19,
            event: "POST",
            associated_id: $scope.folio_conciliate,
            identifier: "liquidación masiva y se adjuntó archivo(s)",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
        }
      };
      $scope.changeSensible = function (sensible, index) {
        uploader.queue[index].formData[0].sensible = sensible;
      };

      $scope.saveFile = function (file) {
        $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });

        if (fileItem) {
          $scope.countFile++;
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        if (item.file.sensible != undefined) {
          item.formData[0].sensible = item.file.sensible;
        }
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
        item.formData[0].folio = $scope.userInfo.folio;
      };

      vm.uploadFiles = uploadFiles;
      function uploadFiles(folio) {
        $scope.userInfo = {
          id: folio,
          folio: folio,
        };
        $scope.userInfo.url = $scope.uploader.url =
          url.IP + "liquidacion/" + folio + "/archivos/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }

      $scope.liquidarTodo = function (r) {
        vm.form = {
          since: convertDate(
            new Date(new Date().setMonth(new Date().getMonth() - 3))
          ),
          until: convertDate(new Date()),
          liquidation_date: vm.form.liquidation_date,
        };

        SweetAlert.swal(
          {
            title: "Liquidar recibo(s)-",
            text: "¿Está seguro de liquidar todos recibo(s)?",
            type: "warning",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            showCancelButton: true,
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
            allowOutsideClick: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              vm.rec_to_liquidate = [];
              $scope.recibos_todo_liq.forEach(function (rec) {
                if (rec.poliza) {
                  if (rec.poliza.aseguradora.id == ase.id) {
                    vm.rec_to_liquidate.push(rec);
                  }
                } else if (rec.fianza) {
                  if (rec.fianza.afianzadora.id == ase.id) {
                    vm.rec_to_liquidate.push(rec);
                  }
                }
              });
              $scope.folio_conciliate = vm.rec_to_liquidate[0].id;

              vm.rec_to_liquidate.forEach(function (recibo) {
                patchRecibo(recibo.url, {
                  liquidacion_date: new Date(toDate(vm.form.liquidation_date)),
                  status: 5,
                  liquidacion_folio: vm.rec_to_liquidate[0].id,
                });
              });
              SweetAlert.swal(
                {
                  title: "Hecho",
                  text:
                    "Todos los recibos de la Aseguradora: " +
                    ase.alias +
                    " se han liquidado, folio de liquidación: " +
                    vm.rec_to_liquidate[0].id,
                  type: "success",
                  showCancelButton: false,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Ok",
                  cancelButtonText: "No",
                  closeOnConfirm: true,
                  closeOnCancel: false,
                },
                function (isConfirm) {
                  var folio = vm.rec_to_liquidate[0].id;
                  uploadFiles($scope.folio_conciliate);
                  // vm.rec_to_liquidate= []
                  $uibModalInstance.dismiss("cancel");
                  activate();
                  $http({
                    method: "POST",
                    url: url.IP + "get-pdf-liquidacion/",
                    data: {
                      liquidacion_folio: folio,
                      generado_por: usr["nameFull"],
                    },
                  }).then(function success(response) {
                    var file = new Blob([response.data], {
                      type: "application/pdf",
                    });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                      window.navigator.msSaveOrOpenBlob(file);
                    } else {
                      var fileURL = URL.createObjectURL(file);
                      $scope.content = $sce.trustAsResourceUrl(fileURL);
                      window.open($scope.content);
                    }
                  });
                }
              );
            } else {
            }
          }
        );
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.close(5);
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    function liquidateMassiveSelectedModal(
      formito,
      $timeout,
      $rootScope,
      $scope,
      $uibModalInstance,
      url,
      toaster,
      MESSAGES,
      recibos,
      form_data,
      FileUploader,
      $sessionStorage
    ) {
      $rootScope.form_data = form_data;
      $scope.recibos = recibos;
      var ase = form_data;
      vm = this;

      vm.form = formito;
      vm.form.liquidation_date = convertDate(new Date());
      /** Uploader files **/
      $scope.userInfo = {
        id: 0,
      };
      $scope.countFile = 0;
      $scope.okFile = 0;
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      //     name: 'customFilter',
      //     fn: function(item, options) {
      //         return this.queue.length < 20;
      //     }
      // });
      // ALERTA SUCCES UPLOADFILES
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $scope.okFile++;
        if ($scope.okFile == $scope.countFile) {
          toaster.success("Se han adjuntado archivos a la liquidación");
          $scope.cancel();

          var params = {
            model: 19,
            event: "POST",
            associated_id: $scope.liquidacion_folio,
            identifier: "liquidación masiva y se adjuntó archivo(s)",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
        }
      };
      $scope.changeSensible = function (sensible, index) {
        uploader.queue[index].formData[0].sensible = sensible;
      };

      $scope.saveFile = function (file) {
        $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });

        if (fileItem) {
          $scope.countFile++;
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        if (item.file.sensible != undefined) {
          item.formData[0].sensible = item.file.sensible;
        }
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
        item.formData[0].folio = $scope.userInfo.folio;
      };

      vm.uploadFiles = uploadFiles;
      function uploadFiles(folio) {
        $scope.userInfo = {
          id: folio,
          folio: folio,
        };
        $scope.userInfo.url = $scope.uploader.url =
          url.IP + "liquidacion/" + folio + "/archivos/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }
      $scope.liquidarTodo = function (r) {
        SweetAlert.swal(
          {
            title: "Liquidar recibo(s).",
            text: "¿Está seguro de liquidar los recibo(s)?",
            type: "warning",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            showCancelButton: true,
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
            allowOutsideClick: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              $scope.liquidacion_folio = $scope.recibos[0].id;
              $scope.recibos.forEach(function (recibo) {
                if (recibo.bono) {
                  recibo.bono = recibo.bono.url;
                }
                patchRecibo(recibo.url, {
                  liquidacion_date: new Date(toDate(vm.form.liquidation_date)),
                  status: 5,
                  liquidacion_folio: $scope.recibos[0].id,
                });
              });
              SweetAlert.swal(
                {
                  title: "Hecho",
                  text:
                    "Los recibos se han liquidado, folio de liquidacion: " +
                    $scope.recibos[0].id,
                  type: "success",
                  showCancelButton: false,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Ok",
                  cancelButtonText: "No",
                  closeOnConfirm: true,
                  closeOnCancel: false,
                },
                function (isConfirm) {
                  uploadFiles($scope.liquidacion_folio);
                  var folio = $scope.liquidacion_folio;
                  $scope.recibos = [];
                  $uibModalInstance.dismiss("cancel");
                  $http({
                    method: "POST",
                    url: url.IP + "get-pdf-liquidacion/",
                    data: {
                      liquidacion_folio: folio,
                      generado_por: usr["nameFull"],
                    },
                  }).then(function success(response) {
                    var file = new Blob([response.data], {
                      type: "application/pdf",
                    });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                      window.navigator.msSaveOrOpenBlob(file);
                    } else {
                      var fileURL = URL.createObjectURL(file);
                      $scope.content = $sce.trustAsResourceUrl(fileURL);
                      window.open($scope.content);
                    }
                  });
                }
              );
            } else {
            }
          }
        );
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          vm.aseguradoras = [];
          $scope.recibos = [];
          $uibModalInstance.close(5);
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    function receipt_exist(item, array) {
      var flag = false;
      array.forEach(function (element) {
        if (element.id == item.id) {
          flag = true;
          return;
        }
      });
      return flag;
    }
    $scope.AjustarConciliacion = function (receipt) {
      if ($scope.ajustar_conciliacion == true) {
        $scope.ajustar_conciliacion = false;
        var data = {
          comision_conciliada: parseFloat(receipt.comision_conciliada).toFixed(
            2
          ),
          status: 6,
        };
        $http({
          method: "PATCH",
          url: receipt.url,
          data: data,
        });
      } else {
        $scope.ajustar_conciliacion = true;
      }

      if (vm.form.provider != null) {
        var p = vm.form.provider.id;
      } else {
        var p = 0;
      }

      if (vm.form.ramo != null) {
        var r = vm.form.ramo.id;
      } else {
        var r = 0;
      }

      if (vm.form.subramo != null) {
        var s = vm.form.subramo.id;
      } else {
        var s = 0;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   var filter_amount_a = 'v2/claves/get-comission-amount';
      var filter_amount_a = "get-comission-amount";
      $http
        .get(
          url.IP +
            filter_amount_a +
            "/?" +
            "provider=" +
            p +
            "&" +
            "ramo=" +
            r +
            "&" +
            "subramo=" +
            s +
            "&" +
            "polizas_iniciales=" +
            vm.form.polizas_iniciales +
            "&" +
            "polizas_renovadas=" +
            vm.form.polizas_renovadas +
            "&" +
            "recibos_pagados=" +
            vm.form.recibos_pagados +
            "&" +
            "recibos_no_pagados=" +
            vm.form.recibos_no_pagados +
            "&" +
            "recibos_liquidados=" +
            vm.form.recibos_liquidados +
            "&" +
            "recibos_conciliados=" +
            vm.form.recibos_conciliados +
            "&" +
            "since=" +
            (vm.form.since + " " + "00:00:00") +
            "&" +
            "until=" +
            (vm.form.until + " " + "23:59:59") +
            "&" +
            "cve_agente=" +
            (vm.form.cve_agente ? vm.form.cve_agente : 0) +
            "&" +
            "contratante=" +
            (vm.form.contratante ? vm.form.contratante.value : 0) +
            "&" +
            "type_contractor=" +
            (vm.form.contratante ? vm.form.contratante.type : 0) +
            "&" +
            "order=" +
            1 +
            "&" +
            "asc=" +
            1 +
            "&"
        )
        .then(function success(response) {
          vm.form.total = response.data.total;
          vm.form.total_conciliado = response.data.total_conciliado;
        });
    };

    function addToClose(recibo, aseguradora) {
      if (receipt_exist(recibo, $scope.toClose)) {
        aseguradora.recibos_listos.splice(
          vm.form.recibos_listos.indexOf(recibo),
          1
        );
        // if (aseguradora.recibos_listos.length == 0){
        //   aseguradora.recibos_listos = [{
        //     'none':'none'
        //   }];
        // }
        return;
      }
      if (
        recibo.receipt_type != 1 &&
        recibo.receipt_type != 2 &&
        recibo.receipt_type != 3 &&
        recibo.receipt_type != 4
      ) {
        return;
      }
      // $scope.toClose.some(function(receipt) {
      //   if(receipt.id == recibo.id){
      //     // $scope.toClose.splice($scope.toClose.indexOf(receipt),1)
      //     return;
      //   }
      // });

      $scope.toClose.push(recibo);
      aseguradora.recibos_listos.splice(
        aseguradora.recibos_listos.indexOf(recibo),
        1
      );
      // vm.form.recibos_listos.splice(vm.form.recibos_listos.indexOf(recibo),1)
      // if (vm.aseguradoras[$scope.idxAseguradora].recibos_listos.length == 0){
      //   vm.aseguradoras[$scope.idxAseguradora].recibos_listos = [{
      //     'none':'none'
      //   }];
      // }
    }
    $scope.idxAseguradora = null;

    function DeleteToClose(recibo) {
      if (
        receipt_exist(
          recibo,
          vm.aseguradoras[$scope.idxAseguradora].recibos_listos
        )
      ) {
        $scope.toClose.splice($scope.toClose.indexOf(recibo), 1);
        vm.form.recibos_listos.some(function (item) {
          if (item["none"] == "none") {
            vm.form.recibos_listos.splice(
              vm.form.recibos_listos.indexOf(item),
              1
            );
          }
        });
        return;
      }
      // vm.form.recibos_listos.some(function(receipt) {
      //   if(receipt.id == recibo.id){
      //     return;
      //   }
      // });

      vm.aseguradoras[$scope.idxAseguradora].recibos_listos.push(recibo);
      $scope.toClose.splice($scope.toClose.indexOf(recibo), 1);

      vm.aseguradoras[$scope.idxAseguradora].recibos_listos.some(function (
        item
      ) {
        if (item["none"] == "none") {
          vm.aseguradoras[$scope.idxAseguradora].recibos_listos.splice(
            vm.aseguradoras[$scope.idxAseguradora].recibos_listos.indexOf(item),
            1
          );
        }
      });
    }

    $scope.selectExcel = function (parData) {
      $scope.strcutureData = certStructure(parData);
      treeStructure($scope.strcutureData);

      // ocultar árbol
      $scope.id_tree = true;
    };

    function treeStructure(parData) {
      var tree = [];
      // for (var key in parData) {
      //   var data = parData[key];
      //   if (data.length) {
      var data = parData;
      // checar asegurados (parents)
      var parents = [];
      $scope.suma = 0;
      $scope.suma2 = 0;
      $scope.toConciliate = [];
      // var childs = [];
      var wait = [];

      data.forEach(function (item) {
        if (
          item.inicio_vigencia_poliza == "" ||
          item.inicio_vigencia_poliza == null ||
          item.inicio_vigencia_poliza == undefined ||
          item.fin_vigencia_poliza == "" ||
          item.fin_vigencia_poliza == null ||
          item.fin_vigencia_poliza == undefined
        ) {
          SweetAlert.swal(
            "ERROR",
            "No se encontraron fechas de vigencia de poliza",
            "error"
          );
          return;
        }
        if (
          item.recibo_tipo == "" ||
          item.recibo_tipo == null ||
          item.recibo_tipo == undefined ||
          item.serie == "" ||
          item.serie == null ||
          item.serie == undefined
        ) {
          SweetAlert.swal(
            "ERROR",
            "Se encontraron datos completos en Layout",
            "error"
          );
          return;
        }

        item.inicio_vigencia = item.inicio_vigencia_poliza;
        item.fin_vigencia = item.fin_vigencia_poliza;

        $http
          .get(
            url.IP +
              "get-receipt-conciliate-data/?poliza=" +
              item.poliza +
              "&serie=" +
              item.serie +
              "&recibo_tipo=" +
              item.recibo_tipo +
              "&vigencia_i=" +
              item.inicio_vigencia +
              " " +
              "00:00:00" +
              "&vigencia_f=" +
              item.fin_vigencia +
              " " +
              "23:59:59" +
              "&" +
              "endoso=" +
              (item.endoso ? item.endoso : 0) +
              "&"
          )
          .success(function (response) {
            var comision_sistema = response;
            if (response == 404) {
              SweetAlert.swal(
                "Error",
                "Algunos recibos no fueron encontrados",
                "error"
              );
              return;
            } else if (response == "Recibo no liquidado") {
              SweetAlert.swal(
                "Error",
                "Algunos de los recibos no estan liquidados",
                "error"
              );
              return;
            }
            if (response["recibo "] == "El recibo no se puede conciliar") {
              SweetAlert.swal(
                "Error",
                "Existen recibos que no se pueden conciliar, revise los datos",
                "error"
              );
              return;
            }

            if (!comision_sistema.comision) {
              var parent_content =
                "<strong>Póliza: </strong> " +
                item.poliza +
                " - " +
                "<strong>Serie: </strong> " +
                item.serie +
                " - " +
                "<strong>Comisión capturada: </strong>" +
                item.comision +
                " | " +
                "<strong>Comisión del sistema: </strong>" +
                "Recibo no liquidado o ya conciliado";
            } else {
              $scope.toConciliate.push({
                sistema: comision_sistema,
                capturado: item,
              });
              var parent_content =
                "<strong>Póliza: </strong> " +
                item.poliza +
                " - " +
                "<strong>Serie: </strong> " +
                item.serie +
                " - " +
                "<strong>Comisión capturada: </strong>" +
                item.comision +
                " | " +
                "<strong>Comisión del sistema: </strong>" +
                comision_sistema.comision;
              $scope.suma = $scope.suma + parseFloat(item.comision);
              $scope.suma2 =
                $scope.suma2 + parseFloat(comision_sistema.comision);

              // tree.push(element);
              // tree.push({text: '<strong>Total capturado:  </strong>'+ suma.toFixed(2) + '<strong>Total del sistema:  </strong>'+ suma2.toFixed(2)})
            }
            var element = {
              text: parent_content,
            };
            tree.push(element);
            $("#tree").treeview({ data: tree });
          })
          .error(function (error) {
            console.log(error);
          });
      });
    }

    $scope.finishMassiveConciliate = function () {
      if (vm.cuenta == undefined || vm.cuenta.length == 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SELECTACCOUNT, "error");
        return;
      }
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var folio = $scope.toConciliate[0].sistema.id;
            $scope.toConciliate.forEach(function (item) {
              var data = {
                conciliacion_folio: folio,
                status: 6,
                comision_conciliada: parseFloat(
                  item.capturado.comision
                ).toFixed(2),
                conciliacion_date: new Date(item.capturado.fecha_aplicacion),
                conciliacion_observation: vm.form.massive_observation,
                conciliation_account: vm.cuenta.url,
              };
              patchRecibo(item.sistema.url, data);
            });

            SweetAlert.swal(
              "¡Listo!",
              MESSAGES.OK.RECEIPTCONCILIAR + folio,
              "success"
            );
            $scope.conciliar_masivos = false;
            $scope.suma = 0;
            $scope.suma2 = 0;
            $scope.toConciliate = [];
            vm.cuenta = [];
          } else {
            SweetAlert.swal("Cancelado", MESSAGES.ERROR.CANCELACCOUNT, "error");
          }
        }
      );
    };

    $scope.conciliar_masivo = function () {
      if ($scope.conciliar_masivos == true) {
        $scope.conciliar_masivos = false;
        $scope.toConciliate = [];
        $scope.suma = 0;
        $scope.suma2 = 0;
      } else {
        $scope.conciliar_masivos = true;
      }
    };

    function certStructure(parData) {
      var massive_data = [];
      parData["conciliacion_layout"].forEach(function (object) {
        massive_data.push(object);
      });
      return massive_data;
    }

    function massive_close() {}

    $scope.showAccount = false;
    $scope.toConciliation = false;
    $scope.arrayConciliation = [];
    $scope.addReceipt = function (receipt) {
      if (receipt.bono) {
        receipt.bono = receipt.bono.url;
      }
      var idx = $scope.arrayConciliation.indexOf(receipt);
      if (idx == -1) {
        $scope.arrayConciliation.push(receipt);
      } else {
        $scope.arrayConciliation.splice(idx, 1);
      }
      if ($scope.arrayConciliation.length == 0) {
        $scope.showAccount = false;
      }
    };

    $scope.showDataAccount = function () {
      $http.get(url.IP + "accounts/").then(function (response) {
        vm.accounts = response.data.results;
        $rootScope.acounts_data = response.data.results;
        vm.cuenta = $rootScope.acounts_data[0];
      });
      $scope.showAccount = true;
      vm.form.conciliate_date = datesFactory.convertDate(new Date());
    };
    $scope.showDataAccountTodos = function (ase) {
      vm.form.conciliate_date = datesFactory.convertDate(new Date());
      $scope.showAccount = true;
      // SweetAlert.swal("Advertencia", "La conciliación se hará sobre los recibos en la página disponible ", "warning");
      SweetAlert.swal(
        "Advertencia",
        MESSAGES.WARNING.CONCPAGEDISPON,
        "warning"
      );
      vm.aseguradora_to_conc = ase;
    };

    $scope.hideDAtaAccount = function () {
      $scope.showAccount = false;
    };

    function sinDiacriticos(texto) {
      return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    $scope.massiceConciliation = function () {
      var folio = $scope.arrayConciliation[0].id;
      var count = 0;
      var rec = 0;
      $scope.arrayConciliation.forEach(function (item) {
        var aux_pol = item.poliza ? item.poliza.id : "";
        var aux_fia = item.fianza ? item.fianza.id : "";
        var aux_bono = item.bono ? item.bono.id : "";
        // item.conciliacion_folio = folio;
        // item.conciliacion_date = toDate(vm.form.conciliate_date);
        // item.conciliation_account = vm.cuenta.url;
        // item.status = 6;
        var datar = {
          conciliacion_folio: folio,
          conciliacion_date: toDate(vm.form.conciliate_date),
          conciliation_account: vm.cuenta.url,
          comision_conciliada: parseFloat(item.comision_conciliada).toFixed(2),
          comision_conciliada_p: parseFloat(
            item.comision_conciliada_p_ok
              ? item.comision_conciliada_p_ok
              : item.comision_conciliada_p
          ).toFixed(2),
          comision_conciliada_p_estimada: item.comision_conciliada_p_estimada
            ? parseFloat(item.comision_conciliada_p_estimada).toFixed(2)
            : 0,
          rate_exchange: item.rate_exchange,
          status: 6,
        };
        if (item.receipt_type == 3) {
          // if (datar['comision_conciliada']>0){
          datar["comision_conciliada"] = parseFloat(
            onlyNumberFromString(item.comision_conciliada)
          ).toFixed(2);
          datar["comision_conciliada"] = datar["comision_conciliada"] * -1;
          // }
        } else {
          datar = datar;
        }
        // item.poliza = item.poliza ? item.poliza.url : '';
        // item.fianza = item.fianza ? item.fianza.url : '';
        item.endorsement = item.endorsement ? item.endorsement.url : "";
        $http.patch(item.url, datar).then(function success(response) {
          rec = rec + 1;
          if (response.status === 200 || response.status === 201) {
            count = count + 1;
            if (aux_pol != "") {
              var paramsRec = {
                model: 4,
                event: "POST",
                associated_id: response.data.id,
                identifier: "actualizó el recibo a conciliado.",
              };
              dataFactory
                .post("send-log/", paramsRec)
                .then(function success(response) {});
              var params = {
                model: 1,
                event: "POST",
                associated_id: aux_pol,
                identifier: "actualizó el recibo a conciliado.",
              };

              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
            } else if (aux_bono) {
              var paramsF = {
                model: 13,
                event: "POST",
                associated_id: aux_bono,
                identifier: "actualizó el recibo a conciliado.",
              };

              dataFactory
                .post("send-log/", paramsF)
                .then(function success(response) {});
            }
          }

          if (rec == $scope.arrayConciliation.length) {
            $scope.arrayConciliation = [];
            showAlert(count, rec, folio);
          }
        });
      });
    };
    $scope.massiceConciliationTodos = function (recibos) {
      var folio = recibos[0].id;
      var count = 0;
      var rec = 0;
      for (var i = 0; i < recibos.length; i++) {
        var datar = {
          conciliacion_folio: folio,
          conciliacion_date: toDate(vm.form.conciliate_date),
          conciliation_account: vm.cuenta.url,
          status: 6,
          comision_conciliada: parseFloat(
            recibos[i].comision_conciliada
          ).toFixed(),
          comision_conciliada_p: parseFloat(
            recibos[i].comision_conciliada_p_ok
          ).toFixed(),
          comision_conciliada_p_estimada: parseFloat(
            recibos[i].comision_conciliada_p_estimada
          ).toFixed(),
          rate_exchange: recibos[i].rate_exchange,
        };
        // if (recibos[i].poliza){
        //   recibos[i].conciliacion_folio = folio;
        //   recibos[i].conciliacion_date = toDate(vm.form.conciliate_date);
        //   recibos[i].conciliation_account = vm.cuenta.url;
        //   recibos[i].status = 6;
        //   // recibos[i].poliza = recibos[i].poliza.url;
        //   // recibos[i].endorsement = recibos[i].endorsement.url;
        // }else if (recibos[i].fianza){
        //   recibos[i].conciliacion_folio = folio;
        //   recibos[i].conciliacion_date = toDate(vm.form.conciliate_date);
        //   recibos[i].conciliation_account = vm.cuenta.url;
        //   recibos[i].status = 6;
        //   // recibos[i].fianza = recibos[i].fianza.url;
        // }
        $http.patch(recibos[i].url, datar).then(function success(response) {
          rec = rec + 1;
          if (response.status === 200) {
            count = count + 1;
          }

          if (rec == recibos.length) {
            recibos = [];
            showAlert(count, rec, folio);
          }
        });
      }
    };
    // ----------------
    $scope.showAlert1 = function (count, obj, folio) {
      if (count == obj) {
        activate();
        SweetAlert.swal(
          "Hecho",
          "Se han conciliado " + count + " recibos con el folio: " + folio,
          "success"
        );
        $http({
          method: "POST",
          url: url.IP + "get-pdf-conciliacion/",
          data: {
            conciliacion_folio: folio,
          },
        }).then(function success(response) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
        });
      } else {
        SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
      }
    };
    // ---------------------------
    function showAlert(count, obj, folio) {
      if (count == obj) {
        SweetAlert.swal(
          "Hecho",
          "Se han conciliado " + count + " recibos con el folio: " + folio,
          "success"
        );
        $http({
          method: "POST",
          url: url.IP + "get-pdf-conciliacion/",
          data: {
            conciliacion_folio: folio,
          },
        }).then(function success(response) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
        });
      } else {
        SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
      }
      process_comission();
    }

    function getPendientes() {
      // vm.show_receipt_info = false;
      // vm.conciliar = false;
      if (vm.form.provider != null) {
        var p = vm.form.provider.id;
      } else {
        var p = 0;
      }

      if (vm.form.ramo != null) {
        var r = vm.form.ramo.id;
      } else {
        var r = 0;
      }

      if (vm.form.subramo != null) {
        var s = vm.form.subramo.id;
      } else {
        var s = 0;
      }

      vm.form.receipt_pagination = false;

      $http
        .get(
          url.IP +
            "get-comissions-conciliate/?" +
            "provider=" +
            p +
            "&" +
            "ramo=" +
            r +
            "&" +
            "subramo=" +
            s +
            "&" +
            "polizas_iniciales=" +
            vm.form.polizas_iniciales +
            "&" +
            "polizas_renovadas=" +
            vm.form.polizas_renovadas +
            "&" +
            "recibos_pagados=" +
            vm.form.recibos_pagados +
            "&" +
            "recibos_no_pagados=" +
            vm.form.recibos_no_pagados +
            "&" +
            "recibos_liquidados=" +
            vm.form.recibos_liquidados +
            "&" +
            "recibos_conciliados=" +
            vm.form.recibos_conciliados +
            "&" +
            "since=" +
            (vm.form.since + " " + "00:00:00") +
            "&" +
            "until=" +
            (vm.form.until + " " + "23:59:59") +
            "&" +
            "report_by=" +
            (vm.form.dates_sel ? vm.form.dates_sel.id : 0) +
            "&"
        )
        .success(function (response) {
          vm.form.recibos_listos = response.results;
          vm.form.recibos_config = {
            count: response.count,
            next: response.next,
            previous: response.previous,
          };

          vm.form.receipt_pagination = true;
        })
        .error(function (response) {
          // body...
        })
        .catch(function (response) {
          // body...
        });

      // $http.get(url.IP + 'get-comission-conciliate-amount/?'+
      //   'provider='+p +'&'+
      //   'ramo='+r+'&'+
      //   'subramo='+ s +'&'+
      //   'polizas_iniciales=' +vm.form.polizas_iniciales+'&'+
      //   'polizas_renovadas='+ vm.form.polizas_renovadas+'&'+
      //   'recibos_pagados=' + vm.form.recibos_pagados+'&'+
      //   'recibos_no_pagados='+ vm.form.recibos_no_pagados+'&'+
      //   'recibos_liquidados='+ vm.form.recibos_liquidados+'&'+
      //   'recibos_conciliados='+ vm.form.recibos_conciliados+'&'+
      //   'since=' + (vm.form.since)+'&'+
      //   'until=' +(vm.form.until)+'&'
      //    ).then(function success(response) {
      //      vm.form.total = response.data.total
      //      vm.form.total_conciliado = response.data.total_conciliado
      //    })
    }

    // function enableConciliacion(numero){

    // }

    function enableConciliacion(numero, val) {
      if (vm.aseguradoras && vm.aseguradoras.length > 0) {
        vm.aseguradoras = [];
      }
      if (vm.form.recibos_conciliados && numero == 2) {
        vm.form.recibos_pagados = false;
        vm.form.recibos_no_pagados = false;
        vm.form.recibos_liquidados = false;
        vm.form.recibos_conciliados = val;
      } else {
        vm.form.recibos_conciliados = false;
      }
      if (numero == 1) {
        $scope.liquidarTodos = true;
        vm.form.recibos_pagados = val;
      } else {
        $scope.liquidarTodos = false;
      }
      if (numero == 4) {
        vm.form.recibos_liquidados = val;
        $scope.conciliateTodos = true;
      } else {
        $scope.conciliateTodos = false;
      }
      if (numero == 3) {
        vm.form.recibos_no_pagados = val;
      }
    }

    $scope.paginationNew = function () {};

    function activate() {
      getProviders();
      $http.get(url.IP + "accounts/").then(function (response) {
        vm.accounts = response.data.results;
        $rootScope.acounts_data = response.data.results;
        vm.cuenta = $rootScope.acounts_data[0];
      });

      vm.form = {
        contratante:
          $localStorage.saved_filters_comisiones &&
          $localStorage.saved_filters_comisiones["contratante"]
            ? $localStorage.saved_filters_comisiones["contratante"]
            : "",
        provider:
          $localStorage.saved_filters_comisiones &&
          $localStorage.saved_filters_comisiones["Provedor"]
            ? $localStorage.saved_filters_comisiones["Provedor"]
            : 0,
        cve_agente:
          $localStorage.saved_filters_comisiones &&
          $localStorage.saved_filters_comisiones["cve_agente"]
            ? $localStorage.saved_filters_comisiones["cve_agente"]
            : "",
        dates_sel:
          $localStorage.saved_filters_comisiones &&
          $localStorage.saved_filters_comisiones["dates_sel"]
            ? $localStorage.saved_filters_comisiones["dates_sel"]
            : 0,
        polizas_iniciales:
          $localStorage.saved_filters_comisiones &&
          $localStorage.saved_filters_comisiones["polizas_iniciales"]
            ? $localStorage.saved_filters_comisiones["polizas_iniciales"]
            : true,
        polizas_renovadas:
          $localStorage.saved_filters_comisiones &&
          $localStorage.saved_filters_comisiones["polizas_renovadas"]
            ? $localStorage.saved_filters_comisiones["polizas_renovadas"]
            : true,
        recibos_pagados:
          $localStorage.saved_filters_comisiones &&
          $localStorage.saved_filters_comisiones["recibos_pagados"]
            ? $localStorage.saved_filters_comisiones["recibos_pagados"]
            : false,
        recibos_no_pagados:
          $localStorage.saved_filters_comisiones &&
          $localStorage.saved_filters_comisiones["recibos_no_pagados"]
            ? $localStorage.saved_filters_comisiones["recibos_no_pagados"]
            : false,
        recibos_liquidados:
          $localStorage.saved_filters_comisiones &&
          $localStorage.saved_filters_comisiones["recibos_liquidados"]
            ? $localStorage.saved_filters_comisiones["recibos_liquidados"]
            : true,
        recibos_conciliados:
          $localStorage.saved_filters_comisiones &&
          $localStorage.saved_filters_comisiones["recibos_conciliados"]
            ? $localStorage.saved_filters_comisiones["recibos_conciliados"]
            : false,
        since: convertDate(
          new Date(new Date().setMonth(new Date().getMonth() - 3))
        ),
        until: convertDate(new Date()),
      };

      if ($localStorage.saved_filters_comisiones) {
        if ($localStorage.saved_filters_comisiones["dates_sel"]) {
          $scope.dates_selected = true;
        }
      }
    }

    $scope.show_providers = false;
    function getProviders() {
      providerService.getReadListProviders().then(function (data) {
        vm.providers = data;
      });
    }
    // prueba aseguradora______
    $scope.selectProvider = function (aseguradora, idx, order, asc) {
      $scope.aseg_selected = aseguradora;
      $scope.order_s = order;
      $scope.asc_s = asc;
      $scope.idx_selected = idx;
      $scope.idxAseguradora = idx;
      vm.form.recibos_listos = aseguradora.recibos_listos;
      vm.buttonReport = true;
      vm.show_receipt_info = false;
      $scope.ajustar_conciliacion = false;
      vm.conciliar = false;
      if (vm.form.provider != null) {
        var p = vm.form.provider.id;
      } else {
        var p = 0;
      }

      if (vm.form.ramo != null) {
        var r = vm.form.ramo.id;
      } else {
        var r = 0;
      }

      if (vm.form.subramo != null) {
        var s = vm.form.subramo.id;
      } else {
        var s = 0;
      }

      vm.form.receipt_pagination = false;
      // if((vm.form.since) <= (vm.form.until)){
      // vm.form.since = vm.form.since+ " " + "00:00:00";
      // vm.form.until = vm.form.until+ " " + "23:59:59";

      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   var filter_comission_p = 'v2/claves/get-comissions';
      var filter_comission_p = "get-comissions";
      $http
        .get(
          url.IP +
            filter_comission_p +
            "/?" +
            "provider=" +
            aseguradora.id +
            "&" +
            "ramo=" +
            r +
            "&" +
            "subramo=" +
            s +
            "&" +
            "polizas_iniciales=" +
            vm.form.polizas_iniciales +
            "&" +
            "polizas_renovadas=" +
            vm.form.polizas_renovadas +
            "&" +
            "recibos_pagados=" +
            vm.form.recibos_pagados +
            "&" +
            "recibos_no_pagados=" +
            vm.form.recibos_no_pagados +
            "&" +
            "recibos_liquidados=" +
            vm.form.recibos_liquidados +
            "&" +
            "recibos_conciliados=" +
            vm.form.recibos_conciliados +
            "&" +
            "since=" +
            (vm.form.since + " " + "00:00:00") +
            "&" +
            "until=" +
            (vm.form.until + " " + "23:59:59") +
            "&" +
            "contratante=" +
            (vm.form.contratante ? vm.form.contratante.value : 0) +
            "&" +
            "type_contractor=" +
            (vm.form.contratante ? vm.form.contratante.type : 0) +
            "&" +
            "cve_agente=" +
            (vm.form.cve_agente ? vm.form.cve_agente : 0) +
            "&" +
            "report_by=" +
            (vm.form.dates_sel ? vm.form.dates_sel.id : 0) +
            "&" +
            "order=" +
            (order ? order : 0) +
            "&" +
            "asc=" +
            (asc ? asc : 0) +
            "&"
        )
        .success(function (response) {
          aseguradora.recibos_listos = response.results;
          for (var i = 0; i < aseguradora.recibos_listos.length; i++) {
            aseguradora.recibos_listos[i].comision_conciliada =
              aseguradora.recibos_listos[i].comision_conciliada;
            aseguradora.recibos_listos[i].comision_conciliada_p_estimada =
              aseguradora.recibos_listos[i].poliza.comision_percent;
            if (aseguradora.recibos_listos[i].poliza.f_currency == 1) {
              aseguradora.recibos_listos[i].rate_exchange = 1;
            } else {
              aseguradora.recibos_listos[i].rate_exchange = aseguradora
                .recibos_listos[i].rate_exchange
                ? parseFloat(
                    aseguradora.recibos_listos[i].rate_exchange
                  ).toFixed(2)
                : 1;
            }
            if (aseguradora.recibos_listos[i].status == "Liquidado") {
              aseguradora.recibos_listos[i].comision_conciliada =
                aseguradora.recibos_listos[i].comision;
              aseguradora.recibos_listos[i].comision_conciliada_p = parseFloat(
                aseguradora.recibos_listos[i].comision_conciliada_p_estimada
                  ? aseguradora.recibos_listos[i].comision_conciliada_p_estimada
                  : 0
              );
              aseguradora.recibos_listos[i].comision_conciliada_p_ok =
                parseFloat(
                  aseguradora.recibos_listos[i].comision_conciliada_p_estimada
                    ? aseguradora.recibos_listos[i]
                        .comision_conciliada_p_estimada
                    : 0
                );
              if (
                aseguradora.recibos_listos[i] &&
                aseguradora.recibos_listos[i].poliza &&
                parseInt(
                  aseguradora.recibos_listos[i].poliza.comision_rpf_percent
                ) == 0 &&
                parseInt(
                  aseguradora.recibos_listos[i].poliza.comision_derecho_percent
                ) == 0
              ) {
                if (
                  parseFloat(aseguradora.recibos_listos[i].prima_neta).toFixed(
                    2
                  ) == 0.0
                ) {
                  aseguradora.recibos_listos[i].comision_conciliada_p =
                    parseFloat(0).toFixed(2);
                  aseguradora.recibos_listos[i].comision_conciliada_p_ok =
                    parseFloat(0).toFixed(2);
                } else {
                  $scope.division = parseFloat(
                    parseFloat(
                      parseFloat(
                        aseguradora.recibos_listos[i].prima_neta *
                          parseFloat(
                            aseguradora.recibos_listos[i].rate_exchange
                          )
                      )
                    ) / 100
                  ).toFixed(2);
                  aseguradora.recibos_listos[i].comision_conciliada_p =
                    parseFloat(
                      parseFloat(
                        aseguradora.recibos_listos[i].comision_conciliada
                      ) / parseFloat($scope.division)
                    ).toFixed(2);
                  if (
                    isFinite(
                      aseguradora.recibos_listos[i].comision_conciliada_p
                    ) == false
                  ) {
                    aseguradora.recibos_listos[i].comision_conciliada_p = 0;
                    aseguradora.recibos_listos[i].comision_conciliada_p_ok = 0;
                  }
                }
              } else {
                var recibo_comision = aseguradora.recibos_listos[i].comision;
                var comision_conciliada = parseFloat(
                  aseguradora.recibos_listos[i].comision_conciliada
                );
                var rate_exchange = parseFloat(
                  aseguradora.recibos_listos[i].rate_exchange
                );
                recibo_comision =
                  aseguradora.recibos_listos[i].comision *
                  (rate_exchange ? rate_exchange : 1);
                if (
                  parseFloat(comision_conciliada).toFixed(1) <
                  parseFloat(recibo_comision).toFixed(1)
                ) {
                  aseguradora.recibos_listos[i].comision_conciliada_p = "⬇️";
                }
                if (
                  parseFloat(comision_conciliada).toFixed(1) >
                  parseFloat(recibo_comision).toFixed(1)
                ) {
                  aseguradora.recibos_listos[i].comision_conciliada_p = "⬆️";
                }
                if (
                  parseFloat(recibo_comision).toFixed(1) ==
                  parseFloat(comision_conciliada).toFixed(1)
                ) {
                  aseguradora.recibos_listos[i].comision_conciliada_p = "✔";
                }
                // comision_conciliada_p_ok for use to save
                if (
                  parseFloat(aseguradora.recibos_listos[i].prima_neta).toFixed(
                    2
                  ) == 0.0
                ) {
                  aseguradora.recibos_listos[i].comision_conciliada_p_ok =
                    parseFloat(0).toFixed(2);
                } else {
                  $scope.division = parseFloat(
                    parseFloat(
                      parseFloat(
                        aseguradora.recibos_listos[i].prima_neta *
                          parseFloat(
                            aseguradora.recibos_listos[i].rate_exchange
                          )
                      )
                    ) / 100
                  ).toFixed(2);
                  aseguradora.recibos_listos[i].comision_conciliada_p_ok =
                    parseFloat(
                      parseFloat(
                        aseguradora.recibos_listos[i].comision_conciliada
                      ) / parseFloat($scope.division)
                    ).toFixed(2);
                  if (
                    isFinite(
                      aseguradora.recibos_listos[i].comision_conciliada_p_ok
                    ) == false
                  ) {
                    aseguradora.recibos_listos[i].comision_conciliada_p_ok = 0;
                  }
                }
              }
              //
            }
          }
          aseguradora.recibos_config = {
            count: response.count,
            next: response.next,
            previous: response.previous,
          };

          vm.form.receipt_pagination = true;
        })
        .error(function (response) {
          // body...
        })
        .catch(function (response) {
          // body...
        });
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   var filter_amount_p = 'v2/claves/get-comission-amount';
      var filter_amount_p = "get-comission-amount";
      $http
        .get(
          url.IP +
            filter_amount_p +
            "/?" +
            "provider=" +
            aseguradora.id +
            "&" +
            "ramo=" +
            r +
            "&" +
            "subramo=" +
            s +
            "&" +
            "polizas_iniciales=" +
            vm.form.polizas_iniciales +
            "&" +
            "polizas_renovadas=" +
            vm.form.polizas_renovadas +
            "&" +
            "recibos_pagados=" +
            vm.form.recibos_pagados +
            "&" +
            "recibos_no_pagados=" +
            vm.form.recibos_no_pagados +
            "&" +
            "recibos_liquidados=" +
            vm.form.recibos_liquidados +
            "&" +
            "recibos_conciliados=" +
            vm.form.recibos_conciliados +
            "&" +
            "since=" +
            (vm.form.since + " " + "00:00:00") +
            "&" +
            "until=" +
            (vm.form.until + " " + "23:59:59") +
            "&" +
            "contratante=" +
            (vm.form.contratante ? vm.form.contratante.value : 0) +
            "&" +
            "type_contractor=" +
            (vm.form.contratante ? vm.form.contratante.type : 0) +
            "&" +
            "cve_agente=" +
            (vm.form.cve_agente ? vm.form.cve_agente : 0) +
            "&" +
            "report_by=" +
            (vm.form.dates_sel ? vm.form.dates_sel.id : 0) +
            "&" +
            "order=" +
            (order ? order : 0) +
            "&" +
            "asc=" +
            (asc ? asc : 0) +
            "&"
        )
        .then(function success(response) {
          aseguradora.total = response.data.total;
          aseguradora.total_conciliado = response.data.total_conciliado;
        });
    };

    // prueba aseguradoraaaaaaaaaaaaa
    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;
      if (parWord) {
        if (parWord.length >= 3) {
          if (parType) {
            var word_data = parWord.val;
            parWord = parWord.val;
          } else {
            var word_data = vm.form.contratante.val;
          }
        }
      } else {
        if (vm.form.contratante) {
          if (vm.form.contratante.value) {
            vm.form.contratante.value = 0;
          }
          if (vm.form.contratante.type) {
            vm.form.contratante.type = 0;
          }
        }
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   var filter_contractor = 'v2/contratantes/contractors-match/';
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type: item.type_person == "Física" ? 1 : 2,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type: item.type_person == "Física" ? 1 : 2,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }
    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        return;
      }
      $http.get(url.IP + "ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.ramos = ramos.data;
      });
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        return;
      }
      try {
        vm.subramos = obj.subramo_ramo;
      } catch (e) {}
    }

    function changeSubRamo(obj) {
      vm.form.subramo = obj;
    }

    vm.buttonReport = false;

    function process_comission(order, asc) {
      $scope.arrayConciliation = [];
      vm.aseguradoras = [];
      $scope.recibos_todos = [];
      $scope.toClose = [];
      vm.buttonReport = true;
      vm.show_receipt_info = false;
      $scope.ajustar_conciliacion = false;
      vm.conciliar = false;
      if (vm.form) {
        if (vm.form.provider != null) {
          var p = vm.form.provider.id;
        } else {
          var p = 0;
        }
      } else {
        var p = 0;
      }

      if (!p) {
        p = 0;
      }

      if (vm.form.ramo != null) {
        var r = vm.form.ramo.id;
      } else {
        var r = 0;
      }

      if (vm.form.subramo != null) {
        var s = vm.form.subramo.id;
      } else {
        var s = 0;
      }

      vm.form.receipt_pagination = false;
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   var filter_provider = 'v2/claves/get-comissions-aseguradoras';
      var filter_provider = "get-comissions-aseguradoras";
      $http
        .get(
          url.IP +
            filter_provider +
            "/?" +
            "provider=" +
            p +
            "&" +
            "ramo=" +
            r +
            "&" +
            "subramo=" +
            s +
            "&" +
            "polizas_iniciales=" +
            vm.form.polizas_iniciales +
            "&" +
            "polizas_renovadas=" +
            vm.form.polizas_renovadas +
            "&" +
            "recibos_pagados=" +
            vm.form.recibos_pagados +
            "&" +
            "recibos_no_pagados=" +
            vm.form.recibos_no_pagados +
            "&" +
            "recibos_liquidados=" +
            vm.form.recibos_liquidados +
            "&" +
            "recibos_conciliados=" +
            vm.form.recibos_conciliados +
            "&" +
            "since=" +
            (vm.form.since + " " + "00:00:00") +
            "&" +
            "until=" +
            (vm.form.until + " " + "23:59:59") +
            "&" +
            "contratante=" +
            (vm.form.contratante ? vm.form.contratante.value : 0) +
            "&" +
            "type_contractor=" +
            (vm.form.contratante ? vm.form.contratante.type : 0) +
            "&" +
            "cve_agente=" +
            (vm.form.cve_agente ? vm.form.cve_agente : 0) +
            "&" +
            "report_by=" +
            (vm.form.dates_sel ? vm.form.dates_sel.id : 0) +
            "&" +
            "order=" +
            (order ? order : 0) +
            "&" +
            "asc=" +
            (asc ? asc : 0) +
            "&"
        )
        .success(function (response) {
          if (response) {
            $scope.show_providers = true;
            vm.aseguradoras = response.providers ? response.providers : [];
            $scope.recibos_todos = response.results ? response.results : [];
          }
        })
        .error(function (response) {
          // body...
        })
        .catch(function (response) {
          // body...
        });
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   var filter_amount = 'v2/claves/get-comission-amount';
      var filter_amount = "get-comission-amount";
      $http
        .get(
          url.IP +
            filter_amount +
            "/?" +
            "provider=" +
            p +
            "&" +
            "ramo=" +
            r +
            "&" +
            "subramo=" +
            s +
            "&" +
            "polizas_iniciales=" +
            vm.form.polizas_iniciales +
            "&" +
            "polizas_renovadas=" +
            vm.form.polizas_renovadas +
            "&" +
            "recibos_pagados=" +
            vm.form.recibos_pagados +
            "&" +
            "recibos_no_pagados=" +
            vm.form.recibos_no_pagados +
            "&" +
            "recibos_liquidados=" +
            vm.form.recibos_liquidados +
            "&" +
            "recibos_conciliados=" +
            vm.form.recibos_conciliados +
            "&" +
            "since=" +
            (vm.form.since + " " + "00:00:00") +
            "&" +
            "until=" +
            (vm.form.until + " " + "23:59:59") +
            "&" +
            "contratante=" +
            (vm.form.contratante ? vm.form.contratante.value : 0) +
            "&" +
            "type_contractor=" +
            (vm.form.contratante ? vm.form.contratante.type : 0) +
            "&" +
            "cve_agente=" +
            (vm.form.cve_agente ? vm.form.cve_agente : 0) +
            "&" +
            "report_by=" +
            (vm.form.dates_sel ? vm.form.dates_sel.id : 0) +
            "&" +
            "order=" +
            (order ? order : 0) +
            "&" +
            "asc=" +
            (asc ? asc : 0) +
            "&"
        )
        .then(function success(response) {
          if (response) {
            vm.form.total = response.data.total;
            vm.form.total_conciliado = response.data.total_conciliado;
          }
        });

      $localStorage.saved_filters_comisiones = angular.copy(vm.form);
      $localStorage.saved_filters_comisiones["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_comisiones["Provedor"] = vm.form.provider;
      $localStorage.saved_filters_comisiones["cve_agente"] = vm.form.cve_agente;
      $localStorage.saved_filters_comisiones["dates_sel"] = vm.form.dates_sel;
      $localStorage.saved_filters_comisiones["polizas_iniciales"] =
        vm.form.polizas_iniciales;
      $localStorage.saved_filters_comisiones["polizas_renovadas"] =
        vm.form.polizas_renovadas;
      $localStorage.saved_filters_comisiones["recibos_pagados"] =
        vm.form.recibos_pagados;
      $localStorage.saved_filters_comisiones["recibos_no_pagados"] =
        vm.form.recibos_no_pagados;
      $localStorage.saved_filters_comisiones["recibos_liquidados"] =
        vm.form.recibos_liquidados;
      $localStorage.saved_filters_comisiones["recibos_conciliados"] =
        vm.form.recibos_conciliados;
    }

    $scope.exportData = function (param, aseguradora) {
      if (param == 1) {
        if (vm.form.provider != null) {
          var p = vm.form.provider.id;
        } else {
          var p = 0;
        }

        if (vm.form.ramo != null) {
          var r = vm.form.ramo.id;
        } else {
          var r = 0;
        }

        if (vm.form.subramo != null) {
          var s = vm.form.subramo.id;
        } else {
          var s = 0;
        }
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   // var excel_comission = 'v2/claves/reporte-comision/';
        //   var excel_comission = 'service_reporte-v2-comision-excel';
        var excel_comission = "service_reporte-comision-excel";
        $http({
          method: "GET",
          url:
            url.IP +
            excel_comission +
            "?" +
            "provider=" +
            aseguradora.id +
            "&" +
            "ramo=" +
            r +
            "&" +
            "subramo=" +
            s +
            "&" +
            "polizas_iniciales=" +
            vm.form.polizas_iniciales +
            "&" +
            "polizas_renovadas=" +
            vm.form.polizas_renovadas +
            "&" +
            "recibos_pagados=" +
            vm.form.recibos_pagados +
            "&" +
            "recibos_no_pagados=" +
            vm.form.recibos_no_pagados +
            "&" +
            "recibos_liquidados=" +
            vm.form.recibos_liquidados +
            "&" +
            "recibos_conciliados=" +
            vm.form.recibos_conciliados +
            "&" +
            "since=" +
            (vm.form.since + " " + "00:00:00") +
            "&" +
            "until=" +
            (vm.form.until + " " + "23:59:59") +
            "&" +
            "contratante=" +
            (vm.form.contratante ? vm.form.contratante.value : 0) +
            "&" +
            "type_contractor=" +
            (vm.form.contratante ? vm.form.contratante.type : 0) +
            "&" +
            "cve_agente=" +
            (vm.form.cve_agente ? vm.form.cve_agente : 0) +
            "&" +
            "order=" +
            ($scope.order_s ? $scope.order_s : 0) +
            "&" +
            "asc=" +
            ($scope.asc_s ? $scope.asc_s : 0) +
            "&",
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
          .then(function (data) {
            if (data.status == 200) {
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Comisiones.xls");
            } else {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.ERRORDOWNLOADREP,
                "error"
              );
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    function returnToList() {
      // vm.conciliar = false;
      // vm.show_receipt_info = false;
      $scope.ajustar_conciliacion = false;
      vm.recibos_actual = [];
    }

    $scope.boton_liquidado = false;
    $scope.boton_pagado = false;

    function editRecibo(receipt) {
      vm.conciliar = true;
      // vm.show_receipt_info = true;
      vm.comision_conciliada = receipt.comision_conciliada;
      if (receipt.status == "Conciliado") {
        $scope.boton_liquidado = false;
        $scope.boton_pagado = false;
      }

      if (receipt.status == "Liquidado") {
        $scope.boton_liquidado = true;
        $scope.boton_pagado = false;
      }

      if (receipt.status == "Pagado") {
        $scope.boton_pagado = true;
        $scope.boton_liquidado = false;
      }

      vm.recibos_actual = [receipt];
      vm.form.comision_conciliada = parseFloat(vm.recibos_actual[0].comision);
      if (receipt.poliza) {
        var value = receipt.poliza;
        var type = 1;
      } else if (receipt.fianza) {
        var value = receipt.fianza;
        var type = 2;
      } else if (receipt.bono) {
        var value = receipt.bono;
        var type = 3;
      }
      insuranceService.getInsuranceRead(value, type).then(
        function success(data) {
          vm.myPolicy = data;

          // TRAE INFORMACIÓN DEL CONTRATANTE
          var idContratante = null;
          var dat = {};
          if (vm.myPolicy.contractor) {
            idContratante = vm.myPolicy.contractor;
            dat.type = 0;
            dat.contratanteId = idContratante;
          }

          if (type == 1) {
            ContratanteService.getContratante(dat).then(
              function success(request) {
                vm.contratante = request;
                vm.addressContratante = request.address_contractor[0];
              },
              function error(err) {
                console.log("err - contratante");
              }
            );
          } else {
            vm.contratante = data.contractor ? data.contractor : null;
            vm.addressContratante = vm.contratante.address_contractor
              ? vm.contratante.address_contractor[0]
              : "";
          }
        },
        function error(error) {
          console.log("Error - poliza", error);
        }
      );

      // updateReceiptStatus();
      try {
        if ($localStorage.receiptUpdated) {
          if (
            $localStorage.receiptUpdated.id == vm.idFReceiptFound &&
            $localStorage.receiptModified == true
          ) {
            vm.pago_recibo_actual[0].status =
              $localStorage.receiptUpdated.status;
          }
        }
      } catch (err) {
        console.log(err);
      }
    }

    function onlyNumberFromString(string) {
      return parseFloat(string.match(/\d+(\.\d+)?/g));
    }
    $scope.validateComisionTable = function (aseg, item, idx) {
      for (var i = 0; i < vm.aseguradoras.length; i++) {
        if (vm.aseguradoras[i].id == aseg.id) {
          // vm.aseguradoras[i].recibos_listos[idx].comision_conciliada = (vm.aseguradoras[i].recibos_listos[idx].comision_conciliada).toFixed(2);
          aseg.recibos_listos[idx].comision_conciliada = item.toString();
        }
      }
    };

    $scope.validateComision = function (item) {
      if (item) {
        if (parseFloat(item) < 0) {
          vm.form.comision_conciliada = 0;
        } else {
          vm.form.comision_conciliada = vm.form.comision_conciliada.toString();
        }
      }
    };

    $scope.validateComisionTableEstimada = function (aseg, item, idx, tipo) {
      for (var i = 0; i < vm.aseguradoras.length; i++) {
        if (aseg.id == aseg.id) {
          if (tipo == 3) {
            //tipo de cambio
            if (
              aseg.recibos_listos[idx] &&
              aseg.recibos_listos[idx].poliza &&
              parseInt(aseg.recibos_listos[idx].poliza.comision_rpf_percent) ==
                0 &&
              parseInt(
                aseg.recibos_listos[idx].poliza.comision_derecho_percent
              ) == 0
            ) {
              if (
                parseFloat(aseg.recibos_listos[idx].prima_neta).toFixed(2) == 0
              ) {
                aseg.recibos_listos[idx].comision_conciliada_p = 0;
                aseg.recibos_listos[idx].comision_conciliada_p_ok = 0;
              } else {
                $scope.division = parseFloat(
                  parseFloat(
                    parseFloat(
                      aseg.recibos_listos[idx].prima_neta *
                        parseFloat(aseg.recibos_listos[idx].rate_exchange)
                    )
                  ) / 100
                ).toFixed(2);
                aseg.recibos_listos[idx].comision_conciliada_p = parseFloat(
                  parseFloat(
                    aseg.recibos_listos[idx].comision_conciliada
                      ? aseg.recibos_listos[idx].comision_conciliada
                      : 0
                  ) / parseFloat($scope.division)
                ).toFixed(2);
                if (
                  isFinite(aseg.recibos_listos[idx].comision_conciliada_p) ==
                  false
                ) {
                  aseg.recibos_listos[idx].comision_conciliada_p = 0;
                  aseg.recibos_listos[idx].comision_conciliada_p_ok = 0;
                }
              }
            } else {
              var recibo_comision = aseg.recibos_listos[idx].comision;
              var comision_conciliada = parseFloat(
                aseg.recibos_listos[idx].comision_conciliada
              );
              if (
                aseg.recibos_listos[idx] &&
                aseg.recibos_listos[idx].poliza &&
                aseg.recibos_listos[idx].poliza &&
                aseg.recibos_listos[idx].poliza.f_currency != 1
              ) {
                var rate_exchange = parseFloat(
                  aseg.recibos_listos[idx].rate_exchange
                );
                recibo_comision =
                  aseg.recibos_listos[idx].comision * rate_exchange;
              }
              if (
                parseFloat(comision_conciliada).toFixed(1) <
                parseFloat(recibo_comision).toFixed(1)
              ) {
                aseg.recibos_listos[idx].comision_conciliada_p = "⬇️";
              }
              if (
                parseFloat(comision_conciliada).toFixed(1) >
                parseFloat(recibo_comision).toFixed(1)
              ) {
                aseg.recibos_listos[idx].comision_conciliada_p = "⬆️";
              }
              if (
                parseFloat(recibo_comision).toFixed(1) ==
                parseFloat(comision_conciliada).toFixed(1)
              ) {
                aseg.recibos_listos[idx].comision_conciliada_p = "✔";
              }
            }
            if (
              parseFloat(aseg.recibos_listos[idx].prima_neta).toFixed(2) == 0
            ) {
              aseg.recibos_listos[idx].comision_conciliada_p_ok = 0;
            } else {
              $scope.division = parseFloat(
                parseFloat(
                  parseFloat(
                    aseg.recibos_listos[idx].prima_neta *
                      parseFloat(aseg.recibos_listos[idx].rate_exchange)
                  )
                ) / 100
              ).toFixed(2);
              aseg.recibos_listos[idx].comision_conciliada_p_ok = parseFloat(
                parseFloat(
                  aseg.recibos_listos[idx].comision_conciliada
                    ? aseg.recibos_listos[idx].comision_conciliada
                    : 0
                ) / parseFloat($scope.division)
              ).toFixed(2);
              if (
                isFinite(aseg.recibos_listos[idx].comision_conciliada_p_ok) ==
                false
              ) {
                aseg.recibos_listos[idx].comision_conciliada_p_ok = 0;
              }
            }
          }
          if (tipo == 2) {
            // -------------------------------------
            if (
              aseg.recibos_listos[idx] &&
              aseg.recibos_listos[idx].poliza &&
              parseInt(aseg.recibos_listos[idx].poliza.comision_rpf_percent) ==
                0 &&
              parseInt(
                aseg.recibos_listos[idx].poliza.comision_derecho_percent
              ) == 0
            ) {
              if (
                parseFloat(aseg.recibos_listos[idx].prima_neta).toFixed(2) ==
                0.0
              ) {
                aseg.recibos_listos[idx].comision_conciliada_p =
                  parseFloat(0).toFixed(2);
                aseg.recibos_listos[idx].comision_conciliada_p_ok =
                  parseFloat(0).toFixed(2);
              } else {
                $scope.division = parseFloat(
                  parseFloat(
                    parseFloat(
                      aseg.recibos_listos[idx].prima_neta *
                        parseFloat(aseg.recibos_listos[idx].rate_exchange)
                    )
                  ) / 100
                ).toFixed(2);
                aseg.recibos_listos[idx].comision_conciliada_p = parseFloat(
                  parseFloat(aseg.recibos_listos[idx].comision_conciliada) /
                    parseFloat($scope.division)
                ).toFixed(2);
                if (
                  isFinite(aseg.recibos_listos[idx].comision_conciliada_p) ==
                  false
                ) {
                  aseg.recibos_listos[idx].comision_conciliada_p = 0;
                  aseg.recibos_listos[idx].comision_conciliada_p_ok = 0;
                }
              }
            } else {
              // var sumapercents = parseInt(aseg.recibos_listos[idx].poliza.comision_rpf_percent)+parseInt(aseg.recibos_listos[idx].poliza.comision_derecho_percent)+parseInt(aseg.recibos_listos[idx].poliza.comision_percent)
              // $scope.division = parseFloat(parseFloat(parseFloat(aseg.recibos_listos[idx].prima_neta * parseFloat(aseg.recibos_listos[idx].rate_exchange)))/100).toFixed(2)
              // var calculo = parseFloat(parseFloat(aseg.recibos_listos[idx].comision_conciliada) / parseFloat($scope.division)).toFixed(2)
              // // RF4564545
              // console.log('cccccccccccc',calculo,aseg.recibos_listos[idx])
              // if(parseFloat(calculo) < parseFloat(aseg.recibos_listos[idx].comision_conciliada_p_estimada)){
              //   aseg.recibos_listos[idx].comision_conciliada_p='⬇️'
              // }
              // if(parseFloat(calculo) > parseFloat(aseg.recibos_listos[idx].comision_conciliada_p_estimada)){
              //   aseg.recibos_listos[idx].comision_conciliada_p='⬆️'
              // }
              // if(parseFloat(calculo) == parseFloat(aseg.recibos_listos[idx].comision_conciliada_p_estimada)){
              //   aseg.recibos_listos[idx].comision_conciliada_p='✔'
              // }
              // if(isFinite(calculo) ==false){
              //   aseg.recibos_listos[idx].comision_conciliada_p=0
              // }

              var recibo_comision = aseg.recibos_listos[idx].comision;
              var comision_conciliada = parseFloat(
                aseg.recibos_listos[idx].comision_conciliada
              );
              if (
                aseg.recibos_listos[idx] &&
                aseg.recibos_listos[idx].poliza &&
                aseg.recibos_listos[idx].poliza &&
                aseg.recibos_listos[idx].poliza.f_currency != 1
              ) {
                var rate_exchange = parseFloat(
                  aseg.recibos_listos[idx].rate_exchange
                );
                recibo_comision =
                  aseg.recibos_listos[idx].comision * rate_exchange;
              }
              if (
                parseFloat(comision_conciliada).toFixed(1) <
                parseFloat(recibo_comision).toFixed(1)
              ) {
                aseg.recibos_listos[idx].comision_conciliada_p = "⬇️";
              }
              if (
                parseFloat(comision_conciliada).toFixed(1) >
                parseFloat(recibo_comision).toFixed(1)
              ) {
                aseg.recibos_listos[idx].comision_conciliada_p = "⬆️";
              }
              if (
                parseFloat(recibo_comision).toFixed(1) ==
                parseFloat(comision_conciliada).toFixed(1)
              ) {
                aseg.recibos_listos[idx].comision_conciliada_p = "✔";
              }
            }
            // ******************************************
            if (
              parseFloat(aseg.recibos_listos[idx].prima_neta).toFixed(2) == 0
            ) {
              aseg.recibos_listos[idx].comision_conciliada_p_ok = 0;
            } else {
              aseg.recibos_listos[idx].comision_conciliada_p_ok = parseFloat(
                aseg.recibos_listos[idx].comision_conciliada_p_estimada
                  ? aseg.recibos_listos[idx].comision_conciliada_p_estimada
                  : 0
              );
              $scope.division = parseFloat(
                parseFloat(
                  parseFloat(
                    aseg.recibos_listos[idx].prima_neta *
                      parseFloat(aseg.recibos_listos[idx].rate_exchange)
                  )
                ) / 100
              ).toFixed(2);
              aseg.recibos_listos[idx].comision_conciliada_p_ok = parseFloat(
                parseFloat(aseg.recibos_listos[idx].comision_conciliada) /
                  parseFloat($scope.division)
              ).toFixed(2);
              if (
                isFinite(aseg.recibos_listos[idx].comision_conciliada_p_ok) ==
                false
              ) {
                aseg.recibos_listos[idx].comision_conciliada_p_ok = 0;
              }
            }
          }
        }
      }
    };
    function forma_pago(parValue) {
      switch (parValue) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        case 24:
          return "Quincenal";
          break;
        default:
          return "No especificada";
      }
    }

    function status(parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        default:
          return "Pendiente";
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    function liquidarRecibo(recibo) {
      if (recibo.status == "Pagado") {
        var data = {
          status: 5,
          liquidacion_folio: recibo.id,
          liquidacion_date: new Date(),
        };
        patchRecibo(recibo.url, data);
        setTimeout(function () {
          SweetAlert.swal(
            "Hecho",
            "El recibo se ha liquidado, folio de liquidacion: " + recibo.id,
            "success"
          );
        }, 100);
      }
    }

    function conciliarRecibo(recibo) {
      // if(parseFloat(vm.form.comision_conciliada) > parseFloat(recibo.comision)){
      //   SweetAlert.swal("Error",'La comisión a conciliar es mayor a la comisión del recibo', "error");
      //   return;
      // }
      if (recibo.status == "Liquidado") {
        if (vm.cuenta == undefined || vm.cuenta.length == 0) {
          SweetAlert.swal("Error", MESSAGES.ERROR.SELECTACCOUNT, "error");
          return;
        }

        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "Los cambios no podrán revertirse",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            closeOnConfirm: false,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var data = {
                status: 6,
                comision_conciliada: parseFloat(
                  vm.form.comision_conciliada
                ).toFixed(2),
                conciliacion_date: toDate(vm.form.conciliate_date),
                conciliacion_folio: recibo.id,
                conciliation_account: vm.cuenta.url,
              };

              patchRecibo(recibo.url, data);
              SweetAlert.swal(
                "¡Listo!",
                MESSAGES.OK.RECEIPTCONCILIAR + recibo.id,
                "success"
              );
              vm.conciliar = false;
              vm.cuenta = [];
              vm.comision_conciliada = 0;
            } else {
              SweetAlert.swal(
                "Cancelado",
                MESSAGES.ERROR.CANCELACCOUNT,
                "error"
              );
            }
          }
        );
      }
    }

    function patchRecibo(url, data) {
      $http({
        method: "PATCH",
        url: url,
        data: data,
      })
        // $http.patch(url,data)
        .success(function (response) {
          vm.show_receipt_info = false;
          var dataRec = response.data;
          if (response.status == 6) {
            var params = {
              model: 4,
              event: "PATCH",
              associated_id: response.id,
              identifier: " concilio el recibo",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response_f) {});
          } else if (response.status == 5) {
            var params = {
              model: 4,
              event: "PATCH",
              associated_id: response.id,
              identifier: " liquido el recibo",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response_f_) {});
          }
          process_comission();
        })
        .error(function (errorResponse) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORUPDATERECEIPTS, "error");
        })
        .catch(function (catchResponse) {
          toaster.success("Recibo actualizado exitosamente");
          console.log("error", error);
        });
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      // console.log('pages', pages);

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }

        $scope.selectPage($scope.totalPages.length);

        $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&status=") !== -1) {
              var status = prev_.substring(prev_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }

        getProviders(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getProviders(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ComisionesConsultaCtrl", ComisionesConsultaCtrl);

  ComisionesConsultaCtrl.$inject = [
    "$scope",
    "providerService",
    "groupService",
    "$http",
    "url",
    "SweetAlert",
    "MESSAGES",
    "$sessionStorage",
    "$localStorage",
    "$sce",
  ];

  function ComisionesConsultaCtrl(
    $scope,
    providerService,
    groupService,
    $http,
    url,
    SweetAlert,
    MESSAGES,
    $sessionStorage,
    $localStorage,
    $sce
  ) {
    var vm = this;

    $scope.providers = [];
    $scope.claves = [];
    $scope.ramos = [];
    $scope.subramos = [];
    $scope.groups = [];
    $scope.show_commission = false;
    $scope.commissions = [];
    $scope.show_table = true;
    $scope.show_information = false;
    $scope.created_at = false;
    $scope.created_at = false;
    vm.form = {
      contratante: 0,
    };
    vm.table = {
      headers: [
        "Folio de Conciliación",
        "Cuenta",
        "Observaciones",
        "Fecha de Conciliación",
        "Registros",
      ],
    };
    vm.option_policy = [
      {
        id: 1,
        name: "Inicio de vigencia",
      },
      {
        id: 2,
        name: "Fecha de Conciliación",
      },
    ];

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (acceso) {
        if (acceso.model_name == "Cobranza") {
          vm.acceso_cob = acceso;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_rec = true;
              } else {
                vm.acceso_pag_rec = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desconc_rec = true;
              } else {
                vm.acceso_desconc_rec = false;
              }
            } else if (acc.permission_name == "Desliquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_desliq_rec = true;
              } else {
                vm.acceso_desliq_rec = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_rec = true;
              } else {
                vm.acceso_conc_rec = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_rec = true;
              } else {
                vm.acceso_liq_rec = false;
              }
            } else if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            }
          });
        } else if (acceso.model_name == "Correos electronicos") {
          vm.acceso_correo = acceso;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (acceso.model_name == "Pólizas") {
          vm.acceso_polizas = acceso;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (acceso.model_name == "Reportes") {
          vm.acceso_reportes = acceso;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (acceso.model_name == "Archivos") {
          $scope.acceso_files = acceso;
          $scope.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                $scope.permiso_archivos = true;
              } else {
                $scope.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    $scope.changeReport = function () {
      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id == 1) {
          $scope.created_at = false;
          $scope.vigency = true;
        } else if (vm.form.dates_sel.id == 2) {
          $scope.vigency = false;
          $scope.created_at = true;
        }
      } else {
        $scope.vigency = false;
        $scope.created_at = false;
      }
    };

    $scope.active = function () {
      providerService.getReadListProviders().then(function (provider) {
        $scope.providers = provider;
      });

      groupService.getGroups().then(function (group) {
        $scope.groups = group;
      });
      $scope.filterDate = {
        startDate: $scope.convertDate(new Date()),
        endDate: $scope.convertDate(
          new Date().setYear(new Date().getFullYear() + 1)
        ),
      };

      vm.form = {
        contratante:
          $localStorage.saved_filters_consultar &&
          $localStorage.saved_filters_consultar["contratante"]
            ? $localStorage.saved_filters_consultar["contratante"]
            : "",
        dates_sel:
          $localStorage.saved_filters_consultar &&
          $localStorage.saved_filters_consultar["dates_sel"]
            ? $localStorage.saved_filters_consultar["dates_sel"]
            : 0,
        since: $scope.convertDate(
          new Date(new Date().setMonth(new Date().getMonth() - 3))
        ),
        until: $scope.convertDate(new Date()),
      };

      $scope.provider =
        $localStorage.saved_filters_consultar &&
        $localStorage.saved_filters_consultar["Provedor"]
          ? $localStorage.saved_filters_consultar["Provedor"]
          : 0;
      $scope.folio_conciliacion =
        $localStorage.saved_filters_consultar &&
        $localStorage.saved_filters_consultar["folio"]
          ? $localStorage.saved_filters_consultar["folio"]
          : "";
      $scope.clave =
        $localStorage.saved_filters_consultar &&
        $localStorage.saved_filters_consultar["clave"]
          ? $localStorage.saved_filters_consultar["clave"]
          : "";

      if (vm.form.dates_sel) {
        $scope.vigency = true;
      }
    };

    $scope.convertDate = function (inputFormat) {
      function inputDate(days) {
        return days < 10 ? "0" + days : days;
      }
      var dateFormat = new Date(inputFormat);
      var date = [
        inputDate(dateFormat.getDate()),
        inputDate(dateFormat.getMonth() + 1),
        dateFormat.getFullYear(),
      ].join("/");
      return date;
    };
    $scope.exportDataExcel = function (param, folio) {
      if (param == 1) {
        var data = {
          folio: $scope.folio_selected,
        };
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   // var excel_receipt = 'v2/recibos/reporte-recibos-conciliados';
        //   var excel_receipt = 'service_reporte-v2-conciliados-excel';
        var excel_receipt = "service_reporte-conciliados-excel";
        $http({
          method: "POST",
          url: url.IP + excel_receipt,
          data: $scope.params_folio,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
          .then(function (data) {
            if (data.status == 200) {
              var blob = new Blob([data.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Recibos_Conciliados.xls");
            } else {
              SweetAlert.swal(
                "Error",
                MESSAGES.ERROR.ERRORDOWNLOADREP,
                "error"
              );
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    $scope.changeProvider = function (provider) {
      if (!provider) {
        $scope.subramos = [];
        $scope.ramos = [];
        return;
      }
      $http
        .get(url.IP + "ramos-by-provider/" + provider.id)
        .then(function (ramo) {
          $scope.ramos = ramo.data;
        });
      $scope.getClaves(provider);
      $scope.provider = provider;
    };

    $scope.getClaves = function (provider) {
      $http
        .get(url.IP + "claves-by-provider/" + provider.id)
        .then(
          function success(clave) {
            $scope.claves = clave.data;
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    };

    $scope.changeRamo = function (ramo) {
      if (!ramo) {
        $scope.subramos = [];
        return;
      }
      $scope.subramos = ramo.subramo_ramo;
      $scope.ramo = ramo;
    };

    $scope.changeSubRamo = function (subramo) {
      $scope.subramo = subramo;
    };

    $scope.changeClave = function (clave) {
      $scope.clave = clave.id;
    };

    $scope.changeGrupo = function (grupo) {
      $scope.grupo = grupo.id;
    };
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.getPDFConciliacion = function (cf) {
      $http({
        method: "POST",
        url: url.IP + "get-pdf-conciliacion/",
        data: {
          conciliacion_folio: cf,
          generado_por: usr["nameFull"],
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
      });
    };
    vm.changeRecibos = changeRecibos;
    function changeRecibos(par, asc) {
      switch (par) {
        case 1:
          showReceipts($scope.folio_selected, par, asc);
          vm.numero_asc = asc;
          vm.numerop_asc = 0;
          vm.numeroe_asc = 0;
          vm.contratante_asc = 0;
          vm.recibo_asc = 0;
          vm.vigencia_asc = 0;
          vm.primatotal_asc = 0;
          vm.comision_asc = 0;
          vm.conciliada_asc = 0;
          break;
        case 2:
          showReceipts($scope.folio_selected, par, asc);
          vm.numero_asc = 0;
          vm.numerop_asc = asc;
          vm.numeroe_asc = 0;
          vm.contratante_asc = 0;
          vm.recibo_asc = 0;
          vm.vigencia_asc = 0;
          vm.primatotal_asc = 0;
          vm.comision_asc = 0;
          vm.conciliada_asc = 0;
          break;
        case 3:
          showReceipts($scope.folio_selected, par, asc);
          vm.numero_asc = 0;
          vm.numerop_asc = 0;
          vm.numeroe_asc = asc;
          vm.contratante_asc = 0;
          vm.recibo_asc = 0;
          vm.vigencia_asc = 0;
          vm.primatotal_asc = 0;
          vm.comision_asc = 0;
          vm.conciliada_asc = 0;
          break;
        case 4:
          showReceipts($scope.folio_selected, par, asc);
          vm.numero_asc = 0;
          vm.numerop_asc = 0;
          vm.numeroe_asc = 0;
          vm.contratante_asc = asc;
          vm.recibo_asc = 0;
          vm.vigencia_asc = 0;
          vm.primatotal_asc = 0;
          vm.comision_asc = 0;
          vm.conciliada_asc = 0;
          break;
        case 5:
          showReceipts($scope.folio_selected, par, asc);
          vm.numero_asc = 0;
          vm.numerop_asc = 0;
          vm.numeroe_asc = 0;
          vm.contratante_asc = 0;
          vm.recibo_asc = asc;
          vm.vigencia_asc = 0;
          vm.primatotal_asc = 0;
          vm.comision_asc = 0;
          vm.conciliada_asc = 0;
          break;
        case 6:
          showReceipts($scope.folio_selected, par, asc);
          vm.numero_asc = 0;
          vm.numerop_asc = 0;
          vm.numeroe_asc = 0;
          vm.contratante_asc = 0;
          vm.recibo_asc = 0;
          vm.vigencia_asc = asc;
          vm.primatotal_asc = 0;
          vm.comision_asc = 0;
          vm.conciliada_asc = 0;
          break;
        case 7:
          showReceipts($scope.folio_selected, par, asc);
          vm.numero_asc = 0;
          vm.numerop_asc = 0;
          vm.numeroe_asc = 0;
          vm.contratante_asc = 0;
          vm.recibo_asc = 0;
          vm.vigencia_asc = 0;
          vm.primatotal_asc = asc;
          vm.comision_asc = 0;
          vm.conciliada_asc = 0;
          break;
        case 8:
          showReceipts($scope.folio_selected, par, asc);
          vm.numero_asc = 0;
          vm.numerop_asc = 0;
          vm.numeroe_asc = 0;
          vm.contratante_asc = 0;
          vm.recibo_asc = 0;
          vm.vigencia_asc = 0;
          vm.primatotal_asc = 0;
          vm.comision_asc = asc;
          vm.conciliada_asc = 0;
          break;
        case 9:
          showReceipts($scope.folio_selected, par, asc);
          vm.numero_asc = 0;
          vm.numerop_asc = 0;
          vm.numeroe_asc = 0;
          vm.contratante_asc = 0;
          vm.recibo_asc = 0;
          vm.vigencia_asc = 0;
          vm.primatotal_asc = 0;
          vm.comision_asc = 0;
          vm.conciliada_asc = asc;
          break;
      }
    }
    $scope.shReceipst = false;

    $scope.showFilter = function (param) {
      $scope.commissions = [];
      $scope.recibos_folio = [];
      if (!$scope.vigency && !$scope.created_at) {
        SweetAlert.swal(
          "Advertencia",
          MESSAGES.WARNING.SELECTCONSULT,
          "warning"
        );
        return;
      }
      $scope.shReceipst = false;
      $scope.show_commission = true;
      $scope.params = {
        provider: $scope.provider ? $scope.provider.id : 0,
        ramo: $scope.ramo ? $scope.ramo.id : 0,
        subramo: $scope.subramo ? $scope.subramo.id : 0,
        since: $scope.filterDate.startDate
          ? $scope.filterDate.startDate
          : $scope.si,
        until: $scope.filterDate.endDate
          ? $scope.filterDate.endDate
          : $scope.un,
        contratante: vm.form.contratante.val ? vm.form.contratante.value : 0,
        grupo: $scope.group ? $scope.group.id : 0,
        type_contractor: vm.form.contratante ? vm.form.contratante.type : 0,
        cve: $scope.cve_agente ? $scope.cve_agente : 0,
        folio_conciliacion: $scope.folio_conciliacion
          ? $scope.folio_conciliacion
          : 0,
        date_selected:
          vm.form.dates_sel && vm.form.dates_sel.id
            ? vm.form.dates_sel.id
            : $scope.vigency
            ? 1
            : 2,
      };
      if (vm.form.contratante) {
        if (vm.form.contratante.value && !vm.form.contratante.val) {
          $scope.params.contratante = 0;
        }
      }
      $scope.params.since = $scope.params.since + " " + "00:00:00";
      $scope.params.until = $scope.params.until + " " + "23:59:59";

      // $http.get(url.IP + 'conciliate-states/',$scope.params)
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   var filter_consulta = 'v2/recibos/conciliate-states/';
      var filter_consulta = "conciliate-states/";
      $http({
        method: "GET",
        url: url.IP + filter_consulta,
        params: $scope.params,
      })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.commissions = response.data;
          }
        })
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      $localStorage.saved_filters_consultar = angular.copy(vm.form);
      $localStorage.saved_filters_consultar["contratante"] =
        vm.form.contratante;
      $localStorage.saved_filters_consultar["Provedor"] = $scope.provider;
      $localStorage.saved_filters_consultar["folio"] =
        $scope.folio_conciliacion;
      $localStorage.saved_filters_consultar["clave"] = $scope.clave;
      $localStorage.saved_filters_consultar["dates_sel"] = vm.form.dates_sel;
    };
    vm.showReceipts = showReceipts;
    function showReceipts(folio, par, asc) {
      $scope.shReceipst = true;
      $scope.folio_selected = folio;
      $scope.params_folio = {};
      $scope.params_folio = $scope.params;
      $scope.params_folio.folio = folio;
      $scope.params_folio.orden = par ? par : 1;
      $scope.params_folio.asc = asc ? asc : 1;
      $scope.folio_selected = folio;

      $http({
        method: "GET",
        url: url.IP + "leer-folios-conciliacion-recibos",
        params: $scope.params_folio,
      }).then(
        function success(response) {
          if (response) {
            $scope.recibos_folio = response.data.recibos;
          }
        },
        function error(error) {
          swal("Error", "Folio inválido", "error");
          return;
        }
      );
    }
    function getContractors() {
      ContratanteService.getContratantes().then(function (data) {
        vm.contractors = data;
      });
    }
    vm.matchesContractors = matchesContractors;
    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   var filter_contractor = 'v2/contratantes/contractors-match/';
          var filter_contractor = "contractors-match/";
          $http
            .post(url.IP + filter_contractor, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }
    $scope.see_information = function (item) {
      $scope.show_information = true;
      $scope.show_table = false;

      $http
        .get(url.IP + "receipt-states/" + item.folio)
        .then(function success(response) {
          if (status == 200) {
            $scope.concilliation = response.results;
          }
        })
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    };

    $scope.returnToList = function () {
      $scope.show_information = false;
      $scope.show_table = true;
    };

    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

/* global angular */
(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ColectivosRenewalCtrl", ColectivosRenewalCtrl);

  ColectivosRenewalCtrl.$inject = [
    "$scope",
    "$http",
    "url",
    "$stateParams",
    "$sessionStorage",
    "MESSAGES",
    "SweetAlert",
    "$state",
    "providerService",
    "helpers",
    "dataFactory",
    "datesFactory",
    "FileUploader",
    "formatValues",
    "$rootScope",
    "$localStorage",
    "$timeout",
    "coverageService",
    "$q",
  ];

  function ColectivosRenewalCtrl(
    $scope,
    $http,
    url,
    $stateParams,
    $sessionStorage,
    MESSAGES,
    SweetAlert,
    $state,
    providerService,
    helpers,
    dataFactory,
    datesFactory,
    FileUploader,
    formatValues,
    $rootScope,
    $localStorage,
    $timeout,
    coverageService,
    $q
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    $scope.infoUser = $sessionStorage.infoUser;

    var order = this;

    // quite $uibModalInstance en ColectivosRenewalCtrl para que funcionara

    $scope.showOt = true;
    $scope.showRenewal = true;
    $scope.caratula = {};
    $scope.subgrupos = {};
    $scope.paquetes = {};
    $scope.package = {};
    $rootScope.show_contractor = false;
    $scope.create_natural = true;
    $scope.create_juridical = true;
    $scope.claves = [];
    $scope.renewals = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.renewalSelected = $scope.renewals[0];
    $scope.administrationTypes = [
      { value: 1, label: "Simplificada" },
      { value: 2, label: "Autoadministrada" },
      { value: 3, label: "Detallada" },
    ];
    $scope.currencys = [
      { value: 1, label: "Pesos" },
      { value: 2, label: "Dólares" },
      { value: 3, label: "UDI" },
      { value: 4, label: "Euros" },
    ];

    $scope.conductos_de_pago = [
      { value: 1, label: "No domiciliada" },
      { value: 2, label: "Agente" },
      { value: 3, label: "CAC" },
      { value: 4, label: "CAT/Domiciliado" },
      { value: 5, label: "Nómina" },
      { value: 6, label: "CUT" },
    ];

    $scope.referenciadores = [];
    $scope.referenciadorArray = [];
    $scope.referenciadoresSelected = [];
    $scope.btnTraditionalStyle = {
      color: "#ffffff",
      "background-color": "#1cb394",
    };
    $scope.btnMinimalStyle = {
      color: "#707877",
      "background-color": "#ffffff",
      "border-top": "1px solid #1cb394",
      "border-right": "1px solid #1cb394",
      "border-bottom": "1px solid #1cb394",
    };
    $scope.frequencies = [
      { value: 7, label: "Semanal" },
      { value: 14, label: "Catorcenal" },
      // {'value':24, 'label':'Quincenal'},
      { value: 1, label: "Mensual" },
      { value: 2, label: "Bimestral" },
      { value: 3, label: "Trimestral" },
      { value: 6, label: "Semestral" },
      { value: 12, label: "Anual" },
      { value: 5, label: "Contado" },
    ];
    $scope.btnPolicyStyle = {
      color: "#ffffff",
      "background-color": "#1c84c4",
    };
    $scope.btnSudgroupStyle = {
      color: "#707877",
      "background-color": "#ffffff",
      "border-top": "1px solid #1c84c4",
      "border-right": "1px solid #1c84c4",
      "border-bottom": "1px solid #1c84c4",
    };
    $scope.btnCertificateStyle = {
      color: "#707877",
      "background-color": "#ffffff",
      "border-top": "1px solid #1c84c4",
      "border-right": "1px solid #1c84c4",
      "border-bottom": "1px solid #1c84c4",
      "border-left": "1px solid #1c84c4",
    };

    $scope.businessline = [
      { id: 0, name: "Otro" },
      { id: 1, name: "Comercial" },
      { id: 2, name: "Personal" },
    ];
    $scope.directiveReceipts = [];
    $scope.dataToSave = [];
    $scope.addSubgrupos = false;
    $scope.subgroupsInfo = [];
    $scope.addressSubgroups = [];
    $scope.subgroups = [];
    $scope.receiptsSubgroup = false;
    $scope.packageSelected = {};
    $scope.package = {
      package_name: "",
      coverage_package: [],
      type_package: 2,
    };
    $scope.newPackage = false;
    $scope.newCoverages = [];
    $scope.personalizePackage = false;
    $scope.configCoverages = [];
    $scope.paquetes = [];
    $scope.dataCaratula = [];
    $scope.showTableCertificates = false;
    $scope.excelJson = [];
    $scope.beneficiaries_life = [];
    $scope.beneficiaries_medical = [];
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certifcados = [];

    $scope.celulas = [];
    $scope.agrupaciones = [];
    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    activate();

    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      $scope.accesos = $sessionStorage.permisos;
      if ($scope.accesos) {
        $scope.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            $scope.acceso_polizas = perm;
            $scope.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  $scope.acceso_adm_pol = true;
                } else {
                  $scope.acceso_adm_pol = false;
                }
              }
              if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  $scope.acceso_ver_pol = true;
                } else {
                  $scope.acceso_ver_pol = false;
                }
              }
              if (acc.permission_name == "Cancelar pólizas") {
                if (acc.checked == true) {
                  $scope.acceso_canc_pol = true;
                } else {
                  $scope.acceso_canc_pol = false;
                }
              }
              if (acc.permission_name == "Eliminar pólizas") {
                if (acc.checked == true) {
                  $scope.acceso_elim_pol = true;
                } else {
                  $scope.acceso_elim_pol = false;
                }
              }
              if (acc.permission_name == "Comisión no obligatoria") {
                if (acc.checked == true) {
                  $scope.acceso_cno_pol = true;
                } else {
                  $scope.acceso_cno_pol = false;
                }
              }
            });
          }
          if (perm.model_name == "Referenciadores") {
            $scope.acceso_ref = perm;
            $scope.acceso_ref.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver referenciadores") {
                if (acc.checked == true) {
                  $scope.acceso_ver_ref = true;
                } else {
                  $scope.acceso_ver_ref = false;
                }
              }
            });
          }
        });
      }
      $scope.directiveReceipts["canCreate"] = false;
      $http
        .post(url.IP + "get_caratula_complete/", {
          caratula: $stateParams.polizaId,
        })
        .then(function success(response) {
          if (response.status == 200) {
            $http({
              method: "GET",
              url: url.IP + "historic-policies/",
              params: {
                actual_id: $stateParams.polizaId,
              },
            }).then(function success(response) {
              response.data.results.forEach(function function_name(old) {
                console.log("old", old);
                if (old.new_policy && old.new_policy.status == 1) {
                  SweetAlert.swal(
                    "Información",
                    "La póliza ya tiene una OT de renovación",
                    "info"
                  );
                  // console.log('$scope.caratula', $scope.caratula);
                  if ($scope.caratula.document_type == "Póliza de grupo") {
                    $state.go("colectividades.info", {
                      polizaId: $stateParams.polizaId,
                    });
                  }
                }
              });
            });

            $scope.caratula = response.data.data.caratula;
            $scope.copy_caratula = angular.copy(response.data.data.caratula);
            $scope.originCaratula = angular.copy(response.data.data.caratula);
            $scope.caratula.folio = "";
            $scope.caratula.poliza_number = "";
            $scope.caratula.observations = "";
            $scope.copy_subgroups = angular.copy(response.data.data.childs);
            $scope.copy_packages = angular.copy(response.data.data.paquetes);

            $scope.conductoSelected = $scope.caratula.conducto_de_pago;

            $scope.startDate = datesFactory.convertDate(
              $scope.caratula.end_of_validity
            );
            $scope.checkDate($scope.startDate);
            fillProvider();

            $scope.aseguradoraSelected = $scope.caratula.aseguradora;
            $scope.business_lineSelected =
              $scope.businessline[$scope.caratula.business_line];
            $scope.currencys.forEach(function (item) {
              if (
                $localStorage.save_renewal_poliza_grupo &&
                $localStorage.save_renewal_poliza_grupo["f_currency"]
              ) {
                $scope.currencySelected =
                  $localStorage.save_renewal_poliza_grupo["f_currency"];
                $scope.caratula.f_currency = $scope.currencySelected;
                if (!$scope.currencySelected) {
                  if (item.label == $scope.caratula.f_currency) {
                    $scope.currencySelected = item.value;
                    $scope.caratula.f_currency = item.value;
                  }
                }
              } else {
                if (item.label == $scope.caratula.f_currency) {
                  $scope.currencySelected = item.value;
                  $scope.caratula.f_currency = item.value;
                }
              }
            });
            $scope.administrationTypes.forEach(function (item) {
              if (item.label == $scope.caratula.administration_type) {
                $scope.administrationSelected = item;
              }
            });

            order.contratante = {};
            $scope.caratula.contractor = $scope.copy_caratula.contractor;
            if ($scope.caratula.contractor) {
              $scope.caratula.contractor.address_contractor.forEach(function (
                address
              ) {
                if (address.id == $scope.caratula.address) {
                  $scope.addressSelected = address;
                }
              });
              order.contratante.val = $scope.caratula.contractor.full_name;
              order.contratante.value = $scope.caratula.contractor;
            }

            // Recibos
            $scope.directiveReceipts.domiciliado = false;
            $scope.directiveReceipts.payment = {
              value: $scope.caratula.forma_de_pago,
            };
            $scope.directiveReceipts.startDate = $scope.startDate;
            $scope.directiveReceipts.endingDate = $scope.endDate;
            var date1 = new Date($scope.caratula.start_of_validity);
            var date2 = new Date($scope.caratula.end_of_validity);
            var timeDiff = Math.abs(date2.getTime() - date1.getTime());
            $scope.directiveReceipts.policy_days_duration = Math.ceil(
              timeDiff / (1000 * 3600 * 24)
            );

            $http
              .get(url.IP + "usuarios/")
              .then(function (user) {
                user.data.results.forEach(function (u) {
                  u.first_name = u.first_name.toUpperCase();
                  u.last_name = u.last_name.toUpperCase();
                  u.name =
                    u.first_name.toUpperCase() +
                    " " +
                    u.last_name.toUpperCase();
                });
                $scope.users = user.data.results;
                if ($scope.caratula.responsable) {
                  $scope.users.forEach(function (item) {
                    if (item.id == $scope.caratula.responsable.id) {
                      $scope.responsableSelected = item.id;
                      $scope.caratula.responsable = item.id;
                    }
                  });
                }

                $scope.ejecutivos = user.data.results;
                if ($scope.caratula.collection_executive) {
                  $scope.users.forEach(function (item) {
                    if (item.id == $scope.caratula.collection_executive.id) {
                      $scope.executiveSelected = item.id;
                      $scope.caratula.collection_executive = item.id;
                    }
                  });
                }

                $scope.getClaves($scope.aseguradoraSelected);
              })
              .catch(function (e) {
                console.log("error", e);
              });

            dataFactory
              .get("sucursales-to-show-unpag/")
              .then(function success(response) {
                if (response.status === 200 || response.status === 201) {
                  $scope.sucursales = response.data;
                  if ($scope.caratula.sucursal) {
                    $scope.sucursales.forEach(function (item) {
                      if (item.id == $scope.caratula.sucursal.id) {
                        $scope.sucursalSelected = item.id;
                        $scope.caratula.sucursal = item.id;
                      }
                    });
                  }
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });

            $http
              .get(url.IP + "get-vendors/")
              .then(function (user) {
                user.data.forEach(function (u) {
                  u.first_name = u.first_name.toUpperCase();
                  u.last_name = u.last_name.toUpperCase();
                  u.name =
                    u.first_name.toUpperCase() +
                    " " +
                    u.last_name.toUpperCase();
                });
                $scope.referenciadores = user.data;
                var vendedor = {
                  referenciador: "",
                  comision_vendedor: "",
                };
                $scope.referenciadorArray.push(vendedor);
              })
              .catch(function (e) {
                console.log("error", e);
              });

            dataFactory
              .post("celula_contractor_info/")
              .then(function (response) {
                $scope.celulas = response.data;
              });

            if ($scope.caratula.celula) {
              $http
                .get(url.IP + "celula_contractor/" + $scope.caratula.celula)
                .then(function (response) {
                  $scope.celulaSelected = response.data;
                  $scope.changeCelula($scope.celulaSelected);
                });
            }

            dataFactory.get("groupingLevel-resume/").then(function (response) {
              $scope.agrupaciones = response.data;
            });

            if ($scope.caratula.grouping_level) {
              $http
                .get(
                  url.IP + "groupinglevel/" + $scope.caratula.grouping_level.id
                )
                .then(function (response) {
                  $scope.grouping_levelSelected = response.data;
                  $scope.info_sub = $scope.caratula;
                  $scope.changeAgrupacion($scope.grouping_levelSelected);
                });
            }

            // Referenciadores

            if ($scope.caratula.ref_policy.length > 0) {
              $scope.caratula.ref_policy.forEach(function (refs) {
                $http
                  .get(refs.referenciador.url)
                  .then(function success(response_ref_plicy) {
                    if (response_ref_plicy) {
                      refs.data = response_ref_plicy.data;
                      refs.referenciador = response_ref_plicy.data.id;
                      refs.selectedRef = true;
                      $scope.referenciadorArray.push(refs);
                    }
                  });
              });
            }

            $scope.chanceScheme($scope.caratula.scheme);
            $scope.paymentSelected = $scope.caratula.forma_de_pago;
            $scope.chancePayment($scope.caratula.forma_de_pago);
            $scope.createReceits($scope.caratula.receipts_by);
            if ($scope.caratula.grouping_level) {
              $http
                .get(
                  url.IP + "groupinglevel/" + $scope.caratula.grouping_level.id
                )
                .then(function (response) {
                  $scope.grouping_levelSelected = response.data;
                  $scope.changeAgrupacion($scope.grouping_levelSelected);
                });
            }
            if ($scope.caratula.celula) {
              $http
                .get(url.IP + "celula_contractor/" + $scope.caratula.celula)
                .then(function (response) {
                  $scope.celulaSelected = response.data;
                  $scope.changeCelula($scope.celulaSelected);
                });
            }

            $scope.info_sub = $scope.caratula;
            getInternalNumber();
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    }

    function getInternalNumber() {
      $http({
        method: "POST",
        url: url.IP + "internal-number/",
      })
        .then(
          function success(response) {
            if (response.status === 200 || response.status === 201) {
              $scope.caratula.internal_number = "OT000" + response.data.id;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log("error", e);
        });
    }

    function fillProvider() {
      var d = $scope.startDate;
      try {
        var day = d.getDate();
        var month = d.getMonth() + 1; //Months are zero based
        var year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var day = f.getDate();
        var month = f.getMonth() + 1; //Months are zero based
        var year = f.getFullYear();
      }

      var date = year + "-" + month + "-" + day;
      providerService.getProviderByKey(date).then(
        function success(data) {
          $scope.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    $scope.showButtonPolicy = function () {
      $scope.showOt = false;
      $scope.aseguradoraSelected = $scope.caratula.aseguradora;
      $scope.ramoSelected = $scope.caratula.ramo;
      $scope.subramoSelected = $scope.caratula.subramo;
      $scope.administrationSelected = $scope.caratula.administration_type;
      $scope.paymentSelected = $scope.caratula.forma_de_pago;
      $scope.getClaves($scope.aseguradoraSelected);
    };

    $scope.hideButtonOT = function () {
      $scope.showOt = true;
      $scope.aseguradoraSelected = $scope.caratula.aseguradora;
      $scope.ramoSelected = $scope.caratula.ramo;
      $scope.subramoSelected = $scope.caratula.subramo;
      $scope.administrationSelected = $scope.caratula.administration_type;
      $scope.paymentSelected = $scope.caratula.forma_de_pago;
      $scope.getClaves($scope.aseguradoraSelected);
    };

    $scope.checkNumPolicy = function () {
      if ($scope.caratula.poliza_number) {
        helpers
          .existPolicyNumber("renovaciones_polizagrupo")
          .then(function (request) {
            if (request == true) {
              SweetAlert.swal("Error", MESSAGES.ERROR.POLICYEXIST, "error");
              $scope.caratula.poliza_number = "";
            }
          })
          .catch(function (err) {
            console.log("Error", err);
          });
      }
    };

    // var myInsurance = $stateParams.myInsurance;
    // if(myInsurance.url){
    //   order  = {
    //     contratante : {}
    //   }

    //   order.contratante.value = $stateParams.myInsurance;
    //   if(order.contratante.value.email){
    //     order.contratante.value.email = $stateParams.myInsurance.email
    //   }
    // }

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if ($scope.referenciadores) {
          $scope.referenciadores.some(function (user) {
            if (user.url == order.contratante.value.vendor) {
              $scope.referenciadorArray[0] = {
                referenciador: user.id,
                comision_vendedor: "",
              };
            }
          });
        }
        if (order.contratante.value.address_contractor) {
          if (order.contratante.value.address_contractor) {
            $scope.caratula.contractor = order.contratante.value.id;
            $scope.addresses = order.contratante.value.address_contractor;
          }
          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.caratula.address = $scope.addresses[0].id;
          }
        }
      }
    });

    $scope.changeAddress = function (param) {
      $scope.caratula.address = param.id;
    };

    $scope.contratanteCreator = function () {
      $rootScope.show_contractor = true;
      // $scope.orderInfo = vm;
      $localStorage.orderForm = JSON.stringify($scope.caratula);
    };

    $scope.checkDate = function (param) {
      if (param.length == 10) {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();
      } else {
        var day = new Date().getDate();
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();
        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();
      }
      $scope.directiveReceipts.startDate = $scope.startDate;
      $scope.directiveReceipts.endingDate = $scope.endDate;
      var date1 = new Date($scope.caratula.start_of_validity);
      var date2 = new Date($scope.caratula.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );
      $scope.directiveReceipts.domiciliado = false;
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        $scope.caratula.end_of_validity = toDate(param);
        $scope.directiveReceipts.endingDate = param;
        var date1 = new Date($scope.caratula.start_of_validity);
        var date2 = new Date($scope.caratula.end_of_validity);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        $scope.directiveReceipts.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
      }
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function toDate(dateStr) {
      if (dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(
          dateParts[2],
          dateParts[1] - 1,
          dateParts[0]
        ).toISOString(); // month is 0-based
        return dateObject;
      }
    }

    $scope.getClaves = function (param) {
      $scope.caratula.aseguradora = param;
      $scope.ramoSelected = null;
      $scope.subramoSelected = null;
      $scope.caratula.ramo = null;
      $scope.caratula.subramo = null;
      if ($scope.caratula.aseguradora && $scope.caratula.aseguradora.id) {
        $http
          .get(url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id)
          .then(function success(clavesResponse) {
            $scope.claves = clavesResponse.data;
            if ($scope.claves.length == 1) {
              $scope.caratula.clave = $scope.claves[0].id;
              $scope.claveSelected = $scope.claves[0];
            } else {
              $scope.claves.forEach(function (item) {
                if (item.id == $scope.caratula.clave.id) {
                  $scope.caratula.clave = item.id;
                  $scope.claveSelected = item;
                }
              });
            }
          })
          .catch(function (error) {
            console.log("Error - claves-by-provider - catch", error);
          });

        $http
          .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
          .then(
            function success(response) {
              $scope.ramos = response.data;
              $scope.sinRamo = true;
              $scope.ramoSelected = null;
              $scope.subramoSelected = null;
              $scope.ramos.forEach(function (item) {
                if (item.id == $scope.originCaratula.ramo.id) {
                  $scope.sinRamo = false;
                  $scope.ramoSelected = item;
                  $scope.caratula.ramo = item;
                  $scope.subramos = item.subramo_ramo;
                  $scope.subramos.forEach(function (subramo) {
                    if (
                      subramo.subramo_name ==
                      $scope.originCaratula.subramo.subramo_name
                    ) {
                      $scope.subramoSelected = subramo;
                      $scope.caratula.subramo = subramo;
                      $scope.directiveReceipts.subramo = subramo;
                      $scope.dataToSave.subramo = subramo;
                      var comisiones = [];
                      if (
                        $scope.claveSelected &&
                        $scope.claveSelected.clave_comision
                      ) {
                        if ($scope.claveSelected.clave_comision.length) {
                          $scope.claveSelected.clave_comision.forEach(function (
                            item
                          ) {
                            if (
                              $scope.subramoSelected.subramo_name ==
                              item.subramo
                            ) {
                              comisiones.push(item);
                            }
                          });
                        }
                      }
                      $scope.directiveReceipts.comisiones = comisiones;
                      $scope.getPackage();
                    }
                  });
                }
              });
              if ($scope.sinRamo) {
                $scope.caratula.ramo = null;
                $scope.ramoSelected = null;
                $scope.subramoSelected = null;
                $scope.caratula.subramo = null;
                $scope.directiveReceipts.subramo = null;
              }
            },
            function error(e) {
              console.log("Error - ramos-by-provider", e);
            }
          )
          .catch(function (error) {
            console.log("Error - ramos-by-provider - catch", error);
          });
      } else {
        $scope.caratula.ramo = null;
        $scope.caratula.clave = null;
        $scope.caratula.subramo = null;
        $scope.ramos = [];
        $scope.subramos = [];
        $scope.ramoSelected = null;
        $scope.aseguradoraSelected = null;
        $scope.subramoSelected = null;
        $scope.claves = [];
        $scope.claveSelected = null;
      }
      $scope.caratula.aseguradora = param;
    };

    $scope.refreshProvider = function () {
      fillProvider();
    };

    $scope.changeClave = function (param) {
      if (param) {
        $scope.caratula.clave = param.id;
        $scope.claveSelected = param;
      }
    };

    $scope.changeRamo = function (param) {
      if (param) {
        $scope.caratula.ramo = param;
        $scope.subramos = param.subramo_ramo;
        if (!$localStorage.save_renewal_poliza_grupo) {
          $localStorage.save_renewal_poliza_grupo = angular.copy(
            $scope.caratula
          );
        }
        $localStorage.save_renewal_poliza_grupo["ramo"] = param;
      }
    };

    $scope.changeSubramo = function (param) {
      if (param) {
        $scope.caratula.subramo = param;
        $scope.directiveReceipts.subramo = param;

        var comisiones = [];
        if ($scope.claveSelected.clave_comision.length) {
          $scope.claveSelected.clave_comision.forEach(function (item) {
            if (param.subramo_name == item.subramo) {
              comisiones.push(item);
            }
          });
        }

        if (!$localStorage.save_renewal_poliza_grupo) {
          $localStorage.save_renewal_poliza_grupo = angular.copy(
            $scope.caratula
          );
        }
        $localStorage.save_renewal_poliza_grupo["subramo"] = param;

        $scope.directiveReceipts.comisiones = comisiones;
      }

      $scope.getPackage();
    };

    $scope.changeRenewal = function (param) {
      $scope.caratula.is_renewable = param.value;
      if (!$localStorage.save_renewal_poliza_grupo) {
        $localStorage.save_renewal_poliza_grupo = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_poliza_grupo["is_renewable"] = param.value;
    };

    $scope.changeAdminType = function (param) {
      $scope.caratula.administration_type = param.value;
      if ($scope.caratula.administration_type == 1) {
        SweetAlert.swal(
          "Simplificada",
          "Se puede capturar endoso por el ajuste anual “A” o “D según el caso.",
          "info"
        );
      } else if ($scope.caratula.administration_type == 2) {
        SweetAlert.swal(
          "Autoadministrada",
          "Se pueden capturar endosos por movimientos de altas o bajas sin recibos y, sin notas de crédito.",
          "info"
        );
      } else if ($scope.caratula.administration_type == 3) {
        SweetAlert.swal(
          "Detallada",
          "Se pueden capturar endosos por movimientos de altas o bajas con recibos al cobro o notas de crédito, según el caso.",
          "info"
        );
      }
      if (!$localStorage.save_renewal_poliza_grupo) {
        $localStorage.save_renewal_poliza_grupo = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_poliza_grupo["administration_type"] =
        param.label;
    };

    $scope.changeCurrency = function (param) {
      $scope.caratula.f_currency = param && param.value ? param.value : param;
      if (!$localStorage.save_renewal_poliza_grupo) {
        $localStorage.save_renewal_poliza_grupo = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_poliza_grupo["f_currency"] = param;
    };

    $scope.changeResponsable = function (param) {
      $scope.caratula.responsable = param;
      if (!$localStorage.save_renewal_poliza_grupo) {
        $localStorage.save_renewal_poliza_grupo = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_poliza_grupo["responsable"] = param;
    };

    $scope.changeExecutive = function (param) {
      $scope.caratula.collection_executive = param;
      if (!$localStorage.save_renewal_poliza_grupo) {
        $localStorage.save_renewal_poliza_grupo = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_poliza_grupo["collection_executive"] = param;
    };

    $scope.changeSucursal = function (param) {
      $scope.caratula.sucursal = param;
      if (!$localStorage.save_renewal_poliza_grupo) {
        $localStorage.save_renewal_poliza_grupo = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_poliza_grupo["sucursal"] = param;
    };

    $scope.changeDomiciliado = function (param) {
      $scope.directiveReceipts.domiciliado = param;
    };

    $scope.changeCelula = function (param) {
      $scope.caratula.celula = param.id;
      if (!$localStorage.save_renewal_poliza_grupo) {
        $localStorage.save_renewal_poliza_grupo = angular.copy($scope.caratula);
      }
      $localStorage.save_renewal_poliza_grupo["celula"] = param.id;
    };

    $scope.changeAgrupacion = function (data) {
      $scope.sub_asignaciones = data.subgrupos;
      $scope.caratula.groupinglevel = data.id;
      if ($scope.info_sub.subgrouping_level) {
        $http
          .get(url.IP + "groupinglevel/" + $scope.info_sub.subgrouping_level.id)
          .then(function (response) {
            $scope.subgroupingSelected = response.data;
            $scope.sub_asignaciones.forEach(function (item) {
              if (item.id == $scope.subgroupingSelected.id) {
                $scope.changeSubagrupacion(item);
              }
            });
          });
      }
    };

    $scope.changeSubagrupacion = function (data) {
      if (data.subsubgrupos) {
        $scope.sub_subasignaciones = data.subsubgrupos;
        $scope.caratula.groupinglevel = data.id;
        if ($scope.info_sub.subsubgrouping_level) {
          $http
            .get(
              url.IP +
                "groupinglevel/" +
                $scope.info_sub.subsubgrouping_level.id
            )
            .then(function (response) {
              $scope.subsubgroupingSelected = response.data;
              $scope.caratula.groupinglevel = response.data.id;
            });
        }
      }
    };

    $scope.changeSubsubagrupacion = function (data) {
      $scope.caratula.groupinglevel = data.id;
    };

    $scope.addReferenciador = function () {
      var addReferenciadores = {
        referenciador: "",
        comision_vendedor: "",
      };
      $scope.referenciadorArray.push(addReferenciadores);
    };

    $scope.deleteReferenciador = function (index) {
      $scope.referenciadorArray.splice(index, 1);
    };

    $scope.changeComRef = function (param, index, com) {
      $scope.referenciadorArray[index].comision_vendedor = param;
      if (com.comision_vendedor > 100) {
        com.comision_vendedor = 0;
      } else if (com.comision_vendedor < 0) {
        com.comision_vendedor = 0;
      }
      $scope.checkTotalComision(com);
    };
    $scope.checkTotalComision = function (item) {
      var totalComision = $scope.referenciadorArray.reduce(function (
        sum,
        item
      ) {
        return sum + (parseFloat(item.comision_vendedor) || 0); // Convert to number, default to 0 if undefined
      },
      0);
      if (totalComision > 100) {
        $scope.comisionError =
          "La suma de las comisiones no puede superar el 100%";
        item.comision_vendedor = 0;
      } else {
        $scope.comisionError = null; // No error if total is within limit
      }
    };

    $scope.chanceScheme = function (param) {
      $scope.caratula.scheme = parseInt(param);
      if (param == 1) {
        $scope.frequencies = [
          { value: 7, label: "Semanal" },
          { value: 14, label: "Catorcenal" },
          // {'value':24, 'label':'Quincenal'},
          { value: 1, label: "Mensual" },
          { value: 2, label: "Bimestral" },
          { value: 3, label: "Trimestral" },
          { value: 6, label: "Semestral" },
          { value: 12, label: "Anual" },
          { value: 5, label: "Contado" },
        ];
        $scope.btnTraditionalStyle = {
          color: "#ffffff",
          "background-color": "#1cb394",
        };
        $scope.btnMinimalStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1cb394",
          "border-right": "1px solid #1cb394",
          "border-bottom": "1px solid #1cb394",
        };
      } else {
        $scope.frequencies = [{ value: 5, label: "Contado" }];
        $scope.paymentSelected = $scope.frequencies[0].value;
        $scope.chancePayment(5);
        $scope.caratula.receipts_by = 1;
        $scope.btnTraditionalStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1cb394",
          "border-bottom": "1px solid #1cb394",
          "border-left": "1px solid #1cb394",
        };
        $scope.btnMinimalStyle = {
          color: "#ffffff",
          "background-color": "#1cb394",
        };
        SweetAlert.swal(
          "Prima Mínima",
          "El esquema de pago de prima mínima solo permite recibos a nivel póliza.",
          "info"
        );
      }
    };

    $scope.chancePayment = function (param) {
      $scope.caratula.forma_de_pago = parseInt(param);
      $scope.directiveReceipts.payment = param;
    };

    $scope.createReceits = function (param) {
      $scope.caratula.receipts_by = param;
      if (param == 1) {
        $scope.btnPolicyStyle = {
          color: "#ffffff",
          "background-color": "#1c84c4",
        };
        $scope.btnSudgroupStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-right": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
        };
        $scope.btnCertificateStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-right": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
        };
      } else if (param == 2) {
        $scope.btnPolicyStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
        };
        $scope.btnSudgroupStyle = {
          color: "#ffffff",
          "background-color": "#1c84c4",
        };
        $scope.btnCertificateStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-right": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
        };
        SweetAlert.swal(
          "Recibos por subgrupo",
          "Deberas crear en los recibos en los subgrupos.",
          "info"
        );
      } else {
        $scope.btnPolicyStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-right": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
        };
        $scope.btnSudgroupStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
        };
        $scope.btnCertificateStyle = {
          color: "#ffffff",
          "background-color": "#1c84c4",
        };
        SweetAlert.swal(
          "Recibos por certificados",
          "Deberas crear en los recibos en los certificados.",
          "info"
        );
      }
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item, options){
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
      $scope.okFile++;
      if ($scope.okFile == $scope.uploader.queue.length) {
        $timeout(function () {
          if ($scope.dataCaratula.poliza_number) {
            SweetAlert.swal(
              "¡Listo!",
              "Colectividad creada exitosamente.",
              "success"
            );
            $scope.nextCertificate();
          }
          if (!$scope.dataCaratula.poliza_number) {
            SweetAlert.swal(
              "¡Listo!",
              "Orden de Trabajo creada exitosamente.",
              "success"
            );
            if ($scope.subgroups.length == 0 || $scope.paquetes.length == 0) {
              $state.go("colectividades.info", {
                polizaId: $scope.dataCaratula.id,
              });
            } else {
              $scope.nextCertificate();
            }
          }

          if ($uibModalInstance) {
            $uibModalInstance.close(200);
          }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        order.options.checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 2 });
      } else {
        order.options.checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 1 });
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
      fileItem.removeAfterUpload = true;
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $scope.files = [];
      $scope.files_ = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.nextSubgroup = function () {
      $scope.showCar = true;
      $scope.showSub = false;
    };

    $scope.nextPackage = function () {
      $scope.showSub = true;
      $scope.showPac = false;
    };

    $scope.nextCertificate = function () {
      $scope.showPac = true;
      $scope.showCer = false;
    };

    $scope.copySubgroup = function () {
      if ($scope.caratula.receipts_by == 2) {
        SweetAlert.swal(
          "Subgrupos",
          "No se pueden clonan los subgrupos porque has seleccionado recibos por subgrupo, tendrás que agregarlos manualmente para crear los recibos.",
          "info"
        );
        return;
      }
      var copy_sub = angular.copy($scope.copy_subgroups);
      copy_sub.forEach(function (item) {
        var sub = {
          name: item.name,
          observations: item.observations,
          contractor: null,
          address: null,
          categorias: [],
          p_neta: 0,
          descuento: 0,
          rpf: 0,
          derecho: 0,
          sub_total: 0,
          iva: 0,
          p_total: 0,
          comision: 0,
          comision_percent: 0,
          recibos_poliza: [],
          document_type: 4,
        };
        item.categorias.forEach(function (category) {
          var cate = {
            name: category.name,
            observations: category.observations,
            hospital_level: category.hospital_level,
            document_type: 5,
          };
          sub.categorias.push(cate);
        });
        $scope.subgroups.push(sub);
      });
      $scope.subgroupsInfo = angular.copy($scope.copy_subgroups);
    };

    $scope.defaultSubgroup = function () {
      if (!$scope.caratula.subramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      } else {
        SweetAlert.swal(
          {
            title: "Subgrupo Default",
            text: "Se creará también una categoría por default ¿Estas de acuerdo?",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
          },
          function (isConfirm) {
            if (isConfirm) {
              $scope.itemSubgrupos = {
                name: "Default",
                observations: "",
                contractor: null,
                address: null,
                categorias: [
                  {
                    name: "Default",
                    observations: null,
                    hospital_level: null,
                    document_type: 5,
                  },
                ],
              };
              if ($scope.caratula.subramo.subramo_name == "Gastos Médicos") {
                $scope.itemSubgrupos.categorias[0].hospital_level = "Default";
              }
              $scope.addSubgroup();

              $scope.showSub = true;
              $scope.showPac = false;
            }
          }
        );
      }
    };

    $scope.showSubgroup = function (param) {
      order.contratanteSubgrupo = null;
      $scope.contractors_data = [];
      $scope.addressSubgroups = [];
      $scope.addSubgrupos = param;
      if ($scope.addSubgrupos) {
        $scope.itemSubgrupos = {
          name: "",
          observations: "",
          contractor: null,
          address: null,
          categorias: [
            {
              name: "",
              observations: "",
              hospital_level: "",
              document_type: 5,
            },
          ],
        };
      }
    };

    $scope.addCategorie = function (index) {
      var categoria = {
        name: "",
        observations: "",
        hospital_level: "",
        document_type: 5,
      };
      $scope.itemSubgrupos.categorias.push(categoria);
    };

    $scope.deleteCategorie = function (index) {
      $scope.itemSubgrupos.categorias.splice(index, 1);
    };

    $scope.addSubgroup = function () {
      if (!$scope.caratula.subramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (!$scope.itemSubgrupos.name) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORSUBGROUP, "error");
        return;
      }
      if (
        !$scope.showOt &&
        $scope.caratula.receipts_by == 2 &&
        $scope.receiptsSubgroup
      ) {
        if (!order.contratanteSubgrupo) {
          SweetAlert.swal(
            "Error",
            "Agrega un contratante al subgrupo.",
            "error"
          );
          return;
        }
        if (!$scope.itemSubgrupos.address) {
          SweetAlert.swal(
            "Error",
            "Agrega una dirección al subgrupo.",
            "error"
          );
          return;
        }
        if (!$scope.dataToSave.recibos_poliza) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
      }
      var flagCoverage = false;
      $scope.itemSubgrupos.categorias.forEach(function (item, index) {
        if (!item.name) {
          flagCoverage = true;
          SweetAlert.swal(
            "Error",
            "Agrega el nombre de la categoría " + (index + 1) + ".",
            "error"
          );
        }
        if ($scope.caratula.subramo.subramo_name == "Gastos Médicos") {
          if (!item.hospital_level) {
            flagCoverage = true;
            SweetAlert.swal(
              "Error",
              "Agrega el nivel hospitalario de la categoría " +
                (index + 1) +
                ".",
              "error"
            );
          }
        }
      });
      if (flagCoverage) {
        return;
      }

      var infoSubgrupo = {
        name: $scope.itemSubgrupos.name,
        contractor: $scope.itemSubgrupos.contractor
          ? $scope.itemSubgrupos.contractor.val
          : null,
        receipts:
          $scope.caratula.receipts_by == 2
            ? $scope.dataToSave.recibos_poliza
              ? $scope.dataToSave.recibos_poliza.length
              : 0
            : 0,
        categorias: $scope.itemSubgrupos.categorias,
      };
      $scope.subgroupsInfo.push(infoSubgrupo);
      var itemsubgrupo = {
        name: $scope.itemSubgrupos.name,
        observations: $scope.itemSubgrupos.observations,
        contractor: $scope.itemSubgrupos.contractor,
        address: $scope.itemSubgrupos.address
          ? $scope.itemSubgrupos.address
          : null,
        p_neta: $scope.dataToSave.p_neta ? $scope.dataToSave.p_neta : 0,
        descuento: $scope.dataToSave.descuento
          ? $scope.dataToSave.descuento
          : 0,
        rpf: $scope.dataToSave.rpf ? $scope.dataToSave.rpf : 0,
        derecho: $scope.dataToSave.derecho ? $scope.dataToSave.derecho : 0,
        sub_total: $scope.dataToSave.sub_total
          ? $scope.dataToSave.sub_total
          : 0,
        iva: $scope.dataToSave.iva ? $scope.dataToSave.iva : 0,
        p_total: $scope.dataToSave.p_total ? $scope.dataToSave.p_total : 0,
        comision: $scope.dataToSave.comision ? $scope.dataToSave.comision : 0,
        comision_percent: $scope.dataToSave.comision_percent
          ? $scope.dataToSave.comision_percent
          : 0,
        recibos_poliza: $scope.dataToSave.recibos_poliza
          ? $scope.dataToSave.recibos_poliza
          : [],
        document_type: 4,
        categorias: $scope.itemSubgrupos.categorias,
      };
      $scope.subgroups.push(itemsubgrupo);
      $scope.addSubgrupos = false;
    };

    $scope.showReceiptsSubgroup = function (param) {
      $scope.receiptsSubgroup = param;
    };

    $scope.$watch(
      "order.contratanteSubgrupo.value",
      function (newValue, oldValue) {
        if (order.contratanteSubgrupo) {
          if (order.contratanteSubgrupo.value.address_contractor) {
            $scope.itemSubgrupos.contractor = order.contratanteSubgrupo;
            if (order.contratanteSubgrupo.value.address_contractor) {
              $scope.itemSubgrupos.contractor =
                order.contratanteSubgrupo.value.id;
              $scope.addressSubgroups =
                order.contratanteSubgrupo.value.address_contractor;
            }
            if ($scope.addressSubgroups.length == 1) {
              $scope.itemSubgrupos.addressSelected = $scope.addressSubgroups[0];
              $scope.itemSubgrupos.address = $scope.addressSubgroups[0].id;
            }
          }
        }
      }
    );

    $scope.changeAddressSubgroup = function (param) {
      $scope.itemSubgrupos.address = param.id;
    };

    $scope.deleteSubgroup = function (index) {
      $scope.subgroupsInfo.splice(index, 1);
      $scope.subgroups.splice(index, 1);
    };

    $scope.copyPackage = function () {
      var copy_pack = angular.copy($scope.copy_packages);
      copy_pack.forEach(function (item) {
        var pack = {
          package_name: item.package_name,
          coverage_package: item.coverage_package,
          type_package: item.type_package,
        };
        $scope.paquetes.push(pack);
      });
    };

    $scope.getPackage = function () {
      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          provider: $scope.caratula.aseguradora.id,
        })
        .then(function success(response) {
          if (response.status === 200) {
            $scope.packages = [];
            if (response.data.length) {
              $scope.packages = response.data;
            }
          }
        })
        .catch(function (error) {
          console.log("error", e);
        });
    };

    $scope.changePackage = function (param) {
      if (param) {
        order.defaults = {
          package_name: param.package_name,
          formInfo: { code: $scope.caratula.subramo.subramo_code },
          coverages: [],
          coverageList: [],
        };
        $scope.coveragesPackages = param.coverage_package;
        $scope.personalizePackage = true;
        param.coverage_package.forEach(function (element) {
          if (element.default) {
            order.defaults.coverages.push(angular.copy(element));
          } else {
            order.defaults.coverageList.push(angular.copy(element));
          }
        });
      } else {
        $scope.coveragesPackages = [];
      }
    };

    $scope.demo = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    $scope.saveSum = function (parValue, parCoverage) {
      $scope.n_exis = 0;
      parCoverage.sums_coverage.forEach(function (item) {
        $scope.exist_flag = false;
        if (item) {
          if (item.sum_insured == parValue) {
            $scope.exist_flag = true;
            $scope.n_exis = $scope.n_exis + 1;
            if ($scope.exist_flag == true) {
              $scope.exist_flag = true;
              $scope.n_exis = $scope.n_exis + 1;
            }
          } else if ($scope.n_exis == 0 || $scope.n_exis == undefined) {
            $scope.exist_flag = false;
          }
          if ($scope.n_exis > 0) {
            $scope.exist_flag = true;
          }
        }
      });
      if (
        !$scope.exist_flag ||
        $scope.n_exis == 0 ||
        $scope.n_exis == undefined
      ) {
        var obj = {
          sum_insured: parValue,
          default: false,
          coverage_sum: parCoverage.url,
        };

        coverageService.createSumInsured(obj).then(function (response) {
          if (response.id) {
            $scope.result_ = false;
            parCoverage.sums_coverage.push(response);
          }
        });
      }
    };

    $scope.saveDed = function (parValue, parCoverage) {
      $scope.n_exis = 0;
      parCoverage.deductible_coverage.forEach(function (item) {
        $scope.exist_flag = false;
        if (item) {
          if (item.deductible == parValue) {
            $scope.exist_flag = true;
            $scope.n_exis = $scope.n_exis + 1;
            if ($scope.exist_flag == true) {
              $scope.exist_flag = true;
              $scope.n_exis = $scope.n_exis + 1;
            }
          } else if ($scope.n_exis == 0 || $scope.n_exis == undefined) {
            $scope.exist_flag = false;
          }
          if ($scope.n_exis > 0) {
            $scope.exist_flag = true;
          }
        }
      });
      if (
        !$scope.exist_flag ||
        $scope.n_exis == 0 ||
        $scope.n_exis == undefined
      ) {
        var obj = {
          deductible: parValue,
          default: false,
          coverage_deductible: parCoverage.url,
        };

        coverageService.createDeducible(obj).then(function (response) {
          if (response.id) {
            $scope.result_ = false;
            parCoverage.deductible_coverage.push(response);
          }
        });
      }
    };

    order.options = {
      deleteCoverage: function (obj, index) {
        order.defaults.coverages.splice(index, 1);
        order.defaults.coverageList.push(obj);
      },
      addCoverage: function (obj) {
        if (obj) {
          order.defaults.coverages.push(obj);

          order.defaults.coverageList.forEach(function (coverage) {
            if (coverage.coverage_name == obj.coverage_name) {
              order.defaults.coverageList.splice(
                order.defaults.coverageList.indexOf(coverage),
                1
              );
            }
          });
        }
      },
    };

    $scope.addPackageCoverage = function (param) {
      if (param) {
        var coverage = {
          coverage_name: "",
          sums_coverage: [],
          deductible: [],
          coinsurance_coverage: [],
          topecoinsurance_coverage: [],
        };
        $scope.newCoverages.push(coverage);
      } else {
        $scope.newCoverages = [];
      }
    };

    $scope.deletePackageCoverage = function (index) {
      $scope.newCoverages.splice(index, 1);
    };

    $scope.saveCoverage = function (param) {
      $scope.newCoverages.forEach(function (coverage, index) {
        if (coverage.coverage_name) {
          var covObj = {
            coverage_name: coverage.coverage_name,
            provider: $scope.caratula.aseguradora.url,
            package: param.url,
            sums_coverage: [],
            deductible_coverage: [],
            coinsurance_coverage: [],
            topecoinsurance_coverage: [],
            typeCoverage: 2,
          };

          var test = {
            coverage_sum: coverage.url,
            default: true,
            id: 0,
            org: "",
            sum_insured: coverage.sums_coverage ? coverage.sums_coverage : 0,
            url: "",
          };
          covObj.sums_coverage.push(test);

          var test = {
            coverage_deductible: coverage.url,
            default: true,
            id: 0,
            org: "",
            deductible: coverage.deductible_coverage
              ? coverage.deductible_coverage
              : 0,
            url: "",
          };
          covObj.deductible_coverage.push(test);

          $http
            .post(url.IP + "coberturas-configuraciones/", covObj)
            .then(createCoverageComplete)
            .catch(createCoverageFailed);

          function createCoverageComplete(response) {
            if (response.status == 200 || response.status == 201) {
              order.defaults.coverages.push(covObj);
              if (index + 1 == $scope.newCoverages.length) {
                $scope.addPackageCoverage(false);
              }
            }
          }

          function createCoverageFailed(error) {}
        }
      });
    };

    $scope.showNewPackage = function (param) {
      $scope.newPackage = param;
      $scope.personalizePackage = false;
      $scope.newPackageCoverage = {
        package_name: "",
        description: "",
        coverage_package: [
          {
            coverage_name: "",
            deductible: "",
            sums_coverage: [],
            coinsurance_coverage: [],
          },
        ],
      };
    };

    $scope.addNewPackageCoverage = function () {
      var coverage = {
        coverage_name: "",
        sums_coverage: [],
        deductible: [],
        coinsurance_coverage: [],
        topecoinsurance_coverage: [],
      };
      $scope.newPackageCoverage.coverage_package.push(coverage);
    };

    $scope.deleteNewPackageCoverage = function (index) {
      $scope.newPackageCoverage.coverage_package.splice(index, 1);
    };

    $scope.saveNewPackage = function () {
      if (!$scope.caratula.subramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      var data = {
        package_name: $scope.newPackageCoverage.package_name,
        provider: $scope.caratula.aseguradora.id,
        ramo: $scope.caratula.ramo.id,
        subramo: $scope.caratula.subramo.id,
        coverage_package: $scope.newPackageCoverage.coverage_package,
        type_package: 1,
      };
      $http
        .post(url.IP + "packagecreate_new/", data)
        .then(function success(response) {
          if (response.status == 200) {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWPACKAGE, "success");
            $scope.getPackage();
            $scope.showNewPackage(false);
          } else {
            SweetAlert.swal(
              "¡Listo!",
              MESSAGES.OK.ERRORCREATEPACKAGE,
              "success"
            );
          }
        })
        .catch(function (error) {
          console.log("error", e);
        });
    };

    $scope.addCoverageArray = function (param) {
      if (param.selected) {
        $scope.package.coverage_package.push(angular.copy(param));
      } else {
        $scope.package.coverage_package.forEach(function (item, index, object) {
          if (param.id == item.id) {
            object.splice(index, 1);
          }
        });
      }
    };

    $scope.currency = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    $scope.deleteCoverage = function (param) {
      $scope.configCoverages.splice($scope.configCoverages.indexOf(param), 1);
      $scope.coveragesPackages.forEach(function (item) {
        if (item.coverage_name == param.coverage_name) {
          item.selected = false;
        }
      });
    };

    $scope.addPackage = function () {
      $scope.package.package_name = order.defaults.package_name;
      $scope.package.coverage_package = order.defaults.coverages;
      // if(!$scope.package.package_name){
      //   SweetAlert.swal("Error", "Escribe un nombre del paquete.", "error");
      //   return;
      // }
      if ($scope.package.coverage_package.length == 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
        return;
      }
      if ($scope.package.coverage_package[0].coverage_name) {
        if (
          !$scope.package.coverage_package[0].sumInPolicy ||
          !$scope.package.coverage_package[0].deductibleInPolicy
        ) {
          SweetAlert.swal("Error", MESSAGES.ERROR.DEDUCTIBLEREQUIRED, "error");
          return;
        }
      }
      var pack = angular.copy($scope.package);
      $scope.paquetes.push(pack);
      $scope.package = {
        package_name: "",
        coverage_package: [],
        type_package: 2,
      };

      $scope.packageSelected = {};
      $scope.personalizePackage = false;
      $scope.getPackage();
    };

    $scope.deletePackage = function (index) {
      $scope.paquetes.splice(index, 1);
    };
    function isString(x) {
      return Object.prototype.toString.call(x) === "[object String]";
    }
    $scope.disabled = false;
    $scope.validityInsurance = function () {
      $scope.disabled = true;
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (
        !$scope.showOt &&
        $scope.caratula.receipts_by != 3 &&
        !$scope.directiveReceipts.canCreate
      ) {
        l.stop();
        $scope.disabled = false;
        SweetAlert.swal(
          "Error",
          "OPRIMA EL BOTON CALCULAR Y GENERAR RECIBOS",
          "error"
        );
        return;
      }

      if (!$scope.caratula.identifier) {
        l.stop();
        $scope.disabled = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.IDENTIFIERREQUIRED, "error");
        return;
      }
      if (!$scope.showOt) {
        if (!$scope.caratula.poliza_number) {
          l.stop();
          $scope.disabled = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
          return;
        }
      }
      if (!order.contratante.val) {
        l.stop();
        $scope.disabled = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        return;
      }
      if (!$scope.caratula.address) {
        l.stop();
        $scope.disabled = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        return;
      }
      if (!$scope.caratula.aseguradora) {
        l.stop();
        $scope.disabled = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        return;
      }
      if (!$scope.caratula.clave) {
        l.stop();
        $scope.disabled = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        return;
      }
      if (!$scope.caratula.ramo) {
        $scope.disabled = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        return;
      }
      if (!$scope.caratula.subramo) {
        $scope.disabled = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (!$scope.caratula.administration_type) {
        l.stop();
        $scope.disabled = false;
        SweetAlert.swal(
          "Error",
          MESSAGES.ERROR.ADMINISTRATIONREQUIRED,
          "error"
        );
        return;
      }
      if (!$scope.caratula.forma_de_pago) {
        l.stop();
        $scope.disabled = false;
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORPAYFORM, "error");
        return;
      }
      if (!$scope.showOt && $scope.caratula.receipts_by == 1) {
        if (!$scope.dataToSave.recibos_poliza) {
          l.stop();
          $scope.disabled = false;
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
        if ($scope.caratula.scheme == 2) {
          if (
            $scope.dataToSave.steps.length !=
            $scope.dataToSave.recibos_poliza.length - 1
          ) {
            l.stop();
            $scope.disabled = false;
            SweetAlert.swal(
              "Error",
              "El número de escalones no coincide con el número de recibos.",
              "error"
            );
            return;
          }
          if (parseFloat($scope.dataToSave.sumaPorcentaje) != 100) {
            l.stop();
            $scope.disabled = false;
            SweetAlert.swal(
              "Error",
              "La sumatoria de todos los porcentajes de cada escalon no pueden se diferente al 100%, verifica los porcentajes.",
              "error"
            );
            return;
          }
        }
      }
      if ($scope.subgroups.length == 0 && !$scope.showOt) {
        l.stop();
        $scope.disabled = false;
        SweetAlert.swal("Error", "Agrega un subgrupo", "error");
        return;
      }
      if ($scope.paquetes.length == 0 && !$scope.showOt) {
        l.stop();
        $scope.disabled = false;
        SweetAlert.swal("Error", "Agrega un paquete", "error");
        return;
      }
      $scope.referenciadoresSelected = [];
      $scope.referenciadorArray.forEach(function (item) {
        if (item.referenciador != "") {
          if (item.comision_vendedor == "") {
            item.comision_vendedor = 0;
          }
          $scope.referenciadoresSelected.push(item);
        }
      });
      $scope.referenciadores_copy = $scope.referenciadoresSelected.filter(
        function (item) {
          return item && item.referenciador;
        }
      );
      if ($scope.acceso_cno_pol == false) {
        if (
          ($scope.referenciadorArray &&
            $scope.referenciadorArray.length == 0) ||
          ($scope.referenciadores_copy &&
            $scope.referenciadores_copy.length == 0)
        ) {
          l.stop();
          $scope.disabled = false;
          SweetAlert.swal("Error", "Seleccione el referenciador.", "error");
          return;
        }
      }

      $scope.saveInsurance();
    };

    $scope.changeBusinessLine = function (val) {
      $scope.business_lineSelected = val;
    };

    $scope.saveInsurance = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.disabled = true;
      $scope.caratula_renewal = {
        identifier: $scope.caratula.identifier
          ? $scope.caratula.identifier
          : null,
        internal_number: $scope.caratula.internal_number
          ? $scope.caratula.internal_number
          : null,
        folio: $scope.caratula.folio ? $scope.caratula.folio : null,
        poliza_number: $scope.caratula.poliza_number
          ? $scope.caratula.poliza_number
          : null,
        contractor: $scope.caratula.contractor
          ? $scope.caratula.contractor
          : null,
        address: $scope.caratula.address,
        start_of_validity: $scope.caratula.start_of_validity,
        end_of_validity: $scope.caratula.end_of_validity,
        aseguradora: $scope.caratula.aseguradora.id,
        clave: $scope.caratula.clave,
        ramo: $scope.caratula.ramo.id,
        subramo: $scope.caratula.subramo.id,
        is_renewable: $scope.caratula.is_renewable
          ? $scope.caratula.is_renewable
          : $scope.renewalSelected
          ? $scope.renewalSelected.value
          : null,
        administration_type:
          $scope.caratula.administration_type == "Simplificada"
            ? 1
            : $scope.caratula.administration_type == "Autoadministrada"
            ? 2
            : 3,
        f_currency: $scope.caratula.f_currency,
        responsable: $scope.caratula.responsable
          ? $scope.caratula.responsable
          : null,
        collection_executive: $scope.caratula.collection_executive
          ? $scope.caratula.collection_executive
          : null,
        sucursal: $scope.caratula.sucursal ? $scope.caratula.sucursal : null,
        observations: $scope.caratula.observations
          ? $scope.caratula.observations
          : "",
        forma_de_pago: $scope.caratula.forma_de_pago,
        scheme: $scope.caratula.scheme,
        p_neta: $scope.dataToSave.p_neta ? $scope.dataToSave.p_neta : 0,
        descuento: $scope.dataToSave.descuento
          ? $scope.dataToSave.descuento
          : 0,
        rpf: $scope.dataToSave.rpf ? $scope.dataToSave.rpf : 0,
        derecho: $scope.dataToSave.derecho ? $scope.dataToSave.derecho : 0,
        sub_total: $scope.dataToSave.sub_total
          ? $scope.dataToSave.sub_total
          : 0,
        iva: $scope.dataToSave.iva ? $scope.dataToSave.iva : 0,
        p_total: $scope.dataToSave.p_total ? $scope.dataToSave.p_total : 0,
        comision: $scope.dataToSave.comision ? $scope.dataToSave.comision : 0,
        comision_percent: $scope.dataToSave.comision_percent
          ? $scope.dataToSave.comision_percent
          : 0,
        receipts_by: $scope.caratula.receipts_by
          ? $scope.caratula.receipts_by
          : null,
        recibos_poliza: $scope.dataToSave.recibos_poliza
          ? $scope.dataToSave.recibos_poliza
          : [],
        total_receipts: $scope.dataToSave.recibos_poliza
          ? $scope.dataToSave.recibos_poliza.length
          : $scope.caratula.total_receipts,
        accident_rate: $scope.dataToSave.accident_rate
          ? $scope.dataToSave.accident_rate
          : 0,
        steps: $scope.dataToSave.steps ? $scope.dataToSave.steps : [],
        status: $scope.showOt ? 1 : 14,
        document_type: 3,
        business_line: $scope.business_lineSelected
          ? $scope.business_lineSelected.id
          : 0,
        celula: $scope.caratula.celula ? $scope.caratula.celula : "",
        groupinglevel: $scope.caratula.groupinglevel
          ? $scope.caratula.groupinglevel
          : "",
        conducto_de_pago: $scope.conductoSelected
          ? $scope.conductoSelected
          : $scope.caratula.conducto_de_pago,
      };

      if ($scope.caratula.poliza_number) {
        if (
          process(convertDate($scope.caratula.start_of_validity)) >
          process(convertDate(new Date()))
        ) {
          $scope.caratula_renewal.status = 10;
        } else {
          $scope.caratula_renewal.status = 14;
        }
      }

      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }

      $scope.referenciadoresSelected = [];
      $scope.referenciadorArray.forEach(function (item) {
        if (item.referenciador != "") {
          if (item.comision_vendedor == "") {
            item.comision_vendedor = 0;
          }
          $scope.referenciadoresSelected.push(item);
        }
      });

      $scope.subgroups.forEach(function (subgrupo, index_sub) {
        if (subgrupo["recibos_poliza"]) {
          subgrupo.recibos_poliza.forEach(function (recibo, index) {
            $scope.subgroups[index_sub]["recibos_poliza"][index][
              "conducto_de_pago"
            ] = $scope.caratula_renewal.conducto_de_pago;
          });
        }
      });

      $scope.colectividad = {
        caratula: $scope.caratula_renewal,
        referenciadores: $scope.referenciadoresSelected,
        subgrupos: $scope.subgroups,
        paquetes: $scope.paquetes,
      };

      $http
        .post(url.IP + "caratula-complete/", $scope.colectividad)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            $localStorage.save_renewal_poliza_grupo = {};
            $scope.dataCaratula = response.data.data.caratula;
            $scope.dataSubgroup = response.data.data.childs;
            $scope.dataPackage = response.data.data.paquetes;
            if ($scope.dataCaratula.ramo.ramo_code == 1) {
              $scope.layout_name = "Layout_Col_Vida.xls";
            } else if ($scope.dataCaratula.ramo.ramo_code == 2) {
              $scope.layout_name = "Layout_Col_GM.xls";
            } else if ($scope.dataCaratula.ramo.ramo_code == 3) {
              if ($scope.dataCaratula.subramo.subramo_name == "Automóviles") {
                $scope.layout_name = "Layout_Col_Flotillas.xls";
              } else if (
                $scope.dataCaratula.subramo.subramo_name == "Diversos"
              ) {
                $scope.layout_name = "Layout_Col_Equipo.xls";
              } else {
                $scope.layout_name = "Layout_Col_Danios.xls";
              }
            }
            if ($scope.countFile > 0) {
              l.stop();
              $scope.disabled = false;
              uploadFiles($scope.dataCaratula.id);
            } else {
              l.stop();
              $scope.disabled = false;
              if ($scope.dataCaratula.poliza_number) {
                SweetAlert.swal(
                  "¡Listo!",
                  "Colectividad creada exitosamente.",
                  "success"
                );
                $scope.nextCertificate();
              }
              if (!$scope.dataCaratula.poliza_number) {
                SweetAlert.swal(
                  "¡Listo!",
                  "Orden de Trabajo creada exitosamente.",
                  "success"
                );
                if (
                  $scope.subgroups.length == 0 ||
                  $scope.paquetes.length == 0
                ) {
                  $state.go("colectividades.info", {
                    polizaId: $scope.dataCaratula.id,
                  });
                } else {
                  $scope.nextCertificate();
                }
              }
            }

            /* Actualiza la póliza antigua */
            if (
              process(convertDate($scope.caratula.start_of_validity)) >
              process(convertDate(new Date()))
            ) {
              if ($scope.dataCaratula.poliza_number) {
                var data = {
                  status: 12,
                  renewed_status: 1 /* renueva como póliza */,
                };
              } else {
                var data = {
                  renewed_status: 2 /* renueva como ot */,
                };
              }
            } else {
              // var data = {
              //   renewed: true,
              //   status: 12,
              //   renewed_status: 1/* renueva como póliza */
              // }
              if ($scope.dataCaratula.poliza_number) {
                var data = {
                  status: 12,
                  renewed_status: 1 /* renueva como póliza */,
                };
              } else {
                var data = {
                  renewed_status: 2 /* renueva como ot */,
                };
              }
            }

            $http
              .patch($scope.copy_caratula.url, data)
              .then(function (resp) {})
              .catch(function (e) {
                l.stop();
                console.log("error - caratula - catch", e);
              });

            /* Relación con la póliza original */
            if ($scope.copy_caratula.poliza_number) {
              var oldPolicy = {
                policy: $scope.copy_caratula.poliza_number,
                base_policy: $scope.copy_caratula.url,
                new_policy: $scope.dataCaratula.url,
              };
            } else {
              var oldPolicy = {
                base_policy: $scope.copy_caratula.url,
                new_policy: $scope.dataCaratula.url,
              };
            }
            $http
              .post(url.IP + "v1/polizas/viejas/", oldPolicy)
              .then(function (res) {})
              .catch(function (e) {
                l.stop();
                console.log("error - caratula - catch", e);
              });

            var paramsRec = {
              model: 13,
              event: "PATCH",
              associated_id: $scope.copy_caratula.id,
              identifier: $scope.dataCaratula.poliza_number
                ? " renovó la poliza a " + $scope.dataCaratula.poliza_number
                : " renovó la póliza a OT",
              change: [],
            };
            dataFactory
              .post("send_log_specific/", paramsRec)
              .then(function success(responseLo) {});

            var paramsC = {
              model: 13,
              event: "PATCH",
              associated_id: $scope.dataCaratula.id,
              identifier:
                " creó la renovación a partir de " +
                $scope.copy_caratula.poliza_number,
              change: [],
            };
            dataFactory
              .post("send_log_specific/", paramsC)
              .then(function success(responseLo) {});

            $http.patch(order.contratante.value.url, {
              email: order.contratante.value.email,
              phone_number: order.contratante.value.phone_number,
            });
          } else {
            l.stop();
            $scope.disabled = false;
            SweetAlert.swal("Error", response.data.data, "error");
          }
        })
        .catch(function (e) {
          l.stop();
          $scope.disabled = false;
          console.log("error - caratula - catch", e);
        });
    };

    $scope.goToInformation = function () {
      if (!$scope.dataCaratula.id) {
        SweetAlert.swal("¡Error!", "Debes crear la carátula primero.", "error");
        return;
      } else {
        $state.go("colectividades.info", { polizaId: $scope.dataCaratula.id });
      }
    };

    $scope.validateEmail = function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      if (!$scope.dataCaratula.id) {
        SweetAlert.swal(
          "¡Error!",
          "Debes crear la carátula primero para poder cargar certificados.",
          "error"
        );
        return;
      } else {
        var flagCertificate = false;
        if (param.VIDA) {
          if ($scope.dataCaratula.subramo.subramo_name == "Vida") {
            $scope.beneficiaries_life = [];
            $scope.excelJson = param.VIDA;
            $scope.excelJson.forEach(function (item) {
              if (!item.FAMILIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FAMILIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CERTIFICADO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CORREO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateEmail(item.CORREO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.TIPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.TIPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.TIPO < 1 || item.TIPO > 2) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.PARENTESCO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PARENTESCO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.PARENTESCO < 1 || item.PARENTESCO > 4) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna PARENTESCO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.NOMBRE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.APELLIDO_PATERNO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.APELLIDO_MATERNO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.FECHA_NACIMIENTO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SEXO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.SEXO.length > 1) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SEXO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.FECHA_ANTIGUEDAD) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.FECHA_ANTIGUEDAD)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.TIPO_SUMA_ASEGURADA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.TIPO_SUMA_ASEGURADA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO_SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (
                    item.TIPO_SUMA_ASEGURADA < 1 ||
                    item.TIPO_SUMA_ASEGURADA > 2
                  ) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna TIPO_SUMA_ASEGURADA no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.SUMA_ASEGURADA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SUELDO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUELDO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.FUMADOR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FUMADOR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.FUMADOR)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FUMADOR, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.FUMADOR < 0 || item.FUMADOR > 1) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna FUMADOR no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.VIGENCIA_INICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_FIN) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SUBGRUPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.SUBGRUPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.CATEGORIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.CATEGORIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              try {
                if (item.PRIMA_NETA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.RPF.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.DERECHO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.IVA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.COMISION.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              } catch (e) {}
              if (item.TIPO == 2) {
                var dataBeneficiary = {
                  familia: item.FAMILIA,
                  certificate: item.CERTIFICADO,
                  optional_relationship: item.PARENTESCO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: toDate(item.FECHA_NACIMIENTO),
                  sex: item.SEXO,
                  antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                  percentage: 0,
                };
                $scope.beneficiaries_life.push(dataBeneficiary);
              }
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else if (param.ASEGURADOS) {
          if ($scope.dataCaratula.subramo.subramo_name == "Gastos Médicos") {
            $scope.beneficiaries_medical = [];
            $scope.excelJson = param.ASEGURADOS;
            $scope.excelJson.forEach(function (item) {
              if (!item.FAMILIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FAMILIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CERTIFICADO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CORREO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateEmail(item.CORREO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.TIPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.TIPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.TIPO < 1 || item.TIPO > 2) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.PARENTESCO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PARENTESCO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.PARENTESCO < 1 || item.PARENTESCO > 4) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna PARENTESCO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.NOMBRE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.APELLIDO_PATERNO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.APELLIDO_MATERNO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.FECHA_NACIMIENTO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SEXO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.SEXO.length > 1) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SEXO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.FECHA_ANTIGUEDAD) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.FECHA_ANTIGUEDAD)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_INICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_FIN) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SUBGRUPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.SUBGRUPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.CATEGORIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.CATEGORIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              try {
                if (item.PRIMA_NETA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.RPF.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.DERECHO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.IVA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.COMISION.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              } catch (e) {}
              if (item.TIPO == 2) {
                var dataBeneficiary = {
                  familia: item.FAMILIA,
                  certificate: item.CERTIFICADO,
                  relationship: item.PARENTESCO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: toDate(item.FECHA_NACIMIENTO),
                  sex: item.SEXO,
                  antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                  clause: item.FAMILIA,
                  p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                  rpf: item.RPF ? item.RPF : 0,
                  derecho: item.DERECHO ? item.DERECHO : 0,
                  iva: item.IVA ? item.IVA : 0,
                  p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
                  comision: item.COMISION ? item.COMISION : 0,
                };
                $scope.beneficiaries_medical.push(dataBeneficiary);
              }
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else if (param.FLOTILLA) {
          if ($scope.dataCaratula.subramo.subramo_name == "Automóviles") {
            $scope.excelJson = param.FLOTILLA;
            $scope.excelJson.forEach(function (item) {
              if (!item.INCISO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CORREO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateEmail(item.CORREO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.MARCA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MODELO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.AÑO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna AÑO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SERVICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SERVICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PROCEDENCIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PROCEDENCIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.PROCEDENCIA < 0 || item.PROCEDENCIA > 4) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna PROCEDENCIA no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.USO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.USO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.USO < 1 || item.USO > 3) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.VERSION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SERIE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.VIGENCIA_INICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_FIN) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SUBGRUPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.SUBGRUPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.CATEGORIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.CATEGORIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              try {
                if (item.PRIMA_NETA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.RPF.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.DERECHO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.IVA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.COMISION.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              } catch (e) {}
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else if (param.DANIOS_DIVERSO) {
          if ($scope.dataCaratula.subramo.subramo_name == "Diversos") {
            $scope.excelJson = param.DANIOS_DIVERSO;
            $scope.excelJson.forEach(function (item) {
              if (!item.INCISO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CORREO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateEmail(item.CORREO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.MARCA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MODELO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.DESCRIPCION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DESCRIPCION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.AÑO_CONSTRUCCION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna AÑO_CONSTRUCCION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.AÑO_RECONSTRUCCION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna AÑO_RECONSTRUCCION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.VALOR_COMPRA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VALOR_COMPRA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.USO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.USO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.USO < 1 || item.USO > 3) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.VERSION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SERIE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.VIGENCIA_INICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_FIN) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SUBGRUPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.SUBGRUPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.CATEGORIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.CATEGORIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              try {
                if (item.PRIMA_NETA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.RPF.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.DERECHO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.IVA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.COMISION.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              } catch (e) {}
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else if (param.DANIOS_IRC) {
          if (
            $scope.dataCaratula.subramo.subramo_name == "Incendio" ||
            $scope.dataCaratula.subramo.subramo_name == "Responsabilidad Civil"
          ) {
            $scope.excelJson = param.DANIOS_IRC;
            $scope.excelJson.forEach(function (item) {
              if (!item.INCISO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CORREO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateEmail(item.CORREO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SUCURSAL) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUCURSAL, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.GIRO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna GIRO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.TIPO_CONSTRUCTIVO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_CONSTRUCTIVO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.TIPO_CONSTRUCTIVO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO_CONSTRUCTIVO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (
                    item.TIPO_CONSTRUCTIVO < 1 ||
                    item.TIPO_CONSTRUCTIVO > 3
                  ) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna TIPO_CONSTRUCTIVO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.NO_NIVELES) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_NIVELES, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.ZONA_FHM) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna ZONA_FHM, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.ZONA_TYEV) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna ZONA_TYEV, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CALLE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CALLE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.NO_INTERIOR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_INTERIOR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.NO_EXTERIOR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_EXTERIOR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MUNICIPIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MUNICIPIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.COLONIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COLONIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CIUDAD) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CIUDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.ESTADO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna ESTADO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CP) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CP, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SUBGRUPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.SUBGRUPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.CATEGORIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.CATEGORIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              try {
                if (item.PRIMA_NETA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.RPF.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.DERECHO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.IVA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.COMISION.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              } catch (e) {}
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
            "error"
          );
        }
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.cancelCertificates = function () {
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.saveCertificates = function () {
      $scope.loader = true;
      $scope.certifcados = [];

      if ($scope.selectedCertificates.VIDA) {
        $scope.selectedCertificates.VIDA.forEach(function (item) {
          if (item.TIPO == 1) {
            var dataLife = [
              {
                personal: {
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: toDate(item.FECHA_NACIMIENTO),
                  antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  salary: item.SUELDO ? parseInt(item.SUELDO) : 0,
                  sum_assured: item.SUMA_ASEGURADA
                    ? parseInt(item.SUMA_ASEGURADA)
                    : 0,
                  type_sa: item.TIPO_SUMA_ASEGURADA
                    ? parseInt(item.TIPO_SUMA_ASEGURADA)
                    : 0,
                },
                smoker: item.FUMADOR
                  ? item.FUMADOR == 0
                    ? false
                    : true
                  : null,
                beneficiaries_life: [],
              },
            ];

            $scope.beneficiaries_life.forEach(function (beneficiarie) {
              if (beneficiarie.familia == item.FAMILIA) {
                dataLife[0].beneficiaries_life.push(beneficiarie);
              }
            });

            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            if (item.SUBGRUPO) {
              $scope.dataSubgroup.forEach(function (itemSubgrupo) {
                if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                  if (itemSubgrupo.address) {
                    contractor_certificate = itemSubgrupo.contractor
                      ? itemSubgrupo.contractor.id
                      : null;
                  } else {
                    contractor_certificate = $scope.dataCaratula.contractor
                      ? $scope.dataCaratula.contractor
                      : null;
                  }
                }
              });
            } else {
              contractor_certificate = $scope.dataCaratula.contractor
                ? $scope.dataCaratula.contractor
                : null;
            }

            var certificateData = {
              caratula: $scope.dataCaratula.id,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number:
                $scope.dataCaratula.poliza_number +
                " - INC. " +
                item.CERTIFICADO,
              contractor: contractor_certificate,
              ramo: $scope.dataCaratula.ramo.id,
              subramo: $scope.dataCaratula.subramo.id,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: toDate(item.VIGENCIA_INICIO),
              end_of_validity: toDate(item.VIGENCIA_FIN),
              status: $scope.dataCaratula.status == "Vigente" ? 14 : 1,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: [],
              life_policy: dataLife,
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "VIDA_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
              rpf: item.RPF ? item.RPF : 0,
              derecho: item.DERECHO ? item.DERECHO : 0,
              iva: item.IVA ? item.IVA : 0,
              p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
              comision: item.COMISION ? item.COMISION : 0,
              rec_antiguedad: toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
            };

            $scope.certifcados.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.ASEGURADOS) {
        $scope.selectedCertificates.ASEGURADOS.forEach(function (item) {
          if (item.TIPO == 1) {
            var dataMedical = [
              {
                personal: {
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: toDate(item.FECHA_NACIMIENTO),
                  antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                  rpf: item.RPF ? item.RPF : 0,
                  derecho: item.DERECHO ? item.DERECHO : 0,
                  iva: item.IVA ? item.IVA : 0,
                  p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
                  comision: item.COMISION ? item.COMISION : 0,
                },
                disease_type: 0,
                relationship_accident: [],
              },
            ];

            $scope.beneficiaries_medical.forEach(function (beneficiarie) {
              if (beneficiarie.familia == item.FAMILIA) {
                dataMedical[0].relationship_accident.push(beneficiarie);
              }
            });

            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            if (item.SUBGRUPO) {
              $scope.dataSubgroup.forEach(function (itemSubgrupo) {
                if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                  if (itemSubgrupo.address) {
                    contractor_certificate = itemSubgrupo.contractor
                      ? itemSubgrupo.contractor.id
                      : null;
                  } else {
                    contractor_certificate = $scope.dataCaratula.contractor
                      ? $scope.dataCaratula.contractor
                      : null;
                  }
                }
              });
            } else {
              contractor_certificate = $scope.dataCaratula.contractor
                ? $scope.dataCaratula.contractor
                : null;
            }

            var certificateData = {
              caratula: $scope.dataCaratula.id,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number:
                $scope.dataCaratula.poliza_number +
                " - INC. " +
                item.CERTIFICADO,
              contractor: contractor_certificate,
              ramo: $scope.dataCaratula.ramo.id,
              subramo: $scope.dataCaratula.subramo.id,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: toDate(item.VIGENCIA_INICIO),
              end_of_validity: toDate(item.VIGENCIA_FIN),
              status: $scope.dataCaratula.status == "Vigente" ? 14 : 1,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: dataMedical,
              life_policy: [],
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "GASTOS_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
              rpf: item.RPF ? item.RPF : 0,
              derecho: item.DERECHO ? item.DERECHO : 0,
              iva: item.IVA ? item.IVA : 0,
              p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
              comision: item.COMISION ? item.COMISION : 0,
              rec_antiguedad: toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
            };
            $scope.certifcados.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.FLOTILLA) {
        $scope.selectedCertificates.FLOTILLA.forEach(function (item) {
          var dataCar = [
            {
              car_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              driver: item.CONDUCTOR ? item.CONDUCTOR : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              brand: item.MARCA,
              model: item.MODELO,
              year: item.AÑO,
              version: item.VERSION,
              serial: item.SERIE,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              license_plates: item.MATRICULA ? item.MATRICULA : null,
              usage: parseInt(item.USO),
              service: item.SERVICIO,
              procedencia: parseInt(item.PROCEDENCIA),
              sum_insured: item.VALOR_O_SUMA_ASEGURADA
                ? item.VALOR_O_SUMA_ASEGURADA
                : null,
              charge_type: item.TIPO_CARGA ? parseInt(item.TIPO_CARGA) : null,
              adjustment: item.ADAPTACIONES ? item.ADAPTACIONES : null,
              mont_adjustment: item.MONTO_ADAPTACIONES
                ? item.MONTO_ADAPTACIONES
                : null,
              special_team: item.EQUIPAMIENTO ? item.EQUIPAMIENTO : null,
              mont_special_team: item.MONTO_EQUIPAMIENTO
                ? item.MONTO_EQUIPAMIENTO
                : null,
              beneficiary_name: null,
              preferential_benefiaciary: item.BENEFICIARIO_PREFERENTE
                ? item.BENEFICIARIO_PREFERENTE
                : null,
              beneficiary_rfc: item.BENEFICIARIO_RFC
                ? item.BENEFICIARIO_RFC
                : null,
              beneficiary_address: item.BENEFICIARIO_DIRECCION
                ? item.BENEFICIARIO_DIRECCION
                : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.dataSubgroup.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.dataCaratula.contractor
                    ? $scope.dataCaratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.dataCaratula.contractor
              ? $scope.dataCaratula.contractor
              : null;
          }

          var certificateData = {
            caratula: $scope.dataCaratula.id,
            certificate_number: item.INCISO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number:
              $scope.dataCaratula.poliza_number + " - INC. " + item.INCISO,
            contractor: contractor_certificate,
            ramo: $scope.dataCaratula.ramo.id,
            subramo: $scope.dataCaratula.subramo.id,
            paquete: item.PAQUETE,
            observations: "",
            old_policies: [],
            start_of_validity: toDate(item.VIGENCIA_INICIO),
            end_of_validity: toDate(item.VIGENCIA_FIN),
            status: $scope.dataCaratula.status == "Vigente" ? 14 : 1,
            automobiles_policy: dataCar,
            damages_policy: [],
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
            rpf: item.RPF ? item.RPF : 0,
            derecho: item.DERECHO ? item.DERECHO : 0,
            iva: item.IVA ? item.IVA : 0,
            p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
            comision: item.COMISION ? item.COMISION : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      } else if (
        $scope.selectedCertificates.DANIOS_DIVERSO ||
        $scope.selectedCertificates.DANIOS_IRC
      ) {
        var excelJson = [];
        if ($scope.selectedCertificates.DANIOS_DIVERSO) {
          excelJson = $scope.selectedCertificates.DANIOS_DIVERSO;
        } else if ($scope.selectedCertificates.DANIOS_IRC) {
          excelJson = $scope.selectedCertificates.DANIOS_IRC;
        }
        excelJson.forEach(function (item) {
          var dataDamage = [
            {
              dam_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              item_details: item.OBSERVACIONES,
              usage: item.USO ? parseInt(item.USO) : 0,
              brand: item.MARCA ? item.MARCA : null,
              model: item.MODELO ? item.MODELO : null,
              construction_year: item.AÑO_CONSTRUCCION
                ? item.AÑO_CONSTRUCCION
                : null,
              reconstruction_year: item.AÑO_RECONSTRUCCION
                ? item.AÑO_RECONSTRUCCION
                : null,
              version: item.VERSION ? item.VERSION : null,
              serial: item.SERIE ? item.SERIE : null,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              matricula: item.MATRICULA ? item.MATRICULA : null,
              permiso: item.PERMISO ? item.PERMISO : null,
              purchase_value: item.VALOR_COMPRA
                ? parseInt(item.VALOR_COMPRA)
                : 0,
              item_address:
                item.CALLE +
                " " +
                item.NO_INTERIOR +
                " Ext." +
                item.NO_EXTERIOR +
                " " +
                item.COLONIA +
                " " +
                item.CIUDAD +
                " " +
                item.ESTADO +
                " C.P." +
                item.CP,
              sucursal: item.SUCURSAL ? item.SUCURSAL : null,
              giro: item.GIRO ? item.GIRO : null,
              type_construction: item.TIPO_CONSTRUCTIVO
                ? parseInt(item.TIPO_CONSTRUCTIVO)
                : 0,
              no_levels: item.NO_NIVELES ? item.NO_NIVELES : null,
              fhm_zone: item.ZONA_FHM ? item.ZONA_FHM : null,
              tyev_zone: item.ZONA_TYEV ? item.ZONA_TYEV : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.dataSubgroup.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.dataCaratula.contractor
                    ? $scope.dataCaratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.dataCaratula.contractor
              ? $scope.dataCaratula.contractor
              : null;
          }

          var certificateData = {
            caratula: $scope.dataCaratula.id,
            certificate_number: item.INCISO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number:
              $scope.dataCaratula.poliza_number + " - INC. " + item.INCISO,
            contractor: contractor_certificate,
            ramo: $scope.dataCaratula.ramo.id,
            subramo: $scope.dataCaratula.subramo.id,
            paquete: item.PAQUETE,
            observations: "",
            old_policies: [],
            start_of_validity: toDate(item.VIGENCIA_INICIO),
            end_of_validity: toDate(item.VIGENCIA_FIN),
            status: $scope.dataCaratula.status == "Vigente" ? 14 : 1,
            automobiles_policy: [],
            damages_policy: dataDamage,
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
            rpf: item.RPF ? item.RPF : 0,
            derecho: item.DERECHO ? item.DERECHO : 0,
            iva: item.IVA ? item.IVA : 0,
            p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
            comision: item.COMISION ? item.COMISION : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      }

      $http({
        method: "POST",
        url: url.IP + "mass-certificates/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal("¡Hecho!", MESSAGES.OK.CERTIFICATESDONE, "success");
            $state.go("colectividades.info", {
              polizaId: $scope.dataCaratula.id,
            });
          } else {
            $scope.loader = false;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORCERTIFICATES, "error");
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
  }
})();

/* global angular */
(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ColectivosInfoCtrl", ColectivosInfoCtrl);
  ColectivosInfoCtrl.$inject = [
    "$uibModal",
    "$sessionStorage",
    "$scope",
    "$state",
    "$stateParams",
    "$http",
    "url",
    "SweetAlert",
    "MESSAGES",
    "FileUploader",
    "$timeout",
    "$parse",
    "dataFactory",
    "$rootScope",
    "datesFactory",
    "generalService",
    "$sce",
    "toaster",
    "$location",
    "$localStorage",
    "appStates",
    "helpers",
    "whatsappWebFlagService",
  ];

  function ColectivosInfoCtrl(
    $uibModal,
    $sessionStorage,
    $scope,
    $state,
    $stateParams,
    $http,
    url,
    SweetAlert,
    MESSAGES,
    FileUploader,
    $timeout,
    $parse,
    dataFactory,
    $rootScope,
    datesFactory,
    generalService,
    $sce,
    toaster,
    $location,
    $localStorage,
    appStates,
    helpers,
    whatsappWebFlagService
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.decrptedtoken = usr;

    var vm = this;
    vm.whatsappWebEnabled = whatsappWebFlagService.isEnabled();
    whatsappWebFlagService.subscribe(function (enabled) {
      $scope.$evalAsync(function () {
        vm.whatsappWebEnabled = enabled;
      });
    }, $scope);
    $scope.allCerificatesCaratula = [];
    $scope.category = {};
    $scope.get_conductos = function (param) {
      param = parseInt(param);
      var conductos = {
        1: "No domiciliada",
        2: "Agente",
        3: "CAC",
        4: "CAT/Domiciliado",
        5: "Nómina",
        6: "CUT",
      };
      return conductos[param];
    };
    $scope.errorMensaje = "";

    $scope.allCerificatesCaratula = [];
    $scope.showOt = true;
    $scope.show_caratula = true;
    $scope.show_masivopdfs = false;
    $scope.show_subgrupo = false;
    $scope.show_paquete = false;
    $scope.show_certificado = false;
    $scope.okFile = 0;
    $scope.countFile = 0;
    $scope.incompleteOT = {
      complete: true,
      caratule: [],
      subgroups: [],
      packages: [],
      certificates: [],
    };
    vm.createRecordatorio = createRecordatorio;
    vm.changeEndorsement = changeEndorsement;
    $scope.infoFlag = true;
    $scope.endoFlag = false;
    $scope.noteFlag = false;
    $scope.adjuFlag = false;
    $scope.show_historic = false;
    vm.showRecordatorios = showRecordatorios;
    $scope.notesCaratula = [];
    $scope.recibos_poliza = [];

    $scope.show_binnacle_receipt = false;
    $scope.show_binnacle_receipt_endorsement = false;
    $scope.show_binnacle_receipt_subgroup = false;

    $scope.subgroup_total_prima = [];
    $scope.changes = [];
    $scope.categorySelected = {
      id: null,
      is_category: 0,
      certificates: [],
      config: {},
    };

    $scope.dataToSave = {};
    $scope.directiveReceipts = {};
    $scope.periods = [];
    $scope.statusReceiptCertificates = [
      { value: 0, label: "Todos" },
      { value: 4, label: "Pendiente de Pago" },
      { value: 1, label: "Pagado" },
    ];
    $scope.statusReceiptCertificateSelected =
      $scope.statusReceiptCertificates[0];
    $scope.desSelected = false;
    $scope.totalReceiptPeriod = 0;
    $scope.totalReceiptPay = 0;
    $scope.totalReceiptPending = 0;
    $scope.totalReceiptSelected = 0;

    $scope.infoFlagCertificate = true;
    $scope.endorsementFlagCertificate = false;
    $scope.siniesterFlagCertificate = false;

    $rootScope.certificados_a_pagar = [];
    $rootScope.total_a_pagar = 0;

    $localStorage["save_data_certificate"] = {};
    $localStorage["save_data_certificate"]["personal"] = {};
    $scope.isEdit = false;
    $scope.newCertificate = {};

    $scope.excelJson = [];
    $scope.beneficiaries_life = [];
    $scope.beneficiaries_medical = [];
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.showTableCertificates = false;
    $scope.loader = false;
    $scope.certifcados = [];
    $scope.show_beneficiarie = false;
    $scope.statusActive = 1;

    $scope.sexs = [
      { value: "F", label: "Femenino" },
      { value: "M", label: "Masculino" },
    ];
    $scope.typesInsureds = [
      { value: 1, label: "Fija" },
      { value: 2, label: "Regla" },
    ];
    $scope.smokers = [
      { value: false, label: "No" },
      { value: true, label: "Si" },
    ];
    $scope.relationships = [
      { value: 1, label: "Titular" },
      { value: 2, label: "Cónyuge" },
      { value: 3, label: "Hijo" },
      { value: 4, label: "Otro" },
    ];
    $scope.usages = [
      { value: 1, label: "Particular" },
      { value: 2, label: "Carga Comercial" },
      { value: 3, label: "Servicio Público" },
    ];
    $scope.procedencias = [
      { value: 0, label: "Sin especificar" },
      { value: 1, label: "Residencia" },
      { value: 2, label: "Turista" },
      { value: 3, label: "Legalizado" },
      { value: 4, label: "Fronterizo" },
    ];
    $scope.typesCharges = [
      { value: 0, label: "Sin especificar" },
      { value: 1, label: "A" },
      { value: 2, label: "B" },
      { value: 3, label: "C" },
    ];
    $scope.typesConstruction = [
      { value: 1, label: "Macizo" },
      { value: 2, label: "Madera" },
      { value: 3, label: "Lámina" },
    ];

    $scope.copy_policy_history = {};
    vm.form = {};
    vm.form.endoso_n = "";
    vm.isCollapsed = false;
    // Function to toggle the collapse state
    vm.toggleCollapse = function () {
      vm.isCollapsed = !vm.isCollapsed;
    };
    // permisos accesos
    $scope.accesos = $sessionStorage.permisos;
    if ($scope.accesos) {
      $scope.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          $scope.acceso_polizas = perm;
          $scope.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_adm_pol = true;
              } else {
                $scope.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                $scope.acceso_ver_pol = true;
              } else {
                $scope.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_canc_pol = true;
              } else {
                $scope.acceso_canc_pol = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_elim_pol = true;
              } else {
                $scope.acceso_elim_pol = false;
              }
            } else if (acc.permission_name == "Rehabilitar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_adm_rehabilitar = true;
              } else {
                $scope.acceso_adm_rehabilitar = false;
              }
            }
          });
        }
        if (perm.model_name == "Endosos") {
          $scope.acceso_endosos = perm;
          $scope.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                $scope.acceso_adm_end = true;
              } else {
                $scope.acceso_adm_end = false;
              }
            }
          });
        }
        if (perm.model_name == "Reportes") {
          $scope.acceso_reportes = perm;
          $scope.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                $scope.acceso_rep_fia = true;
              } else {
                $scope.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                $scope.acceso_rep_sin = true;
              } else {
                $scope.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                $scope.acceso_rep_end = true;
              } else {
                $scope.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                $scope.acceso_rep_pol = true;
              } else {
                $scope.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                $scope.acceso_rep_ren = true;
              } else {
                $scope.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                $scope.acceso_rep_cob = true;
              } else {
                $scope.acceso_rep_cob = false;
              }
            }
          });
        }
        if (perm.model_name == "Ordenes de trabajo") {
          $scope.acceso_ot = perm;
          $scope.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                $scope.acceso_adm_ot = true;
              } else {
                $scope.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                $scope.acceso_ver_ot = true;
              } else {
                $scope.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                $scope.acceso_canc_ot = true;
              } else {
                $scope.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_elim_ot = true;
              } else {
                $scope.acceso_elim_ot = false;
              }
            } else if (acc.permission_name == "Tablero de OTs") {
              if (acc.checked == true) {
                $scope.acceso_tab = true;
              } else {
                $scope.acceso_tab = false;
              }
            }
          });
        }
        if (perm.model_name == "Contratantes y grupos") {
          $scope.acceso_contg = perm;
          $scope.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                $scope.acceso_adm_cont = true;
              } else {
                $scope.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                $scope.acceso_ver_cont = true;
              } else {
                $scope.acceso_ver_cont = false;
              }
            }
          });
        }
        if (perm.model_name == "Siniestros") {
          $scope.acceso_sin = perm;
          $scope.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                $scope.acceso_adm_sin = true;
              } else {
                $scope.acceso_adm_sin = false;
              }
            }
          });
        }
        if (perm.model_name == "Mensajeria") {
          $scope.acceso_mns = perm;
          $scope.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                $scope.acceso_mns = true;
              } else {
                $scope.acceso_mns = false;
              }
            }
          });
        }
        if (perm.model_name == "Formatos") {
          $scope.acceso_form = perm;
          $scope.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                $scope.acceso_form = true;
              } else {
                $scope.acceso_form = false;
              }
            }
          });
        }
        if (perm.model_name == "Correos electronicos") {
          $scope.acceso_correo = perm;
          $scope.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                $scope.acceso_cor = true;
              } else {
                $scope.acceso_cor = false;
              }
            }
          });
        }
        if (perm.model_name == "Cobranza") {
          $scope.acceso_cob = perm;
          $scope.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                $scope.acceso_ver_cob = true;
              } else {
                $scope.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                $scope.acceso_desp_cob = true;
              } else {
                $scope.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                $scope.acceso_pag_cob = true;
              } else {
                $scope.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                $scope.acceso_desco_cob = true;
              } else {
                $scope.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                $scope.acceso_conc_cob = true;
              } else {
                $scope.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                $scope.acceso_liq_cob = true;
              } else {
                $scope.acceso_liq_cob = false;
              }
            } else if (acc.permission_name == "Eliminar recibos") {
              if (acc.checked == true) {
                $scope.acceso_elim_rec = true;
              } else {
                $scope.acceso_elim_rec = false;
              }
            }
            if (
              acc.permission_name ==
              "No permitir editar recibos Pagados/Liquidados"
            ) {
              if (acc.checked == true) {
                $scope.acceso_pl_cob = true; //no se editan
              } else {
                $scope.acceso_pl_cob = false; //se pueden editar pagados-liquidados
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          $scope.acceso_ref = perm;
          $scope.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_adm_ref = true;
              } else {
                $scope.acceso_adm_ref = false;
              }
            }
            if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_pag_ref = true;
              } else {
                $scope.acceso_pag_ref = false;
              }
            }
            if (acc.permission_name == "Cambiar refrenciador en pólizas") {
              if (acc.checked == true) {
                $scope.acceso_chg_ref = true;
              } else {
                $scope.acceso_chg_ref = false;
              }
            }
            if (acc.permission_name == "Ver referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_ver_ref = true;
              } else {
                $scope.acceso_ver_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          $scope.coms = perm;
          $scope.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                $scope.permiso_comisiones = true;
              } else {
                $scope.permiso_comisiones = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          $scope.acceso_files = perm;
          $scope.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                $scope.permiso_archivos = true;
              } else {
                $scope.permiso_archivos = false;
              }
            } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                $scope.permiso_administrar_adjuntos = true;
              } else {
                $scope.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
      });
    }

    activate();

    $scope.downloadExcelAdjustment = function () {
      //
      var blob = new Blob([document.getElementById("exportable").innerHTML], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });
      saveAs(blob, "Reporte_ajuste_anual.xls");
    };

    $scope.openModal = function (task) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/tasks/task.modal.html",
        controller: "TareasModalCtrl",
        size: "lg",
        resolve: {
          task: function () {
            return task;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          receipt: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          activate();
        },
        function () {
          console.info("modal closed");
        }
      );
    };
    $scope.moveOTState = function (newcontainer, principal, seguimiento) {
      SweetAlert.swal(
        {
          title: "Mover Registro",
          text:
            "Se moverá " +
            $scope.caratula.internal_number +
            " de: " +
            $scope.caratula.seguimiento +
            ", al Contenedor: " +
            newcontainer.tablero,
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
            if (principal.contenedores && principal.contenedores.length > 0) {
              principal.contenedores.forEach(function (r, i) {
                if (r.tablero == seguimiento) {
                  r.polizas.splice(r.polizas.indexOf($scope.caratula.id), 1);
                }
                if (r.tablero == newcontainer.tablero) {
                  r.polizas.push($scope.caratula.id);
                }
                if (r) {
                  if (r["details_endoso"]) {
                    r["details_endoso"] = [];
                  }
                  if (r["details_polizas"]) {
                    r["details_polizas"] = [];
                  }
                }
              });
            }
            var payload = {
              polizas_ots: principal.contenedores,
              name: principal.name,
              color: principal.color,
              url: $scope.principal.url ? $scope.principal.url : "",
            };
            if ($scope.principal.url && $scope.principal.url != "") {
              $http
                .patch($scope.principal.url, payload)
                .then(
                  function success(response) {
                    $scope.caratula.seguimiento = newcontainer.tablero;
                    activate();
                  },
                  function error(e) {
                    console.log("Error - promotorias--", e);
                  }
                )
                .catch(function (error) {
                  console.log("Error - promotablero - catch", error);
                });
            }
          }
        }
      );
    };
    function createRecordatorio(registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return vm.insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }
    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };
    $scope.show_section = function (value) {
      switch (value) {
        case 1:
          $scope.show_caratula = true;
          $scope.show_subgrupo = false;
          $scope.show_paquete = false;
          $scope.show_certificado = false;
          $scope.show_masivopdfs = false;
          break;
        case 2:
          $scope.show_caratula = false;
          $scope.show_subgrupo = true;
          $scope.show_paquete = false;
          $scope.show_certificado = false;
          $scope.show_masivopdfs = false;
          break;
        case 3:
          $scope.show_caratula = false;
          $scope.show_subgrupo = false;
          $scope.show_paquete = true;
          $scope.show_certificado = false;
          $scope.show_masivopdfs = false;
          break;
        case 4:
          $scope.show_caratula = false;
          $scope.show_subgrupo = false;
          $scope.show_paquete = false;
          $scope.show_certificado = true;
          $scope.show_masivopdfs = false;
          vm.loadBatches();
          break;
        case 5:
          $scope.show_caratula = false;
          $scope.show_subgrupo = false;
          $scope.show_paquete = false;
          $scope.show_certificado = false;
          $scope.show_masivopdfs = true;
          break;
        default:
          $scope.show_caratula = true;
          $scope.show_subgrupo = false;
          $scope.show_paquete = false;
          $scope.show_certificado = false;
          $scope.show_masivopdfs = false;
      }
    };
    function obtenerNotas() {
      $http({
        method: "GET",
        url: url.IP + "notas-by-contractor/",
        params: {
          contractor: $scope.caratula.contractor
            ? $scope.caratula.contractor.id
            : $scope.caratula.contractor.id,
          type_contractor: $scope.caratula.natural ? "natural" : "juridical",
          poliza_id: $scope.caratula.id,
        },
      })
        .then(function success(response) {
          $scope.notesCaratula = response.data;
        })
        .catch(function (e) {
          console.log("error", e);
        });
    }
    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      var url_ = $location.path();
      if (url_.indexOf("editar") > -1) {
        $scope.directiveReceipts.is_edit = true;
      } else {
        $scope.directiveReceipts.is_edit = false;
      }
      try {
        $http
          .post(url.IP + "get-data-promotoria-initial/")
          .then(
            function success(response) {
              if (response.data.results.length > 0) {
                $scope.principal = response.data.original;
                $scope.principal.contenedores =
                  response.data.original.data_details;
                $scope.principal.url = response.data.original.url;
                $scope.principal.id = response.data.original.id;
              }
            },
            function error(e) {
              console.log("Error - promotorias--", e);
            }
          )
          .catch(function (error) {
            $scope.principal.contenedores = [];
            console.log("Error - promotablero - catch", error);
          });
      } catch (e) {}
      // $http.post(url.IP + 'get_caratula_complete/',
      $http
        .post(url.IP + "get_caratula_colectiva/", {
          caratula: $stateParams.polizaId,
        })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.caratula = response.data.data.caratula;
            $scope.sumas = response.data.sumas;
            $rootScope.edit_collective = undefined;
            $rootScope.add_collective = undefined;
            $http
              .post(url.IP + "get_caratula_colectiva_childs/", {
                caratula: $stateParams.polizaId,
              })
              .then(function success(response) {
                if (response.status == 200) {
                  $scope.subgrupos = response.data.data.childs;
                  $scope.paquetes = response.data.data.paquetes;
                  $rootScope.edit_collective = undefined;
                  $rootScope.add_collective = undefined;
                  $http
                    .get(
                      url.IP + "polizas/" + $scope.caratula.id + "/archivos/"
                    )
                    .then(function (response) {
                      $scope.filesCover = response.data.results;
                    })
                    .catch(function (e) {
                      console.log("error", e);
                    });
                  if ($scope.caratula.receipts_by == 2) {
                    $scope.calculatePrimasSubgroup();
                  }
                  $scope.allCertificates();
                  $scope.incompleteCollective();
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });
            if (!$scope.caratula.poliza_number && $scope.caratula.status != 1) {
              $scope.showOt = false;
            } else {
              $scope.showOt = true;
            }
            if ($scope.caratula.contractor) {
              $scope.cover_contractor = $scope.caratula.contractor;
              if ($scope.caratula.address) {
                if ($scope.caratula.contractor.address_contractor) {
                  $scope.caratula.contractor.address_contractor.forEach(
                    function (dir, index) {
                      if (dir.id == $scope.caratula.address) {
                        $scope.cover_contractor.direccion = dir;
                      }
                    }
                  );
                } else {
                  $scope.cover_contractor.direccion =
                    $scope.caratula.contractor.address_contractor[0];
                }
              } else {
                $scope.cover_contractor.direccion =
                  $scope.caratula.contractor.address_contractor[0];
              }
              if ($scope.cover_contractor.groupinglevel) {
                if ($scope.cover_contractor.groupinglevel.type_grouping == 3) {
                  $scope.cover_contractor.subsubgrouping =
                    $scope.cover_contractor.groupinglevel.description;
                  $http
                    .get($scope.cover_contractor.groupinglevel.parent)
                    .then(function (response) {
                      $scope.cover_contractor.subgrouping =
                        response.data.description;
                      $http
                        .get(response.data.parent)
                        .then(function (response1) {
                          $scope.cover_contractor.grouping_level =
                            response1.data.description;
                        });
                    });
                }
                if ($scope.cover_contractor.groupinglevel.type_grouping == 2) {
                  $scope.cover_contractor.subgrouping =
                    $scope.cover_contractor.groupinglevel.description;
                  $http
                    .get($scope.cover_contractor.groupinglevel.parent)
                    .then(function (response1) {
                      $scope.cover_contractor.grouping_level =
                        response1.data.description;
                    });
                }
                if ($scope.cover_contractor.groupinglevel.type_grouping == 1) {
                  $scope.cover_contractor.grouping_level =
                    $scope.cover_contractor.groupinglevel.description;
                }
              }
            }

            if (parseInt($scope.caratula.business_line) == 1) {
              $scope.businessLine = "Comercial";
            }
            if (parseInt($scope.caratula.business_line) == 2) {
              $scope.businessLine = "Personal";
            }
            if (parseInt($scope.caratula.business_line) == 0) {
              $scope.businessLine = "Otro";
            }

            if ($scope.caratula.celula) {
              $http
                .get(url.IP + "celula_contractor/" + $scope.caratula.celula)
                .then(function (response) {
                  $scope.celula = response.data.celula_name;
                });
            }
            var lie = Ladda.create(
              document.querySelector(".ladda-button-initial-e")
            );
            lie.start();
            $scope.conteoCertificados = 0;
            $http({
              method: "GET",
              url: url.IP + "get-endosos-by-policy",
              params: {
                policy: $scope.caratula.id,
              },
            })
              .then(function success(response) {
                $scope.endorsements = response.data.datae;
                $scope.endorsementsCaratula = response.data;
                $scope.conteoCertificados = response.data.conteoCertificados;
                lie.stop();
                $scope.allCertificates();
              })
              .catch(function (e) {
                console.log("error", e);
              });
            // $http({
            //   method: 'GET',
            //   url: url.IP + 'get-endosos-sinister',
            //   params: {
            //     policy: $scope.caratula.id
            //   }
            // })
            // .then(function success(response) {
            //     $scope.endorsements= response.data.datae
            //     $scope.endorsementsCaratula = response.data;
            //     lie.stop();
            //     $scope.allCertificates();
            // })
            // .catch(function (e) {
            //   console.log('error', e);
            // });

            $scope.notesCaratula = [];

            var linc = Ladda.create(
              document.querySelector(".ladda-button-initial-nc")
            );
            linc.start();
            $scope.existeNueva = false;
            $http({
              method: "GET",
              url: url.IP + "notas-by-contractor/",
              params: {
                contractor: $scope.caratula.contractor
                  ? $scope.caratula.contractor.id
                  : $scope.caratula.contractor.id,
                type_contractor: $scope.caratula.natural
                  ? "natural"
                  : "juridical",
                poliza_id: $scope.caratula.id,
              },
            })
              .then(function success(response) {
                $scope.notesCaratula = response.data;
                linc.stop();
              })
              .catch(function (e) {
                console.log("error", e);
              });

            $http
              .get(url.IP + "polizas/" + $scope.caratula.id + "/archivos/")
              .then(function (response) {
                $scope.filesCover = response.data.results;
              })
              .catch(function (e) {
                console.log("error", e);
              });
            if (
              $scope.caratula.receipts_by == 1 ||
              $scope.caratula.receipts_by == 3
            ) {
              $scope.calculatePrimas($scope.caratula.recibos_poliza);
            }
            $scope.calculatePrimasEndorsement($scope.caratula.recibos_poliza);
            $scope.getComments();
            $scope.allCertificates();

            // $scope.recibos_poliza = $scope.caratula.recibos_poliza.filter(function(recibo){
            //   if (recibo.receipt_type == 1 && !recibo.serie_manual && recibo.status != 0){
            //     return true;
            //   }
            //   return false;
            // });
            vm.endosos_options = [];
            vm.endorsement_receipts_show_bak = [];
            vm.endorsement_receipts_show = [];
            // $scope.caratula.recibos_poliza.filter(function(receipt){
            //   if ((receipt.receipt_type == 2 || receipt.receipt_type == 3) && receipt.status != 0){
            //     function findCoincidences(argument) {
            //       return argument === receipt.endorsement;
            //     }
            //     if(!vm.endosos_options.find(findCoincidences)){
            //       vm.endosos_options.push(receipt.endorsement);
            //     }
            //     vm.endorsement_receipts_show.push(receipt);
            //     vm.endorsement_receipts_show_bak.push(receipt);
            //   }
            // });
            $http({
              method: "GET",
              url: url.IP + "historic-policies/",
              params: {
                actual_id: $scope.caratula.id,
              },
            })
              .then(function success(response) {
                $scope.policy_history = [];
                if (response.data.results.length) {
                  response.data.results.forEach(function function_name(
                    old,
                    index
                  ) {
                    if ($scope.caratula.id != old.base_policy.id) {
                      $scope.policy_history.push(old.base_policy);
                      if (index == 0) {
                        $scope.copy_policy_history = angular.copy(
                          old.base_policy
                        );
                      }
                    } else if (old.new_policy) {
                      $scope.policy_history.push(old.new_policy);
                      $scope.existeNueva = true;
                    }
                  });
                }
              })
              .catch(function (e) {
                console.log("error - caratula - catch", e);
              });
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    }
    function changeEndorsement(endoaux, x, page) {
      if (endoaux) {
        // vm.endorsement_receipts_show = []
        // vm.endorsement_receipts_show_bak.forEach(function(child) {
        //   if(child.endorsement == endoaux){
        //     vm.endorsement_receipts_show.push(child);
        //   }
        // })
        $scope.recibosEndosos = [];
        dataFactory
          .post("receipts-by-policy-endosos/", {
            caratula: $scope.caratula.id,
            page: page ? page : 1,
            endoso: vm.form.endoso_n ? vm.form.endoso_n[0] : "",
          })
          .then(function success(response) {
            $scope.recibosEndosos = response.data["results"];
            $scope.recibos_pagie = {
              count: response.data.count,
              previous: url.IP + "receipts-by-policy/",
              next: url.IP + "receipts-by-policy/",
            };
            vm.show_pag_recendoso = true;
            testPaginationE("recibosEndosos", "recibos_pagie");
          })
          .catch(function (e) {
            console.log("error", e);
          });
      } else {
        vm.endorsement_receipts_show = vm.endorsement_receipts_show_bak;
      }
    }
    $scope.traerRecibosEndosos = function (endos, uno, page) {
      $scope.recibosEndosos = [];
      vm.endosos_options = [];
      // $http.get(url.IP + 'receipts-by-policy/'+$scope.caratula.id+'/')
      // .then(function(response) {
      dataFactory
        .post("receipts-by-policy-endosos/", {
          caratula: $scope.caratula.id,
          page: page ? page : 1,
          endoso: vm.form.endoso_n ? vm.form.endoso_n[0] : "",
        })
        .then(function success(response) {
          $scope.recibosEndosos = response.data["results"];
          vm.endosos_options = response.data["endosos"];
          $scope.recibos_pagie = {
            count: response.data.count,
            previous: url.IP + "receipts-by-policy/",
            next: url.IP + "receipts-by-policy/",
          };
          vm.show_pag_recendoso = true;
          testPaginationE("recibosEndosos", "recibos_pagie");
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };
    $scope.traerRecibos = function (uno, page) {
      $scope.recibosTodos = [];
      // $http.get(url.IP + 'receipts-by-policy/'+$scope.caratula.id+'/')
      // .then(function(response) {
      dataFactory
        .post("receipts-by-policy/", {
          caratula: $scope.caratula.id,
          page: page ? page : 1,
        })
        .then(function success(response) {
          $scope.recibosTodos = response.data["results"];
          $scope.recibos_pagi = {
            count: response.data.count,
            previous: url.IP + "receipts-by-policy/",
            next: url.IP + "receipts-by-policy/",
          };
          vm.show_pag_cobranza = true;
          testPagination("recibosTodos", "recibos_pagi");
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };
    $scope.changePrimaTitular = function (param) {
      param.sub_total = parseFloat(
        parseFloat(
          parseFloat(param.p_neta ? param.p_neta : 0) +
            parseFloat(param.rpf ? param.rpf : 0) +
            parseFloat(param.derecho ? param.derecho : 0)
        ).toFixed(2)
      ).toString();

      if ($scope.caratula.ramo.ramo_code != 1) {
        param.iva = parseFloat(
          parseFloat(parseFloat(param.sub_total) * 0.16).toFixed(2)
        ).toString();
        $scope.copy_iva_titular = angular.copy(param.iva);
      } else {
        param.iva = "0";
      }
      param.p_total = parseFloat(
        parseFloat(parseFloat(param.sub_total) + parseFloat(param.iva)).toFixed(
          2
        )
      ).toString();

      //$scope.updateTotal();
    };
    $scope.createNotes = function (insurance) {
      if (insurance) {
        SweetAlert.swal(
          {
            title: "¡Aviso!",
            text: "Se creará una nueva nota de crédito. ¿Desea continuar?",
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
          },
          function (isConfirm) {
            if (isConfirm) {
              var modalInstance = $uibModal.open({
                templateUrl: "app/polizas/add.receiptsModal.html",
                controller: AddReceiptModalCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  serie: function () {
                    return null;
                  },
                  poliza: function () {
                    return insurance;
                  },
                  caratula: function () {
                    return insurance;
                  },
                  tipo: function () {
                    return 3;
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });

              modalInstance.closed.then(function (receipt) {
                obtenerNotas();
              });
            } else {
            }
          }
        );
      } else {
        SweetAlert.swal("Error", "No se puede agregar", "error");
        return;
      }
    };
    $scope.datoscontributorios = function (contrib) {
      $scope.newCertificate.contributory = contrib;
    };
    $scope.renovarPolizaRehabilitate = function (idp, numerop) {
      $scope.date1 = convertDate(
        datesFactory.toDate(convertDate($scope.caratula.end_of_validity))
      );
      if (process($scope.date1) < process(convertDate(new Date()))) {
        $scope.status_nuevo = 13;
      } else if (process($scope.date1) > process(convertDate(new Date()))) {
        $scope.status_nuevo = 14;
      } else {
        $scope.status_nuevo = 14;
      }
      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }
      SweetAlert.swal(
        {
          title: "Actualización de Póliza grupo para Renovación",
          text:
            "Los cambios se aplicarán en la Póliza " +
            $scope.caratula.poliza_number,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .patch($scope.caratula.url, { status: $scope.status_nuevo })
              .then(upgPolicyComplete)
              .catch(upgPolicyFailed);
            function upgPolicyComplete(response, status, headers, config) {
              if (response.status === 200 || response.status === 201) {
                SweetAlert.swal(
                  "¡Listo!",
                  MESSAGES.OK.UPGRADEPOLICY,
                  "success"
                );
                var params = {
                  model: 18,
                  event: "POST",
                  associated_id: $scope.caratula.id,
                  identifier: "actualizo la póliza grupo para ser renovada ",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                setTimeout(function () {
                  location.reload();
                }, 1500);
              }
            }
            function upgPolicyFailed(response, status, headers, config) {
              return response;
            }
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La póliza no se ha afectado",
              "error"
            );
          }
        }
      );
    };
    $scope.reActivatePolicy = function (id, poliza_number) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/polizas.rehabilitar.html",
        controller: ReActivatePolicyCtrl,
        controllerAs: "vmm",
        size: "md",
        resolve: {
          idInsurance: function () {
            return id;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (response) {
        $http
          .post(url.IP + "rehabilitar-poliza/", response)
          .then(
            function (response_rehabilitar) {
              console.log("response_rehabilitar", response_rehabilitar);

              var params = {
                model: 18,
                event: "POST",
                associated_id: id,
                identifier: poliza_number
                  ? "reactivó la póliza."
                  : "reactivó la OT.",
              };
              dataFactory.post("send-log/", params);
              if (poliza_number) {
                toaster.success("Se rehabilitó la póliza correctamente");
              } else {
                toaster.success("Se rehabilitó la OT correctamente");
              }

              setTimeout(function () {
                location.reload();
              }, 1500);
            },
            function (error) {
              console.log("Error al rehabilitar ", error);
              toaster.error("ocurrión un error al rehabilitar la póliza");
            }
          )
          .catch(function (error) {
            console.log("Error al rehabilitar ", error);
            toaster.error("ocurrión un error al rehabilitar la póliza");
          });
      });
    };
    // lista elementos certificados
    // controller.js (AngularJS 1.x)
    vm.items = [];
    vm.batch = null;
    vm.page = 1;
    vm.pages = 1;
    vm.filterStatus = "";
    vm.loading = false;
    vm.loadingRetryAll = false;

    vm.loadItems = function (page) {
      vm.loading = true;
      vm.page = page || 1;

      var params = {
        org: vm.org, // tu org actual
        page: vm.page,
        page_size: 50,
      };
      if (vm.filterStatus) params.status = vm.filterStatus;
      $http
        .get(url.IP + "share-certificates/batch-items/" + vm.batch_id + "/", {
          params: params,
        })
        .then(function (resp) {
          vm.batch = resp.data.batch;
          vm.items = resp.data.items;
          vm.pages = resp.data.pagination.pages;
        })
        .catch(function (e) {
          SweetAlert.swal("ERROR", "No se pudo cargar la tabla", "error");
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    vm.retryAllFailed = function () {
      SweetAlert.swal(
        {
          title: "Reenviar fallidos",
          text: "Se reenviarán todos los certificados con estatus FAILED. ¿Continuar?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, reenviar",
          cancelButtonText: "Cancelar",
        },
        function (ok) {
          if (!ok) return;

          vm.loadingRetryAll = true;
          $http
            .post(
              url.IP +
                "share-certificates/batch-retry-failed/" +
                vm.batch_id +
                "/",
              {}
            )
            .then(function (resp) {
              SweetAlert.swal(
                "OK",
                "Reintento finalizado. Reenviados: " +
                  resp.data.resent +
                  ", aún fallidos: " +
                  resp.data.still_failed,
                "success"
              );
              vm.loadItems(1);
            })
            .catch(function () {
              SweetAlert.swal("ERROR", "No se pudo reenviar fallidos", "error");
            })
            .finally(function () {
              vm.loadingRetryAll = false;
            });
        }
      );
    };

    vm.retryOne = function (it) {
      it._retrying = true;
      $http
        .post(url.IP + "share-certificates/batch-retry-item/" + it.id + "/", {})
        .then(function (resp) {
          // actualiza item en tabla
          it.status = resp.data.status;
          it.error_message = resp.data.error_message;
          it.attempts = resp.data.attempts;
          vm.batch.sent = resp.data.batch.sent;
          vm.batch.failed = resp.data.batch.failed;

          if (it.status === "SENT") {
            SweetAlert.swal(
              "ENVIADO",
              "Se reenvi\u00f3 correctamente",
              "success"
            );
          } else {
            SweetAlert.swal(
              "FALL\u00d3",
              it.error_message || "Error al reenviar",
              "error"
            );
          }
        })
        .catch(function () {
          SweetAlert.swal(
            "ERROR",
            "No se pudo reenviar el certificado",
            "error"
          );
        })
        .finally(function () {
          it._retrying = false;
        });
    };

    vm.showError = function (it) {
      SweetAlert.swal({
        title: "Detalle del error",
        text: it.error_message || "Sin detalle",
        type: "info",
      });
    };

    // lista fin elementos enviaados o no
    function ReActivatePolicyCtrl($scope, $uibModalInstance, idInsurance) {
      $scope.mostrar_alerta = true;

      $scope.buttonDisabled = true;
      $scope.motivo_rehabilitacion = "";
      $scope.reActivatePolicy = function () {
        $uibModalInstance.close({
          motivo_rehabilitacion: $scope.motivo_rehabilitacion,
          id: idInsurance,
        });
      };

      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.createReceipts = function (insurance) {
      if (insurance) {
        SweetAlert.swal(
          {
            title: "¡Aviso!",
            text: "Se creará un nuevo recibo. ¿Desea continuar?",
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
          },
          function (isConfirm) {
            if (isConfirm) {
              var serie = 0;
              $scope.caratula.recibos_poliza.forEach(function (recibo) {
                if (recibo.receipt_type == 1 && recibo.status != 0) {
                  if (parseInt(recibo.recibo_numero) > serie) {
                    serie = parseInt(recibo.recibo_numero);
                  }
                }
              });
              var modalInstance = $uibModal.open({
                templateUrl: "app/polizas/add.receiptsModal.html",
                controller: AddReceiptModalCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  serie: function () {
                    return serie + 1;
                  },
                  poliza: function () {
                    return insurance;
                  },
                  caratula: function () {
                    return $scope.caratula;
                  },
                  tipo: function () {
                    return 1;
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });

              modalInstance.closed.then(function (receipt) {
                activate();
              });
            } else {
            }
          }
        );
      } else {
        SweetAlert.swal("Error", "No se puede agregar", "error");
        return;
      }
    };

    function AddReceiptModalCtrl(
      tipo,
      serie,
      url,
      $http,
      $rootScope,
      $scope,
      $uibModalInstance,
      poliza,
      caratula,
      dataFactory,
      SweetAlert,
      datesFactory
    ) {
      var rec = this;
      rec.tipo = tipo;
      rec.recibo_numero = serie;
      rec.fecha_inicio = convertDate(new Date());
      rec.fecha_fin = convertDate(new Date());
      rec.prima_neta = 0.0;
      rec.rpf = 0.0;
      rec.derecho = 0.0;
      rec.sub_total = 0.0;
      rec.iva = 0.0;
      rec.comision = 0.0;
      rec.prima_total = 0.0;
      rec.vencimiento = convertDate(new Date());

      $scope.change_date = function (date) {
        rec.fecha_fin = date;
        rec.vencimiento = date;
      };

      $scope.validateDecimal = function (form, data) {
        form = String(form).replace(/[A-Za-z]/g, "");
        form = String(form).replace(/,/g, "");
      };

      $scope.changePrimas = function (data) {
        var subtotal_ =
          parseFloat(data.prima_neta) +
          parseFloat(data.rpf) +
          parseFloat(data.derecho);
        var iva_ = subtotal_ * 0.16;
        var prima_total_ = parseFloat(subtotal_ + parseFloat(iva_));
        rec.iva = iva_.toFixed(2);

        data.sub_total = subtotal_.toFixed(2);
        data.prima_total = prima_total_.toFixed(2);
        data.iva = rec.iva;
      };

      $scope.validateDates = function (date) {
        rec.fecha_inicio = date;
      };

      var date1, date2, date3, dateDiff1, dateDiff2;
      $scope.validateDates_venc = function (date) {
        //Validando vacio
        if (date == undefined) {
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede estar vacia",
            "error"
          );
          return;
        }
        if (poliza.document_type == 4) {
          poliza.end_of_validity = caratula.end_of_validity;
        }
        //Validando no menor a fecha inicio
        date1 = datesFactory.toDate(date);
        date2 = datesFactory.toDate(rec.fecha_inicio);
        date3 = datesFactory.toDate(convertDate(poliza.end_of_validity));
        dateDiff1 = moment(date1).diff(moment(date2), "days");
        dateDiff2 = moment(date1).diff(moment(date3), "days");

        // if(dateDiff1 < 0){
        //   SweetAlert.swal("Error", "La fecha de vencimiento no puede ser menor que la inicial", "error");
        //   return;
        // }
        //Validando a no mayor a 30 dias de fin de vigencia de poliza
        if (dateDiff2 > 30) {
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede ser mayor a 30 días a la fecha de la vigencia de la poliza",
            "error"
          );
          return;
        }
      };

      $scope.saveRecibo = function (data_receipt) {
        //var date = rec.vencimiento;
        if (rec.vencimiento == undefined) {
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede estar vacia",
            "error"
          );
          return;
        }
        if (poliza.document_type == 4) {
          poliza.end_of_validity = caratula.end_of_validity;
        }
        //Validando no menor a fecha inicio
        date1 = datesFactory.toDate(rec.vencimiento);
        date2 = datesFactory.toDate(rec.fecha_inicio);
        date3 = datesFactory.toDate(convertDate(poliza.end_of_validity));
        dateDiff1 = moment(date1).diff(moment(date2), "days");
        dateDiff2 = moment(date1).diff(moment(date3), "days");

        if (poliza.document_type == 4) {
          poliza.end_of_validity = caratula.end_of_validity;
        }

        if (!data_receipt.serie_manual || data_receipt.serie_manual == "") {
          if (tipo != 3) {
            SweetAlert.swal(
              "Error",
              "Debe ingresar un número de serie manual válido",
              "error"
            );
            return;
          }
        }

        // if(dateDiff1 < 0){
        //   SweetAlert.swal("Error", "La fecha de vencimiento no puede ser menor que la inicial", "error");
        //   return;
        // }
        //Validando a no mayor a 30 dias de fin de vigencia de poliza
        if (dateDiff2 > 30) {
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede ser mayor a 30 días a la fecha de la vigencia de la poliza",
            "error"
          );
          return;
        }

        if (
          process(rec.fecha_inicio) <
          process(convertDate(poliza.start_of_validity))
        ) {
          SweetAlert.swal(
            "Error",
            "La fecha de inicio del recibo no puede ser menor a la fecha de inicio de la póliza.",
            "error"
          );
          return;
        }

        if (process(rec.fecha_fin) < process(rec.fecha_inicio)) {
          SweetAlert.swal(
            "Error",
            "La fecha fin del recibo no puede ser menor a la de su inicio.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        var folio = "Sin folio";
        if (tipo == 3) {
          folio = data_receipt.recibo_numero;
          var data = {
            fecha_inicio: toDate(data_receipt.fecha_inicio),
            fecha_fin: toDate(data_receipt.fecha_fin),
            vencimiento: toDate(data_receipt.vencimiento),
            prima_neta:
              parseFloat(data_receipt.prima_neta).toFixed(2) < 0
                ? parseFloat(data_receipt.prima_neta).toFixed(2)
                : parseFloat(data_receipt.prima_neta).toFixed(2) * -1,
            derecho:
              parseFloat(data_receipt.derecho).toFixed(2) < 0
                ? parseFloat(data_receipt.derecho).toFixed(2)
                : parseFloat(data_receipt.derecho).toFixed(2) * -1,
            rpf:
              parseFloat(data_receipt.rpf).toFixed(2) < 0
                ? parseFloat(data_receipt.rpf).toFixed(2)
                : parseFloat(data_receipt.rpf).toFixed(2) * -1,
            iva:
              parseFloat(data_receipt.iva).toFixed(2) < 0
                ? parseFloat(data_receipt.iva).toFixed(2)
                : parseFloat(data_receipt.iva).toFixed(2) * -1,
            comision:
              parseFloat(data_receipt.comision).toFixed(2) < 0
                ? parseFloat(data_receipt.comision).toFixed(2)
                : parseFloat(data_receipt.comision).toFixed(2) * -1,
            sub_total:
              parseFloat(data_receipt.sub_total).toFixed(2) < 0
                ? parseFloat(data_receipt.sub_total).toFixed(2)
                : parseFloat(data_receipt.sub_total).toFixed(2) * -1,
            prima_total:
              parseFloat(data_receipt.prima_total).toFixed(2) < 0
                ? parseFloat(data_receipt.prima_total).toFixed(2)
                : parseFloat(data_receipt.prima_total).toFixed(2) * -1,
            recibo_numero: data_receipt.recibo_numero
              ? data_receipt.recibo_numero
              : serie,
            serie_manual: data_receipt.serie_manual
              ? data_receipt.serie_manual
              : 0,
            poliza: poliza.url,
            status: 4,
            receipt_type: tipo,
            isCopy: false,
            isActive: true,
            folio: folio,
          };
        } else {
          var data = {
            fecha_inicio: toDate(data_receipt.fecha_inicio),
            fecha_fin: toDate(data_receipt.fecha_fin),
            vencimiento: toDate(data_receipt.vencimiento),
            prima_neta: parseFloat(data_receipt.prima_neta).toFixed(2),
            derecho: parseFloat(data_receipt.derecho).toFixed(2),
            rpf: parseFloat(data_receipt.rpf).toFixed(2),
            iva: parseFloat(data_receipt.iva).toFixed(2),
            comision: parseFloat(data_receipt.comision).toFixed(2),
            sub_total: parseFloat(data_receipt.sub_total).toFixed(2),
            prima_total: parseFloat(data_receipt.prima_total).toFixed(2),
            recibo_numero: data_receipt.recibo_numero
              ? data_receipt.recibo_numero
              : serie,
            serie_manual: data_receipt.serie_manual
              ? data_receipt.serie_manual
              : 0,
            poliza: poliza.url,
            status: 4,
            receipt_type: tipo,
            isCopy: false,
            isActive: true,
            folio: folio,
          };
        }

        $http
          .post(url.IP + "recibos/", data)
          .then(
            function success(req) {
              SweetAlert.swal(
                "Creado",
                "El recibo " + data_receipt.recibo_numero + " ha sido creado.",
                "success"
              );
              var params = {
                model: 4,
                event: "POST",
                associated_id: req["data"].id,
                identifier:
                  "creó el recibo " +
                  data_receipt.recibo_numero +
                  " de la póliza " +
                  poliza.poliza_number,
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});

              var params_ = {
                model: 18,
                event: "POST",
                associated_id: req["data"].id,
                identifier:
                  "creó el recibo " +
                  data_receipt.recibo_numero +
                  " de la póliza " +
                  poliza.poliza_number,
              };

              dataFactory
                .post("send-log/", params_)
                .then(function success(response) {});
              $uibModalInstance.dismiss("cancel");
            },
            function error(error) {
              console.log(error);
            }
          )
          .catch(function (e) {
            console.log(e);
          });
      };

      $scope.cancel = function (v) {
        $uibModalInstance.dismiss("cancel");
      };

      function convertDate(inputFormat, indicator) {
        // function pad(s) { return (s < 10) ? '0' + s : s; }
        // var d = new Date(inputFormat);
        // // var date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
        // // return date;
        // var date = inputFormat;
        // if(inputFormat.length != 10){
        //   function pad(s) { return (s < 10) ? '0' + s : s; }
        //     var d = new Date(inputFormat);
        //     if(indicator){
        //       date = [pad(d.getDate()+1), pad(d.getMonth()+1), d.getFullYear()].join('/');
        //     } else {
        //       date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
        //     }
        // }
        // return date;
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d_uno = new Date(inputFormat);
        var fecha = new Date(inputFormat);
        if (fecha.getUTCHours() <= 11) {
          fecha.setHours(fecha.getHours() + 12);
        } else {
          fecha.setHours(fecha.getHours() + 5);
        }
        var d = fecha;
        // var d = new Date(inputFormat).toISOString()//prueba
        // console.log('-fecha 2',d,new Date(d.toLocaleString()))
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
        return date;
      }

      function toDate(dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

        return dateObject;
      }
    }

    $scope.eliminarRecibos = function () {
      $scope.caratula.recibos_poliza.forEach(function (receipt) {
        if (receipt.receipt_type == 1) {
          $http
            .delete(receipt.url)
            .then(function (response) {})
            .catch(function (e) {
              console.log("error", e);
            });
        }
      });
      activate();
    };

    $scope.incompleteCollective = function () {
      $scope.incompleteOT = {
        complete: true,
        caratule: [],
        subgroups: [],
        packages: [],
        certificates: [],
      };
      if (
        !$scope.caratula.poliza_number &&
        $scope.caratula.receipts_by == 1 &&
        $scope.caratula.recibos_poliza.length == 0
      ) {
        var item = {
          text: "Agregar No. de Póliza, Primas y Generar Recibos.",
        };
        $scope.incompleteOT.caratule.push(item);
        $scope.incompleteOT.complete = false;
      }

      if (
        !$scope.caratula.poliza_number &&
        $scope.caratula.receipts_by != 1 &&
        $scope.caratula.recibos_poliza.length == 0
      ) {
        var item = {
          text: "Agregar No. de Póliza.",
        };
        $scope.incompleteOT.caratule.push(item);
        $scope.incompleteOT.complete = false;
      }

      if ($scope.subgrupos && $scope.subgrupos.length == 0) {
        var item = {
          text: "Agregar Subgrupos.",
        };
        $scope.incompleteOT.subgroups.push(item);
        $scope.incompleteOT.complete = false;
      } else {
        if ($scope.caratula.receipts_by == 2) {
          if ($scope.subgrupo) {
            $scope.subgrupos.forEach(function (subgroup) {
              if (subgroup.recibos_poliza.length == 0) {
                var item = {
                  text: "Agregar Recibos a " + subgroup.name + ".",
                };
                $scope.incompleteOT.subgroups.push(item);
                $scope.incompleteOT.complete = false;
              }
            });
          }
        }
      }

      if ($scope.paquetes && $scope.paquetes.length == 0) {
        var item = {
          text: "Agregar Paquetes.",
        };
        $scope.incompleteOT.packages.push(item);
        $scope.incompleteOT.complete = false;
      }
      if ($scope.categorySelected.certificates.length == 0) {
        var item = {
          text: "Agregar Certificados.",
        };
        $scope.incompleteOT.certificates.push(item);
        $scope.incompleteOT.complete = false;
      } else {
        if (
          $scope.caratula.receipts_by == 3 &&
          $scope.caratula.recibos_poliza.length == 0
        ) {
          var item = {
            text: "Agregar Recibos.",
          };
          $scope.incompleteOT.certificates.push(item);
          $scope.incompleteOT.complete = false;
        }
      }
    };

    //---guardar como poliza
    $scope.convertPolicy = function (myInsurance) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/colectivos/conversion.html",
        controller: ConversionCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policyModal: function () {
            return $scope.caratula;
          },
          showOt: function () {
            return $scope.showOt;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };
    $scope.showChange = function (endoso) {
      $http.get(endoso.policy).then(function success(respon) {
        endoso.policy = respon.data;
        $http.get(respon.data.ramo).then(function success(respon1) {
          endoso.policy.ramo = respon1.data;
        });
        $http.get(respon.data.subramo).then(function success(respon2) {
          endoso.policy.subramo = respon2.data;
        });
      });
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/infoChange.modal.html",
        controller: "InfoChangeCtrl",
        size: "lg",
        resolve: {
          endoso: function () {
            return endoso;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };
    $scope.tipo_pago = function (parValue) {
      switch (parValue) {
        case 1:
          return "Reembolso";
          break;
        case 2:
          return "Programación";
          break;
        case 3:
          return "Pago directo";
          break;
        case 4:
          return "Aclaración";
          break;
        default:
          return "No especificada";
      }
    };

    $scope.addPhoneWhatsapp = function (insurance, contra) {
      insurance.contratante = contra;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.phone.whatsappsms_reminderpay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return insurance;
          },
          valueReceipt: function () {
            return insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };
    function ConversionCtrl(
      $scope,
      MESSAGES,
      policyModal,
      $uibModalInstance,
      dataFactory,
      SweetAlert,
      $state,
      url,
      $http,
      helpers,
      showOt
    ) {
      var vmm = this;
      $scope.policy = policyModal;
      $scope.dataToSave = {};
      $scope.directiveReceipts = {};
      $scope.directiveReceipts["canCreate"] = false;

      $scope.directiveReceipts.subramo = $scope.policy.subramo.subramo_name;
      $scope.directiveReceipts.startDate = convertDate(
        $scope.policy.start_of_validity
      );
      $scope.directiveReceipts.endingDate = convertDate(
        $scope.policy.end_of_validity
      );
      $scope.directiveReceipts.payment = $scope.policy.forma_de_pago;
      var date1 = new Date($scope.policy.start_of_validity);
      var date2 = new Date($scope.policy.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );
      $scope.directiveReceipts.domiciliado = false;
      try {
        $http({
          method: "GET",
          url: url.IP + "historic-policies/",
          params: {
            actual_id: $scope.policy.id,
          },
        }).then(function success(response) {
          vmm.policy_history = [];
          response.data.results.forEach(function function_name(old) {
            if ($scope.policy.id != old.base_policy.id) {
              vmm.policy_history.push(old.base_policy);
            } else if (old.new_policy) {
              vmm.policy_history.push(old.new_policy);
            }
          });
        });
      } catch (e) {
        console.log("History policy (update)_", e);
      }

      getClaves();

      function getClaves() {
        $http
          .get(url.IP + "claves-by-provider/" + $scope.policy.aseguradora.id)
          .then(function success(clavesResponse) {
            $scope.claves = clavesResponse.data;
            if ($scope.claves.length == 1) {
              $scope.claveSelected = $scope.claves[0];
            } else {
              $scope.claves.forEach(function (item) {
                if (item.id == $scope.policy.clave.id) {
                  $scope.claveSelected = item;
                }
              });
            }
            $http
              .get(url.IP + "ramos-by-provider/" + $scope.policy.aseguradora.id)
              .then(
                function success(response) {
                  $scope.ramos = response.data;
                  $scope.ramos.forEach(function (item) {
                    if (item.ramo_name == $scope.policy.ramo.ramo_name) {
                      $scope.subramos = item.subramo_ramo;
                      $scope.subramos.forEach(function (subramo) {
                        if (
                          subramo.subramo_name ==
                          $scope.policy.subramo.subramo_name
                        ) {
                          var comisiones = [];
                          if ($scope.claveSelected.clave_comision) {
                            if ($scope.claveSelected.clave_comision.length) {
                              $scope.claveSelected.clave_comision.forEach(
                                function (item) {
                                  if (
                                    $scope.policy.subramo.subramo_name ==
                                    item.subramo
                                  ) {
                                    comisiones.push(item);
                                  }
                                }
                              );
                            }
                          }

                          $scope.directiveReceipts.comisiones = comisiones;
                        }
                      });
                    }
                  });
                },
                function error(e) {
                  console.log("Error - ramos-by-provider", e);
                }
              )
              .catch(function (error) {
                console.log("Error - ramos-by-provider - catch", error);
              });
          })
          .catch(function (error) {
            console.log("Error - claves-by-provider - catch", error);
          });
      }

      $scope.checkNumPolicy = function () {
        // if($scope.policy.poliza_number){
        //   if (vmm.policy_history.length){
        //     var num_P = 'renovaciones_polizagrupo'
        //   }else{
        //     var num_P = $scope.policy.poliza_number
        //   }
        //   helpers.existPolicyNumber(num_P)
        //   .then(function(request){
        //     if(request == true) {
        //       SweetAlert.swal("Error",MESSAGES.ERROR.POLICYEXIST, "error")
        //       $scope.policy.poliza_number = '';
        //     }
        //   })
        //   .catch(function(err) {
        //     console.log('Error', err)
        //   });
        // }
      };

      $scope.save = function () {
        if (
          !$scope.directiveReceipts.canCreate &&
          $scope.policy.receipts_by == 1
        ) {
          SweetAlert.swal(
            "Error",
            "OPRIMA EL BOTON CALCULAR Y GENERAR RECIBOS",
            "error"
          );
          return;
        }
        if ($scope.policy.poliza_number) {
          if (vmm.policy_history.length) {
            var num_P = "renovaciones_polizagrupo";
          } else {
            var num_P = $scope.policy.poliza_number;
          }
          helpers
            .existPolicyNumber(num_P)
            .then(function (request) {
              if (request == true) {
                SweetAlert.swal("Error", MESSAGES.ERROR.POLICYEXIST, "error");
                $scope.policy.poliza_number = "";
                return;
              }
            })
            .catch(function (err) {
              console.log("Error", err);
            });
        }

        if (
          !$scope.dataToSave.recibos_poliza &&
          $scope.policy.receipts_by == 1
        ) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
        if ($scope.policy.receipts_by == 1) {
          var data_caratula = {
            folio: $scope.policy.folio,
            poliza_number: $scope.policy.poliza_number,
            status: 14,
            p_neta: $scope.dataToSave.poliza.primaNeta
              ? $scope.dataToSave.poliza.primaNeta
              : 0,
            descuento: $scope.dataToSave.poliza.descuento
              ? $scope.dataToSave.poliza.descuento
              : 0,
            rpf: $scope.dataToSave.poliza.rpf
              ? $scope.dataToSave.poliza.rpf
              : 0,
            derecho: $scope.dataToSave.poliza.derecho
              ? $scope.dataToSave.poliza.derecho
              : 0,
            sub_total: $scope.dataToSave.poliza.subTotal
              ? $scope.dataToSave.poliza.subTotal
              : 0,
            iva: $scope.dataToSave.poliza.iva
              ? $scope.dataToSave.poliza.iva
              : 0,
            p_total: $scope.dataToSave.poliza.primaTotal
              ? $scope.dataToSave.poliza.primaTotal
              : 0,
            comision: $scope.dataToSave.comision
              ? $scope.dataToSave.comision
              : 0,
            comision_percent: $scope.dataToSave.comision_percent
              ? $scope.dataToSave.comision_percent
              : 0,
            total_receipts: $scope.dataToSave.recibos_poliza
              ? $scope.dataToSave.recibos_poliza.length
              : $scope.caratula.total_receipts,
            accident_rate: $scope.dataToSave.accident_rate
              ? $scope.dataToSave.accident_rate
              : 0,
            steps: $scope.dataToSave.steps ? $scope.dataToSave.steps : [],
          };
        } else {
          var data_caratula = {
            folio: $scope.policy.folio,
            poliza_number: $scope.policy.poliza_number,
            status: 14,
          };
        }

        $http
          .patch($scope.policy.url, data_caratula)
          .then(function (response) {
            if (response.status == 200 || response.status == 201) {
              var paramsRec = {
                model: 18,
                event: "PATCH",
                associated_id: $scope.policy.id,
                identifier: " convirtió la OT a Póliza.",
                change: [],
              };
              dataFactory
                .post("send_log_specific/", paramsRec)
                .then(function success(response) {});
              $scope.showOt = true;
              activate();
              SweetAlert.swal(
                "¡Listo!",
                "Póliza actualizada exitosamente.",
                "success"
              );
              $scope.cancel();
            } else {
              SweetAlert.swal("Error", "Ócurrio un error.", "error");
            }
          })
          .catch(function (error) {
            console.log("error", error);
            SweetAlert.swal("Error", "Ócurrio un error.", "error");
          });

        if ($scope.policy.receipts_by == 1) {
          $scope.dataToSave.recibos_poliza.forEach(function (item, index) {
            item.poliza = $scope.policy.url;
            item.conducto_de_pago = $scope.policy.conducto_de_pago;

            item.fecha_fin = toDate(item.fecha_fin);
            item.fecha_inicio = toDate(item.fecha_inicio);
            item.vencimiento = toDate(item.vencimiento);

            $http
              .post(url.IP + "recibos/", item)
              .then(function (data) {
                if (data.status === 201) {
                }
              })
              .catch(function (error) {
                console.log("error", error);
                SweetAlert.swal("Error", "Ócurrio un error.", "error");
              });
          });
        }

        if (vmm.policy_history) {
          vmm.policy_history.forEach(function (elem) {
            if (elem.status == 14) {
              var data = {
                status: 12,
                renewed_status: 1,
              };
            } else if (elem.status == 13) {
              var data = {
                status: 12,
                renewed_status: 1,
              };
            } else {
              var data = {
                renewed_status: 1,
              };
            }
            /* Actualiza la póliza antigua */
            $http.patch(elem.url, data).then(function (res_pacth_ren) {});
          });
        }
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.editCollective = function (param) {
      $rootScope.edit_collective = param;
      $state.go("colectividades.edit", { polizaId: $scope.caratula.id });
    };

    $scope.addSubgroupPackage = function (param) {
      //2 subgrupo, 3 paquete
      $rootScope.add_collective = param;
      $rootScope.conducto_de_pago = $scope.caratula.conducto_de_pago;
      $state.go("colectividades.edit", { polizaId: $scope.caratula.id });
    };

    $scope.gotoRenewal = function () {
      $state.go("colectividades.renewal", { polizaId: $scope.caratula.id });
    };

    function showRecordatorios() {
      vm.infoFlag = false;
      vm.recordatoriosFlag = true;
      vm.recordatoriosFlagC = true;
    }
    function PolicyModalCtrl(
      $scope,
      contractorModal,
      $uibModalInstance,
      urlInsurance,
      receipts,
      caratula
    ) {
      $scope.buttonDisabled = true;
      $scope.addnotasToCancel = true;
      $scope.optionsCancel = [
        // {'value': 3, 'label': 'Cancelación definitiva'}
        { value: 3, label: "Cancelación definitiva - A petición" },
        { value: 4, label: "Cancelación definitiva - Falta de pago" },
      ];
      $scope.date_cancel = convertDate(new Date());
      $scope.checkCancelDate = function (dat) {
        $scope.date_cancel = dat;
      };
      $scope.addnotasToCancelF = function (addnotas) {
        $scope.addnotasToCancel = addnotas;
      };
      $scope.cancelPolicy = function (option, reason, date, addnotas) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (option.value == 3 || option.value == 4) {
          if (date) {
            date = datesFactory.toDate(date);
          } else {
            date = new Date();
          }
          if (caratula.status == "En trámite") {
            var status_to_change = 2;
          } else {
            var status_to_change = 11;
          }
          $http
            .patch(urlInsurance, {
              status: status_to_change,
              reason_cancel: option.label + " // " + reason,
              date_cancel: date,
              cancelnotas: $scope.addnotasToCancel,
            })
            .then(function (data) {
              caratula.status = data.data.status;
              var params = {
                model: 18,
                event: "PATCH",
                associated_id: caratula.id,
                identifier: "canceló la carátula de forma definitiva.",
              };
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});
              l.stop();
              activate();
              $uibModalInstance.dismiss("cancel");
              swal(
                "Hecho",
                "Se ha cancelado definitivamente la Carátula",
                "success"
              );
            });
        }
      };

      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.getPDF = function (param) {
      $http({
        method: "GET",
        url: url.IP + "get-pdf-ot/",
        responseType: "arraybuffer",
        params: {
          id: param,
        },
      })
        .then(function (response) {
          var file = new Blob([response.data], { type: "application/pdf" });

          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);

          var params = {
            model: 18,
            event: "POST",
            associated_id: $scope.caratula.id,
            identifier: "generó el PDF.",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.sendProvider = function (param) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/aseguradoras/send.modal.html",
        controller: "SendPDFModalCtrl",
        size: "md",
        resolve: {
          provider: function () {
            return param;
          },
          typeOT: function () {
            return 1;
          },
          from: function () {
            return null;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };

    $scope.deletePolicy = function () {
      $http({
        method: "GET",
        url: url.IP + "get-relations-by-id/",
        params: {
          id: $scope.caratula.id,
          id_caratula: $scope.caratula.id,
        },
      })
        .then(function (response_relations) {
          console.log("response relations", response_relations);
          var foo = response_relations.data["categorias"].map(function (bar) {
            return "ID: " + bar[2] + ",Nombre:" + bar[0] + "\n";
          });
          var crt = response_relations.data["certificados"].map(function (bar) {
            return (
              "ID: " +
              bar[3] +
              ",Certificado:" +
              bar[2] +
              ",Categoría:" +
              bar[0] +
              "\n"
            );
          });
          // var arc = response_relations.data['archivos'].map(function(bar){
          //   return 'ID: '+bar[3]+',Nombre:'+bar[2]+',PólizaID:'+bar[0]+'\n'
          // })
          // var arcc = response_relations.data['archivosCertificados'].map(function(bar){
          //   return 'ID: '+bar[3]+',Nombre:'+bar[2]+',PólizaID:'+bar[0]+'\n'
          // })
          var end = response_relations.data["endosos"].map(function (bar) {
            return (
              "ID: " +
              bar[2] +
              ",Número:" +
              bar[1] +
              ",Interno:" +
              bar[0] +
              "\n"
            );
          });
          var endc = response_relations.data["endososCertificados"].map(
            function (bar) {
              return (
                "ID: " +
                bar[4] +
                ",Número:" +
                bar[1] +
                ",Interno:" +
                bar[0] +
                ",PolizaN:" +
                bar[2] +
                ",PolizaID:" +
                bar[3] +
                "\n"
              );
            }
          );
          // var recs = response_relations.data['recibos'].map(function(bar){
          //   return 'ID: '+bar[3]+',Serie:'+bar[0]+',Tipo:'+bar[1]+'\n'
          // })
          var sins = response_relations.data["siniestros"].map(function (bar_) {
            return (
              "ID: " +
              bar_[4] +
              ",Número:" +
              bar_[1] +
              ",Interno:" +
              bar_[0] +
              ",PolizaN:" +
              bar_[2] +
              ",PolizaID:" +
              bar_[3] +
              "\n"
            );
          });
          var sinsc = response_relations.data["siniestrosCertificados"].map(
            function (bar) {
              return (
                "ID: " +
                bar[4] +
                ",Número:" +
                bar[1] +
                ",Interno:" +
                bar[0] +
                ",PolizaN:" +
                bar[2] +
                ",PolizaID:" +
                bar[3] +
                "\n"
              );
            }
          );
          $scope.textLog =
            "Categorias: " +
            (response_relations.data["categorias"] ? foo : "Sin categorías") +
            "\n";
          $scope.textLog =
            $scope.textLog +
            "Certificados: " +
            (response_relations.data["certificados"]
              ? crt
              : "Sin certificados") +
            "\n";
          // $scope.textLog = $scope.textLog +'Archivos: '+ (response_relations.data['archivos'] ? arc : 'Sin archivos')+'\n'
          // $scope.textLog = $scope.textLog +'Archivos Certificados: '+ (response_relations.data['archivosCertificados'] ? arcc : 'Sin archivos Certificados')+'\n'
          $scope.textLog =
            $scope.textLog +
            "Endosos: " +
            (response_relations.data["endosos"] ? end : "Sin endosos") +
            "\n";
          $scope.textLog =
            $scope.textLog +
            "EndososCertificados: " +
            (response_relations.data["endososCertificados"]
              ? endc
              : "Sin endosos Certificados") +
            "\n";
          // $scope.textLog = $scope.textLog +'Recibos: '+ (response_relations.data['recibos'] ? recs: 'Sin recibos')+'\n'
          $scope.textLog =
            $scope.textLog +
            "Siniestros: " +
            (response_relations.data["siniestros"] ? sins : "Sin siniestros") +
            "\n";
          $scope.textLog =
            $scope.textLog +
            "Siniestros Certificados: " +
            (response_relations.data["siniestrosCertificados"]
              ? sinsc
              : "Sin siniestros certificados");
          // $scope.textLog = $scope.textLog +'Archivos Certificados: '+ (response_relations.data['archivosCertificados'] ? arcc : 'Sin archivos certificados')

          var modalInstance = $uibModal.open({
            templateUrl: "app/colectivos/deleteElement.modal.html",
            controller: DeleteElementController,
            size: "lg",
            backdrop: "static",
            keyboard: false,
            resolve: {
              log: function () {
                return $scope.textLog;
              },
              valores: function () {
                return response_relations.data;
              },
              item: function () {
                return $scope.caratula;
              },
              tipo: function () {
                return 3;
              },
              caratula: function () {
                return $scope.caratula;
              },
              copy_policy_history: function () {
                return $scope.copy_policy_history;
              },
            },
          });
          modalInstance.closed.then(function (x) {
            $scope.allCertificates();
          });
        })
        .catch(function (e) {
          console.log("e", e);
        });
      // SweetAlert.swal({
      //   title: "Eliminar Póliza de Grupo",
      //   text: "Los cambios no podrán revertirse, ¿Está seguro?",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#DD6B55",
      //   confirmButtonText: "Si",
      //   cancelButtonText: "No",
      //   closeOnConfirm: true,
      //   closeOnCancel: false
      // },
      // function(isConfirm){
      //   if(isConfirm){
      //     $http.post(url.IP + 'delete-colectivity/', {'id': $scope.caratula.id,'logs':$scope.textLog})
      //     .then(function(response){
      //       if($scope.copy_policy_history){
      //         if($scope.copy_policy_history.url){
      //           if(process(convertDate($scope.copy_policy_history.start_of_validity)) > process(convertDate(new Date()))){
      //             var data = {
      //               status: 10,
      //               renewed_status: 0
      //             }
      //           }else{
      //             if(process(convertDate($scope.copy_policy_history.end_of_validity)) > process(convertDate(new Date()))){
      //               var data = {
      //                 status: 14,
      //                 renewed_status: 0
      //               }
      //             }else{
      //               var data = {
      //                 status: 13,
      //                 renewed_status: 0
      //               }
      //             }
      //           }
      //           function process(date){
      //             var parts = date.split("/");
      //             var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
      //             return date.getTime();
      //           }
      //           $http.patch($scope.copy_policy_history.url, data)
      //           .then(function success(request){
      //             if(request.status === 200){
      //               var paramsRec = {
      //                 'model': 18,
      //                 'event': "PATCH",
      //                 'associated_id': $scope.copy_policy_history.id,
      //                 'identifier':" eliminó la renovación."
      //               }
      //               dataFactory.post('send-log/', paramsRec).then(function success(response){

      //               });
      //             }
      //           })
      //           .catch(function(e){
      //             console.log('error', e);
      //           });
      //         }
      //       }

      //       SweetAlert.swal("¡Listo!", MESSAGES.OK.DELETECOLLECTIVITY, "success");

      //       var name = 'Inicio';
      //       var route = 'inicio.inicio';
      //       $scope.name_for_new_tab = name;
      //       $scope.route_for_new_tab = route;

      //       var existe = false;
      //       if (name && route){
      //         $scope.route_for_new_tab = route;
      //         $scope.name_for_new_tab = name;
      //         appStates.states.forEach(function(state) {
      //           if (state.route == $scope.route_for_new_tab){
      //             existe = true;
      //           }
      //         });
      //       }

      //       if (!existe){
      //         var active_tab = appStates.states.findIndex(function(item){
      //           if (item.active){
      //             return true
      //           }
      //           return false;
      //         });

      //         appStates.states[active_tab] = {
      //           name: $scope.name_for_new_tab,
      //           heading: $scope.name_for_new_tab,
      //           route: $scope.route_for_new_tab,
      //           active: true,
      //           isVisible: true,
      //           href: $state.href($scope.route_for_new_tab),
      //         }
      //       }
      //       $localStorage.tab_states = appStates.states;
      //       $state.go($scope.route_for_new_tab);
      //     })
      //     .catch(function(e){
      //       console.log('error', e);
      //     });
      //    }else{
      //     SweetAlert.swal("Cancelado", "La Póliza de Grupo no se ha eliminado", "error");
      //   }
      // });
    };

    $scope.cancelPolicyModal = function (param) {
      SweetAlert.swal(
        {
          title: "Cancelar",
          text: "Los cambios no podrán revertirse, ¿Está seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var modalInstance = $uibModal.open({
              templateUrl: "app/polizas/poliza.modal.html",
              controller: PolicyModalCtrl,
              controllerAs: "vmm",
              size: "md",
              resolve: {
                contractorModal: function () {
                  return $scope.contratante;
                },
                urlInsurance: function () {
                  return param.url;
                },
                receipts: function () {
                  return [];
                },
                caratula: function () {
                  return $scope.caratula;
                },
              },
              backdrop:
                "static" /* this prevent user interaction with the background */,
              keyboard: false,
            });
            modalInstance.result.then(function (receipt) {
              $state.go("colectividades.info", { polizaId: myInsurance.id });
            });
          } else {
            SweetAlert.swal(
              "Cancelado",
              "La Póliza de Grupo no se ha cancelado.",
              "error"
            );
          }
        }
      );
    };

    $scope.getLog = function () {
      dataFactory
        .get("get-specific-log", {
          model: 18,
          associated_id: $scope.caratula.id,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/colectivos/log.modal.html",
            controller: LogController,
            size: "lg",
            backdrop: "static",
            keyboard: false,
            resolve: {
              log: function () {
                return response.data;
              },
            },
          });
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.returnToInfo = function () {
      $scope.infoFlag = true;
      $scope.endoFlag = false;
      $scope.noteFlag = false;
      $scope.adjuFlag = false;
    };

    $scope.showEndorsements = function () {
      console.log("i", $scope.endorsements);
      vm.endorsementsPolicy = [];
      vm.endorsementsCert = [];
      vm.loadingEndorsementsPolicy = true;
      vm.loadingEndorsementsCert = true;
      $scope.infoFlag = false;
      $scope.endoFlag = true;
      $scope.noteFlag = false;
      $scope.adjuFlag = false;
      // 1) Endosos de póliza
      $http
        .get(url.IP + "view-endosos", {
          params: { policy: $scope.caratula.id },
        })
        .then(function (res) {
          vm.endorsementsPolicy =
            res.data && res.data.endosos ? res.data.endosos : res.data || [];
          // 2) Certificados con endosos
          vm.loadingEndorsementsCert = false;
          vm.endorsementsCert =
            res.data && res.data.certificados
              ? res.data.certificados
              : res.data || [];
        })
        .finally(function () {
          vm.loadingEndorsementsPolicy = false;
        });
    };

    $scope.concept = function (param) {
      switch (param) {
        case 1:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 2:
          return "CAMBIO DE SUMA ASEGURADA";
          break;
        case 3:
          return "OTRO";
          break;
        case 4:
          return "PRÓRROGA DE VIGENCIA";
          break;
        case 5:
          return "AGREGAR COBERTURAS";
          break;
        case 6:
          return "DECLARACIÓN MENSUAL";
          break;
        case 8:
          return "CAMBIO DATOS FISCALES";
          break;
        case 9:
          return "ESPECIFICACIONES";
          break;
        case 11:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 12:
          return "DISMINUCIÓN EN LA SUMA ASEGURADA";
          break;
        case 13:
          return "BAJA DE COBERTURA";
          break;
        case 14:
          return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
          break;
        case 15:
          return "BAJA DE ASEGURADO";
          break;
        case 16:
          return "CANCELACIÓN DE PÓLIZA POR PETICIÓN";
          break;
        case 17:
          return "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO";
          break;
        case 23:
          return "ANTIGÜEDAD RECONOCIDA";
          break;
        case 24:
          return "ALTA ASEGURADOS";
          break;
        case 25:
          return "BAJA ASEGURADO";
          break;
        case 26:
          return "AJUSTE ANUAL A";
          break;
        case 27:
          return "RECONOCIMIENTO ANTIGÜEDAD";
          break;
        case 28:
          return "AJUSTE ANUAL D";
          break;
        case 41:
          return "ALTA DE UNIDAD";
          break;
        case 42:
          return "AGREGAR COBERTURA";
          break;
        case 43:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 44:
          return "AGREGAR CARGA";
          break;
        case 45:
          return "AGREGAR ADAPTACIONES Y CONVERSIONES";
          break;
        case 46:
          return "INCLUIR BP";
          break;
        case 47:
          return "CORREGIR DESCRIPCIÓN";
          break;
        case 48:
          return "AGREGAR TEXTOS ACLARATORIOS";
          break;
        case 49:
          return "ADAPTACIONES SOLO PARA EFECTOS DE RC";
          break;
        case 50:
          return "AGREGAR PLACAS, MOTOR O CORREGIR SERIE";
          break;
        case 51:
          return "CANCELACIONES";
          break;
        case 52:
          return "ELIMINACIÓN DE COBERTURAS";
          break;
        default:
          return "OTRO";
      }
    };

    $scope.goToEndorsement = function (param) {
      var name = "Endoso";
      if (param) {
        $scope.route_for_new_tab = "endorsement.info";
        var route = "endorsement.info";
      } else {
        $scope.route_for_new_tab = "endorsement.collectivity";
        var route = "endorsement.collectivity";
      }

      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;

      if (param) {
        $state.go("endorsement.info", { endosoId: param });
      } else {
        $scope.caratula.doEndorsement = true;
        var params = {
          myInsurance: $scope.caratula,
          contractor: $scope.contractorModal,
        };
        if (route == "endorsement.collectivity") {
          $localStorage["save_created_endoso_grupo"] = {};
          $localStorage["save_created_endoso_grupo"]["poliza"] =
            $scope.caratula.poliza_number;
          $localStorage["save_created_endoso_grupo"]["poliza_id"] =
            $scope.caratula.id;
          $localStorage["save_created_endoso_grupo"]["origin_endorsement"] =
            $scope.caratula;
        }
        $state.go("endorsement.collectivity", params);
      }
    };

    $scope.showNotes = function () {
      $scope.infoFlag = false;
      $scope.endoFlag = false;
      $scope.noteFlag = true;
      $scope.adjuFlag = false;
    };

    $scope.verAjusteCuenta = function (item) {
      if (item) {
        $scope.ajuste_neta = 0;
        $scope.ajuste_total = 0;
        $scope.ajuste_rpf = 0;
        $scope.ajuste_iva = 0;
        $scope.ajuste_derecho = 0;
        var data = {
          policy: item,
        };
        dataFactory
          .get("get-endosos-colect/", data)
          .then(function (response) {
            if (response.status == 200 || response.status == 201) {
              if (response.data.endosos.length > 0) {
                $scope.endorsement_history = response.data.endosos;

                $scope.infoFlag = false;
                $scope.endoFlag = false;
                $scope.noteFlag = false;
                $scope.adjuFlag = true;
                $scope.show_section(1);

                $scope.endorsement_history.forEach(function (endoso) {
                  $scope.ajuste_neta =
                    $scope.ajuste_neta + parseFloat(endoso.p_neta);
                  $scope.ajuste_rpf =
                    $scope.ajuste_rpf + parseFloat(endoso.rpf);
                  $scope.ajuste_derecho =
                    $scope.ajuste_derecho + parseFloat(endoso.derecho);
                  $scope.ajuste_iva =
                    $scope.ajuste_iva + parseFloat(endoso.iva);
                  $scope.ajuste_total =
                    $scope.ajuste_total + parseFloat(endoso.p_total);
                });
              }
            }
          })
          .catch(function (e) {
            console.log("error", e);
          });
      }
    };

    $scope.shareCertificatesAPPEmail = function (caratula, caratulaInfo) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/polizas.certificateMasivoEmail.html",
        controller: assignCertificateMasivoModalView,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policy_id: function () {
            return caratula;
          },
          caratulaInfo: function () {
            return caratulaInfo;
          },
          contratante: function () {
            return $scope.contratante;
          },
          sendOnlyEmail: function () {
            return false;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };
    $scope.shareCertificatesApp = function (caratula) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Se compartirán todos los certificados a los correos asignados a un usuario de la App",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id_poliza: caratula,
              is_owner: false,
              active: true,
            };
            dataFactory
              .post("shareCertificatesToApp/", data_email)
              .then(function success(req) {
                if (req.status == 200 || req.status == 201) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "Se ha enviado el correo correspondiente de confirmación",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "Ha ocurrido un error al compartir certificados de la Carátula",
                    "error"
                  );
                }
              });
          }
        }
      );
    };

    $scope.shareCertificatesEmail = function (caratula, caratulaInfo) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/polizas.certificateMasivoEmail.html",
        controller: assignCertificateMasivoModalView,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policy_id: function () {
            return caratula.id;
          },
          caratulaInfo: function () {
            return caratulaInfo;
          },
          contratante: function () {
            return $scope.contratante;
          },
          sendOnlyEmail: function () {
            return true;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };

    $scope.statusPayment = function (value) {
      switch (value) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 7:
          return "Semanal";
          break;
        case 12:
          return "Anual";
          break;
        case 14:
          return "Catorcenal";
          break;
        case 24:
          return "Quincenal";
          break;
        default:
          return value;
      }
    };
    // No Renovar
    $scope.cancelRenovate = function (valuePoliza) {
      swal(
        {
          title: "No renovar",
          text: "Motivo:",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: false,
        },
        function (inputValue) {
          if (inputValue === false) return false;
          if (inputValue === "") {
            swal.showInputError("Necesita especificar un motivo de No Renovar");
            return false;
          }
          var data = {
            reason_ren: inputValue,
            status: 15,
          };
          $http.patch(valuePoliza.url, data).then(function (ren) {
            var params = {
              model: 18,
              event: "PATCH",
              associated_id: valuePoliza.id,
              identifier:
                " cambio el estatus a No Renovada por el motivo " +
                ren.data.reason_ren +
                " de la póliza " +
                ren.data.poliza_number +
                ".",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          });
          $scope.caratula.status = "No Renovada";
          $scope.caratula.reason_ren = inputValue;
          swal(
            "Hecho",
            "La póliza se ha cerrado y no se vera más en el listado de renovaciones",
            "success"
          );
        }
      );
    };
    $scope.changedomiciliado = function () {
      SweetAlert.swal(
        {
          title: "Domiciliar Póliza de Grupo",
          text: "Este cambio se aplicará a todos los recibos, ¿desea domiciliar?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, domiciliar",
          cancelButtonText: "No, no domiciliar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.caratula.recibos_poliza.forEach(function (receipt) {
              $http
                .patch(receipt.url, { is_cat: true })
                .then(function (response) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "Recibo(s) actualizado(s)",
                    "success"
                  );
                  activate();
                });
            });
            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.caratula.id,
              identifier:
                " cambio el estatus del cargo Automático(Domiciliado) a SI de los recibos desde la carátula.",
            };
            dataFactory
              .post("send-log/", paramsRec)
              .then(function success(response) {});
          } else {
            $scope.caratula.recibos_poliza.forEach(function (receipt) {
              $http
                .patch(receipt.url, { is_cat: false })
                .then(function (response) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "Recibo(s) actualizado(s)",
                    "success"
                  );
                  activate();
                });
            });
            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.caratula.id,
              identifier:
                " cambio el estatus del cargo Automático(Domiciliado) a NO de los recibos desde la carátula.",
            };
            dataFactory
              .post("send-log/", paramsRec)
              .then(function success(response) {});
          }
        }
      );
    };

    $scope.statusReceipt = function (parValue) {
      switch (parValue) {
        case 1:
          return "Pagado";
          break;
        case 2:
          return "Cancelado";
          break;
        case 3:
          return "Prorrogado";
          break;
        case 4:
          return "Pendiente de Pago";
          break;
        case 5:
          return "Liquidado";
          break;
        case 6:
          return "Conciliado";
          break;
        case 7:
          return "Cerrado";
          break;
        case 8:
          return "Precancelado";
          break;
        case 9:
          return "Pago Parcial";
          break;
        default:
          return parValue;
      }
    };

    $scope.calculatePrimas = function (receipts) {
      $scope.total_prima = 0;
      $scope.total_rpf = 0;
      $scope.total_derecho = 0;
      $scope.total_iva = 0;
      $scope.total_total = 0;
      $scope.total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 1 && receipts[i].status != 0) {
          $scope.total_prima =
            parseFloat($scope.total_prima) + parseFloat(receipts[i].prima_neta);
          $scope.total_rpf =
            parseFloat($scope.total_rpf) + parseFloat(receipts[i].rpf);
          $scope.total_derecho =
            parseFloat($scope.total_derecho) + parseFloat(receipts[i].derecho);
          $scope.total_iva =
            parseFloat($scope.total_iva) + parseFloat(receipts[i].iva);
          $scope.total_total =
            parseFloat($scope.total_total) +
            parseFloat(receipts[i].prima_total);
          $scope.total_comision =
            parseFloat($scope.total_comision) +
            parseFloat(receipts[i].comision);
        }
      }
    };

    $scope.calculatePrimasEndorsement = function (receipts) {
      $scope.endorsement_total_prima = 0;
      $scope.endorsement_total_rpf = 0;
      $scope.endorsement_total_derecho = 0;
      $scope.endorsement_total_iva = 0;
      $scope.endorsement_total_total = 0;
      $scope.endorsement_total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 2 && receipts[i].status != 0) {
          $scope.endorsement_total_prima =
            parseFloat($scope.endorsement_total_prima) +
            parseFloat(receipts[i].prima_neta);
          $scope.endorsement_total_rpf =
            parseFloat($scope.endorsement_total_rpf) +
            parseFloat(receipts[i].rpf);
          $scope.endorsement_total_derecho =
            parseFloat($scope.endorsement_total_derecho) +
            parseFloat(receipts[i].derecho);
          $scope.endorsement_total_iva =
            parseFloat($scope.endorsement_total_iva) +
            parseFloat(receipts[i].iva);
          $scope.endorsement_total_total =
            parseFloat($scope.endorsement_total_total) +
            parseFloat(receipts[i].prima_total);
          $scope.endorsement_total_comision =
            parseFloat($scope.endorsement_total_comision) +
            parseFloat(receipts[i].comision);
        }
      }
    };

    $scope.calculatePrimasEndorsement = function (receipts) {
      $scope.endorsement_total_prima = 0;
      $scope.endorsement_total_rpf = 0;
      $scope.endorsement_total_derecho = 0;
      $scope.endorsement_total_iva = 0;
      $scope.endorsement_total_total = 0;
      $scope.endorsement_total_comision = 0;
      for (var i = 0; i < receipts.length; i++) {
        if (receipts[i].receipt_type == 2 && receipts[i].status != 0) {
          $scope.endorsement_total_prima =
            parseFloat($scope.endorsement_total_prima) +
            parseFloat(receipts[i].prima_neta);
          $scope.endorsement_total_rpf =
            parseFloat($scope.endorsement_total_rpf) +
            parseFloat(receipts[i].rpf);
          $scope.endorsement_total_derecho =
            parseFloat($scope.endorsement_total_derecho) +
            parseFloat(receipts[i].derecho);
          $scope.endorsement_total_iva =
            parseFloat($scope.endorsement_total_iva) +
            parseFloat(receipts[i].iva);
          $scope.endorsement_total_total =
            parseFloat($scope.endorsement_total_total) +
            parseFloat(receipts[i].prima_total);
          $scope.endorsement_total_comision =
            parseFloat($scope.endorsement_total_comision) +
            parseFloat(receipts[i].comision);
        }
      }
    };

    $scope.calculatePrimasSubgroup = function () {
      $scope.subgrupos.forEach(function (subgroup) {
        if (subgroup.recibos_poliza.length > 0) {
          $scope.total_prima = 0;
          $scope.total_rpf = 0;
          $scope.total_derecho = 0;
          $scope.total_iva = 0;
          $scope.total_total = 0;
          $scope.total_comision = 0;
          for (var i = 0; i < subgroup.recibos_poliza.length; i++) {
            if (subgroup.recibos_poliza[i].receipt_type == 1) {
              ($scope.total_prima =
                parseFloat($scope.total_prima) +
                parseFloat(subgroup.recibos_poliza[i].prima_neta)),
                ($scope.total_rpf =
                  parseFloat($scope.total_rpf) +
                  parseFloat(subgroup.recibos_poliza[i].rpf)),
                ($scope.total_derecho =
                  parseFloat($scope.total_derecho) +
                  parseFloat(subgroup.recibos_poliza[i].derecho)),
                ($scope.total_iva =
                  parseFloat($scope.total_iva) +
                  parseFloat(subgroup.recibos_poliza[i].iva)),
                ($scope.total_total =
                  parseFloat($scope.total_total) +
                  parseFloat(subgroup.recibos_poliza[i].prima_total)),
                ($scope.total_comision =
                  parseFloat($scope.total_comision) +
                  parseFloat(subgroup.recibos_poliza[i].comision));
            }
          }
          var totales = {
            total_prima: $scope.total_prima,
            total_rpf: $scope.total_rpf,
            total_derecho: $scope.total_derecho,
            total_iva: $scope.total_iva,
            total_total: $scope.total_total,
            total_comision: $scope.total_comision,
          };
          $scope.subgroup_total_prima.push(totales);
        } else {
          var totales = {
            total_prima: 0,
            total_rpf: 0,
            total_derecho: 0,
            total_iva: 0,
            total_total: 0,
            total_comision: 0,
          };
          $scope.subgroup_total_prima.push(totales);
        }
      });
      $scope.allPrimasSugroup();
    };

    $scope.allPrimasSugroup = function () {
      $scope.caratula.p_neta = 0;
      $scope.total_rpf = 0;
      $scope.total_derecho = 0;
      $scope.total_iva = 0;
      $scope.total_total = 0;
      $scope.total_comision = 0;
      $scope.subgroup_total_prima.forEach(function (item) {
        ($scope.caratula.p_neta =
          parseFloat($scope.caratula.p_neta) + parseFloat(item.total_prima)),
          ($scope.caratula.rpf =
            parseFloat($scope.caratula.rpf) + parseFloat(item.total_rpf)),
          ($scope.caratula.derecho =
            parseFloat($scope.caratula.derecho) +
            parseFloat(item.total_derecho)),
          ($scope.caratula.iva =
            parseFloat($scope.caratula.iva) + parseFloat(item.total_iva)),
          ($scope.caratula.p_total =
            parseFloat($scope.caratula.p_total) + parseFloat(item.total_total)),
          ($scope.caratula.comision =
            parseFloat($scope.caratula.comision) +
            parseFloat(item.total_comision));
      });
    };

    $scope.deliveredReceipt = function (receipt) {
      SweetAlert.swal(
        {
          title: "Entregado",
          text: "Este recibo se marcara como entregado, ¿Estás seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          comfirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "PATCH",
              url: receipt.url,
              data: {
                delivered: true,
              },
            }).then(function success(response) {
              if (response.status == 200) {
                var params = {
                  model: 4,
                  event: "PATCH",
                  associated_id: receipt.id,
                  identifier: " actualizó el recibo a Entregado.",
                };
                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});
                SweetAlert.swal(
                  "¡Listo!",
                  "Recibo actualizado exitosamente.",
                  "success"
                );
                activate();
              }
            });
          }
        }
      );
    };

    $scope.changeStatusModal = function (contractor, receipt) {
      receipt.contratante = contractor;
      var insurance = $scope.caratula;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return $scope.caratula;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    };

    $scope.addEmailsConfirmPolicy = function (insurance, param) {
      insurance.contratante = param;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return insurance;
          },
          valueReceipt: function () {
            return insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    };

    $scope.returnToReceipts = function () {
      $scope.show_binnacle_receipt = false;
    };

    $scope.showBinnacleReceipt = function (receipt) {
      $scope.show_binnacle_receipt = true;
      $scope.receipt_id = receipt.id;
      $scope.comments_data_receipt = [];
      $scope.receiptmodel = receipt.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: receipt.id,
        },
      })
        .then(function (request) {
          $scope.comments_data_receipt = request.data.results;
          $scope.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.returnToReceiptsEndorsement = function () {
      $scope.show_binnacle_receipt_endorsement = false;
    };

    $scope.showBinnacleReceiptEndorsement = function (receipt) {
      $scope.show_binnacle_receipt_endorsement = true;
      $scope.receipt_id = receipt.id;
      $scope.comments_data_receipt = [];
      $scope.receiptmodel = receipt.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: receipt.id,
        },
      })
        .then(function (request) {
          $scope.comments_data_receipt = request.data.results;
          $scope.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.returnToReceiptsSubgroup = function () {
      $scope.show_binnacle_receipt_subgroup = false;
    };

    $scope.showBinnacleReceiptSubgroup = function (receipt) {
      $scope.show_binnacle_receipt_subgroup = true;
      $scope.receipt_id = receipt.id;
      $scope.comments_data_receipt = [];
      $scope.receiptmodel = receipt.url;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: receipt.id,
        },
      })
        .then(function (request) {
          $scope.comments_data_receipt = request.data.results;
          $scope.comments_config_receipt = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.editReceipt = function (receipt, index) {
      var texto =
        "No se validarán las primas y ni las fechas al editar este recibo. ¿Deseas continuar?";
      if (
        $scope.acceso_pl_cob == false &&
        (receipt.status == 1 || receipt.status == "Pagado")
      ) {
        var texto =
          "No se validarán las primas y ni las fechas al editar este recibo.  \nEstas editando un recibo PAGADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      } else if (
        $scope.acceso_pl_cob == false &&
        (receipt.status == 5 || receipt.status == "Liquidado")
      ) {
        var texto =
          "No se validarán las primas y ni las fechas al editar este recibo.  \nEstas editando un recibo LIQUIDADO, para posteriores casos te recomendamos revisar bien las primas antes del proceso de pago/liquidación, ya que este tipo de acciones no son recomendables.\n ¿Deseas continuar?";
      }
      if (
        receipt.status == 4 ||
        receipt.status == "Pendiente de pago" ||
        ($scope.acceso_pl_cob == false &&
          (receipt.status == 5 ||
            receipt.status == "Liquidado" ||
            receipt.status == 1 ||
            receipt.status == "Pagado"))
      ) {
        SweetAlert.swal(
          {
            title: "Advertencia",
            text: texto,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var modalInstance = $uibModal.open({
                templateUrl: "app/colectivos/receipt.html",
                controller: EditReceiptCtrl,
                controllerAs: "rec",
                size: "lg",
                resolve: {
                  recibo: function () {
                    return receipt;
                  },
                  index: function () {
                    return index;
                  },
                  caratula: function () {
                    return $scope.caratula;
                  },
                  acceso_pl_cob: function () {
                    return $scope.acceso_pl_cob;
                  },
                },
                backdrop: "static",
                keyboard: false,
              });
              modalInstance.closed.then(function (receipt) {
                activate();
              });
            } else {
              SweetAlert.swal(
                "Cancelado",
                "El recibo no ha sido actualizado.",
                "error"
              );
            }
          }
        );
      } else {
        SweetAlert.swal(
          "Advertencia",
          "El recibo no se puede editar porque no esta pendiente de pago.",
          "warning"
        );
      }
    };

    function EditReceiptCtrl(
      url,
      $http,
      $rootScope,
      recibo,
      index,
      caratula,
      $scope,
      $uibModalInstance,
      acceso_pl_cob
    ) {
      var rec = this;
      rec.recibo = recibo;
      var fecha_inicio = recibo.fecha_inicio;
      var fecha_fin = recibo.fecha_fin;
      var fecha_venc = recibo.vencimiento;

      rec.recibo.fecha_inicio = datesFactory.convertDate(recibo.fecha_inicio);
      rec.recibo.fecha_fin = datesFactory.convertDate(recibo.fecha_fin);
      rec.recibo.vencimiento = datesFactory.convertDate(recibo.vencimiento);

      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d_uno = new Date(inputFormat);
        var fecha = new Date(inputFormat);
        if (fecha.getUTCHours() <= 11) {
          fecha.setHours(fecha.getHours() + 12);
        } else {
          fecha.setHours(fecha.getHours() + 5);
        }
        var d = fecha;
        // var d = new Date(inputFormat).toISOString()//prueba
        // console.log('-fecha 2',d,new Date(d.toLocaleString()))
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
        return date;
      }

      function toDate(dateStr) {
        if (dateStr) {
          var dateString = dateStr;
          var dateParts = dateString.split("/");
          var dateObject = new Date(
            dateParts[2],
            dateParts[1] - 1,
            dateParts[0]
          );
          return dateObject;
        }
      }
      var date1, date2, date3, dateDiff1, dateDiff2;
      $scope.validateDates_venc = function (date) {
        //Validando vacio
        if (date == undefined) {
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede estar vacia",
            "error"
          );
          return;
        }
        //Validando no menor a fecha inicio
        date1 = datesFactory.toDate(date);
        date2 = datesFactory.toDate(rec.recibo.fecha_inicio);
        date3 = datesFactory.toDate(convertDate(caratula.end_of_validity));
        dateDiff1 = moment(date1).diff(moment(date2), "days");
        dateDiff2 = moment(date1).diff(moment(date3), "days");

        // if(dateDiff1 < 0){
        //   rec.recibo.vencimiento = convertDate(fecha_venc);
        //   SweetAlert.swal("Error", "La fecha de vencimiento no puede ser menor que la inicial", "error");
        //   return;
        // }
        //Validando a no mayor a 30 dias de fin de vigencia de Póliza de Grupo
        if (dateDiff2 > 30) {
          rec.recibo.vencimiento = convertDate(fecha_venc);
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede ser mayor a 30 días a la fecha de la vigencia de la Póliza de Grupo",
            "error"
          );
          return;
        }
      };
      $scope.validateDecimal = function (form) {
        form = String(form).replace(/[A-Za-z]/g, "");
        form = String(form).replace(/,/g, "");
        return form;
      };

      $scope.changePrimas = function (data) {
        rec.recibo.sub_total = (
          parseFloat(data.prima_neta) +
          parseFloat(data.rpf) +
          parseFloat(data.derecho)
        ).toFixed(2);
        rec.recibo.prima_total = (
          parseFloat(rec.recibo.sub_total) + parseFloat(data.iva)
        ).toFixed(2);
      };

      $scope.saveReceipt = function (receipt) {
        var texto_log = "";
        if (
          (receipt.status == 1 || receipt.status == "Pagado") &&
          acceso_pl_cob == false
        ) {
          var texto_log = " EDICION DE RECIBO PAGADO";
        }
        if (
          (receipt.status == 5 || receipt.status == "Liquidado") &&
          acceso_pl_cob == false
        ) {
          var texto_log = " EDICION DE RECIBO LIQUIDADO";
        }
        if (process(receipt.fecha_fin) < process(receipt.fecha_inicio)) {
          SweetAlert.swal(
            "Error",
            "La fecha fin del recibo no puede ser menor a la de su inicio.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }
        if (rec.recibo.vencimiento == undefined) {
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede estar vacia",
            "error"
          );
          return;
        }

        //Validando no menor a fecha inicio
        date1 = datesFactory.toDate(rec.recibo.vencimiento);
        date2 = datesFactory.toDate(rec.recibo.fecha_inicio);
        date3 = datesFactory.toDate(convertDate(caratula.end_of_validity));
        dateDiff1 = moment(date1).diff(moment(date2), "days");
        dateDiff2 = moment(date1).diff(moment(date3), "days");

        // if(dateDiff1 < 0){
        //   SweetAlert.swal("Error", "La fecha de vencimiento no puede ser menor que la inicial", "error");
        //   return;
        // }
        //Validando a no mayor a 30 dias de fin de vigencia de poliza
        if (dateDiff2 > 30) {
          SweetAlert.swal(
            "Error",
            "La fecha de vencimiento no puede ser mayor a 30 días a la fecha de la vigencia de la Póliza",
            "error"
          );
          return;
        }

        if (
          process(rec.recibo.fecha_inicio) <
          process(convertDate(caratula.start_of_validity))
        ) {
          SweetAlert.swal(
            "Error",
            "La fecha de inicio del recibo no puede ser menor a la fecha de inicio de la póliza.",
            "error"
          );
          return;
        }

        if (process(rec.recibo.fecha_fin) < process(rec.recibo.fecha_inicio)) {
          SweetAlert.swal(
            "Error",
            "La fecha fin del recibo no puede ser menor a la de su inicio.",
            "error"
          );
          return;
        }
        var obj = {
          fecha_inicio: new Date(toDate(receipt.fecha_inicio)),
          fecha_fin: new Date(toDate(receipt.fecha_fin)),
          prima_neta: receipt.prima_neta,
          rpf: receipt.rpf,
          derecho: receipt.derecho,
          iva: receipt.iva,
          prima_total: receipt.prima_total,
          comision: receipt.comision,
          vencimiento: new Date(toDate(receipt.vencimiento)),
          delivered: receipt.delivered,
        };

        $http.patch(receipt.url, obj).then(function (response) {
          var params = {
            model: 18,
            event: "PATCH",
            associated_id: caratula.id,
            identifier:
              "actualizó el recibo, " +
              receipt.recibo_numero +
              "- " +
              texto_log +
              ".",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          var params = {
            model: 4,
            event: "POST",
            associated_id: receipt.id,
            identifier: "actualizó el recibo, " + texto_log + ".",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          SweetAlert.swal(
            "¡Listo!",
            "El recibo ha sido actualizado.",
            "success"
          );
          $scope.cancel(true);
        });
      };

      $scope.cancel = function (v) {
        if (!v) {
          rec.recibo.fecha_inicio = fecha_inicio;
          rec.recibo.fecha_fin = fecha_fin;
          rec.recibo.vencimiento = fecha_venc;
        }
        $uibModalInstance.dismiss("cancel");
      };
    }
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };
    $scope.deleteReceipts = function (receipt, index) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text:
            "No será posible recuperar este recibo: " + receipt.recibo_numero,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: receipt.id,
              id_poliza: $scope.caratula.id,
              model: 8,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {});
            $http
              .patch(receipt.url, { status: 0 })
              .then(function (recibo_delete) {
                var paramsDelRec = {
                  model: 18,
                  event: "DELETE",
                  associated_id: $scope.caratula.id,
                  identifier:
                    " elimino un recibo (" +
                    receipt.recibo_numero +
                    ") de la póliza",
                };
                dataFactory
                  .post("send-log/", paramsDelRec)
                  .then(function success(response) {});
                if (recibo_delete.data.status == 0) {
                  if (recibo_delete.data.receipt_type == 3) {
                    $scope.notesCaratula.splice(index, 1);
                  } else {
                    $scope.caratula.recibos_poliza.splice(index, 1);
                  }
                }
                SweetAlert.swal("¡Hecho!", "Recibo eliminado.", "success");
              });
          }
        }
      );
    };

    // Upload files
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.tipoPoliza.document_type == 6) {
        $scope.certificate.files.push(response);
      }
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal(
          "¡Listo!",
          "Archivos cargados exitosamente.",
          "success"
        );
        if (
          $scope.tipoPoliza.document_type == 3 ||
          $scope.tipo_pago.document_type == "Póliza de grupo"
        ) {
          $state.go("colectividades.info", { polizaId: $scope.caratula.id });
          $state.reload();
        }
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
      fileItem.removeAfterUpload = true;
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }

      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(polizaId) {
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";

      $scope.files = [];

      // $timeout(function() {
      $scope.uploader.uploadAll();

      saveLogFile($scope.countFile, polizaId, $scope.model_log);
      activate();
      // }, 1000);
    }
    function saveLogFile(num, polizaId, model) {
      if (num > 0) {
        var params = {
          model: model,
          event: "PATCH",
          associated_id: polizaId,
          identifier: " añadio " + num + " archivos a la póliza.",
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});
      }
    }
    $scope.showFiles = function (item) {
      $http
        .get(url.IP + "polizas/" + item.id + "/archivos/")
        .then(function (response) {
          item.files = response.data.results;
          if (item.showFile) {
            item.showFile = false;
          } else {
            item.showFile = true;
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.saveFiles = function (param) {
      $scope.model_log = 18;
      if (param.document_type == 6) {
        $scope.model_log = 25;
      }
      $scope.countFile = $scope.uploader.queue.length;
      $scope.tipoPoliza = param;
      uploadFiles(param.id);
    };
    $scope.saveFile = function (file) {
      var urls = file.url;
      if (urls == undefined) {
        urls = url.IP + "polizas/" + file.owner + "/archivos/" + file.id;
      }
      $http.patch(urls, { nombre: file.nombre, sensible: file.sensible });
    };
    $scope.deleteFile = function (file, container, param) {
      $scope.model_log = 18;
      if (param.document_type == 6) {
        $scope.model_log = 25;
      }
      SweetAlert.swal(
        {
          title: "Eliminar Archivo",
          text: "No será posible recuperar este archivo, ¿Estás seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "GET",
              url: url.IP + "delete-manual",
              params: {
                file_id: file.id,
              },
            })
              .then(function success(response) {
                if (response.data.status == 204) {
                  SweetAlert.swal(
                    "¡Listo!",
                    "El archivo fue eliminado exitosamente.",
                    "success"
                  );
                  var params = {
                    model: $scope.model_log,
                    event: "PATCH",
                    associated_id: param.id,
                    identifier:
                      " elimino 1 archivo de la póliza grupo " + file.nombre,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  container.splice(container.indexOf(file), 1);
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
        }
      );
    };

    $scope.renameFile = function (file, vmFiles) {
      var patch = {
        nombre: file.nombre,
        sensible: file.sensible,
      };
      $http
        .patch(file.url, patch)
        .then(function (response) {
          if (response.status == 403) {
            $http
              .get(file.url)
              .then(function (response) {
                console.log(response);
                file.nombre = response.data;
              })
              .catch(function (e) {
                console.log("error", e);
              });
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.goToPolicy = function (policy) {
      $state.go("colectividades.info", { polizaId: policy.id });
    };

    $scope.getComments = function () {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 1,
          id_model: $scope.caratula.id,
        },
      })
        .then(function (response) {
          $scope.comments_data = response.data.results;
          $scope.comments_config = {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          };
          $http({
            method: "GET",
            url: url.IP + "comments/",
            params: {
              model: 18,
              id_model: $scope.caratula.id,
            },
          })
            .then(function (response) {
              if (response.data.results) {
                response.data.results.forEach(function (x) {
                  $scope.comments_data.push(x);
                });
              }
              $scope.comments_config = {
                count: response.data.count,
                next: response.data.next,
                previous: response.data.previous,
              };
            })
            .catch(function (e) {
              console.log("e", e);
            });
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.deleteSubgroup = function (item, index) {
      $http({
        method: "GET",
        url: url.IP + "get-relations-by-id/",
        params: {
          id: item.id,
          id_caratula: $scope.caratula.id,
        },
      })
        .then(function (response_relations) {
          if (response_relations.data) {
            var foo = response_relations.data["categorias"].map(function (bar) {
              return "ID: " + bar[2] + ",Nombre:" + bar[0] + "\n";
            });
            var crt = response_relations.data["certificados"].map(function (
              bar
            ) {
              return (
                "ID: " +
                bar[3] +
                ",Certificado:" +
                bar[2] +
                ",Categoría:" +
                bar[0] +
                "\n"
              );
            });
            var arc = response_relations.data["archivos"].map(function (bar) {
              return (
                "ID: " +
                bar[3] +
                ",Nombre:" +
                bar[2] +
                ",PólizaID:" +
                bar[0] +
                "\n"
              );
            });
            var arcc = response_relations.data["archivosCertificados"].map(
              function (bar) {
                return (
                  "ID: " +
                  bar[3] +
                  ",Nombre:" +
                  bar[2] +
                  ",PólizaID:" +
                  bar[0] +
                  "\n"
                );
              }
            );
            var end = response_relations.data["endosos"].map(function (bar) {
              return (
                "ID: " +
                bar[2] +
                ",Número:" +
                bar[1] +
                ",Interno:" +
                bar[0] +
                "\n"
              );
            });
            var endc = response_relations.data["endososCertificados"].map(
              function (bar) {
                return (
                  "ID: " +
                  bar[4] +
                  ",Número:" +
                  bar[1] +
                  ",Interno:" +
                  bar[0] +
                  ",PolizaN:" +
                  bar[2] +
                  ",PolizaID:" +
                  bar[3] +
                  "\n"
                );
              }
            );
            var recs = response_relations.data["recibos"].map(function (bar) {
              return (
                "ID: " + bar[3] + ",Serie:" + bar[0] + ",Tipo:" + bar[1] + "\n"
              );
            });
            var sins = response_relations.data["siniestros"].map(function (
              bar
            ) {
              return (
                "ID: " +
                bar[4] +
                ",Número:" +
                bar[1] +
                ",Interno:" +
                bar[0] +
                ",PolizaN:" +
                bar[2] +
                ",PolizaID:" +
                bar[3] +
                "\n"
              );
            });
            var sinsc = response_relations.data["siniestrosCertificados"].map(
              function (bar) {
                return (
                  "ID: " +
                  bar[4] +
                  ",Número:" +
                  bar[1] +
                  ",Interno:" +
                  bar[0] +
                  ",PolizaN:" +
                  bar[2] +
                  ",PolizaID:" +
                  bar[3] +
                  "\n"
                );
              }
            );
            $scope.textLogS =
              "Categorias: " +
              (response_relations.data["categorias"] ? foo : "Sin categorías") +
              "\n";
            $scope.textLogS =
              $scope.textLogS +
              "Certificados: " +
              (response_relations.data["certificados"]
                ? crt
                : "Sin certificados") +
              "\n";
            // $scope.textLogS = $scope.textLogS +'Archivos: '+ (response_relations.data['archivos'] ? arc : 'Sin archivos')+'\n'
            // $scope.textLogS = $scope.textLogS +'Archivos Certificados: '+ (response_relations.data['archivosCertificados'] ? arcc : 'Sin archivos Certificados')+'\n'
            $scope.textLogS =
              $scope.textLogS +
              "Endosos: " +
              (response_relations.data["endosos"] ? end : "Sin endosos") +
              "\n";
            $scope.textLogS =
              $scope.textLogS +
              "EndososCertificados: " +
              (response_relations.data["endososCertificados"]
                ? endc
                : "Sin endosos Certificados") +
              "\n";
            // $scope.textLogS = $scope.textLogS +'Recibos: '+ (response_relations.data['recibos'] ? recs: 'Sin recibos')+'\n'
            $scope.textLogS =
              $scope.textLogS +
              "Siniestros: " +
              (response_relations.data["siniestros"]
                ? sins
                : "Sin siniestros") +
              "\n";
            $scope.textLogS =
              $scope.textLogS +
              "Siniestros Certificados: " +
              (response_relations.data["siniestrosCertificados"]
                ? sinsc
                : "Sin siniestros certificados");
            // $scope.textLogS = $scope.textLogS +'Archivos Certificados: '+ (response_relations.data['archivosCertificados'] ? arcc : 'Sin archivos certificados')

            var modalInstance = $uibModal.open({
              templateUrl: "app/colectivos/deleteElement.modal.html",
              controller: DeleteElementController,
              size: "lg",
              backdrop: "static",
              keyboard: false,
              resolve: {
                log: function () {
                  return $scope.textLog;
                },
                valores: function () {
                  return response_relations.data;
                },
                item: function () {
                  return item;
                },
                tipo: function () {
                  return 1;
                },
                caratula: function () {
                  return $scope.caratula;
                },
                copy_policy_history: function () {
                  return $scope.copy_policy_history;
                },
              },
            });
            modalInstance.closed.then(function (x) {
              $scope.allCertificates();
            });
            // SweetAlert.swal({
            //   title: 'Eliminar Subgrupo',
            //   text: "Se eliminará el Subgrupo con todas sus Categorías y Certificados, ¿Estás Seguro?\n"+$scope.textLogS,
            //   type: "warning",
            //   showCancelButton: true,
            //   confirmButtonColor: "#DD6B55",
            //   confirmButtonText: "Si, estoy seguro.",
            //   cancelButtonText: "Cancelar",
            //   closeOnConfirm: false
            // },
            // function(isConfirm){
            //   if(isConfirm){
            //     if($scope.subgrupos.length > 1){
            //       $http.delete(item.url)
            //       .then(function success(response){
            //         if(response.status == 204){
            //           var paramsLogP = {
            //             'model': 1,
            //             'event': "PATCH",
            //             'associated_id': $scope.caratula.id,
            //             'change': (response_relations.data),
            //             'identifier': " eliminó el subgrupo " + item.name + " y sus relaciones.",
            //           }
            //           dataFactory.post('send_log_specific/', paramsLogP).then(function success(response){
            //             SweetAlert.swal("¡Listo!", "Se ha eliminado el subgrupo, con todas sus categorías y certificados.", "success");
            //           });
            //           $scope.subgrupos.splice(index, 1);
            //           var paramsRec = {
            //             'model': 1,
            //             'event': "PATCH",
            //             'associated_id': $scope.caratula.id,
            //             'identifier': " eliminó el subgrupo " + item.name + " con todas las categorías y certificados.",
            //             'change': []
            //           }
            //           dataFactory.post('send_log_specific/', paramsRec).then(function success(response){
            //             SweetAlert.swal("¡Listo!", "Se ha eliminado el subgrupo, con todas sus categorías y certificados.", "success");
            //           });
            //         }
            //       })
            //       .catch(function(e){
            //         console.log('e', e);
            //       });
            //     }else{
            //       SweetAlert.swal("Error", "No se eliminó el subgrupo porque la carátula no puede quedarse sin subgrupos.", "error");
            //     }
            //   }
            // });
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
      // SweetAlert.swal({
      //   title: 'Eliminar Subgrupo',
      //   text: "Se eliminará el Subgrupo con todas sus Categorías y Certificados, ¿Estás Seguro?",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#DD6B55",
      //   confirmButtonText: "Si, estoy seguro.",
      //   cancelButtonText: "Cancelar",
      //   closeOnConfirm: false
      // },
      // function(isConfirm){
      //   if(isConfirm){
      //     if($scope.subgrupos.length > 1){
      //       $http.delete(item.url)
      //       .then(function success(response){
      //         if(response.status == 204){
      //           $scope.subgrupos.splice(index, 1);
      //           var paramsRec = {
      //             'model': 18,
      //             'event': "PATCH",
      //             'associated_id': $scope.caratula.id,
      //             'identifier': " eliminó el subgrupo " + item.name + " con todas las categorías y certificados.",
      //             'change': []
      //           }
      //           dataFactory.post('send_log_specific/', paramsRec).then(function success(response){
      //             SweetAlert.swal("¡Listo!", "Se ha eliminado el subgrupo, con todas sus categorías y certificados.", "success");
      //           });
      //         }
      //       })
      //       .catch(function(e){
      //         console.log('e', e);
      //       });
      //     }else{
      //       SweetAlert.swal("Error", "No se eliminó el subgrupo porque la carátula no puede quedarse sin subgrupos.", "error");
      //     }
      //   }
      // });
    };

    $scope.deleteCategory = function (item, param, index) {
      $http({
        method: "GET",
        url: url.IP + "get-relations-by-id/",
        params: {
          id: item.id,
          id_caratula: $scope.caratula.id,
        },
      })
        .then(function (response_relations) {
          if (response_relations.data) {
            var foo = response_relations.data["categorias"].map(function (bar) {
              return "ID: " + bar[2] + ",Nombre:" + bar[0] + "\n";
            });
            var crt = response_relations.data["certificados"].map(function (
              bar
            ) {
              return (
                "ID: " +
                bar[3] +
                ",Certificado:" +
                bar[2] +
                ",Categoría:" +
                bar[0] +
                "\n"
              );
            });
            // var arc = response_relations.data['archivos'].map(function(bar){
            //   return 'ID: '+bar[3]+',Nombre:'+bar[2]+',PólizaID:'+bar[0]+'\n'
            // })
            // var arcc = response_relations.data['archivosCertificados'].map(function(bar){
            //   return 'ID: '+bar[3]+',Nombre:'+bar[2]+',PólizaID:'+bar[0]+'\n'
            // })
            var end = response_relations.data["endosos"].map(function (bar) {
              return (
                "ID: " +
                bar[2] +
                ",Número:" +
                bar[1] +
                ",Interno:" +
                bar[0] +
                "\n"
              );
            });
            var endc = response_relations.data["endososCertificados"].map(
              function (bar) {
                return (
                  "ID: " +
                  bar[4] +
                  ",Número:" +
                  bar[1] +
                  ",Interno:" +
                  bar[0] +
                  ",PolizaN:" +
                  bar[2] +
                  ",PolizaID:" +
                  bar[3] +
                  "\n"
                );
              }
            );
            // var recs = response_relations.data['recibos'].map(function(bar){
            //   return 'ID: '+bar[3]+',Serie:'+bar[0]+',Tipo:'+bar[1]+'\n'
            // })
            var sins = response_relations.data["siniestros"].map(function (
              bar
            ) {
              return (
                "ID: " +
                bar[4] +
                ",Número:" +
                bar[1] +
                ",Interno:" +
                bar[0] +
                ",PolizaN:" +
                bar[2] +
                ",PolizaID:" +
                bar[3] +
                "\n"
              );
            });
            var sinsc = response_relations.data["siniestrosCertificados"].map(
              function (bar) {
                return (
                  "ID: " +
                  bar[4] +
                  ",Número:" +
                  bar[1] +
                  ",Interno:" +
                  bar[0] +
                  ",PolizaN:" +
                  bar[2] +
                  ",PolizaID:" +
                  bar[3] +
                  "\n"
                );
              }
            );
            $scope.textLog =
              "Categorias: " +
              (response_relations.data["categorias"] ? foo : "Sin categorías") +
              "\n";
            $scope.textLog =
              $scope.textLog +
              "Certificados: " +
              (response_relations.data["certificados"]
                ? crt
                : "Sin certificados") +
              "\n";
            // $scope.textLog = $scope.textLog +'Archivos: '+ (response_relations.data['archivos'] ? arc : 'Sin archivos')+'\n'
            // $scope.textLog = $scope.textLog +'Archivos Certificados: '+ (response_relations.data['archivosCertificados'] ? arcc : 'Sin archivos Certificados')+'\n'
            $scope.textLog =
              $scope.textLog +
              "Endosos: " +
              (response_relations.data["endosos"] ? end : "Sin endosos") +
              "\n";
            $scope.textLog =
              $scope.textLog +
              "EndososCertificados: " +
              (response_relations.data["endososCertificados"]
                ? endc
                : "Sin endosos Certificados") +
              "\n";
            // $scope.textLog = $scope.textLog +'Recibos: '+ (response_relations.data['recibos'] ? recs: 'Sin recibos')+'\n'
            $scope.textLog =
              $scope.textLog +
              "Siniestros: " +
              (response_relations.data["siniestros"]
                ? sins
                : "Sin siniestros") +
              "\n";
            $scope.textLog =
              $scope.textLog +
              "Siniestros Certificados: " +
              (response_relations.data["siniestrosCertificados"]
                ? sinsc
                : "Sin siniestros certificados");
            // $scope.textLog = $scope.textLog +'Archivos Certificados: '+ (response_relations.data['archivosCertificados'] ? arcc : 'Sin archivos certificados')

            var modalInstance = $uibModal.open({
              templateUrl: "app/colectivos/deleteElement.modal.html",
              controller: DeleteElementController,
              size: "lg",
              backdrop: "static",
              keyboard: false,
              resolve: {
                log: function () {
                  return $scope.textLog;
                },
                valores: function () {
                  return response_relations.data;
                },
                item: function () {
                  return item;
                },
                tipo: function () {
                  return 2;
                },
                caratula: function () {
                  return $scope.caratula;
                },
                copy_policy_history: function () {
                  return $scope.copy_policy_history;
                },
              },
            });
            modalInstance.closed.then(function (x) {
              $scope.allCertificates();
            });
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
      // SweetAlert.swal({
      //   title: 'Eliminar Categoría',
      //   text: "Se eliminará la Categoría y todos sus Certificados, ¿Estás Seguro?",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#DD6B55",
      //   confirmButtonText: "Si, estoy seguro.",
      //   cancelButtonText: "Cancelar",
      //   closeOnConfirm: false
      // },
      // function(isConfirm){
      //   if(isConfirm){
      //     if(param.categorias.length > 1){
      //       $http.delete(item.url)
      //       .then(function success(response){
      //         if(response.status == 204){
      //           param.categorias.splice(index, 1);
      //           var paramsRec = {
      //             'model': 18,
      //             'event': "PATCH",
      //             'associated_id': $scope.caratula.id,
      //             'identifier': " eliminó el subgrupo " + item.name + " con todas las categorías y certificados.",
      //             'change': []
      //           }
      //           dataFactory.post('send_log_specific/', paramsRec).then(function success(response){
      //             SweetAlert.swal("¡Listo!", "Se ha eliminado la categoría y todos sus certificados.", "success");
      //           });
      //         }
      //       })
      //       .catch(function(e){
      //         console.log('e', e);
      //       });
      //     }else{
      //       SweetAlert.swal("Error", "No se eliminó la categoría porque el subgrupo no puede quedarse sin categorías.", "error");
      //     }
      //   }
      // });
    };

    $scope.changedomiciliadoSubgroup = function (subgroup) {
      SweetAlert.swal(
        {
          title: "Domiciliado",
          text: "Todos los recibos se actualizarán",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            subgroup.recibos_poliza.forEach(function (receipt) {
              $http
                .patch(receipt.url, { is_cat: true })
                .then(function (response) {
                  SweetAlert.swal(
                    "¡Hecho!",
                    "Recibo(s) actualizado(s)",
                    "success"
                  );
                  activate();
                });
            });
            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.caratula.id,
              identifier:
                " cambio el estatus del cargo Automático(Domiciliado) a SI de los recibos del subgrupo " +
                subgroup.name +
                ".",
            };
            dataFactory
              .post("send-log/", paramsRec)
              .then(function success(response) {});
          } else {
            subgroup.recibos_poliza.forEach(function (receipt) {
              $http
                .patch(receipt.url, { is_cat: false })
                .then(function (response) {
                  SweetAlert.swal(
                    "¡Hecho!",
                    "Recibo(s) actualizado(s)",
                    "success"
                  );
                  activate();
                });
            });
            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.caratula.id,
              identifier:
                " cambio el estatus del cargo Automático(Domiciliado) a NO de los recibos del subgrupo " +
                subgroup.name +
                ".",
            };
            dataFactory
              .post("send-log/", paramsRec)
              .then(function success(response) {});
          }
        }
      );
    };

    $scope.deletePackage = function (item, index) {
      SweetAlert.swal(
        {
          title: "Eliminar Paquete",
          text: "Se eliminará el paquete, ¿Estás Seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            if ($scope.paquetes.length > 1) {
              $http
                .delete(item.url)
                .then(function success(response) {
                  if (response.status == 204) {
                    $scope.paquetes.splice(index, 1);
                    var paramsRec = {
                      model: 18,
                      event: "PATCH",
                      associated_id: $scope.caratula.id,
                      identifier: " eliminó el paquete " + item.name + ".",
                      change: [],
                    };
                    dataFactory
                      .post("send_log_specific/", paramsRec)
                      .then(function success(response) {
                        SweetAlert.swal(
                          "¡Listo!",
                          "Se ha eliminado el paquete.",
                          "success"
                        );
                      });
                  }
                })
                .catch(function (e) {
                  console.log("e", e);
                });
            } else {
              SweetAlert.swal(
                "Error",
                "No se eliminó el paquete porque la carátula no puede quedarse sin paquetes.",
                "error"
              );
            }
          }
        }
      );
    };

    $scope.showItemCertificate = function (value) {
      switch (value) {
        case 1:
          $scope.show_tableCertificate = true;
          $scope.show_infoCertificate = false;
          $scope.show_editCertificate = false;
          $scope.show_massCertificate = false;
          $scope.show_receiptCertificate = false;
          $scope.show_showReceiptCertificate = false;
          $scope.show_showUpdateEmails = false;

          $scope.infoFlagCertificate = true;
          $scope.endorsementFlagCertificate = false;
          $scope.siniesterFlagCertificate = false;
          break;
        case 2:
          $scope.show_tableCertificate = false;
          $scope.show_infoCertificate = true;
          $scope.show_editCertificate = false;
          $scope.show_massCertificate = false;
          $scope.show_receiptCertificate = false;
          $scope.show_showReceiptCertificate = false;
          $scope.show_showUpdateEmails = false;
          break;
        case 3:
          $scope.show_tableCertificate = false;
          $scope.show_infoCertificate = false;
          $scope.show_editCertificate = true;
          $scope.show_massCertificate = false;
          $scope.show_receiptCertificate = false;
          $scope.show_showReceiptCertificate = false;
          $scope.show_showUpdateEmails = false;
          break;
        case 4:
          if (
            $scope.incompleteOT.subgroups.length == 0 &&
            $scope.incompleteOT.packages.length == 0
          ) {
            $scope.show_tableCertificate = false;
            $scope.show_infoCertificate = false;
            $scope.show_editCertificate = false;
            $scope.show_massCertificate = true;
            $scope.show_receiptCertificate = false;
            $scope.show_showReceiptCertificate = false;
            $scope.show_showUpdateEmails = false;
          } else {
            SweetAlert.swal(
              "Error",
              "Debes agregar subgrupos y/o paquetes primero para poder cargar certificados manualmente.",
              "error"
            );
          }
          break;
        case 7:
          if (
            $scope.incompleteOT.subgroups.length == 0 &&
            $scope.incompleteOT.packages.length == 0
          ) {
            $scope.show_tableCertificate = false;
            $scope.show_infoCertificate = false;
            $scope.show_editCertificate = false;
            $scope.show_massCertificate = false;
            $scope.show_receiptCertificate = false;
            $scope.show_showReceiptCertificate = false;
            $scope.show_showUpdateEmails = true;
          } else {
            SweetAlert.swal(
              "Error",
              "Debes agregar subgrupos y/o paquetes primero para poder cargar certificados manualmente.",
              "error"
            );
          }
          break;
        case 5:
          $scope.show_tableCertificate = false;
          $scope.show_infoCertificate = false;
          $scope.show_editCertificate = false;
          $scope.show_massCertificate = false;
          $scope.show_receiptCertificate = true;
          $scope.show_showReceiptCertificate = false;
          $scope.show_showUpdateEmails = false;

          $scope.calculateReceipts();
          break;
        case 6:
          $scope.show_tableCertificate = false;
          $scope.show_infoCertificate = false;
          $scope.show_editCertificate = false;
          $scope.show_massCertificate = false;
          $scope.show_receiptCertificate = false;
          $scope.show_showReceiptCertificate = true;
          $scope.show_showUpdateEmails = false;

          $scope.showReceiptsCertificate();
          break;
        default:
          $scope.show_tableCertificate = true;
          $scope.show_infoCertificate = false;
          $scope.show_editCertificate = false;
          $scope.show_massCertificate = false;
          $scope.show_showUpdateEmails = false;
      }
    };

    $scope.getCertificates = function (param, value) {
      $scope.show_section(4);
      $scope.showItemCertificate(1);
      $scope.allExcel = false;
      $scope.statusActive = value == 1 ? 1 : 0;
      $scope.categorySelected.id = param.id;
      $scope.categorySelected.is_category = 1;
      $scope.categorySelected.certificates = [];
      $http({
        method: "GET",
        url: url.IP + "get-certificates/",
        params: {
          parent: param.id,
          active: value,
        },
      })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.categorySelected.certificates = response.data.results;
            $scope.categorySelected.certificates.forEach(function (item) {
              if (item.life_policy.length) {
                item.certificate_number = item.life_policy[0].personal
                  .certificate
                  ? angular.copy(item.life_policy[0].personal.certificate)
                  : item.certificate_number;
                item.poliza_number = item.life_policy[0].personal.certificate
                  ? $scope.caratula.poliza_number +
                    " - INC. " +
                    item.life_policy[0].personal.certificate
                  : item.poliza_number;
              }
              if (item.accidents_policy.length) {
                item.certificate_number = item.accidents_policy[0].personal
                  .certificate
                  ? angular.copy(item.accidents_policy[0].personal.certificate)
                  : item.certificate_number;
                item.poliza_number = item.accidents_policy[0].personal
                  .certificate
                  ? $scope.caratula.poliza_number +
                    " - INC. " +
                    item.accidents_policy[0].personal.certificate
                  : item.poliza_number;
              }
            });
            $scope.categorySelected.config = {
              count: response.data.count,
              previous: response.data.previous,
              next: response.data.next,
            };
            $scope.testPagination(
              "categorySelected.certificates",
              "categorySelected.config"
            );
            $scope.getEndorsementSiniester();
            $scope.categorySelected.certificates.forEach(function (item) {
              if (item.life_policy.length) {
                item.datos = angular.copy(item.life_policy[0]);
              } else if (item.accidents_policy.length) {
                item.datos = angular.copy(item.accidents_policy[0]);
              } else if (item.automobiles_policy.length) {
                item.datos = angular.copy(item.automobiles_policy[0]);
              } else if (item.damages_policy.length) {
                item.datos = angular.copy(item.damages_policy[0]);
              }
            });
          } else {
            SweetAlert.swal(
              "Error",
              "Ocurrió un error, por favor intenta de nuevo.",
              "Error"
            );
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.allCertificates = function () {
      $scope.showItemCertificate(1);
      $scope.cadena = "";
      $scope.allExcel = true;
      $scope.categorySelected.id = $scope.caratula.id;
      $scope.categorySelected.is_category = 0;
      $scope.categorySelected.certificates = [];
      $http({
        method: "GET",
        url: url.IP + "get-allcertificates/",
        params: {
          caratula: $scope.caratula.id,
          active: 3,
        },
      })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.categorySelected.certificates = response.data.results;
            $scope.categorySelected.certificates.forEach(function (item) {
              if (item.life_policy.length) {
                item.certificate_number = item.life_policy[0].personal
                  .certificate
                  ? angular.copy(item.life_policy[0].personal.certificate)
                  : item.certificate_number;
                item.poliza_number = item.life_policy[0].personal.certificate
                  ? $scope.caratula.poliza_number +
                    " - INC. " +
                    item.life_policy[0].personal.certificate
                  : item.poliza_number;
              }
              if (item.accidents_policy.length) {
                item.certificate_number = item.accidents_policy[0].personal
                  .certificate
                  ? angular.copy(item.accidents_policy[0].personal.certificate)
                  : item.certificate_number;
                item.poliza_number = item.accidents_policy[0].personal
                  .certificate
                  ? $scope.caratula.poliza_number +
                    " - INC. " +
                    item.accidents_policy[0].personal.certificate
                  : item.poliza_number;
              }
            });
            $scope.categorySelected.config = {
              count: response.data.count,
              previous: response.data.previous,
              next: response.data.next,
            };
            $scope.testPagination(
              "categorySelected.certificates",
              "categorySelected.config"
            );
            if ($scope.categorySelected.certificates.length > 0) {
              $scope.getEndorsementSiniester();
            }
            $scope.categorySelected.certificates.forEach(function (item) {
              if (item.life_policy.length) {
                item.datos = angular.copy(item.life_policy[0]);
              } else if (item.accidents_policy.length) {
                item.datos = angular.copy(item.accidents_policy[0]);
              } else if (item.automobiles_policy.length) {
                item.datos = angular.copy(item.automobiles_policy[0]);
              } else if (item.damages_policy.length) {
                item.datos = angular.copy(item.damages_policy[0]);
              }
            });
            $scope.incompleteCollective();
          } else {
            SweetAlert.swal(
              "Error",
              "Ocurrió un error, por favor intenta de nuevo.",
              "Error"
            );
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.search = function (param) {
      if (param) {
        $scope.cadena = param;
        $scope.allExcel = false;
        $http({
          method: "GET",
          url: url.IP + "search-certificates/",
          params: {
            cadena: param,
            parent: $scope.categorySelected.id,
            is_category: $scope.categorySelected.is_category,
          },
        })
          .then(function success(response) {
            if (response.status == 200) {
              $scope.categorySelected.certificates = response.data.results;
              $scope.categorySelected.certificates.forEach(function (item) {
                if (item.life_policy.length) {
                  item.certificate_number = item.life_policy[0].personal
                    .certificate
                    ? angular.copy(item.life_policy[0].personal.certificate)
                    : item.certificate_number;
                  item.poliza_number = item.life_policy[0].personal.certificate
                    ? $scope.caratula.poliza_number +
                      " - INC. " +
                      item.life_policy[0].personal.certificate
                    : item.poliza_number;
                }
                if (item.accidents_policy.length) {
                  item.certificate_number = item.accidents_policy[0].personal
                    .certificate
                    ? angular.copy(
                        item.accidents_policy[0].personal.certificate
                      )
                    : item.certificate_number;
                  item.poliza_number = item.accidents_policy[0].personal
                    .certificate
                    ? $scope.caratula.poliza_number +
                      " - INC. " +
                      item.accidents_policy[0].personal.certificate
                    : item.poliza_number;
                }
              });
              $scope.categorySelected.config = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };
              $scope.testPagination(
                "categorySelected.certificates",
                "categorySelected.config"
              );
              if ($scope.categorySelected.certificates.length > 0) {
                $scope.getEndorsementSiniester();
              }
              $scope.categorySelected.certificates.forEach(function (item) {
                if (item.life_policy.length) {
                  item.datos = angular.copy(item.life_policy[0]);
                } else if (item.accidents_policy.length) {
                  item.datos = angular.copy(item.accidents_policy[0]);
                } else if (item.automobiles_policy.length) {
                  item.datos = angular.copy(item.automobiles_policy[0]);
                } else if (item.damages_policy.length) {
                  item.datos = angular.copy(item.damages_policy[0]);
                }
              });
            } else {
              SweetAlert.swal(
                "Error",
                "Ocurrió un error, por favor intenta de nuevo.",
                "error"
              );
            }
          })
          .catch(function (e) {
            console.log("error", e);
          });
      } else {
        $scope.allCertificates();
      }
    };

    $scope.getEndorsementSiniester = function () {
      $scope.categorySelected.certificates.forEach(function (item, index) {
        $http({
          method: "GET",
          url: url.IP + "get-endosos-sinister/",
          params: {
            policy: item.id,
          },
        })
          .then(function success(response) {
            item.endosos = response.data.endosos;
            item.siniestros = response.data.siniestros;
          })
          .catch(function (e) {
            console.log("error", e);
          });

        if (item.life_policy.length) {
          item.datos = angular.copy(item.life_policy[0]);
        } else if (item.accidents_policy.length) {
          item.datos = angular.copy(item.accidents_policy[0]);
        } else if (item.automobiles_policy.length) {
          item.datos = angular.copy(item.automobiles_policy[0]);
        } else if (item.damages_policy.length) {
          item.datos = angular.copy(item.damages_policy[0]);
        }
      });
    };

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.selectPage = function (parPage) {
        var url = "";
        if (config_.next || config_.previous) {
          if (config_.next) {
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            url = config_.next.substring(0, config_.next.indexOf("&page=") + 6);
            url += parPage.toString();

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            url = "";
            var otherParameters = config_.previous.substring(
              config_.previous.indexOf("&page=") + 6
            );

            if (config_.previous.search("&page=") !== -1) {
              url = config_.previous.substring(
                0,
                config_.previous.indexOf("&page=") + 6
              );
              url += parPage.toString();
            } else {
              url = config_.previous;
            }

            if (config_.previous.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }

        getProviders(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;
        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      $scope.lastPage = function () {
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      function getProviders(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(response) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, response.data.results);

              var data = {
                count: response.data.count,
                previous: response.data.previous,
                next: response.data.next,
              };

              if ($scope.categorySelected.certificates.length) {
                $scope.categorySelected.certificates.forEach(function (
                  item,
                  index
                ) {
                  if (item.life_policy.length) {
                    item.certificate_number = item.life_policy[0].personal
                      .certificate
                      ? angular.copy(item.life_policy[0].personal.certificate)
                      : item.certificate_number;
                    item.poliza_number = item.life_policy[0].personal
                      .certificate
                      ? $scope.caratula.poliza_number +
                        " - INC. " +
                        item.life_policy[0].personal.certificate
                      : item.poliza_number;
                  }
                  if (item.accidents_policy.length) {
                    item.certificate_number = item.accidents_policy[0].personal
                      .certificate
                      ? angular.copy(
                          item.accidents_policy[0].personal.certificate
                        )
                      : item.certificate_number;
                    item.poliza_number = item.accidents_policy[0].personal
                      .certificate
                      ? $scope.caratula.poliza_number +
                        " - INC. " +
                        item.accidents_policy[0].personal.certificate
                      : item.poliza_number;
                  }

                  var pagesCertificates = {
                    policy: item.id,
                  };
                  dataFactory
                    .get("get-endosos-sinister/", pagesCertificates)
                    .then(function success(response) {
                      item.endosos = response.data.endosos;
                      item.siniestros = response.data.siniestros;
                    });

                  if (item.life_policy.length) {
                    item.datos = angular.copy(item.life_policy[0]);
                  } else if (item.accidents_policy.length) {
                    item.datos = angular.copy(item.accidents_policy[0]);
                  } else if (item.automobiles_policy.length) {
                    item.datos = angular.copy(item.automobiles_policy[0]);
                  } else if (item.damages_policy.length) {
                    item.datos = angular.copy(item.damages_policy[0]);
                  }
                });
              }

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };

    $scope.downloadExcel = function (parCategory, active) {
      $scope.filtros = {
        is_category: $scope.categorySelected
          ? $scope.categorySelected.is_category
          : 0,
        parent: parCategory ? parCategory.id : $scope.caratula.id,
        active: $scope.statusActive,
        cadena: $scope.cadena ? $scope.cadena : "",
      };
      $http({
        method: "POST",
        url: url.IP + "service_reporte-certificate-excel",
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Certificados.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
    };

    $scope.downloadExcelAll = function (caratula, active) {
      $scope.filtros = {
        // parent: caratula.id,
        // active: 3
        is_category: $scope.categorySelected
          ? $scope.categorySelected.is_category
          : 0,
        parent: $scope.categorySelected
          ? $scope.categorySelected.id
          : $scope.caratula.id,
        active: $scope.statusActive,
        cadena: $scope.cadena ? $scope.cadena : "",
      };
      $http({
        method: "POST",
        url: url.IP + "service_reporte-certificate-excel",
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Certificados.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
    };

    $scope.calculateReceipts = function () {
      SweetAlert.swal(
        "Información",
        "Solo se crearán recibos en certificados activos y  que no tengan recibos.",
        "info"
      );

      $scope.dataToSave = {};
      $scope.dataToSave.poliza = {
        primaNeta: parseFloat($scope.sumas.p_neta),
        rpf: parseFloat($scope.sumas.rpf),
        derecho: parseFloat($scope.sumas.derecho),
        subTotal:
          parseFloat($scope.sumas.p_neta) +
          parseFloat($scope.sumas.rpf) +
          parseFloat($scope.sumas.derecho),
        iva: parseFloat($scope.sumas.iva),
        primaTotal: parseFloat($scope.sumas.p_total),
        comision: parseFloat($scope.sumas.comision),
      };
      $scope.directiveReceipts.subramo = $scope.caratula.subramo.subramo_name;
      $scope.directiveReceipts.startDate = convertDate(
        $scope.caratula.start_of_validity
      );
      $scope.directiveReceipts.endingDate = convertDate(
        $scope.caratula.end_of_validity
      );
      $scope.directiveReceipts.payment = $scope.caratula.forma_de_pago;
      var date1 = new Date($scope.caratula.start_of_validity);
      var date2 = new Date($scope.caratula.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );
      $scope.directiveReceipts.domiciliado = false;
      getClaves();
    };
    function getClaves() {
      $http
        .get(url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id)
        .then(function success(clavesResponse) {
          $scope.claves = clavesResponse.data;
          if ($scope.claves.length == 1) {
            $scope.claveSelected = $scope.claves[0];
          } else {
            $scope.claves.forEach(function (item) {
              if (item.id == $scope.policy.clave.id) {
                $scope.claveSelected = item;
              }
            });
          }
          $http
            .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
            .then(
              function success(response) {
                $scope.ramos = response.data;
                $scope.ramos.forEach(function (item) {
                  if (item.ramo_name == $scope.caratula.ramo.ramo_name) {
                    $scope.subramos = item.subramo_ramo;
                    $scope.subramos.forEach(function (subramo) {
                      if (
                        subramo.subramo_name ==
                        $scope.caratula.subramo.subramo_name
                      ) {
                        var comisiones = [];
                        if ($scope.claveSelected.clave_comision) {
                          if ($scope.claveSelected.clave_comision.length) {
                            $scope.claveSelected.clave_comision.forEach(
                              function (item) {
                                if (
                                  $scope.caratula.subramo.subramo_name ==
                                  item.subramo
                                ) {
                                  comisiones.push(item);
                                }
                              }
                            );
                          }
                        }

                        $scope.directiveReceipts.comisiones = comisiones;
                      }
                    });
                  }
                });
              },
              function error(e) {
                console.log("Error - ramos-by-provider", e);
              }
            )
            .catch(function (error) {
              console.log("Error - ramos-by-provider - catch", error);
            });
        })
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }
    $scope.saveReceiptsCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (!$scope.caratula.recibos_poliza) {
        if (!$scope.dataToSave.recibos_poliza) {
          l.stop();
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
      }

      var data_caratula = {
        p_neta: $scope.dataToSave.poliza.primaNeta
          ? $scope.dataToSave.poliza.primaNeta
          : 0,
        descuento: $scope.dataToSave.poliza.descuento
          ? $scope.dataToSave.poliza.descuento
          : 0,
        rpf: $scope.dataToSave.poliza.rpf ? $scope.dataToSave.poliza.rpf : 0,
        derecho: $scope.dataToSave.poliza.derecho
          ? $scope.dataToSave.poliza.derecho
          : 0,
        sub_total: $scope.dataToSave.poliza.subTotal
          ? $scope.dataToSave.poliza.subTotal
          : 0,
        iva: $scope.dataToSave.poliza.iva ? $scope.dataToSave.poliza.iva : 0,
        p_total: $scope.dataToSave.poliza.primaTotal
          ? $scope.dataToSave.poliza.primaTotal
          : 0,
        comision: $scope.dataToSave.comision ? $scope.dataToSave.comision : 0,
        comision_percent: $scope.dataToSave.comision_percent
          ? $scope.dataToSave.comision_percent
          : 0,
        total_receipts: $scope.dataToSave.recibos_poliza
          ? $scope.dataToSave.recibos_poliza.length
          : $scope.caratula.total_receipts,
      };

      $http
        .patch($scope.caratula.url, data_caratula)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.caratula.id,
              identifier:
                " agregó recibos a la carátula a partir de los certificados.",
              change: [],
            };
            dataFactory
              .post("send_log_specific/", paramsRec)
              .then(function success(response) {});
            // var data_receipt = {
            //   caratula: $scope.caratula.id,
            //   option: 2
            // }

            // $http.post(url.IP+'update_receiptscollective/', data_receipt)
            // .then(function(data) {
            //   if(data.status === 201){

            //   }
            // })
            // .catch(function(error) {
            //   console.log('error', error);
            //   SweetAlert.swal('Error','Ócurrio un error.', 'error');
            // });
          }
        })
        .catch(function (error) {
          console.log("error", error);
          l.stop();
          SweetAlert.swal("Error", "Ócurrio un error.", "error");
        });

      if ($scope.dataToSave.recibos_poliza) {
        $scope.dataToSave.recibos_poliza.forEach(function (item, index) {
          item.poliza = $scope.caratula.url;
          item.fecha_fin = toDate(item.fecha_fin);
          item.fecha_inicio = toDate(item.fecha_inicio);
          item.vencimiento = toDate(item.vencimiento);

          $http
            .post(url.IP + "recibos/", item)
            .then(function (data) {
              if (data.status === 201) {
              }
            })
            .catch(function (error) {
              console.log("error", error);
              l.stop();
              SweetAlert.swal("Error", "Ócurrio un error.", "error");
            });
        });
      }

      $scope.data_receipts = {
        caratula: $scope.caratula.id,
        parent: 0,
        applyRPF:
          $scope.dataToSave.aplicarRpf == true
            ? 1
            : $scope.dataToSave.aplicarRpf == false
            ? 0
            : 0,
        applyDerecho:
          $scope.dataToSave.aplicarDerecho == true
            ? 1
            : $scope.dataToSave.aplicarDerecho == false
            ? 0
            : 0,
        applyDescuento: 0,
      };
      $http({
        method: "POST",
        url: url.IP + "receipts-certificate/",
        data: $scope.data_receipts,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            SweetAlert.swal(
              "¡Listo!",
              "Recibos Creados exitosamente",
              "success"
            );
            $scope.showReceiptsCertificate();
            $scope.show_section(1);
            l.stop();
            activate();
          } else {
            l.stop();
            SweetAlert.swal("ERROR", "Ócurrio un error", "error");
          }
        })
        .catch(function (e) {
          console.log("error", e);
          l.stop();
        });
    };

    $scope.showReceiptsCertificate = function () {
      $scope.periods = [];
      var total_periods;
      switch ($scope.caratula.forma_de_pago) {
        case 1:
          total_periods = 12;
          break;
        case 2:
          total_periods = 6;
          break;
        case 3:
          total_periods = 4;
          break;
        case 5:
          total_periods = 1;
          break;
        case 6:
          total_periods = 2;
          break;
        case 12:
          total_periods = 1;
          break;
        default:
          break;
      }
      for (var i = 1; i <= total_periods; i++) {
        $scope.periods.push({ value: i, label: "Periodo " + i });
      }
      $scope.periodSelected = $scope.periods[0];

      $http({
        method: "POST",
        url: url.IP + "info_certificados_Collective/",
        data: {
          status: 0,
          caratula: $scope.caratula.id,
          parent: 0,
        },
      })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.allReceiptsCertificates = response.data.certificates;
            $scope.changePeriod({ value: 1, label: "Periodo 1" });

            $scope.show_categories = false;
            $scope.show_createCertificate = false;
            $scope.show_receiptsCertificate = true;
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.changePeriod = function (param) {
      $scope.totalReceiptPeriod = 0;
      $scope.totalReceiptPay = 0;
      $scope.totalReceiptPending = 0;
      $scope.totalReceiptSelected = 0;
      $scope.receiptsPeriods = [];

      if ($scope.allReceiptsCertificates) {
        $scope.allReceiptsCertificates.forEach(function (item) {
          if (item.recibos_poliza.length > 0) {
            item.recibos_poliza[param.value - 1].selected = false;
            item.recibos_poliza[param.value - 1].no_certificate = item.id;
            $scope.receiptsPeriods.push(
              item.recibos_poliza[parseInt(param.value) - 1]
            );
            if (item.recibos_poliza[param.value - 1].status == 4) {
              $scope.totalReceiptPending =
                parseFloat($scope.totalReceiptPending) +
                parseFloat(item.recibos_poliza[param.value - 1].prima_total);
            } else if (item.recibos_poliza[param.value - 1].status == 1) {
              $scope.totalReceiptPay =
                parseFloat($scope.totalReceiptPay) +
                parseFloat(item.recibos_poliza[param.value - 1].prima_total);
            }
            $scope.totalReceiptPeriod =
              parseFloat($scope.totalReceiptPeriod) +
              parseFloat(item.recibos_poliza[param.value - 1].prima_total);
            $scope.copy_receiptsPeriods = angular.copy($scope.receiptsPeriods);
          }
        });
      }

      $scope.desSelected = false;
    };

    $scope.changeStatusReceipt = function (param) {
      $scope.receiptsPeriods = $scope.copy_receiptsPeriods;
      if (param.value != 0) {
        $scope.receiptsPeriods = [];
        $scope.copy_receiptsPeriods.forEach(function (item) {
          if (item.status == param.value) {
            $scope.receiptsPeriods.push(item);
          }
        });
      }
    };

    $scope.copy_receiptsSearch = [];
    $scope.searchReceipt = function (param) {
      if ($scope.copy_receiptsSearch.length == 0) {
        $scope.copy_receiptsSearch = angular.copy($scope.receiptsPeriods);
      }
      $scope.receiptsPeriods = [];
      if (param == "") {
        $scope.receiptsPeriods = $scope.copy_receiptsSearch;
      } else {
        $scope.copy_receiptsSearch.forEach(function (item) {
          if (item.poliza.indexOf(param.toUpperCase()) != -1) {
            $scope.receiptsPeriods.push(item);
          }
        });
      }
    };

    $scope.allReciptsSelected = function (param) {
      $scope.desSelected = param;
      $scope.totalReceiptSelected = 0;
      $scope.receiptsPeriods.forEach(function (item) {
        item.selected = param;
        if (param) {
          $scope.sumReceipts(item);
        }
      });
    };

    $scope.sumReceipts = function (param) {
      if (param.selected) {
        $scope.totalReceiptSelected =
          parseFloat($scope.totalReceiptSelected) +
          parseFloat(param.prima_total);
      } else {
        $scope.totalReceiptSelected =
          parseFloat($scope.totalReceiptSelected) -
          parseFloat(param.prima_total);
      }
    };

    $scope.payReceipts = function () {
      $scope.receiptsPeriods.forEach(function (item, index) {
        if (item.selected) {
          $http
            .patch(item.url, { status: 1 })
            .then(function (response) {
              item.status = 1;
              SweetAlert.swal(
                "¡Listo!",
                "Recibos actualizados exitosamente.",
                "success"
              );
              var data_receipt = {
                caratula: $scope.caratula.id,
                option: 1,
              };

              $http
                .post(url.IP + "update_receiptscollective/", data_receipt)
                .then(function (data) {
                  $state.reload();
                  if (data.status === 201) {
                  }
                })
                .catch(function (error) {
                  console.log("error", error);
                  SweetAlert.swal("Error", "Ócurrio un error.", "error");
                });
            })
            .catch(function (e) {
              console.log("error", e);
            });
        }
      });
    };

    $scope.deleteReceiptsCertificate = function (param) {
      SweetAlert.swal(
        {
          title: "Eliminar Recibos del Certificado",
          text: "Se eliminarán todos los recibos de este certificado y no se podrá recuperar después, ¿Estás Seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var total_receipt_certificate = angular.copy(
              param.recibos_poliza.length
            );
            param.recibos_poliza.forEach(function (receipt, index) {
              $http
                .delete(receipt.url)
                .then(function (response) {})
                .catch(function (e) {
                  console.log("error", e);
                });

              if (index + 1 == total_receipt_certificate) {
                var paramsRec = {
                  model: 18,
                  event: "POST",
                  associated_id: param.id,
                  identifier: " eliminó los recibos.",
                };
                dataFactory
                  .post("send_log_specific/", paramsRec)
                  .then(function success(response) {});
                param.recibos_poliza = [];
                SweetAlert.swal(
                  "¡Listo!",
                  "Recibos eliminados exitosamente.",
                  "success"
                );
              }
            });
          }
        }
      );
    };
    $scope.checkDate = function (val, t, event, ind) {
      var clipboardData =
        event.originalEvent.clipboardData || window.clipboardData;
      var pastedText = clipboardData.getData("text");
      if (t == 1) {
        $scope.newCertificate.rec_antiguedad = datesFactory.convertDate(
          datesFactory.toDate(pastedText)
        );
      } else if (t == 2) {
        $scope.newCertificate.datos.personal.birthdate =
          datesFactory.convertDate(datesFactory.toDate(pastedText));
      } else if (t == 3) {
        $scope.newCertificate.datos.relationship_accident[ind].birthdate =
          datesFactory.convertDate(datesFactory.toDate(pastedText));
      } else if (t == 4) {
        $scope.newCertificate.datos.relationship_accident[ind].antiguedad =
          datesFactory.convertDate(datesFactory.toDate(pastedText));
      }
    };
    $scope.createIndividualCertificate = function () {
      $scope.countCategories();
      // -------------************
      $scope.isEdit = false;
      if ($localStorage.save_edition_poliza_certificado) {
        if (
          $localStorage.save_edition_poliza_certificado &&
          $localStorage.save_edition_poliza_certificado.datos
        ) {
          $scope.newCertificate = $localStorage.save_edition_poliza_certificado;
          if ($scope.newCertificate.datos.smoker) {
            $scope.smokers.forEach(function (item) {
              if (item.value == $scope.newCertificate.datos.smoker.value) {
                $scope.newCertificate.datos.smoker = item;
              }
            });
          }
          $scope.sexs.forEach(function (item) {
            if (
              $scope.newCertificate.datos.personal &&
              $scope.newCertificate.datos.personal.sex &&
              item.value == $scope.newCertificate.datos.personal.sex.value
            ) {
              $scope.newCertificate.datos.personal.sex = item;
            }
          });

          if ($scope.newCertificate.datos.personal.type_sa) {
            $scope.typesInsureds.forEach(function (item) {
              if (
                item.value == $scope.newCertificate.datos.personal.type_sa.value
              ) {
                $scope.newCertificate.datos.personal.type_sa = item;
              }
            });
          }
          if ($scope.newCertificate.datos.relationship_accident) {
            $scope.newCertificate.datos.relationship_accident.forEach(function (
              beneficiarie
            ) {
              if (beneficiarie.birthdate) {
                if (beneficiarie.birthdate.indexOf("-") != -1) {
                  beneficiarie.birthdate = convertDate(beneficiarie.birthdate);
                  beneficiarie.charge_date = beneficiarie.charge_date
                    ? convertDate(beneficiarie.charge_date)
                    : null;
                  beneficiarie.discharge_date = beneficiarie.discharge_date
                    ? convertDate(beneficiarie.discharge_date)
                    : null;
                  beneficiarie.antiguedad = beneficiarie.antiguedad
                    ? convertDate(beneficiarie.antiguedad)
                    : null;
                }
              }
              $scope.sexs.forEach(function (item) {
                if (item.value == beneficiarie.sex) {
                  beneficiarie.sex = item;
                }
              });
              $scope.relationships.forEach(function (item) {
                if (item.value == beneficiarie.relationship) {
                  beneficiarie.relationship = item;
                }
              });
            });
          } else {
            $scope.newCertificate.datos.relationship_accident = [
              {
                familia: "",
                certificate: "",
                first_name: "",
                last_name: "",
                second_last_name: "",
                charge_date: convertDate(new Date()),
                birthdate: convertDate(new Date()),
                antiguedad: "",
                relationship: $scope.relationships[3],
                sex: $scope.sexs[0],
                p_neta: 0,
                rpf: 0,
                derecho: 0,
                salary: 0,
                iva: 0,
                p_total: 0,
                comision: 0,
                is_active: true,
                contributory: false,
              },
            ];
          }
          if ($scope.newCertificate.parent) {
            if (
              $scope.newCertificate.parent.policy == $scope.caratula.id &&
              $scope.categoriesJson
            ) {
              $scope.categoriesJson.forEach(function (item) {
                if (
                  item.category_id == $scope.newCertificate.parent.category_id
                ) {
                  $scope.newCertificate.parent = item;
                }
              });
            } else {
              $scope.newCertificate.parent = "";
            }
          }
          if ($scope.newCertificate.paquete) {
            if (
              $scope.newCertificate.paquete.policy == $scope.caratula.id &&
              $scope.paquetes
            ) {
              $scope.categoriesJson.forEach(function (item) {
                if (
                  item.category_id == $scope.newCertificate.paquete.category_id
                ) {
                  $scope.newCertificate.paquete = item;
                }
              });
            } else {
              $scope.newCertificate.paquete = "";
            }
          }
        } else {
          $scope.isEdit = false;
          $scope.newCertificate = {};
          $scope.newCertificate.certificate_number = "";
          $scope.newCertificate.contributory = false;
          $scope.newCertificate.certificado_inciso_activo = true;
          $scope.newCertificate.rec_antiguedad = convertDate(new Date());
          $scope.newCertificate.start_of_validity = convertDate(new Date());
          $scope.newCertificate.end_of_validity = convertDate(
            $scope.caratula.end_of_validity
          );
          $scope.newCertificate.charge_date = convertDate(new Date());
          $scope.newCertificate.p_neta = "";
          $scope.newCertificate.rpf = "";
          $scope.newCertificate.derecho = "";
          $scope.newCertificate.iva = "";
          $scope.newCertificate.p_total = "";
          $scope.newCertificate.comision = "";
          if ($scope.caratula.subramo.subramo_code == 1) {
            $scope.newCertificate.datos = {
              personal: {
                certificate: "",
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: convertDate(new Date()),
                antiguedad: convertDate(new Date()),
                charge_date: convertDate(new Date()),
                sex: $scope.sexs[0],
                email: "",
                salary: 0,
                sum_assured: "",
                type_sa: $scope.typesInsureds[0],
              },
              smoker: $scope.smokers[0],
              beneficiaries_life: [
                {
                  familia: "",
                  certificate: "",
                  first_name: "",
                  last_name: "",
                  second_last_name: "",
                  birthdate: convertDate(new Date()),
                  charge_date: convertDate(new Date()),
                  antiguedad: "",
                  optional_relationship: $scope.relationships[3],
                  sex: $scope.sexs[0],
                  percentage: 0,
                },
              ],
            };
          } else if ($scope.caratula.ramo.ramo_code == 2) {
            $scope.newCertificate.datos = {
              personal: {
                certificate: "",
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: convertDate(new Date()),
                antiguedad: convertDate(new Date()),
                charge_date: convertDate(new Date()),
                sex: $scope.sexs[0],
                email: "",
                p_neta: 0,
                rpf: 0,
                derecho: 0,
                iva: 0,
                p_total: 0,
                comision: 0,
                contributory: $scope.newCertificate.contributory,
              },
              relationship_accident: [
                {
                  familia: "",
                  certificate: "",
                  first_name: "",
                  last_name: "",
                  second_last_name: "",
                  charge_date: convertDate(new Date()),
                  birthdate: convertDate(new Date()),
                  antiguedad: "",
                  relationship: $scope.relationships[3],
                  sex: $scope.sexs[0],
                  p_neta: 0,
                  rpf: 0,
                  derecho: 0,
                  iva: 0,
                  p_total: 0,
                  comision: 0,
                  is_active: true,
                  contributory: $scope.newCertificate.contributory,
                },
              ],
            };
          } else if ($scope.caratula.ramo.ramo_code == 9) {
            $scope.newCertificate.datos = {
              adjustment: "",
              beneficiary_address: "",
              beneficiary_rfc: "",
              brand: "",
              car_owner: "",
              charge_type: $scope.typesCharges[0],
              color: "",
              driver: "",
              email: "",
              engine: "",
              license_plates: "",
              model: "",
              mont_adjustment: 0,
              mont_special_team: 0,
              no_employee: "",
              preferential_benefiaciary: "",
              procedencia: $scope.procedencias[0],
              serial: "",
              service: "",
              special_team: "",
              sum_insured: 0,
              usage: $scope.usages[0],
              version: "",
              year: "",
            };
          } else if ($scope.caratula.subramo.subramo_code == 13) {
            $scope.newCertificate.datos = {
              brand: "",
              dam_owner: "",
              color: "",
              email: "",
              engine: "",
              item_address: "",
              model: "",
              construction_year: 0,
              reconstruction_year: 0,
              no_employee: "",
              permiso: "",
              serial: "",
              usage: $scope.usages[0],
              version: "",
              item_details: "",
              purchase_value: 0,
            };
          } else if ($scope.caratula.subramo.subramo_code == 7) {
            $scope.newCertificate.datos = {
              email: "",
              item_address: "",
              no_levels: 0,
              giro: "",
              fhm_zone: "",
              type_construction: $scope.typesConstruction[0],
              tyev_zone: "",
              sucursal: "",
            };
          }
        }
      } else {
        $scope.newCertificate = {};
        $scope.newCertificate.certificate_number = "";
        $scope.newCertificate.certificado_inciso_activo = true;
        $scope.newCertificate.contributory = false;
        $scope.newCertificate.rec_antiguedad = convertDate(new Date());
        $scope.newCertificate.start_of_validity = convertDate(new Date());
        $scope.newCertificate.end_of_validity = convertDate(
          $scope.caratula.end_of_validity
        );
        $scope.newCertificate.charge_date = convertDate(new Date());
        $scope.newCertificate.p_neta = "";
        $scope.newCertificate.rpf = "";
        $scope.newCertificate.derecho = "";
        $scope.newCertificate.iva = "";
        $scope.newCertificate.p_total = "";
        $scope.newCertificate.comision = "";
        if ($scope.caratula.subramo.subramo_code == 1) {
          $scope.newCertificate.datos = {
            personal: {
              certificate: "",
              first_name: "",
              last_name: "",
              second_last_name: "",
              birthdate: convertDate(new Date()),
              antiguedad: convertDate(new Date()),
              charge_date: convertDate(new Date()),
              sex: $scope.sexs[0],
              email: "",
              salary: "",
              sum_assured: "",
              type_sa: $scope.typesInsureds[0],
            },
            smoker: $scope.smokers[0],
            beneficiaries_life: [
              {
                familia: "",
                certificate: "",
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: convertDate(new Date()),
                charge_date: convertDate(new Date()),
                antiguedad: "",
                optional_relationship: $scope.relationships[3],
                sex: $scope.sexs[0],
                percentage: 0,
              },
            ],
          };
        } else if ($scope.caratula.ramo.ramo_code == 2) {
          $scope.newCertificate.datos = {
            personal: {
              certificate: "",
              first_name: "",
              last_name: "",
              second_last_name: "",
              birthdate: convertDate(new Date()),
              antiguedad: convertDate(new Date()),
              charge_date: convertDate(new Date()),
              sex: $scope.sexs[0],
              email: "",
              p_neta: 0,
              rpf: 0,
              derecho: 0,
              iva: 0,
              p_total: 0,
              comision: 0,
              contributory: $scope.newCertificate.contributory,
            },
            relationship_accident: [
              {
                familia: "",
                certificate: "",
                first_name: "",
                last_name: "",
                second_last_name: "",
                charge_date: convertDate(new Date()),
                birthdate: convertDate(new Date()),
                antiguedad: "",
                relationship: $scope.relationships[3],
                sex: $scope.sexs[0],
                p_neta: 0,
                rpf: 0,
                derecho: 0,
                iva: 0,
                p_total: 0,
                comision: 0,
                is_active: true,
                contributory: $scope.newCertificate.contributory,
              },
            ],
          };
        } else if ($scope.caratula.ramo.ramo_code == 9) {
          $scope.newCertificate.datos = {
            adjustment: "",
            beneficiary_address: "",
            beneficiary_rfc: "",
            brand: "",
            car_owner: "",
            charge_type: $scope.typesCharges[0],
            color: "",
            driver: "",
            email: "",
            engine: "",
            license_plates: "",
            model: "",
            mont_adjustment: 0,
            mont_special_team: 0,
            no_employee: "",
            preferential_benefiaciary: "",
            procedencia: $scope.procedencias[0],
            serial: "",
            service: "",
            special_team: "",
            sum_insured: 0,
            usage: $scope.usages[0],
            version: "",
            year: "",
          };
        } else if ($scope.caratula.subramo.subramo_code == 13) {
          $scope.newCertificate.datos = {
            brand: "",
            dam_owner: "",
            color: "",
            email: "",
            engine: "",
            item_address: "",
            model: "",
            construction_year: 0,
            reconstruction_year: 0,
            no_employee: "",
            permiso: "",
            serial: "",
            usage: $scope.usages[0],
            version: "",
            item_details: "",
            purchase_value: 0,
          };
        } else if ($scope.caratula.subramo.subramo_code == 7) {
          $scope.newCertificate.datos = {
            email: "",
            item_address: "",
            no_levels: 0,
            giro: "",
            fhm_zone: "",
            type_construction: $scope.typesConstruction[0],
            tyev_zone: "",
            sucursal: "",
          };
        }
      }
      // *************************
      if (!$localStorage.save_edition_poliza_certificado) {
        if ($scope.caratula.subramo.subramo_code == 1) {
          $scope.newCertificate.datos = {
            personal: {
              certificate: "",
              first_name: "",
              last_name: "",
              second_last_name: "",
              birthdate: convertDate(new Date()),
              antiguedad: convertDate(new Date()),
              charge_date: convertDate(new Date()),
              sex: $scope.sexs[0],
              email: "",
              salary: "",
              sum_assured: "",
              type_sa: $scope.typesInsureds[0],
            },
            smoker: $scope.smokers[0],
            beneficiaries_life: [
              {
                familia: "",
                certificate: "",
                first_name: "",
                last_name: "",
                second_last_name: "",
                birthdate: convertDate(new Date()),
                charge_date: convertDate(new Date()),
                antiguedad: "",
                optional_relationship: $scope.relationships[3],
                sex: $scope.sexs[0],
                percentage: 0,
              },
            ],
          };
        } else if ($scope.caratula.ramo.ramo_code == 2) {
          $scope.newCertificate.datos = {
            personal: {
              certificate: "",
              first_name: "",
              last_name: "",
              second_last_name: "",
              birthdate: convertDate(new Date()),
              antiguedad: convertDate(new Date()),
              charge_date: convertDate(new Date()),
              sex: $scope.sexs[0],
              email: "",
              p_neta: 0,
              rpf: 0,
              derecho: 0,
              iva: 0,
              p_total: 0,
              comision: 0,
              contributory: $scope.newCertificate.contributory,
            },
            relationship_accident: [
              {
                familia: "",
                certificate: "",
                first_name: "",
                last_name: "",
                second_last_name: "",
                charge_date: convertDate(new Date()),
                birthdate: convertDate(new Date()),
                antiguedad: "",
                relationship: $scope.relationships[3],
                sex: $scope.sexs[0],
                p_neta: 0,
                rpf: 0,
                derecho: 0,
                iva: 0,
                p_total: 0,
                comision: 0,
                is_active: true,
                contributory: $scope.newCertificate.contributory,
              },
            ],
          };
        } else if ($scope.caratula.ramo.ramo_code == 9) {
          $scope.newCertificate.datos = {
            adjustment: "",
            beneficiary_address: "",
            beneficiary_rfc: "",
            brand: "",
            car_owner: "",
            charge_type: $scope.typesCharges[0],
            color: "",
            driver: "",
            email: "",
            engine: "",
            license_plates: "",
            model: "",
            mont_adjustment: 0,
            mont_special_team: 0,
            no_employee: "",
            preferential_benefiaciary: "",
            procedencia: $scope.procedencias[0],
            serial: "",
            service: "",
            special_team: "",
            sum_insured: 0,
            usage: $scope.usages[0],
            version: "",
            year: "",
          };
        } else if ($scope.caratula.subramo.subramo_code == 13) {
          $scope.newCertificate.datos = {
            brand: "",
            dam_owner: "",
            color: "",
            email: "",
            engine: "",
            item_address: "",
            model: "",
            construction_year: 0,
            reconstruction_year: 0,
            no_employee: "",
            permiso: "",
            serial: "",
            usage: $scope.usages[0],
            version: "",
            item_details: "",
            purchase_value: 0,
          };
        } else if ($scope.caratula.subramo.subramo_code == 7) {
          $scope.newCertificate.datos = {
            email: "",
            item_address: "",
            no_levels: 0,
            giro: "",
            fhm_zone: "",
            type_construction: $scope.typesConstruction[0],
            tyev_zone: "",
            sucursal: "",
          };
        }
      }
      if (
        $scope.incompleteOT.subgroups.length == 0 &&
        $scope.incompleteOT.packages.length == 0
      ) {
        $scope.countCategories();
        $scope.showItemCertificate(3);
      } else {
        SweetAlert.swal(
          "Error",
          "Debes agregar subgrupos y/o paquetes primero para poder cargar certificados manualmente.",
          "error"
        );
      }
    };

    $scope.countCategories = function () {
      $scope.categoriesJson = [];
      $scope.subgrupos.forEach(function (item) {
        for (var i = 0; i < item.categorias.length; i++) {
          var category = {
            subgroup: item.name,
            category: item.categorias[i].name,
            category_id: item.categorias[i].id,
            policy: $scope.caratula.id,
          };
          $scope.categoriesJson.push(category);
        }
      });
    };

    $scope.saveIndividualCertificate = function (c, salary) {
      $scope.certifcados = [];
      if ($scope.caratula.subramo.subramo_code == 1) {
        $scope.newCertificate.datos.personal.certificate =
          $scope.newCertificate.certificate_number;
        $scope.newCertificate.datos.personal.sex =
          $scope.newCertificate.datos.personal.sex.value;
        $scope.newCertificate.datos.personal.salary = $scope.newCertificate
          .datos.personal.salary
          ? $scope.newCertificate.datos.personal.salary
          : salary
          ? salary
          : 0;
        $scope.newCertificate.datos.personal.type_sa =
          $scope.newCertificate.datos.personal.type_sa.value;
        $scope.newCertificate.datos.personal.birthdate = toDate(
          $scope.newCertificate.datos.personal.birthdate
        );
        $scope.newCertificate.datos.personal.antiguedad = toDate(
          $scope.newCertificate.rec_antiguedad
        );
        $scope.newCertificate.datos.personal.charge_date = $scope.newCertificate
          .datos.personal.charge_date
          ? toDate($scope.newCertificate.datos.personal.charge_date)
          : new Date();
        $scope.newCertificate.datos.smoker =
          $scope.newCertificate.datos.smoker.value;
        if (
          $scope.newCertificate.datos &&
          $scope.newCertificate.datos.beneficiaries_life
        ) {
          $scope.newCertificate.datos.beneficiaries_life.forEach(function (
            beneficiarie
          ) {
            beneficiarie.birthdate = toDate(beneficiarie.birthdate);
            beneficiarie.antiguedad = toDate(
              $scope.newCertificate.rec_antiguedad
            );
            beneficiarie.sex = beneficiarie.sex.value;
            beneficiarie.charge_date = beneficiarie.charge_date
              ? toDate(beneficiarie.charge_date)
              : toDate(new Date());
            beneficiarie.optional_relationship =
              beneficiarie.optional_relationship.value;
          });
        }
        var certificateData = {
          caratula: $scope.caratula.id,
          certificate_number: $scope.newCertificate.certificate_number,
          folio: $scope.newCertificate.folio ? $scope.newCertificate.folio : "",
          parent: $scope.newCertificate.parent.category_id,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC. " +
            $scope.newCertificate.certificate_number,
          contractor: $scope.caratula.contractor,
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          paquete: $scope.newCertificate.paquete.id,
          observations: $scope.newCertificate.observations
            ? $scope.newCertificate.observations
            : "",
          old_policies: [],
          start_of_validity: toDate($scope.newCertificate.start_of_validity),
          end_of_validity: toDate($scope.newCertificate.end_of_validity),
          charge_date: $scope.newCertificate.charge_date
            ? toDate($scope.newCertificate.charge_date)
            : new Date(),
          status: $scope.caratula.status,
          automobiles_policy: [],
          damages_policy: [],
          accidents_policy: [],
          life_policy: [$scope.newCertificate.datos],
          document_type: 6,
          coverageInPolicy_policy: [],
          identifier:
            "VIDA_" +
            $scope.newCertificate.datos.personal.first_name +
            "_" +
            $scope.newCertificate.datos.personal.first_name,
          p_neta: $scope.newCertificate.p_neta
            ? $scope.newCertificate.p_neta
            : 0,
          rpf: $scope.newCertificate.rpf ? $scope.newCertificate.rpf : 0,
          derecho: $scope.newCertificate.derecho
            ? $scope.newCertificate.derecho
            : 0,
          iva: $scope.newCertificate.iva ? $scope.newCertificate.iva : 0,
          p_total: $scope.newCertificate.p_total
            ? $scope.newCertificate.p_total
            : 0,
          comision: $scope.newCertificate.comision
            ? $scope.newCertificate.comision
            : 0,
          rec_antiguedad: toDate($scope.newCertificate.rec_antiguedad),
          contacto: "",
        };
        $scope.certifcados.push(certificateData);
      } else if ($scope.caratula.ramo.ramo_code == 2) {
        $scope.newCertificate.datos.personal.sex =
          $scope.newCertificate.datos.personal.sex.value;
        $scope.newCertificate.datos.personal.charge_date = $scope.newCertificate
          .datos.personal.charge_date
          ? toDate($scope.newCertificate.datos.personal.charge_date)
          : new Date();
        $scope.newCertificate.datos.personal.birthdate = toDate(
          $scope.newCertificate.datos.personal.birthdate
        );
        $scope.newCertificate.datos.personal.antiguedad = toDate(
          $scope.newCertificate.rec_antiguedad
        );
        $scope.newCertificate.datos.personal.contributory = $scope
          .newCertificate.contributory
          ? $scope.newCertificate.contributory
          : false;
        $scope.newCertificate.datos.personal.rfc_cve =
          $scope.newCertificate.datos.personal.rfc_cve;
        $scope.newCertificate.datos.personal.rfc_homocve =
          $scope.newCertificate.datos.personal.rfc_homocve;
        $scope.newCertificate.datos.personal.dom_callenum =
          $scope.newCertificate.datos.personal.dom_callenum;
        $scope.newCertificate.datos.personal.dom_colonia =
          $scope.newCertificate.datos.personal.dom_colonia;
        $scope.newCertificate.datos.personal.dom_cp =
          $scope.newCertificate.datos.personal.dom_cp;
        $scope.newCertificate.datos.personal.dom_poblacion =
          $scope.newCertificate.datos.personal.dom_poblacion;
        $scope.newCertificate.datos.personal.dom_estado =
          $scope.newCertificate.datos.personal.dom_estado;
        // Primas Titular
        $scope.newCertificate.datos.personal.p_neta = $scope.newCertificate
          .datos.personal.p_neta
          ? parseFloat($scope.newCertificate.datos.personal.p_neta).toFixed(2)
          : 0;
        $scope.newCertificate.datos.personal.rpf = $scope.newCertificate.datos
          .personal.rpf
          ? parseFloat($scope.newCertificate.datos.personal.rpf).toFixed(2)
          : 0;
        $scope.newCertificate.datos.personal.derecho = $scope.newCertificate
          .datos.personal.derecho
          ? parseFloat($scope.newCertificate.datos.personal.derecho).toFixed(2)
          : 0;
        $scope.newCertificate.datos.personal.iva = $scope.newCertificate.datos
          .personal.iva
          ? parseFloat($scope.newCertificate.datos.personal.iva).toFixed(2)
          : 0;
        $scope.newCertificate.datos.personal.p_total = $scope.newCertificate
          .datos.personal.p_total
          ? parseFloat($scope.newCertificate.datos.personal.p_total).toFixed(2)
          : 0;
        $scope.newCertificate.datos.personal.comision = $scope.newCertificate
          .datos.personal.comision
          ? parseFloat($scope.newCertificate.datos.personal.comision).toFixed(2)
          : 0;

        // Suma
        $scope.sum_neta = $scope.newCertificate.datos.personal.p_neta;
        $scope.sum_rpf = $scope.newCertificate.datos.personal.rpf;
        $scope.sum_derecho = $scope.newCertificate.datos.personal.derecho;
        $scope.sum_iva = $scope.newCertificate.datos.personal.iva;
        $scope.sum_total = $scope.newCertificate.datos.personal.p_total;
        $scope.sum_comision = $scope.newCertificate.datos.personal.comision;
        // Fin Primas Titular
        if ($scope.newCertificate.datos.relationship_accident) {
          $scope.newCertificate.datos.relationship_accident.forEach(function (
            beneficiarie
          ) {
            beneficiarie.birthdate = toDate(beneficiarie.birthdate);
            beneficiarie.charge_date = beneficiarie.charge_date
              ? toDate(beneficiarie.charge_date)
              : new Date();
            beneficiarie.antiguedad = toDate(
              $scope.newCertificate.rec_antiguedad
            );
            beneficiarie.sex = beneficiarie.sex.value;
            beneficiarie.relationship = beneficiarie.relationship.value;
            beneficiarie.certificate = beneficiarie.certificate
              ? beneficiarie.certificate
              : $scope.newCertificate.certificate_number
              ? $scope.newCertificate.certificate_number
              : "";
            beneficiarie.contributory = $scope.newCertificate.contributory;
            beneficiarie.rfc_cve = beneficiarie.rfc_cve;
            beneficiarie.rfc_homocve = beneficiarie.rfc_homocve;
            beneficiarie.dom_callenum = beneficiarie.dom_callenum;
            beneficiarie.dom_colonia = beneficiarie.dom_colonia;
            beneficiarie.dom_cp = beneficiarie.dom_cp;
            beneficiarie.dom_poblacion = beneficiarie.dom_poblacion;
            beneficiarie.dom_estado = beneficiarie.dom_estado;
            // Primas Dependiente
            beneficiarie.p_neta = beneficiarie.p_neta
              ? parseFloat(beneficiarie.p_neta).toFixed(2)
              : 0;
            beneficiarie.rpf = beneficiarie.rpf
              ? parseFloat(beneficiarie.rpf).toFixed(2)
              : 0;
            beneficiarie.derecho = beneficiarie.derecho
              ? parseFloat(beneficiarie.derecho).toFixed(2)
              : 0;
            beneficiarie.iva = beneficiarie.iva
              ? parseFloat(beneficiarie.iva).toFixed(2)
              : 0;
            beneficiarie.p_total = beneficiarie.p_total
              ? parseFloat(beneficiarie.p_total).toFixed(2)
              : 0;
            beneficiarie.comision = beneficiarie.comision
              ? parseFloat(beneficiarie.comision).toFixed(2)
              : 0;
            // Suma
            $scope.sum_neta = parseFloat(
              parseFloat($scope.sum_neta) + parseFloat(beneficiarie.p_neta)
            ).toFixed(2);
            $scope.sum_rpf = parseFloat(
              parseFloat($scope.sum_rpf) + parseFloat(beneficiarie.rpf)
            ).toFixed(2);
            $scope.sum_derecho = parseFloat(
              parseFloat($scope.sum_derecho) + parseFloat(beneficiarie.derecho)
            ).toFixed(2);
            $scope.sum_iva = parseFloat(
              parseFloat($scope.sum_iva) + parseFloat(beneficiarie.iva)
            ).toFixed(2);
            $scope.sum_total = parseFloat(
              parseFloat($scope.sum_total) + parseFloat(beneficiarie.p_total)
            ).toFixed(2);
            $scope.sum_comision = parseFloat(
              parseFloat($scope.sum_comision) +
                parseFloat(beneficiarie.comision)
            ).toFixed(2);

            // Fin Primas Dependiente
          });
        } else {
          $scope.newCertificate.datos.relationship_accident = [];
        }
        var certificateData = {
          caratula: $scope.caratula.id,
          certificate_number: $scope.newCertificate.certificate_number,
          folio: $scope.newCertificate.folio ? $scope.newCertificate.folio : "",
          parent: $scope.newCertificate.parent.category_id,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC. " +
            $scope.newCertificate.certificate_number,
          contractor: $scope.caratula.contractor,
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          paquete: $scope.newCertificate.paquete.id,
          observations: $scope.newCertificate.observations
            ? $scope.newCertificate.observations
            : "",
          old_policies: [],
          start_of_validity: toDate($scope.newCertificate.start_of_validity),
          end_of_validity: toDate($scope.newCertificate.end_of_validity),
          charge_date: $scope.newCertificate.charge_date
            ? toDate($scope.newCertificate.charge_date)
            : new Date(),
          status: $scope.caratula.status,
          automobiles_policy: [],
          damages_policy: [],
          accidents_policy: [$scope.newCertificate.datos],
          life_policy: [],
          document_type: 6,
          contributory: $scope.newCertificate.contributory,
          coverageInPolicy_policy: [],
          identifier:
            "AEGM_" +
            $scope.newCertificate.datos.personal.first_name +
            "_" +
            $scope.newCertificate.datos.personal.first_name,
          // p_neta: $scope.newCertificate.p_neta ? $scope.newCertificate.p_neta : 0,
          // rpf: $scope.newCertificate.rpf ? $scope.newCertificate.rpf : 0,
          // derecho: $scope.newCertificate.derecho ? $scope.newCertificate.derecho : 0,
          // iva: $scope.newCertificate.iva ? $scope.newCertificate.iva : 0,
          // p_total: $scope.newCertificate.p_total ? $scope.newCertificate.p_total : 0,
          // comision: $scope.newCertificate.comision ? $scope.newCertificate.comision : 0,
          p_neta: $scope.sum_neta
            ? parseFloat($scope.sum_neta).toFixed(2)
            : $scope.newCertificate.p_neta
            ? parseFloat($scope.newCertificate.p_neta).toFixed(2)
            : 0,
          rpf: $scope.sum_rpf
            ? parseFloat($scope.sum_rpf).toFixed(2)
            : $scope.newCertificate.rpf
            ? parseFloat($scope.newCertificate.rpf).toFixed(2)
            : 0,
          derecho: $scope.sum_derecho
            ? parseFloat($scope.sum_derecho).toFixed(2)
            : $scope.newCertificate.derecho
            ? parseFloat($scope.newCertificate.derecho).toFixed(2)
            : 0,
          iva: $scope.sum_iva
            ? parseFloat($scope.sum_iva).toFixed(2)
            : $scope.newCertificate.iva
            ? parseFloat($scope.newCertificate.iva).toFixed(2)
            : 0,
          p_total: $scope.sum_total
            ? parseFloat($scope.sum_total).toFixed(2)
            : $scope.newCertificate.iva
            ? parseFloat($scope.newCertificate.iva).toFixed(2)
            : 0,
          comision: $scope.sum_comision
            ? parseFloat($scope.sum_comision).toFixed(2)
            : $scope.newCertificate.comision
            ? parseFloat($scope.newCertificate.comision).toFixed(2)
            : 0,
          rec_antiguedad: toDate($scope.newCertificate.rec_antiguedad),
          contacto: "",
        };
        $scope.certifcados.push(certificateData);
      } else if ($scope.caratula.subramo.subramo_code == 9) {
        $scope.newCertificate.datos.adjustment = $scope.newCertificate.datos
          .adjustment
          ? $scope.newCertificate.datos.adjustment
          : "";
        $scope.newCertificate.datos.beneficiary_address = $scope.newCertificate
          .datos.beneficiary_address
          ? $scope.newCertificate.datos.beneficiary_address
          : "";
        $scope.newCertificate.datos.beneficiary_rfc = $scope.newCertificate
          .datos.beneficiary_rfc
          ? $scope.newCertificate.datos.beneficiary_rfc
          : "";
        $scope.newCertificate.datos.brand = $scope.newCertificate.datos.brand
          ? $scope.newCertificate.datos.brand
          : "";
        $scope.newCertificate.datos.car_owner = $scope.newCertificate.datos
          .car_owner
          ? $scope.newCertificate.datos.car_owner
          : "";
        $scope.newCertificate.datos.charge_type = $scope.newCertificate.datos
          .charge_type
          ? $scope.newCertificate.datos.charge_type.value
          : 0;
        $scope.newCertificate.datos.color = $scope.newCertificate.datos.color
          ? $scope.newCertificate.datos.color
          : "";
        $scope.newCertificate.datos.driver = $scope.newCertificate.datos.driver
          ? $scope.newCertificate.datos.driver
          : "";
        $scope.newCertificate.datos.email = $scope.newCertificate.datos.email
          ? $scope.newCertificate.datos.email
          : "";
        $scope.newCertificate.datos.engine = $scope.newCertificate.datos.engine
          ? $scope.newCertificate.datos.engine
          : "";
        $scope.newCertificate.datos.license_plates = $scope.newCertificate.datos
          .license_plates
          ? $scope.newCertificate.datos.license_plates
          : "";
        $scope.newCertificate.datos.model = $scope.newCertificate.datos.model
          ? $scope.newCertificate.datos.model
          : "";
        $scope.newCertificate.datos.mont_adjustment = $scope.newCertificate
          .datos.mont_adjustment
          ? $scope.newCertificate.datos.mont_adjustment
          : 0;
        $scope.newCertificate.datos.mont_special_team = $scope.newCertificate
          .datos.mont_special_team
          ? $scope.newCertificate.datos.mont_special_team
          : 0;
        $scope.newCertificate.datos.no_employee = $scope.newCertificate.datos
          .no_employee
          ? $scope.newCertificate.datos.no_employee
          : 0;
        $scope.newCertificate.datos.preferential_benefiaciary = $scope
          .newCertificate.datos.preferential_benefiaciary
          ? $scope.newCertificate.datos.preferential_benefiaciary
          : 0;
        $scope.newCertificate.datos.procedencia = $scope.newCertificate.datos
          .procedencia
          ? $scope.newCertificate.datos.procedencia.value
          : 0;
        $scope.newCertificate.datos.serial = $scope.newCertificate.datos.serial
          ? $scope.newCertificate.datos.serial
          : "";
        $scope.newCertificate.datos.service = $scope.newCertificate.datos
          .service
          ? $scope.newCertificate.datos.service
          : "";
        $scope.newCertificate.datos.special_team = $scope.newCertificate.datos
          .special_team
          ? $scope.newCertificate.datos.special_team
          : "";
        $scope.newCertificate.datos.sum_insured = $scope.newCertificate.datos
          .sum_insured
          ? $scope.newCertificate.datos.sum_insured
          : "";
        $scope.newCertificate.datos.usage = $scope.newCertificate.datos.usage
          ? $scope.newCertificate.datos.usage.value
          : 0;
        $scope.newCertificate.datos.version = $scope.newCertificate.datos
          .version
          ? $scope.newCertificate.datos.version
          : "";
        $scope.newCertificate.datos.year = $scope.newCertificate.datos.year
          ? $scope.newCertificate.datos.year
          : 0;

        var certificateData = {
          caratula: $scope.caratula.id,
          certificate_number: $scope.newCertificate.certificate_number,
          folio: $scope.newCertificate.folio ? $scope.newCertificate.folio : "",
          parent: $scope.newCertificate.parent.category_id,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC. " +
            $scope.newCertificate.certificate_number,
          charge_date: $scope.newCertificate.charge_date
            ? toDate($scope.newCertificate.charge_date)
            : new Date(),
          contractor: $scope.caratula.contractor,
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          paquete: $scope.newCertificate.paquete.id,
          observations: $scope.newCertificate.observations
            ? $scope.newCertificate.observations
            : "",
          old_policies: [],
          start_of_validity: toDate($scope.newCertificate.start_of_validity),
          end_of_validity: toDate($scope.newCertificate.end_of_validity),
          status: $scope.caratula.status,
          automobiles_policy: [$scope.newCertificate.datos],
          damages_policy: [],
          accidents_policy: [],
          life_policy: [],
          document_type: 6,
          coverageInPolicy_policy: [],
          identifier:
            "AUTO_" +
            $scope.newCertificate.datos.serial +
            "_" +
            $scope.newCertificate.datos.version +
            "_" +
            $scope.newCertificate.datos.year,
          p_neta: $scope.newCertificate.p_neta
            ? $scope.newCertificate.p_neta
            : 0,
          rpf: $scope.newCertificate.rpf ? $scope.newCertificate.rpf : 0,
          derecho: $scope.newCertificate.derecho
            ? $scope.newCertificate.derecho
            : 0,
          iva: $scope.newCertificate.iva ? $scope.newCertificate.iva : 0,
          p_total: $scope.newCertificate.p_total
            ? $scope.newCertificate.p_total
            : 0,
          comision: $scope.newCertificate.comision
            ? $scope.newCertificate.comision
            : 0,
          rec_antiguedad: toDate($scope.newCertificate.rec_antiguedad),
          contacto: "",
        };
        $scope.certifcados.push(certificateData);
      } else if ($scope.caratula.subramo.subramo_code == 13) {
        $scope.newCertificate.datos.brand = $scope.newCertificate.datos.brand
          ? $scope.newCertificate.datos.brand
          : "";
        $scope.newCertificate.datos.color = $scope.newCertificate.datos.color
          ? $scope.newCertificate.datos.color
          : "";
        $scope.newCertificate.datos.construction_year = $scope.newCertificate
          .datos.construction_year
          ? $scope.newCertificate.datos.construction_year
          : "";
        $scope.newCertificate.datos.email = $scope.newCertificate.datos.email
          ? $scope.newCertificate.datos.email
          : "";
        $scope.newCertificate.datos.engine = $scope.newCertificate.datos.engine
          ? $scope.newCertificate.datos.engine
          : "";
        $scope.newCertificate.datos.dam_owner = $scope.newCertificate.datos
          .dam_owner
          ? $scope.newCertificate.datos.dam_owner
          : "";
        $scope.newCertificate.datos.model = $scope.newCertificate.datos.model
          ? $scope.newCertificate.datos.model
          : "";
        $scope.newCertificate.datos.no_employee = $scope.newCertificate.datos
          .no_employee
          ? $scope.newCertificate.datos.no_employee
          : 0;
        $scope.newCertificate.datos.permiso = $scope.newCertificate.datos
          .permiso
          ? $scope.newCertificate.datos.permiso
          : 0;
        $scope.newCertificate.datos.serial = $scope.newCertificate.datos.serial
          ? $scope.newCertificate.datos.serial
          : "";
        $scope.newCertificate.datos.purchase_value = $scope.newCertificate.datos
          .purchase_value
          ? $scope.newCertificate.datos.purchase_value
          : 0;
        $scope.newCertificate.datos.reconstruction_year = $scope.newCertificate
          .datos.reconstruction_year
          ? $scope.newCertificate.datos.reconstruction_year
          : "";
        $scope.newCertificate.datos.usage = $scope.newCertificate.datos.usage
          ? $scope.newCertificate.datos.usage.value
          : 0;
        $scope.newCertificate.datos.version = $scope.newCertificate.datos
          .version
          ? $scope.newCertificate.datos.version
          : "";

        var certificateData = {
          caratula: $scope.caratula.id,
          certificate_number: $scope.newCertificate.certificate_number,
          folio: $scope.newCertificate.folio ? $scope.newCertificate.folio : "",
          parent: $scope.newCertificate.parent.category_id,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC. " +
            $scope.newCertificate.certificate_number,
          contractor: $scope.caratula.contractor,
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          paquete: $scope.newCertificate.paquete.id,
          observations: $scope.newCertificate.observations
            ? $scope.newCertificate.observations
            : "",
          old_policies: [],
          start_of_validity: toDate($scope.newCertificate.start_of_validity),
          end_of_validity: toDate($scope.newCertificate.end_of_validity),
          charge_date: $scope.newCertificate.charge_date
            ? toDate($scope.newCertificate.charge_date)
            : new Date(),
          status: $scope.caratula.status,
          automobiles_policy: [],
          damages_policy: [$scope.newCertificate.datos],
          accidents_policy: [],
          life_policy: [],
          document_type: 6,
          coverageInPolicy_policy: [],
          identifier:
            "DIV_" +
            $scope.newCertificate.datos.serial +
            "_" +
            $scope.newCertificate.datos.version +
            "_" +
            $scope.newCertificate.datos.brand,
          p_neta: $scope.newCertificate.p_neta
            ? $scope.newCertificate.p_neta
            : 0,
          rpf: $scope.newCertificate.rpf ? $scope.newCertificate.rpf : 0,
          derecho: $scope.newCertificate.derecho
            ? $scope.newCertificate.derecho
            : 0,
          iva: $scope.newCertificate.iva ? $scope.newCertificate.iva : 0,
          p_total: $scope.newCertificate.p_total
            ? $scope.newCertificate.p_total
            : 0,
          comision: $scope.newCertificate.comision
            ? $scope.newCertificate.comision
            : 0,
          rec_antiguedad: toDate($scope.newCertificate.rec_antiguedad),
          contacto: "",
        };
        $scope.certifcados.push(certificateData);
      } else if ($scope.caratula.subramo.subramo_code == 7) {
        $scope.newCertificate.datos.fhm_zone = $scope.newCertificate.datos
          .fhm_zone
          ? $scope.newCertificate.datos.fhm_zone
          : "";
        $scope.newCertificate.datos.giro = $scope.newCertificate.datos.giro
          ? $scope.newCertificate.datos.giro
          : "";
        $scope.newCertificate.datos.item_address = $scope.newCertificate.datos
          .item_address
          ? $scope.newCertificate.datos.item_address
          : "";
        $scope.newCertificate.datos.email = $scope.newCertificate.datos.email
          ? $scope.newCertificate.datos.email
          : "";
        $scope.newCertificate.datos.no_levels = $scope.newCertificate.datos
          .no_levels
          ? $scope.newCertificate.datos.no_levels
          : "";
        $scope.newCertificate.datos.sucursal = $scope.newCertificate.datos
          .sucursal
          ? $scope.newCertificate.datos.sucursal
          : "";
        $scope.newCertificate.datos.tyev_zone = $scope.newCertificate.datos
          .tyev_zone
          ? $scope.newCertificate.datos.tyev_zone
          : "";
        $scope.newCertificate.datos.type_construction = $scope.newCertificate
          .datos.type_construction
          ? $scope.newCertificate.datos.type_construction.value
          : 0;

        var certificateData = {
          caratula: $scope.caratula.id,
          certificate_number: $scope.newCertificate.certificate_number,
          folio: $scope.newCertificate.folio ? $scope.newCertificate.folio : "",
          parent: $scope.newCertificate.parent.category_id,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC. " +
            $scope.newCertificate.certificate_number,
          contractor: $scope.caratula.contractor,
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          paquete: $scope.newCertificate.paquete.id,
          observations: $scope.newCertificate.observations
            ? $scope.newCertificate.observations
            : "",
          old_policies: [],
          start_of_validity: toDate($scope.newCertificate.start_of_validity),
          end_of_validity: toDate($scope.newCertificate.end_of_validity),
          charge_date: $scope.newCertificate.charge_date
            ? toDate($scope.newCertificate.charge_date)
            : new Date(),
          status: $scope.caratula.status,
          automobiles_policy: [],
          damages_policy: [$scope.newCertificate.datos],
          accidents_policy: [],
          life_policy: [],
          document_type: 6,
          coverageInPolicy_policy: [],
          identifier:
            "D_INC_" +
            $scope.newCertificate.datos.serial +
            "_" +
            $scope.newCertificate.datos.version +
            "_" +
            $scope.newCertificate.datos.brand,
          p_neta: $scope.newCertificate.p_neta
            ? $scope.newCertificate.p_neta
            : 0,
          rpf: $scope.newCertificate.rpf ? $scope.newCertificate.rpf : 0,
          derecho: $scope.newCertificate.derecho
            ? $scope.newCertificate.derecho
            : 0,
          iva: $scope.newCertificate.iva ? $scope.newCertificate.iva : 0,
          p_total: $scope.newCertificate.p_total
            ? $scope.newCertificate.p_total
            : 0,
          comision: $scope.newCertificate.comision
            ? $scope.newCertificate.comision
            : 0,
          rec_antiguedad: toDate($scope.newCertificate.rec_antiguedad),
          contacto: "",
        };
        $scope.certifcados.push(certificateData);
      } else if (
        $scope.caratula.subramo.subramo_code != 7 &&
        $scope.caratula.subramo.subramo_code != 13 &&
        $scope.caratula.subramo.subramo_code != 9 &&
        $scope.caratula.subramo.subramo_code != 13
      ) {
        $scope.newCertificate.datos.insured_item = $scope.newCertificate.datos
          .insured_item
          ? $scope.newCertificate.datos.insured_item
          : "";
        $scope.newCertificate.datos.item_address = $scope.newCertificate.datos
          .item_address
          ? $scope.newCertificate.datos.item_address
          : "";
        $scope.newCertificate.datos.item_details = $scope.newCertificate.datos
          .item_details
          ? $scope.newCertificate.datos.item_details
          : "";
        $scope.newCertificate.datos.email = $scope.newCertificate.datos.email
          ? $scope.newCertificate.datos.email
          : "";

        var certificateData = {
          caratula: $scope.caratula.id,
          certificate_number: $scope.newCertificate.certificate_number,
          folio: $scope.newCertificate.folio ? $scope.newCertificate.folio : "",
          parent: $scope.newCertificate.parent.category_id,
          poliza_number:
            $scope.caratula.poliza_number +
            " - INC. " +
            $scope.newCertificate.certificate_number,
          contractor: $scope.caratula.contractor,
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          paquete: $scope.newCertificate.paquete.id,
          observations: $scope.newCertificate.observations
            ? $scope.newCertificate.observations
            : "",
          old_policies: [],
          start_of_validity: toDate($scope.newCertificate.start_of_validity),
          end_of_validity: toDate($scope.newCertificate.end_of_validity),
          charge_date: $scope.newCertificate.charge_date
            ? toDate($scope.newCertificate.charge_date)
            : new Date(),
          status: $scope.caratula.status,
          automobiles_policy: [],
          damages_policy: [$scope.newCertificate.datos],
          accidents_policy: [],
          life_policy: [],
          document_type: 6,
          coverageInPolicy_policy: [],
          identifier:
            "D_INC_" +
            $scope.newCertificate.datos.serial +
            "_" +
            $scope.newCertificate.datos.version +
            "_" +
            $scope.newCertificate.datos.brand,
          p_neta: $scope.newCertificate.p_neta
            ? $scope.newCertificate.p_neta
            : 0,
          rpf: $scope.newCertificate.rpf ? $scope.newCertificate.rpf : 0,
          derecho: $scope.newCertificate.derecho
            ? $scope.newCertificate.derecho
            : 0,
          iva: $scope.newCertificate.iva ? $scope.newCertificate.iva : 0,
          p_total: $scope.newCertificate.p_total
            ? $scope.newCertificate.p_total
            : 0,
          comision: $scope.newCertificate.comision
            ? $scope.newCertificate.comision
            : 0,
          rec_antiguedad: toDate($scope.newCertificate.rec_antiguedad),
          contacto: "",
        };
        $scope.certifcados.push(certificateData);
      }
      $scope.saveOK($scope.certifcados);
    };
    $scope.evaluateCertificates = function (certificados) {
      $scope.certifcados = certificados;
      $scope.errorMensaje = "";
      $http({
        method: "POST",
        url: url.IP + "certificates-evaluate/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            if (response.data.exist) {
              // Show SweetAlert confirmation dialog
              SweetAlert.swal(
                {
                  title:
                    "Existen pólizas vigentes o por iniciar con el mismo Número de Serie: " +
                    response.data.poliza,
                  text: "¿Continuar registrando los certificados?",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Si, continuar.",
                  cancelButtonText: "Cancelar",
                  closeOnConfirm: false,
                },
                function (isConfirm) {
                  if (isConfirm) {
                    SweetAlert.close();
                    $scope.saveOKGral($scope.certifcados);
                  } else {
                    var l = Ladda.create(
                      document.querySelector(".ladda-button")
                    );
                    l.start();
                    l.stop();
                    $scope.certificados = [];
                    $scope.loader = false;
                  }
                }
              );
            } else {
              SweetAlert.close();
              $scope.saveOKGral(certificados);
            }
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };
    $scope.saveOK = function (certificados) {
      $scope.certifcados = certificados;
      $http({
        method: "POST",
        url: url.IP + "mass-certificates/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.CERTIFICATESDONE, "success");
            $localStorage.save_edition_poliza_certificado = {};
            var logManual = {
              model: 18,
              event: "POST",
              associated_id: $scope.caratula.id,
              identifier:
                " agregó " +
                $scope.certifcados.length +
                " certificado a la póliza de grupo de forma manual.",
            };
            dataFactory
              .post("send_log_specific/", logManual)
              .then(function success(response) {
                $localStorage.save_edition_poliza_certificado = {};
              });
            activate();
            $scope.createIndividualCertificate();
            $scope.showItemCertificate(4);
          } else {
            SweetAlert.swal("ERROR", response.data.data, "error");
            if ($scope.newCertificate.datos.personal.type_sa) {
              if ($scope.newCertificate.rec_antiguedad.indexOf("-") != -1) {
                $scope.newCertificate.rec_antiguedad = convertDate(
                  $scope.newCertificate.rec_antiguedad
                );
              }
              if (
                $scope.newCertificate.datos.personal.birthdate.indexOf("-") !=
                -1
              ) {
                $scope.newCertificate.datos.personal.birthdate = convertDate(
                  $scope.newCertificate.datos.personal.birthdate
                );
              }
              $scope.sexs.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.personal.sex) {
                  $scope.newCertificate.datos.personal.sex = item;
                }
              });
              $scope.typesInsureds.forEach(function (item) {
                if (
                  item.value == $scope.newCertificate.datos.personal.type_sa
                ) {
                  $scope.newCertificate.datos.personal.type_sa = item;
                }
              });
              $scope.smokers.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.smoker) {
                  $scope.newCertificate.datos.smoker = item;
                }
              });
              $scope.newCertificate.datos.beneficiaries_life.forEach(function (
                beneficiarie
              ) {
                if (beneficiarie.birthdate.indexOf("-") != -1) {
                  beneficiarie.birthdate = convertDate(beneficiarie.birthdate);
                }
                $scope.sexs.forEach(function (item) {
                  if (item.value == beneficiarie.sex) {
                    beneficiarie.sex = item;
                  }
                });
                $scope.relationships.forEach(function (item) {
                  if (item.value == beneficiarie.optional_relationship) {
                    beneficiarie.optional_relationship = item;
                  }
                });
              });
            }
            if ($scope.newCertificate.datos.relationship_accident) {
              if ($scope.newCertificate.rec_antiguedad.indexOf("-") != -1) {
                $scope.newCertificate.rec_antiguedad = convertDate(
                  $scope.newCertificate.rec_antiguedad
                );
              }
              if (
                $scope.newCertificate.datos.personal.birthdate.indexOf("-") !=
                -1
              ) {
                $scope.newCertificate.datos.personal.birthdate = convertDate(
                  $scope.newCertificate.datos.personal.birthdate
                );
              }
              $scope.sexs.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.personal.sex) {
                  $scope.newCertificate.datos.personal.sex = item;
                }
              });
              $scope.newCertificate.datos.relationship_accident.forEach(
                function (beneficiarie) {
                  if (beneficiarie.birthdate.indexOf("-") != -1) {
                    beneficiarie.birthdate = convertDate(
                      beneficiarie.birthdate
                    );
                  }
                  $scope.sexs.forEach(function (item) {
                    if (item.value == beneficiarie.sex) {
                      beneficiarie.sex = item;
                    }
                  });
                  $scope.relationships.forEach(function (item) {
                    if (item.value == beneficiarie.relationship) {
                      beneficiarie.relationship = item;
                    }
                  });
                }
              );
            }
            if ($scope.newCertificate.datos.procedencia) {
              $scope.usages.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.usage) {
                  $scope.newCertificate.datos.usage = item;
                }
              });
              $scope.typesCharges.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.charge_type) {
                  $scope.newCertificate.datos.charge_type = item;
                }
              });
              $scope.procedencias.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.procedencia) {
                  $scope.newCertificate.datos.procedencia = item;
                }
              });
            }
            if ($scope.newCertificate.datos.type_construction) {
              $scope.typesConstruction.forEach(function (item) {
                if (
                  item.value ==
                  $scope.newCertificate.damages_policy[0].type_construction
                ) {
                  $scope.newCertificate.datos.type_construction = item;
                }
              });
              $scope.usages.forEach(function (item) {
                if (item.value == $scope.newCertificate.datos.usage) {
                  $scope.newCertificate.datos.usage = item;
                }
              });
            }
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };
    function convertDate(inputFormat) {
      // function pad(s) { return (s < 10) ? '0' + s : s; }
      // var d = new Date(inputFormat);
      // var date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
      // return date;
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d_uno = new Date(inputFormat);
      var fecha = new Date(inputFormat);
      if (fecha.getUTCHours() <= 11) {
        fecha.setHours(fecha.getHours() + 12);
      } else {
        fecha.setHours(fecha.getHours() + 5);
      }
      var d = fecha;
      // var d = new Date(inputFormat).toISOString()//prueba
      // console.log('-fecha 2',d,new Date(d.toLocaleString()))
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function toDate(dateStr) {
      if (dateStr) {
        if (dateStr.includes("T")) {
          return dateStr;
        }
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(
          dateParts[2],
          dateParts[1] - 1,
          dateParts[0]
        ).toISOString(); // month is 0-based
        return dateObject;
      }
    }

    $scope.validateEmail = function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.VIDA) {
        if (
          $scope.caratula.subramo.subramo_name == "Vida" ||
          $scope.caratula.subramo.subramo_name == "Funerarios"
        ) {
          $scope.beneficiaries_life = [];
          $scope.excelJson = param.VIDA;
          $scope.excelJson.forEach(function (item) {
            if (!item.FAMILIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FAMILIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CERTIFICADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.TIPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.TIPO < 1 || item.TIPO > 2) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.PARENTESCO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PARENTESCO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.PARENTESCO < 1 || item.PARENTESCO > 4) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PARENTESCO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.NOMBRE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_PATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_MATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.FECHA_NACIMIENTO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SEXO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SEXO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (item.SEXO.length > 1) {
                SweetAlert.swal(
                  "Error",
                  "Los valores de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO no son válidos, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.FECHA_ANTIGUEDAD) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_ANTIGUEDAD)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.TIPO_SUMA_ASEGURADA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO_SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO_SUMA_ASEGURADA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (
                  item.TIPO_SUMA_ASEGURADA < 1 ||
                  item.TIPO_SUMA_ASEGURADA > 2
                ) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO_SUMA_ASEGURADA no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.SUMA_ASEGURADA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SUELDO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUELDO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.FUMADOR) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FUMADOR, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.FUMADOR)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FUMADOR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.FUMADOR < 0 || item.FUMADOR > 1) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FUMADOR no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}

            if (item.TIPO == 2) {
              var dataBeneficiary = {
                familia: item.FAMILIA,
                certificate: item.CERTIFICADO,
                optional_relationship: item.PARENTESCO,
                first_name: item.NOMBRE,
                last_name: item.APELLIDO_PATERNO,
                second_last_name: item.APELLIDO_MATERNO,
                birthdate: toDate(item.FECHA_NACIMIENTO),
                sex: item.SEXO,
                antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                percentage: 0,
              };
              $scope.beneficiaries_life.push(dataBeneficiary);
            }
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.ASEGURADOS) {
        $scope.contributory = false;
        if ($scope.caratula.ramo.ramo_name == "Accidentes y Enfermedades") {
          $scope.beneficiaries_medical = [];
          $scope.excelJson = param.ASEGURADOS;
          $scope.excelJson.forEach(function (item) {
            if ("RFC_CVE" in item) {
              $scope.contributory = true;
            }
            if (!item.FAMILIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FAMILIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CERTIFICADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.TIPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.TIPO < 1 || item.TIPO > 2) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.PARENTESCO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PARENTESCO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.PARENTESCO < 1 || item.PARENTESCO > 4) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PARENTESCO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.NOMBRE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_PATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_MATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.FECHA_NACIMIENTO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SEXO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SEXO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (item.SEXO.length > 1) {
                SweetAlert.swal(
                  "Error",
                  "Los valores de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO no son válidos, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.FECHA_ANTIGUEDAD) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_ANTIGUEDAD)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}

            if (item.TIPO == 2) {
              var dataBeneficiary = {
                familia: item.FAMILIA,
                certificate: item.CERTIFICADO,
                relationship: item.PARENTESCO ? parseInt(item.PARENTESCO) : 4,
                first_name: item.NOMBRE,
                last_name: item.APELLIDO_PATERNO,
                second_last_name: item.APELLIDO_MATERNO,
                birthdate: toDate(item.FECHA_NACIMIENTO),
                sex: item.SEXO,
                antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                clause: item.FAMILIA,
                p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                rpf: item.RPF ? item.RPF : 0,
                derecho: item.DERECHO ? item.DERECHO : 0,
                iva: item.IVA ? item.IVA : 0,
                p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
                comision: item.COMISION ? item.COMISION : 0,
                contributory: $scope.contributory ? $scope.contributory : false,
                rfc_cve: item.RFC_CVE ? item.RFC_CVE : "",
                rfc_homocve: item.RFC_HOMOCVE ? item.RFC_HOMOCVE : "",
                dom_callenum: item.DOM_CALLE_NUM ? item.DOM_CALLE_NUM : "",
                dom_colonia: item.DOM_COLONIA ? item.DOM_COLONIA : "",
                dom_cp: item.DOM_CP ? item.DOM_CP : "",
                dom_poblacion: item.DOM_POBLACION ? item.DOM_POBLACION : "",
                dom_estado: item.DOM_ESTADO ? item.DOM_ESTADO : "",
              };
              $scope.beneficiaries_medical.push(dataBeneficiary);
            }
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.FLOTILLA) {
        if ($scope.caratula.subramo.subramo_name == "Automóviles") {
          $scope.excelJson = param.FLOTILLA;
          $scope.excelJson.forEach(function (item) {
            if (!item.INCISO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.MARCA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MODELO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.AÑO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna AÑO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SERVICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERVICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.PROCEDENCIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PROCEDENCIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.PROCEDENCIA < 0 || item.PROCEDENCIA > 4) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PROCEDENCIA no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.USO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna USO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.USO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.USO < 1 || item.USO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.VERSION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SERIE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          } else {
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.DANIOS_DIVERSO) {
        if ($scope.caratula.subramo.subramo_name == "Diversos") {
          $scope.excelJson = param.DANIOS_DIVERSO;
          $scope.excelJson.forEach(function (item) {
            if (!item.INCISO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.MARCA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MODELO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.DESCRIPCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DESCRIPCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.AÑO_CONSTRUCCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna AÑO_CONSTRUCCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.AÑO_RECONSTRUCCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna AÑO_RECONSTRUCCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.VALOR_COMPRA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VALOR_COMPRA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.USO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna USO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.USO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.USO < 1 || item.USO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.VERSION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SERIE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.DANIOS_IRC) {
        if (
          $scope.caratula.subramo.subramo_name == "Incendio" ||
          $scope.dataCaratula.subramo.subramo_name == "Responsabilidad Civil"
        ) {
          $scope.excelJson = param.DANIOS_IRC;
          $scope.excelJson.forEach(function (item) {
            if (!item.INCISO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUCURSAL) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUCURSAL, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.GIRO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna GIRO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.TIPO_CONSTRUCTIVO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO_CONSTRUCTIVO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO_CONSTRUCTIVO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_CONSTRUCTIVO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.TIPO_CONSTRUCTIVO < 1 || item.TIPO_CONSTRUCTIVO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO_CONSTRUCTIVO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.NO_NIVELES) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_NIVELES, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.ZONA_FHM) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ZONA_FHM, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.ZONA_TYEV) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ZONA_TYEV, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CALLE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CALLE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.NO_INTERIOR) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_INTERIOR, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.NO_EXTERIOR) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_EXTERIOR, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MUNICIPIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MUNICIPIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.COLONIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna COLONIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CIUDAD) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CIUDAD, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.ESTADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ESTADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CP) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CP, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.validateExcelUpdateEmails = function (param) {
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.CERTIFICADOS) {
        $scope.beneficiaries_life = [];
        $scope.excelJson = param.CERTIFICADOS;
        $scope.excelJson.forEach(function (item) {
          if (!item["CERTIFICADO(TITULAR)"]) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna FAMILIA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.EMAIL) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
        });
        if (!flagCertificate) {
          $scope.selectedCertificates = param;
          $scope.showTableUpdateEmails = true;
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          if (item.AÑO_CONSTRUCCION) {
            item.ANO_CONSTRUCCION = item.AÑO_CONSTRUCCION;
            item.ANO_RECONSTRUCCION = item.AÑO_RECONSTRUCCION;
          }
          if (item.AÑO) {
            item.ANO = item.AÑO;
          }
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.cancelCertificates = function () {
      $scope.errorMensaje = "";
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.certificados = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.cancelUpdateEmails = function () {
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
      $scope.showTableUpdateEmails = false;
    };

    $scope.saveUpdateEmails = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loader = true;
      $scope.certifcados = [];

      var payload = $scope.selectedCertificates.CERTIFICADOS;
      payload = payload.map(function (item) {
        var obj = {
          certificado: item["CERTIFICADO(TITULAR)"],
          email: item["EMAIL"],
          caratula: $scope.caratula.id,
        };
        return obj;
      });
      console.log(payload);

      $http({
        method: "POST",
        url: url.IP + "emails-certificates/",
        data: payload,
      })
        .then(function success(response) {
          l.stop();
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal("¡Listo!", MESSAGES.OK.CERTIFICATESDONE, "success");
            activate();
            $scope.cancelCertificates();
            $scope.showItemCertificate(4);
          } else {
            $scope.loader = false;
            SweetAlert.swal("ERROR", response.data.data, "error");
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error", e);
        });
    };

    $scope.checkNumSerie = function (serial) {
      if (serial) {
        helpers
          .existSerial(serial)
          .then(function (request) {
            if (request.exist == true) {
              SweetAlert.swal(
                "Información",
                "La SERIE del AUTO ya existe en otra póliza vigente: " +
                  request.poliza,
                "info"
              );
              // order.subforms.auto.serial = '';
            }
          })
          .catch(function (err) {});
      }
    };
    $scope.saveCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loader = true;
      $scope.certifcados = [];

      if ($scope.selectedCertificates.VIDA) {
        $scope.selectedCertificates.VIDA.forEach(function (item) {
          $scope.tipoUpload = item.TIPO;
          $scope.item = item;
          if (item.TIPO == 1) {
            var dataLife = [
              {
                personal: {
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: toDate(item.FECHA_NACIMIENTO),
                  antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  salary: item.SUELDO ? parseInt(item.SUELDO) : 0,
                  sum_assured: item.SUMA_ASEGURADA
                    ? parseInt(item.SUMA_ASEGURADA)
                    : 0,
                  type_sa: item.TIPO_SUMA_ASEGURADA
                    ? parseInt(item.TIPO_SUMA_ASEGURADA)
                    : 0,
                },
                smoker: item.FUMADOR
                  ? item.FUMADOR == 0
                    ? false
                    : true
                  : null,
                beneficiaries_life: [],
              },
            ];

            $scope.beneficiaries_life.forEach(function (beneficiarie) {
              if (beneficiarie.familia == item.FAMILIA) {
                dataLife[0].beneficiaries_life.push(beneficiarie);
              }
            });

            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            if (item.SUBGRUPO) {
              $scope.subgrupos.forEach(function (itemSubgrupo) {
                if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                  if (itemSubgrupo.address) {
                    contractor_certificate = itemSubgrupo.contractor
                      ? itemSubgrupo.contractor.id
                      : null;
                  } else {
                    contractor_certificate = $scope.caratula.contractor
                      ? $scope.caratula.contractor
                      : null;
                  }
                }
              });
            } else {
              contractor_certificate = $scope.caratula.contractor
                ? $scope.caratula.contractor
                : null;
            }

            var certificateData = {
              caratula: $scope.caratula.id,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number:
                $scope.caratula.poliza_number + " - INC. " + item.CERTIFICADO,
              contractor: contractor_certificate,
              ramo: $scope.caratula.ramo.id,
              subramo: $scope.caratula.subramo.id,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: toDate(item.VIGENCIA_INICIO),
              end_of_validity: toDate(item.VIGENCIA_FIN),
              status: $scope.caratula.status == "Vigente" ? 14 : 1,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: [],
              life_policy: dataLife,
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "VIDA_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
              rpf: item.RPF ? item.RPF : 0,
              derecho: item.DERECHO ? item.DERECHO : 0,
              iva: item.IVA ? item.IVA : 0,
              p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
              comision: item.COMISION ? item.COMISION : 0,
              rec_antiguedad: toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
            };

            $scope.certifcados.push(certificateData);
            $scope.allCerificatesCaratula.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.ASEGURADOS) {
        $scope.selectedCertificates.ASEGURADOS.forEach(function (item) {
          $scope.tipoUpload = item.TIPO;
          $scope.sum_neta = 0;
          $scope.sum_rpf = 0;
          $scope.sum_derecho = 0;
          $scope.sum_iva = 0;
          $scope.sum_total = 0;
          $scope.sum_comision = 0;
          if (item.TIPO == 1) {
            var dataMedical = [
              {
                personal: {
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: toDate(item.FECHA_NACIMIENTO),
                  antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                  rpf: item.RPF ? item.RPF : 0,
                  derecho: item.DERECHO ? item.DERECHO : 0,
                  iva: item.IVA ? item.IVA : 0,
                  p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
                  comision: item.COMISION ? item.COMISION : 0,
                  contributory: $scope.contributory
                    ? $scope.contributory
                    : false,
                  rfc_cve: item.RFC_CVE ? item.RFC_CVE : "",
                  rfc_homocve: item.RFC_HOMOCVE ? item.RFC_HOMOCVE : "",
                  dom_callenum: item.DOM_CALLE_NUM ? item.DOM_CALLE_NUM : "",
                  dom_colonia: item.DOM_COLONIA ? item.DOM_COLONIA : "",
                  dom_cp: item.DOM_CP ? item.DOM_CP : "",
                  dom_poblacion: item.DOM_POBLACION ? item.DOM_POBLACION : "",
                  dom_estado: item.DOM_ESTADO ? item.DOM_ESTADO : "",
                },
                disease_type: 0,
                relationship_accident: [],
              },
            ];

            $scope.sum_neta = dataMedical[0].personal.p_neta;
            $scope.sum_rpf = dataMedical[0].personal.rpf;
            $scope.sum_derecho = dataMedical[0].personal.derecho;
            $scope.sum_iva = dataMedical[0].personal.iva;
            $scope.sum_total = dataMedical[0].personal.p_total;
            $scope.sum_comision = dataMedical[0].personal.comision;

            $scope.beneficiaries_medical.forEach(function (beneficiarie) {
              if (beneficiarie.familia == item.FAMILIA) {
                beneficiarie.sex = beneficiarie.sex;
                dataMedical[0].relationship_accident.push(beneficiarie);
                $scope.sum_neta = parseFloat(
                  parseFloat($scope.sum_neta) + parseFloat(item.PRIMA_NETA)
                ).toFixed(2);
                $scope.sum_rpf = parseFloat(
                  parseFloat($scope.sum_rpf) + parseFloat(item.RPF)
                ).toFixed(2);
                $scope.sum_derecho = parseFloat(
                  parseFloat($scope.sum_derecho) + parseFloat(item.DERECHO)
                ).toFixed(2);
                $scope.sum_iva = parseFloat(
                  parseFloat($scope.sum_iva) + parseFloat(item.IVA)
                ).toFixed(2);
                $scope.sum_total = parseFloat(
                  parseFloat($scope.sum_total) + parseFloat(item.PRIMA_TOTAL)
                ).toFixed(2);
                $scope.sum_comision = parseFloat(
                  parseFloat($scope.sum_comision) + parseFloat(item.COMISION)
                ).toFixed(2);
              }
            });

            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            if (item.SUBGRUPO) {
              $scope.subgrupos.forEach(function (itemSubgrupo) {
                if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                  if (itemSubgrupo.address) {
                    contractor_certificate = itemSubgrupo.contractor
                      ? itemSubgrupo.contractor.id
                      : null;
                  } else {
                    contractor_certificate = $scope.caratula.contractor
                      ? $scope.caratula.contractor
                      : null;
                  }
                }
              });
            } else {
              contractor_certificate = $scope.caratula.contractor
                ? $scope.caratula.contractor
                : null;
            }

            var certificateData = {
              caratula: $scope.caratula.id,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number:
                $scope.caratula.poliza_number + " - INC. " + item.CERTIFICADO,
              contractor: contractor_certificate,
              ramo: $scope.caratula.ramo.id,
              subramo: $scope.caratula.subramo.id,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: toDate(item.VIGENCIA_INICIO),
              end_of_validity: toDate(item.VIGENCIA_FIN),
              status: $scope.caratula.status == "Vigente" ? 14 : 1,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: dataMedical,
              life_policy: [],
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "GASTOS_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: $scope.sum_neta
                ? parseFloat($scope.sum_neta).toFixed(2)
                : item.PRIMA_NETA
                ? parseFloat(item.PRIMA_NETA).toFixed(2)
                : 0,
              rpf: $scope.sum_rpf
                ? parseFloat($scope.sum_rpf).toFixed(2)
                : item.RPF
                ? parseFloat(item.RPF).toFixed(2)
                : 0,
              derecho: $scope.sum_derecho
                ? parseFloat($scope.sum_derecho).toFixed(2)
                : item.DERECHO
                ? parseFloat(item.DERECHO).toFixed(2)
                : 0,
              iva: $scope.sum_iva
                ? parseFloat($scope.sum_iva).toFixed(2)
                : item.IVA
                ? parseFloat(item.IVA).toFixed(2)
                : 0,
              p_total: $scope.sum_total
                ? parseFloat($scope.sum_total).toFixed(2)
                : item.PRIMA_TOTAL
                ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                : 0,
              comision: $scope.sum_comision
                ? parseFloat($scope.sum_comision).toFixed(2)
                : item.COMISION
                ? parseFloat(item.COMISION).toFixed(2)
                : 0,
              rec_antiguedad: toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
              contributory: $scope.contributory,
            };
            $scope.certifcados.push(certificateData);
            $scope.allCerificatesCaratula.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.FLOTILLA) {
        $scope.selectedCertificates.FLOTILLA.forEach(function (item) {
          var dataCar = [
            {
              car_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              driver: item.CONDUCTOR ? item.CONDUCTOR : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              brand: item.MARCA,
              model: item.MODELO,
              year: item.AÑO,
              version: item.VERSION,
              serial: item.SERIE,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              license_plates: item.MATRICULA ? item.MATRICULA : null,
              usage: parseInt(item.USO),
              service: item.SERVICIO,
              procedencia: parseInt(item.PROCEDENCIA),
              sum_insured: item.VALOR_O_SUMA_ASEGURADA
                ? item.VALOR_O_SUMA_ASEGURADA
                : null,
              charge_type: item.TIPO_CARGA ? parseInt(item.TIPO_CARGA) : null,
              adjustment: item.ADAPTACIONES ? item.ADAPTACIONES : null,
              mont_adjustment: item.MONTO_ADAPTACIONES
                ? item.MONTO_ADAPTACIONES
                : null,
              special_team: item.EQUIPAMIENTO ? item.EQUIPAMIENTO : null,
              mont_special_team: item.MONTO_EQUIPAMIENTO
                ? item.MONTO_EQUIPAMIENTO
                : null,
              beneficiary_name: null,
              preferential_benefiaciary: item.BENEFICIARIO_PREFERENTE
                ? item.BENEFICIARIO_PREFERENTE
                : null,
              beneficiary_rfc: item.BENEFICIARIO_RFC
                ? item.BENEFICIARIO_RFC
                : null,
              beneficiary_address: item.BENEFICIARIO_DIRECCION
                ? item.BENEFICIARIO_DIRECCION
                : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.subgrupos.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.caratula.contractor
                    ? $scope.caratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.caratula.contractor
              ? $scope.caratula.contractor
              : null;
          }

          var certificateData = {
            caratula: $scope.caratula.id,
            certificate_number: item.INCISO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number:
              $scope.caratula.poliza_number + " - INC. " + item.INCISO,
            contractor: contractor_certificate,
            ramo: $scope.caratula.ramo.id,
            subramo: $scope.caratula.subramo.id,
            paquete: item.PAQUETE,
            observations: "",
            old_policies: [],
            start_of_validity: toDate(item.VIGENCIA_INICIO),
            end_of_validity: toDate(item.VIGENCIA_FIN),
            status: $scope.caratula.status == "Vigente" ? 14 : 1,
            automobiles_policy: dataCar,
            damages_policy: [],
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
            rpf: item.RPF ? item.RPF : 0,
            derecho: item.DERECHO ? item.DERECHO : 0,
            iva: item.IVA ? item.IVA : 0,
            p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
            comision: item.COMISION ? item.COMISION : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      } else if (
        $scope.selectedCertificates.DANIOS_DIVERSO ||
        $scope.selectedCertificates.DANIOS_IRC
      ) {
        var excelJson = [];
        if ($scope.selectedCertificates.DANIOS_DIVERSO) {
          excelJson = $scope.selectedCertificates.DANIOS_DIVERSO;
        } else if ($scope.selectedCertificates.DANIOS_IRC) {
          excelJson = $scope.selectedCertificates.DANIOS_IRC;
        }
        excelJson.forEach(function (item) {
          var dataDamage = [
            {
              dam_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              item_details: item.OBSERVACIONES
                ? item.OBSERVACIONES
                : item.DESCRIPCION
                ? item.DESCRIPCION
                : "",
              usage: item.USO ? parseInt(item.USO) : 0,
              brand: item.MARCA ? item.MARCA : null,
              model: item.MODELO ? item.MODELO : null,
              construction_year: item.AÑO_CONSTRUCCION
                ? item.AÑO_CONSTRUCCION
                : null,
              reconstruction_year: item.AÑO_RECONSTRUCCION
                ? item.AÑO_RECONSTRUCCION
                : null,
              version: item.VERSION ? item.VERSION : null,
              serial: item.SERIE ? item.SERIE : null,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              matricula: item.MATRICULA ? item.MATRICULA : null,
              permiso: item.PERMISO ? item.PERMISO : null,
              purchase_value: item.VALOR_COMPRA
                ? parseInt(item.VALOR_COMPRA)
                : 0,
              item_address:
                item.CALLE +
                " " +
                item.NO_INTERIOR +
                " Ext." +
                item.NO_EXTERIOR +
                " " +
                item.COLONIA +
                " " +
                item.CIUDAD +
                " " +
                item.ESTADO +
                " C.P." +
                item.CP,
              sucursal: item.SUCURSAL ? item.SUCURSAL : null,
              giro: item.GIRO ? item.GIRO : null,
              type_construction: item.TIPO_CONSTRUCTIVO
                ? parseInt(item.TIPO_CONSTRUCTIVO)
                : 0,
              no_levels: item.NO_NIVELES ? item.NO_NIVELES : null,
              fhm_zone: item.ZONA_FHM ? item.ZONA_FHM : null,
              tyev_zone: item.ZONA_TYEV ? item.ZONA_TYEV : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.subgrupos.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.caratula.contractor
                    ? $scope.caratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.caratula.contractor
              ? $scope.caratula.contractor
              : null;
          }

          var certificateData = {
            caratula: $scope.caratula.id,
            certificate_number: item.INCISO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number:
              $scope.caratula.poliza_number + " - INC. " + item.INCISO,
            contractor: contractor_certificate,
            ramo: $scope.caratula.ramo.id,
            subramo: $scope.caratula.subramo.id,
            paquete: item.PAQUETE,
            observations: "",
            old_policies: [],
            start_of_validity: toDate(item.VIGENCIA_INICIO),
            end_of_validity: toDate(item.VIGENCIA_FIN),
            status: $scope.caratula.status == "Vigente" ? 14 : 1,
            automobiles_policy: [],
            damages_policy: dataDamage,
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
            rpf: item.RPF ? item.RPF : 0,
            derecho: item.DERECHO ? item.DERECHO : 0,
            iva: item.IVA ? item.IVA : 0,
            p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
            comision: item.COMISION ? item.COMISION : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      }
      // Dependientes
      if ($scope.selectedCertificates.ASEGURADOS) {
        $scope.certifcadosDependientes = [];
        if ($scope.tipoUpload == 2) {
          $scope.certifcadosDependientes = [];
          $scope.allCerificatesCaratula.forEach(function (certExistentes) {
            $scope.upd_neta = certExistentes.p_neta
              ? parseFloat(certExistentes.p_neta).toFixed(2)
              : 0;
            $scope.upd_rpf = certExistentes.rpf
              ? parseFloat(certExistentes.rpf).toFixed(2)
              : 0;
            $scope.upd_derecho = certExistentes.derecho
              ? parseFloat(certExistentes.derecho).toFixed(2)
              : 0;
            $scope.upd_iva = certExistentes.iva
              ? parseFloat(certExistentes.iva).toFixed(2)
              : 0;
            $scope.upd_total = certExistentes.p_total
              ? parseFloat(certExistentes.p_total).toFixed(2)
              : 0;
            $scope.upd_comision = certExistentes.comision
              ? parseFloat(certExistentes.comision).toFixed(2)
              : 0;
            if (
              certExistentes.accidents_policy &&
              certExistentes.accidents_policy[0] &&
              certExistentes.accidents_policy[0].relationship_accident.length >
                0
            ) {
              certExistentes.accidents_policy[0].relationship_accident.forEach(
                function (depExistente) {
                  var full = depExistente.full_name;
                  $scope.beneficiaries_medical.forEach(function (
                    denpendientes
                  ) {
                    var full_to_add =
                      denpendientes.first_name +
                      " " +
                      denpendientes.last_name +
                      " " +
                      denpendientes.second_last_name;
                    if (
                      denpendientes.familia == certExistentes.certificate_number
                    ) {
                      $scope.certExistente = certExistentes;
                      if (
                        (!denpendientes.url ||
                          denpendientes.url == undefined) &&
                        full != full_to_add
                      ) {
                        denpendientes.birthdate = denpendientes.birthdate
                          ? denpendientes.birthdate
                          : null;
                        denpendientes.antiguedad = denpendientes.antiguedad
                          ? denpendientes.antiguedad
                          : null;
                        denpendientes.accident =
                          $scope.certExistente.accidents_policy[0].url;
                        denpendientes.relationship =
                          denpendientes.relationship &&
                          denpendientes.relationship.value
                            ? denpendientes.relationship.value
                            : denpendientes.relationship
                            ? denpendientes.relationship
                            : 4;
                        denpendientes.certificate = denpendientes.certificate
                          ? denpendientes.certificate
                          : certExistentes.certificate_number
                          ? certExistentes.certificate_number
                          : "";
                        denpendientes.p_neta = denpendientes.p_neta
                          ? parseFloat(denpendientes.p_neta).toFixed(2)
                          : 0;
                        denpendientes.rpf = denpendientes.rpf
                          ? parseFloat(denpendientes.rpf).toFixed(2)
                          : 0;
                        denpendientes.derecho = denpendientes.derecho
                          ? parseFloat(denpendientes.derecho).toFixed(2)
                          : 0;
                        denpendientes.iva = denpendientes.iva
                          ? parseFloat(denpendientes.iva).toFixed(2)
                          : 0;
                        denpendientes.p_total = denpendientes.p_total
                          ? parseFloat(denpendientes.p_total).toFixed(2)
                          : 0;
                        denpendientes.comision = denpendientes.comision
                          ? parseFloat(denpendientes.comision).toFixed(2)
                          : 0;
                        if (denpendientes.sex && denpendientes.sex.value) {
                          denpendientes.sex = denpendientes.sex.value;
                        }
                        generalService
                          .createRelationship(denpendientes)
                          .then(function (resRelation) {
                            denpendientes.familia = "";
                            denpendientes.url = resRelation.data.url;
                            $scope.show_beneficiarie = false;
                            $scope.beneficiaries_medical.splice(
                              $scope.beneficiaries_medical.indexOf(
                                denpendientes
                              ),
                              1
                            );
                            // Sumas
                            $scope.upd_neta = parseFloat(
                              parseFloat($scope.upd_neta) +
                                parseFloat(resRelation.data.p_neta)
                            ).toFixed(2);
                            $scope.upd_rpf = parseFloat(
                              parseFloat($scope.upd_rpf) +
                                parseFloat(resRelation.data.rpf)
                            ).toFixed(2);
                            $scope.upd_derecho = parseFloat(
                              parseFloat($scope.upd_derecho) +
                                parseFloat(resRelation.data.derecho)
                            ).toFixed(2);
                            $scope.upd_iva = parseFloat(
                              parseFloat($scope.upd_iva) +
                                parseFloat(resRelation.data.iva)
                            ).toFixed(2);
                            $scope.upd_total = parseFloat(
                              parseFloat($scope.upd_total) +
                                parseFloat(resRelation.data.p_total)
                            ).toFixed(2);
                            $scope.upd_comision = parseFloat(
                              parseFloat($scope.upd_comision) +
                                parseFloat(resRelation.data.comision)
                            ).toFixed(2);
                            // Update data primas
                            var jsonUpdate = {
                              p_neta: $scope.upd_neta
                                ? parseFloat($scope.upd_neta).toFixed(2)
                                : certExistentes.p_neta
                                ? parseFloat(certExistentes.p_neta).toFixed(2)
                                : 0,
                              rpf: $scope.upd_rpf
                                ? parseFloat($scope.upd_rpf).toFixed(2)
                                : certExistentes.rpf
                                ? parseFloat(certExistentes.rpf).toFixed(2)
                                : 0,
                              derecho: $scope.upd_derecho
                                ? parseFloat($scope.upd_derecho).toFixed(2)
                                : certExistentes.derecho
                                ? parseFloat(certExistentes.derecho).toFixed(2)
                                : 0,
                              iva: $scope.upd_iva
                                ? parseFloat($scope.upd_iva).toFixed(2)
                                : certExistentes.iva
                                ? parseFloat(certExistentes.iva).toFixed(2)
                                : 0,
                              p_total: $scope.upd_total
                                ? parseFloat($scope.upd_total).toFixed(2)
                                : certExistentes.p_total
                                ? parseFloat(certExistentes.p_total).toFixed(2)
                                : 0,
                              comision: $scope.upd_comision
                                ? parseFloat($scope.upd_comision).toFixed(2)
                                : certExistentes.comision
                                ? parseFloat(certExistentes.comision).toFixed(2)
                                : 0,
                            };
                            $http
                              .patch(certExistentes.url, jsonUpdate)
                              .then(function success(request) {
                                if (request.status === 200) {
                                }
                              })
                              .catch(function (e) {
                                console.log("error", e);
                              });
                          });
                      }
                    }
                  });
                }
              );
            } else {
              $scope.beneficiaries_medical.forEach(function (denpendientes) {
                if (
                  denpendientes.familia == certExistentes.certificate_number
                ) {
                  $scope.certExistente = certExistentes;
                  if (!denpendientes.url || denpendientes.url == undefined) {
                    if (denpendientes.sex && denpendientes.sex.value) {
                      denpendientes.sex = denpendientes.sex.value;
                    }
                    denpendientes.birthdate = denpendientes.birthdate
                      ? denpendientes.birthdate
                      : null;
                    denpendientes.antiguedad = denpendientes.antiguedad
                      ? denpendientes.antiguedad
                      : null;
                    denpendientes.accident =
                      $scope.certExistente.accidents_policy[0].url;
                    denpendientes.relationship = denpendientes.relationship
                      ? denpendientes.relationship.value
                      : 0;
                    denpendientes.sex = denpendientes.sex
                      ? denpendientes.sex.value
                      : "M";
                    denpendientes.certificate = denpendientes.certificate
                      ? denpendientes.certificate
                      : certExistentes.certificate_number
                      ? certExistentes.certificate_number
                      : "";
                    denpendientes.p_neta = denpendientes.p_neta
                      ? parseFloat(denpendientes.p_neta).toFixed(2)
                      : 0;
                    denpendientes.rpf = denpendientes.rpf
                      ? parseFloat(denpendientes.rpf).toFixed(2)
                      : 0;
                    denpendientes.derecho = denpendientes.derecho
                      ? parseFloat(denpendientes.derecho).toFixed(2)
                      : 0;
                    denpendientes.iva = denpendientes.iva
                      ? parseFloat(denpendientes.iva).toFixed(2)
                      : 0;
                    denpendientes.p_total = denpendientes.p_total
                      ? parseFloat(denpendientes.p_total).toFixed(2)
                      : 0;
                    denpendientes.comision = denpendientes.comision
                      ? parseFloat(denpendientes.comision).toFixed(2)
                      : 0;
                    generalService
                      .createRelationship(denpendientes)
                      .then(function (resRelation) {
                        denpendientes.familia = "";
                        denpendientes.url = resRelation.data.url;
                        $scope.show_beneficiarie = false;
                        $scope.beneficiaries_medical.splice(
                          $scope.beneficiaries_medical.indexOf(denpendientes),
                          1
                        );
                        // Sumas
                        $scope.upd_neta = parseFloat(
                          parseFloat($scope.upd_neta) +
                            parseFloat(resRelation.data.p_neta)
                        ).toFixed(2);
                        $scope.upd_rpf = parseFloat(
                          parseFloat($scope.upd_rpf) +
                            parseFloat(resRelation.data.rpf)
                        ).toFixed(2);
                        $scope.upd_derecho = parseFloat(
                          parseFloat($scope.upd_derecho) +
                            parseFloat(resRelation.data.derecho)
                        ).toFixed(2);
                        $scope.upd_iva = parseFloat(
                          parseFloat($scope.upd_iva) +
                            parseFloat(resRelation.data.iva)
                        ).toFixed(2);
                        $scope.upd_total = parseFloat(
                          parseFloat($scope.upd_total) +
                            parseFloat(resRelation.data.p_total)
                        ).toFixed(2);
                        $scope.upd_comision = parseFloat(
                          parseFloat($scope.upd_comision) +
                            parseFloat(resRelation.data.comision)
                        ).toFixed(2);
                        // Update data primas
                        var jsonUpdate = {
                          p_neta: $scope.upd_neta
                            ? parseFloat($scope.upd_neta).toFixed(2)
                            : certExistentes.p_neta
                            ? parseFloat(certExistentes.p_neta).toFixed(2)
                            : 0,
                          rpf: $scope.upd_rpf
                            ? parseFloat($scope.upd_rpf).toFixed(2)
                            : certExistentes.rpf
                            ? parseFloat(certExistentes.rpf).toFixed(2)
                            : 0,
                          derecho: $scope.upd_derecho
                            ? parseFloat($scope.upd_derecho).toFixed(2)
                            : certExistentes.derecho
                            ? parseFloat(certExistentes.derecho).toFixed(2)
                            : 0,
                          iva: $scope.upd_iva
                            ? parseFloat($scope.upd_iva).toFixed(2)
                            : certExistentes.iva
                            ? parseFloat(certExistentes.iva).toFixed(2)
                            : 0,
                          p_total: $scope.upd_total
                            ? parseFloat($scope.upd_total).toFixed(2)
                            : certExistentes.p_total
                            ? parseFloat(certExistentes.p_total).toFixed(2)
                            : 0,
                          comision: $scope.upd_comision
                            ? parseFloat($scope.upd_comision).toFixed(2)
                            : certExistentes.comision
                            ? parseFloat(certExistentes.comision).toFixed(2)
                            : 0,
                        };
                        $http
                          .patch(certExistentes.url, jsonUpdate)
                          .then(function success(request) {
                            if (request.status === 200) {
                            }
                          })
                          .catch(function (e) {
                            console.log("error", e);
                          });
                      });
                  }
                }
              });
            }
          });
        }
      }
      // Beneficiarios
      if ($scope.selectedCertificates.VIDA) {
        $scope.certifcadosDependientes = [];
        if ($scope.tipoUpload == 2) {
          $scope.certifcadosDependientes = [];
          $scope.allCerificatesCaratula.forEach(function (certExistentes) {
            $scope.beneficiaries_life.forEach(function (element) {
              if (element.familia == certExistentes.certificate_number) {
                $scope.certExistente = certExistentes;
                if (!element.url || element.url == undefined) {
                  element.life = $scope.certExistente.life_policy[0].url;
                  element.birthdate = element.birthdate
                    ? element.birthdate
                    : null;
                  element.optional_relationship = element.optional_relationship
                    ? element.optional_relationship
                    : 0;
                  element.full_name =
                    element.first_name +
                    " " +
                    element.last_name +
                    " " +
                    element.second_last_name;
                  element.sex = element.sex ? element.sex : "M";
                  element.antiguedad = element.antiguedad
                    ? element.antiguedad
                    : null;
                  generalService
                    .createBeneficiaries(element)
                    .then(function (resRelation) {
                      element.familia = "";
                      element.url = resRelation.data.url;
                      $scope.show_beneficiarie = false;
                      var indice = $scope.beneficiaries_life.indexOf(element); // obtenemos el indice
                      $scope.beneficiaries_life =
                        $scope.beneficiaries_life.splice(indice, 1); // 1 es la cantidad de elemento a eliminar
                      $scope.certifcadosDependientes.push(resRelation.data);
                    });
                }
              }
            });
          });
        }
      }
      if (
        $scope.caratula.subramo.subramo_name == "Automóviles" ||
        $scope.caratula.subramo.subramo_code == 9
      ) {
        $scope.evaluateCertificates($scope.certifcados);
      } else {
        $scope.saveOKGral($scope.certifcados);
      }
    };
    $scope.saveOKGral = function (certificados) {
      $scope.errorMensaje = "";
      SweetAlert.close();
      $scope.certifcados = certificados;
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $http({
        method: "POST",
        url: url.IP + "mass-certificates/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          l.stop();
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal("¡Listo!", MESSAGES.OK.CERTIFICATESDONE, "success");
            activate();
            $scope.cancelCertificates();
            $scope.showItemCertificate(4);
          } else {
            $scope.loader = false;
            var errorMessage =
              response.data && response.data.data
                ? response.data.data
                : response.data
                ? response.data
                : "Revise los datos de carga.";
            $scope.alerta(errorMessage);
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error", e);
        });
    };
    $scope.alerta = function (mensaje) {
      $scope.errorMensaje = mensaje;
    };
    $scope.selectCerficate = function (item) {
      $scope.showItemCertificate(2);
      $scope.certificate = item;
      if ($scope.certificate.paquete) {
        $http({
          method: "GET",
          url: $scope.certificate.paquete,
        })
          .then(function success(response) {
            $scope.packageCertificate = response.data;
          })
          .catch(function (e) {
            l.stop();
            console.log("error", e);
          });
      }
      $http
        .get(url.IP + "polizas/" + item.id + "/archivos/")
        .then(function (response) {
          item.files = response.data.results;
        })
        .catch(function (e) {
          console.log("error", e);
        });

      if ($scope.caratula.receipts_by == 3) {
        $scope.total_prima_certificate = 0;
        $scope.total_rpf_certificate = 0;
        $scope.total_derecho_certificate = 0;
        $scope.total_iva_certificate = 0;
        $scope.total_total_certificate = 0;
        $scope.total_comision_certificate = 0;
        item.recibos_poliza.forEach(function (receipt) {
          if (receipt.receipt_type == 5 && receipt.status != 0) {
            $scope.total_prima_certificate =
              parseFloat($scope.total_prima_certificate) +
              parseFloat(receipt.prima_neta);
            $scope.total_rpf_certificate =
              parseFloat($scope.total_rpf_certificate) +
              parseFloat(receipt.rpf);
            $scope.total_derecho_certificate =
              parseFloat($scope.total_derecho_certificate) +
              parseFloat(receipt.derecho);
            $scope.total_iva_certificate =
              parseFloat($scope.total_iva_certificate) +
              parseFloat(receipt.iva);
            $scope.total_total_certificate =
              parseFloat($scope.total_total_certificate) +
              parseFloat(receipt.prima_total);
            $scope.total_comision_certificate =
              parseFloat($scope.total_comision_certificate) +
              parseFloat(receipt.comision);
          }
        });
      }
    };

    $scope.getLogCertificate = function () {
      dataFactory
        .get("get-specific-log", {
          model: 25,
          associated_id: $scope.certificate.id,
        })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/colectivos/log.modal.html",
            controller: LogController,
            size: "lg",
            backdrop: "static",
            keyboard: false,
            resolve: {
              log: function () {
                return response.data;
              },
            },
          });
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    function LogController($scope, $uibModalInstance, log) {
      $scope.logs = log;

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    function DeleteElementController(
      $scope,
      $uibModalInstance,
      log,
      valores,
      item,
      tipo,
      caratula,
      copy_policy_history
    ) {
      $scope.aeliminar = log;
      $scope.lista = valores;
      $scope.tipo = tipo;
      $scope.itemDelete = item;
      $scope.caratula = caratula;
      $scope.copy_policy_history = copy_policy_history;
      // 1------subgrupo,2-categoria,c3--ertificado
      $scope.okay = function (x) {
        var texto = "";
        var texto2 = "";
        var texto3 = "";
        if (item.document_type == 3) {
          texto = "Subgrupo";
          texto2 =
            "Se eliminará la Póliza de Grupo, subgrupos, categorías y todas sus dependencias, ¿Estás Seguro?";
          texto3 =
            "Se ha eliminado la Póliza de Grupo " +
            item.name +
            "(" +
            item.id +
            ") y sus relaciones ";
        }
        if (item.document_type == 4) {
          texto = "Subgrupo";
          texto2 =
            "Se eliminará el Subgrupo, categorías y todos sus Certificados, ¿Estás Seguro?";
          texto3 =
            "Se ha eliminado el subgrupo " +
            item.name +
            "(" +
            item.id +
            ") y sus relaciones ";
        }
        if (item.document_type == 5) {
          texto = "Categoría";
          texto2 =
            "Se eliminará la Categoría y todos sus Certificados, ¿Estás Seguro?";
          texto3 =
            "Se ha eliminado la categoría " +
            item.name +
            "(" +
            item.id +
            ") y sus relaciones ";
        }
        if (item.document_type == 6) {
          texto = "Certificado";
          texto2 =
            "Se eliminará el Certificado y sus relaciones, ¿Estás Seguro?";
          texto3 =
            "Se ha eliminado el certificado " +
            item.certificate_number +
            "(" +
            item.id +
            ") y sus relaciones ";
        }
        SweetAlert.swal(
          {
            title: "Eliminar " + texto,
            text: texto2 + "\n",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              // user, org, method, target, identifier, associate_id
              // if(param.categorias.length > 1){
              $http
                .delete(item.url)
                .then(function success(response) {
                  if (response.status == 204) {
                    var paramsLogP_ = {
                      model: 1,
                      event: "PATCH",
                      associated_id: caratula.id,
                      change: log,
                      identifier: texto3,
                    };
                    dataFactory
                      .post("send_log_specific/", paramsLogP_)
                      .then(function success(response) {});
                    var paramsLogP = {
                      model: 1,
                      event: "PATCH",
                      associated_id: caratula.id,
                      change: log,
                      identifier: texto3,
                    };
                    SweetAlert.swal(
                      "¡Listo!",
                      "Se ha eliminado definitivamente el registro",
                      "success"
                    );
                    $uibModalInstance.dismiss("cancel");
                    // dataFactory.post('send_log_specific/', paramsLogP).then(function success(response){
                    //   SweetAlert.swal("¡Listo!", texto3, "success");
                    //   $uibModalInstance.dismiss('cancel');
                    // });
                  } else {
                    $uibModalInstance.dismiss("cancel");
                  }
                })
                .catch(function (e) {
                  console.log("e", e);
                });
              // }else{
              //   SweetAlert.swal("Error", "No se eliminó la categoría porque el subgrupo no puede quedarse sin categorías.", "error");
              // }
            } else {
              $uibModalInstance.dismiss("cancel");
            }
          }
        );
        // $uibModalInstance.dismiss('cancel');
      };
      $scope.deletePGrupo = function (y) {
        var texto = "";
        var texto2 = "";
        var texto3 = "";
        if (
          item.document_type == 3 ||
          item.document_type == "Póliza de Grupo"
        ) {
          texto = "Subgrupo";
          texto2 =
            "Se eliminará la Póliza de Grupo, subgrupos, categorías y todas sus dependencias, ¿Estás Seguro?";
          texto3 =
            "Se ha eliminado la Póliza de Grupo " +
            item.name +
            "(" +
            item.id +
            ") y sus relaciones ";
        }
        SweetAlert.swal(
          {
            title: "Eliminar Póliza de Grupo",
            text: "Los cambios no podrán revertirse, ¿Está seguro?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http
                .post(url.IP + "delete-colectivity/", {
                  id: $scope.caratula.id,
                  logs: log,
                })
                .then(function (response) {
                  if ($scope.copy_policy_history) {
                    if ($scope.copy_policy_history.url) {
                      if (
                        process(
                          convertDate(
                            $scope.copy_policy_history.start_of_validity
                          )
                        ) > process(convertDate(new Date()))
                      ) {
                        var data = {
                          status: 10,
                          renewed_status: 0,
                        };
                      } else {
                        if (
                          process(
                            convertDate(
                              $scope.copy_policy_history.end_of_validity
                            )
                          ) > process(convertDate(new Date()))
                        ) {
                          var data = {
                            status: 14,
                            renewed_status: 0,
                          };
                        } else {
                          var data = {
                            status: 13,
                            renewed_status: 0,
                          };
                        }
                      }
                      function process(date) {
                        var parts = date.split("/");
                        var date = new Date(
                          parts[1] + "/" + parts[0] + "/" + parts[2]
                        );
                        return date.getTime();
                      }
                      $http
                        .patch($scope.copy_policy_history.url, data)
                        .then(function success(request) {
                          if (request.status === 200) {
                            var paramsRec = {
                              model: 18,
                              event: "PATCH",
                              associated_id: $scope.copy_policy_history.id,
                              identifier: " eliminó la renovación.",
                            };
                            dataFactory
                              .post("send-log/", paramsRec)
                              .then(function success(response) {});
                          }
                        })
                        .catch(function (e) {
                          console.log("error", e);
                        });
                    }
                  }
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.DELETECOLLECTIVITY,
                    "success"
                  );

                  var name = "Inicio";
                  var route = "inicio.inicio";
                  $scope.name_for_new_tab = name;
                  $scope.route_for_new_tab = route;

                  var existe = false;
                  if (name && route) {
                    $scope.route_for_new_tab = route;
                    $scope.name_for_new_tab = name;
                    appStates.states.forEach(function (state) {
                      if (state.route == $scope.route_for_new_tab) {
                        existe = true;
                      }
                    });
                  }

                  if (!existe) {
                    var active_tab = appStates.states.findIndex(function (
                      item
                    ) {
                      if (item.active) {
                        return true;
                      }
                      return false;
                    });

                    appStates.states[active_tab] = {
                      name: $scope.name_for_new_tab,
                      heading: $scope.name_for_new_tab,
                      route: $scope.route_for_new_tab,
                      active: true,
                      isVisible: true,
                      href: $state.href($scope.route_for_new_tab),
                    };
                  }
                  $localStorage.tab_states = appStates.states;
                  $state.go($scope.route_for_new_tab);

                  $uibModalInstance.dismiss("cancel");
                })
                .catch(function (e) {
                  console.log("error", e);
                });
            } else {
              SweetAlert.swal(
                "Cancelado",
                "La Póliza de Grupo no se ha eliminado",
                "error"
              );
            }
          }
        );
      };
      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }
    $scope.assignCertificate = function (id) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/polizas.assign_certificate.html",
        controller: assignCertificateModalView,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policy_id: function () {
            return id;
          },
          contratante: function () {
            return $scope.contratante;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };
    $scope.assignPolicy = function (id) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/polizas.assign.html",
        controller: assignModalView,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policy_id: function () {
            return id;
          },
          contratante: function () {
            return $scope.contratante;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };
    $scope.contributoryInfo = function (id) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/colectivos/contributory.html",
        controller: contributoryModalView,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          policy_id: function () {
            return id;
          },
          caratula: function () {
            return $scope.caratula;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };
    function getCratula() {
      $http
        .post(url.IP + "get_caratula_colectiva/", {
          caratula: $stateParams.polizaId,
        })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.caratula = response.data.data.caratula;
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    }
    $scope.cambiarReferenciador = function (data, poliza) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/polizas/referenciadores.modal.html",
        controller: ReferenciadorModalCtrl,
        controllerAs: "vendedor",
        size: "lg",
        resolve: {
          poliza: function () {
            return poliza;
          },
          actual: function () {
            return data;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(
        function (response) {
          getCratula();
        },
        function () {
          getCratula();
          console.info("modal closed");
        }
      );
    };
    function ReferenciadorModalCtrl(
      poliza,
      actual,
      $http,
      $rootScope,
      $uibModalInstance,
      dataFactory,
      SweetAlert,
      datesFactory,
      $localStorage,
      $scope
    ) {
      var vmm = this;
      $scope.referenciador_a_cambiar = actual.referenciador;
      $scope.poliza_especifica = poliza;
      $scope.comisionError2 = "";
      activate_r();
      function activate_r() {
        // -------------------------Referenciadores
        dataFactory.get("get-vendors/").then(function (user) {
          user.data.forEach(function (vn) {
            vn.first_name = vn.first_name.toUpperCase();
            vn.last_name = vn.last_name.toUpperCase();
            vn.name = vn.first_name + " " + vn.last_name;
          });
          $scope.referenciadores = user.data.filter(function (vn) {
            return vn.id !== actual.referenciador.id;
          });
          $scope.ref_to_patch_policy = "";
          $scope.ref_to_change_id = "";
          poliza.ref_policy.filter(function (vn) {
            if (vn.url == actual.url) {
              $scope.ref_to_patch_policy = vn.url;
              $scope.ref_to_change_id = vn.id;
            }
          });
        });
      }
      $scope.validateComision = function () {
        // if ($scope.comision_vendedor > 100) {
        //   $scope.comision_vendedor = 100;
        // } else if ($scope.comision_vendedor < 0) {
        //   $scope.comision_vendedor = 0;
        // }
        $scope.checkTotalComision2($scope.comision_vendedor);
      };

      $scope.checkTotalComision2 = function (valor) {
        var totalComision = poliza.ref_policy.reduce(function (sum, item) {
          if (item.id !== $scope.ref_to_change_id) {
            return sum + (parseFloat(item.comision_vendedor) || 0);
          }
          return sum;
        }, 0);
        totalComision += parseFloat(valor);
        if (totalComision > 100) {
          $scope.comisionError2 =
            "La suma de las comisiones no puede superar el 100%";
          $scope.comision_vendedor = 0;
        } else {
          $scope.comisionError2 = "";
        }
      };
      $scope.cambiar = function (refe, comision) {
        var ref = {};
        ref.referenciador = refe.url;
        ref.comision_vendedor = comision ? comision : 0;
        ref.policy = poliza.url;
        ref.anterior = $scope.ref_to_change_id;
        ref.is_changed = false;
        if (ref.referenciador) {
          dataFactory
            .post("referenciadores-policy/", ref)
            .then(
              function success(response_ref_created) {
                $scope.ref_cambiado = response_ref_created.data;
                console.log(
                  "response to create new ref***",
                  response_ref_created
                );
                // set flat to last refer
                $http
                  .patch($scope.ref_to_patch_policy, { is_changed: true })
                  .then(function (response_patch_ref_last) {
                    var params = {
                      model: 18,
                      event: "POST",
                      associated_id: poliza.id,
                      identifier:
                        "cambio el Referenciador: " +
                        $scope.referenciador_a_cambiar.first_name +
                        " " +
                        $scope.referenciador_a_cambiar.last_name +
                        " por " +
                        $scope.ref_cambiado.ref_name,
                    };
                    dataFactory
                      .post("send-log/", params)
                      .then(function success(response) {});
                    setTimeout(function () {}, 1500);
                    $uibModalInstance.dismiss("cancel");
                  })
                  .catch(function (e) {
                    console.log("error", e);
                  });
              },
              function error(error) {
                console.log(error);
              }
            )
            .catch(function (e) {
              console.log(e);
            });
        } else {
          console.log("___Sin referenciador__");
        }
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    function contributoryModalView(
      $scope,
      $uibModalInstance,
      policy_id,
      url,
      caratula,
      dataFactory
    ) {
      $scope.caratulaInfo = caratula;
      $scope.editInfo = false;
      $scope.editContributory = function (argument) {
        $scope.editInfo = true;
      };
      $scope.saveInfoContributory = function (info) {
        // $scope.send = false;
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        var dataeditc = { contributory: info.contributory };

        $http
          .patch(info.url, dataeditc)
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                activate();
                SweetAlert.swal(
                  "¡Listo!",
                  "Información Contributoria guardada",
                  "success"
                );
                $uibModalInstance.dismiss("cancel");
              } else {
                l.stop();
                SweetAlert.swal("ERROR", MESSAGES.ERROR.POLICYERROR, "error");
              }
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("error", e);
          });
      };
      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }
    function assignModalView(
      $scope,
      $uibModalInstance,
      policy_id,
      url,
      contratante
    ) {
      $scope.send = true;
      var share_via_email = [];
      var share_via_email_r = [];

      var vmm = this;
      $scope.soloEmail = false;
      $scope.tipopoliza = "Carátula";
      vmm.is_owner = false;
      vmm.email_assign_mail = "";
      vmm.custom_email = true;
      vmm.htmlVariable = "";
      vmm.first_comment = "";
      vmm.second_comment = "";
      $http
        .get(url.IP + "polizas/" + policy_id + "/archivos/")
        .then(function (response) {
          $scope.files = response.data.results;
          $scope.files.forEach(function (archivo, index) {
            $scope.files[index]["origin"] = "P";
          });
        })
        .catch(function (e) {
          console.log("error", e);
        });

      dataFactory
        .get("emailtemplate-unpag/", {
          template_model: 2,
          id_policy: policy_id,
        })
        .then(function success(response) {
          $scope.plantillas = response.data;
        });
      $http
        .post(url.IP + "get-assign/", { poliza: policy_id })
        .then(
          function success(response) {
            $scope.people_assigned = response.data;
            $scope.owner_exist = true;
            $scope.people_assigned.some(function (people) {
              if (people.is_owner == true) {
                $scope.owner_exist = false;
                return;
              }
            });
          },
          function error(err) {
            console.log("error", err);
          }
        )
        .catch(function (e) {
          console.log("error", e);
        });
      $scope.changePlantilla = function (item) {
        if (item) {
          vmm.subjectEmail = item.title;
          vmm.first_comment = item.text;
          if (vmm.first_comment.includes("\n")) {
            vmm.first_comment = vmm.first_comment.replace("\n", "<br><br>");
          }
          vmm.second_comment = item.bottom_text;
          vmm.custom_email = true;
          $scope.getTemplate(true);
        } else {
          vmm.subjectEmail = "";
          vmm.first_comment = "";
          vmm.second_comment = "";
          vmm.custom_email = true;
          $scope.getTemplate(true);
        }
      };

      $scope.showEmailInInput = function (correo, ind) {
        $scope.email_assign = correo;
        // $scope.email_assign = contratante.email;
      };

      $scope.emails = [];
      $scope.addEmail = function (email) {
        if (validateEmail(email) == false) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        } else {
          $scope.emails.push(email);
          $scope.email_assign = "";
        }
      };

      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      $scope.sendEmail = function (receipt) {
        $scope.send = false;
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        var data_shared = {
          id: policy_id,
          emails: $scope.emails,
          files: share_via_email,
          files_r: share_via_email_r,
        };
        var data_shared = {
          is_owner: $scope.is_owner,
          active: true,
          poliza: policy_id,
          id: policy_id,
          email: email,
          emails: $scope.emails,
          files: share_via_email,
          files_r: share_via_email_r,
          first_comment: vmm.first_comment,
          second_comment: vmm.second_comment,
          custom_email: vmm.custom_email,
          subject: vmm.subjectEmail,
        };
        $http
          .post(url.IP + "share-policy-manual/", data_shared)
          // $http.post(url.IP+'share-policy-manual/', {'id': policy_id, 'emails': $scope.emails})
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.POLICYSEND, "success");
                $uibModalInstance.dismiss("cancel");
              } else {
                l.stop();
                SweetAlert.swal("ERROR", MESSAGES.ERROR.POLICYERROR, "error");
              }
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("error", e);
          });
      };

      $scope.deleteEmail = function (email) {
        $http({
          method: "GET",
          url: url.IP + "delete-assign/",
          params: {
            id: email.id,
          },
        })
          .then(function (request) {
            assignModalView($scope, $uibModalInstance, policy_id, url);
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };

      $scope.shareFileEmail = function (file) {
        if (file.to_send) {
          file.to_send = false;
        } else {
          file.to_send = true;
        }
        share_via_email = [];
        share_via_email_r = [];
        $scope.files.forEach(function (filex) {
          if (filex.to_send && filex.origin == "P") {
            share_via_email.push(filex.id);
          }
          if (filex.to_send && filex.origin == "R") {
            share_via_email_r.push(filex.id);
          }
        });
      };

      $scope.shareFile = function (file) {
        $http
          .get(url.IP + "patch-policy-file/" + file.id)
          .then(function (response) {
            if (file.shared) {
              $scope.fileshared = true;
            } else {
              $scope.fileshared = false;
            }
            $scope.files.some(function (filex) {
              if (filex.id == response.data.id) {
                filex.shared = response.data.shared;
              }
            });
            $scope.files[file] = response.data;
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };

      $scope.is_owner = false;
      $scope.getTemplate = function (custom_email) {
        if (custom_email) {
          $http
            .get(url.IP + "share-policy-manual/" + policy_id)
            .then(function (response) {
              if (response.status === 200) {
                vmm.head = response.data.head;
                vmm.body = response.data.body;
                vmm.footer = response.data.footer;
                vmm.subjectDefault = response.data.subject_default;
                if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
                  vmm.subjectEmail = vmm.subjectDefault;
                }
              }
            })
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          vmm.htmlVariable = "";
          vmm.first_comment = "";
          vmm.second_comment = "";
        }
      };
      $scope.emptySubject = function (v) {
        if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
          vmm.subjectEmail = vmm.subjectDefault;
        }
      };
      $scope.assignPolicy = function (email) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (email) {
          if (validateEmail(email) == false) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
            return;
          }
          if (!email) {
            console.log("sin ema", email);
          }
          var assign = {
            is_owner: $scope.is_owner,
            active: true,
            poliza: policy_id,
            email: email,
            first_name: vmm.first_comment,
            last_name: vmm.second_comment,
            custom_email: vmm.custom_email,
          };
          $http
            .post(url.IP + "assign-pendient/", assign)
            .then(function (response) {
              if (response.status === 200 || request.status === 201) {
                if (response.data.type == 1) {
                  l.stop();
                  SweetAlert.swal(
                    "Advertencia",
                    MESSAGES.INFO.POLICYASSIGNED,
                    "warning"
                  );
                } else {
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.INFO.POLICYPENDIENT,
                    "success"
                  );
                }
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
          $uibModalInstance.dismiss("cancel");
        } else {
          if ($scope.fileshared && $scope.fileshared == true) {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.FILESHARED, "success");
          }
          l.stop();
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.remove_email = function (index) {
        $scope.emails.splice(index, 1);
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.save_info_tab = function () {
      $localStorage.save_edition_poliza_certificado = angular.copy(
        $scope.newCertificate
      );
    };

    $scope.editCerficate = function (item) {
      $scope.originCertificate = [];
      $scope.isEdit = true;
      $scope.originCertificate = angular.copy(item);
      if ($localStorage.save_edition_poliza_certificado) {
        if ($localStorage.save_edition_poliza_certificado["id"] == item.id) {
          $scope.newCertificate = $localStorage.save_edition_poliza_certificado;
        } else {
          $scope.newCertificate = item;
        }
      } else {
        $scope.newCertificate = item;
      }
      if ($scope.newCertificate.start_of_validity) {
        if (
          $scope.newCertificate.start_of_validity &&
          $scope.newCertificate.start_of_validity.indexOf("-") != -1
        ) {
          $scope.newCertificate.start_of_validity = datesFactory.convertDate(
            $scope.newCertificate.start_of_validity
          );
        }
      } else {
        $scope.newCertificate.start_of_validity = null;
      }
      if ($scope.newCertificate.end_of_validity) {
        if ($scope.newCertificate.end_of_validity.indexOf("-") != -1) {
          $scope.newCertificate.end_of_validity = datesFactory.convertDate(
            $scope.newCertificate.end_of_validity
          );
        }
      } else {
        $scope.newCertificate.end_of_validity = null;
      }
      if (
        $scope.newCertificate.life_policy &&
        $scope.newCertificate.life_policy.length
      ) {
        if ($scope.newCertificate.rec_antiguedad) {
          if (
            $scope.newCertificate.rec_antiguedad &&
            $scope.newCertificate.rec_antiguedad.indexOf("-") != -1
          ) {
            $scope.newCertificate.rec_antiguedad = datesFactory.convertDate(
              $scope.newCertificate.rec_antiguedad
            );
          }
        } else {
          if (
            $scope.newCertificate.life_policy[0].personal &&
            $scope.newCertificate.life_policy[0].personal.antiguedad &&
            $scope.newCertificate.life_policy[0].personal.antiguedad.indexOf(
              "-"
            ) != -1
          ) {
            $scope.newCertificate.rec_antiguedad = datesFactory.convertDate(
              $scope.newCertificate.life_policy[0].personal.antiguedad
            );
          } else {
            $scope.newCertificate.rec_antiguedad = null;
          }
        }
        if ($scope.newCertificate.datos.personal.birthdate) {
          if (
            $scope.newCertificate.datos.personal.birthdate.indexOf("-") != -1
          ) {
            $scope.newCertificate.datos.personal.birthdate =
              datesFactory.convertDate(
                $scope.newCertificate.datos.personal.birthdate
              );
          }
        }
        if ($scope.newCertificate.datos.personal.charge_date) {
          if (
            $scope.newCertificate.datos.personal.charge_date.indexOf("-") != -1
          ) {
            $scope.newCertificate.datos.personal.charge_date = $scope
              .newCertificate.datos.personal.charge_date
              ? datesFactory.convertDate(
                  $scope.newCertificate.datos.personal.charge_date
                )
              : null;
          }
        }
        if ($scope.newCertificate.datos.personal.discharge_date) {
          if (
            $scope.newCertificate.datos.personal.discharge_date.indexOf("-") !=
            -1
          ) {
            $scope.newCertificate.datos.personal.discharge_date = $scope
              .newCertificate.datos.personal.discharge_date
              ? datesFactory.convertDate(
                  $scope.newCertificate.datos.personal.discharge_date
                )
              : null;
          }
        }

        $scope.sexs.forEach(function (item) {
          if (item.value == $scope.newCertificate.datos.personal.sex) {
            $scope.newCertificate.datos.personal.sex = item;
          }
        });
        $scope.typesInsureds.forEach(function (item) {
          if (item.value == $scope.newCertificate.datos.personal.type_sa) {
            $scope.newCertificate.datos.personal.type_sa = item;
          }
        });
        $scope.smokers.forEach(function (item) {
          if (item.value == $scope.newCertificate.life_policy[0].smoker) {
            $scope.newCertificate.datos.smoker = item;
          }
        });
        $scope.newCertificate.datos.sum_assured = parseFloat(
          $scope.newCertificate.datos.sum_assured
        );
        $scope.newCertificate.datos.salary = parseFloat(
          $scope.newCertificate.datos.salary
        );
        $scope.newCertificate.datos.beneficiaries_life.forEach(function (
          beneficiarie
        ) {
          if (beneficiarie.birthdate) {
            if (beneficiarie.birthdate.indexOf("-") != -1) {
              beneficiarie.birthdate = datesFactory.convertDate(
                beneficiarie.birthdate
              );
            }
          }
          $scope.sexs.forEach(function (item) {
            if (item.value == beneficiarie.sex) {
              beneficiarie.sex = item;
            }
          });
          $scope.relationships.forEach(function (item) {
            if (item.value == beneficiarie.optional_relationship) {
              beneficiarie.optional_relationship = item;
            }
          });
        });
      } else if (
        $scope.newCertificate.accidents_policy &&
        $scope.newCertificate.accidents_policy.length
      ) {
        if ($scope.newCertificate.rec_antiguedad) {
          if (
            $scope.newCertificate.rec_antiguedad &&
            $scope.newCertificate.rec_antiguedad.indexOf("-") != -1
          ) {
            $scope.newCertificate.rec_antiguedad = datesFactory.convertDate(
              $scope.newCertificate.rec_antiguedad
            );
          }
        } else {
          if (
            $scope.newCertificate.accidents_policy[0].personal &&
            $scope.newCertificate.accidents_policy[0].personal.antiguedad &&
            $scope.newCertificate.accidents_policy[0].personal.antiguedad.indexOf(
              "-"
            ) != -1
          ) {
            $scope.newCertificate.rec_antiguedad = datesFactory.convertDate(
              $scope.newCertificate.accidents_policy[0].personal.antiguedad
            );
          } else {
            $scope.newCertificate.rec_antiguedad = null;
          }
        }
        if ($scope.newCertificate.datos.personal.birthdate) {
          if (
            $scope.newCertificate.datos.personal.birthdate.indexOf("-") != -1
          ) {
            $scope.newCertificate.datos.personal.birthdate =
              datesFactory.convertDate(
                $scope.newCertificate.datos.personal.birthdate
              );
          }
        }

        if ($scope.newCertificate.datos.personal.charge_date) {
          if (
            $scope.newCertificate.datos.personal.charge_date.indexOf("-") != -1
          ) {
            $scope.newCertificate.datos.personal.charge_date = $scope
              .newCertificate.datos.personal.charge_date
              ? datesFactory.convertDate(
                  $scope.newCertificate.datos.personal.charge_date
                )
              : null;
          }
        }
        if ($scope.newCertificate.datos.personal.discharge_date) {
          if (
            $scope.newCertificate.datos.personal.discharge_date.indexOf("-") !=
            -1
          ) {
            $scope.newCertificate.datos.personal.discharge_date = $scope
              .newCertificate.datos.personal.discharge_date
              ? datesFactory.convertDate(
                  $scope.newCertificate.datos.personal.discharge_date
                )
              : null;
          }
        }

        $scope.sexs.forEach(function (item) {
          $scope.newCertificate.datos.personal.sex =
            $scope.newCertificate.datos.personal.sex;
          if (
            item.value ==
            ($scope.newCertificate.datos.personal.sex.value
              ? $scope.newCertificate.datos.personal.sex.value
              : $scope.newCertificate.datos.personal.sex)
          ) {
            $scope.newCertificate.datos.personal.sex = item;
          }
        });
        $scope.newCertificate.datos.relationship_accident.forEach(function (
          beneficiarie
        ) {
          if (beneficiarie.birthdate) {
            if (beneficiarie.birthdate.indexOf("-") != -1) {
              beneficiarie.birthdate = datesFactory.convertDate(
                beneficiarie.birthdate
              );
              beneficiarie.charge_date = beneficiarie.charge_date
                ? datesFactory.convertDate(beneficiarie.charge_date)
                : null;
              beneficiarie.discharge_date = beneficiarie.discharge_date
                ? datesFactory.convertDate(beneficiarie.discharge_date)
                : null;
              beneficiarie.antiguedad = beneficiarie.antiguedad
                ? datesFactory.convertDate(beneficiarie.antiguedad)
                : null;
            }
          }
          $scope.sexs.forEach(function (item) {
            if (item.value == beneficiarie.sex) {
              beneficiarie.sex = item;
            }
          });
          $scope.relationships.forEach(function (item) {
            if (item.value == beneficiarie.relationship) {
              beneficiarie.relationship = item;
            }
          });
        });
      } else if (
        $scope.newCertificate.automobiles_policy &&
        $scope.newCertificate.automobiles_policy.length
      ) {
        $scope.usages.forEach(function (item) {
          if (item.value == $scope.newCertificate.datos.usage) {
            $scope.newCertificate.datos.usage = item;
          }
        });
        $scope.typesCharges.forEach(function (item) {
          if (item.value == $scope.newCertificate.datos.charge_type) {
            $scope.newCertificate.datos.charge_type = item;
          }
        });
        $scope.procedencias.forEach(function (item) {
          if (item.value == $scope.newCertificate.datos.procedencia) {
            $scope.newCertificate.datos.procedencia = item;
          }
        });
        $scope.newCertificate.datos.mont_adjustment = parseFloat(
          $scope.newCertificate.datos.mont_adjustment
        );
        $scope.newCertificate.datos.mont_special_team = parseFloat(
          $scope.newCertificate.datos.mont_special_team
        );
        if ($scope.newCertificate.fecha_baja_inciso) {
          if (
            $scope.newCertificate.fecha_baja_inciso &&
            $scope.newCertificate.fecha_baja_inciso.indexOf("-") != -1
          ) {
            $scope.newCertificate.fecha_baja_inciso = datesFactory.convertDate(
              $scope.newCertificate.fecha_baja_inciso
            );
          }
        } else {
          $scope.newCertificate.fecha_baja_inciso = null;
        }
      } else if (
        $scope.newCertificate.damages_policy &&
        $scope.newCertificate.damages_policy.length
      ) {
        $scope.typesConstruction.forEach(function (item) {
          if (
            item.value ==
            $scope.newCertificate.damages_policy[0].type_construction
          ) {
            $scope.newCertificate.datos.type_construction = item;
          }
        });
        $scope.usages.forEach(function (item) {
          if (item.value == $scope.newCertificate.datos.usage) {
            $scope.newCertificate.datos.usage = item;
          }
        });
        $scope.newCertificate.datos.no_levels = parseFloat(
          $scope.newCertificate.datos.no_levels
        );
        $scope.newCertificate.datos.purchase_value = parseFloat(
          $scope.newCertificate.datos.purchase_value
        );
      }

      $scope.newCertificate.p_neta = parseFloat($scope.newCertificate.p_neta);
      $scope.newCertificate.rpf = parseFloat($scope.newCertificate.rpf);
      $scope.newCertificate.derecho = parseFloat($scope.newCertificate.derecho);
      $scope.newCertificate.iva = parseFloat($scope.newCertificate.iva);
      $scope.newCertificate.p_total = parseFloat($scope.newCertificate.p_total);
      $scope.newCertificate.comision = parseFloat(
        $scope.newCertificate.comision
      );
      $scope.showItemCertificate(3);
    };
    // ediciń save lcoa storage certofocate
    vm.saveLocalstorage = saveLocalstorage;
    function saveLocalstorage(cer) {
      $scope.save_info_tab();
      $localStorage["save_data_certificate"]["caratula"] = $scope.caratula.id;
      $localStorage["save_data_certificate"]["certificate_number"] =
        $scope.newCertificate.certificate_number;
      $localStorage["save_data_certificate"]["folio"] =
        $scope.newCertificate.folio;
      $localStorage["save_data_certificate"]["rec_antiguedad"] =
        $scope.newCertificate.rec_antiguedad;
      $localStorage["save_data_certificate"]["start_of_validity"] =
        $scope.newCertificate.start_of_validity;
      $localStorage["save_data_certificate"]["end_of_validity"] =
        $scope.newCertificate.end_of_validity;

      $localStorage["save_data_certificate"]["observations"] =
        $scope.newCertificate.observations;
      if (!$localStorage["save_data_certificate"]["personal"]) {
        $localStorage["save_data_certificate"]["personal"] = {};
      }
      $localStorage["save_data_certificate"]["personal"]["email"] =
        $scope.newCertificate.datos.personal.email;
      $localStorage["save_data_certificate"]["personal"]["first_name"] =
        $scope.newCertificate.datos.personal.first_name;
      $localStorage["save_data_certificate"]["personal"]["last_name"] =
        $scope.newCertificate.datos.personal.last_name;
      $localStorage["save_data_certificate"]["personal"]["second_last_name"] =
        $scope.newCertificate.datos.personal.second_last_name;
      $localStorage["save_data_certificate"]["personal"]["birthdate"] =
        $scope.newCertificate.datos.personal.birthdate;
      $localStorage["save_data_certificate"]["personal"]["charge_date"] =
        $scope.newCertificate.datos.personal.charge_date;
      $localStorage["save_data_certificate"]["personal"]["discharge_date"] =
        $scope.newCertificate.datos.personal.discharge_date;
      $localStorage["save_data_certificate"]["personal"]["sex"] =
        $scope.newCertificate.datos.personal.sex;
      $localStorage["save_data_certificate"]["personal"]["salary"] =
        $scope.newCertificate.datos.personal.salary;

      $localStorage["save_data_certificate"]["personal"]["p_neta"] =
        $scope.newCertificate.datos.personal.p_neta;
      $localStorage["save_data_certificate"]["personal"]["derecho"] =
        $scope.newCertificate.datos.personal.derecho;
      $localStorage["save_data_certificate"]["personal"]["rpf"] =
        $scope.newCertificate.datos.personal.rpf;
      $localStorage["save_data_certificate"]["personal"]["iva"] =
        $scope.newCertificate.datos.personal.iva;
      $localStorage["save_data_certificate"]["personal"]["p_total"] =
        $scope.newCertificate.datos.personal.p_total;
      $localStorage["save_data_certificate"]["personal"]["comision"] =
        $scope.newCertificate.datos.personal.comision;

      $localStorage["save_data_certificate"]["personal"]["p_neta_earned"] =
        $scope.newCertificate.datos.personal.p_neta_earned;
      $localStorage["save_data_certificate"]["personal"]["rpf_earned"] =
        $scope.newCertificate.datos.personal.rpf_earned;
      $localStorage["save_data_certificate"]["personal"]["derecho_earned"] =
        $scope.newCertificate.datos.personal.derecho_earned;
      $localStorage["save_data_certificate"]["personal"]["iva_earned"] =
        $scope.newCertificate.datos.personal.iva_earned;
      $localStorage["save_data_certificate"]["personal"]["p_total_earned"] =
        $scope.newCertificate.datos.personal.p_total_earned;
      $localStorage["save_data_certificate"]["personal"]["comision_earned"] =
        $scope.newCertificate.datos.personal.comision_earned;
    }
    vm.saveLocalstorage = saveLocalstorage;
    vm.saveLocalstorageBeneficiarie = saveLocalstorageBeneficiarie;
    function saveLocalstorageBeneficiarie(cer) {
      $localStorage.save_data_adddependiente = angular.copy(
        $scope.newBeneficierie
      );
    }
    //-----------------------------------------------
    $scope.addBeneficiarie = function () {
      if ($scope.newCertificate.datos.relationship_accident) {
        var beneficiarie = {
          first_name: "",
          last_name: "",
          second_last_name: "",
          birthdate: "",
          sex: $scope.sexs[0],
          familia: "",
          certificate: "",
          relationship: $scope.relationships[3],
          antiguedad: "",
          p_neta: 0,
          rpf: 0,
          derecho: 0,
          iva: 0,
          p_total: 0,
          comision: 0,
          is_active: true,
        };
        $scope.newCertificate.datos.relationship_accident.push(beneficiarie);
      } else {
        var beneficiarie = {
          first_name: "",
          last_name: "",
          second_last_name: "",
          birthdate: "",
          sex: $scope.sexs[0],
          familia: "",
          certificate: "",
          optional_relationship: $scope.relationships[3],
          antiguedad: "",
          p_neta: 0,
          rpf: 0,
          derecho: 0,
          iva: 0,
          p_total: 0,
          comision: 0,
          is_active: true,
        };
        $scope.newCertificate.datos.beneficiaries_life.push(beneficiarie);
      }
    };

    $scope.deleteBeneficiarie = function (index) {
      if ($scope.newCertificate.datos.relationship_accident) {
        $scope.newCertificate.datos.relationship_accident.splice(index, 1);
      } else {
        $scope.newCertificate.datos.beneficiaries_life.splice(index, 1);
      }
    };

    $scope.addDependent = function (item) {
      $scope.copy_newBeneficierie = angular.copy(item);
      $scope.newBeneficierie = [];
      $scope.newBeneficierie = item;
      if ($scope.newBeneficierie.accidents_policy.length > 0) {
        if (
          $scope.newBeneficierie.accidents_policy[0].relationship_accident
            .length == 0
        ) {
          $scope.newBeneficierie.accidents_policy[0].relationship_accident = [
            {
              first_name: "",
              last_name: "",
              second_last_name: "",
              birthdate: "",
              sex: $scope.sexs[0],
              familia: "",
              certificate: "",
              relationship: $scope.relationships[3],
              antiguedad: "",
              p_neta: 0,
              rpf: 0,
              derecho: 0,
              iva: 0,
              p_total: 0,
              comision: 0,
              is_active: true,
              contributory: $scope.newCertificate.contributory,
            },
          ];
        } else {
          // $scope.newBeneficierie.accidents_policy[0].relationship_accident.splice($scope.newBeneficierie.accidents_policy[0].relationship_accident.indexOf(item), 1)
          $scope.newBeneficierie.accidents_policy[0].relationship_accident = [];
          $scope.newBeneficierie.accidents_policy[0].relationship_accident.push(
            {
              first_name: "",
              last_name: "",
              second_last_name: "",
              birthdate: "",
              sex: $scope.sexs[0],
              familia: "",
              certificate: "",
              relationship: $scope.relationships[3],
              antiguedad: "",
              p_neta: 0,
              rpf: 0,
              derecho: 0,
              iva: 0,
              p_total: 0,
              comision: 0,
              is_active: true,
              contributory: $scope.newCertificate.contributory,
            }
          );
        }
      } else {
        if (
          $scope.newBeneficierie.life_policy[0].beneficiaries_life.length == 0
        ) {
          $scope.newBeneficierie.life_policy[0].beneficiaries_life = [
            {
              first_name: "",
              last_name: "",
              second_last_name: "",
              birthdate: "",
              sex: $scope.sexs[0],
              familia: "",
              certificate: "",
              optional_relationship: $scope.relationships[3],
              antiguedad: "",
            },
          ];
        } else {
          // $scope.newBeneficierie.life_policy[0].beneficiaries_life.splice($scope.newBeneficierie.life_policy[0].beneficiaries_life.indexOf(item), 1)
          $scope.newBeneficierie.life_policy[0].beneficiaries_life = [];
          $scope.newBeneficierie.life_policy[0].beneficiaries_life.push({
            first_name: "",
            last_name: "",
            second_last_name: "",
            birthdate: "",
            sex: $scope.sexs[0],
            familia: "",
            certificate: "",
            optional_relationship: $scope.relationships[3],
            antiguedad: "",
          });
        }
      }
      if ($localStorage["save_data_adddependiente"]) {
        if (
          $localStorage["save_data_adddependiente"].caratula ==
          $scope.caratula.id
        ) {
          $scope.newBeneficierie = $localStorage["save_data_adddependiente"];
        }
      }
      $scope.show_beneficiarie = true;
    };

    $scope.cancelBeneficiarie = function () {
      $scope.show_beneficiarie = false;
      $scope.categorySelected.certificates.forEach(function (item, index) {
        if (item.id == $scope.copy_newBeneficierie.id) {
          $scope.categorySelected.certificates[index] =
            $scope.copy_newBeneficierie;
        }
      });
    };

    $scope.addNewBeneficiarie = function (index) {
      if ($scope.caratula.subramo.subramo_code == 3) {
        var beneficiarie = {
          first_name: "",
          last_name: "",
          second_last_name: "",
          birthdate: "",
          sex: $scope.sexs[0],
          familia: "",
          certificate: "",
          relationship: $scope.relationships[3],
          antiguedad: "",
          p_neta: 0,
          rpf: 0,
          derecho: 0,
          iva: 0,
          p_total: 0,
          comision: 0,
        };
        $scope.newBeneficierie.accidents_policy[0].relationship_accident.push(
          beneficiarie
        );
      } else {
        var beneficiarie = {
          first_name: "",
          last_name: "",
          second_last_name: "",
          birthdate: "",
          sex: $scope.sexs[0],
          familia: "",
          certificate: "",
          optional_relationship: $scope.relationships[3],
          antiguedad: "",
        };
        $scope.newBeneficierie.life_policy[0].beneficiaries_life.push(
          beneficiarie
        );
      }
    };

    $scope.deleteNewBeneficiarie = function (index) {
      if ($scope.newBeneficierie.accidents_policy[0].relationship_accident) {
        $scope.newBeneficierie.accidents_policy[0].relationship_accident.splice(
          index,
          1
        );
      } else {
        $scope.newBeneficierie.life_policy[0].beneficiaries_life.splice(
          index,
          1
        );
      }
    };

    $scope.deleteBeneficiarieInfo = function (item, index) {
      SweetAlert.swal(
        {
          title: "Eliminar Dependiente",
          text: "Se eliminará el Dependiente y no se podrá recuperar después, ¿Estás Seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(item.url).then(function (response) {
              if (response.status == 204) {
                $scope.selectCerficate($scope.certificate);
                SweetAlert.swal(
                  "¡Listo!",
                  "Dependiente eliminado exitosamente.",
                  "success"
                );
                var paramsRec = {
                  model: 25,
                  event: "PATCH",
                  associated_id: $scope.certificate.id,
                  identifier:
                    " eliminó un dependiente del certificado " +
                    $scope.certificate.certificate_number +
                    ".",
                  change: [],
                };
                dataFactory
                  .post("send_log_specific/", paramsRec)
                  .then(function success(response) {});
              }
            });
            $scope.certificate.accidents_policy[0].relationship_accident.splice(
              $scope.certificate.accidents_policy[0].relationship_accident.indexOf(
                item
              ),
              1
            );
          }
        }
      );
    };

    $scope.saveBeneficiarie = function () {
      var flagNewBeneficiarie = false;
      if ($scope.caratula.ramo.ramo_code == 2) {
        $scope.upd_neta = $scope.newBeneficierie.p_neta
          ? parseFloat($scope.newBeneficierie.p_neta).toFixed(2)
          : 0;
        $scope.upd_rpf = $scope.newBeneficierie.rpf
          ? parseFloat($scope.newBeneficierie.rpf).toFixed(2)
          : 0;
        $scope.upd_derecho = $scope.newBeneficierie.derecho
          ? parseFloat($scope.newBeneficierie.derecho).toFixed(2)
          : 0;
        $scope.upd_iva = $scope.newBeneficierie.iva
          ? parseFloat($scope.newBeneficierie.iva).toFixed(2)
          : 0;
        $scope.upd_total = $scope.newBeneficierie.p_total
          ? parseFloat($scope.newBeneficierie.p_total).toFixed(2)
          : 0;
        $scope.upd_comision = $scope.newBeneficierie.comision
          ? parseFloat($scope.newBeneficierie.comision).toFixed(2)
          : 0;
        $scope.newBeneficierie.accidents_policy[0].relationship_accident.forEach(
          function (relationshipData, index) {
            if (!relationshipData.first_name) {
              SweetAlert.swal(
                "Error",
                "Agrega el nombre del dependiente #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (!relationshipData.last_name) {
              SweetAlert.swal(
                "Error",
                "Agrega el apellido paterno del dependiente #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (!relationshipData.second_last_name) {
              SweetAlert.swal(
                "Error",
                "Agrega el apellido materno del dependiente #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (!relationshipData.birthdate) {
              SweetAlert.swal(
                "Error",
                "Agrega la fecha de nacimiento del dependiente #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (!relationshipData.relationship) {
              SweetAlert.swal(
                "Error",
                "Agrega el parentesco del dependiente #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (!relationshipData.sex) {
              SweetAlert.swal(
                "Error",
                "Agrega el sexo del dependiente #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (!relationshipData.antiguedad) {
              SweetAlert.swal(
                "Error",
                "Agrega la fecha de antigüedad del dependiente #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (flagNewBeneficiarie) {
              return;
            }
            if (!relationshipData.url || relationshipData.url == undefined) {
              relationshipData.birthdate = relationshipData.birthdate
                ? toDate(relationshipData.birthdate)
                : null;
              relationshipData.antiguedad = relationshipData.antiguedad
                ? toDate(relationshipData.antiguedad)
                : null;
              relationshipData.accident =
                $scope.newBeneficierie.accidents_policy[0].url;
              relationshipData.relationship = relationshipData.relationship
                ? relationshipData.relationship.value
                : 0;
              relationshipData.sex = relationshipData.sex
                ? relationshipData.sex.value
                : "M";
              relationshipData.certificate = relationshipData.certificate
                ? relationshipData.certificate
                : $scope.newBeneficierie.certificate_number
                ? $scope.newBeneficierie.certificate_number
                : "";
              // Primas Dependiente
              relationshipData.p_neta = relationshipData.p_neta
                ? parseFloat(relationshipData.p_neta).toFixed(2)
                : 0;
              relationshipData.rpf = relationshipData.rpf
                ? parseFloat(relationshipData.rpf).toFixed(2)
                : 0;
              relationshipData.derecho = relationshipData.derecho
                ? parseFloat(relationshipData.derecho).toFixed(2)
                : 0;
              relationshipData.iva = relationshipData.iva
                ? parseFloat(relationshipData.iva).toFixed(2)
                : 0;
              relationshipData.p_total = relationshipData.p_total
                ? parseFloat(relationshipData.p_total).toFixed(2)
                : 0;
              relationshipData.comision = relationshipData.comision
                ? parseFloat(relationshipData.comision).toFixed(2)
                : 0;
              relationshipData.contributory =
                $scope.newBeneficierie.contributory;
              // Sumas
              $scope.upd_neta = parseFloat(
                parseFloat($scope.upd_neta) +
                  parseFloat(relationshipData.p_neta)
              ).toFixed(2);
              $scope.upd_rpf = parseFloat(
                parseFloat($scope.upd_rpf) + parseFloat(relationshipData.rpf)
              ).toFixed(2);
              $scope.upd_derecho = parseFloat(
                parseFloat($scope.upd_derecho) +
                  parseFloat(relationshipData.derecho)
              ).toFixed(2);
              $scope.upd_iva = parseFloat(
                parseFloat($scope.upd_iva) + parseFloat(relationshipData.iva)
              ).toFixed(2);
              $scope.upd_total = parseFloat(
                parseFloat($scope.upd_total) +
                  parseFloat(relationshipData.p_total)
              ).toFixed(2);
              $scope.upd_comision = parseFloat(
                parseFloat($scope.upd_comision) +
                  parseFloat(relationshipData.comision)
              ).toFixed(2);
              generalService
                .createRelationship(relationshipData)
                .then(function (responseRelation) {
                  // $scope.responseFromThis.relationships.push(relationship);
                  $scope.show_beneficiarie = false;
                  $scope.allCertificates();
                });
            }
          }
        );
        // Update data primas
        var jsonUpdate = {
          p_neta: $scope.upd_neta
            ? parseFloat($scope.upd_neta).toFixed(2)
            : $scope.newBeneficierie.p_neta
            ? parseFloat($scope.newBeneficierie.p_neta).toFixed(2)
            : 0,
          rpf: $scope.upd_rpf
            ? parseFloat($scope.upd_rpf).toFixed(2)
            : $scope.newBeneficierie.rpf
            ? parseFloat($scope.newBeneficierie.rpf).toFixed(2)
            : 0,
          derecho: $scope.upd_derecho
            ? parseFloat($scope.upd_derecho).toFixed(2)
            : $scope.newBeneficierie.derecho
            ? parseFloat($scope.newBeneficierie.derecho).toFixed(2)
            : 0,
          iva: $scope.upd_iva
            ? parseFloat($scope.upd_iva).toFixed(2)
            : $scope.newBeneficierie.iva
            ? parseFloat($scope.newBeneficierie.iva).toFixed(2)
            : 0,
          p_total: $scope.upd_total
            ? parseFloat($scope.upd_total).toFixed(2)
            : $scope.newBeneficierie.iva
            ? parseFloat($scope.newBeneficierie.iva).toFixed(2)
            : 0,
          comision: $scope.upd_comision
            ? parseFloat($scope.upd_comision).toFixed(2)
            : $scope.newBeneficierie.comision
            ? parseFloat($scope.newBeneficierie.comision).toFixed(2)
            : 0,
          contributory: $scope.newBeneficierie.contributory,
        };
        $http
          .patch($scope.newBeneficierie.url, jsonUpdate)
          .then(function success(request) {
            if (request.status === 200) {
            }
          })
          .catch(function (e) {
            console.log("error", e);
          });
        $localStorage["save_data_adddependiente"] = {};
      } else if ($scope.caratula.subramo.subramo_code == 1) {
        $scope.newBeneficierie.life_policy[0].beneficiaries_life.forEach(
          function (element, index) {
            if (!element.first_name) {
              SweetAlert.swal(
                "Error",
                "Agrega el nombre del beneficiario #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (!element.last_name) {
              SweetAlert.swal(
                "Error",
                "Agrega el apellido paterno del beneficiario #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (!element.second_last_name) {
              SweetAlert.swal(
                "Error",
                "Agrega el apellido materno del beneficiario #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (!element.birthdate) {
              SweetAlert.swal(
                "Error",
                "Agrega la fecha de nacimiento del beneficiario #" +
                  (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (!element.optional_relationship) {
              SweetAlert.swal(
                "Error",
                "Agrega el parentesco del beneficiario #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (!element.sex) {
              SweetAlert.swal(
                "Error",
                "Agrega el sexo del beneficiario #" + (index + 1),
                "error"
              );
              flagNewBeneficiarie = true;
            }
            if (flagNewBeneficiarie) {
              return;
            }
            if (!element.url || element.url == undefined) {
              element.life = $scope.newBeneficierie.life_policy[0].url;
              element.birthdate = element.birthdate
                ? toDate(element.birthdate)
                : null;
              element.optional_relationship = element.optional_relationship
                ? element.optional_relationship.value
                : 0;
              element.full_name =
                element.first_name +
                " " +
                element.last_name +
                " " +
                element.second_last_name;
              element.sex = element.sex ? element.sex.value : "M";
              element.antiguedad = element.antiguedad
                ? toDate(convertDate(element.antiguedad))
                : null;
              generalService
                .createBeneficiaries(element)
                .then(function (beneficiarie) {
                  // $scope.responseFromThis.beneficiarios.push(beneficiarie);
                  $scope.show_beneficiarie = false;
                  $scope.allCertificates();
                });
            }
          }
        );
        $localStorage["save_data_adddependiente"] = {};
      }
    };

    $scope.validateBirthdate = function (param) {
      if (process(param) > process(convertDate(new Date()))) {
        SweetAlert.swal(
          "Error",
          "La fecha de nacimiento no puede ser mayor a la fecha de hoy.",
          "error"
        );
        return;
      }

      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }
    };

    $scope.validateCertificate = function (cert, salary, cate) {
      var flagBeneficiarie = false;
      if (!$scope.newCertificate.start_of_validity) {
        SweetAlert.swal(
          "Error",
          "Agrega una fecha de vigencia inicio.",
          "error"
        );
        return;
      }
      if (!$scope.newCertificate.end_of_validity) {
        SweetAlert.swal("Error", "Agrega una fecha de vigencia fin.", "error");
        return;
      } else {
        if (
          process($scope.newCertificate.start_of_validity) <
            process(convertDate($scope.caratula.start_of_validity)) ||
          process($scope.newCertificate.end_of_validity) >
            process(convertDate($scope.caratula.end_of_validity))
        ) {
          SweetAlert.swal("Error", MESSAGES.WARNING.VALIDITYOUTRANGE, "error");
          return;
        }
      }
      function process(date) {
        var parts = date.split("/");
        var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        return date.getTime();
      }

      if (!$scope.newCertificate.parent) {
        SweetAlert.swal("Error", "Selecciona una categoría.", "error");
        return;
      }
      if (!$scope.newCertificate.paquete) {
        SweetAlert.swal("Error", "Selecciona un paquete.", "error");
        return;
      }
      if (!$scope.newCertificate.certificate_number) {
        SweetAlert.swal("Error", "Agrega un número de certificado.", "error");
        return;
      }
      if ($scope.caratula.subramo.subramo_name == "Vida") {
        if (!$scope.newCertificate.rec_antiguedad) {
          SweetAlert.swal("Error", "Agrega una fecha de antigüedad.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.personal.email) {
          SweetAlert.swal("Error", "Agrega un correo electrónico.", "error");
          return;
        } else {
          if (
            !$scope.validateEmail($scope.newCertificate.datos.personal.email)
          ) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
            return;
          }
        }
        if (!$scope.newCertificate.datos.personal.first_name) {
          SweetAlert.swal("Error", "Agrega un nombre al titular.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.personal.last_name) {
          SweetAlert.swal(
            "Error",
            "Agrega un apellido paterno al titular.",
            "error"
          );
          return;
        }
        if (!$scope.newCertificate.datos.personal.second_last_name) {
          SweetAlert.swal(
            "Error",
            "Agrega un apellido materno al titular.",
            "error"
          );
          return;
        }
        if (!$scope.newCertificate.datos.personal.birthdate) {
          SweetAlert.swal(
            "Error",
            "Agrega una fecha de nacimiento al titular.",
            "error"
          );
          return;
        }
        if (!$scope.newCertificate.datos.personal.sex) {
          SweetAlert.swal("Error", "Selecciona un sexo al titular.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.personal.type_sa) {
          SweetAlert.swal(
            "Error",
            "Selecciona un tipo de suma asegurada al titular.",
            "error"
          );
          return;
        }
        if (!$scope.newCertificate.datos.personal.sum_assured) {
          SweetAlert.swal(
            "Error",
            "Agrega una suma asegurada al titular.",
            "error"
          );
          return;
        }
        // if(!$scope.newCertificate.datos.personal.salary){
        //   // SweetAlert.swal('Error', 'Agrega un sueldo al titular.', 'error');
        //   // return;
        // }else{
        //   // $scope.newCertificate.datos.personal.salary = 0
        // }
        if (!$scope.newCertificate.datos.smoker) {
          SweetAlert.swal("Error", "Selecciona si fuma el titular.", "error");
          return;
        }
        // if($scope.newCertificate.datos.beneficiaries_life.length > 0){
        //   var flagBeneficiarie = false;
        //   $scope.newCertificate.datos.beneficiaries_life.forEach(function(beneficiarie, index){
        //     if(!beneficiarie.first_name){
        //       SweetAlert.swal('Error', 'Agrega un nombre al beneficiario ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //     if(!beneficiarie.last_name){
        //       SweetAlert.swal('Error', 'Agrega un apellido paterno al beneficiario ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //     if(!beneficiarie.second_last_name){
        //       SweetAlert.swal('Error', 'Agrega un apellido materno al beneficiario ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //     if(!beneficiarie.birthdate){
        //       SweetAlert.swal('Error', 'Agrega un nombre al beneficiario ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //     if(!beneficiarie.optional_relationship){
        //       SweetAlert.swal('Error', 'Selecciona un parentesco al beneficiario ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //     if(!beneficiarie.sex){
        //       SweetAlert.swal('Error', 'Selecciona un sexo al beneficiario ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //   });
        // }
      } else if (
        $scope.caratula.ramo.ramo_name.toLowerCase() ==
        "accidentes y enfermedades"
      ) {
        if (!$scope.newCertificate.datos.personal.email) {
          SweetAlert.swal("Error", "Agrega un correo electrónico.", "error");
          return;
        } else {
          if (
            !$scope.validateEmail($scope.newCertificate.datos.personal.email)
          ) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
            return;
          }
        }
        if (!$scope.newCertificate.datos.personal.first_name) {
          SweetAlert.swal("Error", "Agrega un nombre al titular.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.personal.last_name) {
          SweetAlert.swal(
            "Error",
            "Agrega un apellido paterno al titular.",
            "error"
          );
          return;
        }
        if (!$scope.newCertificate.datos.personal.second_last_name) {
          SweetAlert.swal(
            "Error",
            "Agrega un apellido materno al titular.",
            "error"
          );
          return;
        }
        if (!$scope.newCertificate.datos.personal.birthdate) {
          SweetAlert.swal(
            "Error",
            "Agrega una fecha de nacimiento al titular.",
            "error"
          );
          return;
        }
        if (!$scope.newCertificate.datos.personal.sex) {
          SweetAlert.swal("Error", "Selecciona un sexo al titular.", "error");
          return;
        }
        // if($scope.newCertificate.datos.relationship_accident.length > 0){
        //   $scope.newCertificate.datos.relationship_accident.forEach(function(beneficiarie, index){
        //     if(!beneficiarie.first_name){
        //       SweetAlert.swal('Error', 'Agrega un nombre al dependiente ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //     if(!beneficiarie.last_name){
        //       SweetAlert.swal('Error', 'Agrega un apellido paterno al dependiente ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //     if(!beneficiarie.second_last_name){
        //       SweetAlert.swal('Error', 'Agrega un apellido materno al dependiente ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //     if(!beneficiarie.birthdate){
        //       SweetAlert.swal('Error', 'Agrega un nombre al dependiente ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //     if(!beneficiarie.relationship){
        //       SweetAlert.swal('Error', 'Selecciona un parentesco al dependiente ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //     if(!beneficiarie.sex){
        //       SweetAlert.swal('Error', 'Selecciona un sexo al dependiente ' + (index + 1) + '.', 'error');
        //       flagBeneficiarie = true;
        //     }
        //   });
        // }
      } else if ($scope.caratula.subramo.subramo_name == "Automóviles") {
        if (!$scope.newCertificate.datos.email) {
          SweetAlert.swal("Error", "Agrega un correo electrónico.", "error");
          return;
        } else {
          if (!$scope.validateEmail($scope.newCertificate.datos.email)) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
            return;
          }
        }
        if (!$scope.newCertificate.datos.brand) {
          SweetAlert.swal("Error", "Agrega una marca.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.model) {
          SweetAlert.swal("Error", "Agrega un modelo.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.year) {
          SweetAlert.swal("Error", "Agrega un año.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.version) {
          SweetAlert.swal("Error", "Agrega una versión.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.serial) {
          SweetAlert.swal("Error", "Agrega un número de serie.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.usage) {
          SweetAlert.swal("Error", "Agrega un uso.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.service) {
          SweetAlert.swal("Error", "Selecciona un serivicio.", "error");
          return;
        }
        if (!$scope.newCertificate.datos.procedencia) {
          SweetAlert.swal("Error", "Selecciona una procedencia.", "error");
          return;
        }
      } else if (
        $scope.caratula.subramo.subramo_name == "Incendio" ||
        $scope.caratula.subramo.subramo_name == "Diversos"
      ) {
        if (!$scope.newCertificate.datos.email) {
          SweetAlert.swal("Error", "Agrega un correo electrónico.", "error");
          return;
        } else {
          if (!$scope.validateEmail($scope.newCertificate.datos.email)) {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERROREMAIL, "error");
            return;
          }
        }
        if ($scope.caratula.subramo.subramo_name == "Incendio") {
          if (!$scope.newCertificate.datos.sucursal) {
            SweetAlert.swal("Error", "Agrega una sucursal.", "error");
            return;
          }
          if (!$scope.newCertificate.datos.giro) {
            SweetAlert.swal("Error", "Agrega un giro.", "error");
            return;
          }
          if (!$scope.newCertificate.datos.type_construction) {
            SweetAlert.swal(
              "Error",
              "Selecciona un tipo de contrucción.",
              "error"
            );
            return;
          }
          if (!$scope.newCertificate.datos.no_levels) {
            SweetAlert.swal("Error", "Agrega un número de niveles.", "error");
            return;
          }
          if (!$scope.newCertificate.datos.fhm_zone) {
            SweetAlert.swal("Error", "Agrega una zona FHM.", "error");
            return;
          }
          if (!$scope.newCertificate.datos.tyev_zone) {
            SweetAlert.swal("Error", "Agrega una zona TYEV.", "error");
            return;
          }
        } else if ($scope.caratula.subramo.subramo_name == "Diversos") {
          if (!$scope.newCertificate.datos.item_details) {
            SweetAlert.swal("Error", "Agrega una descripción.", "error");
            return;
          }
          if (!$scope.newCertificate.datos.usage) {
            SweetAlert.swal("Error", "Selecciona un uso.", "error");
            return;
          }
          if (!$scope.newCertificate.datos.brand) {
            SweetAlert.swal("Error", "Agrega una marca.", "error");
            return;
          }
          if (!$scope.newCertificate.datos.model) {
            SweetAlert.swal("Error", "Agrega un modelo.", "error");
            return;
          }
          if (!$scope.newCertificate.datos.construction_year) {
            SweetAlert.swal("Error", "Agrega un año de contrucción.", "error");
            return;
          }
          if (!$scope.newCertificate.datos.reconstruction_year) {
            SweetAlert.swal(
              "Error",
              "Agrega un año de recontrucción.",
              "error"
            );
            return;
          }
          if (!$scope.newCertificate.datos.version) {
            SweetAlert.swal("Error", "Agrega una versión.", "error");
            return;
          }
          if (!$scope.newCertificate.datos.serial) {
            SweetAlert.swal("Error", "Agrega un número de serie.", "error");
            return;
          }
          if (!$scope.newCertificate.datos.permiso) {
            SweetAlert.swal("Error", "Agrega un permiso.", "error");
            return;
          }
        }
      } else {
        if (
          !$scope.newCertificate.datos.insured_item &&
          $scope.caratula.ramo.ramo_code == 3 &&
          $scope.caratula.subramo.subramo_code != 9
        ) {
          SweetAlert.swal("Error", "Agrega el Bien asegurado.", "error");
          return;
        }
        if (
          $scope.newCertificate.datos &&
          $scope.newCertificate.datos.email &&
          !$scope.newCertificate.datos.email
        ) {
          SweetAlert.swal("Error", "Agrega un email.", "error");
          return;
        }
      }
      if (flagBeneficiarie) {
        return;
      } else {
        if (!$scope.isEdit) {
          $scope.saveIndividualCertificate(cert, salary);
        } else {
          $scope.valueCertificate(null, salary);
        }
      }
    };

    $scope.valueCertificate = function (cer, salary) {
      $scope.newCertificate.start_of_validity = toDate(
        $scope.newCertificate.start_of_validity
      );
      $scope.newCertificate.end_of_validity = toDate(
        $scope.newCertificate.end_of_validity
      );
      if ($scope.newCertificate.life_policy.length) {
        $scope.newCertificate.rec_antiguedad = toDate(
          $scope.newCertificate.rec_antiguedad
        );
        $scope.newCertificate.life_policy[0].personal.email =
          $scope.newCertificate.datos.personal.email;
        $scope.newCertificate.life_policy[0].personal.first_name =
          $scope.newCertificate.datos.personal.first_name;
        $scope.newCertificate.life_policy[0].personal.last_name =
          $scope.newCertificate.datos.personal.last_name;
        $scope.newCertificate.life_policy[0].personal.second_last_name =
          $scope.newCertificate.datos.personal.second_last_name;
        $scope.newCertificate.life_policy[0].personal.birthdate = toDate(
          $scope.newCertificate.datos.personal.birthdate
        );
        $scope.newCertificate.life_policy[0].personal.charge_date = toDate(
          $scope.newCertificate.datos.personal.charge_date
        );
        $scope.newCertificate.life_policy[0].personal.discharge_date = toDate(
          $scope.newCertificate.datos.personal.discharge_date
        );
        $scope.newCertificate.life_policy[0].personal.sex =
          $scope.newCertificate.datos.personal.sex.value;
        $scope.newCertificate.life_policy[0].personal.type_sa =
          $scope.newCertificate.datos.personal.type_sa.value;
        $scope.newCertificate.life_policy[0].personal.sum_assured =
          $scope.newCertificate.datos.personal.sum_assured;
        $scope.newCertificate.life_policy[0].personal.salary = $scope
          .newCertificate.datos.personal.salary
          ? $scope.newCertificate.datos.personal.salary
          : salary
          ? salary
          : 0;
        $scope.newCertificate.life_policy[0].smoker =
          $scope.newCertificate.datos.smoker.value;
        $scope.newCertificate.life_policy[0].beneficiaries_life.forEach(
          function (beneficiarie, index) {
            beneficiarie.birthdate = toDate(
              $scope.newCertificate.datos.beneficiaries_life[index].birthdate
            );
            beneficiarie.charge_date = $scope.newCertificate.datos
              .beneficiaries_life[index].charge_date
              ? toDate(
                  $scope.newCertificate.datos.beneficiaries_life[index]
                    .charge_date
                )
              : null;
            beneficiarie.discharge_date = $scope.newCertificate.datos
              .beneficiaries_life[index].discharge_date
              ? toDate(
                  $scope.newCertificate.datos.beneficiaries_life[index]
                    .discharge_date
                )
              : null;
            beneficiarie.first_name =
              $scope.newCertificate.datos.beneficiaries_life[index].first_name;
            beneficiarie.last_name =
              $scope.newCertificate.datos.beneficiaries_life[index].last_name;
            beneficiarie.second_last_name =
              $scope.newCertificate.datos.beneficiaries_life[
                index
              ].second_last_name;
            beneficiarie.optional_relationship =
              $scope.newCertificate.datos.beneficiaries_life[
                index
              ].optional_relationship.value;
            beneficiarie.sex =
              $scope.newCertificate.datos.beneficiaries_life[index].sex.value;
            beneficiarie.antiguedad = $scope.newCertificate.rec_antiguedad;
          }
        );
      } else if ($scope.newCertificate.accidents_policy.length) {
        $scope.sum_neta = 0;
        $scope.sum_rpf = 0;
        $scope.sum_derecho = 0;
        $scope.sum_iva = 0;
        $scope.sum_total = 0;
        $scope.sum_comision = 0;
        $scope.newCertificate.rec_antiguedad = toDate(
          $scope.newCertificate.rec_antiguedad
        );
        $scope.newCertificate.contributory = $scope.newCertificate.contributory;
        $scope.newCertificate.accidents_policy[0].personal.email =
          $scope.newCertificate.datos.personal.email;
        $scope.newCertificate.accidents_policy[0].personal.antiguedad = toDate(
          $scope.newCertificate.rec_antiguedad
        );
        $scope.newCertificate.accidents_policy[0].personal.first_name =
          $scope.newCertificate.datos.personal.first_name;
        $scope.newCertificate.accidents_policy[0].personal.last_name =
          $scope.newCertificate.datos.personal.last_name;
        $scope.newCertificate.accidents_policy[0].personal.second_last_name =
          $scope.newCertificate.datos.personal.second_last_name;
        $scope.newCertificate.accidents_policy[0].personal.birthdate = toDate(
          $scope.newCertificate.datos.personal.birthdate
        );
        $scope.newCertificate.accidents_policy[0].personal.charge_date = $scope
          .newCertificate.datos.personal.charge_date
          ? toDate($scope.newCertificate.datos.personal.charge_date)
          : null;
        $scope.newCertificate.accidents_policy[0].personal.discharge_date =
          $scope.newCertificate.datos.personal.discharge_date
            ? toDate($scope.newCertificate.datos.personal.discharge_date)
            : null;
        $scope.newCertificate.accidents_policy[0].personal.sex =
          $scope.newCertificate.datos.personal.sex.value;
        $scope.newCertificate.accidents_policy[0].personal.contributory = $scope
          .newCertificate.contributory
          ? $scope.newCertificate.contributory
          : false;
        $scope.newCertificate.accidents_policy[0].personal.rfc_cve =
          $scope.newCertificate.datos.personal.rfc_cve;
        $scope.newCertificate.accidents_policy[0].personal.rfc_homocve =
          $scope.newCertificate.datos.personal.rfc_homocve;
        $scope.newCertificate.accidents_policy[0].personal.dom_callenum =
          $scope.newCertificate.datos.personal.dom_callenum;
        $scope.newCertificate.accidents_policy[0].personal.dom_colonia =
          $scope.newCertificate.datos.personal.dom_colonia;
        $scope.newCertificate.accidents_policy[0].personal.dom_cp =
          $scope.newCertificate.datos.personal.dom_cp;
        $scope.newCertificate.accidents_policy[0].personal.dom_poblacion =
          $scope.newCertificate.datos.personal.dom_poblacion;
        $scope.newCertificate.accidents_policy[0].personal.dom_estado =
          $scope.newCertificate.datos.personal.dom_estado;
        // Primas Titular
        $scope.newCertificate.accidents_policy[0].personal.p_neta = $scope
          .newCertificate.datos.personal.p_neta
          ? parseFloat($scope.newCertificate.datos.personal.p_neta).toFixed(2)
          : 0;
        $scope.newCertificate.accidents_policy[0].personal.rpf = $scope
          .newCertificate.datos.personal.rpf
          ? parseFloat($scope.newCertificate.datos.personal.rpf).toFixed(2)
          : 0;
        $scope.newCertificate.accidents_policy[0].personal.derecho = $scope
          .newCertificate.datos.personal.derecho
          ? parseFloat($scope.newCertificate.datos.personal.derecho).toFixed(2)
          : 0;
        $scope.newCertificate.accidents_policy[0].personal.iva = $scope
          .newCertificate.datos.personal.iva
          ? parseFloat($scope.newCertificate.datos.personal.iva).toFixed(2)
          : 0;
        $scope.newCertificate.accidents_policy[0].personal.p_total = $scope
          .newCertificate.datos.personal.p_total
          ? parseFloat($scope.newCertificate.datos.personal.p_total).toFixed(2)
          : 0;
        $scope.newCertificate.accidents_policy[0].personal.comision = $scope
          .newCertificate.datos.personal.comision
          ? parseFloat($scope.newCertificate.datos.personal.comision).toFixed(2)
          : 0;
        // Primas Titular Devengadas
        $scope.newCertificate.accidents_policy[0].personal.p_neta_earned =
          $scope.newCertificate.datos.personal.p_neta_earned
            ? parseFloat(
                $scope.newCertificate.datos.personal.p_neta_earned
              ).toFixed(2)
            : 0;
        $scope.newCertificate.accidents_policy[0].personal.rpf_earned = $scope
          .newCertificate.datos.personal.rpf_earned
          ? parseFloat($scope.newCertificate.datos.personal.rpf_earned).toFixed(
              2
            )
          : 0;
        $scope.newCertificate.accidents_policy[0].personal.derecho_earned =
          $scope.newCertificate.datos.personal.derecho_earned
            ? parseFloat(
                $scope.newCertificate.datos.personal.derecho_earned
              ).toFixed(2)
            : 0;
        $scope.newCertificate.accidents_policy[0].personal.iva_earned = $scope
          .newCertificate.datos.personal.iva_earned
          ? parseFloat($scope.newCertificate.datos.personal.iva_earned).toFixed(
              2
            )
          : 0;
        $scope.newCertificate.accidents_policy[0].personal.p_total_earned =
          $scope.newCertificate.datos.personal.p_total_earned
            ? parseFloat(
                $scope.newCertificate.datos.personal.p_total_earned
              ).toFixed(2)
            : 0;
        $scope.newCertificate.accidents_policy[0].personal.comision_earned =
          $scope.newCertificate.datos.personal.comision_earned
            ? parseFloat(
                $scope.newCertificate.datos.personal.comision_earned
              ).toFixed(2)
            : 0;
        // Suma
        $scope.sum_neta =
          $scope.newCertificate.accidents_policy[0].personal.p_neta;
        $scope.sum_rpf = $scope.newCertificate.accidents_policy[0].personal.rpf;
        $scope.sum_derecho =
          $scope.newCertificate.accidents_policy[0].personal.derecho;
        $scope.sum_iva = $scope.newCertificate.accidents_policy[0].personal.iva;
        $scope.sum_total =
          $scope.newCertificate.accidents_policy[0].personal.p_total;
        $scope.sum_comision =
          $scope.newCertificate.accidents_policy[0].personal.comision;
        // Fin Primas Titular
        $scope.newCertificate.accidents_policy[0].relationship_accident.forEach(
          function (beneficiarie, index) {
            beneficiarie.birthdate = toDate(
              $scope.newCertificate.datos.relationship_accident[index].birthdate
            );
            beneficiarie.charge_date = $scope.newCertificate.datos
              .relationship_accident[index].charge_date
              ? toDate(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .charge_date
                )
              : null;
            beneficiarie.discharge_date = $scope.newCertificate.datos
              .relationship_accident[index].discharge_date
              ? toDate(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .discharge_date
                )
              : null;
            beneficiarie.first_name =
              $scope.newCertificate.datos.relationship_accident[
                index
              ].first_name;
            beneficiarie.last_name =
              $scope.newCertificate.datos.relationship_accident[
                index
              ].last_name;
            beneficiarie.second_last_name =
              $scope.newCertificate.datos.relationship_accident[
                index
              ].second_last_name;
            beneficiarie.relationship =
              $scope.newCertificate.datos.relationship_accident[
                index
              ].relationship.value;
            beneficiarie.sex = $scope.newCertificate.datos
              .relationship_accident[index].sex
              ? $scope.newCertificate.datos.relationship_accident[index].sex
                  .value
              : null;
            beneficiarie.antiguedad = toDate(
              $scope.newCertificate.datos.relationship_accident[index]
                .antiguedad
            );
            beneficiarie.certificate = $scope.newCertificate.datos
              .relationship_accident[index].certificate
              ? $scope.newCertificate.datos.relationship_accident[index]
                  .certificate
              : $scope.newCertificate.certificate_number
              ? $scope.newCertificate.certificate_number
              : "";
            beneficiarie.contributory = $scope.newCertificate.contributory;
            beneficiarie.rfc_cve =
              $scope.newCertificate.datos.relationship_accident[index].rfc_cve;
            beneficiarie.rfc_homocve =
              $scope.newCertificate.datos.relationship_accident[
                index
              ].rfc_homocve;
            beneficiarie.dom_callenum =
              $scope.newCertificate.datos.relationship_accident[
                index
              ].dom_callenum;
            beneficiarie.dom_colonia =
              $scope.newCertificate.datos.relationship_accident[
                index
              ].dom_colonia;
            beneficiarie.dom_cp =
              $scope.newCertificate.datos.relationship_accident[index].dom_cp;
            beneficiarie.dom_poblacion =
              $scope.newCertificate.datos.relationship_accident[
                index
              ].dom_poblacion;
            beneficiarie.dom_estado =
              $scope.newCertificate.datos.relationship_accident[
                index
              ].dom_estado;
            // Primas Dependiente
            beneficiarie.p_neta = $scope.newCertificate.datos
              .relationship_accident[index].p_neta
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .p_neta
                ).toFixed(2)
              : 0;
            beneficiarie.rpf = $scope.newCertificate.datos
              .relationship_accident[index].rpf
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index].rpf
                ).toFixed(2)
              : 0;
            beneficiarie.derecho = $scope.newCertificate.datos
              .relationship_accident[index].derecho
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .derecho
                ).toFixed(2)
              : 0;
            beneficiarie.iva = $scope.newCertificate.datos
              .relationship_accident[index].iva
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index].iva
                ).toFixed(2)
              : 0;
            beneficiarie.p_total = $scope.newCertificate.datos
              .relationship_accident[index].p_total
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .p_total
                ).toFixed(2)
              : 0;
            beneficiarie.comision = $scope.newCertificate.datos
              .relationship_accident[index].comision
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .comision
                ).toFixed(2)
              : 0;
            // Primas Dependiente Devengadas
            beneficiarie.p_neta_earned = $scope.newCertificate.datos
              .relationship_accident[index].p_neta_earned
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .p_neta_earned
                ).toFixed(2)
              : 0;
            beneficiarie.rpf_earned = $scope.newCertificate.datos
              .relationship_accident[index].rpf_earned
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .rpf_earned
                ).toFixed(2)
              : 0;
            beneficiarie.derecho_earned = $scope.newCertificate.datos
              .relationship_accident[index].derecho_earned
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .derecho_earned
                ).toFixed(2)
              : 0;
            beneficiarie.iva_earned = $scope.newCertificate.datos
              .relationship_accident[index].iva_earned
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .iva_earned
                ).toFixed(2)
              : 0;
            beneficiarie.p_total_earned = $scope.newCertificate.datos
              .relationship_accident[index].p_total_earned
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .p_total_earned
                ).toFixed(2)
              : 0;
            beneficiarie.comision_earned = $scope.newCertificate.datos
              .relationship_accident[index].comision_earned
              ? parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .comision_earned
                ).toFixed(2)
              : 0;
            // Suma
            $scope.sum_neta = parseFloat(
              parseFloat($scope.sum_neta) +
                parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .p_neta
                )
            ).toFixed(2);
            $scope.sum_rpf = parseFloat(
              parseFloat($scope.sum_rpf) +
                parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index].rpf
                )
            ).toFixed(2);
            $scope.sum_derecho = parseFloat(
              parseFloat($scope.sum_derecho) +
                parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .derecho
                )
            ).toFixed(2);
            $scope.sum_iva = parseFloat(
              parseFloat($scope.sum_iva) +
                parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index].iva
                )
            ).toFixed(2);
            $scope.sum_total = parseFloat(
              parseFloat($scope.sum_total) +
                parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .p_total
                )
            ).toFixed(2);
            $scope.sum_comision = parseFloat(
              parseFloat($scope.sum_comision) +
                parseFloat(
                  $scope.newCertificate.datos.relationship_accident[index]
                    .comision
                )
            ).toFixed(2);
          }
        );
      } else if ($scope.newCertificate.automobiles_policy.length) {
        $scope.newCertificate.automobiles_policy[0].car_owner =
          $scope.newCertificate.datos.car_owner;
        $scope.newCertificate.automobiles_policy[0].driver =
          $scope.newCertificate.datos.driver;
        $scope.newCertificate.automobiles_policy[0].email =
          $scope.newCertificate.datos.email;
        $scope.newCertificate.automobiles_policy[0].no_employee =
          $scope.newCertificate.datos.no_employee;
        $scope.newCertificate.automobiles_policy[0].brand =
          $scope.newCertificate.datos.brand;
        $scope.newCertificate.automobiles_policy[0].model =
          $scope.newCertificate.datos.model;
        $scope.newCertificate.automobiles_policy[0].year =
          $scope.newCertificate.datos.year;
        $scope.newCertificate.automobiles_policy[0].version =
          $scope.newCertificate.datos.version;
        $scope.newCertificate.automobiles_policy[0].serial =
          $scope.newCertificate.datos.serial;
        $scope.newCertificate.automobiles_policy[0].engine =
          $scope.newCertificate.datos.engine;
        $scope.newCertificate.automobiles_policy[0].color =
          $scope.newCertificate.datos.color;
        $scope.newCertificate.automobiles_policy[0].license_plates =
          $scope.newCertificate.datos.license_plates;
        $scope.newCertificate.automobiles_policy[0].usage =
          $scope.newCertificate.datos.usage.value;
        $scope.newCertificate.automobiles_policy[0].service =
          $scope.newCertificate.datos.service;
        $scope.newCertificate.automobiles_policy[0].procedencia =
          $scope.newCertificate.datos.procedencia.value;
        $scope.newCertificate.automobiles_policy[0].sum_insured =
          $scope.newCertificate.datos.sum_insured;
        $scope.newCertificate.automobiles_policy[0].charge_type =
          $scope.newCertificate.datos &&
          $scope.newCertificate.datos.charge_type &&
          $scope.newCertificate.datos.charge_type.value
            ? $scope.newCertificate.datos.charge_type.value
            : null;
        $scope.newCertificate.automobiles_policy[0].adjustment =
          $scope.newCertificate.datos.adjustment;
        $scope.newCertificate.automobiles_policy[0].mont_adjustment =
          $scope.newCertificate.datos.mont_adjustment;
        $scope.newCertificate.automobiles_policy[0].special_team =
          $scope.newCertificate.datos.special_team;
        $scope.newCertificate.automobiles_policy[0].mont_special_team =
          $scope.newCertificate.datos.mont_special_team;
        $scope.newCertificate.automobiles_policy[0].preferential_benefiaciary =
          $scope.newCertificate.datos.preferential_benefiaciary;
        $scope.newCertificate.automobiles_policy[0].beneficiary_rfc =
          $scope.newCertificate.datos.beneficiary_rfc;
        $scope.newCertificate.automobiles_policy[0].beneficiary_address =
          $scope.newCertificate.datos.beneficiary_address;
      } else if ($scope.newCertificate.damages_policy.length) {
        $scope.newCertificate.damages_policy[0].email =
          $scope.newCertificate.datos.email;
        if ($scope.caratula.subramo.subramo_name == "Incendio") {
          $scope.newCertificate.damages_policy[0].sucursal =
            $scope.newCertificate.datos.sucursal;
          $scope.newCertificate.damages_policy[0].giro =
            $scope.newCertificate.datos.giro;
          $scope.newCertificate.damages_policy[0].type_construction =
            $scope.newCertificate.datos.type_construction.value;
          $scope.newCertificate.damages_policy[0].no_levels =
            $scope.newCertificate.datos.no_levels;
          $scope.newCertificate.damages_policy[0].fhm_zone =
            $scope.newCertificate.datos.fhm_zone;
          $scope.newCertificate.damages_policy[0].tyev_zone =
            $scope.newCertificate.datos.tyev_zone;
          $scope.newCertificate.damages_policy[0].item_address =
            $scope.newCertificate.datos.item_address;
        } else if ($scope.caratula.subramo.subramo_name == "Diversos") {
          $scope.newCertificate.damages_policy[0].dam_owner =
            $scope.newCertificate.datos.dam_owner;
          $scope.newCertificate.damages_policy[0].no_employee =
            $scope.newCertificate.datos.no_employee;
          $scope.newCertificate.damages_policy[0].item_details =
            $scope.newCertificate.datos.item_details;
          $scope.newCertificate.damages_policy[0].usage =
            $scope.newCertificate.datos.usage.value;
          $scope.newCertificate.damages_policy[0].brand =
            $scope.newCertificate.datos.brand;
          $scope.newCertificate.damages_policy[0].model =
            $scope.newCertificate.datos.model;
          $scope.newCertificate.damages_policy[0].construction_year =
            $scope.newCertificate.datos.construction_year;
          $scope.newCertificate.damages_policy[0].reconstruction_year =
            $scope.newCertificate.datos.reconstruction_year;
          $scope.newCertificate.damages_policy[0].version =
            $scope.newCertificate.datos.version;
          $scope.newCertificate.damages_policy[0].serial =
            $scope.newCertificate.datos.serial;
          $scope.newCertificate.damages_policy[0].engine =
            $scope.newCertificate.datos.engine;
          $scope.newCertificate.damages_policy[0].color =
            $scope.newCertificate.datos.color;
          $scope.newCertificate.damages_policy[0].matricula =
            $scope.newCertificate.datos.matricula;
          $scope.newCertificate.damages_policy[0].permiso =
            $scope.newCertificate.datos.permiso;
          $scope.newCertificate.damages_policy[0].purchase_value =
            $scope.newCertificate.datos.purchase_value;
          $scope.newCertificate.damages_policy[0].item_address =
            $scope.newCertificate.datos.item_address;
        } else {
          $scope.newCertificate.damages_policy[0].email =
            $scope.newCertificate.datos.email;
          $scope.newCertificate.damages_policy[0].insured_item =
            $scope.newCertificate.datos.insured_item;
          $scope.newCertificate.damages_policy[0].item_details =
            $scope.newCertificate.datos.item_details;
          $scope.newCertificate.damages_policy[0].item_address =
            $scope.newCertificate.datos.item_address;
        }
      }
      $scope.updateCertificate();
    };
    $scope.saveBaja = false;
    $scope.changeBaja = function (url_c, valor, motivo_baja) {
      $scope.saveBaja = true;
      if (url_c) {
        $http
          .patch(url_c, { baja: valor, motivo_baja: motivo_baja })
          .then(function (response) {
            $scope.saveBaja = false;
            if (response.status == 200) {
              toaster.success(
                "Cambio exitoso",
                "El cambio se ha aplicado con éxito"
              );
            } else {
              $scope.saveBaja = false;
              toaster.warning("Ha ocurrido un problema", "Intente nuevamente");
              vm.form.baja = !valor;
              vm.form.motivo_baja = "";
            }
          });
      }
    };
    $scope.updateCertificate = function () {
      $scope.changes = [];
      var jsonUpdate = {
        folio: $scope.newCertificate.folio,
        status: $scope.newCertificate.status,
        start_of_validity: $scope.newCertificate.start_of_validity,
        end_of_validity: $scope.newCertificate.end_of_validity,
        p_neta: $scope.sum_neta
          ? parseFloat($scope.sum_neta).toFixed(2)
          : $scope.newCertificate.p_neta
          ? parseFloat($scope.newCertificate.p_neta).toFixed(2)
          : 0,
        rpf: $scope.sum_rpf
          ? parseFloat($scope.sum_rpf).toFixed(2)
          : $scope.newCertificate.rpf
          ? parseFloat($scope.newCertificate.rpf).toFixed(2)
          : 0,
        derecho: $scope.sum_derecho
          ? parseFloat($scope.sum_derecho).toFixed(2)
          : $scope.newCertificate.derecho
          ? parseFloat($scope.newCertificate.derecho).toFixed(2)
          : 0,
        iva: $scope.sum_iva
          ? parseFloat($scope.sum_iva).toFixed(2)
          : $scope.newCertificate.iva
          ? parseFloat($scope.newCertificate.iva).toFixed(2)
          : 0,
        p_total: $scope.sum_total
          ? parseFloat($scope.sum_total).toFixed(2)
          : $scope.newCertificate.p_total
          ? parseFloat($scope.newCertificate.p_total).toFixed(2)
          : 0,
        comision: $scope.sum_comision
          ? parseFloat($scope.sum_comision).toFixed(2)
          : $scope.newCertificate.comision
          ? parseFloat($scope.newCertificate.comision).toFixed(2)
          : 0,
        certificate_number: $scope.newCertificate.certificate_number,
        poliza_number:
          $scope.caratula.poliza_number +
          " - INC. " +
          $scope.newCertificate.certificate_number,
        contributory: $scope.newCertificate.contributory,
        document_type: 6,
        observations: $scope.newCertificate.observations
          ? $scope.newCertificate.observations
          : "",
      };

      if ($scope.newCertificate.automobiles_policy[0]) {
        jsonUpdate.fecha_baja_inciso = toDate(
          $scope.newCertificate.fecha_baja_inciso
        );
      }
      try {
        if ($scope.newCertificate.rec_antiguedad) {
          jsonUpdate.rec_antiguedad = $scope.newCertificate.rec_antiguedad;
        }
      } catch (e) {}
      $http
        .patch($scope.newCertificate.url, jsonUpdate)
        .then(function success(request) {
          if (request.status === 200) {
            $localStorage.save_edition_poliza_certificado = {};
            if (
              convertDate($scope.originCertificate.start_of_validity) !==
              convertDate(request.data.start_of_validity)
            ) {
              var change_log = {
                name: "Vigencia Inicio",
                origin: convertDate($scope.originCertificate.start_of_validity),
                change: convertDate(request.data.start_of_validity),
              };
              $scope.changes.push(change_log);
            }
            if (
              convertDate($scope.originCertificate.end_of_validity) !==
              convertDate(request.data.end_of_validity)
            ) {
              var change_log = {
                name: "Vigencia Fin",
                origin: convertDate($scope.originCertificate.end_of_validity),
                change: convertDate(request.data.end_of_validity),
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCertificate.p_neta !== request.data.p_neta) {
              var change_log = {
                name: "Prima Neta",
                origin: $scope.originCertificate.p_neta,
                change: request.data.p_neta,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCertificate.rpf !== request.data.rpf) {
              var change_log = {
                name: "RPF",
                origin: $scope.originCertificate.rpf,
                change: request.data.rpf,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCertificate.derecho !== request.data.derecho) {
              var change_log = {
                name: "Derecho",
                origin: $scope.originCertificate.derecho,
                change: request.data.derecho,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCertificate.iva !== request.data.iva) {
              var change_log = {
                name: "IVA",
                origin: $scope.originCertificate.iva,
                change: request.data.iva,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCertificate.p_total !== request.data.p_total) {
              var change_log = {
                name: "Prima Total",
                origin: $scope.originCertificate.p_total,
                change: request.data.p_total,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCertificate.comision !== request.data.comision) {
              var change_log = {
                name: "Comisión",
                origin: $scope.originCertificate.comision,
                change: request.data.comision,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.newCertificate.life_policy.length) {
              $scope.newCertificate.life_policy[0].personal.certificate =
                jsonUpdate.certificate_number;
              $http
                .patch(
                  $scope.newCertificate.life_policy[0].personal.url,
                  $scope.newCertificate.life_policy[0].personal
                )
                .then(function success(response) {
                  if (response.status == 200) {
                    // log life
                    if ($scope.newCertificate.life_policy[0].personal) {
                      if (
                        $scope.originCertificate.datos.personal.first_name !==
                        response.data.first_name
                      ) {
                        var change_log = {
                          name: "Nombre",
                          origin:
                            $scope.originCertificate.datos.personal.first_name,
                          change: response.data.first_name,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.personal.last_name !==
                        response.data.last_name
                      ) {
                        var change_log = {
                          name: "A. Paterno",
                          origin:
                            $scope.originCertificate.datos.personal.last_name,
                          change: response.data.last_name,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.personal
                          .second_last_name !== response.data.second_last_name
                      ) {
                        var change_log = {
                          name: "A. Materno",
                          origin:
                            $scope.originCertificate.datos.personal
                              .second_last_name,
                          change: response.data.second_last_name,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.personal.email !==
                        response.data.email
                      ) {
                        var change_log = {
                          name: "Correo",
                          origin: $scope.originCertificate.datos.personal.email,
                          change: response.data.email,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        convertDate(
                          $scope.originCertificate.datos.personal.birthdate
                        ) !== convertDate(response.data.birthdate)
                      ) {
                        var change_log = {
                          name: "Fecha Nacimiento",
                          origin: convertDate(
                            $scope.originCertificate.datos.personal.birthdate
                          ),
                          change: convertDate(response.data.birthdate),
                        };
                        $scope.changes.push(change_log);
                      }
                      if ($scope.originCertificate.datos.personal.sex.value) {
                        if (
                          $scope.originCertificate.datos.personal.sex.value !==
                          response.data.sex
                        ) {
                          var change_log = {
                            name: "Género",
                            origin:
                              $scope.originCertificate.datos.personal.sex
                                .value == "F"
                                ? "Femenino"
                                : "Masculino",
                            change:
                              response.data.sex == F ? "Femenino" : "Masculino",
                          };
                          $scope.changes.push(change_log);
                        }
                      } else if (
                        $scope.originCertificate.datos.personal.sex !==
                        response.data.sex
                      ) {
                        var change_log = {
                          name: "Género",
                          origin:
                            $scope.originCertificate.datos.personal.sex == "F"
                              ? "Femenino"
                              : "Masculino",
                          change:
                            response.data.sex == F ? "Femenino" : "Masculino",
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.personal.type_sa.value
                      ) {
                        if (
                          $scope.originCertificate.datos.personal.type_sa
                            .value !== response.data.type_sa
                        ) {
                          var change_log = {
                            name: "Tipo S.A.",
                            origin:
                              $scope.originCertificate.datos.personal.type_sa
                                .value,
                            change: response.data.type_sa,
                          };
                          $scope.changes.push(change_log);
                        }
                      } else if (
                        $scope.originCertificate.datos.personal.type_sa !==
                        response.data.type_sa
                      ) {
                        var change_log = {
                          name: "Tipo S.A.",
                          origin:
                            $scope.originCertificate.datos.personal.type_sa,
                          change: response.data.type_sa,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.personal.sum_assured !==
                        response.data.sum_assured
                      ) {
                        var change_log = {
                          name: "Suma Asegurada",
                          origin:
                            $scope.originCertificate.datos.personal.sum_assured,
                          change: response.data.sum_assured,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.personal.salary !==
                        response.data.salary
                      ) {
                        var change_log = {
                          name: "Sueldo",
                          origin:
                            $scope.originCertificate.datos.personal.salary,
                          change: response.data.salary,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.personal.smoker !==
                        response.data.smoker
                      ) {
                        var change_log = {
                          name: "Fumador",
                          origin:
                            $scope.originCertificate.datos.personal.smoker,
                          change: response.data.smoker,
                        };
                        $scope.changes.push(change_log);
                      }
                    }

                    var paramsRec = {
                      model: 25,
                      event: "PATCH",
                      associated_id: $scope.newCertificate.id,
                      identifier: " actualizó el certificado.",
                      change: $scope.changes,
                    };
                    if ($scope.changes.length != 0) {
                      dataFactory
                        .post("send_log_specific/", paramsRec)
                        .then(function success(response) {});
                    }
                  }
                })
                .catch(function (e) {
                  console.log("error", e);
                });
              if (
                $scope.newCertificate.life_policy[0].beneficiaries_life.length
              ) {
                $scope.newCertificate.life_policy[0].beneficiaries_life.forEach(
                  function (item, index) {
                    $http
                      .patch(item.url, item)
                      .then(function success(response) {
                        if (response.status == 200) {
                          $scope.changesBeneficiarie = [];
                          if (
                            $scope.originCertificate.datos.beneficiaries_life[
                              index
                            ].first_name !== response.data.first_name
                          ) {
                            var change_log = {
                              name: "Nombre",
                              origin:
                                $scope.originCertificate.datos
                                  .beneficiaries_life[index].first_name,
                              change: response.data.first_name,
                            };
                            $scope.changesBeneficiarie.push(change_log);
                          }
                          if (
                            $scope.originCertificate.datos.beneficiaries_life[
                              index
                            ].last_name !== response.data.last_name
                          ) {
                            var change_log = {
                              name: "A. Paterno",
                              origin:
                                $scope.originCertificate.datos
                                  .beneficiaries_life[index].last_name,
                              change: response.data.last_name,
                            };
                            $scope.changesBeneficiarie.push(change_log);
                          }
                          if (
                            $scope.originCertificate.datos.beneficiaries_life[
                              index
                            ].second_last_name !==
                            response.data.second_last_name
                          ) {
                            var change_log = {
                              name: "A. Materno",
                              origin:
                                $scope.originCertificate.datos
                                  .beneficiaries_life[index].second_last_name,
                              change: response.data.second_last_name,
                            };
                            $scope.changesBeneficiarie.push(change_log);
                          }
                          if (
                            $scope.originCertificate.datos.beneficiaries_life[
                              index
                            ].sex.value
                          ) {
                            if (
                              $scope.originCertificate.datos.beneficiaries_life[
                                index
                              ].sex.value !== response.data.sex
                            ) {
                              var change_log = {
                                name: "Género",
                                origin:
                                  $scope.originCertificate.datos
                                    .beneficiaries_life[index].sex.value == "F"
                                    ? "Femenino"
                                    : "Masculino",
                                change:
                                  response.data.sex == "F"
                                    ? "Femenino"
                                    : "Masculino",
                              };
                              $scope.changesBeneficiarie.push(change_log);
                            }
                          } else if (
                            $scope.originCertificate.datos.beneficiaries_life[
                              index
                            ].sex !== response.data.sex
                          ) {
                            var change_log = {
                              name: "Género",
                              origin:
                                $scope.originCertificate.datos
                                  .beneficiaries_life[index].sex == "F"
                                  ? "Femenino"
                                  : "Masculino",
                              change:
                                response.data.sex == "F"
                                  ? "Femenino"
                                  : "Masculino",
                            };
                            $scope.changesBeneficiarie.push(change_log);
                          }
                          if (
                            convertDate(
                              $scope.originCertificate.datos.beneficiaries_life[
                                index
                              ].birthdate
                            ) !== convertDate(response.data.birthdate)
                          ) {
                            var change_log = {
                              name: "Fecha Nacimiento",
                              origin: convertDate(
                                $scope.originCertificate.datos
                                  .beneficiaries_life[index].birthdate
                              ),
                              change: convertDate(response.data.birthdate),
                            };
                            $scope.changesBeneficiarie.push(change_log);
                          }
                          if (
                            $scope.originCertificate.datos.beneficiaries_life[
                              index
                            ].optional_relationship.value
                          ) {
                            if (
                              parseInt(
                                $scope.originCertificate.datos
                                  .beneficiaries_life[index]
                                  .optional_relationship.value
                              ) !==
                              parseInt(response.data.optional_relationship)
                            ) {
                              var change_log = {
                                name: "Parentesco",
                                origin:
                                  $scope.originCertificate.datos
                                    .beneficiaries_life[index]
                                    .optional_relationship.value == 1
                                    ? "Titular"
                                    : $scope.originCertificate.datos
                                        .beneficiaries_life[index]
                                        .optional_relationship.value == 2
                                    ? "Cónyuge"
                                    : $scope.originCertificate.datos
                                        .beneficiaries_life[index]
                                        .optional_relationship.value == 3
                                    ? "Hijo"
                                    : "Otro",
                                change:
                                  response.data.relationship == 1
                                    ? "Titular"
                                    : response.data.relationship == 2
                                    ? "Cónyuge"
                                    : response.data.relationship == 3
                                    ? "Hijo"
                                    : "Otro",
                              };
                              $scope.changesBeneficiarie.push(change_log);
                            }
                          } else if (
                            parseInt(
                              $scope.originCertificate.datos.beneficiaries_life[
                                index
                              ].optional_relationship
                            ) !== parseInt(response.data.optional_relationship)
                          ) {
                            var change_log = {
                              name: "Parentesco",
                              origin:
                                $scope.originCertificate.datos
                                  .beneficiaries_life[index]
                                  .optional_relationship == 1
                                  ? "Titular"
                                  : $scope.originCertificate.datos
                                      .beneficiaries_life[index]
                                      .optional_relationship == 2
                                  ? "Cónyuge"
                                  : $scope.originCertificate.datos
                                      .beneficiaries_life[index]
                                      .optional_relationship == 3
                                  ? "Hijo"
                                  : "Otro",
                              change:
                                response.data.relationship == 1
                                  ? "Titular"
                                  : response.data.relationship == 2
                                  ? "Cónyuge"
                                  : response.data.relationship == 3
                                  ? "Hijo"
                                  : "Otro",
                            };
                            $scope.changesBeneficiarie.push(change_log);
                          }
                          if (
                            convertDate(
                              $scope.originCertificate.datos.beneficiaries_life[
                                index
                              ].antiguedad
                            ) !== convertDate(response.data.antiguedad)
                          ) {
                            var change_log = {
                              name: "Fecha Antigüedad",
                              origin:
                                $scope.originCertificate.datos
                                  .beneficiaries_life[index].antiguedad,
                              change: convertDate(response.data.antiguedad),
                            };
                            $scope.changesBeneficiarie.push(change_log);
                          }
                          var paramsRec = {
                            model: 25,
                            event: "PATCH",
                            associated_id: $scope.newCertificate.id,
                            identifier:
                              " actualizó el beneficiario " +
                              response.data.first_name +
                              " " +
                              response.data.last_name +
                              " " +
                              response.data.second_last_name +
                              ".",
                            change: $scope.changesBeneficiarie,
                          };
                          if ($scope.changesBeneficiarie.length != 0) {
                            dataFactory
                              .post("send_log_specific/", paramsRec)
                              .then(function success(response) {});
                          }
                          $scope.selectCerficate($scope.newCertificate);
                          SweetAlert.swal(
                            "¡Listo!",
                            "Certificado actualizado exitosamente.",
                            "success"
                          );
                        }
                      })
                      .catch(function (e) {
                        console.log("error", e);
                      });
                  }
                );
              } else {
                $scope.selectCerficate($scope.newCertificate);
                SweetAlert.swal(
                  "¡Listo!",
                  "Certificado actualizado exitosamente.",
                  "success"
                );
              }
            } else if ($scope.newCertificate.accidents_policy.length) {
              $scope.newCertificate.accidents_policy[0].personal.certificate =
                jsonUpdate.certificate_number;
              $http
                .patch(
                  $scope.newCertificate.accidents_policy[0].personal.url,
                  $scope.newCertificate.accidents_policy[0].personal
                )
                .then(function success(response) {
                  if (response.status == 200) {
                    // log accyenf
                    if ($scope.newCertificate.accidents_policy[0].personal) {
                      if (
                        $scope.originCertificate.datos.personal.first_name !==
                        response.data.first_name
                      ) {
                        var change_log = {
                          name: "Nombre",
                          origin:
                            $scope.originCertificate.datos.personal.first_name,
                          change: response.data.first_name,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.personal.last_name !==
                        response.data.last_name
                      ) {
                        var change_log = {
                          name: "A. Paterno",
                          origin:
                            $scope.originCertificate.datos.personal.last_name,
                          change: response.data.last_name,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.personal
                          .second_last_name !== response.data.second_last_name
                      ) {
                        var change_log = {
                          name: "A. Materno",
                          origin:
                            $scope.originCertificate.datos.personal
                              .second_last_name,
                          change: response.data.second_last_name,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.personal.email !==
                        response.data.email
                      ) {
                        var change_log = {
                          name: "Correo",
                          origin: $scope.originCertificate.datos.personal.email,
                          change: response.data.email,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        convertDate(
                          $scope.originCertificate.datos.personal.birthdate
                        ) !== convertDate(response.data.birthdate)
                      ) {
                        var change_log = {
                          name: "Fecha Nacimiento",
                          origin: convertDate(
                            $scope.originCertificate.datos.personal.birthdate
                          ),
                          change: convertDate(response.data.birthdate),
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.personal &&
                        $scope.originCertificate.datos.personal.sex &&
                        $scope.originCertificate.datos.personal.sex.value
                      ) {
                        if (
                          $scope.originCertificate.datos.personal.sex.value !==
                          response.data.sex
                        ) {
                          var change_log = {
                            name: "Género",
                            origin:
                              $scope.originCertificate.datos.personal.sex
                                .value == "F"
                                ? "Femenino"
                                : "Masculino",
                            change:
                              response.data.sex == F ? "Femenino" : "Masculino",
                          };
                          $scope.changes.push(change_log);
                        }
                      } else if (
                        $scope.originCertificate.datos.personal.sex !==
                        response.data.sex
                      ) {
                        var change_log = {
                          name: "Género",
                          origin:
                            $scope.originCertificate.datos.personal.sex == "F"
                              ? "Femenino"
                              : "Masculino",
                          change:
                            response.data.sex == F ? "Femenino" : "Masculino",
                        };
                        $scope.changes.push(change_log);
                      }
                    }

                    var paramsRec = {
                      model: 25,
                      event: "PATCH",
                      associated_id: $scope.newCertificate.id,
                      identifier: " actualizó el certificado.",
                      change: $scope.changes,
                    };
                    if ($scope.changes.length != 0) {
                      dataFactory
                        .post("send_log_specific/", paramsRec)
                        .then(function success(response) {});
                    }
                  }
                })
                .catch(function (e) {
                  console.log("error", e);
                });
              if (
                $scope.newCertificate.accidents_policy[0].relationship_accident
                  .length
              ) {
                $scope.newCertificate.accidents_policy[0].relationship_accident.forEach(
                  function (item, index) {
                    $http
                      .patch(item.url, item)
                      .then(function success(response) {
                        if (response.status == 200) {
                          $scope.changesDependient = [];
                          if (
                            $scope.originCertificate.datos
                              .relationship_accident[index].first_name !==
                            response.data.first_name
                          ) {
                            var change_log = {
                              name: "Nombre",
                              origin:
                                $scope.originCertificate.datos
                                  .relationship_accident[index].first_name,
                              change: response.data.first_name,
                            };
                            $scope.changesDependient.push(change_log);
                          }
                          if (
                            $scope.originCertificate.datos
                              .relationship_accident[index].last_name !==
                            response.data.last_name
                          ) {
                            var change_log = {
                              name: "A. Paterno",
                              origin:
                                $scope.originCertificate.datos
                                  .relationship_accident[index].last_name,
                              change: response.data.last_name,
                            };
                            $scope.changesDependient.push(change_log);
                          }
                          if (
                            $scope.originCertificate.datos
                              .relationship_accident[index].second_last_name !==
                            response.data.second_last_name
                          ) {
                            var change_log = {
                              name: "A. Materno",
                              origin:
                                $scope.originCertificate.datos
                                  .relationship_accident[index]
                                  .second_last_name,
                              change: response.data.second_last_name,
                            };
                            $scope.changesDependient.push(change_log);
                          }
                          if (
                            $scope.originCertificate.datos
                              .relationship_accident[index] &&
                            $scope.originCertificate.datos
                              .relationship_accident[index].sex &&
                            $scope.originCertificate.datos
                              .relationship_accident[index].sex.value
                          ) {
                            if (
                              $scope.originCertificate.datos
                                .relationship_accident[index].sex.value !==
                              response.data.sex
                            ) {
                              var change_log = {
                                name: "Género",
                                origin:
                                  $scope.originCertificate.datos
                                    .relationship_accident[index].sex.value ==
                                  "F"
                                    ? "Femenino"
                                    : "Masculino",
                                change:
                                  response.data.sex == "F"
                                    ? "Femenino"
                                    : "Masculino",
                              };
                              $scope.changesDependient.push(change_log);
                            }
                          } else if (
                            $scope.originCertificate.datos
                              .relationship_accident[index].sex !==
                            response.data.sex
                          ) {
                            var change_log = {
                              name: "Género",
                              origin:
                                $scope.originCertificate.datos
                                  .relationship_accident[index].sex == "F"
                                  ? "Femenino"
                                  : "Masculino",
                              change:
                                response.data.sex == "F"
                                  ? "Femenino"
                                  : "Masculino",
                            };
                            $scope.changesDependient.push(change_log);
                          }
                          if (
                            convertDate(
                              $scope.originCertificate.datos
                                .relationship_accident[index].birthdate
                            ) !== convertDate(response.data.birthdate)
                          ) {
                            var change_log = {
                              name: "Fecha Nacimiento",
                              origin: convertDate(
                                $scope.originCertificate.datos
                                  .relationship_accident[index].birthdate
                              ),
                              change: convertDate(response.data.birthdate),
                            };
                            $scope.changesDependient.push(change_log);
                          }
                          if (
                            $scope.originCertificate.datos
                              .relationship_accident[index].relationship.value
                          ) {
                            if (
                              parseInt(
                                $scope.originCertificate.datos
                                  .relationship_accident[index].relationship
                                  .value
                              ) !== parseInt(response.data.relationship)
                            ) {
                              var change_log = {
                                name: "Parentesco",
                                origin:
                                  $scope.originCertificate.datos
                                    .relationship_accident[index]
                                    .relationship == 1
                                    ? "Titular"
                                    : $scope.originCertificate.datos
                                        .relationship_accident[index]
                                        .relationship == 2
                                    ? "Cónyuge"
                                    : $scope.originCertificate.datos
                                        .relationship_accident[index]
                                        .relationship == 3
                                    ? "Hijo"
                                    : "Otro",
                                change:
                                  response.data.relationship == 1
                                    ? "Titular"
                                    : response.data.relationship == 2
                                    ? "Cónyuge"
                                    : response.data.relationship == 3
                                    ? "Hijo"
                                    : "Otro",
                              };
                              $scope.changesDependient.push(change_log);
                            }
                          } else if (
                            parseInt(
                              $scope.originCertificate.datos
                                .relationship_accident[index].relationship
                            ) !== parseInt(response.data.relationship)
                          ) {
                            var change_log = {
                              name: "Parentesco",
                              origin:
                                $scope.originCertificate.datos
                                  .relationship_accident[index].relationship ==
                                1
                                  ? "Titular"
                                  : $scope.originCertificate.datos
                                      .relationship_accident[index]
                                      .relationship == 2
                                  ? "Cónyuge"
                                  : $scope.originCertificate.datos
                                      .relationship_accident[index]
                                      .relationship == 3
                                  ? "Hijo"
                                  : "Otro",
                              change:
                                response.data.relationship == 1
                                  ? "Titular"
                                  : response.data.relationship == 2
                                  ? "Cónyuge"
                                  : response.data.relationship == 3
                                  ? "Hijo"
                                  : "Otro",
                            };
                            $scope.changesDependient.push(change_log);
                          }
                          if (
                            convertDate(
                              $scope.originCertificate.datos
                                .relationship_accident[index].antiguedad
                            ) !== convertDate(response.data.antiguedad)
                          ) {
                            var change_log = {
                              name: "Fecha Antigüedad",
                              origin: convertDate(
                                $scope.originCertificate.datos
                                  .relationship_accident[index].antiguedad
                              ),
                              change: convertDate(response.data.antiguedad),
                            };
                            $scope.changesDependient.push(change_log);
                          }
                          var paramsRec = {
                            model: 25,
                            event: "PATCH",
                            associated_id: $scope.newCertificate.id,
                            identifier:
                              " actualizó el dependiente " +
                              response.data.first_name +
                              " " +
                              response.data.last_name +
                              " " +
                              response.data.second_last_name +
                              ".",
                            change: $scope.changesDependient,
                          };
                          if ($scope.changesDependient.length != 0) {
                            dataFactory
                              .post("send_log_specific/", paramsRec)
                              .then(function success(response) {});
                          }
                          $scope.selectCerficate($scope.newCertificate);
                          SweetAlert.swal(
                            "¡Listo!",
                            "Certificado actualizado exitosamente.",
                            "success"
                          );
                        }
                      })
                      .catch(function (e) {
                        console.log("error", e);
                      });
                  }
                );
              } else {
                $scope.selectCerficate($scope.newCertificate);
                SweetAlert.swal(
                  "¡Listo!",
                  "Certificado actualizado exitosamente.",
                  "success"
                );
              }
            } else if ($scope.newCertificate.automobiles_policy.length) {
              if ($scope.newCertificate.certificado_inciso_activo) {
                $http
                  .patch(
                    $scope.newCertificate.automobiles_policy[0].url,
                    $scope.newCertificate.automobiles_policy[0]
                  )
                  .then(function success(response) {
                    if (response.status == 200) {
                      // log automobiles
                      if ($scope.newCertificate.automobiles_policy[0]) {
                        if (
                          $scope.originCertificate.datos.car_owner !==
                          response.data.car_owner
                        ) {
                          var change_log = {
                            name: "Propietario",
                            origin: $scope.originCertificate.datos.car_owner,
                            change: response.data.car_owner,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.driver !==
                          response.data.driver
                        ) {
                          var change_log = {
                            name: "Conductor",
                            origin: $scope.originCertificate.datos.driver,
                            change: response.data.driver,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.no_employee !==
                          response.data.no_employee
                        ) {
                          var change_log = {
                            name: "No. Empleado",
                            origin: $scope.originCertificate.datos.no_employee,
                            change: response.data.no_employee,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.brand !==
                          response.data.brand
                        ) {
                          var change_log = {
                            name: "Marca",
                            origin: $scope.originCertificate.datos.brand,
                            change: response.data.brand,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.model !==
                          response.data.model
                        ) {
                          var change_log = {
                            name: "Modelo",
                            origin: $scope.originCertificate.datos.model,
                            change: response.data.model,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.year !==
                          response.data.year
                        ) {
                          var change_log = {
                            name: "Año",
                            origin: $scope.originCertificate.datos.year,
                            change: response.data.year,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.version !==
                          response.data.version
                        ) {
                          var change_log = {
                            name: "Versión",
                            origin: $scope.originCertificate.datos.version,
                            change: response.data.version,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.serial !==
                          response.data.serial
                        ) {
                          var change_log = {
                            name: "Serie",
                            origin: $scope.originCertificate.datos.serial,
                            change: response.data.serial,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.engine !==
                          response.data.engine
                        ) {
                          var change_log = {
                            name: "Motor",
                            origin: $scope.originCertificate.datos.engine,
                            change: response.data.engine,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.color !==
                          response.data.color
                        ) {
                          var change_log = {
                            name: "Color",
                            origin: $scope.originCertificate.datos.color,
                            change: response.data.color,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.license_plates !==
                          response.data.license_plates
                        ) {
                          var change_log = {
                            name: "Matrícula",
                            origin:
                              $scope.originCertificate.datos.license_plates,
                            change: response.data.license_plates,
                          };
                          $scope.changes.push(change_log);
                        }
                        if ($scope.originCertificate.datos.usage.value) {
                          if (
                            parseInt(
                              $scope.originCertificate.datos.usage.value
                            ) !== parseInt(response.data.usage)
                          ) {
                            var change_log = {
                              name: "Uso",
                              origin:
                                $scope.originCertificate.datos.usage.value == 1
                                  ? "Particular"
                                  : $scope.originCertificate.datos.usage
                                      .value == 2
                                  ? "Carga Comercial"
                                  : "Servicio Público",
                              change:
                                response.data.usage == 1
                                  ? "Particular"
                                  : response.data.usage == 2
                                  ? "Carga Comercial"
                                  : "Servicio Público",
                            };
                            $scope.changes.push(change_log);
                          }
                        } else if (
                          parseInt($scope.originCertificate.datos.usage) !==
                          parseInt(response.data.usage)
                        ) {
                          var change_log = {
                            name: "Uso",
                            origin:
                              $scope.originCertificate.datos.usage == 1
                                ? "Particular"
                                : $scope.originCertificate.datos.usage == 2
                                ? "Carga Comercial"
                                : "Servicio Público",
                            change:
                              response.data.usage == 1
                                ? "Particular"
                                : response.data.usage == 2
                                ? "Carga Comercial"
                                : "Servicio Público",
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.service !==
                          response.data.service
                        ) {
                          var change_log = {
                            name: "Servicio",
                            origin: $scope.originCertificate.datos.service,
                            change: response.data.service,
                          };
                          $scope.changes.push(change_log);
                        }
                        if ($scope.originCertificate.datos.procedencia.value) {
                          if (
                            parseInt(
                              $scope.originCertificate.datos.procedencia.value
                            ) !== parseInt(response.data.procedencia)
                          ) {
                            var change_log = {
                              name: "Procedencia",
                              origin:
                                $scope.originCertificate.datos.procedencia
                                  .value == 0
                                  ? "Sin especificar"
                                  : $scope.originCertificate.datos.procedencia
                                      .value == 1
                                  ? "Residencia"
                                  : $scope.originCertificate.datos.procedencia
                                      .value == 2
                                  ? "Turista"
                                  : $scope.originCertificate.datos.procedencia
                                      .value == 3
                                  ? "Legalizado"
                                  : "Fronterizo",
                              change:
                                response.data.procedencia == 0
                                  ? "Sin especificar"
                                  : response.data.procedencia == 1
                                  ? "Residencia"
                                  : response.data.procedencia == 2
                                  ? "Turista"
                                  : response.data.procedencia == 3
                                  ? "Legalizado"
                                  : "Fronterizo",
                            };
                            $scope.changes.push(change_log);
                          }
                        } else if (
                          parseInt(
                            $scope.originCertificate.datos.procedencia
                          ) !== parseInt(response.data.procedencia)
                        ) {
                          var change_log = {
                            name: "Procedencia",
                            origin:
                              $scope.originCertificate.datos.procedencia == 0
                                ? "Sin especificar"
                                : $scope.originCertificate.datos.procedencia ==
                                  1
                                ? "Residencia"
                                : $scope.originCertificate.datos.procedencia ==
                                  2
                                ? "Turista"
                                : $scope.originCertificate.datos.procedencia ==
                                  3
                                ? "Legalizado"
                                : "Fronterizo",
                            change:
                              response.data.procedencia == 0
                                ? "Sin especificar"
                                : response.data.procedencia == 1
                                ? "Residencia"
                                : response.data.procedencia == 2
                                ? "Turista"
                                : response.data.procedencia == 3
                                ? "Legalizado"
                                : "Fronterizo",
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.sum_insured !==
                          response.data.sum_insured
                        ) {
                          var change_log = {
                            name: "Suma Asegurada",
                            origin: $scope.originCertificate.datos.sum_insured,
                            change: response.data.sum_insured,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.charge_type &&
                          $scope.originCertificate.datos.charge_type.value
                        ) {
                          if (
                            parseInt(
                              $scope.originCertificate.datos.charge_type.value
                            ) !== parseInt(response.data.charge_type)
                          ) {
                            var change_log = {
                              name: "Tipo Carga",
                              origin:
                                $scope.originCertificate.datos.charge_type
                                  .value == 1
                                  ? "A"
                                  : $scope.originCertificate.datos.charge_type
                                      .value == 2
                                  ? "B"
                                  : "C",
                              change:
                                response.data.charge_type == 1
                                  ? "A"
                                  : response.data.charge_type == 2
                                  ? "B"
                                  : "C",
                            };
                            $scope.changes.push(change_log);
                          }
                        } else if (
                          parseInt(
                            $scope.originCertificate.datos.charge_type
                          ) !== parseInt(response.data.charge_type)
                        ) {
                          var change_log = {
                            name: "Tipo Carga",
                            origin:
                              $scope.originCertificate.datos.charge_type == 1
                                ? "A"
                                : $scope.originCertificate.datos.charge_type ==
                                  2
                                ? "B"
                                : "C",
                            change:
                              response.data.charge_type == 1
                                ? "A"
                                : response.data.charge_type == 2
                                ? "B"
                                : "C",
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.adjustment !==
                          response.data.adjustment
                        ) {
                          var change_log = {
                            name: "Adaptaciones",
                            origin: $scope.originCertificate.datos.adjustment,
                            change: response.data.adjustment,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.mont_adjustment !==
                          response.data.mont_adjustment
                        ) {
                          var change_log = {
                            name: "Monto Adaptaciones",
                            origin:
                              $scope.originCertificate.datos.mont_adjustment,
                            change: response.data.mont_adjustment,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.special_team !==
                          response.data.special_team
                        ) {
                          var change_log = {
                            name: "Equipamiento",
                            origin: $scope.originCertificate.datos.special_team,
                            change: response.data.special_team,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.mont_special_team !==
                          response.data.mont_special_team
                        ) {
                          var change_log = {
                            name: "Monto Equipamiento",
                            origin:
                              $scope.originCertificate.datos.mont_special_team,
                            change: response.data.mont_special_team,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos
                            .preferential_benefiaciary !==
                          response.data.preferential_benefiaciary
                        ) {
                          var change_log = {
                            name: "Beneficiario",
                            origin:
                              $scope.originCertificate.datos
                                .preferential_benefiaciary,
                            change: response.data.preferential_benefiaciary,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.beneficiary_rfc !==
                          response.data.beneficiary_rfc
                        ) {
                          var change_log = {
                            name: "Beneficiario RFC",
                            origin:
                              $scope.originCertificate.datos.beneficiary_rfc,
                            change: response.data.beneficiary_rfc,
                          };
                          $scope.changes.push(change_log);
                        }
                        if (
                          $scope.originCertificate.datos.beneficiary_address !==
                          response.data.beneficiary_address
                        ) {
                          var change_log = {
                            name: "Beneficiario Dirección",
                            origin:
                              $scope.originCertificate.datos
                                .beneficiary_address,
                            change: response.data.beneficiary_address,
                          };
                          $scope.changes.push(change_log);
                        }
                        var paramsRec = {
                          model: 25,
                          event: "PATCH",
                          associated_id: $scope.newCertificate.id,
                          identifier: " actualizó el certificado.",
                          change: $scope.changes,
                        };
                        if ($scope.changes) {
                          dataFactory
                            .post("send_log_specific/", paramsRec)
                            .then(function success(response) {
                              $scope.changes = [];
                            });
                        }
                      }
                      $scope.selectCerficate($scope.newCertificate);
                      SweetAlert.swal(
                        "¡Listo!",
                        "Certificado actualizado exitosamente.",
                        "success"
                      );
                    }
                  })
                  .catch(function (e) {
                    console.log("error", e);
                  });
              } else {
                $scope.selectCerficate($scope.newCertificate);
                SweetAlert.swal(
                  "¡Listo!",
                  "Certificado actualizado exitosamente.",
                  "success"
                );
              }
            } else if ($scope.newCertificate.damages_policy.length) {
              try {
                delete $scope.newCertificate.damages_policy[0].damage_type;
              } catch (u) {}
              $http
                .patch(
                  $scope.newCertificate.damages_policy[0].url,
                  $scope.newCertificate.damages_policy[0]
                )
                .then(function success(response) {
                  if (response.status == 200) {
                    // log diversos-incendio
                    if ($scope.newCertificate.damages_policy[0]) {
                      if (
                        $scope.originCertificate.datos.dam_owner !==
                        response.data.dam_owner
                      ) {
                        var change_log = {
                          name: "Propietario",
                          origin: $scope.originCertificate.datos.dam_owner,
                          change: response.data.dam_owner,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.insured_item !==
                        response.data.insured_item
                      ) {
                        var change_log = {
                          name: "Asegurado",
                          origin: $scope.originCertificate.datos.insured_item,
                          change: response.data.insured_item,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.email !==
                        response.data.email
                      ) {
                        var change_log = {
                          name: "Correo",
                          origin: $scope.originCertificate.datos.email,
                          change: response.data.email,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.no_employee !==
                        response.data.no_employee
                      ) {
                        var change_log = {
                          name: "No.Empleado",
                          origin: $scope.originCertificate.datos.no_employee,
                          change: response.data.no_employee,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.item_details !==
                        response.data.item_details
                      ) {
                        var change_log = {
                          name: "Descripción",
                          origin: $scope.originCertificate.datos.item_details,
                          change: response.data.item_details,
                        };
                        $scope.changes.push(change_log);
                      }
                      if ($scope.originCertificate.datos.usage) {
                        if ($scope.originCertificate.datos.usage.value) {
                          if (
                            parseInt(
                              $scope.originCertificate.datos.usage.value
                            ) !== parseInt(response.data.usage)
                          ) {
                            var change_log = {
                              name: "Uso",
                              origin:
                                $scope.originCertificate.datos.usage.value == 1
                                  ? "Particular"
                                  : $scope.originCertificate.datos.usage
                                      .value == 2
                                  ? "Carga Comercial"
                                  : "Servicio Público",
                              change:
                                response.data.usage == 1
                                  ? "Particular"
                                  : response.data.usage == 2
                                  ? "Carga Comercial"
                                  : "Servicio Público",
                            };
                            $scope.changes.push(change_log);
                          }
                        } else if (
                          parseInt($scope.originCertificate.datos.usage) !==
                          parseInt(response.data.usage)
                        ) {
                          var change_log = {
                            name: "Uso",
                            origin:
                              $scope.originCertificate.datos.usage == 1
                                ? "Particular"
                                : $scope.originCertificate.datos.usage == 2
                                ? "Carga Comercial"
                                : "Servicio Público",
                            change:
                              response.data.usage == 1
                                ? "Particular"
                                : response.data.usage == 2
                                ? "Carga Comercial"
                                : "Servicio Público",
                          };
                          $scope.changes.push(change_log);
                        }
                      }
                      if (
                        $scope.originCertificate.datos.brand !==
                        response.data.brand
                      ) {
                        var change_log = {
                          name: "Marca",
                          origin: $scope.originCertificate.datos.brand,
                          change: response.data.brand,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.model !==
                        response.data.model
                      ) {
                        var change_log = {
                          name: "Modelo",
                          origin: $scope.originCertificate.datos.model,
                          change: response.data.model,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.construction_year !==
                        response.data.construction_year
                      ) {
                        var change_log = {
                          name: "Año Construcción",
                          origin:
                            $scope.originCertificate.datos.construction_year,
                          change: response.data.construction_year,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.reconstruction_year !==
                        response.data.reconstruction_year
                      ) {
                        var change_log = {
                          name: "Año Reconstrucción",
                          origin:
                            $scope.originCertificate.datos.reconstruction_year,
                          change: response.data.reconstruction_year,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.version !==
                        response.data.version
                      ) {
                        var change_log = {
                          name: "Versión",
                          origin: $scope.originCertificate.datos.version,
                          change: response.data.version,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.serial !==
                        response.data.serial
                      ) {
                        var change_log = {
                          name: "Serie",
                          origin: $scope.originCertificate.datos.serial,
                          change: response.data.serial,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.engine !==
                        response.data.engine
                      ) {
                        var change_log = {
                          name: "Motor",
                          origin: $scope.originCertificate.datos.engine,
                          change: response.data.engine,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.color !==
                        response.data.color
                      ) {
                        var change_log = {
                          name: "Color",
                          origin: $scope.originCertificate.datos.color,
                          change: response.data.color,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.matricula !==
                        response.data.matricula
                      ) {
                        var change_log = {
                          name: "Matrícula",
                          origin: $scope.originCertificate.datos.matricula,
                          change: response.data.matricula,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.permiso !==
                        response.data.permiso
                      ) {
                        var change_log = {
                          name: "Permiso",
                          origin: $scope.originCertificate.datos.permiso,
                          change: response.data.permiso,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.purchase_value !==
                        response.data.purchase_value
                      ) {
                        var change_log = {
                          name: "Valor Compra",
                          origin: $scope.originCertificate.datos.purchase_value,
                          change: response.data.purchase_value,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.sucursal !==
                        response.data.sucursal
                      ) {
                        var change_log = {
                          name: "Sucursal",
                          origin: $scope.originCertificate.datos.sucursal,
                          change: response.data.sucursal,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.giro !==
                        response.data.giro
                      ) {
                        var change_log = {
                          name: "Giro",
                          origin: $scope.originCertificate.datos.giro,
                          change: response.data.giro,
                        };
                        $scope.changes.push(change_log);
                      }
                      if ($scope.originCertificate.datos.type_construction) {
                        if (
                          $scope.originCertificate.datos.type_construction.value
                        ) {
                          if (
                            parseInt(
                              $scope.originCertificate.datos.type_construction
                                .value
                            ) !== parseInt(response.data.type_construction)
                          ) {
                            var change_log = {
                              name: "Tipo Construcción",
                              origin:
                                $scope.originCertificate.datos.type_construction
                                  .value == 1
                                  ? "Macizo"
                                  : $scope.originCertificate.datos
                                      .type_construction.value == 2
                                  ? "Madera"
                                  : "Lámina",
                              change:
                                response.data.type_construction == 1
                                  ? "Macizo"
                                  : response.data.type_construction == 2
                                  ? "Madera"
                                  : "Lámina",
                            };
                            $scope.changes.push(change_log);
                          }
                        } else if (
                          parseInt(
                            $scope.originCertificate.datos.type_construction
                          ) !== parseInt(response.data.type_construction)
                        ) {
                          var change_log = {
                            name: "Tipo Construcción",
                            origin:
                              $scope.originCertificate.datos
                                .type_construction == 1
                                ? "Macizo"
                                : $scope.originCertificate.datos
                                    .type_construction == 2
                                ? "Madera"
                                : "Lámina",
                            change:
                              response.data.type_construction == 1
                                ? "Macizo"
                                : response.data.type_construction == 2
                                ? "Madera"
                                : "Lámina",
                          };
                          $scope.changes.push(change_log);
                        }
                      }
                      if (
                        $scope.originCertificate.datos.no_levels !==
                        response.data.no_levels
                      ) {
                        var change_log = {
                          name: "No. Niveles",
                          origin: $scope.originCertificate.datos.no_levels,
                          change: response.data.no_levels,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.fhm_zone !==
                        response.data.fhm_zone
                      ) {
                        var change_log = {
                          name: "Zona FHM",
                          origin: $scope.originCertificate.datos.fhm_zone,
                          change: response.data.fhm_zone,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.tyev_zone !==
                        response.data.tyev_zone
                      ) {
                        var change_log = {
                          name: "Zona TYEV",
                          origin: $scope.originCertificate.datos.tyev_zone,
                          change: response.data.tyev_zone,
                        };
                        $scope.changes.push(change_log);
                      }
                      if (
                        $scope.originCertificate.datos.item_address !==
                        response.data.item_address
                      ) {
                        var change_log = {
                          name: "Dirección",
                          origin: $scope.originCertificate.datos.item_address,
                          change: response.data.item_address,
                        };
                        $scope.changes.push(change_log);
                      }
                    }

                    var paramsRec = {
                      model: 25,
                      event: "PATCH",
                      associated_id: $scope.newCertificate.id,
                      identifier: " actualizó el certificado.",
                      change: $scope.changes,
                    };
                    if ($scope.changes) {
                      dataFactory
                        .post("send_log_specific/", paramsRec)
                        .then(function success(response) {
                          $scope.changes = [];
                        });
                    }

                    $scope.selectCerficate($scope.newCertificate);
                    SweetAlert.swal(
                      "¡Listo!",
                      "Certificado actualizado exitosamente.",
                      "success"
                    );
                  }
                })
                .catch(function (e) {
                  console.log("error", e);
                });
            }

            $scope.allCertificates();
            $http({
              method: "POST",
              url: url.IP + "info_certificados_Collective/",
              data: {
                status: 0,
                caratula: $scope.caratula.id,
                parent: 0,
              },
            })
              .then(function success(response1) {
                if (response1.status == 200) {
                  $scope.allCerificatesCaratula = response1.data.certificates;
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });
            $state.reload();
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.deleteCertificate = function (item) {
      $http({
        method: "GET",
        url: url.IP + "get-relations-by-id/",
        params: {
          id: item.id,
          id_caratula: $scope.caratula.id,
        },
      })
        .then(function (response_relations) {
          if (response_relations.data) {
            var foo = response_relations.data["categorias"].map(function (bar) {
              return "ID: " + bar[2] + ",Nombre:" + bar[0] + "\n";
            });
            var crt = response_relations.data["certificados"].map(function (
              bar
            ) {
              return (
                "ID: " +
                bar[3] +
                ",Certificado:" +
                bar[2] +
                ",Categoría:" +
                bar[0] +
                "\n"
              );
            });
            // var arc = response_relations.data['archivos'].map(function(bar){
            //   return 'ID: '+bar[3]+',Nombre:'+bar[2]+',PólizaID:'+bar[0]+'\n'
            // })
            // var arcc = response_relations.data['archivosCertificados'].map(function(bar){
            //   return 'ID: '+bar[3]+',Nombre:'+bar[2]+',PólizaID:'+bar[0]+'\n'
            // })
            var end = response_relations.data["endosos"].map(function (bar) {
              return (
                "ID: " +
                bar[2] +
                ",Número:" +
                bar[1] +
                ",Interno:" +
                bar[0] +
                "\n"
              );
            });
            var endc = response_relations.data["endososCertificados"].map(
              function (bar) {
                return (
                  "ID: " +
                  bar[4] +
                  ",Número:" +
                  bar[1] +
                  ",Interno:" +
                  bar[0] +
                  ",PolizaN:" +
                  bar[2] +
                  ",PolizaID:" +
                  bar[3] +
                  "\n"
                );
              }
            );
            // var recs = response_relations.data['recibos'].map(function(bar){
            //   return 'ID: '+bar[3]+',Serie:'+bar[0]+',Tipo:'+bar[1]+'\n'
            // })
            var sins = response_relations.data["siniestros"].map(function (
              bar_
            ) {
              return (
                "ID: " +
                bar_[4] +
                ",Número:" +
                bar_[1] +
                ",Interno:" +
                bar_[0] +
                ",PolizaN:" +
                bar_[2] +
                ",PolizaID:" +
                bar_[3] +
                "\n"
              );
            });
            var sinsc = response_relations.data["siniestrosCertificados"].map(
              function (bar) {
                return (
                  "ID: " +
                  bar[4] +
                  ",Número:" +
                  bar[1] +
                  ",Interno:" +
                  bar[0] +
                  ",PolizaN:" +
                  bar[2] +
                  ",PolizaID:" +
                  bar[3] +
                  "\n"
                );
              }
            );
            $scope.textLog =
              "Categorias: " +
              (response_relations.data["categorias"] ? foo : "Sin categorías") +
              "\n";
            $scope.textLog =
              $scope.textLog +
              "Certificados: " +
              (response_relations.data["certificados"]
                ? crt
                : "Sin certificados") +
              "\n";
            // $scope.textLog = $scope.textLog +'Archivos: '+ (response_relations.data['archivos'] ? arc : 'Sin archivos')+'\n'
            // $scope.textLog = $scope.textLog +'Archivos Certificados: '+ (response_relations.data['archivosCertificados'] ? arcc : 'Sin archivos Certificados')+'\n'
            $scope.textLog =
              $scope.textLog +
              "Endosos: " +
              (response_relations.data["endosos"] ? end : "Sin endosos") +
              "\n";
            $scope.textLog =
              $scope.textLog +
              "EndososCertificados: " +
              (response_relations.data["endososCertificados"]
                ? endc
                : "Sin endosos Certificados") +
              "\n";
            // $scope.textLog = $scope.textLog +'Recibos: '+ (response_relations.data['recibos'] ? recs: 'Sin recibos')+'\n'
            $scope.textLog =
              $scope.textLog +
              "Siniestros: " +
              (response_relations.data["siniestros"]
                ? sins
                : "Sin siniestros") +
              "\n";
            $scope.textLog =
              $scope.textLog +
              "Siniestros Certificados: " +
              (response_relations.data["siniestrosCertificados"]
                ? sinsc
                : "Sin siniestros certificados");
            // $scope.textLog = $scope.textLog +'Archivos Certificados: '+ (response_relations.data['archivosCertificados'] ? arcc : 'Sin archivos certificados')

            var modalInstance = $uibModal.open({
              templateUrl: "app/colectivos/deleteElement.modal.html",
              controller: DeleteElementController,
              size: "lg",
              backdrop: "static",
              keyboard: false,
              resolve: {
                log: function () {
                  return $scope.textLog;
                },
                valores: function () {
                  return response_relations.data;
                },
                item: function () {
                  return item;
                },
                tipo: function () {
                  return 3;
                },
                caratula: function () {
                  return $scope.caratula;
                },
                copy_policy_history: function () {
                  return $scope.copy_policy_history;
                },
              },
            });
            modalInstance.closed.then(function (x) {
              $scope.allCertificates();
            });
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
      // SweetAlert.swal({
      //   title: 'Eliminar Certificado',
      //   text: "Se eliminará el Certificado y no se podrá recuperar después, ¿Estás Seguro?",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#DD6B55",
      //   confirmButtonText: "Si, estoy seguro.",
      //   cancelButtonText: "cancelar",
      //   closeOnConfirm: false
      // },
      // function(isConfirm){
      //   if(isConfirm){
      //     $http.delete(item.url)
      //     .then(function(response){
      //       if(response.status == 204){
      //         SweetAlert.swal("¡Listo!", MESSAGES.OK.DELETECERT, "success");
      //         activate();
      //       }
      //     });
      //     $scope.categorySelected.certificates.splice($scope.categorySelected.certificates.indexOf(item), 1);
      //   }
      // });
    };

    $scope.showEndorsementsCertificate = function (item) {
      $scope.infoFlagCertificate = false;
      $scope.endorsementFlagCertificate = true;
      $scope.siniesterFlagCertificate = false;

      $http({
        method: "GET",
        url: url.IP + "view-endosos",
        params: {
          policy: item.id,
        },
      })
        .then(function success(response) {
          $scope.endorsementsCertificate = response.data.endosos;
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.goToSiniesterCert = function (cert_info, cover_contractor) {
      $scope.open_in_same_tab(
        "Siniestros vida",
        "siniestros.create_vida",
        { myInsurance: cert_info, contractor: cover_contractor },
        0
      );
    };
    $scope.openendoso = function (endorsement) {
      $scope.open_in_same_tab(
        "Endosos Información",
        "endorsement.info",
        { endosoId: endorsement.id },
        endorsement.id
      );
    };

    $scope.showSinistersCertificate = function (item) {
      $scope.infoFlagCertificate = false;
      $scope.endorsementFlagCertificate = false;
      $scope.siniesterFlagCertificate = true;

      $http({
        method: "GET",
        url: url.IP + "view-sinister",
        params: {
          policy: item.id,
        },
      })
        .then(function success(response) {
          $scope.sinistersCertificate = response.data.siniestros;
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.infoSinister = function (sinister) {
      if ($scope.caratula.ramo.ramo_name == "Accidentes y Enfermedades") {
        // $state.go('siniestros.info',{siniestroId: sinister.id});
        $scope.open_in_same_tab(
          "Siniestros",
          "siniestros.info",
          { siniestroId: sinister.id },
          sinister.id
        );
      } else if (
        $scope.caratula.ramo.ramo_name == "Daños" &&
        $scope.caratula.subramo.subramo_name == "Automóviles"
      ) {
        // $state.go('siniestros.auto_info',{siniestroId: sinister.id});
        $scope.open_in_same_tab(
          "Siniestros autos",
          "siniestros.auto_info",
          { siniestroId: sinister.id },
          sinister.id
        );
      } else if ($scope.caratula.ramo.ramo_name == "Vida") {
        // $state.go('siniestros.vida_info',{siniestroId: sinister.id})
        $scope.open_in_same_tab(
          "Siniestros vida",
          "siniestros.vida_info",
          { siniestroId: sinister.id },
          sinister.id
        );
      } else if (
        $scope.caratula.ramo.ramo_name == "Daños" &&
        $scope.caratula.subramo.subramo_name != "Automóviles"
      ) {
        // $state.go('siniestros.danio_info',{siniestroId: sinister.id})
        $scope.open_in_same_tab(
          "Siniestros daños",
          "siniestros.danio_info",
          { siniestroId: sinister.id },
          sinister.id
        );
      }
    };

    $scope.open_in_same_tab = function (name, route, params, identifier) {
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
      }

      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      appStates.states[active_tab] = {
        id: identifier,
        name: $scope.name_for_new_tab,
        heading: $scope.name_for_new_tab,
        route: $scope.route_for_new_tab,
        active: true,
        isVisible: true,
        href: $state.href($scope.route_for_new_tab),
      };
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.goToSiniester = function (param, type, name, route) {
      if (type == 2) {
        $scope.certificate.relation = param.id;
      }
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;
      var params = {
        myInsurance: $scope.certificate,
        contractor: $scope.cover_contractor,
      };
      $state.go($scope.route_for_new_tab, params);
      //$state.go('siniestros.accidentes', {myInsurance: $scope.certificate, contractor: ""})
    };

    $scope.goSiniester = function (name, route) {
      $scope.name_for_new_tab = name;
      $scope.route_for_new_tab = route;

      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      $localStorage.tab_states = appStates.states;

      var params = {
        myInsurance: $scope.cert_info,
        contractor: $scope.cover_contractor,
      };
      $state.go($scope.route_for_new_tab, params);
    };
    // jira 859 pdfs masiva a certificados
    vm.massive = {
      files: [],
      loading: false,
      result: null,
    };
    $scope.showMassivePDFs = function () {
      vm.massive = {
        files: [],
        loading: false,
        result: null,
      };
      // manda al tab 5 (ya lo tienes)
      $scope.show_section(5);
    };
    // util simple para identificar archivos (evita duplicados)
    function fileKey(f) {
      return [f.name, f.size, f.lastModified].join("|");
    }

    vm.onMassiveFilesSelected = function ($files) {
      if (!$files || !$files.length) return;

      vm.massive.result = null;

      // índice de los que ya existen
      var existing = {};
      for (var i = 0; i < vm.massive.files.length; i++) {
        existing[fileKey(vm.massive.files[i])] = true;
      }

      // agrega nuevos
      for (var j = 0; j < $files.length; j++) {
        var f = $files[j];

        // opcional: filtra solo PDFs por extensión
        if (!/\.pdf$/i.test(f.name)) continue;

        var key = fileKey(f);
        if (!existing[key]) {
          vm.massive.files.push(f);
          existing[key] = true;
        }
      }
    };

    vm.removeMassiveFile = function (idx) {
      vm.massive.files.splice(idx, 1);
      if (!vm.massive.files.length) {
        // limpia resultado si quieres
        // vm.massive.result = null;
        var el = document.getElementById("massivePdfInput");
        if (el) el.value = null;
      }
    };
    vm.clearMassivePDFs = function () {
      vm.massive.files = [];
      vm.massive.result = null;
      // ✅ opcional: limpiar el input file visualmente
      var el = document.getElementById("massivePdfInput");
      if (el) el.value = null;
    };
    vm.uploadMassivePDFs = function () {
      var lx = Ladda.create(document.querySelector(".ladda-button-x"));
      lx.start();
      if (!vm.massive.files.length) {
        lx.stop();
        return;
      }
      var fd = new FormData();
      fd.append("owner", $scope.caratula.id);
      for (var i = 0; i < vm.massive.files.length; i++) {
        var f = vm.massive.files[i];
        fd.append("arch", f, f.name); // se repite "arch"
        fd.append("nombre", f.name); // se repite "nombre"
      }
      return $http({
        method: "POST",
        url: url.IP + "polizas-grupo/" + $scope.caratula.id + "/massive-pdfs/",
        data: fd,
        transformRequest: angular.identity,
        headers: { "Content-Type": undefined },
        // params: { org: 'pruebas' }
      })
        .then(function (resp) {
          lx.stop();
          vm.massive.result = resp.data; // ✅ aquí queda disponible para la vista
          // ✅ limpiar lista SOLO si fue exitoso
          vm.massive.files = [];
          // ✅ opcional: limpiar el input file visualmente
          var el = document.getElementById("massivePdfInput");
          if (el) el.value = null;
        })
        .catch(function (e) {
          lx.stop();
          SweetAlert.swal(
            "ERROR",
            "No se pudo procesar la carga masiva.",
            "error"
          );
        })
        .finally(function () {
          lx.stop();
          vm.massive.loading = false;
        });
    };
    // vm.exportMassivePDFs = function (batchId) {
    //   var exportUrl = url.IP + 'polizas-grupo/massive-pdfs/export/' + batchId + '/';
    //   window.open(exportUrl, '_blank');
    // };
    vm.exportMassivePDFs = function (batchId) {
      if (!batchId) return;
      var exportUrl =
        url.IP + "polizas-grupo/massive-pdfs/export/" + batchId + "/";
      $http({
        method: "GET",
        url: exportUrl,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(
            blob,
            "resultado_carga_masiva_pdf_por_tirular_" + batchId + ".xls"
          );
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
    };
    vm.massiveHistory = {
      loading: false,
      batches: [],
      selected: null,
      detail: null,
    };
    vm.loadMassiveHistory = function () {
      vm.massiveHistory.loading = true;
      vm.massiveHistory.batches = [];
      vm.massiveHistory.selected = null;
      vm.massiveHistory.detail = null;

      var urlHist =
        url.IP +
        "polizas-grupo/" +
        $scope.caratula.id +
        "/massive-pdfs/batches/";

      return $http
        .get(urlHist, {})
        .then(function (resp) {
          vm.massiveHistory.batches =
            resp.data && resp.data.results ? resp.data.results : [];
        })
        .finally(function () {
          vm.massiveHistory.loading = false;
        });
    };
    vm.openBatchPDFs = function (batch) {
      vm.massive = {
        files: [],
        loading: false,
        result: null,
      };
      // ✅ opcional: limpiar el input file visualmente
      var el = document.getElementById("massivePdfInput");
      if (el) el.value = null;
      vm.massiveHistory.selected = batch;
      vm.massiveHistory.detail = null;
      var urlDet =
        url.IP + "polizas-grupo/massive-pdfs/batches/" + batch.batch_id + "/";
      return $http.get(urlDet, {}).then(function (resp) {
        vm.massiveHistory.detail = resp.data;
      });
    };
    // jira 859 pdfs masivo a certificados fin
    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);

        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        $scope.traerRecibos(null, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    // -----------------PAGINACIÓN
    function testPaginationE(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPagesE = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesE.push(i + 1);
      }

      $scope.lastPageE = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesE.length > 5) {
          $scope.end = $scope.totalPagesE.length;
          $scope.start = $scope.totalPagesE.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPagesE.length);

        // $scope.actual_page = $scope.totalPagesE.length;
        // $scope.page = $scope.totalPagesE.length;
      };

      $scope.selectPageE = function (parPage) {
        $scope.actual_pageE = parPage;
        $scope.traerRecibosEndosos(vm.form.endoso_n, null, parPage);
      };

      $scope.previousBlockPagesE = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_pageE) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesE.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_pageE) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesE.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesE.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    $scope.verdetalle_pdfs = false;
    vm.openBatch = function (batchId) {
      if (batchId) {
        $scope.verdetalle_pdfs = true;
        vm.batch_id = batchId["batch_id"];
        console.log("batchccccc", batchId);
        if (batchId) {
          vm.loadItems();
        }
      }
    };

    vm.batches = [];
    vm.loadBatches = function (page) {
      var params = {
        id_poliza: $scope.caratula.id, // carátula
        page: page || 1,
        page_size: 20,
      };
      $http
        .get(url.IP + "share-certificates/batches/", { params: params })
        .then(function (resp) {
          vm.batches = resp.data.batches || [];
          vm.batches_pages = resp.data.pagination.pages;
          vm.batches_page = resp.data.pagination.page;
        })
        .catch(function (e) {
          console.log(e);
          SweetAlert.swal(
            "Error",
            "No se pudo cargar el historial de envíos",
            "error"
          );
        });
    };

    function assignCertificateMasivoModalView(
      $scope,
      $uibModalInstance,
      policy_id,
      caratulaInfo,
      url,
      contratante,
      sendOnlyEmail
    ) {
      $scope.send = true;
      var share_via_email = [];
      var share_via_email_r = [];

      var vmm = this;
      $scope.sendOnlyEmail = sendOnlyEmail;
      $scope.titulo = "Compartir Masivo por Correo Electrónico";
      vmm.is_owner = false;
      vmm.email_assign_mail = "";
      vmm.custom_email = true;
      vmm.htmlVariable = "";
      vmm.first_comment = "";
      vmm.second_comment = "";
      vmm.subjectEmail =
        "SE LE COMPARTE SU CERTIFICADO PERTENECIENTE  A LA PÓLIZA DE GRUPO " +
        String(
          caratulaInfo && caratulaInfo.poliza_number
            ? caratulaInfo.poliza_number
            : caratulaInfo.internal_number
        );
      dataFactory
        .get("emailtemplate-unpag/", {
          template_model: 5,
          id_policy: policy_id ? policy_id : caratulaInfo.id,
        })
        .then(
          function success(response) {
            $scope.plantillas = response.data;
          },
          function error(err) {}
        )
        .catch(function (e) {});

      $scope.plantillaSeleccionada = {};
      $scope.changePlantilla = function (item) {
        $scope.plantillaSeleccionada = item;
        if (item) {
          vmm.subjectEmail = item.title ? item.title : vmm.subjectEmail;
          vmm.first_comment = item.text;
          if (vmm.first_comment.includes("\n")) {
            vmm.first_comment = vmm.first_comment.replace("\n", "<br><br>");
          }
          vmm.second_comment = item.bottom_text;
          vmm.custom_email = true;
          $scope.getTemplate(true);
        } else {
          $scope.plantillaSeleccionada = {};
          vmm.subjectEmail = "";
          vmm.first_comment = "";
          vmm.second_comment = "";
          vmm.custom_email = true;
          $scope.getTemplate(true);
        }
      };
      $scope.getTemplate = function (custom_email) {
        if (custom_email) {
          $http
            .get(
              url.IP + "share-policy-manual/" + policy_id
                ? policy_id
                : caratulaInfo.id
            )
            .then(function (response) {
              if (response.status === 200) {
                vmm.head = response.data.head;
                vmm.body = response.data.body;
                vmm.footer = response.data.footer;
                vmm.subjectDefault = response.data.subject_default;
                if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
                  vmm.subjectEmail = vmm.subjectDefault
                    ? vmm.subjectDefault
                    : vmm.subjectEmail;
                }
              }
            })
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          vmm.htmlVariable = "";
          vmm.first_comment = "";
          vmm.second_comment = "";
        }
      };
      $scope.sendEmailMasivo = function (x) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "Se compartirán todos los certificados al Correo Electrónico designado",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              var data_email = {
                id_poliza: caratulaInfo.id,
                is_owner: false,
                active: true,
                first_comment: vmm.first_comment,
                second_comment: vmm.second_comment,
                subjectEmail: vmm.subjectEmail,
                plantilla: $scope.plantillaSeleccionada
                  ? $scope.plantillaSeleccionada.id
                  : "",
              };
              dataFactory
                .post("shareCertificatesToEmail/", data_email)
                .then(function (req) {
                  l.stop();
                  if (req.status === 200 || req.status === 201) {
                    var batchId = req.data && req.data.batch_id;
                    vm.batch_id = batchId;
                    // Si backend ya está regresando batch_id
                    if (batchId) {
                      vm.loadItems();
                    }
                    // Fallback si aún no regresas batch_id (mientras migras backend)
                    SweetAlert.swal(
                      "¡Listo!",
                      "Se envió el correo, revise los resultados",
                      "success"
                    );
                    $uibModalInstance.dismiss("cancel");
                  } else {
                    SweetAlert.swal(
                      "Error",
                      "Ha ocurrido un error al compartir certificados de la Carátula",
                      "error"
                    );
                  }
                })
                .catch(function (e) {
                  l.stop();
                  console.log("error", e);
                  SweetAlert.swal(
                    "Error",
                    "Ocurrió un error al enviar. Revisa consola/logs.",
                    "error"
                  );
                });

              // dataFactory.post('shareCertificatesToEmail/', data_email).then(function success(req) {
              //     if (req.status == 200 || req.status == 201){
              //       l.stop();
              //       SweetAlert.swal("¡Listo!", "Se ha enviado el correo correspondiente de confirmación", "success")
              //       $uibModalInstance.dismiss('cancel');
              //     }else{
              //       l.stop();
              //       SweetAlert.swal("Error", "Ha ocurrido un error al compartir certificados de la Carátula", "error")
              //     }
              // });
            } else {
              l.stop();
            }
          }
        );
      };

      $scope.sendEmailMasivoApp = function (x) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "Se compartirán todos los certificados a la App/Email",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: true,
          },
          function (isConfirm) {
            if (isConfirm) {
              var data_email = {
                id_poliza: caratulaInfo.id,
                is_owner: false,
                active: true,
                first_comment: vmm.first_comment,
                second_comment: vmm.second_comment,
                subjectEmail: vmm.subjectEmail,
                plantilla: $scope.plantillaSeleccionada
                  ? $scope.plantillaSeleccionada.id
                  : "",
              };
              dataFactory
                .post("shareCertificatesToAppEmail/", data_email)
                .then(function success(req) {
                  if (req.status == 200 || req.status == 201) {
                    l.stop();
                    SweetAlert.swal(
                      "¡Listo!",
                      "Se ha enviado el correo correspondiente de confirmación",
                      "success"
                    );
                    $uibModalInstance.dismiss("cancel");
                  } else {
                    l.stop();
                    SweetAlert.swal(
                      "Error",
                      "Ha ocurrido un error al compartir certificados de la Carátula",
                      "error"
                    );
                  }
                });
            } else {
              l.stop();
            }
          }
        );
      };
      $scope.emptySubject = function (v) {
        if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
          vmm.subjectEmail =
            "SE LE COMPARTE SU CERTIFICADO PERTENECIENTE  A LA PÓLIZA DE GRUPO " +
            String(
              caratulaInfo && caratulaInfo.poliza_number
                ? caratulaInfo.poliza_number
                : caratulaInfo.internal_number
            );
        }
      };
      $scope.assignPolicy = function (email) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (email) {
          if (validateEmail(email) == false) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
            return;
          }
          if (!email) {
            console.log("sin ema", email);
          }
          var assign = {
            is_owner: $scope.is_owner,
            active: true,
            poliza: policy_id,
            email: email,
            first_name: vmm.first_comment,
            last_name: vmm.second_comment,
            custom_email: vmm.custom_email,
          };
          $http
            .post(url.IP + "assign-pendient/", assign)
            .then(function (response) {
              if (response.status === 200 || request.status === 201) {
                if (response.data.type == 1) {
                  l.stop();
                  SweetAlert.swal(
                    "Advertencia",
                    MESSAGES.INFO.POLICYASSIGNED,
                    "warning"
                  );
                } else {
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.INFO.POLICYPENDIENT,
                    "success"
                  );
                }
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
          $uibModalInstance.dismiss("cancel");
        } else {
          if ($scope.fileshared && $scope.fileshared == true) {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.FILESHARED, "success");
          }
          l.stop();
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.remove_email = function (index) {
        $scope.emails.splice(index, 1);
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }
    function assignCertificateModalView(
      $scope,
      $uibModalInstance,
      policy_id,
      url,
      contratante
    ) {
      $scope.send = true;
      var share_via_email = [];
      var share_via_email_r = [];

      var vmm = this;
      $scope.plantillaSeleccionada = {};

      $scope.sendOnlyEmail = false;
      vmm.is_owner = false;
      vmm.email_assign_mail = "";
      vmm.custom_email = true;
      vmm.htmlVariable = "";
      vmm.first_comment = "";
      vmm.second_comment = "";

      dataFactory
        .get("emailtemplate-unpag/", {
          template_model: 5,
          id_policy: policy_id,
        })
        .then(
          function success(response) {
            $scope.plantillas = response.data;
          },
          function error(err) {}
        )
        .catch(function (e) {});
      $scope.changePlantilla = function (item) {
        $scope.plantillaSeleccionada = item;
        if (item) {
          vmm.subjectEmail = item.title;
          vmm.first_comment = item.text;
          if (vmm.first_comment.includes("\n")) {
            vmm.first_comment = vmm.first_comment.replace("\n", "<br><br>");
          }
          vmm.second_comment = item.bottom_text;
          vmm.custom_email = true;
          $scope.getTemplate(true);
        } else {
          vmm.subjectEmail = "";
          vmm.first_comment = "";
          vmm.second_comment = "";
          vmm.custom_email = true;
          $scope.getTemplate(true);
        }
      };
      $scope.getTemplate = function (custom_email) {
        if (custom_email) {
          var idplantilla = $scope.plantillaSeleccionada
            ? $scope.plantillaSeleccionada.id
            : null;
          $http
            .get(url.IP + "share-policy-manual/" + vm.insurance.id, {
              params: { template_id: idplantilla }, // o idplantilla: idplantilla
            })
            .then(function (response) {
              if (response.status === 200) {
                vmm.head = response.data.head;
                vmm.body = response.data.body;
                vmm.footer = response.data.footer;
                vmm.subjectDefault = response.data.subject_default;
                if (!vmm.subjectEmail) vmm.subjectEmail = vmm.subjectDefault;
              }
            })
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          vmm.htmlVariable = "";
          vmm.first_comment = "";
          vmm.second_comment = "";
        }
      };
      $http
        .post(url.IP + "get-assign/", { poliza: policy_id })
        .then(
          function success(response) {
            $scope.people_assigned = response.data;
            $scope.owner_exist = true;
            $scope.people_assigned.some(function (people) {
              if (people.is_owner == true) {
                $scope.owner_exist = false;
                return;
              }
            });
          },
          function error(err) {}
        )
        .catch(function (e) {});
      $http
        .get(url.IP + "polizas/" + policy_id + "/archivos/")
        .then(function (response) {
          $scope.files = response.data.results;
          $scope.files.forEach(function (archivo, index) {
            $scope.files[index]["origin"] = "P";
          });
        })
        .catch(function (e) {
          console.log("error", e);
        });

      $scope.showEmailInInput = function () {
        $scope.email_assign = contratante.email;
      };

      $scope.emails = [];
      $scope.addEmail = function (email) {
        if (validateEmail(email) == false) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
          return;
        } else {
          $scope.emails.push(email);
          $scope.email_assign = "";
        }
      };

      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      $scope.sendEmail = function (receipt) {
        $scope.send = false;
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        var data_shared = {
          id: policy_id,
          emails: $scope.emails,
          files: share_via_email,
          files_r: share_via_email_r,
        };
        var data_shared = {
          is_owner: $scope.is_owner,
          active: true,
          poliza: policy_id,
          id: policy_id,
          email: email,
          emails: $scope.emails,
          files: share_via_email,
          files_r: share_via_email_r,
          first_comment: vmm.first_comment,
          second_comment: vmm.second_comment,
          custom_email: vmm.custom_email,
          subject: vmm.subjectEmail,
          plantilla: $scope.plantillaSeleccionada
            ? $scope.plantillaSeleccionada.id
            : {},
        };
        $http
          .post(url.IP + "share-certificate-manual/", data_shared)
          // $http.post(url.IP+'share-policy-manual/', {'id': policy_id, 'emails': $scope.emails})
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.POLICYSEND, "success");
                $uibModalInstance.dismiss("cancel");
              } else {
                l.stop();
                SweetAlert.swal("ERROR", MESSAGES.ERROR.POLICYERROR, "error");
              }
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("error", e);
          });
      };

      $scope.deleteEmail = function (email) {
        $http({
          method: "GET",
          url: url.IP + "delete-assign/",
          params: {
            id: email.id,
          },
        })
          .then(function (request) {
            $scope.people_assigned.splice(
              $scope.people_assigned.indexOf(email),
              1
            );
            assignModalView($scope, $uibModalInstance, policy_id, url);
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };

      $scope.shareFileEmail = function (file) {
        if (file.to_send) {
          file.to_send = false;
        } else {
          file.to_send = true;
        }
        share_via_email = [];
        share_via_email_r = [];
        $scope.files.forEach(function (filex) {
          if (filex.to_send && filex.origin == "P") {
            share_via_email.push(filex.id);
          }
          if (filex.to_send && filex.origin == "R") {
            share_via_email_r.push(filex.id);
          }
        });
      };

      $scope.shareFile = function (file) {
        $http
          .get(url.IP + "patch-policy-file/" + file.id)
          .then(function (response) {
            if (file.shared) {
              $scope.fileshared = true;
            } else {
              $scope.fileshared = false;
            }
            $scope.files.some(function (filex) {
              if (filex.id == response.data.id) {
                filex.shared = response.data.shared;
              }
            });
            $scope.files[file] = response.data;
          })
          .catch(function (e) {
            console.log("e", e);
          });
      };

      $scope.is_owner = false;
      $scope.getTemplate = function (custom_email) {
        var idplantilla = $scope.plantillaSeleccionada
          ? $scope.plantillaSeleccionada.id
          : null;
        if (custom_email) {
          $http
            .get(url.IP + "share-certificate-manual/" + policy_id, {
              params: { template_id: idplantilla }, // o idplantilla: idplantilla
            })
            .then(function (response) {
              if (response.status === 200) {
                vmm.head = response.data.head;
                vmm.body = response.data.body;
                vmm.footer = response.data.footer;
                vmm.subjectDefault = response.data.subject_default;
                if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
                  vmm.subjectEmail = vmm.subjectDefault;
                }
              }
            })
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          vmm.htmlVariable = "";
          vmm.first_comment = "";
          vmm.second_comment = "";
        }
      };
      $scope.emptySubject = function (v) {
        if (vmm.subjectEmail == "" || vmm.subjectEmail == undefined) {
          vmm.subjectEmail = vmm.subjectDefault;
        }
      };
      $scope.assignPolicy = function (email) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if (email) {
          if (validateEmail(email) == false) {
            l.stop();
            SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
            return;
          }
          if (!email) {
            console.log("sin ema", email);
          }
          var assign = {
            is_owner: $scope.is_owner,
            active: true,
            poliza: policy_id,
            email: email,
            first_name: vmm.first_comment,
            last_name: vmm.second_comment,
            custom_email: vmm.custom_email,
          };
          $http
            .post(url.IP + "assign-pendient/", assign)
            .then(function (response) {
              if (response.status === 200 || request.status === 201) {
                if (response.data.type == 1) {
                  l.stop();
                  SweetAlert.swal(
                    "Advertencia",
                    MESSAGES.INFO.POLICYASSIGNED,
                    "warning"
                  );
                } else {
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.INFO.POLICYPENDIENT,
                    "success"
                  );
                }
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
          $uibModalInstance.dismiss("cancel");
        } else {
          if ($scope.fileshared && $scope.fileshared == true) {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.FILESHARED, "success");
          }
          l.stop();
          $uibModalInstance.dismiss("cancel");
        }
      };

      $scope.remove_email = function (index) {
        $scope.emails.splice(index, 1);
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }
    // ---------------------------------
  }
})();

/* global angular */
(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ColectivosEditCtrl", ColectivosEditCtrl);

  ColectivosEditCtrl.$inject = [
    "$scope",
    "$http",
    "url",
    "$stateParams",
    "$sessionStorage",
    "MESSAGES",
    "SweetAlert",
    "$state",
    "providerService",
    "helpers",
    "dataFactory",
    "FileUploader",
    "formatValues",
    "$rootScope",
    "$localStorage",
    "$timeout",
    "coverageService",
    "toaster",
    "$q",
  ];

  function ColectivosEditCtrl(
    $scope,
    $http,
    url,
    $stateParams,
    $sessionStorage,
    MESSAGES,
    SweetAlert,
    $state,
    providerService,
    helpers,
    dataFactory,
    FileUploader,
    formatValues,
    $rootScope,
    $localStorage,
    $timeout,
    coverageService,
    toaster,
    $q
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    $scope.infoUser = $sessionStorage.infoUser;

    var order = this;
    var groupEditDraft = {};

    function resetGroupEditDraft() {
      groupEditDraft = {};
    }

    function hasGroupEditDraft() {
      return groupEditDraft && Object.keys(groupEditDraft).length > 0;
    }

    function ensureGroupEditDraft() {
      if (!groupEditDraft || Object.keys(groupEditDraft).length === 0) {
        groupEditDraft = angular.copy($scope.caratula) || {};
      }
      return groupEditDraft;
    }

    function setGroupEditDraftValue(key, value) {
      ensureGroupEditDraft();
      groupEditDraft[key] = value;
    }

    $scope.showOt = true;
    $scope.caratula = {};
    $scope.subgrupos = {};
    $scope.paquetes = {};
    $scope.package = {};
    $rootScope.show_contractor = false;
    $scope.create_natural = true;
    $scope.create_juridical = true;
    $scope.claves = [];
    $scope.renewals = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.renewalSelected = $scope.renewals[0];
    $scope.administrationTypes = [
      { value: 1, label: "Simplificada" },
      { value: 2, label: "Autoadministrada" },
      { value: 3, label: "Detallada" },
    ];
    $scope.currencys = [
      { value: 1, label: "Pesos" },
      { value: 2, label: "Dólares" },
      { value: 3, label: "UDI" },
      { value: 4, label: "Euros" },
    ];
    $scope.conductos_de_pago = [
      { value: 1, label: "No domiciliada" },
      { value: 2, label: "Agente" },
      { value: 3, label: "CAC" },
      { value: 4, label: "CAT/Domiciliado" },
      { value: 5, label: "Nómina" },
      { value: 6, label: "CUT" },
    ];
    $scope.referenciadores = [];
    $scope.referenciadorArray = [];
    $scope.referenciadoresSelected = [];
    $scope.btnTraditionalStyle = {
      color: "#ffffff",
      "background-color": "#1cb394",
    };
    $scope.btnMinimalStyle = {
      color: "#707877",
      "background-color": "#ffffff",
      "border-top": "1px solid #1cb394",
      "border-right": "1px solid #1cb394",
      "border-bottom": "1px solid #1cb394",
    };
    $scope.frequencies = [
      { value: 7, label: "Semanal" },
      { value: 14, label: "Catorcenal" },
      // {'value':24, 'label':'Quincenal'},
      { value: 1, label: "Mensual" },
      { value: 2, label: "Bimestral" },
      { value: 3, label: "Trimestral" },
      { value: 6, label: "Semestral" },
      { value: 12, label: "Anual" },
      { value: 5, label: "Contado" },
    ];
    $scope.show_caratula = false;
    $scope.show_subgrupo = false;
    $scope.show_paquete = false;
    $scope.create_subgroup = false;
    $scope.create_package = false;
    $scope.directiveReceipts = {};
    $scope.dataToSave = {
      recalcular: true,
    };

    $scope.businessline = [
      { id: 0, name: "Otro" },
      { id: 1, name: "Comercial" },
      { id: 2, name: "Personal" },
    ];

    $scope.celulas = [];
    $scope.agrupaciones = [];
    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    activate();

    $scope.changeConducto = function (param) {
      $scope.caratula.conducto_de_pago = param;
      $scope.directiveReceipts.conducto_de_pago = param;
    };

    function activate() {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      $http
        .post(url.IP + "get_caratula_complete/", {
          caratula: $stateParams.polizaId,
        })
        .then(function success(response) {
          if (response.status == 200) {
            if (
              hasGroupEditDraft() &&
              groupEditDraft["id"] == response.data.data.caratula.id
            ) {
              $scope.caratula = angular.copy(groupEditDraft);
            } else {
              resetGroupEditDraft();
              $scope.caratula = response.data.data.caratula;
            }
            $scope.childs = response.data.data.childs;
            $scope.originCaratula = angular.copy(response.data.data.caratula);
            if ($scope.caratula.poliza_number) {
              $scope.showOt = false;
            }
            $scope.show_caratula = true;
            if ($scope.caratula.receipts_by == 1) {
              $scope.receipts = [];
              $scope.originCaratula.recibos_poliza.forEach(function (receipt) {
                if (receipt.receipt_type == 1 && receipt.status != 0) {
                  receipt.fecha_inicio = convertDate(receipt.fecha_inicio);
                  receipt.fecha_fin = convertDate(receipt.fecha_fin);
                  receipt.vencimiento = convertDate(receipt.vencimiento);
                  if (receipt.status != 4 && receipt.stataus != 0) {
                    $scope.dataToSave.recalcular = false;
                  }
                  $scope.receipts.push(receipt);
                }
                if ($scope.caratula.scheme == 2) {
                  // if(receipt.receipt_type == 3){
                  if (receipt.receipt_type == 1 && receipt.status != 0) {
                    receipt.fecha_inicio = convertDate(receipt.fecha_inicio);
                    receipt.fecha_fin = convertDate(receipt.fecha_fin);
                    receipt.vencimiento = convertDate(receipt.vencimiento);
                    if (receipt.status != 4 && receipt.stataus != 0) {
                      $scope.dataToSave.recalcular = false;
                    }
                    $scope.receipts.push(receipt);
                  }
                }
              });
              $scope.show_caratula = true;
            }

            $scope.conductoSelected = $scope.caratula.conducto_de_pago;

            $scope.business_lineSelected =
              $scope.businessline[$scope.caratula.business_line];
            $scope.startDate = convertDate($scope.caratula.start_of_validity);
            $scope.endDate = convertDate($scope.caratula.end_of_validity);
            fillProvider();
            $scope.renewals.forEach(function (ite) {
              if (ite.value == $scope.caratula.is_renewable) {
                $scope.renewalSelected = ite;
              }
            });
            $scope.aseguradoraSelected = $scope.caratula.aseguradora;

            $scope.currencys.forEach(function (item) {
              if (hasGroupEditDraft() && groupEditDraft["f_currency"]) {
                $scope.currencySelected = groupEditDraft["f_currency"];
                $scope.caratula.f_currency = $scope.currencySelected;
                if (!$scope.currencySelected) {
                  if (item.label == $scope.caratula.f_currency) {
                    $scope.currencySelected = item.value;
                    $scope.caratula.f_currency = item.value;
                  }
                }
              } else {
                if (item.label == $scope.caratula.f_currency) {
                  $scope.currencySelected = item.value;
                  $scope.caratula.f_currency = item.value;
                }
              }
            });
            $scope.administrationTypes.forEach(function (item) {
              if (item.label == $scope.caratula.administration_type) {
                $scope.administrationSelected = item;
              }
            });

            if ($scope.caratula.celula) {
              var idC = $scope.caratula.celula.id
                ? $scope.caratula.celula.id
                : $scope.caratula.celula;
              dataFactory
                .post("celula_contractor_info/")
                .then(function (response) {
                  $scope.celulas = response.data;
                  $scope.celulas.forEach(function (it) {
                    if (parseInt(it.id) == parseInt(idC)) {
                      $scope.celulaSelected = it;
                      $scope.changeCelula($scope.celulaSelected);
                    }
                  });
                });
            }

            if ($scope.caratula.grouping_level) {
              $http
                .get(
                  url.IP + "groupinglevel/" + $scope.caratula.grouping_level.id
                )
                .then(function (response) {
                  $scope.grouping_levelSelected = response.data;
                  $scope.changeAgrupacion($scope.grouping_levelSelected);
                });
            }

            $scope.info_sub = $scope.caratula;

            order.contratante = {};
            if ($scope.caratula.contractor) {
              $scope.caratula.contractor.address_contractor.forEach(function (
                address
              ) {
                if (address.id == $scope.caratula.address) {
                  $scope.addressSelected = address;
                }
              });
              order.contratante.val = $scope.caratula.contractor.full_name;
              order.contratante.value = $scope.caratula.contractor;
            }

            // Recibos
            $scope.directiveReceipts.domiciliado = false;
            $scope.directiveReceipts.payment = {
              value: $scope.caratula.forma_de_pago,
            };
            $scope.directiveReceipts.startDate = $scope.startDate;
            $scope.directiveReceipts.endingDate = $scope.endDate;
            $scope.dataToSave.accident_rate = parseFloat(
              $scope.caratula.accident_rate
            );
            $scope.caratula.steps = $scope.caratula.steps.replace(/'/g, '"');
            $scope.dataToSave.steps = $scope.caratula.steps
              ? JSON.parse($scope.caratula.steps)
              : [];
            $scope.dataToSave.receipts = $scope.receipts;
            $scope.dataToSave.numeroRecibos =
              $scope.caratula.recibos_poliza.length;
            $scope.dataToSave.poliza = {
              primaNeta: parseFloat($scope.caratula.p_neta),
              descuento: parseFloat($scope.caratula.descuento),
              rpf: parseFloat($scope.caratula.rpf),
              derecho: parseFloat($scope.caratula.derecho),
              iva: parseFloat($scope.caratula.iva),
              subTotal: $scope.caratula.sub_total,
              primaTotal: $scope.caratula.p_total,
            };
            var date1 = new Date($scope.caratula.start_of_validity);
            var date2 = new Date($scope.caratula.end_of_validity);
            var timeDiff = Math.abs(date2.getTime() - date1.getTime());
            $scope.directiveReceipts.policy_days_duration = Math.ceil(
              timeDiff / (1000 * 3600 * 24)
            );

            $http
              .get(url.IP + "usuarios/")
              .then(function (user) {
                user.data.results.forEach(function (u) {
                  u.first_name = u.first_name.toUpperCase();
                  u.last_name = u.last_name.toUpperCase();
                  u.name =
                    u.first_name.toUpperCase() +
                    " " +
                    u.last_name.toUpperCase();
                });
                $scope.users = user.data.results;
                if ($scope.caratula.responsable) {
                  $scope.users.forEach(function (item) {
                    if (item.id == $scope.caratula.responsable.id) {
                      $scope.responsableSelected = item;
                    }
                  });
                }

                $scope.ejecutivos = user.data.results;
                if ($scope.caratula.collection_executive) {
                  $scope.users.forEach(function (item) {
                    if (item.id == $scope.caratula.collection_executive.id) {
                      $scope.executiveSelected = item;
                    }
                  });
                }

                $scope.aseguradoraOriginal = $scope.aseguradoraSelected;
                $scope.getClaves($scope.aseguradoraSelected, 1);
              })
              .catch(function (e) {
                console.log("error", e);
              });

            dataFactory
              .get("sucursales-to-show-unpag/")
              .then(function success(response) {
                if (response.status === 200 || response.status === 201) {
                  $scope.sucursales = response.data;
                  if ($scope.caratula.sucursal) {
                    $scope.sucursales.forEach(function (item) {
                      if (item.id == $scope.caratula.sucursal.id) {
                        $scope.sucursalSelected = item;
                      }
                    });
                  }
                }
              })
              .catch(function (e) {
                console.log("error", e);
              });

            dataFactory
              .post("celula_contractor_info/")
              .then(function (response) {
                $scope.celulas = response.data;
              });

            dataFactory.get("groupingLevel-resume/").then(function (response) {
              $scope.agrupaciones = response.data;
            });

            $http
              .get(url.IP + "get-vendors/")
              .then(function (user) {
                $scope.referenciadores = user.data;
                var vendedor = {
                  referenciador: "",
                  comision_vendedor: "",
                };
                user.data.forEach(function (vnd) {
                  vnd.first_name = vnd.first_name.toUpperCase();
                  vnd.last_name = vnd.last_name.toUpperCase();
                  vnd.name =
                    vnd.first_name.toUpperCase() +
                    " " +
                    vnd.last_name.toUpperCase();
                });
                $scope.referenciadorArray.push(vendedor);
              })
              .catch(function (e) {
                console.log("error", e);
              });

            // Referenciadores

            if ($scope.caratula.ref_policy.length > 0) {
              $scope.caratula.ref_policy.forEach(function (refs) {
                if (refs.referenciador && refs.referenciador.url) {
                  $http
                    .get(refs.referenciador.url)
                    .then(function success(response_ref_plicy) {
                      if (response_ref_plicy) {
                        refs.data = response_ref_plicy.data;
                        refs.referenciador = response_ref_plicy.data.url;
                        refs.selectedRef = true;
                        $scope.referenciadorArray.push(refs);
                      }
                    });
                }
              });
            }

            $scope.paymentSelected = $scope.caratula.forma_de_pago;
            $scope.erase_categorie = [];
            if ($rootScope.edit_collective == undefined) {
              if ($rootScope.add_collective != undefined) {
                if ($rootScope.add_collective == 2) {
                  $scope.subgrupos = {
                    name: "",
                    contractor: null,
                    observations: "",
                    categorias: [
                      {
                        name: "",
                        hospital_level: "",
                        observations: "",
                      },
                    ],
                  };
                  $scope.directiveReceipts.payment =
                    $scope.caratula.forma_de_pago;
                  $scope.show_caratula = false;
                  $scope.show_subgrupo = true;
                  $scope.show_paquete = false;
                  $scope.create_subgroup = true;
                  $scope.create_package = false;
                } else if ($rootScope.add_collective == 3) {
                  $scope.getPackage();
                  $scope.package = {
                    package_name: "",
                    policy: $scope.caratula.id,
                    provider: $scope.caratula.aseguradora.url,
                    ramo: $scope.caratula.ramo.url,
                    subramo: $scope.caratula.subramo.url,
                    type_package: 2,
                    coverage_package: [],
                  };
                  $scope.show_caratula = false;
                  $scope.show_subgrupo = false;
                  $scope.show_paquete = true;
                  $scope.create_subgroup = false;
                  $scope.create_package = true;
                }
              } else {
                $scope.show_caratula = true;
                $scope.show_subgrupo = false;
                $scope.show_paquete = false;
                $scope.create_subgroup = false;
                $scope.create_package = false;
                $scope.chanceScheme($scope.caratula.scheme);
              }
            } else {
              if ($rootScope.edit_collective.document_type) {
                if ($rootScope.edit_collective.document_type == "Carátula") {
                  $scope.show_caratula = true;
                  $scope.show_subgrupo = false;
                  $scope.show_paquete = false;
                  $scope.create_subgroup = false;
                  $scope.create_package = false;
                  $scope.chanceScheme($scope.caratula.scheme);
                } else if ($rootScope.edit_collective.document_type == 4) {
                  $scope.subgrupos = $rootScope.edit_collective;
                  $scope.originSubgroup = angular.copy(
                    $rootScope.edit_collective
                  );

                  order.contratanteSubgrupo = {};
                  if ($scope.subgrupos.contractor) {
                    if ($scope.subgrupos.contractor) {
                      $scope.subgrupos.contractor.address_contractor.forEach(
                        function (address) {
                          if (address.id == $scope.subgrupos.address) {
                            $scope.subgrupos.addressSelected = address;
                          }
                        }
                      );
                      order.contratanteSubgrupo.val =
                        $scope.subgrupos.contractor.full_name;
                      order.contratanteSubgrupo.value =
                        $scope.subgrupos.contractor;
                    }
                  }
                  $scope.dataToSave.receipts = [];
                  if ($scope.caratula.receipts_by == 2) {
                    $scope.originSubgroup.recibos_poliza.forEach(function (
                      receipt
                    ) {
                      if (receipt.receipt_type == 1) {
                        receipt.fecha_inicio = convertDate(
                          receipt.fecha_inicio
                        );
                        receipt.fecha_fin = convertDate(receipt.fecha_fin);
                        receipt.vencimiento = convertDate(receipt.vencimiento);
                        if (receipt.status != 4) {
                          $scope.dataToSave.recalcular = false;
                        }
                        $scope.dataToSave.receipts.push(receipt);
                      }
                    });
                  }

                  $scope.dataToSave.numeroRecibos =
                    $scope.originSubgroup.recibos_poliza.length;
                  $scope.dataToSave.poliza = {
                    primaNeta: parseFloat($scope.originSubgroup.p_neta),
                    descuento: parseFloat($scope.originSubgroup.descuento),
                    rpf: parseFloat($scope.originSubgroup.rpf),
                    derecho: parseFloat($scope.originSubgroup.derecho),
                    iva: parseFloat($scope.originSubgroup.iva),
                    subTotal: $scope.originSubgroup.sub_total,
                    primaTotal: $scope.originSubgroup.p_total,
                  };
                  var date1 = new Date($scope.caratula.start_of_validity);
                  var date2 = new Date($scope.caratula.end_of_validity);
                  var timeDiff = Math.abs(date2.getTime() - date1.getTime());
                  $scope.directiveReceipts.policy_days_duration = Math.ceil(
                    timeDiff / (1000 * 3600 * 24)
                  );

                  if (hasGroupEditDraft() && groupEditDraft.subgrupos) {
                    $scope.subgrupos = groupEditDraft.subgrupos;
                  }

                  $scope.show_caratula = false;
                  $scope.show_subgrupo = true;
                  $scope.show_paquete = false;
                  $scope.create_subgroup = false;
                  $scope.create_package = false;
                }
              } else {
                $scope.package = $rootScope.edit_collective;
                $scope.originPackage = angular.copy($rootScope.edit_collective);

                $scope.package.coverage_package.forEach(function (coverage) {
                  coverage.sumInPolicy = {
                    value: coverage.sums_coverage[0].sum_insured,
                  };
                  coverage.deductibleInPolicy = {
                    value: coverage.deductible_coverage[0].deductible,
                  };
                  if (coverage.coinsurance_coverage.length > 0) {
                    coverage.coinsuranceInPolicy = {
                      value: coverage.coinsurance_coverage[0].coinsurance,
                    };
                  }
                  if (coverage.topecoinsurance_coverage.length > 0) {
                    coverage.topeCoinsuranceInPolicy = {
                      value:
                        coverage.topecoinsurance_coverage[0].topecoinsurance,
                    };
                  }
                });

                $scope.changePackage($scope.package);

                $scope.show_caratula = false;
                $scope.show_subgrupo = false;
                $scope.show_paquete = true;
                $scope.create_subgroup = false;
                $scope.create_package = false;
              }
            }
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });

      $scope.accesos = $sessionStorage.permisos;
      if ($scope.accesos) {
        $scope.accesos.forEach(function (perm) {
          if (perm.model_name == "Referenciadores") {
            $scope.acceso_ref = perm;
            $scope.acceso_ref.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver referenciadores") {
                if (acc.checked == true) {
                  $scope.acceso_ver_ref = true;
                } else {
                  $scope.acceso_ver_ref = false;
                }
              }
            });
          }
        });
      }
    }

    $scope.save_info_tab = function () {
      // Replica el snapshot previo en localStorage: conservamos la carátula y
      // las secciones dependientes en memoria para que el usuario no pierda los
      // cambios al navegar por las pestañas.
      groupEditDraft = angular.copy($scope.caratula) || {};
      groupEditDraft.subgrupos = angular.copy($scope.subgrupos);
      groupEditDraft.package = angular.copy($scope.package);
      groupEditDraft.newPackageCoverage = angular.copy(
        $scope.newPackageCoverage
      );
    };

    function fillProvider() {
      var d = $scope.startDate;
      try {
        var day = d.getDate();
        var month = d.getMonth() + 1; //Months are zero based
        var year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var day = f.getDate();
        var month = f.getMonth() + 1; //Months are zero based
        var year = f.getFullYear();
      }

      var date = year + "-" + month + "-" + day;
      providerService.getProviderByKey(date).then(
        function success(data) {
          $scope.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    $scope.checkDate = function (param) {
      if (param.length == 10) {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();
      } else {
        var day = new Date().getDate();
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();
        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();
      }
      $scope.directiveReceipts.startDate = param;
      $scope.directiveReceipts.endingDate = $scope.endDate;
      var date1 = new Date($scope.caratula.start_of_validity);
      var date2 = new Date($scope.caratula.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        $scope.caratula.end_of_validity = toDate(param);
        var date1 = new Date($scope.caratula.start_of_validity);
        var date2 = new Date($scope.caratula.end_of_validity);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        $scope.directiveReceipts.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
      }
    };

    function convertDate(inputFormat) {
      // console.log('fecha original',inputFormat)
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d_uno = new Date(inputFormat);
      var fecha = new Date(inputFormat);
      if (fecha.getUTCHours() <= 11) {
        fecha.setHours(fecha.getHours() + 12);
      } else {
        fecha.setHours(fecha.getHours() + 5);
      }
      var d = fecha;
      // var d = new Date(inputFormat).toISOString()//prueba
      // console.log('-fecha 2',d,new Date(d.toLocaleString()))
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
      // function pad(s) { return (s < 10) ? '0' + s : s; }
      // var d = new Date(inputFormat);
      // var date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
      // return date;
    }

    function toDate(dateStr) {
      if (dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(
          dateParts[2],
          dateParts[1] - 1,
          dateParts[0]
        ).toISOString(); // month is 0-based
        return dateObject;
      }
    }

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if ($scope.referenciadores) {
          $scope.referenciadores.some(function (user) {
            if (user.url == order.contratante.value.vendor) {
              $scope.referenciadorArray[0] = {
                referenciador: user.id,
                comision_vendedor: "",
              };
            }
          });
        }
        if (order.contratante.value.address_contractor) {
          $scope.caratula.contractor = order.contratante.value;
          $scope.addresses = order.contratante.value.address_contractor;

          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.caratula.address = $scope.addresses[0].url;
          }
        }
      }
    });

    $scope.changeAddress = function (param) {
      $scope.caratula.address = param;
    };

    $scope.contratanteCreator = function () {
      $rootScope.show_contractor = true;
      // $scope.orderInfo = vm;
      $localStorage.orderForm = JSON.stringify($scope.caratula);
    };

    $scope.getClaves = function (param, tipo) {
      $scope.caratula.aseguradora = param;
      $scope.aseguradoraSelected = param;
      $scope.ramoSelected = null;
      $scope.subramoSelected = null;
      $scope.caratula.ramo = null;
      $scope.caratula.subramo = null;
      if (tipo == 1) {
        if ($scope.caratula.aseguradora && $scope.caratula.aseguradora.id) {
          $http
            .get(
              url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id
            )
            .then(function success(clavesResponse) {
              $scope.claves = clavesResponse.data;
              if ($scope.claves.length == 1) {
                $scope.caratula.clave = $scope.claves[0];
                $scope.claveSelected = $scope.claves[0];
              } else {
                $scope.claves.forEach(function (item) {
                  if (item.id == $scope.caratula.clave.id) {
                    $scope.claveSelected = item;
                  }
                });
              }
            })
            .catch(function (error) {
              console.log("Error - claves-by-provider - catch", error);
            });

          $http
            .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
            .then(
              function success(response) {
                $scope.ramos = response.data;
                $scope.ramos.forEach(function (item) {
                  if (item.ramo_name == $scope.originCaratula.ramo.ramo_name) {
                    $scope.ramoSelected = item;
                    $scope.caratula.ramo = item;
                    $scope.subramos = item.subramo_ramo;
                    $scope.subramos.forEach(function (subramo) {
                      if (
                        subramo.subramo_name ==
                        $scope.originCaratula.subramo.subramo_name
                      ) {
                        $scope.subramoSelected = subramo;
                        $scope.caratula.subramo = subramo;

                        $scope.directiveReceipts.subramo = subramo;
                        $scope.dataToSave.subramo = subramo;

                        var comisiones = [];

                        if ($scope.claveSelected) {
                          if ($scope.claveSelected.clave_comision) {
                            if ($scope.claveSelected.clave_comision.length) {
                              $scope.claveSelected.clave_comision.forEach(
                                function (item) {
                                  if (
                                    $scope.subramoSelected.subramo_name ==
                                    item.subramo
                                  ) {
                                    comisiones.push(item);
                                  }
                                }
                              );
                            }
                          }
                        }

                        $scope.directiveReceipts.comisiones = comisiones;
                      }
                    });
                  }
                });
              },
              function error(e) {
                console.log("Error - ramos-by-provider", e);
              }
            )
            .catch(function (error) {
              console.log("Error - ramos-by-provider - catch", error);
            });
        } else {
          $scope.caratula.ramo = null;
          $scope.caratula.clave = null;
          $scope.caratula.subramo = null;
          $scope.ramos = [];
          $scope.subramos = [];
          $scope.ramoSelected = null;
          $scope.aseguradoraSelected = null;
          $scope.subramoSelected = null;
          $scope.claves = [];
          $scope.claveSelected = null;
        }
      } else {
        $scope.ramos = [];
        $scope.subramos = [];
        $scope.ramoSelected = null;
        $scope.aseguradoraSelected = null;
        $scope.subramoSelected = null;
        $scope.claves = [];
        $scope.claveSelected = null;
        $scope.caratula.aseguradora = param;
        if ($scope.caratula.aseguradora && $scope.caratula.aseguradora.id) {
          $http
            .get(
              url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id
            )
            .then(function success(clavesResponse) {
              $scope.claves = clavesResponse.data;
              if ($scope.claves.length == 1) {
                $scope.caratula.clave = $scope.claves[0];
                $scope.claveSelected = $scope.claves[0];
              } else {
                $scope.claves.forEach(function (item) {
                  if (item.id == $scope.caratula.clave.id) {
                    $scope.claveSelected = item;
                  }
                });
              }
            })
            .catch(function (error) {
              console.log("Error - claves-by-provider - catch", error);
            });

          $http
            .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
            .then(
              function success(response) {
                $scope.ramos = response.data;
                if (param && param.id == $scope.aseguradoraOriginal.id) {
                  $scope.ramos.forEach(function (item) {
                    if (
                      $scope.caratula &&
                      $scope.caratula.ramo &&
                      $scope.caratula.ramo.ramo_name &&
                      item.ramo_name == $scope.caratula.ramo.ramo_name
                    ) {
                      $scope.ramoSelected = item;
                      $scope.subramos = item.subramo_ramo;
                      $scope.subramos.forEach(function (subramo) {
                        if (
                          subramo.subramo_name ==
                          $scope.caratula.subramo.subramo_name
                        ) {
                          $scope.subramoSelected = subramo;

                          $scope.directiveReceipts.subramo = subramo;
                          $scope.dataToSave.subramo = subramo;

                          var comisiones = [];

                          if ($scope.claveSelected) {
                            if ($scope.claveSelected.clave_comision) {
                              if ($scope.claveSelected.clave_comision.length) {
                                $scope.claveSelected.clave_comision.forEach(
                                  function (item) {
                                    if (
                                      $scope.subramoSelected.subramo_name ==
                                      item.subramo
                                    ) {
                                      comisiones.push(item);
                                    }
                                  }
                                );
                              }
                            }
                          }

                          $scope.directiveReceipts.comisiones = comisiones;
                        }
                      });
                    }
                  });
                } else {
                  $scope.caratula.ramo = null;
                  $scope.caratula.subramo = null;
                  $scope.ramoSelected = null;
                  $scope.subramoSelected = null;
                }
              },
              function error(e) {
                console.log("Error - ramos-by-provider", e);
              }
            )
            .catch(function (error) {
              console.log("Error - ramos-by-provider - catch", error);
            });
        }
      }
    };

    $scope.refreshProvider = function () {
      fillProvider();
    };

    $scope.changeClave = function (param) {
      if (param) {
        $scope.caratula.clave = param;
        $scope.claveSelected = param;
      }
    };

    $scope.changeRamo = function (param) {
      if (param) {
        $scope.subramoSelected = null;
        $scope.caratula.ramo = param;
        $scope.caratula.subramo = null;
        $scope.subramos = param.subramo_ramo;
      }
    };

    $scope.changeSubramo = function (param) {
      if (param) {
        $scope.caratula.subramo = param;
        $scope.directiveReceipts.subramo = param;

        var comisiones = [];
        if ($scope.claveSelected.clave_comision.length) {
          $scope.claveSelected.clave_comision.forEach(function (item) {
            if (param.subramo_name == item.subramo) {
              comisiones.push(item);
            }
          });
        }

        $scope.directiveReceipts.comisiones = comisiones;
      }
    };

    $scope.changeRenewal = function (param) {
      $scope.caratula.is_renewable = param.value;
      setGroupEditDraftValue("is_renewable", param);
    };

    $scope.changeAdminType = function (param) {
      $scope.caratula.administration_type = param.value;
      if ($scope.caratula.administration_type == 1) {
        SweetAlert.swal(
          "Simplificada",
          "Se puede capturar endoso por el ajuste anual “A” o “D según el caso.",
          "info"
        );
      } else if ($scope.caratula.administration_type == 2) {
        SweetAlert.swal(
          "Autoadministrada",
          "Se pueden capturar endosos por movimientos de altas o bajas sin recibos y, sin notas de crédito.",
          "info"
        );
      } else if ($scope.caratula.administration_type == 3) {
        SweetAlert.swal(
          "Detallada",
          "Se pueden capturar endosos por movimientos de altas o bajas con recibos al cobro o notas de crédito, según el caso.",
          "info"
        );
      }
      setGroupEditDraftValue("administration_type", param);
    };

    $scope.changeCurrency = function (param) {
      $scope.caratula.f_currency = param;
      setGroupEditDraftValue("f_currency", param);
    };

    $scope.changeResponsable = function (param) {
      $scope.caratula.responsable = param;
      setGroupEditDraftValue("responsable", param);
    };

    $scope.changeExecutive = function (param) {
      $scope.caratula.collection_executive = param;
      setGroupEditDraftValue("collection_executive", param);
    };

    $scope.changeSucursal = function (param) {
      $scope.caratula.sucursal = param;
      setGroupEditDraftValue("sucursal", param);
    };

    $scope.changeCelula = function (param) {
      $scope.caratula.celula = param.url;
      setGroupEditDraftValue("celula", param);
      $scope.celulaSelected = param;
    };

    $scope.changeAgrupacion = function (data) {
      $scope.sub_asignaciones = data.subgrupos;
      $scope.sub_subasignaciones = [];
      $scope.caratula.groupinglevel = data.url;
      if ($scope.info_sub.subgrouping_level) {
        $http
          .get(url.IP + "groupinglevel/" + $scope.info_sub.subgrouping_level.id)
          .then(function (response) {
            $scope.subgroupingSelected = response.data;
            if ($scope.subgroupingSelected.parent != data.url) {
              $scope.subgroupingSelected = {};
            }
            $scope.sub_asignaciones.forEach(function (item) {
              if (item.id == $scope.subgroupingSelected.id) {
                $scope.subgroupingSelected = item;
                $scope.changeSubagrupacion(item);
              }
            });
          });
      }
    };

    $scope.changeSubagrupacion = function (data) {
      $scope.sub_subasignaciones = [];
      if (data.subsubgrupos) {
        $scope.sub_subasignaciones = data.subsubgrupos;
        $scope.caratula.groupinglevel = data.url;
        if ($scope.info_sub.subsubgrouping_level) {
          $http
            .get(
              url.IP +
                "groupinglevel/" +
                $scope.info_sub.subsubgrouping_level.id
            )
            .then(function (response) {
              $scope.subsubgroupingSelected = response.data;
              $scope.caratula.groupinglevel = response.data.url;
              if ($scope.subsubgroupingSelected.parent != data.url) {
                $scope.subsubgroupingSelected = {};
              }
              $scope.sub_asignaciones.forEach(function (item) {
                if (item.id == $scope.subsubgroupingSelected.id) {
                  $scope.subsubgroupingSelected = item;
                  $scope.caratula.groupinglevel = item.url;
                  $scope.changeSubsubagrupacion(item);
                }
              });
            });
        }
      }
    };

    $scope.changeSubsubagrupacion = function (data) {
      if (data) {
        $scope.caratula.groupinglevel = data.url;
      }
    };

    $scope.addReferenciador = function () {
      var addReferenciadores = {
        referenciador: "",
        comision_vendedor: "",
      };
      $scope.referenciadorArray.push(addReferenciadores);
    };

    $scope.deleteReferenciador = function (index) {
      $scope.referenciadorArray.splice(index, 1);
    };

    $scope.changeComRef = function (param, index, com) {
      $scope.referenciadorArray[index].comision_vendedor = param;
      if (com.comision_vendedor > 100) {
        com.comision_vendedor = 0;
      } else if (com.comision_vendedor < 0) {
        com.comision_vendedor = 0;
      }
      $scope.checkTotalComision(com);
    };
    $scope.checkTotalComision = function (item) {
      var totalComision = $scope.referenciadorArray.reduce(function (
        sum,
        item
      ) {
        return sum + (parseFloat(item.comision_vendedor) || 0); // Convert to number, default to 0 if undefined
      },
      0);
      if (totalComision > 100) {
        $scope.comisionError =
          "La suma de las comisiones no puede superar el 100%";
        item.comision_vendedor = 0;
      } else {
        $scope.comisionError = null; // No error if total is within limit
      }
    };

    $scope.chanceScheme = function (param) {
      $scope.caratula.scheme = parseInt(param);
      if (param == 1) {
        $scope.frequencies = [
          { value: 7, label: "Semanal" },
          { value: 14, label: "Catorcenal" },
          // {'value':24, 'label':'Quincenal'},
          { value: 1, label: "Mensual" },
          { value: 2, label: "Bimestral" },
          { value: 3, label: "Trimestral" },
          { value: 6, label: "Semestral" },
          { value: 12, label: "Anual" },
          { value: 5, label: "Contado" },
        ];
        $scope.caratula.receipts_by = $scope.originCaratula.receipts_by;
        $scope.btnTraditionalStyle = {
          color: "#ffffff",
          "background-color": "#1cb394",
        };
        $scope.btnMinimalStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1cb394",
          "border-right": "1px solid #1cb394",
          "border-bottom": "1px solid #1cb394",
        };
      } else {
        $scope.frequencies = [{ value: 5, label: "Contado" }];
        $scope.paymentSelected = $scope.frequencies[0].value;
        $scope.chancePayment(5);
        $scope.caratula.receipts_by = 1;
        $scope.btnTraditionalStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1cb394",
          "border-bottom": "1px solid #1cb394",
          "border-left": "1px solid #1cb394",
        };
        $scope.btnMinimalStyle = {
          color: "#ffffff",
          "background-color": "#1cb394",
        };
        SweetAlert.swal(
          "Prima Mínima",
          "El esquema de pago de prima mínima solo permite recibos a nivel póliza.",
          "info"
        );
      }
    };
    $scope.formapagochanged = false;
    $scope.chancePayment = function (param) {
      $scope.formapagochanged = false;
      if (
        param != $scope.originCaratula.forma_de_pago &&
        $scope.showOt == false &&
        (($scope.dataToSave &&
          $scope.dataToSave.recibos_poliza &&
          $scope.dataToSave.recibos_poliza.length > 0) ||
          ($scope.caratula &&
            $scope.caratula.recibos_poliza &&
            $scope.caratula.recibos_poliza.length > 0))
      ) {
        $scope.dataToSave.recibos_poliza = [];
        $scope.formapagochanged = true;
        SweetAlert.swal(
          "Cambio Forma de Pago",
          "Debe volver a Generar Recibos por cambio de Forma de Pago",
          "info"
        );
      }
      $scope.caratula.forma_de_pago = parseInt(param);
      $scope.directiveReceipts.payment = { value: param };
    };

    $scope.deleteReferenciador = function (param, index) {
      SweetAlert.swal(
        {
          title: "Eliminar Referenciador",
          text: "Los cambios no podrán revertirse, ¿Estás seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "No",
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.referenciadorArray.forEach(function (item) {
              if (item.url) {
                if (param.url == item.url) {
                  $http.delete(param.url);
                  $scope.referenciadorArray.splice(index, 1);
                  var paramsRec = {
                    model: 18,
                    event: "PATCH",
                    associated_id: $scope.caratula.id,
                    identifier:
                      " eliminó un referenciador " +
                      item.data.first_name +
                      " " +
                      item.data.last_name,
                    change: [],
                  };
                  dataFactory
                    .post("send_log_specific/", paramsRec)
                    .then(function success(responseLo) {});
                }
              }
            });
          }
        }
      );
    };

    $scope.validityInsurance = function () {
      if (!$scope.caratula.identifier) {
        SweetAlert.swal("Error", MESSAGES.ERROR.IDENTIFIERREQUIRED, "error");
        return;
      }
      if (!$scope.showOt) {
        if (!$scope.caratula.poliza_number) {
          SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
          return;
        }
      }
      if (!order.contratante.val) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        return;
      }
      if (!$scope.caratula.address) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        return;
      }
      if (!$scope.caratula.clave || !$scope.claveSelected) {
        SweetAlert.swal("Error", "Ingrese una clave", "error");
        return;
      }
      if (!$scope.caratula.aseguradora) {
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        return;
      }
      if (!$scope.caratula.clave) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        return;
      }
      if (!$scope.caratula.ramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        return;
      }
      if (!$scope.caratula.subramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (!$scope.caratula.administration_type) {
        SweetAlert.swal(
          "Error",
          MESSAGES.ERROR.ADMINISTRATIONREQUIRED,
          "error"
        );
        return;
      }
      if (!$scope.caratula.forma_de_pago) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORPAYFORM, "error");
        return;
      }

      // if(!$scope.showOt && $scope.caratula.receipts_by == 1){
      //   if(!$scope.dataToSave.recibos_poliza){
      //     SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
      //     return;
      //   }
      //   if($scope.caratula.scheme == 2){
      //     if($scope.dataToSave.steps.length != ($scope.dataToSave.recibos_poliza.length - 1)){
      //       SweetAlert.swal("Error", "El número de escalones no coincide con el número de recibos.", "error");
      //       return;
      //     }
      //     if(parseFloat($scope.dataToSave.sumaPorcentaje) != 100){
      //       SweetAlert.swal('Error', 'La sumatoria de todos los porcentajes de cada escalon no pueden se diferente al 100%, verifica los porcentajes.', 'error');
      //       return;
      //     }
      //   }
      // }
      $scope.updateCaralule();
    };

    $scope.changeBusinessLine = function (val) {
      $scope.business_lineSelected = val;
    };
    $scope.updateCaralule = function () {
      $scope.changes = [];
      $scope.changesContractor = [];
      var data_caratula = {
        identifier: $scope.caratula.identifier
          ? $scope.caratula.identifier
          : null,
        folio: $scope.caratula.folio ? $scope.caratula.folio : null,
        poliza_number: $scope.caratula.poliza_number
          ? $scope.caratula.poliza_number
          : null,
        contractor: $scope.caratula.contractor
          ? $scope.caratula.contractor.url
          : null,
        address: $scope.caratula.address.url,
        start_of_validity: $scope.caratula.start_of_validity,
        end_of_validity: $scope.caratula.end_of_validity,
        aseguradora: $scope.caratula.aseguradora.url,
        clave: $scope.caratula.clave.url,
        ramo: $scope.caratula.ramo.url,
        subramo: $scope.caratula.subramo.url,
        is_renewable: $scope.caratula.is_renewable
          ? $scope.caratula.is_renewable
          : $scope.renewalSelected
          ? $scope.renewalSelected.value
          : null,
        administration_type:
          $scope.caratula.administration_type == "Simplificada" ||
          $scope.caratula.administration_type == 1
            ? 1
            : $scope.caratula.administration_type == "Autoadministrada" ||
              $scope.caratula.administration_type == 2
            ? 2
            : 3,
        f_currency: $scope.caratula.f_currency,
        responsable: $scope.caratula.responsable
          ? $scope.caratula.responsable.url
          : null,
        collection_executive: $scope.caratula.collection_executive
          ? $scope.caratula.collection_executive.url
          : null,
        sucursal: $scope.caratula.sucursal
          ? $scope.caratula.sucursal.url
          : null,
        observations: $scope.caratula.observations
          ? $scope.caratula.observations
          : "",
        forma_de_pago: $scope.caratula.forma_de_pago,
        scheme: $scope.caratula.scheme,
        status:
          $scope.caratula.status == "Vigente" || $scope.caratula.status == 14
            ? 14
            : $scope.caratula.status == "Vencida" ||
              $scope.caratula.status == 13
            ? 13
            : $scope.caratula.status == "Renovada" ||
              $scope.caratula.status == 12
            ? 12
            : $scope.caratula.status == "Cancelada" ||
              $scope.caratula.status == 11
            ? 11
            : $scope.caratula.status == "Por iniciar" ||
              $scope.caratula.status == 10
            ? 10
            : $scope.caratula.status == "En trámite" ||
              $scope.caratula.status == 1
            ? 1
            : $scope.caratula.status == "No Renovada" ||
              $scope.caratula.status == 15
            ? 15
            : 10,
        p_neta: $scope.dataToSave.poliza.primaNeta
          ? $scope.dataToSave.poliza.primaNeta
          : 0,
        descuento: $scope.dataToSave.poliza.descuento
          ? $scope.dataToSave.poliza.descuento
          : 0,
        rpf: $scope.dataToSave.poliza.rpf ? $scope.dataToSave.poliza.rpf : 0,
        derecho: $scope.dataToSave.poliza.derecho
          ? $scope.dataToSave.poliza.derecho
          : 0,
        sub_total: $scope.dataToSave.poliza.subTotal
          ? $scope.dataToSave.poliza.subTotal
          : 0,
        iva: $scope.dataToSave.poliza.iva ? $scope.dataToSave.poliza.iva : 0,
        p_total: $scope.dataToSave.poliza.primaTotal
          ? $scope.dataToSave.poliza.primaTotal
          : 0,
        comision: $scope.dataToSave.comision
          ? $scope.dataToSave.comision
          : $scope.caratula.comision,
        comision_percent: $scope.dataToSave.comision_percent
          ? $scope.dataToSave.comision_percent
          : $scope.caratula.comision_percent,
        comision_derecho_percent: $scope.dataToSave.poliza
          .comision_derecho_percent
          ? $scope.dataToSave.poliza.comision_derecho_percent
          : $scope.caratula.comision_derecho_percent,
        comision_rpf_percent: $scope.dataToSave.poliza.comision_rpf_percent
          ? $scope.dataToSave.poliza.comision_rpf_percent
          : $scope.caratula.comision_rpf_percent,
        total_receipts: $scope.dataToSave.recibos_poliza
          ? $scope.dataToSave.recibos_poliza.length
          : $scope.caratula.total_receipts,
        accident_rate: $scope.dataToSave.poliza.accident_rate
          ? $scope.dataToSave.poliza.accident_rate
          : $scope.dataToSave.accident_rate,
        steps: $scope.dataToSave.steps ? $scope.dataToSave.steps : [],
        business_line: $scope.business_lineSelected
          ? $scope.business_lineSelected.id
          : 0,
        celula:
          $scope.caratula.celula && $scope.caratula.celula.url
            ? $scope.caratula.celula.url
            : $scope.caratula.celula
            ? $scope.caratula.celula
            : "",
        groupinglevel: $scope.caratula.groupinglevel
          ? $scope.caratula.groupinglevel
          : "",
        conducto_de_pago: $scope.caratula.conducto_de_pago
          ? $scope.caratula.conducto_de_pago
          : 1,
      };
      if (
        $scope.dataToSave &&
        $scope.dataToSave.prima_comision &&
        parseFloat(data_caratula.comision_percent) !=
          parseFloat($scope.dataToSave.prima_comision)
      ) {
        data_caratula.comision_percent = $scope.dataToSave.prima_comision
          ? $scope.dataToSave.prima_comision
          : $scope.dataToSave.comision_percent
          ? $scope.dataToSave.comision_percent
          : 0;
      }
      $scope.referenciadoresSelected = [];
      $scope.referenciadorArray.forEach(function (item) {
        if (item.referenciador != "") {
          if (item.comision_vendedor == "") {
            item.comision_vendedor = 0;
          }
          $scope.referenciadoresSelected.push(item);
        }
      });

      $http
        .patch(order.contratante.value.url, {
          email: order.contratante.value.email,
          phone_number: order.contratante.value.phone_number,
        })
        .then(function (data) {
          if (data.status == 200 || data.status == 201) {
            if ($scope.originCaratula.contractor) {
              var data_contractor = $scope.originCaratula.contractor;
            }
            if (data_contractor.email !== data.data.email) {
              var change_log = {
                name: "Correo Electrónico",
                origin: data_contractor.email,
                change: data.data.email,
              };
              $scope.changesContractor.push(change_log);
            }
            if (data_contractor.phone_number !== data.data.phone_number) {
              var change_log = {
                name: "Teléfono",
                origin: data_contractor.emphone_numberail,
                change: data.data.phone_number,
              };
              $scope.changesContractor.push(change_log);
            }
            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.caratula.id,
              identifier: " actualizó la carátula.",
              change: $scope.changesContractor,
            };
            if ($scope.changesContractor.length != 0) {
              dataFactory
                .post("send_log_specific/", paramsRec)
                .then(function success(response) {});
            }
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
      $http
        .patch($scope.caratula.url, data_caratula)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            resetGroupEditDraft();
            $scope.caratula = response.data;
            response.data.recibos_poliza.forEach(function (recibo) {
              $http.patch(recibo, {
                conducto_de_pago: data_caratula.conducto_de_pago,
              });
            });

            if ($scope.childs && $scope.childs.length > 0) {
              $scope.childs.some(function (child) {
                if (child.recibos_poliza && child.recibos_poliza.length > 0) {
                  child.recibos_poliza.forEach(function (recibo) {
                    console.log("iiiiiiiiiiiiiiiiiiiiiiii", recibo);
                    $http.patch(recibo["url"], {
                      conducto_de_pago: data_caratula.conducto_de_pago,
                    });
                  });
                }
              });
            }

            if ($scope.originCaratula.identifier !== response.data.identifier) {
              var change_log = {
                name: "Identificador",
                origin: $scope.originCaratula.identifier,
                change: response.data.identifier,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCaratula.folio !== response.data.folio) {
              var change_log = {
                name: "Folio",
                origin: $scope.originCaratula.folio,
                change: response.data.folio,
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.poliza_number !==
              response.data.poliza_number
            ) {
              var change_log = {
                name: "No. Póliza",
                origin: $scope.originCaratula.poliza_number,
                change: response.data.poliza_number,
              };
              $scope.changes.push(change_log);
            }
            var data_address = {};
            if ($scope.originCaratula.contractor) {
              var data_contractor = $scope.originCaratula.contractor;
              $scope.originCaratula.contractor.address_contractor.forEach(
                function (item) {
                  if (item.id == $scope.originCaratula.address) {
                    data_address = item;
                  }
                }
              );
            }
            if (response.data.contractor) {
              var response_contractor = response.data.contractor;
            }
            if (data_contractor.url !== response_contractor) {
              var change_log = {
                name: "Contratante",
                origin: data_contractor.full_name
                  ? data_contractor.full_name
                  : data_contractor.first_name,
                change: $scope.caratula.contractor
                  ? $scope.caratula.contractor.full_name
                  : $scope.caratula.contractor.first_name,
              };
              $scope.changes.push(change_log);
            }
            if (data_address.url !== response.data.address) {
              if ($scope.caratula && $scope.caratula.address) {
                var change_log = {
                  name: "Dirección",
                  origin:
                    data_address.route +
                    " #" +
                    data_address.street_number +
                    ", " +
                    data_address.administrative_area_level_1 +
                    ", " +
                    data_address.administrative_area_level_2,
                  change:
                    $scope.caratula.address.route +
                    " #" +
                    $scope.caratula.address.street_number +
                    ", " +
                    $scope.caratula.address.administrative_area_level_1 +
                    ", " +
                    $scope.caratula.address.administrative_area_level_2,
                };
                $scope.changes.push(change_log);
              }
            }
            if (
              $scope.originCaratula.start_of_validity !==
              response.data.start_of_validity
            ) {
              var change_log = {
                name: "Fecha Inicio",
                origin: convertDate($scope.originCaratula.start_of_validity),
                change: convertDate(response.data.start_of_validity),
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.end_of_validity !==
              response.data.end_of_validity
            ) {
              var change_log = {
                name: "Fecha Fin",
                origin: convertDate($scope.originCaratula.end_of_validity),
                change: convertDate(response.data.end_of_validity),
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.aseguradora.url !==
              response.data.aseguradora
            ) {
              var change_log = {
                name: "Aseguradora",
                origin: $scope.originCaratula.aseguradora.alias,
                change: $scope.caratula.aseguradora.alias,
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.clave &&
              $scope.originCaratula.clave.url !== response.data.clave
            ) {
              var change_log = {
                name: "Clave",
                origin:
                  $scope.originCaratula.clave.name +
                  " " +
                  $scope.originCaratula.clave.clave,
                change:
                  $scope.caratula.clave.name +
                  " " +
                  $scope.caratula.clave.clave,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCaratula.ramo.url !== response.data.ramo) {
              var change_log = {
                name: "Ramo",
                origin: $scope.originCaratula.ramo.ramo_name,
                change: $scope.caratula.ramo.ramo_name,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCaratula.subramo.url !== response.data.subramo) {
              var change_log = {
                name: "Subramo",
                origin: $scope.originCaratula.subramo.subramo_name,
                change: $scope.caratula.subramo.subramo_name,
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.is_renewable !== response.data.is_renewable
            ) {
              var change_log = {
                name: "Renovable",
                origin:
                  $scope.originCaratula.is_renewable == 1
                    ? "Renovable"
                    : "No Renovable",
                change:
                  response.data.is_renewable == 1
                    ? "Renovable"
                    : "No Renovable",
              };
              $scope.changes.push(change_log);
            }
            if (response.data.administration_type == 1) {
              var administration = "Simplificada";
            } else if (response.data.administration_type == 2) {
              var administration = "Autoadministrada";
            } else if (response.data.administration_type == 3) {
              var administration = "Detallada";
            }
            if ($scope.originCaratula.administration_type !== administration) {
              var change_log = {
                name: "Tipo de Administración",
                origin: $scope.originCaratula.administration_type,
                change: administration,
              };
              $scope.changes.push(change_log);
            }
            if (response.data.f_currency == 1) {
              var currency = "Pesos";
            } else if (response.data.f_currency == 2) {
              var currency = "Dólares";
            } else if (response.data.f_currency == 3) {
              var currency = "UDI";
            } else if (response.data.f_currency == 4) {
              var currency = "Euros";
            }
            if ($scope.originCaratula.f_currency !== currency) {
              var change_log = {
                name: "Moneda",
                origin: $scope.originCaratula.f_currency,
                change: currency,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCaratula.responsable) {
              if (
                $scope.originCaratula.responsable.url !==
                response.data.responsable
              ) {
                var change_log = {
                  name: "Responsable",
                  origin: $scope.originCaratula.responsable
                    ? $scope.originCaratula.responsable.first_name +
                      " " +
                      $scope.originCaratula.responsable.last_name
                    : "Ninguno",
                  change: $scope.caratula.responsable
                    ? $scope.caratula.responsable.first_name +
                      " " +
                      $scope.caratula.responsable.last_name
                    : "Ninguno",
                };
                $scope.changes.push(change_log);
              }
            } else {
              if (
                $scope.originCaratula.responsable !== response.data.responsable
              ) {
                var change_log = {
                  name: "Responsable",
                  origin: $scope.originCaratula.responsable
                    ? $scope.originCaratula.responsable.first_name +
                      " " +
                      $scope.originCaratula.responsable.last_name
                    : "Ninguno",
                  change: $scope.caratula.responsable
                    ? $scope.caratula.responsable.first_name +
                      " " +
                      $scope.caratula.responsable.last_name
                    : "Ninguno",
                };
                $scope.changes.push(change_log);
              }
            }
            if ($scope.originCaratula.collection_executive) {
              if (
                $scope.originCaratula.collection_executive.url !==
                response.data.collection_executive
              ) {
                var change_log = {
                  name: "E. Cobranza",
                  origin: $scope.originCaratula.collection_executive
                    ? $scope.originCaratula.collection_executive.first_name +
                      " " +
                      $scope.originCaratula.collection_executive.last_name
                    : "Ninguno",
                  change: $scope.caratula.collection_executive
                    ? $scope.caratula.collection_executive.first_name +
                      " " +
                      $scope.caratula.collection_executive.last_name
                    : "Ninguno",
                };
                $scope.changes.push(change_log);
              }
            } else {
              if (
                $scope.originCaratula.collection_executive !==
                response.data.collection_executive
              ) {
                var change_log = {
                  name: "E. Cobranza",
                  origin: $scope.originCaratula.collection_executive
                    ? $scope.originCaratula.collection_executive.first_name +
                      " " +
                      $scope.originCaratula.collection_executive.last_name
                    : "Ninguno",
                  change: $scope.caratula.collection_executive
                    ? $scope.caratula.collection_executive.first_name +
                      " " +
                      $scope.caratula.collection_executive.last_name
                    : "Ninguno",
                };
                $scope.changes.push(change_log);
              }
            }
            if ($scope.originCaratula.sucursal) {
              if (
                $scope.originCaratula.sucursal.url !== response.data.sucursal
              ) {
                var change_log = {
                  name: "Sucursal",
                  origin: $scope.originCaratula.sucursal
                    ? $scope.originCaratula.sucursal.sucursal_name
                    : "Ninguno",
                  change: $scope.caratula.sucursal
                    ? $scope.caratula.sucursal.sucursal_name
                    : "Ninguno",
                };
                $scope.changes.push(change_log);
              }
            } else {
              if ($scope.originCaratula.sucursal !== response.data.sucursal) {
                var change_log = {
                  name: "Sucursal",
                  origin: $scope.originCaratula.sucursal
                    ? $scope.originCaratula.sucursal.sucursal_name
                    : "Ninguno",
                  change: $scope.caratula.sucursal
                    ? $scope.caratula.sucursal.sucursal_name
                    : "Ninguno",
                };
                $scope.changes.push(change_log);
              }
            }
            if ($scope.originCaratula.scheme !== response.data.scheme) {
              var change_log = {
                name: "Esquema de Pago",
                origin:
                  $scope.originCaratula.scheme == 1
                    ? "Tradicional"
                    : "Prima Mínima",
                change:
                  response.data.scheme == 1 ? "Tradicional" : "Prima Mínima",
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.business_line !==
              response.data.business_line
            ) {
              var change_log = {
                name: "Linea de Negocio",
                origin:
                  $scope.originCaratula.business_line == 0
                    ? "Otro"
                    : $scope.originCaratula.business_line == 1
                    ? "Comercial"
                    : "Perosnal",
                change:
                  response.data.business_line == 0
                    ? "Otro"
                    : response.data.business_line == 1
                    ? "Comercial"
                    : "Perosnal",
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.groupinglevel !==
              response.data.groupinglevel
            ) {
              if (
                $scope.originCaratula.grouping_level.description !==
                response.data.grouping_level.description
              ) {
                var change_log = {
                  name: "Agrupación",
                  origin: $scope.originCaratula.grouping_level.description,
                  change: response.data.grouping_level.description,
                };
                $scope.changes.push(change_log);
              }
            }
            if (
              $scope.originCaratula.total_receipts !==
              response.data.total_receipts
            ) {
              var change_log = {
                name: "No. Recibos",
                origin: $scope.originCaratula.total_receipts,
                change: response.data.total_receipts,
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.forma_de_pago !==
              response.data.forma_de_pago
            ) {
              var change_log = {
                name: "Frecuencia de Pago",
                origin:
                  $scope.originCaratula.forma_de_pago == 1
                    ? "Mensual"
                    : $scope.originCaratula.forma_de_pago == 2
                    ? "Bimestral"
                    : $scope.originCaratula.forma_de_pago == 3
                    ? "Trimestral"
                    : $scope.originCaratula.forma_de_pago == 5
                    ? "Anual"
                    : $scope.originCaratula.forma_de_pago == 6
                    ? "Semestral"
                    : $scope.originCaratula.forma_de_pago == 7
                    ? "Semanal"
                    : $scope.originCaratula.forma_de_pago == 12
                    ? "contado"
                    : $scope.originCaratula.forma_de_pago == 14
                    ? "Catorcenal"
                    : "Quincenal",
                change:
                  response.data.forma_de_pago == 1
                    ? "Mensual"
                    : response.data.forma_de_pago == 2
                    ? "Bimestral"
                    : response.data.forma_de_pago == 3
                    ? "Trimestral"
                    : response.data.forma_de_pago == 5
                    ? "Anual"
                    : response.data.forma_de_pago == 6
                    ? "Semestral"
                    : response.data.forma_de_pago == 7
                    ? "Semanal"
                    : response.data.forma_de_pago == 12
                    ? "contado"
                    : response.data.forma_de_pago == 14
                    ? "Catorcenal"
                    : "Quincenal",
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.accident_rate !==
              response.data.accident_rate
            ) {
              var change_log = {
                name: "Siniestralidad",
                origin: $scope.originCaratula.accident_rate + "%",
                change: response.data.accident_rate + "%",
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.scheme == 2 &&
              $scope.originCaratula.steps
            ) {
              var origin_steps = $scope.originCaratula.steps.replace(/'/g, '"');
              var origin_steps = JSON.parse(origin_steps);
              var response_steps = response.data.steps.replace(/'/g, '"');
              var response_steps = JSON.parse(response_steps);
              if (origin_steps.length !== response_steps.length) {
                var change_log = {
                  name: "No. Escalones",
                  origin: origin_steps.length,
                  change: response_steps.length,
                };
                $scope.changes.push(change_log);
              }
            }
            if (
              $scope.originCaratula.conducto_de_pago !==
              response.data.conducto_de_pago
            ) {
              var change_log = {
                name: "Conducto de pago",
                origin:
                  $scope.originCaratula.conducto_de_pago == 1
                    ? "No domiciliada"
                    : $scope.originCaratula.conducto_de_pago == 2
                    ? "Agente"
                    : $scope.originCaratula.conducto_de_pago == 3
                    ? "CAC"
                    : $scope.originCaratula.conducto_de_pago == 4
                    ? "CAT/Domiciliado"
                    : $scope.originCaratula.conducto_de_pago == 5
                    ? "Nómina"
                    : "CUT",
                change:
                  response.data.conducto_de_pago == 1
                    ? "No domiciliada"
                    : response.data.conducto_de_pago == 2
                    ? "Agente"
                    : response.data.conducto_de_pago == 3
                    ? "CAC"
                    : response.data.conducto_de_pago == 4
                    ? "CAT/Domiciliado"
                    : response.data.conducto_de_pago == 5
                    ? "Nómina"
                    : "CUT",
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.observations !== response.data.observations
            ) {
              var change_log = {
                name: "Observaciones",
                origin: $scope.originCaratula.observations,
                change: response.data.observations,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCaratula.p_neta != response.data.p_neta) {
              var change_log = {
                name: "Prima Neta",
                origin: "$" + $scope.originCaratula.p_neta,
                change: "$" + response.data.p_neta,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCaratula.descuento != response.data.descuento) {
              var change_log = {
                name: "Descuento",
                origin: "$" + $scope.originCaratula.descuento,
                change: "$" + response.data.descuento,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCaratula.rpf != response.data.rpf) {
              var change_log = {
                name: "RPF",
                origin: "$" + $scope.originCaratula.rpf,
                change: "$" + response.data.rpf,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCaratula.derecho != response.data.derecho) {
              var change_log = {
                name: "Derecho",
                origin: "$" + $scope.originCaratula.derecho,
                change: "$" + response.data.derecho,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCaratula.iva != response.data.iva) {
              var change_log = {
                name: "IVA",
                origin: "$" + $scope.originCaratula.iva,
                change: "$" + response.data.iva,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCaratula.p_total != response.data.p_total) {
              var change_log = {
                name: "Prima Total",
                origin: "$" + $scope.originCaratula.p_total,
                change: "$" + response.data.p_total,
              };
              $scope.changes.push(change_log);
            }
            if ($scope.originCaratula.comision != response.data.comision) {
              var change_log = {
                name: "Comisión",
                origin: "$" + $scope.originCaratula.comision,
                change: "$" + response.data.comision,
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.comision_percent !=
              response.data.comision_percent
            ) {
              var change_log = {
                name: "Porcentaje Comisión",
                origin: "$" + $scope.originCaratula.comision_percent,
                change: "$" + response.data.comision_percent,
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.comision_derecho_percent !=
              response.data.comision_derecho_percent
            ) {
              var change_log = {
                name: "%Comisión Derecho",
                origin: "$" + $scope.originCaratula.comision_derecho_percent,
                change: "$" + response.data.comision_derecho_percent,
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originCaratula.comision_rpf_percent !=
              response.data.comision_rpf_percent
            ) {
              var change_log = {
                name: "%Comisión RPF",
                origin: "$" + $scope.originCaratula.comision_rpf_percent,
                change: "$" + response.data.comision_rpf_percent,
              };
              $scope.changes.push(change_log);
            }
            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.caratula.id,
              identifier: " actualizó la carátula.",
              change: $scope.changes,
            };
            if ($scope.changes.length != 0) {
              dataFactory
                .post("send_log_specific/", paramsRec)
                .then(function success(responseLo) {});
            }
            $scope.referenciadoresSelected.forEach(function (referencing) {
              referencing.policy = response.data.url;
              var ref_to_change = referencing;
              if (referencing.url) {
                $http
                  .patch(referencing.url, referencing)
                  .then(function (responseRA) {
                    if (responseRA.status == 200 || responseRA.status == 201) {
                      var paramsRec = {
                        model: 18,
                        event: "PATCH",
                        associated_id: $scope.caratula.id,
                        identifier: " actualizó un referenciador.",
                        change: [],
                      };
                      try {
                        if (
                          ref_to_change.ref_name.toLowerCase() !=
                          responseRA.data.ref_name.toLowerCase()
                        ) {
                          var params = {
                            model: 18,
                            event: "PATCH",
                            associated_id: $scope.caratula.id,
                            identifier:
                              " cambio el referenciador " +
                              ref_to_change.ref_name +
                              " por: " +
                              responseRA.data.ref_name +
                              " a la póliza.",
                          };
                          dataFactory
                            .post("send-log/", params)
                            .then(function success(response) {});
                        }
                      } catch (uuu) {}
                      // dataFactory.post('send_log_specific/', paramsRec).then(function success(responseLo){});
                    }
                  })
                  .catch(function (e) {
                    console.log(e);
                  });
              } else {
                if (referencing.referenciador) {
                  dataFactory
                    .post("referenciadores-policy/", referencing)
                    .then(function (responseRN) {
                      if (
                        responseRN.status == 200 ||
                        responseRN.status == 201
                      ) {
                        $http
                          .get(referencing.referenciador)
                          .then(function success(rfp) {
                            if (rfp) {
                              $scope.inforef = rfp.data;
                              var params = {
                                model: 18,
                                event: "PATCH",
                                associated_id: $scope.caratula.id,
                                identifier:
                                  " añadio el referenciador " +
                                  $scope.inforef.first_name +
                                  " " +
                                  $scope.inforef.last_name +
                                  " a la póliza.",
                              };
                              dataFactory
                                .post("send-log/", params)
                                .then(function success(response) {});
                            }
                          });
                      }
                    })
                    .catch(function (e) {
                      console.log(e);
                    });
                }
              }
            });
            $scope.recibos_patch = [];
            $scope.nota_patch = [];
            if ($scope.receipts) {
              $scope.receipts.forEach(function (receipt) {
                if (receipt.receipt_type == 1) {
                  $scope.recibos_patch.push(receipt);
                  console.log("ooooooooooo", $scope.recibos_patch);
                } else if (receipt.receipt_type == 3) {
                  $scope.nota_patch.push(receipt);
                }
              });
            }
            if (
              $scope.dataToSave.recibos_poliza &&
              $scope.originCaratula.scheme == response.data.scheme
            ) {
              if (
                $scope.receipts &&
                $scope.receipts.length == response.data.total_receipts
              ) {
                $scope.yaactuaizados = 0;
                $scope.totaldeben = $scope.dataToSave.recibos_poliza.length;
                $scope.totalActualizados = $scope.recibos_patch.length;
                // ----------------------------------------------------------------------------------------------
                // Requiere inyectar $q además de $http
                $scope.recibosFinales = [];
                $scope.yaactuaizados = 0;

                function toDateSafe(v) {
                  return toDate(v);
                } // usa tu toDate real

                // 1) Indexar arrays por recibo_numero
                var nuevos = ($scope.dataToSave.recibos_poliza || []).slice(); // copia
                var actuales = ($scope.recibos_patch || []).slice(); // copia
                console.log("actuales*****+++", actuales);
                var mapNuevos = {};
                nuevos.forEach(function (r) {
                  mapNuevos[r.recibo_numero] = r;
                });

                var mapActuales = {};
                actuales.forEach(function (r) {
                  mapActuales[r.recibo_numero] = r;
                });
                console.log("actuales*****+++", actuales);

                // 2) Calcular qué se actualiza, qué se crea, qué se elimina
                var toUpdate = [];
                var toCreate = [];
                var toDelete = [];

                actuales.forEach(function (oldR) {
                  var nuevoR = mapNuevos[oldR.recibo_numero];
                  if (nuevoR) toUpdate.push({ old: oldR, neu: nuevoR });
                  else toDelete.push(oldR);
                });

                nuevos.forEach(function (nuevoR) {
                  if (!mapActuales[nuevoR.recibo_numero]) toCreate.push(nuevoR);
                });

                // Helpers para armar payloads
                function buildPatchPayload(data) {
                  return {
                    prima_neta: data.prima_neta,
                    rpf: data.rpf,
                    derecho: data.derecho,
                    sub_total: data.sub_total,
                    iva: data.iva,
                    prima_total: data.prima_total,
                    comision: data.comision,
                    fecha_inicio: toDateSafe(data.fecha_inicio),
                    fecha_fin: toDateSafe(data.fecha_fin),
                    vencimiento: toDateSafe(data.vencimiento),
                    status: 4,
                  };
                }

                function buildPostPayload(data) {
                  return {
                    prima_neta: data.prima_neta,
                    poliza: $scope.caratula.url,
                    receipt_type: 1,
                    recibo_numero: data.recibo_numero,
                    rpf: data.rpf,
                    derecho: data.derecho,
                    sub_total: data.sub_total,
                    iva: data.iva,
                    prima_total: data.prima_total,
                    comision: data.comision,
                    fecha_inicio: toDateSafe(data.fecha_inicio),
                    fecha_fin: toDateSafe(data.fecha_fin),
                    vencimiento: toDateSafe(data.vencimiento),
                    status: 4,
                  };
                }
                // 3) Ejecutar: primero PATCH (en paralelo), luego POST (si aplica), luego DELETE
                var patchPromises = toUpdate.map(function (pair) {
                  var payload = buildPatchPayload(pair.neu);
                  console.log("payoad*****+++", payload);
                  return $http
                    .patch(pair.old.url, payload)
                    .then(function (res) {
                      $scope.yaactuaizados++;
                      $scope.recibosFinales.push(res.data);
                      console.log(
                        "recibosFinales*****+++",
                        $scope.recibosFinales
                      );
                      return res.data;
                    });
                });
                $q.all(patchPromises)
                  .then(function () {
                    // Si solo quieres crear cuando cambió forma de pago:
                    if (!$scope.formapagochanged) return [];

                    var postPromises = toCreate.map(function (r) {
                      return $http
                        .post(url.IP + "recibos/", buildPostPayload(r))
                        .then(function (res) {
                          $scope.recibosFinales.push(res.data);
                          return res.data;
                        });
                    });

                    return $q.all(postPromises);
                  })
                  .then(function (createdList) {
                    // agregar los nuevos a recibos_patch al final (ya confirmados)
                    if (createdList && createdList.length) {
                      createdList.forEach(function (r) {
                        $scope.recibos_patch.push(r);
                      });
                    }

                    // DELETE al final para no borrar antes de crear
                    var deletePromises = toDelete.map(function (r) {
                      return $http.delete(r.url);
                    });

                    return $q.all(deletePromises);
                  })
                  .then(function () {
                    // ✅ Estado final consistente: recibosFinales contiene los patch + posts
                    console.log("✅ Sincronización completa");
                    activate(); // si aplica
                  })
                  .catch(function (err) {
                    console.log("❌ Error en sincronización de recibos", err);
                  });

                // ************************************************************************************++*********+
                if (response.data.scheme == 2) {
                  $scope.dataToSave.recibos_poliza.forEach(function (receipt) {
                    if (receipt.receipt_type == 3) {
                      var object = {
                        prima_neta: receipt.prima_neta,
                        rpf: receipt.rpf,
                        derecho: receipt.derecho,
                        sub_total: receipt.sub_total,
                        iva: receipt.iva,
                        prima_total: receipt.prima_total,
                        comision: receipt.comision,
                        fecha_inicio: toDate(receipt.fecha_inicio),
                        fecha_fin: toDate(receipt.fecha_fin),
                        vencimiento: toDate(receipt.vencimiento),
                        status: 4,
                      };
                      $http
                        .patch($scope.nota_patch[0].url, object)
                        .then(function (responseRe) {})
                        .catch(function (e) {
                          console.log("error", e);
                        });
                    }
                  });
                }
                var params = {
                  model: 18,
                  event: "POST",
                  associated_id: $scope.caratula.id,
                  identifier: " actualizó los recibos de la póliza de grupo.",
                };

                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {
                    activate();
                  });
              } else {
                $scope.receipts.forEach(function (receipt) {
                  $http
                    .delete(receipt.url)
                    .then(function (response) {})
                    .catch(function (e) {
                      console.log("error", e);
                    });
                });
                if ($scope.originCaratula.scheme == 1) {
                  var params = {
                    model: 18,
                    event: "DELETE",
                    associated_id: $scope.caratula.id,
                    identifier:
                      " eliminó los recibos de la póliza de grupo por cambio de frecuencia de pago.",
                  };
                } else if ($scope.originCaratula.scheme == 2) {
                  var params = {
                    model: 18,
                    event: "DELETE",
                    associated_id: $scope.caratula.id,
                    identifier:
                      " eliminó los recibos de la póliza de grupo por cambio en el número de escalones en prima mínima.",
                  };
                }

                dataFactory
                  .post("send-log/", params)
                  .then(function success(response) {});

                $scope.dataToSave.recibos_poliza.forEach(function (
                  item,
                  index
                ) {
                  item.poliza = $scope.caratula.url;
                  // parseando recibos

                  item.fecha_fin = toDate(item.fecha_fin);
                  item.fecha_inicio = toDate(item.fecha_inicio);

                  if (item.vencimiento) {
                    var vencimiento = new Date(
                      toDate(item.vencimiento)
                    ).setHours(11.59, 59, 0);
                    item.vencimiento = new Date(vencimiento);
                  }

                  $http
                    .post(url.IP + "recibos/", item)
                    .then(function (data) {
                      if (data.status === 201) {
                      }
                    })
                    .catch(function (error) {
                      console.log("error", error);
                      SweetAlert.swal("Error", "Ócurrio un error.", "error");
                    });

                  if ($scope.dataToSave.recibos_poliza.length == index + 1) {
                    $state.reload();
                  }
                });
              }
            }

            if (
              $scope.dataToSave.recibos_poliza &&
              $scope.originCaratula.scheme != response.data.scheme
            ) {
              $scope.receipts.forEach(function (receipt) {
                $http
                  .delete(receipt.url)
                  .then(function (response) {})
                  .catch(function (e) {
                    console.log("error", e);
                  });
              });
              var params = {
                model: 18,
                event: "DELETE",
                associated_id: $scope.caratula.id,
                identifier:
                  " eliminó los recibos de la póliza de grupo por cambio de esquema de pago.",
              };

              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});

              $scope.dataToSave.recibos_poliza.forEach(function (item, index) {
                item.poliza = $scope.caratula.url;
                item.fecha_fin = toDate(item.fecha_fin);
                item.fecha_inicio = toDate(item.fecha_inicio);
                item.vencimiento = toDate(item.vencimiento);

                $http
                  .post(url.IP + "recibos/", item)
                  .then(function (data) {
                    if (data.status === 201) {
                    }
                  })
                  .catch(function (error) {
                    console.log("error", error);
                    SweetAlert.swal("Error", "Ócurrio un error.", "error");
                  });
              });
            }

            SweetAlert.swal(
              "¡Listo!",
              "La carátula ha sido actualizada existosamente.",
              "success"
            );
            activate();
            $state.go("colectividades.info", { polizaId: $scope.caratula.id });
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.addCategorie = function (index) {
      var categoria = {
        name: "",
        observations: "",
        hospital_level: "",
        document_type: 5,
      };
      $scope.subgrupos.categorias.push(categoria);
    };

    $scope.deleteCategorie = function (index) {
      if ($scope.subgrupos.categorias[index].url) {
        $scope.erase_categorie.push($scope.subgrupos.categorias[index]);
      }
      $scope.subgrupos.categorias.splice(index, 1);
    };

    $scope.$watch(
      "order.contratanteSubgrupo.value",
      function (newValue, oldValue) {
        if (order.contratanteSubgrupo) {
          if (order.contratanteSubgrupo.value.address_contractor) {
            $scope.subgrupos.contractor = order.contratanteSubgrupo;
            $scope.subgrupos.contractor = order.contratanteSubgrupo.value.id;
            $scope.addressSubgroups =
              order.contratanteSubgrupo.value.address_contractor;
            if ($scope.addressSubgroups.length == 1) {
              $scope.subgrupos.addressSelected = $scope.addressSubgroups[0];
              $scope.subgrupos.address = $scope.addressSubgroups[0].id;
            }
          }
        }
      }
    );

    $scope.validitySubgroup = function () {
      if (!$scope.subgrupos.name) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORSUBGROUP, "error");
        return;
      }
      if (
        !$scope.showOt &&
        $scope.caratula.receipts_by == 2 &&
        $scope.subgrupos.recibos_poliza
      ) {
        if (!order.contratanteSubgrupo) {
          SweetAlert.swal(
            "Error",
            "Agrega un contratante al subgrupo.",
            "error"
          );
          return;
        }
        if (!$scope.subgrupos.address) {
          SweetAlert.swal(
            "Error",
            "Agrega una dirección al subgrupo.",
            "error"
          );
          return;
        }
        if (!$scope.dataToSave.recibos_poliza) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
      }
      var flagCoverage = false;
      $scope.subgrupos.categorias.forEach(function (item, index) {
        if (!item.name) {
          flagCoverage = true;
          SweetAlert.swal(
            "Error",
            "Agrega el nombre de la categoría " + (index + 1) + ".",
            "error"
          );
        }
        if ($scope.caratula.subramo.subramo_name == "Gastos Médicos") {
          if (!item.hospital_level) {
            flagCoverage = true;
            SweetAlert.swal(
              "Error",
              "Agrega el nivel hospitalario de la categoría " +
                (index + 1) +
                ".",
              "error"
            );
          }
        }
      });
      if (flagCoverage) {
        return;
      } else {
        if ($scope.erase_categorie.length > 0) {
          SweetAlert.swal(
            {
              title: "Eliminar Categoría",
              text: "Se eliminarán la categorías y todos sus certificados, ¿Estás Seguro?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Si, estoy seguro.",
              cancelButtonText: "Cancelar",
              closeOnConfirm: false,
            },
            function (isConfirm) {
              if (isConfirm) {
                if ($scope.subgrupos.categorias.length >= 1) {
                  $scope.updateSubgroup();
                } else {
                  SweetAlert.swal(
                    "Error",
                    "No se eliminó la categoría porque el subgrupo no puede quedarse sin categorías.",
                    "error"
                  );
                }
              }
            }
          );
        } else {
          if ($scope.create_subgroup) {
            $scope.saveSubgroup();
          } else {
            $scope.updateSubgroup();
          }
        }
      }
    };

    $scope.saveSubgroup = function () {
      if ($scope.dataToSave.recibos_poliza) {
        $scope.dataToSave.recibos_poliza.forEach(function (receipt) {
          receipt.conducto_de_pago = $scope.caratula.conducto_de_pago;
          receipt.fecha_inicio = toDate(receipt.fecha_inicio);
          receipt.fecha_fin = toDate(receipt.fecha_fin);
          receipt.vencimiento = toDate(receipt.vencimiento);
        });
      }

      var data_save_subgroup = {
        address: $scope.subgrupos.address,
        caratula: $scope.caratula.id,
        coverageInPolicy_policy: [],
        document_type: 4,
        contractor: $scope.subgrupos.contractor,
        name: $scope.subgrupos.name,
        observations: $scope.subgrupos.observations,
        parent: $scope.caratula.id,
        p_neta: $scope.dataToSave.poliza.primaNeta
          ? $scope.dataToSave.poliza.primaNeta
          : 0,
        descuento: $scope.dataToSave.poliza.descuento
          ? $scope.dataToSave.poliza.descuento
          : 0,
        rpf: $scope.dataToSave.poliza.rpf ? $scope.dataToSave.poliza.rpf : 0,
        derecho: $scope.dataToSave.poliza.derecho
          ? $scope.dataToSave.poliza.derecho
          : 0,
        sub_total: $scope.dataToSave.poliza.subTotal
          ? $scope.dataToSave.poliza.subTotal
          : 0,
        iva: $scope.dataToSave.poliza.iva ? $scope.dataToSave.poliza.iva : 0,
        p_total: $scope.dataToSave.poliza.primaTotal
          ? $scope.dataToSave.poliza.primaTotal
          : 0,
        comision: $scope.dataToSave.comision ? $scope.dataToSave.comision : 0,
        comision_percent: $scope.dataToSave.comision_percent
          ? $scope.dataToSave.comision_percent
          : 0,
        recibos_poliza: $scope.dataToSave.recibos_poliza
          ? $scope.dataToSave.recibos_poliza
          : [],
        total_receipts: $scope.dataToSave.recibos_poliza
          ? $scope.dataToSave.recibos_poliza.length
          : $scope.caratula.total_receipts,
      };
      $http
        .post(url.IP + "subgrupos/", data_save_subgroup)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.caratula.id,
              identifier: " creó el subgrupo " + response.data.name + ".",
              change: [],
            };
            dataFactory
              .post("send_log_specific/", paramsRec)
              .then(function success(response) {
                SweetAlert.swal(
                  "¡Listo!",
                  "El subgrupo ha sido creado existosamente.",
                  "success"
                );
                $state.go("colectividades.info", {
                  polizaId: $scope.caratula.id,
                });
              });

            $scope.subgrupos.categorias.forEach(function (category) {
              var data_new_category = {
                name: category.name,
                observations: category.observations,
                hospital_level: category.hospital_level,
                document_type: 5,
                parent: response.data.url,
                caratula: $scope.caratula.id,
              };
              $http
                .post(url.IP + "categories/", data_new_category)
                .then(function (requestNC) {
                  if (requestNC.status == 200 || requestNC.status == 201) {
                    var paramsRec = {
                      model: 18,
                      event: "PATCH",
                      associated_id: $scope.caratula.id,
                      identifier:
                        " creó la categoría " +
                        requestNC.data.name +
                        " del subgrupo " +
                        $scope.subgrupos.name +
                        ".",
                      change: [],
                    };
                    dataFactory
                      .post("send_log_specific/", paramsRec)
                      .then(function success(response) {});
                  }
                })
                .catch(function (e) {
                  console.log("error", e);
                });
            });
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.updateSubgroup = function () {
      $scope.changes = [];
      var origin_category = {};
      var data_subgroup = {
        name: $scope.subgrupos.name,
        observations: $scope.subgrupos.observations,
        p_neta: $scope.dataToSave.poliza.primaNeta
          ? $scope.dataToSave.poliza.primaNeta
          : 0,
        descuento: $scope.dataToSave.poliza.descuento
          ? $scope.dataToSave.poliza.descuento
          : 0,
        rpf: $scope.dataToSave.poliza.rpf ? $scope.dataToSave.poliza.rpf : 0,
        derecho: $scope.dataToSave.poliza.derecho
          ? $scope.dataToSave.poliza.derecho
          : 0,
        sub_total: $scope.dataToSave.poliza.subTotal
          ? $scope.dataToSave.poliza.subTotal
          : 0,
        iva: $scope.dataToSave.poliza.iva ? $scope.dataToSave.poliza.iva : 0,
        p_total: $scope.dataToSave.poliza.primaTotal
          ? $scope.dataToSave.poliza.primaTotal
          : 0,
        comision: $scope.dataToSave.comision ? $scope.dataToSave.comision : 0,
        comision_percent: $scope.dataToSave.comision_percent
          ? $scope.dataToSave.comision_percent
          : 0,
        // recibos_poliza: $scope.dataToSave.recibos_poliza ? $scope.dataToSave.recibos_poliza : [],
        total_receipts: $scope.dataToSave.recibos_poliza
          ? $scope.dataToSave.recibos_poliza.length
          : $scope.caratula.total_receipts,
        contractor: order.contratanteSubgrupo.value
          ? order.contratanteSubgrupo.value.url
          : null,
        address: $scope.subgrupos.addressSelected
          ? $scope.subgrupos.addressSelected.url
          : null,
      };

      $http
        .patch($scope.subgrupos.url, data_subgroup)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            if ($scope.originSubgroup.name !== response.data.name) {
              var change_log = {
                name: "Nombre",
                origin: $scope.originSubgroup.name,
                change: response.data.name,
              };
              $scope.changes.push(change_log);
            }
            if (
              $scope.originSubgroup.observations !== response.data.observations
            ) {
              var change_log = {
                name: "Observaciones",
                origin: $scope.originSubgroup.observations,
                change: response.data.observations,
              };
              $scope.changes.push(change_log);
            }
            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.caratula.id,
              identifier: " actualizó el subgrupo " + response.data.name + ".",
              change: $scope.changes,
            };
            if ($scope.changes.length != 0) {
              dataFactory
                .post("send_log_specific/", paramsRec)
                .then(function success(response) {});
            }

            $scope.subgrupos.categorias.forEach(function (category) {
              if (category.url) {
                var datas_category = {
                  name: category.name,
                  hospital_level: category.hospital_level
                    ? category.hospital_level
                    : "",
                  observations: category.observations,
                };
                $http
                  .patch(category.url, datas_category)
                  .then(function (request) {
                    if (request.status == 200 || request.status == 201) {
                      $scope.changesCategories = [];
                      $scope.originSubgroup.categorias.forEach(function (
                        origin_category
                      ) {
                        if (origin_category.id == request.data.id) {
                          if (origin_category.name !== request.data.name) {
                            var change_log = {
                              name: "Nombre",
                              origin: origin_category.name,
                              change: request.data.name,
                            };
                            $scope.changesCategories.push(change_log);
                          }
                          if (
                            origin_category.hospital_level !==
                            request.data.hospital_level
                          ) {
                            var change_log = {
                              name: "Nivel Hospitalario",
                              origin: origin_category.hospital_level,
                              change: request.data.hospital_level,
                            };
                            $scope.changesCategories.push(change_log);
                          }
                          if (
                            origin_category.observations !==
                            request.data.observations
                          ) {
                            var change_log = {
                              name: "Observaciones",
                              origin: origin_category.observations,
                              change: request.data.observations,
                            };
                            $scope.changesCategories.push(change_log);
                          }

                          var paramsRec = {
                            model: 18,
                            event: "PATCH",
                            associated_id: $scope.caratula.id,
                            identifier:
                              " actualizó la categoría " +
                              request.data.name +
                              " del subgrupo " +
                              $scope.subgrupos.name +
                              ".",
                            change: $scope.changesCategories,
                          };
                          if ($scope.changesCategories.length != 0) {
                            dataFactory
                              .post("send_log_specific/", paramsRec)
                              .then(function success(response) {});
                          }
                        }
                      });
                    }
                  })
                  .catch(function (e) {
                    console.log("error", e);
                  });
              } else {
                var data_new_category = {
                  name: category.name,
                  observations: category.observations,
                  hospital_level: category.hospital_level,
                  document_type: 5,
                  parent: $scope.subgrupos.url,
                  caratula: $scope.caratula.id,
                };
                $http
                  .post(url.IP + "categories/", data_new_category)
                  .then(function (requestNC) {
                    if (requestNC.status == 200 || requestNC.status == 201) {
                      var paramsRec = {
                        model: 18,
                        event: "PATCH",
                        associated_id: $scope.caratula.id,
                        identifier:
                          " creó la categoría " +
                          requestNC.data.name +
                          " del subgrupo " +
                          $scope.subgrupos.name +
                          ".",
                        change: [],
                      };
                      dataFactory
                        .post("send_log_specific/", paramsRec)
                        .then(function success(response) {});
                    }
                  })
                  .catch(function (e) {
                    console.log("error", e);
                  });
              }
            });

            if ($scope.erase_categorie.length > 0) {
              $scope.erase_categorie.forEach(function (category_delete, index) {
                var data_category = {
                  status: 0,
                  document_type: 5,
                  name: category_delete.name,
                  caratula: $scope.caratula.id,
                };
                $http
                  .patch(category_delete.url, data_category)
                  .then(function (response) {
                    if (response.status == 200 || response.status == 201) {
                      if (index + 1 == $scope.erase_categorie.length) {
                        SweetAlert.swal(
                          "¡Listo!",
                          "El subgrupo ha sido actualizado existosamente.",
                          "success"
                        );
                        $state.go("colectividades.info", {
                          polizaId: $scope.caratula.id,
                        });
                      }
                    }
                  })
                  .catch(function (e) {
                    console.log("error", e);
                  });
              });
            } else {
              SweetAlert.swal(
                "¡Listo!",
                "El subgrupo ha sido actualizado existosamente.",
                "success"
              );
              $state.go("colectividades.info", {
                polizaId: $scope.caratula.id,
              });
            }

            if (
              $scope.subgrupos.recibos_poliza.length !=
              $scope.dataToSave.recibos_poliza.length
            ) {
              $scope.subgrupos.recibos_poliza.forEach(function (receipt) {
                $http
                  .delete(receipt.url)
                  .then(function (response) {})
                  .catch(function (e) {
                    console.log("error", e);
                  });
              });
              var params = {
                model: 18,
                event: "DELETE",
                associated_id: $scope.caratula.id,
                identifier:
                  " eliminó los recibos del subgrupo por cambio de frecuencia.",
              };

              dataFactory
                .post("send-log/", params)
                .then(function success(response) {});

              $scope.dataToSave.recibos_poliza.forEach(function (item, index) {
                item.poliza = $scope.subgrupos.url;
                item.fecha_fin = toDate(item.fecha_fin);
                item.fecha_inicio = toDate(item.fecha_inicio);
                item.vencimiento = toDate(item.vencimiento);

                $http
                  .post(url.IP + "recibos/", item)
                  .then(function (data) {
                    if (data.status === 201) {
                    }
                  })
                  .catch(function (error) {
                    console.log("error", error);
                    SweetAlert.swal("Error", "Ócurrio un error.", "error");
                  });
              });
            } else {
              if ($scope.dataToSave.recibos_poliza) {
                $scope.subgrupos.recibos_poliza.forEach(function (
                  receipt,
                  index
                ) {
                  if (
                    receipt.recibo_numero ==
                    $scope.dataToSave.recibos_poliza[index].recibo_numero
                  ) {
                    var object = {
                      prima_neta:
                        $scope.dataToSave.recibos_poliza[index].prima_neta,
                      rpf: $scope.dataToSave.recibos_poliza[index].rpf,
                      derecho: $scope.dataToSave.recibos_poliza[index].derecho,
                      sub_total:
                        $scope.dataToSave.recibos_poliza[index].sub_total,
                      iva: $scope.dataToSave.recibos_poliza[index].iva,
                      prima_total:
                        $scope.dataToSave.recibos_poliza[index].prima_total,
                      comision:
                        $scope.dataToSave.recibos_poliza[index].comision,
                      status: 4,
                    };
                    $http
                      .patch(receipt.url, object)
                      .then(function (responseRe) {})
                      .catch(function (e) {
                        console.log("error", e);
                      });
                  }
                });
              }
            }
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.getPackage = function () {
      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: $scope.caratula.ramo.id,
          subramo: $scope.caratula.subramo.id,
          provider: $scope.caratula.aseguradora.id,
        })
        .then(function success(response) {
          if (response.status === 200) {
            $scope.packages = [];
            if (response.data.length) {
              $scope.packages = response.data;
            }
          }
        })
        .catch(function (error) {
          console.log("error", e);
        });
    };

    $scope.changePackage = function (param) {
      if (param) {
        order.defaults = {
          package_name: param.package_name,
          formInfo: { code: $scope.caratula.subramo.subramo_code },
          coverages: [],
          coverageList: [],
        };
        $scope.coveragesPackages = param.coverage_package;
        $scope.personalizePackage = true;
        $scope.packageSelected = param;
        $scope.newCoverages = [];
        param.coverage_package.forEach(function (element) {
          if (element.default) {
            order.defaults.coverages.push(angular.copy(element));
          } else {
            order.defaults.coverageList.push(angular.copy(element));
          }
        });
      } else {
        $scope.coveragesPackages = [];
      }
    };

    $scope.demo = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    $scope.saveSum = function (parValue, parCoverage) {
      $scope.n_exis = 0;
      parCoverage.sums_coverage.forEach(function (item) {
        $scope.exist_flag = false;
        if (item) {
          if (item.sum_insured == parValue) {
            $scope.exist_flag = true;
            $scope.n_exis = $scope.n_exis + 1;
            if ($scope.exist_flag == true) {
              $scope.exist_flag = true;
              $scope.n_exis = $scope.n_exis + 1;
            }
          } else if ($scope.n_exis == 0 || $scope.n_exis == undefined) {
            $scope.exist_flag = false;
          }
          if ($scope.n_exis > 0) {
            $scope.exist_flag = true;
          }
        }
      });
      if (
        !$scope.exist_flag ||
        $scope.n_exis == 0 ||
        $scope.n_exis == undefined
      ) {
        var obj = {
          sum_insured: parValue,
          default: false,
          coverage_sum: parCoverage.url,
        };

        coverageService.createSumInsured(obj).then(function (response) {
          if (response.id) {
            $scope.result_ = false;
            parCoverage.sums_coverage.push(response);
          }
        });
      }
    };

    $scope.saveDed = function (parValue, parCoverage) {
      $scope.n_exis = 0;
      parCoverage.deductible_coverage.forEach(function (item) {
        $scope.exist_flag = false;
        if (item) {
          if (item.deductible == parValue) {
            $scope.exist_flag = true;
            $scope.n_exis = $scope.n_exis + 1;
            if ($scope.exist_flag == true) {
              $scope.exist_flag = true;
              $scope.n_exis = $scope.n_exis + 1;
            }
          } else if ($scope.n_exis == 0 || $scope.n_exis == undefined) {
            $scope.exist_flag = false;
          }
          if ($scope.n_exis > 0) {
            $scope.exist_flag = true;
          }
        }
      });
      if (
        !$scope.exist_flag ||
        $scope.n_exis == 0 ||
        $scope.n_exis == undefined
      ) {
        var obj = {
          deductible: parValue,
          default: false,
          coverage_deductible: parCoverage.url,
        };

        coverageService.createDeducible(obj).then(function (response) {
          $scope.result_ = false;
          parCoverage.deductible_coverage.push(response);
        });
      }
    };

    order.options = {
      deleteCoverage: function (obj, index) {
        order.defaults.coverages.splice(index, 1);
        // if ((order.defaults.coverageList.indexOf(obj) > -1)) {
        order.defaults.coverageList.push(obj);
        // }
      },
      addCoverage: function (obj) {
        if (obj) {
          // if ((order.defaults.coverages.indexOf(obj) > -1)) {
          //   order.defaults.coverages.push(obj);
          // }
          order.defaults.coverages.push(obj);

          order.defaults.coverageList.forEach(function (coverage) {
            if (coverage.coverage_name == obj.coverage_name) {
              order.defaults.coverageList.splice(
                order.defaults.coverageList.indexOf(coverage),
                1
              );
            }
          });
        }
      },
    };

    $scope.showNewPackage = function (param) {
      $scope.newPackage = param;
      $scope.personalizePackage = false;

      if (hasGroupEditDraft() && groupEditDraft.newPackageCoverage) {
        $scope.newPackageCoverage = angular.copy(
          groupEditDraft.newPackageCoverage
        );
      } else {
        $scope.newPackageCoverage = {
          package_name: "",
          description: "",
          coverage_package: [
            {
              coverage_name: "",
              deductible: "",
              sums_coverage: [],
              coinsurance_coverage: [],
            },
          ],
        };
      }
    };

    $scope.addNewPackageCoverage = function () {
      var coverage = {
        coverage_name: "",
        deductible: [],
        sums_coverage: [],
        coinsurance_coverage: [],
      };
      $scope.newPackageCoverage.coverage_package.push(coverage);
    };

    $scope.deleteNewPackageCoverage = function (index) {
      $scope.newPackageCoverage.coverage_package.splice(index, 1);
    };

    $scope.saveNewPackage = function () {
      if (!$scope.caratula.subramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      var data = {
        package_name: $scope.newPackageCoverage.package_name,
        provider: $scope.caratula.aseguradora.id,
        ramo: $scope.caratula.ramo.id,
        subramo: $scope.caratula.subramo.id,
        coverage_package: $scope.newPackageCoverage.coverage_package,
        type_package: 1,
      };
      $http
        .post(url.IP + "packagecreate_new/", data)
        .then(function success(response) {
          if (response.status == 200) {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWPACKAGE, "success");
            $scope.getPackage();
            $scope.showNewPackage(false);
          } else {
            SweetAlert.swal(
              "¡Listo!",
              MESSAGES.OK.ERRORCREATEPACKAGE,
              "success"
            );
          }
        })
        .catch(function (error) {
          console.log("error", e);
        });
    };

    $scope.addCoverageArray = function (param) {
      if (param.selected) {
        $scope.package.coverage_package.push(angular.copy(param));
      } else {
        $scope.package.coverage_package.forEach(function (item, index, object) {
          if (param.id == item.id) {
            object.splice(index, 1);
          }
        });
      }
    };

    $scope.currency = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    $scope.deleteCoverage = function (param) {
      $scope.configCoverages.splice($scope.configCoverages.indexOf(param), 1);
      $scope.coveragesPackages.forEach(function (item) {
        if (item.coverage_name == param.coverage_name) {
          item.selected = false;
        }
      });
    };

    $scope.addPackage = function () {
      $scope.package.package_name = order.defaults.package_name;
      $scope.package.coverage_package = order.defaults.coverages;
      // if(!$scope.package.package_name){
      //   SweetAlert.swal("Error", "Escribe un nombre del paquete.", "error");
      //   return;
      // }
      if ($scope.package.coverage_package.length == 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
        return;
      }
      // if((!$scope.package.coverage_package[0].sumInPolicy || !$scope.package.coverage_package[0].sums_coverage) || (!$scope.package.coverage_package[0].deductibleInPolicy || || !$scope.package.coverage_package[0].deductible_coverage)){
      //   SweetAlert.swal('Error', MESSAGES.ERROR.DEDUCTIBLEREQUIRED, 'error');
      //   return;
      // }
      $http
        .post(url.IP + "paquetes/", $scope.package)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            var coverages_config = [];
            $scope.package.coverage_package.forEach(function (item, index) {
              var covObj = {
                coverage_name: item.coverage_name,
                provider: $scope.caratula.aseguradora.url,
                package: response.data.url,
                deductible_coverage: [],
                sums_coverage: [],
                coinsurance_coverage: [],
                topecoinsurance_coverage: [],
                typeCoverage: 2,
              };

              if (!item.sumInPolicy && item.sums_coverage.length) {
                covObj.sums_coverage.push(item.sums_coverage[0]);
              } else {
                var test = {
                  coverage_sum: item.url,
                  default: true,
                  id: 0,
                  org: "",
                  sum_insured: item.sumInPolicy ? item.sumInPolicy.value : 0,
                  url: "",
                };
                covObj.sums_coverage.push(test);
              }

              if (!item.deductibleInPolicy && item.deductible_coverage.length) {
                covObj.deductible_coverage.push(item.deductible_coverage[0]);
              } else {
                if (item.deductibleInPolicy == undefined) {
                  var test = {
                    coverage_deductible: item.url,
                    default: true,
                    id: 0,
                    org: "",
                    deductible: "",
                    url: "",
                  };
                } else {
                  var test = {
                    coverage_deductible: item.url,
                    default: true,
                    id: 0,
                    org: "",
                    deductible: item.deductibleInPolicy
                      ? item.deductibleInPolicy.value
                      : 0,
                    url: "",
                  };
                }
                covObj.deductible_coverage.push(test);
              }
              if ($scope.caratula.subramo.subramo_name == "Gastos Médicos") {
                if (item.coinsurance_coverage) {
                  if (item.coinsuranceInPolicy == undefined) {
                    var test = {
                      coverage_coinsurance: item.url,
                      default: true,
                      id: 0,
                      org: "",
                      coinsurance: 0,
                      url: "",
                    };
                  } else {
                    var test = {
                      coverage_coinsurance: item.url,
                      default: true,
                      id: 0,
                      org: "",
                      coinsurance: item.coinsuranceInPolicy
                        ? item.coinsuranceInPolicy.value
                        : 0,
                      url: "",
                    };
                  }
                  covObj.coinsurance_coverage.push(test);
                }

                if (item.topecoinsurance_coverage) {
                  if (item.topeCoinsuranceInPolicy == undefined) {
                    var test = {
                      coverage_topecoinsurance: item.url,
                      default: true,
                      id: 0,
                      org: "",
                      topecoinsurance: 0,
                      url: "",
                    };
                  } else {
                    var test = {
                      coverage_topecoinsurance: item.url,
                      default: true,
                      id: 0,
                      org: "",
                      topecoinsurance: item.topeCoinsuranceInPolicy
                        ? item.topeCoinsuranceInPolicy.value
                        : 0,
                      url: "",
                    };
                  }
                  covObj.topecoinsurance_coverage.push(test);
                } else {
                  var test = {
                    coverage_topecoinsurance: item.url,
                    default: true,
                    id: 0,
                    org: "",
                    topecoinsurance: item.topeCoinsuranceInPolicy
                      ? item.topeCoinsuranceInPolicy.value
                      : 0,
                    url: "",
                  };
                  covObj.topecoinsurance_coverage.push(test);
                }
              }

              $http
                .post(url.IP + "coberturas-configuraciones/", covObj)
                .then(createCoverageComplete)
                .catch(createCoverageFailed);

              function createCoverageComplete(response) {}

              function createCoverageFailed(error) {}
            });

            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.caratula.id,
              identifier:
                " creó el paquete " + response.data.package_name + ".",
              change: [],
            };
            dataFactory
              .post("send_log_specific/", paramsRec)
              .then(function success(response) {
                SweetAlert.swal(
                  "¡Listo!",
                  "El paquete ha sido creado existosamente.",
                  "success"
                );
                $state.go("colectividades.info", {
                  polizaId: $scope.caratula.id,
                });
              });
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.updatePackage = function () {
      $scope.changes = [];
      $scope.package.coverage_package = order.defaults.coverages;
      $http
        .patch($scope.package.url, $scope.package)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            if (
              $scope.originPackage.package_name !== response.data.package_name
            ) {
              var change_log = {
                name: "Nombre",
                origin: $scope.originPackage.package_name,
                change: response.data.package_name,
              };
              $scope.changes.push(change_log);
            }

            var paramsRec = {
              model: 18,
              event: "PATCH",
              associated_id: $scope.caratula.id,
              identifier:
                " actualizó el paquete " + response.data.package_name + ".",
              change: $scope.changes,
            };
            if ($scope.changes.length != 0) {
              dataFactory
                .post("send_log_specific/", paramsRec)
                .then(function success(response) {});
            }
            order.defaults.coverages.forEach(function (coverage) {
              var data_coverage = {
                policy: $scope.caratula.id,
                package: $scope.package.url,
                id: $scope.package.id,
                url: coverage.url,
                coverage_name: coverage.coverage_name,
                deductible_coverage: {
                  coverage_deductible: coverage.deductible_coverage[0].url,
                  deducible: coverage.deductibleInPolicy.value,
                  id: coverage.deductible_coverage[0].id,
                },
                sums_coverage: {
                  coverage_sum: coverage.sums_coverage[0].url,
                  sum_insured: coverage.sumInPolicy.value,
                  id: coverage.sums_coverage[0].id,
                },
                coinsurance_coverage: {
                  coverage_coinsurance: coverage.coinsurance_coverage[0]
                    ? coverage.coinsurance_coverage[0].url
                    : "",
                  coinsurance: coverage.coinsuranceInPolicy
                    ? coverage.coinsuranceInPolicy.value
                    : "",
                  id: coverage.coinsurance_coverage[0]
                    ? coverage.coinsurance_coverage[0].id
                    : "",
                },
                topecoinsurance_coverage: {
                  coverage_topecoinsurance: coverage.topecoinsurance_coverage[0]
                    ? coverage.topecoinsurance_coverage[0].url
                    : "",
                  topecoinsurance: coverage.topeCoinsuranceInPolicy
                    ? coverage.topeCoinsuranceInPolicy.value
                    : "",
                  id: coverage.topecoinsurance_coverage[0]
                    ? coverage.topecoinsurance_coverage[0].id
                    : "",
                },
              };
              $http
                .post(url.IP + "patch-package-coverage/", data_coverage)
                .then(function (responseC) {
                  if (responseC.status == 200 || responseC.status == 201) {
                    $scope.originPackage.coverage_package.forEach(function (
                      origin_coverage
                    ) {
                      $scope.changesCoverages = [];
                      if (
                        responseC.data.data.suma.coverage_sum ==
                          origin_coverage.url ||
                        responseC.data.data.deductible.coverage_deductible ==
                          origin_coverage.url
                      ) {
                        if (
                          origin_coverage.sums_coverage[0].sum_insured !==
                          responseC.data.data.suma.sum_insured
                        ) {
                          var change_log = {
                            name: "Suma Asegurada",
                            origin:
                              origin_coverage.sums_coverage[0].sum_insured,
                            change: responseC.data.data.suma.sum_insured,
                          };
                          $scope.changesCoverages.push(change_log);
                        }
                        if (
                          origin_coverage.deductible_coverage[0].deductible !==
                          responseC.data.data.deductible.deductible
                        ) {
                          var change_log = {
                            name: "Deducible",
                            origin:
                              origin_coverage.deductible_coverage[0].deductible,
                            change: responseC.data.data.deductible.deductible,
                          };
                          $scope.changesCoverages.push(change_log);
                        }
                        if (
                          $scope.caratula.subramo.subramo_name ==
                          "Gastos Médicos"
                        ) {
                          try {
                            if (
                              origin_coverage.coinsurance_coverage[0]
                                .coinsurance !==
                              responseC.data.data.coinsurance.coinsurance
                            ) {
                              var change_log = {
                                name: "Coaseguro",
                                origin:
                                  origin_coverage.coinsurance_coverage[0]
                                    .coinsurance,
                                change:
                                  responseC.data.data.coinsurance.coinsurance,
                              };
                              $scope.changesCoverages.push(change_log);
                            }
                            if (
                              origin_coverage.topecoinsurance_coverage[0]
                                .topecoinsurance !==
                              responseC.data.data.topeCoinsurance
                                .topecoinsurance
                            ) {
                              var change_log = {
                                name: "Tope Coaseguro",
                                origin:
                                  origin_coverage.topecoinsurance_coverage[0]
                                    .topecoinsurance,
                                change:
                                  responseC.data.data.topeCoinsurance
                                    .topecoinsurance,
                              };
                              $scope.changesCoverages.push(change_log);
                            }
                          } catch (e) {
                            console.log("rorrr", e);
                          }
                        }
                        var paramsRec = {
                          model: 18,
                          event: "PATCH",
                          associated_id: $scope.caratula.id,
                          identifier:
                            " actualizó la covertura " +
                            coverage.coverage_name +
                            " del paquete " +
                            response.data.package_name +
                            ".",
                          change: $scope.changesCoverages,
                        };
                        if ($scope.changesCoverages.length != 0) {
                          dataFactory
                            .post("send_log_specific/", paramsRec)
                            .then(function success(response) {});
                        }
                      }
                    });
                  }
                })
                .catch(function (e) {
                  console.log("error", e);
                });
            });
            SweetAlert.swal(
              "¡Listo!",
              "El paquete ha sido actualizado existosamente.",
              "success"
            );
            $state.go("colectividades.info", { polizaId: $scope.caratula.id });
          }
        })
        .catch(function (e) {
          console.log("2", e);
        });
    };
    $scope.addPackageCoverage = function (param) {
      if (param) {
        var coverage = {
          coverage_name: "",
          sums_coverage: [],
          deductible: [],
          coinsurance_coverage: [],
          topecoinsurance_coverage: [],
        };
        $scope.newCoverages.push(coverage);
      } else {
        $scope.newCoverages = [];
      }
    };

    $scope.deletePackageCoverage = function (index) {
      $scope.newCoverages.splice(index, 1);
    };

    $scope.saveCoverage = function (param) {
      $scope.newCoverages.forEach(function (coverage, index) {
        if (coverage.coverage_name) {
          var covObj = {
            coverage_name: coverage.coverage_name,
            provider: $scope.caratula.aseguradora.url,
            package: param.url,
            sums_coverage: [],
            deductible_coverage: [],
            coinsurance_coverage: [],
            topecoinsurance_coverage: [],
            typeCoverage: 2,
          };

          var test = {
            coverage_sum: coverage.url,
            default: true,
            id: 0,
            org: "",
            sum_insured: coverage.sums_coverage ? coverage.sums_coverage : 0,
            url: "",
          };
          covObj.sums_coverage.push(test);

          var test = {
            coverage_deductible: coverage.url,
            default: true,
            id: 0,
            org: "",
            deductible: coverage.deductible_coverage
              ? coverage.deductible_coverage
              : 0,
            url: "",
          };
          covObj.deductible_coverage.push(test);

          $http
            .post(url.IP + "coberturas-configuraciones/", covObj)
            .then(createCoverageComplete)
            .catch(createCoverageFailed);

          function createCoverageComplete(response) {
            if (response.status == 200 || response.status == 201) {
              order.defaults.coverages.push(covObj);
              if (index + 1 == $scope.newCoverages.length) {
                $scope.addPackageCoverage(false);
              }
            }
          }

          function createCoverageFailed(error) {}
        }
      });
    };
  }
})();

/* global angular */
(function () {
  "use strict";

  angular.module("inspinia").controller("ColectivosCtrl", ColectivosCtrl);

  ColectivosCtrl.$inject = [
    "$scope",
    "$http",
    "url",
    "$stateParams",
    "$sessionStorage",
    "MESSAGES",
    "SweetAlert",
    "$state",
    "providerService",
    "helpers",
    "dataFactory",
    "FileUploader",
    "formatValues",
    "$rootScope",
    "$localStorage",
    "$uibModalInstance",
    "$timeout",
    "coverageService",
    "ContratanteService",
    "$location",
  ];

  function ColectivosCtrl(
    $scope,
    $http,
    url,
    $stateParams,
    $sessionStorage,
    MESSAGES,
    SweetAlert,
    $state,
    providerService,
    helpers,
    dataFactory,
    FileUploader,
    formatValues,
    $rootScope,
    $localStorage,
    $uibModalInstance,
    $timeout,
    coverageService,
    ContratanteService,
    $location
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    $scope.infoUser = $sessionStorage.infoUser;

    var vm = this;
    var order = this;
    var groupDraft = {};

    function resetGroupDraft() {
      groupDraft = {};
    }

    function hasGroupDraft() {
      return groupDraft && Object.keys(groupDraft).length > 0;
    }

    $rootScope.disabled = false;

    $scope.showOt = true;
    $scope.showRenewal = false;
    $scope.saving = false;
    $scope.caratula = {};
    $rootScope.show_contractor = false;
    $scope.create_natural = true;
    $scope.create_juridical = true;
    $scope.claves = [];
    $scope.renewals = [
      { value: 1, label: "Renovable" },
      { value: 2, label: "No Renovable" },
    ];
    $scope.renewalSelected = $scope.renewals[0];
    $scope.administrationTypes = [
      { value: 1, label: "Simplificada" },
      { value: 2, label: "Autoadministrada" },
      { value: 3, label: "Detallada" },
    ];
    $scope.currencys = [
      { value: 1, label: "Pesos" },
      { value: 2, label: "Dólares" },
      { value: 3, label: "UDI" },
      { value: 4, label: "Euros" },
    ];
    $scope.currencySelected = $scope.currencys[0].value;

    $scope.conductos_de_pago = [
      { value: 1, label: "No domiciliada" },
      { value: 2, label: "Agente" },
      { value: 3, label: "CAC" },
      { value: 4, label: "CAT/Domiciliado" },
      { value: 5, label: "Nómina" },
      { value: 6, label: "CUT" },
    ];

    $scope.conductoSelected = $scope.conductos_de_pago[0].value;
    $scope.referenciadores = [];
    $scope.referenciadorArray = [];
    $scope.referenciadoresSelected = [];
    $scope.caratula.scheme = 1;
    $scope.caratula.receipts_by = 1;
    $scope.btnTraditionalStyle = {
      color: "#ffffff",
      "background-color": "#1cb394",
    };
    $scope.btnMinimalStyle = {
      color: "#707877",
      "background-color": "#ffffff",
      "border-top": "1px solid #1cb394",
      "border-right": "1px solid #1cb394",
      "border-bottom": "1px solid #1cb394",
    };
    $scope.frequencies = [
      { value: 7, label: "Semanal" },
      { value: 14, label: "Catorcenal" },
      // {'value':24, 'label':'Quincenal'},
      { value: 1, label: "Mensual" },
      { value: 2, label: "Bimestral" },
      { value: 3, label: "Trimestral" },
      { value: 6, label: "Semestral" },
      { value: 12, label: "Anual" },
      { value: 5, label: "Contado" },
    ];
    $scope.btnPolicyStyle = {
      color: "#ffffff",
      "background-color": "#1c84c4",
    };
    $scope.btnSudgroupStyle = {
      color: "#707877",
      "background-color": "#ffffff",
      "border-top": "1px solid #1c84c4",
      "border-right": "1px solid #1c84c4",
      "border-bottom": "1px solid #1c84c4",
    };
    $scope.btnCertificateStyle = {
      color: "#707877",
      "background-color": "#ffffff",
      "border-top": "1px solid #1c84c4",
      "border-right": "1px solid #1c84c4",
      "border-bottom": "1px solid #1c84c4",
      "border-left": "1px solid #1c84c4",
    };
    $scope.directiveReceipts = [];
    $scope.dataToSave = [];
    $scope.addSubgrupos = false;
    $scope.subgroupsInfo = [];
    $scope.addressSubgroups = [];
    $scope.subgroups = [];
    $scope.packageSelected = {};
    $scope.package = {
      package_name: "",
      coverage_package: [],
      type_package: 2,
    };
    $scope.newPackage = false;
    $scope.newCoverages = [];
    $scope.personalizePackage = false;
    $scope.configCoverages = [];
    $scope.paquetes = [];
    $scope.dataCaratula = [];
    $scope.showTableCertificates = false;
    $scope.excelJson = [];
    $scope.beneficiaries_life = [];
    $scope.beneficiaries_medical = [];
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certifcados = [];
    $scope.businessline = [
      { id: 1, name: "Comercial" },
      { id: 2, name: "Personal" },
      { id: 0, name: "Otro" },
    ];
    $scope.business_lineSelected = 0;
    $scope.celulas = [];
    $scope.agrupaciones = [];
    $scope.sub_asignaciones = [];
    $scope.sub_subasignaciones = [];

    $scope.campo_agrupacion = false;
    $scope.campo_celula = false;
    $scope.campo_lineanegocio = false;
    $scope.moduleName = "Célula";
    dataFactory.get("orginfo/").then(function success(response) {
      if (response.data.results.length) {
        $scope.configuracionGlobal = response.data.results[0];
        $scope.campo_agrupacion = $scope.configuracionGlobal.filtros_agrupacion;
        $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
        $scope.campo_lineanegocio =
          $scope.configuracionGlobal.filtros_lineanegocio;
        if ($scope.configuracionGlobal.moduleName) {
          $scope.moduleName = $scope.configuracionGlobal.moduleName;
        }
      }
    });
    order.accesos = $sessionStorage.permisos;
    if (order.accesos) {
      order.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          order.acceso_polizas = perm;
          order.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                order.acceso_adm_pol = true;
              } else {
                order.acceso_adm_pol = false;
              }
            }
            if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                order.acceso_ver_pol = true;
              } else {
                order.acceso_ver_pol = false;
              }
            }
            if (acc.permission_name == "Comisión no obligatoria") {
              if (acc.checked == true) {
                order.acceso_cno_pol = true;
              } else {
                order.acceso_cno_pol = false;
              }
            }
          });
        }
        if (perm.model_name == "Formatos") {
          order.acceso_form = perm;
          order.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                order.acceso_form = true;
              } else {
                order.acceso_form = false;
              }
            }
          });
        }
        if (perm.model_name == "Ordenes de trabajo") {
          order.acceso_ot = perm;
          order.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                order.acceso_adm_ot = true;
              } else {
                order.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                order.acceso_ver_ot = true;
              } else {
                order.acceso_ver_ot = false;
              }
            }
          });
        }
        if (perm.model_name == "Contratantes y grupos") {
          order.acceso_contg = perm;
          order.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_adm_cont = true;
              } else {
                order.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                order.acceso_ver_cont = true;
              } else {
                order.acceso_ver_cont = false;
              }
            }
          });
        }
        if (perm.model_name == "Comisiones") {
          order.coms = perm;
          order.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                order.permiso_comisiones = true;
              } else {
                order.permiso_comisiones = false;
              }
            }
          });
        }
        if (perm.model_name == "Archivos") {
          order.acceso_files = perm;
          order.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                order.permiso_archivos = true;
              } else {
                order.permiso_archivos = false;
              }
            } // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                order.permiso_administrar_adjuntos = true;
              } else {
                order.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
        if (perm.model_name == "Referenciadores") {
          order.acceso_refereciador = perm;
          order.acceso_refereciador.permissions.forEach(function (acc) {
            if (acc.permission_name == "Referenciador no obligatorio") {
              if (acc.checked == true) {
                order.acc_referenciador_obligatorio = true;
              } else {
                order.acc_referenciador_obligatorio = false;
              }
            }
          });
        }
      });
    }
    $scope.acceso_ver_ref = true;
    $scope.checkDate = function (param) {
      if (param.length == 10) {
        var x = mesDiaAnio(param);
        param = convertDate(x);
      }
    };
    activate();
    resetGroupDraft();
    function activate() {
      resetGroupDraft();
      $http
        .post(url.IP + "get-data-promotoria-initial/")
        .then(
          function success(response) {
            if (response.data.results.length > 0) {
              $scope.principal = response.data.original;
              $scope.principal.contenedores =
                response.data.original.data_details;
              $scope.principal.url = response.data.original.url;
              $scope.principal.id = response.data.original.id;
            }
          },
          function error(e) {
            console.log("Error - promotorias--", e);
          }
        )
        .catch(function (error) {
          $scope.principal.contenedores = [];
          console.log("Error - promotablero - catch", error);
        });
      $scope.directiveReceipts.canCreate = false;
      var url_path = $location.path();
      if (url_path.indexOf("editar") > -1) {
        $scope.directiveReceipts.is_edit = true;
      } else {
        $scope.directiveReceipts.is_edit = false;
      }
      getInternalNumber();
      $scope.startDate = convertDate(new Date());
      fillProvider();

      $http.get(url.IP + "usuarios/").then(function (user) {
        user.data.results.forEach(function (vnd) {
          vnd.first_name = vnd.first_name.toUpperCase();
          vnd.last_name = vnd.last_name.toUpperCase();
          vnd.name =
            vnd.first_name.toUpperCase() + " " + vnd.last_name.toUpperCase();
        });
        $scope.users = user.data.results;
        $scope.ejecutivos = user.data.results;
        $scope.startDate = convertDate(new Date());
        $scope.checkDate($scope.startDate);
      });

      dataFactory
        .get("sucursales-to-show-unpag/")
        .then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            $scope.sucursales = response.data;
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });

      // dataFactory.get('celula_contractor/')
      dataFactory.post("celula_contractor_info/").then(function (response) {
        $scope.celulas = response.data;
        if (groupDraft["celula"]) {
          $scope.celulas.forEach(function (item) {
            if (item.id == groupDraft["celula"]["id"]) {
              $scope.celulaSelected = item;
              $scope.caratula.celula = item.id;
            }
          });
        }
      });

      dataFactory.get("groupingLevel-resume/").then(function (response) {
        $scope.agrupaciones = response.data;
        if (groupDraft["agrupacion"]) {
          $scope.agrupaciones.forEach(function (item) {
            if (item.id == groupDraft["agrupacion"]["id"]) {
              $scope.grouping_levelSelected = item;
              $scope.sub_asignaciones = item.subgrupos;
              if (groupDraft["subagrupacion"]) {
                $scope.sub_asignaciones.forEach(function (item2) {
                  if (item2.id == groupDraft["subagrupacion"]["id"]) {
                    $scope.subgroupingSelected = item2;
                    $scope.sub_subasignaciones = item2.subsubgrupos;
                    if (groupDraft["subsubagrupacion"]) {
                      $scope.sub_subasignaciones.forEach(function (item3) {
                        if (item3.id == groupDraft["subsubagrupacion"]["id"]) {
                          $scope.subsubgroupingSelected = item3;
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
      });

      $http
        .get(url.IP + "get-vendors/")
        .then(function (user) {
          user.data.forEach(function (vnd) {
            vnd.first_name = vnd.first_name.toUpperCase();
            vnd.last_name = vnd.last_name.toUpperCase();
            vnd.name =
              vnd.first_name.toUpperCase() + " " + vnd.last_name.toUpperCase();
          });
          $scope.referenciadores = user.data;
          var vendedor = {
            referenciador: "",
            comision_vendedor: "",
          };
          $scope.referenciadorArray.push(vendedor);
          if (
            $localStorage.orderFormCotizacion &&
            $localStorage.orderFormCotizacion.referenciador
          ) {
            $scope.referenciadores.forEach(function (user) {
              if (
                user.url === $localStorage.orderFormCotizacion.referenciador &&
                !$scope.referenciadorArray.some(function (ref) {
                  return ref.referenciador === user.url;
                })
              ) {
                $scope.referenciadorArray.push({ referenciador: user.id });
              }
            });
          }

          if ($localStorage.orderFormCotizacion) {
            $scope.showOt = false;
            $scope.activeJustified = 1; // Abre el tab de índice 1 (Póliza)
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });

      var myInsurance = $stateParams.myInsurance;
      if (myInsurance.url) {
        var contrac = {};
        contrac.contratanteId = myInsurance.id;
        if (myInsurance.type_person == "Fisica") {
          contrac.type = "fisicas";
        }
        if (myInsurance.type_person == "Moral") {
          contrac.type = "morales";
        }
        ContratanteService.getContratanteFull(contrac).then(function (
          contractor
        ) {
          order.contratante = {};
          $scope.order.contratante = {};
          if (contractor.cellule) {
            // $http.get(contractor.cellule)
            $http
              .get(
                contractor.cellule.url
                  ? contractor.cellule.url
                  : contractor.cellule
              )
              .then(function success(respo) {
                $scope.celulaSelected = respo.data;
              });
          }
          $scope.info_sub = contractor;
          if (contractor.groupinglevel) {
            // $http.get(contractor.groupinglevel)
            $http
              .get(
                contractor.groupinglevel.url
                  ? contractor.groupinglevel.url
                  : contractor.groupinglevel
              )
              .then(function success(respons) {
                if (respons.data.type_grouping == 3) {
                  $scope.info_sub.subsubgrouping = respons.data.description;
                  $http.get(respons.data.parent).then(function success(respon) {
                    $scope.info_sub.subgrouping = respon.data.description;
                    $http.get(respon.data.parent).then(function success(respo) {
                      $scope.grouping_levelSelected = respo.data;
                      $scope.changeAgrupacion(respo.data);
                    });
                    $scope.subsubgroupingSelected == respon.data;
                  });
                  order.form.subsubgrouping == respons.data;
                } else if (respons.data.type_grouping == 2) {
                  $scope.info_sub.subgrouping = respons.data.description;
                  $http.get(respons.data.parent).then(function success(respon) {
                    $scope.grouping_levelSelected = respon.data;
                    $scope.changeAgrupacion(respon.data);
                  });
                  $scope.subgroupingSelected == respons.data;
                } else if (respons.data.type_grouping == 1) {
                  $scope.grouping_levelSelected = respons.data;
                  $scope.changeAgrupacion(respons.data);
                }
              });
          }

          if (contractor) {
            if ($scope.referenciadores) {
              $scope.referenciadores.some(function (user) {
                if (user.url == contractor.vendor) {
                  $scope.referenciadorArray[0] = {
                    referenciador: user.id,
                    comision_vendedor: "",
                  };
                }
              });
            }
            if (contractor.address_contractor) {
              if (contractor.address_contractor) {
                $scope.caratula.contractor = contractor.id;
                $scope.addresses = contractor.address_contractor;
              }
              if ($scope.addresses.length == 1) {
                $scope.addressSelected = $scope.addresses[0];
                $scope.caratula.address = $scope.addresses[0].id;
              }
            }
          }

          if (contractor.first_name) {
            order.contratante.val =
              contractor.first_name +
              " " +
              contractor.last_name +
              " " +
              contractor.second_last_name;
            order.contratante.label =
              contractor.first_name +
              " " +
              contractor.last_name +
              " " +
              contractor.second_last_name;
          }
          if (contractor.full_name) {
            order.contratante.val = contractor.full_name;
            order.contratante.label = contractor.full_name;
          }
          if (contractor.address_contractor) {
            $scope.addresses = contractor.address_contractor;
          }
          $scope.addressSelected = $scope.addresses[0];
          order.contratante.value = contractor;
          order.contratante.value.email = contractor.email;
          $scope.order.contratante = order.contratante;
        });
      }
      if ($localStorage.orderFormCotizacion) {
        var cotizacion = $localStorage.orderFormCotizacion;
        $scope.cotizacion_formulario = $localStorage.orderFormCotizacion;
        if (cotizacion.prospecto == 2) {
          var cotizacion_contratante = cotizacion.contractor;

          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: cotizacion_contratante,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data.contractors) {
                var source = [];
                var contratactorsFound = response.data.contractors;

                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    if (
                      obj.label.toLowerCase() ==
                      cotizacion_contratante.toLowerCase()
                    ) {
                      order.contratante = obj;
                      order.contratante.value.email = obj.value.email;
                      $scope.order.contratante = order.contratante;
                    }
                    source.push(obj);
                  });
                }

                $scope.contractors_data = source;
              }
            });
        }
      }
      $scope.caratula.observations = hasGroupDraft()
        ? groupDraft["observations"]
        : "";
      $scope.caratula.identifier = hasGroupDraft()
        ? groupDraft["identifier"]
        : "";
      $scope.caratula.internal_number = hasGroupDraft()
        ? groupDraft["internal_number"]
        : "";
      $scope.caratula.folio = hasGroupDraft() ? groupDraft["folio"] : "";
      $scope.caratula.poliza_number = hasGroupDraft()
        ? groupDraft["poliza_number"]
        : "";
      order.contratante = hasGroupDraft() ? groupDraft["contratante"] : "";
      $scope.addressSelected = hasGroupDraft() ? groupDraft["address"] : "";
      $scope.aseguradoraSelected = hasGroupDraft()
        ? groupDraft["aseguradora"]
        : "";
      $scope.startDate = hasGroupDraft()
        ? groupDraft["startDate"]
        : convertDate(new Date());

      // $scope.paquetes = hasGroupDraft() && groupDraft['paquetes'] ? groupDraft['paquetes'] : true;

      if (hasGroupDraft() && groupDraft["referenciadores"]) {
        $scope.referenciadorArray = groupDraft["referenciadores"];
        $scope.referenciadoresSelected = $scope.referenciadorArray;
      }
      if (hasGroupDraft()) {
        if (groupDraft.idPoliza && groupDraft.idPoliza.id) {
          SweetAlert.swal(
            "¡Listo!",
            "La colectividad ha sido creada con anterioridad. El formulario se ha borrado",
            "success"
          );
          $scope.showCar = false;
          $scope.showSub = false;
          $scope.showPac = false;
          $scope.dataCaratula = groupDraft.idPoliza;
        }
      }
      $scope.referenciadorArray = $scope.referenciadorArray.filter(function (
        item
      ) {
        if (item.referenciador) {
          return true;
        }
        return false;
      });
      if ($scope.aseguradoraSelected) {
        $http
          .get(url.IP + "claves-by-provider/" + $scope.aseguradoraSelected.id)
          .then(function success(clavesResponse) {
            $scope.claves = clavesResponse.data;
            if ($scope.claves.length == 1) {
              $scope.caratula.clave = $scope.claves[0].id;
              $scope.claveSelected = $scope.claves[0];
            }
          })
          .catch(function (error) {
            console.log("Error - claves-by-provider - catch", error);
          });

        $http
          .get(url.IP + "ramos-by-provider/" + $scope.aseguradoraSelected.id)
          .then(
            function success(response) {
              $scope.ramos = response.data;
            },
            function error(e) {
              console.log("Error - ramos-by-provider", e);
            }
          )
          .catch(function (error) {
            console.log("Error - ramos-by-provider - catch", error);
          });
      }
      $scope.caratula.clave =
        hasGroupDraft() && groupDraft["clave"] ? groupDraft["clave"]["id"] : "";
      $scope.caratula.aseguradora =
        hasGroupDraft() && groupDraft["aseguradora"]
          ? groupDraft["aseguradora"]["id"]
          : "";
      $scope.caratula.ramo =
        hasGroupDraft() && groupDraft["ramo"] ? groupDraft["ramo"]["id"] : "";
      $scope.caratula.subramo =
        hasGroupDraft() && groupDraft["subramo"]
          ? groupDraft["subramo"]["id"]
          : "";
      $scope.claveSelected = hasGroupDraft() ? groupDraft["clave"] : "";
      $scope.ramoSelected = hasGroupDraft() ? groupDraft["ramo"] : "";
      if ($scope.ramoSelected) {
        $scope.subramos = $scope.ramoSelected.subramo_ramo;
      }
      $scope.caratula.ramo = $scope.ramoSelected;
      $scope.caratula.subramo = $scope.subramoSelected;
      $scope.caratula.aseguradora = $scope.aseguradoraSelected;

      $scope.subramoSelected = hasGroupDraft()
        ? groupDraft["subramo"]
        : $scope.subramoSelected
        ? $scope.subramoSelected
        : "";

      if ($scope.claveSelected && $scope.subramoSelected) {
        changeSubramoS($scope.subramoSelected);
      }
      if (hasGroupDraft()) {
        if (groupDraft["is_renewable"]) {
          $scope.renewals.forEach(function (item) {
            if (item.value == groupDraft["is_renewable"]["value"]) {
              $scope.renewalSelected = item;
            }
          });
        }
        if (groupDraft["administration_type"]) {
          $scope.administrationTypes.forEach(function (item) {
            if (item.value == groupDraft["administration_type"]) {
              $scope.administrationSelected = item;
              $scope.caratula.administration_type = item.value;
            }
          });
        }
        $scope.currencySelected =
          hasGroupDraft() && groupDraft["f_currency"]
            ? groupDraft["f_currency"]
            : 1;
        $scope.responsableSelected = hasGroupDraft()
          ? groupDraft["responsable"]
          : "";
        $scope.executiveSelected = hasGroupDraft()
          ? groupDraft["collection_executive"]
          : "";
        $scope.caratula.responsable = $scope.responsableSelected;
        $scope.caratula.collection_executive = $scope.executiveSelected;
        if (groupDraft["conducto_de_pago"]) {
          $scope.conductos_de_pago.forEach(function (item) {
            if (item.value == groupDraft["conducto_de_pago"]) {
              $scope.conductoSelected = item.value;
              $scope.caratula.conducto_de_pago = item.value;
            }
          });
        }
        if (groupDraft["business_line"]) {
          $scope.businessline.forEach(function (item) {
            if (item.id == groupDraft["business_line"]["id"]) {
              $scope.business_lineSelected = item;
            }
          });
        }
        $scope.sucursalSelected = hasGroupDraft() ? groupDraft["sucursal"] : "";
        $scope.caratula.sucursal = $scope.sucursalSelected;
        if (groupDraft["scheme"]) {
          if (parseInt(groupDraft["scheme"]) == 1) {
            $scope.btnTraditionalStyle = {
              color: "#ffffff",
              "background-color": "#1cb394",
            };
            $scope.btnMinimalStyle = {
              color: "#707877",
              "background-color": "#ffffff",
              "border-top": "1px solid #1cb394",
              "border-right": "1px solid #1cb394",
              "border-bottom": "1px solid #1cb394",
            };
          } else {
            $scope.paymentSelected = 5;
            // $scope.chancePayment(5);
            $scope.caratula.receipts_by = 1;
            $scope.btnTraditionalStyle = {
              color: "#707877",
              "background-color": "#ffffff",
              "border-top": "1px solid #1cb394",
              "border-bottom": "1px solid #1cb394",
              "border-left": "1px solid #1cb394",
            };
            $scope.btnMinimalStyle = {
              color: "#ffffff",
              "background-color": "#1cb394",
            };
            SweetAlert.swal(
              "Prima Mínima",
              "El esquema de pago de prima mínima solo permite recibos a nivel póliza.",
              "info"
            );
          }
        }
        $scope.paymentSelected = hasGroupDraft() ? groupDraft["payment"] : {};
        $scope.caratula.forma_de_pago = $scope.paymentSelected
          ? $scope.paymentSelected
          : "";
        $scope.directiveReceipts.payment = $scope.paymentSelected;
        if (groupDraft["receipts_by"]) {
          $scope.caratula.receipts_by = groupDraft["receipts_by"];
          if (groupDraft["receipts_by"] == 1) {
            $scope.btnPolicyStyle = {
              color: "#ffffff",
              "background-color": "#1c84c4",
            };
            $scope.btnSudgroupStyle = {
              color: "#707877",
              "background-color": "#ffffff",
              "border-top": "1px solid #1c84c4",
              "border-right": "1px solid #1c84c4",
              "border-bottom": "1px solid #1c84c4",
            };
            $scope.btnCertificateStyle = {
              color: "#707877",
              "background-color": "#ffffff",
              "border-top": "1px solid #1c84c4",
              "border-right": "1px solid #1c84c4",
              "border-bottom": "1px solid #1c84c4",
              "border-left": "1px solid #1c84c4",
            };
          } else if (groupDraft["receipts_by"] == 2) {
            $scope.btnPolicyStyle = {
              color: "#707877",
              "background-color": "#ffffff",
              "border-top": "1px solid #1c84c4",
              "border-left": "1px solid #1c84c4",
              "border-bottom": "1px solid #1c84c4",
            };
            $scope.btnSudgroupStyle = {
              color: "#ffffff",
              "background-color": "#1c84c4",
            };
            $scope.btnCertificateStyle = {
              color: "#707877",
              "background-color": "#ffffff",
              "border-top": "1px solid #1c84c4",
              "border-right": "1px solid #1c84c4",
              "border-bottom": "1px solid #1c84c4",
              "border-left": "1px solid #1c84c4",
            };
            SweetAlert.swal(
              "Recibos por subgrupo",
              "Deberas crear en los recibos en los subgrupos.",
              "info"
            );
          } else {
            $scope.btnPolicyStyle = {
              color: "#707877",
              "background-color": "#ffffff",
              "border-top": "1px solid #1c84c4",
              "border-right": "1px solid #1c84c4",
              "border-bottom": "1px solid #1c84c4",
              "border-left": "1px solid #1c84c4",
            };
            $scope.btnSudgroupStyle = {
              color: "#707877",
              "background-color": "#ffffff",
              "border-top": "1px solid #1c84c4",
              "border-bottom": "1px solid #1c84c4",
              "border-left": "1px solid #1c84c4",
            };
            $scope.btnCertificateStyle = {
              color: "#ffffff",
              "background-color": "#1c84c4",
            };
            SweetAlert.swal(
              "Recibos por certificados",
              "Deberas crear en los recibos en los certificados.",
              "info"
            );
          }
        }
        $scope.subgroupsInfo = hasGroupDraft() ? groupDraft["subgrupos"] : [];
        $scope.subgroups = $scope.subgroupsInfo ? $scope.subgroupsInfo : [];
        if (groupDraft["paquetes"]) {
          $scope.paquetes = hasGroupDraft() ? groupDraft["paquetes"] : [];
        } else {
          $scope.paquetes = [];
        }

        if ($scope.paquetes && $scope.paquetes.length) {
          $scope.caratula.ramo = $scope.ramoSelected;
          $scope.caratula.subramo = $scope.subramoSelected;
          $scope.caratula.aseguradora = $scope.aseguradoraSelected;
          var payload = {
            ramo: $scope.ramoSelected ? $scope.ramoSelected.id : 0,
            subramo: $scope.subramoSelected ? $scope.subramoSelected.id : 0,
            provider: $scope.aseguradoraSelected
              ? $scope.aseguradoraSelected.id
              : 0,
          };
          $http
            .post(url.IP + "paquetes-data-by-subramo/", payload)
            .then(function success(response) {
              if (response.status === 200) {
                $scope.packages = [];
                if (response.data.length) {
                  $scope.packages = response.data;
                }
              }
            })
            .catch(function (error) {
              console.log("error", e);
            });
        }
      }
    }

    if ($localStorage.orderFormCotizacion) {
      try {
        var dataOrderForm = JSON.parse($localStorage.orderFormCotizacion);
        var startDate = convertDate(
          new Date(mesDiaAnio(dataOrderForm.startDate))
        );
        var endingDate = convertDate(
          new Date(mesDiaAnio(dataOrderForm.endingDate))
        );
        $scope.dataToSave.start_of_validity = new Date(mesDiaAnio(startDate));
        $scope.dataToSave.end_of_validity = new Date(mesDiaAnio(endingDate));
      } catch (e) {
        startDate = convertDate(new Date());
        var endingDate = convertDate(
          new Date().setYear(new Date().getFullYear() + 1)
        );

        $scope.dataToSave.start_of_validity = new Date(mesDiaAnio(startDate));
        $scope.dataToSave.end_of_validity = new Date(mesDiaAnio(endingDate));
      }
    }
    function mesDiaAnio(parDate) {
      // console.log('parDate', parDate);
      var d = new Date(toDate(parDate));
      // console.log('d', d);
      var date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
      // console.log('date', date);
      return date;
    }
    function convertDate(inputFormat, indicator) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      if (indicator) {
        var date = [
          pad(d.getDate() + 1),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      } else {
        var date = [
          pad(d.getDate()),
          pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/");
      }

      return date;
    }
    // ------------tablero OT------
    $scope.moveOTState = function (newcontainer, principal, seguimiento) {
      // function moveOTState(newcontainer,principal,seguimiento,tipo){
      SweetAlert.swal(
        {
          title: "Mover Registro",
          text:
            "Se moverá " +
            $scope.caratula.internal_number +
            " de: " +
            $scope.caratula.seguimiento +
            ", al Contenedor: " +
            newcontainer.tablero,
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (isConfirm) {
            if (principal.contenedores && principal.contenedores.length > 0) {
              principal.contenedores.forEach(function (r, i) {
                if (r.tablero == seguimiento) {
                  r.polizas.splice(r.polizas.indexOf($scope.caratula.id), 1);
                }
                if (r.tablero == newcontainer.tablero) {
                  r.polizas.push($scope.caratula.id);
                }
                if (r) {
                  if (r["details_endoso"]) {
                    r["details_endoso"] = [];
                  }
                  if (r["details_polizas"]) {
                    r["details_polizas"] = [];
                  }
                }
              });
            }
            var payload = {
              polizas_ots: principal.contenedores,
              name: principal.name,
              color: principal.color,
              url: $scope.principal.url ? $scope.principal.url : "",
            };
            if ($scope.principal.url && $scope.principal.url != "") {
              $http
                .patch($scope.principal.url, payload)
                .then(
                  function success(response) {
                    $scope.caratula.seguimiento = newcontainer.tablero;
                    activate();
                  },
                  function error(e) {
                    console.log("Error - promotorias--", e);
                  }
                )
                .catch(function (error) {
                  console.log("Error - promotablero - catch", error);
                });
            }
          }
        }
      );
    };
    // tablero OT------------------
    $scope.saveLocalstorange = function (ssr) {
      groupDraft["observations"] = $scope.caratula.observations;
      groupDraft["identifier"] = $scope.caratula.identifier;
      groupDraft["internal_number"] = $scope.caratula.internal_number;
      groupDraft["folio"] = $scope.caratula.folio;
      groupDraft["poliza_number"] = $scope.caratula.poliza_number;
      groupDraft["contratante"] = order.contratante;
      groupDraft["address"] = $scope.addressSelected;
      groupDraft["subgrupos"] = $scope.subgroupsInfo
        ? $scope.subgroupsInfo
        : $scope.subgroups
        ? $scope.subgroups
        : [];
      groupDraft["paquetes"] = $scope.paquetes;
      groupDraft["referenciadores"] = $scope.referenciadorArray;
      groupDraft["clave"] = $scope.claveSelected;
      // groupDraft['aseguradora'] =  $scope.aseguradoraSelected;
      // groupDraft['ramo'] =  $scope.ramoSelected;
      // groupDraft['subramo'] =  ssr ? ssr : $scope.subramoSelected;
    };

    $scope.changeBusinessLine = function (val) {
      groupDraft.business_line = val;
      $scope.business_lineSelected = val;
    };

    function getInternalNumber() {
      $http({
        method: "POST",
        url: url.IP + "internal-number/",
      })
        .then(
          function success(response) {
            if (response.status === 200 || response.status === 201) {
              $scope.caratula.internal_number = "OT000" + response.data.id;
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log("error", e);
        });
    }

    function fillProvider() {
      var d = $scope.startDate;
      try {
        var day = d.getDate();
        var month = d.getMonth() + 1; //Months are zero based
        var year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var day = f.getDate();
        var month = f.getMonth() + 1; //Months are zero based
        var year = f.getFullYear();
      }

      var date = year + "-" + month + "-" + day;
      providerService.getProviderByKey(date).then(
        function success(data) {
          $scope.providers = data.data;
          if (
            $localStorage.orderFormCotizacion &&
            $localStorage.orderFormCotizacion.aseguradora_seleccionada
          ) {
            var aseguradoraSeleccionada = (
              $localStorage.orderFormCotizacion.aseguradora_seleccionada || ""
            ).toLowerCase();
            $scope.providers.forEach(function (aseg) {
              if (aseg.alias.toLowerCase() == aseguradoraSeleccionada) {
                $scope.aseguradoraSelected = aseg;
                groupDraft.aseguradora = aseg;
                $scope.caratula.aseguradora = aseg;
                $scope.getClaves(aseg);
              }
            });
          }
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    $scope.showButtonPolicy = function () {
      $scope.showOt = false;
      $scope.aseguradoraSelected = $scope.caratula.aseguradora;
      $scope.ramoSelected = $scope.caratula.ramo;
      $scope.subramoSelected = $scope.caratula.subramo;
      if (groupDraft["administration_type"]) {
        $scope.administrationTypes.forEach(function (item) {
          if (item.value == groupDraft["administration_type"]) {
            $scope.administrationSelected = item;
          }
        });
      } else {
        $scope.administrationSelected = $scope.caratula.administration_type;
      }
      if (groupDraft["payment"]) {
        $scope.paymentSelected = hasGroupDraft() ? groupDraft["payment"] : {};
        $scope.caratula.forma_de_pago = $scope.paymentSelected
          ? $scope.paymentSelected
          : "";
        $scope.directiveReceipts.payment = $scope.paymentSelected;
      } else {
        $scope.paymentSelected = $scope.caratula.forma_de_pago;
        $scope.caratula.forma_de_pago = $scope.paymentSelected
          ? $scope.paymentSelected
          : "";
        $scope.directiveReceipts.payment = $scope.paymentSelected;
      }
    };

    $scope.hideButtonOT = function () {
      $scope.showOt = true;
      $scope.aseguradoraSelected = $scope.caratula.aseguradora;
      $scope.ramoSelected = $scope.caratula.ramo;
      $scope.subramoSelected = $scope.caratula.subramo;
      if (groupDraft["administration_type"]) {
        $scope.administrationTypes.forEach(function (item) {
          if (item.value == groupDraft["administration_type"]) {
            $scope.administrationSelected = item;
          }
        });
      } else {
        $scope.administrationSelected = $scope.caratula.administration_type;
      }
      if (groupDraft["payment"]) {
        $scope.paymentSelected = hasGroupDraft() ? groupDraft["payment"] : {};
        $scope.caratula.forma_de_pago = $scope.paymentSelected
          ? $scope.paymentSelected
          : "";
        $scope.directiveReceipts.payment = $scope.paymentSelected;
      } else {
        $scope.paymentSelected = $scope.caratula.forma_de_pago;
        $scope.caratula.forma_de_pago = $scope.paymentSelected
          ? $scope.paymentSelected
          : "";
        $scope.directiveReceipts.payment = $scope.paymentSelected;
      }
    };

    $scope.checkNumPolicy = function () {
      if ($scope.caratula.poliza_number) {
        helpers
          .existPolicyNumber($scope.caratula.poliza_number)
          .then(function (request) {
            if (request == true) {
              SweetAlert.swal("Error", MESSAGES.ERROR.POLICYEXIST, "error");
              $scope.caratula.poliza_number = "";
            }
          })
          .catch(function (err) {
            console.log("Error", err);
          });
      }
    };

    var myInsurance = $stateParams.myInsurance;
    if (myInsurance.url) {
      order = {
        contratante: {},
      };

      order.contratante.value = $stateParams.myInsurance;
      if (order.contratante.value.email) {
        order.contratante.value.email = $stateParams.myInsurance.email;
      }
    }

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          // if($scope.infoUser.staff && !$scope.infoUser.superuser){
          //   $scope.show_contratante = 'v2/contratantes/contractors-match/';
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord.val,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch("order.contratante.value", function (newValue, oldValue) {
      if (order.contratante) {
        if ($scope.referenciadores) {
          $scope.referenciadores.some(function (user) {
            if (user.url == order.contratante.value.vendor) {
              $scope.referenciadorArray[0] = {
                referenciador: user.id,
                comision_vendedor: "",
              };
            }
          });
        }
        if (order.contratante.value.address_contractor) {
          if (order.contratante.value.address_contractor) {
            $scope.caratula.contractor = order.contratante.value.id;
            $scope.addresses = order.contratante.value.address_contractor;
          }
          if ($scope.addresses.length == 1) {
            $scope.addressSelected = $scope.addresses[0];
            $scope.caratula.address = $scope.addresses[0].id;
          }
        }
        if (order.contratante.value.full_name) {
          order.contratante.val = order.contratante.value.full_name;
          order.contratante.label = order.contratante.value.full_name;
          $scope.addresses = order.contratante.value.address_contractor;
        }
        if (order.contratante.value.phone_number) {
          order.contratante.phone_number = order.contratante.value.phone_number;
        }

        if (
          order.contratante &&
          order.contratante.value &&
          order.contratante.value.sucursal
        ) {
          dataFactory
            .get("sucursales-to-show-unpag/")
            .then(function success(response) {
              if (response.status === 200 || response.status === 201) {
                $scope.sucursales = response.data;
                if ($scope.sucursales && order.contratante.value) {
                  $scope.sucursales.forEach(function (item) {
                    if (item.url == order.contratante.value.sucursal) {
                      $scope.sucursalSelected = item.id;
                      $scope.caratula.sucursal = $scope.sucursalSelected;
                    }
                  });
                }
              }
            })
            .catch(function (e) {
              console.log("error", e);
            });
        }
        if (order.contratante.value.cellule) {
          if (order.contratante.value.email) {
            order.contratante.email = order.contratante.value.email;
          }
          $scope.celulas.forEach(function (item) {
            if (
              String(item.url) ==
              (order.contratante.value.cellule.url
                ? String(order.contratante.value.cellule.url)
                : String(order.contratante.value.cellule))
            ) {
              $scope.celulaSelected = item;
              $scope.changeCelula($scope.celulaSelected);
            }
          });
        }
        $scope.info_sub = order.contratante.value;
        // if(order.contratante.value.groupinglevel){
        //   $scope.agrupaciones.forEach(function(item){
        //     if(String(item.url) == (order.contratante.value.groupinglevel.url ? String(order.contratante.value.groupinglevel.url) : String(order.contratante.value.groupinglevel))){
        //       $scope.grouping_levelSelected = item;
        //       $scope.changeAgrupacion($scope.grouping_levelSelected);
        //     }
        //   });
        // }
        if (order.contratante.value.groupinglevel) {
          // $http.get(order.contratante.value.groupinglevel.
          $http
            .get(
              order.contratante.value.groupinglevel.url
                ? order.contratante.value.groupinglevel.url
                : order.contratante.value.groupinglevel
            )
            .then(function success(respons) {
              if (respons.data.type_grouping == 3) {
                $scope.info_sub.subsubgrouping = respons.data.description;
                $http.get(respons.data.parent).then(function success(respon) {
                  $scope.info_sub.subgrouping = respon.data.description;
                  $http.get(respon.data.parent).then(function success(respo) {
                    $scope.grouping_levelSelected = respo.data;
                    $scope.changeAgrupacion(respo.data);
                  });
                  $scope.subsubgroupingSelected = respon.data;
                });
                $scope.info_sub.subsubgrouping = respons.data;
              } else if (respons.data.type_grouping == 2) {
                $scope.info_sub.subgrouping = respons.data.description;
                $http.get(respons.data.parent).then(function success(respon) {
                  $scope.grouping_levelSelected = respon.data;
                  $scope.changeAgrupacion(respon.data);
                });
                $scope.subgroupingSelected == respons.data;
              } else if (respons.data.type_grouping == 1) {
                $scope.grouping_levelSelected = respons.data;
                $scope.changeAgrupacion(respons.data);
              }
            });
        }
        $scope.order.contratante = order.contratante;
      }
    });

    $scope.changeAddress = function (param) {
      $scope.caratula.address = param.id;
    };

    $scope.contratanteCreator = function () {
      $rootScope.show_contractor = true;
      // $scope.orderInfo = vm;
      $localStorage.orderForm = JSON.stringify($scope.caratula);
    };

    $scope.checkDate = function (param) {
      if (param.length == 10) {
        var date_initial = param.split("/");
        var day = date_initial[0];
        var month = date_initial[1];
        var year = parseInt(date_initial[2]);

        if (day.length == 1) {
          day = "0" + day;
        }
        if (month.length == 1) {
          month = "0" + month;
        }

        $scope.startDate = param;
        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();

        if (process(param) > process($scope.endDate)) {
          SweetAlert.swal(
            "Error",
            "La fecha inicio no puede ser mayor a la fecha fin.",
            "error"
          );
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }
      } else {
        var day = new Date().getDate();
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();

        $scope.startDate = param;
        $scope.endDate = convertDate(
          new Date(month + "/" + day + "/" + (year + 1))
        );
        $scope.caratula.start_of_validity = new Date(
          month + "/" + day + "/" + year
        ).toISOString();
        $scope.caratula.end_of_validity = new Date(
          month + "/" + day + "/" + (year + 1)
        ).toISOString();
      }
      $scope.directiveReceipts.startDate = $scope.startDate;
      $scope.directiveReceipts.endingDate = $scope.endDate;
      var date1 = new Date($scope.caratula.start_of_validity);
      var date2 = new Date($scope.caratula.end_of_validity);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      $scope.directiveReceipts.policy_days_duration = Math.ceil(
        timeDiff / (1000 * 3600 * 24)
      );

      groupDraft.startDate = param;
    };

    $scope.checkEndDate = function (param) {
      if (param.length == 10) {
        if (process(param) < process($scope.startDate)) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORDATERANGE, "error");
          return;
        }

        function process(date) {
          var parts = date.split("/");
          var date = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
          return date.getTime();
        }

        $scope.caratula.end_of_validity = toDate(param);
        $scope.directiveReceipts.endingDate = param;
        var date1 = new Date($scope.caratula.start_of_validity);
        var date2 = new Date($scope.caratula.end_of_validity);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        $scope.directiveReceipts.policy_days_duration = Math.ceil(
          timeDiff / (1000 * 3600 * 24)
        );
      }
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function toDate(dateStr) {
      if (dateStr) {
        var dateString = dateStr; // Oct 23
        var dateParts = dateString.split("/");
        var dateObject = new Date(
          dateParts[2],
          dateParts[1] - 1,
          dateParts[0]
        ).toISOString(); // month is 0-based
        return dateObject;
      }
    }

    $scope.getClaves = function (param) {
      $scope.aseguradoraSelected = param;
      groupDraft.aseguradora = param;
      $scope.caratula.aseguradora = param;
      if ($scope.caratula.aseguradora && $scope.caratula.aseguradora.id) {
        $http
          .get(url.IP + "claves-by-provider/" + $scope.caratula.aseguradora.id)
          .then(function success(clavesResponse) {
            $scope.claves = clavesResponse.data;
            if ($scope.claves.length == 1) {
              $scope.caratula.clave = $scope.claves[0].id;
              $scope.claveSelected = $scope.claves[0];
              $scope.changeClave($scope.claveSelected);
            }
          })
          .catch(function (error) {
            console.log("Error - claves-by-provider - catch", error);
          });

        $http
          .get(url.IP + "ramos-by-provider/" + $scope.caratula.aseguradora.id)
          .then(
            function success(response) {
              $scope.ramos = response.data;
              if ($localStorage.orderFormCotizacion) {
                $scope.ramos.forEach(function (ram) {
                  if (
                    ram &&
                    ram.ramo_name &&
                    ram.ramo_name.toLowerCase() ==
                      $localStorage.orderFormCotizacion.ramo.toLowerCase()
                  ) {
                    $scope.dataToSave.ramo = ram;
                    $scope.ramoSelected = ram;
                    $scope.caratula.ramo = ram;
                    $scope.changeRamo(ram);
                  }
                });
              }
            },
            function error(e) {
              console.log("Error - ramos-by-provider", e);
            }
          )
          .catch(function (error) {
            console.log("Error - ramos-by-provider - catch", error);
          });
      } else {
        $scope.caratula.ramo = null;
        $scope.caratula.clave = null;
        $scope.caratula.subramo = null;
        $scope.ramos = [];
        $scope.subramos = [];
        $scope.ramoSelected = null;
        $scope.aseguradoraSelected = null;
        $scope.subramoSelected = null;
        $scope.claves = [];
        $scope.claveSelected = null;
      }
    };

    $scope.refreshProvider = function () {
      fillProvider();
    };

    $scope.changeClave = function (param) {
      if (param) {
        groupDraft.clave = param;
        $scope.caratula.clave = param.id;
        $scope.claveSelected = param;
        if ($scope.caratula.subramo) {
          $scope.changeSubramo($scope.caratula.subramo);
        }
      }
    };

    $scope.changeRamo = function (param) {
      if (param) {
        groupDraft.ramo = param;
        $scope.caratula.ramo = param;
        $scope.subramos = param.subramo_ramo;
        if (
          $localStorage.orderFormCotizacion &&
          $localStorage.orderFormCotizacion.subramo
        ) {
          var subramoSeleccionado = (
            $localStorage.orderFormCotizacion.subramo || ""
          ).toLowerCase();
          $scope.subramos.forEach(function (ram) {
            if (ram.subramo_name.toLowerCase() == subramoSeleccionado) {
              $scope.dataToSave.subramo = ram;
              $scope.subramoSelected = ram;
              $scope.caratula.subramo = ram;
            }
          });
        }
      }
    };
    order.changeSubramoS = changeSubramoS;
    function changeSubramoS(param) {
      if (param) {
        groupDraft.subramo = param;
        $scope.caratula.subramo = param;
        $scope.directiveReceipts.subramo = param;

        var comisiones = [];
        if (
          $scope.claveSelected &&
          $scope.claveSelected.clave_comision.length
        ) {
          $scope.claveSelected.clave_comision.forEach(function (item) {
            if (param.subramo_name == item.subramo) {
              comisiones.push(item);
            }
          });
        }

        $scope.directiveReceipts.comisiones = comisiones;
      }

      getPackage2();
    }
    order.getPackage2 = getPackage2;
    function getPackage2() {
      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: $scope.caratula.ramo ? $scope.caratula.ramo.id : 0,
          subramo: $scope.caratula.subramo ? $scope.caratula.subramo.id : 0,
          provider: $scope.caratula.aseguradora
            ? $scope.caratula.aseguradora.id
            : 0,
        })
        .then(function success(response) {
          if (response.status === 200) {
            $scope.packages = [];
            if (response.data.length) {
              $scope.packages = response.data;
            }
          }
        })
        .catch(function (error) {
          console.log("error", e);
        });
    }
    $scope.changeSubramo = function (param) {
      if (param) {
        groupDraft.subramo = param;
        $scope.caratula.subramo = param;
        $scope.directiveReceipts.subramo = param;
        $scope.saveLocalstorange();
        var comisiones = [];
        if (
          $scope.claveSelected &&
          $scope.claveSelected.clave_comision.length
        ) {
          $scope.claveSelected.clave_comision.forEach(function (item) {
            if (param.subramo_name == item.subramo) {
              comisiones.push(item);
            }
          });
        }

        $scope.directiveReceipts.comisiones = comisiones;
      }

      $scope.getPackage();
    };

    $scope.changeRenewal = function (param) {
      groupDraft.is_renewable = param;
      $scope.caratula.is_renewable = param.value;
    };

    $scope.changeAdminType = function (param) {
      groupDraft.administration_type = param.value;
      $scope.caratula.administration_type = param.value;
      if ($scope.caratula.administration_type == 1) {
        SweetAlert.swal(
          "Simplificada",
          "Se puede capturar endoso por el ajuste anual “A” o “D según el caso.",
          "info"
        );
      } else if ($scope.caratula.administration_type == 2) {
        SweetAlert.swal(
          "Autoadministrada",
          "Se pueden capturar endosos por movimientos de altas o bajas sin recibos y, sin notas de crédito.",
          "info"
        );
      } else if ($scope.caratula.administration_type == 3) {
        SweetAlert.swal(
          "Detallada",
          "Se pueden capturar endosos por movimientos de altas o bajas con recibos al cobro o notas de crédito, según el caso.",
          "info"
        );
      }
    };

    $scope.changeCurrency = function (param) {
      groupDraft.f_currency = param;
      $scope.caratula.f_currency = param;
    };

    $scope.changeResponsable = function (param) {
      groupDraft.responsable = param;
      $scope.caratula.responsable = param;
    };

    $scope.changeExecutive = function (param) {
      groupDraft.collection_executive = param;
      $scope.caratula.collection_executive = param;
    };

    $scope.changeSucursal = function (param) {
      groupDraft.sucursal = param;
      $scope.caratula.sucursal = param;
    };

    $scope.changeConducto = function (param) {
      groupDraft.conducto_de_pago = param;
      $scope.caratula.conducto_de_pago = param;
      $scope.directiveReceipts.conducto_de_pago = param;
    };

    $scope.changeCelula = function (param) {
      groupDraft.celula = param;
      $scope.caratula.celula = param.id;
    };

    $scope.changeAgrupacion = function (data) {
      groupDraft.agrupacion = data;
      $scope.sub_asignaciones = data.subgrupos;
      $scope.caratula.groupinglevel = data.id;
      if ($scope.info_sub.subgrouping) {
        $scope.sub_asignaciones.forEach(function (item) {
          if (item.description == $scope.info_sub.subgrouping) {
            $scope.subgroupingSelected = item;
            $scope.caratula.groupinglevel = data.id;
            $scope.changeSubagrupacion(item);
          }
        });
      }
    };

    $scope.changeSubagrupacion = function (data) {
      if (data.subsubgrupos) {
        $scope.sub_subasignaciones = data.subsubgrupos;
        $scope.caratula.groupinglevel = data.id;
        groupDraft.subagrupacion = data;
        if ($scope.info_sub.subsubgrouping) {
          $scope.sub_subasignaciones.forEach(function (item) {
            if (item.url == $scope.info_sub.subsubgrouping.url) {
              $scope.subsubgroupingSelected = item;
              $scope.caratula.groupinglevel = item.id;
            }
          });
        }
      }
    };

    $scope.changeSubsubagrupacion = function (data) {
      $scope.caratula.groupinglevel = data.id;
      groupDraft.subsubagrupacion = data;
    };

    $scope.addReferenciador = function () {
      var addReferenciadores = {
        referenciador: "",
        comision_vendedor: "",
      };
      $scope.referenciadorArray.push(addReferenciadores);
    };

    $scope.deleteReferenciador = function (index) {
      $scope.referenciadorArray.splice(index, 1);
    };

    $scope.changeComRef = function (param, index, com) {
      $scope.referenciadorArray[index].comision_vendedor = param;
      if (com.comision_vendedor > 100) {
        com.comision_vendedor = 0;
      } else if (com.comision_vendedor < 0) {
        com.comision_vendedor = 0;
      }
      $scope.checkTotalComision(com);
    };
    $scope.checkTotalComision = function (item) {
      var totalComision = $scope.referenciadorArray.reduce(function (
        sum,
        item
      ) {
        return sum + (parseFloat(item.comision_vendedor) || 0); // Convert to number, default to 0 if undefined
      },
      0);
      if (totalComision > 100) {
        $scope.comisionError =
          "La suma de las comisiones no puede superar el 100%";
        item.comision_vendedor = 0;
      } else {
        $scope.comisionError = null; // No error if total is within limit
      }
    };

    $scope.chanceScheme = function (param) {
      groupDraft.scheme = param;
      $scope.caratula.scheme = parseInt(param);
      if (param == 1) {
        $scope.btnTraditionalStyle = {
          color: "#ffffff",
          "background-color": "#1cb394",
        };
        $scope.btnMinimalStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1cb394",
          "border-right": "1px solid #1cb394",
          "border-bottom": "1px solid #1cb394",
        };
      } else {
        $scope.paymentSelected = 5;
        $scope.chancePayment(5);
        $scope.caratula.receipts_by = 1;
        $scope.btnTraditionalStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1cb394",
          "border-bottom": "1px solid #1cb394",
          "border-left": "1px solid #1cb394",
        };
        $scope.btnMinimalStyle = {
          color: "#ffffff",
          "background-color": "#1cb394",
        };
        SweetAlert.swal(
          "Prima Mínima",
          "El esquema de pago de prima mínima solo permite recibos a nivel póliza.",
          "info"
        );
      }
    };

    $scope.chancePayment = function (param) {
      if (
        $scope.param != $scope.caratula.forma_de_pago &&
        $scope.showOt == false &&
        $scope.dataToSave &&
        $scope.dataToSave.recibos_poliza &&
        $scope.dataToSave.recibos_poliza.length > 0
      ) {
        $scope.dataToSave.recibos_poliza = [];
        SweetAlert.swal(
          "Cambio Forma de Pago",
          "Debe volver a Generar Recibos por cambio de Forma de Pago",
          "info"
        );
      }
      groupDraft.payment = param;
      $scope.caratula.forma_de_pago = parseInt(param);
      $scope.directiveReceipts.payment = param;
    };

    $scope.createReceits = function (param) {
      groupDraft.receipts_by = param;
      $scope.caratula.receipts_by = param;
      $scope.dataToSave.recibos_poliza = [];
      if (param == 1) {
        $scope.btnPolicyStyle = {
          color: "#ffffff",
          "background-color": "#1c84c4",
        };
        $scope.btnSudgroupStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-right": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
        };
        $scope.btnCertificateStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-right": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
        };
      } else if (param == 2) {
        $scope.btnPolicyStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
        };
        $scope.btnSudgroupStyle = {
          color: "#ffffff",
          "background-color": "#1c84c4",
        };
        $scope.btnCertificateStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-right": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
        };
        SweetAlert.swal(
          "Recibos por subgrupo",
          "Deberas crear en los recibos en los subgrupos.",
          "info"
        );
      } else {
        $scope.btnPolicyStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-right": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
        };
        $scope.btnSudgroupStyle = {
          color: "#707877",
          "background-color": "#ffffff",
          "border-top": "1px solid #1c84c4",
          "border-bottom": "1px solid #1c84c4",
          "border-left": "1px solid #1c84c4",
        };
        $scope.btnCertificateStyle = {
          color: "#ffffff",
          "background-color": "#1c84c4",
        };
        SweetAlert.swal(
          "Recibos por certificados",
          "Deberas crear en los recibos en los certificados.",
          "info"
        );
      }
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    // var uploader = $scope.uploader = new FileUploader({
    //   headers: {
    //     'Authorization': 'Bearer ' + token,
    //     'Accept': 'application/json'
    //   },onCompleteAll: function() {
    //     $rootScope.disabled = false;  // Enable the button once all uploads complete
    //     $scope.$apply();  // Trigger a digest cycle to update the view
    //   },
    //   onErrorItem: function(fileItem, response, status, headers) {
    //     $rootScope.disabled = false;  // Enable the button on error
    //     console.log('Error uploading file:', fileItem, response, status, headers);
    //     SweetAlert.swal("Error", "Error al subir archivos.", "error");
    //     $scope.$apply();  // Trigger a digest cycle to update the view
    //   }
    // });
    // Initialize FileUploader with required configurations
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
      onCompleteAll: function () {
        $rootScope.disabled = false; // Enable the button once all uploads complete
        $scope.$apply(); // Trigger a digest cycle to update the view
      },
      onErrorItem: function (fileItem, response, status, headers) {
        $rootScope.disabled = false; // Enable the button on error
        console.log(
          "Error uploading file:",
          fileItem,
          response,
          status,
          headers
        );
        SweetAlert.swal("Error", "Error al subir archivos.", "error");
        $scope.$apply(); // Trigger a digest cycle to update the view
      },
    }));
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };
    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item, options){
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $rootScope.disabled = true;
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
      $scope.okFile++;
      if ($scope.okFile == $scope.uploader.queue.length) {
        // $timeout(function(){
        $rootScope.disabled = false;
        if ($scope.dataCaratula.poliza_number) {
          SweetAlert.swal(
            "¡Listo!",
            "Colectividad creada exitosamente.",
            "success"
          );
          $scope.nextCertificate();
        }
        if (!$scope.dataCaratula.poliza_number) {
          SweetAlert.swal(
            "¡Listo!",
            "Orden de Trabajo creada exitosamente.",
            "success"
          );
          if ($scope.subgroups.length == 0 || $scope.paquetes.length == 0) {
            $state.go("colectividades.info", {
              polizaId: $scope.dataCaratula.id,
            });
          } else {
            $scope.nextCertificate();
          }
        }

        if ($uibModalInstance) {
          $uibModalInstance.close(200);
        }
        // }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      $rootScope.disabled = false;
      if (response.status == 413) {
        order.options.checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 2 });
      } else {
        order.options.checkDate("initial");
        $state.go("polizas.editar", { polizaId: $scope.idPolicy, message: 1 });
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
      fileItem.removeAfterUpload = true;
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    function uploadFiles(polizaId) {
      $rootScope.disabled = true;
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "polizas/" + polizaId + "/archivos/";
      $scope.files = [];
      $scope.files_ = [];
      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.nextSubgroup = function () {
      $scope.showCar = true;
      $scope.showSub = false;
    };

    $scope.nextPackage = function () {
      $scope.showSub = true;
      $scope.showPac = false;
    };

    $scope.nextCertificate = function () {
      $scope.showPac = true;
      $scope.showCer = false;
    };

    $scope.defaultSubgroup = function () {
      if (!$scope.caratula.subramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      } else {
        SweetAlert.swal(
          {
            title: "Subgrupo Default",
            text: "Se creará también una categoría por default ¿Estas de acuerdo?",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si",
            cancelButtonText: "No",
          },
          function (isConfirm) {
            if (isConfirm) {
              $scope.itemSubgrupos = {
                name: "Default",
                observations: "",
                contractor: null,
                address: null,
                categorias: [
                  {
                    name: "Default",
                    observations: null,
                    hospital_level: null,
                    document_type: 5,
                  },
                ],
              };
              if ($scope.caratula.subramo.subramo_name == "Gastos Médicos") {
                $scope.itemSubgrupos.categorias[0].hospital_level = "Default";
              }
              $scope.addSubgroup();

              $scope.showSub = true;
              $scope.showPac = false;
            }
          }
        );
      }
    };

    $scope.showSubgroup = function (param) {
      $scope.addSubgrupos = param;
      if ($scope.addSubgrupos) {
        $scope.itemSubgrupos = {
          name: "",
          observations: "",
          recibos_poliza: [],
          contractor: null,
          address: null,
          categorias: [
            {
              name: "",
              observations: "",
              hospital_level: "",
              document_type: 5,
            },
          ],
        };
      }
    };

    $scope.addCategorie = function (index) {
      var categoria = {
        name: "",
        observations: "",
        hospital_level: "",
        document_type: 5,
      };
      $scope.itemSubgrupos.categorias.push(categoria);
    };

    $scope.deleteCategorie = function (index) {
      $scope.itemSubgrupos.categorias.splice(index, 1);
    };

    $scope.addSubgroup = function () {
      if (!$scope.caratula.subramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (!$scope.itemSubgrupos.name) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORSUBGROUP, "error");
        return;
      }
      if (!$scope.showOt && $scope.caratula.receipts_by == 2) {
        if (!order.contratanteSubgrupo) {
          SweetAlert.swal(
            "Error",
            "Agrega un contratante al subgrupo.",
            "error"
          );
          return;
        }
        if (!$scope.itemSubgrupos.address) {
          SweetAlert.swal(
            "Error",
            "Agrega una dirección al subgrupo.",
            "error"
          );
          return;
        }
        if (!$scope.dataToSave.poliza) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
        if (!$scope.dataToSave.recibos_poliza) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          return;
        }
      }
      if ($scope.showOt && $scope.caratula.receipts_by == 2) {
        if (!order.contratanteSubgrupo) {
          SweetAlert.swal(
            "Error",
            "Agrega un contratante al subgrupo.",
            "error"
          );
          return;
        }
        if (!$scope.itemSubgrupos.address) {
          SweetAlert.swal(
            "Error",
            "Agrega una dirección al subgrupo.",
            "error"
          );
          return;
        }
      }
      var flagCoverage = false;
      $scope.itemSubgrupos.categorias.forEach(function (item, index) {
        if (!item.name) {
          flagCoverage = true;
          SweetAlert.swal(
            "Error",
            "Agrega el nombre de la categoría " + (index + 1) + ".",
            "error"
          );
        }
        if ($scope.caratula.subramo.subramo_name == "Gastos Médicos") {
          if (!item.hospital_level) {
            flagCoverage = true;
            SweetAlert.swal(
              "Error",
              "Agrega el nivel hospitalario de la categoría " +
                (index + 1) +
                ".",
              "error"
            );
          }
        }
      });
      if (flagCoverage) {
        return;
      }

      var infoSubgrupo = {
        name: $scope.itemSubgrupos.name,
        contractor: $scope.itemSubgrupos.contractor
          ? $scope.itemSubgrupos.contractor.val
          : null,
        // receipts: $scope.caratula.receipts_by == 2 ? $scope.dataToSave.recibos_poliza ? $scope.dataToSave.recibos_poliza.length : 0 : 0,
        categorias: $scope.itemSubgrupos.categorias,
        recibos_poliza: [],
        document_type: 4,
      };
      if (!$scope.subgroupsInfo) {
        $scope.subgroupsInfo = [];
      }
      $scope.subgroupsInfo.push(infoSubgrupo);
      var itemsubgrupo = {
        name: $scope.itemSubgrupos.name,
        observations: $scope.itemSubgrupos.observations,
        contractor: $scope.itemSubgrupos.contractor
          ? $scope.itemSubgrupos.contractor
          : null,
        address: $scope.itemSubgrupos.address
          ? $scope.itemSubgrupos.address
          : null,
        p_neta: $scope.dataToSave.p_neta ? $scope.dataToSave.p_neta : 0,
        descuento: $scope.dataToSave.descuento
          ? $scope.dataToSave.descuento
          : 0,
        rpf: $scope.dataToSave.rpf ? $scope.dataToSave.rpf : 0,
        derecho: $scope.dataToSave.derecho ? $scope.dataToSave.derecho : 0,
        sub_total: $scope.dataToSave.sub_total
          ? $scope.dataToSave.sub_total
          : 0,
        iva: $scope.dataToSave.iva ? $scope.dataToSave.iva : 0,
        p_total: $scope.dataToSave.p_total ? $scope.dataToSave.p_total : 0,
        comision: $scope.dataToSave.comision ? $scope.dataToSave.comision : 0,
        comision_percent: $scope.dataToSave.comision_percent
          ? $scope.dataToSave.comision_percent
          : 0,
        recibos_poliza: $scope.dataToSave.recibos_poliza
          ? $scope.dataToSave.recibos_poliza
          : [],
        document_type: 4,
        categorias: $scope.itemSubgrupos.categorias,
      };

      itemsubgrupo.recibos_poliza.forEach(function (recibo, index) {
        itemsubgrupo.recibos_poliza[index]["conducto_de_pago"] =
          $scope.caratula.conducto_de_pago;
      });
      if (!$scope.subgroups) {
        $scope.subgroups = [];
      }

      $scope.subgroups.push(angular.copy(itemsubgrupo));
      $scope.addSubgrupos = false;
      order.contratanteSubgrupo = [];
      if ($scope.caratula.receipts_by == 2) {
        $scope.dataToSave = [];
      }
      $scope.saveLocalstorange();
    };

    $scope.$watch(
      "order.contratanteSubgrupo.value",
      function (newValue, oldValue) {
        if (order.contratanteSubgrupo) {
          if (order.contratanteSubgrupo.value.address_contractor) {
            $scope.itemSubgrupos.contractor = order.contratanteSubgrupo;
            if (order.contratanteSubgrupo.value.address_contractor) {
              $scope.itemSubgrupos.contractor =
                order.contratanteSubgrupo.value.id;
              try {
                $scope.addressSubgroups =
                  order.contratanteSubgrupo.value.address_contractor;
              } catch (e) {}
            }
            if ($scope.addressSubgroups.length == 1) {
              $scope.itemSubgrupos.addressSelected = $scope.addressSubgroups[0];
              $scope.itemSubgrupos.address = $scope.addressSubgroups[0].id;
            }
          }
        }
      }
    );

    $scope.changeAddressSubgroup = function (param) {
      $scope.itemSubgrupos.address = param.id;
    };

    $scope.deleteSubgroup = function (index) {
      $scope.subgroupsInfo.splice(index, 1);
      $scope.subgroups.splice(index, 1);
    };

    $scope.getPackage = function () {
      $http
        .post(url.IP + "paquetes-data-by-subramo/", {
          ramo: $scope.caratula.ramo ? $scope.caratula.ramo.id : 0,
          subramo: $scope.caratula.subramo ? $scope.caratula.subramo.id : 0,
          provider: $scope.caratula.aseguradora
            ? $scope.caratula.aseguradora.id
            : 0,
        })
        .then(function success(response) {
          if (response.status === 200) {
            $scope.packages = [];
            if (response.data.length) {
              $scope.packages = response.data;
            }
          }
        })
        .catch(function (error) {
          console.log("error", e);
        });
    };

    $scope.changePackage = function (param) {
      if (param) {
        order.defaults = {
          package_name: param.package_name,
          formInfo: { code: $scope.caratula.subramo.subramo_code },
          coverages: [],
          coverageList: [],
        };
        $scope.order = {};
        $scope.order.defaults = {
          package_name: param.package_name,
          formInfo: { code: $scope.caratula.subramo.subramo_code },
          coverages: [],
          coverageList: [],
        };
        $scope.coveragesPackages = param.coverage_package;
        $scope.personalizePackage = true;
        param.coverage_package.forEach(function (element) {
          if (element.default) {
            order.defaults.coverages.push(angular.copy(element));
            $scope.order.defaults.coverages.push(angular.copy(element));
          } else {
            order.defaults.coverageList.push(angular.copy(element));
            $scope.order.defaults.coverageList.push(angular.copy(element));
          }
        });
      } else {
        $scope.coveragesPackages = [];
      }
    };

    $scope.demo = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    $scope.saveSum = function (parValue, parCoverage) {
      $scope.n_exis = 0;
      parCoverage.sums_coverage.forEach(function (item) {
        $scope.exist_flag = false;
        if (item) {
          if (item.sum_insured == parValue) {
            $scope.exist_flag = true;
            $scope.n_exis = $scope.n_exis + 1;
            if ($scope.exist_flag == true) {
              $scope.exist_flag = true;
              $scope.n_exis = $scope.n_exis + 1;
            }
          } else if ($scope.n_exis == 0 || $scope.n_exis == undefined) {
            $scope.exist_flag = false;
          }
          if ($scope.n_exis > 0) {
            $scope.exist_flag = true;
          }
        }
      });
      if (
        !$scope.exist_flag ||
        $scope.n_exis == 0 ||
        $scope.n_exis == undefined
      ) {
        var obj = {
          sum_insured: parValue,
          default: false,
          coverage_sum: parCoverage.url,
        };

        coverageService.createSumInsured(obj).then(function (response) {
          if (response.id) {
            $scope.result_ = false;
            parCoverage.sums_coverage.push(response);
          }
        });
      }
    };

    $scope.saveDed = function (parValue, parCoverage) {
      $scope.n_exis = 0;
      parCoverage.deductible_coverage.forEach(function (item) {
        $scope.exist_flag = false;
        if (item) {
          if (item.deductible == parValue) {
            $scope.exist_flag = true;
            $scope.n_exis = $scope.n_exis + 1;
            if ($scope.exist_flag == true) {
              $scope.exist_flag = true;
              $scope.n_exis = $scope.n_exis + 1;
            }
          } else if ($scope.n_exis == 0 || $scope.n_exis == undefined) {
            $scope.exist_flag = false;
          }
          if ($scope.n_exis > 0) {
            $scope.exist_flag = true;
          }
        }
      });
      if (
        !$scope.exist_flag ||
        $scope.n_exis == 0 ||
        $scope.n_exis == undefined
      ) {
        var obj = {
          deductible: parValue ? parValue : 0,
          default: false,
          coverage_deductible: parCoverage.url,
        };

        coverageService.createDeducible(obj).then(function (response) {
          if (response.id) {
            $scope.result_ = false;
            parCoverage.deductible_coverage.push(response);
          }
        });
      }
    };

    order.options = {
      deleteCoverage: function (obj, index) {
        order.defaults.coverages.splice(index, 1);
        order.defaults.coverageList.push(obj);
      },
      addCoverage: function (obj) {
        if (obj) {
          order.defaults.coverages.push(obj);

          order.defaults.coverageList.forEach(function (coverage) {
            if (coverage.coverage_name == obj.coverage_name) {
              order.defaults.coverageList.splice(
                order.defaults.coverageList.indexOf(coverage),
                1
              );
            }
          });
        }
      },
    };
    $scope.order = {};
    $scope.order.options = {};
    $scope.order.options = {
      deleteCoverage: function (obj, index) {
        $scope.order.defaults.coverages.splice(index, 1);
        $scope.order.defaults.coverageList.push(obj);
      },
      addCoverage: function (obj) {
        if (obj) {
          $scope.order.defaults.coverages.push(obj);

          $scope.order.defaults.coverageList.forEach(function (coverage) {
            if (coverage.coverage_name == obj.coverage_name) {
              $scope.order.defaults.coverageList.splice(
                order.defaults.coverageList.indexOf(coverage),
                1
              );
            }
          });
        }
      },
    };
    $scope.deleteCoveragePaq = function (obj, index) {
      $scope.order.defaults.coverages.splice(index, 1);
      $scope.order.defaults.coverageList.push(obj);
    };
    $scope.addCoveragePaq = function (obj) {
      if (obj) {
        $scope.order.defaults.coverages.push(obj);

        $scope.order.defaults.coverageList.forEach(function (coverage) {
          if (coverage.coverage_name == obj.coverage_name) {
            $scope.order.defaults.coverageList.splice(
              order.defaults.coverageList.indexOf(coverage),
              1
            );
          }
        });
      }
    };
    $scope.addPackageCoverage = function (param) {
      if (param) {
        var coverage = {
          coverage_name: "",
          sums_coverage: [],
          deductible: [],
          coinsurance_coverage: [],
          topecoinsurance_coverage: [],
        };
        $scope.newCoverages.push(coverage);
      } else {
        $scope.newCoverages = [];
      }
    };

    $scope.deletePackageCoverage = function (index) {
      $scope.newCoverages.splice(index, 1);
    };

    $scope.saveCoverage = function (param) {
      $scope.newCoverages.forEach(function (coverage, index) {
        if (coverage.coverage_name) {
          var covObj = {
            coverage_name: coverage.coverage_name,
            provider: $scope.caratula.aseguradora.url,
            package: param.url,
            sums_coverage: [],
            deductible_coverage: [],
            coinsurance_coverage: [],
            topecoinsurance_coverage: [],
            typeCoverage: 2,
          };

          var test = {
            coverage_sum: coverage.url,
            default: true,
            id: 0,
            org: "",
            sum_insured: coverage.sums_coverage ? coverage.sums_coverage : 0,
            url: "",
          };
          covObj.sums_coverage.push(test);

          var test = {
            coverage_deductible: coverage.url,
            default: true,
            id: 0,
            org: "",
            deductible: coverage.deductible_coverage
              ? coverage.deductible_coverage
              : 0,
            url: "",
          };
          covObj.deductible_coverage.push(test);

          $http
            .post(url.IP + "coberturas-configuraciones/", covObj)
            .then(createCoverageComplete)
            .catch(createCoverageFailed);

          function createCoverageComplete(response) {
            if (response.status == 200 || response.status == 201) {
              order.defaults.coverages.push(covObj);
              $scope.order.defaults.coverages.push(covObj);
              if (index + 1 == $scope.newCoverages.length) {
                $scope.addPackageCoverage(false);
              }
            }
          }

          function createCoverageFailed(error) {}
        }
      });
    };

    $scope.showNewPackage = function (param) {
      $scope.newPackage = param;
      $scope.personalizePackage = false;
      $scope.newPackageCoverage = {
        package_name: "",
        description: "",
        coverage_package: [
          {
            coverage_name: "",
            deductible: "",
            sums_coverage: [],
            coinsurance_coverage: [],
          },
        ],
      };
    };

    $scope.addNewPackageCoverage = function () {
      var coverage = {
        coverage_name: "",
        sums_coverage: [],
        deductible: [],
        coinsurance_coverage: [],
        topecoinsurance_coverage: [],
      };
      $scope.newPackageCoverage.coverage_package.push(coverage);
    };

    $scope.deleteNewPackageCoverage = function (index) {
      $scope.newPackageCoverage.coverage_package.splice(index, 1);
    };

    $scope.saveNewPackage = function () {
      var flagNewCoverage = false;
      if (!$scope.caratula.subramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        return;
      }
      if (!$scope.newPackageCoverage.package_name) {
        SweetAlert.swal("Error", "Agrega el nombre del paquete.", "error");
        return;
      }
      $scope.newPackageCoverage.coverage_package.forEach(function (
        coverage,
        index
      ) {
        if (!coverage.coverage_name) {
          SweetAlert.swal(
            "Error",
            "Agrega el nombre de la cobertura #" + (index + 1) + ".",
            "error"
          );
          flagNewCoverage = true;
        }
      });
      if (flagNewCoverage) {
        return;
      }
      var data = {
        package_name: $scope.newPackageCoverage.package_name,
        provider: $scope.caratula.aseguradora.id,
        ramo: $scope.caratula.ramo.id,
        subramo: $scope.caratula.subramo.id,
        coverage_package: $scope.newPackageCoverage.coverage_package,
        type_package: 1,
      };
      $http
        .post(url.IP + "packagecreate_new/", data)
        .then(function success(response) {
          if (response.status == 200) {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWPACKAGE, "success");
            $scope.getPackage();
            $scope.showNewPackage(false);
          } else {
            SweetAlert.swal(
              "¡Listo!",
              MESSAGES.OK.ERRORCREATEPACKAGE,
              "success"
            );
          }
        })
        .catch(function (error) {
          console.log("error", e);
        });
    };

    $scope.addCoverageArray = function (param) {
      if (param.selected) {
        $scope.package.coverage_package.push(angular.copy(param));
      } else {
        $scope.package.coverage_package.forEach(function (item, index, object) {
          if (param.id == item.id) {
            object.splice(index, 1);
          }
        });
      }
    };

    $scope.currency = function (param) {
      var model = formatValues.currency(param);
      return model;
    };

    $scope.deleteCoverage = function (param) {
      $scope.configCoverages.splice($scope.configCoverages.indexOf(param), 1);
      $scope.coveragesPackages.forEach(function (item) {
        if (item.coverage_name == param.coverage_name) {
          item.selected = false;
        }
      });
    };

    $scope.addPackage = function () {
      $scope.package.package_name = order.defaults.package_name;
      $scope.package.coverage_package = order.defaults.coverages;
      // if(!$scope.package.package_name){
      //   SweetAlert.swal("Error", "Escribe un nombre del paquete.", "error");
      //   return;
      // }
      if ($scope.package.coverage_package.length == 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.COVERAGESREQUIRED, "error");
        return;
      }
      try {
        $scope.package.coverage_package = $scope.order.defaults.coverages
          ? $scope.order.defaults.coverages
          : order.defaults.coverages;
      } catch (i) {
        $scope.package.coverage_package = $scope.package.coverage_package;
      }
      if (
        !$scope.package.coverage_package[0].sumInPolicy ||
        !$scope.package.coverage_package[0].deductibleInPolicy
      ) {
        SweetAlert.swal("Error", MESSAGES.ERROR.DEDUCTIBLEREQUIRED, "error");
        return;
      }
      var pack = angular.copy($scope.package);
      if (!$scope.paquetes) {
        $scope.paquetes = [];
      }
      $scope.paquetes.push(pack);
      $scope.package = {
        package_name: "",
        coverage_package: [],
        type_package: 2,
      };

      $scope.packageSelected = {};
      $scope.personalizePackage = false;
      $scope.getPackage();
      $scope.saveLocalstorange();
    };

    $scope.deletePackage = function (index) {
      $scope.paquetes.splice(index, 1);
    };

    function isString(x) {
      return Object.prototype.toString.call(x) === "[object Number]";
    }
    $scope.validityInsurance = function (arg) {
      $rootScope.disabled = true; // Disable the button at the start

      if (
        !$scope.showOt &&
        $scope.caratula.receipts_by != 3 &&
        !$scope.directiveReceipts.canCreate
      ) {
        SweetAlert.swal(
          "Error",
          "OPRIMA EL BOTON CALCULAR Y GENERAR RECIBOS",
          "error"
        );
        $rootScope.disabled = false; // Enable the button
        return;
      }

      $scope.referenciadores_copy = $scope.referenciadorArray.filter(function (
        item
      ) {
        return item && item.referenciador && isString(item.referenciador);
      });

      if (
        !order.acc_referenciador_obligatorio &&
        $scope.referenciadores_copy.length <= 0
      ) {
        SweetAlert.swal(
          "Error",
          "Seleccione al menos un referenciador",
          "error"
        );
        $rootScope.disabled = false; // Enable the button
        return;
      }

      if (!$scope.caratula.identifier) {
        SweetAlert.swal("Error", MESSAGES.ERROR.IDENTIFIERREQUIRED, "error");
        $rootScope.disabled = false; // Enable the button
        return;
      }

      if (!$scope.showOt) {
        if (!$scope.caratula.poliza_number) {
          SweetAlert.swal("Error", MESSAGES.ERROR.POLICYNOREQUIRED, "error");
          $rootScope.disabled = false; // Enable the button
          return;
        }
      }

      if (!order.contratante.val) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORCONTRACTOR, "error");
        $rootScope.disabled = false; // Enable the button
        return;
      }

      if (!$scope.caratula.address) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ADDRESS, "error");
        $rootScope.disabled = false; // Enable the button
        return;
      }

      if (!$scope.caratula.aseguradora || !$scope.aseguradoraSelected) {
        SweetAlert.swal("Error", MESSAGES.ERROR.PROVIDERREQUIRED, "error");
        $rootScope.disabled = false; // Enable the button
        return;
      }

      if (!$scope.caratula.clave) {
        SweetAlert.swal("Error", MESSAGES.ERROR.CLAVE, "error");
        $rootScope.disabled = false; // Enable the button
        return;
      }

      if (!$scope.caratula.ramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.RAMOREQUIRED, "error");
        $rootScope.disabled = false; // Enable the button
        return;
      }

      if (!$scope.caratula.subramo) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SUBRAMOREQUIRED, "error");
        $rootScope.disabled = false; // Enable the button
        return;
      }

      if (!$scope.caratula.administration_type) {
        SweetAlert.swal(
          "Error",
          MESSAGES.ERROR.ADMINISTRATIONREQUIRED,
          "error"
        );
        $rootScope.disabled = false; // Enable the button
        return;
      }

      if (!$scope.caratula.forma_de_pago) {
        SweetAlert.swal("Error", MESSAGES.ERROR.ERRORPAYFORM, "error");
        $rootScope.disabled = false; // Enable the button
        return;
      }

      if (!$scope.showOt && $scope.caratula.receipts_by == 1) {
        if (!$scope.dataToSave.recibos_poliza) {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERRORRECEIPTS, "error");
          $rootScope.disabled = false; // Enable the button
          return;
        }
        if ($scope.caratula.scheme == 2) {
          if (
            $scope.dataToSave.steps.length !=
            $scope.dataToSave.recibos_poliza.length - 1
          ) {
            SweetAlert.swal(
              "Error",
              "El número de escalones no coincide con el número de recibos.",
              "error"
            );
            $rootScope.disabled = false; // Enable the button
            return;
          }
          if (parseFloat($scope.dataToSave.sumaPorcentaje) != 100) {
            SweetAlert.swal(
              "Error",
              "La sumatoria de todos los porcentajes de cada escalon no pueden se diferente al 100%, verifica los porcentajes.",
              "error"
            );
            $rootScope.disabled = false; // Enable the button
            return;
          }
        }
      }

      if ($scope.subgroups.length == 0 && !$scope.showOt) {
        SweetAlert.swal("Error", "Agrega un subgrupo", "error");
        $rootScope.disabled = false; // Enable the button
        return;
      }

      if ($scope.paquetes && $scope.paquetes.length == 0 && !$scope.showOt) {
        SweetAlert.swal("Error", "Agrega un paquete", "error");
        $rootScope.disabled = false; // Enable the button
        return;
      }

      $scope.referenciadoresSelected = [];
      $scope.referenciadorArray.forEach(function (item) {
        if (item.referenciador != "") {
          if (item.comision_vendedor == "") {
            item.comision_vendedor = 0;
          }
          $scope.referenciadoresSelected.push(item);
        }
      });

      if (order.acceso_cno_pol == false) {
        if (
          ($scope.referenciadorArray &&
            $scope.referenciadorArray.length == 0) ||
          ($scope.referenciadores_copy &&
            $scope.referenciadores_copy.length == 0)
        ) {
          SweetAlert.swal("Error", "Seleccione el referenciador.", "error");
          $rootScope.disabled = false; // Enable the button
          return;
        }
      }

      $scope.copy_caratula = angular.copy($scope.caratula);
      $scope.saveInsurance(arg);
    };

    $scope.saveInsurance = function (arg) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (
        $scope.dataToSave &&
        $scope.dataToSave.prima_comision &&
        parseFloat($scope.dataToSave.comision_percent) !=
          parseFloat($scope.dataToSave.prima_comision)
      ) {
        $scope.dataToSave.comision_percent = $scope.dataToSave.prima_comision
          ? $scope.dataToSave.prima_comision
          : $scope.dataToSave.comision_percent
          ? $scope.dataToSave.comision_percent
          : 0;
      }
      $rootScope.disabled = true;
      $scope.caratula.folio = $scope.caratula.folio
        ? $scope.caratula.folio
        : null;
      $scope.caratula.poliza_number = $scope.caratula.poliza_number
        ? $scope.caratula.poliza_number
        : null;
      $scope.caratula.aseguradora = $scope.caratula.aseguradora.id;
      $scope.caratula.ramo = $scope.caratula.ramo.id
        ? $scope.caratula.ramo.id
        : $scope.caratula.ramo
        ? $scope.caratula.ramo
        : null;
      $scope.caratula.subramo = $scope.caratula.subramo.id
        ? $scope.caratula.subramo.id
        : $scope.caratula.subramo
        ? $scope.caratula.subramo
        : null;
      $scope.caratula.is_renewable = $scope.caratula.is_renewable
        ? $scope.caratula.is_renewable
        : $scope.renewalSelected
        ? $scope.renewalSelected.value
        : null;
      $scope.caratula.f_currency = $scope.caratula.f_currency
        ? $scope.caratula.f_currency
        : $scope.currencySelected
        ? $scope.currencySelected
        : 1;
      $scope.caratula.responsable = $scope.caratula.responsable
        ? $scope.caratula.responsable
        : null;
      $scope.caratula.collection_executive = $scope.caratula
        .collection_executive
        ? $scope.caratula.collection_executive
        : null;
      $scope.caratula.sucursal = $scope.caratula.sucursal
        ? $scope.caratula.sucursal
        : null;
      $scope.caratula.observations = $scope.caratula.observations
        ? $scope.caratula.observations
        : "";
      $scope.caratula.p_neta = $scope.dataToSave.p_neta
        ? $scope.dataToSave.p_neta
        : 0;
      $scope.caratula.descuento = $scope.dataToSave.descuento
        ? $scope.dataToSave.descuento
        : 0;
      $scope.caratula.rpf = $scope.dataToSave.rpf ? $scope.dataToSave.rpf : 0;
      $scope.caratula.derecho = $scope.dataToSave.derecho
        ? $scope.dataToSave.derecho
        : 0;
      $scope.caratula.sub_total = $scope.dataToSave.sub_total
        ? $scope.dataToSave.sub_total
        : 0;
      $scope.caratula.iva = $scope.dataToSave.iva ? $scope.dataToSave.iva : 0;
      $scope.caratula.p_total = $scope.dataToSave.p_total
        ? $scope.dataToSave.p_total
        : 0;
      $scope.caratula.comision = $scope.dataToSave.comision
        ? $scope.dataToSave.comision
        : 0;
      $scope.caratula.comision_percent = $scope.dataToSave.comision_percent
        ? $scope.dataToSave.comision_percent
        : 0;
      $scope.caratula.receipts_by = $scope.caratula.receipts_by
        ? $scope.caratula.receipts_by
        : null;
      $scope.caratula.recibos_poliza = $scope.dataToSave.recibos_poliza
        ? $scope.dataToSave.recibos_poliza
        : [];
      $scope.caratula.total_receipts = $scope.dataToSave.recibos_poliza
        ? $scope.dataToSave.recibos_poliza.length
        : 0;
      $scope.caratula.accident_rate = $scope.dataToSave.accident_rate
        ? $scope.dataToSave.accident_rate
        : 0;
      $scope.caratula.steps = $scope.dataToSave.steps
        ? $scope.dataToSave.steps
        : [];
      $scope.caratula.status = $scope.showOt ? 1 : 14;
      $scope.caratula.document_type = 3;
      $scope.caratula.business_line = $scope.business_lineSelected
        ? $scope.business_lineSelected.id
        : 0;
      $scope.caratula.celula = $scope.caratula.celula
        ? $scope.caratula.celula
        : "";
      $scope.caratula.groupinglevel = $scope.caratula.groupinglevel
        ? $scope.caratula.groupinglevel
        : "";
      $scope.caratula.conducto_de_pago = $scope.caratula.conducto_de_pago
        ? $scope.caratula.conducto_de_pago
        : 1;
      $scope.caratula.comision_derecho_percent =
        $scope.dataToSave &&
        $scope.dataToSave.poliza &&
        $scope.dataToSave.poliza.comision_derecho_percent
          ? $scope.dataToSave.poliza.comision_derecho_percent
          : 0;
      $scope.caratula.comision_rpf_percent =
        $scope.dataToSave &&
        $scope.dataToSave.poliza &&
        $scope.dataToSave.poliza.comision_rpf_percent
          ? $scope.dataToSave.poliza.comision_rpf_percent
          : 0;
      $scope.caratula.recibos_poliza.forEach(function (recibo, index) {
        $scope.caratula.recibos_poliza[index]["conducto_de_pago"] =
          $scope.caratula.conducto_de_pago;
      });

      $scope.referenciadoresSelected = [];
      $scope.referenciadorArray.forEach(function (item) {
        if (item.referenciador != "") {
          if (item.comision_vendedor == "") {
            item.comision_vendedor = 0;
          }
          $scope.referenciadoresSelected.push(item);
        }
      });

      $scope.colectividad = {
        caratula: $scope.caratula,
        referenciadores: $scope.referenciadoresSelected,
        subgrupos: $scope.subgroups,
        paquetes: $scope.paquetes,
      };
      if (
        $rootScope.from_task &&
        $rootScope.task_associated &&
        $rootScope.task_associated.url
      ) {
        $scope.colectividad.caratula.from_task = $rootScope.from_task;
        $scope.colectividad.caratula.task_associated =
          $rootScope.task_associated.id;
      }
      $http
        .post(url.IP + "caratula-complete/", $scope.colectividad)
        .then(function (response) {
          if (response.status == 200 || response.status == 201) {
            $scope.dataCaratula = response.data.data.caratula;
            if (
              $rootScope.from_task &&
              $rootScope.task_associated &&
              $rootScope.task_associated.url
            ) {
              $http.patch($rootScope.task_associated.url, {
                ot_model: 1,
                ot_id_reference: $scope.dataCaratula.id,
              });
            }
            $scope.dataSubgroup = response.data.data.childs;
            $scope.dataPackage = response.data.data.paquetes;
            if ($scope.dataCaratula.ramo.ramo_code == 1) {
              $scope.layout_name = "Layout_Col_Vida.xls";
            } else if ($scope.dataCaratula.ramo.ramo_code == 2) {
              $scope.layout_name = "Layout_Col_GM.xls";
            } else if ($scope.dataCaratula.ramo.ramo_code == 3) {
              if ($scope.dataCaratula.subramo.subramo_name == "Automóviles") {
                $scope.layout_name = "Layout_Col_Flotillas.xls";
              } else if (
                $scope.dataCaratula.subramo.subramo_name == "Diversos"
              ) {
                $scope.layout_name = "Layout_Col_Equipo.xls";
              } else {
                $scope.layout_name = "Layout_Col_Danios.xls";
              }
            }
            if ($scope.countFile > 0) {
              l.stop();
              $rootScope.disabled = true;
              uploadFiles($scope.dataCaratula.id);
            } else {
              l.stop();
              if ($scope.dataCaratula.poliza_number) {
                resetGroupDraft();
                $localStorage.orderFormCotizacion = {};
                // groupDraft.idPoliza= $scope.dataCaratula
                SweetAlert.swal(
                  "¡Listo!",
                  "Colectividad creada exitosamente.",
                  "success"
                );
                $state.go("colectividades.info", {
                  polizaId: $scope.dataCaratula.id,
                });
                $scope.nextCertificate();
              }
              if (!$scope.dataCaratula.poliza_number) {
                resetGroupDraft();
                SweetAlert.swal(
                  "¡Listo!",
                  "Orden de Trabajo creada exitosamente.",
                  "success"
                );
                if (arg) {
                  $state.go("colectividades.info", {
                    polizaId: $scope.dataCaratula.id,
                  });
                }
                if (
                  $scope.subgroups.length == 0 ||
                  $scope.paquetes.length == 0
                ) {
                  $state.go("colectividades.info", {
                    polizaId: $scope.dataCaratula.id,
                  });
                } else {
                  // groupDraft.idPoliza= $scope.dataCaratula
                  resetGroupDraft();
                  $state.go("colectividades.info", {
                    polizaId: $scope.dataCaratula.id,
                  });
                  $scope.nextCertificate();
                }
              }
            }
            $http.patch(order.contratante.value.url, {
              email: order.contratante.value.email,
              phone_number: order.contratante.value.phone_number,
            });
          } else {
            l.stop();
            $rootScope.disabled = false;
            SweetAlert.swal("Error", response.data.data, "error");
            $scope.caratula.aseguradora = $scope.copy_caratula.aseguradora;
            $scope.caratula.ramo = $scope.copy_caratula.ramo;
            $scope.caratula.subramo = $scope.copy_caratula.subramo;
          }
        })
        .catch(function (e) {
          l.stop();
          $rootScope.disabled = false;
          console.log("error - caratula - catch", e);
        })
        .finally(function () {
          l.stop();
          if ($scope.countFile === 0) {
            $rootScope.disabled = false; // Enable the button if there are no files to upload
          }
        });
    };

    $scope.goToInformation = function () {
      if (!$scope.dataCaratula.id) {
        SweetAlert.swal("Error!", "Debes crear la carátula primero.", "error");
        return;
      } else {
        groupDraft.idPoliza = {};
        $state.go("colectividades.info", { polizaId: $scope.dataCaratula.id });
      }
    };

    $scope.validateEmail = function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      if (!$scope.dataCaratula.id) {
        SweetAlert.swal(
          "Error!",
          "Debes crear la carátula primero para poder cargar certificados.",
          "error"
        );
        return;
      } else {
        var flagCertificate = false;
        if (param.VIDA) {
          if (
            $scope.dataCaratula.subramo.subramo_name == "Vida" ||
            $scope.dataCaratula.subramo.subramo_name == "Funerarios"
          ) {
            $scope.beneficiaries_life = [];
            $scope.excelJson = param.VIDA;
            $scope.excelJson.forEach(function (item) {
              if (!item.FAMILIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FAMILIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CERTIFICADO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CORREO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateEmail(item.CORREO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.TIPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.TIPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.TIPO < 1 || item.TIPO > 2) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.PARENTESCO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PARENTESCO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.PARENTESCO < 1 || item.PARENTESCO > 4) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna PARENTESCO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.NOMBRE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.APELLIDO_PATERNO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.APELLIDO_MATERNO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.FECHA_NACIMIENTO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SEXO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.SEXO.length > 1) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SEXO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.FECHA_ANTIGUEDAD) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.FECHA_ANTIGUEDAD)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.TIPO_SUMA_ASEGURADA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.TIPO_SUMA_ASEGURADA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO_SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (
                    item.TIPO_SUMA_ASEGURADA < 1 ||
                    item.TIPO_SUMA_ASEGURADA > 2
                  ) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna TIPO_SUMA_ASEGURADA no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.SUMA_ASEGURADA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SUELDO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUELDO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.FUMADOR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FUMADOR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.FUMADOR)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FUMADOR, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.FUMADOR < 0 || item.FUMADOR > 1) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna FUMADOR no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.VIGENCIA_INICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_FIN) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SUBGRUPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.SUBGRUPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.CATEGORIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.CATEGORIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              try {
                if (item.PRIMA_NETA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.RPF.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.DERECHO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.IVA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.COMISION.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              } catch (e) {}

              if (item.TIPO == 2) {
                var dataBeneficiary = {
                  familia: item.FAMILIA,
                  certificate: item.CERTIFICADO,
                  optional_relationship: item.PARENTESCO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: toDate(item.FECHA_NACIMIENTO),
                  sex: item.SEXO,
                  antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                  percentage: 0,
                };
                $scope.beneficiaries_life.push(dataBeneficiary);
              }
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else if (param.ASEGURADOS) {
          $scope.contributory = false;
          if (
            $scope.dataCaratula.ramo.ramo_name == "Accidentes y Enfermedades"
          ) {
            $scope.beneficiaries_medical = [];
            $scope.excelJson = param.ASEGURADOS;
            $scope.excelJson.forEach(function (item) {
              if ("RFC_CVE" in item) {
                $scope.contributory = true;
              }
              if (!item.FAMILIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FAMILIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CERTIFICADO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CORREO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateEmail(item.CORREO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.TIPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.TIPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.TIPO < 1 || item.TIPO > 2) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.PARENTESCO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PARENTESCO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.PARENTESCO < 1 || item.PARENTESCO > 4) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna PARENTESCO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.NOMBRE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.APELLIDO_PATERNO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.APELLIDO_MATERNO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.FECHA_NACIMIENTO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SEXO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.SEXO.length > 1) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SEXO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.FECHA_ANTIGUEDAD) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.FECHA_ANTIGUEDAD)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_INICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_FIN) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SUBGRUPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.SUBGRUPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.CATEGORIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.CATEGORIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              try {
                if (item.PRIMA_NETA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.RPF.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.DERECHO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.IVA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.COMISION.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              } catch (e) {}

              if (item.TIPO == 2) {
                var dataBeneficiary = {
                  familia: item.FAMILIA,
                  certificate: item.CERTIFICADO,
                  relationship: item.PARENTESCO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: toDate(item.FECHA_NACIMIENTO),
                  sex: item.SEXO,
                  antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                  clause: item.FAMILIA,
                  p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                  rpf: item.RPF ? item.RPF : 0,
                  derecho: item.DERECHO ? item.DERECHO : 0,
                  iva: item.IVA ? item.IVA : 0,
                  p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
                  comision: item.COMISION ? item.COMISION : 0,
                };
                $scope.beneficiaries_medical.push(dataBeneficiary);
              }
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else if (param.FLOTILLA) {
          if ($scope.dataCaratula.subramo.subramo_name == "Automóviles") {
            $scope.excelJson = param.FLOTILLA;
            $scope.excelJson.forEach(function (item) {
              if (!item.INCISO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CORREO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateEmail(item.CORREO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.MARCA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MODELO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.AÑO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna AÑO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SERVICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SERVICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.PROCEDENCIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PROCEDENCIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.PROCEDENCIA < 0 || item.PROCEDENCIA > 4) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna PROCEDENCIA no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.USO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.USO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.USO < 1 || item.USO > 3) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.VERSION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SERIE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.VIGENCIA_INICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_FIN) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SUBGRUPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.SUBGRUPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.CATEGORIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.CATEGORIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              try {
                if (item.PRIMA_NETA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.RPF.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.DERECHO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.IVA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.COMISION.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              } catch (e) {}
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else if (param.DANIOS_DIVERSO) {
          if ($scope.dataCaratula.subramo.subramo_name == "Diversos") {
            $scope.excelJson = param.DANIOS_DIVERSO;
            $scope.excelJson.forEach(function (item) {
              if (!item.INCISO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CORREO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateEmail(item.CORREO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.MARCA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MODELO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.DESCRIPCION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DESCRIPCION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.AÑO_CONSTRUCCION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna AÑO_CONSTRUCCION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.AÑO_RECONSTRUCCION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna AÑO_RECONSTRUCCION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.VALOR_COMPRA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VALOR_COMPRA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.USO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.USO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (item.USO < 1 || item.USO > 3) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.VERSION) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SERIE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.VIGENCIA_INICIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.VIGENCIA_FIN) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SUBGRUPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.SUBGRUPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.CATEGORIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.CATEGORIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              try {
                if (item.PRIMA_NETA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.RPF.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.DERECHO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.IVA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.COMISION.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              } catch (e) {}
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else if (param.DANIOS_IRC) {
          if (
            $scope.dataCaratula.subramo.subramo_name == "Incendio" ||
            $scope.dataCaratula.subramo.subramo_name == "Responsabilidad Civil"
          ) {
            $scope.excelJson = param.DANIOS_IRC;
            $scope.excelJson.forEach(function (item) {
              if (!item.INCISO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CORREO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (!$scope.validateEmail(item.CORREO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.SUCURSAL) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUCURSAL, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.GIRO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna GIRO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.TIPO_CONSTRUCTIVO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_CONSTRUCTIVO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.TIPO_CONSTRUCTIVO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO_CONSTRUCTIVO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                } else {
                  if (
                    item.TIPO_CONSTRUCTIVO < 1 ||
                    item.TIPO_CONSTRUCTIVO > 3
                  ) {
                    SweetAlert.swal(
                      "Error",
                      "Los valores de la linea " +
                        (parseInt(item.__rowNum__) + 1) +
                        " de la columna TIPO_CONSTRUCTIVO no son válidos, corrige el error y vuelve a subir el excel.",
                      "error"
                    );
                    flagCertificate = true;
                  }
                }
              }
              if (!item.NO_NIVELES) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_NIVELES, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.ZONA_FHM) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna ZONA_FHM, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.ZONA_TYEV) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna ZONA_TYEV, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CALLE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CALLE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.NO_INTERIOR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_INTERIOR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.NO_EXTERIOR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_EXTERIOR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.MUNICIPIO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna MUNICIPIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.COLONIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COLONIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CIUDAD) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CIUDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.ESTADO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna ESTADO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.CP) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CP, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.SUBGRUPO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.SUBGRUPO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.CATEGORIA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.CATEGORIA)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              if (!item.PAQUETE) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (isNaN(item.PAQUETE)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
              try {
                if (item.PRIMA_NETA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.RPF.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.DERECHO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.IVA.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
                if (item.COMISION.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              } catch (e) {}
            });

            if (!flagCertificate) {
              $scope.selectedCertificates = param;
              $scope.addViews(0);
            }
          } else {
            SweetAlert.swal(
              "Error",
              "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
              "error"
            );
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
            "error"
          );
        }
      }
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          if (item.AÑO_CONSTRUCCION) {
            item.ANO_CONSTRUCCION = item.AÑO_CONSTRUCCION;
            item.ANO_RECONSTRUCCION = item.AÑO_RECONSTRUCCION;
          }
          if (item.AÑO) {
            item.ANO = item.AÑO;
          }
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.selectViews = function (value) {
      $scope.optionViews = value;
      $scope.addViews(0);
    };
    $scope.formatPrimas = function (parValue) {
      if (parValue) {
        parValue = parValue.toString();

        if (
          parValue.search(/[A-Za-z]/g) > -1 ||
          parValue.search(/[0-9]%/g) > -1
        ) {
          return parValue;
        } else {
          var num = parseFloat(parValue);
          var num_format = num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");

          return num_format;
          // return parValue;
        }
      }
    };
    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.cancelCertificates = function () {
      $scope.showTableCertificates = false;
      $scope.selectedCertificates = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.saveCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loader = true;
      $scope.certifcados = [];

      if ($scope.selectedCertificates.VIDA) {
        $scope.selectedCertificates.VIDA.forEach(function (item) {
          if (item.TIPO == 1) {
            var dataLife = [
              {
                personal: {
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: toDate(item.FECHA_NACIMIENTO),
                  antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  salary: item.SUELDO ? parseInt(item.SUELDO) : 0,
                  sum_assured: item.SUMA_ASEGURADA
                    ? parseInt(item.SUMA_ASEGURADA)
                    : 0,
                  type_sa: item.TIPO_SUMA_ASEGURADA
                    ? parseInt(item.TIPO_SUMA_ASEGURADA)
                    : 0,
                },
                smoker: item.FUMADOR
                  ? item.FUMADOR == 0
                    ? false
                    : true
                  : null,
                beneficiaries_life: [],
              },
            ];

            $scope.beneficiaries_life.forEach(function (beneficiarie) {
              if (beneficiarie.familia == item.FAMILIA) {
                dataLife[0].beneficiaries_life.push(beneficiarie);
              }
            });

            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            if (item.SUBGRUPO) {
              $scope.dataSubgroup.forEach(function (itemSubgrupo) {
                if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                  if (itemSubgrupo.address) {
                    contractor_certificate = itemSubgrupo.contractor
                      ? itemSubgrupo.contractor.id
                      : null;
                  } else {
                    contractor_certificate = $scope.dataCaratula.contractor
                      ? $scope.dataCaratula.contractor
                      : null;
                  }
                }
              });
            } else {
              contractor_certificate = $scope.dataCaratula.contractor
                ? $scope.dataCaratula.contractor
                : null;
            }

            var certificateData = {
              caratula: $scope.dataCaratula.id,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number:
                $scope.dataCaratula.poliza_number +
                " - INC. " +
                item.CERTIFICADO,
              contractor: contractor_certificate,
              ramo: $scope.dataCaratula.ramo.id,
              subramo: $scope.dataCaratula.subramo.id,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: toDate(item.VIGENCIA_INICIO),
              end_of_validity: toDate(item.VIGENCIA_FIN),
              status: $scope.dataCaratula.status == "Vigente" ? 14 : 1,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: [],
              life_policy: dataLife,
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "VIDA_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: item.PRIMA_NETA
                ? parseFloat(item.PRIMA_NETA).toFixed(2)
                : 0,
              rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
              derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
              iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
              p_total: item.PRIMA_TOTAL
                ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                : 0,
              comision: item.COMISION
                ? parseFloat(item.COMISION).toFixed(2)
                : 0,
              rec_antiguedad: toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
            };

            $scope.certifcados.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.ASEGURADOS) {
        $scope.selectedCertificates.ASEGURADOS.forEach(function (item) {
          $scope.sum_neta = 0;
          $scope.sum_rpf = 0;
          $scope.sum_derecho = 0;
          $scope.sum_iva = 0;
          $scope.sum_total = 0;
          $scope.sum_comision = 0;
          if (item.TIPO == 1) {
            var dataMedical = [
              {
                personal: {
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: toDate(item.FECHA_NACIMIENTO),
                  antiguedad: toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  p_neta: item.PRIMA_NETA
                    ? parseFloat(item.PRIMA_NETA).toFixed(2)
                    : 0,
                  rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
                  derecho: item.DERECHO
                    ? parseFloat(item.DERECHO).toFixed(2)
                    : 0,
                  iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
                  p_total: item.PRIMA_TOTAL
                    ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                    : 0,
                  comision: item.COMISION
                    ? parseFloat(item.COMISION).toFixed(2)
                    : 0,
                  contributory: $scope.contributory
                    ? $scope.contributory
                    : false,
                  rfc_cve: item.RFC_CVE ? item.RFC_CVE : "",
                  rfc_homocve: item.RFC_HOMOCVE ? item.RFC_HOMOCVE : "",
                  dom_callenum: item.DOM_CALLE_NUM ? item.DOM_CALLE_NUM : "",
                  dom_colonia: item.DOM_COLONIA ? item.DOM_COLONIA : "",
                  dom_cp: item.DOM_CP ? item.DOM_CP : "",
                  dom_poblacion: item.DOM_POBLACION ? item.DOM_POBLACION : "",
                  dom_estado: item.DOM_ESTADO ? item.DOM_ESTADO : "",
                },
                disease_type: 0,
                relationship_accident: [],
              },
            ];
            $scope.sum_neta = dataMedical[0].personal.p_neta;
            $scope.sum_rpf = dataMedical[0].personal.rpf;
            $scope.sum_derecho = dataMedical[0].personal.derecho;
            $scope.sum_iva = dataMedical[0].personal.iva;
            $scope.sum_total = dataMedical[0].personal.p_total;
            $scope.sum_comision = dataMedical[0].personal.comision;

            $scope.beneficiaries_medical.forEach(function (beneficiarie) {
              if (beneficiarie.familia == item.FAMILIA) {
                beneficiarie.sex = item.SEXO;
                beneficiarie.contributory = $scope.contributory
                  ? $scope.contributory
                  : false;
                beneficiarie.rfc_cve = item.RFC_CVE ? item.RFC_CVE : "";
                beneficiarie.rfc_homocve = item.RFC_HOMOCVE
                  ? item.RFC_HOMOCVE
                  : "";
                beneficiarie.dom_callenum = item.DOM_CALLE_NUM
                  ? item.DOM_CALLE_NUM
                  : "";
                beneficiarie.dom_colonia = item.DOM_COLONIA
                  ? item.DOM_COLONIA
                  : "";
                beneficiarie.dom_cp = item.DOM_CP ? item.DOM_CP : "";
                beneficiarie.dom_poblacion = item.DOM_POBLACION
                  ? item.DOM_POBLACION
                  : "";
                beneficiarie.dom_estado = item.DOM_ESTADO
                  ? item.DOM_ESTADO
                  : "";
                dataMedical[0].relationship_accident.push(beneficiarie);
                $scope.sum_neta = parseFloat(
                  parseFloat($scope.sum_neta) + parseFloat(beneficiarie.p_neta)
                ).toFixed(2);
                $scope.sum_rpf = parseFloat(
                  parseFloat($scope.sum_rpf) + parseFloat(beneficiarie.rpf)
                ).toFixed(2);
                $scope.sum_derecho = parseFloat(
                  parseFloat($scope.sum_derecho) +
                    parseFloat(beneficiarie.derecho)
                ).toFixed(2);
                $scope.sum_iva = parseFloat(
                  parseFloat($scope.sum_iva) + parseFloat(beneficiarie.iva)
                ).toFixed(2);
                $scope.sum_total = parseFloat(
                  parseFloat($scope.sum_total) +
                    parseFloat(beneficiarie.p_total)
                ).toFixed(2);
                $scope.sum_comision = parseFloat(
                  parseFloat($scope.sum_comision) +
                    parseFloat(beneficiarie.comision)
                ).toFixed(2);
              }
            });

            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            if (item.SUBGRUPO) {
              $scope.dataSubgroup.forEach(function (itemSubgrupo) {
                if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                  if (itemSubgrupo.address) {
                    contractor_certificate = itemSubgrupo.contractor
                      ? itemSubgrupo.contractor.id
                      : null;
                  } else {
                    contractor_certificate = $scope.dataCaratula.contractor
                      ? $scope.dataCaratula.contractor
                      : null;
                  }
                }
              });
            } else {
              contractor_certificate = $scope.dataCaratula.contractor
                ? $scope.dataCaratula.contractor
                : null;
            }

            var certificateData = {
              caratula: $scope.dataCaratula.id,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number:
                $scope.dataCaratula.poliza_number +
                " - INC. " +
                item.CERTIFICADO,
              contractor: contractor_certificate,
              ramo: $scope.dataCaratula.ramo.id,
              subramo: $scope.dataCaratula.subramo.id,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: toDate(item.VIGENCIA_INICIO),
              end_of_validity: toDate(item.VIGENCIA_FIN),
              status: $scope.dataCaratula.status == "Vigente" ? 14 : 1,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: dataMedical,
              life_policy: [],
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "GASTOS_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: $scope.sum_neta
                ? parseFloat($scope.sum_neta).toFixed(2)
                : item.PRIMA_NETA
                ? parseFloat(item.PRIMA_NETA).toFixed(2)
                : 0,
              rpf: $scope.sum_rpf
                ? parseFloat($scope.sum_rpf).toFixed(2)
                : item.RPF
                ? parseFloat(item.RPF).toFixed(2)
                : 0,
              derecho: $scope.sum_derecho
                ? parseFloat($scope.sum_derecho).toFixed(2)
                : item.DERECHO
                ? parseFloat(item.DERECHO).toFixed(2)
                : 0,
              iva: $scope.sum_iva
                ? parseFloat($scope.sum_iva).toFixed(2)
                : item.IVA
                ? parseFloat(item.IVA).toFixed(2)
                : 0,
              p_total: $scope.sum_total
                ? parseFloat($scope.sum_total).toFixed(2)
                : item.PRIMA_TOTAL
                ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                : 0,
              comision: $scope.sum_comision
                ? parseFloat($scope.sum_comision).toFixed(2)
                : item.COMISION
                ? parseFloat(item.COMISION).toFixed(2)
                : 0,
              rec_antiguedad: toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
              contributory: $scope.contributory,
            };
            $scope.certifcados.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.FLOTILLA) {
        $scope.selectedCertificates.FLOTILLA.forEach(function (item) {
          var dataCar = [
            {
              car_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              driver: item.CONDUCTOR ? item.CONDUCTOR : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              brand: item.MARCA,
              model: item.MODELO,
              year: item.AÑO,
              version: item.VERSION,
              serial: item.SERIE,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              license_plates: item.MATRICULA ? item.MATRICULA : null,
              usage: parseInt(item.USO),
              service: item.SERVICIO,
              procedencia: parseInt(item.PROCEDENCIA),
              sum_insured: item.VALOR_O_SUMA_ASEGURADA
                ? item.VALOR_O_SUMA_ASEGURADA
                : null,
              charge_type: item.TIPO_CARGA ? parseInt(item.TIPO_CARGA) : null,
              adjustment: item.ADAPTACIONES ? item.ADAPTACIONES : null,
              mont_adjustment: item.MONTO_ADAPTACIONES
                ? item.MONTO_ADAPTACIONES
                : null,
              special_team: item.EQUIPAMIENTO ? item.EQUIPAMIENTO : null,
              mont_special_team: item.MONTO_EQUIPAMIENTO
                ? item.MONTO_EQUIPAMIENTO
                : null,
              beneficiary_name: null,
              preferential_benefiaciary: item.BENEFICIARIO_PREFERENTE
                ? item.BENEFICIARIO_PREFERENTE
                : null,
              beneficiary_rfc: item.BENEFICIARIO_RFC
                ? item.BENEFICIARIO_RFC
                : null,
              beneficiary_address: item.BENEFICIARIO_DIRECCION
                ? item.BENEFICIARIO_DIRECCION
                : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.dataSubgroup.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.dataCaratula.contractor
                    ? $scope.dataCaratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.dataCaratula.contractor
              ? $scope.dataCaratula.contractor
              : null;
          }

          var certificateData = {
            caratula: $scope.dataCaratula.id,
            certificate_number: item.INCISO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number:
              $scope.dataCaratula.poliza_number + " - INC. " + item.INCISO,
            contractor: contractor_certificate,
            ramo: $scope.dataCaratula.ramo.id,
            subramo: $scope.dataCaratula.subramo.id,
            paquete: item.PAQUETE,
            observations: "",
            old_policies: [],
            start_of_validity: toDate(item.VIGENCIA_INICIO),
            end_of_validity: toDate(item.VIGENCIA_FIN),
            status: $scope.dataCaratula.status == "Vigente" ? 14 : 1,
            automobiles_policy: dataCar,
            damages_policy: [],
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA
              ? parseFloat(item.PRIMA_NETA).toFixed(2)
              : 0,
            rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
            derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
            iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
            p_total: item.PRIMA_TOTAL
              ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
              : 0,
            comision: item.COMISION ? parseFloat(item.COMISION).toFixed(2) : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      } else if (
        $scope.selectedCertificates.DANIOS_DIVERSO ||
        $scope.selectedCertificates.DANIOS_IRC
      ) {
        var excelJson = [];
        if ($scope.selectedCertificates.DANIOS_DIVERSO) {
          excelJson = $scope.selectedCertificates.DANIOS_DIVERSO;
        } else if ($scope.selectedCertificates.DANIOS_IRC) {
          excelJson = $scope.selectedCertificates.DANIOS_IRC;
        }
        excelJson.forEach(function (item) {
          var dataDamage = [
            {
              dam_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              item_details: item.OBSERVACIONES,
              usage: item.USO ? parseInt(item.USO) : 0,
              brand: item.MARCA ? item.MARCA : null,
              model: item.MODELO ? item.MODELO : null,
              construction_year: item.AÑO_CONSTRUCCION
                ? item.AÑO_CONSTRUCCION
                : null,
              reconstruction_year: item.AÑO_RECONSTRUCCION
                ? item.AÑO_RECONSTRUCCION
                : null,
              version: item.VERSION ? item.VERSION : null,
              serial: item.SERIE ? item.SERIE : null,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              matricula: item.MATRICULA ? item.MATRICULA : null,
              permiso: item.PERMISO ? item.PERMISO : null,
              purchase_value: item.VALOR_COMPRA
                ? parseInt(item.VALOR_COMPRA)
                : 0,
              item_address:
                item.CALLE +
                " " +
                item.NO_INTERIOR +
                " Ext." +
                item.NO_EXTERIOR +
                " " +
                item.COLONIA +
                " " +
                item.CIUDAD +
                " " +
                item.ESTADO +
                " C.P." +
                item.CP,
              sucursal: item.SUCURSAL ? item.SUCURSAL : null,
              giro: item.GIRO ? item.GIRO : null,
              type_construction: item.TIPO_CONSTRUCTIVO
                ? parseInt(item.TIPO_CONSTRUCTIVO)
                : 0,
              no_levels: item.NO_NIVELES ? item.NO_NIVELES : null,
              fhm_zone: item.ZONA_FHM ? item.ZONA_FHM : null,
              tyev_zone: item.ZONA_TYEV ? item.ZONA_TYEV : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.dataSubgroup.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.dataCaratula.contractor
                    ? $scope.dataCaratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.dataCaratula.contractor
              ? $scope.dataCaratula.contractor
              : null;
          }

          var certificateData = {
            caratula: $scope.dataCaratula.id,
            certificate_number: item.INCISO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number:
              $scope.dataCaratula.poliza_number + " - INC. " + item.INCISO,
            contractor: contractor_certificate,
            ramo: $scope.dataCaratula.ramo.id,
            subramo: $scope.dataCaratula.subramo.id,
            paquete: item.PAQUETE,
            observations: "",
            old_policies: [],
            start_of_validity: toDate(item.VIGENCIA_INICIO),
            end_of_validity: toDate(item.VIGENCIA_FIN),
            status: $scope.dataCaratula.status == "Vigente" ? 14 : 1,
            automobiles_policy: [],
            damages_policy: dataDamage,
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA
              ? parseFloat(item.PRIMA_NETA).toFixed(2)
              : 0,
            rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
            derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
            iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
            p_total: item.PRIMA_TOTAL
              ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
              : 0,
            comision: item.COMISION ? parseFloat(item.COMISION).toFixed(2) : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      }

      $http({
        method: "POST",
        url: url.IP + "mass-certificates/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          l.stop();
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal("¡Hecho!", MESSAGES.OK.CERTIFICATESDONE, "success");
            $state.go("colectividades.info", {
              polizaId: $scope.dataCaratula.id,
            });
          } else {
            $scope.loader = false;
            SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORCERTIFICATES, "error");
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
  }
})();

function agregarOnChange(elem) {
  $(elem)
    .find("#nvo")
    .parent()
    .parent()
    .append(
      '<button onClick="closeOT()" class="btn btn-block btn-outline btn-success">Crear Contratante</button>'
    );
  $(elem).find("#nvo").parent().remove();
}

function closeOT() {
  $("#closeOT").click();
  $("#createCont").click();
}

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("CertificadosPlantillasCtrl", CertificadosPlantillasCtrl);

  CertificadosPlantillasCtrl.$inject = [
    "$timeout",
    "$scope",
    "$sce",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "$sessionStorage",
    "$uibModal",
    "textAngularManager",
    "FileUploader",
    "$rootScope",
  ];

  function CertificadosPlantillasCtrl(
    $timeout,
    $scope,
    $sce,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    $sessionStorage,
    $uibModal,
    textAngularManager,
    FileUploader,
    $rootScope
  ) {
    var vm = this;
    $scope.showQuotation = false;
    $scope.showInfoQuotation = false;
    $scope.showEditInformation = false;
    $scope.plantilla = {};
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.configuracionGlobal = {
      fecha_limite_email: false,
    };
    $(".js-example-basic-multiple").select2();
    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    $scope.allRamos = [];
    $scope.allRamos = [
      {
        code: 1,
        descr: "Vida",
      },
      {
        code: 2,
        descr: "Accidentes y Enfermedades",
      },
      {
        code: 3,
        descr: "Daños",
      },
      {
        code: 9,
        descr: "Daños/Automóviles",
      },
    ];
    $scope.createQuotation = function () {
      $scope.campos = [
        {
          id: "dato_cnumcertificado",
          label: "Número de Certificado",
          key: "numcertificado",
        },
        { id: "dato_ccontratante", label: "Contratante", key: "contratante" },
        { id: "dato_cvigencia", label: "Vigencia", key: "vigencia" },
        { id: "dato_caseguradora", label: "Aseguradora", key: "compania" },
        { id: "dato_csubramo", label: "Subramo", key: "subramo" },
        { id: "dato_cmoneda", label: "Moneda", key: "moneda" },
        {
          id: "dato_cfrecuenciapago",
          label: "Frecuencia de Pago",
          key: "frecuenciapago",
        },
        { id: "dato_casegurado", label: "Asegurado", key: "asegurado" },
        {
          id: "dato_cptotal",
          label: "Prima Total del Certificado",
          key: "total",
        },
        {
          id: "dato_cpneta",
          label: "Prima Neta del Certificado",
          key: "pneta",
        },
        {
          id: "dato_cderecho",
          label: "Derecho del Certificado",
          key: "derecho",
        },
        { id: "dato_crpf", label: "RPF del Certificado", key: "rpf" },
        { id: "dato_civ", label: "IVA del Certificado", key: "iva" },
      ];

      $scope.plantilla = $scope.plantilla || {};
      $scope.plantilla.name = $scope.plantilla.name || "";

      // Default TRUE (sin pisar lo que ya venga cargado)
      $scope.campos.forEach(function (c) {
        if (
          $scope.plantilla[c.id] === undefined ||
          $scope.plantilla[c.id] === null
        ) {
          $scope.plantilla[c.id] = true;
        }
      });
      $scope.showEditInformation = false;
      $scope.showQuotation = true;
      $scope.plantilla.subject_default = false;
    };
    $scope.subject_default = false;
    $scope.closeTemplate = function () {
      $scope.showQuotation = false;
      $scope.plantilla = {};
    };
    $scope.isReadOnly = true;
    activate();

    $scope.cambiarCampos = function () {
      $scope.configuracionGlobal = {};
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
        }
      });
      $scope.configurar = !$scope.configurar;
    };
    $scope.cambiarDato = function (dato, valor) {
      var data = {};
      data[dato.toString()] = valor;
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, data)
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory.post("orginfo/", data).then(function success(response) {
            if (response.status == 201) {
              $scope.configuracionGlobal = response.data;
              SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
              return;
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
            } else {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            }
          });
        }
      }
    };
    function activate() {
      dataFactory
        .get("emailtemplate/", { template_model: 5 })
        .then(function success(response) {
          vm.quotations = response.data.results;
          vm.config_pagination = response.data;
          $scope.show_pagination = true;
        });
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
        }
      });
    }

    $scope.selectProv = function (sel) {
      $scope.ramos_code = [];
      $scope.plantilla.ramo_code.forEach(function (cl) {
        $scope.ramos_code.push(parseInt(cl.code));
      });
    };

    $scope.showInformation = function (item) {
      if (item) {
        $scope.showInfoQuotation = !$scope.showInfoQuotation;
        $scope.quotation = item;
      } else {
        $scope.showInfoQuotation = !$scope.showInfoQuotation;
      }
    };

    $scope.savePlantilla = function (form) {
      form.template_model = 5;
      form.ramo_code = $scope.ramos_code;
      dataFactory.post("emailtemplate/", form).then(function success(response) {
        SweetAlert.swal(
          "¡Listo!",
          "Plantilla guardada correctamente.",
          "success"
        );
        $scope.closeTemplate();
        activate();
      });
    };
    $scope.cahngeFechaLimiteEmail = function (val) {
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, {
              fecha_limite_email: $scope.configuracionGlobal.fecha_limite_email,
            })
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory
            .post("orginfo/", {
              fecha_limite_email: $scope.configuracionGlobal.fecha_limite_email,
            })
            .then(function success(response) {
              if (response.status == 201) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
      }
    };
    $scope.updateDelivery = function (form) {
      var data = {
        name: form.name,
        title: form.title,
        text: form.text,
        bottom_text: form.bottom_text,
        subject_default: form.subject_default,
        ramo_code: $scope.ramos_code,
      };
      $http.patch(form.url, data).then(function success(response) {
        $scope.showEditInformation = false;
        SweetAlert.swal(
          "¡Listo!",
          "Plantilla actualizada correctamente.",
          "success"
        );
        $scope.closeTemplate();
        activate();
      });
    };

    $scope.editQuatation = function (form) {
      $scope.plantilla = form || {};
      $scope.plantilla.name = form.name || "";
      $scope.ramos_code = [];
      $scope.campos = [
        {
          id: "dato_cnumcertificado",
          label: "Número de Certificado",
          key: "numcertificado",
        },
        { id: "dato_ccontratante", label: "Contratante", key: "contratante" },
        { id: "dato_cvigencia", label: "Vigencia", key: "vigencia" },
        { id: "dato_caseguradora", label: "Aseguradora", key: "compania" },
        { id: "dato_csubramo", label: "Subramo", key: "subramo" },
        { id: "dato_cmoneda", label: "Moneda", key: "moneda" },
        {
          id: "dato_cfrecuenciapago",
          label: "Frecuencia de Pago",
          key: "frecuenciapago",
        },
        { id: "dato_casegurado", label: "Asegurado", key: "asegurado" },
        {
          id: "dato_cptotal",
          label: "Prima Total del Certificado",
          key: "total",
        },
        {
          id: "dato_cpneta",
          label: "Prima Neta del Certificado",
          key: "pneta",
        },
        {
          id: "dato_cderecho",
          label: "Derecho del Certificado",
          key: "derecho",
        },
        { id: "dato_crpf", label: "RPF del Certificado", key: "rpf" },
        { id: "dato_civ", label: "IVA del Certificado", key: "iva" },
      ];

      // Default TRUE (sin pisar lo que ya venga cargado)
      $scope.campos.forEach(function (c) {
        if (
          $scope.plantilla[c.id] === undefined ||
          $scope.plantilla[c.id] === null
        ) {
          $scope.plantilla[c.id] = true;
        }
      });

      $scope.plantilla.name = form.name;
      $scope.plantilla.title = form.title;
      $scope.plantilla.text = form.text;
      $scope.plantilla.bottom_text = form.bottom_text;
      $scope.plantilla.url = form.url;
      // $scope.plantilla.ramo_code= [];
      $scope.plantilla.subject_default = form.subject_default;
      $scope.showQuotation = true;
      $scope.showEditInformation = true;
      if (form.ramo_code) {
        var convertedCodes = form.ramo_code.map(function (code) {
          return parseInt(code);
        });
        // $scope.plantilla.ramo_code = form.ramo_code;
        convertedCodes.forEach(function (cl) {
          $scope.ramos_code.push(parseInt(cl));
          $scope.allRamos.forEach(function (cd) {
            if (parseInt(cd.code) == cl) {
              $scope.plantilla.ramo_code.push(cd);
            }
          });
        });
        $timeout(function () {
          $("#ramoSelect").select2();
        }, 10);
      }
    };
    $scope.$watch("plantilla.ramo_code", function (newValues, oldValues) {
      if (newValues !== oldValues) {
        $timeout(function () {
          $("#ramoSelect").trigger("change");
        }, 0);
      }
    });
    $scope.focusEditor = function () {
      $scope.editor_focus = true;
    };

    $scope.unfocusEditor = function () {};

    $scope.getFile = function () {
      var editor = textAngularManager.retrieveEditor("myEditorCreate").scope;
      editor.displayElements.text.trigger("focus");

      var modalInstance = $uibModal.open({
        template:
          '<label class="col-xs-12 btn btn-info">Agregar Imagen desde PC' +
          '<input multiple nv-file-select="" type="file" name="xyz" uploader="uploader" accept=".jpg" class="display-none"/>' +
          "</label>",
        // size: 'sm',
        controller: ModalInstanceFileCtrl,
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (imgUrl) {
        var imageLink;
        imageLink = $rootScope.image_url;
        var embed = '<img src="' + imageLink + ' ">';
        // return textAngular.$editor().wrapSelection('insertHTML', embed, true);

        var editor = textAngularManager.retrieveEditor("myEditorCreate");
        editor.scope.wrapSelection("insertHTML", embed, true);
      });
    };
    function ModalInstanceFileCtrl($scope, $rootScope, $uibModalInstance) {
      $scope.userInfo = {
        id: 0,
      };
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        allowedFileType: ["png", "jpg", "jpeg"],
      }));

      $scope.userInfo.url = $scope.uploader.url = url.IP + "plantillas-html/";
      $scope.uploader.autoUpload = true;
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $rootScope.image_url = response.arch;
        if ($uibModalInstance) {
          $uibModalInstance.close();
        }
      };
      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };
      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });
      };
      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = usr.org;
      };
      $scope.validateFiles = function () {
        var input = document.getElementById("fileInput");
        var files = input.files;
        var totalSize = 0;
        var errorMessageElement = document.getElementById("error-message");
        for (var i = 0; i < files.length; i++) {
          totalSize += files[i].size;
        }
        var totalSizeMB = totalSize / (1024 * 1024);
        if (totalSizeMB > 25) {
          errorMessageElement.style.display = "block";
          errorMessageElement.textContent =
            "La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.";
        } else {
          errorMessageElement.style.display = "none"; // Hide error message if files are valid
        }
      };
      function uploadFiles() {
        $scope.userInfo.url = $scope.uploader.url = url.IP + "plantillas-html/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("NotaCreditoCtrl", NotaCreditoCtrl);

  NotaCreditoCtrl.$inject = [
    "$sce",
    "$state",
    "dataFactory",
    "url",
    "$http",
    "$localStorage",
    "SweetAlert",
    "$scope",
    "statusPayform",
    "curr_rate_options",
    "$uibModalInstance",
    "helpers",
    "receipt",
    "statusReceipt",
    "receiptService",
    "toaster",
    "from",
    "MESSAGES",
    "$sessionStorage",
    "FileUploader",
    "fileService",
    "$rootScope",
    "insurance",
    "emailService",
  ];

  function NotaCreditoCtrl(
    $sce,
    $state,
    dataFactory,
    url,
    $http,
    $localStorage,
    SweetAlert,
    $scope,
    statusPayform,
    curr_rate_options,
    $uibModalInstance,
    helpers,
    receipt,
    statusReceipt,
    receiptService,
    toaster,
    from,
    MESSAGES,
    $sessionStorage,
    FileUploader,
    fileService,
    $rootScope,
    insurance,
    emailService
  ) {
    var vm = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    receipt.payDate = convertDate(new Date());

    $scope.data_note = [];

    $scope.notascredito = [
      { value: 1, label: "Transferencia" },
      { value: 2, label: "Cheque" },
      { value: 3, label: "Aplicada" },
    ];

    $scope.statusReceipt = [
      { label: "LIQUIDAR", value: 3 },
      { label: "APLICAR", value: 2 },
    ];
    $scope.archivos = {};
    $scope.archivos = {
      headers: ["Archivo", "Tamaño", "Progreso", "Opciones", "Documento"],
    };

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    /** Uploader files **/
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        toaster.success("Se ha aplicado la nota de crédito");
        $scope.cancel();

        var params = {
          model: 19,
          event: "POST",
          associated_id: $scope.data_note.id,
          identifier: "aplicó la nota de crédito y se adjuntó archivo(s)",
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    vm.uploadFiles = uploadFiles;
    function uploadFiles(reciboId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "notas/" + reciboId + "/archivos/";
      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");

      return date;
    }

    activate();

    function activate() {
      $scope.insurance = insurance;
      $scope.receipt = receipt;

      if (!$scope.contractor) {
        $scope.contractor = receipt.policy.natural
          ? receipt.policy.natural
          : receipt.policy.juridical;
      }
      dataFactory
        .get("notas/" + $scope.receipt.id + "/archivos/")
        .then(function success(response) {
          $scope.files = response.data.results;
        });

      $scope.view_cartas = true;
      // dataFactory.get('has-view-cartas-permission')
      // .then(function(req) {
      //     if(req.status == 200) {
      //         $scope.view_cartas = req.data;
      //     }
      // });

      // dataFactory.get('has-add-emails-permission')
      //   .then(function(req) {
      //     if(true) {
      //       $scope.add_emails = req.data;
      //     }
      //   });
    }

    $scope.goToPolicy = function (poliza) {
      if (poliza.policy.document_type == 1) {
        $state.go("polizas.info", { polizaId: poliza.policy.id });
      } else if (poliza.policy.document_type == 3) {
        $state.go("colectividades.info", { polizaId: poliza.policy.id });
      }
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };

    $scope.goToEndorsement = function (notaCred) {
      $state.go("endorsement.info", { endosoId: notaCred.endorsement.id });

      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        if (from) {
          $uibModalInstance.close(5);
        } else {
          $uibModalInstance.dismiss("cancel");
        }
      }
    };

    $scope.deleteFile = function (file, files) {
      fileService.deleteFile(file, files);
    };

    $scope.changeNotaStatus = function (receipt) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      receipt.pay_date = receipt.payDate ? toDate(receipt.payDate) : null;
      receipt.status = receipt.status.value;
      $http({
        method: "POST",
        url: url.IP + "apply-nota/",
        data: receipt,
      }).then(function success(response) {
        $scope.data_note = receipt;
        if (response.status == 200 || response.status === 201) {
          $scope.userInfo = {
            id: receipt.id,
          };
          dataFactory
            .get("polizas/" + receipt.policy.id)
            .then(function success(response) {
              $scope.policy = response.data;
              // Send Email
              // if ($scope.policy.natural){
              //     $http.get($scope.policy.natural)
              //       .then(function(response) {
              //         if(response.data.email){
              //             //Send Email
              //             if($localStorage.email_config){
              //                 if($localStorage.email_config.apply_nota == true){
              //                   $scope.idNota = receipt.id;
              //                   var model = 8;
              //                   emailService.sendEmailAtm(model,$scope.idNota)
              //                 }
              //             }
              //             //Send Email
              //         }
              //     });
              // }else if ($scope.policy.juridical){
              //     $http.get($scope.policy.juridical)
              //       .then(function(response) {
              //         if(response.data.email){
              //             //Send Email
              //             if($localStorage.email_config){
              //                 if($localStorage.email_config.apply_nota == true){
              //                   $scope.idNota = receipt.id;
              //                   var model = 8;
              //                   emailService.sendEmailAtm(model,$scope.idNota)
              //                 }
              //             }
              //             //Send Email
              //         }
              //     });
              // }
            });
          $scope.userInfo.url = $scope.uploader.url =
            url.IP + "notas/" + receipt.id + "/archivos/";
          $scope.uploader.uploadAll();
          SweetAlert.swal(
            "¡Listo!",
            "Se ha aplicado la nota de crédito",
            "success"
          );
          $scope.cancel();

          if ($scope.countFile > 0) {
            $scope.userInfo.url = $scope.uploader.url =
              url.IP + "notas/" + receipt.id + "/archivos/";
            $scope.uploader.uploadAll();
          } else {
            toaster.success("Se ha aplicado la nota de crédito");
            $scope.cancel();

            var params = {
              model: 19,
              event: "POST",
              associated_id: receipt.id,
              identifier: "aplicó la nota de crédito",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          }
        } else {
          l.stop();
        }
      });
    };

    function toDate(dateStr) {
      var dateString = dateStr;
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("LogCtrl", LogCtrl);

  LogCtrl.$inject = [
    "log",
    "$sce",
    "$state",
    "dataFactory",
    "url",
    "$http",
    "$localStorage",
    "SweetAlert",
    "$scope",
    "statusPayform",
    "curr_rate_options",
    "$uibModalInstance",
    "helpers",
    "statusReceipt",
    "receiptService",
    "toaster",
    "MESSAGES",
    "$sessionStorage",
    "FileUploader",
    "fileService",
  ];

  function LogCtrl(
    log,
    $sce,
    $state,
    dataFactory,
    url,
    $http,
    $localStorage,
    SweetAlert,
    $scope,
    statusPayform,
    curr_rate_options,
    $uibModalInstance,
    helpers,
    statusReceipt,
    receiptService,
    toaster,
    MESSAGES,
    $sessionStorage,
    FileUploader,
    fileService
  ) {
    var vm = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var show = false;

    /** Uploader files **/
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        toaster.success("Se ha aplicado la nota de crédito");
        $scope.cancel();

        var params = {
          model: 19,
          event: "POST",
          associated_id: $scope.data_note.id,
          identifier: "aplicó la nota de crédito y se adjuntó archivo(s).",
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    vm.uploadFiles = uploadFiles;
    function uploadFiles(reciboId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "notas/" + reciboId + "/archivos/";
      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    activate();

    function activate() {
      $scope.logs = log;
    }

    $scope.show_mail = function (id) {
      $scope.show = true;
      $http.get(url.IP + "log-email/" + id + "/" + 0).then(function (response) {
        if (response.status == 200) {
          $scope.mail = response.data;
        }
      });
    };
    $scope.hide_mail = function () {
      $scope.show = false;
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss("cancel");
    };

    $scope.deleteFile = function (file, files) {
      fileService.deleteFile(file, files);
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("EmailDetailCtrl", EmailDetailCtrl);

  EmailDetailCtrl.$inject = [
    "mail",
    "$sce",
    "$state",
    "dataFactory",
    "url",
    "$http",
    "$localStorage",
    "SweetAlert",
    "$scope",
    "statusPayform",
    "curr_rate_options",
    "$uibModalInstance",
    "helpers",
    "statusReceipt",
    "receiptService",
    "toaster",
    "MESSAGES",
    "$sessionStorage",
    "FileUploader",
    "fileService",
  ];

  function EmailDetailCtrl(
    mail,
    $sce,
    $state,
    dataFactory,
    url,
    $http,
    $localStorage,
    SweetAlert,
    $scope,
    statusPayform,
    curr_rate_options,
    $uibModalInstance,
    helpers,
    statusReceipt,
    receiptService,
    toaster,
    MESSAGES,
    $sessionStorage,
    FileUploader,
    fileService
  ) {
    var vm = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var show = false;

    /** Uploader files **/
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        toaster.success("Se ha aplicado la nota de crédito");
        $scope.cancel();

        var params = {
          model: 19,
          event: "POST",
          associated_id: $scope.data_note.id,
          identifier: "aplicó la nota de crédito y se adjuntó archivo(s).",
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    vm.uploadFiles = uploadFiles;
    function uploadFiles(reciboId) {
      $scope.userInfo = {
        id: endorsementId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "notas/" + reciboId + "/archivos/";
      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    activate();

    function activate() {
      $scope.mail = mail;
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss("cancel");
    };

    $scope.deleteFile = function (file, files) {
      fileService.deleteFile(file, files);
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("InfoChangeCtrl", InfoChangeCtrl);

  InfoChangeCtrl.$inject = [
    "endoso",
    "formatValues",
    "$scope",
    "$uibModalInstance",
    "$http",
  ];

  function InfoChangeCtrl(
    endoso,
    formatValues,
    $scope,
    $uibModalInstance,
    $http
  ) {
    $scope.vm = this;

    var None = "";
    var True = true;
    var False = false;
    $scope.changeC = false;
    $scope.coberturas = [2, 3, 5, 19, 12, 13, 14, 21];
    $scope.asegurado = [4, 20, 8, 15, 22];

    activate();

    function activate() {
      $scope.vm.endoso = endoso;
      try {
        var json = JSON.stringify(eval("(" + endoso.original + ")"));
        $scope.vm.original = JSON.parse(json);
        var json = JSON.stringify(eval("(" + endoso.change + ")"));
        $scope.vm.change = JSON.parse(json);
      } catch (e) {
        $scope.vm.original = {};
        $scope.vm.change = {};
      }
      if (endoso.concept == 35 || endoso.concept == 24) {
        $scope.changeC = true;
      }

      if (endoso.concept == 1 || endoso.concept == 11) {
        $scope.cfp = true;
      } else if (endoso.concept == 16 || endoso.concept == 17) {
        $scope.cancelacion = true;
      } else if ($scope.coberturas.indexOf(endoso.concept) >= 0) {
        $scope.coberturas = true;
        if (endoso.concept == 13) {
          $scope.coberturas_baja = true;
        }
      } else if ($scope.asegurado.indexOf(endoso.concept) >= 0) {
        $scope.cfp = false;
        $scope.coberturas = false;
        $scope.coberturas_baja = false;
        $scope.aseguradotype = true;
      } else {
        $scope.otros = true;
      }
    }

    $scope.formatCoverage = function (parValue) {
      if (parValue) {
        var res = parValue.replace("$", "");
        if (res) {
          var model = formatValues.currency(res);
          return model;
        } else {
          return "";
        }
      }
    };

    $scope.concept = function (parConcept) {
      switch (parConcept) {
        case 1:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 2:
          return "CAMBIO DE SUMA ASEGURADA";
          break;
        case 3:
          return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
          break;
        case 4:
          return "AGREGAR ASEGURADO";
          break;
        case 5:
          return "AGREGAR COBERTURAS";
          break;
        case 6:
          return "DECLARACIÓN MENSUAL";
          break;
        case 8:
          return "CAMBIO DATOS FISCALES";
          break;
        case 9:
          return "ESPECIFICACIONES";
          break;
        case 11:
          return "CAMBIO DE FORMA DE PAGO";
          break;
        case 12:
          return "DISMINUCIÓN EN LA SUMA ASEGURADA";
          break;
        case 13:
          return "BAJA DE COBERTURA";
          break;
        case 14:
          return "CAMBIO DE DEDUCIBLE Y/O COASEGURO";
          break;
        case 15:
          return "BAJA DE ASEGURADO";
          break;
        case 16:
          return "CANCELACIÓN DE PÓLIZA POR PETICIÓN";
          break;
        case 17:
          return "CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO";
          break;
        case 23:
          return "ANTIGÜEDAD RECONOCIDA";
          break;
        case 24:
          return "ALTA DE ASEGURADOS";
          break;
        case 23:
          return "BAJA DE ASEGURADOS";
          break;
        case 35:
          return "CAMBIO DE CERTIFICADO";
          break;
        default:
          return "OTRO";
      }
    };

    $scope.payform = function (parPayform) {
      switch (parPayform) {
        case 1:
          return "Mensual";
          break;
        case 2:
          return "Bimestral";
          break;
        case 3:
          return "Trimestral";
          break;
        case 4:
          return "Cuatrimestral";
          break;
        case 5:
          return "Contado";
          break;
        case 6:
          return "Semestral";
          break;
        case 12:
          return "Anual";
          break;
        case 24:
          return "Quincenal";
          break;
        default:
          return "No especificada";
      }
    };

    $scope.status = function (parValue) {
      switch (parValue) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        default:
          return "Pendiente";
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss("cancel");
    };
  }
})();

function removeByValue(list, value) {
  var idx = list.findIndex(function (x) {
    return x.value === value;
  });
  if (idx >= 0) list.splice(idx, 1);
}

function ensureOption(list, opt) {
  var exists = list.some(function (x) {
    return x.value === opt.value;
  });
  if (!exists) list.push(opt);
}

function keepOnlyValues(list, allowedValues) {
  // deja solo los que estén en allowedValues
  for (var i = list.length - 1; i >= 0; i--) {
    if (allowedValues.indexOf(list[i].value) === -1) {
      list.splice(i, 1);
    }
  }
}

(function () {
  "use strict";

  angular.module("inspinia").controller("CertificateCtrl", CertificateCtrl);

  CertificateCtrl.$inject = [
    "caratula",
    "certificates",
    "poliza_number",
    "$sce",
    "$state",
    "dataFactory",
    "url",
    "$http",
    "$localStorage",
    "SweetAlert",
    "$scope",
    "statusPayform",
    "curr_rate_options",
    "$uibModalInstance",
    "helpers",
    "statusReceipt",
    "receiptService",
    "toaster",
    "MESSAGES",
    "$sessionStorage",
    "FileUploader",
    "fileService",
  ];

  function CertificateCtrl(
    caratula,
    certificates,
    poliza_number,
    $sce,
    $state,
    dataFactory,
    url,
    $http,
    $localStorage,
    SweetAlert,
    $scope,
    statusPayform,
    curr_rate_options,
    $uibModalInstance,
    helpers,
    statusReceipt,
    receiptService,
    toaster,
    MESSAGES,
    $sessionStorage,
    FileUploader,
    fileService
  ) {
    var vm = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    /** Uploader files **/
    $scope.userInfo = {
      id: 0,
    };

    $scope.exportData = function (cert) {
      $scope.filtros = {
        id_caratula: caratula.id,
      };
      $http({
        method: "POST",
        // url: url.IP + 'reporte-certificates-flotilla/',
        url: url.IP + "service_reporte-certificateFlotilla-excel",
        data: $scope.filtros,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function success(request) {
          if (request.status === 200) {
            var blob = new Blob([request.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Flotilla.xls");
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    activate();

    function activate() {
      $scope.certificates = certificates.results;
      $scope.number = poliza_number;
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss("cancel");
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "CobranzasPlantillasWhatsappCtrl",
      CobranzasPlantillasWhatsappCtrl
    );

  CobranzasPlantillasWhatsappCtrl.$inject = [
    "$scope",
    "$parse",
    "$sce",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "PersistenceFactory",
    "$sessionStorage",
  ];

  function CobranzasPlantillasWhatsappCtrl(
    $scope,
    $parse,
    $sce,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    PersistenceFactory,
    $sessionStorage
  ) {
    $scope.showPlantilla = false;
    $scope.showInfoPlantilla = false;
    $scope.showEditInformation = false;
    $scope.plantilla = {};
    $scope.savingPlantilla = false;

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    $scope.createQuotation = function () {
      $scope.showPlantilla = true;
      $scope.showEditInformation = false;
      $scope.plantilla = {};
    };

    $scope.closeQuotation = function () {
      $scope.showEditInformation = false;
      $scope.showPlantilla = false;
      $scope.plantilla = {};
    };
    var vm = this;
    function isBlankText(value) {
      if (!value) {
        return true;
      }
      var cleaned = value
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/g, "")
        .replace(/\s/g, "");
      return cleaned.length === 0;
    }

    activate();
    $scope.page = 1;
    function activate(page) {
      $scope.page = page ? page : 1;
      $scope.actual_page = $scope.page;
      $scope.filtros = { page: $scope.page };
      $http({
        method: "GET",
        url: url.IP + "whatsappwebtemplate/",
        data: $scope.filtros,
      }).then(function success(response) {
        vm.templatesList = response.data.results;
        vm.templates = {};
        vm.templates = {
          count: response.data.count,
          previous: response.data.previous,
          next: response.data.next,
        };
        if (vm.templates) {
          $scope.showTemplates = true;
        } else {
          $scope.showTemplates = false;
        }
        testPagination("vm.templates", "vm.templates");
      });
    }

    $scope.selectProv = function (sel) {
      $scope.aseguradoras = sel;
    };

    $scope.showInformation = function (item) {
      if (item) {
        $scope.showInfoPlantilla = !$scope.showInfoPlantilla;
        $scope.plantilla = item;
      } else {
        $scope.showInfoPlantilla = !$scope.showInfoPlantilla;
      }
    };

    $scope.saveDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (!form || !form.title || !form.text) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de continuar.",
          "warning"
        );
        return;
      }

      if (isBlankText(form.title) || isBlankText(form.text)) {
        SweetAlert.swal(
          "Error",
          "El identificador y el mensaje no pueden estar vacíos.",
          "warning"
        );
        return;
      }

      form.type_message = 2;
      $scope.savingPlantilla = true;

      dataFactory
        .post("whatsappwebtemplate/", form)
        .then(function success(response) {
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla guardada correctamente.",
            "success"
          );
          $scope.closeQuotation();
          activate(1);
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.updateDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (!form || !form.title || !form.text) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de actualizar.",
          "warning"
        );
        return;
      }

      if (isBlankText(form.title) || isBlankText(form.text)) {
        SweetAlert.swal(
          "Error",
          "El identificador y el mensaje no pueden estar vacíos.",
          "warning"
        );
        return;
      }

      $scope.savingPlantilla = true;

      var data = {
        title: form.title,
        text: form.text,
      };
      $http
        .patch(form.url, data)
        .then(function success(response) {
          $scope.showEditInformation = false;
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla actualizada correctamente.",
            "success"
          );
          $scope.closeQuotation();
          activate(1);
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.borrarPlantilla = function (item) {
      if (!item || !item.url) {
        return;
      }
      SweetAlert.swal(
        {
          title: "¿Confirmas la eliminación?",
          text: "La plantilla se eliminará permanentemente.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí, borrar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }
          $http
            .delete(item.url)
            .then(function success() {
              SweetAlert.swal(
                "¡Listo!",
                "Plantilla eliminada correctamente.",
                "success"
              );
              activate(1);
            })
            .catch(function () {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            });
        }
      );
    };

    $scope.editQuatation = function (form) {
      $scope.plantilla.title = form.title;
      $scope.plantilla.text = form.text;
      $scope.plantilla.url = form.url;
      $scope.showPlantilla = true;
      $scope.showEditInformation = true;
    };

    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        activate(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("CobranzasPlantillasSmsCtrl", CobranzasPlantillasSmsCtrl);

  CobranzasPlantillasSmsCtrl.$inject = [
    "$scope",
    "$parse",
    "$sce",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "PersistenceFactory",
    "$sessionStorage",
  ];

  function CobranzasPlantillasSmsCtrl(
    $scope,
    $parse,
    $sce,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    PersistenceFactory,
    $sessionStorage
  ) {
    $scope.showPlantilla = false;
    $scope.showInfoPlantilla = false;
    $scope.showEditInformation = false;
    $scope.plantilla = {};
    $scope.savingPlantilla = false;

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    $scope.createQuotation = function () {
      $scope.showPlantilla = true;
      $scope.showEditInformation = false;
      $scope.plantilla = {};
    };

    $scope.closeQuotation = function () {
      $scope.showEditInformation = false;
      $scope.showPlantilla = false;
      $scope.plantilla = {};
    };
    var vm = this;
    function isBlankText(value) {
      if (!value) {
        return true;
      }
      return value.toString().trim().length === 0;
    }

    activate();
    $scope.page = 1;
    function activate(page) {
      $scope.page = page ? page : 1;
      $scope.actual_page = $scope.page;
      $scope.filtros = { page: $scope.page };
      // dataFactory.get('smstemplates-list/'+'&page='+$scope.page)
      $http({
        method: "POST",
        url: url.IP + "smstemplates-list/",
        data: $scope.filtros,
      }).then(function success(response) {
        vm.templatesList = response.data.results;
        vm.templates = {};
        vm.templates = {
          count: response.data.count,
          previous: response.data.previous,
          next: response.data.next,
        };
        if (vm.templates) {
          $scope.showTemplates = true;
        } else {
          $scope.showTemplates = false;
        }
        testPagination("vm.templates", "vm.templates");
      });
    }

    $scope.selectProv = function (sel) {
      $scope.aseguradoras = sel;
    };

    $scope.showInformation = function (item) {
      if (item) {
        $scope.showInfoPlantilla = !$scope.showInfoPlantilla;
        $scope.plantilla = item;
      } else {
        $scope.showInfoPlantilla = !$scope.showInfoPlantilla;
      }
    };

    $scope.saveDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (!form || !form.title || !form.text) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de continuar.",
          "warning"
        );
        return;
      }

      if (isBlankText(form.title) || isBlankText(form.text)) {
        SweetAlert.swal(
          "Error",
          "El identificador y el mensaje no pueden estar vacíos.",
          "warning"
        );
        return;
      }

      $scope.savingPlantilla = true;
      dataFactory
        .post("smstemplate/", form)
        .then(function success(response) {
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla guardada correctamente.",
            "success"
          );
          $scope.closeQuotation();
          activate(1);
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.updateDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (!form || !form.title || !form.text) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de actualizar.",
          "warning"
        );
        return;
      }

      if (isBlankText(form.title) || isBlankText(form.text)) {
        SweetAlert.swal(
          "Error",
          "El identificador y el mensaje no pueden estar vacíos.",
          "warning"
        );
        return;
      }

      $scope.savingPlantilla = true;
      var data = {
        title: form.title,
        text: form.text,
      };
      $http
        .patch(form.url, data)
        .then(function success(response) {
          $scope.showEditInformation = false;
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla actualizada correctamente.",
            "success"
          );
          $scope.closeQuotation();
          activate(1);
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.borrarPlantilla = function (item) {
      if (!item || !item.url) {
        return;
      }
      SweetAlert.swal(
        {
          title: "¿Confirmas la eliminación?",
          text: "La plantilla se eliminará permanentemente.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí, borrar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }
          $http
            .delete(item.url)
            .then(function success() {
              SweetAlert.swal(
                "¡Listo!",
                "Plantilla eliminada correctamente.",
                "success"
              );
              activate(1);
            })
            .catch(function () {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            });
        }
      );
    };

    $scope.editQuatation = function (form) {
      $scope.plantilla.title = form.title;
      $scope.plantilla.text = form.text;
      $scope.plantilla.url = form.url;
      $scope.showPlantilla = true;
      $scope.showEditInformation = true;
    };

    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;
        activate(parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("CobranzasPlantillasCtrl", CobranzasPlantillasCtrl);

  CobranzasPlantillasCtrl.$inject = [
    "$uibModal",
    "$scope",
    "$sce",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "$sessionStorage",
    "textAngularManager",
    "FileUploader",
    "$rootScope",
  ];

  function CobranzasPlantillasCtrl(
    $uibModal,
    $scope,
    $sce,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    $sessionStorage,
    textAngularManager,
    FileUploader,
    $rootScope
  ) {
    var vm = this;
    $scope.showQuotation = false;
    $scope.showInfoQuotation = false;
    $scope.showEditInformation = false;
    $scope.plantilla = {};
    $scope.savingPlantilla = false;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;
    $scope.configurar = false;
    $scope.createQuotation = function () {
      $scope.showQuotation = true;
    };
    $scope.cambiarCampos = function () {
      $scope.configuracionGlobal = {};
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
        }
      });
      $scope.configurar = !$scope.configurar;
    };
    $scope.closeQuotation = function () {
      $scope.showQuotation = false;
      $scope.plantilla = {};
    };
    $scope.cambiarDato = function (dato, valor) {
      var data = {};
      data[dato.toString()] = valor;
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, data)
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory.post("orginfo/", data).then(function success(response) {
            if (response.status == 201) {
              $scope.configuracionGlobal = response.data;
              SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
              return;
            } else if (response.status == 403) {
              SweetAlert.swal("Error", response.data.detail, "error");
            } else {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            }
          });
        }
      }
    };
    activate();

    function activate() {
      $scope.configuracionGlobal = {};
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
        }
      });
      dataFactory
        .get("emailtemplate/", { template_model: 1 })
        .then(function success(response) {
          vm.quotations = response.data.results;
          vm.config_pagination = response.data;
          $scope.show_pagination = true;
        });
    }

    $scope.selectProv = function (sel) {
      $scope.aseguradoras = sel;
    };

    $scope.showInformation = function (item) {
      if (item) {
        $scope.showInfoQuotation = !$scope.showInfoQuotation;
        $scope.quotation = item;
      } else {
        $scope.showInfoQuotation = !$scope.showInfoQuotation;
      }
    };

    $scope.saveDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (
        !form ||
        !form.name ||
        !form.title ||
        !form.text ||
        !form.bottom_text
      ) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de continuar.",
          "warning"
        );
        return;
      }

      form.template_model = 1;
      $scope.savingPlantilla = true;

      dataFactory
        .post("emailtemplate/", form)
        .then(function success(response) {
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla guardada correctamente.",
            "success"
          );
          $scope.closeQuotation();
          activate();
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.updateDelivery = function (form) {
      if ($scope.savingPlantilla) {
        return;
      }

      if (
        !form ||
        !form.name ||
        !form.title ||
        !form.text ||
        !form.bottom_text
      ) {
        SweetAlert.swal(
          "Error",
          "Completa todos los campos obligatorios antes de actualizar.",
          "warning"
        );
        return;
      }

      $scope.savingPlantilla = true;

      var data = {
        name: form.name,
        title: form.title,
        text: form.text,
        bottom_text: form.bottom_text,
      };
      $http
        .patch(form.url, data)
        .then(function success(response) {
          SweetAlert.swal(
            "¡Listo!",
            "Plantilla actualizada correctamente.",
            "success"
          );
          $scope.closeQuotation();
          activate();
        })
        .catch(function () {
          SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
        })
        .finally(function () {
          $scope.savingPlantilla = false;
        });
    };

    $scope.borrarPlantilla = function (item) {
      if (!item || !item.url) {
        return;
      }
      SweetAlert.swal(
        {
          title: "¿Confirmas la eliminación?",
          text: "La plantilla se eliminará permanentemente.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí, borrar",
          cancelButtonText: "Cancelar",
        },
        function (isConfirm) {
          if (!isConfirm) {
            return;
          }
          $http
            .delete(item.url)
            .then(function success() {
              SweetAlert.swal(
                "¡Listo!",
                "Plantilla eliminada correctamente.",
                "success"
              );
              activate();
            })
            .catch(function () {
              SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
            });
        }
      );
    };

    $scope.changeFechaLimiteEmail = function (val) {
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, {
              fecha_limite_email_cobranza:
                $scope.configuracionGlobal.fecha_limite_email_cobranza,
            })
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory
            .post("orginfo/", {
              fecha_limite_email_cobranza:
                $scope.configuracionGlobal.fecha_limite_email_cobranza,
            })
            .then(function success(response) {
              if (response.status == 201) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
      }
    };

    $scope.changeButtonSegumovilEmail = function (val) {
      if ($scope.configuracionGlobal) {
        if ($scope.configuracionGlobal.url) {
          $http
            .patch($scope.configuracionGlobal.url, {
              boton_segumovil: $scope.configuracionGlobal.boton_segumovil,
            })
            .then(function success(response) {
              if (response.status == 200) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal(
                  "Actualizado",
                  MESSAGES.OK.SAVEDCONFIG,
                  "success"
                );
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        } else {
          dataFactory
            .post("orginfo/", {
              boton_segumovil: $scope.configuracionGlobal.boton_segumovil,
            })
            .then(function success(response) {
              if (response.status == 201) {
                $scope.configuracionGlobal = response.data;
                SweetAlert.swal("Guardado", MESSAGES.OK.SAVEDCONFIG, "success");
                return;
              } else if (response.status == 403) {
                SweetAlert.swal("Error", response.data.detail, "error");
              } else {
                SweetAlert.swal("Error", MESSAGES.ERROR.GRALERROR, "error");
              }
            });
        }
      }
    };
    $scope.editQuatation = function (form) {
      $scope.plantilla.name = form.name;
      $scope.plantilla.title = form.title;
      $scope.plantilla.text = form.text;
      $scope.plantilla.bottom_text = form.bottom_text;
      $scope.plantilla.url = form.url;
      $scope.showQuotation = true;
      $scope.showEditInformation = true;
    };
    $scope.focusEditor = function () {
      $scope.editor_focus = true;
    };

    $scope.unfocusEditor = function () {};

    $scope.getFile = function () {
      var editor = textAngularManager.retrieveEditor("myEditorCreate").scope;
      editor.displayElements.text.trigger("focus");

      var modalInstance = $uibModal.open({
        template:
          '<label class="col-xs-12 btn btn-info">Agregar Imagen desde PC' +
          '<input multiple nv-file-select="" type="file" name="xyz" uploader="uploader" accept=".jpg" class="display-none"/>' +
          "</label>",
        // size: 'sm',
        controller: ModalInstanceFileCtrl,
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (imgUrl) {
        var imageLink;
        imageLink = $rootScope.image_url;
        var embed = '<img src="' + imageLink + ' ">';
        // return textAngular.$editor().wrapSelection('insertHTML', embed, true);

        var editor = textAngularManager.retrieveEditor("myEditorCreate");
        editor.scope.wrapSelection("insertHTML", embed, true);
      });
    };
    function ModalInstanceFileCtrl($scope, $rootScope, $uibModalInstance) {
      $scope.userInfo = {
        id: 0,
      };
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        allowedFileType: ["png", "jpg", "jpeg"],
      }));

      $scope.userInfo.url = $scope.uploader.url = url.IP + "plantillas-html/";
      $scope.uploader.autoUpload = true;
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $rootScope.image_url = response.arch;
        if ($uibModalInstance) {
          $uibModalInstance.close();
        }
      };
      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };
      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });
      };
      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = usr.org;
      };
      $scope.validateFiles = function () {
        var input = document.getElementById("fileInput");
        var files = input.files;
        var totalSize = 0;
        var errorMessageElement = document.getElementById("error-message");
        for (var i = 0; i < files.length; i++) {
          totalSize += files[i].size;
        }
        var totalSizeMB = totalSize / (1024 * 1024);
        if (totalSizeMB > 25) {
          errorMessageElement.style.display = "block";
          errorMessageElement.textContent =
            "La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.";
        } else {
          errorMessageElement.style.display = "none"; // Hide error message if files are valid
        }
      };
      function uploadFiles() {
        $scope.userInfo.url = $scope.uploader.url = url.IP + "plantillas-html/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("CobranzasModal", CobranzasModal);
  CobranzasModal.$inject = [
    "appStates",
    "datesFactory",
    "$sce",
    "$state",
    "dataFactory",
    "url",
    "$http",
    "$localStorage",
    "SweetAlert",
    "$scope",
    "statusPayform",
    "curr_rate_options",
    "$uibModalInstance",
    "helpers",
    "receipt",
    "insurance",
    "bono",
    "statusReceipt",
    "receiptService",
    "toaster",
    "from",
    "MESSAGES",
    "$sessionStorage",
    "FileUploader",
    "fileService",
    "$rootScope",
    "emailService",
    "$uibModal",
    "$location",
  ];

  function CobranzasModal(
    appStates,
    datesFactory,
    $sce,
    $state,
    dataFactory,
    url,
    $http,
    $localStorage,
    SweetAlert,
    $scope,
    statusPayform,
    curr_rate_options,
    $uibModalInstance,
    helpers,
    receipt,
    insurance,
    bono,
    statusReceipt,
    receiptService,
    toaster,
    from,
    MESSAGES,
    $sessionStorage,
    FileUploader,
    fileService,
    $rootScope,
    emailService,
    $uibModal,
    $location
  ) {
    var vm = this;
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
    vm.pagar_parcial_bool = false;
    vm.pagos = [];
    vm.cantidad_pago_parcial = 0;
    vm.pago_date = new Date();
    vm.edith_promesa_pago = false;
    $scope.bono = bono ? true : false;
    $scope.boton_liquidado = false;
    $scope.statusPayform = [];
    $scope.can_pay = true;
    insurance =
      insurance || receipt.poliza || receipt.policy || receipt.fianza || {};
    $scope._insurance = insurance;
    var insuranceDocType = insurance ? insurance.document_type : null;
    if (insuranceDocType == 7 || insuranceDocType == 8) {
      $scope.statusReceipt = [
        { label: "PAGADO", value: 1 },
        // {label: 'CANCELADO', value: 2 },
        { label: "PRORROGADO", value: 3 },
        { label: "PENDIENTE DE PAGO", value: 4 },
        { label: "LIQUIDADO", value: 5 },
        { label: "CONCILIADO", value: 6 },
        { label: "CERRADO", value: 7 },
        // {label: 'PRECANCELADO', value: 8 },
        { value: 9, label: "PAGO PARCIAL" },
      ];
      $scope.statusReceipt_C = [
        { label: "PAGADO", value: 1 },
        { label: "CERRADO", value: 7 },
        // {label: 'CANCELADO', value: 2 },
        { label: "PRORROGADO", value: 3 },
        { label: "PENDIENTE DE PAGO", value: 4 },
        { label: "LIQUIDADO", value: 5 },
        { label: "CONCILIADO", value: 6 },
        // {label: 'PRECANCELADO', value: 8},
        { value: 9, label: "PAGO PARCIAL" },
      ];
    } else {
      $scope.statusReceipt = [
        { label: "PAGADO", value: 1 },
        { label: "CANCELADO", value: 2 },
        { label: "PRORROGADO", value: 3 },
        { label: "PENDIENTE DE PAGO", value: 4 },
        { label: "LIQUIDADO", value: 5 },
        { label: "CONCILIADO", value: 6 },
        { label: "CERRADO", value: 7 },
        { label: "PRECANCELADO", value: 8 },
        { value: 9, label: "PAGO PARCIAL" },
      ];
      $scope.statusReceipt_C = [
        { label: "PAGADO", value: 1 },
        { label: "CERRADO", value: 7 },
        { label: "CANCELADO", value: 2 },
        { label: "PRORROGADO", value: 3 },
        { label: "PENDIENTE DE PAGO", value: 4 },
        { label: "LIQUIDADO", value: 5 },
        { label: "CONCILIADO", value: 6 },
        { label: "PRECANCELADO", value: 8 },
        { value: 9, label: "PAGO PARCIAL" },
      ];
    }
    vm.accesos = $sessionStorage.permisos;
    vm.changeConciliate = true;
    vm.accesos.forEach(function (acceso) {
      if (acceso.model_name == "Cobranza") {
        vm.acceso_cob = acceso;
        vm.acceso_cob.permissions.forEach(function (acc) {
          if (acc.permission_name == "Pagar y prorrogar") {
            if (acc.checked == true) {
              vm.acceso_pag_rec = true;
            } else {
              vm.acceso_pag_rec = false;
              $scope.statusReceipt.splice(
                $scope.statusReceipt.indexOf({ label: "PAGADO", value: 1 }),
                1
              );
              $scope.statusReceipt.splice(
                $scope.statusReceipt.indexOf({ label: "PRORROGADO", value: 3 }),
                1
              );
            }
          }
          if (acc.permission_name == "Desconciliación de recibos") {
            if (acc.checked == true) {
              vm.acceso_desconc_rec = true;
            } else {
              vm.acceso_desconc_rec = false;
            }
          }
          if (acc.permission_name == "Desliquidar recibos") {
            if (acc.checked == true) {
              $scope.acceso_desliq_rec = true;
            } else {
              $scope.acceso_desliq_rec = false;
            }
          }
          if (acc.permission_name == "Conciliar recibos") {
            if (acc.checked == true) {
              vm.changeConciliate = true;
              vm.acceso_conc_rec = true;
              $scope.statusReceipt.unshift({ label: "CONCILIADO", value: 6 });
              $scope.statusReceipt_C.unshift({ label: "CONCILIADO", value: 6 });
            } else {
              vm.changeConciliate = false;
              vm.acceso_conc_rec = false;
              $scope.statusReceipt.splice(
                $scope.statusReceipt.indexOf({ label: "CONCILIADO", value: 6 }),
                1
              );
              $scope.statusReceipt_C.splice(
                $scope.statusReceipt_C.indexOf({
                  label: "CONCILIADO",
                  value: 6,
                }),
                1
              );
            }
          }
          if (acc.permission_name == "Liquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_liq_rec = true;
            } else {
              vm.acceso_liq_rec = false;
              $scope.statusReceipt.splice(
                $scope.statusReceipt.indexOf({ label: "LIQUIDADO", value: 5 }),
                1
              );
              $scope.statusReceipt_C.splice(
                $scope.statusReceipt_C.indexOf({
                  label: "LIQUIDADO",
                  value: 5,
                }),
                1
              );
            }
          }
          if (acc.permission_name == "Ver cobranza") {
            if (acc.checked == true) {
              vm.acceso_ver_cob = true;
            } else {
              vm.acceso_ver_cob = false;
            }
          }
          if (acc.permission_name == "Despagar recibos") {
            if (acc.checked == true) {
              vm.acceso_despag_rec = true;
            } else {
              vm.acceso_despag_rec = false;
              if (receipt.status == "Pagado" || receipt.status == 1) {
                $scope.statusReceipt_C.splice(
                  $scope.statusReceipt_C.indexOf({
                    label: "PRORROGADO",
                    value: 3,
                  }),
                  1
                );
                $scope.statusReceipt_C.splice(
                  $scope.statusReceipt_C.indexOf({
                    label: "PENDIENTE DE PAGO",
                    value: 4,
                  }),
                  1
                );
                $scope.statusReceipt.splice(
                  $scope.statusReceipt.indexOf({
                    label: "PRORROGADO",
                    value: 3,
                  }),
                  1
                );
                $scope.statusReceipt.splice(
                  $scope.statusReceipt.indexOf({
                    label: "PENDIENTE DE PAGO",
                    value: 4,
                  }),
                  1
                );
              }
              // $scope.statusReceipt = [
              //   {label: 'PAGADO', value: 1 },
              //   {label: 'LIQUIDADO', value: 5 },
              //   {label: 'CONCILIADO', value: 6 },
              //   {label: 'CERRADO', value: 7 },
              //   {value: 9, label: 'PAGO PARCIAL'}
              // ];
            }
          }
          if (acc.permission_name == "Eliminar recibos") {
            if (acc.checked == true) {
              $scope.acceso_del_cob = true;
            } else {
              $scope.acceso_del_cob = false;
            }
          }
        });
      }
      if (acceso.model_name == "Correos electronicos") {
        vm.acceso_correo = acceso;
        vm.acceso_correo.permissions.forEach(function (acc) {
          if (acc.permission_name == "Correos") {
            if (acc.checked == true) {
              vm.acceso_cor = true;
            } else {
              vm.acceso_cor = false;
            }
          }
        });
      }
      if (acceso.model_name == "Endosos") {
        vm.acceso_endosos = acceso;
        vm.acceso_endosos.permissions.forEach(function (acc) {
          if (acc.permission_name == "Registrar endosos") {
            if (acc.checked == true) {
              vm.acceso_reg_end = true;
            } else {
              vm.acceso_reg_end = false;
            }
          }
        });
      }
      if (acceso.model_name == "Comisiones") {
        vm.coms = acceso;
        vm.coms.permissions.forEach(function (acc) {
          if (acc.permission_name == "Comisiones") {
            if (acc.checked == true) {
              vm.permiso_comisiones = true;
            } else {
              vm.permiso_comisiones = false;
            }
          }
        });
      }
      if (acceso.model_name == "Mensajeria") {
        $scope.acceso_mns = acceso;
        $scope.acceso_mns.permissions.forEach(function (acc) {
          if (acc.permission_name == "Mensajeria") {
            if (acc.checked == true) {
              $scope.acceso_mns = true;
            } else {
              $scope.acceso_mns = false;
            }
          }
        });
      }
      if (acceso.model_name == "Archivos") {
        $scope.acceso_dash = acceso;
        $scope.acceso_dash.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar archivos sensibles") {
            if (acc.checked == true) {
              $scope.permiso_archivos = true;
              vm.permiso_archivos = true;
            } else {
              $scope.permiso_archivos = false;
              vm.permiso_archivos = false;
            }
          }
          // Administrar adjuntos //no agregar, no eliminar, no renombrar, no marcar sensible
          if (acc.permission_name == "Administrar adjuntos") {
            if (acc.checked == true) {
              vm.permiso_administrar_adjuntos = true;
              $scope.permiso_administrar_adjuntos = true;
            } else {
              vm.permiso_administrar_adjuntos = false;
              $scope.permiso_administrar_adjuntos = false;
            }
          }
        });
      }
    });
    $scope.curr_rate_options = [];
    $scope.cancel = cancel;
    $scope.flag = true;
    $scope.changeReceiptStatus = changeReceiptStatus;
    $scope.banco = 0;
    $scope.data_receipt = [];

    vm.form = {};
    vm.form.contratante = {};
    vm.form.comision_conciliada_p = 0;
    vm.form.comision_conciliada_p_estimada = 0;
    vm.form.comision_conciliada_p_ok = 0;
    $scope.task = false;
    $scope.delivery = false;
    $scope.activeConciliar = false;
    $scope.delivery_man = {};
    $scope.new_task = {};
    $scope.filters = {};
    $scope.new_task.fecha = datesFactory.convertDate(new Date());

    activate();
    var vm = ($scope.vm = {
      files: [],
    });
    $scope.flagBank = false;
    $localStorage.receiptUpdated = {};
    $scope.dataToSave = {};
    $localStorage.receiptModified = false;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.user_pay = {};
    $http({
      method: "GET",
      url: url.IP + "get_user_by_username/",
      params: {
        username: usr.name,
      },
    })
      .then(function (request) {
        $scope.user_pay = request.data;
      })
      .catch(function (e) {
        console.log("e", e);
      });

    $scope.payDate = convertDate(new Date());
    $scope.fecha_pago = "";

    $scope.address_type = [
      {
        name: "Dirección Fiscal",
        id: 1,
      },
      {
        name: "Dirección de cobro",
        id: 2,
      },
      {
        name: "Dirección de paquetería",
        id: 3,
      },
      {
        name: "Dirección de riesgo",
        id: 4,
      },
    ];

    /** Uploader files **/
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });
    vm.createRecordatorio = createRecordatorio;
    function createRecordatorio(registroSelected, tipo) {
      $uibModalInstance.close();
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return vm.insurance;
          },
        },
        // $uibModalInstance.close();
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    }
    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $uibModalInstance.close();
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };
    $scope.proceder_pago_parcial = function (receipt) {
      var original_receipt = angular.copy(receipt);
      if (
        (original_receipt.status == 6 &&
          $scope.status != original_receipt.status &&
          $scope.change_to_conciliate == false) ||
        vm.acceso_desconc_rec == false
      ) {
        SweetAlert.swal(
          "Error",
          "No tiene permiso para hacer cambios en recibos conciliados",
          "warning"
        );
        return;
      }
      if (vm.cantidad_pago_parcial == null || vm.cantidad_pago_parcial <= 0) {
        toaster.error("Ingrese una cantidad válida");
        return;
      }
      if (!vm.folio_pay) {
        toaster.error("Ingrese documento de pago");
        return;
      }
      if (!vm.pago_date) {
        toaster.error("Ingrese fecha de pago");
        return;
      }
      $http
        .post(url.IP + "pagos/", {
          pago: vm.cantidad_pago_parcial,
          recibo: receipt.url,
          recibo_id: receipt.id,
          forma_pago: $scope.dataToSave.pay_form,
          documento_pago: vm.folio_pay,
          fecha_de_pago: datesFactory.toDate(vm.pago_date),
        })
        .then(function success(response) {
          if (response.status == 500) {
            try {
              toaster.error(response.data["detail"]);
            } catch (err) {
              console.log(err, response.data);
            }
            vm.pagos_parciales_total += parseFloat(vm.cantidad_pago_parcial);
            vm.pagos_parciales_restante =
              receipt.prima_total - vm.pagos_parciales_total;
            return;
          }
          vm.pagos.push(response.data);
          vm.cantidad_pago_parcial = null;
          vm.folio_pay = null;
        });
    };
    $scope.update_promesa_pago = function (receipt) {
      if (!vm.new_promesa_pago) {
        toaster.error("Ingresa  promesa de pago");
        return;
      }
      $http
        .post(url.IP + "promesa-pago/", {
          recibo_id: receipt.id,
          promesa_pago: datesFactory.toDate(vm.new_promesa_pago),
        })
        .then(function success(response) {
          if (response.status == 500) {
            try {
              toaster.error(response.data["detail"]);
            } catch (err) {
              console.log(err, response.data);
            }
          } else if (response.status == 200) {
            receipt.promesa_pago = vm.new_promesa_pago;
            var params = {
              model: 4,
              event: "POST",
              associated_id: receipt.id,
              identifier:
                " ha actualizado la Fecha Promesa de Pago (" +
                vm.new_promesa_pago +
                ")",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
          }
          vm.edith_promesa_pago = false;
          return;
        });
    };

    $scope.pagar_parcial = function (recibo_id) {
      if (!vm.pagar_parcial_bool) {
        vm.pagar_parcial_bool = true;
      } else {
        vm.pagar_parcial_bool = false;
      }
    };

    $scope.validarDecimales = function (input) {
      if ($scope.receipt.receipt_type == 3) {
        vm.form.comision_conciliada = input.toString();
      } else {
        if (parseFloat(input) < 0) {
          vm.form.comision_conciliada = "0";
        } else {
          vm.form.comision_conciliada = input.toString();
        }
      }
    };

    $scope.calcualrCC = function (input, tipo) {
      if (tipo == 3) {
        if (parseFloat(vm.form.comision_conciliada_p_estimada) != 0.0) {
          vm.form.comision_conciliada_p = parseFloat(
            vm.form.comision_conciliada_p_estimada
          );
          $scope.division = parseFloat(
            parseFloat(
              parseFloat(receipt.prima_neta * $scope.dataToSave.rate_exchange)
            ) / 100
          ).toFixed(2);
          vm.form.comision_conciliada_p = parseFloat(
            parseFloat(
              vm.form.comision_conciliada ? vm.form.comision_conciliada : 0
            ) / parseFloat($scope.division)
          ).toFixed(2);
          if (vm.form.comision_conciliada_p < 0) {
            vm.form.comision_conciliada_p = vm.form.comision_conciliada_p * -1;
            vm.form.comision_conciliada_p_ok =
              vm.form.comision_conciliada_p_ok * -1;
          }
        } else {
          $scope.division = parseFloat(
            parseFloat(
              parseFloat(
                receipt.prima_neta * parseFloat($scope.dataToSave.rate_exchange)
              )
            ) / 100
          ).toFixed(2);
          vm.form.comision_conciliada_p = parseFloat(
            parseFloat(vm.form.comision_conciliada) /
              parseFloat($scope.division)
          ).toFixed(2);
          if (vm.form.comision_conciliada_p < 0) {
            vm.form.comision_conciliada_p = vm.form.comision_conciliada_p * -1;
            vm.form.comision_conciliada_p_ok =
              vm.form.comision_conciliada_p_ok * -1;
          }
        }
      }
      if (tipo == 2) {
        // vm.form.comision_conciliada = (input)
        if (parseFloat(vm.form.comision_conciliada_p_estimada) != 0.0) {
          // vm.form.comision_conciliada_p = parseFloat(vm.form.comision_conciliada_p_estimada ? vm.form.comision_conciliada_p_estimada : 0)
          // $scope.division = parseFloat(parseFloat(parseFloat(receipt.prima_neta *  parseFloat($scope.dataToSave.rate_exchange)))/100).toFixed(2)
          // vm.form.comision_conciliada_p = parseFloat(parseFloat( vm.form.comision_conciliada) / parseFloat($scope.division)).toFixed(2)
          // if(vm.form.comision_conciliada_p <0){
          //   vm.form.comision_conciliada_p = vm.form.comision_conciliada_p * -1
          // }
          if (
            receipt &&
            receipt.poliza_informacion &&
            receipt.poliza_informacion[0] &&
            parseInt(receipt.poliza_informacion[0].comision_rpf_percent) == 0 &&
            parseInt(receipt.poliza_informacion[0].comision_derecho_percent) ==
              0
          ) {
            vm.form.comision_conciliada_p = parseFloat(
              vm.form.comision_conciliada_p_estimada || 0
            );
            var prima_neta = parseFloat(receipt.prima_neta);
            var rate_exchange = parseFloat($scope.dataToSave.rate_exchange);
            var division = (prima_neta * rate_exchange) / 100;
            $scope.division = division.toFixed(2);
            var comision_conciliada = parseFloat(vm.form.comision_conciliada);
            vm.form.comision_conciliada_p = (
              comision_conciliada / division
            ).toFixed(2);
            if (vm.form.comision_conciliada_p < 0) {
              vm.form.comision_conciliada_p = (
                vm.form.comision_conciliada_p * -1
              ).toFixed(2);
              vm.form.comision_conciliada_p_ok = (
                vm.form.comision_conciliada_p_ok * -1
              ).toFixed(2);
            }
          } else {
            var recibo_comision = receipt.comision;
            var comision_conciliada = parseFloat(vm.form.comision_conciliada);
            if (
              receipt &&
              receipt.poliza_informacion &&
              receipt.poliza_informacion[0] &&
              receipt.poliza_informacion[0] != 1
            ) {
              var rate_exchange = parseFloat($scope.dataToSave.rate_exchange);
              recibo_comision = receipt.comision * rate_exchange;
            }
            if (
              parseFloat(comision_conciliada).toFixed(1) <
              parseFloat(recibo_comision).toFixed(1)
            ) {
              vm.form.comision_conciliada_p = "⬇️ INFERIOR";
            }
            if (
              parseFloat(comision_conciliada).toFixed(1) >
              parseFloat(recibo_comision).toFixed(1)
            ) {
              vm.form.comision_conciliada_p = "⬆️ SUPERIOR";
            }
            if (
              parseFloat(recibo_comision).toFixed(1) ==
              parseFloat(comision_conciliada).toFixed(1)
            ) {
              vm.form.comision_conciliada_p = "✔ CORRECTA";
            }
          }
          if (parseFloat(vm.form.comision_conciliada_p_estimada) != 0.0) {
            vm.form.comision_conciliada_p_ok = parseFloat(
              vm.form.comision_conciliada_p_estimada
                ? vm.form.comision_conciliada_p_estimada
                : 0
            );
            $scope.division = parseFloat(
              parseFloat(
                parseFloat(
                  receipt.prima_neta *
                    parseFloat($scope.dataToSave.rate_exchange)
                )
              ) / 100
            ).toFixed(2);
            vm.form.comision_conciliada_p_ok = parseFloat(
              parseFloat(vm.form.comision_conciliada) /
                parseFloat($scope.division)
            ).toFixed(2);
            if (vm.form.comision_conciliada_p_ok < 0) {
              vm.form.comision_conciliada_p_ok =
                vm.form.comision_conciliada_p_ok * -1;
            }
          } else {
            $scope.division = parseFloat(
              parseFloat(
                parseFloat(
                  receipt.prima_neta *
                    parseFloat($scope.dataToSave.rate_exchange)
                )
              ) / 100
            ).toFixed(2);
            vm.form.comision_conciliada_p_ok = parseFloat(
              parseFloat(vm.form.comision_conciliada) /
                parseFloat($scope.division)
            ).toFixed(2);
            if (vm.form.comision_conciliada_p_ok < 0) {
              vm.form.comision_conciliada_p_ok =
                vm.form.comision_conciliada_p_ok * -1;
            }
          }
          // if(isFinite(calculo) ==false){
          //   receipt.comision_conciliada_p=0
          // }
        } else {
          $scope.division = parseFloat(
            parseFloat(
              parseFloat(
                receipt.prima_neta * parseFloat($scope.dataToSave.rate_exchange)
              )
            ) / 100
          ).toFixed(2);
          vm.form.comision_conciliada_p_ok = parseFloat(
            parseFloat(vm.form.comision_conciliada) /
              parseFloat($scope.division)
          ).toFixed(2);
          if (vm.form.comision_conciliada_p_ok < 0) {
            vm.form.comision_conciliada_p = vm.form.comision_conciliada_p * -1;
            vm.form.comision_conciliada_p_ok =
              vm.form.comision_conciliada_p_ok * -1;
          }
        }
      }
      $scope.isComisionConciliadaPExceeded =
        parseFloat(vm.form.comision_conciliada_p) > 100;
    };
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        toaster.success(MESSAGES.OK.UPDATERECEIPT);
        if (receipt.status == 1) {
          SweetAlert.swal("¡Listo!", "El recibo ha sido pagado.", "success");
        }

        // if ($uibModalInstance) {
        //   if (from) {
        //     $uibModalInstance.close(5);
        //   } else {
        //     $uibModalInstance.close($scope.data_receipt);
        //   }
        // }

        if ($scope.data_receipt.status == 1) {
          $scope.status_receipt =
            "actualizó el recibo a pagado y se adjuntó archivo(s).";
        } else if ($scope.data_receipt.status == 2) {
          $scope.status_receipt =
            "actualizó el recibo a cancelado y se adjuntó archivo(s).";
        } else if ($scope.data_receipt.status == 3) {
          $scope.status_receipt =
            "actualizó el recibo a prorrogado y se adjuntó archivo(s).";
        } else if ($scope.data_receipt.status == 4) {
          $scope.status_receipt =
            "actualizó el recibo a pendiente y se adjuntó archivo(s).";
        } else if ($scope.data_receipt.status == 5) {
          $scope.status_receipt =
            "actualizó el recibo a liquidado y se adjuntó archivo(s).";
        } else if ($scope.data_receipt.status == 6) {
          $scope.status_receipt =
            "actualizó el recibo a conciliado y se adjuntó archivo(s).";
        } else if ($scope.data_receipt.status == 7) {
          $scope.status_receipt =
            "actualizó el recibo a cerrado y se adjuntó archivo(s).";
        }
        if ($scope.status_receipt) {
          var params = {
            model: 4,
            event: "POST",
            associated_id: $scope.data_receipt.id,
            identifier: $scope.status_receipt,
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
        } else {
          var params = {
            model: 4,
            event: "POST",
            associated_id: $scope.id_recibo,
            identifier: "Adjunto archivo(s",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          if ($uibModalInstance) {
            if (from) {
              $uibModalInstance.close(5);
            } else {
              $uibModalInstance.close($scope.data_receipt);
            }
          }
        }
      }
    };
    $scope.getLogReceipt = function (model, id) {
      dataFactory
        .get("get-specific-log", { model: model, associated_id: id })
        .then(function success(response) {
          $scope.logs = response.data;
        });
    };
    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    vm.uploadFiles = uploadFiles;
    function uploadFiles(reciboId) {
      $scope.userInfo = {
        id: receipt.id,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "recibos/" + reciboId + "/archivos/";
      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.saveFiles = function (id, banco, payDate) {
      $scope.id_recibo = id;
      $scope.userInfo.id = receipt.id;
      $scope.userInfo.url = $scope.uploader.url = receipt.url + "archivos/";
      $scope.uploader.uploadAll();
      if ($scope.status.value) {
        var statuspatch = $scope.status.value;
      } else {
        var statuspatch = $scope.status;
      }
      if (
        (receipt.status != undefined || !receipt.status) &&
        statuspatch != receipt.status
      ) {
        $scope.changeReceiptStatus(banco, payDate);
      } else {
        if ($scope.description) {
          $http
            .patch(receipt.url, { description: $scope.description })
            .then(function success(response) {});
        }
      }
    };

    $scope.saveFolioFac = function (input) {
      $http
        .patch(receipt.url, { folio_factura: input })
        .then(function success(response) {
          var params = {
            model: 4,
            event: "PATCH",
            associated_id: response.data.id,
            identifier:
              " actualizo el recibo con un folio de factura: " + input,
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          receipt.folio_factura = response.data.folio_factura;
        });
    };

    $scope.deleteBono = function () {
      $http.delete(insurance.url).then(function success(response) {
        if (response.status == 204) {
          SweetAlert.swal("Hecho", MESSAGES.OK.BONODELETED, "success");
          $uibModalInstance.dismiss("cancel");
        }
      });
    };

    $scope.viewCarta = function (poliza, carta, recibo) {
      if ($scope.receiptPar.poliza.id) {
        poliza = $scope.receiptPar.poliza.id;
      } else {
        poliza = poliza;
      }

      $http({
        method: "GET",
        url: url.IP + "get-pdf-form/",
        params: {
          id_poliza: poliza,
          id_carta: carta,
          id_recibo: recibo,
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
        // $scope.pdf = response.data;
        // $http({
        //   method: 'GET',
        //   url: url.IP + 'get-pdf',
        //   params: {
        //     'pdf_name': $scope.pdf.pdf_name
        //   },
        //   responseType: 'arraybuffer'

        // }).then(function success(response) {

        //   })
      });
    };

    $scope.getLiquidacionPDF = function (recibo) {
      $http({
        method: "POST",
        url: url.IP + "get-pdf-liquidacion/",
        data: {
          liquidacion_folio: recibo.liquidacion_folio,
          generado_por: usr["nameFull"],
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
      });
    };

    $scope.getPDFConciliacion = function (recibo) {
      $http({
        method: "POST",
        url: url.IP + "get-pdf-conciliacion/",
        data: {
          conciliacion_folio: recibo.conciliacion_folio,
          generado_por: usr["nameFull"],
        },
      }).then(function success(response) {
        var file = new Blob([response.data], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          var fileURL = URL.createObjectURL(file);
          $scope.content = $sce.trustAsResourceUrl(fileURL);
          window.open($scope.content);
        }
      });
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");

      return date;
    }

    $scope.goToPolicy = function (poliza) {
      if ($scope.receiptPar.poliza.id) {
        poliza = $scope.receiptPar.poliza.id;
        $state.go("polizas.info", { polizaId: poliza });
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      } else {
        $state.go("polizas.info", { polizaId: $scope.receiptPoliza.id });
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      }
    };

    $scope.showEmail = function (receipt) {
      SweetAlert.swal(
        {
          title: "Correo",
          text: $scope.receiptPar.contratante.email,
          type: "info",
          confirmButtonText: "Enviar recordatorio",
          cancelButtonText: "Salir",
          showCancelButton: true,
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          allowOutsideClick: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .post(url.IP + "payment-reminder-manual/", { r_id: receipt.id })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                  } else {
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
          }
        }
      );
    };
    $scope.change_to_cancel = false;
    $scope.activeConciliar = false;
    $scope.changedValue = function (status) {
      $scope.activeConciliar = false;
      $scope.change_to_cancel = false;
      $scope.flagBank = false;

      if (status.value != 9) {
        vm.pagar_parcial_bool = false;
      }

      if (status.value == 3) {
        $scope.flagBank = true;
        $scope.change_to_conciliate = false;
      } else if (status.value == 4) {
        receipt.description = $scope.description;
        $scope.change_to_conciliate = true;
      } else if (status.value == 7) {
        $scope.change_to_conciliate = true;
      } else if (status.value == 5) {
        $scope.dataToSave.liquidacion_folio = receipt.id;
        $scope.payDate = convertDate(new Date());
        $scope.change_to_conciliate = false;
      } else if (status.value == 2) {
        $scope.change_to_cancel = true;
        $scope.change_to_conciliate = true;
      } else if (status.value == 6) {
        $scope.boton_liquidado = true;
        $scope.change_to_conciliate = true;
        $scope.activeConciliar = true;
        vm.form = {};
        vm.form.conciliate_date = convertDate(new Date());
        vm.form.comision_conciliada = 0;
        vm.form.comision_conciliada_p_estimada = insurance.comision_percent;
        vm.form.comision_conciliada_p = receipt.comision_conciliada_p_ok
          ? receipt.comision_conciliada_p_ok
          : 0;
      } else if (status.value == 9) {
        $scope.pagar_parcial(receipt.id);
      } else {
        $scope.boton_liquidado = false;
        $scope.change_to_conciliate = false;
      }
      $scope.dataToSave.status = status.value;
      $scope.status = status.value;

      switch (insurance.f_currency) {
        case 1:
          $scope.rate = curr_rate_options[0];
          $scope.dataToSave.curr_rate = curr_rate_options[0].value;
          break;
        case 2:
          $scope.rate = curr_rate_options[1];
          $scope.dataToSave.curr_rate = curr_rate_options[1].value;
          break;
        case 3:
          $scope.rate = curr_rate_options[2];
          $scope.dataToSave.curr_rate = curr_rate_options[2].value;
          break;
        case 4:
          $scope.rate = curr_rate_options[3];
          $scope.dataToSave.curr_rate = curr_rate_options[3].value;
          break;
        case 5:
          $scope.rate = curr_rate_options[4];
          $scope.dataToSave.curr_rate = curr_rate_options[4].value;
          break;
        case 6:
          $scope.rate = curr_rate_options[5];
          $scope.dataToSave.curr_rate = curr_rate_options[5].value;
          break;
        case 7:
          $scope.rate = curr_rate_options[6];
          $scope.dataToSave.curr_rate = curr_rate_options[6].value;
          break;
        default:
          $scope.rate = curr_rate_options[0];
          try {
            if (curr_rate_options[7].value) {
              $scope.dataToSave.curr_rate = curr_rate_options[7].value;
            } else {
              $scope.dataToSave.curr_rate = 1;
            }
          } catch (j) {
            $scope.dataToSave.curr_rate = 1;
          }
      }
    };

    $scope.AjustarConciliacion = function (receipt) {
      if ($scope.ajustar_conciliacion == true) {
        $scope.ajustar_conciliacion = false;
        var data = {
          comision_conciliada: receipt.comision_conciliada,
        };
        var params = {
          model: 4,
          event: "PATCH",
          associated_id: receipt.id,
          identifier:
            " actualizo el recibo en comisión conciliada: " +
            receipt.comision_conciliada,
        };
        dataFactory
          .post("send-log/", params)
          .then(function success(response) {});
        $http({
          method: "PATCH",
          url: receipt.url,
          data: data,
        });
      } else {
        $scope.ajustar_conciliacion = true;
      }

      if (vm.form.provider != null) {
        var p = vm.form.provider.id;
      } else {
        var p = 0;
      }

      if (vm.form.ramo != null) {
        var r = vm.form.ramo.id;
      } else {
        var r = 0;
      }

      if (vm.form.subramo != null) {
        var s = vm.form.subramo.id;
      } else {
        var s = 0;
      }
      $http
        .get(
          url.IP +
            "get-comission-amount/?" +
            "provider=" +
            p +
            "&" +
            "ramo=" +
            r +
            "&" +
            "subramo=" +
            s +
            "&" +
            "polizas_iniciales=" +
            vm.form.polizas_iniciales +
            "&" +
            "polizas_renovadas=" +
            vm.form.polizas_renovadas +
            "&" +
            "recibos_pagados=" +
            vm.form.recibos_pagados +
            "&" +
            "recibos_no_pagados=" +
            vm.form.recibos_no_pagados +
            "&" +
            "recibos_liquidados=" +
            vm.form.recibos_liquidados +
            "&" +
            "recibos_conciliados=" +
            vm.form.recibos_conciliados +
            "&" +
            "since=" +
            (vm.form.since + " " + "00:00:00") +
            "&" +
            "until=" +
            (vm.form.until + " " + "23:59:59") +
            "&" +
            "cve_agente=" +
            (vm.form.cve_agente ? vm.form.cve_agente : 0) +
            "&"
        )
        .then(function success(response) {
          vm.form.total = response.data.total;
          vm.form.total_conciliado = response.data.total_conciliado;
        });
    };
    vm.conciliarRecibo = conciliarRecibo;
    function conciliarRecibo(recibo) {
      if (vm.cuenta == undefined || vm.cuenta.length == 0) {
        SweetAlert.swal("Error", MESSAGES.ERROR.SELECTACCOUNT, "error");
        return;
      }
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Los cambios no podrán revertirse",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "¡Si!",
          cancelButtonText: "No",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data = {
              status: 6,
              comision_conciliada: parseFloat(
                vm.form.comision_conciliada
              ).toFixed(2),
              comision_conciliada_p: parseFloat(
                vm.form.comision_conciliada_p_ok
              ).toFixed(2),
              comision_conciliada_p_estimada: vm.form
                .comision_conciliada_p_estimada
                ? parseFloat(vm.form.comision_conciliada_p_estimada).toFixed(2)
                : 0,
              rate_exchange: $scope.dataToSave.rate_exchange
                ? $scope.dataToSave.rate_exchange
                : 1,
              conciliacion_date: toDate(vm.form.conciliate_date),
              conciliacion_folio: recibo.id,
              conciliation_account: vm.cuenta.url,
              description: $scope.description ? $scope.description : null,
            };
            if (recibo.receipt_type == 3) {
              if (data["comision_conciliada"] > 0) {
                data["comision_conciliada"] = data["comision_conciliada"] * -1;
              }
            }
            patchRecibo(recibo.url, data);

            SweetAlert.swal(
              "¡Listo!",
              MESSAGES.OK.RECEIPTCONCILIAR + recibo.id,
              "success"
            );
            vm.conciliar = false;
            vm.cuenta = [];
            vm.comision_conciliada = 0;
            $scope.locpath = $location.path();
            if ($scope.locpath.includes("endosos/informacion")) {
              $state.reload();
            }
            if ($location.path() == "/cobranzas/folios") {
              $state.reload();
            }
            if ($location.path().includes("/colectividades/")) {
              $state.reload();
            }
            if ($location.path().includes("/flotillas/")) {
              $state.reload();
            }
            if ($location.path().includes("/polizas/")) {
              $state.reload();
            }

            $uibModalInstance.dismiss("cancel");
          } else {
            SweetAlert.swal("Cancelado", MESSAGES.ERROR.CANCELACCOUNT, "error");
          }
        }
      );
    }

    function patchRecibo(url, data) {
      $http({
        method: "PATCH",
        url: url,
        data: data,
      })
        // $http.patch(url,data)
        .success(function (response) {
          if (response) {
            $scope.status = true;
            vm.show_receipt_info = false;
            // activate();
            // $uibModalInstance.close(response);
            // $uibModalInstance.close(5);
            if ($uibModalInstance) {
              if (from) {
                $uibModalInstance.close(5);
              } else {
                $uibModalInstance.close(response);
              }
            }
            if ($uibModalInstance) {
              if (from) {
                $uibModalInstance.close(5);
              } else {
                $uibModalInstance.close(response);
              }
            }

            $scope.status_receipt = "actualizó el recibo a conciliado.";

            var params = {
              model: 4,
              event: "POST",
              associated_id: receipt.id,
              identifier: $scope.status_receipt,
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {
                if ($scope.insurance.document_type == 1) {
                  var paramsPol = {
                    model: 1,
                    event: "PATCH",
                    associated_id: $scope.insurance.id,
                    identifier: $scope.status_receipt,
                  };
                  dataFactory
                    .post("send-log/", paramsPol)
                    .then(function success(response) {});
                } else if ($scope.insurance.document_type == "Carátula") {
                  var paramsF = {
                    model: 18,
                    event: "PATCH",
                    associated_id: $scope.insurance.id,
                    identifier: $scope.status_receipt,
                  };
                  dataFactory
                    .post("send-log/", paramsF)
                    .then(function success(response) {});
                } else if ($scope.insurance.document_type == 7) {
                  var paramsF = {
                    model: 13,
                    event: "PATCH",
                    associated_id: $scope.insurance.id,
                    identifier: $scope.status_receipt,
                  };
                  dataFactory
                    .post("send-log/", paramsF)
                    .then(function success(response) {});
                }
              });
          }
        })
        .error(function (errorResponse) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORUPDATERECEIPTS, "error");
        })
        .catch(function (catchResponse) {
          toaster.success("Póliza Actualizada exitosamente");
          console.log("error", error);
        });
    }

    $scope.show_mail = function (id) {
      $scope.show = true;
      $http.get(url.IP + "log-email/" + id + "/" + 0).then(function (response) {
        if (response.status == 200) {
          $scope.mail = response.data;
        }
      });
    };
    $scope.hide_mail = function () {
      $scope.show = false;
    };

    $scope.changeRate = function (param) {
      $scope.dataToSave.rate_exchange = parseFloat(param.toFixed(4));
    };

    function process_comission(argument) {
      vm.buttonReport = true;
      vm.show_receipt_info = false;
      $scope.ajustar_conciliacion = false;
      vm.conciliar = false;
      if (vm.form.provider != null) {
        var p = vm.form.provider.id;
      } else {
        var p = 0;
      }

      if (vm.form.ramo != null) {
        var r = vm.form.ramo.id;
      } else {
        var r = 0;
      }

      if (vm.form.subramo != null) {
        var s = vm.form.subramo.id;
      } else {
        var s = 0;
      }

      vm.form.receipt_pagination = false;
      // if((vm.form.since) <= (vm.form.until)){
      // vm.form.since = vm.form.since+ " " + "00:00:00";
      // vm.form.until = vm.form.until+ " " + "23:59:59";
      $http
        .get(
          url.IP +
            "get-comissions/?" +
            "provider=" +
            p +
            "&" +
            "ramo=" +
            r +
            "&" +
            "subramo=" +
            s +
            "&" +
            "polizas_iniciales=" +
            vm.form.polizas_iniciales +
            "&" +
            "polizas_renovadas=" +
            vm.form.polizas_renovadas +
            "&" +
            "recibos_pagados=" +
            vm.form.recibos_pagados +
            "&" +
            "recibos_no_pagados=" +
            vm.form.recibos_no_pagados +
            "&" +
            "recibos_liquidados=" +
            vm.form.recibos_liquidados +
            "&" +
            "recibos_conciliados=" +
            vm.form.recibos_conciliados +
            "&" +
            "since=" +
            (vm.form.since + " " + "00:00:00") +
            "&" +
            "until=" +
            (vm.form.until + " " + "23:59:59") +
            "&" +
            "cve_agente=" +
            (vm.form.cve_agente ? vm.form.cve_agente : 0) +
            "&"
        )
        .success(function (response) {
          vm.form.recibos_listos = response.results;
          vm.form.recibos_config = {
            count: response.count,
            next: response.next,
            previous: response.previous,
          };

          vm.form.receipt_pagination = true;
        })
        .error(function (response) {
          // body...
        })
        .catch(function (response) {
          // body...
        });
      $http
        .get(
          url.IP +
            "get-comission-amount/?" +
            "provider=" +
            p +
            "&" +
            "ramo=" +
            r +
            "&" +
            "subramo=" +
            s +
            "&" +
            "polizas_iniciales=" +
            vm.form.polizas_iniciales +
            "&" +
            "polizas_renovadas=" +
            vm.form.polizas_renovadas +
            "&" +
            "recibos_pagados=" +
            vm.form.recibos_pagados +
            "&" +
            "recibos_no_pagados=" +
            vm.form.recibos_no_pagados +
            "&" +
            "recibos_liquidados=" +
            vm.form.recibos_liquidados +
            "&" +
            "recibos_conciliados=" +
            vm.form.recibos_conciliados +
            "&" +
            "since=" +
            (vm.form.since + " " + "00:00:00") +
            "&" +
            "until=" +
            (vm.form.until + " " + "23:59:59") +
            "&" +
            "cve_agente=" +
            (vm.form.cve_agente ? vm.form.cve_agente : 0) +
            "&"
        )
        .then(function success(response) {
          vm.form.total = response.data.total;
          vm.form.total_conciliado = response.data.total_conciliado;
        });
      // }else{
      //   // toaster.error("La fecha "+vm.form.since+' mayor a '+vm.form.until);
      //   toaster.error("La fecha de inicio no coincide");
      // }
    }
    $scope.add_cuenta = false;
    $scope.add_account = function () {
      $scope.add_cuenta = true;
      $http.get(url.IP + "bancos/").then(function (bank) {
        $scope.bancos = bank.data;
      });
      vm.banco_selected = 0;
      vm.name = "";
      vm.account = "";
      vm.observation = "";
    };

    $scope.saveAccount = function () {
      if (vm.name) {
        if (vm.account) {
          if (vm.banco_selected) {
            if (vm.observation) {
              $http
                .post(url.IP + "accounts/", {
                  name: vm.name,
                  account: vm.account,
                  observation: vm.observation,
                  bank: vm.banco_selected,
                })
                .then(
                  function success(request) {
                    if (request.status === 200 || request.status === 201) {
                      $rootScope.new_account = request.data;
                      // accounts.push(request.data);
                      $http.get(url.IP + "accounts/").then(function (response) {
                        vm.accounts = response.data.results;
                        $rootScope.acounts_data = response.data.results;
                      });
                      toaster.success("Cuenta creada exitosamente");
                      $scope.add_cuenta = false;
                    } else {
                      toaster.warning("Error al crear cuenta");
                    }
                  },
                  function error(error) {
                    console.log("error - email", error);
                  }
                )
                .catch(function (e) {
                  console.log("error - catch", e);
                });
            } else {
              toaster.warning("Ingresa observciones");
            }
          } else {
            toaster.warning(MESSAGES.WARNING.EMPTYBANK);
          }
        } else {
          toaster.warning("Ingresa una cuenta");
        }
      } else {
        toaster.warning("Ingresa un nombre a la cuenta");
      }
    };

    $scope.cancel_add_cuenta = function () {
      $scope.add_cuenta = false;
    };

    $scope.changedPago = function (value, type) {
      if (type == 1) {
        $scope.dataToSave.pay_form = value.value;
        if (value.value == 7) {
          $scope.display_notes = true;
        }
      } else {
        $scope.dataToSave.liquidacion_form = value.value;
      }
    };

    $scope.changedRate = function (value, type) {
      if (type == 1) {
        $scope.dataToSave.curr_rate = value.value;
      } else {
        $scope.dataToSave.liquidacion_curr_rate = value.value;
      }
    };

    $scope.changedDate = function (value) {
      var fecha_pago = toDate(value);
      $scope.fecha_pago = toDate(value);

      if (receipt.policy) {
        if (receipt.policy.url) {
          $http.get(receipt.policy.url).then(function (response) {
            if (response.status === 200 || response.status === 201) {
              $scope.poliza_recibo = response.data;
              var fecha_inicio = toDate(
                convertDate($scope.poliza_recibo.start_of_validity)
              );
              var fecha_fin = toDate(
                convertDate($scope.poliza_recibo.end_of_validity)
              );
              // if ($scope.poliza_recibo.status != 10) {
              //   if(fecha_pago < fecha_inicio){
              //     SweetAlert.swal("Error", "Fecha de pago no puede ser menor a la fecha de vigencia póliza, se guardará con la fecha de hoy", "error");
              //     $scope.payDate = convertDate(receipt.fecha_inicio);
              //     $scope.changedDate1(convertDate(new Date()));
              //     return;
              //   }else{
              //     $scope.payDate = convertDate(toDate(value));
              //   }
              // }
              $scope.payDate = convertDate(toDate(value));
            }
          });
        } else {
          $http.get(receipt.policy).then(function (response) {
            if (response.status === 200 || response.status === 201) {
              $scope.poliza_recibo = response.data;
              var fecha_inicio = toDate(
                convertDate($scope.poliza_recibo.start_of_validity)
              );
              var fecha_fin = toDate(
                convertDate($scope.poliza_recibo.end_of_validity)
              );
              // if ($scope.poliza_recibo.status != 10) {
              //   if(fecha_pago < fecha_inicio){
              //     SweetAlert.swal("Error", "Fecha de pago no puede ser menor a la fecha de vigencia póliza, se guardará con la fecha de hoy", "error");
              //     $scope.payDate = convertDate(receipt.fecha_inicio);
              //     $scope.changedDate1(convertDate(new Date()));
              //     return;
              //   }else{
              //     $scope.payDate = convertDate(toDate(value));
              //   }
              // }
              $scope.payDate = convertDate(toDate(value));
            }
          });
        }
      }
    };

    $scope.changedDate1 = function (value, receipt) {
      $scope.payDate = convertDate(toDate(value));
    };

    $scope.observations = function (value) {
      $scope.description = value;
    };

    $scope.showFolio = true;
    $scope.showPay = false;
    $scope.showFolioSave = false;

    $scope.applyFolio = function (value) {
      if (value) {
        $scope.showFolio = false;
        $scope.showPay = false;
        vm.folioPay = false;
        if ($scope.folioSave.length > 0) {
          $scope.showFolioSave = true;
        } else {
          vm.apply = false;
          $scope.showFolio = true;
          $scope.showFolioSave = false;
          SweetAlert.swal("Error", "No hay ningún folio guardado", "error");
          return;
        }
      } else {
        $scope.showFolio = true;
        $scope.showPay = false;
        $scope.showFolioSave = false;
        $scope.pago = "";
        $scope.rate = "";
        $scope.pay_doc = "";
        $scope.bancos = "";
      }
    };

    $scope.showFolioPay = function (value) {
      if (value) {
        $scope.showPay = true;
        $scope.vm.folio_pay = "";
      } else {
        $scope.showPay = false;
      }
    };

    $scope.changedFolio = function (folio) {
      switch (folio.pay_form) {
        case 1:
          $scope.pago = $scope.statusPayform[0];
          break;
        case 2:
          $scope.pago = $scope.statusPayform[1];
          break;
        case 3:
          $scope.pago = $scope.statusPayform[2];
          break;
        case 4:
          $scope.pago = $scope.statusPayform[3];
          break;
        case 5:
          $scope.pago = $scope.statusPayform[4];
          break;
        case 6:
          $scope.pago = $scope.statusPayform[5];
          break;
        default:
          $scope.pago = "";
      }

      switch (folio.curr_rate) {
        case 1:
          $scope.rate = $scope.curr_rate_options[0];
          break;
        case 2:
          $scope.rate = $scope.curr_rate_options[1];
          break;
        case 3:
          $scope.rate = $scope.curr_rate_options[2];
          break;
        case 4:
          $scope.rate = $scope.curr_rate_options[3];
          break;
        case 5:
          $scope.rate = $scope.curr_rate_options[4];
          break;
        default:
          $scope.rate = "";
      }

      $scope.pay_doc = folio.pay_doc;
      $scope.bancos = folio.bank ? folio.bank.alias : "";
      $scope.folio_to_folio = folio.folio;
      $scope.changedPago($scope.pago, 1);
      $scope.changedRate($scope.rate, 1);
      $scope.matchesBanks({ val: $scope.bancos }, 3);
    };
    // ************
    // Edit Contractor
    $scope.chngDesc = false;
    $scope.changeDescriptionC = function (val) {
      $scope.chngDesc = val;
    };
    $scope.saveDescript = function (cntr) {
      $http
        .get(url.IP + "polizas/" + receipt.poliza_id)
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            $http
              .patch(response.data.contractor, {
                description: cntr.description,
              })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    swal(
                      "Hecho",
                      "Las observaciones se han guardado",
                      "success"
                    );
                    $scope.chngDesc = false;
                    $scope.nj_contractor = request.data;
                  } else {
                    swal("Error", "No se guardo la información.", "error");
                  }
                  var paramsCont = {
                    model: cntr.type_person == "Fisica" ? 2 : 3,
                    event: "PATCH",
                    associated_id: cntr.id,
                    identifier:
                      " actualizo las observaciones del contratante (Observaciones: " +
                      cntr.description +
                      ".",
                  };
                  dataFactory
                    .post("send-log/", paramsCont)
                    .then(function success(response) {});
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          }
        });
    };
    // ************************
    function changeReceiptStatus(b, p) {
      var original_receipt = angular.copy(receipt);
      if (
        (original_receipt.status == 6 &&
          $scope.status != original_receipt.status &&
          $scope.change_to_conciliate == false) ||
        vm.acceso_desconc_rec == false
      ) {
        SweetAlert.swal(
          "Error",
          "No tiene permiso para hacer cambios en recibos conciliados",
          "warning"
        );
        return;
      }
      if (vm.folioPay) {
        if ($scope.dataToSave.pay_form == undefined) {
          toastr.warning("Ingrese una forma de pago");
          return;
        }
        if ($scope.dataToSave.curr_rate == undefined) {
          toastr.warning("Ingrese un tipo de cambio");
          return;
        }
        if ($scope.pay_doc == undefined) {
          toastr.warning("Ingrese un documento de pago");
          return;
        }
        if ($scope.bank_sb == undefined) {
          toastr.warning("Ingrese un banco");
          return;
        } else {
          $scope.bank_folio = {};
          $scope.bank_folio.url = $scope.bank_sb.url;
          $scope.bank_folio.alias = $scope.bank_sb.val;
        }
      }
      if (!$scope.desliquidar) {
        SweetAlert.swal(
          "Error",
          "No tiene permiso para hacer cambios en recibos liquidados o conciliados",
          "warning"
        );
        return;
      }
      /* Boton de carga */
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      /* Sube archivos */
      $scope.userInfo = {
        id: receipt.id,
      };
      if ($scope.fecha_pago) {
        $scope.fecha_pago = $scope.fecha_pago;
      } else if (p) {
        $scope.fecha_pago = toDate(p);
      } else {
        $scope.fecha_pago = new Date();
      }
      $scope.userInfo.url = $scope.uploader.url = receipt.url + "archivos/";
      $scope.uploader.uploadAll();

      $scope.dataToSave.pay_doc = $scope.pay_doc ? $scope.pay_doc : "";
      $scope.dataToSave.description = $scope.description;
      $scope.dataToSave.url = receipt.url;

      $scope.dataToSave.liquidacion_doc = $scope.liquidacion_doc
        ? $scope.liquidacion_doc
        : "";

      if ($scope.status == 1) {
        $scope.dataToSave.bank = $scope.bank_sb ? $scope.bank_sb.url : null;
        $scope.dataToSave.user_pay = $scope.user_pay
          ? $scope.user_pay.url
          : null;
        $scope.dataToSave.folio_pago = $scope.folio_to_folio
          ? $scope.folio_to_folio
          : null;
      } else if ($scope.status == 5) {
        $scope.dataToSave.liquidacion_bank = $scope.bank_sb
          ? $scope.bank_sb.url
          : null;
      }

      receipt.status = $scope.dataToSave.status;
      if (receipt.policy) {
        if (receipt.policy.url) {
          $http.get(receipt.policy.url).then(function (response) {
            if (response.status === 200 || response.status === 201) {
              $scope.poliza_recibo = response.data;
              var fecha_inicio = toDate(
                convertDate($scope.poliza_recibo.start_of_validity)
              );
              var fecha_fin = toDate(
                convertDate($scope.poliza_recibo.end_of_validity)
              );
            }
          });
        } else {
          $http
            .get(url.IP + "polizas/" + $scope.insurance.id)
            .then(function (response) {
              if (response.status === 200 || response.status === 201) {
                $scope.poliza_recibo = response.data;
                var fecha_inicio = toDate(
                  convertDate($scope.poliza_recibo.start_of_validity)
                );
                var fecha_fin = toDate(
                  convertDate($scope.poliza_recibo.end_of_validity)
                );
              }
            });
        }
      } else if (receipt.fianza) {
        if (receipt.fianza.url) {
          $http.get(receipt.fianza.url).then(function (response) {
            if (response.status === 200 || response.status === 201) {
              $scope.poliza_recibo = response.data;
              var fecha_inicio = toDate(
                convertDate($scope.poliza_recibo.start_of_validity)
              );
              var fecha_fin = toDate(
                convertDate($scope.poliza_recibo.end_of_validity)
              );
              // if ($scope.poliza_recibo.status != 10) {
              //   if($scope.fecha_pago < fecha_inicio){
              //     SweetAlert.swal("Error", "Fecha de pago no puede ser menor a la fecha de vigencia póliza, se guardará con la fecha de hoy", "error");
              //     $scope.fecha_pago = convertDate(new Date());
              //     l.stop();
              //     return;
              //   }else{
              //   }
              // }
            }
          });
        } else {
          $http.get(receipt.fianza).then(function (response) {
            if (response.status === 200 || response.status === 201) {
              $scope.poliza_recibo = response.data;
              var fecha_inicio = toDate(
                convertDate($scope.poliza_recibo.start_of_validity)
              );
              var fecha_fin = toDate(
                convertDate($scope.poliza_recibo.end_of_validity)
              );
              // if ($scope.poliza_recibo.status != 10) {
              //   if($scope.fecha_pago < fecha_inicio){
              //     SweetAlert.swal("Error", "Fecha de pago no puede ser menor a la fecha de vigencia póliza, se guardará con la fecha hoy", "error");
              //     $scope.fecha_pago = convertDate(new Date());
              //     l.stop();
              //     return;
              //   }else{
              //   }
              // }
            }
          });
        }
      }

      if (b) {
        $scope.dataToSave.bank = $scope.banco
          ? $scope.banco.value.undefined
          : null;
      }
      var payDate2 = $scope.fecha_pago ? $scope.fecha_pago : new Date();

      if (vm.folioPay) {
        $scope.array_folio_pay = {
          folio: vm.folio_pay,
          pay_form: $scope.dataToSave.pay_form,
          curr_rate: $scope.dataToSave.curr_rate,
          pay_doc: $scope.dataToSave.pay_doc,
          bank: $scope.bank_folio.url,
          pay_date: payDate2,
        };

        dataFactory
          .post("folios-pago/", $scope.array_folio_pay)
          .then(function success(response) {
            toastr.info("Se ha guardado el folio de pago: " + vm.folio_pay);
          });
      }
      $scope.dataToSave.rate_exchange = $scope.dataToSave.rate_exchange
        ? $scope.dataToSave.rate_exchange
        : 1;
      if ($scope.dataToSave.status == 1) {
        $scope.dataToSave.pay_date = $scope.fecha_pago
          ? $scope.fecha_pago
          : new Date();
        $scope.dataToSave.user_pay = $scope.user_pay
          ? $scope.user_pay.url
          : null;
        $scope.dataToSave.folio_pago = $scope.folio_to_folio
          ? $scope.folio_to_folio
          : null;
        $scope.dataToSave.rate_exchange = $scope.dataToSave.rate_exchange
          ? $scope.dataToSave.rate_exchange
          : 1;
      } else if ($scope.dataToSave.status == 5) {
        $scope.dataToSave.liquidacion_date = $scope.fecha_pago
          ? $scope.fecha_pago
          : new Date();
      } else if (receipt.status == 3) {
        if (!$scope.description) {
          SweetAlert.swal(
            "Error",
            "No se han ingresado observaciones",
            "error"
          );
          l.stop();
          return;
        }
      }

      $localStorage.receiptUpdated = {
        id: receipt.id,
        status: receipt.status,
      };
      $localStorage.receiptModified = true;
      if ($scope.display_input) {
        $scope.dataToSave.excedente = vm.excedente;
      }
      if ($scope.dataToSave.status == 10) {
        //anulado
        if (
          (insurance.document_type == 7 || insurance.document_type == 8) &&
          receipt.endorsement &&
          receipt.receipt_type == 2
        ) {
          if (receipt.endoso_informacion) {
            if (receipt.endoso_informacion[0].status == 2) {
              $http
                .patch(receipt.endoso_informacion[0].url, { status: 6 })
                .then(function success(response) {});
            }
          }
        }
      }
      if (original_receipt.status == 10 && $scope.dataToSave.status != 10) {
        //anulado
        if (
          (insurance.document_type == 7 || insurance.document_type == 8) &&
          receipt.endorsement &&
          receipt.receipt_type == 2
        ) {
          if (receipt.endoso_informacion) {
            if (receipt.endoso_informacion[0].status == 6) {
              $http
                .patch(receipt.endoso_informacion[0].url, {
                  status: 2,
                  endorsement_receipt: [],
                })
                .then(function success(response) {});
            }
          }
        }
      }

      if ($scope.dataToSave.status == 6) {
        vm.conciliarRecibo(receipt);
      }
      if (!helpers.isTheReceiptCanceled(receipt.status)) {
        receiptService
          .updateReceiptServiceL($scope.dataToSave)
          .then(function (data) {
            if (data.status === 200 || data.status === 201) {
              if ($scope.dataToSave.pay_form == 7) {
                var nota_pay_data = {
                  pay_form: 8,
                  curr_rate: $scope.dataToSave.curr_rate,
                  pay_doc: "Aplicación de recibo",
                  pay_date: payDate2,
                  status: 1,
                };
                $http.patch(data.data.url, nota_pay_data);
              }
              if ($location.$$path == "/index/main") {
                $http({
                  method: "GET",
                  url: url.IP + "chart-recibos/",
                }).then(function (recibos) {
                  $localStorage.receipt_count = recibos.data;
                  $state.go("index.main");
                  // $state.reload();
                });
              }
              toaster.success(MESSAGES.OK.UPDATERECEIPT);
              if (
                receipt.status == 1 &&
                (receipt.receipt_type == 2 || receipt.receipt_type == 1)
              ) {
                // if (receipt.contratante){
                //   if(receipt.contratante.email){
                //     //Send Email
                //     if($localStorage.email_config){
                //       if($localStorage.email_config.cobranza_pago == true){
                //         $scope.idRecibo = receipt.id
                //         var model = 6;
                //         emailService.sendEmailAtm(model,$scope.idRecibo)
                //       }
                //     }
                //     //Send Email
                //   }
                // }else if ($scope.insurance.contractor){
                //   // $scope.contratante_ok={}
                //   // try{
                //   //   $http.get(url.IP + 'contractor/'+$scope.insurance.contractor).then(function(respuesta) {
                //   //     if(respuesta.status === 200 || respuesta.status === 201) {
                //   //       $scope.contratante_ok=respuesta.data
                //   //     }
                //   //   });
                //   // }catch(e){
                //   //   if($scope.nj_contractor){
                //   //     $scope.contratante_ok=$scope.nj_contractor
                //   //   }else{
                //   //     $scope.contratante_ok=$scope.insurance.contractor
                //   //   }
                //   // }
                //   if($scope.nj_contractor.email){
                //     //Send Email
                //     if($localStorage.email_config){
                //       if($localStorage.email_config.apply_nota == true){
                //           $scope.idNota = receipt.id;
                //           var model = 8;
                //           emailService.sendEmailAtm(model,$scope.idNota)
                //         }else{

                //       }
                //     }
                //     //Send Email
                //   }
                // }
                SweetAlert.swal(
                  "¡Listo!",
                  "El recibo ha sido pagado.",
                  "success"
                );
                if ($scope.insurance.status == 4) {
                  var params = {
                    model: 1,
                    event: "PATCH",
                    associated_id: $scope.insurance.id,
                    identifier:
                      " actualizó póliza de Precancelada a vigente al cambiar un recibo de estatus",
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  $http.patch($scope.insurance.url, { status: 14 });
                }
              }
              if (receipt.status == 1 && receipt.receipt_type == 3) {
                // if (receipt.contratante){
                //   if(receipt.contratante){
                //     //Send Email
                //     if($localStorage.email_config){
                //       if($localStorage.email_config.apply_nota == true){
                //           $scope.idNota = receipt.id;
                //           var model = 8;
                //           emailService.sendEmailAtm(model,$scope.idNota)
                //         }else{

                //       }
                //     }
                //     //Send Email
                //   }
                // }else if ($scope.insurance.contractor){
                //   if($scope.insurance.contractor.email){
                //     //Send Email
                //     if($localStorage.email_config){
                //       if($localStorage.email_config.apply_nota == true){
                //           $scope.idNota = receipt.id;
                //           var model = 8;
                //           emailService.sendEmailAtm(model,$scope.idNota)
                //         }else{

                //       }
                //     }
                //     //Send Email
                //   }
                // }
                SweetAlert.swal(
                  "¡Listo!",
                  "El recibo ha sido pagado.",
                  "success"
                );
                if ($scope.insurance.status == 4) {
                  $http.patch($scope.insurance.url, { status: 14 });
                }
              }
              if ($uibModalInstance) {
                if (from) {
                  $uibModalInstance.close(5);
                } else {
                  $uibModalInstance.close(data.data);
                }
              }
              if ($uibModalInstance) {
                if (from) {
                  $uibModalInstance.close(5);
                } else {
                  $uibModalInstance.close(data.data);
                }
              }

              if (receipt.status == 1) {
                $scope.status_receipt = "actualizó el recibo a pagado.";
              } else if (receipt.status == 2) {
                $scope.status_receipt = "actualizó el recibo a cancelado.";
              } else if (receipt.status == 3) {
                $scope.status_receipt = "actualizó el recibo a prorrogado.";
              } else if (receipt.status == 4) {
                $scope.status_receipt = "actualizó el recibo a pendiente.";
              } else if (receipt.status == 5) {
                $scope.status_receipt = "actualizó el recibo a liquidado.";
              } else if (receipt.status == 6) {
                $scope.status_receipt = "actualizó el recibo a conciliado.";
              } else if (receipt.status == 7) {
                $scope.status_receipt = "actualizó el recibo a cerrado.";
              } else if (receipt.status == 8) {
                $scope.status_receipt = "actualizó el recibo a Precancelado.";
              } else if (receipt.status == 9) {
                $scope.status_receipt = "actualizó el recibo a Pago Parcial.";
              } else if (receipt.status == 10) {
                $scope.status_receipt = "actualizó el recibo a Anulado.";
              } else if (receipt.status == 11) {
                $scope.status_receipt = "actualizó el recibo a Preanulado.";
              } else {
                $scope.status_receipt =
                  "actualizó el recibo (código estatus = " + receipt.status
                    ? receipt.status
                    : "";
              }
              var params = {
                model: 4,
                event: "POST",
                associated_id: receipt.id,
                identifier: $scope.status_receipt,
              };
              if (
                receipt.description != $scope.description &&
                params["identifier"]
              ) {
                params["identifier"] =
                  params["identifier"] +
                  " actualizo las observaciones del Recibo: " +
                  $scope.description;
              } else if (
                receipt.description != $scope.description &&
                params["identifier"] == undefined
              ) {
                params["identifier"] =
                  "Actualizo las observaciones del Recibo: " +
                  $scope.description;
              }
              dataFactory
                .post("send-log/", params)
                .then(function success(response) {
                  if ($scope.insurance.document_type == 1) {
                    var paramsPol = {
                      model: 1,
                      event: "POST",
                      associated_id: $scope.insurance.id,
                      identifier: params["identifier"],
                    };
                    dataFactory
                      .post("send-log/", paramsPol)
                      .then(function success(response) {});
                  } else if ($scope.insurance.document_type == "Carátula") {
                    var paramsF = {
                      model: 18,
                      event: "POST",
                      associated_id: $scope.insurance.id,
                      identifier: params["identifier"],
                    };
                    dataFactory
                      .post("send-log/", paramsF)
                      .then(function success(response) {});
                  } else if ($scope.insurance.document_type == 7) {
                    var paramsF = {
                      model: 13,
                      event: "POST",
                      associated_id: $scope.insurance.id,
                      identifier: params["identifier"],
                    };
                    dataFactory
                      .post("send-log/", paramsF)
                      .then(function success(response) {});
                  }
                });
            }
            // else {
            //   swal("¡Error!", "Ha ocurrido un error.", "error");
            //   l.stop();
            // }
          });
      } else {
        swal(
          {
            title: receipt.endorsement
              ? "Cancelar Recibo"
              : "Cancelar Recibo y Póliza",
            text: receipt.endorsement
              ? "El Recibo será cancelado"
              : "Todos los recibos futuros y la póliza quedarán cancelados, ¿Estás seguro?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Sí, cancelar",
            cancelButtonText: "No",
            closeOnConfirm: false,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              var recibo_cancelado = receiptService.cancelReceiptsFrom(
                receipt,
                $scope.insurance.id
              );
              swal(
                "¡Cancelado!",
                "Se han cancelado todos los recibos futuros y la póliza. (No se cancelaron recibos pagados)",
                "success"
              );
              $uibModalInstance.close(recibo_cancelado);
            } else {
              l.stop();
              swal("No cancelado", "No se aplicó ningun cambio", "error");
              $uibModalInstance.cancel("cancel");
            }
          }
        );
      }
    }

    function activate() {
      if (
        parseInt(receipt.status) == 6 ||
        receipt.status == "Conciliado" ||
        receipt.status == "CONCILIADO"
      ) {
        $scope.boton_liquidado = true;
      }
      $http.get(url.IP + "get-pagos/" + receipt.id).then(function (response) {
        vm.pagos = response.data;
        vm.pagos_parciales_total = 0;
        vm.pagos_parciales_restante = 0;
        vm.pagos.forEach(function (pago) {
          vm.pagos_parciales_total += parseFloat(pago.pago);
        });
        vm.pagos_parciales_restante =
          receipt.prima_total - vm.pagos_parciales_total;
      });

      $http
        .get(url.IP + "get-pagos-subsecuentes/" + receipt.id)
        .then(function (can_pay) {
          $scope.can_pay = can_pay.data.canpay;
        });

      $scope.change_to_conciliate = false;
      $scope.recordatorios = [];
      if (receipt.recordatorios) {
        $scope.recordatorios = receipt.recordatorios
          ? receipt.recordatorios
          : [];
      }
      if (insurance.document_type == 7 || insurance.document_type == 8) {
        $scope.statusReceipt = [
          // {label: 'CANCELADO', value: 2 },
          { label: "PENDIENTE DE PAGO", value: 4 },
          { label: "CERRADO", value: 7 },
          // {label: 'PRECANCELADO', value: 8 },
          { value: 10, label: "ANULADO" },
          { value: 11, label: "PREANULADO" },
        ];
        $scope.statusReceipt_C = [
          { label: "PAGADO", value: 1 },
          // {label: 'CANCELADO', value: 2 },
          { label: "PRORROGADO", value: 3 },
          { label: "PENDIENTE DE PAGO", value: 4 },
          { label: "LIQUIDADO", value: 5 },
          { label: "CONCILIADO", value: 6 },
          { label: "CERRADO", value: 7 },
          // {label: 'PRECANCELADO', value: 8 },
          { label: "PAGO PARCIAL", value: 9 },
          { value: 10, label: "ANULADO" },
          { value: 11, label: "PREANULADO" },
        ];
      } else {
        $scope.statusReceipt = [
          { label: "CANCELADO", value: 2 },
          { label: "PENDIENTE DE PAGO", value: 4 },
          { label: "CERRADO", value: 7 },
          { label: "PRECANCELADO", value: 8 },
        ];
        $scope.statusReceipt_C = [
          { label: "PAGADO", value: 1 },
          { label: "CANCELADO", value: 2 },
          { label: "PRORROGADO", value: 3 },
          { label: "PENDIENTE DE PAGO", value: 4 },
          { label: "LIQUIDADO", value: 5 },
          { label: "CONCILIADO", value: 6 },
          { label: "CERRADO", value: 7 },
          { label: "PRECANCELADO", value: 8 },
          { label: "PAGO PARCIAL", value: 9 },
        ];
      }
      var receiptParam = receipt;
      $scope.receiptPar = receipt;
      $scope.user = usr;
      vm.accesos = $sessionStorage.permisos;
      vm.accesos.forEach(function (acceso) {
        if (acceso.model_name == "Cobranza") {
          vm.acceso_cob = acceso;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_rec = true;
                $scope.statusReceipt.unshift({ label: "PAGADO", value: 1 });
                $scope.statusReceipt.unshift({ label: "PRORROGADO", value: 3 });
                $scope.statusReceipt.unshift({
                  label: "PAGO PARCIAL",
                  value: 9,
                });
              } else {
                vm.acceso_pag_rec = false;
                $scope.statusReceipt_C.splice(
                  $scope.statusReceipt_C.indexOf({ label: "PAGADO", value: 1 }),
                  1
                );
                $scope.statusReceipt_C.splice(
                  $scope.statusReceipt_C.indexOf({
                    label: "PRORROGADO",
                    value: 3,
                  }),
                  1
                );
                $scope.statusReceipt_C.splice(
                  $scope.statusReceipt_C.indexOf({
                    label: "PAGO PARCIAL",
                    value: 9,
                  }),
                  1
                );
                $scope.statusReceipt.splice(
                  $scope.statusReceipt.indexOf({ label: "PAGADO", value: 1 }),
                  1
                );
                $scope.statusReceipt.splice(
                  $scope.statusReceipt.indexOf({
                    label: "PRORROGADO",
                    value: 3,
                  }),
                  1
                );
                $scope.statusReceipt.splice(
                  $scope.statusReceipt.indexOf({
                    label: "PAGO PARCIAL",
                    value: 9,
                  }),
                  1
                );
              }
            }
            if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desconc_rec = true;
              } else {
                vm.acceso_desconc_rec = false;
                if (receipt.status == "Conciliado" || receipt.status == 6) {
                  $scope.statusReceipt_C.splice(
                    $scope.statusReceipt_C.indexOf({
                      label: "PRORROGADO",
                      value: 3,
                    }),
                    1
                  );
                  $scope.statusReceipt_C.splice(
                    $scope.statusReceipt_C.indexOf({
                      label: "PENDIENTE DE PAGO",
                      value: 4,
                    }),
                    1
                  );
                  $scope.statusReceipt_C.splice(
                    $scope.statusReceipt_C.indexOf({
                      label: "PAGADO",
                      value: 1,
                    }),
                    1
                  );
                  $scope.statusReceipt.splice(
                    $scope.statusReceipt.indexOf({
                      label: "PRORROGADO",
                      value: 3,
                    }),
                    1
                  );
                  $scope.statusReceipt.splice(
                    $scope.statusReceipt.indexOf({
                      label: "PENDIENTE DE PAGO",
                      value: 4,
                    }),
                    1
                  );
                  $scope.statusReceipt.splice(
                    $scope.statusReceipt.indexOf({ label: "PAGADO", value: 1 }),
                    1
                  );
                  $scope.statusReceipt_C.splice(
                    $scope.statusReceipt_C.indexOf({
                      label: "LIQUIDADO",
                      value: 5,
                    }),
                    1
                  );
                  $scope.statusReceipt.splice(
                    $scope.statusReceipt.indexOf({
                      label: "LIQUIDADO",
                      value: 5,
                    }),
                    1
                  );
                }
              }
            }
            if (acc.permission_name == "Desliquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_desliq_rec = true;
              } else {
                vm.acceso_desliq_rec = false;
                if (receipt.status == "Liquidado" || receipt.status == 5) {
                  $scope.statusReceipt_C.splice(
                    $scope.statusReceipt_C.indexOf({
                      label: "PRORROGADO",
                      value: 3,
                    }),
                    1
                  );
                  $scope.statusReceipt_C.splice(
                    $scope.statusReceipt_C.indexOf({
                      label: "PENDIENTE DE PAGO",
                      value: 4,
                    }),
                    1
                  );
                  $scope.statusReceipt_C.splice(
                    $scope.statusReceipt_C.indexOf({
                      label: "PAGADO",
                      value: 1,
                    }),
                    1
                  );
                  $scope.statusReceipt.splice(
                    $scope.statusReceipt.indexOf({
                      label: "PRORROGADO",
                      value: 3,
                    }),
                    1
                  );
                  $scope.statusReceipt.splice(
                    $scope.statusReceipt.indexOf({
                      label: "PENDIENTE DE PAGO",
                      value: 4,
                    }),
                    1
                  );
                  $scope.statusReceipt.splice(
                    $scope.statusReceipt.indexOf({ label: "PAGADO", value: 1 }),
                    1
                  );
                }
              }
            }
            if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_despag_rec = true;
              } else {
                vm.acceso_despag_rec = false;
                if (receipt.status == "Pagado" || receipt.status == 1) {
                  $scope.statusReceipt_C.splice(
                    $scope.statusReceipt_C.indexOf({
                      label: "PRORROGADO",
                      value: 3,
                    }),
                    1
                  );
                  $scope.statusReceipt_C.splice(
                    $scope.statusReceipt_C.indexOf({
                      label: "PENDIENTE DE PAGO",
                      value: 4,
                    }),
                    1
                  );

                  $scope.statusReceipt.splice(
                    $scope.statusReceipt.indexOf({
                      label: "PRORROGADO",
                      value: 3,
                    }),
                    1
                  );
                  $scope.statusReceipt.splice(
                    $scope.statusReceipt.indexOf({
                      label: "PENDIENTE DE PAGO",
                      value: 4,
                    }),
                    1
                  );
                }
              }
            }
            if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_rec = true;
                $scope.change_to_conciliate = true;
                vm.changeConciliate = true;
                $scope.statusReceipt.unshift({ label: "CONCILIADO", value: 6 });
                $scope.statusReceipt_C.unshift({
                  label: "CONCILIADO",
                  value: 6,
                });
              } else {
                vm.acceso_conc_rec = false;
                vm.changeConciliate = false;
                $scope.change_to_conciliate = false;
                // $scope.statusReceipt.splice($scope.statusReceipt.indexOf({label: 'CONCILIADO', value: 6 }),1)
                $scope.statusReceipt.splice(
                  $scope.statusReceipt.indexOf({
                    label: "CONCILIADO",
                    value: 6,
                  }),
                  1
                );
                $scope.statusReceipt_C.splice(
                  $scope.statusReceipt_C.indexOf({
                    label: "CONCILIADO",
                    value: 6,
                  }),
                  1
                );
              }
            }
            if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_rec = true;
                $scope.statusReceipt.unshift({ label: "LIQUIDADO", value: 5 });
                $scope.statusReceipt_C.unshift({
                  label: "LIQUIDADO",
                  value: 5,
                });
              } else {
                vm.acceso_liq_rec = false;
                $scope.statusReceipt.splice(
                  $scope.statusReceipt.indexOf({
                    label: "LIQUIDADO",
                    value: 5,
                  }),
                  1
                );
                $scope.statusReceipt_C.splice(
                  $scope.statusReceipt_C.indexOf({
                    label: "LIQUIDADO",
                    value: 5,
                  }),
                  1
                );
              }
            }
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
                if (
                  !vm.acceso_liq_rec &&
                  !vm.acceso_conc_rec &&
                  !vm.acceso_liq_rec &&
                  !vm.acceso_pag_rec
                ) {
                  if (
                    insurance.document_type == 7 ||
                    insurance.document_type == 8
                  ) {
                    $scope.statusReceipt = [];
                    $scope.statusReceipt_C = [];
                  } else {
                    $scope.statusReceipt = [];
                    $scope.statusReceipt_C = [];
                  }
                }
              } else {
                vm.acceso_ver_cob = false;
              }
            }
            if (acc.model_name == "Mensajeria") {
              $scope.acceso_mns = acc;
              $scope.acceso_mns.permissions.forEach(function (acc) {
                if (acc.permission_name == "Mensajeria") {
                  if (acc.checked == true) {
                    $scope.acceso_mns = true;
                  } else {
                    $scope.acceso_mns = false;
                  }
                }
              });
            }
          });
        }
        if (acceso.model_name == "Correos electronicos") {
          vm.acceso_correo = acceso;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        }
        if (acceso.model_name == "Endosos") {
          vm.acceso_endosos = acceso;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        }
        if (acceso.model_name == "Mensajeria") {
          $scope.acceso_mns = acceso;
          $scope.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                $scope.acceso_mns = true;
              } else {
                $scope.acceso_mns = false;
              }
            }
          });
        }
        if (acceso.model_name == "Archivos") {
          $scope.acceso_files = acceso;
          $scope.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                $scope.permiso_archivos = true;
                vm.permiso_archivos = true;
              } else {
                $scope.permiso_archivos = false;
                vm.permiso_archivos = false;
              }
            }
            if (acc.permission_name == "Administrar adjuntos") {
              if (acc.checked == true) {
                $scope.permiso_administrar_adjuntos = true;
                $scope.permiso_administrar_adjuntos = true;
                vm.permiso_administrar_adjuntos = true;
              } else {
                $scope.permiso_administrar_adjuntos = false;
                vm.permiso_administrar_adjuntos = false;
              }
            }
          });
        }
        if (acceso.model_name == "Pólizas") {
          $scope.acceso_polizas = acceso;
          $scope.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_adm_pol = true;
              } else {
                $scope.acceso_adm_pol = false;
              }
            }
            if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                $scope.acceso_ver_pol = true;
              } else {
                $scope.acceso_ver_pol = false;
              }
            }
            if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_canc_pol = true;
              } else {
                $scope.acceso_canc_pol = false;
                if (insurance) {
                  if (
                    receipt.receipt_type == 1 &&
                    insurance.document_type == 1
                  ) {
                    $scope.statusReceipt.splice(
                      $scope.statusReceipt.indexOf({
                        label: "CANCELADO",
                        value: 2,
                      }),
                      1
                    );
                    $scope.statusReceipt.splice(
                      $scope.statusReceipt.indexOf({
                        label: "PRECANCELADO",
                        value: 8,
                      }),
                      1
                    );
                    $scope.statusReceipt_C.splice(
                      $scope.statusReceipt_C.indexOf({
                        label: "CANCELADO",
                        value: 2,
                      }),
                      1
                    );
                    $scope.statusReceipt_C.splice(
                      $scope.statusReceipt_C.indexOf({
                        label: "PRECANCELADO",
                        value: 8,
                      }),
                      1
                    );
                  }
                }
              }
            }
            if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_elim_pol = true;
              } else {
                $scope.acceso_elim_pol = false;
              }
            }
          });
        }
      });

      if (vm.acceso_liq_rec) {
        $scope.stL = false;
        $scope.statusReceipt.forEach(function (st) {
          if (st.value == 5) {
            $scope.stL = true;
          }
        });
        if ($scope.stL == false) {
          $scope.statusReceipt.unshift({ label: "LIQUIDADO", value: 5 });
          $scope.statusReceipt_C.unshift({ label: "LIQUIDADO", value: 5 });
        }
      }

      if (vm.acceso_conc_rec) {
        $scope.stC = false;
        $scope.statusReceipt.forEach(function (st) {
          if (st.value == 6) {
            $scope.stC = true;
          }
        });
        if ($scope.stC == false) {
          vm.changeConciliate = false;
          $scope.statusReceipt.unshift({ label: "CONCILIADO", value: 6 });
          $scope.statusReceipt_C.unshift({ label: "CONCILIADO", value: 6 });
        }
      }
      $scope.statusReceipt.sort(function (a, b) {
        return a.value - b.value;
      });
      $scope.id_recibo = receiptParam.id;
      $scope.desliquidar = true;

      $scope.disabled_liq = false;
      $scope.disabled_pag = false;
      $scope.disabled_conc = false;
      if (vm.acceso_desliq_rec) {
        $scope.disabled_liq = true;
      }
      if (vm.acceso_despag_rec) {
        $scope.disabled_pag = true;
      }
      if (vm.acceso_desconc_rec) {
        $scope.disabled_conc = true;
      }

      var aux_receipt;
      if (receipt.id) {
        aux_receipt = receipt.id;
      } else {
        aux_receipt = receipt;
      }

      $scope.view_cartas = true;
      dataFactory.get("get-delivery").then(function success(responseGet) {
        if (responseGet.status == 200) {
          $scope.delivery_mans = responseGet.data;
        }
      });
      $http
        .get(url.IP + "receipt-pay-data/" + aux_receipt)
        .then(function (recibo) {
          receipt = recibo.data;
          if (receipt.user_pay) {
            $http.get(receipt.user_pay).then(function (data) {
              $scope.user_pay2 = data.data;
            });
          }
          if (receipt.user_liq) {
            $http.get(receipt.user_liq).then(function (data) {
              $scope.user_liq = data.data;
            });
          }
          if (insurance) {
            if (insurance.fianza_number) {
              receipt.poliza_number = insurance.fianza_number;
            }
          }
          $scope.inprocess_toendoso = "";
          if (insurance) {
            if (
              insurance.document_type != "Fianza" &&
              insurance.document_type != 7
            ) {
              $http({
                method: "GET",
                url: url.IP + "get-endosos-policies",
                params: {
                  policy: insurance.id,
                  type: 1,
                },
              }).then(function success(response) {
                if (response.data.endosos) {
                  if (response.data.endosos.length) {
                    $scope.inprocess_toendoso = "En proceso de endoso";
                  }
                }
              });
            } else if (
              insurance.document_type == "Fianza" ||
              insurance.document_type == 7
            ) {
              $http({
                method: "GET",
                url: url.IP + "get-endosos-policies",
                params: {
                  policy: insurance.id,
                  type: 2,
                },
              }).then(function success(response) {
                if (response.data.endosos.length) {
                  $scope.inprocess_toendoso = "En proceso de endoso";
                }
              });
            }
          }
          $scope.status = {};
          $scope.status.value = receipt.status;
          if ($scope.status.value == 5 || $scope.status.value == 6) {
            // $scope.statusReceipt = $scope.statusReceipt_C;
            // $scope.change_to_conciliate = true;
            // if(!vm.acceso_conc_rec){
            //   $scope.change_to_conciliate = false;
            //   // $scope.statusReceipt.splice($scope.statusReceipt.indexOf({label: 'CONCILIADO', value: 6 }),1)
            //   // $scope.statusReceipt_C.splice($scope.statusReceipt_C.indexOf({label: 'CONCILIADO', value: 6 }),1)
            // }else{
            //   console.log('xxxxxxxxxxxxxxx',vm.acceso_conc_rec)
            // }
          }
          $scope.nota = "";
          $http.get(url.IP + "accounts/").then(function (response) {
            vm.accounts = response.data.results;
            $rootScope.acounts_data = response.data.results;
            vm.cuenta = $rootScope.acounts_data[0];
            if (vm.form != undefined || !vm.form) {
              vm.form = {};
            }
            if (receipt.receipt_type == 3) {
              $scope.nota =
                "Las cantidades se guardarán en negativo (comisión conciliada).";
            }
            vm.form.conciliate_date = convertDate(new Date());
            vm.form.comision_conciliada = parseFloat(
              receipt.comision_conciliada
            ).toFixed(2);
            vm.form.comision_conciliada_p_estimada = parseFloat(
              insurance.comision_percent
            ).toFixed(2);
            vm.form.comision_conciliada_p = receipt.comision_conciliada_p
              ? parseFloat(receipt.comision_conciliada_p).toFixed(2)
              : 0;
          });
          $scope.pago = receipt.payform;
          $scope.rate = receipt.curr_rate;
          $scope.pay_doc = receipt.pay_doc;
          $scope.banco = receipt.bank;
          $scope.description = receipt.description;
          $scope.payDate = receipt.pay_date
            ? convertDate(receipt.pay_date)
            : convertDate(new Date());
          $scope.receipt = receipt;
          $scope.insurance = insurance;
          $scope.receipt.contratante = receiptParam.full_name;
          $scope.dataToSave.rate_exchange = parseFloat(receipt.rate_exchange);
          // $scope.receipt.policy = $scope.receiptPar.poliza;
          if (receiptParam.contractor) {
            $scope.receipt.contractor = receiptParam.contractor;
          }
          for (var i = 0; i < statusPayform.length; i++) {
            $scope.statusPayform.push(statusPayform[i]);
            if (receipt.pay_form == i + 1) {
              $scope.pago = statusPayform[i];
            }
          }
          if ($scope.insurance.contractor) {
            if ($scope.insurance.contractor.id) {
              // $scope.insurance.contractor = $scope.insurance.contractor.id
            }
          } else if (receipt.poliza) {
            if (receipt.poliza.contractor) {
              if (receipt.poliza.contractor.id) {
                // $scope.insurance.contractor = receipt.poliza.contractor.id
              }
            }
          }
          if (!$scope.bono) {
            $http({
              method: "GET",
              url: url.IP + "notas-by-contractor",
              params: {
                type_contractor: $scope.insurance.natural
                  ? "natural"
                  : "juridical",
                contractor: $scope.insurance.contractor
                  ? $scope.insurance.contractor.id
                  : 0,
                pendientes: 1,
                poliza_id: $scope.insurance.id,
              },
            }).then(function success(res) {
              if (res.data.length) {
                var nota = {
                  label: "NOTA DE CRÉDITO",
                  value: 10,
                };
                $scope.statusPayform.push(nota);
                // $scope.notascredito = res.data;
                // if($scope.notascredito.length){
                //   $scope.notascredito.forEach(function(nota) {
                //     nota.label = "Folio: " + nota.folio + " - $" + nota.prima_total;
                //   })
                // }
              }
            });
          }

          $http({
            method: "GET",
            url: url.IP + "cartas-by-model",
            params: {
              model: 4,
            },
          }).then(function success(response) {
            vm.cartas = response.data;
          });

          dataFactory.get("leer-folios-pago/").then(function success(response) {
            $scope.folioSave = response.data.results;
          });

          for (var i = 0; i < curr_rate_options.length; i++) {
            $scope.curr_rate_options.push(curr_rate_options[i]);

            if (receipt.curr_rate == i + 1) {
              $scope.rate = curr_rate_options[i];
              try {
                $scope.dataToSave.curr_rate = $scope.rate.value;
              } catch (e) {}
            }
          }

          try {
            $http.get(receipt.bank).then(function (response) {
              var obj_response = {
                label: response.data.alias,
                value: {
                  id: response.data.id,
                  url: response.data.url,
                },
              };
              $scope.banco = obj_response;
            });
          } catch (err) {}

          try {
            $http
              .get($scope.receipt.liquidacion_bank)
              .then(function (response) {
                var obj_response = {
                  label: response.data.alias,
                  value: {
                    id: response.data.id,
                    url: response.data.url,
                  },
                };
                $scope.banco_liquidacion = obj_response;
              });
          } catch (err) {}
          $scope.description = receipt.description;
          $scope.pay_doc = receipt.pay_doc;
          if (!$scope.bono) {
            if ($scope.insurance.contractor) {
              if ($scope.insurance.contractor.id) {
                var idc = $scope.insurance.contractor.id;
              } else {
                var idc = $scope.insurance.contractor;
              }
              dataFactory
                .get("contractors-app/" + idc)
                .then(function success(response) {
                  $scope.nj_contractor = response.data;
                  if (receipt.poliza) {
                    if (receipt.poliza.contractor) {
                      $scope.insurance.contractor = response.data;
                      receipt.poliza.contractor = response.data;
                    }
                  }
                  $scope.address_options = response.data.address_contractor;
                });
            } else {
              $scope.nj_contractor = receipt.full_name;
            }
          }
        });
      getFiles(receipt.id);

      vm.form.comision_conciliada = receipt.comision_conciliada
        ? receipt.comision_conciliada
        : 0;
      vm.form.comision_conciliada_p_estimada = insurance.comision_percent
        ? insurance.comision_percent
        : 0;
      vm.form.comision_conciliada_p = receipt.comision_conciliada_p
        ? receipt.comision_conciliada_p
        : 0;
    }

    function getFiles(id) {
      return receiptService.getFiles(id).then(function (data) {
        vm.files = data;
        return vm.files;
      });
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }

    $scope.selectNote = function (parModel, parType, type) {
      if (type == 1) {
        if (parType == 1) {
          $scope.pay_doc = parModel.label;
        } else if (parType == 2) {
          $scope.pay_doc = parModel;
        }
      } else {
        if (parType == 1) {
          $scope.liquidacion_doc = parModel.label;
        } else if (parType == 2) {
          $scope.liquidacion_doc = parModel;
        }
      }

      $scope.notaToApply = parModel;
    };

    function cancel() {
      if ($uibModalInstance) {
        if (from) {
          $uibModalInstance.close(5);
        } else {
          $uibModalInstance.dismiss("cancel");
        }
      }
    }

    $scope.showInputX = function () {
      $scope.display_input = true;
    };

    $scope.matchesBanks = function (parWord, type) {
      $scope.banks_data = 0;

      if (parWord) {
        $scope.bank_sb = parWord;
        var word_data = parWord.val;
        parWord = parWord.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          var params = {
            pal: parWord,
          };

          dataFactory.get("banks-match/", params).then(function (response) {
            if (response.status === 200) {
              var source = [];
              var groups = response.data.results;
              groups.forEach(function (item) {
                var obj = {
                  label: item.alias,
                  value: item.id,
                  url: item.url,
                };
                source.push(obj);
              });
              $scope.banks_data = source;
              if (type == 3) {
                $scope.bank_sb.url = $scope.banks_data[0].url;
              }
            }
          });
        }
      }
    };

    $scope.eraseInput = function () {
      $scope.manual_opt = true;
      $scope.contratante_opt = false;
      $scope.new_task.address = "";
    };

    $scope.saveTask = function () {
      if ($scope.new_task.address.id) {
        $scope.new_task.address =
          $scope.new_task.address.route +
          " " +
          $scope.new_task.address.street_number +
          " Int. " +
          $scope.new_task.address.street_number_int +
          " " +
          $scope.new_task.address.sublocality +
          " " +
          $scope.new_task.address.administrative_area_level_2 +
          ", " +
          $scope.new_task.address.administrative_area_level_1;
      }
      $scope.new_task.delivery = $scope.new_task.delivery_selected.url;
      $scope.new_task.date = new Date(
        datesFactory.toDate($scope.new_task.fecha)
      );
      $scope.new_task.type_address = $scope.new_task.address.tipo;
      dataFactory
        .post("tasks/", $scope.new_task)
        .then(function success(responseTask) {
          if (responseTask.status == 201 || responseTask.status == 201) {
            SweetAlert.swal("Hecho", "Se ha asigando la tarea", "success");
            vm.form = {};
            vm.form.contratante = {};
            $scope.new_task = {};
            $scope.task = false;
            vm.address = [];
            $uibModalInstance.dismiss("cancel");
          }
        });
    };

    $scope.matchesContractors = function (parWord) {
      $scope.contractors_data = 0;
      var word_data = vm.form.contratante.val;
      if (word_data) {
        if (word_data.length >= 3) {
          dataFactory
            .post("contractors-match/", { matchWord: parWord })
            .then(function (response) {
              if (response.status === 200 && response.data.contractors) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
        $scope.contractors_data = [];
      }
    };

    $scope.$watch("vm.form.contratante.value", function (newValue, oldValue) {
      if (vm.form != undefined) {
        if (vm.form.contratante.value) {
          if (vm.form.contratante.value.full_name) {
            vm.form.contratante.val = vm.form.contratante.value.full_name;
          }
          if (vm.form.contratante.value.address_contractor) {
            vm.address = vm.form.contratante.value.address_contractor;
            toaster.warning("Seleccione la dirección del combo");
          }
          // }

          try {
            if (vm.address.length == 1) {
              vm.form.address = vm.address[0];
            }
          } catch (err) {}
        }
      }
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("CobranzasFoliosCtrl", CobranzasFoliosCtrl);

  CobranzasFoliosCtrl.$inject = [
    "providerService",
    "curr_rate_options",
    "$localStorage",
    "receiptService",
    "statusPayform",
    "toaster",
    "$uibModal",
    "statusReceipt",
    "SweetAlert",
    "MESSAGES",
    "$uibModalInstance",
    "modalService",
    "valueReceipt",
    "$sessionStorage",
    "$http",
    "url",
    "$parse",
    "$scope",
    "$state",
    "exportFactory",
    "$location",
    "dataFactory",
  ];

  function CobranzasFoliosCtrl(
    providerService,
    curr_rate_options,
    $localStorage,
    receiptService,
    statusPayform,
    toaster,
    $uibModal,
    statusReceipt,
    SweetAlert,
    MESSAGES,
    $uibModalInstance,
    modalService,
    valueReceipt,
    $sessionStorage,
    $http,
    url,
    $parse,
    $scope,
    $state,
    exportFactory,
    $location,
    dataFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.pageTitle = "Cobranza";
    vm.receipts = [];
    vm.receipt = {};
    vm.changeStatusModal = changeStatusModal;
    vm.showComment = showComment;
    vm.showPhone = showPhone;
    vm.showEmail = showEmail;
    vm.canceledReceipts = [];
    vm.paidReceipts = [];
    vm.NotasModal = NotasModal;
    vm.pendingReceipts = [];
    vm.close = close;
    vm.liquidar_is_posible = false;
    vm.pagar_is_posible = false;
    // vm.loading = false;
    vm.user = usr;
    vm.table = {};
    vm.emailsReminderAdd = emailsReminderAdd;
    // vm.addEmails = addEmails;
    // vm.deleteEmails = deleteEmails;
    // TODO: quitar al terminar
    vm.user.permiso.editar = true;
    vm.buscar_por_folio = false;
    vm.folio_a_buscar = "";

    vm.responsiv = responsiv;
    vm.getCobranza = getCobranza;
    vm.testPagination = testPagination;
    vm.receipts_to_pay_lenght = 0;

    vm.changeProvider = changeProvider;
    vm.changeReferenciador = changeReferenciador;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeUntil = changeUntil;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.showBinnacle = showBinnacle;
    vm.returnToReceipts = returnToReceipts;
    vm.showAll = showAll;
    vm.returnToNote = returnToNote;
    vm.tipo_folio_buscar = 1;

    vm.form = {
      provider: 0,
      ramo: 0,
      subramo: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
      payment: 0,
      status: 0,
      contratante: 0,
      group: 0,
      vendedor: 0,
    };

    vm.payment = [
      {
        id: 0,
        name: "Todas las formas de pago",
      },
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];
    vm.table = {
      headers: [
        "Tipo",
        "Contratante",
        "Póliza",
        "Periodo",
        "Aseguradora",
        "Estatus",
        "Prima Total",
        "Creado Por",
        "Antigüedad",
        "Acciones",
      ],
    };
    vm.table_nc = {
      headers: [
        "Contratante",
        "Folio",
        "Número endoso",
        "Número póliza",
        "Fecha emisión",
        "Prima Total",
        "Forma de pago",
        "Moneda",
        "Antigüedad",
        "Acciones",
      ],
    };

    var arr = [];
    var nums = [];
    $scope.form = {};
    $scope.form.emails_reminder = [];
    // $scope.form.emails_reminder.forEach(function(elem, index) {
    //      arr.push(elem);
    // });

    /*Enviar correos*/
    $scope.receiptAll = valueReceipt;
    $scope.showAddEmail = false;
    $scope.show_Email = false;
    $scope.optionsSent = [
      { value: 1, label: "Solo al contratante" },
      { value: 2, label: "Añadir correos adicionales" },
    ];

    $scope.showAddEmails = function (param) {
      if (param.value == 1) {
        $scope.showAddEmail = false;
        $scope.show_Email = true;
      } else {
        $scope.showAddEmail = true;
        $scope.show_Email = false;
      }
    };
    // $(window).load(function() {
    //     $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    activate();
    vm.form.since = convertDate(new Date());
    // var endingDate =  convertDate(new Date().setYear(new Date().getFullYear() + 1));
    var endingDate = convertDate(new Date());
    vm.form.until = endingDate;

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal(
          "Error",
          "La fecha final no puede ser menor que la inicial",
          "error"
        );
        var newdate = convertDate(new Date());
        vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }
    $scope.filesToFolio = function (folio) {
      // Files
      if ($scope.tfolio == 2) {
        $http
          .get(url.IP + "liquidacion/" + folio + "/archivos/")
          .then(function (response) {
            $scope.files = response.data.results;
          });
      }
      // ____________Files
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/liquidate_massive_files.html",
        controller: liquidateMassiveModal,
        controllerAs: "vm",
        ////windowClass: 'animated fadeIn',
        size: "lg",
        // resolve:{'rn':receipt.recibo_numero,'recibo':receipt},
        resolve: {
          form_data: function () {
            return folio;
          },
          files: function () {
            return $scope.files;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(
        function () {},
        function () {}
      );
    };

    function liquidateMassiveModal(
      $timeout,
      $rootScope,
      $scope,
      $uibModalInstance,
      url,
      toaster,
      MESSAGES,
      form_data,
      FileUploader,
      $sessionStorage,
      files
    ) {
      $rootScope.folio = form_data;
      $rootScope.files = files;

      $scope.folio = form_data;
      vm = this;

      /** Uploader files **/
      $scope.userInfo = {
        id: 0,
      };
      $scope.countFile = 0;
      $scope.okFile = 0;
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      //     name: 'customFilter',
      //     fn: function(item, options) {
      //         return this.queue.length < 20;
      //     }
      // });
      // ALERTA SUCCES UPLOADFILES
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $scope.okFile++;
        if ($scope.okFile == $scope.countFile) {
          toaster.success("Se han adjuntado archivos a la liquidación");
          $scope.cancel();

          var params = {
            model: 19,
            event: "POST",
            associated_id: $scope.folio,
            identifier: "liquidación masiva y se adjuntó archivo(s).",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
        }
      };
      $scope.changeSensible = function (sensible, index) {
        uploader.queue[index].formData[0].sensible = sensible;
      };

      $scope.saveFile = function (file) {
        $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });

        if (fileItem) {
          $scope.countFile++;
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        if (item.file.sensible != undefined) {
          item.formData[0].sensible = item.file.sensible;
        }
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
        item.formData[0].folio = $scope.userInfo.folio;
      };

      vm.uploadFiles = uploadFiles;
      function uploadFiles(folio) {
        $scope.userInfo = {
          id: folio,
          folio: folio,
        };
        $scope.userInfo.url = $scope.uploader.url =
          url.IP + "liquidacion/" + folio + "/archivos/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }
      $scope.subirArchivos = function (folio) {
        uploadFiles($scope.folio);
      };
      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.close(5);
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    // $(window).load(function() {
    //   $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    getSubramos();
    getProviders();

    function activate() {
      $scope.infoUser = $sessionStorage.infoUser;
      vm.accesos = $sessionStorage.permisos;
      vm.accesos.forEach(function (acceso) {
        if (acceso.model_name == "Cobranza") {
          vm.acceso_cob = acceso;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_rec = true;
              } else {
                vm.acceso_pag_rec = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desconc_rec = true;
              } else {
                vm.acceso_desconc_rec = false;
              }
            } else if (acc.permission_name == "Desliquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_desliq_rec = true;
              } else {
                vm.acceso_desliq_rec = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_rec = true;
              } else {
                vm.acceso_conc_rec = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_rec = true;
              } else {
                vm.acceso_liq_rec = false;
              }
            } else if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            }
          });
        } else if (acceso.model_name == "Correos electronicos") {
          vm.acceso_correo = acceso;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (acceso.model_name == "Pólizas") {
          vm.acceso_polizas = acceso;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            }
          });
        } else if (acceso.model_name == "Reportes") {
          vm.acceso_reportes = acceso;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (acceso.model_name == "Archivos") {
          vm.acceso_files = acceso;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        }
      });
      getSubramos();
      getProviders();
      getUsuarios();
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_fol = 'v2/recibos/leer-folios-pago-consult/';
      $scope.url_go_fol = "leer-folios-pago-consult/";
      $http({
        method: "GET",
        url: url.IP + $scope.url_go_fol,
        params: {
          status: 1,
        },
      }).then(function (results) {
        if (results.data) {
          vm.folios_pago = results.data.folios;
          vm.folios_liquidacion = results.data.liquidacion;
          vm.show_pag_policy = true;
          $scope.show_folios = true;
        }
      });
      if (vm.tipo_folio_buscar == 1) {
        // dataFactory.get('leer-folios-pago/')
        $http({
          method: "GET",
          url: url.IP + $scope.url_go_fol,
          params: {
            status: 1,
          },
        }).then(function success(response) {
          $scope.foliosLiquidacion = [];
          $scope.foliosPago = response.data.folios;
        });
      } else if (vm.tipo_folio_buscar == 2) {
        $scope.foliosPago = [];
        $scope.foliosLiquidacion = results.data.liquidacion;
      }
      getProviders();
      getReferenciador();

      vm.tipo_folio_buscar = $localStorage["save_filters_folio_cobranza"]
        ? $localStorage["save_filters_folio_cobranza"]["tipo_folio_buscar"]
        : 1;
      if (vm.tipo_folio_buscar) {
        // $scope.tipoFolio();
        $scope.url_go_fol = "leer-folios-pago-consult/";
        if (vm.tipo_folio_buscar == 1) {
          dataFactory
            .get("leer-folios-pago-consult/")
            .then(function success(response) {
              $scope.foliosLiquidacion = [];
              $scope.foliosPago = response.data.folios;
              $scope.foliosPago.forEach(function (item) {
                if (
                  item.folio_pago ==
                  $localStorage["save_filters_folio_cobranza"][
                    "folio_a_buscar"
                  ]["folio_pago"]
                ) {
                  vm.folio_a_buscar = item;
                }
              });
            });
        } else if (vm.tipo_folio_buscar == 2) {
          $scope.foliosPago = [];
          $scope.foliosLiquidacion = [];
          $http({
            method: "GET",
            url: url.IP + $scope.url_go_fol,
            params: {
              status: 1,
            },
          }).then(function (results) {
            if (results.data) {
              $scope.foliosLiquidacion = results.data.liquidacion;
              $scope.foliosLiquidacion.forEach(function (item) {
                if (
                  item.liquidacion_folio ==
                  $localStorage["save_filters_folio_cobranza"][
                    "folio_a_buscar"
                  ]["liquidacion_folio"]
                ) {
                  vm.folio_a_buscar = item;
                }
              });
            }
          });
        }
        vm.folio_a_buscar = false;
      }
      vm.folio_a_buscar = $localStorage["save_filters_folio_cobranza"]
        ? $localStorage["save_filters_folio_cobranza"]["folio_a_buscar"]
        : "";
      vm.form.user = $localStorage["save_filters_folio_cobranza"]
        ? $localStorage["save_filters_folio_cobranza"]["user"]
        : "";
    }
    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
      });
    }
    function showAll() {
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_fol = 'v2/recibos/leer-folios-pago-consult/';
      $scope.url_go_fol = "leer-folios-pago-consult/";
      $http({
        method: "GET",
        url: url.IP + $scope.url_go_fol,
        params: {
          status: 1,
        },
      }).then(function (results) {
        if (results.data) {
          vm.folios_pago = results.data.folios;
          vm.folios_liquidacion = results.data.liquidacion;
          vm.rc = results.data.recibos;
          vm.show_pag_policy = true;
          $scope.show_folios = true;
        }
      });
      vm.folio_a_buscar = false;
    }

    function returnToReceipts() {
      vm.show_binnacle = false;
    }
    function returnToNote() {
      vm.show_binnacle_nc = false;
    }
    vm.addFilter = addFilter;
    $scope.fechasFilter = false;

    function addFilter(param) {
      if (param == 1) {
        $scope.fechasFilter = true;
      } else {
        $scope.fechasFilter = false;
      }
    }

    $scope.statusReceipts = function (parStatus) {
      switch (parStatus.status) {
        case 1:
          return "Pagado";
          break;
        case 2:
          return "Cancelado";
          break;
        case 3:
          return "Prorrogado";
          break;
        case 4:
          return "Pendiente de pago";
          break;
        case 9:
          return "Pago Parcial";
          break;
        case 5:
          return "Liquidado";
          break;
        case 6:
          return "Conciliado";
          break;
        case 7:
          return "Cerrado";
          break;
        case 8:
          return "Precancelado";
          break;
        default:
          return "Pendiente de pago";
      }
    };

    $scope.exportData = function (param) {
      $scope.filtros = {
        folio: $scope.folio_active,
        tipo_folio: $scope.tfolio,
      };
      if ($scope.fechasFilter) {
        $scope.filtros.inicial = vm.form.since + " 00:00:00";
        $scope.filtros.final = vm.form.until + " 23:59:59";
      } else {
        $scope.filtros.inicial = "";
        $scope.filtros.final = "";
      }
      $scope.filtros.usuarios = $scope.users;
      if (param == 1) {
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   // $scope.url_go_exc = 'v2/recibos/reporte-folios/';
        //   $scope.url_go_exc = 'service_reporte-v2-folioslist-excel';
        $scope.url_go_exc = "service_reporte-folioslist-excel";
        $http({
          method: "POST",
          url: url.IP + $scope.url_go_exc,
          data: $scope.filtros,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
          .then(function success(request) {
            if (request.status === 200) {
              var blob = new Blob([request.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Folios.xls");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    $scope.tipoFolio = function (param) {
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_fol = 'v2/recibos/leer-folios-pago-consult/';
      $scope.url_go_fol = "leer-folios-pago-consult/";
      if (vm.tipo_folio_buscar == 1) {
        dataFactory
          .get("leer-folios-pago-consult/")
          .then(function success(response) {
            $scope.foliosLiquidacion = [];
            $scope.foliosPago = response.data.folios;
          });
      } else if (vm.tipo_folio_buscar == 2) {
        $scope.foliosPago = [];
        $scope.foliosLiquidacion = [];
        $http({
          method: "GET",
          url: url.IP + $scope.url_go_fol,
          params: {
            status: 1,
          },
        }).then(function (results) {
          if (results.data) {
            $scope.foliosLiquidacion = results.data.liquidacion;
          }
        });
      }
      vm.folio_a_buscar = false;
    };

    function showBinnacle(param) {
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.receipt_id = param.id;
      if (param.gastos_expedicion) {
        vm.notas_id = param.id;
        vm.show_binnacle_nc = true;
      } else {
        vm.show_binnacle = true;
      }
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }
    vm.changeReceipts = changeReceipts;
    function changeReceipts(par, asc) {
      switch (par) {
        case 1:
          Generar($scope.param, par, asc);
          vm.receipts_tipo_asc = asc;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 2:
          Generar($scope.param, par, asc);
          vm.receipts_cont_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 3:
          Generar($scope.param, par, asc);
          vm.receipts_nump_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 4:
          Generar($scope.param, par, asc);
          vm.receipts_periodo_asc = asc;
          vm.receipts_cont_asc = 0;
          vm.receipts_tipo_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 5:
          Generar($scope.param, par, asc);
          vm.receipts_aseg_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          vm.receipts_ffin_asc = 0;
          break;
        case 6:
          Generar($scope.param, par, asc);
          vm.receipts_estatus_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 7:
          Generar($scope.param, par, asc);
          vm.receipts_ptotal_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 8:
          Generar($scope.param, par, asc);
          vm.receipts_operador_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_ffin_asc = 0;
          break;
      }
    }
    vm.show_nota = false;

    function Generar(param, order, asc, page) {
      $scope.param = param;
      getCobranza(param, order, asc, page);
      if (vm.show_binnacle == true || vm.show_binnacle_nc == true) {
        vm.show_binnacle = false;
        vm.show_binnacle_nc = false;
      }
    }

    vm.show_button1 = false;
    vm.show_button2 = false;
    vm.show_button3 = false;
    vm.show_button4 = false;
    vm.show_button0 = false;
    vm.show_button_nc = false;

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
      if (sel.length == 1) {
        if (vm.id) {
          $http.get(url.IP + "subramos-by-ramo/" + vm.id).then(function (data) {
            vm.subramos_toselected = data.data;
          });
        }
      }
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        vm.subramos_selected.push(sr.id);
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    function getCobranza(folio, tipo, asc, parPage, index) {
      if (vm.folio_a_buscar) {
        if (vm.folio_a_buscar <= 0) {
          swal("Error", "Folio inválido", "error");
          return;
        } else {
          if (vm.tipo_folio_buscar == 1) {
            var folio_pl = vm.folio_a_buscar.folio_pago;
            var tipo_folio = vm.tipo_folio_buscar;
          } else if (vm.tipo_folio_buscar == 2) {
            var folio_pl = vm.folio_a_buscar.liquidacion_folio;
            var tipo_folio = vm.tipo_folio_buscar;
          }
          vm.folios_pago = [];
          vm.folios_liquidacion = [];
        }
      } else {
        if (tipo) {
          if (tipo <= 0) {
            swal("Error", "Tipo Folio inválido", "error");
            return;
          } else {
            if (tipo == 1) {
              if (folio) {
                if (folio <= 0) {
                  swal("Error", "Folio inválido", "error");
                  return;
                } else if (folio.folio_pago) {
                  var folio_pl = folio.folio_pago;
                } else {
                  var folio_pl = null;
                }
              }
              var tipo_folio = tipo;
            } else {
              if (tipo == 2) {
                if (folio) {
                  if (folio <= 0) {
                    swal("Error", "Folio inválido", "error");
                    return;
                  } else if (folio.liquidacion_folio) {
                    var folio_pl = folio.liquidacion_folio;
                  }
                }
                var tipo_folio = tipo;
              }
            }
          }
        }
      }
      $scope.tfolio = tipo_folio;
      $scope.folio_active = folio_pl;

      if (vm.form.user) {
        $scope.users = [vm.form.user.id];
      } else {
        $scope.users = [];
      }
      if ($scope.fechasFilter) {
        $scope.inicial = vm.form.since + " 00:00:00";
        $scope.final = vm.form.until + " 23:59:59";
      } else {
        $scope.inicial = "";
        $scope.final = "";
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_recs = 'v2/recibos/get-recibos-folio-pago-liquidacion/';
      $scope.url_go_recs = "get-recibos-folio-pago-liquidacion/";
      $http
        .post(url.IP + $scope.url_go_recs, {
          folio: folio_pl,
          tipo_folio: tipo_folio,
          page: parPage,
          usuarios: $scope.users,
          inicial: $scope.inicial,
          final: $scope.final,
        })
        .then(
          function success(response) {
            if (tipo_folio == 1) {
              $scope.index_folio_p = index;
            } else if (tipo_folio == 2) {
              $scope.index_folio = index;
            }
            vm.receipts_to_pay_lenght = response.data.count;
            if (response.status === 200 && response.data.results.length) {
              $scope.results = response.data.results;
              if (response.data.folios) {
                vm.folios_pago = response.data.folios.folios;
                vm.folios_liquidacion = response.data.folios.liquidacion;
                vm.show_pag_policy = true;
                $scope.show_folios = true;
              }
              // Files
              if (tipo_folio == 2) {
                $http
                  .get(url.IP + "liquidacion/" + folio_pl + "/archivos/")
                  .then(function (response) {
                    $scope.files = response.data.results;
                  });
              }
              // ____________Files
              var item_ = $scope.results[0];

              $scope.head_data = [];
              for (var i in item_) {
                var obj = { field: i };
                $scope.head_data.push(obj);
              }
              vm.receipts = [];
              vm.receipts_liq = [];
              vm.recibosliquidados = [];
              vm.recibospago = [];
              vm.receipts = response.data.results;
              if (response.data) {
                vm.receipts = [];
                if (!vm.folio_a_buscar && tipo_folio == 1) {
                  vm.receipts = response.data.results;
                  vm.receipt = {};
                  vm.receipt_r = {
                    count: response.data.count,
                    previous: response.data.previous,
                    next: response.data.next,
                  };
                  if (vm.receipts) {
                    vm.show_pag_policy = true;
                  } else {
                    vm.show_pag_policy = false;
                  }
                  testPagination("vm.receipts", "vm.receipt");
                } else if (!vm.folio_a_buscar && tipo_folio == 2) {
                  vm.receipts_liq = response.data.results;
                  vm.receipt = {};
                  vm.receipt_l = {
                    count: response.data.count,
                    previous: response.data.previous,
                    next: response.data.next,
                  };
                  if (vm.receipts_liq) {
                    vm.show_pag_policy = true;
                  } else {
                    vm.show_pag_policy = false;
                  }
                  testPagination("vm.receipts_liq", "vm.receipt_l");
                } else if (vm.folio_a_buscar && vm.tipo_folio_buscar == 2) {
                  vm.recibosliquidados = response.data.results;
                  vm.receipt = {};
                  vm.receipt_l = {
                    count: response.data.count,
                    previous: response.data.previous,
                    next: response.data.next,
                  };
                  if (vm.receipts_liq) {
                    vm.show_pag_policy = true;
                  } else {
                    vm.show_pag_policy = false;
                  }
                  testPagination("vm.recibosliquidados", "vm.receipt_l");
                } else if (vm.folio_a_buscar && vm.tipo_folio_buscar == 1) {
                  vm.recibospago = response.data.results;
                  vm.receipt = {};
                  vm.receipt_l = {
                    count: response.data.count,
                    previous: response.data.previous,
                    next: response.data.next,
                  };
                  if (vm.receipts_liq) {
                    vm.show_pag_policy = true;
                  } else {
                    vm.show_pag_policy = false;
                  }
                  testPagination("vm.recibospago", "vm.receipt_l");
                }
              }
            } else {
              vm.receipts = [];
              vm.receipts_liq = [];
              SweetAlert.swal(
                "Sin registros",
                MESSAGES.ERROR.ERRORFOUNDRECEIPTS,
                "info"
              );
            }
          },
          function error(error) {
            swal("Error", "Folio inválido", "error");
            return;
          }
        );

      $localStorage["save_filters_folio_cobranza"]["tipo_folio_buscar"] =
        vm.tipo_folio_buscar ? vm.tipo_folio_buscar : 1;
      $localStorage["save_filters_folio_cobranza"]["folio_a_buscar"] =
        vm.folio_a_buscar ? vm.folio_a_buscar : 0;
      $localStorage["save_filters_folio_cobranza"]["user"] = vm.form.user
        ? vm.form.user
        : 0;
    }

    if ("save_filters_folio_cobranza" in $localStorage) {
    } else {
      $localStorage["save_filters_folio_cobranza"] = {};
    }

    $scope.sendMailContractor = function (receipt) {
      if (receipt.contratante) {
        if (receipt.contratante.email && !receipt.contratante.email == "") {
          var arrayEmails = [];
          arrayEmails = [receipt.contratante.email];
          $http
            .post(url.IP + "payment-reminder-manual/", {
              r_id: receipt.id,
              emails: arrayEmails,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  SweetAlert.swal(
                    "Enviado",
                    "El recordatorio ha sido enviado",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "No se envió el recordatorio. Contacte a su administrador.",
                    "error"
                  );
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          toaster.info("El contratante no tiene correo, agregue correos");
        }
      } else {
        toaster.error("El contratante no tiene correo, agregue correos");
      }
    };

    /* Función que paga o liquida la consulta */
    $scope.liquidar_masivo = function (flag, order, asc, parPage) {
      if (flag == 1) {
        if (vm.receipts_to_pay_lenght > 1)
          var _text =
            "Confirmar el pago de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibos)";
        else
          var _text =
            "Confirmar el pago de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibo)";
        var data_alert = {
          title: "Pagar selección",
          text: _text,
          type: "warning",
          confirmButtonText: "Pagar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
        };
      } else {
        if (vm.receipts_to_pay_lenght > 1)
          var _text =
            "Confirmar liquidación de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibos)";
        else
          var _text =
            "Confirmar liquidación de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibo)";
        var data_alert = {
          title: "Liquidar selección",
          text: _text,
          type: "warning",
          confirmButtonText: "Liquidar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
        };
      }
      SweetAlert.swal(data_alert, function (isConfirm) {
        if (isConfirm) {
          var params = {
            provider: vm.form.provider.id
              ? vm.form.provider.id
              : vm.form.provider,
            vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
            ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
            subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
            since: vm.form.since ? vm.form.since : vm.form.si,
            until: vm.form.until ? vm.form.until : vm.form.un,
            payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
            contratante: vm.form.contratante.value
              ? vm.form.contratante.value
              : 0,
            grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
            type_contractor: vm.form.contratante.type
              ? vm.form.contratante.type
              : 0,
            status: flag,
            page: parPage ? parPage : 1,
            dates: vm.form.dates,
            ramos: vm.ramos_selected ? vm.ramos_selected : 0,
            subramos: vm.subramos_selected ? vm.subramos_selected : 0,
            providers: vm.providers_selected ? vm.providers_selected : 0,
          };
          if (vm.form.contratante.val == "") {
            params.contratante = 0;
            vm.form.contratante.value = "";
            vm.form.contratante.type = "";
          }
          params.since = params.since + " " + "00:00:00";
          params.until = params.until + " " + "23:59:59";
          if ($location.path() == "/cobranzas/recibosPendientes") {
            params.since = "01/01/1950" + " " + "00:00:00";
            params.until = "31/12/2099" + " " + "23:59:59";
            params.status = 1;
          }
          $scope.filtros = params;
          $scope.filtros.order = order;
          $scope.filtros.asc = asc;
          $http({
            method: "POST",
            url: url.IP + "pay-cobranza-massive/",
            data: $scope.filtros,
          }).then(function (response) {
            if (flag == 1) {
              swal(
                "Pagado, folio: " + response.data.folio,
                "La selección ha sido pagada",
                "success"
              );
            } else {
              if (response.data.folio) {
                swal(
                  "Liquidado, folio: " + response.data.folio,
                  "La selección ha sido liquidada",
                  "success"
                );
              } else {
                swal(
                  "Error al liquidar ",
                  "No se han liquidado los recibos",
                  "error"
                );
              }
            }
            getCobranza(flag, order, asc, parPage);
          });
        } else {
        }
      });
    };

    $scope.addEmailsConfirm = function (valueReceipt) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasFoliosCtrl",
        size: "md",
        resolve: {
          valueReceipt: function () {
            return valueReceipt;
          },
        },
      });
    };

    function responsiv() {
      $("#pendientes").trigger("resize");
      $("#pagados").trigger("resize");
      $("#cancelados").trigger("resize");
    }

    function changeStatusModal(receipt) {
      var insurance = receipt.poliza;
      var index = vm.receipts.indexOf(receipt);

      if ($uibModalInstance) {
        $uibModalInstance.close({
          action: 6,
          data: { receipt: receipt, from: true },
        });
      } else {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/cobranzas/cobranzas.modal.html",
          controller: "CobranzasModal",
          size: "lg",
          resolve: {
            receipt: function () {
              return receipt;
            },
            insurance: function () {
              return insurance;
            },
            from: function () {
              return null;
            },
            bono: function () {
              return null;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        modalInstance.result.then(function (receipt) {
          activate();
        });
      }
    }
    function NotasModal(nota) {
      vm.insurance_ = nota;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/notaCredito.modal.html",
        controller: "NotaCreditoCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return nota;
          },
          insurance: function () {
            return vm.insurance_;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        vm.notas_credito.splice(index, 1);
        activate();
      });
    }

    function emailsReminderAdd(receipt) {
      $scope.form = {};
      $scope.form.emails_reminder = [];
      var mail = {
        email: "",
      };
      if (receipt.contratante) {
        var cmail = {
          email: receipt.contratante.email,
        };
      }
      if (receipt.contratante) {
        $scope.form.emails_reminder.push(cmail);
      } else {
        $scope.form.emails_reminder.push(mail);
      }
      vm.insurance_ = receipt;
      $scope.receipt_pay = receipt;
      $uibModal.receipt = receipt;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasFoliosCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return vm.insurance_;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    }

    $scope.addEmails = function (type) {
      var mail = {
        email: "",
      };
      $scope.form.emails_reminder.push(mail);
    };

    $scope.deleteEmails = function (mail, type) {
      $scope.form.emails_reminder.splice(mail, 1);
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    $scope.sendReminder = function (mails) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (mails.length > 0) {
        $scope.error_email = false;
        $scope.receipt_pay = $uibModal.receipt;
        var arrayEmails = [];

        mails.forEach(function (it) {
          if (validateEmail(it.email)) {
            arrayEmails.push(it.email);
          } else {
            $scope.error_email = true;
          }
        });

        if (!$scope.error_email) {
          if ($scope.receiptAll.contratante) {
            arrayEmails.push($scope.receiptAll.contratante.email);
          }

          if (arrayEmails.length == 0) {
            l.stop();
            SweetAlert.swal("Error", "Agregue correos", "error");
            return;
          }

          if (arrayEmails) {
            $http
              .post(url.IP + "payment-reminder-manual/", {
                r_id: $scope.receiptAll.id,
                emails: arrayEmails,
              })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    l.stop();
                    swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                    $uibModalInstance.dismiss("cancel");
                  } else {
                    l.stop();
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                    $uibModalInstance.dismiss("cancel");
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          }
        } else {
          l.stop();
          SweetAlert.swal(
            "Error",
            "Verifique el formato de los correo",
            "error"
          );
        }
      } else {
        if ($scope.receiptAll.contratante) {
          if (
            $scope.receiptAll.contratante.email &&
            !$scope.receiptAll.contratante.email == ""
          ) {
            var arrayEmails = [];
            arrayEmails = [$scope.receiptAll.contratante.email];
            $http
              .post(url.IP + "payment-reminder-manual/", {
                r_id: $scope.receiptAll.id,
                emails: arrayEmails,
              })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    SweetAlert.swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                    $uibModalInstance.dismiss("cancel");
                  } else {
                    SweetAlert.swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                    $uibModalInstance.dismiss("cancel");
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
            toaster.error(
              "El contratante no tiene correo, agregue correos",
              "error"
            );
          }
        }
      }
    };

    function showPhone(receipt) {
      var number = String(receipt.contratante.phone);
      var formattedNumber = number;
      if (number[0] == "1") {
        var c = number[0] == "1" ? "1 " : "";
        number = number[0] == "1" ? number.slice(1) : number;
      } else if (number[0] == "0" && number[1] == "1") {
        var c = number[0] == "0" && number[1] == "1" ? "01 " : "";
        number =
          number[0] == "0" && number[1] == "1" ? number.slice(2) : number;
      } else var c = "";
      var area;
      var front;
      if (
        number.substring(0, 2) == 55 ||
        number.substring(0, 2) == 33 ||
        number.substring(0, 2) == 81
      ) {
        area = number.substring(0, 2);
        front = number.substring(2, 6);
      } else {
        area = number.substring(0, 3);
        front = number.substring(3, 6);
      }

      var end = number.substring(6, 10);
      var ext = number.substring(10, 15);

      if (front) {
        formattedNumber = c + "(" + area + ") " + front;
      }
      if (end) {
        formattedNumber += "-" + end;
      }
      if (ext) {
        formattedNumber += " ext. " + ext;
      }
      SweetAlert.swal({
        title: "Teléfono:",
        text: formattedNumber,
        type: "info",
      });
    }

    function showEmail(receipt) {
      if (receipt.contratante) {
        var data_alert = {
          title: "Correo",
          text: receipt.contratante.email,
          type: "info",
          confirmButtonText: "Enviar recordatorio",
          cancelButtonText: "Salir",
          showCancelButton: true,
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
        };
      } else {
        var data_alert_correo = {
          title: "Correo",
          text: "Escribe el correo para enviar el recordatorio:",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: false,
          animation: "slide-from-top",
          inputPlaceholder: "email@mail.com",
        };
      }
      if (data_alert) {
        SweetAlert.swal(data_alert, function (isConfirm) {
          if (isConfirm) {
            $http
              .post(url.IP + "payment-reminder-manual/", { r_id: receipt.id })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                  } else {
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
          }
        });
      } else if (data_alert_correo) {
        SweetAlert.swal(data_alert_correo, function (inputValue) {
          if (inputValue === false) return false;

          if (inputValue === "") {
            swal.showInputError("Ingresa un correo");
            return false;
          }
          $http
            .post(url.IP + "payment-reminder-manual/", {
              r_id: receipt.id,
              email: inputValue,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  swal("Enviado", "El recordatorio ha sido enviado", "success");
                } else {
                  swal(
                    "Error",
                    "No se envió el recordatorio. Contacte a su administrador.",
                    "error"
                  );
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        });
      }
    }

    function showComment(receipt) {
      SweetAlert.swal({
        title: "Observaciones",
        text: receipt.description,
        type: "info",
      });
    }

    function close() {
      $state.go("index.main");
    }
    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        vm.getCobranza($scope.param_a, $scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
    function testPagination_nc(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages_nc = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page_nc = 1;
      $scope.not_prev = true;
      for (var i = 0; i < pages; i++) {
        $scope.totalPages_nc.push(i + 1);
      }

      $scope.lastPage_nc = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages_nc.length > 5) {
          $scope.end = $scope.totalPages_nc.length;
          $scope.start = $scope.totalPages_nc.length - 5;
          $scope.show_prev_block_nc = true;
        }
        $scope.selectPage_nc($scope.totalPages_nc.length);
        // $scope.actual_page_nc = $scope.totalPages_nc.length;
        // $scope.page = $scope.totalPages_nc.length;
      };

      $scope.selectPage_nc = function (parPage) {
        $scope.actual_page_nc = parPage;

        vm.getNotas($scope.param_a, $scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages_nc = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page_nc) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages_nc.length) {
            $scope.not_next_nc = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block_nc = false;
        }
      };

      $scope.nextBlockPages_nc = function (param) {
        $scope.show_prev_block_nc = true;

        if (param) {
          if ($scope.end > $scope.actual_page_nc) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages_nc.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages_nc.length) {
              $scope.not_next_nc = true;
            }
          } else {
            $scope.not_next_nc = true;
          }
        }
      };
    }
    function getProviders() {
      providerService.getReadListProviders().then(function (data) {
        vm.providers = data;
      });
    }
    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_name: "Vida",
        },
        {
          id: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
      ];
    }
    function getReferenciador() {
      vm.vendedores = [];
      $http.get(url.IP + "get-vendors").then(function (user) {
        // $scope.vendors_data = user.data;
        if (user.data.length > 0) {
          user.data.forEach(function (u) {
            var obj = {
              name: u.first_name + " " + u.last_name,
              id: u.id,
            };
            vm.vendedores.push(obj);
          });
        }
      });
    }

    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group.val) {
        var word_data = vm.form.group.val;
      }
      if (word_data) {
        if (word_data.length >= 3) {
          $http
            .post(url.IP + "grupos-match/", {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $http
            .post(url.IP + "contractors-match/", {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200 && response.data.contractors) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    function changeReferenciador(obj) {}

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      }
      $http.get(url.IP + "ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.ramos = ramos.data;
      });
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      }
      try {
        vm.subramos = obj.subramo_ramo;
      } catch (e) {}
    }

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 0;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    $scope.print = function (item) {};
    $scope.showEndorsement = function (endoso) {
      if (endoso.receipt_type == 2) {
        if (endoso.poliza.subramo == "Gastos Medicos") var type = "disease";
        else if (endoso.poliza.subramo == "Vida") var type = "life";
        else var type = "automobile";
      }
      $state.go("endosos.pendingDataMassive", {
        endorsementId: endoso.id,
        endorsementType: type,
      });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("CobranzasCtrl", CobranzasCtrl);
  CobranzasCtrl.$inject = [
    "$q",
    "$sce",
    "$timeout",
    "FileUploader",
    "datesFactory",
    "MESSAGES",
    "providerService",
    "curr_rate_options",
    "$localStorage",
    "receiptService",
    "statusPayform",
    "toaster",
    "$uibModal",
    "statusReceipt",
    "SweetAlert",
    "$uibModalInstance",
    "modalService",
    "valueReceipt",
    "$sessionStorage",
    "$http",
    "url",
    "$parse",
    "$scope",
    "$state",
    "exportFactory",
    "$location",
    "dataFactory",
    "$rootScope",
    "whatsappWebFlagService",
    "whatsappWebHelper",
    "$filter",
  ];

  function CobranzasCtrl(
    $q,
    $sce,
    $timeout,
    FileUploader,
    datesFactory,
    MESSAGES,
    providerService,
    curr_rate_options,
    $localStorage,
    receiptService,
    statusPayform,
    toaster,
    $uibModal,
    statusReceipt,
    SweetAlert,
    $uibModalInstance,
    modalService,
    valueReceipt,
    $sessionStorage,
    $http,
    url,
    $parse,
    $scope,
    $state,
    exportFactory,
    $location,
    dataFactory,
    $rootScope,
    whatsappWebFlagService,
    whatsappWebHelper,
    $filter
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.org_name = usr.urlname;
    vm.accesos = $sessionStorage.permisos;
    vm.pageTitle = "Cobranza";
    vm.receipts = [];
    vm.receipt = {};
    vm.r_type = "1";
    vm.changeStatusModal = changeStatusModal;
    vm.showComment = showComment;
    vm.showPhone = showPhone;
    vm.showEmail = showEmail;
    vm.canceledReceipts = [];
    vm.paidReceipts = [];
    vm.NotasModal = NotasModal;
    vm.pendingReceipts = [];
    vm.close = close;
    vm.liquidar_is_posible = false;
    vm.pagar_is_posible = false;
    // vm.loading = false;
    vm.user = usr;
    vm.getUsuarios = getUsuarios;
    vm.table = {};
    vm.emailsReminderAdd = emailsReminderAdd;
    // vm.addEmails = addEmails;
    // vm.deleteEmails = deleteEmails;
    // TODO: quitar al terminar
    vm.user.permiso.editar = true;
    vm.buscar_por_folio = false;
    vm.folio_a_buscar = "";
    vm.word = "";

    vm.responsiv = responsiv;
    vm.getCobranza = getCobranza;
    vm.testPagination = testPagination;
    vm.receipts_to_pay_lenght = 0;

    vm.changeProvider = changeProvider;
    vm.changeReferenciador = changeReferenciador;
    vm.changeRamo = changeRamo;
    vm.changeSubRamo = changeSubRamo;
    vm.changeUntil = changeUntil;
    vm.changePayment = changePayment;
    vm.Generar = Generar;
    vm.matchesContractors = matchesContractors;
    vm.matchesGroup = matchesGroup;
    vm.showBinnacle = showBinnacle;
    vm.returnToReceipts = returnToReceipts;
    vm.returnToNote = returnToNote;
    vm.tipo_folio_buscar = 1;
    vm.getLog = getLog;
    $scope.user_pay = {};
    $scope.mails = [];
    $scope.mails_cc = [];
    $scope.mails_cco = [];
    var share_via_email = [];
    $scope.infoUser = $sessionStorage.infoUser;
    $scope.head = "";
    $scope.body = "";
    $scope.footer = "";
    $scope.image_sms = "";
    // $scope.custom_email = "";
    $scope.custom_email = true;
    $scope.signature_edith = false;
    $scope.banner_edith = false;
    $scope.in_process = false;
    $scope.show_notes = false;
    vm.first_comment = "";
    vm.second_comment = "";
    vm.only_caratula_poliza = 0;
    vm.matchesGroupinglevel = matchesGroupinglevel;
    vm.matchesClassification = matchesClassification;

    vm.carga_masiva = false;
    vm.errores_carga_masiva = [];
    vm.lista_carga_masiva = [];
    vm.lista_carga_masivapago = [];
    vm.messageWhatsappManual = "";
    vm.whatsappWebPhone = "";
    vm.whatsappWebEnabled = whatsappWebFlagService.isEnabled();
    whatsappWebFlagService.subscribe(function (enabled) {
      $scope.$evalAsync(function () {
        vm.whatsappWebEnabled = enabled;
      });
    }, $scope);

    vm.changeSubgroup = changeSubgroup;
    vm.changeSubsubgroup = changeSubsubgroup;

    vm.changeSubgrouping = changeSubgrouping;
    vm.changeSubsubgrouping = changeSubsubgrouping;
    $scope.subgroups = [];
    $scope.subsubgroups = [];
    $scope.subgrouping = [];
    $scope.subsubgrouping = [];
    vm.changeBLine = changeBLine;

    vm.businesLine = [
      {
        id: 1,
        name: "Comercial",
      },
      {
        id: 2,
        name: "Personal",
      },
      {
        id: 3,
        name: "Otro",
      },
    ];

    vm.ramos_toselected = [
      {
        id: 1,
        ramo_name: "Vida",
      },
      {
        id: 2,
        ramo_name: "Accidentes y Enfermedades",
      },
      {
        id: 3,
        ramo_name: "Daños",
      },
    ];
    $scope.showButtonPending = false;
    $scope.showButtonPay = false;
    $scope.showButtonLiquidado = false;
    $scope.showButtonConciliado = false;

    function changeBLine(obj) {
      $scope.bLine = obj;
      if (obj) {
        vm.form.businesLine = obj;
      } else {
        vm.form.businesLine = 0;
      }
    }

    var formdata = new FormData();

    vm.accesos.forEach(function (acceso) {
      if (acceso.model_name == "Cobranza") {
        vm.acceso_cob = acceso;
        vm.acceso_cob.permissions.forEach(function (acc) {
          if (acc.permission_name == "Pagar y prorrogar") {
            if (acc.checked == true) {
              vm.acceso_pag_rec = true;
            } else {
              vm.acceso_pag_rec = false;
            }
          } else if (acc.permission_name == "Desconciliación de recibos") {
            if (acc.checked == true) {
              vm.acceso_desconc_rec = true;
            } else {
              vm.acceso_desconc_rec = false;
            }
          } else if (acc.permission_name == "Desliquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_desliq_rec = true;
            } else {
              vm.acceso_desliq_rec = false;
            }
          } else if (acc.permission_name == "Conciliar recibos") {
            if (acc.checked == true) {
              vm.acceso_conc_rec = true;
            } else {
              vm.acceso_conc_rec = false;
            }
          } else if (acc.permission_name == "Liquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_liq_rec = true;
            } else {
              vm.acceso_liq_rec = false;
            }
          } else if (acc.permission_name == "Ver cobranza") {
            if (acc.checked == true) {
              vm.acceso_ver_cob = true;
            } else {
              vm.acceso_ver_cob = false;
            }
          } else if (acc.model_name == "Archivos") {
            vm.acceso_files = acc;
            vm.acceso_files.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              }
            });
          }
        });
      }
      if (acceso.model_name == "Correos electronicos") {
        vm.acceso_correo = acceso;
        vm.acceso_correo.permissions.forEach(function (acc) {
          if (acc.permission_name == "Correos") {
            if (acc.checked == true) {
              vm.acceso_cor = true;
            } else {
              vm.acceso_cor = false;
            }
          }
        });
      }
      if (acceso.model_name == "Pólizas") {
        vm.acceso_polizas = acceso;
        vm.acceso_polizas.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar pólizas") {
            if (acc.checked == true) {
              vm.acceso_adm_pol = true;
            } else {
              vm.acceso_adm_pol = false;
            }
          } else if (acc.permission_name == "Ver pólizas") {
            if (acc.checked == true) {
              vm.acceso_ver_pol = true;
            } else {
              vm.acceso_ver_pol = false;
            }
          }
        });
      }
      if (acceso.model_name == "Reportes") {
        vm.acceso_reportes = acceso;
        vm.acceso_reportes.permissions.forEach(function (acc) {
          if (acc.permission_name == "Reporte fianzas") {
            if (acc.checked == true) {
              vm.acceso_rep_fia = true;
            } else {
              vm.acceso_rep_fia = false;
            }
          } else if (acc.permission_name == "Reporte Siniestros") {
            if (acc.checked == true) {
              vm.acceso_rep_sin = true;
            } else {
              vm.acceso_rep_sin = false;
            }
          } else if (acc.permission_name == "Reporte Endosos") {
            if (acc.checked == true) {
              vm.acceso_rep_end = true;
            } else {
              vm.acceso_rep_end = false;
            }
          } else if (acc.permission_name == "Reporte pólizas") {
            if (acc.checked == true) {
              vm.acceso_rep_pol = true;
            } else {
              vm.acceso_rep_pol = false;
            }
          } else if (acc.permission_name == "Reporte renovaciones") {
            if (acc.checked == true) {
              vm.acceso_rep_ren = true;
            } else {
              vm.acceso_rep_ren = false;
            }
          } else if (acc.permission_name == "Reporte cobranza") {
            if (acc.checked == true) {
              vm.acceso_rep_cob = true;
            } else {
              vm.acceso_rep_cob = false;
            }
          }
        });
      }
      if (acceso.model_name == "Referenciadores") {
        vm.acceso_ref = acceso;
        vm.acceso_ref.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar referenciadores") {
            if (acc.checked == true) {
              vm.acceso_adm_ref = true;
            } else {
              vm.acceso_adm_ref = false;
            }
          } else if (acc.permission_name == "Pagar a referenciadores") {
            if (acc.checked == true) {
              vm.acceso_pag_ref = true;
            } else {
              vm.acceso_pag_ref = false;
            }
          } else if (acc.permission_name == "Cambiar refrenciador en pólizas") {
            if (acc.checked == true) {
              vm.acceso_chg_ref = true;
            } else {
              vm.acceso_chg_ref = false;
            }
          } else if (acc.permission_name == "Ver referenciadores") {
            if (acc.checked == true) {
              vm.acceso_ver_ref = true;
            } else {
              vm.acceso_ver_ref = false;
            }
          }
        });
      }
    });

    $scope.recordatoriosFlag = false;
    $scope.showRecordatorios = function () {
      $scope.recordatoriosFlag = !$scope.recordatoriosFlag;
    };

    $scope.goToRecordatorio = function (rec) {
      if (rec.recordatorio) {
        $scope.name_for_new_tab = "Recordatorio desde registro";
        $scope.route_for_new_tab = "recordatorios.desde_registro_show";
        var params = { id: rec.recordatorio.id };
      }
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab, params),
        };
      }
      $localStorage.tab_states = appStates.states;
      $state.go($scope.route_for_new_tab, params);
    };

    $scope.createRecordatorio = function (registroSelected, tipo) {
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return $scope.endorsement;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    vm.option_tp = [
      {
        id: 1,
        name: "Individual",
      },
      {
        id: 3,
        name: "Póliza de Grupo",
      },
      {
        id: 11,
        name: "Colectividad",
      },
      {
        id: 12,
        name: "Póliza de Colectividad",
      },
    ];
    vm.form = getDefaultFilters();
    $scope.select_provider = [];
    $scope.select_ramo = [];
    $scope.select_sramo = [];
    $scope.select_user_pay = [];
    vm.ramos_selected = [];
    vm.subramos_selected = [];
    vm.providers_selected = [];

    function getDefaultFilters() {
      return {
        provider: 0,
        ramo: 0,
        subramo: 0,
        since: convertDate(new Date()),
        until: convertDate(new Date()),
        payment: 0,
        status: 0,
        contratante: "",
        group: 0,
        vendedor: 0,
        tipo_recibo: 0,
        tipo_poliza: 0,
        subgroup: 0,
        subsubgroup: 0,
        groupinglevel: 0,
        subgrouping: 0,
        classification: 0,
        subsubgrouping: 0,
        businesLine: 0,
        celula: 0,
        only_caratula: 0,
        poliza_number: "",
        tipo_cobro: 0,
        ejecutivo: 0,
      };
    }

    vm.payment = [
      {
        id: 0,
        name: "Todas las formas de pago",
      },
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 4,
        name: "Cuatrimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
      {
        id: 7,
        name: "Semanal",
      },
      {
        id: 14,
        name: "Catorcenal",
      },
    ];

    vm.tipo_recibo = [
      {
        id: 0,
        name: "Todos",
      },
      {
        id: 1,
        name: "Iniciales ",
      },
      {
        id: 2,
        name: "Subsecuentes",
      },
    ];

    vm.conductos = [
      {
        id: 0,
        name: "Todos",
      },
      {
        id: 4,
        name: "CAT/Domiciliados",
      },
      {
        id: 1,
        name: "No Domiciliados",
      },
      {
        id: 2,
        name: "Agentes",
      },
      {
        id: 3,
        name: "CAC",
      },
      {
        id: 5,
        name: "Nómina",
      },
      {
        id: 6,
        name: "CUT",
      },
    ];

    vm.status = [
      {
        id: 1,
        name: "Pendientes",
      },
      {
        id: 2,
        name: "Pagados",
      },
      {
        id: 3,
        name: "Liquidados",
      },
      {
        id: 4,
        name: "Cancelados",
      },
      {
        id: 5,
        name: "Precancelados",
      },
    ];

    vm.table = {
      headers: [
        "Tipo",
        "Contratante",
        "Póliza",
        "Periodo",
        "Aseguradora",
        "Estatus",
        "Prima Total",
        "Creado Por",
        "Antigüedad",
        "Acciones",
        "Fecha de vencimiento",
        "Promesa de pago",
      ],
    };
    vm.table_nc = {
      headers: [
        "Contratante",
        "Folio",
        "Número endoso",
        "Número póliza",
        "Fecha emisión",
        "Prima Total",
        "Forma de pago",
        "Moneda",
        "Antigüedad",
        "Acciones",
      ],
    };

    var arr = [];
    var nums = [];
    $scope.form = {};
    $scope.form.emails_reminder = [];
    // $scope.form.emails_reminder.forEach(function(elem, index) {
    //      arr.push(elem);
    // });

    /*Enviar correos*/
    $scope.receiptAll = valueReceipt;
    updateReminderDetails($scope.receiptAll && $scope.receiptAll.reminder_info);

    $scope.$watch(
      "receiptAll.reminder_info",
      function (newInfo, oldInfo) {
        if (newInfo === oldInfo && newInfo === undefined) {
          return;
        }

        if (!newInfo && newInfo !== 0) {
          if (vm.reminderDetails.length || vm.reminderDetailsText) {
            vm.reminderDetails = [];
            vm.reminderDetailsText = "";
            applyReminderPreview();
          }
          return;
        }

        updateReminderDetails(newInfo);
      },
      true
    );
    vm.previewBaseMessage = "";
    vm.previewReady = false;
    vm.previewLoading = false;
    vm.originalPreviewSource =
      $scope.preview === undefined || $scope.preview === null
        ? ""
        : $scope.preview.toString();

    if (vm.reminderDetailsText) {
      applyReminderPreview();
    }

    if (vm.originalPreviewSource) {
      finalizeReminderPreview(vm.originalPreviewSource);
    }

    function updateReminderDetails(info) {
      vm.reminderDetails = buildReminderDetails(info);
      vm.reminderDetailsText = buildReminderDetailsText(vm.reminderDetails);
      applyReminderPreview();
    }

    function buildReminderDetails(info) {
      if (!info) return [];

      var details = [];

      // 🟢 Forzar inclusión de Póliza desde receiptAll si el backend no la mandó
      if (!info.policyNumber && $scope.receiptAll && $scope.receiptAll.poliza) {
        info.policyNumber =
          $scope.receiptAll.poliza.poliza_number ||
          $scope.receiptAll.poliza.certificate_number ||
          $scope.receiptAll.poliza.internal_number ||
          "";
      }

      // Póliza primero
      if (info.policyNumber)
        details.push({ label: "Póliza", value: info.policyNumber });

      // Guardamos temporalmente el número de endoso
      var endorsementTemp = info.endorsementNumber
        ? { label: "Número de Endoso", value: info.endorsementNumber }
        : null;

      // Resto de campos
      if (info.subbranch)
        details.push({ label: "Subramo", value: info.subbranch });
      if (info.series) details.push({ label: "Serie", value: info.series });
      if (info.insured)
        details.push({ label: "Asegurado", value: info.insured });
      if (info.totalPremium) {
        var totalPremium = parseFloat(info.totalPremium);
        details.push({
          label: "Prima Total",
          value: isNaN(totalPremium) ? info.totalPremium : totalPremium,
          filter: "currency",
        });
      }
      if (info.currency)
        details.push({ label: "Moneda", value: info.currency });
      if (info.dueDate) {
        var dueDateValue = info.dueDate;
        if (!angular.isDate(dueDateValue)) {
          var parsedDate = new Date(dueDateValue);
          if (!isNaN(parsedDate.getTime())) dueDateValue = parsedDate;
        }
        details.push({
          label: "Fecha Límite de Pago",
          value: dueDateValue,
          filter: "date",
        });
      }
      if (info.comments)
        details.push({ label: "Dudas o comentarios", value: info.comments });

      // 🧩 Asegurar que “Número de Endoso” quede justo debajo de “Póliza”
      if (endorsementTemp) {
        var polizaIndex = details.findIndex(function (d) {
          return normalizeDetailLabel(d.label) === "póliza";
        });
        if (polizaIndex !== -1) {
          details.splice(polizaIndex + 1, 0, endorsementTemp);
        } else {
          details.unshift(endorsementTemp);
        }
      }

      // Mantener “Moneda” después de “Prima Total”
      var currencyDetail = null;
      var premiumIndex = -1;
      details.forEach(function (detail, i) {
        var label = normalizeDetailLabel(detail.label);
        if (label === "moneda") currencyDetail = detail;
        if (["prima total", "total premium", "prima_total"].includes(label))
          premiumIndex = i;
      });
      if (currencyDetail) {
        details = details.filter(function (d) {
          return normalizeDetailLabel(d.label) !== "moneda";
        });
        if (premiumIndex !== -1 && premiumIndex < details.length) {
          details.splice(premiumIndex + 1, 0, currencyDetail);
        } else {
          details.push(currencyDetail);
        }
      }
      return details;

      function normalizeDetailLabel(label) {
        if (!label && label !== 0) return "";
        return label.toString().replace(/:\s*$/, "").trim().toLowerCase();
      }
    }

    function buildReminderDetailsText(details) {
      if (!details || !details.length) {
        return "";
      }

      // Detectar posición de Póliza y Endoso para forzar el orden correcto
      var polizaIndex = details.findIndex(function (d) {
        return normalizeLabel(d.label) === "póliza";
      });

      var endosoIndex = details.findIndex(function (d) {
        return normalizeLabel(d.label) === "número de endoso";
      });

      if (
        polizaIndex !== -1 &&
        endosoIndex !== -1 &&
        endosoIndex !== polizaIndex + 1
      ) {
        // extraer el endoso y reinsertarlo justo después de póliza
        var endosoItem = details.splice(endosoIndex, 1)[0];
        details.splice(polizaIndex + 1, 0, endosoItem);
      }

      // Ahora construimos el texto plano con el orden correcto
      var lines = [];

      angular.forEach(details, function (detail) {
        var formattedValue = formatReminderDetailValue(detail);
        if (
          formattedValue !== undefined &&
          formattedValue !== null &&
          formattedValue !== ""
        ) {
          lines.push(detail.label + ": " + formattedValue);
        }
      });

      return lines.join("<br>");

      function normalizeLabel(label) {
        return (label || "").toString().trim().toLowerCase();
      }
    }

    function formatReminderDetailValue(detail) {
      if (!detail) {
        return "";
      }

      var value = detail.value;

      if (detail.filter === "currency") {
        return $filter("currency")(value);
      }

      if (detail.filter === "date") {
        var dateValue = value;
        if (!angular.isDate(dateValue)) {
          var parsedDate = new Date(value);
          if (!isNaN(parsedDate.getTime())) {
            dateValue = parsedDate;
          }
        }

        return $filter("date")(dateValue, "dd/MM/yy");
      }

      return value;
    }

    function composeReminderPreview(base) {
      var baseString =
        base === undefined || base === null ? "" : base.toString();
      var detailsText = vm.reminderDetailsText;

      if (!detailsText) {
        return baseString;
      }

      var sanitizedBase = removeReminderDetailLines(
        baseString,
        vm.reminderDetails
      );
      if (sanitizedBase.indexOf(detailsText) !== -1) {
        return sanitizedBase;
      }

      var trimmedBase = sanitizedBase.trim();
      var separator = trimmedBase ? "<br><br>" : "";

      // 🟢 Mantener lógica de mover el endoso debajo de la póliza
      if (
        trimmedBase.indexOf("Póliza:") !== -1 &&
        detailsText.indexOf("Número de Endoso:") !== -1
      ) {
        var parts = detailsText.split("<br>");
        var endosoLine = null;

        for (var i = 0; i < parts.length; i++) {
          if (parts[i].indexOf("Número de Endoso:") !== -1) {
            endosoLine = parts[i];
            // ✅ Elimina también esa línea del texto original para evitar que se repita
            parts.splice(i, 1);
            break;
          }
        }

        // reconstruimos `detailsText` SIN el endoso
        detailsText = parts.join("<br>");

        if (endosoLine) {
          var lines = trimmedBase.split("<br>");
          var polizaIndex = -1;
          for (var j = 0; j < lines.length; j++) {
            if (lines[j].indexOf("Póliza:") !== -1) {
              polizaIndex = j;
              break;
            }
          }

          if (polizaIndex !== -1) {
            lines.splice(polizaIndex + 1, 0, endosoLine);
            trimmedBase = lines.join("<br>");
          }
        }
      }
      return (trimmedBase ? trimmedBase + separator : "") + detailsText;
    }

    function setReminderPreviewLoading() {
      vm.previewLoading = true;
      vm.previewReady = false;
    }

    function finalizeReminderPreview(message) {
      vm.previewLoading = false;

      // 🔹 Convertir saltos de línea en <br> para mostrar correctamente en el preview
      var formattedMessage =
        message === undefined || message === null ? "" : message.toString();
      formattedMessage = formattedMessage
        .replace(/\r?\n/g, "<br>") // convierte saltos \n o \r\n a <br>
        .replace(/\s{2,}/g, " "); // limpia espacios extra

      vm.previewBaseMessage = formattedMessage;
      vm.previewReady = true;
      vm.originalPreviewSource = vm.previewBaseMessage;

      applyReminderPreview();
    }

    function applyReminderPreview() {
      if (!vm.previewReady) {
        return;
      }

      var baseSource = vm.previewBaseMessage;
      if (baseSource === undefined || baseSource === null) {
        baseSource = "";
      }

      if (!baseSource && !vm.reminderDetailsText) {
        $scope.preview = "";
        return;
      }
      $scope.preview = composeReminderPreview(baseSource);
    }

    function removeReminderDetailLines(baseString, details) {
      if (!baseString || !details || !details.length) {
        return baseString || "";
      }

      var labels = details
        .map(function (detail) {
          return detail && detail.label ? detail.label.toLowerCase() : "";
        })
        .filter(function (label) {
          return !!label;
        });

      if (!labels.length) {
        return baseString;
      }

      var segments = baseString.split(/<br\s*\/?\s*>/i);
      var keptSegments = [];

      angular.forEach(segments, function (segment) {
        if (segment === undefined || segment === null) {
          return;
        }

        var trimmedSegment = segment.replace(/^[\s\u00a0]+|[\s\u00a0]+$/g, "");

        if (!trimmedSegment) {
          if (
            keptSegments.length &&
            keptSegments[keptSegments.length - 1] !== ""
          ) {
            keptSegments.push("");
          }
          return;
        }

        var lowerSegment = trimmedSegment.toLowerCase();
        var isDetailLine = labels.some(function (label) {
          return lowerSegment.indexOf(label + ":") === 0;
        });

        if (!isDetailLine) {
          keptSegments.push(trimmedSegment);
        }
      });

      while (keptSegments.length && keptSegments[0] === "") {
        keptSegments.shift();
      }

      return keptSegments.join("<br>");
    }

    $scope.showAddEmail = false;
    $scope.optionsSent = [
      { value: 1, label: "Solo al contratante" },
      { value: 2, label: "Añadir correos" },
    ];

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    /* Uploader files */
    $scope.countFile = 0;
    $scope.okFile = 0;
    showAddEmails(1);
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));
    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));
    // Log de registro de pago y/o liquidación recibos seleccionados
    function log_liq_and_pay_selected(rec) {
      if (rec.status == 1) {
        $scope.status_receipt =
          "actualizó recibo(s) " +
          $scope.recibos_a_pagar.length +
          " a pagado(s) " +
          "con el folio de pago: " +
          $scope.folio_pago;
      } else if (rec.status == 5) {
        $scope.status_receipt =
          "actualizó recibo(s) " +
          $scope.recibos_a_liquidar.length +
          " a liquidado(s) " +
          " con el folio de liquidación: " +
          $scope.folio_liquidacion;
      }

      var params = {
        model: 4,
        event: "POST",
        associated_id: rec.id,
        identifier: $scope.status_receipt,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
    }
    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.FILETOOLARGE, "error");
      } else {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "~" ||
            specialChars[i] == "%" ||
            specialChars[i] == "=" ||
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
            str = str.split("$").join("");
            fileItem.file.name = fileItem.file.name.split("$").join("");
            str = str.split("#").join("");
            fileItem.file.name = fileItem.file.name.split("#").join("");
            str = str.split("$#").join("");
            fileItem.file.name = fileItem.file.name.split("$#").join("");
            str = str.split("~").join("");
            fileItem.file.name = fileItem.file.name.split("~").join("");
            str = str.split("%").join("");
            fileItem.file.name = fileItem.file.name.split("%").join("");
            str = str.split("=").join("");
            fileItem.file.name = fileItem.file.name.split("=").join("");
            str = str.split("_").join("");
            fileItem.file.name = fileItem.file.name.split("_").join("");
            str = str.split(" ").join("");
            fileItem.file.name = fileItem.file.name.split(" ").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      fileItem.file.name = fileItem.file.name
        .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
        .replace(/ /g, "");
      fileItem.file.name = fileItem.file.name.trim();
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };

    $scope.open_in_same_tab = function (name, route) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        appStates.states.forEach(function (state) {
          if (state.route == $scope.route_for_new_tab) {
            existe = true;
          }
        });
      }

      if (!existe) {
        var active_tab = appStates.states.findIndex(function (item) {
          if (item.active) {
            return true;
          }
          return false;
        });

        appStates.states[active_tab] = {
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };

        $localStorage.tab_states = appStates.states;
        // $localStorage.tab_index = $localStorage.tab_states.length -1;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.ramo == undefined) {
        item.ramo = 2;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].ramo = item.ramo;
    };

    function uploadFiles(ticketId) {
      $scope.userInfo = {
        id: ticketId.id,
      };
      $scope.userInfo.url = url.IP + "ticket/" + ticketId.id + "/archivos/";
      $scope.uploader.uploadAll();
    }

    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };

    $scope.saveFile = function (file) {
      $http.patch(file.url, { nombre: file.nombre, sensible: file.sensible });
    };

    $scope.selectUserPay = function (x, y) {
      vm.user_pay_selected = [];
      x.forEach(function (r) {
        vm.user_pay_selected.push(parseInt(r.id));
      });
    };

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function getBase64(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        console.log(reader.result);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    }

    $scope.fileNameChanged = function (ele) {
      $scope.filePdf = ele.files[0];
      var file = ele.files[0];

      var r = new FileReader();
      $scope.data = {};
      r.onloadend = function (e) {
        $scope.data.b64 = e.target.result;
        $scope.$apply();
        $scope.blod = $scope.data.b64.replace(
          /^data:application\/vnd.ms-excel;base64,/,
          ""
        );
      };
      r.readAsDataURL(file); //once defined all callbacks, begin reading the file
    };

    $scope.validarLayoutCargaMasiva = function () {
      $scope.loading = true;
      $http({
        method: "POST",
        url: url.IP + "check-cobranza-liquidacion-masiva",
        data: {
          recibos: vm.lista_carga_masiva,
          folio_liquidacion: vm.folio_liquidacion,
          validar: true,
        },
      })
        .then(
          function (response) {
            $scope.loading = false;
            if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length > 0
            ) {
              if (response["data"]) {
                $scope.loading = true;
                // Conexión a socket.io
                // if(vm.org_name =='ancora'){
                //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                // }else{
                var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // }
                //var socket = io.connect("http://127.0.0.1:8080");
                socket.emit("subscribe", response.data);
                // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                // socket.on('result', function(url){
                socket.on(response.data, function (url) {
                  socket.disconnect();
                  $scope.loading = false;
                  SweetAlert.swal({
                    title: "El reporte de evaluación está listo para descargar",
                    icon: "success",
                    text: "Encuentra la liga de descarga en la sección de notificaciones",
                    timer: 5000,
                  });
                  // var notificacion = {
                  //   'title': 'La lista recibos evaluados ha sido generado',
                  //   'description': url,
                  //   'model': 26,
                  //   'id_reference':0
                  // }
                  // dataFactory.post('notificaciones/', notificacion)
                  // .then(function success(response) {
                  //   SweetAlert.swal({
                  //     title: 'El reporte de evaluación está listo para descargar',
                  //     icon: 'success',
                  //     text: 'Encuentra la liga de descarga en la sección de notificaciones',
                  //     timer: 5000
                  //   });
                  //   $scope.loading = false;
                  //   socket.disconnect();
                  // }).catch(function(err) {
                  //   socket.disconnect();
                  // })
                });
                toaster.info(
                  "Generando...",
                  "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                );
              } else {
                toaster.error(
                  "Aviso",
                  "Ha ocurrido un error, intente nuevamente"
                );
              }
            } else if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length == 0
            ) {
              SweetAlert.swal(
                "Cargado",
                "Archivo validado exitosamente",
                "success"
              );
            } else {
              SweetAlert.swal(
                "Error",
                "Ocurrieron errores en el proceso",
                "error"
              );
            }
          },
          function (error) {
            $scope.loading = false;
          }
        )
        .catch(function (error) {
          $scope.loading = false;
        });
    };

    $scope.cargarLayoutCargaMasiva = function () {
      console.log(usr);
      SweetAlert.swal(
        {
          title: "¡Aviso!",
          text: "Se liquidarán todos los recibos cargados y válidos, no es necesario validar el layout para esta acción. ¿Desea continuar?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        },
        function (isConfirm) {
          $scope.loading = true;
          if (isConfirm) {
            $http({
              method: "POST",
              url: url.IP + "cobranza-liquidacion-masiva",
              data: {
                recibos: vm.lista_carga_masiva,
                folio_liquidacion: vm.folio_liquidacion,
                validar: false,
                file: $scope.blod,
                name_file: $scope.filePdf.name,
                owner: usr.name,
                org: vm.org_name,
                source: "Liquidación por Carga Masiva MÉTODO TRADICIONAL",
              },
            })
              .then(
                function (response) {
                  $scope.loading = false;
                  if (
                    response &&
                    response["status"] == 200 &&
                    response["data"] &&
                    response["data"].length > 0
                  ) {
                    if (response["data"]) {
                      $scope.loading = true;
                      // Conexión a socket.io
                      // if(vm.org_name =='ancora'){
                      //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                      // }else{
                      var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                      // }
                      //var socket = io.connect("http://127.0.0.1:8080");
                      socket.emit("subscribe", response.data);
                      // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                      // socket.on('result', function(url){
                      socket.on(response.data, function (url) {
                        socket.disconnect();
                        $scope.loading = false;
                        SweetAlert.swal({
                          title:
                            "El reporte de evaluación está listo para descargar",
                          icon: "success",
                          text: "Encuentra la liga de descarga en la sección de notificaciones",
                          timer: 5000,
                        });
                        // var notificacion = {
                        //   'title': 'La lista de retroalimentación de recibos cargados ha sido generado',
                        //   'description': url,
                        //   'model': 26,
                        //   'id_reference':0
                        // }
                        // dataFactory.post('notificaciones/', notificacion)
                        // .then(function success(response) {
                        //   SweetAlert.swal({
                        //     title: 'El reporte de retroalimentación sobre recibos cargados está listo para descargar',
                        //     icon: 'success',
                        //     text: 'Encuentra la liga de descarga en la sección de notificaciones',
                        //     timer: 5000
                        //   });
                        //   $scope.loading = false;
                        //   socket.disconnect();
                        // }).catch(function(err) {
                        //   socket.disconnect();
                        // })
                      });
                      toaster.info(
                        "Generando...",
                        "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                      );
                    }
                  } else if (
                    response &&
                    response["status"] == 200 &&
                    response["data"] &&
                    response["data"].length == 0
                  ) {
                    SweetAlert.swal(
                      "Cargado",
                      "Archivo validado exitosamente",
                      "success"
                    );
                    $scope.loading = false;
                  } else {
                    SweetAlert.swal(
                      "Error",
                      "Ocurrieron errores en el proceso",
                      "error"
                    );
                    $scope.loading = false;
                  }
                },
                function (error) {
                  $scope.loading = false;
                }
              )
              .catch(function (error) {
                $scope.loading = false;
              });
          } else {
          }
        }
      );
    };
    // Pago
    $scope.validarLayoutCargaMasivaId = function () {
      $scope.loadingPagoId = true;
      $http({
        method: "POST",
        url: url.IP + "check-cobranza-id-pago-masivo",
        data: {
          recibos: vm.lista_carga_masiva_pago_id,
          folio_pago: vm.folio_liquidacion,
          validar: true,
        },
      })
        .then(
          function (response) {
            console.log(response);
            $scope.loadingPagoId = false;
            if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length > 0
            ) {
              $scope.modalInstance = $uibModal.open({
                templateUrl: "app/cobranzas/cobranzas.modal.errores.html",
                controller: CobranzaErroresCtrl,
                controllerAs: "vmm",
                size: "md",
                resolve: {
                  errores: function () {
                    return response["data"];
                  },
                  titulo: function () {
                    return "Errores de validación de layout";
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });
            } else if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length == 0
            ) {
              SweetAlert.swal(
                "Cargado",
                "Archivo validado exitosamente",
                "success"
              );
            } else {
              SweetAlert.swal(
                "Error",
                "Ocurrieron errores en el proceso",
                "error"
              );
            }
          },
          function (error) {
            $scope.loadingPagoId = false;
          }
        )
        .catch(function (error) {
          $scope.loadingPagoId = false;
        });
    };
    $scope.cargarLayoutCargaMasivaId = function () {
      SweetAlert.swal(
        {
          title: "¡Aviso!",
          text: "Se liquidarán todos los recibos cargados y válidos, no es necesario validar el layout para esta acción. ¿Desea continuar?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        },
        function (isConfirm) {
          $scope.loadingPagoId = true;
          if (isConfirm) {
            $http({
              method: "POST",
              url: url.IP + "cobranza-id-pago-masivo",
              data: {
                recibos: vm.lista_carga_masiva_pago_id,
                folio_pago: vm.folio_liquidacion,
                validar: true,
                file: $scope.blod,
                name_file: $scope.filePdf.name,
                owner: usr.name,
                org: vm.org_name,
                source: "Pago por Carga Masiva (MEDIANTE ID)",
              },
            })
              .then(
                function (response) {
                  $scope.loadingPagoId = false;
                  if (
                    response &&
                    response["status"] == 200 &&
                    response["data"] &&
                    response["data"].length > 0
                  ) {
                    $scope.modalInstance = $uibModal.open({
                      templateUrl: "app/cobranzas/cobranzas.modal.errores.html",
                      controller: CobranzaErroresCtrl,
                      controllerAs: "vmm",
                      size: "md",
                      resolve: {
                        errores: function () {
                          return response["data"];
                        },
                        titulo: function () {
                          return "Reporte de carga de layout";
                        },
                      },
                      backdrop:
                        "static" /* this prevent user interaction with the background */,
                      keyboard: false,
                    });
                  } else if (
                    response &&
                    response["status"] == 200 &&
                    response["data"] &&
                    response["data"].length == 0
                  ) {
                    SweetAlert.swal(
                      "Cargado",
                      "Archivo validado exitosamente",
                      "success"
                    );
                    $scope.loading = false;
                  } else {
                    SweetAlert.swal(
                      "Error",
                      "Ocurrieron errores en el proceso",
                      "error"
                    );
                    $scope.loading = false;
                  }
                },
                function (error) {
                  $scope.loadingPagoId = false;
                }
              )
              .catch(function (error) {
                $scope.loadingPagoId = false;
              });
          } else {
          }
        }
      );
    };
    // ---pago masivo--
    $scope.validarLayoutCargaMasiva1 = function () {
      $scope.loadingPago = true;
      $http({
        method: "POST",
        url: url.IP + "cobranza-pago-masiva",
        data: {
          recibos: vm.lista_carga_masivapago,
          folio_pago: vm.folio_pago,
          validar: true,
        },
      })
        .then(
          function (response) {
            $scope.loadingPago = false;
            if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length > 0
            ) {
              if (response["data"]) {
                $scope.loadingPago = true;
                // Conexión a socket.io
                // if(vm.org_name =='ancora'){
                //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                // }else{
                var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // }
                //var socket = io.connect("http://127.0.0.1:8080");
                socket.emit("subscribe", response.data);
                // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                // socket.on('result', function(url){
                socket.on(response.data, function (url) {
                  socket.disconnect();
                  $scope.loadingPago = false;
                  SweetAlert.swal({
                    title:
                      "La lista de retroalimentación de recibos cargados ha sido generado",
                    icon: "success",
                    text: "Encuentra la liga de descarga en la sección de notificaciones",
                    timer: 5000,
                  });
                  // var notificacion = {
                  //   'title': 'La lista de retroalimentación de recibos cargados ha sido generado',
                  //   'description': url,
                  //   'model': 26,
                  //   'id_reference':0
                  // }
                  // dataFactory.post('notificaciones/', notificacion)
                  // .then(function success(response) {
                  //   SweetAlert.swal({
                  //     title: 'El reporte de retroalimentación sobre recibos cargados está listo para descargar',
                  //     icon: 'success',
                  //     text: 'Encuentra la liga de descarga en la sección de notificaciones',
                  //     timer: 5000
                  //   });
                  //   $scope.loadingPago = false;
                  //   socket.disconnect();
                  // }).catch(function(err) {
                  //   socket.disconnect();
                  // })
                });
                toaster.info(
                  "Generando...",
                  "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                );
              }
            } else if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length == 0
            ) {
              $scope.loadingPago = false;
              SweetAlert.swal(
                "Cargado",
                "Archivo validado exitosamente",
                "success"
              );
            } else {
              SweetAlert.swal(
                "Error",
                "Ocurrieron errores en el proceso",
                "error"
              );
            }
          },
          function (error) {
            $scope.loadingPago = false;
          }
        )
        .catch(function (error) {
          $scope.loadingPago = false;
        });
    };
    $scope.cargarLayoutCargaMasiva1 = function () {
      SweetAlert.swal(
        {
          title: "¡Aviso!",
          text: "Se Pagarán todos los recibos cargados y válidos, no es necesario validar el layout para esta acción. ¿Desea continuar?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.loadingPago = true;
            $http({
              method: "POST",
              url: url.IP + "cobranza-pago-masiva",
              data: {
                recibos: vm.lista_carga_masivapago,
                folio_pago: vm.folio_pago,
                validar: false,
                file: $scope.blod,
                name_file: $scope.filePdf.name,
                owner: usr.name,
                org: vm.org_name,
                source: "Pago por Carga Masiva MÉTODO TRADICIONAL",
              },
            })
              .then(
                function (response) {
                  $scope.loadingPago = false;
                  if (
                    response &&
                    response["status"] == 200 &&
                    response["data"] &&
                    response["data"].length > 0
                  ) {
                    if (response["data"]) {
                      $scope.loadingPago = true;
                      // Conexión a socket.io
                      // if(vm.org_name =='ancora'){
                      //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                      // }else{
                      var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                      // }
                      //var socket = io.connect("http://127.0.0.1:8080");
                      socket.emit("subscribe", response.data);
                      // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                      // socket.on('result', function(url){
                      socket.on(response.data, function (url) {
                        socket.disconnect();
                        $scope.loadingPago = false;
                        SweetAlert.swal({
                          title:
                            "El reporte de evaluación está listo para descargar",
                          icon: "success",
                          text: "Encuentra la liga de descarga en la sección de notificaciones",
                          timer: 5000,
                        });
                        // var notificacion = {
                        //   'title': 'La lista de retroalimentación de recibos cargados ha sido generado',
                        //   'description': url,
                        //   'model': 26,
                        //   'id_reference':0
                        // }
                        // dataFactory.post('notificaciones/', notificacion)
                        // .then(function success(response) {
                        //   SweetAlert.swal({
                        //     title: 'El reporte de retroalimentación sobre recibos cargados está listo para descargar',
                        //     icon: 'success',
                        //     text: 'Encuentra la liga de descarga en la sección de notificaciones',
                        //     timer: 5000
                        //   });
                        //   $scope.loadingPago = false;
                        //   socket.disconnect();
                        // }).catch(function(err) {
                        //   socket.disconnect();
                        // })
                      });
                      toaster.info(
                        "Generando...",
                        "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                      );
                    }
                  } else if (
                    response &&
                    response["status"] == 200 &&
                    response["data"] &&
                    response["data"].length == 0
                  ) {
                    SweetAlert.swal(
                      "Cargado",
                      "Archivo validado exitosamente",
                      "success"
                    );
                  } else {
                    SweetAlert.swal(
                      "Error",
                      "Ocurrieron errores en el proceso",
                      "error"
                    );
                  }
                },
                function (error) {
                  $scope.loadingPago = false;
                }
              )
              .catch(function (error) {
                $scope.loadingPago = false;
              });
          } else {
          }
        }
      );
    };
    // liquidacion ID
    $scope.validarLayoutCargaMasiva1Id = function () {
      $scope.loadingLiqId = true;
      $http({
        method: "POST",
        url: url.IP + "check-cobranza-id-liquidacion-masiva",
        data: {
          recibos: vm.lista_carga_masiva_liquidacion_id,
          folio_liquidacion: vm.folio_liquidacion,
          validar: true,
        },
      })
        .then(
          function (response) {
            $scope.loadingLiqId = false;
            if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length > 0
            ) {
              $scope.modalInstance = $uibModal.open({
                templateUrl: "app/cobranzas/cobranzas.modal.errores.html",
                controller: CobranzaErroresCtrl,
                controllerAs: "vmm",
                size: "md",
                resolve: {
                  errores: function () {
                    return response["data"];
                  },
                  titulo: function () {
                    return "Errores de validación de layout";
                  },
                },
                backdrop:
                  "static" /* this prevent user interaction with the background */,
                keyboard: false,
              });
            } else if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length == 0
            ) {
              $scope.loadingLiqId = false;
              SweetAlert.swal(
                "Cargado",
                "Archivo validado exitosamente",
                "success"
              );
            } else {
              SweetAlert.swal(
                "Error",
                "Ocurrieron errores en el proceso",
                "error"
              );
            }
          },
          function (error) {
            $scope.loadingLiqId = false;
          }
        )
        .catch(function (error) {
          $scope.loadingLiqId = false;
        });
    };
    $scope.cargarLayoutCargaMasiva1Id = function () {
      SweetAlert.swal(
        {
          title: "¡Aviso!",
          text: "Se Pagarán todos los recibos cargados y válidos, no es necesario validar el layout para esta acción. ¿Desea continuar?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.loadingLiqId = true;
            $http({
              method: "POST",
              url: url.IP + "cobranza-id-liquidacion-masiva",
              data: {
                recibos: vm.lista_carga_masiva_liquidacion_id,
                folio_liquidacion: vm.folio_liquidacion,
                validar: true,
                file: $scope.blod,
                name_file: $scope.filePdf.name,
                owner: usr.name,
                org: vm.org_name,
                source: "Liquidación por Carga Masiva (MEDIANTE ID)",
              },
            })
              .then(
                function (response) {
                  $scope.loadingLiqId = false;
                  if (
                    response &&
                    response["status"] == 200 &&
                    response["data"] &&
                    response["data"].length > 0
                  ) {
                    $scope.modalInstance = $uibModal.open({
                      templateUrl: "app/cobranzas/cobranzas.modal.errores.html",
                      controller: CobranzaErroresCtrl,
                      controllerAs: "vmm",
                      size: "md",
                      resolve: {
                        errores: function () {
                          return response["data"];
                        },
                        titulo: function () {
                          return "Reporte de carga de layout";
                        },
                      },
                      backdrop:
                        "static" /* this prevent user interaction with the background */,
                      keyboard: false,
                    });
                  } else if (
                    response &&
                    response["status"] == 200 &&
                    response["data"] &&
                    response["data"].length == 0
                  ) {
                    SweetAlert.swal(
                      "Cargado",
                      "Archivo validado exitosamente",
                      "success"
                    );
                  } else {
                    SweetAlert.swal(
                      "Error",
                      "Ocurrieron errores en el proceso",
                      "error"
                    );
                  }
                },
                function (error) {
                  $scope.loadingLiqId = false;
                }
              )
              .catch(function (error) {
                $scope.loadingLiqId = false;
              });
          } else {
          }
        }
      );
    };
    // *************************

    // Validar al cargar id
    $scope.validateExcelIdLiquidacion = function (param) {
      $scope.excelFile = [];
      if (param && param["datos"] && param["datos"].length > 0) {
        var flag_errores = false;
        vm.errores_carga_masiva = [];
        param["datos"].forEach(function (dato) {
          if (!isNumeric(dato.ID_SAAM)) {
            vm.errores_carga_masiva.push(
              "En la columna serie_de_recibo en la fila " +
                (parseInt(dato.__rowNum__) + 1) +
                " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
            );
            flag_errores = true;
          }
          if (!dato.fecha_de_liquidacion) {
            vm.errores_carga_masiva.push(
              "En la columna fecha_de_liquidacion en la fila " +
                (parseInt(dato.__rowNum__) + 1) +
                " el campo está vacío"
            );
            flag_errores = true;
          } else {
            var pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
            if (!pattern.test(dato.fecha_de_liquidacion)) {
              vm.errores_carga_masiva.push(
                "En la columna fecha_de_liquidacion en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo no corresponde a un formato de fecha válido (Revisar hoja de ayuda)"
              );
              flag_errores = true;
            }
          }
        });
        if (flag_errores) {
          vm.carga_masiva = false;
          $scope.modalInstance = $uibModal.open({
            templateUrl: "app/cobranzas/cobranzas.modal.errores.html",
            controller: CobranzaErroresCtrl,
            controllerAs: "vmm",
            size: "lg",
            resolve: {
              errores: function () {
                return vm.errores_carga_masiva;
              },
              titulo: function () {
                return "Errores Recibos Carga Masiva";
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
        } else {
          param["datos"] = param["datos"].map(function (dato) {
            dato["rowNum"] = parseInt(dato.__rowNum__) + 1;
            return dato;
          });
          vm.lista_carga_masiva_liquidacion_id = param["datos"];
          vm.carga_masiva_id = true;
          SweetAlert.swal("Cargado", "Archivo cargado exitosamente", "success");
        }
      } else {
        SweetAlert.swal("ERROR", "El layout está vacío", "error");
        return;
        vm.carga_masiva = false;
      }
    };
    $scope.validateExcelIdPago = function (param) {
      var flag_errores = false;
      $scope.excelFilePago = [];
      if (param && param["datos"] && param["datos"].length > 0) {
        var flag_errores = false;
        vm.errores_carga_masivapago = [];
        param["datos"].forEach(function (dato) {
          if (!isNumeric(dato.ID_SAAM)) {
            vm.errores_carga_masivapago.push(
              "En la columna ID_SAAM en la fila " +
                (parseInt(dato.__rowNum__) + 1) +
                " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
            );
            flag_errores = true;
          }
          if (!dato.fecha_de_pago) {
            vm.errores_carga_masivapago.push(
              "En la columna fecha_de_pago en la fila " +
                (parseInt(dato.__rowNum__) + 1) +
                " el campo está vacío"
            );
            flag_errores = true;
          } else {
            var pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
            if (!pattern.test(dato.fecha_de_pago)) {
              vm.errores_carga_masivapago.push(
                "En la columna fecha_de_pago en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo no corresponde a un formato de fecha válido (Revisar hoja de ayuda)"
              );
              flag_errores = true;
            }
          }
        });
        if (flag_errores) {
          vm.carga_masivapago = false;
          $scope.modalInstance = $uibModal.open({
            templateUrl: "app/cobranzas/cobranzas.modal.errores.html",
            controller: CobranzaErroresPagoCtrl,
            controllerAs: "vmm",
            size: "lg",
            resolve: {
              errores: function () {
                return vm.errores_carga_masivapago;
              },
              titulo: function () {
                return "Errores Recibos Carga Masiva";
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
        } else {
          param["datos"] = param["datos"].map(function (dato) {
            dato["rowNum"] = parseInt(dato.__rowNum__) + 1;
            return dato;
          });
          vm.lista_carga_masiva_pago_id = param["datos"];
          vm.carga_masiva_pago_id = true;
          SweetAlert.swal("Cargado", "Archivo cargado exitosamente", "success");
        }
      } else {
        SweetAlert.swal("ERROR", "El layout está vacío", "error");
        return;
        vm.carga_masivapago = false;
      }
    };

    $scope.validateExcel = function (param) {
      $scope.excelFile = [];
      if (param && param["datos"] && param["datos"].length > 0) {
        var flag_errores = false;
        vm.errores_carga_masiva = [];
        param["datos"].forEach(function (dato) {
          if (dato && dato.ID_SAAM) {
            if (!isNumeric(dato.ID_SAAM)) {
              vm.errores_carga_masiva.push(
                "En la columna serie_de_recibo en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
              );
              flag_errores = true;
            }
            if (!dato.fecha_de_liquidacion) {
              vm.errores_carga_masiva.push(
                "En la columna fecha_de_liquidacion en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            } else {
              var pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
              if (!pattern.test(dato.fecha_de_liquidacion)) {
                vm.errores_carga_masiva.push(
                  "En la columna fecha_de_liquidacion en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo no corresponde a un formato de fecha válido (Revisar hoja de ayuda)"
                );
                flag_errores = true;
              }
            }
          } else {
            if (!dato.fecha_de_liquidacion) {
              vm.errores_carga_masiva.push(
                "En la columna fecha_de_liquidacion en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            } else {
              var pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
              if (!pattern.test(dato.fecha_de_liquidacion)) {
                vm.errores_carga_masiva.push(
                  "En la columna fecha_de_liquidacion en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo no corresponde a un formato de fecha válido (Revisar hoja de ayuda)"
                );
                flag_errores = true;
              }
            }
            if (!dato.fecha_inicio_vigencia_recibo) {
              vm.errores_carga_masiva.push(
                "En la columna fecha_inicio_vigencia_recibo en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            } else {
              var pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
              if (!pattern.test(dato.fecha_inicio_vigencia_recibo)) {
                vm.errores_carga_masiva.push(
                  "En la columna fecha_inicio_vigencia_recibo en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo no corresponde a un formato de fecha válido (Revisar hoja de ayuda)"
                );
                flag_errores = true;
              }
            }
            if (!dato.frecuencia_de_pago) {
              vm.errores_carga_masiva.push(
                "En la columna frecuencia_de_pago en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            } else {
              if (!isNumeric(dato.frecuencia_de_pago)) {
                vm.errores_carga_masiva.push(
                  "En la columna frecuencia_de_pago en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
                );
                flag_errores = true;
              }
            }
            if (!dato.numero_de_poliza) {
              vm.errores_carga_masiva.push(
                "En la columna numero_de_poliza en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            }
            if (!dato.prima_total) {
              vm.errores_carga_masiva.push(
                "En la columna prima_total en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            } else {
              if (!isNumeric(dato.prima_total)) {
                vm.errores_carga_masiva.push(
                  "En la columna prima_total en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
                );
                flag_errores = true;
              }
            }
            if (!dato.serie_de_recibo) {
              vm.errores_carga_masiva.push(
                "En la columna serie_de_recibo en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            } else {
              if (!isNumeric(dato.serie_de_recibo)) {
                vm.errores_carga_masiva.push(
                  "En la columna serie_de_recibo en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
                );
                flag_errores = true;
              }
            }
            if (!dato.tipo) {
              vm.errores_carga_masiva.push(
                "En la columna tipo en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            }

            if (
              dato.tipo != "PG" &&
              dato.tipo != "PC" &&
              dato.tipo != "PI" &&
              dato.tipo != "NCI"
            ) {
              vm.errores_carga_masiva.push(
                "En la columna tipo en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
              );
              flag_errores = true;
            }

            if (
              dato.frecuencia_de_pago != 1 &&
              dato.frecuencia_de_pago != 2 &&
              dato.frecuencia_de_pago != 3 &&
              dato.frecuencia_de_pago != 4 &&
              dato.frecuencia_de_pago != 5 &&
              dato.frecuencia_de_pago != 6 &&
              dato.frecuencia_de_pago != 7 &&
              dato.frecuencia_de_pago != 12 &&
              dato.frecuencia_de_pago != 14 &&
              dato.frecuencia_de_pago != 24
            ) {
              vm.errores_carga_masiva.push(
                "En la columna frecuencia_de_pago en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
              );
              flag_errores = true;
            }
          }
        });
        if (flag_errores) {
          vm.carga_masiva = false;
          $scope.modalInstance = $uibModal.open({
            templateUrl: "app/cobranzas/cobranzas.modal.errores.html",
            controller: CobranzaErroresCtrl,
            controllerAs: "vmm",
            size: "lg",
            resolve: {
              errores: function () {
                return vm.errores_carga_masiva;
              },
              titulo: function () {
                return "Errores Recibos Carga Masiva";
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
        } else {
          param["datos"] = param["datos"].map(function (dato) {
            dato["rowNum"] = parseInt(dato.__rowNum__) + 1;
            return dato;
          });
          vm.lista_carga_masiva = param["datos"];
          vm.carga_masiva = true;
          SweetAlert.swal("Cargado", "Archivo cargado exitosamente", "success");
        }
      } else {
        SweetAlert.swal("ERROR", "El layout está vacío", "error");
        return;
        vm.carga_masiva = false;
      }
    };
    $scope.validateExcelPago = function (param) {
      var flag_errores = false;
      $scope.excelFilePago = [];
      if (param && param["datos"] && param["datos"].length > 0) {
        var flag_errores = false;
        vm.errores_carga_masivapago = [];
        param["datos"].forEach(function (dato) {
          if (dato && dato.ID_SAAM) {
            if (!isNumeric(dato.ID_SAAM)) {
              vm.errores_carga_masivapago.push(
                "En la columna ID_SAAM en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
              );
              flag_errores = true;
            }
            if (!dato.fecha_de_pago) {
              vm.errores_carga_masivapago.push(
                "En la columna fecha_de_pago en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            } else {
              var pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
              if (!pattern.test(dato.fecha_de_pago)) {
                vm.errores_carga_masivapago.push(
                  "En la columna fecha_de_pago en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo no corresponde a un formato de fecha válido (Revisar hoja de ayuda)"
                );
                flag_errores = true;
              }
            }
          } else {
            if (!dato.fecha_de_pago) {
              vm.errores_carga_masivapago.push(
                "En la columna fecha_de_pago en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            } else {
              var pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
              if (!pattern.test(dato.fecha_de_pago)) {
                vm.errores_carga_masivapago.push(
                  "En la columna fecha_de_pago en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo no corresponde a un formato de fecha válido (Revisar hoja de ayuda)"
                );
                flag_errores = true;
              }
            }
            if (!dato.fecha_inicio_vigencia_recibo) {
              vm.errores_carga_masivapago.push(
                "En la columna fecha_inicio_vigencia_recibo en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            } else {
              var pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
              if (!pattern.test(dato.fecha_inicio_vigencia_recibo)) {
                vm.errores_carga_masivapago.push(
                  "En la columna fecha_inicio_vigencia_recibo en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo no corresponde a un formato de fecha válido (Revisar hoja de ayuda)"
                );
                flag_errores = true;
              }
            }
            if (dato.tipo != "NCI") {
              if (!dato.frecuencia_de_pago) {
                vm.errores_carga_masivapago.push(
                  "En la columna frecuencia_de_pago en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo está vacío"
                );
                flag_errores = true;
              } else {
                if (!isNumeric(dato.frecuencia_de_pago)) {
                  vm.errores_carga_masivapago.push(
                    "En la columna frecuencia_de_pago en la fila " +
                      (parseInt(dato.__rowNum__) + 1) +
                      " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
                  );
                  flag_errores = true;
                }
              }
              if (!dato.numero_de_poliza) {
                vm.errores_carga_masivapago.push(
                  "En la columna numero_de_poliza en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo está vacío"
                );
                flag_errores = true;
              }
            }
            if (!dato.prima_total) {
              vm.errores_carga_masivapago.push(
                "En la columna prima_total en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            } else {
              if (!isNumeric(dato.prima_total)) {
                vm.errores_carga_masivapago.push(
                  "En la columna prima_total en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
                );
                flag_errores = true;
              }
            }
            if (!dato.serie_de_recibo) {
              vm.errores_carga_masivapago.push(
                "En la columna serie_de_recibo en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            } else {
              if (!isNumeric(dato.serie_de_recibo)) {
                vm.errores_carga_masivapago.push(
                  "En la columna serie_de_recibo en la fila " +
                    (parseInt(dato.__rowNum__) + 1) +
                    " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
                );
                flag_errores = true;
              }
            }
            if (!dato.tipo) {
              vm.errores_carga_masivapago.push(
                "En la columna tipo en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo está vacío"
              );
              flag_errores = true;
            }
            if (
              dato.tipo != "PG" &&
              dato.tipo != "PC" &&
              dato.tipo != "PI" &&
              dato.tipo != "NCI"
            ) {
              vm.errores_carga_masivapago.push(
                "En la columna tipo en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
              );
              flag_errores = true;
            }
            if (
              dato.frecuencia_de_pago != 1 &&
              dato.frecuencia_de_pago != 2 &&
              dato.frecuencia_de_pago != 3 &&
              dato.frecuencia_de_pago != 4 &&
              dato.frecuencia_de_pago != 5 &&
              dato.frecuencia_de_pago != 6 &&
              dato.frecuencia_de_pago != 7 &&
              dato.frecuencia_de_pago != 12 &&
              dato.frecuencia_de_pago != 14 &&
              dato.frecuencia_de_pago != 24
            ) {
              vm.errores_carga_masivapago.push(
                "En la columna frecuencia_de_pago en la fila " +
                  (parseInt(dato.__rowNum__) + 1) +
                  " el campo no corresponde a un valor válido (Revisar hoja de ayuda)"
              );
              flag_errores = true;
            }
          }
        });
        if (flag_errores) {
          vm.carga_masivapago = false;
          $scope.modalInstance = $uibModal.open({
            templateUrl: "app/cobranzas/cobranzas.modal.errores.html",
            controller: CobranzaErroresPagoCtrl,
            controllerAs: "vmm",
            size: "lg",
            resolve: {
              errores: function () {
                return vm.errores_carga_masivapago;
              },
              titulo: function () {
                return "Errores Recibos Carga Masiva";
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
        } else {
          param["datos"] = param["datos"].map(function (dato) {
            dato["rowNum"] = parseInt(dato.__rowNum__) + 1;
            return dato;
          });
          vm.lista_carga_masivapago = param["datos"];
          vm.carga_masivapago = true;
          SweetAlert.swal("Cargado", "Archivo cargado exitosamente", "success");
        }
      } else {
        SweetAlert.swal("ERROR", "El layout está vacío", "error");
        return;
        vm.carga_masivapago = false;
      }
    };

    function CobranzaErroresCtrl(
      $q,
      $scope,
      $sessionStorage,
      $uibModalInstance,
      $http,
      MESSAGES,
      errores,
      datesFactory,
      titulo
    ) {
      var vmm = this;

      vmm.errores = errores;
      vmm.titulo = titulo;

      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    function CobranzaErroresPagoCtrl(
      $q,
      $scope,
      $sessionStorage,
      $uibModalInstance,
      $http,
      MESSAGES,
      errores,
      datesFactory,
      titulo
    ) {
      var vmm = this;

      vmm.errores = errores;
      vmm.titulo = titulo;

      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    $scope.addEmail = function (email) {
      if (validateEmail(email) == false) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.INVALIDEMAIL, "error");
        return;
      } else {
        if ($scope.mails.indexOf(email) < 0 && $scope.vm.r_type == "1") {
          $scope.mails.push(email);
          $scope.vm.email_assign_mail = "";
        } else if (
          $scope.mails_cc.indexOf(email) < 0 &&
          $scope.vm.r_type == "2"
        ) {
          $scope.mails_cc.push(email);
          $scope.vm.email_assign_mail = "";
        } else if (
          $scope.mails_cco.indexOf(email) < 0 &&
          $scope.vm.r_type == "3"
        ) {
          $scope.mails_cco.push(email);
          $scope.vm.email_assign_mail = "";
        } else if (!$scope.vm.r_type) {
          SweetAlert.swal("ERROR", "Elegir Pricipal, Cc o Cco", "error");
        } else {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.REPEATEMAIL, "error");
        }
      }
    };
    $scope.phones_sms = [];

    $scope.addPhoneMensajeria = function (phmns) {
      var telefono = whatsappWebHelper.normalizePhone(phmns);
      if (telefono) {
        if (telefono.length < 9) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORLENGTHPHONE, "error");
          return;
        }
        if (
          $scope.phones_sms.indexOf(telefono) < 0 ||
          $scope.phones_sms.includes(telefono) == false
        ) {
          $scope.phones_sms.push(telefono);
        }
        if (vm.whatsappsms === 3) {
          vm.whatsappWebPhone = telefono;
        }
        vm.phone_mensajeria = "";
      } else {
        SweetAlert.swal("ERROR", "Agregue un Teléfono válido", "error");
        return;
      }
    };

    $scope.selectWhatsappWebPhone = function (phone) {
      if (phone === undefined || phone === null) {
        vm.whatsappWebPhone = "";
        return;
      }

      var telefono = whatsappWebHelper.normalizePhone(phone);
      if (!telefono) {
        vm.whatsappWebPhone = "";
        return;
      }

      if ($scope.phones_sms.indexOf(telefono) === -1) {
        return;
      }

      vm.whatsappWebPhone = telefono;
    };

    $scope.sendMessageByType = function () {
      try {
        if (!Array.isArray($scope.phones_sms) || !$scope.phones_sms.length) {
          SweetAlert.swal("ERROR", "Agregue Teléfonos", "error");
          return;
        }

        var telefonoSeleccionado = vm.whatsappWebPhone;

        if (vm.whatsappsms === 3) {
          if (!telefonoSeleccionado && $scope.phones_sms.length === 1) {
            telefonoSeleccionado = $scope.phones_sms[0];
          }

          if (!telefonoSeleccionado) {
            SweetAlert.swal(
              "ERROR",
              "Seleccione un número para enviar por WhatsApp Web",
              "error"
            );
            return;
          }
        }

        if (!telefonoSeleccionado && $scope.phones_sms.length) {
          telefonoSeleccionado =
            $scope.phones_sms[$scope.phones_sms.length - 1];
        }

        var telefono = whatsappWebHelper.normalizePhone(telefonoSeleccionado);

        if (!telefono) {
          SweetAlert.swal("ERROR", "Agregue un Teléfono válido", "error");
          return;
        }

        var manualValue = vm.messageWhatsappManual;
        if (!manualValue) {
          var manualTextarea = document.querySelector(
            'textarea[ng-model="vm.messageWhatsappManual"]'
          );
          manualValue = manualTextarea ? manualTextarea.value : "";
        }

        var previewHtml = $scope.preview;
        if (!previewHtml) {
          var previewDiv = document.querySelector('[ng-bind-html="preview"]');
          previewHtml = previewDiv
            ? previewDiv.innerHTML ||
              previewDiv.innerText ||
              previewDiv.textContent ||
              ""
            : "";
        }

        var mensajeFinal = whatsappWebHelper.composeMessage(
          manualValue,
          previewHtml,
          true
        );

        if (!mensajeFinal || !mensajeFinal.trim()) {
          alert("No hay mensaje para enviar.");
          return;
        }

        var url = whatsappWebHelper.buildWhatsAppUrl(telefono, mensajeFinal);

        if (!url) {
          alert("No fue posible construir el enlace de WhatsApp.");
          return;
        }

        window.open(url, "_blank");
      } catch (err) {
        console.error("Error al enviar mensaje WhatsApp Web:", err);
        alert("Ocurrió un error al intentar abrir WhatsApp Web.");
      }
    };

    $scope.sendReminderWhatsapp = function (
      files,
      first_comment,
      second_comment
    ) {
      if (vm.whatsappsms == 0) {
        $scope.type_msj = "all";
        var tipomsj = "Whatsapp/SMS";
      } else if (vm.whatsappsms == 1) {
        $scope.type_msj = "whatsapp";
        var tipomsj = "Whatsapp";
      } else if (vm.whatsappsms == 2) {
        $scope.type_msj = "sms";
        var tipomsj = "SMS";
      } else {
        $scope.type_msj = "all";
        var tipomsj = "Whatsapp/SMS";
      }
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if ($scope.phones_sms.length == 0) {
        l.stop();
        SweetAlert.swal("Error", "Agregue Teléfonos", "error");
        return;
      }
      if ($scope.phones_sms.length > 0) {
        $scope.receipt_pay = $uibModal.receipt;
        if ($scope.phones_sms) {
          $http
            .post(url.IP + "payment-reminder-whatsapp/", {
              r_id: $scope.receiptAll.id,
              phones_sms: $scope.phones_sms,
              asunto: $scope.subjectEmail,
              mensaje: vm.messageEmail,
              model: 4,
              type_msj: $scope.type_msj,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  l.stop();
                  swal("Enviado", "El recordatorio ha sido enviado", "success");
                  var params = {
                    model: 4,
                    event: "POST",
                    associated_id: $scope.receiptAll.id,
                    identifier: "Ha enviado el recordatorio por " + tipomsj,
                    save_logmail: 1,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  $uibModalInstance.dismiss("cancel");
                } else {
                  if (
                    request.data.response &&
                    request.data.response != "<Response [404]>"
                  ) {
                    l.stop();
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.\n" +
                        request.data.response,
                      "error"
                    );
                    $uibModalInstance.dismiss("cancel");
                  } else {
                    l.stop();
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                    $uibModalInstance.dismiss("cancel");
                  }
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        }
      } else {
        if ($scope.receiptAll.contratante) {
          if (
            $scope.receiptAll.contratante.email &&
            !$scope.receiptAll.contratante.email == ""
          ) {
            var arrayEmails = [];
            arrayEmails = [$scope.receiptAll.contratante.email];
            $http
              .post(url.IP + "payment-reminder-manual/", {
                r_id: $scope.receiptAll.id,
                emails: arrayEmails,
                asunto: $scope.subjectEmail,
                mensaje: vm.messageEmail,
              })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    SweetAlert.swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                    $uibModalInstance.dismiss("cancel");
                  } else {
                    SweetAlert.swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                    $uibModalInstance.dismiss("cancel");
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
            SweetAlert.swal(
              "El contratante no tiene correo, agregue correos",
              "error"
            );
            l.stop();
          }
        } else {
          SweetAlert.swal(
            "El contratante no tiene correo, agregue correos",
            "error"
          );
          l.stop();
        }
      }
    };

    $scope.shareFileEmail = function (file) {
      if (file.to_send) {
        file.to_send = false;
      } else {
        file.to_send = true;
      }
      share_via_email = [];
      $scope.files.forEach(function (filex) {
        if (filex.to_send) {
          share_via_email.push(filex.id);
        }
      });
    };

    $scope.SeleccionliquidarTodos = function () {
      var val = true;
      if (vm.receipts && vm.receipts.length > 0) {
        try {
          val = !vm.receipts[0].checked;
        } catch (err) {}
      }
      vm.receipts.map(function (receipt) {
        receipt["checked"] = val;
        return receipt;
      });
    };

    $scope.liquidarTodos = function () {
      var flag_continue = false;
      if (vm.receipts) {
        vm.receipts.forEach(function (receipt) {
          if (receipt.checked) {
            flag_continue = true;
          }
        });
        if (!flag_continue) {
          swal("Error", "Seleccione al menos un recibo para liquidar", "error");
          return;
        }
      }
      SweetAlert.swal(
        {
          title: "¡Aviso!",
          text: "Se liquidarán todos los recibos seleccionados. ¿Desea continuar?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.modalInstance = $uibModal.open({
              templateUrl: "app/cobranzas/cobranzas.modal.pago.html",
              controller: CobranzaLiquidaCtrl,
              controllerAs: "vmm",
              size: "lg",
              resolve: {
                recibos_a_liquidar: function () {
                  return vm.receipts.filter(function (r) {
                    return r.checked;
                  });
                },
                user_pay: function () {
                  return $scope.user_pay;
                },
                folio_pago: function () {
                  return vm.receipts[0].folio_pago;
                },
              },
              backdrop:
                "static" /* this prevent user interaction with the background */,
              keyboard: false,
            });
          } else {
          }
        }
      );
    };

    function CobranzaLiquidaCtrl(
      $q,
      $scope,
      $sessionStorage,
      $uibModalInstance,
      statusPayform,
      curr_rate_options,
      $http,
      MESSAGES,
      recibos_a_liquidar,
      user_pay,
      folio_pago
    ) {
      var vmm = this;
      vmm.accion = "Liquidar";
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);

      vmm.pago_date = convertDate(new Date());

      $scope.statusPayform = [];
      $scope.curr_rate_options = [];

      $scope.recibos_a_liquidar = recibos_a_liquidar;
      for (var i = 0; i < statusPayform.length; i++) {
        $scope.statusPayform.push(statusPayform[i]);
      }

      for (var i = 0; i < curr_rate_options.length; i++) {
        $scope.curr_rate_options.push(curr_rate_options[i]);
      }

      $scope.matchesBanks = function (parWord, type) {
        $scope.banks_data = 0;

        if (parWord) {
          $scope.bank_sb = parWord;
          var word_data = parWord.val;
          parWord = parWord.val;
        }

        if (word_data) {
          if (word_data.length >= 3) {
            var params = {
              pal: parWord,
            };

            dataFactory.get("banks-match/", params).then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data.results;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.alias,
                    value: item.id,
                    url: item.url,
                  };
                  source.push(obj);
                });
                $scope.banks_data = source;
                if (type == 3) {
                  $scope.bank_sb.url = $scope.banks_data[0].url;
                }
              }
            });
          }
        }
      };

      $scope.saveLiquidados = function () {
        $scope.pay_date = datesFactory.toDate(vmm.pago_date);
        var promises = [];
        $scope.folio_pago = folio_pago;
        $scope.rec_count = 0;
        recibos_a_liquidar.forEach(function (receipt, index) {
          promises.push(
            $http({
              method: "PATCH",
              url: receipt.url,
              data: {
                liquidacion_folio: $scope.folio_pago,
                liquidacion_date: $scope.pay_date
                  ? $scope.pay_date
                  : new Date(),
                status: 5,
                liquidacion_curr_rate: vmm.rate ? vmm.rate.value : null,
                liquidacion_doc: vmm.pay_doc,
                liquidacion_form: vmm.pay_form ? vmm.pay_form.value : null,
              },
            }).then(function (response) {
              swal(
                "Liquidado, folio: " + response.data.liquidacion_folio,
                "La selección ha sido liquidada",
                "success"
              );
              $scope.json_receipts_pay = [
                {
                  endosos: 0,
                  polizas: 0,
                  colectividades: 0,
                  total_endosos: 0,
                  total_polizas: 0,
                  total_colectividades: 0,
                },
              ];
              try {
                log_liq_and_pay_selected(response.data);
              } catch (e) {
                console.log("error al log recibo", e);
              }
            })
          );
          $q.all(promises).then(function () {
            recibos_a_liquidar.map(function (rec) {
              rec["status"] = 5;
              return rec;
            });
            getPDFLiquidacion($scope.folio_pago);
            getCobranza(2, 1, 1, 1);
            $scope.cancel();
          });
          $scope.rec_count = $scope.rec_count + 1;
        });
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }
    $scope.remove_phone = function (index) {
      var removed = $scope.phones_sms.splice(index, 1);
      if (removed && removed.length && vm.whatsappWebPhone === removed[0]) {
        vm.whatsappWebPhone = "";
        if (vm.whatsappsms === 3 && $scope.phones_sms.length === 1) {
          vm.whatsappWebPhone = $scope.phones_sms[0];
        }
      }
      if (
        !vm.whatsappWebPhone &&
        vm.whatsappsms === 3 &&
        $scope.phones_sms.length === 1
      ) {
        vm.whatsappWebPhone = $scope.phones_sms[0];
      }
    };

    $scope.remove_email = function (index) {
      $scope.mails.splice(index, 1);
    };
    $scope.remove_email_cc = function (index) {
      $scope.mails_cc.splice(index, 1);
    };
    $scope.remove_email_cco = function (index) {
      $scope.mails_cco.splice(index, 1);
    };

    function showAddEmails(param) {
      if ($scope.receiptAll.poliza) {
        if ($scope.receiptAll.poliza.contractor) {
          var name_contractor = $scope.receiptAll.poliza.contractor
            ? $scope.receiptAll.poliza.contractor
            : "";
          $http
            .post(url.IP + "contractors-contact/", {
              name: name_contractor,
            })
            .then(function (response) {
              if (response.status === 200) {
                $scope.correos = response.data.contact;
              }
            });
        } else if ($scope.receiptAll.contratante) {
          if ($scope.receiptAll.contratante.full_name) {
            var name_contractor = $scope.receiptAll.contratante.full_name;
            $http
              .post(url.IP + "contractors-contact/", {
                name: name_contractor,
              })
              .then(function (response) {
                if (response.status === 200) {
                  $scope.correos = response.data.contact;
                  $scope.correo_mostrar = response.data.contractors[0].email;
                }
              });
          }
        }
      } else {
        $scope.correos = [];
      }
      if (param.value == 1) {
        $scope.showAddEmail = false;
      } else {
        $scope.showAddEmail = true;
      }
    }
    function showAddPhones(param) {
      if ($scope.receiptAll.poliza) {
        if ($scope.receiptAll.poliza.contractor) {
          var name_contractor = $scope.receiptAll.poliza.contractor
            ? $scope.receiptAll.poliza.contractor
            : "";
          $http
            .post(url.IP + "contractors-contact/", {
              name: name_contractor,
            })
            .then(function (response) {
              if (response.status === 200) {
                $scope.phones = response.data.contractors[0].phone_contractor;
              }
            });
        } else if ($scope.receiptAll.contratante) {
          if ($scope.receiptAll.contratante.full_name) {
            var name_contractor = $scope.receiptAll.contratante.full_name;
            $http
              .post(url.IP + "contractors-contact/", {
                name: name_contractor,
              })
              .then(function (response) {
                if (response.status === 200) {
                  $scope.phones = response.data.contractors[0].phone_contractor;
                  $scope.correo_mostrar =
                    response.data.contractors[0].phone_mensajeria;
                }
              });
          }
        }
      } else {
        $scope.phones = [];
      }
    }
    $scope.ver_notas = function () {
      if ($scope.show_notes) {
        $scope.show_notes = false;
      } else {
        $scope.show_notes = true;
      }
    };

    $scope.getTemplate = function (custom_email, tipoc) {
      if (custom_email) {
        $http
          .get(url.IP + "payment-reminder-manual/" + $scope.receiptAll.id)
          .then(function (response) {
            if (response.status === 200) {
              $scope.head = response.data.head;
              $scope.body = response.data.body;
              $scope.footer = response.data.footer;
            }
          })
          .catch(function (e) {
            console.log("error - catch", e);
          });
      } else {
        vm.first_comment = "";
        vm.second_comment = "";
      }
      if (tipoc && tipoc == "email") {
        vm.messageEmail = "";
      }
    };

    activate();
    getCelulasContractor();

    function getCelulasContractor() {
      $http.post(url.IP + "celula_contractor_info/").then(function (celulas) {
        $scope.celulas = celulas.data;
      });
    }
    // var endingDate =  convertDate(new Date().setYear(new Date().getFullYear() + 1));
    // var endingDate =  convertDate(new Date());
    // vm.form.until = endingDate;

    function changeUntil() {
      var since = toDate(vm.form.since).getTime();
      var until = toDate(vm.form.until).getTime();
      var diff = until - since;
      var antiguedad = parseInt(diff / (1000 * 60 * 60 * 24));
      if (antiguedad < 0) {
        SweetAlert.swal(
          "Error",
          "La fecha final no puede ser menor que la inicial",
          "error"
        );
        var newdate = convertDate(new Date());
        vm.form.until = newdate;
      }
    }

    function toDate(dateStr) {
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    getSubramos();
    getProviders();
    getUsuarios();
    getSignature();
    function getUsuarios() {
      $http.get(url.IP + "usuarios/").then(function (data) {
        vm.users = data.data.results;
        vm.datos_users = data.data.results;
        vm.ejecutivos = [];
        vm.datos_users.forEach(function (u) {
          var obj = {
            name: u.first_name + " " + u.last_name,
            id: u.id,
          };
          vm.ejecutivos.push(obj);
        });
      });
    }
    function getSignature() {
      $http.get(url.IP + "signature/").then(function (response) {
        if (response.status === 200) {
          if (response.data.results.length) {
            $scope.signature = response.data.results[0].signature;
          }
        }
      });
    }
    $scope.setSignature = function () {
      $http
        .post(url.IP + "signature/", { signature: vm.signature })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            $scope.signature_edith = false;
            $scope.signature = response.data.signature;
            if ($scope.custom_email) {
              $http
                .get(url.IP + "payment-reminder-manual/" + $scope.receiptAll.id)
                .then(function (response) {
                  if (response.status === 200) {
                    $scope.head = response.data.head;
                    $scope.body = response.data.body;
                    $scope.footer = response.data.footer;
                  }
                })
                .catch(function (e) {
                  console.log("error - catch", e);
                });
            }
          }
        });
    };
    $scope.edithSignature = function () {
      $scope.signature_edith = true;
    };
    $scope.edithBanner = function () {
      $scope.banner_edith = true;
    };
    $scope.cancelEdithSignature = function () {
      $scope.signature_edith = false;
    };
    $scope.CancelEdithBanner = function () {
      $scope.banner_edith = false;
    };
    $scope.editImagesms = function () {
      $scope.imagesms_edit = true;
    };
    $scope.CancelEditISms = function () {
      $scope.imagesms_edit = false;
    };
    function activate(x) {
      $scope.campo_agrupacion = false;
      $scope.campo_celula = false;
      $scope.campo_lineanegocio = false;
      $scope.moduleName = "Célula";
      dataFactory.get("orginfo/").then(function success(response) {
        if (response.data.results.length) {
          $scope.configuracionGlobal = response.data.results[0];
          $scope.campo_agrupacion =
            $scope.configuracionGlobal.filtros_agrupacion;
          $scope.campo_celula = $scope.configuracionGlobal.filtros_celula;
          $scope.campo_lineanegocio =
            $scope.configuracionGlobal.filtros_lineanegocio;
          if ($scope.configuracionGlobal.moduleName) {
            $scope.moduleName = $scope.configuracionGlobal.moduleName;
          }
        }
      });
      // vm.whatsappsms = 0//whatsapp
      vm.whatsappsms = vm.whatsappWebEnabled ? 3 : 2; //whatsapp
      $scope.plantillasWhatsappWeb = [];
      $scope.loadingPlantillasWhatsappWeb = false;
      $scope.plantillaWhatsappWeb = null;
      if (vm.whatsappWebEnabled) {
        loadWhatsappWebTemplates();
      }
      $scope.getTemplate(true);
      $http({
        method: "GET",
        url: url.IP + "get_user_by_username/",
        params: {
          username: vm.user.name,
        },
      })
        .then(function (request) {
          $scope.user_pay = request.data;
        })
        .catch(function (e) {
          console.log("e", e);
        });
      $scope.ver_select_pay = false;
      getSubramos();
      getProviders();
      $scope.json_receipts = [
        {
          endosos: 0,
          polizas: 0,
          colectividades: 0,
          polizaColectividad: 0,
          fianzas: 0,
          total_prima: 0,
          endososNota: 0,
          total_nota: 0,
        },
      ];
      $scope.json_receipts_pay = [
        {
          endosos: 0,
          polizas: 0,
          colectividades: 0,
          fianzas: 0,
          total_prima: 0,
          endososNota: 0,
          total_nota: 0,
        },
      ];

      vm.form.status = vm.status[0];

      if ($scope.receiptAll) {
        var id_poliza = $scope.receiptAll.poliza
          ? $scope.receiptAll.poliza.id
          : 0;
        var id_fianza = $scope.receiptAll.fianza
          ? $scope.receiptAll.fianza.id
          : 0;
        $scope.asegurado = $scope.receiptAll.poliza
          ? $scope.receiptAll.poliza.id
          : 0;
        if (!id_poliza && $scope.receiptAll.poliza) {
          $http
            .get($scope.receiptAll.poliza)
            .then(function success(result) {
              if (result.status === 200 || result.status === 201) {
                id_poliza = result.data.id;
                if ($scope.receiptAll) {
                  dataFactory
                    .get("v1/notasCredito-info", {
                      status: 4,
                      id_poliza: id_poliza,
                      id_fianza: id_fianza,
                    })
                    .then(function success(nota) {
                      if (nota.status === 200 || nota.status === 201) {
                        $scope.notasCredito = nota.data;
                        $scope.notasCredito.forEach(function (it) {
                          it.sendNote = false;
                        });
                      }
                    })
                    .catch(function (e) {
                      console.log("e", e);
                    });
                }
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
        }
        if (!id_fianza && $scope.receiptAll.fianza) {
          $http
            .get($scope.receiptAll.fianza)
            .then(function success(result) {
              if (result.status === 200 || result.status === 201) {
                id_fianza = result.data.id;
                if ($scope.receiptAll) {
                  dataFactory
                    .get("v1/notasCredito-info", {
                      status: 4,
                      id_fianza: id_fianza,
                      id_poliza: id_poliza,
                    })
                    .then(function success(nota) {
                      if (nota.status === 200 || nota.status === 201) {
                        $scope.notasCredito = nota.data;
                        $scope.notasCredito.forEach(function (it) {
                          it.sendNote = false;
                        });
                      }
                    })
                    .catch(function (e) {
                      console.log("e", e);
                    });
                }
              }
            })
            .catch(function (e) {
              console.log("e", e);
            });
        }
        if (id_fianza != 0 && id_fianza != undefined) {
          if ($scope.receiptAll) {
            dataFactory
              .get("v1/notasCredito-info", {
                status: 4,
                id_poliza: 0,
                id_fianza: id_fianza,
              })
              .then(function success(nota) {
                if (nota.status === 200 || nota.status === 201) {
                  $scope.notasCredito = nota.data;
                  $scope.notasCredito.forEach(function (it) {
                    it.sendNote = false;
                  });
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
        if (id_poliza != 0 && id_poliza != undefined) {
          if ($scope.receiptAll) {
            dataFactory
              .get("v1/notasCredito-info", {
                status: 4,
                id_poliza: id_poliza,
                id_fianza: 0,
              })
              .then(function success(nota) {
                if (nota.status === 200 || nota.status === 201) {
                  $scope.notasCredito = nota.data;
                  $scope.notasCredito.forEach(function (it) {
                    it.sendNote = false;
                  });
                }
              })
              .catch(function (e) {
                console.log("e", e);
              });
          }
        }
      }

      if ($location.path() == "/cobranzas/recibosPendientes") {
        $scope.url_go_rp = "v1/receipts/";
        $http({
          method: "GET",
          url: url.IP + $scope.url_go_rp,
          params: {
            status: 1,
          },
        }).then(function (results) {
          vm.receipts = results.data;
          // vm.receipt = {
          //     count: results.data.count,
          //     previous: results.data.previous,
          //     next: results.data.next
          //   };
          //   vm.show_pag_policy = true;
          //   testPagination('vm.receipts', 'vm.receipt');
        });
      } else {
        $scope.ver_select_pay = true;
        getProviders();
        getReferenciador();
      }
      function loadWhatsappWebTemplates() {
        if ($scope.loadingPlantillasWhatsappWeb) {
          return;
        }
        $scope.loadingPlantillasWhatsappWeb = true;
        dataFactory
          .get("whatsappwebtemplate-unpag/")
          .then(function success(response) {
            var data = response && response.data ? response.data : [];
            var results = [];
            if (angular.isArray(data)) {
              results = data;
            } else if (data && data.results && angular.isArray(data.results)) {
              results = data.results;
            }
            $scope.plantillasWhatsappWeb = results;
            if (vm.whatsappsms === 3 && $scope.plantillasWhatsappWeb.length) {
              if (!$scope.plantillaWhatsappWeb) {
                $scope.plantillaWhatsappWeb = $scope.plantillasWhatsappWeb[0];
              }
              $scope.changePlantillaWhaWeb($scope.plantillaWhatsappWeb);
            }
          })
          .catch(function (error) {
            console.log("error - whatsapp web templates", error);
          })
          .finally(function () {
            $scope.loadingPlantillasWhatsappWeb = false;
          });
      }

      dataFactory
        .get("emailtemplate-unpag/", { template_model: 1 })
        .then(function success(response) {
          $scope.plantillas = response.data;
        });
      if ($scope.receiptAll) {
        if ($scope.receiptAll.contratante) {
          if ($scope.receiptAll.contratante.full_name) {
            var aseguradoname = $scope.receiptAll.contratante.full_name;
          } else {
            var aseguradoname = $scope.receiptAll.contratante;
          }
        } else {
          var aseguradoname = "Asegurado";
        }
      } else {
        var aseguradoname = "Asegurado";
      }

      dataFactory
        .get("smstemplate-unpag/")
        .then(function success(response) {
          $scope.plantillaSMS = response.data;
          if ($scope.plantillaSMS && response.data.length) {
            vm.messageEmail = $scope.plantillaSMS[0].text;
            $scope.plantilla = $scope.plantillaSMS[0];
          }
          setReminderPreviewLoading();
          $http({
            method: "GET",
            url: url.IP + "payment-reminder-whatsapp/",
            params: { r_id: $scope.receiptAll.id, tipo: vm.whatsappsms },
          })
            .then(function (request) {
              if (request.status === 200 || request.status === 201) {
                finalizeReminderPreview(
                  (request.data &&
                    request.data.response &&
                    request.data.response.mensaje) ||
                    ""
                );
              } else {
                finalizeReminderPreview("");
              }
            })
            .catch(function (error) {
              console.log("error - email", error);
              finalizeReminderPreview("");
            });
        })
        .catch(function (error) {
          console.log("error - smstemplate-unpag", error);
          finalizeReminderPreview("");
        });
      $http
        .get(url.IP + "banner/")
        .then(function (response) {
          if (response.status === 200) {
            if (
              response &&
              response.data &&
              response.data.results &&
              response.data.results.length > 0
            ) {
              var result = response.data.results[0];
              $scope.image_sms = result.image_sms;
              $scope.id_banners = result.id;
              $scope.footer = result.footer;
              $scope.header = result.header;
            }
          }
        })
        .catch(function (e) {
          console.log("error - catch", e);
        });

      $scope.plantillasWhatsapp = [
        {
          id: 1,
          mensaje:
            "Estimado Asegurado, su recibo esta cercano a vencer, le recordamos realizar su pago para que no quede sin cobertura, quedamos a sus órdenes para cualquier duda",
        },
        {
          id: 2,
          mensaje:
            "Estimado asegurado, es un placer saludarle, el motivo de este mensaje es para informarle que su recibo está próximo a vencer. Quedamos disponibles para cualquier duda o aclaración al respecto.",
        },
        {
          id: 3,
          mensaje:
            "Estimado Asegurado le informamos que su recibo ha vencido el día de hoy, contacte a su ejecutivo para que le aclare dudas sobre como realizar el pago",
        },
        {
          id: 4,
          mensaje:
            "Estimado asegurado, es un placer saludarle de parte de " +
            vm.org_name.toUpperCase() +
            ", le recordamos que su recibo está próximo a vencer.",
        },
        {
          id: 5,
          mensaje:
            "Estimado(a) Asegurado, le recordamos que su recibo está próximo a vencer, quedamos al pendiente para cualquier duda o aclaración al respecto.",
        },
        {
          id: 6,
          mensaje:
            "Estimado Asegurado, le recodamos que su recibo esta por vencer, si tiene dudas referente a su pago, puede contactar a su ejecutivo",
        },
        {
          id: 7,
          mensaje:
            "Estimado Asegurado, su recibo esta cercano a vencer, le recordamos realizar su pago para que no quede sin cobertura, quedamos a sus órdenes para cualquier duda",
        },
      ];
    }
    $scope.tipoMensaje = function (typ) {
      if (typ === 3 && !vm.whatsappWebEnabled) {
        vm.whatsappsms = 2;
        typ = 2;
      }
      if (typ == 1) {
        vm.messageWhatsappManual = "";
        vm.messageEmail = $scope.plantillasWhatsapp[0].mensaje;
        $scope.plantilla = $scope.plantillasWhatsapp[0];
      }
      if (typ == 2) {
        vm.messageWhatsappManual = "";
        vm.messageEmail = $scope.plantillaSMS[0].text;
        $scope.plantilla = $scope.plantillaSMS[0];
      }
      if (typ == 3) {
        vm.messageEmail = "";
        if (
          $scope.plantillasWhatsappWeb &&
          $scope.plantillasWhatsappWeb.length
        ) {
          var seleccionActual = $scope.plantillaWhatsappWeb;
          var existeSeleccion = false;
          if (seleccionActual && seleccionActual.id) {
            existeSeleccion = $scope.plantillasWhatsappWeb.some(function (
              template
            ) {
              return template.id === seleccionActual.id;
            });
          }
          if (!existeSeleccion) {
            $scope.plantillaWhatsappWeb = $scope.plantillasWhatsappWeb[0];
          }
          $scope.changePlantillaWhaWeb($scope.plantillaWhatsappWeb);
        } else {
          vm.messageWhatsappManual = "";
        }
        if ($scope.phones_sms && $scope.phones_sms.length) {
          if ($scope.phones_sms.indexOf(vm.whatsappWebPhone) === -1) {
            vm.whatsappWebPhone =
              $scope.phones_sms[$scope.phones_sms.length - 1];
          }
        } else {
          vm.whatsappWebPhone = "";
        }
      }
      if (typ != 3) {
        vm.whatsappWebPhone = "";
      }
      setReminderPreviewLoading();
      $http({
        method: "GET",
        url: url.IP + "payment-reminder-whatsapp/",
        params: { r_id: $scope.receiptAll.id, tipo: vm.whatsappsms },
      })
        .then(function (request) {
          if (request.status === 200 || request.status === 201) {
            finalizeReminderPreview(
              (request.data &&
                request.data.response &&
                request.data.response.mensaje) ||
                ""
            );
          } else {
            finalizeReminderPreview("");
          }
        })
        .catch(function (error) {
          console.log("error - email", error);
          finalizeReminderPreview("");
        });
    };

    $scope.changePlantilla = function (item) {
      if (item) {
        $scope.subjectEmail = item.title;
        vm.first_comment = item.text;
        if (vm.first_comment.includes("\n")) {
          vm.first_comment = vm.first_comment.replace("\n", "<br><br>");
        }
        vm.second_comment = item.bottom_text;
        $scope.custom_email = true;
        $scope.getTemplate(true);
      } else {
        $scope.subjectEmail = "";
        $scope.first_comment = "";
        $scope.second_comment = "";
        $scope.custom_email = false;
        $scope.getTemplate(false);
      }
    };
    $scope.changeSMS = function (item) {
      if (item) {
        vm.messageEmail = item.text;
        $scope.custom_email = true;
      } else {
        vm.messageEmail =
          "Estimado Asegurado: Usted tiene un recibo pendiente de pago, comuníquese con " +
          (vm.org_name.toUpperCase() ? vm.org_name : "") +
          " para más Información " +
          "\n";
        $scope.custom_email = false;
      }
    };
    $scope.changePlantillaWha = function (item) {
      if (item) {
        if (item.mensaje.includes("\n")) {
          item.mensaje = item.mensaje.replace("\n", "<br><br>");
        }
        vm.messageEmail = item.mensaje;
        $scope.custom_email = true;
      } else {
        vm.messageEmail =
          "Estimado Asegurado: Usted tiene un recibo pendiente de pago, comuníquese con " +
          (vm.org_name.toUpperCase() ? vm.org_name : "") +
          " para más Información " +
          "\n";
        $scope.custom_email = false;
      }
    };
    $scope.changePlantillaWhaWeb = function (item) {
      if (item) {
        var mensaje = item.text || item.mensaje || "";
        if (
          mensaje &&
          typeof mensaje === "string" &&
          mensaje.indexOf("<") !== -1
        ) {
          mensaje = mensaje
            .replace(/<br\s*\/?>(\r?\n)?/gi, "\n")
            .replace(/<\/p>/gi, "\n")
            .replace(/<[^>]+>/g, "");
        }
        vm.messageWhatsappManual =
          whatsappWebHelper.normalizeLineBreaks(mensaje);
        $scope.custom_email = true;
      } else {
        vm.messageWhatsappManual = "";
      }
    };
    $scope.addPhoneWhatsapp = function (insurance, contra) {
      insurance.contratante = contra;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.phone.whatsappsms_reminderpay.html",
        controller: "CobranzasCtrl",
        controllerAs: "vm",
        size: "lg",
        resolve: {
          insurance: function () {
            return insurance;
          },
          valueReceipt: function () {
            return insurance;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };

    vm.getCaratulas = getCaratulas;
    function getCaratulas(parId) {
      var results = [];
      var mapeo_caratulas = [];
      if (parId) {
        if (parId.val.length >= 3) {
          $scope.show_cds = "get-all-caratulas/";
          $http({
            method: "POST",
            url: url.IP + $scope.show_cds,
            data: {
              word: parId.val,
            },
          })
            .then(
              function success(request) {
                var results = [];
                var mapeo_caratulas = [];
                if (request.status == 200) {
                  if (request.data.length == 0) {
                    vm.only_caratula_poliza = 0;
                    $scope.autocompleteData = [];
                    vm.word.id = 0;
                    toaster.warning("Carátula no encontrada");
                  } else {
                    request.data.forEach(function (poliza) {
                      vm.policy = poliza;
                      if (poliza.document_type == 11) {
                        mapeo_caratulas.push(poliza);
                      }
                    });
                    results = _.map(mapeo_caratulas, function (item) {
                      if (item.contractor) {
                        var label =
                          item.poliza_number +
                          " - " +
                          item.contractor.full_name +
                          " - " +
                          convertDate(vm.policy.start_of_validity) +
                          " - " +
                          convertDate(vm.policy.end_of_validity);
                      } else {
                        var label = item.poliza_number;
                      }
                      return {
                        label: label,
                        value: item.poliza_number,
                        id: item.id,
                        document_type: item.document_type,
                      };
                    });
                    $scope.autocompleteData = results;
                  }
                }
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        } else {
          vm.only_caratula_poliza = 0;
          $scope.autocompleteData = [];
          vm.word.id = 0;
        }
      }
    }
    vm.getCarSelected = getCarSelected;
    function getCarSelected(caratula) {
      vm.only_caratula_poliza = caratula.id;
    }
    $scope.$watch("vm.word", function (newValue, oldValue) {
      if (vm.word) {
        if (vm.word.id) {
          vm.only_caratula_poliza = parseInt(vm.word.id);
        } else {
          vm.only_caratula_poliza = 0;
        }
      }
    });
    function returnToReceipts(x) {
      vm.show_binnacle = false;
      $scope.filtros.tipo_recibo = vm.form.tipo_recibo
        ? vm.form.tipo_recibo
        : 0;
    }
    $scope.showTabs = function (param) {
      $scope.tab = param ? true : false;
    };
    function returnToNote() {
      vm.show_binnacle_nc = false;
    }
    function getLog(rece) {
      dataFactory
        .get("get-specific-log", { model: 4, associated_id: rece.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/log.modal.html",
            controller: "LogCtrl",
            size: "lg",
            resolve: {
              log: function () {
                return response.data;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    }

    // function verFlotilla(rece) {
    $scope.verFlotilla = function (colect) {
      dataFactory
        .get("get-certificates-flotilla", { id_caratula: colect.id })
        .then(function success(response) {
          var modalInstance = $uibModal.open({
            //jshint ignore:line
            templateUrl: "app/cobranzas/flotilla.modal.html",
            controller: "CertificateCtrl",
            size: "lg",
            resolve: {
              certificates: function () {
                return response.data;
              },
              poliza_number: function () {
                return colect.poliza_number;
              },
              caratula: function () {
                return colect;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
          modalInstance.result.then(function (receipt) {
            vm.receipts.splice(index, 1);
            activate();
          });
        });
    };

    $scope.exportData = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (vm.form.subgroup) {
        if (vm.form.subgroup.id) {
          var g1 = vm.form.subgroup.id;
        } else {
          var g1 = 0;
        }
      }
      if (vm.form.subsubgroup) {
        if (vm.form.subsubgroup.id) {
          var g2 = vm.form.subsubgroup.id;
        } else {
          var g2 = 0;
        }
      } else {
        var g2 = 0;
      }
      if (vm.form.groupinglevel) {
        if (vm.form.groupinglevel.val) {
          var gl = vm.form.groupinglevel.value;
        } else {
          var gl = 0;
        }
      } else {
        var gl = 0;
      }
      if (vm.form.subgrouping) {
        if (vm.form.subgrouping.id) {
          var gl1 = vm.form.subgrouping.id;
        } else {
          var gl1 = 0;
        }
      } else {
        var gl1 = 0;
      }
      if (vm.form.subsubgrouping) {
        if (vm.form.subsubgrouping.id) {
          var gl2 = vm.form.subsubgrouping.id;
        } else {
          var gl2 = 0;
        }
      } else {
        var gl2 = 0;
      }
      if (vm.form.celula) {
        if (vm.form.celula.id) {
          var cel = vm.form.celula.id;
        } else {
          var cel = 0;
        }
      } else {
        var cel = 0;
      }
      $scope.filtros.tipo_recibo = vm.form.tipo_recibo
        ? vm.form.tipo_recibo
        : 0;
      $scope.filtros.tipo_poliza = vm.form.tipo_poliza
        ? vm.form.tipo_poliza.id
        : 0;
      $scope.filtros.user_pay = vm.user_pay_selected ? vm.user_pay_selected : 0;
      $scope.filtros.polizas = vm.form.poliza_number;
      $scope.filtros.classification = vm.form.classification.value
        ? vm.form.classification.value
        : vm.form.classification;
      $scope.filtros.subgrupo = g1 ? g1 : 0;
      $scope.filtros.celula = cel ? cel : 0;
      $scope.filtros.subsubgrupo = g2 ? g2 : 0;
      $scope.filtros.groupinglevel = gl ? gl : 0;
      $scope.filtros.subgrupinglevel = gl1 ? gl1 : 0;
      $scope.filtros.subsubgrupinglevel = gl2 ? gl2 : 0;
      $scope.filtros.businessLine = $scope.bLine ? $scope.bLine.id : 0;
      $scope.filtros.only_caratula = vm.only_caratula_poliza
        ? vm.only_caratula_poliza
        : 0;
      $scope.filtros.conducto_de_pago = vm.form.tipo_cobro;
      var url_rep = "service_reporte-cobranzalist-excel";
      if (param == 1) {
        $http({
          // method: 'GET',
          // url: url.IP + 'reporte-cobranzamod',
          // params: $scope.filtros,
          method: "POST",
          url: url.IP + url_rep, //'reporte-cobranzamod/',
          data: $scope.filtros,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
          .then(function success(request) {
            if (request.status === 200) {
              var blob = new Blob([request.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Reporte_Cobranza.xls");
            }
            l.stop();
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      }
      if (param == 2) {
        $http({
          method: "GET",
          url: url.IP + "reporte-cobranzaAll",
          params: $scope.filtros,
        })
          .then(function success(request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "Cobranzas");
            }
            l.stop();
          })
          .catch(function (e) {
            l.stop();
            console.log("e", e);
          });
      }
      // if(param == 3){
      //     $http({
      //           method: 'GET',
      //           url: url.IP + 'reporte-cobranzaPagados',
      //           params: $scope.filtros
      //       }). then(function success(request) {
      //             if(request.status === 200) {
      //                 exportFactory.excel(request.data, 'Recibos_pagados');
      //             }

      //           })
      //           .catch(function (e) {
      //             console.log('e', e);
      //           });

      // }
      // if(param == 4){
      //     $http({
      //           method: 'GET',
      //           url: url.IP + 'reporte-cobranzaCancelados',
      //           params: $scope.filtros
      //       }). then(function success(request) {
      //             if(request.status === 200) {
      //                 exportFactory.excel(request.data, 'Recibos_cancelados');
      //             }

      //           })
      //           .catch(function (e) {
      //             console.log('e', e);
      //           });

      // }
      // if(param == 5){
      //     $http({
      //           method: 'GET',
      //           url: url.IP + 'reporte-cobranzamod',
      //           params: $scope.filtros
      //       }). then(function success(request) {
      //             if(request.status === 200) {
      //                 exportFactory.excel(request.data, 'Recibos Liquidades');
      //             }

      //           })
      //           .catch(function (e) {
      //             console.log('e', e);
      //           });

      // }
    };

    // function showBinnacle(param) {
    //   $http({
    //     method: 'GET',
    //     url: url.IP+'comments/',
    //     params: {
    //       'model': 4,
    //     'id_model': param.id
    //     }
    //   })
    //   .then(function(request) {

    //     vm.comments_data = request.data.results;
    //     vm.comments_config = {
    //       count: request.data.count,
    //       previous: request.data.previous,
    //       next: request.data.next
    //     }
    //   })
    //   .catch(function(e) {
    //     console.log('e', e);
    //   });

    //   vm.receipt_id = param.id;
    //   if (param.gastos_expedicion){
    //     vm.notas_id = param.id;
    //     vm.show_binnacle_nc = true;
    //   }else{
    //     vm.show_binnacle = true;
    //   }
    // };
    function exportReceiptComments() {
      if (!vm.receipt_id || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
      };

      var params = {
        model: 4,
        id_model: vm.receipt_id,
      };
      if (vm.org_name) {
        params.org = vm.org_name;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: params,
          downloadName: "bitacora-cobranzas.xlsx",
          token: token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }

    function showBinnacle(param, parType) {
      $scope.receiptmodel = param.url;
      vm.receipt = param;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 4,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });

      vm.receipt_url = param.url;
      vm.receipt_id = param.id;
      if (param.gastos_expedicion) {
        vm.notas_id = param.id;
        vm.show_binnacle_nc = true;
      } else {
        vm.show_binnacle = true;
      }
    }

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }
    vm.changeReceipts = changeReceipts;
    function changeReceipts(par, asc) {
      switch (par) {
        case 1:
          Generar($scope.param, par, asc);
          vm.receipts_tipo_asc = asc;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 2:
          Generar($scope.param, par, asc);
          vm.receipts_cont_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 3:
          Generar($scope.param, par, asc);
          vm.receipts_nump_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 4:
          Generar($scope.param, par, asc);
          vm.receipts_periodo_asc = asc;
          vm.receipts_cont_asc = 0;
          vm.receipts_tipo_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 5:
          Generar($scope.param, par, asc);
          vm.receipts_aseg_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          vm.receipts_ffin_asc = 0;
          break;
        case 6:
          Generar($scope.param, par, asc);
          vm.receipts_estatus_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 7:
          Generar($scope.param, par, asc);
          vm.receipts_ptotal_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_operador_asc = 0;
          break;
        case 8:
          Generar($scope.param, par, asc);
          vm.receipts_operador_asc = asc;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_ffin_asc = 0;
          break;
        case 11:
          Generar($scope.param, par, asc);
          vm.receipts_operador_asc = 0;
          vm.receipts_tipo_asc = 0;
          vm.receipts_cont_asc = 0;
          vm.receipts_nump_asc = 0;
          vm.receipts_periodo_asc = 0;
          vm.receipts_aseg_asc = 0;
          vm.receipts_estatus_asc = 0;
          vm.receipts_ptotal_asc = 0;
          vm.receipts_ffin_asc = 0;
          vm.receipt_promesa_pago = asc;
          break;
      }
    }
    vm.show_nota = false;

    function Generar(param, order, asc, page) {
      $scope.param = param;
      getCobranza(param, order, asc, page);
      if (vm.show_binnacle == true || vm.show_binnacle_nc == true) {
        vm.show_binnacle = false;
        vm.show_binnacle_nc = false;
      }
    }
    vm.show_button1 = false;
    vm.show_button2 = false;
    vm.show_button3 = false;
    vm.show_button4 = false;
    vm.show_button0 = false;
    vm.show_button_nc = false;

    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.ramos_selected = [];
      vm.subramos_toselected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r.id));
      });
      getSubramos();
      // if (sel.length == 1) {
      //   if (vm.id) {
      //     $http.get(url.IP + 'subramos-by-ramo_code/'+ vm.id)
      //       .then(function(data){
      //           vm.subramos_toselected = data.data;
      //     });
      //   }
      // }
      // if(sel.length == 0){
      //     vm.subramos_toselected = []
      //     vm.subramos_selected = [];
      // }
    };

    $scope.selectSubramos = function (sel) {
      vm.subramos_selected = [];
      sel.forEach(function (sr) {
        if (sr.subramo_code) var code = sr.subramo_code;
        else var code = sr.id;
        vm.subramos_selected.push(code);
      });
    };

    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    };

    $scope.loader = 1;
    function getCobranza(param, order, asc, parPage) {
      vm.receipts = [];
      $scope.recibos_a_liquidar = [];
      $scope.recibos_a_pagar = [];
      $scope.showButtonPending = false;
      $scope.showButtonPay = false;
      $scope.todosPendientes(false);
      $scope.todosPagados(false);

      $scope.folio_liquidacion = "";
      $scope.folio_pago = "";
      var lb = Ladda.create(document.querySelector(".ladda-button2"));
      if (vm.buscar_por_folio) {
        if (vm.folio_a_buscar <= 0) {
          swal("Error", "Folio inválido", "error");
          return;
        }
        if (vm.form.user) {
          $scope.users = [vm.form.user.id];
        } else {
          $scope.users = [];
        }
        $http
          .post(url.IP + "get-recibos-folio-pago-liquidacion/", {
            folio: vm.folio_a_buscar,
            tipo_folio: vm.tipo_folio_buscar,
            page: parPage,
            usuarios: $scope.users,
            inicial: "",
            final: "",
          })
          .then(
            function success(response) {
              vm.receipts_to_pay_lenght = response.data.count;
              if (response.status === 200 && response.data.results.length) {
                $scope.results = response.data.results;

                var item_ = $scope.results[0];

                $scope.head_data = [];
                for (var i in item_) {
                  var obj = { field: i };
                  $scope.head_data.push(obj);
                }
                vm.receipts = [];
                vm.receipts = response.data.results;
                if (param < 5) {
                  vm.receipts = [];
                  vm.receipts = response.data.results;
                  vm.receipt = {};
                  vm.receipt = {
                    count: response.data.count,
                    previous: response.data.previous,
                    next: response.data.next,
                  };
                  if (vm.receipts) {
                    vm.show_pag_policy = true;
                  } else {
                    vm.show_pag_policy = false;
                  }
                  testPagination("vm.receipts", "vm.receipt");
                }
              } else {
                toaster.warning("No se encontraron recibos");
              }
            },
            function error(error) {
              swal("Error", "Folio inválido", "error");
              return;
            }
          );
      } else {
        lb.start();
        if (param == 1) {
          vm.pagar_is_posible = true;
        } else {
          vm.pagar_is_posible = false;
        }
        if (param == 2) {
          vm.liquidar_is_posible = true;
        } else {
          vm.liquidar_is_posible = false;
        }
        if (vm.form.status.id == 2) {
          vm.liquidar_is_posible = true;
        } else {
          vm.liquidar_is_posible = false;
        }
        $scope.order = order;
        $scope.asc = asc;
        $scope.param_a = param;
        $scope.page = parPage ? parPage : 1;
        vm.show_pag_policy = false;
        $scope.results = [];
        vm.receipts = [];
        $scope.param = param;
        if (param == 1) {
          //pendiente
          vm.show_button1 = true;
        }
        if (vm.form.subgroup) {
          if (vm.form.subgroup.id) {
            var g1 = vm.form.subgroup.id;
          } else {
            var g1 = 0;
          }
        }
        if (vm.form.subsubgroup) {
          if (vm.form.subsubgroup.id) {
            var g2 = vm.form.subsubgroup.id;
          } else {
            var g2 = 0;
          }
        } else {
          var g2 = 0;
        }
        if (vm.form.groupinglevel) {
          if (vm.form.groupinglevel.val) {
            var gl = vm.form.groupinglevel.value;
          } else {
            var gl = 0;
          }
        } else {
          var gl = 0;
        }
        if (vm.form.subgrouping) {
          if (vm.form.subgrouping.id) {
            var gl1 = vm.form.subgrouping.id;
          } else {
            var gl1 = 0;
          }
        } else {
          var gl1 = 0;
        }
        if (vm.form.subsubgrouping) {
          if (vm.form.subsubgrouping.id) {
            var gl2 = vm.form.subsubgrouping.id;
          } else {
            var gl2 = 0;
          }
        } else {
          var gl2 = 0;
        }
        if (vm.form.celula) {
          if (vm.form.celula.id) {
            var cel = vm.form.celula.id;
          } else {
            var cel = 0;
          }
        } else {
          var cel = 0;
        }
        var params = {
          provider: vm.form.provider.id
            ? vm.form.provider.id
            : vm.form.provider,
          vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
          ejecutivo: vm.form.ejecutivo ? vm.form.ejecutivo.id : 0,
          ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
          subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
          since: vm.form.since ? vm.form.since : vm.form.si,
          until: vm.form.until ? vm.form.until : vm.form.un,
          payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
          status: vm.form.status ? vm.form.status.id : vm.form.status,
          contratante: vm.form.contratante.value
            ? vm.form.contratante.value
            : 0,
          grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
          type_contractor: vm.form.contratante.type
            ? vm.form.contratante.type
            : 0,
          // status: vm.form.status.id,
          page: parPage ? parPage : 1,
          dates: vm.form.dates,
          ramos: vm.ramos_selected ? vm.ramos_selected : 0,
          subramos: vm.subramos_selected ? vm.subramos_selected : 0,
          providers: vm.providers_selected ? vm.providers_selected : 0,
          tipo_recibo: vm.form.tipo_recibo ? vm.form.tipo_recibo : 0,
          user_pay: vm.user_pay_selected ? vm.user_pay_selected : 0,
          tipo_poliza: vm.form.tipo_poliza ? vm.form.tipo_poliza.id : 0,
          classification: vm.form.classification.value
            ? vm.form.classification.value
            : 0,
          subgrupo: g1 ? g1 : 0,
          subsubgrupo: g2 ? g2 : 0,
          groupinglevel: gl ? gl : 0,
          subgrupinglevel: gl1 ? gl1 : 0,
          subsubgrupinglevel: gl2 ? gl2 : 0,
          businessLine: $scope.bLine ? $scope.bLine.id : 0,
          celula: cel ? cel : 0,
          only_caratula: vm.only_caratula_poliza ? vm.only_caratula_poliza : 0,
          conducto_de_pago: vm.form.tipo_cobro,
        };
        if (vm.form.contratante.val == "") {
          params.contratante = 0;
          vm.form.contratante.value = "";
          vm.form.contratante.type = "";
        }
        if (vm.form.group.val == "") {
          params.grupo = 0;
          vm.form.group.value = "";
          vm.form.group.type = "";
        }
        params.since = params.since + " " + "00:00:00";
        params.until = params.until + " " + "23:59:59";
        if ($location.path() == "/cobranzas/recibosPendientes") {
          params.since = "01/01/1950" + " " + "00:00:00";
          params.until = "31/12/2099" + " " + "23:59:59";
          params.status = 1;
        }
        $scope.filtros = params;
        $scope.filtros.order = order;
        $scope.filtros.asc = asc;
        $scope.filtros.polizas = vm.form.poliza_number;
        var get_cobranza = "get-cobranza/";

        if ($scope.loader == 1) {
          $scope.loader = 2;
          $http({
            method: "POST",
            url: url.IP + get_cobranza,
            data: $scope.filtros,
          }).then(
            function success(response) {
              vm.receipts_to_pay_lenght = response.data.count;
              $rootScope.results_rec = response.data;
              $rootScope.filtros_consulta = $scope.filtros;
              if (response.status === 200 && response.data.results.length) {
                vm.receipts = [];
                $scope.results = response.data.results;
                lb.stop();
                // if($location.path() == "/cobranzas/recibosPendientes"){
                vm.receipts = response.data.results;
                vm.receipts = {
                  count: response.data.count,
                  previous: url.IP + get_cobranza,
                  next: url.IP + get_cobranza,
                };
                if (param == 2) {
                  response.data.results.forEach(function (rec) {
                    $scope.recibos_a_liquidar.forEach(function (rec_w) {
                      if (rec.id == rec_w.id) {
                        if (rec) {
                          rec.toPay = true;
                        } else {
                        }
                      }
                    });
                  });
                }
                // testPagination('vm.receipts', 'vm.receipts');
                if (
                  $scope.filtros &&
                  $scope.filtros.status &&
                  ($scope.filtros.status == 2 ||
                    $scope.filtros.status == 4 ||
                    $scope.filtros.status == 1)
                ) {
                  vm.show_pag_policy = false;
                } else {
                  $scope.obtenerPaginacion(
                    response.data,
                    parPage ? parPage : 1,
                    order,
                    asc,
                    param
                  );
                  vm.show_pag_policy = true;
                }
                // }

                var item_ = $scope.results[0];

                $scope.head_data = [];
                for (var i in item_) {
                  var obj = { field: i };
                  lb.stop();
                  $scope.head_data.push(obj);
                }

                if (response.status === 200 && response.data.results.length) {
                  lb.stop();
                  vm.receipts = [];
                  vm.receipt = {};
                  vm.receipts = response.data.results;
                  vm.receipt = {
                    count: response.data.count,
                    previous: response.data.previous,
                    next: response.data.next,
                  };
                  if (vm.receipts) {
                    vm.show_pag_policy = true;
                  } else {
                    vm.show_pag_policy = false;
                  }
                  // testPagination('vm.receipts', 'vm.receipt');
                  if (
                    $scope.filtros &&
                    $scope.filtros.status &&
                    ($scope.filtros.status == 2 ||
                      $scope.filtros.status == 4 ||
                      $scope.filtros.status == 1)
                  ) {
                    vm.show_pag_policy = false;
                  } else {
                    $scope.obtenerPaginacion(
                      response.data,
                      parPage ? parPage : 1,
                      order,
                      asc,
                      param
                    );
                    vm.show_pag_policy = true;
                  }
                }
              } else {
                lb.stop();
                toaster.warning("No se encontraron recibos");
              }
              $scope.loader = 1;
            },
            function error(err) {
              console.log("error", err);
              lb.stop();
            }
          );
          $scope.filtros.polizaId = 0;
        } else {
          SweetAlert.swal(
            "Error",
            "Debe esperar a que termine la consulta anterior.",
            "error"
          );
        }
      }
    }

    $scope.sendMailContractor = function (receipt) {
      if (receipt.contratante) {
        if (receipt.contratante.email && !receipt.contratante.email == "") {
          var arrayEmails = [];
          arrayEmails = [receipt.contratante.email];
          var notasC = [];
          if ($scope.notasCredito) {
            $scope.notasCredito.forEach(function (itRec) {
              if (itRec.sendNote) {
                notasC.push(itRec.sendNote);
                $scope.notaSelected = itRec;
              }
            });
          }
          if (notasC.length > 1) {
            l.stop();
            SweetAlert.swal(
              "Información",
              "Seleccione sólo una Nota de Crédito",
              "warning"
            );
            return;
          }
          if ($scope.notaSelected) {
            var num_nota = $scope.notaSelected.id;
          } else {
            var num_nota = 0;
          }

          $http
            .post(url.IP + "payment-reminder-manual/", {
              r_id: receipt.id,
              emails: arrayEmails,
              nota_id: num_nota,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  SweetAlert.swal(
                    "Enviado",
                    "El recordatorio ha sido enviado",
                    "success"
                  );
                } else {
                  SweetAlert.swal(
                    "Error",
                    "No se envió el recordatorio. Contacte a su administrador.",
                    "error"
                  );
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          toaster.info("El contratante no tiene correo, agregue correos");
        }
      } else {
        toaster.error("El contratante no tiene correo, agregue correos");
      }
    };

    // nueva paginación inicial
    $scope.obtenerPaginacion = function (pagesdata, pagina, order, asc, param) {
      $scope.paginacion = {
        count: pagesdata["count"],
        previous: pagesdata["previous"],
        next: pagesdata["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      vm.getCobranza($scope.param_a, $scope.order, $scope.asc, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        vm.getCobranza(
          $scope.param_a,
          $scope.order,
          $scope.asc,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        vm.getCobranza(
          $scope.param_a,
          $scope.order,
          $scope.asc,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };

    $scope.liquidar_masivo = function (flag, order, asc, parPage) {
      if (flag == 1) {
        if (vm.receipts_to_pay_lenght > 1)
          var _text =
            "Confirmar el pago de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibos)";
        else
          var _text =
            "Confirmar el pago de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibo)";
        var data_alert = {
          title: "Pagar selección",
          text: _text,
          type: "warning",
          confirmButtonText: "Pagar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
        };

        var data_alert = {
          title:
            "Confirmar el pago de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibos)",
          text: "Escriba la fecha de Pago: *(DD/MM/AAAA)",
          type: "input",
          confirmButtonText: "Pagar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          closeOnConfirm: true,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
          inputPlaceholder: "DD/MM/AAAA",
        };

        SweetAlert.swal(data_alert, function (inputValue) {
          if (inputValue === false) return false;
          if (
            inputValue &&
            (inputValue.length < 10 || inputValue.length > 10)
          ) {
            toaster.error(
              "Fecha de Pago incorrecta,escriba la Fecha de Pago en formato correcto (DD/MM/AAAA)"
            );
            return false;
          }
          if (inputValue === "") {
            swal("Escriba la Fecha de Pago en formato correcto (DD/MM/AAAA)");
            return false;
          } else {
            $scope.pay_date = datesFactory.toDate(inputValue);
            $scope.pay_date_view = convertDate($scope.pay_date);
            if (
              $scope.pay_date != "Invalid Date" &&
              $scope.pay_date != null &&
              $scope.pay_date != "NaN/NaN/NaN"
            ) {
              if (vm.form.subgroup) {
                if (vm.form.subgroup.id) {
                  var g1 = vm.form.subgroup.id;
                } else {
                  var g1 = 0;
                }
              }
              if (vm.form.subsubgroup) {
                if (vm.form.subsubgroup.id) {
                  var g2 = vm.form.subsubgroup.id;
                } else {
                  var g2 = 0;
                }
              } else {
                var g2 = 0;
              }
              if (vm.form.groupinglevel) {
                if (vm.form.groupinglevel.val) {
                  var gl = vm.form.groupinglevel.value;
                } else {
                  var gl = 0;
                }
              } else {
                var gl = 0;
              }
              if (vm.form.subgrouping) {
                if (vm.form.subgrouping.id) {
                  var gl1 = vm.form.subgrouping.id;
                } else {
                  var gl1 = 0;
                }
              } else {
                var gl1 = 0;
              }
              if (vm.form.subsubgrouping) {
                if (vm.form.subsubgrouping.id) {
                  var gl2 = vm.form.subsubgrouping.id;
                } else {
                  var gl2 = 0;
                }
              } else {
                var gl2 = 0;
              }
              if (vm.form.celula) {
                if (vm.form.celula.id) {
                  var cel = vm.form.celula.id;
                } else {
                  var cel = 0;
                }
              } else {
                var cel = 0;
              }
              var params = {
                provider: vm.form.provider.id
                  ? vm.form.provider.id
                  : vm.form.provider,
                vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
                ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
                subramo: vm.form.subramo.id
                  ? vm.form.subramo.id
                  : vm.form.subramo,
                since: vm.form.since ? vm.form.since : vm.form.si,
                until: vm.form.until ? vm.form.until : vm.form.un,
                payment: vm.form.payment.id
                  ? vm.form.payment.id
                  : vm.form.payment,
                ejecutivo: vm.form.ejecutivo ? vm.form.ejecutivo.id : 0,
                // status: vm.form.status.id ? vm.form.status.id : vm.form.status,
                tipo_recibo: vm.form.tipo_recibo ? vm.form.tipo_recibo : 0,
                contratante: vm.form.contratante.value
                  ? vm.form.contratante.value
                  : 0,
                grupo: vm.form.group.value
                  ? vm.form.group.value
                  : vm.form.group,
                type_contractor: vm.form.contratante.type
                  ? vm.form.contratante.type
                  : 0,
                status: flag,
                page: parPage ? parPage : 1,
                dates: vm.form.dates,
                ramos: vm.ramos_selected ? vm.ramos_selected : 0,
                subramos: vm.subramos_selected ? vm.subramos_selected : 0,
                providers: vm.providers_selected ? vm.providers_selected : 0,
                polizas: vm.form.poliza_number ? vm.form.poliza_number : 0,
                pay_date: $scope.pay_date ? $scope.pay_date : 0,
                tipo_poliza: vm.form.tipo_poliza ? vm.form.tipo_poliza.id : 0,
                classification: vm.form.classification.value
                  ? vm.form.classification.value
                  : vm.form.classification,
              };
              if (vm.form.contratante.val == "") {
                params.contratante = 0;
                vm.form.contratante.value = "";
                vm.form.contratante.type = "";
              }
              // if((params.since) <= (params.until)){
              params.since = params.since + " " + "00:00:00";
              params.until = params.until + " " + "23:59:59";
              if ($location.path() == "/cobranzas/recibosPendientes") {
                params.since = "01/01/1950" + " " + "00:00:00";
                params.until = "31/12/2099" + " " + "23:59:59";
                params.status = 1;
              }
              $scope.filtros = params;
              $scope.filtros.order = order;
              $scope.filtros.asc = asc;
              $scope.filtros.user_pay = vm.user_pay_selected
                ? vm.user_pay_selected
                : 0;
              $scope.filtros.polizaId = 0;
              $scope.filtros.pay_date = $scope.pay_date
                ? $scope.pay_date
                : new Date();
              $scope.filtros.subgrupo = g1 ? g1 : 0;
              $scope.filtros.subsubgrupo = g2 ? g2 : 0;
              $scope.filtros.groupinglevel = gl ? gl : 0;
              $scope.filtros.subgrupinglevel = gl1 ? gl1 : 0;
              $scope.filtros.subsubgrupinglevel = gl2 ? gl2 : 0;
              $scope.filtros.celula = cel ? cel : 0;
              $scope.filtros.businessLine = $scope.bLine ? $scope.bLine.id : 0;
              $scope.filtros.only_caratula = vm.only_caratula_poliza
                ? vm.only_caratula_poliza
                : 0;
              $scope.url_go_pmas = "pay-cobranza-massive/";
              $http({
                method: "POST",
                url: url.IP + $scope.url_go_pmas,
                data: $scope.filtros,
              }).then(function (response) {
                if (response.status == 200 || response.status == 201) {
                  swal(
                    "Pagado, folio: " + response.data.folio,
                    "La selección ha sido pagada",
                    "success"
                  );
                  log_liq_and_pay_massive(response.data);
                } else {
                  swal("Error: la selección no ha sido pagada", "error");
                }
                getCobranza(flag, order, asc, parPage);
              });
            } else {
              toaster.error(
                "Fecha de Pago incorrecta,escriba la Fecha de Pago en formato correcto (DD/MM/AAAA)"
              );
            }
          }
        });
      } else {
        if (vm.receipts_to_pay_lenght > 1)
          var _text =
            "Confirmar liquidación de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibos)";
        else
          var _text =
            "Confirmar liquidación de la selección de los filtros? (" +
            vm.receipts_to_pay_lenght +
            " recibo)";
        var data_alert = {
          title: "Liquidar selección",
          text: _text,
          type: "warning",
          confirmButtonText: "Liquidar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
        };
        SweetAlert.swal(data_alert, function (isConfirm) {
          if (isConfirm) {
            if (vm.form.subgroup) {
              if (vm.form.subgroup.id) {
                var g1 = vm.form.subgroup.id;
              } else {
                var g1 = 0;
              }
            }
            if (vm.form.subsubgroup) {
              if (vm.form.subsubgroup.id) {
                var g2 = vm.form.subsubgroup.id;
              } else {
                var g2 = 0;
              }
            } else {
              var g2 = 0;
            }
            if (vm.form.groupinglevel) {
              if (vm.form.groupinglevel.val) {
                var gl = vm.form.groupinglevel.value;
              } else {
                var gl = 0;
              }
            } else {
              var gl = 0;
            }
            if (vm.form.subgrouping) {
              if (vm.form.subgrouping.id) {
                var gl1 = vm.form.subgrouping.id;
              } else {
                var gl1 = 0;
              }
            } else {
              var gl1 = 0;
            }
            if (vm.form.subsubgrouping) {
              if (vm.form.subsubgrouping.id) {
                var gl2 = vm.form.subsubgrouping.id;
              } else {
                var gl2 = 0;
              }
            } else {
              var gl2 = 0;
            }
            if (vm.form.celula) {
              if (vm.form.celula.id) {
                var cel = vm.form.celula.id;
              } else {
                var cel = 0;
              }
            } else {
              var cel = 0;
            }

            var params = {
              provider: vm.form.provider.id
                ? vm.form.provider.id
                : vm.form.provider,
              vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0,
              ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
              subramo: vm.form.subramo.id
                ? vm.form.subramo.id
                : vm.form.subramo,
              since: vm.form.since ? vm.form.since : vm.form.si,
              until: vm.form.until ? vm.form.until : vm.form.un,
              payment: vm.form.payment.id
                ? vm.form.payment.id
                : vm.form.payment,
              ejecutivo: vm.form.ejecutivo ? vm.form.ejecutivo.id : 0,
              // status: vm.form.status.id ? vm.form.status.id : vm.form.status,
              tipo_recibo: vm.form.tipo_recibo ? vm.form.tipo_recibo : 0,
              contratante: vm.form.contratante.value
                ? vm.form.contratante.value
                : 0,
              grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
              type_contractor: vm.form.contratante.type
                ? vm.form.contratante.type
                : 0,
              status: flag,
              page: parPage ? parPage : 1,
              celula: cel ? cel : 0,
              dates: vm.form.dates,
              ramos: vm.ramos_selected ? vm.ramos_selected : 0,
              subramos: vm.subramos_selected ? vm.subramos_selected : 0,
              providers: vm.providers_selected ? vm.providers_selected : 0,
              polizas: vm.form.poliza_number ? vm.form.poliza_number : 0,
              tipo_poliza: vm.form.tipo_poliza ? vm.form.tipo_poliza.id : 0,
              classification: vm.form.classification.value
                ? vm.form.classification.value
                : vm.form.classification,
              only_caratula: vm.only_caratula_poliza
                ? vm.only_caratula_poliza
                : 0,
            };
            if (vm.form.contratante.val == "") {
              params.contratante = 0;
              vm.form.contratante.value = "";
              vm.form.contratante.type = "";
            }
            // if((params.since) <= (params.until)){
            params.since = params.since + " " + "00:00:00";
            params.until = params.until + " " + "23:59:59";
            if ($location.path() == "/cobranzas/recibosPendientes") {
              params.since = "01/01/1950" + " " + "00:00:00";
              params.until = "31/12/2099" + " " + "23:59:59";
              params.status = 1;
            }
            $scope.filtros = params;
            $scope.filtros.order = order;
            $scope.filtros.asc = asc;
            $scope.filtros.user_pay = vm.user_pay_selected
              ? vm.user_pay_selected
              : 0;
            $scope.filtros.polizaId = 0;
            $scope.filtros.subgrupo = g1 ? g1 : 0;
            $scope.filtros.subsubgrupo = g2 ? g2 : 0;
            $scope.filtros.groupinglevel = gl ? gl : 0;
            $scope.filtros.subgrupinglevel = gl1 ? gl1 : 0;
            $scope.filtros.subsubgrupinglevel = gl2 ? gl2 : 0;
            $scope.filtros.businessLine = $scope.bLine ? $scope.bLine.id : 0;
            $scope.url_go_liq = "pay-cobranza-massive/";
            $http({
              method: "POST",
              url: url.IP + $scope.url_go_liq,
              data: $scope.filtros,
            }).then(function (response) {
              if (response.status == 200 || response.status == 201) {
                swal(
                  "Liquidado, folio: " + response.data.folio,
                  "La selección ha sido liquidada",
                  "success"
                );
                log_liq_and_pay_massive(response.data);
                getPDFLiquidacion(response.data.folio);
              } else {
                swal("Error: la selección no ha sido liquidada", "error");
              }
              getCobranza(flag, order, asc, parPage);
            });
          } else {
          }
        });
      }
      // SweetAlert.swal(data_alert,
      //   function(isConfirm) {

      //     if(isConfirm) {
      //       var params = {
      //         provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider ,
      //         vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0 ,
      //         ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
      //         subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
      //         since: vm.form.since ? vm.form.since : vm.form.si,
      //         until: vm.form.until ? vm.form.until : vm.form.un,
      //         payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
      //         ejecutivo: vm.form.ejecutivo ? vm.form.ejecutivo.id : 0 ,
      //         // status: vm.form.status.id ? vm.form.status.id : vm.form.status,
      //         tipo_recibo: vm.form.tipo_recibo ? vm.form.tipo_recibo : 0 ,
      //         contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
      //         grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
      //         type_contractor : vm.form.contratante.type ? vm.form.contratante.type : 0,
      //         status: flag,
      //         page: parPage ? parPage : 1,
      //         dates: vm.form.dates,
      //         ramos: vm.ramos_selected ? vm.ramos_selected : 0,
      //         subramos: vm.subramos_selected ? vm.subramos_selected : 0,
      //         providers: vm.providers_selected ? vm.providers_selected : 0,
      //         polizas: vm.form.poliza_number ? vm.form.poliza_number : 0
      //       }
      //       if(vm.form.contratante.val == "" ){
      //         params.contratante = 0;
      //         vm.form.contratante.value = "";
      //         vm.form.contratante.type = ""
      //       }
      //       // if((params.since) <= (params.until)){
      //         params.since = params.since+ " " + "00:00:00";
      //         params.until = params.until+ " " + "23:59:59";
      //       if($location.path() == "/cobranzas/recibosPendientes"){
      //         params.since = "01/01/1950"+ " " + "00:00:00";
      //         params.until = "31/12/2099"+ " " + "23:59:59";
      //         params.status = 1;
      //       }
      //       $scope.filtros = params;
      //       $scope.filtros.order = order;
      //       $scope.filtros.asc = asc;
      //       $scope.filtros.user_pay = vm.user_pay_selected ? vm.user_pay_selected : 0;
      //       $scope.filtros.polizaId = 0;
      //       $http({
      //         method: 'POST',
      //         url: url.IP + 'pay-cobranza-massive/',
      //           data: $scope.filtros
      //         }).then(function(response) {
      //           if (response.status == 200 || response.status == 201) {
      //               swal("Liquidado, folio: "+response.data.folio,"La selección ha sido liquidada", "success");
      //               $scope.log_liq_and_pay_massive(response.data);
      //           }else{
      //             swal("Error: la selección no ha sido liquidada", "error");
      //           }
      //           getCobranza(flag,order,asc,parPage);
      //       })
      //     } else {
      //     }
      // });
      // SweetAlert.swal(data_alert,
      //   function(isConfirm) {

      //     if(isConfirm) {
      //       var params = {
      //         provider: vm.form.provider.id ? vm.form.provider.id : vm.form.provider ,
      //         vendedor: vm.form.vendedor ? vm.form.vendedor.id : 0 ,
      //         ramo: vm.form.ramo.id ? vm.form.ramo.id : vm.form.ramo,
      //         subramo: vm.form.subramo.id ? vm.form.subramo.id : vm.form.subramo,
      //         since: vm.form.since ? vm.form.since : vm.form.si,
      //         until: vm.form.until ? vm.form.until : vm.form.un,
      //         payment: vm.form.payment.id ? vm.form.payment.id : vm.form.payment,
      //         ejecutivo: vm.form.ejecutivo ? vm.form.ejecutivo.id : 0 ,
      //         // status: vm.form.status.id ? vm.form.status.id : vm.form.status,
      //         tipo_recibo: vm.form.tipo_recibo ? vm.form.tipo_recibo : 0 ,
      //         contratante: vm.form.contratante.value ? vm.form.contratante.value : 0,
      //         grupo: vm.form.group.value ? vm.form.group.value : vm.form.group,
      //         type_contractor : vm.form.contratante.type ? vm.form.contratante.type : 0,
      //         status: flag,
      //         page: parPage ? parPage : 1,
      //         dates: vm.form.dates,
      //         ramos: vm.ramos_selected ? vm.ramos_selected : 0,
      //         subramos: vm.subramos_selected ? vm.subramos_selected : 0,
      //         providers: vm.providers_selected ? vm.providers_selected : 0,
      //         polizas: vm.form.poliza_number ? vm.form.poliza_number : 0
      //       }
      //     if(vm.form.contratante.val == "" ){
      //       params.contratante = 0;
      //       vm.form.contratante.value = "";
      //       vm.form.contratante.type = ""
      //     }
      //     // if((params.since) <= (params.until)){
      //       params.since = params.since+ " " + "00:00:00";
      //       params.until = params.until+ " " + "23:59:59";
      //     if($location.path() == "/cobranzas/recibosPendientes"){
      //       params.since = "01/01/1950"+ " " + "00:00:00";
      //       params.until = "31/12/2099"+ " " + "23:59:59";
      //       params.status = 1;
      //     }
      //     $scope.filtros = params;
      //     $scope.filtros.order = order;
      //     $scope.filtros.asc = asc;
      //     $scope.filtros.user_pay = vm.user_pay_selected ? vm.user_pay_selected : 0;
      //     $scope.filtros.polizaId = 0;
      //     $http({
      //       // method: 'GET',
      //       // url: url.IP + 'get-cobranza/',
      //       // params: $scope.filtros
      //       method: 'POST',
      //       url: url.IP + 'pay-cobranza-massive/',
      //       data: $scope.filtros
      //     }).then(function(response) {
      //       if (response.status == 200 || response.status == 201) {
      //         if (flag == 1){
      //           swal("Pagado, folio: "+response.data.folio,"La selección ha sido pagada", "success");
      //           $scope.log_liq_and_pay_massive(response.data);
      //         }
      //         else{
      //           swal("Liquidado, folio: "+response.data.folio,"La selección ha sido liquidada", "success");
      //           $scope.log_liq_and_pay_massive(response.data);
      //         }
      //       }else{
      //         swal("Error: la selección no ha sido pagada", "error");
      //       }
      //       getCobranza(flag,order,asc,parPage);
      //     })
      //   } else {
      //   }
      // });
    };
    // Liquidación de recibos seleccionados
    $scope.liquidar_selected = function () {
      $scope.rec_count = 0;
      $scope.folio_liquidacion = "";
      if ($scope.recibos_a_liquidar.length > 0) {
        $scope.folio_liquidacion = $scope.recibos_a_liquidar[0].id;
        var _text =
          "¿ Confirma Liquidación de la selección de " +
          $scope.recibos_a_liquidar.length +
          " recibos ?";
        // return
      } else {
        toaster.warning("Debe agregar recibos a liquidar");
        return;
      }
      var data_alert = {
        title: "Liquidar recibos seleccionados",
        text: _text,
        type: "warning",
        confirmButtonText: "Liquidar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (isConfirm) {
        if (isConfirm) {
          $scope.recibos_a_liquidar.forEach(function (receipt, index) {
            $http({
              // method: 'GET',
              // url: url.IP + 'get-cobranza/',
              // params: $scope.filtros
              method: "PATCH",
              url: receipt.url,
              data: {
                liquidacion_folio: $scope.folio_liquidacion,
                liquidacion_date: new Date(),
                status: 5,
              },
            }).then(function (response) {
              swal(
                "Liquidado, folio: " + response.data.liquidacion_folio,
                "La selección ha sido liquidada",
                "success"
              );
              $scope.json_receipts_pay = [
                {
                  endosos: 0,
                  polizas: 0,
                  colectividades: 0,
                  fianzas: 0,
                  total_prima: 0,
                  endososNota: 0,
                  total_nota: 0,
                },
              ];
              try {
                log_liq_and_pay_selected(response.data);
              } catch (e) {
                console.log("error al log recibo", e);
              }
              getPDFLiquidacion(response.data.liquidacion_folio);
            });
            $scope.rec_count = $scope.rec_count + 1;
            if ($scope.rec_count == $scope.recibos_a_liquidar.length) {
              $scope.recibos_a_liquidar = [];
              $scope.json_receipts_pay = [
                {
                  endosos: 0,
                  polizas: 0,
                  colectividades: 0,
                  fianzas: 0,
                  total_prima: 0,
                  endososNota: 0,
                  total_nota: 0,
                },
              ];
              getCobranza(2, 1, 1, 1);
              activate($scope.folio_liquidacion);
            }
          });
        } else {
        }
      });
    };
    function getPDFLiquidacion(folio) {
      if (folio) {
        $http({
          method: "POST",
          url: url.IP + "get-pdf-liquidacion/",
          data: {
            liquidacion_folio: folio,
            generado_por: usr["nameFull"],
          },
        }).then(function success(response) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
        });
      }
    }

    $scope.todosPendientes = function (value) {
      $scope.showButtonPending = value;
      if (value) {
        $scope.recibos_a_pagar = [];
        vm.receipts.forEach(function (item, index) {
          item.to_liquidate = true;
          $scope.recibos_a_pagar.push(item);
          if (vm.receipts.length == index + 1) {
            $scope.sumaRecibos();
          }
        });
      } else {
        vm.receipts.forEach(function (item) {
          item.to_liquidate = false;
        });
        $scope.recibos_a_pagar = [];
        $scope.json_receipts = [
          {
            endosos: 0,
            polizas: 0,
            colectividades: 0,
            polizaColectividad: 0,
            fianzas: 0,
            total_prima: 0,
            endososNota: 0,
            total_nota: 0,
          },
        ];
      }
    };

    $scope.todosPagados = function (value) {
      $scope.showButtonPay = value;
      if (value) {
        vm.receipts.forEach(function (item) {
          item.toPay = true;
          $scope.recibos_a_liquidar.push(item);
          $scope.sumaRecibosPagados();
        });
      } else {
        vm.receipts.forEach(function (item) {
          item.toPay = false;
        });
        $scope.recibos_a_liquidar = [];
        $scope.json_receipts_pay = [
          {
            endosos: 0,
            polizas: 0,
            colectividades: 0,
            polizaColectividad: 0,
            fianzas: 0,
            total_prima: 0,
            endososNota: 0,
            total_nota: 0,
          },
        ];
      }
    };

    $scope.sumaRecibos = function (todos, recibo, val) {
      $scope.json_receipts = [
        {
          endosos: 0,
          polizas: 0,
          colectividades: 0,
          polizaColectividad: 0,
          fianzas: 0,
          total_prima: 0,
          endososNota: 0,
          total_nota: 0,
        },
      ];
      vm.receipts.forEach(function (item, index) {
        var toLiquidate = angular.copy(item.to_liquidate);
        if (toLiquidate == true) {
          if (item.poliza.document_type == 1 && item.receipt_type == 1) {
            $scope.json_receipts[0].polizas =
              parseFloat($scope.json_receipts[0].polizas) + 1;
            $scope.json_receipts[0].total_prima =
              parseFloat($scope.json_receipts[0].total_prima) +
              parseFloat(item.prima_total);
          } else if (item.endorsement) {
            if (item.receipt_type == 2) {
              $scope.json_receipts[0].endosos =
                parseFloat($scope.json_receipts[0].endosos) + 1;
              $scope.json_receipts[0].total_prima =
                parseFloat($scope.json_receipts[0].total_prima) +
                parseFloat(item.prima_total);
            } else if (item.receipt_type == 3) {
              $scope.json_receipts[0].endososNota =
                parseFloat($scope.json_receipts[0].endososNota) + 1;
              $scope.json_receipts[0].total_nota =
                parseFloat($scope.json_receipts[0].total_nota) +
                parseFloat(item.prima_total);
            }
          } else if (item.poliza.document_type == 3 && item.receipt_type == 1) {
            $scope.json_receipts[0].colectividades =
              parseFloat($scope.json_receipts[0].colectividades) + 1;
            $scope.json_receipts[0].total_prima =
              parseFloat($scope.json_receipts[0].total_prima) +
              parseFloat(item.prima_total);
          } else if (
            item.poliza.document_type == 7 ||
            (item.poliza.document_type == 8 && item.receipt_type == 1)
          ) {
            $scope.json_receipts[0].fianzas =
              parseFloat($scope.json_receipts[0].fianzas) + 1;
            $scope.json_receipts[0].total_prima =
              parseFloat($scope.json_receipts[0].total_prima) +
              parseFloat(item.prima_total);
          } else if (
            item.poliza.document_type == 12 &&
            item.receipt_type == 1
          ) {
            $scope.json_receipts[0].polizas =
              parseFloat($scope.json_receipts[0].polizas) + 1;
            $scope.json_receipts[0].total_prima =
              parseFloat($scope.json_receipts[0].total_prima) +
              parseFloat(item.prima_total);
          }
        }
      });
    };

    $scope.sumaRecibosPagados = function (todo, recibo, val) {
      $scope.json_receipts_pay = [
        {
          endosos: 0,
          polizas: 0,
          colectividades: 0,
          fianzas: 0,
          total_prima: 0,
          endososNota: 0,
          total_nota: 0,
        },
      ];
      vm.receipts.forEach(function (item, index) {
        var toToPay = angular.copy(item.toPay);
        if (toToPay == true) {
          if (item.poliza.document_type == 1 && item.receipt_type == 1) {
            $scope.json_receipts_pay[0].polizas =
              parseFloat($scope.json_receipts_pay[0].polizas) + 1;
            $scope.json_receipts_pay[0].total_prima =
              parseFloat($scope.json_receipts_pay[0].total_prima) +
              parseFloat(item.prima_total);
          } else if (item.endorsement) {
            if (item.receipt_type == 2) {
              $scope.json_receipts_pay[0].endosos =
                parseFloat($scope.json_receipts_pay[0].endosos) + 1;
              $scope.json_receipts_pay[0].total_prima =
                parseFloat($scope.json_receipts_pay[0].total_prima) +
                parseFloat(item.prima_total);
            } else if (item.receipt_type == 3) {
              $scope.json_receipts_pay[0].endososNota =
                parseFloat($scope.json_receipts_pay[0].endososNota) + 1;
              $scope.json_receipts_pay[0].total_nota =
                parseFloat($scope.json_receipts_pay[0].total_nota) +
                parseFloat(item.prima_total);
            }
          } else if (item.poliza.document_type == 3 && item.receipt_type == 1) {
            $scope.json_receipts_pay[0].colectividades =
              parseFloat($scope.json_receipts_pay[0].colectividades) + 1;
            $scope.json_receipts_pay[0].total_prima =
              parseFloat($scope.json_receipts_pay[0].total_prima) +
              parseFloat(item.prima_total);
          } else if (
            item.poliza.document_type == 7 ||
            (item.poliza.document_type == 8 && item.receipt_type == 1)
          ) {
            $scope.json_receipts_pay[0].fianzas =
              parseFloat($scope.json_receipts_pay[0].fianzas) + 1;
            $scope.json_receipts_pay[0].total_prima =
              parseFloat($scope.json_receipts_pay[0].total_prima) +
              parseFloat(item.prima_total);
          } else if (
            item.poliza.document_type == 12 &&
            item.receipt_type == 1
          ) {
            $scope.json_receipts_pay[0].polizas =
              parseFloat($scope.json_receipts_pay[0].polizas) + 1;
            $scope.json_receipts_pay[0].total_prima =
              parseFloat($scope.json_receipts_pay[0].total_prima) +
              parseFloat(item.prima_total);
          }
        }
      });
    };

    // Pago de recibos seleccionados
    $scope.pay_receipts_selected = function (value) {
      if (value == 1) {
        $scope.recibos_a_liquidar = [];
      } else {
        $scope.recibos_a_pagar = [];
      }
      $scope.rec_count_pay = 0;
      var modalInstance = $uibModal.open({
        templateUrl: "app/cobranzas/cobranzas.modal.pago.html",
        controller: CobranzaPagoCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          recibos_a_pagar: function () {
            return $scope.recibos_a_pagar;
          },
          recibos_a_liquidar: function () {
            return $scope.recibos_a_liquidar;
          },
          user_pay: function () {
            return $scope.user_pay;
          },
          folio_pago: function () {
            return $scope.folio_pago;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };

    function CobranzaPagoCtrl(
      $scope,
      $sessionStorage,
      $uibModalInstance,
      statusPayform,
      curr_rate_options,
      $http,
      MESSAGES,
      recibos_a_pagar,
      recibos_a_liquidar,
      user_pay,
      folio_pago
    ) {
      var vmm = this;
      vmm.accion = "Pagar";
      /* Información de usuario */
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);

      vmm.pago_date = convertDate(new Date());

      $scope.statusPayform = [];
      $scope.curr_rate_options = [];

      $scope.recibos_a_pagar = recibos_a_pagar;
      $scope.recibos_a_liquidar = recibos_a_liquidar;
      for (var i = 0; i < statusPayform.length; i++) {
        $scope.statusPayform.push(statusPayform[i]);
      }

      for (var i = 0; i < curr_rate_options.length; i++) {
        $scope.curr_rate_options.push(curr_rate_options[i]);
      }

      $scope.matchesBanks = function (parWord, type) {
        $scope.banks_data = 0;

        if (parWord) {
          $scope.bank_sb = parWord;
          var word_data = parWord.val;
          parWord = parWord.val;
        }

        if (word_data) {
          if (word_data.length >= 3) {
            var params = {
              pal: parWord,
            };

            dataFactory.get("banks-match/", params).then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data.results;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.alias,
                    value: item.id,
                    url: item.url,
                  };
                  source.push(obj);
                });
                $scope.banks_data = source;
                if (type == 3) {
                  $scope.bank_sb.url = $scope.banks_data[0].url;
                }
              }
            });
          }
        }
      };

      $scope.save = function () {
        $scope.pay_date = datesFactory.toDate(vmm.pago_date);
        $scope.pay_date_view = convertDate($scope.pay_date);

        $scope.folio_pago = recibos_a_pagar[0].id;

        $scope.rec_count_pay = 0;

        recibos_a_pagar.forEach(function (receipt) {
          $http({
            method: "PATCH",
            url: receipt.url,
            data: {
              folio_pago: $scope.folio_pago,
              pay_date: $scope.pay_date ? $scope.pay_date : new Date(),
              status: 1,
              user_pay: user_pay ? user_pay.url : null,
              bank: $scope.bank_sb ? $scope.bank_sb.url : null,
              pay_doc: vmm.pay_doc,
              rate_exchange: vmm.rate_exchange ? $scope.rate_exchange : 1,
              pay_form: vmm.pay_form ? vmm.pay_form.value : null,
            },
          }).then(function (response) {
            swal(
              "Pagado, folio: " + response.data.folio_pago,
              "La selección ha sido pagada, fecha de pago: " +
                $scope.pay_date_view,
              "success"
            );
            $scope.json_receipts = [
              {
                endosos: 0,
                polizas: 0,
                colectividades: 0,
                polizaColectividad: 0,
                fianzas: 0,
                total_prima: 0,
                endososNota: 0,
                total_nota: 0,
              },
            ];
            try {
              log_liq_and_pay_selected(response.data);
            } catch (e) {
              console.log("error al log recibo", e);
            }
          });
          $scope.rec_count_pay = $scope.rec_count_pay + 1;
          if ($scope.rec_count_pay == $scope.recibos_a_pagar.length) {
            $scope.recibos_a_pagar = [];
            $scope.folio_pago = "";
            getCobranza(1, 1, 1, 1);
            activate();
          }
        });
        $scope.cancel();
      };

      $scope.saveLiquidados = function () {
        $scope.pay_date = datesFactory.toDate(vmm.pago_date);

        $scope.folio_pago = recibos_a_liquidar[0].id;

        recibos_a_liquidar.forEach(function (receipt, index) {
          $http({
            method: "PATCH",
            url: receipt.url,
            data: {
              liquidacion_folio: $scope.folio_pago,
              liquidacion_date: $scope.pay_date ? $scope.pay_date : new Date(),
              status: 5,
              liquidacion_bank: $scope.bank_sb ? $scope.bank_sb.url : null,
              liquidacion_curr_rate: vmm.rate ? vmm.rate.value : null,
              liquidacion_doc: vmm.pay_doc,
              liquidacion_form: vmm.pay_form ? vmm.pay_form.value : null,
            },
          }).then(function (response) {
            swal(
              "Liquidado, folio: " + response.data.liquidacion_folio,
              "La selección ha sido liquidada",
              "success"
            );
            $scope.json_receipts_pay = [
              {
                endosos: 0,
                polizas: 0,
                colectividades: 0,
                total_endosos: 0,
                total_polizas: 0,
                total_colectividades: 0,
              },
            ];
            try {
              log_liq_and_pay_selected(response.data);
            } catch (e) {
              console.log("error al log recibo", e);
            }
            getPDFLiquidacion(response.data.liquidacion_folio);
          });
          $scope.rec_count = $scope.rec_count + 1;
          if ($scope.rec_count == $scope.recibos_a_liquidar.length) {
            $scope.recibos_a_liquidar = [];
            getCobranza(2, 1, 1, 1);
            activate($scope.folio_liquidacion);
          }
        });
        $scope.cancel();
      };

      $scope.cancel = function () {
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
      };
    }

    // Conciliar conculta
    $scope.conciliar_masivo = function (flag, order, asc, parPage) {
      $rootScope.banco_selected = 0;
      $rootScope.name = "";
      $rootScope.account = "";
      $rootScope.observation = "";
      $rootScope.addAccount = false;
      $http.get(url.IP + "bancos/").then(function (bank) {
        $rootScope.bancos = bank.data;
      });
      $http.get(url.IP + "accounts/").then(function (response) {
        vm.accounts = response.data.results;
        $rootScope.acounts_data = response.data.results;
        vm.cuenta = $rootScope.acounts_data[0];
      });
      vm.form.conciliate_date = convertDate(new Date());
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/conciliar_masivo_modal.html",
        controller: "CobranzasCtrl",
        size: "md",
        resolve: {
          flag: function () {
            return flag;
          },
          order: function () {
            return order;
          },
          asc: function () {
            return asc;
          },
          parPage: function () {
            return parPage;
          },
          valueReceipt: function () {
            return "";
          },
        },
      });
    };
    $scope.add_account = function () {
      $rootScope.addAccount = true;
    };
    $scope.cancel_addAccount = function () {
      $rootScope.addAccount = false;
    };
    $scope.selectBanco = function (s) {
      $rootScope.banco_selected = s;
    };
    $scope.selectData = function (n, a, o) {
      if (n) {
        $rootScope.name = n;
      }
      if (a) {
        $rootScope.account = a;
      }
      if (o) {
        $rootScope.observation = n;
      }
    };
    $scope.saveAccount = function () {
      $rootScope.addAccount = false;
      if ($rootScope.banco_selected) {
        $http
          .post(url.IP + "accounts/", {
            name: $rootScope.name,
            account: $rootScope.account,
            observation: $rootScope.observation,
            bank: $rootScope.banco_selected,
          })
          .then(
            function success(request) {
              if (request.status === 200 || request.status === 201) {
                $rootScope.new_account = request.data;
                // accounts.push(request.data);
                toaster.success("Cuenta creada exitosamente");
              } else {
                toaster.warning("Error al crear cuenta");
              }
            },
            function error(error) {
              console.log("error - email", error);
            }
          )
          .catch(function (e) {
            console.log("error - catch", e);
          });
      } else {
        toaster.warning(MESSAGES.WARNING.EMPTYBANK);
      }
    };
    $scope.conciliar_consulta = function (cc, fa, acc, consulta, filtros) {
      if (!cc || !fa || !acc) {
        toaster.error("Complete todos los campos");
        return;
      }
      var _text =
        "Confirmar la Conciliación de la consulta (" +
        consulta.count +
        " recibo)";
      $scope.filtros_conciliacion = filtros;
      var data_alert = {
        title: "Conciliar selección",
        text: _text,
        type: "warning",
        confirmButtonText: "Conciliar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        closeOnConfirm: false,
        showLoaderOnConfirm: true,
        showConfirmButton: true,
      };
      SweetAlert.swal(data_alert, function (isConfirm) {
        if (isConfirm) {
          $scope.filtros_conciliacion.comision_conciliada =
            parseFloat(cc).toFixed(2);
          $scope.filtros_conciliacion.conciliacion_date =
            datesFactory.toDate(fa);
          $scope.filtros_conciliacion.account = acc.id;
          // $scope.filtros_conciliacion.only_caratula = vm.only_caratula_poliza ? vm.only_caratula_poliza : 0
          $scope.url_go_conc = "conciliar-cobranza-massive/";
          $http({
            // method: 'GET',
            // url: url.IP + 'get-cobranza/',
            // params: $scope.filtros
            method: "POST",
            url: url.IP + $scope.url_go_conc,
            data: $scope.filtros_conciliacion,
          }).then(function (response) {
            if (response.status == 200 || response.status == 201) {
              swal("Conciliada, folio de conciliación: " + response.data.folio);
              vm.receipts = [];
              getCobranza(1, 1, 1, 1);
              activate();
            } else {
              swal("Error: La consulta NO ha sido conciliada", "error");
            }
            $uibModalInstance.dismiss("cancel");
            vm.receipts = [];
            getCobranza(1, 1, 1, 1);
            activate();
          });
        } else {
          $uibModalInstance.dismiss("cancel");
        }
      });
    };
    // Log de registro de pago y/o liquidación recibos masivo
    function log_liq_and_pay_massive(rec) {
      if (rec.status == 1) {
        $scope.status_receipt =
          "actualizó recibo a pagado( con el folio de pago: " + rec.folio;
      } else if (rec.status == 5) {
        $scope.status_receipt =
          "actualizó reciboa liquidado con el folio de liquidación: " +
          rec.folio;
      }

      var params = {
        model: 4,
        event: "POST",
        associated_id: rec.id,
        identifier: $scope.status_receipt,
      };
      dataFactory.post("send-log/", params).then(function success(response) {});
    }

    $scope.addEmailsConfirm = function (valueReceipt) {
      var id_poliza = valueReceipt.poliza ? valueReceipt.poliza.id : 0;
      var id_fianza = valueReceipt.fianza ? valueReceipt.fianza.id : 0;
      if (valueReceipt) {
        dataFactory
          .get("v1/notasCredito-info", {
            status: 4,
            id_poliza: id_poliza,
            id_fianza: id_fianza,
          })
          .then(function success(nota) {
            if (nota.status === 200 || nota.status === 201) {
              $scope.notasCredito = nota.data;
              $scope.notasCredito.forEach(function (it) {
                it.sendNote = false;
              });
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
      $http
        .get(url.IP + "recibos/" + valueReceipt.id + "/archivos/")
        .then(function (response) {
          if (response.status === 200) {
            vm.files = response.data.results;
            $scope.files = response.data.results;
            $scope.show_files_policy = true;
            $scope.files.forEach(function (file) {
              file["to_send"] = false;
            });
          }
        });
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        size: "lg",
        resolve: {
          valueReceipt: function () {
            return valueReceipt;
          },
        },
      });
    };
    $scope.adjFiles = false;
    $scope.adjFilesOK = function (val) {
      $scope.adjFiles = val;
      $http
        .get(url.IP + "recibos/" + $scope.receiptAll.id + "/archivos/")
        .then(function (response) {
          if (response.status === 200) {
            vm.files = response.data.results;
            $scope.files = response.data.results;
            $scope.files.forEach(function (file) {
              file["to_send"] = false;
            });
            $scope.show_files_policy = true;
          }
        });
    };

    function responsiv() {
      $("#pendientes").trigger("resize");
      $("#pagados").trigger("resize");
      $("#cancelados").trigger("resize");
    }
    function normalizeReceiptStatus(st) {
      if (st === null || st === undefined) return null;

      var n = parseInt(st, 10);
      if (!isNaN(n)) return n;

      // Por si llega texto: "Conciliado", etc.
      var s = ("" + st).trim().toLowerCase();
      if (s === "conciliado") return 6;
      if (s === "liquidado") return 5;
      if (s === "pagado") return 1;
      if (s === "cancelado") return 2;
      if (s === "precancelado") return 8;
      if (s.indexOf("pend") === 0) return 4;
      return null;
    }

    var mapReceiptToVm = {
      4: 1, // Pendiente
      1: 2, // Pagado
      5: 3, // Liquidado
      6: 3, // Conciliado -> Liquidados
      2: 4, // Cancelado
      8: 5, // Precancelado
    };

    function syncStatusWithReceipt(receipt, vm, formStatus, receipts) {
      var rStatus = normalizeReceiptStatus(receipt.status);
      var expectedVmId = mapReceiptToVm[rStatus];
      if (!expectedVmId) return;

      var currentFormId = parseInt(formStatus, 10);

      if (!isNaN(currentFormId) && currentFormId !== expectedVmId) {
        // borrar SOLO el recibo que coincide
        var idx = receipts.findIndex(function (r) {
          return r.id === receipt.id; // o indexOf(receipt) si es misma referencia
        });
        if (idx !== -1) receipts.splice(idx, 1);
      }
    }
    function changeStatusModal(receipt) {
      var insurance = receipt.poliza ? receipt.poliza : receipt.fianza;
      var index = vm.receipts.indexOf(receipt);
      if ($uibModalInstance) {
        $uibModalInstance.close({
          action: 6,
          data: { receipt: receipt, from: true },
        });
      } else {
        var modalInstance = $uibModal.open({
          //jshint ignore:line
          templateUrl: "app/cobranzas/cobranzas.modal.html",
          controller: "CobranzasModal",
          size: "lg",
          resolve: {
            receipt: function () {
              return receipt;
            },
            insurance: function () {
              return insurance;
            },
            from: function () {
              return null;
            },
            bono: function () {
              return null;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
        modalInstance.result.then(function (receipt) {
          // Ejemplo de uso en activate()
          syncStatusWithReceipt(
            receipt,
            vm.receipts,
            vm.form.status.id,
            vm.receipts
          );
          // getCobranza(1,1,1,1)
          // if((receipt.status ==1 || receipt.status ==4) && vm.form.status==1){//si se pago y se solicito pendientes de pago lo quita
          //   vm.receipts.splice(index, 1);
          // }
          // if(receipt.status ==1 && vm.form.status==1){//si se pago y se solicito pendientes de pago lo quita
          //   vm.receipts.splice(index, 1);
          // }
          // activate();
        });
      }
    }
    function NotasModal(nota) {
      vm.insurance_ = nota;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/notaCredito.modal.html",
        controller: "NotaCreditoCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return nota;
          },
          insurance: function () {
            return vm.insurance_;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        vm.notas_credito.splice(index, 1);
        activate();
      });
    }

    function emailsReminderAdd(receipt) {
      $scope.form = {};
      $scope.form.emails_reminder = [];
      var mail = {
        email: "",
      };
      if (receipt.contratante) {
        var cmail = {
          email: receipt.contratante.email,
        };
      }
      if (receipt.contratante) {
        $scope.form.emails_reminder.push(cmail);
      } else {
        $scope.form.emails_reminder.push(mail);
      }
      vm.insurance_ = receipt;
      $scope.receipt_pay = receipt;
      var id_poliza = receipt.poliza ? receipt.poliza.id : 0;
      var id_fianza = receipt.fianza ? receipt.fianza.id : 0;
      if (receipt) {
        dataFactory
          .get("v1/notasCredito-info", {
            status: 4,
            id_poliza: id_poliza,
            id_fianza: id_fianza,
          })
          .then(function success(nota) {
            if (nota.status === 200 || nota.status === 201) {
              $scope.notasCredito = nota.data;
              $scope.notasCredito.forEach(function (it) {
                it.sendNote = false;
              });
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
      $uibModal.receipt = receipt;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/add.emails.reminder_pay.html",
        controller: "CobranzasCtrl",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return vm.insurance_;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    }

    $scope.addEmails = function (type) {
      var mail = {
        email: "",
      };
      $scope.form.emails_reminder.push(mail);
    };

    $scope.deleteEmails = function (mail, type) {
      $scope.form.emails_reminder.splice(mail, 1);
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.subjectEmail = "";
    vm.messageEmail =
      "Estimado Asegurado: Usted tiene un recibo pendiente de pago, comuníquese con " +
      (vm.org_name.toUpperCase() ? vm.org_name : "") +
      " para más Información " +
      "\n";
    /** Uploader files **/
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });
    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    vm.uploadFiles = uploadFiles;
    function uploadFiles(reciboId) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.userInfo = {
        id: reciboId,
      };
      $scope.uploadOk = false;
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      $scope.uploader.queue.forEach(function (ch, index) {
        var str = ch.file.name;
        var regex = /[^\w\s]/gi;
        for (i = 0; i < specialChars.length; i++) {
          if (str.indexOf(specialChars[i]) > -1) {
            $scope.uploadOk = true;
            SweetAlert.swal(
              "Error",
              "El nombre de archivo: " +
                str +
                ", contiene carácteres especiales, renombre y, vuelva a cargarlo. " +
                specialChars[i],
              "error"
            );
            $scope.uploader.queue.splice($scope.uploader.queue.indexOf(ch), 1);
            return;
          } else {
            $scope.uploadOk = true;
          }
        }
      });
      if ($scope.uploadOk) {
        $scope.userInfo.url = $scope.uploader.url =
          url.IP + "recibos/" + reciboId + "/archivos/";
        $scope.files = [];
      }

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }
    $scope.noFiles = false;
    $scope.saveFiles = function (id) {
      $scope.id_recibo = id;
      $scope.userInfo.id = $scope.receiptAll.id;
      $scope.uploadOk = false;
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      $scope.uploader.queue.forEach(function (ch, index) {
        var str = ch.file.name;
        var regex = /[^\w\s]/gi;
        for (i = 0; i < specialChars.length; i++) {
          if (str.indexOf(specialChars[i]) > -1) {
            $scope.uploadOk = true;
            SweetAlert.swal(
              "Error",
              "El nombre de archivo: " +
                str +
                ", contiene carácteres especiales, renombre y, vuelva a cargarlo. " +
                specialChars[i],
              "error"
            );
            $scope.uploader.queue.splice($scope.uploader.queue.indexOf(ch), 1);
            return;
          } else {
            $scope.uploadOk = true;
          }
        }
      });
      if ($scope.uploadOk) {
        $scope.userInfo.url = $scope.uploader.url =
          url.IP + "recibos/" + id + "/archivos/";
        $scope.uploader.uploadAll();
      }
      $http
        .get(url.IP + "recibos/" + id + "/archivos/")
        .then(function (response) {
          if (response.status === 200) {
            vm.files = response.data.results;
            $scope.files = response.data.results;
            $scope.files.forEach(function (file) {
              file["to_send"] = false;
            });
            $scope.noFiles = true;
          }
        });
    };
    $scope.selectNota = function (nota, val) {
      if (val) {
        $scope.notaSelected = nota;
      } else {
        $scope.notaSelected = "";
      }
    };
    $scope.sendReminder = function (files, first_comment, second_comment) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();

      var notasC = [];
      if ($scope.notasCredito) {
        $scope.notasCredito.forEach(function (itRec) {
          if (itRec.sendNote) {
            notasC.push(itRec.sendNote);
            $scope.notaSelected = itRec;
          }
        });
      }
      if (notasC.length > 1) {
        l.stop();
        SweetAlert.swal(
          "Información",
          "Seleccione sólo una Nota de Crédito",
          "warning"
        );
        return;
      }
      if (
        $scope.mails.length == 0 &&
        $scope.mails_cc.length == 0 &&
        $scope.mails_cco.length == 0
      ) {
        l.stop();
        SweetAlert.swal("Error", "Agregue correos", "error");
        return;
      }
      if (
        $scope.mails.length > 0 ||
        $scope.mails_cc.length > 0 ||
        $scope.mails_cco.length > 0
      ) {
        $scope.receipt_pay = $uibModal.receipt;

        if ($scope.notaSelected) {
          var num_nota = $scope.notaSelected.id;
        } else {
          var num_nota = 0;
        }
        if ($scope.mails || $scope.mails_cc || $scope.mails_cco) {
          //$scope.arrayEmailsSend = arrayEmails;
          if ($scope.custom_email) {
            vm.messageEmail = "";
          } else {
            vm.messageEmail = vm.messageEmail;
          }
          $http
            .post(url.IP + "payment-reminder-manual/", {
              r_id: $scope.receiptAll.id,
              nota_id: num_nota,
              emails: $scope.mails,
              emails_cc: $scope.mails_cc,
              emails_cco: $scope.mails_cco,
              files: share_via_email,
              asunto: $scope.subjectEmail,
              mensaje: vm.messageEmail,
              model: 4,
              first_comment: first_comment,
              second_comment: second_comment,
              custom_email: $scope.custom_email,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  l.stop();
                  swal("Enviado", "El recordatorio ha sido enviado", "success");
                  var params = {
                    model: 4,
                    event: "POST",
                    associated_id: $scope.receiptAll.id,
                    identifier: "Ha enviado el recordatorio",
                    save_logmail: 1,
                  };
                  dataFactory
                    .post("send-log/", params)
                    .then(function success(response) {});
                  $uibModalInstance.dismiss("cancel");
                } else {
                  l.stop();
                  swal(
                    "Error",
                    "No se envió el recordatorio. Contacte a su administrador.",
                    "error"
                  );
                  $uibModalInstance.dismiss("cancel");
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        }
      } else {
        if ($scope.receiptAll.contratante) {
          if (
            $scope.receiptAll.contratante.email &&
            !$scope.receiptAll.contratante.email == ""
          ) {
            var arrayEmails = [];
            arrayEmails = [$scope.receiptAll.contratante.email];
            $http
              .post(url.IP + "payment-reminder-manual/", {
                r_id: $scope.receiptAll.id,
                emails: arrayEmails,
                asunto: $scope.subjectEmail,
                mensaje: vm.messageEmail,
              })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    SweetAlert.swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                    $uibModalInstance.dismiss("cancel");
                  } else {
                    SweetAlert.swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                    $uibModalInstance.dismiss("cancel");
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
            SweetAlert.swal(
              "El contratante no tiene correo, agregue correos",
              "error"
            );
            l.stop();
          }
        } else {
          SweetAlert.swal(
            "El contratante no tiene correo, agregue correos",
            "error"
          );
          l.stop();
        }
      }
    };

    function showPhone(receipt) {
      var number = String(receipt.contratante.phone);
      var formattedNumber = number;
      if (number[0] == "1") {
        var c = number[0] == "1" ? "1 " : "";
        number = number[0] == "1" ? number.slice(1) : number;
      } else if (number[0] == "0" && number[1] == "1") {
        var c = number[0] == "0" && number[1] == "1" ? "01 " : "";
        number =
          number[0] == "0" && number[1] == "1" ? number.slice(2) : number;
      } else var c = "";
      var area;
      var front;
      if (
        number.substring(0, 2) == 55 ||
        number.substring(0, 2) == 33 ||
        number.substring(0, 2) == 81
      ) {
        area = number.substring(0, 2);
        front = number.substring(2, 6);
      } else {
        area = number.substring(0, 3);
        front = number.substring(3, 6);
      }

      var end = number.substring(6, 10);
      var ext = number.substring(10, 15);
      var phones_array = [];
      // -----------------------------------
      if (receipt.poliza) {
        if (receipt.poliza.contractor) {
          if (receipt.poliza.contractor.phone_contractor) {
            receipt.poliza.contractor.phone_contractor.forEach(function (u) {
              if (u.phone_type == 1) {
                $scope.phone_type = "Casa";
              } else if (u.phone_type == 2) {
                $scope.phone_type = "Oficina";
              } else if (u.phone_type == 3) {
                $scope.phone_type = "Móvil";
              } else {
                $scope.phone_type = "Otro";
              }
              phones_array.push($scope.phone_type + ": " + u.phone + "\n");
              // phones_array.push('\n')
            });
          }
        }
      }
      if (front) {
        formattedNumber = c + "(" + area + ") " + front;
      }
      if (end) {
        formattedNumber += "-" + end;
      }
      if (ext) {
        formattedNumber += " ext. " + ext;
      }
      if (formattedNumber) {
        // phones_array.push(formattedNumber)
        phones_array.push("Principal: " + formattedNumber + "\n");
        // phones_array.push('\n')
      }
      SweetAlert.swal(
        {
          title: "Teléfono (s)",
          // text: formattedNumber,
          text: phones_array,
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "##87CEFA",
          confirmButtonText: "Se hizo llamada",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var obj = {
              track_phone: true,
            };
            $http.patch(receipt.url, obj);
            swal.close();
          }
        }
      );
      // ----------------------------------x-x-x-
      // SweetAlert.swal({
      //   title: "Teléfono:",
      //   text: formattedNumber,
      //   type: "info"
      // });
    }

    function showEmail(receipt) {
      if (receipt.contratante) {
        var data_alert = {
          title: "Correo",
          text: receipt.contratante.email,
          type: "info",
          confirmButtonText: "Enviar recordatorio",
          cancelButtonText: "Salir",
          showCancelButton: true,
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          showConfirmButton: true,
        };
      } else {
        var data_alert_correo = {
          title: "Correo",
          text: "Escribe el correo para enviar el recordatorio:",
          type: "input",
          showCancelButton: true,
          closeOnConfirm: false,
          animation: "slide-from-top",
          inputPlaceholder: "email@mail.com",
        };
      }
      if (data_alert) {
        SweetAlert.swal(data_alert, function (isConfirm) {
          if (isConfirm) {
            $http
              .post(url.IP + "payment-reminder-manual/", { r_id: receipt.id })
              .then(
                function success(request) {
                  if (request.status === 200 || request.status === 201) {
                    swal(
                      "Enviado",
                      "El recordatorio ha sido enviado",
                      "success"
                    );
                  } else {
                    swal(
                      "Error",
                      "No se envió el recordatorio. Contacte a su administrador.",
                      "error"
                    );
                  }
                },
                function error(error) {
                  console.log("error - email", error);
                }
              )
              .catch(function (e) {
                console.log("error - catch", e);
              });
          } else {
          }
        });
      } else if (data_alert_correo) {
        SweetAlert.swal(data_alert_correo, function (inputValue) {
          if (inputValue === false) return false;

          if (inputValue === "") {
            swal.showInputError("Ingresa un correo");
            return false;
          }
          $http
            .post(url.IP + "payment-reminder-manual/", {
              r_id: receipt.id,
              email: inputValue,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  swal("Enviado", "El recordatorio ha sido enviado", "success");
                } else {
                  swal(
                    "Error",
                    "No se envió el recordatorio. Contacte a su administrador.",
                    "error"
                  );
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        });
      }
    }

    function showComment(receipt) {
      SweetAlert.swal({
        title: "Observaciones",
        text: receipt.description,
        type: "info",
      });
    }

    function close() {
      $state.go("index.main");
    }
    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        vm.getCobranza($scope.param_a, $scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }

    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        vm.providers = data.data;
      });
    }

    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_name: "Vida",
        },
        {
          id: 30,
          subramo_name: "Funerarios",
        },
        {
          id: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
        {
          id: 31,
          subramo_name: "Líneas Financieras",
        },
      ];
    }
    function getReferenciador() {
      vm.vendedores = [];
      $http.get(url.IP + "get-vendors").then(function (user) {
        // $scope.vendors_data = user.data;
        user.data.forEach(function (u) {
          var obj = {
            name: u.first_name + " " + u.last_name,
            id: u.id,
          };
          vm.vendedores.push(obj);
        });
      });
    }
    function matchesGroup(parWord, parType) {
      $scope.groups_data = 0;
      $scope.subgroups = [];
      $scope.subsubgroups = [];
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.group) {
        if (vm.form.group.val) {
          var word_data = vm.form.group.val;
        }
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_group = "grupos-match/";
          $http
            .post(url.IP + $scope.show_group, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groups = response.data;
                groups.forEach(function (item) {
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  $scope.subgroups = item.subgrupos;
                  // $scope.subsubgroups = [];
                  // $scope.subgroups.forEach(function(itm) {
                  //   $scope.subsubgroups = itm.subsubgrupos
                  // });
                  var obj = {
                    label: item.group_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.groups_data = source;
              }
            });
        }
      }
    }

    $scope.$watch("vm.form.group.value", function (newValue, oldValue) {
      if (vm.form.group) {
        if (vm.form.group.value) {
          $http
            .get(url.IP + "grupos/" + vm.form.group.value)
            .then(function (item) {
              vm.form.group.data = item.data;

              $scope.subgroups = item.data.subgrupos;
              $scope.subgroups.forEach(function (itm) {
                $scope.subsubgroups = itm.subsubgrupos;
              });
            });
        }
      }
    });

    function matchesGroupinglevel(parWord, parType) {
      $scope.subgrouping = [];
      $scope.subsubgrouping = [];
      $scope.groupunglevels_data = 0;
      vm.form.subgrouping = 0;
      vm.form.subsubgrouping = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.groupinglevel.val) {
        var word_data = vm.form.groupinglevel.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_grouping = "groupinglevel-match/";

          $http
            .post(url.IP + $scope.show_grouping, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var groupinglevels = response.data ? response.data : [];
                if (groupinglevels) {
                  groupinglevels.forEach(function (item) {
                    $scope.subsubgrouping = [];
                    $scope.subgrouping.forEach(function (itm) {
                      $scope.subsubgrouping = itm.subsubgrupos;
                    });
                    var obj = {
                      label: item.description,
                      value: item.id,
                      url: item.url,
                      subgrupos: item.subgrupos,
                    };
                    source.push(obj);
                  });
                }

                $scope.groupinglevels_data = source;
              }
            });
        }
      }
    }
    // --GroupingLevel
    // classification
    function matchesClassification(parWord, parType) {
      $scope.classification_data = 0;
      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else if (vm.form.classification.val) {
        var word_data = vm.form.classification.val;
      }
      if (word_data) {
        if (word_data.length >= 2) {
          $scope.show_claass = "classification-match/";

          $http
            .post(url.IP + $scope.show_claass, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200) {
                var source = [];
                var classifica = response.data;
                classifica.forEach(function (item) {
                  var obj = {
                    label: item.classification_name,
                    value: item.id,
                  };
                  source.push(obj);
                });
                $scope.classification_data = source;
              }
            });
        }
      }
    }
    function changeSubgroup(subg) {
      vm.form.subgroup = subg;
      vm.subgroup = subg;
      $scope.subsubgroups = subg.subsubgrupos ? subg.subsubgrupos : [];
    }

    $scope.changeConducto = function (conducto) {
      vm.form.tipo_cobro = conducto;
    };
    function changeSubsubgroup(subg) {
      vm.form.subsubgroup = subg;
      vm.subsubgroup = subg;
    }
    // Nivel de agrupación
    function changeSubgrouping(subgl) {
      vm.form.subgrouping = subgl;
      vm.subgrouping = subgl;
      $scope.subsubgrouping = subgl.subsubgrupos ? subgl.subsubgrupos : [];
    }
    function changeSubsubgrouping(subgl) {
      vm.form.subsubgrouping = subgl;
      vm.subsubgrouping = subgl;
    }
    function matchesContractors(parWord, parType) {
      $scope.contractors_data = 0;

      if (parType) {
        var word_data = parWord.val;
        parWord = parWord.val;
      } else {
        var word_data = vm.form.contratante.val;
      }

      if (word_data) {
        if (word_data.length >= 3) {
          $scope.show_contratante = "contractors-match/";
          $http
            .post(url.IP + $scope.show_contratante, {
              matchWord: parWord,
            })
            .then(function (response) {
              if (response.status === 200 && response.data.contractors) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item.id,
                        type:
                          item.type_person == "Física"
                            ? "natural"
                            : "juridical",
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      } else {
      }
    }

    function changeReferenciador(obj) {}

    function changeProvider(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.ramos = [];
        vm.form.provider = 0;
        return;
      }
      $http.get(url.IP + "ramos-by-provider/" + obj.id).then(function (ramos) {
        vm.ramos = ramos.data;
      });
    }

    function changeRamo(obj) {
      if (!obj) {
        vm.subramos = [];
        vm.form.ramo = 0;
        return;
      }
      try {
        vm.subramos = obj.subramo_ramo;
      } catch (e) {}
    }

    $scope.recibos_a_liquidar = [];
    $scope.massiveReceipts = function (recibos, receipt, v) {
      if (v) {
        receipt.toPay = v;
        $scope.recibos_a_liquidar.push(receipt);
        $scope.sumaRecibosPagados(recibos, receipt, v);
      } else {
        receipt.toPay = v;
        $scope.recibos_a_liquidar.forEach(function (d) {
          if (!v) {
            if (d.id == receipt.id) {
              $scope.recibos_a_liquidar.splice(receipt, 1);
              $scope.sumaRecibosPagados(recibos, receipt, v);
            }
          }
        });
      }
    };

    $scope.recibos_a_pagar = [];
    $scope.massiveReceiptsPay = function (recibos, receipt, v) {
      if (vm.form.status.id == 1) {
        if (v) {
          receipt.to_liquidate = v;
          $scope.recibos_a_pagar.push(receipt);
          $scope.sumaRecibos(recibos, receipt, v);
        } else {
          receipt.to_liquidate = v;
          $scope.recibos_a_pagar.forEach(function (d) {
            if (!v) {
              if (d.id == receipt.id) {
                $scope.recibos_a_pagar.splice(receipt, 1);
                $scope.sumaRecibos(recibos, receipt, v);
              }
            }
          });
        }
      } else {
        receipt.toPay = v;
        $scope.massiveReceipts(recibos, receipt, v);
      }
    };

    function changeSubRamo(obj) {
      if (obj) {
        vm.form.subramo = obj;
      } else {
        vm.form.subramo = 0;
      }
    }
    function changeStatus(obj) {
      if (obj) {
        vm.form.status = obj;
      } else {
        vm.form.status = 1;
      }
    }

    function changePayment(obj) {
      if (obj) {
        vm.form.payment = obj;
      } else {
        vm.form.payment = 0;
      }
    }

    $(".datepicker-me input").datepicker();
    $(".js-example-basic-multiple").select2();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    $scope.print = function (item) {};
    $scope.showEndorsement = function (endoso) {
      if (endoso.receipt_type == 2) {
        if (endoso.poliza.subramo == "Gastos Medicos") var type = "disease";
        else if (endoso.poliza.subramo == "Vida") var type = "life";
        else var type = "automobile";
      }
      $state.go("endosos.pendingDataMassive", {
        endorsementId: endoso.id,
        endorsementType: type,
      });
    };
    $scope.addFile = function (key, files) {
      if (
        files[0].name.indexOf(".jpg") < 0 &&
        files[0].name.indexOf(".png") < 0 &&
        files[0].name.indexOf(".jpeg") < 0
      ) {
        swal("Error", "Archivo no valido, deber(.jpg, .png, .jpeg)", "error");
        files = null;
        return;
      }
      if (key == "header" && files.length) {
        $scope.b_header = true;
      } else if (key == "header" && !files.length) {
        $scope.b_header = false;
      } else if (key == "footer" && files.length) {
        $scope.b_footer = true;
      } else if (key == "footer" && !files.length) {
        $scope.b_footer = true;
      } else if (key == "image_sms" && !files.length) {
        $scope.image_sms = true;
      } else if (key == "image_sms" && files.length) {
        $scope.image_sms = true;
      }
      formdata.append(key, files[0]);
    };
    $scope.saveFilesHF = function () {
      if (!$scope.b_header || !$scope.b_footer) {
        swal("Error", "Error  banner vacio o archivos no validos", "error");
        return;
      }

      var settings = {
        async: true,
        crossDomain: true,
        url: url.IP + "banner/?org=" + vm.org_name,
        method: "POST",
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", "Bearer " + token);
        },
        processData: false,
        contentType: false,
        mimeType: "multipart/form-data",
        data: formdata,
      };
      $.ajax(settings)
        .done(function (response) {
          $scope.banner_edith = false;
          swal("Actualizado", "Valores actualizados", "success");
          if ($scope.custom_email) {
            $http
              .get(url.IP + "payment-reminder-manual/" + $scope.receiptAll.id)
              .then(function (response) {
                if (response.status === 200) {
                  $scope.head = response.data.head;
                  $scope.body = response.data.body;
                  $scope.footer = response.data.footer;
                }
              })
              .catch(function (e) {
                console.log("error - catch", e);
              });
          }
        })
        .error(function (response) {
          $scope.banner_edith = false;
          swal("Error", "Error al actualizar ", "error");
        });
      $scope.in_process = false;
    };
    $scope.saveFilesIsms = function () {
      if (!$scope.image_sms) {
        swal("Error", "Error imagen vacia o archivos no válidos", "error");
        return;
      }
      if ($scope.id_banners) {
        var settings = {
          async: true,
          crossDomain: true,
          url:
            url.IP +
            "banner/" +
            $scope.id_banners +
            "/" +
            "?org=" +
            vm.org_name,
          method: "PATCH",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + token);
          },
          processData: false,
          contentType: false,
          mimeType: "multipart/form-data",
          data: formdata,
        };
        $.ajax(settings)
          .done(function (response) {
            $scope.imagesms_edit = false;
            swal("Actualizado", "Valores actualizados", "success");
          })
          .error(function (response) {
            $scope.banner_edith = false;
            swal("Error", "Error al actualizar ", "error");
          });
      } else {
        var settings = {
          async: true,
          crossDomain: true,
          url: url.IP + "banner/?org=" + vm.org_name,
          method: "POST",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + token);
          },
          processData: false,
          contentType: false,
          mimeType: "multipart/form-data",
          data: formdata,
        };
        $.ajax(settings)
          .done(function (response) {
            $scope.imagesms_edit = false;
            swal("Actualizado", "Valores actualizados", "success");
          })
          .error(function (response) {
            $scope.banner_edith = false;
            swal("Error", "Error al actualizar ", "error");
          });
      }
      $scope.in_process = false;
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("CobranzasBonosCtrl", CobranzasBonosCtrl);

  CobranzasBonosCtrl.$inject = [
    "providerService",
    "curr_rate_options",
    "$localStorage",
    "receiptService",
    "statusPayform",
    "toaster",
    "$uibModal",
    "statusReceipt",
    "SweetAlert",
    "$uibModalInstance",
    "modalService",
    "valueReceipt",
    "$sessionStorage",
    "$http",
    "url",
    "$parse",
    "$scope",
    "$state",
    "exportFactory",
    "$location",
    "dataFactory",
    "PersistenceFactory",
    "datesFactory",
  ];

  function CobranzasBonosCtrl(
    providerService,
    curr_rate_options,
    $localStorage,
    receiptService,
    statusPayform,
    toaster,
    $uibModal,
    statusReceipt,
    SweetAlert,
    $uibModalInstance,
    modalService,
    valueReceipt,
    $sessionStorage,
    $http,
    url,
    $parse,
    $scope,
    $state,
    exportFactory,
    $location,
    dataFactory,
    PersistenceFactory,
    datesFactory
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.pageTitle = "Cobranza";
    vm.save_bono = save_bono;
    vm.GetBonos = GetBonos;
    vm.select_provider = [];
    vm.selectProv = selectProv;
    vm.openModal = openModal;

    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    vm.form = {
      provider: 0,
      since: convertDate(new Date()),
      until: convertDate(new Date()),
    };

    vm.bonos = [];
    vm.accesos = $sessionStorage.permisos;
    vm.accesos.forEach(function (acceso) {
      if (acceso.model_name == "Cobranza") {
        vm.acceso_cob = acceso;
        vm.acceso_cob.permissions.forEach(function (acc) {
          if (acc.permission_name == "Pagar y prorrogar") {
            if (acc.checked == true) {
              vm.acceso_pag_rec = true;
            } else {
              vm.acceso_pag_rec = false;
            }
          } else if (acc.permission_name == "Desconciliación de recibos") {
            if (acc.checked == true) {
              vm.acceso_desconc_rec = true;
            } else {
              vm.acceso_desconc_rec = false;
            }
          } else if (acc.permission_name == "Desliquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_desliq_rec = true;
            } else {
              vm.acceso_desliq_rec = false;
            }
          } else if (acc.permission_name == "Conciliar recibos") {
            if (acc.checked == true) {
              vm.acceso_conc_rec = true;
            } else {
              vm.acceso_conc_rec = false;
            }
          } else if (acc.permission_name == "Liquidar recibos") {
            if (acc.checked == true) {
              vm.acceso_liq_rec = true;
            } else {
              vm.acceso_liq_rec = false;
            }
          } else if (acc.permission_name == "Ver cobranza") {
            if (acc.checked == true) {
              vm.acceso_ver_cob = true;
            } else {
              vm.acceso_ver_cob = false;
            }
          } else if (acc.model_name == "Archivos") {
            vm.acceso_files = acc;
            vm.acceso_files.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              }
            });
          }
        });
      } else if (acceso.model_name == "Correos electronicos") {
        vm.acceso_correo = acceso;
        vm.acceso_correo.permissions.forEach(function (acc) {
          if (acc.permission_name == "Correos") {
            if (acc.checked == true) {
              vm.acceso_cor = true;
            } else {
              vm.acceso_cor = false;
            }
          }
        });
      } else if (acceso.model_name == "Pólizas") {
        vm.acceso_polizas = acceso;
        vm.acceso_polizas.permissions.forEach(function (acc) {
          if (acc.permission_name == "Administrar pólizas") {
            if (acc.checked == true) {
              vm.acceso_adm_pol = true;
            } else {
              vm.acceso_adm_pol = false;
            }
          } else if (acc.permission_name == "Ver pólizas") {
            if (acc.checked == true) {
              vm.acceso_ver_pol = true;
            } else {
              vm.acceso_ver_pol = false;
            }
          }
        });
      } else if (acceso.model_name == "Reportes") {
        vm.acceso_reportes = acceso;
        vm.acceso_reportes.permissions.forEach(function (acc) {
          if (acc.permission_name == "Reporte fianzas") {
            if (acc.checked == true) {
              vm.acceso_rep_fia = true;
            } else {
              vm.acceso_rep_fia = false;
            }
          } else if (acc.permission_name == "Reporte Siniestros") {
            if (acc.checked == true) {
              vm.acceso_rep_sin = true;
            } else {
              vm.acceso_rep_sin = false;
            }
          } else if (acc.permission_name == "Reporte Endosos") {
            if (acc.checked == true) {
              vm.acceso_rep_end = true;
            } else {
              vm.acceso_rep_end = false;
            }
          } else if (acc.permission_name == "Reporte pólizas") {
            if (acc.checked == true) {
              vm.acceso_rep_pol = true;
            } else {
              vm.acceso_rep_pol = false;
            }
          } else if (acc.permission_name == "Reporte renovaciones") {
            if (acc.checked == true) {
              vm.acceso_rep_ren = true;
            } else {
              vm.acceso_rep_ren = false;
            }
          } else if (acc.permission_name == "Reporte cobranza") {
            if (acc.checked == true) {
              vm.acceso_rep_cob = true;
            } else {
              vm.acceso_rep_cob = false;
            }
          }
        });
      }
    });
    vm.bono = {
      aseguradora: "0",
      start_validity: convertDate(new Date()),
      end_validity: convertDate(
        new Date().setYear(new Date().getFullYear() + 1)
      ),
      cantidad: 0,
      tipo_de_cambio: "1",
      factura_number: "",
    };

    $scope.types_bono = [
      { id: 1, name: "Emisión" },
      { id: 2, name: "Cancelación" },
      { id: 3, name: "Producción" },
      { id: 4, name: "Otro" },
    ];

    vm.option_policy = [
      {
        id: 1,
        name: "Inicio de vigencia",
      },
      {
        id: 4,
        name: "Fecha de liquidación",
      },
      {
        id: 5,
        name: "Fecha de conciliación",
      },
      {
        id: 6,
        name: "Fecha de ingreso",
      },
    ];

    activate();
    vm.form.since = convertDate(new Date().setMonth(new Date().getMonth() - 1));
    // var endingDate =  convertDate(new Date().setYear(new Date().getFullYear() + 1));
    var endingDate = convertDate(new Date());
    vm.form.until = endingDate;

    $scope.changeProvider = function (provider) {
      if (!provider) {
        $scope.subramos = [];
        $scope.ramos = [];
        return;
      }
      $http
        .get(url.IP + "ramos-by-provider/" + provider.id)
        .then(function (ramo) {
          $scope.ramos = ramo.data;
        });
      $scope.getClaves(provider);
      $scope.provider = provider;
    };
    $scope.getClaves = function (provider) {
      $http
        .get(url.IP + "claves-by-provider/" + provider.id)
        .then(
          function success(clave) {
            $scope.claves = clave.data;
            $scope.clave = $localStorage["bono"]
              ? $localStorage["bono"]["clave"]
              : "";
            console.log("claves", $scope.clave, $localStorage["bono"]);
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    };
    vm.getClavesS = getClavesS;
    function getClavesS(provider) {
      $http
        .get(url.IP + "claves-by-provider/" + provider.id)
        .then(
          function success(clave) {
            $scope.claves = clave.data;
            $scope.clave = $localStorage["bono"]
              ? $localStorage["bono"]["clave"]
              : "";
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    }
    $scope.changeClave = function (clave) {
      if (clave) {
        $scope.clave_selected = clave.id;
      } else {
        $scope.clave_selected = "";
      }
    };

    $scope.changeReport = function () {
      if (vm.form.dates_sel) {
        if (vm.form.dates_sel.id == 1) {
          $scope.created_at = true;
          $scope.vigency = false;
        } else if (vm.form.dates_sel.id == 2) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 3) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 4) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 5) {
          $scope.vigency = true;
          $scope.created_at = false;
        } else if (vm.form.dates_sel.id == 6) {
          $scope.vigency = true;
          $scope.created_at = false;
        }
      } else {
        $scope.vigency = false;
        $scope.created_at = false;
      }
    };
    function toDate(dateStr) {
      if (!dateStr) return dateStr;
      var dateString = dateStr; // Oct 23
      var dateParts = dateString.split("/");
      var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based

      return dateObject;
    }
    // $(window).load(function() {
    //   $('.js-example-basic-multiple').select2();
    // });
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    function save_bono() {
      if ($scope.clave) {
      } else {
        toaster.error("Seleccione una Clave de Aseguradora válida");
        return;
      }
      if ($scope.type_bono) {
      } else {
        toaster.error("Seleccione un Tipo válido");
        return;
      }
      if (vm.bono.aseguradora == "0") {
        toaster.error("Seleccione una aseguradora válida");
        return;
      }
      if (vm.bono.cantidad <= 0) {
        toaster.error("La cantidad debe ser mayor a 0");
        return;
      }
      var bono_aux = {
        aseguradora: vm.bono.aseguradora ? vm.bono.aseguradora.url : undefined,
        clave: $scope.clave ? $scope.clave.url : undefined,
        type_bono: $scope.type_bono ? $scope.type_bono.id : undefined,
        start_validity: toDate(vm.bono.start_validity),
        end_validity: toDate(vm.bono.end_validity),
        cantidad: vm.bono.cantidad,
        tipo_cambio: vm.bono.tipo_de_cambio,
        factura_number: vm.bono.factura_number ? vm.bono.factura_number : 0,
        vendor: vm.bono.vendor ? vm.bono.vendor : "",
      };
      $http({
        method: "POST",
        url: url.IP + "bonos/",
        data: bono_aux,
      }).then(function (response) {
        if (response) {
          if (response.status == 201 || response.status == 200) {
            toaster.info("Bono creado: " + response.data.id);
            PersistenceFactory.eliminar();
            $localStorage["bono"] = {};
          }
          $scope.receipts = [
            {
              comision: vm.bono.cantidad ? vm.bono.cantidad : 0,
              delivered: false,
              derecho: 0,
              endingDate: toDate(vm.bono.end_validity),
              fecha_fin: toDate(vm.bono.end_validity),
              fecha_inicio: toDate(vm.bono.start_validity),
              iva: 0,
              status: 1,
              prima: 0,
              prima_neta: 0,
              prima_total: 0,
              receipt_type: 4,
              recibo_numero: 1,
              rpf: 0,
              startDate: toDate(vm.bono.start_validity),
              total: 0,
              bono: response.data.url,
              vencimiento: toDate(
                convertDate(
                  new Date(vm.bono.start_validity).setMonth(
                    new Date().getMonth() + 1
                  )
                )
              ),
            },
          ];
          // form.receipts.forEach(function(new_receipt, receipt_index) {
          dataFactory.post("recibos/", $scope.receipts[0]).then(function (req) {
            if (req.status == 201 || req.status == 200) {
              toaster.info("Recibo creado: " + req.data.id);
            }
          });

          // });
        }
        $localStorage.save_bono = [];
        vm.bono = {};
        GetBonos();
        // vm.bono = {
        //   aseguradora: "0",
        //   fecha_entrega: convertDate(new Date()),
        //   cantidad: 0,
        //   tipo_de_cambio: "1"
        // };
      });
    }
    $scope.dataToSave = {};
    $scope.dataToSave.start_of_validity = new Date(
      toDate(vm.bono.start_validity)
    );
    $scope.dataToSave.end_of_validity = new Date(toDate(vm.bono.end_validity));
    $scope.form = {
      contratante: "",
      poliza: "",
      folio: "",
      tel: "",
      correo: "",
      ramo: "",
      type: "",
      subramo: "",
      aseguradora: "",
      paquete: "",
      payment: 5,
      internal_number: "",
      startDate: vm.bono.start_validity,
      endingDate: vm.bono.end_validity,
      start_of_validity: new Date(toDate(vm.bono.start_validity)),
      end_of_validity: new Date(toDate(vm.bono.end_validity)),
      ceder_comision: false,
      comision_percent: 0.0,
      udi: 0.0,
      renewal: 1,
    };
    function activate() {
      $(".js-example-basic-multiple").select2();
      $http.get(url.IP + "get-vendors/").then(function (user) {
        $scope.referenciador = user.data;
      });
      $http.get(url.IP + "usuarios/").then(function (user) {
        $scope.users = [];
        user.data.results.forEach(function (usr) {
          if (usr.user_info.is_active) {
            $scope.users.push(usr);
          }
        });
      });

      vm.bono.aseguradora = $localStorage["bono"]
        ? $localStorage["bono"]["aseguradora"]
        : "";
      if (vm.bono.aseguradora) {
        getClavesS(vm.bono.aseguradora);
      }
      $scope.clave = $localStorage["bono"]
        ? $localStorage["bono"]["clave"]
        : "";
      $scope.type_bono = $localStorage["bono"]
        ? $localStorage["bono"]["type_bono"]
        : "";
      vm.bono.cantidad = $localStorage["bono"]
        ? $localStorage["bono"]["cantidad"]
        : "";
      vm.bono.start_validity = $localStorage["bono"]
        ? $localStorage["bono"]["start_validity"]
        : "";
      vm.bono.end_validity = $localStorage["bono"]
        ? $localStorage["bono"]["end_validity"]
        : "";
      vm.bono.factura_number = $localStorage["bono"]
        ? $localStorage["bono"]["factura_number"]
        : "";
      vm.bono.tipo_de_cambio = $localStorage["bono"]
        ? $localStorage["bono"]["tipo_de_cambio"]
        : "";
      vm.bono.vendor = $localStorage["bono"]
        ? $localStorage["bono"]["vendor"]
        : "";
      vm.select_provider = $localStorage["bono"]
        ? $localStorage["bono"]["select_provider"]
        : "";
      vm.form.dates_sel = $localStorage["bono"]
        ? $localStorage["bono"]["dates_sel"]
        : "";
      vm.form.since = $localStorage["bono"]
        ? $localStorage["bono"]["since"]
        : "";
      vm.form.until = $localStorage["bono"]
        ? $localStorage["bono"]["until"]
        : "";
      $scope.created_at = $localStorage["bono"]
        ? $localStorage["bono"]["created_at"]
        : $scope.created_at;
      $scope.vigency = $localStorage["bono"]
        ? $localStorage["bono"]["vigency"]
        : $scope.vigency;
      getProviders();
      // GetBonos();
    }
    $scope.saveLocalstorange = function () {
      $localStorage["bono"] = $localStorage["bono"]
        ? $localStorage["bono"]
        : {};
      $localStorage["bono"]["aseguradora"] = vm.bono.aseguradora
        ? vm.bono.aseguradora
        : [];
      $localStorage["bono"]["clave"] = $scope.clave ? $scope.clave : "";
      $localStorage["bono"]["type_bono"] = $scope.type_bono
        ? $scope.type_bono
        : "";
      $localStorage["bono"]["cantidad"] = vm.bono.cantidad
        ? vm.bono.cantidad
        : 0;
      $localStorage["bono"]["start_validity"] = vm.bono.start_validity
        ? vm.bono.start_validity
        : convertDate(new Date());
      $localStorage["bono"]["end_validity"] = vm.bono.end_validity
        ? vm.bono.end_validity
        : convertDate(new Date());
      $localStorage["bono"]["factura_number"] = vm.bono.factura_number
        ? vm.bono.factura_number
        : "";
      $localStorage["bono"]["tipo_de_cambio"] = vm.bono.tipo_de_cambio
        ? vm.bono.tipo_de_cambio
        : 1;
      $localStorage["bono"]["vendor"] = vm.bono.vendor ? vm.bono.vendor : "";
      $localStorage["bono"]["select_provider"] = vm.select_provider
        ? vm.select_provider
        : "";
      $localStorage["bono"]["dates_sel"] = vm.form.dates_sel
        ? vm.form.dates_sel
        : "";
      $localStorage["bono"]["since"] = vm.form.since
        ? vm.form.since
        : convertDate(new Date());
      $localStorage["bono"]["until"] = vm.form.until
        ? vm.form.until
        : convertDate(new Date());
      $localStorage["bono"]["created_at"] = $scope.created_at;
      $localStorage["bono"]["vigency"] = $scope.vigency;
    };
    $scope.changeVendedor = function (vendedor) {
      $scope.users.some(function (user) {
        if (vendedor == user.id) {
          var vendedor_info = user.user_info.info_vendedor[0];
          if (vendedor_info.vendedor_subramos.length == 0) {
            SweetAlert.swal(
              "error",
              "El vendedor no tiene comisión en el subramo actual"
            );
            order.form.vendor = null;
            return;
          }
        }
      });
    };

    function GetBonos() {
      var aux_provider = [];
      if (vm.select_provider && vm.select_provider.length) {
        vm.select_provider.forEach(function (provider) {
          aux_provider.push(provider.id);
        });
      }
      var params = {
        report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 1,
        since: vm.form.since,
        until: vm.form.until,
        provider: aux_provider.length ? aux_provider : 0,
      };
      $http({
        method: "GET",
        url: url.IP + "bonos-to-show/",
        params: params,
      }).then(function (response) {
        vm.bonos = response.data.results;
        // if(response.data.next || response.data.previous){
        vm.receipt_pagination = true;
        vm.receipt_r = {
          count: response.data.count,
          previous: response.data.previous,
          next: response.data.next,
        };
        $scope.testPagination("vm.bonos", "vm.receipt_r");
        // }
      });
    }

    function openModal(bono) {
      if (bono) {
        var receipt = bono.recibos_bono[0];
        var insurance = bono;
        var bono = true;
      }
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return insurance;
          },
          bono: function () {
            return bono;
          },
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        vm.GetBonos();
      });
    }

    $scope.exportData = function () {
      var aux_provider = [];
      if (vm.select_provider) {
        vm.select_provider.forEach(function (provider) {
          aux_provider.push(provider.id);
        });
      }
      var data = {
        from: vm.form.since,
        until: vm.form.until,
        // _provider :aux_provider.length ? aux_provider:0,
        provider: aux_provider.length ? aux_provider : 0,
        report_by: vm.form.dates_sel ? vm.form.dates_sel.id : 1,
      };
      $http({
        method: "POST",
        url: url.IP + "bonos-to-excel/",
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
        data: data,
      })
        .then(function success(request) {
          if (request.status === 200) {
            var blob = new Blob([request.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte_Bonos.xls");
          }
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    function selectProv(sel) {
      vm.providers_selected = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
      });
    }

    // -----------PAGINACIÓN
    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);

        $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&status=") !== -1) {
              var status = prev_.substring(prev_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }
        getDataBonos(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getDataBonos(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    function getProviders() {
      // providerService.getReadListProviders()
      //       .then(function(data){
      //           vm.providers = data;
      //       });
      var d = new Date();
      var curr_date = d.getDate();
      var curr_month = d.getMonth() + 1; //Months are zero based
      var curr_year = d.getFullYear();
      var date = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(date).then(
        function success(data) {
          vm.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    }

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    $scope.validateDecimal = function (input) {
      if (input) {
        if (parseFloat(input) < 0) {
          vm.bono.cantidad = 0;
        } else {
          vm.bono.cantidad = parseFloat(input.toFixed(2));
        }
      }
    };
    //-- Peticion de persistencia--//
    var json_data = {};
    var form = document.getElementsByClassName("ibox-content col-md-12");
    var elementos = {};
    //Valores reutilizables
    var interval, interval1, valor;
    var getClaves_go = false;
    var count = 0;

    function set_dataForm(json) {
      PersistenceFactory.set_inputs(json);

      if (
        json["vm.bono.aseguradora"] != "" &&
        json["vm.bono.aseguradora"] != "?"
      ) {
        valor = PersistenceFactory.find_index(
          vm.providers,
          json["vm.bono.aseguradora"]
        );
        $scope.changeProvider(vm.providers[valor]);
        vm.bono.aseguradora = vm.providers[valor];
      }
      if (json["clave"] != "") {
        interval1 = setInterval(function () {
          if (getClaves_go == true) {
            clearInterval(interval1);
            if ($scope.claves.length > 0) {
              valor = PersistenceFactory.find_index(
                $scope.claves,
                json["clave"]
              );
              $scope.clave = $scope.claves[valor];
            }
          }
        }, 1000);
      }
      if (json["type_bono"] != "") {
        valor = $scope.types_bono;
        $scope.type_bono = valor[parseInt(json["type_bono"]) - 1];
      }
    }

    interval = setInterval(function () {
      if (form != undefined && PersistenceFactory.count == 0) {
        PersistenceFactory.inicial(
          usr.org,
          "Bonos",
          usr.nameFull,
          PersistenceFactory.get_dataForm(form)
        );
      }
      if (
        PersistenceFactory.init_return != "" &&
        PersistenceFactory.init_return != undefined
      ) {
        clearInterval(interval);
        if (PersistenceFactory.init_return.status == "data_view") {
          set_dataForm(PersistenceFactory.json_return);
        }
        PersistenceFactory.interval = setInterval(function () {
          PersistenceFactory.editado(PersistenceFactory.get_dataForm(form));
        }, PersistenceFactory.intervalTime); /* /* */
      }
    }, 1000);
    //-- End Peticion de persistencia--//
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").factory("coverageService", coverageService);

  coverageService.$inject = ["url", "$http", "globalVar"];

  function coverageService(url, $http, globalVar) {
    var service = {
      createCoverage: createCoverage,
      createCoverageConfig: createCoverageConfig,
      createSumInsured: createSumInsured,
      createDeducible: createDeducible,
      createCoberturaPoliza: createCoberturaPoliza,
      getCoverages: getCoverages,
      getCoverage: getCoverage,
      getForms: getForms,
      getCoveragesByPackage: getCoveragesByPackage,
      updateCoverage: updateCoverage,
      deletePackage: deletePackage,
      getCoverageByUri: getCoverageByUri,
      createCoverageComplete: createCoverageComplete,
      updateCoverageComplete: updateCoverageComplete,
      deleteCoverageByUri: deleteCoverageByUri,
      deleteCoverageComplete: deleteCoverageComplete,
      getProviderData: getProviderData,
    };

    return service;

    ////////////

    //coverage_name: "Ejemplo"
    //deductible_coverage: Array[]
    //package: "http://localhost:8000/v1/paquetes/information/1/"
    //provider: "http://localhost:8000/proveedores/1/"
    //sums_coverage: Array[]
    //prima: ''

    function getProviderData(provider_id) {
      return $http
        .get(url.IP + "proveedores-ramo/" + provider_id)
        .then(getProvidersComplete)
        .catch(getProvidersFailed);

      function getProvidersComplete(response) {
        var dfd = $.Deferred();
        dfd.resolve(response.data.results);
        return dfd.promise();
      }

      function getProvidersFailed(error) {
        return error;
      }
    }
    function createCoverageComplete(data) {
      var dfd = $.Deferred();
      var count = 0;
      var complete =
        data.sums_coverage.length + data.deductible_coverage.length;

      var submitForm = {
        coverage_name: data.coverage_name,
        priority: data.priority ? data.priority : 0,
        provider: data.provider,
        package: data.package,
        prima: data.prima,
      };

      createCoverage(submitForm).then(function (coverage) {
        data.deductible_coverage.forEach(function (deductible) {
          var deductibleObj = {
            deductible: deductible.deductible,
            coverage_deductible: coverage.url,
          };
          createDeducible(deductibleObj).then(function (data) {
            coverage.deductible_coverage.push(data);
            count++;
            if (count == complete) {
              dfd.resolve(coverage);
            }
          });
        });
        data.sums_coverage.forEach(function (sum) {
          var sumObj = {
            sum_insured: sum.sum_insured,
            coverage_sum: coverage.url,
          };
          createSumInsured(sumObj).then(function (data) {
            coverage.sums_coverage.push(data);
            count++;
            if (count == complete) {
              dfd.resolve(coverage);
            }
          });
        });
      });
      return dfd.promise();
    }

    function createCoberturaPoliza(data) {
      return $http
        .post(url.IP + "coberturas-polizas/", data)
        .then(createCoberturaPolizaComplete)
        .catch(createCoberturaPolizaFailed);

      function createCoberturaPolizaComplete(response) {
        return response.data;
      }

      function createCoberturaPolizaFailed(error) {}
    }

    function createCoverage(data) {
      return $http
        .post(url.IP + "coberturas/", data)
        .then(createCoverageComplete)
        .catch(createCoverageFailed);

      function createCoverageComplete(response) {
        return response.data;
      }

      function createCoverageFailed(error) {}
    }

    function createCoverageConfig(data) {
      return $http
        .post(url.IP + "coberturas-configuraciones/", data)
        .then(createCoverageComplete)
        .catch(createCoverageFailed);

      function createCoverageComplete(response) {
        return response.data;
      }

      function createCoverageFailed(error) {}
    }

    function createSumInsured(data) {
      return $http
        .post(url.IP + "sumas-aseguradas/", data)
        .then(createSumInsuredComplete)
        .catch(createSumInsuredFailed);

      function createSumInsuredComplete(response) {
        return response.data;
      }

      function createSumInsuredFailed(error) {}
    }

    //coverage_sum: "http://localhost:8000/coberturas/55/"
    //id: 99
    //sum_insured: "2222"
    //url: "http://localhost:8000/sumas-aseguradas/99/"
    function deleteSumInsured(sum) {
      return $http
        .delete(sum.url)
        .then(createDeducibleComplete)
        .catch(createDeducibleFailed);

      function createDeducibleComplete(response) {
        return response;
      }

      function createDeducibleFailed(error) {}
    }

    function createDeducible(data) {
      return $http
        .post(url.IP + "deducibles/", data)
        .then(createDeducibleComplete)
        .catch(createDeducibleFailed);

      function createDeducibleComplete(response) {
        return response.data;
      }

      function createDeducibleFailed(error) {}
    }

    //coverage_deductible: "http://localhost:8000/coberturas/55/"
    //deductible: "3333"
    //id: 107
    //url: "http://localhost:8000/deducibles/107/"
    function deleteDeductible(deductible) {
      return $http
        .delete(deductible.url)
        .then(createDeducibleComplete)
        .catch(createDeducibleFailed);

      function createDeducibleComplete(response) {
        return response;
      }

      function createDeducibleFailed(error) {}
    }

    function getCoverages() {
      return $http
        .get(url.IP + "coberturas/")
        .then(getCoveragesComplete)
        .catch(getCoveragesFailed);

      function getCoveragesComplete(response) {
        return response.data.results;
      }

      function getCoveragesFailed(error) {}
    }

    function getCoverageByUri(uri) {
      return $http.get(uri).then(getCoverageComplete).catch(getCoverageFailed);

      function getCoverageComplete(response) {
        return response;
      }

      function getCoverageFailed(error) {}
    }

    function getCoverage(data) {
      data.paqueteId = url.IP + "coberturas/" + data.paqueteId + "/";
      return $http
        .get(data.paqueteId)
        .then(getCoverageComplete)
        .catch(getCoverageFailed);

      function getCoverageComplete(response) {
        return response.data;
      }

      function getCoverageFailed(error) {}
    }

    function getCoveragesByPackage(id) {
      var data = globalVar.coveragesByPackage.replace(":package", id);
      return $http.get(data).then(function (res) {
        return res;
      });
    }

    function getForms() {}

    function updateCoverage(coverage) {
      var uri = coverage.url ? coverage.url : coverage;

      return $http
        .put(uri, coverage)
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          return error;
        });
    }
    // coverage_deductibles_add: Array[0]
    // coverage_deductibles_delete: Array[0]
    // coverage_sums_add: Array[0]
    // coverage_sums_delete: Array[0]
    // url: "http://localhost:8000/coberturas/24/"
    function updateCoverageComplete(coverage) {
      var dfd = $.Deferred();
      var cont = 0;
      var transactions =
        coverage.coverage_deductibles_delete.length +
        coverage.coverage_deductibles_add.length +
        coverage.coverage_sums_add.length +
        coverage.coverage_sums_delete.length;

      coverage.coverage_deductibles_delete.forEach(function (deleted) {
        deleteDeductible(deleted).then(isDone);
      });

      coverage.coverage_sums_delete.forEach(function (deletedSum) {
        deleteSumInsured(deletedSum).then(isDone);
      });

      coverage.coverage_deductibles_add.forEach(function (addedDeductible) {
        var deductibleObj = {
          deductible: addedDeductible.deductible,
          default: addedDeductible.default,
          coverage_deductible: coverage.url,
        };
        createDeducible(deductibleObj).then(isDone);
      });

      coverage.coverage_sums_add.forEach(function (addedSum) {
        var sumObj = {
          sum_insured: addedSum.sum_insured,
          default: addedSum.default,
          coverage_sum: coverage.url,
        };
        createSumInsured(sumObj).then(isDone);
      });
      $http
        .patch(coverage.url, {
          coverage_name: coverage.coverage_name,
          priority: coverage.priority,
        })
        // $http.patch(coverage.url,coverage)
        .then(isDone);

      function isDone() {
        cont++;
        if (cont == transactions) {
          getCoverageByUri(coverage.url).then(function (coverage) {
            dfd.resolve(coverage);
          });
        }
      }

      return dfd.promise();
    }

    function deleteCoverageByUri(uri) {
      return $http.delete(uri).then(deleteCompleted).catch(deleteFailed);

      function deleteCompleted(response) {
        return response;
      }

      function deleteFailed(error) {
        return error;
      }
    }

    // deductible_coverage: Array[]
    // sums_coverage: Array[]
    // url: "http://localhost:8000/coberturas/24/"
    function deleteCoverageComplete(coverage) {
      var dfd = $.Deferred();
      var cont = 0;
      var transactions =
        coverage.deductible_coverage.length + coverage.sums_coverage.length + 1; // +1 cuz cvg

      coverage.deductible_coverage.forEach(function (deductible) {
        deleteDeductible(deductible).then(isDone);
      });

      coverage.sums_coverage.forEach(function (sum) {
        deleteSumInsured(sum).then(isDone);
      });
      // TODO El API debe poder borrar la cobertura
      deleteCoverageByUri(coverage.url).then(isDone);

      function isDone(response) {
        cont++;
        if (cont == transactions) {
          dfd.resolve(coverage);
        }
      }

      return dfd.promise();
    }

    function deletePackage() {}
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular
    .module("inspinia")
    .controller("CoberturasCtrl", CoberturasCtrl)
    .filter("propsFilter", propsFilter);

  function propsFilter() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        items.forEach(function (item) {
          var itemMatches = false;
          var keys = Object.keys(props);

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }
          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }
      return out;
    };
  }

  CoberturasCtrl.$inject = [
    "url",
    "$state",
    "$q",
    "$http",
    "$scope",
    "providerService",
    "packageService",
    "coverageService",
  ];

  function CoberturasCtrl(
    url,
    $state,
    $q,
    $http,
    $scope,
    providerService,
    packageService,
    coverageService
  ) {
    var vm = this;
    vm.groups = [];
    vm.pageTitle = "Coberturas";
    vm.submit = submit;

    vm.provider = {};
    vm.providers = [];

    vm.ramo = [];
    vm.isDefault = false;

    vm.branch = {};
    vm.subBranch = {};

    vm.package = {};

    vm.deducible = [];
    vm.deducibles = ["20", "10", "30"];

    vm.sum = [];
    vm.sums = ["100", "200", "350", "500"];

    vm.createCoverage = createCoverage;

    vm.form = {
      coverage: "",
      providers: "",
      paquete: "",
      sum: "",
      deducible: "",
      prima: "",
    };

    $scope.$watch("vm.provider", function (newValue, oldValue) {
      var wait = [];
      try {
        // $http.get(url.IP + 'proveedores-ramo/'+provider_id)
        // wait.push(provider);
        wait.push($http.get(vm.provider.url));

        $q.all(wait).then(function (response) {
          vm.ramo = response[0].data.ramo_provider;
        });
      } catch (err) {}
    });

    function createCoverage() {
      var deducibles = [];
      var sumas = [];
      deducibles.push(0.0);
      sumas.push(0.0);

      var coverage = {
        coverage_name: vm.form.coverage,
        priority: vm.form.priority,
        provider: vm.provider.url,
        package: vm.packages.url,
        deductible_coverage: deducibles,
        sums_coverage: sumas,
        coinsurance_coverage: coinsurances,
        topecoinsurance_coverage: topecoinsurances,
      };

      coverageService.createCoverage(coverage).then(function (response) {
        $state.go("paquetes.paquetes");
      });
    }

    vm.selectProvider = function () {};

    vm.selectBranch = function () {};

    vm.selectSubBranch = function () {};

    vm.selectPackage = function () {};

    activate();

    function activate() {
      getProviders();
    }

    function submit(isValid) {
      if (isValid) {
        alert("awesonme");
      }
    }

    function getProviders() {
      return providerService.getReadListProviders().then(function (data) {
        return (vm.providers = data);
      });
    }

    function getPackages() {
      return packageService.getPackages().then(function (data) {
        vm.packages = data;
        return vm.packages;
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("clasificacionController", clasificacionController);

  clasificacionController.$inject = [
    "$scope",
    "dataFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "$q",
    "helpers",
    "globalVar",
    "generalService",
  ];

  function clasificacionController(
    $scope,
    dataFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    $q,
    helpers,
    globalVar,
    generalService
  ) {
    $scope.vm = this;
    $scope.showClasification = false;
    $scope.showEditClasification = false;
    $scope.clasification = {};

    $scope.createClasification = function () {
      $scope.showClasification = true;
    };

    activate();
    function activate() {
      dataFactory.get("classification/").then(function success(response) {
        $scope.clasificationList = response.data.results;
      });
    }

    $scope.save = function (form) {
      $scope.dataToSave = {};
      $scope.dataToSave.classification_name = form.classification_name;
      $scope.dataToSave.description = form.description;

      dataFactory
        .post("classification/", $scope.dataToSave)
        .then(function success(response) {
          if (response.status == 200 || response.status == 201) {
            SweetAlert.swal(
              "¡Listo!",
              "Clasificación creada exitosamente.",
              "success"
            );
            $scope.close();
            activate();
          } else {
            $scope.close();
            activate();
          }
        });
    };

    $scope.close = function () {
      $scope.showClasification = false;
    };

    $scope.edit = function (param) {
      $scope.showClasification = false;
      $scope.showEditClasification = true;
      $scope.clasification = [];
      $scope.editClasification = param;
    };

    $scope.cancelEdit = function (param) {
      $scope.showClasification = false;
      $scope.showEditClasification = false;
      $scope.clasification = [];
      $scope.editClasification = [];
    };

    $scope.update = function (param) {
      $http
        .patch(param.url, {
          classification_name: param.classification_name,
          description: param.description,
        })
        .then(function (data) {
          if (data.status == 200) {
            SweetAlert.swal(
              "¡Listo!",
              "Clasificación actualizada correctamente.",
              "success"
            );
            $scope.cancelEdit();
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });
    };

    $scope.delete = function (url) {
      SweetAlert.swal(
        {
          title: "Eliminar Clasificación",
          text: "Se eliminara la información, ¿Está seguro?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(url).then(function success(response) {
              if (response.status == 204) {
                SweetAlert.swal(
                  "¡Listo!",
                  "Se ha eliminado la clasificación exitosamente.",
                  "success"
                );
                activate();
              }
            });
          }
        }
      );
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("RenovacionChartCtrl", RenovacionChartCtrl);

  RenovacionChartCtrl.$inject = [
    "url",
    "$http",
    "$scope",
    "$state",
    "$uibModal",
    "insuranceService",
    "exportFactory",
    "$sessionStorage",
  ];

  function RenovacionChartCtrl(
    url,
    $http,
    $scope,
    $state,
    $uibModal,
    insuranceService,
    exportFactory,
    $sessionStorage
  ) {
    // Conect functions with main.controller
    var greatGrandFather = $scope.$parent.$parent.$parent.main;

    $scope.setPolicyToList = setPolicyToList;
    $scope.setSiniesters = setSiniesters;

    $scope.labels = ["Verde", "Amarillo", "Naranja", "Rojo"];
    $scope.data = [0, 0, 0, 0];
    $scope.chartEvent = chartEvent;

    $scope.totalPolicies = {
      size: 0,
      collection: [],
      red: [],
      orange: [],
      yellow: [],
      green: [],
    };

    $scope.policies = [];
    $scope.sumPolicies = [];

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    activate();

    function activate() {}

    function chartEvent(points) {
      if (points.length > 0) {
        if (points[0].label === $scope.labels[0]) {
          $scope.policies = $scope.totalPolicies.green;
        } else if (points[0].label === $scope.labels[1]) {
          $scope.policies = $scope.totalPolicies.yellow;
        } else if (points[0].label === $scope.labels[2]) {
          $scope.policies = $scope.totalPolicies.orange;
        } else if (points[0].label === $scope.labels[3]) {
          $scope.policies = $scope.totalPolicies.red;
        }
        greatGrandFather.policies = $scope.policies;
        $("html, body").animate(
          { scrollTop: $("#renovacion").offset().top },
          "slow"
        ); //jshint ignore:line
        greatGrandFather.showAndHidePanels(false, false, true);
      }
    }

    $scope.configGraph = function (typeGraph) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/charts/config.chart.html",
        controller: "ConfigChartModalCtrl",
        size: "md",
        resolve: {
          typeGraphic: function () {
            return typeGraph;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    greatGrandFather.changeRenAll = changeRenAll;
    greatGrandFather.show_renewal = true;
    function changeRenAll(par, asc) {
      switch (par) {
        case 1:
          $scope.setPolicyToList(par, asc);
          greatGrandFather.ren_nump_asc = asc;
          greatGrandFather.ren_cont_asc = 0;
          greatGrandFather.ren_subr_asc = 0;
          greatGrandFather.ren_aseg_asc = 0;
          greatGrandFather.ren_vig_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 2:
          $scope.setPolicyToList(par, asc);
          greatGrandFather.ren_cont_asc = asc;
          greatGrandFather.ren_nump_asc = 0;
          greatGrandFather.ren_subr_asc = 0;
          greatGrandFather.ren_aseg_asc = 0;
          greatGrandFather.ren_vig_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 3:
          $scope.setPolicyToList(par, asc);
          greatGrandFather.ren_subr_asc = asc;
          greatGrandFather.ren_nump_asc = 0;
          greatGrandFather.ren_cont_asc = 0;
          greatGrandFather.ren_aseg_asc = 0;
          greatGrandFather.ren_vig_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 4:
          $scope.setPolicyToList(par, asc);
          greatGrandFather.ren_aseg_asc = asc;
          greatGrandFather.ren_cont_asc = 0;
          greatGrandFather.ren_nump_asc = 0;
          greatGrandFather.ren_subr_asc = 0;
          greatGrandFather.ren_vig_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 5:
          $scope.setPolicyToList(par, asc);
          greatGrandFather.ren_vig_asc = asc;
          greatGrandFather.ren_nump_asc = 0;
          greatGrandFather.ren_cont_asc = 0;
          greatGrandFather.ren_subr_asc = 0;
          greatGrandFather.ren_aseg_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 6:
          $scope.setPolicyToList(par, asc);
          greatGrandFather.ren_vig_asc = 0;
          greatGrandFather.ren_nump_asc = 0;
          greatGrandFather.ren_cont_asc = 0;
          greatGrandFather.ren_subr_asc = 0;
          greatGrandFather.ren_aseg_asc = 0;
          greatGrandFather.receipt_aseg_asc = asc;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 7:
          $scope.setPolicyToList(par, asc);
          greatGrandFather.ren_vig_asc = 0;
          greatGrandFather.ren_nump_asc = 0;
          greatGrandFather.ren_cont_asc = 0;
          greatGrandFather.ren_subr_asc = 0;
          greatGrandFather.ren_aseg_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = asc;
          break;
      }
    }
    greatGrandFather.changeSinAll = changeSinAll;
    greatGrandFather.show_sinister = true;
    function changeSinAll(par, asc) {
      switch (par) {
        case 1:
          $scope.setSiniesters(par, asc);
          greatGrandFather.sin_afec_asc = asc;
          greatGrandFather.sin_cont_asc = 0;
          greatGrandFather.sin_aseg_asc = 0;
          greatGrandFather.sin_nump_asc = 0;
          greatGrandFather.sin_nums_asc = 0;
          greatGrandFather.sin_subr_asc = 0;
          greatGrandFather.sin_fecha_asc = 0;
          greatGrandFather.sin_status_asc = 0;
          break;
        case 2:
          $scope.setSiniesters(par, asc);
          greatGrandFather.sin_cont_asc = asc;
          greatGrandFather.sin_afec_asc = 0;
          greatGrandFather.sin_aseg_asc = 0;
          greatGrandFather.sin_nump_asc = 0;
          greatGrandFather.sin_nums_asc = 0;
          greatGrandFather.sin_subr_asc = 0;
          greatGrandFather.sin_fecha_asc = 0;
          greatGrandFather.sin_status_asc = 0;
          break;
        case 3:
          $scope.setSiniesters(par, asc);
          greatGrandFather.sin_aseg_asc = asc;
          greatGrandFather.sin_afec_asc = 0;
          greatGrandFather.sin_cont_asc = 0;
          greatGrandFather.sin_nump_asc = 0;
          greatGrandFather.sin_nums_asc = 0;
          greatGrandFather.sin_subr_asc = 0;
          greatGrandFather.sin_fecha_asc = 0;
          greatGrandFather.sin_status_asc = 0;
          break;
        case 4:
          $scope.setSiniesters(par, asc);
          greatGrandFather.sin_nump_asc = asc;
          greatGrandFather.sin_cont_asc = 0;
          greatGrandFather.sin_afec_asc = 0;
          greatGrandFather.sin_aseg_asc = 0;
          greatGrandFather.sin_nums_asc = 0;
          greatGrandFather.sin_subr_asc = 0;
          greatGrandFather.sin_fecha_asc = 0;
          greatGrandFather.sin_status_asc = 0;
          break;
        case 5:
          $scope.setSiniesters(par, asc);
          greatGrandFather.sin_nums_asc = asc;
          greatGrandFather.sin_afec_asc = 0;
          greatGrandFather.sin_cont_asc = 0;
          greatGrandFather.sin_aseg_asc = 0;
          greatGrandFather.sin_nump_asc = 0;
          greatGrandFather.sin_subr_asc = 0;
          greatGrandFather.sin_fecha_asc = 0;
          greatGrandFather.sin_status_asc = 0;
          break;
        case 6:
          $scope.setSiniesters(par, asc);
          greatGrandFather.sin_nums_asc = 0;
          greatGrandFather.sin_afec_asc = 0;
          greatGrandFather.sin_cont_asc = 0;
          greatGrandFather.sin_aseg_asc = 0;
          greatGrandFather.sin_nump_asc = 0;
          greatGrandFather.sin_subr_asc = asc;
          greatGrandFather.sin_fecha_asc = 0;
          greatGrandFather.sin_status_asc = 0;
          break;
        case 7:
          $scope.setSiniesters(par, asc);
          greatGrandFather.sin_nums_asc = 0;
          greatGrandFather.sin_afec_asc = 0;
          greatGrandFather.sin_cont_asc = 0;
          greatGrandFather.sin_aseg_asc = 0;
          greatGrandFather.sin_nump_asc = 0;
          greatGrandFather.sin_subr_asc = 0;
          greatGrandFather.sin_fecha_asc = asc;
          greatGrandFather.sin_status_asc = 0;
          break;
        case 8:
          $scope.setSiniesters(par, asc);
          greatGrandFather.sin_nums_asc = 0;
          greatGrandFather.sin_afec_asc = 0;
          greatGrandFather.sin_cont_asc = 0;
          greatGrandFather.sin_aseg_asc = 0;
          greatGrandFather.sin_nump_asc = 0;
          greatGrandFather.sin_subr_asc = 0;
          greatGrandFather.sin_fecha_asc = 0;
          greatGrandFather.sin_status_asc = asc;
          break;
      }
    }
    function setPolicyToList(order, asc) {
      greatGrandFather.titleID = null;
      greatGrandFather.title = "";
      greatGrandFather.show_renewal = true;
      greatGrandFather.order = order;
      greatGrandFather.asc = asc;
      greatGrandFather.show_paginationRenewals = false;
      greatGrandFather.show_renovaciones_pagination = false;
      greatGrandFather.cadena = "";
      insuranceService
        .getInsurancesForDash(order, asc)
        .then(function (request) {
          var data = request.data;
          greatGrandFather.config_renovaciones = request.config;

          greatGrandFather.policies = data;
          data.forEach(function (elem) {
            var diff = -1 * moment().diff(moment(elem.end_of_validity), "days"); //jshint ignore:line
            if (diff <= 0) {
              //jshint ignore:line
              $scope.totalPolicies.red.push(elem);
              $scope.data[3] += 1;
              $scope.totalPolicies.size += 1;
            } else if (diff >= 1 && diff <= 20) {
              //jshint ignore:line
              $scope.totalPolicies.orange.push(elem);
              $scope.data[2] += 1;
              $scope.totalPolicies.size += 1;
            } else if (diff >= 21 && diff <= 40) {
              //jshint ignore:line
              $scope.totalPolicies.yellow.push(elem);
              $scope.data[1] += 1;
              $scope.totalPolicies.size += 1;
            } else if (diff >= 41 && diff <= 60) {
              //jshint ignore:line
              $scope.totalPolicies.green.push(elem);
              $scope.data[0] += 1;
              $scope.totalPolicies.size += 1;
            }
          });

          greatGrandFather.show_paginationRenewals = true;
          greatGrandFather.show_renovaciones_pagination = true;
        });

      $("html, body").animate(
        { scrollTop: $("#cobranza").offset().top },
        "slow"
      ); //jshint ignore:line
      greatGrandFather.policies = $scope.totalPolicies.green.concat(
        $scope.totalPolicies.red,
        $scope.totalPolicies.orange,
        $scope.totalPolicies.yellow
      );
      greatGrandFather.showAndHidePanels(false, false, true);
    }
    greatGrandFather.exportDataRenewalAll = exportDataRenewalAll;
    function exportDataRenewalAll(param, cad) {
      var lr = Ladda.create(document.querySelector(".ladda-button2"));
      lr.start();
      if (greatGrandFather.cadena) {
        var params = {
          order: greatGrandFather.order,
          asc: greatGrandFather.asc,
          tipo: "all",
          cadena: greatGrandFather.cadena,
        };
      } else {
        var params = {
          order: greatGrandFather.order,
          asc: greatGrandFather.asc,
          tipo: "all",
        };
      }
      if (param == 3) {
        // httpCall('excel-graficas-polizas/', parType, titleID, title);
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   // var excel_renewal = 'v2/polizas/excel-graficas-renewal/';
        //   var excel_renewal = 'service_reporte-v2-renovacionesDash-excel';
        var excel_renewal = "service_reporte-renovacionesDash-excel";
        $http({
          method: "GET",
          url: url.IP + excel_renewal,
          params: params,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function success(data) {
          if (data.status == 200) {
            lr.stop();
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte_Renovaciones_Dash.xls");
          } else {
            lr.stop();
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al descargar el reporte",
              "error"
            );
          }
        });
      } else {
        lr.stop();
      }
    }

    function setSiniesters(order, asc) {
      greatGrandFather.show_sinister = true;
      greatGrandFather.notas = false;
      greatGrandFather.order = order;
      greatGrandFather.asc = asc;
      greatGrandFather.titleID = 0;
      greatGrandFather.search = false;
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.chart_siniester = 'v2/siniestros/graficas-siniestros/';
      $scope.chart_siniester = "graficas-siniestros/";
      $http({
        method: "GET",
        url: url.IP + $scope.chart_siniester,
        params: { tipo: "all", order: order, asc: asc },
      }).then(
        function success(response) {
          greatGrandFather.sinisters = response.data.results;
          if ((greatGrandFather.sinisters.status = 1)) {
            greatGrandFather.sinisters.statusLabel = "Pendiente";
          } else if ((greatGrandFather.sinisters.status = 2)) {
            greatGrandFather.sinisters.statusLabel = "En trámite";
          } else if ((greatGrandFather.sinisters.status = 3)) {
            greatGrandFather.sinisters.statusLabel = "Completado";
          } else if ((greatGrandFather.sinisters.status = 4)) {
            greatGrandFather.sinisters.statusLabel = "Cancelado";
          } else if ((greatGrandFather.sinisters.status = 5)) {
            greatGrandFather.sinisters.statusLabel = "Rechazado";
          }
          greatGrandFather.sinisterTable = true;
          greatGrandFather.renewalTable = false;
          greatGrandFather.policyTable = false;
          greatGrandFather.coverageTable = false;
          greatGrandFather.config_sinisters = {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          };
          greatGrandFather.show_sinisters_pagination = true;
        },
        function error(e) {
          console.log("ERROR: ", e);
        }
      );
    }
    greatGrandFather.exportDataSinAll = exportDataSinAll;
    function exportDataSinAll(param) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      if (param == 4) {
        var excel_sinister = "service_reporte-siniestrosDash-excel";
        $http({
          method: "GET",
          url: url.IP + excel_sinister,
          params: {
            tipo: "all",
            order: greatGrandFather.order,
            asc: greatGrandFather.asc,
          },
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function success(data) {
          if (data.status == 200) {
            l.stop();
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte_Siniestros_Dash.xls");
          } else {
            l.stop();
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al descargar el reporte",
              "error"
            );
          }
        });
      } else {
        l.stop();
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("EndosoChartCtrl", EndosoChartCtrl);

  EndosoChartCtrl.$inject = [
    "$scope",
    "$rootScope",
    "$state",
    "$uibModal",
    "insuranceService",
  ];

  function EndosoChartCtrl(
    $scope,
    $rootScope,
    $state,
    $uibModal,
    insuranceService
  ) {
    $scope.labels = ["Verde", "Amarillo", "Rojo"];
    $scope.data = [0, 3, 0];
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("ConfigChartModalCtrl", ConfigChartModalCtrl);

  ConfigChartModalCtrl.$inject = [
    "typeGraphic",
    "$uibModalInstance",
    "$scope",
    "dataFactory",
    "SweetAlert",
    "MESSAGES",
  ];

  function ConfigChartModalCtrl(
    typeGraphic,
    $uibModalInstance,
    $scope,
    dataFactory,
    SweetAlert,
    MESSAGES
  ) {
    var vm = this;

    activate();
    get_info_graphic();

    $scope.config = {};
    function activate() {
      $scope.typeGraphic = typeGraphic;
      if ($scope.typeGraphic == 1) {
        $scope.typeGraph = "OTs";
      } else if ($scope.typeGraphic == 2) {
        $scope.typeGraph = "Cobranza";
      } else if ($scope.typeGraphic == 3) {
        $scope.typeGraph = "Renovaciones";
      } else if ($scope.typeGraphic == 4) {
        $scope.typeGraph = "Siniestros";
      } else if ($scope.typeGraphic == 5) {
        $scope.typeGraph = "Tareas";
      } else {
        $scope.typeGraph = "Cotizaciones";
      }

      dataFactory
        .get("get-specific-log", {
          model: 19,
          associated_id: $scope.typeGraphic,
        })
        .then(function success(response) {
          $scope.logs = response.data;
        });
    }

    function get_info_graphic() {
      if ($scope.typeGraphic == 2) {
        var data = {
          type_graphic: $scope.typeGraphic,
        };
        dataFactory.get("graphic/", data).then(function success(response) {
          $scope.config = response.data.results[0];
          if (!$scope.config) {
            $scope.config = { option_filter: 2 };
          }
        });
      }
      if ($scope.typeGraphic == 5) {
        var data = {
          type_graphic: 5,
        };
        dataFactory.get("graphic/", data).then(function success(response) {
          $scope.config = response.data.results[0];
          if (!$scope.config) {
            $scope.config = { option_filter: 3 };
          }
        });
      }
      if ($scope.typeGraphic == 6) {
        var data = {
          type_graphic: 6,
        };
        dataFactory.get("graphic/", data).then(function success(response) {
          $scope.config = response.data.results[0];
          if (!$scope.config) {
            $scope.config = { option_filter: 3 };
          }
        });
      }
    }

    $scope.close = function () {
      $uibModalInstance.dismiss("cancel");
    };

    $scope.showLog = function () {
      if ($scope.showIt) {
        $scope.showIt = false;
      } else {
        $scope.showIt = true;
      }
    };

    $scope.saveConfig = function (config) {
      config.type_graphic = $scope.typeGraphic;
      if ($scope.typeGraphic == 1 || $scope.typeGraphic == 4) {
        config.red = 1000;
      } else if (
        $scope.typeGraphic == 2 ||
        $scope.typeGraphic == 3 ||
        $scope.typeGraphic == 5
      ) {
        config.red = 0;
      }
      dataFactory.post("graphic/", config).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          SweetAlert.swal("Hecho", MESSAGES.OK.CONFIGSAVED, "success");
          $uibModalInstance.dismiss("cancel");
          var params = {
            model: 19,
            event: "POST",
            associated_id: $scope.typeGraphic,
            identifier: "creó una configuración para la gráfica.",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
        } else {
          SweetAlert.swal("Error", MESSAGES.ERROR.ERROR, "error");
        }
      });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("CobranzaChartCtrl", CobranzaChartCtrl);

  CobranzaChartCtrl.$inject = [
    "$scope",
    "$rootScope",
    "$state",
    "$uibModal",
    "receiptService",
    "$http",
    "url",
    "exportFactory",
    "$sessionStorage",
  ];

  function CobranzaChartCtrl(
    $scope,
    $rootScope,
    $state,
    $uibModal,
    receiptService,
    $http,
    url,
    exportFactory,
    $sessionStorage
  ) {
    // Conect functions with main.controller
    var greatGrandFather = $scope.$parent.$parent.$parent.main;

    $scope.setCobranzasToList = setCobranzasToList;

    $scope.labels = [
      "En tiempo",
      "Se acerca su vencimiento",
      "Gestionar cobranza urgente",
      "Recibos vencidos",
    ];
    $scope.data = [0, 0, 0, 0];
    $scope.chartEvent = chartEvent;

    $scope.totalReceipts = {
      size: 0,
      collection: [],
      red: [],
      orange: [],
      yellow: [],
      green: [],
    };

    $scope.receipts = [];

    activate();

    function verifyChildren(elem, data) {
      for (var i = 0; i < data.length; i++) {
        var recibo = data[i];
        if (elem.id == recibo.rp_owner_id) {
          if ((recibo.status == 4 || recibo.status == 3) && recibo.isActive) {
            return true;
          }
        }
      }
      if (elem.status == 4 || elem.status == 3) {
        return true;
      }
      return false;
    }

    $scope.configGraph = function (typeGraph) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/charts/config.chart.html",
        controller: "ConfigChartModalCtrl",
        size: "md",
        resolve: {
          typeGraphic: function () {
            return typeGraph;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    function activate() {}

    function chartEvent(points) {
      if (points.length > 0) {
        if (points[0].label === $scope.labels[0]) {
          $scope.receipts = $scope.totalReceipts.green;
        } else if (points[0].label === $scope.labels[1]) {
          $scope.receipts = $scope.totalReceipts.yellow;
        } else if (points[0].label === $scope.labels[2]) {
          $scope.receipts = $scope.totalReceipts.orange;
        } else if (points[0].label === $scope.labels[3]) {
          $scope.receipts = $scope.totalReceipts.red;
        }
        greatGrandFather.receipts = $scope.receipts;

        $("html, body").animate(
          { scrollTop: $("#cobranza").offset().top },
          "fast"
        ); //jshint ignore:line
        greatGrandFather.showAndHidePanels(false, true, false);
      }
    }

    function updateReceupt(receiptUpdated) {
      var flag = false;
      $scope.totalReceipts.green.forEach(function (receipt, index) {
        if (receipt.id == receiptUpdated.id) {
          $scope.totalReceipts.green.splice(index, 1);
          flag = true;
        }
      });

      if (!flag) {
        $scope.totalReceipts.yellow.forEach(function (receipt, index) {
          if (receipt.id == receiptUpdated.id) {
            $scope.totalReceipts.yellow.splice(index, 1);
            flag = true;
          }
        });
      }

      if (!flag) {
        $scope.totalReceipts.orange.forEach(function (receipt, index) {
          if (receipt.id == receiptUpdated.id) {
            $scope.totalReceipts.orange.splice(index, 1);
            flag = true;
          }
        });
      }

      if (!flag) {
        $scope.totalReceipts.red.forEach(function (receipt, index) {
          if (receipt.id == receiptUpdated.id) {
            $scope.totalReceipts.red.splice(index, 1);
            flag = true;
          }
        });
      }
    }
    greatGrandFather.changeReceiptAll = changeReceiptAll;
    greatGrandFather.show_cobranza = true;
    function changeReceiptAll(par, asc) {
      switch (par) {
        case 1:
          $scope.setCobranzasToList(par, asc);
          greatGrandFather.receipt_num_asc = asc;
          greatGrandFather.receipt_cont_asc = 0;
          greatGrandFather.receipt_nump_asc = 0;
          greatGrandFather.receipt_vig_asc = 0;
          greatGrandFather.receipt_subr_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 2:
          $scope.setCobranzasToList(par, asc);
          greatGrandFather.receipt_cont_asc = asc;
          greatGrandFather.receipt_num_asc = 0;
          greatGrandFather.receipt_nump_asc = 0;
          greatGrandFather.receipt_vig_asc = 0;
          greatGrandFather.receipt_subr_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 3:
          $scope.setCobranzasToList(par, asc);
          greatGrandFather.receipt_nump_asc = asc;
          greatGrandFather.receipt_num_asc = 0;
          greatGrandFather.receipt_cont_asc = 0;
          greatGrandFather.receipt_vig_asc = 0;
          greatGrandFather.receipt_subr_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 4:
          $scope.setCobranzasToList(par, asc);
          greatGrandFather.receipt_vig_asc = asc;
          greatGrandFather.receipt_cont_asc = 0;
          greatGrandFather.receipt_num_asc = 0;
          greatGrandFather.receipt_nump_asc = 0;
          greatGrandFather.receipt_subr_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 5:
          $scope.setCobranzasToList(par, asc);
          greatGrandFather.receipt_subr_asc = asc;
          greatGrandFather.receipt_num_asc = 0;
          greatGrandFather.receipt_cont_asc = 0;
          greatGrandFather.receipt_nump_asc = 0;
          greatGrandFather.receipt_vig_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 6:
          $scope.setCobranzasToList(par, asc);
          greatGrandFather.receipt_subr_asc = 0;
          greatGrandFather.receipt_num_asc = 0;
          greatGrandFather.receipt_cont_asc = 0;
          greatGrandFather.receipt_nump_asc = 0;
          greatGrandFather.receipt_vig_asc = 0;
          greatGrandFather.receipt_aseg_asc = asc;
          greatGrandFather.receipt_venc_asc = 0;
          break;
        case 7:
          $scope.setCobranzasToList(par, asc);
          greatGrandFather.receipt_subr_asc = 0;
          greatGrandFather.receipt_num_asc = 0;
          greatGrandFather.receipt_cont_asc = 0;
          greatGrandFather.receipt_nump_asc = 0;
          greatGrandFather.receipt_vig_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = asc;
          break;
        case 8:
          $scope.setCobranzasToList(par, asc);
          greatGrandFather.receipt_subr_asc = 0;
          greatGrandFather.receipt_num_asc = 0;
          greatGrandFather.receipt_cont_asc = 0;
          greatGrandFather.receipt_nump_asc = 0;
          greatGrandFather.receipt_vig_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          greatGrandFather.receipt_pneta = asc;
          break;
        case 13:
          $scope.setCobranzasToList(par, asc);
          greatGrandFather.receipt_subr_asc = 0;
          greatGrandFather.receipt_num_asc = 0;
          greatGrandFather.receipt_cont_asc = 0;
          greatGrandFather.receipt_nump_asc = 0;
          greatGrandFather.receipt_vig_asc = 0;
          greatGrandFather.receipt_aseg_asc = 0;
          greatGrandFather.receipt_venc_asc = 0;
          greatGrandFather.receipt_pneta = 0;
          greatGrandFather.receipt_promesa_pago = asc;
          break;
      }
    }
    function setCobranzasToList(order, asc) {
      greatGrandFather.show_binnacle_receipt = false;
      greatGrandFather.show_cobranza = true;
      greatGrandFather.order = order;
      greatGrandFather.asc = asc;
      greatGrandFather.show_paginationReceipts = false;
      greatGrandFather.show_receipts_pagination = false;
      greatGrandFather.parType = "total";
      receiptService.getDashReceipts(order, asc).then(function (request) {
        var data = request.data;
        greatGrandFather.receipts = data;
        for (var i = 0; i < greatGrandFather.receipts.length; i++) {
          greatGrandFather.receipts[i].receipt_type =
            greatGrandFather.receipts[i].receipt_type == 1
              ? "Póliza"
              : greatGrandFather.receipts[i].receipt_type == 2
              ? "Endoso"
              : "Nota Crédito/Endoso";
          if (greatGrandFather.receipts[i].poliza) {
            greatGrandFather.receipts[i].poliza.status =
              greatGrandFather.receipts[i].poliza.status == 1
                ? "En trámite"
                : greatGrandFather.receipts[i].poliza.status == 2
                ? "OT Cancelada"
                : greatGrandFather.receipts[i].poliza.status == 10
                ? "Por Iniciar"
                : greatGrandFather.receipts[i].poliza.status == 11
                ? "Cancelada"
                : greatGrandFather.receipts[i].poliza.status == 12
                ? "Renovada"
                : greatGrandFather.receipts[i].poliza.status == 13
                ? "Vencida"
                : greatGrandFather.receipts[i].poliza.status == 14
                ? "Vigente"
                : "Vigente";
          } else if (greatGrandFather.receipts[i].fianza) {
            greatGrandFather.receipts[i].fianza.status =
              greatGrandFather.receipts[i].fianza.status == 1
                ? "En trámite"
                : greatGrandFather.receipts[i].fianza.status == 2
                ? "OT Cancelada"
                : greatGrandFather.receipts[i].fianza.status == 10
                ? "Por Iniciar"
                : greatGrandFather.receipts[i].fianza.status == 11
                ? "Cancelada"
                : greatGrandFather.receipts[i].fianza.status == 12
                ? "Anulada"
                : greatGrandFather.receipts[i].fianza.status == 13
                ? "Rechazada"
                : greatGrandFather.receipts[i].fianza.status == 15
                ? "Renovada"
                : "Vigente";
          }
          // greatGrandFather.receipts[i].poliza.status = greatGrandFather.receipts[i].poliza.status == 1 ? "En trámite" :
          // greatGrandFather.receipts[i].poliza.status == 2 ? "OT Cancelada" : greatGrandFather.receipts[i].poliza.status == 10 ? "Por Iniciar" :
          // greatGrandFather.receipts[i].poliza.status == 11 ? "Cancelada" : greatGrandFather.receipts[i].poliza.status == 12 ? "Renovada" :
          // greatGrandFather.receipts[i].poliza.status == 13 ? "Vencida" : greatGrandFather.receipts[i].poliza.status == 15 ? "No renovada" : "Vigente";
          if (greatGrandFather.receipts[i].status == 1) {
            greatGrandFather.receipts[i].status = "Pagado";
          } else if (greatGrandFather.receipts[i].status == 2) {
            greatGrandFather.receipts[i].status = "Cancelado";
          } else if (greatGrandFather.receipts[i].status == 3) {
            greatGrandFather.receipts[i].status = "Prorrogado";
          } else if (greatGrandFather.receipts[i].status == 4) {
            greatGrandFather.receipts[i].status = "Pendiente de pago";
          } else if (greatGrandFather.receipts[i].status == 5) {
            greatGrandFather.receipts[i].status = "Liquidado";
          } else if (greatGrandFather.receipts[i].status == 6) {
            greatGrandFather.receipts[i].status = "Conciliado";
          } else if (greatGrandFather.receipts[i].status == 7) {
            greatGrandFather.receipts[i].status = "Cerrado";
          } else if (greatGrandFather.receipts[i].status == 0) {
            greatGrandFather.receipts[i].status = "Desactivado";
          } else if (greatGrandFather.receipts[i].status == 9) {
            greatGrandFather.receipts[i].status = "Pago Parcial";
          } else {
            greatGrandFather.receipts[i].status = "Sin estatus";
          }
          if (greatGrandFather.receipts[i].poliza) {
            if (greatGrandFather.receipts[i].poliza.forma_de_pago == 1) {
              greatGrandFather.receipts[i].poliza.forma_de_pago = "Mensual";
            } else if (greatGrandFather.receipts[i].poliza.forma_de_pago == 2) {
              greatGrandFather.receipts[i].poliza.forma_de_pago = "Bimestral";
            } else if (greatGrandFather.receipts[i].poliza.forma_de_pago == 3) {
              greatGrandFather.receipts[i].poliza.forma_de_pago = "Trimestral";
            } else if (greatGrandFather.receipts[i].poliza.forma_de_pago == 5) {
              greatGrandFather.receipts[i].poliza.forma_de_pago = "Contado";
            } else if (greatGrandFather.receipts[i].poliza.forma_de_pago == 6) {
              greatGrandFather.receipts[i].poliza.forma_de_pago = "Semestral";
            } else if (
              greatGrandFather.receipts[i].poliza.forma_de_pago == 12
            ) {
              greatGrandFather.receipts[i].poliza.forma_de_pago = "Anual";
            } else {
              greatGrandFather.receipts[i].poliza.forma_de_pago = "Sin estatus";
            }
          }
        }
        greatGrandFather.config_receipts = request.config;
        if (request) {
          if (request.data) {
            request.data.forEach(function (rec) {
              greatGrandFather.recibos_a_pagar.forEach(function (rec_w) {
                if (rec.id == rec_w.id) {
                  if (rec) {
                    rec.toPay = true;
                  } else {
                  }
                }
              });
            });
          }
        }
        // $rootScope.show_receipts_pagination = true;

        data.forEach(function (elem) {
          if (verifyChildren(elem, data)) {
            var diff = -1 * moment().diff(moment(elem.fecha_inicio), "days"); //jshint ignore:line
            if (elem.recibo_numero == 1) {
              var diff2 = diff + 30;
            } else {
              var diff2 = diff;
            }

            if (diff2 <= 45 && diff2 >= 31) {
              //jshint ignore:line
              $scope.totalReceipts.green.push(elem);
              $scope.data[0] += 1;
              $scope.totalReceipts.size += 1;
            } else if (diff2 <= 30 && diff2 >= 16) {
              //jshint ignore:line
              $scope.totalReceipts.yellow.push(elem);
              $scope.data[1] += 1;
              $scope.totalReceipts.size += 1;
            } else if (diff2 <= 15 && diff2 >= 1) {
              //jshint ignore:line
              $scope.totalReceipts.orange.push(elem);
              $scope.data[2] += 1;
              $scope.totalReceipts.size += 1;
            } else if (diff2 <= 0) {
              //jshint ignore:line
              $scope.totalReceipts.red.push(elem);
              $scope.data[3] += 1;
              $scope.totalReceipts.size += 1;
            }
          }
        });

        greatGrandFather.show_paginationReceipts = true;
        greatGrandFather.show_receipts_pagination = true;
      });

      $("html, body").animate(
        { scrollTop: $("#cobranza").offset().top },
        "slow"
      ); //jshint ignore:line
      greatGrandFather.receipts = $scope.totalReceipts.green.concat(
        $scope.totalReceipts.red,
        $scope.totalReceipts.orange,
        $scope.totalReceipts.yellow
      );
      greatGrandFather.showAndHidePanels(false, true, false);
      greatGrandFather.titleID = null;
      greatGrandFather.title = "";
    }
    greatGrandFather.exportDataReceiptsAll = exportDataReceiptsAll;
    function exportDataReceiptsAll(param) {
      var lrc = Ladda.create(document.querySelector(".ladda-button3"));
      lrc.start();
      greatGrandFather.show_cobranza = true;

      $scope.infoUser = $sessionStorage.infoUser;
      // if (!$scope.infoUser.superuser && $scope.infoUser.staff ) {
      //   // $scope.url_go = 'v2/recibos/excel-graficas-recibos-all/'; //v2/endosos/reporte-endosos/';
      //   $scope.url_go = 'service_reporte-v2-recibosDash-excel'
      $scope.url_go = "service_reporte-recibosDash-excel";
      if (param == 2) {
        // httpCall('excel-graficas-polizas/', parType, titleID, title);
        $http({
          method: "GET",
          url: url.IP + $scope.url_go, //'v2/recibos/excel-graficas-recibos-all/',
          params: {
            order: greatGrandFather.order,
            asc: greatGrandFather.asc,
          },
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            lrc.stop();
            var blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Dash_Cobranza_Todos.xls");
          } else {
            lrc.stop();
          }
        });
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("CedulaController", CedulaController);

  CedulaController.$inject = [
    "$localStorage",
    "$scope",
    "dataFactory",
    "datesFactory",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "exportFactory",
  ];

  function CedulaController(
    $localStorage,
    $scope,
    dataFactory,
    datesFactory,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    exportFactory
  ) {
    var vm = this;
    $scope.showQuotation = false;
    $localStorage["cedula"] = $localStorage["cedula"]
      ? $localStorage["cedula"]
      : {};
    $scope.showInfoQuotation = false;
    $scope.quotationNew = [
      {
        contratante: {},
      },
    ];

    $scope.createQuotation = function () {
      $scope.showQuotation = true;

      $localStorage.cedula["showQuotation"] = true;
    };

    $scope.closeQuotation = function () {
      $scope.showQuotation = false;
      $localStorage.cedula["showQuotation"] = false;
      vm.form = [{}];
      $localStorage.cedula["form"] = vm.form;
    };

    $scope.change = function () {
      $localStorage.cedula["form"] = vm.form;
    };

    activate();
    function activate() {
      $scope.showQuotation =
        $localStorage.cedula && $localStorage.cedula["showQuotation"]
          ? $localStorage.cedula["showQuotation"]
          : false;
      vm.form =
        $localStorage.cedula && $localStorage.cedula["form"]
          ? $localStorage.cedula["form"]
          : vm.form;
      dataFactory.get("cedula/").then(function success(response) {
        $scope.quotations = response.data.results;
        vm.form = {};
      });
    }

    $scope.saveCedula = function (form) {
      vm.form.expiracion = new Date(datesFactory.toDate(vm.form.exp_date));
      dataFactory.post("cedula/", vm.form).then(function success(response) {
        vm.form = {};
        $scope.quotations.push(response.data);
        SweetAlert.swal("¡Listo!", "Se ha guardado la cédula", "success");
        $localStorage.cedula = {};
        $scope.closeQuotation();
        activate();
      });
    };
    $scope.getReportCedula = function (form) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $http({
        method: "POST",
        // url: url.IP +'reporte-cedula/',
        url: url.IP + "service_reporte-cedula-excel",
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function (data) {
          if (data.status == 200) {
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Cédulas.xls");
            l.stop();
          } else {
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al descargar el reporte",
              "error"
            );
            l.stop();
          }
        })
        .catch(function (e) {
          console.log("e", e);
          l.stop();
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("CarpetasAdjuntosCtrl", CarpetasAdjuntosCtrl);

  CarpetasAdjuntosCtrl.$inject = [
    "$scope",
    "FileUploader",
    "$timeout",
    "toaster",
    "MESSAGES",
    "$sessionStorage",
    "$http",
    "url",
    "$state",
    "SweetAlert",
    "$stateParams",
    "dataFactory",
  ];

  function CarpetasAdjuntosCtrl(
    $scope,
    FileUploader,
    $timeout,
    toaster,
    MESSAGES,
    $sessionStorage,
    $http,
    url,
    $state,
    SweetAlert,
    $stateParams,
    dataFactory
  ) {
    var vm = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.orgName = usr.org;

    $scope.carpeta = {
      nombre: "",
      id: "",
    };
    $scope.carpetasList = [];
    $scope.archivos_general = [];
    $scope.isSeller = [];
    $scope.nuevacarpeta = false;
    $scope.files_pagination = false;
    $scope.archivosGenerales = false;
    $scope.filesGenerales = function (u) {
      $scope.archivosGenerales = u;
      angular.forEach($scope.carpetasList, function (carpeta) {
        carpeta.expanded = false;
      });
    };
    $scope.showContainerFiles = function (value) {
      $scope.bell = value;
      if (value == 1) {
        $scope.showFiles = false;
      } else {
        $scope.showFiles = true;
        SweetAlert.swal("Imagen", MESSAGES.INFO.INFOBANNER, "info");
      }
    };
    $scope.nuevaCarpeta = function (val, objeto) {
      $scope.archivosGenerales = false;
      $scope.carpetasList = [];
      $scope.nuevacarpeta = val;
      if ($scope.uploader && $scope.uploader.queue) {
        $scope.uploader.queue = [];
      }
      if (objeto) {
        $scope.carpeta = objeto;
        dataFactory
          .get("adjuntointerno-carpeta/", { carpeta: objeto.id })
          .then(function success(response) {
            $scope.carpeta.archivos = response.data.results;
          })
          .catch(function (e) {
            console.log("e archivos by carp**", e);
          });
      }
      if (!val) {
        obtenerCarpetas();
        $scope.carpeta = {
          nombre: "",
          id: "",
        };
      }
    };
    obtenerCarpetas();
    function obtenerCarpetas() {
      $scope.carpetasList = [];
      $scope.archivos_general = [];
      //
      dataFactory
        .get("carpeta/")
        .then(function success(response) {
          if (response.data.length) {
            $scope.carpetasList = response.data;
            $scope.carpetasList.forEach(function (item) {
              item.isSeller = false;
              item.expanded = false;
              item.archivos = []; // si quieres iniciar también el array de archivos
            });
          }
        })
        .catch(function (e) {
          console.log("e lista**", e);
        });
      dataFactory
        .get("adjuntointerno-libre/")
        .then(function success(response) {
          if (response.data.results.length) {
            $scope.archivos_general = response.data.results;

            if (response.data.count > 10) {
              $scope.obtenerPaginacion(response.data, 1);
              $scope.files_pagination = true;
            }
          }
        })
        .catch(function (e) {
          console.log("e lista**", e);
        });
    }
    function obtenerLibres() {
      dataFactory
        .get("adjuntointerno-libre/")
        .then(function success(response) {
          if (response.data.results.length) {
            $scope.archivos_general = response.data.results;

            if (response.data.count > 10) {
              $scope.obtenerPaginacion(response.data, 1);
              $scope.files_pagination = true;
            }
          }
        })
        .catch(function (e) {
          console.log("e lista**", e);
        });
    }
    $scope.eliminarCarpeta = function (val, objeto) {
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      if (objeto.url) {
        SweetAlert.swal(
          {
            title: "Eliminar la Carpeta: " + objeto.nombre,
            text: objeto.nombre + "\n",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http
                .delete(objeto.url)
                .then(function success(response) {
                  if (response.status == 204) {
                    l.stop();
                    obtenerCarpetas();
                    SweetAlert.swal(
                      "¡Listo!",
                      "Se ha eliminado definitivamente la Carpeta: " +
                        objeto.nombre,
                      "success"
                    );
                  } else {
                    l.stop();
                    SweetAlert.swal(
                      "¡Error!",
                      response.data.detail + "\n" + objeto.nombre,
                      "error"
                    );
                  }
                })
                .catch(function (e) {
                  console.log("e", e);
                });
            }
          }
        );
      }
    };
    $scope.obtenerArchivosCarpetas = function (idcarpet, item) {
      dataFactory
        .get("adjuntointerno-carpeta/", { carpeta: idcarpet })
        .then(function success(response) {
          item.archivos = response.data.results;
          if (response.data.count > 10) {
            $scope.obtenerPaginacionCarpeta(response.data, 1);
            $scope.files_paginationCarpeta = true;
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e archivos by carp**", e);
        });
    };
    $scope.crearCarpeta = function () {
      var l = Ladda.create(document.querySelector(".ladda-button1"));
      l.start();
      if ($scope.carpeta && $scope.carpeta.id == "") {
        $http({
          method: "POST",
          url: url.IP + "carpeta/",
          data: $scope.carpeta,
        }).then(function success(response) {
          if (response.status == 201) {
            l.stop();
            obtenerCarpetas();
            uploadFiles(response.data, true);
            $scope.nuevacarpeta = false;
            $scope.carpeta = {
              nombre: "",
              id: "",
            };
          }
        });
      } else {
        update();
      }
    };

    function update() {
      var l = Ladda.create(document.querySelector(".ladda-button1"));
      l.start();
      $http({
        method: "PATCH",
        url: $scope.carpeta.url,
        data: $scope.carpeta,
      })
        .then(function success(response) {
          if (response.status == 200) {
            obtenerCarpetas();
            uploadFiles(response.data, true);
            $scope.nuevacarpeta = false;
            l.stop();
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e update**", e);
        });
    }
    $scope.files_paginationCarpeta = false;
    $scope.toggleArchivos = function (item, idx) {
      $scope.archivosGenerales = false;
      angular.forEach($scope.carpetasList, function (carpeta) {
        if (carpeta !== item) {
          carpeta.expanded = false;
        }
      });
      item.expanded = !item.expanded;
      dataFactory
        .get("adjuntointerno-carpeta/", { carpeta: item.id })
        .then(function success(response) {
          item.archivos = response.data.results;
          if (response.data.count > 10) {
            $scope.obtenerPaginacionCarpeta(response.data, 1);
            $scope.files_paginationCarpeta = true;
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("e files**", e);
        });
    };
    $scope.deleteFile = function (file, container) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este archivo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http({
              method: "GET",
              url: url.IP + "delete-file-carpeta",
              params: {
                file_id: file.id,
              },
            }).then(function success(response) {
              if (response.data.status == 204) {
                SweetAlert.swal(
                  "¡Eliminado!",
                  "El archivo fue eliminado.",
                  "success"
                );
                container.splice(container.indexOf(file), 1);
              }
            });
          }
        }
      );
    };
    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        archivo: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].carpeta =
        $scope.userInfo && $scope.userInfo.id ? $scope.userInfo.id : null;
      if (
        !item.formData[0].carpeta ||
        item.formData[0].carpeta === "undefined"
      ) {
        delete item.formData[0].carpeta;
      }
    };

    vm.uploadFiles = uploadFiles;
    function uploadFiles(carpetasId, encarpeta) {
      try {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
      } catch (u) {
        var l = Ladda.create(document.querySelector(".ladda-button1"));
        l.start();
      }
      $scope.userInfo = carpetasId;
      $scope.userInfo.url = $scope.uploader.url =
        url.IP +
        "carpeta/" +
        carpetasId.id +
        "/archivos/?org=" +
        $scope.orgName;

      $scope.files = [];
      $scope.uploader.uploadAll();
      $scope.uploader.onCompleteAll = function () {
        $scope.uploader.clearQueue();
        if (encarpeta) {
          $scope.obtenerArchivosCarpetas(carpetasId.id, carpetasId);
        }
        l.stop();
      };
    }
    vm.uploadFilesFree = uploadFilesFree;
    function uploadFilesFree(carpetasId, encarpeta) {
      var l = Ladda.create(document.querySelector(".ladda-button3"));
      l.start();
      $scope.userInfo = carpetasId;
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "adjuntointerno-libre/?org=" + $scope.orgName;

      $scope.files = [];
      $scope.uploader.uploadAll();
      $scope.uploader.onCompleteAll = function () {
        l.stop();
        $scope.uploader.clearQueue();
        obtenerLibres();
        if (encarpeta) {
          $scope.obtenerArchivosCarpetas(carpetasId.id, carpetasId);
        }
      };
    }
    $scope.saveFile = function (file) {
      var urls =
        file.url + "?carpeta=" + file.carpeta + "&org=" + $scope.orgName;
      if (urls == undefined) {
        urls = url.IP + "carpeta/" + file.owner + "/archivos/" + file.id;
      }
      $http.patch(urls, { nombre: file.nombre, sensible: file.sensible });
    };
    // pagianción
    vm.siguientesRegistros = siguientesRegistros;
    function siguientesRegistros(pagina, page) {
      dataFactory
        .get("adjuntointerno-libre/?page=" + page + "&org=" + $scope.orgName)
        .then(function success(response) {
          if (response.data.results.length) {
            $scope.archivos_general = response.data.results;
            $scope.obtenerPaginacion(response.data, page ? page : 1);
          }
        })
        .catch(function (e) {
          console.log("e lista**", e);
        });
    }
    vm.siguientesRegistrosFCarpeta = siguientesRegistrosFCarpeta;
    function siguientesRegistrosFCarpeta(item, page) {
      dataFactory
        .get(
          "adjuntointerno-carpeta/?page=" +
            page +
            "&org=" +
            $scope.orgName +
            "&carpeta=" +
            item.id
        )
        .then(function success(response) {
          if (response.data.results.length) {
            item.archivos = response.data.results;
            $scope.obtenerPaginacionCarpeta(response.data, page ? page : 1);
          }
        })
        .catch(function (e) {
          console.log("e lista**", e);
        });
    }
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (pagesdata, pagina) {
      $scope.paginacion = {
        count: pagesdata["count"],
        previous: pagesdata["previous"],
        next: pagesdata["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina) {
      $scope.pagina = pagina;
      siguientesRegistros(1, pagina);
    };

    $scope.anteriorPagina = function () {
      if ($scope.paginacion["paginaActual"] > 1) {
        $scope.pagina = $scope.paginacion["paginaActual"] - 1;
        siguientesRegistros(
          $scope.pagina,
          $scope.paginacion["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePagina = function () {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $scope.pagina = $scope.paginacion["paginaActual"] + 1;
        siguientesRegistros(
          $scope.pagina,
          $scope.paginacion["paginaActual"] + 1
        );
      }
    };
    // nueva paginación inicial carpeta
    $scope.obtenerPaginacionCarpeta = function (pagesdata, pagina) {
      $scope.paginacionCarpeta = {
        count: pagesdata["count"],
        previous: pagesdata["previous"],
        next: pagesdata["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginasCarpeta = Math.ceil(
        $scope.paginacionCarpeta["count"] / 10
      );
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginasCarpeta; i++) {
        if ($scope.paginacionCarpeta["totalPaginas"].length <= 5) {
          $scope.paginacionCarpeta["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacionCarpeta["totalPaginas"].length > 5) {
        $scope.paginacionCarpeta["paginaInicio"] =
          $scope.paginacionCarpeta["totalPaginas"] - 5;
      } else {
        $scope.paginacionCarpeta["paginaInicio"] = 1;
      }
      if ($scope.paginacionCarpeta["totalPaginas"].length > 5) {
        $scope.paginacionCarpeta["paginaFin"] = 5;
      } else {
        $scope.paginacionCarpeta["paginaFin"] =
          $scope.paginacionCarpeta["totalPaginas"].length;
      }
    };

    $scope.selecionPaginaCarpeta = function (pagina, item) {
      $scope.paginaCarpeta = pagina;
      siguientesRegistrosFCarpeta(item, pagina);
    };

    $scope.anteriorPaginaCarpeta = function (pag, item) {
      if ($scope.paginacionCarpeta["paginaActual"] > 1) {
        $scope.paginaCarpeta = $scope.paginacionCarpeta["paginaActual"] - 1;
        siguientesRegistrosFCarpeta(
          item,
          $scope.paginacionCarpeta["paginaActual"] - 1
        );
      }
    };

    $scope.siguientePaginaCarpeta = function (pag, item) {
      var numeroPaginas = Math.ceil($scope.paginacionCarpeta["count"] / 10);
      if (numeroPaginas > $scope.paginacionCarpeta["paginaActual"]) {
        $scope.paginaCarpeta = $scope.paginacionCarpeta["paginaActual"] + 1;
        siguientesRegistrosFCarpeta(
          item,
          $scope.paginacionCarpeta["paginaActual"] + 1
        );
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("cargaRecibosCtrl", cargaRecibosCtrl);

  cargaRecibosCtrl.$inject = [
    "$sessionStorage",
    "$rootScope",
    "$scope",
    "$http",
    "url",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$state",
  ];

  function cargaRecibosCtrl(
    $sessionStorage,
    $rootScope,
    $scope,
    $http,
    url,
    SweetAlert,
    FileUploader,
    datesFactory,
    $state
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;

    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.certifcados = [];
    $scope.loader = false;

    $scope.fileNameChanged = function (ele) {
      var lo = Ladda.create(document.querySelector(".ladda-button2"));
      lo.start();
      lo.stop();
    };

    $scope.validateExcel = function (param) {
      var lo = Ladda.create(document.querySelector(".ladda-button2"));
      lo.start();
      lo.stop();
      $scope.loader = true;
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.RECIBOS) {
        $scope.excelJson = param.RECIBOS;
        $scope.excelJson.forEach(function (item) {
          if (!item.ID_RECIBO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ID_RECIBO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.SERIE_RECIBO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna SERIE_RECIBO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.POLIZA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna POLIZA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.INICIO_VIGENCIA_POLIZA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna INICIO_VIGENCIA_POLIZA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.ENDOSO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ENDOSO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.NOMBRE_ARCHIVO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NOMBRE_ARCHIVO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
        });

        if (!flagCertificate) {
          $scope.selectedPolices = param;
          $scope.addViews(0);
          $scope.loader = false;
        }
      } else {
        $scope.loader = false;
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.changeViews = function () {
      $scope.loader = true;
      var lo = Ladda.create(document.querySelector(".ladda-button2"));
      lo.start();
      lo.stop();
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
          $scope.loader = false;
          lo.stop();
        }
      });
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.saveContractors = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.certifcados = [];
      $scope.loader = true;
      $scope.selectedPolices.CONTRATANTES.forEach(function (item) {
        if (item.TIPO_DIRECCION) {
          $scope.addresstipo = vm.address_type[item.TIPO_DIRECCION];
        }
        if (item.TIPO == 1 && item.APELLIDO_MATERNO) {
          var apmat = item.APELLIDO_MATERNO ? item.APELLIDO_MATERNO : "";
        } else {
          var apmat = "";
        }
        $scope.fullname =
          item.TIPO == 1
            ? item.NOMBRE + " " + item.APELLIDO_PATERNO + " " + apmat
            : item.NOMBRE_EMPRESA;
        var dataPolicy = {
          alta_hacienda: false,
          aviso_privacidad: false,
          birth_date: datesFactory.toDate(
            item.TIPO == 1 ? item.FECHA_NACIMIENTO : item.FECHA_CONSTITUCION
          ),
          boleta_predial: false,
          cambio_domicilio_hacienda: false,
          card_official_identification: false,
          carta_buro: false,
          carta_nombramiento: false,
          cellule: item.CELULA,
          certificado_gravamen: false,
          classification: item.CLASIFICACION,
          comprobante_inscripcion_firma: false,
          constitutive_act: false,
          contrato_multiple_afianzadora: false,
          CURP: false,
          curriculo: false,
          declaracion_anual: false,
          description: item.OBSERVACIONES,
          email: item.CORREO,
          escritura_inmueble: false,
          estados_financieros_anuales: false,
          estados_financieros_parciales: false,
          entrevista_afianzadora: false,
          fiscal_power: false,
          group: item.GRUPO,
          groupinglevel: item.SUBSUBAGRUPACION
            ? item.SUBSUBAGRUPACION
            : item.SUBAGRUPACION
            ? item.SUBAGRUPACION
            : item.AGRUPACION,
          has_bound_solidarity: false,
          modifications_constitutive_act: false,
          only_sureties: false,
          phone_number: item.TELEFONO,
          protocolizaciones: false,
          recibos_nomina: false,
          responsable: item.RESPONSABLE,
          rfc: item.RFC,
          rfc_document: false,
          signed_format_ic: false,
          sucursal: item.SUCURSAL,
          type_person: item.TIPO,
          vendor: item.REFERENCIADOR,
          voucher_efirm: false,
          voucher_of_address: false,
          first_name: item.TIPO == 1 ? item.NOMBRE : item.NOMBRE_EMPRESA,
          last_name: item.APELLIDO_PATERNO,
          second_last_name: item.APELLIDO_MATERNO,
          full_name: $scope.fullname,
          address_create: {
            administrative_area_level_1: item.ESTADO,
            administrative_area_level_2: item.MUNICIPIO,
            route: item.CALLE ? item.CALLE : "",
            street_number_int: item.NUM_INT ? item.NUM_INT : "",
            street_number: item.NUM_EXT ? item.NUM_EXT : "",
            sublocality: item.COLONIA ? item.COLONIA : "",
            postal_code: item.CODIGO_POSTAL ? item.CODIGO_POSTAL : "",
            details: item.REFERENCIAS ? item.REFERENCIAS : "",
            tipo: $scope.addresstipo
              ? $scope.addresstipo.name
              : "Dirección Personal",
          },
          correos: {
            email1: item.CORREO_2,
            email2: item.CORREO_3,
          },
          telefonos: {
            phone1: item.TELEFONO_2,
            phone2: item.TELEFONO_3,
          },
        };

        $scope.certifcados.push(dataPolicy);
      });

      $http({
        method: "POST",
        url: url.IP + "massives-contractors/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            l.stop();
            SweetAlert.swal(
              "¡Listo!",
              "Contratantes guardadas exitosamente.",
              "success"
            );
            $state.go("contratantes.main");
          } else {
            l.stop();
            if (response.data) {
              if (response.data.data) {
                $scope.certifcados = [];
                SweetAlert.swal("ERROR", response.data.data, "error");
              } else {
                $scope.certifcados = [];
                SweetAlert.swal(
                  "ERROR",
                  "Ocurrió un error al cargar los contratantes.",
                  "error"
                );
              }
            } else {
              SweetAlert.swal(
                "ERROR",
                "Ocurrió un error al cargar los contratantes.",
                "error"
              );
            }
            $scope.loader = false;
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("cargaPolizaGrupoCtrl", cargaPolizaGrupoCtrl);

  cargaPolizaGrupoCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "url",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$state",
  ];

  function cargaPolizaGrupoCtrl(
    $sessionStorage,
    $scope,
    $http,
    url,
    SweetAlert,
    FileUploader,
    datesFactory,
    $state
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;

    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certifcados = [];

    activate();

    function activate() {}

    $scope.validateExcel = function (param) {
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.POLIZA_GRUPO) {
        $scope.recibos_poliza = [];
        $scope.excelJson = param.POLIZA_GRUPO;
        $scope.excelJson.forEach(function (item) {
          if (!item.IDENTIFICADOR) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna IDENTIFICADOR, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.NO_POLIZA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NO_POLIZA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CONTRATANTE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CONTRATANTE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.DIRECCION) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna DIRECCION, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.VIGENCIA_INICIO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
              SweetAlert.swal(
                "Error",
                "Formato inválido de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          }
          if (!item.VIGENCIA_FIN) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (!$scope.validateDate(item.VIGENCIA_FIN)) {
              SweetAlert.swal(
                "Error",
                "Formato inválido de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          }
          if (!item.ASEGURADORA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ASEGURADORA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CLAVE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CLAVE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.RAMO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna RAMO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.SUBRAMO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna SUBRAMO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.RENOVABLE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna RENOVABLE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.TIPO_ADMINISTRACION) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna TIPO_ADMINISTRACION, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.FRECUENCIA_PAGO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna FRECUENCIA_PAGO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.SUBGRUPO) {
            SweetAlert.swal(
              "Error",
              "Formato inválido de la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CATEGORIA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.PAQUETE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          try {
            if (item.PRIMA_NETA.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.RPF.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.DERECHO.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.IVA.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.PRIMA_TOTAL.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.COMISION.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (item.PORCENTAJE_COMISION.indexOf(",") > -1) {
              SweetAlert.swal(
                "Error",
                "Esta linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          } catch (e) {}

          if (item.TIPO == 2) {
            var receipts = {
              clase: item.NO_POLIZA,
              recibo_numero: item.NO_RECIBO,
              prima_neta: item.PRIMA_RECIBO,
              rpf: item.RPF_RECIBO,
              derecho: item.DERECHO_RECIBO,
              sub_total: parseFloat(
                (
                  parseFloat(item.PRIMA_RECIBO) +
                  parseFloat(item.RPF_RECIBO) +
                  parseFloat(item.DERECHO_RECIBO)
                ).toFixed(2)
              ),
              iva: item.IVA_RECIBO,
              prima_total: item.TOTAL_RECIBO,
              comision: item.COMISION_RECIBO,
              receipt_type: 1,
              delivered: false,
              fecha_inicio: item.INICIO_RECIBO,
              fecha_fin: item.FIN_RECIBO,
              vencimiento: item.VENCIMIENTO_RECIBO,
            };
            $scope.recibos_poliza.push(receipts);
          }
        });

        if (!flagCertificate) {
          $scope.selectedPolices = param;
          $scope.addViews(0);
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.cancelCertificates = function () {
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.savePolicies = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loader = true;
      $scope.selectedPolices.POLIZA_GRUPO.forEach(function (item) {
        if (item.TIPO == 1) {
          var dataPolicy = {
            accident_rate: 0,
            address: item.DIRECCION,
            administration_type: item.TIPO_ADMINISTRACION,
            aseguradora: item.ASEGURADORA,
            business_line: item.LINEA_NEGOCIO,
            celula: item.CELULA,
            clave: item.CLAVE,
            collection_executive: item.EJECUTIVO_COBRANZA,
            comision: item.COMISION,
            comision_percent: item.PORCENTAJE_COMISION,
            conducto_de_pago: item.CONDUCTO_PAGO,
            contractor: item.CONTRATANTE,
            derecho: item.DERECHO,
            descuento: 0,
            document_type: 3,
            end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
            f_currency: item.MONEDA,
            folio: item.FOLIO,
            forma_de_pago: item.FRECUENCIA_PAGO,
            groupinglevel: item.SUBSUBAGRUPACION
              ? item.SUBSUBAGRUPACION
              : item.SUBAGRUPACION
              ? item.SUBAGRUPACION
              : item.AGRUPACION,
            identifier: item.IDENTIFICADOR,
            internal_number: 0,
            is_renewable: item.RENOVABLE,
            iva: item.IVA,
            observations: item.OBSERVACIONES,
            p_neta: item.PRIMA_NETA,
            p_total: item.PRIMA_TOTAL,
            paquetes: [
              {
                coverage_package: [
                  {
                    coverage_name: "AMPLIA",
                    deductibleInPolicy: { value: "AMPLIA" },
                    sumInPolicy: { value: "AMPLIA" },
                    coinsuranceInPolicy: { value: "AMPLIA" },
                    topeCoinsuranceInPolicy: { value: "AMPLIA" },
                    typeCoverage: 2,
                  },
                ],
                package_name: item.PAQUETE ? item.PAQUETE : "AMPLIA",
                type_package: 2,
              },
            ],
            poliza_anterior: item.ID_POLIZA_ANTERIOR,
            poliza_number: item.NO_POLIZA,
            ramo: item.RAMO,
            receipts_by: 1,
            recibos_poliza: [],
            ref_policy: item.REFERENCIADOR
              ? [{ comision_vendedor: 0, referenciador: item.REFERENCIADOR }]
              : [],
            responsable: item.RESPONSABLE,
            rpf: item.RPF,
            scheme: 1,
            start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
            status: 14,
            steps: [],
            sub_total: item.SUBRAMO,
            subgrupos: [
              {
                categorias: [
                  {
                    document_type: 5,
                    hospital_level: item.NIVEL_HOSPITALARIO,
                    name: item.CATEGORIA,
                  },
                ],
                document_type: 4,
                name: item.SUBGRUPO,
                recibos_poliza: [],
              },
            ],
            subramo: item.SUBRAMO,
            sucursal: item.SUCURSAL,
            total_receipts: 0,
          };

          $scope.recibos_poliza.forEach(function (receipt, index) {
            if (receipt.clase == item.NO_POLIZA) {
              try {
                receipt.fecha_inicio = datesFactory.toDate(
                  receipt.fecha_inicio
                );
              } catch (e) {
                receipt.fecha_inicio = receipt.fecha_inicio;
              }
              try {
                receipt.fecha_fin = datesFactory.toDate(receipt.fecha_fin);
              } catch (e) {
                receipt.fecha_fin = receipt.fecha_fin;
              }
              try {
                receipt.vencimiento = datesFactory.toDate(receipt.vencimiento);
              } catch (e) {
                receipt.vencimiento = receipt.vencimiento;
              }
              dataPolicy.recibos_poliza.push(receipt);
            }
          });

          $scope.certifcados.push(dataPolicy);
        }
      });

      $http({
        method: "POST",
        url: url.IP + "massives-polizas/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          l.stop();
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal(
              "¡Listo!",
              "Pólizas de grupo guardadas exitosamente.",
              "success"
            );
            $state.go("polizas.table");
          } else {
            $scope.loader = false;
            if (response.data) {
              if (response.data.data) {
                $scope.certifcados = [];
                SweetAlert.swal("ERROR", response.data.data, "error");
              } else {
                $scope.certifcados = [];
                SweetAlert.swal(
                  "ERROR",
                  "Ocurrió un error al cargar las pólizas.",
                  "error"
                );
              }
            } else {
              $scope.certifcados = [];
              SweetAlert.swal(
                "ERROR",
                "Ocurrió un error al cargar las pólizas.",
                "error"
              );
            }
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("cargaPolizaCtrl", cargaPolizaCtrl);

  cargaPolizaCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "url",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$state",
    "MESSAGES",
  ];

  function cargaPolizaCtrl(
    $sessionStorage,
    $scope,
    $http,
    url,
    SweetAlert,
    FileUploader,
    datesFactory,
    $state,
    MESSAGES
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;

    $scope.ramos = [
      { id: 1, name: "Vida" },
      { id: 2, name: "Accidentes y Enfermedades" },
      { id: 9, name: "Automóviles" },
      { id: 3, name: "Daños" },
    ];

    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certifcados = [];

    $scope.optionViewsDependient = $scope.optionsViews[0];
    $scope.valueInitialDependients = 1;
    $scope.valueFinalDependients = 10;
    $scope.excelJsonViewsDependients = [];

    $scope.statesArray = [
      { id: 1, name: "Aguascalientes" },
      { id: 2, name: "Baja California " },
      { id: 3, name: "Baja California Sur" },
      { id: 4, name: "Campeche" },
      { id: 5, name: "Chiapas" },
      { id: 6, name: "Chihuahua" },
      { id: 7, name: "Coahuila" },
      { id: 8, name: "Colima" },
      { id: 9, name: "Ciudad de México" },
      { id: 10, name: "Durango" },
      { id: 11, name: "Estado de México" },
      { id: 12, name: "Guanajuato" },
      { id: 13, name: "Guerrero" },
      { id: 14, name: "Hidalgo" },
      { id: 15, name: "Jalisco" },
      { id: 16, name: "Michoacán" },
      { id: 17, name: "Morelos" },
      { id: 18, name: "Nayarit" },
      { id: 19, name: "Nuevo León" },
      { id: 20, name: "Oaxaca" },
      { id: 21, name: "Puebla" },
      { id: 22, name: "Querétaro" },
      { id: 23, name: "Quintana Roo" },
      { id: 24, name: "San Luis Potosí" },
      { id: 25, name: "Sinaloa" },
      { id: 26, name: "Sonora" },
      { id: 27, name: "Tabasco" },
      { id: 28, name: "Tamaulipas" },
      { id: 29, name: "Tlaxcala" },
      { id: 30, name: "Veracruz" },
      { id: 31, name: "Yucatán" },
      { id: 32, name: "Zacatecas" },
    ];

    activate();

    function activate() {}

    $scope.chageRamo = function (param) {
      $scope.ramoSelected = param;
    };

    $scope.fileNameChanged = function (ele) {
      var lo = Ladda.create(document.querySelector(".ladda-button2"));
      lo.start();
      lo.stop();
    };

    $scope.validateExcel = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      $scope.excelJson = [];
      $scope.recibos_poliza = [];
      var flagCertificate = false;
      if (param.VIDA) {
        if ($scope.ramoSelected.name == "Vida") {
          $scope.beneficiaries_life = [];
          $scope.excelJson = param.VIDA;
          $scope.excelJsonDependiente = param.BENEFICIARIOS;
          $scope.excelJson.forEach(function (item) {
            if (!item.CLASE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CLASE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.NO_POLIZA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_POLIZA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CONTRATANTE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CONTRATANTE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.DIRECCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DIRECCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            }
            if (!item.RENOVABLE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RENOVABLE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.ASEGURADORA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ASEGURADORA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CLAVE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CLAVE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.RAMO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RAMO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.SUBRAMO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBRAMO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.TIPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (isNaN(item.TIPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.TIPO < 47 || item.TIPO > 49) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
            }
            if (!item.MONEDA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MONEDA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CONDUCTO_PAGO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CONDUCTO_PAGO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.FRECUENCIA_PAGO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FRECUENCIA_PAGO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (parseInt(item.CLASE) == 1) {
              if (!item.NOMBRE_TITULAR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NOMBRE_TITULAR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (!item.APELLIDO_PATERNO_TITULAR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna APELLIDO_PATERNO_TITULAR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (!item.SEXO_TITULAR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO_TITULAR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (!item.FECHA_NACIMIENTO_TITULAR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO_TITULAR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.FECHA_NACIMIENTO_TITULAR)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FECHA_NACIMIENTO_TITULAR, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.FUMADOR_TITULAR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FUMADOR_TITULAR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            } catch (e) {}
            if (item.CLASE == 2) {
              if (!item.NO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (
                  item.NO_RECIBO.indexOf(",") > -1 ||
                  item.NO_RECIBO.indexOf(".") > -1
                ) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna NO_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.PRIMA_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.PRIMA_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.RPF_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.RPF_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.DERECHO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.DERECHO_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.IVA_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.IVA_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.TOTAL_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TOTAL_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.COMISION_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.COMISION_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.TOTAL_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TOTAL_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.INICIO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.INICIO_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.FIN_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.FIN_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.VENCIMIENTO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.VENCIMIENTO_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              var receipts = {
                clase: item.NO_POLIZA,
                recibo_numero: item.NO_RECIBO,
                prima_neta: item.PRIMA_RECIBO,
                rpf: item.RPF_RECIBO,
                derecho: item.DERECHO_RECIBO,
                sub_total: parseFloat(
                  (
                    parseFloat(item.PRIMA_RECIBO) +
                    parseFloat(item.RPF_RECIBO) +
                    parseFloat(item.DERECHO_RECIBO)
                  ).toFixed(2)
                ),
                iva: item.IVA_RECIBO,
                prima_total: item.TOTAL_RECIBO,
                comision: item.COMISION_RECIBO,
                receipt_type: 1,
                delivered: false,
                fecha_inicio: item.INICIO_RECIBO,
                fecha_fin: item.FIN_RECIBO,
                vencimiento: item.VENCIMIENTO_RECIBO,
              };
              $scope.recibos_poliza.push(receipts);
            }
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
            $scope.addViewsDependients(0);
            l.stop();
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
          l.stop();
        }
      } else if (param.GASTOSMEDICOS) {
        if ($scope.ramoSelected.name == "Accidentes y Enfermedades") {
          $scope.beneficiaries_medical = [];
          $scope.excelJson = param.GASTOSMEDICOS;
          $scope.excelJsonDependiente = param.DEPENDIENTES;
          $scope.excelJson.forEach(function (item) {
            if (!item.CLASE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CLASE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.NO_POLIZA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_POLIZA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CONTRATANTE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CONTRATANTE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.DIRECCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DIRECCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            }
            if (!item.RENOVABLE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RENOVABLE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.ASEGURADORA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ASEGURADORA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CLAVE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CLAVE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.RAMO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RAMO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.SUBRAMO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBRAMO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.TIPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (isNaN(item.TIPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.TIPO < 46 || item.TIPO > 46) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
            }
            if (!item.MONEDA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MONEDA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CONDUCTO_PAGO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CONDUCTO_PAGO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.FRECUENCIA_PAGO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FRECUENCIA_PAGO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (parseInt(item.CLASE) == 1) {
              if (!item.NOMBRE_TITULAR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NOMBRE_TITULAR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (!item.APELLIDO_PATERNO_TITULAR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna APELLIDO_PATERNO_TITULAR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (!item.SEXO_TITULAR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO_TITULAR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (!item.FECHA_NACIMIENTO_TITULAR) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO_TITULAR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.FECHA_NACIMIENTO_TITULAR)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FECHA_NACIMIENTO_TITULAR, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            } catch (e) {}
            if (item.CLASE == 2) {
              if (!item.NO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.NO_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna NO_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.PRIMA_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.PRIMA_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.RPF_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.RPF_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.DERECHO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.DERECHO_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.IVA_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.IVA_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.TOTAL_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TOTAL_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.COMISION_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.COMISION_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.TOTAL_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TOTAL_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.INICIO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.INICIO_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.FIN_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.FIN_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.VENCIMIENTO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.VENCIMIENTO_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              var receipts = {
                clase: item.NO_POLIZA,
                recibo_numero: item.NO_RECIBO,
                prima_neta: item.PRIMA_RECIBO,
                rpf: item.RPF_RECIBO,
                derecho: item.DERECHO_RECIBO,
                sub_total: parseFloat(
                  (
                    parseFloat(item.PRIMA_RECIBO) +
                    parseFloat(item.RPF_RECIBO) +
                    parseFloat(item.DERECHO_RECIBO)
                  ).toFixed(2)
                ),
                iva: item.IVA_RECIBO,
                prima_total: item.TOTAL_RECIBO,
                comision: item.COMISION_RECIBO,
                receipt_type: 1,
                delivered: false,
                fecha_inicio: item.INICIO_RECIBO,
                fecha_fin: item.FIN_RECIBO,
                vencimiento: item.VENCIMIENTO_RECIBO,
              };
              $scope.recibos_poliza.push(receipts);
            }
          });
          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
            $scope.addViewsDependients(0);
            l.stop();
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
          l.stop();
        }
      } else if (param.AUTOS) {
        if ($scope.ramoSelected.name == "Automóviles") {
          $scope.excelJson = param.AUTOS;
          $scope.excelJson.forEach(function (item) {
            if (!item.CLASE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CLASE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.NO_POLIZA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_POLIZA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CONTRATANTE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CONTRATANTE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.DIRECCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DIRECCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            }
            if (!item.RENOVABLE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RENOVABLE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.ASEGURADORA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ASEGURADORA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CLAVE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CLAVE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.RAMO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RAMO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.SUBRAMO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBRAMO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.TIPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (isNaN(item.TIPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.TIPO < 0 || item.TIPO > 9) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
            }
            if (!item.MONEDA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MONEDA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CONDUCTO_PAGO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CONDUCTO_PAGO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.FRECUENCIA_PAGO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FRECUENCIA_PAGO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.MARCA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.ANO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ANO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.VERSION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.SERIE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.USO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna USO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (isNaN(item.USO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.USO < 1 || item.USO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
            }
            if (!item.SERVICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERVICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.PORCENTAJE_COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PORCENTAJE_COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            } catch (e) {}
            if (item.CLASE == 2) {
              if (!item.NO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.NO_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna NO_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.PRIMA_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.PRIMA_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.RPF_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.RPF_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.DERECHO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.DERECHO_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.IVA_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.IVA_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.TOTAL_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TOTAL_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.COMISION_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.COMISION_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.TOTAL_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TOTAL_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.INICIO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.INICIO_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.FIN_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.FIN_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.VENCIMIENTO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.VENCIMIENTO_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              var receipts = {
                clase: item.NO_POLIZA,
                recibo_numero: parseInt(item.NO_RECIBO),
                prima_neta: item.PRIMA_RECIBO,
                rpf: item.RPF_RECIBO,
                derecho: item.DERECHO_RECIBO,
                sub_total: parseFloat(
                  (
                    parseFloat(item.PRIMA_RECIBO) +
                    parseFloat(item.RPF_RECIBO) +
                    parseFloat(item.DERECHO_RECIBO)
                  ).toFixed(2)
                ),
                iva: item.IVA_RECIBO,
                prima_total: item.TOTAL_RECIBO,
                comision: item.COMISION_RECIBO,
                receipt_type: 1,
                delivered: false,
                fecha_inicio: item.INICIO_RECIBO,
                fecha_fin: item.FIN_RECIBO,
                vencimiento: item.VENCIMIENTO_RECIBO,
              };
              $scope.recibos_poliza.push(receipts);
            }
            if (item.ESTADO_CIRCULACION) {
              $scope.statesArray.forEach(function (state) {
                if (state.id == parseInt(item.ESTADO_CIRCULACION)) {
                  item.ESTADO_CIRCULACION = state.name;
                }
              });
            }
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
            l.stop();
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
          l.stop();
        }
      } else if (param.DANIOS) {
        if ($scope.ramoSelected.name == "Daños") {
          $scope.excelJson = param.DANIOS;
          $scope.excelJson.forEach(function (item) {
            if (!item.CLASE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CLASE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.NO_POLIZA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_POLIZA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CONTRATANTE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CONTRATANTE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.DIRECCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DIRECCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            }
            if (!item.RENOVABLE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RENOVABLE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.ASEGURADORA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ASEGURADORA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CLAVE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CLAVE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.RAMO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna RAMO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.SUBRAMO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBRAMO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.TIPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            } else {
              if (isNaN(item.TIPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.TIPO < 0 || item.TIPO > 63) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
            }
            if (!item.MONEDA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MONEDA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.CONDUCTO_PAGO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CONDUCTO_PAGO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.FRECUENCIA_PAGO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FRECUENCIA_PAGO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            if (!item.BIEN_ASEGURADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna BIEN_ASEGURADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              l.stop();
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              }
            } catch (e) {}
            if (item.CLASE == 2) {
              if (!item.NO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.NO_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna NO_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.PRIMA_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.PRIMA_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PRIMA_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.RPF_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.RPF_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna RPF_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.DERECHO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.DERECHO_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna DERECHO_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.IVA_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.IVA_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna IVA_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.TOTAL_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TOTAL_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.COMISION_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna COMISION_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.COMISION_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (item.TOTAL_RECIBO.indexOf(",") > -1) {
                  SweetAlert.swal(
                    "Error",
                    "Esta linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TOTAL_RECIBO contiene coma (,), elimina y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.INICIO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.INICIO_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna INICIO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.FIN_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.FIN_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FIN_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              if (!item.VENCIMIENTO_RECIBO) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                l.stop();
              } else {
                if (!$scope.validateDate(item.VENCIMIENTO_RECIBO)) {
                  SweetAlert.swal(
                    "Error",
                    "Formato inválido de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna VENCIMIENTO_RECIBO, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                  l.stop();
                }
              }
              var receipts = {
                clase: item.NO_POLIZA,
                recibo_numero: parseInt(item.NO_RECIBO),
                prima_neta: item.PRIMA_RECIBO,
                rpf: item.RPF_RECIBO,
                derecho: item.DERECHO_RECIBO,
                sub_total: parseFloat(
                  (
                    parseFloat(item.PRIMA_RECIBO) +
                    parseFloat(item.RPF_RECIBO) +
                    parseFloat(item.DERECHO_RECIBO)
                  ).toFixed(2)
                ),
                iva: item.IVA_RECIBO,
                prima_total: item.TOTAL_RECIBO,
                comision: item.COMISION_RECIBO,
                receipt_type: 1,
                delivered: false,
                fecha_inicio: item.INICIO_RECIBO,
                fecha_fin: item.FIN_RECIBO,
                vencimiento: item.VENCIMIENTO_RECIBO,
              };
              $scope.recibos_poliza.push(receipts);
            }
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
            l.stop();
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
          l.stop();
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
        l.stop();
      }
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJsonViewsDependients = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.addViewsDependients = function (value) {
      if (value == 0) {
        $scope.valueInitialDependient = 1;
        $scope.valueFinalDependient = $scope.optionViewsDependient.value;
        if ($scope.valueFinalDependient > $scope.excelJsonDependiente.length) {
          $scope.valueFinalDependient = $scope.excelJsonDependiente.length;
        }
      } else if (value == 1) {
        $scope.valueInitialDependient =
          $scope.valueInitialDependient + $scope.optionViewsDependient.value;
        $scope.valueFinalDependient =
          $scope.valueInitialDependient +
          ($scope.optionViewsDependient.value - 1);
        if ($scope.valueFinalDependient > $scope.excelJsonDependiente.length) {
          $scope.valueFinalDependient = $scope.excelJsonDependiente.length;
        }
      } else {
        $scope.valueInitialDependient =
          $scope.valueInitialDependient - $scope.optionViewsDependient.value;
        $scope.valueFinalDependient =
          $scope.valueInitialDependient +
          ($scope.optionViewsDependient.value - 1);
      }
      $scope.changeViewsDependients();
    };

    $scope.changeViewsDependients = function () {
      $scope.excelJsonViewsDependients = [];
      $scope.excelJsonDependiente.forEach(function (item, index) {
        if (
          index + 1 >= $scope.valueInitialDependient &&
          index < $scope.valueFinalDependient
        ) {
          $scope.excelJsonViewsDependients.push(item);
        }
      });
    };

    $scope.validateEmail = function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.cancelCertificates = function () {
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      $scope.excelJsonDependiente = [];
      $scope.excelJsonViews = [];
      $scope.excelJsonViewsDependients = [];
    };

    $scope.saveCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loader = true;
      $scope.certifcados = [];

      if ($scope.selectedCertificates.VIDA) {
        $scope.certifcados = {
          polizas: $scope.selectedCertificates.VIDA,
          dependientes: $scope.selectedCertificates.BENEFICIARIOS,
        };
      } else if ($scope.selectedCertificates.GASTOSMEDICOS) {
        $scope.certifcados = {
          polizas: $scope.selectedCertificates.GASTOSMEDICOS,
          dependientes: $scope.selectedCertificates.DEPENDIENTES,
        };
      } else if ($scope.selectedCertificates.AUTOS) {
        $scope.selectedCertificates.AUTOS.forEach(function (item) {
          if (item.CLASE == 1) {
            var dataCar = [
              {
                car_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
                driver: item.CONDUCTOR ? item.CONDUCTOR : null,
                email: item.CORREO,
                no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
                brand: item.MARCA,
                model: item.MODELO ? item.MODELO : null,
                year: item.ANO,
                version: item.VERSION,
                serial: item.SERIE,
                engine: item.MOTOR ? item.MOTOR : null,
                color: item.COLOR ? item.COLOR : null,
                license_plates: item.MATRICULA ? item.MATRICULA : null,
                usage: parseInt(item.USO),
                service: item.SERVICIO,
                procedencia: item.MATRICULA ? parseInt(item.PROCEDENCIA) : null,
                sum_insured: item.VALOR_O_SUMA_ASEGURADA
                  ? item.VALOR_O_SUMA_ASEGURADA
                  : null,
                charge_type: item.TIPO_CARGA ? parseInt(item.TIPO_CARGA) : null,
                adjustment: item.ADAPTACIONES ? item.ADAPTACIONES : null,
                mont_adjustment: item.MONTO_ADAPTACIONES
                  ? item.MONTO_ADAPTACIONES
                  : null,
                special_team: item.EQUIPAMIENTO ? item.EQUIPAMIENTO : null,
                mont_special_team: item.MONTO_EQUIPAMIENTO
                  ? item.MONTO_EQUIPAMIENTO
                  : null,
                beneficiary_name: item.BENEFICIARIO_PREFERENTE
                  ? item.BENEFICIARIO_PREFERENTE
                  : null,
                preferential_benefiaciary: item.BENEFICIARIO_PREFERENTE
                  ? item.BENEFICIARIO_PREFERENTE
                  : null,
                beneficiary_rfc: item.BENEFICIARIO_RFC
                  ? item.BENEFICIARIO_RFC
                  : null,
                beneficiary_address: item.BENEFICIARIO_DIRECCION
                  ? item.BENEFICIARIO_DIRECCION
                  : null,
              },
            ];

            $scope.receipts_policy = [];
            $scope.recibos_poliza.forEach(function (receipt, index) {
              if (receipt.clase == item.NO_POLIZA) {
                try {
                  receipt.fecha_inicio = datesFactory.toDate(
                    receipt.fecha_inicio
                  );
                } catch (e) {
                  receipt.fecha_inicio = receipt.fecha_inicio;
                }
                try {
                  receipt.fecha_fin = datesFactory.toDate(receipt.fecha_fin);
                } catch (e) {
                  receipt.fecha_fin = receipt.fecha_fin;
                }
                try {
                  receipt.vencimiento = datesFactory.toDate(
                    receipt.vencimiento
                  );
                } catch (e) {
                  receipt.vencimiento = receipt.vencimiento;
                }
                $scope.receipts_policy.push(receipt);
              }
            });

            var certificateData = {
              accident_rate: "",
              accidents_policy: [],
              address: item.DIRECCION,
              aseguradora: item.ASEGURADORA,
              automobiles_policy: dataCar,
              business_line: item.LINEA_NEGOCIO,
              caratula: "",
              celula: item.CELULA ? item.CELULA : "",
              certificado_inciso_activo: true,
              certificate_number: "",
              clave: item.CLAVE,
              collection_executive: item.EJECUTIVO_COBRANZA,
              comision: item.COMISION
                ? parseFloat(item.COMISION).toFixed(2)
                : 0,
              comision_percent: item.PORCENTAJE_COMISION
                ? item.PORCENTAJE_COMISION
                : "",
              conducto_de_pago: item.CONDUCTO_PAGO ? item.CONDUCTO_PAGO : "",
              contacto: "",
              contractor: item.CONTRATANTE,
              contratante_subgroup: null,
              coverageInPolicy_policy: [
                {
                  coinsurance: "AMPLIA",
                  coverage_name: "AMPLIA",
                  deductible: "AMPLIA",
                  package: item.PAQUETE ? item.PAQUETE : "AMPLIA",
                  prima: "AMPLIA",
                  priority: "AMPLIA",
                  sum_insured: "AMPLIA",
                  topecoinsurance: "AMPLIA",
                },
              ],
              damages_policy: [],
              derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
              descuento: item.DESCUENTO ? item.DESCUENTO : "0",
              document_type: 1,
              emision_date: null,
              end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
              f_currency: item.MONEDA,
              fecha_baja_inciso: null,
              folio: item.FOLIO ? item.FOLIO : "",
              forma_de_pago: item.FRECUENCIA_PAGO,
              give_comision: "0",
              grouping_level: item.SUBSUBAGRUPACION
                ? item.SUBSUBAGRUPACION
                : item.SUBAGRUPACION
                ? item.SUBAGRUPACION
                : item.AGRUPACION,
              groupinglevel: item.SUBSUBAGRUPACION
                ? item.SUBSUBAGRUPACION
                : item.SUBAGRUPACION
                ? item.SUBAGRUPACION
                : item.AGRUPACION,
              hospital_level: null,
              identifier: item.IDENTIFICADOR ? item.IDENTIFICADOR : "",
              internal_number: "",
              is_renewable: item.RENOVABLE,
              iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
              life_policy: [],
              observations: "",
              p_neta: item.PRIMA_NETA
                ? parseFloat(item.PRIMA_NETA).toFixed(2)
                : 0,
              p_total: item.PRIMA_TOTAL
                ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                : 0,
              parent: null,
              paquete: item.PAQUETE ? item.PAQUETE : null,
              poliza_anterior: item.ID_POLIZA_ANTERIOR
                ? item.ID_POLIZA_ANTERIOR
                : "",
              poliza_number: item.NO_POLIZA,
              ramo: item.RAMO,
              rec_antiguedad: null,
              ref_policy: [
                {
                  referenciador: item.REFERENCIADOR ? item.REFERENCIADOR : 0,
                  comision_vendedor: 0,
                },
              ],
              recibos_poliza: $scope.receipts_policy,
              responsable: item.RESPONSABLE ? item.RESPONSABLE : "",
              rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
              scheme: 1,
              start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
              state_circulation: item.ESTADO_CIRCULACION
                ? item.ESTADO_CIRCULACION
                : "",
              status: 14,
              steps: "",
              sub_total: "0",
              subramo: item.SUBRAMO,
              sucursal: item.SUCURSAL ? item.SUCURSAL : "",
            };
            $scope.certifcados.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.DANIOS) {
        $scope.selectedCertificates.DANIOS.forEach(function (item) {
          if (item.CLASE == 1) {
            var dataDamage = [
              {
                damage_type: item.TIPO ? item.TIPO : 1,
                insured_item: item.BIEN_ASEGURADO,
                item_address: item.BIEN_DIRECCION ? item.BIEN_DIRECCION : "",
                item_details: item.BIEN_DETALLES ? item.BIEN_DETALLES : "",
              },
            ];

            $scope.receipts_policy = [];
            $scope.recibos_poliza.forEach(function (receipt, index) {
              if (receipt.clase == item.NO_POLIZA) {
                try {
                  receipt.fecha_inicio = datesFactory.toDate(
                    receipt.fecha_inicio
                  );
                } catch (e) {
                  receipt.fecha_inicio = receipt.fecha_inicio;
                }
                try {
                  receipt.fecha_fin = datesFactory.toDate(receipt.fecha_fin);
                } catch (e) {
                  receipt.fecha_fin = receipt.fecha_fin;
                }
                try {
                  receipt.vencimiento = datesFactory.toDate(
                    receipt.vencimiento
                  );
                } catch (e) {
                  receipt.vencimiento = receipt.vencimiento;
                }
                $scope.receipts_policy.push(receipt);
              }
            });

            var certificateData = {
              accident_rate: "",
              accidents_policy: [],
              address: item.DIRECCION,
              aseguradora: item.ASEGURADORA,
              automobiles_policy: [],
              business_line: item.LINEA_NEGOCIO,
              caratula: "",
              celula: item.CELULA ? item.CELULA : "",
              certificado_inciso_activo: true,
              certificate_number: "",
              clave: item.CLAVE,
              collection_executive: item.EJECUTIVO_COBRANZA,
              comision: item.COMISION
                ? parseFloat(item.COMISION).toFixed(2)
                : 0,
              comision_percent: item.PORCENTAJE_COMISION
                ? item.PORCENTAJE_COMISION
                : "",
              conducto_de_pago: item.CONDUCTO_PAGO ? item.CONDUCTO_PAGO : "",
              contacto: "",
              contractor: item.CONTRATANTE,
              contratante_subgroup: null,
              coverageInPolicy_policy: [
                {
                  coinsurance: "AMPLIA",
                  coverage_name: "AMPLIA",
                  deductible: "AMPLIA",
                  package: item.PAQUETE ? item.PAQUETE : "AMPLIA",
                  prima: "AMPLIA",
                  priority: "AMPLIA",
                  sum_insured: "AMPLIA",
                  topecoinsurance: "AMPLIA",
                },
              ],
              damages_policy: dataDamage,
              derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
              descuento: item.DESCUENTO ? item.DESCUENTO : "0",
              document_type: 1,
              emision_date: null,
              end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
              f_currency: item.MONEDA,
              fecha_baja_inciso: null,
              folio: item.FOLIO ? item.FOLIO : "",
              forma_de_pago: item.FRECUENCIA_PAGO,
              give_comision: "0",
              grouping_level: item.SUBSUBAGRUPACION
                ? item.SUBSUBAGRUPACION
                : item.SUBAGRUPACION
                ? item.SUBAGRUPACION
                : item.AGRUPACION,
              groupinglevel: item.SUBSUBAGRUPACION
                ? item.SUBSUBAGRUPACION
                : item.SUBAGRUPACION
                ? item.SUBAGRUPACION
                : item.AGRUPACION,
              hospital_level: null,
              identifier: item.IDENTIFICADOR ? item.IDENTIFICADOR : "",
              internal_number: "",
              is_renewable: item.RENOVABLE,
              iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
              life_policy: [],
              observations: "",
              p_neta: item.PRIMA_NETA
                ? parseFloat(item.PRIMA_NETA).toFixed(2)
                : 0,
              p_total: item.PRIMA_TOTAL
                ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                : 0,
              parent: null,
              paquete: item.PAQUETE ? item.PAQUETE : null,
              poliza_anterior: item.ID_POLIZA_ANTERIOR
                ? item.ID_POLIZA_ANTERIOR
                : "",
              poliza_number: item.NO_POLIZA,
              ramo: item.RAMO,
              rec_antiguedad: null,
              ref_policy: [
                {
                  referenciador: item.REFERENCIADOR ? item.REFERENCIADOR : 0,
                  comision_vendedor: 0,
                },
              ],
              recibos_poliza: $scope.receipts_policy,
              responsable: item.RESPONSABLE ? item.RESPONSABLE : "",
              rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
              scheme: 1,
              start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
              state_circulation: "",
              status: 14,
              steps: "",
              sub_total: "0",
              subramo: item.SUBRAMO,
              sucursal: item.SUCURSAL ? item.SUCURSAL : "",
            };
            $scope.certifcados.push(certificateData);
          }
        });
      }

      if (
        $scope.selectedCertificates.VIDA ||
        $scope.selectedCertificates.GASTOSMEDICOS
      ) {
        $scope.url_excel = "read-excel-policies/";
      } else {
        $scope.url_excel = "massives-polizas-individuales/";
      }

      $http({
        method: "POST",
        url: url.IP + $scope.url_excel,
        data: $scope.certifcados,
      })
        .then(function success(response) {
          l.stop();
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal(
              "¡Listo!",
              "Pólizas guardadas exitosamente.",
              "success"
            );
            $state.go("polizas.table");
          } else {
            $scope.loader = false;
            if (response.data) {
              if (response.data.data) {
                $scope.certifcados = [];
                SweetAlert.swal("ERROR", response.data.data, "error");
              } else {
                $scope.certifcados = [];
                SweetAlert.swal(
                  "ERROR",
                  "Ocurrió un error al cargar las pólizas.",
                  "error"
                );
              }
            } else {
              $scope.certifcados = [];
              SweetAlert.swal(
                "ERROR",
                "Ocurrió un error al cargar las pólizas.",
                "error"
              );
            }
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("cargaNoRenovacionCtrl", cargaNoRenovacionCtrl);

  cargaNoRenovacionCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "url",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$state",
    "MESSAGES",
  ];

  function cargaNoRenovacionCtrl(
    $sessionStorage,
    $scope,
    $http,
    url,
    SweetAlert,
    FileUploader,
    datesFactory,
    $state,
    MESSAGES
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;

    $scope.ramos = [
      { id: 1, name: "Vida" },
      { id: 2, name: "Accidentes y Enfermedades" },
      { id: 9, name: "Automóviles" },
      { id: 3, name: "Daños" },
    ];

    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certifcados = [];

    $scope.optionViewsDependient = $scope.optionsViews[0];
    $scope.valueInitialDependients = 1;
    $scope.valueFinalDependients = 10;
    $scope.excelJsonViewsDependients = [];

    activate();

    function activate() {}

    $scope.chageRamo = function (param) {
      $scope.ramoSelected = param;
    };

    $scope.fileNameChanged = function (ele) {
      var lo = Ladda.create(document.querySelector(".ladda-button2"));
      lo.start();
      lo.stop();
    };

    $scope.validateExcel = function (param) {
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      $scope.excelJson = [];
      $scope.recibos_poliza = [];
      var flagCertificate = false;
      console.log("-para", param);
      if (param.LAYOUT_NORENOVACION) {
        $scope.excelJson = param.LAYOUT_NORENOVACION;
        $scope.excelJson.forEach(function (item) {
          if (!item.ID_SAAM_POLIZA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ID SAAM POLIZA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            l.stop();
          }
          if (!item.MOTIVO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna MOTIVO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            l.stop();
          }
        });
        if (!flagCertificate) {
          $scope.selectedCertificates = param;
          $scope.addViews(0);
          l.stop();
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde al proceso. Revisa el layout seleccionado.",
          "error"
        );
        l.stop();
      }
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJsonViewsDependients = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.addViewsDependients = function (value) {
      if (value == 0) {
        $scope.valueInitialDependient = 1;
        $scope.valueFinalDependient = $scope.optionViewsDependient.value;
        if ($scope.valueFinalDependient > $scope.excelJsonDependiente.length) {
          $scope.valueFinalDependient = $scope.excelJsonDependiente.length;
        }
      } else if (value == 1) {
        $scope.valueInitialDependient =
          $scope.valueInitialDependient + $scope.optionViewsDependient.value;
        $scope.valueFinalDependient =
          $scope.valueInitialDependient +
          ($scope.optionViewsDependient.value - 1);
        if ($scope.valueFinalDependient > $scope.excelJsonDependiente.length) {
          $scope.valueFinalDependient = $scope.excelJsonDependiente.length;
        }
      } else {
        $scope.valueInitialDependient =
          $scope.valueInitialDependient - $scope.optionViewsDependient.value;
        $scope.valueFinalDependient =
          $scope.valueInitialDependient +
          ($scope.optionViewsDependient.value - 1);
      }
      $scope.changeViewsDependients();
    };

    $scope.changeViewsDependients = function () {
      $scope.excelJsonViewsDependients = [];
      $scope.excelJsonDependiente.forEach(function (item, index) {
        if (
          index + 1 >= $scope.valueInitialDependient &&
          index < $scope.valueFinalDependient
        ) {
          $scope.excelJsonViewsDependients.push(item);
        }
      });
    };

    $scope.validateEmail = function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.cancelNoRenovacion = function () {
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      $scope.excelJsonDependiente = [];
      $scope.excelJsonViews = [];
      $scope.excelJsonViewsDependients = [];
    };

    $scope.saveNoRenovacion = function (excelJsonViews) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loader = true;
      $scope.norenovacionid = [];

      if ($scope.excelJson) {
        console.log("exe", $scope.excelJson, $scope.excelJsonViews);
        $scope.excelJson.forEach(function (item) {
          var data = {
            id: item.ID_SAAM_POLIZA,
            reason: item.MOTIVO,
          };
          $scope.norenovacionid.push(data);
        });
      }
      console.log("n", $scope.norenovacionid);
      $scope.url_excel = "massives-norenovacion-polizas/";
      $http({
        method: "POST",
        url: url.IP + $scope.url_excel,
        data: $scope.norenovacionid,
      })
        .then(function success(response) {
          l.stop();
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal(
              "¡Listo!",
              "Pólizas actualizadas exitosamente.",
              "success"
            );
            $state.go("polizas.table");
          } else {
            $scope.loader = false;
            if (response.data) {
              if (response.data.data) {
                $scope.certifcados = [];
                SweetAlert.swal("ERROR", response.data.data, "error");
              } else {
                $scope.certifcados = [];
                SweetAlert.swal(
                  "ERROR",
                  "Ocurrió un error al actualizar las pólizas.",
                  "error"
                );
              }
            } else {
              $scope.certifcados = [];
              SweetAlert.swal(
                "ERROR",
                "Ocurrió un error al actualizar las pólizas.",
                "error"
              );
            }
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("cargaPGInfoContributoriaCtrl", cargaPGInfoContributoriaCtrl);

  cargaPGInfoContributoriaCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "url",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$state",
    "toaster",
    "dataFactory",
  ];

  function cargaPGInfoContributoriaCtrl(
    $sessionStorage,
    $scope,
    $http,
    url,
    SweetAlert,
    FileUploader,
    datesFactory,
    $state,
    toaster,
    dataFactory
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;
    $scope.org_name = usr.urlname;
    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certifcados = [];

    activate();

    function activate() {}

    $scope.validateExcel = function (param) {
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      $scope.loader = true;
      var flagCertificate = false;
      if (param.POLIZA_CONTRIBUTORIA) {
        $scope.recibos_poliza = [];
        $scope.excelJson = param.POLIZA_CONTRIBUTORIA;
        $scope.excelJson.forEach(function (item) {
          if (!item.ID && !item.NUMERO_POLIZA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ID, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.NUMERO_POLIZA && !item.ID) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NUMERO_POLIZA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.VIGENCIA_INICIO && !item.ID) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          } else {
            if (item.VIGENCIA_INICIO) {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                $scope.loader = false;
              }
            }
          }
          if (!item.VIGENCIA_FIN && !item.ID) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          } else {
            if (item.VIGENCIA_FIN) {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                $scope.loader = false;
              }
            }
          }
          if (!item.RFC_CVE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna RFC_CVE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.RFC_HOMOCVE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna RFC_HOMOCVE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.DOM_CALLE_NUM) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna DOM_CALLE_NUM, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.DOM_COLONIA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna DOM_COLONIA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.DOM_CP) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna DOM_CP, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.DOM_POBLACION) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna DOM_POBLACION, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.DOM_ESTADO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna DOM_ESTADO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
        });

        if (!flagCertificate) {
          $scope.selectedPolices = param;
          $scope.loader = false;
          $scope.addViews(0);
        }
      } else {
        $scope.loader = false;
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.cancelCertificates = function () {
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
      $scope.loader = false;
      $scope.loadingValidate = false;
      $scope.loadingSave = false;
    };

    $scope.savePolicies = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loader = true;
      $scope.selectedPolices.POLIZA_CONTRIBUTORIA.forEach(function (item) {
        var dataPolicy = {
          id: item.ID ? item.ID : 0,
          poliza_number: item.NUMERO_POLIZA ? item.NUMERO_POLIZA : "",
          start_of_validity: item.VIGENCIA_INICIO ? item.VIGENCIA_INICIO : "",
          end_of_validity: item.VIGENCIA_FIN ? item.VIGENCIA_FIN : "",
          rfc_cve: item.RFC_CVE,
          rfc_homocve: item.RFC_HOMOCVE,
          dom_callenum: item.DOM_CALLE_NUM,
          dom_colonia: item.DOM_COLONIA,
          dom_cp: item.DOM_CP,
          dom_poblacion: item.DOM_POBLACION,
          dom_estado: item.DOM_ESTADO,
          contributory: true,
        };
        $scope.certifcados.push(dataPolicy);
      });

      $http({
        method: "POST",
        url: url.IP + "massives-polizas-infocontributoria/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          l.stop();
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal(
              "¡Listo!",
              "Información de Pólizas de grupo guardada exitosamente.",
              "success"
            );
            $state.go("polizas.table");
          } else {
            $scope.loader = false;
            if (response.data) {
              if (response.data.data) {
                $scope.certifcados = [];
                SweetAlert.swal("ERROR", response.data.data, "error");
              } else {
                $scope.certifcados = [];
                SweetAlert.swal(
                  "ERROR",
                  "Ocurrió un error al cargar la información de las pólizas de grupo.",
                  "error"
                );
              }
            } else {
              $scope.certifcados = [];
              SweetAlert.swal(
                "ERROR",
                "Ocurrió un error al cargar la información de las pólizas de grupo.",
                "error"
              );
            }
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
    $scope.validateCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      $scope.selectedPolices.POLIZA_CONTRIBUTORIA.forEach(function (item) {
        var dataPolicy = {
          id: item.ID ? item.ID : 0,
          poliza_number: item.NUMERO_POLIZA ? item.NUMERO_POLIZA : "",
          start_of_validity: item.VIGENCIA_INICIO ? item.VIGENCIA_INICIO : "",
          end_of_validity: item.VIGENCIA_FIN ? item.VIGENCIA_FIN : "",
          rfc_cve: item.RFC_CVE,
          rfc_homocve: item.RFC_HOMOCVE,
          dom_callenum: item.DOM_CALLE_NUM,
          dom_colonia: item.DOM_COLONIA,
          dom_cp: item.DOM_CP,
          dom_poblacion: item.DOM_POBLACION,
          dom_estado: item.DOM_ESTADO,
          contributory: true,
        };
        $scope.certifcados.push(dataPolicy);
      });
      $scope.loadingValidate = true;
      $http({
        method: "POST",
        url: url.IP + "validate-pgrupoinfo-massive",
        data: {
          certificados: $scope.certifcados,
          validar: true,
        },
      })
        .then(
          function (response) {
            $scope.loadingValidate = false;
            if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length > 0
            ) {
              if (response["data"]) {
                $scope.loadingValidate = true;
                // Conexión a socket.io
                // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // if($scope.org_name =='ancora'){
                //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                // }else{
                var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // }
                socket.emit("subscribe", response.data);
                socket.on(response.data, function (url) {
                  $scope.loadingValidate = false;
                  $scope.validado = true;
                  socket.disconnect();
                  SweetAlert.swal({
                    title:
                      "La lista de retroalimentación de Póliza de Grupo Información Contributoria ha sido generado",
                    icon: "success",
                    text: "Encuentra la liga de descarga en la sección de notificaciones",
                    timer: 5000,
                  });
                  // var notificacion = {
                  //   'title': 'La lista de retroalimentación de Póliza de Grupo Información Contributoria ha sido generado',
                  //   'description': url,
                  //   'model': 26,
                  //   'id_reference':0
                  // }
                  // dataFactory.post('notificaciones/', notificacion)
                  // .then(function success(response) {
                  //   SweetAlert.swal({
                  //     title: 'El reporte de retroalimentación sobre Póliza de Grupo Información Contributoria está listo para descargar',
                  //     icon: 'success',
                  //     text: 'Encuentra la liga de descarga en la sección de notificaciones',
                  //     timer: 5000
                  //   });
                  //   $scope.loadingValidate = false;
                  //   $scope.validado = true;
                  //   socket.disconnect();
                  // }).catch(function(err) {
                  //   socket.disconnect();
                  //   $scope.loadingValidate = false;
                  //   $scope.validado = true;
                  // })
                });
                toaster.info(
                  "Generando...",
                  "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                );
              }
            } else if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length == 0
            ) {
              $scope.loadingValidate = false;
              $scope.validado = true;
              SweetAlert.swal(
                "Cargado",
                "Archivo validado exitosamente",
                "success"
              );
            } else {
              $scope.loadingValidate = false;
              SweetAlert.swal(
                "Error",
                "Ocurrieron errores en el proceso",
                "error"
              );
            }
          },
          function (error) {
            $scope.loadingValidate = false;
          }
        )
        .catch(function (error) {
          $scope.loadingValidate = false;
        });
    };
    $scope.saveCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loadingSave = true;
      $scope.certifcados = [];
      $scope.selectedPolices.POLIZA_CONTRIBUTORIA.forEach(function (item) {
        var dataPolicy = {
          id: item.ID ? item.ID : 0,
          poliza_number: item.NUMERO_POLIZA ? item.NUMERO_POLIZA : "",
          start_of_validity: item.VIGENCIA_INICIO ? item.VIGENCIA_INICIO : "",
          end_of_validity: item.VIGENCIA_FIN ? item.VIGENCIA_FIN : "",
          rfc_cve: item.RFC_CVE,
          rfc_homocve: item.RFC_HOMOCVE,
          dom_callenum: item.DOM_CALLE_NUM,
          dom_colonia: item.DOM_COLONIA,
          dom_cp: item.DOM_CP,
          dom_poblacion: item.DOM_POBLACION,
          dom_estado: item.DOM_ESTADO,
          contributory: true,
        };
        $scope.certifcados.push(dataPolicy);
      });
      $scope.loadingSave = true;
      $http({
        method: "POST",
        url: url.IP + "validate-pgrupoinfo-massive",
        data: {
          certificados: $scope.certifcados,
          validar: false,
        },
      })
        .then(
          function (response) {
            $scope.loadingSave = false;
            if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length > 0
            ) {
              if (response["data"]) {
                $scope.loadingSave = true;
                // Conexión a socket.io
                // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // if($scope.org_name =='ancora'){
                //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                // }else{
                var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // }
                socket.emit("subscribe", response.data);
                socket.on(response.data, function (url) {
                  $scope.loadingValidate = false;
                  $scope.validado = true;
                  socket.disconnect();
                  SweetAlert.swal({
                    title:
                      "La lista de retroalimentación de Póliza de Grupo Información Contributoria ha sido generado",
                    icon: "success",
                    text: "Encuentra la liga de descarga en la sección de notificaciones",
                    timer: 5000,
                  });
                  // var notificacion = {
                  //   'title': 'La lista de retroalimentación de Póliza de Grupo Información Contributoria cargados ha sido generado',
                  //   'description': url,
                  //   'model': 26,
                  //   'id_reference':0
                  // }
                  // dataFactory.post('notificaciones/', notificacion)
                  // .then(function success(response) {
                  //   SweetAlert.swal({
                  //     title: 'El reporte de retroalimentación sobre Póliza de Grupo Información Contributoria cargados está listo para descargar',
                  //     icon: 'success',
                  //     text: 'Encuentra la liga de descarga en la sección de notificaciones',
                  //     timer: 5000
                  //   });
                  //   $scope.loadingSave = false;
                  //   $scope.validado = true;
                  //   socket.disconnect();
                  // }).catch(function(err) {
                  //   socket.disconnect();
                  // })
                });
                toaster.info(
                  "Generando...",
                  "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                );
              }
            } else if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length == 0
            ) {
              $scope.loadingSave = false;
              SweetAlert.swal(
                "Cargado",
                "Archivo validado exitosamente",
                "success"
              );
            } else {
              $scope.loadingSave = false;
              SweetAlert.swal(
                "Error",
                "Ocurrieron errores en el proceso",
                "error"
              );
            }
          },
          function (error) {
            $scope.loadingSave = false;
          }
        )
        .catch(function (error) {
          $scope.loadingSave = false;
        });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("cargaFlotillaCtrl", cargaFlotillaCtrl);

  cargaFlotillaCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "url",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$state",
  ];

  function cargaFlotillaCtrl(
    $sessionStorage,
    $scope,
    $http,
    url,
    SweetAlert,
    FileUploader,
    datesFactory,
    $state
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;

    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certifcados = [];

    activate();

    function activate() {}
    $scope.fileNameChanged = function (ele) {
      var lo = Ladda.create(document.querySelector(".ladda-button2"));
      lo.start();
      lo.stop();
    };
    $scope.validateExcel = function (param) {
      var lo = Ladda.create(document.querySelector(".ladda-button2"));
      lo.start();
      lo.stop();
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.FLOTILLA) {
        $scope.excelJson = param.FLOTILLA;
        $scope.excelJson.forEach(function (item) {
          if (!item.NO_CARATULA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna NO_CARATULA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.IDENTIFICADOR) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna IDENTIFICADOR, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.VIGENCIA_INICIO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
              SweetAlert.swal(
                "Error",
                "Formato inválido de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          }
          if (!item.VIGENCIA_FIN) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          } else {
            if (!$scope.validateDate(item.VIGENCIA_FIN)) {
              SweetAlert.swal(
                "Error",
                "Formato inválido de la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
          }
          if (!item.CONTRATANTE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CONTRATANTE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.DIRECCION) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna DIRECCION, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.ASEGURADORA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ASEGURADORA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.CLAVE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna CLAVE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.RAMO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna RAMO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.SUBRAMO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna SUBRAMO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.TIPO_CARATULA) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna TIPO_CARATULA, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
          if (!item.RENOVABLE) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna RENOVABLE, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
          }
        });

        if (!flagCertificate) {
          $scope.selectedPolices = param;
          $scope.addViews(0);
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.cancelCertificates = function () {
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };

    $scope.savePolicies = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loader = true;
      $scope.selectedPolices.FLOTILLA.forEach(function (item) {
        var dataPolicy = {
          address: item.DIRECCION,
          aseguradora: item.ASEGURADORA,
          business_line: item.LINEA_NEGOCIO,
          celula: item.CELULA,
          clave: item.CLAVE,
          collection_executive: item.EJECUTIVO_COBRANZA,
          contractor: item.CONTRATANTE,
          document_type: 11,
          end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
          f_currency: item.MONEDA,
          groupinglevel: item.SUBSUBAGRUPACION
            ? item.SUBSUBAGRUPACION
            : item.SUBAGRUPACION
            ? item.SUBAGRUPACION
            : item.AGRUPACION,
          identifier: item.IDENTIFICADOR,
          is_renewable: item.RENOVABLE,
          poliza_anterior: item.ID_POLIZA_ANTERIOR,
          poliza_number: item.NO_CARATULA,
          ramo: item.RAMO,
          ref_policy: [
            {
              comision_vendedor: 0,
              referenciador: item.REFERENCIADOR,
            },
          ],
          responsable: item.RESPONSABLE,
          start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
          status: 14,
          subramo: item.SUBRAMO,
          type_policy: item.TIPO_CARATULA,
        };

        $scope.certifcados.push(dataPolicy);
      });

      $http({
        method: "POST",
        url: url.IP + "massives-flotillas/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          l.stop();
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            SweetAlert.swal(
              "¡Listo!",
              "Flotillas guardadas exitosamente.",
              "success"
            );
            $state.go("polizas.table");
          } else {
            l.stop();
            if (response.data) {
              if (response.data.data) {
                $scope.certifcados = [];
                SweetAlert.swal("ERROR", response.data.data, "error");
              } else {
                $scope.certifcados = [];
                SweetAlert.swal(
                  "ERROR",
                  "Ocurrió un error al cargar las Flotillas Carátula.",
                  "error"
                );
              }
            } else {
              SweetAlert.swal(
                "ERROR",
                "Ocurrió un error al cargar las Flotillas Carátula.",
                "error"
              );
            }
            $scope.loader = false;
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("cargaContractorCtrl", cargaContractorCtrl);

  cargaContractorCtrl.$inject = [
    "$sessionStorage",
    "$rootScope",
    "$scope",
    "$http",
    "url",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$state",
  ];

  function cargaContractorCtrl(
    $sessionStorage,
    $rootScope,
    $scope,
    $http,
    url,
    SweetAlert,
    FileUploader,
    datesFactory,
    $state
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;

    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.excelJsonViewsC = [];
    $scope.certifcados = [];
    $scope.loader = false;
    $scope.carga = false;
    $scope.actualizacion = false;
    activate();
    $scope.fileNameChanged = function (ele) {
      var lo = Ladda.create(document.querySelector(".ladda-button2"));
      lo.start();
      lo.stop();
    };
    function activate() {}
    $scope.updateContractors = function () {
      $scope.carga = false;
      $scope.actualizacion = true;
    };
    $scope.agregarContractors = function () {
      $scope.carga = true;
      $scope.actualizacion = false;
    };
    $scope.validateExcel = function (param) {
      console.log("-----nooo", param);
      var lo = Ladda.create(document.querySelector(".ladda-button2"));
      lo.start();
      lo.stop();
      $scope.loader = true;
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.CONTRATANTES) {
        $scope.excelJson = param.CONTRATANTES;
        $scope.excelJson.forEach(function (item) {
          if (!item.TIPO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna TIPO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (item.TIPO == 1) {
            if (!item.NOMBRE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              $scope.loader = false;
            }
            if (!item.APELLIDO_PATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              $scope.loader = false;
            }
            if (!item.FECHA_NACIMIENTO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              $scope.loader = false;
            } else {
              if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                $scope.loader = false;
              }
            }
            if (!item.GENERO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna GENERO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              $scope.loader = false;
            }
          } else {
            if (!item.NOMBRE_EMPRESA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NOMBRE_EMPRESA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              $scope.loader = false;
            }
            if (!item.FECHA_CONSTITUCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_CONSTITUCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
              $scope.loader = false;
            } else {
              if (!$scope.validateDate(item.FECHA_CONSTITUCION)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_CONSTITUCION, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
                $scope.loader = false;
              }
            }
          }
          if (!item.RFC) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna RFC, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.GRUPO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna GRUPO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.ESTADO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ESTADO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.MUNICIPIO) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna MUNICIPIO, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
        });

        if (!flagCertificate) {
          $scope.selectedPolices = param;
          $scope.addViews(0);
          $scope.loader = false;
        }
      } else {
        $scope.loader = false;
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.changeViews = function () {
      $scope.loader = true;
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
          $scope.loader = false;
        }
      });
    };
    $scope.changeViewsContractors = function () {
      $scope.loader = true;
      $scope.excelJsonViewsC = [];
      $scope.excelJsonC.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViewsC.push(item);
          $scope.loader = false;
        }
      });
    };
    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.cancelContractors = function () {
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
    };
    vm.address_type = [
      {
        name: "Dirección Personal",
        id: 0,
      },
      {
        name: "Dirección Fiscal",
        id: 1,
      },
      {
        name: "Dirección de cobro",
        id: 2,
      },
      {
        name: "Dirección de paquetería",
        id: 3,
      },
      {
        name: "Dirección de riesgo",
        id: 4,
      },
      {
        name: "CFDI",
        id: 5,
      },
    ];
    $scope.validateExcelUpd = function (param) {
      console.log("dsfd", param);
      $scope.loader = true;
      $scope.contractors = [];
      $scope.excelJsonC = [];
      var flagCertificate = false;
      if (param.CONTRATANTES) {
        $scope.excelJsonC = param.CONTRATANTES;
        $scope.excelJsonC.forEach(function (item) {
          if (!item.ID) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna ID, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
          if (!item.MOVIL) {
            SweetAlert.swal(
              "Error",
              "Esta vacía la linea " +
                (parseInt(item.__rowNum__) + 1) +
                " de la columna MOVIL, corrige el error y vuelve a subir el excel.",
              "error"
            );
            flagCertificate = true;
            $scope.loader = false;
          }
        });

        if (!flagCertificate) {
          $scope.contractors = param;
          $scope.addViewsContractors(0);
          $scope.loader = false;
        }
      } else {
        $scope.loader = false;
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
        console.log("--$scope.contractors", $scope.contractors, param);
      }
    };

    $scope.addViewsContractors = function (value) {
      $scope.showTableContractors = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJsonC.length) {
          $scope.valueFinal = $scope.excelJsonC.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJsonC.length) {
          $scope.valueFinal = $scope.excelJsonC.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViewsContractors();
    };

    $scope.saveContractors = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.certifcados = [];
      $scope.loader = true;
      $scope.selectedPolices.CONTRATANTES.forEach(function (item) {
        if (item.TIPO_DIRECCION) {
          $scope.addresstipo = vm.address_type[item.TIPO_DIRECCION];
        }
        if (item.TIPO == 1 && item.APELLIDO_MATERNO) {
          var apmat = item.APELLIDO_MATERNO ? item.APELLIDO_MATERNO : "";
        } else {
          var apmat = "";
        }
        if (item.VIP) {
          if (item.VIP == 0 || item.VIP == "0") {
            $scope.vipc = false;
          } else if (item.VIP == 1 || item.VIP == "1") {
            $scope.vipc = true;
          } else {
            $scope.vipc = false;
          }
        } else {
          $scope.vipc = false;
        }
        $scope.fullname =
          item.TIPO == 1
            ? item.NOMBRE + " " + item.APELLIDO_PATERNO + " " + apmat
            : item.NOMBRE_EMPRESA;
        var dataPolicy = {
          alta_hacienda: false,
          aviso_privacidad: false,
          birth_date: datesFactory.toDate(
            item.TIPO == 1 ? item.FECHA_NACIMIENTO : item.FECHA_CONSTITUCION
          ),
          boleta_predial: false,
          cambio_domicilio_hacienda: false,
          card_official_identification: false,
          carta_buro: false,
          carta_nombramiento: false,
          cellule: item.CELULA,
          certificado_gravamen: false,
          classification: item.CLASIFICACION,
          comprobante_inscripcion_firma: false,
          constitutive_act: false,
          contrato_multiple_afianzadora: false,
          CURP: false,
          curriculo: false,
          declaracion_anual: false,
          description: item.OBSERVACIONES,
          sex: item.GENERO,
          email: item.CORREO,
          escritura_inmueble: false,
          estados_financieros_anuales: false,
          estados_financieros_parciales: false,
          entrevista_afianzadora: false,
          fiscal_power: false,
          group: item.GRUPO,
          groupinglevel: item.SUBSUBAGRUPACION
            ? item.SUBSUBAGRUPACION
            : item.SUBAGRUPACION
            ? item.SUBAGRUPACION
            : item.AGRUPACION,
          has_bound_solidarity: false,
          modifications_constitutive_act: false,
          only_sureties: false,
          phone_number: item.TELEFONO,
          protocolizaciones: false,
          recibos_nomina: false,
          responsable: item.RESPONSABLE,
          rfc: item.RFC,
          vip: $scope.vipc,
          rfc_document: false,
          signed_format_ic: false,
          sucursal: item.SUCURSAL,
          type_person: item.TIPO,
          vendor: item.REFERENCIADOR,
          voucher_efirm: false,
          voucher_of_address: false,
          first_name: item.TIPO == 1 ? item.NOMBRE : item.NOMBRE_EMPRESA,
          last_name: item.APELLIDO_PATERNO,
          second_last_name: item.APELLIDO_MATERNO,
          full_name: $scope.fullname,
          address_create: {
            administrative_area_level_1: item.ESTADO,
            administrative_area_level_2: item.MUNICIPIO,
            route: item.CALLE ? item.CALLE : "",
            street_number_int: item.NUM_INT ? item.NUM_INT : "",
            street_number: item.NUM_EXT ? item.NUM_EXT : "",
            sublocality: item.COLONIA ? item.COLONIA : "",
            postal_code: item.CODIGO_POSTAL ? item.CODIGO_POSTAL : "",
            details: item.REFERENCIAS ? item.REFERENCIAS : "",
            tipo: $scope.addresstipo
              ? $scope.addresstipo.name
              : "Dirección Personal",
          },
          correos: {
            email1: item.CORREO_2,
            email2: item.CORREO_3,
          },
          telefonos: {
            phone1: item.TELEFONO_2,
            phone2: item.TELEFONO_3,
          },
        };

        $scope.certifcados.push(dataPolicy);
      });

      $http({
        method: "POST",
        url: url.IP + "massives-contractors/",
        data: $scope.certifcados,
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            l.stop();
            SweetAlert.swal(
              "¡Listo!",
              "Contratantes guardadas exitosamente.",
              "success"
            );
            $state.go("contratantes.main");
          } else {
            l.stop();
            if (response.data) {
              if (response.data.data) {
                $scope.certifcados = [];
                SweetAlert.swal("ERROR", response.data.data, "error");
              } else {
                $scope.certifcados = [];
                SweetAlert.swal(
                  "ERROR",
                  "Ocurrió un error al cargar los contratantes.",
                  "error"
                );
              }
            } else {
              SweetAlert.swal(
                "ERROR",
                "Ocurrió un error al cargar los contratantes.",
                "error"
              );
            }
            $scope.loader = false;
          }
        })
        .catch(function (e) {
          l.stop();
          console.log("error - caratula - catch", e);
        });
    };
    $scope.saveContractorsUpd = function () {
      var lz = Ladda.create(document.querySelector(".ladda-button3"));
      lz.start();
      $scope.contratantes = [];
      $scope.loader = true;
      $scope.contractors.CONTRATANTES.forEach(function (item) {
        var datax = {
          id: item.ID,
          phone: item.MOVIL,
        };
        $scope.contratantes.push(datax);
      });

      $http({
        method: "POST",
        url: url.IP + "update-contractors-phonemsj-id/",
        data: { contractors: $scope.contratantes },
      })
        .then(function success(response) {
          if (response.status === 201 || response.status === 200) {
            $scope.loader = false;
            lz.stop();
            SweetAlert.swal(
              "¡Listo!",
              "Contratantes actualizados exitosamente.",
              "success"
            );
            $state.go("contratantes.main");
          } else {
            lz.stop();
            if (response.data) {
              if (response.data.data) {
                $scope.contractosupd = [];
                SweetAlert.swal("ERROR", response.data.data, "error");
              } else {
                $scope.contractosupd = [];
                SweetAlert.swal(
                  "ERROR",
                  "Ocurrió un error al cargar los contratantes.",
                  "error"
                );
              }
            } else {
              SweetAlert.swal(
                "ERROR",
                "Ocurrió un error al cargar los contratantes.",
                "error"
              );
            }
            $scope.loader = false;
          }
        })
        .catch(function (e) {
          lz.stop();
          console.log("error - caratula - catch", e);
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("cargaCertificadosCtrl", cargaCertificadosCtrl);

  cargaCertificadosCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "url",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$state",
    "MESSAGES",
    "toaster",
    "dataFactory",
  ];

  function cargaCertificadosCtrl(
    $sessionStorage,
    $scope,
    $http,
    url,
    SweetAlert,
    FileUploader,
    datesFactory,
    $state,
    MESSAGES,
    toaster,
    dataFactory
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    // var token = JSON.parse(decryptedToken);
    var usr = JSON.parse(decryptedUser);
    var check = false;
    $scope.org_name = usr.urlname;

    $scope.ramos = [
      { id: 1, name: "Accidentes y Enfermedades" },
      { id: 2, name: "Automóviles" },
      { id: 3, name: "Daños" },
      { id: 3, name: "Incendio" },
      { id: 3, name: "Diversos" },
      { id: 1, name: "Vida" },
    ];

    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certifcados = [];

    activate();

    function activate() {}

    $scope.chageRamo = function (param) {
      $scope.ramoSelected = param;
    };

    $scope.validateExcel = function (param) {
      $scope.excelJson = [];
      var flagCertificate = false;
      if (param.ASEGURADOS_vida) {
        if (
          $scope.ramoSelected.name == "Vida" ||
          $scope.ramoSelected.name == "Funerarios"
        ) {
          $scope.beneficiaries_life = [];
          $scope.excelJson = param.ASEGURADOS_vida;
          $scope.excelJson.forEach(function (item) {
            if (!item.FAMILIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FAMILIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CERTIFICADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.TIPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.TIPO < 1 || item.TIPO > 2) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.PARENTESCO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PARENTESCO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.PARENTESCO < 1 || item.PARENTESCO > 4) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PARENTESCO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.NOMBRE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_PATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_MATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.FECHA_NACIMIENTO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SEXO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SEXO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (item.SEXO.length > 1) {
                SweetAlert.swal(
                  "Error",
                  "Los valores de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO no son válidos, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.FECHA_ANTIGUEDAD) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_ANTIGUEDAD)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.TIPO_SUMA_ASEGURADA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO_SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO_SUMA_ASEGURADA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (
                  item.TIPO_SUMA_ASEGURADA < 1 ||
                  item.TIPO_SUMA_ASEGURADA > 2
                ) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO_SUMA_ASEGURADA no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.SUMA_ASEGURADA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUMA_ASEGURADA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SUELDO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUELDO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.FUMADOR_TITULAR) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FUMADOR_TITULAR, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.FUMADOR_TITULAR)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FUMADOR_TITULAR, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.FUMADOR_TITULAR < 0 || item.FUMADOR_TITULAR > 1) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna FUMADOR_TITULAR no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.NO_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.ID_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna ID_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}

            if (item.TIPO == 2) {
              var dataBeneficiary = {
                familia: item.FAMILIA,
                certificate: item.CERTIFICADO,
                optional_relationship: item.PARENTESCO,
                first_name: item.NOMBRE,
                last_name: item.APELLIDO_PATERNO,
                second_last_name: item.APELLIDO_MATERNO,
                birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                sex: item.SEXO,
                antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                percentage: 0,
              };
              $scope.beneficiaries_life.push(dataBeneficiary);
            }
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.ASEGURADOS) {
        if ($scope.ramoSelected.name == "Accidentes y Enfermedades") {
          $scope.beneficiaries_medical = [];
          $scope.excelJson = param.ASEGURADOS;
          $scope.excelJson.forEach(function (item) {
            if (!item.FAMILIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FAMILIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CERTIFICADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.TIPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.TIPO < 1 || item.TIPO > 2) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.PARENTESCO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PARENTESCO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PARENTESCO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.PARENTESCO < 1 || item.PARENTESCO > 4) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna PARENTESCO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.NOMBRE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NOMBRE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_PATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_PATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.APELLIDO_MATERNO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna APELLIDO_MATERNO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.FECHA_NACIMIENTO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_NACIMIENTO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_NACIMIENTO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SEXO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SEXO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (item.SEXO.length > 1) {
                SweetAlert.swal(
                  "Error",
                  "Los valores de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SEXO no son válidos, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.FECHA_ANTIGUEDAD) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.FECHA_ANTIGUEDAD)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna FECHA_ANTIGUEDAD, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
            if (!item.NO_CARATULA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_CARATULA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.ID_CARATULA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ID_CARATULA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }

            if (item.TIPO == 2) {
              var dataBeneficiary = {
                familia: item.FAMILIA,
                caratula: item.ID_CARATULA,
                certificate: item.CERTIFICADO,
                relationship: item.PARENTESCO,
                first_name: item.NOMBRE,
                last_name: item.APELLIDO_PATERNO,
                second_last_name: item.APELLIDO_MATERNO,
                birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                sex: item.SEXO,
                antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                clause: item.FAMILIA,
                p_neta: item.PRIMA_NETA ? item.PRIMA_NETA : 0,
                rpf: item.RPF ? item.RPF : 0,
                derecho: item.DERECHO ? item.DERECHO : 0,
                iva: item.IVA ? item.IVA : 0,
                p_total: item.PRIMA_TOTAL ? item.PRIMA_TOTAL : 0,
                comision: item.COMISION ? item.COMISION : 0,
              };
              $scope.beneficiaries_medical.push(dataBeneficiary);
            }
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.FLOTILLA) {
        if ($scope.ramoSelected.name == "Automóviles") {
          $scope.excelJson = param.FLOTILLA;
          $scope.excelJson.forEach(function (item) {
            if (!item.INCISO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna INCISO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.MARCA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MODELO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.ANIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ANIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SERVICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERVICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            // if(!item.PROCEDENCIA){
            //   SweetAlert.swal('Error', 'Esta vacía la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.', 'error');
            //   flagCertificate = true;
            // }else{
            //   if(isNaN(item.PROCEDENCIA)){
            //     SweetAlert.swal('Error', 'Formato inválido de la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna PROCEDENCIA, corrige el error y vuelve a subir el excel.', 'error');
            //     flagCertificate = true;
            //   }else{
            //     if(item.PROCEDENCIA < 0 || item.PROCEDENCIA > 4){
            //       SweetAlert.swal('Error', 'Los valores de la linea ' + (parseInt(item.__rowNum__) + 1) +' de la columna PROCEDENCIA no son válidos, corrige el error y vuelve a subir el excel.', 'error');
            //       flagCertificate = true;
            //     }
            //   }
            // }
            if (!item.USO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna USO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.USO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.USO < 1 || item.USO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.VERSION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SERIE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.NO_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.ID_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna ID_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.DANIOS_DIVERSO) {
        if ($scope.ramoSelected.name == "Diversos") {
          $scope.excelJson = param.DANIOS_DIVERSO;
          $scope.excelJson.forEach(function (item) {
            if (!item.CERTIFICADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.MARCA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MARCA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MODELO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MODELO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.DESCRIPCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna DESCRIPCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.AÑO_CONSTRUCCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna AÑO_CONSTRUCCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.AÑO_RECONSTRUCCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna AÑO_RECONSTRUCCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.VALOR_COMPRA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VALOR_COMPRA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.USO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna USO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.USO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna USO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.USO < 1 || item.USO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna USO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.VERSION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VERSION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SERIE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SERIE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.VIGENCIA_INICIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_INICIO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_INICIO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.VIGENCIA_FIN) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateDate(item.VIGENCIA_FIN)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna VIGENCIA_FIN, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.NO_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.ID_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna ID_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.DANIOS_IRC) {
        if (
          $scope.ramoSelected.name == "Incendio" ||
          $scope.ramoSelected.name == "Responsabilidad Civil"
        ) {
          $scope.excelJson = param.DANIOS_IRC;
          $scope.excelJson.forEach(function (item) {
            if (!item.CERTIFICADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.SUCURSAL) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUCURSAL, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.GIRO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna GIRO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.TIPO_CONSTRUCTIVO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna TIPO_CONSTRUCTIVO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.TIPO_CONSTRUCTIVO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna TIPO_CONSTRUCTIVO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              } else {
                if (item.TIPO_CONSTRUCTIVO < 1 || item.TIPO_CONSTRUCTIVO > 3) {
                  SweetAlert.swal(
                    "Error",
                    "Los valores de la linea " +
                      (parseInt(item.__rowNum__) + 1) +
                      " de la columna TIPO_CONSTRUCTIVO no son válidos, corrige el error y vuelve a subir el excel.",
                    "error"
                  );
                  flagCertificate = true;
                }
              }
            }
            if (!item.NO_NIVELES) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_NIVELES, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.ZONA_FHM) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ZONA_FHM, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.ZONA_TYEV) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ZONA_TYEV, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CALLE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CALLE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.NO_INTERIOR) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_INTERIOR, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.NO_EXTERIOR) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna NO_EXTERIOR, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.MUNICIPIO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna MUNICIPIO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.COLONIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna COLONIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CIUDAD) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CIUDAD, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.ESTADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna ESTADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CP) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CP, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.NO_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.ID_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna ID_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else if (param.DANIOS) {
        if ($scope.ramoSelected.name == "Daños") {
          $scope.excelJson = param.DANIOS;
          $scope.excelJson.forEach(function (item) {
            if (!item.CERTIFICADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CERTIFICADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.CORREO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (!$scope.validateEmail(item.CORREO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CORREO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.BIEN_ASEGURADO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna BIEN_ASEGURADO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.BIEN_DETALLES) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna BIEN_DETALLES, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.BIEN_DIRECCION) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna BIEN_DIRECCION, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            }
            if (!item.SUBGRUPO) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.SUBGRUPO)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna SUBGRUPO, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.CATEGORIA) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.CATEGORIA)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna CATEGORIA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            if (!item.PAQUETE) {
              SweetAlert.swal(
                "Error",
                "Esta vacía la linea " +
                  (parseInt(item.__rowNum__) + 1) +
                  " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                "error"
              );
              flagCertificate = true;
            } else {
              if (isNaN(item.PAQUETE)) {
                SweetAlert.swal(
                  "Error",
                  "Formato inválido de la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PAQUETE, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            }
            try {
              if (item.PRIMA_NETA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_NETA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.RPF.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna RPF contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.DERECHO.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna DERECHO contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.IVA.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna IVA contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.PRIMA_TOTAL.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna PRIMA_TOTAL contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (item.COMISION.indexOf(",") > -1) {
                SweetAlert.swal(
                  "Error",
                  "Esta linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna COMISION contiene coma (,), elimina y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.NO_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna NO_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
              if (!item.ID_CARATULA) {
                SweetAlert.swal(
                  "Error",
                  "Esta vacía la linea " +
                    (parseInt(item.__rowNum__) + 1) +
                    " de la columna ID_CARATULA, corrige el error y vuelve a subir el excel.",
                  "error"
                );
                flagCertificate = true;
              }
            } catch (e) {}
          });

          if (!flagCertificate) {
            $scope.selectedCertificates = param;
            $scope.addViews(0);
          }
        } else {
          SweetAlert.swal(
            "Error",
            "El layout no corresponde al subramo de la carátula. Revisa el layout seleccionado.",
            "error"
          );
        }
      } else {
        SweetAlert.swal(
          "Error",
          "El layout no corresponde a ninguno de nuestros formatos. Revisa el layout seleccionado",
          "error"
        );
      }
    };

    $scope.addViews = function (value) {
      $scope.showTableCertificates = true;
      if (value == 0) {
        $scope.valueInitial = 1;
        $scope.valueFinal = $scope.optionViews.value;
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else if (value == 1) {
        $scope.valueInitial = $scope.valueInitial + $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
        if ($scope.valueFinal > $scope.excelJson.length) {
          $scope.valueFinal = $scope.excelJson.length;
        }
      } else {
        $scope.valueInitial = $scope.valueInitial - $scope.optionViews.value;
        $scope.valueFinal =
          $scope.valueInitial + ($scope.optionViews.value - 1);
      }
      $scope.changeViews();
    };

    $scope.changeViews = function () {
      $scope.excelJsonViews = [];
      $scope.excelJson.forEach(function (item, index) {
        if (index + 1 >= $scope.valueInitial && index < $scope.valueFinal) {
          $scope.excelJsonViews.push(item);
        }
      });
    };

    $scope.validateEmail = function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    $scope.validado = false;
    $scope.validateDate = function (date) {
      var date_initial = date.split("/");
      var day = parseInt(date_initial[0]);
      var month = parseInt(date_initial[1]);
      var year = parseInt(date_initial[2]);

      if (month > 12) {
        return false;
      } else {
        if (String(year).length != 4) {
          return false;
        } else {
          return true;
        }
      }
    };

    $scope.cancelCertificates = function () {
      $scope.selectedPolices = [];
      $scope.excelJson = [];
      $scope.excelJsonViews = [];
      $scope.loadingValidate = false;
      $scope.loadingSave = false;
      $scope.loader = false;
      if (socket) {
        socket.disconnect();
      }
    };

    vm.lista_carga_certificados = [];
    $scope.validateCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      // $scope.loader = true;
      $scope.certifcados = [];
      $scope.dataSubgroup = [];
      if ($scope.selectedCertificates.ASEGURADOS_vida) {
        $scope.selectedCertificates.ASEGURADOS_vida.forEach(function (item) {
          if (item.TIPO == 1) {
            var dataLife = [
              {
                personal: {
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                  antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  salary: item.SUELDO ? parseInt(item.SUELDO) : 0,
                  sum_assured: item.SUMA_ASEGURADA
                    ? parseInt(item.SUMA_ASEGURADA)
                    : 0,
                  type_sa: item.TIPO_SUMA_ASEGURADA
                    ? parseInt(item.TIPO_SUMA_ASEGURADA)
                    : 0,
                  smoker: item.FUMADOR_TITULAR
                    ? item.FUMADOR_TITULAR == 0
                      ? false
                      : true
                    : null,
                },
                smoker: item.FUMADOR_TITULAR
                  ? item.FUMADOR_TITULAR == 0
                    ? false
                    : true
                  : null,
                beneficiaries_life: [],
              },
            ];

            $scope.beneficiaries_life.forEach(function (beneficiarie) {
              if (beneficiarie.familia == item.FAMILIA) {
                dataLife[0].beneficiaries_life.push(beneficiarie);
              }
            });

            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            if (item.SUBGRUPO) {
              $scope.dataSubgroup.forEach(function (itemSubgrupo) {
                if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                  if (itemSubgrupo.address) {
                    contractor_certificate = itemSubgrupo.contractor
                      ? itemSubgrupo.contractor.id
                      : null;
                  } else {
                    contractor_certificate = $scope.dataCaratula.contractor
                      ? $scope.dataCaratula.contractor
                      : null;
                  }
                }
              });
            } else {
              contractor_certificate = $scope.dataCaratula.contractor
                ? $scope.dataCaratula.contractor
                : null;
            }

            var certificateData = {
              caratula: item.ID_CARATULA,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number: item.NO_CARATULA + " - INC. " + item.CERTIFICADO,
              contractor: null,
              ramo: null,
              subramo: null,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
              end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
              status: 14,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: [],
              life_policy: dataLife,
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "VIDA_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: item.PRIMA_NETA
                ? parseFloat(item.PRIMA_NETA).toFixed(2)
                : 0,
              rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
              derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
              iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
              p_total: item.PRIMA_TOTAL
                ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                : 0,
              comision: item.COMISION
                ? parseFloat(item.COMISION).toFixed(2)
                : 0,
              rec_antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
            };

            $scope.certifcados.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.ASEGURADOS) {
        $scope.selectedCertificates.ASEGURADOS.forEach(function (item) {
          $scope.sum_neta = 0;
          $scope.sum_rpf = 0;
          $scope.sum_derecho = 0;
          $scope.sum_iva = 0;
          $scope.sum_total = 0;
          $scope.sum_comision = 0;
          if (item.TIPO == 1) {
            var dataMedical = [
              {
                personal: {
                  caratula: item.ID_CARATULA,
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                  antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  p_neta: item.PRIMA_NETA
                    ? parseFloat(item.PRIMA_NETA).toFixed(2)
                    : 0,
                  rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
                  derecho: item.DERECHO
                    ? parseFloat(item.DERECHO).toFixed(2)
                    : 0,
                  iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
                  p_total: item.PRIMA_TOTAL
                    ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                    : 0,
                  comision: item.COMISION
                    ? parseFloat(item.COMISION).toFixed(2)
                    : 0,
                },
                disease_type: 0,
                relationship_accident: [],
              },
            ];
            $scope.sum_neta = dataMedical[0].personal.p_neta;
            $scope.sum_rpf = dataMedical[0].personal.rpf;
            $scope.sum_derecho = dataMedical[0].personal.derecho;
            $scope.sum_iva = dataMedical[0].personal.iva;
            $scope.sum_total = dataMedical[0].personal.p_total;
            $scope.sum_comision = dataMedical[0].personal.comision;

            $scope.beneficiaries_medical.forEach(function (beneficiarie) {
              if (
                beneficiarie.familia == item.FAMILIA &&
                item.ID_CARATULA == beneficiarie.caratula
              ) {
                dataMedical[0].relationship_accident.push(beneficiarie);
                $scope.sum_neta = parseFloat(
                  parseFloat($scope.sum_neta) + parseFloat(beneficiarie.p_neta)
                ).toFixed(2);
                $scope.sum_rpf = parseFloat(
                  parseFloat($scope.sum_rpf) + parseFloat(beneficiarie.rpf)
                ).toFixed(2);
                $scope.sum_derecho = parseFloat(
                  parseFloat($scope.sum_derecho) +
                    parseFloat(beneficiarie.derecho)
                ).toFixed(2);
                $scope.sum_iva = parseFloat(
                  parseFloat($scope.sum_iva) + parseFloat(beneficiarie.iva)
                ).toFixed(2);
                $scope.sum_total = parseFloat(
                  parseFloat($scope.sum_total) +
                    parseFloat(beneficiarie.p_total)
                ).toFixed(2);
                $scope.sum_comision = parseFloat(
                  parseFloat($scope.sum_comision) +
                    parseFloat(beneficiarie.comision)
                ).toFixed(2);
              }
            });

            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            var certificateData = {
              caratula: item.ID_CARATULA,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number: item.NO_CARATULA + " - INC. " + item.CERTIFICADO,
              contractor: contractor_certificate,
              ramo: null,
              subramo: null,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
              end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
              status: 14,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: dataMedical,
              life_policy: [],
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "GASTOS_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: $scope.sum_neta
                ? parseFloat($scope.sum_neta).toFixed(2)
                : item.PRIMA_NETA
                ? parseFloat(item.PRIMA_NETA).toFixed(2)
                : 0,
              rpf: $scope.sum_rpf
                ? parseFloat($scope.sum_rpf).toFixed(2)
                : item.RPF
                ? parseFloat(item.RPF).toFixed(2)
                : 0,
              derecho: $scope.sum_derecho
                ? parseFloat($scope.sum_derecho).toFixed(2)
                : item.DERECHO
                ? parseFloat(item.DERECHO).toFixed(2)
                : 0,
              iva: $scope.sum_iva
                ? parseFloat($scope.sum_iva).toFixed(2)
                : item.IVA
                ? parseFloat(item.IVA).toFixed(2)
                : 0,
              p_total: $scope.sum_total
                ? parseFloat($scope.sum_total).toFixed(2)
                : item.PRIMA_TOTAL
                ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                : 0,
              comision: $scope.sum_comision
                ? parseFloat($scope.sum_comision).toFixed(2)
                : item.COMISION
                ? parseFloat(item.COMISION).toFixed(2)
                : 0,
              rec_antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
            };
            $scope.certifcados.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.FLOTILLA) {
        $scope.selectedCertificates.FLOTILLA.forEach(function (item) {
          var dataCar = [
            {
              car_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              driver: item.CONDUCTOR ? item.CONDUCTOR : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              brand: item.MARCA,
              model: item.MODELO,
              year: item.ANIO,
              version: item.VERSION,
              serial: item.SERIE,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              license_plates: item.MATRICULA ? item.MATRICULA : null,
              usage: parseInt(item.USO),
              service: item.SERVICIO,
              procedencia: parseInt(item.PROCEDENCIA ? item.PROCEDENCIA : 0),
              sum_insured: item.VALOR_O_SUMA_ASEGURADA
                ? item.VALOR_O_SUMA_ASEGURADA
                : null,
              charge_type: item.TIPO_CARGA ? parseInt(item.TIPO_CARGA) : null,
              adjustment: item.ADAPTACIONES ? item.ADAPTACIONES : null,
              mont_adjustment: item.MONTO_ADAPTACIONES
                ? item.MONTO_ADAPTACIONES
                : null,
              special_team: item.EQUIPAMIENTO ? item.EQUIPAMIENTO : null,
              mont_special_team: item.MONTO_EQUIPAMIENTO
                ? item.MONTO_EQUIPAMIENTO
                : null,
              beneficiary_name: null,
              preferential_benefiaciary: item.BENEFICIARIO_PREFERENTE
                ? item.BENEFICIARIO_PREFERENTE
                : null,
              beneficiary_rfc: item.BENEFICIARIO_RFC
                ? item.BENEFICIARIO_RFC
                : null,
              beneficiary_address: item.BENEFICIARIO_DIRECCION
                ? item.BENEFICIARIO_DIRECCION
                : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.dataSubgroup.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.dataCaratula.contractor
                    ? $scope.dataCaratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.dataCaratula.contractor
              ? $scope.dataCaratula.contractor
              : null;
          }

          var certificateData = {
            caratula: item.ID_CARATULA,
            certificate_number: item.INCISO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number: item.NO_CARATULA + " - INC. " + item.INCISO,
            contractor: contractor_certificate,
            ramo: null,
            subramo: null,
            paquete: item.PAQUETE,
            observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
            old_policies: [],
            start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
            end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
            status: 14,
            automobiles_policy: dataCar,
            damages_policy: [],
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA
              ? parseFloat(item.PRIMA_NETA).toFixed(2)
              : 0,
            rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
            derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
            iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
            p_total: item.PRIMA_TOTAL
              ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
              : 0,
            comision: item.COMISION ? parseFloat(item.COMISION).toFixed(2) : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      } else if (
        $scope.selectedCertificates.DANIOS_DIVERSO ||
        $scope.selectedCertificates.DANIOS_IRC
      ) {
        var excelJson = [];
        if ($scope.selectedCertificates.DANIOS_DIVERSO) {
          excelJson = $scope.selectedCertificates.DANIOS_DIVERSO;
        } else if ($scope.selectedCertificates.DANIOS_IRC) {
          excelJson = $scope.selectedCertificates.DANIOS_IRC;
        }
        excelJson.forEach(function (item) {
          var dataDamage = [
            {
              dam_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              item_details: item.OBSERVACIONES,
              usage: item.USO ? parseInt(item.USO) : 0,
              brand: item.MARCA ? item.MARCA : null,
              model: item.MODELO ? item.MODELO : null,
              construction_year: item.AÑO_CONSTRUCCION
                ? item.AÑO_CONSTRUCCION
                : null,
              reconstruction_year: item.AÑO_RECONSTRUCCION
                ? item.AÑO_RECONSTRUCCION
                : null,
              version: item.VERSION ? item.VERSION : null,
              serial: item.SERIE ? item.SERIE : null,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              matricula: item.MATRICULA ? item.MATRICULA : null,
              permiso: item.PERMISO ? item.PERMISO : null,
              purchase_value: item.VALOR_COMPRA ? item.VALOR_COMPRA : 0,
              item_address:
                item.CALLE +
                " " +
                item.NO_INTERIOR +
                " Ext." +
                item.NO_EXTERIOR +
                " " +
                item.COLONIA +
                " " +
                item.CIUDAD +
                " " +
                item.ESTADO +
                " C.P." +
                item.CP,
              sucursal: item.SUCURSAL ? item.SUCURSAL : null,
              giro: item.GIRO ? item.GIRO : null,
              type_construction: item.TIPO_CONSTRUCTIVO
                ? parseInt(item.TIPO_CONSTRUCTIVO)
                : 0,
              no_levels: item.NO_NIVELES ? item.NO_NIVELES : null,
              fhm_zone: item.ZONA_FHM ? item.ZONA_FHM : null,
              tyev_zone: item.ZONA_TYEV ? item.ZONA_TYEV : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.dataSubgroup.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.dataCaratula.contractor
                    ? $scope.dataCaratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.dataCaratula.contractor
              ? $scope.dataCaratula.contractor
              : null;
          }

          var certificateData = {
            caratula: item.ID_CARATULA,
            certificate_number: item.CERTIFICADO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number: item.NO_CARATULA + " - INC. " + item.CERTIFICADO,
            contractor: contractor_certificate,
            ramo: null,
            subramo: null,
            paquete: item.PAQUETE,
            observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
            old_policies: [],
            start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
            end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
            status: 14,
            automobiles_policy: [],
            damages_policy: dataDamage,
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA
              ? parseFloat(item.PRIMA_NETA).toFixed(2)
              : 0,
            rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
            derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
            iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
            p_total: item.PRIMA_TOTAL
              ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
              : 0,
            comision: item.COMISION ? parseFloat(item.COMISION).toFixed(2) : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      } else if ($scope.selectedCertificates.DANIOS) {
        var excelJson = [];
        if ($scope.selectedCertificates.DANIOS) {
          excelJson = $scope.selectedCertificates.DANIOS;
        }
        excelJson.forEach(function (item) {
          var dataDamage1 = [
            {
              insured_item: item.BIEN_ASEGURADO ? item.BIEN_ASEGURADO : "",
              email: item.CORREO,
              item_address: item.BIEN_DIRECCION ? item.BIEN_DIRECCION : "",
              item_details: item.BIEN_DETALLES ? item.BIEN_DETALLES : "",
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.dataSubgroup.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.dataCaratula.contractor
                    ? $scope.dataCaratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.dataCaratula.contractor
              ? $scope.dataCaratula.contractor
              : null;
          }

          var certificateData = {
            caratula: item.ID_CARATULA,
            certificate_number: item.CERTIFICADO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number: item.NO_CARATULA + " - INC. " + item.CERTIFICADO,
            contractor: contractor_certificate,
            ramo: null,
            subramo: null,
            paquete: item.PAQUETE,
            observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
            old_policies: [],
            start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
            end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
            status: 14,
            automobiles_policy: [],
            damages_policy: dataDamage1,
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier:
              item.BIEN_ASEGURADO +
              "_" +
              item.BIEN_DETALLES +
              "_" +
              item.CERTIFICADO,
            p_neta: item.PRIMA_NETA
              ? parseFloat(item.PRIMA_NETA).toFixed(2)
              : 0,
            rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
            derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
            iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
            p_total: item.PRIMA_TOTAL
              ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
              : 0,
            comision: item.COMISION ? parseFloat(item.COMISION).toFixed(2) : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      }
      $scope.loadingValidate = true;
      $http({
        method: "POST",
        url: url.IP + "validate-certificates-massive",
        data: {
          certificados: $scope.certifcados,
          validar: true,
        },
      })
        .then(
          function (response) {
            $scope.loadingValidate = false;
            if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length > 0
            ) {
              if (response["data"]) {
                $scope.loadingValidate = true;
                // Conexión a socket.io
                // var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // if($scope.org_name =='ancora'){
                //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                // }else{
                var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // }
                //var socket = io.connect("http://127.0.0.1:8080");
                socket.emit("subscribe", response.data);
                // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                // socket.on('result', function(url){
                socket.on(response.data, function (url) {
                  $scope.loadingValidate = false;
                  $scope.validado = true;
                  socket.disconnect();
                  SweetAlert.swal({
                    title:
                      "El reporte de retroalimentación sobre certificados cargados está listo para descargar",
                    icon: "success",
                    text: "Encuentra la liga de descarga en la sección de notificaciones",
                    timer: 5000,
                  });
                  // var notificacion = {
                  //   'title': 'La lista de retroalimentación de certificados cargados ha sido generado',
                  //   'description': url,
                  //   'model': 26,
                  //   'id_reference':0
                  // }
                  // dataFactory.post('notificaciones/', notificacion)
                  // .then(function success(response) {
                  //   SweetAlert.swal({
                  //     title: 'El reporte de retroalimentación sobre certificados cargados está listo para descargar',
                  //     icon: 'success',
                  //     text: 'Encuentra la liga de descarga en la sección de notificaciones',
                  //     timer: 5000
                  //   });
                  //   $scope.loadingValidate = false;
                  //   $scope.validado = true;
                  //   socket.disconnect();
                  // }).catch(function(err) {
                  //   socket.disconnect();
                  //   $scope.loadingValidate = false;
                  //   $scope.validado = true;
                  // })
                });
                toaster.info(
                  "Generando...",
                  "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                );
              }
            } else if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length == 0
            ) {
              $scope.loadingValidate = false;
              $scope.validado = true;
              SweetAlert.swal(
                "Cargado",
                "Archivo validado exitosamente",
                "success"
              );
            } else {
              $scope.loadingValidate = false;
              SweetAlert.swal(
                "Error",
                "Ocurrieron errores en el proceso",
                "error"
              );
            }
          },
          function (error) {
            $scope.loadingValidate = false;
          }
        )
        .catch(function (error) {
          $scope.loadingValidate = false;
        });
    };
    $scope.saveCertificates = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.loadingSave = true;
      $scope.certifcados = [];
      $scope.dataSubgroup = [];

      if ($scope.selectedCertificates.ASEGURADOS_vida) {
        $scope.selectedCertificates.ASEGURADOS_vida.forEach(function (item) {
          if (item.TIPO == 1) {
            var dataLife = [
              {
                personal: {
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                  antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  salary: item.SUELDO ? parseInt(item.SUELDO) : 0,
                  sum_assured: item.SUMA_ASEGURADA
                    ? parseInt(item.SUMA_ASEGURADA)
                    : 0,
                  type_sa: item.TIPO_SUMA_ASEGURADA
                    ? parseInt(item.TIPO_SUMA_ASEGURADA)
                    : 0,
                },
                smoker: item.FUMADOR_TITULAR
                  ? item.FUMADOR_TITULAR == 0
                    ? false
                    : true
                  : null,
                beneficiaries_life: [],
              },
            ];

            $scope.beneficiaries_life.forEach(function (beneficiarie) {
              if (beneficiarie.familia == item.FAMILIA) {
                dataLife[0].beneficiaries_life.push(beneficiarie);
              }
            });

            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            if (item.SUBGRUPO) {
              $scope.dataSubgroup.forEach(function (itemSubgrupo) {
                if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                  if (itemSubgrupo.address) {
                    contractor_certificate = itemSubgrupo.contractor
                      ? itemSubgrupo.contractor.id
                      : null;
                  } else {
                    contractor_certificate = $scope.dataCaratula.contractor
                      ? $scope.dataCaratula.contractor
                      : null;
                  }
                }
              });
            } else {
              contractor_certificate = $scope.dataCaratula.contractor
                ? $scope.dataCaratula.contractor
                : null;
            }

            var certificateData = {
              caratula: item.ID_CARATULA,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number: item.NO_CARATULA + " - INC. " + item.CERTIFICADO,
              contractor: contractor_certificate,
              ramo: null,
              subramo: null,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
              end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
              status: 14,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: [],
              life_policy: dataLife,
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "VIDA_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: item.PRIMA_NETA
                ? parseFloat(item.PRIMA_NETA).toFixed(2)
                : 0,
              rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
              derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
              iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
              p_total: item.PRIMA_TOTAL
                ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                : 0,
              comision: item.COMISION
                ? parseFloat(item.COMISION).toFixed(2)
                : 0,
              rec_antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
            };

            $scope.certifcados.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.ASEGURADOS) {
        $scope.selectedCertificates.ASEGURADOS.forEach(function (item) {
          $scope.sum_neta = 0;
          $scope.sum_rpf = 0;
          $scope.sum_derecho = 0;
          $scope.sum_iva = 0;
          $scope.sum_total = 0;
          $scope.sum_comision = 0;
          if (item.TIPO == 1) {
            var dataMedical = [
              {
                personal: {
                  caratula: item.ID_CARATULA,
                  certificate: item.CERTIFICADO,
                  first_name: item.NOMBRE,
                  last_name: item.APELLIDO_PATERNO,
                  second_last_name: item.APELLIDO_MATERNO,
                  birthdate: datesFactory.toDate(item.FECHA_NACIMIENTO),
                  antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
                  sex: item.SEXO,
                  email: item.CORREO,
                  p_neta: item.PRIMA_NETA
                    ? parseFloat(item.PRIMA_NETA).toFixed(2)
                    : 0,
                  rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
                  derecho: item.DERECHO
                    ? parseFloat(item.DERECHO).toFixed(2)
                    : 0,
                  iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
                  p_total: item.PRIMA_TOTAL
                    ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                    : 0,
                  comision: item.COMISION
                    ? parseFloat(item.COMISION).toFixed(2)
                    : 0,
                },
                disease_type: 0,
                relationship_accident: [],
              },
            ];
            $scope.sum_neta = dataMedical[0].personal.p_neta;
            $scope.sum_rpf = dataMedical[0].personal.rpf;
            $scope.sum_derecho = dataMedical[0].personal.derecho;
            $scope.sum_iva = dataMedical[0].personal.iva;
            $scope.sum_total = dataMedical[0].personal.p_total;
            $scope.sum_comision = dataMedical[0].personal.comision;

            $scope.beneficiaries_medical.forEach(function (beneficiarie) {
              if (
                beneficiarie.familia == item.FAMILIA &&
                item.ID_CARATULA == beneficiarie.caratula
              ) {
                dataMedical[0].relationship_accident.push(beneficiarie);
                $scope.sum_neta = parseFloat(
                  parseFloat($scope.sum_neta) + parseFloat(beneficiarie.p_neta)
                ).toFixed(2);
                $scope.sum_rpf = parseFloat(
                  parseFloat($scope.sum_rpf) + parseFloat(beneficiarie.rpf)
                ).toFixed(2);
                $scope.sum_derecho = parseFloat(
                  parseFloat($scope.sum_derecho) +
                    parseFloat(beneficiarie.derecho)
                ).toFixed(2);
                $scope.sum_iva = parseFloat(
                  parseFloat($scope.sum_iva) + parseFloat(beneficiarie.iva)
                ).toFixed(2);
                $scope.sum_total = parseFloat(
                  parseFloat($scope.sum_total) +
                    parseFloat(beneficiarie.p_total)
                ).toFixed(2);
                $scope.sum_comision = parseFloat(
                  parseFloat($scope.sum_comision) +
                    parseFloat(beneficiarie.comision)
                ).toFixed(2);
              }
            });

            var natural_certificate = null;
            var juridical_certificate = null;
            var contractor_certificate = null;

            var certificateData = {
              caratula: item.ID_CARATULA,
              certificate_number: item.CERTIFICADO,
              folio: item.FOLIO ? item.FOLIO : "",
              parent: item.CATEGORIA,
              poliza_number: item.NO_CARATULA + " - INC. " + item.CERTIFICADO,
              contractor: contractor_certificate,
              ramo: null,
              subramo: null,
              paquete: item.PAQUETE,
              observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
              old_policies: [],
              start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
              end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
              status: 14,
              automobiles_policy: [],
              damages_policy: [],
              accidents_policy: dataMedical,
              life_policy: [],
              document_type: 6,
              coverageInPolicy_policy: [],
              identifier: "GASTOS_" + item.NOMBRE + "_" + item.APELLIDO_PATERNO,
              p_neta: $scope.sum_neta
                ? parseFloat($scope.sum_neta).toFixed(2)
                : item.PRIMA_NETA
                ? parseFloat(item.PRIMA_NETA).toFixed(2)
                : 0,
              rpf: $scope.sum_rpf
                ? parseFloat($scope.sum_rpf).toFixed(2)
                : item.RPF
                ? parseFloat(item.RPF).toFixed(2)
                : 0,
              derecho: $scope.sum_derecho
                ? parseFloat($scope.sum_derecho).toFixed(2)
                : item.DERECHO
                ? parseFloat(item.DERECHO).toFixed(2)
                : 0,
              iva: $scope.sum_iva
                ? parseFloat($scope.sum_iva).toFixed(2)
                : item.IVA
                ? parseFloat(item.IVA).toFixed(2)
                : 0,
              p_total: $scope.sum_total
                ? parseFloat($scope.sum_total).toFixed(2)
                : item.PRIMA_TOTAL
                ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
                : 0,
              comision: $scope.sum_comision
                ? parseFloat($scope.sum_comision).toFixed(2)
                : item.COMISION
                ? parseFloat(item.COMISION).toFixed(2)
                : 0,
              rec_antiguedad: datesFactory.toDate(item.FECHA_ANTIGUEDAD),
              contacto: "",
            };
            $scope.certifcados.push(certificateData);
          }
        });
      } else if ($scope.selectedCertificates.FLOTILLA) {
        $scope.selectedCertificates.FLOTILLA.forEach(function (item) {
          var dataCar = [
            {
              car_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              driver: item.CONDUCTOR ? item.CONDUCTOR : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              brand: item.MARCA,
              model: item.MODELO,
              year: item.ANIO,
              version: item.VERSION,
              serial: item.SERIE,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              license_plates: item.MATRICULA ? item.MATRICULA : null,
              usage: parseInt(item.USO),
              service: item.SERVICIO,
              procedencia: parseInt(item.PROCEDENCIA),
              sum_insured: item.VALOR_O_SUMA_ASEGURADA
                ? item.VALOR_O_SUMA_ASEGURADA
                : null,
              charge_type: item.TIPO_CARGA ? parseInt(item.TIPO_CARGA) : null,
              adjustment: item.ADAPTACIONES ? item.ADAPTACIONES : null,
              mont_adjustment: item.MONTO_ADAPTACIONES
                ? item.MONTO_ADAPTACIONES
                : null,
              special_team: item.EQUIPAMIENTO ? item.EQUIPAMIENTO : null,
              mont_special_team: item.MONTO_EQUIPAMIENTO
                ? item.MONTO_EQUIPAMIENTO
                : null,
              beneficiary_name: null,
              preferential_benefiaciary: item.BENEFICIARIO_PREFERENTE
                ? item.BENEFICIARIO_PREFERENTE
                : null,
              beneficiary_rfc: item.BENEFICIARIO_RFC
                ? item.BENEFICIARIO_RFC
                : null,
              beneficiary_address: item.BENEFICIARIO_DIRECCION
                ? item.BENEFICIARIO_DIRECCION
                : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.dataSubgroup.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.dataCaratula.contractor
                    ? $scope.dataCaratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.dataCaratula.contractor
              ? $scope.dataCaratula.contractor
              : null;
          }

          var certificateData = {
            caratula: item.ID_CARATULA,
            certificate_number: item.INCISO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number: item.NO_CARATULA + " - INC. " + item.INCISO,
            contractor: contractor_certificate,
            ramo: null,
            subramo: null,
            paquete: item.PAQUETE,
            observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
            old_policies: [],
            start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
            end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
            status: 14,
            automobiles_policy: dataCar,
            damages_policy: [],
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA
              ? parseFloat(item.PRIMA_NETA).toFixed(2)
              : 0,
            rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
            derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
            iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
            p_total: item.PRIMA_TOTAL
              ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
              : 0,
            comision: item.COMISION ? parseFloat(item.COMISION).toFixed(2) : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      } else if (
        $scope.selectedCertificates.DANIOS_DIVERSO ||
        $scope.selectedCertificates.DANIOS_IRC
      ) {
        var excelJson = [];
        if ($scope.selectedCertificates.DANIOS_DIVERSO) {
          excelJson = $scope.selectedCertificates.DANIOS_DIVERSO;
        } else if ($scope.selectedCertificates.DANIOS_IRC) {
          excelJson = $scope.selectedCertificates.DANIOS_IRC;
        }
        excelJson.forEach(function (item) {
          var dataDamage = [
            {
              dam_owner: item.PROPIETARIO ? item.PROPIETARIO : null,
              email: item.CORREO,
              no_employee: item.NO_EMPLEADO ? item.NO_EMPLEADO : null,
              item_details: item.OBSERVACIONES,
              usage: item.USO ? parseInt(item.USO) : 0,
              brand: item.MARCA ? item.MARCA : null,
              model: item.MODELO ? item.MODELO : null,
              construction_year: item.AÑO_CONSTRUCCION
                ? item.AÑO_CONSTRUCCION
                : null,
              reconstruction_year: item.AÑO_RECONSTRUCCION
                ? item.AÑO_RECONSTRUCCION
                : null,
              version: item.VERSION ? item.VERSION : null,
              serial: item.SERIE ? item.SERIE : null,
              engine: item.MOTOR ? item.MOTOR : null,
              color: item.COLOR ? item.COLOR : null,
              matricula: item.MATRICULA ? item.MATRICULA : null,
              permiso: item.PERMISO ? item.PERMISO : null,
              purchase_value: item.VALOR_COMPRA ? item.VALOR_COMPRA : 0,
              item_address:
                item.CALLE +
                " " +
                item.NO_INTERIOR +
                " Ext." +
                item.NO_EXTERIOR +
                " " +
                item.COLONIA +
                " " +
                item.CIUDAD +
                " " +
                item.ESTADO +
                " C.P." +
                item.CP,
              sucursal: item.SUCURSAL ? item.SUCURSAL : null,
              giro: item.GIRO ? item.GIRO : null,
              type_construction: item.TIPO_CONSTRUCTIVO
                ? parseInt(item.TIPO_CONSTRUCTIVO)
                : 0,
              no_levels: item.NO_NIVELES ? item.NO_NIVELES : null,
              fhm_zone: item.ZONA_FHM ? item.ZONA_FHM : null,
              tyev_zone: item.ZONA_TYEV ? item.ZONA_TYEV : null,
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.dataSubgroup.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.dataCaratula.contractor
                    ? $scope.dataCaratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.dataCaratula.contractor
              ? $scope.dataCaratula.contractor
              : null;
          }

          var certificateData = {
            caratula: item.ID_CARATULA,
            certificate_number: item.CERTIFICADO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number: item.NO_CARATULA + " - INC. " + item.CERTIFICADO,
            contractor: contractor_certificate,
            ramo: null,
            subramo: null,
            paquete: item.PAQUETE,
            observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
            old_policies: [],
            start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
            end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
            status: 14,
            automobiles_policy: [],
            damages_policy: dataDamage,
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier: item.MARCA + "_" + item.MODELO + "_" + item.AÑO,
            p_neta: item.PRIMA_NETA
              ? parseFloat(item.PRIMA_NETA).toFixed(2)
              : 0,
            rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
            derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
            iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
            p_total: item.PRIMA_TOTAL
              ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
              : 0,
            comision: item.COMISION ? parseFloat(item.COMISION).toFixed(2) : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      } else if ($scope.selectedCertificates.DANIOS) {
        var excelJson = [];
        if ($scope.selectedCertificates.DANIOS) {
          excelJson = $scope.selectedCertificates.DANIOS;
        }
        excelJson.forEach(function (item) {
          var dataDamage1 = [
            {
              insured_item: item.BIEN_ASEGURADO ? item.BIEN_ASEGURADO : "",
              email: item.CORREO,
              item_address: item.BIEN_DIRECCION ? item.BIEN_DIRECCION : "",
              item_details: item.BIEN_DETALLES ? item.BIEN_DETALLES : "",
            },
          ];

          var natural_certificate = null;
          var juridical_certificate = null;
          var contractor_certificate = null;

          if (item.SUBGRUPO) {
            $scope.dataSubgroup.forEach(function (itemSubgrupo) {
              if (itemSubgrupo.id == parseInt(item.SUBGRUPO)) {
                if (itemSubgrupo.address) {
                  contractor_certificate = itemSubgrupo.contractor
                    ? itemSubgrupo.contractor.id
                    : null;
                } else {
                  contractor_certificate = $scope.dataCaratula.contractor
                    ? $scope.dataCaratula.contractor
                    : null;
                }
              }
            });
          } else {
            contractor_certificate = $scope.dataCaratula.contractor
              ? $scope.dataCaratula.contractor
              : null;
          }

          var certificateData = {
            caratula: item.ID_CARATULA,
            certificate_number: item.CERTIFICADO,
            folio: item.FOLIO ? item.FOLIO : "",
            parent: item.CATEGORIA,
            poliza_number: item.NO_CARATULA + " - INC. " + item.CERTIFICADO,
            contractor: contractor_certificate,
            ramo: null,
            subramo: null,
            paquete: item.PAQUETE,
            observations: item.OBSERVACIONES ? item.OBSERVACIONES : "",
            old_policies: [],
            start_of_validity: datesFactory.toDate(item.VIGENCIA_INICIO),
            end_of_validity: datesFactory.toDate(item.VIGENCIA_FIN),
            status: 14,
            automobiles_policy: [],
            damages_policy: dataDamage1,
            accidents_policy: [],
            life_policy: [],
            document_type: 6,
            coverageInPolicy_policy: [],
            identifier:
              item.BIEN_ASEGURADO +
              "_" +
              item.BIEN_DETALLES +
              "_" +
              item.CERTIFICADO,
            p_neta: item.PRIMA_NETA
              ? parseFloat(item.PRIMA_NETA).toFixed(2)
              : 0,
            rpf: item.RPF ? parseFloat(item.RPF).toFixed(2) : 0,
            derecho: item.DERECHO ? parseFloat(item.DERECHO).toFixed(2) : 0,
            iva: item.IVA ? parseFloat(item.IVA).toFixed(2) : 0,
            p_total: item.PRIMA_TOTAL
              ? parseFloat(item.PRIMA_TOTAL).toFixed(2)
              : 0,
            comision: item.COMISION ? parseFloat(item.COMISION).toFixed(2) : 0,
            rec_antiguedad: null,
            contacto: "",
          };
          $scope.certifcados.push(certificateData);
        });
      }
      $scope.loadingSave = true;
      $http({
        method: "POST",
        url: url.IP + "validate-certificates-massive",
        data: {
          certificados: $scope.certifcados,
          validar: false,
        },
      })
        .then(
          function (response) {
            $scope.loadingSave = false;
            if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length > 0
            ) {
              if (response["data"]) {
                $scope.loadingSave = true;
                // Conexión a socket.io
                // if($scope.org_name =='ancora'){
                //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
                // }else{
                var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
                // }
                socket.emit("subscribe", response.data);
                // Aquí espera el mensaje que reciba de socketIO cuando el reporte esté listo
                // socket.on('result', function(url){
                socket.on(response.data, function (url) {
                  socket.disconnect();
                  $scope.loadingSave = false;
                  $scope.validado = true;
                  SweetAlert.swal({
                    title:
                      "El reporte de retroalimentación sobre certificados cargados está listo para descargar",
                    icon: "success",
                    text: "El reporte de retroalimentación sobre certificados cargados está listo para descargar",
                    timer: 5000,
                  });
                  // var notificacion = {
                  //   'title': 'La lista de retroalimentación de certificados cargados ha sido generado',
                  //   'description': url,
                  //   'model': 26,
                  //   'id_reference':0
                  // }
                  // dataFactory.post('notificaciones/', notificacion)
                  // .then(function success(response) {
                  //   SweetAlert.swal({
                  //     title: 'El reporte de retroalimentación sobre certificados cargados está listo para descargar',
                  //     icon: 'success',
                  //     text: 'Encuentra la liga de descarga en la sección de notificaciones',
                  //     timer: 5000
                  //   });
                  //   $scope.loadingSave = false;
                  //   $scope.validado = true;
                  //   socket.disconnect();
                  // }).catch(function(err) {
                  //   socket.disconnect();
                  // })
                });
                toaster.info(
                  "Generando...",
                  "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
                );
              }
            } else if (
              response &&
              response["status"] == 200 &&
              response["data"] &&
              response["data"].length == 0
            ) {
              $scope.loadingSave = false;
              SweetAlert.swal(
                "Cargado",
                "Archivo validado exitosamente",
                "success"
              );
            } else {
              $scope.loadingSave = false;
              SweetAlert.swal(
                "Error",
                "Ocurrieron errores en el proceso",
                "error"
              );
            }
          },
          function (error) {
            $scope.loadingSave = false;
          }
        )
        .catch(function (error) {
          $scope.loadingSave = false;
        });
      // $http({
      //   method: 'POST',
      //   url: url.IP + 'massives-certificados/',
      //   data: $scope.certifcados
      // })
      // .then(function success (response) {
      //   l.stop();
      //   if(response.status === 201 || response.status === 200){
      //     $scope.loadingSave = false;
      //     SweetAlert.swal("¡Listo!", MESSAGES.OK.CERTIFICATESDONE, 'success');
      //     $state.go('polizas.table');
      //   }else{
      //     $scope.loadingSave = false;
      //     if (response.data) {
      //       if (response.data.data) {
      //         $scope.certifcados = []
      //         SweetAlert.swal("ERROR",response.data.data, "error");
      //       }else{
      //         $scope.certifcados = []
      //         SweetAlert.swal("ERROR", 'Ocurrió un error al cargar las pólizas.', "error");
      //       }
      //     }else{
      //       $scope.certifcados = []
      //       SweetAlert.swal("ERROR", 'Ocurrió un error al cargar las pólizas.', "error");
      //     }
      //   }
      // })
      // .catch(function (e) {
      //   l.stop();
      //   console.log('error - caratula - catch', e);
      // });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("cargaCatalogoCtrl", cargaCatalogoCtrl);

  cargaCatalogoCtrl.$inject = [
    "$scope",
    "dataFactory",
    "datesFactory",
    "$sessionStorage",
    "$http",
    "providerService",
    "SweetAlert",
    "MESSAGES",
    "url",
    "exportFactory",
    "toaster",
    "$q",
    "helpers",
  ];

  function cargaCatalogoCtrl(
    $scope,
    dataFactory,
    datesFactory,
    $sessionStorage,
    $http,
    providerService,
    SweetAlert,
    MESSAGES,
    url,
    exportFactory,
    toaster,
    $q,
    helpers
  ) {
    var order = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);

    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.org_name = usr.urlname;
    $scope.decrptedtoken = usr;
    $scope.contractorLayout = {};
    $scope.policyLayout = {};
    $scope.caratuleLayout = {};

    activate();

    function activate() {
      $http.get(url.IP + "gruposSubgrupos-resume/").then(function (response) {
        $scope.groups = response.data;
      });

      var d = datesFactory.convertDate(new Date());
      try {
        var day = d.getDate();
        var month = d.getMonth() + 1; //Months are zero based
        var year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var day = f.getDate();
        var month = f.getMonth() + 1; //Months are zero based
        var year = f.getFullYear();
      }

      var date = year + "-" + month + "-" + day;
      providerService.getProviderByKey(date).then(
        function success(data) {
          $scope.providersLayout = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );

      $http.get(url.IP + "usuarios/").then(function (user) {
        $scope.usersLayout = user.data.results;
        $scope.ejecutivosLayout = user.data.results;
      });

      dataFactory.post("celula_contractor_info/").then(function (response) {
        $scope.celulasLayout = response.data;
      });
      $scope.clasificaciones = [];
      dataFactory.get("classification/").then(function (response) {
        response.data.results.forEach(function (item) {
          $scope.clasificaciones.push(item);
        });
      });
      dataFactory.get("groupingLevel-resume/").then(function (response) {
        $scope.agrupacionesLayout = response.data;
      });

      $http
        .get(url.IP + "get-vendors/")
        .then(function (user) {
          $scope.referenciadoresLayout = user.data;
        })
        .catch(function (e) {
          console.log("error", e);
        });

      dataFactory
        .get("sucursales-to-show-unpag/")
        .then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            $scope.sucursalesLayout = response.data;
          }
        })
        .catch(function (e) {
          console.log("error", e);
        });

      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          $scope.statesArray = data.data;
        });
    }

    $scope.downloadExcel = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.url_go_excel = "service_reporte-catalogos-excel";
      $http({
        method: "POST",
        url: url.IP + $scope.url_go_excel,
        data: $scope.filtros,
      })
        .then(function success(response) {
          if (response.status == 200) {
            l.stop();
            // Conexión a socket.io
            // if($scope.org_name =='ancora'){
            //   var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET_ANCORA);
            // }else{
            var socket = io.connect(url.REPORT_SERVICE_NODE_SOCKET);
            // }
            socket.emit("subscribe", response.data);
            socket.on(response.data, function (url) {
              socket.disconnect();
              SweetAlert.swal({
                title: "El reporte está listo para descargar",
                icon: "success",
                text: "Encuentra la liga de descarga en la sección de notificaciones",
                timer: 5000,
              });
              // var notificacion = {
              //   'title': 'El reporte solicitado ha sido generado',
              //   'description': url,
              //   'model': 26,
              //   'id_reference':0
              // }
              // dataFactory.post('notificaciones/', notificacion)
              // .then(function success(response) {
              //   SweetAlert.swal({
              //     title: 'El reporte está listo para descargar',
              //     icon: 'success',
              //     text: 'Encuentra la liga de descarga en la sección de notificaciones',
              //     timer: 5000
              //   });
              //   socket.disconnect();
              // }).catch(function(err) {
              //   socket.disconnect();
              // })
            });
            toaster.info(
              "Generando...",
              "El archivo se está generando, en unos momentos podrá descargarlo, puedes seguir navegando, solo no recargues la página"
            );
          } else {
            l.stop();
            toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
          }
        })
        .catch(function (error) {
          l.stop();
          toaster.error("Aviso", "Ha ocurrido un error, intente nuevamente");
        });
    };

    $scope.matchesContractors = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          $http
            .post(url.IP + "contractors-match/", {
              matchWord: parWord.val,
              poliza: true,
            })
            .then(function (response) {
              if (response.status === 200 && response.data != 404) {
                var source = [];
                var contratactorsFound = response.data.contractors;
                if (contratactorsFound.length) {
                  contratactorsFound.forEach(function (item) {
                    if (item.full_name) {
                      var obj = {
                        label: item.full_name,
                        value: item,
                      };
                    } else {
                      var obj = {
                        label:
                          item.first_name +
                          " " +
                          item.last_name +
                          " " +
                          item.second_last_name,
                        value: item,
                      };
                    }
                    source.push(obj);
                  });
                }
                $scope.contractors_data = source;
              }
            });
        }
      }
    };

    $scope.$watch(
      "order.searchContratante.value",
      function (newValue, oldValue) {
        if (order.searchContratante) {
          if (order.searchContratante.value.address_contractor) {
            $scope.contractorLayout.id = order.searchContratante.value.id;
            $scope.contractorLayout.name = order.searchContratante.val;
            $scope.contractorLayout.contractor = order.searchContratante.value;
            if (
              order.searchContratante.value.address_contractor ||
              order.searchContratante.value.type_person == 1 ||
              order.searchContratante.value.type_person == "Física"
            ) {
              $scope.contractorLayout.type = 1;
              $scope.contractorLayout.address =
                order.searchContratante.value.address_contractor;
            } else {
              $scope.contractorLayout.type = 2;
              $scope.contractorLayout.address =
                order.searchContratante.value.address_contractor;
            }
          }
        }
      }
    );

    $scope.getClaves = function (param) {
      $http
        .get(url.IP + "claves-by-provider/" + param.id)
        .then(function success(clavesResponse) {
          $scope.clavesLayout = clavesResponse.data;
          if ($scope.clavesLayout.length == 1) {
            $scope.claveLay = $scope.clavesLayout[0];
          }
        })
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });

      $http
        .get(url.IP + "ramos-by-provider/" + param.id)
        .then(
          function success(response) {
            $scope.ramosLayout = response.data;
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    $scope.changeClave = function (param) {
      if (param) {
        if ($scope.subramoLay) {
          $scope.changeSubramo($scope.subramoLay);
        }
      }
    };

    $scope.changeRamo = function (param) {
      if (param) {
        $scope.subramosLayout = param.subramo_ramo;
      }
    };

    $scope.changeSubramo = function (param) {
      if (param) {
        $http
          .post(url.IP + "paquetes-data-by-subramo/", {
            ramo: $scope.ramoLay.id,
            subramo: $scope.subramoLay.id,
            provider: $scope.providerLay.id,
          })
          .then(function success(response) {
            if (response.status === 200) {
              $scope.paquetesLayout = [];
              if (response.data.length) {
                $scope.paquetesLayout = response.data;
              }
            }
          })
          .catch(function (error) {
            console.log("error", e);
          });
      }
    };

    $scope.changeAgrupacion = function (param) {
      if (param) {
        $scope.subagrupacionesLayout = param.subgrupos;
        $scope.subsubagrupacionesLayout = [];
      }
    };

    $scope.changeSubagrupacion = function (param) {
      if (param) {
        $scope.subsubagrupacionesLayout = param.subsubgrupos;
      }
    };

    $scope.matchesPolicies = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          dataFactory
            .post("get-endorsements-policies/", { word: parWord.val })
            .then(
              function success(request) {
                var results = [];
                results = _.map(request.data, function (item) {
                  var label =
                    item.poliza_number +
                    " - " +
                    item.contractor +
                    " - " +
                    datesFactory.convertDate(item.start_of_validity) +
                    " - " +
                    datesFactory.convertDate(item.end_of_validity);
                  return {
                    label: label,
                    value: item,
                    id: item.id,
                  };
                });
                $scope.policies_data = results;
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };

    $scope.policyLay = [];
    $scope.$watch("order.searchPolicy.value", function (newValue, oldValue) {
      if (order.searchPolicy) {
        if (order.searchPolicy.value.poliza_number) {
          $scope.policyLay.id = order.searchPolicy.value.id;
          $scope.policyLay.poliza_number =
            order.searchPolicy.value.poliza_number;
          $scope.policyLay.start = datesFactory.convertDate(
            order.searchPolicy.value.start_of_validity
          );
          $scope.policyLay.end = datesFactory.convertDate(
            order.searchPolicy.value.end_of_validity
          );
          $scope.policyLay.recibos = order.searchPolicy.value.recibos_poliza;
        }
      }
    });

    $scope.matchesCaratules = function (parWord) {
      if (parWord) {
        if (parWord.val.length >= 3) {
          dataFactory
            .post("get-endorsements-collect/", {
              word: parWord.val,
              mode: "caratula",
            })
            .then(
              function success(request) {
                var results = [];
                results = _.map(request.data, function (item) {
                  var label =
                    item.poliza_number +
                    " - " +
                    item.contractor +
                    " - " +
                    datesFactory.convertDate(item.start_of_validity) +
                    " - " +
                    datesFactory.convertDate(item.end_of_validity);
                  return {
                    label: label,
                    value: item,
                    id: item.id,
                  };
                });
                $scope.caratules_data = results;
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log("e", e);
            });
        }
      }
    };

    $scope.caratuleLay = [];
    $scope.$watch("order.searchCaratule.value", function (newValue, oldValue) {
      if (order.searchCaratule) {
        if (order.searchCaratule.value.poliza_number) {
          $scope.caratuleLay.id = order.searchCaratule.value.id;
          $scope.caratuleLay.poliza_number =
            order.searchCaratule.value.poliza_number;
          $scope.caratuleLay.start = datesFactory.convertDate(
            order.searchCaratule.value.start_of_validity
          );
          $scope.caratuleLay.end = datesFactory.convertDate(
            order.searchCaratule.value.end_of_validity
          );
          $scope.caratuleLay.receipts_by =
            order.searchCaratule.value.receipts_by;
          $scope.getPolicy($scope.caratuleLay.id);
        }
      }
    });

    $scope.getPolicy = function (param) {
      $http
        .post(url.IP + "get_caratula_complete/", { caratula: param })
        .then(function success(response) {
          if (response.status == 200) {
            $scope.caratuleLay.recibos =
              response.data.data.caratula.recibos_poliza;
            $scope.subgrupoLayout = response.data.data.childs;
            $scope.paqueteGLayout = response.data.data.paquetes;
          } else {
            SweetAlert.swal("Error", MESSAGES.ERROR.ERRORSEARCHPOLICY, "error");
          }
        })
        .catch(function (e) {
          // console.log('e', e);
        });
    };

    $scope.changeSubgroup = function (param) {
      if (param) {
        $scope.categoriaLayout = param.categorias;
      } else {
        $scope.categoriaLayout = [];
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("cargaCancelacionPolizaCtrl", cargaCancelacionPolizaCtrl);

  cargaCancelacionPolizaCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "url",
    "SweetAlert",
    "FileUploader",
    "datesFactory",
    "$state",
    "MESSAGES",
  ];

  function cargaCancelacionPolizaCtrl(
    $sessionStorage,
    $scope,
    $http,
    url,
    SweetAlert,
    FileUploader,
    datesFactory,
    $state,
    MESSAGES
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;

    $scope.optionsViews = [
      { value: 10, label: "10" },
      { value: 25, label: "25" },
      { value: 50, label: "50" },
    ];
    $scope.optionViews = $scope.optionsViews[0];
    $scope.valueInitial = 1;
    $scope.valueFinal = 10;
    $scope.excelJsonViews = [];
    $scope.loader = false;
    $scope.certifcados = [];

    activate();

    function activate() {}

    $scope.selectExcelCancelacionPolizasById = function (parData) {
      // $scope.showCertificates = false;
      // $scope.showPolicies = true;
      vm.archivos_encontrados_by_id = 0;
      vm.file_cancelacion_polizas_loaded_by_id = false;
      vm.loader_by_id = true;
      vm.elementos_cancelacion_polizas_by_id = parData["Layout de Cancelacion"];

      $http
        .post(url.IP + "validate-polizas-to-cancel/", {
          elementos: vm.elementos_cancelacion_polizas_by_id,
        })
        .then(function (response) {
          if (response.data && response.data["elementos"]) {
            vm.elementos_cancelacion_polizas_by_id = response.data["elementos"];
          }
          vm.loader_by_id = false;
          vm.file_cancelacion_polizas_loaded_by_id = true;
          vm.boton_por_id_habilitado = true;
        })
        .catch(function (err) {
          toaster.error("Ocurrio un error, intentelo nuevamente");
          vm.loader_by_id = false;
        });
      vm.archivos_encontrados = 0;

      // vm.loader = false;
      SweetAlert.swal(
        "Ojo",
        "Solo se cancelarán las pólizas encontradas junto con sus recibos de póliza y endoso pendientes de pago",
        "warning"
      );
    };

    function enviarCancelPolizas() {
      vm.boton_por_id_habilitado = false;
      vm.elementos_cancelacion_polizas_by_id =
        vm.elementos_cancelacion_polizas_by_id.filter(function (item) {
          return item && item["ID_SAAM"];
        });

      $http
        .post(url.IP + "cancelar-polizas-por-layout/", {
          elementos: vm.elementos_cancelacion_polizas_by_id,
        })
        .then(function (response) {
          SweetAlert.swal(
            "LISTO",
            "Polizas canceladas correctamente",
            "success"
          );
        });
    }

    $scope.cancelPolizasMassive = function () {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "Se cancelarán las pólizas encontradas así como sus recibos de póliza y endoso pendientes de pago",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            enviarCancelPolizas();
          }
        }
      );
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("CampaignListCtrl", CampaignListCtrl);

  CampaignListCtrl.$inject = [
    "datesFactory",
    "toaster",
    "$scope",
    "FileUploader",
    "$sessionStorage",
    "$http",
    "url",
    "$state",
    "SweetAlert",
  ];

  function CampaignListCtrl(
    datesFactory,
    toaster,
    $scope,
    FileUploader,
    $sessionStorage,
    $http,
    url,
    $state,
    SweetAlert
  ) {
    var vm = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    vm.show_pag_search = false;
    $scope.next = null;
    $scope.previous = null;

    $scope.campaign = {};

    activate();

    $scope.deactivate_campaign = function (campaign, operation) {
      if (operation == 1) {
        //desactivar campaña para app
        if (campaign.active_season == true) {
          $http.patch(campaign.url, { active_season: true }).then(
            function success(response) {
              toaster.success("Campaña actualizada");
            },
            function error(response) {
              toaster.error("Error al actualizar campaña");
            }
          );
        } else {
          $http.patch(campaign.url, { active_season: false }).then(
            function success(response) {
              toaster.success("Campaña actualizada");
            },
            function error(response) {
              toaster.error("Error al actualizar campaña");
            }
          );
        }
      } else {
        //Eliminar campaña
        SweetAlert.swal(
          {
            title: "Eliminar Campaña",
            text: "¿Está seguro de eliminar esta campaña?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
            closeOnConfirm: false,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http.patch(campaign.url, { is_active: false }).then(
                function success(response) {
                  SweetAlert.swal("Campaña eliminada");
                },
                function error(response) {
                  SweetAlert.swal("Error al eliminar campaña");
                }
              );
              activate();
            } else {
              SweetAlert.swal(
                "¡Cancelado!",
                "La campaña no fue eliminada",
                "error"
              );
              return;
            }
          }
        );
      }
    };

    function activate() {
      $http({
        method: "GET",
        url: url.IP + "campaigns-table",
      }).then(function success(response) {
        $scope.campaigns = response.data.results;
        $scope.previous = response.data.previous;
        $scope.next = response.data.next;
      });
    }

    $scope.editCampaign = function (campaign) {
      var params = { campaignId: campaign.id };
      $state.go("campaign.edit", params);
    };

    $scope.goTo = function (url) {
      $http({
        method: "GET",
        url: url,
      }).then(function success(response) {
        $scope.campaigns = response.data.results;
        $scope.previous = response.data.previous;
        $scope.next = response.data.next;
      });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("CampaignCtrl", CampaignCtrl);

  CampaignCtrl.$inject = [
    "$localStorage",
    "textAngularManager",
    "taRegisterTool",
    "datesFactory",
    "$rootScope",
    "$q",
    "helpers",
    "$uibModal",
    "$scope",
    "FileUploader",
    "$timeout",
    "toaster",
    "MESSAGES",
    "$sessionStorage",
    "$http",
    "url",
    "$state",
    "SweetAlert",
    "providerService",
    "$stateParams",
    "taOptions",
    "PersistenceFactory",
  ];

  function CampaignCtrl(
    $localStorage,
    textAngularManager,
    taRegisterTool,
    datesFactory,
    $rootScope,
    $q,
    helpers,
    $uibModal,
    $scope,
    FileUploader,
    $timeout,
    toaster,
    MESSAGES,
    $sessionStorage,
    $http,
    url,
    $state,
    SweetAlert,
    providerService,
    $stateParams,
    taOptions,
    PersistenceFactory
  ) {
    var vm = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.conciliar_masivos = false;
    $scope.showFiles = true;
    $scope.campaign = {};
    $scope.campaign.emails = [];
    $scope.campaign.emisor = [];
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (acceso) {
        if (acceso.model_name == "Correos electronicos") {
          vm.acceso_correo = acceso;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (acceso.model_name == "Endosos") {
          vm.acceso_endosos = acceso;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (acceso.model_name == "Mensajeria") {
          $scope.acceso_mns = acceso;
          $scope.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                $scope.acceso_mns = true;
              } else {
                $scope.acceso_mns = false;
              }
            }
          });
        } else if (acceso.model_name == "Archivos") {
          $scope.acceso_files = acceso;
          $scope.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                $scope.permiso_archivos = true;
              } else {
                $scope.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    $scope.group = [];

    $scope.grupos = [];

    if ($localStorage && $localStorage["saved_data_campaigns"]) {
    } else {
      $localStorage["saved_data_campaigns"] = {};
    }
    // filtro de emails

    $scope.ages = [
      0, 5, 10, 15, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
      35, 36, 37, 38, 39, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100,
    ];
    $scope.genders = [
      { id: 3, text: "Todos" },
      { id: 1, text: "Hombre" },
      { id: 2, text: "Mujer" },
    ];
    $scope.tipos = [
      { id: 3, text: "Todos" },
      { id: 1, text: "Fisicas" },
      { id: 2, text: "Morales" },
    ];
    $scope.reportes_por = [
      { id: 0, text: "Selecciona una opción" },
      { id: 1, text: "Inicio de Vigencia" },
      { id: 2, text: "Fin de Vigencia" },
    ];

    $scope.ramos_por = [
      { id: 1, text: " Vida" },
      { id: 2, text: " Accidentes y Enfermedades" },
      { id: 3, text: " Daños" },
    ];

    $scope.payments = [
      { id: 0, name: "Todas las formas de pago" },
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];

    $scope.status_ = [
      // {'id':0,'name': 'Todos los estatus'},
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
      {
        id: 15,
        name: "No renovada",
      },
    ];

    $scope.campaign.age_min = 0;
    $scope.campaign.age_max = 100;
    $scope.campaign.sex = 3;
    $scope.campaign.type_contractor = 3;
    $scope.campaign.status = 0;
    $scope.campaign.payment = 0;
    $scope.campaign.report = 0;
    $scope.campaign.provider = 0;
    $scope.campaign.ramo = 0;
    $scope.campaign.subramo = 0;
    $scope.campaign.group = [];

    $scope.addTaskOK = function (obj) {
      angular.element(document).ready(function () {
        $(".js-example-basic-multiple").select2();
      });
      $(".js-example-basic-multiple").select2();
    };

    $scope.cleanFilters = function () {
      $scope.campaign.age_min = 20;
      $scope.campaign.age_max = 24;
      $scope.campaign.sex = 3;
      $scope.campaign.type_contractor = 3;
      $scope.campaign.status = 0;
      $scope.campaign.payment = 0;
      $scope.campaign.report = 0;
      $scope.campaign.provider = 0;
      $scope.campaign.ramo = 0;
      $scope.campaign.subramo = 0;
      $scope.campaign.group = 0;
      $scope.campaign.provider = 0;
      $scope.campaign.ramo = 0;
      $scope.campaign.subramo = 0;
    };

    $scope.show_filter_tags = false;
    $scope.loader = false;
    $scope.email_filter_tags = [];

    $q.when()
      .then(function () {
        var defer = $q.defer();
        defer.resolve(helpers.getStates());
        return defer.promise;
      })
      .then(function (data) {
        $scope.statesArray = data.data;
        $scope.estado = 0;
      });

    getProviders();
    getGrupos();
    getSubramos();
    getReferenciadores();

    activate();

    function activate() {
      // /get-usersemail-operatives
      $http
        .get(url.IP + "get-usersemail-operatives/")
        .then(function (response) {
          $scope.emailsemisores = response.data;
          console.log("ooooooooooo", $scope.emailsemisores);
        });
      $scope.campaign.sendingName = usr.email;
      if (!$localStorage["saved_data_campaigns"]) {
        $scope.campaign.age_min = 0;
        $scope.campaign.age_max = 100;
        $scope.campaign.sex = 3;
        $scope.campaign.type_contractor = 3;
        $scope.campaign.status = 0;
        $scope.campaign.payment = 0;
        $scope.campaign.report = 0;
        $scope.campaign.provider = 0;
        $scope.campaign.ramo = 0;
        $scope.campaign.subramo = 0;
        $scope.campaign.group = [];
      } else {
        $scope.campaign.status =
          $localStorage["saved_data_campaigns"]["status"];
        $scope.campaign.sramo =
          $localStorage["saved_data_campaigns"]["select_sramo"];
        $scope.group_selected =
          $localStorage["saved_data_campaigns"]["group_selected"];
        $scope.campaign.name = $localStorage["saved_data_campaigns"]["name"];
        // $scope.campaign.sendingName = $localStorage['saved_data_campaigns']['sendingName'];
        $scope.campaign.subject =
          $localStorage["saved_data_campaigns"]["subject"];

        $scope.campaign.age_min = $localStorage["saved_data_campaigns"][
          "age_min"
        ]
          ? $localStorage["saved_data_campaigns"]["age_min"]
          : 0;
        $scope.campaign.age_max = $localStorage["saved_data_campaigns"][
          "age_max"
        ]
          ? $localStorage["saved_data_campaigns"]["age_max"]
          : 100;
        $scope.campaign.sex = $localStorage["saved_data_campaigns"]["sex"]
          ? $localStorage["saved_data_campaigns"]["sex"]
          : 3;
        $scope.campaign.type_contractor = $localStorage["saved_data_campaigns"][
          "type_contractor"
        ]
          ? $localStorage["saved_data_campaigns"]["type_contractor"]
          : 3;
        $scope.campaign.payment = $localStorage["saved_data_campaigns"][
          "payment"
        ]
          ? $localStorage["saved_data_campaigns"]["payment"]
          : 0;
        $scope.campaign.report = $localStorage["saved_data_campaigns"]["report"]
          ? $localStorage["saved_data_campaigns"]["report"]
          : 0;
        $scope.campaign.since = $localStorage["saved_data_campaigns"]["since"];
        $scope.campaign.until = $localStorage["saved_data_campaigns"]["until"];
        $scope.email_filter_tags = $localStorage["saved_data_campaigns"][
          "email_filter_tags"
        ]
          ? $localStorage["saved_data_campaigns"]["email_filter_tags"]
          : [];
        vm.htmlVariable = $localStorage["saved_data_campaigns"]["htmlVariable"];

        $scope.select_status = $scope.campaign.status;
        $scope.select_ramo = [];
        if ($localStorage["saved_data_campaigns"]["select_ramo"]) {
          $localStorage["saved_data_campaigns"]["select_ramo"].forEach(
            function (ramo) {
              $scope.ramos_por.forEach(function (item) {
                if (item.id == ramo) {
                  $scope.select_ramo.push(item);
                }
              });
            }
          );
        }
      }
    }

    function getReferenciadores() {
      $http.get(url.IP + "usuarios/").then(function (user) {
        $scope.users = user.data.results;
        $scope.select_sreferenciador = [];
        if ($localStorage["saved_data_campaigns"]["select_sreferenciador"]) {
          $localStorage["saved_data_campaigns"][
            "select_sreferenciador"
          ].forEach(function (ref) {
            $scope.users.forEach(function (item) {
              if (ref == item.id) {
                $scope.select_sreferenciador.push(item);
              }
            });
          });
        }
      });
    }
    function getProviders() {
      var d = convertDate(new Date());
      try {
        var curr_date = d.getDate();
        var curr_month = d.getMonth() + 1; //Months are zero based
        var curr_year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var curr_date = f.getDate();
        var curr_month = f.getMonth() + 1; //Months are zero based
        var curr_year = f.getFullYear();
      }

      var date = curr_year + "-" + curr_month + "-" + curr_date;
      providerService
        .getProviderByKey(date)
        // providerService.getReadListProviders()
        .then(function (data) {
          vm.providers = data.data;
          var aux = [];
          if ($localStorage["saved_data_campaigns"]["select_provider"]) {
            $localStorage["saved_data_campaigns"]["select_provider"].forEach(
              function (sp) {
                vm.providers.forEach(function (p) {
                  if (sp == p.id) {
                    aux.push(p);
                  }
                });
              }
            );
            $scope.select_provider = aux;
          }
        });
    }

    $scope.selectRamos = function (sel) {
      console.log($scope.select_ramo);
      $scope.campaign.ramo = [];
      vm.subramos_toselected = [];
      $scope.select_sramo = [];
      $localStorage["saved_data_campaigns"]["select_ramo"] = [];
      sel.forEach(function (r) {
        console.log("r", r);
        r = r && r.id ? r.id : r;
        $scope.campaign.ramo.push(parseInt(r));
        $localStorage["saved_data_campaigns"]["select_ramo"].push(parseInt(r));

        $http.get(url.IP + "subramos-by-ramo_code/" + r).then(function (data) {
          data.data.forEach(function (sr) {
            vm.subramos_toselected.push(sr);
            // body...
          });
          $localStorage["saved_data_campaigns"]["select_sramo"].forEach(
            function (sramo) {
              vm.subramos_toselected.forEach(function (item) {
                if (item.id == sramo) {
                  $scope.select_sramo.push(item);
                }
              });
            }
          );
        });
      });
      if (sel.length == 0) {
        vm.subramos_toselected = [];
        vm.subramos_selected = [];
        getSubramos();
      }
    };

    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      $scope.select_sramo = [];
      vm.subramos_toselected = [
        {
          id: 9,
          subramo_name: "Automóviles",
        },
        {
          id: 3,
          subramo_name: "Gastos Médicos",
        },
        {
          id: 2,
          subramo_name: "Accidentes Personales",
        },
        {
          id: 1,
          subramo_name: "Vida",
        },
        {
          id: 7,
          subramo_name: "Incendio",
        },
        {
          id: 4,
          subramo_name: "Salud",
        },
        {
          id: 10,
          subramo_name: "Crédito",
        },
        {
          id: 11,
          subramo_name: "Crédito a la Vivienda",
        },
        {
          id: 13,
          subramo_name: "Diversos",
        },
        {
          id: 12,
          subramo_name: "Garantía Financiera",
        },
        {
          id: 8,
          subramo_name: "Agrícola y de Animales",
        },
        {
          id: 6,
          subramo_name: "Marítimo y Transportes",
        },
        {
          id: 5,
          subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
        },
        {
          id: 14,
          subramo_name: "Terremoto y Otros Riesgos Catastróficos",
        },
      ];
      if ($localStorage["saved_data_campaigns"]) {
        if ($localStorage["saved_data_campaigns"]["select_sramo"]) {
          $localStorage["saved_data_campaigns"]["select_sramo"].forEach(
            function (sramo) {
              vm.subramos_toselected.forEach(function (subramo) {
                if (sramo == subramo.id) {
                  $scope.select_sramo.push(subramo);
                }
              });
            }
          );
        }
      }
    }

    $scope.validarEmail = function (item) {
      if (!validateEmail(item)) {
        SweetAlert.swal(
          "Error",
          "El formato del correo es invalido",
          "warning"
        );
      }

      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
    };

    $scope.changeShowFilterTags = function (show_filter_tags) {
      if (show_filter_tags == true) {
        $scope.show_filter_tags = false;
      } else {
        $scope.show_filter_tags = true;
      }
    };

    $scope.change_state = function (data) {
      if (data == 0) {
        $scope.estado = data;
        getEmailsBack();
        return;
      }
      $scope.statesArray.some(function (state) {
        if (state.id == data) {
          $scope.cities = state.cities;
          $scope.cities.push({ id: 0, city: "Todos" });
          $scope.ciudad = 0;
        }
      });
      $scope.estado = data;
      getEmailsBack();
    };

    $scope.change_ciudad = function (arg) {
      $scope.campaign.ciudad = arg;
      getEmailsBack();
    };

    $scope.change_age_min = function (arg) {
      $scope.campaign.age_min = arg;
    };
    $scope.change_age_max = function (arg) {
      $scope.campaign.age_max = arg;
    };

    $scope.change_sex = function (arg) {
      $scope.campaign.gender = arg;
    };

    $scope.change_status = function (arg) {
      $scope.campaign.status = [];
      arg.forEach(function (g) {
        $scope.campaign.status.push(g);
      });
      $localStorage["saved_data_campaigns"]["status"] = $scope.campaign.status;
    };

    $scope.change_payment = function (arg) {
      $scope.campaign.payment = arg;
    };

    $scope.change_reporte = function (arg) {
      $scope.campaign.reporte_por = arg;
    };

    $scope.changeSince = function (arg) {
      $scope.campaign.since = arg;
    };

    $scope.changeUntil = function (arg) {
      $scope.campaign.until = arg;
    };

    $scope.change_provider = function (arg) {
      $scope.campaign.provider = [];
      arg.forEach(function (g) {
        $scope.campaign.provider.push(g.id);
      });

      $localStorage["saved_data_campaigns"]["select_provider"] =
        $scope.campaign.provider;
    };

    $scope.change_sramo = function (arg) {
      $scope.campaign.sramo = [];
      $localStorage["saved_data_campaigns"]["select_sramo"] = [];
      arg.forEach(function (g) {
        if (g.subramo_code) {
          $scope.campaign.sramo.push(g.subramo_code);
        } else {
          $scope.campaign.sramo.push(g.id);
        }
      });
      $localStorage["saved_data_campaigns"]["select_sramo"] =
        $scope.campaign.sramo;
    };

    $scope.change_grupo = function (grupo) {
      $scope.campaign.group = [];
      grupo.forEach(function (g) {
        $scope.campaign.group.push(g.id);
      });
      $localStorage["saved_data_campaigns"]["group_selected"] =
        $scope.campaign.group;
    };

    $scope.change_sreferenciadores = function (arg) {
      $scope.campaign.sreferenciador = [];
      arg.forEach(function (g) {
        if (g.id) {
          $scope.campaign.sreferenciador.push(g.id);
        } else {
          $scope.campaign.sreferenciador.push(g.id);
        }
      });
      $localStorage["saved_data_campaigns"]["select_sreferenciador"] =
        $scope.campaign.sreferenciador;
    };
    $scope.add_emails = function () {
      $scope.email_tags = $scope.email_filter_tags;
      $scope.email_filter_tags = "";
    };

    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
        $("#modalContratate")
          .parent()
          .parent()
          .parent()
          .css("display", "block");
      }
    };

    $scope.change_tipo = function (tipo) {
      $scope.campaign.tipo = tipo;
    };

    $scope.cleanEmails = function () {
      $scope.email_filter_tags = [];
    };

    function getGrupos() {
      $http.get(url.IP + "grupos-resume").then(function (response) {
        $scope.campaign.grupos = response.data;
        if ($scope.group_selected) {
          $scope.group_selected.forEach(function (item, index) {
            $scope.campaign.grupos.forEach(function (grupo) {
              // console.log(grupo, item);
              if (item == grupo.id) {
                $scope.group_selected[index] = grupo;
              }
              return item;
            });
          });
        }
      });
    }

    $scope.getEmailsBack = function () {
      $scope.loader = true;
      $scope.data = {
        age_min: $scope.campaign.age_min ? $scope.campaign.age_min : 0,
        age_max: $scope.campaign.age_max ? $scope.campaign.age_max : 0,
        sex: $scope.campaign.gender ? $scope.campaign.gender : 0,
        type_contractor: $scope.campaign.tipo ? $scope.campaign.tipo : 3,
        group: $scope.campaign.group ? $scope.campaign.group : 0,
        status: $scope.campaign.status ? $scope.campaign.status : 0,
        payment: $scope.campaign.payment ? $scope.campaign.payment : 0,
        report: $scope.campaign.report ? $scope.campaign.report : 0,
        since: $scope.campaign.since
          ? datesFactory.toDate($scope.campaign.since)
          : 0,
        until: $scope.campaign.until
          ? datesFactory.toDate($scope.campaign.until)
          : 0,
        provider: $scope.campaign.provider ? $scope.campaign.provider : 0,
        ramo: $scope.campaign.ramo ? $scope.campaign.ramo : 0,
        subramo: $scope.campaign.sramo ? $scope.campaign.sramo : 0,
        referenciadores: $scope.campaign.sreferenciador
          ? $scope.campaign.sreferenciador
          : 0,
      };

      $http({
        method: "GET",
        url: url.IP + "get-emails",
        params: $scope.data,
      })
        .then(function success(response) {
          // $scope.email_filter_tags = [];
          response.data.forEach(function (email, index) {
            $scope.email_filter_tags.push({
              text: email,
              id: index + new Date().getTime() + email,
            });
          });
          toaster.success("Emails cargados correctamente");
          $scope.loader = false;
        })
        .catch(function error() {
          toaster.error("Error al cargar los emails intente nuevamente");
          $scope.loader = false;
        });
    };

    function convertDate(inputFormat) {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var d = new Date(inputFormat);
      var date = [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
      return date;
    }

    $scope.send_frequency = [
      { id: 0, text: "Única vez" },
      { id: 1, text: "Diario" },
      { id: 2, text: "Semanal" },
      { id: 3, text: "Mensual" },
    ];
    $scope.campaign.repeatEmail = 0;
    $scope.campaign.sendingDate = undefined;
    vm.email_tags = [];
    vm.htmlVariable =
      '<h1 style="font-size: 1.8em;text-align: center;">El veloz murciélago hindú comía feliz cardillo y kiwi</h1><p><br/></p><p><br/></p><p style="text-align: center;"><img src="http://textangular.com/images/textAngularLogo.png"/>​</p><ul style="font-size: 14px;text-align: left;"><li><i>José compró una vieja zampoña en Perú. Excusándose, Sofía tiró su whisky al desagüe de la banqueta</i>.</li><li><i>El cadáver de Wamba, rey godo de España, fue exhumado y trasladado en una caja de zinc que pesó un kilo&#34;.</i></li><li><i>El velo<i></i>z murciélago hindú comía feliz cardillo y kiwi. La cigüeña tocaba el saxofón detrás del palenque de paja</i> (Para las fuentes de Microsoft).</li><li><i>El viejo Señor Gómez pedía queso, kiwi y habas, pero le ha tocado un saxofón.</i></li><li><i>Jovencillo emponzoñado de whisky: ¡qué figurota exhibe!</i> (para la fuentes tipográficas bajo las <a href="https://es.wikipedia.org/wiki/Distribuci%C3%B3n_Linux" title="Distribución Linux" style="background-color: transparent;">distribuciones GNU/Linux</a>).</li><li><i>Whisky bueno: ¡excitad mi frágil pequeña vejez!</i></li><li><i style="text-align: center;">Quiere la boca exhausta vid, kiwi, piña y fugaz jamón&#34;.</i></li></ul><div style="text-align: center;"></div><div style="text-align: center;"><span style="font-size: 14px;"><i><br/></i></span></div><div style="text-align: center;"><br/></div>';
    // $scope.campaign.sendingDate = new Date(datesFactory.toDate(new Date))

    taOptions.toolbar = [
      ["h1", "h2", "h3", "h4", "h5", "h6"],
      [
        "bold",
        "italics",
        "underline",
        "strikeThrough",
        "ul",
        "ol",
        "redo",
        "undo",
      ],
      [
        "justifyLeft",
        "justifyCenter",
        "justifyRight",
        "indent",
        "outdent",
        "insertLink",
        "insertImage",
      ],
      // ['html', 'insertImage','insertLink', 'insertVideo', 'wordcount', 'charcount']
    ];

    $scope.reviewDate = function (date) {
      var today = new Date();
      var date_ = new Date(
        date.split("/")[2],
        date.split("/")[1] - 1,
        date.split("/")[0]
      );
      if (date_ <= today) {
        SweetAlert.swal(
          "ERROR",
          "La fecha de envio debe de ser mayor al dia de hoy",
          "error"
        );
        today = today.setDate(today.getDate() + 1);
        $scope.campaign.sendingDate = datesFactory.convertDate(today);
      }
    };

    $scope.url_ = $state.current.name;

    $scope.focusEditor = function () {
      $scope.editor_focus = true;
    };

    $scope.unfocusEditor = function () {
      // if(!$scope.get_file) {
      //   $scope.editor_focus = false;
      // }
    };

    $scope.getFile = function () {
      var editor = textAngularManager.retrieveEditor("myEditorCreate").scope;
      editor.displayElements.text.trigger("focus");

      var modalInstance = $uibModal.open({
        template:
          '<label class="col-xs-12 btn btn-info">Agregar Imagen desde PC' +
          '<input multiple nv-file-select="" type="file" name="xyz" uploader="uploader" accept=".jpg" class="display-none"/>' +
          "</label>",
        // size: 'sm',
        controller: ModalInstanceFileCtrl,
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (imgUrl) {
        var imageLink;
        imageLink = $rootScope.image_url;
        var embed = '<img src="' + imageLink + ' ">';
        // return textAngular.$editor().wrapSelection('insertHTML', embed, true);

        var editor = textAngularManager.retrieveEditor("myEditorCreate");
        editor.scope.wrapSelection("insertHTML", embed, true);
      });
    };

    function ModalInstanceFileCtrl($scope, $rootScope, $uibModalInstance) {
      $scope.userInfo = {
        id: 0,
      };
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        allowedFileType: ["png", "jpg", "jpeg"],
      }));

      $scope.userInfo.url = $scope.uploader.url = url.IP + "campaigns-html/";
      $scope.uploader.autoUpload = true;

      // uploader.filters.push({
      //   name: 'customFilter',
      //   fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
      //     return this.queue.length < 20;
      //   }
      // });

      // ALERTA SUCCES UPLOADFILES
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        // el url del archivo cargado esta en response.arch
        $rootScope.image_url = response.arch;
        if ($uibModalInstance) {
          $uibModalInstance.close();
        }
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });
      };

      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = usr.org;
      };
      $scope.validateFiles = function () {
        var input = document.getElementById("fileInput");
        var files = input.files;
        var totalSize = 0;
        var errorMessageElement = document.getElementById("error-message");

        // Loop through the selected files to sum their sizes
        for (var i = 0; i < files.length; i++) {
          totalSize += files[i].size;
        }

        // Convert total size to MB
        var totalSizeMB = totalSize / (1024 * 1024);

        // Check if the total size exceeds 25MB
        if (totalSizeMB > 25) {
          errorMessageElement.style.display = "block";
          errorMessageElement.textContent =
            "La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.";
        } else {
          errorMessageElement.style.display = "none"; // Hide error message if files are valid
        }
      };

      function uploadFiles() {
        $scope.userInfo.url = $scope.uploader.url = url.IP + "campaigns-html/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }
    }

    $scope.changeShowFilterTags = function (show_tags) {
      if (show_tags == true) {
        $scope.show_tags = false;
      } else {
        $scope.show_tags = true;
      }
    };

    // $scope.system_emails = function() {
    // var modalInstance = $uibModal.open({ //jshint ignore:line
    //     templateUrl: 'app/campaigns/campaign.modal.filter.html',
    //     controller: ModalInstanceCtrl,
    //     resolve: {
    //       parent: function() {
    //         return vm;
    //       }
    //     },
    //     backdrop: 'static', /* this prevent user interaction with the background */
    //     keyboard: false
    //     // windowClass: 'animated fadeIn'
    // }).result.then(function(data) {
    // $rootScope.email_filter_tags.forEach(function(obj) {
    //     // var index = vm.email_tags.findIndex(x => x.text==obj['text'])
    //     var index = -1;
    //     vm.email_tags.forEach(function(email) {
    //         if (email.text == obj['text'])
    //             index = 1
    //     });
    //     if (index === -1){
    //         vm.email_tags.push(obj)
    //     }
    //     else{
    //         toaster.warning("Email "+ obj['text'] +" repetido");
    //     }
    // });
    // $scope.campaign.age_min = $rootScope.campaign.age_min
    // $scope.campaign.age_max = $rootScope.campaign.age_max
    // $scope.campaign.sex = $rootScope.campaign.gender
    // $scope.campaign.state = $rootScope.campaign.estado
    // $scope.campaign.city = $rootScope.campaign.ciudad
    // }, function() {
    //     // body...
    // });
    // }

    $scope.massive_load = function () {
      if ($scope.conciliar_masivos == true) {
        $scope.conciliar_masivos = false;
        $scope.toConciliate = [];
        $scope.suma = 0;
        $scope.suma2 = 0;
      } else {
        $scope.conciliar_masivos = true;
      }
    };

    $scope.save = function () {
      if (!$scope.campaign.sendingName) {
        SweetAlert.swal("Error", "Escribe un correo del remitente", "error");
        return;
      } else {
        if (!validateEmail($scope.campaign.sendingName)) {
          SweetAlert.swal(
            "Error",
            "El formato del correo del nombre del remitente es invalido",
            "error"
          );
          return;
        }

        function validateEmail(email) {
          var re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        }
      }
      if (!$scope.campaign.subject) {
        SweetAlert.swal("Error", "Escribe un asunto", "error");
        return;
      }

      $scope.campaign.type_contractor = $scope.campaign.type_contractor
        ? $scope.campaign.type_contractor
        : 3;
      $scope.campaign.report = $scope.campaign.report
        ? $scope.campaign.report
        : 0;
      $scope.campaign.since = $scope.campaign.since ? $scope.campaign.since : 0;
      $scope.campaign.until = $scope.campaign.until ? $scope.campaign.until : 0;
      $scope.campaign.provider = $scope.campaign.provider
        ? $scope.campaign.provider
        : 0;
      $scope.campaign.ramo = $scope.campaign.ramo ? $scope.campaign.ramo : 0;
      ($scope.campaign.subramo = $scope.campaign.sramo
        ? $scope.campaign.sramo
        : 0),
        ($scope.campaign.referenciadores = $scope.campaign.referenciadores
          ? $scope.campaign.referenciadores
          : 0);

      if ($scope.campaign.sex == 0) {
        $scope.campaign.sex = 3;
      }
      if ($scope.email_filter_tags.length == 0) {
        toaster.error("La lista de destinatarios no debe de estar vacía.");
        return;
      }
      var aux_emails = [];
      $scope.campaign.message = vm.htmlVariable;
      $scope.email_filter_tags.forEach(function (item) {
        aux_emails.push(item["text"]);
      });
      if (uploader && uploader.queue && uploader.queue.length != 0) {
        var files = uploader.queue;
        var totalSize = 0;
        var errorMessageElement = document.getElementById("message");
        for (var i = 0; i < files.length; i++) {
          totalSize += files[i].file.size;
        }
        var totalSizeMB = totalSize / (1024 * 1024);
        if (totalSizeMB > 25) {
          errorMessageElement.style.display = "block";
          errorMessageElement.style.textAlign = "center";
          errorMessageElement.textContent =
            "La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.*";
          return;
        } else {
          errorMessageElement.style.display = "none"; // Hide error message if files are valid
        }
      }
      $scope.campaign.emails = aux_emails + "";
      // var mesdia = datesFactory.mesDiaAnio($scope.campaign.sendingDate)
      // var todate = datesFactory.toDate(mesdia)
      $scope.campaign.sendingDate = new Date();
      $http
        .post(url.IP + "campaigns/", $scope.campaign)
        .then(function (response) {
          if (response.status == 201) {
            $localStorage["saved_data_campaigns"] = {};
            uploadFiles(response.data);
            $state.go("campaign.list");
          } else {
            SweetAlert.swal("Error", "Escribe un asunto", "error");
          }
        });
    };

    $scope.updateSave = function () {
      $localStorage["saved_data_campaigns"]["name"] = $scope.campaign.name;
      $localStorage["saved_data_campaigns"]["sendingName"] =
        $scope.campaign.sendingName;
      $localStorage["saved_data_campaigns"]["subject"] =
        $scope.campaign.subject;

      $localStorage["saved_data_campaigns"]["age_min"] =
        $scope.campaign.age_min;
      $localStorage["saved_data_campaigns"]["age_max"] =
        $scope.campaign.age_max;
      $localStorage["saved_data_campaigns"]["sex"] = $scope.campaign.sex;
      $localStorage["saved_data_campaigns"]["type_contractor"] =
        $scope.campaign.type_contractor;
      $localStorage["saved_data_campaigns"]["payment"] =
        $scope.campaign.payment;
      $localStorage["saved_data_campaigns"]["report"] = $scope.campaign.report;
      $localStorage["saved_data_campaigns"]["since"] = $scope.campaign.since;
      $localStorage["saved_data_campaigns"]["until"] = $scope.campaign.until;

      $localStorage["saved_data_campaigns"]["email_filter_tags"] =
        $scope.email_filter_tags;
      $localStorage["saved_data_campaigns"]["htmlVariable"] =
        $scope.vm.htmlVariable;
    };

    $scope.cancel = function () {
      $state.go("campaign.list");
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    vm.uploadFiles = uploadFiles;
    function uploadFiles(campaign) {
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "campaigns/" + campaign.id + "/archivos/";
      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.selectExcel = function (parData) {
      $scope.strcutureData = certStructure(parData);
    };
    function certStructure(parData) {
      var dateid;
      parData["Hoja1"].forEach(function (obj) {
        $.each(obj, function (key, value) {
          dateid = new Date().getTime();
          if (value.indexOf("@") != -1) {
            // var index = vm.email_tags.findIndex(x => x.text==value)
            var index = -1;
            $scope.email_filter_tags.forEach(function (email) {
              if (email.text == value) index = 1;
            });
            if (index === -1) {
              $scope.email_filter_tags.push({
                text: value,
                id: dateid + value,
              });
            } else {
              toaster.warning("Email " + value + " repetido");
            }
          }
        });
      });
      $scope.massive_load();
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("CampaignEditCtrl", CampaignEditCtrl);

  CampaignEditCtrl.$inject = [
    "providerService",
    "textAngularManager",
    "taRegisterTool",
    "datesFactory",
    "$rootScope",
    "$q",
    "helpers",
    "$uibModal",
    "$scope",
    "FileUploader",
    "$timeout",
    "toaster",
    "MESSAGES",
    "$sessionStorage",
    "$http",
    "url",
    "$state",
    "SweetAlert",
    "$stateParams",
    "taOptions",
  ];

  function CampaignEditCtrl(
    providerService,
    textAngularManager,
    taRegisterTool,
    datesFactory,
    $rootScope,
    $q,
    helpers,
    $uibModal,
    $scope,
    FileUploader,
    $timeout,
    toaster,
    MESSAGES,
    $sessionStorage,
    $http,
    url,
    $state,
    SweetAlert,
    $stateParams,
    taOptions
  ) {
    var vm = this;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.conciliar_masivos = false;
    $scope.showFiles = true;
    $scope.campaign = {};
    $scope.loader = false;
    $scope.campaign.emails = [];
    $scope.send_frequency = [
      { id: 0, text: "Única vez" },
      { id: 1, text: "Diario" },
      { id: 2, text: "Semanal" },
      { id: 3, text: "Mensual" },
    ];
    $scope.campaign.repeatEmail = 0;
    vm.email_tags = [];
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (acceso) {
        if (acceso.model_name == "Correos electronicos") {
          vm.acceso_correo = acceso;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (acceso.model_name == "Endosos") {
          vm.acceso_endosos = acceso;
          vm.acceso_endosos.permissions.forEach(function (acc) {
            if (acc.permission_name == "Registrar endosos") {
              if (acc.checked == true) {
                vm.acceso_reg_end = true;
              } else {
                vm.acceso_reg_end = false;
              }
            }
          });
        } else if (acceso.model_name == "Mensajeria") {
          $scope.acceso_mns = acceso;
          $scope.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                $scope.acceso_mns = true;
              } else {
                $scope.acceso_mns = false;
              }
            }
          });
        }
      });
    }
    // $scope.name_editor = 'editor';
    $scope.url_ = $state.current.name;
    $scope.group_to_show;
    $scope.provider_to_show;
    $scope.ramo_to_show;
    $scope.subramo_to_show;
    $scope.email_filter_tags = [];
    vm.providers = [];
    $scope.campaign.grupos = [];

    getProviders();
    getSubramos();
    activate();
    $scope.ages = [
      0, 5, 10, 15, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
      35, 36, 37, 38, 39, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100,
    ];
    $scope.genders = [
      { id: 3, text: "Todos" },
      { id: 1, text: "Hombre" },
      { id: 2, text: "Mujer" },
    ];
    $scope.tipos = [
      { id: 3, text: "Todos" },
      { id: 1, text: "Fisicas" },
      { id: 2, text: "Morales" },
    ];
    $scope.reportes_por = [
      { id: 0, text: "Selecciona una opción" },
      { id: 1, text: "Inicio de Vigencia" },
      { id: 2, text: "Fin de Vigencia" },
    ];
    $scope.payments = [
      { id: 0, name: "Todas las formas de pago" },
      {
        id: 1,
        name: "Mensual",
      },
      {
        id: 2,
        name: "Bimestral",
      },
      {
        id: 3,
        name: "Trimestral",
      },
      {
        id: 5,
        name: "Contado",
      },
      {
        id: 6,
        name: "Semestral",
      },
      {
        id: 12,
        name: "Anual",
      },
    ];

    $scope.status_ = [
      { id: 0, name: "Todos los estatus" },
      {
        id: 1,
        name: "En trámite",
      },
      {
        id: 2,
        name: "OT Cancelada",
      },
      {
        id: 4,
        name: "Precancelada",
      },
      {
        id: 10,
        name: "Por iniciar",
      },
      {
        id: 11,
        name: "Cancelada",
      },
      {
        id: 12,
        name: "Renovada",
      },
      {
        id: 13,
        name: "Vencida",
      },
      {
        id: 14,
        name: "Vigente",
      },
      {
        id: 15,
        name: "No renovada",
      },
    ];

    $scope._subramos = [
      {
        id: 9,
        subramo_name: "Automóviles",
      },
      {
        id: 3,
        subramo_name: "Gastos Médicos",
      },
      {
        id: 2,
        subramo_name: "Accidentes Personales",
      },
      {
        id: 1,
        subramo_name: "Vida",
      },
      {
        id: 7,
        subramo_name: "Incendio",
      },
      {
        id: 4,
        subramo_name: "Salud",
      },
      {
        id: 10,
        subramo_name: "Crédito",
      },
      {
        id: 11,
        subramo_name: "Crédito a la Vivienda",
      },
      {
        id: 13,
        subramo_name: "Diversos",
      },
      {
        id: 12,
        subramo_name: "Garantía Financiera",
      },
      {
        id: 8,
        subramo_name: "Agrícola y de Animales",
      },
      {
        id: 6,
        subramo_name: "Marítimo y Transportes",
      },
      {
        id: 5,
        subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
      },
      {
        id: 14,
        subramo_name: "Terremoto y Otros Riesgos Catastróficos",
      },
    ];

    taOptions.toolbar = [
      ["h1", "h2", "h3", "h4", "h5", "h6"],
      [
        "bold",
        "italics",
        "underline",
        "strikeThrough",
        "ul",
        "ol",
        "redo",
        "undo",
      ],
      [
        "justifyLeft",
        "justifyCenter",
        "justifyRight",
        "indent",
        "outdent",
        "insertLink",
        "insertImage",
      ],
      // ['html', 'insertImage','insertLink', 'insertVide$o', 'wordcount', 'charcount']
    ];

    // Create our own insertImage button
    // taRegisterTool('customInsertImage', {
    //   iconclass: "fa fa-upload",
    //   action: function($deferred) {
    //     var textAngular = this;
    //     var modalInstance = $uibModal.open({
    //       template: '<label class="col-xs-12 btn btn-info">Agregar Imagen desde PC'+
    //                   '<input multiple nv-file-select="" type="file" name="xyz" uploader="uploader" accept=".jpg" class="display-none"/>'+
    //                 '</label>',
    //       // size: 'sm',
    //       controller: ModalInstanceFileCtrl
    //     });

    //     modalInstance.result.then(function(imgUrl) {
    //         var imageLink;
    //         imageLink = $rootScope.image_url;
    //         var embed = '<img src="' + imageLink + ' ">';
    //         return textAngular.$editor().wrapSelection('insertHTML', embed, true);
    //     });
    //     return false;
    //   }
    // });

    // // Now add the button to the default toolbar definition
    // // Note: It'll be the last button
    // taOptions.toolbar[2].push('customInsertImage');

    // editor.displayElements.text.trigger('focus');
    $scope.focusEditor = function () {
      $scope.editor_focus = true;
    };

    $scope.unfocusEditor = function () {
      // if($scope.get_file) {
      //   $scope.editor_focus = true;
      // } else {
      //   $scope.editor_focus = false;
      // }
    };

    function getProviders() {
      providerService.getReadListProviders().then(function (data) {
        vm.providers = data;
      });
    }

    $scope.getFile = function () {
      var editor = textAngularManager.retrieveEditor("myEditor").scope;
      editor.displayElements.text.trigger("focus");

      var modalInstance = $uibModal.open({
        template:
          '<label class="col-xs-12 btn btn-info">Agregar Imagen desde PC' +
          '<input multiple nv-file-select="" type="file" name="xyz" uploader="uploader" accept=".jpg" class="display-none"/>' +
          "</label>",
        // size: 'sm',
        controller: ModalInstanceFileCtrl,
        resolve: {
          from: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });

      modalInstance.result.then(function (imgUrl) {
        // editor.displayElements.text.trigger('focus');

        var imageLink;
        imageLink = $rootScope.image_url;
        var embed = '<img src="' + imageLink + ' ">';
        // return textAngular.$editor().wrapSelection('insertHTML', embed, true);
        $scope.editor_focus = true;

        var editor = textAngularManager.retrieveEditor("myEditor");
        editor.scope.wrapSelection("insertHTML", embed, true);
      });
    };

    function ModalInstanceFileCtrl($scope, $rootScope, $uibModalInstance) {
      $scope.userInfo = {
        id: 0,
      };
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        allowedFileType: ["png", "jpg", "jpeg"],
      }));

      $scope.userInfo.url = $scope.uploader.url = url.IP + "campaigns-html/";
      $scope.uploader.autoUpload = true;

      // uploader.filters.push({
      //   name: 'customFilter',
      //   fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
      //     return this.queue.length < 20;
      //   }
      // });

      // ALERTA SUCCES UPLOADFILES
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        // el url del archivo cargado esta en response.arch
        $rootScope.image_url = response.arch;
        if ($uibModalInstance) {
          $uibModalInstance.close();
        }
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });
      };

      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = usr.org;
      };

      function uploadFiles() {
        $scope.userInfo.url = $scope.uploader.url = url.IP + "campaigns-html/";
        $scope.files = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
        }, 1000);
      }
    }

    $scope.change_ciudad = function (arg) {
      $scope.campaign.ciudad = arg;
      getEmailsBack();
    };

    $scope.change_age_min = function (arg) {
      $scope.campaign.age_min = arg;
    };
    $scope.change_age_max = function (arg) {
      $scope.campaign.age_max = arg;
    };

    $scope.change_sex = function (arg) {
      $scope.campaign.gender = arg;
    };

    $scope.change_status = function (arg) {
      $scope.status = arg.id;
    };

    $scope.change_payment = function (arg) {
      $scope.campaign.payment = arg.id;
    };

    $scope.change_reporte = function (arg) {
      $scope.campaign.reporte_por = arg;
    };

    $scope.changeSince = function (arg) {
      $scope.campaign.since = arg;
    };

    $scope.changeUntil = function (arg) {
      $scope.campaign.until = arg;
    };

    $scope.change_provider = function (arg) {
      $scope.campaign.provider = [];
      arg.forEach(function (g) {
        $scope.campaign.provider.push(g.id);
        $scope.campaign.provider_to_show.push(g.alias);
      });
    };

    $scope.change_sramo = function (arg) {
      $scope.campaign.sramo = [];
      arg.forEach(function (g) {
        if (g.subramo_code) {
          $scope.campaign.sramo.push(g.subramo_code);
          $scope.subramo_to_show.push(g.subramo_name);
        } else {
          $scope.campaign.sramo.push(g.id);
          $scope.subramo_to_show.push(g.subramo_name);
        }
      });
    };

    $scope.change_grupo = function (grupo) {
      $scope.campaign.group = [];
      grupo.forEach(function (g) {
        $scope.campaign.group.push(g.id);
      });
    };

    function getSubramos() {
      vm.subramos_toselected = [];
      vm.subramos_selected = [];
      vm.subramos_toselected = $scope._subramos;
    }

    function verifyGroup() {
      if (
        $scope.campaign.group &&
        $scope.campaign.group.length &&
        $scope.campaign.group.length > 0
      ) {
        $scope.campaign.group.forEach(function (element) {
          try {
            parseInt(element);
          } catch (err) {
            $scope.campaign.group = 0;
          }
        });
      }
    }

    $scope.getEmailsBack = function () {
      // try{
      //   $scope.campaign.since = datesFactory.convertDate($scope.campaign.since);
      //   $scope.campaign.until = datesFactory.convertDate($scope.campaign.until);
      // }
      // catch(err){

      // }
      $scope.loader = true;
      $scope.data = {
        age_min: $scope.campaign.age_min ? $scope.campaign.age_min : 0,
        age_max: $scope.campaign.age_max ? $scope.campaign.age_max : 0,
        sex: $scope.campaign.gender ? $scope.campaign.gender : 0,
        type_contractor: $scope.campaign.tipo ? $scope.campaign.tipo : 3,
        group: $scope.campaign.group ? $scope.campaign.group : 0,
        status: $scope.campaign.status ? $scope.campaign.status : 0,
        payment: $scope.campaign.payment ? $scope.campaign.payment : 0,
        report: $scope.campaign.reporte_por ? $scope.campaign.reporte_por : 0,
        provider: $scope.campaign.provider ? $scope.campaign.provider : 0,
        ramo: $scope.campaign.ramo ? $scope.campaign.ramo : 0,
        subramo: $scope.campaign.sramo ? $scope.campaign.sramo : 0,
      };
      if ($scope.data.report != 0) {
        $scope.data.since = $scope.campaign.since
          ? datesFactory.toDate($scope.campaign.since)
          : 0;
        $scope.data.until = $scope.campaign.until
          ? datesFactory.toDate($scope.campaign.until)
          : 0;
      }

      verifyGroup();

      if ($scope.campaign.group == "[]") {
        $scope.campaign.group = 0;
      }

      $http({
        method: "GET",
        url: url.IP + "get-emails",
        params: $scope.data,
      })
        .then(function success(response) {
          // $scope.email_filter_tags = [];
          response.data.forEach(function (email, index) {
            $scope.email_filter_tags.push({
              text: email,
              id: index + new Date().getTime() + email,
            });
          });
          toaster.success("Emails cargados correctamente");
          $scope.loader = false;
        })
        .catch(function error() {
          toaster.error("Error al cargar los emails intente nuevamente");
          $scope.loader = false;
        });
    };

    function activate() {
      $http
        .get(url.IP + "get-usersemail-operatives/")
        .then(function (response) {
          $scope.emailsemisores = response.data;
        });
      $http
        .get(url.IP + "campaigns/" + $stateParams.campaignId)
        .then(function (response) {
          $scope.campaign = response.data;
          vm.htmlVariable = response.data.message;
          vm.email_tags = $scope.campaign.emails.split(",");
          vm.files = $scope.campaign.campaign_files;
          $scope.campaign.sendingDate = datesFactory.convertDate(
            $scope.campaign.sendingDate
          );
          $scope.campaign.type_contractor = parseInt(
            $scope.campaign.type_contractor
          );
          $scope.campaign.payment = parseInt($scope.campaign.payment);
          $scope.campaign.report = parseInt($scope.campaign.report);
          $scope.campaign.status = JSON.parse($scope.campaign.status);

          if (
            Number.isInteger($scope.campaign.status) &&
            $scope.campaign.status != 0
          ) {
            $scope.campaign.status = [$scope.campaign.status];
          }

          if ($scope.campaign.group == "[]") {
            $scope.campaign.group = 0;
          }
          if ($scope.campaign.ramo == "[]") {
            $scope.campaign.ramo = 0;
          }
          if ($scope.campaign.provider == "[]") {
            $scope.campaign.provider = 0;
          }
          if ($scope.campaign.subramo == "[]") {
            $scope.campaign.subramo = 0;
          }

          try {
            $scope.campaign.emails = $scope.campaign.emails.split(",");
            $scope.campaign.emails.forEach(function (email, index) {
              $scope.email_filter_tags.push({
                text: email,
                id: index + new Date().getTime() + email,
              });
            });
          } catch (err) {
            $scope.email_filter_tags.push({
              text: $scope.campaign.emails,
              id: 1 + new Date().getTime() + email,
            });
          }

          $scope.provider_to_show = [];
          $scope.ramo_to_show = [];
          $scope.group_to_show = [];
          $scope.subramo_to_show = [];

          if ($scope.campaign.provider.indexOf("[") != -1) {
            $scope.campaign.provider = $scope.campaign.provider.replace(
              "[",
              ""
            );
            $scope.campaign.provider = $scope.campaign.provider.replace(
              "]",
              ""
            );
            $scope.campaign.provider = $scope.campaign.provider.split(",");
            $scope.campaign.provider.forEach(function (p, i) {
              $scope.campaign.provider[i] = parseInt(
                $scope.campaign.provider[i]
              );
              vm.providers.some(function (p) {
                if (p.id == parseInt($scope.campaign.provider[i])) {
                  $scope.provider_to_show.push(p.alias);
                }
              });
            });
          } else {
            $scope.campaign.provider = parseInt($scope.campaign.provider);
            $scope.provider_to_show = $scope.campaign.provider;
          }

          if ($scope.campaign.ramo.indexOf("[") != -1) {
            $scope.campaign.ramo = $scope.campaign.ramo.replace("[", "");
            $scope.campaign.ramo = $scope.campaign.ramo.replace("]", "");
            $scope.campaign.ramo = $scope.campaign.ramo.split(",");
            $scope.campaign.ramo.forEach(function (p, i) {
              $scope.campaign.ramo[i] = parseInt($scope.campaign.ramo[i]);
              if (parseInt($scope.campaign.ramo[i]) == 1) {
                $scope.ramo_to_show.push("Vida");
              }
              if (parseInt($scope.campaign.ramo[i]) == 2) {
                $scope.ramo_to_show.push("Gastos Médicos");
              }
              if (parseInt($scope.campaign.ramo[i]) == 3) {
                $scope.ramo_to_show.push("Daños");
              }
            });
          } else {
            $scope.campaign.ramo = parseInt($scope.campaign.ramo);
            $scope.ramo_to_show = $scope.campaign.ramo;
          }
          if ($scope.campaign.subramo.indexOf("[") != -1) {
            $scope.campaign.subramo = $scope.campaign.subramo.replace("[", "");
            $scope.campaign.subramo = $scope.campaign.subramo.replace("]", "");
            $scope.campaign.subramo = $scope.campaign.subramo.split(",");
            $scope.campaign.subramo.forEach(function (p, i) {
              $scope.campaign.subramo[i] = parseInt($scope.campaign.subramo[i]);
              $scope._subramos.some(function (s) {
                if (s.id == parseInt($scope.campaign.subramo[i])) {
                  $scope.subramo_to_show.push(s.subramo_name);
                }
              });
            });
          } else {
            $scope.campaign.subramo = parseInt($scope.campaign.subramo);
            $scope.subramo_to_show = $scope.campaign.subramo;
          }
          $http.get(url.IP + "grupos-resume").then(function (response) {
            $scope.campaign.grupos = response.data;
            if (
              $scope.campaign &&
              $scope.campaign.group &&
              $scope.campaign.group.indexOf("[") != -1
            ) {
              $scope.campaign.group = $scope.campaign.group.replace("[", "");
              $scope.campaign.group = $scope.campaign.group.replace("]", "");
              $scope.campaign.group = $scope.campaign.group.split(",");

              $scope.campaign.group.forEach(function (grupo, i) {
                $scope.campaign.group[i] = parseInt($scope.campaign.group[i]);
                $scope.campaign.grupos.some(function (g) {
                  if (g.id == parseInt(grupo)) {
                    $scope.group_to_show.push(g.group_name);
                  }
                });
              });
            } else {
              $scope.campaign.group = parseInt($scope.campaign.group);
              $scope.group_to_show = $scope.campaign.group;
            }
          });
          $scope.campaign.payment = parseInt($scope.campaign.payment);
        });

      $scope.cleanFilters = function () {
        $scope.campaign.age_min = 20;
        $scope.campaign.age_max = 24;
        $scope.campaign.sex = 3;
        $scope.campaign.type_contractor = 3;
        $scope.campaign.status = 0;
        $scope.campaign.payment = 0;
        $scope.campaign.report = 0;
        $scope.campaign.provider = 0;
        $scope.campaign.ramo = 0;
        $scope.campaign.subramo = 0;
        $scope.campaign.group = 0;
        $scope.campaign.provider = 0;
        $scope.campaign.ramo = 0;
        $scope.campaign.subramo = 0;
        $scope.provider_to_show = 0;
        $scope.group_to_show = 0;
        $scope.ramo_to_show = 0;
        $scope.subramo_to_show = 0;
      };

      $scope.selectRamos = function (sel) {
        $scope.campaign.ramo = [];
        vm.subramos_toselected = [];
        sel.forEach(function (r) {
          $scope.campaign.ramo.push(parseInt(r));
          $http
            .get(url.IP + "subramos-by-ramo_code/" + r)
            .then(function (data) {
              data.data.forEach(function (sr) {
                vm.subramos_toselected.push(sr);
                // body...
              });
            });
        });
        if (sel.length == 0) {
          vm.subramos_toselected = [];
          vm.subramos_selected = [];
          getSubramos();
        }
      };
    }

    $scope.sendNow = function (id) {
      SweetAlert.swal(
        {
          title: "¿Está seguro de enviar esta campaña?",
          text: "Solo se enviarán los archivos ya guardados en la base de datos tipo pdf, excel e imágenes jpeg/jpg/png.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Enviar",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            if ($scope.email_filter_tags.length == 0) {
              toaster.error(
                "La lista de destinatarios no debe de estar vacía."
              );
              return;
            }
            if (uploader && uploader.queue && uploader.queue.length != 0) {
              var files = uploader.queue;
              var totalSize = 0;
              var errorMessageElement = document.getElementById("message");
              for (var i = 0; i < files.length; i++) {
                totalSize += files[i].file.size;
              }
              var totalSizeMB = totalSize / (1024 * 1024);
              if (totalSizeMB > 25) {
                errorMessageElement.style.display = "block";
                errorMessageElement.style.textAlign = "center";
                errorMessageElement.textContent =
                  "La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.*";
                return;
              } else {
                errorMessageElement.style.display = "none"; // Hide error message if files are valid
              }
            }
            $scope.campaign.message = vm.htmlVariable;
            $scope.campaign.sendingDate = new Date(
              datesFactory.toDate($scope.campaign.sendingDate)
            );
            var aux_emails = [];
            $scope.email_filter_tags.forEach(function (item) {
              aux_emails.push(item["text"]);
            });
            $scope.campaign.emails = aux_emails + "";

            $http
              .patch($scope.campaign.url, $scope.campaign)
              .then(function (response) {
                if (response.status == 200) {
                  uploadFiles($scope.campaign);
                  setTimeout(function () {
                    $http
                      .post(url.IP + "send-campaign/", {
                        id: id,
                        files: $scope.campaign.campaign_files,
                      })
                      .then(
                        function success(response) {
                          if (
                            response.status == 200 ||
                            response.status == 201
                          ) {
                            SweetAlert.swal(
                              "¡Listo!",
                              "Campaña enviada",
                              "success"
                            );
                          } else {
                            SweetAlert.swal(
                              "Error",
                              "Error al enviar campaña, " +
                                response.data.response.status,
                              "error"
                            );
                          }
                          $state.go("campaign.list");
                        },
                        function error(response) {
                          SweetAlert.swal(
                            "¡Error!",
                            "Error al enviar campaña",
                            "error"
                          );
                        }
                      );
                    activate();
                  }, 2000);
                }
              });
          } else {
            SweetAlert.swal(
              "¡Cancelado!",
              "La campaña no fue enviada",
              "error"
            );
            return;
          }
        }
      );
    };

    $scope.massive_load = function () {
      if ($scope.conciliar_masivos == true) {
        $scope.conciliar_masivos = false;
        $scope.toConciliate = [];
        $scope.suma = 0;
        $scope.suma2 = 0;
      } else {
        $scope.conciliar_masivos = true;
      }
    };

    $scope.save = function () {
      $scope.campaign.type_contractor = $scope.campaign.type_contractor
        ? $scope.campaign.type_contractor
        : 3;
      $scope.campaign.report = $scope.campaign.report
        ? $scope.campaign.report
        : 0;
      $scope.campaign.since = $scope.campaign.since ? $scope.campaign.since : 0;
      $scope.campaign.until = $scope.campaign.until ? $scope.campaign.until : 0;
      $scope.campaign.group = $scope.campaign.group ? $scope.campaign.group : 0;
      $scope.campaign.provider = $scope.campaign.provider
        ? $scope.campaign.provider
        : 0;
      $scope.campaign.ramo = $scope.campaign.ramo ? $scope.campaign.ramo : 0;
      $scope.campaign.subramo = $scope.campaign.sramo
        ? $scope.campaign.sramo
        : 0;

      if (
        Array.isArray($scope.campaign.group) &&
        $scope.campaign.group.length == 0
      ) {
        $scope.campaign.group = 0;
      }

      if (
        Array.isArray($scope.campaign.provider) &&
        $scope.campaign.provider.length == 0
      ) {
        $scope.campaign.provider = 0;
      }

      if (
        Array.isArray($scope.campaign.status) &&
        $scope.campaign.status.length == 0
      ) {
        $scope.campaign.status = 0;
      }

      if (
        Array.isArray($scope.campaign.ramo) &&
        $scope.campaign.ramo.length == 0
      ) {
        $scope.campaign.ramo = 0;
      }

      if (
        Array.isArray($scope.campaign.subramo) &&
        $scope.campaign.subramo.length == 0
      ) {
        $scope.campaign.subramo = 0;
      }

      if ($scope.email_filter_tags.length == 0) {
        toaster.error("La lista de destinatarios no debe de estar vacía.");
        return;
      }
      var aux_emails = [];
      $scope.campaign.message = vm.htmlVariable;
      $scope.email_filter_tags.forEach(function (item) {
        aux_emails.push(item["text"]);
      });

      $scope.campaign.emails = aux_emails + "";
      $scope.campaign.sendingDate = new Date(
        datesFactory.toDate($scope.campaign.sendingDate)
      );
      $http
        .patch($scope.campaign.url, $scope.campaign)
        .then(function (response) {
          uploadFiles($scope.campaign);
          if (response.status == 200) {
            toaster.success("La campaña se ha actualizado exitosamente");
            setTimeout(function () {
              $state.go("campaign.list");
            }, 1500);
          }
        });
    };

    $scope.cancel = function () {
      $state.go("campaign.list");
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    vm.uploadFiles = uploadFiles;
    function uploadFiles(campaign) {
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "campaigns/" + campaign.id + "/archivos/";
      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    $scope.cleanEmails = function () {
      $scope.email_filter_tags = [];
    };

    $scope.selectExcel = function (parData) {
      $scope.strcutureData = certStructure(parData);
    };
    function certStructure(parData) {
      var dateid;
      parData["Hoja1"].forEach(function (obj) {
        $.each(obj, function (key, value) {
          dateid = new Date().getTime();
          if (value.indexOf("@") != -1) {
            // var index = vm.email_tags.findIndex(x => x.text==value)
            var index = -1;
            $scope.email_filter_tags.forEach(function (email) {
              if (email.text == value) index = 1;
            });
            if (index === -1) {
              $scope.email_filter_tags.push({
                text: value,
                id: dateid + value,
              });
            } else {
              toaster.warning("Email " + value + " repetido");
            }
          }
        });
      });
      $scope.massive_load();
    }
  }
})();

(function () {
  "use strict";
  angular.module("inspinia").factory("buscadorService", buscadorService);
  buscadorService.$inject = [
    "SweetAlert",
    "datesFactory",
    "dataFactory",
    "formService",
    "coverageService",
    "fileService",
    "ContratanteService",
    "packageService",
    "ramoService",
    "providerService",
    "payform",
    "receiptService",
    "url",
    "$q",
    "$http",
    "globalVar",
    "helpers",
    "$localStorage",
    "generalService",
    "$sessionStorage",
  ];
  function buscadorService(
    SweetAlert,
    datesFactory,
    dataFactory,
    formService,
    coverageService,
    fileService,
    ContratanteService,
    packageService,
    ramoService,
    providerService,
    payform,
    receiptService,
    url,
    $q,
    $http,
    globalVar,
    helpers,
    $localStorage,
    generalService,
    $sessionStorage
  ) {
    var infoUser = $localStorage.infoUser;
    var files = [];
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var orgName = usr.org;
    var service = {
      // otra:otra,
      // pruebaChain:pruebaChain,
      obtenerResultados: obtenerResultados,
      getPolizasData: getPolizasData,
      getContratantesData: getContratantesData,
      getFianzasData: getFianzasData,
      getOtsData: getOtsData,
      getGruposData: getGruposData,
      getAseguradorasData: getAseguradorasData,
      getSiniestrosData: getSiniestrosData,
      getEndososData: getEndososData,
      getRecibosData: getRecibosData,
      getCertificadosData: getCertificadosData,
    };
    return service;
    function getContratantesData(cadena) {
      var postData = {
        cadena: cadena,
        org: usr.org,
      };
      var dfdc = $q.defer();
      var busquedaCompletaC = {};
      var thingsC = 0;
      var thingsToLoadC = 0;
      thingsToLoadC++;
      if (usr.org == "ancora") {
        var u = url.SUPERBUSCADOR_ANCORA;
      } else {
        var u = url.SUPERBUSCADOR;
      }
      $http({
        method: "POST",
        //   url: u + '/superbuscador_contratantes',
        url: u + "/buscador_contratantes",
        data: postData,
      })
        .then(function (busquedaContractor) {
          if (checkResponseC(busquedaContractor)) {
            return;
          }
          var busquedaOK = busquedaContractor.data;
          // busquedaOK.contratantes = busquedaOK.contractors;
          // busquedaOK.contratantes_resultados = busquedaOK.resultados;
          busquedaOK.contratantes =
            parseInt(busquedaOK.resultados_fisicas.length) +
            parseInt(busquedaOK.resultados_morales.length);
          busquedaCompletaC = angular.copy(busquedaOK);
          thingLoaded("contratantes");
          thingLoaded("bsuquedaCompletaOK"); // fin
        })
        .catch(function (error) {
          dfdc.reject(error);
        });
      function thingLoaded(what) {
        thingsC++;
        if (thingsC > thingsToLoadC) {
          dfdc.resolve(busquedaCompletaC);
        }
      }
      function checkResponseC(response) {
        if (response.status < 200 || response.status >= 300) {
          dfdc.reject(response);
          return true;
        }
        return false;
      }
      return dfdc.promise;
    }
    function getPolizasData(cadena) {
      var postData = {
        cadena: cadena,
        org: usr.org,
      };
      var dfdc = $q.defer();
      var busquedaCompletaP = {};
      var thingsC = 0;
      var thingsToLoadC = 0;
      thingsToLoadC++;
      if (usr.org == "ancora") {
        var u = url.SUPERBUSCADOR_ANCORA;
      } else {
        var u = url.SUPERBUSCADOR;
      }
      $http({
        method: "POST",
        url: u + "/buscador_polizas",
        //   url: u+ '/superbuscador_polizas_lista',
        data: postData,
      })
        .then(function (busquedaPolizas) {
          if (checkResponseC(busquedaPolizas)) {
            return;
          }
          var busquedaOK = busquedaPolizas.data;
          busquedaOK.polizas = busquedaOK.resultados.length;
          busquedaOK.policies = busquedaOK.resultados.length;
          busquedaOK.polizas_resultados = busquedaOK.resultados;
          // var busquedaOK = busquedaPolizas.data.coincidences
          // busquedaOK.polizas = busquedaOK.policies;
          // busquedaOK.polizas_resultados = busquedaOK.resultados;
          busquedaCompletaP.policies = angular.copy(busquedaOK);
          thingLoaded("polizas");
          thingLoaded("busquedaCompletaOK"); // fin
        })
        .catch(function (error) {
          dfdc.reject(error);
        });
      function thingLoaded(what) {
        thingsC++;
        if (thingsC > thingsToLoadC) {
          dfdc.resolve(busquedaCompletaP);
        }
      }
      function checkResponseC(response) {
        if (response.status < 200 || response.status >= 300) {
          dfdc.reject(response);
          return true;
        }
        return false;
      }
      return dfdc.promise;
    }
    function getFianzasData(cadena) {
      var postData = {
        cadena: cadena,
        org: usr.org,
      };
      var dfdc = $q.defer();
      var busquedaCompletaP = {};
      var thingsC = 0;
      var thingsToLoadC = 0;
      thingsToLoadC++;
      if (usr.org == "ancora") {
        var u = url.SUPERBUSCADOR_ANCORA;
      } else {
        var u = url.SUPERBUSCADOR;
      }
      $http({
        method: "POST",
        //   url: u + '/superbuscador_fianzas',
        url: u + "/buscador_fianzas",
        data: postData,
      })
        .then(function (busquedaFianzas) {
          if (checkResponseC(busquedaFianzas)) {
            return;
          }
          var busquedaOK = busquedaFianzas.data;
          busquedaOK.fianzas = busquedaOK.resultados.length;
          busquedaOK.fianzas_resultados = busquedaOK.resultados;
          busquedaCompletaP = angular.copy(busquedaOK);
          thingLoaded("fianzas");
          thingLoaded("busquedaCompletaOK"); // fin
        })
        .catch(function (error) {
          dfdc.reject(error);
        });
      function thingLoaded(what) {
        thingsC++;
        if (thingsC > thingsToLoadC) {
          dfdc.resolve(busquedaCompletaP);
        }
      }
      function checkResponseC(response) {
        if (response.status < 200 || response.status >= 300) {
          dfdc.reject(response);
          return true;
        }
        return false;
      }
      return dfdc.promise;
    }
    function getEndososData(cadena) {
      var postData = {
        cadena: cadena,
        org: usr.org,
      };
      var dfdc = $q.defer();
      var busquedaCompletaG = {};
      var thingsC = 0;
      var thingsToLoadC = 0;
      thingsToLoadC++;
      if (usr.org == "ancora") {
        var u = url.SUPERBUSCADOR_ANCORA;
      } else {
        var u = url.SUPERBUSCADOR;
      }
      $http({
        method: "POST",
        //   url: u + '/superbuscador_endosos',
        url: u + "/buscador_endosos",
        data: postData,
      })
        .then(function (busquedaEndorsments) {
          if (checkResponseC(busquedaEndorsments)) {
            return;
          }
          var busquedaOK = busquedaEndorsments.data;
          busquedaOK.endorsments = busquedaOK.resultados.length;
          busquedaOK.endorsments_resultados = busquedaOK.resultados;
          busquedaCompletaG.endorsments = angular.copy(busquedaOK);
          thingLoaded("endosos");
          thingLoaded("busquedaCompletaOK"); // fin
        })
        .catch(function (error) {
          dfdc.reject(error);
        });
      function thingLoaded(what) {
        thingsC++;
        if (thingsC > thingsToLoadC) {
          dfdc.resolve(busquedaCompletaG);
        }
      }
      function checkResponseC(response) {
        if (response.status < 200 || response.status >= 300) {
          dfdc.reject(response);
          return true;
        }
        return false;
      }
      return dfdc.promise;
    }
    function getRecibosData(cadena) {
      var postData = {
        cadena: cadena,
        org: usr.org,
      };
      var dfdc = $q.defer();
      var busquedaCompletaG = {};
      var thingsC = 0;
      var thingsToLoadC = 0;
      thingsToLoadC++;
      if (usr.org == "ancora") {
        var u = url.SUPERBUSCADOR_ANCORA;
      } else {
        var u = url.SUPERBUSCADOR;
      }
      $http({
        method: "POST",
        //   url: u + '/superbuscador_recibos',
        url: u + "/buscador_recibos",
        data: postData,
      })
        .then(function (busquedaReceipts) {
          if (checkResponseC(busquedaReceipts)) {
            return;
          }
          console.log("busqeeee", busquedaReceipts);
          var busquedaOK = busquedaReceipts.data;
          busquedaOK.recibos = busquedaOK.resultados.length;
          busquedaOK.recibos_resultados = busquedaOK.resultados;
          busquedaCompletaG.recibos = angular.copy(busquedaOK);
          thingLoaded("recibos");
          thingLoaded("busquedaCompletaOK"); // fin
        })
        .catch(function (error) {
          dfdc.reject(error);
        });
      function thingLoaded(what) {
        thingsC++;
        if (thingsC > thingsToLoadC) {
          dfdc.resolve(busquedaCompletaG);
        }
      }
      function checkResponseC(response) {
        if (response.status < 200 || response.status >= 300) {
          dfdc.reject(response);
          return true;
        }
        return false;
      }
      return dfdc.promise;
    }
    function getAseguradorasData(cadena) {
      var postData = {
        cadena: cadena,
        org: usr.org,
      };
      var dfdc = $q.defer();
      var busquedaCompletaG = {};
      var thingsC = 0;
      var thingsToLoadC = 0;
      thingsToLoadC++;
      if (usr.org == "ancora") {
        var u = url.SUPERBUSCADOR_ANCORA;
      } else {
        var u = url.SUPERBUSCADOR;
      }
      $http({
        method: "POST",
        // url: u + '/superbuscador_aseguradoras',
        url: u + "/buscador_aseguradoras",
        data: postData,
      })
        .then(function (busquedaProviders) {
          if (checkResponseC(busquedaProviders)) {
            return;
          }
          var busquedaOK = busquedaProviders.data;
          console.log("bsucador aseguradoras", busquedaOK);
          busquedaOK.providers = busquedaOK.resultados.length;
          busquedaOK.providers_resultados = busquedaOK.resultados;
          console.log("bsucador aseguradoras", busquedaOK);
          busquedaCompletaG = angular.copy(busquedaOK);
          thingLoaded("aseg");
          thingLoaded("busquedaCompletaOK"); // fin
        })
        .catch(function (error) {
          dfdc.reject(error);
        });
      function thingLoaded(what) {
        thingsC++;
        if (thingsC > thingsToLoadC) {
          dfdc.resolve(busquedaCompletaG);
        }
      }
      function checkResponseC(response) {
        if (response.status < 200 || response.status >= 300) {
          dfdc.reject(response);
          return true;
        }
        return false;
      }
      return dfdc.promise;
    }
    function getSiniestrosData(cadena) {
      var postData = {
        cadena: cadena,
        org: usr.org,
      };
      var dfdc = $q.defer();
      var busquedaCompletaP = {};
      var thingsC = 0;
      var thingsToLoadC = 0;
      thingsToLoadC++;
      if (usr.org == "ancora") {
        var u = url.SUPERBUSCADOR_ANCORA;
      } else {
        var u = url.SUPERBUSCADOR;
      }
      $http({
        method: "POST",
        // url: u + '/superbuscador_siniestros',
        url: u + "/buscador_siniestros",
        data: postData,
      })
        .then(function (busquedaSinisters) {
          if (checkResponseC(busquedaSinisters)) {
            return;
          }
          console.log("busquedaSinisters", busquedaSinisters);
          // var busquedaOK = busquedaSinisters.data.coincidences
          // busquedaOK.sinisters = busquedaOK.sinisters;
          // busquedaOK.sinisters_resultados = busquedaOK.resultados;
          var busquedaOK = busquedaSinisters.data;
          busquedaOK.sinisters = busquedaOK.resultados.length;
          busquedaOK.sinisters_resultados = busquedaOK.resultados;
          busquedaCompletaP.sinisters = angular.copy(busquedaOK);
          thingLoaded("siniestros");
          thingLoaded("busquedaCompletaOK"); // fin
        })
        .catch(function (error) {
          dfdc.reject(error);
        });
      function thingLoaded(what) {
        thingsC++;
        if (thingsC > thingsToLoadC) {
          dfdc.resolve(busquedaCompletaP);
        }
      }
      function checkResponseC(response) {
        if (response.status < 200 || response.status >= 300) {
          dfdc.reject(response);
          return true;
        }
        return false;
      }
      return dfdc.promise;
    }
    function getGruposData(cadena) {
      var postData = {
        cadena: cadena,
        org: usr.org,
      };
      var dfdc = $q.defer();
      var busquedaCompletaP = {};
      var thingsC = 0;
      var thingsToLoadC = 0;
      thingsToLoadC++;
      if (usr.org == "ancora") {
        var u = url.SUPERBUSCADOR_ANCORA;
      } else {
        var u = url.SUPERBUSCADOR;
      }
      $http({
        method: "POST",
        //   url: u+ '/superbuscador_grupos',
        url: u + "/buscador_grupos",
        data: postData,
      })
        .then(function (busquedaGroups) {
          if (checkResponseC(busquedaGroups)) {
            return;
          }
          var busquedaOK = busquedaGroups.data;
          busquedaOK.groups = busquedaOK.resultados.length;
          busquedaOK.groups_resultados = busquedaOK.resultados;
          busquedaCompletaP = angular.copy(busquedaOK);
          thingLoaded("grupos");
          thingLoaded("busquedaCompletaOK"); // fin
        })
        .catch(function (error) {
          dfdc.reject(error);
        });
      function thingLoaded(what) {
        thingsC++;
        if (thingsC > thingsToLoadC) {
          dfdc.resolve(busquedaCompletaP);
        }
      }
      function checkResponseC(response) {
        if (response.status < 200 || response.status >= 300) {
          dfdc.reject(response);
          return true;
        }
        return false;
      }
      return dfdc.promise;
    }
    function getOtsData(cadena) {
      var postData = {
        cadena: cadena,
        org: usr.org,
      };
      var dfdc = $q.defer();
      var busquedaCompletaP = {};
      var thingsC = 0;
      var thingsToLoadC = 0;
      thingsToLoadC++;
      if (usr.org == "ancora") {
        var u = url.SUPERBUSCADOR_ANCORA;
      } else {
        var u = url.SUPERBUSCADOR;
      }
      $http({
        method: "POST",
        //   url: u + '/superbuscador_ots',
        url: u + "/buscador_ots",
        data: postData,
      })
        .then(function (busquedaOTsx) {
          if (checkResponseC(busquedaOTsx)) {
            return;
          }
          var busquedaOK = busquedaOTsx.data;
          busquedaOK.conteos_ots = parseInt(
            busquedaOK.resultados_ots.length +
              busquedaOK.resultados_endosos.length
          );
          busquedaOK.ots_resultados = busquedaOK.resultados_ots;
          busquedaOK.otsendosos_resultados = busquedaOK.resultados_endosos;
          busquedaCompletaP = angular.copy(busquedaOK);
          thingLoaded("ots");
          thingLoaded("busquedaCompletaOK"); // fin
        })
        .catch(function (error) {
          dfdc.reject(error);
        });
      function thingLoaded(what) {
        thingsC++;
        if (thingsC > thingsToLoadC) {
          dfdc.resolve(busquedaCompletaP);
        }
      }
      function checkResponseC(response) {
        if (response.status < 200 || response.status >= 300) {
          dfdc.reject(response);
          return true;
        }
        return false;
      }
      return dfdc.promise;
    }
    function getCertificadosData(cadena) {
      var postData = {
        cadena: cadena,
        org: usr.org,
      };
      var dfdc = $q.defer();
      var busquedaCompletaG = {};
      var thingsC = 0;
      var thingsToLoadC = 0;
      thingsToLoadC++;
      if (usr.org == "ancora") {
        var u = url.SUPERBUSCADOR_ANCORA;
      } else {
        var u = url.SUPERBUSCADOR;
      }
      $http({
        method: "POST",
        //   url: u + '/superbuscador_certificados',
        url: u + "/buscador_certificados",
        data: postData,
      })
        .then(function (busquedaCertificates) {
          if (checkResponseC(busquedaCertificates)) {
            return;
          }
          var busquedaOK = busquedaCertificates.data;
          busquedaOK.certificados = busquedaOK.resultados.length;
          busquedaOK.certificados_resultados = busquedaOK.resultados;
          // busquedaOK.certificados = busquedaOK.certificados;
          // busquedaOK.certificados_resultados = busquedaOK.resultados;
          busquedaCompletaG = angular.copy(busquedaOK);
          thingLoaded("certificados");
          thingLoaded("busquedaCompletaOK"); // fin
        })
        .catch(function (error) {
          dfdc.reject(error);
        });
      function thingLoaded(what) {
        thingsC++;
        if (thingsC > thingsToLoadC) {
          dfdc.resolve(busquedaCompletaG);
        }
      }
      function checkResponseC(response) {
        if (response.status < 200 || response.status >= 300) {
          dfdc.reject(response);
          return true;
        }
        return false;
      }
      return dfdc.promise;
    }
    function obtenerResultados(cadena) {
      var postData = {
        cadena: cadena,
        org: usr.org,
      };
      var dfd = $q.defer();
      var busquedaCompleta = {};
      var things = 0;
      var thingsToLoad = 0; //
      // $http.post(url.SUPERBUSCADOR + 'superbuscador_contratantes/'+postData+'/')
      thingsToLoad++;
      $http({
        method: "POST",
        url: url.SUPERBUSCADOR + "/superbuscador_contratantes",
        data: postData,
      })
        .then(function (busquedaContractor) {
          if (checkResponse(busquedaContractor)) {
            return;
          }
          var busquedaOK = busquedaContractor.data.coincidences;
          busquedaOK.contratantes = busquedaOK.contractors;
          busquedaOK.contratantes_resultados = busquedaOK.resultados;
          busquedaCompleta.contractors = angular.copy(busquedaOK);
          thingLoaded("contratantes");
          //polizas
          thingsToLoad++;
          // $http.post(url.SUPERBUSCADOR + 'superbuscador_polizas_/'+postData+'/')
          $http({
            method: "POST",
            url: url.SUPERBUSCADOR + "/superbuscador_polizas_lista",
            data: postData,
          })
            .then(function (busquedaPolizas) {
              if (checkResponse(busquedaPolizas)) {
                return;
              }
              var busquedaOK = busquedaPolizas.data.coincidences;
              busquedaOK.polizas = busquedaOK.policies;
              busquedaOK.polizas_resultados = busquedaOK.resultados;
              busquedaCompleta.policies = angular.copy(busquedaOK);
              // thingsToLoad += 1
              thingLoaded("polizas");
            })
            .catch(function (error) {
              console.log("eror al buscar polizas", error);
            });
          thingsToLoad++;
          // $http.post(url.SUPERBUSCADOR + 'superbuscador_fianzas/'+postData+'/')
          $http({
            method: "POST",
            url: url.SUPERBUSCADOR + "/superbuscador_fianzas",
            data: postData,
          })
            .then(function (busquedaFianzas) {
              if (checkResponse(busquedaFianzas)) {
                return;
              }
              var busquedaOK = busquedaFianzas.data.coincidences;
              busquedaOK.fianzas = busquedaOK.fianzas;
              busquedaOK.fianzas_resultados = busquedaOK.resultados;
              busquedaCompleta.fianzas = angular.copy(busquedaOK);
              // thingsToLoad += 1
              thingLoaded("fianzas");
            })
            .catch(function (error) {
              console.log("eror al buscar fianzas", error);
            });
          thingsToLoad++;
          // $http.post(url.SUPERBUSCADOR + 'superbuscador_ots/'+postData+'/')
          $http({
            method: "POST",
            url: url.SUPERBUSCADOR + "/superbuscador_ots",
            data: postData,
          })
            .then(function (busquedaOts) {
              if (checkResponse(busquedaOts)) {
                return;
              }
              var busquedaOK = busquedaOts.data.coincidences;
              busquedaOK.ots = busquedaOK.ots;
              busquedaOK.ots_resultados = busquedaOK.resultados;
              busquedaCompleta.ots = angular.copy(busquedaOK);
              // thingsToLoad += 1
              thingLoaded("ots");
            })
            .catch(function (error) {
              console.log("eror al buscar ots", error);
            });
          thingsToLoad++;
          // $http.post(url.SUPERBUSCADOR + 'superbuscador_grupos/'+postData+'/')
          $http({
            method: "POST",
            url: url.SUPERBUSCADOR + "/superbuscador_grupos",
            data: postData,
          })
            .then(function (busquedaGroups) {
              if (checkResponse(busquedaGroups)) {
                return;
              }
              var busquedaOK = busquedaGroups.data.coincidences;
              busquedaOK.groups = busquedaOK.groups;
              busquedaOK.groups_resultados = busquedaOK.resultados;
              busquedaCompleta.groups = angular.copy(busquedaOK);
              // thingsToLoad += 1
              thingLoaded("groups");
            })
            .catch(function (error) {
              console.log("eror al buscar groups", error);
            });
          thingsToLoad++;
          // $http.post(url.SUPERBUSCADOR + 'superbuscador_aseguradoras/'+postData+'/')
          $http({
            method: "POST",
            url: url.SUPERBUSCADOR + "/superbuscador_aseguradoras",
            data: postData,
          })
            .then(function (busquedaProviders) {
              if (checkResponse(busquedaProviders)) {
                return;
              }
              var busquedaOK = busquedaProviders.data.coincidences;
              busquedaOK.providers = busquedaOK.providers;
              busquedaOK.providers_resultados = busquedaOK.resultados;
              busquedaCompleta.providers = angular.copy(busquedaOK);
              // thingsToLoad += 1
              thingLoaded("providers");
            })
            .catch(function (error) {
              console.log("eror al buscar providers", error);
            });
          thingsToLoad++;
          // $http.post(url.SUPERBUSCADOR + 'superbuscador_siniestros/'+postData+'/')
          $http({
            method: "POST",
            url: url.SUPERBUSCADOR + "/superbuscador_siniestros",
            data: postData,
          })
            .then(function (busquedaSinisters) {
              if (checkResponse(busquedaSinisters)) {
                return;
              }
              var busquedaOK = busquedaSinisters.data.coincidences;
              busquedaOK.sinisters = busquedaOK.sinisters;
              busquedaOK.sinisters_resultados = busquedaOK.resultados;
              busquedaCompleta.sinisters = angular.copy(busquedaOK);
              // thingsToLoad += 1
              thingLoaded("sinisters");
            })
            .catch(function (error) {
              console.log("eror al buscar sinisters", error);
            });
          thingsToLoad++;
          // $http.post(url.SUPERBUSCADOR + 'superbuscador_endosos/'+postData+'/')
          $http({
            method: "POST",
            url: url.SUPERBUSCADOR + "/superbuscador_endosos",
            data: postData,
          })
            .then(function (busquedaEndorsments) {
              if (checkResponse(busquedaEndorsments)) {
                return;
              }
              var busquedaOK = busquedaEndorsments.data.coincidences;
              busquedaOK.endorsments = busquedaOK.endorsments;
              busquedaOK.endorsments_resultados = busquedaOK.resultados;
              busquedaCompleta.endorsments = angular.copy(busquedaOK);
              // thingsToLoad += 1
              thingLoaded("endorsments");
            })
            .catch(function (error) {
              console.log("eror al buscar endorsments", error);
            });
          thingsToLoad++;
          // $http.post(url.SUPERBUSCADOR + 'superbuscador_recibos/'+postData+'/')
          $http({
            method: "POST",
            url: url.SUPERBUSCADOR + "/superbuscador_recibos",
            data: postData,
          })
            .then(function (busquedaReceipts) {
              if (checkResponse(busquedaReceipts)) {
                return;
              }
              var busquedaOK = busquedaReceipts.data.coincidences;
              busquedaOK.recibos = busquedaOK.recibos;
              busquedaOK.recibos_resultados = busquedaOK.resultados;
              busquedaCompleta.recibos = angular.copy(busquedaOK);
              // thingsToLoad += 1
              thingLoaded("recibos");
            })
            .catch(function (error) {
              console.log("eror al buscar recibos", error);
            });
          thingsToLoad++;
          // $http.post(url.SUPERBUSCADOR + 'superbuscador_certificados/'+postData+'/')
          $http({
            method: "POST",
            url: url.SUPERBUSCADOR + "/superbuscador_certificados",
            data: postData,
          })
            .then(function (busquedaCertificates) {
              if (checkResponse(busquedaCertificates)) {
                return;
              }
              var busquedaOK = busquedaCertificates.data.coincidences;
              busquedaOK.certificados = busquedaOK.certificados;
              busquedaOK.certificados_resultados = busquedaOK.resultados;
              busquedaCompleta.certificados = angular.copy(busquedaOK);
              // thingsToLoad += 1
              thingLoaded("certificados");
            })
            .catch(function (error) {
              console.log("eror al buscar certificados", error);
            });
          thingLoaded("bsuquedaCompletaOK"); // fin
        })
        .catch(function (error) {
          dfd.reject(error);
        });

      function thingLoaded(what) {
        things++;
        if (things > thingsToLoad) {
          dfd.resolve(busquedaCompleta);
        }
      }
      function checkResponse(response) {
        if (response.status < 200 || response.status >= 300) {
          dfd.reject(response);
          return true;
        }
        return false;
      }
      return dfd.promise;
    }
    function buy() {
      $http({
        method: "POST",
        url: url.SUPERBUSCADOR + "/superbuscador_certificados",
        data: postData,
      }).then(function (response) {});
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("BuscadorCtrl", BuscadorCtrl)
    .directive("fooRepeatDone", function () {
      return function ($scope, element) {
        if ($scope.$last) {
          // all are rendered
          $(".table").trigger("footable_redraw");
        }
      };
    });
  BuscadorCtrl.$inject = [
    "buscadorService",
    "appStates",
    "$uibModal",
    "receiptService",
    "$state",
    "$http",
    "$q",
    "url",
    "contactService",
    "providerService",
    "toaster",
    "helpers",
    "MESSAGES",
    "$localStorage",
    "$sessionStorage",
    "$stateParams",
    "$scope",
    "$rootScope",
    "$parse",
    "dataFactory",
    "datesFactory",
  ];

  function BuscadorCtrl(
    buscadorService,
    appStates,
    $uibModal,
    receiptService,
    $state,
    $http,
    $q,
    url,
    contactService,
    providerService,
    toaster,
    helpers,
    MESSAGES,
    $localStorage,
    $sessionStorage,
    $stateParams,
    $scope,
    $rootScope,
    $parse,
    dataFactory,
    datesFactory
  ) {
    $scope.vm = this;
    var cadena = $stateParams.cadena;
    $scope.showContractors = false;
    $scope.showPolicies = false;
    $scope.showFianzas = false;
    $scope.showOT = false;
    $scope.showCaratulas = false;
    $scope.showGroups = false;
    $scope.showProviders = false;
    $scope.showSinisters = false;
    $scope.showEndorsments = false;
    $scope.showReceipts = false;

    $scope.conteoEstatus = false;
    $scope.totalEstatus = 0;
    $scope.conteoSubramo = false;
    $scope.totalSubramo = 0;
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    $scope.orgName = usr.org;
    $scope.minMaxCon = function () {
      $modalCon = $(this).closest(".mymodal").attr("id");

      $apnData = $(this).closest(".mymodal");

      $modal = "#" + $modalCon;

      $(".modal-backdrop").addClass("display-none");

      $($modal).toggleClass("min");

      if ($($modal).hasClass("min")) {
        $(".minmaxCon").append($apnData);

        $(this).find("i").toggleClass("fa-minus").toggleClass("fa-clone");
      } else {
        $(".container").append($apnData);

        $(this).find("i").toggleClass("fa-clone").toggleClass("fa-minus");
      }
    };

    $scope.contractors_type = [
      { name: "Fisica", value: 1 },
      { name: "Moral", value: 2 },
    ];

    if ($stateParams.cadena) {
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go = 'v2/generics/seeker/';
      $scope.url_go = "seeker/";
      $http({
        method: "POST",
        // url: url.IP + 'seeker/',
        url: url.IP + $scope.url_go,
        data: {
          cadena: cadena,
          org: usr.org,
        },
      })
        .then(
          function success(request) {
            $scope.conteos = request.data;
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    }

    $scope.status = function (value) {
      switch (value) {
        case 1:
          return "En trámite";
          break;
        case 2:
          return "OT Cancelada";
          break;
        case 4:
          return "Precancelada";
          break;
        case 10:
          return "Por iniciar";
          break;
        case 11:
          return "Cancelada";
          break;
        case 12:
          return "Renovada";
          break;
        case 13:
          return "Vencida";
          break;
        case 14:
          return "Vigente";
          break;
        case 15:
          return "No renovada";
          break;
        case 17:
          return "Anulada";
          break;
        case 24:
          return "Pre-Anulada";
          break;
        default:
          return "Pendiente";
      }
    };
    $scope.accesos = $sessionStorage.permisos;
    $rootScope.permisos_new = $rootScope.permisos;
    if ($scope.accesos) {
      $scope.accesos.forEach(function (perm) {
        if (perm.model_name == "Dashboard") {
          $scope.acceso_dash = perm;
          $scope.acceso_dash.permissions.forEach(function (acc) {
            if (acc.permission_name == "Gráfica OTs") {
              if (acc.checked == true) {
                $scope.permiso_g_ot = true;
              } else {
                $scope.permiso_g_ot = false;
              }
            } else if (acc.permission_name == "Gráfica cobranza") {
              if (acc.checked == true) {
                $scope.permiso_g_cob = true;
              } else {
                $scope.permiso_g_cob = false;
              }
            } else if (acc.permission_name == "Gráfica renovaciones") {
              if (acc.checked == true) {
                $scope.permiso_g_ren = true;
              } else {
                $scope.permiso_g_ren = false;
              }
            } else if (acc.permission_name == "Gráfica siniestros") {
              if (acc.checked == true) {
                $scope.permiso_g_sin = true;
              } else {
                $scope.permiso_g_sin = false;
              }
            }
          });
        } else if (perm.model_name == "Pólizas") {
          $scope.acceso_polizas = perm;
          $scope.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                $scope.acceso_adm_pol = true;
              } else {
                $scope.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                $scope.acceso_ver_pol = true;
              } else {
                $scope.acceso_ver_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Endosos") {
          $scope.acceso_endosos = perm;
        } else if (perm.model_name == "Ordenes de trabajo") {
          $scope.acceso_ot = perm;
          $scope.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                $scope.acceso_adm_ot = true;
              } else {
                $scope.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                $scope.acceso_ver_ot = true;
              } else {
                $scope.acceso_ver_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Siniestros") {
          $scope.acceso_sin = perm;
          $scope.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                $scope.acceso_adm_sin = true;
              } else {
                $scope.acceso_adm_sin = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          $scope.acceso_cob = perm;
          $scope.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                $scope.acceso_ver_cob = true;
              } else {
                $scope.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                $scope.acceso_desp_cob = true;
              } else {
                $scope.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                $scope.acceso_pag_cob = true;
              } else {
                $scope.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                $scope.acceso_desco_cob = true;
              } else {
                $scope.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                $scope.acceso_conc_cob = true;
              } else {
                $scope.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                $scope.acceso_liq_cob = true;
              } else {
                $scope.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          $scope.acceso_correo = perm;
          $scope.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                $scope.acceso_cor = true;
              } else {
                $scope.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          $scope.acceso_reportes = perm;
          $scope.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                $scope.acceso_rep_fia = true;
              } else {
                $scope.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                $scope.acceso_rep_sin = true;
              } else {
                $scope.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                $scope.acceso_rep_end = true;
              } else {
                $scope.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                $scope.acceso_rep_pol = true;
              } else {
                $scope.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                $scope.acceso_rep_ren = true;
              } else {
                $scope.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                $scope.acceso_rep_cob = true;
              } else {
                $scope.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          $scope.acceso_form = perm;
          $scope.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                $scope.acceso_form = true;
              } else {
                $scope.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Agenda") {
          $scope.acceso_age = perm;
          $scope.acceso_age.permissions.forEach(function (acc) {
            if (acc.permission_name == "Agenda") {
              if (acc.checked == true) {
                $scope.acceso_age = true;
              } else {
                $scope.acceso_age = false;
              }
            }
          });
        } else if (perm.model_name == "Mensajeria") {
          $scope.acceso_mns = perm;
          $scope.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                $scope.acceso_mns = true;
              } else {
                $scope.acceso_mns = false;
              }
            }
          });
        } else if (perm.model_name == "Campañas") {
          $scope.acceso_camp = perm;
          $scope.acceso_camp.permissions.forEach(function (acc) {
            if (acc.permission_name == "Campañas") {
              if (acc.checked == true) {
                $scope.acceso_camp = true;
              } else {
                $scope.acceso_camp = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          $scope.acceso_contg = perm;
          $scope.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                $scope.acceso_adm_cont = true;
              } else {
                $scope.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                $scope.acceso_ver_cont = true;
              } else {
                $scope.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          $scope.acceso_ref = perm;
          $scope.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_adm_ref = true;
              } else {
                $scope.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                $scope.acceso_pag_ref = true;
              } else {
                $scope.acceso_pag_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Fianzas") {
          $scope.acceso_fian = perm;
          $scope.acceso_fian.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar fianzas") {
              if (acc.checked == true) {
                $scope.acceso_adm_fia = true;
              } else {
                $scope.acceso_adm_fia = false;
              }
            } else if (acc.permission_name == "Ver fianzas") {
              if (acc.checked == true) {
                $scope.acceso_ver_fia = true;
              } else {
                $scope.acceso_ver_fia = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          $scope.acceso_files = perm;
          $scope.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                $scope.permiso_archivos = true;
              } else {
                $scope.permiso_archivos = false;
              }
            }
          });
        }
      });
    }
    $scope.active = 0;
    $scope.selectContrctorType = function (parType) {
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_cont = 'v2/generics/seeker-naturals/';
      //   $scope.url_go_jur = 'v2/generics/seeker-juridicals/';
      $scope.url_go_cont = "seeker-naturals/";
      $scope.url_go_jur = "seeker-juridicals/";

      $http({
        method: "GET",
        // url: url.IP + 'seeker-naturals/',
        url: url.IP + $scope.url_go_cont,
        params: {
          cadena: cadena,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              // $scope.juridicals = [];
              $scope.naturals = request.data.results;
              if (request.data.count == 0) {
                $scope.active = 1;
              } else {
                $scope.active = 0;
              }

              if ($scope.naturals.length) {
                $("#naturals").click();
              } else {
                $("#juridicals").click();
              }

              $scope.config_cont_naturals = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              $scope.show_pag_cont_naturals = true;
              // $scope.show_pag_cont_juridical = false;
              $scope.testPagination("naturals", "config_cont_naturals");
            }

            $http({
              method: "GET",
              url: url.IP + $scope.url_go_jur,
              params: {
                cadena: cadena,
              },
            })
              .then(
                function success(request) {
                  if (request.status === 200) {
                    $scope.juridicals = request.data.results;
                    $scope.config_cont_juridical = {
                      count: request.data.count,
                      previous: request.data.previous,
                      next: request.data.next,
                    };

                    $scope.show_pag_cont_juridical = true;
                    // $scope.show_pag_cont_naturals = false;
                    $scope.testPaginationJ(
                      "juridicals",
                      "config_cont_juridical"
                    );
                  }
                },
                function error(error) {}
              )
              .catch(function (e) {
                console.log(e);
              });
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.open_in_same_tab = function (name, route, params, identifier, type) {
      var existe = false;
      if (name && route) {
        $scope.route_for_new_tab = route;
        $scope.name_for_new_tab = name;
        // appStates.states.forEach(function(state) {
        //   if (state.route == $scope.route_for_new_tab){
        //     existe = true;
        //   }
        // });
      }

      // if (!existe){
      var active_tab = appStates.states.findIndex(function (item) {
        if (item.active) {
          return true;
        }
        return false;
      });
      if (type) {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
          type: type,
        };
      } else {
        appStates.states[active_tab] = {
          id: identifier,
          name: $scope.name_for_new_tab,
          heading: $scope.name_for_new_tab,
          route: $scope.route_for_new_tab,
          active: true,
          isVisible: true,
          href: $state.href($scope.route_for_new_tab),
        };
      }
      // }
      $localStorage.tab_states = appStates.states;
      $localStorage.tab_index = $localStorage.tab_states.length - 1;

      $state.go($scope.route_for_new_tab, params);
    };

    $scope.goToPolicy = function (insurance) {
      if (insurance.document_type == 1) {
        $scope.open_in_same_tab(
          "Información Póliza",
          "polizas.info",
          { polizaId: insurance.id },
          insurance.id,
          null
        );
        // $state.go('polizas.info', {polizaId: insurance.id});
      } else if (insurance.document_type == 3) {
        $scope.open_in_same_tab(
          "Información Colectividad",
          "colectividades.info",
          { polizaId: insurance.id },
          insurance.id,
          null
        );
        // $state.go('colectividades.info', {polizaId: insurance.id});
      } else if (insurance.document_type == 6) {
        $scope.open_in_same_tab(
          "Información Colectividad",
          "colectividades.info",
          { polizaId: insurance.caratula },
          insurance.caratula,
          null
        );
        // $state.go('colectividades.info', {polizaId: insurance.caratula});
      } else if (insurance.document_type == 7) {
        $scope.open_in_same_tab(
          "Información Fianza",
          "fianzas.info",
          { polizaId: insurance.id },
          insurance.id,
          null
        );
        // $state.go('fianzas.info', {polizaId: insurance.id});
      } else if (insurance.document_type == 8) {
        $scope.open_in_same_tab(
          "Información Fianza",
          "fianzas.details",
          { polizaId: insurance.id },
          insurance.id,
          null
        );
        // $state.go('fianzas.details',{polizaId: insurance.id});
      } else if (insurance.document_type == 11) {
        $scope.open_in_same_tab(
          "Información Flotilla",
          "flotillas.info",
          { polizaId: insurance.id },
          insurance.id,
          null
        );
        $state.go("flotillas.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 12) {
        $scope.open_in_same_tab(
          "Información Flotilla",
          "flotillas.info",
          { polizaId: insurance.caratula },
          insurance.caratula,
          null
        );
        // $state.go('flotillas.info',{polizaId: insurance.caratula});
      }
    };

    $scope.goToFianza = function (insurance) {
      if (insurance.document_type == 7) {
        $scope.open_in_same_tab(
          "Información Fianza",
          "fianzas.info",
          { polizaId: insurance.id },
          insurance.id,
          null
        );
        // $state.go('fianzas.info', {polizaId: insurance.id})
      } else if (insurance.document_type == 8) {
        $scope.open_in_same_tab(
          "Información Fianza",
          "fianzas.details",
          { polizaId: insurance.id },
          insurance.id,
          null
        );
        $state.go("fianzas.details", { polizaId: insurance.id });
      }
    };

    $scope.goToEndorsement = function (insurance) {
      if (
        insurance.policy.document_type == 7 ||
        insurance.policy.document_type == 8
      ) {
        $scope.open_in_same_tab(
          "Información Endoso",
          "endorsement.details",
          { endosoId: insurance.id },
          insurance.id,
          null
        );
        // $state.go('endorsement.details', {endosoId: insurance.id})
      } else {
        $scope.open_in_same_tab(
          "Información Endoso",
          "endorsement.info",
          { endosoId: insurance.id },
          insurance.id,
          null
        );
        // $state.go('endorsement.info',{endosoId: insurance.id})
      }
    };

    $scope.seekerContractors = function () {
      $scope.showPolicies = false;
      $scope.showGroups = false;
      $scope.showProviders = false;
      $scope.showSinisters = false;
      $scope.showEndorsments = false;
      $scope.showOT = false;
      $scope.showCaratulas = false;
      $scope.showReceipts = false;
      $scope.showFianzas = false;
      if ($scope.showContractors) {
        $scope.showContractors = false;
      } else if ($scope.conteos.contractors != 0) {
        $scope.showContractors = true;
      }
      $scope.selectContrctorType();
    };

    $scope.siniestrosInfo = function (
      sinistersId,
      sinisterRamo,
      sinisterSubramo,
      sinisters,
      sinister
    ) {
      // {siniestroId: sinister.id},{sinisterRamo: sinister.ramo},{sinisterSubramo: sinister.poliza.subramo},sinisters,sinister

      if (
        sinisterRamo.sinisterRamo == "Daños" ||
        sinisterRamo.sinisterRamo == "Daños (Autos)" ||
        (sinister.poliza.ramo == "Daños" &&
          sinister.poliza.subramo == "Automóviles")
      ) {
        $scope.sinistersRamo = 1;
        $scope.open_in_same_tab(
          "Información Sinestro",
          "siniestros.auto_info",
          { siniestroId: sinistersId.siniestroId },
          sinistersId.siniestroId,
          null
        );
        // $state.go('siniestros.auto_info', {siniestroId: sinistersId.siniestroId});
      } else if (sinisterRamo.sinisterRamo == "Vida") {
        $scope.sinistersRamo = 2;
        $scope.open_in_same_tab(
          "Información Sinestro",
          "siniestros.vida_info",
          { siniestroId: sinistersId.siniestroId },
          sinistersId.siniestroId,
          null
        );
        // $state.go('siniestros.vida_info', {siniestroId: sinistersId.siniestroId});
      } else if (sinisterRamo.sinisterRamo == "Accidentes y Enfermedades") {
        $scope.sinistersRamo = 3;
        $scope.open_in_same_tab(
          "Información Sinestro",
          "siniestros.info",
          { siniestroId: sinistersId.siniestroId },
          sinistersId.siniestroId,
          null
        );
        // $state.go('siniestros.info', {siniestroId: sinistersId.siniestroId});
      } else if (sinisterRamo.sinisterRamo == "Daños (no auto)") {
        $scope.open_in_same_tab(
          "Información Sinestro",
          "siniestros.danio_info",
          { siniestroId: sinistersId.siniestroId },
          sinistersId.siniestroId,
          null
        );
        // $state.go('siniestros.danio_info', {siniestroId: sinistersId.siniestroId});
      }
    };

    $scope.resultsBySubramo = function (subramo) {
      $scope.conteoEstatus = false;
      $scope.totalEstatus = 0;
      $http({
        method: "GET",
        url: url.IP + "seeker-policies/",
        params: {
          cadena: cadena,
          subramo: subramo.id,
          status: 0,
        },
      })
        .then(
          function success(requestSubramo) {
            if (requestSubramo.status === 200) {
              $scope.conteoSubramo = true;
              $scope.totalSubramo = requestSubramo.data.count;
              $scope.policies = [];
              $scope.policies = requestSubramo.data.results;
              $scope.config_policies = {
                count: requestSubramo.data.count,
                previous: requestSubramo.data.previous,
                next: requestSubramo.data.next,
              };
              $scope.show_pag_policies = true;
              $scope.testPagination("policies", "config_policies");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.orderVigencia = function () {
      if ($scope.order_type_asc == 1) {
        $scope.order_type_asc = 2;
      } else {
        $scope.order_type_asc = 1;
      }

      $scope.seekerPolicies($scope.order_type_asc);
    };

    $scope.seekerPolicies = function (order, status) {
      $scope.conteoEstatus = false;
      $scope.totalEstatus = 0;
      $scope.showContractors = false;
      $scope.showGroups = false;
      $scope.showProviders = false;
      $scope.showSinisters = false;
      $scope.showEndorsments = false;
      $scope.showCaratulas = false;
      $scope.showOT = false;
      $scope.showReceipts = false;
      $scope.showFianzas = false;
      if (order == 0) {
        if ($scope.showPolicies) {
          $scope.showPolicies = false;
        } else if ($scope.conteos.policies != 0) {
          $scope.showPolicies = true;
        }
      }
      $scope.url_go_pol = "seeker-policies/";
      $scope.url_go_subs = "seeker-policies-subramos/";
      $http({
        method: "GET",
        url: url.IP + $scope.url_go_pol,
        params: {
          cadena: cadena,
          asc: order ? order : 0,
          status: status,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              if (status && status != 0) {
                $scope.conteoSubramo = false;
                $scope.totalSubramo = 0;
                $scope.conteoEstatus = true;
                $scope.totalEstatus = request.data.count;
              } else {
                $scope.conteoEstatus = false;
              }
              dataFactory
                .get($scope.url_go_subs, { cadena: cadena })
                .then(function succes(response) {
                  $scope.subramos_result = response.data.results;
                });

              $scope.policies = request.data.results;
              $scope.config_policies = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              $scope.show_pag_policies = true;
              $scope.testPagination("policies", "config_policies");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.seekerCerts = function (order, status) {
      $scope.showContractors = false;
      $scope.showGroups = false;
      $scope.showProviders = false;
      $scope.showSinisters = false;
      $scope.showEndorsments = false;
      $scope.showCaratulas = false;
      $scope.showOT = false;
      $scope.showReceipts = false;
      $scope.showFianzas = false;
      $scope.showPolicies = false;
      if (order == 0) {
        if ($scope.showCerts) {
          $scope.showCerts = false;
        } else if ($scope.conteos.certificados != 0) {
          $scope.showCerts = true;
        }
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_c = 'v2/generics/seeker-certs/';
      $scope.url_go_c = "seeker-certs/";
      $http({
        method: "GET",
        url: url.IP + $scope.url_go_c,
        params: {
          cadena: cadena,
          asc: order ? order : 0,
          status: status,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              // dataFactory.get('seeker-policies-subramos/', {cadena: cadena})
              // .then(function succes(response) {
              //     $scope.subramos_result = response.data.results;
              // })

              $scope.policies = request.data.results;
              $scope.config_policies = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              $scope.show_pag_policies = true;
              $scope.testPagination("policies", "config_policies");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.searchReceipts = function () {
      $scope.showContractors = false;
      $scope.showGroups = false;
      $scope.showProviders = false;
      $scope.showSinisters = false;
      $scope.showEndorsments = false;
      $scope.showCaratulas = false;
      $scope.showOT = false;
      $scope.showPolicies = false;
      $scope.showFianzas = false;
      if ($scope.showReceipts) {
        $scope.showReceipts = false;
      } else if ($scope.conteos.recibos != 0) {
        $scope.showReceipts = true;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_rc = 'v2/generics/search-receipts/';
      $scope.url_go_rc = "search-receipts/";
      $http({
        method: "GET",
        url: url.IP + $scope.url_go_rc,
        params: {
          cadena: cadena,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              $scope.receipts = request.data.results;
              $scope.config_receipts = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              $scope.show_pag_receipts = true;
              $scope.testPagination("receipts", "config_receipts");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.seekerFianzas = function () {
      $scope.showContractors = false;
      $scope.showGroups = false;
      $scope.showProviders = false;
      $scope.showSinisters = false;
      $scope.showEndorsments = false;
      $scope.showCaratulas = false;
      $scope.showOT = false;
      $scope.showPolicies = false;
      $scope.showReceipts = false;
      if ($scope.showFianzas) {
        $scope.showFianzas = false;
      } else if ($scope.conteos.fianzas != 0) {
        $scope.showFianzas = true;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_fia = 'v2/generics/seeker-fianzas/';
      $scope.url_go_fia = "seeker-fianzas/";
      $http({
        method: "GET",
        url: url.IP + $scope.url_go_fia,
        params: {
          cadena: cadena,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              $scope.fianzas = request.data.results;
              $scope.config_fianzas = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              $scope.show_pag_fianzas = true;
              $scope.conteos.fianzas = request.data.count;
              $scope.testPaginationF("fianzas", "config_fianzas");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.editRecibo = function (receipt) {
      $scope.loaded = false;

      var recibos = [];
      var recibos_hijo = [];
      var endorsements = [];
      recibos_hijo.push(receipt);
      receiptService.getChildrenReceipts(receipt.id).then(function (recibos) {
        $http({
          method: "GET",
          url: url.IP + "cartas-by-model",
          params: {
            model: 4,
          },
        }).then(function success(response) {
          $scope.cartas = response.data;
        });

        try {
          recibos.forEach(function (recibo) {
            recibos_hijo.push(recibo);
          });
        } catch (err) {}
      });

      $scope.pago_recibo_actual = recibos_hijo;
      $scope.loaded = true;

      receipt.contratante = receipt.natural
        ? receipt.natural
        : receipt.juridical;
      // var index = vm.receipts.indexOf(receipt);
      var modalInstance = $uibModal.open({
        templateUrl: "app/cobranzas/cobranzas.modal.html",
        controller: "CobranzasModal",
        size: "lg",
        resolve: {
          receipt: function () {
            return receipt;
          },
          insurance: function () {
            return receipt.poliza;
          },
          from: function () {
            return null;
          },
          bono: function () {
            return null;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {});
    };

    $scope.searchOTs = function () {
      $scope.showContractors = false;
      $scope.showGroups = false;
      $scope.showProviders = false;
      $scope.showSinisters = false;
      $scope.showCaratulas = false;
      $scope.showPolicies = false;
      $scope.showEndorsments = false;
      $scope.showReceipts = false;
      $scope.showFianzas = false;
      if ($scope.showOT) {
        $scope.showOT = false;
      } else if ($scope.conteos.ots != 0) {
        $scope.showOT = true;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_oe = 'v2/generics/search-ot-endorsments/';
      $scope.url_go_oe = "search-ot-endorsments/";
      $http({
        method: "GET",
        url: url.IP + $scope.url_go_oe,
        params: {
          cadena: cadena,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              $scope.ot_historic = [];
              $scope.ots_endosos = request.data;
              $scope.ots_fianza = request.data.ots_fianza;
              if (request.data.historic) {
                $scope.ot_hist = request.data.historic;
                $scope.ot_hist.forEach(function (x) {
                  if (x.new_policy) {
                    if (x.new_policy.status == 1 || x.new_policy.status == 2) {
                      $scope.ot_historic.push(x.new_policy);
                    }
                  }
                });
              }
              // if (request.data.endosos_pol) {
              //   request.data.endosos_pol.forEach(function(c){
              //      $scope.ots_endosos.endosos.forEach(function(d){
              //       if (c.id == d.id) {
              //       }else{
              //         $scope.ots_endosos.endosos.push(c)
              //       }
              //      })
              //     // $scope.ots_endosos.endosos.push(c)
              //   });
              // }
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.searchCaratulas = function () {
      $scope.showContractors = false;
      $scope.showGroups = false;
      $scope.showProviders = false;
      $scope.showSinisters = false;
      $scope.showEndorsments = false;
      $scope.showPolicies = false;
      $scope.showOT = false;
      $scope.showReceipts = false;
      $scope.showFianzas = false;
      if ($scope.showCaratulas) {
        $scope.showCaratulas = false;
      } else if ($scope.conteos.colectividades != 0) {
        $scope.showCaratulas = true;
      }
      $http({
        method: "GET",
        url: url.IP + "search-caratulas/",
        params: {
          cadena: cadena,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              $scope.caratulas = request.data.results;
              $scope.config_caratulas = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              $scope.show_pag_caratulas = true;
              $scope.testPagination("caratulas", "config_caratulas");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.seekerGroups = function () {
      $scope.showContractors = false;
      $scope.showPolicies = false;
      $scope.showOT = false;
      $scope.showCaratulas = false;
      $scope.showProviders = false;
      $scope.showSinisters = false;
      $scope.showEndorsments = false;
      $scope.showReceipts = false;
      $scope.showFianzas = false;
      if ($scope.showGroups) {
        $scope.showGroups = false;
      } else if ($scope.conteos.groups != 0) {
        $scope.showGroups = true;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_gr = 'v2/generics/seeker-groups/';
      $scope.url_go_gr = "seeker-groups/";
      $http({
        method: "GET",
        url: url.IP + $scope.url_go_gr,
        params: {
          cadena: cadena,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              $scope.groups = request.data.results;
              $scope.groups_config = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              $scope.show_pag_groups = true;
              $scope.testPagination("groups", "groups_config");
            }

            // if(request.status === 200){
            //     $scope.groups = request.data.results;
            // }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.seekerProviders = function () {
      $scope.showContractors = false;
      $scope.showPolicies = false;
      $scope.showOT = false;
      $scope.showCaratulas = false;
      $scope.showGroups = false;
      $scope.showSinisters = false;
      $scope.showEndorsments = false;
      $scope.showReceipts = false;
      $scope.showFianzas = false;
      if ($scope.showProviders) {
        $scope.showProviders = false;
      } else if ($scope.conteos.providers != 0) {
        $scope.showProviders = true;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_aseg = 'v2/generics/seeker-provider/';
      $scope.url_go_aseg = "seeker-provider/";
      $http({
        method: "GET",
        url: url.IP + $scope.url_go_aseg,
        params: {
          cadena: cadena,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              $scope.providers = request.data.results;
              $scope.providers_config = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              $scope.show_pag_providers = true;
              $scope.testPagination("providers", "providers_config");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.seekerSinisters = function () {
      $scope.showContractors = false;
      $scope.showPolicies = false;
      $scope.showOT = false;
      $scope.showCaratulas = false;
      $scope.showGroups = false;
      $scope.showProviders = false;
      $scope.showEndorsments = false;
      $scope.showReceipts = false;
      $scope.showFianzas = false;
      if ($scope.showSinisters) {
        $scope.showSinisters = false;
      } else if ($scope.conteos.sinisters != 0) {
        $scope.showSinisters = true;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_sin = 'v2/generics/seeker-sinisters/';
      $scope.url_go_sin = "seeker-sinisters/";
      $http({
        method: "GET",
        url: url.IP + $scope.url_go_sin,
        params: {
          cadena: cadena,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              $scope.sinisters = request.data.results;
              $scope.siniesters_config = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              $scope.show_pag_sinisters = true;
              $scope.testPagination("sinisters", "siniesters_config");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.seekerEndorsments = function (order, asc) {
      $scope.showContractors = false;
      $scope.showPolicies = false;
      $scope.showOT = false;
      $scope.showCaratulas = false;
      $scope.showGroups = false;
      $scope.showProviders = false;
      $scope.showSinisters = false;
      $scope.showReceipts = false;
      $scope.showFianzas = false;
      if ($scope.showEndorsments) {
        $scope.showEndorsments = false;
      } else if ($scope.conteos.endorsments != 0) {
        $scope.showEndorsments = true;
      }
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   $scope.url_go_end = 'v2/generics/search-endorsments/';
      $scope.url_go_end = "search-endorsments/";
      $http({
        method: "GET",
        url: url.IP + $scope.url_go_end,
        params: {
          cadena: cadena,
          order: order ? order : 1,
          asc: asc ? asc : 1,
        },
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              $scope.endorsments = request.data.results;
              $scope.endorsments_config = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              $scope.show_pag_endorsments = true;
              $scope.testPagination("endorsments", "endorsments_config");
            }
          },
          function error(error) {}
        )
        .catch(function (e) {
          console.log(e);
        });
    };

    $scope.changeEndosos = function (par, asc) {
      $scope.showEndorsments = true;
      switch (par) {
        case 1:
          $scope.seekerEndorsments(par, asc);
          $scope.end_num = asc;
          $scope.end_tipo = 0;
          $scope.end_nump = 0;
          $scope.end_form = 0;
          $scope.end_status = 0;
          break;
        case 2:
          $scope.seekerEndorsments(par, asc);
          $scope.end_num = 0;
          $scope.end_tipo = asc;
          $scope.end_nump = 0;
          $scope.end_form = 0;
          $scope.end_status = 0;
          break;
        case 3:
          $scope.seekerEndorsments(par, asc);
          $scope.end_num = 0;
          $scope.end_tipo = 0;
          $scope.end_nump = asc;
          $scope.end_form = 0;
          $scope.end_status = 0;
          break;
        case 4:
          $scope.seekerEndorsments(par, asc);
          $scope.end_num = 0;
          $scope.end_tipo = 0;
          $scope.end_nump = 0;
          $scope.end_form = asc;
          $scope.end_status = 0;
          break;
        case 5:
          $scope.seekerEndorsments(par, asc);
          $scope.end_num = 0;
          $scope.end_tipo = 0;
          $scope.end_nump = 0;
          $scope.end_form = 0;
          $scope.end_status = asc;
          break;
        default:
          $scope.seekerEndorsments(par, asc);
          break;
      }
    };

    $scope.goToContractorView = function (person) {
      $scope.open_in_same_tab(
        "Información Contratante",
        "contratantes.info",
        {
          type: checkType(person.type_person),
          contratanteId: person.id,
        },
        person.id,
        person.type_person
      );
      // $state.go('contratantes.info', {
      //     type: checkType(person.type_person),
      //     contratanteId: person.id
      // });
    };

    $scope.goToGroups = function (group) {
      $scope.open_in_same_tab(
        "Información Grupo",
        "grupos.info",
        { grupoId: group.id },
        group.id,
        null
      );
      // ui-sref="grupos.info({grupoId: group.id})
    };

    $scope.goToProvider = function (prov) {
      $scope.open_in_same_tab(
        "Información Aseg.",
        "aseguradoras.edit",
        { aseguradoraId: prov.id },
        prov.id,
        null
      );
      // ui-sref="aseguradoras.edit({aseguradoraId: prov.id})"
    };

    function checkType(type) {
      //jshint ignore:line
      return type === "Física" ? "fisicas" : "morales";
    }

    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);

        $scope.actual_page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&status=") !== -1) {
              var status = prev_.substring(prev_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }
        getProviders(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
      $scope.formatDate = function (date) {
        return date.replace("Z", "");
      };

      function getProviders(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    $scope.testPaginationF = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPagesF = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_pageF = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesF.push(i + 1);
      }

      $scope.lastPageF = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesF.length > 5) {
          $scope.end = $scope.totalPagesF.length;
          $scope.start = $scope.totalPagesF.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPageF($scope.totalPagesF.length);

        $scope.actual_pageF = $scope.totalPagesF.length;
      };

      $scope.selectPageF = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&status=") !== -1) {
              var status = prev_.substring(prev_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }
        getFianzas(url);
        $scope.actual_pageF = parPage;
        if ($scope.actual_pageF > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_pageF == $scope.totalPagesF.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPagesF = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_pageF) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesF.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesF = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_pageF) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesF.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesF.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getFianzas(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    $scope.testPaginationJ = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);

      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPagesJ = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_pageJ = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPagesJ.push(i + 1);
      }

      $scope.lastPage = function () {
        // TODO: ultimo bloque
        if ($scope.totalPagesJ.length > 5) {
          $scope.end = $scope.totalPagesJ.length;
          $scope.start = $scope.totalPagesJ.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPagesJ.length);

        $scope.actual_pageJ = $scope.totalPagesJ.length;
      };

      $scope.selectPageJ = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&status=") !== -1) {
              var status = prev_.substring(prev_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          }
        }
        getProvidersJ(url);
        $scope.actual_pageJ = parPage;
        if ($scope.actual_pageJ > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_pageJ == $scope.totalPagesJ.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPagesJ = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_pageJ) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPagesJ.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPagesJ = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_pageJ) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPagesJ.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPagesJ.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getProvidersJ(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("BlockCtrl", BlockCtrl);

  BlockCtrl.$inject = [
    "$scope",
    "$state",
    "$localStorage",
    "$sessionStorage",
    "url",
    "$http",
    "Idle",
    "URLS_CONFIG",
    "$location",
  ];

  function BlockCtrl(
    $scope,
    $state,
    $localStorage,
    $sessionStorage,
    url,
    $http,
    Idle,
    URLS_CONFIG,
    $location
  ) {
    $scope.avatar = $localStorage.avatar;
    $scope.info = JSON.parse($localStorage.loginInfo);
    // $scope.count_time = count_time;

    Idle.unwatch();
    count_time();
    // -------------//-------
    function count_time() {
      $state.go("login.login");
    }
    // ----------------------//-------

    $scope.unlock = function (parPassword) {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);

      // var hostUrl = 'https://cas.miurabox.com/';
      // var hostUrl = 'http://localhost:9000/';
      var hostUrl = URLS_CONFIG.cas;

      $http({
        method: "POST",
        url: hostUrl + "us-login",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/x-www-form-urlencoded",
        },
        data:
          "username=" +
          encodeURIComponent(usr.name) +
          "&password=" +
          encodeURIComponent(parPassword) +
          "&org=" +
          encodeURIComponent(usr.org),
      })
        .then(
          function success(request) {
            if (request.status === 200) {
              if ($sessionStorage.actualPage !== "/block-page") {
                $location.path($sessionStorage.actualPage);
              } else {
                $state.go("index.main");
              }

              Idle.watch();
            } else {
              $scope.error_message = "Contraseña invalida, intente nuevamente.";
              $scope.password = "";
            }
          },
          function error(error) {
            $scope.error_message = "Contraseña invalida, intente nuevamente.";
            $scope.password = "";
          }
        )
        .catch(function (e) {
          console.log("e", e);
          $scope.error_message = "Contraseña invalida, intente nuevamente.";
          $scope.password = "";
        });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("EditablesCtrl", EditablesCtrl);

  EditablesCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "FileUploader",
    "url",
    "SweetAlert",
    "dataFactory",
    "MESSAGES",
    "$parse",
    "providerService",
  ];

  function EditablesCtrl(
    $sessionStorage,
    $scope,
    $http,
    FileUploader,
    url,
    SweetAlert,
    dataFactory,
    MESSAGES,
    $parse,
    providerService
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = true;

    //vm.deleteFile = deleteFile;

    /* Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });

    activate();

    function activate() {
      check = true;
      dataFactory.get("archivos/editables/").then(function success(response) {
        vm.files = response.data.results;
        vm.files = response.data.results;
        $scope.config_pagination = response.data;
        $scope.show_pag_editables = true;
        // if($scope.files) {
        //   $scope.archivosBD = [];
        //   $scope.archivosBD = response.data.results;
        //   $scope.archBD = {};
        //   $scope.archBD = {
        //       count: response.data.count,
        //       previous: response.data.previous,
        //       next: response.data.next
        //     };
        //   if($scope.archivosBD){
        //     $scope.show_pag_editables = true;
        //   }else{
        //     $scope.show_pag_editables = false;
        //   }
        //   // testPagination('archivosBD', 'archBD');
        // }
        $scope.getProvider();
      });
    }

    $scope.getProvider = function () {
      var d = new Date();
      try {
        var curr_date = d.getDate();
        var curr_month = d.getMonth() + 1; //Months are zero based
        var curr_year = d.getFullYear();
      } catch (error) {
        var from = d.split("/");
        var f = new Date(from[2], from[1] - 1, from[0]);
        var curr_date = f.getDate();
        var curr_month = f.getMonth() + 1; //Months are zero based
        var curr_year = f.getFullYear();
      }

      var date = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(date).then(
        function success(data) {
          $scope.providers = data.data;
        },
        function error(err) {
          console.log("error", err);
        }
      );
    };

    $scope.aseguradoraSelection = function () {
      $http
        .get(url.IP + "ramos-by-provider/" + $scope.aseguradoraEditables.id)
        .then(
          function success(response) {
            $scope.ramos = response.data;
          },
          function error(e) {
            console.log("Error - ramos-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - ramos-by-provider - catch", error);
        });
    };

    $scope.changeRamo = function () {
      $scope.subramos = $scope.ramoEditables.subramo_ramo;
    };

    $scope.format = function (it) {
      check = this.item.is_format;
    };

    $scope.uploadFiles = function () {
      // var l = Ladda.create( document.querySelector( '.ladda-button' ) );
      // l.start();
      var asgId = null;
      var rmId = null;
      var srmId = null;
      if ($scope.aseguradoraEditables && $scope.aseguradoraEditables.id) {
        asgId = $scope.aseguradoraEditables.id;
      } else {
        SweetAlert.swal("Error", "Seleccione una aseguradora", "error");
        return;
      }
      if ($scope.ramoEditables && $scope.ramoEditables.id) {
        rmId = $scope.ramoEditables.id;
      } else {
        SweetAlert.swal("Error", "Seleccione un ramo", "error");
        return;
      }
      if ($scope.subramoEditables && $scope.subramoEditables.id) {
        srmId = $scope.subramoEditables.id;
      } else {
        SweetAlert.swal("Error", "Seleccione un subramo", "error");
        return;
      }
      $scope.userInfo.url = $scope.uploader.url =
        url.IP +
        "archivos/editables/?org=" +
        usr.urlname +
        "&aseguradora=" +
        asgId +
        "&ramo=" +
        rmId +
        "&subramo=" +
        srmId;
      $scope.uploader.uploadAll();
    };

    /* Alerta success uploadfiles */
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        SweetAlert.swal("Hecho", "Formato cargado", "success");
        activate();
        uploader.queue = [];
      }
      check = true;
    };

    /* Alerta error uploadfiles */
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal(
        "ERROR",
        MESSAGES.ERROR.ERRORONUPLOADFILES +
          "\n Seleccione aseguradora, ramo, subramo",
        "error"
      );
      return;
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
        is_format: true,
      });
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.is_format = true;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
      item.formData[0].is_format = check;
    };

    $scope.deleteFile = function (file, container) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este archivo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http
              .delete(url.IP + "archivos/editables/?org=" + usr.urlname, {
                params: { file_id: file.id },
              })
              .then(function (response) {
                container.splice(container.indexOf(file), 1);
                SweetAlert.swal(
                  "¡Eliminado!",
                  "El archivo fue eliminado.",
                  "success"
                );
              });
          }
        }
      );
    };

    $scope.editFile = function (file, nombre) {
      $http
        .put(url.IP + "archivos/editables/?org=" + usr.urlname, {
          params: { file_id: file.id, file: file },
        })
        .then(function (response) {});
    };
    // -----------PAGINACIÓN
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      // $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }

      $scope.lastPageP = function () {
        // TODO: ultimo bloque
        if ($scope.totalPages.length > 5) {
          $scope.end = $scope.totalPages.length;
          $scope.start = $scope.totalPages.length - 5;
          $scope.show_prev_block = true;
        }
        $scope.selectPage($scope.totalPages.length);
        // $scope.actual_page = $scope.totalPages.length;
        // $scope.page = $scope.totalPages.length;
      };

      $scope.selectPage = function (parPage) {
        $scope.actual_page = parPage;

        activate($scope.param_a, $scope.order, $scope.asc, parPage);
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("CartasListCtrl", CartasListCtrl);

  CartasListCtrl.$inject = [
    "$scope",
    "FileUploader",
    "$sessionStorage",
    "$http",
    "url",
    "$state",
    "SweetAlert",
  ];

  function CartasListCtrl(
    $scope,
    FileUploader,
    $sessionStorage,
    $http,
    url,
    $state,
    SweetAlert
  ) {
    var vm = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    $scope.letters = [];
    $scope.next = null;
    $scope.previous = null;

    activate();

    function activate() {
      $http({
        method: "GET",
        url: url.IP + "cartas",
      }).then(function success(response) {
        $scope.letters = response.data.results;
        $scope.campaigns = response.data.results;
        $scope.previous = response.data.previous;
        $scope.next = response.data.next;
      });
    }

    $scope.editLetter = function (letter) {
      var params = { myInsurance: letter };
      $state.go("bibliotecas.edit", params);
    };

    $scope.deleteLetter = function (letter, index, container) {
      SweetAlert.swal(
        {
          title: "Eliminar Carta",
          text: "¿Está seguro de eliminar esta carta?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            $http.delete(letter.url).then(function success(response) {
              if (response.status == 204) {
                SweetAlert.swal(
                  "¡Listo!",
                  "El la carta ha sido eliminada",
                  "success"
                );
                container.splice(container.indexOf(letter), 1);
              } else if (response.status == 403) {
                SweetAlert.swal("¡Cancelado!", response.data.detail, "error");
                return;
              }
            });
          } else {
            SweetAlert.swal(
              "¡Cancelado!",
              "La carta no fue eliminada",
              "error"
            );
            return;
          }
        }
      );
    };

    $scope.goTo = function (url) {
      $scope.letters = [];
      $http({
        method: "GET",
        url: url,
      }).then(function success(response) {
        $scope.letters = response.data.results;
        $scope.campaigns = response.data.results;
        $scope.previous = response.data.previous;
        $scope.next = response.data.next;
      });
    };
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("BibliotecasCtrl", BibliotecasCtrl);

  BibliotecasCtrl.$inject = [
    "$scope",
    "FileUploader",
    "$timeout",
    "toaster",
    "MESSAGES",
    "$sessionStorage",
    "$http",
    "url",
    "$state",
    "SweetAlert",
    "$stateParams",
  ];

  function BibliotecasCtrl(
    $scope,
    FileUploader,
    $timeout,
    toaster,
    MESSAGES,
    $sessionStorage,
    $http,
    url,
    $state,
    SweetAlert,
    $stateParams
  ) {
    var vm = this;

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);

    $scope.letter = {
      name: "",
      title: "",
      text: "",
      model: "",
    };

    $scope.bell = 1;
    $scope.showFiles = false;

    if ($stateParams.myInsurance != "some default") {
      $scope.letter = $stateParams.myInsurance;

      $http
        .get(url.IP + "cartas/" + $scope.letter.id + "/archivos")
        .then(function succcess(response) {
          if (response.data.results.length) {
            $scope.imgLetter = response.data.results[0].arch;
          }
        });
    }

    $scope.showContainerFiles = function (value) {
      $scope.bell = value;
      if (value == 1) {
        $scope.showFiles = false;
      } else {
        $scope.showFiles = true;
        SweetAlert.swal("Imagen", MESSAGES.INFO.INFOBANNER, "info");
      }
    };

    $scope.save = function () {
      $http({
        method: "POST",
        url: url.IP + "cartas/",
        data: $scope.letter,
      }).then(function success(response) {
        if (response.status == 201) {
          if ($scope.bell == 1) {
            $state.go("bibliotecas.list");
          } else {
            uploadFiles(response.data.id, true);
            $state.go("bibliotecas.list");
          }
        }
      });
    };

    $scope.update = function () {
      $http({
        method: "PATCH",
        url: $scope.letter.url,
        data: $scope.letter,
      }).then(function success(response) {
        if (response.status == 200) {
          if ($scope.bell == 1) {
            $state.go("bibliotecas.list");
          } else {
            uploadFiles(response.data.id, true);
            $state.go("bibliotecas.list");
          }
        }
      });
    };

    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //   name: 'customFilter',
    //   fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //     return this.queue.length < 20;
    //   }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      toaster.success(MESSAGES.OK.UPLOADFILES);
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });
    };

    uploader.onBeforeUploadItem = function (item) {
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };

    vm.uploadFiles = uploadFiles;
    function uploadFiles(letterId, activate) {
      $scope.userInfo = {
        id: letterId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "cartas/" + letterId + "/archivos/?active=" + activate;
      $scope.files = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }

    //-- Peticion de persistencia--//

    var json_data = {};
    var form = document.getElementsByTagName("form");
    var elementos = {};
    //Valores reutilizables
    var interval, valor;

    function set_dataForm(json) {
      //Validar radios
      if (json["letter.model"] != "" && json["letter.model"] != undefined) {
        valor = angular.element(
          '[ng-model="letter.model"]',
          '[value="' + json["letter.model"] + '"]'
        );
        valor.prevObject[0].checked = true;
        valor.prevObject[0].setAttribute("aria-checked", "true");
      }

      if (json["letter.name"] != "") {
        $scope.letter.name = json["letter.name"];
      }
      if (json["letter.text"] != "") {
        $scope.letter.text = json["letter.text"];
      }
      if (json["letter.title"] != "") {
        $scope.letter.title = json["letter.title"];
      }
      if (json["letter.model"] != "") {
        $scope.letter.model = json["letter.model"];
      }

      // Validar Botones
      if (
        json["letter.name"] != "" &&
        json["letter.text"] != "" &&
        json["letter.title"] != "" &&
        json["letter.bell"] != "" &&
        json["letter.model"] != "" &&
        json["letter.model"] != undefined
      ) {
        // PersistenceFactory.val_botons('letterForm.$invalid')
      }
    }

    // interval = setInterval(function(){
    //   if(form != undefined && PersistenceFactory.count == 0){//&& PersistenceFactory.count == 0
    //     PersistenceFactory.inicial(usr.org,'Carta',usr.nameFull,PersistenceFactory.get_dataForm(form));
    //   }
    //   if(PersistenceFactory.init_return != ''){
    //     clearInterval(interval);
    //     if(PersistenceFactory.init_return.status == 'data_view' ){
    //       set_dataForm(PersistenceFactory.json_return);
    //     }
    //     PersistenceFactory.interval = setInterval(function(){
    //       PersistenceFactory.editado(PersistenceFactory.get_dataForm(form));
    //     }, PersistenceFactory.intervalTime);/* */
    //   }
    // }, 2000);
    //-- End Peticion de persistencia--//
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("SendPDFModalCtrl", SendPDFModalCtrl);

  SendPDFModalCtrl.$inject = [
    "$uibModalInstance",
    "providerService",
    "provider",
    "$scope",
    "dataFactory",
    "SweetAlert",
    "MESSAGES",
    "typeOT",
    "$sessionStorage",
    "FileUploader",
    "$http",
    "url",
  ];

  function SendPDFModalCtrl(
    $uibModalInstance,
    providerService,
    provider,
    $scope,
    dataFactory,
    SweetAlert,
    MESSAGES,
    typeOT,
    $sessionStorage,
    FileUploader,
    $http,
    url
  ) {
    $scope.vm = this;
    $scope.cc = false;
    $scope.vm.email = [];
    $scope.typeOT = typeOT;
    $scope.plantillas = [];
    activate();

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    $scope.vm.subjectEmail = "";
    $scope.vm.messageEmail = "";
    function activate() {
      if (provider.policy) {
        var provider_id = provider.policy.aseguradora.id;
        $scope.provider_id = provider.policy.aseguradora.id;
        $scope.idPoliza = provider.policy.id;
        $scope.policyId = provider.policy.id;
      } else if (provider.aseguradora) {
        var provider_id = provider.aseguradora.id;
        $scope.provider_id = provider.aseguradora.id;
        $scope.idPoliza = provider.id;
        $scope.policyId = provider.aseguradora ? provider.aseguradora.id : 0;
      }
      providerService
        .getEmailContacts(provider_id)
        .then(function success(response) {
          $scope.vm.contacts = response.data.results;
        });
      loadEndosoTemplates();
    }

    $scope.flagMethod = function () {
      if ($scope.cc) {
        $scope.cc = false;
      } else {
        $scope.cc = true;
      }
    };

    $scope.custom_email = "";
    $scope.sendEmail = function (
      parEmail,
      files,
      first_comment,
      second_comment
    ) {
      if (
        $scope.vm.subjectEmail &&
        ($scope.vm.messageEmail || $scope.vm.first_comment)
      ) {
        $scope.sendEmail_OK(parEmail, files, first_comment, second_comment);
      } else {
        SweetAlert.swal(
          "Error",
          "Asegurese de agregar el Asunto y Mensaje",
          "error"
        );
      }
    };
    $scope.sendEmail_OK = function (
      parEmail,
      files,
      first_comment,
      second_comment
    ) {
      if (typeOT == 1) {
        var parUrl = "get-pdf-ot/";
        var data = { id: provider.id };
        // return
        dataFactory
          .post("send-to-provider/", {
            pdf: "ot",
            id: data.id,
            email: parEmail.email ? [parEmail.email] : [parEmail],
            files: share_via_email,
            asunto: $scope.vm.subjectEmail,
            mensaje: $scope.vm.messageEmail,
            custom_email: $scope.custom_email,
            first_comment: $scope.vm.first_comment,
            second_comment: $scope.vm.second_comment,
          })
          .then(function success(resend) {
            if (resend.status == 200) {
              SweetAlert.swal("¡Listo!", MESSAGES.OK.SENDPROVIDER, "success");
              $scope.cancel();
            } else {
              SweetAlert.swal(
                "Error",
                "No se ha podido enviar a la compañia",
                "error"
              );
            }
          });
      } else if (typeOT == 2) {
        var parUrl = "get-pdf-endosos-new/";
        if (provider.policy) {
          var data = {
            poliza: provider.policy.id,
            endoso: provider.id,
            pdf: "ot",
            id: provider.policy.id,
            email: parEmail.email ? [parEmail.email] : [parEmail],
            files: share_via_email,
            asunto: $scope.vm.subjectEmail,
            mensaje: $scope.vm.messageEmail,
            custom_email: $scope.custom_email,
            first_comment: $scope.vm.first_comment,
            second_comment: $scope.vm.second_comment,
          };
        }
        if (provider.fianza) {
          var data = {
            poliza: provider.fianza.id,
            endoso: provider.id,
            pdf: "ot",
            id: provider.fianza.id,
            email: parEmail.email ? [parEmail.email] : [parEmail],
            files: share_via_email,
            asunto: $scope.vm.subjectEmail,
            mensaje: $scope.vm.messageEmail,
            custom_email: $scope.custom_email,
            first_comment: $scope.vm.first_comment,
            second_comment: $scope.vm.second_comment,
          };
        }

        dataFactory
          .post("send-to-provider/", data)
          .then(function success(resend) {
            if (resend.status == 200) {
              SweetAlert.swal("¡Listo!", MESSAGES.OK.SENDPROVIDER, "success");
              $scope.cancel();
            } else {
              SweetAlert.swal(
                "Error",
                "No se ha podido enviar a la compañia",
                "error"
              );
            }
          });
      }
    };
    $scope.adjFilesOK = function (val) {
      $scope.adjFiles = val;
      if (typeOT == 1) {
        $http
          .get(url.IP + "polizas/" + $scope.idPoliza + "/archivos/")
          .then(function (response) {
            if (response.status === 200) {
              $scope.vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.files.forEach(function (file) {
                file["to_send"] = false;
              });
              $scope.show_files_policy = true;
            }
          });
      }
      if (typeOT == 2) {
        $scope.idPoliza = provider.id;
        $http
          .get(url.IP + "endosos/" + $scope.idPoliza + "/archivos/")
          .then(function (response) {
            if (response.status === 200) {
              $scope.vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.files.forEach(function (file) {
                file["to_send"] = false;
              });
              $scope.show_files_policy = true;
            }
          });
      }
    };
    // ---------------

    var share_via_email = [];
    function loadEndosoTemplates() {
      dataFactory
        .get("emailtemplate/", { template_model: 6 })
        .then(function success(response) {
          $scope.plantillas = response ? response.data.results : [];
        })
        .catch(function (err) {
          console.log("error loading templates", err);
        });
    }
    $scope.changePlantilla = function (item) {
      if (!item) {
        return;
      }
      $scope.vm.subjectEmail = item.title || $scope.vm.subjectEmail;
      $scope.vm.first_comment = item.text || "";
      if ($scope.vm.first_comment && $scope.vm.first_comment.includes("\n")) {
        $scope.vm.first_comment = $scope.vm.first_comment.replace(
          /\n/g,
          "<br><br>"
        );
      }
      $scope.vm.second_comment = item.bottom_text || "";
      $scope.custom_email = true;
    };
    $scope.getTemplate = function (custom_email) {
      if (!custom_email) {
        $scope.vm.first_comment = "";
        $scope.vm.second_comment = "";
      }
    };
    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    /** Uploader files **/
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: { Authorization: "Bearer " + token, Accept: "application/json" },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item, options) {
    //         return this.queue.length < 20;
    //     }
    // });
    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
      });

      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };
    $scope.vm.uploadFiles = uploadFiles;
    function uploadFiles(polizaId) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.userInfo = {
        id: polizaId,
      };
      $scope.uploadOk = false;
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      $scope.uploader.queue.forEach(function (ch, index) {
        var str = ch.file.name;
        var regex = /[^\w\s]/gi;
        for (i = 0; i < specialChars.length; i++) {
          if (str.indexOf(specialChars[i]) > -1) {
            $scope.uploadOk = true;
            SweetAlert.swal(
              "Error",
              "El nombre de archivo: " +
                str +
                ", contiene carácteres especiales, renombre y, vuelva a cargarlo. " +
                specialChars[i],
              "error"
            );
            $scope.uploader.queue.splice($scope.uploader.queue.indexOf(ch), 1);
            return;
          } else {
            $scope.uploadOk = true;
          }
        }
      });
      if ($scope.uploadOk) {
        if (typeOT == 1) {
          $scope.userInfo.url = $scope.uploader.url =
            url.IP + "polizas/" + $scope.idPoliza + "/archivos/";
        }
        if (typeOT == 2) {
          $scope.userInfo.url = $scope.uploader.url =
            url.IP + "endosos/" + $scope.idPoliza + "/archivos/";
        }
        $scope.files = [];
      }

      $timeout(function () {
        $scope.uploader.uploadAll();
      }, 1000);
    }
    $scope.noFiles = false;
    $scope.saveFiles = function (id) {
      $scope.id_recibo = $scope.idPoliza;
      $scope.userInfo.id = $scope.idPoliza;
      $scope.uploadOk = false;
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      $scope.uploader.queue.forEach(function (ch, index) {
        var str = ch.file.name;
        var regex = /[^\w\s]/gi;
        for (i = 0; i < specialChars.length; i++) {
          if (str.indexOf(specialChars[i]) > -1) {
            $scope.uploadOk = true;
            SweetAlert.swal(
              "Error",
              "El nombre de archivo: " +
                str +
                ", contiene carácteres especiales, renombre y, vuelva a cargarlo. " +
                specialChars[i],
              "error"
            );
            $scope.uploader.queue.splice($scope.uploader.queue.indexOf(ch), 1);
            return;
          } else {
            $scope.uploadOk = true;
          }
        }
      });
      if ($scope.uploadOk) {
        if (typeOT == 1) {
          $scope.userInfo.url = $scope.uploader.url =
            url.IP + "polizas/" + $scope.idPoliza + "/archivos/";
        }
        if (typeOT == 2) {
          $scope.userInfo.url = $scope.uploader.url =
            url.IP + "endosos/" + $scope.idPoliza + "/archivos/";
        }
        $scope.uploader.uploadAll();
      }
      if (typeOT == 1) {
        $http
          .get(url.IP + "polizas/" + $scope.idPoliza + "/archivos/")
          .then(function (response) {
            if (response.status === 200) {
              $scope.vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.files.forEach(function (file) {
                file["to_send"] = false;
              });
              $scope.noFiles = true;
            }
          });
      }
      if (typeOT == 2) {
        $http
          .get(url.IP + "endosos/" + $scope.idPoliza + "/archivos/")
          .then(function (response) {
            if (response.status === 200) {
              $scope.vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.files.forEach(function (file) {
                file["to_send"] = false;
              });
              $scope.noFiles = true;
            }
          });
      }
    };
    $scope.shareFileEmail = function (file) {
      if (file.to_send) {
        file.to_send = false;
      } else {
        file.to_send = true;
      }
      share_via_email = [];
      $scope.files.forEach(function (filex) {
        if (filex.to_send) {
          share_via_email.push(filex.id);
        }
      });
    };
    // ***********************+
    $scope.cancel = function () {
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular
    .module("inspinia")
    .controller("AseguradorasSubramoCtrl", AseguradorasSubramoCtrl);

  AseguradorasSubramoCtrl.$inject = [
    "$state",
    "$stateParams",
    "$uibModal",
    "providerService",
    "ramoService",
    "contactService",
    "toaster",
  ];

  function AseguradorasSubramoCtrl(
    $state,
    $stateParams,
    $uibModal,
    providerService,
    ramoService,
    contactService,
    toaster
  ) {
    var vm = this;
    // vm.openModal = openModal;
    vm.cancel = cancel;
    vm.submit = submit;
    // vm.provider = {};
    vm.ramo = {};
    vm.subramos = [];
    vm.form = {
      subramo_name: "Subramo 1",
      subramo_code: "123",
    };
    //
    // // //Contacts
    // // vm.deleteContacts = deleteContacts;
    // // vm.addContact = addContact;
    //
    activate();

    function activate() {
      ramoService.getRamo($stateParams).then(function (ramo) {
        vm.ramo = ramo;
        vm.subramos = ramo.subramo_ramo;
      });
    }
    //
    // function openModal(){
    //     var modalInstance = $uibModal.open({ //jshint ignore:line
    //         templateUrl: 'templates/delete.html',
    //         controller: ModalInstanceCtrl,
    //         //windowClass: 'animated fadeIn'
    //     });
    // }
    //
    // function ModalInstanceCtrl ($scope, $uibModalInstance) {
    //     $scope.name = 'proveedor';
    //     $scope.ok = function () {
    //         return providerService.deleteProvider($stateParams.aseguradoraId)
    //             .then(function(){
    //                 $uibModalInstance.close();
    //                 $state.go('aseguradoras.aseguradoras');
    //             });
    //     };
    //
    //     $scope.cancel = function () {
    //         $uibModalInstance.dismiss('cancel');
    //     };
    // }
    //
    function submit() {
      var form = angular.copy(vm.form);
      form.ramo = vm.ramo.url;

      // form.provider = vm.provider.url;
      return ramoService.createSubramo(form).then(function (data) {
        toaster.success("Se ha agregado un nuevo ramo");
        vm.subramos.push(data);
      });
    }

    function cancel() {
      vm.form = {
        subramo_name: "",
        subramo_code: "",
      };
    }
    //
    // // Contacts
    // function deleteContacts(url, index){
    //     return contactService.deleteContact(url)
    //         .then(function(){
    //             vm.form.contact_provider.splice(index, 1); //jshint ignore:line
    //             toaster.error('Se ha borrado un contacto');
    //         });
    // }
    //
    //
    // function addContact(){
    //     var contact = {name: 'demo', phone_number: '811', email: 'fer@gmail.com'} //jshint ignore:line
    //     vm.form.contact_provider.push(contact); //jshint ignore:line
    // }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").factory("providerService", providerService);

  providerService.$inject = ["url", "$http", "$localStorage"];

  function providerService(url, $http, $localStorage) {
    var infoUser = $localStorage.infoUser;
    var service = {
      createProvider: createProvider,
      getProviders: getProviders,
      getProvidersFi: getProvidersFi,
      getProvider: getProvider,
      getProviderByUri: getProviderByUri,
      updateProvider: updateProvider,
      deleteProvider: deleteProvider,
      getReadProviders: getReadProviders,
      getReadListProviders: getReadListProviders,
      getReadListTableProviders: getReadListTableProviders,
      getProviderById: getProviderById,
      getProviderFull: getProviderFull,
      getProviderByKey: getProviderByKey,
      getAfianzadoraPoviderByKey: getAfianzadoraPoviderByKey,
      getProviderFiByKey: getProviderFiByKey,
      getEmailContacts: getEmailContacts,
      getClaves: getClaves,
    };

    return service;

    ////////////

    // CREATE
    function createProvider(data) {
      return $http
        .post(url.IP + "proveedores/", data)
        .then(createProviderComplete)
        .catch(createProviderFailed);

      function createProviderComplete(response) {
        return response.data;
      }

      function createProviderFailed(error) {
        return error;
      }
    }

    function getProviderByKey(data) {
      var test = { start_date: data };
      infoUser = $localStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //     var show_group = 'v2/aseguradoras/get-aseguradoras-clave/';
      var show_group = "get-aseguradoras-clave/";
      return $http.get(url.IP + show_group + "?date=" + data + "&");
    }

    function getAfianzadoraPoviderByKey(data, type) {
      var test = { start_date: data };
      type = type ? type : 0;
      infoUser = $localStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //     var show_group = 'v2/aseguradoras/get-aseguradoras-clave/';
      var show_group = "get-provider-clave/";
      return $http.get(
        url.IP + show_group + "?date=" + data + "&" + "type=" + type + "&"
      );
    }

    function getProviderFiByKey(data) {
      var test = { start_date: data };
      infoUser = $localStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //   var show_provider = 'v2/fianzas/get-afianzadoras-clave';
      var show_provider = "get-afianzadoras-clave";

      return $http.get(url.IP + show_provider + "?date=" + data + "&");
    }

    //   READ
    function getProviders() {
      return $http
        .get(url.IP + "proveedores/")
        .then(getProvidersComplete)
        .catch(getProvidersFailed);

      function getProvidersComplete(response) {
        return response.data.results;
      }

      function getProvidersFailed(error) {
        return error;
      }
    }

    function getProvidersFi() {
      infoUser = $localStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //     var show_provider_list = 'v2/fianzas/afianzadoras';
      var show_provider_list = "afianzadoras";
      return $http
        .get(url.IP + show_provider_list)
        .then(getProvidersComplete)
        .catch(getProvidersFailed);

      function getProvidersComplete(response) {
        return response.data.results;
      }

      function getProvidersFailed(error) {
        return error;
      }
    }

    function getReadProviders() {
      return $http
        .get(url.IP + "proveedores-resume/")
        .then(getProvidersComplete)
        .catch(getProvidersFailed);

      function getProvidersComplete(response) {
        return response.data.results;
      }

      function getProvidersFailed(error) {
        return error;
      }
    }

    // Alimenta el dropdown
    function getReadListProviders() {
      infoUser = $localStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //     var show_provider = 'v2/aseguradoras/proveedores-resume-list/';
      var show_provider = "proveedores-resume-list/";

      return $http
        .get(url.IP + show_provider)
        .then(getProvidersComplete)
        .catch(getProvidersFailed);

      function getProvidersComplete(response) {
        return response.data;
        // return response.data.results;
        // var results = {
        //   data: response.data,
        //   config: {
        //     count: response.data.count,
        //     next: response.data.next,
        //     previous: response.data.previous
        //   }
        // };

        // return results;
      }

      function getProvidersFailed(error) {
        return error;
      }
    }

    // alimentar la tabla con este endpoint
    function getReadListTableProviders() {
      infoUser = $localStorage.infoUser;
      // if(infoUser.staff && !infoUser.superuser){
      //     var show_provider_all = 'v2/aseguradoras/proveedores-table-resume/';
      var show_provider_all = "proveedores-table-resume/";
      return $http
        .get(url.IP + show_provider_all)
        .then(getProvidersComplete)
        .catch(getProvidersFailed);

      function getProvidersComplete(response) {
        // return response.data;
        // return response.data.results;
        var results = {
          data: response.data,
          config: {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          },
        };

        return results;
      }

      function getProvidersFailed(error) {
        return error;
      }
    }

    function getProviderByUri(uri) {
      return $http.get(uri).then(getProviderComplete).catch(getProviderFailed);

      function getProviderComplete(response) {
        return response;
      }

      function getProviderFailed(error) {
        return error;
      }
    }

    function getProviderById(id) {
      return $http
        .get(url.IP + "proveedores-info/" + id)
        .then(getProviderComplete)
        .catch(getProviderFailed);

      function getProviderComplete(response) {
        return response;
      }

      function getProviderFailed(error) {
        return error;
      }
    }

    function getClaves(data) {
      return $http
        .get(url.IP + "claves-resume/")
        .then(getClavesComplete)
        .catch(getClavesFailed);

      function getClavesComplete(response) {
        return response.data;
      }

      function getClavesFailed(error) {
        return error;
      }
    }

    function getProviderFull(data) {
      if (!isNaN(Number(data.aseguradoraId))) {
        data.aseguradoraId = url.IP + "proveedores/" + data.aseguradoraId + "/";
      } else if (data.provider) {
        data.aseguradoraId = data.provider;
      } else if (data.aseguradora) {
        data.aseguradoraId = data.aseguradora;
      } else {
        data.aseguradoraId = data.aseguradoraId;
      }
      return $http
        .get(data.aseguradoraId)
        .then(getProviderComplete)
        .catch(getProviderFailed);

      function getProviderComplete(response) {
        return response.data;
      }

      function getProviderFailed(error) {
        return error;
      }
    }

    function getProvider(data) {
      if (!isNaN(Number(data.aseguradoraId))) {
        data.aseguradoraId =
          url.IP + "proveedores-resume/" + data.aseguradoraId + "/";
      } else if (data.provider) {
        data.aseguradoraId = data.provider;
      } else if (data.aseguradora) {
        data.aseguradoraId = data.aseguradora;
      } else {
        data.aseguradoraId = data.aseguradoraId;
      }
      return $http
        .get(data.aseguradoraId)
        .then(getProviderComplete)
        .catch(getProviderFailed);

      function getProviderComplete(response) {
        return response.data;
      }

      function getProviderFailed(error) {
        return error;
      }
    }

    //UPDATE
    function updateProvider(data) {
      return $http
        .put(url.IP + "proveedores/" + data.id + "/", data)
        .then(updateProviderComplete)
        .catch(updateProviderFailed);

      function updateProviderComplete(response) {
        return response;
      }

      function updateProviderFailed(error) {
        return error;
      }
    }

    //DELETE
    function deleteProvider(data) {
      if (!isNaN(Number(data.aseguradoraId))) {
        data.aseguradoraId = url.IP + "proveedores/" + data.aseguradoraId + "/";
      }
      return $http
        .delete(data.aseguradoraId)
        .then(deleteProviderComplete)
        .catch(deleteProviderFailed);

      function deleteProviderComplete(response, status, headers, config) {
        //jshint ignore:line
        return response;
      }

      function deleteProviderFailed(error) {
        //jshint ignore:line
        return error;
      }
    }

    function getEmailContacts(provider) {
      return $http({
        method: "GET",
        url: url.IP + "provider-contact-email",
        params: {
          provider_policy: provider,
        },
      });
    }
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular
    .module("inspinia")
    .controller("AseguradorasInfoCtrl", AseguradorasInfoCtrl);

  AseguradorasInfoCtrl.$inject = [
    "url",
    "$http",
    "$state",
    "$stateParams",
    "$q",
    "helpers",
    "$uibModal",
    "providerService",
    "contactService",
    "toaster",
    "MESSAGES",
    "$localStorage",
    "SweetAlert",
    "$sessionStorage",
    "$scope",
  ];

  function AseguradorasInfoCtrl(
    url,
    $http,
    $state,
    $stateParams,
    $q,
    helpers,
    $uibModal,
    providerService,
    contactService,
    toaster,
    MESSAGES,
    $localStorage,
    SweetAlert,
    $sessionStorage,
    $scope
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.providers = [];
    vm.openModal = openModal;
    vm.cancel = cancel;
    vm.save = save;

    //Contacts
    vm.deleteContacts = deleteContacts;
    vm.addContact = addContact;
    vm.user = usr;
    vm.address_list = [];
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.changeRamo = changeRamo;
    vm.changeSubramo = changeSubramo;

    activate();

    function addAddress() {
      var address = {
        //     compania: '',
        rfc: "",
        raw: "",
        street_address: "",
        intersection: "",
        political: "",
        administrative_area_level_1: "",
        administrative_area_level_1_short: "",
        administrative_area_level_2: "",
        administrative_area_level_3: "",
        colloquial_area: "",
        sublocality: "",
        neighborhood: "",
        premise: "",
        subpremise: "",
        natural_feature: "",
        country: "",
        country_code: "",
        locality: "",
        postal_code: "",
        route: "",
        street_number: "",
        street_number_int: "",
        formatted: "",
        latitude: "",
        longitude: "",
        details: "",
        composed: "",
      };
      vm.address_list.push(address);
    }

    function deleteAddress(address, index) {
      if (address.url) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "You will not be able to recover this imaginary file!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, Estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: false,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http.delete(address.url).then(function () {
                swal(
                  "Deleted!",
                  "Your imaginary file has been deleted.",
                  "success"
                );
              });
            } else {
              swal("Cancelled", "Your imaginary file is safe :)", "error");
              return;
            }
          }
        );
      } else {
        vm.address_list.splice(index, 1);
      }
    }

    function activate() {
      vm.ramos = [];
      vm.contact_list = [];
      providerService.getProviderFull($stateParams).then(function (provider) {
        vm.form = provider;
        if (provider) {
          if (provider.contact_provider) {
            provider.contact_provider.forEach(function (contact) {
              vm.contact_list.push(contact);
              vm.contact_list.forEach(function (c) {
                vm.contacto = c;
                if (contact.ramo) {
                  $http.get(contact.ramo).then(function (cont_ramo) {
                    vm.ramos = cont_ramo.data;
                    // vm.form.contact_provider.ramo = cont_ramo;
                    contact.ramo_s = cont_ramo;
                    vm.ramo_contacto = cont_ramo;
                    vm.ramos = [
                      {
                        ramo_name: vm.ramos.ramo_name,
                        id: vm.ramos.id,
                        url: vm.ramos.url,
                        provider: vm.ramos.provider,
                        ramo_code: vm.ramos.ramo_code,
                        conramo: vm.ramos.ramo_name,
                      },
                    ];
                    vm.ramos.forEach(function (info_c) {
                      vm.form.contact_provider.forEach(function (form_c) {
                        form_c.conramo = info_c;
                        form_c.consubramo = cont_ramo.data.subramo_ramo;
                        info_c.subramo_ramo = cont_ramo.data.subramo_ramo;
                        changeRamo(vm.form.contact_provider, info_c);
                      });
                    });
                  });
                }
                //
                if (contact.subramo) {
                  $http.get(contact.subramo).then(function (cont_subramo) {
                    vm.subramos = cont_subramo.data;
                    vm.subramo_contacto = cont_subramo;
                    contact.subramo_s = cont_subramo;
                    vm.subramos = [
                      {
                        subramo_name: vm.subramos.subramo_name,
                        id: vm.subramos.id,
                        url: vm.subramos.url,
                        ramo: vm.subramos.ramo,
                        subramo_code: vm.subramos.subramo_code,
                        consubramo: vm.subramos.subramo_name,
                      },
                    ];
                    vm.subramos.forEach(function (info_cs) {
                      vm.form.contact_provider.forEach(function (form_cs) {
                        vm.ramos.conramo = vm.ramos;
                        form_cs.consubramo = info_cs;
                        changeSubramo(vm.form.contact_provider, info_cs);
                      });
                    });
                  });
                }
              });
            });
          }
        }
        provider.address_provider.forEach(function (address) {
          vm.address_list.push(address);
        });
        var nums = [];
        setTimeout(function () {
          $(".telefono").each(function (telefono) {
            var actual = $(this);
            nums.push(actual);
          });

          $http
            .get(url.IP + "ramos-by-provider/" + provider.id)
            .then(function (ramos) {
              vm.ramos = ramos.data;
            });
        }, 500);
      });

      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          vm.statesArray = data.data;
        });
    }

    function changeRamo(obj, ramo) {
      obj.ramo = ramo.url;
      if (!ramo) {
        vm.subramos = [];
        return;
      }
      try {
        vm.subramos = ramo.subramo_ramo;
      } catch (e) {}
    }

    function changeSubramo(obj, subramo) {
      if (subramo) {
        obj.subramo = subramo.url;
      }
    }

    function openModal() {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "templates/delete.html",
        controller: ModalInstanceCtrl,
        //windowClass: 'animated fadeIn'
      });
    }

    function ModalInstanceCtrl($scope, $uibModalInstance) {
      $scope.name = "proveedor";
      $scope.ok = function () {
        return providerService.deleteProvider($stateParams).then(function () {
          $uibModalInstance.close();
          $state.go("aseguradoras.aseguradoras");
        });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function save() {
      var flag = false;
      var nums = [];
      $(".telefono").each(function (telefono) {
        var actual = $(this);
        // var valActual = $(this).val();
        nums.push(actual);
      });
      vm.form.contact_provider.forEach(function (contact) {
        if (
          !validateEmail(contact.email) ||
          !contact.name ||
          !contact.phone_number
        ) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
          flag = true;
          return;
        }
      });
      if (flag) {
        return;
      }

      var form = angular.copy(vm.form);
      return providerService.updateProvider(form).then(function (data) {
        form.contact_provider.forEach(function (elem, index) {
          //jshint ignore:line
          elem.provider = data.data.url;
          if (!elem.url) {
            contactService.createContact(elem);
          } else {
            contactService.updateContact(elem);
          }
        });
        vm.address_list.forEach(function (address) {
          if (address.url) {
            $http.put(address.url, address);
          } else {
            address.aseg = vm.form.url;
            $http.post(url.IP + "v1/address/", address);
          }
        });
        toaster.success("Se ha editado correctamente un nuevo proveedor");
        $state.go("aseguradoras.aseguradoras");
      });
    }

    function cancel() {
      $state.go("aseguradoras.aseguradoras");
    }

    // Contacts
    function deleteContacts(url, index) {
      $localStorage.indx = index;
      $localStorage.urll = url;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/aseguradoras/aseguradoras.deleteContact.html",
        controller: ModalInstanceCtrlDeleteContact,
        //windowClass: 'animated fadeIn'
      });
    }

    function ModalInstanceCtrlDeleteContact($scope, $uibModalInstance) {
      var index = $localStorage.indx;
      var url = $localStorage.urll;
      $scope.ok = function () {
        if ((url && index) || (url && !index)) {
          if (usr.permiso.eliminar) {
            try {
              return contactService.deleteContact(url).then(function () {
                vm.form.contact_provider.splice(index, 1); //jshint ignore:line
                toaster.success(MESSAGES.OK.DELETECONTRACTOR);
                $uibModalInstance.dismiss("cancel");
              });
            } catch (err) {
              throw err; // toaster.error('Agregue al menos un contacto' + err.message);
            }
            $uibModalInstance.dismiss("cancel");
          } else {
            SweetAlert.swal(
              "Oops...",
              "No tienes permiso para eliminar registros",
              "error"
            );
          }
        } else {
          vm.form.contact_provider.splice(index, 1); //jshint ignore:line
        }
        $uibModalInstance.dismiss("cancel");
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }

    function addContact() {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
        ramo: "",
        subramo: "",
      }; //jshint ignore:line
      vm.form.contact_provider.push(contact); //jshint ignore:line
    }
  }
})();

(function () {
  "use strict";
  /* jshint devel: true */

  angular
    .module("inspinia")
    .controller("AseguradorasEditCtrl", AseguradorasEditCtrl);

  AseguradorasEditCtrl.$inject = [
    "url",
    "$http",
    "$state",
    "$stateParams",
    "$q",
    "helpers",
    "$uibModal",
    "providerService",
    "contactService",
    "toaster",
    "MESSAGES",
    "$localStorage",
    "SweetAlert",
    "$sessionStorage",
    "$scope",
  ];

  function AseguradorasEditCtrl(
    url,
    $http,
    $state,
    $stateParams,
    $q,
    helpers,
    $uibModal,
    providerService,
    contactService,
    toaster,
    MESSAGES,
    $localStorage,
    SweetAlert,
    $sessionStorage,
    $scope
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vm = this;
    vm.providers = [];
    vm.openModal = openModal;
    vm.cancel = cancel;
    vm.save = save;

    //Contacts
    vm.deleteContacts = deleteContacts;
    vm.addContact = addContact;
    vm.user = usr;
    vm.address_list = [];
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.changeRamo = changeRamo;
    vm.changeSubramo = changeSubramo;

    activate();

    function addAddress() {
      var address = {
        //     compania: '',
        rfc: "",
        raw: "",
        street_address: "",
        intersection: "",
        political: "",
        administrative_area_level_1: "",
        administrative_area_level_1_short: "",
        administrative_area_level_2: "",
        administrative_area_level_3: "",
        colloquial_area: "",
        sublocality: "",
        neighborhood: "",
        premise: "",
        subpremise: "",
        natural_feature: "",
        country: "",
        country_code: "",
        locality: "",
        postal_code: "",
        route: "",
        street_number: "",
        street_number_int: "",
        formatted: "",
        latitude: "",
        longitude: "",
        details: "",
        composed: "",
      };
      vm.address_list.push(address);
    }

    function deleteAddress(address, index) {
      if (address.url) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "You will not be able to recover this imaginary file!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: false,
            closeOnCancel: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http.delete(address.url).then(function () {
                swal(
                  "Deleted!",
                  "Your imaginary file has been deleted.",
                  "success"
                );
              });
            } else {
              swal("Cancelled", "Your imaginary file is safe :)", "error");
              return;
            }
          }
        );
      } else {
        vm.address_list.splice(index, 1);
      }
    }

    function activate() {
      vm.ramos = [];
      vm.contact_list = [];
      providerService.getProviderFull($stateParams).then(function (provider) {
        vm.form = provider;
        if (provider) {
          if (provider.contact_provider) {
            provider.contact_provider.forEach(function (contact) {
              vm.contact_list.push(contact);
              vm.contact_list.forEach(function (c) {
                vm.contacto = c;
                if (vm.contacto.ramo) {
                  $http.get(vm.contacto.ramo).then(function (cont_ramo) {
                    vm.ramos = cont_ramo.data;
                    vm.ramos = [
                      {
                        ramo_name: vm.ramos.ramo_name,
                        id: vm.ramos.id,
                        url: vm.ramos.url,
                        provider: vm.ramos.provider,
                        ramo_code: vm.ramos.ramo_code,
                        conramo: vm.ramos.ramo_name,
                      },
                    ];
                    vm.ramos.forEach(function (info_c) {
                      vm.form.contact_provider.forEach(function (form_c) {
                        form_c.conramo = info_c;
                        form_c.consubramo = cont_ramo.data.subramo_ramo;
                        info_c.subramo_ramo = cont_ramo.data.subramo_ramo;
                        changeRamo(vm.form.contact_provider, info_c);
                      });
                    });
                  });
                }
                //
                if (vm.contacto.subramo) {
                  $http.get(vm.contacto.subramo).then(function (cont_subramo) {
                    vm.subramos = cont_subramo.data;
                    vm.subramos = [
                      {
                        subramo_name: vm.subramos.subramo_name,
                        id: vm.subramos.id,
                        url: vm.subramos.url,
                        ramo: vm.subramos.ramo,
                        subramo_code: vm.subramos.subramo_code,
                        consubramo: vm.subramos.subramo_name,
                      },
                    ];
                    vm.subramos.forEach(function (info_cs) {
                      vm.form.contact_provider.forEach(function (form_cs) {
                        vm.ramos.conramo = vm.ramos;
                        form_cs.consubramo = info_cs;
                        changeSubramo(vm.form.contact_provider, info_cs);
                      });
                    });
                  });
                }
              });
            });
          }
        }
        provider.address_provider.forEach(function (address) {
          vm.address_list.push(address);
        });
        var nums = [];
        setTimeout(function () {
          $(".telefono").each(function (telefono) {
            var actual = $(this);
            nums.push(actual);
          });

          $http
            .get(url.IP + "ramos-by-provider/" + provider.id)
            .then(function (ramos) {
              vm.ramos = ramos.data;
            });
        }, 500);
      });

      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          vm.statesArray = data.data;
        });
    }

    function changeRamo(obj, ramo) {
      obj.ramo = ramo.url;
      if (!ramo) {
        vm.subramos = [];
        return;
      }
      try {
        vm.subramos = ramo.subramo_ramo;
      } catch (e) {}
    }

    function changeSubramo(obj, subramo) {
      if (subramo) {
        obj.subramo = subramo.url;
      }
    }

    function openModal() {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "templates/delete.html",
        controller: ModalInstanceCtrl,
        //windowClass: 'animated fadeIn'
      });
    }

    function ModalInstanceCtrl($scope, $uibModalInstance) {
      $scope.name = "proveedor";
      $scope.ok = function () {
        return providerService.deleteProvider($stateParams).then(function () {
          $uibModalInstance.close();
          $state.go("aseguradoras.aseguradoras");
        });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function save() {
      var flag = false;
      var nums = [];
      $(".telefono").each(function (telefono) {
        var actual = $(this);
        // var valActual = $(this).val();
        nums.push(actual);
      });
      vm.form.contact_provider.forEach(function (contact) {
        if (!contact.name) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
          flag = true;
          return;
        }
        if (!validateEmail(contact.email)) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
          flag = true;
          return;
        }
        if (!contact.phone_number) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
          flag = true;
          return;
        }
      });
      if (flag) {
        return;
      }

      var form = angular.copy(vm.form);
      return providerService.updateProvider(form).then(function (data) {
        form.contact_provider.forEach(function (elem, index) {
          //jshint ignore:line
          elem.provider = data.data.url;

          // nums[index].intlTelInput({
          //     nationalMode: true,
          //     separateDialCode: true,
          //     allowExtensions: true,
          //     autoHideDialCode: true,
          //     utilsScript: "../bower_components/intl-tel-input/lib/libphonenumber/build/utils.js" // just for formatting/placeholders etc
          // });
          // var intlNumber = nums[index].intlTelInput("getNumber");
          // var extensionIntlN = nums[index].intlTelInput("getExtension");

          // elem.phone_numbe2r = intlNumber + extensionIntlN;

          if (!elem.url) {
            contactService.createContact(elem);
          } else {
            contactService.updateContact(elem);
          }
        });
        vm.address_list.forEach(function (address) {
          if (address.url) {
            address.administrative_area_level_1 =
              address.administrative_area_level_1.state;
            address.administrative_area_level_2 =
              address.administrative_area_level_2.city;

            $http.put(address.url, address);
          } else {
            address.aseg = vm.form.url;
            address.administrative_area_level_1 =
              address.administrative_area_level_1.state;
            address.administrative_area_level_2 =
              address.administrative_area_level_2.city;
            $http.post(url.IP + "v1/address/", address);
          }
        });
        toaster.success("Se ha editado correctamente un nuevo proveedor");
        // $state.go('aseguradoras.aseguradoras');
        $state.go("aseguradoras.info", { aseguradoraId: data.data.id });
      });
    }

    function cancel() {
      $state.go("aseguradoras.aseguradoras");
    }

    // Contacts
    function deleteContacts(url, index) {
      $localStorage.indx = index;
      $localStorage.urll = url;
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/aseguradoras/aseguradoras.deleteContact.html",
        controller: ModalInstanceCtrlDeleteContact,
        //windowClass: 'animated fadeIn'
      });
    }

    function ModalInstanceCtrlDeleteContact($scope, $uibModalInstance) {
      var index = $localStorage.indx;
      var url = $localStorage.urll;
      $scope.ok = function () {
        if ((url && index) || (url && !index)) {
          if (usr.permiso.eliminar) {
            try {
              return contactService.deleteContact(url).then(function () {
                vm.form.contact_provider.splice(index, 1); //jshint ignore:line
                toaster.success(MESSAGES.OK.DELETECONTRACTOR);
                $uibModalInstance.dismiss("cancel");
              });
            } catch (err) {
              throw err; // toaster.error('Agregue al menos un contacto' + err.message);
            }
            $uibModalInstance.dismiss("cancel");
          } else {
            SweetAlert.swal(
              "Oops...",
              "No tienes permiso para eliminar registros",
              "error"
            );
          }
        } else {
          vm.form.contact_provider.splice(index, 1); //jshint ignore:line
        }
        $uibModalInstance.dismiss("cancel");
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }

    function addContact() {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
        departament: "",
        ramo: "",
        subramo: "",
      }; //jshint ignore:line
      vm.form.contact_provider.push(contact); //jshint ignore:line
    }
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("AseguradorasCtrl", AseguradorasCtrl);

  AseguradorasCtrl.$inject = [
    "SweetAlert",
    "$scope",
    "$state",
    "$http",
    "$q",
    "url",
    "contactService",
    "providerService",
    "toaster",
    "helpers",
    "MESSAGES",
    "$localStorage",
    "$sessionStorage",
    "exportFactory",
    "$uibModalInstance",
  ];

  function AseguradorasCtrl(
    SweetAlert,
    $scope,
    $state,
    $http,
    $q,
    url,
    contactService,
    providerService,
    toaster,
    helpers,
    MESSAGES,
    $localStorage,
    $sessionStorage,
    exportFactory,
    $uibModalInstance
  ) {
    // console.log('ñlklkejñijreiworuweoi');

    var vm = this;
    vm.groups = [];
    vm.submit = submit;
    vm.providers = [];
    $scope.showCompany = false;

    vm.address_list = [
      {
        //     compania: '',
        rfc: "",
        raw: "",
        street_address: "",
        intersection: "",
        political: "",
        administrative_area_level_1: "",
        administrative_area_level_1_short: "",
        administrative_area_level_2: "",
        administrative_area_level_3: "",
        colloquial_area: "",
        sublocality: "",
        neighborhood: "",
        premise: "",
        subpremise: "",
        natural_feature: "",
        country: "",
        country_code: "",
        locality: "",
        postal_code: "",
        route: "",
        street_number: "",
        street_number_int: "",
        formatted: "",
        latitude: "",
        longitude: "",
        details: "",
        composed: "",
      },
    ];
    vm.form = {
      compania: "",
      rfc: "",
      description: "",
      phone: "",
      website: "",
      contact_provider: [],
      ramo_provider: [],
      ramos_provider: {
        vida: true,
        accidentes: true,
        autos: true,
        danios: true,
        provider_id: 0,
      },
      ramos_afianzadora: {
        fidelidad: true,
        judiciales: true,
        administrativas: true,
        credito: true,
        fideicomiso: true,
        provider_id: 0,
      },
    };

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.user = usr;

    //Contacts
    vm.deleteContacts = deleteContacts;
    vm.addContact = addContact;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.returnToProvider = returnToProvider;
    vm.getAll = getAll;
    vm.showBinnacle = showBinnacle;
    vm.search = search;
    vm.activate = activate;
    vm.commentsExportLoading = false;
    vm.exportProviderComments = exportProviderComments;
    // vm.keyReport = keyReport;

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    activate();

    function addAddress() {
      var address = {
        rfc: "",
        raw: "",
        street_address: "",
        intersection: "",
        political: "",
        administrative_area_level_1: "",
        administrative_area_level_1_short: "",
        administrative_area_level_2: "",
        administrative_area_level_3: "",
        colloquial_area: "",
        sublocality: "",
        neighborhood: "",
        premise: "",
        subpremise: "",
        natural_feature: "",
        country: "",
        country_code: "",
        locality: "",
        postal_code: "",
        route: "",
        street_number: "",
        street_number_int: "",
        formatted: "",
        latitude: "",
        longitude: "",
        details: "",
        composed: "",
      };
      vm.address_list.push(address);
    }

    function deleteAddress(index) {
      vm.address_list.splice(index, 1);
    }

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    $scope.filterValue = function ($event) {
      if (isNaN(String.fromCharCode($event.charCode))) {
        $event.preventDefault();
      }
    };

    $scope.keyReport = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $http({
        method: "GET",
        // url: url.IP +'claves-excel',
        url: url.IP + "service_reporte-claves-excel",
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Claves.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
        l.stop();
      });
    };

    function submit(isValid) {
      var flag = false;
      if (vm.form.contact_provider.length) {
        vm.form.contact_provider.forEach(function (contact) {
          if (
            !validateEmail(contact.email) ||
            !contact.name ||
            !contact.phone_number
          ) {
            SweetAlert.swal("ERROR", MESSAGES.ERROR.SELADDRES, "error");
            flag = true;
            return;
          }
        });
      }
      if (!vm.afianzadora) {
        if (vm.form.ramos_provider) {
          if (!vm.form.ramos_provider.accidentes) {
            if (!vm.form.ramos_provider.danios) {
              if (!vm.form.ramos_provider.vida) {
                if (!vm.form.ramos_provider.autos) {
                  SweetAlert.swal(
                    "Error",
                    "Debe capturar al menos un ramo",
                    "error"
                  );
                  return;
                }
              }
            }
          }
        }
        vm.form.provider_type = 1;
      } else {
        vm.form.provider_type = 2;
        if (vm.form.ramos_afianzadora) {
          if (!vm.form.ramos_afianzadora.fidelidad) {
            if (!vm.form.ramos_afianzadora.judiciales) {
              if (!vm.form.ramos_afianzadora.administrativas) {
                if (!vm.form.ramos_provider.credito) {
                  if (!vm.form.ramos_afianzadora.fideicomiso) {
                    SweetAlert.swal(
                      "Error",
                      "Debe capturar al menos un ramo",
                      "error"
                    );
                    return;
                  }
                }
              }
            }
          }
        }
      }
      if (flag) {
        return;
      }
      var form = angular.copy(vm.form);
      var arr = [];
      var nums = [];

      $(".telefono").each(function (telefono) {
        var actual = $(this);
        nums.push(actual);
      });

      if (vm.form.contact_provider.length) {
        vm.form.contact_provider.forEach(function (elem, index) {
          arr.push(elem);
        });
      }

      form.contact = arr;
      form.polizas_provider = [];

      return providerService.createProvider(form).then(function (data) {
        if (!data) {
          SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORCREATECOMPANY, "error");
          return "";
        } else {
          if (vm.afianzadora) {
            vm.form.ramos_afianzadora.provider_id = data.id;
            $http
              .post(
                url.IP + "create-ramos-afianzadora",
                vm.form.ramos_afianzadora
              )
              .success(function (response) {});
          } else {
            vm.form.ramos_provider.provider_id = data.id;
            $http
              .post(url.IP + "create-ramos-provider", vm.form.ramos_provider)
              .success(function (response) {});
          }
          form.contact.forEach(function (contact) {
            contact.provider = data.url;
            contactService.createContact(contact);
          });
          toaster.success("Se ha agregado correctamente una nueva aseguradora");
        }
        vm.providers.push(data);
        vm.form = {};
        vm.address_list.forEach(function (address) {
          address.administrative_area_level_1 =
            address.administrative_area_level_1.state;
          address.administrative_area_level_2 =
            address.administrative_area_level_2.city;
          address.aseg = data.url;
          $http
            .post(url.IP + "v1/address/", address)
            .then(function (response) {});
        });
        vm.address_list = [];
        addAddress();

        vm.form = {
          compania: "",
          rfc: "",
          description: "",
          phone: "",
          contact_provider: [],
          ramo_provider: [],
          ramos_provider: {
            vida: true,
            accidentes: true,
            autos: true,
            danios: true,
            provider_id: 0,
          },
          ramos_afianzadora: {
            fidelidad: true,
            judiciales: true,
            administrativas: true,
            credito: true,
            fideicomiso: true,
            provider_id: 0,
          },
        };
      });
      $scope.showCompany = false;
    }

    $scope.cancel = function () {
      $scope.showCompany = false;
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
    };

    function activate() {
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          vm.statesArray = data.data;
        });
    }

    function getAll() {
      vm.providers = [];
      vm.buttonReport = false;
      return getProviders();
    }

    function returnToProvider() {
      vm.show_binnacle = false;
    }

    function search(cadena) {
      $scope.param_cadena = cadena;
      vm.show_binnacle = false;

      $scope.show_pagination = false;
      vm.providers = [];
      if (cadena.length) {
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   var filter_provider = 'v2/generics/seeker-provider/';
        var filter_provider = "seeker-provider/";
        $http({
          method: "GET",
          url: url.IP + filter_provider,
          params: {
            cadena: cadena,
          },
        })
          .then(
            function success(request) {
              if (request.status === 200 && request.data.results.length) {
                vm.providers = request.data.results;
                vm.config_pagination = request.data;
                $scope.show_pagination = true;
              } else {
                toaster.warning("No se encontraron registros");
              }
              vm.buttonReport = true;
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else {
        vm.providers = [];
      }
    }

    function getProviders() {
      vm.show_binnacle = false;
      return providerService.getReadListTableProviders().then(function (data) {
        vm.providers = data.data.results;
        vm.config_pagination = data.config;
        $scope.show_pagination = true;
      });
    }
    //-----------------------------------------------------------comments
    function showBinnacle(param) {
      vm.show_binnacle = true;
      vm.provider_id = param.id;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 11,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }
    //-------------------------------------------------------------comments

    function exportProviderComments() {
      if (!vm.provider_id || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
        $scope.$evalAsync(function () {});
      };

      var paramsObj = {
        model: 11,
        id_model: vm.provider_id,
      };
      if (vm.org_name) {
        paramsObj.org = vm.org_name;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );

      exportFactory
        .commentsExport({
          params: paramsObj,
          downloadName: "bitacora-proveedor.xlsx",
          token: vm.token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }

    // Contacts
    function deleteContacts(url, index) {
      if ((url && index) || (url && !index)) {
        try {
          return contactService.deleteContact(url).then(function () {
            vm.form.contact_provider.splice(index, 1); //jshint ignore:line
            toaster.success(MESSAGES.OK.DELETECONTRACTOR);
          });
        } catch (err) {
          throw err; // toaster.error('Agregue al menos un contacto' + err.message);
        }
        $uibModalInstance.dismiss("cancel");
      } else {
        vm.form.contact_provider.splice(index, 1); //jshint ignore:line
      }
    }

    function addContact() {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
        departament: "",
      }; //jshint ignore:line
      vm.form.contact_provider.push(contact);
    }

    vm.clearFilter = function () {
      $(".filter-status").val("");
      $(".footable").trigger("footable_clear_filter");
    };

    vm.filteringEventHandler = function (e) {
      var selected = $(".filter-status").find(":selected").text();
      if (selected && selected.length > 0) {
        e.filter += e.filter && e.filter.length > 0 ? " " + selected : selected;
        e.clear = !e.filter;
      }
    };

    vm.filterByStatus = function () {
      $(".footable").trigger("footable_filter", {
        filter: $("#filter").val(),
      });
    };

    vm.filter = {
      status: null,
    };

    $scope.exportData = function (aseguradoras) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $http
        .get(url.IP + "reporte-aseguradoras/")
        .then(
          function success(request) {
            l.stop();
            exportFactory.excel(request.data, "Aseguradoras");
          },
          function error(error) {
            l.stop();
            console.log("error", error);
          }
        )
        .catch(function (e) {
          l.stop();
          console.log(e);
        });
    };
    $scope.exportDataSeeker = function (param) {
      var data = { cadena: $scope.param_cadena };
      if (param == 1) {
        // naturales seeker
        $http({
          method: "GET",
          url: url.IP + "reporte-seekerProviders/",
          params: data,
        })
          .then(function (request) {
            if (request.status === 200) {
              exportFactory.excel(request.data, "Paquetes");
            }
          })
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("AseguradorasCtrl", AseguradorasCtrl)
    .directive("fooRepeatDone", function () {
      return function ($scope, element) {
        if ($scope.$last) {
          // all are rendered
          $(".table").trigger("footable_redraw");
        }
      };
    });

  AseguradorasCtrl.$inject = [
    "SweetAlert",
    "$scope",
    "$state",
    "$http",
    "$q",
    "url",
    "contactService",
    "providerService",
    "toaster",
    "helpers",
    "MESSAGES",
    "$localStorage",
    "$sessionStorage",
    "exportFactory",
    "PersistenceFactory",
  ];

  function AseguradorasCtrl(
    SweetAlert,
    $scope,
    $state,
    $http,
    $q,
    url,
    contactService,
    providerService,
    toaster,
    helpers,
    MESSAGES,
    $localStorage,
    $sessionStorage,
    exportFactory,
    PersistenceFactory
  ) {
    var vm = this;
    vm.groups = [];
    vm.submit = submit;
    vm.providers = [];
    vm.address_list = [
      {
        //     compania: '',
        rfc: "",
        raw: "",
        street_address: "",
        intersection: "",
        political: "",
        administrative_area_level_1: "",
        administrative_area_level_1_short: "",
        administrative_area_level_2: "",
        administrative_area_level_3: "",
        colloquial_area: "",
        sublocality: "",
        neighborhood: "",
        premise: "",
        subpremise: "",
        natural_feature: "",
        country: "",
        country_code: "",
        locality: "",
        postal_code: "",
        route: "",
        street_number: "",
        street_number_int: "",
        formatted: "",
        latitude: "",
        longitude: "",
        details: "",
        composed: "",
      },
    ];
    vm.form = {
      compania: "",
      rfc: "",
      description: "",
      phone: "",
      contact_provider: [],
      ramo_provider: [],
      ramos_provider: {
        vida: true,
        accidentes: true,
        autos: true,
        danios: true,
        provider_id: 0,
      },
      ramos_afianzadora: {
        fidelidad: true,
        judiciales: true,
        administrativas: true,
        credito: true,
        fideicomiso: true,
        provider_id: 0,
      },
    };
    vm.ramos = [];
    vm.ramos = [
      { ramo_name: "Vida", id: "1" },
      { ramo_name: "Accidentes y Enfermedades", id: "2" },
      { ramo_name: "Daños", id: "3" },
    ];
    vm.subramos = [];

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    vm.user = usr;

    /* Información de usuario */
    $scope.infoUser = $sessionStorage.infoUser;

    //Contacts
    vm.deleteContacts = deleteContacts;
    vm.addContact = addContact;
    vm.addAddress = addAddress;
    vm.deleteAddress = deleteAddress;
    vm.returnToProvider = returnToProvider;
    vm.getAll = getAll;
    vm.ramos_ = [];
    vm.showBinnacle = showBinnacle;
    vm.search = search;
    vm.activate = activate;
    vm.changeRamo = changeRamo;
    vm.changeSubramo = changeSubramo;
    $scope.showCompany = false;
    vm.infoProvider = infoProvider;
    function infoProvider(provider) {
      $state.go("aseguradoras.info", { aseguradoraId: provider.id });
    }

    $scope.keyReport = function () {
      var l = Ladda.create(document.querySelector(".ladda-button2"));
      l.start();
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //     // var excel_key = 'v2/claves/claves-excel';
      //     var excel_key = 'service_reporte-v2-claves-excel';
      var excel_key = "service_reporte-claves-excel";
      $http({
        method: "GET",
        url: url.IP + excel_key,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Claves.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
        l.stop();
      });
    };

    function changeRamo(obj, ramo, index) {
      if (ramo) {
        if (ramo.id) {
          $http({
            method: "GET",
            url: url.IP + "ramo-by-id/" + ramo.id,
          })
            .then(
              function success(request) {
                if (request.status === 200 && request.data) {
                  vm.ramos_ = request.data;
                  obj.ramo = vm.ramos_.url;
                  $scope.ramo_url = obj.ramo;
                  if (vm.ramos_.url) {
                    $http
                      .get(url.IP + "subramos-by-ramo/" + ramo.id)
                      .then(function (subramos) {
                        vm.subramos = subramos.data;
                      });
                  }
                } else {
                  toaster.warning("No se encontraron registros");
                }
                vm.buttonReport = true;
              },
              function error(error) {}
            )
            .catch(function (e) {
              console.log(e);
            });
        }
      } else {
        toaster.warning("Seleccione un ramo");
      }
      // obj.ramo = vm.ramos_.url;
      if (!ramo) {
        vm.subramos = [];
        return;
      }
      try {
        vm.subramos = ramo.subramo_ramo;
      } catch (e) {}
    }
    function changeSubramo(obj, subramo, index) {
      if (subramo) {
        if (subramo.url) {
          obj.subramo = subramo.url;
        }
      } else {
        // SweetAlert.swal("error",'Selecciona un subramo', "error");
        toaster.warning("Seleccione un subramo");
        return;
      }
    }

    activate();

    function addAddress() {
      var address = {
        rfc: "",
        raw: "",
        street_address: "",
        intersection: "",
        political: "",
        administrative_area_level_1: "",
        administrative_area_level_1_short: "",
        administrative_area_level_2: "",
        administrative_area_level_3: "",
        colloquial_area: "",
        sublocality: "",
        neighborhood: "",
        premise: "",
        subpremise: "",
        natural_feature: "",
        country: "",
        country_code: "",
        locality: "",
        postal_code: "",
        route: "",
        street_number: "",
        street_number_int: "",
        formatted: "",
        latitude: "",
        longitude: "",
        details: "",
        composed: "",
      };
      vm.address_list.push(address);
    }

    function deleteAddress(index) {
      vm.address_list.splice(index, 1);
    }

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function submit(isValid) {
      var flag = false;
      if (vm.form.contact_provider.length) {
        vm.form.contact_provider.forEach(function (contact) {
          if (
            !validateEmail(contact.email) ||
            !contact.name ||
            !contact.phone_number
          ) {
            toaster.error(MESSAGES.ERROR.SELADDRES);
            flag = true;
            return;
          }
        });
      }
      if (!vm.afianzadora) {
        if (vm.form.ramos_provider) {
          if (!vm.form.ramos_provider.accidentes) {
            if (!vm.form.ramos_provider.danios) {
              if (!vm.form.ramos_provider.vida) {
                if (!vm.form.ramos_provider.autos) {
                  SweetAlert.swal(
                    "Error",
                    "Debe capturar al menos un ramo",
                    "error"
                  );
                  return;
                }
              }
            }
          }
        }
        vm.form.provider_type = 1;
      } else {
        vm.form.provider_type = 2;
        if (vm.form.ramos_afianzadora) {
          if (!vm.form.ramos_afianzadora.fidelidad) {
            if (!vm.form.ramos_afianzadora.judiciales) {
              if (!vm.form.ramos_afianzadora.administrativas) {
                if (!vm.form.ramos_provider.credito) {
                  if (!vm.form.ramos_afianzadora.fideicomiso) {
                    SweetAlert.swal(
                      "Error",
                      "Debe capturar al menos un ramo",
                      "error"
                    );
                    return;
                  }
                }
              }
            }
          }
        }
      }
      if (flag) {
        return;
      }
      var form = angular.copy(vm.form);
      var arr = [];
      var nums = [];

      $(".telefono").each(function (telefono) {
        var actual = $(this);
        nums.push(actual);
      });

      if (vm.form.contact_provider.length) {
        vm.form.contact_provider.forEach(function (elem, index) {
          arr.push(elem);
        });
      }

      form.contact = arr;
      if (form.contact.conramo) {
        form.contact.conramo.url = $scope.ramo_url;
      }
      form.polizas_provider = [];

      return providerService.createProvider(form).then(function (data) {
        if (!data) {
          toaster.error(
            "Se ha generado un error al guardar su aseguradora, favor de revisar su información."
          );
          return "";
        } else {
          if (vm.afianzadora) {
            vm.form.ramos_afianzadora.provider_id = data.id;
            $http
              .post(
                url.IP + "create-ramos-afianzadora",
                vm.form.ramos_afianzadora
              )
              .success(function (response) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWFASTENER, "success");
              });
          } else {
            vm.form.ramos_provider.provider_id = data.id;
            $http
              .post(url.IP + "create-ramos-provider", vm.form.ramos_provider)
              .success(function (response) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.NEWCOMPANY, "success");
              });
          }
          form.contact.forEach(function (contact) {
            contact.provider = data.url;
            // contact.conramo.url = $scope.ramo_url
            contactService.createContact(contact);
          });
          $scope.showCompany = false;
        }
        vm.providers.push(data);
        vm.form = {};
        vm.address_list.forEach(function (address) {
          address.administrative_area_level_1 =
            address.administrative_area_level_1.state;
          address.administrative_area_level_2 =
            address.administrative_area_level_2.city;
          address.aseg = data.url;
          $http
            .post(url.IP + "v1/address/", address)
            .then(function (response) {});
        });
        vm.address_list = [];
        addAddress();

        vm.form = {
          compania: "",
          rfc: "",
          description: "",
          phone: "",
          contact_provider: [],
          ramo_provider: [],
          ramos_provider: {
            vida: true,
            accidentes: true,
            autos: true,
            danios: true,
            provider_id: 0,
          },
          ramos_afianzadora: {
            fidelidad: true,
            judiciales: true,
            administrativas: true,
            credito: true,
            fideicomiso: true,
            provider_id: 0,
          },
        };
      });
    }

    function activate() {
      $q.when()
        .then(function () {
          var defer = $q.defer();
          defer.resolve(helpers.getStates());
          return defer.promise;
        })
        .then(function (data) {
          vm.statesArray = data.data;
        });
    }

    function getAll() {
      vm.providers = [];
      vm.buttonReport = false;
      return getProviders();
    }

    function returnToProvider() {
      vm.show_binnacle = false;
    }

    function search(cadena) {
      $scope.param_cadena = cadena;
      vm.show_binnacle = false;

      $scope.show_pagination = false;
      vm.providers = [];
      if (cadena.length) {
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   var filter_provider = 'v2/generics/seeker-provider/';
        var filter_provider = "seeker-provider/";
        $http({
          method: "GET",
          url: url.IP + filter_provider,
          params: {
            cadena: cadena,
          },
        })
          .then(
            function success(request) {
              if (request.status === 200 && request.data.results.length) {
                vm.providers = request.data.results;
                vm.config_pagination = request.data;
                $scope.show_pagination = true;
              } else {
                toaster.warning("No se encontraron registros");
              }
              vm.buttonReport = true;
            },
            function error(error) {}
          )
          .catch(function (e) {
            console.log(e);
          });
      } else {
        vm.providers = [];
      }
    }

    function getProviders() {
      vm.show_binnacle = false;
      return providerService.getReadListTableProviders().then(function (data) {
        vm.providers = data.data.results;
        vm.config_pagination = data.config;
        $scope.show_pagination = true;
      });
    }
    //-----------------------------------------------------------comments
    function showBinnacle(param) {
      vm.show_binnacle = true;
      vm.provider_id = param.id;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 11,
          id_model: param.id,
        },
      })
        .then(function (request) {
          vm.comments_data = request.data.results;
          vm.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    }
    //-------------------------------------------------------------comments

    function exportProviderComments() {
      if (!vm.provider_id || vm.commentsExportLoading) {
        return;
      }
      vm.commentsExportLoading = true;

      var resetLoading = function () {
        vm.commentsExportLoading = false;
        $scope.$evalAsync(function () {});
      };
      var paramsObj = {
        model: 11,
        id_model: vm.provider_id,
      };
      if (vm.org_name) {
        paramsObj.org = vm.org_name;
      }
      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );
      exportFactory
        .commentsExport({
          params: paramsObj,
          downloadName: "bitacora-proveedor.xlsx",
          token: vm.token,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }

    // Contacts
    function deleteContacts(url, index) {
      if ((url && index) || (url && !index)) {
        try {
          return contactService.deleteContact(url).then(function () {
            vm.form.contact_provider.splice(index, 1); //jshint ignore:line
            toaster.success(MESSAGES.OK.DELETECONTRACTOR);
          });
        } catch (err) {
          throw err; // toaster.error('Agregue al menos un contacto' + err.message);
        }
        $uibModalInstance.dismiss("cancel");
      } else {
        vm.form.contact_provider.splice(index, 1); //jshint ignore:line
      }
    }

    function addContact() {
      var contact = {
        name: "",
        phone_number: "",
        email: "",
        departament: "",
      }; //jshint ignore:line
      vm.form.contact_provider.push(contact);
    }

    vm.clearFilter = function () {
      $(".filter-status").val("");
      $(".footable").trigger("footable_clear_filter");
    };

    vm.filteringEventHandler = function (e) {
      var selected = $(".filter-status").find(":selected").text();
      if (selected && selected.length > 0) {
        e.filter += e.filter && e.filter.length > 0 ? " " + selected : selected;
        e.clear = !e.filter;
      }
    };

    vm.filterByStatus = function () {
      $(".footable").trigger("footable_filter", {
        filter: $("#filter").val(),
      });
    };

    vm.filter = {
      status: null,
    };

    $scope.exportData = function (aseguradoras) {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      // if($scope.infoUser.staff && !$scope.infoUser.superuser){
      //   // var excel_provider = 'v2/aseguradoras/reporte-aseguradoras/';
      //   var excel_provider = 'service_reporte-v2-aseguradoras-excel';
      var excel_provider = "service_reporte-aseguradoras-excel";

      $http({
        method: "POST",
        url: url.IP + excel_provider,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Aseguradora(s).xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
        l.stop();
      });
    };

    $scope.exportDataSeeker = function (param) {
      var data = { cadena: $scope.param_cadena };
      if (param == 1) {
        // naturales seeker
        // if($scope.infoUser.staff && !$scope.infoUser.superuser){
        //   // var excel_provider_seeker = 'v2/aseguradoras/reporte-seekerProviders/';
        //   var excel_provider_seeker ='service_reporte-v2-seekerAseguradoras-excel';
        var excel_provider_seeker = "service_reporte-seekerAseguradoras-excel";

        $http({
          method: "POST",
          url: url.IP + excel_provider_seeker,
          data: data,
          headers: {
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }).then(function (data, status, headers, config) {
          if (data.status == 200) {
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Reporte_Aseguradora(s).xls");
          } else {
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al descargar el reporte",
              "error"
            );
          }
        });
      }
    };
    //-- Peticion de persistencia--//

    var json_data = {};
    var form = document.getElementsByTagName("form");
    var elementos = {};
    //Valores reutilizables
    var interval, interval1, valor;
    var count = 0;

    function set_dataForm(json) {
      $scope.showCompany = true;

      interval1 = setInterval(function () {
        if (form.length > 1) {
          //PersistenceFactory.set_inputs(json);
          seguir();
          clearInterval(interval1);
        }
      }, 1000);

      function seguir() {
        if (json["vm.form.compania"]) {
          vm.form.compania = json["vm.form.compania"][0].valor;
        }
        if (json["vm.form.alias"]) {
          vm.form.alias = json["vm.form.alias"][0].valor;
        }
        if (json["vm.form.rfc"]) {
          vm.form.rfc = json["vm.form.rfc"][0].valor;
        }
        if (json["vm.form.phone"]) {
          vm.form.phone = json["vm.form.phone"][0].valor;
        }
        if (json["vm.form.website"]) {
          vm.form.website = json["vm.form.website"][0].valor;
        }
      }
    }

    interval = setInterval(function () {
      if (form != undefined && PersistenceFactory.count == 0) {
        //&& PersistenceFactory.count == 0
        PersistenceFactory.inicial(
          vm.user.org,
          "Aseguradoras",
          vm.user.nameFull,
          PersistenceFactory.get_dataForm(form)
        );
      }
      if (PersistenceFactory.init_return != "") {
        clearInterval(interval);
        if (PersistenceFactory.init_return.status == "data_view") {
          set_dataForm(PersistenceFactory.json_return);
        }
        PersistenceFactory.interval = setInterval(function () {
          PersistenceFactory.editado(PersistenceFactory.get_dataForm(form));
        }, PersistenceFactory.intervalTime); /* */
      }
    }, 2000);
    //-- End Peticion de persistencia--//
  }
})();

(function () {
  "use strict";

  angular.module("inspinia").controller("groupingLevelCtrl", groupingLevelCtrl);

  groupingLevelCtrl.$inject = [
    "$sessionStorage",
    "$scope",
    "$http",
    "url",
    "dataFactory",
    "SweetAlert",
    "$parse",
  ];

  function groupingLevelCtrl(
    $sessionStorage,
    $scope,
    $http,
    url,
    dataFactory,
    SweetAlert,
    $parse,
    $uibModalInstance
  ) {
    var vm = this;

    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);
    var check = false;

    $scope.showGrouping = false;

    activate();

    function activate() {
      dataFactory.get("groupingLevel-resume/").then(function (response) {
        $scope.grupingLevelList = response.data;
      });
    }

    $scope.editSub = function (item, sub, index) {
      $scope.groupinglevel = sub;
      $scope.groupinglevel.groupinglevel = item.description;
      $scope.level_grouping = item.level_grouping;
      $scope.subgrouping = sub.url;
      $scope.showGrouping = true;
    };

    $scope.add = function () {
      var obj = {
        description: "",
      };
      $scope.groupinglevel.subsubgrupos.push(obj);
    };

    $scope.delete = function (sub, idx) {
      if (sub.url) {
        swal(
          {
            title: "¿Estás seguro?",
            text: "La agrupación se eliminará aunque no guardes los cambios. ¿Desea eliminar la agrupación?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
          },
          function (isConfirm) {
            if (isConfirm) {
              $http.delete(sub.url);
              $scope.groupinglevel.subsubgrupos.splice(idx, 1);
            } else {
            }
          }
        );
      } else {
        $scope.groupinglevel.subsubgrupos.splice(idx, 1);
      }
    };

    $scope.update = function () {
      $http.patch($scope.groupinglevel.url, {
        description: $scope.groupinglevel.description,
      });
      $scope.groupinglevel.subsubgrupos.forEach(function (item) {
        if (!item.url) {
          $scope.grupo = {
            description: item.description,
            level_grouping: $scope.level_grouping,
            parent: $scope.subgrouping,
            type_grouping: 3,
          };

          $http({
            method: "POST",
            url: url.IP + "groupinglevel/",
            data: $scope.grupo,
          }).then(function (request_sub) {});
        } else {
          $http.patch(item.url, { description: item.description });
        }
      });
      $scope.showGrouping = false;
      activate();
    };

    $scope.close = function () {
      $scope.showGrouping = false;
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "PagoAgentesEstadosCuentaController",
      PagoAgentesEstadosCuentaController
    );
  PagoAgentesEstadosCuentaController.$inject = [
    "$scope",
    "$sce",
    "$http",
    "$state",
    "url",
    "formatValues",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "dataFactory",
    "datesFactory",
    "$parse",
    "$sessionStorage",
    "$uibModal",
  ];

  function PagoAgentesEstadosCuentaController(
    $scope,
    $sce,
    $http,
    $state,
    url,
    formatValues,
    SweetAlert,
    MESSAGES,
    providerService,
    dataFactory,
    datesFactory,
    $parse,
    $sessionStorage,
    $uibModal
  ) {
    var vm = this;

    $scope.users = [];
    $scope.seller = [];
    $scope.isSeller = [];
    $scope.estadoscuenta = false;
    $scope.recibospagar = false;
    $scope.main_estados = [];
    activate();
    function activate() {
      $http.get(url.IP + "get-vendors/").then(function (response) {
        $scope.users = response.data;
        $scope.users.forEach(function (u, i) {
          u.isSeller = false;
        });
      });
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Referenciadores") {
            vm.acceso_ref = perm;
            vm.acceso_ref.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar referenciadores") {
                if (acc.checked == true) {
                  vm.acceso_adm_ref = true;
                } else {
                  vm.acceso_adm_ref = false;
                }
              } else if (acc.permission_name == "Pagar a referenciadores") {
                if (acc.checked == true) {
                  vm.acceso_pag_ref = true;
                } else {
                  vm.acceso_pag_ref = false;
                }
              } else if (
                acc.permission_name == "Cambiar refrenciador en pólizas"
              ) {
                if (acc.checked == true) {
                  vm.acceso_chg_ref = true;
                } else {
                  vm.acceso_chg_ref = false;
                }
              }
            });
          } else if (perm.model_name == "Archivos") {
            vm.acceso_files = perm;
            vm.acceso_files.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar archivos sensibles") {
                if (acc.checked == true) {
                  vm.permiso_archivos = true;
                } else {
                  vm.permiso_archivos = false;
                }
              }
            });
          }
        });
      }
    }
    $scope.obtenerEstados = function (parItem, parType, u, index) {
      // $scope.isSeller[main_index] = false;
      $scope.estadoscuenta = true;
      $scope.recibospagar = false;
      $scope.main_recibos = [];
      $scope.main_estados = [];
      dataFactory
        .get("estado-cuenta-referenciador/", { referenciador: parType.id })
        .then(function (estados) {
          $scope.main_estados = estados.data.results;
          vm.edos_config = {
            count: estados.data.count,
            previous: estados.data.previous,
            next: estados.data.next,
          };
          $scope.isSeller.forEach(function (sel, ind) {
            if (ind == index) {
              $scope.isSeller[index] = true;
            } else {
              $scope.isSeller[ind] = false;
            }
          });
          vm.show_pag_edos = true;
          vm.show_pag_edos_rechazados = false;
          vm.show_pag_edos_cerrados = false;
          testPagination("main_estados", "vm.edos_config");
        });
    };
    $scope.returnToTable = function () {
      $scope.show_detail = false;
    };

    $scope.obtenerRecibos = function (parItem, parType, index, parData) {
      $scope.main_estados = [];
      $scope.main_recibos = [];
      $scope.vendor_selected = {};
      $scope.estadoscuenta = false;
      $scope.recibospagar = true;
      // $scope.isSeller[index] = true;
      // $scope.users[index].isSeller = true
      $scope.isSeller.forEach(function (sel, ind) {
        if (ind == index) {
          $scope.isSeller[index] = true;
        } else {
          $scope.isSeller[ind] = false;
        }
      });
      $scope.vendedor_selected = parData;
      $scope.vendor_selected.value = parData;
      $scope.sellerReceipt_add = [];
      dataFactory
        .get("get-referenciador-receipts/", { vendedor: parType.id })
        .then(function (response) {
          if (response.data) {
            $scope.vend = {};
            $scope.main_recibos = response.data.data;
            parData.sellerReceipts = response.data.data;
            parData.subtotal = response.data.suma.toFixed(2);
            parData.gastos_operacion =
              response.data.gastos_operacion.toFixed(2);
            parData.total = response.data.total.toFixed(2);
            parData.vendedor_go = response.data.vendedor_go.toFixed(2);
            try {
              response.data.concepts = response.data.concepts
                .split("'")
                .join('"');
              response.data.concepts = response.data.concepts
                .split("None")
                .join('""');
              if (typeof response.data.concepts == "string") {
                response.data.concepts = JSON.parse(response.data.concepts);
              }
            } catch (ee) {
              console.log("-errror---", ee, parData.concepts);
            }
            $scope.vend.sellerReceipts = response.data.data;
            $scope.vend.subtotal = response.data.suma.toFixed(2);
            $scope.vend.gastos_operacion =
              response.data.gastos_operacion.toFixed(2);
            $scope.vend.total = response.data.total.toFixed(2);
            $scope.vend.vendedor_go = response.data.vendedor_go.toFixed(2);
            $scope.vend.value = $scope.vendor_selected.value;
            $scope.vend.subtotal_1 = 0;
            $scope.vend.subtotal_1MXN = 0;
            $scope.vend.go_final = 0;
            $scope.vend.go_finalMXN = 0;
            $scope.vend.total_final = 0;
            $scope.vend.total_finalMXN = 0;
            $scope.vend.comision__ = response.data.com;
            $scope.vend.sellerReceipts1 = [];
            $scope.vend.sellerReceipts.forEach(function (rec, index) {
              if (rec.poliza) {
                if (rec.poliza.ref_policy) {
                  $scope.recibos_ok = [];
                  rec.poliza.ref_policy.forEach(function (ref, index) {
                    // if (ref.referenciador.id == $scope.vendor_selected.value) {
                    if (
                      parseFloat(ref.comision_vendedor).toFixed(2) != 0.0 &&
                      ref.is_changed == false
                    ) {
                      if ($scope.recibos_ok.includes(rec.id)) {
                        console.log(
                          "-----no hacer calculo--si-incl",
                          rec.id,
                          $scope.recibos_ok
                        );
                      } else {
                        console.log(
                          "-----hacer calculo--",
                          rec.id,
                          $scope.recibos_ok
                        );
                        rec.comision_vendedor = parseFloat(
                          ref.comision_vendedor
                        ).toFixed(2);
                        $scope.vend.subtotal_1 =
                          parseFloat($scope.vend.subtotal_1) +
                          parseFloat(
                            $scope.calculateCommission(
                              rec.comision_conciliada,
                              rec.comision_vendedor,
                              rec.cambiar_comision_al_vendedor,
                              rec.comision_al_vendedor
                            )
                          );
                        $scope.recibos_ok.push(rec.id);
                        if (rec.poliza.f_currency != 1) {
                          var comcon = parseFloat(
                            $scope.calculateCommission(
                              rec.comision_conciliada,
                              rec.comision_vendedor,
                              rec.cambiar_comision_al_vendedor,
                              rec.comision_al_vendedor
                            )
                          );
                          $scope.vend.subtotal_1MXN =
                            parseFloat($scope.vend.subtotal_1MXN) +
                            parseFloat(
                              parseFloat(rec.rate_exchange) * parseFloat(comcon)
                            );
                        }
                      }
                    } else {
                      if (rec.comision_vendedor != "No existe subramo") {
                        rec.comision_vendedor = rec.comision_vendedor;
                      } else if ($scope.vend.comision__) {
                        rec.comision_vendedor = $scope.vend.comision__;
                      }
                      // rec.comision_vendedor = ref.comision_vendedor---anterior cambio doble si ref 2 veces en poliza
                      if (rec.comision_vendedor) {
                        if ($scope.recibos_ok.includes(rec.id)) {
                          console.log(
                            "---1--no hacer calculo--",
                            rec.id,
                            $scope.recibos_ok
                          );
                        } else {
                          $scope.vend.subtotal_1 =
                            parseFloat($scope.vend.subtotal_1) +
                            parseFloat(
                              $scope.calculateCommission(
                                rec.comision_conciliada,
                                rec.comision_vendedor,
                                rec.cambiar_comision_al_vendedor,
                                rec.comision_al_vendedor
                              )
                            );
                          $scope.recibos_ok.push(rec.id);
                          if (rec.poliza.f_currency != 1) {
                            var comcon = parseFloat(
                              $scope.calculateCommission(
                                rec.comision_conciliada,
                                rec.comision_vendedor,
                                rec.cambiar_comision_al_vendedor,
                                rec.comision_al_vendedor
                              )
                            );
                            $scope.vend.subtotal_1MXN =
                              parseFloat($scope.vend.subtotal_1MXN) +
                              parseFloat(
                                parseFloat(rec.rate_exchange) *
                                  parseFloat(comcon)
                              );
                          }
                        }
                      }
                    }
                  });
                }
                if (rec.poliza.vendor && rec.poliza.ref_policy.length == 0) {
                  if (rec.comision_vendedor) {
                    rec.comision_vendedor = rec.comision_vendedor;
                  } else if ($scope.vend.comision__) {
                    rec.comision_vendedor = $scope.vend.comision__;
                  }
                  $scope.vend.subtotal_1 =
                    parseFloat($scope.vend.subtotal_1) +
                    parseFloat(
                      $scope.calculateCommission(
                        rec.comision_conciliada,
                        rec.comision_vendedor,
                        rec.cambiar_comision_al_vendedor,
                        rec.comision_al_vendedor
                      )
                    );
                  if (rec.poliza.f_currency != 1) {
                    var comcon = parseFloat(
                      $scope.calculateCommission(
                        rec.comision_conciliada,
                        rec.comision_vendedor,
                        rec.cambiar_comision_al_vendedor,
                        rec.comision_al_vendedor
                      )
                    );
                    $scope.vend.subtotal_1MXN =
                      parseFloat($scope.vend.subtotal_1MXN) +
                      parseFloat(
                        parseFloat(rec.rate_exchange) * parseFloat(comcon)
                      );
                  }
                }
              } else {
                if (rec.comision_vendedor) {
                  rec.comision_vendedor = rec.comision_vendedor;
                } else if ($scope.vend.comision__) {
                  rec.comision_vendedor = $scope.vend.comision__;
                }
                $scope.vend.subtotal_1 =
                  parseFloat($scope.vend.subtotal_1) +
                  parseFloat(
                    $scope.calculateCommission(
                      rec.comision_conciliada,
                      rec.comision_vendedor,
                      rec.cambiar_comision_al_vendedor,
                      rec.comision_al_vendedor
                    )
                  );
                if (rec.poliza.f_currency != 1) {
                  var comcon = parseFloat(
                    $scope.calculateCommission(
                      rec.comision_conciliada,
                      rec.comision_vendedor,
                      rec.cambiar_comision_al_vendedor,
                      rec.comision_al_vendedor
                    )
                  );
                  $scope.vend.subtotal_1MXN =
                    parseFloat($scope.vend.subtotal_1MXN) +
                    parseFloat(
                      parseFloat(rec.rate_exchange) * parseFloat(comcon)
                    );
                }
              }
              // No mover
              $scope.sellerReceipt_add[rec.id] = false;
            });
            // $scope.vend.go_final = parseFloat(($scope.vend.vendedor_go /100) * $scope.vend.subtotal_1).toFixed(2);
            // $scope.vend.go_finalMXN = parseFloat(($scope.vend.vendedor_go /100) * $scope.vend.subtotal_1MXN).toFixed(2);
            // $scope.vend.total_final = parseFloat($scope.vend.subtotal_1 - $scope.vend.go_final).toFixed(2);
            // $scope.vend.total_finalMXN = parseFloat($scope.vend.subtotal_1MXN - $scope.vend.go_finalMXN).toFixed(2);
            $scope.vend.concepts = response.data.concepts;
            $scope.vendedorTodos = angular.copy($scope.vend);
            $scope.originalCalculos = angular.copy($scope.vend);
            $scope.vend.conceptos_grales = response.data.conceptos_grales;
            $scope.vend.conceptos_grales.forEach(function (concpt, idcb) {
              $scope.vend.conceptos_grales[idcb].checked = true;
            });
            // $scope.checkRecGralInicial($scope.vend.conceptos_grales,$scope.vend,$scope.originalCalculos)
            if (response.data.valores && response.data["valores"]["total"]) {
              var val_results = response.data.valores;
              $scope.originalCalculos.subtotal_1 =
                val_results["subtotal_final_suma"];
              $scope.vend.total_abonos_grales = val_results["abonos_grales"];
              $scope.vend.total_cargos_grales = val_results["cargos_grales"];
              $scope.vend.total_abonos_individuales =
                val_results["abonos_individuales"];
              $scope.vend.total_cargos_individuales =
                val_results["cargos_individuales"];
              $scope.vend.sumas_bonos = val_results["sumasabonos"];
              $scope.vend.sumas_cargos = val_results["sumascargos"];
              $scope.subtotal_1_1 = val_results["subtotal_cargos_abonos"];
              $scope.vend.go_final = val_results["go"];
              $scope.total_final_1 = val_results["total"];
            } else {
              var val_results = 0;
              // $scope.originalCalculos.subtotal_1
              $scope.originalCalculos.subtotal_1 = 0;
              $scope.vend.total_abonos_grales = 0;
              $scope.vend.total_cargos_grales = 0;
              $scope.vend.total_abonos_individuales = 0;
              $scope.vend.total_cargos_individuales = 0;
              $scope.vend.sumas_bonos = 0;
              $scope.vend.sumas_cargos = 0;
              $scope.subtotal_1_1 = 0;
              $scope.vend.go_final = 0;
              if (response.data && response.data.data) {
                $scope.checkRecGralInicial(
                  $scope.vend.conceptos_grales,
                  $scope.vend,
                  $scope.originalCalculos
                );
              }
            }
          }
        });
    };
    vm.form = {};
    $scope.checkRec = function (val, argument, vend1, index) {
      vend1.subTotal_cn = vend1.subTotal_cn
        ? vend1.subTotal_cn
        : vend1.subtotal_1;
      var tipo_calculo = argument.tipo_calculo;
      var calculo = argument.calculo;
      var cantidad = argument.cantidad;
      $scope.total_final_edo = 0;
      if (calculo == 1) {
        //Abono
        if (tipo_calculo == 1) {
          //$
          if (val) {
            var abonos = cantidad;
            vend1.concepts[index].subtotal_aplicado =
              vend1.subtotal_1 + cantidad;
          } else {
            var abonos = 0;
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1;
          }
          vend1.concepts[index].abono_peso = abonos;
          $scope.vend.concepts = vend1.concepts;
        }
        if (tipo_calculo == 2) {
          //%
          if (val) {
            var abonos = vend1.subtotal_1 * (cantidad / 100);
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1 + abonos;
          } else {
            var abonos = 0;
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1;
          }
          vend1.concepts[index].abono_peso = abonos;
          $scope.vend.concepts = vend1.concepts;
        }
      }
      if (calculo == 2) {
        //Cargo
        if (tipo_calculo == 1) {
          //$
          if (val) {
            var cargos = cantidad;
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1 - cargos;
          } else {
            var cargos = 0;
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1;
          }
          vend1.concepts[index].cargo_peso = cargos;
          $scope.vend.concepts = vend1.concepts;
        }
        if (tipo_calculo == 2) {
          //%
          if (val) {
            var cargos = cantidad;
            var subCargo = vend1.subTotal_cn * (cargos / 100);
            vend1.concepts[index].subtotal_aplicado =
              vend1.subtotal_1 - subCargo;
          } else {
            var cargos = 0;
            var subCargo = 0;
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1;
          }
          vend1.concepts[index].cargo_peso = subCargo;
          $scope.vend.concepts = vend1.concepts;
        }
      }
      var sumas = 0;
      var cargosx = 0;
      vend1.total_abonos = 0;
      vend1.total_cargos = 0;
      vend1.concepts.forEach(function (ec) {
        if (ec.abono_peso) {
          sumas = sumas + ec.abono_peso;
        }
        if (ec.cargo_peso) {
          cargosx = cargosx + ec.cargo_peso;
        }
        vend1.total_abonos = sumas;
        vend1.total_cargos = cargosx;
        vend1.totalFinal_edo = vend1.subtotal_1 + vend1.total_abonos;
        vend1.totalFinal_edo = vend1.totalFinal_edo - vend1.total_cargos;
        vend1.totalFinal_edo_ok = vend1.totalFinal_edo - vend1.gastos_operacion;
      });
    };
    $scope.f_currency = function (parData) {
      if (parData.poliza) {
        switch (parData.poliza.f_currency) {
          case 1:
            return "Pesos";
            break;
          case 2:
            return "Dolares";
            break;
          case 3:
            return "UDI";
            break;
        }
      }
    };
    $scope.calculoConcepts = function (v, val, seller, rec) {
      $scope.subtotal_add = 0;
      $scope.recibos_ok2 = [];
      seller.forEach(function (item, index) {
        v.sellerReceipts.forEach(function (item2, index2) {
          if (index == item2.id) {
            if (item) {
              if (item2.poliza) {
                if (item2.poliza.ref_policy) {
                  item2.poliza.ref_policy.forEach(function (ref, index) {
                    if (
                      ref.referenciador.id == $scope.vendor_selected.value &&
                      ref.is_changed == false
                    ) {
                      if (parseFloat(ref.comision_vendedor).toFixed(2) != 0.0) {
                        item2.comision_vendedor = parseFloat(
                          ref.comision_vendedor
                        ).toFixed(2);
                        if (item2.comision_vendedor != "No existe subramo") {
                          item2.comision_vendedor = item2.comision_vendedor;
                        } else if (parData.comision__) {
                          item2.comision_vendedor = parData.comision__;
                        }
                        if ($scope.recibos_ok2.includes(item2.id)) {
                          console.log(
                            "ya se ha calculado",
                            item2,
                            $scope.subtotal_add
                          );
                        } else {
                          $scope.recibos_ok2.push(item2.id);
                          $scope.subtotal_add =
                            parseFloat($scope.subtotal_add) +
                            parseFloat(
                              $scope.calculateCommission(
                                item2.comision_conciliada,
                                item2.comision_vendedor,
                                item2.cambiar_comision_al_vendedor,
                                item2.comision_al_vendedor
                              )
                            );
                        }
                      } else {
                        if (item2.comision_vendedor != "No existe subramo") {
                          item2.comision_vendedor = item2.comision_vendedor;
                        } else if ($scope.subtotal_add) {
                          item2.comision_vendedor = $scope.subtotal_add;
                        }
                        if (item2.comision_vendedor) {
                          if ($scope.recibos_ok2.includes(item2.id)) {
                            console.log(
                              "2ya se ha calculado",
                              item2,
                              $scope.subtotal_add
                            );
                          } else {
                            $scope.recibos_ok2.push(item2.id);
                            $scope.subtotal_add =
                              parseFloat($scope.subtotal_add) +
                              parseFloat(
                                $scope.calculateCommission(
                                  item2.comision_conciliada,
                                  item2.comision_vendedor,
                                  item2.cambiar_comision_al_vendedor,
                                  item2.comision_al_vendedor
                                )
                              );
                          }
                        }
                      }
                    } else {
                      if (item2.poliza.vendor) {
                        if ($scope.recibos_ok2.includes(item2.id)) {
                          console.log(
                            "3ya se ha calculado",
                            item2,
                            $scope.subtotal_add
                          );
                        } else {
                          $scope.recibos_ok2.push(item2.id);
                          $scope.subtotal_add =
                            parseFloat($scope.subtotal_add) +
                            parseFloat(
                              $scope.calculateCommission(
                                item2.comision_conciliada,
                                item2.comision_vendedor,
                                item2.cambiar_comision_al_vendedor,
                                item2.comision_al_vendedor
                              )
                            );
                        }
                      }
                    }
                  });
                }
                if (
                  item2.poliza.vendor &&
                  item2.poliza.ref_policy.length == 0
                ) {
                  if ($scope.recibos_ok2.includes(item2.id)) {
                    console.log(
                      "4ya se ha calculado",
                      item2,
                      $scope.subtotal_add
                    );
                  } else {
                    $scope.recibos_ok2.push(item2.id);
                    $scope.subtotal_add =
                      parseFloat($scope.subtotal_add) +
                      parseFloat(
                        $scope.calculateCommission(
                          item2.comision_conciliada,
                          item2.comision_vendedor,
                          item2.cambiar_comision_al_vendedor,
                          item2.comision_al_vendedor
                        )
                      );
                  }
                }
              } else {
                if ($scope.recibos_ok2.includes(item2.id)) {
                  console.log(
                    "5ya se ha calculado",
                    item2,
                    $scope.subtotal_add
                  );
                } else {
                  $scope.recibos_ok2.push(item2.id);
                  $scope.subtotal_add =
                    parseFloat($scope.subtotal_add) +
                    parseFloat(
                      $scope.calculateCommission(
                        item2.comision_conciliada,
                        item2.comision_vendedor,
                        item2.cambiar_comision_al_vendedor,
                        item2.comision_al_vendedor
                      )
                    );
                }
              }
            } else {
            }
          }
        });
      });
      var sumas = 0;
      var cargosx = 0;
      v.concepts.forEach(function (ec) {
        if (ec.abono_peso) {
          sumas = sumas + ec.abono_peso;
        }
        if (ec.cargo_peso) {
          cargosx = cargosx + ec.cargo_peso;
        }
        v.account_total_abonos = sumas;
        v.account_total_cargos = cargosx;
        v.account_totalFinal_edo = $scope.subtotal_add + v.account_total_abonos;
        v.account_totalFinal_edo =
          v.account_totalFinal_edo - v.account_total_cargos;
        // ------------------------
        $scope.gastos_operacion = (
          (parseFloat(v.vendedor_go) / 100).toFixed(2) *
          v.account_totalFinal_edo
        ).toFixed(2);
        $scope.total = (
          v.account_totalFinal_edo - $scope.gastos_operacion
        ).toFixed(2);
        v.gastos_operacion = $scope.gastos_operacion;
        // -------------------
        v.account_totalFinal_edo_ok =
          v.account_totalFinal_edo - v.gastos_operacion;
      });
    };
    $scope.tipocalculo_options = [
      { id: 1, name: "$" },
      { id: 2, name: "%" },
    ];
    $scope.calculo_options = [
      { id: 1, name: "Abono" },
      { id: 2, name: "Cargo" },
    ];

    $scope.comisiones_calculadas = 0;
    $scope.calculateCommission = function (
      prima,
      comision,
      cambiar_comision_al_vendedor,
      comision_al_vendedor
    ) {
      if (cambiar_comision_al_vendedor) {
        return comision_al_vendedor;
      }
      comision = parseFloat(comision);
      prima = parseFloat(prima);
      if (comision >= 0) {
        return (prima * (comision / 100.0)).toFixed(2);
      } else {
        return 0;
      }
    };
    $scope.viewReceipts = function (estado) {
      $state.go("agentes.receipts", { folioId: estado.id });
    };

    // calcular conceptos generales initial
    $scope.checkRecGralInicial = function (
      conceptosg,
      vend1,
      originalCalculos
    ) {
      $scope.calculandoGral = true;
      vend1.subTotal_cn = originalCalculos.totalFinal_edo
        ? originalCalculos.totalFinal_edo
        : originalCalculos.subtotal_1;

      $scope.total_final_edo = 0;
      var abonos_grales = 0;
      var cargos_grales = 0;
      $scope.aplicarGral = false;
      var abonos_pesos = 0;
      var cargos_pesos = 0;
      conceptosg.forEach(function (argument, indexgral) {
        if (vend1.sellerReceipts && argument.checked) {
          if ($scope.sellerReceipt_add) {
            vend1.sellerReceipts.forEach(function (recibo, indexx) {
              $scope.aplicarGral = false;
              $scope.sellerReceipt_add.forEach(function (item2, index2) {
                if (recibo.id == index2) {
                  if (item2) {
                    //recibo dentro del estado
                    if (
                      recibo.poliza &&
                      recibo.poliza.aseguradora_id &&
                      argument.aseguradoras
                    ) {
                      if (
                        argument.aseguradoras.includes(
                          recibo.poliza.aseguradora_id
                        )
                      ) {
                        if (argument.ramos.includes(recibo.poliza.ramo_code)) {
                          if (
                            argument.tipopolizas.includes(
                              recibo.poliza.document_type
                            )
                          ) {
                            $scope.aplicarGral = true; //coincide con arreglos configurados
                          }
                        }
                      } else if (
                        argument.ramos.includes(recibo.poliza.ramo_code)
                      ) {
                        if (
                          argument.tipopolizas.includes(
                            recibo.poliza.document_type
                          )
                        ) {
                          $scope.aplicarGral = true; //coincide con arreglos configurados
                        }
                      } else if (
                        argument.tipopolizas.includes(
                          recibo.poliza.document_type
                        )
                      ) {
                        $scope.aplicarGral = true; //coincide con arreglos configurados
                      }
                    }
                    // si no hay aseguradoras,ramos,tipopolizas se calculan ya que se consideran todos
                    if (
                      argument.aseguradoras.length == 0 &&
                      argument.tipopolizas.length == 0 &&
                      argument.ramos.length == 0
                    ) {
                      // aplicar
                      $scope.aplicarGral = true; //coincide sin configuraciones
                    }
                    if ($scope.aplicarGral) {
                      var comision_ref = (
                        recibo.comision_conciliada *
                        (recibo.comision_vendedor / 100.0)
                      ).toFixed(2);
                      console.log(
                        "comision---",
                        comision_ref,
                        argument.cantidad,
                        argument.calculo,
                        vend1,
                        vend1.subTotal_cn,
                        argument.concepto
                      );
                      if (argument.calculo == 1) {
                        //Abono
                        if (argument.tipo_calculo == 2) {
                          //% cada recibo, $ se aplica al final
                          var abono_a_moneda =
                            (parseFloat(argument.cantidad) *
                              parseFloat(comision_ref)) /
                            100;
                          abonos_grales =
                            parseFloat(abonos_grales) +
                            parseFloat(abono_a_moneda);
                          console.log(
                            "abonos_grales",
                            cargoabonos_graless_grales
                          );
                        }
                      }
                      if (argument.calculo == 2) {
                        //Cargo
                        if (argument.tipo_calculo == 2) {
                          //%cada recibo, $ al final
                          var cargo_a_moneda =
                            (parseFloat(argument.cantidad) *
                              parseFloat(comision_ref)) /
                            100;
                          cargos_grales =
                            parseFloat(cargos_grales) +
                            parseFloat(cargo_a_moneda);
                          console.log("cargos_grales", cargos_grales);
                        }
                      }
                    } else {
                      console.log("no aplica el concepto", argument.concepto);
                    }
                  } //recibo dentro del estado
                }
              });
            });
          }
          if (argument.calculo == 1) {
            //Abono
            if (argument.tipo_calculo == 1) {
              //$
              abonos_pesos = abonos_pesos + parseFloat(argument.cantidad);
            }
          }
          if (argument.calculo == 2) {
            //Abono
            if (argument.tipo_calculo == 1) {
              //$
              cargos_pesos = cargos_pesos + parseFloat(argument.cantidad);
            }
          }
        }
      });
      if (cargos_pesos || abonos_pesos || abonos_grales || cargos_grales) {
        var subTotalFinalc =
          parseFloat(originalCalculos.subtotal_1) +
          parseFloat(abonos_grales) +
          parseFloat(abonos_pesos);
        var subTotalFinal =
          parseFloat(subTotalFinalc) -
          (parseFloat(cargos_grales) + parseFloat(cargos_pesos));
        $scope.subtotal_1_1 = subTotalFinal;
        var go =
          parseFloat($scope.subtotal_1_1) *
          (parseFloat(vend1.vendedor_go) / 100);
        vend1.go_final = go;
        $scope.total_final_1 =
          parseFloat(subTotalFinal) - parseFloat(vend1.go_final);
        vend1.total_abonos_grales =
          parseFloat(abonos_grales) + parseFloat(abonos_pesos);
        vend1.total_cargos_grales =
          parseFloat(cargos_grales) + parseFloat(cargos_pesos);
        vend1.totalFinal_edo = subTotalFinal;
      }
      if ($scope.aplicarGral == false) {
        var subTotalFinalc = parseFloat(originalCalculos.subtotal_1);
        var subTotalFinal = parseFloat(subTotalFinalc);
        $scope.subtotal_1_1 = subTotalFinal;
        var go =
          parseFloat($scope.subtotal_1_1) *
          (parseFloat(vend1.vendedor_go) / 100);
        vend1.go_final = go;
        $scope.total_final_1 =
          parseFloat(subTotalFinal) - parseFloat(vend1.go_final);
        vend1.total_abonos_grales =
          parseFloat(abonos_grales) + parseFloat(abonos_pesos);
        vend1.total_cargos_grales =
          parseFloat(cargos_grales) + parseFloat(cargos_pesos);
        vend1.totalFinal_edo = subTotalFinal;
      }
    };
    // ---------------------------------------------
    $scope.shareState = function (state) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/agentes/pago.enviarMail.html",
        controller: assignModalView,
        controllerAs: "vmm",
        ////windowClass: 'animated fadeIn',
        size: "lg",
        // resolve:{'rn':receipt.recibo_numero,'recibo':receipt},
        resolve: {
          state: function () {
            return state;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    function assignModalView(
      $scope,
      $uibModalInstance,
      state,
      url,
      toaster,
      MESSAGES,
      FileUploader,
      $sessionStorage
    ) {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.adjFiles = false;
      $scope.stateaccount = state;
      $scope.email_assigns = state.vendedor.email;
      $scope.emails = [];

      function validateEmail(email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
      $scope.addEmail = function (email) {
        if (validateEmail(email) == false) {
          toaster.error(MESSAGES.ERROR.INVALIDEMAIL);
          return;
        } else {
          $scope.emails.push(email);
          $scope.email_assigns = "";
        }
      };
      $scope.adjFilesOK = function (val) {
        $scope.adjFiles = val;
        $http
          .get(url.IP + "estado-cuenta/" + state.id + "/archivos/")
          .then(function (response) {
            if (response.status === 200) {
              vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.files.forEach(function (file) {
                file["to_send"] = false;
              });
              $scope.show_files_policy = true;
            }
          });
      };
      /** Uploader files **/
      $scope.userInfo = {
        id: 0,
      };
      $scope.countFile = 0;
      $scope.okFile = 0;

      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });

        if (fileItem) {
          $scope.countFile++;
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        if (item.file.sensible != undefined) {
          item.formData[0].sensible = item.file.sensible;
        }
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
      };

      vm.uploadFiles = uploadFiles;
      function uploadFiles(reciboId) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.userInfo = {
          id: reciboId,
        };
        $scope.uploadOk = false;
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
        $scope.uploader.queue.forEach(function (ch, index) {
          var str = ch.file.name;
          var regex = /[^\w\s]/gi;
          for (i = 0; i < specialChars.length; i++) {
            if (str.indexOf(specialChars[i]) > -1) {
              $scope.uploadOk = true;
              SweetAlert.swal(
                "Error",
                "El nombre de archivo: " +
                  str +
                  ", contiene carácteres especiales, renombre y, vuelva a cargarlo. " +
                  specialChars[i],
                "error"
              );
              $scope.uploader.queue.splice(
                $scope.uploader.queue.indexOf(ch),
                1
              );
              return;
            } else {
              $scope.uploadOk = true;
            }
          }
        });
        if ($scope.uploadOk) {
          $scope.userInfo.url = $scope.uploader.url =
            url.IP + "estado-cuenta/" + reciboId + "/archivos/";
          $scope.files = [];
          $scope.uploader.queue = [];
        }

        $timeout(function () {
          $scope.uploader.uploadAll();
          // $scope.adjFiles = false
        }, 1000);
      }
      $scope.noFiles = false;
      $scope.saveFiles = function (id) {
        $scope.id_recibo = id;
        $scope.userInfo.id = $scope.stateaccount.id;
        $scope.uploadOk = true;
        if ($scope.uploadOk) {
          $scope.userInfo.url = $scope.uploader.url =
            url.IP + "estado-cuenta/" + id + "/archivos/";
          $scope.uploader.uploadAll();
          // $scope.adjFiles = false
        }
        $http
          .get(url.IP + "estado-cuenta/" + id + "/archivos/")
          .then(function (response) {
            if (response.status === 200) {
              vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.files.forEach(function (file) {
                file["to_send"] = false;
              });
              $scope.noFiles = true;
            }
          });
      };
      $scope.shareFileEmail = function (file) {
        if (file.to_send) {
          file.to_send = false;
        } else {
          file.to_send = true;
        }
        $scope.share_via_email = [];
        $scope.files.forEach(function (filex) {
          if (filex.to_send) {
            $scope.share_via_email.push(filex.id);
          }
        });
      };
      $scope.sendEmail = function (subject, message) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if ($scope.emails.length > 0) {
          $http
            .post(url.IP + "send-email-vendor-state/", {
              pdf_name: "pdf",
              id: state.id,
              emails: $scope.emails,
              subject: subject,
              message: message,
              files: $scope.share_via_email,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  toaster.success("El estado de cuenta ha sido enviado");
                  $uibModalInstance.dismiss("cancel");
                } else {
                  toaster.warning(
                    "No se envió el estado de cuenta. Contacte a su administrador."
                  );
                  l.stop();
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          toaster.warning(MESSAGES.WARNING.EMPTYEMAIL);
          l.stop();
        }
      };
      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.generarPdf = function (estado) {
      dataFactory
        .get("get-pdf-agentes/" + "?id_estado=" + estado.id + "&")
        .then(function (response) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
        });
    };
    $scope.returnToVendedor = function (vendedor) {
      vendedor.show_binnacle = false;
    };
    $scope.edosCuentas = function (vendedor) {
      var params = {
        vendedor: vendedor.id,
      };
      $http({
        method: "POST",
        // url: url.IP+'edos-cuenta-by-referenciador/',
        url: url.IP + "service_reporte-vendedorEdoCuenta-excel",
        data: params,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function (data, status, headers, config) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Edos_cuenta_Recibos.xls");
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };
    $scope.format_currency = function (parValue) {
      if (parValue) {
        parValue = parValue.toString();
        if (
          parValue.search(/[A-Za-z]/g) > -1 ||
          parValue.search(/[0-9]%/g) > -1
        ) {
          return parValue;
        } else {
          var num = parseFloat(parValue);
          var num_format =
            "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
          return num_format;
        }
      }
    };

    function is_json(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
    function isEmptyObject(obj) {
      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          return false;
        }
      }

      return true;
    }
    $scope.validateDecimal = function (input) {
      if (input) {
        if (parseFloat(input) < 0) {
          $scope.$filternewConcept.value = 0;
        } else {
          $scope.newConcept.value = parseFloat(input.toFixed(2));
        }
      }
    };
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }
      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;
            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );
            if (next_.search("&referenciador=") !== -1) {
              var status = next_.substring(
                next_.indexOf("&referenciador=") + 1
              );
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&referenciador=") !== -1) {
              var status = prev_.substring(
                prev_.indexOf("&referenciador=") + 1
              );
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params + "&";
            }
          }
        }

        // url += '&referenciador=1
        getSinisterPag(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };
      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;
        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getSinisterPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }
    // detalle recibos modal
    function PagoAgentesModalCtrl(
      $scope,
      $state,
      FileUploader,
      $sessionStorage,
      $uibModalInstance,
      payModal
    ) {
      $scope.pay = [];
      if (payModal) {
        $scope.inputDisabled = true;
        $scope.pay.referenciador = payModal.referenciador;
        $scope.pay.fecha = payModal.fecha;
        $scope.pay.banco = payModal.banco;
        $scope.pay.num_cuenta = payModal.num_cuenta;
        $scope.pay.num_transaccion = payModal.num_transaccion;
        $scope.pay.importe = payModal.importe;
      } else {
        $scope.inputDisabled = false;
        $scope.pay.fecha = new Date();
      }

      $scope.convertDate = function (inputFormat) {
        function inputDate(days) {
          return days < 10 ? "0" + days : days;
        }
        var dateFormat = new Date(inputFormat);
        var date = [
          inputDate(dateFormat.getDate()),
          inputDate(dateFormat.getMonth() + 1),
          dateFormat.getFullYear(),
        ].join("/");
        return date;
      };

      $scope.demo = function (param) {
        var model = formatValues.currency(param);
        return model;
      };

      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var token = JSON.parse(decryptedToken);
      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        $rootScope.show_contractor = false;
        toaster.success(MESSAGES.OK.NEWCONTRACTOR);
      };
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        toaster.error(MESSAGES.ERROR.ERRORONUPLOADFILES);
      };

      uploader.onAfterAddingFile = function (fileItem) {
        $scope.array_files = true;
        $scope.specialchar = [];
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
        var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        var str = fileItem.file.name;
        for (i = 0; i < specialChars.length; i++) {
          if (str.indexOf(specialChars[i]) > -1) {
            if (
              specialChars[i] == " " ||
              specialChars[i] == "_" ||
              specialChars[i] == "~" ||
              specialChars[i] == "%" ||
              specialChars[i] == "=" ||
              specialChars[i] == "-" ||
              specialChars[i] == " " ||
              specialChars[i] == "_" ||
              specialChars[i] == "#" ||
              specialChars[i] == "(" ||
              specialChars[i] == ")" ||
              specialChars[i] == ":" ||
              specialChars[i] == '"'
            ) {
              str = str.replace(/-/g, "");
              fileItem.file.name = fileItem.file.name.replace(/-/g, "");
              str = str.replace(/ /g, "");
              fileItem.file.name = fileItem.file.name.replace(/ /g, "");
              str = str.replace(/_/g, "");
              fileItem.file.name = fileItem.file.name.replace(/_/g, "");
              str = str.replace(/#/g, "");
              fileItem.file.name = fileItem.file.name.replace(/#/g, "");
              str = str.split(")").join("");
              fileItem.file.name = fileItem.file.name.split(")").join("");
              str = str.split("(").join("");
              fileItem.file.name = fileItem.file.name.split("(").join("");
              str = str.split(":").join("");
              fileItem.file.name = fileItem.file.name.split(":").join("");
              str = str.split('"').join("");
              fileItem.file.name = fileItem.file.name.split('"').join("");
              str = str.split("+").join("");
              fileItem.file.name = fileItem.file.name.split("+").join("");
              str = str.split("$").join("");
              fileItem.file.name = fileItem.file.name.split("$").join("");
              str = str.split("#").join("");
              fileItem.file.name = fileItem.file.name.split("#").join("");
              str = str.split("$#").join("");
              fileItem.file.name = fileItem.file.name.split("$#").join("");
              str = str.split("~").join("");
              fileItem.file.name = fileItem.file.name.split("~").join("");
              str = str.split("%").join("");
              fileItem.file.name = fileItem.file.name.split("%").join("");
              str = str.split("=").join("");
              fileItem.file.name = fileItem.file.name.split("=").join("");
              str = str.split("_").join("");
              fileItem.file.name = fileItem.file.name.split("_").join("");
              str = str.split(" ").join("");
              fileItem.file.name = fileItem.file.name.split(" ").join("");
            } else {
              $scope.specialchar.push(specialChars[i]);
            }
          }
        }
        fileItem.file.name = fileItem.file.name
          .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
          .replace(/ /g, "");
        fileItem.file.name = fileItem.file.name.trim();
        fileItem.formData.push({
          arch: fileItem._file,
          nombre: fileItem.file.name,
        });
        if ($scope.specialchar.length > 0) {
          $scope.uploader.queue.splice(
            $scope.uploader.queue.indexOf(fileItem),
            1
          );
          SweetAlert.swal(
            "Error",
            "El nombre de archivo: " +
              str +
              ", contiene carácteres especiales: " +
              $scope.specialchar,
            "error"
          );
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
      };
      $(".datepicker-me input").datepicker();
      $.fn.datepicker.defaults.format = "dd/mm/yyyy";
      $.fn.datepicker.defaults.startView = 2;
      $.fn.datepicker.defaults.autoclose = true;
      $.fn.datepicker.defaults.language = "es";
    }
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("PagoAgentesDetalleController", PagoAgentesDetalleController);

  PagoAgentesDetalleController.$inject = [
    "$rootScope",
    "toaster",
    "$q",
    "$stateParams",
    "$scope",
    "providerService",
    "groupService",
    "$http",
    "url",
    "$state",
    "$uibModal",
    "dataFactory",
    "MESSAGES",
    "datesFactory",
    "$localStorage",
  ];

  function PagoAgentesDetalleController(
    $rootScope,
    toaster,
    $q,
    $stateParams,
    $scope,
    providerService,
    groupService,
    $http,
    url,
    $state,
    $uibModal,
    dataFactory,
    MESSAGES,
    datesFactory,
    $localStorage
  ) {
    var vm = this;

    $scope.showTableReceipts = false;
    $scope.showInformation = false;
    $scope.hideInformation = true;
    $scope.showPayRecipt = false;
    $scope.folio = "";
    $scope.providers = [];
    $scope.claves = [];
    $scope.ramos = [];
    $scope.subramos = [];
    $scope.groups = [];
    $scope.provider = 0;
    $scope.ramo = 0;
    $scope.subramo = 0;
    $scope.grupo = 0;
    $scope.clave = 0;
    $scope.vendor_selected = { value: 0 };
    $scope.main_estados = [];
    vm.files = [];

    active();

    function active() {
      $scope.present_in_edo = false;
      dataFactory
        .get("estado-cuenta/" + $stateParams.folioId)
        .then(function (response) {
          $scope.current_state = response.data;
          $scope.current_state.subtotal_1 = 0;
          if ($scope.current_state.date) {
            $scope.current_state.date = $scope.convertDate(
              $scope.current_state.date
            );
          }
          $scope.num_edos_receipt = 0;
          if ($scope.current_state.account_state_receipts.length > 0) {
            $scope.current_state.account_state_receipts.forEach(function (
              rec,
              idx
            ) {
              if (rec.poliza) {
                if (rec.poliza.ref_policy) {
                  rec.poliza.ref_policy.forEach(function (ref, index) {
                    if (
                      ref.referenciador.id == $scope.current_state.vendedor.id
                    ) {
                      rec.comision_vendedor = parseFloat(
                        ref.comision_vendedor
                      ).toFixed(2);
                      $scope.current_state.subtotal_1 =
                        parseFloat($scope.current_state.subtotal_1) +
                        parseFloat(
                          $scope.calculateCommission(
                            parseFloat(rec.comision_conciliada),
                            parseFloat(rec.comision_vendedor),
                            rec.cambiar_comision_al_vendedor,
                            rec.comision_al_vendedor
                          )
                        );
                    }
                  });
                }
              } else {
                $scope.current_state.subtotal_1 =
                  parseFloat($scope.current_state.subtotal_1) +
                  parseFloat(
                    $scope.calculateCommission(
                      rec.comision_conciliada,
                      rec.comision_vendedor,
                      rec.cambiar_comision_al_vendedor,
                      rec.comision_al_vendedor
                    )
                  );
              }
            });
          } else {
          }
          try {
            $scope.current_state.concepts = $scope.current_state.concepts
              .split("'")
              .join('"');
            $scope.current_state.concepts = $scope.current_state.concepts
              .split("None")
              .join('""');
            if (typeof $scope.current_state.concepts == "string") {
              $scope.current_state.concepts = JSON.parse(
                $scope.current_state.concepts
              );
            }
          } catch (ee) {
            console.log("-errror---", ee, $scope.current_state.concepts);
          }
        });
    }

    $scope.convertDate = function (inputFormat) {
      function inputDate(days) {
        return days < 10 ? "0" + days : days;
      }
      var dateFormat = new Date(inputFormat);
      var date = [
        inputDate(dateFormat.getDate()),
        inputDate(dateFormat.getMonth() + 1),
        dateFormat.getFullYear(),
      ].join("/");
      return date;
    };

    $scope.returnToTable = function () {
      $scope.show_detail = false;
    };

    $scope.hideAllInformation = function () {
      $scope.showInformation = false;
      $scope.hideInformation = true;
    };

    $scope.goToReject = function (current_state) {
      var files_ = current_state.estado_cuenta_files;

      if (current_state) {
        $scope.paymentsData = current_state;
        var modalInstance = $uibModal.open({
          templateUrl: "app/agentes/pago.reject.html",
          controller: PagoAgentesModalCtrl,
          controllerAs: "vm",
          size: "lg",
          resolve: {
            payModal: function () {
              return $scope.paymentsData;
            },
            files: function () {
              return files_;
            },
            // vm:function() {
            //     return vm
            // }
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
      }
    };

    $scope.calculateCommission = function (
      prima,
      comision,
      cambiar_comision_al_vendedor,
      comision_al_vendedor
    ) {
      if (cambiar_comision_al_vendedor) {
        return comision_al_vendedor;
      }
      comision = parseFloat(comision);
      prima = parseFloat(prima);
      if (comision >= 0) {
        return (prima * (comision / 100.0)).toFixed(2);
      } else {
        return 0;
      }
    };

    $scope.goToPay = function (current_state, value) {
      var files_ = current_state.estado_cuenta_files;
      try {
        if (value == 1) {
          files_[0].detalle = true;
        } else {
          files_[0].detalle = false;
        }
      } catch (e) {}

      if (current_state) {
        $scope.paymentsData = current_state;
        var modalInstance = $uibModal.open({
          templateUrl: "app/agentes/pago.pagare.html",
          controller: PagoAgentesModalCtrl,
          controllerAs: "vm",
          size: "lg",
          resolve: {
            payModal: function () {
              return $scope.paymentsData;
            },
            files: function () {
              return files_;
            },
          },
          backdrop:
            "static" /* this prevent user interaction with the background */,
          keyboard: false,
        });
      }
    };

    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    /*Controlador del modal*/

    function PagoAgentesModalCtrl(
      $rootScope,
      toaster,
      $scope,
      $state,
      FileUploader,
      $sessionStorage,
      $uibModalInstance,
      payModal,
      $q,
      files,
      $localStorage
    ) {
      var vm = this;
      vm.files = files;
      $scope.present_in_edo = false;
      $scope.convertDate = function (inputFormat) {
        function inputDate(days) {
          return days < 10 ? "0" + days : days;
        }
        var dateFormat = new Date(inputFormat);
        var date = [
          inputDate(dateFormat.getDate()),
          inputDate(dateFormat.getMonth() + 1),
          dateFormat.getFullYear(),
        ].join("/");
        return date;
      };
      function convertDate(inputFormat, indicator) {
        function pad(s) {
          return s < 10 ? "0" + s : s;
        }
        var d = new Date(inputFormat);
        // var date = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
        // return date;
        var date = inputFormat;
        if (inputFormat.length != 10) {
          function pad(s) {
            return s < 10 ? "0" + s : s;
          }
          var d = new Date(inputFormat);
          if (indicator) {
            date = [
              pad(d.getDate() + 1),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          } else {
            date = [
              pad(d.getDate()),
              pad(d.getMonth() + 1),
              d.getFullYear(),
            ].join("/");
          }
        }
        return date;
      }
      $scope.pay = [];
      if (payModal) {
        $scope.inputDisabled = false;
        $scope.pay.referenciador = payModal.vendedor.name;
        if (payModal.date) {
          $scope.pay.fecha = convertDate(new Date())
            ? convertDate(payModal.date)
            : $scope.convertDate(new Date());
        } else {
          $scope.pay.fecha = $scope.convertDate(new Date());
        }
        $scope.pay.banco = payModal.vendedor.bank;
        $scope.pay.num_cuenta = payModal.vendedor.reference_number;
        $scope.pay.num_transaccion = payModal.transaction_number;
        $scope.pay.importe = payModal.total
          ? parseFloat(payModal.total).toFixed(2)
          : 0.0;
        ($scope.pay.status = payModal.status),
          ($scope.pay.info_recibos = payModal.info_recibos),
          ($scope.pay.info_recibos_account = payModal.info_recibos_account),
          ($scope.pay.observation = payModal.observation);
        $scope.pay.importe = parseFloat($scope.pay.importe).toFixed(2);
      } else {
        $scope.inputDisabled = false;
        // $scope.pay.fecha = $scope.convertDate(new Date());
        $scope.pay.fecha = new Date();
        $scope.pay.importe;
      }

      try {
        if (vm.files[0].detalle) {
          $scope.inputDisabled = true;
        }
      } catch (e) {}

      $scope.closePopup = function () {
        $uibModalInstance.dismiss("cancel");
      };
      $scope.validateCantidad = function (item) {
        if (item) {
          if (parseFloat(item) < 0) {
            $scope.pay.importe = 0;
          } else {
            $scope.pay.importe = parseFloat($scope.pay.importe).toFixed(2);
            $scope.pay.importe = parseFloat($scope.pay.importe);
          }
        }
      };
      $scope.uploadFiles = function (ec_id) {
        $scope.userInfo = {
          id: ec_id,
        };

        $scope.userInfo.url = $scope.uploader.url =
          url.IP + "estado-cuenta/" + ec_id + "/archivos/";

        $q.when()
          .then(function () {
            var defer = $q.defer();
            defer.resolve($scope.uploader.uploadAll());
            return defer.promise;
          })
          .then(function () {
            toaster.success("Se han subido sus archivos correctamente");
          });
      };
      $scope.stringToNumber = function (value) {
        return parseFloat(value);
      };
      $scope.patchState = function (status) {
        if (status == 3 || status == 2) {
          $http
            .patch(payModal.url, {
              observation: $scope.pay.observation,
              date: $scope.pay.fecha
                ? datesFactory.toDate($scope.pay.fecha)
                : new Date(),
            })
            .then(function success(response) {
              if (response.status == 200 || response.status == 201) {
                $scope.uploadFiles(payModal.id);
              }
            });
          $scope.closePopup();
          $state.go("agentes.agentes");
          return;
        }
        $http
          .patch(payModal.url, {
            transaction_number: $scope.pay.num_transaccion,
            status: 3,
            observation: $scope.pay.observation,
            total: $scope.pay.importe
              ? parseFloat($scope.pay.importe).toFixed(2)
              : 0,
            date: $scope.pay.fecha
              ? datesFactory.toDate($scope.pay.fecha)
              : new Date(),
          })
          .then(function succes(response) {
            if (response.status == 200 || response.status == 201) {
              $scope.uploadFiles(payModal.id);
              if (payModal.account_state_receipt) {
                if (payModal.account_state_receipt.length > 0) {
                  $scope.num_edos_receipt = 0;
                  $scope.accRecibos = [];
                  payModal.account_state_receipt.forEach(function (rec, index) {
                    var p = {
                      status: 3,
                    };
                    dataFactory
                      .post("estado-cuenta-table-info/", p)
                      .then(function (datos) {
                        if (datos.data.results.length > 0) {
                          datos.data.results.forEach(function (rec_t, idx) {
                            if (payModal.id != rec_t.id) {
                              // rec_t.account_state_receipt.forEach(function(oedo,idx){
                              //     console.log('c--------c--------h-------',oedo,oedo.id,rec.id)
                              //     if (oedo.poliza) {
                              //             if (oedo.id == rec.id) {
                              //                 $scope.present_in_edo = true;
                              //                 $scope.accRecibos.push(oedo);
                              //                 $scope.num_edos_receipt = $scope.num_edos_receipt + 1
                              //                 console.log('cccccccccuuuy---',$scope.present_in_edo,$scope.accRecibos)
                              //             }
                              //             console.log('uuuuuuuy---',$scope.present_in_edo,$scope.accRecibos)
                              //             console.log('uuuuuu-.hf.,hgf.,h',$scope.num_edos_receipt)
                              //             $scope.refPolicy = oedo.poliza.ref_policy;
                              //             $scope.recAccount = rec;
                              //             // if (oedo.poliza.ref_policy.length == ($scope.num_edos_receipt + 1)) {
                              //             //     // Patch con sttaus 7 y vendedor cerrado 2
                              //             //     $http.patch(rec.url,
                              //             //     {
                              //             //         'status' : 7,
                              //             //         'vendedor_cerrado_new':2
                              //             //     });
                              //             //     console.log('---21------CERRADO_____',rec)
                              //             //     $state.go('agentes.agentes')
                              //             // }
                              //             // else{
                              //             //     $http.patch(rec.url,
                              //             //     {
                              //             //         'status' : rec.status,
                              //             //         'vendedor_cerrado_new':1
                              //             //     });
                              //             //     console.log('---2----n--CERRADO_____',rec)
                              //             //     $state.go('agentes.agentes')
                              //             // }
                              //         // }
                              //     }
                              //     // else{
                              //     //     // Cambiar normal
                              //     //     $http.patch(rec.url,
                              //     //     {
                              //     //         'status' : 7,
                              //     //         'vendedor_cerrado_new':1
                              //     //     });
                              //     //     console.log('-22---n-----CERRADO_____',rec)
                              //     //     $state.go('agentes.agentes')
                              //     // }
                              // })
                              rec_t.account_state_receipts.forEach(function (
                                oedo,
                                idx
                              ) {
                                if (oedo.poliza) {
                                  if (oedo.id == rec.id) {
                                    $scope.present_in_edo = true;
                                    $scope.accRecibos.push(oedo);
                                    $scope.num_edos_receipt =
                                      $scope.num_edos_receipt + 1;
                                  }

                                  $scope.refPolicy = oedo.poliza.ref_policy;
                                  $scope.recAccount = rec;
                                }
                              });
                            }
                            // else{
                            //     $http.patch(rec.url,
                            //     {
                            //         'status' : rec.status,
                            //         'vendedor_cerrado_new':1
                            //     });
                            //     $state.go('agentes.agentes')
                            // }
                          });
                        }
                        // else{
                        //   // payModal.account_state_receipt.forEach(function(recibo) {
                        //       $http.patch(rec.url,
                        //       {
                        //           'status' : rec.status,
                        //           'vendedor_cerrado_new':1
                        //       });
                        //       $state.go('agentes.agentes')
                        //   // })
                        // }
                        if (
                          $scope.refPolicy.length ==
                          $scope.num_edos_receipt + 1
                        ) {
                          $http.patch($scope.recAccount.url, {
                            status: $localStorage.email_config.cerrar_recibos
                              ? 7
                              : 6,
                            vendedor_cerrado_new: 2,
                          });
                        } else if ($scope.recAccount.fianza) {
                          $http.patch($scope.recAccount.url, {
                            status: $localStorage.email_config.cerrar_recibos
                              ? 7
                              : 6,
                            vendedor_cerrado_new: 2,
                          });
                        } else {
                          $http.patch($scope.recAccount.url, {
                            status: 6,
                            vendedor_cerrado_new: 1,
                          });
                        }
                      });
                  });
                }
              } else if (payModal.account_state_receipts.length > 0) {
                $scope.num_edos_receipt = 0;
                $scope.accRecibos = [];
                payModal.account_state_receipts.forEach(function (rec, index) {
                  var p = {
                    status: 3,
                  };
                  dataFactory
                    .post("estado-cuenta-table-info/", p)
                    .then(function (datos) {
                      if (datos.data.results.length > 0) {
                        datos.data.results.forEach(function (rec_t, idx) {
                          if (payModal.id != rec_t.id) {
                            // if (rec_t.account_state_receipt.length > 0) {
                            //     rec_t.account_state_receipt.forEach(function(oedo,idx){
                            //         $scope.recAccount = rec;
                            //         if (oedo.id == rec.id) {
                            //             $scope.present_in_edo = true;
                            //             $scope.num_edos_receipt = $scope.num_edos_receipt + 1
                            //             console.log('cccccccccuuuy-eeeeee--',$scope.present_in_edo,$scope.accRecibos)
                            //         }
                            //         console.log('uuuuuuuy--eeeeeee-',$scope.present_in_edo,$scope.accRecibos)
                            //         if (oedo.poliza) {
                            //             $scope.refPolicy = oedo.poliza.ref_policy;
                            //             if (rec_t.vendedor.id != payModal.vendedor.id) {
                            //                 if (oedo.id == rec.id) {
                            //                     $scope.present_in_edo = true;
                            //                     $scope.num_edos_receipt = $scope.num_edos_receipt + 1
                            //                 }else{
                            //                 }
                            //             }
                            //             if (oedo.poliza.ref_policy.length == ($scope.num_edos_receipt + 1)) {
                            //                 $scope.recAccount = rec;
                            //                 $scope.refPolicy = oedo.poliza.ref_policy;
                            //                 // Patch con sttaus 7 y vendedor cerrado 2
                            //                 // $http.patch(rec.url,
                            //                 // {
                            //                 //     'status' : 7,
                            //                 //     'vendedor_cerrado_new':2
                            //                 // });
                            //                 // console.log('---3------CERRADO_____',rec)
                            //                 // $state.go('agentes.agentes');
                            //             }else{
                            //                 // $http.patch(rec.url,
                            //                 // {
                            //                 //     'status' : rec.status,
                            //                 //     'vendedor_cerrado_new':1
                            //                 // });
                            //                 // console.log('-----2w----CERRADO_____',rec)
                            //                 // $state.go('agentes.agentes');
                            //             }
                            //         }
                            //         // else{
                            //         //     $http.patch(rec.url,
                            //         //     {
                            //         //         'status' : 7,
                            //         //         'vendedor_cerrado_new':2
                            //         //     });
                            //         //     console.log('-----2----CERRADO_____',rec)
                            //         //     $state.go('agentes.agentes');
                            //         //     // Cambiar normal
                            //         // }
                            //     })
                            // }else if (rec_t.account_state_receipts.length > 0) {
                            //     rec_t.account_state_receipts.forEach(function(oedo2,idx){
                            //         if (oedo2.poliza) {
                            //             // if (rec_t.vendedor.id != payModal.vendedor.id) {
                            //                 if (oedo2.id == rec.id) {
                            //                     $scope.present_in_edo = true;
                            //                     $scope.num_edos_receipt = $scope.num_edos_receipt + 1

                            //                 }else{
                            //                 }
                            //                 if (oedo2.poliza.ref_policy.length == ($scope.num_edos_receipt + 1)) {
                            //                     $scope.recAccount = rec;
                            //                     $scope.refPolicy = oedo2.poliza.ref_policy;
                            //                 // Patch con sttaus 7 y vendedor cerrado 2
                            //                 // $http.patch(rec.url,
                            //                 // {
                            //                 //     'status' : 7,
                            //                 //     'vendedor_cerrado_new':2
                            //                 // });

                            //                 // console.log('-----4----CERRADO_____',rec)
                            //                 // $state.go('agentes.agentes');
                            //             }else{
                            //                 // $http.patch(rec.url,
                            //                 // {
                            //                 //     'status' : rec.status,
                            //                 //     'vendedor_cerrado_new':1
                            //                 // });

                            //                 // console.log('-------33--CERRADO_____',rec)
                            //                 // $state.go('agentes.agentes');
                            //             }
                            //         }
                            //         // else{
                            //             // Cambiar normal
                            //         //     $http.patch(rec.url,
                            //         //     {
                            //         //         'status' : 7,
                            //         //         'vendedor_cerrado_new':2
                            //         //     });
                            //         //     console.log('---442------CERRADO_____',rec)
                            //         //     $state.go('agentes.agentes');
                            //         // }
                            //     })
                            // }
                            rec_t.account_state_receipts.forEach(function (
                              oedo,
                              idx
                            ) {
                              if (oedo.poliza) {
                                if (oedo.id == rec.id) {
                                  $scope.present_in_edo = true;
                                  $scope.accRecibos.push(oedo);
                                  $scope.num_edos_receipt =
                                    $scope.num_edos_receipt + 1;
                                }
                                $scope.refPolicy = oedo.poliza.ref_policy;
                                $scope.recAccount = rec;
                              }
                            });
                          } else {
                          }
                        });
                      } else {
                      }
                      if (
                        $scope.refPolicy.length ==
                        $scope.num_edos_receipt + 1
                      ) {
                        $http.patch($scope.recAccount.url, {
                          status: $localStorage.email_config.cerrar_recibos
                            ? 7
                            : 6,
                          vendedor_cerrado_new: 2,
                        });
                      } else if ($scope.recAccount.fianza) {
                        $http.patch($scope.recAccount.url, {
                          status: $localStorage.email_config.cerrar_recibos
                            ? 7
                            : 6,
                          vendedor_cerrado_new: 2,
                        });
                      } else {
                        $http.patch($scope.recAccount.url, {
                          status: 6,
                          vendedor_cerrado_new: 1,
                        });
                      }
                    });
                });
              }
              // payModal.account_state_receipt.forEach(function(recibo) {
              //     $http.patch(recibo.url,
              //     {
              //         'status' : 7,
              //         'vendedor_cerrado':1
              //     });
              // })
            }
          });
        $scope.closePopup();
        $state.go("agentes.agentes");
      };

      $scope.patchReject = function () {
        $http
          .patch(payModal.url, {
            reason_reject: $scope.pay.reason_reject,
            status: 2,
            date: $scope.pay.fecha
              ? datesFactory.toDate($scope.pay.fecha)
              : new Date(),
          })
          .then(function success(response) {
            if (response.status == 200 || response.status == 201) {
              $http
                .post(url.IP + "reset-receipts-accountstate/", {
                  account: payModal.id,
                })
                .then(function (response) {
                  if (response.status == 200) {
                    $scope.uploadFiles(payModal.id);
                    $scope.closePopup();
                    $state.go("agentes.agentes");
                  }
                });
            }
          });
      };

      $scope.demo = function (param) {
        var model = formatValues.currency(param);
        return model;
      };

      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var token = JSON.parse(decryptedToken);

      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      // 	name: 'customFilter',
      // 	fn: function(item, options){
      // 		return this.queue.length < 20;
      // 	}
      // });

      // ALERTA SUCCES UPLOADFILES --aqui
      uploader.onSuccessItem = function (
        fileItem,
        response,
        status,
        headers
      ) {};

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        toaster.error(MESSAGES.ERROR.ERRORONUPLOADFILES);
      };

      uploader.onAfterAddingFile = function (fileItem) {
        $scope.array_files = true;
        $scope.specialchar = [];
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
        var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

        var str = fileItem.file.name;
        for (i = 0; i < specialChars.length; i++) {
          if (str.indexOf(specialChars[i]) > -1) {
            if (
              specialChars[i] == " " ||
              specialChars[i] == "_" ||
              specialChars[i] == "~" ||
              specialChars[i] == "%" ||
              specialChars[i] == "=" ||
              specialChars[i] == "-" ||
              specialChars[i] == " " ||
              specialChars[i] == "_" ||
              specialChars[i] == "#" ||
              specialChars[i] == "(" ||
              specialChars[i] == ")" ||
              specialChars[i] == ":" ||
              specialChars[i] == '"'
            ) {
              str = str.replace(/-/g, "");
              fileItem.file.name = fileItem.file.name.replace(/-/g, "");
              str = str.replace(/ /g, "");
              fileItem.file.name = fileItem.file.name.replace(/ /g, "");
              str = str.replace(/_/g, "");
              fileItem.file.name = fileItem.file.name.replace(/_/g, "");
              str = str.replace(/#/g, "");
              fileItem.file.name = fileItem.file.name.replace(/#/g, "");
              str = str.split(")").join("");
              fileItem.file.name = fileItem.file.name.split(")").join("");
              str = str.split("(").join("");
              fileItem.file.name = fileItem.file.name.split("(").join("");
              str = str.split(":").join("");
              fileItem.file.name = fileItem.file.name.split(":").join("");
              str = str.split('"').join("");
              fileItem.file.name = fileItem.file.name.split('"').join("");
              str = str.split("+").join("");
              fileItem.file.name = fileItem.file.name.split("+").join("");
              str = str.split("$").join("");
              fileItem.file.name = fileItem.file.name.split("$").join("");
              str = str.split("#").join("");
              fileItem.file.name = fileItem.file.name.split("#").join("");
              str = str.split("$#").join("");
              fileItem.file.name = fileItem.file.name.split("$#").join("");
              str = str.split("~").join("");
              fileItem.file.name = fileItem.file.name.split("~").join("");
              str = str.split("%").join("");
              fileItem.file.name = fileItem.file.name.split("%").join("");
              str = str.split("=").join("");
              fileItem.file.name = fileItem.file.name.split("=").join("");
              str = str.split("_").join("");
              fileItem.file.name = fileItem.file.name.split("_").join("");
              str = str.split(" ").join("");
              fileItem.file.name = fileItem.file.name.split(" ").join("");
            } else {
              $scope.specialchar.push(specialChars[i]);
            }
          }
        }
        fileItem.file.name = fileItem.file.name
          .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
          .replace(/ /g, "");
        fileItem.file.name = fileItem.file.name.trim();
        fileItem.formData.push({
          arch: fileItem._file,
          nombre: fileItem.file.name,
        });
        if ($scope.specialchar.length > 0) {
          $scope.uploader.queue.splice(
            $scope.uploader.queue.indexOf(fileItem),
            1
          );
          toaster.error(
            "El nombre de archivo: " +
              str +
              ", contiene carácteres especiales: " +
              $scope.specialchar
          );
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
      };

      $(".datepicker-me input").datepicker();
      $.fn.datepicker.defaults.format = "dd/mm/yyyy";
      $.fn.datepicker.defaults.startView = 2;
      $.fn.datepicker.defaults.autoclose = true;
      $.fn.datepicker.defaults.language = "es";
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("PagoAgentesController", PagoAgentesController);

  PagoAgentesController.$inject = [
    "$parse",
    "$scope",
    "providerService",
    "groupService",
    "$http",
    "url",
    "exportFactory",
    "$state",
    "$uibModal",
    "dataFactory",
    "SweetAlert",
    "MESSAGES",
    "toaster",
    "$rootScope",
    "$stateParams",
    "$sce",
    "$sessionStorage",
    "$localStorage",
    "FileUploader",
  ];

  function PagoAgentesController(
    $parse,
    $scope,
    providerService,
    groupService,
    $http,
    url,
    exportFactory,
    $state,
    $uibModal,
    dataFactory,
    SweetAlert,
    MESSAGES,
    toaster,
    $rootScope,
    $stateParams,
    $sce,
    $sessionStorage,
    $localStorage,
    FileUploader
  ) {
    var vm = this;
    $scope.disabled_cuenta = false;

    $scope.showTableReceipts = false;
    $scope.showInformation = false;
    $scope.hideInformation = true;
    $scope.showPayRecipt = false;
    $scope.folio = "";
    $scope.busqueda = "";
    $scope.providers = [];
    $scope.claves = [];
    $scope.ramos = [];
    $scope.subramos = [];
    $scope.groups = [];
    $scope.provider = 0;
    $scope.ramo = 0;
    $scope.subramo = 0;
    $scope.grupo = 0;
    $scope.clave = 0;
    $scope.vendor_selected = { value: 0 };
    $scope.main_estados = [];
    $scope.show_binnacle = false;
    $scope.recibos_radio_filter = 2;
    $scope.date_flag = true;
    $scope.cargandoResultados = true;
    $scope.receipts_edo = [];
    $scope.vendor_filter = false;
    $scope.calculandoGral = false;
    $scope.seleccionartodos = true;
    $scope.vendor_selected = {
      label: "",
      value: "",
    };
    $scope.stateFilter = {
      referenciador: "",
    };
    vm.filterReferenciador = "";
    vm.readyToLoad = false;
    vm.loadingEstados = false;
    vm.form = {};
    $scope.checkRec = function (val, argument, vend1, index) {
      vend1.subTotal_cn = vend1.subTotal_cn
        ? vend1.subTotal_cn
        : vend1.subtotal_1;
      var tipo_calculo = argument.tipo_calculo;
      var calculo = argument.calculo;
      var cantidad = argument.cantidad;
      $scope.total_final_edo = 0;
      if (calculo == 1) {
        //Abono
        if (tipo_calculo == 1) {
          //$
          if (val) {
            var abonos = cantidad;
            vend1.concepts[index].subtotal_aplicado =
              vend1.subtotal_1 + cantidad;
          } else {
            var abonos = 0;
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1;
          }
          vend1.concepts[index].abono_peso = abonos;
          $scope.vend.concepts = vend1.concepts;
        }
        if (tipo_calculo == 2) {
          //%
          if (val) {
            var abonos = vend1.subtotal_1 * (cantidad / 100);
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1 + abonos;
          } else {
            var abonos = 0;
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1;
          }
          vend1.concepts[index].abono_peso = abonos;
          $scope.vend.concepts = vend1.concepts;
        }
      }
      if (calculo == 2) {
        //Cargo
        if (tipo_calculo == 1) {
          //$
          if (val) {
            var cargos = cantidad;
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1 - cargos;
          } else {
            var cargos = 0;
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1;
          }
          vend1.concepts[index].cargo_peso = cargos;
          $scope.vend1 = vend1;
          // $scope.vend1.concepts = vend1.concepts
        }
        if (tipo_calculo == 2) {
          //%
          if (val) {
            var cargos = cantidad;
            var subCargo = vend1.subTotal_cn * (cargos / 100);
            vend1.concepts[index].subtotal_aplicado =
              vend1.subtotal_1 - subCargo;
          } else {
            var cargos = 0;
            var subCargo = 0;
            vend1.concepts[index].subtotal_aplicado = vend1.subtotal_1;
          }
          vend1.concepts[index].cargo_peso = subCargo;
          $scope.vend.concepts = vend1.concepts;
        }
      }
      var sumas = 0;
      var cargosx = 0;
      vend1.total_abonos = 0;
      vend1.total_cargos = 0;
      vend1.concepts.forEach(function (ec) {
        if (ec.abono_peso) {
          sumas = sumas + ec.abono_peso;
        }
        if (ec.cargo_peso) {
          cargosx = cargosx + ec.cargo_peso;
        }
        vend1.total_abonos = sumas;
        vend1.total_cargos = cargosx;
        vend1.totalFinal_edo = vend1.subtotal_1 + vend1.total_abonos;
        vend1.totalFinal_edo = vend1.totalFinal_edo - vend1.total_cargos;
        vend1.totalFinal_edo_ok = vend1.totalFinal_edo - vend1.gastos_operacion;
        // ok
      });
    };
    $scope.tipocalculo_options = [
      { id: 1, name: "$" },
      { id: 2, name: "%" },
    ];
    $scope.calculo_options = [
      { id: 1, name: "Abono" },
      { id: 2, name: "Cargo" },
    ];
    $scope.convertDate = function (inputFormat) {
      function inputDate(days) {
        return days < 10 ? "0" + days : days;
      }
      var dateFormat = new Date(inputFormat);
      var date = [
        inputDate(dateFormat.getDate()),
        inputDate(dateFormat.getMonth() + 1),
        dateFormat.getFullYear(),
      ].join("/");
      return date;
    };
    $localStorage["agentes"] = $localStorage["agentes"]
      ? $localStorage["agentes"]
      : {};
    $scope.filterDate = {
      startDate: $scope.convertDate(
        new Date().setYear(new Date().getFullYear())
      ),
      endDate: $scope.convertDate(
        new Date().setYear(new Date().getFullYear() + 1)
      ),
    };
    vm.accesos = $sessionStorage.permisos;
    if (vm.accesos) {
      vm.accesos.forEach(function (perm) {
        if (perm.model_name == "Pólizas") {
          vm.acceso_polizas = perm;
          vm.acceso_polizas.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar pólizas") {
              if (acc.checked == true) {
                vm.acceso_adm_pol = true;
              } else {
                vm.acceso_adm_pol = false;
              }
            } else if (acc.permission_name == "Ver pólizas") {
              if (acc.checked == true) {
                vm.acceso_ver_pol = true;
              } else {
                vm.acceso_ver_pol = false;
              }
            } else if (acc.permission_name == "Cancelar pólizas") {
              if (acc.checked == true) {
                vm.acceso_canc_pol = true;
              } else {
                vm.acceso_canc_pol = false;
              }
            } else if (acc.permission_name == "Eliminar pólizas") {
              if (acc.checked == true) {
                vm.acceso_elim_pol = true;
              } else {
                vm.acceso_elim_pol = false;
              }
            }
          });
        } else if (perm.model_name == "Reportes") {
          vm.acceso_reportes = perm;
          vm.acceso_reportes.permissions.forEach(function (acc) {
            if (acc.permission_name == "Reporte fianzas") {
              if (acc.checked == true) {
                vm.acceso_rep_fia = true;
              } else {
                vm.acceso_rep_fia = false;
              }
            } else if (acc.permission_name == "Reporte Siniestros") {
              if (acc.checked == true) {
                vm.acceso_rep_sin = true;
              } else {
                vm.acceso_rep_sin = false;
              }
            } else if (acc.permission_name == "Reporte Endosos") {
              if (acc.checked == true) {
                vm.acceso_rep_end = true;
              } else {
                vm.acceso_rep_end = false;
              }
            } else if (acc.permission_name == "Reporte pólizas") {
              if (acc.checked == true) {
                vm.acceso_rep_pol = true;
              } else {
                vm.acceso_rep_pol = false;
              }
            } else if (acc.permission_name == "Reporte renovaciones") {
              if (acc.checked == true) {
                vm.acceso_rep_ren = true;
              } else {
                vm.acceso_rep_ren = false;
              }
            } else if (acc.permission_name == "Reporte cobranza") {
              if (acc.checked == true) {
                vm.acceso_rep_cob = true;
              } else {
                vm.acceso_rep_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Ordenes de trabajo") {
          vm.acceso_ot = perm;
          vm.acceso_ot.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar OTs") {
              if (acc.checked == true) {
                vm.acceso_adm_ot = true;
              } else {
                vm.acceso_adm_ot = false;
              }
            } else if (acc.permission_name == "Ver OTs") {
              if (acc.checked == true) {
                vm.acceso_ver_ot = true;
              } else {
                vm.acceso_ver_ot = false;
              }
            } else if (acc.permission_name == "Cancelar OTs") {
              if (acc.checked == true) {
                vm.acceso_canc_ot = true;
              } else {
                vm.acceso_canc_ot = false;
              }
            } else if (acc.permission_name == "Eliminar OTs") {
              if (acc.checked == true) {
                vm.acceso_elim_ot = true;
              } else {
                vm.acceso_elim_ot = false;
              }
            }
          });
        } else if (perm.model_name == "Contratantes y grupos") {
          vm.acceso_contg = perm;
          vm.acceso_contg.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_adm_cont = true;
              } else {
                vm.acceso_adm_cont = false;
              }
            } else if (acc.permission_name == "Ver contratantes y grupos") {
              if (acc.checked == true) {
                vm.acceso_ver_cont = true;
              } else {
                vm.acceso_ver_cont = false;
              }
            }
          });
        } else if (perm.model_name == "Siniestros") {
          vm.acceso_sin = perm;
          vm.acceso_sin.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar siniestros") {
              if (acc.checked == true) {
                vm.acceso_adm_sin = true;
              } else {
                vm.acceso_adm_sin = false;
              }
            }
          });
        } else if (perm.model_name == "Mensajeria") {
          vm.acceso_mns = perm;
          vm.acceso_mns.permissions.forEach(function (acc) {
            if (acc.permission_name == "Mensajeria") {
              if (acc.checked == true) {
                vm.acceso_mns = true;
              } else {
                vm.acceso_mns = false;
              }
            }
          });
        } else if (perm.model_name == "Formatos") {
          vm.acceso_form = perm;
          vm.acceso_form.permissions.forEach(function (acc) {
            if (acc.permission_name == "Formatos") {
              if (acc.checked == true) {
                vm.acceso_form = true;
              } else {
                vm.acceso_form = false;
              }
            }
          });
        } else if (perm.model_name == "Correos electronicos") {
          vm.acceso_correo = perm;
          vm.acceso_correo.permissions.forEach(function (acc) {
            if (acc.permission_name == "Correos") {
              if (acc.checked == true) {
                vm.acceso_cor = true;
              } else {
                vm.acceso_cor = false;
              }
            }
          });
        } else if (perm.model_name == "Cobranza") {
          vm.acceso_cob = perm;
          vm.acceso_cob.permissions.forEach(function (acc) {
            if (acc.permission_name == "Ver cobranza") {
              if (acc.checked == true) {
                vm.acceso_ver_cob = true;
              } else {
                vm.acceso_ver_cob = false;
              }
            } else if (acc.permission_name == "Despagar recibos") {
              if (acc.checked == true) {
                vm.acceso_desp_cob = true;
              } else {
                vm.acceso_desp_cob = false;
              }
            } else if (acc.permission_name == "Pagar y prorrogar") {
              if (acc.checked == true) {
                vm.acceso_pag_cob = true;
              } else {
                vm.acceso_pag_cob = false;
              }
            } else if (acc.permission_name == "Desconciliación de recibos") {
              if (acc.checked == true) {
                vm.acceso_desco_cob = true;
              } else {
                vm.acceso_desco_cob = false;
              }
            } else if (acc.permission_name == "Conciliar recibos") {
              if (acc.checked == true) {
                vm.acceso_conc_cob = true;
              } else {
                vm.acceso_conc_cob = false;
              }
            } else if (acc.permission_name == "Liquidar recibos") {
              if (acc.checked == true) {
                vm.acceso_liq_cob = true;
              } else {
                vm.acceso_liq_cob = false;
              }
            }
          });
        } else if (perm.model_name == "Referenciadores") {
          vm.acceso_ref = perm;
          vm.acceso_ref.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar referenciadores") {
              if (acc.checked == true) {
                vm.acceso_adm_ref = true;
              } else {
                vm.acceso_adm_ref = false;
              }
            } else if (acc.permission_name == "Pagar a referenciadores") {
              if (acc.checked == true) {
                vm.acceso_pag_ref = true;
              } else {
                vm.acceso_pag_ref = false;
              }
            } else if (
              acc.permission_name == "Cambiar refrenciador en pólizas"
            ) {
              if (acc.checked == true) {
                vm.acceso_chg_ref = true;
              } else {
                vm.acceso_chg_ref = false;
              }
            }
          });
        } else if (perm.model_name == "Archivos") {
          vm.acceso_files = perm;
          vm.acceso_files.permissions.forEach(function (acc) {
            if (acc.permission_name == "Administrar archivos sensibles") {
              if (acc.checked == true) {
                vm.permiso_archivos = true;
              } else {
                vm.permiso_archivos = false;
              }
            }
          });
        } else if (perm.model_name == "Comisiones") {
          vm.coms = perm;
          vm.coms.permissions.forEach(function (acc) {
            if (acc.permission_name == "Comisiones") {
              if (acc.checked == true) {
                vm.permiso_comisiones = true;
              } else {
                vm.permiso_comisiones = false;
              }
            }
          });
        }
      });
    }
    vm.option_policy = [
      {
        id: 1,
        name: "Inicio de vigencia",
      },
      {
        id: 2,
        name: "Vencimiento",
      },
      {
        id: 3,
        name: "Fecha de pago",
      },
      {
        id: 4,
        name: "Fecha de liquidación",
      },
      {
        id: 5,
        name: "Fecha de conciliación",
      },
      {
        id: 6,
        name: "Todos",
      },
    ];
    // general

    $scope.checkRecGralIndiv = function (
      tipoCalculos,
      conceptosGrales,
      conceptosIndividuales,
      vend1,
      index,
      originalCalculos
    ) {
      if (tipoCalculos == "recibos") {
        originalCalculos = $scope.calculoSubTotales(
          vend1,
          vend1.sellerReceipt_add,
          vend1,
          originalCalculos
        );
        console.log("orur", originalCalculos);
      }
      var abonos_grales = 0;
      var cargos_grales = 0;
      $scope.aplicarGral = false;
      var abonos_pesos = 0;
      var cargos_pesos = 0;
      conceptosGrales.forEach(function (argument, indexgral) {
        if (vend1.sellerReceipts && argument.checked) {
          if ($scope.sellerReceipt_add) {
            vend1.sellerReceipts.forEach(function (recibo, indexx) {
              $scope.aplicarGral = false;
              $scope.sellerReceipt_add.forEach(function (item2, index2) {
                if (recibo.id == index2) {
                  if (item2) {
                    //recibo dentro del estado
                    if (
                      recibo.poliza &&
                      recibo.poliza.aseguradora_id &&
                      argument.aseguradoras
                    ) {
                      if (
                        argument.aseguradoras.includes(
                          recibo.poliza.aseguradora_id
                        )
                      ) {
                        if (argument.ramos.includes(recibo.poliza.ramo_code)) {
                          if (
                            argument.tipopolizas.includes(
                              recibo.poliza.document_type
                            )
                          ) {
                            $scope.aplicarGral = true; //coincide con arreglos configurados
                          }
                        }
                      } else if (
                        argument.ramos.includes(recibo.poliza.ramo_code)
                      ) {
                        if (
                          argument.tipopolizas.includes(
                            recibo.poliza.document_type
                          )
                        ) {
                          $scope.aplicarGral = true; //coincide con arreglos configurados
                        }
                      } else if (
                        argument.tipopolizas.includes(
                          recibo.poliza.document_type
                        )
                      ) {
                        $scope.aplicarGral = true; //coincide con arreglos configurados
                      }
                    }
                    // si no hay aseguradoras,ramos,tipopolizas se calculan ya que se consideran todos
                    if (
                      argument.aseguradoras.length == 0 &&
                      argument.tipopolizas.length == 0 &&
                      argument.ramos.length == 0
                    ) {
                      // aplicar
                      $scope.aplicarGral = true; //coincide sin configuraciones
                    }
                    if ($scope.aplicarGral) {
                      var comision_ref = (
                        recibo.comision_conciliada *
                        (recibo.comision_vendedor / 100.0)
                      ).toFixed(2);
                      if (argument.calculo == 1) {
                        //Abono
                        if (argument.tipo_calculo == 2) {
                          //% cada recibo, $ se aplica al final
                          var abono_a_moneda =
                            (parseFloat(argument.cantidad) *
                              parseFloat(comision_ref)) /
                            100;
                          abonos_grales =
                            parseFloat(abonos_grales) +
                            parseFloat(abono_a_moneda);
                          console.log(
                            "abonos_grales",
                            cargoabonos_graless_grales
                          );
                        }
                      }
                      if (argument.calculo == 2) {
                        //Cargo
                        if (argument.tipo_calculo == 2) {
                          //%cada recibo, $ al final
                          var cargo_a_moneda =
                            (parseFloat(argument.cantidad) *
                              parseFloat(comision_ref)) /
                            100;
                          cargos_grales =
                            parseFloat(cargos_grales) +
                            parseFloat(cargo_a_moneda);
                        }
                      }
                    } else {
                      console.log("no aplica el concepto", argument.concepto);
                    }
                  } //recibo dentro del estado
                }
              });
            });
          }
          if (argument.calculo == 1) {
            //Abono
            if (argument.tipo_calculo == 1) {
              //$
              abonos_pesos = abonos_pesos + parseFloat(argument.cantidad);
            }
          }
          if (argument.calculo == 2) {
            //Abono
            if (argument.tipo_calculo == 1) {
              //$
              cargos_pesos = cargos_pesos + parseFloat(argument.cantidad);
            }
          }
        }
      });
      if (cargos_pesos || abonos_pesos || abonos_grales || cargos_grales) {
        var subTotalFinalc =
          parseFloat(originalCalculos.subtotal_1) +
          parseFloat(abonos_grales) +
          parseFloat(abonos_pesos);
        var subTotalFinal =
          parseFloat(subTotalFinalc) -
          (parseFloat(cargos_grales) + parseFloat(cargos_pesos));
        $scope.subtotal_1_1 = subTotalFinal;
        var go =
          parseFloat($scope.subtotal_1_1) *
          (parseFloat(vend1.vendedor_go) / 100);
        vend1.go_final = go;
        $scope.total_final_1 = parseFloat(subTotalFinal);

        vend1.total_abonos_grales =
          parseFloat(abonos_grales) + parseFloat(abonos_pesos);
        vend1.total_cargos_grales =
          parseFloat(cargos_grales) + parseFloat(cargos_pesos);
        vend1.totalFinal_edo = subTotalFinal;
      }
      if ($scope.aplicarGral == false) {
        var subTotalFinalc = parseFloat(originalCalculos.subtotal_1);
        var subTotalFinal = parseFloat(subTotalFinalc);
        $scope.subtotal_1_1 = subTotalFinal;
        var go =
          parseFloat($scope.subtotal_1_1) *
          (parseFloat(vend1.vendedor_go) / 100);
        vend1.go_final = go;
        $scope.total_final_1 = parseFloat(subTotalFinal) - vend1.go_final;
        vend1.total_abonos_grales =
          parseFloat(abonos_grales) + parseFloat(abonos_pesos);
        vend1.total_cargos_grales =
          parseFloat(cargos_grales) + parseFloat(cargos_pesos);
        vend1.totalFinal_edo = subTotalFinal;
      }
      // aplicar individuales
      var sumas = 0;
      var cargosx = 0;
      vend1.total_abonos = 0;
      vend1.total_cargos = 0;
      var cargos = 0;
      var subCargo = 0;
      conceptosIndividuales.forEach(function (indiv, indexind) {
        var calculo = indiv.calculo;
        var tipo_calculo = indiv.tipo_calculo;
        var val = indiv.checked;
        var cantidad = indiv.cantidad;
        if (val) {
          if (calculo == 1) {
            //Abono
            if (tipo_calculo == 1) {
              //$
              if (val) {
                var abonos = cantidad;
                vend1.concepts[index].subtotal_aplicado =
                  $scope.subtotal_1_1 + cantidad;
              } else {
                var abonos = 0;
                indiv.subtotal_aplicado = $scope.subtotal_1_1;
              }
              indiv.abono_peso = abonos;
              $scope.vend.concepts = vend1.concepts;
            }
            if (tipo_calculo == 2) {
              //%
              if (val) {
                var abonos = $scope.subtotal_1_1 * (cantidad / 100);
                indiv.subtotal_aplicado = $scope.subtotal_1_1 + abonos;
              } else {
                var abonos = 0;
                indiv.subtotal_aplicado = $scope.subtotal_1_1;
              }
              indiv.abono_peso = abonos;
              $scope.vend.concepts = vend1.concepts;
            }
          }
          if (calculo == 2) {
            //Cargo
            if (tipo_calculo == 1) {
              //$
              if (val) {
                cargos = cantidad;
                indiv.subtotal_aplicado = $scope.subtotal_1_1 - cargos;
              } else {
                cargos = 0;
                indiv.subtotal_aplicado = $scope.subtotal_1_1;
              }
              indiv.cargo_peso = cargos;
              $scope.vend1 = vend1;
              // $scope.vend1.concepts = vend1.concepts
            }
            if (tipo_calculo == 2) {
              //%
              if (val) {
                cargos = cantidad;
                subCargo = $scope.subtotal_1_1 * (cargos / 100);
                indiv.subtotal_aplicado = $scope.subtotal_1_1 - subCargo;
              } else {
                cargos = cargos;
                subCargo = subCargo;
                indiv.subtotal_aplicado = $scope.subtotal_1_1;
              }
              indiv.cargo_peso = subCargo;
              $scope.vend.concepts = vend1.concepts;
            }
          }
          // vend1.concepts.forEach(function(ec){
          if (indiv.abono_peso) {
            sumas = sumas + indiv.abono_peso;
          }
          if (indiv.cargo_peso) {
            cargosx = cargosx + indiv.cargo_peso;
          }
        }
        vend1.sumas = sumas;
        vend1.cargosx = cargosx;
        // })
      });
      var subTotalFinalc_i =
        parseFloat($scope.subtotal_1_1) + parseFloat(vend1.sumas);
      subTotalFinal = parseFloat(subTotalFinalc_i) - parseFloat(vend1.cargosx);
      $scope.subtotal_1_1 = subTotalFinal;
      var go =
        parseFloat($scope.subtotal_1_1) * (parseFloat(vend1.vendedor_go) / 100);
      vend1.go_final = go;
      $scope.total_final_1 = parseFloat(subTotalFinal);
      vend1.total_abonos_grales =
        parseFloat(vend1.total_abonos_grales) + parseFloat(vend1.sumas);
      vend1.total_cargos_grales =
        parseFloat(vend1.total_cargos_grales) + parseFloat(vend1.cargosx);
      vend1.totalFinal_edo = subTotalFinal;
      // aplicar individuales
    };
    // calcular conceptos generales initial
    $scope.checkRecGralInicial = function (
      conceptosg,
      vend1,
      originalCalculos
    ) {
      $scope.calculandoGral = true;
      vend1.subTotal_cn = originalCalculos.totalFinal_edo
        ? originalCalculos.totalFinal_edo
        : originalCalculos.subtotal_1;

      $scope.total_final_edo = 0;
      var abonos_grales = 0;
      var cargos_grales = 0;
      $scope.aplicarGral = false;
      var abonos_pesos = 0;
      var cargos_pesos = 0;
      conceptosg.forEach(function (argument, indexgral) {
        if (vend1.sellerReceipts && argument.checked) {
          if ($scope.sellerReceipt_add) {
            vend1.sellerReceipts.forEach(function (recibo, indexx) {
              $scope.aplicarGral = false;
              $scope.sellerReceipt_add.forEach(function (item2, index2) {
                if (recibo.id == index2) {
                  if (item2) {
                    //recibo dentro del estado
                    if (
                      recibo.poliza &&
                      recibo.poliza.aseguradora_id &&
                      argument.aseguradoras
                    ) {
                      if (
                        argument.aseguradoras.includes(
                          recibo.poliza.aseguradora_id
                        )
                      ) {
                        if (argument.ramos.includes(recibo.poliza.ramo_code)) {
                          if (
                            argument.tipopolizas.includes(
                              recibo.poliza.document_type
                            )
                          ) {
                            $scope.aplicarGral = true; //coincide con arreglos configurados
                          }
                        }
                      } else if (
                        argument.ramos.includes(recibo.poliza.ramo_code)
                      ) {
                        if (
                          argument.tipopolizas.includes(
                            recibo.poliza.document_type
                          )
                        ) {
                          $scope.aplicarGral = true; //coincide con arreglos configurados
                        }
                      } else if (
                        argument.tipopolizas.includes(
                          recibo.poliza.document_type
                        )
                      ) {
                        $scope.aplicarGral = true; //coincide con arreglos configurados
                      }
                    }
                    // si no hay aseguradoras,ramos,tipopolizas se calculan ya que se consideran todos
                    if (
                      argument.aseguradoras.length == 0 &&
                      argument.tipopolizas.length == 0 &&
                      argument.ramos.length == 0
                    ) {
                      // aplicar
                      $scope.aplicarGral = true; //coincide sin configuraciones
                    }
                    if ($scope.aplicarGral) {
                      var comision_ref = (
                        recibo.comision_conciliada *
                        (recibo.comision_vendedor / 100.0)
                      ).toFixed(2);
                      console.log(
                        "comision---",
                        comision_ref,
                        argument.cantidad,
                        argument.calculo,
                        vend1,
                        vend1.subTotal_cn,
                        argument.concepto
                      );
                      if (argument.calculo == 1) {
                        //Abono
                        if (argument.tipo_calculo == 2) {
                          //% cada recibo, $ se aplica al final
                          var abono_a_moneda =
                            (parseFloat(argument.cantidad) *
                              parseFloat(comision_ref)) /
                            100;
                          abonos_grales =
                            parseFloat(abonos_grales) +
                            parseFloat(abono_a_moneda);
                          console.log(
                            "abonos_grales",
                            cargoabonos_graless_grales
                          );
                        }
                      }
                      if (argument.calculo == 2) {
                        //Cargo
                        if (argument.tipo_calculo == 2) {
                          //%cada recibo, $ al final
                          var cargo_a_moneda =
                            (parseFloat(argument.cantidad) *
                              parseFloat(comision_ref)) /
                            100;
                          cargos_grales =
                            parseFloat(cargos_grales) +
                            parseFloat(cargo_a_moneda);
                          console.log("cargos_grales", cargos_grales);
                        }
                      }
                    } else {
                      console.log("no aplica el concepto", argument.concepto);
                    }
                  } //recibo dentro del estado
                }
              });
            });
          }
          if (argument.calculo == 1) {
            //Abono
            if (argument.tipo_calculo == 1) {
              //$
              abonos_pesos = abonos_pesos + parseFloat(argument.cantidad);
            }
          }
          if (argument.calculo == 2) {
            //Abono
            if (argument.tipo_calculo == 1) {
              //$
              cargos_pesos = cargos_pesos + parseFloat(argument.cantidad);
            }
          }
        }
      });
      if (cargos_pesos || abonos_pesos || abonos_grales || cargos_grales) {
        var subTotalFinalc =
          parseFloat(originalCalculos.subtotal_1) +
          parseFloat(abonos_grales) +
          parseFloat(abonos_pesos);
        var subTotalFinal =
          parseFloat(subTotalFinalc) -
          (parseFloat(cargos_grales) + parseFloat(cargos_pesos));
        $scope.subtotal_1_1 = subTotalFinal;
        var go =
          parseFloat($scope.subtotal_1_1) *
          (parseFloat(vend1.vendedor_go) / 100);
        vend1.go_final = go;
        $scope.total_final_1 =
          parseFloat(subTotalFinal) - parseFloat(vend1.go_final);
        vend1.total_abonos_grales =
          parseFloat(abonos_grales) + parseFloat(abonos_pesos);
        vend1.total_cargos_grales =
          parseFloat(cargos_grales) + parseFloat(cargos_pesos);
        vend1.totalFinal_edo = subTotalFinal;
      }
      if ($scope.aplicarGral == false) {
        var subTotalFinalc = parseFloat(originalCalculos.subtotal_1);
        var subTotalFinal = parseFloat(subTotalFinalc);
        $scope.subtotal_1_1 = subTotalFinal;
        var go =
          parseFloat($scope.subtotal_1_1) *
          (parseFloat(vend1.vendedor_go) / 100);
        vend1.go_final = go;
        $scope.total_final_1 =
          parseFloat(subTotalFinal) - parseFloat(vend1.go_final);
        vend1.total_abonos_grales =
          parseFloat(abonos_grales) + parseFloat(abonos_pesos);
        vend1.total_cargos_grales =
          parseFloat(cargos_grales) + parseFloat(cargos_pesos);
        vend1.totalFinal_edo = subTotalFinal;
      }
    };
    // ---------------------------------------------
    // conceptos generales
    $scope.updateComision = function (recibo, vnd) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/agentes/modal.update.comision.html",
        controller: updateComision,
        controllerAs: "vmm",
        size: "md",
        resolve: {
          recibo: function () {
            return recibo;
          },
          vnd: function () {
            return vnd;
          },
          filter: function () {
            return $scope.filterDate;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (result) {
        $scope.showFilter();
      });
      modalInstance.result.catch(function (result) {
        $scope.showFilter();
      });
      function updateComision(
        $scope,
        recibo,
        $uibModalInstance,
        $state,
        toaster,
        vnd,
        filter
      ) {
        var vmm = this;
        vmm.actualizar = actualizar;
        vmm.close = close;
        $scope.comision = String(
          parseFloat(
            (parseFloat(recibo.comision_conciliada) *
              parseFloat(recibo.comision_vendedor)) /
              100
          ).toFixed(2)
        );
        function actualizar(comision) {
          if (parseInt(comision) == 0) {
            toaster.error("La comisión debe ser mayor a 0");
            return;
          }
          var to_update = {
            cambiar_comision_al_vendedor: true,
            comision_al_vendedor: comision,
          };
          $http.patch(recibo.url, to_update).then(function (response) {
            toaster.success("La comisión se actualizó exitosamente");
            $uibModalInstance.dismiss("cancel");
          });
        }
        function close() {
          $uibModalInstance.dismiss("cancel");
          $scope.showFilter();
        }
      }
    };
    $scope.updateComisionPolicyRef = function (recibo, vnd) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/agentes/modal.update.comision_policy.html",
        controller: updateComisionPolicy,
        controllerAs: "vmmm",
        size: "md",
        resolve: {
          recibo: function () {
            return recibo;
          },
          vnd: function () {
            return vnd;
          },
          filter: function () {
            return $scope.filterDate;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (result) {
        $scope.showFilter();
      });
      modalInstance.result.catch(function (result) {
        $scope.showFilter();
      });
      function updateComisionPolicy(
        $scope,
        recibo,
        $uibModalInstance,
        $state,
        toaster,
        vnd,
        filter
      ) {
        var vmmm = this;
        vmmm.actualizar = actualizar;
        vmmm.close = close;
        vmmm.recibo_ok = recibo;
        if (recibo.poliza.ref_policy) {
          recibo.poliza.ref_policy.forEach(function (ref) {
            if (vnd.value == ref.referenciador.id && ref.is_changed == false) {
              vmmm.referenciador = ref;
            }
          });
        }
        $scope.comision = String(
          parseFloat(
            (parseFloat(recibo.comision_conciliada) *
              parseFloat(recibo.comision_vendedor)) /
              100
          ).toFixed(2)
        );
        $scope.calcular = function (com) {
          $scope.data_update = {
            comision_vendedor: vmmm.referenciador.comision_vendedor,
          };
          if (com && parseInt(com) > 0) {
            vmmm.comision_conciliada = recibo.comision_conciliada;
            vmmm.comision_ref = recibo.comision_vendedor;
            if (recibo.poliza.ref_policy) {
              recibo.poliza.ref_policy.forEach(function (ref) {
                if (
                  vnd.value == ref.referenciador.id &&
                  ref.is_changed == false
                ) {
                  vmmm.comision_al_referenciador =
                    (parseFloat(com) * 100) /
                    parseFloat(vmmm.comision_conciliada);
                  $scope.data_update = {
                    comision_vendedor: parseFloat(
                      vmmm.comision_al_referenciador
                    ).toFixed(2),
                  };
                }
              });
            }
          }
        };
        function actualizar(comision) {
          if (parseInt(comision) == 0) {
            toaster.error("La comisión debe ser mayor a 0");
            return;
          }
          $http
            .patch(vmmm.referenciador.url, $scope.data_update)
            .then(function (response) {
              toaster.success(
                "La comisión del referenciador en la póliza se ha actualizado exitosamente"
              );
              $uibModalInstance.dismiss("cancel");
            });
        }
        function close() {
          $uibModalInstance.dismiss("cancel");
          $scope.showFilter();
        }
      }
    };

    $scope.changeReport = function (param) {
      if (param && param["id"] == 6) {
        $scope.dates_selected = false;
      } else {
        $scope.dates_selected = true;
      }
    };

    $scope.change_filter_radio = function (selector) {
      $scope.recibos_radio_filter = selector;
    };

    $scope.f_currency = function (parData) {
      if (parData.poliza) {
        switch (parData.poliza.f_currency) {
          case 1:
            return "Pesos";
            break;
          case 2:
            return "Dolares";
            break;
          case 3:
            return "UDI";
            break;
        }
      } else if (parData.fianza) {
        switch (parData.fianza.f_currency) {
          case 1:
            return "Pesos";
            break;
          case 2:
            return "Dolares";
            break;
          case 3:
            return "UDI";
            break;
        }
      }
    };

    $scope.addRecibo_edo = function (r, vend2, valor) {
      if ($scope.sellerReceipt_add[r.id]) {
        // console.log('---------',$scope.sellerReceipt_add,r,vend2,valor)
      } else {
        // console.log('-----sss----',$scope.sellerReceipt_add,r,vend2,valor)
      }
    };
    // --------sss-

    $scope.createEdo = function (container, rec) {
      rec.forEach(function (receipt) {
        $scope.receipts_edo.forEach(function (val) {
          if (receipt.id == val.id) {
          }
        });
      });
    };
    /*Nuevo estadoo*/
    function requestEstados(parStatus, parPage, busqueda) {
      if (!vm.readyToLoad) {
        $scope.statusSelected = parStatus;
        vm.loadingEstados = false;
        $scope.cargandoResultados = false;
        return;
      }
      var referenciador = vm.filterReferenciador;
      $scope.statusSelected = parStatus;
      $scope.cargandoResultados = true;
      vm.loadingEstados = true;
      $scope.main_estados = [];
      var params = {
        status: parStatus,
        page: parPage ? parPage : 1,
        folio: busqueda ? busqueda : "",
      };
      if (referenciador) {
        params.referenciador = referenciador;
      }
      dataFactory
        .get("estado-cuenta-table/", params)
        .then(function (estados) {
          $scope.main_estados = estados.data.results;
          if (parStatus == 1) {
            vm.show_pag_edos = true;
            vm.show_pag_edos_rechazados = false;
            vm.show_pag_edos_cerrados = false;
            $scope.obtenerPaginacion(
              estados.data,
              parPage ? parPage : 1,
              busqueda
            );
          } else if (parStatus == 2) {
            vm.show_pag_edos = false;
            vm.show_pag_edos_rechazados = true;
            vm.show_pag_edos_cerrados = false;
            $scope.obtenerPaginacion(
              estados.data,
              parPage ? parPage : 1,
              busqueda
            );
          } else if (parStatus == 3) {
            vm.show_pag_edos = false;
            vm.show_pag_edos_rechazados = false;
            vm.show_pag_edos_cerrados = true;
            $scope.obtenerPaginacion(
              estados.data,
              parPage ? parPage : 1,
              busqueda
            );
          }
        })
        .catch(function (error) {
          console.log("error", error);
        })
        .finally(function () {
          vm.loadingEstados = false;
          $scope.cargandoResultados = false;
        });
    }

    $scope.states_table_search = function (parStatus, parPage, busqueda) {
      if (!busqueda) {
        return;
      }
      vm.readyToLoad = true;
      requestEstados(parStatus, parPage ? parPage : 1, busqueda);
    };

    $scope.buscarEstadosFiltro = function () {
      var referenciador = $scope.stateFilter.referenciador || "";
      if (!referenciador) {
        SweetAlert.swal(
          "Aviso",
          "Seleccionar todos los referenciadores puede tardar varios segundos en cargar los estados de cuenta.",
          "info"
        );
      }
      vm.filterReferenciador = referenciador;
      vm.readyToLoad = true;
      requestEstados($scope.statusSelected || 1, 1, $scope.busqueda);
    };

    $scope.obtenerTodosReferenciadores = function () {
      $scope.stateFilter.referenciador = "";
      SweetAlert.swal(
        "Aviso",
        "Obtener estados de cuenta para todos los referenciadores puede tardar varios segundos.",
        "info"
      );
      vm.filterReferenciador = "";
      vm.readyToLoad = true;
      requestEstados($scope.statusSelected || 1, 1, $scope.busqueda);
    };

    $scope.update_states_table = function (parStatus, parPage, busqueda) {
      requestEstados(parStatus, parPage ? parPage : 1, busqueda);
    };

    $scope.goToPolicy = function (insurance) {
      if (insurance.document_type == 1) {
        $state.go("polizas.info", { polizaId: insurance.id });
      } else if (insurance.document_type == 3) {
        $state.go("colectividades.info", { polizaId: insurance.id });
      }
    };

    $scope.saveReferenciador = function (agente) {
      if (agente) {
        $localStorage.agentes["vendor_selected"] = agente;
      } else {
        delete $localStorage.agentes["vendor_selected"];
      }
    };
    // nueva paginación inicial
    $scope.obtenerPaginacion = function (pagesdata, pagina) {
      $scope.paginacion = {
        count: pagesdata["count"],
        previous: pagesdata["previous"],
        next: pagesdata["next"],
        totalPaginas: [],
        paginaInicio: 0,
        paginaActual: pagina,
        paginaFin: 0,
      };
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      var i = 0;
      i = pagina - 5;
      if (i <= 0) {
        i = 0;
      }

      for (i; i < numeroPaginas; i++) {
        if ($scope.paginacion["totalPaginas"].length <= 5) {
          $scope.paginacion["totalPaginas"].push(i + 1);
        }
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaInicio"] =
          $scope.paginacion["totalPaginas"] - 5;
      } else {
        $scope.paginacion["paginaInicio"] = 1;
      }
      if ($scope.paginacion["totalPaginas"].length > 5) {
        $scope.paginacion["paginaFin"] = 5;
      } else {
        $scope.paginacion["paginaFin"] =
          $scope.paginacion["totalPaginas"].length;
      }
    };

    $scope.selecionPagina = function (pagina, busqueda) {
      $scope.update_states_table($scope.statusSelected, pagina, busqueda);
    };

    $scope.anteriorPagina = function (busqueda) {
      if ($scope.paginacion["paginaActual"] > 1) {
        $scope.update_states_table(
          $scope.statusSelected,
          $scope.paginacion["paginaActual"] - 1,
          busqueda
        );
      }
    };

    $scope.siguientePagina = function (busqueda) {
      var numeroPaginas = Math.ceil($scope.paginacion["count"] / 10);
      if (numeroPaginas > $scope.paginacion["paginaActual"]) {
        $scope.update_states_table(
          $scope.statusSelected,
          $scope.paginacion["paginaActual"] + 1,
          busqueda
        );
      }
    };
    $scope.changeInput = function () {
      $localStorage.agentes["ramo"] = $scope.ramo;
      $localStorage.agentes["group"] = $scope.group;
      $localStorage.agentes["clave"] = $scope.clave;
      $localStorage.agentes["form"] =
        vm.form && vm.form.dates_sel ? vm.form.dates_sel : vm.form;
      $localStorage.agentes["startDate"] = $scope.filterDate.startDate;
      $localStorage.agentes["endDate"] = $scope.filterDate.endDate;
      $localStorage.agentes["recibos_radio_filter"] =
        $scope.recibos_radio_filter;
    };

    $scope.active = function () {
      $scope.cargandoResultados = true;
      $scope.busqueda = "";
      if ($localStorage.email_config) {
        $scope.cerrarRecibos = $localStorage.email_config.cerrar_recibos;
      }
      if ($localStorage && $localStorage.agentes) {
        $scope["filterDate"] = {};
        vm.form = {};
        $scope.vendor_selected =
          $localStorage.agentes && $localStorage.agentes["vendor_selected"]
            ? $localStorage.agentes["vendor_selected"]
            : "";
        $scope.provider =
          $localStorage.agentes && $localStorage.agentes["provider"]
            ? $localStorage.agentes["provider"].id
            : "";
        $scope.ramo =
          $localStorage.agentes && $localStorage.agentes["ramo"]
            ? $localStorage.agentes["ramo"].id
            : "";
        $scope.subramo =
          $localStorage.agentes && $localStorage.agentes["subramo"]
            ? $localStorage.agentes["subramo"]
            : "";
        $scope.group = $localStorage.agentes && $localStorage.agentes["group"];
        $scope.clave = $localStorage.agentes["clave"];
        vm.form["dates_sel"] =
          $localStorage.agentes && $localStorage.agentes["form"];
        $scope["filterDate"]["startDate"] = $localStorage.agentes["startDate"];
        $scope["filterDate"]["endDate"] =
          $localStorage.agentes && $localStorage.agentes["endDate"];
        $scope.recibos_radio_filter =
          $localStorage.agentes &&
          $localStorage.agentes["recibos_radio_filter"];

        if ($scope.provider) {
          $scope.changeProvider($scope.provider);
        }
        if (
          vm.form &&
          vm.form["dates_sel"] &&
          vm.form["dates_sel"]["id"] &&
          vm.form["dates_sel"]["id"] != 6
        ) {
          $scope.dates_selected = true;
        }

        if (
          $localStorage.agentes &&
          $localStorage.agentes["recibos_radio_filter"]
        ) {
          $scope.change_filter_radio($scope.recibos_radio_filter);
          // $scope.showFilter();
        }
        if (vm.form && vm.form["dates_sel"] == undefined) {
          vm.form["dates_sel"] = vm.option_policy[5];
        }
      }
      $scope.vendors_data = [];
      $scope.vendorsLoading = false;
      function fetchVendors() {
        $scope.vendorsLoading = true;
        return $http
          .get(url.IP + "get-vendors")
          .then(function (user) {
            $scope.vendors_data = user.data.map(function (u) {
              return {
                label: u.first_name + " " + u.last_name,
                value: u.id,
              };
            });
          })
          .catch(function (error) {
            console.error("No se pudieron cargar los referenciadores", error);
          })
          .finally(function () {
            $scope.vendorsLoading = false;
          });
      }
      $scope.loadReferenciadores = fetchVendors;
      fetchVendors();
      providerService.getReadListProviders().then(function (provider) {
        $scope.providers = provider;
        if ($localStorage.agentes && $localStorage.agentes["provider"]) {
          $scope.providers.forEach(function (p) {
            if (p.id == $localStorage.agentes["provider"]) {
              $scope.provider = p.id;
              $scope.changeProvider(p);
            }
          });
        }
        $scope.providers.push({ compania: " Todas las afianzadoras", id: -1 });
        $scope.providers.push({ compania: " Todos los seguros", id: -2 });
      });
      groupService.getGroups().then(function (group) {
        $scope.groups = group;
        if ($localStorage.agentes && $localStorage.agentes["group"]) {
          $scope.groups.forEach(function (p) {
            if (p.id == $localStorage.agentes["group"]) {
              $scope.group = p;
              $scope.grupo = p;
              // $scope.changeGrupo(p);
            }
          });
        }
      });
      if ($scope.date_flag) {
        if ($localStorage.agentes && $localStorage.agentes["startDate"]) {
        } else {
          $scope.filterDate = {
            startDate: $scope.convertDate(
              new Date().setYear(new Date().getFullYear())
            ),
            endDate: $scope.convertDate(
              new Date().setYear(new Date().getFullYear() + 1)
            ),
          };
          $scope.date_flag = false;
        }
      }
    };
    $scope.cerrarrecibosenedo = function (stat) {
      var dataorginfo = {
        cerrar_recibos: stat,
      };
      $localStorage.email_config.cerrar_recibos = $scope.cerrarRecibos;
      $http
        .patch($localStorage.email_config.url, dataorginfo)
        .then(function success(response) {
          if (response.status == 201 || response.status == 200) {
            $localStorage.email_config.cerrar_recibos = stat;
            SweetAlert.swal(
              "Información Actualizada",
              MESSAGES.OK.SAVEDCONFIG,
              "success"
            );
          } else if (response.status == 403) {
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al guardar la configuración",
              "error"
            );
          } else {
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al guardar la configuración",
              "error"
            );
          }
        });
    };

    $scope.changeVendor = function (vendor, s, i) {
      $scope.vendor_selected = {};
      if (vendor && vendor.value) {
        $scope.vendor_selected["value"] = s.value;
        $scope.vendor_selected["label"] = s.label;
        $scope.vendor_filter = true;
      } else {
        delete $localStorage.agentes["vendor_selected"];
        $scope.vendor_selected = {};
        $scope.show_vendedores_1 = false;
      }
    };

    $scope.changeProvider = function (provider) {
      if (!provider || provider.id == -2) {
        $scope.subramos = [];
        $scope.ramos = [];
        $scope.ramo = null;
        $scope.subramo = null;
        $scope.ramos = $scope.fake_ramos;
        return;
      } else if (provider.id == -1) {
        $scope.subramos = [];
        $scope.ramos = [];
        $scope.ramo = null;
        $scope.subramo = null;
        $scope.ramos = $scope.afianzadoras_ramos;
        return;
      }
      if (provider.id) {
        var pkp = provider.id;
      } else {
        var pkp = provider;
      }
      try {
        $http
          .get(url.IP + "ramos-by-provider/" + pkp)
          .then(
            function success(ramo) {
              $scope.ramos = ramo.data;
              if ($localStorage.agentes && $localStorage.agentes["ramo"]) {
                ramo.data.forEach(function (p) {
                  if (p.id == $localStorage.agentes["ramo"]) {
                    $scope.ramo = p.id;
                    $scope.changeRamo(p);
                  }
                });
              }
            },
            function error(e) {
              console.log("Error - claves-by-provider", e);
            }
          )
          .catch(function (error) {
            console.log("Error - claves-by-provider - catch", error);
          });
      } catch (e) {
        console.log("error", e);
        return;
      }
      $scope.getClaves(provider);
      $scope.provider = pkp;
      $localStorage.agentes["provider"] = $scope.provider;
    };

    $scope.getClaves = function (provider) {
      if (provider.id) {
        var pkp = provider.id;
      } else {
        var pkp = provider;
      }
      $http
        .get(url.IP + "claves-by-provider/" + pkp)
        .then(
          function success(clave) {
            $scope.claves = clave.data;
            if ($localStorage.agentes && $localStorage.agentes["clave"]) {
              $scope.claves.forEach(function (p) {
                if (p.id == $localStorage.agentes["clave"]) {
                  $scope.clave = p;
                }
              });
            }
          },
          function error(e) {
            console.log("Error - claves-by-provider", e);
          }
        )
        .catch(function (error) {
          console.log("Error - claves-by-provider - catch", error);
        });
    };

    $scope.changeRamo = function (ramo) {
      if (!ramo) {
        $scope.subramos = [];
        return;
      }

      $scope.ramos.forEach(function (ramo_) {
        if (ramo.id) {
          var pkr = ramo.id;
        } else {
          var pkr = ramo;
        }
        if (ramo_.id == pkr) {
          $scope.subramos = ramo_.subramo_ramo;
        }
      });
      $scope.ramo = ramo;
      if ($localStorage.agentes && $localStorage.agentes["subramo"]) {
        $scope.ramo = $scope.ramo.id;
      }
      if ($localStorage.agentes && $localStorage.agentes["subramo"]) {
        $scope.subramos.forEach(function (p) {
          if (p.id == $localStorage.agentes["subramo"]) {
            $scope.subramo = p.id;
          }
        });
      }
    };

    $scope.changeSubRamo = function (subramo) {
      if (subramo) {
        $scope.subramo = subramo && subramo.id ? subramo.id : subramo;
        $localStorage.agentes["subramo"] = $scope.subramo;
      }
    };

    $scope.changeClave = function (clave) {
      if (clave.id) {
        clave = clave.id;
      } else {
        clave = clave;
      }
      $scope.clave = clave;
    };

    $scope.changeGrupo = function (grupo) {
      if (!grupo) {
        $scope.grupo = 0;
        return;
      }
      $scope.group = grupo.id;
      $scope.grupo = grupo.id;
      $localStorage.agentes["group"] = $scope.group;
    };

    $scope.disabled_cuenta = false;

    $scope.print = function (vnd) {
      $scope.disabled_cuenta = true;
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      $scope.receipts_ = [];
      var flag_status = false;
      vnd.sellerReceipts.forEach(function (item) {
        if (item.status != 6) {
          flag_status = true;
        }
      });

      if (vnd.sellerReceipts.length == 0 || flag_status == true) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORPRINTRECEIPT, "error");
        l.stop();
        return;
      }
      var data = {
        vendedor: vnd.value,
        recibos: [],
        total: vnd.total,
        g_o_vend: vnd.g_o_vend,
        concepts: JSON.stringify(vnd.concepts),
      };
      // ------------------------
      // vnd.sellerReceipts.forEach(function(item) {
      //     data.recibos.push(item.id);
      // });
      // ------------------
      $scope.d = {};
      $scope.d.recibos = [];
      if ($scope.sellerReceipt_add) {
        $scope.recibos_a_edo = [];
        for (var i = 0; i < $scope.sellerReceipt_add.length; i++) {
          if ($scope.sellerReceipt_add[i] != undefined) {
            if ($scope.sellerReceipt_add[i] == true) {
              $scope.recibos_a_edo.push(i);
            }
          }
        }
        vnd.sellerReceipts.forEach(function (item) {
          // data.recibos.push(item.id);
          $scope.recibos_a_edo.forEach(function (add) {
            // data.recibos.push(add);
            if (add == item.id) {
              data.recibos.push(add);
              $scope.d.recibos.push(item);
            }
          });
        });
        $scope.cc = 0;
        $scope.g_o_vend = 0;
        $scope.c_vendedor = 0;
        $scope.com_rec = 0;
        $scope.subtotal = 0;
        if ($scope.d.recibos) {
          $scope.g_o_vend = $scope.g_o_vend + parseFloat(vnd.vendedor_go);
          $scope.d.recibos.forEach(function (item) {
            if (item) {
              $scope.cc = $scope.cc + parseFloat(item.comision_conciliada);
              $scope.com_rec = $scope.com_rec + parseFloat(item.comision);
              $scope.c_vendedor = parseFloat(item.comision_vendedor);
              $scope.subtotal =
                parseFloat($scope.subtotal) +
                parseFloat(
                  $scope.calculateCommission(
                    item.comision_conciliada,
                    item.comision_vendedor,
                    item.cambiar_comision_al_vendedor,
                    item.comision_al_vendedor
                  )
                );
            }
          });
          if ($scope.cc) {
            $scope.gastos_operacion = 0;
            $scope.total = 0;
            $scope.comision = 0;
            $scope.gastos_operacion = (
              (parseFloat($scope.g_o_vend) / 100).toFixed(2) * $scope.subtotal
            ).toFixed(2);
            $scope.total = ($scope.subtotal - $scope.gastos_operacion).toFixed(
              2
            );
            vnd.gastos_operacion = $scope.gastos_operacion;
            // console.log('$scope.gastos_operacion',$scope.gastos_operacion,$scope.total)
            if (!isNaN($scope.total)) {
              data.total = $scope.total;
            } else {
              $scope.total = 0;
              data.total = 0;
              SweetAlert.swal(
                "Error",
                "Vendedor  no tiene comisión en el subramo del Recibo a agregar a la cuenta",
                "error"
              );
              l.stop();
              return;
            }
          }
        }
      } else {
        SweetAlert.swal(
          "Error",
          "Agregue los recibos para el Estado de Cuenta",
          "error"
        );
        l.stop();
        return;
      }
      if ($scope.recibos_a_edo.length == 0) {
        SweetAlert.swal(
          "Error",
          "Agregue los recibos para el Estado de Cuenta",
          "error"
        );
        l.stop();
        return;
      }
      l.stop();
      if (vnd) {
        if (vnd.gastos_operacion) {
          if (vnd.account_totalFinal_edo_ok && vnd.account_totalFinal_edo) {
            data.total = parseFloat(vnd.account_totalFinal_edo_ok).toFixed(2);
            data.subtotal = parseFloat(vnd.account_totalFinal_edo).toFixed(2);
          }
        }
      }
      data.g_o_vend = parseFloat(vnd.gastos_operacion).toFixed(2);
      console.log("data", data, vnd);
      data.conceptos_generales_aplicados = [];
      if (vnd.conceptos_grales) {
        vnd.conceptos_grales.forEach(function (add) {
          if (add.checked) {
            data.conceptos_generales_aplicados.push(add.id);
          }
        });
      }
      data["subtotal_1"] = vnd.subtotal_1;
      l.stop();
      dataFactory.post("estado-cuenta/", data).then(function (request) {
        if (request.status == 200 || request.status == 201) {
          $scope.disabled_cuenta = false;
          SweetAlert.swal("Listo", MESSAGES.ERROR.OKPRINTRECEIPT, "success");
          $scope.showFilter();
          l.stop();
          vnd.sellerReceipts = [];
        } else {
          $scope.disabled_cuenta = false;
          SweetAlert.swal(
            "ERROR",
            "Ha ocurrido un error al crear el estado de cuenta",
            "error"
          );
          l.stop();
          return;
        }
      });
    };
    $scope.calculoConcepts = function (v, val, seller, rec) {
      $scope.subtotal_add = 0;
      $scope.recibos_ok2 = [];
      seller.forEach(function (item, index) {
        v.sellerReceipts.forEach(function (item2, index2) {
          if (index == item2.id) {
            if (item) {
              if (item2.poliza) {
                if (item2.poliza.ref_policy) {
                  item2.poliza.ref_policy.forEach(function (ref, index) {
                    if (
                      ref.referenciador.id == $scope.vendor_selected.value &&
                      ref.is_changed == false
                    ) {
                      if (parseFloat(ref.comision_vendedor).toFixed(2) != 0.0) {
                        item2.comision_vendedor = parseFloat(
                          ref.comision_vendedor
                        ).toFixed(2);
                        if (item2.comision_vendedor != "No existe subramo") {
                          item2.comision_vendedor = item2.comision_vendedor;
                        } else if (parData.comision__) {
                          item2.comision_vendedor = parData.comision__;
                        }
                        if ($scope.recibos_ok2.includes(item2.id)) {
                          console.log(
                            "ya se ha calculado",
                            item2,
                            $scope.subtotal_add
                          );
                        } else {
                          $scope.recibos_ok2.push(item2.id);
                          $scope.subtotal_add =
                            parseFloat($scope.subtotal_add) +
                            parseFloat(
                              $scope.calculateCommission(
                                item2.comision_conciliada,
                                item2.comision_vendedor,
                                item2.cambiar_comision_al_vendedor,
                                item2.comision_al_vendedor
                              )
                            );
                        }
                      } else {
                        if (item2.comision_vendedor != "No existe subramo") {
                          item2.comision_vendedor = item2.comision_vendedor;
                        } else if ($scope.subtotal_add) {
                          item2.comision_vendedor = $scope.subtotal_add;
                        }
                        if (item2.comision_vendedor) {
                          if ($scope.recibos_ok2.includes(item2.id)) {
                            console.log(
                              "2ya se ha calculado",
                              item2,
                              $scope.subtotal_add
                            );
                          } else {
                            $scope.recibos_ok2.push(item2.id);
                            $scope.subtotal_add =
                              parseFloat($scope.subtotal_add) +
                              parseFloat(
                                $scope.calculateCommission(
                                  item2.comision_conciliada,
                                  item2.comision_vendedor,
                                  item2.cambiar_comision_al_vendedor,
                                  item2.comision_al_vendedor
                                )
                              );
                          }
                        }
                      }
                    } else {
                      if (item2.poliza.vendor) {
                        if ($scope.recibos_ok2.includes(item2.id)) {
                          console.log(
                            "3ya se ha calculado",
                            item2,
                            $scope.subtotal_add
                          );
                        } else {
                          $scope.recibos_ok2.push(item2.id);
                          $scope.subtotal_add =
                            parseFloat($scope.subtotal_add) +
                            parseFloat(
                              $scope.calculateCommission(
                                item2.comision_conciliada,
                                item2.comision_vendedor,
                                item2.cambiar_comision_al_vendedor,
                                item2.comision_al_vendedor
                              )
                            );
                        }
                      }
                    }
                  });
                }
                if (
                  item2.poliza.vendor &&
                  item2.poliza.ref_policy.length == 0
                ) {
                  if ($scope.recibos_ok2.includes(item2.id)) {
                    console.log(
                      "4ya se ha calculado",
                      item2,
                      $scope.subtotal_add
                    );
                  } else {
                    $scope.recibos_ok2.push(item2.id);
                    $scope.subtotal_add =
                      parseFloat($scope.subtotal_add) +
                      parseFloat(
                        $scope.calculateCommission(
                          item2.comision_conciliada,
                          item2.comision_vendedor,
                          item2.cambiar_comision_al_vendedor,
                          item2.comision_al_vendedor
                        )
                      );
                  }
                }
              } else {
                if ($scope.recibos_ok2.includes(item2.id)) {
                  console.log(
                    "5ya se ha calculado",
                    item2,
                    $scope.subtotal_add
                  );
                } else {
                  $scope.recibos_ok2.push(item2.id);
                  $scope.subtotal_add =
                    parseFloat($scope.subtotal_add) +
                    parseFloat(
                      $scope.calculateCommission(
                        item2.comision_conciliada,
                        item2.comision_vendedor,
                        item2.cambiar_comision_al_vendedor,
                        item2.comision_al_vendedor
                      )
                    );
                }
              }
            } else {
              console.log(
                "no cnsiderar---",
                $scope.subtotal_add,
                v,
                val,
                seller,
                rec
              );
            }
          }
        });
      });
      var sumas = 0;
      var cargosx = 0;
      v.concepts.forEach(function (ec) {
        if (ec.abono_peso) {
          sumas = sumas + ec.abono_peso;
        }
        if (ec.cargo_peso) {
          cargosx = cargosx + ec.cargo_peso;
        }
        v.account_total_abonos = sumas;
        v.account_total_cargos = cargosx;
        v.account_totalFinal_edo = $scope.subtotal_add + v.account_total_abonos;
        v.account_totalFinal_edo =
          v.account_totalFinal_edo - v.account_total_cargos;
        // ------------------------
        $scope.gastos_operacion = (
          (parseFloat(v.vendedor_go) / 100).toFixed(2) *
          v.account_totalFinal_edo
        ).toFixed(2);
        $scope.total = (
          v.account_totalFinal_edo - $scope.gastos_operacion
        ).toFixed(2);
        v.gastos_operacion = $scope.gastos_operacion;
        // -------------------
        v.account_totalFinal_edo_ok =
          v.account_totalFinal_edo - v.gastos_operacion;
      });
    };
    $scope.calculoSubTotales = function (v, val, seller, rec) {
      $scope.subtotal_add = 0;
      $scope.recibos_ok2 = [];
      $scope.sellerReceipt_add.forEach(function (item, index) {
        v.sellerReceipts.forEach(function (item2, index2) {
          if (index == item2.id) {
            if (item) {
              if (item2.poliza) {
                if (item2.poliza.ref_policy) {
                  item2.poliza.ref_policy.forEach(function (ref, index) {
                    if (
                      ref.referenciador.id == $scope.vendor_selected.value &&
                      ref.is_changed == false
                    ) {
                      if (parseFloat(ref.comision_vendedor).toFixed(2) != 0.0) {
                        item2.comision_vendedor = parseFloat(
                          ref.comision_vendedor
                        ).toFixed(2);
                        if (item2.comision_vendedor != "No existe subramo") {
                          item2.comision_vendedor = item2.comision_vendedor;
                        } else if (parData.comision__) {
                          item2.comision_vendedor = parData.comision__;
                        }
                        if ($scope.recibos_ok2.includes(item2.id)) {
                          console.log(
                            "ya se ha calculado",
                            item2,
                            $scope.subtotal_add
                          );
                        } else {
                          $scope.recibos_ok2.push(item2.id);
                          $scope.subtotal_add =
                            parseFloat($scope.subtotal_add) +
                            parseFloat(
                              $scope.calculateCommission(
                                item2.comision_conciliada,
                                item2.comision_vendedor,
                                item2.cambiar_comision_al_vendedor,
                                item2.comision_al_vendedor
                              )
                            );
                        }
                      } else {
                        if (item2.comision_vendedor != "No existe subramo") {
                          item2.comision_vendedor = item2.comision_vendedor;
                        } else if ($scope.subtotal_add) {
                          item2.comision_vendedor = $scope.subtotal_add;
                        }
                        if (item2.comision_vendedor) {
                          if ($scope.recibos_ok2.includes(item2.id)) {
                            console.log(
                              "2ya se ha calculado",
                              item2,
                              $scope.subtotal_add
                            );
                          } else {
                            $scope.recibos_ok2.push(item2.id);
                            $scope.subtotal_add =
                              parseFloat($scope.subtotal_add) +
                              parseFloat(
                                $scope.calculateCommission(
                                  item2.comision_conciliada,
                                  item2.comision_vendedor,
                                  item2.cambiar_comision_al_vendedor,
                                  item2.comision_al_vendedor
                                )
                              );
                          }
                        }
                      }
                    } else {
                      if (item2.poliza.vendor) {
                        if ($scope.recibos_ok2.includes(item2.id)) {
                          console.log(
                            "3ya se ha calculado",
                            item2,
                            $scope.subtotal_add
                          );
                        } else {
                          $scope.recibos_ok2.push(item2.id);
                          $scope.subtotal_add =
                            parseFloat($scope.subtotal_add) +
                            parseFloat(
                              $scope.calculateCommission(
                                item2.comision_conciliada,
                                item2.comision_vendedor,
                                item2.cambiar_comision_al_vendedor,
                                item2.comision_al_vendedor
                              )
                            );
                        }
                      }
                    }
                  });
                }
                if (
                  item2.poliza.vendor &&
                  item2.poliza.ref_policy.length == 0
                ) {
                  if ($scope.recibos_ok2.includes(item2.id)) {
                    console.log(
                      "4ya se ha calculado",
                      item2,
                      $scope.subtotal_add
                    );
                  } else {
                    $scope.recibos_ok2.push(item2.id);
                    $scope.subtotal_add =
                      parseFloat($scope.subtotal_add) +
                      parseFloat(
                        $scope.calculateCommission(
                          item2.comision_conciliada,
                          item2.comision_vendedor,
                          item2.cambiar_comision_al_vendedor,
                          item2.comision_al_vendedor
                        )
                      );
                  }
                }
              } else {
                if ($scope.recibos_ok2.includes(item2.id)) {
                  console.log(
                    "5ya se ha calculado",
                    item2,
                    $scope.subtotal_add
                  );
                } else {
                  $scope.recibos_ok2.push(item2.id);
                  $scope.subtotal_add =
                    parseFloat($scope.subtotal_add) +
                    parseFloat(
                      $scope.calculateCommission(
                        item2.comision_conciliada,
                        item2.comision_vendedor,
                        item2.cambiar_comision_al_vendedor,
                        item2.comision_al_vendedor
                      )
                    );
                }
              }
            } else {
              console.log(
                "no cnsiderar---",
                $scope.subtotal_add,
                v,
                val,
                seller,
                rec
              );
            }
          }
        });
      });
      v.account_total_abonos = 0;
      v.account_total_cargos = 0;
      v.account_totalFinal_edo = $scope.subtotal_add + v.account_total_abonos;
      v.account_totalFinal_edo =
        v.account_totalFinal_edo - v.account_total_cargos;
      // ------------------------
      $scope.gastos_operacion = 0;
      $scope.total = (
        v.account_totalFinal_edo - $scope.gastos_operacion
      ).toFixed(2);
      v.gastos_operacion = $scope.gastos_operacion;
      // -------------------
      v.account_totalFinal_edo_ok = v.account_totalFinal_edo;
      v.subtotal_1 = $scope.subtotal_add;
      return v;
    };
    $scope.calculoConceptsOnix = function (v, val, seller, rec) {
      $scope.subtotal_add = 0;
      $scope.recibos_ok2 = [];
      $scope.subtotal_onix = 0;
      $scope.total_onix = 0;
      $scope.go_onix = 0;
      seller.forEach(function (item, index) {
        v.sellerReceipts.forEach(function (item2, index2) {
          if (index == item2.id) {
            if (item) {
              if (item2.poliza) {
                if (item2.poliza.ref_policy) {
                  item2.poliza.ref_policy.forEach(function (ref, index) {
                    if (
                      ref.referenciador.id == $scope.vendor_selected.value &&
                      ref.is_changed == false
                    ) {
                      if (parseFloat(ref.comision_vendedor).toFixed(2) != 0.0) {
                        item2.comision_vendedor = parseFloat(
                          ref.comision_vendedor
                        ).toFixed(2);
                        if (item2.comision_vendedor != "No existe subramo") {
                          item2.comision_vendedor = item2.comision_vendedor;
                        } else if (parData.comision__) {
                          item2.comision_vendedor = parData.comision__;
                        }
                        if ($scope.recibos_ok2.includes(item2.id)) {
                          console.log(
                            "ya se ha calculado",
                            item2,
                            $scope.subtotal_add
                          );
                        } else {
                          $scope.recibos_ok2.push(item2.id);
                          $scope.subtotal_add =
                            parseFloat($scope.subtotal_add) +
                            parseFloat(
                              $scope.calculateCommission(
                                item2.comision_conciliada,
                                item2.comision_vendedor,
                                item2.cambiar_comision_al_vendedor,
                                item2.comision_al_vendedor
                              )
                            );
                        }
                      } else {
                        if (item2.comision_vendedor != "No existe subramo") {
                          item2.comision_vendedor = item2.comision_vendedor;
                        } else if ($scope.subtotal_add) {
                          item2.comision_vendedor = $scope.subtotal_add;
                        }
                        if (item2.comision_vendedor) {
                          if ($scope.recibos_ok2.includes(item2.id)) {
                            console.log(
                              "2ya se ha calculado",
                              item2,
                              $scope.subtotal_add
                            );
                          } else {
                            $scope.recibos_ok2.push(item2.id);
                            $scope.subtotal_add =
                              parseFloat($scope.subtotal_add) +
                              parseFloat(
                                $scope.calculateCommission(
                                  item2.comision_conciliada,
                                  item2.comision_vendedor,
                                  item2.cambiar_comision_al_vendedor,
                                  item2.comision_al_vendedor
                                )
                              );
                          }
                        }
                      }
                    } else {
                      if (item2.poliza.vendor) {
                        if ($scope.recibos_ok2.includes(item2.id)) {
                          console.log(
                            "3ya se ha calculado",
                            item2,
                            $scope.subtotal_add
                          );
                        } else {
                          $scope.recibos_ok2.push(item2.id);
                          $scope.subtotal_add =
                            parseFloat($scope.subtotal_add) +
                            parseFloat(
                              $scope.calculateCommission(
                                item2.comision_conciliada,
                                item2.comision_vendedor,
                                item2.cambiar_comision_al_vendedor,
                                item2.comision_al_vendedor
                              )
                            );
                        }
                      }
                    }
                  });
                }
                if (
                  item2.poliza.vendor &&
                  item2.poliza.ref_policy.length == 0
                ) {
                  if ($scope.recibos_ok2.includes(item2.id)) {
                    console.log(
                      "4ya se ha calculado",
                      item2,
                      $scope.subtotal_add
                    );
                  } else {
                    $scope.recibos_ok2.push(item2.id);
                    $scope.subtotal_add =
                      parseFloat($scope.subtotal_add) +
                      parseFloat(
                        $scope.calculateCommission(
                          item2.comision_conciliada,
                          item2.comision_vendedor,
                          item2.cambiar_comision_al_vendedor,
                          item2.comision_al_vendedor
                        )
                      );
                  }
                }
              } else {
                if ($scope.recibos_ok2.includes(item2.id)) {
                  console.log(
                    "5ya se ha calculado",
                    item2,
                    $scope.subtotal_add
                  );
                } else {
                  $scope.recibos_ok2.push(item2.id);
                  $scope.subtotal_add =
                    parseFloat($scope.subtotal_add) +
                    parseFloat(
                      $scope.calculateCommission(
                        item2.comision_conciliada,
                        item2.comision_vendedor,
                        item2.cambiar_comision_al_vendedor,
                        item2.comision_al_vendedor
                      )
                    );
                }
              }
            } else {
              console.log(
                "no cnsiderar---",
                $scope.subtotal_add,
                v,
                val,
                seller,
                rec
              );
            }
          }
        });
      });
      // subtotal_1
      // go_final
      // total_final
      var sumas = 0;
      var cargosx = 0;
      v.concepts.forEach(function (ec) {
        if (ec.abono_peso) {
          sumas = sumas + ec.abono_peso;
        }
        if (ec.cargo_peso) {
          cargosx = cargosx + ec.cargo_peso;
        }
        v.account_total_abonos = sumas;
        v.account_total_cargos = cargosx;
        v.account_totalFinal_edo = $scope.subtotal_add + v.account_total_abonos;
        v.account_totalFinal_edo =
          v.account_totalFinal_edo - v.account_total_cargos;
        v.subtotal_1 = $scope.subtotal_add;
        // ------------------------
        $scope.gastos_operacion = (
          (parseFloat(v.vendedor_go) / 100).toFixed(2) *
          v.account_totalFinal_edo
        ).toFixed(2);
        $scope.total = (
          v.account_totalFinal_edo - $scope.gastos_operacion
        ).toFixed(2);
        v.gastos_operacion = $scope.gastos_operacion;
        v.go_final = $scope.gastos_operacion;
        // -------------------
        v.total_final = v.account_totalFinal_edo - v.gastos_operacion;
        v.account_totalFinal_edo_ok =
          v.account_totalFinal_edo - v.gastos_operacion;
      });
    };
    $scope.printTodos = function (sel) {
      var lt = Ladda.create(document.querySelector(".ladda-button2"));
      lt.start();
      $scope.receipts_ = [];
      var flag_status = false;

      $scope.sellerReceipt_add.forEach(function (item, index) {
        $scope.sellerReceipt_add[index] = true;
      });
      $scope.subtotal_add = 0;
      $scope.recibos_ok3 = [];
      $scope.sellerReceipt_add.forEach(function (item, index) {
        sel.sellerReceipts.forEach(function (item2, index2) {
          if (index == item2.id) {
            if (item) {
              if (item2.poliza) {
                if (item2.poliza.ref_policy) {
                  item2.poliza.ref_policy.forEach(function (ref, index) {
                    if (
                      ref.referenciador.id == $scope.vendor_selected.value &&
                      ref.is_changed == false
                    ) {
                      if (parseFloat(ref.comision_vendedor).toFixed(2) != 0.0) {
                        item2.comision_vendedor = parseFloat(
                          ref.comision_vendedor
                        ).toFixed(2);
                        if (item2.comision_vendedor != "No existe subramo") {
                          item2.comision_vendedor = item2.comision_vendedor;
                        } else if (parData.comision__) {
                          item2.comision_vendedor = parData.comision__;
                        }
                        if ($scope.recibos_ok3.includes(item2.id)) {
                          console.log(
                            "ya se ha calculado",
                            item2,
                            $scope.subtotal_add
                          );
                        } else {
                          $scope.recibos_ok3.push(item2.id);
                          $scope.subtotal_add =
                            parseFloat($scope.subtotal_add) +
                            parseFloat(
                              $scope.calculateCommission(
                                item2.comision_conciliada,
                                item2.comision_vendedor,
                                item2.cambiar_comision_al_vendedor,
                                item2.comision_al_vendedor
                              )
                            );
                        }
                      } else {
                        if (item2.comision_vendedor != "No existe subramo") {
                          item2.comision_vendedor = item2.comision_vendedor;
                        } else if ($scope.subtotal_add) {
                          item2.comision_vendedor = $scope.subtotal_add;
                        }
                        if (item2.comision_vendedor) {
                          if ($scope.recibos_ok3.includes(item2.id)) {
                            console.log(
                              "ya se ha calculado",
                              item2,
                              $scope.subtotal_add
                            );
                          } else {
                            $scope.recibos_ok3.push(item2.id);
                            $scope.subtotal_add =
                              parseFloat($scope.subtotal_add) +
                              parseFloat(
                                $scope.calculateCommission(
                                  item2.comision_conciliada,
                                  item2.comision_vendedor,
                                  item2.cambiar_comision_al_vendedor,
                                  item2.comision_al_vendedor
                                )
                              );
                          }
                        }
                      }
                    } else {
                      if (item2.poliza.vendor) {
                        if ($scope.recibos_ok3.includes(item2.id)) {
                          console.log(
                            "ya se ha calculado",
                            item2,
                            $scope.subtotal_add
                          );
                        } else {
                          $scope.recibos_ok3.push(item2.id);
                          $scope.subtotal_add =
                            parseFloat($scope.subtotal_add) +
                            parseFloat(
                              $scope.calculateCommission(
                                item2.comision_conciliada,
                                item2.comision_vendedor,
                                item2.cambiar_comision_al_vendedor,
                                item2.comision_al_vendedor
                              )
                            );
                        }
                      }
                    }
                  });
                }
                if (
                  item2.poliza.vendor &&
                  item2.poliza.ref_policy.length == 0
                ) {
                  if ($scope.recibos_ok3.includes(item2.id)) {
                    console.log(
                      "ya se ha calculado",
                      item2,
                      $scope.subtotal_add
                    );
                  } else {
                    $scope.recibos_ok3.push(item2.id);
                    $scope.subtotal_add =
                      parseFloat($scope.subtotal_add) +
                      parseFloat(
                        $scope.calculateCommission(
                          item2.comision_conciliada,
                          item2.comision_vendedor,
                          item2.cambiar_comision_al_vendedor,
                          item2.comision_al_vendedor
                        )
                      );
                  }
                }
              } else {
                if ($scope.recibos_ok3.includes(item2.id)) {
                  console.log("ya se ha calculado", item2, $scope.subtotal_add);
                } else {
                  $scope.recibos_ok3.push(item2.id);
                  $scope.subtotal_add =
                    parseFloat($scope.subtotal_add) +
                    parseFloat(
                      $scope.calculateCommission(
                        item2.comision_conciliada,
                        item2.comision_vendedor,
                        item2.cambiar_comision_al_vendedor,
                        item2.comision_al_vendedor
                      )
                    );
                }
              }
            } else {
            }
          }
        });
      });
      var sumas = 0;
      var cargosx = 0;
      sel.concepts.forEach(function (ec) {
        if (ec.abono_peso) {
          sumas = sumas + ec.abono_peso;
        }
        if (ec.cargo_peso) {
          cargosx = cargosx + ec.cargo_peso;
        }
        sel.account_total_abonos = sumas;
        sel.account_total_cargos = cargosx;
        sel.account_totalFinal_edo =
          $scope.subtotal_add + sel.account_total_abonos;
        sel.account_totalFinal_edo =
          sel.account_totalFinal_edo - sel.account_total_cargos;
        sel.account_totalFinal_edo_ok =
          sel.account_totalFinal_edo - sel.gastos_operacion;
      });
      lt.stop();
      $scope.print(sel);
    };
    $scope.selectVendor = function (parData) {
      var p = $scope.provider ? $scope.provider : 0;
      var r = $scope.ramo ? $scope.ramo : 0;
      var s = $scope.subramo ? $scope.subramo : 0;
      var c = $scope.clave ? $scope.clave : 0;
      var g = $scope.group ? $scope.group : 0;
      if (g.id) {
        g = g.id;
      }
      if (c.id) {
        c = c.id;
      }
      $scope.vendedor_selected = parData;
      $scope.saveReferenciador(parData);
      $scope.recibos_radio_filter = $scope.recibos_radio_filter
        ? $scope.recibos_radio_filter
        : 1;
      $scope.vendor_selected = {};
      $scope.vendor_selected["value"] =
        parData && parData["value"] ? parData["value"] : 0;
      $scope.sellerReceipt_add = [];
      $http
        .get(
          url.IP +
            "get-vendedores-receipts/?" +
            "provider=" +
            p +
            "&" +
            "ramo=" +
            r +
            "&" +
            "subramo=" +
            s +
            "&" +
            "clave=" +
            c +
            "&" +
            "grupo=" +
            g +
            "&" +
            "vendedor=" +
            $scope.vendor_selected.value +
            "&" +
            "since=" +
            $scope.filterDate.startDate +
            " " +
            "00:00:00" +
            "&" +
            "until=" +
            $scope.filterDate.endDate +
            " " +
            "23:59:59" +
            "&" +
            "radio=" +
            $scope.recibos_radio_filter +
            "&" +
            "report_by=" +
            (vm.form.dates_sel ? vm.form.dates_sel.id : 6) +
            "&"
        )
        .success(function (response) {
          if (response.data) {
            parData.sellerReceipts = response.data;
            parData.subtotal = response.suma.toFixed(2);
            parData.gastos_operacion = response.gastos_operacion.toFixed(2);
            parData.total = response.total.toFixed(2);
            parData.conceptos_grales = response.conceptos_grales;
            parData.vendedor_go = response.vendedor_go.toFixed(2);
            parData.subtotal_1 = 0;
            parData.go_final = 0;
            parData.total_final = 0;
            parData.comision__ = response.com;
            try {
              response.concepts = response.concepts.split("'").join('"');
              response.concepts = response.concepts.split("None").join('""');
              if (typeof response.concepts == "string") {
                response.concepts = JSON.parse(response.concepts);
              }
            } catch (ee) {
              console.log("-errror---", ee, parData.concepts);
            }
            parData.concepts = response.concepts;
            parData.sellerReceipts.forEach(function (rec, index) {
              if (rec.poliza) {
                if (rec.poliza.ref_policy) {
                  rec.poliza.ref_policy.forEach(function (ref, index) {
                    if (
                      ref.referenciador.id == $scope.vendor_selected.value &&
                      ref.is_changed == false
                    ) {
                      if (parseFloat(ref.comision_vendedor).toFixed(2) != 0.0) {
                        rec.comision_vendedor = parseFloat(
                          ref.comision_vendedor
                        ).toFixed(2);
                        if (rec.comision_vendedor != "No existe subramo") {
                          rec.comision_vendedor = rec.comision_vendedor;
                        } else if (parData.comision__) {
                          rec.comision_vendedor = parData.comision__;
                        }
                        parData.subtotal_1 =
                          parseFloat(parData.subtotal_1) +
                          parseFloat(
                            $scope.calculateCommission(
                              rec.comision_conciliada,
                              rec.comision_vendedor,
                              rec.cambiar_comision_al_vendedor,
                              rec.comision_al_vendedor
                            )
                          );
                      } else {
                        if (rec.comision_vendedor != "No existe subramo") {
                          rec.comision_vendedor = rec.comision_vendedor;
                        } else if (parData.comision__) {
                          rec.comision_vendedor = parData.comision__;
                        }
                        if (rec.comision_vendedor) {
                          parData.subtotal_1 =
                            parseFloat(parData.subtotal_1) +
                            parseFloat(
                              $scope.calculateCommission(
                                rec.comision_conciliada,
                                rec.comision_vendedor,
                                rec.cambiar_comision_al_vendedor,
                                rec.comision_al_vendedor
                              )
                            );
                        }
                      }
                    } else {
                      if (rec.poliza.vendor) {
                        parData.subtotal_1 =
                          parseFloat(parData.subtotal_1) +
                          parseFloat(
                            $scope.calculateCommission(
                              rec.comision_conciliada,
                              rec.comision_vendedor,
                              rec.cambiar_comision_al_vendedor,
                              rec.comision_al_vendedor
                            )
                          );
                      }
                    }
                  });
                }
                if (rec.poliza.vendor && rec.poliza.ref_policy.length == 0) {
                  parData.subtotal_1 =
                    parseFloat(parData.subtotal_1) +
                    parseFloat(
                      $scope.calculateCommission(
                        rec.comision_conciliada,
                        rec.comision_vendedor,
                        rec.cambiar_comision_al_vendedor,
                        rec.comision_al_vendedor
                      )
                    );
                }
              } else {
                parData.subtotal_1 =
                  parseFloat(parData.subtotal_1) +
                  parseFloat(
                    $scope.calculateCommission(
                      rec.comision_conciliada,
                      rec.comision_vendedor,
                      rec.cambiar_comision_al_vendedor,
                      rec.comision_al_vendedor
                    )
                  );
              }
              $scope.sellerReceipt_add[rec.id] = true;
            });
            parData.go_final = parseFloat(
              (parData.vendedor_go / 100) * parData.subtotal_1
            ).toFixed(2);
            parData.total_final = parseFloat(
              parData.subtotal_1 - parData.go_final
            ).toFixed(2);
            $scope.originalCalculos = angular.copy(parData);

            parData.conceptos_grales.forEach(function (concpt, idcb) {
              parData.conceptos_grales[idcb].checked = true;
            });

            if (response.valores && response["valores"]["total"]) {
              var val_results = response.valores;
              $scope.originalCalculos.subtotal_1 =
                val_results["subtotal_final_suma"];
              parData.total_abonos_grales = val_results["abonos_grales"];
              parData.total_cargos_grales = val_results["cargos_grales"];
              parData.total_abonos_individuales =
                val_results["abonos_individuales"];
              parData.total_cargos_individuales =
                val_results["cargos_individuales"];
              parData.sumas_bonos = val_results["sumasabonos"];
              parData.sumas_cargos = val_results["sumascargos"];
              $scope.subtotal_1_1 = val_results["subtotal_cargos_abonos"];
              parData.go_final = val_results["go"];
              $scope.total_final_1 = val_results["total"];
            } else {
              var val_results = 0;
              // $scope.originalCalculos.subtotal_1
              $scope.originalCalculos.subtotal_1 = 0;
              $scope.vend.total_abonos_grales = 0;
              $scope.vend.total_cargos_grales = 0;
              parData.total_abonos_individuales = 0;
              parData.total_cargos_individuales = 0;
              parData.sumas_bonos = 0;
              parData.sumas_cargos = 0;
              $scope.subtotal_1_1 = 0;
              $scope.vend.go_final = 0;
              if (response.data && response.data.data) {
                $scope.checkRecGralInicial(
                  $scope.vend.conceptos_grales,
                  $scope.vend,
                  $scope.originalCalculos
                );
              }
            }
            // $scope.checkRecGralInicial(parData.conceptos_grales,parData,$scope.originalCalculos)
            // console.log('----------gofnal',parData,parData.vendedor_go)
          }
        })
        .error(function (response) {})
        .catch(function (response) {});
    };
    $scope.format_currency = function (parValue) {
      if (parValue) {
        parValue = parValue.toString();

        if (
          parValue.search(/[A-Za-z]/g) > -1 ||
          parValue.search(/[0-9]%/g) > -1
        ) {
          return parValue;
        } else {
          var num = parseFloat(parValue);
          var num_format =
            "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");

          return num_format;
          // return parValue;
        }
      }
    };
    $scope.selectVendorExcel = function (parData) {
      var p = $scope.provider ? $scope.provider : 0;
      var r = $scope.ramo ? $scope.ramo : 0;
      var s = $scope.subramo ? $scope.subramo : 0;
      var c = $scope.clave ? $scope.clave : 0;
      var g = $scope.group ? $scope.group : 0;

      $scope.vendedor_selected = parData;
      $scope.vendor_selected.value = parData.value;
      // $scope.sellerReceipt_add = [];

      if (g.id) {
        g = g.id;
      }
      if (c.id) {
        c = c.id;
      }
      $http({
        method: "GET",
        // url: url.IP + 'get-vendedores-receipts-excel/?'+
        url:
          url.IP +
          "service_reporte-recibosVendedor-excel?" +
          "provider=" +
          p +
          "&" +
          "ramo=" +
          r +
          "&" +
          "subramo=" +
          s +
          "&" +
          "clave=" +
          c +
          "&" +
          "grupo=" +
          g +
          "&" +
          "vendedor=" +
          $scope.vendor_selected.value +
          "&" +
          "since=" +
          $scope.filterDate.startDate +
          " " +
          "00:00:00" +
          "&" +
          "until=" +
          $scope.filterDate.endDate +
          " " +
          "23:59:59" +
          "&" +
          "radio=" +
          $scope.recibos_radio_filter +
          "&" +
          "report_by=" +
          (vm.form.dates_sel ? vm.form.dates_sel.id : 6) +
          "&",
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function success(data) {
          if (data.status == 200) {
            var blob = new Blob([data.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Excel_vendedor.xls");
          } else {
            SweetAlert.swal(
              "Error",
              "Ha ocurrido un error al descargar el excel",
              "error"
            );
          }
        })
        .error(function (response) {})
        .catch(function (response) {});
    };

    $scope.returnToTable = function () {
      $scope.show_detail = false;
    };

    $scope.getInfoPolicy = function (param) {
      if (param.poliza) {
        var data_id = param.poliza.id;
      } else if (param.fianza) {
        return;
      } else {
        return;
      }
      dataFactory.get("leer-polizas-info/" + data_id).then(function (request) {
        // $scope.show_detail = true;
        $scope.info_policy = request.data;

        if ($scope.info_policy.contractor) {
          var url_ = "contractor/" + $scope.info_policy.contractor + "/";
        }

        dataFactory.get(url_).then(function (contractor) {
          $scope.info_contractor = contractor.data;

          if (contractor.data.address_contractor) {
            $scope.info_contractor.address =
              contractor.data.address_contractor[0];
          }

          var modalInstance = $uibModal.open({
            templateUrl: "app/agentes/pago.informacion.html",
            controller: PagoAgentesModalController,
            controllerAs: "vmm",
            size: "lg",
            resolve: {
              contractorModal: function () {
                return $scope.info_contractor;
              },
              policyModal: function () {
                return $scope.info_policy;
              },
            },
            backdrop:
              "static" /* this prevent user interaction with the background */,
            keyboard: false,
          });
        });
      });
    };

    $localStorage.saved_filters_pagar = {
      recibos_radio_filter: 2,
    };

    $scope.showFilter = function () {
      $scope.originalCalculos = {};
      $scope.total_final_1 = 0;
      $scope.disabled_cuenta = false;
      $scope.sh_all = true;
      var parData = {};
      if ($scope.vendor_filter == true) {
        $scope.sh_all = false;
      }
      // $scope.selectVendor($scope.vendor_selected)

      // var parData = $scope.vendor_selected
      $scope.sellerReceipts = [];
      if ($scope.vendor_selected && !$scope.vendor_selected.val) {
        // $scope.vendor_selected.value = 0;
      }

      $scope.show_vendedores = false;
      $scope.vendor_selected = $localStorage.agentes["vendor_selected"];
      if ($scope.vendor_selected && $scope.vendor_selected.value > 0) {
        // $scope.vendors_data = [];
        $scope.show_vendedores_1 = true;

        $scope.showTableReceipts = true;

        var p = $scope.provider ? $scope.provider : 0;
        var r = $scope.ramo ? $scope.ramo : 0;
        var s = $scope.subramo ? $scope.subramo : 0;
        var c = $scope.clave ? $scope.clave : 0;
        var g = $scope.group ? $scope.group : 0;
        if (g.id) {
          g = g.id;
        }
        if (c.id) {
          c = c.id;
        }
        $scope.sellerReceipt_add = [];
        $http
          .get(
            url.IP +
              "get-vendedores-receipts/?" +
              "provider=" +
              p +
              "&" +
              "ramo=" +
              r +
              "&" +
              "subramo=" +
              s +
              "&" +
              "clave=" +
              c +
              "&" +
              "grupo=" +
              g +
              "&" +
              "vendedor=" +
              $scope.vendor_selected.value +
              "&" +
              "since=" +
              $scope.filterDate.startDate +
              " " +
              "00:00:00" +
              "&" +
              "until=" +
              $scope.filterDate.endDate +
              " " +
              "23:59:59" +
              "&" +
              "radio=" +
              $scope.recibos_radio_filter +
              "&" +
              "report_by=" +
              (vm.form.dates_sel ? vm.form.dates_sel.id : 6) +
              "&"
          )
          .success(function (response) {
            if (response.data) {
              $scope.vend = {};
              parData.sellerReceipts = response.data;
              parData.subtotal = response.suma.toFixed(2);
              parData.gastos_operacion = response.gastos_operacion.toFixed(2);
              parData.total = response.total.toFixed(2);
              parData.vendedor_go = response.vendedor_go.toFixed(2);
              try {
                response.concepts = response.concepts.split("'").join('"');
                response.concepts = response.concepts.split("None").join('""');
                if (typeof response.concepts == "string") {
                  response.concepts = JSON.parse(response.concepts);
                }
              } catch (ee) {
                console.log("-errror---", ee, parData.concepts);
              }
              $scope.vend.sellerReceipts = response.data;
              $scope.vend.subtotal = response.suma.toFixed(2);
              $scope.vend.gastos_operacion =
                response.gastos_operacion.toFixed(2);
              $scope.vend.total = response.total.toFixed(2);
              $scope.vend.vendedor_go = response.vendedor_go.toFixed(2);
              $scope.vend.value = $scope.vendor_selected.value;
              $scope.vend.subtotal_1 = 0;
              $scope.vend.subtotal_1MXN = 0;
              $scope.vend.go_final = 0;
              $scope.vend.go_finalMXN = 0;
              $scope.vend.total_final = 0;
              $scope.vend.total_finalMXN = 0;
              $scope.vend.comision__ = response.com;
              $scope.vend.conceptos_grales = response.conceptos_grales;
              $scope.vend.sellerReceipts1 = [];
              $scope.vend.conceptos_grales.forEach(function (cn, ind) {
                $scope.vend.conceptos_grales[ind].checked = false;
              });
              $scope.vend.sellerReceipts.forEach(function (rec, index) {
                // ----------no este ya en cuentas del mismo usuario
                // ------------NO
                if (rec.poliza) {
                  if (rec.poliza.ref_policy) {
                    $scope.recibos_ok = [];
                    rec.poliza.ref_policy.forEach(function (ref, index) {
                      if (
                        ref.referenciador.id == $scope.vendor_selected.value &&
                        ref.is_changed == false
                      ) {
                        if (
                          parseFloat(ref.comision_vendedor).toFixed(2) != 0.0
                        ) {
                          if ($scope.recibos_ok.includes(rec.id)) {
                            console.log(
                              "-----no hacer calculo--si-incl",
                              rec.id,
                              $scope.recibos_ok
                            );
                          } else {
                            console.log(
                              "-----hacer calculo--",
                              rec.id,
                              $scope.recibos_ok
                            );
                            rec.comision_vendedor = parseFloat(
                              ref.comision_vendedor
                            ).toFixed(2);
                            $scope.vend.subtotal_1 =
                              parseFloat($scope.vend.subtotal_1) +
                              parseFloat(
                                $scope.calculateCommission(
                                  rec.comision_conciliada,
                                  rec.comision_vendedor,
                                  rec.cambiar_comision_al_vendedor,
                                  rec.comision_al_vendedor
                                )
                              );
                            $scope.recibos_ok.push(rec.id);
                            if (rec.poliza.f_currency != 1) {
                              var comcon = parseFloat(
                                $scope.calculateCommission(
                                  rec.comision_conciliada,
                                  rec.comision_vendedor,
                                  rec.cambiar_comision_al_vendedor,
                                  rec.comision_al_vendedor
                                )
                              );
                              $scope.vend.subtotal_1MXN =
                                parseFloat($scope.vend.subtotal_1MXN) +
                                parseFloat(
                                  parseFloat(rec.rate_exchange) *
                                    parseFloat(comcon)
                                );
                            }
                          }
                        } else {
                          if (rec.comision_vendedor != "No existe subramo") {
                            rec.comision_vendedor = rec.comision_vendedor;
                          } else if ($scope.vend.comision__) {
                            rec.comision_vendedor = $scope.vend.comision__;
                          }
                          // rec.comision_vendedor = ref.comision_vendedor---anterior cambio doble si ref 2 veces en poliza
                          if (rec.comision_vendedor) {
                            if ($scope.recibos_ok.includes(rec.id)) {
                              console.log(
                                "---1--no hacer calculo--",
                                rec.id,
                                $scope.recibos_ok
                              );
                            } else {
                              console.log(
                                "--2---hacer calculo--",
                                rec.id,
                                $scope.recibos_ok
                              );
                              $scope.vend.subtotal_1 =
                                parseFloat($scope.vend.subtotal_1) +
                                parseFloat(
                                  $scope.calculateCommission(
                                    rec.comision_conciliada,
                                    rec.comision_vendedor,
                                    rec.cambiar_comision_al_vendedor,
                                    rec.comision_al_vendedor
                                  )
                                );
                              $scope.recibos_ok.push(rec.id);
                              if (rec.poliza.f_currency != 1) {
                                var comcon = parseFloat(
                                  $scope.calculateCommission(
                                    rec.comision_conciliada,
                                    rec.comision_vendedor,
                                    rec.cambiar_comision_al_vendedor,
                                    rec.comision_al_vendedor
                                  )
                                );
                                $scope.vend.subtotal_1MXN =
                                  parseFloat($scope.vend.subtotal_1MXN) +
                                  parseFloat(
                                    parseFloat(rec.rate_exchange) *
                                      parseFloat(comcon)
                                  );
                              }
                            }
                          }
                        }
                        // $scope.vend.subtotal_1 = parseFloat($scope.vend.subtotal_1) + parseFloat($scope.calculateCommission(rec.comision_conciliada, rec.comision_vendedor, rec.cambiar_comision_al_vendedor, rec.comision_al_vendedor))
                      } else {
                        if (rec.comision_vendedor) {
                          rec.comision_vendedor = rec.comision_vendedor;
                        } else if ($scope.vend.comision__) {
                          rec.comision_vendedor = $scope.vend.comision__;
                        }
                        if (rec.poliza.vendor) {
                          $scope.vend.subtotal_1 =
                            parseFloat($scope.vend.subtotal_1) +
                            parseFloat(
                              $scope.calculateCommission(
                                rec.comision_conciliada,
                                rec.comision_vendedor,
                                rec.cambiar_comision_al_vendedor,
                                rec.comision_al_vendedor
                              )
                            );
                          console.log("xxxxxxxxx", $scope.vend);
                          if (rec.poliza.f_currency != 1) {
                            var comcon = parseFloat(
                              $scope.calculateCommission(
                                rec.comision_conciliada,
                                rec.comision_vendedor,
                                rec.cambiar_comision_al_vendedor,
                                rec.comision_al_vendedor
                              )
                            );
                            $scope.vend.subtotal_1MXN =
                              parseFloat($scope.vend.subtotal_1MXN) +
                              parseFloat(
                                parseFloat(rec.rate_exchange) *
                                  parseFloat(comcon)
                              );
                          }
                        }
                      }
                    });
                  }
                  if (rec.poliza.vendor && rec.poliza.ref_policy.length == 0) {
                    if (rec.comision_vendedor) {
                      rec.comision_vendedor = rec.comision_vendedor;
                    } else if ($scope.vend.comision__) {
                      rec.comision_vendedor = $scope.vend.comision__;
                    }
                    $scope.vend.subtotal_1 =
                      parseFloat($scope.vend.subtotal_1) +
                      parseFloat(
                        $scope.calculateCommission(
                          rec.comision_conciliada,
                          rec.comision_vendedor,
                          rec.cambiar_comision_al_vendedor,
                          rec.comision_al_vendedor
                        )
                      );
                    console.log("ccccccc", $scope.vend);
                    if (rec.poliza.f_currency != 1) {
                      var comcon = parseFloat(
                        $scope.calculateCommission(
                          rec.comision_conciliada,
                          rec.comision_vendedor,
                          rec.cambiar_comision_al_vendedor,
                          rec.comision_al_vendedor
                        )
                      );
                      $scope.vend.subtotal_1MXN =
                        parseFloat($scope.vend.subtotal_1MXN) +
                        parseFloat(
                          parseFloat(rec.rate_exchange) * parseFloat(comcon)
                        );
                    }
                  }
                } else {
                  if (rec.comision_vendedor) {
                    rec.comision_vendedor = rec.comision_vendedor;
                  } else if ($scope.vend.comision__) {
                    rec.comision_vendedor = $scope.vend.comision__;
                  }
                  $scope.vend.subtotal_1 =
                    parseFloat($scope.vend.subtotal_1) +
                    parseFloat(
                      $scope.calculateCommission(
                        rec.comision_conciliada,
                        rec.comision_vendedor,
                        rec.cambiar_comision_al_vendedor,
                        rec.comision_al_vendedor
                      )
                    );

                  if (rec.poliza.f_currency != 1) {
                    var comcon = parseFloat(
                      $scope.calculateCommission(
                        rec.comision_conciliada,
                        rec.comision_vendedor,
                        rec.cambiar_comision_al_vendedor,
                        rec.comision_al_vendedor
                      )
                    );
                    $scope.vend.subtotal_1MXN =
                      parseFloat($scope.vend.subtotal_1MXN) +
                      parseFloat(
                        parseFloat(rec.rate_exchange) * parseFloat(comcon)
                      );
                  }
                }
                // No mover
                $scope.sellerReceipt_add[rec.id] = true;
              });
              $scope.vend.go_final = parseFloat(
                ($scope.vend.vendedor_go / 100) * $scope.vend.subtotal_1
              ).toFixed(2);
              $scope.vend.go_finalMXN = parseFloat(
                ($scope.vend.vendedor_go / 100) * $scope.vend.subtotal_1MXN
              ).toFixed(2);
              $scope.vend.total_final = parseFloat(
                $scope.vend.subtotal_1 - $scope.vend.go_final
              ).toFixed(2);
              $scope.vend.total_finalMXN = parseFloat(
                $scope.vend.subtotal_1MXN - $scope.vend.go_finalMXN
              ).toFixed(2);
              $scope.vend.concepts = response.concepts;
              $scope.vendedorTodos = angular.copy($scope.vend);
              $scope.originalCalculos = angular.copy($scope.vend);
              $scope.vend.conceptos_grales.forEach(function (concpt, idcb) {
                $scope.vend.conceptos_grales[idcb].checked = true;
              });
              // $scope.checkRecGralInicial($scope.vend.conceptos_grales,$scope.vend,$scope.originalCalculos)
              if (response.valores && response["valores"]["total"]) {
                var val_results = response.valores;
                $scope.originalCalculos.subtotal_1 =
                  val_results["subtotal_final_suma"];
                $scope.vend.total_abonos_grales = val_results["abonos_grales"];
                $scope.vend.total_cargos_grales = val_results["cargos_grales"];
                $scope.vend.total_abonos_individuales =
                  val_results["abonos_individuales"];
                $scope.vend.total_cargos_individuales =
                  val_results["cargos_individuales"];
                $scope.vend.sumas_bonos = val_results["sumasabonos"];
                $scope.vend.sumas_cargos = val_results["sumascargos"];
                $scope.subtotal_1_1 = val_results["subtotal_cargos_abonos"];
                $scope.vend.go_final = val_results["go"];
                $scope.total_final_1 = val_results["total"];
              } else {
                var val_results = 0;
                // $scope.originalCalculos.subtotal_1
                $scope.originalCalculos.subtotal_1 = 0;
                $scope.vend.total_abonos_grales = 0;
                $scope.vend.total_cargos_grales = 0;
                $scope.vend.total_abonos_individuales = 0;
                $scope.vend.total_cargos_individuales = 0;
                $scope.vend.sumas_bonos = 0;
                $scope.vend.sumas_cargos = 0;
                $scope.subtotal_1_1 = 0;
                $scope.vend.go_final = 0;
                if (response.data && response.data.data) {
                  $scope.checkRecGralInicial(
                    $scope.vend.conceptos_grales,
                    $scope.vend,
                    $scope.originalCalculos
                  );
                }
              }
            }
          })
          .error(function (response) {})
          .catch(function (response) {});
      } else {
        $scope.active();
        $scope.show_vendedores = true;
      }
    };

    function validateEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
    $scope.seleccionarTodos = function (valuee, vendedor) {
      var listarecibos = [];
      $scope.sellerReceipt_add.forEach(function (rec, idx) {
        $scope.sellerReceipt_add[idx] = valuee;
        listarecibos.push(idx);
      });
      var datasend = {
        valor: valuee,
        vendedor: vendedor.value,
        recibos: listarecibos,
        generales: vendedor.conceptos_grales,
        subtotal: vendedor.subtotal,
        porce_vendedor_go: vendedor.vendedor_go,
        conceptos: vendedor.concepts,
      };
      dataFactory
        .post("calcular-estado-cuenta/", datasend)
        .then(function (request) {
          if (request.status == 200 || request.status == 201) {
            if (request.data && request.data["results"] && valuee) {
              var val_results = request.data["results"];
              $scope.originalCalculos.subtotal_1 =
                val_results["subtotal_final_suma"];
              vendedor.total_abonos_grales = val_results["abonos_grales"];
              vendedor.total_cargos_grales = val_results["cargos_grales"];
              vendedor.total_abonos_individuales =
                val_results["abonos_individuales"];
              vendedor.total_cargos_individuales =
                val_results["cargos_individuales"];
              vendedor.sumas_bonos = val_results["sumasabonos"];
              vendedor.sumas_cargos = val_results["sumascargos"];
              $scope.subtotal_1_1 = val_results["subtotal_cargos_abonos"];
              vendedor.go_final = val_results["go"];
              $scope.total_final_1 = val_results["total"];
            } else {
              var val_results = 0;
              // $scope.originalCalculos.subtotal_1
              $scope.originalCalculos.subtotal_1 = 0;
              vendedor.total_abonos_grales = 0;
              vendedor.total_cargos_grales = 0;
              vendedor.total_abonos_individuales = 0;
              vendedor.total_cargos_individuales = 0;
              vendedor.sumas_bonos = 0;
              vendedor.sumas_cargos = 0;
              $scope.subtotal_1_1 = 0;
              vendedor.go_final = 0;
              $scope.total_final_1 = 0;
            }
          } else {
            SweetAlert.swal(
              "ERROR",
              "Ha ocurrido un error al calcular el estado de cuenta",
              "error"
            );
            return;
          }
        });
      // if(!valuee){
      //   vendedor.subtotal_1=0
      //   vendedor.go_final=0
      //   vendedor.total_final=0
      // }else{
      //   vendedor.subtotal_1=$scope.vendedorTodos.subtotal_1;
      //   vendedor.go_final=$scope.vendedorTodos.go_final;
      //   vendedor.total_final=$scope.vendedorTodos.total_final;
      //   vendedor.conceptos_grales = $scope.vendedorTodos.conceptos_grales;
      //   vendedor.concepts = $scope.vendedorTodos.concepts;
      // }
    };
    // obtenerSoloSeleccionados(vend.conceptos_grales,vend.concepts,vend,originalCalculos)
    $scope.obtenerSoloSeleccionados = function (
      conceptos_grales,
      concepts,
      vend,
      originalCalculos
    ) {
      var listareciboso = [];
      $scope.sellerReceipt_add.forEach(function (rec, idx) {
        if (rec) {
          listareciboso.push(idx);
        }
      });
      var datasend = {
        valor: true,
        vendedor: vend.value,
        recibos: listareciboso,
        generales: vend.conceptos_grales,
        subtotal: vend.subtotal,
        porce_vendedor_go: vend.vendedor_go,
        conceptos: vend.concepts,
      };
      dataFactory
        .post("calcular-estado-cuenta/", datasend)
        .then(function (request) {
          if (request.status == 200 || request.status == 201) {
            if (request.data && request.data["results"]) {
              var val_results = request.data["results"];
              $scope.originalCalculos.subtotal_1 =
                val_results["subtotal_final_suma"];
              vend.total_abonos_grales = val_results["abonos_grales"];
              vend.total_cargos_grales = val_results["cargos_grales"];
              vend.total_abonos_individuales =
                val_results["abonos_individuales"];
              vend.total_cargos_individuales =
                val_results["cargos_individuales"];
              vend.sumas_bonos = val_results["sumasabonos"];
              vend.sumas_cargos = val_results["sumascargos"];
              $scope.subtotal_1_1 = val_results["subtotal_cargos_abonos"];
              vend.go_final = val_results["go"];
              $scope.total_final_1 = val_results["total"];
            } else {
              var val_results = 0;
              $scope.originalCalculos.subtotal_1 = 0;
              vend.total_abonos_grales = 0;
              vend.total_cargos_grales = 0;
              vend.total_abonos_individuales = 0;
              vend.total_cargos_individuales = 0;
              vend.sumas_bonos = 0;
              vend.sumas_cargos = 0;
              $scope.subtotal_1_1 = 0;
              vend.go_final = 0;
              $scope.total_final_1 = 0;
            }
          } else {
            SweetAlert.swal(
              "ERROR",
              "Ha ocurrido un error al calcular el estado de cuenta",
              "error"
            );
            return;
          }
        });
    };
    $scope.shareState = function (state) {
      var modalInstance = $uibModal.open({
        //jshint ignore:line
        templateUrl: "app/agentes/pago.enviarMail.html",
        controller: assignModalView,
        controllerAs: "vmm",
        ////windowClass: 'animated fadeIn',
        size: "lg",
        // resolve:{'rn':receipt.recibo_numero,'recibo':receipt},
        resolve: {
          state: function () {
            return state;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    function assignModalView(
      $scope,
      $uibModalInstance,
      state,
      url,
      toaster,
      MESSAGES,
      FileUploader,
      $sessionStorage
    ) {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var usr = JSON.parse(decryptedUser);
      var token = JSON.parse(decryptedToken);
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      $scope.adjFiles = false;
      $scope.stateaccount = state;
      $scope.email_assigns = state.vendedor.email;
      $scope.emails = [];
      $scope.addEmail = function (email) {
        if (validateEmail(email) == false) {
          toaster.error(MESSAGES.ERROR.INVALIDEMAIL);
          return;
        } else {
          $scope.emails.push(email);
          $scope.email_assigns = "";
        }
      };
      $scope.adjFilesOK = function (val) {
        $scope.adjFiles = val;
        $http
          .get(url.IP + "estado-cuenta/" + state.id + "/archivos/")
          .then(function (response) {
            if (response.status === 200) {
              vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.files.forEach(function (file) {
                file["to_send"] = false;
              });
              $scope.show_files_policy = true;
            }
          });
      };
      /** Uploader files **/
      $scope.userInfo = {
        id: 0,
      };
      $scope.countFile = 0;
      $scope.okFile = 0;

      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      //     name: 'customFilter',
      //     fn: function(item, options) {
      //         return this.queue.length < 20;
      //     }
      // });
      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        SweetAlert.swal("ERROR", MESSAGES.ERROR.ERRORONUPLOADFILES, "error");
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
        });

        if (fileItem) {
          $scope.countFile++;
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        if (item.file.sensible != undefined) {
          item.formData[0].sensible = item.file.sensible;
        }
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
      };

      vm.uploadFiles = uploadFiles;
      function uploadFiles(reciboId) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        $scope.userInfo = {
          id: reciboId,
        };
        $scope.uploadOk = false;
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
        $scope.uploader.queue.forEach(function (ch, index) {
          var str = ch.file.name;
          var regex = /[^\w\s]/gi;
          for (i = 0; i < specialChars.length; i++) {
            if (str.indexOf(specialChars[i]) > -1) {
              $scope.uploadOk = true;
              SweetAlert.swal(
                "Error",
                "El nombre de archivo: " +
                  str +
                  ", contiene carácteres especiales, renombre y, vuelva a cargarlo. " +
                  specialChars[i],
                "error"
              );
              $scope.uploader.queue.splice(
                $scope.uploader.queue.indexOf(ch),
                1
              );
              return;
            } else {
              $scope.uploadOk = true;
            }
          }
        });
        if ($scope.uploadOk) {
          $scope.userInfo.url = $scope.uploader.url =
            url.IP + "estado-cuenta/" + reciboId + "/archivos/";
          $scope.files = [];
          $scope.uploader.queue = [];
        }

        $timeout(function () {
          $scope.uploader.uploadAll();
          // $scope.adjFiles = false
        }, 1000);
      }
      $scope.noFiles = false;
      $scope.saveFiles = function (id) {
        $scope.id_recibo = id;
        $scope.userInfo.id = $scope.stateaccount.id;
        $scope.uploadOk = true;
        if ($scope.uploadOk) {
          $scope.userInfo.url = $scope.uploader.url =
            url.IP + "estado-cuenta/" + id + "/archivos/";
          $scope.uploader.uploadAll();
          // $scope.adjFiles = false
        }
        $http
          .get(url.IP + "estado-cuenta/" + id + "/archivos/")
          .then(function (response) {
            if (response.status === 200) {
              vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.files.forEach(function (file) {
                file["to_send"] = false;
              });
              $scope.noFiles = true;
            }
          });
      };
      $scope.shareFileEmail = function (file) {
        if (file.to_send) {
          file.to_send = false;
        } else {
          file.to_send = true;
        }
        $scope.share_via_email = [];
        $scope.files.forEach(function (filex) {
          if (filex.to_send) {
            $scope.share_via_email.push(filex.id);
          }
        });
      };
      $scope.sendEmail = function (subject, message) {
        var l = Ladda.create(document.querySelector(".ladda-button"));
        l.start();
        if ($scope.emails.length > 0) {
          $http
            .post(url.IP + "send-email-vendor-state/", {
              pdf_name: "pdf",
              id: state.id,
              emails: $scope.emails,
              subject: subject,
              message: message,
              files: $scope.share_via_email,
            })
            .then(
              function success(request) {
                if (request.status === 200 || request.status === 201) {
                  toaster.success("El estado de cuenta ha sido enviado");
                  $uibModalInstance.dismiss("cancel");
                } else {
                  toaster.warning(
                    "No se envió el estado de cuenta. Contacte a su administrador."
                  );
                  l.stop();
                }
              },
              function error(error) {
                console.log("error - email", error);
              }
            )
            .catch(function (e) {
              console.log("error - catch", e);
            });
        } else {
          toaster.warning(MESSAGES.WARNING.EMPTYEMAIL);
          l.stop();
        }
      };

      $scope.cancel = function () {
        if ($uibModalInstance) $uibModalInstance.dismiss("cancel");
      };
    }

    $scope.generarPdf = function (estado) {
      dataFactory
        .get("get-pdf-agentes/" + "?id_estado=" + estado.id + "&")
        .then(function (response) {
          var file = new Blob([response.data], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          } else {
            var fileURL = URL.createObjectURL(file);
            $scope.content = $sce.trustAsResourceUrl(fileURL);
            window.open($scope.content);
          }
        });
    };

    $scope.returnToProvider = function () {
      $scope.show_binnacle = false;
    };

    //-----------------------------------------------------------comments
    $scope.showBinnacle = function (estado) {
      $scope.show_binnacle = true;
      $scope.current_state = estado.id;
      $http({
        method: "GET",
        url: url.IP + "comments/",
        params: {
          model: 12,
          id_model: estado.id,
        },
      })
        .then(function (request) {
          $scope.comments_data = request.data.results;
          $scope.comments_config = {
            count: request.data.count,
            previous: request.data.previous,
            next: request.data.next,
          };
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    function exportBinnacleComments() {
      if (
        !$scope.current_state ||
        $scope.commentsExportLoading ||
        !($scope.comments_data && $scope.comments_data.length)
      ) {
        return;
      }

      $scope.commentsExportLoading = true;

      var resetLoading = function () {
        $scope.commentsExportLoading = false;
      };

      var authToken = "";
      try {
        var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
        authToken = JSON.parse(decryptedToken);
      } catch (error) {
        authToken = "";
      }

      var bearerToken =
        authToken && authToken.token ? authToken.token : authToken;

      var params = {
        model: 12,
        id_model: $scope.current_state,
      };
      if (userOrgName) {
        params.org = userOrgName;
      }

      toaster.info(
        "Generando...",
        "El archivo se está generando, espera un momento."
      );
      exportFactory
        .commentsExport({
          params: params,
          downloadName: "bitacora-estados.xlsx",
          token: bearerToken,
        })
        .then(function () {
          SweetAlert.swal({
            title: "Listo",
            icon: "success",
            text: "La bitacora se descargo exitosamente",
            timer: 5000,
          });
        })
        .catch(function (error) {
          console.error("Error exportando comentarios", error);
          SweetAlert.swal(
            "Error",
            "No se pudo exportar los comentarios. Intenta nuevamente.",
            "error"
          );
        })
        .finally(function () {
          resetLoading();
        });
    }

    //-------------------------------------------------------------comments

    $scope.showAllInformation = function (item, param) {
      $scope.showInformation = true;
      $scope.hideInformation = false;

      if (item == 1) {
        $scope.showPayRecipt = false;
      } else {
        $scope.showPayRecipt = true;
      }

      $scope.getInfoPolicy(param);
    };
    $scope.hideAllInformation = function () {
      $scope.showInformation = false;
      $scope.hideInformation = true;
    };
    $scope.comisiones_calculadas = 0;
    $scope.calculateCommission = function (
      prima,
      comision,
      cambiar_comision_al_vendedor,
      comision_al_vendedor
    ) {
      if (cambiar_comision_al_vendedor) {
        return comision_al_vendedor;
      }
      comision = parseFloat(comision);
      prima = parseFloat(prima);
      if (comision >= 0) {
        return (prima * (comision / 100.0)).toFixed(2);
      } else {
        return 0;
      }
    };

    /*Estado de cuenta*/

    $scope.viewReceipts = function (estado) {
      $state.go("agentes.receipts", { folioId: estado.id });
    };

    $scope.goToPay = function (item) {
      if (item) {
        $scope.paymentsData = item;
      }
      var modalInstance = $uibModal.open({
        templateUrl: "app/agentes/pago.pagare.html",
        controller: PagoAgentesModalCtrl,
        controllerAs: "vmm",
        size: "lg",
        resolve: {
          payModal: function () {
            return $scope.paymentsData;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
    };

    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    /*Controlador del modal*/

    function PagoAgentesModalCtrl(
      $scope,
      $state,
      FileUploader,
      $sessionStorage,
      $uibModalInstance,
      payModal
    ) {
      $scope.pay = [];
      if (payModal) {
        $scope.inputDisabled = true;
        $scope.pay.referenciador = payModal.referenciador;
        $scope.pay.fecha = payModal.fecha;
        $scope.pay.banco = payModal.banco;
        $scope.pay.num_cuenta = payModal.num_cuenta;
        $scope.pay.num_transaccion = payModal.num_transaccion;
        $scope.pay.importe = payModal.importe;
      } else {
        $scope.inputDisabled = false;
        // $scope.pay.fecha = $scope.convertDate(new Date());
        $scope.pay.fecha = new Date();
      }

      $scope.convertDate = function (inputFormat) {
        function inputDate(days) {
          return days < 10 ? "0" + days : days;
        }
        var dateFormat = new Date(inputFormat);
        var date = [
          inputDate(dateFormat.getDate()),
          inputDate(dateFormat.getMonth() + 1),
          dateFormat.getFullYear(),
        ].join("/");
        return date;
      };

      $scope.demo = function (param) {
        var model = formatValues.currency(param);
        return model;
      };

      var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
      var token = JSON.parse(decryptedToken);

      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      // 	name: 'customFilter',
      // 	fn: function(item, options){
      // 		return this.queue.length < 20;
      // 	}
      // });

      // ALERTA SUCCES UPLOADFILES --aqui
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        // if($location.path() == '/contratantes/crear'){
        // 	$location.path('/contratantes/lista');
        // }
        // else{
        // 	$rootScope.show_contractor = false;
        // }

        $rootScope.show_contractor = false;
        toaster.success(MESSAGES.OK.NEWCONTRACTOR);
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        toaster.error(MESSAGES.ERROR.ERRORONUPLOADFILES);
      };

      uploader.onAfterAddingFile = function (fileItem) {
        $scope.array_files = true;
        $scope.specialchar = [];
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
        var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        var str = fileItem.file.name;
        for (i = 0; i < specialChars.length; i++) {
          if (str.indexOf(specialChars[i]) > -1) {
            if (
              specialChars[i] == " " ||
              specialChars[i] == "_" ||
              specialChars[i] == "~" ||
              specialChars[i] == "%" ||
              specialChars[i] == "=" ||
              specialChars[i] == "-" ||
              specialChars[i] == " " ||
              specialChars[i] == "_" ||
              specialChars[i] == "#" ||
              specialChars[i] == "(" ||
              specialChars[i] == ")" ||
              specialChars[i] == ":" ||
              specialChars[i] == '"'
            ) {
              str = str.replace(/-/g, "");
              fileItem.file.name = fileItem.file.name.replace(/-/g, "");
              str = str.replace(/ /g, "");
              fileItem.file.name = fileItem.file.name.replace(/ /g, "");
              str = str.replace(/_/g, "");
              fileItem.file.name = fileItem.file.name.replace(/_/g, "");
              str = str.replace(/#/g, "");
              fileItem.file.name = fileItem.file.name.replace(/#/g, "");
              str = str.split(")").join("");
              fileItem.file.name = fileItem.file.name.split(")").join("");
              str = str.split("(").join("");
              fileItem.file.name = fileItem.file.name.split("(").join("");
              str = str.split(":").join("");
              fileItem.file.name = fileItem.file.name.split(":").join("");
              str = str.split('"').join("");
              fileItem.file.name = fileItem.file.name.split('"').join("");
              str = str.split("+").join("");
              fileItem.file.name = fileItem.file.name.split("+").join("");
              str = str.split("$").join("");
              fileItem.file.name = fileItem.file.name.split("$").join("");
              str = str.split("#").join("");
              fileItem.file.name = fileItem.file.name.split("#").join("");
              str = str.split("$#").join("");
              fileItem.file.name = fileItem.file.name.split("$#").join("");
              str = str.split("~").join("");
              fileItem.file.name = fileItem.file.name.split("~").join("");
              str = str.split("%").join("");
              fileItem.file.name = fileItem.file.name.split("%").join("");
              str = str.split("=").join("");
              fileItem.file.name = fileItem.file.name.split("=").join("");
              str = str.split("_").join("");
              fileItem.file.name = fileItem.file.name.split("_").join("");
              str = str.split(" ").join("");
              fileItem.file.name = fileItem.file.name.split(" ").join("");
            } else {
              $scope.specialchar.push(specialChars[i]);
            }
          }
        }
        fileItem.file.name = fileItem.file.name
          .replace(/[&\/\\#^+()$~%'":*=_?<>{}!@]/g, "")
          .replace(/ /g, "");
        fileItem.file.name = fileItem.file.name.trim();
        fileItem.formData.push({
          arch: fileItem._file,
          nombre: fileItem.file.name,
        });
        if ($scope.specialchar.length > 0) {
          $scope.uploader.queue.splice(
            $scope.uploader.queue.indexOf(fileItem),
            1
          );
          SweetAlert.swal(
            "Error",
            "El nombre de archivo: " +
              str +
              ", contiene carácteres especiales: " +
              $scope.specialchar,
            "error"
          );
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
      };

      $(".datepicker-me input").datepicker();
      $.fn.datepicker.defaults.format = "dd/mm/yyyy";
      $.fn.datepicker.defaults.startView = 2;
      $.fn.datepicker.defaults.autoclose = true;
      $.fn.datepicker.defaults.language = "es";
    }

    function PagoAgentesModalController(
      $scope,
      policyModal,
      contractorModal,
      $uibModalInstance,
      $state,
      $sessionStorage
    ) {
      var vmm = this;
      vmm.cancel = cancel;
      vmm.accesos = $sessionStorage.permisos;
      if (vmm.accesos) {
        vmm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vmm.acceso_polizas = perm;
            vmm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vmm.acceso_adm_pol = true;
                } else {
                  vmm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vmm.acceso_ver_pol = true;
                } else {
                  vmm.acceso_ver_pol = false;
                }
              } else if (acc.permission_name == "Cancelar pólizas") {
                if (acc.checked == true) {
                  vmm.acceso_canc_pol = true;
                } else {
                  vmm.acceso_canc_pol = false;
                }
              } else if (acc.permission_name == "Eliminar pólizas") {
                if (acc.checked == true) {
                  vmm.acceso_elim_pol = true;
                } else {
                  vmm.acceso_elim_pol = false;
                }
              }
            });
          }
        });
      }

      $scope.info_policy = policyModal;
      $scope.info_contractor = contractorModal;

      $scope.goToPolicy = function (insurance) {
        if (insurance.document_type == 1) {
          $state.go("polizas.info", { polizaId: insurance.id });
        } else if (insurance.document_type == 3) {
          $state.go("colectividades.info", { polizaId: insurance.id });
        }
        cancel();
      };

      $http
        .get(url.IP + "polizas/" + $scope.info_policy.id + "/archivos/")
        .then(function (response) {
          $scope.files = response.data.results;
        });

      function cancel() {
        $uibModalInstance.dismiss("cancel");
      }
    }

    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }
      $scope.selectPage = function (parPage) {
        $scope.main_estados = [];
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;

            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&status=") !== -1) {
              var status = prev_.substring(prev_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params + "&";
            }
          }
        }

        // url += '&status=1
        getSinisterPag(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getSinisterPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }

    $scope.fake_ramos = [
      {
        id: -1,
        ramo_code: -1,
        ramo_name: "Vida",
        subramo_ramo: [
          {
            id: -1,
            subramo_code: -1,
            subramo_name: "Vida",
          },
        ],
      },
      {
        id: -2,
        ramo_code: -2,
        ramo_name: "Accidentes y Enfermedades",
        subramo_ramo: [
          {
            id: -2,
            subramo_code: -2,
            subramo_name: "Accidentes Personales",
          },
          {
            id: -3,
            subramo_code: -3,
            subramo_name: "Gastos Médicos",
          },
          {
            id: -4,
            subramo_code: -4,
            subramo_name: "Salud",
          },
        ],
      },
      {
        id: -3,
        ramo_code: -3,
        ramo_name: "Daños",
        subramo_ramo: [
          {
            id: -5,
            subramo_code: -5,
            subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
          },
          {
            id: -6,
            subramo_code: -6,
            subramo_name: "Marítimo y Transportes",
          },
          {
            id: -7,
            subramo_code: -7,
            subramo_name: "Incendio",
          },
          {
            id: -8,
            subramo_code: -8,
            subramo_name: "Agrícola y de Animales",
          },
          {
            id: -9,
            subramo_code: -9,
            subramo_name: "Automóviles",
          },
          {
            id: -10,
            subramo_code: -10,
            subramo_name: "Crédito",
          },
          {
            id: -11,
            subramo_code: -11,
            subramo_name: "Crédito a la Vivienda",
          },
          {
            id: -12,
            subramo_code: -12,
            subramo_name: "Garantía Financiera",
          },
          {
            id: -13,
            subramo_code: -13,
            subramo_name: "Diversos",
          },
          {
            id: -14,
            subramo_code: -14,
            subramo_name: "Terremoto y Otros Riesgos Catastróficos",
          },
        ],
      },
    ];

    $scope.afianzadoras_ramos = [
      {
        id: -4,
        ramo_code: -4,
        ramo_name: "Fidelidad",
        subramo_ramo: [
          {
            id: -15,
            subramo_code: -15,
            subramo_name: "Individual",
          },
          {
            id: -16,
            subramo_code: -16,
            subramo_name: "Colectivas",
          },
        ],
      },
      {
        id: -5,
        ramo_code: -5,
        ramo_name: "Judiciales",
        subramo_ramo: [
          {
            id: -17,
            subramo_code: -17,
            subramo_name: "Penales",
          },
          {
            id: -18,
            subramo_code: -18,
            subramo_name: "No Penales",
          },
          {
            id: -19,
            subramo_code: -19,
            subramo_name: "Amparo a conductores",
          },
        ],
      },
      {
        id: -6,
        ramo_code: -6,
        ramo_name: "Administrativas",
        subramo_ramo: [
          {
            id: -20,
            subramo_code: -20,
            subramo_name: "Obra",
          },
          {
            id: -21,
            subramo_code: -21,
            subramo_name: "Proveeduria",
          },
          {
            id: -22,
            subramo_code: -22,
            subramo_name: "Fiscales",
          },
          {
            id: -23,
            subramo_code: -23,
            subramo_name: "Arrendamiento",
          },
          {
            id: -24,
            subramo_code: -24,
            subramo_name: "Obras Administrativas",
          },
        ],
      },
      {
        id: -7,
        ramo_code: -7,
        ramo_name: "Crédito",
        subramo_ramo: [
          {
            id: -25,
            subramo_code: -25,
            subramo_name: "Suministro",
          },
          {
            id: -26,
            subramo_code: -26,
            subramo_name: "Compra venta",
          },
        ],
      },
      {
        id: -8,
        ramo_code: -8,
        ramo_name: "Fideicomiso",
        subramo_ramo: [
          {
            id: -27,
            subramo_code: -27,
            subramo_name: "Otras Administrativas",
          },
          {
            id: -28,
            subramo_code: -28,
            subramo_name: "Relación con fianza",
          },
          {
            id: -29,
            subramo_code: -29,
            subramo_name: "Sin relación con fianza",
          },
        ],
      },
    ];
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller("PagoAgentesAdminController", PagoAgentesAdminController);
  PagoAgentesAdminController.$inject = [
    "$scope",
    "$http",
    "$state",
    "url",
    "formatValues",
    "SweetAlert",
    "MESSAGES",
    "providerService",
    "dataFactory",
    "datesFactory",
    "$parse",
    "$uibModal",
  ];

  function PagoAgentesAdminController(
    $scope,
    $http,
    $state,
    url,
    formatValues,
    SweetAlert,
    MESSAGES,
    providerService,
    dataFactory,
    datesFactory,
    $parse,
    $uibModal
  ) {
    var vm = this;

    $scope.users = [];
    $scope.seller = [];
    $scope.isSeller = [];
    // $scope.valida = valida;

    $scope.pay_ways = [
      { key: 1, val: "Clabe" },
      { key: 2, val: "Número de cuenta" },
      { key: 3, val: "Número de tarjeta" },
      { key: 4, val: "Efectivo" },
    ];

    $scope.fcs = [
      { key: 1, val: "Semanal" },
      { key: 2, val: "Quincenal" },
      { key: 3, val: "Mensual" },
    ];

    $scope.fake_ramos = [
      {
        id: -1,
        ramo_code: -1,
        ramo_name: "Vida",
        subramo_ramo: [
          {
            id: -1,
            subramo_code: -1,
            subramo_name: "Vida",
          },
        ],
      },
      {
        id: -2,
        ramo_code: -2,
        ramo_name: "Accidentes y Enfermedades",
        subramo_ramo: [
          {
            id: -2,
            subramo_code: -2,
            subramo_name: "Accidentes Personales",
          },
          {
            id: -3,
            subramo_code: -3,
            subramo_name: "Gastos Médicos",
          },
          {
            id: -4,
            subramo_code: -4,
            subramo_name: "Salud",
          },
        ],
      },
      {
        id: -3,
        ramo_code: -3,
        ramo_name: "Daños",
        subramo_ramo: [
          {
            id: -5,
            subramo_code: -5,
            subramo_name: "Responsabilidad Civil y Riesgos Profesionales",
          },
          {
            id: -6,
            subramo_code: -6,
            subramo_name: "Marítimo y Transportes",
          },
          {
            id: -7,
            subramo_code: -7,
            subramo_name: "Incendio",
          },
          {
            id: -8,
            subramo_code: -8,
            subramo_name: "Agrícola y de Animales",
          },
          {
            id: -9,
            subramo_code: -9,
            subramo_name: "Automóviles",
          },
          {
            id: -10,
            subramo_code: -10,
            subramo_name: "Crédito",
          },
          {
            id: -11,
            subramo_code: -11,
            subramo_name: "Crédito a la Vivienda",
          },
          {
            id: -12,
            subramo_code: -12,
            subramo_name: "Garantía Financiera",
          },
          {
            id: -13,
            subramo_code: -13,
            subramo_name: "Diversos",
          },
          {
            id: -14,
            subramo_code: -14,
            subramo_name: "Terremoto y Otros Riesgos Catastróficos",
          },
        ],
      },
    ];

    $scope.afianzadoras_ramos = [
      {
        id: -4,
        ramo_code: -4,
        ramo_name: "Fidelidad",
        subramo_ramo: [
          {
            id: -15,
            subramo_code: -15,
            subramo_name: "Individual",
          },
          {
            id: -16,
            subramo_code: -16,
            subramo_name: "Colectivas",
          },
        ],
      },
      {
        id: -5,
        ramo_code: -5,
        ramo_name: "Judiciales",
        subramo_ramo: [
          {
            id: -17,
            subramo_code: -17,
            subramo_name: "Penales",
          },
          {
            id: -18,
            subramo_code: -18,
            subramo_name: "No Penales",
          },
          {
            id: -19,
            subramo_code: -19,
            subramo_name: "Amparo a conductores",
          },
        ],
      },
      {
        id: -6,
        ramo_code: -6,
        ramo_name: "Administrativas",
        subramo_ramo: [
          {
            id: -20,
            subramo_code: -20,
            subramo_name: "Obra",
          },
          {
            id: -21,
            subramo_code: -21,
            subramo_name: "Proveeduria",
          },
          {
            id: -22,
            subramo_code: -22,
            subramo_name: "Fiscales",
          },
          {
            id: -23,
            subramo_code: -23,
            subramo_name: "Arrendamiento",
          },
          {
            id: -24,
            subramo_code: -24,
            subramo_name: "Obras Administrativas",
          },
        ],
      },
      {
        id: -7,
        ramo_code: -7,
        ramo_name: "Crédito",
        subramo_ramo: [
          {
            id: -25,
            subramo_code: -25,
            subramo_name: "Suministro",
          },
          {
            id: -26,
            subramo_code: -26,
            subramo_name: "Compra venta",
          },
        ],
      },
      {
        id: -8,
        ramo_code: -8,
        ramo_name: "Fideicomiso",
        subramo_ramo: [
          {
            id: -27,
            subramo_code: -27,
            subramo_name: "Otras Administrativas",
          },
          {
            id: -28,
            subramo_code: -28,
            subramo_name: "Relación con fianza",
          },
          {
            id: -29,
            subramo_code: -29,
            subramo_name: "Sin relación con fianza",
          },
        ],
      },
    ];

    $scope.delete_subramos = [];
    $scope.delete_subramos_referenciador = [];
    $scope.delete_phones = [];

    vm.subramo = {
      ramos: $scope.fake_ramos,
      sub_ramos: "",
      provider: "",
      ramo: "",
      subramo: "",
      comision_percentage: "",
    };

    //$http.get(url.IP + 'usuarios/')
    $http.get(url.IP + "userslist_admin/").then(function (user) {
      //$scope.users = user.data.results;
      $scope.users = user.data;

      $scope.users.forEach(function (user) {
        user["phones"] = [];
        user["subramos"] = [];
        user["polizas"] = [];
        user["show_binnacle"] = false;
      });

      $scope.show_pagination = true;
      $scope.config_pagination = {
        count: user.data.count,
        next: user.data.next,
        previous: user.data.previous,
      };

      $scope.testPagination("users", "config_pagination");

      providerService.getReadListProviders().then(function (provider) {
        $scope.just_aseguradoras = [];
        $scope.just_afianzadoras = [];
        $scope.aseguradoras = provider;

        $scope.aseguradoras.push(
          {
            compania: " Todas las afianzadoras",
            id: -1,
            url: null,
            rfc: null,
            alias: "Todas afianzadoras",
          },
          {
            compania: " Todos los seguros",
            id: -2,
            url: null,
            rfc: null,
            alias: "Todos seguros",
          }
        );

        $scope.aseguradoras.forEach(function (prov) {
          if (prov.provider_type == 1) {
            $scope.just_aseguradoras.push(prov);
          } else {
            $scope.just_afianzadoras.push(prov);
          }
        });
      });
    });

    $scope.VendorsReport = function () {
      $http({
        method: "GET",
        // url: url.IP +'vendors-report',
        url: url.IP + "service_reporte-vendedores-excel",
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      }).then(function (data, status, headers, config) {
        if (data.status == 200) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte_Referenciadores.xls");
        } else {
          SweetAlert.swal(
            "Error",
            "Ha ocurrido un error al descargar el reporte",
            "error"
          );
        }
      });
    };
    // conceptos generales
    $scope.addConceptosGralesModal = function (conceptos) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/agentes/conceptos.administrador.html",
        controller: "AgenteConceptosGralesModalCtrl",
        size: "lg",
        resolve: {
          conceptos: function () {
            return conceptos;
          },
          data: function () {
            return null;
          },
          associated: function () {
            return null;
          },
          receipt: function () {
            return null;
          },
          route: function () {
            return null;
          },
          modelo: function () {
            return null;
          },
        },
      });
      modalInstance.result.then(
        function (response) {
          // cerrar modal
        },
        function () {
          //close callback
          console.info("modal closed");
        }
      );
    };
    $scope.statusResp = function (parItem, parType) {
      if (parType == 1) {
        parItem.user_info.is_active = false;
      } else if (parType == 2) {
        parItem.user_info.is_active = true;
      }

      $http
        .patch(parItem.user_info.url, {
          is_active: parItem.user_info.is_active,
        })
        .then(function (res) {});
    };
    $scope.convertToUser = function (parItem) {
      $http
        .patch(parItem.user_info.url, {
          is_vendedor: false,
        })
        .then(function (res) {
          if (res.status == 200) {
            parItem.user_info.is_vendedor = false;
          }
        });
    };
    $scope.returnToVendedor = function (vendedor) {
      vendedor.show_binnacle = false;
    };

    $scope.verPolizas = function (vendedor, page) {
      vendedor.show_binnacle = true;
      if (page) {
        page = page;
      } else {
        page = 1;
      }
      $http
        .get(
          url.IP +
            "vendedor-polizas?vendedor=" +
            vendedor.id +
            "&page=" +
            page +
            "&"
        )
        .then(
          function success(response) {
            vendedor.polizas = response.data.results;
            vendedor.polizas = response.data.results;
            vm.polizasV = {
              count: response.data.count,
              previous:
                url.IP +
                "vendedor-polizas?vendedor=" +
                vendedor.id +
                "&page=" +
                page +
                "&",
              next:
                url.IP +
                "vendedor-polizas?vendedor=" +
                vendedor.id +
                "&page=" +
                page +
                "&",
            };
            $scope.testPagination2("vendedor.polizas", "vm.polizasV", vendedor);
            vm.show_pag_policy_v = true;
          },
          function error(error) {
            console.log(error);
          }
        );
    };

    $scope.verFianzas = function (vendedor, page) {
      vendedor.show_binnacle = true;
      if (page) {
        page = page;
      } else {
        page = 1;
      }
      $http
        .get(
          url.IP +
            "vendedor-fianzas?vendedor=" +
            vendedor.id +
            "&page=" +
            page +
            "&"
        )
        .then(
          function success(response) {
            vendedor.polizas = response.data.results;
            vendedor.polizas = response.data.results;
            vm.polizasV = {
              count: response.data.count,
              previous:
                url.IP +
                "vendedor-fianzas?vendedor=" +
                vendedor.id +
                "&page=" +
                page +
                "&",
              next:
                url.IP +
                "vendedor-fianzas?vendedor=" +
                vendedor.id +
                "&page=" +
                page +
                "&",
            };
            $scope.testPagination2("vendedor.polizas", "vm.polizasV", vendedor);
            vm.show_pag_policy_v = true;
          },
          function error(error) {
            console.log(error);
          }
        );
    };
    $scope.edosCuentas = function (vendedor) {
      var params = {
        vendedor: vendedor.id,
      };
      $http({
        method: "POST",
        // url: url.IP+'edos-cuenta-by-referenciador/',
        url: url.IP + "service_reporte-vendedorEdoCuenta-excel",
        data: params,
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then(function (data, status, headers, config) {
          var blob = new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Edos_cuenta_Recibos.xls");
        })
        .catch(function (e) {
          console.log("e", e);
        });
    };

    $scope.checkSelected = function (value, parUser, tipo) {
      try {
        parUser.user_info.info_vendedor[0].concepts =
          parUser.user_info.info_vendedor[0].concepts.split("'").join('"');
        parUser.user_info.info_vendedor[0].concepts =
          parUser.user_info.info_vendedor[0].concepts.split("None").join('""');
        if (typeof parUser.user_info.info_vendedor[0].concepts == "string") {
          parUser.user_info.info_vendedor[0].concepts = JSON.parse(
            parUser.user_info.info_vendedor[0].concepts
          );
        }
      } catch (ee) {
        if (parUser.user_info.info_vendedor.length == 0) {
          parUser.user_info.info_vendedor[0] = {};
          parUser.user_info.info_vendedor[0].concepts = [
            {
              concept: "Gastos de Operación",
              cantidad: 0,
              value: 0,
              tipo_calculo: 2,
              calculo: 2,
              checked: true,
              disabled: true,
              id: 1,
            },
          ];
        } else {
          console.log("--", parUser.user_info.info_vendedor);
        }
      }
      if (value) {
        $http.get(url.IP + "bancos/").then(function (bank) {
          $scope.banks = bank.data;

          if (parUser.user_info) {
            if (
              parUser.user_info.is_vendedor ||
              parUser.user_info.info_vendedor.length
            ) {
              var seller_data = parUser.user_info.info_vendedor[0];
              $scope.original_data = vendedorStructure(parUser, seller_data);
            }
          } else {
            parUser.hired_date = datesFactory.convertDate(new Date());
          }
        });
      } else {
        $scope.users.forEach(function (user) {
          if (parUser.id == user.id) {
            user["phones"] = [];
            user["subramos"] = [];
          }
        });
      }
    };

    function vendedorStructure(parUser, parData) {
      if (parData.hired_date) {
        var date = new Date(parData.hired_date);
      } else {
        var date = new Date();
      }
      parUser.hired_date = datesFactory.convertDate(date);
      parUser.reference_number = parData.reference_number;
      parUser.gastos_operacion = parData.gastos_operacion;
      parUser.address = parData.address;
      parUser.email = parData.email;
      parUser.url = parData.url;

      $scope.banks.forEach(function (bank) {
        if (bank.id == parData.bank) {
          parUser.bank = bank;
        }
      });

      $scope.fcs.forEach(function (frec) {
        if (frec.key == parData.frequencia_de_cobro) {
          parUser.frequencia_de_cobro = frec;
        }
      });

      $scope.pay_ways.forEach(function (pay) {
        if (pay.key == parData.tipo_pago) {
          parUser.pay_way = pay;
        }
      });
      if (parData.vendedor_phone) {
        if (parData.vendedor_phone.length) {
          if (parData.vendedor_phone.length == 1) {
            parUser.phone = parData.vendedor_phone[0].phone;
          } else if (parData.vendedor_phone.length > 1) {
            parData.vendedor_phone.forEach(function (phone, index) {
              if (index == 0) {
                parUser.phone = parData.vendedor_phone[0].phone;
              } else {
                parUser.phones.push(phone.phone);
              }
            });
          }
        }
      }
      if (parData.vendedor_subramos) {
        parData.vendedor_subramos.forEach(function (sub_ramo) {
          var data = {
            provider: sub_ramo.provider,
            ramo: sub_ramo.ramo,
            subramo: sub_ramo.subramo,
            comision_percentage: sub_ramo.comision,
            comision: sub_ramo.comision,
            id: sub_ramo.id,
            url: sub_ramo.url,
            ramos: $scope.fake_ramos,
          };

          $scope.aseguradoras.forEach(function (provider) {
            if (sub_ramo.provider == 0 && sub_ramo.ramo != 0) {
              data.ramos = $scope.fake_ramos;

              data.ramos.forEach(function (ramo) {
                if (ramo.id == sub_ramo.ramo) {
                  data.ramo = ramo;
                  data.sub_ramos = ramo.subramo_ramo;

                  ramo.subramo_ramo.forEach(function (sub) {
                    if (sub.id == sub_ramo.subramo) {
                      data.subramo = sub;
                    }
                  });
                }
              });
            } else if (sub_ramo.provider == -2 && !data.ramos.length) {
              data.ramos = $scope.fake_ramos;
            } else if (sub_ramo.provider == -1 && !data.ramos.length) {
              data.ramos = $scope.afianzadoras_ramos;
            } else if (provider.id == sub_ramo.provider) {
              data.provider = provider;
              if (provider.id < 0) {
                if (provider.id == -1) {
                  data.ramos = $scope.afianzadoras_ramos;
                } else if (provider.id == -2) {
                  data.ramos = $scope.fake_ramos;
                }

                data.ramos.forEach(function (ramo) {
                  if (ramo.id == sub_ramo.ramo) {
                    data.ramo = ramo;
                    data.sub_ramos = ramo.subramo_ramo;

                    ramo.subramo_ramo.forEach(function (sub) {
                      if (sub.id == sub_ramo.subramo) {
                        data.subramo = sub;
                      }
                    });
                  }
                });
              } else {
                $http
                  .get(url.IP + "ramos-by-provider/" + provider.id)
                  .then(function (ramo) {
                    data.ramos = ramo.data;

                    data.ramos.forEach(function (ramo) {
                      if (ramo.id == sub_ramo.ramo) {
                        data.ramo = ramo;
                        data.sub_ramos = ramo.subramo_ramo;

                        ramo.subramo_ramo.forEach(function (sub) {
                          if (sub.id == sub_ramo.subramo) {
                            data.subramo = sub;
                          }
                        });
                      }
                    });
                  });
              }
            }
          });
          if (typeof data.provider == "object") {
            if (data.provider.id == -1) {
              data.ramos = $scope.afianzadoras_ramos;
            } else if ((data.provider.id = -2)) {
              $scope.changeProvider(vm.subramo, data.provider.id);
            }
          }

          parUser.subramos.push(data);
        });
      }
      return angular.copy(parUser);
    }

    $scope.addPhone = function (index) {
      if ($scope.users[index].phones) {
        $scope.users[index].phones.push("");
      } else {
        $scope.users[index].phones = [""];
      }
    };

    $scope.deletePhone = function (index, index2, item) {
      $scope.users[index].phones.splice(index2, 1);

      for (
        var i = 0;
        i <
        $scope.users[index].user_info.info_vendedor[0].vendedor_phone.length;
        i++
      ) {
        if (
          item ===
          $scope.users[index].user_info.info_vendedor[0].vendedor_phone[i].phone
        ) {
          $scope.delete_phones.push(
            $scope.users[index].user_info.info_vendedor[0].vendedor_phone[i]
          );
        }
      }
    };

    $scope.changeProvider = function (sub_ramo, provider) {
      // if(!provider || provider.id == -2 ){
      //     $scope.subramos = []
      //     $scope.ramos = []
      //     sub_ramo.ramos = $scope.fake_ramos;
      //     return
      // } else if(provider.id == -1 ) {
      //     $scope.subramos = []
      //     $scope.ramos = []
      //     sub_ramo.ramos = $scope.afianzadoras_ramos;
      //     return;
      // }
      if (!provider.id == -2) {
        $scope.subramos = [];
        $scope.ramos = [];
        sub_ramo.ramos = $scope.fake_ramos;
        return;
      } else if (provider.id == -2) {
        $scope.subramos = [];
        $scope.ramos = [];
        sub_ramo.ramos = $scope.afianzadoras_ramos;
        return;
      }
      // aseguradoras
      if (provider.id) {
        $http
          .get(url.IP + "ramos-by-provider/" + provider.id)
          .then(function (ramo) {
            sub_ramo.ramos = ramo.data;
          });
      }
    };

    $scope.changeRamo = function (sub_ramo) {
      if (!sub_ramo.ramo) {
        $scope.subramos = [];
        sub_ramo.sub_ramos = [];
        return;
      }

      sub_ramo.sub_ramos = sub_ramo.ramo.subramo_ramo;
    };
    // Promotorias
    $scope.newConcept = {
      value: null,
      model: null,
      tipo_calculo: 1,
      calculo: 1,
      options: [
        { id: 1, name: "$" },
        { id: 2, name: "%" },
      ],
      calculo_options: [
        { id: 1, name: "Suma" },
        { id: 2, name: "Resta" },
      ],
      checked: false,
      disabled: false,
    };
    $scope.concepts = [];

    $scope.tipocalculo_options = [
      { id: 1, name: "$" },
      { id: 2, name: "%" },
    ];
    $scope.calculo_options = [
      { id: 1, name: "Abono" },
      { id: 2, name: "Cargo" },
    ];
    $scope.addConcept = function (uservendor) {
      if (uservendor) {
        if (uservendor.concepts) {
          if (
            typeof uservendor.concepts == "object" &&
            uservendor.concepts.length == 0
          ) {
            uservendor.concepts = [];
          }
        }
      }
      if (
        JSON.stringify(uservendor.concepts) === "{}" ||
        uservendor.concepts == "" ||
        uservendor.concepts == " "
      ) {
        uservendor.concepts = [];
        uservendor.concepts = [
          {
            concept: "Gastos de Operación",
            cantidad: 0,
            value: 0,
            tipo_calculo: 2,
            calculo: 2,
            checked: true,
            disabled: true,
            id: 1,
          },
        ];
      }
      console.log("-ssssssss", uservendor);
      var concept = {
        concept: "",
        cantidad: 0,
        value: 10,
        tipo_calculo: 1,
        calculo: 1,
        checked: false,
        disabled: false,
        id: 0,
      };
      uservendor.concepts.push(concept);
    };

    $scope.removeConcept = function (item, array, user) {
      user.user_info.info_vendedor[0].concepts.splice(item, 1);
    };

    function is_json(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
    function isEmptyObject(obj) {
      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          return false;
        }
      }

      return true;
    }
    $scope.saveConcepts = function (concepts, us, main_index) {
      var enviarok = false;
      if (concepts) {
        concepts.forEach(function (c) {
          if (
            c.tipo_calculo == 2 &&
            (c.cantidad == null || c.cantidad == "") &&
            c.cantidad != 0
          ) {
            SweetAlert.swal(
              "Error",
              "Agregue una cantidad en Gastos de Operación",
              "error"
            );
            enviarok = false;
            throw new Error("revise la cantidad de GO");
            return;
          } else {
            enviarok = true;
          }
        });
      } else {
        enviarok = true;
      }
      if (enviarok) {
        var datac = {
          concepts: JSON.stringify(concepts),
        };
        if (us.user_info.info_vendedor[0].url) {
          $http
            .patch(us.user_info.info_vendedor[0].url, datac)
            .then(function (req) {
              if (req.status == 200) {
                SweetAlert.swal("¡Listo!", MESSAGES.OK.UPDATESELLER, "success");
                console.log("---guardado-concepts");
              }
            });
        } else {
          if (enviarok) {
            $scope.saveSeller(main_index);
          }
        }
      }
    };

    $scope.validateGasto = function (input) {
      if (input.tipo_calculo == 2) {
        if (parseFloat(input.cantidad).toFixed(2) > 100.0) {
          parseFloat(0).toFixed(2);
          SweetAlert.swal(
            "¡Error!",
            MESSAGES.ERROR.ERRORFORMATPERCENT,
            "error"
          );
        }
      }
    };
    $scope.validateDecimal = function (input) {
      if (input) {
        if (parseFloat(input) < 0) {
          $scope.$filternewConcept.value = 0;
        } else {
          $scope.newConcept.value = parseFloat(input.toFixed(2));
        }
      }
    };
    // Promotorias fin
    $scope.changeSubRamo = function (sub_ramo) {};

    $scope.addSubramo = function (index) {
      if ($scope.users[index].subramos) {
        $scope.users[index].subramos.push({ ramos: $scope.fake_ramos });
      } else {
        $scope.users[index].subramos = [{}];
      }
    };

    $scope.deleteSubramo = function (index_main, index_sub, data) {
      $scope.delete_subramos.push(data.subramos[index_sub]);
      data.subramos.splice(index_sub, 1);
    };

    $scope.saveSeller = function (main_index) {
      var user = angular.copy($scope.users[main_index]);

      if (user.user_info) {
        if (user.user_info.is_vendedor) {
          var vendedor_ = user.user_info.info_vendedor[0].id;
        }
      } else {
        var vendedor_ = user.id;
      }

      if (user.subramos.length) {
        var subramos_ = user.subramos.map(function (item) {
          var subramo_post = {
            provider: item.provider ? item.provider.id : 0,
            ramo: item.ramo ? item.ramo.id : 0,
            subramo: item.subramo ? item.subramo.id : 0,
            comision: item.comision_percentage
              ? parseFloat(item.comision_percentage)
              : 0,
            vendedor: vendedor_,
          };

          if (item.id) {
            subramo_post.id = item.id;
          }

          if (item.url) {
            subramo_post.url = item.url;
          }

          return subramo_post;
        });
      } else {
        var subramos_ = [];
      }

      if (user.phones.length) {
        var phones_ = user.phones.map(function (phn) {
          var phones_return = {
            phone: phn,
            vendedor: vendedor_,
          };

          if (phn.id) {
            phones_return.id = phn.id;
          }

          if (phn.url) {
            phones_return.url = phn.url;
          }

          return phones_return;
        });

        if (user.phone) {
          phones_.push({ phone: user.phone, vendedor: vendedor_ });
        }
      } else {
        if (user.phone) {
          var phones_ = [{ phone: user.phone, vendedor: vendedor_ }];
        }
      }

      var hired_date_ = datesFactory.toDate(user.hired_date);

      user.vendedor_subramos = subramos_;
      user.hired_date = hired_date_;
      user.vendedor_phone = phones_;
      user.gastos_operacion = user.gastos_operacion
        ? parseFloat(user.gastos_operacion).toFixed(2)
        : 0;
      user.user = user.id;
      user.vendedor = vendedor_;
      user.is_vendedor = true;

      if (user.user_info.info_vendedor.length > 0) {
        // bank data
        if (user.bank) {
          if (user.bank.url) {
            user.bank = user.bank.id;
          }
        } else {
          SweetAlert.swal("Error!", MESSAGES.WARNING.EMPTYBANK, "error");
          return;
        }

        if (user.user_info.is_vendedor) {
          var data_source = {};

          var hired_date_original = datesFactory.toDate(
            $scope.original_data.hired_date
          );

          if (hired_date_original !== hired_date_) {
            data_source.hired_date = user.hired_date;
          }

          if ($scope.original_data.bank.id !== user.bank.id) {
            data_source.bank = user.bank.id;
          }

          if ($scope.original_data.reference_number !== user.reference_number) {
            data_source.reference_number = user.reference_number;
          }

          if ($scope.original_data.pay_way.key !== user.pay_way.key) {
            data_source.tipo_pago = user.pay_way.key;
          }

          if (
            parseFloat($scope.original_data.gastos_operacion) !==
            parseFloat(user.gastos_operacion)
          ) {
            data_source.gastos_operacion = user.gastos_operacion;
          }

          if ($scope.original_data.email !== user.email) {
            data_source.email = user.email;
          }

          if (
            $scope.original_data.phone !== "" &&
            $scope.original_data.phone !== user.phone
          ) {
            var source_phone = {};
            var source_url = user.user_info.info_vendedor[0].vendedor_phone[0];
            source_phone.phone = user.phone;
            $http.patch(source_url.url, source_phone).then(function (req) {
              if (req.status == 200) {
              }
            });
          }

          for (var i = 0; i < $scope.original_data.phones.length; i++) {
            if ($scope.original_data.phones[i] !== user.phones[i]) {
              var source_phone = {};
              var source_url =
                user.user_info.info_vendedor[0].vendedor_phone[i + 1];
              source_phone.phone = user.phones[i];
              $http.patch(source_url.url, source_phone).then(function (req) {
                if (req.status == 200) {
                }
              });
            }
          }

          if ($scope.original_data.address !== user.address) {
            data_source.address = user.address;
          }
          var enviarok = false;
          if (user.user_info.info_vendedor[0].concepts) {
            user.user_info.info_vendedor[0].concepts.forEach(function (c) {
              if (
                c.tipo_calculo == 2 &&
                (c.cantidad == null || c.cantidad == "") &&
                c.cantidad != 0
              ) {
                SweetAlert.swal(
                  "Error",
                  "Agregue una cantidad en Gastos de Operación",
                  "error"
                );
                enviarok = false;
                throw new Error("revise la cantidad de GO*");
                return;
              } else {
                enviarok = true;
              }
            });
          } else {
            enviarok = true;
          }
          if (enviarok) {
            data_source.concepts = JSON.stringify(
              user.user_info.info_vendedor[0].concepts
            );
            $http.patch(user.url, data_source).then(function (req) {
              if (req.status == 200) {
                $http.get(url.IP + "userslist_admin/").then(function (user) {
                  if (user.data.results) {
                    $scope.users = user.data.results;
                  } else {
                    $scope.users = user.data;
                  }
                  try {
                    req.data.concepts = JSON.parse(req.data.concepts);
                    req.data.hired_date = datesFactory.convertDate(
                      req.data.hired_date
                    );
                    $scope.users[main_index] = req.data;
                    $scope.users[main_index].phones = req.data.vendedor_phone;
                    $scope.users[main_index].isSeller = false;
                    $scope.users[main_index].subramos =
                      req.data.vendedor_subramos;
                    $state.reload();
                  } catch (u) {
                    console.log("uuuuuuu", u);
                  }
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.UPDATESELLER,
                    "success"
                  );

                  $scope.show_pagination = true;
                  $scope.config_pagination = {
                    count: user.data.count,
                    next: user.data.next,
                    previous: user.data.previous,
                  };

                  $scope.testPagination("users", "config_pagination");

                  $scope.users.forEach(function (user) {
                    user["phones"] = [];
                    user["subramos"] = [];
                  });

                  providerService
                    .getReadListProviders()
                    .then(function (provider) {
                      $scope.aseguradoras = provider;
                    });
                });
              }
            });

            if ($scope.original_data.subramos.length !== subramos_.length) {
              // DELETE $scope.delete_subramos
              if ($scope.delete_subramos.length) {
                $scope.delete_subramos.forEach(function (item_d) {
                  $http.delete(item_d.url).then(function (delete_item) {});
                });
              }

              subramos_.forEach(function (item) {
                if (item.id) {
                  $scope.original_data.subramos.forEach(function (o_item) {
                    if (o_item.id == item.id) {
                      if (
                        parseFloat(o_item.comision) !==
                        parseFloat(item.comision)
                      ) {
                        $http
                          .patch(item.url, { comision: item.comision })
                          .then(function (comision) {});
                      }
                    }
                  });
                } else {
                  dataFactory
                    .post("subramos-vendedor/", item)
                    .then(function (subramo_) {});
                }
              });
            } else {
              subramos_.forEach(function (item) {
                if (item.id) {
                  $scope.original_data.subramos.forEach(function (o_item) {
                    if (o_item.id == item.id) {
                      var sub_ramo_data = {};

                      if (
                        parseFloat(o_item.comision) !==
                        parseFloat(item.comision)
                      ) {
                        sub_ramo_data.comision = item.comision;
                      }

                      if (o_item.provider !== item.provider) {
                        sub_ramo_data.provider = item.provider;
                      }

                      if (o_item.ramo !== item.ramo) {
                        sub_ramo_data.ramo = item.ramo;
                      }

                      if (o_item.subramo !== item.subramo) {
                        sub_ramo_data.subramo = item.subramo;
                      }

                      $http
                        .patch(item.url, sub_ramo_data)
                        .then(function (request) {});
                    }
                  });
                }
              });
            }

            $scope.original_data.phones.push($scope.original_data.phone);

            if ($scope.original_data.phones.length !== phones_.length) {
              // DELETE $scope.delete_subramos
              if ($scope.delete_phones.length) {
                $scope.delete_phones.forEach(function (item) {
                  $http.delete(item.url).then(function (delete_item) {});
                });
              }

              phones_.forEach(function (item) {
                if (item.id) {
                  $scope.original_data.phones.forEach(function (o_item) {
                    if (o_item.id == item.id) {
                      if (
                        parseFloat(o_item.phone) !==
                        parseFloat(item.$scope.delete_phones)
                      ) {
                        $http
                          .patch(item.url, { phone: item.$scope.delete_phones })
                          .then(function (phine) {});
                      }
                    }
                  });
                } else {
                  // post
                  dataFactory
                    .post("phone-vendedor/", item)
                    .then(function (phne_) {});
                }
              });
            }
          }
        } else {
          var enviarok = false;
          if (user.user_info.info_vendedor[0].concepts) {
            user.user_info.info_vendedor[0].concepts.forEach(function (c) {
              if (
                c.tipo_calculo == 2 &&
                (c.cantidad == null || c.cantidad == "") &&
                c.cantidad != 0
              ) {
                SweetAlert.swal(
                  "Error",
                  "Agregue una cantidad en Gastos de Operación",
                  "error"
                );
                enviarok = false;
                throw new Error("revise la cantidad de GO _ ");
                return;
              } else {
                enviarok = true;
              }
            });
          } else {
            enviarok = true;
          }
          if (enviarok) {
            user.concepts = JSON.stringify(
              user.user_info.info_vendedor[0].concepts
            );
            user.is_vendedor = true;
            dataFactory.post("vendedores/", user).then(function (data) {
              if (data.status == 201) {
                $scope.isSeller[main_index] = false;
                $scope.users.forEach(function (user, index) {
                  if (user.id == data.data.user) {
                    // dataFactory.get('get-vendors/'+ data.data.user)
                    dataFactory.get("userslist_admin/").then(function (req) {
                      req.data["phones"] = [];
                      req.data["subramos"] = [];
                      $scope.users = req.data;
                      $scope.users[index] = req.data;
                    });
                  }
                });
                // $http.get(url.IP + 'get-vendors/')
                dataFactory.get("userslist_admin/").then(function (user) {
                  if (user.data.results) {
                    $scope.users = user.data.results;
                  } else {
                    $scope.users = user.data;
                  }
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.CREATESELLER,
                    "success"
                  );

                  $scope.show_pagination = true;
                  $scope.config_pagination = {
                    count: user.data.count,
                    next: user.data.next,
                    previous: user.data.previous,
                  };

                  $scope.testPagination("users", "config_pagination");

                  if ($scope.users.length) {
                    $scope.users.forEach(function (user) {
                      user["phones"] = [];
                      user["subramos"] = [];
                    });
                  }

                  providerService
                    .getReadListProviders()
                    .then(function (provider) {
                      $scope.aseguradoras = provider;
                    });
                });
              }
            });
          }
        }
      } else {
        var enviarok = false;
        if (user.user_info.info_vendedor[0].concepts) {
          user.user_info.info_vendedor[0].concepts.forEach(function (c) {
            if (
              c.tipo_calculo == 2 &&
              (c.cantidad == null || c.cantidad == "") &&
              c.cantidad != 0
            ) {
              SweetAlert.swal(
                "Error",
                "Agregue una cantidad en Gastos de Operación",
                "error"
              );
              enviarok = false;
              throw new Error("revise la cantidad de GO+");
              return;
            } else {
              enviarok = true;
            }
          });
        } else {
          enviarok = true;
        }
        if (enviarok) {
          user.concepts = JSON.stringify(
            user.user_info.info_vendedor[0].concepts
          );
          user.is_vendedor = true;
          user.bank = user.bank.id;
          user.tipo_pago = user.pay_way.key;
          dataFactory.post("vendedores/", user).then(function (data) {
            if (data.status == 201) {
              $scope.isSeller[main_index] = false;
              $scope.users.forEach(function (user, index) {
                if (user.id == data.data.user) {
                  // dataFactory.get('get-vendors/'+ data.data.user)
                  dataFactory.get("userslist_admin/").then(function (req) {
                    req.data["phones"] = [];
                    req.data["subramos"] = [];
                    $scope.users[index] = req.data;
                  });
                }
              });
              // $http.get(url.IP + 'get-vendors/')
              dataFactory.get("userslist_admin/").then(function (user) {
                if (user.data.results) {
                  $scope.users = user.data.results;
                } else {
                  $scope.users = user.data;
                }
                SweetAlert.swal("¡Listo!", MESSAGES.OK.CREATESELLER, "success");

                $scope.show_pagination = true;
                $scope.config_pagination = {
                  count: user.data.count,
                  next: user.data.next,
                  previous: user.data.previous,
                };

                $scope.testPagination("users", "config_pagination");

                if ($scope.users.length) {
                  $scope.users.forEach(function (user) {
                    user["phones"] = [];
                    user["subramos"] = [];
                  });
                }

                providerService
                  .getReadListProviders()
                  .then(function (provider) {
                    $scope.aseguradoras = provider;
                  });
              });
            }
          });
        }
      }
    };
    // agregar referenciador manual
    $scope.cancelarFormulario = function (i) {
      $scope.referenciadorAcapturar = false;
      $scope.formulario = {};
    };
    $scope.referenciadorAcapturar = false;
    $scope.agregarReferenciador = function () {
      $scope.referenciadorAcapturar = true;
      $http.get(url.IP + "bancos/").then(function (bank) {
        $scope.banks = bank.data;
      });
      console.log("armar json para capturar nuevo referenciador*");
      $scope.formulario = {
        hired_date: datesFactory.convertDate(new Date()),
        bank: "",
        email: "",
        address: "",
        pay_way: 1,
        reference_number: "",
        vendedor_phone: [],
        vendedor_subramos: [],
        info_vendedor: {
          concepts: [
            {
              concept: "Gastos de Operación",
              cantidad: 0,
              value: 0,
              tipo_calculo: 2,
              calculo: 2,
              checked: true,
              disabled: true,
              id: 1,
            },
          ],
        },
        subramos: [{ ramos: $scope.fake_ramos }],
        userinfo: {
          user: {
            first_name: "",
            last_name: "",
            phones: [],
          },
          is_vendedor: true,
        },
      };
      console.log(
        "armar json para capturar nuevo referenciador*",
        $scope.formulario
      );
    };

    $scope.addPhoneReferenciador = function (index) {
      if ($scope.formulario.userinfo.user.phones) {
        $scope.formulario.userinfo.user.phones.push("");
      } else {
        $scope.formulario.userinfo.user.phones = [""];
      }
    };

    $scope.deletePhoneReferenciador = function (index, item) {
      $scope.formulario.userinfo.user.phones.splice(index, 1);
    };

    $scope.addConceptReferenciador = function (new_vendor) {
      if (new_vendor) {
        if (new_vendor.info_vendedor.concepts) {
          if (
            typeof new_vendor.info_vendedor.concepts == "object" &&
            new_vendor.info_vendedor.concepts.length == 0
          ) {
            new_vendor.info_vendedor.concepts = [];
          }
        }
      }
      if (
        JSON.stringify(new_vendor.info_vendedor.concepts) === "{}" ||
        new_vendor.info_vendedor.concepts == "" ||
        new_vendor.info_vendedor.concepts == " "
      ) {
        new_vendor.info_vendedor.concepts = [];
        new_vendor.info_vendedor.concepts = [
          {
            concept: "Gastos de Operación",
            cantidad: 0,
            value: 0,
            tipo_calculo: 2,
            calculo: 2,
            checked: true,
            disabled: true,
            id: 1,
          },
        ];
      }
      var concept = {
        concept: "",
        cantidad: 0,
        value: 10,
        tipo_calculo: 1,
        calculo: 1,
        checked: false,
        disabled: false,
        id: 0,
      };
      new_vendor.info_vendedor.concepts.push(concept);
    };

    $scope.removeConceptReferenciador = function (index) {
      $scope.formulario.info_vendedor.concepts.splice(index, 1);
    };
    $scope.addSubramoR = function (index) {
      if ($scope.formulario.subramos) {
        $scope.formulario.subramos.push({ ramos: $scope.fake_ramos });
      } else {
        $scope.formulario.subramos = [{}];
      }
    };
    $scope.deleteSubramoR = function (index_main) {
      $scope.delete_subramos_referenciador.push(
        $scope.formulario.subramos[index_main]
      );
      $scope.formulario.subramos.splice(index_main, 1);
    };
    function cargarDeNuevo() {
      $scope.busqueda = "";
      $http.get(url.IP + "userslist_admin/").then(function (user) {
        if (user.data.results) {
          $scope.users = user.data.results;
        } else {
          $scope.users = user.data;
        }
        $scope.users.forEach(function (user) {
          user["phones"] = [];
          user["subramos"] = [];
        });

        providerService.getReadListProviders().then(function (provider) {
          $scope.aseguradoras = provider;
        });
      });
    }
    $scope.saveReferenciador = function (data) {
      var dataToSave = {};
      dataToSave = data;
      if (data.subramos.length) {
        // Validar que ninguna comisión esté vacía o en cero
        var comisionesInvalidas = data.subramos.some(function (item) {
          return (
            !item.comision_percentage ||
            parseFloat(item.comision_percentage) === 0
          );
        });

        // if (comisionesInvalidas) {
        //     SweetAlert.swal("Error", "La comisión no puede estar vacía o en cero.", "error");
        //     return; // corta la ejecución
        // }

        var subramos_ = data.subramos.map(function (item) {
          var subramo_post = {
            provider: item.provider ? item.provider.id : 0,
            ramo: item.ramo ? item.ramo.id : 0,
            subramo: item.subramo ? item.subramo.id : 0,
            comision: parseFloat(item.comision_percentage),
          };
          if (item.id) subramo_post.id = item.id;
          if (item.url) subramo_post.url = item.url;
          return subramo_post;
        });
      } else {
        var subramos_ = [];
      }

      var phones_ = [];
      if (dataToSave.userinfo.user.phones.length) {
        var phones_ = dataToSave.userinfo.user.phones.map(function (phn) {
          var phones_return = {
            phone: phn,
          };
          if (phn.id) {
            phones_return.id = phn.id;
          }
          if (phn.url) {
            phones_return.url = phn.url;
          }
          return phones_return;
        });
        if (dataToSave.userinfo.user.phone) {
          phones_.push({ phone: userinfo.user.phone });
        }
      } else {
        if (dataToSave.userinfo.user.phone) {
          var phones_ = [{ phone: dataToSave.userinfo.user.phone }];
        }
      }
      dataToSave.vendedor_subramos = subramos_;
      dataToSave.vendedor_phone = phones_;
      var tosave_referenciador_saam = true;
      // if(dataToSave.info_vendedor.concepts){
      //     dataToSave.info_vendedor.concepts.forEach(function (c) {
      //         if (
      //             c.tipo_calculo == 2 &&
      //             (c.cantidad === undefined || c.cantidad === null || c.cantidad === '' || Number(c.cantidad) === 0)
      //         ) {
      //             SweetAlert.swal("Error", "Agregue una cantidad en Gastos de Operación", "error");
      //             tosave_referenciador_saam = false;
      //             throw new Error("revise la cantidad de GO+");
      //         } else {
      //             tosave_referenciador_saam = true;
      //         }
      //     });
      // }else{
      //     tosave_referenciador_saam = true;
      // }
      if (dataToSave.bank == "" || !dataToSave.bank) {
        SweetAlert.swal("Error", "Agregue un Banco", "error");
        tosave_referenciador_saam = false;
      }
      if (
        dataToSave.userinfo.user.first_name == "" ||
        !dataToSave.userinfo.user.first_name
      ) {
        SweetAlert.swal("Error", "Agregue un Nombre", "error");
        tosave_referenciador_saam = false;
      }
      if (
        dataToSave.userinfo.user.phone == "" ||
        !dataToSave.userinfo.user.phone
      ) {
        SweetAlert.swal("Error", "Agregue un teléfono", "error");
        tosave_referenciador_saam = false;
      }
      if (
        dataToSave.userinfo.user.last_name == "" ||
        !dataToSave.userinfo.user.last_name
      ) {
        SweetAlert.swal("Error", "Agregue un Apellido", "error");
        tosave_referenciador_saam = false;
      }
      if (dataToSave.email == "" || !dataToSave.email) {
        SweetAlert.swal("Error", "Agregue un Correo", "error");
        tosave_referenciador_saam = false;
      }
      if (dataToSave.reference_number == "" || !dataToSave.reference_number) {
        SweetAlert.swal("Error", "Agregue un Número de referencia", "error");
        tosave_referenciador_saam = false;
      }
      if (dataToSave.pay_way == "" || !dataToSave.pay_way) {
        SweetAlert.swal("Error", "Agregue una Froma de Pago", "error");
        tosave_referenciador_saam = false;
      }
      console.log("tosave_referenciador_saam", tosave_referenciador_saam);
      if (tosave_referenciador_saam) {
        if (dataToSave.info_vendedor && dataToSave.info_vendedor.concepts) {
          dataToSave.concepts = JSON.stringify(
            dataToSave.info_vendedor.concepts
          );
        }
        dataToSave.is_vendedor = true;
        if (dataToSave.bank && dataToSave.bank.id) {
          dataToSave.bank = dataToSave.bank.id;
        }
        if (dataToSave.pay_way && dataToSave.pay_way.key) {
          dataToSave.tipo_pago = dataToSave.pay_way.key;
        }
        if (dataToSave.hired_date) {
          try {
            dataToSave.hired_date = datesFactory.toDate(dataToSave.hired_date);
          } catch (i) {
            dataToSave.hired_date = dataToSave.hired_date;
          }
        }
        dataFactory
          .post("direct-vendedores/", dataToSave)
          .then(
            function success(data_request) {
              if (data_request.status == 201 || data_request.status == 200) {
                $scope.referenciadorAcapturar = false;
                cargarDeNuevo();
                if (
                  data_request &&
                  data_request.data &&
                  data_request.data.usuario_reutilizado
                ) {
                  SweetAlert.swal(
                    "Información",
                    "El usuario ya se encontraba registrado en SAAM. Se reutilizó el registro existente y se realizó la asociación correspondiente (no se generó un duplicado).",
                    "info"
                  );
                }
              } else {
                if (
                  $scope.formulario &&
                  $scope.formulario.bank &&
                  Array.isArray($scope.banks)
                ) {
                  var idBuscado = $scope.formulario.bank;
                  var bank = $scope.banks.find(function (item) {
                    return item.id === idBuscado;
                  });
                  if (bank) {
                    // solo reemplaza si se encuentra
                    $scope.formulario.bank = bank;
                  } else {
                    // si no se encuentra, deja el ID tal cual
                    console.warn("Banco no encontrado con ID:", idBuscado);
                  }
                }
                console.log("data_request.data", data_request.data);
                SweetAlert.swal(
                  "Error",
                  JSON.stringify(data_request.data, null, 2),
                  "error"
                );
                tosave_referenciador_saam = false;
              }
            },
            function error(error) {
              try {
                $scope.formulario.hired_date = datesFactory.convertDate(
                  $scope.formulario.hired_date
                );
              } catch (u) {}
              console.log("error", error);
              SweetAlert.swal(
                "Error",
                JSON.stringify(error.data, null, 2),
                "error"
              );
              tosave_referenciador_saam = false;
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    };
    $scope.changeRamoR = function (sub_ramo) {
      if (!sub_ramo.ramo) {
        $scope.subramos = [];
        sub_ramo.sub_ramos = [];
        return;
      }
      sub_ramo.sub_ramos = sub_ramo.ramo.subramo_ramo;
    };
    $scope.changeSubRamoR = function (sub_ramo) {};

    $scope.changeProviderR = function (sub_ramo, provider) {
      if (!provider.id == -2) {
        $scope.subramos = [];
        $scope.ramos = [];
        sub_ramo.ramos = $scope.fake_ramos;
        return;
      } else if (provider.id == -2) {
        $scope.subramos = [];
        $scope.ramos = [];
        sub_ramo.ramos = $scope.afianzadoras_ramos;
        return;
      }
      // aseguradoras
      if (provider.id) {
        $http
          .get(url.IP + "ramos-by-provider/" + provider.id)
          .then(function (ramo) {
            sub_ramo.ramos = ramo.data;
          });
      }
    };
    $scope.busqueda = "";
    $scope.buscar = function (buscar) {
      if ($scope.busqueda && buscar) {
        dataFactory
          .get("buscar-vendedores/" + "?abuscar=" + $scope.busqueda + "&")
          .then(
            function success(response) {
              $scope.users = response.data;
              if ($scope.users) {
                $scope.users.forEach(function (user) {
                  user["phones"] = [];
                  user["subramos"] = [];
                  user["polizas"] = [];
                  user["show_binnacle"] = false;
                });
              }
            },
            function error(error) {
              cargarDeNuevo();
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      } else {
        cargarDeNuevo();
      }
    };
    // add new referenciador final*********
    // agregar referenciador manual fin
    $scope.testPagination = function (parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }
      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;
      var previous_array = [];
      var next_array = [];
      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }
      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
          } else {
            if (config_.previous.search("&page=") !== -1) {
              var url = config_.previous.substring(
                0,
                config_.previous.indexOf("&page=") + 6
              );
              url += parPage.toString();
            } else {
              var url = config_.previous;
            }
          }
        }
        getProviders(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }
        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };
      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };
      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };
      function getProviders(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };

              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
      $scope.testPagination2 = function (parModel, parConfig, vendedor) {
        var config_ = $parse(parConfig)($scope);
        if (config_) {
          var pages = Math.ceil(config_.count / 10);
        }
        $scope.totalPages = [];
        var count_items = 0;
        var count_pages = 0;

        var previous_array = [];
        var next_array = [];

        $scope.start = 0;
        $scope.end = 5;
        // $scope.actual_page = 1;
        $scope.not_prev = true;

        for (var i = 0; i < pages; i++) {
          $scope.totalPages.push(i + 1);
        }

        $scope.lastPageP = function () {
          // TODO: ultimo bloque
          if ($scope.totalPages.length > 5) {
            $scope.end = $scope.totalPages.length;
            $scope.start = $scope.totalPages.length - 5;
            $scope.show_prev_block = true;
          }
          $scope.selectPage($scope.totalPages.length);
          // $scope.actual_page = $scope.totalPages.length;
          // $scope.page = $scope.totalPages.length;
        };
        $scope.selectPage = function (parPage) {
          $scope.actual_page = parPage;

          $scope.verPolizas(
            vendedor,
            parPage,
            $scope.param_a,
            $scope.order,
            $scope.asc
          );
        };

        $scope.previousBlockPages = function (param) {
          if (param) {
            if ($scope.start < $scope.actual_page) {
              $scope.start = $scope.start - 1;
              $scope.end = $scope.end - 1;
            }
          } else {
            $scope.start = $scope.start - 5;
            $scope.end = $scope.end - 5;

            if ($scope.end < $scope.totalPages.length) {
              $scope.not_next = false;
            }
          }

          if ($scope.end <= 5) {
            $scope.start = 0;
            $scope.end = 5;
            $scope.show_prev_block = false;
          }
        };

        $scope.nextBlockPages = function (param) {
          $scope.show_prev_block = true;

          if (param) {
            if ($scope.end > $scope.actual_page) {
              $scope.start = $scope.start + 1;
              $scope.end = $scope.end + 1;
            }
          } else {
            if ($scope.end < $scope.totalPages.length) {
              $scope.start = $scope.start + 5;
              $scope.end = $scope.end + 5;

              if ($scope.end == $scope.totalPages.length) {
                $scope.not_next = true;
              }
            } else {
              $scope.not_next = true;
            }
          }
        };
      };
    };
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .controller(
      "AgenteConceptosGralesModalCtrl",
      AgenteConceptosGralesModalCtrl
    );

  AgenteConceptosGralesModalCtrl.$inject = [
    "$http",
    "$scope",
    "$uibModal",
    "$uibModalInstance",
    "dataFactory",
    "conceptos",
    "datesFactory",
    "SweetAlert",
    "MESSAGES",
    "data",
    "associated",
    "route",
    "modelo",
    "$state",
    "$sessionStorage",
    "FileUploader",
    "url",
    "receipt",
    "appStates",
    "$localStorage",
    "providerService",
    "$parse",
    "$rootScope",
  ];

  function AgenteConceptosGralesModalCtrl(
    $http,
    $scope,
    $uibModal,
    $uibModalInstance,
    dataFactory,
    conceptos,
    datesFactory,
    SweetAlert,
    MESSAGES,
    data,
    associated,
    route,
    modelo,
    $state,
    $sessionStorage,
    FileUploader,
    url,
    receipt,
    appStates,
    $localStorage,
    providerService,
    $parse,
    $rootScope
  ) {
    /* Información de usuario */
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    $(".datepicker-me input").datepicker();

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";
    $scope.historic_email = false;

    $scope.vm = this;
    var vm = this;
    $scope.nuevo = false;
    vm.email_send_historic = "";
    $scope.referenciadorNames = [];
    $scope.listaNames = [];

    $scope.priorities = [
      {
        id: 1,
        name: "Alta",
      },
      {
        id: 2,
        name: "Media",
      },
      {
        id: 3,
        name: "Baja",
      },
    ];

    $scope.concepts = [
      {
        id: 1,
        name: "Cotización",
      },
      {
        id: 2,
        name: "Emisión",
      },
      {
        id: 3,
        name: "Endoso A",
      },
      {
        id: 4,
        name: "Corrección",
      },
      {
        id: 5,
        name: "Cancelación",
      },
      {
        id: 6,
        name: "Renovación",
      },
      {
        id: 7,
        name: "Otro",
      },
      {
        id: 8,
        name: "Reembolso",
      },
      {
        id: 9,
        name: "Programación de cirugía",
      },
      {
        id: 10,
        name: "Endoso B",
      },
      {
        id: 11,
        name: "Endoso D",
      },
      {
        id: 12,
        name: "Reconocimiento de antigüedad",
      },
      {
        id: 13,
        name: "Carta de antigüedad",
      },
    ];

    vm.showRecordatorios = showRecordatorios;
    function showRecordatorios() {
      vm.infoFlag = false;
      vm.recordatoriosFlag = true;
    }
    $scope.createRecordatorio = function (registroSelected, tipo) {
      $uibModalInstance.close();
      var insurance = registroSelected;
      var modalInstance = $uibModal.open({
        templateUrl:
          "app/recordatorios/desde-registro/desderegistro.modal.html",
        controller: "RecordatorioRegistroCtrl",
        size: "lg",
        resolve: {
          poliza: function () {
            return registroSelected;
          },
          tipoRegistro: function () {
            return tipo;
          },
          from: function () {
            return null;
          },
          parent: function () {
            return $scope.vm.form;
          },
        },
        backdrop:
          "static" /* this prevent user interaction with the background */,
        keyboard: false,
      });
      modalInstance.result.then(function (receipt) {
        activate();
      });
    };
    angular.element(document).ready(function () {
      $(".js-example-basic-multiple").select2();
    });
    activate();

    function activate() {
      $scope.emails_users = [];
      vm.accesos = $sessionStorage.permisos;
      if (vm.accesos) {
        vm.accesos.forEach(function (perm) {
          if (perm.model_name == "Pólizas") {
            vm.acceso_polizas = perm;
            vm.acceso_polizas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_adm_pol = true;
                } else {
                  vm.acceso_adm_pol = false;
                }
              } else if (acc.permission_name == "Ver pólizas") {
                if (acc.checked == true) {
                  vm.acceso_ver_pol = true;
                } else {
                  vm.acceso_ver_pol = false;
                }
              } else if (acc.permission_name == "Cancelar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_canc_pol = true;
                } else {
                  vm.acceso_canc_pol = false;
                }
              } else if (acc.permission_name == "Eliminar pólizas") {
                if (acc.checked == true) {
                  vm.acceso_elim_pol = true;
                } else {
                  vm.acceso_elim_pol = false;
                }
              }
            });
          } else if (perm.model_name == "Reportes") {
            vm.acceso_reportes = perm;
            vm.acceso_reportes.permissions.forEach(function (acc) {
              if (acc.permission_name == "Reporte fianzas") {
                if (acc.checked == true) {
                  vm.acceso_rep_fia = true;
                } else {
                  vm.acceso_rep_fia = false;
                }
              } else if (acc.permission_name == "Reporte Siniestros") {
                if (acc.checked == true) {
                  vm.acceso_rep_sin = true;
                } else {
                  vm.acceso_rep_sin = false;
                }
              } else if (acc.permission_name == "Reporte Endosos") {
                if (acc.checked == true) {
                  vm.acceso_rep_end = true;
                } else {
                  vm.acceso_rep_end = false;
                }
              } else if (acc.permission_name == "Reporte pólizas") {
                if (acc.checked == true) {
                  vm.acceso_rep_pol = true;
                } else {
                  vm.acceso_rep_pol = false;
                }
              } else if (acc.permission_name == "Reporte renovaciones") {
                if (acc.checked == true) {
                  vm.acceso_rep_ren = true;
                } else {
                  vm.acceso_rep_ren = false;
                }
              } else if (acc.permission_name == "Reporte cobranza") {
                if (acc.checked == true) {
                  vm.acceso_rep_cob = true;
                } else {
                  vm.acceso_rep_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Ordenes de trabajo") {
            vm.acceso_ot = perm;
            vm.acceso_ot.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar OTs") {
                if (acc.checked == true) {
                  vm.acceso_adm_ot = true;
                } else {
                  vm.acceso_adm_ot = false;
                }
              } else if (acc.permission_name == "Ver OTs") {
                if (acc.checked == true) {
                  vm.acceso_ver_ot = true;
                } else {
                  vm.acceso_ver_ot = false;
                }
              } else if (acc.permission_name == "Cancelar OTs") {
                if (acc.checked == true) {
                  vm.acceso_canc_ot = true;
                } else {
                  vm.acceso_canc_ot = false;
                }
              } else if (acc.permission_name == "Eliminar OTs") {
                if (acc.checked == true) {
                  vm.acceso_elim_ot = true;
                } else {
                  vm.acceso_elim_ot = false;
                }
              }
            });
          } else if (perm.model_name == "Contratantes y grupos") {
            vm.acceso_contg = perm;
            vm.acceso_contg.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar contratantes y grupos") {
                if (acc.checked == true) {
                  vm.acceso_adm_cont = true;
                } else {
                  vm.acceso_adm_cont = false;
                }
              } else if (acc.permission_name == "Ver contratantes y grupos") {
                if (acc.checked == true) {
                  vm.acceso_ver_cont = true;
                } else {
                  vm.acceso_ver_cont = false;
                }
              }
            });
          } else if (perm.model_name == "Siniestros") {
            vm.acceso_sin = perm;
            vm.acceso_sin.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar siniestros") {
                if (acc.checked == true) {
                  vm.acceso_adm_sin = true;
                } else {
                  vm.acceso_adm_sin = false;
                }
              }
            });
          } else if (perm.model_name == "Mensajeria") {
            vm.acceso_mns = perm;
            vm.acceso_mns.permissions.forEach(function (acc) {
              if (acc.permission_name == "Mensajeria") {
                if (acc.checked == true) {
                  vm.acceso_mns = true;
                } else {
                  vm.acceso_mns = false;
                }
              }
            });
          } else if (perm.model_name == "Formatos") {
            vm.acceso_form = perm;
            vm.acceso_form.permissions.forEach(function (acc) {
              if (acc.permission_name == "Formatos") {
                if (acc.checked == true) {
                  vm.acceso_form = true;
                } else {
                  vm.acceso_form = false;
                }
              }
            });
          } else if (perm.model_name == "Correos electronicos") {
            vm.acceso_correo = perm;
            vm.acceso_correo.permissions.forEach(function (acc) {
              if (acc.permission_name == "Correos") {
                if (acc.checked == true) {
                  vm.acceso_cor = true;
                } else {
                  vm.acceso_cor = false;
                }
              }
            });
          } else if (perm.model_name == "Cobranza") {
            vm.acceso_cob = perm;
            vm.acceso_cob.permissions.forEach(function (acc) {
              if (acc.permission_name == "Ver cobranza") {
                if (acc.checked == true) {
                  vm.acceso_ver_cob = true;
                } else {
                  vm.acceso_ver_cob = false;
                }
              } else if (acc.permission_name == "Despagar recibos") {
                if (acc.checked == true) {
                  vm.acceso_desp_cob = true;
                } else {
                  vm.acceso_desp_cob = false;
                }
              } else if (acc.permission_name == "Pagar y prorrogar") {
                if (acc.checked == true) {
                  vm.acceso_pag_cob = true;
                } else {
                  vm.acceso_pag_cob = false;
                }
              } else if (acc.permission_name == "Desconciliación de recibos") {
                if (acc.checked == true) {
                  vm.acceso_desco_cob = true;
                } else {
                  vm.acceso_desco_cob = false;
                }
              } else if (acc.permission_name == "Conciliar recibos") {
                if (acc.checked == true) {
                  vm.acceso_conc_cob = true;
                } else {
                  vm.acceso_conc_cob = false;
                }
              } else if (acc.permission_name == "Liquidar recibos") {
                if (acc.checked == true) {
                  vm.acceso_liq_cob = true;
                } else {
                  vm.acceso_liq_cob = false;
                }
              }
            });
          } else if (perm.model_name == "Referenciadores") {
            vm.acceso_ref = perm;
            vm.acceso_ref.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar referenciadores") {
                if (acc.checked == true) {
                  vm.acceso_adm_ref = true;
                } else {
                  vm.acceso_adm_ref = false;
                }
              } else if (acc.permission_name == "Pagar a referenciadores") {
                if (acc.checked == true) {
                  vm.acceso_pag_ref = true;
                } else {
                  vm.acceso_pag_ref = false;
                }
              } else if (
                acc.permission_name == "Cambiar refrenciador en pólizas"
              ) {
                if (acc.checked == true) {
                  vm.acceso_chg_ref = true;
                } else {
                  vm.acceso_chg_ref = false;
                }
              }
            });
          } else if (perm.model_name == "Fianzas") {
            vm.acceso_fianzas = perm;
            vm.acceso_fianzas.permissions.forEach(function (acc) {
              if (acc.permission_name == "Administrar fianzas") {
                if (acc.checked == true) {
                  vm.acceso_adm_fia = true;
                } else {
                  vm.acceso_adm_fia = false;
                }
              } else if (acc.permission_name == "Ver fianzas") {
                if (acc.checked == true) {
                  vm.acceso_ver_fia = true;
                } else {
                  vm.acceso_ver_fia = false;
                }
              } else if (acc.permission_name == "Cancelar fianzas") {
                if (acc.checked == true) {
                  vm.acceso_canc_fia = true;
                } else {
                  vm.acceso_canc_fia = false;
                }
              } else if (acc.permission_name == "Eliminar fianzas") {
                if (acc.checked == true) {
                  vm.acceso_elim_fia = true;
                } else {
                  vm.acceso_elim_fia = false;
                }
              }
            });
          }
        });
      }
      if (conceptos) {
        $scope.conceptos_update = angular.copy(conceptos);
        $scope.vm.form = angular.copy(conceptos);
        $scope.title = conceptos.title;
        $scope.onetime = conceptos.onetime;
        var selected_user = [];
        $.each(conceptos.vendedores, function (i, e) {
          selected_user.push(e.id);
        });
        $scope.selected_user = selected_user;
        var selected_provider = [];
        $.each(conceptos.aseguradoras, function (i, e) {
          selected_provider.push(e.id);
        });
        $scope.selected_provider = selected_provider;
        var selected_ramo = [];
        $.each(conceptos.ramos, function (i, e) {
          selected_ramo.push(e.id);
        });
        $scope.selected_ramo = selected_ramo;
        var selected_tipopolizas = [];
        $.each(conceptos.tipopolizas, function (i, e) {
          selected_tipopolizas.push(e.id);
        });
        $scope.selected_tipopolizas = selected_tipopolizas;
        vm.conceptosGralesId = conceptos.id;
        $scope.conceptos = [
          {
            concept: conceptos.concept,
            cantidad: conceptos.cantidad,
            value: 0,
            tipo_calculo: conceptos.tipo_calculo,
            calculo: conceptos.calculo,
          },
        ];
      } else if (data) {
        $scope.vm.form = {};
        $scope.title = "Conceptos Generales";
        $scope.vm.form.title = $scope.title;
        $scope.onetime = conceptos.onetime;
        $scope.vm.form.onetime = 1;
        $scope.conceptos = [
          {
            concept: "",
            cantidad: 0,
            value: 0,
            tipo_calculo: 2,
            calculo: 2,
          },
        ];
      } else {
        $scope.vm.form = {};
        $scope.title = "Conceptos Generales";
        $scope.vm.form.title = $scope.title;
        $scope.vm.form.onetime = 1;
        $scope.onetime = true;
        $scope.conceptos = [
          {
            concept: "",
            cantidad: 0,
            value: 0,
            tipo_calculo: 2,
            calculo: 2,
          },
        ];
        $scope.title = "Conceptos Generales";
      }
      dataFactory.get("get-vendors/").then(function (data) {
        $scope.vendedores = data.data;
        if ($scope.selected_user) {
          var selected_user = [];
          $.each(data.data.results, function (i, e) {
            if ($scope.selected_user.includes(e.id)) {
              selected_user.push(e);
            }
          });
          $scope.select_user = selected_user;
        }
      });
      dataFactory
        .get("conceptos-generales-referenciador/")
        .then(function (data) {
          $scope.configuraciones = data.data.results;
          if ($scope.configuraciones.length == 0) {
            $scope.nuevo = true;
          }
          vm.conceptos_config = {
            count: data.data.count,
            previous: data.data.previous,
            next: data.data.next,
          };
          vm.show_pag_confs = true;
          testPagination("configuraciones", "vm.conceptos_config");
          console.log("configiraciones", data);
        });
      getProviders();
    }
    function getProviders() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1; //Months are zero based
      var curr_year = date.getFullYear();
      var d = curr_year + "-" + curr_month + "-" + curr_date;
      providerService.getProviderByKey(d).then(function (data) {
        vm.providers = data.data;
      });
    }
    $scope.agregarConfiguracion = function (n) {
      vm.form = {};
      $scope.vm.form = {};
      $scope.select_ramo = [];
      $scope.select_provider = [];
      $scope.select_user = [];
      $scope.nuevo = n;
    };
    $scope.editConceptos = function (o, cnfg) {
      $scope.isEdit = true;
      vm.form = {};
      $scope.vm.form = {};
      $scope.vm.form = cnfg;
      $scope.select_ramo = [];
      $scope.select_provider = [];
      $scope.select_user = [];
      $scope.nuevo = true;
      $scope.onetime = cnfg.onetime;
      $scope.vm.form.onetime = cnfg.onetime ? 1 : 2;
      $scope.conceptos = [
        {
          concept: cnfg.concepto,
          cantidad: parseFloat(cnfg.cantidad).toFixed(2),
          tipo_calculo: cnfg.tipo_calculo,
          calculo: cnfg.calculo,
        },
      ];
      var selected_tipop = [];
      $.each([1, 3, 12], function (i, e) {
        if (cnfg.tipopolizas.includes(e)) {
          selected_tipop.push(e);
        }
      });
      $scope.select_tipopolizas = selected_tipop;
      // $scope.selectedMultiples($scope.select_tipopolizas);
      var selected_ramo = [];
      $.each([1, 2, 3, 9], function (i, e) {
        if (cnfg.ramos.includes(e)) {
          selected_ramo.push(e);
        }
      });
      $scope.select_ramo = selected_ramo;
      // $scope.selectedMultiplesR($scope.select_ramo);
      var selected_provider = [];
      $scope.listaNames = [];
      $.each(vm.providers, function (i, e) {
        if (cnfg.aseguradoras.includes(e.id)) {
          selected_provider.push(e);
          $scope.listaNames.push(e.alias);
        }
      });
      $rootScope.select_provider = selected_provider;
      // $scope.selectedMultiplesA($scope.select_provider);
      // $scope.selected_tipopolizas =  cnfg.tipopolizas;
      // $scope.selected_user = cnfg.vendedores
      dataFactory.get("get-vendors/").then(function (data) {
        $scope.vendedores = data.data;
        if (cnfg.vendedores) {
          var selected_user = [];
          $scope.referenciadorNames = [];
          $.each(data.data, function (i, e) {
            if (cnfg.vendedores.includes(e.id)) {
              selected_user.push(e);
              $scope.referenciadorNames.push(e.first_name + " " + e.last_name);
            }
          });
          $scope.select_user = selected_user;
          // $scope.selectedMultiplesRf($scope.referenciadorNames);
        }
      });
    };
    $scope.selectedMultiplesRf = function (val) {
      $("#select_user").val(val).change();
    };
    $scope.selectedMultiplesR = function (val) {
      $("#select_ramo").val(val).change();
    };
    $scope.selectedMultiplesA = function (val) {
      $("#select_provider").val(val).change();
    };
    $scope.selectedMultiples = function (val) {
      $("#select_tipopolizas").val(val).change();
    };
    $scope.selectRamos = function (sel) {
      vm.ramos_selected = [];
      vm.id = sel[0];
      sel.forEach(function (r) {
        vm.ramos_selected.push(parseInt(r));
      });
    };
    $scope.selectTipoP = function (sel) {
      vm.tipopolizas = [];
      sel.forEach(function (r) {
        vm.tipopolizas.push(parseInt(r));
      });
    };
    $scope.selectProv = function (sel) {
      vm.providers_selected = [];
      $scope.listaNames = [];
      sel.forEach(function (cl) {
        vm.providers_selected.push(cl.id);
        $scope.listaNames.push(cl.alias);
      });
    };
    $scope.close = function () {
      $uibModalInstance.close();
    };
    $scope.selectUser = function (obj) {
      vm.referenciadores = [];
      $scope.referenciadorNames = [];
      obj.forEach(function (cl) {
        vm.referenciadores.push(cl.id);
        $scope.referenciadorNames.push(cl.first_name + " " + cl.last_name);
      });
    };

    $scope.change_onetime = function (valor) {
      if (valor == 1) {
        $scope.onetime = true;
      } else {
        $scope.onetime = false;
      }
    };
    $scope.saveConceptos = function () {
      var data_send = {
        ramos: vm.ramos_selected,
        vendedores: vm.referenciadores,
        vendedores_vigentes: vm.referenciadores,
        tipopolizas: vm.tipopolizas,
        aseguradoras: vm.providers_selected,
        concepto: $scope.conceptos[0].concept,
        cantidad: $scope.conceptos[0].cantidad,
        calculo: $scope.conceptos[0].calculo,
        tipo_calculo: $scope.conceptos[0].tipo_calculo,
        title: vm.form.title,
        is_active: true,
        onetime: $scope.onetime,
      };
      dataFactory
        .post("conceptos-generales-referenciador/", data_send)
        .then(function success(response) {
          if (response.status === 200 || response.status === 201) {
            var params = {
              model: 34,
              event: "POST",
              associated_id: response.data.id,
              identifier:
                "creo la configuración para referenciadores conceptos generales.",
            };
            dataFactory
              .post("send-log/", params)
              .then(function success(response) {});
            SweetAlert.swal(
              "¡Hecho!",
              MESSAGES.OK.SAVECONCEPTOSGRALES,
              "success"
            );
            $uibModalInstance.close();
          }
        });
    };

    $scope.updateConceptos = function () {
      vm.form.onetime = $scope.onetime;
      var data_send = {
        ramos: vm.ramos_selected,
        vendedores: vm.referenciadores,
        vendedores_vigentes: vm.referenciadores,
        tipopolizas: vm.tipopolizas,
        aseguradoras: vm.providers_selected,
        concepto: $scope.conceptos[0].concept,
        cantidad: $scope.conceptos[0].cantidad,
        calculo: $scope.conceptos[0].calculo,
        tipo_calculo: $scope.conceptos[0].tipo_calculo,
        title: vm.form.title,
        is_active: true,
        onetime: $scope.onetime,
      };
      $http.patch(vm.form.url, data_send).then(function success(response) {
        if (response.status === 200 || response.status === 201) {
          $scope.isEdit = false;
          var params = {
            model: 34,
            event: "PATCH",
            associated_id: response.data.id,
            identifier:
              "edito/actualizo la configuración para referenciadores conceptos generales.",
          };
          dataFactory
            .post("send-log/", params)
            .then(function success(response) {});
          SweetAlert.swal(
            "¡Hecho!",
            MESSAGES.OK.SAVECONCEPTOSGRALES,
            "success"
          );
          $uibModalInstance.close();
        }
      });
    };

    $scope.newConcept = {
      value: null,
      model: null,
      tipo_calculo: 1,
      calculo: 1,
      options: [
        { id: 1, name: "$" },
        { id: 2, name: "%" },
      ],
      calculo_options: [
        { id: 1, name: "Suma" },
        { id: 2, name: "Resta" },
      ],
      checked: false,
      disabled: false,
    };
    $scope.concepts = [];

    $scope.tipocalculo_options = [
      { id: 1, name: "$" },
      { id: 2, name: "%" },
    ];
    $scope.calculo_options = [
      { id: 1, name: "Abono" },
      { id: 2, name: "Cargo" },
    ];
    $scope.addConcept = function (uservendor) {
      if (uservendor) {
        if (uservendor.concepts) {
          if (
            typeof uservendor.concepts == "object" &&
            uservendor.concepts.length == 0
          ) {
            uservendor.concepts = [];
          }
        }
      }
      if (
        JSON.stringify(uservendor.concepts) === "{}" ||
        uservendor.concepts == "" ||
        uservendor.concepts == " "
      ) {
        $scope.concepts = [];
        $scope.concepts = [
          {
            concept: "Gastos de Operación",
            cantidad: 0,
            value: 0,
            tipo_calculo: 2,
            calculo: 2,
            checked: true,
            disabled: true,
            id: 1,
          },
        ];
      }
      console.log("-ssssssss", $scope.concepts);
      var concept = {
        concept: "",
        cantidad: 0,
        value: 10,
        tipo_calculo: 1,
        calculo: 1,
        checked: false,
        disabled: false,
        id: 0,
      };
      uservendor.concepts.push(concept);
    };

    $scope.removeConcept = function (item, array, user) {
      $scope.concepts.splice(item, 1);
    };
    function testPagination(parModel, parConfig) {
      var config_ = $parse(parConfig)($scope);
      if (config_) {
        var pages = Math.ceil(config_.count / 10);
      }

      $scope.totalPages = [];
      var count_items = 0;
      var count_pages = 0;

      var previous_array = [];
      var next_array = [];

      $scope.start = 0;
      $scope.end = 5;
      $scope.actual_page = 1;
      $scope.not_prev = true;

      for (var i = 0; i < pages; i++) {
        $scope.totalPages.push(i + 1);
      }
      $scope.selectPage = function (parPage) {
        if (config_.next || config_.previous) {
          if (config_.next) {
            var next_ = config_.next;

            var otherParameters = config_.next.substring(
              config_.next.indexOf("&page=") + 6
            );

            if (next_.search("&status=") !== -1) {
              var status = next_.substring(next_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            var url = config_.next.substring(
              0,
              config_.next.indexOf("&page=") + 6
            );
            url += parPage.toString();
            url += "&" + status;

            if (config_.next.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params;
            }
          } else {
            var prev_ = config_.previous;
            var otherParameters = prev_.substring(prev_.indexOf("&page=") + 6);
            if (prev_.search("&status=") !== -1) {
              var status = prev_.substring(prev_.indexOf("&status=") + 1);
            } else {
              var status = "";
            }

            if (prev_.search("&page=") !== -1) {
              var url = prev_.substring(0, prev_.indexOf("&page=") + 6);
              url += parPage.toString();
              url += "&" + status;
            } else {
              var url = config_.previous;
            }
            if (config_.prev_.search("&") !== -1) {
              var params = otherParameters.substring(
                2,
                otherParameters.indexOf("&") + 1000
              );
              url += "&" + params + "&";
            }
          }
        }

        // url += '&status=1
        getSinisterPag(url);
        $scope.actual_page = parPage;
        if ($scope.actual_page > 1) {
          $scope.not_prev = false;
        }

        if ($scope.actual_page == $scope.totalPages.length - 1) {
          $scope.not_next = true;
        }
      };

      $scope.previousBlockPages = function (param) {
        if (param) {
          if ($scope.start < $scope.actual_page) {
            $scope.start = $scope.start - 1;
            $scope.end = $scope.end - 1;
          }
        } else {
          $scope.start = $scope.start - 5;
          $scope.end = $scope.end - 5;

          if ($scope.end < $scope.totalPages.length) {
            $scope.not_next = false;
          }
        }

        if ($scope.end <= 5) {
          $scope.start = 0;
          $scope.end = 5;
          $scope.show_prev_block = false;
        }
      };

      $scope.nextBlockPages = function (param) {
        $scope.show_prev_block = true;

        if (param) {
          if ($scope.end > $scope.actual_page) {
            $scope.start = $scope.start + 1;
            $scope.end = $scope.end + 1;
          }
        } else {
          if ($scope.end < $scope.totalPages.length) {
            $scope.start = $scope.start + 5;
            $scope.end = $scope.end + 5;

            if ($scope.end == $scope.totalPages.length) {
              $scope.not_next = true;
            }
          } else {
            $scope.not_next = true;
          }
        }
      };

      function getSinisterPag(parUrl) {
        $http
          .get(parUrl)
          .then(
            function success(request) {
              var source = $parse(parModel);
              source.assign($scope, []);
              source.assign($scope, request.data.results);

              var data = {
                count: request.data.count,
                previous: request.data.previous,
                next: request.data.next,
              };
              var config = $parse(parConfig);
              config.assign($scope, []);
              config.assign($scope, data);
            },
            function error(error) {
              console.log("error", error);
            }
          )
          .catch(function (e) {
            console.log("e", e);
          });
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .directive("onFinishRendex", function ($timeout, $sessionStorage) {
      return {
        restrict: "A",
        link: function (scope, element, attr) {
          if (scope.$last === true) {
            $timeout(function () {
              scope.$emit("ngRepeatFinished");
            });
          }
        },
      };
    })
    .controller("AgendaCtrl", AgendaCtrl);

  AgendaCtrl.$inject = [
    "$http",
    "$scope",
    "calendarConfig",
    "dataFactory",
    "SweetAlert",
    "$uibModal",
    "url",
    "FileUploader",
    "$sessionStorage",
    "$localStorage",
    "$timeout",
  ];

  function AgendaCtrl(
    $http,
    $scope,
    calendarConfig,
    dataFactory,
    SweetAlert,
    $uibModal,
    url,
    FileUploader,
    $sessionStorage,
    $localStorage,
    $timeout
  ) {
    $scope.$on("ngRepeatFinished", function () {
      // console.log("Hola");

      $(".js-example-basic-multiple").select2();
    });
    // $("#checkbox").click(function(){
    //   if($("#checkbox").is(':checked') ){
    //     $("[name='states'] > option").prop("selected","selected");
    //     $("[name='states']").trigger("change");
    //   }else{
    //     $("[name='states'] > option").removeAttr("selected");
    //     $("[name='states']").trigger("change");
    //   }
    // });

    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var decryptedToken = sjcl.decrypt("Token", $sessionStorage.token);
    var usr = JSON.parse(decryptedUser);
    var token = JSON.parse(decryptedToken);
    var vm = this;
    $(".datepicker-me input").datepicker();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.language = "es";

    $scope.today = new Date();

    $scope.colors = [
      { id: "1", name: "Negro", value: "#000000" },
      { id: "2", name: "Rojo", value: "#ff0000" },
      { id: "3", name: "Amarillo", value: "#ffff00" },
      { id: "4", name: "Verde", value: "#008000" },
      { id: "5", name: "Azul", value: "#0000ff" },
      { id: "6", name: "Violeta", value: "#800080" },
      { id: "7", name: "Gris", value: "#808080" },
    ];

    vm.changeInitDate = changeInitDate;

    var date_match = addDays(new Date($scope.today));
    var options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    $scope.legend_today = date_match.toLocaleDateString("es-ES", options);

    function addDays(date) {
      date.setDate(date.getDate());
      return date;
    }

    $scope.changeMonth = function (value) {
      if (value == 0) {
        $scope.new_today = new Date();
        $scope.new_today.setMonth($scope.new_today.getMonth());
      } else {
        $scope.new_today.setMonth($scope.new_today.getMonth() + value);
      }
      var date_match = addDays(new Date($scope.new_today));
      var options = { month: "long" };
      $scope.month_today = date_match.toLocaleDateString("es-ES", options);
      var optionsYear = { year: "numeric" };
      $scope.year_today = date_match.toLocaleDateString("es-ES", optionsYear);
    };

    function changeInitDate(event, index) {
      if (new Date(event.startsAt) > new Date(event.endsAt)) {
        vm.events_new[index]["endsAt"] = new Date(event.startsAt);
        // $scope.event.endsAt = new Date(date).setDate(new Date(date).getDate()+1)
      }
    }

    activate();

    function activate() {
      dataFactory.get("schedule/").then(function success(response) {
        vm.events = response.data.results;
      });

      dataFactory.get("usuarios/").then(function (data) {
        var rs = data.data.results;
        var na = [];
        for (var v in rs) {
          var name = rs[v]["first_name"] + " " + rs[v]["last_name"];
          var us = {
            name: name,
            first_name: rs[v]["first_name"],
            last_name: rs[v]["last_name"],
            id: rs[v]["id"],
          };
          na.push(us);
        }
        vm.users = na;
        // console.log(vm.users);
      });
    }

    //These variables MUST be set as a minimum for the calendar to work
    vm.calendarView = "month";
    vm.viewDate = new Date();
    var actions = [
      {
        label: "<i class='glyphicon glyphicon-pencil'></i>",
        onClick: function (args) {
          console.log("Edited", args.calendarEvent);
        },
      },
      {
        label: "<i class='glyphicon glyphicon-remove'></i>",
        onClick: function (args) {
          console.log("Deleted", args.calendarEvent);
        },
      },
    ];
    vm.events_new = [];

    vm.cellIsOpen = false;

    vm.addEvent = function () {
      if ($localStorage["save_filters_diary"]) {
        vm.events_new = [];
        vm.events_new.push({
          title: $localStorage["save_filters_diary"]["title"]
            ? $localStorage["save_filters_diary"]["title"]
            : "",
          startsAt: new Date(),
          endsAt: new Date(),
          color: $localStorage["save_filters_diary"]["color"]
            ? $localStorage["save_filters_diary"]["color"]
            : 0,
          draggable: true,
          resizable: true,
          participants: $localStorage["save_filters_diary"]["participants"]
            ? $localStorage["save_filters_diary"]["participants"]
            : "",
          observations: $localStorage["save_filters_diary"]["observations"]
            ? $localStorage["save_filters_diary"]["observations"]
            : "",
        });
        $scope.colors.forEach(function (item) {
          if (item.id == $localStorage["save_filters_diary"]["color"]["id"]) {
            vm.events_new[0].color = item;
          }
        });
      } else {
        for (var i = 0; i < vm.events_new.length; i++) {
          vm.events_new[i].color = vm.events_new[i].color.value;
        }
        vm.events_new.push({
          title: "",
          startsAt: new Date(),
          endsAt: new Date(),
          color: calendarConfig.colorTypes.warning,
          draggable: true,
          resizable: true,
          participants: "",
          observations: "",
        });
      }

      if ("save_filters_diary" in $localStorage) {
      } else {
        $localStorage["save_filters_diary"] = {};
      }
    };

    vm.saveLocalstorange = function () {
      $localStorage["save_filters_diary"]["title"] = vm.events_new[0].title;
      $localStorage["save_filters_diary"]["color"] = vm.events_new[0].color;
      $localStorage["save_filters_diary"]["startsAt"] =
        vm.events_new[0].startsAt;
      $localStorage["save_filters_diary"]["endsAt"] = vm.events_new[0].endsAt;
      $localStorage["save_filters_diary"]["observations"] =
        vm.events_new[0].observations;
      $localStorage["save_filters_diary"]["participants"] =
        vm.events_new[0].participants;
    };

    vm.saveEvent = function () {
      var l = Ladda.create(document.querySelector(".ladda-button"));
      l.start();
      var tempS = vm.events_new;
      for (var i = 0; i < tempS; i++) {
        tempS[i].color = tempS[i].color.value;
      }

      // tempS.map(function(item){
      //   item.endsAt = new Date(tempS[i].color.endsAt);
      //   console.log('endsAt ',item.endsAt);
      //   return item;
      // });

      // console.log('tempS', tempS);

      dataFactory
        .post("schedule/", tempS)
        .then(function success(response) {
          if (response.status == 200 || response.status == 201) {
            if ($scope.countFile > 0) {
              uploadFiles(response.data[0].id);
            }
            SweetAlert.swal("Hecho", "Se han guardado los eventos", "success");
            for (var i = 0; i < vm.events_new.length; i++) {
              vm.events_new.splice(i, 1);
            }
            l.stop();
            activate();
          } else {
            l.stop();
            SweetAlert.swal(
              "ERROR",
              "Ha ocurrido un error al guardar el evento, revise datos requeridos y, vuelva intentarlo",
              "error"
            );
            return;
          }
        })
        .then(function () {
          setTimeout(function () {
            // vm.addEvent();
          }, 100);
        });
    };

    vm.eventClicked = function (event) {
      var modalInstance = $uibModal.open({
        templateUrl: "app/agenda/agenda.modal.html",
        controller: AgendaModalCtrl,
        controllerAs: "vmm",
        size: "md",
        resolve: {
          eventModal: function () {
            return event;
          },
        },
        backdrop: "static",
        keyboard: false,
      });
    };

    vm.eventEdited = function (event) {
      console.log("Edited", event);
    };

    vm.eventDeleted = function (event) {
      console.log("Deleted", event);
    };

    vm.eventTimesChanged = function (event) {
      console.log("Dropped or resized", event);
    };

    vm.toggle = function ($event, field, event) {
      $event.preventDefault();
      $event.stopPropagation();
      event[field] = !event[field];
    };

    vm.timespanClicked = function (date, cell) {
      if (vm.calendarView === "month") {
        if (
          (vm.cellIsOpen &&
            moment(date)
              .startOf("day")
              .isSame(moment(vm.viewDate).startOf("day"))) ||
          cell.events.length === 0 ||
          !cell.inMonth
        ) {
          vm.cellIsOpen = false;
        } else {
          vm.cellIsOpen = true;
          vm.viewDate = date;
        }
      } else if (vm.calendarView === "year") {
        if (
          (vm.cellIsOpen &&
            moment(date)
              .startOf("month")
              .isSame(moment(vm.viewDate).startOf("month"))) ||
          cell.events.length === 0
        ) {
          vm.cellIsOpen = false;
        } else {
          vm.cellIsOpen = true;
          vm.viewDate = date;
        }
      }
    };

    $scope.delete = function (event, idx) {
      vm.events_new.splice(idx, 1);
    };
    $scope.Adds = function (idx) {
      // vm.events_new[idx].push({
      vm.events_new[0].participants = vm.users;
      // $('.js-example-basic-multiple').select2();
      // $scope.digest();
    };
    $scope.changeSensible = function (sensible, index) {
      uploader.queue[index].formData[0].sensible = sensible;
    };
    /** Uploader files */
    $scope.userInfo = {
      id: 0,
    };
    $scope.countFile = 0;
    $scope.okFile = 0;

    var uploader = ($scope.uploader = new FileUploader({
      headers: {
        //'Authorization': 'Token ' + token,
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }));

    // uploader.filters.push({
    //     name: 'customFilter',
    //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
    //         return this.queue.length < 20;
    //     }
    // });

    // ALERTA SUCCES UPLOADFILES
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      //toaster.success(MESSAGES.OK.UPLOADFILES);
      if ($uibModalInstance) {
        $uibModalInstance.dismiss("cancel");
      }
      $scope.okFile++;
      if ($scope.okFile == $scope.countFile) {
        $timeout(function () {
          // if($uibModalInstance) {
          // $uibModalInstance.close(200);
          // }
        }, 1000);
      }
    };

    // ALERTA ERROR UPLOADFILES
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response.status == 413) {
        toaster.error(MESSAGES.ERROR.FILETOOLARGE);
        // order.options.checkDate('initial');
        // $state.go('polizas.editar', { polizaId: $scope.idPolicy, message: 2 });
      } else {
        toaster.error(MESSAGES.ERROR.ERRORONUPLOADFILES);
        // order.options.checkDate('initial');
        // $state.go('polizas.editar', { polizaId: $scope.idPolicy, message: 1 });
      }
    };

    uploader.onAfterAddingFile = function (fileItem) {
      fileItem.formData.push({
        arch: fileItem._file,
        nombre: fileItem.file.name,
      });
      $scope.specialchar = [];
      var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
      var str = fileItem.file.name;
      for (i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          if (
            specialChars[i] == "-" ||
            specialChars[i] == " " ||
            specialChars[i] == "_" ||
            specialChars[i] == "#" ||
            specialChars[i] == "(" ||
            specialChars[i] == ")" ||
            specialChars[i] == ":" ||
            specialChars[i] == '"'
          ) {
            str = str.replace(/-/g, "");
            fileItem.file.name = fileItem.file.name.replace(/-/g, "");
            str = str.replace(/ /g, "");
            fileItem.file.name = fileItem.file.name.replace(/ /g, "");
            str = str.replace(/_/g, "");
            fileItem.file.name = fileItem.file.name.replace(/_/g, "");
            str = str.replace(/#/g, "");
            fileItem.file.name = fileItem.file.name.replace(/#/g, "");
            str = str.split(")").join("");
            fileItem.file.name = fileItem.file.name.split(")").join("");
            str = str.split("(").join("");
            fileItem.file.name = fileItem.file.name.split("(").join("");
            str = str.split(":").join("");
            fileItem.file.name = fileItem.file.name.split(":").join("");
            str = str.split('"').join("");
            fileItem.file.name = fileItem.file.name.split('"').join("");
            str = str.split("+").join("");
            fileItem.file.name = fileItem.file.name.split("+").join("");
          } else {
            $scope.specialchar.push(specialChars[i]);
          }
        }
      }
      if ($scope.specialchar.length > 0) {
        $scope.uploader.queue.splice(
          $scope.uploader.queue.indexOf(fileItem),
          1
        );
        SweetAlert.swal(
          "Error",
          "El nombre de archivo: " +
            str +
            ", contiene carácteres especiales: " +
            $scope.specialchar,
          "error"
        );
      }
      if (fileItem) {
        $scope.countFile++;
      }
    };

    uploader.onBeforeUploadItem = function (item) {
      if (item.file.sensible != undefined) {
        item.formData[0].sensible = item.file.sensible;
      }
      item.url = $scope.userInfo.url;
      item.formData[0].nombre = item.file.name;
      item.alias = "";
      item.formData[0].owner = $scope.userInfo.id;
    };
    function uploadFiles(eventId) {
      $scope.userInfo = {
        id: eventId,
      };
      $scope.userInfo.url = $scope.uploader.url =
        url.IP + "events/" + eventId + "/archivos/";
      $scope.files = [];
      $scope.files_ = [];

      $timeout(function () {
        $scope.uploader.uploadAll();
        $http
          .get(url.IP + "events/" + eventId + "/archivos/")
          .then(function (response) {
            // console.log('files', response);
            if (response.status === 200) {
              vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.show_files_events = true;
            } else if (response.status === 403) {
              $scope.show_files_events = false;
            }
          });
      }, 1000);
    }
    function AgendaModalCtrl(
      $scope,
      eventModal,
      $uibModalInstance,
      $http,
      MESSAGES,
      url,
      FileUploader
    ) {
      $scope.colors = [
        { id: "1", name: "Negro", value: "#000000" },
        { id: "2", name: "Rojo", value: "#ff0000" },
        { id: "3", name: "Amarillo", value: "#ffff00" },
        { id: "4", name: "Verde", value: "#008000" },
        { id: "5", name: "Azul", value: "#0000ff" },
        { id: "6", name: "Violeta", value: "#800080" },
        { id: "7", name: "Gris", value: "#808080" },
      ];

      if (eventModal) {
        $http
          .get(url.IP + "events/" + eventModal.id + "/archivos/")
          .then(function (response) {
            // console.log('files', response);
            if (response.status === 200) {
              vm.files = response.data.results;
              $scope.files = response.data.results;
              $scope.show_files_events = true;
            } else if (response.status === 403) {
              $scope.show_files_events = false;
            }
          });
      } else {
        $scope.files = [];
        vm.files = [];
      }
      $scope.event = eventModal;

      for (var i = 0; i < $scope.colors.length; i++) {
        if ($scope.event.color == $scope.colors[i].value) {
          $scope.event.color = $scope.colors[i];
        }
      }

      $scope.event.startsAt = new Date($scope.event.startsAt);
      $scope.event.endsAt = new Date($scope.event.endsAt);
      try {
        var aux_color = JSON.parse($scope.event.color.split("'").join('"'));
        $scope.colors.forEach(function (color) {
          if (color.id == aux_color.id) {
            $scope.event.color = color;
          }
        });
      } catch (err) {}

      $scope.editEvent = function (event) {
        // event.color = event.color.value;
        $http.patch(event.url, event).then(function (response) {
          if (response.status == 200) {
            SweetAlert.swal("¡Listo!", MESSAGES.OK.UPDATEEVENT, "success");
            if ($scope.countFile > 0) {
              uploadFiles(event.id);
            }
            activate();
            $uibModalInstance.dismiss("cancel");
          }
        });
      };

      $scope.deleteFile = function (file, container) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "No será posible recuperar este archivo",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar",
            closeOnConfirm: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http({
                method: "GET",
                url: url.IP + "delete-manual",
                params: {
                  file_id: file.id,
                },
              }).then(function success(response) {
                if (response.data.status == 204) {
                  SweetAlert.swal(
                    "¡Eliminado!",
                    "El archivo fue eliminado.",
                    "success"
                  );
                  container.splice(container.indexOf(file), 1);
                }
              });
            }
          }
        );
      };
      $scope.deleteEvent = function (event) {
        SweetAlert.swal(
          {
            title: "¿Está seguro?",
            text: "No será posible recuperar el evento",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Si, estoy seguro.",
            cancelButtonText: "Cancelar.",
            closeOnConfirm: false,
          },
          function (isConfirm) {
            if (isConfirm) {
              $http.delete(event.url).then(function (response) {
                if (response.status == 204) {
                  if ($scope.files) {
                    $scope.files.forEach(function (x) {
                      $http.delete(x.url).then(function (delFile) {});
                    });
                  }
                  SweetAlert.swal(
                    "¡Listo!",
                    MESSAGES.OK.DELETEEVENT,
                    "success"
                  );
                  activate();
                  $uibModalInstance.dismiss("cancel");
                }
              });
            }
          }
        );
      };
      /** Uploader files */
      $scope.userInfo = {
        id: 0,
      };
      $scope.countFile = 0;
      $scope.okFile = 0;

      var uploader = ($scope.uploader = new FileUploader({
        headers: {
          //'Authorization': 'Token ' + token,
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }));

      // uploader.filters.push({
      //     name: 'customFilter',
      //     fn: function(item /*{File|FileLikeObject}*/ , options) { //jshint ignore:line
      //         return this.queue.length < 20;
      //     }
      // });

      // ALERTA SUCCES UPLOADFILES
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        //toaster.success(MESSAGES.OK.UPLOADFILES);
        if ($uibModalInstance) {
          $uibModalInstance.dismiss("cancel");
        }
        $scope.okFile++;
        if ($scope.okFile == $scope.countFile) {
          $timeout(function () {
            if ($uibModalInstance) {
              // $uibModalInstance.close(200);
            }
          }, 1000);
        }
      };

      // ALERTA ERROR UPLOADFILES
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        if (response.status == 413) {
          toaster.error(MESSAGES.ERROR.FILETOOLARGE);
          // order.options.checkDate('initial');
          // $state.go('polizas.editar', { polizaId: $scope.idPolicy, message: 2 });
        } else {
          toaster.error(MESSAGES.ERROR.ERRORONUPLOADFILES);
          // order.options.checkDate('initial');
          // $state.go('polizas.editar', { polizaId: $scope.idPolicy, message: 1 });
        }
      };

      uploader.onAfterAddingFile = function (fileItem) {
        fileItem.formData.push({
          arch: fileItem._file,
          nombre: fileItem.file.name,
        });
        $scope.specialchar = [];
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,/~`-=";
        var str = fileItem.file.name;
        for (i = 0; i < specialChars.length; i++) {
          if (str.indexOf(specialChars[i]) > -1) {
            if (
              specialChars[i] == "-" ||
              specialChars[i] == " " ||
              specialChars[i] == "_" ||
              specialChars[i] == "#" ||
              specialChars[i] == "(" ||
              specialChars[i] == ")" ||
              specialChars[i] == ":" ||
              specialChars[i] == '"'
            ) {
              str = str.replace(/-/g, "");
              fileItem.file.name = fileItem.file.name.replace(/-/g, "");
              str = str.replace(/ /g, "");
              fileItem.file.name = fileItem.file.name.replace(/ /g, "");
              str = str.replace(/_/g, "");
              fileItem.file.name = fileItem.file.name.replace(/_/g, "");
              str = str.replace(/#/g, "");
              fileItem.file.name = fileItem.file.name.replace(/#/g, "");
              str = str.split(")").join("");
              fileItem.file.name = fileItem.file.name.split(")").join("");
              str = str.split("(").join("");
              fileItem.file.name = fileItem.file.name.split("(").join("");
              str = str.split(":").join("");
              fileItem.file.name = fileItem.file.name.split(":").join("");
              str = str.split('"').join("");
              fileItem.file.name = fileItem.file.name.split('"').join("");
              str = str.split("+").join("");
              fileItem.file.name = fileItem.file.name.split("+").join("");
            } else {
              $scope.specialchar.push(specialChars[i]);
            }
          }
        }
        fileItem.formData.push({
          arch: fileItem._file,
          nombre: fileItem.file.name,
        });
        if ($scope.specialchar.length > 0) {
          $scope.uploader.queue.splice(
            $scope.uploader.queue.indexOf(fileItem),
            1
          );
          SweetAlert.swal(
            "Error",
            "El nombre de archivo: " +
              str +
              ", contiene carácteres especiales: " +
              $scope.specialchar,
            "error"
          );
        }
        if (fileItem) {
          $scope.countFile++;
        }
      };

      uploader.onBeforeUploadItem = function (item) {
        if (item.file.sensible != undefined) {
          item.formData[0].sensible = item.file.sensible;
        }
        item.url = $scope.userInfo.url;
        item.formData[0].nombre = item.file.name;
        item.alias = "";
        item.formData[0].owner = $scope.userInfo.id;
      };
      function uploadFiles(eventId) {
        $scope.userInfo = {
          id: eventId,
        };
        $scope.userInfo.url = $scope.uploader.url =
          url.IP + "events/" + eventId + "/archivos/";
        $scope.files = [];
        $scope.files_ = [];

        $timeout(function () {
          $scope.uploader.uploadAll();
          $http
            .get(url.IP + "events/" + eventModal.id + "/archivos/")
            .then(function (response) {
              // console.log('files', response);
              if (response.status === 200) {
                vm.files = response.data.results;
                $scope.files = response.data.results;
                $scope.show_files_events = true;
              } else if (response.status === 403) {
                $scope.show_files_events = false;
              }
            });
        }, 1000);
      }
      $scope.close = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }
  }
})();

(function () {
  "use strict";
  var app = angular.module("inspinia");
  app.constant("URLS_CONFIG", {
    cas: "https://users-api.miurabox.com/",
    // cas: 'http://localhost:9000/',
    api: "https://api.miurabox.com/",
    // api: 'http://localhost:8000/',  // Referencia
    //mc: 'https://grupoasapi.multicotizador.com/'
    // mc: 'http://127.0.0.1:8001/'
    REPORT_SERVICE_NODE_SOCKET_ANCORA: "https://socketancora.mbxservicios.com",
    REPORT_SERVICE_NODE_SOCKET: "https://socketn.mbxservicios.com",
    SERVICE_PDF: "https://pdf-api.miurabox.com/",
    LECTORPDF: "https://pdfreader.mbxservicios.com/",
  });
})();

(function () {
  "use strict";

  var app = angular.module("inspinia");

  app.factory("appStates", [
    "$state",
    "$localStorage",
    function ($state, $localStorage) {
      var states = [
        // { name: 'Polizas', heading: "Polizas", route: "polizas.table", event: null, isVisible: true, href: $state.href("polizas.table") },
        {
          id: 0,
          name: "Dashboard",
          heading: "Dashboard",
          route: "index.main",
          event: null,
          isVisible: true,
          href: $state.href("index.main"),
        },
        // { name: 'Crear contratante', heading: "Crear contratante", route: "contratantes.create", event: null, isVisible: true, href: $state.href("contratantes.create") },
      ];
      try {
        if ($localStorage.tab_states && $localStorage.tab_states.length > 0) {
          var states = $localStorage.tab_states;
        }
      } catch (err) {
        console.error("error states", err);
        $localStorage.tab_states = states;
      }

      var getActiveTab = function () {
        var index = states.findIndex(function (state) {
          return state.active === true;
        });
        return index;
      };

      var getActualTab = function () {
        var index = $localStorage.tab_index;
        return $localStorage.tab_states[index];
      };

      var estados = function (current_state, url, stateParams) {
        // console.log(current_state);
        // console.log('regex ', url.match(/contratantes\/fisicas\/(.*)$/)[1].replace('/',''));
        var abstract_estados = {
          "inicio.inicio": {
            id: 0,
            name: "Inicio",
            heading: "Inicio",
            route: "inicio.inicio",
            event: null,
            active: true,
            isVisible: true,
            href: $state.href("inicio.inicio"),
          },
          "index.main": {
            id: 0,
            name: "Dashboard",
            heading: "Dashboard",
            route: "index.main",
            event: null,
            active: true,
            isVisible: true,
            href: $state.href("index.main"),
          },
          "contratantes.create": {
            id: 0,
            name: "Nuevo contratante",
            heading: "Nuevo contratante",
            route: "contratantes.create",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("contratantes.create"),
          },
          "contratantes.list": {
            id: 0,
            name: "Lista contratantes",
            heading: "Lista contratantes",
            route: "contratantes.list",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("contratantes.list"),
          },
          "recordatorios.automaticos": {
            id: 0,
            name: "Recordatorios automáticos",
            heading: "Recordatorios automáticos",
            route: "recordatorios.automaticos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("recordatorios.automaticos"),
          },
          "recordatorios.libres": {
            id: 0,
            name: "Recordatorios libres",
            heading: "Recordatorios libres",
            route: "recordatorios.libres",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("recordatorios.libres"),
          },
          "recordatorios.desde_registros": {
            id: 0,
            name: "Recordatorios de registros",
            heading: "Recordatorios de registros",
            route: "recordatorios.desde_registros",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("recordatorios.desde_registros"),
          },
          "contratantes.main": {
            id: 0,
            name: "Lista contratantes",
            heading: "Lista contratantes",
            route: "contratantes.list",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("contratantes.list"),
          },
          "contratantes.info": {
            active: true,
            heading: "Información contratante",
            name: "Información contratante",
            href: $state.href("contratantes.info", {
              contratanteId: url.match(/contratantes\/fisicas\/(.*)$/)
                ? url.match(/contratantes\/fisicas\/(.*)$/)[1].replace("/", "") //nested ternary operator
                : url.match(/contratantes\/morales\/(.*)$/)
                ? url.match(/contratantes\/morales\/(.*)$/)[1].replace("/", "")
                : 0,
              type: url.match(/contratantes\/(.*)$/)
                ? url.match(/contratantes\/(.*)$/)[1].split("/")[0]
                : 0,
            }),
            id: url.match(/contratantes\/fisicas\/(.*)$/)
              ? url.match(/contratantes\/fisicas\/(.*)$/)[1].replace("/", "")
              : url.match(/contratantes\/morales\/(.*)$/)
              ? url.match(/contratantes\/morales\/(.*)$/)[1].replace("/", "")
              : 0,
            type: url.match(/contratantes\/(.*)$/)
              ? url.match(/contratantes\/(.*)$/)[1].split("/")[0]
              : 0,
            isVisible: true,
            route: "contratantes.info",
          },
          "recordatorios.automaticos_detalle": {
            active: true,
            heading: "Información recordatorio",
            name: "Información recordatorio",
            href: $state.href("recordatorios.automaticos_detalle", {
              id: url.match(/recordatorios\/automaticos-detalle\/(.*)$/)
                ? url
                    .match(/recordatorios\/automaticos-detalle\/(.*)$/)[1]
                    .replace("/", "")
                : 0,
            }),
            id: url.match(/recordatorios\/automaticos-detalle\/(.*)$/)
              ? url
                  .match(/recordatorios\/automaticos-detalle\/(.*)$/)[1]
                  .replace("/", "")
              : 0,
            isVisible: true,
            route: "recordatorios.automaticos_detalle",
          },
          "contratantes.edit": {
            active: true,
            heading: "Editar contratante",
            name: "Editar contratante",
            href: $state.href("contratantes.edit", {
              contratanteId: url.match(/contratantes\/fisicas\/editar\/(.*)$/)
                ? url
                    .match(/contratantes\/fisicas\/editar\/(.*)$/)[1]
                    .replace("/", "") //nested ternary operator
                : url.match(/contratantes\/morales\/editar\/(.*)$/)
                ? url
                    .match(/contratantes\/morales\/editar\/(.*)$/)[1]
                    .replace("/", "")
                : 0,
              type: url.match(/contratantes\/(.*)$/)
                ? url.match(/contratantes\/(.*)$/)[1].split("/")[0]
                : 0,
            }),
            id: url.match(/contratantes\/fisicas\/editar\/(.*)$/)
              ? url
                  .match(/contratantes\/fisicas\/editar\/(.*)$/)[1]
                  .replace("/", "")
              : url.match(/contratantes\/morales\/editar\/(.*)$/)
              ? url
                  .match(/contratantes\/morales\/editar\/(.*)$/)[1]
                  .replace("/", "")
              : 0,
            type: url.match(/contratantes\/(.*)$/)
              ? url.match(/contratantes\/(.*)$/)[1].split("/")[0]
              : 0,
            isVisible: true,
            route: "contratantes.edit",
          },
          "grupos.grupos": {
            id: 0,
            name: "Grupos",
            heading: "Grupos",
            route: "grupos.grupos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("grupos.grupos"),
          },
          "grupos.info": {
            active: true,
            heading: "Información grupo",
            name: "Información grupo",
            href: $state.href("grupos.info", {
              grupoId: url.match(/grupos\/informacion\/(.*)$/)
                ? url.match(/grupos\/informacion\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
            id: url.match(/grupos\/informacion\/(.*)$/)
              ? url.match(/grupos\/informacion\/(.*)$/)[1].replace("/", "")
              : 0,
            isVisible: true,
            route: "grupos.info",
          },
          "grupos.edit": {
            active: true,
            heading: "Edición grupo",
            name: "Edición grupo",
            href: $state.href("grupos.edit", {
              grupoId: url.match(/grupos\/editar\/(.*)$/)
                ? url.match(/grupos\/editar\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
            id: url.match(/grupos\/editar\/(.*)$/)
              ? url.match(/grupos\/editar\/(.*)$/)[1].replace("/", "")
              : 0,
            isVisible: true,
            route: "grupos.edit",
          },
          "clasificacion.clasificacion": {
            id: 0,
            name: "Clasificación",
            heading: "Clasificación",
            route: "clasificacion.clasificacion",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("clasificacion.clasificacion"),
          },
          "celulacontractor.celulacontractor": {
            id: 0,
            name: "Célula",
            heading: "Célula",
            route: "celulacontractor.celulacontractor",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("celulacontractor.celulacontractor"),
          },
          "groupinglevel.groupinglevel": {
            id: 0,
            name: "Niveles de Agrupación",
            heading: "Niveles de Agrupación",
            route: "groupinglevel.groupinglevel",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("groupinglevel.groupinglevel"),
          },
          "polizas.table": {
            id: 0,
            name: "Listado pólizas",
            heading: "Listado pólizas",
            route: "polizas.table",
            event: null,
            active: true,
            isVisible: true,
            href: $state.href("polizas.table"),
          },
          "polizas.info": {
            id: url.match(/polizas\/(.*)$/)
              ? url.match(/polizas\/(.*)$/)[1]
              : 0,
            name: "Información pólizas",
            heading: "Información pólizas",
            route: "polizas.info",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("polizas.info", {
              polizaId: url.match(/polizas\/(.*)$/)
                ? url.match(/polizas\/(.*)$/)[1]
                : 0,
            }),
          },
          "polizas.create": {
            id: 0,
            name: "Crear póliza",
            heading: "Crear póliza",
            route: "polizas.create",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("polizas.create"),
          },
          "polizas.editar": {
            id: url.match(/polizas\/(.*)$/)
              ? url.match(/polizas\/(.*)$/)[1].replace("/editar", "")
              : 0,
            name: "Editar póliza",
            heading: "Editar póliza",
            route: "polizas.editar",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("polizas.editar", {
              polizaId: url.match(/polizas\/(.*)$/)
                ? url.match(/polizas\/(.*)$/)[1].replace("/editar", "")
                : 0,
            }),
          },
          "compartir.create": {
            id: url.match(/compartir\/(.*)$/)
              ? url.match(/compartir\/(.*)$/)[1]
              : 0,
            name: "Compartir a la App",
            heading: "Compartir a la App",
            route: "compartir.create",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("compartir.create", {
              polizaId: url.match(/compartir\/(.*)$/)
                ? url.match(/compartir\/(.*)$/)[1]
                : 0,
            }),
          },
          "conexion.agentes": {
            id: url.match(/conexion\/(.*)$/)
              ? url.match(/conexion\/(.*)$/)[1]
              : 0,
            name: "Conexión Agentes",
            heading: "Conexión Agentes",
            route: "conexion.agentes",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("conexion.agentes", {
              polizaId: url.match(/conexion\/(.*)$/)
                ? url.match(/conexion\/(.*)$/)[1]
                : 0,
            }),
          },
          "colectividades.main": {
            id: 0,
            name: "Póliza Grupo",
            heading: "Póliza Grupo",
            route: "colectividades.main",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("colectividades.main"),
          },
          "colectividades.table": {
            id: 0,
            name: "Listado PGrupo",
            heading: "Listado PGrupo",
            route: "colectividades.table",
            event: null,
            active: true,
            isVisible: true,
            href: $state.href("colectividades.table"),
          },
          "colectividades.info": {
            id: url.match(/colectividades\/(.*)$/)
              ? url.match(/colectividades\/(.*)$/)[1]
              : 0,
            name: "Información Póliza Grupo",
            heading: "Información Póliza Grupo",
            route: "colectividades.info",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("colectividades.info", {
              polizaId: url.match(/colectividades\/(.*)$/)
                ? url.match(/colectividades\/(.*)$/)[1]
                : 0,
            }),
          },
          "colectividades.edit": {
            id: url.match(/colectividades\/editar\/(.*)$/)
              ? url
                  .match(/colectividades\/editar\/(.*)$/)[1]
                  .replace("/editar", "")
              : 0,
            name: "Editar póliza",
            heading: "Editar póliza",
            route: "colectividades.edit",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("colectividades.edit", {
              polizaId: url.match(/colectividades\/editar\/(.*)$/)
                ? url
                    .match(/colectividades\/editar\/(.*)$/)[1]
                    .replace("/editar", "")
                : 0,
            }),
          },
          "colectividades.renewal": {
            id: url.match(/colectividades\/renovaciones\/(.*)$/)
              ? url
                  .match(/colectividades\/renovaciones\/(.*)$/)[1]
                  .replace("/", "")
              : 0,
            name: "Renovar póliza",
            heading: "Renovar póliza",
            route: "colectividades.renewal",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("colectividades.renewal", {
              polizaId: url.match(/colectividades\/renovaciones\/(.*)$/)
                ? url
                    .match(/colectividades\/renovaciones\/(.*)$/)[1]
                    .replace("/", "")
                : 0,
            }),
          },
          "colectividades.convertirPoliza": {
            id: 0,
            name: "Convertir a póliza",
            heading: "Convertir a póliza",
            route: "colectividades.convertirPoliza",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("colectividades.convertirPoliza"),
          },
          "colectividades.masivos": {
            id: 0,
            name: "Archivos a Certificados",
            heading: "Archivos a Certificados",
            route: "colectividades.masivos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("colectividades.masivos"),
          },
          "colectivos.plantillas": {
            id: 0,
            name: "Certificados Plantillas",
            heading: "Certificados Plantillas",
            route: "colectivos.plantillas",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("colectivos.plantillas"),
          },
          "flotillas.flotillas": {
            id: 0,
            name: "Flotillas",
            heading: "Flotillas",
            route: "flotillas.flotillas",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("flotillas.flotillas"),
          },
          "flotillas.info": {
            id: url.match(/flotillas\/(.*)$/)
              ? url.match(/flotillas\/(.*)$/)[1]
              : 0,
            name: "Información flotillas",
            heading: "Información flotillas",
            route: "flotillas.info",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("flotillas.info", {
              polizaId: url.match(/flotillas\/(.*)$/)
                ? url.match(/flotillas\/(.*)$/)[1]
                : 0,
            }),
          },
          "flotillas.details": {
            id: url.match(/flotillas\/(.*)$/)
              ? url.match(/flotillas\/(.*)$/)[1]
              : 0,
            name: "Información flotillas",
            heading: "Información flotillas",
            route: "flotillas.details",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("flotillas.details", {
              polizaId: url.match(/flotillas\/(.*)$/)
                ? url.match(/flotillas\/(.*)$/)[1]
                : 0,
            }),
          },
          "flotillas.edit": {
            id: url.match(/flotillas\/editar\/(.*)$/)
              ? url.match(/flotillas\/editar\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Editar Colectividad",
            heading: "Editar Colectividad",
            route: "flotillas.edit",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("flotillas.edit", {
              polizaId: url.match(/flotillas\/editar\/(.*)$/)
                ? url.match(/flotillas\/editar\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "flotillas.renewal": {
            id: url.match(/flotillas\/renewal\/(.*)$/)
              ? url.match(/flotillas\/renewal\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Renovar Colectividad",
            heading: "Renovar Colectividad",
            route: "flotillas.renewal",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("flotillas.renewal", {
              polizaId: url.match(/flotillas\/renewal\/(.*)$/)
                ? url.match(/flotillas\/renewal\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "fianzas.fianzas": {
            id: 0,
            name: "Fianzas",
            heading: "Fianzas",
            route: "fianzas.fianzas",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.fianzas"),
          },
          "fianzas.reclist": {
            id: 0,
            name: "Lista reclamaciones",
            heading: "Lista reclamaciones",
            route: "fianzas.reclist",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.reclist"),
          },
          "fianzas.reclinf": {
            id: url.match(/reclamaciones\/info\/(.*)$/)
              ? url.match(/reclamaciones\/info\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información Reclamación",
            heading: "Información Reclamación",
            route: "fianzas.reclinf",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.reclinf", {
              claimId: url.match(/reclamaciones\/info\/(.*)$/)
                ? url.match(/reclamaciones\/info\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "fianzas.colectividades": {
            id: 0,
            name: "Fianzas Colectivas",
            heading: "Fianzas Colectivas",
            route: "fianzas.colectividades",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.colectividades"),
          },
          "fianzas.edit": {
            id: url.match(/fianzas\/colectividades\/editar\/(.*)$/)
              ? url
                  .match(/fianzas\/colectividades\/editar\/(.*)$/)[1]
                  .replace("/", "")
              : 0,
            name: "Editar fianzas",
            heading: "Editar fianzas",
            route: "fianzas.edit",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.edit", {
              polizaId: url.match(/fianzas\/colectividades\/editar\/(.*)$/)
                ? url
                    .match(/fianzas\/colectividades\/editar\/(.*)$/)[1]
                    .replace("/", "")
                : 0,
            }),
          },
          "fianzas.renewal": {
            id: url.match(/fianzas\/colectividades\/(.*)$/)
              ? url.match(/fianzas\/colectividades\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Renovar fianzas",
            heading: "Renovar fianzas",
            route: "fianzas.renewal",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.renewal", {
              polizaId: url.match(/fianzas\/colectividades\/(.*)/)
                ? url.match(/fianzas\/colectividades\/(.*)/)[1].replace("/", "")
                : 0,
            }),
          },
          "fianzas.reissue": {
            id: url.match(/colectividades\/(.*)$/)
              ? url.match(/colectividades\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Reexpedir fianzas",
            heading: "Reexpedir fianzas",
            route: "fianzas.reissue",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.reissue", {
              polizaId: url.match(/colectividades\/(.*)$/)
                ? url.match(/colectividades\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "fianzas.details": {
            id: url.match(/fianzas\/colectividades\/(.*)$/)
              ? url.match(/fianzas\/colectividades\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información fianzas Colectivas",
            heading: "Información fianzas Colectivas",
            route: "fianzas.details",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.details", {
              polizaId: url.match(/fianzas\/colectividades\/(.*)$/)
                ? url
                    .match(/fianzas\/colectividades\/(.*)$/)[1]
                    .replace("/", "")
                : 0,
            }),
          },
          "fianzas.reclamaciones": {
            id: 0,
            name: "Reclamaciones de Fianza",
            heading: "Reclamaciones de Fianza",
            route: "fianzas.reclamaciones",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.reclamaciones"),
          },
          "fianzas.list": {
            id: 0,
            name: "Lista fianzas",
            heading: "Lista fianzas",
            route: "fianzas.list",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.list"),
          },
          "fianzas.info": {
            id: url.match(/fianzas\/informacion\/(.*)$/)
              ? url.match(/fianzas\/informacion\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información fianzas",
            heading: "Información fianzas",
            route: "fianzas.info",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.info", {
              polizaId: url.match(/fianzas\/informacion\/(.*)$/)
                ? url.match(/fianzas\/informacion\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "fianzas.pprovlist": {
            id: 0,
            name: "Lista proveedores",
            heading: "Lista proveedores",
            route: "fianzas.pprovlist",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.pprovlist"),
          },
          "fianzas.pprovnew": {
            id: 0,
            name: "Nuevo proveedores",
            heading: "Nuevo proveedores",
            route: "fianzas.pprovnew",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.pprovnew"),
          },
          "fianzas.editar": {
            id: url.match(/fianzas\/editar\/(.*)$/)
              ? url.match(/fianzas\/editar\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Edición fianzas",
            heading: "Edición fianzas",
            route: "fianzas.editar",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.editar", {
              polizaId: url.match(/fianzas\/editar\/(.*)$/)
                ? url.match(/fianzas\/editar\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "fianzas.renovar": {
            id: url.match(/fianzas\/(.*)$\/(.*)$/)
              ? url.match(/fianzas\/(.*)$\/(.*)$/)[1].replace("/", "")
              : 0,
            renovacion: url.match(/fianzas\/(.*)$\/(.*)$/)
              ? url.match(/fianzas\/(.*)$\/(.*)$/)[2].replace("/", "")
              : 0,
            name: "Renovar fianzas",
            heading: "Renovar fianzas",
            route: "fianzas.renovar",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.renovar", {
              polizaId: url.match(/fianzas\/(.*)$\/(.*)$/)
                ? url.match(/fianzas\/(.*)$\/(.*)$/)[1].replace("/", "")
                : 0,
              renovacion: url.match(/fianzas\/(.*)$\/(.*)$/)
                ? url.match(/fianzas\/(.*)$\/(.*)$/)[2].replace("/", "")
                : 0,
            }),
          },
          "fianzas.reexpedir": {
            id: url.match(/fianzas\/(.*)$\/(.*)$/)
              ? url.match(/fianzas\/(.*)$\/(.*)$/)[1].replace("/", "")
              : 0,
            reexpedir: url.match(/fianzas\/(.*)$\/(.*)$/)
              ? url.match(/fianzas\/(.*)$\/(.*)$/)[2].replace("/", "")
              : 0,
            name: "Reexpedir fianzas",
            heading: "Reexpedir fianzas",
            route: "fianzas.reexpedir",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("fianzas.reexpedir", {
              polizaId: url.match(/fianzas\/(.*)$\/(.*)$/)
                ? url.match(/fianzas\/(.*)$\/(.*)$/)[1].replace("/", "")
                : 0,
              reexpedir: url.match(/fianzas\/(.*)$\/(.*)$/)
                ? url.match(/fianzas\/(.*)$\/(.*)$/)[2].replace("/", "")
                : 0,
            }),
          },
          "reclamacion.edit": {
            id: url.match(/fianzas\/reclamaciones\/(.*)$/)
              ? url.match(/fianzas\/reclamaciones\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Reclamaciones fianzas",
            heading: "Reclamaciones fianzas",
            route: "reclamacion.edit",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reclamacion.edit", {
              reclId: url.match(/fianzas\/reclamaciones\/(.*)$/)
                ? url.match(/fianzas\/reclamaciones\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "fianzas.pprovinfo": {
            active: true,
            heading: "Información Programa Proveedores",
            name: "Información Programa Proveedores",
            href: $state.href("fianzas.pprovinfo", {
              contratanteId: url.match(/programa\/fisicas\/(.*)$/)
                ? url.match(/programa\/fisicas\/(.*)$/)[1].replace("/", "")
                : url.match(/programa\/morales\/(.*)$/)
                ? url.match(/programa\/morales\/(.*)$/)[1].replace("/", "")
                : 0,
              type: url.match(/programa\/(.*)$/)
                ? url.match(/programa\/(.*)$/)[1].split("/")[0]
                : 0,
            }),
            id: url.match(/programa\/fisicas\/(.*)$/)
              ? url.match(/programa\/fisicas\/(.*)$/)[1].replace("/", "")
              : url.match(/programa\/morales\/(.*)$/)
              ? url.match(/programa\/morales\/(.*)$/)[1].replace("/", "")
              : 0,
            type: url.match(/programa\/(.*)$/)
              ? url.match(/programa\/(.*)$/)[1].split("/")[0]
              : 0,
            isVisible: true,
            route: "fianzas.pprovinfo",
          },
          "fianzas.pprovedit": {
            active: true,
            heading: "Edición Programa Proveedores",
            name: "Edición Programa Proveedores",
            href: $state.href("fianzas.pprovedit", {
              contratanteId: url.match(/programa\/fisicas\/(.*)$/)
                ? url.match(/programa\/fisicas\/(.*)$/)[1].replace("/", "") //nested ternary operator
                : url.match(/programa\/morales\/(.*)$/)
                ? url.match(/programa\/morales\/(.*)$/)[1].replace("/", "")
                : 0,
              type: url.match(/programa\/(.*)$/)
                ? url.match(/programa\/(.*)$/)[1].split("/")[0]
                : 0,
            }),
            id: url.match(/programa\/fisicas\/(.*)$/)
              ? url.match(/programa\/fisicas\/(.*)$/)[1].replace("/", "")
              : url.match(/programa\/morales\/(.*)$/)
              ? url.match(/programa\/morales\/(.*)$/)[1].replace("/", "")
              : 0,
            type: url.match(/programa\/(.*)$/)
              ? url.match(/programa\/(.*)$/)[1].split("/")[0]
              : 0,
            isVisible: true,
            route: "fianzas.pprovedit",
          },
          "endorsement.endorsement": {
            id: 0,
            name: "Endosos",
            heading: "Endosos",
            route: "endorsement.endorsement",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("endorsement.endorsement"),
          },
          "endorsement.lista": {
            id: 0,
            name: "Lista endosos",
            heading: "Lista endosos",
            route: "endorsement.lista",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("endorsement.lista"),
          },
          "endorsement.collectivity": {
            id: 0,
            name: "Endosos Póliza Grupo",
            heading: "Endosos Póliza Grupo",
            route: "endorsement.collectivity",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("endorsement.collectivity"),
          },
          "endorsement.info": {
            id: url.match(/endosos\/informacion\/(.*)$/)
              ? url.match(/endosos\/informacion\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información endosos",
            heading: "Información endosos",
            route: "endorsement.info",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("endorsement.info", {
              endosoId: url.match(/endosos\/informacion\/(.*)$/)
                ? url.match(/endosos\/informacion\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "endorsement.details": {
            id: url.match(/endosos\/info\/(.*)$/)
              ? url.match(/endosos\/info\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información endosos",
            heading: "Información endosos",
            route: "endorsement.details",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("endorsement.details", {
              endosoId: url.match(/endosos\/info\/(.*)$/)
                ? url.match(/endosos\/info\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "endorsement.edit": {
            id: url.match(/endosos\/edit\/(.*)$/)
              ? url.match(/endosos\/edit\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Editar endosos",
            heading: "Editar endosos",
            route: "endorsement.edit",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("endorsement.edit", {
              endosoId: url.match(/endosos\/edit\/(.*)$/)
                ? url.match(/endosos\/edit\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "endorsement.collective": {
            id: 0,
            name: "Endosos Grupo",
            heading: "Endosos Grupo",
            route: "endorsement.collective",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("endorsement.collective"),
          },
          "endorsement.update": {
            id: url.match(/endosos\/editar\/(.*)$/)
              ? url.match(/endosos\/editar\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Editar endosos",
            heading: "Editar endosos",
            route: "endorsement.update",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("endorsement.update", {
              endosoId: url.match(/endosos\/editar\/(.*)$/)
                ? url.match(/endosos\/editar\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "endorsement.fianza": {
            id: url.match(/endoso\/fianza\/(.*)$/)
              ? url.match(/endoso\/fianza\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Crear endoso Fianza",
            heading: "Crear endoso Fianza",
            route: "endorsement.fianza",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("endorsement.fianza", {
              fianzaId: url.match(/endoso\/fianza\/(.*)$/)
                ? url.match(/endoso\/fianza\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "renovaciones.renovaciones": {
            id: 0,
            name: "Renovaciones",
            heading: "Renovaciones",
            route: "renovaciones.renovaciones",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("renovaciones.renovaciones"),
          },
          "renovaciones.polizas": {
            id: url.match(/renovaciones\/renovacion-poliza\/(.*)$/)
              ? url
                  .match(/renovaciones\/renovacion-poliza\/(.*)$/)[1]
                  .replace("/", "")
              : 0,
            name: "Renovación pólizas",
            heading: "Renovación pólizas",
            route: "renovaciones.polizas",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("renovaciones.polizas", {
              polizaId: url.match(/renovaciones\/renovacion-poliza\/(.*)$/)
                ? url
                    .match(/renovaciones\/renovacion-poliza\/(.*)$/)[1]
                    .replace("/", "")
                : 0,
            }),
          },
          "cobranzas.cobranzas": {
            id: 0,
            name: "Lista cobranza",
            heading: "Lista cobranza",
            route: "cobranzas.cobranzas",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("cobranzas.cobranzas"),
          },
          "cobranzas.recibospendientes": {
            id: 0,
            name: "Lista Recibos Pendientes",
            heading: "Lista Recibos Pendientes",
            route: "cobranzas.recibospendientes",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("cobranzas.recibospendientes"),
          },
          "cobranzas.folios": {
            id: 0,
            name: "Folios",
            heading: "Folios",
            route: "cobranzas.folios",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("cobranzas.folios"),
          },
          "cobranzas.bonos": {
            id: 0,
            name: "Bonos",
            heading: "Bonos",
            route: "cobranzas.bonos",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("cobranzas.bonos"),
          },
          "cobranzas.cobranzamasivo": {
            id: 0,
            name: "Pago y Liquidación masivo",
            heading: "Pago y Liquidación masivo",
            route: "cobranzas.cobranzamasivo",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("cobranzas.cobranzamasivo"),
          },
          "cobranzas.repositorio": {
            id: 0,
            name: "Repositorio Pago",
            heading: "Repositorio Pago",
            route: "cobranzas.repositorio",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("cobranzas.repositorio"),
          },
          "aseguradoras.aseguradoras": {
            id: 0,
            name: "Aseguradoras",
            heading: "Aseguradoras",
            route: "aseguradoras.aseguradoras",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("aseguradoras.aseguradoras"),
          },
          "aseguradoras.edit": {
            id: url.match(/aseguradoras\/(.*)$/)
              ? url.match(/aseguradoras\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Edición Aseguradoras",
            heading: "Edición Aseguradoras",
            route: "aseguradoras.edit",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("aseguradoras.edit", {
              aseguradoraId: url.match(/aseguradoras\/(.*)$/)
                ? url.match(/aseguradoras\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "aseguradoras.info": {
            id: url.match(/aseguradoras\/info\/(.*)$/)
              ? url.match(/aseguradoras\/info\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información Aseguradoras",
            heading: "Información Aseguradoras",
            route: "aseguradoras.info",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("aseguradoras.info", {
              aseguradoraId: url.match(/aseguradoras\/info\/(.*)$/)
                ? url.match(/aseguradoras\/info\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "aseguradoras.ramos": {
            id: url.match(/aseguradoras\/(.*)$/)
              ? url.match(/aseguradoras\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información Aseguradoras Ramos",
            heading: "Información Aseguradoras Ramos",
            route: "aseguradoras.ramos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("aseguradoras.ramos", {
              aseguradoraId: url.match(/aseguradoras\/(.*)$/)
                ? url.match(/aseguradoras\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "aseguradoras.subramos": {
            id: url.match(/aseguradoras\/(.*)$\/ramos\/(.*)$/)
              ? url
                  .match(/aseguradoras\/(.*)$\/ramos\/(.*)$/)[1]
                  .replace("/", "")
              : 0,
            ramosId: url.match(/aseguradoras\/(.*)$\/ramos\/(.*)$/)
              ? url
                  .match(/aseguradoras\/(.*)$\/ramos\/(.*)$/)[2]
                  .replace("/", "")
              : 0,
            name: "Información Aseguradoras Ramos",
            heading: "Información Aseguradoras Ramos",
            route: "aseguradoras.subramos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("aseguradoras.subramos", {
              aseguradoraId: url.match(/aseguradoras\/(.*)$\/ramos\/(.*)$/)
                ? url
                    .match(/aseguradoras\/(.*)$\/ramos\/(.*)$/)[1]
                    .replace("/", "")
                : 0,
              ramosId: url.match(/aseguradoras\/(.*)$\/ramos\/(.*)$/)
                ? url
                    .match(/aseguradoras\/(.*)$\/ramos\/(.*)$/)[2]
                    .replace("/", "")
                : 0,
            }),
          },
          "carga.contractor": {
            id: 0,
            name: "Carga masiva Contratantes",
            heading: "Carga masiva Contratantes",
            route: "carga.contractor",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("carga.contractor"),
          },
          "carga.poliza": {
            id: 0,
            name: "Carga masiva Pólizas Individual",
            heading: "Carga masiva Pólizas Individual",
            route: "carga.poliza",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("carga.poliza"),
          },
          "carga.norenovacion": {
            id: 0,
            name: "Carga masiva Pólizas a No Renovar ID",
            heading: "Carga masiva Pólizas a No Renovar ID",
            route: "carga.norenovacion",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("carga.norenovacion"),
          },
          "carga.pgrupo": {
            id: 0,
            name: "Carga masiva Pólizas Grupo",
            heading: "Carga masiva Pólizas Grupo",
            route: "carga.pgrupo",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("carga.pgrupo"),
          },
          "carga.certificado": {
            id: 0,
            name: "Carga masiva Certificados",
            heading: "Carga masiva Certificados",
            route: "carga.certificado",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("carga.certificado"),
          },
          "carga.flotilla": {
            id: 0,
            name: "Carga masiva Flotillas",
            heading: "Carga masiva Flotillas",
            route: "carga.flotilla",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("carga.flotilla"),
          },
          "carga.recibos": {
            id: 0,
            name: "Carga masiva Recibos",
            heading: "Carga masiva Recibos",
            route: "carga.recibos",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("carga.recibos"),
          },
          "carga.catalogo": {
            id: 0,
            name: "Catálogos",
            heading: "Catálogos",
            route: "carga.catalogo",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("carga.catalogo"),
          },
          "carga.cancelacion": {
            id: 0,
            name: "Carga cancelación",
            heading: "Carga cancelación",
            route: "carga.cancelacion",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("carga.cancelacion"),
          },
          "carga.infocontributoria": {
            id: 0,
            name: "Carga Información Contributoria Pólizas Grupo",
            heading: "Carga Información Contributoria Pólizas Grupo",
            route: "carga.infocontributoria",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("carga.infocontributoria"),
          },
          "paquetes.paquetes": {
            id: 0,
            name: "Paquetes",
            heading: "Paquetes",
            route: "paquetes.paquetes",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("paquetes.paquetes"),
          },
          "paquetes.edit": {
            id: url.match(/paquetes\/(.*)$/)
              ? url.match(/paquetes\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información paquetes coberturas",
            heading: "Información paquetes coberturas",
            route: "paquetes.edit",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("paquetes.edit", {
              paqueteId: url.match(/paquetes\/(.*)$/)
                ? url.match(/paquetes\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "coberturas.coberturas": {
            id: 0,
            name: "Coberturas",
            heading: "Coberturas",
            route: "coberturas.coberturas",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("coberturas.coberturas"),
          },
          "cotizacion.cotizacion": {
            id: 0,
            name: "Cotización",
            heading: "Cotización",
            route: "cotizacion.cotizacion",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("cotizacion.cotizacion"),
          },
          "cotizacion.info": {
            id: url.match(/cotizacion\/(.*)$/)
              ? url.match(/cotizacion\/(.*)$/)[1]
              : 0,
            name: "Cotización",
            heading: "Cotización",
            route: "cotizacion.cotizacion",
            event: null,
            isVisible: true,
            active: true,
            params: stateParams,
            href: $state.href("cotizacion.info", {
              polizaId: url.match(/cotizacion\/(.*)$/)
                ? url.match(/cotizacion\/(.*)$/)[1]
                : 0,
            }),
          },
          "siniestros.plantillas": {
            id: 0,
            name: "Siniestros Plantillas",
            heading: "Siniestros Plantillas",
            route: "siniestros.plantillas",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.plantillas"),
          },
          "siniestros.lista": {
            id: 0,
            name: "Listado siniestros",
            heading: "Listado siniestros",
            route: "siniestros.lista",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.lista"),
          },
          "siniestros.accidentes": {
            id: 0,
            name: "Creación Siniestros",
            heading: "Creación Siniestros",
            route: "siniestros.accidentes",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.accidentes"),
          },
          "siniestros.create_accidentes": {
            id: 0,
            name: "Creación siniestros Accidentes",
            heading: "Creación siniestros Accidentes",
            route: "siniestros.create_accidentes",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.create_accidentes", stateParams),
          },
          "siniestros.damages": {
            id: 0,
            name: "Creación siniestros Daños",
            heading: "Creación siniestros Daños",
            route: "siniestros.damages",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.damages", stateParams),
          },
          "siniestros.vida": {
            id: 0,
            name: "Siniestros Vida",
            heading: "Siniestros Vida",
            route: "siniestros.vida",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.vida", stateParams),
          },
          "siniestros.create_vida": {
            id: 0,
            name: "Creación siniestros Vida",
            heading: "Creación siniestros Vida",
            route: "siniestros.create_vida",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.create_vida", stateParams),
          },
          "siniestros.info": {
            id: url.match(/siniestros\/gmm\/info\/(.*)$/)
              ? url.match(/siniestros\/gmm\/info\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información siniestros",
            heading: "Información siniestros",
            route: "siniestros.info",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.info", {
              siniestroId: url.match(/siniestros\/gmm\/info\/(.*)$/)
                ? url.match(/siniestros\/gmm\/info\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "siniestros.edit": {
            id: url.match(/siniestros\/gmm\/edit\/(.*)$/)
              ? url.match(/siniestros\/gmm\/edit\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Edición siniestros",
            heading: "Edición siniestros",
            route: "siniestros.edit",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.edit", {
              siniestroId: url.match(/siniestros\/gmm\/edit\/(.*)$/)
                ? url.match(/siniestros\/gmm\/edit\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "siniestros.accidentesInfo": {
            id: url.match(/siniestros\/accidentes\/info\/(.*)$/)
              ? url
                  .match(/siniestros\/accidentes\/info\/(.*)$/)[1]
                  .replace("/", "")
              : 0,
            name: "Información siniestros",
            heading: "Información siniestros",
            route: "siniestros.accidentesInfo",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.accidentesInfo", {
              siniestroId: url.match(/siniestros\/accidentes\/info\/(.*)$/)
                ? url
                    .match(/siniestros\/accidentes\/info\/(.*)$/)[1]
                    .replace("/", "")
                : 0,
            }),
          },
          "siniestros.vida_info": {
            id: url.match(/siniestros\/vida\/(.*)$/)
              ? url.match(/siniestros\/vida\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información siniestros",
            heading: "Información siniestros",
            route: "siniestros.vida_info",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.vida_info", {
              siniestroId: url.match(/siniestros\/vida\/(.*)$/)
                ? url.match(/siniestros\/vida\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "siniestros.autos": {
            id: 0,
            name: "Creación siniestros Autos",
            heading: "Creación siniestros Autos",
            route: "siniestros.autos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.autos", stateParams),
          },
          "siniestros.create_autos": {
            id: 0,
            name: "Creación siniestros Autos",
            heading: "Creación siniestros Autos",
            route: "siniestros.create_autos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.create_autos", stateParams),
          },
          "siniestros.danios": {
            id: 0,
            name: "Creación siniestros Daños",
            heading: "Creación siniestros Daños",
            route: "siniestros.danios",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.danios", stateParams),
          },
          "siniestros.create_danios": {
            id: 0,
            name: "Creación siniestros Daños",
            heading: "Creación siniestros Daños",
            route: "siniestros.create_danios",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.create_danios", stateParams),
          },
          "siniestros.auto_info": {
            id: url.match(/siniestros\/autos\/(.*)$/)
              ? url.match(/siniestros\/autos\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información siniestros",
            heading: "Información siniestros",
            route: "siniestros.auto_info",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.auto_info", {
              siniestroId: url.match(/siniestros\/autos\/(.*)$/)
                ? url.match(/siniestros\/autos\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "siniestros.danio_info": {
            id: url.match(/siniestros\/danios\/(.*)$/)
              ? url.match(/siniestros\/danios\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Información siniestros",
            heading: "Información siniestros",
            route: "siniestros.danio_info",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("siniestros.danio_info", {
              siniestroId: url.match(/siniestros\/danios\/(.*)$/)
                ? url.match(/siniestros\/danios\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "comisiones.comisiones": {
            id: 0,
            name: "Comisiones Conciliar",
            heading: "Comisiones Conciliar",
            route: "comisiones.comisiones",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("comisiones.comisiones", stateParams),
          },
          "comisiones.consulta": {
            id: 0,
            name: "Info Comisiones",
            heading: "Info Comisiones",
            route: "comisiones.consulta",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("comisiones.consulta", stateParams),
          },
          "comisiones.conciliarid": {
            id: 0,
            name: "Conciliar Masivo ID",
            heading: "Conciliar Masivo ID",
            route: "comisiones.conciliarid",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("comisiones.conciliarid", stateParams),
          },
          "agentes.agentes": {
            id: 0,
            name: "Referenciadores",
            heading: "Referenciadores",
            route: "agentes.agentes",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("agentes.agentes", stateParams),
          },
          "agentes.receipts": {
            id: 0,
            name: "Referenciadores Recibos",
            heading: "Referenciadores Recibos",
            route: "agentes.receipts",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("agentes.receipts", stateParams),
          },
          "reportes.cobranza": {
            id: 0,
            name: "Reporte Cobranza",
            heading: "Reporte Cobranza",
            route: "reportes.cobranza",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.cobranza"),
          },
          "reportes.auditoria": {
            id: 0,
            name: "Reporte Auditoria",
            heading: "Reporte Auditoria",
            route: "reportes.auditoria",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.auditoria"),
          },
          "reportes.cotizaciones": {
            id: 0,
            name: "Reporte Cotizaciones",
            heading: "Reporte Cotizaciones",
            route: "reportes.cotizaciones",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.cotizaciones"),
          },
          "reportes.renovaciones": {
            id: 0,
            name: "Reporte Renovaciones",
            heading: "Reporte Renovaciones",
            route: "reportes.renovaciones",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.renovaciones"),
          },
          "reportes.endosos": {
            id: 0,
            name: "Reporte Endosos",
            heading: "Reporte Endosos",
            route: "reportes.endosos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.endosos"),
          },
          "reportes.polizas": {
            id: 0,
            name: "Reporte Pólizas",
            heading: "Reporte Pólizas",
            route: "reportes.polizas",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.polizas"),
          },
          "reportes.polizas_contributorias": {
            id: 0,
            name: "Reporte Pólizas Contributorias",
            heading: "Reporte Pólizas Contributorias",
            route: "reportes.polizas_contributorias",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.polizas_contributorias"),
          },
          "reportes.siniestros": {
            id: 0,
            name: "Reporte Siniestros",
            heading: "Reporte Siniestros",
            route: "reportes.siniestros",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.siniestros"),
          },
          "reportes.fianzas": {
            id: 0,
            name: "Reporte Fianzas",
            heading: "Reporte Fianzas",
            route: "reportes.fianzas",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.fianzas"),
          },
          "reportes.fianzas_ben": {
            id: 0,
            name: "Beneficiarios",
            heading: "Beneficiarios",
            route: "reportes.fianzas_ben",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.fianzas_ben"),
          },
          "reportes.log": {
            id: 0,
            name: "Reporte Log",
            heading: "Reporte Log",
            route: "reportes.log",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.log"),
          },
          "reportes.task": {
            id: 0,
            name: "Reporte Tareas",
            heading: "Reporte Tareas",
            route: "reportes.task",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.task"),
          },
          "reportes.certificates": {
            id: 0,
            name: "Reporte certificados",
            heading: "Reporte certificados",
            route: "reportes.certificates",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.certificates"),
          },
          "reportes.cumple": {
            id: 0,
            name: "Reporte cumpleaños",
            heading: "Reporte cumpleaños",
            route: "reportes.cumple",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.cumple"),
          },
          "reportes.cobranzafianzas": {
            id: 0,
            name: "Reporte fianzas",
            heading: "Reporte fianzas",
            route: "reportes.cobranzafianzas",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.cobranzafianzas"),
          },
          "reportes.edoclientes": {
            id: 0,
            name: "Reporte edo. clientes",
            heading: "Reporte edo. clientes",
            route: "reportes.edoclientes",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.edoclientes"),
          },
          "reportes.cobranza_liq": {
            id: 0,
            name: "Reporte liquidaciones",
            heading: "Reporte liquidaciones",
            route: "reportes.cobranza_liq",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.cobranza_liq"),
          },
          "reportes.cobranza_subsec": {
            id: 0,
            name: "Reporte recibos subsecuentes",
            heading: "Reporte recibos subsecuentes",
            route: "reportes.cobranza_subsec",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.cobranza_subsec"),
          },
          "reportes.cobranzapendiente": {
            id: 0,
            name: "Reporte recibos pendientes",
            heading: "Reporte recibos pendientes",
            route: "reportes.cobranzapendiente",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.cobranzapendiente"),
          },
          "reportes.renovacionespendientes": {
            id: 0,
            name: "Reporte renovaciones pendientes",
            heading: "Reporte renovaciones pendientes",
            route: "reportes.renovacionespendientes",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.renovacionespendientes"),
          },
          "reportes.adjuntos": {
            id: 0,
            name: "Reporte Adjuntos",
            heading: "Reporte Adjuntos",
            route: "reportes.adjuntos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.adjuntos"),
          },
          "reportes.otsendosos": {
            id: 0,
            name: "Reporte OT endosos",
            heading: "Reporte OT endosos",
            route: "reportes.otsendosos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.otsendosos"),
          },
          "reportes.polizasTitularesConyuges": {
            id: 0,
            name: "Reporte Titulares",
            heading: "Reporte Titulares",
            route: "reportes.polizasTitularesConyuges",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.polizasTitularesConyuges"),
          },
          "reportes.conservacion": {
            id: 0,
            name: "Reporte Estadístico",
            heading: "Reporte Estadístico",
            route: "reportes.conservacion",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.conservacion"),
          },
          "reportes.ventacruzada": {
            id: 0,
            name: "Reporte Venta Cruzada",
            heading: "Reporte Venta Cruzada",
            route: "reportes.ventacruzada",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.ventacruzada"),
          },
          "reportes.asegurados": {
            id: 0,
            name: "Reporte Asegurados",
            heading: "Reporte Asegurados",
            route: "reportes.asegurados",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("reportes.asegurados"),
          },
          "bibliotecas.list": {
            id: 0,
            name: "Bibliotecas",
            heading: "Bibliotecas",
            route: "bibliotecas.list",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("bibliotecas.list"),
          },
          "bibliotecas.bibliotecas": {
            id: 0,
            name: "Bibliotecas",
            heading: "Bibliotecas",
            route: "bibliotecas.bibliotecas",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("bibliotecas.bibliotecas"),
          },
          "bibliotecas.edit": {
            id: 0,
            name: "Edición Bibliotecas",
            heading: "Edición Bibliotecas",
            route: "bibliotecas.edit",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("bibliotecas.edit"),
          },
          "bibliotecas.layouts": {
            id: 0,
            name: "Layouts Bibliotecas",
            heading: "Layouts Bibliotecas",
            route: "bibliotecas.layouts",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("bibliotecas.layouts"),
          },
          "bibliotecas.editables": {
            id: 0,
            name: "Editables Bibliotecas",
            heading: "Editables Bibliotecas",
            route: "bibliotecas.editables",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("bibliotecas.editables"),
          },
          "campaign.list": {
            id: 0,
            name: "Campañas",
            heading: "Campañas",
            route: "campaign.list",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("campaign.list"),
          },
          "campaign.create": {
            id: 0,
            name: "Creación Campañas",
            heading: "Creación Campañas",
            route: "campaign.create",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("campaign.create"),
          },
          "campaign.edit": {
            id: url.match(/campaigns\/(.*)$/)
              ? url.match(/campaigns\/(.*)$/)[1].replace("/", "")
              : 0,
            name: "Editar Campaña",
            heading: "Editar Campaña",
            route: "campaign.edit",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("campaign.edit", {
              campaignId: url.match(/campaigns\/(.*)$/)
                ? url.match(/campaigns\/(.*)$/)[1].replace("/", "")
                : 0,
            }),
          },
          "mensajeria.principal": {
            id: 0,
            name: "Mensajería",
            heading: "Mensajería",
            route: "mensajeria.principal",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("mensajeria.principal"),
          },
          "multicotizador.multicotizador": {
            id: 0,
            name: "Multicotizador Autos",
            heading: "Multicotizador Autos",
            route: "multicotizador.multicotizador",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("multicotizador.multicotizador"),
          },
          "multicotizador.emision": {
            id: 0,
            name: "Multicotizador Emisión Autos",
            heading: "Multicotizador Emisión Autos",
            route: "multicotizador.emision",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("multicotizador.emision"),
          },
          "multicotizador.administrador": {
            id: 0,
            name: "Multicotizador Administrador Autos",
            heading: "Multicotizador Administrador Autos",
            route: "multicotizador.administrador",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("multicotizador.administrador"),
          },
          "multicotizador.configurador": {
            id: 0,
            name: "Multicotizador configurador ",
            heading: "Multicotizador configurador ",
            route: "multicotizador.configurador",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("multicotizador.configurador"),
          },
          "task.task": {
            id: 0,
            name: "Tareas",
            heading: "Tareas",
            route: "task.task",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("task.task"),
          },
          "task.admin": {
            id: 0,
            name: "Tareas Administrador",
            heading: "Tareas Administrador",
            route: "task.admin",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("task.admin"),
          },
          "kbi.principal": {
            id: 0,
            name: "KBI",
            heading: "KBI",
            route: "kbi.principal",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("kbi.principal"),
          },
          "config.lectura_documentos": {
            id: 0,
            name: "Documentos",
            heading: "Documentos",
            route: "config.lectura_documentos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("config.lectura_documentos"),
          },
          "config.configuracion_filtros": {
            id: 0,
            name: "Filtros",
            heading: "Filtros",
            route: "config.configuracion_filtros",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("config.configuracion_filtros"),
          },
          "config.edit_lectura_documentos": {
            id: url.match(/config\/lectura-documentos\/(.*)$/)
              ? url
                  .match(/config\/lectura-documentos\/(.*)$/)[1]
                  .replace("/", "")
              : 0,
            name: "Editar Documentos",
            heading: "Editar Documentos",
            route: "config.edit_lectura_documentos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("config.edit_lectura_documentos", {
              configId: url.match(/config\/lectura-documentos\/(.*)$/)
                ? url
                    .match(/config\/lectura-documentos\/(.*)$/)[1]
                    .replace("/", "")
                : 0,
            }),
          },
          "cedula.cedula": {
            id: 0,
            name: "Cédula",
            heading: "Cédula",
            route: "cedula.cedula",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("cedula.cedula"),
          },
          "emails.smtp": {
            id: 0,
            name: "SMTP",
            heading: "SMTP",
            route: "emails.smtp",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("emails.smtp"),
          },
          "emails.config": {
            id: 0,
            name: "Configuración Email",
            heading: "Configuración Email",
            route: "emails.config",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("emails.config"),
          },
          "agenda.agenda": {
            id: 0,
            name: "Agenda",
            heading: "Agenda",
            route: "agenda.agenda",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("agenda.agenda"),
          },
          "ibis.usuarios": {
            id: 0,
            name: "Ibis usuarios",
            heading: "Ibis usuarios",
            route: "ibis.usuarios",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("ibis.usuarios"),
          },
          "ibis.formatos": {
            id: 0,
            name: "Formatos",
            heading: "Formatos",
            route: "ibis.formatos",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("ibis.formatos"),
          },
          "ibis.formatosPlantillasWhatsappSiniestros": {
            id: 0,
            name: "Plantillas WhatsApp Web Siniestros",
            heading: "Plantillas WhatsApp Web (Siniestros)",
            route: "ibis.formatosPlantillasWhatsappSiniestros",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("ibis.formatosPlantillasWhatsappSiniestros"),
          },
          "ibis.directorio": {
            id: 0,
            name: "Directorio",
            heading: "Directorio",
            route: "ibis.directorio",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("ibis.directorio"),
          },
          "ibis.red": {
            id: 0,
            name: "Red Ibis",
            heading: "Red Ibis",
            route: "ibis.red",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("ibis.red"),
          },
          "sucursal.config": {
            id: 0,
            name: "Sucursales",
            heading: "Sucursales",
            route: "sucursal.config",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("sucursal.config", stateParams),
          },
          "help.manual": {
            id: 0,
            name: "Ayuda",
            heading: "Ayuda",
            route: "help.manual",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("help.manual", stateParams),
          },
          "help.policy": {
            id: 0,
            name: "Ayuda",
            heading: "Ayuda",
            route: "help.policy",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("help.policy", stateParams),
          },
          "buscador.buscador": {
            id: url.match(/buscador\/(.*)$/)
              ? url.match(/buscador\/(.*)$/)[1]
              : 0,
            name: "Superbuscador",
            heading: "Superbuscador",
            route: "buscador.buscador",
            event: null,
            active: true,
            isVisible: true,
            href: $state.href("buscador.buscador"),
          },
          "buscador.modal": {
            id: url.match(/buscador\/modal\/(.*)$/)
              ? url.match(/buscador\/modal\/(.*)$/)[1]
              : 0,
            name: "Superbuscador Modal",
            heading: "Superbuscador Modal",
            route: "buscador.modal",
            event: null,
            active: true,
            isVisible: true,
            href: $state.href("buscador.modal"),
          },
          "tablero.init": {
            id: url.match(/tablero\/(.*)$/)
              ? url.match(/tablero\/(.*)$/)[1]
              : 0,
            name: "Tablero OTs",
            heading: "Tablero OTs",
            route: "tablero.init",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("tablero.init", {
              polizaId: url.match(/tablero\/(.*)$/)
                ? url.match(/tablero\/(.*)$/)[1]
                : 0,
            }),
          },
          "medicoscelulas.configuracion": {
            id: 0,
            name: "Médicos",
            heading: "Médicos",
            route: "medicoscelulas.configuracion",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("medicoscelulas.configuracion", {}),
          },
          "agentes.estadoscuenta": {
            id: 0,
            name: "Estados de Cuenta",
            heading: "Estados de Cuenta",
            route: "agentes.estadoscuenta",
            event: null,
            isVisible: true,
            active: true,
            href: $state.href("agentes.estadoscuenta", {}),
          },
        };
        var selected_state = abstract_estados[current_state];
        return selected_state;
      };
      // states.findIndex(function(state){
      //     if (state.active) {
      //         console.log('-index states--',state,states)
      //         $state.go(state.route)
      //     }
      // })
      // if (appstate[]) {}
      return {
        states: states,
        getActiveTab: getActiveTab,
        estados: estados,
        getActualTab: getActualTab,
      };
    },
  ]);
})();

(function () {
  angular.module("inspinia").controller("showFilesCtrl", showFilesCtrl);

  showFilesCtrl.$inject = [
    "$http",
    "$localStorage",
    "$scope",
    "fileService",
    "$sessionStorage",
    "SweetAlert",
    "toaster",
  ];

  function showFilesCtrl(
    $http,
    $localStorage,
    $scope,
    fileService,
    $sessionStorage,
    SweetAlert,
    toaster
  ) {
    var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
    var usr = JSON.parse(decryptedUser);

    var vmFiles = this;

    vmFiles.rename = rename;
    vmFiles.user = usr;
    vmFiles.deleteFile = deleteFile;

    activate();

    function activate() {}

    $scope.deleteRfile = function (file, container) {
      // console.log(file);
      fileService.deleteReceiptfile(file.url, file, container);
    };

    function deleteFile(file, container) {
      console.log("file", file);
      console.log("container", container);
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperarrr este archivo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            // deleteIT(url, file.id)
            $http.delete(file.url + "%").then(function (response) {
              container.splice(container.indexOf(file), 1);
              SweetAlert.swal(
                "¡Eliminado!",
                "El archivo fue eliminado.",
                "success"
              );
            });
          }
        }
      );
    }

    function rename(file, vmFiles) {
      console.log(file);
      fileService.renameFile(file).then(function (response) {
        if (response.status == 403) {
          $http.get(file.url).then(function (response) {
            console.log(response);
            file.nombre = response.data;
          });
        }
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("inspinia")
    .factory("generalService", generalService)
    .factory("SweetAlert", SweetAlert);

  generalService.$inject = ["$http", "globalVar", "groupService", "url"];

  function generalService($http, globalVar, groupService, url) {
    var service = {
      deleteService: deleteService,
      getFiles: getFiles,
      postService: postService,
      updateService: updateService,
      updateAddressService: updateAddressService,
      createPersonalInformation: createPersonalInformation,
      createBeneficiaries: createBeneficiaries,
      createRelationship: createRelationship,
      manyServices: manyServices,
      getPersonalInformation: getPersonalInformation,
      // Forms
      lifeForm: lifeForm,
      diseaseForm: diseaseForm,
      damageForm: damageForm,
      automobileForm: automobileForm,
      deleteFile: deleteFile,
      getByUrl: getByUrl,
      updateByUrl: updateByUrl,
    };

    return service;

    ////////////

    function lifeForm(obj) {
      return $http.post(globalVar.lifeForm, obj);
    }

    function diseaseForm(obj) {
      return $http.post(globalVar.diseaseForm, obj);
    }

    function damageForm(obj) {
      return $http.post(globalVar.damageForm, obj);
    }

    function automobileForm(obj) {
      return $http.post(globalVar.automobileForm, obj);
    }

    function createPersonalInformation(req) {
      return $http.post(globalVar.personal, req).then(function (res) {
        return res;
      });
    }

    function getPersonalInformation(req) {
      return $http.get(req).then(function (res) {
        return res;
      });
    }

    function createBeneficiaries(req) {
      return $http.post(globalVar.beneficiaries, req).then(function (res) {
        return res;
      });
    }

    function createRelationship(req) {
      return $http.post(globalVar.relationships, req).then(function (res) {
        return res;
      });
    }

    function deleteService(obj) {
      //var ok_to_delete = true;
      $http
        .get(url.IP + "ok-to-delete/" + obj.id + "/")
        .then(function success(response) {
          var ok_to_delete = false;

          if (response.data == false) {
            ok_to_delete = true;
          } else {
            ok_to_delete = false;
          }

          if (ok_to_delete == true) {
            return $http.delete(obj.url).then(deleteServiceComplete);
          }
        });

      function deleteServiceComplete(response) {
        console.log(response);
        return response;
      }
    }

    /*function deleteService(obj) {
            $http.get(url.IP + 'ok-to-delete/' + obj.id+ '/')
            .then(function success(response) {
                if(response.data){
                    var ok_to_delete = false
                } else {
                    var ok_to_delete = true
                }
            })
            if(ok_to_delete){
                console.log("dentro del if")
                return $http.delete(obj.url)
                    .then(deleteServiceComplete);
            }

            function deleteServiceComplete(response) {
                return response;
            }
    



        }*/

    /*function deleteService(obj) {
            var ok = false;
            
            $http.get(url.IP + 'ok-to-delete/' + obj.id + '/')
            .then(function success(response) {
                console.log(response.data)
                
                if(response.data == false){
                    console.log("se deberia de eliminar");
                    var ok_to_delete = true;
                } 
                else {
                    console.log("no se deberia de eliminar");
                    var ok_to_delete = false;
                }
                ok = ok_to_delete;
                console.log("ok",ok);

                if(ok == true)
                {
                console.log("se va a eliminar");
                return $http.delete(obj.url)
                    .then(deleteServiceComplete);
                }
            })

            function deleteServiceComplete(response) {
                return response;
            }
        }
    */

    function deleteFile(url, id) {
      var req = url + "archivos/:id/".replace(":id", id);
      return $http
        .delete(req)
        .then(deleteFileCompleted)
        .catch(deleteFileFailed);

      function deleteFileCompleted(response) {
        return response;
      }

      function deleteFileFailed(error) {
        return error;
      }
    }

    function getFiles(data) {
      // console.log(data);
      var url = data + "archivos/";

      return $http.get(url).then(getFilesComplete).catch(getFilesFailed);

      function getFilesComplete(response) {
        var result = response.data.results;
        result.forEach(function (file) {
          file.url = url + file.id;
        });

        return result;
      }

      function getFilesFailed(error) {
        return error;
      }
    }

    function postService(data) {
      return $http
        .post(data.url, data)
        .then(postServiceComplete)
        .catch(postServiceFailed);

      function postServiceComplete(response, status, headers, config) {
        //jshint ignore:line
        return response;
      }

      function postServiceFailed(response, status, headers, config) {
        //jshint ignore:line
        return status;
      }
    }

    function updateService(obj) {
      return $http
        .put(obj.url, obj)
        .then(updateServiceComplete)
        .catch(updateServiceFailed);

      function updateServiceComplete(response) {
        return response;
      }

      function updateServiceFailed(error) {
        return error;
      }
    }

    function updateAddressService(obj) {
      return $http
        .put(obj.url + obj.id + "/", obj)
        .then(updateAddressServiceComplete)
        .catch(updateAddressServiceFailed);

      function updateAddressServiceComplete(response) {
        return response;
      }

      function updateAddressServiceFailed(error) {
        return error;
      }
    }

    function manyServices() {
      return {
        groupService: groupService,
      };
    }

    function getByUrl(req) {
      return $http.get(req);
    }

    function updateByUrl(req) {
      return $http.put(req.url, req);
    }
  }

  SweetAlert.$inject = ["$rootScope"];

  function SweetAlert($rootScope) {
    var swal = window.swal;

    //public methods
    var self = {
      swal: function (arg1, arg2, arg3) {
        $rootScope.$evalAsync(function () {
          if (typeof arg2 === "function") {
            swal(
              arg1,
              function (isConfirm) {
                $rootScope.$evalAsync(function () {
                  arg2(isConfirm);
                });
              },
              arg3
            );
          } else {
            swal(arg1, arg2, arg3);
          }
        });
      },
      success: function (title, message) {
        $rootScope.$evalAsync(function () {
          swal(title, message, "success");
        });
      },
      error: function (title, message) {
        $rootScope.$evalAsync(function () {
          swal(title, message, "error");
        });
      },
      warning: function (title, message) {
        $rootScope.$evalAsync(function () {
          swal(title, message, "warning");
        });
      },
      info: function (title, message) {
        $rootScope.$evalAsync(function () {
          swal(title, message, "info");
        });
      },
      showInputError: function (message) {
        $rootScope.$evalAsync(function () {
          swal.showInputError(message);
        });
      },
      close: function () {
        $rootScope.$evalAsync(function () {
          swal.close();
        });
      },
    };

    return self;
  }
})();

(function () {
  var navigationService = function (
    $rootScope,
    $location,
    $state,
    $sce,
    $q,
    appStates
  ) {
    var states = appStates.states,
      currentState,
      previousState,
      validationFn,
      isDirtyFn,
      onNavigateFn,
      isDiscarded = false,
      isValid = function () {
        return validationFn();
      },
      isDirty = function () {
        return isDirtyFn();
      },
      resetState = function (state) {
        state.active = false;
      },
      resetAllStates = function () {
        for (var i = 0; i < states.length; i++) {
          resetState(states[i]);
        }
      },
      findState = function (routeName) {
        var criteriaFunction = function (c) {
          return c.route === routeName; // || routeName.indexOf(c.route) != -1;
        };
        return states.filter(criteriaFunction)[0];
      },
      findStatesByGroup = function (group) {
        var criteriaFunction = function (c) {
          return c.group === group;
        };
        return states.filter(criteriaFunction);
      };

    function resetCallbacks() {
      onNavigateFn = null;
      validationFn = function () {
        return true;
      };
      isDirtyFn = function () {
        return false;
      };
    }

    $rootScope.$on("$stateChangeStart", function (event, toState, toParams) {
      // Set initial state
      if (currentState) {
        currentState.href = decodeURIComponent(
          $state.href(currentState.route, $location.search())
        );
        currentState.stateParams = $location.search();
      } else {
        currentState = findState(toState.name, toParams);
        if (currentState) {
          currentState.href = decodeURIComponent(
            $state.href(currentState.route, $location.search())
          );
          currentState.stateParams = $location.search();
        }
      }

      var valdatinFnResponse = validationFn();
      if (
        (valdatinFnResponse !== true || valdatinFnResponse.error === true) &&
        toState.name !== "error"
      ) {
        var errorTitle = "Validation Error!";
        var errorBody = valdatinFnResponse.errorMessage
          ? valdatinFnResponse.errorMessage
          : "Please correct the form errors listed!";
        var modal = dialogService.openDialog("modalError.html", [
          "$scope",
          "$uibModalInstance",
          function ($scope, $uibModalInstance) {
            $scope.modalHeader = $sce.trustAsHtml(errorTitle);
            $scope.modalBody = $sce.trustAsHtml(
              dialogService.stringFormat(
                "<p><strong>{0}</strong></p>",
                errorBody
              )
            );
            $scope.ok = function () {
              $uibModalInstance.close();
            };
            $scope.hasCancel = false;
          },
        ]);
        event.preventDefault();
        return;
      }

      if (!onNavigateFn && !isDirty()) {
        resetCallbacks();
        currentState = findState(toState.name, toParams);
        return;
      }

      event.preventDefault();

      var discardCallback = isDirty()
        ? dialogService.openDiscardChangesDialog
        : function () {
            return true;
          };

      var navCallack = !onNavigateFn
        ? function () {
            return true;
          }
        : onNavigateFn;

      var discardPromise = $q.when(discardCallback());
      discardPromise.then(function () {
        var navigatePromise = $q.when(navCallack());
        navigatePromise.then(function () {
          resetCallbacks();
          $state.go(toState, toParams);
        });
      });
    });

    $rootScope.$on(
      "$stateChangeSuccess",
      function (event, toState, toParams, fromState, fromParams) {
        if (currentState && toState.name !== "error") {
          currentState.active = true;
          previousState = findState(fromState.name);
          if (previousState && previousState.name !== currentState.name) {
            previousState.active = false;
          }
        } else {
          resetAllStates();
          currentState = findState(toState.name);
          if (currentState) {
            currentState.active = true;
          }
        }

        // Handle breadcrumbs by group reference - or if they have no group reference.
        if (currentState) {
          var index = states.indexOf(currentState);
          var group = currentState.group;
          var groupStates = findStatesByGroup(group);
          var groupIndex = 0;
          var isFirst = false;
          if (groupStates && groupStates.length > 0) {
            isFirst = groupStates[0] == currentState;
            for (var i = 0; i < groupStates.length; i++) {
              if (groupStates[i] == currentState) {
                groupIndex = i;
                break;
              }
            }
          }

          // Set visibility keeping the first item in the group, if it's active non-visible
          for (var i = 0; i <= index; i++) {
            if (states[i].group === group && !isFirst) {
              states[i].isVisible = true;
            } else {
              states[i].isVisible = false;
            }
          }

          // If we have a grouping of states, deal with it to make the proper states invisible
          // This effectively makes it possible to keep the items after the current state invisible
          if (groupStates && groupStates.length > 0) {
            if (groupIndex < groupStates.length - 1) {
              for (var i = groupIndex + 1; i <= groupStates.length - 1; i++) {
                groupStates[i].isVisible = false;
              }
            }
          } else {
            if (index < states.length - 1) {
              for (var i = index + 1; i <= states.length - 1; i++) {
                states[i].isVisible = false;
              }
            }
          }
        }
      }
    );

    resetCallbacks();

    return {
      states: states,
      currentState: function () {
        return currentState;
      },
      previousState: function () {
        return previousState;
      },
      isDirty: isDirty,
      setOnNavigateCallback: function (onNavigateCb) {
        onNavigateFn = onNavigateCb;
      },
      setIsDirtyCallback: function (isDirtyCb) {
        isDirtyFn = isDirtyCb;
      },
      setValidationCallback: function (validationCb) {
        validationFn = validationCb;
      },
    };
  };

  ("use strict");

  var app = angular.module("inspinia");

  app.factory("navigationService", navigationService);
})();

(function () {
  "use strict";

  angular.module("inspinia").factory("models", models);

  models.$inject = [];

  function models() {
    var service = {
      beneficiary: beneficiary,
      asegurados: asegurados,
      orderForm: orderForm,
      relationships: relationships,
      auto: auto,
    };

    return service;

    function beneficiary(arr) {
      return {
        first_name: "",
        last_name: "",
        second_last_name: "",
        // birthdate: convertDate(new Date()),
        sex: "",
        optional_relationship: "",
        percentage: 0,
        person: 1,
        antiguedad: null,
      };
    }

    function asegurados(arr) {
      return {
        first_name: "",
        last_name: "",
        second_last_name: "",
        sex: "",
        smoker: "",
        antiguedad: null,
      };
    }

    function relationships() {
      return {
        first_name: "",
        last_name: "",
        second_last_name: "",
        birthdate: null,
        antiguedad: null,
        sex: null,
        relationship: null,
        accident: null,
      };
    }

    function orderForm() {
      return {
        contratante: "",
        poliza: "",
        folio: "",
        ramo: "",
        type: "",
        subramo: "",
        aseguradora: "",
        paquete: "",
        payment: "",
        startDate: new Date(),
        endingDate: new Date(new Date().setYear(new Date().getFullYear() + 1)),
      };
    }

    function auto() {
      return {
        brand: "",
        model: "",
        year: "",
        version: "",
        serial: "",
        engine: "",
        color: "",
        license_plates: "",
      };
    }
  }
})();

/**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {
  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular
      .element(".sidebard-panel")
      .css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element("nav.navbar-default").height();
    var wrapperHeigh = angular.element("#page-wrapper").height();

    if (navbarHeigh > wrapperHeigh) {
      angular.element("#page-wrapper").css("min-height", navbarHeigh + "px");
    }

    if (navbarHeigh < wrapperHeigh) {
      angular
        .element("#page-wrapper")
        .css("min-height", angular.element(window).height() + "px");
    }

    if (angular.element("body").hasClass("fixed-nav")) {
      if (navbarHeigh > wrapperHeigh) {
        angular
          .element("#page-wrapper")
          .css("min-height", navbarHeigh - 60 + "px");
      } else {
        angular
          .element("#page-wrapper")
          .css("min-height", angular.element(window).height() - 60 + "px");
      }
    }
  }

  angular.element(window).bind("load resize scroll", function () {
    if (!angular.element("body").hasClass("body-small")) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function () {
    if (
      angular.element(window).scrollTop() > 0 &&
      !angular.element("body").hasClass("fixed-nav")
    ) {
      angular.element("#right-sidebar").addClass("sidebar-top");
    } else {
      angular.element("#right-sidebar").removeClass("sidebar-top");
    }
  });

  $timeout(function () {
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function () {
    if (angular.element(document).width() < 769) {
      angular.element("body").addClass("body-small");
    } else {
      angular.element("body").removeClass("body-small");
    }
  });
});

(function () {
  "use strict";

  angular.module("inspinia").factory("helpers", helpers);

  helpers.$inject = [
    "coverageService",
    "statusReceipt",
    "url",
    "globalVar",
    "$http",
    "$q",
    "$log",
    "$filter",
    "$localStorage",
    "SweetAlert",
    "generalService",
    "$sessionStorage",
  ];

  function helpers(
    coverageService,
    statusReceipt,
    url,
    globalVar,
    $http,
    $q,
    $log,
    $filter,
    $localStorage,
    SweetAlert,
    generalService,
    $sessionStorage
  ) {
    var service = {
      checkType: checkType,
      getStates: getStates,
      getDiseases: getDiseases,
      hasAtLeastOneAddress: hasAtLeastOneAddress,
      hasAtLeastOneContact: hasAtLeastOneContact,
      hasAValidPolicyNumber: hasAValidPolicyNumber,
      isTheReceiptCanceled: isTheReceiptCanceled,
      isResponseOk: isResponseOk,
      isResponseAnError: isResponseAnError,
      subformChecker: subformChecker,
      diseaseType: diseaseType,
      damageType: damageType,
      createCoverages: createCoverages,
      formBySubBranch: formBySubBranch,
      isPolicy: isPolicy,
      isOT: isOT,
      getFormByPolicy: getFormByPolicy,
      getContractorsByGroup: getContractorsByGroup,
      copyExisting: copyExisting,
      calculateReceiptsValue: calculateReceiptsValue,
      getAutoYears: getAutoYears,
      policyModel: policyModel,
      beneficiariesPercentageGreaterThanZero:
        beneficiariesPercentageGreaterThanZero,
      existPolicy: existPolicy,
      existPolicyNumber: existPolicyNumber,
      existSerial: existSerial,
      existSerialRenovacion: existSerialRenovacion,
      existOT: existOT,
      monthDiff: monthDiff,
      existPolicyFolio: existPolicyFolio,
    };

    return service;

    function renameFile(file) {
      var patch = {
        nombre: file.nombre,
      };
      //$http.patch(file.arch)
    }

    ////////////
    /** Get an array and verify is has at least one element */
    function hasAtLeastOneContact(arr) {
      return arr.length ? true : false;
    }

    /** Check type of contractor */
    function checkType(type) {
      return type === 1 ? "fisicas" : "morales";
    }

    function getStates() {
      var dfd = $q.defer();
      if (!$localStorage.states) {
        $http.get(globalVar.states).then(function (responseStates) {
          if (responseStates.status == 200) {
            $localStorage.states = responseStates;
            dfd.resolve($localStorage.states);
          } else {
            dfd.reject();
          }
        });
      } else {
        dfd.resolve($localStorage.states);
      }

      return dfd.promise;
      return $http.get(globalVar.states);
    }

    function getDiseases() {
      var dfd = $q.defer();

      if (!$localStorage.diseases) {
        $http.get(globalVar.diseases).then(function (responseDiseases) {
          if (responseDiseases.status == 200) {
            $localStorage.diseases = responseDiseases;
            dfd.resolve($localStorage.diseases);
          } else {
            dfd.reject();
          }
        });
      } else {
        dfd.resolve($localStorage.diseases);
      }

      return dfd.promise;
      return $http.get(globalVar.diseases);
    }

    function hasAValidPolicyNumber(num) {
      return num !== 0 ? true : false;
    }

    function hasAtLeastOneAddress(arr) {
      return arr.length ? true : false;
    }

    function isTheReceiptCanceled(status) {
      return status === statusReceipt[1].value ? true : false;
    }

    function isResponseOk(req) {
      return req === 200 || req === 201 ? true : false;
    }

    function isResponseAnError(req) {
      return req === 400 ? true : false;
    }

    function diseaseType(req) {
      if (req === "2") {
        // Accidentes personales
        return 1;
      } else if (req === "3") {
        // Gastos medicos
        return 2;
      } else if (req === "4") {
        // Salud
        return 3;
      } else {
        return 0;
      }
    }

    function damageType(req) {
      if (req === 5) {
        // Responsabilidad Civil y Riesgos Profesionales
        return 1;
      } else if (req === 6) {
        // Marítimo y transportes
        return 2;
      } else if (req === 7) {
        // Incendio
        return 3;
      } else if (req === 8) {
        // Agrícola y de Animales
        return 4;
      } else if (req === 10) {
        // Crédito
        return 5;
      } else if (req === 11) {
        // Crédito a la vivienda
        return 6;
      } else if (req === 12) {
        // Garantía financiera
        return 7;
      } else if (req === 13) {
        // Diversos
        return 8;
      } else if (req === 14) {
        // Terremoto y otros riesgos catastróficos
        return 9;
      } else {
        return 0;
      }
    }

    function isPolicy(insurance) {
      var status = insurance.status;
      return (
        status === 4 ||
        status === 10 ||
        status == 11 ||
        status == 12 ||
        status == 13 ||
        status == 14 ||
        status == 15
      );
    }

    function isOT(insurance) {
      var status = insurance.status;
      return status === 1 || status == 2;
    }

    function subformChecker(subform) {
      if (subform.auto) {
        subform.auto.urlForm = globalVar.automobileForm;
        return subform.auto;
      } else if (subform.life) {
        subform.life.urlForm = globalVar.lifeForm;
        return subform.life;
      } else if (subform.disease) {
        subform.disease.urlForm = globalVar.diseaseForm;
        return subform.disease;
      } else if (subform.damage) {
        subform.damage.urlForm = globalVar.damageForm;
        return subform.damage;
      } else {
        return null;
      }
    }

    function createCoverages(coverages, policy) {
      var coverage = {};
      coverages.forEach(function (elem) {
        coverage = {
          policy: policy.url,
          package: policy.paquete,
          coverage_name: elem.coverage_name ? elem.coverage_name : "",
          deductible: elem.deductible ? elem.deductible : "",
          sum_insured: elem.sum_insured ? elem.sum_insured : "",
          prima: elem.prima ? elem.prima : "",
          coinsurance: elem.coinsuranceInPolicy
            ? elem.coinsuranceInPolicy.value
            : 0,
          topecoinsurance: elem.topeCoinsuranceInPolicy
            ? elem.topeCoinsuranceInPolicy.value
            : 0,
        };

        if (elem.coinsurance) {
          coverage = {
            policy: policy.url,
            package: policy.paquete,
            coverage_name: elem.coverage_name ? elem.coverage_name : "",
            deductible: elem.deductible ? elem.deductible : "",
            sum_insured: elem.sum_insured ? elem.sum_insured : "",
            prima: elem.prima ? elem.prima : "",
            coinsurance: elem.coinsurance ? elem.coinsurance : 0,
            topecoinsurance: elem.topecoinsurance ? elem.topecoinsurance : 0,
          };
        }
        if (elem.sumInPolicy || elem.deductibleInPolicy) {
          coverage = {
            policy: policy.url,
            package: policy.paquete,
            coverage_name: elem.coverage_name ? elem.coverage_name : "",
            deductible: elem.deductibleInPolicy
              ? elem.deductibleInPolicy.value
              : "",
            sum_insured: elem.sumInPolicy ? elem.sumInPolicy.value : "",
            prima: elem.prima ? elem.prima : "",
            coinsurance: elem.coinsuranceInPolicy
              ? elem.coinsuranceInPolicy.value
              : 0,
            topecoinsurance: elem.topeCoinsuranceInPolicy
              ? elem.topeCoinsuranceInPolicy.value
              : 0,
          };
        }
        /*coverage = {
                    'policy': policy.url,
                    'package': policy.paquete,
                    'coverage_name': elem.coverage_name ? elem.coverage_name : '',
                    'deductible': elem.deductibleInPolicy ? elem.deductibleInPolicy.label : '',
                    'sum_insured': elem.sumInPolicy ? elem.sumInPolicy.label : '',
                    'prima': elem.primaInPolicy ? elem.primaInPolicy : '',
                    'coinsurance': elem.coinsuranceInPolicy ? elem.coinsuranceInPolicy : ''
                };*/
        coverageService.createCoberturaPoliza(coverage);
      });
    }

    function formBySubBranch(param) {
      return $http.get(param.subramo).then(function (res) {
        var data = {};
        if (res.data.subramo_code === "9") {
          // Auto
          data = param.automobiles_policy;
        } else if (res.data.subramo_code === "1") {
          // Life
          data = param.life_policy;
        } else if (
          res.data.subramo_code === "2" ||
          res.subramo_code === "3" ||
          res.subramo_code === "4"
        ) {
          // disease
          data = param.accidents_policy;
        } else if (
          res.data.subramo_code === "5" ||
          res.subramo_code === "6" ||
          res.subramo_code === "7" ||
          res.subramo_code === "8" ||
          res.subramo_code === "10" ||
          res.subramo_code === "11" ||
          res.subramo_code === "12" ||
          res.subramo_code === "13" ||
          res.subramo_code === "14"
        ) {
          // damage
          data = param.damages_policy;
        }
        return data;
      });
    }

    function getFormByPolicy(res) {
      // Select form
      if (res.accidents_policy.length >= 1) {
        return [res.accidents_policy, 0];
      } else if (res.automobiles_policy.length >= 1) {
        return [res.automobiles_policy, 1];
      } else if (res.damages_policy.length >= 1) {
        return [res.damages_policy, 2];
      } else if (res.life_policy.length >= 1) {
        return [res.life_policy, 3];
      }
    }

    function monthDiff(d1, d2) {
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    }

    function getContractorsByGroup() {
      var defered = $q.defer();
      var promise = defered.promise;

      $http.get(url.IP + "grupos/").then(function (res) {
        var contractors = [];
        res.data.results.forEach(function (group, index) {
          group.natural_group.forEach(function (natural, index) {
            natural.groupName = group.group_name;
            natural.name = natural.first_name + " " + natural.last_name;
            contractors.push(natural);
          });
          group.juridical_group.forEach(function (juridical, index) {
            juridical.groupName = group.group_name;
            juridical.name = juridical.j_name;
            contractors.push(juridical);
          });
        });
        defered.resolve(contractors);
      });
      return promise;
    }

    function copyExisting(theTarget, theSource) {
      var result = {};

      for (var key in theTarget) {
        if (theSource[key]) {
          result[key] = theSource[key];
        } else {
          result[key] = theTarget[key];
        }
      }

      return result;
    }

    function calculateReceiptsValue(defaults, payform, policy) {
      // var defered = $q.defer();
      // var promise = defered.promise;

      var receipt = angular.copy(defaults.receipt);
      var config = angular.copy(defaults.config);
      var receipts = [];
      var receiptAmount = 12 / payform;
      var arrayLen = new Array(receiptAmount);
      var initDate = angular.copy(policy.start_of_validity);
      var endDate = angular.copy(policy.end_of_validity);

      var obj = {
        prima: receipt.primaNeta / receiptAmount,
        rpf: receipt.rpf / receiptAmount,
        derecho: receipt.derecho / receiptAmount,
        iva: receipt.iva,
        subTotal: 0,
        total: 0,
        // subTotal: receipt.subTotal / receiptAmount,
        // total: receipt.primaTotal / receiptAmount
      };

      for (var i = 0; i < arrayLen.length; i++) {
        // Check options
        if (config.derecho) {
          if (i === 0) {
            obj.derecho = parseFloat(receipt.derecho);
          } else {
            obj.derecho = 0;
          }
        }

        if (config.rpf) {
          if (i === 0) {
            obj.rpf = parseFloat(receipt.rpf);
          } else {
            obj.rpf = 0;
          }
        }

        endDate = new Date(moment(initDate).add(payform, "months").calendar());

        obj.subTotal = obj.prima + obj.rpf + obj.derecho;
        obj.total = obj.subTotal * 1.16;

        var receipt = {
          prima: parseFloat(obj.prima.toFixed(2)),
          rpf: parseFloat(obj.rpf.toFixed(2)),
          derecho: parseFloat(obj.derecho.toFixed(2)),
          iva: 16,
          subTotal: parseFloat(obj.subTotal.toFixed(2)),
          total: parseFloat(obj.total.toFixed(2)),
          startDate: $filter("date")(initDate, "yyyy-MM-dd"),
          endingDate: $filter("date")(endDate, "yyyy-MM-dd"),
        };
        initDate = endDate;
        receipts.push(angular.copy(receipt));
      }
      return receipts;
    }

    function getAutoYears() {
      var actualYear = new Date().getFullYear();
      var oldYear = actualYear - 50;
      var years = [];

      for (var i = oldYear; i <= actualYear + 100; i++) {
        years.push(i);
      }

      return years;
    }

    function policyModel(form, docType) {
      return {
        internal_number: form.internal_number ? form.internal_number : "",
        folio: form.folio ? form.folio : "",
        poliza_number: form.poliza_number ? form.poliza_number : "",
        natural: form.natural ? form.natural : null,
        juridical: form.juridical ? form.juridical : null,
        aseguradora: form.aseguradora ? form.aseguradora : null,
        ramo: form.ramo ? form.ramo : null,
        subramo: form.subramo ? form.subramo : null,
        paquete: form.paquete ? form.paquete : null,
        observations: form.observations ? form.observations : "",
        old_policies: [],
        start_of_validity: form.start_of_validity ? form.start_of_validity : "",
        end_of_validity: form.end_of_validity ? form.end_of_validity : "",
        forma_de_pago: null,
        status: form.status ? form.status : null,
        recibos_poliza: [],
        document_type: docType,
      };
    }

    function beneficiariesPercentageGreaterThanZero(beneficiariesList) {
      if (beneficiariesList.length === 0) {
        return false;
      } else if (beneficiariesList.length === 1) {
        if (beneficiariesList[0].percentage > 100) {
          return true;
        }
        return false;
      } else {
        var percentage = beneficiariesList.reduce(function (a, b) {
          return {
            percentage: parseFloat(a.percentage) + parseFloat(b.percentage),
          };
        });
        if (percentage.percentage > 100) {
          return true;
        }
        return false;
      }
    }

    function existPolicy(policy) {
      return $http
        .get(globalVar.existPolicy.replace(":id", policy))
        .then(function (res) {
          return res.data;
        });
    }
    function existPolicyNumber(policy) {
      var d = {
        id: policy,
      };
      return $http({
        method: "POST",
        url: globalVar.existPolicyNumber,
        data: d,
      }).then(function (res) {
        return res.data;
      });
    }

    function existSerial(policy) {
      return $http
        .get(globalVar.existSerial.replace(":id", policy))
        .then(function (res) {
          return res.data;
        });
    }
    function existSerialRenovacion(policy, idpoliza) {
      var url = globalVar.existSerialRenovacion
        .replace(":id", policy)
        .replace(":idpoliza", idpoliza);

      return $http.get(url).then(function (res) {
        return res.data;
      });
    }

    function existPolicyFolio(folio) {
      return $http
        .get(globalVar.existPolicyFolio.replace(":pk", folio))
        .then(function (res) {
          return res.data;
        });
    }

    function existOT(ot) {
      return $http
        .get(globalVar.existOT.replace(":id", ot))
        .then(function (res) {
          return res.data;
        });
    }
  }
})();

(function () {
  "use strict";

  var app = angular.module("inspinia");

  app.filter("fileName", function () {
    return function (input) {
      var urls = /[^/]+$/g;
      if (input.match(urls)) {
        input = input.substring(input.lastIndexOf("/") + 1, input.length);
      }
      return input;
    };
  });

  app.filter("receipts", function (statusReceipt) {
    return function (param) {
      if (param) {
        switch (param) {
          case 1:
            return statusReceipt[0].label;
          case 2:
            return statusReceipt[1].label;
          case 3:
            return statusReceipt[2].label;
          case 4:
            return statusReceipt[3].label;
          case 5:
            return statusReceipt[4].label;
          case 6:
            return statusReceipt[5].label;
          case 7:
            return statusReceipt[6].label;
          case 8:
            return statusReceipt[7].label;
          case 10:
            return statusReceipt[8].label;
          case 11:
            return statusReceipt[9].label;
        }
      }
    };
  });

  app.filter("endorsement", function (endorsement) {
    return function (param) {
      if (param) {
        switch (parseInt(param)) {
          case 1:
            return endorsement[0].label;
          case 2:
            return endorsement[1].label;
          case 3:
            return endorsement[2].label;
          case 4:
            return endorsement[3].label;
          case 5:
            return endorsement[4].label;
          default:
            return "Error en su estado.";
        }
      }
    };
  });

  app.filter("payformtype", function (payform) {
    return function (param) {
      if (param) {
        switch (param) {
          case 1:
            return payform[0].label;
          case 2:
            return payform[1].label;
          case 3:
            return payform[2].label;
          case 4:
            return payform[3].label;
          case 6:
            return payform[4].label;
          case 5:
            return "Contado";
          case 12:
            return payform[5].label;
        }
      }
    };
  });

  app.filter("order", function (ot) {
    return function (ot) {
      if (ot === "0") {
        return "Orden";
      }
    };
  });

  app.filter("policystatus", function (status) {
    return function (param) {
      switch (param) {
        case 1:
          return status[0].label;
        case 2:
          return status[1].label;
        case 10:
          return status[2].label;
        case 11:
          return status[3].label;
        case 12:
          return status[4].label;
        case 13:
          return status[5].label;
        case 14:
          return status[6].label;
      }
    };
  });

  app.filter("relationship", function (status) {
    return function (param) {
      switch (param) {
        case 1:
          return "Titular";
        case 2:
          return "Conyuge";
        case 3:
          return "Hijo";
        default:
          return "";
      }
    };
  });

  app.filter("curr_rate_options", function (curr_rate_options) {
    return function (param) {
      switch (param) {
        case 1:
          return curr_rate_options[0].label;
        case 2:
          return curr_rate_options[1].label;
        case 3:
          return curr_rate_options[2].label;
        case 4:
          return curr_rate_options[3].label;
        case 5:
          return curr_rate_options[4].label;
      }
    };
  });

  app.filter("capitalize", function () {
    return function (input, scope) {
      if (!input) {
        return input;
      }
      input = input.toLowerCase();
      return input.substring(0, 1).toUpperCase() + input.substring(1);
    };
  });

  app.filter("percentage", function () {
    return function (input) {
      return input + "%";
    };
  });
})();

(function () {
  angular.module("inspinia").factory("fileService", fileService);

  fileService.$inject = [
    "$http",
    "SweetAlert",
    "$localStorage",
    "$sessionStorage",
    "url",
  ];

  function fileService($http, SweetAlert, $localStorage, $sessionStorage, url) {
    var service = {
      deleteFile: deleteFile,
      getFiles: getFiles,
      renameFile: renameFile,
      deleteReceiptfile: deleteReceiptfile,
      getPermission: getPermission,
    };
    return service;

    function getPermission() {
      var decryptedUser = sjcl.decrypt("User", $sessionStorage.user);
      var usr = JSON.parse(decryptedUser);
      var user = usr.permiso;
      return user;
    }

    function deleteFile(file, container) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este archivo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            var data_email = {
              id: file.id,
              id_poliza: file.owner.id,
              model: 6,
              type_person: 0,
            };
            dataFactory
              .post("send-email-admins-deletes/", data_email)
              .then(function success(req) {
                console.log(".................:::::.....", req);
              });
            // deleteIT(url, file.id)
            $http.delete(file.url).then(
              function success(response) {
                SweetAlert.swal(
                  "¡Eliminado!",
                  "El archivo fue eliminado.",
                  "success"
                );
                container.splice(container.indexOf(file), 1);
              },
              function error(err) {
                console.log("err", err);
              }
            );
          }
        }
      );
    }

    function deleteIT(url, id) {
      var req = url + "archivos/:id/".replace(":id", id);
      return $http
        .delete(req)
        .then(deleteFileCompleted)
        .catch(deleteFileFailed);

      function deleteFileCompleted(response) {
        return response;
      }
      function deleteFileFailed(error) {
        return error;
      }
    }

    function deleteReceiptfile(url, file, container) {
      SweetAlert.swal(
        {
          title: "¿Está seguro?",
          text: "No será posible recuperar este archivo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si, estoy seguro.",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            sendDelete(url, file.id).then(function (response) {
              container.files.splice(container.files.indexOf(file), 1);
              // container.splice(container.indexOf(file), 1);
              SweetAlert.swal(
                "¡Eliminado!",
                "El archivo fue eliminado.",
                "success"
              );
            });
          }
        }
      );
    }

    function sendDelete(url, id) {
      // var req = url + 'archivos/:id/'.replace(':id', id)
      return $http
        .delete(url)
        .then(deleteFileCompleted)
        .catch(deleteFileFailed);

      function deleteFileCompleted(response) {
        return response;
      }

      function deleteFileFailed(error) {
        return error;
      }
    }

    function getFiles(url) {
      return $http.get(url).then(getFilesComplete).catch(getFilesFailed);

      function getFilesComplete(response) {
        var result = response.data.results;

        if (response.status === 200) {
          var result = response.data.results;
          result.forEach(function (file) {
            file.url = url + file.id + "/";
          });

          return result;
        } else if (response.status === 403) {
          return response.data;
        }
      }

      function getFilesFailed(error) {
        return error;
      }
    }

    function renameFile(file) {
      var patch = {
        nombre: file.nombre,
        sensible: file.sensible,
      };
      return $http.patch(file.url, patch);
    }
  }
})();

"use strict";

//Directive used to set metisMenu and minimalize button
var app = angular.module("inspinia");

app.directive("uploadTemplate", function () {
  return {
    restrict: "EA",
    templateUrl: "templates/upload.html",
    controller: function ($scope, $element) {},
  };
});

app.directive("naturalContractors", function () {
  return {
    restrict: "EA",
    templateUrl: "app/contratantes/contratantes.natural.html",
    controller: function ($scope, $element) {},
  };
});

app.directive("juridicalContractors", function () {
  return {
    restrict: "EA",
    templateUrl: "app/contratantes/contratantes.juridical.html",
    controller: function ($scope, $element) {},
  };
});
app.directive("sideNavigation", function ($timeout) {
  return {
    restrict: "A",
    link: function (scope, element) {
      // Call metsi to build when user signup
      scope.$watch("authentication.user", function () {
        $timeout(function () {
          element.metisMenu();
        });
      });
    },
  };
});

app.directive("intTelNumber", function () {
  return {
    // Restrict it to being an attribute
    restrict: "A",
    // responsible for registering DOM listeners as well as updating the DOM
    link: function (scope, element, attrs) {
      scope.$watch("loaded", function () {
        if (scope.loaded == true) {
          // apply plugin
          element.intlTelInput(scope.options);
          //validate loaded number
          var countryCode =
            element[0].nextSibling.children[0].children[0].className.split(
              " "
            )[1];
          scope.validateTelephoneNumber(element[0].value, countryCode);
        }
      });
    },
  };
});

app.directive("autoInput", function ($timeout) {
  return function (scope, iElement, iAttrs) {
    iElement.autocomplete({
      source: scope[iAttrs.uiItems],
      select: function () {
        $timeout(function () {
          iElement.trigger("input");
        }, 0);
      },
    });
  };
});

app.directive("minimalizaSidebar", function ($timeout) {
  return {
    restrict: "A",
    template:
      '<a class="btn btn-outline btn-menu btn-default" href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
    controller: function ($scope, $element) {
      $scope.minimalize = function () {
        angular.element("body").toggleClass("mini-navbar");
        if (
          !angular.element("body").hasClass("mini-navbar") ||
          angular.element("body").hasClass("body-small")
        ) {
          // Hide menu in order to smoothly turn on when maximize menu
          angular.element("#side-menu").hide();
          // For smoothly turn on menu
          $timeout(function () {
            angular.element("#side-menu").fadeIn(500);
          }, 100);
        } else {
          // Remove all inline style from jquery fadeIn function to reset menu state
          angular.element("#side-menu").removeAttr("style");
        }
      };
    },
  };
});
app.directive("iboxTools", function ($timeout) {
  return {
    restrict: "A",
    scope: true,
    templateUrl: "app/components/common/ibox_tools.html",
    controller: function ($scope, $element) {
      // Function for collapse ibox
      $scope.showhide = function () {
        var ibox = $element.closest("div.ibox");
        var icon = $element.find("i:first");
        var content = ibox.find("div.ibox-content");
        content.slideToggle(200);
        // Toggle icon from up to down
        icon.toggleClass("fa-chevron-up").toggleClass("fa-chevron-down");
        ibox.toggleClass("").toggleClass("border-bottom");
        $timeout(function () {
          ibox.resize();
          ibox.find("[id^=map-]").resize();
        }, 50);
      };
      // Function for close ibox
      $scope.closebox = function () {
        var ibox = $element.closest("div.ibox");
        ibox.remove();
      };
      $scope.click = function () {};
    },
  };
});
// STATUS = { (1,'En trámite.'), (2, 'OT Cancelada.'), (4, 'Precancelada'), (10,'Por iniciar'), (11, 'Cancelada'), (12,'Cerrada'), (13, 'Vencida'), (14,'Vigente') }
app.directive("status", function () {
  var linkFunction = function (scope, element, attributes) {
    // console.log(Number(attributes['status']));
    switch (Number(attributes["status"])) {
      case 1:
        scope.text = "En trámite";
        break;
      case 2:
        scope.text = "OT Cancelada";
        break;
      case 4:
        scope.text = "Precancelada";
        break;
      case 10:
        scope.text = "Por iniciar";
        break;
      case 11:
        scope.text = "Cancelada";
        break;
      case 12:
        scope.text = "Renovada";
        break;
      case 13:
        scope.text = "Vencida";
        break;
      case 14:
        scope.text = "Vigente";
        break;
      case 15:
        scope.text = "No renovada";
        break;
      default:
        scope.text = "Pendiente";
    }
    // scope.text = attributes["status"];
  };

  return {
    restrict: "A",
    template: "<p>{{text}}</p>",
    link: linkFunction,
  };
});

app.directive("siniestroStatus", function () {
  var linkFunction = function (scope, element, attributes) {
    switch (Number(attributes["siniestroStatus"])) {
      case 1:
        return "Pendiente";
      case 2:
        return "En Trámite";
      case 3:
        return "Procedente";
      case 4:
        return "Cancelada";
      case 5:
        return "Rechazada";
      default:
        return "Sin estatus";
    }
    // scope.text = attributes["status"];
  };

  return {
    restrict: "A",
    template: "<p>{{text}}</p>",
    link: linkFunction,
  };
});

app.directive("statusInput", function () {
  return {
    restrict: "AE",
    scope: {
      value: "=ngModel",
    },
    template:
      '<input class="form-control" value="{{value}}" type="text" disabled="disabled">',
    link: function (scope, elem, attr) {
      switch (scope.value) {
        case 1:
          scope.value = "En trámite";
          break;
        case 2:
          scope.value = "OT Cancelada";
          break;
        case 4:
          scope.value = "Precancelada";
          break;
        case 10:
          scope.value = "Por iniciar";
          break;
        case 11:
          scope.value = "Cancelada";
          break;
        case 12:
          scope.value = "Renovada";
          break;
        case 13:
          scope.value = "Vencida";
          break;
        case 14:
          scope.value = "Vigente";
          break;
        case 15:
          scope.value = "No renovada";
          break;
        default:
          scope.value = "Pendiente";
      }
    },
  };
});
// STATUS = { (1,'Pagado'), (2, 'Cancelado'), (3,'Prorrogado'), (4,'Pendiente de pago') }

app.directive("statusReceipt", function () {
  var linkFunction = function (scope, element, attributes) {
    switch (Number(attributes["statusReceipt"])) {
      case 1:
        scope.text = "Pagado";
        break;
      case 2:
        scope.text = "Cancelado";
        break;
      case 3:
        scope.text = "Prorrogado";
        break;
      case 4:
        scope.text = "Pendiente de pago";
        break;
      case 9:
        scope.text = "Pago Parcial";
        break;
      case 5:
        scope.text = "Liquidado";
        break;
      case 6:
        scope.text = "Conciliado";
        break;
      case 8:
        scope.text = "Precancelado";
        break;
      default:
        scope.text = "Pendiente de pago";
    }
    // scope.text = attributes["status"];
  };

  return {
    restrict: "A",
    template: "<p>{{text}}</p>",
    link: linkFunction,
  };
});

app.directive("statusPayform", function () {
  var linkFunction = function (scope, element, attributes) {
    switch (Number(attributes["statusPayform"])) {
      case 1:
        scope.text = "Cheque";
        break;
      case 2:
        scope.text = "Efectivo";
        break;
      case 3:
        scope.text = "Transferencia";
        break;
      case 4:
        scope.text = "Depósito bancario";
        break;
      case 5:
        scope.text = "Tarjeta de crédito";
        break;
      default:
        scope.text = "Sin forma de pago";
    }
    // scope.text = attributes["status"];
  };

  return {
    restrict: "A",
    template: "<p>{{text}}</p>",
    link: linkFunction,
  };
});

// app.directive('statusReceiptClean', function(){
//     var linkFunction = function(scope, element, attributes) {
//       switch (Number(attributes['statusReceiptClean'])) {
//         case 1:
//           scope.text = 'Pagado';
//           break;
//         case 2:
//           scope.text = 'Cancelado';
//           break;
//         case 3:
//           scope.text = 'Prorrogado';
//           break;
//         case 4:
//           scope.text = 'Pendiente de pago';
//           break;
//         case 9:
//           scope.text = 'Pago Parcial';
//           break;
//         case 5:
//           scope.text = 'Liquidado';
//           break;
//         case 8:
//           scope.text = 'Precancelado';
//           break;
//         default:
//           scope.text = 'Pendiente de pago';
//       }
//       // scope.text = attributes["status"];
//     };

//     return {
//       restrict: 'A',
//       template: '{{text}}',
//       link: linkFunction
//     };
// });
app.directive("statusReceiptClean", function () {
  return {
    restrict: "A",
    scope: {
      statusReceiptClean: "=",
    },
    template: "{{ text }}",
    link: function (scope) {
      function updateText(status) {
        switch (Number(status)) {
          case 1:
            scope.text = "Pagado";
            break;
          case 2:
            scope.text = "Cancelado";
            break;
          case 3:
            scope.text = "Prorrogado";
            break;
          case 4:
            scope.text = "Pendiente de pago";
            break;
          case 5:
            scope.text = "Liquidado";
            break;
          case 8:
            scope.text = "Precancelado";
            break;
          case 9:
            scope.text = "Pago Parcial";
            break;
          default:
            scope.text = "Pendiente de pago";
        }
      }

      // 🔥 escucha cambios reales
      scope.$watch("statusReceiptClean", function (newVal) {
        updateText(newVal);
      });
    },
  };
});

app.directive("endorsementStatus", function (endorsement) {
  var linkFunction = function (scope, element, attributes) {
    switch (Number(attributes["endorsementStatus"])) {
      case 1:
        scope.text = endorsement[0].label;
        break;
      case 2:
        scope.text = endorsement[1].label;
        break;
      case 3:
        scope.text = endorsement[2].label;
        break;
      case 4:
        scope.text = endorsement[3].label;
        break;
      case 5:
        scope.text = endorsement[4].label;
    }
  };

  return {
    restrict: "A",
    template: "{{text}}",
    link: linkFunction,
  };
});

// FORMA_DE_PAGO = {(1, 'Mensual'), (2, 'Bimestral'), (3, 'Trimestral'),
//                 (6, 'Semestral'), (12, 'Anual'), (24, 'Quincenal')}
app.directive("payment", function () {
  var linkFunction = function (scope, element, attributes) {
    //alert(Number(attributes['payment']));
    switch (Number(attributes["payment"])) {
      case 1:
        scope.payment = "Mensual";
        break;
      case 2:
        scope.payment = "Bimestral";
        break;
      case 3:
        scope.payment = "Trimestral";
        break;
      case 4:
        scope.payment = "Cuatrimestral";
        break;
      case 5:
        scope.payment = "Contado";
        break;
      case 6:
        scope.payment = "Semestral";
        break;
      case 12:
        scope.payment = "Anual";
        break;
      case 24:
        scope.payment = "Quincenal";
        break;

      default:
        scope.payment = "No especificada";
    }
  };

  return {
    restrict: "A",
    template: "<p>{{payment}}</p>",
    link: linkFunction,
  };
});
app.directive("paymentInput", function () {
  return {
    restrict: "AE",
    scope: {
      value: "=ngModel",
    },
    template:
      '<input class="form-control" value="{{value}}" type="text" disabled="disabled">',
    link: function (scope, elem, attr) {
      switch (scope.value) {
        case 1:
          scope.value = "Mensual";
          break;
        case 2:
          scope.value = "Bimestral";
          break;
        case 3:
          scope.value = "Trimestral";
          break;
        case 5:
          scope.value = "Contado";
          break;
        case 6:
          scope.value = "Semestral";
          break;
        case 12:
          scope.value = "Anual";
          break;
        case 24:
          scope.value = "Quincenal";
          break;
        default:
          scope.value = "No especificada";
      }
    },
  };
});

// states -> constant
// app.directive('statesList', stateList);
// function stateList(){
//     var directive = {
//         restrict: 'EA',
//         template: '<select class="form-control m-b" ng-model="state" ng-options="s.state for s in vm.statesArr track by s.id" required></select>',
//         scope: {
//           state: '=',
//         },
//         controller: StatesCtrl,
//         controllerAs: 'vm',
//         bindToController: true,
//         link: link
//     };
//
//     return directive;
//
//     function link(scope, iElement, iAttrs, ctrl){}
// }
//
// StatesCtrl.$inject = ['states', '$timeout'];
// function StatesCtrl(states, $timeout){
//     var vm = this;
//
//     vm.statesArr = states;
//     // $timeout(function() {
//     //     vm.statesArr.forEach(function(elem, index){
//     //         if (elem.state === vm.ngModel){
//     //             vm.ngModel = vm.statesArr[index].state;
//     //         }
//     //     });
//     // }, 1000);
// }
//
// // HACK remove use of watch
// app.directive('citiesList', citiesList);
// function citiesList(){
//     var directive = {
//         resctrict: 'EA',
//         required: 'state',
//         scope: {
//             // states: '=',
//             ngModel: '='
//         },
//         controller: CitiesCtrl,
//         controllerAs: 'vm',
//         bindToController: true,
//         template: '<select class="form-control m-b" ng-model="ngModel" ng-options="c.name for c in vm.cities track by c.id"></select>',
//         // template: '<select class="form-control m-b" ng-model="ngModel" ng-options="c.name for c in vm.cities track by c.id" required></select>',
//         link: link
//     };
//
//     return directive;
//
//     function link(scope, element, attrs) {
//       // scope.$watch('states', function(newVal, oldVal){
//       //     scope.citiesArr = cities[newVal.id - 1].city;
//       //     scope.citiesArr.forEach(function(elem, index){
//       //         if (elem.name === scope.ngModel){
//       //             scope.ngModel = scope.citiesArr[index];
//       //         }
//       //     });
//       // });
//     }
// }
//
// CitiesCtrl.$inject = ['$scope', 'cities'];
// function CitiesCtrl($scope, cities){
//     var vm = this;
//     ////console.log(vm);
//     // var vm = this;
//     // vm.cities = cities;
//     ////console.log(vm);
//     // $scope.$watch(angular.bind(this, function(){
//     //   return this.states;
//     // }), function(newVal, oldVal){
//     //    ////console.log('new', newVal, 'old', oldVal);
//     // var vm = this;
//     // vm.cities = cities;
//     // $scope.$watch(angular.bind(this, function(){
//     //   return this.states;
//     // }), function(newVal, oldVal){
//     // });
// }

app.directive("addressPanel", addressPanel);
function addressPanel() {
  var directive = {
    restrict: "EA",
    templateUrl: "app/components/common/address-panel.html",
    scope: {
      addresses: "=ngModel",
    },
    link: link,
    controller: AddressCtrl,
    controllerAs: "vm",
    bindToController: true,
  };

  return directive;

  function link(scope, element, attrs, ctrl) {}
}

AddressCtrl.$inject = [];
function AddressCtrl() {
  var vm = this;

  vm.addAddress = addAddress;
  vm.deleteAddress = deleteAddress;
  function addAddress() {
    var address = { address: "New address" };
    vm.addresses.push(address);
  }

  function deleteAddress(index) {
    vm.addresses.splice(index, 1);
  }
}

app.directive("optionsDisabled", function ($parse) {
  var disableOptions = function (scope, attr, element, data, fnDisableIfTrue) {
    // refresh the disabled options in the select element.
    var options = element.find("option");
    for (var pos = 0, index = 0; pos < options.length; pos++) {
      var elem = angular.element(options[pos]);
      if (elem.val() != "") {
        var locals = {};
        locals[attr] = data[index];
        elem.attr("disabled", fnDisableIfTrue(scope, locals));
        index++;
      }
    }
  };
  return {
    priority: 0,
    require: "ngModel",
    link: function (scope, iElement, iAttrs, ctrl) {
      // parse expression and build array of disabled options
      var expElements = iAttrs.optionsDisabled.match(
        /^\s*(.+)\s+for\s+(.+)\s+in\s+(.+)?\s*/
      );
      var attrToWatch = expElements[3];
      var fnDisableIfTrue = $parse(expElements[1]);
      scope.$watch(
        attrToWatch,
        function (newValue, oldValue) {
          if (newValue)
            disableOptions(
              scope,
              expElements[2],
              iElement,
              newValue,
              fnDisableIfTrue
            );
        },
        true
      );
      // handle model updates properly
      scope.$watch(iAttrs.ngModel, function (newValue, oldValue) {
        var disOptions = $parse(attrToWatch)(scope);
        if (newValue)
          disableOptions(
            scope,
            expElements[2],
            iElement,
            disOptions,
            fnDisableIfTrue
          );
      });
    },
  };
});
app.directive("dateValidator", function () {
  return {
    restrict: "A", // Used as an attribute
    require: "ngModel", // Works with ng-model
    link: function (scope, element, attrs, ngModel) {
      // Initialize Bootstrap Datepicker
      element
        .datepicker({
          autoclose: true,
          format: "dd/mm/yyyy",
        })
        .on("changeDate", function (e) {
          scope.$apply(function () {
            var formattedDate = validateAndFixDate(e.format()); // Validate & Fix
            ngModel.$setViewValue(formattedDate);
            ngModel.$render();
          });
        });

      // Validate on Blur (when user finishes typing)
      element.on("blur", function () {
        scope.$apply(function () {
          var formattedDate = validateAndFixDate(element.val()); // Validate & Fix
          ngModel.$setViewValue(formattedDate);
          ngModel.$render();
        });
      });

      // Function to validate and fix the date format
      function validateAndFixDate(date) {
        if (!date) return "";

        // Match DD/MM/YYYY or DD-MM-YYYY or DD.MM.YYYY formats
        var datePattern =
          /^(0[1-9]|[12][0-9]|3[01])[/.-](0[1-9]|1[0-2])[/.-](\d{4,5})$/;
        var match = date.match(datePattern);

        if (!match) return ""; // Invalid format → Reset field

        var day = match[1];
        var month = match[2];
        var year = match[3];

        // **Fix: If the year has 5 digits, trim it**
        if (year.length === 5) {
          year = year.substring(0, 4);
        }

        year = parseInt(year, 10);
        var currentYear = new Date().getFullYear();

        // Ensure year is between 1900 and current year
        if (year < 1900 || year > currentYear) return "";

        return day + "/" + month + "/" + year; // Return valid, fixed format
      }
    },
  };
});

app.directive("autoComplete", [
  "$q",
  "$http",
  "$sce",
  "$timeout",
  function ($q, $http, $sce, $timeout) {
    // standard keys code
    var KEY_DW = 40;
    var KEY_UP = 38;
    var KEY_ES = 27;
    var KEY_EN = 13;
    var KEY_TAB = 9;

    return {
      restrict: "EA",
      require: "^?form",
      scope: {
        selectedResult: "=",
        initialValue: "=",
        resultsFormatter: "=",
        source: "=",
        placeholder: "@",
        minlength: "@",
        selectHandler: "=",
        overrideSearch: "=",
        optLblNoResults: "@",
      },
      template:
        '<div class="autocomplete-content">' +
        '  <input ng-model="inputString" type="text" placeholder="{{placeholder}}" ng-change="inputChangeHandler($event)" class="autocomplete-text toolbarProp" ng-blur="hideResults($event)" autocapitalize="off" autocorrect="off" autocomplete="off" />' +
        '  <div class="autocomplete-dropdown" ng-show="showDropdown">' +
        '    <div class="autocomplete-search-text" ng-show="searching" ng-bind="labelSearching"></div>' +
        '    <div class="autocomplete-search-text" ng-show="noResults"  ng-bind="labelNoResults"></div>' +
        '    <ul class="autocomplete-list"><li class="autocomplete-row" ng-repeat="result in results" ng-click="selectResult(result, $event)" ng-mouseenter="hoverRow($index)" ng-mouseleave="hoverOut($index)" ng-class="{\'autocomplete-highlight-row\': $index == currentIndex}">' +
        '      <span class="autocomplete-title" ng-bind-html="result.label"></span>' +
        "    </li></ul>" +
        "</div>" +
        "</div>",
      link: function (scope, elem, attrs, ctrl) {
        var inputField = elem.find("input");
        var httpCancel = null;
        var suggestionsList = elem[0].querySelector(".autocomplete-dropdown");
        scope.currentIndex = -1;
        scope.searching = false;
        scope.noResults = false;
        scope.resultSelect = false;
        scope.labelSearching = "Searching...";
        if (scope.optLblNoResults === undefined)
          scope.labelNoResults = "No results found";
        else scope.labelNoResults = scope.optLblNoResults;
        scope.searchInput = "";
        if (scope.minlength && scope.minlength !== "") {
          scope.minlength = parseInt(scope.minlength, 10);
        } else {
          scope.minlength = 1;
        }
        if (scope.initialValue) {
          scope.inputString = scope.initialValue;
          scope.searchInput = scope.inputString;
          scope.$watch("initialValue", function (newval, oldval) {
            if (newval && newval.length > 0) {
              scope.inputString = scope.initialValue;
            }
          });
        }

        //scroll to the top of list when end of list is reached
        function scrollToTop() {
          if (isScrollNeeded()) {
            var row = elem[0].querySelectorAll(".autocomplete-row")[0];
            suggestionsList.scrollTop = -1 * row.offsetHeight;
          }
        }

        function scrollToBottom() {
          if (isScrollNeeded()) {
            var row =
              elem[0].querySelectorAll(".autocomplete-row")[
                scope.results.length - 1
              ];
            suggestionsList.scrollTop = row.getBoundingClientRect().top;
          }
        }

        function isScrollNeeded() {
          var ddCSS = getComputedStyle(suggestionsList);
          return (
            suggestionsList.scrollHeight > suggestionsList.clientHeight &&
            (ddCSS.overflowY === "auto" ||
              ddCSS.overflowY === "visible" ||
              ddCSS.overflowY === "scroll")
          );
        }

        function adjustddHeight() {
          if (isScrollNeeded()) {
            var ddCSS = getComputedStyle(suggestionsList);
            var borderTop, paddingTop, offset, scroll, ddHeight, rowHeight;
            var row =
              elem[0].querySelectorAll(".autocomplete-row")[scope.currentIndex];
            borderTop = parseInt(ddCSS.borderTopWidth, 10) || 0;
            paddingTop = parseInt(ddCSS.paddingTop, 10) || 0;
            offset =
              row.getBoundingClientRect().top -
              suggestionsList.getBoundingClientRect().top -
              borderTop -
              paddingTop;
            scroll = suggestionsList.scrollTop;
            ddHeight = suggestionsList.offsetHeight;
            rowHeight = row.offsetHeight;
            if (offset < 0) {
              suggestionsList.scrollTop = scroll + offset;
            } else if (offset + rowHeight > ddHeight) {
              suggestionsList.scrollTop =
                scroll + offset - ddHeight + rowHeight;
            }
          }
        }

        function keydownHandler(event) {
          var keyCode = event.which ? event.which : event.keyCode;
          scope.inputString = inputField.val();
          if (keyCode === KEY_EN && scope.results) {
            if (
              scope.currentIndex >= 0 &&
              scope.currentIndex < scope.results.length
            ) {
              event.preventDefault();
              scope.selectResult(scope.results[scope.currentIndex]);
            } else {
              clearResults();
            }
            scope.$apply();
          } else if (keyCode === KEY_DW && scope.results) {
            event.preventDefault();
            if (
              scope.currentIndex + 1 < scope.results.length &&
              scope.showDropdown
            ) {
              scope.currentIndex++;
              scope.inputString = scope.results[scope.currentIndex].title;
              adjustddHeight();
            } else if (scope.currentIndex + 1 === scope.results.length) {
              scope.currentIndex = -1;
              scope.inputString = scope.searchInput;
              scrollToTop();
            }
            scope.$apply();
          } else if (keyCode === KEY_UP && scope.results) {
            event.preventDefault();
            if (scope.currentIndex >= 1) {
              scope.currentIndex--;
              scope.inputString = scope.results[scope.currentIndex].title;
              adjustddHeight();
            } else if (scope.currentIndex === 0) {
              scope.currentIndex = -1;
              scope.inputString = scope.searchInput;
            } else if (scope.currentIndex === -1) {
              scope.currentIndex = scope.results.length - 1;
              scope.inputString = scope.results[scope.currentIndex].title;
              scrollToBottom();
            }
            scope.$apply();
          } else if (keyCode === KEY_TAB) {
            if (
              scope.results &&
              scope.results.length > 0 &&
              scope.showDropdown
            ) {
              if (
                scope.currentIndex > -1 &&
                scope.currentIndex < scope.results.length
              ) {
                scope.selectResult(scope.results[scope.currentIndex]);
              } else {
                clearResults();
              }
            }
            //call digest to move focus to the next focusable element(default TAB behaviour)
            scope.$digest();
          } else if (keyCode === KEY_ES) {
            event.preventDefault();
            clearResults();
            scope.inputString = scope.searchInput;
            scope.$apply();
          }
        }

        function clearResults() {
          scope.showDropdown = false;
          scope.results = [];
          if (suggestionsList) {
            suggestionsList.scrollTop = 0;
          }
        }

        function initResults() {
          scope.showDropdown = true;
          scope.currentIndex = -1;
          scope.results = [];
        }

        function getLocalResults(str) {
          var i;
          var matches = [];

          for (i = 0; i < scope.source.length; i++) {
            var match = false;
            if (
              scope.overrideSearch &&
              typeof scope.overrideSearch == "function"
            ) {
              match = scope.overrideSearch(str, scope.source[i]);
            } else {
              var matcher = new RegExp(
                str.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&"),
                "i"
              );
              match = matcher.test(scope.source[i].label || scope.source[i]);
            }

            if (match) {
              matches[matches.length] = scope.source[i];
            }
          }
          scope.searching = false;
          processResults(matches, str);
        }

        function getSearchResults(str) {
          scope.resultSelect = false;
          // Begin the search
          if (!str || str.length < scope.minlength) {
            return;
          }
          if (scope.source) {
            scope.searching = true;
            scope.noResults = false;
            if (typeof scope.source == "function") {
              var config = scope.source(str);
              if (httpCancel) {
                httpCancel.resolve();
              }
              httpCancel = $q.defer();
              config.timeout = httpCancel.promise;
              $http(config).then(
                function (response) {
                  var results = [];
                  if (
                    scope.resultsFormatter &&
                    typeof scope.resultsFormatter == "function"
                  ) {
                    results = scope.resultsFormatter(str, response);
                  } else {
                    results = response.data;
                  }
                  scope.searching = false;
                  processResults(results, str);
                },
                function (response) {
                  if (console && console.error) {
                    console.error(
                      "call to get remote data failed with error" +
                        response.status
                    );
                  }
                }
              );
            } else {
              getLocalResults(str);
            }
          }
        }

        function processResults(responseData, str) {
          var i, text, highlightText, value;

          if (responseData && responseData.length > 0) {
            scope.results = [];

            for (i = 0; i < responseData.length; i++) {
              text = highlightText = responseData[i].label || responseData[i];
              //highlight the text that match the input text
              highlightText = highlightMatches(text, str);
              if (responseData[i].value != null) {
                value = responseData[i].value;
              } else {
                value = text;
              }
              scope.results[scope.results.length] = {
                title: text,
                label: highlightText,
                value: value,
              };
            }
          } else {
            scope.noResults = true;
            scope.results = [];
          }
        }

        function highlightMatches(dataStr, str) {
          var result;
          var matcher = new RegExp(
            str.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&"),
            "i"
          );
          var match = dataStr.match(matcher);
          if (match) {
            result = dataStr.replace(
              matcher,
              '<span class="matched-text">' + match[0] + "</span>"
            );
          } else {
            result = dataStr;
          }
          return $sce.trustAsHtml(result);
        }

        //call search if input is changed
        scope.inputChangeHandler = function () {
          scope.searchInput = scope.inputString;
          if (!scope.inputString || scope.inputString === "") {
            scope.showDropdown = false;
          } else if (scope.inputString.length >= scope.minlength) {
            initResults();
            getSearchResults(scope.inputString);
          }
        };

        //event handler for blur, will set scope.selectedResult with the value of input field, if not
        //selected from suggestions
        scope.hideResults = function (event) {
          event.preventDefault();
          if (httpCancel) {
            httpCancel.resolve();
          }
          $timeout(function () {
            //scope.resultSelect will be false if nothing is selected from autocomplete list
            if (scope.resultSelect === false) {
              scope.inputString = scope.searchInput;
              clearResults();
              scope.$apply(function () {
                if (scope.inputString && scope.inputString.length > 0) {
                  inputField.val(scope.inputString);
                }
              });
              var result = {
                label: scope.inputString,
                value: null,
                isSelectedFromMenu: false,
              };
              scope.selectedResult = result;
              if (
                scope.selectHandler &&
                typeof scope.selectHandler === "function"
              ) {
                scope.selectHandler(false);
              }
            }
          }, 200);
        };

        scope.hoverRow = function (index) {
          scope.currentIndex = index;
          if (scope.results) {
            scope.currentResult = scope.results[scope.currentIndex];
          }
        };
        scope.hoverOut = function (index) {
          scope.currentResult = null;
          scope.currentIndex = -1;
        };
        //on click handler on each <li> item of autocomplete list
        scope.selectResult = function (result, event) {
          scope.inputString = result.title;
          scope.searchInput = scope.inputString;
          scope.resultSelect = true;
          var resultSelected = {
            label: result.title,
            value: result.value,
            isSelectedFromMenu: true,
          };
          scope.selectedResult = resultSelected;
          $timeout(function () {
            if (
              scope.selectHandler &&
              typeof scope.selectHandler === "function"
            ) {
              scope.selectHandler(true);
            }
          }, 200);
          clearResults();
        };
        inputField.on("keydown", keydownHandler);
        //Setting width of the suggestions list same as input field
        var inputElem = elem[0].querySelector("input.autocomplete-text");
        elem[0].querySelector(".autocomplete-dropdown").style.width =
          getComputedStyle(inputElem).width;
      },
    };
  },
]);

(function () {
  "use strict";

  // TODO remove
  angular.module("inspinia").constant("moduleInjection", {
    angularDatepicker: [
      {
        files: [
          "../bower_components/angular-datepicker/dist/angular-datepicker.css",
          "../bower_components/angular-datepicker/dist/angular-datepicker.js",
        ],
        // [{type: 'text/css', path: '../bower_components/angular-datepicker/dist/angular-datepicker.css'},
        //         {type: 'application/javascript', path: '../bower_components/angular-datepicker/dist/angular-datepicker.js'}]
      },
    ],
    angularFileUpload: [
      {
        files: [
          "../bower_components/angular-file-upload/dist/angular-file-upload.min.js",
        ],
      },
    ],
    angularLocale: [
      {
        files: ["../bower_components/angular-i18n/angular-locale_es-mx.js"],
      },
    ],
    jQuery: [
      {
        // files: [{type: 'text/css', path: 'components/common/jquery.steps.css'}]
        files: [
          "../bower_components/jquery/dist/jquery.js",
          "../bower_components/angular-typeahead/dist/angular-typeahead.js",
        ],
      },
    ],
    moment: [
      {
        files: ["../bower_components/moment/moment.js"],
      },
    ],
    selectize: [
      {
        files: [
          "../bower_components/selectize/dist/css/selectize.css",
          "../bower_components/selectize/dist/js/selectize.js",
        ],
        // [{type: 'text/css', path: '../bower_components/selectize/dist/css/selectize.css'},
        //         {type: 'application/javascript', path: '../bower_components/selectize/dist/js/selectize.js'}]
      },
    ],
    toaster: [
      {
        name: "toaster",
        files: [
          "../bower_components/AngularJS-Toaster/toaster.min.css",
          "../bower_components/AngularJS-Toaster/toaster.min.js",
        ],
      },
    ],
    angulari18n: [
      {
        name: "angular-i18n",
        files: ["../bower_components/angular-i18n/angular-locale_es-mx.js"],
      },
    ],
    uiSelect: [
      {
        files: [
          "../bower_components/ui-select/dist/select.js",
          "../bower_components/ui-select/dist/select.css",
        ],
      },
    ],
    base64: [
      {
        files: [
          "../bower_components/angular-base64-upload/dist/angular-base64-upload.min.js",
        ],
      },
    ],
    pdfmake: [
      {
        files: [
          "../bower_components/pdfmake/build/pdfmake.min.js",
          "../bower_components/pdfmake/build/vfs_fonts.js",
        ],
      },
    ],
  });
})();

(function () {
  "use strict";

  var app = angular.module("inspinia");
  app.constant("MESSAGES", {
    OK: {
      SAVECONCEPTOSGRALES:
        "Se ha guardado la Configuración de Conceptos Generales",
      SAVETICKET: "Se ha guardado la tarea",
      CERTIFICATESDONE: "Se han cargado los certificados",
      UPDATEENDORSEMENT: "Se ha actualizado el endoso",
      EMAILSENDED: "Se ha enviado el email correspondiente",
      SAVEDEMAIL: "Se ha guardado el email",
      SAVEDCONFIG: "Se ha guardado la configuración",
      UPLOADFILES: "Archivos cargados",
      UPLOADFILEONE: "Archivo cargado",
      NEWCOMPANY: "Nueva aseguradora guardada",
      NEWFASTENER: "Nueva afianzadora guardada",
      NEWFIANZAOK: "Nueva Fianza guardada",
      NEWCONTRACTOR: "Nuevo contratante guardado",
      NEWGROUP: "Nuevo grupo guardado",
      NEWOT: "Nueva orden de trabajo guardada",
      UPGRADEOT: "Orden de trabajo actualizada",
      NEWPOLICY: "La póliza y los recibos han sido creados",
      UPGRADEPOLICY: "Póliza actualizada",
      NEWPACKAGE: "Paquete guardado",
      NEWBRANCH: "Ramo creado",
      NEWSUBBRANCH: "Subramo creado",
      NEWENDORSEMENT: "Endoso creado",
      RENEWALPOLICY: "Póliza renovada",
      RENEWALFIANZA: "Fianza renovada",
      NEWRAMO: "Nuevo ramo guardado",
      NEWSUBRAMO: "Nuevo subramo guardado",
      APPLIEDENDORSEMENT: "Endoso aplicado",
      UPDATEDSTATUS: "Estatus actualizado",
      PAIDRECEIPT: "Recibo pagado",
      EDITREGISTRY: "Registro modificado",
      CANCELENDORSEMENT: "Endoso cancelado",
      CANCELPOLICY: "Póliza y recibos cancelados",
      CANCELRECEIPTS: "Recibo y subsecuentes cancelados",
      DELETEENDORSEMENT: "Endoso eliminado",
      DELETEGROUP: "Grupo eliminado",
      DELETEPACKAGE: "Paquete eliminado",
      DELETEPOLICY: "Póliza eliminada",
      DELETEFILE: "Archivos eliminados",
      DELETECONTRACTOR: "Contacto eliminado",
      DELETEADDRESS: "Dirección eliminada",
      CORRECTCHANGE: "Se ha guardado correctamente el cambio",
      DELETERAMO: "Se ha eliminado el ramo",
      DELETESUBRAMO: "Se ha eliminado el subramo",
      DELETEOT: "OT eliminada",
      UPDATECONTRACTOR: "Contratante editado correctamente.",
      UPDATERECEIPT: "Se han aplicado los cambios a tu recibo",
      SINIESTERUPDATED: "Siniestro actualizado",
      DELETECERT: "El certificado ha sido eliminado satisfactoriamente.",
      DELETECONTRATANTE: "El contratante ha sido eliminado.",
      RECEIPTCONCILIAR: "El recibo se ha conciliado, folio de conciliación: ",
      POLICYCANCELED: "La póliza ha sido cancelada",
      POLICYREACTIVED: "La póliza ha sido Reactivada",
      CANCELEDCANCEL: "El estatus de la póliza es precancelado",
      CREATESELLER: "El vendedor se creó correctamente",
      UPDATESELLER: "El vendedor se actualizó correctamente",
      OKPRINTRECEIPT: "Estado de cuenta creado correctamente",
      POLICYSEND: "La póliza ha sido enviada",
      ENDOSOSEND: "El endoso ha sido compartido",
      FILESHARED: "Se compartieron archivos",
      FILENOSHARED: "Se dejaron de compartir archivos",
      POLICYSHARED: "La póliza ha sido compartida",
      DELETECOLLECTIVITY: "La colectividad se ha eliminado",
      SENDPROVIDER: "El email ha sido enviado a la compañia",
      SENDEMAIL: "El correo electrónico ha sido enviado",
      DELETEENDOSO: "El endoso ha sido eliminado",
      DELETEEVENT: "El evento ha sido eliminado correctamente",
      UPDATEEVENT: "El evento ha sido actualizado correctamente",
      REGISTERENDOSO: "El endoso ha sido registrado",
      BONODELETED: "El bono ha sido eliminado",
      QUOTATIONCREATE: "La cotización ha sido creada.",
      SUCURSALCREATE: "La sucursal ha sido creada.",
      QUOTATIONCHANGE: "Se han guardado los cambios.",
      OKNORENOVATION:
        "La colectividad se ha cerrado y no se vera más en el listado de renovaciones.",
      CONFIGSAVED:
        "Se ha guardado su configuración, por favor refrescar el navegador para ver aplicados los cambios en la gráfica",
      HISTSENDEMAIL: "El histórico ha sido enviado.",
    },
    ERROR: {
      ERRORREPORTGRAL: "Ha ocurrido un error al generar el reporte",
      DATESOUT:
        "La vigencia de los recibos no corresponde con la vigencia de la póliza, favor de generar recibos nuevamente",
      DATESOUT_FY:
        "La vigencia de los recibos no corresponde con la vigencia del primer año la póliza, favor de generar recibos nuevamente",
      INVALIDEMAIL: "Ingrese un e-mail válido",
      INVALIDEMAILCONTACT: "Ingrese un e-mail válido del contacto",
      CONTRACTORERROR: "Debes seleccionar un contratante válido",
      MINIMUMPHONELENGTH: "El telefono no debe ser mayor a 15 caracteres",
      THISNAMEALREADYEXIST:
        "Este nombre de grupo ya existe en esta organización",
      APPNOTACTIVE:
        "Su cuenta fue desactivada por falta de pago \n comuníquese a finanzas@miurabox.com con copia a soporte@miurabox.com",
      PRIMESDOESNTMATCH:
        "La suma de las primas netas de los recibos no coinciden con la prima total de la póliza",
      RPFDOESNTMATCH:
        "El rpf total de los recibos no coinciden con el rpf total de la póliza",
      DERECHODOESNTMATCH:
        "La suma de los derecho de los recibos no coinciden con el derecho total de la póliza",
      SUBTOTALDOESNTMATCH:
        "La suma del subtotal de los recibos no coincide con el subtotal de la póliza",
      TOTALDOESNTMATCH:
        "La suma de la prima total de los recibos no coincide con el total de la póliza",
      SELLOCATION: "Falta estado, ciudad, dirección o código postal",
      SELADDRES: "Favor de escribir el nombre del contacto",
      SELGROUP: "Escoja al menos un grupo",
      SELPAY: "Seleccione una frecuencia de pago",
      ERRORCREATECONTRACTOR:
        "Error al guardar contrantante, favor de revisar la información",
      ERRORCREATECOMPANY:
        "Error al crear aseguradora, favor de revisar la información",
      ERRORCREATEGROUP:
        "Error al crear el grupo, favor de revisar la información",
      ERRORCREATEOT:
        "Error al crear la orden de trabajo, favor de revisar la información",
      ERRORCREATEPOLICY:
        "Error al crear la póliza, favor de revisar la información",
      ERRORCREATERECIEPTS:
        "Error al crear los recibos, favor de revisar la información",
      ERRORCREATEPACKAGE:
        "Error al crear el paquete, favor de revisar la información",
      ERRORCREATEBRANCH:
        "Error al crear el ramo, favor de revisar la información",
      ERRORCREATESUBBRANCH:
        "Error al crear el subramo, favor de revisar la información",
      ERRORCREATEENDORSEMENT:
        "Error al crear el endoso, favor de revisar la información",
      ERRORRECEIPTSENDORSEMENT: "Seleccione un número de recibos",
      ERRORFOLIOENDORSEMENTREG: "Debe ingresar un folio para el endoso",
      ERRORNUMBERENDORSEMENT: "Debe ingresar un número para el endoso",
      ERRORTYPEENDORSEMENT: "Debe seleccionar un tipo de endoso",
      ERRORFOLIOENDORSEMENT: "Ya existe ese número de folio",
      ERRORONUPDATEADDRESS:
        "Error al guardar su dirección, favor de revisar la información",
      ERRORRENEWALPOLICY:
        "Error al renovar la póliza, favor de revisar la información",
      ERRORRENEWPOLICY: "Esta póliza ya tiene una renovación",
      ERRORREPROCCESSRENPOLICY: "Esta póliza esta ya en proceso de renovación",
      ERRORSTATUSUPDATE:
        "Error al actualizar el estatus, favor de revisar la información",
      ERRORONUPLOADFILES:
        "Error al cargar archivos, favor de revisar la información",
      FILETOOLARGE: "El archivo es demasiado grande. Maximo 30 MB",
      ADDATLEASTONECONTACT: "Favor de agregar al menos un contacto",
      ADDATLEASTONEDIRECCTION: "Favor de agregar al menos una dirección",
      LOGIN: "Contraseña o correo inválida",
      PRODUCTACCESS: "No tienes acceso a este producto",
      ERRORAPI: "Error al iniciar sesion en el API",
      ERRORCREATERAMO:
        "Error al crear el ramo, favor de revisar la información",
      ERRORCREATESUBRAMO:
        "Error al crear el subramo, favor de revisar la información",
      ERRORWRONGRAMOCODE:
        "El código de ramo debe ser de 1 a 3 dígitos, favor de revisar la información",
      ERRORWRONGSUBRAMOCODE:
        "El código de subramo debe ser de 1 a 3 dígitos, favor de revisar la información",
      ERRORWRONGRAMONAME:
        "El nombre del ramo debe ser ingresado, favor de revisar la información",
      ERRORWRONGSUBRAMONAME:
        "El nombre del subramo debe ser ingresado, favor de revisar la información",
      UPDATECONTRACTOR: "Error al actualizar su contratante.",
      FOLIOREQUIRED: "Folio requerido",
      POLICYNOREQUIRED: "Agrega un número de póliza",
      RECEIPTSREQUIRED: "Generar recibos es requerido",
      NOTESREQUIRED: "Generar la nota de crédito es requerido",
      DATAFORMREQUIRED: "Datos de formulario requeridos",
      DATAFORMNAME: "Nombre(s) es requerido",
      DATAFORMJNAME: "Nombre de la Empresa es requerido",
      DATAFORMLASTNAME: "Apellido Paterno es requerido",
      DATAFORMBIRTHDAY: "Fecha de Nacimiento es requerido",
      DATAFORMESTABLISHMENT: "Fecha de Constitución es requerido",
      DATAFORMRFC: "RFC es requerido",
      DATAFORMSEX: "Género es requerido",
      DATAADDRESSREQUIRED: "Datos de dirección requeridos",
      ADMINISTRATIONREQUIRED: "Seleccione un tipo de administración",
      OBSERVATIONREQUIRED: "Debe agregar observaciones",
      ERRORINTERNETCONNECTION: "No hay conexión a internet",
      COMISSION: "Debe seleccionar una comisión",
      POLICYEXIST: "El número de póliza ya existe",
      FIANZAEXIST: "El número de fianza ya existe",
      ADDRESS: "Debe seleccionar una dirección del contratante",
      PHONE: "Debe ingresar un teléfono",
      CLAVE: "Debe seleccionar una clave de agente",
      PACKAGE: "Debe seleccionar un paquete",
      DATES: "Debe seleccionar las fechas",
      AUTOFORM: "Datos del automóvil (marca, modelo, año, serie) requeridos",
      AUTOUSAGE: "Seleccione un uso al automóvil",
      AUTOSERVICE: "Seleccione un servicio al automóvil",
      COVERAGESREQUIRED: "Al menos una cobertura es requerida",
      DEDUCTIBLEREQUIRED:
        "Las sumas aseguradas y los deducibles de las coberturas no pueden ir vacíos",
      COVERAGEALREADYEXIST: "Ya existe ésta cobertura",
      GREATERTHAN100: "No puede tener un porcentaje mayor a 100%",
      GREATERTHANDEC100:
        "No puede tener un porcentaje mayor a 100% y sin punto decimal",
      ONEBENEFICIARY: "Debe agregar al menos un beneficiario",
      ONEASEGURADOLIFE: "Debe agregar al menos un ASEGURADO",
      RAMOREQUIRED: "Debe seleccionar un ramo",
      SUBRAMOREQUIRED: "Debe seleccionar un subramo",
      PROVIDERREQUIRED: "Debe seleccionar una aseguradora",
      PRIMATOTAL: "No se calculó la prima total",
      POLIZAMAXLENGTH:
        "Asegúrese que el número de póliza no tenga más de 30 caracteres",
      FOLIOMAXLENGTH: "Asegúrese que el folio no tenga más de 30 caracteres",
      RECEIPTSDATES:
        "Revisa que los recibos tengan fecha de inicio y fecha de fin",
      RECEIPTSERROR: "Ha ocurrido un error al guardar los recibos.",
      CANCELCERT: "El certificado no fue eliminado.",
      GRALERROR: "Ha ocurrido un error",
      CANCELACCOUNT: "El recibo no se ha conciliado",
      SELECTACCOUNT: "Seleccione una cuenta",
      DELETECONTACT: "Se ha borrado un contacto",
      ERRORNAMEPHONEEMAIL:
        "Favor de añadir nombre o teléfono y verificar que se use el formato correcto para los correos de los contactos",
      ERRORNUMBER: "Favor de ingresar un número válido",
      ERRORNAMECOVERAGE: "Es necesario asignar un nombre a la cobertura",
      ERROR: "Ha ocurrido un error",
      ERRORSEARCHPOLICY: "Póliza no encontrada",
      ERRORPRIMA:
        "La prima total de los recibos no coincide con la prima total del endoso",
      ERRORRECEIPTS: "Debe generar los recibos",
      ERRORCERTIFICATES:
        "Ha ocurrido un error al guardar los certificados, por favor revise la información",
      ERRORNUMCERTIFICATES:
        "Solo es posible cargar un máximo de 800 registros por archivo",
      ERRORSUBGROUP: "Debe ingresar el nombre del subgrupo",
      ERRORUPDATERECEIPTS:
        "Ah ocurrido un error al actualizar el recibo, intente nuevamente",
      ERRORPERMISSIONAPP: "El usuario no tiene permiso para acceder",
      ERRORPRINTRECEIPT: "Solo puedes imprimir recibos conciliados",
      ERROREMAILMAX:
        "Asegúrese de que ningún correo electrónico tenga más de 70 caracteres",
      ERRORGROUPMAX: "Asegúrese de que el grupo no tenga más de 100 caracteres",
      ERRORCONCEPT: "Debes seleccionar un concepto",
      ERRORDATERANGE: "La fecha final no puede ser menor que la inicial",
      ERRORDATEBIRTHDATE:
        "La fecha de nacimiento no puede ser mayor al día de hoy",
      ERRORDATEFORMESTABLISHMENT:
        "La fecha de constitución no puede ser mayor al día de hoy",
      ERRORTYPEAUTO: "Debes seleccionar un tipo de automóvil",
      ERRORLENGTHPHONE: "El número teléfono debe de ser de 10 dígitos",
      ERRORLENGTHPHONECONTACT:
        "Revise números de teléfono en contactos; deben ser mayores a 9 dígitos",
      ERRORSERVER: "Ha ocurrido un problema al guardar la póliza",
      OPTIONNOTVALID: "No es una eleccion valida",
      ERRORWITHOUTEMAIL: "Agrega un correo electrónico o un teléfono",
      ENDOSOBS: "Agregue descripción del endoso",
      ASEGURADOREQUIRED: "Complete los datos del Asegurado",
      IDENTIFIERREQUIRED: "Debe ingresar identificador",
      ERRORCONTRACTOR: "Agrega un contratante",
      ERROREMAIL: "Agrega un correo electrónico valido",
      ERRORPAYFORM: "Debe seleccionar una forma de pago",
      ERRORDOWNLOADREP: "Ha ocurrido un error al descargar el reporte",
      ERRORSENDEMAIL: "No se encontraron resultados  con esos filtros.",
      ERRORFOUNDRECEIPTS: "No se encontraron recibos.",
      FIANZANOREQUIRED: "Agrega un número de fianza.",
      EMISIONREQUIRED: "Agrega una fecha de emisión.",
      AFIANZADORAREQUIRED: "Debes seleccionar una afianzadora.",
      TYPEFIANZAREQUIRED: "Debes seleccionar un tipo de fianza.",
      RODEAFIANZADOREQUIRED: "Agrega un monto afianzado.",
      VENDORREQUIRED: "Debes seleccionar un referenciador.",
      ERROREXECUTIONRANGE:
        "La fecha final del plazo de ejecución no puede ser menor que la inicial",
      NOCONTRACTREQUIRED: "Agrega un número de contrato.",
      OBJECTREQUIRED: "Agrega un objeto de contrato.",
      TOTALAMOUNTREQUIRED: "Agrega un monto total.",
      GUARANTEEPERCENTAGEREQUIRED: "Agrega un porcentaje de garantía.",
      BENEFICIARYREQUIRED: "Agrega al menos un beneficiario.",
      BENEFICIARYNAMEREQUIRED: "Agrega el nombre del beneficiario  #",
      BENEFICIARYLASTNAMEREQUIRED:
        "Agrega el apellido paterno del beneficiario  #",
      BENEFICIARYJNAMEREQUIRED: "Agrega la razón social del beneficiario  #",
      SINIESTERERROR:
        "Ha ocurrido un error al actualizar (falta de información al crearlo)",
      DATEESTABLISHMENT:
        "Seleccione la Fecha de Constitución del Calendario ó complete con formato DD/MM/AAAA",
      DATEBIRTHDAY:
        "Seleccione la Fecha de Nacimiento del Calendario ó complete con formato DD/MM/AAAA",
      HISTERRORSENDEMAIL:
        "No ha sido posible enviar el histórico, intente nuevamente.",
      ERRORENDORSEMENTCONCEPT: "Debes seleccionar un concepto.",
      ERRORFORMATNUMBER: "Error de formato, agregue sólo números.",
      ERRORFORMATPERCENT: "Error de formato, ingrese un porcentaje válido.",
      SELECTCERTTOEND:
        "Click en Buscar, elija un certificado (click en Elegir).",
      REVIEWEMAIL: "Revise el correo electrónico ",
      REPEATEMAIL: "El correo electrónico ya ha sido agregado con anterioridad",
    },
    INFO: {
      MANUALLYDATES: "Agregar manualmente las fechas",
      CONTRACTORTYPEPERSON:
        "Para usar este boton debe seleccionar un contratante fisico",
      POLICYPENDIENT: "La póliza ha sido asignada al e-mail",
      POLICYASSIGNED:
        "El e-mail ingresado pertenece a un usuario registrado, póliza asignada ",
      SUCCESSINTERNETCONNECTION: "Se ha recuperado la conexión a internet",
      INFOBANNER: "La imagen debe tener una resolución de 1000 x 120px",
      CANCELCONTRACTOR: "No se ha aplicado ningún cambio.",
      VIGENCYNOTECREDITWRITE:
        "Agregue las fechas de vigencia manual, dentro de las fechas del endoso",
    },
    WARNING: {
      VALIDITYENDORSEMENT:
        "Vigencia de endoso fuera de rango de vigencia de póliza",
      VALIDITYOUTRANGE: "Fecha de vigencia fuera del rango",
      UPLOADINGFILES: "Se estan subiendo los archivos. Por favor espera",
      EMPTYEMAIL: "La lista de correos está vacía",
      EMPTYBANK: "Seleccione un banco válido",
      CHANGEPAYFORM:
        "Si se cambia la forma de pago, tiene generar sus recibos nuevamente, ¿esta de acuerdo?",
      WARNINGCONTRACTOR: "El contratante tiene pólizas asignadas",
      WARNINGRECEIPTS:
        "La vigencia de cada recibo fue actualizada. Debe revisar la vigencia de los recibos antes de guardar",
      WARNINGSINIESTER: "Por favor, agrega los procedentes de cada factura",
      CHOOSECONCEPT: "Por favor, elija un concepto de cancelación",
      DELETENDO:
        "¿Está seguro que desea eliminar este endoso? Se eliminarán todos los recibos y/o certificados.",
      SELECTCONSULT: "Seleccione una opción de Consulta Por",
      CONCPAGEDISPON:
        "La conciliación se hará sobre los recibos en la página disponible",
      NOSAVEDEMAIL: "Debes guardar el correo antes de enviarlo.",
      FIANSACOMISION: "La fianza se creara sin comisión.",
      WITHOUTCERTS:
        "No existen certificados en la carátula, el endoso se aplicará a la Carátula.",
      DATEFILTERREMOVED:
        "El tiempo de carga de los resultados puede afectarse considerablemente si se selecciona esta opción.",
    },
  });
  app.constant("globalValues", {
    enfermedades: "padecimientos/",
    states: "v1/configurations/states/",
    cities: "v1/configurations/cities/",
    address: "v1/address/",
    // Forms
    automobileForm: "v1/forms/automobile-damages/",
    damageForm: "v1/forms/damages/",
    diseaseForm: "v1/forms/disease/",
    lifeForm: "v1/forms/lifes/",
    // Form info
    automobileInfoForm: "v1/forms/automobile/informations/:id/",
    damageInfoForm: "v1/forms/damages/informations/:id/",
    diseaseInfoForm: "v1/forms/disease/informations/:id/",
    lifeInfoForm: "v1/forms/lifes/informations/:id/",
    //Generics
    personal: "v1/personal-informations/",
    beneficiaries: "v1/beneficiaries/",
    relationships: "v1/relationships/",
    // Endorsements
    automobileEndorsement: "v1/endorsements/automobiles/",
    damageEndorsement: "v1/endorsements/damages/",
    diseaseEndorsement: "v1/endorsements/disease/",
    lifeEndorsement: "v1/endorsements/lifes/",
    existEndorsement: "v1/policies/endorsements/:id/",
    // Endorsements min info
    automobileMinEndorsement: "v1/endorsements/info-automobiles/",
    damageMinEndorsement: "v1/endorsements/info-damages/",
    diseaseMinEndorsement: "v1/endorsements/info-disease/",
    lifeMinEndorsement: "v1/endorsements/info-lifes/",
    // Endorsements info
    automobileInfoEndorsement: "v1/endorsements/automobiles/1/informations/",
    damageInfoEndorsement: "v1/endorsements/damages/1/informations/",
    diseaseInfoEndorsement: "v1/endorsements/disease/1/informations/",
    lifeInfoEndorsement: "v1/endorsements/lifes/1/informations/",

    automobileMoreInfoEndorsement: "v1/endorsements/automobiles/1/editInfo/",
    damageMoreInfoEndorsement: "v1/endorsements/damages/1/editInfo/",
    diseaseMoreInfoEndorsement: "v1/endorsements/disease/1/editInfo/",
    lifeMoreInfoEndorsement: "v1/endorsements/lifes/1/editInfo/",
    //Policies and receipts
    policyByNumber: "v1/policies/",
    policyByNumberURL: "v1/policies/urls/",
    existPolicy: "v1/policies/:id/exist/",
    existPolicyNumber: "v1/policies/exist_number/",
    existSerial: "serial/:id/exist/",
    existSerialRenovacion: "serial/:id/exist-renovacion/:idpoliza/",
    existPolicyFolio: "v1/policies/folio/:pk/exist/",

    folio: "v1/folios/:folio/",
    policiesWithoutReceipts: "v1/policies/clean/",
    receiptsWithPolicy: "v1/receipts/",
    existOT: "v1/ot/:id/exist/",
    // Coverages
    coveragesByPackage: "v1/packages/:package/coverages/",
  });
  app.factory("globalVar", function (url, globalValues) {
    var service = {
      diseases: url.IP + globalValues.enfermedades,
      states: url.IP + globalValues.states,
      cities: url.IP + globalValues.cities,
      address: url.IP + globalValues.address,
      // Forms
      automobileForm: url.IP + globalValues.automobileForm,
      lifeForm: url.IP + globalValues.lifeForm,
      diseaseForm: url.IP + globalValues.diseaseForm,
      damageForm: url.IP + globalValues.damageForm,
      // Form info
      automobileInfoForm: url.IP + globalValues.automobileInfoForm,
      damageInfoForm: url.IP + globalValues.damageInfoForm,
      diseaseInfoForm: url.IP + globalValues.diseaseInfoForm,
      lifeInfoForm: url.IP + globalValues.lifeInfoForm,
      // Generics
      personal: url.IP + globalValues.personal,
      beneficiaries: url.IP + globalValues.beneficiaries,
      relationships: url.IP + globalValues.relationships,
      // Endorsements
      automobileEndorsement: url.IP + globalValues.automobileEndorsement,
      damageEndorsement: url.IP + globalValues.damageEndorsement,
      diseaseEndorsement: url.IP + globalValues.diseaseEndorsement,
      lifeEndorsement: url.IP + globalValues.lifeEndorsement,
      existEndorsement: url.IP + globalValues.existEndorsement,
      // Endorsements min info
      automobileMinEndorsement: url.IP + globalValues.automobileMinEndorsement,
      damageMinEndorsement: url.IP + globalValues.damageMinEndorsement,
      diseaseMinEndorsement: url.IP + globalValues.diseaseMinEndorsement,
      lifeMinEndorsement: url.IP + globalValues.lifeMinEndorsement,
      // Endorsements info
      automobileInfoEndorsement:
        url.IP + globalValues.automobileInfoEndorsement,
      damageInfoEndorsement: url.IP + globalValues.damageInfoEndorsement,
      diseaseInfoEndorsement: url.IP + globalValues.diseaseInfoEndorsement,
      lifeInfoEndorsement: url.IP + globalValues.lifeInfoEndorsement,
      // Endorsements more info
      automobileMoreInfoEndorsement:
        url.IP + globalValues.automobileMoreInfoEndorsement,
      damageMoreInfoEndorsement:
        url.IP + globalValues.damageMoreInfoEndorsement,
      diseaseMoreInfoEndorsement:
        url.IP + globalValues.diseaseMoreInfoEndorsement,
      lifeMoreInfoEndorsement: url.IP + globalValues.lifeMoreInfoEndorsement,
      // Policies and receipts
      policyByNumber: url.IP + globalValues.policyByNumber,
      policyByNumberURL: url.IP + globalValues.policyByNumberURL,
      existPolicy: url.IP + globalValues.existPolicy,
      existPolicyNumber: url.IP + globalValues.existPolicyNumber,
      existSerial: url.IP + globalValues.existSerial,
      existSerialRenovacion: url.IP + globalValues.existSerialRenovacion,
      existPolicyFolio: url.IP + globalValues.existPolicyFolio,

      folio: url.IP + globalValues.folio,
      policiesWithoutReceipts: url.IP + globalValues.policiesWithoutReceipts,
      receiptsWithPolicy: url.IP + globalValues.receiptsWithPolicy,
      existOT: url.IP + globalValues.existOT,
      // Coverages
      coveragesByPackage: url.IP + globalValues.coveragesByPackage,
    };
    return service;
  });

  app.constant("forms", {
    auto: { subranch_name: "Automóviles", subbranch_code: 9 },
  });

  app.constant("facturas_conceptos", [
    { name: "Medicamentos", value: "Medicamentos" },
    { name: "Honorarios Médicos", value: "Honorarios Médicos" },
    { name: "Hospitalización", value: "Hospitalización" },
    { name: "Estudios", value: "Estudios" },
    { name: "Prótesis", value: "Prótesis" },
    { name: "Ambulancia", value: "Ambulancia" },
    { name: "Otros", value: "Otros" },
  ]);

  app.constant("sex", [
    { value: "M", label: "MASCULINO" },
    { value: "F", label: "FEMENINO" },
  ]);

  app.constant("tiposBeneficiarios", [
    {
      option: "TITULAR",
      relationship: 1,
      disabled: false,
    },
    {
      option: "CONYUGE",
      relationship: 2,
      disabled: false,
    },
    {
      option: "HIJO",
      relationship: 3,
      disabled: false,
    },
    {
      option: "OTRO",
      relationship: 4,
      disabled: false,
    },
  ]);

  app.constant("status", [
    { value: 1, label: "EN TRÁMITE" },
    { value: 2, label: "OT CANCELADA" },
    { value: 10, label: "POR INICIAR" },
    { value: 11, label: "CANCELADA" },
    { value: 12, label: "RENOVADA" },
    { value: 13, label: "VENCIDA" },
    { value: 14, label: "VIGENTE" },
    { value: 15, label: "NO RENOVADA" },
    { value: 16, label: "SINIESTRADA" },
  ]);

  app.constant("statusSiniestro", [
    { value: 1, label: "PENDIENTE" },
    { value: 2, label: "EN TRAMITE" },
    { value: 3, label: "PROCEDENTE" },
    { value: 4, label: "CANCELADA" },
    { value: 5, label: "RECHAZADA" },
  ]);

  app.constant("payform", [
    { value: 1, label: "MENSUAL" },
    { value: 2, label: "BIMESTRAL" },
    { value: 3, label: "TRIMESTRAL" },
    // {value: 4, label: 'CUATRIMESTRAL'},
    { value: 5, label: "CONTADO" },
    { value: 6, label: "SEMESTRAL" },
    { value: 12, label: "ANUAL" },
    // {value: 24, label: 'Quincenal'},
  ]);

  app.constant("formaPago", [
    { value: 1, label: "MENSUAL" },
    { value: 2, label: "BIMESTRAL" },
    { value: 3, label: "TRIMESTRAL" },
    { value: 5, label: "CONTADO" },
    { value: 6, label: "SEMESTRAL" },
    { value: 4, label: "CUATRIMESTRAL" },
    { value: 12, label: "ANUAL" },
    // {value: 24, label: 'Quincenal'},
  ]);

  app.constant("statusReceipt", [
    { value: 1, label: "PAGADO" },
    { value: 2, label: "CANCELADO" },
    { value: 3, label: "PRORROGADO" },
    { value: 4, label: "PENDIENTE DE PAGO" },
    { value: 5, label: "LIQUIDADO" },
    { value: 6, label: "CONCILIADO" },
    { value: 7, label: "CERRADO" },
    { value: 8, label: "PRECANCELADO" },
    { value: 10, label: "ANULADO" },
    { value: 11, label: "PREANULADO" },
  ]);

  app.constant("statusPayform", [
    { value: 1, label: "CHEQUE" },
    { value: 2, label: "EFECTIVO" },
    { value: 3, label: "TRANSFERENCIA" },
    { value: 4, label: "DEPOSITO BANCARIO" },
    { value: 5, label: "TARJETA DE CREDITO" },
    { value: 6, label: "TARJETA DE DEBITO" },
    { value: 7, label: "ESTADO DE CUENTA" },
    { value: 8, label: "COMPAÑIA" },
    { value: 9, label: "CAT/DOMICILIADO" },
  ]);

  app.constant("curr_rate_options", [
    { value: 1, label: "PESO" },
    { value: 2, label: "DOLAR" },
    { value: 3, label: "UDI" },
    { value: 4, label: "EURO" },
    { value: 5, label: "DOLAR CANADIENSE" },
    { value: 6, label: "LIBRA ESTERLINA" },
    { value: 7, label: "YEN" },
  ]);

  app.constant("endorsement", [
    { value: 1, label: "PENDIENTE" }, //Cuando se crea el endoso. Este es el estatus por default.
    { value: 2, label: "REGISTRADO" }, //Cuando se acepta y aplica el endoso. De aquí ya no se puede cambiar a ningún otro estatus, ya que es el paso final.
    { value: 3, label: "RECHAZADO" }, //Cuando la compañía rechaza el endoso.
    { value: 4, label: "CANCELADO" }, //Cuando el usuario cancela el endoso.
    { value: 5, label: "EN TRÁMITE" }, //Posterior a pendiente
  ]);

  app.constant("conceptA", [
    { value: 1, label: "CAMBIO DE FORMA DE PAGO" },
    // {value: 2, label: 'CAMBIO DE SUMA ASEGURADA'},
    // {value: 3, label: 'CAMBIO DE DEDUCIBLE Y/O COASEGURO'},
    // {value: 4, label: 'AGREGAR ASEGURADO'},
    // {value: 5, label: 'AGREGAR COBERTURAS'},
    // {value: 6, label: 'DECLARACIÓN MENSUAL'},
    // {value: 19, label: 'OTRO (COBERTURAS)'},
    // {value: 20, label: 'OTRO (ASEGURADO)'},
    { value: 7, label: "OTRO" },
  ]);

  app.constant("conceptFianza", [
    // {value: 1, label: 'AUMENTO MONTO AFIANZADO'},
    // {value: 2, label: 'DECREMENTO MONTO AFIANZADO'},
    // {value: 3, label: 'CAMBIO DE PORCENTAJE DE GARANTÍA'},
    // {value: 5, label: 'CAMBIO DE DATOS'},
    { value: 4, label: "OTRO" },
  ]);

  app.constant("conceptB", [
    // {value: 8, label: 'CAMBIO DATOS FISCALES'},
    // {value: 33, label: 'CORRECCION DE DATOS'},
    // {value: 34, label: 'CORRECCION DE DATOS BENEFICIARIO'},
    // {value: 9, label: 'ESPECIFICACIONES'},
    // {value: 23, label: 'ANTIGÜEDAD RECONOCIDA'},
    { value: 10, label: "OTRO" },
  ]);

  app.constant("conceptD", [
    // {value: 12, label: 'DISMINUCIÓN EN LA SUMA ASEGURADA'},
    // {value: 13, label: 'BAJA DE COBERTURA'},
    // {value: 14, label: 'CAMBIO DE DEDUCIBLE Y/O COASEGURO'},
    // {value: 15, label: 'BAJA DE ASEGURADO'},
    // {value: 16, label: 'CANCELACIÓN DE PÓLIZA POR PETICIÓN'},
    // {value: 17, label: 'CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO'},
    // {value: 21, label: 'OTRO (COBERTURAS)'},
    // {value: 22, label: 'OTRO (ASEGURADO)'},
    { value: 18, label: "OTRO" },
  ]);

  app.constant("collectivityConceptA", [
    // // {id: 24, name: 'ALTA DE CERTIFICADOS'},
    // {id: 26, name: 'AJUSTE ANUAL A'},
    // {id: 30, name: 'DECLARACIÓN'},
    // // {id: 31, name: 'AGREGAR DEPENDIENTE/BENEFICIARIO'},
    // {id: 41, name: 'ALTA DE UNIDAD'},
    // {id: 42, name: 'AGREGAR COBERTURA'},
    { id: 43, name: "CAMBIO DE FORMA DE PAGO" },
    // {id: 44, name: 'AGREGAR CARGA'},
    // {id: 45, name: 'AGREGAR ADAPTACIONES Y CONVERSIONES'},
    { id: 29, name: "OTRO" },
  ]);

  app.constant("collectivityConceptB", [
    // // {id: 24, name: 'ALTA DE CERTIFICADOS'},
    // // {id: 25, name: 'BAJA DE CERTIFICADOS'},
    // {id: 27, name: 'RECONOCIMIENTO DE ANTIGÜEDAD'},
    // {id: 46, name: 'INCLUIR BP'},
    // {id: 47, name: 'CORREGIR DESCRIPCIÓN'},
    // {id: 48, name: 'AGREGAR TEXTOS ACLARATORIOS'},
    // {id: 49, name: 'ADAPTACIONES SOLO PARA EFECTOS DE RC'},
    // {id: 50, name: 'AGREGAR PLACAS, MOTOR O CORREGIR SERIE'},
    { id: 29, name: "OTRO" },
  ]);

  app.constant("collectivityConceptD", [
    // {id: 25, name: 'BAJA DE CERTIFICADOS'},
    // {id: 26, name: 'AJUSTE ANUAL D'},
    // {id: 30, name: 'DECLARACIÓN'},
    // {id: 32, name: 'CANCELACIÓN'},
    // {id: 51, name: 'CANCELACIONES'},
    // {id: 52, name: 'ELIMINACIÓN DE COBERTURAS'},
    { id: 29, name: "OTRO" },
  ]);
})();

angular
  .module("config", [])
  .constant("url", {
    _commentIP: "http://localhost:8000/",
    test_commentIP: "https://testapi.miurabox.com/",
    IP: "https://api.miurabox.com/",
    MC: "https://testapi.multicotizador.com/",
    IP_CAS: "https://users-api.miurabox.com/",
    SOCKETNODE: "https://socketn.mbxservicios.com",
    REPORT_SERVICE_NODE_SOCKET: "https://socketn.mbxservicios.com",
    REPORT_SERVICE_NODE_SOCKET_ANCORA: "https://socketancora.mbxservicios.com",
    SERVICE_PDF: "https://pdf-api.miurabox.com",
    LECTORPDF: "https://pdfreader.mbxservicios.com/",
  });

angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("index.html","<!DOCTYPE html><html ng-app=\"inspinia\"><head><meta charset=\"utf-8\"><title>SAAM</title><meta name=\"description\" content=\"\"><meta name=\"viewport\" content=\"width=device-width\"><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><script src=\"https://socketn.mbxservicios.com/socket.io/socket.io.js\"></script><link href=\"https://miurabox.s3.amazonaws.com/areas/angular.areas.css\" rel=\"stylesheet\"><style type=\"text/css\">\n        @font-face {\n          font-family: \'footable\';\n          src: url(\'../fonts/footable.eot\');\n          src: url(\'../fonts/footable.eot?#iefix\') format(\'embedded-opentype\'), url(\'../fonts/footable.woff\') format(\'woff\'), url(\'../fonts/footable.ttf\') format(\'truetype\'), url(\'../fonts/footable.svg#footable\') format(\'svg\');\n          font-weight: normal;\n          font-style: normal;\n        }\n        @media screen and (-webkit-min-device-pixel-ratio: 0) {\n          @font-face {\n            font-family: \'footable\';\n            src: url(\'../fonts/footable.svg#footable\') format(\'svg\');\n            font-weight: normal;\n            font-style: normal;\n          }\n        }\n    </style><script type=\"text/javascript\"> window.paceOptions = { ajax: { ignoreURLs: [/.*firebase.*/] } } </script></head><body class=\"skin-1 bg-1\" ng-controller=\"MainCtrl as main\"><div ui-view=\"\"></div><script type=\"text/javascript\" src=\"https://cdnjs.cloudflare.com/ajax/libs/xls/0.7.6/xls.min.js\"></script><script type=\"text/javascript\" src=\"https://www.shieldui.com/shared/components/latest/js/shieldui-all.min.js\"></script><script type=\"text/javascript\" src=\"https://www.shieldui.com/shared/components/latest/js/jszip.min.js\"></script><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><script src=\"https://www.gstatic.com/firebasejs/5.5.6/firebase.js\"></script><script src=\"https://cdn.firebase.com/libs/angularfire/2.2.0/angularfire.min.js\"></script><script>\n      var config = {\n          apiKey: \"AIzaSyAV6KX7UXiCAEQwNUUC5gnYNHHjzhGgiXs\",\n          authDomain: \"saamnotificaciones.firebaseapp.com\",\n          databaseURL: \"https://saamnotificaciones.firebaseio.com\",\n          projectId: \"saamnotificaciones\",\n          storageBucket: \"saamnotificaciones.appspot.com\",\n          messagingSenderId: \"293300832695\"\n        };\n      firebase.initializeApp(config);\n\n          if (firebase.messaging.isSupported()) {\n            const messaging = firebase.messaging();\n            messaging.usePublicVapidKey(\"BEriMw3XUr54ZgUkMjKfeDs_mVEenVtZ-2VJNKOrjTvMytnVPLLBnj6mec-nfZeWtyB_HuK86lz3zrMknkmqxR0\");\n          }\n    </script><script type=\"text/javascript\">\n      $(document).ready(function() {\n        window.scrollTo(0,0);\n        Ladda.bind( \'.ladda-button\' );\n      });\n      // $(window).load(function() {\n      //     $(\'.js-example-basic-multiple\').select2();\n      // });\n      angular.element(document).ready(function(){\n        $(\'.js-example-basic-multiple\').select2();\n      });\n      if ($(window).width() >= 768) {\n        $(\'.skin-1.bg-1\').addClass(\'mini-navbar\');\n      }\n      else {\n        $(\'.skin-1.bg-1\').removeClass(\'mini-navbar\');\n      }\n    </script><script src=\"https://cdn.datatables.net/1.10.12/js/jquery.dataTables.min.js\"></script><script src=\"https://cdn.datatables.net/buttons/1.2.2/js/dataTables.buttons.min.js\"></script><script src=\"https://cdn.datatables.net/buttons/1.2.2/js/buttons.colVis.min.js\"></script><script src=\"https://cdn.datatables.net/buttons/1.2.2/js/buttons.html5.min.js\"></script><script src=\"https://cdn.datatables.net/buttons/1.2.2/js/buttons.print.min.js\"></script><script src=\"https://cdn.datatables.net/1.10.12/js/dataTables.bootstrap.min.js\"></script><script src=\"https://cdn.datatables.net/buttons/1.2.2/js/buttons.bootstrap.min.js\"></script><script src=\"https://cdnjs.cloudflare.com/ajax/libs/jszip/2.5.0/jszip.min.js\"></script><script src=\"https://cdn.rawgit.com/bpampuch/pdfmake/0.1.18/build/vfs_fonts.js\"></script><script src=\"https://cdnjs.cloudflare.com/ajax/libs/jszip/2.5.0/jszip.min.js\"></script><script src=\"https://cdn.datatables.net/colreorder/1.5.0/js/dataTables.colReorder.js\"></script></body></html>");
$templateCache.put("templates/delete.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Eliminar</h4></div><div class=\"modal-body\"><p>¿Está seguro que desea eliminar este {{ name }}?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">No</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Sí</button></div></div>");
$templateCache.put("templates/editPolicy.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Editar Pólizas</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><form method=\"post\" name=\"form\" ng-submit=\"submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"col-sm-6 form-group\"><label>Contratantes</label> <input class=\"form-control\" name=\"poliza\" value=\"{{form.natural}}{{form.juridical}}\" type=\"text\" disabled=\"disabled\"></div><div class=\"col-sm-6 form-group\"><label>Número de Póliza</label> <input class=\"form-control\" name=\"poliza\" ng-model=\"form.poliza_number\" type=\"text\"></div><div class=\"col-sm-6 form-group\"><p class=\"row\"><label>Aseguradora actual: {{::form.aseguradora}}</label></p><label>Aseguradora*</label><select class=\"form-control m-b\" ng-model=\"form.aseguradora\" ng-options=\"p.compania for p in providers track by p.url\" ng-change=\"changeProvider(form.aseguradora)\" required=\"\"></select></div><div class=\"col-sm-6 form-group\"><p class=\"row\"><label>Ramo actual: {{::form.ramo}}</label></p><label>Ramo*</label><select class=\"form-control m-b\" ng-model=\"form.ramo\" data-ng-options=\"ramo.ramo_name for ramo in ramos track by ramo.url\" ng-change=\"changeRamos(form.ramo)\" required=\"\"><option value=\"\">Selecciona un ramo</option></select></div><div class=\"col-sm-6 form-group\"><p class=\"row\"><label>Subramos actual: {{::form.subramo}}</label></p><label>Subramos*</label><select class=\"form-control m-b\" ng-model=\"form.subramo\" data-ng-options=\"subramo.subramo_name for subramo in subramos track by subramo.url\" ng-change=\"changeSubramos(form.subramo)\" required=\"\"><option value=\"\">Selecciona un subramo</option></select></div><div class=\"col-sm-6 form-group\"><p class=\"row\"><label>Paquete actual: {{::form.paquete}}</label></p><label>Paquetes*</label><select class=\"form-control m-b\" ng-model=\"form.paquete\" data-ng-options=\"package.package_name for package in paquetes track by package.url\" ng-change=\"changePackage(form.paquete)\" required=\"\"><option value=\"\">Selecciona un paquete</option></select></div><div class=\"col-sm-6 form-group\" id=\"data_2\"><label>Fecha de Inicio</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" name=\"startDate\" ng-model=\"form.start_of_validity\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-sm-6 form-group\" id=\"data_2\"><label>Fecha de Fin</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" name=\"endingDate\" ng-model=\"form.end_of_validity\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-sm-6 form-group\"><p class=\"row\"><label>Forma de pago actual:<tr payment=\"{{::form.forma_de_pago}}\"></tr></label></p><label>Forma de pagos*</label><select class=\"form-control m-b\" ng-model=\"form.forma_de_pago\" data-ng-options=\"s.label for s in payform track by s.value\" required=\"\"><option value=\"\">Selecciona una forma de pago</option></select></div><div class=\"row\"><div class=\"form-group col-sm-12\"><button class=\"btn btn-success\" type=\"button\" ng-disabled=\"form.$invalid\" ng-click=\"saveOT()\">Guardar OT</button> <button class=\"btn btn-success\" type=\"button\" ng-click=\"openModal()\">Crear recibo</button> <button class=\"btn btn-success\" type=\"button\" ng-disabled=\"form.$invalid\" ng-show=\"show.receipt\" ng-click=\"saveInsurance()\">Crear póliza</button></div></div><div class=\"row\"><div class=\"form-group col-sm-12\">Estatus <label status=\"{{form.status}}\" class=\"control-label\"></label></div></div></form></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Cerrar</button></div></div>");
$templateCache.put("templates/forms.html","<div class=\"row\"><div ng-if=\"order.defaults.formInfo.code === 1 || order.defaults.formInfo.code === 30\" ng-include=\"\'templates/template.formulario.vida.html\'\"></div></div><div class=\"row\"><div ng-if=\"order.defaults.formInfo.code === 9\" ng-include=\"\'templates/template.formulario.automoviles.html\'\"></div></div><div class=\"row no-margin\"><div ng-if=\"order.defaults.formInfo.code === 2 || order.defaults.formInfo.code === 3 || order.defaults.formInfo.code === 4\" ng-include=\"\'templates/template.formulario.accidentes.html\'\"></div></div><div class=\"row\"><div ng-if=\"order.defaults.formInfo.code === 5 || order.defaults.formInfo.code === 6 || order.defaults.formInfo.code === 7 || order.defaults.formInfo.code === 8 || order.defaults.formInfo.code === 10 || order.defaults.formInfo.code === 11 || order.defaults.formInfo.code === 12 || order.defaults.formInfo.code === 13 || order.defaults.formInfo.code === 14 || order.defaults.formInfo.code === 31\" ng-include=\"\'templates/template.formulario.danios.html\'\"></div></div>");
$templateCache.put("templates/forms.read.html","<div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Formularios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div ng-if=\"vm.insuranceData.subramo.subramo_code === \'1\'\" ng-include=\"\'templates/template.formulario.vida.html\'\"></div></div><div class=\"row\"><div ng-if=\"vm.insuranceData.subramo.subramo_code === \'9\'\" ng-include=\"\'templates/template.formulario.automoviles.html\'\"></div></div><div class=\"row\"><div ng-if=\"vm.insuranceData.subramo.subramo_code === \'2\' || vm.insuranceData.subramo.subramo_code === \'3\' || vm.insuranceData.subramo.subramo_code === \'4\'\" ng-include=\"\'templates/template.formulario.accidentes.html\'\"></div></div><div class=\"row\"><div ng-if=\"vm.insuranceData.subramo.subramo_code === \'5\' || vm.insuranceData.subramo.subramo_code === \'6\' || vm.insuranceData.subramo.subramo_code === \'7\' || vm.insuranceData.subramo.subramo_code === \'8\' || vm.insuranceData.subramo.subramo_code === \'10\' || vm.insuranceData.subramo.subramo_code === \'11\' || vm.insuranceData.subramo.subramo_code === \'12\' || vm.insuranceData.subramo.subramo_code === \'13\' || vm.insuranceData.subramo.subramo_code === \'14\'\" ng-include=\"\'templates/template.formulario.danios.html\'\"></div></div></div></div></div>");
$templateCache.put("templates/groups.html","<div class=\"col-xs-12\" ng-if=\"order.defaults.policyType == \'Grupal\'\"><div class=\"row\"><div class=\"col-md-5 form-group\"><select name=\"subgroup\" id=\"subgroup\" class=\"form-control\" ng-model=\"order.defaults.subgroup\" ng-change=\"changeSubgroup(order.defaults.subgroup)\"><option value=\"\">Seleccione un subgrupo</option></select></div><div class=\"col-md-2 form-group\"><div class=\"row\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"addSubgroup\">Agregar subgrupo</button></div></div><div class=\"col-md-5 form-group\"><select name=\"category\" id=\"category\" class=\"form-control\" ng-model=\"order.defaults.category\" ng-change=\"changeCategory(order.defaults.category)\"><option value=\"\">Seleccione una categoría</option></select></div><div class=\"col-md-12 col-sm-12 form-group\" ng-if=\"order.defaults.policyType == \'Grupal\'\"><div ng-if=\"order.show.showForms\" ng-include=\"\'templates/forms.html\'\"></div></div><div class=\"col-md-12 col-sm-12 form-group\" ng-if=\"order.defaults.policyType == \'Grupal\'\"><div ng-include=\"\'app/coberturas/coberturas.table.html\'\"></div></div><div class=\"col-md-12 col-sm-6 form-group\" ng-if=\"order.defaults.policyType == \'Grupal\'\"><fieldset><legend class=\"legend-title\" align=\"center\">Observaciones</legend><div class=\"row\"><div class=\"col-xs-12 form-group\"><textarea type=\"text\" class=\"form-control\" ng-model=\"order.form.observations\"></textarea></div></div></fieldset></div><div class=\"col-md-12 col-sm-12 form-group\" ng-if=\"order.defaults.policyType == \'Grupal\'\"><div ng-include=\"\'templates/upload.html\'\"></div><div ng-include=\"\'templates/show-files.html\'\"></div></div><div class=\"col-md-12 col-sm-12 form-group\" ng-hide=\"order.show.ot\" ng-if=\"order.defaults.policyType == \'Grupal\'\"><div ng-include=\"\'app/ordenes/recibos.generic.html\'\"></div></div></div></div>");
$templateCache.put("templates/modal-warning-lock.html","<div idle-countdown=\"countdown\" ng-init=\"countdown=5\" class=\"modal-body\"><div><label class=\"autocomplete-title text-center\">Tu sesión expirará en {{countdown}} segundos.</label></div><div class=\"sk-cube-grid\"><div class=\"sk-cube sk-cube1\"></div><div class=\"sk-cube sk-cube2\"></div><div class=\"sk-cube sk-cube3\"></div><div class=\"sk-cube sk-cube4\"></div><div class=\"sk-cube sk-cube5\"></div><div class=\"sk-cube sk-cube6\"></div><div class=\"sk-cube sk-cube7\"></div><div class=\"sk-cube sk-cube8\"></div><div class=\"sk-cube sk-cube9\"></div></div></div>");
$templateCache.put("templates/otInfo.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Ordenes de Trabajo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><table class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>No. Póliza</th><th>Nombres</th><th>Aseguradora</th><th>Estatus</th></tr></thead><tbody><tr ng-repeat=\"poliza in polizas track by $index\"><td>{{poliza.poliza_number}}</td><td>{{poliza.natural}} {{poliza.juridical}}</td><td>{{poliza.aseguradora}}</td><td><p status=\"{{poliza.status}}\"></p></td></tr></tbody></table></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div></div>");
$templateCache.put("templates/show-files.html","<div class=\"col-xs-12\"><div ng-controller=\"showFilesCtrl as vmFiles\"><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"file in vm.files track by $index\"><div class=\"ibox-title\"><h5>Archivo: {{ file.nombre }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><div class=\"table-flex\"><div class=\"row table-row\"><div class=\"table-cell col-xs-12 col-sm-3\"><label>Nombre</label><div><input ng-model=\"item.file.name\" ng-blur=\"uploader.onRename(item)\" onblur=\"blurArchivoCargadoShow(this)\" class=\"form-control display-none\"> <strong>{{ file.nombre }}</strong></div></div><div class=\"table-cell col-xs-12 col-sm-3\"><label>Opciones</label><div><a class=\"btn btn-success btn-bm0\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary btn-bm0\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,vm.files)\" ng-if=\"vmFiles.user.permiso.eliminar && (vm.permiso_administrar_adjuntos || permiso_administrar_adjuntos)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargadoShow(), saveInput = true\" ng-if=\"vm.permiso_administrar_adjuntos || permiso_administrar_adjuntos\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\" ng-if=\"vm.permiso_administrar_adjuntos || permiso_administrar_adjuntos\">Guardar</span> <input type=\"checkbox\" ng-model=\"file.sensible\" ng-if=\"vm.permiso_administrar_adjuntos || permiso_administrar_adjuntos\"><strong>* Archivo sensible</strong></div></div><div class=\"table-cell col-xs-12 col-sm-3\" ng-if=\"fileSinister\"><label>Documento</label><select ng-model=\"file.type_document\" class=\"form-control\" ng-change=\"changeTypeDoc(padecimiento_type)\" disabled=\"\"><option value=\"\" disabled=\"\">Seleccione una opción</option><option value=\"im\">INFORME MÉDICO</option><option value=\"aa\">AVISO DE ACCIDENTE</option><option value=\"re\">RESULTADO DE ESTUDIOS</option><option value=\"in\">INTERPRETACION</option><option value=\"ec\">ESTADO DE CUENTA</option><option value=\"ida\">IDENTIFICACIÓN AFECTADO</option><option value=\"df\">DESGLOCE DE FACTURAS</option><option value=\"ex\">EXPEDIENTE COMPLETO</option><option value=\"fc\">FACTURA</option><option value=\"fq\">FINIQUITO</option><option value=\"ca\">CARTA ACLARATORIA</option><option value=\"cr\">CARTA RECHAZO</option><option value=\"sr\">SOLICITUD DE REEMBOLSO</option><option value=\"cd\">COMPROBANTE DE DOMICILIO</option></select></div></div></div></div></div><table class=\"table table-bordered table hidden-xs hidden-sm float-e-margins\"><h3 class=\"text-center\">Archivos que estan actualmente en la base de datos</h3><thead><tr><th width=\"300px\">Nombre</th><th width=\"400px\">Opciones</th><th ng-if=\"(vm.permiso_archivos || permiso_archivos) && (vm.permiso_administrar_adjuntos || permiso_administrar_adjuntos)\" width=\"200px\"></th><th width=\"300px\" ng-if=\"fileSinister\">Documento</th></tr></thead><tbody><tr ng-repeat=\"file in vm.files track by $index\"><td><input id=\"input_txt_arch\" ng-model=\"file.nombre\" ng-if=\"vm.permiso_administrar_adjuntos || permiso_administrar_adjuntos\" ng-blur=\"vmFiles.rename(file, vm.files)\" onblur=\"blurArchivoCargadoShow(this)\" class=\"form-control display-none\"><p style=\"width:300px;overflow: hidden;white-space: wrap;text-overflow:clip\"><strong>{{ file.nombre }}</strong></p></td><td nowrap=\"\"><a class=\"btn btn-success btn-bm0\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary btn-bm0\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"vmFiles.deleteFile(file,vm.files)\" ng-if=\"vmFiles.user.permiso.eliminar && (vm.permiso_administrar_adjuntos || permiso_administrar_adjuntos)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargadoShow(), saveInput = true\" ng-if=\"vm.permiso_administrar_adjuntos || permiso_administrar_adjuntos\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td><td ng-if=\"(vm.permiso_archivos || permiso_archivos) && (vm.permiso_administrar_adjuntos || permiso_administrar_adjuntos)\"><input type=\"checkbox\" ng-change=\"vmFiles.rename(file, vm.files)\" ng-model=\"file.sensible\"> * Archivo sensible</td><td ng-if=\"fileSinister\"><select ng-model=\"file.type_document\" class=\"form-control\" ng-change=\"changeTypeDoc(padecimiento_type)\" disabled=\"\"><option value=\"\" disabled=\"\">Seleccione una opción</option><option value=\"im\">INFORME MÉDICO</option><option value=\"aa\">AVISO DE ACCIDENTE</option><option value=\"re\">RESULTADO DE ESTUDIOS</option><option value=\"in\">INTERPRETACION</option><option value=\"ec\">ESTADO DE CUENTA</option><option value=\"ida\">ID AFECTADO</option><option value=\"df\">DESGLOCE DE FACTURAS</option><option value=\"ex\">EXPEDIENTE COMPLETO</option><option value=\"fc\">FACTURA</option><option value=\"fq\">FINIQUITO</option><option value=\"ca\">CARTA ACLARATORIA</option><option value=\"cr\">CARTA RECHAZO</option><option value=\"sr\">SOLICITUD DE REEMBOLSO</option><option value=\"cd\">COMPROBANTE DE DOMICILIO</option></select></td></tr></tbody></table></div><script type=\"text/javascript\">\n\n    function renombrarArchivoCargadoShow(){\n\n    console.log(\'renombrarArchivoCargadoShow--\');\n\n      // console.log($(event.target).parent().parent().parent())\n\n      //var strongTag = $(event.target).parent().parent().parent().find(\"td strong\");\n      //var inputTag = $(event.target).parent().parent().parent().find(\"[id=\'input_txt_arch\']\");\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"[id=\'input_txt_arch\']\");\n\n      var btnTag = $(event.target).parent().parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().parent().find(\"td span\");\n\n      btnTag.addClass(\'display-none\');\n      dummy.removeClass(\'display-none\');\n\n\n      inputTag.removeClass(\'display-none\');\n      strongTag.addClass(\'display-none\');\n\n      inputTag.focus();\n    }\n\n    function blurArchivoCargadoShow(){\n      var strongTag = $(event.target).parent().parent().parent().find(\"td strong\");\n      var inputTag = $(event.target);\n      var btnTag = $(event.target).parent().parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().parent().find(\"td span\");\n\n      // btnTag.prop(\'onclick\',null).off(\'click\');\n\n      btnTag.removeClass(\'display-none\');\n      dummy.addClass(\'display-none\');\n\n\n      inputTag.addClass(\'display-none\');\n      strongTag.removeClass(\'display-none\');\n    }\n  </script></div>");
$templateCache.put("templates/show-filesRecepits.html","<br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><div class=\"table-responsive\" ng-controller=\"showFilesCtrl as vmFiles\"><table class=\"table table-bordered\"><thead><tr><th>Archivo</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in vm.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"vmFiles.rename(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-warning\" ng-click=\"vmFiles.delete(file,vm)\" ng-if=\"vmFiles.user.permiso.eliminar\">Borrar</a> <button class=\"btn btn-info\" onclick=\"renombrarArchivoCargado()\" type=\"button\">Renombrar</button> <input type=\"checkbox\" ng-model=\"file.sensible\"><strong>*Archivo sensible</strong> <span class=\"btn btn-success display-none\">Guardar</span></td></tr></tbody></table></div><script type=\"text/javascript\">   \n\n    function renombrarArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n\n      btnTag.addClass(\'display-none\');\n      dummy.removeClass(\'display-none\');\n\n\n      inputTag.removeClass(\'display-none\');\n      strongTag.addClass(\'display-none\');\n\n      inputTag.focus();\n    }\n\n    function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target);\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n\n      // btnTag.prop(\'onclick\',null).off(\'click\');\n\n      btnTag.removeClass(\'display-none\');\n      dummy.addClass(\'display-none\');\n     \n\n      inputTag.addClass(\'display-none\');\n      strongTag.removeClass(\'display-none\');\n    }\n  </script>");
$templateCache.put("templates/template.formulario.accidentes.html","<toaster-container></toaster-container><div class=\"row\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Datos del titular</legend><div class=\"col-xs-12 form-group\"><button type=\"button\" ng-click=\"order.options.disease.fillContractorData()\" class=\"btn btn-success pull-right\">Llenar con datos del contratante</button></div></div><div class=\"row\"><div class=\"data-container\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"order.subforms.disease.first_name\" type=\"text\" ng-change=\"identifier()\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Apellido Paterno <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"order.subforms.disease.last_name\" type=\"text\" ng-change=\"identifier()\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Apellido Materno</label> <input class=\"form-control\" name=\"name\" ng-model=\"order.subforms.disease.second_last_name\" type=\"text\" ng-change=\"identifier()\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de Nacimiento <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"order.subforms.disease.birthdate\" data-date-format=\"mm/dd/yyyy\" ng-paste=\"order.options.disease.checkDate(order.subforms.disease.birthdate,\'{{order.subforms.disease.birthdate}}\',1,$event)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Sexo <span class=\"color-red\">*</span></label><select id=\"gender{{$index}}\" class=\"form-control m-b\" ng-model=\"order.subforms.disease.sex\" ng-options=\"option.value as option.name for option in sex\" ng-change=\"save_info_tab()\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Antigüedad</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"order.subforms.disease.antiguedad\" data-date-format=\"mm/dd/yyyy\" ng-paste=\"order.options.disease.checkDate(order.subforms.disease.antiguedad,\'{{order.subforms.disease.antiguedad}}\',2,$event)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"row\" ng-if=\"order.subforms.disease.relationshipList.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"order.subforms.disease.relationshipList.length == 0\">Quitar Dependiente</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"order.subforms.disease.relationshipList.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Dependientes</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"order.options.disease.relationships.add(order.subforms.disease.relationships)\" type=\"button\">Agregar Dependiente</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"order.options.disease.relationships.add(order.subforms.disease.relationships)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"relationship in order.subforms.disease.relationshipList track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"order.options.disease.relationships.destroy($index,relationship)\">Quitar Dependiente</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"order.options.disease.relationships.destroy($index,relationship)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Dependiente #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"order.options.disease.relationships.add(order.subforms.disease.relationships)\" type=\"button\">Agregar Dependiente</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"order.options.disease.relationships.add(order.subforms.disease.relationships)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"nombre{{$index}}\">Nombre <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"relationship.first_name\" type=\"text\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last{{$index}}\">Apellido Paterno <span class=\"color-red\">*</span></label> <input id=\"last{{$index}}\" name=\"last{{$index}}\" class=\"form-control\" ng-model=\"relationship.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"relationship.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"parentesco{{0}}\">Parentesco <span class=\"color-red\">*</span></label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"relationship.relationship\" ng-change=\"order.options.disease.relationships.selectType(relationship.relationship,\'{{relationship.relationship}}\')\" ng-options=\"r.option for r in order.options.disease.types track by r.option\" options-disabled=\"r.disabled for r in order.options.disease.types\"><option value=\"\" disabled=\"\">Selecciona</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.birthdate\" data-date-format=\"mm/dd/yyyy\" ng-paste=\"order.options.disease.relationships.checkDate(relationship.birthdate,\'{{relationship.birthdate}}\',3,$event,$index)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"gender{{$index}}\">Sexo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"sex as sex.label for sex in order.defaults.sex track by sex.value\" ng-model=\"relationship.sex\"><option value=\"\" disabled=\"\">Selecciona</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Antigüedad</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.antiguedad\" data-date-format=\"mm/dd/yyyy\" ng-paste=\"order.options.disease.relationships.checkDate(relationship.antiguedad,\'{{relationship.antiguedad}}\',4,$event,$index)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div></div>");
$templateCache.put("templates/template.formulario.automoviles.html","<fieldset><legend class=\"legend-title\" align=\"center\">Datos de automóvil</legend><div class=\"ibox float-e-margins\"><form role=\"form\" ng-model=\"order.subforms\"><div class=\"form-group col-xs-12 col-md-12\"><label for=\"brand\">Busqueda rápida</label><autocomplete datasource=\"autocompleteCarsData\" id=\"autocomplete\" model=\"order.subforms.auto.selectedCar\" change=\"order.autocomplete(order.subforms.auto.selectedCar); identifier()\"></autocomplete></div><div class=\"hidden-md hidden-lg col-xs-12 form-group\"><label>Conductor</label><div class=\"form-group\"><input class=\"form-control\" type=\"text\" ng-model=\"order.subforms.auto.driver\" ng-change=\"save_info_tab()\"></div><div class=\"form-group\"><button class=\"btn btn-success col-xs-12\" type=\"button\" ng-click=\"order.setContractor()\">Llenar con datos del contratante</button></div></div><div class=\"hidden-xs hidden-sm col-xs-12 form-group\"><label>Conductor</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" ng-model=\"order.subforms.auto.driver\" ng-change=\"save_info_tab()\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"order.setContractor()\">Llenar con los datos del contratante</button></div></div></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"brand\">Marca <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"brand\" ng-model=\"order.subforms.auto.brand\" type=\"text\" ng-change=\"identifier();year_auto()\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"model\">Modelo</label> <input class=\"form-control\" name=\"model\" ng-model=\"order.subforms.auto.model\" type=\"text\" ng-change=\"identifier();year_auto()\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"year\">Año <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"year for year in order.defaults.years track by year\" ng-model=\"order.subforms.auto.year\" ng-change=\"identifier();year_auto()\"><option value=\"\">Selecciona el modelo</option></select></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"version\">Versión <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"version\" ng-model=\"order.subforms.auto.version\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"serial\">Serie <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"serial\" ng-blur=\"checkNumSerie()\" ng-model=\"order.subforms.auto.serial\" type=\"text\" required=\"\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"engine\">Motor</label> <input class=\"form-control\" name=\"engine\" ng-model=\"order.subforms.auto.engine\" type=\"text\" ng-change=\"save_info_tab()\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"color\">Color</label> <input class=\"form-control\" name=\"color\" ng-model=\"order.subforms.auto.color\" type=\"text\" ng-change=\"save_info_tab()\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"license_plates\">Matrícula</label> <input class=\"form-control\" name=\"license_plates\" ng-model=\"order.subforms.auto.license_plates\" type=\"text\" ng-change=\"save_info_tab()\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"use\">Uso <span class=\"color-red\">*</span></label><select ng-model=\"order.subforms.auto.usage\" ng-options=\"type.id as type.name for type in usages\" class=\"form-control\" ng-change=\"save_info_tab()\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.subforms.auto.usage == 2 || order.subforms.auto.usage == \'2\'\"><label>Tipo de Carga</label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.charge_type\" ng-change=\"save_info_tab();\" name=\"charge_type\" ng-model=\"order.subforms.auto.charge_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"use\">Servicio <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"color\" ng-model=\"order.subforms.auto.service\" type=\"text\" ng-change=\"save_info_tab()\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Estado de Circulación</label><select class=\"form-control\" data-ng-options=\"estado.state for estado in statesArray track by estado.url\" ng-change=\"save_info_tab()\" name=\"state\" ng-model=\"order.subforms.auto.state_circulation\" required=\"\"><option value=\"\">Selecciona un estado</option></select></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Adaptaciones</legend><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\"><label>Monto de adaptación</label> <input class=\"form-control\" type=\"text\" ng-model=\"order.subforms.auto.mont_adjustment\" ng-change=\"save_info_tab()\" format-currency=\"\"></div><div class=\"form-group\"><label>Adaptación</label> <textarea class=\"form-control\" ng-model=\"order.subforms.auto.adjustment\" ng-change=\"save_info_tab()\"></textarea></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\"><label>Monto de equipamiento</label> <input type=\"text\" class=\"form-control\" ng-model=\"order.subforms.auto.mont_special_team\" ng-change=\"save_info_tab()\" format-currency=\"\"></div><div class=\"form-group\"><label>Equipo especial</label> <textarea class=\"form-control\" ng-model=\"order.subforms.auto.special_team\" ng-change=\"save_info_tab()\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Beneficiario Preferente</legend><div class=\"col-xs-12 col-md-6 form-group\"><label>Nombre beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"order.subforms.auto.beneficiary_name\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Dirección beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"order.subforms.auto.beneficiary_address\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>RFC beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"order.subforms.auto.beneficiary_rfc\" maxlength=\"13\"></div></div></div></form></div></fieldset>");
$templateCache.put("templates/template.formulario.danios.html","<fieldset><legend align=\"right\">Datos de inmueble</legend><div class=\"ibox float-e-margins\"><form role=\"form\" ng-model=\"order.subforms\"><div class=\"form-group col-xs-12 col-md-6\"><label>Bien asegurado <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"order.subforms.damage.insured_item\" type=\"text\" ng-change=\"identifier()\"></div><div class=\"form-group col-xs-12 col-md-6\"><label>Detalles</label> <input class=\"form-control\" ng-model=\"order.subforms.damage.item_details\" type=\"text\" ng-change=\"save_info_tab()\"></div><div class=\"form-group col-xs-12 col-md-6\"><label>Direccion</label> <input class=\"form-control\" ng-model=\"order.subforms.damage.item_address\" type=\"text\" ng-change=\"save_info_tab()\"></div></form></div></fieldset>");
$templateCache.put("templates/template.formulario.salud.html","<div class=\"ibox float-e-margins\"><form role=\"form\" ng-model=\"form\"><div class=\"formgroup col-sm-12\"><label for=\"name\">Nombre</label> <input id=\"name\" class=\"form-control\" ng-model=\"subform.first_name\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"middle_name\">Segundo Nombre</label> <input id=\"middle_name\" class=\"form-control\" ng-model=\"form.middle_name\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"last_name\">Apellidos</label> <input id=\"last_name\" class=\"form-control\" ng-model=\"subform.last_name\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"relationship\">Parentesco</label><select class=\"form-control\" ng-model=\"subform.relationship\"><option value=\"\">Selecciona el parentesco</option><option value=\"holder\">Titular</option><option value=\"partner\">Cónyuge</option><option value=\"child\">Hijo(a)</option></select></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"nacimiento\">Fecha de nacimiento</label><div id=\"nacimiento\" class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" id=\"birthdate\" ng-model=\"subform.birthdate\"></div></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"gender\">Sexo</label><div id=\"gender\"><input type=\"radio\" ng-model=\"subform.gender\" name=\"gender\" ng-value=\"\'M\'\">Masculino<br><input type=\"radio\" ng-model=\"subform.gender\" name=\"gender\" ng-value=\"\'F\'\">Femenino</div></div></form></div>");
$templateCache.put("templates/template.formulario.vida.html","<toaster-container></toaster-container><div class=\"row\"><div class=\"data-container\"><legend class=\"legend-title\" align=\"center\">Datos de asegurado</legend><div class=\"row\" ng-if=\"order.subforms.life.aseguradosList.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"order.subforms.life.aseguradosList.length == 0\">Quitar Asegurado</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"order.subforms.life.aseguradosList.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Asegurados</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"order.options.life.asegurados.add();addAsegurado()\" type=\"button\">Agregar Asegurado</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"order.options.life.asegurados.add()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"life_as in order.subforms.life.aseguradosList track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"order.options.life.asegurados.destroy($index,life_as); delAsegurados()\">Quitar Asegurado</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"order.options.life.asegurados.destroy($index,life_as)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Asegurado #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"order.options.life.asegurados.add();addAsegurado()\" type=\"button\">Agregar Asegurado</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"order.options.life.asegurados.add()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div><div class=\"col-xs-12 form-group\"><button type=\"button\" ng-if=\"$index == 0\" ng-click=\"order.options.life.asegurados.fillContractorData()\" class=\"btn btn-success pull-right\">Llenar con datos del contratante</button></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"names_aseg\">Nombre <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"life_as.first_name\" type=\"text\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent\">Apellido Paterno <span class=\"color-red\">*</span></label> <input type=\"text\" ng-model=\"life_as.last_name\" class=\"form-control\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent_1\">Apellido Materno</label> <input type=\"text\" name=\"last_name_dependent_1\" ng-model=\"life_as.second_last_name\" class=\"form-control\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"life_as.birthdate\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\" for=\"sex{{$index}}\"><label for=\"sex{{$index}}\">Sexo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"life_as.sex\" placeholder=\"\" ng-change=\"save_info_tab()\"><option value=\"\">Selecciona una opcion</option><option value=\"M\">MASCULINO</option><option value=\"F\">FEMENINO</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"ant{{$index}}\">Antigüedad</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"life_as.antiguedad\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3form-group\"><label>Fumador <span class=\"color-red\">*</span></label><div><input type=\"radio\" ng-model=\"life_as.smoker\" ng-value=\"\'True\'\" ng-change=\"save_info_tab()\"> Si<br><input type=\"radio\" ng-model=\"life_as.smoker\" ng-value=\"\'False\'\" ng-change=\"save_info_tab()\"> No</div></div></div></div></div><div class=\"row\" ng-if=\"order.subforms.life.beneficiariesList.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"order.subforms.life.beneficiariesList.length == 0\">Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"order.subforms.life.beneficiariesList.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Beneficiarios</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"order.options.life.beneficiary.add();addBeneficiary()\" type=\"button\">Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"order.options.life.beneficiary.add()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"beneficiary in order.subforms.life.beneficiariesList track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button ng-if=\"order.subforms.life.beneficiariesList.length > 1\" type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"order.options.life.beneficiary.destroy($index,beneficiary); delBeneficiary()\">Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"order.options.life.beneficiary.destroy($index,beneficiary)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"order.options.life.beneficiary.add();addBeneficiary()\" type=\"button\">Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"order.options.life.beneficiary.add()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 m-b\"><button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiary.person == 2\" ng-click=\"changePerson(1, beneficiary)\">Fisica</button> <button class=\"btn btn-primary col-xs-6\" ng-if=\"beneficiary.person == 1\" ng-click=\"changePerson(1, beneficiary)\">Fisica</button> <button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiary.person == 1\" ng-click=\"changePerson(2, beneficiary)\">Moral</button> <button class=\"btn btn-primary col-xs-6\" ng-if=\"beneficiary.person == 2\" ng-click=\"changePerson(2, beneficiary)\">Moral</button></div><div ng-if=\"beneficiary.person == 1\"><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"names_dependant\">Nombre <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"names_dependant\" ng-model=\"beneficiary.first_name\" class=\"form-control\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent\">Apellido Paterno <span class=\"color-red\">*</span></label> <input type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent_1\">Apellido Materno</label> <input type=\"text\" name=\"last_name_dependent_1\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"parentesco\">Parentesco <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"parentesco\" ng-model=\"beneficiary.optional_relationship\" class=\"form-control\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"beneficiary.birthdate\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Sexo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"beneficiary.sex\" placeholder=\"\" ng-change=\"save_info_tab()\"><option value=\"\">Selecciona una opcion</option><option value=\"M\">MASCULINO</option><option value=\"F\">FEMENINO</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"ants{{$index}}\">Antigüedad</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"beneficiary.antiguedad\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-md-3 form-group\"><label for=\"ben_percentage\">Porcentaje <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"beneficiary.percentage\" class=\"form-control\" ng-model=\"beneficiary.percentage\" ng-blur=\"percentage_life(beneficiary.percentage,$index,beneficiary)\"></div></div><div ng-if=\"beneficiary.person == 2\"><div class=\"col-xs-6 form-group\"><label for=\"nombre{{$index}}\">Razón Social <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiary.j_name\" type=\"text\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-6 form-group\"><label for=\"nombre{{$index}}\">RFC <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiary.rfc\" type=\"text\" maxlength=\"13\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"antm{{$index}}\">Antigüedad</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"beneficiary.antiguedad\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div></div></div>");
$templateCache.put("templates/upload.html","<div class=\"col-xs-12\"><fieldset><legend class=\"legend-title\" align=\"center\">Cargar Archivos</legend><div filters=\"queueLimit, customFilter\" nv-file-drop=\"\" uploader=\"uploader\"><div class=\"row\"><div class=\"col-xs-12 col-md-9 form-group\"><h3 class=\"text-center\">Archivos a subir ({{ uploader.queue.length }})</h3><p id=\"message\"></p></div><div class=\"col-xs-12 col-sm-4 col-md-3 pull-right form-group\"><label class=\"col-xs-12 btn btn-success\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i> Agregar Archivo <input multiple=\"\" nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploader\" class=\"display-none\" id=\"fileInput\"></label></div><div class=\"col-xs-12 form-group visible-xs-block\"><label ng-if=\"filesContractor\" class=\"col-xs-12 btn btn-default\"><span class=\"fa fa-camera\"></span> <input accept=\"image/*;capture=camera\" multiple=\"\" nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploader\" class=\"display-none\"></label></div><table class=\"table table-stripped hidden-xs hidden-sm\"><thead><tr><th ng-model=\"archivos.headers[0]\">{{archivos.headers[0]}}</th><th ng-model=\"archivos.headers[1]\">{{archivos.headers[1]}}</th><th ng-model=\"archivos.headers[2]\">{{archivos.headers[2]}}</th><th ng-model=\"archivos.headers[3]\">{{archivos.headers[3]}}</th><th ng-if=\"fileSinister\" ng-model=\"archivos.headers[4]\">{{archivos.headers[4]}}</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue track by $index\"><td><input id=\"input_txt_pre\" ng-model=\"item.file.name\" ng-blur=\"uploader.onRename(item)\" onblur=\"blurArchivoPreCargado(this)\" class=\"form-control display-none\"> <strong id=\"label_txt_pre\">{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }}MB</td><td ng-show=\"uploader.isHTML5\" width=\"20%\"><div class=\"progress margin-bottom-0\"><div class=\"progress-bar\" ng-style=\"{ \'width\': item.progress + \'%\' }\" role=\"progressbar\"></div></div></td><td nowrap=\"\"><button class=\"btn btn-danger btn-xs\" ng-click=\"item.remove()\" type=\"button\">Remover</button> <button class=\"btn btn-info btn-xs\" onclick=\"renombrarArchivoPreCargado();\" type=\"button\">Renombrar</button> <input type=\"checkbox\" ng-change=\"changeSensible(item.sensible,$index)\" ng-model=\"item.sensible\"><b>* Archivo sensible</b> <span class=\"btn btn-success btn-xs display-none\">Guardar</span></td><td ng-if=\"fileSinister\"><select ng-model=\"item.padecimiento_type\" class=\"form-control\" ng-change=\"changeTypeDoc(item.padecimiento_type, $index)\"><option value=\"\" disabled=\"\">Seleccione una opción</option><option value=\"im\">INFORME MÉDICO</option><option value=\"aa\">AVISO DE ACCIDENTE</option><option value=\"re\">RESULTADO DE ESTUDIOS</option><option value=\"in\">INTERPRETACION</option><option value=\"ec\">ESTADO DE CUENTA</option><option value=\"ida\">IDENTIFICACIÓN AFECTADO</option><option value=\"df\">DESGLOCE DE FACTURAS</option><option value=\"ex\">EXPEDIENTE COMPLETO</option><option value=\"fc\">FACTURA</option><option value=\"fq\">FINIQUITO</option><option value=\"ca\">CARTA ACLARATORIA</option><option value=\"cr\">CARTA RECHAZO</option><option value=\"sr\">SOLICITUD DE REEMBOLSO</option><option value=\"cd\">COMPROBANTE DE DOMICILIO</option></select></td><td ng-if=\"ibis\"><select ng-model=\"item.padecimiento_type\" class=\"form-control\" ng-change=\"changeTypeDoc(item.padecimiento_type, $index)\"><option value=\"\" disabled=\"\">Seleccione una opción</option><option value=\"1\">Vida</option><option value=\"2\">Gastos Médicos</option><option value=\"3\">Daños</option><option value=\"4\">Automóviles</option></select></td></tr></tbody></table><br><div class=\"col-xs-12\"><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"item in uploader.queue track by $index\"><div class=\"ibox-title\"><h5>{{ archivos.headers[0] }}: <input ng-model=\"item.file.name\" ng-blur=\"uploader.onRename(item)\" onblur=\"blurArchivoPreCargado(this)\" class=\"form-control display-none\"> <strong>{{ item.file.name }}</strong></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-3\"><label>{{ archivos.headers[0] }}</label><div><input ng-model=\"item.file.name\" ng-blur=\"uploader.onRename(item)\" onblur=\"blurArchivoPreCargado(this)\" class=\"form-control display-none\"></div><strong>{{ item.file.name }}</strong></div><div class=\"table-cell col-xs-12 col-sm-3\"><label>{{ archivos.headers[1] }}</label><p ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }}MB</p></div><div class=\"table-cell col-xs-12 col-sm-3\"><label>{{ archivos.headers[2] }}</label><p class=\"margin-bottom-0\" ng-show=\"uploader.isHTML5\"><div class=\"progress margin-bottom-0\"><div class=\"progress-bar\" ng-style=\"{ \'width\': item.progress + \'%\' }\" role=\"progressbar\"></div></div></p></div><div class=\"table-cell col-xs-12 col-sm-3\"><label>{{ archivos.headers[3] }}</label><div nowrap=\"\"><button class=\"btn btn-danger btn-xs\" ng-click=\"item.remove()\" type=\"button\"><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"btn btn-info btn-xs\" onclick=\"renombrarArchivoPreCargado();\" type=\"button\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <span class=\"btn btn-success btn-xs display-none\"><span class=\"glyphicon glyphicon-floppy\"></span></span></div></div><div class=\"table-cell col-xs-12 col-sm-6\" ng-if=\"fileSinister\"><label>{{archivos.headers[4] }}</label><p ng-if=\"fileSinister\"><select ng-model=\"padecimiento_type\" class=\"form-control\" ng-change=\"changeTypeDoc(padecimiento_type)\"><option value=\"\" disabled=\"\">Seleccione una opciÃ³n</option><option value=\"im\">INFORME MÉDICO</option><option value=\"aa\">AVISO DE ACCIDENTE</option><option value=\"re\">RESULTADO DE ESTUDIOS</option><option value=\"in\">INTERPRETACION</option><option value=\"ec\">ESTADO DE CUENTA</option><option value=\"ida\">ID AFECTADO</option><option value=\"df\">DESGLOCE DE FACTURAS</option></select></p></div></div></div></div></div></div></div><script type=\"text/javascript\">\n/*\n        function renombrar(index) {\n        console.log(\'renombrar\');\n\n\n          var test = $(index).attr(\'id\');\n          try{\n            test = test.replace(\'rename_\',\'\')\n          }\n          catch(e){}\n\n          var strongTag = $(event.target).parent().parent().find(\"td strong\");\n          var inputTag = $(event.target).parent().parent().find(\"td input\");\n          var btnTag = $(event.target).parent().parent().find(\"button\");\n          var dummy = $(event.target).parent().parent().find(\"span\");\n\n          btnTag.addClass(\'display-none\');\n          dummy.removeClass(\'display-none\');\n\n          inputTag.removeClass(\'display-none\');\n          strongTag.addClass(\'display-none\');\n          inputTag.focus();\n          inputTag.show();\n        }\n*/\n        function renombrarArchivoPreCargado(){\n\n          var strongTag = $(event.target).parent().parent().find(\"[id=\'label_txt_pre\']\");\n          //find(\"td strong\");\n          var inputTag  = $(event.target).parent().parent().find(\"[id=\'input_txt_pre\']\");\n\n          var btnTag = $(event.target).parent().parent().find(\"button\");\n          var dummy = $(event.target).parent().parent().find(\"td span\");\n\n          btnTag.addClass(\'display-none\');\n          dummy.removeClass(\'display-none\');\n\n\n          inputTag.removeClass(\'display-none\');\n          strongTag.addClass(\'display-none\');\n\n          inputTag.focus();\n        }\n\n        function blurArchivoPreCargado(index){\n          var strongTag = $(event.target).parent().parent().find(\"[id=\'label_txt_pre\']\");\n          var inputTag = $(event.target).parent().parent().find(\"[id=\'input_txt_pre\']\");\n          var btnTag = $(event.target).parent().parent().find(\"button\");\n          var dummy = $(event.target).parent().parent().find(\"td span\");\n          btnTag.removeClass(\'display-none\');\n          dummy.addClass(\'display-none\');\n          inputTag.addClass(\'display-none\');\n          strongTag.removeClass(\'display-none\');\n        }\n        function validateFiles (uploader) {\n          var input = document.getElementById(\'fileInput\');\n          var files = input.files;\n          var totalSize = 0;\n          var errorMessageElement = document.getElementById(\'error-message\');\n          for (var i = 0; i < files.length; i++) {\n              totalSize += files[i].size;\n          }\n          var totalSizeMB = totalSize / (1024 * 1024);\n          if (totalSizeMB > 25) {\n              errorMessageElement.style.display = \'block\';\n              errorMessageElement.textContent = \'La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.\';\n          } else {\n              errorMessageElement.style.display = \'none\'; \n          }\n        };\n        document.getElementById(\'fileInput\').addEventListener(\'change\', function () {\n          const fileInput = document.getElementById(\'fileInput\');\n          const files = fileInput.files;\n          const currentPage = window.location; \n          let totalSize = 0;          \n          for (let i = 0; i < files.length; i++) {\n            totalSize += files[i].size;\n          }\n          const totalSizeMB = totalSize / (1024 * 1024);\n          const message = document.getElementById(\'message\');\n          if (totalSizeMB > 25) {\n            if (currentPage.href.includes(\'campaigns\')) {\n              message.textContent = \'La suma de los archivos seleccionados excede los 25 MB. Por favor, selecciona menos archivos o archivos más pequeños.\';\n              message.style.color = \'red\';\n            }\n          } else {\n              message.textContent = \'Archivos válidos.\';\n              message.style.color = \'green\';\n          }\n        });\n      </script></div></fieldset></div>");
$templateCache.put("app/agenda/agenda.html","<link href=\"bower_components/angular-bootstrap-calendar/dist/css/angular-bootstrap-calendar.min.css\" rel=\"stylesheet\"><script src=\"bower_components/angular-bootstrap-calendar/dist/js/angular-bootstrap-calendar-tpls.min.js\"></script><toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Agenda</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Agenda</strong></li></ol></div></div><div ng-controller=\"AgendaCtrl as vm\" class=\"col-xs-12 m-t\"><legend class=\"legend-title\" style=\"text-transform: capitalize;\">{{ legend_today }}</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-4 text-center\" ng-init=\"changeMonth(0)\"><div class=\"btn-group\"><button class=\"btn btn-primary\" mwl-date-modifier=\"\" date=\"vm.viewDate\" decrement=\"vm.calendarView\" ng-click=\"vm.cellIsOpen = false; changeMonth(-1);\"><i class=\"fa fa-backward\"></i></button> <button class=\"btn btn-default\" mwl-date-modifier=\"\" date=\"vm.viewDate\" set-to-today=\"\" ng-click=\"vm.cellIsOpen = false; changeMonth(0);\">Hoy</button> <button class=\"btn btn-primary\" mwl-date-modifier=\"\" date=\"vm.viewDate\" increment=\"vm.calendarView\" ng-click=\"vm.cellIsOpen = false; changeMonth(1);\"><i class=\"fa fa-forward\"></i></button></div></div><br class=\"visible-xs visible-sm\"><div class=\"col-xs-12 col-sm-4\"><h2 align=\"center\">{{ month_today | uppercase }} / {{ year_today }}</h2></div><br class=\"visible-xs visible-sm\"><div class=\"col-xs-12 col-sm-4 text-center\"><div class=\"btn-group\"><label class=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'year\'\" ng-click=\"vm.cellIsOpen = false\">Año</label> <label class=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'month\'\" ng-click=\"vm.cellIsOpen = false\">Mes</label> <label class=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'week\'\" ng-click=\"vm.cellIsOpen = false\">Semana</label> <label class=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'day\'\" ng-click=\"vm.cellIsOpen = false\">Día</label></div></div></div><br><mwl-calendar events=\"vm.events\" view=\"vm.calendarView\" view-title=\"vm.calendarTitle\" view-date=\"vm.viewDate\" on-event-click=\"vm.eventClicked(calendarEvent)\" on-event-times-changed=\"vm.eventTimesChanged(calendarEvent); calendarEvent.startsAt = calendarNewEventStart; calendarEvent.endsAt = calendarNewEventEnd\" cell-is-open=\"vm.cellIsOpen\" day-view-start=\"06:00\" day-view-end=\"22:59\" day-view-split=\"30\" cell-modifier=\"vm.modifyCell(calendarCell)\" cell-auto-open-disabled=\"true\" on-timespan-click=\"vm.timespanClicked(calendarDate, calendarCell)\"></mwl-calendar><br><br><div class=\"row\" ng-init=\"showTable = false\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.addEvent(); showTable = true;\">Agregar Nuevo Evento</button></div></div><div class=\"row\" ng-show=\"showTable\"><div class=\"col-xs-12\"><h3 align=\"center\">Editar Evento</h3><hr></div><div class=\"col-xs-12\"><table class=\"table table-bordered\"><thead><tr><th>Titulo <span class=\"color-red\">*</span></th><th>Color</th><th>Inicio</th><th>Fin</th><th>Opciones</th></tr></thead><tbody ng-repeat=\"event in vm.events_new track by $index\" on-finish-rendex=\"\"><form name=\"myForm\"><tr><td><input required=\"true\" type=\"text\" class=\"form-control\" ng-model=\"event.title\" ng-change=\"vm.saveLocalstorange()\"></td><td><select class=\"form-control\" ng-model=\"event.color\" ng-options=\"option.name for option in colors\" ng-change=\"vm.saveLocalstorange()\"><option required=\"\" value=\"\" disabled=\"\">Selecciona un color</option></select></td><td><p class=\"input-group\" style=\"max-width: 250px\"><input type=\"text\" class=\"form-control\" readonly=\"\" uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=\"event.startsAt\" ng-change=\"vm.changeInitDate(event, $index)\" is-open=\"event.startOpen\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.toggle($event, \'startOpen\', event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div uib-timepicker=\"\" ng-model=\"event.startsAt\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"true\"></div></td><td><p class=\"input-group\" style=\"max-width: 250px\"><input type=\"text\" class=\"form-control\" readonly=\"\" uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=\"event.endsAt\" is-open=\"event.endOpen\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.toggle($event, \'endOpen\', event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div uib-timepicker=\"\" ng-model=\"event.endsAt\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"true\"></div></td><td><button class=\"btn btn-danger\" ng-click=\"delete(event, $index)\">Eliminar</button></td></tr><tr><td colspan=\"5\"><label>Observaciones<span class=\"color-red\">*</span></label><p class=\"input-group\" style=\"width: 100%\"><input required=\"true\" type=\"text\" class=\"form-control\" ng-model=\"event.observations\" ng-change=\"vm.saveLocalstorange()\"></p></td></tr><tr><td colspan=\"5\"><label>Involucrados<span class=\"color-red\">*</span></label><select required=\"\" id=\"b{{$index}}\" class=\"js-example-basic-multiple form-control\" multiple=\"multiple\" ng-model=\"event.participants\" data-ng-options=\'users.name for users in vm.users | orderBy: \"first_name\" track by users.id\' ng-change=\"vm.saveLocalstorange()\"><option value=\"\"></option></select></td></tr><tr><td colspan=\"5\"><label>Archivos</label><div class=\"col-xs-12 form-group\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"row\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div></td></tr></form></tbody></table><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"vm.saveEvent()\">Guardar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"showTable = false;\">Cancelar</button></div></div></div></div>");
$templateCache.put("app/agenda/agenda.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Evento</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"motivo\">Título: <span class=\"color-red\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"event.title\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"motivo\">Color: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"event.color\" ng-options=\"option.name for option in colors\"><option value=\"\" disabled=\"\">Selecciona un color</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"motivo\">Inicio: <span class=\"color-red\">*</span></label><p class=\"input-group\" style=\"max-width: 250px\"><input type=\"text\" class=\"form-control\" readonly=\"\" uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=\"event.startsAt\" is-open=\"event.startOpen\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.toggle($event, \'startOpen\', event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div uib-timepicker=\"\" ng-model=\"event.startsAt\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"true\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"motivo\">Fin: <span class=\"color-red\">*</span></label><p class=\"input-group\" style=\"max-width: 250px\"><input type=\"text\" class=\"form-control\" readonly=\"\" uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=\"event.endsAt\" is-open=\"event.endOpen\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.toggle($event, \'endOpen\', event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div uib-timepicker=\"\" ng-model=\"event.endsAt\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"true\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><h4>Participantes</h4><span ng-repeat=\"event in event.participants\" on-finish-rendex=\"\"><span>{{ event.user.first_name }} {{ event.user.last_name }}</span><br></span></div><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div></div><table class=\"table table-bordered table\"><h3 class=\"text-center\">Archivos que estan actualmente en la base de datos</h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th width=\"200px\"></th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><input id=\"blur_text\" type=\"text\" ng-model=\"file.nombre\" ng-blur=\"saveFile(file)\" onblur=\"blurArchivoCargado(this)\" class=\"form-control display-none\"> <strong>{{ file.nombre }}</strong></td><td nowrap=\"\"><a class=\"btn btn-success btn-bm0\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary btn-bm0\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,files)\">Borrar</a></td><td><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> * Archivo sensible</td></tr></tbody></table></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"deleteEvent(event)\">Eliminar Evento</button></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"close()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success ladda-button\" ng-click=\"editEvent(event)\" type=\"button\">Guardar Cambios</button></div></div>");
$templateCache.put("app/agentes/conceptos.administrador.html","<div class=\"inmodal\" id=\"modal_in\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">{{title}}</h4></div><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"modal-body\"><div class=\"row\" ng-show=\"nuevo\"><button class=\"btn btn-secondary\" ng-show=\"configuraciones.length >0\" ng-click=\"agregarConfiguracion(false)\">Lista</button><br><div class=\"col-xs-12 form-group\"><label>Título <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"title\" ng-model=\"vm.form.title\"></div><div class=\"col-xs-12 col-sm-6 checkbox\" align=\"center\" style=\"margin-top: 0;\" ng-init=\"change_onetime(1)\"><label><input type=\"radio\" value=\"1\" ng-model=\"vm.form.onetime\" ng-click=\"change_onetime(vm.form.onetime);\"> Una vez</label></div><div class=\"col-xs-12 col-sm-6 checkbox\" align=\"center\"><label><input type=\"radio\" value=\"2\" ng-model=\"vm.form.onetime\" ng-click=\"change_onetime(vm.form.onetime);\"> Recurrente</label></div><div class=\"col-xs-12 form-group\"><label>Aseguradora(s)</label><select id=\"select_provider\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select><div ng-if=\"isEdit\"><ul ng-repeat=\"as in listaNames track by $index\"><li><span>{{as}}</span></li></ul></div></div><div class=\"col-xs-12 form-group\"><label>Ramo(s)</label><select id=\"select_ramo\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option><option value=\"9\">Automóviles</option></select><div ng-if=\"isEdit\"><ul ng-repeat=\"r in select_ramo track by $index\"><li><span ng-if=\"r==1\">Vida</span> <span ng-if=\"r==2\">Accidentes y Enfermedades</span> <span ng-if=\"r==3\">Daños</span> <span ng-if=\"r==9\">Automóviles</span></li></ul></div></div><div class=\"col-xs-12 form-group\"><label>Tipo de Póliza(s)</label><select id=\"select_tipopolizas\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_tipopolizas\" ng-change=\"selectTipoP(select_tipopolizas)\"><option value=\"1\">Individual</option><option value=\"3\">Grupo</option><option value=\"12\">Colectividad/Flotilla</option></select><div ng-if=\"isEdit\"><ul ng-repeat=\"p in select_tipopolizas track by $index\"><li><span ng-if=\"p==1\">Individual</span> <span ng-if=\"p==3\">Grupo</span> <span ng-if=\"p==12\">Flotilla</span></li></ul></div></div><div class=\"col-xs-12 form-group\"><label>Referenciador(es)</label><div class=\"col-xs-12\"><select id=\"select_user\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"user.first_name + \' \' + user.last_name for user in vendedores | orderBy: \'first_name\' track by user.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select><div ng-if=\"isEdit\"><ul ng-repeat=\"rf in referenciadorNames track by $index\"><li><span>{{rf}}</span></li></ul></div></div></div><div ng-repeat=\"concept in conceptos track by $index\"><div class=\"col-xs-6 col-lg-6 col-sm-6\"><label>Concepto</label> <input class=\"form-control\" type=\"text\" ng-model=\"concept.concept\" name=\"\"></div><div class=\"col-xs-6 col-lg-6 col-sm-6\"><label align=\"center\">Cantidad</label><div class=\"col-xs-12\"><select class=\"col-xs-3 form-control\" ng-model=\"concept.tipo_calculo\" ng-options=\"valor.id as valor.name for valor in tipocalculo_options\" ng-change=\"calcularTotales(concept.tipo_calculo)\" style=\"width: 20%;\"></select><input class=\"col-xs-3 form-control\" type=\"text\" ng-model=\"concept.cantidad\" ng-change=\"validateGasto(concept)\" name=\"\" style=\"width: 35%;\"><select class=\"col-xs-4 form-control\" ng-model=\"concept.calculo\" ng-options=\"c.id as c.name for c in calculo_options\" ng-change=\"calcularTotales(concept.calculo)\" style=\"width: 25%;\"></select><button class=\"col-xs-2 btn btn-danger center-block btn-sm\" ng-click=\"removeConcept($index, users[$index].user_info.info_vendedor[0],item)\" ng-if=\"concept.disabled ==false\" ng-model=\"main.btn_all\"><i class=\"fa fa-trash\" aria-hidden=\"true\" style=\"width: 20%;\"></i></button></div></div></div></div><br><div class=\"row\" ng-show=\"!nuevo\"><div class=\"col-xs-12\" ng-show=\"configuraciones.length >0 && !nuevo\"><button class=\"btn btn-secondary\" ng-if=\"!nuevo\" ng-click=\"agregarConfiguracion(true)\">Agregar Configuración</button><br><div class=\"table-responsive hidden-xs hidden-sm\"><table class=\"table table-bordered table-hover\"><thead><tr><th>ID</th><th>Título</th><th>Concepto</th><th>Aseguradora(s)</th><th>Ramo(s)</th><th>Referenciador(es)</th><th>Tipo Póliza(s)</th><th>Tipo</th><th>Cantidad</th><th>Cálculo</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"cnfg in configuraciones track by $index\"><td>{{cnfg.id}}</td><td>{{cnfg.title}}</td><td>{{cnfg.concepto}}</td><td><span ng-repeat=\"asg in cnfg.aseguradoras_lista\"><label for=\"\">{{asg.alias}}</label></span></td><td><span ng-repeat=\"rms in cnfg.ramos\"><label for=\"\" ng-if=\"rms == 1\">Vida</label> <label for=\"\" ng-if=\"rms == 2\">Accidentes y Enfermedades</label> <label for=\"\" ng-if=\"rms == 3\">Daños</label> <label for=\"\" ng-if=\"rms == 9\">automóviles</label></span></td><td><span ng-repeat=\"vn in cnfg.vendedores_lista\"><label for=\"\">{{vn.name}}</label></span></td><td><span ng-repeat=\"tp in cnfg.tipopolizas\"><label for=\"\" ng-if=\"tp == 1\">Individual</label> <label for=\"\" ng-if=\"tp == 3\">Grupo</label> <label for=\"\" ng-if=\"tp == 12\">Flotilla</label></span></td><td><span ng-if=\"cnfg.tipo_calculo ==1\">Moneda</span><span ng-if=\"cnfg.tipo_calculo ==2\">Porcentaje</span></td><td><span ng-if=\"cnfg.tipo_calculo ==1\">{{cnfg.cantidad | currency}}</span> <span ng-if=\"cnfg.tipo_calculo ==2\">{{cnfg.cantidad}}</span></td><td><span ng-if=\"cnfg.calculo ==2 || cnfg.calculo ==\'2\'\">Cargo</span><span ng-if=\"cnfg.calculo ==1 || cnfg.calculo ==\'1\'\">Abono</span></td><td ng-click=\"$event.stopPropagation()\"><button class=\"btn-success btn-sm\" ng-click=\"editConceptos($index, cnfg)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div ng-if=\"vm.show_pag_confs\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div><div class=\"modal-footer\" ng-show=\"nuevo\"><button class=\"btn btn-primary\" ng-if=\"vm.form.id\" ng-click=\"updateConceptos(vm.form)\">Actualizar</button> <button class=\"btn btn-primary\" ng-if=\"!vm.form.id\" ng-click=\"saveConceptos(vm.form)\">Guardar</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Cerrar</button></div><script type=\"text/javascript\">\n    $.fn.modal.Constructor.prototype.enforceFocus = function() {};\n	$(\'#select_user\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n	$(\'#select_ramo\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n	$(\'#select_provider\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n	$(\'#select_tipopolizas\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n    $(\".js-example-tokenizer\").select2({\n        tags: true,\n        tokenSeparators: [\',\', \' \']\n    })\n</script></div>");
$templateCache.put("app/agentes/modal.update.comision.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Actualizar comisión</h4></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"form-group col-sm-11\"><label for=\"motivo\">Comisión: <span class=\"color-red\">*</span></label> <input type=\"text\" oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');\" name=\"comision\" ng-model=\"comision\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"vmm.close()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success\" ng-click=\"vmm.actualizar(comision)\" type=\"button\">Actualizar</button></div>");
$templateCache.put("app/agentes/modal.update.comision_policy.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Actualizar Comisión del Referenciador en la Póliza</h4></div></div><br><div class=\"col-xs-12 form-group\"><div class=\"alert alert-warning alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> Los valores que se cambien afectarán a todos los cálculos relacionados.</div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"form-group col-sm-11\"><label for=\"motivo\">Comisión: <span class=\"color-red\">*</span></label> <input type=\"text\" oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');\" name=\"comision\" ng-model=\"comision\" ng-blur=\"calcular(comision)\" class=\"form-control\"></div><div class=\"col-xs-12\" align=\"center\"><label for=\"\">Comisión Conciliada:</label><b>{{vmmm.recibo_ok.comision_conciliada | currency}}</b><br><label for=\"\">Póliza:</label><span>{{vmmm.recibo_ok.poliza.poliza_number}}</span><br><label for=\"\">Referenciador:</label><span>{{vmmm.referenciador.referenciador.first_name}} {{vmmm.referenciador.referenciador.last_name}}</span><br><label for=\"\">Comisión original:</label><span>{{vmmm.referenciador.comision_vendedor}}%</span><br><label for=\"\">Comisión Final:</label><b>{{vmmm.comision_al_referenciador}}%</b><br></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"vmmm.close()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success\" ng-click=\"vmmm.actualizar(comision)\" *ngif=\"vmmm.comision_al_referenciador\" type=\"button\">Actualizar</button></div>");
$templateCache.put("app/agentes/pago.administrador.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Referenciadores</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Administración de Referenciadores</strong></li></ol></div></div><br><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Usuarios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6\"><div class=\"form-group\"><label for=\"buscador\">Buscador:</label> <input id=\"buscador\" class=\"form-control\" type=\"text\" ng-model=\"busqueda\" placeholder=\"Escribe para buscar...\"></div></div><div class=\"col-xs-12 col-sm-3 pull-right\" ng-if=\"busqueda\"><div class=\"form-group\"><label class=\"invisible\">Todos</label> <button type=\"button\" class=\"btn btn-secondary btn-block\" ng-click=\"buscar(false)\" title=\"Cargar Todos\"><i class=\"fa fa-list\"></i> Todos</button></div></div><div class=\"col-xs-12 col-sm-3 pull-right\" ng-if=\"busqueda\"><div class=\"form-group\"><label class=\"invisible\">Buscar</label> <button type=\"button\" class=\"btn btn-warning btn-block\" ng-click=\"buscar(true)\" title=\"Aplicar búsqueda\"><i class=\"fa fa-search\"></i>Buscar</button></div></div></div><div class=\"row\" style=\"margin-bottom: 20px;\"><div class=\"col-md-12 text-right\"><button class=\"btn btn-secondary\" style=\"margin-left: 8px;\" ng-click=\"addConceptosGralesModal()\">Conceptos Generales</button> <button class=\"btn btn-success\" style=\"margin-left: 8px;\" ng-click=\"VendorsReport()\">Reporte de referenciadores</button> <button class=\"btn btn-info\" style=\"margin-left: 8px;\" ng-click=\"agregarReferenciador()\">Agregar +</button></div></div><br><div class=\"alert alert-info\" ng-if=\"users.length === 0\"><i class=\"fa fa-info-circle\"></i> No se encontraron resultados para tu búsqueda.</div><div class=\"row\" ng-if=\"!referenciadorAcapturar\"><div class=\"col-xs-12 form-group\"><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in users track by $index\" ng-init=\"isSeller[$index] = false; main_index = $index\"><legend class=\"legend-title hidden-xs hidden-sm\" ng-if=\"item.user_info.is_vendedor\">{{ item.first_name}} {{ item.last_name }}<div class=\"pull-right\"><span class=\"color-blue pull-right user-title\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], users[$index],1)\">Vendedor</span> <button class=\"btn btn-primary pull-right\" ng-if=\"item.user_info.is_active\" ng-click=\"statusResp(item, 1)\" style=\"margin-right: 10px;\">Desactivar responsable</button> <button class=\"btn btn-success pull-right\" ng-click=\"convertToUser(item)\">Convertir a usuario</button> <button class=\"btn btn-success pull-right\" ng-if=\"!item.user_info.is_active\" ng-click=\"statusResp(item, 2)\" style=\"margin-right: 10px;\">Activar responsable</button></div></legend><legend class=\"legend-title hidden-xs hidden-sm\" ng-if=\"!item.user_info.is_vendedor\">{{ item.first_name}} {{ item.last_name }}<div class=\"pull-right\"><span class=\"color-blue pull-right user-title\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], users[$index],0)\">Usuario</span> <button class=\"btn btn-primary pull-right\" ng-if=\"item.user_info.is_active\" ng-click=\"statusResp(item, 1)\" style=\"margin-right: 10px;\">Desactivar responsable</button> <button class=\"btn btn-success pull-right\" ng-if=\"!item.user_info.is_active\" ng-click=\"statusResp(item, 2)\" style=\"margin-right: 10px;\">Activar responsable</button></div></legend><h2 class=\"legend-title visible-xs-block visible-sm-block\" ng-if=\"item.user_info.is_vendedor\">{{ item.first_name}} {{ item.last_name }}<div class=\"pull-right\"><h4 class=\"color-blue user-title\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], users[$index],1)\">Vendedor</h4><button class=\"btn btn-primary pull-right\" ng-if=\"item.user_info.is_active\" ng-click=\"statusResp(item, 1)\" style=\"margin-right: 10px;\">Desactivar responsable</button> <button class=\"btn btn-success pull-right\" ng-click=\"convertToUser(item)\">Convertir a usuario</button> <button class=\"btn btn-success pull-right\" ng-if=\"!item.user_info.is_active\" ng-click=\"statusResp(item, 2)\" style=\"margin-right: 10px;\">Activar responsable</button></div></h2><h2 class=\"legend-title visible-xs-block visible-sm-block\" ng-if=\"!item.user_info.is_vendedor\">{{ item.first_name}} {{ item.last_name }}<div class=\"pull-right\"><h4 class=\"color-blue user-title\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], users[$index],0)\">Usuario</h4><button class=\"btn btn-primary pull-right\" ng-if=\"item.user_info.is_active\" ng-click=\"statusResp(item, 1)\" style=\"margin-right: 10px;\">Desactivar responsable</button> <button class=\"btn btn-success pull-right\" ng-if=\"!item.user_info.is_active\" ng-click=\"statusResp(item, 2)\" style=\"margin-right: 10px;\">Activar responsable</button></div></h2><div class=\"pull-right m-b\" ng-if=\"item.user_info.is_vendedor\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"verPolizas(item)\">Ver pólizas</a></li><li><a ng-click=\"verFianzas(item)\">Ver fianzas</a></li><li><a ng-click=\"edosCuentas(item)\"><i class=\"fa fa-download\"></i> Recibos en Edo.Cuenta</a></li></ul></div></div><br><br><br><div class=\"row animate\" ng-if=\"item.show_binnacle\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12\"><button class=\"btn btn-success\" ng-click=\"returnToVendedor(item)\"><span class=\"fa fa-reply\"></span> Regresar</button></div><div class=\"col-xs-12 btn-mt\"><div class=\"table-responsive hidden-xs hidden-sm\"><table class=\"table table-bordered table-hover\"><thead><tr><th>ID</th><th>Tipo</th><th>Número</th><th>Contratante</th><th>Aseguradora</th><th>Subramo</th><th>Forma de pago</th><th>Estatus</th><th>Vigencia</th><th>Antigüedad</th></tr></thead><tbody><tr ng-repeat=\"insurance in item.polizas track by $index\"><td>{{insurance.id}}</td><td>{{insurance.document_type}}</td><td>{{ insurance.poliza_number }}{{ insurance.fianza_number }}</td><td><span>{{ insurance.contractor }}</span></td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.subramo }}</td><td>{{insurance.forma_de_pago}}</td><td status=\"{{insurance.status}}\"></td><td>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</td><td ng-if=\"!(insurance.antiguedad > 0)\">0 días</td></tr><tr ng-repeat=\"insurance in vm.search_results track by $index\" ui-sref=\"colectividades.info({polizaId: insurance.id})\" ng-if=\"insurance.document_type == 3\"><td>Colectividad</td><td>{{ insurance.poliza_number }}</td><td><span>{{ insurance.contractor}}</span></td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.subramo }}</td><td payment=\"{{insurance.forma_de_pago}}\"></td><td status=\"{{insurance.status}}\"></td><td>{{ insurance.start_of_validity | date: \'medium\': \'UTC\'}} - {{ insurance.end_of_validity | date: \'medium\': \'UTC\'}}</td><td ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</td><td ng-if=\"!(insurance.antiguedad > 0)\">0 días</td></tr></tbody></table><div ng-if=\"vm.show_pag_policy_v\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div><div class=\"row\" ng-if=\"isSeller[$index]\"><form name=\"form\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de Ingreso:<span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"users[$index].hired_date\" value=\"{{filterDate.startDate}}\" data-date-format=\"mm/dd/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Banco:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"users[$index].bank\" ng-options=\"bank.alias for bank in banks | orderBy: \'alias\' track by bank.url\" required=\"\"><option value=\"\" disabled=\"\">Seleccione un banco</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número de Referencia:<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"users[$index].reference_number\" ng-disabled=\"users[$index].pay_way.key == 4\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Forma de Pago:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"users[$index].pay_way\" ng-options=\"pay_way.val for pay_way in pay_ways | orderBy: \'id\' track by pay_way.key\" required=\"\"><option value=\"\" disabled=\"\">Seleccione una forma de pago</option></select></div><div class=\"col-xs-12 col-md-8 col-lg-6 form-group\"><label>Dirección:<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"users[$index].address\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Correo electrónico:<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" name=\"\" ng-model=\"users[$index].email\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Teléfono:<span class=\"color-red\">*</span></label><div class=\"input-group form-group\"><phonenumber-directive placeholder=\"myPrompt\" model=\"users[$index].phone\"></phonenumber-directive><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"addPhone($index)\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span></div><div class=\"input-group form-group\" ng-repeat=\"item in users[main_index].phones track by $index\" ng-init=\"child_index = $index\"><phonenumber-directive placeholder=\"myPrompt\" model=\"users[main_index].phones[child_index]\"></phonenumber-directive><span class=\"input-group-btn\"><button class=\"btn btn-danger btn-add-contractor\" ng-click=\"deletePhone(main_index, child_index, users[main_index].phones[child_index])\"><i class=\"fa fa-minus\" aria-hidden=\"true\"></i></button></span></div></div><hr><div class=\"col-xs-8 pull-right\"><div class=\"col-xs-3\" style=\"margin-top: 23px;\" ng-if=\"users[$index].user_info.info_vendedor[0].concepts.length >0\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"isSeller[$index] = false;saveConcepts(users[$index].user_info.info_vendedor[0].concepts,users[$index],main_index)\">Guardar</button></div><div class=\"col-xs-3\" style=\"margin-top: 23px;\"><button class=\"col-xs-12 btn btn-secondary pull-right\" ng-click=\"addConcept(users[$index].user_info.info_vendedor[0])\">Agregar concepto</button></div><div class=\"col-xs-8\"></div><div ng-repeat=\"concept in users[$index].user_info.info_vendedor[0].concepts track by $index\"><div class=\"col-xs-6 col-lg-6 col-sm-6\"><label>Concepto</label> <input class=\"form-control\" type=\"text\" ng-model=\"concept.concept\" name=\"\" ng-if=\"concept.disabled ==false\"> <input class=\"form-control\" type=\"text\" ng-model=\"concept.concept\" name=\"\" disabled=\"\" ng-if=\"concept.disabled ==true\"></div><div class=\"col-xs-6 col-lg-6 col-sm-6\"><label align=\"center\">Cantidad</label><div class=\"col-xs-12\"><select class=\"col-xs-3 form-control\" ng-model=\"concept.tipo_calculo\" ng-options=\"valor.id as valor.name for valor in tipocalculo_options\" ng-change=\"calcularTotales(concept.tipo_calculo)\" style=\"width: 20%;\" disabled=\"\" ng-if=\"concept.disabled ==true\"></select><select class=\"col-xs-3 form-control\" ng-model=\"concept.tipo_calculo\" ng-options=\"valor.id as valor.name for valor in tipocalculo_options\" ng-change=\"calcularTotales(concept.tipo_calculo)\" style=\"width: 20%;\" ng-if=\"concept.disabled ==false\"></select><input class=\"col-xs-3 form-control\" type=\"number\" ng-model=\"concept.cantidad\" ng-change=\"validateGasto(concept)\" name=\"\" style=\"width: 35%;\"><select class=\"col-xs-4 form-control\" ng-model=\"concept.calculo\" ng-options=\"c.id as c.name for c in calculo_options\" ng-change=\"calcularTotales(concept.calculo)\" style=\"width: 25%;\" disabled=\"\" ng-if=\"concept.disabled ==true\"></select><select class=\"col-xs-4 form-control\" ng-model=\"concept.calculo\" ng-options=\"c.id as c.name for c in calculo_options\" ng-change=\"calcularTotales(concept.calculo)\" style=\"width: 25%;\" ng-if=\"concept.disabled ==false\"></select><button class=\"col-xs-2 btn btn-danger center-block btn-sm\" ng-click=\"removeConcept($index, users[$index].user_info.info_vendedor[0],item)\" ng-if=\"concept.disabled ==false\" ng-model=\"main.btn_all\"><i class=\"fa fa-trash\" aria-hidden=\"true\" style=\"width: 20%;\"></i></button></div></div></div></div><hr><hr><div class=\"col-xs-12\"><div class=\"col-xs-12 legend-gray\" ng-if=\"item.subramos.length == 0\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"item.subramos.length == 0\">Quitar Subramo</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"item.subramos.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Subramos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addSubramo(main_index)\" type=\"button\">Agregar Subramo</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addSubramo(main_index)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"col-xs-12 address-container\" ng-repeat=\"sub_ramo in item.subramos track by $index\" ng-init=\"main_subramos_index = $index; assignAgain()\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteSubramo(main_index, main_subramos_index, item)\">Quitar Subramo</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts($index, 1)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Subramo #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addSubramo(main_index)\" type=\"button\">Agregar Subramo</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addSubramo(main_index)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora</label><select class=\"form-control\" ng-model=\"sub_ramo.provider\" ng-options=\"provider.compania for provider in aseguradoras | orderBy: \'compania\'\" ng-change=\"changeProvider(sub_ramo, provider)\"><option value=\"\">Todas las aseguradoras</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo</label><select class=\"form-control\" ng-model=\"sub_ramo.ramo\" ng-options=\"ramo.ramo_name for ramo in sub_ramo.ramos | orderBy: \'ramo_name\' track by ramo.id\" ng-change=\"changeRamo(sub_ramo)\"><option value=\"\">Todos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo</label><select class=\"form-control\" ng-model=\"sub_ramo.subramo\" ng-options=\"subramo.subramo_name for subramo in sub_ramo.sub_ramos | orderBy: \'subramo_name\' track by subramo.id\" ng-change=\"changeSubRamo(sub_ramo.subramo)\"><option value=\"\">Todos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Porcentaje de Comisión %</label> <input class=\"form-control\" type=\"text\" name=\"\" minlength=\"1\" maxlength=\"10\" ng-model=\"sub_ramo.comision_percentage\"></div></div></div></form><div class=\"col-xs-12 form-group\"><button class=\"btn btn-success btn-mt pull-right\" ng-if=\"item.user_info.info_vendedor.length == 0\" ng-disabled=\"form.$invalid\" ng-click=\"saveSeller(main_index)\">Guardar como Vendedor</button> <button class=\"btn btn-success btn-mt pull-right\" ng-if=\"item.user_info.info_vendedor.length > 0\" ng-disabled=\"form.$invalid\" ng-click=\"isSeller[$index] = false; saveSeller(main_index)\">Actualizar</button></div></div></li></ul></div></div><div class=\"row\" ng-if=\"referenciadorAcapturar\"><div class=\"col-md-12\"><div class=\"panel panel-default\" style=\"box-shadow: 0 2px 6px rgba(0,0,0,0.1); border-radius: 6px;\"><div class=\"panel-heading text-align-center\" style=\"background-color: #f5f5f5; border-bottom: 1px solid #ddd; padding: 15px 20px;\"><h3 style=\"margin: 0;\">Captura de Referenciador</h3></div><div class=\"panel-body\" style=\"padding: 20px;\"><div class=\"row\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Nombre <span class=\"color-red\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"formulario.userinfo.user.first_name\"></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Apellido paterno <span class=\"color-red\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"formulario.userinfo.user.last_name\"></div><div class=\"col-md-4 form-group\"><label>Teléfono: <span class=\"color-red\">*</span></label><div class=\"input-group form-group\"><phonenumber-directive placeholder=\"myPrompt\" model=\"formulario.userinfo.user.phone\"></phonenumber-directive><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"addPhoneReferenciador()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span></div><div class=\"input-group form-group\" ng-repeat=\"item in formulario.userinfo.user.phones track by $index\" ng-init=\"up_index = $index\"><phonenumber-directive placeholder=\"myPrompt\" model=\"formulario.userinfo.user.phones[up_index]\"></phonenumber-directive><span class=\"input-group-btn\"><button class=\"btn btn-danger btn-add-contractor\" ng-click=\"deletePhoneReferenciador(up_index, formulario.userinfo.user.phones[up_index])\"><i class=\"fa fa-minus\" aria-hidden=\"true\"></i></button></span></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Correo electrónico <span class=\"color-red\">*</span></label> <input type=\"email\" class=\"form-control\" ng-model=\"formulario.email\" placeholder=\"ejemplo@correo.com\"></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Dirección</label> <input type=\"text\" class=\"form-control\" ng-model=\"formulario.address\" placeholder=\"Calle, número, colonia...\"></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Fecha de Ingreso</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"formulario.hired_date\" value=\"{{formulario.hired_date}}\" data-date-format=\"mm/dd/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Banco <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"formulario.bank\" ng-options=\"bank.alias for bank in banks | orderBy: \'alias\' track by bank.url\"><option value=\"\">Seleccione un banco</option></select></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Forma de pago <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"formulario.pay_way\" ng-options=\"pay_way.val for pay_way in pay_ways | orderBy: \'id\' track by pay_way.key\"><option value=\"\" disabled=\"\">Seleccione una forma de pago</option></select></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Número de referencia <span class=\"color-red\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"formulario.reference_number\"></div><hr><div class=\"col-xs-12\"><div class=\"col-xs-3 pull-right\" style=\"margin-top: 13px; margin-bottom: 10px;\"><button class=\"col-xs-12 btn btn-warning pull-right\" ng-click=\"addConceptReferenciador(formulario)\"><strong>Concepto</strong> <i class=\"glyphicon glyphicon-plus\"></i></button></div><hr><div ng-repeat=\"concept in formulario.info_vendedor.concepts track by $index\" class=\"panel panel-default\" style=\"margin-bottom: 15px; border-radius: 6px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); padding: 15px;\"><div class=\"row\"><div class=\"col-md-6 form-group\"><label>Concepto</label> <input type=\"text\" class=\"form-control\" ng-model=\"concept.concept\" ng-disabled=\"concept.disabled\"></div><div class=\"col-md-6\"><label>Cantidad <span class=\"color-red\">*</span></label><div class=\"form-row\" style=\"display: flex; gap: 8px; flex-wrap: wrap; align-items: center;\"><select class=\"form-control\" style=\"flex: 1 1 20%;\" ng-model=\"concept.tipo_calculo\" ng-options=\"valor.id as valor.name for valor in tipocalculo_options\" ng-change=\"calcularTotales(concept.tipo_calculo)\" ng-disabled=\"concept.disabled\"></select><input type=\"number\" class=\"form-control\" style=\"flex: 1 1 30%;\" ng-model=\"concept.cantidad\" ng-change=\"validateGasto(concept)\" placeholder=\"Cantidad\"><select class=\"form-control\" style=\"flex: 1 1 25%;\" ng-model=\"concept.calculo\" ng-options=\"c.id as c.name for c in calculo_options\" ng-change=\"calcularTotales(concept.calculo)\" ng-disabled=\"concept.disabled\"></select><button type=\"button\" class=\"btn btn-danger btn-sm\" style=\"flex: 0 0 auto;\" ng-click=\"removeConceptReferenciador($index)\" ng-if=\"!concept.disabled\" title=\"- Eliminar concepto\"><i class=\"fa fa-trash\"></i></button></div></div></div></div></div><hr><hr><div class=\"col-xs-12\"><div ng-if=\"formulario.subramos.length == 0\" class=\"panel panel-default\" style=\"margin-bottom: 15px; border-radius: 6px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); padding: 15px;\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"formulario.subramos.length == 0\">Eliminar <i class=\"fa fa-minus\" aria-hidden=\"true\"></i></button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"formulario.subramos.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Subramos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addSubramoR($index)\" type=\"button\">Agregar <i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addSubramoR($index)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"col-xs-12 address-container\" ng-repeat=\"sub_ramo in formulario.subramos track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"formulario.subramos.length == 1\" ng-click=\"deleteSubramoR($index, main_subramos_index, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" ng-disabled=\"formulario.subramos.length == 1\" name=\"button\" ng-click=\"vm.deleteSubramoR($index, 1)\">Eliminar <i class=\"glyphicon glyphicon-minus\"></i></button> <span>Subramo #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addSubramoR(main_index)\" type=\"button\">Agregar <i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addSubramoR(main_index)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora</label><select class=\"form-control\" ng-model=\"sub_ramo.provider\" ng-options=\"provider.compania for provider in aseguradoras | orderBy: \'compania\'\" ng-change=\"changeProviderR(sub_ramo, sub_ramo.provider)\"><option value=\"\">Todas las aseguradoras</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo</label><select class=\"form-control\" ng-model=\"sub_ramo.ramo\" ng-options=\"ramo.ramo_name for ramo in sub_ramo.ramos | orderBy: \'ramo_name\' track by ramo.id\" ng-change=\"changeRamoR(sub_ramo)\"><option value=\"\">Todos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo</label><select class=\"form-control\" ng-model=\"sub_ramo.subramo\" ng-options=\"subramo.subramo_name for subramo in sub_ramo.sub_ramos | orderBy: \'subramo_name\' track by subramo.id\" ng-change=\"changeSubRamoR(sub_ramo.subramo)\"><option value=\"\">Todos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Porcentaje de Comisión % <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"\" minlength=\"1\" maxlength=\"10\" ng-model=\"sub_ramo.comision_percentage\"></div></div><br></div><div class=\"col-xs-12 form-group\"><button class=\"btn btn-info btn-mt pull-right\" ng-click=\"saveReferenciador(formulario)\">Guardar</button> <button class=\"btn btn-danger btn-mt\" ng-click=\"cancelarFormulario(formulario)\">Cancelar</button></div></div></div></div></div></div><script>\n  function valida(e){\n      tecla = (document.all) ? e.keyCode : e.which;\n\n      //Tecla de retroceso para borrar, siempre la permite\n      if (tecla==8){\n          return true;\n      }\n          \n      // Patron de entrada, en este caso solo acepta numeros\n      patron =/^[0-9]+([.][0-9]+)?/;\n      tecla_final = String.fromCharCode(tecla);\n      // return patron.test(tecla_final);\n      return tecla_final;\n  }\n</script></div></div>");
$templateCache.put("app/agentes/pago.agentes.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Referenciadores</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Pago a Referenciador</strong></li></ol></div></div><div class=\"ibox float-e-margins\"><br><div class=\"ibox-title\"><h5>Pago a Referenciadores</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-init=\"active()\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"Nuevo Estado de Cuenta\" ng-if=\"vm.acceso_pag_ref\"><div ng-include=\"\'app/agentes/pago.nuevo.html\'\"></div></uib-tab><uib-tab index=\"1\" heading=\"Estados de Cuenta\" ng-if=\"vm.acceso_pag_ref\" ng-click=\"update_states_table(1)\"><div ng-include=\"\'app/agentes/pago.estado.html\'\"></div></uib-tab></uib-tabset></div></div>");
$templateCache.put("app/agentes/pago.enviarMail.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Enviar Estado de Cuenta</h4></div><div class=\"modal-body\"><div class=\"row\"><div ng-if=\"!vm.show_binnacle\"><div class=\"col-xs-12\"><h4>Por favor ingrese el o los correo(s) electrónico(s) a quien se desea enviar:</h4><div class=\"col-xs-12 form-group\"><label>Correo electrónico <span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" name=\"email_assigns\" ng-model=\"email_assigns\" type=\"email\" required=\"\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"addEmail(email_assigns)\">Agregar</button></div></div></div><div class=\"col-xs-12 form-group\"><label>Asunto <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"subject\" type=\"text\"></div><div class=\"col-xs-12 form-group\"><label>Mensaje <span class=\"color-red\">*</span></label> <textarea class=\"col-xs-12 form-control textarea-modal\" ng-model=\"message\"></textarea></div><div class=\"text-align-center\" ng-if=\"stateaccount.id && !adjFiles\"><button class=\"btn btn-secondary\" type=\"button\" ng-click=\"adjFilesOK(true)\" title=\"Deberá guardar los archivos para poder ser adjuntados en el correo\">Adjuntar/Ver Archivos</button></div><div class=\"col-xs-12 row\" ng-if=\"adjFiles\"><div upload-template=\"\"></div><label class=\"color-blue\" align=\"center\">Deberá guardar los archivos para poder ser adjuntados en el correo</label><div class=\"text-align-center\" ng-if=\"uploader.queue.length > 0\"><button class=\"btn btn-primary\" type=\"button\" name=\"savefiles\" title=\"Click aquí y los archivos podrán ser adjuntados en el correo\" ng-click=\"saveFiles(stateaccount.id)\">Guardar archivos</button></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th width=\"20px\">Adjuntar</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"vmFiles.rename(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,files)\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</button> <span class=\"btn btn-success display-none\">Guardar</span></td><td><input type=\"checkbox\" ng_model=\"file.checked\" ng-change=\"shareFileEmail(file)\"></td></tr></tbody></table></div></div><div class=\"text-align-center\" ng-if=\"adjFiles\"><button class=\"btn btn-secondary\" type=\"button\" ng-click=\"adjFilesOK(false)\">Ocultar Archivos</button></div></div><div class=\"col-xs-12 form-group\"><label>Se enviara a:</label><table class=\"table table-bordered\"><thead><th>Correo electrónico</th></thead><tr ng-repeat=\"email in emails\"><td>{{email}}</td></tr></table></div><div class=\"col-xs-12 form-group\"><button class=\"btn btn-primary ladda-button\" ng-disabled=\"\" ng-click=\"sendEmail(subject, message)\">Compartir por correo electrónico</button></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div></div>");
$templateCache.put("app/agentes/pago.estado.html","<style>\n      .ref-filter-panel {\n        padding: 1.25rem 1.5rem;\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        gap: 0.85rem;\n        background: #fff;\n        border: 1px solid #e1e5ec;\n        border-radius: 0.5rem;\n        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n      }\n\n      .ref-filter-panel .form-group {\n        flex: 1 1 360px;\n        min-width: 320px;\n        margin-bottom: 0;\n      }\n\n      .ref-filter-panel label {\n        display: block;\n        font-weight: 600;\n        margin-bottom: 0.15rem;\n      }\n\n      .ref-filter-panel .form-control {\n        width: 100%;\n        min-width: 200px;\n      }\n\n      .ref-filter-panel .btn {\n        border-radius: 0.35rem;\n        min-height: 40px;\n      }\n\n      .ref-filter-panel .btn-primary {\n        background-color: #00a69c;\n        border-color: #00a69c;\n        align-self: flex-end;\n        margin-top: 0.35rem;\n      }\n\n      .ref-filter-panel .btn-default {\n        border-color: #d9dde0;\n        color: #363636;\n        margin-top: 0.35rem;\n      }\n\n      .ref-filter-panel .btn-group {\n        display: flex;\n        gap: 0.5rem;\n        margin-top: 0.35rem;\n        margin-left: auto;\n      }\n\n      .ref-filter-panel small {\n        display: block;\n        margin-top: 0.35rem;\n        color: #6c757d;\n      }\n\n      .ref-filter-panel .input-group .form-control {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n\n      .ref-filter-panel .input-group-btn .btn {\n        border-left: 1px solid #d9dde0;\n        border-radius: 0 0.35rem 0.35rem 0;\n        padding: 0 0.8rem;\n        height: 45px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        box-shadow: none;\n      }\n\n      .btn-refresh {\n        background-color: #fff;\n        border-color: #e1e5ec;\n        color: #5a5f63;\n        height: 38px;\n        padding: 0 0.65rem;\n        transition: background-color 0.15s ease, border-color 0.15s ease;\n      }\n\n      .btn-refresh:hover:not(:disabled) {\n        background-color: #f4f6fb;\n        border-color: #cdd3db;\n      }\n      .btn-obtener {\n        background-color: #4bb543;\n        border-color: #4bb543;\n        box-shadow: 0 0 0 1px #4bb543 inset, 0 2px 6px rgba(0, 0, 0, 0.16);\n      }\n      .btn-obtener:hover:not(:disabled) {\n        background-color: #44a53c;\n        border-color: #44a53c;\n      }\n\n      .action-row {\n        display: flex;\n        gap: 0.5rem;\n        margin-top: 0.75rem;\n      }\n\n      .action-row.full-width {\n        width: 100%;\n        justify-content: flex-start;\n      }\n\n      .btn-obtener-todos {\n        width: auto;\n        padding: 0 1.25rem;\n        font-size: 0.95rem;\n        text-align: center;\n      }\n\n    </style><div class=\"row animate\"><div class=\"col-xs-12\"><div class=\"panel panel-default\"><div class=\"ref-filter-panel\"><div class=\"form-group\"><label class=\"control-label\">Buscar por Referenciador</label><div class=\"input-group\"><select class=\"form-control\" ng-model=\"stateFilter.referenciador\" ng-options=\"vendor.value as vendor.label for vendor in vendors_data track by vendor.value\"><option value=\"\">Todos los referenciadores</option></select><span class=\"input-group-btn\"><button class=\"btn btn-default btn-refresh\" type=\"button\" ng-click=\"loadReferenciadores()\" ng-disabled=\"vendorsLoading\"><i class=\"fa\" ng-class=\"vendorsLoading ? \'fa-spinner fa-spin\' : \'fa-refresh\'\"></i></button></span></div><small class=\"text-muted\" ng-if=\"vendorsLoading\">Actualizando lista de referenciadores...</small></div><div class=\"action-row\"><button class=\"btn btn-primary btn-obtener\" ng-click=\"buscarEstadosFiltro()\" ng-disabled=\"cargandoResultados\"><i class=\"fa fa-search\"></i> Buscar</button></div><div class=\"action-row full-width\"><button class=\"btn btn-primary btn-obtener btn-obtener-todos\" ng-click=\"obtenerTodosReferenciadores()\" ng-disabled=\"cargandoResultados\"><i class=\"fa fa-users\"></i> Obtener todos</button></div></div></div><style>\n          .loader-above-table {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            padding: 1rem 0;\n            border-bottom: 1px solid #e6e9ed;\n            margin: 0 15px 15px;\n          }\n        </style><div class=\"tabular-wrapper\"><div class=\"loader-above-table\" ng-if=\"cargandoResultados && vm.readyToLoad\"><i class=\"fa fa-cog fa-spin fa-3x\"></i> <span class=\"margin-left-10\">Cargando estados...</span></div><div class=\"tabs-container\" ng-if=\"vm.readyToLoad\"><uib-tabset><uib-tab heading=\"Pre-Aprobado\" id=\"aprobado\" ng-click=\"update_states_table(1,1,busqueda)\"><div class=\"panel-body\" ng-if=\"!show_binnacle\"><div class=\"col-xs-12 col-sm-6\"><div class=\"form-group\"><label for=\"buscador\">Buscador por Folio:</label> <input id=\"buscador\" class=\"form-control\" type=\"text\" ng-model=\"busqueda\" placeholder=\"Escribe para buscar...\" ng-blur=\"states_table_search(1,1,busqueda)\"></div></div><table class=\"table table-bordered table-hover\"><thead><tr><th>Referenciador</th><th>Folio</th><th>A pagar</th><th>Fecha de impresión</th><th>Operación</th></tr></thead><tbody><tr ng-repeat=\"estado in main_estados track by $index\" ng-click=\"viewReceipts(estado)\"><td>{{ estado.vendedor.name }}</td><td>{{ estado.folio }}</td><td>{{ estado.total_final | currency }}</td><td>{{ estado.impresion_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-click=\"shareState(estado)\" ng-if=\"vm.acceso_cor\"><i class=\"fa fa-envelope\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"generarPdf(estado)\"><i class=\"fa fa-file\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"showBinnacle(estado)\"><i class=\"fa fa-comment\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_edos\" class=\"text-center\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina,busqueda)\"></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina,busqueda)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina,busqueda)\"></li></ul></nav></div></div><div class=\"row col-xs-12\"><label class=\"pull-right\"><input type=\"checkbox\" name=\"\" ng-model=\"cerrarRecibos\" ng-click=\"cerrarrecibosenedo(cerrarRecibos)\" ng-change=\"cerrarrecibosenedo(cerrarRecibos)\"><span class=\"col-xs-12 pull-right blue-color\"><b>Cerrar Recibos al Cerrar Pago</b></span></label></div></div></uib-tab><uib-tab heading=\"Rechazados\" id=\"rechazado\" ng-click=\"update_states_table(2,1,busqueda)\"><div class=\"panel-body\" ng-if=\"!show_binnacle\"><div class=\"col-xs-12 col-sm-6\"><div class=\"form-group\"><label for=\"buscador\">Buscador por Folio:</label> <input id=\"buscador\" class=\"form-control\" type=\"text\" ng-model=\"busqueda\" placeholder=\"Escribe para buscar...\" ng-blur=\"states_table_search(2,1,busqueda)\"></div></div><table class=\"table table-bordered table-hover\"><thead><tr><th>Referenciador</th><th>Folio</th><th>A pagar</th><th>Fecha de impresión</th><th>Operación</th></tr></thead><tbody><tr ng-repeat=\"estado in main_estados track by $index\" ng-click=\"viewReceipts(estado)\"><td>{{ estado.vendedor.name }}</td><td>{{ estado.folio }}</td><td>{{ estado.total | currency }}</td><td>{{ estado.impresion_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-click=\"shareState(estado)\" ng-if=\"vm.acceso_cor\"><i class=\"fa fa-envelope\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"generarPdf(estado)\"><i class=\"fa fa-file\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"showBinnacle(estado)\"><i class=\"fa fa-comment\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_edos_rechazados\" class=\"text-center\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina,busqueda)\"></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina,busqueda)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina,busqueda)\"></li></ul></nav></div></div></div></uib-tab><uib-tab heading=\"Cerrados\" id=\"cerrado\" ng-click=\"update_states_table(3,1,busqueda)\"><div class=\"panel-body\" ng-if=\"!show_binnacle\"><div class=\"col-xs-12 col-sm-6\"><div class=\"form-group\"><label for=\"buscador\">Buscador por Folio:</label> <input id=\"buscador\" class=\"form-control\" type=\"text\" ng-model=\"busqueda\" placeholder=\"Escribe para buscar...\" ng-blur=\"states_table_search(3,1,busqueda)\"></div></div><table class=\"table table-bordered table-hover\"><thead><tr><th>Referenciador</th><th>Folio</th><th>A pagar</th><th>Fecha de impresión</th><th>Operación</th></tr></thead><tbody><tr ng-repeat=\"estado in main_estados track by $index\" ng-click=\"viewReceipts(estado)\"><td>{{ estado.vendedor.name }}</td><td>{{ estado.folio }}</td><td>{{ estado.total | currency }}</td><td>{{ estado.impresion_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-click=\"shareState(estado)\" ng-if=\"vm.acceso_cor\"><i class=\"fa fa-envelope\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"generarPdf(estado)\"><i class=\"fa fa-file\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"showBinnacle(estado)\"><i class=\"fa fa-comment\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_edos_cerrados\" class=\"text-center\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina,busqueda)\"></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina,busqueda)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina,busqueda)\"></li></ul></nav></div></div></div></uib-tab></uib-tabset></div><div class=\"row animate\" ng-if=\"show_binnacle\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"returnToProvider()\"><span class=\"fa fa-reply\"></span> Regresar</button></div><div class=\"col-xs-12 btn-mt\"><comments datasource=\"comments_data\" typemodel=\"12\" config=\"comments_config\" idmodel=\"current_state\"></comments></div></div><div class=\"alert alert-info\" ng-if=\"!vm.readyToLoad\">Selecciona un referenciador o elige \"Todos los referenciadores\" para comenzar a consultar estados de cuenta.</div></div></div></div></div>");
$templateCache.put("app/agentes/pago.estadoscuenta.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Estados de Cuenta</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Estados de Cuenta</strong></li></ol></div></div><br><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Usuarios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><br><div class=\"row\"><div class=\"col-xs-12 form-group\"><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in users track by $index\" ng-init=\"isSeller[$index] = false; main_index = $index\"><legend class=\"legend-title hidden-xs hidden-sm\">{{ item.first_name}} {{ item.last_name }}<div class=\"pull-right\"><span class=\"color-blue pull-right user-title\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true; obtenerEstados(isSeller[$index], users[$index],1,$index)\">Estados de Cuenta</span></div></legend><br><div class=\"row\" ng-if=\"isSeller[$index] && main_estados.length >0 && estadoscuenta\"><div><button class=\"btn btn-secondary pull-right\" ng-click=\"obtenerRecibos(isSeller[$index], users[$index],$index,item)\" style=\"margin-right: 10px;\">Recibos Por Pagar</button></div><div class=\"pull-right m-b\" ng-if=\"item.user_info.is_vendedor\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"edosCuentas(item)\"><i class=\"fa fa-download\"></i> Recibos en Edo.Cuenta</a></li></ul></div></div><form name=\"form\"><div class=\"col-xs-12\"><div class=\"tabs-container\"><uib-tabset ng-if=\"!show_binnacle\"><uib-tab heading=\"Estados de Cuenta\"><div class=\"panel-body\"><table class=\"table table-hover\"><thead><tr><th>Estatus</th><th>Referenciador</th><th>Folio</th><th>A pagar</th><th>Fecha de impresión</th><th>Operación</th></tr></thead><tbody><tr ng-repeat=\"estado in main_estados track by $index\" ng-click=\"viewReceipts(estado)\"><td>{{ estado.status }}</td><td>{{ estado.vendedor.name }}</td><td>{{ estado.folio }}</td><td>{{ estado.total_final | currency }}</td><td>{{ estado.impresion_date | date: \'dd/MM/yyyy h:mm:ss a\' : \'UTC\'}}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-click=\"shareState(estado)\" ng-if=\"vm.acceso_cor\"><i class=\"fa fa-envelope\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"generarPdf(estado)\"><i class=\"fa fa-file\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_edos\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div></div></uib-tab></uib-tabset></div></div></form><div class=\"col-xs-12 form-group\"><button class=\"btn btn-success btn-mt pull-right\" ng-if=\"item.user_info.info_vendedor.length == 0\" ng-disabled=\"form.$invalid\" ng-click=\"descargarstados(main_index)\">Excel</button> <button class=\"btn btn-success btn-mt pull-right\" ng-if=\"item.user_info.info_vendedor.length > 0\" ng-disabled=\"form.$invalid\" ng-click=\"isSeller[$index] = false; descargarRecibos(main_index)\">Regresar</button></div></div><div class=\"row\" ng-if=\"isSeller[$index] && main_recibos.length >0 && recibospagar\"><div class=\"pull-right\"><button class=\"btn btn-secondary pull-right\" ng-click=\"obtenerEstados(isSeller[$index], users[$index],$index,item)\" style=\"margin-right: 10px;\">Estados de Cuenta</button></div><form name=\"form\"><div class=\"col-xs-12\"><div class=\"tabs-container\"><uib-tabset ng-if=\"!show_binnacle\"><uib-tab heading=\"Recibos por Pagar\"><div class=\"panel-body\"><table class=\"table table-bordered table-hover\" ng-if=\"!show_detail\"><thead><tr><th>Contratante</th><th>Número de Póliza o Fianza</th><th>Tipo de Recibo</th><th>Período</th><th>Fecha de conciliación</th><th>Moneda</th><th>Tipo cambio</th><th>Endoso</th><th>Prima Neta</th><th ng-if=\"vm.permiso_comisiones\">Comisión Conciliada</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th></tr></thead><tbody><tr ng-repeat=\"sellerReceipt in item.sellerReceipts\" ng-click=\"getInfoPolicy(sellerReceipt)\"><td ng-if=\"sellerReceipt.poliza\"><span class=\"font-weight-bold\">{{sellerReceipt.poliza.contractor}}</span><br><small ng-if=\"sellerReceipt.poliza.type_person ==1\">Persona Física</small> <small ng-if=\"!sellerReceipt.poliza.type_person ==2\">Persona Moral</small></td><td><span class=\"font-weight-bold\" ng-if=\"sellerReceipt.poliza\">Póliza: {{sellerReceipt.poliza.poliza_number}}</span><br><small>Serie: {{sellerReceipt.recibo_numero}}</small></td><td><span>{{sellerReceipt.rtype}}</span></td><td><span>Desde: {{sellerReceipt.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}}</span><br><span>Hasta: {{sellerReceipt.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</span></td><td ng-if=\"sellerReceipt.conciliacion_date\">{{sellerReceipt.conciliacion_date | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td ng-if=\"!sellerReceipt.conciliacion_date\">Sin fecha</td><td>{{f_currency(sellerReceipt)}}</td><td>{{sellerReceipt.rate_exchange}}</td><td>{{sellerReceipt.nendoso}}</td><td>{{sellerReceipt.prima_neta | currency}}</td><td ng-if=\"vm.permiso_comisiones\">{{sellerReceipt.comision_conciliada | currency}}</td><td ng-click=\"$event.stopPropagation()\" ng-if=\"vm.permiso_comisiones\"><span class=\"font-weight-bold\">{{calculateCommission(sellerReceipt.comision_conciliada, sellerReceipt.comision_vendedor, sellerReceipt.cambiar_comision_al_vendedor, sellerReceipt.comision_al_vendedor)}}</span><br><small>{{sellerReceipt.comision_vendedor}}%</small> <button ng-if=\"sellerReceipt.status == 6 && recibos_radio_filter == 1\" class=\"btn-default\" ng-click=\"updateComision(sellerReceipt, item)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table></div></uib-tab></uib-tabset></div></div><div class=\"row\" ng-if=\"!show_detail\"><div class=\"col-xs-12 col-sm-9 pull-right\"><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-6 pull-right\"><label class=\"blue-color\">Conceptos</label><div ng-repeat=\"concept in vend.concepts track by $index\"><div class=\"col-xs-6 col-lg-6 col-sm-6 pull-right\"><div class=\"col-xs-12 border-box-check\"><label>{{concept.concept}}</label> <label ng-if=\"concept.tipo_calculo ==1\">$</label>{{concept.cantidad}} <label ng-if=\"concept.tipo_calculo ==2\">%</label><label ng-if=\"concept.calculo ==1\">Abono</label><label ng-if=\"concept.calculo ==2\">Cargo</label></div></div></div></div></div><div class=\"col-xs-12\"></div><div class=\"row col-xs-12\"><label align=\"center\" style=\"background-color: cadetblue;\" class=\"col-xs-12\">Cálculos Conceptos Generales</label><div class=\"col-xs-12\" ng-if=\"vend.conceptos_grales\"><label class=\"blue-color\">Conceptos Generales</label><div ng-repeat=\"gral in vend.conceptos_grales track by $index\"><div class=\"col-xs-6 col-lg-6 col-sm-6 pull-right\"><div class=\"col-xs-12 border-box-check\"><label>{{gral.concepto}}</label> <label ng-if=\"gral.tipo_calculo ==1\">$</label>{{gral.cantidad}} <label ng-if=\"gral.tipo_calculo ==2\">%</label><label ng-if=\"gral.calculo ==1\">Abono</label><label ng-if=\"gral.calculo ==2\">Cargo</label> <span ng-if=\"gral.calculo ==1\">{{gral.abono_peso | currency}}</span> <span ng-if=\"gral.calculo ==2\">{{gral.cargo_peso | currency}}</span></div></div></div></div><div class=\"col-xs-4\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">SubTotal:</label>{{originalCalculos.subtotal_1 | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Abono(s):</label>{{vend.sumas_bonos | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Cargo(s):</label>{{vend.sumas_cargos | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Total Final al Edo:*</label>{{total_final_1 | currency}}</div></div></div></div></div></div><div class=\"row\" ng-if=\"!show_detail\"><div class=\"col-xs-12 col-sm-5 pull-right\"><div class=\"col-xs-12 form-group\"><button class=\"btn btn-primary\" ng-click=\"selectVendorExcel(item)\" ng-if=\"vm.acceso_rep_cob\">Descargar excel</button></div></div></div></form></div></li></ul></div></div></div></div><script>\n  function valida(e){\n      tecla = (document.all) ? e.keyCode : e.which;\n      //Tecla de retroceso para borrar, siempre la permite\n      if (tecla==8){\n          return true;\n      }          \n      // Patron de entrada, en este caso solo acepta numeros\n      patron =/^[0-9]+([.][0-9]+)?/;\n      tecla_final = String.fromCharCode(tecla);\n      // return patron.test(tecla_final);\n      return tecla_final;\n    }\n</script>");
$templateCache.put("app/agentes/pago.informacion.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Información</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ info_contractor.full_name }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Tipo de Persona:</span><div><span ng-if=\"info_contractor.type_person == \'Fisica\'\">Fisica</span> <span ng-if=\"info_contractor.type_person == \'Moral\'\">Moral</span></div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"info_contractor.birthday\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ info_contractor.birthday | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"info_contractor.date_of_establishment\"><span class=\"blue-color\">Fecha de Constitución:</span><div><span>{{ info_contractor.date_of_establishment | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">RFC:</span><div><span>{{ info_contractor.rfc }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"info_contractor.type_person == \'Fisica\'\"><span class=\"blue-color\">Género:</span><div><span ng-if=\"info_contractor.sex == \'F\'\">FEMENINO</span> <span ng-if=\"info_contractor.sex == \'M\'\">MASCULINO</span></div></div><div class=\"col-xs-12 col-md-8 form-group\"><span class=\"blue-color\">Correo:</span><div><span>{{ info_contractor.email }}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ info_contractor.phone_number | phonenumber }}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Dirección:</span><div><span ng-if=\"info_contractor.address.route\">{{ info_contractor.address.route }}</span> <span ng-if=\"info_contractor.address.street_number\">{{ info_contractor.address.street_number }}</span> <span ng-if=\"info_contractor.address.street_number_int\">Int. {{ info_contractor.address.street_number_int }},</span> <span ng-if=\"info_contractor.address.sublocality\">{{ info_contractor.address.sublocality }},</span> <span ng-if=\"info_contractor.address.administrative_area_level_2\">{{ info_contractor.address.administrative_area_level_2 }},</span> <span ng-if=\"info_contractor.address.administrative_area_level_1\">{{ info_contractor.address.administrative_area_level_1 }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Referencias:</span><div><span>{{ info_contractor.description }}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"legend-title\" align=\"center\">Póliza</legend><div class=\"col-xs-12 form-group\"><div class=\"btn-group pull-right\"><button class=\"btn btn-info dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vmm.acceso_adm_pol\"><a ng-click=\"goToPolicy(info_policy)\">Ver Póliza</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li></ul></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Identificador:</span><div><span>{{ info_policy.identifier }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{ info_policy.poliza_number }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ info_policy.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ info_policy.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ info_policy.aseguradora.alias }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Clave del Agente:</span><div><span>{{info_policy.clave.name}} - {{ info_policy.clave.clave }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ info_policy.ramo }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ info_policy.subramo }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Paquete:</span><div><span>{{ info_policy.paquete }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Comisión:</span><div><span>{{ info_policy.comision | currency }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"info_policy.f_currency == 1\">PESOS</span> <span ng-if=\"info_policy.f_currency == 2\">DOLARES</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span ng-if=\"info_policy.forma_de_pago == 1\">MENSUAL</span> <span ng-if=\"info_policy.forma_de_pago == 2\">BIMESTRAL</span> <span ng-if=\"info_policy.forma_de_pago == 3\">TRIMESTRAL</span> <span ng-if=\"info_policy.forma_de_pago == 6\">SEMESTRAL</span> <span ng-if=\"info_policy.forma_de_pago == 5\">CONTADO</span> <span ng-if=\"info_policy.forma_de_pago == 12\">ANUAL</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ info_policy.observations }}</span></div></div></div><div class=\"row\"><div class=\"form-group col-xs-12\" ng-if=\"showPayRecipt\"><button class=\"btn btn-success pull-right\" ng-click=\"goToPay()\"><i class=\"fa fa-bookmark-o\" aria-hidden=\"true\"></i> Cerrar Pago</button></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"vmm.cancel()\" type=\"button\">Cerrar</button></div></div>");
$templateCache.put("app/agentes/pago.nuevo.html","<div class=\"ibox-content\"><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\"><label>Referenciador</label><select class=\"form-control\" ng-change=\"changeInput();changeVendor(vendors_data,vendor_selected,$index); saveReferenciador(vendor_selected)\" ng-model=\"vendor_selected\" ng-options=\"vendors_data.label for vendors_data in vendors_data | orderBy: \'label\' track by vendors_data.value\"><option value=\"\">Seleccione un referenciador</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\"><label>Aseguradora</label><select class=\"form-control\" ng-model=\"provider\" ng-options=\"provider.id as provider.compania for provider in providers | orderBy: \'compania\'\" ng-change=\"changeProvider(provider); changeInput()\"><option value=\"\" disabled=\"\">Seleccione una aseguradora</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\"><label>Ramo</label><select class=\"form-control\" ng-model=\"ramo\" ng-options=\"ramo.id as ramo.ramo_name for ramo in ramos | orderBy: \'ramo_name\'\" ng-change=\"changeRamo(ramo); changeInput()\" ng-disabled=\"!provider\"><option value=\"\" disabled=\"\">Seleccione un ramo</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\"><label>Subramo</label><select class=\"form-control\" ng-model=\"subramo\" ng-options=\"subramo.id as subramo.subramo_name for subramo in subramos | orderBy: \'subramo_name\'\" ng-change=\"changeSubRamo(subramo)\" ng-disabled=\"!ramo\"><option value=\"\" disabled=\"\">Seleccione un subramo</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Grupos</label><select class=\"form-control\" ng-model=\"group\" ng-options=\"group.group_name for group in groups | orderBy: \'group_name\' track by group.url\" ng-change=\"changeGrupo(group);changeInput()\"><option value=\"\">Seleccione un grupo</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Clave de Agente</label><select class=\"form-control\" ng-model=\"clave\" ng-options=\"clave.id as clave.clave + \' - \' + clave.name for clave in claves | orderBy: \'clave\' track by clave.url\" ng-change=\"changeClave(clave); changeInput()\"><option value=\"\">Seleccione una clave de agente</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Consulta por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport(vm.form.dates_sel); changeInput()\"><option value=\"\">Selecciona una opción</option></select></div><div ng-if=\"dates_selected\"><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" ng-change=\"changeInput()\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"filterDate.startDate\" value=\"{{filterDate.startDate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" ng-change=\"changeInput()\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"filterDate.endDate\" value=\"{{filterDate.endDate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"col-xs-12 form-group\"><hr><div class=\"col-xs-12 col-sm-6 checkbox\" align=\"center\" style=\"margin-top: 0;\" ng-init=\"change_filter_radio(1)\"><label><input type=\"radio\" value=\"1\" ng-model=\"recibos_radio_filter\" ng-click=\"change_filter_radio(recibos_radio_filter); showFilter(); changeInput()\"> Conciliados</label></div><div class=\"col-xs-12 col-sm-6 checkbox\" align=\"center\"><label><input type=\"radio\" value=\"2\" ng-model=\"recibos_radio_filter\" ng-click=\"change_filter_radio(recibos_radio_filter); showFilter(); changeInput()\"> Todos</label></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-success btn-mt\" ng-click=\"showFilter()\">Consultar</button></div></div><div class=\"row\" ng-if=\"show_vendedores\"><legend class=\"legend-title\" align=\"center\">Referenciadores</legend><div class=\"col-xs-12\"><ul class=\"list-group\"><div ng-repeat=\"vnd in vendors_data\"><li class=\"list-group-item\" ng-init=\"vendedor[$index] = false\"><legend class=\"legend-title\" ng-click=\"vendedor[$index] ? vendedor[$index] = false : vendedor[$index] = true; selectVendor(vnd)\">{{ vnd.label }}</legend><div class=\"row\" ng-if=\"vendedor[$index]\"><div class=\"col-xs-12\"><div class=\"col-xs-12\"><label><input type=\"checkbox\" ng-model=\"seleccionartodos\" ng-click=\"seleccionarTodos(seleccionartodos,vnd)\">Deseleccionar/Seleccionar Todos</label></div><table class=\"table table-bordered table-hover\" ng-if=\"!show_detail\"><thead><tr><th ng-if=\"recibos_radio_filter == 1\">Agregar</th><th>Contratante (.)</th><th>Número de Póliza o Fianza</th><th>Tipo de Recibo</th><th>Período</th><th>Fecha de conciliación</th><th>Prima Neta</th><th>Moneda</th><th>Tipo cambio</th><th>Endoso</th><th ng-if=\"vm.permiso_comisiones\">Comisión Conciliada</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th></tr></thead><tbody><tr ng-repeat=\"sellerReceipt in vnd.sellerReceipts\" ng-click=\"getInfoPolicy(sellerReceipt)\"><td ng-if=\"sellerReceipt.status == 6 && recibos_radio_filter == 1\" ng-click=\"$event.stopPropagation()\"><label><input icheck=\"\" type=\"checkbox\" ng-model=\"sellerReceipt_add[sellerReceipt.id]\" ng-checked=\"sellerReceipt_add[sellerReceipt.id]\" ng-click=\"addRecibo_edo(sellerReceipt,vnd);obtenerSoloSeleccionados(vnd.conceptos_grales,vnd.concepts,vnd,originalCalculos);\"></label></td><td ng-if=\"sellerReceipt.poliza\"><span class=\"font-weight-bold\">{{sellerReceipt.poliza.contractor}}</span><br><small ng-if=\"sellerReceipt.poliza.type_person ==1\">Persona Física</small> <small ng-if=\"!sellerReceipt.poliza.type_person ==2\">Persona Moral</small></td><td><span class=\"font-weight-bold\" ng-if=\"sellerReceipt.poliza\">Póliza: {{sellerReceipt.poliza.poliza_number}}</span><br><small>Serie: {{sellerReceipt.recibo_numero}}</small></td><td><span>{{sellerReceipt.rtype}}</span></td><td><span>Desde: {{sellerReceipt.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}}</span><br><span>Hasta: {{sellerReceipt.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</span></td><td ng-if=\"sellerReceipt.conciliacion_date\">{{sellerReceipt.conciliacion_date | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td ng-if=\"!sellerReceipt.conciliacion_date\">Sin fecha</td><td>{{sellerReceipt.prima_neta | currency}}</td><td>{{f_currency(sellerReceipt)}}</td><td>{{sellerReceipt.rate_exchange}}</td><td>{{sellerReceipt.nendoso}}</td><td ng-if=\"vm.permiso_comisiones\">{{sellerReceipt.comision_conciliada | currency}}</td><td ng-click=\"$event.stopPropagation()\" ng-if=\"vm.permiso_comisiones\"><span class=\"font-weight-bold\">{{calculateCommission(sellerReceipt.comision_conciliada, sellerReceipt.comision_vendedor, sellerReceipt.cambiar_comision_al_vendedor, sellerReceipt.comision_al_vendedor)}}</span><br><small>{{sellerReceipt.comision_vendedor}}%</small> <button ng-if=\"sellerReceipt.status == 6 && recibos_radio_filter == 1 && (sellerReceipt.poliza.ref_policy.length==1)\" class=\"btn-default\" ng-click=\"updateComision(sellerReceipt, vnd)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></button> <button ng-if=\"sellerReceipt.status == 6 && recibos_radio_filter == 1 && (sellerReceipt.poliza.ref_policy.length>1)\" class=\"btn-default\" ng-click=\"updateComisionPolicyRef(sellerReceipt, vnd)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div class=\"row\" ng-if=\"!show_detail\"><div class=\"col-xs-12 col-sm-9 pull-right\"><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 pull-right\" style=\"border-bottom:red\"><label align=\"center\" style=\"background-color: steelblue;\" class=\"col-xs-12\">Cálculos Conceptos</label><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Conceptos</label><div ng-repeat=\"concept in vnd.concepts track by $index\"><div class=\"col-xs-8 col-lg-6 col-sm-6 pull-right\"><div class=\"col-xs-12 border-box-check\"><label>{{concept.concept}}</label> <label ng-if=\"concept.tipo_calculo ==1\">$</label>{{concept.cantidad}} <label ng-if=\"concept.tipo_calculo ==2\">%</label><label ng-if=\"concept.calculo ==1\">Abono</label><label ng-if=\"concept.calculo ==2\">Cargo</label><input type=\"checkbox\" ng-model=\"concept.checked\" ng-if=\"concept.id==1\" disabled=\"\" checked=\"\"><input type=\"checkbox\" ng-model=\"concept.checked\" ng-checked=\"concept.checked\" ng-click=\"obtenerSoloSeleccionados(vnd.conceptos_grales,vnd.concepts,vnd,originalCalculos);\"> Aplicar al Edo.<br></div></div></div></div><div class=\"col-xs-6\"><div class=\"col-xs-12 col-sm-8 form-group\"></div></div></div><div class=\"col-xs-12\"></div><div class=\"row col-xs-12\"></div><div class=\"row col-xs-12\"><label align=\"center\" style=\"background-color: cadetblue;\" class=\"col-xs-12\">Cálculos Conceptos Generales</label><div class=\"col-xs-12\" ng-if=\"vnd.conceptos_grales\"><label class=\"blue-color\">Conceptos Generales</label><div ng-repeat=\"gral in vnd.conceptos_grales track by $index\"><div class=\"col-xs-6 col-lg-6 col-sm-6 pull-right\"><div class=\"col-xs-12 border-box-check\"><label>{{gral.concepto}}</label> <label ng-if=\"gral.tipo_calculo ==1\">$</label>{{gral.cantidad}} <label ng-if=\"gral.tipo_calculo ==2\">%</label><label ng-if=\"gral.calculo ==1\">Abono</label><label ng-if=\"gral.calculo ==2\">Cargo</label><input type=\"checkbox\" ng-model=\"gral.checked\" ng-checked=\"gral.checked\" ng-click=\"obtenerSoloSeleccionados(vend.conceptos_grales,vend.concepts,vend,originalCalculos);\"> Aplicar al Edo.<br><span ng-if=\"gral.calculo ==1\">{{gral.abono_peso | currency}}</span> <span ng-if=\"gral.calculo ==2\">{{gral.cargo_peso | currency}}</span></div></div></div></div><div class=\"col-xs-4\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">SubTotal:</label>{{originalCalculos.subtotal_1 | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Abono(s):</label>{{vnd.sumas_bonos | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Cargo(s):</label>{{vnd.sumas_cargos | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Total Final al Edo:*</label>{{total_final_1 | currency}}</div></div></div></div><div class=\"row col-xs-12\"></div><div class=\"row col-xs-12\"></div></div></div><div class=\"row\" ng-if=\"!show_detail\"><div class=\"col-xs-12 col-sm-5 pull-right\"><div class=\"col-xs-12 form-group\"><button class=\"btn btn-primary\" ng-click=\"selectVendorExcel(vnd)\" ng-if=\"vm.acceso_rep_cob\">Descargar excel</button> <button type=\"button\" class=\"col-xs-12 btn btn-success btn-mt ladda-button\" ng-if=\"vnd.sellerReceipts.length >= 0 && vm.acceso_pag_ref\" ng-click=\"print(vnd)\" ng-disabled=\"disabled_cuenta\">Crear Estado de Cuenta</button></div></div></div></div></div></div></li></div></ul></div></div><div class=\"row\" ng-if=\"show_vendedores_1\"><legend class=\"legend-title\" align=\"center\">Referenciador</legend><div class=\"col-xs-12\"><ul class=\"list-group\"><li class=\"list-group-item\" ng-init=\"vendedor[$index] = true\"><legend class=\"legend-title\" ng-click=\"vendedor[$index] ? vendedor[$index] = false : vendedor[$index] = true; selectVendor(vnd)\">{{ vendor_selected.label }}</legend><div class=\"row\" ng-if=\"vendedor[$index]\"><div class=\"col-xs-12\"><div class=\"col-xs-12\"><label><input type=\"checkbox\" ng-model=\"seleccionartodos\" ng-click=\"seleccionarTodos(seleccionartodos,vend)\">Deseleccionar/Seleccionar Todos</label></div><table class=\"table table-bordered table-hover\" ng-if=\"!show_detail\"><thead><tr><th ng-if=\"recibos_radio_filter == 1\">Agregar</th><th>Contratante (*)</th><th>Número de Póliza o Fianza</th><th>Tipo de Recibo</th><th>Período</th><th>Fecha de conciliación</th><th>Moneda</th><th>Tipo cambio</th><th>Endoso</th><th>Prima Neta</th><th ng-if=\"vm.permiso_comisiones\">Comisión Conciliada</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th></tr></thead><tbody><tr ng-repeat=\"sellerReceipt in vend.sellerReceipts\" ng-click=\"getInfoPolicy(sellerReceipt)\"><td ng-if=\"sellerReceipt.status == 6 && recibos_radio_filter == 1\" ng-click=\"$event.stopPropagation()\"><label><input icheck=\"\" type=\"checkbox\" ng-model=\"sellerReceipt_add[sellerReceipt.id]\" ng-checked=\"sellerReceipt_add[sellerReceipt.id]\" ng-click=\"addRecibo_edo(sellerReceipt,vend);obtenerSoloSeleccionados(vend.conceptos_grales,vend.concepts,vend,originalCalculos);\"></label></td><td ng-if=\"sellerReceipt.poliza\"><span class=\"font-weight-bold\">{{sellerReceipt.poliza.contractor}}</span><br><small ng-if=\"sellerReceipt.poliza.type_person ==1\">Persona Física</small> <small ng-if=\"!sellerReceipt.poliza.type_person ==2\">Persona Moral</small></td><td><span class=\"font-weight-bold\" ng-if=\"sellerReceipt.poliza\">Póliza: {{sellerReceipt.poliza.poliza_number}}</span><br><small>Serie: {{sellerReceipt.recibo_numero}}</small></td><td><span>{{sellerReceipt.rtype}}</span></td><td><span>Desde: {{sellerReceipt.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}}</span><br><span>Hasta: {{sellerReceipt.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</span></td><td ng-if=\"sellerReceipt.conciliacion_date\">{{sellerReceipt.conciliacion_date | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td ng-if=\"!sellerReceipt.conciliacion_date\">Sin fecha</td><td>{{f_currency(sellerReceipt)}}</td><td>{{sellerReceipt.rate_exchange}}</td><td>{{sellerReceipt.nendoso}}</td><td>{{sellerReceipt.prima_neta | currency}}</td><td ng-if=\"vm.permiso_comisiones\">{{sellerReceipt.comision_conciliada | currency}}</td><td ng-click=\"$event.stopPropagation()\" ng-if=\"vm.permiso_comisiones\"><span class=\"font-weight-bold\">{{calculateCommission(sellerReceipt.comision_conciliada, sellerReceipt.comision_vendedor, sellerReceipt.cambiar_comision_al_vendedor, sellerReceipt.comision_al_vendedor)}}</span><br><small ng-if=\"sellerReceipt.comision_conciliada_final\" class=\"font-weight-bold\">{{sellerReceipt.comision_conciliada_final}}</small><br><small>{{sellerReceipt.comision_vendedor}}%</small> <button ng-if=\"sellerReceipt.status == 6 && recibos_radio_filter == 1 && (sellerReceipt.poliza.ref_policy.length==1)\" class=\"btn-default\" ng-click=\"updateComision(sellerReceipt, vend)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></button> <button ng-if=\"sellerReceipt.status == 6 && recibos_radio_filter == 1 && (sellerReceipt.poliza.ref_policy.length>1)\" class=\"btn-default\" ng-click=\"updateComisionPolicyRef(sellerReceipt, vend)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div class=\"row\" ng-if=\"!show_detail\"><div class=\"col-xs-12 col-sm-9 pull-right\"><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 pull-right\"><label align=\"center\" style=\"background-color: steelblue;\" class=\"col-xs-12\">Cálculos Conceptos</label><div class=\"col-xs-6 pull-right\"><label class=\"blue-color\">Conceptos</label><div ng-repeat=\"concept in vend.concepts track by $index\"><div class=\"col-xs-6 col-lg-6 col-sm-6 pull-right\"><div class=\"col-xs-12 border-box-check\"><label>{{concept.concept}}</label> <label ng-if=\"concept.tipo_calculo ==1\">$</label>{{concept.cantidad}} <label ng-if=\"concept.tipo_calculo ==2\">%</label><label ng-if=\"concept.calculo ==1\">Abono</label><label ng-if=\"concept.calculo ==2\">Cargo</label> <input type=\"checkbox\" ng-model=\"concept.checked\" ng-click=\"checkRec(concept.checked,concept,vend,$index);calculoConcepts(vend,sellerReceipt_add[sellerReceipt.id],sellerReceipt_add,sellerReceipt)\" ng-if=\"concept.id==1\" disabled=\"\" checked=\"\"><input type=\"checkbox\" ng-model=\"concept.checked\" ng-checked=\"concept.checked\" ng-click=\"obtenerSoloSeleccionados(vend.conceptos_grales,vend.concepts,vend,originalCalculos);\" ng-if=\"concept.id==0\"> Aplicar al Edo.<br></div></div></div></div><div class=\"col-xs-6\"><div class=\"col-xs-12 col-sm-8 form-group\"></div></div></div><div class=\"row col-xs-12\"></div><div class=\"row col-xs-12\"><label align=\"center\" style=\"background-color: cadetblue;\" class=\"col-xs-12\">Cálculos Conceptos Generales</label><div class=\"col-xs-12\" ng-if=\"vend.conceptos_grales\"><label class=\"blue-color\">Conceptos Generales</label><div ng-repeat=\"gral in vend.conceptos_grales track by $index\"><div class=\"col-xs-6 col-lg-6 col-sm-6 pull-right\"><div class=\"col-xs-12 border-box-check\"><label>{{gral.concepto}}</label> <label ng-if=\"gral.tipo_calculo ==1\">$</label>{{gral.cantidad}} <label ng-if=\"gral.tipo_calculo ==2\">%</label><label ng-if=\"gral.calculo ==1\">Abono</label><label ng-if=\"gral.calculo ==2\">Cargo</label><input type=\"checkbox\" ng-model=\"gral.checked\" ng-checked=\"gral.checked\" ng-click=\"obtenerSoloSeleccionados(vend.conceptos_grales,vend.concepts,vend,originalCalculos);\"> Aplicar al Edo.<br><span ng-if=\"gral.calculo ==1\">{{gral.abono_peso | currency}}</span> <span ng-if=\"gral.calculo ==2\">{{gral.cargo_peso | currency}}</span></div></div></div></div><div class=\"col-xs-4\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">SubTotal:</label>{{originalCalculos.subtotal_1 | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Abono(s):</label>{{vend.sumas_bonos | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Cargo(s):</label>{{vend.sumas_cargos | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Total Final al Edo:**</label>{{total_final_1 | currency}}</div></div></div></div><div class=\"row col-xs-12\"></div><div class=\"row col-xs-12\"></div></div></div><div class=\"row\" ng-if=\"!show_detail\"><div class=\"col-xs-12 col-sm-5 pull-right\"><div class=\"col-xs-12 form-group\"><button class=\"btn btn-primary\" ng-click=\"selectVendorExcel(vend)\" ng-if=\"vm.acceso_rep_cob\">Descargar excel</button> <button class=\"col-xs-12 btn btn-success btn-mt ladda-button\" ng-if=\"vend.sellerReceipts.length >= 0 && vm.acceso_pag_ref\" ng-click=\"print(vend)\" ng-disabled=\"disabled_cuenta\">Crear Estado de Cuenta</button></div></div></div></div></div></li></ul></div></div><div class=\"row\" ng-if=\"showTableReceipts && !show_vendedores && !show_vendedores_1\"><legend class=\"legend-title\" align=\"center\">Recibos</legend><div class=\"col-xs-12\"><div ng-if=\"hideInformation\"><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th ng-if=\"recibos_radio_filter == 1\">Agregar</th><th>Contratante (-)</th><th>Número de póliza</th><th>Tipo de recibo</th><th>Periodo</th><th>Fecha de conciliación</th><th>Moneda</th><th>Tipo Cambio</th><th>Endoso</th><th>Prima Neta</th><th ng-if=\"vm.permiso_comisiones\">Comisión conciliada</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th></tr></thead><tbody><tr ng-repeat=\"sellerReceipt in vnd.sellerReceipts\" ng-click=\"showAllInformation(1, sellerReceipt)\"><td ng-if=\"sellerReceipt.status == 6 && recibos_radio_filter == 1\" ng-click=\"$event.stopPropagation()\"><label><input icheck=\"\" type=\"checkbox\" ng-model=\"sellerReceipt_add[sellerReceipt.id]\" ng-checked=\"sellerReceipt_add[sellerReceipt.id]\" ng-click=\"addRecibo_edo(sellerReceipt,vnd);obtenerSoloSeleccionados(vnd.conceptos_grales,vnd.concepts,vnd,originalCalculos);\"></label></td><td><span class=\"font-weight-bold\">{{sellerReceipt.poliza.contractor}}</span><br><small ng-if=\"sellerReceipt.poliza.type_person ==1\">Persona Física</small> <small ng-if=\"!sellerReceipt.poliza.type_person ==2\">Persona Moral</small></td><td><span class=\"font-weight-bold\">Póliza: {{sellerReceipt.poliza.poliza_number}}</span><br><small>Serie: {{sellerReceipt.recibo_numero}}</small></td><td><span ng-if=\"sellerReceipt.receipt_type == 1\">Póliza</span> <span ng-if=\"sellerReceipt.receipt_type == 2\">Endoso</span></td><td><span>Desde: {{sellerReceipt.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}}</span><br><span>Hasta: {{sellerReceipt.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</span></td><td ng-if=\"sellerReceipt.conciliacion_date\">{{sellerReceipt.conciliacion_date | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td ng-if=\"!sellerReceipt.conciliacion_date\">Sin fecha</td><td>{{f_currency(sellerReceipt)}}</td><td>{{sellerReceipt.rate_exchange}}</td><td>{{sellerReceipt.nendoso}}</td><td>{{sellerReceipt.prima_neta | currency}}</td><td ng-if=\"vm.permiso_comisiones\">{{sellerReceipt.comision_conciliada | currency}}</td><td ng-if=\"vm.permiso_comisiones\"><span class=\"font-weight-bold\">{{calculateCommission(sellerReceipt.comision_conciliada, sellerReceipt.comision_vendedor, sellerReceipt.cambiar_comision_al_vendedor, sellerReceipt.comision_al_vendedor)}}</span><br><small>{{sellerReceipt.comision_vendedor}}%</small></td></tr></tbody></table></div><div class=\"row\" ng-if=\"!show_detail\"><div class=\"col-xs-12 col-sm-9 pull-right\"><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 col-sm-4 form-group\"></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-10 pull-right\"><label class=\"blue-color\">Conceptos</label><div ng-repeat=\"concept in vend.concepts track by $index\"><div class=\"col-xs-8 col-lg-8 col-sm-8 pull-right\"><div class=\"col-xs-12 border-box-check\"><label>{{concept.concept}}</label> <label ng-if=\"concept.tipo_calculo ==1\">$</label>{{concept.cantidad}} <label ng-if=\"concept.tipo_calculo ==2\">%</label><label ng-if=\"concept.calculo ==1\">Abono</label><label ng-if=\"concept.calculo ==2\">Cargo</label> <input type=\"checkbox\" ng-model=\"concept.checked\" ng-click=\"checkRec(concept.checked,concept,vend,$index);calculoConcepts(vend,sellerReceipt_add[sellerReceipt.id],sellerReceipt_add,sellerReceipt)\" ng-if=\"concept.id==1\" disabled=\"\" checked=\"\"><input type=\"checkbox\" ng-model=\"concept.checked\" ng-checked=\"concept.checked\" ng-click=\"obtenerSoloSeleccionados(vend.conceptos_grales,vend.concepts,vend,originalCalculos);\" ng-if=\"concept.id==0\"> Aplicar al Edo.<br><span ng-if=\"concept.calculo ==1\">{{concept.abono_peso | currency}}</span> <span ng-if=\"concept.calculo ==2\">{{concept.cargo_peso | currency}}</span></div></div></div></div><div class=\"col-xs-6\"><div class=\"col-xs-12 col-sm-8 form-group\"><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">SubTotal:</label>{{originalCalculos.subtotal_1 | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Abono(s):</label>{{vend.sumas_bonos | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Cargo(s):</label>{{vend.sumas_cargos | currency}}</div><div class=\"col-xs-12 pull-right\"><label class=\"blue-color\">Total Final al Edo:***</label>{{total_final_1 | currency}}</div></div></div></div><div class=\"col-xs-12\"></div></div></div><div class=\"row\" ng-if=\"!show_detail\"><div class=\"col-xs-12 col-sm-5 pull-right\"><div class=\"col-xs-12 form-group\"><button class=\"col-xs-12 btn btn-success btn-mt ladda-button\" ng-if=\"vnd.sellerReceipts.length >= 0 && vm.acceso_pag_ref\" ng-click=\"print(vnd)\" ng-disabled=\"disabled_cuenta\">Crear Estado de Cuenta</button></div></div></div></div></div><div class=\"col-xs-12 animate\" ng-if=\"showInformation\"><button class=\"btn btn-info\" ng-click=\"hideAllInformation()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button><div class=\"btn-mt\" ng-include=\"\'app/agentes/pago.informacion.html\'\"></div></div></div></div>");
$templateCache.put("app/agentes/pago.pagare.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Cerrar Pago</h4></div><div class=\"modal-body\"><div class=\"ibox-content\"><legend class=\"legend-title\" align=\"center\">Combinaciones</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Referenciador:</span><div><span>{{ pay.referenciador }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Aseguradora(s):</span><div ng-repeat=\"aseg in pay.info_recibos.aseguradoras\"><span>{{ aseg }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Ramo(s):</span><div ng-repeat=\"ramo in pay.info_recibos.ramos\"><span>{{ ramo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Subramo(s):</span><div ng-repeat=\"subramo in pay.info_recibos.subramos\"><span>{{ subramo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Grupo(s):</span><div ng-repeat=\"grupo in pay.info_recibos.grupos\"><span>{{ grupo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Clave(s) de Agente(s):</span><div ng-repeat=\"clave in pay.info_recibos.claves\"><span>{{ clave }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Póliza(s):</span><div ng-repeat=\"poliza in pay.info_recibos.polizas\"><span>{{ poliza }}</span></div></div></div><hr><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><label>Referenciador</label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"pay.referenciador\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Fecha</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"pay.fecha\" value=\"{{payments.date}}\" data-date-format=\"mm/dd/yyyy\" ng-disabled=\"inputDisabled\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Banco Destino</label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"pay.banco\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Número de Cuenta</label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"pay.num_cuenta\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Número de transacción <span class=\"color-red\" title=\"El número de transacción es necesario\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"pay.num_transaccion\" ng-disabled=\"inputDisabled\" required=\"\"> <span ng-if=\"!pay.num_transaccion\" class=\"color-red\">El número de transacción es requerido</span></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Importe</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span><input class=\"form-control\" type=\"text\" ng-model=\"pay.importe\" ng-blur=\"validateCantidad(pay.importe)\" ng-init=\"stringToNumber(pay.importe)\"></div></div><div class=\"form-group col-xs-12 col-sm-12\"><label>Observación</label> <textarea class=\"form-control\" ng-model=\"pay.observation\"></textarea></div></div><div class=\"row\" ng-if=\"vm.files\"><div class=\"col-xs-12\"><div class=\"hr-line-dashed\"></div><div upload-template=\"\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\"></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"closePopup()\">Cancelar</button> <button ng-disabled=\"!pay.num_transaccion\" class=\"btn btn-success\" ng-click=\"patchState(pay.status)\">Guardar</button></div></div>");
$templateCache.put("app/agentes/pago.recibos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Referenciadores</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"agentes.agentes\">Pago a Agentes</a></li><li class=\"active\"><strong>Recibos</strong></li></ol></div></div><div class=\"ibox float-e-margins\"><br><div class=\"ibox-title\"><h5>Recibos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><label>Estatus:</label><br><div ng-if=\"current_state.status == 3\" class=\"label\" ng-class=\"{ \'label-success\': 1==1 }\">Cerrado</div><div ng-if=\"current_state.status == 1\" class=\"label\" ng-class=\"{ \'label-warning\': 1==1 }\">Pendiente</div><div ng-if=\"current_state.status == 2\" class=\"label\" ng-class=\"{ \'label-danger\': 1==1 }\">Rechazado</div></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><label>Folio:</label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"current_state.folio\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\" ng-if=\"current_state.date\"><label>Fecha:</label><br><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"current_state.date\" value=\"{{current_state.date}}\" data-date-format=\"mm/dd/yyyy\" disabled=\"\"></div></div><span class=\"form-control\" ng-if=\"current_state.reason_reject\"><b>Razón del rechazo:</b> <i>{{current_state.reason_reject}}</i></span><legend class=\"legend-title\" align=\"center\">Combinaciones</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Referenciador:</span><div><span>{{ current_state.vendedor.name }}</span></div></div><div ng-if=\"current_state.info_recibos.subramos.length > 0 && current_state.info_recibos_account.subramos.length == 0\"><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Aseguradora(s):</span><div ng-repeat=\"aseg in current_state.info_recibos.aseguradoras\"><span>{{ aseg }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Ramo(s):</span><div ng-repeat=\"ramo in current_state.info_recibos.ramos\"><span>{{ ramo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Subramo(s):</span><div ng-repeat=\"subramo in current_state.info_recibos.subramos\"><span>{{ subramo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Grupo(s):</span><div ng-repeat=\"grupo in current_state.info_recibos.grupos\"><span>{{ grupo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Póliza(s):</span><div ng-repeat=\"poliza in current_state.info_recibos.polizas\"><span>{{poliza}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Fecha Inicio:</span><div><span>{{ current_state.info_recibos.desde | date: \"dd/MM/yyyy\" : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Fecha Fin:</span><div><span>{{ current_state.info_recibos.hasta | date: \"dd/MM/yyyy\": \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Clave(s) de Agente(s):</span><div ng-repeat=\"clave in current_state.info_recibos.claves\"><span>{{ clave }}</span></div></div></div><div ng-if=\"current_state.info_recibos_account.subramos.length > 0 && current_state.info_recibos.subramos.length == 0\"><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Aseguradora(s):</span><div ng-repeat=\"aseg in current_state.info_recibos_account.aseguradoras\"><span>{{ aseg }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Ramo(s):</span><div ng-repeat=\"ramo in current_state.info_recibos_account.ramos\"><span>{{ ramo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Subramo(s):</span><div ng-repeat=\"subramo in current_state.info_recibos_account.subramos\"><span>{{ subramo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Grupo(s):</span><div ng-repeat=\"grupo in current_state.info_recibos_account.grupos\"><span>{{ grupo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Póliza(s):</span><div ng-repeat=\"poliza in current_state.info_recibos_account.polizas\"><span>{{poliza}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Fecha Inicio:</span><div><span>{{ current_state.info_recibos_account.desde | date: \"dd/MM/yyyy\" : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Fecha Fin:</span><div><span>{{ current_state.info_recibos_account.hasta | date: \"dd/MM/yyyy\" : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Clave(s) de Agente(s):</span><div ng-repeat=\"clave in current_state.info_recibos_account.claves\"><span>{{ clave }}</span></div></div></div><div ng-if=\"current_state.info_recibos.subramos.length > 0 && current_state.info_recibos_account.subramos.length > 0\"><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Aseguradora(s):</span><div ng-repeat=\"aseg in current_state.info_recibos.aseguradoras\"><span>{{ aseg }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Ramo(s):</span><div ng-repeat=\"ramo in current_state.info_recibos.ramos\"><span>{{ ramo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Subramo(s):</span><div ng-repeat=\"subramo in current_state.info_recibos.subramos\"><span>{{ subramo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Grupo(s):</span><div ng-repeat=\"grupo in current_state.info_recibos.grupos\"><span>{{ grupo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Póliza(s):</span><div ng-repeat=\"poliza in current_state.info_recibos.polizas\"><span>{{poliza}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Fecha Inicio:</span><div><span>{{ current_state.info_recibos.desde | date: \"dd/MM/yyyy\" : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Fecha Fin:</span><div><span>{{ current_state.info_recibos.hasta | date: \"dd/MM/yyyy\": \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Clave(s) de Agente(s):</span><div ng-repeat=\"clave in current_state.info_recibos.claves\"><span>{{ clave }}</span></div></div></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Total Pago:</span><div><span>{{ current_state.total | currency}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><label class=\"blue-color\" align=\"center\">Conceptos:</label><div><div ng-repeat=\"cn in current_state.concepts track by $index\"><label>{{cn.concept}}</label> <label ng-if=\"cn.tipo_calculo ==1\">$</label>{{cn.cantidad}}<label ng-if=\"cn.tipo_calculo ==2\">%</label><label ng-if=\"cn.calculo ==1\">Abono</label><label ng-if=\"cn.calculo ==2\">Cargo</label> <span ng-if=\"cn.checked ==true\"><i class=\"fa fa-check\"></i>Aplica</span> <span ng-if=\"cn.checked ==false\"><i class=\"fa fa-close\"></i>No Aplica</span></div></div></div></div><div class=\"row\"><div ng-if=\"hideInformation\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Contratante</th><th>Número de póliza</th><th>Tipo de recibo</th><th>Periodo</th><th>Prima Neta</th><th ng-if=\"vm.permiso_comisiones\">Comisión conciliada</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th></tr></thead><tbody><tr ng-repeat=\"recibo in current_state.account_state_receipts track by $index\" ng-if=\"current_state.account_state_receipts.length > 0\"><td><span class=\"font-weight-bold\" ng-if=\"recibo.poliza.contractor\">{{ recibo.poliza.contractor }}</span><br><small ng-if=\"recibo.poliza.type_person ==1\">Persona Física</small> <small ng-if=\"recibo.poliza.type_person ==2\">Persona Moral</small></td><td><span class=\"font-weight-bold\">Póliza: {{ recibo.poliza.poliza_number }}</span><br><small>Serie: {{ recibo.recibo_numero }}</small></td><td ng-if=\"recibo.receipt_type == 1\">Póliza</td><td ng-if=\"recibo.receipt_type != 1\">Endoso</td><td><span>Desde: {{ recibo.fecha_inicio | date: \"dd/MM/yyyy\" : \'UTC\'}}</span><br><span>Hasta: {{ recibo.fecha_fin | date: \"dd/MM/yyyy\" : \'UTC\'}}</span></td><td>{{ recibo.prima_neta }}</td><td ng-if=\"vm.permiso_comisiones\">{{ recibo.comision_conciliada | currency }}</td><td ng-if=\"vm.permiso_comisiones\"><span class=\"font-weight-bold\">{{ calculateCommission(recibo.comision_conciliada, recibo.comision_vendedor,recibo.cambiar_comision_al_vendedor,recibo.comision_al_vendedor ) | currency}}</span><br><small>%{{ recibo.comision_vendedor }}</small></td></tr></tbody></table><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\" ng-if=\"current_state.status == 1\"><div class=\"col-xs-12 form-group\"><button class=\"col-xs-12 btn btn-success btn-mt\" ng-click=\"goToPay(current_state, 0)\">Cerrar Pago</button></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\" ng-if=\"current_state.status != 3 && current_state.status != 2\"><div class=\"col-xs-12 form-group\"><button class=\"col-xs-12 btn btn-danger btn-mt\" ng-click=\"goToReject(current_state)\">Rechazar Pago</button></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\" ng-if=\"current_state.status != 1\"><div class=\"col-xs-12 form-group\"><button class=\"col-xs-12 btn btn-primary btn-mt\" ng-click=\"goToPay(current_state, 1)\">Detalles</button></div></div></div></div></div></div></div>");
$templateCache.put("app/agentes/pago.reject.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Cerrar Pago</h4></div><div class=\"modal-body\"><div class=\"ibox-content\"><div><h3>Combinaciones</h3><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-4\"><label class=\"blue-color\">Aseguradora</label><div><span>AIG Seguros S.A. de C.V.</span></div></div><div class=\"form-group col-xs-12 col-sm-4\"><label class=\"blue-color\">Ramo</label><div><span>Daños</span></div></div><div class=\"form-group col-xs-12 col-sm-4\"><label class=\"blue-color\">Subramo</label><div><span>Automóviles</span></div></div><div class=\"form-group col-xs-12 col-sm-4\"><label class=\"blue-color\">Grupo</label><div><span>IMDB</span></div></div><div class=\"form-group col-xs-12 col-sm-4\"><label class=\"blue-color\">Clave del Agente</label><div><span>7851 - GPI AGENTE DE SEGUROS Y FINANZAS</span></div></div><div class=\"form-group col-xs-12 col-sm-4\"><label class=\"blue-color\">Periodo</label><div><span>10/10/2017 - 17/10/2017</span></div></div></div><hr></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><label>Referenciador</label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"pay.referenciador\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Fecha</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"pay.fecha\" value=\"{{payments.date}}\" data-date-format=\"mm/dd/yyyy\" ng-disabled=\"inputDisabled\"></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Banco Destino</label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"pay.banco\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Número de Cuenta</label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"pay.num_cuenta\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Número de transacción</label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"pay.num_transaccion\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Importe</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span><input class=\"form-control\" type=\"text\" ng-model=\"pay.importe\" ng-blur=\"validateCantidad(pay.importe)\" ng-init=\"stringToNumber(pay.importe)\"></div></div></div><div class=\"row\" ng-if=\"vm.files\"><div class=\"col-xs-12\"><div class=\"hr-line-dashed\"></div><div upload-template=\"\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\"></div></div></div><label>Razón del rechazo:</label> <textarea class=\"form-control\" ng-model=\"pay.reason_reject\"></textarea></div></div><div class=\"modal-footer\"><button class=\"btn btn-success\" ng-click=\"patchReject()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Rechazar</button> <button class=\"btn btn-white\" ng-click=\"closePopup()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Cerrar</button></div></div>");
$templateCache.put("app/agrupaciones/agrupacion.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Agrupaciones</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Agrupaciones</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Agrupaciones</h5></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!showGrouping\"><div class=\"panel-body table-over-y animate\"><table class=\"table table-hover table-bordered\"><thead><tr><th>Nombre</th><th>Subagrupaciones</th></tr></thead><tbody><tr ng-repeat=\"item in grupingLevelList track by $index\"><td>{{ item.description }}</td><td><ul ng-repeat=\"sub in item.subgrupos\"><li class=\"col-xs-8\"><b>{{ sub.description }}</b><div ng-repeat=\"subsub in sub.subsubgrupos\"><small>{{ subsub.description }}</small><br></div></li><div class=\"col-xs-4\"><a class=\"btn btn-sm btn-white\" ng-click=\"editSub(item, sub, $index)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a></div></ul></td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"showGrouping\"><div class=\"col-xs-12 form-group\"><legend align=\"center\">{{ groupinglevel.groupinglevel }}</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Subagrupación</label> <input class=\"form-control\" type=\"text\" ng-model=\"groupinglevel.description\"></div><div class=\"address-container\" ng-repeat=\"subsub in groupinglevel.subsubgrupos track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"subsub.url\" ng-click=\"delete(subsub, $index)\">Quitar Subagrupación</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"delete(subsub, $index)\" ng-disabled=\"vm.form.userAddresses.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Subagrupación #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"add()\" type=\"button\">Agregar Subagrupación</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"add()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Subsubagrupación</label> <input type=\"text\" class=\"form-control\" ng-model=\"subsub.description\"></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 m-t pull-right\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"update()\">Guardar</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 m-t pull-right\"><button class=\"btn btn-white col-xs-12\" ng-click=\"close()\">Cancelar</button></div></div></div></div></div></div>");
$templateCache.put("app/aseguradoras/aseguradoras.config.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-9\"><h2>Aseguradoras</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"aseguradoras.aseguradoras\">Aseguradoras</a></li><li class=\"active\"><strong>Configuraciones</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"ibox\" ng-hide=\"true\"><div class=\"ibox-title\"><h5>Ramos</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"panel-body\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><form class=\"form-horizontal\" method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form.name.$invalid && !form.name.$pristine }\"><label class=\"col-sm-2 control-label\">Nombre del ramo*</label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"name\" ng-model=\"vm.form.ramo_name\" required=\"\" type=\"text\"></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.name.$invalid && !form.name.$pristine }\"><label class=\"col-sm-2 control-label\">Código del ramo*</label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"name\" ng-model=\"vm.form.ramo_code\" required=\"\" type=\"text\"></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"form-group col-sm-12\"><button class=\"btn btn-white pull-right\" type=\"button\" ng-click=\"vm.cancel()\">Borrar datos</button> <button class=\"btn btn-success pull-right margin-right-10\" ng-disabled=\"form.$invalid\" type=\"submit\" ng-click=\"vm.save()\">Guardar</button></div></div></form></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title\" ng-if=\"vm.user.permiso.crear\"><h5>Agregar Ramos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><form role=\"form\"><div class=\"row\"><div class=\"col-sm-12\"><h3>Información del Ramo</h3></div></div><div class=\"row\"><div class=\"form-group col-sm-6\"><label for=\"ramo_code\">Código del ramo</label> <input class=\"form-control\" type=\"number\" ng-model=\"vm.ramo_form.ramo_code\"></div><div class=\"form-group col-sm-6\"><label for=\"ramo_name\">Nombre del ramo</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.ramo_form.ramo_name\"></div></div><div class=\"check-element animate-show\" ng-show=\"vm.ramo_form.validRamo()\"><div class=\"row\"><div class=\"col-sm-12\"><h3>Subramos</h3></div></div><div class=\"row\"><div class=\"form-group col-sm-6\"><label for=\"subramo_code\">Codigo del subramo</label> <input id=\"subramo_code\" type=\"number\" class=\"form-control\" ng-model=\"vm.ramo_form.subramo_code\"></div><div class=\"form-group col-sm-6\"><label for=\"subramo_name\">Nombre del subramo</label> <input id=\"subramo_name\" type=\"text\" class=\"form-control\" ng-model=\"vm.ramo_form.subramo_name\"></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><button ng-if=\"vm.user.permiso.crear\" type=\"button\" class=\"btn btn-info btn-block\" ng-click=\"vm.ramo_form.addSubramo(vm.ramo_form.subramo_code,vm.ramo_form.subramo_name)\">Agregar</button></div></div><div class=\"check-element animate-show\" ng-show=\"vm.ramo_form.hasSubramos()\"><div class=\"row\"><div class=\"form-group col-sm-12\"><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th>Subramo ID</th><th>Subramo Nombre</th><th style=\"width=30%;\">Acción</th></tr></thead><tbody><tr ng-repeat=\"subramo in vm.ramo_form.subramos track by $index\"><td>{{subramo.subramo_code}}</td><td>{{subramo.subramo_name}}</td><td><button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.ramo_form.deleteSubramo(subramo)\" ng-if=\"vm.user.permiso.eliminar\">Eliminar</button></td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div class=\"form-group\"><button type=\"button\" ng-click=\"vm.ramo_form.submit()\" ng-disabled=\"!vm.ramo_form.validForm()\" class=\"btn btn-success\" ng-if=\"vm.user.permiso.editar\">>Guardar</button> <button type=\"button\" ng-click=\"vm.ramo_form.cancel()\" class=\"btn\">Cancelar</button></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Ramos y subramos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><table class=\"table table-striped table-bordered table-hover dataTables-example\" datatable=\"ng\"><thead><tr><th>Ramo</th><th>Código del ramo</th></tr></thead><tbody><tr ng-repeat=\"ramo in vm.ramos track by $index\" ng-click=\"vm.editRamoModal(ramo)\"><td>{{ramo.ramo_name}}</td><td>{{ramo.ramo_code}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/aseguradoras/aseguradoras.deleteContact.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Eliminar</h4></div><div class=\"modal-body\"><p></p><h1>¿Está seguro que desea eliminar este contacto?</h1><br\\>El contacto se eliminará aunque no guarde los cambios<p></p></br\\></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">No</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Sí</button></div></div>");
$templateCache.put("app/aseguradoras/aseguradoras.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Aseguradoras</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"aseguradoras.aseguradoras\">Aseguradoras</a></li><li class=\"active\"><strong>Editar</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Información</h5></div><div class=\"ibox-content\"><div class=\"row\"><form method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"col-xs-12 col-md-6 form-group\"><label>Compañia<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"vm.form.compania\" required=\"\" type=\"phone\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Alias<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"alias\" ng-model=\"vm.form.alias\" required=\"\" type=\"phone\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>RFC<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"rfc\" ng-model=\"vm.form.rfc\" required=\"\" type=\"phone\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Teléfono</label><phonenumber-directive model=\"vm.form.phone\"></phonenumber-directive></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Website<span class=\"color-red\">*</span></label><textarea class=\"form-control\" name=\"name\" ng-model=\"vm.form.website\" required=\"\" cols=\"1\" rows=\"1\" style=\"resize: none;\"></textarea></div><div class=\"address-container\" ng-repeat=\"address in vm.address_list track by $index\"><div class=\"col-xs-12 legend-gray btn-mt\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteAddress($index)\" ng-disabled=\"vm.address_list.length <= 1\">Quitar dirección</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteAddress($index)\" ng-disabled=\"vm.address_list.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Dirección #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addAddress()\" type=\"button\">Agregar dirección</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addAddress()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 nopadding form-group\" ng-class=\"{ \'has-error\': form.state.$invalid && !form.state.$pristine }\"><label>Estado<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"estado.state for estado in vm.statesArray track by estado.url\" name=\"state\" ng-model=\"address.administrative_area_level_1\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un estado</option></select></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\" ng-class=\"{ \'has-error\': form.city.$invalid && !form.city.$pristine }\"><label>Municipio<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"ciudad.city for ciudad in address.administrative_area_level_1.cities track by ciudad.url\" name=\"city\" ng-model=\"address.administrative_area_level_2\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un municipio</option></select></div><div class=\"col-xs-12 col-md-8 nopadding form-group\"><label>Calle</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.route\" id=\"id_address_route\" name=\"address_route\" data-geo=\"route\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Ext.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number\" id=\"id_address_street_number\" name=\"address_street_number\" data-geo=\"street_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Int.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number_int\" id=\"id_address_street_number_int\" name=\"address_street_number_int\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Colonia</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.sublocality\" id=\"id_address_sublocality\" name=\"address_sublocality\" data-geo=\"sublocality\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Código Postal</label> <input type=\"tel\" name=\"zip\" ng-model=\"address.postal_code\" minlength=\"5\" maxlength=\"5\" class=\"form-control\" ng-keypress=\"filterValue($event)\"></div><div class=\"col-xs-12 nopadding form-group\"><label>Referencias</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.details\" id=\"id_address_details\" name=\"address_details\"></div><input type=\"hidden\" class=\"form-control\" ng-model=\"address.administrative_area_level_1_short\" id=\"id_address_administrative_area_level_1_short\" name=\"address_state_code\" data-geo=\"administrative_area_level_1_short\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country\" id=\"id_address_country\" name=\"address_country\" data-geo=\"country\" value=\"México\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.composed\" id=\"id_address_composed\" name=\"address_composed\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country_code\" id=\"id_address_country_code\" name=\"address_country_code\" data-geo=\"country_short\" value=\"MX\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.locality\" id=\"id_address_locality\" name=\"address_locality\" data-geo=\"locality\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.latitude\" id=\"id_address_latitude\" name=\"address_latitude\" data-geo=\"lat\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.longitude\" id=\"id_address_longitude\" name=\"address_longitude\" data-geo=\"lng\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.formatted\" id=\"id_address_formatted\" name=\"address_formatted\" data-geo=\"formatted_address\"></div></div><div class=\"col-xs-12 form-group btn-mt\"><label>Observaciones</label> <textarea class=\"form-control\" type=\"text\" ng-model=\"vm.form.description\"></textarea></div><div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Información de contacto</legend></div><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.form.contact_provider.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"vm.form.contact_provider == 0\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"vm.form.contact_provider.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contactos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"contact in vm.form.contact_provider track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteContacts(contact.url, $index)\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts(contact.url, $index)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contacto #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"contact.name\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" type=\"email\" ng-model=\"contact.email\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Teléfono</label><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone_number\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Departamento</label> <input class=\"form-control\" type=\"text\" ng-model=\"contact.departament\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Ramo</label><select class=\"form-control\" ng-model=\"contact.conramo\" data-ng-options=\"ramo.ramo_name for ramo in vm.ramos track by ramo.url\" ng-change=\"vm.changeRamo(contact, contact.conramo)\"><option value=\"\">Todos los ramos</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Subramo</label><select class=\"form-control\" ng-model=\"contact.consubramo\" data-ng-options=\"subramo.subramo_name for subramo in vm.subramos track by subramo.url\" ng-change=\"vm.changeSubramo(contact, contact.consubramo)\"><option value=\"\">Todos los subramos</option></select></div></div></div><div class=\"btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" type=\"submit\" ng-click=\"vm.save()\" ng-if=\"vm.user.permiso.editar\">Guardar Cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button id=\"cancelButtonMoral\" class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></form></div></div></div></div></div>");
$templateCache.put("app/aseguradoras/aseguradoras.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Aseguradoras</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Aseguradoras</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-md-10\"><button class=\"btn btn-success\" ng-click=\"showCompany = true\">Agregar Nueva</button></div><div class=\"col-md-2 pull-right\"><button class=\"btn btn-primary ladda-button2\" ng-click=\"keyReport()\">Reporte de claves</button></div></div><br><div class=\"row\" ng-if=\"showCompany\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Agregar Nueva</h5></div><div class=\"ibox-content\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"Aseguradoras\" ng-click=\"vm.afianzadora = false\"><div class=\"ibox-content\"><form name=\"form\" ng-submit=\"vm.submit(form.$valid)\"><div class=\"row\"><div class=\"col-xs-12 col-md-6 form-group\"><label>Compañía<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"phone\" name=\"\" ng-model=\"vm.form.compania\" required=\"\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Alias<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"phone\" name=\"\" ng-model=\"vm.form.alias\" required=\"\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>RFC<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"phone\" name=\"\" ng-model=\"vm.form.rfc\" required=\"\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Teléfono<span class=\"color-red\">*</span></label><phonenumber-directive model=\"vm.form.phone\" requerid=\"\"></phonenumber-directive></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Website<span class=\"color-red\">*</span></label> <textarea class=\"form-control\" name=\"\" ng-model=\"vm.form.website\" required=\"\" cols=\"1\" rows=\"1\" style=\"resize: none;\"></textarea></div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Ramos</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.form.ramos.vida\">Vida</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.form.ramos.accidentes\">Accidentes y Enfermedades</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.form.ramos.autos\">Automóviles</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.form.ramos.danios\">Daños</label></div></div></div></div><div class=\"address-container\" ng-repeat=\"address in vm.address_list track by $index\"><div class=\"col-xs-12 legend-gray btn-mt\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteAddress($index)\" ng-disabled=\"vm.address_list.length <= 1\">Quitar dirección</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteAddress($index)\" ng-disabled=\"vm.address_list.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Dirección #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addAddress()\" type=\"button\">Agregar dirección</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addAddress()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 nopadding form-group\" ng-class=\"{ \'has-error\': form.state.$invalid && !form.state.$pristine }\"><label>Estado<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"estado.state for estado in vm.statesArray track by estado.url\" name=\"state\" ng-model=\"address.administrative_area_level_1\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un estado</option></select></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\" ng-class=\"{ \'has-error\': form.city.$invalid && !form.city.$pristine }\"><label>Municipio<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"ciudad.city for ciudad in address.administrative_area_level_1.cities track by ciudad.url\" name=\"city\" ng-model=\"address.administrative_area_level_2\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un municipio</option></select></div><div class=\"col-xs-12 col-md-8 nopadding form-group\"><label>Calle</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.route\" id=\"id_address_route\" name=\"address_route\" data-geo=\"route\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Ext.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number\" id=\"id_address_street_number\" name=\"address_street_number\" data-geo=\"street_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Int.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number_int\" id=\"id_address_street_number_int\" name=\"address_street_number_int\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Colonia</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.sublocality\" id=\"id_address_sublocality\" name=\"address_sublocality\" data-geo=\"sublocality\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Código Postal</label> <input type=\"tel\" name=\"zip\" ng-model=\"address.postal_code\" minlength=\"5\" maxlength=\"5\" class=\"form-control\" ng-keypress=\"filterValue($event)\"></div><div class=\"col-xs-12 nopadding form-group\"><label>Referencias</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.details\" id=\"id_address_details\" name=\"address_details\"></div><input type=\"hidden\" class=\"form-control\" ng-model=\"address.administrative_area_level_1_short\" id=\"id_address_administrative_area_level_1_short\" name=\"address_state_code\" data-geo=\"administrative_area_level_1_short\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country\" id=\"id_address_country\" name=\"address_country\" data-geo=\"country\" value=\"México\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.composed\" id=\"id_address_composed\" name=\"address_composed\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country_code\" id=\"id_address_country_code\" name=\"address_country_code\" data-geo=\"country_short\" value=\"MX\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.locality\" id=\"id_address_locality\" name=\"address_locality\" data-geo=\"locality\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.latitude\" id=\"id_address_latitude\" name=\"address_latitude\" data-geo=\"lat\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.longitude\" id=\"id_address_longitude\" name=\"address_longitude\" data-geo=\"lng\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.formatted\" id=\"id_address_formatted\" name=\"address_formatted\" data-geo=\"formatted_address\"></div></div><div class=\"col-xs-12 form-group btn-mt\"><label>Observaciones</label> <textarea class=\"form-control\" type=\"text\" ng-model=\"vm.form.description\"></textarea></div><div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Información de contacto</legend></div><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.form.contact_provider.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"vm.form.contact_provider == 0\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"vm.form.contact_provider.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contactos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"contact in vm.form.contact_provider track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteContacts(contact.url, $index)\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts(contact.url, $index)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contacto #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"contact.name\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" type=\"email\" ng-model=\"contact.email\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Teléfono</label><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone_number\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Ramo</label><select class=\"form-control\" ng-model=\"contact.conramo\" data-ng-options=\"ramo.ramo_name for ramo in vm.ramos track by ramo.id\" ng-change=\"vm.changeRamo(contact, contact.conramo,$index)\" required=\"\"><option value=\"\">Todos los ramos</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Subramo</label><select class=\"form-control\" ng-model=\"contact.consubramo\" data-ng-options=\"subramo.subramo_name for subramo in vm.subramos track by subramo.url\" ng-change=\"vm.changeSubramo(contact, contact.consubramo,$index)\" required=\"\"><option value=\"\">Todos los subramos</option></select></div></div></div><div class=\"btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button ng-if=\"vm.user.permiso.crear\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" type=\"submit\">Crear Aseguradora</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button id=\"cancelButtonMoral\" class=\"col-xs-12 btn btn-danger\" ng-click=\"cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></form></div></uib-tab><uib-tab index=\"1\" heading=\"Afianzadoras\" ng-click=\"vm.afianzadora = true\"><div class=\"ibox-content\"><form name=\"form\" ng-submit=\"vm.submit(form.$valid)\"><div class=\"row\"><div class=\"col-xs-12 col-md-6 form-group\"><label>Compañía<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"phone\" name=\"\" ng-model=\"vm.form.compania\" required=\"\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Alias<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"phone\" name=\"\" ng-model=\"vm.form.alias\" required=\"\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>RFC<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"phone\" name=\"\" ng-model=\"vm.form.rfc\" required=\"\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Teléfono<span class=\"color-red\">*</span></label><phonenumber-directive model=\"vm.form.phone\" requerid=\"\"></phonenumber-directive></div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Ramos</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-2 col-md-offset-1\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.form.ramos.fidelidad\">Fidelidad</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-2\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.form.ramos.judiciales\">Judiciales</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-2\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.form.ramos.administrativas\">Administrativas</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-2\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.form.ramos.credito\">Crédito</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-2\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.form.ramos.fideicomiso\">Fideicomiso</label></div></div></div></div><div class=\"address-container\" ng-repeat=\"address in vm.address_list track by $index\"><div class=\"col-xs-12 legend-gray btn-mt\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteAddress($index)\" ng-disabled=\"vm.address_list.length <= 1\">Quitar dirección</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteAddress($index)\" ng-disabled=\"vm.address_list.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Dirección #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addAddress()\" type=\"button\">Agregar dirección</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addAddress()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 nopadding form-group\" ng-class=\"{ \'has-error\': form.state.$invalid && !form.state.$pristine }\"><label>Estado<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"estado.state for estado in vm.statesArray track by estado.url\" name=\"state\" ng-model=\"address.administrative_area_level_1\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un estado</option></select></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\" ng-class=\"{ \'has-error\': form.city.$invalid && !form.city.$pristine }\"><label>Municipio<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"ciudad.city for ciudad in address.administrative_area_level_1.cities track by ciudad.url\" name=\"city\" ng-model=\"address.administrative_area_level_2\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un municipio</option></select></div><div class=\"col-xs-12 col-md-8 nopadding form-group\"><label>Calle</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.route\" id=\"id_address_route\" name=\"address_route\" data-geo=\"route\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Ext.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number\" id=\"id_address_street_number\" name=\"address_street_number\" data-geo=\"street_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Int.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number_int\" id=\"id_address_street_number_int\" name=\"address_street_number_int\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Colonia</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.sublocality\" id=\"id_address_sublocality\" name=\"address_sublocality\" data-geo=\"sublocality\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Código Postal</label> <input type=\"tel\" name=\"zip\" ng-model=\"address.postal_code\" minlength=\"5\" maxlength=\"5\" class=\"form-control\" ng-keypress=\"filterValue($event)\"></div><div class=\"col-xs-12 nopadding form-group\"><label>Referencias</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.details\" id=\"id_address_details\" name=\"address_details\"></div><input type=\"hidden\" class=\"form-control\" ng-model=\"address.administrative_area_level_1_short\" id=\"id_address_administrative_area_level_1_short\" name=\"address_state_code\" data-geo=\"administrative_area_level_1_short\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country\" id=\"id_address_country\" name=\"address_country\" data-geo=\"country\" value=\"México\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.composed\" id=\"id_address_composed\" name=\"address_composed\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country_code\" id=\"id_address_country_code\" name=\"address_country_code\" data-geo=\"country_short\" value=\"MX\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.locality\" id=\"id_address_locality\" name=\"address_locality\" data-geo=\"locality\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.latitude\" id=\"id_address_latitude\" name=\"address_latitude\" data-geo=\"lat\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.longitude\" id=\"id_address_longitude\" name=\"address_longitude\" data-geo=\"lng\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.formatted\" id=\"id_address_formatted\" name=\"address_formatted\" data-geo=\"formatted_address\"></div></div><div class=\"col-xs-12 form-group btn-mt\"><label>Observaciones</label> <textarea class=\"form-control\" type=\"text\" ng-model=\"vm.form.description\"></textarea></div><div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Información de contacto</legend></div><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.form.contact_provider.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"vm.form.contact_provider == 0\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"vm.form.contact_provider.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contactos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"contact in vm.form.contact_provider track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteContacts(contact.url, $index)\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts(contact.url, $index)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contacto #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"contact.name\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" type=\"email\" ng-model=\"contact.email\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Teléfono</label><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone_number\"></phonenumber-directive></div></div></div><div class=\"btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button ng-if=\"vm.user.permiso.crear\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" type=\"submit\">Crear Afianzadora</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button id=\"cancelButtonMoral\" class=\"col-xs-12 btn btn-danger\" ng-click=\"cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></form></div></uib-tab></uib-tabset></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Aseguradoras</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-8 col-lg-12 form-group\"><label>Aseguradora</label><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Buscar\" ng-enter=\"vm.search(cadena)\" ng-model=\"cadena\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.getAll()\">Mostrar todo</button></div></div></div></div><div id=\"exportable\" ng-if=\"vm.providers.length\"><table class=\"table footable table-hover table-bordered\" data-filter=\"#filter\" data-page-size=\"25\" id=\"dvData\" ng-if=\"!vm.show_binnacle\"><thead><th class=\"footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Alias <span class=\"footable-sort-indicator\"></span></th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\">Compañía <span class=\"footable-sort-indicator\"></span></th><th data-hide=\"phone\" class=\"footable-sortable\" style=\"display: none;\">RFC <span class=\"footable-sort-indicator\"></span></th><th data-hide=\"phone\" class=\"footable-sortable\" style=\"display: none;\">Opción</th><th data-hide=\"phone\" class=\"footable-sortable\">Acciones</th></thead><tbody><tr ng-repeat=\"provider in vm.providers | orderBy: \'alias\' track by $index\" foo-repeat-done=\"\"><td>{{ provider.alias }}</td><td>{{ provider.compania }}</td><td>{{ provider.rfc }}</td><td><button ng-click=\"vm.editProvider(provider)\" ui-sref=\"aseguradoras.edit({aseguradoraId: provider.id})\" type=\"button\" class=\"btn btn-w-m btn-default\" name=\"button\" ng-if=\"vm.user.permiso.editar\">Editar</button> <button ng-click=\"vm.infoProvider(provider)\" type=\"button\" class=\"btn btn-w-m btn-success\" name=\"button\">Ver</button></td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(provider)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"show_pagination && !vm.show_binnacle\" class=\"text-center\"><pagination config=\"vm.config_pagination\" model=\"vm.providers\"></pagination></div><div ng-if=\"vm.providers.length && vm.buttonReport == false && !vm.show_binnacle\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 btn btn-primary ladda-button\" ng-click=\"exportData()\">Generar reporte</button></div><div ng-if=\"vm.buttonReport == true && !vm.show_binnacle\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 btn btn-primary ladda-button\" ng-click=\"exportDataSeeker(1)\">Generar reporte</button></div><div class=\"animate\" ng-if=\"vm.show_binnacle\"><div class=\"\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"vm.returnToProvider()\"><span class=\"fa fa-reply\"></span> Regresar</button></div><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" typemodel=\"11\" config=\"vm.comments_config\" idmodel=\"vm.provider_id\" exportable=\"true\"></comments></div></div></div></div></div></div></div></div>");
$templateCache.put("app/aseguradoras/aseguradoras.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Aseguradoras</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"aseguradoras.aseguradoras\">Aseguradoras</a></li><li class=\"active\"><strong>{{vm.form.compania}}</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Información</h5></div><div class=\"ibox-content\"><div class=\"row\"><form method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"col-xs-6 form-group\"><span class=\"blue-color\">Compañia</span><div><span>{{vm.form.compania}}</span></div></div><div class=\"col-xs-6 form-group\"><span class=\"blue-color\">Alías</span><div><span>{{vm.form.alias}}</span></div></div><div class=\"col-xs-6 form-group\"><span class=\"blue-color\">RFC</span><div><span>{{vm.form.rfc}}</span></div></div><div class=\"col-xs-6 form-group\" ng-if=\"vm.form.phone\"><span class=\"blue-color\">Teléfono</span><div><span>{{vm.form.phone | phonenumber}}</span></div></div><div class=\"col-xs-6 form-group\" ng-if=\"!vm.form.phone\"><span class=\"blue-color\">Teléfono</span><div><span class=\"red-color\">Sin teléfono asignado</span></div></div><div class=\"col-xs-6 form-group\" ng-if=\"vm.form.website\"><span class=\"blue-color\">Website</span><div><span>{{vm.form.website}}</span></div></div><div class=\"col-xs-6 form-group\" ng-if=\"!vm.form.website\"><span class=\"blue-color\">Website</span><div><span class=\"red-color\">Sin website asignado</span></div></div><br><br><div class=\"col-xs-6 form-group\"><span class=\"blue-color\">Creado por</span><div><span>{{vm.form.owner}}</span></div></div><div class=\"col-xs-6 form-group\"><span class=\"blue-color\">Observaciones</span><div><span>{{vm.form.description}}</span></div></div><div class=\"address-container\" ng-repeat=\"address in vm.address_list track by $index\"><div class=\"col-xs-12 legend-gray btn-mt\"><legend class=\"legend-title legend-flex\" align=\"center\"><span>Dirección #{{$index + 1}}</span></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-3 form-group\"><span class=\"blue-color\">Estado</span><div><span>{{vm.address_list[$index].administrative_area_level_1}}</span></div></div><div class=\"col-xs-3 form-group\"><span class=\"blue-color\">Municipio</span><div><span>{{vm.address_list[$index].administrative_area_level_2}}</span></div></div><div class=\"col-xs-3 form-group\"><span class=\"blue-color\">Calle</span><div><span>{{vm.address_list[$index].route}}</span></div></div><div class=\"col-xs-3 form-group\"><span class=\"blue-color\">Núm. Exterior</span><div><span>{{vm.address_list[$index].street_number}}</span></div></div><div class=\"col-xs-3 form-group\"><span class=\"blue-color\">Núm. Interior</span><div><span>{{vm.address_list[$index].street_number_int}}</span></div></div><div class=\"col-xs-3 form-group\"><span class=\"blue-color\">Colonia</span><div><span>{{vm.address_list[$index].sublocality}}</span></div></div><div class=\"col-xs-3 form-group\"><span class=\"blue-color\">Código Postal</span><div><span>{{vm.address_list[$index].postal_code}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Referencias</span><div><span>{{vm.address_list[$index].details}}</span></div></div><input type=\"hidden\" class=\"form-control\" ng-model=\"address.administrative_area_level_1_short\" id=\"id_address_administrative_area_level_1_short\" name=\"address_state_code\" data-geo=\"administrative_area_level_1_short\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country\" id=\"id_address_country\" name=\"address_country\" data-geo=\"country\" value=\"México\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.composed\" id=\"id_address_composed\" name=\"address_composed\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country_code\" id=\"id_address_country_code\" name=\"address_country_code\" data-geo=\"country_short\" value=\"MX\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.locality\" id=\"id_address_locality\" name=\"address_locality\" data-geo=\"locality\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.latitude\" id=\"id_address_latitude\" name=\"address_latitude\" data-geo=\"lat\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.longitude\" id=\"id_address_longitude\" name=\"address_longitude\" data-geo=\"lng\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.formatted\" id=\"id_address_formatted\" name=\"address_formatted\" data-geo=\"formatted_address\"></div></div><br><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Ramos - Subramos</legend><div ng-repeat=\"item in vm.form.ramo_provider\"><ul class=\"todo-list m-t small-list\"><li ng-init=\"show_ramo[$index] = true\" ng-click=\"show_ramo[$index] ? show_ramo[$index] = false : show_ramo[$index] = true; selectRamo(item);\" ng-class=\"{\'ramo-selected\': item.id == ramoResult.id}\" class=\"ramo-item\"><span class=\"m-l-xs blue-color\">{{item.ramo_name}}</span><div ng-repeat=\"sitem in item.subramo_ramo\"><ul class=\"todo-list m-t small-list\"><li ng-init=\"show_subramo[$index] = true\" ng-click=\"show_subramo[$index] ? show_subramo[$index] = false : show_subramo[$index] = true; selectSubramo(sitem);\" class=\"subramo-sitem\"><span class=\"m-l-xs\">{{sitem.subramo_name}}</span></li></ul></div></li></ul></div></div><br><br><div ng-if=\"vm.form.contact_provider.length\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Información de contacto</legend></div><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.form.contact_provider.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><span>Contactos</span></legend></div></div><div class=\"row address-container\" ng-repeat=\"contact in vm.form.contact_provider track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><span>Contacto #{{$index + 1}}</span></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Nombre</span><div><span>{{contact.name}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Correo Electrónico</span><div><span>{{contact.email}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Teléfono</span><div><span>{{contact.phone_number | phonenumber}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Departamento</span><div><span>{{contact.departament}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Ramo</span><div><span>{{vm.form.contact_provider[$index].ramo_s.data.ramo_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Subramo</span><div><span>{{vm.form.contact_provider[$index].subramo_s.data.subramo_name}}</span></div></div></div></div></div></div></form><br><br><div class=\"btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-info\" ui-sref=\"aseguradoras.edit({aseguradoraId: vm.form.id})\" type=\"button\">Editar</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Regresar</button></div></div></div></div></div></div></div>");
$templateCache.put("app/aseguradoras/aseguradoras.subramos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Aseguradoras</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"aseguradoras.aseguradoras\">Aseguradoras</a></li><li><a ui-sref=\"aseguradoras.ramos\">Ramos</a></li><li class=\"active\"><strong>Subramos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Subramos</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"panel-body\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><form class=\"form-horizontal\" method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form.name.$invalid && !form.name.$pristine }\"><label class=\"col-sm-2 control-label\">Nombre del subramo<span class=\"color-red\">*</span></label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"name\" ng-model=\"vm.form.subramo_name\" required=\"\" type=\"text\"></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.name.$invalid && !form.name.$pristine }\"><label class=\"col-sm-2 control-label\">Código del subramo<span class=\"color-red\">*</span></label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"name\" ng-model=\"vm.form.subramo_code\" required=\"\" type=\"text\"></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"form-group col-sm-12\"><button class=\"btn btn-white pull-right\" type=\"button\" ng-click=\"vm.cancel()\">Borrar datos</button> <button class=\"btn btn-success pull-right margin-top-10\" ng-disabled=\"form.$invalid\" type=\"submit\">Guardar</button></div></div></form></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Subramos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><table class=\"table table-striped table-bordered table-hover dataTables-example\" datatable=\"ng\"><thead><tr><th>Subramos</th><th>Código del subramo</th><th></th></tr></thead><tbody><tr ng-repeat=\"subramo in vm.subramos track by $index\"><td><a>{{subramo.subramo_name}}</a></td><td>{{subramo.subramo_code}}</td><td></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/aseguradoras/send.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Enviar PDF a la Compañía</h4></div><div class=\"modal-body\"><div class=\"row\" ng-if=\"!vm.show_binnacle\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><div><h4>Emails registrados en esta aseguradora:</h4><div class=\"form-group\"><select class=\"form-control\" ng-options=\"contact.email for contact in vm.contacts\" ng-change=\"EmailSelection()\" name=\"email\" ng-model=\"vm.email\"><option value=\"\">Selecciona un email</option></select></div><div class=\"form-group\"><a ng-click=\"combo = true\">Ingresar un email diferente</a></div><div class=\"form-group\" ng-if=\"combo\"><label>Escriba el correo electrónico al que desea enviar:<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"email_assign\" ng-model=\"vm.email[0]\" type=\"email\" required=\"\"></div><div class=\"form-group pull-right\" ng-if=\"combo\"><a ng-click=\"flagMethod()\">Cc</a></div><div class=\"form-group\" ng-if=\"cc\"><label>Cc:</label> <input class=\"form-control\" name=\"email_assign\" ng-model=\"vm.email[1]\" type=\"email\" required=\"\"></div><div class=\"col-xs-12\"><div class=\"form-group col-xs-12\"><label>Asunto:</label> <input class=\"col-xs-12 form-control\" type=\"text\" name=\"\" ng-model=\"vm.subjectEmail\"></div><div class=\"form-group col-xs-12\"><label>Mensaje:</label><div><input type=\"checkbox\" name=\"custom_mail\" ng-model=\"custom_email\" ng-change=\"getTemplate(custom_email)\"> <label>Personalizar</label><br></div><div class=\"form-group\"><label>Plantilla de Endoso:</label><select class=\"form-control\" ng-options=\"plantilla.title for plantilla in plantillas\" ng-model=\"selectedPlantilla\" ng-change=\"changePlantilla(selectedPlantilla)\"><option value=\"\">Selecciona una plantilla</option></select></div><textarea ng-if=\"!custom_email\" class=\"col-xs-12 form-control textarea-modal\" ng-model=\"vm.messageEmail\"></textarea><div ng-if=\"custom_email\" class=\"col-xs-12\" ng-bind-html=\"head\" name=\"head\"></div><div ng-if=\"custom_email\" text-angular=\"\" ng-model=\"vm.first_comment\" name=\"\"></div><br><div ng-if=\"custom_email\" ng-bind-html=\"body\" name=\"body\"></div><div ng-if=\"custom_email\" text-angular=\"\" ng-model=\"vm.second_comment\"></div><br><div ng-if=\"custom_email\" ng-bind-html=\"footer\" name=\"footer\"></div><br><label ng-if=\"(signature && !custom_email) || (signature_edith)\">Firma</label><div ng-if=\"!signature_edith && !custom_email\" ng-bind-html=\"signature\" name=\"signature\"></div><div ng-if=\"signature_edith\" text-angular=\"\" ng-model=\"vm.signature\"></div><button ng-if=\"signature_edith\" class=\"btn btn-primary\" type=\"button\" ng-click=\"setSignature()\" title=\"Guardar Firma\">Guardar</button> <button ng-if=\"signature_edith\" class=\"btn btn-danger\" type=\"button\" ng-click=\"cancelEdithSignature()\" title=\"Guardar Firma\">Cancelar</button><br><button ng-if=\"banner_edith\" class=\"btn btn-primary\" type=\"button\" ng-click=\"saveFilesHF()\" title=\"Guardar Firma\">Guardar</button> <button ng-if=\"banner_edith\" class=\"btn btn-danger\" type=\"button\" ng-click=\"CancelEdithBanner()\" title=\"Guardar Firma\">Cancelar</button></div></div></div><div class=\"text-align-center\"><button class=\"btn btn-secondary\" type=\"button\" ng-click=\"adjFilesOK(true)\" title=\"Deberá guardar los archivos para poder ser adjuntados en el correo\">Adjuntar/Ver Archivos</button></div><div class=\"col-xs-12 row\" ng-if=\"adjFiles\"><div upload-template=\"\"></div><div class=\"text-align-center\" ng-if=\"uploader.queue.length > 0\"><button class=\"btn btn-secondary\" type=\"button\" name=\"savefiles\" title=\"Click aquí y los archivos podrán ser adjuntados en el correo\" ng-click=\"saveFiles(provider.id)\">Guardar archivos</button></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th width=\"20px\">Adjuntar</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"vmFiles.rename(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,files)\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</button> <span class=\"btn btn-success display-none\">Guardar</span></td><td><input type=\"checkbox\" ng_model=\"file.checked\" ng-change=\"shareFileEmail(file)\"></td></tr></tbody></table></div></div><div class=\"text-align-center\" ng-if=\"adjFiles\"><button class=\"btn btn-secondary\" type=\"button\" ng-click=\"adjFilesOK(false)\">Ocultar Archivos</button></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" type=\"button\" ng-click=\"cancel()\">Cerrar</button> <button class=\"btn btn-primary ladda-button\" ng-click=\"sendEmail(vm.email,files, vm.first_comment, vm.second_comment)\">Enviar</button></div></div>");
$templateCache.put("app/bibliotecas/bibliotecas.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ vm.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><span>Editar Carta</span></li><li class=\"active\"><strong>{{letter.id}}</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Carta</h5></div><div class=\"ibox-content\"><div ng-include=\"\'app/bibliotecas/bibliotecas.form.html\'\"></div></div></div></div></div>");
$templateCache.put("app/bibliotecas/bibliotecas.form.html","<form name=\"letterForm\" novalidate=\"\"><div class=\"row\"><div class=\"form-group col-xs-12 col-md-6\"><label class=\"control-label\" for=\"name\">Nombre <span class=\"color-red\">*</span></label> <input class=\"form-control col-xs-12 col-sm-6\" ng-model=\"letter.name\" type=\"text\" name=\"name\" required=\"\"></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-md-6\"><label class=\"control-label\" for=\"title\">Título <span class=\"color-red\">*</span></label> <input class=\"form-control col-xs-12 col-sm-6\" ng-model=\"letter.title\" type=\"text\" name=\"title\" required=\"\"></div><div class=\"form-group col-xs-12\"><label class=\"control-label\" for=\"title\">Texto <span class=\"color-red\">*</span></label> <textarea style=\"min-width: 100%; max-width: 100%; height: 400px; max-height: 400px; max-height: 600px;\" class=\"form-control\" ng-model=\"letter.text\" type=\"text\" required=\"\"></textarea></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Tipo <span class=\"color-red\">*</span></legend><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-lg-2\"><div class=\"checkbox\"><label><input ng-model=\"letter.model\" type=\"radio\" value=\"1\" required=\"\"> PÓLIZA</label></div></div><div class=\"col-xs-12 col-sm-4 col-lg-2\"><div class=\"checkbox\"><label><input ng-model=\"letter.model\" type=\"radio\" value=\"6\" required=\"\"> OT</label></div></div><div class=\"col-xs-12 col-sm-4 col-lg-2\"><div class=\"checkbox\"><label><input ng-model=\"letter.model\" type=\"radio\" value=\"2\" required=\"\"> ENDOSO</label></div></div><div class=\"col-xs-12 col-sm-4 col-lg-2\"><div class=\"checkbox\"><label><input ng-model=\"letter.model\" type=\"radio\" value=\"3\" required=\"\"> RENOVACIONES</label></div></div><div class=\"col-xs-12 col-sm-4 col-lg-2\"><div class=\"checkbox\"><label><input ng-model=\"letter.model\" type=\"radio\" value=\"4\" required=\"\"> COBRANZA</label></div></div><div class=\"col-xs-12 col-sm-4 col-lg-2\"><div class=\"checkbox\"><label><input ng-model=\"letter.model\" type=\"radio\" value=\"5\" required=\"\"> SINIESTRO</label></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Campaña</legend><div class=\"col-xs-12\"></div><div class=\"col-xs-12 checkbox\"><label><input ng-model=\"bell\" ng-click=\"showContainerFiles(bell)\" type=\"radio\" value=\"1\"> Usar campaña actual</label><br><label><input ng-model=\"bell\" ng-click=\"showContainerFiles(bell)\" type=\"radio\" value=\"2\"> Nueva campaña</label></div><div class=\"form-group col-sm-12\" ng-show=\"showFiles\"><label class=\"col-xs-12 col-sm-3 btn btn-success pull-right\">Agregar Archivo <input multiple=\"\" nv-file-select=\"\" class=\"display-none\" id=\"file_url\" type=\"file\" name=\"xyz\" uploader=\"uploader\" accept=\"image/*\"></label> <label class=\"pull-right margin-right-10\">La imagen debe tener una resolución de 1000 x 120px</label><table class=\"table table-stripped hidden-xs hidden-sm\"><thead><tr><th ng-model=\"archivos.headers[0]\">{{archivos.headers[0]}}</th><th ng-model=\"archivos.headers[1]\">{{archivos.headers[1]}}</th><th ng-model=\"archivos.headers[2]\">{{archivos.headers[2]}}</th><th ng-model=\"archivos.headers[3]\">{{archivos.headers[3]}}</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue track by $index\"><td><input ng-model=\"item.file.name\" ng-blur=\"uploader.onRename(item)\" onblur=\"blurArchivoCargado(this)\" class=\"form-control display-none\"> <strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }}MB</td><td ng-show=\"uploader.isHTML5\"><div class=\"progress margin-bottom-0\"><div class=\"progress-bar\" ng-style=\"{ \'width\': item.progress + \'%\' }\" role=\"progressbar\"></div></div></td><td nowrap=\"\"><button class=\"btn btn-danger btn-xs\" ng-click=\"item.remove()\" type=\"button\">Remover</button> <button class=\"btn btn-info btn-xs\" onclick=\"renombrarArchivoCargado()\" type=\"button\">Renombrar</button> <span class=\"btn btn-success btn-xs display-none\">Guardar</span></td></tr></tbody></table><div class=\"col-xs-12\"><img class=\"img-thumbnail img-responsive center-block\" id=\"img_destino\"></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><button class=\"btn btn-success btn-mt pull-right\" ng-disabled=\"letterForm.$invalid\" ng-click=\"save()\" type=\"button\" ng-if=\"!letter.id\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar</button></div><div class=\"col-sm-12\"><button class=\"btn btn-success btn-mt pull-right\" ng-disabled=\"letterForm.$invalid\" ng-click=\"update()\" type=\"button\" ng-if=\"letter.id\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Actualizar</button></div></div></form><script type=\"text/javascript\">\n  function mostrarImagen(input) {\n    if (input.files && input.files[0]) {\n      var reader = new FileReader();\n      reader.onload = function (e) {\n        $(\'#img_destino\').attr(\'src\', e.target.result);\n      }\n      reader.readAsDataURL(input.files[0]);\n    }\n  }\n   \n  $(\"#file_url\").change(function(){\n    mostrarImagen(this);\n  });\n\n  function renombrar(index) {\n    var test = $(index).attr(\'id\');\n    \n    try{\n      test = test.replace(\'rename_\',\'\')\n    }\n    catch(e){}\n\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n    inputTag.focus();\n    inputTag.show();\n  }\n\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(index){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.removeClass(\'display-none\');\n    dummy.addClass(\'display-none\');\n\n    inputTag.addClass(\'display-none\');\n    strongTag.removeClass(\'display-none\');\n  }\n</script>");
$templateCache.put("app/bibliotecas/bibliotecas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ vm.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Crear carta</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Nueva carta</h5></div><div class=\"ibox-content\"><div ng-include=\"\'app/bibliotecas/bibliotecas.form.html\'\"></div></div></div></div></div>");
$templateCache.put("app/bibliotecas/cartas.list.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ vm.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Cartas</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Cartas</h5></div><div class=\"ibox-content\"><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Número</th><th>Nombre</th><th>Título</th><th>Creación</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"letter in letters\"><td>{{ letter.id }}</td><td>{{ letter.name }}</td><td>{{ letter.title }}</td><td>{{ letter.created_at | date: \'dd/MM/yyyy\'}}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); editLetter(letter)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); deleteLetter(letter, index, letters)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button ng-if=\"previous\" class=\"btn btn-success col-xs-12\" ng-click=\"goTo(previous)\" type=\"button\">Anterior</button> <button ng-if=\"next\" class=\"btn btn-success col-xs-12\" ng-click=\"goTo(next)\" type=\"button\">Siguiente</button></div></div></div></div></div>");
$templateCache.put("app/bibliotecas/editables.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Formatos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><strong>Formatos</strong></li><li class=\"active\"><strong>Editables</strong></li></ol></div></div><div class=\"m-t\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Agregar Formatos</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Aseguradora<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"aseguradora.alias for aseguradora in providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"aseguradoraSelection()\" name=\"aseguradora\" ng-model=\"aseguradoraEditables\"><option value=\"\">Selecciona un proveedor</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"ramo.ramo_name for ramo in ramos | orderBy:\'ramo_name\' track by ramo.url\" ng-change=\"changeRamo()\" name=\"ramo\" ng-model=\"ramoEditables\"><option value=\"\">Selecciona un ramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramos<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"subramo.subramo_name for subramo in subramos | orderBy:\'subramo_name\' track by subramo.url\" ng-change=\"changeSubramo()\" name=\"subramo\" ng-model=\"subramoEditables\"><option value=\"\">Selecciona un subramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label class=\"btn btn-success col-xs-12 pull-right\"><i class=\"fa fa-upload\"></i> Agregar formato <input multiple=\"\" nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploader\" class=\"display-none\"></label></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><button class=\"btn btn-primary col-xs-12 ladda-button\" ng-click=\"uploadFiles()\">Guardar formato</button></div><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info\" ng-show=\"uploader.queue.length>0\">Se crearán como formato</div><table class=\"table table-stripped hidden-xs hidden-sm\"><tbody><tr ng-repeat=\"item in uploader.queue track by $index\"><td><input ng-model=\"item.file.name\" ng-blur=\"uploader.onRename(item)\" onblur=\"blurArchivoCargado(this)\" class=\"form-control display-none\"> <strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }}MB</td><td ng-show=\"uploader.isHTML5\" width=\"300px\"><div class=\"progress margin-bottom-0\"><div class=\"progress-bar\" ng-style=\"{ \'width\': item.progress + \'%\' }\" role=\"progressbar\"></div></div></td><td nowrap=\"\"><input type=\"checkbox\" name=\"is_format\" ng-model=\"item.is_format\" ng-click=\"format(item.is_format)\" value=\"1\" style=\"margin:2px;\">Formato<br><button class=\"btn btn-danger btn-xs\" ng-click=\"item.remove()\" type=\"button\"><i class=\"fa fa-times\"></i> Remover</button> <button class=\"btn btn-info btn-xs\" onclick=\"renombrarArchivoCargado()\" type=\"button\"><i class=\"fa fa-edit\"></i> Renombrar</button> <span class=\"btn btn-success btn-xs display-none\"><i class=\"fa fa-save\"></i> Guardar</span></td></tr></tbody></table></div><br><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" \"=\"\"><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"item in uploader.queue track by $index\"><div class=\"ibox-title\"><h5>{{ archivos.headers[0] }}: <input ng-model=\"item.file.name\" ng-blur=\"uploader.onRename(item)\" onblur=\"blurArchivoCargado(this)\" class=\"form-control display-none\"> <strong>{{ item.file.name }}</strong></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><div class=\"table-flex\"><div class=\"row table-row\"><div class=\"table-cell col-xs-12 col-sm-3\"><label>{{ archivos.headers[0] }}</label><div><input ng-model=\"item.file.name\" ng-blur=\"uploader.onRename(item)\" onblur=\"blurArchivoCargado(this)\" class=\"form-control display-none\"></div><strong>{{ item.file.name }}</strong></div><div class=\"table-cell col-xs-12 col-sm-3\"><label>{{ archivos.headers[1] }}</label><p ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }}MB</p></div><div class=\"table-cell col-xs-12 col-sm-3\"><label>{{ archivos.headers[2] }}</label><p class=\"margin-bottom-0\" ng-show=\"uploader.isHTML5\"><div class=\"progress margin-bottom-0\"><div class=\"progress-bar\" ng-style=\"{ \'width\': item.progress + \'%\' }\" role=\"progressbar\"></div></div></p></div><div class=\"table-cell col-xs-12 col-sm-3\"><label>{{ archivos.headers[3] }}</label><div nowrap=\"\"><input type=\"checkbox\" name=\"is_format\" ng-model=\"item.is_format\" ng-click=\"format()\" value=\"\" style=\"margin:2px;\">Formato<br><button class=\"btn btn-danger btn-xs\" ng-click=\"item.remove()\" type=\"button\"><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"btn btn-info btn-xs\" onclick=\"renombrarArchivoCargado()\" type=\"button\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <span class=\"btn btn-success btn-xs display-none\"><span class=\"glyphicon glyphicon-floppy\"></span></span></div></div></div></div></div></div></div><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Formatos disponibles</legend><table class=\"table table-bordered table hidden-xs hidden-sm\"><thead><tr><th>Nombre</th><th>Ramo</th><th>Subramo</th><th>Aseguradora</th><th>Formato</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"file in vm.files track by $index\"><td><input id=\"input_txt\" ng-model=\"file.nombre\" ng-blur=\"editFile(file,this)\" onblur=\"blurArchivoCargado(this)\" class=\"form-control display-none\"> <strong>{{ file.nombre }}</strong></td><td><b>{{ file.ramo_name}}</b></td><td><b>{{ file.subramo_name}}</b></td><td><b>{{ file.aseguradora_name}}</b></td><td><input type=\"checkbox\" name=\"is_format\" ng-model=\"file.is_format\" ng-blur=\"editFile(file,this)\" value=\"{{ file.is_format }}\" style=\"margin:2px;\">Es un Formato<br></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\" target=\"_blank\"><i class=\"fa fa-download\"></i> Descargar</a> <a class=\"btn btn-danger\" ng-click=\"deleteFile(file,vm.files)\"><i class=\"fa fa-trash\"></i> Borrar</a> <a class=\"btn btn-info\" onclick=\"renombrarArchivoCargado(), saveInput = true\"><i class=\"fa fa-edit\"></i> Renombrar</a> <span class=\"btn btn-success display-none\">Guardar</span></td></tr></tbody></table><div ng-if=\"show_pag_editables\" class=\"text-center hidden-xs hidden-sm\"><pagination config=\"config_pagination\" model=\"vm.files\"></pagination></div></div></div><script type=\"text/javascript\">\n  function renombrar(index) {\n    var test = $(index).attr(\'id\');\n    try{\n      test = test.replace(\'rename_\',\'\')\n    }\n    catch(e){}\n\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"[id=\'input_txt\']\");\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n    inputTag.focus();\n    inputTag.show();\n  }\n\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"[id=\'input_txt\']\");\n\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n\n    inputTag.focus();\n\n  }\n\n  function blurArchivoCargado(index){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"[id=\'input_txt\']\");\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    // btnTag.prop(\'onclick\',null).off(\'click\');\n\n    btnTag.removeClass(\'display-none\');\n    dummy.addClass(\'display-none\');\n\n    inputTag.addClass(\'display-none\');\n    strongTag.removeClass(\'display-none\');\n  }\n</script>");
$templateCache.put("app/bibliotecas/layouts.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ vm.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Layouts</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Layouts</h5></div><div class=\"ibox-content\"><uib-tabset><uib-tab heading=\"Pólizas de Grupo\"><br><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Nombre</th><th>Acciones</th></thead><tbody><tr><td>Layout Flotillas</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Flotillas.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Vida</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Vida.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Gastos Médicos</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Gastos_Medicos.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Gastos Médicos Contributoria</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Gastos_Medicos_Contributoria.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Daños Incendio</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Incendio.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Daños Diversos</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Eq_Elect_Contratista.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Para Carga Masiva De Archivos A Certificados</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/layout_carga_masiva_de_certificados.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Para Actualización Masiva de Correos de Certificados</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/layout_actualizacion_email_certificados.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr></tbody></table></uib-tab><uib-tab heading=\"Endosos\"><br><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Nombre</th><th>Acciones</th></thead><tbody><tr><td>Layout Flotillas Alta Certificados</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Flotillas_Endoso_Alta.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Vida Alta Certificados</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Vida_Endoso_Alta.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Gastos Médicos Alta Certificados</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_GMM_endoso_Alta.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Gastos Médicos Alta Certificados Contributoria</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_GMM_endoso_Alta_Contributoria.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Endosos Baja Certificados</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Endoso_Baja.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr></tbody></table></uib-tab><uib-tab heading=\"Colectividades\"><br><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Nombre</th><th>Acciones</th></thead><tbody><tr><td>Layout Colectividad Flotilla</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Colectividad_Flotilla.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr></tbody></table></uib-tab><uib-tab heading=\"Fianzas\"><br><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Nombre</th><th>Acciones</th></thead><tbody><tr><td>Layout Fianza Colectiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Col_Fianza_Fidelidad.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr></tbody></table></uib-tab><uib-tab heading=\"Comisiones\"><br><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Nombre</th><th>Acciones</th></thead><tbody><tr><td>Layout Conciliar Masiva por ID</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/ID_Layout_conciliacion_masiva_saam.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr></tbody></table></uib-tab><uib-tab heading=\"IBIS\"><br><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Nombre</th><th>Acciones</th></thead><tbody><tr><td>Layout Directorio</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Directorio.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Proveedores</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Proveedores.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr></tbody></table></uib-tab><uib-tab heading=\"Campañas\"><br><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Nombre</th><th>Acciones</th></thead><tbody><tr><td>Layout Carga Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/layout_campa%C3%B1as_carga_masiva.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr></tbody></table></uib-tab><uib-tab heading=\"Cobranza\"><br><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Nombre</th><th>Acciones</th></thead><tbody><tr><td>Layout Liquidación Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_liquidacion_masiva+SAAM.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Pago Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_PAGO_MASIVO.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Pago Masiva por ID</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/ID_Layout_pago_masiva_saam.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Liquidación Masiva por ID</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/ID_Layout_liquidacion_masiva_saam.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr></tbody></table></uib-tab><uib-tab heading=\"Cargas Masivas de Adjuntos\"><br><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Nombre</th><th>Acciones</th></thead><tbody><tr><td>Layout Contratantes Masiva Por ID</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/layout_carga_masiva_de_contratantes_por_id.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Certificados Masiva Por ID</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/layout_carga_masiva_de_certificados_por_id.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Pólizas Masiva Por ID</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/layout_carga_masiva_de_polizas_ind_por_id.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Recibos Masiva Por ID</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/layout_carga_masiva_de_recibos_por_id.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr></tbody></table></uib-tab><uib-tab heading=\"Cargas Masivas de Registros\"><br><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Nombre</th><th>Acciones</th></thead><tbody><tr><td>Layout Contratantes Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Contratantes.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Contratantes Móvil Whatsapp/SMS Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_TelefonoMensajeria_Contratantes.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Pólizas Individuales Vida Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Polizas_Vida_Masiva.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Pólizas Individuales Accidentes y Enfermedades Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Polizas_Gastos_Masiva.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Pólizas Individuales Automóviles Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Polizas_Auto_Masiva.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Pólizas Individuales Daños Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Polizas_Danios_Masiva.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Póliza Grupo Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Polizas_Grupo.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Certificados Accidentes y Enfermedades Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Certificados_Gastos_Medicos.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Certificados Vida Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Certificados_Vida.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Certificados Automóviles Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Certificados_Automoviles.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Certificados Daños Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Certificados_Danios.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Certificados Incendio Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Certificados_Incendio.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Certificados Diversos Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Certificados_Diversos.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Flotilla Masiva</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Flotillas_Masiva.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout Cancelación Pólizas</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_De_Cancelacion.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr><tr><td>Layout No Renovación Pólizas ID</td><td ng-click=\"$event.stopPropagation();\"><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Polizas_NoRenovacionID.xls\"><button class=\"btn btn-success\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</button></a></td></tr></tbody></table></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/block-page/block-page.html","<div class=\"gray-bg\"><div class=\"lock-word animated fadeInDown\"><span class=\"first-word\">LOCKED</span><span>SCREEN</span></div><div class=\"middle-box text-center lockscreen animated fadeInDown\"><div><div class=\"m-b-md\"><img alt=\"image\" class=\"img-circle circle-border block-img\" src=\"{{ avatar }}\"></div><h3>{{ info.fname }} {{ info.lname }}</h3><p ng-if=\"!error_message\">Usted está en la pantalla de bloqueo. La aplicación principal se ha cerrado y debes introducir tu password para volver a la aplicación.</p><p ng-if=\"error_message\">{{ error_message }}</p><form class=\"m-t\" role=\"form\"><div class=\"form-group\"><input type=\"password\" ng-model=\"password\" class=\"form-control\" placeholder=\"******\" required=\"\"></div><button ng-click=\"unlock(password)\" class=\"btn btn-primary block full-width\">Desbloquear</button></form></div></div></div>");
$templateCache.put("app/buscador/buscador.template.html","<br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Resultados de la búsqueda</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-10 col-md-offset-1\"><div class=\"ibox-title exp-coll flex-container\" ng-if=\"acceso_ver_cont\" ng-click=\"seekerContractors();testPagination(\'naturals\', \'config_cont_naturals\')\"><strong><div class=\"color-tittle\">Contratantes ({{conteos.contractors}})</div></strong> <span class=\"fa fa-plus\" ng-if=\"!showContractors\"></span> <span class=\"fa fa-minus\" ng-if=\"showContractors\"></span></div><div class=\"ibox-content\" ng-if=\"showContractors\"><uib-tabset active=\"active\"><uib-tab id=\"naturals\" index=\"0\"><uib-tab-heading>Fisicas({{naturals.length}})</uib-tab-heading><table class=\"table table-stripped table-hover\"><thead><tr><th>Nombre</th><th>Fecha de Nacimiento</th><th>Email</th><th>Tipo</th></tr></thead><tbody><tr ng-repeat=\"natural in naturals\" ng-click=\"goToContractorView(natural)\"><td>{{natural.full_name}}</td><td>{{natural.birth_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{natural.email}}</td><td>{{natural.type_person}}</td></tr></tbody></table><div ng-if=\"show_pag_cont_naturals && config_cont_naturals.count > 10 || con_type == 1\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></uib-tab><uib-tab id=\"juridicals\" index=\"1\"><uib-tab-heading>Morales({{juridicals.length}})</uib-tab-heading><table class=\"table table-stripped table-hover\"><thead><tr><th>Nombre</th><th>Fecha de Constitución</th><th>Email</th><th>Tipo</th></tr></thead><tbody><tr ng-repeat=\"juridical in juridicals\" ng-click=\"goToContractorView(juridical)\"><td>{{juridical.full_name}}</td><td>{{juridical.birth_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{juridical.email}}</td><td>{{juridical.type_person}}</td></tr></tbody></table><div ng-if=\"show_pag_cont_juridical && config_cont_juridical.count > 10 || con_type == 2\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPagesJ()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPagesJ | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPageJ(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPagesJ.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div></uib-tab></uib-tabset></div><div><div class=\"ibox-title exp-coll flex-container\" ng-if=\"acceso_ver_pol\" ng-click=\"seekerPolicies(0,0); testPagination(\'policies\', \'config_policies\')\"><strong><div class=\"color-tittle\">Pólizas ({{conteos.policies}})</div></strong> <span class=\"fa fa-plus\" ng-if=\"!showPolicies\"></span> <span class=\"fa fa-minus\" ng-if=\"showPolicies\"></span></div><div class=\"ibox-content\" ng-if=\"showPolicies\"><table class=\"table table-stripped table-hover\"><thead><tr><th>Tipo</th><th>Identificador</th><th>Número de Póliza</th><th ng-click=\"orderVigencia()\">Vigencia <span ng-class=\"{\'fa fa-sort-desc\': order_type_asc == 1, \'fa fa-sort-asc\': order_type_asc == 2}\"></span></th><th>Aseguradora</th><th ng-if=\"subramos_result.length > 1\"><div class=\"btn-group pull-right\"><button class=\"btn\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"background: white;margin-top: -7px;\"><strong>Subramo</strong><span class=\"fa fa-caret-down\"></span><div ng-if=\"conteoSubramo\" class=\"text-muted\" style=\"font-size: 11px; line-height: 1;\">Conteo: {{totalSubramo}}</div></button><ul class=\"dropdown-menu\"><li ng-repeat=\"subramo in subramos_result\" ng-if=\"subramo.subramo_name\"><a ng-click=\"resultsBySubramo(subramo)\">{{subramo.subramo_name}} - {{subramo.ramo.provider}}</a></li></ul></div></th><th ng-if=\"!(subramos_result.length > 1)\">Subramo</th><th>Contratante</th><th><div class=\"btn-group pull-right\"><button class=\"btn\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"background: white;margin-top: -7px; text-align:left;\"><strong>Estatus</strong><span class=\"fa fa-caret-down\"></span><div ng-if=\"conteoEstatus\" class=\"text-muted\" style=\"font-size: 11px; line-height: 1;\">Conteo: {{totalEstatus}}</div></button><ul class=\"dropdown-menu\"><li><a ng-click=\"seekerPolicies(1,10)\">Por iniciar</a></li><li><a ng-click=\"seekerPolicies(1,11)\">Cancelada</a></li><li><a ng-click=\"seekerPolicies(1,12)\">Renovadas</a></li><li><a ng-click=\"seekerPolicies(1,13)\">Vencidas</a></li><li><a ng-click=\"seekerPolicies(1,14)\">Vigentes</a></li><li><a ng-click=\"seekerPolicies(1,15)\">No renovadas</a></li><li><a ng-click=\"seekerPolicies(1,0)\">Todos</a></li></ul></div></th><th>Asegurado / Serie</th></tr></thead><tbody><tr ng-repeat=\"policy in policies track by $index\" ng-click=\"goToPolicy(policy)\"><td ng-if=\"policy.document_type == 1\">Póliza</td><td ng-if=\"policy.document_type == 3\">Póliza de Grupo</td><td ng-if=\"policy.document_type == 6\">Certificado</td><td ng-if=\"policy.document_type == 11\">Colectividad</td><td ng-if=\"policy.document_type == 12\">Póliza de Colectividad</td><td>{{policy.identifier}}</td><td>{{policy.poliza_number}}</td><td>{{(policy.start_of_validity) | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{(policy.end_of_validity) | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{policy.aseguradora}}</td><td>{{policy.subramo}}</td><td ng-if=\"policy.contractor\">{{policy.contractor.full_name}}</td><td>{{status(policy.status)}} <span ng-if=\"orgName ==\'ancora\' && policy.renewed_status ==2 && policy.is_renewable==1\">- En Proceso de Renovación</span></td><td>{{ policy.accidents_policy[0].personal.full_name }} <span ng-if=\"policy.automobiles_policy && policy.automobiles_policy[0]\">{{ policy.automobiles_policy[0].serial }} || {{ policy.automobiles_policy[0].brand }} || {{ policy.automobiles_policy[0].model }} || {{ policy.automobiles_policy[0].year }}</span> <span>{{ policy.life_policy[0].personal.full_name }} {{ policy.damages_policy[0].insured_item }}</span></td></tr></tbody></table><div ng-if=\"show_pag_policies\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div><div><div class=\"ibox-title exp-coll flex-container\" ng-if=\"acceso_ver_fia\" ng-click=\"seekerFianzas(); testPagination(\'fianzas\', \'config_fianzas\')\"><strong><div class=\"color-tittle\">Fianzas ({{conteos.fianzas}})</div></strong> <span class=\"fa fa-plus\" ng-if=\"!showFianzas\"></span> <span class=\"fa fa-minus\" ng-if=\"showFianzas\"></span></div><div class=\"ibox-content\" ng-if=\"showFianzas\"><table class=\"table table-stripped table-hover\"><thead><tr><th>Identificador</th><th>Número de Fianza</th><th>Afianzadora</th><th>Subramo</th><th>Contratante</th><th>Estatus</th><th>Inicio - Fin</th></tr></thead><tbody><tr ng-repeat=\"fianza in fianzas track by $index\" ng-click=\"goToFianza(fianza)\"><td>{{fianza.identifier}}</td><td>{{fianza.poliza_number}}</td><td>{{fianza.aseguradora}}</td><td>{{fianza.subramo}}</td><td ng-if=\"fianza.contractor\">{{fianza.contractor.full_name}}</td><td>{{status(fianza.status)}}</td><td>{{fianza.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{fianza.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</td></tr></tbody></table><div ng-if=\"fianzas && show_pag_fianzas\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPagesF()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPagesF | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPageF(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPagesF()\" ng-if=\"totalPagesF.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPageF()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div><div><div class=\"ibox-title exp-coll flex-container\" ng-if=\"acceso_ver_ot\" ng-click=\"searchOTs(); testPagination(\'ots\', \'config_ots\')\"><strong><div class=\"color-tittle\">OTs ({{conteos.ots}})</div></strong> <span class=\"fa fa-plus\" ng-if=\"!showOT\"></span> <span class=\"fa fa-minus\" ng-if=\"showOT\"></span></div><div class=\"ibox-content\" ng-if=\"showOT\"><table class=\"table table-stripped table-hover\"><thead><tr><th>Tipo</th><th>Identificador</th><th>Folio Interno</th><th>Contratante</th><th>Aseguradora</th><th>Subramo</th><th>Estatus</th></tr></thead><tbody><tr ng-repeat=\"ot in ots_endosos.ots track by $index\" ng-click=\"goToPolicy(ot)\"><td><span ng-if=\"ot.document_type ==1\">Póliza</span> <span ng-if=\"ot.document_type ==3\">Póliza de Grupo</span> <span ng-if=\"ot.document_type ==7\">Fianza</span> <span ng-if=\"ot.document_type ==8\">Fianza Colectiva</span> <span ng-if=\"ot.document_type ==6\">Certificado</span> <span ng-if=\"ot.document_type ==10\">Certificado Fianza</span> <span ng-if=\"ot.document_type ==11\">Colectividad</span> <span ng-if=\"ot.document_type ==12\">Póliza de Colectividad</span></td><td>{{ot.identifier}}</td><td>{{ot.internal_number}}</td><td ng-if=\"ot.contractor\">{{ot.contractor.full_name}}</td><td>{{ot.aseguradora}}</td><td>{{ot.subramo}}</td><td>{{status(ot.status)}}</td></tr><tr ng-repeat=\"ot_h in ot_historic track by $index\" ng-click=\"goToPolicy(ot_h)\"><td>OT</td><td>{{ot_h.internal_number}}</td><td ng-if=\"ot_h.contractor\">{{ot_h.contractor}}</td><td>{{ot_h.aseguradora}}</td><td>{{ot_h.subramo}}</td><td>{{status(ot_h.status)}}</td></tr><tr ng-repeat=\"otfianza in ots_fianza track by $index\" ng-click=\"goToFianza(otfianza)\"><td><span ng-if=\"ot.document_type ==1\">Póliza</span> <span ng-if=\"ot.document_type ==3\">Póliza de Grupo</span> <span ng-if=\"ot.document_type ==7\">Fianza</span> <span ng-if=\"ot.document_type ==8\">Fianza Colectiva</span> <span ng-if=\"ot.document_type ==6\">Certificado</span> <span ng-if=\"ot.document_type ==10\">Certificado Fianza</span> <span ng-if=\"ot.document_type ==11\">Colectividad</span> <span ng-if=\"ot.document_type ==12\">Póliza de Colectividad</span></td><td>{{otfianza.internal_number}}</td><td ng-if=\"otfianza.contractor\">{{otfianza.contractor.full_name}}</td><td>{{otfianza.afianzadora}}</td><td>{{otfianza.subramo}}</td><td ng-if=\"otfianza.status == 1\">Pendiente</td><td ng-if=\"otfianza.status != 1\">En trámite</td></tr><tr ng-repeat=\"ot in ots_endosos.endosos track by $index\" ng-click=\"goToEndorsement(ot)\"><td>Endoso</td><td>{{ot.internal_number}}</td><td>{{ot.policy.contractor.full_name}}</td><td>{{ot.policy.aseguradora}}</td><td>{{ot.policy.subramo}}</td><td ng-if=\"ot.status == 1\">Pendiente</td><td ng-if=\"ot.status != 1\">En trámite</td></tr></tbody></table><div ng-if=\"show_pag_ots\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div><div><div><div class=\"ibox-title exp-coll flex-container\" ng-if=\"acceso_ver_cont\" ng-click=\"seekerGroups(); testPagination(\'groups\', \'groups_config\')\"><strong><div class=\"color-tittle\">Grupos ({{conteos.groups}})</div></strong> <span class=\"fa fa-plus\" ng-if=\"!showGroups\"></span> <span class=\"fa fa-minus\" ng-if=\"showGroups\"></span></div><div class=\"ibox-content\" ng-if=\"showGroups\"><table class=\"table table-stripped table-hover\"><thead><tr><th>Nombre</th><th>Descripción</th></tr></thead><tbody><tr ng-repeat=\"group in groups\" ng-click=\"goToGroups(group)\"><td>{{group.group_name}}</td><td>{{group.description}}</td></tr></tbody></table><div ng-if=\"show_pag_groups\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div><div><div class=\"ibox-title exp-coll flex-container\" ng-click=\"seekerProviders(); testPagination(\'providers\', \'providers_config\')\"><strong><div class=\"color-tittle\">Aseguradoras ({{conteos.providers}})</div></strong> <span class=\"fa fa-plus\" ng-if=\"!showProviders\"></span> <span class=\"fa fa-minus\" ng-if=\"showProviders\"></span></div><div class=\"ibox-content\" ng-if=\"showProviders\"><table class=\"table table-stripped table-hover\"><thead><tr><th>Alias</th><th>RFC</th></tr></thead><tbody><tr ng-repeat=\"prov in providers\" ng-click=\"goToProvider(prov)\"><td>{{prov.compania}}</td><td>{{prov.rfc}}</td></tr></tbody></table><div ng-if=\"show_pag_providers\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div><div><div class=\"ibox-title exp-coll flex-container\" ng-if=\"acceso_adm_sin\" ng-click=\"seekerSinisters(); testPagination(\'sinisters\', \'siniesters_config\')\"><strong><div class=\"color-tittle\">Siniestros ({{conteos.sinisters}})</div></strong> <span class=\"fa fa-plus\" ng-if=\"!showSinisters\"></span> <span class=\"fa fa-minus\" ng-if=\"showSinisters\"></span></div><div class=\"ibox-content\" ng-if=\"showSinisters\"><table class=\"table table-stripped table-hover\"><thead><tr><th>Folio Interno</th><th>Afectado</th><th>Folio Compañia</th><th>Número de Siniestro</th><th>Padecimiento</th><th>Contratante</th><th>Subramo</th><th>Fecha</th><th>Estatus</th></tr></thead><tbody><tr ng-repeat=\"sinister in sinisters\" ng-click=\"siniestrosInfo({siniestroId: sinister.id},{sinisterRamo: sinister.ramo},{sinisterSubramo: sinister.poliza.subramo},sinisters,sinister)\"><td>{{sinister.folio_interno}}</td><td><span ng-if=\"sinister.poliza.accidents_policy.length\"><span ng-if=\"sinister.accidente_sinister[0].dependiente\">{{ sinister.accidente_sinister[0].dependiente.first_name }} {{ sinister.accidente_sinister[0].dependiente.last_name }} {{ sinister.accidente_sinister[0].dependiente.second_last__name }}</span> <span ng-if=\"sinister.accidente_sinister[0].titular\">{{ sinister.accidente_sinister[0].titular.first_name }} {{ sinister.accidente_sinister[0].titular.last_name }} {{ sinister.accidente_sinister[0].titular.second_last__name }}</span></span> <span ng-if=\"sinister.vida_siniester.length\"><span ng-if=\"sinister.vida_siniester[0].nombre_afectado\">{{ sinister.vida_siniester[0].nombre_afectado }}</span> <span ng-if=\"sinister.accidente_sinister[0].titular\">{{ sinister.accidente_sinister[0].titular.first_name }} {{ sinister.accidente_sinister[0].titular.last_name }} {{ sinister.accidente_sinister[0].titular.second_last__name }}</span> <span ng-if=\"!sinister.accidente_sinister && sinister.accidente_sinister.affected_full_name\">{{ sinister.accidente_sinister.affected_full_name }}</span></span> <span ng-if=\"sinister.poliza.automobiles_policy.length\">NO APLICA</span> <span ng-if=\"sinister.poliza.damages_policy.length\">{{sinister.poliza.damages_policy[0].insured_item}}</span> <span ng-if=\"sinister.danios_sinister[0].bien_asegurado && !sinister.poliza.damages_policy.length\">{{sinister.danios_sinister[0].bien_asegurado}}</span> <span ng-if=\"!sinister.danios_sinister[0].bien_asegurado && !sinister.poliza.damages_policy.length\">{{ sinister.aux_affected }}</span> <span ng-if=\"sinister.poliza.life_policy.length && !sinister.vida_siniester[0].nombre_afectado\"><span ng-if=\"sinister.poliza.life_policy[0].personal.full_name\">{{ sinister.poliza.life_policy[0].personal.full_name }}</span> <span ng-if=\"!sinister.poliza.life_policy[0].personal.full_name\">{{ sinister.poliza.life_policy[0].personal.first_name }} {{ sinister.poliza.life_policy[0].personal.last_name }}</span></span> <span ng-if=\"sinister.poliza.life_policy.length\">{{ sinister.poliza.life_policy[0].personal.full_name }}</span></td><td>{{sinister.folio_compania}}</td><td>{{sinister.numero_siniestro}}</td><td><span ng-if=\"sinister.accidente_sinister && sinister.accidente_sinister[0] && sinister.accidente_sinister[0].padecimiento && sinister.accidente_sinister[0].padecimiento.descr\">{{sinister.accidente_sinister[0].padecimiento.descr}}</span> <span ng-if=\"sinister.accidente_sinister && sinister.accidente_sinister[0] && !sinister.accidente_sinister[0].padecimiento\">{{sinister.accidente_sinister[0].ailment}}</span></td><td>{{sinister.poliza.contractor}}</td><td>{{sinister.poliza.subramo}}</td><td>{{sinister.fecha_siniestro | date : \'dd/MM/yyyy\' : \'UTC\'}}</td><td ng-switch=\"sinister.status\"><span ng-switch-when=\"1\">Pendiente</span> <span ng-switch-when=\"2\">En Trámite</span> <span ng-switch-when=\"3\">Completado</span> <span ng-switch-when=\"4\">Cancelado</span> <span ng-switch-when=\"5\">Rechazado</span> <span ng-switch-when=\"6\">En Espera</span> <span ng-switch-when=\"7\">Reproceso</span> <span ng-switch-when=\"8\">Inconformidad</span></td></tr></tbody></table><div ng-if=\"show_pag_sinisters\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div><div><div class=\"ibox-title exp-coll flex-container\" ng-if=\"acceso_ver_ot\" ng-click=\"seekerEndorsments(1,1); testPagination(\'endorsments\', \'endorsments_config\')\"><strong><div class=\"color-tittle\">Endosos ({{conteos.endorsments}})</div></strong> <span class=\"fa fa-plus\" ng-if=\"!showEndorsments\"></span> <span class=\"fa fa-minus\" ng-if=\"showEndorsments\"></span></div><div class=\"ibox-content\" ng-if=\"showEndorsments\"><table class=\"table table-stripped table-hover\"><thead><tr><th ng-click=\"changeEndosos(1, end_num == 1 ? 2 : 1)\">Número de Endoso</th><th ng-click=\"changeEndosos(2, end_tipo == 1 ? 2 : 1)\">Tipo de Endoso</th><th ng-click=\"changeEndosos(3, end_nump == 1 ? 2 : 1)\">Número de Póliza/Fianza</th><th ng-click=\"changeEndosos(5, end_status == 1 ? 2 : 1)\">Descripción</th><th ng-click=\"changeEndosos(4, end_form == 1 ? 2 : 1)\">Formulario</th><th ng-click=\"changeEndosos(5, end_status == 1 ? 2 : 1)\">Estatus</th></tr></thead><tbody><tr ng-repeat=\"endo in endorsments\" ng-click=\"goToEndorsement(endo)\"><td>{{endo.number_endorsement}}</td><td>{{endo.endorsement_type}}</td><td>{{endo.policy.poliza_number}}{{endo.fianza.fianza_number}}</td><td>{{endo.observations}}</td><td>{{endo.policy.subramo}}</td><td>{{endo.status | endorsement}}</td></tr></tbody></table><div ng-if=\"show_pag_endorsments\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div><div class=\"ibox-title exp-coll flex-container\" ng-if=\"acceso_ver_cob\" ng-click=\"searchReceipts(); testPagination(\'receipts\', \'config_receipts\')\"><strong><div class=\"color-tittle\">Recibos ({{conteos.recibos}})</div></strong> <span class=\"fa fa-plus\" ng-if=\"!showReceipts\"></span> <span class=\"fa fa-minus\" ng-if=\"showReceipts\"></span></div><div class=\"ibox-content\" ng-if=\"showReceipts\"><table class=\"table table-stripped table-hover\"><thead><tr><th>Tipo</th><th>Serie</th><th>Número de Póliza</th><th>Aseguradora</th><th>Subramo</th><th>Contratante</th><th>Estatus</th><th>Inicio - Fin</th></tr></thead><tbody><tr ng-repeat=\"policy in receipts track by $index\" ng-click=\"editRecibo(policy)\"><td ng-if=\"policy.poliza.document_type == 12 && policy.receipt_type == 1\">Póliza de Colectividad</td><td ng-if=\"policy.poliza.document_type == 1 && policy.receipt_type == 1\">Póliza</td><td ng-if=\"policy.poliza.document_type == 7 && policy.receipt_type == 1\">Fianza</td><td ng-if=\"policy.poliza.document_type == 3 && policy.receipt_type == 1\">Póliza de Grupo</td><td ng-if=\"policy.receipt_type == 2\">Endoso</td><td ng-if=\"policy.receipt_type == 3\">Nota Crédito / Endoso</td><td>{{policy.recibo_numero}}</td><td>{{policy.poliza.poliza_number}}{{policy.fianza.fianza_number}}</td><td>{{policy.poliza.aseguradora}}{{policy.fianza.afianzadora}}</td><td>{{policy.poliza.ramo}}{{policy.fianza.ramo}}</td><td><span ng-if=\"policy.poliza.contractor\">{{policy.poliza.contractor.full_name}}</span></td><td>{{policy.status}}</td><td>{{policy.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{policy.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</td></tr></tbody></table><div ng-if=\"show_pag_receipts\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div><div class=\"ibox-title exp-coll flex-container\" ng-if=\"acceso_ver_pol\" ng-click=\"seekerCerts(0,0); testPagination(\'policies\', \'config_policies\')\"><strong><div class=\"color-tittle\">Certificados ({{conteos.certificados}})</div></strong> <span class=\"fa fa-plus\" ng-if=\"!showReceipts\"></span> <span class=\"fa fa-minus\" ng-if=\"showReceipts\"></span></div><div class=\"ibox-content\" ng-if=\"showCerts\"><table class=\"table table-stripped table-hover\"><thead><tr><th>Tipo</th><th>Número de Póliza</th><th>Estatus</th><th ng-click=\"orderVigencia()\">Vigencia <span ng-class=\"{\'fa fa-sort-desc\': order_type_asc == 1, \'fa fa-sort-asc\': order_type_asc == 2}\"></span></th><th ng-if=\"subramos_result.length > 1\"><div class=\"btn-group pull-right\"><button class=\"btn\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"background: white;margin-top: -7px;\"><strong>Subramo</strong><span class=\"fa fa-caret-down\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"subramo in subramos_result\" ng-if=\"subramo.subramo_name\"><a ng-click=\"resultsBySubramo(subramo)\">{{subramo.subramo_name}} - {{subramo.ramo.provider}}</a></li></ul></div></th><th ng-if=\"!(subramos_result.length > 1)\">Subramo</th></tr></thead><tbody><tr ng-repeat=\"policy in policies track by $index\" ng-click=\"goToPolicy(policy)\" foo-repeat-done=\"\"><td ng-if=\"policy.document_type == 1\">Póliza</td><td ng-if=\"policy.document_type == 3\">Póliza de Grupo</td><td ng-if=\"policy.document_type == 6\">Certificado</td><td ng-if=\"policy.document_type == 11\">Colectividad</td><td ng-if=\"policy.document_type == 12\">Póliza de Colectividad</td><td>{{policy.poliza_number}}</td><td><span ng-if=\"policy.certificado_inciso_activo\">Activo</span> <span ng-if=\"!policy.certificado_inciso_activo\">Inactivo</span></td><td>{{policy.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{policy.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{policy.subramo}}</td></tr></tbody></table><div ng-if=\"show_pag_policies\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/campaigns/campaign.modal.filter.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Correos del sistema</h4></div><div class=\"modal-body\"><div class=\"row\"><div ng-if=\"!vm.show_binnacle\"><div class=\"col-xs-12\"><h4>Por favor seleccione los correos que desee agregar:</h4><div class=\"col-xs-12\"><div class=\"col-xs-12\"><br></div><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"col-md-12 input-group\"><div class=\"col-md-6\"><label for=\"age_min\">(Edad) De:</label><select class=\"form-control\" ng-model=\"age_min\" ng-change=\"change_age_min(age_min)\" ng-options=\"age for age in ages track by age\"></select></div><div class=\"col-md-6\"><label for=\"age_max\">A:</label><select class=\"form-control\" ng-model=\"age_max\" ng-change=\"change_age_max(age_max)\" ng-options=\"age for age in ages track by age\"></select></div></div></div><div class=\"col-md-6\"><label>Sexo:</label><div class=\"col-md-6\"></div><select class=\"form-control\" ng-model=\"gender\" ng-change=\"change_sex(gender)\" ng-options=\"sex.id as sex.text for sex in genders\"></select></div></div></div><div class=\"col-xs-12\"><br></div><div class=\"row\"><div class=\"col-md-12\"><label>Estado:</label><select class=\"form-control\" ng-model=\"estado\" ng-change=\"change_state(estado)\" ng-options=\"estado.id as estado.state for estado in statesArray\"></select></div></div><div class=\"col-xs-12\"><br></div><div class=\"row\"><div class=\"col-md-12\"><label>Municipio:</label><select class=\"form-control\" ng-model=\"ciudad\" ng-change=\"change_ciudad(ciudad)\" ng-options=\"ciudad.id as ciudad.city for ciudad in cities\"></select></div></div><div class=\"row\"><div class=\"col-xs-12 form-group container-loader\" ng-if=\"loader\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div></div><div class=\"col-xs-12\"><br></div><div class=\"row\"><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"show_filter_tags\" ng-change=\"changeShowFilterTags(show_filter_tags)\"><b>Mostrar e-mails</b></div><div class=\"col-xs-12\"><br></div><div class=\"col-md-12\" ng-if=\"show_filter_tags\"><label>Se enviara a:</label><tags-input ng-model=\"email_filter_tags\"></tags-input></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button class=\"btn btn-primary ladda-button\" ng-disabled=\"\" ng-click=\"add_emails()\">Agregar correos</button></div></div></div>");
$templateCache.put("app/campaigns/campaigns.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ vm.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><span>Editar Campaña</span></li><li class=\"active\"><strong>{{campaign.id}}</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Campaña</h5></div><div class=\"ibox-content\"><div ng-include=\"\'app/campaigns/campaigns.form.html\'\"></div></div></div></div></div>");
$templateCache.put("app/campaigns/campaigns.form.html","<form name=\"letterForm\" novalidate=\"\"><div class=\"row\"><div class=\"form-group col-xs-6 col-md-6\"><label class=\"control-label\" for=\"title\">Nombre de la campaña <span class=\"color-red\">*</span></label> <input class=\"form-control col-xs-12 col-sm-6\" ng-model=\"campaign.name\" type=\"text\" ng-change=\"updateSave()\" required=\"\"></div><div class=\"form-group col-xs-6 col-md-6\"><label class=\"control-label\" for=\"title\">Correo del remitente <span class=\"color-red\">*</span></label><div><select class=\"form-control\" name=\"emisor\" ng-model=\"campaign.sendingName\" ng-change=\"changeEmisor(campaign.sendingName);updateSave()\" ng-options=\"emisor.email as emisor.email +\' || \'+emisor.first_name + \' \' + emisor.last_name for emisor in emailsemisores\"><option value=\"\">Seleccione un emisor</option></select></div></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-md-3 pull-right\"><label class=\"control-label color-red\" for=\"name\">Repetir envío:</label><select class=\"form-control\" ng-model=\"campaign.repeatEmail\" ng-options=\"frequency.id as frequency.text for frequency in send_frequency\" ng-change=\"change_frequency(campaign.repeatEmail)\"></select></div><div class=\"form-group col-xs-12 col-md-12\"><label class=\"control-label\" for=\"title\">Asunto: <span class=\"color-red\">*</span></label> <textarea type=\"text\" class=\"form-control col-xs-12 col-sm-6\" name=\"subject\" ng-model=\"campaign.subject\" ng-change=\"updateSave()\" required=\"\"></textarea></div></div><div class=\"row m-t\"><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"mostrarFiltros = !mostrarFiltros; addTaskOK()\" type=\"button\"><i class=\"fa fa-at\" aria-hidden=\"true\"></i> Correos del Sistema</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-success col-xs-12\" ng-click=\"massive_load()\" type=\"button\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i> Carga Masiva</button></div></div><div class=\"row form-group col-xs-12\"><div ng-if=\"conciliar_masivos\"><div class=\"col-xs-12 col-md-4\"><label>Archivo Excel</label> <input type=\"file\" fileread=\"\" ng-model=\"excelFile\" name=\"readCsvFile\" id=\"readCsvFile\" ng-change=\"selectExcel(excelFile)\"></div></div></div><div class=\"row\" ng-show=\"mostrarFiltros\"><div class=\"col-xs-12\"><h4>Por favor seleccione los correos que desee agregar:</h4><hr></div><div class=\"col-xs-12\" ng-if=\"campaign.id\"><h4 ng-if=\"group_to_show != 0\"><b>Grupos actuales en la campaña:</b> <span ng-repeat=\"grupo in group_to_show track by $index\">{{grupo}},</span></h4><h4 ng-if=\"provider_to_show != 0\"><b>Aseguradoras actuales en la campaña:</b> <span ng-repeat=\"aseg in provider_to_show track by $index\">{{aseg}},</span></h4><h4 ng-if=\"ramo_to_show != 0\"><b>Ramos actuales en la campaña:</b> <span ng-repeat=\"ramo in ramo_to_show track by $index\">{{ramo}},</span></h4><h4 ng-if=\"subramo_to_show != 0\"><b>Subramos actuales en la campaña:</b> <span ng-repeat=\"subramo in subramo_to_show track by $index\">{{subramo}},</span></h4></div><div class=\"col-xs-12 col-md-3 form-group\"><label for=\"age_min\">Edad De:</label><select class=\"form-control\" ng-model=\"campaign.age_min\" ng-change=\"change_age_min(campaign.age_min); updateSave()\" ng-options=\"age for age in ages track by age\"></select></div><div class=\"col-xs-12 col-md-3 form-group\"><label for=\"age_max\">Edad A:</label><select class=\"form-control\" ng-model=\"campaign.age_max\" ng-change=\"change_age_max(campaign.age_max); updateSave()\" ng-options=\"age for age in ages track by age\"></select></div><div class=\"col-xs-12 col-md-3 form-group\"><label>Sexo:</label><select class=\"form-control\" ng-model=\"campaign.sex\" ng-change=\"change_sex(campaign.sex); updateSave()\" ng-options=\"sex.id as sex.text for sex in genders\"></select></div><div class=\"col-xs-12 col-md-3 form-group\"><label>Tipo de Contratante:</label><select class=\"form-control\" ng-model=\"campaign.type_contractor\" ng-change=\"change_tipo(campaign.type_contractor); updateSave()\" ng-options=\"tipo.id as tipo.text for tipo in tipos\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Forma de pago</label><select class=\"form-control\" ng-model=\"campaign.payment\" data-ng-options=\"payment.id as payment.name for payment in payments\" ng-change=\"change_payment(campaign.payment); updateSave()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia de póliza por:</label><select class=\"form-control\" ng-model=\"campaign.report\" ng-change=\"change_reporte(reporte_por); updateSave()\" ng-options=\"reporte.id as reporte.text for reporte in reportes_por\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"campaign.since\" value=\"{{campaign.since | date : \'medium\'}}\" ng-change=\"changeSince(campaign.since); updateSave()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"campaign.until\" value=\"{{campaign.until | date : \'medium\'}}\" ng-change=\"changeUntil(campaign.until); updateSave()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-lg-6 form-group\"><label>Grupo</label><select style=\"width: 100%\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"group_selected\" data-ng-options=\"grupo.group_name for grupo in campaign.grupos track by grupo.id\" ng-change=\"change_grupo(group_selected); updateSave()\"></select></div><div class=\"col-xs-12 col-lg-6 form-group\"><label>Estatus</label><select style=\"width: 100%\" class=\"js-example-basic-multiple form-control\" name=\"campaign.status\" multiple=\"multiple\" ng-model=\"select_status\" data-ng-options=\"status.id as status.name for status in status_\" ng-change=\"change_status(select_status)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-lg-3 form-group\"><label>Aseguradora(s)</label><select style=\"width: 100%\" class=\"js-example-basic-multiple form-control\" name=\"campaign.provider\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'compania\' track by providers.url\" ng-change=\"change_provider(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-lg-3 form-group\"><label>Ramo(s)</label><select style=\"width: 100%\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" data-ng-options=\"ramos_toselected.text for ramos_toselected in ramos_por track by ramos_toselected.id\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo); updateSave()\"></select></div><div class=\"col-xs-12 col-lg-3 form-group\"><label>Subramo(s)</label><select style=\"width: 100%\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"change_sramo(select_sramo); updateSave()\"></select></div><div class=\"col-xs-12 col-lg-3 form-group\"><label>Referenciador(es)</label><select style=\"width: 100%\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sreferenciador\" data-ng-options=\"referenciador_toselected.username for referenciador_toselected in users | orderBy: \'username\' track by referenciador_toselected.url\" ng-change=\"change_sreferenciadores(select_sreferenciador); updateSave()\"></select></div><div class=\"col-xs-12 col-sm-4 form-group pull-right\"><button class=\"btn btn-success col-xs-6\" ng-click=\"getEmailsBack()\" type=\"button\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Consultar Correos</button></div></div><div class=\"col-xs-12 form-group\"><label class=\"control-label\" for=\"title\">Destinatarios: <span class=\"color-red\">*</span></label><tags-input ng-model=\"email_filter_tags\" key-property=\"id\" display-property=\"text\" ng-disabled=\"true\"></tags-input></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-white col-xs-12\" ng-click=\"cleanEmails()\" type=\"button\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i> Borrar Correos</button></div><div class=\"row\"><div class=\"form-group col-xs-12\"><button type=\"button\" class=\"btn btn-default ng-scope\" unselectable=\"on\" tabindex=\"-1\" ng-click=\"getFile()\" ng-disabled=\"!editor_focus\"><i class=\"fa fa-upload\"></i></button><div text-angular=\"\" ng-model=\"vm.htmlVariable\" name=\"myEditor\" ng-focus=\"focusEditor()\" ng-blur=\"unfocusEditor()\" ng-if=\"url_ == \'campaign.edit\'\"></div><div text-angular=\"\" ng-model=\"vm.htmlVariable\" name=\"myEditorCreate\" ng-focus=\"focusEditor()\" ng-blur=\"unfocusEditor()\" ng-if=\"url_ == \'campaign.create\'\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/upload.html\'\"></div><div ng-include=\"\'templates/show-files.html\'\"></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-3 pull-right\" ng-if=\"campaign.id && vm.acceso_cor\"><button class=\"btn btn-success col-xs-12\" ng-click=\"sendNow(campaign.id)\" type=\"button\"><i class=\"fa fa-sign-out\" aria-hidden=\"true\"></i> Enviar ahora</button></div><div class=\"col-xs-12 col-sm-3 pull-right\" ng-if=\"!campaign.id\"><button class=\"btn btn-success col-xs-12\" ng-click=\"save()\" type=\"button\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\" ng-disabled=\"letterForm.$invalid\"></i> Guardar</button></div><div class=\"col-xs-12 col-sm-3 pull-right\"><button class=\"btn btn-white col-xs-12\" ng-click=\"cancel()\" type=\"button\">Cancelar</button></div><div class=\"col-xs-12 col-sm-3 pull-right\" ng-if=\"campaign.id\"><button class=\"btn btn-success col-xs-12\" ng-disabled=\"letterForm.$invalid\" ng-click=\"save()\" type=\"button\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Actualizar</button></div></div></form><script type=\"text/javascript\">\n  function mostrarImagen(input) {\n    if (input.files && input.files[0]) {\n      var reader = new FileReader();\n      reader.onload = function (e) {\n        $(\'#img_destino\').attr(\'src\', e.target.result);\n      }\n      reader.readAsDataURL(input.files[0]);\n    }\n  }\n   \n  $(\"#file_url\").change(function(){\n    mostrarImagen(this);\n  });\n\n  function renombrar(index) {\n    var test = $(index).attr(\'id\');\n    \n    try{\n      test = test.replace(\'rename_\',\'\')\n    }\n    catch(e){}\n\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n    inputTag.focus();\n    inputTag.show();\n  }\n\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(index){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.removeClass(\'display-none\');\n    dummy.addClass(\'display-none\');\n\n    inputTag.addClass(\'display-none\');\n    strongTag.removeClass(\'display-none\');\n  }\n</script>");
$templateCache.put("app/campaigns/campaigns.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ vm.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Crear campaña</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Nueva campaña</h5></div><div class=\"ibox-content\"><div ng-include=\"\'app/campaigns/campaigns.form.html\'\"></div></div></div></div></div>");
$templateCache.put("app/campaigns/campaigns.list.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ vm.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Campañas</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Campañas</h5></div><div class=\"ibox-content\"><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle\"><thead><th>Id</th><th>Nombre</th><th>Asunto</th><th>Fecha de creación</th><th>Fecha de envío</th><th>Envío</th><th>Activa</th></thead><tbody><tr ng-repeat=\"campaign in campaigns\"><td ng-click=\"$event.stopPropagation(); editCampaign(campaign)\">{{ campaign.id }}</td><td ng-click=\"$event.stopPropagation(); editCampaign(campaign)\">{{ campaign.name }}</td><td ng-click=\"$event.stopPropagation(); editCampaign(campaign)\">{{ campaign.subject }}</td><td ng-click=\"$event.stopPropagation(); editCampaign(campaign)\">{{ campaign.created_at | date:\'dd/MM/yyyy\': \'UTC\'}}</td><td ng-click=\"$event.stopPropagation(); editCampaign(campaign)\">{{ campaign.sendingDate | date:\'dd/MM/yyyy\': \'UTC\'}}</td><td ng-click=\"$event.stopPropagation(); editCampaign(campaign)\">{{ campaign.repeatEmail}}</td><td><button class=\"btn btn-white btn-sm\"></button><input type=\"checkbox\" ng-model=\"campaign.active_season\" ng-change=\"deactivate_campaign(campaign,1)\"> <button class=\"btn btn-white\" ng-click=\"deactivate_campaign(campaign,2)\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button ng-if=\"previous\" class=\"btn btn-success col-xs-12\" ng-click=\"goTo(previous)\" type=\"button\">Anterior</button> <button ng-if=\"next\" class=\"btn btn-success col-xs-12\" ng-click=\"goTo(next)\" type=\"button\">Siguiente</button></div></div></div></div></div>");
$templateCache.put("app/carga/carga.cancelacion.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Cancelación Masiva</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Cancelación Masiva de Pólizas</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Cancelación de Pólizas Por Carga Masiva</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!vm.file_cancelacion_polizas_loaded_by_id\"><label class=\"col-xs-12 btn btn-success\">Agregar Layout <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"selectExcelCancelacionPolizasById(excelFile)\"></label></div></div><div class=\"row\" ng-if=\"vm.loader_by_id\"><div class=\"col-xs-12 form-group container-loader\"><img src=\"../../assets/images/loader/bar_loader.gif\"></div></div><div class=\"row\"><div ng-if=\"vm.elementos_cancelacion_polizas_by_id && vm.elementos_cancelacion_polizas_by_id.length > 0 && vm.loader_by_id == false\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 btn btn-info\"><b>Pólizas encontradas</b></div><table class=\"table table-bordered table-hover\"><thead><th>ID</th><th>Número de póliza</th><th>Inicio de vigencia</th><th>Fecha de cancelación</th><th>Motivo de cancelación</th><th>Póliza encontrada</th><th>Póliza errónea</th><th>Póliza múltiple</th><th>Cancelar Notas Crédito</th></thead><tbody><tr ng-repeat=\"item in vm.elementos_cancelacion_polizas_by_id; track by $index\"><td>{{ item[\'ID_SAAM\'] }}</td><td>{{ item[\'POLIZA\'] }}</td><td>{{ item[\'INICIO_VIG_POLIZA\'] }}</td><td>{{ item[\'FECHA_DE_CANCELACION\'] }}</td><td>{{ item[\'MOTIVO\'] }}</td><td style=\"text-align: center;\"><span ng-if=\"!item.found\" class=\"label label-danger\">No Encontrada</span> <span ng-if=\"item.found\" class=\"label label-info\">Encontrada</span></td><td style=\"text-align: center;\"><span ng-if=\"item.error\" class=\"label label-danger\">Con error</span> <span ng-if=\"!item.error\" class=\"label label-info\">Sin error</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.multiple\" class=\"label label-info\">No</span> <span ng-if=\"item.multiple\" class=\"label label-danger\">Si</span></td><td style=\"text-align: center;\"><span ng-if=\"item.cancelnotas\" class=\"label label-danger\">Si</span> <span ng-if=\"!item.cancelnotas\" class=\"label label-danger\">No</span></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><span>Total de registros del layout: <b>{{ vm.elementos_cancelacion_polizas_by_id.length }}</b></span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button ng-if=\"vm.boton_por_id_habilitado\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"cancelPolizasMassive()\">Proceder con la cancelación</button></div></div></div></div></div></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/carga/carga.catalogo.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Catálogos</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Catálogos Cargas Masivas</strong></li></ol></div></div><br><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Catálogos</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"btn btn-primary col-xs-12 ladda-button\" ng-click=\"downloadExcel()\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar Catálogo</button></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante:</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.searchContratante\" change=\"matchesContractors(order.searchContratante)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"order.searchContratante\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Contratante</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ contractorLayout.id }}</span><br><small>Nombre: <span>{{ contractorLayout.name }}</span></small><br><small>ID para Layout Tipo: <span class=\"font-weight-bold\">{{ contractorLayout.type }}</span></small><br><small ng-if=\"contractorLayout.type == 1\">Tipo Contratante: <span>Física</span></small> <small ng-if=\"contractorLayout.type == 2\">Tipo Contratante: <span>Moral</span></small></td></tr></tbody></table></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"order.searchContratante\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"order.searchContratante\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Direcciones</th></tr></thead><tbody><tr ng-repeat=\"item in contractorLayout.address\"><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br><small>Nombre: <span>{{ item.administrative_area_level_2 }}, {{ item.administrative_area_level_1 }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Grupo:</label><select class=\"form-control\" data-ng-options=\"group.group_name for group in groups | orderBy:\'group_name\' track by group.url\" ng-model=\"groupLay\"><option value=\"\">Selecciona un grupo</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"groupLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Grupos</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ groupLay.id }}</span><br><small>Nombre: <span>{{ groupLay.group_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Aseguradora:</label><select class=\"form-control\" data-ng-options=\"provider.alias for provider in providersLayout | orderBy:\'alias\' track by provider.url\" ng-model=\"providerLay\" ng-change=\"getClaves(providerLay)\"><option value=\"\">Selecciona una aseguradora</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"providerLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Aseguradora</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ providerLay.id }}</span><br><small>Nombre: <span>{{ providerLay.alias }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Clave:</label><select class=\"form-control\" data-ng-options=\"clave.name for clave in clavesLayout | orderBy:\'name\' track by clave.url\" ng-model=\"claveLay\" ng-change=\"changeClave(claveLay)\"><option value=\"\">Selecciona una clave</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"claveLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Clave</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ claveLay.id }}</span><br><small>Nombre: <span>{{ claveLay.name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Ramo:</label><select class=\"form-control\" data-ng-options=\"ramo.ramo_name for ramo in ramosLayout | orderBy:\'ramo_name\' track by ramo.url\" ng-model=\"ramoLay\" ng-change=\"changeRamo(ramoLay)\"><option value=\"\">Selecciona una ramo</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"ramoLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Ramo</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ ramoLay.id }}</span><br><small>Nombre: <span>{{ ramoLay.ramo_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Subramo:</label><select class=\"form-control\" data-ng-options=\"subramo.subramo_name for subramo in subramosLayout | orderBy:\'subramo_name\' track by subramo.url\" ng-model=\"subramoLay\" ng-change=\"changeSubramo(subramoLay)\"><option value=\"\">Selecciona una ramo</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"subramoLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Subramo</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ subramoLay.id }}</span><br><small>Nombre: <span>{{ subramoLay.subramo_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Paquete:</label><select class=\"form-control\" data-ng-options=\"package.package_name for package in paquetesLayout | orderBy:\'package_name\' track by package.url\" ng-model=\"paqueteLay\"><option value=\"\">Selecciona un paquete</option></select><span ng-if=\"!paquetesLayout.length\">No hay paquetes en este subramo</span></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"paquetesLayout\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Paquete</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ paqueteLay.id }}</span><br><small>Nombre: <span>{{ paqueteLay.package_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Responsable:</label><select class=\"form-control\" data-ng-options=\"user.first_name + \' \' + user.last_name for user in usersLayout | orderBy:\'first_name\' track by user.url\" ng-model=\"responsableLay\"><option value=\"\">Selecciona un responsalbe</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"responsableLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Responsable</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ responsableLay.id }}</span><br><small>Nombre: <span>{{ responsableLay.first_name }} {{ responsableLay.last_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Ejecutivo de cobranza:</label><select class=\"form-control\" data-ng-options=\"user.first_name + \' \' + user.last_name for user in ejecutivosLayout | orderBy:\'first_name\' track by user.url\" ng-model=\"ejecutivoLay\"><option value=\"\">Selecciona un ejecutivo</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"ejecutivoLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Ejecutivo de cobranza</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ ejecutivoLay.id }}</span><br><small>Nombre: <span>{{ ejecutivoLay.first_name }} {{ ejecutivoLay.last_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Célula:</label><select class=\"form-control\" data-ng-options=\"celula.celula_name for celula in celulasLayout | orderBy:\'celula_name\' track by celula.url\" ng-model=\"celulaLay\"><option value=\"\">Selecciona una célula</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"celulaLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Célula</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ celulaLay.id }}</span><br><small>Nombre: <span>{{ celulaLay.celula_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Agrupación:</label><select class=\"form-control\" data-ng-options=\"agrupacion.description for agrupacion in agrupacionesLayout | orderBy:\'description\' track by agrupacion.url\" ng-model=\"agrupacionLay\" ng-change=\"changeAgrupacion(agrupacionLay)\"><option value=\"\">Selecciona una agrupación</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"agrupacionLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Agrupación</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ agrupacionLay.id }}</span><br><small>Nombre: <span>{{ agrupacionLay.description }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Subagrupación:</label><select class=\"form-control\" data-ng-options=\"agrupacion.description for agrupacion in subagrupacionesLayout | orderBy:\'description\' track by agrupacion.url\" ng-model=\"subagrupacionLay\" ng-change=\"changeSubagrupacion(subagrupacionLay)\"><option value=\"\">Selecciona una subagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"subagrupacionLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Subagrupación</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ subagrupacionLay.id }}</span><br><small>Nombre: <span>{{ subagrupacionLay.description }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Subsubagrupación:</label><select class=\"form-control\" data-ng-options=\"agrupacion.description for agrupacion in subsubagrupacionesLayout | orderBy:\'description\' track by agrupacion.url\" ng-model=\"subsubagrupacionLay\"><option value=\"\">Selecciona una subsubagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"subsubagrupacionLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Subsubagrupación</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ subsubagrupacionLay.id }}</span><br><small>Nombre: <span>{{ subsubagrupacionLay.description }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Sucursal:</label><select class=\"form-control\" data-ng-options=\"sucursal as sucursal.sucursal_name for sucursal in sucursalesLayout\" ng-model=\"sucursalLay\"><option value=\"\">Selecciona un sucursal</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"sucursalLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Sucursal</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ sucursalLay.id }}</span><br><small>Nombre: <span>{{ sucursalLay.sucursal_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Referenciador:</label><select class=\"form-control\" data-ng-options=\"user.first_name + \' \' + user.last_name for user in referenciadoresLayout | orderBy:\'first_name\' track by user.url\" ng-model=\"vendedorLay\"><option value=\"\">Selecciona un ejecutivo</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vendedorLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Referenciador</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ vendedorLay.id }}</span><br><small>Nombre: <span>{{ vendedorLay.first_name }} {{ vendedorLay.last_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Póliza Individual:</label><autocomplete datasource=\"policies_data\" id=\"policies\" model=\"order.searchPolicy\" change=\"matchesPolicies(order.searchPolicy)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"order.searchPolicy\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Póliza Individual</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ policyLay.id }}</span><br><small>Vigencia Inicio: <span>{{ policyLay.start }}</span></small><br><small>Vigencia Fin: <span>{{ policyLay.end }}</span></small><br><small>Número de Póliza: <span>{{ policyLay.poliza_number }}</span></small></td></tr></tbody></table><table class=\"table table-bordered table-hover\"><thead><tr><th>Recibos Póliza</th></tr></thead><tbody><tr ng-repeat=\"item in policyLay.recibos\" ng-if=\"item.receipt_type == 1\"><td><small>Número de serie: <span>{{ item.recibo_numero }}</span></small> - <small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Póliza de Grupo:</label><autocomplete datasource=\"caratules_data\" id=\"caratules\" model=\"order.searchCaratule\" change=\"matchesCaratules(order.searchCaratule)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"order.searchCaratule\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Póliza de Grupo</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ caratuleLay.id }}</span><br><small>Vigencia Inicio: <span>{{ caratuleLay.start }}</span></small><br><small>Vigencia Fin: <span>{{ caratuleLay.end }}</span></small><br><small>Número de Carátula: <span>{{ caratuleLay.poliza_number }}</span></small><br><small>Recibos por: <span ng-if=\"caratuleLay.receipts_by == 1\">Carátula</span> <span ng-if=\"caratuleLay.receipts_by == 2\">Subgrupo</span> <span ng-if=\"caratuleLay.receipts_by == 3\">Certificado</span></small></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratuleLay.receipts_by == 1\"><thead><tr><th>Recibos Carátula</th></tr></thead><tbody><tr ng-repeat=\"item in caratuleLay.recibos\" ng-if=\"item.receipt_type == 1\"><td><small>Número de serie: <span>{{ item.recibo_numero }}</span></small> - <small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Subgrupo:</label><select class=\"form-control\" data-ng-options=\"subgrupo as subgrupo.name for subgrupo in subgrupoLayout\" ng-model=\"subgrupoLay\" ng-change=\"changeSubgroup(subgrupoLay )\"><option value=\"\">Selecciona un subgrupo</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"subgrupoLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Póliza de Grupo</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ subgrupoLay.id }}</span><br><small>Nombre: <span>{{ subgrupoLay.name }}</span></small></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"subgrupoLay.recibos_poliza.length > 0\"><thead><tr><th>Recibos Subgrupo</th></tr></thead><tbody><tr ng-repeat=\"item in subgrupoLay.recibos_poliza\" ng-if=\"item.receipt_type == 1\"><td><small>Número de serie: <span>{{ item.recibo_numero }}</span></small> - <small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Categorías:</label><select class=\"form-control\" data-ng-options=\"categoria as categoria.name for categoria in categoriaLayout\" ng-model=\"categoriaLay\"><option value=\"\">Selecciona una categoría</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"categoriaLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Póliza de Grupo</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ categoriaLay.id }}</span><br><small>Nombre: <span>{{ categoriaLay.name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Paquete de Póliza de Grupo:</label><select class=\"form-control\" data-ng-options=\"packageG.package_name for packageG in paqueteGLayout | orderBy:\'package_name\' track by packageG.url\" ng-model=\"paqueteGLay\"><option value=\"\">Selecciona un paquete</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"paqueteGLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Paquete de Póliza de Grupo</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ paqueteGLay.id }}</span><br><small>Nombre: <span>{{ paqueteGLay.package_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Estado:</label><select class=\"form-control\" data-ng-options=\"state.state for state in statesArray | orderBy:\'state\' track by state.url\" ng-model=\"stateLay\"><option value=\"\">Selecciona un estado</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"stateLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Estado</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ stateLay.id }}</span><br><small>Nombre: <span>{{ stateLay.state }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Municipio:</label><select class=\"form-control\" data-ng-options=\"city.city for city in stateLay.cities | orderBy:\'city\' track by city.url\" ng-model=\"cityLay\"><option value=\"\">Selecciona un municipio</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"cityLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Municipio</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ cityLay.id }}</span><br><small>Nombre: <span>{{ cityLay.city }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Clasificación:</label><select class=\"form-control\" data-ng-options=\"cls.classification_name for cls in clasificaciones | orderBy:\'id\' track by cls.url\" ng-model=\"clasifiLay\"><option value=\"\">Selecciona una clasificación</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"clasifiLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Clasificación</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ clasifiLay.id }}</span><br><small>Nombre: <span>{{ clasifiLay.classification_name }}</span></small></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/carga/carga.certificados.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Carga Masiva</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Carga Masiva Certificados de Pólizas de Grupo</strong></li></ol></div></div><br><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carga Masiva Certificados de Pólizas de Grupo</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label>Ramo:</label><select class=\"form-control\" data-ng-options=\"item.name for item in ramos | orderBy: \'id\'\" ng-model=\"ramoSelected\" ng-change=\"chageRamo(ramoSelected)\"><option value=\"\">Selecciona un ramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando información...</span></div></div></div><div class=\"row\" ng-if=\"excelJsonViews.length\"><div class=\"col-xs-12 form-group\"><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\" ng-if=\"ramoSelected.name == \'Vida\'\"><thead><tr><td>Familia</td><td>Folio</td><td>Certificado</td><td>Correo</td><td>Tipo</td><td>Parentesco</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Tipo Suma Asegurada</td><td>Suma Asegurada</td><td>Sueldo</td><td>Fumador</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Número de Carátula</td><td>ID de Carátula</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.FAMILIA }}</td><td>{{ item.FOLIO }}</td><td>{{ item.CERTIFICADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.TIPO }}</td><td>{{ item.PARENTESCO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.FECHA_NACIMIENTO }}</td><td>{{ item.SEXO }}</td><td>{{ item.FECHA_ANTIGUEDAD }}</td><td>{{ item.TIPO_SUMA_ASEGURADA }}</td><td>{{ item.SUMA_ASEGURADA }}</td><td>{{ item.SUELDO }}</td><td>{{ item.FUMADOR }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.NO_CARATULA }}</td><td>{{ item.ID_CARATULA }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"ramoSelected.name == \'Accidentes y Enfermedades\'\"><thead><tr><td>Familia</td><td>Folio</td><td>Certificado</td><td>Correo</td><td>Tipo</td><td>Parentesco</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Número de Carátula</td><td>ID Carátula</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.FAMILIA }}</td><td>{{ item.FOLIO }}</td><td>{{ item.CERTIFICADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.TIPO }}</td><td>{{ item.PARENTESCO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.FECHA_NACIMIENTO }}</td><td>{{ item.SEXO }}</td><td>{{ item.FECHA_ANTIGUEDAD }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.NO_CARATULA }}</td><td>{{ item.ID_CARATULA }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"ramoSelected.name == \'Automóviles\'\"><thead><tr><td>Inciso</td><td>Propietario</td><td>Conductor</td><td>Correo</td><td>No. Empleado</td><td>Marca</td><td>Modelo</td><td>Año</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Uso</td><td>Servicio</td><td>Procedencia</td><td>Valor Asegurado</td><td>Tipo Carga</td><td>Adaptaciones</td><td>Monto Adaptaciones</td><td>Equipamineto</td><td>Monto Equipamineto</td><td>Beneficiario Preferente</td><td>Beneficiario RFC</td><td>Beneficiario Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Número de Carátula</td><td>ID de Carátula</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.PROPIETARIO }}</td><td>{{ item.CONDUCTOR }}</td><td>{{ item.CORREO }}</td><td>{{ item.NO_EMPLEADO }}</td><td>{{ item.MARCA }}</td><td>{{ item.MODELO }}</td><td>{{ item.ANIO }}</td><td>{{ item.VERSION }}</td><td>{{ item.SERIE }}</td><td>{{ item.MOTOR }}</td><td>{{ item.COLOR }}</td><td>{{ item.MATRICULA }}</td><td>{{ item.USO }}</td><td>{{ item.SERVICIO }}</td><td>{{ item.PROCEDENCIA }}</td><td>{{ item.VALOR_O_SUMA_ASEGURADA }}</td><td>{{ item.TIPO_CARGA }}</td><td>{{ item.ADAPTACIONES }}</td><td>{{ item.MONTO_ADAPTACIONES }}</td><td>{{ item.EQUIPAMIENTO }}</td><td>{{ item.MONTO_EQUIPAMIENTO }}</td><td>{{ item.BENEFICIARIO_PREFERENTE }}</td><td>{{ item.BENEFICIARIO_RFC }}</td><td>{{ item.BENEFICIARIO_DIRECCION }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.NO_CARATULA }}</td><td>{{ item.ID_CARATULA }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"ramoSelected.name == \'Incendio\'\"><thead><tr><td>CERTIFICADO</td><td>Sucursal</td><td>Correo</td><td>Giro</td><td>Tipo Constructivo</td><td>No. Niveles</td><td>Zona FHM</td><td>Zona TYEV</td><td>Calle</td><td>No. Interior</td><td>No. Exterior</td><td>Municipio</td><td>Colonia</td><td>Ciudad</td><td>Estado</td><td>Código Postal</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Número de Carátula</td><td>ID de Carátula</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.CERTIFICADO }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.CORREO }}</td><td>{{ item.GIRO }}</td><td>{{ item.TIPO_CONSTRUCTIVO }}</td><td>{{ item.NO_NIVELES }}</td><td>{{ item.ZONA_FHM }}</td><td>{{ item.ZONA_TYEV }}</td><td>{{ item.CALLE }}</td><td>{{ item.NO_INTERIOR }}</td><td>{{ item.NO_EXTERIOR }}</td><td>{{ item.MUNICIPIO }}</td><td>{{ item.COLONIA }}</td><td>{{ item.CIUDAD }}</td><td>{{ item.ESTADO }}</td><td>{{ item.CP }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.NO_CARATULA }}</td><td>{{ item.ID_CARATULA }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"ramoSelected.name == \'Diversos\'\"><thead><tr><td>CERTIFICADO</td><td>Propietario</td><td>No. Empleado</td><td>Correo</td><td>Descripción</td><td>Uso</td><td>Marca</td><td>Modelo</td><td>Año Construcción</td><td>Año Reconstrucción</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Permiso</td><td>Valor Compra</td><td>Calle</td><td>No. Interior</td><td>No. Exterior</td><td>Ciudad</td><td>Estado</td><td>Código Postal</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Número de Carátula</td><td>ID de Carátula</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.CERTIFICADO }}</td><td>{{ item.PROPIETARIO }}</td><td>{{ item.NO_EMPLEADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.DESCRIPCION }}</td><td>{{ item.USO }}</td><td>{{ item.MARCA }}</td><td>{{ item.MODELO }}</td><td>{{ item.ANO_CONSTRUCCION }}</td><td>{{ item.ANO_RECONSTRUCCION }}</td><td>{{ item.VERSION }}</td><td>{{ item.SERIE }}</td><td>{{ item.MOTOR }}</td><td>{{ item.COLOR }}</td><td>{{ item.MATRICULA }}</td><td>{{ item.PERMISO }}</td><td>{{ item.VALOR_COMPRA }}</td><td>{{ item.CALLE }}</td><td>{{ item.NO_INTERIOR }}</td><td>{{ item.NO_EXTERIOR }}</td><td>{{ item.CIUDAD }}</td><td>{{ item.ESTADO }}</td><td>{{ item.CP }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.NO_CARATULA }}</td><td>{{ item.ID_CARATULA }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"ramoSelected.name == \'Daños\'\"><thead><tr><td>CERTIFICADO</td><td>Bien Asegurado</td><td>Bien detalles</td><td>Bien dirección</td><td>Correo</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Número de Carátula</td><td>ID de Carátula</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.CERTIFICADO }}</td><td>{{ item.BIEN_ASEGURADO }}</td><td>{{ item.BIEN_DETALLES }}</td><td>{{ item.BIEN_DIRECCION }}</td><td>{{ item.CORREO }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.NO_CARATULA }}</td><td>{{ item.ID_CARATULA }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!loadingValidate\"><button class=\"col-xs-12 btn btn-success ladda-button2\" ng-click=\"validateCertificates()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Validar Certificados</button></div><div class=\"col-xs-12 text-center\" ng-if=\"loadingValidate\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Validando la información...</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!loadingSave && validado\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveCertificates()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Certificados</button></div><div class=\"col-xs-12 text-center\" ng-if=\"loadingSave\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Guardando la información...</span></div></div></div></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/carga/carga.certificados.modal.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Carga masiva certificados</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': true}\"><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-12\"><legend class=\"legend-title\" align=\"center\">Estatus</legend><table class=\"table table-bordered table-hover\"><thead><tr><td>Segmento:</td><td>Estatus:</td></tr></thead><tbody><tr ng-repeat=\"item in data_segmentada track by $index\"><td>{{ $index + 1 }}</td><td><div class=\"sk-spinner sk-spinner-rotating-plane margin-top-45p\"></div></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-12\"><legend class=\"legend-title\" align=\"center\">Registros erróneos</legend><table class=\"table table-bordered table-hover\"><thead><tr><td>Registro:</td><td>Error:</td></tr></thead><tbody><tr ng-repeat=\"item in segmentos_erroneos track by $index\"><td>Identificador: {{ item.item.identifier }} Carátula: {{ item.item.caratula }}</td><td ng-if=\"item.error!= \'Cargando...\'\">{{item.error}}</td><td ng-if=\"item.error== \'Cargando...\'\"><div class=\"sk-spinner sk-spinner-rotating-plane margin-top-45p\"></div></td></tr></tbody></table></div></div></div></div></div></form></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\'); \n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/carga/carga.contratante.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Carga Masiva</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Carga Masiva Contratantes</strong></li></ol></div></div><br><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carga Masiva Contratantes</h5></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group\"><button class=\"col-xs-12 btn btn-white ladda-button3\" ng-click=\"updateContractors()\"><i class=\"fa fa-whatsapp\" aria-hidden=\"true\"></i> Agregar Móvil a Contratantes Whatsapp/SMS</button></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group\" ng-if=\"!loadingValidate\"><button class=\"col-xs-12 btn btn-success ladda-button2\" ng-click=\"agregarContractors()\"><i class=\"fa fa-list\" aria-hidden=\"true\"></i> Agregar Contratantes</button></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"carga\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success ladda-button2\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\" onchange=\"angular.element(this).scope().fileNameChanged(this)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando información...</span></div></div><div class=\"row\" ng-if=\"excelJsonViews.length\"><div class=\"col-xs-12 form-group\"><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Tipo</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Nombre de la Empresa</td><td>Fecha Nacimiento</td><td>Fecha Contitución</td><td>RFC</td><td>Género</td><td>Grupo</td><td>Correo Electrónico</td><td>Teléfono</td><td>Sucursal</td><td>Clasificación</td><td>Célula</td><td>Agrupación</td><td>Subagrupación</td><td>Subsubagrupación</td><td>Tipo de Dirección</td><td>Estado</td><td>Municipio</td><td>Calle</td><td>No. Interior</td><td>No. Exterior</td><td>Colonia</td><td>Código Postal</td><td>Referencias</td><td>Observaciones</td><td>Referenciador</td><td>Responsable</td><td>VIP</td><td>Correo 2</td><td>Correo 3</td><td>Teléfono 2</td><td>Teléfono 3</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.TIPO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.NOMBRE_EMPRESA }}</td><td>{{ item.FECHA_NACIMIENTO }}</td><td>{{ item.FECHA_CONSTITUCION }}</td><td>{{ item.RFC }}</td><td>{{ item.GENERO }}</td><td>{{ item.GRUPO }}</td><td>{{ item.CORREO }}</td><td>{{ item.TELEFONO }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.CLASIFICACION }}</td><td>{{ item.CELULA }}</td><td>{{ item.AGRUPACION }}</td><td>{{ item.SUBAGRUPACION }}</td><td>{{ item.SUBSUBAGRUPACION }}</td><td>{{ item.TIPO_DIRECCION }}</td><td>{{ item.ESTADO }}</td><td>{{ item.MUNICIPIO }}</td><td>{{ item.CALLE }}</td><td>{{ item.NUM_INT }}</td><td>{{ item.NUM_EXT }}</td><td>{{ item.COLONIA }}</td><td>{{ item.CODIGO_POSTAL }}</td><td>{{ item.REFERENCIAS }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.REFERENCIADOR }}</td><td>{{ item.RESPONSABLE }}</td><td>{{ item.VIP }}</td><td>{{ item.CORREO_2 }}</td><td>{{ item.CORREO_3 }}</td><td>{{ item.TELEFONO_2 }}</td><td>{{ item.TELEFONO_3 }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelContractors()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveContractors()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Contratantes</button></div></div></div><div class=\"row\" ng-if=\"actualizacion\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success ladda-button3\">Agregar Archivo Actualización Móvil <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFileC\" ng-change=\"validateExcelUpd(excelFileC)\" onclick=\"limpiar()\" onchange=\"angular.element(this).scope().fileNameChanged(this)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando información...</span></div></div><div class=\"row\" ng-if=\"excelJsonViewsC.length\"><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Tipo</td><td>Nombre</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViewsC\"><td>{{ item.ID }}</td><td>{{ item.MOVIL }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelContractorsUpd()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveContractorsUpd()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Actualizar Contratantes</button></div></div></div></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/carga/carga.flotilla.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Carga Masiva</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Carga Masiva Flotillas</strong></li></ol></div></div><br><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carga Masiva Flotillas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success ladda-button2\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\" onchange=\"angular.element(this).scope().fileNameChanged(this)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando información...</span></div></div></div><div class=\"row\" ng-if=\"excelJsonViews.length\"><div class=\"col-xs-12 form-group\"><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Número de carátula</td><td>Identificador</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Contratante</td><td>Dirección</td><td>Aseguradora</td><td>Clave</td><td>Ramo</td><td>Subramo</td><td>Tipo de Carátula</td><td>Moneda</td><td>Linea de Negocio</td><td>Responsable</td><td>Renovable</td><td>Célula</td><td>Agrupación</td><td>Subagrupación</td><td>Subsubagrupación</td><td>Ejecutivo de Cobranza</td><td>Referenciador</td><td>ID de Póliza Anterior</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.NO_CARATULA }}</td><td>{{ item.IDENTIFICADOR }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.CONTRATANTE }}</td><td>{{ item.DIRECCION }}</td><td>{{ item.ASEGURADORA }}</td><td>{{ item.CLAVE }}</td><td>{{ item.RAMO }}</td><td>{{ item.SUBRAMO }}</td><td>{{ item.TIPO_CARATULA }}</td><td>{{ item.MONEDA }}</td><td>{{ item.LINEA_NEGOCIO }}</td><td>{{ item.RESPONSABLE }}</td><td>{{ item.RENOVABLE }}</td><td>{{ item.CELULA }}</td><td>{{ item.AGRUPACION }}</td><td>{{ item.SUBAGRUPACION }}</td><td>{{ item.SUBSUBAGRUPACION }}</td><td>{{ item.EJECUTIVO_COBRANZA }}</td><td>{{ item.REFERENCIADOR }}</td><td>{{ item.ID_POLIZA_ANTERIOR }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"savePolicies()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Flotillas</button></div></div></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/carga/carga.info_contributoria.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Carga Masiva</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Carga Masiva Información Contributoria Pólizas de Grupo</strong></li></ol></div></div><br><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carga Masiva Información Contributoria Pólizas de Grupo</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando información...</span></div></div></div><div class=\"row\" ng-if=\"excelJsonViews.length\"><div class=\"col-xs-12 form-group\"><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>ID</td><td>Número Póliza</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>RFC</td><td>RFC HomoClave</td><td>Domicilio Calle y Número</td><td>Domicilio Colonia</td><td>Domicilio CP</td><td>Domicilio Población/Municipio</td><td>Domicilio Estado</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.ID }}</td><td>{{ item.NUMERO_POLIZA }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.RFC_CVE }}</td><td>{{ item.RFC_HOMOCVE }}</td><td>{{ item.DOM_CALLE_NUM }}</td><td>{{ item.DOM_COLONIA }}</td><td>{{ item.DOM_CP }}</td><td>{{ item.DOM_POBLACION }}</td><td>{{ item.DOM_ESTADO }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!loadingValidate\"><button class=\"col-xs-12 btn btn-success ladda-button2\" ng-click=\"validateCertificates()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Validar Información Contributoria</button></div><div class=\"col-xs-12 text-center\" ng-if=\"loadingValidate\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Validando la información...</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!loadingSave && validado\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveCertificates()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Información Contributoria</button></div><div class=\"col-xs-12 text-center\" ng-if=\"loadingSave\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Guardando la información...</span></div></div></div></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/carga/carga.norenovacion.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Carga Masiva</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Carga Masiva de Pólizas No Renovación (ID))</strong></li></ol></div></div><br><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carga Masiva de Pólizas No Renovación (ID)</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success ladda-button2\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\" onchange=\"angular.element(this).scope().fileNameChanged(this)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando información...</span></div></div></div><div class=\"row\" ng-if=\"excelJsonViews.length\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\">Pólizas No Renovación</legend></div><div class=\"col-xs-12 form-group\"><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>ID Póliza</td><td>Razón</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.ID_SAAM_POLIZA}}</td><td>{{ item.MOTIVO }}</td></tr></tbody></table></div></div></div><div class=\"row\" ng-if=\"excelJsonViews.length\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelNoRenovacion()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveNoRenovacion(excelJsonViews)\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Pólizas</button></div></div></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/carga/carga.poliza.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Carga Masiva</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Carga Masiva de Pólizas Individuales</strong></li></ol></div></div><br><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carga Masiva de Pólizas Individual</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label>Ramo: <span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"item.name for item in ramos | orderBy: \'id\'\" ng-model=\"ramoSelected\" ng-change=\"chageRamo(ramoSelected)\"><option value=\"\">Selecciona un ramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success ladda-button2\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\" onchange=\"angular.element(this).scope().fileNameChanged(this)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando información...</span></div></div></div><div class=\"row\" ng-if=\"excelJsonViews.length\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\">Pólizas</legend></div><div class=\"col-xs-12 form-group\"><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\" ng-if=\"ramoSelected.name == \'Vida\'\"><thead><tr><td>Identificador</td><td>Folio</td><td>Número de Póliza</td><td>Contratante</td><td>Dirección</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Renovable</td><td>Aseguradora</td><td>Clave</td><td>Ramo</td><td>Subramo</td><td>Tipo</td><td>Procedencia</td><td>Moneda</td><td>Responsable</td><td>Ejecutivo de Cobranza</td><td>Paquete</td><td>Linea de Negocio</td><td>Célula</td><td>Agrupación</td><td>Subagrupación</td><td>Subsubagrupación</td><td>Conducto de Pago</td><td>Sucursal</td><td>Referenciador</td><td>Frecuencia de Pago</td><td>Observaciones</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha de Nacimiento</td><td>Sexo</td><td>Fecha de Antigüedad</td><td>Fumador</td><td>Prima Neta</td><td>Descuento</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Porcentaje de Comisión</td><td>Número de Recibo</td><td>Prima Neta de Recibo</td><td>RPF de Recibo</td><td>Derecho de Recibo</td><td>Iva de Recibo</td><td>Prima Total de Recibo</td><td>Comisión de Recibo</td><td>Vigencia Inicio de Recibo</td><td>Vigencia Fin de Recibo</td><td>Vencimiento de Recibo</td><td>ID de Póliza Anterior</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.IDENTIFICADOR }}</td><td>{{ item.FOLIO }}</td><td>{{ item.NO_POLIZA }}</td><td>{{ item.CONTRATANTE }}</td><td>{{ item.DIRECCION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.RENOVABLE }}</td><td>{{ item.ASEGURADORA }}</td><td>{{ item.CLAVE }}</td><td>{{ item.RAMO }}</td><td>{{ item.SUBRAMO }}</td><td>{{ item.TIPO }}</td><td>{{ item.PROCEDENCIA }}</td><td>{{ item.MONEDA }}</td><td>{{ item.RESPONSABLE }}</td><td>{{ item.EJECUTIVO_COBRANZA }}</td><td>{{ item.PAQUETE }}</td><td>{{ item.LINEA_NEGOCIO }}</td><td>{{ item.CELULA }}</td><td>{{ item.AGRUPACION }}</td><td>{{ item.SUBAGRUPACION }}</td><td>{{ item.SUBSUBAGRUPACION }}</td><td>{{ item.CONDUCTO_PAGO }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.REFERENCIADOR }}</td><td>{{ item.FRECUENCIA_PAGO }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.NOMBRE_TITULAR }}</td><td>{{ item.APELLIDO_PATERNO_TITULAR }}</td><td>{{ item.APELLIDO_MATERNO_TITULAR }}</td><td>{{ item.FECHA_NACIMIENTO_TITULAR }}</td><td>{{ item.SEXO_TITULAR }}</td><td>{{ item.FECHA_ANTIGUEDAD_TITULAR }}</td><td>{{ item.FUMADOR_TITULAR }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.DESCUENTO }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.PORCENTAJE_COMISION }}</td><td>{{ item.NO_RECIBO }}</td><td>{{ item.PRIMA_RECIBO }}</td><td>{{ item.RPF_RECIBO }}</td><td>{{ item.DERECHO_RECIBO }}</td><td>{{ item.IVA_RECIBO }}</td><td>{{ item.TOTAL_RECIBO }}</td><td>{{ item.COMISION_RECIBO }}</td><td>{{ item.INICIO_RECIBO }}</td><td>{{ item.FIN_RECIBO }}</td><td>{{ item.VENCIMIENTO_RECIBO }}</td><td>{{ item.ID_POLIZA_ANTERIOR }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"ramoSelected.name == \'Accidentes y Enfermedades\'\"><thead><tr><td>Identificador</td><td>Folio</td><td>Número de Póliza</td><td>Contratante</td><td>Dirección</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Renovable</td><td>Aseguradora</td><td>Clave</td><td>Ramo</td><td>Subramo</td><td>Tipo</td><td>Procedencia</td><td>Moneda</td><td>Responsable</td><td>Ejecutivo de Cobranza</td><td>Paquete</td><td>Linea de Negocio</td><td>Célula</td><td>Agrupación</td><td>Subagrupación</td><td>Subsubagrupación</td><td>Conducto de Pago</td><td>Sucursal</td><td>Referenciador</td><td>Frecuencia de Pago</td><td>Observaciones</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha de Nacimiento</td><td>Sexo</td><td>Fecha de Antigüedad</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Porcentaje de Comisión</td><td>Número de Recibo</td><td>Prima Neta de Recibo</td><td>RPF de Recibo</td><td>Derecho de Recibo</td><td>Iva de Recibo</td><td>Prima Total de Recibo</td><td>Comisión de Recibo</td><td>Vigencia Inicio de Recibo</td><td>Vigencia Fin de Recibo</td><td>Vencimiento de Recibo</td><td>ID de Póliza Anterior</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.IDENTIFICADOR }}</td><td>{{ item.FOLIO }}</td><td>{{ item.NO_POLIZA }}</td><td>{{ item.CONTRATANTE }}</td><td>{{ item.DIRECCION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.RENOVABLE }}</td><td>{{ item.ASEGURADORA }}</td><td>{{ item.CLAVE }}</td><td>{{ item.RAMO }}</td><td>{{ item.SUBRAMO }}</td><td>{{ item.TIPO }}</td><td>{{ item.PROCEDENCIA }}</td><td>{{ item.MONEDA }}</td><td>{{ item.RESPONSABLE }}</td><td>{{ item.EJECUTIVO_COBRANZA }}</td><td>{{ item.PAQUETE }}</td><td>{{ item.LINEA_NEGOCIO }}</td><td>{{ item.CELULA }}</td><td>{{ item.AGRUPACION }}</td><td>{{ item.SUBAGRUPACION }}</td><td>{{ item.SUBSUBAGRUPACION }}</td><td>{{ item.CONDUCTO_PAGO }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.REFERENCIADOR }}</td><td>{{ item.FRECUENCIA_PAGO }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.NOMBRE_TITULAR }}</td><td>{{ item.APELLIDO_PATERNO_TITULAR }}</td><td>{{ item.APELLIDO_MATERNO_TITULAR }}</td><td>{{ item.FECHA_NACIMIENTO_TITULAR }}</td><td>{{ item.SEXO_TITULAR }}</td><td>{{ item.FECHA_ANTIGUEDAD_TITULAR }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.PORCENTAJE_COMISION }}</td><td>{{ item.NO_RECIBO }}</td><td>{{ item.PRIMA_RECIBO }}</td><td>{{ item.RPF_RECIBO }}</td><td>{{ item.DERECHO_RECIBO }}</td><td>{{ item.IVA_RECIBO }}</td><td>{{ item.TOTAL_RECIBO }}</td><td>{{ item.COMISION_RECIBO }}</td><td>{{ item.INICIO_RECIBO }}</td><td>{{ item.FIN_RECIBO }}</td><td>{{ item.VENCIMIENTO_RECIBO }}</td><td>{{ item.ID_POLIZA_ANTERIOR }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"ramoSelected.name == \'Automóviles\'\"><thead><tr><td>Identificador</td><td>Folio</td><td>Número de Póliza</td><td>Contratante</td><td>Dirección</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Renovable</td><td>Aseguradora</td><td>Clave</td><td>Ramo</td><td>Subramo</td><td>Tipo</td><td>Procedencia</td><td>Moneda</td><td>Responsable</td><td>Ejecutivo de Cobranza</td><td>Paquete</td><td>Linea de Negocio</td><td>Célula</td><td>Agrupación</td><td>Subagrupación</td><td>Subsubagrupación</td><td>Conducto de Pago</td><td>Sucursal</td><td>Referenciador</td><td>Frecuencia de Pago</td><td>Observaciones</td><td>Conductor</td><td>Marca</td><td>Modelo</td><td>Año</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Uso</td><td>Servicio</td><td>Estado de Circulación</td><td>Adaptaciones</td><td>Monto Adaptaciones</td><td>Equipamineto</td><td>Monto Equipamineto</td><td>Beneficiario Preferente</td><td>Beneficiario RFC</td><td>Beneficiario Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Porcentaje de Comisión</td><td>Número de Recibo</td><td>Prima Neta de Recibo</td><td>RPF de Recibo</td><td>Derecho de Recibo</td><td>Iva de Recibo</td><td>Prima Total de Recibo</td><td>Comisión de Recibo</td><td>Vigencia Inicio de Recibo</td><td>Vigencia Fin de Recibo</td><td>Vencimiento de Recibo</td><td>ID de Póliza Anterior</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.IDENTIFICADOR }}</td><td>{{ item.FOLIO }}</td><td>{{ item.NO_POLIZA }}</td><td>{{ item.CONTRATANTE }}</td><td>{{ item.DIRECCION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.RENOVABLE }}</td><td>{{ item.ASEGURADORA }}</td><td>{{ item.CLAVE }}</td><td>{{ item.RAMO }}</td><td>{{ item.SUBRAMO }}</td><td>{{ item.TIPO }}</td><td>{{ item.PROCEDENCIA }}</td><td>{{ item.MONEDA }}</td><td>{{ item.RESPONSABLE }}</td><td>{{ item.EJECUTIVO_COBRANZA }}</td><td>{{ item.PAQUETE }}</td><td>{{ item.LINEA_NEGOCIO }}</td><td>{{ item.CELULA }}</td><td>{{ item.AGRUPACION }}</td><td>{{ item.SUBAGRUPACION }}</td><td>{{ item.SUBSUBAGRUPACION }}</td><td>{{ item.CONDUCTO_PAGO }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.REFERENCIADOR }}</td><td>{{ item.FRECUENCIA_PAGO }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.CONDUCTOR }}</td><td>{{ item.MARCA }}</td><td>{{ item.MODELO }}</td><td>{{ item.ANO }}</td><td>{{ item.VERSION }}</td><td>{{ item.SERIE }}</td><td>{{ item.MOTOR }}</td><td>{{ item.COLOR }}</td><td>{{ item.MATRICULA }}</td><td>{{ item.USO }}</td><td>{{ item.SERVICIO }}</td><td>{{ item.ESTADO_CIRCULACION }}</td><td>{{ item.ADAPTACIONES }}</td><td>{{ item.MONTO_ADAPTACIONES }}</td><td>{{ item.EQUIPAMIENTO }}</td><td>{{ item.MONTO_EQUIPAMIENTO }}</td><td>{{ item.BENEFICIARIO_PREFERENTE }}</td><td>{{ item.BENEFICIARIO_RFC }}</td><td>{{ item.BENEFICIARIO_DIRECCION }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.PORCENTAJE_COMISION }}</td><td>{{ item.NO_RECIBO }}</td><td>{{ item.PRIMA_RECIBO }}</td><td>{{ item.RPF_RECIBO }}</td><td>{{ item.DERECHO_RECIBO }}</td><td>{{ item.IVA_RECIBO }}</td><td>{{ item.TOTAL_RECIBO }}</td><td>{{ item.COMISION_RECIBO }}</td><td>{{ item.INICIO_RECIBO }}</td><td>{{ item.FIN_RECIBO }}</td><td>{{ item.VENCIMIENTO_RECIBO }}</td><td>{{ item.ID_POLIZA_ANTERIOR }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"ramoSelected.name == \'Daños\'\"><thead><tr><td>Identificador</td><td>Folio</td><td>Número de Póliza</td><td>Contratante</td><td>Dirección</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Renovable</td><td>Aseguradora</td><td>Clave</td><td>Ramo</td><td>Subramo</td><td>Tipo</td><td>Moneda</td><td>Responsable</td><td>Ejecutivo de Cobranza</td><td>Paquete</td><td>Linea de Negocio</td><td>Célula</td><td>Agrupación</td><td>Subagrupación</td><td>Subsubagrupación</td><td>Conducto de Pago</td><td>Sucursal</td><td>Referenciador</td><td>Frecuencia de Pago</td><td>Observaciones</td><td>Bien Asegurado</td><td>Bien Detalles</td><td>Bien Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Porcentaje de Comisión</td><td>Número de Recibo</td><td>Prima Neta de Recibo</td><td>RPF de Recibo</td><td>Derecho de Recibo</td><td>Iva de Recibo</td><td>Prima Total de Recibo</td><td>Comisión de Recibo</td><td>Vigencia Inicio de Recibo</td><td>Vigencia Fin de Recibo</td><td>Vencimiento de Recibo</td><td>ID de Póliza Anterior</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.IDENTIFICADOR }}</td><td>{{ item.FOLIO }}</td><td>{{ item.NO_POLIZA }}</td><td>{{ item.CONTRATANTE }}</td><td>{{ item.DIRECCION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.RENOVABLE }}</td><td>{{ item.ASEGURADORA }}</td><td>{{ item.CLAVE }}</td><td>{{ item.RAMO }}</td><td>{{ item.SUBRAMO }}</td><td>{{ item.TIPO }}</td><td>{{ item.MONEDA }}</td><td>{{ item.RESPONSABLE }}</td><td>{{ item.EJECUTIVO_COBRANZA }}</td><td>{{ item.PAQUETE }}</td><td>{{ item.LINEA_NEGOCIO }}</td><td>{{ item.CELULA }}</td><td>{{ item.AGRUPACION }}</td><td>{{ item.SUBAGRUPACION }}</td><td>{{ item.SUBSUBAGRUPACION }}</td><td>{{ item.CONDUCTO_PAGO }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.REFERENCIADOR }}</td><td>{{ item.FRECUENCIA_PAGO }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.BIEN_ASEGURADO }}</td><td>{{ item.BIEN_DETALLES }}</td><td>{{ item.BIEN_DIRECCION }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.PORCENTAJE_COMISION }}</td><td>{{ item.NO_RECIBO }}</td><td>{{ item.PRIMA_RECIBO }}</td><td>{{ item.RPF_RECIBO }}</td><td>{{ item.DERECHO_RECIBO }}</td><td>{{ item.IVA_RECIBO }}</td><td>{{ item.TOTAL_RECIBO }}</td><td>{{ item.COMISION_RECIBO }}</td><td>{{ item.INICIO_RECIBO }}</td><td>{{ item.FIN_RECIBO }}</td><td>{{ item.VENCIMIENTO_RECIBO }}</td><td>{{ item.ID_POLIZA_ANTERIOR }}</td></tr></tbody></table></div></div></div><div class=\"row\" ng-if=\"excelJsonViewsDependients.length\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" ng-if=\"ramoSelected.name == \'Vida\'\">Beneficiarios</legend><legend class=\"legend-title\" ng-if=\"ramoSelected.name == \'Accidentes y Enfermedades\'\">Dependientes</legend></div><div class=\"col-xs-12 form-group\"><label>Del {{ valueInitialDependient }} al {{ valueFinalDependient }} de {{ excelJsonDependiente.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViewsDependients(-1)\" ng-disabled=\"valueInitialDependient == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViewsDependients(+1)\" ng-disabled=\"valueFinalDependient == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Número de Póliza</td><td>Vigencia Inicio</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Parentesco</td><td>Fecha de Nacimiento</td><td>Sexo</td><td>Fecha de Antigüedad</td><td ng-if=\"ramoSelected.name == \'Vida\'\">Porcantaje</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViewsDependients\"><td>{{ item.NO_POLIZA }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.PARENTESCO }}</td><td>{{ item.FECHA_NACIMIENTO }}</td><td>{{ item.SEXO }}</td><td>{{ item.FECHA_ANTIGUEDAD}}</td><td ng-if=\"ramoSelected.name == \'Vida\'\">{{ item.PORCENTAJE}}</td></tr></tbody></table></div></div></div><div class=\"row\" ng-if=\"excelJsonViews.length\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveCertificates()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Pólizas</button></div></div></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/carga/carga.polizaGpo.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Carga Masiva</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Carga Masiva Pólizas de Grupo</strong></li></ol></div></div><br><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carga Masiva Pólizas de Grupo</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando información...</span></div></div></div><div class=\"row\" ng-if=\"excelJsonViews.length\"><div class=\"col-xs-12 form-group\"><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Clase</td><td>Identificador</td><td>Folio</td><td>Número de Póliza</td><td>Contratante</td><td>Dirección</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Aseguradora</td><td>Clave</td><td>Ramo</td><td>Subramo</td><td>Renovable</td><td>Tipo de Administración</td><td>Moneda</td><td>Responsable</td><td>Ejecutivo de Cobranza</td><td>Conducto de Pago</td><td>Linea de Negocio</td><td>Célula</td><td>Agrupación</td><td>Subagrupación</td><td>Subsubagrupación</td><td>Sucursal</td><td>Frecuencia de Pago</td><td>Referenciador</td><td>Observaciones</td><td>Subgrupo</td><td>Nivel Hospitalario</td><td>Categoría</td><td>Paquete</td><td>ID de Póliza Anterior</td><td>Número de Recibo</td><td>Prima Neta</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Porcentaje de Comisión</td><td>Prima Neta Recibo</td><td>RPF Recibo</td><td>Derecho Recibo</td><td>Iva Recibo</td><td>Prima Total Recibo</td><td>Comisión Recibo</td><td>Vigencia Inicio Recibo</td><td>Vigencia Fin Recibo</td><td>Vencimiento Recibo</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.CLASE }}</td><td>{{ item.IDENTIFICADOR }}</td><td>{{ item.FOLIO }}</td><td>{{ item.NO_POLIZA }}</td><td>{{ item.CONTRATANTE }}</td><td>{{ item.DIRECCION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.ASEGURADORA }}</td><td>{{ item.CLAVE }}</td><td>{{ item.RAMO }}</td><td>{{ item.SUBRAMO }}</td><td>{{ item.RENOVABLE }}</td><td>{{ item.TIPO_ADMINISTRACION }}</td><td>{{ item.MONEDA }}</td><td>{{ item.RESPONSABLE }}</td><td>{{ item.EJECUTIVO_COBRANZA }}</td><td>{{ item.CONDUCTO_PAGO }}</td><td>{{ item.LINEA_NEGOCIO }}</td><td>{{ item.CELULA }}</td><td>{{ item.AGRUPACION }}</td><td>{{ item.SUBAGRUPACION }}</td><td>{{ item.SUBSUBAGRUPACION }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.FRECUENCIA_PAGO }}</td><td>{{ item.REFERENCIADOR }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.NIVEL_HOSPITALARIO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td><td>{{ item.ID_POLIZA_ANTERIOR }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.PORCENTAJE_COMISION }}</td><td>{{ item.PRIMA_RECIBO }}</td><td>{{ item.RPF_RECIBO }}</td><td>{{ item.DERECHO_RECIBO }}</td><td>{{ item.IVA_RECIBO }}</td><td>{{ item.TOTAL_RECIBO }}</td><td>{{ item.COMISION_RECIBO }}</td><td>{{ item.INICIO_RECIBO }}</td><td>{{ item.FIN_RECIBO }}</td><td>{{ item.VENCIMIENTO_RECIBO }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"savePolicies()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Pólizas</button></div></div></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/carga/carga.recibos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Carga Masiva</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Carga Masiva Archivos Recibos</strong></li></ol></div></div><br><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carga Masiva Archivos Recibos</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success ladda-button2\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\" onchange=\"angular.element(this).scope().fileNameChanged(this)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando información...</span></div></div></div><div class=\"row\" ng-if=\"excelJsonViews.length\"><div class=\"col-xs-12 form-group\"><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>ID del Recibo</td><td>Número de Recibo</td><td>Número de Póliza</td><td>Inicio Vigencia Póliza</td><td>Número de Endoso</td><td>Nombre del archivo</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.ID_RECIBO }}</td><td>{{ item.SERIE_RECIBO }}</td><td>{{ item.POLIZA }}</td><td>{{ item.INICIO_VIGENCIA_POLIZA }}</td><td>{{ item.ENDOSO }}</td><td>{{ item.NOMBRE_ARCHIVO }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelContractors()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveContractors()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Contratantes</button></div></div></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/carga/check.carga.certificados.modal.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Validación de carga masiva certificados</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': true}\"><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-12\"><legend class=\"legend-title\" align=\"center\">Estatus</legend><table class=\"table table-bordered table-hover\"><thead><tr><td>Segmento:</td><td>Estatus:</td></tr></thead><tbody><tr ng-repeat=\"item in data_segmentada track by $index\"><td>{{ $index + 1 }}</td><td><div class=\"sk-spinner sk-spinner-rotating-plane margin-top-45p\"></div></td></tr></tbody></table></div></div></div><div class=\"row\" style=\"margin-top: 20px;\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-12\"><label class=\"label label-warning\">A CONTINUACIÓN SE PRESENTAN LOS ERRORES DE VALIDACIÓN DEL LAYOUT</label></div></div></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-12\"><legend class=\"legend-title\" align=\"center\">Registros erróneos</legend><table class=\"table table-bordered table-hover\"><thead><tr><td>Registro:</td><td>Error:</td></tr></thead><tbody><tr ng-repeat=\"item in segmentos_erroneos track by $index\"><td>Identificador: {{ item.item.identifier }} Carátula: {{ item.item.caratula }}</td><td ng-if=\"item.error!= \'Cargando...\'\">{{item.error}}</td><td ng-if=\"item.error== \'Cargando...\'\"><div class=\"sk-spinner sk-spinner-rotating-plane margin-top-45p\"></div></td></tr></tbody></table></div></div></div></div></div></form></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\'); \n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/carpetas/carpetas.form.html","<div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><legend class=\"legend-title blue-color\" align=\"center\">Adjuntos Internos</legend><form name=\"carpetaForm\" novalidate=\"\" ng-submit=\"crearCarpeta()\" ng-if=\"nuevacarpeta\"><div class=\"form-group\" ng-class=\"{\'has-error\': carpetaForm.nombre.$touched && carpetaForm.nombre.$invalid}\"><label for=\"nombre\">Nombre de la Carpeta</label> <input type=\"text\" id=\"nombre\" name=\"nombre\" class=\"form-control\" ng-model=\"carpeta.nombre\" placeholder=\"Escribe el nombre\" required=\"\"><div class=\"help-block\" ng-messages=\"carpetaForm.nombre.$error\" ng-if=\"carpetaForm.nombre.$touched\"><div ng-message=\"required\">El nombre es obligatorio.</div></div></div><div class=\"col-xs-12 form-group pdbt20\" ng-if=\"carpeta.nombre\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/upload.html\'\"></div></div></div><div class=\"col-xs-12 text-align-center\"><label class=\"text-align-center\">Adjuntos Internos de</label> <span class=\"blue-color\">{{carpeta.nombre}}</span></div><div class=\"row\"><table class=\"table table-hover table-striped\"><thead><tr class=\"text-muted\"><th>Nombre</th><th style=\"width: 300px;\">Opciones</th><th style=\"width: 200px;\">Sensible</th></tr></thead><tbody><tr ng-repeat=\"file in carpeta.archivos track by $index\"><td><i class=\"fa fa-file-o text-muted\"></i> <strong class=\"text-primary\" ng-bind=\"file.nombre\"></strong> <input name=\"text_input\" class=\"form-control input-sm display-none\" ng-model=\"file.nombre\" ng-blur=\"saveFile(file)\"></td><td><div class=\"btn-group btn-group-sm\" role=\"group\"><a class=\"btn btn-outline-success\" download=\"\" href=\"{{file.archivo}}\" target=\"_blank\" title=\"Descargar\"><i class=\"fa fa-download\"></i></a> <a class=\"btn btn-outline-primary\" href=\"{{file.archivo}}\" target=\"_blank\" title=\"Ver\"><i class=\"fa fa-eye\"></i></a> <a class=\"btn btn-outline-primary\" ng-click=\"deleteFile(file,carpeta.archivos)\" title=\"Eliminar\"><i class=\"fa fa-trash\"></i></a></div></td><td><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> Sensible</label></td></tr><tr ng-if=\"!carpeta.archivos || carpeta.archivos.length === 0\"><td colspan=\"3\" class=\"text-center text-muted\">No hay archivos disponibles</td></tr></tbody></table></div></div></div><hr><div class=\"form-group text-right\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"nuevaCarpeta(false,\'\')\">Cancelar</button> <button type=\"submit\" class=\"btn btn-primary ladda-button1\" ng-if=\"!carpeta.id\" ng-disabled=\"carpetaForm.$invalid\">Crear Carpeta</button><button type=\"submit\" class=\"btn btn-primary ladda-button1\" ng-if=\"carpeta.id\" ng-disabled=\"carpetaForm.$invalid\">Actualizar Carpeta</button></div></form><div class=\"btn-toolbar pull-right pdbt20\" ng-if=\"!nuevacarpeta\"><div class=\"btn-group\" style=\"margin-left: 8px;\"><button class=\"btn btn-secondary\" ng-click=\"nuevaCarpeta(true,\'\')\" title=\"Nueva Carpeta\"><i class=\"fa fa-folder blue-color\" aria-hidden=\"true\"></i> <i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></div><div class=\"btn-group\" style=\"margin-left: 8px;\" ng-if=\"archivosGenerales==false\"><button class=\"btn btn-info\" ng-click=\"filesGenerales(true)\" title=\"Nuevo archivo\"><i class=\"fa fa-file blue-color\" aria-hidden=\"true\"></i> <i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></div></div><div class=\"row\" ng-if=\"carpetasList\"><div class=\"col-xs-12 form-group\"><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in carpetasList track by item.id\"><div class=\"clearfix\"><legend class=\"legend-title pull-left blue-color\"><i class=\"fa fa-folder-o\" aria-hidden=\"true\" ng-if=\"!item.expanded\"></i><i class=\"fa fa-folder-open-o\" ng-if=\"item.expanded\" aria-hidden=\"true\"></i> {{ item.nombre }}</legend><div class=\"pull-right\"><button class=\"btn btn-success\" ng-click=\"toggleArchivos(item, $index)\" title=\"Información\"><i class=\"fa\" ng-class=\"item.expanded ? \'fa-ban\' : \'fa-info-circle\'\" aria-hidden=\"true\"></i> {{ item.expanded ? \'Ocultar detalles\' : \'Ver detalles\' }}</button> <button class=\"btn btn-secondary ml-2\" ng-if=\"item.id\" ng-click=\"nuevaCarpeta(true, item)\" title=\"Editar carpeta\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-warning ml-2 ladda-button2\" ng-if=\"item.id\" ng-click=\"eliminarCarpeta(true, item)\" title=\"Eliminar carpeta\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></div></div><ul class=\"list-group\" ng-show=\"item.expanded\"><li class=\"list-group-item text-muted\" ng-if=\"!item.archivos || item.archivos.length===0\">Sin archivos</li><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 text-align-center\"><label class=\"text-align-center\">Adjuntos Internos de</label> <span class=\"blue-color\">{{item.nombre}}</span></div><table class=\"table table-hover table-striped\"><thead><tr class=\"text-muted\"><th>Nombre</th><th style=\"width: 300px;\">Opciones</th><th style=\"width: 200px;\">Sensible</th></tr></thead><tbody><tr ng-repeat=\"file in item.archivos track by $index\"><td><i class=\"fa fa-file-o text-muted\"></i> <strong class=\"text-primary\" ng-bind=\"file.nombre\"></strong> <input name=\"text_input\" class=\"form-control input-sm display-none\" ng-model=\"file.nombre\" ng-blur=\"saveFile(file)\"></td><td><div class=\"btn-group btn-group-sm\" role=\"group\"><a class=\"btn btn-outline-success\" download=\"\" href=\"{{file.archivo}}\" target=\"_blank\" title=\"Descargar\"><i class=\"fa fa-download\"></i></a> <a class=\"btn btn-outline-primary\" href=\"{{file.archivo}}\" target=\"_blank\" title=\"Ver\"><i class=\"fa fa-eye\"></i></a> <a class=\"btn btn-outline-primary\" ng-click=\"deleteFile(file,item.archivos)\" title=\"Eliminar\"><i class=\"fa fa-trash\"></i></a></div></td><td><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> Sensible</label></td></tr><tr ng-if=\"!item.archivos || item.archivos.length === 0\"><td colspan=\"3\" class=\"text-center text-muted\">No hay archivos disponibles</td></tr></tbody></table><div ng-if=\"files_paginationCarpeta\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacionCarpeta[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPaginaCarpeta(paginaCarpeta,item)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"paginaCarpeta in paginacionCarpeta.totalPaginas\" ng-click=\"selecionPaginaCarpeta(paginaCarpeta,item)\" ng-class=\"{\'active\': paginaCarpeta === paginacionCarpeta.paginaActual}\"><a class=\"page-link\" role=\"button\">{{paginaCarpeta}}</a></li><li class=\"page-item\" ng-click=\"siguientePaginaCarpeta(paginaCarpeta,item)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 col-sm-4 col-md-3 pull-right form-group\" ng-if=\"uploader && uploader.queue && uploader.queue.length !=0\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"vm.uploadFiles(item,true)\"><i class=\"fa fa-cloud-upload\" aria-hidden=\"true\"></i></button></div></div></div></div></div></ul></li></ul></div></div><div class=\"ibox float-e-margins listafiles\"><div class=\"ibox-content\"><legend class=\"legend-title blue-color\" align=\"center\" style=\"font-weight: bold;\">📎 Adjuntos Internos Generales</legend><div class=\"row\"><div class=\"col-xs-12 form-group my-3\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\" ng-if=\"archivosGenerales\"><div class=\"ibox-title contentfiles\"><h5 style=\"color: black;\"><i class=\"fa fa-paperclip\"></i> Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 col-sm-4 col-md-3 pull-right form-group\" ng-if=\"uploader && uploader.queue && uploader.queue.length !=0\"><button class=\"col-xs-12 btn btn-primary ladda-button3\" type=\"button\" ng-click=\"vm.uploadFilesFree({},false)\"><i class=\"fa fa-cloud-upload\" aria-hidden=\"true\"></i> Subir</button></div></div><div class=\"col-xs-12 text-align-center\" style=\"margin-top: 10px;\"><label class=\"text-align-center\" style=\"font-weight: bold;\">📁 Lista de Archivos Adjuntos</label></div><div class=\"row\"><table class=\"table table-hover table-striped\"><thead><tr class=\"text-muted\"><th>Nombre</th><th style=\"width: 300px;\">Opciones</th><th style=\"width: 200px;\">Sensible</th></tr></thead><tbody><tr ng-repeat=\"file in archivos_general track by $index\"><td><i class=\"fa fa-file-o text-muted\"></i> <strong class=\"text-primary\" ng-bind=\"file.nombre\"></strong> <input name=\"text_input\" class=\"form-control input-sm display-none\" ng-model=\"file.nombre\" ng-blur=\"saveFile(file)\"></td><td><div class=\"btn-group btn-group-sm\" role=\"group\"><a class=\"btn btn-outline-success\" download=\"\" href=\"{{file.archivo}}\" target=\"_blank\" title=\"Descargar\"><i class=\"fa fa-download\"></i></a> <a class=\"btn btn-outline-primary\" href=\"{{file.archivo}}\" target=\"_blank\" title=\"Ver\"><i class=\"fa fa-eye\"></i></a> <a class=\"btn btn-outline-danger\" ng-click=\"deleteFile(file,archivos_general)\" title=\"Eliminar\"><i class=\"fa fa-trash\"></i></a></div></td><td><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> Sensible</label></td></tr><tr ng-if=\"!archivos_general || archivos_general.length === 0\"><td colspan=\"3\" class=\"text-center text-muted\">No hay archivos disponibles</td></tr></tbody></table><div ng-if=\"files_pagination\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\"><span aria-hidden=\"true\">&raquo;</span></a></li></ul></nav></div></div></div></div></div></div></div></div></div></div></div></div><script type=\"text/javascript\">\n  function mostrarImagen(input) {\n    if (input.files && input.files[0]) {\n      var reader = new FileReader();\n      reader.onload = function (e) {\n        $(\'#img_destino\').attr(\'src\', e.target.result);\n      }\n      reader.readAsDataURL(input.files[0]);\n    }\n  }\n   \n  $(\"#file_url\").change(function(){\n    mostrarImagen(this);\n  });\n\n  function renombrar(index) {\n    var test = $(index).attr(\'id\');\n    \n    try{\n      test = test.replace(\'rename_\',\'\')\n    }\n    catch(e){}\n\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n    inputTag.focus();\n    inputTag.show();\n  }\n\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(index){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.removeClass(\'display-none\');\n    dummy.addClass(\'display-none\');\n\n    inputTag.addClass(\'display-none\');\n    strongTag.removeClass(\'display-none\');\n  }\n</script>");
$templateCache.put("app/carpetas/carpetas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ vm.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Carpeta(s)</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Administración de Carpeta(s)</h5></div><div class=\"ibox-content\"><div ng-include=\"\'app/carpetas/carpetas.form.html\'\"></div></div></div></div></div>");
$templateCache.put("app/cedula/cedula.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Cédula</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Cédula</strong></li></ol></div></div><div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createQuotation()\">Agregar Cédula</button></div><div class=\"col-xs-12\" ng-show=\"showQuotation\"><legend class=\"legend-title\" align=\"center\">Nueva cédula</legend><form class=\"row\" name=\"form\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Cédula <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-change=\"change()\" name=\"last_name\" ng-model=\"vm.form.cedula\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de expiración<span class=\"color-red\">*</span></label><div class=\"input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" ng-change=\"change()\" data-provide=\"datepicker\" name=\"birthday\" ng-model=\"vm.form.exp_date\" value=\"vm.form.exp_date\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label>Detalles</label><fieldset><form name=\"form1\"><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-class=\"{ \'has-error\': form1.observaciones.$invalid && !form1.observaciones.$pristine }\"><textarea ng-change=\"change()\" type=\"text\" class=\"form-control\" name=\"observaciones\" ng-model=\"vm.form.observaciones\"></textarea></div></div></form></fieldset></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"saveCedula(vm.form)\">Crear Cédula</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeQuotation()\">Cancelar</button></div></form></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Cédulas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\" ng-hide=\"showInfoQuotation\"><table class=\"table table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th>No. de cédula</th><th>Fecha de expiración</th><th>Observaciones</th></tr></thead><tbody><tr ng-repeat=\"item in quotations track by $index\"><td>{{ item.cedula }}</td><td>{{ item.expiracion | date:\'medium\' }}</td><td>{{ item.observaciones }}</td></tr></tbody></table><div class=\"col-xs-12 col-sm-6 col-md-3 m-t\" ng-show=\"quotations\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-disabled=\"quotations.length == 0\" ng-click=\"getReportCedula()\">Generar reporte</button></div></div></div></div></div></div>");
$templateCache.put("app/charts/cobranzas.chart.html","<div class=\"col-xs-12 col-sm-3\" ng-if=\"main.permiso_g_cob\"><div class=\"ibox-content\"><h3 class=\"text-center\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i> Cobranza <a ng-if=\"main.permiso_f_cob\" ng-click=\"configGraph(2)\"><i class=\"fa fa-wrench pull-right\" aria-hidden=\"true\"></i></a></h3><br><div class=\"row\"><graphic gtype=\"receipts\" parent-vm=\"main\"></graphic></div><br><button ng-click=\"setCobranzasToList(0,0)\" class=\"btn btn-success center-block\">Ver todos</button></div></div>");
$templateCache.put("app/charts/config.chart.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Configuración de gráfica de {{typeGraph}}</h4></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\" ng-if=\"typeGraphic == 1 || typeGraphic == 4\"><form name=\"form\"><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #17A45D;\">Verde: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" value=\"Creación\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.green\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #F5CD21;\">Amarillo: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" ng-model=\"config.green\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.yellow\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #EA9021;\">Anaranjado: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" ng-model=\"config.yellow\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.orange\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #EA5121;\">Rojo: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Mayor a:</label> <input type=\"text\" name=\"motivo\" ng-model=\"config.orange\" class=\"form-control\" disabled=\"\"></div></div><div class=\"pull-right\"><button class=\"btn btn-white\" ng-click=\"close()\" type=\"button\">Cancelar</button> <button class=\"btn btn-primary ladda-button\" ng-disabled=\"form.$invalid\" ng-click=\"saveConfig(config)\" type=\"button\">Guardar</button></div></form></div><div class=\"wizard\" ng-if=\"typeGraphic == 2 || typeGraphic == 3\"><form name=\"form\"><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #EA5121;\">Rojo: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label>&nbsp;</label> <input type=\"text\" name=\"motivo\" value=\"Sin días restantes\" class=\"form-control\" disabled=\"\"></div><div class=\"col-sm-6 form-group\" ng-if=\"typeGraphic == 2\"><label>Filtrar por:</label><div><input type=\"radio\" ng-model=\"config.option_filter\" name=\"inicio_vigencia\" ng-value=\"1\"> Inicio de vigencia<br><input type=\"radio\" ng-model=\"config.option_filter\" name=\"vencimiento\" ng-value=\"2\"> Vencimiento</div></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #EA9021;\">Anaranjado: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" value=\"0\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.orange\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #F5CD21;\">Amarillo: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" ng-model=\"config.orange\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.yellow\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #17A45D;\">Verde: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" ng-model=\"config.yellow\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.green\" class=\"form-control\" required=\"\"></div></div><div class=\"pull-right\"><button class=\"btn btn-white\" ng-click=\"close()\" type=\"button\">Cancelar</button> <button class=\"btn btn-primary ladda-button\" ng-disabled=\"form.$invalid\" ng-click=\"saveConfig(config)\" type=\"button\">Guardar</button></div></form></div><div class=\"wizard\" ng-if=\"typeGraphic == 5\"><form name=\"form\"><div class=\"form-group col-sm-12\"><div class=\"col-sm-6 form-group\"><label>Filtrar por:</label><div><input type=\"radio\" ng-model=\"config.option_filter\" name=\"creadas\" ng-value=\"1\"> Creadas<br><input type=\"radio\" ng-model=\"config.option_filter\" name=\"asignadas\" ng-value=\"2\"> Asignadas<br><input type=\"radio\" ng-model=\"config.option_filter\" name=\"asignadas\" ng-value=\"3\"> Creadas/Asignadas</div></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #17A45D;\">Verde: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" value=\"Creación\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.green\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #F5CD21;\">Amarillo: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" ng-model=\"config.green\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.yellow\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #EA9021;\">Anaranjado: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" ng-model=\"config.yellow\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.orange\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #EA5121;\">Rojo: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Mayor a:</label> <input type=\"text\" name=\"motivo\" ng-model=\"config.orange\" class=\"form-control\" disabled=\"\"></div></div><div class=\"pull-right\"><button class=\"btn btn-white\" ng-click=\"close()\" type=\"button\">Cancelar</button> <button class=\"btn btn-primary ladda-button\" ng-disabled=\"form.$invalid\" ng-click=\"saveConfig(config)\" type=\"button\">Guardar</button></div></form></div><div class=\"wizard\" ng-if=\"typeGraphic == 6\"><form name=\"form\"><div class=\"form-group col-sm-12\"><div class=\"col-sm-6 form-group\"><label>Filtrar por:</label><div><input type=\"radio\" ng-model=\"config.option_filter\" name=\"entramite\" ng-value=\"1\"> En trámite<br><br></div></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #17A45D;\">Verde: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" value=\"Creación\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.green\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #F5CD21;\">Amarillo: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" ng-model=\"config.green\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.yellow\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #EA9021;\">Anaranjado: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Desde:</label> <input type=\"text\" name=\"motivo\" ng-model=\"config.yellow\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"motivo\">Hasta: (días)</label> <input type=\"number\" name=\"motivo\" ng-model=\"config.orange\" class=\"form-control\" required=\"\"></div></div><div class=\"form-group col-sm-12\"><label for=\"motivo\" style=\"color: #EA5121;\">Rojo: <span class=\"color-black\">*</span></label><br><div class=\"form-group col-sm-6\"><label for=\"motivo\">Mayor a:</label> <input type=\"text\" name=\"motivo\" ng-model=\"config.orange\" class=\"form-control\" disabled=\"\"></div></div><div class=\"pull-right\"><button class=\"btn btn-white\" ng-click=\"close()\" type=\"button\">Cancelar</button> <button class=\"btn btn-primary ladda-button\" ng-disabled=\"form.$invalid\" ng-click=\"saveConfig(config)\" type=\"button\">Guardar</button></div></form></div></div></div><button class=\"btn btn-success\" ng-click=\"showLog()\">Historial de configuración</button><div ng-if=\"showIt\"><div class=\"col-sm-12 m-t\"><table class=\"table table-bordered table-hover\"><thead><th>Fecha</th><th>Acción</th></thead><tbody><tr ng-repeat=\"log in logs track by $index\"><td>{{log.date | date: \'dd/MM/yyyy hh:mm:ss\'}}</td><td>{{log.msj}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/charts/endosos.chart.html","<div class=\"col-sm-4\"><h2>Endosos</h2><canvas id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"data\" chart-labels=\"labels\"></canvas></div>");
$templateCache.put("app/charts/renovaciones.chart.html","<div class=\"col-xs-12 col-sm-3\" ng-if=\"main.permiso_g_ren\"><div class=\"ibox-content col-xs-12 align-self-center\"><h3 class=\"text-center\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i> Renovaciones <a ng-click=\"configGraph(3)\"><i class=\"fa fa-wrench pull-right\" aria-hidden=\"true\"></i></a></h3><br><div class=\"row\"><graphic gtype=\"renewals\"></graphic></div><br><button class=\"btn btn-success center-block\" ng-click=\"setPolicyToList(1,1)\">Ver todos</button></div></div><div class=\"col-xs-12 col-sm-3\" ng-if=\"main.permiso_g_sin\"><div class=\"ibox-content\"><h3 class=\"text-center\"><i class=\"fa fa-ambulance\" aria-hidden=\"true\"></i> Siniestros <a ng-click=\"configGraph(4)\"><i class=\"fa fa-wrench pull-right\" aria-hidden=\"true\"></i></a></h3><br><div class=\"row\"><graphic gtype=\"sinister\"></graphic></div><br><button class=\"btn btn-success center-block\" ng-click=\"setSiniesters(1,1)\" ng-disabled=\"!main.acceso_adm_sin\">Ver todos</button></div></div>");
$templateCache.put("app/clasificacion/clasificacion.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Clasificación</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Clasificación</strong></li></ol></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createClasification()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Agregar Clasificación</button></div><div class=\"col-xs-12\" ng-show=\"showClasification\"><legend class=\"legend-title\" align=\"center\">Nueva Clasificación</legend><form class=\"row padding-10\" name=\"form\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Clasificación <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"clasificacion.classification_name\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" ng-model=\"clasificacion.description\"></textarea></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"save(clasificacion)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"close()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></form></div></div><div class=\"ibox float-e-margins\" ng-if=\"!showEditClasification\"><div class=\"ibox-title\"><h5>Clasificaciónes</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><table class=\"table table-hover table-bordered\"><thead><tr><th>Nombre</th><th>Observaciones</th><th>opciones</th></tr></thead><tbody><tr ng-repeat=\"item in clasificationList track by $index\"><td>{{ item.classification_name }}</td><td>{{ item.description }}</td><td ng-click=\"$event.stopPropagation()\"><a ng-click=\"edit(item)\" type=\"button\" class=\"btn btn-white\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a></td></tr></tbody></table></div></div></div></div><div class=\"row\" ng-if=\"showEditClasification\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"cancelEdit()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Editar Clasificación</legend><form class=\"row padding-10\" name=\"form\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Clasificación <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"editClasification.classification_name\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" ng-model=\"editClasification.description\"></textarea></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"update(editClasification)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Actualizar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelEdit()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></form></div></div>");
$templateCache.put("app/coberturas/coberturas.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ gc.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Coberturas</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Agregar nueva cobertura</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><form class=\"form-horizontal\" method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form.name.$invalid && !form.name.$pristine }\"><label class=\"col-sm-2 control-label\">Nombre de la cobertura<span class=\"color-red\">*</span></label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"coverage\" ng-model=\"vm.form.coverage\" required=\"\" type=\"text\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Aseguradora</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"prov as prov.compania for prov in vm.providers\" ng-model=\"vm.provider\" ng-change=\"vm.selectProvider()\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Ramos</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"branch as branch.ramo_name for branch in vm.ramo\" ng-model=\"vm.branch\" ng-change=\"vm.selectBranch()\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Subramos</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"sub as sub.subramo_name for sub in vm.branch.subramo_ramo\" ng-model=\"vm.subBranch\" ng-change=\"vm.selectSubBranch()\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Paquetes</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"pack as pack.package_name for pack in vm.subBranch.package_subramo\" ng-model=\"vm.packages\" ng-change=\"vm.selectPackage()\"></select></div></div></form></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button class=\"btn btn-primary\" ng-disabled=\"form.$invalid\" type=\"button\" ng-click=\"vm.createCoverage()\">Crear cobertura</button></div></div></div></div></div></div>");
$templateCache.put("app/coberturas/coberturas.table.html","<fieldset><legend class=\"legend-title\" align=\"center\">Coberturas</legend><div class=\"row\"><div class=\"col-xs-12 form-group\"><table class=\"table table-hover\"><thead><tr><th class=\"text-align-center\">Cobertura</th><th class=\"text-align-center\">Suma Asegurada</th><th class=\"text-align-center\">Deducible</th><th class=\"text-align-center\" ng-if=\"order.defaults.formInfo.code === 2 || order.defaults.formInfo.code === 3 || order.defaults.formInfo.code === 4 || order.defaults.formInfo.code === 5 || order.defaults.formInfo.code === 6 || order.defaults.formInfo.code === 7 || order.defaults.formInfo.code === 8 || order.defaults.formInfo.code === 10 || order.defaults.formInfo.code === 11 || order.defaults.formInfo.code === 12 || order.defaults.formInfo.code === 13 || order.defaults.formInfo.code === 14\">Coaseguro</th><th class=\"text-align-center\" ng-if=\"order.defaults.formInfo.code === 2 || order.defaults.formInfo.code === 3 || order.defaults.formInfo.code === 4 || order.defaults.formInfo.code === 5 || order.defaults.formInfo.code === 6 || order.defaults.formInfo.code === 7 || order.defaults.formInfo.code === 8 || order.defaults.formInfo.code === 10 || order.defaults.formInfo.code === 11 || order.defaults.formInfo.code === 12 || order.defaults.formInfo.code === 13 || order.defaults.formInfo.code === 14\">Tope Coaseguro</th><th></th></tr></thead><tbody><tr ng-repeat=\"coverage in order.defaults.coverages track by coverage.url | orderBy: \'id\'\"><td><p ng-if=\"coverage.coverage_name != \'\'\" ng-bind=\"coverage.coverage_name\"></p></td><td><div class=\"input-group\" ng-if=\"coverage.coverage_name != \'\'\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.sums_coverage\" ng-if=\"item.sum_insured !== null\" ng-init=\"!coverage.sumInPolicy.value ? coverage.sumInPolicy.value = item.sum_insured : def = item.default\" ng-click=\"coverage.sumInPolicy.value = item.sum_insured; show_button_save_sum = false\"><a>{{demo(item.sum_insured) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.sumInPolicy.value\" ng-keyup=\"show_button_save_sum = true\" format-currency=\"\"><div class=\"input-group-btn\" ng-show=\"show_button_save_sum\"><button class=\"btn btn-success\" ng-click=\"saveSum(coverage.sumInPolicy.value, coverage);show_button_save_sum = result_\">+</button></div></div></td><td><div class=\"input-group\" ng-if=\"coverage.coverage_name != \'\'\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.deductible_coverage\" ng-if=\"item.deductible !== null\" ng-init=\"!coverage.deductibleInPolicy.value ? coverage.deductibleInPolicy.value = item.deductible : def = item.default\" ng-click=\"coverage.deductibleInPolicy.value = item.deductible; show_button_save_ded = false\"><a>{{demo(item.deductible) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.deductibleInPolicy.value\" ng-keyup=\"show_button_save_ded = true\" format-currency=\"\"><div class=\"input-group-btn\" ng-show=\"show_button_save_ded\"><button class=\"btn btn-success\" ng-click=\"saveDed(coverage.deductibleInPolicy.value, coverage);show_button_save_ded = result_ded\">+</button></div></div></td><td ng-if=\"order.defaults.formInfo.code === 2 || order.defaults.formInfo.code === 3 || order.defaults.formInfo.code === 4 || order.defaults.formInfo.code === 5 || order.defaults.formInfo.code === 6 || order.defaults.formInfo.code === 7 || order.defaults.formInfo.code === 8 || order.defaults.formInfo.code === 10 || order.defaults.formInfo.code === 11 || order.defaults.formInfo.code === 12 || order.defaults.formInfo.code === 13 || order.defaults.formInfo.code === 14\"><div class=\"form-group\"><input class=\"col-xs-12 form-control\" type=\"text\" ng-if=\"coverage.coverage_name != \'\'\" ng-model=\"coverage.coinsuranceInPolicy.value\" value=\"\"></div></td><td ng-if=\"order.defaults.formInfo.code === 2 || order.defaults.formInfo.code === 3 || order.defaults.formInfo.code === 4 || order.defaults.formInfo.code === 5 || order.defaults.formInfo.code === 6 || order.defaults.formInfo.code === 7 || order.defaults.formInfo.code === 8 || order.defaults.formInfo.code === 10 || order.defaults.formInfo.code === 11 || order.defaults.formInfo.code === 12 || order.defaults.formInfo.code === 13 || order.defaults.formInfo.code === 14\"><div class=\"form-group\"><input class=\"col-xs-12 form-control\" type=\"text\" ng-if=\"coverage.coverage_name != \'\'\" ng-model=\"coverage.topeCoinsuranceInPolicy.value\" value=\"\"></div></td><td><button class=\"btn btn-white\" name=\"button\" ng-if=\"coverage.coverage_name != \'\'\" ng-click=\"order.options.deleteCoverage(coverage, $index); deleteCoveragePaq(coverage,$index)\" type=\"button\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><label>Agregar coberturas</label><select class=\"form-control m-b\" ng-options=\"cvg.coverage_name for cvg in order.defaults.coverageList | orderBy: \'coverage_name\' track by cvg.id\" ng-change=\"order.options.addCoverage(order.defaults.coverageInPackage);addCoveragePaq(order.defaults.coverageInPackage)\" ng-model=\"order.defaults.coverageInPackage\"><option value=\"\" disabled=\"\">Agrega una cobertura</option></select></div><div class=\"col-xs-12 form-group\" ng-if=\"newCoverPack == true\"><button ng-click=\"newCoverages()\" class=\"col-xs-12 btn btn-success pull-right col-md-4 col-lg-2 margin-bottom-10\">Nueva cobertura</button></div></div></fieldset>");
$templateCache.put("app/cobranzas/add.emails.reminder_pay.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Enviar a correo electrónico</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"row\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title\" align=\"center\">Recordatorio de pago por correo electrónico</legend><div class=\"col-xs-12 form-group\"><label>Correo electrónico<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"email\" name=\"email_assign_mail\" ng-model=\"vm.email_assign_mail\" required=\"\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"addEmail(vm.email_assign_mail)\">Agregar</button></div></div><div><input name=\"principal\" value=\"1\" ng-model=\"vm.r_type\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"principal\">Principal</span>&nbsp;&nbsp;&nbsp; <input name=\"cc\" value=\"2\" ng-model=\"vm.r_type\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"> <span for=\"cc\">Cc</span>&nbsp;&nbsp;&nbsp; <input name=\"cco\" value=\"3\" ng-model=\"vm.r_type\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"> <span for=\"cco\">Cco</span></div><input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{receiptAll.contratante.email}}\" ng-click=\"addEmail(receiptAll.contratante.email)\"> <input ng-repeat=\"correo in correos\" class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{correo.correo}}\" ng-click=\"addEmail(correo.correo)\"></div><div class=\"col-xs-12 form-group\" ng-if=\"mails.length\"><br><label>Se enviara a:</label><table class=\"table table-bordered\"><thead><th>Correo electrónico</th><th>Acciones</th></thead><tr ng-repeat=\"email in mails track by $index\"><td>{{email}}</td><td><button class=\"btn btn-danger\" ng-click=\"remove_email($index)\"><i class=\"fa fa-trash\"></i></button></td></tr></table></div><div class=\"col-xs-12 form-group\" ng-if=\"mails_cc.length\"><br><label>Se enviara con copia a:</label><table class=\"table table-bordered\"><thead><th>Correo electrónico</th><th>Acciones</th></thead><tr ng-repeat=\"email in mails_cc track by $index\"><td>{{email}}</td><td><button class=\"btn btn-danger\" ng-click=\"remove_email_cc($index)\"><i class=\"fa fa-trash\"></i></button></td></tr></table></div><div class=\"col-xs-12 form-group\" ng-if=\"mails_cco.length\"><br><label>Se enviara con copia oculta a:</label><table class=\"table table-bordered\"><thead><th>Correo electrónico</th><th>Acciones</th></thead><tr ng-repeat=\"email in mails_cco track by $index\"><td>{{email}}</td><td><button class=\"btn btn-danger\" ng-click=\"remove_email_cco($index)\"><i class=\"fa fa-trash\"></i></button></td></tr></table></div></div></div></div><span ng-if=\"receiptAll.receipt_type != 3 && notasCredito.length > 0\"><a ng-if=\"!show_notes\" ng-click=\"ver_notas()\">Ver notas de crédito</a><a ng-if=\"show_notes\" ng-click=\"ver_notas()\">Ocultar notas de crédito</a></span><br><div class=\"row col-xs-12\" ng-if=\"(receiptAll.receipt_type != 3 && notasCredito.length > 0) && show_notes\"><div class=\"ibox float-e-margins col-xs-12\"><div class=\"col-xs-12\"><h5 align=\"center\" class=\"blue-color\">Notas de Crédito</h5></div><div class=\"table-responsive col-xs-12 ng-scope\" ng-if=\"!main.show_binnacle_receipt\" id=\"tableDash\"><table class=\"table table-bordered table-hover col-xs-12\"><thead><th></th><th>Serie</th><th>Contratante</th><th>Endoso</th><th>Póliza</th><th>Prima Neta</th><th>Derecho</th><th>RPF</th><th>IVA</th><th>Prima Total</th><th>Vigencia</th><th>Vencimiento</th></thead><tbody><tr ng-repeat=\"item in notasCredito track by $index\" ng-if=\"item.status != 0\"><td ng-click=\"$event.stopPropagation()\"><label><input type=\"checkbox\" ng-model=\"item.sendNote\" ng-click=\"selectNota(item,item.sendNote)\" class=\"checkbox\"></label></td><td>{{item.recibo_numero}}</td><td>{{item.poliza.contractor.full_name}}</td><td>{{item.endorsement.number_endorsement}}</td><td>{{item.poliza.poliza_number}}{{item.fianza.fianza_number}}</td><td>{{item.prima_neta | currency}}</td><td>{{item.derecho | currency}}</td><td>{{item.rpf | currency}}</td><td>{{item.iva | currency}}</td><td>{{item.prima_total | currency}}</td><td>{{item.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}} - {{item.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{item.vencimiento | date: \'dd/MM/yyyy\': \'UTC\'}}</td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-if=\"receiptAll.contratante.description\"><span class=\"blue-color\">Observaciones del contratante:</span><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"receiptAll.contratante.description\"><span>{{ receiptAll.contratante.description }}</span></div></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Plantillas de Cobranza:</label><select class=\"form-control\" ng-options=\"item.name for item in plantillas\" ng-change=\"changePlantilla(plantilla)\" ng-model=\"plantilla\"><option value=\"\">Selecciona una plantilla</option></select></div><div class=\"form-group col-xs-12\"><label>Asunto:</label> <input class=\"col-xs-12 form-control\" type=\"text\" name=\"\" ng-model=\"subjectEmail\"></div><div class=\"form-group col-xs-12\"><label>Mensaje:</label><div><input type=\"checkbox\" name=\"custom_mail\" ng-model=\"custom_email\" ng-change=\"getTemplate(custom_email,\'email\')\"> <label>Personalizar</label><br></div><textarea ng-if=\"!custom_email\" class=\"col-xs-12 form-control textarea-modal\" ng-model=\"vm.messageEmail\"></textarea><div ng-if=\"custom_email\" text-angular=\"\" ng-model=\"vm.first_comment\" name=\"\"></div><br><div ng-if=\"custom_email\" ng-bind-html=\"body\" name=\"body\"></div><div ng-if=\"custom_email\" text-angular=\"\" ng-model=\"vm.second_comment\"></div><br><br><label ng-if=\"(signature && !custom_email) || (signature_edith)\">Firma</label><div ng-if=\"!signature_edith && !custom_email\" ng-bind-html=\"signature\" name=\"signature\"></div><div ng-if=\"signature_edith\" text-angular=\"\" ng-model=\"vm.signature\"></div><button ng-if=\"signature_edith\" class=\"btn btn-primary\" type=\"button\" ng-click=\"setSignature()\" title=\"Guardar Firma\">Guardar</button> <button ng-if=\"signature_edith\" class=\"btn btn-danger\" type=\"button\" ng-click=\"cancelEdithSignature()\" title=\"Guardar Firma\">Cancelar</button> <button ng-if=\"!signature_edith\" class=\"btn btn-default\" type=\"button\" ng-click=\"edithSignature()\" title=\"Editar Firma\">Editar Firma</button><br><form ng-if=\"banner_edith\"><label>* Estos archivos seran modificados para todas las cuentas de la organización</label><div class=\"form-group col-xs-12\"><label>Banner Superior :</label> <input class=\"col-xs-12 form-control\" type=\"file\" onchange=\"angular.element(this).scope().addFile(\'header\',this.files)\" ng-model=\"vm.b_super\"></div><div class=\"form-group col-xs-12\"><label>Banner Inferior:</label> <input class=\"col-xs-12 form-control\" type=\"file\" onchange=\"angular.element(this).scope().addFile(\'footer\',this.files)\" ng-model=\"vm.b_infer\"></div></form><button ng-if=\"banner_edith\" class=\"btn btn-primary\" type=\"button\" ng-click=\"saveFilesHF()\" title=\"Guardar Firma\">Guardar</button> <button ng-if=\"banner_edith\" class=\"btn btn-danger\" type=\"button\" ng-click=\"CancelEdithBanner()\" title=\"Guardar Firma\">Cancelar</button> <button ng-if=\"!banner_edith\" class=\"btn btn-default\" type=\"button\" ng-click=\"edithBanner()\" title=\"Editar Banner\">Editar Banner</button></div></div></div><div class=\"text-align-center\" ng-if=\"receiptAll.id && !adjFiles\"><button class=\"btn btn-secondary\" type=\"button\" ng-click=\"adjFilesOK(true)\" title=\"Deberá guardar los archivos para poder ser adjuntados en el correo\">Adjuntar/Ver Archivos</button></div><div class=\"col-xs-12 row\" ng-if=\"adjFiles\"><div upload-template=\"\"></div><div class=\"text-align-center\" ng-if=\"uploader.queue.length > 0\"><button class=\"btn btn-secondary\" type=\"button\" name=\"savefiles\" title=\"Click aquí y los archivos podrán ser adjuntados en el correo\" ng-click=\"saveFiles(receiptAll.id)\">Guardar archivos</button></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th width=\"20px\">Adjuntar</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"vmFiles.rename(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,files)\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</button> <span class=\"btn btn-success display-none\">Guardar</span></td><td><input type=\"checkbox\" ng_model=\"file.checked\" ng-change=\"shareFileEmail(file)\"></td></tr></tbody></table></div></div><div class=\"text-align-center\" ng-if=\"adjFiles\"><button class=\"btn btn-secondary\" type=\"button\" ng-click=\"adjFilesOK(false)\">Ocultar Archivos</button></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"sendReminder(files, vm.first_comment, vm.second_comment)\">Enviar recordatorio</button></div></div><script type=\"text/javascript\">\n  // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n  // $(document).ready(function(){\n  //   $(\'#modal_email\').modal(\'hide\');\n  //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n  //       $(\'body\').removeClass(\'modal-open\');\n  //       $(\'.modal-backdrop\').remove();\n  //     };\n  //   });\n// });\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    strongTag.hide();\n    inputTag.show();\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target);\n\n    strongTag.show();\n    inputTag.hide();\n  }\n\n  function renombrar_correo(){\n    var inputTag = $(event.target).parent().parent().parent().find(\"[id=\'item_txt\']\");\n    var spanTag = $(event.target).parent().parent().parent().find(\"[id=\'item_txt_span\']\");\n\n    inputTag.removeClass(\'display-none\');\n    spanTag.addClass(\'display-none\');\n\n    inputTag.focus();\n  }\n\n  function blur_correo(){\n    var inputTag = $(event.target).parent().parent().parent().find(\"[id=\'item_txt\']\");\n    var spanTag = $(event.target).parent().parent().parent().find(\"[id=\'item_txt_span\']\");\n\n    inputTag.addClass(\'display-none\');\n    spanTag.removeClass(\'display-none\');\n  }\n</script>");
$templateCache.put("app/cobranzas/add.phone.whatsappsms_reminderpay.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">{{ vm.whatsappWebEnabled ? \'Enviar a Móvil (WhatsApp Web)\' : \'Enviar a Móvil (Whatsapp/SMS)\' }}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"row\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title\" align=\"center\">{{ vm.whatsappWebEnabled ? \'Recordatorio de pago por WhatsApp Web\' : \'Recordatorio de pago por Móvil (SMS)\' }}</legend><div class=\"col-xs-12 form-group\"><label>{{ vm.whatsappWebEnabled ? \'Móvil (WhatsApp Web)\' : \'Móvil (Whatsapp/SMS)\' }}<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"phone\" name=\"phone_mensajeria\" ng-model=\"vm.phone_mensajeria\" maxlength=\"10\" required=\"\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"addPhoneMensajeria(vm.phone_mensajeria)\">Agregar</button></div></div><div class=\"col-xs-12 form-group\"><div class=\"radio-options-group\"><label class=\"radio-option-pill\" ng-if=\"!vm.whatsappWebEnabled\" ng-class=\"{\'active\': vm.whatsappsms == 1}\"><input type=\"radio\" name=\"type_msj\" ng-model=\"vm.whatsappsms\" ng-change=\"tipoMensaje(vm.whatsappsms)\" ng-value=\"1\"> <span>Whatsapp</span></label> <label class=\"radio-option-pill\" ng-if=\"vm.whatsappWebEnabled\" ng-class=\"{\'active\': vm.whatsappsms == 3}\"><input type=\"radio\" name=\"type_msj\" ng-model=\"vm.whatsappsms\" ng-change=\"tipoMensaje(vm.whatsappsms)\" ng-value=\"3\"> <span>WhatsApp Web (manual)</span></label> <label class=\"radio-option-pill\" ng-if=\"!vm.whatsappWebEnabled\" ng-class=\"{\'active\': vm.whatsappsms == 2}\"><input type=\"radio\" name=\"type_msj\" ng-model=\"vm.whatsappsms\" ng-change=\"tipoMensaje(vm.whatsappsms)\" ng-value=\"2\"> <span>SMS</span></label></div></div><input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{receiptAll.contratante.phone_mensajeria}}\" ng-click=\"addPhoneMensajeria(receiptAll.contratante.phone_mensajeria)\"> <input ng-repeat=\"phone in phones\" class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{phone.phone}}\" ng-click=\"addPhoneMensajeria(phone)\"></div><div class=\"col-xs-12 form-group\" ng-if=\"phones_sms.length\"><br><label>Se enviara a:</label><table class=\"table table-bordered\"><thead><tr><th ng-if=\"vm.whatsappsms == 3\">Seleccionar</th><th>Teléfono</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"phonem in phones_sms track by $index\"><td ng-if=\"vm.whatsappsms == 3\" class=\"text-center\"><input type=\"radio\" name=\"whatsappWebPhone\" ng-checked=\"phonem === vm.whatsappWebPhone\" ng-click=\"selectWhatsappWebPhone(phonem)\"></td><td>{{phonem}}</td><td><button class=\"btn btn-danger\" ng-click=\"remove_phone($index)\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div></div></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-if=\"vm.whatsappsms == 0 || vm.whatsappsms ==1\"><label>Plantillas de Whatsapp:<span class=\"red-color\">*</span></label><select class=\"form-control\" ng-options=\"item.mensaje for item in plantillasWhatsapp\" ng-change=\"changePlantillaWha(plantilla)\" ng-model=\"plantilla\"><option value=\"\" disabled=\"\">Selecciona una plantilla</option></select></div><div class=\"form-group col-xs-12 col-sm-6\" ng-if=\"vm.whatsappWebEnabled && vm.whatsappsms == 3\"><label>Plantillas de WhatsApp Web:<span class=\"red-color\">*</span></label><select class=\"form-control\" ng-options=\"item.title for item in plantillasWhatsappWeb\" ng-change=\"changePlantillaWhaWeb(plantillaWhatsappWeb)\" ng-model=\"plantillaWhatsappWeb\"><option value=\"\" disabled=\"\">Selecciona una Plantilla</option></select></div><div class=\"form-group col-xs-12 col-sm-6\" ng-if=\"!vm.whatsappWebEnabled && vm.whatsappsms ==2\"><label>Plantillas de SMS:<span class=\"red-color\">*</span></label><select class=\"form-control\" ng-options=\"item.text for item in plantillaSMS\" ng-change=\"changeSMS(plantilla)\" ng-model=\"plantilla\"><option value=\"\" disabled=\"\">Selecciona una Plantilla</option></select></div><div class=\"form-group col-xs-12\"><label>Mensaje:</label> <span ng-if=\"vm.whatsappsms ==1\" class=\"red-color\">Seleccione una Plantilla de Whatsapp</span> <textarea ng-if=\"vm.whatsappsms ==1\" class=\"col-xs-8 form-control textarea-modal\" ng-model=\"vm.messageEmail\" disabled=\"\"></textarea> <textarea ng-if=\"vm.whatsappsms ==2\" class=\"col-xs-8 form-control textarea-modal\" ng-model=\"vm.messageEmail\"></textarea> <textarea ng-if=\"vm.whatsappWebEnabled && vm.whatsappsms == 3\" class=\"col-xs-8 form-control textarea-modal\" placeholder=\"Escribe aquí tu mensaje para enviar por WhatsApp Web\" ng-model=\"vm.messageWhatsappManual\"></textarea><div class=\"alert alert-warning\" ng-if=\"vm.whatsappWebEnabled && vm.whatsappsms == 3\" style=\"margin-top:1rem;\" ng-init=\"antiSpamExpanded = true\"><div class=\"clearfix\"><strong>⚠️ Uso de WhatsApp Web:</strong> <button type=\"button\" class=\"btn btn-link btn-xs pull-right\" ng-click=\"antiSpamExpanded = !antiSpamExpanded\">{{ antiSpamExpanded ? \'Ocultar detalles\' : \'Mostrar más\' }}</button></div><ul class=\"list-unstyled\" ng-show=\"antiSpamExpanded\" style=\"margin-top:0.3rem;\"><li>• Envía en tandas pequeñas y deja pausas entre envíos para evitar limitaciones.</li><li>• Contacta preferentemente a clientes con consentimiento y/o interacción previa.</li><li>• Evita textos idénticos masivos.</li><li>• Si el cliente solicita no recibir mensajes, respeta la baja de inmediato.</li></ul><p class=\"text-muted\" ng-show=\"antiSpamExpanded\" style=\"margin-bottom:0;\">Las restricciones, límites o bloqueos son reglas y mecanismos de WhatsApp, ajenos a SAAM.</p><p class=\"text-muted\" ng-if=\"!antiSpamExpanded\" style=\"margin-bottom:0;\">Hay algunas restricciones que deberías saber cuando uses WhatsApp Web.</p></div><br><br><form ng-if=\"imagesms_edit && vm.whatsappsms !=2\"><label>* Esta imagen será modificada para todas las cuentas de la organización</label><div class=\"form-group col-xs-12\"><label>Imagen anexa al mensaje:</label> <input class=\"col-xs-12 form-control\" id=\"fileimagesms\" type=\"file\" onchange=\"angular.element(this).scope().addFile(\'image_sms\',this.files)\" ng-model=\"vm.image_sms\"></div></form><button ng-if=\"imagesms_edit\" class=\"btn btn-primary\" type=\"button\" ng-click=\"saveFilesIsms()\" title=\"Guardar Firma\">Guardar</button> <button ng-if=\"imagesms_edit\" class=\"btn btn-danger\" type=\"button\" ng-click=\"CancelEditISms()\" title=\"Guardar Firma\">Cancelar</button></div></div><div class=\"form-group col-xs-12\" align=\"center\"><div ng-if=\"preview\" ng-bind-html=\"preview\" name=\"preview\"></div><br></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-if=\"vm.whatsappsms != 3\" ng-disabled=\"!vm.previewReady || vm.previewLoading\" ng-click=\"sendReminderWhatsapp(files, vm.first_comment, vm.second_comment)\">Enviar recordatorio</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-disabled=\"!vm.previewReady || vm.previewLoading\" ng-if=\"vm.whatsappWebEnabled && vm.whatsappsms == 3\" ng-click=\"sendMessageByType()\"><i class=\"fa fa-whatsapp\"></i> Enviar WhatsApp</button></div></div><script type=\"text/javascript\">\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    strongTag.hide();\n    inputTag.show();\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target);\n\n    strongTag.show();\n    inputTag.hide();\n  }\n\n  function renombrar_correo(){\n    var inputTag = $(event.target).parent().parent().parent().find(\"[id=\'item_txt\']\");\n    var spanTag = $(event.target).parent().parent().parent().find(\"[id=\'item_txt_span\']\");\n\n    inputTag.removeClass(\'display-none\');\n    spanTag.addClass(\'display-none\');\n\n    inputTag.focus();\n  }\n\n  function blur_correo(){\n    var inputTag = $(event.target).parent().parent().parent().find(\"[id=\'item_txt\']\");\n    var spanTag = $(event.target).parent().parent().parent().find(\"[id=\'item_txt_span\']\");\n\n    inputTag.addClass(\'display-none\');\n    spanTag.removeClass(\'display-none\');\n  }\n  const maxSize = 5000000; \n\n  // Obtener referencia al elemento\n  const $miInput = document.querySelector(\"#fileimagesms\");\n  $(\"#fileimagesms\").on(\"change\", function() {\n    if (this.files.length <= 0) return;\n    const archivo = this.files[0];\n    if (archivo.size > maxSize) {\n        const tamanioEnMb = maxSize / 1000000;\n        alert(`El tamaño máximo es ${tamanioEnMb} MB`);\n        // Limpiar\n        $miInput.value = \"\";\n    } else {\n        // Validación pasada. Envía el formulario o haz lo que tengas que hacer\n    }\n  });\n</script></div>");
$templateCache.put("app/cobranzas/cobranzas.bonos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Bonos</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Bonos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title\"><h5>Nuevo bono</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Aseguradora</label><select class=\"form-control\" ng-model=\"vm.bono.aseguradora\" ng-options=\"providers.compania ? providers.compania : providers.id for providers in vm.providers | orderBy: \'compania\' track by providers.url\" ng-change=\"changeProvider(vm.bono.aseguradora); saveLocalstorange()\" required=\"\"><option value=\"0\">Seleccione una aseguradora</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Clave de Agente</label><select class=\"form-control\" ng-model=\"clave\" ng-options=\"clave as clave.clave + \' - \' + clave.name for clave in claves | orderBy: \'clave\' track by clave.url\" ng-change=\"changeClave(clave); saveLocalstorange()\"><option value=\"\">Seleccione una clave de agente</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo</label><select class=\"form-control\" ng-options=\"type.name for type in types_bono | orderBy:\'name\' track by type.id\" ng-change=\"changeType(); saveLocalstorange()\" name=\"type\" ng-model=\"type_bono\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Cantidad</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input type=\"number\" ng-model=\"vm.bono.cantidad\" ng-change=\"validateDecimal(vm.bono.cantidad); saveLocalstorange()\" class=\"ng-valid ng-dirty ng-touched form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de inicio:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.bono.start_validity\" value=\"{{vm.bono.start_validity}}\" ng-change=\"vm.changeUntil(); saveLocalstorange()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de fin:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.bono.end_validity\" value=\"{{vm.bono.end_validity}}\" ng-change=\"vm.changeUntil(); saveLocalstorange()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Número de Factura</label> <input type=\"text\" ng-model=\"vm.bono.factura_number\" class=\"ng-valid ng-dirty ng-touched form-control\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo de cambio</label><select class=\"form-control\" ng-change=\"change_pesos();saveLocalstorange()\" ng-model=\"vm.bono.tipo_de_cambio\" required=\"\"><option value=\"1\">Pesos</option><option value=\"2\">Dólares</option></select></div><div ng-if=\"referenciador\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label for=\"vendedor\">Referenciador</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"vendedor\" ng-model=\"vm.bono.vendor\" ng-change=\"changeVendedor(vm.bono.vendor); saveLocalstorange()\" ng-options=\"vendedor.url as vendedor.first_name + \' \' + vendedor.last_name for vendedor in referenciador\"><option value=\"\">Seleccione un referenciador</option></select><span class=\"input-group-btn\" ng-disabled=\"!order.form.subramo\"><button class=\"btn btn-primary\" ng-click=\"addNewSubramo()\"><i class=\"glyphicon glyphicon-pencil\"></i></button></span></div></div></div><div class=\"col-sm-12 form-group margin-top-24\"><button class=\"btn btn-info pull-right\" ng-click=\"vm.save_bono()\">Guardar nuevo bono</button></div></div></div></div></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bonos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora(s)</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.select_provider\" data-ng-options=\"providers.compania ? providers.compania : providers.id for providers in vm.providers | orderBy: \'compania\' track by providers.url\" ng-change=\"vm.selectProv(vm.select_provider);saveLocalstorange()\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport();saveLocalstorange()\"><option value=\"\">Selecciona una opción</option></select></div><div ng-if=\"vigency || created_at\"><div class=\"col-xs-3 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input ng-disabled=\"vm.buscar_por_folio\" type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince();saveLocalstorange()\" data-date-format=\"dd/mm/yyyy\"></div></div><div class=\"col-xs-3 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input ng-disabled=\"vm.buscar_por_folio\" type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil();saveLocalstorange()\" data-date-format=\"dd/mm/yyyy\"></div></div></div><div class=\"col-sm-3 form-group margin-top-24\" ng-if=\"vm.acceso_ver_cob\"><button class=\"btn btn-success col-xs-12\" ng-click=\"vm.GetBonos()\">Consultar</button></div></div></div></div></div></div></div><div ng-if=\"vm.bonos && vm.bonos.length\" class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Listado</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row animate\" ng-if=\"!vm.show_binnacle\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div class=\"project-list\"><table class=\"table table-bordered table-hover hidden-xs hidden-sm\" id=\"cobranza\"><thead><tr><th ng-model=\"vm.table.headers[0]\">Aseguradora</th><th ng-model=\"vm.table.headers[0]\">Clave Agente</th><th ng-model=\"vm.table.headers[0]\">Vigencia</th><th ng-model=\"vm.table.headers[0]\">Cantidad</th><th ng-model=\"vm.table.headers[0]\">Factura</th><th ng-model=\"vm.table.headers[0]\">Referenciador</th><th ng-model=\"vm.table.headers[0]\">Tipo de cambio</th><th ng-model=\"vm.table.headers[0]\">Tipo de bono</th></tr></thead><tbody><tr ng-repeat=\"bono in vm.bonos track by $index\" ng-click=\"vm.openModal(bono); vm.show_receipt_info = true\"><td>{{bono.aseguradora}}</td><td>{{bono.clave.clave }} - {{bono.clave.name}}</td><td>{{bono.start_validity | date:\"dd/MM/yyyy\": \'UTC\'}} - {{bono.end_validity | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td>{{bono.cantidad | currency}}</td><td>{{bono.factura_number}}</td><td>{{bono.vendor}}</td><td>{{bono.tipo_cambio}}</td><td>{{bono.type_bono}}</td></tr></tbody></table><div ng-if=\"vm.receipt_pagination\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br><br></div></div></div></div><div class=\"col-xs-12 col-sm-3\" ng-if=\"vm.acceso_rep_cob\"><button ng-if=\"vm.bonos && vm.bonos.length\" ng-click=\"exportData()\" class=\"btn btn-primary margin-top-10 col-xs-12\">Generar Reporte</button></div><div class=\"row animate\" ng-if=\"vm.show_binnacle\"><div class=\"col-md-12\"><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\"></comments></div><div class=\"col-md-12\"><a class=\"btn btn-primary\" ng-click=\"vm.returnToReceipts()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div></div></div></div></div></div></div></div>");
$templateCache.put("app/cobranzas/cobranzas.folios.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Cobranza</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Cobranza Folio Pago/Liquidación</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-sm-6 form-group text-center\"><input name=\"look_folio_pago\" value=\"1\" ng-model=\"vm.tipo_folio_buscar\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\" ng-change=\"tipoFolio(vm.tipo_folio_buscar)\"><span for=\"look_folio_pago\">Folio de pago</span></div><div class=\"col-xs-12 col-sm-6 form-group text-center\"><input name=\"look_folio_liq\" value=\"2\" ng-model=\"vm.tipo_folio_buscar\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\" ng-change=\"tipoFolio(vm.tipo_folio_buscar)\"> <span for=\"look_folio_liq\">Folio de liquidación</span></div><div class=\"col-xs-12 col-md-8 col-lg-6 col-sm-4 form-group\"><label>Folio:</label><div class=\"col-xs-12 input-group\"><select class=\"form-control\" ng-if=\"vm.tipo_folio_buscar == 1\" ng-model=\"vm.folio_a_buscar\" ng-change=\"changedFolio(folio)\" ng-options=\"folio as folio.folio_pago for folio in foliosPago\" required=\"\"><option value=\"\">Selecciona un folio</option></select><select class=\"form-control\" ng-if=\"vm.tipo_folio_buscar == 2\" ng-model=\"vm.folio_a_buscar\" ng-change=\"changedFolio(folio)\" ng-options=\"folio as folio.liquidacion_folio for folio in foliosLiquidacion\" required=\"\"><option value=\"\">Selecciona un folio</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Creado por</label><select class=\"form-control\" ng-model=\"vm.form.user\" data-ng-options=\"user.first_name +\' \'+user.last_name for user in vm.users | orderBy: \'first_name\' track by user.id\" ng-change=\"selectUser(vm.form.user)\"><option value=\"\">Todos los usuarios</option></select></div><div class=\"row\"><div ng-if=\"!fechasFilter\" class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-20\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.addFilter(1)\">Agregar filtro de fechas</button></div><div class=\"col-xs-12 col-sm-8\" ng-if=\"fechasFilter\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 margin-top-20\"><button class=\"btn btn-sm btn-warning\" ng-click=\"vm.addFilter(2)\">x</button></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.folio_a_buscar\"><button class=\"col-xs-12 btn btn-secondary\" ng-click=\"vm.showAll()\">Mostrar todos</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group pull-right\"><button type=\"button\" class=\"col-xs-12 btn btn-primary\" ng-click=\"vm.Generar(1,1,1,1)\">Consultar</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Folios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12\"><ul class=\"list-group\" ng-if=\"vm.tipo_folio_buscar == 1 || vm.tipo_folio_buscar == \'1\'\"><div ng-repeat=\"folios in vm.folios_pago | orderBy: \'folio\'\"><li class=\"list-group-item\" ng-init=\"folios[$index] = false\"><legend class=\"legend-title\" ng-click=\"folios[$index] ? folios[$index] = false : folios[$index] = true; vm.getCobranza(folios, 1,1,1,$index)\">Folio de Pago: {{ folios.folio_pago }}</legend><div class=\"row\" ng-if=\"folios[$index] && index_folio_p == $index\" ng-hide=\"!vm.receipts.length\"><div class=\"panel-body table-over-y\"><legend class=\"legend-title\" align=\"center\">Recibos</legend><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\" id=\"cobranza\" ng-if=\"folios[$index]\"><thead><tr><th ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}}</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th><th ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}}</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th><th ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}}</th><th ng-model=\"vm.table.headers[10]\">Fecha Liquidación</th><th>Folio Liquidación</th><th>Fecha Pago</th><th>Folio Pago</th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}}</th></tr></thead><tbody><tr ng-repeat=\"receipt in vm.receipts track by $index\" ng-click=\"vm.editRecibo(receipt); vm.show_receipt_info = true\"><td><span ng-if=\"receipt.receipt_type == 1 && receipt.poliza\">Póliza</span> <span ng-if=\"receipt.receipt_type == 1 && receipt.fianza\">Fianza</span> <span ng-if=\"receipt.receipt_type == 2\">Endoso</span> <span ng-if=\"receipt.receipt_type == 3\">Nota Crédito/Endoso</span> <span ng-if=\"receipt.receipt_type == 4\">Bono</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">{{receipt.poliza.contractor.full_name}}</span><br><small ng-if=\"receipt.poliza.contractor.type_person ==1 || receipt.poliza.contractor.type_person ==\'Física\'\">Persona Fisica</small> <small ng-if=\"receipt.poliza.contractor.type_person ==2 || receipt.poliza.contractor.type_person ==\'Moral\'\">Persona Moral</small></td><td class=\"project-title\"><a ng-if=\"vm.acceso_adm_pol && receipt.poliza\" ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a> <a ng-if=\"vm.acceso_adm_fia && receipt.receipt_type == 1 && (receipt.poliza.document_type == 7 || receipt.poliza.document_type == 8)\" ui-sref=\"fianzas.info({polizaId: receipt.poliza.id})\">Fianza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"!vm.acceso_adm_pol && receipt.poliza\" ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</span> <span ng-if=\"!vm.acceso_adm_fia && receipt.receipt_type == 1 && (receipt.poliza.document_type == 7 || receipt.poliza.document_type == 8)\" ui-sref=\"fianzas.info({polizaId: receipt.poliza.poli\">Fianza: {{ receipt.poliza.poliza_number }}</span><br><small>Serie:</small><br><small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></td><td class=\"project-title\"><span class=\"font-weight-bold\" ng-if=\"receipt.poliza\">Aseguradora: {{ receipt.poliza.aseguradora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}</small></td><td class=\"project-status\"><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8}\">{{ statusReceipts(receipt) }}</div></td><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.liquidacion_date | date: \'dd-MM-yyyy\' }}</td><td>{{ receipt.liquidacion_folio }}</td><td>{{ receipt.pay_date | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td>{{ receipt.folio_pago}}</td><td>{{ receipt.poliza.owner }}{{ receipt.fianza.owner }}</td><td ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</td><td ng-if=\"!(receipt.antiguedad > 0)\">0 días</td><td class=\"project actions\"><a class=\"btn btn-white btn-sm\" ng-click=\"vm.changeStatusModal(receipt)\"><i class=\"fa fa-pencil\"></i> Aplicar</a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showPhone(receipt)\" ng-disabled=\"!receipt.contratante.phone\"><i class=\"fa fa-phone\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"addEmailsConfirm(receipt)\" ng-if=\"vm.acceso_cor\"><i class=\"fa fa-envelope\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showComment(receipt)\" ng-disabled=\"reviews\"><i class=\"fa fa-file\"></i> Observaciones</a> <a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.receipts.length && vm.acceso_rep_cob\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button ng-click=\"exportData(1)\" class=\"col-xs-12 btn btn-primary\">Generar Reporte</button></div></div></div><div class=\"col-xs-12 hidden-xs hidden-sm\" ng-if=\"vm.form.receipt_pagination || vm.form.recibos_config > 10\"><pagination config=\"vm.receipt_r\" model=\"vm.receipt\" params=\"toClose\"></pagination></div><br></div></li></div></ul><ul class=\"list-group\" ng-if=\"vm.tipo_folio_buscar == 2\"><div ng-repeat=\"folios_liq in vm.folios_liquidacion | orderBy: \'liquidacion_folio\'\"><li class=\"list-group-item\" ng-init=\"folios_liq[$index] = false\"><legend class=\"legend-title\" ng-click=\"folios_liq[$index] ? folios_liq[$index] = false : folios_liq[$index] = true; vm.getCobranza(folios_liq, 2,1,1,$index)\">Folio de Liquidación: {{ folios_liq.liquidacion_folio }}</legend><div class=\"row\" ng-if=\"folios_liq[$index] && index_folio == $index\"><div ng-if=\"vm.receipts_liq.length\"><legend class=\"legend-title\" align=\"center\">Recibos</legend><div class=\"pull-right\"><a class=\"btn btn-white btn-sm\" ng-click=\"filesToFolio(folios_liq.liquidacion_folio )\"><i class=\"fa fa-upload\"></i> Archivos</a></div><hr><br><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\" id=\"cobranza\" ng-if=\"folios_liq[$index]\"><thead><tr><th ng-model=\"vm.table.headers[0]\">Tipo</th><th ng-model=\"vm.table.headers[1]\">Contratante</th><th ng-model=\"vm.table.headers[2]\">Número Póliza/Fianza</th><th ng-model=\"vm.table.headers[3]\">Número Recibo</th><th ng-model=\"vm.table.headers[4]\">Aseguradora</th><th ng-model=\"vm.table.headers[5]\">Estatus</th><th ng-model=\"vm.table.headers[6]\">Prima Total</th><th ng-model=\"vm.table.headers[6]\">Fecha Liquidación</th><th ng-model=\"vm.table.headers[6]\">Folio Liquidación</th><th ng-model=\"vm.table.headers[6]\">Fecha Pago</th><th ng-model=\"vm.table.headers[6]\">Folio pago</th><th ng-model=\"vm.table.headers[7]\">Creado Por</th><th ng-model=\"vm.table.headers[8]\">Antigüedad</th><th ng-model=\"vm.table.headers[9]\">Acciones</th></tr></thead><tbody><tr ng-repeat=\"receipt in vm.receipts_liq track by $index\" ng-click=\"vm.editRecibo(receipt); vm.show_receipt_info = true\"><td><span ng-if=\"receipt.receipt_type == 1 && (receipt.poliza.document_type != 7 && receipt.poliza.document_type != 8)\">Póliza</span> <span ng-if=\"receipt.receipt_type == 1 && (receipt.poliza.document_type == 7 || receipt.poliza.document_type == 8)\">Fianza</span> <span ng-if=\"receipt.receipt_type == 2\">Endoso</span> <span ng-if=\"receipt.receipt_type == 3\">Nota Crédito/Endoso</span> <span ng-if=\"receipt.receipt_type == 4\">Bono</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">{{receipt.poliza.contractor.full_name}}</span><br><small ng-if=\"receipt.poliza.contractor.type_person ==1 || receipt.poliza.contractor.type_person ==\'Física\'\">Persona Fisica</small> <small ng-if=\"receipt.poliza.contractor.type_person ==2 || receipt.poliza.contractor.type_person ==\'Moral\'\">Persona Moral</small></td><td class=\"project-title\"><a ng-if=\"vm.acceso_adm_pol && (receipt.poliza.document_type != 7 && receipt.poliza.document_type != 8)\" ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"!vm.acceso_adm_pol\">Póliza: {{ receipt.poliza.poliza_number }}</span> <a ng-if=\"vm.acceso_adm_fia && receipt.receipt_type == 1 && (receipt.poliza.document_type == 7 || receipt.poliza.document_type == 8)\" ui-sref=\"fianzas.info({polizaId: receipt.poliza.id})\">Fianza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"!vm.acceso_adm_fia && receipt.receipt_type == 1 && (receipt.poliza.document_type == 7 || receipt.poliza.document_type == 8)\">Fianza: {{ receipt.poliza.poliza_number }}</span><br><small>Serie:</small><br><small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></td><td class=\"project-title\"><span class=\"font-weight-bold\" ng-if=\"receipt.poliza || receipt.bono\">Aseguradora: {{ receipt.poliza.aseguradora }}{{ receipt.bono.aseguradora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}{{ receipt.fianza.subramo }}</small></td><td class=\"project-status\"><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8}\">{{ statusReceipts(receipt) }}</div></td><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.liquidacion_date | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td>{{ receipt.liquidacion_folio }}</td><td>{{ receipt.pay_date | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td>{{ receipt.folio_pago}}</td><td>{{ receipt.poliza.owner }}{{receipt.fianza.owner}}{{receipt.bono.owner}}</td><td ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</td><td ng-if=\"!(receipt.antiguedad > 0)\">0 días</td><td class=\"project actions\"><a class=\"btn btn-white btn-sm\" ng-click=\"vm.changeStatusModal(receipt)\"><i class=\"fa fa-pencil\"></i> Aplicar</a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showPhone(receipt)\" ng-disabled=\"!receipt.contratante.phone\"><i class=\"fa fa-phone\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"addEmailsConfirm(receipt)\" ng-if=\"vm.acceso_cor\"><i class=\"fa fa-envelope\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showComment(receipt)\" ng-disabled=\"reviews\"><i class=\"fa fa-file\"></i> Observaciones</a> <a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.receipts_liq.length && vm.acceso_rep_cob\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button ng-click=\"exportData(1)\" class=\"col-xs-12 btn btn-primary\">Generar Reporte</button></div></div></div></div><div class=\"col-xs-12 hidden-xs hidden-sm\" ng-if=\"vm.form.receipt_pagination || vm.form.recibos_config > 10\"><pagination config=\"vm.receipt_l\" model=\"vm.receipts_liq\" params=\"toClose\"></pagination></div><br></div></li></div></ul></div><div ng-if=\"vm.folio_a_buscar && (vm.recibosliquidados.length || vm.recibospago.length)\"><div class=\"project-list\"><legend class=\"legend-title\" align=\"center\">Recibos</legend><table class=\"table table-bordered table-hover hidden-xs hidden-sm\"><thead><th ng-click=\"vm.changeReceipts(1, vm.receipts_tipo_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_tipo_asc == 1, \'fa fa-sort-asc\': vm.receipts_tipo_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(2, vm.receipts_cont_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_cont_asc == 1, \'fa fa-sort-asc\': vm.receipts_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(3, vm.receipts_nump_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_nump_asc == 1, \'fa fa-sort-asc\': vm.receipts_nump_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(4, vm.receipts_periodo_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_periodo_asc == 1, \'fa fa-sort-asc\': vm.receipts_periodo_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(5, vm.receipts_aseg_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_aseg_asc == 1, \'fa fa-sort-asc\': vm.receipts_aseg_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(6, vm.receipts_estatus_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_estatus_asc == 1, \'fa fa-sort-asc\': vm.receipts_estatus_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(7, vm.receipts_ptotal_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ptotal_asc == 1, \'fa fa-sort-asc\': vm.receipts_ptotal_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(8, vm.receipts_operador_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_operador_asc == 1, \'fa fa-sort-asc\': vm.receipts_operador_asc == 2}\"></span></th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}}</th></thead><tbody ng-if=\"vm.recibospago.length\"><tr ng-if=\"vm.recibospago.length\" ng-repeat=\"receipt in vm.recibospago track by $index\"><td><span ng-if=\"receipt.receipt_type == 1 && (receipt.poliza.document_type != 7 && receipt.poliza.document_type != 8)\">Póliza</span> <span ng-if=\"receipt.receipt_type == 1 && (receipt.poliza.document_type == 7 || receipt.poliza.document_type == 8)\">Fianza</span> <span ng-if=\"receipt.receipt_type == 2\">Endoso</span> <span ng-if=\"receipt.receipt_type == 3\">Nota Crédito/Endoso</span> <span ng-if=\"receipt.receipt_type == 4\">Bono</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">{{receipt.poliza.contractor.full_name}}</span><br><small ng-if=\"receipt.poliza.contractor.type_person ==1 || receipt.poliza.contractor.type_person ==\'Física\'\">Persona Fisica</small> <small ng-if=\"receipt.poliza.contractor.type_person ==2 || receipt.poliza.contractor.type_person ==\'Moral\'\">Persona Moral</small></td><td class=\"project-title\"><a ng-if=\"vm.acceso_adm_pol\" ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"!vm.acceso_adm_pol && receipt.receipt_type == 1 && (receipt.poliza.document_type != 7 && receipt.poliza.document_type != 8)\">Póliza: {{ receipt.poliza.poliza_number }}</span> <a ng-if=\"vm.acceso_adm_fia && receipt.receipt_type == 1 && (receipt.poliza.document_type == 7 || receipt.poliza.document_type == 8)\" ui-sref=\"fianzas.info({polizaId: receipt.poliza.id})\">Fianza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"!vm.acceso_adm_pol && receipt.receipt_type == 1 && (receipt.poliza.document_type != 7 && receipt.poliza.document_type != 8)\">Póliza: {{ receipt.poliza.poliza_number }}</span> <span ng-if=\"!vm.acceso_adm_fia && receipt.receipt_type == 1 && (receipt.poliza.document_type == 7 || receipt.poliza.document_type == 8)\">Fianza: {{ receipt.poliza.poliza_number }}</span><br><small>Serie:</small><br><small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></td><td class=\"project-title\"><span class=\"font-weight-bold\" ng-if=\"receipt.poliza\">Aseguradora: {{ receipt.poliza.aseguradora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}</small></td><td class=\"project-status\"><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8}\">{{ statusReceipts(receipt) }}</div></td><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.poliza.owner }}{{ receipt.bono.owner }}</td><td ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</td><td ng-if=\"!(receipt.antiguedad > 0)\">0 días</td><td class=\"project actions\"><a class=\"btn btn-white btn-sm\" ng-click=\"vm.changeStatusModal(receipt)\"><i class=\"fa fa-pencil\"></i> Aplicar</a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showPhone(receipt)\" ng-disabled=\"!receipt.contratante.phone\"><i class=\"fa fa-phone\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"addEmailsConfirm(receipt)\" ng-if=\"vm.acceso_cor\"><i class=\"fa fa-envelope\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showComment(receipt)\" ng-disabled=\"reviews\"><i class=\"fa fa-file\"></i> Observaciones</a> <a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody><tbody ng-if=\"vm.recibosliquidados.length\"><tr ng-if=\"vm.recibosliquidados.length\" ng-repeat=\"receipt in vm.recibosliquidados track by $index\"><td><span ng-if=\"receipt.receipt_type == 1 && (receipt.poliza.document_type != 7 && receipt.poliza.document_type != 8)\">Póliza</span> <span ng-if=\"receipt.receipt_type == 1 && (receipt.poliza.document_type == 7 && receipt.poliza.document_type == 8)\">Fianza</span> <span ng-if=\"receipt.receipt_type == 2\">Endoso</span> <span ng-if=\"receipt.receipt_type == 3\">Nota Crédito/Endoso</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">{{receipt.poliza.contractor.full_name}}<br><small ng-if=\"receipt.poliza.contractor.type_person ==1 || receipt.poliza.contractor.type_person ==\'Física\'\">Persona Fisica</small> <small ng-if=\"receipt.poliza.contractor.type_person ==2 || receipt.poliza.contractor.type_person ==\'Moral\'\">Persona Moral</small></span></td><td class=\"project-title\"><a ng-if=\"vm.acceso_adm_pol && (receipt.poliza.document_type != 7 && receipt.poliza.document_type != 8)\" ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"!vm.acceso_adm_pol && receipt.poliza\">Póliza: {{ receipt.poliza.poliza_number }}</span> <a ng-if=\"vm.acceso_adm_fia && (receipt.poliza.document_type == 7 && receipt.poliza.document_type == 8)\" ui-sref=\"fianzas.info({polizaId: receipt.poliza.id})\">Fianza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"!vm.acceso_adm_fia && (receipt.poliza.document_type == 7 && receipt.poliza.document_type == 8)\">Fianza: {{ receipt.poliza.poliza_number }}</span><br><small>Serie:</small><br><small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}{{receipt.fianza.recibos_fianza.length}}</small></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></td><td class=\"project-title\"><span class=\"font-weight-bold\" ng-if=\"receipt.poliza\">Aseguradora: {{ receipt.poliza.aseguradora }}</span> <span class=\"font-weight-bold\" ng-if=\"receipt.fianza\">Afianzadora: {{ receipt.fianza.afianzadora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}{{ receipt.fianza.subramo }}</small></td><td class=\"project-status\"><div status-receipt-clean=\"{{ receipt.status }}\" class=\"label\" ng-class=\"{\'label-success\': receipt.status == 1, \'label-info\' : receipt.status == 2, \'label-primary\' : receipt.status == 3, \'label-warning\' : receipt.status == 4, \'label-info\' : receipt.status == 5 }\"></div></td><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.poliza.owner }}{{ receipt.fianza.owner }}{{ receipt.bono.owner }}</td><td ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</td><td ng-if=\"!(receipt.antiguedad > 0)\">0 días</td><td class=\"project actions\"><a class=\"btn btn-white btn-sm\" ng-click=\"vm.changeStatusModal(receipt)\"><i class=\"fa fa-pencil\"></i> Aplicar</a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showPhone(receipt)\" ng-disabled=\"!receipt.contratante.phone\"><i class=\"fa fa-phone\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"addEmailsConfirm(receipt)\" ng-if=\"vm.acceso_cor\"><i class=\"fa fa-envelope\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showComment(receipt)\" ng-disabled=\"reviews\"><i class=\"fa fa-file\"></i> Observaciones</a> <a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"(vm.recibospago.length || vm.recibosliquidados.length) && vm.acceso_rep_cob\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button ng-click=\"exportData(1)\" class=\"col-xs-12 btn btn-primary\">Generar Reporte</button></div></div></div><div ng-if=\"vm.show_pag_policy\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"project-list\"><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.status == 5 && receipt.isCopy == false\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}:<p ng-if=\"receipt.receipt_type == 1\">Póliza</p><p ng-if=\"receipt.receipt_type == 2\">Endoso</p></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p ng-if=\"receipt.receipt_type == 1\">Póliza</p><p ng-if=\"receipt.receipt_type == 2\">Endoso</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[1] }}</label><p>{{receipt.poliza.contractor.full_name}}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[2] }}</label><p><a ng-if=\"vm.acceso_adm_pol\" ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"!vm.acceso_adm_pol\">Póliza: {{ receipt.poliza.poliza_number }}</span></p><small>Serie:</small> <small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[3] }}</label><p><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[4] }}</label><p><span class=\"font-weight-bold\">{{ receipt.poliza.aseguradora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}</small></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-status\"><label>{{ vm.table.headers[5] }}</label><div status-receipt-clean=\"{{ receipt.status }}\" class=\"label\" ng-class=\"{\'label-success\': receipt.status == 1, \'label-info\' : receipt.status == 2,\'label-primary\' : receipt.status == 3, \'label-warning\' : receipt.status == 4 }\"></div></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ receipt.prima_total | currency}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ receipt.poliza.owner }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</p><p ng-if=\"!(receipt.antiguedad > 0)\">0 días</p></div><div class=\"table-cell col-xs-12 col-sm-6 project actions\"><label>{{ vm.table.headers[9] }}</label><p><a class=\"btn btn-white btn-sm\" ng-click=\"vm.changeStatusModal(receipt)\"><i class=\"fa fa-pencil\"></i> Aplicar</a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showPhone(receipt)\" ng-disabled=\"!receipt.contratante.phone\"><i class=\"fa fa-phone\"></i></a><a class=\"btn btn-white btn-sm\" ng-click=\"addEmailsConfirm(receipt)\" ng-if=\"vm.acceso_cor\"><i class=\"fa fa-envelope\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showComment(receipt)\" ng-disabled=\"reviews\"><i class=\"fa fa-file\"></i> Observaciones</a><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></tr></table></div></div><div ng-if=\"vm.show_pag_policy\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div></div></div></div>");
$templateCache.put("app/cobranzas/cobranzas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Cobranza</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Cobranza</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!vm.buscar_por_folio\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete><small ng-if=\"vm.form.contratante && vm.form.contratante.value\"><i><b>ID</b> de contratante para layout : <b>{{vm.form.contratante.value}}</b></i></small></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"subgroups.length >0\"><label>SubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subgroup\" data-ng-options=\"subgroup.group_name for subgroup in subgroups track by subgroup.url\" ng-change=\"vm.changeSubgroup(vm.form.subgroup)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"subsubgroups.length >0\"><label>SubsubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subsubgroup\" data-ng-options=\"subsubgroup.group_name for subsubgroup in subsubgroups track by subsubgroup.url\" ng-change=\"vm.changeSubsubgroup(vm.form.subsubgroup)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-model=\"vm.form.businesLine\" data-ng-options=\"businesLine.name for businesLine in vm.businesLine track by businesLine.id\" ng-change=\"vm.changeBLine(vm.form.businesLine)\" required=\"\"><option value=\"\">Todas las líneas</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-model=\"vm.form.celula\" data-ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"saveLocalStorage()\"><option value=\"\">Todo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"campo_agrupacion\"><label>Nivel de Agrupación</label><autocomplete datasource=\"groupinglevels_data\" id=\"groupingleves\" model=\"vm.form.groupinglevel\" change=\"vm.matchesGroupinglevel(vm.form.groupinglevel.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.form.groupinglevel.subgrupos.length >0 && campo_agrupacion\"><label>SubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subgrouping\" data-ng-options=\"subgrouping.description for subgrouping in vm.form.groupinglevel.subgrupos track by subgrouping.url\" ng-change=\"vm.changeSubgrouping(vm.form.subgrouping)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.form.subgrouping.subsubgrupos.length >0 && campo_agrupacion\"><label>SubsubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subsubgrouping\" data-ng-options=\"subsubgroupin.description for subsubgroupin in vm.form.subgrouping.subsubgrupos track by subsubgroupin.url\" ng-change=\"vm.changeSubsubgrouping(vm.form.subsubgrouping)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Clasificación</label><autocomplete datasource=\"classification_data\" id=\"classification\" model=\"vm.form.classification\" change=\"vm.matchesClassification(vm.form.classification.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Número de póliza</label> <input type=\"text\" name=\"poliza_number\" ng-model=\"vm.form.poliza_number\" class=\"form-control\" ng-change=\"saveLocalStorage()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Estatus</label><select class=\"form-control\" ng-model=\"vm.form.status\" data-ng-options=\"payment.name for payment in vm.status\" ng-change=\"vm.changeStatus(vm.form.status)\" required=\"\"></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Aseguradora(s)</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Ramo(s)</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\" data-ng-options=\"ramos_toselected as ramos_toselected.ramo_name for ramos_toselected in vm.ramos_toselected track by ramos_toselected.id\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Subramo(s)</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"js-example-basic-multiple form-control\" name=\"states1[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Forma de pago</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"form-control\" ng-model=\"vm.form.payment\" data-ng-options=\"payment.name for payment in vm.payment track by payment.id\" ng-change=\"vm.changePayment(vm.form.payment)\" required=\"\"><option value=\"\">Todas las formas de pago</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Pagado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user_pay\" data-ng-options=\"users_p.first_name + \' \' + users_p.last_name for users_p in vm.users | orderBy: \'username\' track by users_p.url\" ng-change=\"selectUserPay(select_user_pay)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input ng-disabled=\"vm.buscar_por_folio\" type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input ng-disabled=\"vm.buscar_por_folio\" type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.acceso_ver_ref\"><label>Referenciador</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"form-control\" ng-model=\"vm.form.vendedor\" data-ng-options=\"vendedor.name for vendedor in vm.vendedores | orderBy: \'name\' track by vendedor.id\" ng-change=\"vm.changeReferenciador(vm.form.vendedor)\"><option value=\"\">Todos los referenciadores</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo de Recibo</label><select ng-model=\"vm.form.tipo_recibo\" ng-options=\"item.id as item.name for item in vm.tipo_recibo\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Conducto de Pago</label><select class=\"form-control\" ng-change=\"changeConducto(vm.form.tipo_cobro)\" ng-options=\"item.id as item.name for item in vm.conductos\" ng-model=\"vm.form.tipo_cobro\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Ejecutivo de cobranza</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"form-control\" ng-model=\"vm.form.ejecutivo\" data-ng-options=\"ejecutivos.name for ejecutivos in vm.ejecutivos | orderBy: \'name\' track by ejecutivos.id\" ng-change=\"saveLocalStorage()\"><option value=\"\">Todos los Ejecutivos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24\"><input name=\"look_folio\" ng-model=\"vm.buscar_por_folio\" type=\"checkbox\" class=\"ng-valid ng-dirty ng-touched\"> <span for=\"look_folio\">Buscar por número de folio de pago/liquidación</span></div><div ng-if=\"vm.buscar_por_folio\" class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24 text-center\"><input name=\"look_folio_pago\" value=\"1\" ng-model=\"vm.tipo_folio_buscar\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"look_folio_pago\">Folio de pago</span></div><div ng-if=\"vm.buscar_por_folio\" class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24 text-center\"><input name=\"look_folio_liq\" value=\"2\" ng-model=\"vm.tipo_folio_buscar\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"look_folio_liq\">Folio de liquidación</span></div><div ng-if=\"vm.buscar_por_folio\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Buscar Folio:</label> <input placeholder=\"Folio\" type=\"text\" ng-if=\"vm.buscar_por_folio\" class=\"form-control\" ng-model=\"vm.folio_a_buscar\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.buscar_por_folio\"><label>Creado por</label><select class=\"form-control\" ng-model=\"vm.form.user\" data-ng-options=\"user.first_name +\' \'+user.last_name for user in vm.users | orderBy: \'first_name\' track by user.id\" ng-change=\"selectUser(vm.form.user)\"><option value=\"\">Todos los usuarios</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Carátula:</label><br><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.word\" change=\"vm.getCaratulas(vm.word)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getCarSelected(vm.word)\"><span class=\"fa fa-ok\"></span> Seleccionar</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24 pull-right\" ng-if=\"vm.acceso_ver_cob\"><button class=\"col-xs-12 btn btn-success ladda-button2\" ng-click=\"vm.Generar(1,1,1,1)\">Consultar</button></div></div></div></div></div></div><div ng-if=\"vm.buscar_por_folio\" class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Resultados de búsqueda por folio</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row animate\" ng-if=\"!vm.show_binnacle\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><uib-tabset><div class=\"panel-body\"><button class=\"btn btn-success col-md-4\" ng-if=\"vm.receipts && vm.receipts.length > 0 && vm.tipo_folio_buscar == 1\" ng-click=\"SeleccionliquidarTodos()\"><i class=\"fa fa-check-square\" aria-hidden=\"true\"></i> Seleccionar todos</button><div class=\"project-list\"><table class=\"table table-bordered table-hover table-hover hidden-xs hidden-sm\"><thead><th>Seleccionar</th><th ng-click=\"vm.changeReceipts(1, vm.receipts_tipo_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_tipo_asc == 1, \'fa fa-sort-asc\': vm.receipts_tipo_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(2, vm.receipts_cont_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_cont_asc == 1, \'fa fa-sort-asc\': vm.receipts_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(3, vm.receipts_nump_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_nump_asc == 1, \'fa fa-sort-asc\': vm.receipts_nump_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(4, vm.receipts_periodo_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_periodo_asc == 1, \'fa fa-sort-asc\': vm.receipts_periodo_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(5, vm.receipts_aseg_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_aseg_asc == 1, \'fa fa-sort-asc\': vm.receipts_aseg_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(6, vm.receipts_estatus_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_estatus_asc == 1, \'fa fa-sort-asc\': vm.receipts_estatus_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(7, vm.receipts_ptotal_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ptotal_asc == 1, \'fa fa-sort-asc\': vm.receipts_ptotal_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(8, vm.receipts_operador_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_operador_asc == 1, \'fa fa-sort-asc\': vm.receipts_operador_asc == 2}\"></span></th><th>Sucursal</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}}</th></thead><tbody><tr ng-repeat=\"receipt in vm.receipts track by $index\"><td><input name=\"look_folio\" ng-model=\"receipt.checked\" type=\"checkbox\" class=\"ng-valid ng-dirty ng-touched\"></td><td ng-if=\"receipt.receipt_type == 1\">Póliza</td><td ng-if=\"receipt.receipt_type == 2\">Endoso</td><td ng-if=\"receipt.receipt_type == 3\">Nota Crédito/Endoso</td><td class=\"project-title\"><span class=\"font-weight-bold\">{{receipt.poliza.contractor.full_name}}</span><br><small ng-if=\"receipt.poliza.contractor.type_person == \'Física\'\">Persona Física</small> <small ng-if=\"receipt.poliza.contractor.type_person == \'Moral\'\">Persona Moral</small></td><td class=\"project-title\"><a ng-if=\"vm.acceso_ver_pol\" ng-click=\"open_tab(receipt.poliza.id)\">Póliza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"!vm.acceso_ver_pol\">Póliza: {{ receipt.poliza.poliza_number }}</span><br><small ng-if=\"receipt.poliza.identifier\"><b>Identificador:</b>{{ receipt.poliza.identifier }}</small><br><small>Serie:</small><br><small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\': \'UTC\'}}</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">Aseguradora: {{ receipt.poliza.aseguradora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}</small></td><td class=\"project-status\"><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></td><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.poliza.owner }}</td><td>{{ receipt.poliza.sucursal.sucursal_name}}</td><td>{{ receipt.antiguedad}} días</td><td class=\"project actions\"><a class=\"btn btn-white btn-sm\" ng-click=\"vm.changeStatusModal(receipt)\"><i class=\"fa fa-pencil\"></i> Aplicar</a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showPhone(receipt)\" ng-disabled=\"!receipt.contratante.phone\"><i class=\"fa fa-phone\"></i></a><a ng-if=\"vm.acceso_cor\" class=\"btn btn-white btn-sm\" ng-click=\"addEmailsConfirm(receipt)\"><i class=\"fa fa-envelope\"></i></a> <span title=\"{{ vm.whatsappWebEnabled ? \'Recordatorio por WhatsApp Web\' : \'Recordatorio por SMS\' }}\"><button class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); addPhoneWhatsapp(receipt, receipt.poliza.contractor)\" ng-disabled=\"receipt.status != 4\"><img ng-if=\"!vm.whatsappWebEnabled\" style=\"height: 15px;\" class=\"icon-menu\" src=\"../../assets/comment-sms-solid.svg\"> <i ng-if=\"vm.whatsappWebEnabled\" class=\"fa fa-whatsapp\" style=\"color: #25D366;\" aria-hidden=\"true\"></i></button></span> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showComment(receipt)\" ng-disabled=\"reviews\"><i class=\"fa fa-file\"></i> Observaciones</a> <a class=\"btn btn-warning btn-sm\" ng-click=\"$event.stopPropagation();applyEx()\" ng-if=\"receipt.excedente > 0\" style=\"background-color: white;border-color: #f8ac59;color: black;\"><a class=\"btn btn-success btn-sm\" ng-click=\"$event.stopPropagation();verFlotilla(receipt.poliza)\" ng-if=\"receipt.poliza.document_type == 3 && receipt.poliza.subramo == \'Automóviles\'\" style=\"background-color: white;border-color: #BAC5C7;color: black;\"><i class=\"fa fa-car\" aria-hidden=\"true\" title=\"Ver detalle de Flotilla\"></i></a></a><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a ng-if=\"receipt.poliza.conducto_de_pago != \'No domiciliada\'\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"{{receipt.poliza.conducto_de_pago}}\"><i ng-if=\"receipt.poliza.conducto_de_pago == \'Agente\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CAC\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CAT/Domiciliado\'\" class=\"fa fa-credit-card-alt\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'Nómina\'\" class=\"fa fa-money\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CUT\'\" class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_policy\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.status == 2 && receipt.isCopy == false\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}:<p ng-if=\"receipt.receipt_type == 1\">Póliza</p><p ng-if=\"receipt.receipt_type == 2\">Endoso</p><p ng-if=\"receipt.receipt_type == 3\">Nota Crédito/Endoso</p></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p ng-if=\"receipt.receipt_type == 1\">Póliza</p><p ng-if=\"receipt.receipt_type == 2\">Endoso</p><p ng-if=\"receipt.receipt_type == 3\">ota Crédito/NEndoso</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[1] }}</label><p>{{receipt.poliza.contractor.full_name}}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[2] }}</label><p><a ng-if=\"vm.acceso_ver_pol\" ng-click=\"open_tab(receipt.poliza.id)\">Póliza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"!vm.acceso_ver_pol\">Póliza: {{ receipt.poliza.poliza_number }}</span></p><br><small ng-if=\"receipt.poliza.identifier\"><b>Identificador:</b>{{ receipt.poliza.identifier }}</small><br><small>Serie:</small> <small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[3] }}</label><p><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\': \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\': \'UTC\'}}</span></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[4] }}</label><p><span class=\"font-weight-bold\">{{ receipt.poliza.aseguradora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}</small></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-status\"><label>{{ vm.table.headers[5] }}</label><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ receipt.prima_total | currency}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ receipt.poliza.owner }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{ receipt.antiguedad}} días</p></div><div class=\"table-cell col-xs-12 col-sm-6 project actions\"><label>{{ vm.table.headers[9] }}</label><p><a class=\"btn btn-white btn-sm\" ng-click=\"vm.changeStatusModal(receipt)\"><i class=\"fa fa-pencil\"></i> Aplicar</a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showPhone(receipt)\" ng-disabled=\"!receipt.contratante.phone\"><i class=\"fa fa-phone\"></i></a><a ng-if=\"vm.acceso_cor\" class=\"btn btn-white btn-sm\" ng-click=\"addEmailsConfirm(receipt)\"><i class=\"fa fa-envelope\"></i></a> <span title=\"{{ vm.whatsappWebEnabled ? \'Recordatorio por WhatsApp Web\' : \'Recordatorio por SMS\' }}\"><button class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); addPhoneWhatsapp(receipt, receipt.poliza.contractor)\" ng-disabled=\"receipt.status != 4\"><img ng-if=\"!vm.whatsappWebEnabled\" style=\"height: 15px;\" class=\"icon-menu\" src=\"../../assets/comment-sms-solid.svg\"> <i ng-if=\"vm.whatsappWebEnabled\" class=\"fa fa-whatsapp\" style=\"color: #25D366;\" aria-hidden=\"true\"></i></button></span> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showComment(receipt)\" ng-disabled=\"reviews\"><i class=\"fa fa-file\"></i> Observaciones</a><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a ng-if=\"receipt.poliza.conducto_de_pago != \'No domiciliada\'\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"{{receipt.poliza.conducto_de_pago}}\"><i ng-if=\"receipt.poliza.conducto_de_pago == \'Agente\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CAC\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CAT/Domiciliado\'\" class=\"fa fa-credit-card-alt\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'Nómina\'\" class=\"fa fa-money\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CUT\'\" class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a></p></div></tr></table></div></div><br></div><button class=\"btn btn-info col-md-4 pull-right\" ng-if=\"vm.receipts && vm.receipts.length > 0 && vm.tipo_folio_buscar == 1\" ng-click=\"liquidarTodos()\"><i class=\"fa fa-check-square\" aria-hidden=\"true\"></i> Liquidar selección</button></div></uib-tabset></div></div></div><div ng-if=\"vm.receipts.length\"><div ng-if=\"vm.show_button1 == true && !vm.show_binnacle\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-10 pull-right\" ng-if=\"vm.acceso_rep_cob\"><button ng-click=\"exportData(1)\" class=\"col-xs-12 btn btn-primary ladda-button\">Generar Reporte</button></div></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle\"><div class=\"col-md-12\"><label>Bitácora Recibos</label><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><div class=\"row margin-bottom-10\"><div class=\"col-xs-12 text-right\"></div></div><comments datasource=\"vm.comments_data\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\" receiptmodel=\"vm.receipt_url\" exportable=\"true\"></comments></div><div class=\"col-md-12\"><a class=\"btn btn-primary\" ng-click=\"vm.returnToReceipts()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div></div></div></div></div></div></div><div ng-if=\"!vm.buscar_por_folio && vm.acceso_ver_cob\" class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Cobranza</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row animate\" ng-if=\"!vm.show_binnacle\"><div class=\"col-xs-12\"><div class=\"tabs-container\" ng-if=\"vm.acceso_ver_cob\"><div ng-include=\"\'app/cobranzas/recibospendientes.tabla.html\'\"></div></div></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle\"><div class=\"col-md-12\"><label>Bitácora Recibos</label><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\" receiptmodel=\"vm.receipt_url\" exportable=\"true\"></comments></div><div class=\"col-md-12\"><a class=\"btn btn-primary\" ng-click=\"vm.returnToReceipts()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div></div></div></div></div></div></div><div ng-if=\"!vm.buscar_por_folio && vm.acceso_ver_cob\" class=\"row\" style=\"display: none\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Notas de Crédito</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row animate\" ng-if=\"!vm.show_binnacle_nc\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><uib-tabset><div class=\"panel-body\"><div class=\"project-list\"><table class=\"table table-bordered table-hover table-hover hidden-xs hidden-sm\"><thead><th ng-click=\"vm.changeNCr(1, vm.nota_cont_asc == 1 ? 2 : 1)\" ng-model=\"vm.table_nc.headers[0]\">{{vm.table_nc.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.nota_cont_asc == 1, \'fa fa-sort-asc\': vm.nota_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeNCr(2, vm.nota_folio_asc == 1 ? 2 : 1)\" ng-model=\"vm.table_nc.headers[1]\">{{vm.table_nc.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.nota_folio_asc == 1, \'fa fa-sort-asc\': vm.nota_folio_asc == 2}\"></span></th><th ng-click=\"vm.changeNCr(3, vm.nota_numend_asc == 1 ? 2 : 1)\" ng-model=\"vm.table_nc.headers[2]\">{{vm.table_nc.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.nota_numend_asc == 1, \'fa fa-sort-asc\': vm.nota_numend_asc == 2}\"></span></th><th ng-click=\"vm.changeNCr(4, vm.nota_numpol_asc == 1 ? 2 : 1)\" ng-model=\"vm.table_nc.headers[3]\">{{vm.table_nc.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.nota_numpol_asc == 1, \'fa fa-sort-asc\': vm.nota_numpol_asc == 2}\"></span></th><th ng-click=\"vm.changeNCr(5, vm.nota_fecha_asc == 1 ? 2 : 1)\" ng-model=\"vm.table_nc.headers[4]\">{{vm.table_nc.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.nota_fecha_asc == 1, \'fa fa-sort-asc\': vm.nota_fecha_asc == 2}\"></span></th><th ng-click=\"vm.changeNCr(6, vm.nota_ptotal_asc == 1 ? 2 : 1)\" ng-model=\"vm.table_nc.headers[5]\">{{vm.table_nc.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.nota_ptotal_asc == 1, \'fa fa-sort-asc\': vm.nota_ptotal_asc == 2}\"></span></th><th ng-click=\"vm.changeNCr(7, vm.nota_pago_asc == 1 ? 2 : 1)\" ng-model=\"vm.table_nc.headers[6]\">{{vm.table_nc.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.nota_pago_asc == 1, \'fa fa-sort-asc\': vm.nota_pago_asc == 2}\"></span></th><th ng-click=\"vm.changeNCr(8, vm.nota_moneda_asc == 1 ? 2 : 1)\" ng-model=\"vm.table_nc.headers[7]\">{{vm.table_nc.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.nota_moneda_asc == 1, \'fa fa-sort-asc\': vm.nota_moneda_asc == 2}\"></span></th><th ng-model=\"vm.table_nc.headers[8]\">{{vm.table_nc.headers[8]}}</th><th ng-model=\"vm.table_nc.headers[9]\">{{vm.table_nc.headers[9]}}</th></thead><tbody><tr ng-repeat=\"nota in vm.notas_credito track by $index\"><td>{{nota.policy.contractor.full_name}}</td><td>{{nota.folio}}</td><td>{{nota.endorsement.number_endorsement}}</td><td>{{nota.policy.poliza_number}}</td><td>{{ nota.fecha_emision | date:\"dd/MM/yyyy\" }}</td><td>{{ nota.prima_total | currency}}</td><td payment=\"{{nota.payform}}\"></td><td ng-if=\"nota.policy.f_currency == 1\">PESOS</td><td ng-if=\"nota.policy.f_currency != 1\">DOLARES</td><td ng-if=\"!(nota.antiguedad > 0)\">0 días</td><td ng-if=\"nota.antiguedad > 0\">{{ nota.antiguedad}} días</td><td class=\"project actions\"><a class=\"btn btn-white btn-sm\" ng-click=\"vm.NotasModal(nota)\"><i class=\"fa fa-pencil\"></i> Aplicar</a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showPhone(nota)\" ng-disabled=\"!nota.contratante.phone\"><i class=\"fa fa-phone\"></i></a><a ng-if=\"vm.acceso_cor\" class=\"btn btn-white btn-sm\" ng-click=\"addEmailsConfirm(nota)\"><i class=\"fa fa-envelope\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showComment(nota)\" ng-disabled=\"reviews\"><i class=\"fa fa-file\"></i> Observaciones</a><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(nota,\'recibo\')\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a ng-if=\"receipt.poliza.conducto_de_pago != \'No domiciliada\'\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"{{receipt.poliza.conducto_de_pago}}\"><i ng-if=\"receipt.poliza.conducto_de_pago == \'Agente\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CAC\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CAT/Domiciliado\'\" class=\"fa fa-credit-card-alt\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'Nómina\'\" class=\"fa fa-money\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CUT\'\" class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_nc && vm.notas_credito\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages_nc()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages_nc | slice:start:end\" ng-class=\"{\'active\': page === actual_page_nc}\" ng-click=\"selectPage_nc(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages_nc()\" ng-if=\"totalPages_nc.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage_nc()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"nota in vm.notas_credito track by $index\"><div class=\"ibox-title\"><h5>{{ vm.table_nc.headers[0] }}<p ng-if=\"nota.auto_endorsement\">{{nota.auto_endorsement.policy.contractor.full_name}}</p><p ng-if=\"nota.damages_endorsement\">{{nota.damages_endorsement.policy.contractor.full_name}}</p><p ng-if=\"nota.disease_endorsement\">{{nota.disease_endorsement.policy.contractor.full_name}}</p><p ng-if=\"nota.life_endorsement\">{{nota.life_endorsement.policy.contractor.full_name}}</p><div ibox-tools=\"\"></div></h5></div></div><br></div></div></uib-tabset></div></div></div><div ng-if=\"vm.notas_credito.length\"><div ng-if=\"vm.show_button_nc == true && !vm.show_binnacle_nc && vm.acceso_rep_cob\"><button ng-click=\"exportData(3)\" class=\"btn btn-primary margin-top-10 ladda-button\">Generar Reporte</button></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle_nc\"><div class=\"col-md-12\"><label>Bitácora Recibos</label><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.notas_id\" receiptmodel=\"vm.receipt_url\" exportable=\"true\"></comments></div><div class=\"col-md-12\"><a class=\"btn btn-primary\" ng-click=\"vm.returnToNote()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div></div></div></div></div></div></div><script type=\"text/javascript\">\n  $(window).load(function() { $(\"#state\").select2(); });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/cobranzas/cobranzas.modal.errores.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">{{vmm.titulo}}</h4></div><div class=\"modal-body\"><ul><li ng-repeat=\"error in vmm.errores track by $index\"><span>{{error}}</span><br></li></ul></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div></div>");
$templateCache.put("app/cobranzas/cobranzas.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Aplicar recibo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\" ng-init=\"poliza = false; recibos = true; bitacora = false; conciliado = false; log = false;recordatorios=false;cerrado=false\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': recibos }\"><a ng-click=\"recibos = true; pagado = false; liquidado = false; mensajeria = false; conciliado = false; log = false; recordatorios=false;cerrado=false\">Aplicar</a></li><li ng-class=\"{ \'active\': pagado }\"><a ng-click=\"recibos = false; pagado = true; liquidado = false; mensajeria = false; conciliado = false; log = false; recordatorios=false;cerrado=false\">Info. Pago</a></li><li ng-class=\"{ \'active\': liquidado }\"><a ng-click=\"recibos = false; pagado = false; liquidado = true; mensajeria = false; conciliado = false; log = false; recordatorios=false;cerrado=false\">Info. Liquidación</a></li><li ng-class=\"{ \'active\': conciliado }\"><a ng-click=\"recibos = false; pagado = false; liquidado = false; mensajeria = false; conciliado = true; log = false; recordatorios=false;cerrado=false\">Info. Conciliación</a></li><li ng-class=\"{ \'active\': cerrado }\"><a title=\"Folio(s) de Estados de Cuenta\" aria-label=\"Folio(s) de Estados de Cuenta\" ng-click=\"recibos=false; pagado=false; liquidado=false; mensajeria=false; conciliado=false; cerrado=true; log=false; recordatorios=false\">Folios Edo. Cuenta</a></li><li ng-class=\"{ \'active\': mensajeria }\"><a ng-click=\"recibos = false; pagado = false; liquidado = false; mensajeria = true; conciliado = false; log = false; recordatorios=false;cerrado=false\">Mensajería</a></li><li ng-class=\"{ \'active\': log }\"><a ng-click=\"recibos = false; pagado = false; liquidado = false; mensajeria = false; conciliado = false; log = true; recordatorios=false;cerrado=false;getLogReceipt(4,receipt.id)\">Log</a></li><li ng-class=\"{ \'active\': recordatorios }\"><a ng-click=\"recibos = false; pagado = false; liquidado = false; mensajeria = false; conciliado = false;recibos = false; recordatorios = true\">Recordatorios</a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': recibos}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"receipt.isDB\"><a ng-click=\"goToPolicy(receiptPoliza.id)\">Ver póliza</a></li><li><a ng-click=\"getLiquidacionPDF(receipt)\" ng-if=\"(receipt.status == 5 || receipt.status == 6) && receipt.liquidacion_folio\">Ver PDF liquidación</a></li><li ng-if=\"add_emails && vm.acceso_cor\"><a ng-click=\"showEmail(receipt)\">Enviar recordatorio de pago</a></li><li ng-if=\"bono\"><a ng-click=\"deleteBono()\">Eliminar bono</a></li><li class=\"dropdown-submenu\" ng-if=\"vm.files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!vm.files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"vm.files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"vm.files\" ng-repeat=\"file in vm.files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length && view_cartas\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"viewCarta(receipt.poliza_id, carta.id, receipt.id)\">{{carta.name}}</a></li></ul></li></ul></div><br><div class=\"row\"><div class=\"form-group col-xs-8 col-sm-6\"><h3>Estatus actual:</h3><div ng-bind=\"receipt.status | receipts\" class=\"label\" ng-class=\"{\'label-success\': receipt.status == 1 || receipt.status == 5, \'label-danger\': receipt.status == 2, \'label-warning\' : receipt.status == 3 || receipt.status == 4 || receipt.status == 10 || receipt.status == 11, \'label-default\': receipt.status == 6 || receipt.status == 7 || receipt.status == 8 || receipt.status == 9}\"></div></div><div class=\"form-group col-xs-4 col-sm-6 pull-right\"><a class=\"btn btn-info btn-sm pull-right\" title=\"Crear Recordatorio\" ng-click=\"$event.stopPropagation();vm.createRecordatorio(receipt,4)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-md-6\"><span class=\"color-blue\">Contratante:</span><p ng-if=\"(receipt.policy.natural.full_name || receipt.policy.juridical.j_name) && !nj_contractor\">{{receipt.policy.natural.full_name}}{{receipt.policy.juridical.j_name}}{{receipt.contractor}}</p><p ng-if=\"(receipt.fianza.natural || receipt.fianza.juridical) && !nj_contractor\">{{receipt.fianza.natural}}{{receipt.fianza.juridical}}{{receipt.contractor}}</p><p ng-if=\"(receipt.policy.natural || receipt.policy.juridical) && !((receipt.policy.natural.full_name || receipt.policy.juridical.j_name) || ((receipt.fianza.natural || receipt.fianza.juridical))) && !nj_contractor\">{{receipt.policy.natural}}{{receipt.policy.juridical}}</p><p ng-if=\"(receipt.contratante.full_name || receipt.contratante.j_name) && !((receipt.policy.natural.full_name || receipt.policy.juridical.j_name) || ((receipt.fianza.natural || receipt.fianza.juridical))) && !nj_contractor\">{{receipt.contratante.full_name}}{{receipt.contratante.j_name}}</p><p ng-if=\"nj_contractor\">{{nj_contractor.full_name}} {{nj_contractor.j_name}}</p><p ng-if=\"!nj_contractor\">{{receipt.contratante}}</p></div><br><div class=\"form-group col-xs-12\" ng-if=\"!chngDesc\"><span class=\"blue-color\">Observaciones:</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeDescriptionC(true)\"><i class=\"fa fa-edit\" aria-hidden=\"true\"></i></button><div><span style=\"background-color: #E5F518;\">{{ nj_contractor.description }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"chngDesc\"><label>Observaciones</label> <textarea class=\"form-control\" ng-model=\"nj_contractor.description\" type=\"text\"></textarea><div class=\"col-xs-6\"><button class=\"btn btn-primary btn-sm\" ng-click=\"saveDescript(nj_contractor)\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-warning btn-sm\" ng-click=\"changeDescriptionC(false)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Tipo de Recibo:</span><p ng-if=\"receipt.receipt_type == 1\">Recibo de póliza</p><p ng-if=\"receipt.receipt_type == 2\">Recibo de endoso</p><p ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.recibo_numero\"><span class=\"color-blue\">Serie:</span><p>{{receipt.recibo_numero}}</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.folio\"><span class=\"color-blue\">Folio:</span><p>{{receipt.folio}}</p></div><div ng-if=\"receipt.receipt_type == 1\" class=\"col-xs-12 col-md-3\"><span ng-if=\"_insurance.document_type != 7 && _insurance.document_type != 8\" class=\"color-blue\">Número de Póliza:</span> <span ng-if=\"_insurance.document_type == 7 || _insurance.document_type == 8\" class=\"color-blue\">Número de Fianza:</span><p ng-if=\"receipt.poliza\">{{receipt.poliza}}</p><p ng-if=\"!receipt.poliza\">{{receipt.poliza_aux}}</p></div><div ng-if=\"receipt.receipt_type == 2\" class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Número de Endoso:</span><p ng-if=\"receipt.endorsement\">{{receipt.endorsement}}</p></div><div ng-if=\"receipt.receipt_type == 1\" class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Identificador:</span><p ng-if=\"receipt.identifier\">{{receipt.identifier}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Inicio de Vigencia:</span><p>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Fin de Vigencia:</span><p>{{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.vencimiento\"><span class=\"color-blue\">Fecha de Vencimiento:</span><p>{{receipt.vencimiento | date: \'dd/MM/yyyy\' : \'UTC\'}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Prima Neta:</span><p>{{receipt.prima_neta | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span ng-if=\"_insurance.document_type != 7 && _insurance.document_type != 8\" class=\"color-blue\">Derecho:</span> <span ng-if=\"_insurance.document_type == 7 || _insurance.document_type == 8\" class=\"color-blue\">Gastos:</span><p>{{receipt.derecho | currency}}</p></div><div class=\"col-xs-12 col-md-6\"><span ng-if=\"_insurance.document_type != 7 && _insurance.document_type != 8\" class=\"color-blue\">Recargo por Pago Fraccionado:</span> <span ng-if=\"_insurance.document_type == 7 || _insurance.document_type == 8\" class=\"color-blue\">Derecho:</span><p>{{receipt.rpf | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Iva:</span><p>{{receipt.iva | currency}}</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"vm.permiso_comisiones\"><span class=\"color-blue\">Comisión:</span><p>{{receipt.comision | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Prima Total:</span><p>{{receipt.prima_total | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\"><strong>Creado por:</strong></span><p>{{receipt.owner}}</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.folio_factura\"><span class=\"color-blue\"><strong>Referencia compañia</strong></span><p>{{receipt.folio_factura}}</p></div><div class=\"col-xs-8 col-md-3 form-group\"><span class=\"color-blue\">Promesa de pago:</span><p ng-if=\"!vm.edith_promesa_pago\">{{receipt.promesa_pago | date: \'dd/MM/yyyy\'}} <a class=\"color-blue\" ng-click=\"vm.edith_promesa_pago=true\">Editar</a></p><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"vm.edith_promesa_pago\"><input type=\"text\" name=\"promesa_pago\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.new_promesa_pago\" value=\"{{receipt.promesa_pago}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-4 col-md-1 form-group\" ng-if=\"vm.edith_promesa_pago\"><button class=\"form-control btn btn-primary\" type=\"button\" ng-click=\"update_promesa_pago(receipt)\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i></button> <button class=\"form-control btn btn-danger\" type=\"button\" ng-click=\"vm.edith_promesa_pago=false;\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></div><br><div class=\"col-xs-12 col-md-4\" ng-if=\"receipt.status ==6 || receipt.status ==\'6\'\"><span class=\"color-blue\">Comisión conciliada:</span><p>{{receipt.comision_conciliada | currency}}</p></div><div class=\"col-xs-12 col-md-4\" ng-if=\"receipt.status ==6 || receipt.status ==\'6\'\"><span class=\"color-blue\">% Comisión Estimada:</span><p>{{receipt.comision_conciliada_p_estimada}}</p></div><div class=\"col-xs-12 col-md-4\" ng-if=\"receipt.status ==6 || receipt.status ==\'6\'\"><span class=\"color-blue\">% Comisión conciliada:</span><p>{{receipt.comision_conciliada_p}}</p></div><br></div><div class=\"col-xs-12 form-group\" ng-if=\"!receipt.pay_date && status == 1\"><hr><span><input ng-model=\"vm.apply\" ng-click=\"applyFolio(vm.apply)\" type=\"checkbox\"> Aplicar Folio de Pago</span></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"showFolioSave\"><label>Folio a aplicar:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"folio\" ng-change=\"changedFolio(folio)\" ng-options=\"folio as folio.folio for folio in folioSave\" required=\"\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona un folio</option></select></div><div class=\"col-xs-12 form-group\"><label ng-if=\"status.value != 6 && receipt.id && can_pay == true\">Estatus<span class=\"color-red\">*</span></label> <label ng-if=\"status.value == 6 && receipt.id && can_pay == true\">Estatus</label><select class=\"form-control\" ng-model=\"status\" ng-change=\"changedValue(status)\" ng-options=\"status as status.label for status in statusReceipt track by status.value\" ng-if=\"receipt.id\" required=\"\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona un estatus</option></select><span class=\"form-control-static\" ng-if=\"status && status.value && status.value == 6\"><span ng-if=\"status.value && status.value==6\">Conciliado</span> <span ng-if=\"status.value && status.value==5\">Liquidado</span> <span ng-if=\"status.value && status.value==1\">Pagado</span> <span ng-if=\"status.value && status.value==4\">Pendiente de pago</span> <span ng-if=\"status.value && status.value==7\">Cerrado</span> <span ng-if=\"status.value && status.value==2\">Cancelado</span> <span ng-if=\"status.value && status.value==3\">Prorrogado</span></span></div><br><div class=\"col-xs-4 form-group\" ng-if=\"vm.pagar_parcial_bool == true\"><label>Cantidad pago parcial ($)<span class=\"color-red\">*</span></label> <input class=\"form-control col-xs-12\" type=\"number\" ng-model=\"vm.cantidad_pago_parcial\"></div><div class=\"col-xs-8 form-group\" ng-if=\"vm.pagar_parcial_bool == true\"><div class=\"col-xs-6 col-md-6 form-group\"><label>Forma de Pago</label><select class=\"form-control\" ng-model=\"pago\" ng-change=\"changedPago(pago, 1)\" ng-options=\"pago as pago.label for pago in statusPayform track by pago.value\" ng-disabled=\"status.value == 6\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona una forma de pago</option></select></div><div class=\"col-xs-6 col-sm-6 form-group\"><label>Documento de pago<span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.folio_pay\" type=\"text\"></div></div><div class=\"col-xs-12 col-sm-6 form-group pull-right\" ng-if=\"vm.pagar_parcial_bool == true\"><div class=\"col-xs-6\"><label>Fecha de pago<span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.pago_date\" value=\"{{vm.pago_date}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><button class=\"btn btn-success col-xs-6 m-t\" ng-click=\"proceder_pago_parcial(receipt)\">Abonar</button></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"showFolio && !receipt.pay_date && status == 1\"><span><input ng-model=\"vm.folioPay\" ng-click=\"showFolioPay(vm.folioPay)\" type=\"checkbox\"> Folio de Pago</span></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"showPay\"><label>Folio <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.folio_pay\" type=\"text\"></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"receipt.status == 4 && status == 1\"><label>Forma de Pago</label><select class=\"form-control\" ng-model=\"pago\" ng-change=\"changedPago(pago, 1)\" ng-options=\"pago as pago.label for pago in statusPayform track by pago.value\" ng-disabled=\"status.value == 6\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona una forma de pago</option></select></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"!receipt.liquidacion_form && status == 5\"><label>Forma de Liquidación</label><select class=\"form-control\" ng-model=\"pago\" ng-change=\"changedPago(pago, 2)\" ng-options=\"pago as pago.label for pago in statusPayform track by pago.value\" ng-disabled=\"status.value == 6\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona una forma de pago</option></select></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"display_notes\"><label>Notas</label><select class=\"form-control m-b\" ng-model=\"pay_doc\" ng-change=\"selectNote(pay_doc, 1, 1)\" ng-options=\"item as item.label for item in notascredito track by item.label\" ng-disabled=\"(receipt.status == 2 || receipt.status == 1) && flag\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona la nota de crédito</option></select></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"!receipt.curr_rate && status == 1\"><label>Moneda</label><h3 ng-if=\"insurance.f_currency ==1\">Peso</h3><h3 ng-if=\"insurance.f_currency ==2\">Dólar</h3><h3 ng-if=\"insurance.f_currency ==3\">UDI</h3><h3 ng-if=\"insurance.f_currency ==4\">Euro</h3><h3 ng-if=\"insurance.f_currency ==5\">Dólar Canadiense</h3><h3 ng-if=\"insurance.f_currency ==6\">Libra Esterlina</h3><h3 ng-if=\"insurance.f_currency ==7\">Yen</h3></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"(!receipt.curr_rate && (status == 1 || status == 5 || (status == 6 || status.value == 6)))\"><label>Tipo de cambio</label><input class=\"form-control\" name=\"rate_exchange\" ng-model=\"dataToSave.rate_exchange\" ng-change=\"changeRate(dataToSave.rate_exchange);calcualrCC(dataToSave.rate_exchange,3)\" ng-disabled=\"(insurance.f_currency ==1 || insurance.f_currency ==\'Pesos\') || (insurance.policy.f_currency ==1 || insurance.policy.f_currency ==\'Pesos\')\" type=\"number\"></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"!receipt.liquidacion_curr_rate && status == 5\"><label>Moneda Liquidación</label><select class=\"form-control\" ng-model=\"rate\" ng-change=\"changedRate(rate, 2)\" ng-options=\"rate as rate.label for rate in curr_rate_options track by rate.value\" ng-disabled=\"status.value == 6\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona un tipo de cambio</option></select></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"!display_notes && !receipt.pay_doc && status == 1\"><label>Documento de Pago</label> <input class=\"form-control\" name=\"pay_doc\" ng-model=\"pay_doc\" ng-change=\"selectNote(pay_doc, 2, 1)\" type=\"text\"></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"pago.value != 7 && !receipt.liquidacion_doc && status == 5\"><label>Documento de Liquidación</label> <input class=\"form-control\" name=\"liquidacion_doc\" ng-model=\"liquidacion_doc\" ng-change=\"selectNote(liquidacion_doc, 2, 2)\" type=\"text\"></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"!receipt.bank && status == 1\"><label>Banco</label><div ng-if=\"showFolio\"><autocomplete datasource=\"banks_data\" id=\"banks\" name=\"banco\" model=\"banco\" change=\"matchesBanks(banco, 1)\"></autocomplete></div><input class=\"form-control\" type=\"text\" ng-if=\"!showFolio\" ng-model=\"bancos\" disabled=\"\"></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"!receipt.liquidacion_bank && status == 5\"><label>Banco Liquidación</label><div ng-if=\"showFolio\"><autocomplete datasource=\"banks_data\" id=\"banks\" name=\"banco\" model=\"banco\" change=\"matchesBanks(banco, 2)\"></autocomplete></div><input class=\"form-control\" type=\"text\" ng-if=\"!showFolio\" ng-model=\"bancos\" disabled=\"\"></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"!receipt.pay_date && status == 1\"><label>Fecha de Pago</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"payDate\" class=\"width-100 text-align-center form-control\" ng-model=\"payDate\" value=\"{{payDate}}\" ng-change=\"vm.options.payDate(); changedDate(payDate)\" data-date-format=\"mm/dd/yyyy\" ng-disabled=\"status == 6\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"!receipt.liquidacion_date && status == 5\"><label>Fecha de Liquidación</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"payDate\" class=\"width-100 text-align-center form-control\" ng-model=\"payDate\" value=\"{{payDate}}\" ng-change=\"vm.options.payDate(); changedDate(payDate)\" data-date-format=\"mm/dd/yyyy\" ng-disabled=\"status == 6\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div ng-if=\"status == 6 || status.value==6\"><div class=\"row col-xs-12\" ng-if=\"boton_liquidado\"><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>% de Comisión Estimada:</label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"vm.form.comision_conciliada_p_estimada\" ng-disabled=\"vm.form.comision_conciliada_p_estimada || insurance.f_currency==1\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>% de Comisión Conciliada:</label> <input class=\"form-control\" type=\"text\" name=\"\" ng-class=\"{\'red\': vm.form.comision_conciliada_p === \'⬆️ SUPERIOR\' || vm.form.comision_conciliada_p === \'⬇️ INFERIOR\',\'green\': vm.form.comision_conciliada_p === \'✔ CORRECTA\',\'input-red\': isComisionConciliadaPExceeded}\" ng-model=\"vm.form.comision_conciliada_p\" ng-disabled=\"vm.form.comision_conciliada_p || insurance.f_currency==1\"> <span class=\"input-red\" ng-if=\"isComisionConciliadaPExceeded\">Porcentaje de Comisión excedida</span></div><br><br><div class=\"col-xs-12 form-group\" ng-if=\"nota\"><div class=\"alert alert-warning alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>{{nota}}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Comisión a conciliar:</label> <span ng-if=\"change_to_conciliate==false\">{{vm.form.comision_conciliada}}</span> <input ng-if=\"change_to_conciliate\" class=\"form-control\" type=\"text\" name=\"\" ng-model=\"vm.form.comision_conciliada\" ng-change=\"validarDecimales(vm.form.comision_conciliada,2);calcualrCC(vm.form.comision_conciliada,2)\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Fecha de aplicación:</label> <span ng-if=\"change_to_conciliate==false\">{{vm.form.comision_conciliada}}</span><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"change_to_conciliate\"><input type=\"text\" name=\"aplication_date\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.conciliate_date\" value=\"{{vm.form.conciliate_date}}\" ng-change=\"vm.options.change_conciliate_date()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\"><label for=\"group\">Cuenta:<span class=\"color-red\">*</span></label> <span ng-if=\"change_to_conciliate==false\">{{vm.cuenta.account}}</span><div class=\"input-group\" ng-if=\"change_to_conciliate\"><div ng-class=\"{ \'has-error\': form.ramo.$invalid && !form.ramo.$pristine }\"><select class=\"form-control m-b\" name=\"ramo\" ng-model=\"vm.cuenta\" ng-options=\"cuenta as (cuenta.name + \' - \' + cuenta.bank +\' - \' + cuenta.account) for cuenta in acounts_data track by cuenta.url\" ng-change=\"vm.change_account(vm.cuenta)\" required=\"\"><option value=\"\" disabled=\"\">Seleccione una cuenta</option></select></div><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"add_account()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 btn-mt\"><button class=\"btn btn-success pull-right\" type=\"button\" ng-if=\"receipt.status == 6 && vm.user.permiso.editar\" ng-click=\"AjustarConciliacion(receipt)\">Ajustar Conciliación</button> <button class=\"btn btn-success pull-right\" type=\"button\" ng-if=\"boton_liquidado && change_to_conciliate\" ng-click=\"vm.conciliarRecibo(receipt)\">Conciliar</button></div></div><br><div ng-if=\"add_cuenta\"><legend class=\"legend-title\" align=\"center\">Agregar cuenta nueva</legend><div class=\"col-xs-12\"><div class=\"col-xs-12 form-group\"><label>Nombre:<span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.name\" type=\"text\" required=\"\"></div><div class=\"col-xs-12 form-group\"><label>Cuenta<span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.account\" type=\"text\" required=\"\"></div><div class=\"col-xs-12 form-group\"><label>Banco<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"bank.id as bank.alias for bank in bancos | orderBy: \'alias\' track by bank.url\" ng-model=\"vm.banco_selected\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione un banco</option></select></div><div class=\"col-xs-12 form-group\"><label>Observación:<span class=\"color-red\">*</span></label> <textarea class=\"form-control\" name=\"observation\" ng-model=\"vm.observation\" type=\"text\" required=\"\"></textarea></div><div class=\"col-xs-12 form-group\"><button class=\"col-xs-12 col-sm-3 btn btn-primary pull-right\" ng-disabled=\"\" ng-click=\"saveAccount()\" type=\"button\">Agregar</button> <button class=\"col-xs-12 col-sm-3 btn btn-white pull-right margin-right-10\" ng-click=\"cancel_add_cuenta()\" type=\"button\">Cancelar</button></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"status == 1\"><span><input ng-model=\"vm.inputx\" ng-click=\"showInputX()\" type=\"checkbox\"> Registrar excedente</span></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"display_input\"><label>Cantidad excedente<span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.excedente\" type=\"text\" required=\"\"></div><div class=\"col-xs-12\"><br><label>Observaciones</label> <textarea class=\"form-control\" name=\"poliza\" ng-model=\"description\" ng-disabled=\"status.value == 6 || status == 6\" type=\"text\"></textarea></div><div class=\"col-xs-12 form-group\"><h3 ng-if=\"vm.pagos && vm.pagos.length > 0\">Pagos parciales</h3></div><table class=\"table table-bordered table hidden-xs hidden-sm\" ng-if=\"vm.pagos && vm.pagos.length > 0\"><thead><tr><th>Fecha</th><th>Pagos</th><th>Forma de pago</th><th>Documento de pago</th></tr></thead><tbody><tr ng-repeat=\"pago in vm.pagos track by $index\"><td>{{pago.fecha_de_pago | date:\'medium\'}}</td><td>{{pago.pago | currency}}</td><td>{{pago.forma_pago_display}}</td><td>{{pago.documento_pago}}</td></tr><tr><td></td><td></td><td><b>Total:</b> {{vm.pagos_parciales_total | currency}}</td><td><b>Restante:</b> {{vm.pagos_parciales_restante | currency}}</td></tr></tbody></table><div class=\"col-xs-12\"><div ng-if=\"vm.permiso_administrar_adjuntos || permiso_administrar_adjuntos\"><div upload-template=\"\"></div></div><div style=\"width:400px;\" ng-include=\"\'templates/show-files.html\'\"></div><div ng-if=\"vm.permiso_administrar_adjuntos || permiso_administrar_adjuntos\" class=\"text-align-center\"><button class=\"btn btn-primary\" type=\"button\" name=\"savefiles\" ng-click=\"saveFiles(receipt.id,banco,payDate)\">Guardar archivos</button></div></div><hr><div class=\"col-xs-12 m-t\"><button type=\"button\" class=\"btn btn-success pull-right ladda-button\" ng-click=\"changeReceiptStatus(banco,payDate)\" ng-disabled=\"!status\" ng-if=\"!activeConciliar\">Guardar cambios</button></div></div></div><div class=\"tab-pane\" ng-if=\"pagado == true\"><br><div class=\"row\"><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Estatus:</span><p ng-if=\"receipt.status == 1\">PAGADO</p><p ng-if=\"receipt.status == 2\">CANCELADO</p><p ng-if=\"receipt.status == 3\">PRORROGADO</p><p ng-if=\"receipt.status == 4\">PENDIENTE DE PAGO</p><p ng-if=\"receipt.status == 5\">LIQUIDADO</p><p ng-if=\"receipt.status == 6\">CONCILIADO</p><p ng-if=\"receipt.status == 7\">CERRADO</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Tipo de Recibo:</span><p ng-if=\"receipt.receipt_type == 1\">Recibo de póliza</p><p ng-if=\"receipt.receipt_type == 2\">Recibo de endoso</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Serie:</span><p>{{receipt.recibo_numero}} {{receipt.folio}}</p></div><div class=\"col-xs-12 col-md-3\"><span ng-if=\"_insurance.document_type != 7 && _insurance.document_type != 8\" class=\"color-blue\">Número de Póliza:</span> <span ng-if=\"_insurance.document_type == 7 || _insurance.document_type == 8\" class=\"color-blue\">Número de Fianza:</span><p ng-if=\"receipt.poliza\">{{receipt.poliza}}</p><p ng-if=\"!receipt.poliza\">{{receipt.poliza_aux}}</p></div></div><div class=\"row\" align=\"center\" ng-if=\"receipt.status == 4\"><br><br><br><span>El recibo no está pagado</span></div><div class=\"row\" ng-if=\"receipt.status != 4\"><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Fecha de Pago:</span><p ng-if=\"receipt.pay_date\">{{receipt.pay_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</p><p ng-if=\"!receipt.pay_date\">Sin fecha de pago</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Forma de Pago:</span><p ng-if=\"receipt.pay_form == 1\">CHEQUE</p><p ng-if=\"receipt.pay_form == 2\">EFECTIVO</p><p ng-if=\"receipt.pay_form == 3\">TRANSFERENCIA</p><p ng-if=\"receipt.pay_form == 4\">DEPOSITO BANCARIO</p><p ng-if=\"receipt.pay_form == 5\">TARJETA DE CRÉDITO</p><p ng-if=\"receipt.pay_form == 6\">TARJETA DE DEBITO</p><p ng-if=\"receipt.pay_form == 7\">ESTADO DE CUENTA</p><p ng-if=\"receipt.pay_form == 8\">COMPAÑIA</p><p ng-if=\"receipt.pay_form == 9\">CAT/DOMICILIADO</p><p ng-if=\"receipt.pay_form == 10\">NOTA DE CRÉDITO</p><p ng-if=\"receipt.pay_form == null\">Sin forma de pago</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Moneda:</span><p ng-if=\"insurance.f_currency == 1\">PESO</p><p ng-if=\"insurance.f_currency == 2\">DOLAR</p><p ng-if=\"insurance.f_currency == 3\">UDI</p><p ng-if=\"insurance.f_currency == 4\">EURO</p><p ng-if=\"insurance.f_currency == 5\">DOLAR CANADIENSE</p><p ng-if=\"insurance.f_currency == 6\">LIBRA ESTERLINA</p><p ng-if=\"insurance.f_currency == 7\">YEN</p><p ng-if=\"insurance.f_currency == null\">Sin tipo de cambio</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Tipo de cambio:</span><p ng-if=\"receipt.rate_exchange\">{{receipt.rate_exchange}}</p><p ng-if=\"!receipt.rate_exchange\">Sin tipo de cambio</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Documento de Pago:</span><p ng-if=\"receipt.pay_doc\">{{receipt.pay_doc}}</p><p ng-if=\"!receipt.pay_doc\">Sin documento de pago</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Banco:</span><p ng-if=\"receipt.bank\">{{banco.label}}</p><p ng-if=\"!receipt.bank\">Sin banco</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.excedente > 0\"><span class=\"color-blue\">Pagado con excedente:</span><p>{{receipt.excedente | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\"><strong>Pagado por:</strong></span><p>{{user_pay2.first_name}} {{user_pay2.last_name}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\"><strong>Creado por:</strong></span><p>{{insurance.owner}}</p></div></div></div><div class=\"tab-pane\" ng-if=\"liquidado == true\"><br><div class=\"row\"><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Estatus:</span><p ng-if=\"receipt.status == 1\">PAGADO</p><p ng-if=\"receipt.status == 2\">CANCELADO</p><p ng-if=\"receipt.status == 3\">PRORROGADO</p><p ng-if=\"receipt.status == 4\">PENDIENTE DE PAGO</p><p ng-if=\"receipt.status == 5\">LIQUIDADO</p><p ng-if=\"receipt.status == 6\">CONCILIADO</p><p ng-if=\"receipt.status == 7\">CERRADO</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Tipo de Recibo:</span><p ng-if=\"receipt.receipt_type == 1\">Recibo de póliza</p><p ng-if=\"receipt.receipt_type == 2\">Recibo de endoso</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Serie:</span><p>{{receipt.recibo_numero}}</p></div><div class=\"col-xs-12 col-md-3\"><span ng-if=\"_insurance.document_type != 7 && _insurance.document_type != 8\" class=\"color-blue\">Número de Póliza:</span> <span ng-if=\"_insurance.document_type == 7 || _insurance.document_type == 8\" class=\"color-blue\">Número de Fianza:</span><p ng-if=\"receipt.poliza\">{{receipt.poliza}}</p><p ng-if=\"!receipt.poliza\">{{receipt.poliza_aux}}</p></div></div><div class=\"row\" align=\"center\" ng-if=\"receipt.status == 4 || !receipt.liquidacion_date\"><br><br><br><span>El recibo no está liquidado</span></div><div class=\"row\" ng-if=\"receipt.status == 5 || receipt.status == 6\"><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Folio de Liquidación:</span><p>{{receipt.liquidacion_folio}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Fecha de Liquidación:</span><p ng-if=\"receipt.liquidacion_date\">{{receipt.liquidacion_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</p><p ng-if=\"!receipt.liquidacion_date\">Sin fecha de liquidacion</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Forma de Liquidación:</span><p ng-if=\"receipt.liquidacion_form == 1\">CHEQUE</p><p ng-if=\"receipt.liquidacion_form == 2\">EFECTIVO</p><p ng-if=\"receipt.liquidacion_form == 3\">TRANSFERENCIA</p><p ng-if=\"receipt.liquidacion_form == 4\">DEPOSITO BANCARIO</p><p ng-if=\"receipt.liquidacion_form == 5\">TARJETA DE CRÉDITO</p><p ng-if=\"receipt.liquidacion_form == 6\">TARJETA DE DEBITO</p><p ng-if=\"receipt.liquidacion_form == 10\">NOTA DE CRÉDITO</p><p ng-if=\"receipt.liquidacion_form == 7\">ESTADO DE CUENTA</p><p ng-if=\"receipt.liquidacion_form == 9\">COMPAÑIA</p><p ng-if=\"receipt.liquidacion_form == null\">Sin forma de liquidación</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.banco_o_forma_de_liquidacion\"><span class=\"color-blue\">Forma de Liquidación (descripción del usuario):</span><p>{{receipt.banco_o_forma_de_liquidacion}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Tipo de Cambio:</span><p ng-if=\"receipt.rate_exchange\">{{receipt.rate_exchange}}</p><p ng-if=\"!receipt.rate_exchange\">Sin tipo de cambio</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Documento de Liquidación:</span><p ng-if=\"receipt.liquidacion_doc\">{{receipt.liquidacion_doc}}</p><p ng-if=\"!receipt.liquidacion_doc\">Sin documento de liquidación</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Banco:</span><p ng-if=\"receipt.liquidacion_bank\">{{banco_liquidacion.label}}</p><p ng-if=\"!receipt.liquidacion_bank\">Sin banco</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\"><strong>Creado por:</strong></span><p>{{insurance.owner}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\"><strong>Liquidado por:</strong></span><p>{{user_liq.first_name}} {{user_liq.last_name}}</p></div></div></div><div class=\"tab-pane\" ng-if=\"conciliado == true\"><br><div class=\"row\"><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Estatus:</span><p ng-if=\"receipt.status == 1\">PAGADO</p><p ng-if=\"receipt.status == 2\">CANCELADO</p><p ng-if=\"receipt.status == 3\">PRORROGADO</p><p ng-if=\"receipt.status == 4\">PENDIENTE DE PAGO</p><p ng-if=\"receipt.status == 5\">LIQUIDADO</p><p ng-if=\"receipt.status == 6\">CONCILIADO</p><p ng-if=\"receipt.status == 7\">CERRADO</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Tipo de Recibo:</span><p ng-if=\"receipt.receipt_type == 1\">Recibo de póliza</p><p ng-if=\"receipt.receipt_type == 2\">Recibo de endoso</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Serie:</span><p>{{receipt.recibo_numero}}</p></div><div class=\"col-xs-12 col-md-3\"><span ng-if=\"_insurance.document_type != 7 && _insurance.document_type != 8\" class=\"color-blue\">Número de Póliza:</span> <span ng-if=\"_insurance.document_type == 7 || _insurance.document_type == 8\" class=\"color-blue\">Número de Fianza:</span><p ng-if=\"receipt.poliza\">{{receipt.poliza}}</p><p ng-if=\"!receipt.poliza\">{{receipt.poliza_aux}}</p></div></div><div class=\"row\" align=\"center\" ng-if=\"receipt.status != 6 && receipt.status != 7\"><br><br><br><span>El recibo no está conciliado</span></div><div class=\"row\" ng-if=\"receipt.status == 6 || (receipt.status ==7 && receipt.conciliacion_date)\"><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Fecha de Conciliación:</span><p ng-if=\"receipt.conciliacion_date\">{{receipt.conciliacion_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</p><p ng-if=\"!receipt.conciliacion_date\">Sin fecha de conciliación</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Comisión conciliada:</span><p>{{receipt.comision_conciliada | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">% Comisión Estimada:</span><p>{{receipt.comision_conciliada_p_estimada}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">% Comisión conciliada:</span><p>{{receipt.comision_conciliada_p}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Cuenta de conciliación:</span><p ng-if=\"receipt.conciliation_account\">{{receipt.conciliation_account}}</p><p ng-if=\"!receipt.conciliation_account\">Sin cuenta de conciliación</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Folio de conciliación:</span><p ng-if=\"receipt.conciliacion_folio\">{{receipt.conciliacion_folio}}</p><p ng-if=\"!receipt.conciliacion_folio\">Sin folio de conciliación</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\"><strong>Creado por:</strong></span><p>{{insurance.owner}}</p></div><div class=\"col-xs-12 col-md-3\"></div></div></div><div class=\"tab-pane\" ng-if=\"cerrado==true\"><br><div class=\"row\"><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Estatus:</span><p ng-if=\"receipt.status == 1\">PAGADO</p><p ng-if=\"receipt.status == 2\">CANCELADO</p><p ng-if=\"receipt.status == 3\">PRORROGADO</p><p ng-if=\"receipt.status == 4\">PENDIENTE DE PAGO</p><p ng-if=\"receipt.status == 5\">LIQUIDADO</p><p ng-if=\"receipt.status == 6\">CONCILIADO</p><p ng-if=\"receipt.status == 7\">CERRADO</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Tipo de Recibo:</span><p ng-if=\"receipt.receipt_type == 1\">Recibo de póliza</p><p ng-if=\"receipt.receipt_type == 2\">Recibo de endoso</p><p ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Serie:</span><p>{{receipt.recibo_numero}}</p></div><div class=\"col-xs-12 col-md-3\"><span ng-if=\"_insurance.document_type != 7 && _insurance.document_type != 8\" class=\"color-blue\">Número de Póliza:</span> <span ng-if=\"_insurance.document_type == 7 || _insurance.document_type == 8\" class=\"color-blue\">Número de Fianza:</span><p ng-if=\"receipt.poliza\">{{receipt.poliza}}</p><p ng-if=\"!receipt.poliza\">{{receipt.poliza_aux}}</p></div><div class=\"col-xs-12\"><div class=\"panel panel-default\" ng-if=\"receipt.accountstate_folios && receipt.accountstate_folios.length\"><div class=\"panel-heading\" style=\"background:#f7f9fc;border-color:#e6eef5;\"><strong><i class=\"fa fa-hashtag\"></i> Folio(s) de Estado(s) de Cuenta Asociado(s)</strong> <span class=\"badge pull-right\">{{receipt.accountstate_folios.length}}</span></div><div class=\"panel-body\" style=\"padding-top:10px;\"><ul class=\"list-inline\" style=\"margin:0;white-space:normal;\"><li ng-repeat=\"f in receipt.accountstate_folios track by $index\" style=\"margin:4px 6px;\"><span class=\"label label-primary\" style=\"display:inline-block;padding:6px 10px;font-size:12px;border-radius:16px;\">{{ f }}</span></li></ul></div></div><div class=\"text-muted\" ng-if=\"!receipt.accountstate_folios || !receipt.accountstate_folios.length\" style=\"padding:8px 0;\">— No hay folios —</div></div></div><div class=\"row\" align=\"center\" ng-if=\"receipt.status == 7\"><br><b>El recibo está CERRADO</b></div></div><div class=\"tab-pane\" ng-if=\"mensajeria == true\"><br><form class=\"row\" name=\"form\"><div class=\"form-group col-xs-12 col-sm-6\"><label>Mensajero <span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"new_task.delivery_selected\" ng-options=\"delivery_mans.first_name + \' \' + delivery_mans.last_name for delivery_mans in delivery_mans track by delivery_mans.url\"><option value=\"\" disabled=\"\">Seleccione un mensajero</option></select></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Acción <span class=\"red-color\">*</span></label> <input type=\"text\" name=\"action\" class=\"form-control\" ng-model=\"new_task.action\" required=\"\"></div><div class=\"form-group col-xs-12\"><legend class=\"legend-title\" align=\"center\">Dirección desde<span class=\"color-red\">*</span></legend><div class=\"col-xs-12 col-sm-4 col-md-3\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"end_type\" ng-click=\"contratante_opt = true; manual_opt = false;\" value=\"1\" required=\"\"> Contratante</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-3\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"end_type\" ng-click=\"eraseInput()\" value=\"2\" required=\"\"> Manual</label></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contacto</label> <input class=\"form-control\" type=\"text\" ng-model=\"new_task.contact\"></div><br><br><div class=\"col-xs-12 col-sm-4 col-md-6\" ng-if=\"contratante_opt\"><label>Dirección del contratante <span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in address_options\" ng-change=\"\" name=\"address\" ng-model=\"new_task.address\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 col-sm-4 col-md-6\" ng-if=\"!vm.address.length && manual_opt\"><label>Dirección manual <span class=\"red-color\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"new_task.address\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Fecha <span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_task.fecha\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Hora</label> <input type=\"text\" name=\"time\" class=\"form-control\" ng-model=\"new_task.time\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" name=\"observations\" ng-model=\"new_task.observations\">\n                          </textarea></div><div class=\"col-xs-12 m-t\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"form.$invalid\" ng-click=\"saveTask()\">Asignar Tarea</button></div></form></div><div class=\"tab-pane\" ng-if=\"log == true\"><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"></div><div ng-if=\"!show\" class=\"col-xs-12\"><table class=\"table table-bordered table-hover\"><thead><th>Fecha</th><th>Acción</th><th>Opciones</th></thead><tbody><tr ng-repeat=\"log in logs track by $index\"><td>{{log.date | date: \'dd/MM/yyyy hh:mm:ss a\'}}</td><td>{{log.msj}}</td><td><button ng-if=\"log.email_log\" ng-click=\"show_mail(log.id)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\" title=\"Ver Detalles\"></i></button></td></tr></tbody></table></div><div ng-if=\"show\" class=\"panel-body\"><div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-8 form-group\"><label>Enviado a:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"to\" ng-model=\"mail.to\" disabled=\"\"></div></div><div class=\"col-xs-4 form-group\"><label>Fecha:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"to\" ng-model=\"mail.created_at\" disabled=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Copia a:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"cc\" ng-model=\"mail.cc\" disabled=\"\"></div></div></div><table ng-if=\"mail.files && mail.files.length\" class=\"table table-bordered\"><br><h3><span><i>Archivos compartidos</i></span></h3><thead><tr><th>Archivo</th></tr></thead><tbody><tr ng-repeat=\"file in mail.files track by $index\"><td><strong ng-bind=\"file.name\"></strong> <a class=\"btn btn-primary pull-right\" href=\"{{file.url}}\" target=\"_blank\">Ver</a></td></tr></tbody></table><br><div><label>Asunto:</label><div class=\"col-xs-12 input-group\"><textarea class=\"form-control\" type=\"text\" name=\"subject\" ng-model=\"mail.subject\" disabled=\"\"></textarea></div></div><br><div><label>Contenido</label><div class=\"form-group col-xs-12\" ng-bind-html=\"mail.body\"></div></div><div><button class=\"btn btn-danger pull-right ladda-button\" ng-click=\"hide_mail()\">Cerrar</button></div></div></div></div></div></div></div><div class=\"tab-pane\" ng-if=\"recordatorios == true\"><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in receipt.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></form></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div>");
$templateCache.put("app/cobranzas/cobranzas.modal.pago.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">{{vmm.accion}} Recibos</h4></div><div class=\"modal-body\"><div class=\"row\" ng-if=\"vmm.accion == \'Pagar\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Fecha de Pago:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vmm.pago_date\" value=\"{{vm.pago_date}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Forma de Pago:</label><select class=\"form-control\" ng-model=\"vmm.pay_form\" ng-change=\"changedPago(pago, 1)\" ng-options=\"pago as pago.label for pago in statusPayform track by pago.value\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona una forma de pago</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Tipo de Cambio:</label> <input class=\"form-control\" ng-model=\"vmm.rate_exchange\" type=\"text\" name=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Documento de Pago:</label> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.pay_doc\" name=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Banco:</label><autocomplete datasource=\"banks_data\" id=\"banks\" name=\"banco\" model=\"banco\" change=\"matchesBanks(banco, 1)\"></autocomplete></div></div><div class=\"row\" ng-if=\"vmm.accion == \'Liquidar\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Fecha de Liquidación:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vmm.pago_date\" value=\"{{vm.pago_date}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Forma de Liquidación:</label><select class=\"form-control\" ng-model=\"vmm.pay_form\" ng-change=\"changedPago(pago, 1)\" ng-options=\"pago as pago.label for pago in statusPayform track by pago.value\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona una forma de pago</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Moneda Liquidación:</label><select class=\"form-control\" ng-model=\"vmm.rate\" ng-change=\"changedRate(rate, 1)\" ng-options=\"rate as rate.label for rate in curr_rate_options track by rate.value\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona una moneda</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Documento de Liquidación:</label> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.pay_doc\" name=\"\"></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button class=\"btn btn-success\" ng-if=\"recibos_a_pagar.length > 0\" ng-click=\"save()\">Guardar</button> <button class=\"btn btn-success\" ng-if=\"recibos_a_liquidar.length > 0\" ng-click=\"saveLiquidados()\">Guardar</button></div></div>");
$templateCache.put("app/cobranzas/cobranzas.plantillas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Cobranza</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Plantillas de Cobranza</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createQuotation()\">Agregar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"col-xs-12 btn btn-secondary m-t\" ng-click=\"cambiarCampos()\">Campos en el Correo</button></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"showQuotation\" style=\"margin-left: 25px;padding-right: 75px;\"><legend ng-if=\"!showEditInformation\" class=\"legend-title\" align=\"center\">Nueva Plantilla</legend><legend ng-if=\"showEditInformation\" class=\"legend-title\" align=\"center\">Actualizar Plantilla</legend><form class=\"row\" name=\"form\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre de la Plantilla <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"plantilla.name\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Asunto <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"plantilla.title\"></div><button type=\"button\" class=\"btn btn-default ng-scope pull-right\" unselectable=\"on\" tabindex=\"-1\" ng-click=\"getFile()\" ng-disabled=\"!editor_focus\"><i class=\"fa fa-upload\"></i></button><div class=\"col-xs-12 form-group\"><label>Texto Superior <span class=\"color-red\">*</span></label><div text-angular=\"\" ng-model=\"plantilla.text\" name=\"myEditorCreate\" ng-focus=\"focusEditor()\" ng-blur=\"unfocusEditor()\"></div></div><div class=\"col-xs-12 form-group\"><label>Texto Inferior <span class=\"color-red\">*</span></label><div text-angular=\"\" ng-model=\"plantilla.bottom_text\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button ng-if=\"!showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"saveDelivery(plantilla)\">Crear Plantilla</button> <button ng-if=\"showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"updateDelivery(plantilla)\">Actualizar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeQuotation()\">Cancelar</button></div></form></div></div></div><div class=\"ibox\" ng-if=\"configurar\"><div class=\"ibox-title-c bg-light-gray clearfix\"><h3 class=\"section-title\" style=\"text-align: center;\">Configuración de Visualización en Correo</h3><span class=\"pull-right\" ng-click=\"cambiarCampos()\" style=\"cursor: pointer; color: #888;\" title=\"Cerrar sección\"><i class=\"fa fa-times fa-lg\"></i></span></div><div class=\"ibox-content-c row\"><form class=\"form-inline\"><div class=\"row\"><div class=\"col-sm-3 value-email\"><div class=\"checkbox checkbox-inline-c\"><label><input id=\"fecha_limite_email_cobranza\" type=\"checkbox\" ng-model=\"configuracionGlobal.fecha_limite_email_cobranza\" ng-change=\"changeFechaLimiteEmail(configuracionGlobal.fecha_limite_email_cobranza)\"> Fecha límite de pago</label></div></div><div class=\"col-sm-3 value-email\"><div class=\"checkbox checkbox-inline-c\"><label><input id=\"boton_segumovil\" type=\"checkbox\" ng-model=\"configuracionGlobal.boton_segumovil\" ng-change=\"changeButtonSegumovilEmail(configuracionGlobal.boton_segumovil)\"> Botón Segumóvil</label></div></div><div class=\"col-sm-3 value-email\" ng-repeat=\"campo in [ { id: \'dato_contratante\', label: \'Contratante\', key: \'contratante\' }, { id: \'dato_numero_poliza\', label: \'Número de póliza\', key: \'no_poliza\' }, { id: \'dato_concepto\', label: \'Concepto\', key: \'concepto\' }, { id: \'dato_aseguradora\', label: \'Aseguradora\', key: \'aseguradora\' }, { id: \'dato_subramo\', label: \'Subramo\', key: \'subramo\' }, { id: \'dato_serie\', label: \'Serie\', key: \'serie\' }, { id: \'dato_total\', label: \'Total\', key: \'total\' }, { id: \'copia_user_envio\', label: \'Copiar al remitente en envíos manuales de cobranza\', key: \'copia_user_envio\' } ]\"><div class=\"checkbox checkbox-inline-c\"><label><input type=\"checkbox\" id=\"{{campo.id}}\" ng-model=\"configuracionGlobal[campo.id]\" ng-change=\"cambiarDato(campo.id, configuracionGlobal[campo.id])\"> {{campo.label}}</label></div></div></div></form></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Plantillas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\" ng-hide=\"showInfoQuotation\"><table class=\"table table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th>ID</th><th>Nombre</th><th>Asunto</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"item in vm.quotations track by $index\" ng-click=\"showInformation(item)\"><td>{{ item.id }}</td><td>{{ item.name }}</td><td>{{ item.title }}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-sm btn-white\" ng-click=\"editQuatation(item)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"show_pagination\" class=\"text-center\"><pagination config=\"vm.config_pagination\" model=\"vm.quotations\"></pagination></div></div><div class=\"animate\" ng-if=\"showInfoQuotation\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showInformation(null)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Name:</span><div><span>{{ quotation.name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Asunto:</span><div><span>{{ quotation.title }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Texto Superior:</span><div><span>{{ quotation.text }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Texto Inferior:</span><div><span>{{ quotation.bottom_text }}</span></div></div></div></div></div></div>");
$templateCache.put("app/cobranzas/cobranzas.plantillassms.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Cobranza</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Plantillas de Cobranza</strong></li></ol></div></div><br><div class=\"row\" style=\"padding:20px\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createQuotation()\">Agregar Plantilla</button></div><div class=\"col-xs-12\" ng-show=\"showPlantilla\"><legend ng-if=\"!showEditInformation\" class=\"legend-title\" align=\"center\">Nueva Plantilla</legend><legend ng-if=\"showEditInformation\" class=\"legend-title\" align=\"center\">Actualizar Plantilla</legend><form class=\"row\" name=\"form\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"plantilla.title\" name=\"plantillaTitle\" required=\"\"></div><div class=\"col-xs-12 form-group\"><label>Mensaje<span class=\"color-red\">*</span></label> <textarea type=\"text\" class=\"form-control\" name=\"mensaje\" ng-model=\"plantilla.text\" required=\"\"></textarea></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button ng-if=\"!showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid || savingPlantilla\" ng-click=\"saveDelivery(plantilla)\">Crear Plantilla</button> <button ng-if=\"showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid || savingPlantilla\" ng-click=\"updateDelivery(plantilla)\">Actualizar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeQuotation()\">Cancelar</button></div></form></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Plantillas SMS</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\" ng-hide=\"showInfoPlantilla\"><table class=\"table table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th>ID</th><th>Identificador</th><th>Mensaje</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"pl in vm.templatesList track by $index\" ng-click=\"showInformation(pl)\"><td>{{ pl.id }}</td><td>{{ pl.title }}</td><td>{{ pl.text }}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-sm btn-white\" ng-click=\"editQuatation(pl)\" title=\"Editar plantilla\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-sm btn-danger m-l-xs\" ng-click=\"borrarPlantilla(pl)\" title=\"Eliminar plantilla\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"showTemplates\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div>");
$templateCache.put("app/cobranzas/cobranzas.plantillaswhatsapp.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Cobranza</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Plantillas de Cobranza</strong></li></ol></div></div><br><div class=\"row\" style=\"padding:20px\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createQuotation()\">Agregar Plantilla</button></div><div class=\"col-xs-12\" ng-show=\"showPlantilla\"><legend ng-if=\"!showEditInformation\" class=\"legend-title\" align=\"center\">Nueva Plantilla</legend><legend ng-if=\"showEditInformation\" class=\"legend-title\" align=\"center\">Actualizar Plantilla</legend><form class=\"row\" name=\"form\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"plantilla.title\" name=\"plantillaTitle\" required=\"\"></div><div class=\"col-xs-12 form-group\"><label>Mensaje<span class=\"color-red\">*</span></label> <textarea type=\"text\" class=\"form-control\" name=\"mensaje\" ng-model=\"plantilla.text\" required=\"\"></textarea></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button ng-if=\"!showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid || savingPlantilla\" ng-click=\"saveDelivery(plantilla)\">Crear Plantilla</button> <button ng-if=\"showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid || savingPlantilla\" ng-click=\"updateDelivery(plantilla)\">Actualizar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeQuotation()\">Cancelar</button></div></form></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Plantillas Whatsapp Web</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\" ng-hide=\"showInfoPlantilla\"><table class=\"table table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th>ID</th><th>Identificador</th><th>Mensaje</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"pl in vm.templatesList track by $index\" ng-click=\"showInformation(pl)\"><td>{{ pl.id }}</td><td>{{ pl.title }}</td><td>{{ pl.text }}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-sm btn-white\" ng-click=\"editQuatation(pl)\" title=\"Editar plantilla\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-sm btn-danger m-l-xs\" ng-click=\"borrarPlantilla(pl)\" title=\"Eliminar plantilla\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"showTemplates\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div>");
$templateCache.put("app/cobranzas/cobranzasmasivo.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Cobranza</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Cobranza</a></li><li class=\"active\"><strong>Pago/Liquidación Masiva</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"col-xs-12\" ng-if=\"vm.acceso_pag_rec\"><legend class=\"legend-title\" align=\"center\">Pago por Carga Masiva MÉTODO TRADICIONAL</legend></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.acceso_pag_rec\"><label>Pago carga masiva:</label><br><label style=\"margin-left: 5px\" class=\"col-xs-4 btn btn-success\">Cargar Layout Pago <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFilePago\" ng-change=\"validateExcelPago(excelFilePago)\" onclick=\"limpiar()\" onchange=\"angular.element(this).scope().fileNameChanged(this)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loadingPago\"><i class=\"fa fa-cog fa-spin fa-5x\"></i></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group pull-right\" ng-if=\"vm.acceso_pag_rec && vm.carga_masivapago && !loadingPago\"><label>Folio de Pago carga masiva:</label><br><div class=\"col-xs-12 input-group\"><input type=\"text\" name=\"folio_pago\" ng-model=\"vm.folio_pago\" class=\"form-control\"><div class=\"input-group-btn\"><button ng-disabled=\"!vm.folio_pago\" type=\"button\" class=\"btn btn-block btn-info\" ng-click=\"validarLayoutCargaMasiva1()\">Validar layout</button></div><div class=\"input-group-btn\"><button ng-disabled=\"!vm.folio_pago\" type=\"button\" class=\"btn btn-block btn-success\" ng-click=\"cargarLayoutCargaMasiva1()\">Cargar layout</button></div></div></div><div class=\"col-xs-12\" ng-if=\"vm.acceso_liq_rec\"><legend class=\"legend-title\" align=\"center\">Liquidación por Carga Masiva MÉTODO TRADICIONAL</legend></div><div class=\"col-xs-12 row\" ng-if=\"vm.acceso_liq_rec\"><div class=\"col-xs-12 form-group\"><label>Liquidación carga masiva:</label><br><label style=\"margin-left: 5px\" class=\"col-xs-4 btn btn-success\">Cargar Layout Liquidación <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\" onchange=\"angular.element(this).scope().fileNameChanged(this)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loading\"><i class=\"fa fa-cog fa-spin fa-5x\"></i></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group pull-right\" ng-if=\"vm.carga_masiva && !loading\"><label>Folio de Liquidación carga masiva:</label><br><div class=\"col-xs-12 input-group\"><input type=\"text\" name=\"folio_liquidacion\" ng-model=\"vm.folio_liquidacion\" class=\"form-control\"><div class=\"input-group-btn\"><button ng-disabled=\"!vm.folio_liquidacion\" type=\"button\" class=\"btn btn-block btn-info\" ng-click=\"validarLayoutCargaMasiva()\">Validar layout</button></div><div class=\"input-group-btn\"><button ng-disabled=\"!vm.folio_liquidacion\" type=\"button\" class=\"btn btn-block btn-success\" ng-click=\"cargarLayoutCargaMasiva()\">Cargar layout</button></div></div></div></div><div class=\"col-xs-12\" ng-if=\"vm.acceso_pag_rec\"><legend class=\"legend-title\" align=\"center\">Pago por Carga Masiva (MEDIANTE ID)</legend></div><div class=\"col-xs-12 row\" ng-if=\"vm.acceso_pag_rec\"><div class=\"col-xs-12 form-group\"><label>Pago carga masiva:</label><br><label style=\"margin-left: 5px\" class=\"col-xs-4 btn btn-success\">Cargar Layout Pago <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcelIdPago(excelFile)\" onclick=\"limpiar()\" onchange=\"angular.element(this).scope().fileNameChanged(this)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loadingPagoId\"><i class=\"fa fa-cog fa-spin fa-5x\"></i></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group pull-right\" ng-if=\"vm.carga_masiva_pago_id && !loadingPagoId\"><label>Folio de Pago carga masiva:</label><br><div class=\"col-xs-12 input-group\"><input type=\"text\" name=\"folio_liquidacion\" ng-model=\"vm.folio_liquidacion\" class=\"form-control\"><div class=\"input-group-btn\"><button ng-disabled=\"!vm.folio_liquidacion\" type=\"button\" class=\"btn btn-block btn-info\" ng-click=\"validarLayoutCargaMasivaId()\">Validar layout</button></div><div class=\"input-group-btn\"><button ng-disabled=\"!vm.folio_liquidacion\" type=\"button\" class=\"btn btn-block btn-success\" ng-click=\"cargarLayoutCargaMasivaId()\">Cargar layout</button></div></div></div></div><div class=\"col-xs-12\" ng-if=\"vm.acceso_liq_rec\"><legend class=\"legend-title\" align=\"center\">Liquidación por Carga Masiva (MEDIANTE ID)</legend></div><div class=\"col-xs-12 row\" ng-if=\"vm.acceso_liq_rec\"><div class=\"col-xs-12 form-group\"><label>Liquidación carga masiva:</label><br><label style=\"margin-left: 5px\" class=\"col-xs-4 btn btn-success\">Cargar Layout Liquidación <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcelIdLiquidacion(excelFile)\" onclick=\"limpiar()\" onchange=\"angular.element(this).scope().fileNameChanged(this)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loadingLiqId\"><i class=\"fa fa-cog fa-spin fa-5x\"></i></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group pull-right\" ng-if=\"vm.carga_masiva_id && !loadingLiqId\"><label>Folio de Liquidación carga masiva:</label><br><div class=\"col-xs-12 input-group\"><input type=\"text\" name=\"folio_liquidacion\" ng-model=\"vm.folio_liquidacion\" class=\"form-control\"><div class=\"input-group-btn\"><button ng-disabled=\"!vm.folio_liquidacion\" type=\"button\" class=\"btn btn-block btn-info\" ng-click=\"validarLayoutCargaMasiva1Id()\">Validar layout</button></div><div class=\"input-group-btn\"><button ng-disabled=\"!vm.folio_liquidacion\" type=\"button\" class=\"btn btn-block btn-success\" ng-click=\"cargarLayoutCargaMasiva1Id()\">Cargar layout</button></div></div></div></div></div></div></div></div><script type=\"text/javascript\">\n  $(window).load(function() { $(\"#state\").select2(); });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/cobranzas/conciliar_masivo_modal.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Conciliar consulta</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"row\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title\" align=\"center\">Datos de la cuenta</legend><hr><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Comisión a conciliar:</label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"vm.form.comision_conciliada\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Fecha de aplicación:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"aplication_date\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.conciliate_date\" value=\"{{vm.form.conciliate_date}}\" ng-change=\"vm.options.change_conciliate_date()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\"><label for=\"group\">Cuenta:<span class=\"color-red\">*</span></label><div class=\"input-group\"><div ng-class=\"{ \'has-error\': form.ramo.$invalid && !form.ramo.$pristine }\"><select class=\"form-control m-b\" name=\"ramo\" ng-model=\"vm.cuenta\" ng-options=\"cuenta as (cuenta.name + \' - \' + cuenta.bank +\' - \' + cuenta.account) for cuenta in acounts_data track by cuenta.url\" ng-change=\"vm.change_account(vm.cuenta)\" required=\"\"><option value=\"\" disabled=\"\">Seleccione una cuenta</option></select></div><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"add_account()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"row\" ng-if=\"addAccount\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 form-group\"><label>Nombre:<span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"name\" type=\"text\" required=\"\" ng-blur=\"selectData(name,account,observation)\"></div><div class=\"col-xs-12 form-group\"><label>Cuenta<span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"account\" type=\"text\" required=\"\" ng-blur=\"selectData(name,account,observation)\"></div><div class=\"col-xs-12 form-group\"><label>Banco<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"bank.id as bank.alias for bank in bancos | orderBy: \'alias\' track by bank.url\" ng-model=\"banco_selected\" required=\"\" ng-change=\"selectBanco(banco_selected)\"><pre>{{banco_selected | json}}</pre><option value=\"\" disabled=\"\" selected=\"\">Seleccione un banco</option></select></div><div class=\"col-xs-12 form-group\"><label>Observación:<span class=\"color-red\">*</span></label> <textarea class=\"form-control\" name=\"observation\" ng-model=\"observation\" type=\"text\" ng-blur=\"selectData(name,account,observation)\" required=\"\"></textarea></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel_addAccount()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success\" ng-disabled=\"\" ng-click=\"saveAccount()\" type=\"button\">Agregar</button></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"conciliar_consulta(vm.form.comision_conciliada,vm.form.conciliate_date,vm.cuenta,results_rec,filtros_consulta)\">Conciliar consulta</button></div></div>");
$templateCache.put("app/cobranzas/flotilla.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Unidades pendientes de pago de la Colectividad {{number}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Unidades</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row animate\" ng-if=\"!vm.show_binnacle\"><div class=\"col-xs-12\"><div class=\"tabs-container\"><div class=\"\"><table class=\"table table-bordered table-hover\"><thead><th>Inciso</th><th>Estatus</th><th>General</th><th>Serial</th><th>Motor</th><th>Matricula</th><th>Asegurado</th><th>Vigencia</th><th>Costo</th><th>Contacto</th></thead><tbody><tr ng-repeat=\"item in certificates track by $index\" ng-if=\"!item.paid_out\" ng-click=\"show_certificate_data = true; selectCerficate(item)\"><td>{{ item.certificate_number }}</td><td><span ng-if=\"item.certificado_inciso_activo\">Activo</span> <span ng-if=\"!item.certificado_inciso_activo\">Inactivo</span></td><td>{{ item.automobiles_policy[0].brand }} {{item.automobiles_policy[0].model}} {{ item.automobiles_policy[0].year }} {{ item.automobiles_policy[0].version }} {{ item.automobiles_policy[0].color }}</td><td>{{ item.automobiles_policy[0].serial }}</td><td>{{ item.automobiles_policy[0].engine }}</td><td>{{ item.automobiles_policy[0].license_plates }}</td><td>{{ item.automobiles_policy[0].beneficiary_name }}</td><td>{{ item.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ item.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{ item.p_total | currency}}</td><td>{{ item.contacto}}</td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-10\"><button ng-click=\"exportData(1)\" class=\"col-xs-12 btn btn-primary\">Generar Reporte</button></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Salir</button></div></div></div>");
$templateCache.put("app/cobranzas/infoChange.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Cambios del Endoso {{ vm.endoso.number_endorsement }}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"></div><div class=\"\"><legend class=\"text-center\">{{concept(vm.endoso.concept)}}</legend><table class=\"table table-bordered table-hover\" ng-if=\"(!aseguradotype || otros) && !changeC\"><thead><th ng-if=\"!coberturas_baja\">Antes</th><th ng-if=\"!coberturas_baja\">Después</th><th ng-if=\"coberturas_baja\">Cobertura(s) eliminada(s)</th></thead><tbody><tr ng-if=\"cfp\"><td>{{ payform(vm.original.forma_de_pago) }}</td><td>{{ payform(vm.change.forma_de_pago) }}</td></tr><tr ng-if=\"cancelacion\"><td>{{ status(vm.original.status) }}</td><td>{{ status(vm.change.status) }}</td></tr><tr ng-if=\"coberturas == true && !coberturas_baja\"><td><table class=\"table table-hover\"><thead><th>Cobertura</th><th>S.A.</th><th>Deducible</th><th>Coaseguro</th></thead><tbody><tr ng-repeat=\"cob in vm.original\"><td>{{cob.coverage_name}}</td><td>{{formatCoverage(cob.sum_insured) }}</td><td>{{formatCoverage(cob.deductible) }}</td><td>{{formatCoverage(cob.coinsurance) }}</td></tr></tbody></table></td><td><table class=\"table table-hover\"><thead><th>Cobertura</th><th>S.A.</th><th>Deducible</th><th>Coaseguro</th></thead><tbody><tr ng-repeat=\"cob in vm.change\"><td>{{cob.coverage_name}}</td><td>{{ formatCoverage(cob.sum_insured) }}</td><td>{{ formatCoverage(cob.deductible) }}</td><td>{{ formatCoverage(cob.coinsurance) }}</td></tr></tbody></table></td></tr><tr ng-if=\"coberturas && coberturas_baja\"><td colspan=\"2\"><table class=\"table table-hover\"><thead><th>Cobertura</th><th>S.A.</th><th>Deducible</th><th>Coaseguro</th></thead><tbody><tr ng-repeat=\"cob in vm.change\"><td>{{cob.coverage_name}}</td><td>{{ formatCoverage(cob.sum_insured) }}</td><td>{{ formatCoverage(cob.deductible) }}</td><td>{{ formatCoverage(cob.coinsurance) }}</td></tr></tbody></table></td></tr></tbody></table></div><div class=\"panel-body table-over-y\" ng-if=\"changeC\"><table class=\"table table-bordered table-hover\" ng-if=\"vm.endoso.policy.subramo.subramo_code == 1\"><thead><tr><td>Folio</td><td>Certificado</td><td>Correo</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Tipo Suma Asegurada</td><td>Suma Asegurada</td><td>Sueldo</td><td>Fumador</td><td>Beneficiarios</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td></tr></thead><tbody><tr ng-repeat=\"item in vm.change\"><td>{{ item.folio }}</td><td>{{ item.certificate_number }}</td><td>{{ item.life_policy[0].personal.email }}</td><td>{{ item.life_policy[0].personal.first_name }}</td><td>{{ item.life_policy[0].personal.last_name }}</td><td>{{ item.life_policy[0].personal.second_last_name }}</td><td>{{ item.life_policy[0].personal.birthdate | date: \'dd/MM/yyyy\' }}</td><td>{{ item.life_policy[0].personal.sex }}</td><td>{{ item.life_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' }}</td><td>{{ item.life_policy[0].personal.type_sa }}</td><td>{{ item.life_policy[0].personal.sum_assured }}</td><td>{{ item.life_policy[0].personal.salary }}</td><td>{{ item.life_policy[0].smoker }}</td><td><ul ng-repeat=\"relations in item.life_policy[0].beneficiaries_life\"><li>{{ relations.first_name }} {{ relations.last_name }}</li></ul></td><td>{{ item.p_neta }}</td><td>{{ item.rpf }}</td><td>{{ item.derecho }}</td><td>{{ item.iva }}</td><td>{{ item.p_total }}</td><td>{{ item.comision }}</td><td>{{ item.start_of_validity | date: \'dd/MM/yyyy\' }}</td><td>{{ item.end_of_validity | date: \'dd/MM/yyyy\' }}</td><td>{{ item.observations }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"vm.endoso.policy.ramo.ramo_code == 2\"><thead><tr><td>Folio</td><td>Certificado</td><td>Correo</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Dependientes</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td></tr></thead><tbody><tr ng-repeat=\"item in vm.change\"><td>{{ item.folio }}</td><td>{{ item.certificate_number }}</td><td>{{ item.accidents_policy[0].personal.email }}</td><td>{{ item.accidents_policy[0].personal.first_name }}</td><td>{{ item.accidents_policy[0].personal.last_name }}</td><td>{{ item.accidents_policy[0].personal.second_last_name }}</td><td>{{ item.accidents_policy[0].personal.birthdate | date: \'dd/MM/yyyy\' }}</td><td>{{ item.accidents_policy[0].personal.sex }}</td><td>{{ item.accidents_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' }}</td><td><ul ng-repeat=\"relations in item.accidents_policy[0].relationship_accident\"><li>{{ relations.first_name }} {{ relations.last_name }}</li></ul></td><td>{{ item.p_neta }}</td><td>{{ item.rpf }}</td><td>{{ item.derecho }}</td><td>{{ item.iva }}</td><td>{{ item.p_total }}</td><td>{{ item.comision }}</td><td>{{ item.start_of_validity | date: \'dd/MM/yyyy\' }}</td><td>{{ item.end_of_validity | date: \'dd/MM/yyyy\' }}</td><td>{{ item.observations }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"vm.endoso.policy.subramo.subramo_code == 9\"><thead><tr><td>Inciso</td><td>Propietario</td><td>Conductor</td><td>Correo</td><td>No. Empleado</td><td>Marca</td><td>Modelo</td><td>Año</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Uso</td><td>Servicio</td><td>Procedencia</td><td>Valor Asegurado</td><td>Tipo Carga</td><td>Adaptaciones</td><td>Monto Adaptaciones</td><td>Equipamineto</td><td>Monto Equipamineto</td><td>Beneficiario Preferente</td><td>Beneficiario RFC</td><td>Beneficiario Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td></tr></thead><tbody><tr ng-repeat=\"item in vm.change\"><td>{{ item.certificate_number }}</td><td>{{ item.automobiles_policy[0].car_owner }}</td><td>{{ item.automobiles_policy[0].driver }}</td><td>{{ item.automobiles_policy[0].email }}</td><td>{{ item.automobiles_policy[0].no_employee }}</td><td>{{ item.automobiles_policy[0].brand }}</td><td>{{ item.automobiles_policy[0].model }}</td><td>{{ item.automobiles_policy[0].year }}</td><td>{{ item.automobiles_policy[0].version }}</td><td>{{ item.automobiles_policy[0].serial }}</td><td>{{ item.automobiles_policy[0].engine }}</td><td>{{ item.automobiles_policy[0].color }}</td><td>{{ item.automobiles_policy[0].license_plates }}</td><td>{{ item.automobiles_policy[0].usage }}</td><td>{{ item.automobiles_policy[0].service }}</td><td>{{ item.automobiles_policy[0].procedencia }}</td><td>{{ item.automobiles_policy[0].mont_special_team }}</td><td>{{ item.automobiles_policy[0].charge_type }}</td><td>{{ item.automobiles_policy[0].adjustment }}</td><td>{{ item.automobiles_policy[0].mont_adjustment }}</td><td>{{ item.automobiles_policy[0].special_team }}</td><td>{{ item.automobiles_policy[0].mont_special_team }}</td><td>{{ item.automobiles_policy[0].beneficiary_name }}</td><td>{{ item.automobiles_policy[0].beneficiary_rfc }}</td><td>{{ item.automobiles_policy[0].beneficiary_address }}</td><td>{{ item.p_neta }}</td><td>{{ item.rpf }}</td><td>{{ item.derecho }}</td><td>{{ item.iva }}</td><td>{{ item.p_total }}</td><td>{{ item.comision }}</td><td>{{ item.start_of_validity | date: \'dd/MM/yyyy\' }}</td><td>{{ item.end_of_validity | date: \'dd/MM/yyyy\' }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"vm.endoso.policy.subramo.subramo_code == 7\"><thead><tr><td>Inciso</td><td>Sucursal</td><td>Correo</td><td>Giro</td><td>Tipo Constructivo</td><td>No. Niveles</td><td>Zona FHM</td><td>Zona TYEV</td><td>Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td></tr></thead><tbody><tr ng-repeat=\"item in vm.change\"><td>{{ item.certificate_number }}</td><td>{{ item.damages_policy[0].sucursal }}</td><td>{{ item.damages_policy[0].email }}</td><td>{{ item.damages_policy[0].giro }}</td><td>{{ item.damages_policy[0].type_construction }}</td><td>{{ item.damages_policy[0].no_levels }}</td><td>{{ item.damages_policy[0].fhm_zone }}</td><td>{{ item.damages_policy[0].tyev_zone }}</td><td>{{ item.damages_policy[0].item_address }}</td><td>{{ item.p_neta }}</td><td>{{ item.rpf }}</td><td>{{ item.derecho }}</td><td>{{ item.iva }}</td><td>{{ item.p_total }}</td><td>{{ item.comision }}</td><td>{{ item.start_of_validity | date: \'dd/MM/yyyy\' }}</td><td>{{ item.end_of_validity | date: \'dd/MM/yyyy\' }}</td><td>{{ item.damages_policy[0].item_details }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"vm.endoso.policy.subramo.subramo_code == 13\"><thead><tr><td>Inciso</td><td>Propietario</td><td>No. Empleado</td><td>Correo</td><td>Uso</td><td>Marca</td><td>Modelo</td><td>Año Construcción</td><td>Año Reconstrucción</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Permiso</td><td>Valor Compra</td><td>Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td></tr></thead><tbody><tr ng-repeat=\"item in vm.change\"><td>{{ item.certificate_number }}</td><td>{{ item.damages_policy[0].dam_owner }}</td><td>{{ item.damages_policy[0].no_employee }}</td><td>{{ item.damages_policy[0].email }}</td><td>{{ item.damages_policy[0].usage }}</td><td>{{ item.damages_policy[0].brand }}</td><td>{{ item.damages_policy[0].model }}</td><td>{{ item.damages_policy[0].construction_year }}</td><td>{{ item.damages_policy[0].reconstruction_year }}</td><td>{{ item.damages_policy[0].version }}</td><td>{{ item.damages_policy[0].serial }}</td><td>{{ item.damages_policy[0].engine }}</td><td>{{ item.damages_policy[0].color }}</td><td>{{ item.damages_policy[0].matricula }}</td><td>{{ item.damages_policy[0].permiso }}</td><td>{{ item.damages_policy[0].purchase_value }}</td><td>{{ item.damages_policy[0].item_address }}</td><td>{{ item.p_neta }}</td><td>{{ item.rpf }}</td><td>{{ item.derecho }}</td><td>{{ item.iva }}</td><td>{{ item.p_total }}</td><td>{{ item.comision }}</td><td>{{ item.start_of_validity | date: \'dd/MM/yyyy\' }}</td><td>{{ item.end_of_validity | date: \'dd/MM/yyyy\' }}</td><td>{{ item.damages_policy[0].item_details }}</td></tr></tbody></table></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div></div>");
$templateCache.put("app/cobranzas/liquidate_massive_files.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Archivos a folio de Liquidación: {{folio}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"></div><div class=\"ibox-content\"><div class=\"row\"></div><div class=\"col-xs-12\"><div upload-template=\"\"></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"vmFiles.rename(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,files)\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</button> <span class=\"btn btn-success display-none\">Guardar</span></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"subirArchivos(folio)\">Guardar</button></div><script>\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    strongTag.hide();\n    inputTag.show();\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target);\n\n    strongTag.show();\n    inputTag.hide();\n  }\n</script>");
$templateCache.put("app/cobranzas/log.detail.email.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Detalles Correo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"></div><div class=\"panel-body\"><div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-8 form-group\"><label>Enviado a:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"to\" ng-model=\"mail.to\" disabled=\"\"></div></div><div class=\"col-xs-4 form-group\"><label>Fecha:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"to\" ng-model=\"mail.created_at\" disabled=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Copia a:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"cc\" ng-model=\"mail.cc\" disabled=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Copia oculta a:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"cco\" ng-model=\"mail.cco\" disabled=\"\"></div></div></div><table ng-if=\"mail.files && mail.files.length\" class=\"table table-bordered\"><br><h3><span><i>Archivos compartidos</i></span></h3><thead><tr><th>Archivo</th></tr></thead><tbody><tr ng-repeat=\"file in mail.files track by $index\"><td><strong ng-bind=\"file.name\"></strong> <a class=\"btn btn-primary pull-right\" href=\"{{file.url}}\" target=\"_blank\">Ver</a></td></tr></tbody></table><br><div><label>Asunto:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"subject\" ng-model=\"mail.subject\" disabled=\"\"></div></div><br><div><label>Contenido</label><div class=\"form-group col-xs-12\" ng-bind-html=\"mail.body\"></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div></div>");
$templateCache.put("app/cobranzas/log.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Registro de Actividad</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"></div><div ng-if=\"!show\" class=\"\"><table class=\"table table-bordered table-hover\"><thead><th>Fecha</th><th>Acción</th><th>Opciones</th></thead><tbody><tr ng-repeat=\"log in logs track by $index\"><td>{{log.date | date: \'dd/MM/yyyy hh:mm:ss a\'}}</td><td>{{log.msj}}</td><td><button ng-if=\"log.email_log\" ng-click=\"show_mail(log.id)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\" title=\"Ver Detalles\"></i></button><div ng-if=\"!log.change[0].name && log.change && log.change !={} && log.change!=[] && log.change\"><span ng-if=\"log.change.length >0 && log.change !=\'{}\'\">{{log.change}}</span></div></td></tr></tbody></table></div><div ng-if=\"show\" class=\"panel-body\"><div><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-8 form-group\"><label>Enviado a:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"to\" ng-model=\"mail.to\" disabled=\"\"></div></div><div class=\"col-xs-4 form-group\"><label>Fecha:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"to\" ng-model=\"mail.created_at\" disabled=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Copia a:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"cc\" ng-model=\"mail.cc\" disabled=\"\"></div></div></div><table ng-if=\"mail.files && mail.files.length\" class=\"table table-bordered\"><br><h3><span><i>Archivos compartidos</i></span></h3><thead><tr><th>Archivo</th></tr></thead><tbody><tr ng-repeat=\"file in mail.files track by $index\"><td><strong ng-bind=\"file.name\"></strong> <a class=\"btn btn-primary pull-right\" href=\"{{file.url}}\" target=\"_blank\">Ver</a></td></tr></tbody></table><br><div><label>Asunto:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" name=\"subject\" ng-model=\"mail.subject\" disabled=\"\"></div></div><br><div><label>Contenido</label><div class=\"form-group col-xs-12\" ng-bind-html=\"mail.body\"></div></div><div><button class=\"btn btn-danger pull-right ladda-button\" ng-click=\"hide_mail()\">Cerrar</button></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div></div>");
$templateCache.put("app/cobranzas/notaCredito.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Aplicar Nota de Crédito</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><h3>Estatus actual:</h3><div class=\"label\" ng-class=\"{\'label-success\': (receipt.status == 1 || receipt.status.value == 1), \'label-primary\': (receipt.status == 2 || receipt.status.value == 2),\'label-info\': (receipt.status == 3 || receipt.status.value == 3)}\"><span ng-if=\"(receipt.status == 1 || receipt.status.value == 1)\">Pendiente</span> <span ng-if=\"(receipt.status == 2 || receipt.status.value == 2)\">Aplicada</span> <span ng-if=\"(receipt.status == 3 || receipt.status.value == 3)\">Liquidada</span> <span ng-if=\"(receipt.status == 5 || receipt.status.value == 5)\">Liquidada</span> <span ng-if=\"(receipt.status == 4 || receipt.status.value == 4)\">Cancelada</span></div></div><div class=\"btn-group pull-right m-t option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"goToPolicy(receipt)\">Ver póliza</a></li><li><a ng-click=\"goToEndorsement(receipt)\">Ver endoso</a></li><li class=\"dropdown-submenu\" ng-if=\"vm.files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!vm.files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"vm.files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"vm.files\" ng-repeat=\"file in vm.files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length && view_cartas\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"viewCarta(receiptPoliza.id, carta.id)\">{{carta.name}}</a></li></ul></li></ul></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-md-6\"><span class=\"color-blue\">Contratante:</span><p ng-if=\"contractor.natural || contractor.juridical\">{{contractor.natural}}{{contractor.juridical}}</p><p ng-if=\"!(contractor.natural || contractor.juridical)\">{{contractor}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Folio nota:</span><p>{{receipt.folio}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Número de póliza:</span><p>{{receipt.policy.poliza_number}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Fecha de emisión:</span><p>{{receipt.fecha_emision | date: \'dd/MM/yyyy\'}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">IVA:</span><p>{{receipt.iva | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">RPF:</span><p>{{receipt.rpf | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Prima neta:</span><p>{{receipt.prima_neta | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Gastos de expedición:</span><p>{{receipt.gastos_expedicion | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Subtotal:</span><p>{{receipt.sub_total | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Prima Total:</span><p>{{receipt.prima_total | currency}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\"><strong>Creado por:</strong></span><p>{{insurance.owner}}</p></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><hr><label>Estatus<span class=\"color-red\">*</span></label><select class=\"form-control m-b\" ng-model=\"receipt.status\" ng-change=\"changedValue(status)\" ng-options=\"status as status.label for status in statusReceipt track by status.value\" ng-if=\"status.value != 6\" required=\"\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona</option></select></div></div><div class=\"col-xs-12 col-md-6\"><br ng-if=\"receipt.status != 2\"><label>Forma de pago</label><select ng-disabled=\"receipt.status == 2\" class=\"form-control\" ng-model=\"receipt.payform\" ng-init=\"receipt.payform = 1\" ng-options=\"item.value as item.label for item in notascredito\"></select></div><div class=\"col-xs-12 col-md-6\"><br ng-if=\"receipt.status != 2\"><label>Documento de pago</label> <input class=\"form-control\" name=\"pay_doc\" ng-model=\"receipt.pay_doc\" ng-change=\"selectNote(pay_doc, 2)\" type=\"text\" ng-disabled=\"receipt.status == 2\"></div><div class=\"col-xs-12 col-md-6\"><br><label>Fecha de reembolso</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=\"text\" name=\"payDate\" class=\"width-100 text-align-center form-control\" ng-model=\"receipt.payDate\" value=\"{{payDate}}\" ng-disabled=\"receipt.status == 2\" ng-change=\"vm.options.payDate()\" data-date-format=\"mm/dd/yyyy\"></div></div><div class=\"col-xs-12 col-md-6\"><br><label>Cuenta</label> <input class=\"form-control\" name=\"pay_doc\" ng-model=\"receipt.account\" type=\"text\" ng-disabled=\"receipt.status == 2\"></div><div class=\"col-xs-12\"><br><label>Observaciones</label> <textarea class=\"form-control\" name=\"poliza\" ng-model=\"receipt.description\" type=\"text\" ng-disabled=\"(receipt.status == 2 || receipt.status == 1) && flag\"></textarea></div><div class=\"col-xs-12\"><div upload-template=\"\"></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"vmFiles.rename(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,files)\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</button> <span class=\"btn btn-success display-none\">Guardar</span></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-disabled=\"receipt.status == 2\" ng-click=\"changeNotaStatus(receipt)\">Guardar</button></div><script>\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    strongTag.hide();\n    inputTag.show();\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target);\n\n    strongTag.show();\n    inputTag.hide();\n  }\n</script>");
$templateCache.put("app/cobranzas/recibospendientes.tabla.html","<div class=\"row\" ng-if=\"vm.form.status.id == 1\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-success col-xs-12\" ng-if=\"!showButtonPending\" ng-click=\"todosPendientes(true)\"><i class=\"fa fa-check-square\" aria-hidden=\"true\"></i> Seleccionar todos</button> <button class=\"btn btn-success col-xs-12\" ng-if=\"showButtonPending\" ng-click=\"todosPendientes(false)\"><i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i> Deseleccionar todos</button></div></div><div class=\"row\" ng-if=\"vm.form.status.id == 2\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-success col-xs-12\" ng-if=\"!showButtonPay\" ng-click=\"todosPagados(true)\"><i class=\"fa fa-check-square\" aria-hidden=\"true\"></i> Seleccionar todos</button> <button class=\"btn btn-success col-xs-12\" ng-if=\"showButtonPay\" ng-click=\"todosPagados(false)\"><i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i> Deseleccionar todos</button></div></div><div class=\"table-responsive\"><div class=\"project-list\" id=\"tab\"><table class=\"table table-bordered table-stripped hidden-xs hidden-sm\"><thead><th ng-if=\"ver_select_pay\"></th><th ng-click=\"vm.changeReceipts(1, vm.receipts_tipo_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_tipo_asc == 1, \'fa fa-sort-asc\': vm.receipts_tipo_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(2, vm.receipts_cont_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_cont_asc == 1, \'fa fa-sort-asc\': vm.receipts_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(3, vm.receipts_nump_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_nump_asc == 1, \'fa fa-sort-asc\': vm.receipts_nump_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(4, vm.receipts_periodo_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_periodo_asc == 1, \'fa fa-sort-asc\': vm.receipts_periodo_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(5, vm.receipts_aseg_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_aseg_asc == 1, \'fa fa-sort-asc\': vm.receipts_aseg_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(6, vm.receipts_estatus_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_estatus_asc == 1, \'fa fa-sort-asc\': vm.receipts_estatus_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(7, vm.receipts_ptotal_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ptotal_asc == 1, \'fa fa-sort-asc\': vm.receipts_ptotal_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(8, vm.receipts_operador_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_operador_asc == 1, \'fa fa-sort-asc\': vm.receipts_operador_asc == 2}\"></span></th><th>Sucursal</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}}</th></thead><tbody><tr ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.isCopy == false && receipt.isActive == true\"><td ng-if=\"ver_select_pay\" ng-click=\"$event.stopPropagation()\"><label ng-if=\"vm.form.status.id == 1\"><input type=\"checkbox\" ng-model=\"receipt.to_liquidate\" ng-click=\"massiveReceiptsPay(vm.receipts,receipt, receipt.to_liquidate)\" class=\"checkbox\"></label> <label ng-if=\"vm.form.status.id == 2\"><input type=\"checkbox\" ng-model=\"receipt.toPay\" ng-click=\"massiveReceiptsPay(vm.receipts,receipt, receipt.toPay)\" class=\"checkbox\"></label></td><td ng-if=\"receipt.receipt_type == 1 && (receipt.poliza.document_type == 1 )\">Póliza</td><td ng-if=\"receipt.receipt_type == 1 && (receipt.poliza.document_type == 11 )\">Colectividad</td><td ng-if=\"receipt.receipt_type == 1 && (receipt.poliza.document_type == 12 )\">Póliza de Colectividad</td><td ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type == 3\">Póliza de Grupo</td><td ng-if=\"receipt.receipt_type == 1 && receipt.fianza == null && receipt.poliza.document_type == 4\">Subgrupo</td><td ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==7\">Fianza</td><td ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==8\">Fianza Colectiva</td><td ng-if=\"receipt.receipt_type == 2\">Endoso</td><td ng-if=\"receipt.receipt_type == 3\">Nota Crédito/Endoso</td><td class=\"project-title\"><div ng-if=\"receipt.poliza.document_type != 12\"><span ng-if=\"!receipt.contratante_sub\" class=\"font-weight-bold\">{{receipt.poliza.contractor.full_name}}</span> <span ng-if=\"receipt.contratante_sub\" class=\"font-weight-bold\">{{receipt.contratante_sub}}</span></div><div ng-if=\"receipt.poliza.document_type == 12\"><span class=\"font-weight-bold\">{{receipt.poliza.contractor.full_name}}</span><br><small>{{receipt.contratante_sub}}</small></div><small ng-if=\"receipt.poliza.contractor.group\"><span class=\"font-weight-bold\">Grupo:</span> {{receipt.poliza.contractor.group}}</small><br><small ng-if=\"receipt.poliza.contractor.type_person == \'Física\'\">Persona Física</small> <small ng-if=\"receipt.poliza.contractor.type_person == \'Moral\'\">Persona Moral</small></td><td class=\"project-title\"><a ng-if=\"receipt.receipt_type == 1 && receipt.fianza == null && !receipt.poliza.caratula && receipt.poliza.document_type ==1\" ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a> <a ng-if=\"receipt.receipt_type == 1 && receipt.fianza == null && !receipt.poliza.caratula && receipt.poliza.document_type ==3\" ui-sref=\"colectividades.info({polizaId: receipt.poliza.id})\">Póliza de Grupo: {{ receipt.poliza.poliza_number }}</a> <a ng-if=\"receipt.receipt_type == 1 && receipt.fianza == null && receipt.poliza.document_type ==4\" ui-sref=\"colectividades.info({polizaId: receipt.poliza.caratula})\">Póliza de Grupo: {{ receipt.poliza.parent.poliza_number }}</a> <a ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==11\" ui-sref=\"flotillas.info({polizaId: receipt.poliza.id})\">Colectividad: {{ receipt.poliza.poliza_number }}</a> <a ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==12\" ui-sref=\"flotillas.info({polizaId: receipt.poliza.caratula})\">Póliza de Colectividad: {{ receipt.poliza.poliza_number }}</a> <a ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==7\" ui-sref=\"fianzas.info({polizaId: receipt.poliza.id})\">Fianza: {{ receipt.poliza.poliza_number}}</a> <a ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==8\" ui-sref=\"colectividades.info({polizaId: receipt.poliza.id})\">Fianza Colectiva: {{ receipt.poliza.poliza_number }}</a> <a ng-click=\"showEndorsement(receipt)\" ng-if=\"receipt.receipt_type == 2\">Endoso: {{ receipt.poliza.poliza_number }}</a><br><small ng-if=\"receipt.poliza.identifier\"><b>Identificador:</b>{{ receipt.poliza.identifier }}</small><br><small>Serie:</small> <small ng-if=\"receipt.receipt_type ==3\">{{receipt.recibo_numero}}</small> <small ng-if=\"receipt.receipt_type == 1\">{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}} {{receipt.fianza.recibos_fianza.length}}</small> <small ng-if=\"receipt.receipt_type == 2\">{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length/2}}</small></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd/MM/yyyy\'}}</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">{{ receipt.poliza.aseguradora }} {{ receipt.fianza.afianzadora }} {{receipt.poliza.parent.aseguradora.alias}}</span><br><small>Subramo: {{ receipt.poliza.subramo }} {{ receipt.fianza.subramo }}{{receipt.poliza.parent.subramo.subramo_name}}</small></td><td class=\"project-status\"><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></td><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.poliza.owner }} {{ receipt.fianza.owner }} {{ receipt.bono.owner }}</td><td>{{ receipt.poliza.sucursal.sucursal_name }}</td><td>{{ receipt.antiguedad }} días</td><td class=\"project actions\"><a class=\"btn btn-white btn-sm\" ng-click=\"vm.changeStatusModal(receipt)\"><i class=\"fa fa-pencil\"></i> Aplicar</a> <button class=\"btn btn-white btn-sm\" ng-click=\"vm.showPhone(receipt)\" ng-disabled=\"!receipt.contratante.phone\"><i class=\"fa fa-phone\"></i></button><div ng-if=\"receipt.track_phone\" class=\"identificador-dash-phone\"></div><button ng-if=\"vm.acceso_cor\" lass=\"btn btn-white btn-sm\" ng-click=\"addEmailsConfirm(receipt)\"><i class=\"fa fa-envelope\"></i></button><div ng-if=\"receipt.track_email\" class=\"identificador-dash-email\"></div><span title=\"{{ vm.whatsappWebEnabled ? \'Recordatorio por WhatsApp Web\' : \'Recordatorio por SMS\' }}\"><button class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); addPhoneWhatsapp(receipt, receipt.poliza.contractor)\" ng-disabled=\"receipt.status != 4\"><img ng-if=\"!vm.whatsappWebEnabled\" style=\"height: 15px;\" class=\"icon-menu\" src=\"../../assets/comment-sms-solid.svg\"> <i ng-if=\"vm.whatsappWebEnabled\" class=\"fa fa-whatsapp\" style=\"color: #25D366;\" aria-hidden=\"true\"></i></button></span> <a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showComment(receipt)\" ng-disabled=\"!receipt.description.length\"><i class=\"fa fa-font\"></i></a><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(receipt)\"><i class=\"fa fa-comments\" aria-hidden=\"true\"></i></a><div ng-if=\"receipt.track_bitacora\" class=\"identificador-dash-binnacle\"></div><a class=\"btn btn-success btn-sm\" ng-click=\"$event.stopPropagation();verFlotilla(receipt.poliza)\" ng-if=\"receipt.poliza.document_type == 3 && receipt.poliza.subramo == \'Automóviles\'\" style=\"background-color: white;border-color: #BAC5C7;color: black;\"><i class=\"fa fa-car\" aria-hidden=\"true\" title=\"Ver detalle\"></i></a> <a class=\"btn btn-default sm\" style=\"color: grey\" ng-click=\"$event.stopPropagation(); vm.getLog(receipt)\"><i class=\"fa fa-history\">Log</i></a> <a class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"$event.stopPropagation(); createRecordatorio(receipt,4)\"><i class=\"fa fa-clock-o\"></i></a> <a ng-if=\"receipt.poliza.conducto_de_pago != \'No domiciliada\'\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"{{receipt.poliza.conducto_de_pago}}\"><i ng-if=\"receipt.poliza.conducto_de_pago == \'Agente\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CAC\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CAT/Domiciliado\'\" class=\"fa fa-credit-card-alt\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'Nómina\'\" class=\"fa fa-money\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CUT\'\" class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-default sm\" style=\"color: red\" ng-click=\"$event.stopPropagation()\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\" ng-if=\"receipt.endosotramite\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\"></i></a></td></tr></tbody></table><div class=\"col-xs-12\"><div class=\"identificador-dash-phone\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se hizo una llamada.</span><div class=\"identificador-dash-email\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se envio un correo.</span><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24 pull-right\" ng-if=\"vm.acceso_pag_rec && recibos_a_pagar.length > 0 && ver_select_pay\"><button ng-click=\"pay_receipts_selected(1)\" class=\"col-xs-12 btn btn-success\">Pagar seleccionados</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24 pull-right\" ng-if=\"vm.liquidar_is_posible && vm.acceso_liq_rec && recibos_a_liquidar.length > 0\"><button ng-click=\"pay_receipts_selected(2)\" class=\"col-xs-12 btn btn-info\">Liquidar seleccionados</button></div><br><br><div class=\"row\" ng-if=\"recibos_a_pagar.length > 0\"><div class=\"col-xs-12 col-sm-6 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Prima Total</th><th>Notas Crédito</th></tr></thead><tbody><tr ng-repeat=\"item in json_receipts\"><td><small>Total: <span class=\"font-weight-bold\">{{ item.total_prima | currency }}</span></small><br><small>Polizas:</small><span class=\"font-weight-bold\">{{ item.polizas }}</span><br><small>Pólizas de Grupo:</small><span class=\"font-weight-bold\">{{ item.colectividades }}</span><br><small>Endosos:</small><span class=\"font-weight-bold\">{{ item.endosos }}</span><br><small>Fianzas:</small><span class=\"font-weight-bold\">{{ item.fianzas }}</span></td><td><small>Total: <span class=\"font-weight-bold\">{{ item.total_nota | currency }}</span></small><br><small>Endosos:</small><span class=\"font-weight-bold\">{{ item.endososNota }}</span></td></tr></tbody></table></div></div><div ng-if=\"recibos_a_liquidar.length > 0\"><div class=\"col-xs-12 col-sm-6 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Prima Total</th><th>Notas Crédito</th></tr></thead><tbody><tr ng-repeat=\"item in json_receipts_pay\"><td><small>Total: <span class=\"font-weight-bold\">{{ item.total_prima | currency }}</span></small><br><small>Polizas:</small><span class=\"font-weight-bold\">{{ item.polizas }}</span><br><small>Pólizas de Grupo:</small><span class=\"font-weight-bold\">{{ item.colectividades }}</span><br><small>Endosos:</small><span class=\"font-weight-bold\">{{ item.endosos }}</span><br><small>Fianzas:</small><span class=\"font-weight-bold\">{{ item.fianzas }}</span></td><td><small>Total: <span class=\"font-weight-bold\">{{ item.total_nota | currency }}</span></small><br><small>Endosos:</small><span class=\"font-weight-bold\">{{ item.endososNota }}</span></td></tr></tbody></table></div></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"(receipt.status == 4 || receipt.status == 3) && receipt.isCopy == false && receipt.isActive == true\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}:<p ng-if=\"receipt.receipt_type == 1\">Póliza</p><p ng-if=\"receipt.receipt_type == 1 && receipt.fianza != null\">Fianza</p><p ng-if=\"receipt.receipt_type == 2\">Endoso</p></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p ng-if=\"receipt.receipt_type == 1\">Póliza</p><p ng-if=\"receipt.receipt_type == 2\">Endoso</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[1] }}</label><p>{{receipt.poliza.contractor.full_name}}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[2] }}</label><p><a ng-if=\"vm.acceso_adm_pol\" ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"!vm.acceso_adm_pol\">Póliza: {{ receipt.poliza.poliza_number }}</span></p><small>Serie:</small> <small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[3] }}</label><p><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[4] }}</label><p><span class=\"font-weight-bold\">{{ receipt.poliza.aseguradora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}</small></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-status\"><label>{{ vm.table.headers[5] }}</label><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></div></tr></table></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ receipt.prima_total | currency}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ receipt.owner }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</p><p ng-if=\"!(receipt.antiguedad > 0)\">0 días</p></div><div class=\"table-cell col-xs-12 col-sm-6 project actions\"><label>{{ vm.table.headers[9] }}</label><p><a class=\"btn btn-white btn-sm\" ng-click=\"vm.changeStatusModal(receipt)\"><i class=\"fa fa-pencil\"></i> Aplicar</a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showPhone(receipt)\" ng-disabled=\"!receipt.contratante.phone\"><i class=\"fa fa-phone\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showEmail(receipt)\" ng-if=\"vm.acceso_cor\"><i class=\"fa fa-envelope\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.showComment(receipt)\" ng-disabled=\"reviews\"><i class=\"fa fa-file\"></i> Observaciones</a><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(receipt, \'recibo\')\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></div></div><div ng-if=\"vm.show_pag_policy\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><br></div><div ng-if=\"vm.receipts.length\"><div ng-if=\"vm.show_button1 == true && !vm.show_binnacle\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24 pull-right\" ng-if=\"vm.acceso_rep_cob\"><button ng-click=\"exportData(1)\" class=\"col-xs-12 btn btn-primary ladda-button\">Generar Reporte</button></div></div></div>");
$templateCache.put("app/colectividades/colectividades.edit.html","<toaster-container></toaster-container><div><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-12\"><h2>Editar Colectividad</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"index.main\">Inicio</a></li><li><a ui-sref=\"polizas.table\">Colectividades</a></li><li><a ui-sref=\"colectividades.info({polizaId: caratula.id})\">Colectividad #{{caratula.poliza_number}}</a></li><li ng-if=\"statesparams.status !=1\"><strong>Edición</strong></li><li ng-if=\"statesparams.status == 1\"><strong>Convertir a póliza</strong></li></ol></div></div><script>\n	    $(\"#wizard\").steps({\n	    	onFinished: function(){\n	    		angular.element(document.getElementById(\'wizard\')).scope().goToList();\n	    	}\n	    });\n	</script></div><br><div id=\"wizard\" class=\"no-padding\"><h1>Carátula</h1><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title title-colapsable\"><h5>CARÁTULA</h5><div class=\"ibox-tools\" ng-init=\"showContent = true\"><a class=\"collapse-link\" ng-click=\"showContent == true ? showContent = false : showContent = true\"><i ng-class=\"{\'fa fa-chevron-up\': showContent, \'fa fa-chevron-down\': !showContent}\"></i></a></div></div><div class=\"ibox-content wizard\" ng-if=\"showContent && verCaratula == true\"><div class=\"col-md-12\"><div class=\"col-md-6 form-group\"><label>Folio interno:</label><div><input type=\"text\" class=\"form-control\" ng-model=\"caratula.internal_number\" disabled=\"\"></div></div><div class=\"col-md-6 form-group\"><label>Folio:</label><div><input type=\"text\" class=\"form-control\" ng-model=\"caratula.folio\"></div></div><div class=\"col-md-6 form-group\" ng-if=\"!order.show.ot\"><label>Número de póliza: <span class=\"color-red\">*</span></label><div><input ng-blur=\"checkNumPolicy()\" type=\"text\" class=\"form-control\" ng-model=\"caratula.poliza_number\"></div></div><div class=\"col-md-6 form-group\" ng-if=\"editot\"><label>Número de póliza: <span class=\"color-red\">*</span></label><div><input ng-blur=\"checkNumPolicy()\" type=\"text\" class=\"form-control\" ng-model=\"caratula.poliza_number\"></div></div><div class=\"col-md-6 form-group\"><label>Identificador: <span class=\"color-red\">*</span></label><div><input type=\"text\" class=\"form-control\" ng-model=\"caratula.identifier\"></div></div><div class=\"col-xs-12 col-md-6 form-group\"><label class=\"control-label\">Contratante {{contrac.selected}}<span class=\"color-red\">*</span></label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.form.contratante\" change=\"matchesContractors(order.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.address.$invalid && !caratula_form.address.$pristine }\"><select class=\"form-control\" data-ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in order.defaults.address track by address.url\" ng-change=\"order.options.changeAddress(order.form.address)\" name=\"address\" ng-model=\"order.form.address\" ng-disabled=\"!order.form.contratante\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" name=\"correo\" ng-model=\"order.form.contratante.email\" type=\"email\" ng-disabled=\"!order.form.contratante || emailStatus\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono</label><phonenumber-directive model=\"order.form.contratante.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"inputValue\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div><div class=\"col-md-4 form-group\"><label>Vigencia</label><div class=\"datepicker-me input-group date\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"caratula.start_of_validity\" value=\"{{caratula.start_of_validity}}\" ng-change=\"checkDate()\" ng-init=\"checkDate(\'initial\')\" ng-disabled=\"caratula.receipts_by == 2\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-md-4 form-group\"><label>al</label><div class=\"datepicker-me input-group date\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"caratula.end_of_validity\" value=\"{{caratula.end_of_validity}}\" ng-disabled=\"caratula.receipts_by == 2\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-md-4 form-group\"><label class=\"text-center\">Aseguradora<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.aseguradora.$invalid && !caratula_form.aseguradora.$pristine }\"><select class=\"form-control\" data-ng-options=\"aseguradora.alias for aseguradora in providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"aseguradoraSelection()\" name=\"aseguradora\" ng-model=\"caratula.aseguradora\" ng-disabled=\"!cover_contractor\" required=\"\"><option value=\"\">Selecciona un proveedor</option></select></div></div><div class=\"col-md-4 form-group\"><label>Clave de agente<span class=\"color-red\">*</span></label><div ng-if=\"!claves.length\" ng-class=\"{ \'has-error\': caratula_form.clave.$invalid && !caratula_form.clave.$pristine }\"><input type=\"text\" name=\"clave\" placeholder=\"No hay ninguna clave para esta aseguradora\" class=\"form-control\" disabled=\"\"></div><div ng-class=\"{ \'has-error\': caratula_form.clave1.$invalid && !caratula_form.clave1.$pristine }\"><select ng-if=\"claves.length\" class=\"form-control\" data-ng-options=\"clave as clave.clave +\' - \'+clave.name for clave in claves | orderBy: \'clave\' track by clave.url\" ng-change=\"changeClave(clave)\" name=\"clave1\" ng-model=\"caratula.clave\" ng-disabled=\"!caratula.aseguradora\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div></div><div class=\"col-md-4 form-group\"><label>Ramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.ramo.$invalid && !caratula_form.ramo.$pristine }\"><select class=\"form-control\" data-ng-options=\"ramo.ramo_name for ramo in ramos track by ramo.url\" ng-change=\"changeRamo()\" name=\"ramo\" ng-model=\"caratula.ramo\" ng-disabled=\"!caratula.aseguradora\" required=\"\"><option value=\"\">Selecciona un ramo</option></select></div></div><div class=\"col-md-4 form-group\"><label>Subramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula.subramo.$invalid && !caratula.subramo.$pristine }\"><select class=\"form-control\" data-ng-options=\"subramo.subramo_name for subramo in subramos track by subramo.url\" ng-change=\"changeSubramo()\" name=\"subramo\" ng-model=\"caratula.subramo\" ng-disabled=\"!caratula.ramo\" required=\"\"><option value=\"\">Selecciona un subramo</option></select></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 form-group\"><label>Renovable<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.renewal.$invalid && !form.renewal.$pristine }\"><select class=\"form-control\" ng-options=\"renewal.value as renewal.label for renewal in order.renewal.options\" ng-change=\"renewalSelection()\" name=\"renewal\" ng-model=\"order.renewal.selected\" required=\"\"></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectCurrency\">Moneda <span class=\"color-red\">*</span></label><select id=\"SelectCurrency\" class=\"form-control\" ng-options=\"f_currency.value as f_currency.label for f_currency in order.f_currency.options\" ng-init=\"order.f_currency.f_currency_selected = 1\" ng-model=\"order.f_currency.f_currency_selected\" ng-change=\"changeCurrency()\"></select></div><div ng-if=\"!order.defaults.comisiones.length\"><span>{{ not_comision }}</span></div><div class=\"col-md-4 form-group\" ng-if=\"order.defaults.comisiones.length\"><div class=\"checkbox margin-top-5\"><label class=\"blue-color\"><input ng-disabled=\"!order.form.clave\" ng-model=\"order.form.ceder_comision\" ng-change=\"order.ceder_comision(true)\" type=\"checkbox\"> Modificar comisión</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Comisión (%) <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"comision\" ng-model=\"order.form.comision_percent\" ng-change=\"change_comision()\" type=\"text\"></div><div class=\"col-md-4 form-group\"><label>Tipo de administración<span class=\"color-red\">*</span></label><div><select class=\"form-control\" ng-change=\"changeAdminType()\" name=\"adminType\" ng-model=\"order.adminType\" required=\"\"><option value=\"\">Selecciona un tipo de administración</option><option value=\"Autoadministrada\">Autoadministrada</option><option value=\"Simplificada\">Simplificada</option><option value=\"Detallada\">Detallada</option></select></div></div><div class=\"col-md-4 form-group\"><label class=\"text-center\">Frecuencia de pago<span class=\"color-red\">*</span></label><div ng-if=\"frec_disabled\"><input class=\"form-control\" ng-model=\"caratula.payment.name\" disabled=\"\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group btn-mt\" ng-if=\"numRecs == totalRecs && caratula.receipts_by == 1\"><button class=\"btn btn-info\" ng-click=\"changeFrequency()\">Cambiar frecuencia</button></div><div ng-if=\"order.ejecutivos.length > 0\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"collection_executive\">Ejecutivo de Cobranza</label><select class=\"form-control\" name=\"collection_executive\" ng-model=\"order.form.collection_executive\" ng-change=\"collection_executive(order.form.collection_executive)\" ng-options=\"collection_executive as collection_executive.first_name + \' \' + collection_executive.last_name for collection_executive in order.ejecutivos track by collection_executive.id\"><option value=\"\">Seleccione un Ejecutivo</option></select></div><div ng-if=\"sucursalList.length > 0\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"sucursal\">Sucursal</label><select class=\"form-control\" name=\"sucursal\" ng-model=\"order.form.sucursal\" ng-change=\"sucursal(order.form.sucursal)\" ng-options=\"sucursal as sucursal.sucursal_name for sucursal in sucursalList track by sucursal.id\"><option value=\"\">Seleccione una Sucursal</option></select></div><div class=\"col-xs-12 form-group\"><div class=\"row form-group\" ng-if=\"!frec_disabled\"><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.form.payment.value\" type=\"radio\" value=\"1\"> MENSUAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment.value\" value=\"2\"> BIMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment.value\" value=\"3\"> TRIMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment.value\" value=\"6\"> SEMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment.value\" value=\"12\"> ANUAL</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.form.payment.value\" type=\"radio\" value=\"5\"> CONTADO</label></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label style=\"margin-bottom: 10px;\">Domiciliado</label><div class=\"col-xs-12 col-sm-6\"><input ng-model=\"order.form.domiciliado\" type=\"radio\" ng-value=\"true\" id=\"_1\" ng-click=\"changeDomiciliado()\"> SI</div><div class=\"col-xs-12 col-sm-6\"><input ng-model=\"order.form.domiciliado\" type=\"radio\" ng-value=\"false\" id=\"_2\" ng-click=\"changeDomiciliado()\"> NO</div></div><div class=\"col-xs-12 col-sm-7 col-md-5 nopadding form-group\"><label>Referenciadores</label><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in referenciadores\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteReferenciador($index, item)\" ng-disabled=\"referenciadores.length <= 1 || item.vendor\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b col-xs-12\" name=\"referenciador_policy\" ng-model=\"item.referenciador\" ng-change=\"changeReferenciador(item)\" ng-options=\"referenciador_policy.url as referenciador_policy.first_name + \' \' + referenciador_policy.last_name for referenciador_policy in referenciador\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\" ng-init=\"referenciadores[$index].resp_type = 0\"><input class=\"form-control m-b col-xs-12 wb102\" type=\"text\" name=\"\" placeholder=\"% Comisión\" ng-model=\"item.comision_vendedor\" ng-disabled=\"referenciadores.length <= 1\" ng-change=\"changeComRef(item)\" required=\"\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button> <a ng-disabled=\"!item.referenciador\" ng-show=\"item.selectedRef && referenciadores.length > 1 && order.poliza.primaTotal\" class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); calculateComision(item, $index)\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i></a></div></div></div></div><div class=\"col-md-12 form-group\"><label>Observaciones:</label><div><textarea type=\"text\" class=\"form-control\" ng-model=\"caratula.observations\"></textarea></div></div></div></div><div><div class=\"col-xs-12\" ng-if=\"receits_on_cover && !order.show.ot || receits_on_cover && editot\"><calculate-receipts poliza=\"order.poliza\" form=\"order.form\" tosave=\"dataToSave\" type=\"1\"></calculate-receipts></div></div><div class=\"col-xs-12 text-right form-group\" ng-if=\"!statesparams.status == 1\"><button class=\"btn btn-primary\" ng-click=\"saveCaratula()\">Guardar Cambios</button></div><div class=\"col-xs-12 text-right form-group\" ng-if=\"statesparams.status == 1 && showContent\"><button class=\"btn btn-primary\" ng-click=\"saveConvPolicyOT(dataToSave,caratula,order.poliza)\">Guardar Cambios</button></div></div></div><h1>Subgrupos</h1><div><div ng-include=\"\'app/colectividades/templates/subgroups.html\'\"></div></div><h1>Categorias</h1><div><div ng-include=\"\'app/colectividades/templates/categories.html\'\"></div></div></div><br><br><br><br>");
$templateCache.put("app/colectividades/colectividades.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-lg-9\"><h2>Colectividades</h2></div></div><script>\n    // var settings = {\n    //     labels: {\n    //         finish: \"Finalizar\",\n    //         next: \"Siguiente\",\n    //         previous: \"Anterior\"\n    //     }\n    // };\n    $(\"#wizard\").steps({\n      onStepChanging: function(event, currentIndex, newIndex) {\n        if(currentIndex == 0){\n            angular.element(document.getElementById(\'wizard\')).scope().saveCaratula();     \n            return true;\n        } else if(currentIndex == 1){\n            if(angular.element(document.getElementById(\'wizard\')).scope().subgroupDone){\n                return true;\n            } else {\n                return false;\n            }\n        } else if(currentIndex == 2){\n            if(angular.element(document.getElementById(\'wizard\')).scope().categoryDone){\n                return true;\n            } else {\n                return false;\n            }\n        } else if(currentIndex == 3){\n            return true;\n        } else if(currentIndex == 4){\n            return true;\n        }\n      }\n    });\n</script><br><div id=\"wizard\" class=\"no-padding\"><h1>Carátula</h1><div><div ng-include=\"\'app/colectividades/templates/crear-ot.html\'\"></div></div><h1>Subgrupos</h1><div><div ng-include=\"\'app/colectividades/templates/subgroups.html\'\"></div></div><h1>Categorias</h1><div><div ng-include=\"\'app/colectividades/templates/categories.html\'\"></div></div><h1>Paquetes</h1><div><div ng-include=\"\'app/colectividades/templates/paquetes.html\'\"></div></div><h1>Certificados</h1><div><div ng-include=\"\'app/colectividades/templates/certificados.html\'\"></div></div></div><br><br><br><br>");
$templateCache.put("app/colectividades/colectividades.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-lg-9\"><h2>Colectividades</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"polizas.table\">Colectividades</a></li><li class=\"active\"><strong>Colectividad #{{caratula.poliza_number}}</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><ul class=\"tab-group\"><li ng-class=\"{ \'active-group\': show_caratula }\" ng-click=\"show_section(1)\">Carátula</li><li ng-class=\"{ \'active-group\': show_subgrupo }\" ng-click=\"show_section(2)\">Subgrupos y Categorías</li><li ng-class=\"{ \'active-group\': show_paquete }\" ng-click=\"show_section(3)\">Paquetes</li><li ng-class=\"{ \'active-group\': show_certificado }\" ng-click=\"show_section(4)\">Certificados</li></ul></div></div><div class=\"row wrapper wrapper-content animated fadeIn ng-scope\" ng-if=\"infoFlag\"><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"coverIncomplete && caratula.subramo.subramo_name != \'Automóviles\'\" class=\"col-xs-12 btn btn-danger\" style=\"margin-bottom: 20px\"><b>Esta colectividad no tiene asegurados</b></div><div ng-if=\"coverIncomplete && caratula.subramo.subramo_name == \'Automóviles\'\" class=\"col-xs-12 btn btn-danger\" style=\"margin-bottom: 20px\"><b>Esta colectividad no tiene automóviles</b></div><div class=\"pull-right option_button m-b\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-if=\"caratula.status == \'En trámite\' && acceso_adm_pol\" ng-click=\"convertPolicy(caratula)\">Convertir a póliza</a></li><li ng-if=\"acceso_adm_ot && acceso_adm_end\"><a ng-click=\"goToEndorsement()\" ng-if=\"caratula.status\">Crear endoso</a></li><li ng-if=\"acceso_elim_pol && caratula.status !=\'En Trámite\' && caratula.status !=\'OT Cancelada\'\"><a ng-click=\"deletePolicy(caratula)\">Eliminar</a></li><li ng-if=\"acceso_elim_ot && (caratula.status ==\'En Trámite\' || caratula.status ==\'OT Cancelada\')\"><a ng-click=\"deletePolicy(caratula)\">Eliminar</a></li><li ng-if=\"acceso_adm_pol && caratula.status !=\'En Trámite\' && caratula.status !=\'OT Cancelada\'\"><a id=\"button\" ng-click=\"cover_edit()\">Editar</a></li><li ng-if=\"acceso_adm_ot && (caratula.status ==\'En Trámite\'|| caratula.status ==\'OT Cancelada\')\"><a id=\"button\" ng-click=\"cover_edit()\">Editar</a></li><li ng-if=\"acceso_canc_pol && caratula.status !=\'En Trámite\' && caratula.status !=\'OT Cancelada\'\"><a ng-click=\"cancelPolicy(caratula)\">Cancelar póliza</a></li><li ng-if=\"acceso_canc_ot && (caratula.status ==\'En Trámite\' || caratula.status ==\'OT Cancelada\')\"><a ng-click=\"cancelPolicy(caratula)\">Cancelar póliza</a></li><li ng-if=\"caratula.status == 4 || caratula.status == \'Precancelada\' && acceso_adm_pol\"><a ng-click=\"reactivePolicy(caratula)\">Reactivar póliza</a></li><li ng-if=\"caratula.status == \'En trámite\'\"><a ng-click=\"getPDF(caratula.id)\">Generar PDF</a></li><li><a ng-click=\"sendProvider(caratula)\" ng-if=\"caratula.status == \'En trámite\'\">Enviar PDF a la compañia</a></li><li class=\"dropdown-submenu\" ng-if=\"caratula.status != \'Cancelada\'; caratula.status != \'En trámite\'; caratula.renewed_status == 0\"><a>Renovar</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li ng-if=\"caratula.status != \'Cancelada\';caratula.status != \'En trámite\' && acceso_adm_pol\"><a ng-click=\"cover_renewal()\">Colectividad</a></li><li ng-if=\"caratula.status != \'En trámite\' && acceso_adm_ot\"><a ng-click=\"cover_renewal(1)\" ng-hide=\"caratula.status == \'Cancelada\'\">OT</a></li></ul></li><li ng-if=\"caratula.status != \'Cancelada\'; caratula.status != \'En trámite\'; caratula.renewed_status == 0\"><a ng-click=\"cancelRenovate(caratula)\">No renovar</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length && permiso_archivos\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"acceso_form\"><a>Descargar layouts</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Col_Flotillas.xls\">Flotillas</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Col_GM.xls\">Gastos médicos</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Col_Vida.xls\">Vida</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"acceso_form\"><a>Ver carta</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li ng-if=\"cartas\" ng-repeat=\"carta in cartas track by $index\"><a ng-click=\"viewCarta(caratula.id, carta)\">{{carta.name}}</a></li><li><a ng-click=\"getPDF(caratula.id)\">RESÚMEN EN PDF</a></li></ul></li><li ng-hide=\"conteos_es.endosos == 0\" ng-if=\"(caratula.administration_type == 2 || caratula.administration_type ==\'Autoadministrada\')\"><a ng-click=\"verAjusteCuenta(caratula.id)\">Info-Ajuste Anual</a></li><li><a ng-click=\"shareCertificatesAPPEmail(caratula.id)\">Compartir Certificados a la App y Correo Electrónico</a></li><li><a ng-click=\"shareCertificatesApp(caratula.id)\">Compartir Certificados a la App</a></li><li><a ng-click=\"shareCertificatesEmail(caratula.id)\">Compartir Certificados al Correo Electrónico</a></li></ul></div></div></div></div><div ng-if=\"show_caratula\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carátula</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\" ng-if=\"caratula.natural\"><b>Nombre</b>:</span> <span class=\"blue-color\" ng-if=\"caratula.juridical\"><b>Razón Social</b>:</span><div><span>{{cover_contractor.full_name}}{{cover_contractor.j_name}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">RFC:</span><div><span>{{cover_contractor.rfc}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Grupo:</span><div><span>{{cover_contractor.group}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div style=\"word-wrap: break-word\"><span>{{cover_contractor.email}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Teléfono:</span><div><span>{{cover_contractor.phone_number}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Dirección</span><div><span>{{cover_contractor.direccion.route}} {{cover_contractor.direccion.street_number}}&nbsp;</span> <span ng-if=\"cover_contractor.direccion.street_number_int\">Int. {{cover_contractor.direccion.street_number_int}},</span> <span>{{cover_contractor.direccion.sublocality}},</span><br><span>{{cover_contractor.direccion.administrative_area_level_2}},</span> <span>{{cover_contractor.direccion.administrative_area_level_1}},</span> <span>CP. {{cover_contractor.direccion.postal_code}}</span></div></div><div class=\"col-xs-12 form-group m-t\" ng-if=\"permiso_archivos\"><button class=\"btn btn-primary m-b\" ng-if=\"!showFilesCar\" ng-click=\"showFiles(1)\"><span class=\"fa fa-files-o\"></span> Archivos de Carátula</button> <button class=\"btn btn-info m-b\" ng-if=\"showFilesCar\" ng-click=\"hideFiles(1)\"><span class=\"fa fa-times\"></span> Ocultar</button></div><div class=\"col-xs-12 form-group\" ng-if=\"acceso_adm_ot\"><button type=\"button\" class=\"btn btn-primary m-r-sm\" ng-click=\"showEndorsements(caratula)\" ng-disabled=\"conteos.endosos == 0\">{{conteos_es.endosos}}</button><span class=\"blue-color\">Endosos</span></div><div class=\"col-xs-12 form-group\" ng-if=\"acceso_ver_cob\"><button type=\"button\" class=\"btn btn-warning m-r-sm\" ng-click=\"showNotas()\" ng-disabled=\"notas_c.length == 0\">{{notas_c.length}}</button><span class=\"blue-color\">Notas de Crédito</span></div></div><div class=\"col-xs-12 col-md-8 border-left\"><legend class=\"legend-title\" align=\"center\">Carátula</legend><div ng-if=\"caratula.poliza_number\" class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\"><b>Número de Póliza</b>:</span><div><span>{{caratula.poliza_number}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Identificador:</span><div><span>{{caratula.identifier}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{caratula.aseguradora.alias}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Clave de Agente:</span><div><span>{{caratula.clave.clave}} <span ng-if=\"caratula.clave.name\">- {{caratula.clave.name}}</span></span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{caratula.ramo.ramo_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{caratula.subramo.subramo_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{caratula.start_of_validity | date: \'dd-MM-yyyy\' : \'UTC\'}} - {{caratula.end_of_validity | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{caratula.forma_de_pago.name}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Tipo de Administración:</span><div><span>{{caratula.administration_type}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" ng-class=\"{\'label-success\': caratula.status == \'En trámite\' || caratula.status == \'Renovada\', \'label-info\' : caratula.status == \'Por iniciar\', \'label-primary\' : caratula.status == \'Vigente\', \'label-warning\' : caratula.status == \'OT Cancelada\' || caratula.status == \'Precancelada\' || caratula.status == 11}\" style=\"float: left; margin-right: 10px\">{{ caratula.status }} <span ng-if=\"caratula.renewed_status == 2\">- En proceso de renovación</span></div></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"caratula.is_renewable\"><span class=\"blue-color\">Tipo Renovable:</span><div><span ng-if=\"caratula.is_renewable ==1\">Renovable</span> <span ng-if=\"caratula.is_renewable ==2\">No renovable</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Moneda:</span><div><span>{{caratula.f_currency}}</span></div></div><div class=\"col-xs-6 col-lg-4 form-group\"><span class=\"blue-color\">Creado Por:</span><div><span>{{caratula.owner}}</span></div></div><div class=\"col-xs-6 col-lg-4 form-group\"><span class=\"blue-color\">Sucursal:</span><div><span>{{caratula.sucursal.sucursal_name}}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"caratula.responsable.first_name\"><span class=\"blue-color\"><i class=\"fa fa-star yellow\"></i> Responsable:</span><div>{{ caratula.responsable.first_name }} {{ caratula.responsable.last_name }}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\"><i class=\"fa fa-calculator yellow\"></i> Ejecutivo de cobranza:</span><div>{{ caratula.collection_executive.first_name }} {{ caratula.collection_executive.last_name }}</div></div><div class=\"col-xs-6 col-lg-4 form-group\" ng-if=\"caratula.vendor && caratula.ref_policy.length == 0\"><span class=\"blue-color\">Referenciador:</span><div><span>{{caratula.vendor.first_name}} {{caratula.vendor.last_name}}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"caratula.ref_policy.length >0\"><span class=\"blue-color\">Referenciador (es):</span><div ng-repeat=\"refs in caratula.ref_policy\"><span>{{refs.data.first_name }} {{ refs.data.last_name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Observaciones:</span><div><span>{{caratula.observations}}</span></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 form-group\" ng-if=\"caratula.poliza_number && caratula.recibos_poliza.length == 0\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Esta colectividad fue creada con recibos en subgrupos, revisa el apartado de subgrupos y categorías para ver los recibos.</div></div><div ng-if=\"vm.insurance.status != 1 && caratula.recibos_poliza.length\"><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Neta:</span><div>{{ caratula.p_neta | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Descuento: &nbsp;</span><div>{{ caratula.descuento | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-6 form-group\"><span class=\"blue-color\">Recargo por Pago Fraccionado:</span><div>{{ caratula.rpf | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Derecho:</span><div>{{ caratula.derecho | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Iva:</span><div>{{ caratula.iva | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Total:</span><div>{{ caratula.p_total | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"permiso_comisiones\"><span class=\"blue-color\">Comisión:</span><div>{{ caratula.comision | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"permiso_comisiones\"><span class=\"blue-color\">Porcentaje de Comisión:</span><div>{{ caratula.comision_percent }}%</div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"caratula\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i><span class=\"blue-color\"><i class=\"fa fa-card\"></i> Cargo Automático:</span><div><span ng-if=\"isCat\" title=\"Los recibos es con cargo a tarjeta (Domiciliado)\">Si</span> <span ng-if=\"!isCat\" title=\"Los recibos NO estan con cargo a tarjeta (Domiciliado)\">No</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changedomiciliadoF(true)\"><i class=\"fa fa-edit\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 col-md-12 col-lg-6 form-group\" ng-if=\"changeDomiciliado\"><div><div class=\"col-xs-12 col-sm-6 form-group\" ng-init=\"newDomiciliado = isCat\"><label style=\"margin-bottom: 10px;\">Domiciliado</label><br><div class=\"col-xs-12 col-sm-4\"><input ng-model=\"newDomiciliado\" type=\"radio\" ng-value=\"true\" id=\"_1\" ng-click=\"changeDomiciliadoValue()\"> SI</div><div class=\"col-xs-12 col-sm-4\"><input ng-model=\"newDomiciliado\" type=\"radio\" ng-value=\"false\" id=\"_2\" ng-click=\"changeDomiciliadoValue()\"> NO</div><button class=\"btn btn-primary btn-sm\" ng-click=\"saveDomiciliado(newDomiciliado)\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-warning btn-sm\" ng-click=\"changedomiciliadoF(false)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></div></div></div></div></div></div><div class=\"col-md-12\" ng-if=\"showFilesCar == true && permiso_archivos\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(1)\">Guardar Archivos</button></div></div><div class=\"row col-md-12 col-sm-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in filesC track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"renameFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,filesC)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td></tr></tbody></table></div></div></div><div class=\"col-md-12\" ng-if=\"!caratula.recibos_poliza.length && show_receits_cover && show_receipts\"><calculate-receipts poliza=\"order.poliza\" form=\"order.form\" tosave=\"dataToSave\" type=\"1\"></calculate-receipts><div><button class=\"btn btn-primary\" ng-click=\"saveReceipts(1)\">Guardar</button></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"caratula.recibos_poliza.length\"><div class=\"ibox-title\"><h5>Recibos</h5><div class=\"ibox-tools\" ng-init=\"showGroups = true\"><a class=\"collapse-link\" ng-click=\"showGroups == true ? showGroups = false : showGroups = true\"><i ng-class=\"{\'fa fa-chevron-up\': showGroups, \'fa fa-chevron-down\': !showGroups}\"></i></a></div></div><div class=\"ibox-content wizard\"><div class=\"col-xs-12 m-t\"><div class=\"ibox float-e-margins\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\"><uib-tab-heading><span ng-if=\"!activeJustified\" class=\"fa fa-calculator\"></span> Póliza</uib-tab-heading><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle_receipt\"><thead><tr><th>Serie</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>Iva</th><th>Prima Total</th><th ng-if=\"permiso_comisiones\">Comisión</th><th>Vigencia</th><th>Vencimiento</th><th>Estatus</th><th>Entregado</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"recibo in caratula.recibos_poliza\" ng-if=\"recibo.receipt_type == 1 && recibo.status != 0\" ng-click=\"changeStatusModal(cover_contractor, recibo)\"><td>{{recibo.recibo_numero}}</td><td>{{recibo.prima_neta | currency}}</td><td>{{recibo.rpf | currency}}</td><td>{{recibo.derecho | currency}}</td><td>{{recibo.iva | currency}}</td><td>{{recibo.prima_total | currency}}</td><td ng-if=\"permiso_comisiones\">{{recibo.comision | currency}}</td><td>{{recibo.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}} - {{recibo.fecha_fin | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td>{{recibo.vencimiento | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == 4, \'label-info\' : recibo.status == 5 || recibo.status == 6, \'label-primary\' : recibo.status == 1 || recibo.status == 3, \'label-warning\' : recibo.status == 2 || recibo.status == 8}\">{{ statusReceipt(recibo.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(recibo)\"><span ng-if=\"recibo.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!recibo.delivered\"><i class=\"fa fa-times\"></i></span></td><td><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><div ng-if=\"recibo.track_bitacora\" class=\"identificador-dash-binnacle\"></div><a ng-if=\"recibo.is_cat\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <button class=\"btn btn-sm btn-white\" ng-click=\"$event.stopPropagation(); editReceipt(recibo)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <button ng-if=\"recibo.status == 4 && acceso_elim_rec == true && caratula.recibos_poliza.length > 1\" class=\"btn btn-sm btn-white\" ng-click=\"$event.stopPropagation(); deleteReceipt(recibo,$index)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td></tr><tr><td><b>Totales</b></td><td><b>{{calculatePrima(caratula.recibos_poliza) | currency}}</b></td><td><b>{{calculateRpf(caratula.recibos_poliza) | currency}}</b></td><td><b>{{calculateDerecho(caratula.recibos_poliza) | currency}}</b></td><td><b>{{calculateIva(caratula.recibos_poliza) | currency}}</b></td><td><b>{{calculatePrimaTotal(caratula.recibos_poliza) | currency}}</b></td><td><b>{{calculateComision(caratula.recibos_poliza) | currency}}</b></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><div class=\"col-xs-12\"><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div><div class=\"row animate\" ng-if=\"show_binnacle_receipt\"><div class=\"col-md-12\"><div><label>Bitácora de recibos</label> <a class=\"btn btn-info pull-right\" ng-click=\"returnToReceipts()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"comments_data_receipt\" typemodel=\"4\" config=\"comments_config\" idmodel=\"receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span ng-if=\"activeJustified\" class=\"fa fa-calculator\"></span> Endosos</uib-tab-heading><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle_receipt_endoso\"><thead><tr><th>Número</th><th>Serie</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>Iva</th><th>Prima Total</th><th ng-if=\"permiso_comisiones\">Comisión</th><th>Vigencia</th><th>Estatus</th><th>Entregado</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"recibo in caratula.recibos_poliza\" ng-if=\"recibo.receipt_type == 2 || recibo.receipt_type == 3\" ng-show=\"recibo.status != 0\" ng-click=\"changeStatusModal(cover_contractor,recibo)\"><td>{{recibo.endorsement}}</td><td>{{recibo.recibo_numero}}</td><td>{{recibo.prima_neta | currency}}</td><td>{{recibo.rpf | currency}}</td><td>{{recibo.derecho | currency}}</td><td>{{recibo.iva | currency}}</td><td>{{recibo.prima_total | currency}}</td><td ng-if=\"permiso_comisiones\">{{recibo.comision | currency}}</td><td>{{recibo.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}} - {{recibo.fecha_fin | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == 4, \'label-info\' : recibo.status == 5 || recibo.status == 6, \'label-primary\' : recibo.status == 1 || recibo.status == 3, \'label-warning\' : recibo.status == 2 || recibo.status == 8}\">{{ statusReceipt(recibo.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(recibo)\"><span ng-if=\"recibo.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!recibo.delivered\"><i class=\"fa fa-times\"></i></span></td><td><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); showBinnacleReceiptEndoso(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><div ng-if=\"recibo.track_bitacora\" class=\"identificador-dash-binnacle\"></div><a ng-if=\"recibo.is_cat\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div class=\"col-xs-12\"><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div><div class=\"row animate\" ng-if=\"show_binnacle_receipt_endoso\"><div class=\"col-md-12\"><div><label>Bitácora de recibos</label> <a class=\"btn btn-info pull-right\" ng-click=\"returnToReceiptsEndoso()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"comments_data_receipt\" typemodel=\"4\" config=\"comments_config\" idmodel=\"receipt_id\"></comments></div></div></div></uib-tab></uib-tabset></div></div></div></div></div><div ng-if=\"show_subgrupo\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Subgrupos y Categorías</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 animate\" ng-repeat=\"sub in subgroups track by $index\" ng-if=\"!show_receipts_sub\" ng-init=\"viewReceipts[$index] = false\"><div ng-init=\"sub.showFiles = false\"><div ng-if=\"sub.name !== \'Default\'\"><legend class=\"legend-title bg-info\" align=\"center\">Subgrupo #{{ $index + 1 }} <a ng-click=\"deleteSub(sub)\"><i class=\"fa fa-trash color-black pull-right\" style=\"position: absolute; top: 18px; right: 40px; font-size: 20px; z-index: 2000;\"></i></a></legend><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-lg-2 form-group\"><span class=\"blue-color\">ID:</span> <span>{{sub.id}}</span></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><span class=\"blue-color\">Nombre:</span> <span>{{sub.name}}</span></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\" ng-if=\"sub.natural.id || sub.juridical.id\"><span class=\"blue-color\">Contratante:</span> <span ng-if=\"sub.natural\">{{sub.natural.full_name}}</span> <span ng-if=\"sub.juridical\">{{sub.juridical.j_name}}</span></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"sub.name !== \'Default\'\"><div ng-init=\"filesS[$index] = []\" ng-if=\"permiso_archivos\"><button class=\"btn btn-default pull-right\" style=\"margin-left: 20px;\" ng-click=\"showFiles(2,sub.id, sub)\"><i class=\"fa fa-files-o\" aria-hidden=\"true\"></i> &nbsp;Archivos Subgrupo</button></div><div><button class=\"btn btn-success pull-right\" style=\"margin-left: 20px;\" ng-click=\"viewReceipts[$index] ? viewReceipts[$index] = false : viewReceipts[$index] = true\" ng-if=\"sub.recibos_poliza.length && !caratula.recibos_poliza.length\">Ver Recibos</button></div><div ng-if=\"sub.natural.id && !sub.recibos_poliza.length\"><button class=\"btn btn-success pull-right\" ng-click=\"addReceipts(sub)\">Agregar Recibos</button></div><div ng-if=\"sub_receipts.juridical.id && !sub.recibos_poliza.length\"><button class=\"btn btn-success pull-right\" ng-click=\"addReceipts(sub)\">Agregar Recibos</button></div></div></div></div><div ng-if=\"sub.showFiles && permiso_archivos\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(2, sub)\">Guardar Archivos</button></div><div class=\"row col-md-12 col-sm-12 form-group\" ng-if=\"showFilesS\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in sub.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"renameFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,sub.files)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td></tr></tbody></table></div></div></div><div class=\"col-xs-12\" ng-if=\"viewReceipts[$index]\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-md-6 col-sm-6 form-group center\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i><span class=\"blue-color\"><i class=\"fa fa-card\"></i> Cargo Automático:</span><div><span ng-if=\"isCat\" title=\"Los recibos es con cargo a tarjeta (Domiciliado)\">Si</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changedomiciliadoF(true)\"><i class=\"fa fa-edit\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-md-6 col-sm-6 form-group\" ng-if=\"changeDomiciliado\"><div class=\"col-xs-12 form-group\" ng-init=\"newDomiciliado = isCat\"><label style=\"margin-bottom: 10px;\">Domiciliado</label><br><div class=\"col-xs-12 col-sm-6 col-md-6\"><input ng-model=\"newDomiciliado\" type=\"radio\" ng-value=\"true\" id=\"_1\" ng-click=\"changeDomiciliadoValue()\"> SI</div><div class=\"col-xs-12 col-sm-6 col-md-6\"><input ng-model=\"newDomiciliado\" type=\"radio\" ng-value=\"false\" id=\"_2\" ng-click=\"changeDomiciliadoValue()\"> NO</div><div class=\"col-xs-12 col-sm-6 col-md-6\"><button class=\"btn btn-primary btn-sm\" ng-click=\"saveDomiciliadoG(newDomiciliado,sub)\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><button class=\"btn btn-warning btn-sm\" ng-click=\"changedomiciliadoF(false)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></div></div></div></div><legend class=\"legend-title\" align=\"center\">Recibos del Subgrupo</legend><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle_receipt\"><thead><th>Serie</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>Iva</th><th>Prima Total</th><th ng-if=\"permiso_comisiones\">Comisión</th><th>Vigencia</th><th>Vencimiento</th><th>Estatus</th><th>Entregado</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"recibo in sub.recibos_poliza\" ng-click=\"changeStatusModal(cover_contractor, recibo)\"><td>{{recibo.recibo_numero}}</td><td>{{recibo.prima_neta | currency}}</td><td>{{recibo.rpf | currency}}</td><td>{{recibo.derecho | currency}}</td><td>{{recibo.iva | currency}}</td><td>{{recibo.prima_total | currency}}</td><td ng-if=\"permiso_comisiones\">{{recibo.comision | currency}}</td><td>{{recibo.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}} - {{recibo.fecha_fin | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td>{{recibo.vencimiento | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == 4, \'label-info\' : recibo.status == 5 || recibo.status == 6, \'label-primary\' : recibo.status == 1 || recibo.status == 3, \'label-warning\' : recibo.status == 2 || recibo.status == 8}\">{{ statusReceipt(recibo.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(recibo)\"><span ng-if=\"recibo.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!recibo.delivered\"><i class=\"fa fa-times\"></i></span></td><td><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><div ng-if=\"recibo.track_bitacora\" class=\"identificador-dash-binnacle\"></div><a ng-if=\"recibo.is_cat\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <button class=\"btn btn-sm btn-white\" ng-click=\"$event.stopPropagation(); editReceipt(recibo)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <button ng-if=\"recibo.status == 4 && acceso_elim_rec == true && caratula.recibos_poliza.length > 1\" class=\"btn btn-sm btn-white\" ng-click=\"$event.stopPropagation(); deleteReceipt(recibo,$index)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td></tr><tr><td><b>Totales</b></td><td><b>{{calculatePrima(sub.recibos_poliza) | currency}}</b></td><td><b>{{calculateRpf(sub.recibos_poliza) | currency}}</b></td><td><b>{{calculateDerecho(sub.recibos_poliza) | currency}}</b></td><td><b>{{calculateIva(sub.recibos_poliza) | currency}}</b></td><td><b>{{calculatePrimaTotal(sub.recibos_poliza) | currency}}</b></td><td><b>{{calculateComision(sub.recibos_poliza) | currency}}</b></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table></div><div class=\"row animate\" ng-if=\"show_binnacle_receipt\"><div class=\"col-md-12\"><div><label>Bitácora de recibos</label> <a class=\"btn btn-info pull-right\" ng-click=\"returnToReceipts()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"comments_data_receipt\" typemodel=\"4\" config=\"comments_config\" idmodel=\"receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div></div><div ng-init=\"category[$index] = false\"><div class=\"list-group col-xs-12 col-sm-6 jumbotron\" ng-repeat=\"category in sub.categories\"><legend class=\"legend-title\" align=\"center\">Categoría #{{ $index + 1 }} <a ng-click=\"deleteCat(category, sub)\"><i class=\"fa fa-trash color-black pull-right\" style=\"position: absolute; top: 18px; right: 40px; font-size: 20px; z-index: 2000;\"></i></a></legend><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><span class=\"blue-color\">ID:</span> <span>{{category.id}}</span></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Nombre:</span> <span>{{category.name}}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Certificados Activos:</span> <span>{{category.certificados_activos}}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Certificados Inactivos:</span> <span>{{category.certificados_inactivos}}</span></div></div><div class=\"row\" ng-init=\"category.showFiles = false\" ng-if=\"permiso_archivos\"><div class=\"col-md-4 form-group\"><button class=\"btn btn-default btn-sm pull-right\" ng-click=\"showFiles(3,category.id, category)\"><i class=\"fa fa-files-o\" aria-hidden=\"true\"></i> Archivos Categoría</button></div><div class=\"col-md-4 form-group\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"selectCategory(category, 1)\">Certificados activos</button></div><div class=\"col-md-4 form-group\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"selectCategory(category, 2)\">Certificados inactivos</button></div></div><div class=\"ibox-content col-xs-12\" ng-if=\"category.showFiles && permiso_archivos\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(3, category)\">Guardar Archivos</button></div><div class=\"row col-xs-12 form-group\" ng-if=\"showFilesC\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in category.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"renameFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,category.files)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"col-md-4\"><button class=\"btn btn-info\" ng-click=\"allCertificates(caratula, 3)\">Todos los certificados</button></div><div class=\"col-md-12\" ng-if=\"show_receipts_sub\"><div><label class=\"btn btn-info\" ng-click=\"returnToSubs()\">Regresar</label></div><div class=\"text-center\"><span>Los recibos se agregarán al subgrupo</span><label>{{sub_receipts.name}}</label> <span>con el contratante</span> <label>{{ sub_receipts.natural.full_name }} {{ sub_receipts.juridical.j_name }}</label></div><div><calculate-receipts poliza=\"order.poliza\" form=\"caratula\" tosave=\"dataToSave\" type=\"1\"></calculate-receipts></div><div class=\"pull-right\"><button class=\"btn btn-success\" ng-click=\"saveReceipts(2)\">Guardar</button></div></div></div></div></div></div></div><div ng-if=\"show_paquete\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Paquetes</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12\"><button class=\"btn btn-success\" ng-if=\"user.permiso.crear || user.permiso.editar\" ng-click=\"newPackage()\">Agregar paquete</button></div><div class=\"col-xs-12 form-group\" ng-if=\"creation_packages\"><div class=\"col-xs-12 col-sm-6 form-group btn-mt\" ng-if=\"packages_data.length\"><label>Paquete</label><select class=\"form-control\" ng-model=\"package_selected\" ng-options=\"item as item.package_name for item in packages_data\" ng-change=\"selectPackage(package_selected)\"><option value=\"\">Selecciona un paquete</option></select></div><div ng-if=\"!packages_data.length\"><span>Este ramo no tiene paquetes actualmente</span></div></div><div class=\"col-xs-12\" ng-if=\"package_selected\"><legend class=\"legend-title\" align=\"center\">Nueva Configuración</legend><div class=\"col-xs-12 col-sm-6\" ng-show=\"showNewCoverage\"><div class=\"col-xs-12 form-group\"><label>Nombre de la Cobertura</label> <input class=\"form-control\" ng-model=\"newCoverage[$index]\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"showNewCoverage = false; newCoverage[$index] = \'\'\">Cancelar</button></div><div class=\"col-xs-12 col-sm-6 form-group\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"saveCoverage(newCoverage[$index], \'config\', package_selected, data);showNewCoverage = false; newCoverage[$index] = \'\'\">Agregar</button></div></div><div class=\"col-xs-12\"><div ng-show=\"!showNewCoverage\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre de la Configuración<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"config_coverages.package_name\"></div><div class=\"col-xs-12 col-sm-3 form-group btn-mt\"><span class=\"dropdown\" uib-dropdown=\"\" is-open=\"isopen\" auto-close=\"outsideClick\"><a href=\"javascript:void(0);\" class=\"dropdown-toggle btn btn-success\" uib-dropdown-toggle=\"\">Mostrar Coberturas</a><ul style=\"margin-top: 10px;\" uib-dropdown-menu=\"\" class=\"dropdown-menu scrollable-menu\" role=\"menu\"><li ng-click=\"addAll(); isopen = false\" ng-if=\"config_coverages.source.length\"><label class=\"menu-item align-center\">Seleccionar Todos</label></li><li ng-repeat=\"item in config_coverages.source track by $index\"><label class=\"menu-item\"><input type=\"checkbox\" ng-model=\"item.selected\" ng-click=\"addCoverageToArray(item)\">&nbsp;{{item.coverage_name}}</label></li></ul></span></div><div class=\"col-xs-12 col-sm-3 form-group btn-mt\"><button class=\"btn btn-info pull-right\" type=\"button\" ng-click=\"showNewCoverage = true\">Nueva Cobertura</button></div></div></div><legend class=\"legend-title\" align=\"center\">Coberturas</legend><div ng-init=\"showConfig[$index] = true\"><div class=\"col-xs-12\" ng-if=\"showConfig[$index]\"><table class=\"table\"><thead><th>Cobertura</th><th>Suma Asegurada<span class=\"color-red\">*</span></th><th>Deducible<span class=\"color-red\">*</span></th><th ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">Coaseguro</th><th ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">Tope Coaseguro</th><th></th></thead><tbody><tr ng-repeat=\"coverage in config_coverages.coveragesConfig | orderBy: \'priority\' track by coverage.url\"><td>{{coverage.coverage_name}}</td><td><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.sums_coverage\" ng-click=\"coverage.sumInPolicy.value = item.sum_insured\"><a>{{demo(item.sum_insured)}}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.sumInPolicy.value\" ng-keyup=\"show_button_save_sum = true\" format-currency=\"\"></div></td><td><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.deductible_coverage\" ng-click=\"coverage.deductibleInPolicy.value = item.deductible\"><a>{{demo(item.deductible)}}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.deductibleInPolicy.value\" ng-keyup=\"show_button_save_ded = true\" format-currency=\"\"></div></td><td ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"coverage.coinsuranceInPolicy.value\" ng-change=\"percentageRange(coverage.coinsuranceInPolicy.value, $index)\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></td><td ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"coverage.topeCoinsuranceInPolicy.value\" format-currency=\"\"></div></td><td><button class=\"btn btn-danger pull-right\" name=\"button\" ng-click=\"deleteCoverage(coverage, data)\" type=\"button\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right\" ng-disabled=\"!config_coverages.package_name\" ng-click=\"saveConfiguration(config_coverages)\">Guardar Configuración</button></div></div><div class=\"col-xs-12 btn-mt\"><div class=\"list-group row\" ng-repeat=\"package in packages track by $index\" ng-init=\"packs[$index] = false; package.edit = false\" ng-show=\"package.edit == false\"><legend class=\"legend-title\" align=\"center\">Paquete #{{ $index + 1 }}</legend><div class=\"col-xs-12 col-sm-10 form-group\"><button type=\"button\" ng-class=\"{\'package-active\': packs[$index] == true}\" class=\"list-group-item\" ng-click=\"packs[$index] ? packs[$index] = false : packs[$index] = true\"><span class=\"blue-color\">ID:</span> <span>{{package.id}} |</span> <span class=\"blue-color\">Nombre:</span> <span>{{package.package_name}}</span></button></div><div class=\"col-xs-12 col-sm-2 form-group\"><button class=\"btn btn-success col-xs-12\" ng-click=\"editPackage(package,$index)\">Editar Paquete</button></div><br><br><br><div ng-if=\"packs[$index]\" class=\"coverages-table\"><table class=\"table\"><thead><th>Nombre</th><th>Suma asegurada</th><th>Deducible</th><th ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">Coaseguro</th><th ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">Tope Coaseguro</th></thead><tbody><tr ng-repeat=\"cob in package.coverage_package | orderBy: \'priority\' track by cob.url\"><td>{{cob.coverage_name}}</td><td ng-if=\"cob.sums_coverage[0].sum_insured\">{{cob.sums_coverage[0].sum_insured}}</td><td ng-if=\"cob.deductible_coverage[0].deductible\">{{cob.deductible_coverage[0].deductible}}</td><td ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">{{cob.coinsurance_coverage[0].coinsurance}}</td><td ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">{{cob.topecoinsurance_coverage[0].topecoinsurance}}</td></tr></tbody></table></div></div><div class=\"list-group\" ng-repeat=\"package in packages track by $index\" ng-if=\"package.edit == true\"><legend class=\"legend-title\" align=\"center\">Paquete #{{ $index + 1 }}</legend><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"folio\">ID</label> <input class=\"form-control\" name=\"id\" type=\"text\" ng-model=\"package.id\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"!order.show.ot\"><label for=\"folio\">Nombre</label> <input class=\"form-control\" name=\"nombre\" type=\"text\" ng-model=\"package.package_name\"></div><br><div><table class=\"table\"><thead><th>Nombre</th><th>Suma asegurada</th><th>Deducible</th><th ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">Coaseguro</th><th ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">Tope Coaseguro</th></thead><tbody><tr ng-repeat=\"cob in package.coverage_package | orderBy: \'priority\' track by cob.url\"><td><input class=\"form-control\" name=\"nombre\" type=\"text\" ng-model=\"cob.coverage_name\"></td><td><input class=\"form-control\" name=\"nombre\" type=\"text\" ng-model=\"cob.sums_coverage[0].sum_insured\"></td><td><input class=\"form-control\" name=\"nombre\" type=\"text\" ng-model=\"cob.deductible_coverage[0].deductible\"></td><td ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\"><input class=\"form-control\" name=\"nombre\" type=\"text\" ng-model=\"cob.coinsurance_coverage[0].coinsurance\" ng-disabled=\"cob.coinsurance_coverage[0].coinsurance ? false : true\"></td><td ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\"><input class=\"form-control\" name=\"nombre\" type=\"text\" ng-model=\"cob.topecoinsurance_coverage[0].topecoinsurance\" ng-disabled=\"cob.topecoinsurance_coverage[0].topecoinsurance ? false : true\"></td></tr></tbody></table><button class=\"btn btn-success pull-right\" ng-click=\"savePackageEdit(package)\">Guardar cambios</button></div></div></div></div></div></div></div></div><div ng-if=\"show_certificado\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Certificados</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"!show_certificate_dat && category_selected && !edit_certificate_data\"><div ng-if=\"!category_selected.certsEmpty\"><label>Buscar</label><div class=\"col-xs-12 col-sm-9 input-group\" style=\"float: left;\"><input class=\"form-control\" type=\"text\" ng-enter=\"search(cadena)\" ng-model=\"cadena\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"search(cadena)\">Buscar</button></div></div><div class=\"input-group-btn col-xs-12 col-sm-3\"><button class=\"btn btn-info\" type=\"button\" ng-if=\"acceso_adm_pol\" ng-click=\"addTemp()\"><i class=\"fa fa-plus\"></i> Agregar Certificado</button></div></div><table class=\"table table-bordered table-hover m-t\" ng-if=\"!category_selected.certsEmpty && !autos && !danios || certs_data && !autos && !danios\"><thead><th>Certificado</th><th>Estatus</th><th>Titular</th><th>Beneficiarios <span ng-if=\"item.datos.beneficiaries_life\">- Porcentaje</span></th><th>Vigencia</th><th>Contacto</th><th>Prima Neta</th><th>Derecho</th><th>RPF</th><th>IVA</th><th>Prima Total</th><th>Antigüedad</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"item in category_selected.certs | orderBy: \'certificate_number\' track by $index\" ng-click=\"selectCerficate(item)\"><td>{{item.certificate_number}}</td><td><span ng-if=\"item.certificado_inciso_activo\" class=\"blue-color\">Activo</span> <span ng-if=\"!item.certificado_inciso_activo\" class=\"blue-color\">Inactivo</span> <span ng-if=\"!item.certificado_inciso_activo && item.fecha_baja_inciso\">Fecha de Baja: {{item.fecha_baja_inciso | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></td><td ng-if=\"item.datos.personal.full_name\">{{item.datos.personal.full_name}}</td><td ng-if=\"!item.datos.personal.full_name\">{{item.datos.personal.first_name}} {{item.datos.personal.last_name}} {{item.datos.personal.second_last_name}}</td><td><div ng-repeat=\"beneficiarie in item.datos.beneficiaries_life\" ng-if=\"item.datos.beneficiaries_life\"><span ng-if=\"beneficiarie.is_active && item.certificado_inciso_activo\" class=\"blue-color\">-Activo</span><span ng-if=\"!beneficiarie.is_active || !item.certificado_inciso_activo\" class=\"blue-color\">-Inactivo</span><div ng-if=\"beneficiarie.is_active && !(beneficiarie.full_name)\">{{beneficiarie.first_name}} {{beneficiarie.last_name}} {{beneficiarie.second_last_name}} - {{beneficiarie.percentage}}%</div><div ng-if=\"beneficiarie.is_active && beneficiarie.full_name\">{{beneficiarie.full_name}} - {{beneficiarie.percentage}}%</div></div><div ng-repeat=\"beneficiarie in item.datos.relationship_accident\" ng-if=\"item.datos.relationship_accident\"><span ng-if=\"beneficiarie.is_active && item.certificado_inciso_activo\" class=\"blue-color\">-Activo</span><span ng-if=\"!beneficiarie.is_active || !item.certificado_inciso_activo\" class=\"blue-color\">-Inactivo</span><div ng-if=\"beneficiarie.full_name\">{{beneficiarie.full_name}}</div><div ng-if=\"!(beneficiarie.full_name)\">{{beneficiarie.first_name}} {{beneficiarie.last_name}} {{beneficiarie.second_last_name}}</div></div></td><td>{{item.start_of_validity | date: \'dd-MM-yyyy\' : \'UTC\'}} - {{item.end_of_validity | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td>{{item.contacto}}</td><td>{{item.p_neta | currency}}</td><td>{{item.derecho | currency}}</td><td>{{item.rpf | currency}}</td><td>{{item.iva | currency}}</td><td>{{item.p_total | currency}}</td><td>{{item.rec_antiguedad | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td ng-click=\"$event.stopPropagation()\"><button ng-if=\"acceso_adm_pol\" class=\"btn btn-info\" ng-click=\"editCerficate(item)\" title=\"Editar Certificado\"><span class=\"fa fa-pencil\"></span></button> <button ng-if=\"acceso_elim_pol\" class=\"btn btn-danger\" ng-click=\"certDelete(item)\" title=\"Eliminar Certificado\"><span class=\"fa fa-trash\"></span></button> <button class=\"btn btn-warning\" ng-click=\"paid(item)\" ng-if=\"!item.paid_out\"><span class=\"fa fa-dollar\"></span></button> <button disabled=\"\" class=\"btn btn-primary\" ng-click=\"paid(item)\" ng-if=\"item.paid_out\"><span class=\"fa fa-dollar\"></span></button> <button class=\"btn btn-success\" ng-if=\"item.certificado_inciso_activo == true && acceso_adm_pol\" ng-click=\"addBeneficiarios(item.certificate_number,item,caratula.subramo)\" title=\"Añadir Dependientes / Beneficiarios\"><span class=\"fa fa-plus\"></span></button><div class=\"col-xs-12 form-group\" ng-if=\"acceso_adm_ot\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showEndorsements(item)\" ng-disabled=\"item.endosos == 0\">{{item.endosos}}</button><span class=\"blue-color\">Endosos</span></div><div class=\"col-xs-12 form-group\" ng-if=\"acceso_adm_sin\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showSinistersCertificate(item)\" ng-disabled=\"item.siniestros == 0\">{{item.siniestros}}</button><span class=\"blue-color\">Siniestros</span></div></td></tr></tbody></table><div><div ng-if=\"caratula.subramo.subramo_code == 3 && manual == true\"><div class=\"row address-container\" ng-repeat=\"relationship in subforms.relationshipList track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"options.relationshipList.destroy($index,relationship)\">Quitar Dependiente</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"options.relationshipList.destroy($index,relationship)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Dependiente #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"options.relationshipList.add(subforms.relationshipList)\" type=\"button\">Agregar Dependiente</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"options.relationshipList.add(subforms.relationshipList)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-2 col-lg-1 col-md-1 col-sm-1 form-group\"><label for=\"names_dependant\">Certificado</label> <button class=\"btn btn-info\"># {{num_certificate}}</button></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"nombre{{$index}}\">Nombre</label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"relationship.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last{{$index}}\">Apellido Paterno</label> <input id=\"last{{$index}}\" name=\"last{{$index}}\" class=\"form-control\" ng-model=\"relationship.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"relationship.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"parentesco{{0}}\">Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"relationship.relationship\" ng-options=\"r.option for r in relation track by r.option\"><option value=\"\" disabled=\"\">Selecciona</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.birthdate\" value=\"{{relationship.birthdate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"gender{{$index}}\">Sexo</label><select class=\"form-control\" ng-options=\"sex as sex.label for sex in defaults.sex track by sex.value\" ng-model=\"relationship.sex\"><option value=\"\" disabled=\"\">Selecciona</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"antiguedad{{$index}}\">Fecha Antigüedad</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.antiguedad\" value=\"{{relationship.antiguedad}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div><div class=\"col-xs-2 col-lg-2 col-md-2 col-sm-1 form-group\" ng-if=\"manual == true || manual_life == true\"><button class=\"btn btn-success\" ng-click=\"saveBeneficiarios(item,subforms.relationshipList)\">Guardar dependientes</button></div></div><div ng-if=\"caratula.subramo.subramo_code == 1 && manual_life == true\"><div class=\"row address-container\" ng-repeat=\"beneficiary in subforms.beneficiariesList track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"options.beneficiary.destroy($index,beneficiary); delBeneficiary()\">Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"options.beneficiary.destroy($index,beneficiary)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"options.beneficiary.add();addBeneficiary()\" type=\"button\">Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"options.beneficiary.add()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div ng-if=\"beneficiary.person == 1\"><div class=\"col-xs-2 col-lg-1 col-md-1 col-sm-1 form-group\"><label for=\"names_dependant\">Certificado</label> <button class=\"btn btn-info\"># {{num_certificate}}</button></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"names_dependant\">Nombre</label> <input type=\"text\" name=\"names_dependant\" ng-model=\"beneficiary.first_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent\">Apellido Paterno</label> <input type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent_1\">Apellido Materno</label> <input type=\"text\" name=\"last_name_dependent_1\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"parentesco\">Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"beneficiary.optional_relationship\" ng-options=\"r.option for r in relation track by r.option\"><option value=\"\" disabled=\"\">Selecciona</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"beneficiary.birthdate\" value=\"{{beneficiary.birthdate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Sexo</label><select class=\"form-control\" ng-model=\"beneficiary.sex\" placeholder=\"\"><option value=\"\">Selecciona una opcion</option><option value=\"M\">MASCULINO</option><option value=\"F\">FEMENINO</option></select></div><div class=\"col-xs-12 col-md-3 form-group\"><label for=\"ben_percentage\">Porcentaje</label> <input type=\"number\" class=\"form-control\" ng-model=\"beneficiary.percentage\" minlength=\"1\" maxlength=\"3\" max=\"100\" min=\"1\"></div></div><div ng-if=\"beneficiary.person == 2\"><div class=\"col-xs-6 form-group\"><label for=\"nombre{{$index}}\">Razón Social <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiary.j_name\" type=\"text\"></div><div class=\"col-xs-6 form-group\"><label for=\"nombre{{$index}}\">RFC</label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiary.rfc\" type=\"text\" maxlength=\"13\"></div></div></div></div><div class=\"col-xs-2 col-lg-2 col-md-2 col-sm-1 form-group\"><button class=\"btn btn-success\" ng-click=\"saveBeneficiarios(item,subforms.beneficiariesList)\">Guardar beneficiarios</button></div></div></div><table class=\"table table-bordered table-hover m-t\" ng-if=\"!category_selected.certsEmpty && autos || certs_data && autos\"><thead><th>Inciso</th><th>Estatus</th><th>General</th><th>Serial</th><th>Motor</th><th>Matrícula</th><th>Conductor</th><th>Beneficiario Preferente</th><th>Asegurado</th><th>Vigencia</th><th>Prima Neta</th><th>Derecho</th><th>RPF</th><th>IVA</th><th>Prima Total</th><th>Comisión</th><th>Suma Asegurada</th><th>Antigüedad</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"item in category_selected.certs track by $index\" ng-click=\"show_certificate_data = true; selectCerficate(item)\"><td>{{ item.certificate_number }}</td><td><span ng-if=\"item.certificado_inciso_activo\" class=\"blue-color\">Activo</span> <span ng-if=\"!item.certificado_inciso_activo\" class=\"blue-color\">Inactivo</span></td><td>{{ item.automobiles_policy[0].brand }} {{item.automobiles_policy[0].model}} {{ item.automobiles_policy[0].year }} {{ item.automobiles_policy[0].version }} {{ item.automobiles_policy[0].color }} <span ng-if=\"item.automobiles_policy[0].usage == 1\">Uso: particular</span> <span ng-if=\"item.automobiles_policy[0].usage == 2\">Uso: Carga</span> <span ng-if=\"item.automobiles_policy[0].usage == 3\">Uso: Servicio Público</span> <span ng-if=\"item.automobiles_policy[0].usage == 2 && item.automobiles_policy[0].charge_type\">Tipo: <span ng-if=\"item.automobiles_policy[0].charge_type == 1\">A</span><span ng-if=\"item.automobiles_policy[0].charge_type == 2\">B</span><span ng-if=\"item.automobiles_policy[0].charge_type == 3\">C</span></span></td><td>{{ item.automobiles_policy[0].serial }}</td><td>{{ item.automobiles_policy[0].engine }}</td><td>{{ item.automobiles_policy[0].license_plates }}</td><td>{{ item.automobiles_policy[0].driver }}</td><td>{{ item.automobiles_policy[0].preferential_benefiaciary }} <span ng-if=\"item.automobiles_policy[0].beneficiary_address\">- {{ item.automobiles_policy[0].beneficiary_address }}</span> <span ng-if=\"item.automobiles_policy[0].beneficiary_rfc\">- {{ item.automobiles_policy[0].beneficiary_rfc }}</span></td><td>{{ item.automobiles_policy[0].beneficiary_name }}</td><td>{{ item.start_of_validity | date: \'dd-MM-yyyy\' : \'UTC\'}} - {{ item.end_of_validity | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td>{{ item.p_neta }}</td><td>{{ item.derecho }}</td><td>{{ item.rpf }}</td><td>{{ item.iva }}</td><td>{{ item.p_total }}</td><td>{{ item.comision }}</td><td><span ng-if=\"item.automobiles_policy[0].sum_insured\">{{ item.automobiles_policy[0].sum_insured}}</span> <span ng-if=\"!item.automobiles_policy[0].sum_insured\">0</span></td><td>{{ item.rec_antiguedad | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td ng-click=\"$event.stopPropagation()\"><button ng-if=\"user.permiso.editar\" class=\"btn btn-info\" ng-click=\"editCerficate(item)\"><span class=\"fa fa-pencil\"></span></button> <button class=\"btn btn-warning\" ng-click=\"paid(item)\" ng-if=\"!item.paid_out\"><span class=\"fa fa-dollar\"></span></button> <button disabled=\"\" class=\"btn btn-primary\" ng-click=\"paid(item)\" ng-if=\"item.paid_out\"><span class=\"fa fa-dollar\"></span></button> <button ng-if=\"user.permiso.eliminar\" class=\"btn btn-danger\" ng-click=\"certDelete(item)\"><span class=\"fa fa-trash\"></span></button><div class=\"col-xs-12 form-group\" ng-if=\"acceso_adm_ot\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showEndorsements(item)\" ng-disabled=\"item.endosos == 0\">{{item.endosos}}</button><span class=\"blue-color\">Endosos</span></div><div class=\"col-xs-12 form-group\" ng-if=\"acceso_adm_sin\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showSinistersCertificate(item)\" ng-disabled=\"item.siniestros == 0\">{{item.siniestros}}</button><span class=\"blue-color\">Siniestros</span></div></td></tr></tbody></table><table class=\"table\" ng-if=\"!category_selected.certsEmpty && danios || certs_data && danios\"><thead><th>Inciso</th><th>Estatus</th><th>Información de la ubicación</th><th width=\"30%\">Opciones</th></thead><tbody><tr ng-repeat=\"item in category_selected.certs track by $index | orderBy : reverse\" ng-click=\"show_certificate_data = true; selectCerficate(item)\"><td>{{ item.certificate_number }}</td><td><span ng-if=\"item.certificado_inciso_activo\" class=\"blue-color\">Activo</span> <span ng-if=\"!item.certificado_inciso_activo\" class=\"blue-color\">Inactivo</span></td><td><div><span class=\"blue-color\">Nombre:</span>{{ item.damages_policy[0].insured_item }}</div><div><span class=\"blue-color\">Dirección:</span>{{ item.damages_policy[0].item_address }}</div><div><span class=\"blue-color\">Prima neta:</span> ${{ item.p_neta}}</div><div><span class=\"blue-color\">Derecho:</span> ${{ item.derecho}}</div><div><span class=\"blue-color\">RPF:</span> ${{ item.rpf}}</div><div><span class=\"blue-color\">IVA:</span> ${{ item.iva}}</div><div><span class=\"blue-color\">Prima Total:</span> ${{ item.p_total}}</div></td><td ng-click=\"$event.stopPropagation()\"><button ng-if=\"acceso_adm_pol\" class=\"btn btn-info\" ng-click=\"editCerficate(item)\"><span class=\"fa fa-pencil\"></span> Editar</button> <button ng-if=\"acceso_elim_pol\" class=\"btn btn-danger\" ng-click=\"certDelete(item)\"><span class=\"fa fa-trash\"></span> Eliminar</button><div class=\"col-xs-12 form-group\" ng-if=\"acceso_adm_ot\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showEndorsements(item)\" ng-disabled=\"item.endosos == 0\">{{item.endosos}}</button><span class=\"blue-color\">Endosos</span></div></td></tr></tbody></table><div class=\"text-center\" ng-if=\"!category_selected.certsEmpty\"><nav aria-label=\"Page navigation example\" ng-if=\"category_selected.show_pagination\"><ul class=\"pagination pagination_center justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"col-xs-12 pull-right\" ng-if=\"acceso_rep_pol\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"downloadExcel(category_selected, 1)\" ng-if=\"allCerts == false\">Descargar excel</button></div><div class=\"col-xs-12 pull-right\" ng-if=\"acceso_rep_pol\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"downloadExcelAll(caratula, 1)\" ng-if=\"allCerts\">Descargar excel *</button></div></div><div class=\"col-xs-12 animate address_components margin-top-20\" ng-if=\"show_certificate_dat\"><div class=\"col-xs-12 margin-top-20\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"returnToCerts()\"><i class=\"fa fa-reply\"></i> Regresar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" style=\"margin-right: -10px;\"><div class=\"col-xs-12 btn-group\"><button type=\"button\" class=\"col-xs-12 btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones del certificado</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"assignPolicy(cert_info.id)\">Compartir</a></li><li><a ng-if=\"caratula.subramo.subramo_code == 1\" ui-sref=\"siniestros.create_vida({myInsurance: cert_info, contractor: cover_contractor})\">Crear siniestro</a></li><li class=\"dropdown-submenu\"><a ng-if=\"acceso_adm_sin && caratula.ramo.ramo_code == 2\">Crear siniestro</a><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"goToSiniester(\'\', 1)\">Por Titular</a></li><li class=\"dropdown-submenu\"><a>Por Dependiente</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-repeat=\"relationship in cert_info.accidents_policy[0].relationship_accident\"><a ng-click=\"goToSiniester(relationship, 2)\">{{relationship.first_name}} {{relationship.last_name}}</a></li></ul></li></ul></li><li ng-if=\"acceso_adm_sin\"><a ng-if=\"caratula.subramo.subramo_code == 9\" ui-sref=\"siniestros.create_autos({myInsurance: cert_info, contractor: cover_contractor})\">Crear siniestro</a></li></ul></div></div></div><div class=\"col-xs-12 col-sm-6\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"col-xs-12 col-lg-8 form-group\"><span class=\"blue-color\" ng-if=\"!cover_contractor.j_name\">Nombre</span> <span class=\"blue-color\" ng-if=\"cover_contractor.j_name\">Razón social</span><div ng-if=\"!cover_contractor.j_name\"><span><b>Contratante:</b> {{cover_contractor.full_name}}</span><br><span ng-if=\"cert_info.automobiles_policy[0].beneficiary_name\"><b>Asegurado:</b>{{cert_info.automobiles_policy[0].beneficiary_name}}</span></div><div ng-if=\"cover_contractor.j_name\"><span><b>Contratante:</b> {{cover_contractor.j_name}}</span> <span><b>Asegurado:</b> {{cert_info.automobiles_policy[0].beneficiary_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Tipo de Persona:</span><div><span>{{cover_contractor.type_person}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{cover_contractor.email}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Teléfono:</span><div><span>{{cover_contractor.phone_number}}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"cert_info.rec_antiguedad\"><span class=\"blue-color\">Antigüedad Certificado:</span><div><span>{{cert_info.rec_antiguedad | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Grupo: &nbsp;</span><div><span>{{cover_contractor.group}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Dirección</span><div><span>{{cover_contractor.direccion.route}} {{cover_contractor.direccion.street_number}}&nbsp;</span> <span ng-if=\"cover_contractor.direccion.street_number_int\">Int. {{cover_contractor.direccion.street_number_int}},</span> <span>{{cover_contractor.direccion.sublocality}},</span><br><span>{{cover_contractor.direccion.administrative_area_level_2}},</span> <span>{{cover_contractor.direccion.administrative_area_level_1}},</span> <span>CP. {{cover_contractor.direccion.postal_code}}</span></div></div></div><div class=\"col-xs-12 col-sm-6\" ng-if=\"!autos && !danios\"><legend class=\"legend-title\" align=\"center\">Información</legend><h4 class=\"col-xs-12\">Asegurado</h4><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Titular:</span><div><span ng-if=\"cert_info.datos.personal.full_name\">{{cert_info.datos.personal.full_name}}</span> <span ng-if=\"!cert_info.datos.personal.full_name\">{{cert_info.datos.personal.first_name}} {{cert_info.datos.personal.last_name}} {{cert_info.datos.personal.second_last_name}}</span></div><div class=\"col-xs-12 form-group\"><span ng-if=\"cert_info.datos.personal.email\"><span class=\"blue-color\" align=\"left\">Correo electrónico:</span>{{cert_info.datos.personal.email}}</span></div><div class=\"col-xs-12 form-group\" ng-if=\"cert_info.datos.personal.antiguedad\"><span class=\"blue-color\" align=\"left\">Antigüedad:</span><div><span>{{cert_info.datos.personal.antiguedad | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></div></div></div><h4 class=\"col-xs-12\" ng-if=\"cert_info.datos.beneficiaries_life\">Beneficiarios</h4><div class=\"col-xs-12 form-group\" ng-if=\"cert_info.datos.beneficiaries_life\"><div ng-repeat=\"item in cert_info.datos.beneficiaries_life\" ng-if=\"item.is_active == true\"><span>{{item.first_name}} {{item.last_name}} {{item.second_last_name}} - {{item.percentage}}%</span><div class=\"col-xs-12 form-group\" ng-if=\"item.antiguedad\"><span class=\"blue-color\" align=\"left\">Antigüedad:</span><div><span>{{item.antiguedad | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></div></div></div></div><h4 class=\"col-xs-12\" ng-if=\"cert_info.datos.relationship_accident\">Dependientes</h4><div class=\"col-xs-12 form-group\" ng-if=\"cert_info.datos.relationship_accident\"><div ng-repeat=\"item in cert_info.datos.relationship_accident\"><span>{{item.first_name}} {{item.last_name}} {{item.second_last_name}}</span><div class=\"col-xs-12 form-group\" ng-if=\"item.antiguedad\"><span class=\"blue-color\" align=\"left\">Antigüedad:</span><div><span>{{item.antiguedad | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></div></div></div></div></div><div class=\"col-xs-12 col-sm-6\" ng-if=\"autos\"><legend class=\"legend-title\" align=\"center\">Información</legend><h4 class=\"col-xs-12\">Flotillas</h4><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"cert_info.automobiles_policy[0].email\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{cert_info.automobiles_policy[0].email}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Marca:</span><div><span>{{cert_info.automobiles_policy[0].brand}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Modelo:</span><div><span>{{cert_info.automobiles_policy[0].model}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Año:</span><div><span>{{cert_info.automobiles_policy[0].year}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Versión:</span><div><span>{{cert_info.automobiles_policy[0].version}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Color:</span><div><span>{{cert_info.automobiles_policy[0].color}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Serie:</span><div><span>{{cert_info.automobiles_policy[0].serial}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Motor:</span><div><span>{{cert_info.automobiles_policy[0].engine}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Conductor:</span><div><span>{{cert_info.automobiles_policy[0].driver}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Beneficiario Preferente:</span><div><span>{{cert_info.automobiles_policy[0].preferential_benefiaciary}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"cert_info.automobiles_policy[0].beneficiary_address\"><span class=\"blue-color\">Dirección Beneficiario:</span><div><span>{{cert_info.automobiles_policy[0].beneficiary_address}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"cert_info.automobiles_policy[0].beneficiary_rfc\"><span class=\"blue-color\">RFC Beneficiario:</span><div><span>{{cert_info.automobiles_policy[0].beneficiary_rfc}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Matrícula:</span><div><span>{{cert_info.automobiles_policy[0].license_plates}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"cert_info.automobiles_policy[0].adjustment\"><span class=\"blue-color\">Adaptaciones:</span><div><span>{{cert_info.automobiles_policy[0].adjustment}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"cert_info.automobiles_policy[0].mont_adjustment\"><span class=\"blue-color\">Monto Adaptaciones:</span><div><span>{{cert_info.automobiles_policy[0].mont_adjustment}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"cert_info.automobiles_policy[0].special_team\"><span class=\"blue-color\">Equipamiento:</span><div><span>{{cert_info.automobiles_policy[0].special_team}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"cert_info.automobiles_policy[0].mont_special_team\"><span class=\"blue-color\">Monto Equipamiento:</span><div><span>{{cert_info.automobiles_policy[0].mont_special_team}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"cert_info.rec_antiguedad\"><span class=\"blue-color\">Antigüedad:</span><div><span>{{cert_info.rec_antiguedad | date: \'dd-MM-yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"cert_info.automobiles_policy[0].usage\"><span class=\"blue-color\">Uso:</span><div><span ng-if=\"cert_info.automobiles_policy[0].usage == \'1\'\">Particular</span> <span ng-if=\"cert_info.automobiles_policy[0].usage == \'2\'\">Carga</span> <span ng-if=\"cert_info.automobiles_policy[0].usage == \'3\'\">servicio Público</span> <span>&nbsp;</span></div></div></div><div class=\"col-xs-12 col-sm-6\" ng-if=\"danios\"><legend class=\"legend-title\" align=\"center\">Información</legend><h4 class=\"col-xs-12\">Ubicaciones</h4><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{cert_info.damages_policy[0].insured_item}}</span> <span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Dirección:</span><div><span>{{cert_info.damages_policy[0].item_address}}</span> <span>&nbsp;</span></div></div></div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Paquete: {{package_certificate.package_name}}</legend><div><table class=\"table table-bordered table-hover\"><thead><th>Cobertura</th><th>Suma Asegurada</th><th>Deducible</th></thead><tbody><tr ng-repeat=\"coverage in package_certificate.coverage_package\" ng-if=\"package_certificate.coverage_package.length\"><td>{{coverage.coverage_name}}</td><td>{{coverage.sums_coverage[0].sum_insured}}</td><td>{{coverage.deductible_coverage[0].deductible}}</td></tr></tbody></table></div></div><div class=\"col-xs-12\" ng-if=\"permiso_archivos\"><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(4, cert_info)\">Guardar Archivos</button></div></div><div class=\"col-xs-12 form-group\" ng-if=\"cert_info.files\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in cert_info.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"renameFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,cert_info.files)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td></tr></tbody></table></div></div></div></div><div class=\"col-xs-12 animate address_components\" ng-if=\"edit_certificate_data && !edit_certificate_data_autos\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"returnToCerts()\"><i class=\"fa fa-reply\"></i> Regresar</button></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número de Certificado:</label><div><input class=\"form-control\" type=\"text\" ng-model=\"cert_info.certificate_number\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Antigüedad:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"cert_info.rec_antiguedad\" value=\"{{cert_info.rec_antiguedad}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div><legend class=\"legend-title\" align=\"center\">Titular</legend><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Nombre:</label><div><input type=\"text\" ng-model=\"cert_info.datos.personal.first_name\" class=\"form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Apellido Paterno:</label><div><input type=\"text\" ng-model=\"cert_info.datos.personal.last_name\" class=\"form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Apellido Materno:</label><div><input type=\"text\" ng-model=\"cert_info.datos.personal.second_last_name\" class=\"form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de nacimiento:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"cert_info.datos.personal.birthdate\" value=\"{{cert_info.datos.personal.birthdate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Correo:</label><div><input type=\"email\" ng-model=\"cert_info.datos.personal.email\" class=\"form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Sexo:</label><select class=\"form-control\" ng-model=\"cert_info.datos.personal.sex\" ng-change=\"changeFCurrency()\" ng-options=\"item.value as item.name for item in sex\" required=\"\"><option value=\"\">Seleccione una opcion</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"cert_info.datos.beneficiaries_life\"><label>Sueldo:</label><div><input class=\"form-control\" type=\"text\" ng-model=\"cert_info.datos.personal.salary\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Antigüedad:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"cert_info.datos.personal.antiguedad\" value=\"{{cert_info.datos.personal.antiguedad}}\" data-date-format=\"dd/mm/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"cert_info.datos.beneficiaries_life\"><label>Suma asegurada:</label><div><input class=\"form-control\" type=\"text\" ng-model=\"cert_info.datos.personal.sum_assured\"></div></div><div ng-repeat=\"benef in cert_info.datos.beneficiaries_life\" ng-if=\"cert_info.datos.beneficiaries_life\"><legend class=\"legend-title col-xs-12\" align=\"center\">Beneficiario #{{ $index + 1 }}</legend><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Nombre:</label><div><input type=\"text\" ng-model=\"benef.first_name\" class=\"form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Apellido Paterno:</label><div><input type=\"text\" ng-model=\"benef.last_name\" class=\"form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Apellido Materno:</label><div><input type=\"text\" ng-model=\"benef.second_last_name\" class=\"form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" id=\"data_2\"><label>Fecha de nacimiento:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"benef.birthdate\" value=\"{{benef.birthdate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Sexo:</label><select class=\"form-control\" ng-model=\"benef.sex\" ng-change=\"changeFCurrency()\" ng-options=\"item.value as item.name for item in sex\" required=\"\"><option value=\"\">Seleccione una opcion</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Parentesco:</label><div><select class=\"form-control m-b\" ng-model=\"benef.optional_relationship\" ng-options=\"r.option for r in relation track by r.option\"><option value=\"\" disabled=\"\">Selecciona</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Porcentaje:</label><div><input type=\"text\" ng-model=\"benef.percentage\" class=\"form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Antigüedad:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"benef.antiguedad\" value=\"{{benef.antiguedad}}\" data-date-format=\"dd/mm/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div ng-repeat=\"benef in cert_info.datos.relationship_accident\" ng-if=\"cert_info.datos.relationship_accident\"><legend class=\"legend-title col-xs-12\" align=\"center\">Dependiente #{{ $index + 1 }}</legend><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Nombre:</label><div><input type=\"text\" ng-model=\"benef.first_name\" class=\"form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Apellido Paterno:</label><div><input type=\"text\" ng-model=\"benef.last_name\" class=\"form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Apellido Materno:</label><div><input type=\"text\" ng-model=\"benef.second_last_name\" class=\"form-control\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" id=\"data_2\"><label>Fecha de nacimiento:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"benef.birthdate\" value=\"{{benef.birthdate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Sexo:</label><select class=\"form-control\" ng-model=\"benef.sex\" ng-change=\"changeFCurrency()\" ng-options=\"item.value as item.name for item in sex\" required=\"\"><option value=\"\">Seleccione una opcion</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Parentesco:</label><div><select class=\"form-control m-b\" ng-model=\"benef.relationship\" ng-options=\"r.option for r in relation track by r.option\"><option value=\"\" disabled=\"\">Selecciona</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" id=\"data_3\"><label>Antigüedad:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"benef.antiguedad\" value=\"{{benef.antiguedad}}\" data-date-format=\"dd/mm/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\" ng-if=\"acceso_adm_pol\"><label class=\"col-xs-12 btn btn-primary\" ng-if=\"user.permiso.editar\" ng-click=\"updateCert(cert_info)\">Guardar</label></div></div><div class=\"col-md-12 animate address_components\" ng-if=\"edit_certificate_data_autos\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><label class=\"col-xs-12 btn btn-info\" ng-click=\"returnToCerts()\"><i class=\"fa fa-reply\"></i> Regresar</label></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número de Certificado:</label><div><input class=\"form-control\" type=\"text\" ng-model=\"cert_info.certificate_number\"></div></div></div><legend class=\"legend-title\" align=\"center\">Automóvil</legend><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Marca</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].brand\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Modelo</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].model\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Año</label><div><select class=\"form-control\" ng-options=\"item for item in car_years\" ng-model=\"cert_info.automobiles_policy[0].year\"><option disabled=\"\">Selecciona una opción</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Versión</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].version\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Color</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].color\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Serie</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].serial\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Motor</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].engine\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Conductor</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].driver\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Matrícula</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].license_plates\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Asegurado</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].beneficiary_name\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Beneficiario Preferente</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].preferential_benefiaciary\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Dirección del Beneficiario</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].beneficiary_address\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>RFC del Beneficiario</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].beneficiary_rfc\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Adaptaciones</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].adjustment\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Correo electrónico</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].email\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Monto Adaptaciones</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].mont_adjustment\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Equipamiento</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].special_team\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Monto Equipamiento</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].mont_special_team\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Servicio</label><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"cert_info.automobiles_policy[0].service\"></div></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"use\">Uso <span class=\"color-red\">*</span></label><select ng-model=\"cert_info.automobiles_policy[0].usage\" class=\"form-control\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una opción</option><option value=\"1\">PARTICULAR</option><option value=\"2\">CARGA</option><option value=\"3\">SERVICIO PÚBLICO</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"cert_info.automobiles_policy[0].usage == 2 || cert_info.automobiles_policy[0].usgae == \'2\'\"><label>Tipo de Carga</label><select class=\"form-control\" ng-options=\"type.id as type.name for type in charge_type\" ng-change=\"changeProc();\" name=\"charge_type\" ng-model=\"cert_info.automobiles_policy[0].charge_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"acceso_adm_pol\"><button class=\"col-xs-12 btn btn-primary\" ng-if=\"user.permiso.editar\" ng-click=\"updateCertCars(cert_info)\">Guardar</button></div></div></div></div><div class=\"col-xs-12 m-t\"><div class=\"col-xs-12 form-group\" ng-if=\"!loader\"><legend class=\"legend-title\" align=\"center\">Archivo Excel</legend><input type=\"file\" fileread=\"\" ng-model=\"excelFile\" name=\"readCsvFile\" id=\"readCsvFile\" ng-change=\"selectExcel(excelFile)\"><div class=\"form-group\"><label>Contenido del archivo</label></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"!id_tree\"><div id=\"tree_ids\" class=\"treeview\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><div id=\"tree\" class=\"treeview\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"config_saved.length\"><table class=\"table table-bordered table-hover\"><thead><th>Número de Paquete</th><th>Nombre</th></thead><tbody><tr ng-repeat=\"item in config_saved\"><td>{{item.id}}</td><td>{{item.package_name}}</td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\" ng-if=\"!loader\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"saveCertificados()\">Finalizar</button></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cogs fa-spin fa-5x\"></i><div><span>Espere unos minutos</span></div></div></div><div class=\"col-xs-12 m-t row\"><div class=\"col-xs-12 m-t\"><div class=\"col-xs-12 form-group\" ng-if=\"!loader_info\"><legend class=\"legend-title\" align=\"center\">Archivo Excel para Información adicional</legend><input type=\"file\" fileread=\"\" ng-model=\"excelFile\" name=\"readCsvFile\" id=\"readCsvFile\" ng-change=\"selectExcelInfoAdicional(excelFile)\"></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\" ng-if=\"!loader_info\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"saveInfoAdicional()\">Cargar Información Adicional</button></div><div class=\"col-xs-12 text-center\" ng-if=\"loader_info\"><i class=\"fa fa-cogs fa-spin fa-5x\"></i><div><span>Espere unos minutos</span></div></div></div></div></div></div></div></div><div ng-if=\"show_caratula\"><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"showHistoric\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Histórico renovaciones y cancelaciones</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div ng-if=\"!vm.show_binnacle_receipt\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th>Número de Póliza</th><th>Vigencia</th><th>Estatus</th><th>Fecha de Renovación</th><th>Renovado Por:</th></tr></thead><tbody><tr ng-repeat=\"policy in caratula_history track by $index\" ng-click=\"goToPolicy(policy)\"><td ng-if=\"policy.poliza_number\">{{policy.poliza_number}}</td><td ng-if=\"!policy.poliza_number\">Sin número asignado</td><td>{{ policy.start_of_validity | date: \'dd-MM-yyyy\' : \'UTC\'}} - {{ policy.end_of_validity | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td>{{status(policy.status)}}</td><td>{{policy.created_at | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td>{{policy.owner}}</td></tr></tbody></table></div></div></div></div></div><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"comments_data\" config=\"comments_config\" typemodel=\"1\" idmodel=\"polizaId\" exportable=\"true\"></comments></div></div></div></div></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"sinistersFlag\"><div class=\"ibox-title\"><h5>Siniestros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><a class=\"btn btn-info m-b\" ng-click=\"returnToInfo()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a><table class=\"table table-hover table-bordered\"><thead><th>Folio</th><th>Número de Siniestro</th><th>Fecha de Creación</th><th>Fecha de Emisión</th><th>Estatus</th><th>Tipo de pago</th></thead><tbody><tr ng-repeat=\"sinister in sinisters track by $index\" ng-click=\"infoSinister(sinister,caratula)\"><td>{{ sinister.folio_compania }}</td><td>{{ sinister.numero_siniestro }}</td><td>{{ sinister.fecha_siniestro | date: \'dd/MM/yyyy h:mm:ss a\': \'UTC\' }}</td><td>{{ sinister.fecha_ingreso | date: \'dd/MM/yyyy h:mm:ss a\' : \'UTC\'}}</td><td ng-if=\"sinister.status == 1\">Pendiente</td><td ng-if=\"sinister.status == 2\">En trámite</td><td ng-if=\"sinister.status == 3\">Completado</td><td ng-if=\"sinister.status == 4\">Cancelado</td><td ng-if=\"sinister.status == 5\">Rechazado</td><td>{{ tipo_pago(sinister.accidente_sinister[0].tipo_pago)}}</td></tr></tbody></table></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"endoFlag\"><div class=\"ibox-title\"><h5>Endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><a class=\"btn btn-info m-b\" ng-click=\"returnToInfo()\"><span class=\"fa fa-reply\"></span> Regresar</a><table class=\"table table-hover table-bordered\"><thead><th>Tipo</th><th>Número de endoso</th><th>Concepto</th><th>Descripción</th><th>Vigencia</th><th>Estatus</th><th>Historial</th></thead><tbody><tr ng-repeat=\"endorsement in endorsements track by $index\" ui-sref=\"endorsement.info({endosoId: endorsement.id})\"><td>{{ endorsement.endorsement_type }}</td><td ng-if=\"endorsement.number_endorsement\">{{ endorsement.number_endorsement }}</td><td ng-if=\"!endorsement.number_endorsement\">Sin número asigando</td><td>{{ concept(endorsement.concept) }}<span ng-if=\"concept(endorsement.concept) == \'OTRO\'\">:</span>{{endorsement.other_desc}}</td><td>{{ endorsement.observations}}</td><td>{{ endorsement.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ endorsement.end_date | date: \'dd/MM/yyyy\': \'UTC\' }}</td><td ng-if=\"endorsement.status == 1\">Pendiente</td><td ng-if=\"endorsement.status == 2\">Registrado</td><td ng-if=\"endorsement.status == 3\">Rechazado</td><td ng-if=\"endorsement.status == 5\">En trámite</td><td ng-if=\"endorsement.status == 4\">Cancelado</td><td ng-if=\"endorsement.migrated\">Sin historial</td><td ng-if=\"endorsement.status != 2\"></td><td ng-if=\"!endorsement.migrated && endorsement.status == 2\"><button class=\"btn btn-default\" style=\"color: grey\" ng-click=\"$event.stopPropagation(); showChange(endorsement)\"><i class=\"fa fa-retweet\">Ver cambios</i></button></td></tr></tbody></table></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"notasFlag\"><div class=\"ibox-title\"><h5>Notas de crédito</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"notasFlag = false; infoFlag = true; hideNotas()\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Folio</th><th>Número de Póliza/Fianza</th><th>Número de Endoso</th><th>Fecha de Inicio</th><th>Prima Total</th><th>Estatus</th></thead><tr ng-repeat=\"nota in notas_c track by $index\" ng-click=\"changeStatusModal(cover_contractor, nota)\"><td>{{ nota.folio }}</td><td>{{ nota.poliza.poliza_number }}{{nota.fianza.fianza_number}}</td><td>{{ nota.endorsement.number_endorsement }}</td><td>{{ nota.fecha_inicio | date: \'dd/MM/yyyy h:mm:ss a\' : \'UTC\'}}</td><td>{{ nota.prima_total | currency }}</td><td><span>{{ (nota.status) }}</span></td></tr></table></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"ajusteCaratula\" id=\"compensacionAdjust\"><div class=\"ibox-title\"><h5>Información de Ajuste Anual</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12\"><button class=\"btn btn-info m-b\" ng-click=\"ajusteCaratula = false; infoFlag = true; hideComp(true)\"><span class=\"fa fa-reply\"></span> Regresar</button></div><div class=\"col-xs-12\" id=\"exportable\"><table class=\"table table-bordered table-hover\"><thead><tr><th>No. Endoso</th><th>Tipo</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>IVA</th><th>Prima Total</th></tr></thead><tbody><tr ng-repeat=\"endosos in endorsement_history\"><td>{{ endosos.number_endorsement }}</td><td>{{ endosos.endorsement_type }}</td><td align=\"right\">{{ endosos.p_neta | currency }}</td><td align=\"right\">{{ endosos.rpf | currency }}</td><td align=\"right\">{{ endosos.derecho | currency }}</td><td align=\"right\">{{ endosos.iva | currency }}</td><td align=\"right\">{{ endosos.p_total | currency }}</td></tr></tbody><thead><tr><td><b>Totales</b></td><td></td><td align=\"right\">{{ ajuste_neta | currency }}</td><td align=\"right\">{{ ajuste_rpf | currency }}</td><td align=\"right\">{{ ajuste_derecho | currency }}</td><td align=\"right\">{{ ajuste_iva | currency }}</td><td align=\"right\">{{ ajuste_total | currency }}</td></tr></thead></table></div><div class=\"col-xs-12 form-group\"><button class=\"btn btn-primary\" ng-click=\"downloadExcelAdjustment()\">Descargar Excel</button></div></div></div><script type=\"text/javascript\">\n\n    function renombrarArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n\n      btnTag.addClass(\'display-none\');\n      dummy.removeClass(\'display-none\');\n\n\n      inputTag.removeClass(\'display-none\');\n      strongTag.addClass(\'display-none\');\n\n      inputTag.focus();\n    }\n\n    function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target);\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n\n      // btnTag.prop(\'onclick\',null).off(\'click\');\n\n      btnTag.removeClass(\'display-none\');\n      dummy.addClass(\'display-none\');\n\n\n      inputTag.addClass(\'display-none\');\n      strongTag.removeClass(\'display-none\');\n    }\n</script>");
$templateCache.put("app/colectividades/colectividades.renewal.html","<script>\n	$(\"#wizard\").steps({\n	onStepChanging: function(event, currentIndex, newIndex) {\n		if(angular.element(document.getElementById(\'wizard\')).scope().type_ren != 1){\n	        if(currentIndex == 0){\n	        	if(angular.element(document.getElementById(\'wizard\')).scope().caratula.poliza_number){\n		        	if(angular.element(document.getElementById(\'wizard\')).scope().caratula.identifier){\n		        		// if(angular.element(document.getElementById(\'wizard\')).scope().dataToSave.recibos_poliza){\n		        		if((angular.element(document.getElementById(\'wizard\')).scope().dataToSave.recibos_poliza) && (angular.element(document.getElementById(\'wizard\')).scope().receits_on_cover)){\n		        			angular.element(document.getElementById(\'wizard\')).scope().saveCaratulaRenovacion();   \n		        			return true;\n		        		// } else {\n		        		}else if(!(angular.element(document.getElementById(\'wizard\')).scope().receits_on_cover)){\n		        			angular.element(document.getElementById(\'wizard\')).scope().saveCaratulaRenovacion();   \n		        			return true;\n		        		} else if((angular.element(document.getElementById(\'wizard\')).scope().receits_on_cover)){\n		        			angular.element(document.getElementById(\'wizard\')).scope().alertP(3);\n		        			return false;\n		        		}\n		        	} else {\n		        		angular.element(document.getElementById(\'wizard\')).scope().alertP(2);\n		        		return false;\n		        	}\n	        	} else {\n		        	angular.element(document.getElementById(\'wizard\')).scope().alertP(1);\n	        		return false;\n	        	}\n	        } else if(currentIndex == 1){\n	        	if(angular.element(document.getElementById(\'wizard\')).scope().subgroupDone){\n	        		return true;\n	        	} else {\n	        		return false;\n	        	}\n	        } else if(currentIndex == 2){\n	        	if(angular.element(document.getElementById(\'wizard\')).scope().categoryDone){\n	        		return true;\n	        	} else {\n	        		return false;\n	        	}\n	        } else if(currentIndex == 3){\n	        	return true;\n	        } else if(currentIndex == 4){\n	        	return true;\n	        }\n		}\n		else{\n			 if(currentIndex == 0){\n		        if(angular.element(document.getElementById(\'wizard\')).scope().caratula.identifier){\n		        	angular.element(document.getElementById(\'wizard\')).scope().saveOTRenovacion();   \n		        	return true;\n		        } else {\n		        	angular.element(document.getElementById(\'wizard\')).scope().alertP(2);\n		        	return false;\n		        }\n	        } else if(currentIndex == 1){\n	        	if(angular.element(document.getElementById(\'wizard\')).scope().subgroupDone){\n	        		return true;\n	        	} else {\n	        		return false;\n	        	}\n	        } else if(currentIndex == 2){\n	        	if(angular.element(document.getElementById(\'wizard\')).scope().categoryDone){\n	        		return true;\n	        	} else {\n	        		return false;\n	        	}\n	        } else if(currentIndex == 3){\n	        	return true;\n	        } else if(currentIndex == 4){\n	        	return true;\n	        }\n		}\n    },\n    onFinished: function() {\n    	angular.element(document.getElementById(\'wizard\')).scope().goToList(); \n    }\n    });\n</script><div><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-lg-9\"><h2>Colectividades</h2></div><div class=\"col-xs-12\"><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"polizas.table\">Colectividades</a></li><li><a ui-sref=\"colectividades.info({polizaId: caratula.id})\">Colectividad #{{caratula.poliza_number}}</a></li><li><strong>Renovación colectividad #{{caratula.poliza_number}}</strong></li></ol></div></div><div id=\"wizard\" class=\"no-padding margin-top-15\"><h1>Carátula</h1><div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Folio interno:</label><div><input type=\"text\" class=\"form-control\" ng-model=\"caratula.internal_number\" disabled=\"\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Folio:</label><div><input type=\"text\" class=\"form-control\" ng-model=\"caratula.folio\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"type_ren != 1\"><label>Número de póliza: <span class=\"color-red\">*</span></label><div><input type=\"text\" class=\"form-control\" ng-model=\"caratula.poliza_number\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador: <span class=\"color-red\">*</span></label><div><input type=\"text\" class=\"form-control\" ng-model=\"caratula.identifier\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label ng-if=\"caratula.natural\">Contratante <span class=\"color-red\">*</span></label> <label ng-if=\"caratula.juridical\">Razón social</label><div ng-if=\"caratula.natural\"><input type=\"text\" class=\"form-control\" ng-model=\"cover_contractor.full_name\"></div><div ng-if=\"caratula.juridical\"><input type=\"text\" class=\"form-control\" ng-model=\"cover_contractor.j_name\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo electrónico:</label><div><input type=\"email\" class=\"form-control\" ng-model=\"cover_contractor.email\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono:</label><div><input type=\"text\" class=\"form-control\" ng-model=\"cover_contractor.phone_number\"></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia</label><div class=\"datepicker-me input-group date\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"caratula.start_of_validity\" value=\"{{caratula.start_of_validity}}\" ng-change=\"checkDate()\" data-date-format=\"dd/mm/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>al</label><div class=\"datepicker-me input-group date\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" id=\"endingDate\" data-provide=\"datepicker\" ng-model=\"caratula.end_of_validity\" value=\"{{caratula.end_of_validity}}\" ng-change=\"checkDate()\" data-date-format=\"dd/mm/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=\"text-center\">Aseguradora<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.aseguradora.$invalid && !caratula_form.aseguradora.$pristine }\"><select class=\"form-control\" data-ng-options=\"aseguradora.alias for aseguradora in providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"aseguradoraSelection()\" name=\"aseguradora\" ng-model=\"caratula.aseguradora\" ng-disabled=\"!cover_contractor\" required=\"\"><option value=\"\">Selecciona un proveedor</option></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Clave de agente<span class=\"color-red\">*</span></label><div ng-if=\"!claves.length\" ng-class=\"{ \'has-error\': caratula_form.clave.$invalid && !caratula_form.clave.$pristine }\"><input type=\"text\" name=\"clave\" placeholder=\"No hay ninguna clave para esta aseguradora\" class=\"form-control\" disabled=\"\"></div><div ng-class=\"{ \'has-error\': caratula_form.clave1.$invalid && !caratula_form.clave1.$pristine }\"><select ng-if=\"claves.length\" class=\"form-control\" data-ng-options=\"clave as clave.clave +\' - \'+clave.name for clave in claves | orderBy: \'clave\' track by clave.url\" ng-change=\"changeClave(clave)\" name=\"clave1\" ng-model=\"caratula.clave\" ng-disabled=\"!caratula.aseguradora\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Ramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.ramo.$invalid && !caratula_form.ramo.$pristine }\"><select class=\"form-control\" data-ng-options=\"ramo.ramo_name for ramo in ramos track by ramo.url\" ng-change=\"changeRamo()\" name=\"ramo\" ng-model=\"caratula.ramo\" ng-disabled=\"!caratula.aseguradora\" required=\"\"><option value=\"\">Selecciona un ramo</option></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Subramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.subramo.$invalid && !caratula_form.subramo.$pristine }\"><select class=\"form-control\" data-ng-options=\"subramo.subramo_name for subramo in subramos track by subramo.url\" ng-change=\"changeSubramo()\" name=\"subramo\" ng-model=\"caratula.subramo\" ng-disabled=\"!caratula.ramo\" required=\"\"><option value=\"\">Selecciona un subramo</option></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Renovable<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.renewal.$invalid && !form.renewal.$pristine }\"><select class=\"form-control\" ng-options=\"renewal.value as renewal.label for renewal in order.renewal.options\" ng-change=\"renewalSelection()\" name=\"renewal\" ng-model=\"order.renewal.selected\" required=\"\"></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Tipo de administración<span class=\"color-red\">*</span></label><div><select class=\"form-control\" ng-change=\"changeAdminType()\" name=\"adminType\" ng-model=\"order.adminType\" required=\"\"><option value=\"\">Selecciona un tipo de administración</option><option value=\"Autoadministrada\">Autoadministrada</option><option value=\"Simplificada\">Simplificada</option><option value=\"Detallada\">Detallada</option></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label class=\"text-center\">Moneda</label><div><input type=\"text\" class=\"form-control\" ng-model=\"caratula.f_currency\"></div></div><div class=\"col-xs-12\"><label>Frecuencia de pago<span class=\"color-red\">*</span></label></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-2\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.form.payment\" type=\"radio\" value=\"1\"> MENSUAL</label></div></div><div class=\"col-xs-12 col-sm-2\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment\" value=\"2\"> BIMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-2\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment\" value=\"3\"> TRIMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-2\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment\" value=\"6\"> SEMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-2\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment\" value=\"12\"> ANUAL</label></div></div><div class=\"col-xs-12 col-sm-2\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.form.payment\" type=\"radio\" value=\"5\"> CONTADO</label></div></div></div><div class=\"col-xs-12 col-sm-7 col-md-5 form-group\"><label>Referenciadores</label><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in referenciadores\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteReferenciador($index, item)\" ng-disabled=\"referenciadores.length <= 1 || item.vendor\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b col-xs-12\" name=\"referenciador_policy\" ng-model=\"item.referenciador\" ng-change=\"changeReferenciador(item)\" ng-options=\"referenciador_policy.url as referenciador_policy.first_name + \' \' + referenciador_policy.last_name for referenciador_policy in referenciador\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\" ng-init=\"referenciadores[$index].resp_type = 0\"><input class=\"form-control m-b col-xs-12 wb102\" type=\"text\" name=\"\" placeholder=\"% Comisión\" ng-model=\"item.comision_vendedor\" ng-disabled=\"referenciadores.length <= 1\" ng-change=\"changeComRef(item)\" required=\"\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button> <a ng-disabled=\"!item.referenciador\" ng-show=\"item.selectedRef && referenciadores.length > 1 && order.poliza.primaTotal\" class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); calculateComision(item, $index)\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i></a></div></div></div></div><div class=\"col-xs-12 form-group\"><label>Observaciones:</label><div><textarea type=\"text\" class=\"form-control\" ng-model=\"caratula.observations\"></textarea></div></div></div><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Selecciona correctamente donde quieres que se creen los recibos.</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><div class=\"radio\"><label class=\"pull-right\" ng-class=\"{\'receipts-select\': receipts_option == \'on_cover\'}\"><input type=\"radio\" ng-model=\"receipts_option\" value=\"on_cover\" ng-change=\"selectReceiptsOption(receipts_option)\"> Crear recibos por póliza</label></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><div class=\"radio\"><label ng-class=\"{\'receipts-select\': receipts_option == \'on_subgroup\'}\"><input type=\"radio\" ng-model=\"receipts_option\" value=\"on_subgroup\" ng-change=\"selectReceiptsOption(receipts_option)\"> Crear recibos por subgrupo (Diferentes Razones Sociales para Facturación)</label></div></div><div class=\"col-xs-12\" ng-if=\"generate_receipts_policy == true && type_ren != 1 && (receits_on_cover)\"><calculate-receipts poliza=\"order.poliza\" form=\"order.form\" tosave=\"dataToSave\" type=\"1\"></calculate-receipts></div></div><h1>Subgrupos</h1><div><div ng-include=\"\'app/colectividades/templates/subgroups.html\'\"></div></div><h1>Categorias</h1><div><div ng-include=\"\'app/colectividades/templates/categories.html\'\"></div></div><h1>Paquetes</h1><div><div ng-include=\"\'app/colectividades/templates/paquetes.html\'\"></div></div><h1>Certificados</h1><div><div ng-include=\"\'app/colectividades/templates/certificados.html\'\"></div></div></div><br><br></div>");
$templateCache.put("app/colectividades/colectividades.subir-masivos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-lg-9\"><h2>Archivos Masivos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"polizas.table\">Grupo de Pólizas</a></li><li class=\"active\"><strong>Cargar Archivos a Certificados</strong></li></ol></div></div><br><div class=\"row\" ng-if=\"showCertificates\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Carga masiva de PDFs a Certificados (TRADICIONAL)</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!foo.file_loaded\"><label class=\"col-xs-12 btn btn-success\">Agregar Layout <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"selectExcel(excelFile)\"></label></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\" ng-if=\"foo.file_loaded && foo.boton_guardar == true\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivos individuales<i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input multiple=\"\" nv-file-select=\"\" ng-click=\"selGralFiles(false)\" type=\"file\" name=\"xyz\" uploader=\"uploader\" class=\"display-none\"></label></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\" ng-if=\"foo.file_loaded && foo.boton_guardar == true\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivos generales<i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"col-xs-12 form-control\" type=\"file\" ng-click=\"selGralFiles(true)\" onchange=\"angular.element(this).scope().addFile(\'arch\',this.files)\" ng-model=\"vm.b_super\"></label></div></div><div class=\"row\" ng-if=\"foo.loader\"><div class=\"col-xs-12 form-group container-loader\"><img src=\"../../assets/images/loader/bar_loader.gif\"></div></div><div class=\"row\"><div ng-if=\"foo.elementos_incompletos && foo.elementos_incompletos.length > 0\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 btn btn-warning\"><b>Esta lista contiene los registros a los que no se cargaron archivos</b></div><table class=\"table table-bordered table-hover\"><thead><th>No. Póliza</th><th>Identificador</th><th>No. Certificado</th><th>ID Categoría</th><th>Nombre del Archivo</th><th>Certificado Encontrado</th><th>Archivo Encontrado</th><th>Estatus</th></thead><tbody><tr ng-repeat=\"item in foo.elementos_incompletos; track by $index\"><td>{{ item[\'Número de Póliza\'] }}</td><td>{{ item[\'Identificador\'] }}</td><td>{{ item[\'Certificado (SAAM)\'] }}</td><td>{{ item[\'ID Categoria SAAM\'] }}</td><td>{{ item[\'NOMBRE DEL ARCHIVO PDF (CERTIFICADO INDIVIDUAL)\'] }}</td><td style=\"text-align: center;\"><span ng-if=\"!item.cert\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.cert\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.file\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.file\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span class=\"label label-warning\">No cargado</span></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><span>Registros fallidos: <b>{{ foo.elementos_incompletos.length }}</b></span></div></div></div><div class=\"row\"><div ng-if=\"foo.elementos && foo.elementos.length > 0 && foo.loader == false\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 btn btn-info\"><b>Archivos encontrados y cargados</b></div><table class=\"table table-bordered table-hover\"><thead><th>No. Póliza</th><th>Identificador</th><th>No. Certificado</th><th>ID Categoría</th><th>Nombre del Archivo</th><th>Certificado Encontrado</th><th>Archivo Encontrado</th><th>Estatus</th></thead><tbody><tr ng-repeat=\"item in foo.elementos; track by $index\"><td>{{ item[\'Número de Póliza\'] }}</td><td>{{ item[\'Identificador\'] }}</td><td>{{ item[\'Certificado (SAAM)\'] }}</td><td>{{ item[\'ID Categoria SAAM\'] }}</td><td>{{ item[\'NOMBRE DEL ARCHIVO PDF (CERTIFICADO INDIVIDUAL)\'] }}</td><td style=\"text-align: center;\"><span ng-if=\"!item.cert\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.cert\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.file\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.file\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.id\" class=\"label label-warning\">Por cargar</span> <span ng-if=\"item.id\" class=\"label label-info\">Cargado</span></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><span>Total de registros del layout: <b>{{ foo.elementos.length }}</b></span><br><span ng-if=\"foo.boton_guardar == true\">Archivos encontrados: <b>{{ foo.archivos_encontrados }}</b></span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"saveFiles()\" ng-if=\"foo.boton_guardar == true\">Cargar archivos <i class=\"fa fa-download\" aria-hidden=\"true\"></i></button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"showPolicies\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Carga masiva de PDFs a Pólizas Individuales de Colectividad (TRADICIONAL)</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!foo.file_loaded\"><label class=\"col-xs-12 btn btn-success\">Agregar Layout <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"selectExcelPolicy(excelFile)\"></label></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\" ng-if=\"foo.file_loaded && foo.boton_guardar == true\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivos <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input multiple=\"\" nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploader\" class=\"display-none\"></label></div></div><div class=\"row\" ng-if=\"foo.loader\"><div class=\"col-xs-12 form-group container-loader\"><img src=\"../../assets/images/loader/bar_loader.gif\"></div></div><div class=\"row\"><div ng-if=\"foo.elementos_incompletos && foo.elementos_incompletos.length > 0\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 btn btn-warning\"><b>Esta lista contiene los registros a los que no se cargaron archivos</b></div><table class=\"table table-bordered table-hover\"><thead><th>No. Cáratula</th><th>No. Poliza</th><th>Nombre del Archivo</th><th>Certificado Encontrado</th><th>Archivo Encontrado</th><th>Estatus</th></thead><tbody><tr ng-repeat=\"item in foo.elementos_incompletos; track by $index\"><td>{{ item[\'Número de Póliza\'] }}</td><td>{{ item[\'Certificado (SAAM)\'] }}</td><td>{{ item[\'NOMBRE DEL ARCHIVO PDF (CERTIFICADO INDIVIDUAL)\'] }}</td><td style=\"text-align: center;\"><span ng-if=\"!item.polizacaratula\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.polizacaratula\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.file\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.file\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span class=\"label label-warning\">No cargado</span></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><span>Registros fallidos: <b>{{ foo.elementos_incompletos.length }}</b></span></div></div></div><div class=\"row\"><div ng-if=\"foo.elementos && foo.elementos.length > 0 && foo.loader == false\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 btn btn-info\"><b>Archivos encontrados y cargados</b></div><table class=\"table table-bordered table-hover\"><thead><th>No. Carátula</th><th>No. Póliza</th><th>Nombre del Archivo</th><th>Certificado Encontrado</th><th>Archivo Encontrado</th><th>Estatus</th></thead><tbody><tr ng-repeat=\"item in foo.elementos; track by $index\"><td>{{ item[\'Número de Póliza\'] }}</td><td>{{ item[\'Certificado (SAAM)\'] }}</td><td>{{ item[\'NOMBRE DEL ARCHIVO PDF (CERTIFICADO INDIVIDUAL)\'] }}</td><td style=\"text-align: center;\"><span ng-if=\"!item.polizacaratula\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.polizacaratula\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.file\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.file\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.id\" class=\"label label-warning\">Por cargar</span> <span ng-if=\"item.id\" class=\"label label-info\">Cargado</span></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><span>Total de registros del layout: <b>{{ foo.elementos.length }}</b></span><br><span ng-if=\"foo.boton_guardar == true\">Archivos encontrados: <b>{{ foo.archivos_encontrados }}</b></span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"saveFilesPolicy()\" ng-if=\"foo.boton_guardar == true\">Cargar archivos <i class=\"fa fa-download\" aria-hidden=\"true\"></i></button></div></div></div></div></div></div></div><script type=\"text/javascript\">\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target);\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    // btnTag.prop(\'onclick\',null).off(\'click\');\n\n    btnTag.removeClass(\'display-none\');\n    dummy.addClass(\'display-none\');\n\n\n    inputTag.addClass(\'display-none\');\n    strongTag.removeClass(\'display-none\');\n  }\n</script><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Carga masiva de PDFs a Certificados por ID</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!foo.file_loaded_by_id\"><label class=\"col-xs-12 btn btn-success\">Agregar Layout <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"selectExcelPolicyById(excelFile)\"></label></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\" ng-if=\"foo.file_loaded_by_id && foo.boton_guardar == true\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivos <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input multiple=\"\" nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploader\" class=\"display-none\"></label></div></div><div class=\"row\" ng-if=\"foo.loader_by_id\"><div class=\"col-xs-12 form-group container-loader\"><img src=\"../../assets/images/loader/bar_loader.gif\"></div></div><div class=\"row\"><div ng-if=\"foo.elementos_by_id && foo.elementos_by_id.length > 0 && foo.loader_by_id == false\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 btn btn-info\"><b>Archivos encontrados y cargados</b></div><table class=\"table table-bordered table-hover\"><thead><th>ID</th><th>Nombre del Archivo</th><th>Certificado Encontrado</th><th>Archivo Encontrado</th><th>Estatus</th></thead><tbody><tr ng-repeat=\"item in foo.elementos_by_id; track by $index\"><td>{{ item[\'ID CERTIFICADO\'] }}{{ item[\'ID POLIZA\'] }}</td><td>{{item[\'NOMBRE DEL ADJUNTO PDF (CERTIFICADO INDIVIDUAL)\']}}{{item[\'NOMBRE DEL ARCHIVO PDF (CERTIFICADO INDIVIDUAL)\']}}</td><td style=\"text-align: center;\"><span ng-if=\"!item.cert\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.cert\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.file\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.file\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.isUploaded && !item.isError\" class=\"label label-warning\">No cargado</span> <span ng-if=\"item.isUploaded\" class=\"label label-info\">Cargado</span> <span ng-if=\"item.isError\" class=\"label label-danger\">Error</span></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><span>Total de registros del layout: <b>{{ foo.elementos_by_id.length }}</b></span><br><span ng-if=\"foo.boton_guardar == true\">Archivos encontrados: <b>{{ foo.archivos_encontrados_by_id }}</b></span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button ng-if=\"foo.boton_por_id_habilitado\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"saveFilesCerts()\">Cargar archivos <i class=\"fa fa-download\" aria-hidden=\"true\"></i></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Carga masiva de PDFs a Pólizas por ID</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!foo.file_polizas_loaded_by_id\"><label class=\"col-xs-12 btn btn-success\">Agregar Layout <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"selectExcelPolizaIndById(excelFile)\"></label></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\" ng-if=\"foo.file_polizas_loaded_by_id && foo.boton_guardar == true\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivos <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input multiple=\"\" nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploader\" class=\"display-none\"></label></div></div><div class=\"row\" ng-if=\"foo.loader_by_id\"><div class=\"col-xs-12 form-group container-loader\"><img src=\"../../assets/images/loader/bar_loader.gif\"></div></div><div class=\"row\"><div ng-if=\"foo.elementos_polizas_by_id && foo.elementos_polizas_by_id.length > 0 && foo.loader_by_id == false\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 btn btn-info\"><b>Archivos encontrados y cargados</b></div><table class=\"table table-bordered table-hover\"><thead><th>ID</th><th>Nombre del Archivo</th><th>Póliza Encontrada</th><th>Archivo Encontrado</th><th>Estatus</th></thead><tbody><tr ng-repeat=\"item in foo.elementos_polizas_by_id; track by $index\"><td>{{ item[\'ID CERTIFICADO\'] }}{{ item[\'ID POLIZA\'] }}</td><td>{{ item[\'NOMBRE DEL ARCHIVO PDF (CERTIFICADO INDIVIDUAL)\'] }}{{item[\'NOMBRE DEL ARCHIVO PDF\']}}</td><td style=\"text-align: center;\"><span ng-if=\"!item.cert\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.cert\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.file\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.file\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.isUploaded && !item.isError\" class=\"label label-warning\">No cargado</span> <span ng-if=\"item.isUploaded\" class=\"label label-info\">Cargado</span> <span ng-if=\"item.isError\" class=\"label label-danger\">Error</span></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><span>Total de registros del layout: <b>{{ foo.elementos_polizas_by_id.length }}</b></span><br><span ng-if=\"foo.boton_guardar == true\">Archivos encontrados: <b>{{ foo.archivos_encontrados_by_id }}</b></span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button ng-if=\"foo.boton_por_id_habilitado\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"saveFilesPolizas()\">Cargar archivos <i class=\"fa fa-download\" aria-hidden=\"true\"></i></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Carga masiva de PDFs a Recibos por ID</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!foo.file_receipts_loaded_by_id\"><label class=\"col-xs-12 btn btn-success\">Agregar Layout <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"selectExcelReceiptById(excelFile)\"></label></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\" ng-if=\"foo.file_receipts_loaded_by_id && foo.boton_por_id_habilitado == true\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivos <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input multiple=\"\" nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploader\" class=\"display-none\"></label></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\" ng-if=\"foo.file_receipts_loaded_by_id && foo.boton_por_id_habilitado == true\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivos generales Recibos<i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"col-xs-12 form-control\" type=\"file\" ng-click=\"selGralFilesReceipts(true)\" onchange=\"angular.element(this).scope().addFileReceipts(\'arch\',this.files)\" ng-model=\"vm.b_super_receipts\"></label></div></div><div class=\"row\" ng-if=\"foo.loader_by_id\"><div class=\"col-xs-12 form-group container-loader\"><img src=\"../../assets/images/loader/bar_loader.gif\"></div></div><div class=\"row\"><div ng-if=\"foo.elementos_receipt_by_id && foo.elementos_receipt_by_id.length > 0 && foo.loader_by_id == false\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 btn btn-info\"><b>Archivos encontrados y cargados</b></div><table class=\"table table-bordered table-hover\"><thead><th>ID</th><th>Nombre del Archivo</th><th>Recibo Encontrado</th><th>Archivo Encontrado</th><th>Estatus</th></thead><tbody><tr ng-repeat=\"item in foo.elementos_receipt_by_id; track by $index\"><td>{{ item[\'ID RECIBO\'] }}</td><td>{{ item[\'NOMBRE DEL ARCHIVO PDF\'] }}</td><td style=\"text-align: center;\"><span ng-if=\"!item.recibo\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.recibo\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.file\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.file\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.isUploaded && !item.isError\" class=\"label label-warning\">No cargado</span> <span ng-if=\"item.isUploaded\" class=\"label label-info\">Cargado</span> <span ng-if=\"item.isError\" class=\"label label-danger\">Error</span></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><span>Total de registros del layout: <b>{{ foo.elementos_receipt_by_id.length }}</b></span><br><span ng-if=\"foo.boton_guardar == true\">Archivos encontrados: <b>{{ foo.archivos_encontrados_by_id }}</b></span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button ng-if=\"foo.boton_por_id_habilitado\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"saveFilesReceipts()\">Cargar archivos <i class=\"fa fa-download\" aria-hidden=\"true\"></i></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Carga masiva de PDFs a Contratantes por ID</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!foo.file_contractors_loaded_by_id\"><label class=\"col-xs-12 btn btn-success\">Agregar Layout <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"selectExcelContractortById(excelFile)\"></label></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\" ng-if=\"foo.file_contractors_loaded_by_id && foo.boton_por_id_habilitado == true\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivos <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input multiple=\"\" nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploader\" class=\"display-none\"></label></div></div><div class=\"row\" ng-if=\"foo.loader_by_id\"><div class=\"col-xs-12 form-group container-loader\"><img src=\"../../assets/images/loader/bar_loader.gif\"></div></div><div class=\"row\"><div ng-if=\"foo.elementos_contractor_by_id && foo.elementos_contractor_by_id.length > 0 && foo.loader_by_id == false\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 btn btn-info\"><b>Archivos encontrados y cargados</b></div><table class=\"table table-bordered table-hover\"><thead><th>ID</th><th>Nombre del Archivo</th><th>Recibo Encontrado</th><th>Archivo Encontrado</th><th>Estatus</th></thead><tbody><tr ng-repeat=\"item in foo.elementos_contractor_by_id; track by $index\"><td>{{ item[\'ID CONTRATANTE\'] }}</td><td>{{ item[\'NOMBRE DEL ARCHIVO PDF\'] }}</td><td style=\"text-align: center;\"><span ng-if=\"!item.contratante\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.contratante\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.file\" class=\"label label-warning\">No Encontrado</span> <span ng-if=\"item.file\" class=\"label label-info\">Encontrado</span></td><td style=\"text-align: center;\"><span ng-if=\"!item.isUploaded && !item.isError\" class=\"label label-warning\">No cargado</span> <span ng-if=\"item.isUploaded\" class=\"label label-info\">Cargado</span> <span ng-if=\"item.isError\" class=\"label label-danger\">Error</span></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><span>Total de registros del layout: <b>{{ foo.elementos_contractor_by_id.length }}</b></span><br><span ng-if=\"foo.boton_guardar == true\">Archivos encontrados: <b>{{ foo.archivos_encontrados_by_id }}</b></span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button ng-if=\"foo.boton_por_id_habilitado\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"saveFilesContractors()\">Cargar archivos <i class=\"fa fa-download\" aria-hidden=\"true\"></i></button></div></div></div></div></div></div></div><style type=\"text/css\">\n  input[type=\"file\"] {\n    display: none;\n  }\n  .custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    color: blue\n  }\n</style>");
$templateCache.put("app/colectividades/colectividades.table.html","<div><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-12\"><h2>Colectividades</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"index.main\">Inicio</a></li><li><strong class=\"active\">Lista de Colectividades</strong></li></ol></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title title-colapsable\"><h5>COLECTIVIDADES</h5></div><div class=\"ibox-content wizard\"><table class=\"table footable table-stripped\" ng-if=\"!show_binnacle\"><thead><th>Identificador</th><th>Contratante</th><th>Aseguradora</th><th>Ramo</th><th>Subramo</th><th>Creación</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"item in covers | orderBy: \'created_at\'\" ng-click=\"coverSelected(item)\"><td>{{ item.identifier }}</td><td ng-if=\"item.natural\">{{item.natural.full_name}}</td><td ng-if=\"item.juridical\">{{item.juridical.j_name}}</td><td ng-if=\"!item.juridical && !item.natural\"></td><td>{{ item.aseguradora }}</td><td>{{ item.ramo.ramo_name }}</td><td>{{ item.subramo.subramo_name }}</td><td>{{ item.created_at | date: dd/MM/yyyy}}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); showBinnacle(item)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table></div><div ng-if=\"show_pagination && !show_binnacle\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div><div class=\"row animate\" ng-if=\"show_binnacle\"><div class=\"col-md-12\"><div class=\"col-md-12\"><button class=\"btn btn-info pull-right\" ng-click=\"returnToColectiv(1)\"><span class=\"fa fa-arrow-left\"></span> Regresar</button></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"comments_data\" typemodel=\"1\" config=\"comments_config\" idmodel=\"item_id\"></comments></div></div></div></div></div></div></div>");
$templateCache.put("app/colectividades/pago_parcial.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Pagar certificado</h4></div><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-repeat=\"error in errors\">{{error}}</div><div class=\"row col-xs-12 col-sm-12 form-group pull-right\"><div class=\"col-xs-12\"><label>Recibos pendientes de la colectividad:</label><ul><li ng-if=\"recibo.status != \'Pagado\' && recibo.status != 1\" ng-repeat=\"recibo in receipts track by $index\">{{recibo.recibo_numero}} : ${{recibo.prima_total}}</li></ul></div></div><div class=\"col-xs-6 form-group\"><label>Cantidad pago parcial ($)<span class=\"color-red\">*</span></label> <input class=\"form-control col-xs-12\" type=\"number\" ng-model=\"vm.cantidad_pago_parcial\"></div><div class=\"col-xs-6 form-group\"><div class=\"col-xs-12 col-md-12 form-group\"><label>Forma de Pago<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"pago\" ng-change=\"changedPago(pago, 1)\" ng-options=\"pago as pago.label for pago in statusPayform track by pago.value\" ng-disabled=\"status.value == 6\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona una forma de pago</option></select></div></div><div class=\"row col-xs-6 form-group\"><div class=\"col-xs-12 col-sm-12 form-group\"><label>Documento de pago<span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.folio_pay\" type=\"text\"></div></div><div class=\"col-xs-6 col-sm-6 form-group pull-right\"><div class=\"col-xs-12\"><label>Fecha de pago<span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.pago_date\" value=\"{{vm.pago_date}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"row col-xs-12 col-sm-12 form-group pull-right\"><div class=\"col-xs-8\"><label>Certificados a pagar</label><ul><li ng-repeat=\"cert in certificados_a_pagar track by $index\">{{cert.certificate_number}} | Prima total : {{cert.p_total | currency}} <i ng-click=\"remove_item(cert)\" class=\"fa fa-times\"></i></li></ul></div><div class=\"col-xs-4\"><label>Suma de prima total de certificados</label><ul><li>{{total_a_pagar | currency}}</li></ul></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"add_more()\">Agregar más certificados al pago</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Pagar</button></div></div>");
$templateCache.put("app/colectividades/receipt.modal.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Actualizar Recibo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><h3>Estatus actual:</h3><div ng-bind=\"rec.recibo.status | receipts\" class=\"label\" ng-class=\"{\'label-success\': rec.recibo.status == 1 || rec.recibo.status == 5, \'label-danger\': rec.recibo.status == 2, \'label-warning\' : rec.recibo.status == 3 || rec.recibo.status == 4, \'label-default\': rec.recibo.status == 6 || rec.receipt.status == 7 || rec.recibo.status == 8}\"></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Número de Recibo</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.recibo_numero\" name=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Inicio Vigencia</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"rec.recibo.fecha_inicio\" value=\"{{rec.recibo.fecha_inicio}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fin Vigencia</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"rec.recibo.fecha_fin\" value=\"{{rec.recibo.fecha_fin}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Prima Neta</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.prima_neta\" ng-change=\"validateDecimal(rec.recibo.prima_neta); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>RPF</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.rpf\" ng-change=\"validateDecimal(rec.recibo.rpf); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Derecho</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.derecho\" ng-change=\"validateDecimal(rec.recibo.derecho); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>IVA</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.iva\" ng-change=\"validateDecimal(rec.recibo.iva); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Comisión</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.comision\" ng-change=\"validateDecimal(rec.recibo.comision); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Vencimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"rec.recibo.vencimiento\" value=\"{{rec.recibo.vencimiento}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Subtotal</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.sub_total\" name=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Prima Total</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.prima_total\" name=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Entregado</label> <input class=\"form-control\" type=\"checkbox\" ng-model=\"rec.recibo.delivered\" name=\"\"></div><div class=\"col-xs-12\" ng-if=\"rec.recibo.receipt_type == 3\"><label>Las cantidades en las notas de crédito tienen que ir con valores negativos.</label></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"saveReceipt(rec.recibo)\">Guardar Cambios</button></div></div>");
$templateCache.put("app/colectivos/certificados.html","<toaster-container></toaster-container><div class=\"row\"><br><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Certificados</legend></div><div class=\"col-xs-12 form-group\" ng-if=\"dataCaratula.id\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> - El layout para cargar certificados a pólizas de grupo es <strong>{{ layout_name }}</strong><br>- El layout lo puedes descargar desde el botón de opciones que se encuentra en esta misma página en la parte superior derecha.<br>- Estos ID te ayudarán a llenar el layout.</div></div><div class=\"col-xs-12\" ng-if=\"dataCaratula.id\"><legend class=\"legend-title\">{{ dataCaratula.subramo.subramo_name }}</legend></div><div class=\"col-xs-12 col-sm-8 form-group\" ng-if=\"dataSubgroup.length > 0\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Subgrupos</th><th>Categorías</th></tr></thead><tbody><tr ng-repeat=\"item in dataSubgroup\"><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br><small>Nombre: <span>{{ item.name }}</span></small></td><td><ul><li ng-repeat=\"categorie in item.categorias\"><small>ID para layout:</small><span class=\"font-weight-bold\">{{ categorie.id }}</span><br><small>Nombre: <span>{{ categorie.name }}</span></small></li></ul></td></tr></tbody></table></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"dataPackage.length > 0\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Paquetes</th></tr></thead><tbody><tr ng-repeat=\"item in dataPackage\"><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br><small>Nombre: <span>{{ item.package_name }}</span></small></td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"!showTableCertificates\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\"></label></div><div class=\"col-sm-6 col-md-3 form-group pull-right\" ng-if=\"!loader\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"goToInformation()\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Información de Pólizas de grupo</button></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando certificados...</span></div></div></div><div class=\"row\" ng-if=\"showTableCertificates\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">{{ caratula.subramo.subramo_name }}</legend></div><div class=\"col-xs-1 form-group\"><select class=\"form-control\" ng-options=\"renewal.value for renewal in optionsViews\" ng-change=\"selectViews(optionViews)\" ng-model=\"optionViews\"></select></div><div><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\" ng-if=\"dataCaratula.ramo.ramo_name == \'Vida\'\"><thead><tr><td>Familia</td><td>Folio</td><td>Certificado</td><td>Correo</td><td>Tipo</td><td>Parentesco</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Tipo Suma Asegurada</td><td>Suma Asegurada</td><td>Sueldo</td><td>Fumador</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.FAMILIA }}</td><td>{{ item.FOLIO }}</td><td>{{ item.CERTIFICADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.TIPO }}</td><td>{{ item.PARENTESCO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.FECHA_NACIMIENTO }}</td><td>{{ item.SEXO }}</td><td>{{ item.FECHA_ANTIGUEDAD }}</td><td>{{ item.TIPO_SUMA_ASEGURADA }}</td><td>{{ item.SUMA_ASEGURADA }}</td><td>{{ item.SUELDO }}</td><td>{{ item.FUMADOR }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"dataCaratula.ramo.ramo_name == \'Accidentes y Enfermedades\'\"><thead><tr><td>Familia</td><td>Folio</td><td>Certificado</td><td>Correo</td><td>Tipo</td><td>Parentesco</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.FAMILIA }}</td><td>{{ item.FOLIO }}</td><td>{{ item.CERTIFICADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.TIPO }}</td><td>{{ item.PARENTESCO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.FECHA_NACIMIENTO }}</td><td>{{ item.SEXO }}</td><td>{{ item.FECHA_ANTIGUEDAD }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"dataCaratula.subramo.subramo_name == \'Automóviles\'\"><thead><tr><td>Inciso</td><td>Propietario</td><td>Conductor</td><td>Correo</td><td>No. Empleado</td><td>Marca</td><td>Modelo</td><td>Año</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Uso</td><td>Servicio</td><td>Procedencia</td><td>Valor Asegurado</td><td>Tipo Carga</td><td>Adaptaciones</td><td>Monto Adaptaciones</td><td>Equipamineto</td><td>Monto Equipamineto</td><td>Beneficiario Preferente</td><td>Beneficiario RFC</td><td>Beneficiario Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.PROPIETARIO }}</td><td>{{ item.CONDUCTOR }}</td><td>{{ item.CORREO }}</td><td>{{ item.NO_EMPLEADO }}</td><td>{{ item.MARCA }}</td><td>{{ item.MODELO }}</td><td>{{ item.ANO }}</td><td>{{ item.VERSION }}</td><td>{{ item.SERIE }}</td><td>{{ item.MOTOR }}</td><td>{{ item.COLOR }}</td><td>{{ item.MATRICULA }}</td><td>{{ item.USO }}</td><td>{{ item.SERVICIO }}</td><td>{{ item.PROCEDENCIA }}</td><td>{{ item.VALOR_O_SUMA_ASEGURADA }}</td><td>{{ item.TIPO_CARGA }}</td><td>{{ item.ADAPTACIONES }}</td><td>{{ item.MONTO_ADAPTACIONES }}</td><td>{{ item.EQUIPAMIENTO }}</td><td>{{ item.MONTO_EQUIPAMIENTO }}</td><td>{{ item.BENEFICIARIO_PREFERENTE }}</td><td>{{ item.BENEFICIARIO_RFC }}</td><td>{{ item.BENEFICIARIO_DIRECCION }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"dataCaratula.subramo.subramo_name == \'Incendio\'\"><thead><tr><td>Inciso</td><td>Sucursal</td><td>Correo</td><td>Giro</td><td>Tipo Constructivo</td><td>No. Niveles</td><td>Zona FHM</td><td>Zona TYEV</td><td>Calle</td><td>No. Interior</td><td>No. Exterior</td><td>Municipio</td><td>Colonia</td><td>Ciudad</td><td>Estado</td><td>Código Postal</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.CORREO }}</td><td>{{ item.GIRO }}</td><td>{{ item.TIPO_CONSTRUCTIVO }}</td><td>{{ item.NO_NIVELES }}</td><td>{{ item.ZONA_FHM }}</td><td>{{ item.ZONA_TYEV }}</td><td>{{ item.CALLE }}</td><td>{{ item.NO_INTERIOR }}</td><td>{{ item.NO_EXTERIOR }}</td><td>{{ item.MUNICIPIO }}</td><td>{{ item.COLONIA }}</td><td>{{ item.CIUDAD }}</td><td>{{ item.ESTADO }}</td><td>{{ item.CP }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"dataCaratula.subramo.subramo_name == \'Diversos\'\"><thead><tr><td>Inciso</td><td>Propietario</td><td>No. Empleado</td><td>Correo</td><td>Descripción</td><td>Uso</td><td>Marca</td><td>Modelo</td><td>Año Construcción</td><td>Año Reconstrucción</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Permiso</td><td>Valor Compra</td><td>Calle</td><td>No. Interior</td><td>No. Exterior</td><td>Ciudad</td><td>Estado</td><td>Código Postal</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.PROPIETARIO }}</td><td>{{ item.NO_EMPLEADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.DESCRIPCION }}</td><td>{{ item.USO }}</td><td>{{ item.MARCA }}</td><td>{{ item.MODELO }}</td><td>{{ item.ANO_CONSTRUCCION }}</td><td>{{ item.ANO_RECONSTRUCCION }}</td><td>{{ item.VERSION }}</td><td>{{ item.SERIE }}</td><td>{{ item.MOTOR }}</td><td>{{ item.COLOR }}</td><td>{{ item.MATRICULA }}</td><td>{{ item.PERMISO }}</td><td>{{ item.VALOR_COMPRA }}</td><td>{{ item.CALLE }}</td><td>{{ item.NO_INTERIOR }}</td><td>{{ item.NO_EXTERIOR }}</td><td>{{ item.CIUDAD }}</td><td>{{ item.ESTADO }}</td><td>{{ item.CP }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveCertificates()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Certificados</button></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/colectivos/certificados.plantillas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Certificados</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Plantillas de Certificados</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-6\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createQuotation()\">Agregar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"col-xs-12 btn btn-secondary m-t\" ng-click=\"cambiarCampos()\">Campos en el Correo</button></div><div class=\"ibox\" ng-if=\"configurar\"><div class=\"ibox-title-c bg-light-gray clearfix\"><h3 class=\"section-title\" style=\"text-align: center;\">Configuración de Visualización en Correo</h3><span class=\"pull-right\" ng-click=\"cambiarCampos()\" style=\"cursor: pointer; color: #888;\" title=\"Cerrar sección\"><i class=\"fa fa-times fa-lg\"></i></span></div><div class=\"ibox-content-c row\"><form class=\"form-inline\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><div class=\"col-sm-3 value-email\" ng-repeat=\"campo in [ { id: \'dato_cnumcertificado\', label: \'Número de Certificado\', key: \'numcertificado\' }, { id: \'dato_ccontratante\', label: \'Contratante\', key: \'contratante\' }, { id: \'dato_cvigencia\', label: \'Vigencia\', key: \'vigencia\' }, { id: \'dato_caseguradora\', label: \'Aseguradora\', key: \'compania\' }, { id: \'dato_csubramo\', label: \'Subramo\', key: \'subramo\' }, { id: \'dato_cmoneda\', label: \'Moneda\', key: \'moneda\' }, { id: \'dato_casegurado\', label: \'Asegurado\', key: \'asegurado\' }, { id: \'dato_cptotal\', label: \'Prima Total del Certificado\', key: \'total\' }, { id: \'dato_cpneta\', label: \'Prima Neta del Certificado\', key: \'pneta\' }, { id: \'dato_cderecho\', label: \'Derecho del Certificado\', key: \'derecho\' }, { id: \'dato_crpf\', label: \'RPF del Certificado\', key: \'rpf\' }, { id: \'dato_civ\', label: \'IVA del Certificado\', key: \'iva\' } ]\"><div class=\"checkbox checkbox-inline-c\"><label><input type=\"checkbox\" id=\"{{campo.id}}\" ng-model=\"configuracionGlobal[campo.id]\" ng-change=\"cambiarDato(campo.id, configuracionGlobal[campo.id])\"> {{campo.label}}</label></div></div></div></div></form></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"showQuotation\" style=\"margin-left: 25px;padding-right: 75px;\"><legend ng-if=\"!showEditInformation\" class=\"legend-title\" align=\"center\">Nueva Plantilla</legend><legend ng-if=\"showEditInformation\" class=\"legend-title\" align=\"center\">Actualizar Plantilla</legend><form class=\"row\" name=\"form\"><div class=\"ibox-content-c row\"></div><div class=\"col-xs-12 col-sm-5 form-group\"><label>Nombre de la Plantilla <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"plantilla.name\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Ramo(s) <span class=\"color-red\">*</span></label><select id=\"ramoSelect\" class=\"js-example-basic-multiple col-xs-12 form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"plantilla.ramo_code\" data-ng-options=\"codes.descr ? codes.descr : codes.code for codes in allRamos | orderBy: \'descr\' track by codes.code\" ng-change=\"selectProv(select_code)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-2 form-group\"><label for=\"defaultsubject\"><input id=\"plantilla.subject_default\" type=\"checkbox\" ng-model=\"plantilla.subject_default\"> Asunto Default</label></div><div class=\"col-xs-12 col-sm-5 form-group\"><label ng-if=\"plantilla.subject_default==false\">Asunto <span class=\"color-red\">*</span></label> <input ng-if=\"plantilla.subject_default==false\" class=\"form-control\" type=\"text\" ng-model=\"plantilla.title\"></div><button type=\"button\" class=\"btn btn-default ng-scope pull-right\" unselectable=\"on\" tabindex=\"-1\" ng-click=\"getFile()\" ng-disabled=\"!editor_focus\"><i class=\"fa fa-upload\"></i></button><div class=\"col-xs-12 form-group\"><label>Texto Superior <span class=\"color-red\">*</span></label><div text-angular=\"\" ng-model=\"plantilla.text\" name=\"myEditorCreate\" ng-focus=\"focusEditor()\" ng-blur=\"unfocusEditor()\"></div></div><div class=\"col-xs-12 form-group\"><label>Texto Inferior <span class=\"color-red\">*</span></label><div text-angular=\"\" name=\"myEditorCreate2\" ng-focus=\"focusEditor()\" ng-blur=\"unfocusEditor()\" ng-model=\"plantilla.bottom_text\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button ng-if=\"!showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"savePlantilla(plantilla)\">Crear Plantilla</button> <button ng-if=\"showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"updateDelivery(plantilla)\">Actualizar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeTemplate()\">Cancelar</button></div></form></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Plantillas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\" ng-if=\"!showInfoQuotation\"><table class=\"table table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th>ID</th><th>Nombre</th><th>Asunto</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"item in vm.quotations track by $index\" ng-click=\"showInformation(item)\"><td>{{ item.id }}</td><td>{{ item.name }}</td><td>{{ item.title }}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-sm btn-white\" ng-click=\"editQuatation(item)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"show_pagination\" class=\"text-center\"><pagination config=\"vm.config_pagination\" model=\"vm.quotations\"></pagination></div></div><div class=\"animate\" ng-if=\"showInfoQuotation\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showInformation(null)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Name:</span><div><span>{{ quotation.name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Asunto:</span><div><span>{{ quotation.title }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Texto Superior:</span><div text-angular=\"\" ng-model=\"quotation.text\" name=\"quotation.text\" ta-disabled=\"isReadOnly\"></div><br></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Texto Inferior:</span><div text-angular=\"\" ng-model=\"quotation.bottom_text\" name=\"quotation.bottom_text\" ta-disabled=\"isReadOnly\"></div></div></div></div></div></div>");
$templateCache.put("app/colectivos/colectivos.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Pólizas de Grupo</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><a ui-sref=\"polizas.table\">Pólizas de Grupo</a></li><li><a ng-if=\"caratula.poliza_number\" ui-sref=\"colectividades.info({polizaId: caratula.id})\">Pólizas de Grupo #{{ caratula.poliza_number }}</a> <a ng-if=\"!caratula.poliza_number\" ui-sref=\"colectividades.info({polizaId: caratula.id})\">OT {{ caratula.internal_number }}</a></li><li class=\"active\"><strong>Editar</strong></li></ol></div></div><br><div class=\"row\" ng-if=\"show_caratula\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"caratule.poliza_number\">Editar Carátula</h5><h5 ng-if=\"!caratule.poliza_number\">Editar Carátula OT</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"show_caratula\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"caratula.identifier\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Folio Interno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"caratula.internal_number\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"!showOt\"><label>Folio:</label> <input class=\"form-control\" type=\"text\" ng-model=\"caratula.folio\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"!showOt\"><label>Número de Póliza: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-blur=\"checkNumPolicy()\" ng-model=\"caratula.poliza_number\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante: <span class=\"color-red\">*</span></label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contratante\" change=\"matchesContractors(order.contratante)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in addresses track by address.url\" ng-change=\"changeAddress(addressSelected)\" ng-model=\"addressSelected\" ng-disabled=\"!order.contratante\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo Electrónico:</label> <input class=\"form-control\" type=\"email\" ng-model=\"order.contratante.value.email\" ng-disabled=\"!order.contratante\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono:</label><phonenumber-directive model=\"order.contratante.value.phone_number\" class=\"ng-isolate-scope\"><input class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" type=\"tel\" maxlength=\"25\" aria-invalid=\"false\" ng-model=\"inputValue\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Vigencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"startDate\" value=\"{{startDate}}\" ng-change=\"checkDate(startDate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Al: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"endDate\" value=\"{{endDate}}\" ng-change=\"checkEndDate(endDate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Aseguradora: <span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control\" ng-options=\"aseguradora.alias for aseguradora in providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"getClaves(aseguradoraSelected,0)\" ng-model=\"aseguradoraSelected\" ng-value=\"\"><option value=\"\">Selecciona un proveedor</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"refreshProvider()\"><i class=\"glyphicon glyphicon-refresh\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Clave de Agente: <span class=\"color-red\">*</span></label> <input ng-if=\"claves.length == 0\" class=\"form-control\" type=\"text\" placeholder=\"Elige una aseguradora aseguradora\" disabled=\"\"> <input ng-if=\"claves.length == 1\" class=\"form-control\" type=\"text\" value=\"{{claves[0].clave + \' - \' + claves[0].name}}\" disabled=\"\"><select ng-if=\"claves.length > 1\" class=\"form-control\" ng-options=\"clave as clave.clave + \' - \' + clave.name for clave in claves | orderBy: \'clave\' track by clave.url\" ng-change=\"changeClave(claveSelected)\" ng-model=\"claveSelected\" ng-disabled=\"!aseguradoraSelected\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"ramo.ramo_name for ramo in ramos track by ramo.url\" ng-change=\"changeRamo(ramoSelected)\" ng-model=\"ramoSelected\" ng-disabled=\"!aseguradoraSelected\"><option value=\"\">Selecciona un ramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"subramo.subramo_name for subramo in subramos track by subramo.url\" ng-change=\"changeSubramo(subramoSelected)\" ng-model=\"subramoSelected\" ng-disabled=\"!ramoSelected\"><option value=\"\">Selecciona un subramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Renovable: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"renewal.label for renewal in renewals\" ng-change=\"changeRenewal(renewalSelected)\" ng-model=\"renewalSelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Tipo de Administración: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"renewal.label for renewal in administrationTypes\" ng-change=\"changeAdminType(administrationSelected)\" ng-model=\"administrationSelected\"><option value=\"\">Selecciona un tipo de administración</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Moneda:</label><select class=\"form-control\" ng-options=\"currency.value as currency.label for currency in currencys\" ng-change=\"changeCurrency(currencySelected)\" ng-model=\"currencySelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Responsable:</label><select class=\"form-control\" ng-options=\"responsable as responsable.first_name + \' \' + responsable.last_name for responsable in users\" ng-change=\"changeResponsable(responsableSelected)\" ng-model=\"responsableSelected\"><option value=\"\">Seleccione un responsable</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ejecutivo de Cobranza:</label><select class=\"form-control\" ng-options=\"collection_executive as collection_executive.first_name + \' \' + collection_executive.last_name for collection_executive in ejecutivos\" ng-change=\"changeExecutive(executiveSelected)\" ng-model=\"executiveSelected\"><option value=\"\">Seleccione un ejecutivo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-options=\"businesslin.name for businesslin in businessline | orderBy:\'id\' track by businesslin.id\" ng-change=\"changeBusinessLine(business_lineSelected);\" name=\"business\" ng-model=\"business_lineSelected\"><option value=\"\" disabled=\"\">Seleccione una línea</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-options=\"celula.celula_name for celula in celulas | orderBy:\'id\' track by celula.id\" ng-change=\"changeCelula(celulaSelected)\" ng-model=\"celulaSelected\"><option value=\"\" disabled=\"\">Seleccione una célula</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Agrupación</label><select class=\"form-control\" ng-options=\"item.description for item in agrupaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeAgrupacion(grouping_levelSelected)\" ng-model=\"grouping_levelSelected\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Subagrupación</label><select class=\"form-control\" ng-options=\"item.description for item in sub_asignaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeSubagrupacion(subgroupingSelected)\" ng-model=\"subgroupingSelected\" ng-disabled=\"!grouping_levelSelected\"><option value=\"\" disabled=\"\">Seleccione una subagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Subsubagrupación</label><select class=\"form-control\" ng-options=\"item.description for item in sub_subasignaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeSubsubagrupacion(subsubgroupingSelected)\" ng-model=\"subsubgroupingSelected\" ng-disabled=\"!subgroupingSelected\"><option value=\"\" disabled=\"\">Seleccione una subsubagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Sucursal:</label><select class=\"form-control\" ng-options=\"sucursal as sucursal.sucursal_name for sucursal in sucursales\" ng-change=\"changeSucursal(sucursalSelected)\" ng-model=\"sucursalSelected\"><option value=\"\">Seleccione una sucursal</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Conducto de pago:</label><select class=\"form-control\" ng-options=\"conducto_de_pago.value as conducto_de_pago.label for conducto_de_pago in conductos_de_pago\" ng-change=\"changeConducto(conductoSelected)\" ng-model=\"conductoSelected\"></select></div><div class=\"col-xs-12 col-sm-6 form-group hidden-xs hidden-sm\" ng-if=\"acceso_ver_ref\"><label>Referenciadores:</label><div ng-repeat=\"item in referenciadorArray\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteReferenciador(item, $index)\" ng-disabled=\"referenciadorArray.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control\" ng-options=\"referenciador.url as referenciador.first_name + \' \' + referenciador.last_name for referenciador in referenciadores\" ng-model=\"item.referenciador\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\"><input class=\"form-control wb102\" type=\"text\" placeholder=\"% Comisión\" ng-disabled=\"referenciadorArray.length <= 1\" ng-change=\"changeComRef(item.comision_vendedor, $index,item)\" ng-model=\"item.comision_vendedor\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Esquema de Pago: <span class=\"color-red\">*</span></label><div><div class=\"btn-group\"><button class=\"btn\" ng-click=\"chanceScheme(1)\" ng-style=\"btnTraditionalStyle\"><i class=\"fa fa-suitcase\" aria-hidden=\"true\"></i> Tradicional</button> <button class=\"btn\" ng-click=\"chanceScheme(2)\" ng-style=\"btnMinimalStyle\"><i class=\"fa fa-cubes\" aria-hidden=\"true\"></i> Prima Mínima</button></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.scheme == 1\"><label>Frecuencia de Pago: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"frequency.value as frequency.label for frequency in frequencies\" ng-change=\"chancePayment(paymentSelected)\" ng-model=\"paymentSelected\"><option value=\"\" disabled=\"\">Selecciona una frecuencia</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.scheme == 2\"><label>Frecuencia de Pago: <span class=\"color-red\">*</span></label><select class=\"form-control\" disabled=\"\"><option value=\"\">Contado</option></select></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Observaciones</legend><textarea class=\"form-control\" type=\"text\" ng-model=\"caratula.observations\"></textarea></div><div ng-if=\"!showOt && caratula.scheme == 1\"><div class=\"col-xs-12 form-group\" ng-if=\"!showOt && caratula.receipts_by == 1\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-colectivo></div></div><div ng-if=\"!showOt && caratula.scheme == 2\"><div class=\"col-xs-12 form-group\" ng-if=\"!showOt && caratula.receipts_by == 1\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"3\"></receipts-colectivo></div></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"validityInsurance()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Carátula</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-white col-xs-12\" ui-sref=\"colectividades.info({polizaId: caratula.id})\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div></div></div></div><div class=\"row\" ng-if=\"show_subgrupo\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"!create_subgroup\">Editar Subgrupo</h5><h5 ng-if=\"create_subgroup\">Crear Subgrupo</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"subgrupos.name\" ng-click=\"save_info_tab()\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones:</label> <textarea type=\"text\" class=\"form-control\" ng-model=\"subgrupos.observations\" ng-click=\"save_info_tab()\"></textarea></div><div ng-if=\"caratula.receipts_by == 2\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante: <span class=\"color-red\">*</span></label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contratanteSubgrupo\" change=\"matchesContractors(order.contratanteSubgrupo)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección:</label><select class=\"form-control\" ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in addressSubgroups track by address.url\" ng-change=\"changeAddressSubgroup(subgrupos.addressSelected)\" ng-model=\"subgrupos.addressSelected\" ng-disabled=\"!order.contratanteSubgrupo\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 form-group\" ng-if=\"!showOt && caratula.receipts_by == 2\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-colectivo></div></div><div class=\"address-container\" ng-repeat=\"item in subgrupos.categorias\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteCategorie($index)\" ng-disabled=\"subgrupos.categorias.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Categoría</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteCategorie($index)\" ng-disabled=\"subgrupos.categorias.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Categoría #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addCategorie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Categoría</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addCategorie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.name\" ng-click=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"caratula.ramo.ramo_code == 2\"><label>Nivel Hospitalario: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.hospital_level\" ng-click=\"save_info_tab()\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones:</label> <textarea type=\"text\" class=\"form-control\" ng-model=\"item.observations\" ng-click=\"save_info_tab()\"></textarea></div></div></div><div class=\"col-xs-12\"><br></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"validitySubgroup()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Subgrupo</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-white col-xs-12\" ui-sref=\"colectividades.info({polizaId: caratula.id})\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div></div></div></div><div class=\"row\" ng-if=\"show_paquete\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"!create_package\">Editar Paquete</h5><h5 ng-if=\"create_package\">Crear Paquete</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!create_package\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"package.package_name\" ng-click=\"save_info_tab()\"></div><div class=\"col-xs-12 form-group\"><div ng-include=\"\'app/coberturas/coberturas.table.html\'\"></div><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 col-sm-3 form-group pull-right\" ng-if=\"newCoverages.length == 0\"><button class=\"btn btn-success col-xs-12\" ng-click=\"addPackageCoverage(true)\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Nueva Cobertura</button></div></div><div class=\"address-container\" ng-repeat=\"item in newCoverages\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deletePackageCoverage($index)\" ng-disabled=\"newCoverages.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Cobertura</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deletePackageCoverage($index)\" ng-disabled=\"newCoverages.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Cobertura #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addPackageCoverage(true)\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Cobertura</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addPackageCoverage(true)\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre de la Cobertura: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.coverage_name\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Suma Asegurada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.sums_coverage\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Deducible:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.deductible_coverage\"></div></div></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\" ng-if=\"newCoverages.length > 0\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"saveCoverage(packageSelected)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Cobertura</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\" ng-if=\"newCoverages.length > 0\"><button class=\"btn btn-white col-xs-12\" ng-click=\"addPackageCoverage(false)\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"updatePackage()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Paquete</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-white col-xs-12\" ui-sref=\"colectividades.info({polizaId: caratula.id})\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div class=\"row\" ng-if=\"create_package\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Paquete: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"pack.package_name for pack in packages\" ng-change=\"changePackage(packageSelected)\" ng-model=\"packageSelected\"><option value=\"\">Selecciona un paquete</option></select></div><div class=\"col-xs-12 col-sm-3 form-group m-t\"><button class=\"btn btn-info\" ng-click=\"showNewPackage(true)\"><i class=\"fa fa-plus-square\" aria-hidden=\"true\"></i> Crear Paquete</button></div><div ng-if=\"newPackage\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Nuevo Paquete</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre del Paquete: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newPackageCoverage.package_name\" ng-click=\"save_info_tab()\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones: <span class=\"color-red\">*</span></label> <textarea type=\"text\" class=\"form-control\" ng-model=\"newPackageCoverage.description\" ng-click=\"save_info_tab()\"></textarea></div><div class=\"address-container\" ng-repeat=\"item in newPackageCoverage.coverage_package\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteNewPackageCoverage($index)\" ng-disabled=\"newPackageCoverage.coverage_package.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Cobertura</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteNewPackageCoverage($index)\" ng-disabled=\"newPackageCoverage.coverage_package.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Cobertura #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addNewPackageCoverage()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Cobertura</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addNewPackageCoverage()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre de la Cobertura: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.coverage_name\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Suma Asegurada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.sums_coverage\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Deducible:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.deductible\"></div></div></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"saveNewPackage()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Crear Nuevo Paquete</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\"><button class=\"btn btn-white col-xs-12\" ng-click=\"showNewPackage(false)\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div ng-if=\"personalizePackage\"><div class=\"col-xs-12 form-group\"><div ng-include=\"\'app/coberturas/coberturas.table.html\'\"></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\" ng-if=\"newCoverages.length == 0\"><button class=\"btn btn-success col-xs-12\" ng-click=\"addPackageCoverage(true)\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Nueva Cobertura</button></div></div><div class=\"address-container\" ng-repeat=\"item in newCoverages\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deletePackageCoverage($index)\" ng-disabled=\"newCoverages.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Cobertura</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deletePackageCoverage($index)\" ng-disabled=\"newCoverages.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Cobertura #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addPackageCoverage(true)\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Cobertura</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addPackageCoverage(true)\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre de la Cobertura: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.coverage_name\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Suma Asegurada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.sums_coverage\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Deducible:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.deductible_coverage\"></div></div></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\" ng-if=\"newCoverages.length > 0\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"saveCoverage(packageSelected)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Cobertura</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\" ng-if=\"newCoverages.length > 0\"><button class=\"btn btn-white col-xs-12\" ng-click=\"addPackageCoverage(false)\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"addPackage()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Paquete</button></div></div></div></div></div></div></div>");
$templateCache.put("app/colectivos/colectivos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Pólizas de Grupo</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Pólizas de Grupo</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"panel-group\"><div class=\"panel panel-default\" ng-init=\"showCar = false\"><div class=\"panel-heading\" ng-click=\"showCar ? showCar = false : showCar = true\"><h4 class=\"panel-title\"><a>Carátula <i class=\"fa fa-check-circle blue-color\" aria-hidden=\"true\" ng-if=\"caratula.identifier && caratula.address && startDate && endDate && caratula.aseguradora && caratula.ramo && caratula.subramo && caratula.administration_type && caratula.forma_de_pago\"></i> <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showCar\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showCar\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showCar\"><div class=\"col-xs-12 animate z-index-1000\" ng-if=\"show_contractor\"><ng-include src=\"\'app/contratantes/contratantes.add.html\'\" ng-controller=\"ContratantesCtrl as vm\"></ng-include></div><div class=\"col-xs-12 animate\" ng-show=\"!show_contractor\"><br><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"OT\" ng-click=\"hideButtonOT()\" ng-show=\"order.acceso_adm_ot\"><div ng-include=\"\" src=\"\'app/colectivos/ordenes.html\'\"></div></uib-tab><uib-tab index=\"1\" heading=\"Póliza\" ng-click=\"showButtonPolicy()\" ng-show=\"order.acceso_adm_pol\"><div ng-include=\"\" src=\"\'app/colectivos/ordenes.html\'\"></div></uib-tab></uib-tabset><br></div></div></div><div class=\"panel panel-default\" ng-init=\"showSub = true\"><div class=\"panel-heading\" ng-click=\"showSub ? showSub = false : showSub = true\"><h4 class=\"panel-title\"><a>Subgrupos y Categorías <i class=\"fa fa-check-circle blue-color\" aria-hidden=\"true\" ng-if=\"subgroups.length > 0\"></i> <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showSub\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showSub\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showSub\"><br><div ng-include=\"\" src=\"\'app/colectivos/subgrupos.html\'\"></div></div></div><div class=\"panel panel-default\" ng-init=\"showPac = true\"><div class=\"panel-heading\" ng-click=\"showPac ? showPac = false : showPac = true\"><h4 class=\"panel-title\"><a>Paquetes <i class=\"fa fa-check-circle blue-color\" aria-hidden=\"true\" ng-if=\"paquetes.length > 0\"></i> <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showPac\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showPac\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showPac\"><br><div ng-include=\"\" src=\"\'app/colectivos/paquetes.html\'\"></div></div></div><div class=\"panel panel-default\" ng-init=\"showCer = true\"><div class=\"panel-heading\" ng-click=\"showCer ? showCer = false : showCer = true\"><h4 class=\"panel-title\"><a>Certificados <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showCer\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showCer\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showCer\"><br><div ng-include=\"\" src=\"\'app/colectivos/certificados.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/colectivos/colectivos.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading page-heading--modern\"><div class=\"col-lg-12\"><div class=\"page-heading__top\"><h2 class=\"page-heading__title\">Póliza de Grupo <span class=\"page-heading__badge\" ng-if=\"caratula.poliza_number\">#{{caratula.poliza_number}}</span></h2><h2 class=\"page-heading__title\" ng-if=\"!caratula.poliza_number\">OT <span class=\"page-heading__badge\" ng-if=\"caratula.internal_number\">#{{caratula.internal_number}}</span></h2></div><ol class=\"breadcrumb page-heading__breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"polizas.table\">Listado de Pólizas</a></li><li class=\"active\" aria-current=\"page\"><strong>Póliza de Grupo</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-success col-xs-12\" data-toggle=\"modal\" data-target=\"#myModal\" ng-if=\"incompleteOT.complete\">Pólizas de Grupo Completo</button> <button type=\"button\" class=\"btn btn-warning col-xs-12\" data-toggle=\"modal\" data-target=\"#myModal\" ng-if=\"!incompleteOT.complete\">Pólizas de Grupo Incompleto</button></div><div class=\"modal fade\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Pólizas de Grupo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Carátula:</label><ul class=\"col-p0\"><li ng-repeat=\"item in incompleteOT.caratule\"><small>{{ item.text }}</small></li></ul></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Subgrupos:</label><ul class=\"col-p0\"><li ng-repeat=\"item in incompleteOT.subgroups\"><small>{{ item.text }}</small></li></ul></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Paquetes:</label><ul class=\"col-p0\"><li ng-repeat=\"item in incompleteOT.packages\"><small>{{ item.text }}</small></li></ul></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Certificados:</label><ul class=\"col-p0\"><li ng-repeat=\"item in incompleteOT.certificates\"><small>{{ item.text }}</small></li></ul></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cerrar</button></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><ul class=\"tab-group\"><li ng-class=\"{ \'active-group\': show_caratula }\" ng-click=\"show_section(1)\">Carátula</li><li ng-class=\"{ \'active-group\': show_subgrupo }\" ng-click=\"show_section(2)\">Subgrupos y Categorías</li><li ng-class=\"{ \'active-group\': show_paquete }\" ng-click=\"show_section(3)\">Paquetes</li><li ng-class=\"{ \'active-group\': show_certificado }\" ng-click=\"show_section(4)\">Certificados</li></ul></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pull-right option_button m-b\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-if=\"caratula.status == \'En trámite\' && acceso_adm_pol\" ng-click=\"convertPolicy(caratula)\">Convertir a póliza</a></li><li ng-if=\"acceso_adm_end\"><a ng-click=\"goToEndorsement()\" ng-if=\"caratula.status\">Crear endoso</a></li><li><a ng-click=\"editCollective(caratula)\">Editar Carátula</a></li><li ng-if=\"caratula.ramo.ramo_code ==2\"><a ng-click=\"contributoryInfo(caratula.id)\"><i class=\"fa fa-currency\" aria-hidden=\"true\"></i>Información Contributoria</a></li><li ng-if=\"acceso_adm_rehabilitar && (caratula.status == \'Cancelada\' || caratula.status == \'OT Cancelada.\')\"><a ng-click=\"reActivatePolicy(caratula.id, caratula.poliza_number)\"><span ng-if=\"caratula.status == \'Cancelada\'\">Rehabilitar Carátula</span> <span ng-if=\"caratula.status == \'OT Cancelada.\'\">Rehabilitar OT</span></a></li><li ng-if=\"acceso_adm_rehabilitar && (caratula.status == 15 || caratula.status == \'No Renovada\')\"><a ng-click=\"renovarPolizaRehabilitate(caratula.id, caratula.poliza_number)\">Rehabilitar Póliza/OT para Renovar</a></li><li class=\"dropdown-submenu\"><a>Editar Subgrupo</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li ng-repeat=\"subgroup in subgrupos\"><a ng-click=\"editCollective(subgroup)\">{{ subgroup.name }}</a></li><li><a ng-click=\"addSubgroupPackage(2)\">Agregar Subgrupo</a></li></ul></li><li class=\"dropdown-submenu\"><a>Editar Paquete</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li ng-repeat=\"pack in paquetes\"><a ng-click=\"editCollective(pack)\">{{ pack.package_name }}</a></li><li><a ng-click=\"addSubgroupPackage(3)\">Agregar Paquete</a></li></ul></li><li ng-if=\"caratula.status != \'Cancelada\'; caratula.status != \'En trámite\'; caratula.renewed_status == 0; caratula.is_renewable == 1 || (caratula.is_renewable ==1 && !existeNueva)\" ng-show=\"caratula.status != \'No Renovada\'\"><a ng-click=\"gotoRenewal(caratula)\">Renovar</a></li><li><a ng-click=\"cancelRenovate(caratula)\" ng-if=\"caratula.status != \'Renovada\' && caratula.status != \'No Renovada\' && caratula.is_renewable == 1 && (acceso_adm_pol && caratula.status !=\'En trámite\' && caratula.status != \'OT Cancelada.\')\">No renovar</a></li><li ng-if=\"caratula.status == \'En trámite\'\"><a ng-click=\"getPDF(caratula.id)\">Generar PDF</a></li><li ng-if=\"caratula.status == \'En trámite\'\"><a ng-click=\"sendProvider(caratula)\">Enviar PDF a la Compañia</a></li><li class=\"dropdown-submenu\" ng-if=\"acceso_form\"><a>Descargar layouts</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li><a target=\"_blank\" href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Flotillas.xls\">Flotillas</a></li><li><a target=\"_blank\" href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Gastos_Medicos.xls\">Gastos médicos</a></li><li><a target=\"_blank\" href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Vida.xls\">Vida</a></li><li><a target=\"_blank\" href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Incendio.xls\">Incendio</a></li><li><a target=\"_blank\" href=\"https://miurabox-public.s3.amazonaws.com/layouts/Layout_Eq_Elect_Contratista.xls\">Diversos</a></li></ul></li><li ng-if=\"(acceso_canc_pol && caratula.status !=\'En Trámite\' && caratula.status !=\'OT Cancelada\') && (caratula.status !=\'Cancelada\' || caratula.status ==11)\"><a ng-if=\"caratula.poliza_number && acceso_canc_pol\" ng-click=\"cancelPolicyModal(caratula)\">Cancelar</a> <a ng-if=\"!caratula.poliza_number && acceso_canc_ot && caratula.status!= \'OT Cancelada.\'\" ng-click=\"cancelPolicyModal(caratula)\">Cancelar OT</a></li><li ng-if=\"acceso_elim_pol\"><a ng-click=\"deletePolicy()\">Eliminar Póliza de Grupo</a></li><li class=\"dropdown-submenu\" ng-if=\"acceso_form\"><a>Ver carta</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li ng-if=\"cartas\" ng-repeat=\"carta in cartas track by $index\"><a ng-click=\"viewCarta(caratula.id, carta)\">{{carta.name}}</a></li><li><a ng-click=\"getPDF(caratula.id)\">RESÚMEN EN PDF</a></li></ul></li><li><a ng-click=\"assignPolicy(caratula.id)\">Compartir Carátula por Correo</a></li><li ng-if=\"caratula.administration_type == 2 || caratula.administration_type ==\'Autoadministrada\'\"><a ng-click=\"verAjusteCuenta(caratula.id)\">Info-Ajuste Anual</a></li><li class=\"dropdown-submenu\" ng-if=\"caratula.status == \'Vigente\' && categorySelected.certificates.length > 0\"><a>Compartir Certificados a</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li><a ng-click=\"shareCertificatesApp(caratula.id)\">App</a></li><li><a ng-click=\"shareCertificatesEmail(caratula.id,caratula)\">Correo Electrónico</a></li><li><a ng-click=\"shareCertificatesAPPEmail(caratula.id,caratula)\">App y Correo Electrónico</a></li></ul></li></ul></div></div></div></div><div ng-if=\"show_caratula\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carátula</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button> <button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(caratula,1)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"infoFlag\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\" ng-if=\"caratula.contractor.type_person ==\'Física\'\"><b>Nombre</b>:</span> <span class=\"blue-color\" ng-if=\"caratula.contractor.type_person ==\'Moral\'\"><b>Razón Social</b>:</span><div><span>{{ cover_contractor.full_name }}{{ cover_contractor.j_name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">RFC:</span><div><span>{{ cover_contractor.rfc }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Grupo:</span><div><span>{{ cover_contractor.group }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"cover_contractor.subgrupo\"><span class=\"blue-color\">SubGrupo:</span><div><span>{{ cover_contractor.subgrupo }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"cover_contractor.subsubgrupo\"><span class=\"blue-color\">SubsubGrupo:</span><div><span>{{ cover_contractor.subsubgrupo }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"cover_contractor.grouping_level\"><span class=\"blue-color\">Nivel de Agrupación:</span><div><span>{{ cover_contractor.grouping_level }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"cover_contractor.subgrouping\"><span class=\"blue-color\">Sub Agrupación:</span><div><span>{{ cover_contractor.subgrouping }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"cover_contractor.subsubgrouping\"><span class=\"blue-color\">Subsub Agrupación:</span><div><span>{{ cover_contractor.subsubgrouping }}</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\" ng-if=\"cover_contractor.classification\"><span class=\"blue-color\">Clasificación:</span><div><span>{{ cover_contractor.classification }}</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\" ng-if=\"cover_contractor.celula && campo_celula\"><span class=\"blue-color\">{{moduleName}}:</span><div><span>{{ cover_contractor.celula }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div style=\"word-wrap: break-word\"><span>{{ cover_contractor.email }}</span></div><div style=\"word-wrap: break-word\" ng-repeat=\"correo in cover_contractor.email_contractor\"><span>{{correo.correo}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ cover_contractor.phone_number }}</span></div></div><div class=\"col-xs-12\" ng-repeat=\"phone_number in cover_contractor.phone_contractor\"><span ng-if=\"phone_number.phone_type == 1\" class=\"fa fa-home\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 2\" class=\"fa fa-building\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 3\" class=\"fa fa-mobile\" aria-hidden=\"true\"></span> <span>{{phone_number.phone | phonenumber}}</span></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Dirección</span><div><span ng-if=\"cover_contractor.direccion.route\">{{ cover_contractor.direccion.route }} {{ cover_contractor.direccion.street_number }},&nbsp;</span> <span ng-if=\"cover_contractor.direccion.street_number_int\">Int. {{ cover_contractor.direccion.street_number_int }},</span> <span ng-if=\"cover_contractor.direccion.sublocality\">{{ cover_contractor.direccion.sublocality }},</span><br><span ng-if=\"cover_contractor.direccion.administrative_area_level_2\">{{ cover_contractor.direccion.administrative_area_level_2 }},</span> <span ng-if=\"cover_contractor.direccion.administrative_area_level_1\">{{ cover_contractor.direccion.administrative_area_level_1 }},</span> <span ng-if=\"cover_contractor.direccion.postal_code\">CP. {{ cover_contractor.direccion.postal_code }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"cover_contractor.contact_contractor.length\"><span class=\"blue-color\">Contactos</span><div ng-repeat=\"contact in cover_contractor.contact_contractor\"><span>{{ contact.name }}</span><br><span>{{ contact.email }}</span><br><span>{{ contact.phone_number }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"cover_contractor.vip\"><span class=\"blue-color\">VIP</span></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-primary ladda-button-initial-e\" ng-click=\"showEndorsements();\" ng-disabled=\"(endorsementsCaratula.endosos || 0) + (conteos.endosos_cert || 0) === 0\">Endosos<span class=\"badge\" style=\"margin-left:8px;\" ng-class=\"{\'badge-success\': (endorsementsCaratula.endosos||0)>0, \'badge-default\': (endorsementsCaratula.endosos||0)==0}\">Póliza: {{ endorsementsCaratula.endosos || 0 }}</span><span class=\"badge\" style=\"margin-left:6px;\" ng-class=\"{\'badge-info\': (conteoCertificados||0)>0, \'badge-default\': (conteoCertificados||0)==0}\">Certificados: {{ conteoCertificados || 0 }}</span></button></div><div class=\"col-xs-12 form-group\" ng-if=\"acceso_ver_cob\"><button type=\"button\" class=\"btn btn-success ladda-button-initial-nc\" ng-click=\"showNotes()\">Notas de Crédito ({{ notesCaratula.length }})</button></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"vm.showRecordatorios()\">{{caratula.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div><div class=\"col-xs-12 col-md-8 border-left\"><legend class=\"legend-title\" align=\"center\">Carátula</legend><div ng-if=\"caratula.poliza_number\" class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\"><b>Número de Póliza</b>:</span><div><span>{{ caratula.poliza_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Identificador:</span><div><span>{{ caratula.identifier }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Folio Interno:</span><div><span>{{ caratula.internal_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ caratula.aseguradora.alias }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Clave de Agente:</span><div><span>{{ caratula.clave.clave }} <span ng-if=\"caratula.clave.name\">- {{ caratula.clave.name }}</span></span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ caratula.ramo.ramo_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ caratula.subramo.subramo_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ caratula.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{ caratula.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{ statusPayment(caratula.forma_de_pago) }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Tipo de Administración:</span><div><span>{{ caratula.administration_type }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" ng-class=\"{\'label-success\': caratula.status == \'En trámite\' || caratula.status == \'No Renovada\' || caratula.status == \'Renovada\', \'label-info\' : caratula.status == \'Por iniciar\', \'label-primary\' : caratula.status == \'Vigente\', \'label-warning\' : caratula.status == \'OT Cancelada\' || caratula.status == \'Precancelada\' || caratula.status == 11}\" style=\"margin-right: 10px\">{{ caratula.status }} <span ng-if=\"(caratula.status !=\'Renovada\' && caratula.status !=\'No Renovada\' && caratula.status !=\'Cancelada\' && caratula.renewed_status == 2 && policy_history.length > 0) || (caratula.renewed_status == 2 && caratula.status ==\'Vencida\' && caratula.org_name==\'ancora\')\">- En proceso de renovación</span></div></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"caratula.status == \'No Renovada\' && caratula.reason_ren\"><span class=\"blue-color\">Razón de No Renovación:</span><div><span ng-if=\"caratula.reason_ren\">{{caratula.reason_ren}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"caratula.is_renewable\"><span class=\"blue-color\">Tipo Renovable:</span><div><span ng-if=\"caratula.is_renewable == 1\">Renovable</span> <span ng-if=\"caratula.is_renewable == 2\">No renovable</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Moneda:</span><div><span>{{ caratula.f_currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Recibos en:</span><div><span ng-if=\"caratula.receipts_by == 1\">Carátula</span> <span ng-if=\"caratula.receipts_by == 2\">Subgrupos</span> <span ng-if=\"caratula.receipts_by == 3\">Certificados</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Esquema de Pago:</span><div><span ng-if=\"caratula.scheme == 1\">Tradicional</span> <span ng-if=\"caratula.scheme == 2\">Prima Mínima</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"caratula.scheme == 2\"><span class=\"blue-color\">Siniestralidad:</span><div><span>{{ caratula.accident_rate }}%</span> <span></span></div></div><div class=\"col-xs-6 col-lg-4 form-group\"><span class=\"blue-color\">Creado Por:</span><div><span>{{ caratula.owner }}</span></div></div><div class=\"col-xs-6 col-lg-4 form-group\"><span class=\"blue-color\">Sucursal:</span><div><span ng-if=\"caratula.sucursal\">{{ caratula.sucursal.sucursal_name }}</span> <span ng-if=\"!caratula.sucursal\">&nbsp;</span></div></div><div class=\"col-xs-6 col-lg-4 form-group\" ng-if=\"campo_lineanegocio\"><span class=\"blue-color\">Línea de Negocio:</span><div><span>{{ businessLine }}</span> <span ng-if=\"!businessLine\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">{{moduleName}}:</span><div><span>{{celula}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.grouping_level && campo_agrupacion\"><span class=\"blue-color\">Agrupación:</span><div><span>{{caratula.grouping_level.description}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.subgrouping_level && campo_agrupacion\"><span class=\"blue-color\">Subagrupación:</span><div><span>{{caratula.subgrouping_level.description}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.subsubgrouping_level && campo_agrupacion\"><span class=\"blue-color\">Subsubagrupación:</span><div><span>{{caratula.subsubgrouping_level.description}}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\"><i class=\"fa fa-star yellow\"></i> Responsable:</span><div><span ng-if=\"caratula.responsable\">{{ caratula.responsable.first_name | uppercase}} {{ caratula.responsable.last_name | uppercase}}</span> <span ng-if=\"!caratula.responsable\">&nbsp;</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\"><i class=\"fa fa-calculator yellow\"></i> Ejecutivo de cobranza:</span><div><span ng-if=\"caratula.collection_executive\">{{ caratula.collection_executive.first_name | uppercase}} {{ caratula.collection_executive.last_name | uppercase}}</span> <span ng-if=\"!caratula.collection_executive\">&nbsp;</span></div></div><div class=\"col-xs-6 col-lg-4 form-group\" ng-if=\"caratula.reason_rehabilitate\"><span class=\"blue-color\">Motivo de rehabilitación:</span><div><span>{{ caratula.reason_rehabilitate }}</span></div></div><br><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"caratula.contratante_subgroup || caratula.group\"><span class=\"blue-color\"><i class=\"fa fa-group yellow\"></i> Grupo:</span><div>{{ caratula.group }}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"caratula.contratante_subgroup || caratula.subgroup\"><span class=\"blue-color\"><i class=\"fa fa-group yellow\"></i> SubGrupo:</span><div>{{ caratula.subgrupo }}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"caratula.contratante_subgroup || caratula.subsubgroup\"><span class=\"blue-color\"><i class=\"fa fa-group yellow\"></i> SubsubGrupo:</span><div>{{ caratula.subsubgrupo }}</div></div><div class=\"col-xs-6 col-lg-4 form-group\" ng-if=\"caratula.vendor && caratula.ref_policy.length == 0 && acceso_ver_ref\"><span class=\"blue-color\">Referenciador:</span><div><span>{{ caratula.vendor.first_name | uppercase}} {{ caratula.vendor.last_name | uppercase}}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"caratula.ref_policy.length > 0 && acceso_ver_ref\"><span class=\"blue-color\">Referenciador(es):</span><div ng-repeat=\"refs in caratula.ref_policy\"><span>{{ refs.referenciador.first_name | uppercase}} {{ refs.referenciador.last_name | uppercase}}</span> <a ng-if=\"caratula.ref_policy && caratula.ref_policy.length> 0\" class=\"btn btn-sm btn-white\" ng-click=\"cambiarReferenciador(refs,caratula)\" title=\"Cambiar Referenciador\"><i class=\"fa fa-rotate-right\" aria-hidden=\"true\"></i></a></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"(caratula.status == \'Cancelada\' || caratula.status == 11) && caratula.reason_cancel\"><span class=\"blue-color\">Razón de Cancelación:</span><div><span ng-if=\"caratula.reason_cancel\">{{caratula.reason_cancel}}</span></div><span class=\"blue-color\" ng-if=\"caratula.date_cancel\">Fecha de Cancelación:</span><div><span ng-if=\"caratula.date_cancel\">{{caratula.date_cancel | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 form-group\" align=\"center\" ng-if=\"caratula.contributory\"><span class=\"blue-color\"><b>Póliza Contributoria</b></span></div><div class=\"col-xs-3 form-group pull-right\" align=\"center\" ng-if=\"caratula.seguimiento && acceso_tab && decrptedtoken.org ==\'pruebas\'\"><span class=\"blue-color\">Tablero OT</span><div><span>{{ caratula.seguimiento }}</span><div class=\"btn-group pull-right m-b\"><button style=\"border: 0px;\" type=\"button\" class=\"btn btn-white btn-sm btn-secondary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bars\" aria-hidden=\"true\"></i></button><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"dropdown-submenu\" ng-if=\"principal.contenedores.length\"><a>Mover a</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"principal.contenedores\"><a class=\"disabled\">Estados</a></li><li ng-if=\"principal.contenedores\" ng-repeat=\"newcontainer in principal.contenedores track by $index\"><a ng-click=\"moveOTState(newcontainer,principal,caratula.seguimiento)\" ng-if=\"newcontainer.tablero != caratula.seguimiento\">{{newcontainer.tablero}}</a></li></ul></li></ul></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ caratula.observations }}</span></div></div><div class=\"col-xs-6 form-group pull-right\" ng-if=\"caratula.task_associated\"><button type=\"button\" class=\"btn btn-white btn-sm btn-secondary\" ng-click=\"openModal(caratula.task_associated_info)\">{{ vm.isCollapsed ? \'Ocultar\' : \'Ver\' }} Tarea Origen</button><div ng-show=\"vm.isCollapsed\"><span class=\"blue-color\">Tarea Origen</span><div><span>{{ caratula.task_associated_info.title }}</span></div></div></div><div class=\"col-xs-12\"><hr></div><div ng-if=\"caratula.status != 1\"><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Neta:</span><div>{{ caratula.p_neta | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Descuento: &nbsp;</span><div>{{ caratula.descuento | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-6 form-group\"><span class=\"blue-color\">Recargo por Pago Fraccionado:</span><div>{{ caratula.rpf | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Derecho:</span><div>{{ caratula.derecho | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Iva:</span><div>{{ caratula.iva | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Total:</span><div>{{ caratula.p_total | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"permiso_comisiones\"><span class=\"blue-color\">Comisión:</span><div>{{ caratula.comision | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"permiso_comisiones\"><span class=\"blue-color\">% Comisión <span ng-if=\"caratula.comision_derecho_percent!=\'0.00\' || caratula.comision_rpf_percent!=\'0.00\'\">Prima Neta</span>:</span><div>{{ caratula.comision_percent }}%</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"permiso_comisiones && caratula.comision_derecho_percent!=\'0.00\'\"><span class=\"blue-color\">% Comisión Derecho:</span><div>{{ caratula.comision_derecho_percent }}%</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"permiso_comisiones && caratula.comision_rpf_percent!=\'0.00\'\"><span class=\"blue-color\">% Comisión RPF:</span><div>{{ caratula.comision_rpf_percent }}%</div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"caratula\"><span class=\"blue-color\">Conducto de pago:</span><div><span>{{ get_conductos(caratula.conducto_de_pago) }}</span> <a ng-click=\"editCollective(caratula)\"><button><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> Editar</button></a></div></div></div></div></div><div class=\"row\" ng-if=\"endoFlag\"><div class=\"row m-t-md\"><button class=\"col-xs-3 btn btn-info\" ng-click=\"returnToInfo()\"><span class=\"fa fa-reply\" aria-hidden=\"true\"></span> Regresar</button><div class=\"col-xs-12 text-align-center\"><div class=\"alert alert-warning m-t-sm\">Endosos</div><uib-tabset active=\"vm.endorsementsTab\"><uib-tab heading=\"Endosos a Póliza ({{vm.endorsementsPolicy.length || 0}})\" index=\"0\"><div class=\"m-t-sm\" ng-if=\"vm.loadingEndorsementsPolicy\"><i class=\"fa fa-spinner fa-spin\"></i> Cargando endosos de póliza...</div><div class=\"alert alert-info m-t-sm\" ng-if=\"!vm.loadingEndorsementsPolicy && (!vm.endorsementsPolicy || !vm.endorsementsPolicy.length)\">No hay endosos registrados para esta póliza.</div><table class=\"table table-bordered table-striped table-hover m-t-sm\" ng-if=\"!vm.loadingEndorsementsPolicy && vm.endorsementsPolicy.length\"><thead><tr><th style=\"width:70px;\">Tipo</th><th>Número de Endoso</th><th>Concepto</th><th>Descripción</th><th>Vigencia</th><th>Estatus</th><th style=\"width:90px;\"></th></tr></thead><tbody><tr ng-repeat=\"endorsement in vm.endorsementsPolicy | orderBy:\'-created_at\'\" ng-click=\"goToEndorsement(endorsement.id)\"><td class=\"text-center\">{{endorsement.endorsement_type}}</td><td>{{endorsement.number_endorsement || \'Sin número asignado\'}}</td><td><span>{{ concept(endorsement.concept) }} <span ng-if=\"concept(endorsement.concept) == \'OTRO\'\">: {{endorsement.other_desc}}</span></span></td><td>{{endorsement.observations || endorsement.description}}</td><td>{{(endorsement.init_date | date:\'dd/MM/yyyy\') + \' - \' + (endorsement.end_date | date:\'dd/MM/yyyy\')}}</td><td><span class=\"label label-default\"><span ng-if=\"endorsement.status == 1\">Pendiente</span> <span ng-if=\"endorsement.status == 2\">Registrado</span> <span ng-if=\"endorsement.status == 3\">Rechazado</span> <span ng-if=\"endorsement.status == 5\">En trámite</span> <span ng-if=\"endorsement.status == 4\">Cancelado</span></span></td><td class=\"text-center\"><button class=\"btn btn-xs btn-primary\" ng-click=\"vm.goToEndorsement(endorsement.id)\"><i class=\"fa fa-external-link\"></i> Ver</button></td></tr></tbody></table></uib-tab><uib-tab heading=\"Endosos a Certificados ({{vm.endorsementsCert.length || 0}})\" index=\"1\"><div class=\"m-t-sm\" ng-if=\"vm.loadingEndorsementsCert\"><i class=\"fa fa-spinner fa-spin\"></i> Cargando endosos de certificados...</div><div class=\"alert alert-info m-t-sm\" ng-if=\"!vm.loadingEndorsementsCert && (!vm.endorsementsCert || !vm.endorsementsCert.length)\">No hay endosos registrados en certificados asociados a esta póliza.</div><table class=\"table table-bordered table-striped table-hover m-t-sm\" ng-if=\"!vm.loadingEndorsementsCert && vm.endorsementsCert.length\"><thead><tr><th>Certificado</th><th style=\"width:70px;\">Tipo</th><th>Número de Endoso</th><th>Concepto</th><th>Descripción</th><th>Vigencia</th><th>Estatus</th><th style=\"width:120px;\"></th></tr></thead><tbody><tr ng-repeat=\"ec in vm.endorsementsCert | orderBy:\'-created_at\'\" ng-click=\"goToEndorsement(ec.id)\"><td><strong>{{ec.poliza_certificate_number || ec.poliza_poliza_number_number || (\'Certificado #\' + ec.poliza_poliza_number)}}</strong></td><td class=\"text-center\">{{ec.endorsement_type}}</td><td>{{ec.number_endorsement || \'Sin número asignado\'}}</td><td><span>{{ concept(ec.concept) }}</span> <span ng-if=\"concept(ec.concept) == \'OTRO\'\">: {{ec.other_desc}}</span></td><td>{{ec.observations || ec.description}}</td><td>{{(ec.init_date | date:\'dd/MM/yyyy\') + \' - \' + (ec.end_date | date:\'dd/MM/yyyy\')}}</td><td><span class=\"label label-default\"><span ng-if=\"ec.status == 1\">Pendiente</span> <span ng-if=\"ec.status == 2\">Registrado</span> <span ng-if=\"ec.status == 3\">Rechazado</span> <span ng-if=\"ec.status == 5\">En trámite</span> <span ng-if=\"ec.status == 4\">Cancelado</span></span></td><td class=\"text-center\"><button class=\"btn btn-xs btn-primary\" ng-click=\"vm.goToEndorsement(ec.id)\"><i class=\"fa fa-external-link\"></i> Ver</button></td></tr></tbody></table></uib-tab></uib-tabset></div></div></div><div class=\"row\" ng-if=\"noteFlag\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"returnToInfo()\"><span class=\"fa fa-reply\" aria-hidden=\"true\"></span> Regresar</button></div><div class=\"col-xs-12 form-group\"><table class=\"table table-hover table-bordered\"><thead><th>Número de Póliza</th><th>Número de Endoso</th><th>Folio</th><th>Vigencia</th><th>Prima Total</th><th>Estatus</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"note in notesCaratula track by $index\" ng-click=\"changeStatusModal(cover_contractor, note)\" ng-if=\"note.status != \'Desactivado\'\"><td>{{ note.poliza.poliza_number }}</td><td ng-if=\"note.endorsement\">{{ note.endorsement.number_endorsement }}</td><td ng-if=\"!note.endorsement\">Nota de crédito libre</td><td>{{ note.folio }}</td><td>{{ note.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ note.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ note.prima_total | currency }}</td><td>{{ note.status }}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-sm btn-white\" ng-click=\"editReceipt(note)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a ng-if=\"note.status == \'Pendiente de pago\' && acceso_elim_rec\" ng-click=\"deleteReceipts(note,$index)\" class=\"btn btn-white btn-sm\" title=\"Eliminar recibo\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><button class=\"btn btn-primary pull-right\" ng-click=\"createNotes(caratula)\">Crear nota de crédito</button></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"vm.recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"vm.recordatoriosFlag = false; vm.infoFlag = true\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in caratula.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div class=\"row\" ng-if=\"adjuFlag\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"returnToInfo()\"><span class=\"fa fa-reply\" aria-hidden=\"true\"></span> Regresar</button></div><div class=\"col-xs-12 form-group\" id=\"exportable\"><table class=\"table table-bordered table-hover\"><thead><tr><th>No. Endoso</th><th>Tipo</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>IVA</th><th>Prima Total</th></tr></thead><tbody><tr ng-repeat=\"endosos in endorsement_history\"><td>{{ endosos.number_endorsement }}</td><td>{{ endosos.endorsement_type }}</td><td align=\"right\">{{ endosos.p_neta | currency }}</td><td align=\"right\">{{ endosos.rpf | currency }}</td><td align=\"right\">{{ endosos.derecho | currency }}</td><td align=\"right\">{{ endosos.iva | currency }}</td><td align=\"right\">{{ endosos.p_total | currency }}</td></tr><tr><td><b>Totales</b></td><td></td><td align=\"right\"><b>{{ ajuste_neta | currency }}</b></td><td align=\"right\"><b>{{ ajuste_rpf | currency }}</b></td><td align=\"right\"><b>{{ ajuste_derecho | currency }}</b></td><td align=\"right\"><b>{{ ajuste_iva | currency }}</b></td><td align=\"right\"><b>{{ ajuste_total | currency }}</b></td></tr></tbody></table></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"downloadExcelAdjustment()\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar Reporte</button></div></div></div></div></div><div class=\"row\" ng-if=\"show_masivopdfs\"><div class=\"col-xs-12\"><div class=\"panel panel-default\"><div class=\"panel-heading text-align-center\"><strong>Carga masiva de PDFs <span class=\"pull-right\"><i class=\"fa fa-file-pdf-o\"></i></span></strong><div class=\"text-muted blue-color\" style=\"margin-top:4px;\">Selecciona varios PDFs.<br>Se asignarán automáticamente si el nombre del archivo coincide con el titular del certificado.</div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-8 col-xs-12 m-b-sm\" style=\"margin-top:8px;\"><input id=\"massivePdfInput\" type=\"file\" accept=\"application/pdf\" multiple=\"\" file-change=\"vm.onMassiveFilesSelected(files)\" class=\"form-control\"><div class=\"well well-sm\" style=\"margin-top:8px;\"><i class=\"fa fa-lightbulb-o\"></i> <b>Tip:</b> Normalizamos el nombre del PDF (mayúsculas/acentos/espacios/_) y se asigna a <b>todas</b> las coincidencias.</div></div><div class=\"col-sm-4 col-xs-12 m-b-sm\" style=\"margin-top:8px;\"><button class=\"btn btn-success btn-block ladda-button-x\" ng-disabled=\"!vm.massive.files.length || vm.massive.loading\" ng-click=\"vm.uploadMassivePDFs()\"><i class=\"fa fa-cloud-upload\"></i> {{ vm.massive.loading ? \'Procesando...\' : \'Procesar PDFs\' }}</button> <button class=\"btn btn-default btn-block\" ng-disabled=\"vm.massive.loading\" ng-click=\"vm.clearMassivePDFs()\"><i class=\"fa fa-trash\"></i> Limpiar</button></div></div><div class=\"row\" ng-if=\"vm.massive.files.length\"><div class=\"col-xs-12\"><div class=\"alert alert-info\"><strong>{{vm.massive.files.length}}</strong> archivo(s) seleccionado(s). <span class=\"text-muted\">Solo se subirán los que tengan match con un titular.</span></div><table class=\"table table-striped table-bordered\"><thead><tr><th>Archivo</th><th style=\"width:120px;\">Acción</th></tr></thead><tbody><tr ng-repeat=\"f in vm.massive.files track by $index\"><td>{{f.name}}</td><td><button class=\"btn btn-xs btn-danger\" ng-click=\"vm.removeMassiveFile($index)\">Quitar</button></td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"vm.massive.result\"><div class=\"col-xs-12\" style=\"margin-top:8px;\"><div class=\"alert alert-success\" ng-if=\"vm.massive.result.summary\"><strong>Resumen:</strong> Seleccionados: <b>{{vm.massive.result.summary.total}}</b> | Cargados: <b>{{vm.massive.result.summary.matched}}</b> | Sin coincidencia: <b>{{vm.massive.result.summary.unmatched}}</b> | Errores: <b>{{vm.massive.result.summary.errors}}</b></div><button class=\"btn btn-warning pull-right\" ng-if=\"vm.massive.result.batch_id\" ng-click=\"vm.exportMassivePDFs(vm.massive.result.batch_id)\"><i class=\"fa fa-download\"></i> Exportar resultado a Excel</button><hr><h4>Cargados correctamente</h4><table class=\"table table-bordered table-striped\" ng-if=\"vm.massive.result.matched_list.length\"><thead><tr><th>Archivo</th><th>ID Certificado</th><th>Titular</th></tr></thead><tbody><tr ng-repeat=\"r in vm.massive.result.matched_list track by $index\"><td>{{r.filename}}</td><td>{{r.certificate_id}}</td><td>{{r.titular}}</td></tr></tbody></table><div class=\"text-muted\" ng-if=\"!vm.massive.result.matched_list.length\">No hubo PDFs cargados.</div><h4 style=\"margin-top:20px;\">Sin coincidencia</h4><table class=\"table table-bordered table-striped\" ng-if=\"vm.massive.result.unmatched_list.length\"><thead><tr><th>Archivo</th><th>Motivo</th></tr></thead><tbody><tr ng-repeat=\"r in vm.massive.result.unmatched_list track by $index\"><td>{{r.filename}}</td><td>{{r.reason}}</td></tr></tbody></table><div class=\"text-muted\" ng-if=\"!vm.massive.result.unmatched_list.length\">No hubo PDFs sin coincidencia.</div></div></div><div class=\"row\" style=\"margin-top:15px;margin-bottom: 10px;\"><div class=\"col-xs-12\"><button class=\"btn btn-default\" ng-click=\"vm.loadMassiveHistory()\" ng-disabled=\"vm.massiveHistory.loading\"><i class=\"fa fa-history\"></i> {{ vm.massiveHistory.loading ? \'Cargando...\' : \'Ver históricos de carga\' }}</button></div></div><div class=\"row\" ng-if=\"vm.massiveHistory.batches.length\" style=\"margin-top:10px;\"><div class=\"col-md-4 col-xs-12\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>Históricos</strong></div><div class=\"panel-body\" style=\"max-height:350px; overflow:auto;\"><div class=\"list-group\"><a href=\"\" class=\"list-group-item\" ng-repeat=\"b in vm.massiveHistory.batches track by b.batch_id\" ng-click=\"vm.openBatchPDFs(b)\" ng-class=\"{active: vm.massiveHistory.selected && vm.massiveHistory.selected.batch_id === b.batch_id}\"><div><strong>#{{b.batch_id}}</strong></div><div class=\"text-muted\">{{ b.created_at | date:\'dd/MM/yyyy HH:mm\' }}</div><div style=\"margin-top:4px;\"><span class=\"label label-success\">OK {{b.summary.matched}}</span> <span class=\"label label-warning\">Sin {{b.summary.unmatched}}</span> <span class=\"label label-danger\">Err {{b.summary.errors}}</span></div></a></div></div></div></div><div class=\"col-md-8 col-xs-12\" ng-if=\"vm.massiveHistory.detail\"><div class=\"panel panel-info\"><div class=\"panel-heading\"><strong>Detalle de la Carga #{{vm.massiveHistory.detail.batch_id}}</strong></div><div class=\"panel-body\" style=\"margin-top:8px;\"><div class=\"alert alert-success\"><strong>Resumen:</strong> Total {{vm.massiveHistory.detail.summary.total}} | Cargados {{vm.massiveHistory.detail.summary.matched}} | Sin coincidencia {{vm.massiveHistory.detail.summary.unmatched}} | Errores {{vm.massiveHistory.detail.summary.errors}}</div><h4>Cargados</h4><table class=\"table table-bordered table-striped\" ng-if=\"vm.massiveHistory.detail.matched_list.length\"><thead><tr><th>Archivo</th><th>Certificado</th><th>Número de Certificado</th><th>Titular</th><th>Archivo ID</th></tr></thead><tbody><tr ng-repeat=\"r in vm.massiveHistory.detail.matched_list track by $index\"><td>{{r.filename}}</td><td>{{r.certificate_id}}</td><td>{{r.numerocertificado}}</td><td>{{r.titular}}</td><td>{{r.polizas_file_id}}</td></tr></tbody></table><div class=\"text-muted\" ng-if=\"!vm.massiveHistory.detail.matched_list.length\">Sin cargados.</div><h4>Sin coincidencia</h4><table class=\"table table-bordered table-striped\" ng-if=\"vm.massiveHistory.detail.unmatched_list.length\"><thead><tr><th>Archivo</th><th>Motivo</th></tr></thead><tbody><tr ng-repeat=\"r in vm.massiveHistory.detail.unmatched_list track by $index\"><td>{{r.filename}}</td><td>{{r.reason}}</td></tr></tbody></table><h4>Errores</h4><table class=\"table table-bordered table-striped\" ng-if=\"vm.massiveHistory.detail.errors_list.length\"><thead><tr><th>Archivo</th><th>Error</th></tr></thead><tbody><tr ng-repeat=\"r in vm.massiveHistory.detail.errors_list track by $index\"><td>{{r.filename}}</td><td>{{r.reason}}</td></tr></tbody></table><div class=\"col-xs-12\" style=\"margin-top:8px;\"><button class=\"btn btn-warning pull-right\" style=\"margin-top:8px;\" ng-if=\"vm.massiveHistory.selected.batch_id\" ng-click=\"vm.exportMassivePDFs(vm.massiveHistory.selected.batch_id)\"><i class=\"fa fa-download\"></i> Exportar resultado a Excel</button></div></div><br></div></div></div></div></div></div></div><div ng-if=\"show_caratula && caratula.recibos_poliza.length > 0\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Recibos Póliza</h5></div><div class=\"ibox-content\"><table class=\"table table-bordered table-hover animate\" ng-if=\"!show_binnacle_receipt\"><thead><tr><th>Serie</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>Iva</th><th>Prima Total</th><th ng-if=\"permiso_comisiones\">Comisión</th><th ng-if=\"permiso_comisiones\">Comisión Conciliada</th><th>Vigencia</th><th>Vencimiento</th><th>Estatus</th><th>Entregado</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"recibo in caratula.recibos_poliza\" ng-if=\"recibo.receipt_type == 1 && recibo.status != 0\" ng-click=\"changeStatusModal(cover_contractor, recibo)\"><td ng-if=\"recibo.serie_manual\">{{recibo.recibo_numero}} / {{recibo.serie_manual}}</td><td ng-if=\"!recibo.serie_manual\">{{recibo.recibo_numero}} / {{caratula.recibos_poliza.length}}</td><td>{{recibo.prima_neta | currency}}</td><td>{{recibo.rpf | currency}}</td><td>{{recibo.derecho | currency}}</td><td>{{recibo.iva | currency}}</td><td>{{recibo.prima_total | currency}}</td><td ng-if=\"permiso_comisiones\">{{recibo.comision | currency}}</td><td ng-if=\"permiso_comisiones\">{{recibo.comision_conciliada | currency}}</td><td>{{recibo.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}} - {{recibo.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{recibo.vencimiento | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == 4, \'label-info\' : recibo.status == 5 || recibo.status == 6, \'label-primary\' : recibo.status == 1 || recibo.status == 3, \'label-warning\' : recibo.status == 2 || recibo.status == 8}\">{{ statusReceipt(recibo.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(recibo);\"><span ng-if=\"recibo.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!recibo.delivered\"><i class=\"fa fa-times\"></i></span></td><td ng-click=\"$event.stopPropagation()\"><span title=\"{{ vm.whatsappWebEnabled ? \'Recordatorio por WhatsApp Web\' : \'Recordatorio por SMS\' }}\" ng-if=\"acceso_adm_pol\"><button class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); addPhoneWhatsapp(recibo, cover_contractor)\" ng-disabled=\"!(recibo.status == 4)\" title=\"{{ vm.whatsappWebEnabled ? \'Recordatorio por WhatsApp Web\' : \'Recordatorio por SMS\' }}\"><img ng-if=\"!vm.whatsappWebEnabled\" style=\"height: 15px;\" class=\"icon-menu\" src=\"../../assets/comment-sms-solid.svg\"> <i ng-if=\"vm.whatsappWebEnabled\" class=\"fa fa-whatsapp\"></i></button></span> <a class=\"btn btn-white btn-sm\" ng-if=\"acceso_cor && !recibo.track_email && acceso_adm_pol\" ng-click=\"addEmailsConfirmPolicy(recibo, cover_contractor)\" ng-disabled=\"!(recibo.status == 4)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-if=\"acceso_cor && recibo.track_email && acceso_adm_pol\" ng-click=\"addEmailsConfirmPolicy(recibo, cover_contractor)\" ng-disabled=\"recibo.status != 4\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-if=\"!recibo.track_bitacora\" ng-click=\"showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"recibo.track_bitacora\" ng-click=\"showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a ng-if=\"caratula.conducto_de_pago != 1\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"{{get_conductos(caratula.conducto_de_pago)}}\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-sm btn-white\" ng-click=\"editReceipt(recibo)\" ng-if=\"acceso_adm_pol\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a ng-if=\"recibo.status == 4 && acceso_elim_rec && caratula.recibos_poliza.length > 1 && acceso_adm_pol\" ng-click=\"deleteReceipts(recibo,$index)\" class=\"btn btn-white btn-sm\" title=\"Eliminar recibo\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-info btn-sm\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(recibo,4)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-default sm\" style=\"color: red\" ng-click=\"$event.stopPropagation()\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\" ng-if=\"recibo.endosotramite\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\"></i></a><tasks click=\"addtask()\" type=\"3\" model=\"recibo.recibo_numero + \' de la póliza \' + caratula.poliza_number\" associated=\"caratula.id\" receipt=\"recibo.id\"></tasks></td></tr><tr><td><b>Totales</b></td><td><b>{{ total_prima | currency }}</b></td><td><b>{{ total_rpf | currency }}</b></td><td><b>{{ total_derecho | currency }}</b></td><td><b>{{ total_iva | currency }}</b></td><td><b>{{ total_total | currency }}</b></td><td ng-if=\"permiso_comisiones\"><b>{{ total_comision| currency }}</b></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><div class=\"col-xs-12\" ng-if=\"!show_binnacle_receipt\"><div class=\"identificador-dash-email\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se envio un correo.</span><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span> <button class=\"btn btn-primary pull-right\" ng-if=\"acceso_adm_pol\" ng-click=\"createReceipts(caratula)\">Crear Recibos</button></div><div class=\"row animate\" ng-if=\"show_binnacle_receipt\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><a class=\"col-xs-12 btn btn-info pull-right\" ng-click=\"returnToReceipts()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</a></div><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Bitácora de recibos</h3><hr></div><div><div class=\"col-xs-12 form-group\"><comments datasource=\"comments_data_receipt\" typemodel=\"4\" config=\"comments_config\" idmodel=\"receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div></div></div></div></div><div ng-if=\"show_caratula && endorsementsCaratula.endosos > 0\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Recibos de Endoso</h5></div><div ng-if=\"show_caratula\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\" \"=\"\"><button class=\"col-xs-12 btn btn-secondary button-title-green\" style=\"border-color: green;\" ng-click=\"traerRecibosEndosos(vm.form.endoso_n,null,1)\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> VER RECIBOS DE ENDOSOS</button></div><div class=\"ibox-content\"><div class=\"row col-sm-6\"><select class=\"form-control\" ng-model=\"vm.form.endoso_n\" data-ng-options=\"endoso_n[1] for endoso_n in vm.endosos_options track by endoso_n\" ng-change=\"vm.changeEndorsement(vm.form.endoso_n,\'\',1)\"><option value=\"\">Todos los endosos</option></select><br></div><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle_receipt_endorsement\"><thead><tr><th>Número endoso</th><th>Serie</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>Iva</th><th>Prima Total</th><th ng-if=\"permiso_comisiones\">Comisión</th><th width=\"5%\" ng-if=\"permiso_comisiones\">Comisión conciliada</th><th>Vigencia</th><th>Vencimiento</th><th>Estatus</th><th>Entregado</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"recibo in recibosEndosos\" ng-click=\"changeStatusModal(cover_contractor, recibo)\"><td>{{recibo.endorsement}}</td><td>{{recibo.recibo_numero}}</td><td>{{recibo.prima_neta | currency}}</td><td>{{recibo.rpf | currency}}</td><td>{{recibo.derecho | currency}}</td><td>{{recibo.iva | currency}}</td><td>{{recibo.prima_total | currency}}</td><td ng-if=\"permiso_comisiones\">{{recibo.comision | currency}}</td><td width=\"5%\" ng-if=\"permiso_comisiones\">{{recibo.comision_conciliada | currency}}</td><td>{{recibo.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}} - {{recibo.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{recibo.vencimiento | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == 4, \'label-info\' : recibo.status == 5 || recibo.status == 6, \'label-primary\' : recibo.status == 1 || recibo.status == 3, \'label-warning\' : recibo.status == 2 || recibo.status == 8}\">{{ statusReceipt(recibo.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(recibo)\"><span ng-if=\"recibo.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!recibo.delivered\"><i class=\"fa fa-times\"></i></span></td><td><a class=\"btn btn-white btn-sm\" ng-if=\"!recibo.track_bitacora\" ng-click=\"$event.stopPropagation(); showBinnacleReceiptEndorsement(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"recibo.track_bitacora\" ng-click=\"$event.stopPropagation(); showBinnacleReceiptEndorsement(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-if=\"acceso_cor\" ng-click=\"$event.stopPropagation(); addEmailsConfirmPolicy(recibo, cover_contractor)\" ng-disabled=\"recibo.status != 4\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a ng-if=\"recibo.poliza.conducto_de_pago != 1\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"{{get_conductos(recibo.poliza.conducto_de_pago)}}\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-info btn-sm\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(recibo,4)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a></td></tr><tr><td><b>Totales</b></td><td><b>{{ endorsement_total_prima | currency }}</b></td><td><b>{{ endorsement_total_rpf | currency }}</b></td><td><b>{{ endorsement_total_derecho | currency }}</b></td><td><b>{{ endorsement_total_iva | currency }}</b></td><td><b>{{ endorsement_total_total | currency }}</b></td><td><b>{{ endorsement_total_comision| currency }}</b></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><div ng-if=\"vm.show_pag_recendoso\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPagesE()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPagesE | slice:start:end\" ng-class=\"{\'active\': page === actual_pageE}\" ng-click=\"selectPageE(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPagesE.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPageE()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"col-xs-12\" ng-if=\"!show_binnacle_receipt_endorsement\"><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div><div class=\"row animate\" ng-if=\"show_binnacle_receipt_endorsement\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><a class=\"col-xs-12 btn btn-info pull-right\" ng-click=\"returnToReceiptsEndorsement()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</a></div><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Bitácora de recibos</h3><hr></div><div><div class=\"col-xs-12 form-group\"><comments datasource=\"comments_data_receipt\" typemodel=\"4\" config=\"comments_config\" idmodel=\"receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div></div></div></div></div><div ng-if=\"show_caratula && policy_history.length > 0\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Histórico renovaciones y cancelaciones</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th>Número de Póliza</th><th>Vigencia</th><th>Estatus</th><th>Fecha de Renovación</th><th>Renovado Por:</th></tr></thead><tbody><tr ng-repeat=\"policy in policy_history track by $index\" ng-click=\"goToPolicy(policy)\"><td ng-if=\"policy.poliza_number\">{{policy.poliza_number}}</td><td ng-if=\"!policy.poliza_number\">Sin número asignado</td><td>{{ policy.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}} - {{ policy.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{status(policy.status)}}</td><td>{{policy.created_at | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{policy.owner}}</td></tr></tbody></table></div></div></div></div></div><div ng-if=\"show_caratula\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Archivos</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-if=\"permiso_administrar_adjuntos\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(caratula)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Archivos</button></div></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th width=\"200px\" ng-if=\"permiso_archivos && permiso_administrar_adjuntos\"></th></tr></thead><tbody><tr ng-repeat=\"file in filesCover track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_input\" class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"saveFile(file)\" ng-if=\"permiso_administrar_adjuntos\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,filesCover,caratula)\" ng-if=\"permiso_administrar_adjuntos\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"permiso_administrar_adjuntos\">Renombrar</button> <span class=\"btn btn-success display-none\" ng-if=\"permiso_administrar_adjuntos\">Guardar</span></td><td ng-if=\"permiso_archivos && permiso_administrar_adjuntos\"><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> * Archivo sensible</td></tr></tbody></table></div></div></div></div></div></div><div ng-if=\"show_caratula\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"comments_data\" config=\"comments_config\" typemodel=\"18\" idmodel=\"caratula.id\" exportable=\"true\"></comments></div></div></div></div></div><div ng-if=\"show_subgrupo\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Subgrupos y Categorías</h5></div><div class=\"ibox-content\"><div class=\"row\" ng-repeat=\"subgroup in subgrupos\" ng-init=\"viewReceipts[$index] = false;\"><div class=\"col-xs-12\"><legend class=\"legend-title\">Subgrupo: {{ subgroup.name }} <button class=\"btn btn-white margin-right-10 pull-right\" ng-click=\"deleteSubgroup(subgroup, $index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i> Eliminar</button> <button class=\"btn btn-primary margin-right-10 pull-right\" ng-init=\"subgroup.showFile = false\" ng-click=\"showFiles(subgroup, $index)\"><i class=\"fa fa-file\" aria-hidden=\"true\"></i> Ver Archivos</button> <button class=\"btn btn-success margin-right-10 pull-right\" ng-if=\"caratula.receipts_by == 2\" ng-click=\"viewReceipts[$index] ? viewReceipts[$index] = false : viewReceipts[$index] = true;\"><i class=\"fa fa-bars\" aria-hidden=\"true\"></i> Ver Recibos</button></legend></div><div class=\"col-xs-12 col-sm-4\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">ID:</span><div><span><b>{{ subgroup.id }}</b></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ subgroup.name }}</span></div></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.receipts_by == 2\"><span class=\"blue-color\">Contratante:</span><div><span>{{ subgroup.contractor.full_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.receipts_by == 2\"><span class=\"blue-color\">Dirección:</span><div><span>{{ subgroup.contractor.address_contractor[0].administrative_area_level_1 }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ subgroup.observations }}</span></div></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 animate\" ng-if=\"viewReceipts[$index]\"><legend class=\"legend-title\" align=\"center\">Recibos del Subgrupo</legend><div class=\"col-xs-12 form-group\" ng-if=\"!show_binnacle_receipt_subgroup\"><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"caratula\"><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"caratula\"><span class=\"blue-color\">Conducto de pago:</span><div><span>{{ get_conductos(caratula.conducto_de_pago) }}</span> <a ng-click=\"editCollective(caratula)\"><button><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> Editar</button></a></div></div></div></div><table class=\"table table-bordered table-hover animate\" ng-if=\"!show_binnacle_receipt_subgroup\"><thead><th>Serie</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>Iva</th><th>Prima Total</th><th ng-if=\"permiso_comisiones\">Comisión</th><th>Vigencia</th><th>Vencimiento</th><th>Estatus</th><th>Entregado</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"recibo in subgroup.recibos_poliza\" ng-click=\"changeStatusModal(cover_contractor, recibo)\"><td>{{ recibo.recibo_numero }}</td><td>{{ recibo.prima_neta | currency }}</td><td>{{ recibo.rpf | currency }}</td><td>{{ recibo.derecho | currency }}</td><td>{{ recibo.iva | currency }}</td><td>{{ recibo.prima_total | currency }}</td><td ng-if=\"permiso_comisiones\">{{ recibo.comision | currency }}</td><td>{{ recibo.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\' }} - {{ recibo.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ recibo.vencimiento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == 4, \'label-info\' : recibo.status == 5 || recibo.status == 6, \'label-primary\' : recibo.status == 1 || recibo.status == 3, \'label-warning\' : recibo.status == 2 || recibo.status == 8}\">{{ statusReceipt(recibo.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(recibo)\"><span ng-if=\"recibo.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!recibo.delivered\"><i class=\"fa fa-times\"></i></span></td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-if=\"acceso_cor && !recibo.track_email\" ng-click=\"addEmailsConfirmPolicy(recibo, cover_contractor)\" ng-disabled=\"!(recibo.status == 4)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-if=\"acceso_cor && recibo.track_email\" ng-click=\"addEmailsConfirmPolicy(recibo, cover_contractor)\" ng-disabled=\"recibo.status != 4\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-if=\"!recibo.track_bitacora\" ng-click=\"showBinnacleReceiptSubgroup(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"recibo.track_bitacora\" ng-click=\"showBinnacleReceiptSubgroup(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a ng-if=\"recibo.is_cat\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-info btn-sm\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(recibo,4)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a> <button class=\"btn btn-sm btn-white\" ng-click=\"editReceipt(recibo)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></td></tr><tr><td><b>Totales</b></td><td><b>{{ subgroup_total_prima[$index].total_prima | currency }}</b></td><td><b>{{ subgroup_total_prima[$index].total_rpf | currency }}</b></td><td><b>{{ subgroup_total_prima[$index].total_derecho | currency }}</b></td><td><b>{{ subgroup_total_prima[$index].total_iva | currency }}</b></td><td><b>{{ subgroup_total_prima[$index].total_total | currency }}</b></td><td><b>{{ subgroup_total_prima[$index].total_comision| currency }}</b></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><div class=\"col-xs-12\" ng-if=\"!show_binnacle_receipt_subgroup\"><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span> <button class=\"btn btn-primary pull-right\" ng-click=\"createReceipts(subgroup)\">Crear Recibos</button><hr></div><div class=\"row animate\" ng-if=\"show_binnacle_receipt_subgroup\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><a class=\"col-xs-12 btn btn-info pull-right\" ng-click=\"returnToReceiptsSubgroup()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</a></div><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Bitácora de recibos</h3><hr></div><div><div class=\"col-xs-12 form-group\"><comments datasource=\"comments_data_receipt\" typemodel=\"4\" config=\"comments_config\" idmodel=\"receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div></div></div><div class=\"col-xs-12 animate\" ng-if=\"subgroup.showFile && permiso_administrar_adjuntos\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(subgroup)\">Guardar Archivos</button></div><div class=\"row col-md-12 col-sm-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th width=\"200px\" ng-if=\"permiso_archivos && permiso_administrar_adjuntos\"></th></tr></thead><tbody><tr ng-repeat=\"file in subgroup.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_input\" class=\"form-control display-none\" ng-if=\"permiso_administrar_adjuntos\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"saveFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,subgroup.files,subgroup)\" ng-if=\"permiso_administrar_adjuntos\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"permiso_administrar_adjuntos\">Renombrar</button> <span class=\"btn btn-success display-none\" ng-if=\"permiso_administrar_adjuntos\">Guardar</span></td><td ng-if=\"permiso_archivos && permiso_administrar_adjuntos\"><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> * Archivo sensible</td></tr></tbody></table></div></div></div><div class=\"col-xs-12\" ng-repeat=\"category in subgroup.categorias\"><legend class=\"legend-title\">Categoría: {{ category.name }} <button class=\"btn btn-white margin-right-10 pull-right\" ng-click=\"deleteCategory(category, subgroup, $index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i> Eliminar</button> <button class=\"btn btn-primary margin-right-10 pull-right\" ng-init=\"category.showFile = false\" ng-if=\"permiso_administrar_adjuntos\" ng-click=\"showFiles(category)\"><i class=\"fa fa-file\" aria-hidden=\"true\"></i> Ver Archivos</button></legend><div class=\"col-xs-12 jumbotron\"><div class=\"col-xs-12 col-sm-2 form-group\"><span class=\"blue-color\">ID:</span><div><span><b>{{ category.id }}</b></span></div></div><div class=\"col-xs-12 col-sm-2 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ category.name }}</span></div></div><div class=\"col-xs-12 col-sm-8 form-group\"><span class=\"blue-color\">Certificados:</span><div><div class=\"col-xs-12 col-sm-3 form-group\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"getCertificates(category, 1)\" ng-disabled=\"category.certificados_activos == 0\"><i class=\"fa fa-arrow-circle-o-up\" aria-hidden=\"true\"></i> Activos ({{ category.certificados_activos }})</button></div><div class=\"col-xs-12 col-sm-3 form-group\"><button class=\"col-xs-12 btn btn-warning\" ng-click=\"getCertificates(category, 2)\" ng-disabled=\"category.certificados_inactivos == 0\"><i class=\"fa fa-arrow-circle-o-down\" aria-hidden=\"true\"></i> Inactivos ({{ category.certificados_inactivos }})</button></div></div></div><div class=\"col-xs-12 col-sm-2 form-group\"><span class=\"blue-color\">Nivel Hospitalario:</span><div><span>{{ category.hospital_level }}</span></div></div></div><div class=\"ibox-content col-xs-12 animate\" ng-if=\"category.showFile\"><div ng-include=\"\'templates/upload.html\'\" ng-if=\"permiso_administrar_adjuntos\"></div><div class=\"col-xs-12 text-right form-group\" ng-if=\"permiso_administrar_adjuntos\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(category)\">Guardar Archivos</button></div><div class=\"row col-md-12 col-sm-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th ng-if=\"permiso_archivos && permiso_administrar_adjuntos\" width=\"200px\"></th></tr></thead><tbody><tr ng-repeat=\"file in category.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_input\" class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-if=\"permiso_administrar_adjuntos\" ng-blur=\"saveFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,category.files,category)\" ng-if=\"permiso_administrar_adjuntos\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"permiso_administrar_adjuntos\">Renombrar</button> <span class=\"btn btn-success display-none\" ng-if=\"permiso_administrar_adjuntos\">Guardar</span></td><td ng-if=\"permiso_archivos && permiso_administrar_adjuntos\"><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> * Archivo sensible</td></tr></tbody></table></div></div><br></div></div></div></div></div></div><div ng-if=\"show_paquete\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Paquetes</h5></div><div class=\"ibox-content\"><div class=\"row\" ng-repeat=\"pack in paquetes\"><div class=\"col-xs-12\"><legend class=\"legend-title\">Paquete: {{ pack.package_name }}</legend></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">ID:</span><div><span><b>{{ pack.id }}</b></span></div></div><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Coberturas</th><th>Suma Asegurada</th><th>Deducible</th><th ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">Coaseguro</th><th ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">Tope de Coaseguro</th></tr></thead><tbody><tr ng-repeat=\"item in pack.coverage_package\"><td>{{ item.coverage_name }}</td><td>{{ item.sums_coverage[0].sum_insured }}</td><td>{{ item.deductible_coverage[0].deductible }}</td><td ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">{{ item.coinsurance_coverage[0].coinsurance }}</td><td ng-if=\"caratula.subramo.subramo_name == \'Gastos Médicos\'\">{{ item.topecoinsurance_coverage[0].topecoinsurance }}</td></tr></tbody></table></div></div></div></div></div><div ng-if=\"show_certificado && show_tableCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Certificados</h5></div><div class=\"ibox-content\"><div class=\"row animate\" ng-if=\"infoFlagCertificate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"allCertificates()\"><i class=\"fa fa-bars\" aria-hidden=\"true\"></i> Todos los Certificados</button></div><div class=\"col-xs-12 col-sm-2 form-group pull-right\" ng-if=\"caratula.receipts_by == 3\"><button class=\"col-xs-12 btn btn-success pull-right\" ng-click=\"showItemCertificate(6)\" ng-disabled=\"categorySelected.certificates == 0\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Ver</button></div><div class=\"col-xs-12 col-sm-2 form-group pull-right\" ng-if=\"caratula.receipts_by == 3\"><button class=\"col-xs-12 btn btn-success pull-right\" ng-click=\"showItemCertificate(5)\" ng-disabled=\"categorySelected.certificates == 0\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Recibos</button></div><div class=\"col-xs-12 col-sm-2 form-group pull-right\" ng-if=\"caratula.ramo.ramo_code==1 || caratula.ramo.ramo_code ==2 || caratula.subramo.subramo_code ==13 || caratula.subramo.subramo_code ==7 || caratula.subramo.subramo_code ==9\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"showItemCertificate(4)\" ng-disabled=\"!showOt\"><i class=\"fa fa-list\" aria-hidden=\"true\"></i> Layout</button></div><div class=\"col-xs-12 col-sm-2 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"createIndividualCertificate()\" ng-disabled=\"!showOt\"><i class=\"fa fa-ellipsis-h\" aria-hidden=\"true\"></i> Manual</button></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Buscar</label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-enter=\"search(cadena)\" ng-model=\"cadena\" placeholder=\"Certificado, Nombre Titular, Beneficiarios, Dependientes, Marca, Serial\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"search(cadena)\">Buscar</button></div></div></div><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered table-hover\" ng-if=\"caratula.ramo.ramo_name == \'Vida\' && !show_beneficiarie\"><thead><th>Certificado</th><th>Folio</th><th>No. Póliza</th><th>Estatus</th><th>Titular</th><th>Sexo</th><th>Beneficiarios</th><th>Fecha Antigüedad</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"item in categorySelected.certificates | orderBy: \'certificate_number\' track by $index\" ng-click=\"selectCerficate(item)\"><td>{{ item.certificate_number }}</td><td>{{ item.folio }}</td><td>{{ item.poliza_number }}</td><td><div class=\"label\" ng-class=\"{\'label-success\': item.certificado_inciso_activo == true, \'label-warning\' : item.certificado_inciso_activo == false}\" style=\"margin-right: 10px\"><span ng-if=\"item.certificado_inciso_activo\">Activo</span> <span ng-if=\"!item.certificado_inciso_activo\">Inactivo</span></div></td><td>{{ item.life_policy[0].personal.first_name }} {{ item.life_policy[0].personal.last_name }} {{ item.life_policy[0].personal.second_last_name }}</td><td><span ng-if=\"item.life_policy[0].personal.sex == \'F\'\">Femenino</span> <span ng-if=\"item.life_policy[0].personal.sex == \'M\'\">Masculino</span></td><td><ul><li ng-repeat=\"beneficiary in item.life_policy[0].beneficiaries_life\"><span>{{ beneficiary.first_name }} {{ beneficiary.last_name }} {{ beneficiary.second_last_name }}</span><div><small ng-if=\"beneficiary.is_active && item.certificado_inciso_activo\"><b>Activo</b></small> <small ng-if=\"!beneficiary.is_active || !item.certificado_inciso_activo\"><b>Inactivo</b></small></div></li></ul></td><td><span ng-if=\"item.rec_antiguedad\">{{ item.rec_antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <span ng-if=\"!item.rec_antiguedad\">{{ item.life_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></td><td ng-click=\"$event.stopPropagation()\"><button ng-if=\"acceso_adm_pol\" class=\"btn btn-white\" ng-click=\"editCerficate(item)\" title=\"Editar Certificado\"><span class=\"fa fa-pencil\"></span></button> <button ng-if=\"acceso_adm_pol\" class=\"btn btn-white\" ng-click=\"addDependent(item)\" title=\"Agregar Beneficiarios\"><span class=\"fa fa-user-plus\"></span></button> <button ng-if=\"acceso_elim_pol\" class=\"btn btn-white\" ng-click=\"deleteCertificate(item)\" title=\"Eliminar Certificado\"><span class=\"fa fa-trash\"></span></button> <button class=\"btn btn-white\" ng-if=\"item.recibos_poliza.length\" ng-click=\"deleteReceiptsCertificate(item)\" title=\"Existen recibos\"><span class=\"fa fa-list-alt\"></span></button> <button class=\"btn btn-white\" ng-click=\"showEndorsementsCertificate(item)\">Endosos({{ item.endosos }})</button> <button class=\"btn btn-white\" ng-click=\"showSinistersCertificate(item)\">Siniestros({{ item.siniestros }})</button></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.ramo.ramo_code == 2 && !show_beneficiarie\"><thead><th>Certificado</th><th>Folio</th><th>No. Póliza</th><th>Estatus</th><th>Titular</th><th>Sexo</th><th>Dependientes</th><th>Fecha Antigüedad</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"item in categorySelected.certificates | orderBy: \'certificate_number\' track by $index\" ng-click=\"selectCerficate(item)\"><td>{{ item.certificate_number }}</td><td>{{ item.folio }}</td><td>{{ item.poliza_number }}</td><td><div class=\"label\" ng-class=\"{\'label-success\': item.certificado_inciso_activo == true, \'label-warning\' : item.certificado_inciso_activo == false}\" style=\"margin-right: 10px\"><span ng-if=\"item.certificado_inciso_activo\">Activo</span> <span ng-if=\"!item.certificado_inciso_activo\">Inactivo</span></div></td><td>{{ item.accidents_policy[0].personal.first_name }} {{ item.accidents_policy[0].personal.last_name }} {{ item.accidents_policy[0].personal.second_last_name }}</td><td><span ng-if=\"item.accidents_policy[0].personal.sex == \'F\'\">Femenino</span> <span ng-if=\"item.accidents_policy[0].personal.sex == \'M\'\">Masculino</span></td><td><ul><li ng-repeat=\"beneficiary in item.accidents_policy[0].relationship_accident\"><span><span ng-if=\"beneficiary.certificate\">{{ beneficiary.certificate }} |</span>{{ beneficiary.first_name }} {{ beneficiary.last_name }} {{ beneficiary.second_last_name }}</span><div><small ng-if=\"beneficiary.is_active && item.certificado_inciso_activo\"><b>Activo</b></small> <small ng-if=\"!beneficiary.is_active || !item.certificado_inciso_activo\"><b>Inactivo</b></small></div></li></ul></td><td><span ng-if=\"item.rec_antiguedad\">{{ item.rec_antiguedad | date: \'dd/MM/yyyy\': \'UTC\' }}</span> <span ng-if=\"!item.rec_antiguedad\">{{ item.accidents_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></td><td ng-click=\"$event.stopPropagation()\"><button ng-if=\"acceso_adm_pol\" class=\"btn btn-white\" ng-click=\"editCerficate(item)\" title=\"Editar Certificado\"><span class=\"fa fa-pencil\"></span></button> <button ng-if=\"acceso_adm_pol\" class=\"btn btn-white\" ng-click=\"addDependent(item)\" title=\"Agregar Dependientes\"><span class=\"fa fa-user-plus\"></span></button> <button ng-if=\"acceso_elim_pol\" class=\"btn btn-white\" ng-click=\"deleteCertificate(item)\" title=\"Eliminar Certificado\"><span class=\"fa fa-trash\"></span></button> <button class=\"btn btn-white\" ng-if=\"item.recibos_poliza.length\" ng-click=\"deleteReceiptsCertificate(item)\" title=\"Existen recibos\"><span class=\"fa fa-list-alt\"></span></button> <button class=\"btn btn-white\" ng-click=\"showEndorsementsCertificate(item)\">Endosos({{ item.endosos }})</button> <button class=\"btn btn-white\" ng-click=\"showSinistersCertificate(item)\">Siniestros({{ item.siniestros }})</button></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.subramo.subramo_code == 9\"><thead><th>Certificado</th><th>No. Póliza</th><th>Estatus</th><th>Marca</th><th>Modelo</th><th>Año</th><th>Versión</th><th>Serie</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"item in categorySelected.certificates | orderBy: \'certificate_number\' track by $index\" ng-click=\"selectCerficate(item)\"><td>{{ item.certificate_number }}</td><td>{{ item.poliza_number }}</td><td><div class=\"label\" ng-class=\"{\'label-success\': item.certificado_inciso_activo == true, \'label-warning\' : item.certificado_inciso_activo == false}\" style=\"margin-right: 10px\"><span ng-if=\"item.certificado_inciso_activo\">Activo</span> <span ng-if=\"!item.certificado_inciso_activo\">Inactivo</span></div></td><td>{{ item.automobiles_policy[0].brand }}</td><td>{{ item.automobiles_policy[0].model }}</td><td>{{ item.automobiles_policy[0].year }}</td><td>{{ item.automobiles_policy[0].version }}</td><td>{{ item.automobiles_policy[0].serial }}</td><td ng-click=\"$event.stopPropagation()\"><button ng-if=\"acceso_adm_pol\" class=\"btn btn-white\" ng-click=\"editCerficate(item)\" title=\"Editar Certificado\"><span class=\"fa fa-pencil\"></span></button> <button ng-if=\"acceso_elim_pol\" class=\"btn btn-white\" ng-click=\"deleteCertificate(item)\" title=\"Eliminar Certificado\"><span class=\"fa fa-trash\"></span></button> <button class=\"btn btn-white\" ng-if=\"item.recibos_poliza.length\" ng-click=\"deleteReceiptsCertificate(item)\" title=\"Existen recibos\"><span class=\"fa fa-list-alt\"></span></button> <button class=\"btn btn-white\" ng-click=\"showEndorsementsCertificate(item)\">Endosos({{ item.endosos }})</button> <button class=\"btn btn-white\" ng-click=\"showSinistersCertificate(item)\">Siniestros({{ item.siniestros }})</button></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.subramo.subramo_code == 13\"><thead><th>Certificado</th><th>No. Póliza</th><th>Estatus</th><th>Marca</th><th>Modelo</th><th>Año Construcción</th><th>Versión</th><th>Serie</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"item in categorySelected.certificates | orderBy: \'certificate_number\' track by $index\" ng-click=\"selectCerficate(item)\"><td>{{ item.certificate_number }}</td><td>{{ item.poliza_number }}</td><td><div class=\"label\" ng-class=\"{\'label-success\': item.certificado_inciso_activo == true, \'label-warning\' : item.certificado_inciso_activo == false}\" style=\"margin-right: 10px\"><span ng-if=\"item.certificado_inciso_activo\">Activo</span> <span ng-if=\"!item.certificado_inciso_activo\">Inactivo</span></div></td><td>{{ item.damages_policy[0].brand }}</td><td>{{ item.damages_policy[0].model }}</td><td>{{ item.damages_policy[0].construction_year }}</td><td>{{ item.damages_policy[0].version }}</td><td>{{ item.damages_policy[0].serial }}</td><td ng-click=\"$event.stopPropagation()\"><button ng-if=\"acceso_adm_pol\" class=\"btn btn-white\" ng-click=\"editCerficate(item)\" title=\"Editar Certificado\"><span class=\"fa fa-pencil\"></span></button> <button ng-if=\"acceso_elim_pol\" class=\"btn btn-white\" ng-click=\"deleteCertificate(item)\" title=\"Eliminar Certificado\"><span class=\"fa fa-trash\"></span></button> <button class=\"btn btn-white\" ng-if=\"item.recibos_poliza.length\" ng-click=\"deleteReceiptsCertificate(item)\" title=\"Existen recibos\"><span class=\"fa fa-list-alt\"></span></button> <button class=\"btn btn-white\" ng-click=\"showEndorsementsCertificate(item)\">Endosos({{ item.endosos }})</button> <button class=\"btn btn-white\" ng-click=\"showSinistersCertificate(item)\">Siniestros({{ item.siniestros }})</button></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.subramo.subramo_code == 7\"><thead><th>Certificado</th><th>No. Póliza</th><th>Estatus</th><th>Sucursal</th><th>Giro</th><th>Tipo Contructivo</th><th>No. Niveles</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"item in categorySelected.certificates | orderBy: \'certificate_number\' track by $index\" ng-click=\"selectCerficate(item)\"><td>{{ item.certificate_number }}</td><td>{{ item.poliza_number }}</td><td><div class=\"label\" ng-class=\"{\'label-success\': item.certificado_inciso_activo == true, \'label-warning\' : item.certificado_inciso_activo == false}\" style=\"margin-right: 10px\"><span ng-if=\"item.certificado_inciso_activo\">Activo</span> <span ng-if=\"!item.certificado_inciso_activo\">Inactivo</span></div></td><td>{{ item.damages_policy[0].sucursal }}</td><td>{{ item.damages_policy[0].giro }}</td><td><span ng-if=\"item.damages_policy[0].type_construction == 1\">Macizo</span> <span ng-if=\"item.damages_policy[0].type_construction == 2\">Madera</span> <span ng-if=\"item.damages_policy[0].type_construction == 3\">Lámina</span></td><td>{{ item.damages_policy[0].no_levels }}</td><td ng-click=\"$event.stopPropagation()\"><button ng-if=\"acceso_adm_pol\" class=\"btn btn-white\" ng-click=\"editCerficate(item)\" title=\"Editar Certificado\"><span class=\"fa fa-pencil\"></span></button> <button ng-if=\"acceso_elim_pol\" class=\"btn btn-white\" ng-click=\"deleteCertificate(item)\" title=\"Eliminar Certificado\"><span class=\"fa fa-trash\"></span></button> <button class=\"btn btn-white\" ng-if=\"item.recibos_poliza.length\" ng-click=\"deleteReceiptsCertificate(item)\" title=\"Existen recibos\"><span class=\"fa fa-list-alt\"></span></button> <button class=\"btn btn-white\" ng-click=\"showEndorsementsCertificate(item)\">Endosos({{ item.endosos }})</button> <button class=\"btn btn-white\" ng-click=\"showSinistersCertificate(item)\">Siniestros({{ item.siniestros }})</button></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.ramo.ramo_code ==3 && (caratula.subramo.subramo_code != 7 && caratula.subramo.subramo_code != 13 && caratula.subramo.subramo_code != 9)\"><thead><th>Certificado</th><th>No. Póliza</th><th>Estatus</th><th>Bien asegurado</th><th>Bien detalles</th><th>Bien dirección</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"item in categorySelected.certificates | orderBy: \'certificate_number\' track by $index\" ng-click=\"selectCerficate(item)\"><td>{{ item.certificate_number }}</td><td>{{ item.poliza_number }}</td><td><div class=\"label\" ng-class=\"{\'label-success\': item.certificado_inciso_activo == true, \'label-warning\' : item.certificado_inciso_activo == false}\" style=\"margin-right: 10px\"><span ng-if=\"item.certificado_inciso_activo\">Activo</span> <span ng-if=\"!item.certificado_inciso_activo\">Inactivo</span></div></td><td>{{ item.damages_policy[0].insured_item }}</td><td>{{ item.damages_policy[0].item_details }}</td><td>{{ item.damages_policy[0].item_address }}</td><td ng-click=\"$event.stopPropagation()\"><button ng-if=\"acceso_adm_pol\" class=\"btn btn-white\" ng-click=\"editCerficate(item)\" title=\"Editar Certificado\"><span class=\"fa fa-pencil\"></span></button> <button ng-if=\"acceso_elim_pol\" class=\"btn btn-white\" ng-click=\"deleteCertificate(item)\" title=\"Eliminar Certificado\"><span class=\"fa fa-trash\"></span></button> <button class=\"btn btn-white\" ng-if=\"item.recibos_poliza.length\" ng-click=\"deleteReceiptsCertificate(item)\" title=\"Existen recibos\"><span class=\"fa fa-list-alt\"></span></button> <button class=\"btn btn-white\" ng-click=\"showEndorsementsCertificate(item)\">Endosos({{ item.endosos }})</button> <button class=\"btn btn-white\" ng-click=\"showSinistersCertificate(item)\">Siniestros({{ item.siniestros }})</button></td></tr></tbody></table><div ng-if=\"show_beneficiarie\"><div class=\"address-container\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\">Certificado: {{ newBeneficierie.certificate_number }}</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Titular:</span><div><span>{{ newBeneficierie.accidents_policy[0].personal.first_name }} {{ newBeneficierie.accidents_policy[0].personal.last_name }} {{ newBeneficierie.accidents_policy[0].personal.second_last_name }} {{ newBeneficierie.life_policy[0].personal.first_name }} {{ newBeneficierie.life_policy[0].personal.last_name }} {{ newBeneficierie.life_policy[0].personal.second_last_name }}</span><br></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Antigüedad:</span><div><span ng-if=\"newBeneficierie.rec_antiguedad\">{{ newBeneficierie.rec_antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <span ng-if=\"!newBeneficierie.rec_antiguedad\">{{ newBeneficierie.accidents_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div></div><div class=\"address-container\" ng-if=\"newBeneficierie.accidents_policy.length\" ng-repeat=\"item in newBeneficierie.accidents_policy[0].relationship_accident\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteNewBeneficiarie($index); vm.saveLocalstorageBeneficiarie(item)\" ng-disabled=\"newBeneficierie.accidents_policy[0].relationship_accident.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Dependiente</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteNewBeneficiarie($index); vm.saveLocalstorageBeneficiarie(item)\" ng-disabled=\"newBeneficierie.accidents_policy[0].relationship_accident.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Dependiente #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addNewBeneficiarie();vm.saveLocalstorageBeneficiarie(item)\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> <span ng-if=\"newBeneficierie.accidents_policy.length\">Agregar Dependiente</span></button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addNewBeneficiarie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Certificado: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.certificate\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.first_name\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.last_name\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.second_last_name\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.birthdate\" value=\"{{item.birthdate}}\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Parentesco: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"relation.label for relation in relationships track by relation.value\" ng-model=\"item.relationship\" value=\"{{relation.value}}\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"sexbeneficiarie.label for sexbeneficiarie in sexs track by sexbeneficiarie.value\" ng-model=\"item.sex\" value=\"{{sexbeneficiarie.value}}\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.antiguedad\" value=\"{{item.antiguedad}}\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"row col-xs-12\"><div class=\"col-xs-12\" ng-if=\"newBeneficierie.contributory\"><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Clave:</label><div ng-if=\"newBeneficierie.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.rfc_cve\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Homoclave:</label><div ng-if=\"newBeneficierie.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.rfc_homocve\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Calle - Número:</label><div ng-if=\"newBeneficierie.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.dom_callenum\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Colonia:</label><div ng-if=\"newBeneficierie.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.dom_colonia\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">CP:</label><div ng-if=\"newBeneficierie.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.dom_cp\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Municipio:</label><div ng-if=\"newBeneficierie.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.dom_poblacion\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Estado:</label><div ng-if=\"newBeneficierie.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.dom_estado\"></div></div></div></div><br><div class=\"col-xs-12\" align=\"center\"><label>Primas del Dependiente</label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.p_neta\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.rpf\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.derecho\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.iva\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.p_total\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.comision\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div></div></div><div class=\"address-container\" ng-if=\"newBeneficierie.life_policy.length\" ng-repeat=\"item in newBeneficierie.life_policy[0].beneficiaries_life\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteNewBeneficiarie($index); vm.saveLocalstorageBeneficiarie(item)\" ng-disabled=\"newBeneficierie.life_policy[0].beneficiaries_life.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteNewBeneficiarie($index); vm.saveLocalstorageBeneficiarie(item)\" ng-disabled=\"newBeneficierie.life_policy[0].beneficiaries_life.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addNewBeneficiarie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addNewBeneficiarie(); vm.saveLocalstorageBeneficiarie(item)\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.first_name\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.last_name\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.second_last_name\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.birthdate\" value=\"{{item.birthdate}}\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Parentesco: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"relation.label for relation in relationships track by relation.value\" ng-model=\"item.optional_relationship\" value=\"{{relation.value}}\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"sexbeneficiarie.label for sexbeneficiarie in sexs track by sexbeneficiarie.value\" ng-model=\"item.sex\" value=\"{{sexbeneficiarie.value}}\" ng-change=\"vm.saveLocalstorageBeneficiarie(item)\"></select></div></div></div><div class=\"col-xs-12\"><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"saveBeneficiarie()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> <span ng-if=\"newBeneficierie.accidents_policy.length\">Guardar Dependiente</span> <span ng-if=\"newBeneficierie.life_policy.length\">Guardar Beneficiario</span></button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelBeneficiarie()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div></div><div class=\"col-xs-12 text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination pagination_center justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{ page }}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"row\"><div class=\"col-xs-12 col-md-6 col-sm-6 text-align-center\"><button type=\"button\" class=\"btn btn-info btn-block\" ng-click=\"showMassivePDFs()\"><i class=\"fa fa-upload m-r-xs\"></i> Cargar PDFs a certificados</button> <small class=\"text-muted\">Carga masiva y validación automática por titular.</small></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"caratula.ramo.ramo_code==1 || caratula.ramo.ramo_code ==2 || caratula.subramo.subramo_code ==13 || caratula.subramo.subramo_code ==7\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"showItemCertificate(7)\" ng-disabled=\"!showOt\"><i class=\"fa fa-list\" aria-hidden=\"true\"></i> Actualización de correos</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\" ng-if=\"acceso_rep_pol\"><button class=\"btn btn-primary col-xs-12\" type=\"button\" ng-click=\"downloadExcel(categorySelected, 1)\" ng-if=\"!allExcel\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Generar Reporte</button> <button class=\"btn btn-primary col-xs-12\" type=\"button\" ng-click=\"downloadExcelAll(caratula, 1)\" ng-if=\"allExcel\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Generar Reporte</button></div></div></div><div class=\"row animate\" ng-if=\"endorsementFlagCertificate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12 form-group\"><table class=\"table table-hover table-bordered\"><thead><th>Tipo</th><th>Número de Endoso</th><th>Concepto</th><th>Descripción</th><th>Vigencia</th><th>Estatus</th><th>Historial</th></thead><tbody><tr ng-repeat=\"endorsement in endorsementsCertificate track by $index\" ng-click=\"openendoso(endorsement)\"><td>{{ endorsement.endorsement_type }}</td><td ng-if=\"endorsement.number_endorsement\">{{ endorsement.number_endorsement }}</td><td ng-if=\"!endorsement.number_endorsement\">Sin número asigando</td><td>{{ concept(endorsement.concept) }} <span ng-if=\"concept(endorsement.concept) == \'OTRO\'\">:</span>{{endorsement.other_desc}}</td><td>{{ endorsement.observations }}</td><td>{{ endorsement.init_date | date: \'dd/MM/yyyy\': \'UTC\' }} - {{ endorsement.end_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td ng-if=\"endorsement.status == 1\">Pendiente</td><td ng-if=\"endorsement.status == 2\">Registrado</td><td ng-if=\"endorsement.status == 3\">Rechazado</td><td ng-if=\"endorsement.status == 5\">En trámite</td><td ng-if=\"endorsement.status == 4\">Cancelado</td><td ng-if=\"endorsement.migrated\">Sin historial</td><td ng-if=\"endorsement.status != 2\"></td><td ng-if=\"!endorsement.migrated && endorsement.status == 2\"><button class=\"btn btn-white\" ng-click=\"$event.stopPropagation(); showChange(endorsement)\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i> Ver Cambios</button></td></tr></tbody></table></div></div><div class=\"row animate\" ng-if=\"siniesterFlagCertificate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12 form-group\"><table class=\"table table-hover table-bordered\"><thead><th>Folio</th><th>Número de Siniestro</th><th>Fecha de Creación</th><th>Fecha de Emisión</th><th>Estatus</th><th>Tipo de Pago</th></thead><tbody><tr ng-repeat=\"sinister in sinistersCertificate track by $index\" ng-click=\"infoSinister(sinister)\"><td>{{ sinister.folio_compania }}</td><td>{{ sinister.numero_siniestro }}</td><td>{{ sinister.fecha_siniestro | date: \'dd/MM/yyyy h:mm:ss a\' : \'UTC\'}}</td><td>{{ sinister.fecha_ingreso | date: \'dd/MM/yyyy h:mm:ss a\': \'UTC\' }}</td><td ng-if=\"sinister.status == 1\">Pendiente</td><td ng-if=\"sinister.status == 2\">En trámite</td><td ng-if=\"sinister.status == 3\">Completado</td><td ng-if=\"sinister.status == 4\">Cancelado</td><td ng-if=\"sinister.status == 5\">Rechazado</td><td ng-if=\"sinister.status == 6\">En espera</td><td ng-if=\"sinister.status == 7\">Reproceso</td><td ng-if=\"sinister.status == 8\">Inconformidad</td><td>{{ tipo_pago(sinister.accidente_sinister[0].tipo_pago)}}</td></tr></tbody></table></div></div><div class=\"row\"><br><div class=\"col-xs-12\"><button class=\"btn btn-warning pull-right\" ng-click=\"vm.loadBatches()\">Actualizar listado</button><br><div class=\"col-lg-12\"><hr><h4 class=\"text-align-center\">Listado de Envíos</h4><hr></div><table class=\"table table-bordered table-striped\"><thead><tr><th>Fecha</th><th>Usuario</th><th>Total</th><th>Enviados</th><th>Fallidos</th><th>Estatus</th><th></th></tr></thead><tbody><tr ng-repeat=\"b in vm.batches\"><td>{{b.created_at | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{b.created_by}}</td><td>{{b.total}}</td><td>{{b.sent}}</td><td>{{b.failed}}</td><td><span clas=\"blue-color\" ng-if=\"b.status ==\'PENDING\'\">Pendiente</span> <span clas=\"blue-color\" ng-if=\"b.status ==\'RUNNING\'\">En proceso</span> <span clas=\"blue-color\" ng-if=\"b.status ==\'DONE\'\">Finalizado</span> <span clas=\"blue-color\" ng-if=\"b.status ==\'FAILED\'\">Falló</span></td><td><button class=\"btn btn-xs btn-primary\" ng-click=\"vm.openBatch(b.id)\">Ver detalle</button></td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"verdetalle\"><div class=\"col-md-12\"><hr><h4 class=\"text-align-center\">Resultados del envío masivo</h4><hr><div class=\"form-inline\" style=\"margin-bottom:10px;\"><label>Status:</label><select class=\"form-control\" ng-model=\"vm.filterStatus\" ng-change=\"vm.loadItems(1)\"><option value=\"\">Todos</option><option value=\"SENT\">Enviados</option><option value=\"FAILED\">Fallidos</option><option value=\"PENDING\">Pendientes</option></select><button class=\"btn btn-primary\" ng-click=\"vm.loadItems(1)\">Actualizar</button> <button class=\"btn btn-danger pull-right\" ng-disabled=\"vm.batch.failed <= 0 || vm.loadingRetryAll\" ng-click=\"vm.retryAllFailed()\">Reenviar TODOS los fallidos ({{vm.batch.failed || 0}})</button></div><div class=\"alert alert-info\" ng-if=\"vm.batch\"><b>Total:</b> {{vm.batch.total}} | <b>Enviados:</b> {{vm.batch.sent}} | <b>Fallidos:</b> {{vm.batch.failed}} | <b>Estatus envío masivo:</b> <span ng-if=\"vm.batch.status ==\'PENDING\'\">Pendiente</span> <span ng-if=\"vm.batch.status ==\'RUNNING\'\">En proceso</span> <span ng-if=\"vm.batch.status ==\'DONE\'\">Finalizado</span> <span ng-if=\"vm.batch.status ==\'FAILED\'\">Falló</span></div><table class=\"table table-striped table-bordered\"><thead><tr><th>Certificado</th><th>Email</th><th>Status</th><th>Intentos</th><th>Última act.</th><th>Error</th><th style=\"width:160px;\">Acciones</th></tr></thead><tbody><tr ng-repeat=\"it in vm.items\"><td>{{it.certificate_number || (\'ID \' + it.certificate_id)}}</td><td>{{it.receiver_email}}</td><td><span class=\"label label-success\" ng-if=\"it.status==\'SENT\'\">Enviado</span> <span class=\"label label-danger\" ng-if=\"it.status==\'FAILED\'\">Falló</span> <span class=\"label label-warning\" ng-if=\"it.status==\'PENDING\'\">Pendiente</span></td><td>{{it.attempts}}</td><td>{{it.updated_at | date:\'dd/MM/yyyy HH:mm\'}}</td><td><span ng-if=\"it.error_message\">{{it.error_message}}</span> <span ng-if=\"!it.error_message\">-</span></td><td><button class=\"btn btn-xs btn-warning\" ng-disabled=\"it._retrying\" ng-click=\"vm.retryOne(it)\">Reenviar</button> <button class=\"btn btn-xs btn-default\" ng-if=\"it.error_message\" ng-click=\"vm.showError(it)\">Ver error</button></td></tr></tbody></table><ul class=\"pagination\"><li ng-class=\"{disabled: vm.page<=1}\"><a href=\"\" ng-click=\"vm.page>1 && vm.loadItems(vm.page-1)\">«</a></li><li class=\"active\"><a href=\"\">{{vm.page}}</a></li><li ng-class=\"{disabled: vm.page>=vm.pages}\"><a href=\"\" ng-click=\"vm.page<vm.pages && vm.loadItems(vm.page+1)\">»</a></li></ul></div></div></div></div></div><div ng-if=\"show_certificado && show_infoCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Información Certificados</h5></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><div class=\"col-xs-12 btn-group\"><button type=\"button\" class=\"col-xs-12 btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones del Certificado</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"getLogCertificate()\"><i class=\"fa fa-history\" aria-hidden=\"true\"></i> Log</a></li><li><a ng-click=\"assignCertificate(certificate.id)\"><i class=\"fa fa-share-alt\" aria-hidden=\"true\"></i> Compartir</a></li><li ng-if=\"caratula.subramo.subramo_code == 1\" ng-click=\"goToSiniesterCert(certificate,cover_contractor)\"><a><i class=\"fa fa-folder\" aria-hidden=\"true\"></i> Crear siniestro</a></li><li class=\"dropdown-submenu\"><a ng-if=\"acceso_adm_sin && caratula.ramo.ramo_code == 2\"><i class=\"fa fa-folder\" aria-hidden=\"true\"></i> Crear siniestro</a><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"goToSiniester(\'\', 1,\'Siniestros\', \'siniestros.accidentes\')\">Por Titular</a></li><li class=\"dropdown-submenu\"><a>Por Dependiente</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-repeat=\"relationship in certificate.accidents_policy[0].relationship_accident\"><a ng-click=\"goToSiniester(relationship, 2,\'Siniestros\', \'siniestros.accidentes\')\">{{relationship.first_name}} {{relationship.last_name}}</a></li></ul></li></ul></li><li ng-if=\"acceso_adm_sin\"><a ng-if=\"caratula.subramo.subramo_code == 9\" ng-click=\"goSiniester(\'Siniestros\', \'siniestros.create_autos\')\"><i class=\"fa fa-folder\" aria-hidden=\"true\"></i> Crear siniestro</a></li></ul></div><br></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Certificado: {{ certificate.certificate_number }}</legend><button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(certificate,25)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"col-xs-12 col-sm-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\" ng-if=\"caratula.contractor.type_person ==1 || caratula.contractor.type_person == \'Física\'\"><b>Nombre</b>:</span> <span class=\"blue-color\" ng-if=\"caratula.contractor.type_person ==2 || caratula.contractor.type_person == \'Moral\'\"><b>Razón Social</b>:</span><div><span>{{ caratula.contractor.full_name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">RFC:</span><div><span>{{ caratula.natural.rfc }}{{ caratula.juridical.rfc }}{{ caratula.contractor.rfc }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Grupo:</span><div><span>{{ caratula.natural.group }}{{ caratula.juridical.group }} {{ caratula.contractor.group }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div style=\"word-wrap: break-word\"><span>{{ caratula.natural.email }}{{ caratula.juridical.email }}{{ caratula.contractor.email }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ caratula.natural.phone_number }}{{ caratula.juridical.phone_number }}{{ caratula.contractor.phone_number }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Dirección</span><div><span ng-if=\"caratula.contractor\">{{ caratula.contractor.address_contractor[0].route }} {{ caratula.contractor.address_contractor[0].street_number }}&nbsp;</span> <span ng-if=\"caratula.contractor\">Int. {{ caratula.contractor.address_contractor[0].street_number_int }},</span> <span ng-if=\"caratula.contractor\">{{ caratula.contractor.address_contractor[0].sublocality }},</span><br><span ng-if=\"caratula.contractor\">{{ caratula.contractor.address_contractor[0].administrative_area_level_2 }},</span> <span ng-if=\"caratula.contractor\">{{ caratula.contractor.address_contractor[0].administrative_area_level_1 }},</span> <span ng-if=\"caratula.contractor\">CP. {{ caratula.contractor.address_contractor[0].postal_code }}</span></div></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><legend class=\"legend-title\" align=\"center\">Información</legend><div ng-if=\"certificate.life_policy.length\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">No. Certificado:</span><div><span>{{ certificate.certificate_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Folio:</span><div><span>{{ certificate.folio }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div><span ng-class=\"{\'label-success\': certificate.life_policy[0].personal.email}\" style=\"padding: 0 8px;\">{{ certificate.life_policy[0].personal.email }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ certificate.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\' }} - {{ certificate.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Antigüedad:</span><div><span ng-if=\"certificate.rec_antiguedad\">{{ certificate.rec_antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <span ng-if=\"!certificate.rec_antiguedad\">{{ certificate.life_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12\"><span><b>Titular</b></span><hr></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ certificate.life_policy[0].personal.first_name }} {{ certificate.life_policy[0].personal.last_name }} {{ certificate.life_policy[0].personal.second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ certificate.life_policy[0].personal.birthdate | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"certificate.life_policy[0].personal.sex == \'F\'\">Femenino</span> <span ng-if=\"certificate.life_policy[0].personal.sex == \'M\'\">Masculino</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Tipo Suma Asegurada:</span><div><span ng-if=\"certificate.life_policy[0].personal.type_sa == 1\">Fija</span> <span ng-if=\"certificate.life_policy[0].personal.type_sa == 2\">Regla</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Suma Asegurada:</span><div><span>{{ certificate.life_policy[0].personal.sum_assured }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Sueldo:</span><div><span>{{ certificate.life_policy[0].personal.salary }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fumador:</span><div><span ng-if=\"certificate.life_policy[0].smoker\">Si</span> <span ng-if=\"!certificate.life_policy[0].smoker\">No</span></div></div><div class=\"col-xs-12\"><span><b>Beneficiarios</b></span><hr></div><div ng-repeat=\"item in certificate.life_policy[0].beneficiaries_life\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ item.first_name }} {{ item.last_name }} {{ item.second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ item.birthdate | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"item.sex == \'F\'\">Femenino</span> <span ng-if=\"item.sex == \'M\'\">Masculino</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Parentesco:</span><div><span ng-if=\"item.optional_relationship == 1\">Titular</span> <span ng-if=\"item.optional_relationship == 2\">Cónyuge</span> <span ng-if=\"item.optional_relationship == 3\">Hijo</span> <span ng-if=\"item.optional_relationship == 4\">Otro</span></div></div></div></div><div ng-if=\"certificate.accidents_policy.length\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">No. Certificado:</span><div><span>{{ certificate.certificate_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Folio:</span><div><span>{{ certificate.folio }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div><span ng-class=\"{\'label-success\': certificate.accidents_policy[0].personal.email}\" style=\"padding: 0 8px;\">{{ certificate.accidents_policy[0].personal.email }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ certificate.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\' }} - {{ certificate.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Antigüedad:</span><div><span ng-if=\"certificate.rec_antiguedad\">{{ certificate.rec_antiguedad | date: \'dd/MM/yyyy\': \'UTC\' }}</span> <span ng-if=\"!certificate.rec_antiguedad\">{{ certificate.accidents_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12\"><span><b>Titular</b></span><hr></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ certificate.accidents_policy[0].personal.first_name }} {{ certificate.accidents_policy[0].personal.last_name }} {{ certificate.accidents_policy[0].personal.second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ certificate.accidents_policy[0].personal.birthdate | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"certificate.accidents_policy[0].personal.sex == \'F\'\">Femenino</span> <span ng-if=\"certificate.accidents_policy[0].personal.sex == \'M\'\">Masculino</span></div></div><div class=\"row col-xs-12\"><div class=\"col-xs-12\" ng-if=\"certificate.contributory\"><div class=\"col-xs-12\"><legend ng-if=\"certificate.contributory\" class=\"blue-color\" align=\"center\"><b>Datos Contributorios</b></legend></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Clave:</label><div ng-if=\"certificate.contributory\"><span>{{certificate.accidents_policy[0].personal.rfc_cve}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Homoclave:</label><div ng-if=\"certificate.contributory\"><span>{{certificate.accidents_policy[0].personal.rfc_homocve}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Calle - Número:</label><div ng-if=\"certificate.contributory\"><span>{{certificate.accidents_policy[0].personal.dom_callenum}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Colonia:</label><div ng-if=\"certificate.contributory\"><span>{{certificate.accidents_policy[0].personal.dom_colonia}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">CP:</label><div ng-if=\"certificate.contributory\"><span>{{certificate.accidents_policy[0].personal.dom_cp}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Municipio:</label><div ng-if=\"certificate.contributory\"><span>{{certificate.accidents_policy[0].personal.dom_poblacion}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Estado:</label><div ng-if=\"certificate.contributory\"><span>{{certificate.accidents_policy[0].personal.dom_estado}}</span></div></div></div></div><br><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"certificate.accidents_policy[0].personal.charge_date\"><span class=\"blue-color\">Fecha de Alta:</span><div><span>{{ certificate.accidents_policy[0].personal.charge_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12\"><br></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Neta:</span><div><span>{{ certificate.accidents_policy[0].personal.p_neta | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RPF:</span><div><span>{{ certificate.accidents_policy[0].personal.rpf | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Derecho:</span><div><span>{{ certificate.accidents_policy[0].personal.derecho | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">IVA:</span><div><span>{{ certificate.accidents_policy[0].personal.iva | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Total:</span><div><span>{{ certificate.accidents_policy[0].personal.p_total | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Comisión:</span><div><span>{{ certificate.accidents_policy[0].personal.comision | currency }}</span></div></div><div ng-if=\"certificate.accidents_policy[0].personal.discharge_date && !certificate.certificado_inciso_activo\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Baja:</span><div><span>{{ certificate.accidents_policy[0].personal.discharge_date | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Neta No Devengada:</span><div><span>-{{ certificate.accidents_policy[0].personal.p_neta_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RPF No Devengada:</span><div><span>-{{ certificate.accidents_policy[0].personal.rpf_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Derecho No Devengada:</span><div><span>-{{ certificate.accidents_policy[0].personal.derecho_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">IVA No Devengada:</span><div><span>-{{ certificate.accidents_policy[0].personal.iva_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Total No Devengada:</span><div><span>-{{ certificate.accidents_policy[0].personal.p_total_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Comisión No Devengada:</span><div><span>-{{ certificate.accidents_policy[0].personal.comision_earned | currency }}</span></div></div></div><div class=\"col-xs-12\"><span><b>Dependientes</b></span><hr></div><div ng-repeat=\"item in certificate.accidents_policy[0].relationship_accident\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\"><b>Certificado:</b></span><div><span>{{ item.certificate }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\"><b>Nombre:</b></span><div><span>{{ item.first_name }} {{ item.last_name }} {{ item.second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ item.birthdate | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"item.sex == \'F\'\">Femenino</span> <span ng-if=\"item.sex == \'M\'\">Masculino</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Parentesco:</span><div><span ng-if=\"item.relationship == 1\">Titular</span> <span ng-if=\"item.relationship == 2\">Cónyuge</span> <span ng-if=\"item.relationship == 3\">Hijo</span> <span ng-if=\"item.relationship == 4\">Otro</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Antigüedad:</span><div><span>{{ item.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Alta:</span><div><span>{{ item.charge_date | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12\" ng-if=\"certificate.contributory\"><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Clave:</label><div ng-if=\"certificate.contributory\"><span>{{item.rfc_cve}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Homoclave:</label><div ng-if=\"certificate.contributory\"><span>{{item.rfc_homocve}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Calle - Número:</label><div ng-if=\"certificate.contributory\"><span>{{item.dom_callenum}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Colonia:</label><div ng-if=\"certificate.contributory\"><span>{{item.dom_colonia}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">CP:</label><div ng-if=\"certificate.contributory\"><span>{{item.dom_cp}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Municipio:</label><div ng-if=\"certificate.contributory\"><span>{{item.dom_poblacion}}</span></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Estado:</label><div ng-if=\"certificate.contributory\"><span>{{item.dom_estado}}</span></div></div></div><br><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Neta:</span><div><span>{{ item.p_neta | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RPF:</span><div><span>{{ item.rpf | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Derecho:</span><div><span>{{ item.derecho | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">IVA:</span><div><span>{{ item.iva | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Total:</span><div><span>{{ item.p_total | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Comisión:</span><div><span>{{ item.comision | currency }}</span></div></div><div ng-if=\"item.discharge_date\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Baja:</span><div><span>{{ item.discharge_date | date: \'dd/MM/yyyy\': \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Neta No Devengada:</span><div><span>-{{ item.p_neta_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RPF No Devengada:</span><div><span>-{{ item.rpf_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Derecho No Devengada:</span><div><span>-{{ item.derecho_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">IVA No Devengada:</span><div><span>-{{ item.iva_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Total No Devengada:</span><div><span>-{{ item.p_total_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Comisión No Devengada:</span><div><span>-{{ item.comision_earned | currency }}</span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"acceso_elim_pol\"><button class=\"btn btn-white\" ng-click=\"deleteBeneficiarieInfo(item, $index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12\"><hr></div></div></div><div ng-if=\"certificate.automobiles_policy.length\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">No. Certificado:</span><div><span>{{ certificate.certificate_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Propietario:</span><div><span>{{ certificate.automobiles_policy[0].car_owner }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Conductor:</span><div><span>{{ certificate.automobiles_policy[0].driver }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div><span ng-class=\"{\'label-success\': certificate.automobiles_policy[0].email}\" style=\"padding: 0 8px;\">{{ certificate.automobiles_policy[0].email }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ certificate.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\' }} - {{ certificate.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">No. Empleado:</span><div><span>{{ certificate.automobiles_policy[0].no_employee }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Marca:</span><div><span>{{ certificate.automobiles_policy[0].brand }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Modelo:</span><div><span>{{ certificate.automobiles_policy[0].model }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Año:</span><div><span>{{ certificate.automobiles_policy[0].year }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Versión:</span><div><span>{{ certificate.automobiles_policy[0].version }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Serie:</span><div><span>{{ certificate.automobiles_policy[0].serial }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Motor:</span><div><span>{{ certificate.automobiles_policy[0].engine }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Color:</span><div><span>{{ certificate.automobiles_policy[0].color }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Matrícula:</span><div><span>{{ certificate.automobiles_policy[0].license_plates }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Uso:</span><div><span ng-if=\"certificate.automobiles_policy[0].usage == 1\">Particular</span> <span ng-if=\"certificate.automobiles_policy[0].usage == 2\">Carga Comercial</span> <span ng-if=\"certificate.automobiles_policy[0].usage == 3\">Servicio Público</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Servicio:</span><div><span>{{ certificate.automobiles_policy[0].service }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Procedencia:</span><div><span ng-if=\"certificate.automobiles_policy[0].procedencia == 0\">Sin especificar</span> <span ng-if=\"certificate.automobiles_policy[0].procedencia == 1\">Residencia</span> <span ng-if=\"certificate.automobiles_policy[0].procedencia == 2\">Turista</span> <span ng-if=\"certificate.automobiles_policy[0].procedencia == 3\">Legalizado</span> <span ng-if=\"certificate.automobiles_policy[0].procedencia == 4\">Fronterizo</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Suma Asegurada:</span><div><span>{{ certificate.automobiles_policy[0].sum_insured | currency }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Tipo de Carga:</span><div><span ng-if=\"certificate.automobiles_policy[0].charge_type == 0\">Sin especificar</span> <span ng-if=\"certificate.automobiles_policy[0].charge_type == 1\">A</span> <span ng-if=\"certificate.automobiles_policy[0].charge_type == 2\">B</span> <span ng-if=\"certificate.automobiles_policy[0].charge_type == 3\">C</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Adaptaciones:</span><div><span>{{ certificate.automobiles_policy[0].adjustment }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Monto de Adaptaciones:</span><div><span>{{ certificate.automobiles_policy[0].mont_adjustment }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Equipamiento:</span><div><span>{{ certificate.automobiles_policy[0].special_team }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Monto de Equipamiento:</span><div><span>{{ certificate.automobiles_policy[0].mont_special_team }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Beneficiario Preferente:</span><div><span>{{ certificate.automobiles_policy[0].preferential_benefiaciary }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Beneficiario RFC:</span><div><span>{{ certificate.automobiles_policy[0].beneficiary_rfc }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Beneficiario Dirección:</span><div><span>{{ certificate.automobiles_policy[0].beneficiary_address }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"certificate.fecha_baja_inciso\"><span class=\"blue-color\">Fecha de Baja:</span><div><span>{{ certificate.fecha_baja_inciso | date: \'dd/MM/yyyy\' : \'UTC\'}} &nbsp;</span></div></div></div><div ng-if=\"certificate.damages_policy.length\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">No. Certificado:</span><div><span>{{ certificate.certificate_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div><span ng-class=\"{\'label-success\': certificate.damages_policy[0].email}\" style=\"padding: 0 8px;\">{{ certificate.damages_policy[0].email }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ certificate.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ certificate.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div ng-if=\"caratula.subramo.subramo_code == 7\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Sucursal:</span><div><span>{{ certificate.damages_policy[0].sucursal }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Giro:</span><div><span>{{ certificate.damages_policy[0].giro }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Tipo Constructivo:</span><div><span ng-if=\"certificate.damages_policy[0].type_construction == 1\">Macizo</span> <span ng-if=\"certificate.damages_policy[0].type_construction == 2\">Madera</span> <span ng-if=\"certificate.damages_policy[0].type_construction == 3\">Lámina</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">No. Niveles:</span><div><span>{{ certificate.damages_policy[0].no_levels }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Zona FHM:</span><div><span>{{ certificate.damages_policy[0].fhm_zone }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Zona TYEV:</span><div><span>{{ certificate.damages_policy[0].tyev_zone }}</span></div></div></div><div ng-if=\"caratula.subramo.subramo_code == 13\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Propietario:</span><div><span>{{ certificate.damages_policy[0].dam_owner }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">No. Empleado:</span><div><span>{{ certificate.damages_policy[0].no_employee }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Descripción:</span><div><span>{{ certificate.damages_policy[0].item_details }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Uso:</span><div><span ng-if=\"certificate.damages_policy[0].usage == 1\">Particular</span> <span ng-if=\"certificate.damages_policy[0].usage == 2\">Carga Comercial</span> <span ng-if=\"certificate.damages_policy[0].usage == 3\">Servicio Público</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Marca:</span><div><span>{{ certificate.damages_policy[0].brand }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Modelo:</span><div><span>{{ certificate.damages_policy[0].model }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Año Construcción:</span><div><span>{{ certificate.damages_policy[0].construction_year }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Año Reconstrucción:</span><div><span>{{ certificate.damages_policy[0].reconstruction_year }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Versión:</span><div><span>{{ certificate.damages_policy[0].version }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Serie:</span><div><span>{{ certificate.damages_policy[0].serial }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Motor:</span><div><span>{{ certificate.damages_policy[0].engine }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Color:</span><div><span>{{ certificate.damages_policy[0].color }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Matrícula:</span><div><span>{{ certificate.damages_policy[0].matricula }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Matrícula:</span><div><span>{{ certificate.damages_policy[0].matricula }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Matrícula:</span><div><span>{{ certificate.damages_policy[0].matricula }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Permiso:</span><div><span>{{ certificate.damages_policy[0].permiso }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Valor Compra:</span><div><span>{{ certificate.damages_policy[0].purchase_value }}</span></div></div></div><div ng-if=\"caratula.subramo.subramo_code !=13 && caratula.subramo.subramo_code !=7\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Bien asegurado:</span><div><span>{{ certificate.damages_policy[0].insured_item }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Detalles:</span><div><span>{{ certificate.damages_policy[0].item_details }}</span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Dirección:</span><div><span>{{ certificate.damages_policy[0].item_address }}</span></div></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Neta:</span><div><span>{{ certificate.p_neta | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RPF:</span><div><span>{{ certificate.rpf | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Derecho:</span><div><span>{{ certificate.derecho | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">IVA:</span><div><span>{{ certificate.iva | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Total:</span><div><span>{{ certificate.p_total | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Comisión:</span><div><span>{{ certificate.comision | currency }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ certificate.observations}}</span></div></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"vm.showRecordatorios()\">{{certificate.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div><div ng-if=\"certificate.fecha_baja_inciso && !certificate.certificado_inciso_activo\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Baja:</span><div><span>{{ certificate.fecha_baja_inciso | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Neta No Devengada:</span><div><span>{{ certificate.p_neta_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RPF No Devengada:</span><div><span>{{ certificate.rpf_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Derecho No Devengada:</span><div><span>{{ certificate.derecho_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">IVA No Devengada:</span><div><span>{{ certificate.iva_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Total No Devengada:</span><div><span>{{ certificate.p_total_earned | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Comisión No Devengada:</span><div><span>{{ certificate.comision_earned | currency }}</span></div></div></div></div><div class=\"ibox-content\"><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in certificate.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div><div class=\"col-xs-12 form-group\" ng-if=\"caratula.receipts_by == 3\"><legend class=\"legend-title\" align=\"center\">Recibos</legend></div><div class=\"col-xs-12\" ng-if=\"caratula.receipts_by == 3\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Serie</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>Iva</th><th>Prima Total</th><th ng-if=\"permiso_comisiones\">Comisión</th><th>Vigencia</th><th>Vencimiento</th><th>Estatus</th></tr></thead><tbody><tr ng-repeat=\"recibo in certificate.recibos_poliza\" ng-if=\"recibo.receipt_type == 5 && recibo.status != 0\"><td>{{recibo.recibo_numero}}</td><td>{{recibo.prima_neta | currency}}</td><td>{{recibo.rpf | currency}}</td><td>{{recibo.derecho | currency}}</td><td>{{recibo.iva | currency}}</td><td>{{recibo.prima_total | currency}}</td><td ng-if=\"permiso_comisiones\">{{recibo.comision | currency}}</td><td>{{recibo.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}} - {{recibo.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{recibo.vencimiento | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == 4, \'label-info\' : recibo.status == 5 || recibo.status == 6, \'label-primary\' : recibo.status == 1 || recibo.status == 3, \'label-warning\' : recibo.status == 2 || recibo.status == 8}\">{{ statusReceipt(recibo.status) }}</div></td></tr><tr><td><b>Totales</b></td><td><b>{{ total_prima_certificate | currency }}</b></td><td><b>{{ total_rpf_certificate | currency }}</b></td><td><b>{{ total_derecho_certificate | currency }}</b></td><td><b>{{ total_iva_certificate | currency }}</b></td><td><b>{{ total_total_certificate | currency }}</b></td><td><b>{{ total_comision_certificate | currency }}</b></td><td></td><td></td><td></td></tr></tbody></table></div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Paquete: {{ packageCertificate.package_name }}</legend><div><table class=\"table table-bordered table-hover\"><thead><th>Cobertura</th><th>Suma Asegurada</th><th>Deducible</th></thead><tbody><tr ng-repeat=\"coverage in packageCertificate.coverage_package\" ng-if=\"packageCertificate.coverage_package.length\"><td>{{ coverage.coverage_name }}</td><td>{{ coverage.sums_coverage[0].sum_insured }}</td><td>{{ coverage.deductible_coverage[0].deductible }}</td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12\"><div class=\"col-xs-12 form-group\" ng-if=\"permiso_administrar_adjuntos\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(certificate)\">Guardar Archivos</button></div></div><div class=\"col-xs-12 form-group\" ng-if=\"certificate.files\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th ng-if=\"permiso_archivos\" width=\"200px\"></th></tr></thead><tbody><tr ng-repeat=\"file in certificate.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_input\" class=\"form-control display-none\" ng-if=\"permiso_administrar_adjuntos\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"saveFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,certificate.files,certificate)\" ng-if=\"permiso_administrar_adjuntos\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"permiso_administrar_adjuntos\">Renombrar</button> <span class=\"btn btn-success display-none\" ng-if=\"permiso_administrar_adjuntos\">Guardar</span></td><td ng-if=\"permiso_archivos && permiso_administrar_adjuntos\"><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> * Archivo sensible</td></tr></tbody></table></div></div></div></div></div></div></div></div><div ng-if=\"show_certificado && show_editCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5 ng-if=\"isEdit\">Editar Certificado</h5><h5 ng-if=\"!isEdit\">Agregar Certificado</h5></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\"></i> Regresar</button></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"!isEdit\"><label>Categoría: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"category as (\'Subgrupo: \' + category.subgroup + \' | Categoría: \'+ category.category) for category in categoriesJson track by category.category_id\" ng-model=\"newCertificate.parent\" value=\"{{category.id}}\"><option value=\"\" disabled=\"\">Selecciona una categoría</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"!isEdit\"><label>Paquetes: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"pack.package_name for pack in paquetes track by pack.url\" ng-model=\"newCertificate.paquete\" value=\"{{pack.id}}\"><option value=\"\" disabled=\"\">Selecciona un paquete</option></select></div><div ng-if=\"caratula.ramo.ramo_code == 1 || caratula.ramo.ramo_code == \'1\'\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Certificado: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.certificate_number\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Folio:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.folio\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.rec_antiguedad\" value=\"{{newCertificate.rec_antiguedad}}\" ng-paste=\"checkDate(newCertificate.rec_antiguedad,1,$event)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo Electrónico: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"newCertificate.datos.personal.email\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Inicio: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.start_of_validity\" value=\"{{newCertificate.start_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Fin: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.end_of_validity\" value=\"{{newCertificate.end_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12\"><label>Titular</label><hr><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.first_name\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.last_name\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.second_last_name\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.datos.personal.birthdate\" ng-change=\"validateBirthdate(newCertificate.datos.personal.birthdate); vm.saveLocalstorage(newCertificate)\" ng-paste=\"checkDate(newCertificate.datos.personal.birthdate,2,$event)\" value=\"{{newCertificate.datos.personal.birthdate}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"sexo.label for sexo in sexs track by $index\" ng-model=\"newCertificate.datos.personal.sex\" value=\"{{sexo.value}}\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo Suma Asegurada: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.label for type in typesInsureds\" ng-model=\"newCertificate.datos.personal.type_sa\" value=\"{{type.value}}\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Suma Asegurada: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificate.datos.personal.sum_assured\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sueldo: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.salary\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fumador: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"smoke.label for smoke in smokers\" ng-model=\"newCertificate.datos.smoker\" value=\"{{smoke.value}}\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></select></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"newCertificate.datos.beneficiaries_life.length == 0 && !isEdit\"><button class=\"btn btn-success col-xs-12\" ng-click=\"addBeneficiarie()\">Agregar Beneficiario</button></div><div class=\"address-container\" ng-repeat=\"item in newCertificate.datos.beneficiaries_life\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-if=\"!isEdit\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-if=\"!isEdit\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-if=\"!isEdit\" ng-click=\"addBeneficiarie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-if=\"!isEdit\" ng-click=\"addBeneficiarie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.first_name\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.last_name\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.second_last_name\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.birthdate\" ng-change=\"validateBirthdate(item.birthdate); vm.saveLocalstorage(newCertificate)\" value=\"{{item.birthdate}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Parentesco:</label><select class=\"form-control\" ng-options=\"relation.label for relation in relationships track by $index\" ng-model=\"item.optional_relationship\" ng-change=\"vm.saveLocalstorage(newCertificate)\" value=\"{{relation.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo:</label><select class=\"form-control\" ng-options=\"sexbeneficiarie.label for sexbeneficiarie in sexs track by $index\" ng-model=\"item.sex\" value=\"{{sexbeneficiarie.value}}\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></select></div></div></div></div><div ng-if=\"caratula.ramo.ramo_code == 2 || caratula.ramo.ramo_code == \'2\'\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Certificado: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.certificate_number\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Folio:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.folio\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.rec_antiguedad\" value=\"{{datosantiguedad}}\" ng-paste=\"checkDate(newCertificate.rec_antiguedad,1,$event)\" ng-change=\"vm.saveLocalstorage(newCertificate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo Electrónico: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"newCertificate.datos.personal.email\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Inicio: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.start_of_validity\" value=\"{{newCertificate.start_of_validity}}\" ng-change=\"vm.saveLocalstorage(newCertificate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Fin: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.end_of_validity\" value=\"{{newCertificate.end_of_validity}}\" ng-change=\"vm.saveLocalstorage(newCertificate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12\" align=\"center\"><label><input type=\"checkbox\" name=\"\" ng-model=\"newCertificate.contributory\" ng-click=\"datosContributorios(newCertificate)\" ng-change=\"vm.saveLocalstorage(newCertificate)\"><span class=\"col-xs-12 pull-right blue-color\">Datos Contributorios</span></label> <label>Titular</label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.first_name\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.last_name\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.second_last_name\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.datos.personal.birthdate\" ng-change=\"validateBirthdate(newCertificate.datos.personal.birthdate)\" value=\"{{newCertificate.datos.personal.birthdate}}\" ng-paste=\"checkDate(newCertificate.datos.personal.birthdate,2,$event)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"isEdit\"><label>Fecha de Alta:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.datos.personal.charge_date\" value=\"{{newCertificate.datos.personal.charge_date}}\" ng-change=\"vm.saveLocalstorage(newCertificate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"isEdit && (newCertificate.certificado_inciso_activo ==false || !newCertificate.certificado_inciso_activo)\"><label>Fecha de Baja:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.datos.personal.discharge_date\" value=\"{{newCertificate.datos.personal.birthdate}}\" ng-change=\"vm.saveLocalstorage(newCertificate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"sexo.label for sexo in sexs track by sexo.value\" ng-model=\"newCertificate.datos.personal.sex\" value=\"{{sexo.value}}\" ng-change=\"vm.saveLocalstorage(newCertificate)\"></select></div><div class=\"row col-xs-12\"><div class=\"col-xs-12\" ng-if=\"newCertificate.contributory\"><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Clave:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"newCertificate.datos.personal.rfc_cve\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Homoclave:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"newCertificate.datos.personal.rfc_homocve\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Calle - Número:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"newCertificate.datos.personal.dom_callenum\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Colonia:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"newCertificate.datos.personal.dom_colonia\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">CP:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"newCertificate.datos.personal.dom_cp\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Municipio:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"newCertificate.datos.personal.dom_poblacion\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Estado:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"newCertificate.datos.personal.dom_estado\"></div></div></div></div><br><div class=\"col-xs-12\" align=\"center\"><label>Primas del Titular</label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.p_neta\" ng-change=\"changePrimaTitular(newCertificate.datos.personal); vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.rpf\" ng-change=\"changePrimaTitular(newCertificate.datos.personal); vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.derecho\" ng-change=\"changePrimaTitular(newCertificate.datos.personal); vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.iva\" ng-change=\"changePrimaTitular(newCertificate.datos.personal); vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.p_total\" ng-change=\"changePrimaTitular(newCertificate.datos.personal); vm.saveLocalstorage(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.comision\" ng-change=\"changePrimaTitular(newCertificate.datos.personal); vm.saveLocalstorage(newCertificate)\"></div><div ng-if=\"!newCertificate.certificado_inciso_activo\" class=\"col-xs-12\" align=\"center\"><label>Primas NO DEVENGADAS del Titular</label><br></div><div ng-if=\"!newCertificate.certificado_inciso_activo\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.p_neta_earned\"></div><div ng-if=\"!newCertificate.certificado_inciso_activo\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.rpf_earned\"></div><div ng-if=\"!newCertificate.certificado_inciso_activo\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.derecho_earned\"></div><div ng-if=\"!newCertificate.certificado_inciso_activo\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.iva_earned\"></div><div ng-if=\"!newCertificate.certificado_inciso_activo\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.p_total_earned\"></div><div ng-if=\"!newCertificate.certificado_inciso_activo\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.personal.comision_earned\"></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"newCertificate.datos.relationship_accident.length == 0 && !isEdit\"><button class=\"btn btn-success col-xs-12\" ng-click=\"addBeneficiarie()\">Agregar Dependiente</button></div><div class=\"address-container\" ng-repeat=\"item in newCertificate.datos.relationship_accident track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiarie($index); vm.saveLocalstorage(newCertificate)\" ng-if=\"!isEdit\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Dependiente</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-if=\"!isEdit\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Dependiente #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiarie(); vm.saveLocalstorage(newCertificate)\" ng-if=\"!isEdit\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Dependiente</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiarie()\" ng-if=\"!isEdit\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Certificado:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.certificate\" ng-change=\"vm.saveLocalstorage(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.first_name\" ng-change=\"vm.saveLocalstorage(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.last_name\" ng-change=\"vm.saveLocalstorage(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.second_last_name\" ng-change=\"vm.saveLocalstorage(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.birthdate\" ng-change=\"validateBirthdate(item.birthdate);vm.saveLocalstorage(item)\" ng-paste=\"checkDate(item.birthdate,3,$event,$index)\" value=\"{{item.birthdate}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"isEdit\"><label>Fecha de Alta:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.charge_date\" value=\"{{item.charge_date}}\" ng-chnage=\"vm.saveLocalstorage(item)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"isEdit && !item.is_active\"><label>Fecha de Baja:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.discharge_date\" value=\"{{item.discharge_date}}\" ng-change=\"vm.saveLocalstorage(item)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Parentesco:</label><select class=\"form-control\" ng-options=\"relation.label for relation in relationships track by relation.value\" ng-model=\"item.relationship\" value=\"{{relation.value}}\" ng-change=\"vm.saveLocalstorage(item)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo:</label><select class=\"form-control\" ng-options=\"sexbeneficiarie.label for sexbeneficiarie in sexs track by sexbeneficiarie.value\" ng-model=\"item.sex\" value=\"{{sexbeneficiarie.value}}\" ng-change=\"vm.saveLocalstorage(item)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.antiguedad\" value=\"{{item.antiguedad}}\" ng-paste=\"checkDate(item.antiguedad,3,$event,$index)\" ng-change=\"vm.saveLocalstorage(item)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"row col-xs-12\"><div class=\"col-xs-12\" ng-if=\"newCertificate.contributory\"><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Clave:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"item.rfc_cve\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Homoclave:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"item.rfc_homocve\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Calle - Número:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"item.dom_callenum\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Colonia:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"item.dom_colonia\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">CP:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"item.dom_cp\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Municipio:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"item.dom_poblacion\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Estado:</label><div ng-if=\"newCertificate.contributory\"><input class=\"form-control\" type=\"text\" ng-change=\"vm.saveLocalstorage(newCertificate)\" ng-model=\"item.dom_estado\"></div></div></div></div><br><div class=\"col-xs-12\" align=\"center\"><label>Primas del Dependiente #{{$index + 1}}</label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.p_neta\" ng-change=\"changePrimaTitular(item);vm.saveLocalstorage(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.rpf\" ng-change=\"changePrimaTitular(item);vm.saveLocalstorage(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.derecho\" ng-change=\"changePrimaTitular(item);vm.saveLocalstorage(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.iva\" ng-change=\"changePrimaTitular(item);vm.saveLocalstorage(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.p_total\" ng-change=\"changePrimaTitular(item);vm.saveLocalstorage(item)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.comision\" ng-change=\"changePrimaTitular(item);vm.saveLocalstorage(item)\"></div><div ng-if=\"!item.is_active\" class=\"col-xs-12\" align=\"center\"><label>Primas NO DEVENGADAS del Dependiente #{{$index + 1}}</label><br></div><div ng-if=\"!item.is_active\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.p_neta_earned\" ng-change=\"vm.saveLocalstorage(item)\"></div><div ng-if=\"!item.is_active\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.rpf_earned\" ng-change=\"vm.saveLocalstorage(item)\"></div><div ng-if=\"!item.is_active\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.derecho_earned\" ng-change=\"vm.saveLocalstorage(item)\"></div><div ng-if=\"!item.is_active\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.iva_earned\" ng-change=\"vm.saveLocalstorage(item)\"></div><div ng-if=\"!item.is_active\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.p_total_earned\" ng-change=\"vm.saveLocalstorage(item)\"></div><div ng-if=\"!item.is_active\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.comision_earned\" ng-change=\"vm.saveLocalstorage(item)\"></div></div></div></div><div ng-if=\"caratula.subramo.subramo_code == 9\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Inciso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.certificate_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Propietario:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.car_owner\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Conductor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.driver\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo Electrónico: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"newCertificate.datos.email\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Inicio: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.start_of_validity\" value=\"{{newCertificate.start_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Fin: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.end_of_validity\" value=\"{{newCertificate.end_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Empleado:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.no_employee\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Marca: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.brand\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Modelo: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.model\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Año: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificate.datos.year\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Versión: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.version\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Serie: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.serial\" ng-blur=\"checkNumSerie(newCertificate.datos.serial)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Motor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.engine\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Color:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.color\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Matrícula:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.license_plates\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Uso: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"uso.label for uso in usages\" ng-model=\"newCertificate.datos.usage\" value=\"{{uso.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Servicio: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.service\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Procedencia: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"origin.label for origin in procedencias\" ng-model=\"newCertificate.datos.procedencia\" value=\"{{origin.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Valor/Suma Asegurada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.sum_insured\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo Carga:</label><select class=\"form-control\" ng-options=\"type.label for type in typesCharges\" ng-model=\"newCertificate.datos.charge_type\" value=\"{{type.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Adaptaciones:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.adjustment\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Monto Adaptaciones:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificate.datos.mont_adjustment\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Equipamiento:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.special_team\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Monto Equipamiento:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificate.datos.mont_special_team\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Beneficiario Preferente:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.preferential_benefiaciary\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Beneficiario RFC:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.beneficiary_rfc\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Beneficiario Dirección:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.beneficiary_address\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"newCertificate.fecha_baja_inciso\"><label>Fecha de Baja: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.fecha_baja_inciso\" value=\"{{newCertificate.fecha_baja_inciso}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div ng-if=\"caratula.subramo.subramo_code == 7 || caratula.subramo.subramo_code == 13\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Inciso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.certificate_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo Electrónico: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"newCertificate.datos.email\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Inicio: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.start_of_validity\" value=\"{{newCertificate.start_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Fin: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.end_of_validity\" value=\"{{newCertificate.end_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div ng-if=\"caratula.subramo.subramo_code == 7\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sucursal: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.sucursal\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Giro: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.giro\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo Constructivo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.label for type in typesConstruction\" ng-model=\"newCertificate.datos.type_construction\" value=\"{{type.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Niveles: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificate.datos.no_levels\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Zona FHM: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.fhm_zone\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Zona TYEV: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.tyev_zone\"></div></div><div ng-if=\"caratula.subramo.subramo_code == 13\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Propietario:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.dam_owner\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Empleado:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.no_employee\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Description: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.item_details\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Uso: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"uso.label for uso in usages\" ng-model=\"newCertificate.datos.usage\" value=\"{{uso.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Marca: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.brand\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Modelo: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.model\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Año Contrucción: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificate.datos.construction_year\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Año Recontrucción: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificate.datos.reconstruction_year\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Versión: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.version\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Serie: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.serial\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Motor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.engine\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Color:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.color\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Matrícula:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.matricula\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Permiso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.permiso\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Valor Comercial:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificate.datos.purchase_value\"></div></div><div class=\"col-xs-12 form-group\"><label>Dirección: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.item_address\"></div></div><div ng-if=\"+caratula.ramo.ramo_code !== 2 && +caratula.ramo.ramo_code !== 1 && +caratula.subramo.subramo_code !== 7 && +caratula.subramo.subramo_code !== 13 && +caratula.subramo.subramo_code !== 9 && +caratula.subramo.subramo_code !== 1\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Inciso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.certificate_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo Electrónico: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"newCertificate.datos.email\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Inicio: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.start_of_validity\" value=\"{{newCertificate.start_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Fin: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.end_of_validity\" value=\"{{newCertificate.end_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label>Bien asegurado:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.insured_item\"></div><div class=\"col-xs-12 form-group\"><label>Detalles:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.item_details\"></div><div class=\"col-xs-12 form-group\"><label>Dirección:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.item_address\"></div></div><div class=\"col-xs-12\"><hr></div><div ng-if=\"caratula.ramo.ramo_code != 2 || caratula.ramo.ramo_code != \'2\'\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.p_neta\" ng-change=\"changePrimaTitular(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.rpf\" ng-change=\"changePrimaTitular(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.derecho\" ng-change=\"changePrimaTitular(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.iva\" ng-change=\"changePrimaTitular(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.p_total\" ng-change=\"changePrimaTitular(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comsión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.comision\" ng-change=\"changePrimaTitular(newCertificate)\"></div></div><div class=\"col-xs-12\"><hr></div><div ng-if=\"!newCertificate.certificado_inciso_activo\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta No Devengada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.p_neta_earned\" ng-change=\"changePrimaTitular(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF Neta No Devengada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.rpf_earned\" ng-change=\"changePrimaTitular(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho Neta No Devengada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.derecho_earned\" ng-change=\"changePrimaTitular(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA Neta No Devengada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.iva_earned\" ng-change=\"changePrimaTitular(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total Neta No Devengada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.p_total_earned\" ng-change=\"changePrimaTitular(newCertificate)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comsión Neta No Devengada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.comision_earned\" ng-change=\"changePrimaTitular(newCertificate)\"></div></div><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 form-group\"><label>Observaciones:</label> <textarea type=\"text\" class=\"form-control\" name=\"observations\" ng-model=\"newCertificate.observations\" ng-change=\"vm.saveLocalstorage()\"></textarea></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"!isEdit\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"validateCertificate(newCertificate.datos.personal,newCertificate.datos.personal.salary)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Certificado</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"isEdit\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"validateCertificate(newCertificate.datos.personal,newCertificate.datos.personal.salary,categorySelected)\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i> Actualizar Certificado</button></div></div></div></div></div><div ng-if=\"show_certificado && show_massCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Agregar Certificados por Layout</h5></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\"></i> Regresar</button></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" ng-if=\"caratula.subramo.subramo_code == 1\">Vida</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo.subramo_code == 30\">Funerarios</legend><legend class=\"legend-title\" ng-if=\"caratula.ramo.ramo_code == 2\">Gastos Médicos</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo.subramo_code == 9\">Automóviles</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo.subramo_code == 7\">Incendio</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo.subramo_code == 13\">Diversos</legend></div><div class=\"col-xs-12 col-sm-8 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Subgrupos</th><th>Categorías</th></tr></thead><tbody><tr ng-repeat=\"item in subgrupos\"><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br><small>Nombre: <span>{{ item.name }}</span></small></td><td><ul><li ng-repeat=\"categorie in item.categorias\"><small>ID para layout:</small><span class=\"font-weight-bold\">{{ categorie.id }}</span><br><small>Nombre: <span>{{ categorie.name }}</span></small></li></ul></td></tr></tbody></table></div><div class=\"col-xs-12 col-sm-4 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Paquetes</th></tr></thead><tbody><tr ng-repeat=\"item in paquetes\"><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br><small>Nombre: <span>{{ item.package_name }}</span></small></td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"!showTableCertificates\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando certificados...</span></div></div></div><div class=\"row\" ng-if=\"showTableCertificates\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">{{ caratula.subramo.subramo_name }}</legend></div><div class=\"col-xs-1 form-group\"><select class=\"form-control\" ng-options=\"renewal.value for renewal in optionsViews\" ng-change=\"selectViews(optionViews)\" ng-model=\"optionViews\"></select></div><div><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\" ng-if=\"caratula.ramo.ramo_name == \'Vida\'\"><thead><tr><td>Familia</td><td>Folio</td><td>Certificado</td><td>Correo</td><td>Tipo</td><td>Parentesco</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Tipo Suma Asegurada</td><td>Suma Asegurada</td><td>Sueldo</td><td>Fumador</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.FAMILIA }}</td><td>{{ item.FOLIO }}</td><td>{{ item.CERTIFICADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.TIPO }}</td><td>{{ item.PARENTESCO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.FECHA_NACIMIENTO }}</td><td>{{ item.SEXO }}</td><td>{{ item.FECHA_ANTIGUEDAD }}</td><td>{{ item.TIPO_SUMA_ASEGURADA }}</td><td>{{ item.SUMA_ASEGURADA }}</td><td>{{ item.SUELDO }}</td><td>{{ item.FUMADOR }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.ramo.ramo_name == \'Accidentes y Enfermedades\'\"><thead><tr><td>Familia</td><td>Folio</td><td>Certificado</td><td>Correo</td><td>Tipo</td><td>Parentesco</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td><td>RFC Clave</td><td>RFC HomoClave</td><td>Domicilio Calle y Número</td><td>Domicilio Colonia</td><td>Domicilio C.P.</td><td>Domicilio Población/Municipio</td><td>Domicilio Estado</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.FAMILIA }}</td><td>{{ item.FOLIO }}</td><td>{{ item.CERTIFICADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.TIPO }}</td><td>{{ item.PARENTESCO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.FECHA_NACIMIENTO }}</td><td>{{ item.SEXO }}</td><td>{{ item.FECHA_ANTIGUEDAD }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td><td>{{item.RFC_CVE}}</td><td>{{item.RFC_HOMOCVE}}</td><td>{{item.DOM_CALLE_NUM}}</td><td>{{item.DOM_COLONIA}}</td><td>{{item.DOM_CP}}</td><td>{{item.DOM_POBLACION}}</td><td>{{item.DOM_ESTADO}}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.subramo.subramo_code == 9\"><div class=\"col-xs-12 text-center\" ng-if=\"errorMensaje\"><div class=\"alert alert-danger alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Error:</strong> {{errorMensaje}}.</div></div><thead><tr><td>Inciso</td><td>Propietario</td><td>Conductor</td><td>Correo</td><td>No. Empleado</td><td>Marca</td><td>Modelo</td><td>Año</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Uso</td><td>Servicio</td><td>Procedencia</td><td>Valor Asegurado</td><td>Tipo Carga</td><td>Adaptaciones</td><td>Monto Adaptaciones</td><td>Equipamineto</td><td>Monto Equipamineto</td><td>Beneficiario Preferente</td><td>Beneficiario RFC</td><td>Beneficiario Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.PROPIETARIO }}</td><td>{{ item.CONDUCTOR }}</td><td>{{ item.CORREO }}</td><td>{{ item.NO_EMPLEADO }}</td><td>{{ item.MARCA }}</td><td>{{ item.MODELO }}</td><td>{{ item.ANO }}</td><td>{{ item.VERSION }}</td><td>{{ item.SERIE }}</td><td>{{ item.MOTOR }}</td><td>{{ item.COLOR }}</td><td>{{ item.MATRICULA }}</td><td>{{ item.USO }}</td><td>{{ item.SERVICIO }}</td><td>{{ item.PROCEDENCIA }}</td><td>{{ item.VALOR_O_SUMA_ASEGURADA }}</td><td>{{ item.TIPO_CARGA }}</td><td>{{ item.ADAPTACIONES }}</td><td>{{ item.MONTO_ADAPTACIONES }}</td><td>{{ item.EQUIPAMIENTO }}</td><td>{{ item.MONTO_EQUIPAMIENTO }}</td><td>{{ item.BENEFICIARIO_PREFERENTE }}</td><td>{{ item.BENEFICIARIO_RFC }}</td><td>{{ item.BENEFICIARIO_DIRECCION }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.subramo.subramo_code == 7\"><thead><tr><td>Inciso</td><td>Sucursal</td><td>Correo</td><td>Giro</td><td>Tipo Constructivo</td><td>No. Niveles</td><td>Zona FHM</td><td>Zona TYEV</td><td>Calle</td><td>No. Interior</td><td>No. Exterior</td><td>Municipio</td><td>Colonia</td><td>Ciudad</td><td>Estado</td><td>Código Postal</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.CORREO }}</td><td>{{ item.GIRO }}</td><td>{{ item.TIPO_CONSTRUCTIVO }}</td><td>{{ item.NO_NIVELES }}</td><td>{{ item.ZONA_FHM }}</td><td>{{ item.ZONA_TYEV }}</td><td>{{ item.CALLE }}</td><td>{{ item.NO_INTERIOR }}</td><td>{{ item.NO_EXTERIOR }}</td><td>{{ item.MUNICIPIO }}</td><td>{{ item.COLONIA }}</td><td>{{ item.CIUDAD }}</td><td>{{ item.ESTADO }}</td><td>{{ item.CP }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.subramo.subramo_code == 13\"><thead><tr><td>Inciso</td><td>Propietario</td><td>No. Empleado</td><td>Correo</td><td>Descripción</td><td>Uso</td><td>Marca</td><td>Modelo</td><td>Año Construcción</td><td>Año Reconstrucción</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Permiso</td><td>Valor Compra</td><td>Calle</td><td>No. Interior</td><td>No. Exterior</td><td>Ciudad</td><td>Estado</td><td>Código Postal</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.PROPIETARIO }}</td><td>{{ item.NO_EMPLEADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.DESCRIPCION }}</td><td>{{ item.USO }}</td><td>{{ item.MARCA }}</td><td>{{ item.MODELO }}</td><td>{{ item.ANO_CONSTRUCCION }}</td><td>{{ item.ANO_RECONSTRUCCION }}</td><td>{{ item.VERSION }}</td><td>{{ item.SERIE }}</td><td>{{ item.MOTOR }}</td><td>{{ item.COLOR }}</td><td>{{ item.MATRICULA }}</td><td>{{ item.PERMISO }}</td><td>{{ item.VALOR_COMPRA }}</td><td>{{ item.CALLE }}</td><td>{{ item.NO_INTERIOR }}</td><td>{{ item.NO_EXTERIOR }}</td><td>{{ item.CIUDAD }}</td><td>{{ item.ESTADO }}</td><td>{{ item.CP }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveCertificates()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Certificados</button></div></div></div></div></div><div ng-if=\"show_certificado && show_showUpdateEmails\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Actualización de correos por layout</h5></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\"></i> Regresar</button></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" ng-if=\"caratula.subramo.subramo_code == 1\">Vida</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo.subramo_code == 30\">Funerarios</legend><legend class=\"legend-title\" ng-if=\"caratula.ramo.ramo_code == 2\">Gastos Médicos</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo.subramo_code == 9\">Automóviles</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo.subramo_code == 7\">Incendio</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo.subramo_code == 13\">Diversos</legend></div></div><div class=\"row\" ng-if=\"!showTableCertificates\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcelUpdateEmails(excelFile)\" onclick=\"limpiar()\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando certificados...</span></div></div></div><div class=\"row\" ng-if=\"showTableUpdateEmails\"><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>CERTIFICADO(TITULAR)</td><td>EMAIL</td></tr></thead><tbody><tr ng-repeat=\"item in excelJson\"><td>{{ item[\'CERTIFICADO(TITULAR)\'] }}</td><td>{{ item.EMAIL }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelUpdateEmails()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveUpdateEmails()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Certificados</button></div></div></div></div></div><div ng-if=\"show_certificado && show_receiptCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Creación de Recibos en Certificados</h5></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\"></i> Regresar</button></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Total de Certificados:</span><div><span>{{ categorySelected.config.count }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{ statusPayment(caratula.forma_de_pago) }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ caratula.subramo.subramo_name }}</span></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 form-group\" ng-if=\"caratula.recibos_poliza.length == 0\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"2\"></receipts-colectivo></div><div class=\"col-xs-12 form-group\" ng-if=\"caratula.recibos_poliza.length == 0\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Se crearán los recibos a nivel carátula, cuando estos ya existan y se agreguen o se quiten certificados, estos se actualizarán automaticamente.</div></div><div class=\"col-xs-12 form-group\" ng-if=\"caratula.recibos_poliza.length > 0\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Los recibos a nivel carátula ya han sido creados, si necesitas modificarlos por favor edita la carátula.</div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveReceiptsCertificates()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear Recibos</button></div></div></div></div></div><div ng-if=\"show_certificado && show_showReceiptCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Recibos en Certificados</h5></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Periodo:</label><select class=\"form-control\" ng-options=\"period.label for period in periods track by period.value\" ng-change=\"changePeriod(periodSelected)\" ng-model=\"periodSelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Vigencia del Periodo:</span><div><span>{{ receiptsPeriods[0].fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ receiptsPeriods[0].fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Total Certificados:</span><div><span>{{ receiptsPeriods.length }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Estatus:</label><select class=\"form-control\" ng-options=\"status.label for status in statusReceiptCertificates track by status.value\" ng-change=\"changeStatusReceipt(statusReceiptCertificateSelected)\" ng-model=\"statusReceiptCertificateSelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-9 form-group\"><label>Buscar</label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-enter=\"searchReceipt(cadena)\" ng-model=\"cadena\" placeholder=\"Certificado, Nombre Titular, Beneficiarios, Dependientes, Marca, Serial\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"searchReceipt(cadena)\">Buscar</button></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t pull-right\" ng-if=\"!desSelected\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"allReciptsSelected(true)\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Seleccionar Todos</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t pull-right\" ng-if=\"desSelected\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"allReciptsSelected(false)\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Deseleccionar Todos</button></div><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Serie</th><th>No. Certificado</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>IVA</th><th>Prima Total</th><th>Comisión</th><th>Vigencia</th><th>Estatus</th><th>Selección</th></tr></thead><tbody><tr ng-repeat=\"receipt in receiptsPeriods track by receipt.id\"><td>{{ receipt.recibo_numero }}</td><td>{{ receipt.poliza }}</td><td>{{ receipt.prima_neta }}</td><td>{{ receipt.rpf }}</td><td>{{ receipt.derecho }}</td><td>{{ receipt.iva }}</td><td>{{ receipt.prima_total }}</td><td>{{ receipt.comision }}</td><td>{{ receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ receipt.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\' }}</td><td><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8}\">{{ statusReceipt(receipt.status) }}</div></td><td><input type=\"checkbox\" name=\"\" ng-model=\"receipt.selected\" ng-click=\"sumReceipts(receipt)\" ng-disabled=\"receipt.status == 1\"></td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-2 form-group pull-right\"><small>Total Seleccionado</small><br><label>{{ totalReceiptSelected | currency }}</label></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group pull-right\"><small>Total Pendiente</small><br><label>{{ totalReceiptPending | currency }}</label></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group pull-right\"><small>Total Pagado</small><br><label>{{ totalReceiptPay | currency }}</label></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group pull-right\"><small>Total Periodo</small><br><label>{{ totalReceiptPeriod | currency }}</label></div></div><div class=\"row\"><div class=\"col-xs-12 form-group col-sm-6 col-md-3 form-group m-t pull-right\"><button class=\"btn btn-success col-xs-12\" ng-click=\"payReceipts()\"><i class=\"fa fa-dollar\" aria-hidden=\"true\"></i> Pagar Recibos Seleccionados</button></div></div></div></div></div><script type=\"text/javascript\">\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"[name=\'text_input\']\");\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n    inputTag.focus();\n  }\n  function blurArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"[name=\'text_input\']\");\n\n    inputTag.addClass(\'display-none\');\n    strongTag.removeClass(\'display-none\');\n  }\n\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/colectivos/colectivos.renewal.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Pólizas de Grupo</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"polizas.table\">Pólizas de Grupo</a></li><li><a ui-sref=\"colectividades.info({polizaId: caratula.id})\">Pólizas de Grupo #{{ copy_caratula.poliza_number }}</a></li><li class=\"active\"><strong>Renovación</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"panel-group\"><div class=\"panel panel-default\" ng-init=\"showCar = false\"><div class=\"panel-heading\" ng-click=\"showCar ? showCar = false : showCar = true\"><h4 class=\"panel-title\"><a>Carátula <i class=\"fa fa-check-circle blue-color\" aria-hidden=\"true\" ng-if=\"showOt == false && caratula.identifier && caratula.address && startDate && endDate && caratula.aseguradora && caratula.ramo && caratula.subramo && caratula.administration_type && caratula.forma_de_pago && caratula.poliza_number\"></i><i class=\"fa fa-check-circle blue-color\" aria-hidden=\"true\" ng-if=\"showOt == true && caratula.identifier && caratula.address && startDate && endDate && caratula.aseguradora && caratula.ramo && caratula.subramo && caratula.administration_type && caratula.forma_de_pago\"></i> <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showCar\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showCar\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showCar\"><div class=\"col-xs-12 animate z-index-9000\" ng-if=\"show_contractor\"><ng-include src=\"\'app/contratantes/contratantes.add.html\'\" ng-controller=\"ContratantesCtrl as vm\"></ng-include></div><div class=\"col-xs-12 animate\" ng-show=\"!show_contractor\"><br><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"OT\" ng-click=\"hideButtonOT()\"><div ng-include=\"\" src=\"\'app/colectivos/ordenes.html\'\"></div></uib-tab><uib-tab index=\"1\" heading=\"Póliza\" ng-click=\"showButtonPolicy()\"><div ng-include=\"\" src=\"\'app/colectivos/ordenes.html\'\"></div></uib-tab></uib-tabset><br></div></div></div><div class=\"panel panel-default\" ng-init=\"showSub = true\"><div class=\"panel-heading\" ng-click=\"showSub ? showSub = false : showSub = true\"><h4 class=\"panel-title\"><a>Subgrupos y Categorías <i class=\"fa fa-check-circle blue-color\" aria-hidden=\"true\" ng-if=\"subgroups.length > 0\"></i> <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showSub\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showSub\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showSub\"><div ng-include=\"\" src=\"\'app/colectivos/subgrupos.html\'\"></div></div></div><div class=\"panel panel-default\" ng-init=\"showPac = true\"><div class=\"panel-heading\" ng-click=\"showPac ? showPac = false : showPac = true\"><h4 class=\"panel-title\"><a>Paquetes <i class=\"fa fa-check-circle blue-color\" aria-hidden=\"true\" ng-if=\"paquetes.length > 0\"></i> <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showPac\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showPac\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showPac\"><br><div ng-include=\"\" src=\"\'app/colectivos/paquetes.html\'\"></div></div></div><div class=\"panel panel-default\" ng-init=\"showCer = true\"><div class=\"panel-heading\" ng-click=\"showCer ? showCer = false : showCer = true\"><h4 class=\"panel-title\"><a>Certificados <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showCer\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showCer\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showCer\"><br><div ng-include=\"\" src=\"\'app/colectivos/certificados.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/colectivos/contributory.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Información Contributoria</h4></div><div class=\"modal-body\"><div class=\"row\" ng-init=\"editInfo = false\"><div class=\"col-xs-12 form-group\" align=\"center\"><span class=\"blue-color\"><b>Número de Póliza:</b></span><div><span>{{ caratulaInfo.poliza_number }}</span></div><div class=\"col-xs-12 col-xs-6\"><input type=\"checkbox\" ng-change=\"changeContributory(caratulaInfo)\" ng-model=\"caratulaInfo.contributory\">Contributoria</div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-secondary ladda-button\" ng-click=\"saveInfoContributory(caratulaInfo)\">Guardar</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div></div>");
$templateCache.put("app/colectivos/conversion.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Convertir a Póliza</h4></div><div class=\"modal-body\"><div class=\"row\"><form class=\"quoteForm\" name=\"otpolicy\" novalidate=\"\"><div class=\"form-group col-xs-6\"><label for=\"\">Folio</label> <input class=\"form-control\" ng-model=\"policy.folio\"></div><div class=\"form-group col-xs-6\"><label>Número de Póliza: <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': policy.poliza_number.$invalid && !policy.poliza_number.$pristine }\"><input class=\"form-control\" ng-blur=\"checkNumPolicy(policy.poliza_number)\" name=\"poliza\" ng-model=\"policy.poliza_number\" type=\"text\" ng-trim=\"false\" required=\"\"></div></div><hr><div class=\"row\" ng-if=\"policy.scheme == 1\"><div class=\"col-xs-12 form-group\" ng-if=\"policy.receipts_by == 1\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-colectivo></div></div><div ng-if=\"policy.scheme == 2\"><div class=\"col-xs-12 form-group\" ng-if=\"policy.receipts_by == 1\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"3\"></receipts-colectivo></div></div></form></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cerrar</button> <button class=\"btn btn-success ladda-button\" ng-disabled=\"otpolicy.$invalid\" ng-click=\"save()\" type=\"button\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Convertir a Póliza</button></div></div>");
$templateCache.put("app/colectivos/deleteElement.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Relaciones</h4></div><div class=\"modal-body\"><div class=\"col-xs-12\" align=\"center\"><label ng-if=\"itemDelete.document_type==3\">Póliza de Grupo: {{itemDelete.poliza_number}}</label> <label ng-if=\"itemDelete.document_type==4\">Subgrupo: {{itemDelete.name}}</label> <label ng-if=\"itemDelete.document_type==5\">Categoría: {{itemDelete.name}}</label> <label ng-if=\"itemDelete.document_type==6\">Certificado: {{itemDelete.certificate_number}}</label></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12\" align=\"center\"><label>Categorías</label></div><table class=\"table table-bordered\"><thead><tr><th>ID</th><th>Categoría</th><th>ID Carátula</th></tr></thead><tbody><tr ng-repeat=\"registro in lista[\'categorias\']\"><td><b>{{ registro[2]}}</b></td><td>{{ registro[0] }}</td><td width=\"30%\"><b>{{ registro[1]}}</b></td></tr></tbody></table><div class=\"col-xs-12\" align=\"center\"><label>Certificados</label></div><table class=\"table table-bordered\"><thead><tr><th>ID</th><th># Certificado</th><th>Categoría</th><th>ID Categoría</th></tr></thead><tbody><tr ng-repeat=\"crt in lista[\'certificados\']\"><td><b>{{ crt[3]}}</b></td><td>{{ crt[2] }}</td><td width=\"30%\"><b>{{ crt[0]}}</b></td><td>{{ crt[1] }}</td></tr></tbody></table><div class=\"col-xs-12\" align=\"center\"><label>Endosos</label></div><table class=\"table table-bordered\"><thead><tr><th>ID</th><th># Endoso</th><th>Interno</th></tr></thead><tbody><tr ng-repeat=\"end in lista[\'endosos\']\"><td><b>{{ end[2]}}</b></td><td>{{ end[1] }}</td><td width=\"30%\"><b>{{ end[0]}}</b></td></tr></tbody></table><div class=\"col-xs-12\" align=\"center\"><label>Siniestros</label></div><table class=\"table table-bordered\"><thead><tr><th>ID</th><th># Siniestro</th><th>Interno</th></tr></thead><tbody><tr ng-repeat=\"sins in lista[\'siniestros\']\"><td><b>{{ sins[2]}}</b></td><td>{{ sins[1] }}</td><td width=\"30%\"><b>{{ sins[0]}}</b></td></tr></tbody></table><div class=\"col-xs-12\" align=\"center\"><label>Endosos Certificados</label></div><table class=\"table table-bordered\"><thead><tr><th>ID</th><th>Interno</th><th># Endoso</th><th># Póliza</th><th>ID Póliza</th></tr></thead><tbody><tr ng-repeat=\"ecr in lista[\'endososCertificados\']\"><td><b>{{ ecr[4]}}</b></td><td>{{ ecr[0] }}</td><td width=\"30%\"><b>{{ ecr[1]}}</b></td><td>{{ ecr[2] }}</td><td>{{ ecr[3] }}</td></tr></tbody></table><div class=\"col-xs-12\" align=\"center\"><label>Siniestros Certificados</label></div><table class=\"table table-bordered\"><thead><tr><th>ID</th><th>Interno</th><th># Siniestro</th><th># Póliza</th><th>ID Póliza</th></tr></thead><tbody><tr ng-repeat=\"scr in lista[\'siniestrosCertificados\']\"><td><b>{{ scr[4]}}</b></td><td>{{ scr[0] }}</td><td width=\"30%\"><b>{{ scr[1]}}</b></td><td>{{ scr[2] }}</td><td>{{ scr[3] }}</td></tr></tbody></table></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-if=\"itemDelete.document_type !=3 && itemDelete.document_type!=\'Póliza de grupo\'\" class=\"btn btn-danger\" ng-click=\"okay(aeliminar)\">Eliminar</button> <button type=\"button\" ng-if=\"itemDelete.document_type ==3 || itemDelete.document_type==\'Póliza de grupo\'\" class=\"btn btn-danger\" ng-click=\"deletePGrupo(aeliminar)\">Eliminar Póliza</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div></div>");
$templateCache.put("app/colectivos/log.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Registro de Actividad</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered\" ng-init=\"showLog = false\"><thead><tr><th>Fecha</th><th>Acción</th><th>Optiones</th></tr></thead><tbody><tr ng-repeat=\"registro in logs\"><td><b>{{ registro.date | date: \'dd/MM/yyyy\' : \'UTC\'}}</b><br><small>{{ registro.date | date: \'h:mm:ss a\'}}</small></td><td>{{ registro.msj }}</td><td width=\"30%\"><div ng-if=\"registro.change[0].name\"><button class=\"btn btn-white\" ng-click=\"showLog ? showLog = false : showLog = true\">Ver cambios</button><div ng-if=\"showLog\" ng-repeat=\"item in registro.change track by $index\"><label>{{ item.name }}</label><br><small>Antes:</small><span>{{ item.origin }}</span><br><small class=\"border-left\">Ahora:</small><span>{{ item.change }}</span></div></div><div ng-if=\"!registro.change[0].name && registro.change && registro.change !={} && registro.change!=[] && registro.change\"><span ng-if=\"registro.change.length >0 && registro.change !=\'{}\'\">{{registro.change}}</span></div></td></tr></tbody></table></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div></div>");
$templateCache.put("app/colectivos/ordenes.html","<toaster-container></toaster-container><div class=\"pull-right option_button m-b\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\" ng-if=\"order.acceso_form\"><li class=\"dropdown-submenu\"><a>Descargar layouts</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Flotillas.xls\">Flotillas</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Gastos_Medicos.xls\">Gastos médicos</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Vida.xls\">Vida</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Incendio.xls\">Incendio</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Eq_Elect_Contratista.xls\">Diversos</a></li></ul></li></ul></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"caratula.identifier\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Folio Interno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"caratula.internal_number\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"!showOt\"><label>Folio:</label> <input class=\"form-control\" type=\"text\" ng-model=\"caratula.folio\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"!showOt\"><label>Número de Póliza: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-blur=\"checkNumPolicy()\" ng-model=\"caratula.poliza_number\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante: <span class=\"color-red\">*</span></label><div class=\"input-group\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contratante\" change=\"matchesContractors(order.contratante)\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"contratanteCreator(); show_contractor = true\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in addresses track by address.url\" ng-change=\"changeAddress(addressSelected)\" ng-model=\"addressSelected\" ng-disabled=\"!order.contratante\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo Electrónico:</label> <input class=\"form-control\" type=\"email\" ng-model=\"order.contratante.value.email\" ng-disabled=\"!order.contratante\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono:</label><phonenumber-directive model=\"order.contratante.value.phone_number\" class=\"ng-isolate-scope\"><input class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" type=\"tel\" maxlength=\"25\" aria-invalid=\"false\" ng-model=\"inputValue\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Vigencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"startDate\" value=\"{{startDate}}\" ng-change=\"checkDate(startDate);saveLocalstorange()\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Al: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"endDate\" value=\"{{endDate}}\" ng-change=\"checkEndDate(endDate);saveLocalstorange()\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Aseguradora: <span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control\" ng-options=\"aseguradora.alias for aseguradora in providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"getClaves(aseguradoraSelected);saveLocalstorange()\" ng-model=\"aseguradoraSelected\"><option value=\"\">Selecciona un proveedor</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"refreshProvider()\"><i class=\"glyphicon glyphicon-refresh\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Clave de Agente: <span class=\"color-red\">*</span></label> <input ng-if=\"claves.length == 0\" class=\"form-control\" type=\"text\" placeholder=\"Elige una aseguradora aseguradora\" disabled=\"\"> <input ng-if=\"claves.length == 1\" class=\"form-control\" type=\"text\" value=\"{{claves[0].clave + \' - \' + claves[0].name}}\" disabled=\"\"><select ng-if=\"claves.length > 1\" class=\"form-control\" ng-options=\"clave as clave.clave + \' - \' + clave.name for clave in claves | orderBy: \'clave\' track by clave.url\" ng-change=\"changeClave(claveSelected); saveLocalstorange()\" ng-model=\"claveSelected\" ng-disabled=\"!aseguradoraSelected\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"ramo.ramo_name for ramo in ramos track by ramo.url\" ng-change=\"changeRamo(ramoSelected);saveLocalstorange()\" ng-model=\"ramoSelected\" ng-disabled=\"!aseguradoraSelected\"><option value=\"\">Selecciona un ramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"subramo.subramo_name for subramo in subramos track by subramo.url\" ng-model=\"subramoSelected\" ng-disabled=\"!ramoSelected\" ng-change=\"changeSubramo(subramoSelected);saveLocalstorange(subramoSelected)\"><option value=\"\">Selecciona un subramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Renovable: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"renewal.label for renewal in renewals\" ng-change=\"changeRenewal(renewalSelected)\" ng-model=\"renewalSelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Tipo de Administración: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"renewal.label for renewal in administrationTypes\" ng-change=\"changeAdminType(administrationSelected);saveLocalstorange()\" ng-model=\"administrationSelected\"><option value=\"\">Selecciona un tipo de administración</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Moneda:</label><select class=\"form-control\" ng-init=\"currencySelected = 1\" ng-options=\"currency.value as currency.label for currency in currencys\" ng-change=\"changeCurrency(currencySelected);saveLocalstorange()\" ng-model=\"currencySelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Responsable:</label><select class=\"form-control\" ng-options=\"responsable.id as responsable.first_name + \' \' + responsable.last_name for responsable in users\" ng-change=\"changeResponsable(responsableSelected);saveLocalstorange()\" ng-model=\"responsableSelected\"><option value=\"\">Seleccione un responsable</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ejecutivo de Cobranza:</label><select class=\"form-control\" ng-options=\"collection_executive.id as collection_executive.first_name + \' \' + collection_executive.last_name for collection_executive in ejecutivos\" ng-change=\"changeExecutive(executiveSelected);saveLocalstorange()\" ng-model=\"executiveSelected\"><option value=\"\">Seleccione un ejecutivo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Conducto de pago:</label><select class=\"form-control\" ng-options=\"conducto_de_pago.value as conducto_de_pago.label for conducto_de_pago in conductos_de_pago\" ng-change=\"changeConducto(conductoSelected);saveLocalstorange()\" ng-model=\"conductoSelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-options=\"businesslin.name for businesslin in businessline | orderBy:\'id\' track by businesslin.id\" ng-change=\"changeBusinessLine(business_lineSelected);saveLocalstorange()\" name=\"business\" ng-model=\"business_lineSelected\"><option value=\"\" disabled=\"\">Seleccione una línea</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-options=\"celula.celula_name for celula in celulas | orderBy:\'id\' track by celula.id\" ng-change=\"changeCelula(celulaSelected);saveLocalstorange()\" ng-model=\"celulaSelected\"><option value=\"\" disabled=\"\">Seleccione {{moduleName}}</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Agrupación</label><select class=\"form-control\" ng-options=\"item.description for item in agrupaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeAgrupacion(grouping_levelSelected); saveLocalstorange()\" ng-model=\"grouping_levelSelected\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Subagrupación</label><select class=\"form-control\" ng-options=\"item.description for item in sub_asignaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeSubagrupacion(subgroupingSelected); saveLocalstorange()\" ng-model=\"subgroupingSelected\" ng-disabled=\"!grouping_levelSelected\"><option value=\"\" disabled=\"\">Seleccione una subagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Subsubagrupación</label><select class=\"form-control\" ng-options=\"item.description for item in sub_subasignaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeSubsubagrupacion(subsubgroupingSelected); saveLocalstorange()\" ng-model=\"subsubgroupingSelected\" ng-disabled=\"!subgroupingSelected\"><option value=\"\" disabled=\"\">Seleccione una subsubagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Sucursal:</label><select class=\"form-control\" ng-options=\"sucursal.id as sucursal.sucursal_name for sucursal in sucursales\" ng-change=\"changeSucursal(sucursalSelected);saveLocalstorange()\" ng-model=\"sucursalSelected\"><option value=\"\">Seleccione una sucursal</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Esquema de Pago: <span class=\"color-red\">*</span></label><div><div class=\"btn-group\"><button class=\"btn\" ng-click=\"chanceScheme(1);saveLocalstorange()\" ng-style=\"btnTraditionalStyle\"><i class=\"fa fa-suitcase\" aria-hidden=\"true\"></i> Tradicional</button> <button class=\"btn\" ng-click=\"chanceScheme(2);saveLocalstorange()\" ng-style=\"btnMinimalStyle\"><i class=\"fa fa-cubes\" aria-hidden=\"true\"></i> Prima Mínima</button></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.scheme == 1\"><label>Frecuencia de Pago: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"frequency.value as frequency.label for frequency in frequencies\" ng-change=\"chancePayment(paymentSelected);saveLocalstorange()\" ng-model=\"paymentSelected\"><option value=\"\" disabled=\"\">Selecciona una frecuencia</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.scheme == 2\"><label>Frecuencia de Pago: <span class=\"color-red\">*</span></label><select class=\"form-control\" disabled=\"\"><option value=\"\">Contado</option></select></div><div class=\"col-xs-12 col-sm-6 form-group hidden-xs hidden-sm\" ng-if=\"acceso_ver_ref\"><label>Referenciadores <span ng-if=\"!order.acc_referenciador_obligatorio\" class=\"color-red\">*</span>:</label><div ng-repeat=\"item in referenciadorArray\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteReferenciador($index);saveLocalstorange()\" ng-disabled=\"referenciadorArray.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control\" ng-change=\"saveLocalstorange()\" ng-options=\"referenciador.id as referenciador.first_name + \' \' + referenciador.last_name for referenciador in referenciadores\" ng-model=\"item.referenciador\"><option value=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\"><input class=\"form-control wb102\" type=\"text\" placeholder=\"% Comisión\" ng-disabled=\"referenciadorArray.length <= 1\" ng-change=\"changeComRef(item.comision_vendedor, $index,item)\" ng-model=\"item.comision_vendedor\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Observaciones</legend><textarea class=\"form-control\" type=\"text\" ng-model=\"caratula.observations\" ng-change=\"saveLocalstorange()\"></textarea></div><div class=\"col-xs-12 form-group\" ng-if=\"order.permiso_administrar_adjuntos\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"row\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div><div ng-if=\"caratula.scheme == 1\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Crear recibos por</legend><div class=\"btn-group col-sm-4 col-sm-offset-4\"><button class=\"btn\" ng-click=\"createReceits(1)\" ng-style=\"btnPolicyStyle\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i> Póliza</button> <button class=\"btn\" ng-click=\"createReceits(2)\" ng-style=\"btnSudgroupStyle\"><i class=\"fa fa-tasks\" aria-hidden=\"true\"></i> Subgrupo</button> <button class=\"btn\" ng-click=\"createReceits(3)\" ng-style=\"btnCertificateStyle\"><i class=\"fa fa-th-large\" aria-hidden=\"true\"></i> Certificado</button></div></div><div class=\"col-xs-12 form-group\" ng-if=\"!showOt && caratula.receipts_by == 1\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-colectivo></div></div><button id=\"createCont\" ng-click=\"contratanteCreator()\" class=\"display-none\"></button><div ng-if=\"!showOt && caratula.scheme == 2\"><div class=\"col-xs-12 form-group\" ng-if=\"caratula.receipts_by == 1\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"3\"></receipts-colectivo></div></div><div class=\"col-xs-12 col-sm-4 col-sm-offset-4 form-group\" ng-if=\"showOt\" ng-show=\"!disabled\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-disabled=\"disabled\" ng-click=\"validityInsurance()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar OT y Salir</button></div><div class=\"row\"><div class=\"col-xs-12 form-group container-loader\" ng-if=\"disabled\"><label class=\"color-blue\" align=\"center\">Se esta guardando la información</label> <img src=\"../../assets/images/loader/blue_loader.gif\"></div></div><div class=\"col-xs-12 col-sm-4 col-sm-offset-4 form-group\" ng-show=\"!disabled\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"nextSubgroup()\"><i class=\"fa fa-forward\" aria-hidden=\"true\"></i> Continuar</button></div></div>");
$templateCache.put("app/colectivos/paquetes.html","<toaster-container></toaster-container><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-sm-4 form-group\" ng-if=\"showRenewal\"><button class=\"btn btn-success col-xs-12\" ng-click=\"copyPackage()\" ng-disabled=\"paquetes.length > 0\"><i class=\"fa fa-clone\" aria-hidden=\"true\"></i> Copiar Paquetes de Pólizas de Grupo Anterior</button></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Paquetes</legend></div><div class=\"col-xs-12 form-group\" ng-if=\"paquetes.length > 0\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Nombre</th><th>Coberturas</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in paquetes\"><td>{{ item.package_name }}</td><td>{{ item.coverage_package.length }}</td><td><button type=\"button\" class=\"btn btn-white\" ng-click=\"deletePackage($index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></tbody></table></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Paquete: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"pack.package_name for pack in packages\" ng-change=\"changePackage(packageSelected)\" ng-model=\"packageSelected\"><option value=\"\" disabled=\"\">Selecciona un paquete</option></select></div><div class=\"col-xs-12 col-sm-3 form-group m-t\"><button class=\"btn btn-info\" ng-click=\"showNewPackage(true)\"><i class=\"fa fa-plus-square\" aria-hidden=\"true\"></i> Crear Paquete</button></div><div ng-if=\"newPackage\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Nuevo Paquete</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre del Paquete: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newPackageCoverage.package_name\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones:</label> <textarea type=\"text\" class=\"form-control\" ng-model=\"newPackageCoverage.description\"></textarea></div><div class=\"address-container\" ng-repeat=\"item in newPackageCoverage.coverage_package\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteNewPackageCoverage($index)\" ng-disabled=\"newPackageCoverage.coverage_package.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Cobertura</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteNewPackageCoverage($index)\" ng-disabled=\"newPackageCoverage.coverage_package.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Cobertura #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addNewPackageCoverage()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Cobertura</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addNewPackageCoverage()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre de la Cobertura: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.coverage_name\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Suma Asegurada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.sums_coverage\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Deducible:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.deductible\"></div></div></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"saveNewPackage()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Paquete</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\"><button class=\"btn btn-white col-xs-12\" ng-click=\"showNewPackage(false)\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div ng-if=\"personalizePackage\"><div class=\"col-xs-12 form-group\"><div ng-include=\"\'app/coberturas/coberturas.table.html\'\"></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\" ng-if=\"newCoverages.length == 0\"><button class=\"btn btn-success col-xs-12\" ng-click=\"addPackageCoverage(true)\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Nueva Cobertura</button></div></div><div class=\"address-container\" ng-repeat=\"item in newCoverages\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deletePackageCoverage($index)\" ng-disabled=\"newCoverages.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Cobertura</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deletePackageCoverage($index)\" ng-disabled=\"newCoverages.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Cobertura #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addPackageCoverage(true)\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Cobertura</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addPackageCoverage(true)\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre de la Cobertura: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.coverage_name\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Suma Asegurada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.sums_coverage\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Deducible:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.deductible_coverage\"></div></div></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\" ng-if=\"newCoverages.length > 0\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"saveCoverage(packageSelected)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Cobertura</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\" ng-if=\"newCoverages.length > 0\"><button class=\"btn btn-white col-xs-12\" ng-click=\"addPackageCoverage(false)\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 form-group\"><br><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Debes agregar el paquete con el botón de abajo para guardarlo y poder agregar el siguiente paquete.</div></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"addPackage()\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Agregar Paquete</button></div></div><div class=\"col-xs-12 form-group\"><br></div><div class=\"col-xs-12 form-group\" ng-if=\"dataCaratula.id && countFile > 0\"><legend class=\"legend-title\" align=\"center\">Subiendo Archivos... ({{ okFile }}/{{ countFile }})</legend><table class=\"table table-stripped hidden-xs hidden-sm\"><tbody><tr ng-repeat=\"item in uploader.queue track by $index\"><td>{{ item.file.name }}</td><td>{{ item.file.size/1024/1024|number:2 }}MB</td><td width=\"20%\"><div class=\"progress margin-bottom-0\"><div class=\"progress-bar\" ng-style=\"{ \'width\': item.progress + \'%\' }\" role=\"progressbar\"></div></div></td></tr></tbody></table></div><div class=\"col-xs-12 col-sm-4 col-sm-offset-4 form-group\"><button class=\"col-xs-12 btn btn-success btn-lg m-t ladda-button\" ng-disabled=\"disabled\" ng-click=\"validityInsurance()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Póliza de Grupo</button></div></div>");
$templateCache.put("app/colectivos/receipt.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Actualizar Recibo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><h3>Estatus actual:</h3><div ng-bind=\"rec.recibo.status | receipts\" class=\"label\" ng-class=\"{\'label-success\': rec.recibo.status == 1 || rec.recibo.status == 5, \'label-danger\': rec.recibo.status == 2, \'label-warning\' : rec.recibo.status == 3 || rec.recibo.status == 4, \'label-default\': rec.recibo.status == 6 || rec.receipt.status == 7 || rec.recibo.status == 8}\"></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Número de Recibo</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.recibo_numero\" name=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Inicio Vigencia</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"rec.recibo.fecha_inicio\" value=\"{{rec.recibo.fecha_inicio}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fin Vigencia</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"rec.recibo.fecha_fin\" value=\"{{rec.recibo.fecha_fin}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Prima Neta</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.prima_neta\" ng-change=\"validateDecimal(rec.recibo.prima_neta); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>RPF</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.rpf\" ng-change=\"validateDecimal(rec.recibo.rpf); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Derecho</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.derecho\" ng-change=\"validateDecimal(rec.recibo.derecho); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>IVA</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.iva\" ng-change=\"validateDecimal(rec.recibo.iva); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Comisión</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.comision\" ng-change=\"validateDecimal(rec.recibo.comision); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Vencimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"rec.recibo.vencimiento\" value=\"{{rec.recibo.vencimiento}}\" data-date-format=\"mm/dd/yyyy\" ng-change=\"validateDates_venc(rec.recibo.vencimiento)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Subtotal</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.sub_total\" name=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Prima Total</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.prima_total\" name=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Entregado</label><div><input type=\"checkbox\" ng-model=\"rec.recibo.delivered\" name=\"\"></div></div><div class=\"col-xs-12 form-group\" ng-if=\"rec.recibo.receipt_type == 3\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Las cantidades en las notas de crédito tienen que ir con valores negativos.</div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"saveReceipt(rec.recibo)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Cambios</button></div></div>");
$templateCache.put("app/colectivos/subgrupos.html","<toaster-container></toaster-container><div class=\"row\"><br><div class=\"col-xs-12 col-sm-6 col-sm-4 form-group\" ng-if=\"showRenewal\"><button class=\"btn btn-success col-xs-12\" ng-click=\"copySubgroup()\" ng-disabled=\"subgroupsInfo.length > 0\"><i class=\"fa fa-clone\" aria-hidden=\"true\"></i> Copiar Subgrupos de Pólizas de Grupo Anterior</button></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Subgrupos</legend></div><div class=\"col-xs-12 form-group\" ng-if=\"subgroupsInfo.length > 0\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Nombre</th><th ng-if=\"subgroupsInfo[0].contractor != null\">Contratante</th><th ng-if=\"subgroupsInfo[0].receipts > 0\">No. Recibos</th><th>Categorías</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in subgroupsInfo\"><td>{{ item.name }}</td><td ng-if=\"item.contractor != null\"><span>{{ item.contractor }}</span></td><td ng-if=\"item.receipts > 0\"><span>{{ item.receipts }}</span></td><td><ul><li ng-repeat=\"categorie in item.categorias\"><span>{{ categorie.name }}</span></li></ul></td><td><button type=\"button\" class=\"btn btn-white\" ng-click=\"deleteSubgroup($index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></tbody></table></div><div class=\"col-xs-12 col-sm-3 col-sm-offset-3 form-group\" ng-if=\"!addSubgrupos\"><button class=\"btn btn-warning col-xs-12\" ng-click=\"defaultSubgroup()\" ng-disabled=\"subgroupsInfo.length || caratula.receipts_by == 2\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Subgrupo Default</button></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"!addSubgrupos\"><button class=\"btn btn-success col-xs-12\" ng-click=\"showSubgroup(true)\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nuevo Subgrupo</button></div><div ng-if=\"addSubgrupos\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"itemSubgrupos.name\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones:</label> <textarea type=\"text\" class=\"form-control\" ng-model=\"itemSubgrupos.observations\"></textarea></div><div ng-if=\"caratula.receipts_by == 2\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante: <span class=\"color-red\">*</span></label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contratanteSubgrupo\" change=\"matchesContractors(order.contratanteSubgrupo)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección:</label><select class=\"form-control\" ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in addressSubgroups track by address.url\" ng-change=\"changeAddressSubgroup(itemSubgrupos.addressSelected)\" ng-model=\"itemSubgrupos.addressSelected\" ng-disabled=\"!order.contratanteSubgrupo\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 form-group\" ng-if=\"!showOt && caratula.receipts_by == 2\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-colectivo></div></div><div class=\"address-container\" ng-repeat=\"item in itemSubgrupos.categorias\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteCategorie($index)\" ng-disabled=\"itemSubgrupos.categorias.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Categoría</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteCategorie($index)\" ng-disabled=\"itemSubgrupos.categorias.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Categoría #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addCategorie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Categoría</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addCategorie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.name\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"caratula.ramo.ramo_code == 2\"><label>Nivel Hospitalario: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.hospital_level\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones:</label> <textarea type=\"text\" class=\"form-control\" ng-model=\"item.observations\"></textarea></div></div></div><div class=\"col-xs-12 form-grou\"><br><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Debes agregar el subgrupo con el botón de abajo para guardarlo y poder agregar el siguiente grupo.</div></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"addSubgroup()\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Agregar Subgrupo</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-white col-xs-12\" ng-click=\"showSubgroup(false)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div class=\"col-xs-12 col-sm-4 col-sm-offset-4 form-group\"><button class=\"col-xs-12 btn btn-primary m-t\" ng-click=\"nextPackage()\"><i class=\"fa fa-forward\" aria-hidden=\"true\"></i> Continuar</button></div></div>");
$templateCache.put("app/comisiones/add_account_modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Agregar Nueva Cuenta</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 form-group\"><label>Nombre:<span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.name\" type=\"text\" required=\"\"></div><div class=\"col-xs-12 form-group\"><label>Cuenta<span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.account\" type=\"text\" required=\"\"></div><div class=\"col-xs-12 form-group\"><label>Banco<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"bank.id as bank.alias for bank in bancos | orderBy: \'alias\' track by bank.url\" ng-model=\"vm.banco_selected\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione un banco</option></select></div><div class=\"col-xs-12 form-group\"><label>Observación:<span class=\"color-red\">*</span></label> <textarea class=\"form-control\" name=\"observation\" ng-model=\"vm.observation\" type=\"text\" required=\"\"></textarea></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success\" ng-disabled=\"\" ng-click=\"saveAccount()\" type=\"button\">Agregar</button></div></div>");
$templateCache.put("app/comisiones/comisiones.consulta.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12\"><h2>Comisiones</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Comisiones</a></li><li class=\"active\"><strong>Consultar</strong></li></ol></div></div><br><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-init=\"active()\"><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\" style=\"word-wrap: break-word;\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\"><label>Aseguradora</label><select class=\"form-control\" ng-model=\"provider\" ng-options=\"provider.compania for provider in providers | orderBy: \'compania\' track by provider.url\" ng-change=\"changeProvider(provider)\"><option value=\"\" disabled=\"\">Seleccione una aseguradora</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\"><label>Ramo</label><select class=\"form-control\" ng-model=\"ramo\" ng-options=\"ramo.ramo_name for ramo in ramos | orderBy: \'ramo_name\' track by ramo.url\" ng-change=\"changeRamo(ramo)\" ng-disabled=\"!provider\"><option value=\"\" disabled=\"\">Seleccione un ramo</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\"><label>Subramo</label><select class=\"form-control\" ng-model=\"subramo\" ng-options=\"subramo.subramo_name for subramo in subramos | orderBy: \'subramo_name\' track by subramo.url\" ng-change=\"changeSubRamo(subramo)\" ng-disabled=\"!ramo\"><option value=\"\">Seleccione un subramo</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\"><label>Folio de conciliación</label><div><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"folio_conciliacion\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\"><label>Clave de Agente</label><select class=\"form-control\" ng-model=\"clave\" ng-options=\"clave as clave.clave + \' - \' + clave.name for clave in claves | orderBy: \'clave\' track by clave.url\" ng-change=\"changeClave(clave)\"><option value=\"\">Seleccione una clave de agente</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Consulta por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport()\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\" ng-if=\"vigency || created_at\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"filterDate.startDate\" value=\"{{filterDate.startDate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4 col-lg-3\" ng-if=\"vigency || created_at\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"filterDate.endDate\" value=\"{{filterDate.endDate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"row\"><div class=\"form-group col-xs-12\"><button class=\"btn btn-success btn-mt pull-right\" ng-click=\"showFilter()\">Consultar</button></div></div></div></div><div class=\"ibox float-e-margins border-bottom\" ng-if=\"show_commission\"><div class=\"ibox-title\"><h5>Conciliaciones</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content animate z-index-9000\" ng-if=\"show_information\"><div class=\"row animate\"><div class=\"col-xs-12\"><div class=\"inmodal\" id=\"myModal\" data-dismiss=\"modal\"><div class=\"form-group\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"returnToList()\">Regresar</button></div><div ng-repeat=\"conciliation in conciliations\"><legend class=\"legend-title\" align=\"center\">Recibo #{{$index + 1}}</legend><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"color-blue\">Número de Recibo</span><div><span>{{ conciliation.recibo_numero }}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"color-blue\">Folio</span><div><span>{{ conciliation.consiliacion_folio }}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"color-blue\">Comisión Conciliada</span><div><span>{{ conciliation.comision_conciliacion }}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"color-blue\">Fecha de Aplicación</span><div><span>{{ conciliation.conciliacion_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"color-blue\">Cuenta</span><div><span>{{ conciliation.conciliation_account }}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"color-blue\">Observaciones</span><div><span>{{ conciliation.conciliacion_observation }}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div></div></div></div></div></div><div class=\"ibox-content\" ng-if=\"show_table\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th ng-model=\"vm.table.headers[0]\">{{ vm.table.headers[0] }}</th><th ng-model=\"vm.table.headers[1]\">{{ vm.table.headers[1] }}</th><th ng-model=\"vm.table.headers[3]\">{{ vm.table.headers[3] }}</th><th ng-model=\"vm.table.headers[4]\">{{ vm.table.headers[4] }}</th></tr></thead><tbody><tr ng-repeat=\"commission in commissions.folios_recibos_count\" ng-click=\"$event.stopPropagation(); vm.showReceipts(commission.conciliacion_folio)\"><td>{{ commission.conciliacion_folio }}</td><td>{{ commission.conciliation_account__account }}</td><td>{{ commission.conciliacion_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ commission.conciliacion_folio__count }}</td></tr></tbody></table><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"commission in commissions\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}: {{ commission.conciliacion_folio }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ commission.conciliacion_folio }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ commission.conciliation_account.account }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p>{{ commission.conciliacion_observation }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ commission.conciliacion_date }}</p></div></tr></table></div></div></div><div class=\"col-xs-12 btn-mt\" ng-if=\"recibos_folio && recibos_folio.length > 0 && shReceipst\"><legend class=\"legend-title\" align=\"center\">Recibos</legend><table class=\"table table-bordered table-hover\"><thead><tr><th>Folio Conciliación</th><th>Fecha Conciliación</th><th ng-click=\"vm.changeRecibos(1, vm.numero_asc == 1 ? 2 : 1)\">Número Recibo <span ng-class=\"{\'fa fa-sort-desc\': vm.numero_asc == 1, \'fa fa-sort-asc\': vm.numero_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(2, vm.numerop_asc == 1 ? 2 : 1)\">Número Póliza/Fianza/Factura Bono <span ng-class=\"{\'fa fa-sort-desc\': vm.numerop_asc == 1, \'fa fa-sort-asc\': vm.numerop_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(3, vm.numeroe_asc == 1 ? 2 : 1)\">Número Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.numeroe_asc == 1, \'fa fa-sort-asc\': vm.numeroe_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(4, vm.contratante_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.contratante_asc == 1, \'fa fa-sort-asc\': vm.contratante_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(5, vm.recibo_asc == 1 ? 2 : 1)\">Tipo de recibo <span ng-class=\"{\'fa fa-sort-desc\': vm.recibo_asc == 1, \'fa fa-sort-asc\': vm.recibo_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(6, vm.vigencia_asc == 1 ? 2 : 1)\">Vigencia <span ng-class=\"{\'fa fa-sort-desc\': vm.vigencia_asc == 1, \'fa fa-sort-asc\': vm.vigencia_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(7, vm.primatotal_asc == 1 ? 2 : 1)\">Prima Total <span ng-class=\"{\'fa fa-sort-desc\': vm.primatotal_asc == 1, \'fa fa-sort-asc\': vm.primatotal_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(8, vm.comision_asc == 1 ? 2 : 1)\">Comisión <span ng-class=\"{\'fa fa-sort-desc\': vm.comision_asc == 1, \'fa fa-sort-asc\': vm.comision_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(9, vm.conciliada_asc == 1 ? 2 : 1)\">Comisión Conciliada <span ng-class=\"{\'fa fa-sort-desc\': vm.conciliada_asc == 1, \'fa fa-sort-asc\': vm.conciliada_asc == 2}\"></span></th></tr></thead><tbody><tr ng-repeat=\"receipt in recibos_folio track by $index\"><td>{{receipt.conciliacion_folio}}</td><td>{{receipt.conciliacion_date | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td>{{ receipt.recibo_numero }}</td><td>{{ receipt.poliza.poliza_number }} {{ receipt.fianza.fianza_number }} {{ receipt.bono.factura_number }} <span ng-if=\"receipt.poliza.document_type == 4 && !receipt.poliza.poliza_number\">{{receipt.poliza.parent.poliza_number}}</span></td><td><span ng-if=\"receipt.receipt_type == 2 || receipt.receipt_type == 3\">{{receipt.endorsement.number_endorsement }}</span></td><td>{{ receipt.poliza.contractor.full_name}}<span ng-if=\"receipt.poliza.document_type == 4 && (!receipt.poliza.contractor)\">{{ receipt.poliza.parent.contractor.full_name }}</span></td><td><span ng-if=\"receipt.receipt_type == 2\">Endoso</span> <span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type == 1\">Póliza</span> <span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type == 3\">Colectividad</span> <span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type == 4\">Subgrupo</span> <span ng-if=\"receipt.receipt_type == 3\">Nota de Crédito / Endoso</span> <span ng-if=\"receipt.receipt_type == 4\">Recibo Bono</span></td><td>{{ receipt.fecha_inicio | date:\"dd/MM/yyyy\": \'UTC\'}} - {{ receipt.fecha_fin | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td>{{ receipt.prima_total | currency}}</td><td>{{ receipt.comision | currency}}</td><td>{{ receipt.comision_conciliada | currency }}</td></tr></tbody></table><br><div class=\"row\" ng-if=\"recibos_folio.length > 0 && vm.acceso_rep_cob\"><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" style=\"margin-bottom: 20px;\"><button class=\"col-xs-12 btn btn-primary ladda-button2\" ng-click=\"exportDataExcel(1)\">Generar Reporte</button></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" style=\"margin-bottom: 20px;\"><button class=\"btn btn-white pull-right\" ng-if=\"folio_selected\" ng-click=\"getPDFConciliacion(folio_selected)\"><strong color-blue=\"\">Ver PDF</strong></button></div></div><div class=\"col-xs-12 form-group\" style=\"margin-bottom: 50px;\"></div></div></div>");
$templateCache.put("app/comisiones/comisiones.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12\"><h2>Comisiones</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Comisiones</a></li><li class=\"active\"><strong>Conciliar</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 form-group\" style=\"word-wrap: break-word;\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Proveedores</label><select class=\"form-control\" name=\"provider\" ng-model=\"vm.form.provider\" ng-options=\"provider.compania for provider in vm.providers | orderBy: \'compania\' track by provider.url\" ng-change=\"vm.changeProvider(vm.form.provider)\"><option value=\"\">Proveedores</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo</label><select class=\"form-control\" name=\"ramo\" ng-model=\"vm.form.ramo\" ng-options=\"ramo.ramo_name for ramo in vm.ramos track by ramo.url\" ng-change=\"vm.changeRamo(vm.form.ramo)\"><option value=\"\">Todos los ramos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramo</label><select class=\"form-control\" name=\"subramo\" ng-model=\"vm.form.subramo\" ng-options=\"subramo.subramo_name for subramo in vm.subramos track by subramo.url\" ng-change=\"vm.changeSubRamo(vm.form.subramo)\"><option value=\"\">Todos los subramos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Clave de agente</label> <input class=\"form-control\" type=\"text\" name=\"agente\" ng-model=\"vm.form.cve_agente\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Consulta por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport(vm.form.dates_sel)\"><option value=\"\">Selecciona una opción</option></select></div><div ng-if=\"dates_selected\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.options.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Pólizas</legend><div class=\"col-sm-offset-3 col-xs-12 col-sm-3 checkbox\" align=\"center\" style=\"margin-top: 0;\"><label><input type=\"checkbox\" ng-model=\"vm.form.polizas_iniciales\">Nuevas</label></div><div class=\"col-xs-12 col-sm-3 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.polizas_renovadas\" ng-change=\"calculate(order.poliza)\">Renovadas</label></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Recibos</legend><div class=\"col-xs-12 col-sm-6 col-md-3 checkbox\" align=\"center\" style=\"margin-top: 0;\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_pagados\" ng-change=\"vm.enableConciliacion(1,vm.form.recibos_pagados)\">Pagados</label></div><div class=\"col-xs-12 col-sm-6 col-md-3 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_no_pagados\" ng-change=\"vm.enableConciliacion(3,vm.form.recibos_no_pagados)\">No pagados</label></div><div class=\"col-xs-12 col-sm-6 col-md-3 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_liquidados\" ng-change=\"vm.enableConciliacion(4,vm.form.recibos_liquidados)\">Liquidados</label></div><div class=\"col-xs-12 col-sm-6 col-md-3 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_conciliados\" ng-change=\"vm.enableConciliacion(2,vm.form.recibos_conciliados)\">Conciliados</label></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.process_comission(1,1)\">Procesar</button></div></div><div class=\"row\"><div ng-if=\"conciliar_masivos\"><hr><div class=\"col-xs-12\"><label>Archivo Excel</label> <input type=\"file\" fileread=\"\" ng-model=\"excelFile\" name=\"readCsvFile\" id=\"readCsvFile\" ng-change=\"selectExcel(excelFile)\"></div><div class=\"col-xs-12 btn-mt\"><div><label>Contenido del Archivo</label></div><div id=\"tree\" class=\"treeview btn-mt\"></div></div><div class=\"col-xs-12 col-md-4\"><label ng-if=\"suma2\">Total comisión del sistema:</label> <input class=\"form-control\" format-as-currency=\"\" ng-model=\"suma2\" ng-if=\"suma2\" readonly=\"\"><br></div><div class=\"col-xs-12 col-md-4\"><label ng-if=\"suma\">Total comisión capturada:</label> <input class=\"form-control\" ng-if=\"suma\" format-as-currency=\"\" ng-model=\"suma\" readonly=\"\"><br></div><div class=\"col-xs-12 col-md-4\" ng-if=\"suma || suma2\"><label for=\"group\">Cuenta:<span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"ramo\" ng-model=\"vm.cuenta\" data-ng-options=\"cuenta as (cuenta.name + \' - \' + cuenta.bank +\' - \' + cuenta.account) for cuenta in acounts_data track by cuenta.url\" ng-change=\"vm.change_account(vm.cuenta)\" required=\"\"><option value=\"\" disabled=\"\">Seleccione una cuenta</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"add_account()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12\"><button class=\"btn btn-success btn-mt pull-right\" ng-if=\"toConciliate.length > 0\" ng-click=\"finishMassiveConciliate()\">Finalizar conciliación masiva</button></div><div class=\"text-center\" ng-if=\"!vm.form.recibos_listos.length && vm.form.receipt_pagination\"><h4>No se han encontrado resultados</h4></div></div></div></div></div></div></div><div class=\"row animated\" id=\"myTable\"><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"show_providers\"><legend class=\"legend-title\" align=\"center\">Aseguradoras</legend><div class=\"col-xs-12\"><ul class=\"list-group\"><div ng-repeat=\"aseguradora in vm.aseguradoras | orderBy: \'compania\'\"><li class=\"list-group-item\" ng-init=\"aseguradora[$index] = false\"><legend class=\"legend-title\" ng-click=\"aseguradora[$index] ? aseguradora[$index] = false : aseguradora[$index] = true; selectProvider(aseguradora, $index,1,1)\">{{ aseguradora.compania }}</legend><div class=\"row\" ng-if=\"aseguradora[$index]\"><div class=\"col-xs-12\"><div class=\"ibox-content animate z-index-9000\" ng-if=\"vm.show_receipt_info\"><div><ng-include src=\"\'app/comisiones/receipt_view_info.html\'\"></ng-include></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 pull-right\" ng-if=\"aseguradora.recibos_conciliados\"><label>Total de comisiones conciliadas:</label> <input class=\"form-control\" format-as-currency=\"\" ng-model=\"aseguradora.total_conciliado\" readonly=\"\"></div><div class=\"col-xs-12\" ng-if=\"!aseguradora.recibos_conciliados\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 pull-right\" ng-if=\"aseguradora.recibos_listos.length > 0\"><label>Total de comisiones:</label> <input class=\"form-control\" format-as-currency=\"\" ng-model=\"aseguradora.total\" readonly=\"\"></div></div><legend class=\"legend-title\" align=\"center\">Recibos</legend><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover hidden-xs hidden-sm\" id=\"cobranza\" ng-if=\"aseguradora[$index]\"><thead><tr><th ng-model=\"vm.table.headers[0]\"></th><th ng-click=\"vm.changeRecibos(1, vm.contratante_asc == 1 ? 2 : 1)\" style=\"word-wrap: break-word;\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.contratante_asc == 1, \'fa fa-sort-asc\': vm.contratante_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(2, vm.poliza_asc == 1 ? 2 : 1)\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.poliza_asc == 1, \'fa fa-sort-asc\': vm.poliza_asc == 2}\"></span></th><th>Endoso</th><th ng-click=\"vm.changeRecibos(3, vm.serie_asc == 1 ? 2 : 1)\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.serie_asc == 1, \'fa fa-sort-asc\': vm.serie_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(13, vm.clave_asc == 1 ? 2 : 1)\">{{vm.table.headers[13]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.clave_asc == 1, \'fa fa-sort-asc\': vm.clave_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(8, vm.prima_neta_asc == 1 ? 2 : 1)\">{{vm.table.headers[8]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.prima_neta_asc == 1, \'fa fa-sort-asc\': vm.prima_neta_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(14, vm.prima_total_asc == 1 ? 2 : 1)\">Prima Total <span ng-class=\"{\'fa fa-sort-desc\': vm.prima_total_asc == 1, \'fa fa-sort-asc\': vm.prima_total_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(9, vm.comision_asc == 1 ? 2 : 1)\">{{vm.table.headers[9]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.comision_asc == 1, \'fa fa-sort-asc\': vm.comision_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(12, vm.comision_conc_asc == 1 ? 2 : 1)\">{{vm.table.headers[12]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.comision_conc_asc == 1, \'fa fa-sort-asc\': vm.comision_conc_asc == 2}\"></span></th><th style=\"width:95px !important;\"><strong>Tipo Cambio</strong></th><th><strong>% Comisión Estimada</strong></th><th><strong>% Comisión Conciliada</strong></th><th ng-click=\"vm.changeRecibos(10, vm.moneda_asc == 1 ? 2 : 1)\">{{vm.table.headers[10]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.moneda_asc == 1, \'fa fa-sort-asc\': vm.moneda_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(5, vm.vigencia_asc == 1 ? 2 : 1)\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.vigencia_asc == 1, \'fa fa-sort-asc\': vm.vigencia_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(6, vm.fecha_liq_asc == 1 ? 2 : 1)\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.fecha_liq_asc == 1, \'fa fa-sort-asc\': vm.fecha_liq_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(7, vm.fecha_pago_asc == 1 ? 2 : 1)\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.fecha_pago_asc == 1, \'fa fa-sort-asc\': vm.fecha_pago_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(4, vm.tipo_asc == 1 ? 2 : 1)\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.tipo_asc == 1, \'fa fa-sort-asc\': vm.tipo_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(15, vm.provider_asc == 1 ? 2 : 1)\">Compañia <span ng-class=\"{\'fa fa-sort-desc\': vm.provider_asc == 1, \'fa fa-sort-asc\': vm.provider_asc == 2}\"></span></th><th ng-click=\"vm.changeRecibos(11, vm.estatus_asc == 1 ? 2 : 1)\">{{vm.table.headers[11]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.estatus_asc == 1, \'fa fa-sort-asc\': vm.estatus_asc == 2}\"></span></th></tr></thead><tbody><tr ng-repeat=\"receipt in aseguradora.recibos_listos track by $index\" ng-click=\"vm.editRecibo(receipt); vm.show_receipt_info = true\"><td ng-click=\"$event.stopPropagation()\"><button class=\"btn btn-primary btn-sm\" ng-if=\"receipt.status == \'Pagado\' && vm.acceso_liq_rec\" type=\"button\" ng-click=\"vm.addToClose(receipt,aseguradora)\"><i class=\"glyphicon glyphicon-plus\"></i></button> <input type=\"checkbox\" ng-if=\"receipt.status == \'Liquidado\' && vm.acceso_conc_rec\" ng-click=\"addReceipt(receipt); toConciliation = true\"> <button class=\"btn btn-info btn-sm\" ng-if=\"receipt.status == \'Conciliado\' && vm.acceso_conc_rec\" ng-click=\"vm.editRecibo(receipt)\"><i class=\"glyphicon glyphicon-check\"></i></button> <input type=\"checkbox\" ng-if=\"receipt.status == \'Pendiente de pago\' && vm.acceso_conc_rec\" ng-click=\"addReceipt(receipt); toConciliation = true\"></td><td style=\"word-wrap: break-word;word-break: break-all;\"><div ng-if=\"receipt.receipt_type != 4\">{{ receipt.poliza.contractor }}</div><span ng-if=\"receipt.receipt_type == 4\">No Aplica</span></td><td><span ng-if=\"receipt.receipt_type !=4\">{{ receipt.poliza.poliza_number }} {{ receipt.fianza.fianza_number }}<span ng-if=\"receipt.poliza.document_type == 4\">{{ receipt.poliza.parent.poliza_number }}</span></span> <span ng-if=\"receipt.receipt_type == 4\">No Aplica</span></td><td><span ng-if=\"receipt.receipt_type == 2 || receipt.receipt_type == 3\">{{ receipt.endorsement.number_endorsement }}</span><span ng-if=\"receipt.receipt_type != 2 && receipt.receipt_type != 3\">No Aplica</span></td><td>{{ receipt.recibo_numero }}</td><td>{{ receipt.poliza.clave.clave }} {{ receipt.fianza.clave.clave }}{{ receipt.bono.clave.clave }}<span ng-if=\"receipt.poliza.document_type == 4\">{{ receipt.poliza.parent.clave.clave }}</span></td><td>{{ receipt.prima_neta | currency}}</td><td>{{ receipt.prima_total | currency}}</td><td>{{ receipt.comision | currency}}</td><td ng-if=\"receipt.status != \'Liquidado\' && receipt.status != \'Pendiente de pago\'\">{{ receipt.comision_conciliada | currency }}</td><td ng-if=\"receipt.status != \'Liquidado\' && receipt.status != \'Pendiente de pago\'\">{{ receipt.rate_exchange}}</td><td ng-if=\"receipt.status != \'Liquidado\' && receipt.status != \'Pendiente de pago\'\">{{ receipt.comision_conciliada_p_estimada}}</td><td ng-if=\"receipt.status != \'Liquidado\' && receipt.status != \'Pendiente de pago\'\">{{ receipt.comision_conciliada_p}}</td><td ng-if=\"receipt.status == \'Liquidado\' || receipt.status == \'Pendiente de pago\'\" ng-click=\"$event.stopPropagation()\"><input class=\"form-control\" type=\"text\" ng-model=\"receipt.comision_conciliada\" ng-change=\"validateComisionTable(aseguradora, receipt.comision_conciliada, $index);validateComisionTableEstimada(aseguradora, receipt.comision_conciliada, $index,2)\"></td><td style=\"width:95px !important;\" ng-if=\"receipt.status == \'Liquidado\' || receipt.status == \'Pendiente de pago\'\" ng-click=\"$event.stopPropagation()\"><input style=\"width:95px !important\" class=\"form-control\" type=\"text\" ng-model=\"receipt.rate_exchange\" ng-change=\"validateComisionTableEstimada(aseguradora, receipt.rate_exchange, $index,3)\" ng-disabled=\"receipt.poliza.f_currency==1\" min=\"1\"></td><td ng-if=\"receipt.status == \'Liquidado\' || receipt.status == \'Pendiente de pago\'\" ng-click=\"$event.stopPropagation()\"><input class=\"form-control\" type=\"text\" ng-model=\"receipt.comision_conciliada_p_estimada\" disabled=\"\"></td><td ng-if=\"receipt.status == \'Liquidado\' || receipt.status == \'Pendiente de pago\'\" ng-click=\"$event.stopPropagation()\"><input class=\"form-control\" type=\"text\" ng-model=\"receipt.comision_conciliada_p\" disabled=\"\" ng-class=\"{\'red\': receipt.comision_conciliada_p === \'⬆️\' || receipt.comision_conciliada_p === \'⬇️\',\'green\': receipt.comision_conciliada_p === \'✔\'}\"></td><td><span ng-if=\"receipt.poliza.f_currency == 1 || receipt.fianza.f_currency == 1\">Pesos</span> <span ng-if=\"receipt.poliza.f_currency == 2 || receipt.fianza.f_currency == 2\">Dólares</span> <span ng-if=\"receipt.bono\">{{receipt.bono.tipo_cambio}}</span> <span ng-if=\"receipt.poliza.f_currency == 3 || receipt.fianza.f_currency == 3\">Udi</span></td><td>{{ receipt.fecha_inicio | date:\"dd/MM/yyyy\": \'UTC\'}} - {{ receipt.fecha_fin | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td ng-if=\"receipt.liquidacion_date\">{{ receipt.liquidacion_date | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td ng-if=\"!receipt.liquidacion_date\">Sin fecha de liquidación</td><td ng-if=\"receipt.pay_date\">{{ receipt.pay_date | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td ng-if=\"!receipt.pay_date\">Sin fecha de pago</td><td><span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==1\">Póliza</span> <span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==3\">Colectividad</span> <span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==4\">Subgrupo</span> <span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==7\">Fianza</span> <span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==8\">Fianza Colectiva</span> <span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type ==12\">Póliza de Carátula</span> <span ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</span> <span ng-if=\"receipt.receipt_type == 4\">Recibo Bono</span> <span ng-if=\"receipt.receipt_type == 2\">Endoso</span></td><td><span ng-if=\"receipt.poliza.parent.aseguradora.alias\">{{ receipt.poliza.parent.aseguradora.alias }}</span> <span ng-if=\"!receipt.poliza.parent.aseguradora.alias && receipt.poliza.aseguradora\">{{ receipt.poliza.aseguradora }}</span>{{ receipt.fianza.afianzadora.alias }} {{ receipt.bono.aseguradora }}</td><td>{{ receipt.status }}</td></tr></tbody></table></div></div><div class=\"col-xs-12\" ng-if=\"vm.form.recibos_pagados == 1 && liquidarTodos && toClose.length == 0 && vm.acceso_liq_rec\"><button class=\"btn btn-success pull-right\" ng-click=\"liquidarTodosF(aseguradora.recibos_listos,aseguradora)\">Liquidar Todos los Recibos</button></div><div class=\"col-xs-12\" ng-if=\"arrayConciliation.length == 0 && vm.form.recibos_liquidados && conciliateTodos && vm.acceso_conc_rec\"><button class=\"btn btn-success pull-right\" ng-click=\"showDataAccountTodos(aseguradora)\">Conciliar Todos los Recibos</button></div><div class=\"col-xs-12\" ng-if=\"arrayConciliation.length > 0 && vm.acceso_conc_rec\"><button class=\"btn btn-success pull-right\" ng-click=\"showDataAccount()\">Conciliar Recibos</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group pull-right\" ng-if=\"showAccount\"><label for=\"group\">Cuenta:<span class=\"color-red\">*</span></label><div class=\"input-group\"><div><select class=\"form-control m-b\" name=\"ramo\" ng-model=\"vm.cuenta\" ng-options=\"cuenta as (cuenta.name + \' - \' + cuenta.bank +\' - \' + cuenta.account) for cuenta in acounts_data track by cuenta.url\" ng-change=\"vm.change_account(vm.cuenta)\" required=\"\"><option value=\"\" disabled=\"\">Seleccione una cuenta</option></select></div><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"add_account()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group pull-right\" ng-if=\"showAccount\"><label>Fecha de aplicación:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"aplication_date\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.conciliate_date\" value=\"{{vm.form.conciliate_date}}\" ng-change=\"vm.options.change_conciliate_date()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 m-t\" ng-if=\"showAccount && arrayConciliation.length > 0 && vm.acceso_conc_rec\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"vm.acceso_conc_rec\"><button class=\"col-xs-12 btn btn-success\" type=\"button\" ng-click=\"massiceConciliation()\">(Conciliar)</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" type=\"button\" ng-click=\"hideDAtaAccount()\">Cancelar</button></div></div><div class=\"col-xs-12 m-t\" ng-if=\"showAccount && conciliateTodos && arrayConciliation.length == 0\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"vm.acceso_conc_rec\"><button class=\"col-xs-12 btn btn-success\" type=\"button\" ng-click=\"massiceConciliationTodos(aseguradora.recibos_listos)\">Conciliar Todos</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" type=\"button\" ng-click=\"hideDAtaAccount()\">Cancelar</button></div></div><div class=\"col-xs-12 btn-mt\" ng-if=\"vm.form.recibos_pagados && toClose.length > 0 && vm.acceso_liq_rec\"><legend class=\"legend-title\" align=\"center\">Recibos a liquidar</legend><table class=\"table table-bordered table-hover hidden-xs hidden-sm\" id=\"close\"><thead><tr><th></th><th ng-model=\"vm.table.headers[1]\">{{ vm.table.headers[1] }}</th><th ng-model=\"vm.table.headers[2]\">{{ vm.table.headers[2] }}</th><th>Número de Endoso</th><th ng-model=\"vm.table.headers[3]\">{{ vm.table.headers[3] }}</th><th ng-model=\"vm.table.headers[4]\">{{ vm.table.headers[4] }}</th><th ng-model=\"vm.table.headers[5]\">{{ vm.table.headers[5] }}</th><th ng-model=\"vm.table.headers[6]\">{{ vm.table.headers[6] }}</th><th ng-model=\"vm.table.headers[7]\">{{ vm.table.headers[7] }}</th><th ng-model=\"vm.table.headers[8]\">{{ vm.table.headers[8] }}</th><th ng-model=\"vm.table.headers[9]\">{{ vm.table.headers[9] }}</th><th ng-model=\"vm.table.headers[10]\">{{ vm.table.headers[10] }}</th><th ng-model=\"vm.table.headers[11]\"><span>{{ vm.table.headers[11] }}</span></th></tr></thead><tbody><tr ng-repeat=\"receipt in toClose track by $index\"><td><button class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"vm.DeleteToClose(receipt)\"><i class=\"glyphicon glyphicon-minus\"></i></button></td><td ng-click=\"vm.editRecibo(receipt)\" style=\"word-wrap: break-word;word-break: break-all;\">{{ receipt.poliza.contractor }}</td><td>{{ receipt.poliza.poliza_number }} {{ receipt.fianza.fianza_number }}<span ng-if=\"receipt.poliza.document_type == 4\">{{ receipt.poliza.parent.poliza_number }}</span></td><td>{{ receipt.recibo_numero }}</td><td><span ng-if=\"receipt.receipt_type == 2 || receipt.receipt_type == 3\">{{ receipt.endorsement.number_endorsement }}</span><span ng-if=\"receipt.receipt_type != 2 || receipt.receipt_type != 3\">No aplica</span></td><td ng-if=\"receipt.receipt_type == 2\">Endoso</td><td ng-if=\"receipt.receipt_type == 1\">Póliza</td><td ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</td><td ng-if=\"receipt.receipt_type == 4\">Recibo Bono</td><td>{{ receipt.fecha_inicio | date:\"dd/MM/yyyy\": \'UTC\'}} - {{ receipt.fecha_fin | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td ng-if=\"receipt.liquidacion_date\">{{ receipt.liquidacion_date | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td ng-if=\"!receipt.liquidacion_date\">Sin fecha de liquidación</td><td ng-if=\"receipt.pay_date\">{{ receipt.pay_date | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td ng-if=\"!receipt.pay_date\">Sin fecha de pago</td><td>{{ receipt.prima_neta | currency}}</td><td>{{ receipt.comision | currency}}</td><td><span ng-if=\"receipt.poliza || receipt.fianza\">{{ receipt.poliza.f_currency | curr_rate_options }} {{ receipt.fianza .f_currency | curr_rate_options }}</span><span ng-if=\"receipt.bono\">{{receipt.bono.tipo_cambio}}</span></td><td><span>{{ receipt.status }}</span></td></tr></tbody></table><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"receipt in toClose track by $index\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[11] }}:<p><input value=\"-\" type=\"button\" ng-click=\"vm.DeleteToClose(receipt)\"></p></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[11] }}</label><p><button class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"vm.DeleteToClose(receipt)\"><i class=\"glyphicon glyphicon-minus\"></i></button></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[1] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.poliza.contractor }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[2] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[3] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.recibo_numero }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[4] }}</label><p ng-if=\"receipt.receipt_type == 2\" ng-click=\"vm.editRecibo(receipt)\">Endoso</p><p ng-if=\"receipt.receipt_type == 1\" ng-click=\"vm.editRecibo(receipt)\">Póliza</p><p ng-if=\"receipt.receipt_type != 1 && receipt.receipt_type != 2\"></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-status\"><label>{{ vm.table.headers[5] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.fecha_inicio | date:\"dd/MM/yyyy\": \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.fecha_fin | date:\"dd/MM/yyyy\": \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.prima_total | currency}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.comision | currency}}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project actions\"><label>{{ vm.table.headers[9] }}</label><p ng-if=\"!vm.form.recibos_conciliados\" ng-click=\"vm.editRecibo(receipt)\">{{ receipt.status }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\" ng-if=\"vm.form.recibos_conciliados\"><label>{{ vm.table.headers[10] }}</label><p ng-if=\"vm.form.recibos_conciliados == false\" ng-click=\"vm.editRecibo(receipt)\">{{ receipt.comision_conciliada | currency }}</p></div></tr></table></div></div><div class=\"col-xs-12\" ng-if=\"vm.acceso_liq_rec\"><button class=\"btn btn-success pull-right\" ng-click=\"CloseMassives()\">Liquidar Recibos</button></div></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"receipt in vm.form.recibos_listos track by $index\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}:<p ng-if=\"vm.form.recibos_no_pagados || vm.form.recibos_pagados\"><input ng-if=\"receipt.status == \'Pagado\'\" type=\"button\" value=\"+\" ng-click=\"vm.addToClose(receipt)\"></p></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p ng-if=\"vm.form.recibos_no_pagados || vm.form.recibos_pagados\"><button class=\"btn btn-primary btn-sm\" ng-if=\"receipt.status == \'Pagado\'\" type=\"button\" ng-click=\"vm.addToClose(receipt)\"><i class=\"glyphicon glyphicon-plus\"></i></button></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[1] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.poliza.contractor}}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[2] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[3] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.recibo_numero }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[4] }}</label><p ng-if=\"receipt.receipt_type == 2\" ng-click=\"vm.editRecibo(receipt)\">Endoso</p><p ng-if=\"receipt.receipt_type == 1\" ng-click=\"vm.editRecibo(receipt)\">Póliza</p><p ng-if=\"receipt.receipt_type != 1 && receipt.receipt_type != 2\"></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-status\"><label>{{ vm.table.headers[5] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.fecha_inicio | date:\"dd/MM/yyyy\": \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.fecha_fin | date:\"dd/MM/yyyy\": \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.prima_total | currency}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.comision | currency}}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project actions\"><label>{{ vm.table.headers[9] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.status }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\" ng-if=\"vm.form.recibos_conciliados\"><label>{{ vm.table.headers[10] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.comision_conciliada | currency}}</p></div></tr></table></div></div><div class=\"col-xs-12\" ng-if=\"vm.buttonReport == true && vm.acceso_rep_cob\"><button ng-model=\"vm.buttonReport\" class=\"btn btn-primary btn-ef btn-ef-3 btn-ef-3c mb-10\" ng-click=\"exportData(1,aseguradora,1,1)\">Generar Reporte <i class=\"fa fa-download\"></i></button></div></div></li></div></ul></div></div></div></div>");
$templateCache.put("app/comisiones/conciliarid.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Conciliar</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Conciliar</a></li><li class=\"active\"><strong>Conciliar Masivo por ID</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Conciliar Masivamente (MEDIANTE ID)</legend></div><div class=\"col-xs-12 row\"><div class=\"col-xs-12 form-group\"><label>Conciliar carga masiva:</label><br><label style=\"margin-left: 5px\" class=\"col-xs-4 btn btn-success\">Cargar Layout Conciliar <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcelIdConciliar(excelFile)\" onclick=\"limpiar()\" onchange=\"angular.element(this).scope().fileNameChanged(this)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loadingConciliacionId\"><i class=\"fa fa-cog fa-spin fa-5x\"></i></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.carga_masiva_conciliacion_id && !loadingConciliacionId\"><div class=\"col-xs-12 col-md-6 col-sm-6\"><label for=\"group\">Fecha de Conciliación:<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"fecha_conciliacion\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.fecha_conciliacion\" value=\"{{vm.fecha_conciliacion}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"col-xs-12 col-md-6 col-sm-6\"><label for=\"group\">Cuenta:<span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"ramo\" ng-model=\"vm.cuenta\" data-ng-options=\"cuenta as (cuenta.name + \' - \' + cuenta.bank +\' - \' + cuenta.account) for cuenta in acounts_data track by cuenta.url\" ng-change=\"vm.change_account(vm.cuenta)\" required=\"\"><option value=\"\" disabled=\"\">Seleccione una cuenta</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"add_account()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div></div><br><div class=\"col-xs-12 col-sm-6 form-group pull-right\" ng-if=\"vm.carga_masiva_conciliacion_id && !loadingConciliacionId\"><div class=\"col-xs-12 input-group\"><div class=\"input-group-btn\"><button ng-disabled=\"!vm.fecha_conciliacion && !vm.cuenta\" type=\"button\" class=\"btn btn-block btn-info\" ng-click=\"validarLayoutCargaMasivaId()\">Validar layout</button></div><div class=\"input-group-btn\"><button ng-disabled=\"!vm.fecha_conciliacion && !vm.cuenta\" type=\"button\" class=\"btn btn-block btn-success\" ng-click=\"cargarLayoutCargaMasivaId()\">Aplicar layout</button></div></div></div></div></div></div></div></div><script type=\"text/javascript\">\n  $(window).load(function() { \n    $(\"#state\").select2(); \n  });\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/comisiones/liquidate_massive.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Liquidación Masiva</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 btn-mt\" ng-if=\"recibos\"><legend class=\"legend-title\" align=\"center\">Recibos a liquidar</legend><table class=\"table table-bordered table-hover hidden-xs hidden-sm\" id=\"close\"><thead><tr><th ng-model=\"vm.table.headers[1]\">Contratante</th><th ng-model=\"vm.table.headers[2]\">#Póliza</th><th ng-model=\"vm.table.headers[3]\">#Recibo</th><th ng-model=\"vm.table.headers[3]\">#Endoso</th><th ng-model=\"vm.table.headers[4]\">Tipo</th><th ng-model=\"vm.table.headers[5]\">Vigencia</th><th ng-model=\"vm.table.headers[6]\">Fecha liquidación</th><th ng-model=\"vm.table.headers[7]\">Fecha pago</th><th ng-model=\"vm.table.headers[8]\">Prima Neta</th><th ng-model=\"vm.table.headers[9]\">Comisión</th><th ng-model=\"vm.table.headers[10]\">Moneda</th></tr></thead><tbody><tr ng-repeat=\"receipt in recibos track by $index\"><td>{{ receipt.poliza.contractor}}</td><td>{{ receipt.poliza.poliza_number }} {{ receipt.fianza.fianza_number }}<span ng-if=\"receipt.poliza.document_type == 4\">{{ receipt.poliza.parent.poliza_number }}</span></td><td>{{ receipt.recibo_numero }}</td><td><span ng-if=\"receipt.receipt_type == 2 || receipt.receipt_type == 3\">{{ receipt.endorsement.number_endorsement }}</span><span ng-if=\"receipt.receipt_type != 2 || receipt.receipt_type != 3\">No aplica</span></td><td ng-if=\"receipt.receipt_type == 2\">Endoso</td><td ng-if=\"receipt.receipt_type == 1\">Póliza</td><td ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</td><td ng-if=\"receipt.receipt_type == 4\">Recibo Bono</td><td>{{ receipt.fecha_inicio | date:\"dd/MM/yyyy\": \'UTC\'}} - {{ receipt.fecha_fin | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td ng-if=\"receipt.liquidacion_date\">{{ receipt.liquidacion_date | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td ng-if=\"!receipt.liquidacion_date\">Sin fecha de liquidación</td><td ng-if=\"receipt.pay_date\">{{ receipt.pay_date | date:\"dd/MM/yyyy\": \'UTC\'}}</td><td ng-if=\"!receipt.pay_date\">Sin fecha de pago</td><td>{{ receipt.prima_neta | currency}}</td><td>{{ receipt.comision | currency}}</td><td><span ng-if=\"receipt.poliza || receipt.fianza\">{{ receipt.poliza.f_currency | curr_rate_options }} {{ receipt.fianza .f_currency | curr_rate_options }}</span><span ng-if=\"receipt.bono\">{{receipt.bono.tipo_cambio}}</span></td></tr></tbody></table><br><div class=\"col-xs-12 col-sm-6 form-group\"><label>Fecha de liquidación:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"aplication_date\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.liquidation_date\" value=\"{{vm.form.liquidation_date}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"receipt in toClose track by $index\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[11] }}:<p><input value=\"-\" type=\"button\" ng-click=\"vm.DeleteToClose(receipt)\"></p></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[11] }}</label><p><button class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"vm.DeleteToClose(receipt)\"><i class=\"glyphicon glyphicon-minus\"></i></button></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[1] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.poliza.contractor }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[2] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[3] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.recibo_numero }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project-title\"><label>{{ vm.table.headers[4] }}</label><p ng-if=\"receipt.receipt_type == 2\" ng-click=\"vm.editRecibo(receipt)\">Endoso</p><p ng-if=\"receipt.receipt_type == 1\" ng-click=\"vm.editRecibo(receipt)\">Póliza</p><p ng-if=\"receipt.receipt_type != 1 && receipt.receipt_type != 2\"></p></div><div class=\"table-cell col-xs-12 col-sm-6 project-status\"><label>{{ vm.table.headers[5] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.fecha_inicio | date:\"dd/MM/yyyy\": \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.fecha_fin | date:\"dd/MM/yyyy\": \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.prima_total | currency}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p ng-click=\"vm.editRecibo(receipt)\">{{ receipt.comision | currency}}</p></div><div class=\"table-cell col-xs-12 col-sm-6 project actions\"><label>{{ vm.table.headers[9] }}</label><p ng-if=\"!vm.form.recibos_conciliados\" ng-click=\"vm.editRecibo(receipt)\">{{ receipt.status }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\" ng-if=\"vm.form.recibos_conciliados\"><label>{{ vm.table.headers[10] }}</label><p ng-if=\"vm.form.recibos_conciliados == false\" ng-click=\"vm.editRecibo(receipt)\">{{ receipt.comision_conciliada | currency }}</p></div></tr></table></div></div></div></div><div class=\"col-xs-12\"><div upload-template=\"\"></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"vmFiles.rename(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,files)\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</button> <span class=\"btn btn-success display-none\">Guardar</span></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"liquidarTodo(receipt)\">Guardar</button></div><script>\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    strongTag.hide();\n    inputTag.show();\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target);\n\n    strongTag.show();\n    inputTag.hide();\n  }\n</script>");
$templateCache.put("app/comisiones/receipt_view_info.html","<div class=\"row animate\"><div class=\"col-xs-12\"><div class=\"inmodal\" id=\"myModal\" data-dismiss=\"modal\"><div class=\"form-group\"><button type=\"button\" class=\"btn btn-info\" ng-show=\"vm.show_receipt_info\" ng-click=\"vm.returnToList(); vm.show_receipt_info = false; vm.conciliar = false;\">Regresar</button></div><div class=\"tabs-container\" ng-init=\"recibos = true; poliza = false\"><uib-tabset ng-if=\"!show_binnacle\"><uib-tab heading=\"Recibo\" id=\"recibo\" ng-click=\"accountStatements(1)\"><div class=\"panel-body\"><table class=\"table table-bordered table-hover\" datatable=\"ng\"><thead><tr><th>Tipo de Recibo</th><th>Periodo</th><th>Estatus</th><th>Prima Neta</th><th>Comisión</th><th ng-if=\"vm.recibos_actual[0].status == \'Conciliado\'\">Comisión Conciliada</th></tr></thead><tbody><tr ng-repeat=\"receipt in vm.recibos_actual track by $index\"><td><span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type == 1\">Póliza</span> <span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type == 3\">Colectividad</span> <span ng-if=\"receipt.receipt_type == 1 && receipt.poliza.document_type == 4\">Subgrupo</span> <span ng-if=\"receipt.receipt_type == 2\">Endoso</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</span></td><td class=\"project-status\">{{receipt.status}}</td><td>{{ receipt.prima_neta | currency }}</td><td>{{ receipt.comision | currency }}</td><td ng-if=\"vm.recibos_actual[0].status == \'Conciliado\' && !ajustar_conciliacion\">{{ receipt.comision_conciliada | currency }}</td><td ng-if=\"vm.recibos_actual[0].status == \'Conciliado\' && ajustar_conciliacion\"><input id=\"ajustar_conciliacion_input\" class=\"form-control\" type=\"number\" ng-model=\"receipt.comision_conciliada\"></td></tr></tbody></table></div></uib-tab><uib-tab heading=\"Información de la Póliza\" id=\"informacion\" ng-click=\"accountStatements(2)\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ vm.contratante.full_name }}</span></div></div><div class=\"form-group\"><span class=\"blue-color\">Dirección:</span><div><span>{{ vm.addressContratante.route }} {{ vm.addressContratante.street_number }}, {{ vm.addressContratante.sublocality }}.</span><div><span>{{ vm.addressContratante.administrative_area_level_1}}, {{vm.addressContratante.administrative_area_level_2}}.</span></div></div></div><div class=\"form-group\"><span class=\"blue-color\">Telefono:</span><div><span>{{ vm.contratante.phone_number }}</span></div></div><div class=\"form-group\"><span class=\"blue-color\">Correo:</span><div><span>{{ vm.contratante.email }}</span></div></div><div class=\"form-group\"><span class=\"blue-color\">Observaciones</span><div><span>{{ vm.contratante.description }}</span></div></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><legend class=\"legend-title\" align=\"center\">Generales</legend><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Número de póliza:</span><div><span>{{ vm.myPolicy.poliza_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Aseguradora - Cve Agente:</span><div><span>{{ vm.myPolicy.aseguradora.alias }} - {{vm.myPolicy.clave.clave}} <span></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ vm.myPolicy.ramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Subramos:</span><div><span>{{ vm.myPolicy.subramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Paquetes:</span><div><span>{{ vm.myPolicy.paquete }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Vigencia</span><div><span>{{ vm.myPolicy.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}} - {{ vm.myPolicy.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{ vm.forma_pago(vm.myPolicy.forma_de_pago) }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Estatus:</span><div><span>{{vm.status(vm.myPolicy.status)}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"vm.myPolicy.f_currency == 1\">PESOS</span> <span ng-if=\"vm.myPolicy.f_currency == 2\">DOLARES</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.myPolicy.observations\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ vm.myPolicy.observations }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\"><strong>Creado por:</strong></span><div><span>{{ vm.myPolicy.owner }}</span></div></div></div></div></uib-tab></uib-tabset></div><div class=\"row btn-mt\" ng-if=\"boton_liquidado\"><hr><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Comisión a conciliar:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"vm.form.comision_conciliada\" ng-change=\"validateComision(vm.form.comision_conciliada)\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Fecha de aplicación:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"aplication_date\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.conciliate_date\" value=\"{{vm.form.conciliate_date}}\" ng-change=\"vm.options.change_conciliate_date()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\"><label for=\"group\">Cuenta:<span class=\"color-red\">*</span></label><div class=\"input-group\"><div ng-class=\"{ \'has-error\': form.ramo.$invalid && !form.ramo.$pristine }\"><select class=\"form-control m-b\" name=\"ramo\" ng-model=\"vm.cuenta\" ng-options=\"cuenta as (cuenta.name + \' - \' + cuenta.bank +\' - \' + cuenta.account) for cuenta in acounts_data track by cuenta.url\" ng-change=\"vm.change_account(vm.cuenta)\" required=\"\"><option value=\"\" disabled=\"\">Seleccione una cuenta</option></select></div><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"add_account()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><button class=\"btn btn-success pull-right\" type=\"button\" ng-if=\"vm.recibos_actual[0].status == \'Conciliado\' && vm.user.permiso.editar && vm.acceso_conc_rec\" ng-click=\"AjustarConciliacion(vm.recibos_actual[0])\">Ajustar Conciliación</button> <button class=\"btn btn-success pull-right\" type=\"button\" ng-if=\"boton_liquidado && vm.user.permiso.editar && vm.acceso_conc_rec\" ng-click=\"vm.conciliarRecibo(vm.recibos_actual[0])\">Conciliar</button> <button class=\"btn btn-success pull-right\" type=\"button\" ng-if=\"boton_pagado && vm.user.permiso.editar && vm.acceso_liq_rec\" ng-click=\"vm.liquidarRecibo(vm.recibos_actual[0])\">Liquidar</button></div></div></div></div></div>");
$templateCache.put("app/compartirapp/compartir.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Compartir</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><a ui-sref=\"polizas.table\">Compartir a la App</a></li></ol></div></div><br><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><br><br><div class=\"row\"><div class=\"col-xs-12 col-lg-12\"><div class=\"col-xs-12 form-group btn-action\"><div class=\"row\"><label class=\"blue-color\">Vigencia Inicial</label></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since | date : \'medium\'}}\" ng-change=\"vm.options.changeSince(); vm.saveLocalstorage()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil(); vm.saveLocalstorage()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"col-xs-12 form-group btn-action\"><label><input type=\"checkbox\" ng-model=\"compartidas\" ng-checked=\"noCompartidas(true)\">Solo Pólizas sin compartir a la APP</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-12 form-group btn-action\" ng-if=\"vm.acceso_ver_ot || vm.acceso_ver_pol\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"vm.search(3, 1,1);\">Consultar</button></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.infoFlag\"><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando información...</span></div></div><div class=\"col-xs-12 col-md-3\" align=\"center\" ng-if=\"!loader\"><label class=\"blue-color checkbox\"><input type=\"checkbox\" ng-value=\"addEmail\" ng-model=\"addEmail\" ng-click=\"$event.stopPropagation();shareToPrincipal(contractors,addEmail,addEmail1,addEmail2,addFiles)\" id=\"addEmail\"> Compartir Pólizas al Correo principal</label></div><div class=\"col-xs-12 col-md-3\" align=\"center\" ng-if=\"!loader\"><label class=\"blue-color checkbox\"><input type=\"checkbox\" ng-value=\"addEmail1\" ng-model=\"addEmail1\" ng-click=\"$event.stopPropagation();shareToPrincipal(contractors,addEmail,addEmail1,addEmail2,addFiles)\" id=\"addEmail1\"> Compartir Pólizas al Correo 1</label></div><div class=\"col-xs-12 col-md-3\" align=\"center\" ng-if=\"!loader\"><label class=\"blue-color checkbox\"><input type=\"checkbox\" ng-value=\"addEmail2\" ng-model=\"addEmail2\" ng-click=\"$event.stopPropagation();shareToPrincipal(contractors,addEmail,addEmail1,addEmail2,addFiles)\" id=\"addEmail2\"> Compartir Pólizas al Correo 2</label></div><div class=\"col-xs-12 col-md-3\" align=\"center\" ng-if=\"!loader\"><label class=\"blue-color checkbox\"><input type=\"checkbox\" ng-value=\"addEmail3\" ng-model=\"addFiles\" ng-click=\"$event.stopPropagation();shareToPrincipal(contractors,addEmail,addEmail1,addEmail2,addFiles)\" id=\"addFiles\"> Compartir Archivos</label></div><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Compartir a la App</h5></div><ul class=\"list-group\"><div ng-repeat=\"conShare in contractors track by conShare.id\"><li class=\"list-group-item\" ng-init=\"polizaAdd[$index] = false\"><legend class=\"legend-title\" ng-click=\"polizaAdd[$index] ? polizaAdd[$index] = false : polizaAdd[$index] = true;\">{{ conShare.full_name }}</legend><div class=\"row\" ng-if=\"polizaAdd[$index]\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\" ng-if=\"!show_detail\"><thead><tr><th>Póliza</th><th>Contratante</th><th>Aseguradora</th><th>Subramo</th><th>Vigencia</th><th>Correo Principal</th><th>Correo 1</th><th>Correo 2</th><th>Archivos</th></tr></thead><tbody><tr ng-repeat=\"polizatoshare in conShare.polizasshare\" ng-click=\"getInfoPolicy(polizatoshare)\"><td>{{polizatoshare.poliza_number}}</td><td>{{polizatoshare.contractor.full_name}}<br><small ng-if=\"polizatoshare.contractor.type_person ==1\">Persona Física</small> <small ng-if=\"!polizatoshare.contractor.type_person ==2\">Persona Moral</small></td><td>{{polizatoshare.aseguradora.alias}}</td><td>{{polizatoshare.subramo}}</td><td><span>{{ polizatoshare.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ polizatoshare.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></td><td ng-click=\"$event.stopPropagation()\"><label><input type=\"checkbox\" ng-model=\"polizatoshare[polizatoshare.id].principal\" ng-click=\"sharetoemail(polizatoshare,polizatoshare[polizatoshare.id],1)\"> {{polizatoshare.contractor.email}}</label></td><td ng-click=\"$event.stopPropagation()\"><label ng-if=\"polizatoshare.contractor.email_contractor[0]\"><input type=\"checkbox\" ng-model=\"polizatoshare[polizatoshare.id].correo1\" ng-click=\"sharetoemail(polizatoshare,polizatoshare[polizatoshare.id],2)\"> {{polizatoshare.contractor.email_contractor[0].correo}}</label></td><td ng-click=\"$event.stopPropagation()\"><label ng-if=\"polizatoshare.contractor.email_contractor[1]\"><input type=\"checkbox\" ng-model=\"polizatoshare[polizatoshare.id].correo2\" ng-click=\"sharetoemail(polizatoshare,polizatoshare[polizatoshare.id],3)\"> {{polizatoshare.contractor.email_contractor[1].correo}}</label></td><td ng-click=\"$event.stopPropagation()\"><label><input type=\"checkbox\" ng-model=\"polizatoshare[polizatoshare.id].files\" ng-click=\"sharetoemail(polizatoshare,polizatoshare[polizatoshare.id],4)\"> Compartir archivos</label></td></tr></tbody></table></div></div></li></div></ul><div class=\"row\"><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 form-group pull-right\"><button class=\"btn btn-primary ladda-button2 pull-right\" ng-click=\"compartir_app(contractors)\">Compartir a la App</button></div></div></div></div></div></div>");
$templateCache.put("app/conexion_agentes/conexion_agentes.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Conexión</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><a ui-sref=\"polizas.table\">Conexión Agentes</a></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-success col-xs-12\" ng-click=\"addConfigProviderOK()\">Agregar Configuración</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"vm.search()\">Ver Resultados</button></div><div ng-show=\"show_addconfig\" class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Nueva Configuración Aseguradora</legend><form class=\"row\" name=\"form\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador<span class=\"red-color\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.title\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Aseguradora<span class=\"red-color\">*</span></label><select class=\"form-control\" ng-options=\"aseguradora.alias for aseguradora in vm.defaults.providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"aseguradoraSelection()\" name=\"aseguradora\" ng-model=\"vm.form.provider\"><option value=\"\">Selecciona un proveedor</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-show=\"vm.form.provider\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-show=\"vm.form.provider\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"blue-color\">Credenciales de la Aseguradora</legend><div class=\"col-xs-12 col-sm-6 form-group\"><label>Usuario<span class=\"red-color\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.usuario\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contraseña<span class=\"red-color\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.password\" required=\"\"></div></div><br><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"SelectCurrency\">Periodicidad <span class=\"color-red\">*</span></label><select id=\"SelectCurrency\" class=\"form-control\" ng-options=\"periodo.value as periodo.label for periodo in periodo\" ng-model=\"vm.form.periodicidad\" ng-change=\"changeCurrency()\"></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha Inicial <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.startDate\" value=\"{{vm.form.startDate}}\" ng-disabled=\"!vm.form.periodicidad\" ng-change=\"checkDate()\" data-date-format=\"mm/dd/yyyy\" ng-init=\"vmm.checkDate(\'initial\')\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"blue-color\">Periodo de Vigencia Pólizas</legend><div class=\"col-xs-12 col-sm-4 form-group\"><label>Desde<span class=\"color-red\">*</span></label><br><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.startDate_scraper\" value=\"{{vm.form.startDate_scraper}}\" ng-change=\"checkDateValues(vm.form.startDate_scraper)\" data-date-format=\"mm/dd/yyyy\" ng-init=\"vm.checkDate(\'initial\')\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Hasta<span class=\"color-red\">*</span></label><br><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.endDate_scraper\" value=\"{{vm.form.endDate_scraper}}\" ng-change=\"checkDate()\" data-date-format=\"mm/dd/yyyy\" disabled=\"\" ng-init=\"vm.checkDate(\'initial\')\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><br><div class=\"col-xs-12 col-sm-6 form-group\"><label>Descripción<span class=\"red-color\">*</span></label> <textarea type=\"text\" class=\"form-control\" ng-model=\"vm.form.descrip\" required=\"\" ng-change=\"vm.saveLocalstorange()\"></textarea></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button ng-if=\"!vm.form.url\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"saveConfig(vm.form)\">Crear Configuración</button> <button ng-if=\"vm.form.url\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"saveConfig(vm.form)\">Actualizar Configuración</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"show_addconfig = false;listaConfigs=true\">Cancelar</button></div></form><div class=\"col-xs-12\"><hr></div></div></div><div class=\"row\" ng-show=\"listaConfigs\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Configuraciones por Aseguradora</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><table class=\"table table-hover table-bordered\"><thead><tr><th>Identificador</th><th>Aseguradora</th><th>Ramo(s)</th><th>Subramo(s)</th><th>Periodicidad</th><th>Credenciales</th><th>Fecha Inicial</th><th>Periodo de Pólizas</th><th>Descripción</th><th>Acción</th></tr></thead><tbody><tr ng-repeat=\"cnfg in configuraciones track by $index\"><td>{{ cnfg.title }}</td><td>{{ cnfg.provider.alias }}</td><td><div ng-if=\"cnfg.ramos.length >0\" class=\"col-xs-12\" ng-repeat=\"rm in cnfg.ramos_sel\"><span>{{rm.ramo_name}}</span></div><span ng-if=\"cnfg.ramos.length ==0\">Todos</span></td><td><div ng-if=\"cnfg.subramos.length >0\" class=\"col-xs-12\" ng-repeat=\"srm in cnfg.subramos_sel\"><span>{{srm.subramo_name}}</span></div><span ng-if=\"cnfg.subramos.length ==0\">Todos</span></td><td>{{ periodo_selected(cnfg.periodicidad) }}</td><td><b>Usuario:</b><br><small>{{ cnfg.username }}</small><br><b>Contraseña:</b><br><small>{{ cnfg.password }}</small></td><td>{{ cnfg.startDate | date: \'medium\'}}</td><td><b>Desde:</b><br><small>{{ cnfg.startDate_scraper | date: \'medium\' }}</small><br><b>Hasta:</b><br><small>{{ cnfg.endDate_scraper | date: \'medium\'}}</small></td><td>{{ cnfg.descrip }}</td><td><a class=\"btn btn-white\"><i class=\"fa fa-pencil\" aria-hidden=\"true\" ng-click=\"$event.stopPropagation();editConfig(cnfg)\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_cn\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPagesP()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPagesP | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPageP(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPagesP()\" ng-if=\"totalPagesP.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPageP()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-show=\"consultashow\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-lg-12\"><div class=\"col-xs-12 form-group btn-action\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 form-group\"><label>Aseguradora <span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control\" ng-options=\"aseguradora.alias for aseguradora in vm.defaults.providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"aseguradoraSelection()\" name=\"aseguradora\" ng-model=\"vm.form.aseguradora\" required=\"\" disabled=\"\"><option value=\"\">Selecciona un proveedor</option></select></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-12 form-group btn-action\" ng-if=\"vm.acceso_ver_ot || vm.acceso_ver_pol\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"vm.search(3, 1,1);\">Consultar</button></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.infoFlag\"><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando información...</span></div></div><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información Pólizas</h5></div><ul class=\"list-group\"><li class=\"list-group-item\" ng-init=\"registros[$index] = true\"><div class=\"row\" ng-if=\"registros[$index]\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Tipo</th><th>Contratante</th><th>Aseguradora</th><th>Subramo</th><th>Vigencia Inicio</th><th>Vigencia Fin</th></tr></thead><tbody><tr ng-repeat=\"poliza in registrosobtenidos track by $index\" ng-click=\"goToInfo(poliza)\"><td>Póliza</td><td>{{polizatoshare.contractor.full_name}}</td><td>{{polizatoshare.aseguradora.alias}}</td><td>{{polizatoshare.subramo.subramo_name}}</td><td>{{polizatoshare.start_of_validity | date: \'medium\': \'UTC\'}}</td><td>{{polizatoshare.end_of_validity | date: \'medium\': \'UTC\'}}</td></tr></tbody></table></div></div></li></ul><div class=\"row\"><div class=\"col-xs-12 pull-right\"></div></div></div></div></div>");
$templateCache.put("app/configuracion/configuracion.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Configuración</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Campos</strong></li></ol></div></div><br><br><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"Filtros, Creación, Edición, Reportes\" ng-click=\"showSettings(1)\"><div id=\"divACL\" class=\"tab-content border p-3\"><div class=\"ibox-content\" ng-if=\"settingsTab === 1 || filtrosACL\" id=\"divACL\"><div class=\"row title-div\"><div class=\"col-xs-12 col-lg-6\"><h3>Visible en Filtros, Creación, Edición, Reportes</h3></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 form-group border p-2\"><label><input id=\"filtros_agrupacion\" type=\"checkbox\" ng-model=\"configuracionGlobal.filtros_agrupacion\" ng-change=\"changeFiltros(configuracionGlobal.filtros_agrupacion)\"> Agrupación</label></div><div class=\"col-xs-12 col-sm-4 form-group border p-2\"><label><input id=\"filtros_celula\" type=\"checkbox\" ng-model=\"configuracionGlobal.filtros_celula\" ng-change=\"changeFiltros2(configuracionGlobal.filtros_celula)\"> Célula</label></div><div class=\"col-xs-12 col-sm-4 form-group border p-2\"><label><input id=\"filtros_lineanegocio\" type=\"checkbox\" ng-model=\"configuracionGlobal.filtros_lineanegocio\" ng-change=\"changeFiltros3(configuracionGlobal.filtros_lineanegocio)\"> Línea de Negocio</label></div></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Configuración de Campos en Reportes\" ng-click=\"showSettings(2)\"><div id=\"divCPR\" class=\"tab-content\"><div class=\"tab-pane fade in active\" ng-if=\"settingsTab === 2 || filtrosCPR\" id=\"divCPR\"><h3 class=\"text-align-center\">Configuración de Vista de Tabla</h3><div class=\"row ibox-content text-center\"><div class=\"col-xs-12 col-sm-4\"><button type=\"button\" class=\"btn btn-success btn-block\" ng-click=\"showList(1)\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-1-circle-fill\" viewbox=\"0 0 16 16\"><path d=\"M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M9.283 4.002H7.971L6.072 5.385v1.271l1.834-1.318h.065V12h1.312z\"></path></svg>Cobranza</button></div><div class=\"col-xs-12 col-sm-4\"><button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"showList(2)\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-2-circle-fill\" viewbox=\"0 0 16 16\"><path d=\"M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.646 6.24c0-.691.493-1.306 1.336-1.306.756 0 1.313.492 1.313 1.236 0 .697-.469 1.23-.902 1.705l-2.971 3.293V12h5.344v-1.107H7.268v-.077l1.974-2.22.096-.107c.688-.763 1.287-1.428 1.287-2.43 0-1.266-1.031-2.215-2.613-2.215-1.758 0-2.637 1.19-2.637 2.402v.065h1.271v-.07Z\"></path></svg>Pólizas</button></div><div class=\"col-xs-12 col-sm-4\"><button type=\"button\" class=\"btn btn-secondary btn-block\" ng-click=\"showList(3)\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-3-circle-fill\" viewbox=\"0 0 16 16\"><path d=\"M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-8.082.414c.92 0 1.535.54 1.541 1.318.012.791-.615 1.36-1.588 1.354-.861-.006-1.482-.469-1.54-1.066H5.104c.047 1.177 1.05 2.144 2.754 2.144 1.653 0 2.954-.937 2.93-2.396-.023-1.278-1.031-1.846-1.734-1.916v-.07c.597-.1 1.505-.739 1.482-1.876-.03-1.177-1.043-2.074-2.637-2.062-1.675.006-2.59.984-2.625 2.12h1.248c.036-.556.557-1.054 1.348-1.054.785 0 1.348.486 1.348 1.195.006.715-.563 1.237-1.342 1.237h-.838v1.072h.879Z\"></path></svg>Renovaciones</button></div></div><div class=\"border p-3 ibox-content\"><div class=\"col-xs-12\"><button class=\"btn btn-warning float-right\" ng-click=\"toggleAll()\">{{ allChecked ? \'Desactivar Todos\' : \'Activar Todos\' }}</button></div><h4 class=\"text-center\">Selecciona las columnas a mostrar: <b ng-if=\"settingsList===1\">Cobranza</b> <b ng-if=\"settingsList===2\">Pólizas</b> <b ng-if=\"settingsList===3\">Renovaciones</b></h4><div class=\"row\" ng-if=\"settingsList===1\"><div class=\"col-xs-4\"><div ng-repeat=\"header in listaCobranza.slice(0, listaCobranza.length / 3)\" style=\"margin-bottom: 5px;\"><label style=\"display: block;\"><input type=\"checkbox\" ng-model=\"selectedHeaders[header]\"> {{ header }}</label></div></div><div class=\"col-xs-4\"><div ng-repeat=\"header in listaCobranza.slice(listaCobranza.length / 3, 2 * listaCobranza.length / 3)\" style=\"margin-bottom: 5px;\"><label style=\"display: block;\"><input type=\"checkbox\" ng-model=\"selectedHeaders[header]\"> {{ header }}</label></div></div><div class=\"col-xs-4\"><div ng-repeat=\"header in listaCobranza.slice(2 * listaCobranza.length / 3)\" style=\"margin-bottom: 5px;\"><label style=\"display: block;\"><input type=\"checkbox\" ng-model=\"selectedHeaders[header]\"> {{ header }}</label></div></div></div><div class=\"row\" ng-if=\"settingsList===2\"><div class=\"col-xs-4\"><div ng-repeat=\"header in listaPolizas.slice(0, listaPolizas.length / 3)\" style=\"margin-bottom: 5px;\"><label style=\"display: block;\"><input type=\"checkbox\" ng-model=\"selectedHeadersP[header]\"> {{ header }}</label></div></div><div class=\"col-xs-4\"><div ng-repeat=\"header in listaPolizas.slice(listaPolizas.length / 3, 2 * listaPolizas.length / 3)\" style=\"margin-bottom: 5px;\"><label style=\"display: block;\"><input type=\"checkbox\" ng-model=\"selectedHeadersP[header]\"> {{ header }}</label></div></div><div class=\"col-xs-4\"><div ng-repeat=\"header in listaPolizas.slice(2 * listaPolizas.length / 3)\" style=\"margin-bottom: 5px;\"><label style=\"display: block;\"><input type=\"checkbox\" ng-model=\"selectedHeadersP[header]\"> {{ header }}</label></div></div></div><div class=\"row\" ng-if=\"settingsList===3\"><div class=\"col-xs-4\"><div ng-repeat=\"header in listaRenovaciones.slice(0, listaRenovaciones.length / 3)\" style=\"margin-bottom: 5px;\"><label style=\"display: block;\"><input type=\"checkbox\" ng-model=\"selectedHeadersR[header]\"> {{ header }}</label></div></div><div class=\"col-xs-4\"><div ng-repeat=\"header in listaRenovaciones.slice(listaRenovaciones.length / 3, 2 * listaRenovaciones.length / 3)\" style=\"margin-bottom: 5px;\"><label style=\"display: block;\"><input type=\"checkbox\" ng-model=\"selectedHeadersR[header]\"> {{ header }}</label></div></div><div class=\"col-xs-4\"><div ng-repeat=\"header in listaRenovaciones.slice(2 * listaRenovaciones.length / 3)\" style=\"margin-bottom: 5px;\"><label style=\"display: block;\"><input type=\"checkbox\" ng-model=\"selectedHeadersR[header]\"> {{ header }}</label></div></div></div><button class=\"btn btn-primary\" ng-click=\"saveSettings(1)\">Guardar Configuración</button></div><hr></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/contratantes/celulacontractor.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2 ng-if=\"moduleName\">{{moduleName}}</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>{{moduleName}}</strong></li></ol></div><div class=\"col-lg-3 pull-right\"><button ng-click=\"cambiarModulo()\" class=\"btn btn-outline btn-block btn-default btn-sm\"><i class=\"fa fa-cog\" aria-hidden=\"true\"></i></button></div></div><div class=\"row\" ng-show=\"!showEditCelula\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createCelula()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Agregar {{moduleName}}</button></div><div class=\"col-xs-12\" ng-show=\"showCelula\"><legend class=\"legend-title\" align=\"center\">Nueva {{moduleName}}</legend><form class=\"row padding-10\" name=\"form\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>{{moduleName}} <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"celulacontractor.celula_name\" ng-change=\"rememberCelulaDraft()\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Usuario(s)</label><select class=\"js-example-basic-multiple form-control\" style=\"width: 100%;\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user_in\" data-ng-options=\"user.first_name + \' \' + user.last_name for user in usuarios_saam | orderBy: \'first_name\' track by user.url\" ng-change=\"selectUsuarios(select_user_in)\"></select></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" ng-model=\"celulacontractor.description\" ng-change=\"rememberCelulaDraft()\"></textarea></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"save(celulacontractor)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"close()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></form></div></div><div class=\"ibox float-e-margins\" ng-if=\"!showEditCelula && !showInfo\"><div class=\"ibox-title\"><h5>{{moduleName}}</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><table class=\"table table-hover table-bordered\"><thead><tr><th>Nombre</th><th>Usuario(s)</th><th>Observaciones</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"item in celulaList track by $index\"><td>{{ item.celula_name }}</td><td><div ng-repeat=\"inv in item.users_many track by $index\" ng-if=\"item.users_many\"><span><span class=\"color-blue\">#{{$index +1}}:</span>{{inv.first_name}} {{inv.last_name}}</span></div></td><td>{{ item.description }}</td><td ng-click=\"$event.stopPropagation()\"><a ng-click=\"edit(item)\" type=\"button\" class=\"btn btn-white\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white\" ng-click=\"verInfo(item)\"><i class=\"fa fa-info\" aria-hidden=\"true\"></i></a></td></tr></tbody></table></div></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"!showEditCelula && showInfo\"><div class=\"col-xs-12 col-sm-6\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"cancelInfo()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Contratantes</legend><div class=\"ibox-title\"><h5>Contratantes en la {{moduleName}}</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><table class=\"table table-hover table-bordered\"><thead><tr><th>Nombre</th><th>Tipo</th><th>RFC</th><th>Correo Electrónico</th><th>Teléfono</th></tr></thead><tbody><tr ng-repeat=\"item in contractors track by $index\"><td>{{ item.full_name }}{{item.j_name}}</td><td><span ng-if=\"item.full_name\">Físico</span> <span ng-if=\"item.j_name\">Moral</span></td><td>{{ item.rfc }}</td><td>{{item.email}}</td><td>{{item.phone_number}}</td></tr></tbody></table></div></div></div></div></div><div class=\"inmodal\" id=\"modal_in\" ng-show=\"showEditCelula\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"cancelEdit()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Editar {{moduleName}}</legend><div class=\"col-xs-12 col-sm-6 form-group\"><label>{{moduleName}} <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"editCelula.celula_name\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Usuario(s)</label><div class=\"selectuser\"><select id=\"select_user\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"user.first_name + \' \' + user.last_name for user in usuarios_saam | orderBy: \'first_name\' track by user.url\" ng-change=\"selectUsuarios(select_user)\"></select></div></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" ng-model=\"editCelula.description\"></textarea></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"update(editCelula)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Actualizar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelEdit()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div></div><script type=\"text/javascript\">\n  // $(\'#select_user\').select2({\n  //       dropdownParent: $(\'.inmodal\')\n  //   });\n</script>");
$templateCache.put("app/contratantes/contratantes.add.html","<div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><uib-tabset template-url=\"app/contratantes/contratantes.tabset.html\" active=\"activeJustified\" justified=\"true\"><uib-tab ng-if=\"create_natural\" template-url=\"app/contratantes/contratantes.tab.html\" index=\"0\" heading=\"Fisica\" ng-click=\"showButtonFisica()\"><div id=\"divFisica\" ng-include=\"\'app/contratantes/contratantes.natural.html\'\"></div></uib-tab><uib-tab ng-if=\"create_juridical\" template-url=\"app/contratantes/contratantes.tab.html\" index=\"1\" heading=\"Moral\" ng-click=\"showButtonMoral()\"><div id=\"divMoral\" ng-include=\"\'app/contratantes/contratantes.juridical.html\'\"></div></uib-tab></uib-tabset></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><button id=\"cancelButtonFisica\" class=\"col-xs-12 btn btn-danger\" ng-click=\"cancelChanges()\" type=\"button\">Cancelar</button></div><div class=\"col-xs-12 col-sm-6 form-group\"><button id=\"saveButtonFisicaModal\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-if=\"fisicas\" ng-disabled=\"!habilitado\" onclick=\"saveContrFisica()\">Guardar contratante Físico</button></div><div class=\"col-xs-12 col-sm-6 form-group\"><button id=\"saveButtonMoralModal\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-if=\"morales\" ng-disabled=\"!habilitado\" onclick=\"saveContrMoral()\">Guardar contratante Moral</button></div></div></div></div></div></div>");
$templateCache.put("app/contratantes/contratantes.agrupacion.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Agregar Agrupación</h4></div><div class=\"modal-body\"><div class=\"row\" ng-if=\"level == 1\"><div class=\"col-xs-12 form-group\"><label>Nueva Agrupación <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"grupo.description\" type=\"text\"></div><div class=\"col-xs-12 form-group\"><label>Responsable <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"responsable\" ng-model=\"grupo.responsable\" ng-change=\"changeResponsable(groupForm.responsable)\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in users track by responsable.url\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select></div><div class=\"col-xs-12\"><div class=\"address-container\" ng-repeat=\"item in subasignaciones\"><label>Subagrupación #{{$index + 1}}</label><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteSubasignaciones($index)\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button></span> <input class=\"form-control\" type=\"text\" ng-model=\"item.group_name\" placeholder=\"Nombre\"> <span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addSubasignaciones()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></span></div></div></div></div><div class=\"row\" ng-if=\"level == 2\"><div class=\"col-xs-12 form-group\"><legend align=\"center\">{{group_modal.description}}</legend></div><div class=\"col-xs-12 form-group\"><label>Nueva Subagrupación <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"grupo.description\" type=\"text\"></div><div class=\"col-xs-12 form-group\"><label>Responsable <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"responsable\" ng-model=\"grupo.responsable\" ng-change=\"changeResponsable(groupForm.responsable)\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in users track by responsable.url\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select></div><div class=\"col-xs-12\"><div class=\"address-container\" ng-repeat=\"item in subsubasignacion\"><label>Subsubagrupación #{{$index + 1}}</label><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteSubsubasignaciones($index)\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button></span> <input class=\"form-control\" type=\"text\" ng-model=\"item.description\" placeholder=\"Nombre\"> <span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addSubsubasignaciones()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></span></div></div></div></div><div class=\"row\" ng-if=\"level == 3\"><div class=\"col-xs-12 form-group\"><legend align=\"center\">{{group_modal.description}}</legend></div><div class=\"col-xs-12 form-group\"><label>Nuevo Subsubagrupación <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"grupo.description\" type=\"text\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button> <button ng-if=\"level == 1\" type=\"button\" class=\"btn btn-primary ladda-button\" ng-click=\"save()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear</button> <button ng-if=\"level == 2\" type=\"button\" class=\"btn btn-primary ladda-button\" ng-click=\"saveSub()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear</button> <button ng-if=\"level == 3\" type=\"button\" class=\"btn btn-primary ladda-button\" ng-click=\"saveSubsub()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear</button></div></div>");
$templateCache.put("app/contratantes/contratantes.celulas.html","<div class=\"inmodal\" id=\"modal_in\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Agregar {{moduleName}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Nueva {{moduleName}} <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"celula.celula_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Usuario<span class=\"color-red\">*</span></label><div class=\"\"><select style=\"width: 100%;\" id=\"select_usercelula\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user_in\" data-ng-options=\"user.first_name + \' \' + user.last_name for user in usuarios_saam | orderBy: \'first_name\' track by user.url\" ng-change=\"selectUsuarios(select_user_in)\"></select></div></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" ng-model=\"celula.description\"></textarea></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel_celula()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary ladda-button\" ng-click=\"save_celula()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear</button></div></div><script type=\"text/javascript\">\n  $(\'#select_user\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n  $(\'#select_usercelula\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n  $(\".js-example-tokenizer\").select2({\n      tags: true,\n      tokenSeparators: [\',\', \' \']\n  })\n</script>");
$templateCache.put("app/contratantes/contratantes.clasificacion.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Agregar Clasificación</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Nueva Clasificación <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"classification.classification_name\" type=\"text\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" ng-model=\"classification.description\"></textarea></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary ladda-button\" ng-click=\"save()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear</button></div></div>");
$templateCache.put("app/contratantes/contratantes.delete.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Eliminar</h4></div><div class=\"modal-body\"><p>¿Está seguro que desea eliminar este contratante?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">No</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Sí</button></div></div>");
$templateCache.put("app/contratantes/contratantes.deleteAddress.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Eliminar</h4></div><div class=\"modal-body\"><p></p><h1>¿Está seguro que desea eliminar esta direccion?</h1><br\\>La direccion se eliminará aunque no guarde los cambios<p></p></br\\></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">No</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Sí</button></div></div>");
$templateCache.put("app/contratantes/contratantes.deleteContact.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Eliminar</h4></div><div class=\"modal-body\"><p></p><h1>¿Está seguro que desea eliminar este contacto?</h1><br\\>El contacto se eliminará aunque no guarde los cambios<p></p></br\\></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">No</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Sí</button></div></div>");
$templateCache.put("app/contratantes/contratantes.edit.html","<div><div ng-if=\"vm.form\"><div class=\"row\" ng-include=\"\'app/contratantes/contratantes.edit.natural.html\'\"></div></div><div ng-if=\"vm.juridicalForm\"><div class=\"row\" ng-include=\"\'app/contratantes/contratantes.edit.juridical.html\'\"></div></div></div>");
$templateCache.put("app/contratantes/contratantes.edit.juridical.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Contratantes</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"contratantes.main\">Contratantes</a></li><li class=\"active\"><strong>Editar</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div><form class=\"col-xs-12\" method=\"post\" name=\"form2\" ng-submit=\"vm.submitJuridical(form2.$valid)\" novalidate=\"\" role=\"form\"><div class=\"data-container\"><div class=\"col-xs-12 nopadding form-group\" ng-class=\"{ \'has-error\': form2.j_name.$invalid && !form2.j_name.$pristine }\"><label>Nombre de la empresa <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"j_name\" ng-model=\"vm.juridicalForm.full_name\" required=\"\" ng-change=\"save_info_tab()\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 nopadding form-group\" id=\"data_2\"><label>Fecha de constitución <span class=\"color-red\">*</span></label><div class=\"input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"vm.juridicalForm.date_of_establishment\" ng-change=\"selectDate(vm.juridicalForm.date_of_establishment)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 nopadding form-group\" ng-class=\"{ \'has-error\': form2.rfc.$invalid && !form2.rfc.$pristine }\"><label>RFC <span class=\"color-red\">*</span></label> <input class=\"form-control\" uppercase-only=\"\" name=\"rfc\" ng-model=\"vm.juridicalForm.rfc\" type=\"text\" maxlength=\"13\" ng-change=\"save_info_tab()\" required=\"\"></div><div class=\"col-xs-12 col-sm-4 nopadding form-group\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\"><label for=\"group\">Grupo<span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"group\" ng-model=\"vm.editForm.group\" ng-change=\"changeGroup(vm.editForm.group)\" ng-options=\"group.group_name for group in vm.groups track by group.id\"><option value=\"\" selected=\"\" disabled=\"\">--Sin grupo--</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(1,2,null)\" type=\"button\" ng-if=\"vm.user.permiso.crear\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\" ng-if=\"vm.editForm.group\"><label for=\"subgroup\">Subgrupo</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"subgroup\" ng-model=\"vm.editForm.subgroup\" ng-change=\"changeSubGroup(vm.editForm.subgroup)\" ng-options=\"group.group_name for group in vm.subgroups track by group.url\"><option value=\"\" disabled=\"\">Seleccione un subgrupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(2,2,vm.editForm.group)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\" ng-if=\"vm.editForm.subgroup\"><label for=\"subgroup2\">Subsubgrupo</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"subgroup2\" ng-model=\"vm.editForm.subsubgrupo\" ng-options=\"group.group_name for group in vm.sub_subgroups track by group.url\"><option value=\"\" disabled=\"\">Seleccione un subgrupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(3,2,vm.editForm.subgroup)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Correo Electrónico (principal)</label> <input class=\"form-control\" ng-model=\"vm.juridicalForm.email\" type=\"email\"></div><div class=\"col-xs-12 col-sm-6 hidden-xs hidden-sm nopadding form-group\"><label>Teléfono (principal)</label><phonenumber-directive placeholder=\"myPrompt\" model=\"vm.juridicalForm.phone_number\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 hidden-xs hidden-sm nopadding form-group\"><label>Móvil (WhatsApp/SMS)</label> <input class=\"form-control\" placeholder=\"4427776677\" type=\"text\" ng-model=\"vm.juridicalForm.phone_mensajeria\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Correo Electrónico (secundarios)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.email_juridical\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.emails.delete($index, 2, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><input class=\"form-control\" lowercase=\"\" ng-model=\"item.correo\" type=\"email\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.emails.add(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a id=\"dropdown-menu-item-link-1\" ng-click=\"item.email_type = 1; vm.closeDropdown();\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal</a></li><li><a id=\"dropdown-menu-item-link-2\" ng-click=\"item.email_type = 2; vm.closeDropdown();\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"item.email_type = 3; vm.closeDropdown();\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"item.email_type = 4; vm.closeDropdown();\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI</a></li></ul></div></div></div><div class=\"nopadding form-group\" ng-if=\"vm.juridicalForm.email_juridical.length == 0\"><div class=\"col-xs-12 input-group form-group\"><button class=\"btn btn-success\" ng-click=\"vm.emails.add(2)\" type=\"button\">Agregar correo</button></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.email_juridical\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.emails.delete($index, 2, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><input class=\"form-control\" lowercase=\"\" ng-model=\"item.correo\" type=\"email\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"item.email_type = 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal</a></li><li><a ng-click=\"item.email_type = 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo</a></li><li><a ng-click=\"item.email_type = 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI</a></li><li><a ng-click=\"item.email_type = 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro</a></li></ul><button class=\"btn btn-success\" ng-click=\"vm.emails.add(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 hidden-md hidden-lg nopadding form-group\"><label>Teléfono (principal)</label><phonenumber-directive placeholder=\"myPrompt\" model=\"vm.juridicalForm.phone_number\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Teléfonos (secundarios)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.phone_juridical\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.phones.delete($index, 2, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><phonenumber-directive placeholder=\"myPrompt\" model=\"item.phone\"></phonenumber-directive><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.phones.add(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a ng-click=\"item.phone_type = 1; vm.closeDropdown();\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa</a></li><li><a ng-click=\"item.phone_type = 2; vm.closeDropdown();\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina</a></li><li><a ng-click=\"item.phone_type = 3; vm.closeDropdown();\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil</a></li></ul></div></div></div><div class=\"nopadding form-group\" ng-if=\"vm.juridicalForm.phone_juridical.length == 0\"><div class=\"col-xs-12 input-group form-group\"><button class=\"btn btn-success\" ng-click=\"vm.phones.add(2)\" type=\"button\">Agregar teléfono</button></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.phone_juridical\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.phones.delete($index, 2 ,item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><phonenumber-directive placeholder=\"myPrompt\" model=\"item.phone\"></phonenumber-directive><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"item.phone_type = 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa</a></li><li><a ng-click=\"item.phone_type = 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina</a></li><li><a ng-click=\"item.phone_type = 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil</a></li></ul><button class=\"btn btn-success\" ng-click=\"vm.phones.add(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div></div><div class=\"row address-container\" ng-repeat=\"address in vm.juridicalForm.userAddresses track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.addresses.delete($index,1)\" ng-disabled=\"address.can_delete\">Quitar dirección</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.addresses.delete($index, 2)\" ng-disabled=\"vm.juridicalForm.userAddresses.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Direccion #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addresses.add(2)\" type=\"button\">Agregar dirección</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addresses.add(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{ \'has-error\': form2.city.$invalid && !form2.city.$pristine }\"><label>Tipo de dirección</label><select class=\"form-control\" data-ng-options=\"type.name for type in vm.address_type track by type.name\" name=\"type\" ng-model=\"address.tipo\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{ \'has-error\': form2.state.$invalid && !form2.state.$pristine }\"><label>Estado<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"estado.state for estado in vm.statesArray track by estado.url\" name=\"state\" ng-model=\"address.administrative_area_level_1\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un estado</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{ \'has-error\': form2.city.$invalid && !form2.city.$pristine }\"><label>Municipio<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"ciudad.city for ciudad in address.administrative_area_level_1.cities track by ciudad.url\" name=\"city\" ng-model=\"address.administrative_area_level_2\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un municipio</option></select></div><div class=\"col-xs-12 col-md-8 nopadding form-group\"><label>Calle</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.route\" id=\"id_address_route\" name=\"address_route\" data-geo=\"route\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>N. Ext.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number\" id=\"id_address_street_number\" name=\"address_street_number\" data-geo=\"street_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>N. Int.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number_int\" id=\"id_address_street_number_int\" name=\"address_street_number_int\"></div><div class=\"col-sm-12 col-sm-6 nopadding form-group\"><label>Colonia</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.sublocality\" id=\"id_address_sublocality\" name=\"address_sublocality\" data-geo=\"sublocality\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Código Postal</label> <input type=\"tel\" name=\"zip\" ng-model=\"address.postal_code\" minlength=\"5\" maxlength=\"5\" class=\"form-control\" ng-keypress=\"filterValue($event)\"></div><div class=\"col-xs-12 nopadding form-group\"><label>Referencias</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.details\" id=\"id_address_details\" name=\"address_details\"></div><div ng-if=\"address.can_delete\"><p>La dirección no se puede eliminar porque existen pólizas con esta dirección asignada</p></div><input type=\"hidden\" class=\"form-control\" ng-model=\"address.administrative_area_level_1_short\" id=\"id_address_administrative_area_level_1_short\" name=\"address_state_code\" data-geo=\"administrative_area_level_1_short\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country\" id=\"id_address_country\" name=\"address_country\" data-geo=\"country\" value=\"México\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.composed\" id=\"id_address_composed\" name=\"address_composed\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country_code\" id=\"id_address_country_code\" name=\"address_country_code\" data-geo=\"country_short\" value=\"MX\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.locality\" id=\"id_address_locality\" name=\"address_locality\" data-geo=\"locality\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.latitude\" id=\"id_address_latitude\" name=\"address_latitude\" data-geo=\"lat\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.longitude\" id=\"id_address_longitude\" name=\"address_longitude\" data-geo=\"lng\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.formatted\" id=\"id_address_formatted\" name=\"address_formatted\" data-geo=\"formatted_address\"></div></div><div class=\"col-xs-12\" ng-if=\"vm.juridicalForm.only_sureties\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Seleccione el archivo a cargar, de clic en el ícono <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> uno a la vez después de seleccionar, para añadirlo.</div></div><div class=\"col-xs-12 col-sm-6 form-group m-t\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"vm.juridicalForm.only_sureties\" ng-change=\"onlyFianzas(2)\"> <span>Solo para Fianzas</span></h3></div><div class=\"col-xs-12 col-sm-6 col-lg-12 form-group\" align=\"center\"><table class=\"table table-bordered\" align=\"center\"><thead><tr><th>Entregado</th><th>Documento</th><th ng-if=\"vm.juridicalForm.only_sureties\">Archivo</th></tr></thead><tbody><tr ng-repeat=\"listaD in vm.listDocument track by $index\"><td class=\"col-lg-3\" ng-click=\"$event.stopPropagation()\"><label><input type=\"checkbox\" ng-model=\"listaD.value\"></label></td><td><span class=\"font-weight-bold\">{{listaD.name}}</span></td><td ng-click=\"$event.stopPropagation()\" ng-if=\"vm.juridicalForm.only_sureties\"><div class=\"col-xs-12 form-group\" id=\"$index\"><label class=\"btn btn-success\" ng-if=\"listaD.file ==false\">Seleccionar Archivo <input nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploaderDocument\" class=\"display-none\"></label> <button class=\"btn btn-white\" ng-if=\"listaD.file ==false\" ng-click=\"addFileList($index,vm.listDocument, uploaderDocument.queue,xyz)\" title=\"Click para añadir archivo y subirlo\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i></button> <span class=\"blue-color\">{{listaD.arch.file.name}}</span><i class=\"fa fa-check-circle\" aria-hidden=\"true\" ng-if=\"listaD.file ==true\"></i></div></td></tr></tbody></table></div><div class=\"col-xs-12 form-group m-t\"><label>Observaciones</label> <textarea class=\"form-control\" ng-model=\"vm.juridicalForm.description\" type=\"text\"></textarea></div><div ng-if=\"sucursalList.length > 0\" class=\"col-xs-12 col-sm-6 form-group\"><label for=\"sucursal\">Sucursal</label><select class=\"form-control\" name=\"sucursal\" ng-model=\"vm.juridicalForm.sucursal\" ng-change=\"sucursal(vm.juridicalForm.sucursal)\" ng-options=\"sucursal as sucursal.sucursal_name for sucursal in sucursalList track by sucursal.id\"><option value=\"\">Seleccione una Sucursal</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"campo_celula\"><label for=\"sucursal\">{{moduleName}}</label><div class=\"input-group\"><select class=\"form-control\" name=\"celula\" ng-model=\"vm.juridicalForm.celula\" ng-change=\"celula(vm.juridicalForm.celula)\" ng-options=\"celula.url as celula.celula_name for celula in vm.celulas\"><option value=\"\" disabled=\"\">Seleccione {{moduleName}}</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.openModalCelulaContractor()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"sucursal\">Clasificación</label><div class=\"input-group\"><select class=\"form-control\" name=\"clasification\" ng-model=\"vm.juridicalForm.classification\" ng-change=\"sucursal(vm.juridicalForm.clasification)\" ng-options=\"clasification.url as clasification.classification_name for clasification in vm.clasifications\"><option value=\"\" disabled=\"\">Seleccione una clasificación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.openModalClasification()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"campo_agrupacion\"><label for=\"sucursal\">Agrupación</label><select class=\"form-control\" name=\"agrupacion\" ng-model=\"vm.editForm.grouping_level\" ng-change=\"changeAgrupacion2(vm.editForm.grouping_level)\" ng-options=\"agrupaciones.description for agrupaciones in vm.agrupaciones track by agrupaciones.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.editForm.grouping_level\"><label for=\"sucursal\">Subagrupación</label><div class=\"input-group\"><select class=\"form-control\" name=\"subagrupacion\" ng-model=\"vm.editForm.subagrupaciones\" ng-change=\"changeSubagrupacion2(vm.editForm.subagrupaciones)\" ng-options=\"agrupaciones.description for agrupaciones in sub_asignaciones track by agrupaciones.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalAsignacion(2,vm.editForm.grouping_level)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.editForm.subagrupaciones\"><label for=\"sucursal\">Subsubagrupación</label><div class=\"input-group\"><select class=\"form-control\" name=\"subsubagrupacion\" ng-model=\"vm.editForm.subsubasignaciones\" ng-change=\"changeSubsubagrupacion2(vm.editForm.subsubasignaciones)\" ng-options=\"grupo.description for grupo in sub_subasignaciones track by grupo.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalAsignacion(3,vm.editForm.subagrupaciones)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div ng-if=\"vm.vendors.length >0 && vm.verReferenciadores\" class=\"col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.vendedor.$invalid && !form.vendedor.$pristine }\"><label for=\"vendedor\">Referenciador<span class=\"color-red\">*</span></label><div class=\"\"><select class=\"form-control m-b\" name=\"vendedor\" ng-model=\"vm.juridicalForm.vendedor\" ng-change=\"changeVendedor(vm.juridicalForm.vendedor)\" ng-options=\"vendedor.name for vendedor in vm.vendors track by vendedor.id\"><option value=\"\">Seleccione un referenciador</option></select></div></div><div ng-if=\"vm.responsables.length >0\" class=\"col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.responsable.$invalid && !form.responsable.$pristine }\"><label for=\"responsable\">Responsable<span class=\"color-red\">*</span></label><div class=\"\"><select class=\"form-control m-b\" name=\"responsable\" ng-model=\"vm.juridicalForm.responsable\" ng-change=\"changeResponsable(vm.juridicalForm.responsable)\" ng-options=\"responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables track by responsable.id\"><option value=\"\">Seleccione un responsable</option></select></div></div><div class=\"hidden-xs hidden-sm nopadding juridicalForm-group\" ng-repeat=\"item in vm.juridicalForm.resp_contractor\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteResponsable($index, 2)\" ng-disabled=\"vm.juridicalForm.resp_contractor.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b\" ng-model=\"item.responsable\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.resp_contractor[$index].resp_type == 0\">Elige el área <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.resp_contractor[$index].resp_type == 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.resp_contractor[$index].resp_type == 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.resp_contractor[$index].resp_type == 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.resp_contractor[$index].resp_type == 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.resp_contractor[$index].resp_type == 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.juridicalForm.resp_contractor[$index].resp_type = 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión</a></li><li><a ng-click=\"vm.juridicalForm.resp_contractor[$index].resp_type = 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo</a></li><li><a ng-click=\"vm.juridicalForm.resp_contractor[$index].resp_type = 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial</a></li><li><a ng-click=\"vm.juridicalForm.resp_contractor[$index].resp_type = 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza</a></li><li><a ng-click=\"vm.juridicalForm.resp_contractor[$index].resp_type = 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros</a></li></ul><button class=\"btn btn-success\" ng-click=\"addResponsable(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Obligado(s) Solidario(s) (Fianzas)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.obligados\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteObligados($index, 2)\" ng-disabled=\"vm.form.obligados.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><div id=\"item[$index]\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"item\" change=\"matchesContractors(item.val)\"></autocomplete></div><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addObligados(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.obligados\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteObligados($index, 2)\" ng-disabled=\"vm.form.obligados.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><div id=\"item[$index]\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"item\" change=\"matchesContractors(item.val)\"></autocomplete></div><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addObligados(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group m-t\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"vm.juridicalForm.vip\"> <span>VIP</span></h3></div><div><input type=\"hidden\" name=\"type_person\" ng-model=\"vm.juridicalForm.type\" value=\"\"></div><div class=\"hr-line-dashed\"></div><div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Información de contacto</legend></div><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.juridicalForm.contact_juridical.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"vm.juridicalForm.contact_juridical.length == 0\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"vm.juridicalForm.contact_juridical.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contactos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact(2)\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"contact in vm.juridicalForm.contact_juridical track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteContacts($index, 2, contact)\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts($index, 2, contact)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contacto #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact(2)\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"contact.name\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" type=\"search\" lowercase=\"\" ng-model=\"contact.email\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Teléfono</label><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone_number\"></phonenumber-directive></div></div></div></div></div></form></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/upload.html\'\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div class=\"col-xs-12 col-sm-4 col-md-3 pull-right form-group\" ng-if=\"vm.permiso_administrar_adjuntos\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-click=\"vm.uploadImages()\">Subir archivos</button></div><div ng-include=\"\'templates/show-files.html\'\"></div></div></div></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"vm.save()\" ng-if=\"vm.user.permiso.editar\">Guardar cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/contratantes/contratantes.edit.natural.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Contratantes</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"contratantes.main\">Contratantes</a></li><li class=\"active\"><strong>Editar</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div><form class=\"col-xs-12\" method=\"post\" name=\"form\" ng-submit=\"vm.submitNatural(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"data-container\"><div class=\"col-xs-12 col-sm-4 nopadding form-group\" ng-class=\"{ \'has-error\': form.name.$invalid && !form.name.$pristine }\"><label>Nombre<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"vm.form.first_name\" required=\"\" type=\"text\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-4 nopadding form-group\" ng-class=\"{ \'has-error\': form.last_name.$invalid && !form.last_name.$pristine }\"><label>Apellido Paterno<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"last_name\" ng-model=\"vm.form.last_name\" required=\"\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-4 nopadding form-group\"><label>Apellido Materno</label> <input class=\"form-control\" type=\"text\" name=\"second_last_name\" ng-model=\"vm.form.second_last_name\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\" id=\"data_2\" ng-class=\"{ \'has-error\': form.birthday.$invalid && !form.birthday.$pristine }\"><label>Fecha de Nacimiento<span class=\"color-red\">*</span></label><div class=\"input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" name=\"birthday\" ng-model=\"vm.form.birthday\" ng-change=\"selectDate(vm.form.birthday)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\" ng-class=\"{ \'has-error\': form.rfc.$invalid && !form.rfc.$pristine }\"><label>RFC<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"rfc\" uppercase-only=\"\" ng-model=\"vm.form.rfc\" maxlength=\"13\" ng-change=\"save_info_tab()\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Género</label><select class=\"form-control\" name=\"sex\" ng-model=\"vm.form.sex\" ng-change=\"save_info_tab()\"><option ng-selected=\"vm.form.sex == \'M\'\" value=\"M\">MASCULINO</option><option ng-selected=\"vm.form.sex == \'F\'\" value=\"F\">FEMENINO</option></select></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\"><label for=\"group\">Grupo<span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"group\" ng-model=\"vm.editForm.group\" ng-change=\"changeGroup(vm.editForm.group)\" ng-options=\"group.group_name for group in vm.groups track by group.id\"><option value=\"\" selected=\"\" disabled=\"\">--Sin grupo--</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(1,1,null)\" type=\"button\" ng-if=\"vm.user.permiso.crear\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\" ng-if=\"vm.editForm.group\"><label for=\"subgroup\">Subgrupo</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"subgroup\" ng-model=\"vm.editForm.subgroup\" ng-change=\"changeSubGroup(vm.editForm.subgroup)\" ng-options=\"group.group_name for group in vm.subgroups track by group.url\"><option value=\"\" disabled=\"\">Seleccione un subgrupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(2,1,vm.editForm.group)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\" ng-if=\"vm.editForm.subgroup\"><label for=\"subgroup2\">Subsubgrupo</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"subgroup2\" ng-model=\"vm.editForm.subsubgrupo\" ng-options=\"ssgroup.group_name for ssgroup in vm.sub_subgroups track by ssgroup.url\"><option value=\"\" disabled=\"\">Seleccione un subgrupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(3,1,vm.editForm.subgroup)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Correo Electrónico (principal)</label> <input class=\"form-control\" ng-model=\"vm.form.email\" type=\"email\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 hidden-xs hidden-sm nopadding form-group\"><label>Teléfono (principal)</label><phonenumber-directive placeholder=\"myPrompt\" model=\"vm.form.phone_number\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 hidden-xs hidden-sm nopadding form-group\"><label>Móvil (WhatsApp/SMS)</label> <input class=\"form-control\" placeholder=\"4427776677\" type=\"text\" ng-model=\"vm.form.phone_mensajeria\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Correos Electrónicos (secundarios)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.form.email_natural\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.emails.delete($index, 1, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><input class=\"form-control\" ng-model=\"item.correo\" type=\"email\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.emails.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a id=\"dropdown-menu-item-link-1\" ng-click=\"item.email_type = 1; vm.closeDropdown();\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal</a></li><li><a id=\"dropdown-menu-item-link-2\" ng-click=\"item.email_type = 2; vm.closeDropdown();\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"item.email_type = 3; vm.closeDropdown();\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"item.email_type = 4; vm.closeDropdown();\"><span class=\"fa fa fa fa-building\" aria-hidden=\"true\"></span> CDFI</a></li></ul></div></div></div><div class=\"nopadding form-group\" ng-if=\"vm.form.email_natural.length == 0\"><div class=\"col-xs-12 input-group form-group\"><button class=\"btn btn-success\" ng-click=\"vm.emails.add(1)\" type=\"button\">Agregar correo</button></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.form.email_natural\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.emails.delete($index, 1, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><input class=\"form-control\" ng-model=\"item.correo\" type=\"email\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"item.email_type = 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal</a></li><li><a ng-click=\"item.email_type = 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo</a></li><li><a ng-click=\"item.email_type = 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI</a></li><li><a ng-click=\"item.email_type = 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro</a></li></ul><button class=\"btn btn-success\" ng-click=\"vm.emails.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 hidden-md hidden-lg nopadding form-group\"><label>Teléfono (principal)</label><phonenumber-directive placeholder=\"myPrompt\" model=\"vm.form.phone_number\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Teléfonos (secundarios)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.form.phone_natural\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.phones.delete($index, 1, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><phonenumber-directive placeholder=\"myPrompt\" model=\"item.phone\"></phonenumber-directive><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.phones.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a ng-click=\"item.phone_type = 1; vm.closeDropdown();\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa</a></li><li><a ng-click=\"item.phone_type = 2; vm.closeDropdown();\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina</a></li><li><a ng-click=\"item.phone_type = 3; vm.closeDropdown();\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil</a></li></ul></div></div></div><div class=\"nopadding form-group\" ng-if=\"vm.form.phone_natural.length == 0\"><div class=\"col-xs-12 input-group form-group\"><button class=\"btn btn-success\" ng-click=\"vm.phones.add(1)\" type=\"button\">Agregar teléfono</button></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.form.phone_natural\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.phones.delete($index, 1, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><phonenumber-directive placeholder=\"myPrompt\" model=\"item.phone\"></phonenumber-directive><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"item.phone_type = 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa</a></li><li><a ng-click=\"item.phone_type = 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina</a></li><li><a ng-click=\"item.phone_type = 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil</a></li></ul><button class=\"btn btn-success\" ng-click=\"vm.phones.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div></div><div class=\"address-container\" ng-repeat=\"address in vm.form.userAddresses track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.addresses.delete($index,1)\" ng-disabled=\"address.can_delete\">Quitar dirección</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.addresses.delete($index,1)\" ng-disabled=\"vm.form.userAddresses.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Direccion #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addresses.add(1)\" type=\"button\">Agregar dirección</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addresses.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{\'has-error\': form2.city.$invalid && !form2.city.$pristine}\"><label>Tipo de dirección</label><select class=\"form-control\" data-ng-options=\"type.name for type in vm.address_type track by type.name\" name=\"type\" ng-model=\"address.tipo\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{\'has-error\': form.state.$invalid && !form.state.$pristine}\"><label>Estado<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"estado.state for estado in vm.statesArray track by estado.url\" name=\"state\" ng-model=\"address.administrative_area_level_1\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un estado</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{\'has-error\': form.city.$invalid && !form.city.$pristine}\"><label>Municipio<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"ciudad.city for ciudad in address.administrative_area_level_1.cities track by ciudad.url\" name=\"city\" ng-model=\"address.administrative_area_level_2\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un municipio</option></select></div><div class=\"col-xs-12 col-md-8 nopadding form-group\"><label>Calle</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.route\" id=\"id_address_route\" name=\"address_route\" data-geo=\"route\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Ext.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number\" id=\"id_address_street_number\" name=\"address_street_number\" data-geo=\"street_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Int.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number_int\" id=\"id_address_street_number_int\" name=\"address_street_number_int\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Colonia</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.sublocality\" id=\"id_address_sublocality\" name=\"address_sublocality\" data-geo=\"sublocality\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Código Postal</label> <input type=\"tel\" name=\"zip\" ng-model=\"address.postal_code\" minlength=\"5\" maxlength=\"5\" class=\"form-control\" ng-keypress=\"filterValue($event)\"></div><div class=\"col-xs-12 nopadding form-group\"><label>Referencias</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.details\" id=\"id_address_details\" name=\"address_details\"></div><input type=\"hidden\" class=\"form-control\" ng-model=\"address.administrative_area_level_1_short\" id=\"id_address_administrative_area_level_1_short\" name=\"address_state_code\" data-geo=\"administrative_area_level_1_short\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country\" id=\"id_address_country\" name=\"address_country\" data-geo=\"country\" value=\"México\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.composed\" id=\"id_address_composed\" name=\"address_composed\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country_code\" id=\"id_address_country_code\" name=\"address_country_code\" data-geo=\"country_short\" value=\"MX\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.locality\" id=\"id_address_locality\" name=\"address_locality\" data-geo=\"locality\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.latitude\" id=\"id_address_latitude\" name=\"address_latitude\" data-geo=\"lat\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.longitude\" id=\"id_address_longitude\" name=\"address_longitude\" data-geo=\"lng\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.formatted\" id=\"id_address_formatted\" name=\"address_formatted\" data-geo=\"formatted_address\"></div></div><br><br><br><div class=\"col-xs-12\" ng-if=\"vm.form.only_sureties\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Seleccione el archivo a cargar, de clic en el ícono <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> uno a la vez después de seleccionar, para añadirlo.</div></div><div class=\"col-xs-12 col-sm-6 form-group m-t\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"vm.form.only_sureties\" ng-change=\"onlyFianzas(1)\"> <span>Solo para Fianzas</span></h3></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-lg-12 form-group\" align=\"center\" style=\"padding-top: 30px\"><table class=\"table table-bordered\" align=\"center\"><thead><tr><th>Entregado</th><th>Documento</th><th ng-if=\"vm.form.only_sureties\">Archivo</th></tr></thead><tbody><tr ng-repeat=\"listaD in vm.listDocument track by $index\"><td class=\"col-lg-3\" ng-click=\"$event.stopPropagation()\"><label><input type=\"checkbox\" ng-model=\"listaD.value\"></label></td><td><span class=\"font-weight-bold\">{{listaD.name}}</span></td><td ng-click=\"$event.stopPropagation()\" ng-if=\"vm.form.only_sureties\"><div class=\"col-xs-12 form-group\" id=\"$index\"><label class=\"btn btn-success\" ng-if=\"listaD.file ==false\">Seleccionar Archivo <input nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploaderDocument\" class=\"display-none\"></label> <button class=\"btn btn-white\" ng-if=\"listaD.file ==false\" ng-click=\"addFileList($index,vm.listDocument, uploaderDocument.queue,xyz)\" title=\"Click para añadir archivo y subirlo\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i></button> <span class=\"blue-color\">{{listaD.arch.file.name}}</span><i class=\"fa fa-check-circle\" aria-hidden=\"true\" ng-if=\"listaD.file ==true\"></i></div></td></tr></tbody></table></div></div><div class=\"col-xs-12 form-group m-t\"><label>Observaciones</label> <textarea class=\"form-control upperclass\" type=\"text\" ng-model=\"vm.form.description\"></textarea></div><div ng-if=\"vm.vendors.length >0 && vm.verReferenciadores\" class=\"col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.vendedor.$invalid && !form.vendedor.$pristine }\"><label for=\"vendedor\">Referenciador<span class=\"color-red\">*</span></label><div><select class=\"form-control m-b\" name=\"vendedor\" ng-model=\"vm.form.vendedor\" ng-change=\"changeVendedor(vm.form.vendedor)\" ng-options=\"vendedor.name for vendedor in vm.vendors track by vendedor.id\"><option value=\"\">Seleccione un referenciador</option></select></div></div><div ng-if=\"sucursalList.length > 0\" class=\"col-xs-12 col-sm-6 form-group\"><label for=\"sucursal\">Sucursal</label><select class=\"form-control\" name=\"sucursal\" ng-model=\"vm.form.sucursal\" ng-change=\"sucursal(vm.form.sucursal)\" ng-options=\"sucursal as sucursal.sucursal_name for sucursal in sucursalList track by sucursal.id\"><option value=\"\">Seleccione una Sucursal</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"campo_celula\"><label for=\"cedulacontractor\">{{moduleName}}</label><div class=\"input-group\"><select class=\"form-control\" name=\"celula\" ng-model=\"vm.form.celula\" ng-change=\"rememberDraft(1)\" ng-options=\"celula.url as celula.celula_name for celula in vm.celulas\"><option value=\"\" disabled=\"\">Seleccione {{moduleName}}</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.openModalCelulaContractor()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"campo_agrupacion\"><label for=\"sucursal\">Agrupación</label><select class=\"form-control\" name=\"agrupacion\" ng-model=\"vm.editForm.grouping_level\" ng-change=\"changeAgrupacion2(vm.editForm.grouping_level)\" ng-options=\"agrupaciones.description for agrupaciones in vm.agrupaciones track by agrupaciones.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.editForm.grouping_level && campo_agrupacion\"><label for=\"sucursal\">Subagrupación</label><div class=\"input-group\"><select class=\"form-control\" name=\"subagrupacion\" ng-model=\"vm.editForm.subagrupaciones\" ng-change=\"changeSubagrupacion2(vm.editForm.subagrupaciones)\" ng-options=\"agrupaciones.description for agrupaciones in sub_asignaciones track by agrupaciones.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalAsignacion(2,vm.editForm.grouping_level)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.editForm.subagrupaciones\"><label for=\"sucursal\">Subsubagrupación</label><div class=\"input-group\"><select class=\"form-control\" name=\"subsubagrupacion\" ng-model=\"vm.editForm.subsubasignaciones\" ng-change=\"changeSubsubagrupacion2(vm.editForm.subsubasignaciones)\" ng-options=\"grupo.description for grupo in sub_subasignaciones track by grupo.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalAsignacion(3,vm.editForm.subagrupaciones)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"sucursal\">Clasificación</label><div class=\"input-group\"><select class=\"form-control\" name=\"clasification\" ng-model=\"vm.form.classification\" ng-change=\"sucursal(vm.form.clasification)\" ng-options=\"clasification.url as clasification.classification_name for clasification in vm.clasifications\"><option value=\"\" disabled=\"\">Seleccione una clasificación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.openModalClasification()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div ng-if=\"vm.responsables.length >0\" class=\"col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.responsable.$invalid && !form.responsable.$pristine }\"><label for=\"responsable\">Responsable<span class=\"color-red\">*</span></label><div><select class=\"form-control m-b\" name=\"responsable\" ng-model=\"vm.form.responsable\" ng-change=\"changeResponsable(vm.form.responsable)\" ng-options=\"responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables track by responsable.id\"><option value=\"\">Seleccione un responsable</option></select></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.form.resp_contractor\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteResponsable($index, 1)\" ng-disabled=\"vm.form.resp_contractor.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b\" ng-model=\"item.responsable\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 0\">Elige el área <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.form.resp_contractor[$index].resp_type = 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión</a></li><li><a ng-click=\"vm.form.resp_contractor[$index].resp_type = 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo</a></li><li><a ng-click=\"vm.form.resp_contractor[$index].resp_type = 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial</a></li><li><a ng-click=\"vm.form.resp_contractor[$index].resp_type = 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza</a></li><li><a ng-click=\"vm.form.resp_contractor[$index].resp_type = 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros</a></li></ul><button class=\"btn btn-success\" ng-click=\"addResponsable(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Obligado(s) Solidario(s) (Fianzas)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.form.obligados\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteObligados($index, 1)\" ng-disabled=\"vm.form.obligados.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><div id=\"item[$index]\"><pre>{{item}}</pre><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"item\" change=\"matchesContractors(item.val)\"></autocomplete></div><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addObligados(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.form.obligados\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteObligados($index, 1)\" ng-disabled=\"vm.form.obligados.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><div id=\"item[$index]\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"item\" change=\"matchesContractors(item.val)\"></autocomplete></div><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addObligados(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group m-t\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"vm.form.vip\"> <span>VIP</span></h3></div><div><input type=\"hidden\" name=\"type_person\" ng-model=\"vm.form.type\" value=\"\"></div><div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Información de contacto</legend></div><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.form.contact_natural.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"vm.form.contact_natural.length == 0\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"vm.form.contact_natural.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contactos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact(1)\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"contact in vm.form.contact_natural track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteContacts($index, 1, contact)\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts($index, 1, contact)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contacto #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact(1)\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"contact.name\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" type=\"search\" lowercase=\"\" ng-model=\"contact.email\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Teléfono</label><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone_number\"></phonenumber-directive></div></div></div></div></div></form></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/upload.html\'\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div class=\"col-xs-12 col-sm-4 col-md-3 pull-right form-group\"><button class=\"col-xs-12 btn btn-primary\" ng-if=\"vm.permiso_administrar_adjuntos\" type=\"button\" ng-click=\"vm.uploadImages()\">Subir archivos</button></div><div ng-include=\"\'templates/show-files.html\'\"></div></div></div></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"vm.save()\" ng-if=\"vm.user.permiso.editar\">Guardar cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></div>");
$templateCache.put("app/contratantes/contratantes.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-lg-9\"><h2>Contratantes</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Contratantes</strong></li></ol></div></div><div class=\"row wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div id=\"addContratantes\" class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><uib-tabset template-url=\"app/contratantes/contratantes.tabset.html\" active=\"activeJustified\" justified=\"true\"><uib-tab template-url=\"app/contratantes/contratantes.tab.html\" index=\"0\" heading=\"Fisicas\" ng-click=\"type(1)\"><div class=\"ibox-content\" natural-contractors=\"\"></div></uib-tab><uib-tab template-url=\"app/contratantes/contratantes.tab.html\" index=\"1\" heading=\"Morales\" ng-click=\"type(2)\"><div class=\"ibox-content\" juridical-contractors=\"\"></div></uib-tab></uib-tabset></div></div></div></div></div>");
$templateCache.put("app/contratantes/contratantes.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-lg-9\"><button ng-if=\"last_state_visited\" class=\"btn btn-primary\" style=\"margin-top:10px ;border-radius: 100%;\" ng-click=\"goBack()\"><i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i></button><h2>Contratantes</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"contratantes.main\">Contratantes</a></li><li class=\"active\"><strong>Información</strong></li></ol></div></div><div class=\"row wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pull-right option_button m-b\"><div class=\"btn-group\" ng-if=\"vm.form.url\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_adm_pol\"><a ng-click=\"goToQuotation(vm.form)\">Crear cotización</a></li><li ng-if=\"vm.acceso_adm_pol\"><a ng-click=\"goToPolicyNueva(vm.form)\">Crear OT/Póliza</a></li><li ng-if=\"vm.acceso_adm_fia\"><a ng-click=\"goToSurety(vm.form)\">Crear Fianza</a></li><li ng-if=\"vm.acceso_ver_pol || vm.acceso_adm_fia || vm.acceso_ver_fia\"><a ng-click=\"vm.verPolizas(vm.form, 0,0)\">Ver pólizas/fianzas</a></li><li ng-if=\"vm.acceso_ver_cob || vm.acceso_ver_pol || vm.acceso_adm_fia || vm.acceso_ver_fia\"><a ng-click=\"vm.verCobranza(vm.form, 1)\">Ver cobranza</a></li><li ng-if=\"vm.acceso_adm_cont\"><a ng-click=\"vm.goToContractorEdit(vm.form)\">Editar</a></li><li ng-if=\"vm.acceso_adm_cont\"><a ng-click=\"vm.deleteContractor(vm.form.id, 2, natural)\">Eliminar</a></li><li><a ng-click=\"vm.getPDFEdo(vm.form)\">Ver Edo.cuenta</a></li><li class=\"dropdown-submenu\" ng-if=\"vm.files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"vm.files\" ng-repeat=\"file in vm.files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li></ul></div><div class=\"btn-group\" ng-if=\"vm.juridicalForm.url\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_adm_pol\"><a ng-click=\"goToQuotation(vm.juridicalForm)\">Crear cotización</a></li><li ng-if=\"vm.acceso_adm_pol\"><a ng-click=\"goToPolicyNueva(vm.juridicalForm)\">Crear OT/Póliza</a></li><li ng-if=\"vm.acceso_adm_fia\"><a ng-click=\"goToSurety(vm.juridicalForm)\">Crear Fianza</a></li><li ng-if=\"vm.acceso_ver_pol || vm.acceso_adm_fia || vm.acceso_ver_fia\"><a ng-click=\"vm.verPolizas(vm.juridicalForm, 0,0)\">Ver pólizas/fianzas</a></li><li ng-if=\"vm.acceso_ver_cob || vm.acceso_ver_pol || vm.acceso_adm_fia || vm.acceso_ver_fia\"><a ng-click=\"vm.verCobranza(vm.juridicalForm, 1)\">Ver cobranza</a></li><li ng-if=\"vm.acceso_adm_sin\"><a ng-click=\"vm.verSiniestros(vm.juridicalForm, 1, 2)\">Ver siniestros</a></li><li ng-if=\"vm.acceso_adm_cont\"><a ng-click=\"vm.goToContractorEdit(vm.juridicalForm)\">Editar</a></li><li ng-if=\"vm.acceso_adm_cont\"><a ng-click=\"vm.deleteContractor(vm.juridicalForm.id, 1, moral)\">Eliminar</a></li><li><a ng-click=\"vm.getPDFEdo(vm.juridicalForm)\">Ver Edo.cuenta</a></li><li class=\"dropdown-submenu\" ng-if=\"vm.files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"vm.files\" ng-repeat=\"file in vm.files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li></ul></div></div></div></div><div class=\"ibox float-e-margins animate\" ng-if=\"vm.form.url && vm.showInfo\"><div class=\"ibox-title\"><h5>Información del contratante</h5><button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"$event.stopPropagation();vm.createRecordatorio(vm.form,2)\"><i class=\"fa fa-clock-o\"></i></button> <button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><legend class=\"legend-title\" align=\"center\">Datos personales</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{vm.form.first_name}} {{vm.form.last_name}} {{vm.form.second_last_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ vm.form.birth_date.replace(\'Z\', \'\') | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">RFC:</span><div><span>{{vm.form.rfc}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Género:</span><div><span ng-if=\"vm.form.sex== \'F\'\">FEMENINO</span> <span ng-if=\"vm.form.sex== \'M\'\">MASCULINO</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Grupo:</span><div><span>{{vm.form.group.group_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.group.subgroup_name\"><span class=\"blue-color\">Subgrupo:</span><div><span>{{vm.form.group.subgroup_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.group.subsubgroup_name\"><span class=\"blue-color\">Subsubgrupo:</span><div><span>{{vm.form.group.subsubgroup_name}}</span></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6 col-sm-6 text-center\"><span class=\"blue-color\">Correo Electrónico:</span><div ng-if=\"vm.form.email\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> <span>{{vm.form.email}}</span></div><div ng-repeat=\"email in vm.form.email_natural\"><span ng-if=\"email.email_type == 1\" class=\"fa fa-user\" aria-hidden=\"true\"></span> <span ng-if=\"email.email_type == 2\" class=\"fa fa-building\" aria-hidden=\"true\"></span> <span ng-if=\"email.email_type == 3\" class=\"fa fa-at\" aria-hidden=\"true\"></span> <span>{{email.correo}}</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-6 text-center\"><span class=\"blue-color\">Teléfono:</span><div ng-if=\"vm.form.phone_number\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> <span>{{vm.form.phone_number | phonenumber}}</span></div><div ng-repeat=\"phone_number in vm.form.phone_natural\"><span ng-if=\"phone_number.phone_type == 1\" class=\"fa fa-home\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 2\" class=\"fa fa-building\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 3\" class=\"fa fa-mobile\" aria-hidden=\"true\"></span> <span>{{phone_number.phone | phonenumber}}</span></div><div ng-if=\"vm.form.phone_mensajeria\"><br><span class=\"blue-color\">WhatsApp/SMS</span><br><span class=\"fa fa-whatsapp\" aria-hidden=\"true\"></span> <span>{{vm.form.phone_mensajeria}}</span></div></div></div><div class=\"col-xs-12 form-group\"><input type=\"checkbox\" name=\"\" ng-change=\"change_vip(vm.form.url, vm.form.vip)\" ng-model=\"vm.form.vip\"> <span class=\"blue-color\">VIP</span></div><br><div class=\"row\"><div class=\"col-xs-12 col-md-6 col-sm-6 form-group\"><span class=\"blue-color\">Baja</span> <input type=\"checkbox\" name=\"\" ng-change=\"changeBaja(\'\',vm.form.baja,\'\')\" ng-model=\"vm.form.baja\"></div><div class=\"col-xs-12 col-md-6 col-sm-6 form-group\" ng-if=\"vm.form.baja\"><div><span class=\"blue-color\">Motivo de Baja:</span> <input type=\"text\" class=\"form-control\" name=\"\" ng-model=\"vm.form.motivo_baja\" ng-disabled=\"!saveBaja\"></div></div><div ng-click=\"$event.stopPropagation();\" class=\"pull-right\" ng-if=\"saveBaja\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation();changeBaja(vm.form.url, vm.form.baja, vm.form.motivo_baja)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i></a></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"infoFisicoc.classification_name\"><span class=\"blue-color\">Clasificación:</span><div><span>{{infoFisicoc.classification_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"infoFisicocel.celula_name && campo_celula\"><span class=\"blue-color\">{{moduleName}}:</span><div><span>{{infoFisicocel.celula_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.grouping_level.group_name && campo_agrupacion\"><span class=\"blue-color\">Nivel Agrupación:</span><div><span>{{vm.form.grouping_level.group_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.grouping_level.subgroup_name && campo_agrupacion\"><span class=\"blue-color\">Nivel Subagrupación:</span><div><span>{{vm.form.grouping_level.subgroup_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.grouping_level.subsubgroup_name && campo_agrupacion\"><span class=\"blue-color\">Nivel Subsubagrupación:</span><div><span>{{vm.form.grouping_level.subsubgroup_name}}</span></div></div><div ng-if=\"vm.form.only_sureties\" class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\"><b>Tipo de contratante:</b></span><div><span><u>Solo para fianzas</u></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><span class=\"blue-color\"><b>Sucursal</b>:</span><div><span>{{vm.form.sucursal.sucursal_name}}</span></div></div><br><div ng-if=\"vm.form.vendor && vm.verReferenciadores\" class=\"col-xs-12 col-sm-6 col-md-3\"><span class=\"blue-color\"><b>Referenciador</b>:</span><div><span>{{vm.form.vendor.first_name}} {{vm.form.vendor.last_name}}</span></div></div><br><div ng-if=\"vm.form.resp_contractor\" class=\"col-xs-12 col-sm-6 col-md-6\"><span class=\"blue-color\"><i class=\"fa fa-star yellow\"></i><b>Responsables</b>:</span><div ng-if=\"vm.form.resp_contractor && vm.form.resp_contractor.length >0\" class=\"col-xs-12\" ng-repeat=\"resp in vm.form.resp_contractor\"><span>{{resp.responsable_name}}</span></div></div><br><div ng-if=\"vm.form.responsable\" class=\"col-xs-12 col-sm-6 col-md-3\"><span class=\"blue-color\"><i class=\"fa fa-star yellow\"></i><b>Responsable</b>:</span><div><span>{{vm.form.responsable.first_name}} {{vm.form.responsable.last_name}}</span></div></div><br><br><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><span class=\"blue-color\"><b>Antigüedad:</b></span><div><span>{{ vm.form.antiguedad }} días</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><span class=\"blue-color\">Obligado(s) Solidario(s):</span><div class=\"row\" ng-repeat=\"sols in solidarios\"><span align=\"center\">{{ sols.full_name }}</span></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"row\" ng-repeat=\"address in vm.form.address_natural\"><legend class=\"legend-title\" align=\"center\">Dirección #{{ $index + 1 }}</legend><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Calle:</span><div><span>{{address.route}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Número Ext.:</span><div><span>{{address.street_number}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div ng-if=\"address.street_number_int\" class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Número Int.:</span><div><span>{{address.street_number_int}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Colonia:</span><div><span>{{address.sublocality}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Municipio:</span><div><span ng-if=\"!address.administrative_area_level_2.state\">{{address.administrative_area_level_2}}</span> <span ng-if=\"address.administrative_area_level_2.city != null\">{{address.administrative_area_level_2.city}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Estado:</span><div><span ng-if=\"!address.administrative_area_level_1.state\">{{address.administrative_area_level_1}}</span> <span ng-if=\"address.administrative_area_level_1.state != null\">{{address.administrative_area_level_1.state}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Código Postal:</span><div><span>{{address.postal_code}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Tipo de dirección:</span><div><span ng-if=\"address.tipo.name\">{{address.tipo.name}}</span> <span ng-if=\"address.tipo && !address.tipo.name\">{{address.tipo}}</span></div></div><div ng-if=\"address.details\" class=\"col-xs-12 form-group\"><span class=\"blue-color\">Referencia:</span><div><span>{{address.details}}</span></div></div></div></div></div><div class=\"row\" ng-if=\"vm.form && vm.showInfo\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Documentos</legend><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Identificación Oficial:</span><div><span ng-if=\"vm.form.card_official_identification\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.card_official_identification\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">CURP:</span><div><span ng-if=\"vm.form.CURP\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.CURP\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Comprobante de Inscripción de Firma Electrónica:</span><div><span ng-if=\"vm.form.voucher_efirm\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.voucher_efirm\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Comprobante de Domicilio:</span><div><span ng-if=\"vm.form.voucher_of_address\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.voucher_of_address\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Formato de Identificación de Cliente Firmado:</span><div><span ng-if=\"vm.form.signed_format_ic\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.signed_format_ic\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\" ng-if=\"vm.org_name !=\'ancora\'\"><span class=\"blue-color\">Poder:</span><div><span ng-if=\"vm.form.fiscal_power\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.fiscal_power\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\" ng-if=\"vm.org_name !=\'ancora\'\"><span class=\"blue-color\">Constancia Situación Fiscal:</span><div><span ng-if=\"vm.form.constancia_situacion_fiscal\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.constancia_situacion_fiscal\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div ng-if=\"vm.form.only_sureties\"><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Carta nombramiento:</span><div><span ng-if=\"vm.form.carta_nombramiento\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.carta_nombramiento\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Currículo:</span><div><span ng-if=\"vm.form.curriculo\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.curriculo\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Contrato multiple de la afianzadora:</span><div><span ng-if=\"vm.form.contrato_multiple_afianzadora\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.contrato_multiple_afianzadora\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Carta buro:</span><div><span ng-if=\"vm.form.carta_buro\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.carta_buro\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Entrevista con la afianzadora:</span><div><span ng-if=\"vm.form.entrevista_afianzadora\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.entrevista_afianzadora\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Constancia Situación Fiscal:</span><div><span ng-if=\"vm.form.rfc_document\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.rfc_document\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Alta ante hacienda o alta electrónica:</span><div><span ng-if=\"vm.form.alta_hacienda\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.alta_hacienda\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Recibos de nómina:</span><div><span ng-if=\"vm.form.recibos_nomina\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.recibos_nomina\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Declaración anual completa con cadena de los últimos dos años inmediatos anteriores:</span><div><span ng-if=\"vm.form.declaracion_anual\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.declaracion_anual\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Estados financieros anuales del año inmediato anterior:</span><div><span ng-if=\"vm.form.estados_financieros_anuales\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.estados_financieros_anuales\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años:</span><div><span ng-if=\"vm.form.estados_financieros_parciales\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.estados_financieros_parciales\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Escritura de inmueble</span><div><span ng-if=\"vm.form.escritura_inmueble\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.escritura_inmueble\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Boleta parcial o avaluó</span><div><span ng-if=\"vm.form.boleta_predial\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.boleta_predial\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Certificado de libertad de gravamen</span><div><span ng-if=\"vm.form.certificado_gravamen\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.certificado_gravamen\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div></div></div><div class=\"col-xs-12 col-md-6\" ng-if=\"vm.form.contact_natural.length > 0\"><legend class=\"legend-title\" align=\"center\">Contacto</legend><div class=\"col-xs-12 form-group\"><div class=\"row\"><div class=\"col-xs-6\" ng-repeat=\"contact in vm.form.contact_natural track by $index\"><legend class=\"legend-title\" align=\"center\">Contacto #{{ $index + 1 }}</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{contact.name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{contact.email}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Téléfono:</span><div><span>{{contact.phone_number | phonenumber}}</span></div></div></div></div></div></div></div><hr><div class=\"col-xs-12 m-b\" ng-if=\"!vm.notasFlag && !vm.recordatoriosFlag\"><table><tr><td><div class=\"\"><button type=\"button\" class=\"btn btn-info m-r-sm\" ng-click=\"vm.showNotas()\" ng-disabled=\"vm.notas.length == 0\">{{vm.notas.length}}</button> <a>Notas de crédito</a></div></td><td><div class=\"\" ng-if=\"vm.form\"><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"vm.showRecordatorios()\">{{vm.form.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div></td></tr></table><br><div class=\"col-xs-12 form-group\" style=\"margin-bottom: 40px;\"><h4>Observaciones:</h4><textarea disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.form.description\"></textarea></div></div><div class=\"ibox float-e-margins animate\" ng-if=\"vm.notasFlag\"><div class=\"ibox-title\"><h5>Notas de crédito</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"col-xs-12 col-sm-4 col-md-3 btn btn-info m-b\" ng-click=\"vm.notasFlag = false\"><span class=\"fa fa-arrow-left\"></span> Regresar</button><table class=\"table\"><thead><th>Folio</th><th>Número de póliza</th><th>Número de endoso</th><th>Fecha de emisión</th><th>Prima total</th><th>Estatus</th></thead><tr ng-repeat=\"nota in vm.notas\" ng-click=\"vm.NotasModal(nota)\"><td>{{nota.folio}}</td><td>{{nota.disease_endorsement.policy.poliza_number}} {{nota.damages_endorsement.policy.poliza_number}} {{nota.auto_endorsement.policy.poliza_number}} {{nota.life_endorsement.policy.poliza_number}}</td><td>{{nota.disease_endorsement.number_endorsement}} {{nota.damages_endorsement.number_endorsement}} {{nota.auto_endorsement.number_endorsement}} {{nota.life_endorsement.number_endorsement}}</td><td>{{nota.fecha_emision | date:\'dd/MM/yyyy\': \'UTC\'}}</td><td>{{nota.prima_total}}</td><td ng-if=\"nota.status == 1\">Pendiente</td><td ng-if=\"nota.status == 2\">Cerrada</td></tr></table></div></div></div></div><div class=\"ibox float-e-margins animate\" ng-if=\"vm.juridicalForm.url && vm.showInfo\"><div class=\"ibox-title\"><h5>Información del contratante</h5><button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"$event.stopPropagation();vm.createRecordatorio(vm.juridicalForm,2)\"><i class=\"fa fa-clock-o\"></i></button> <button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><legend class=\"legend-title\" align=\"center\">Datos personales</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{vm.juridicalForm.full_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Constitución:</span><div><span>{{ vm.juridicalForm.birth_date.replace(\'Z\', \'\') | date: \'dd/MM/yyyy\': \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">RFC:</span><div><span>{{vm.juridicalForm.rfc}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Grupo:</span><div><span>{{vm.juridicalForm.group.group_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.juridicalForm.group.subgroup_name\"><span class=\"blue-color\">Subgrupo:</span><div><span>{{vm.juridicalForm.group.subgroup_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.juridicalForm.group.subsubgroup_name\"><span class=\"blue-color\">Subsubgrupo:</span><div><span>{{vm.juridicalForm.group.subsubgroup_name}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"vm.juridicalForm.email\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> <span>{{vm.juridicalForm.email}}</span></div><div class=\"col-xs-12 col-sm-6\" ng-repeat=\"email in vm.juridicalForm.email_juridical\"><span ng-if=\"email.email_type == 1\" class=\"fa fa-user\" aria-hidden=\"true\"></span> <span ng-if=\"email.email_type == 2\" class=\"fa fa-building\" aria-hidden=\"true\"></span> <span ng-if=\"email.email_type == 3\" class=\"fa fa-at\" aria-hidden=\"true\"></span> <span>{{email.correo}}<br></span></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Teléfono:</span><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"vm.juridicalForm.phone_number\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> <span>{{vm.juridicalForm.phone_number | phonenumber}}</span></div><div class=\"col-xs-12\" ng-repeat=\"phone_number in vm.juridicalForm.phone_juridical\"><span ng-if=\"phone_number.phone_type == 1\" class=\"fa fa-home\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 2\" class=\"fa fa-building\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 3\" class=\"fa fa-mobile\" aria-hidden=\"true\"></span> <span>{{phone_number.phone | phonenumber}}</span></div><div class=\"col-xs-12\" ng-if=\"vm.juridicalForm.phone_mensajeria\"><br><span class=\"blue-color\">WhatsApp/SMS</span><br><span class=\"fa fa-whatsapp\" aria-hidden=\"true\"></span> <span>{{vm.juridicalForm.phone_mensajeria}}</span></div></div></div><div class=\"col-xs-12 form-group\"><input type=\"checkbox\" name=\"\" ng-change=\"change_vip(vm.juridicalForm.url, vm.juridicalForm.vip)\" ng-model=\"vm.juridicalForm.vip\"> <span class=\"blue-color\">VIP</span></div><div class=\"row\"><div class=\"col-xs-12 col-md-6 col-sm-6 form-group\"><span class=\"blue-color\">Baja</span> <input type=\"checkbox\" name=\"\" ng-change=\"changeBaja(\'\',vm.juridicalForm.baja,\'\')\" ng-model=\"vm.juridicalForm.baja\"></div><div class=\"col-xs-12 col-md-6 col-sm-6 form-group\" ng-if=\"vm.juridicalForm.baja\"><div><span class=\"blue-color\">Motivo de Baja:</span> <input type=\"text\" class=\"form-control\" name=\"\" ng-model=\"vm.juridicalForm.motivo_baja\" ng-disabled=\"!saveBaja\"></div></div><div ng-click=\"$event.stopPropagation();\" class=\"pull-right\" ng-if=\"saveBaja\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation();changeBaja(vm.juridicalForm.url, vm.juridicalForm.baja, vm.juridicalForm.motivo_baja)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i></a></div></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><span class=\"blue-color\"><b>Sucursal</b>:</span><div><span>{{vm.juridicalForm.sucursal.sucursal_name}}</span></div></div><br><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"infoMoralc.classification_name\"><span class=\"blue-color\">Clasificación:</span><div><span>{{infoMoralc.classification_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"infoMoralcel.celula_name && campo_celula\"><span class=\"blue-color\">{{moduleName}}:</span><div><span>{{infoMoralcel.celula_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.juridicalForm.grouping_level.group_name && campo_agrupacion\"><span class=\"blue-color\">Nivel Agrupación:</span><div><span>{{vm.juridicalForm.grouping_level.group_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.juridicalForm.grouping_level.subgroup_namee && campo_agrupacion\"><span class=\"blue-color\">Nivel Subagrupación:</span><div><span>{{vm.juridicalForm.grouping_level.subgroup_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.juridicalForm.grouping_level.subsubgroup_namee && campo_agrupacion\"><span class=\"blue-color\">Nivel Subsubagrupación:</span><div><span>{{vm.juridicalForm.grouping_level.subsubgroup_name}}</span></div></div><div ng-if=\"vm.juridicalForm.vendor && vm.verReferenciadores\" class=\"col-xs-12 col-sm-6 col-md-3\"><span class=\"blue-color\"><b>Referenciador</b>:</span><div><span>{{vm.juridicalForm.vendor.first_name}} {{vm.juridicalForm.vendor.last_name}}</span></div></div><div ng-if=\"vm.juridicalForm.responsable\" class=\"col-xs-12 col-sm-6 col-md-3\"><span class=\"blue-color\"><i class=\"fa fa-star yellow\"></i><b>Responsable</b>:</span> <span>{{vm.juridicalForm.responsable.first_name}} {{vm.juridicalForm.responsable.last_name}}</span></div><div ng-if=\"vm.juridicalForm.resp_contractor\" class=\"col-xs-12 col-sm-6 col-md-6\"><span class=\"blue-color\"><i class=\"fa fa-star yellow\"></i><b>Responsables</b>:</span><div class=\"col-xs-12\" ng-repeat=\"resp in vm.juridicalForm.resp_contractor\"><span>{{resp.responsable_name}}</span></div></div><br><div ng-if=\"vm.juridicalForm.only_sureties\" class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Tipo de contratante:</span><div><span>Solo para fianzas</span></div></div><br><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\"><b>Antigüedad:</b></span><div><span>{{vm.juridicalForm.antiguedad }} días</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><span class=\"blue-color\">Obligado(s) Solidario(s):</span><div class=\"row\" ng-repeat=\"sols in solidarios\"><span align=\"center\">{{ sols.full_name }}</span></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"row\" ng-repeat=\"address in vm.juridicalForm.address_juridical\"><legend class=\"legend-title\" align=\"center\">Direccion #{{ $index + 1 }}</legend><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Calle:</span><div><span>{{address.route}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Número Ext.:</span><div><span>{{address.street_number}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div ng-if=\"address.street_number_int\" class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Número Int.:</span><div><span>{{address.street_number_int}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Colonia:</span><div><span>{{address.sublocality}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Municipio:</span><div><span ng-if=\"!address.administrative_area_level_2.state\">{{address.administrative_area_level_2}}</span> <span ng-if=\"address.administrative_area_level_2.city != null\">{{address.administrative_area_level_2.city}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Estado:</span><div><span ng-if=\"!address.administrative_area_level_1.state\">{{address.administrative_area_level_1}}</span> <span ng-if=\"address.administrative_area_level_1.state != null\">{{address.administrative_area_level_1.state}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Código Postal:</span><div><span>{{address.postal_code}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Tipo de dirección:</span><div><span ng-if=\"address.tipo.name\">{{address.tipo.name}}</span> <span ng-if=\"address.tipo && !address.tipo.name\">{{address.tipo}}</span></div></div><div ng-if=\"!address.street_number_int\" class=\"col-xs-12 form-group\"><span class=\"blue-color\">Referencia:</span><div><span>{{address.details}}</span></div></div><div ng-if=\"address.street_number_int\" class=\"col-xs-12 form-group\"><span class=\"blue-color\">Referencia:</span><div><span>{{address.details}}</span></div></div></div></div></div><div class=\"row\" ng-if=\"vm.juridicalForm && vm.showInfo\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Documentos</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Acta Constitutiva:</span><div><span ng-if=\"vm.juridicalForm.constitutive_act\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.constitutive_act\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Constancia Situación Fiscal:</span><div><span ng-if=\"vm.juridicalForm.rfc_document\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.rfc_document\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Cédula de Identificación Fiscal:</span><div><span ng-if=\"vm.juridicalForm.card_official_identification\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.card_official_identification\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div ng-if=\"vm.form.only_sureties\"></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Comprobante de Domicilio Fiscal:</span><div><span ng-if=\"vm.juridicalForm.voucher_of_address\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.voucher_of_address\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Modificaciones al Acta Constitutiva:</span><div><span ng-if=\"vm.juridicalForm.modifications_constitutive_act\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.modifications_constitutive_act\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Poder:</span><div><span ng-if=\"vm.juridicalForm.fiscal_power\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.fiscal_power\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">INE Representante Legal:</span><div><span ng-if=\"vm.juridicalForm.ine_representante\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.ine_representante\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div ng-if=\"vm.juridicalForm.only_sureties\"><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Currículo reciente:</span><div><span ng-if=\"vm.juridicalForm.curriculo\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.curriculo\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Contrato multiple de la afianzadora:</span><div><span ng-if=\"vm.juridicalForm.contrato_multiple_afianzadora\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.contrato_multiple_afianzadora\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Carta Buró:</span><div><span ng-if=\"vm.juridicalForm.carta_buro\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.carta_buro\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Cuestionario o entrevista:</span><div><span ng-if=\"vm.juridicalForm.entrevista_afianzadora\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.entrevista_afianzadora\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Aviso de privacidad de la afianzadora:</span><div><span ng-if=\"vm.juridicalForm.aviso_privacidad\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.aviso_privacidad\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Protocolizaciones:</span><div><span ng-if=\"vm.juridicalForm.protocolizaciones\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.protocolizaciones\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Alta empresa ante hacienda:</span><div><span ng-if=\"vm.juridicalForm.alta_hacienda\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.alta_hacienda\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Cambio de domicilio ante hacienda:</span><div><span ng-if=\"vm.juridicalForm.cambio_domicilio_hacienda\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.cambio_domicilio_hacienda\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Copia del comprobante de inscripción para la e.firma (firma electrónica):</span><div><span ng-if=\"vm.juridicalForm.voucher_efirm\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.voucher_efirm\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Declaración anual completa con cadena, de los últimos dos años:</span><div><span ng-if=\"vm.juridicalForm.declaracion_anual\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.declaracion_anual\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Estados financieros dictaminados cuadernillo completo, del año inmediato anterior:</span><div><span ng-if=\"vm.juridicalForm.estados_financieros_anuales\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.estados_financieros_anuales\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Estados financieros parciales los más recientes de este año con no mayor antigüedad de dos meses:</span><div><span ng-if=\"vm.juridicalForm.estados_financieros_parciales\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.juridicalForm.estados_financieros_parciales\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div></div></div><div class=\"col-xs-12 col-md-6\" ng-if=\"vm.juridicalForm.contact_juridical.length > 0\"><legend class=\"legend-title\" align=\"center\">Contacto</legend><div class=\"col-xs-12 form-group\"><div class=\"row\"><div class=\"col-xs-6\" ng-repeat=\"contact in vm.juridicalForm.contact_juridical track by $index\"><legend class=\"legend-title\" align=\"center\">Contacto #{{ $index + 1 }}</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{contact.name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{contact.email}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Téléfono:</span><div><span>{{contact.phone_number | phonenumber}}</span></div></div></div></div></div></div></div><div class=\"col-xs-12 form-group\" style=\"margin-bottom: 40px;\"><h4>Observaciones:</h4><textarea disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.juridicalForm.description\"></textarea></div><div class=\"\" ng-if=\"vm.juridicalForm\"><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"vm.showRecordatorios()\">{{vm.juridicalForm.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"vm.recordatoriosFlag && vm.form\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"vm.recordatoriosFlag = false; vm.infoFlag = true\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in vm.form.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"vm.recordatoriosFlag && vm.juridicalForm\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"vm.recordatoriosFlag = false; vm.infoFlag = true\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in vm.juridicalForm.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div class=\"ibox float-e-margins animate\" ng-if=\"vm.cobranza\"><div class=\"ibox-title\"><h5>Cobranza</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"col-xs-12 col-sm-4 col-md-3 btn btn-info\" ng-click=\"vm.showInfo = true; vm.cobranza = false\"><span class=\"fa fa-arrow-left\"></span> Regresar</button><br><div class=\"row\"><div class=\"results-container visible-xs-block visible-sm-block\"><div class=\"results-links\"><div class=\"col-xs-12\"><a class=\"col-xs-12 btn btn-default\" ng-click=\"vm.verCobranza(vm.form ? vm.form : vm.juridicalForm , 1);vm.showPendientes();\">Pendientes</a></div><div class=\"col-xs-12\"><a class=\"col-xs-12 btn btn-default\" ng-click=\"vm.verCobranza(vm.form ? vm.form : vm.juridicalForm, 2);vm.showPagados();\">Pagados</a></div><div class=\"col-xs-12\"><a class=\"col-xs-12 btn btn-default\" ng-click=\"vm.verCobranza(vm.form ? vm.form : vm.juridicalForm, 3);vm.showLiquidados();\">Liquidados</a></div><div class=\"col-xs-12\"><a class=\"col-xs-12 btn btn-default\" ng-click=\"vm.verCobranza(vm.form ? vm.form : vm.juridicalForm, 4);vm.showCancelados();\">Cancelados</a></div></div><div class=\"results-content-container\"><div class=\"col-xs-12 panel-body\" ng-show=\"vm.cPendientes\"><legend class=\"col-xs-12 legend-title visible-xs-block visible-sm-block\" align=\"center\">Pendientes</legend><div class=\"results-content\"><div class=\"ibox float-e-margins border-bottom\" ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"(receipt.status == 4 || receipt.status == 3) && receipt.isCopy == false && receipt.isActive == true\"><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 1\"><h5>Póliza: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 2\"><h5>Endoso: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 3\"><h5>Nota Crédito: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ui-sref=\"polizas.info({polizaId: insurance.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6 form-group\" ng-if=\"receipt.receipt_type == 1\"><label>Tipo</label><p>Póliza/Fianza</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\" ng-if=\"receipt.receipt_type == 2\"><label>Tipo</label><p>Endoso</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Contratante</label><p>{{receipt.poliza.contractor.full_name}}</p><br><small ng-if=\"receipt.poliza.contractor.type_person ==1 || receipt.poliza.contractor.type_person ==\'Física\'\">Persona Fisica</small> <small ng-if=\"receipt.poliza.contractor.type_person ==2 || receipt.poliza.contractor.type_person ==\'Moral\'\">Persona Moral</small></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label ng-if=\"receipt.receipt_type == 1\">Póliza</label> <label ng-if=\"receipt.receipt_type == 2\">Endoso</label><p>#{{ receipt.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Período</label><p><span>Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\': \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\': \'UTC\'}}</span></p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Aseguradora/Afianzadora</label><p>{{ receipt.poliza.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Estatus</label><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Prima total</label><p>{{ receipt.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Operador</label><p>{{ receipt.owner }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Antigüedad</label><p ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</p><p ng-if=\"!(receipt.antiguedad > 0)\">0 días</p></div><div ng-if=\"vm.show_pag_policy\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div></div></div><div class=\"col-xs-12 panel-body\" ng-show=\"vm.cPagados\"><legend class=\"col-xs-12 legend-title visible-xs-block visible-sm-block\" align=\"center\">Pagados</legend><div class=\"results-content\"><div class=\"ibox float-e-margins border-bottom\" ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.status == 1 && receipt.isCopy == false\"><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 1\"><h5>Póliza: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 2\"><h5>Endoso: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 3\"><h5>Nota Crédito: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ui-sref=\"polizas.info({polizaId: insurance.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6 form-group\" ng-if=\"receipt.receipt_type == 1\"><label>Tipo</label><p>Póliza/Fianzas</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\" ng-if=\"receipt.receipt_type == 3\"><label>Tipo</label><p>Nota de Crédito</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\" ng-if=\"receipt.receipt_type == 2\"><label>Tipo</label><p>Endoso</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Contratante</label><p>{{receipt.poliza.natural.first_name}} {{receipt.poliza.natural.last_name}} {{receipt.poliza.juridical.j_name}}</p><br><small ng-if=\"receipt.poliza.natural\">Persona Fisica</small> <small ng-if=\"receipt.poliza.juridical\">Persona Moral</small></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label ng-if=\"receipt.receipt_type == 1\">Póliza</label> <label ng-if=\"receipt.receipt_type == 2\">Endoso</label><p>#{{ receipt.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Período</label><p><span>Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\': \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\': \'UTC\'}}</span></p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Aseguradora/Afianzadora</label><p>{{ receipt.poliza.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Estatus</label><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Prima total</label><p>{{ receipt.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Operador</label><p>{{ receipt.owner }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Antigüedad</label><p ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</p><p ng-if=\"!(receipt.antiguedad > 0)\">0 días</p></div><div ng-if=\"vm.show_pag_policy\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div></div></div><div class=\"col-xs-12 panel-body\" ng-show=\"vm.cLiquidados\"><legend class=\"col-xs-12 legend-title visible-xs-block visible-sm-block\" align=\"center\">Líquidados</legend><div class=\"results-content\"><div class=\"ibox float-e-margins border-bottom\" ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.status == 5 && receipt.isCopy == false\"><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 1\"><h5>Póliza: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 2\"><h5>Endoso: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 3\"><h5>Nota crédito: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ui-sref=\"polizas.info({polizaId: insurance.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6 form-group\" ng-if=\"receipt.receipt_type == 1\"><label>Tipo</label><p>Póliza</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\" ng-if=\"receipt.receipt_type == 2\"><label>Tipo</label><p>Endoso</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Contratante</label><p>{{receipt.poliza.contractor.full_name}}</p><br><small ng-if=\"receipt.poliza.contractor.type_person ==1 || receipt.poliza.contractor.type_person ==\'Física\'\">Persona Fisica</small> <small ng-if=\"receipt.poliza.contractor.type_person ==2 || receipt.poliza.contractor.type_person ==\'Moral\'\">Persona Moral</small></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label ng-if=\"receipt.receipt_type == 1\">Póliza</label> <label ng-if=\"receipt.receipt_type == 2\">Endoso</label><p>#{{ receipt.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Período</label><p><span>Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\': \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\': \'UTC\'}}</span></p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Aseguradora</label><p>{{ receipt.poliza.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Estatus</label><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Prima total</label><p>{{ receipt.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Operador</label><p>{{ receipt.owner }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Antigüedad</label><p ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</p><p ng-if=\"!(receipt.antiguedad > 0)\">0 días</p></div><div ng-if=\"vm.show_pag_policy\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div></div></div><div class=\"col-xs-12 panel-body\" ng-show=\"vm.cCancelados\"><legend class=\"col-xs-12 legend-title visible-xs-block visible-sm-block\" align=\"center\">Cancelados</legend><div class=\"results-content\"><div class=\"ibox float-e-margins border-bottom\" ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.status == 2 && receipt.isCopy == false\"><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 1\"><h5>Póliza: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 2\"><h5>Endoso: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-title\" ng-if=\"receipt.receipt_type == 3\"><h5>Nota de Crédito: #{{ receipt.poliza.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ui-sref=\"polizas.info({polizaId: insurance.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6 form-group\" ng-if=\"receipt.receipt_type == 1\"><label>Tipo</label><p>Póliza</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\" ng-if=\"receipt.receipt_type == 3\"><label>Tipo</label><p>Nota de Crédito</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\" ng-if=\"receipt.receipt_type == 4\"><label>Tipo</label><p>Bono</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\" ng-if=\"receipt.receipt_type == 2\"><label>Tipo</label><p>Endoso</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Contratante</label><p>{{receipt.poliza.contractor.full_name}}</p><br><small ng-if=\"receipt.poliza.contractor.type_person ==1 || receipt.poliza.contractor.type_person ==\'Física\'\">Persona Fisica</small> <small ng-if=\"receipt.poliza.contractor.type_person ==2 || receipt.poliza.contractor.type_person ==\'Moral\'\">Persona Moral</small></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label ng-if=\"receipt.receipt_type == 1\">Póliza</label> <label ng-if=\"receipt.receipt_type == 2\">Endoso</label><p>#{{ receipt.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Período</label><p><span>Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\': \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\': \'UTC\'}}</span></p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Aseguradora</label><p>{{ receipt.poliza.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Estatus</label><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Prima total</label><p>{{ receipt.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Operador</label><p>{{ receipt.owner }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Antigüedad</label><p ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</p><p ng-if=\"!(receipt.antiguedad > 0)\">0 días</p></div><div ng-if=\"vm.show_pag_policy\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-10 pull-right\" ng-if=\"vm.acceso_rep_cob && (vm.receipts && vm.receipts.length!=0)\"><button ng-click=\"exportData(vm.form ? vm.form : vm.juridicalForm,1)\" class=\"col-xs-12 btn btn-primary ladda-button\">Generar Reporte</button></div></div></div><div class=\"results-container hidden-xs hidden-sm\"><div class=\"col-xs-12\"><div class=\"tabs-container btn-mt\"><uib-tabset><uib-tab heading=\"Pendientes\" id=\"pendientes\" ng-click=\"vm.responsiv();vm.verCobranza(vm.form ? vm.form : vm.juridicalForm, 1)\"><div class=\"panel-body\"><div class=\"table-responsive\"><div class=\"project-list\"><table class=\"table table-bordered table-hover\"><thead><th>Tipo</th><th>Contratante</th><th>Póliza/Fianza</th><th>Periodo</th><th>Aseguradora/Afianzadora</th><th>Estatus</th><th>Prima total</th><th>Operador</th><th>Antigüedad</th></thead><tbody><tr ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"(receipt.status == 4 || receipt.status == 3) && receipt.isCopy == false && receipt.isActive == true\"><td ng-if=\"receipt.receipt_type == 1\">Póliza</td><td ng-if=\"receipt.receipt_type == 2\">Endoso</td><td ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</td><td class=\"project-title\"><span class=\"font-weight-bold\">{{receipt.poliza.contractor.full_name}}</span><br><small ng-if=\"receipt.poliza.contractor.type_person ==1 || receipt.poliza.contractor.type_person ==\'Física\'\">Persona Fisica</small> <small ng-if=\"receipt.poliza.contractor.type_person ==2 || receipt.poliza.contractor.type_person ==\'Moral\'\">Persona Moral</small></td><td class=\"project-title\"><a ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a><br><small>Serie:</small><br><small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\': \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\': \'UTC\'}}</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">Aseguradora: {{ receipt.poliza.aseguradora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}</small></td><td class=\"project-status\"><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></td></tr></tbody></table></div><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.owner }}</td><td ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</td><td ng-if=\"!(receipt.antiguedad > 0)\">0 días</td><div ng-if=\"vm.show_pag_policy\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></uib-tab></uib-tabset></div><uib-tab heading=\"Pagados\" id=\"pagados\" ng-click=\"vm.responsiv();vm.verCobranza(vm.form ? vm.form : vm.juridicalForm, 2)\"><div class=\"panel-body\"><div class=\"table-responsive\"><div class=\"project-list\"><table class=\"table table-bordered table-hover\"><thead><th>Tipo</th><th>Contratante</th><th>Póliza/Fianza</th><th>Periodo</th><th>Aseguradora/Afianzadora</th><th>Estatus</th><th>Prima total</th><th>Operador</th><th>Antigüedad</th></thead><tbody><tr ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.status == 1 && receipt.isCopy == false\"><td ng-if=\"receipt.receipt_type == 1\">Póliza</td><td ng-if=\"receipt.receipt_type == 2\">Endoso</td><td ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</td><td ng-if=\"receipt.receipt_type == 4\">Bono</td><td class=\"project-title\"><span class=\"font-weight-bold\">{{receipt.poliza.contractor.full_name}}</span><br><small ng-if=\"receipt.poliza.contractor.type_person ==1 || receipt.poliza.contractor.type_person ==\'Física\'\">Persona Fisica</small> <small ng-if=\"receipt.poliza.contractor.type_person ==2 || receipt.poliza.contractor.type_person ==\'Moral\'\">Persona Moral</small></td><td class=\"project-title\"><a ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a><br><small>Serie:</small><br><small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\': \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\': \'UTC\'}}</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">Aseguradora: {{ receipt.poliza.aseguradora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}</small></td><td class=\"project-status\"><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></td></tr></tbody></table></div><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.owner }}</td><td ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</td><td ng-if=\"!(receipt.antiguedad > 0)\">0 días</td><div ng-if=\"vm.show_pag_policy\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></uib-tab></div><uib-tab heading=\"Liquidados\" id=\"liquidados\" ng-click=\"vm.responsiv();vm.verCobranza(vm.form ? vm.form : vm.juridicalForm, 3)\"><div class=\"panel-body\"><div class=\"table-responsive\"><div class=\"project-list\"><table class=\"table table-bordered table-hover\"><thead><th>Tipo</th><th>Contratante</th><th>Póliza/Fianza</th><th>Periodo</th><th>Aseguradora/Afianzadora</th><th>Estatus</th><th>Prima total</th><th>Operador</th><th>Antigüedad</th></thead><tbody><tr ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.status == 5 && receipt.isCopy == false\"><td ng-if=\"receipt.receipt_type == 1\">Póliza</td><td ng-if=\"receipt.receipt_type == 2\">Endoso</td><td ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</td><td ng-if=\"receipt.receipt_type == 4\">Bono</td><td class=\"project-title\"><span class=\"font-weight-bold\">{{receipt.poliza.contractor.full_name}}</span><br><small ng-if=\"receipt.poliza.contractor.type_person ==1 || receipt.poliza.contractor.type_person ==\'Física\'\">Persona Fisica</small> <small ng-if=\"receipt.poliza.contractor.type_person ==2 || receipt.poliza.contractor.type_person ==\'Moral\'\">Persona Moral</small></td><td class=\"project-title\"><a ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a><br><small>Serie:</small><br><small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\': \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\': \'UTC\'}}</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">Aseguradora: {{ receipt.poliza.aseguradora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}</small></td><td class=\"project-status\"><div status-receipt-clean=\"{{ receipt.status }}\" class=\"label\" ng-class=\"{\'label-success\': receipt.status == 1, \'label-info\' : receipt.status == 2, \'label-primary\' : receipt.status == 3, \'label-warning\' : receipt.status == 4, \'label-info\' : receipt.status == 5 }\"></div></td><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.owner }}</td><td ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</td><td ng-if=\"!(receipt.antiguedad > 0)\">0 días</td></tr></tbody></table><div ng-if=\"vm.show_pag_policy\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></uib-tab><uib-tab heading=\"Cancelados\" id=\"cancelados\" ng-click=\"vm.responsiv();vm.verCobranza(vm.form ? vm.form : vm.juridicalForm, 4)\"><div class=\"panel-body\"><div class=\"table-responsive\"><div class=\"project-list\"><table class=\"table table-bordered table-hover\"><thead><th>Tipo</th><th>Contratante</th><th>Póliza/Fianza</th><th>Periodo</th><th>Aseguradora/Afianzadora</th><th>Estatus</th><th>Prima total</th><th>Operador</th><th>Antigüedad</th></thead><tbody><tr ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.status == 2 && receipt.isCopy == false\"><td ng-if=\"receipt.receipt_type == 1\">Póliza</td><td ng-if=\"receipt.receipt_type == 2\">Endoso</td><td ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</td><td ng-if=\"receipt.receipt_type == 4\">Bono</td><td class=\"project-title\"><span class=\"font-weight-bold\">{{receipt.poliza.contractor.full_name}}</span><br><small ng-if=\"receipt.poliza.contractor.type_person ==1 || receipt.poliza.contractor.type_person ==\'Física\'\">Persona Fisica</small> <small ng-if=\"receipt.poliza.contractor.type_person ==2 || receipt.poliza.contractor.type_person ==\'Moral\'\">Persona Moral</small></td><td class=\"project-title\"><a ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a><br><small>Serie:</small><br><small>{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\': \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\': \'UTC\'}}</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">Aseguradora: {{ receipt.poliza.aseguradora }}</span><br><small>Subramo: {{ receipt.poliza.subramo }}</small></td><td class=\"project-status\"><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></td></tr></tbody></table></div><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.owner }}</td><td ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</td><td ng-if=\"!(receipt.antiguedad > 0)\">0 días</td><div ng-if=\"vm.show_pag_policy\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></uib-tab></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-10 pull-right\" ng-if=\"vm.acceso_rep_cob && (vm.receipts && vm.receipts.length!=0)\"><button ng-click=\"exportData(vm.form ? vm.form : vm.juridicalForm,1)\" class=\"col-xs-12 btn btn-primary ladda-button\">Generar Reporte</button></div></div></div></div></div><div class=\"ibox float-e-margins animate\" ng-if=\"vm.polizas\"><div class=\"ibox-title\"><h5>Pólizas</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><button class=\"col-xs-12 col-sm-4 col-md-3 btn btn-info margin-bottom-20\" ng-click=\"vm.showInfo = true; vm.polizas = false\"><span class=\"fa fa-arrow-left\"></span> Regresar</button><br></div></div><div class=\"results-content visible-xs-block visible-sm-block\"><div class=\"ibox float-e-margins border-bottom\" ng-repeat=\"insurance in vm.search_results track by $index\" ng-if=\"insurance.document_type == 1\"><div class=\"ibox-title\"><h5>Póliza: #{{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ng-click=\"goToPolicy(insurance,\'Información pólizas\',\'polizas.info\')\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Tipo</label><p>Póliza/Fianza</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Póliza/Fianza</label><p>#{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Contratante</label><p>{{ insurance.contractor.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Aseguradora/Afianzadora</label><p>{{ insurance.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Subramo</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Forma de pago</label><p payment=\"{{insurance.forma_de_pago}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Estatus</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Vigencia</label><p>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Antigüedad</label><p ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</p><p ng-if=\"!(insurance.antiguedad > 0)\">0 días</p></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-10 pull-right\" ng-if=\"vm.acceso_rep_pol && (vm.search_results && vm.search_results.length!=0)\"><button ng-click=\"exportData(vm.form ? vm.form : vm.juridicalForm,2)\" class=\"col-xs-12 btn btn-primary ladda-button\">Generar Reporte</button></div></div></div><div class=\"results-content visible-xs-block visible-sm-block\"><div class=\"ibox float-e-margins border-bottom\" ng-repeat=\"insurance in vm.search_results track by $index\" ng-if=\"insurance.document_type == 3\"><div class=\"ibox-title\"><h5>Colectividad: #{{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ui-sref=\"colectividades.info({polizaId: insurance.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Tipo</label><p>Colectividad</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Póliza/Fianza</label><p>#{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Contratante</label><p>{{ insurance.contractor.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Aseguradora/Afianzadora</label><p>{{ insurance.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Subramo</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Forma de pago</label><p payment=\"{{insurance.forma_de_pago}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Estatus</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Vigencia</label><p>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6 form-group\"><label>Antigüedad</label><p ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</p><p ng-if=\"!(insurance.antiguedad > 0)\">0 días</p></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-10 pull-right\" ng-if=\"vm.acceso_rep_pol && (vm.search_results && vm.search_results.length!=0)\"><button ng-click=\"exportData(vm.form ? vm.form : vm.juridicalForm,2)\" class=\"col-xs-12 btn btn-primary ladda-button\">Generar Reporte</button></div></div></div><div ng-if=\"vm.show_pag_search && vm.search_config.count > 10\" class=\"text-center visible-xs-block visible-sm-block\"><pagination config=\"vm.search_config\" model=\"vm.search_results\"></pagination></div><div class=\"table-responsive hidden-xs hidden-sm\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Tipo</th><th ng-click=\"vm.changePoliza(1, vm.pol_number_asc == 1 ? 2 : 1)\">Póliza/Fianza <span ng-class=\"{\'fa fa-sort-desc\': vm.pol_number_asc == 1, \'fa fa-sort-asc\': vm.pol_number_asc == 2}\"></span></th><th>Contratante</th><th ng-click=\"vm.changePoliza(2, vm.aseguradora_asc == 1 ? 2 : 1)\">Aseguradora/Afianzadora <span ng-class=\"{\'fa fa-sort-desc\': vm.aseguradora_asc == 1, \'fa fa-sort-asc\': vm.aseguradora_asc == 2}\"></span></th><th ng-click=\"vm.changePoliza(3, vm.subramo_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': vm.subramo_asc == 1, \'fa fa-sort-asc\': vm.subramo_asc == 2}\"></span></th><th>Forma de pago</th><th ng-click=\"vm.changePoliza(4, vm.estatus_asc == 1 ? 2 : 1)\">Estatus <span ng-class=\"{\'fa fa-sort-desc\': vm.estatus_asc == 1, \'fa fa-sort-asc\': vm.estatus_asc == 2}\"></span></th><th ng-click=\"vm.changePoliza(5, vm.vigencia_asc == 1 ? 2 : 1)\">Vigencia <span ng-class=\"{\'fa fa-sort-desc\': vm.vigencia_asc == 1, \'fa fa-sort-asc\': vm.vigencia_asc == 2}\"></span></th><th>Antigüedad</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.search_results track by $index\" ng-click=\"goToPolicy(insurance,\'Información pólizas\',\'polizas.info\')\"><td ng-if=\"insurance.document_type == 1 && insurance.poliza_number\">Póliza</td><td ng-if=\"!insurance.poliza_number\">OT</td><td ng-if=\"insurance.document_type == 3\">Póliza de Grupo</td><td ng-if=\"insurance.document_type == 7\">Fianza</td><td ng-if=\"insurance.document_type == 8\">Fianza Colectividad</td><td ng-if=\"insurance.document_type == 11\">Colectividad</td><td ng-if=\"insurance.document_type == 12\">Póliza de Colectividad</td><td>{{ insurance.poliza_number }}</td><td><span>{{ insurance.contractor.full_name}}</span></td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.subramo }}</td><td>{{payment(insurance.forma_de_pago)}}</td><td>{{status(insurance.status)}}</td><td>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</td><td ng-if=\"!(insurance.antiguedad > 0)\">0 días</td></tr></tbody></table><div ng-if=\"vm.show_pag_search && vm.search_config.count > 10\" class=\"text-center\"><pagination config=\"vm.search_config\" model=\"vm.search_results\"></pagination></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-10 pull-right\" ng-if=\"vm.acceso_rep_pol && (vm.search_results && vm.search_results.length !=0)\"><button ng-click=\"exportData(vm.form ? vm.form : vm.juridicalForm,2)\" class=\"col-xs-12 btn btn-primary ladda-button\">Generar Reporte</button></div></div></div></div><div class=\"ibox float-e-margins animate\" ng-if=\"vm.activityLog\"><div class=\"ibox-title\"><h5>Registro de Actividad</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info\" ng-click=\"vm.showInfo = true; vm.activityLog = false\"><span class=\"fa fa-reply\"></span> Regresar</button><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"block-log\"><div ng-repeat=\"item in log_info\"><span><b>{{ item.date | date: \'dd/MM/yyyy hh:mm:ss a\' : \'UTC\'}}</b></span> <span>{{ item.msj }}</span></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/show-files.html\'\"></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12\"><div class=\"row\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"2\" idmodel=\"vm.contratanteId\" exportable=\"true\"></comments></div></div></div></div></div></div>");
$templateCache.put("app/contratantes/contratantes.juridical.html","<toaster-container></toaster-container><div class=\"row\" ng-init=\"vm.juridicalForm.type_person = 2\"><div class=\"row data-container\"><div class=\"col-xs-12\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Datos del contratante</legend><div class=\"col-xs-12 nopadding form-group\" ng-class=\"{ \'has-error\': form2.j_name.$invalid && !form2.j_name.$pristine }\"><label>Nombre de la empresa <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"j_name\" ng-model=\"vm.juridicalForm.j_name\" required=\"\" type=\"text\" ng-click=\"type(2)\"></div><div class=\"col-xs-12 col-sm-4 nopadding form-group\" id=\"data_2\" ng-class=\"{ \'has-error\': form2.date_of_establishment.$invalid && !form2.date_of_establishment.$pristine }\"><label>Fecha de constitución (DD/MM/AAAA) <span class=\"color-red\">*</span></label><div class=\"input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" name=\"date_of_establishment\" ng-model=\"vm.juridicalForm.date_of_establishment\" ng-blur=\"selectDate(vm.juridicalForm.date_of_establishment)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 nopadding form-group\" ng-class=\"{ \'has-error\': form2.rfc.$invalid && !form2.rfc.$pristine }\"><label>RFC <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"rfc\" uppercase-only=\"\" ng-blur=\"rfc_getDateJ(vm.juridicalForm.rfc,2);validateRFCN(vm.juridicalForm.rfc)\" ng-model=\"vm.juridicalForm.rfc\" maxlength=\"12\" required=\"\"> <span class=\"error-message color-red\" ng-if=\"!isValidRFC || (vm.juridicalForm.rfc && vm.juridicalForm.rfc.length !=12)\">El RFC debe tener exactamente 12 caracteres.</span></div><div class=\"col-xs-12 col-sm-4 nopadding form-group\" ng-class=\"{ \'has-error\': form2.group.$invalid && !form2.group.$pristine }\"><label>Grupo <span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"group\" ng-model=\"vm.juridicalForm.group\" ng-change=\"changeGroup(vm.juridicalForm.group)\" ng-options=\"group.group_name for group in vm.groups track by group.url\"><option value=\"\" disabled=\"\">Seleccione un grupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(1, 2,null)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\" ng-if=\"vm.juridicalForm.group\"><label for=\"subgroup\">Subgrupo</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"subgroup\" ng-model=\"vm.juridicalForm.subgroup\" ng-change=\"changeSubGroup(vm.juridicalForm.subgroup)\" ng-options=\"group.group_name for group in vm.subgroups track by group.url\"><option value=\"\" disabled=\"\">Seleccione un subgrupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(2, 2,vm.juridicalForm.group)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\" ng-if=\"vm.juridicalForm.subgroup\"><label for=\"subgroup2\">Subsubgrupo</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"subgroup2\" ng-model=\"vm.juridicalForm.subsubgrupo\" ng-options=\"group.group_name for group in vm.sub_subgroups track by group.url\"><option value=\"\" disabled=\"\">Seleccione un subgrupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(3, 2,vm.juridicalForm.subgroup)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12\"><input type=\"hidden\" name=\"type_person\" ng-model=\"vm.juridicalForm.type\" value=\"\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Correo Electrónico (principal)</label> <input class=\"form-control\" lowercase=\"\" ng-model=\"vm.juridicalForm.emailMain\" type=\"search\"></div><div class=\"col-xs-12 col-sm-6 hidden-xs hidden-sm nopadding form-group\"><label>Teléfono (principal)</label><phonenumber-directive placeholder=\"myPrompt\" model=\"vm.juridicalForm.phoneMain\" change=\"changePhosne()\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Correos Electrónicos (secundarios)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.emails\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.emails.delete($index, 2)\" ng-disabled=\"vm.juridicalForm.emails.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><input class=\"form-control\" lowercase=\"\" ng-model=\"item.correo\" type=\"search\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.emails.add(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\" ng-init=\"vm.juridicalForm.emails[$index].email_type = 0\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.emails[$index].email_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.emails[$index].email_type == 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.emails[$index].email_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.emails[$index].email_type == 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.emails[$index].email_type == 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a id=\"dropdown-menu-item-link-1\" ng-click=\"vm.juridicalForm.emails[$index].email_type = 1; vm.closeDropdown()\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal</a></li><li><a id=\"dropdown-menu-item-link-2\" ng-click=\"vm.juridicalForm.emails[$index].email_type = 2; vm.closeDropdown()\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"vm.juridicalForm.emails[$index].email_type = 3; vm.closeDropdown()\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"vm.juridicalForm.emails[$index].email_type = 4; vm.closeDropdown()\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI</a></li></ul></div></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.emails\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.emails.delete($index, 2)\" ng-disabled=\"vm.juridicalForm.emails.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><input class=\"form-control\" lowercase=\"\" ng-model=\"item.correo\" type=\"search\"><div class=\"input-group-btn\" ng-init=\"vm.juridicalForm.emails[$index].email_type = 0\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.emails[$index].email_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.emails[$index].email_type == 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.emails[$index].email_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.emails[$index].email_type == 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.emails[$index].email_type == 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.juridicalForm.emails[$index].email_type = 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal</a></li><li><a ng-click=\"vm.juridicalForm.emails[$index].email_type = 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo</a></li><li><a ng-click=\"vm.juridicalForm.emails[$index].email_type = 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI</a></li><li><a ng-click=\"vm.juridicalForm.emails[$index].email_type = 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro</a></li></ul><button class=\"btn btn-success\" ng-click=\"vm.emails.add(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 hidden-md hidden-lg nopadding form-group\"><label>Teléfono (principal)</label><phonenumber-directive placeholder=\"myPrompt\" model=\"vm.juridicalForm.phoneMain\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Teléfonos (secundarios)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.phones\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.phones.delete($index, 2)\" ng-disabled=\"vm.juridicalForm.phones.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><phonenumber-directive placeholder=\"myPrompt\" model=\"item.phone\"></phonenumber-directive><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.phones.add(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\" ng-init=\"vm.juridicalForm.phones[$index].phone_type = 0\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.phones[$index].phone_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.phones[$index].phone_type == 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.phones[$index].phone_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.phones[$index].phone_type == 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a ng-click=\"vm.juridicalForm.phones[$index].phone_type = 1; vm.closeDropdown()\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa</a></li><li><a ng-click=\"vm.juridicalForm.phones[$index].phone_type = 2; vm.closeDropdown()\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina</a></li><li><a ng-click=\"vm.juridicalForm.phones[$index].phone_type = 3; vm.closeDropdown()\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil</a></li></ul></div></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.phones\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.phones.delete($index, 2)\" ng-disabled=\"vm.juridicalForm.phones.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><phonenumber-directive placeholder=\"myPrompt\" model=\"item.phone\"></phonenumber-directive><div class=\"input-group-btn\" ng-init=\"vm.juridicalForm.phones[$index].phone_type = 0\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.phones[$index].phone_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.phones[$index].phone_type == 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.phones[$index].phone_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.phones[$index].phone_type == 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.juridicalForm.phones[$index].phone_type = 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa</a></li><li><a ng-click=\"vm.juridicalForm.phones[$index].phone_type = 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina</a></li><li><a ng-click=\"vm.juridicalForm.phones[$index].phone_type = 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil</a></li></ul><button class=\"btn btn-success\" ng-click=\"vm.phones.add(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 hidden-xs hidden-sm form-group\"><label><input type=\"radio\" ng-model=\"adWhatsapp\" ng-checked=\"addwhatsapp(adWhatsapp)\" value=\"1\"> Informar Móvil para Cobranza WhatsApp/SMS</label><br><div class=\"col-xs-12 col-sm-6 hidden-xs hidden-sm form-group\" ng-if=\"adWhatsapp\"><label>Móvil (WhatsApp/SMS)</label> <input class=\"form-control\" placeholder=\"4427777766\" type=\"text\" ng-model=\"vm.juridicalForm.phone_mensajeria\"></div></div><div ng-if=\"sucursalList\" class=\"col-xs-12 col-sm-6 form-group nopadding\"><label for=\"sucursal\">Sucursal</label><select class=\"form-control m-b\" name=\"sucursal\" ng-model=\"vm.juridicalForm.sucursal\" ng-options=\"sucursal.id as sucursal.sucursal_name for sucursal in sucursalList\"><option value=\"\">Seleccione una sucursal</option></select></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\"><label for=\"sucursal\">Clasificación</label><div class=\"input-group\"><select class=\"form-control\" name=\"clasification\" ng-model=\"vm.juridicalForm.classification\" ng-options=\"clasification.url as clasification.classification_name for clasification in vm.clasifications\"><option value=\"\" disabled=\"\">Seleccione una clasificación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.openModalClasification()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><br><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-if=\"campo_celula\"><label for=\"sucursal\">{{moduleName}}</label><div class=\"input-group\"><select class=\"form-control\" name=\"celula\" ng-model=\"vm.juridicalForm.celula\" ng-options=\"celula.url as celula.celula_name for celula in vm.celulas\"><option value=\"\" disabled=\"\">Seleccione {{moduleName}}</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.openModalCelulaContractor()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-if=\"campo_agrupacion\"><label for=\"sucursal\">Agrupación</label><select class=\"form-control\" name=\"agrupacion\" ng-model=\"vm.juridicalForm.grouping_level\" ng-change=\"changeAgrupacion2(vm.juridicalForm.grouping_level)\" ng-options=\"agrupaciones.description for agrupaciones in vm.agrupaciones track by agrupaciones.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-if=\"vm.juridicalForm.grouping_level && campo_agrupacion\"><label for=\"sucursal\">Subagrupación</label><div class=\"input-group\"><select class=\"form-control\" name=\"subagrupacion\" ng-model=\"vm.juridicalForm.subagrupaciones\" ng-change=\"changeSubagrupacion2(vm.juridicalForm.subagrupaciones)\" ng-options=\"agrupaciones.description for agrupaciones in sub_asignaciones track by agrupaciones.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalAsignacion(2,vm.juridicalForm.grouping_level)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-if=\"vm.juridicalForm.subagrupaciones && campo_agrupacion\"><label for=\"sucursal\">Subsubagrupación</label><div class=\"input-group\"><select class=\"form-control\" name=\"subsubagrupacion\" ng-model=\"vm.juridicalForm.subsubasignaciones\" ng-change=\"changeSubsubagrupacion2(vm.juridicalForm.subsubasignaciones)\" ng-options=\"grupo.description for grupo in sub_subasignaciones track by grupo.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalAsignacion(3,vm.juridicalForm.subagrupaciones)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div></div></div><div class=\"row address-container mt-20\" ng-repeat=\"address in vm.juridicalForm.userAddresses track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.addresses.delete($index,2)\" ng-disabled=\"vm.juridicalForm.userAddresses.length <= 1\">Quitar dirección</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.addresses.delete($index,2)\" ng-disabled=\"vm.juridicalForm.userAddresses.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Direccion #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addresses.add(2)\" type=\"button\">Agregar dirección</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addresses.add(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{ \'has-error\': form2.city.$invalid && !form2.city.$pristine }\"><label>Tipo de dirección</label><select class=\"form-control\" data-ng-options=\"type.name for type in vm.address_type track by type.name\" name=\"type\" ng-model=\"address.tipo\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{ \'has-error\': form2.state.$invalid && !form2.state.$pristine }\"><label>Estado <span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"estado.state for estado in vm.statesArray track by estado.url\" name=\"state\" ng-model=\"address.administrative_area_level_1\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un estado</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{ \'has-error\': form2.city.$invalid && !form2.city.$pristine }\"><label>Municipio <span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"ciudad.city for ciudad in address.administrative_area_level_1.cities track by ciudad.url\" name=\"city\" ng-model=\"address.administrative_area_level_2\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un municipio</option></select></div><div class=\"col-xs-12 col-md-8 nopadding form-group\"><label>Calle</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.route\" id=\"id_address_route\" name=\"address_route\" data-geo=\"route\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Ext.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number\" id=\"id_address_street_number\" name=\"address_street_numberf\" data-geo=\"street_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Int.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number_int\" id=\"id_address_street_number_int\" name=\"address_street_number_int\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Colonia</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.sublocality\" id=\"id_address_sublocality\" name=\"address_sublocality\" data-geo=\"sublocality\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Código Postal</label> <input type=\"tel\" name=\"zip\" ng-model=\"address.postal_code\" minlength=\"5\" maxlength=\"5\" class=\"form-control\" ng-keypress=\"filterValue($event)\"></div><div class=\"col-xs-12 nopadding form-group\"><label>Referencias</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.details\" id=\"id_address_details\" name=\"address_details\"></div><input type=\"hidden\" class=\"form-control\" ng-model=\"address.administrative_area_level_1_short\" id=\"id_address_administrative_area_level_1_short\" name=\"address_state_code\" data-geo=\"administrative_area_level_1_short\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country\" id=\"id_address_country\" name=\"address_country\" data-geo=\"country\" value=\"México\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.composed\" id=\"id_address_composed\" name=\"address_composed\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country_code\" id=\"id_address_country_code\" name=\"address_country_code\" data-geo=\"country_short\" value=\"MX\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.locality\" id=\"id_address_locality\" name=\"address_locality\" data-geo=\"locality\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.latitude\" id=\"id_address_latitude\" name=\"address_latitude\" data-geo=\"lat\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.longitude\" id=\"id_address_longitude\" name=\"address_longitude\" data-geo=\"lng\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.formatted\" id=\"id_address_formatted\" name=\"address_formatted\" data-geo=\"formatted_address\"></div></div><div class=\"col-xs-12 form-group m-t\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"vm.juridicalForm.only_sureties\" ng-change=\"onlyFianzas(2)\"> <span>Solo para Fianzas</span></h3></div><div class=\"col-xs-12\" ng-if=\"vm.form.only_sureties\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Seleccione el archivo a cargar, de clic en el ícono <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> uno a la vez después de seleccionar, para añadirlo.</div></div><div class=\"col-xs-12 col-sm-6 col-lg-12 form-group\" align=\"center\"><table class=\"table table-bordered\" align=\"center\"><thead><tr><th>Entregado</th><th>Documento</th><th ng-if=\"vm.juridicalForm.only_sureties\">Archivo</th></tr></thead><tbody><tr ng-repeat=\"listaD in vm.listDocument track by $index\"><td class=\"col-lg-3\" ng-click=\"$event.stopPropagation()\"><label><input type=\"checkbox\" ng-model=\"listaD.value\"></label></td><td><span class=\"font-weight-bold\">{{listaD.name}}</span></td><td ng-click=\"$event.stopPropagation()\" ng-if=\"vm.juridicalForm.only_sureties\"><div class=\"col-xs-12 form-group\" id=\"$index\"><label class=\"btn btn-success\" ng-if=\"listaD.file ==false\">Seleccionar Archivo <input nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploaderDocument\" class=\"display-none\"></label> <button class=\"btn btn-white\" ng-if=\"listaD.file ==false\" ng-click=\"addFileList($index,vm.listDocument, uploaderDocument.queue,xyz)\" title=\"Click para añadir archivo y subirlo\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i></button> <span class=\"blue-color\">{{listaD.arch.file.name}}</span><i class=\"fa fa-check-circle\" aria-hidden=\"true\" ng-if=\"listaD.file ==true\"></i></div></td></tr></tbody></table></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" ng-model=\"vm.juridicalForm.description\" type=\"text\"></textarea></div></div><div ng-if=\"vm.vendors.length >0\" class=\"col-sm-6 form-group\"><label for=\"vendedor\">Referenciador</label><div class=\"\"><select class=\"form-control m-b\" name=\"vendedor\" ng-model=\"vm.form.vendedor\" ng-change=\"changeVendedor(vm.form.vendedor)\" ng-options=\"vendedor.id as vendedor.name for vendedor in vm.vendors track by vendedor.id\"><option value=\"\" disabled=\"\">Seleccione un referenciador</option></select></div></div><div ng-if=\"vm.responsables.length >0\" class=\"col-sm-6 form-group\"><label for=\"vendedor\">Responsable</label><div class=\"\"><select class=\"form-control m-b\" name=\"responsable\" ng-model=\"vm.form.responsable\" ng-change=\"changeResponsable_single(vm.form.responsable)\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables track by responsable.id\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select></div></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Responsables</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.responsables\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteResponsable($index, 2)\" ng-disabled=\"vm.juridicalForm.responsables.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b\" name=\"responsable\" ng-model=\"item.responsable\" ng-change=\"changeResponsable(vm.juridicalForm.responsable, 2)\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables track by responsable.id\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addResponsable(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\" ng-init=\"vm.juridicalForm.responsables[$index].resp_type = 0\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 0\">Elige el área <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.responsables[$index].resp_type == 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.responsables[$index].resp_type == 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecuivo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.responsables[$index].resp_type == 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.responsables[$index].resp_type == 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.responsables[$index].resp_type == 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a id=\"dropdown-menu-item-link-1\" ng-click=\"vm.juridicalForm.responsables[$index].resp_type = 1; vm.closeDropdown()\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión</a></li><li><a id=\"dropdown-menu-item-link-1\" ng-click=\"vm.juridicalForm.responsables[$index].resp_type = 4; vm.closeDropdown()\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo</a></li><li><a id=\"dropdown-menu-item-link-1\" ng-click=\"vm.juridicalForm.responsables[$index].resp_type = 5; vm.closeDropdown()\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial</a></li><li><a id=\"dropdown-menu-item-link-2\" ng-click=\"vm.juridicalForm.responsables[$index].resp_type = 2; vm.closeDropdown()\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"vm.juridicalForm.responsables[$index].resp_type = 3; vm.closeDropdown()\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros</a></li></ul></div></div></div><div class=\"hidden-xs hidden-sm nopadding juridicalForm-group\" ng-repeat=\"item in vm.juridicalForm.responsables\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteResponsable($index, 2)\" ng-disabled=\"vm.juridicalForm.responsables.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b\" name=\"responsable\" ng-model=\"item.responsable\" ng-change=\"changeResponsable(vm.juridicalForm.responsable)\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables track by responsable.url\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select><div class=\"input-group-btn\" ng-init=\"vm.juridicalForm.responsables[$index].resp_type = 0\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.responsables[$index].resp_type == 0\">Elige el área <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.responsables[$index].resp_type == 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.responsables[$index].resp_type == 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.responsables[$index].resp_type == 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.responsables[$index].resp_type == 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.juridicalForm.responsables[$index].resp_type == 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.juridicalForm.responsables[$index].resp_type = 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión</a></li><li><a ng-click=\"vm.juridicalForm.responsables[$index].resp_type = 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo</a></li><li><a ng-click=\"vm.juridicalForm.responsables[$index].resp_type = 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial</a></li><li><a ng-click=\"vm.juridicalForm.responsables[$index].resp_type = 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza</a></li><li><a ng-click=\"vm.juridicalForm.responsables[$index].resp_type = 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros</a></li></ul><button class=\"btn btn-success\" ng-click=\"addResponsable(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Obligado(s) Solidario(s) (Fianzas)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.obligados\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteObligados($index, 1)\" ng-disabled=\"vm.juridicalForm.obligados.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><div id=\"item[$index]\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"item\" change=\"matchesContractors(item.val)\"></autocomplete></div><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addObligados(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.juridicalForm.obligados\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteObligados($index, 1)\" ng-disabled=\"vm.juridicalForm.obligados.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><div id=\"item[$index]\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"item\" change=\"matchesContractors(item.val)\"></autocomplete></div><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addObligados(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group m-t\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"vm.juridicalForm.vip\"> <span>VIP</span></h3></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Información de contacto</legend></div><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.juridicalForm.contact_juridical.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"vm.juridicalForm.contact_juridical.length == 0\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"vm.juridicalForm.contact_juridical.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contactos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact(2)\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"contact in vm.juridicalForm.contact_juridical track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteContacts($index, 2)\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts($index, 2)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contacto #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact(2)\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact(2)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"contact.name\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" type=\"search\" lowercase=\"\" ng-model=\"contact.email\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Teléfono</label><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone_number\"></phonenumber-directive></div></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\" ng-if=\"vm.permiso_administrar_adjuntos\"><div upload-template=\"\"></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button id=\"saveButtonMoral\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"vm.submitJuridical()\" ng-disabled=\"enviado || !habilitado\">Guardar Contratante Moral</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button id=\"cancelButtonMoral\" class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div>");
$templateCache.put("app/contratantes/contratantes.list.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-lg-9\"><h2>Contratantes</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"contratantes.main\">Contratantes</a></li><li class=\"active\"><strong>Buscar</strong></li></ol></div></div><br><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content padding-bottom-0\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Nombre</label> <input type=\"text\" class=\"form-control\" placeholder=\"Ingresa un nombre\" ng-model=\"vm.form_list.contratante\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>RFC</label> <input type=\"text\" class=\"form-control\" placeholder=\"Ingresa un RFC\" ng-model=\"vm.form_list.rfc\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form_list.grupo\" change=\"vm.matchesGroup(vm.form_list.grupo.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-init=\"vm.changeTypePerson(\'0\')\"><label>Tipo</label><select class=\"form-control cl-md-6\" ng-model=\"vm.form_list.type_person\" ng-change=\"vm.changeTypePerson(vm.form_list.type_person)\"><option value=\"\">Todas</option><option value=\"1\">Fisicas</option><option value=\"2\">Morales</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Condiciones</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_condition\" data-ng-options=\"condiciones_toselected.val for condiciones_toselected in vm.condiciones_toselected track by condiciones_toselected.value\" ng-change=\"selectConditions(select_condition)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group m-t\"><label><input type=\"checkbox\" name=\"valueCheck\" ng-model=\"vm.form.onlySureties\" ng-change=\"onlySureties(vm.form.onlySureties)\"> Solo Fiados</label></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group m-t\"><label><input type=\"checkbox\" name=\"valueCheck\" ng-model=\"vm.form.onlyVIP\" ng-change=\"changeVIP(vm.form.onlyVIP)\"> Solo VIP</label></div><div class=\"col-xs-12 col-md-8 col-lg-12 form-group btn-action\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-3 pull-right\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.Consultar()\">Consultar</button></div></div></div></div></div></div><ul id=\"contextContratantes\" class=\"dropdown-menu\" role=\"menu\" z-index=\"1000\"></ul><div class=\"ibox float-e-margins border-bottom\"><div class=\"ibox-title\"><h5>Contratantes</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"vm.persons.all.length\"><table class=\"table table-stripped table-hover\" ng-if=\"!vm.show_binnacle\"><thead><tr><th ng-model=\"vm.table.headers[0]\" ng-click=\"vm.Consultar()\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.order_asc, \'fa fa-sort-asc\': !vm.order_asc}\"></span></th><th>Grupo</th><th>SubGrupo</th><th>SubSubGrupo</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th>Creado por</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-click=\"vm.goToContractorView(person)\" ng-repeat=\"person in vm.persons.all track by $index\" ng-if=\"vm.persons.all.length\"><td>{{ person.full_name }}</td><td>{{ person.group }}</td><td>{{ person.subgrupo }}</td><td>{{ person.subsubgrupo }}</td><td>{{ person.type_person }}</td><td>{{ person.owner }}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(person)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"7\" model=\"person.full_name\" associated=\"person.id\"></tasks></td></tr><tr ng-if=\"vm.persons\" class=\"gradeX\" ng-click=\"vm.goToContractorView(person)\" ng-repeat=\"person in vm.persons track by $index\"><td>{{ person.full_name }} {{person.j_name}}</td><td>{{ person.group }}</td><td>{{ person.subgrupo }}</td><td>{{ person.subsubgrupo }}</td><td>{{ person.type_person }}</td><td>{{ person.owner }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_naturals && !vm.show_binnacle\" class=\"text-center hidden-xs hidden-sm\"><pagination config=\"vm.naturals_config\" model=\"vm.persons.naturals\"></pagination></div><div ng-if=\"vm.show_pag_juridicals\" class=\"text-center hidden-xs hidden-sm\"><pagination config=\"vm.juridicals_config\" model=\"vm.persons.juridicals\"></pagination></div><div ng-if=\"show_pagination && !vm.show_binnacle\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"person in vm.persons.naturals track by $index\" ng-if=\"vm.persons.naturals.length || type_person == 1\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }} : {{ person.full_name }} {{person.j_name }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ng-click=\"vm.goToContractorView(person)\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ person.full_name }} {{person.j_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ person.type_person }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(person)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></div></div></div></div><div ng-if=\"vm.show_pagination\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-3\" ng-if=\"vm.persons.naturals.length && !vm.show_binnacle\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 btn btn-primary ladda-button-excel\" ng-click=\"vm.exportDataE(1)\">Generar Reporte</button></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-3\" ng-if=\"vm.persons.all.length && !vm.show_binnacle\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 btn btn-primary ladda-button-excel\" ng-click=\"vm.exportDataE(0)\">Generar Reporte</button></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-3\" ng-if=\"vm.persons.juridicals.length && !vm.show_binnacle\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 btn btn-primary ladda-button-excel\" ng-click=\"vm.exportDataE(2)\">Generar Reporte</button></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" typemodel=\"2\" config=\"vm.comments_config\" idmodel=\"vm.person_id\" exportable=\"true\"></comments><div class=\"col-xs-12 col-sm-4 col-md-3\"><div class=\"row\"><a class=\"col-xs-12 btn btn-primary margin-top-10\" ng-click=\"vm.returnToContractors(2)\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div></div></div></div></div></div>");
$templateCache.put("app/contratantes/contratantes.natural.html","<toaster-container></toaster-container><div class=\"row\" ng-init=\"vm.form.type_person = 1\"><form class=\"col-xs-12\" method=\"post\" name=\"form\" ng-submit=\"vm.submitNatural(form.$valid)\" role=\"form\" novalidate=\"\"><div class=\"data-container\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Datos del contratante</legend><div class=\"col-xs-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\': form.name.$invalid && !form.name.$pristine }\"><label>Nombre<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"vm.form.first_name\" required=\"\" type=\"text\" ng-click=\"type(1)\"></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\': form.last_name.$invalid && !form.last_name.$pristine }\"><label>Apellido Paterno<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"last_name\" ng-model=\"vm.form.last_name\" required=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\': form.second_last_name.$invalid && !form.second_last_name.$pristine }\"><label>Apellido Materno</label> <input class=\"form-control\" type=\"text\" name=\"second_last_name\" ng-model=\"vm.form.second_last_name\"></div><div class=\"col-xs-12 col-sm-6 form-group\" id=\"data_2\" ng-class=\"{ \'has-error\': form.birthday.$invalid && !form.birthday.$pristine }\"><label>Fecha de Nacimiento (DD/MM/AAAA)<span class=\"color-red\">*</span></label><div class=\"input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" name=\"birthday\" ng-model=\"vm.form.birthday\" ng-blur=\"selectDate(vm.form.birthday)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>RFC<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"rfc\" uppercase-only=\"\" ng-blur=\"rfc_getDate(vm.form.rfc,1);validateRFCN(vm.form.rfc)\" ng-model=\"vm.form.rfc\" maxlength=\"13\" required=\"\"> <span class=\"error-message color-red\" ng-if=\"!isValidRFCN || (vm.form.rfc && vm.form.rfc.length !=13)\">El RFC debe tener exactamente 13 caracteres.</span></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Género<span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"sex\" ng-model=\"vm.form.sex\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un género</option><option ng-selected=\"vm.form.sex == \'M\'\" value=\"M\">MASCULINO</option><option ng-selected=\"vm.form.sex == \'F\'\" value=\"F\">FEMENINO</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\"><label for=\"group\">Grupo<span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"group\" ng-model=\"vm.form.group\" ng-change=\"changeGroup(vm.form.group)\" ng-options=\"group.group_name for group in vm.groups track by group.url\"><option value=\"\" disabled=\"\">Seleccione un grupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(1, 1,null)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\" ng-if=\"vm.form.group\"><label for=\"subgroup\">Subgrupo</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"subgroup\" ng-model=\"vm.form.subgroup\" ng-change=\"changeSubGroup(vm.form.subgroup)\" ng-options=\"group.group_name for group in vm.subgroups track by group.url\"><option value=\"\" disabled=\"\">Seleccione un subgrupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(2, 1,vm.form.group)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\" ng-if=\"vm.form.subgroup\"><label for=\"subgroup2\">Subsubgrupo</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"subgroup2\" ng-model=\"vm.form.subsubgrupo\" ng-options=\"group.group_name for group in vm.sub_subgroups track by group.url\"><option value=\"\" disabled=\"\">Seleccione un subgrupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(3, 1,vm.form.subgroup)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo Electrónico (principal)</label> <input class=\"form-control\" lowercase=\"\" ng-model=\"vm.form.emailMain\" type=\"search\"></div><div class=\"col-xs-12 col-sm-6 hidden-xs hidden-sm form-group\"><label>Teléfono (principal)</label><phonenumber-directive placeholder=\"myPrompt\" model=\"vm.form.phoneMain\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correos Electrónicos (secundarios)</label><div class=\"hidden-md hidden-lg form-group\" ng-repeat=\"item in vm.form.emails\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.emails.delete($index,1)\" ng-disabled=\"vm.form.emails.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><input class=\"form-control\" lowercase=\"\" ng-model=\"item.correo\" type=\"search\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.emails.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\" ng-init=\"vm.form.emails[$index].email_type = 0\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.emails[$index].email_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.emails[$index].email_type == 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.emails[$index].email_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.emails[$index].email_type == 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.emails[$index].email_type == 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a id=\"dropdown-menu-item-link-1\" ng-click=\"vm.form.emails[$index].email_type = 1; vm.closeDropdown()\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal</a></li><li><a id=\"dropdown-menu-item-link-2\" ng-click=\"vm.form.emails[$index].email_type = 2; vm.closeDropdown()\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"vm.form.emails[$index].email_type = 3; vm.closeDropdown()\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"vm.form.emails[$index].email_type = 4; vm.closeDropdown()\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro</a></li></ul></div></div></div><div class=\"hidden-xs hidden-sm form-group\" ng-repeat=\"item in vm.form.emails\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.emails.delete($index,1)\" ng-disabled=\"vm.form.emails.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><input class=\"form-control\" ng-model=\"item.correo\" type=\"search\"><div class=\"input-group-btn\" ng-init=\"vm.form.emails[$index].email_type = 0\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.emails[$index].email_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.emails[$index].email_type == 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.emails[$index].email_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.emails[$index].email_type == 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.emails[$index].email_type == 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.form.emails[$index].email_type = 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal</a></li><li><a ng-click=\"vm.form.emails[$index].email_type = 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo</a></li><li><a ng-click=\"vm.form.emails[$index].email_type = 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI</a></li><li><a ng-click=\"vm.form.emails[$index].email_type = 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro</a></li></ul><button class=\"btn btn-success\" ng-click=\"vm.emails.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 hidden-md hidden-lg form-group\"><label>Teléfono (principal)</label><phonenumber-directive placeholder=\"myPrompt\" model=\"vm.form.phoneMain\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfonos (secundarios)</label><div class=\"hidden-md hidden-lg form-group\" ng-repeat=\"item in vm.form.phones\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.phones.delete($index,1)\" ng-disabled=\"vm.form.phones.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><phonenumber-directive placeholder=\"myPrompt\" model=\"item.phone\"></phonenumber-directive><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.phones.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\" ng-init=\"vm.form.phones[$index].phone_type = 0\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.phones[$index].phone_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.phones[$index].phone_type == 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.phones[$index].phone_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.phones[$index].phone_type == 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a ng-click=\"vm.form.phones[$index].phone_type = 1; vm.closeDropdown()\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa</a></li><li><a ng-click=\"vm.form.phones[$index].phone_type = 2; vm.closeDropdown()\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina</a></li><li><a ng-click=\"vm.form.phones[$index].phone_type = 3; vm.closeDropdown()\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil</a></li></ul></div></div></div><div class=\"hidden-xs hidden-sm form-group\" ng-repeat=\"item in vm.form.phones\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.phones.delete($index,1)\" ng-disabled=\"vm.form.phones.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><phonenumber-directive placeholder=\"myPrompt\" model=\"item.phone\"></phonenumber-directive><div class=\"input-group-btn\" ng-init=\"vm.form.phones[$index].phone_type = 0\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.phones[$index].phone_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.phones[$index].phone_type == 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.phones[$index].phone_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.phones[$index].phone_type == 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.form.phones[$index].phone_type = 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa</a></li><li><a ng-click=\"vm.form.phones[$index].phone_type = 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina</a></li><li><a ng-click=\"vm.form.phones[$index].phone_type = 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil</a></li></ul><button class=\"btn btn-success\" ng-click=\"vm.phones.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 hidden-xs hidden-sm form-group\"><label><input type=\"radio\" ng-model=\"adWhatsapp\" ng-checked=\"addwhatsapp(adWhatsapp)\" value=\"1\"> Informar Móvil para Cobranza WhatsApp/SMS</label><br><div class=\"col-xs-12 col-sm-6 hidden-xs hidden-sm form-group\" ng-if=\"adWhatsapp\"><label>Móvil (WhatsApp/SMS)</label> <input class=\"form-control\" placeholder=\"4427777766\" type=\"text\" ng-model=\"vm.form.phone_mensajeria\"></div></div><div ng-if=\"sucursalList\" class=\"col-xs-12 col-sm-6 form-group\"><label for=\"sucursal\">Sucursal</label><select class=\"form-control\" name=\"sucursal\" ng-model=\"vm.form.sucursal\" ng-options=\"sucursal.id as sucursal.sucursal_name for sucursal in sucursalList\"><option value=\"\" disabled=\"\">Seleccione una sucursal</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"sucursal\">Clasificación</label><div class=\"input-group\"><select class=\"form-control\" name=\"clasification\" ng-model=\"vm.form.classification\" ng-options=\"clasification.url as clasification.classification_name for clasification in vm.clasifications\"><option value=\"\" disabled=\"\">Seleccione una clasificación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.openModalClasification()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><br><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"campo_celula\"><label for=\"cedulacontractor\">{{moduleName}}</label><div class=\"input-group\"><select class=\"form-control\" name=\"celula\" ng-model=\"vm.form.celula\" ng-options=\"celula.url as celula.celula_name for celula in vm.celulas\"><option value=\"\" disabled=\"\">Seleccione {{moduleName}}</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.openModalCelulaContractor()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"campo_agrupacion\"><label for=\"sucursal\">Agrupación</label><select class=\"form-control\" name=\"agrupacion\" ng-model=\"vm.form.grouping_level\" ng-change=\"changeAgrupacion2(vm.form.grouping_level)\" ng-options=\"agrupaciones.description for agrupaciones in vm.agrupaciones track by agrupaciones.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.grouping_level && campo_agrupacion\"><label for=\"sucursal\">Subagrupación</label><div class=\"input-group\"><select class=\"form-control\" name=\"subagrupacion\" ng-model=\"vm.form.subagrupaciones\" ng-change=\"changeSubagrupacion2(vm.form.subagrupaciones)\" ng-options=\"agrupaciones.description for agrupaciones in sub_asignaciones track by agrupaciones.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalAsignacion(2, vm.form.grouping_level)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.subagrupaciones && campo_agrupacion\"><label for=\"sucursal\">Subsubagrupación</label><div class=\"input-group\"><select class=\"form-control\" name=\"subsubagrupacion\" ng-model=\"vm.form.subsubasignaciones\" ng-change=\"changeSubsubagrupacion2(vm.form.subsubasignaciones)\" ng-options=\"grupo.description for grupo in sub_subasignaciones track by grupo.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalAsignacion(3, vm.form.subagrupaciones)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12\"><input type=\"hidden\" name=\"type_person\" ng-model=\"vm.form.type\" value=\"\"></div></div><div class=\"row address-container\" ng-repeat=\"address in vm.form.userAddresses track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.addresses.delete($index,1)\" ng-disabled=\"vm.form.userAddresses.length <= 1\">Quitar dirección</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.addresses.delete($index,1)\" ng-disabled=\"vm.form.userAddresses.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Direccion #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addresses.add(1)\" type=\"button\">Agregar dirección</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addresses.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{ \'has-error\': form2.city.$invalid && !form2.city.$pristine }\"><label>Tipo de dirección</label><select class=\"form-control\" data-ng-options=\"type.name for type in vm.address_type track by type.name\" name=\"type\" ng-model=\"address.tipo\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{ \'has-error\': form.state.$invalid && !form.state.$pristine }\"><label>Estado<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"estado.state for estado in vm.statesArray track by estado.url\" name=\"state\" ng-model=\"address.administrative_area_level_1\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un estado</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{ \'has-error\': form.city.$invalid && !form.city.$pristine }\"><label>Municipio<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"ciudad.city for ciudad in address.administrative_area_level_1.cities track by ciudad.url\" name=\"city\" ng-model=\"address.administrative_area_level_2\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un municipio</option></select></div><div class=\"col-xs-12 col-md-8 nopadding form-group\"><label>Calle</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.route\" id=\"id_address_route\" name=\"address_route\" data-geo=\"route\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Ext.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number\" id=\"id_address_street_number\" name=\"address_street_number\" data-geo=\"street_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Int.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number_int\" id=\"id_address_street_number_int\" name=\"address_street_number_int\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Colonia</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.sublocality\" id=\"id_address_sublocality\" name=\"address_sublocality\" data-geo=\"sublocality\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Código Postal</label> <input type=\"tel\" name=\"zip\" ng-model=\"address.postal_code\" minlength=\"5\" maxlength=\"5\" class=\"form-control\" ng-keypress=\"filterValue($event)\"></div><div class=\"col-xs-12 nopadding form-group\"><label>Referencias</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.details\" id=\"id_address_details\" name=\"address_details\"></div><input type=\"hidden\" class=\"form-control\" ng-model=\"address.administrative_area_level_1_short\" id=\"id_address_administrative_area_level_1_short\" name=\"address_state_code\" data-geo=\"administrative_area_level_1_short\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country\" id=\"id_address_country\" name=\"address_country\" data-geo=\"country\" value=\"México\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.composed\" id=\"id_address_composed\" name=\"address_composed\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country_code\" id=\"id_address_country_code\" name=\"address_country_code\" data-geo=\"country_short\" value=\"MX\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.locality\" id=\"id_address_locality\" name=\"address_locality\" data-geo=\"locality\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.latitude\" id=\"id_address_latitude\" name=\"address_latitude\" data-geo=\"lat\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.longitude\" id=\"id_address_longitude\" name=\"address_longitude\" data-geo=\"lng\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.formatted\" id=\"id_address_formatted\" name=\"address_formatted\" data-geo=\"formatted_address\"></div></div><div class=\"col-xs-12 col-sm-6 form-group m-t\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"vm.form.only_sureties\" ng-change=\"onlyFianzas(1)\"> <span>Solo para Fianzas</span></h3></div><div class=\"col-xs-12\" ng-if=\"vm.form.only_sureties\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Seleccione el archivo a cargar, de clic en el ícono <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> uno a la vez después de seleccionar, para añadirlo.</div></div><div class=\"col-xs-12 col-sm-6 col-lg-12 form-group\" align=\"center\"><table class=\"table table-bordered\" align=\"center\"><thead><tr><th>Entregado</th><th>Documento</th><th ng-if=\"vm.form.only_sureties\">Archivo</th></tr></thead><tbody><tr ng-repeat=\"listaD in vm.listDocument track by $index\"><td class=\"col-lg-3\" ng-click=\"$event.stopPropagation()\"><label><input type=\"checkbox\" ng-model=\"listaD.value\"></label></td><td><span class=\"font-weight-bold\">{{listaD.name}}</span></td><td ng-click=\"$event.stopPropagation()\" ng-if=\"vm.form.only_sureties\"><div class=\"col-xs-12 form-group\" id=\"$index\"><label class=\"btn btn-success\" ng-if=\"listaD.file ==false\">Seleccionar Archivo <input nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploaderDocument\" class=\"display-none\"></label> <button class=\"btn btn-white\" ng-if=\"listaD.file ==false\" ng-click=\"addFileList($index,vm.listDocument, uploaderDocument.queue,xyz)\" title=\"Click para añadir archivo y subirlo\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i></button> <span class=\"blue-color\">{{listaD.arch.file.name}}</span><i class=\"fa fa-check-circle\" aria-hidden=\"true\" ng-if=\"listaD.file ==true\"></i></div></td></tr></tbody></table></div><div class=\"col-sm-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" type=\"text\" ng-model=\"vm.form.description\"></textarea></div><div ng-if=\"vm.vendors.length >0\" class=\"col-sm-6 form-group\"><label for=\"vendedor\">Referenciador</label><div class=\"\"><select class=\"form-control m-b\" name=\"vendedor\" ng-model=\"vm.form.vendedor\" ng-change=\"changeVendedor(vm.form.vendedor)\" ng-options=\"vendedor.id as vendedor.name for vendedor in vm.vendors track by vendedor.id\"><option value=\"\" disabled=\"\">Seleccione un referenciador</option></select></div></div><div ng-if=\"vm.responsables.length >0\" class=\"col-sm-6 form-group\"><label for=\"vendedor\">Responsable</label><div class=\"\"><select class=\"form-control m-b\" name=\"responsable\" ng-model=\"vm.form.responsable\" ng-change=\"changeResponsable_single(vm.form.responsable)\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables track by responsable.url\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select></div></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Responsables</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.form.responsables\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteResponsable($index, 1)\" ng-disabled=\"vm.form.responsables.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b\" name=\"responsable\" ng-model=\"item.responsable\" ng-change=\"changeResponsable(vm.form.responsable, 1)\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables track by responsable.id\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addResponsable(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\" ng-init=\"vm.form.responsables[$index].resp_type = 0\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 0\">Elige el área <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecuivo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a id=\"dropdown-menu-item-link-1\" ng-click=\"vm.form.responsables[$index].resp_type = 1; vm.closeDropdown()\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión</a></li><li><a id=\"dropdown-menu-item-link-1\" ng-click=\"vm.form.responsables[$index].resp_type = 4; vm.closeDropdown()\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo</a></li><li><a id=\"dropdown-menu-item-link-1\" ng-click=\"vm.form.responsables[$index].resp_type = 5; vm.closeDropdown()\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial</a></li><li><a id=\"dropdown-menu-item-link-2\" ng-click=\"vm.form.responsables[$index].resp_type = 2; vm.closeDropdown()\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"vm.form.responsables[$index].resp_type = 3; vm.closeDropdown()\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros</a></li></ul></div></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.form.responsables\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteResponsable($index, 1)\" ng-disabled=\"vm.form.responsables.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b\" name=\"responsable\" ng-model=\"item.responsable\" ng-change=\"changeResponsable(vm.form.responsable)\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables track by responsable.url\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select><div class=\"input-group-btn\" ng-init=\"vm.form.responsables[$index].resp_type = 0\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 0\">Elige el área <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.responsables[$index].resp_type == 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.form.responsables[$index].resp_type = 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión</a></li><li><a ng-click=\"vm.form.responsables[$index].resp_type = 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo</a></li><li><a ng-click=\"vm.form.responsables[$index].resp_type = 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial</a></li><li><a ng-click=\"vm.form.responsables[$index].resp_type = 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza</a></li><li><a ng-click=\"vm.form.responsables[$index].resp_type = 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros</a></li></ul><button class=\"btn btn-success\" ng-click=\"addResponsable(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Obligado(s) Solidario(s) (Fianzas)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.form.obligados\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteObligados($index, 1)\" ng-disabled=\"vm.form.obligados.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><div id=\"item[$index]\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"item\" change=\"matchesContractors(item.val)\"></autocomplete></div><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addObligados(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.form.obligados\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteObligados($index, 1)\" ng-disabled=\"vm.form.obligados.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><div id=\"item[$index]\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"item\" change=\"matchesContractors(item.val)\"></autocomplete></div><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addObligados(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group m-t\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"vm.form.vip\"> <span>VIP</span></h3></div><div><input type=\"hidden\" name=\"type_person\" ng-model=\"vm.form.type\" value=\"\"></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Información de contacto</legend></div><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.form.contact_natural.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"vm.form.contact_natural.length == 0\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"vm.form.contact_natural.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contactos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact(1)\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"contact in vm.form.contact_natural track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteContacts($index, 1)\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts($index, 1)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contacto #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact(1)\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"contact.name\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" type=\"search\" lowercase=\"\" ng-model=\"contact.email\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Teléfono</label><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone_number\"></phonenumber-directive></div></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\" ng-if=\"vm.permiso_administrar_adjuntos\"><div upload-template=\"\"></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button id=\"saveButtonFisica\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"vm.checkRFC()\" ng-disabled=\"!habilitado\">Guardar Contratante Físico</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button id=\"cancelButtonFisica\" class=\"col-xs-12 btn btn-white\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></form></div>");
$templateCache.put("app/contratantes/contratantes.tab.html","<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\"><a href=\"\" ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude=\"\">{{heading}}</a></li>");
$templateCache.put("app/contratantes/contratantes.tabset.html","<div><ul class=\"nav nav-{{tabset.type || \'tabs\'}}\" ng-class=\"{\'nav-stacked\': vertical, \'nav-justified\': justified}\" ng-transclude=\"\"></ul><div class=\"tab-content\"><div class=\"tab-pane\" ng-repeat=\"tab in tabset.tabs\" ng-class=\"{active: tabset.active === tab.index}\" uib-tab-content-transclude=\"tab\"></div></div></div>");
$templateCache.put("app/cotizacion/accidentes.form.html","<div class=\"row\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Datos del titular</legend><div class=\"col-xs-12 form-group\"><button type=\"button\" ng-click=\"fillContractorData(quotationNew)\" class=\"btn btn-success pull-right\">Llenar con datos del Prospecto</button></div></div><div class=\"row\"><div class=\"data-container\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre</label> <input class=\"form-control\" name=\"name\" ng-model=\"quotationNew.accidents.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Apellido Paterno</label> <input class=\"form-control\" name=\"name\" ng-model=\"quotationNew.accidents.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Apellido Materno</label> <input class=\"form-control\" name=\"name\" ng-model=\"quotationNew.accidents.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de Nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"quotationNew.accidents.birthdate\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Sexo</label><select id=\"gender{{$index}}\" class=\"form-control m-b\" ng-model=\"quotationNew.accidents.sex\" ng-options=\"option.value as option.name for option in sexos\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Antigüedad</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"quotationNew.accidents.antiguedad\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"row\" ng-if=\"quotationNew.accidents.relationshipList.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"quotationNew.accidents.relationshipList.length == 0\">Quitar Dependiente</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"quotationNew.accidents.relationshipList.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Dependientes</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addDependiente()\" type=\"button\">Agregar Dependiente</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addDependiente()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"relationship in quotationNew.accidents.relationshipList track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"removeDependiente($index)\">Quitar Dependiente</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"order.options.disease.relationships.destroy($index,relationship)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Dependiente #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addDependiente()\" type=\"button\">Agregar Dependiente</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"quotationNew.accidents.add()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"nombre{{$index}}\">Nombre</label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"relationship.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last{{$index}}\">Apellido Paterno</label> <input id=\"last{{$index}}\" name=\"last{{$index}}\" class=\"form-control\" ng-model=\"relationship.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"relationship.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"parentesco{{0}}\">Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"relationship.relationship\" ng-options=\"r.option for r in parentescos track by r.option\" options-disabled=\"r.disabled for r in order.options.disease.types\"><option value=\"\" disabled=\"\">Selecciona</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.birthdate\" value=\"{{relationship.birthdate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"gender{{$index}}\">Sexo</label><select class=\"form-control\" ng-options=\"option.value as option.name for option in sexos\" ng-model=\"relationship.value\"><option value=\"\" disabled=\"\">Selecciona</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Antigüedad</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.antiguedad\" value=\"{{relationship.antiguedad}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div></div>");
$templateCache.put("app/cotizacion/autos.form.html","<fieldset><legend class=\"legend-title\" align=\"center\">Datos de automóvil</legend><div class=\"ibox float-e-margins\"><form role=\"form\" ng-model=\"order.subforms\"><div class=\"form-group col-xs-12 col-md-12\"><label for=\"brand\">Busqueda rápida</label><autocomplete datasource=\"autocompleteCarsData\" id=\"autocomplete\" model=\"quotationNew.auto.selectedCar\" change=\"getmatches(quotationNew.auto.selectedCar)\"></autocomplete></div><div class=\"hidden-md hidden-lg col-xs-12 form-group\"><label>Conductor</label><div class=\"form-group\"><input class=\"form-control\" type=\"text\" ng-model=\"quotationNew.auto.driver\"></div></div><div class=\"hidden-xs hidden-sm col-xs-12 form-group\"><label>Conductor</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"text\" ng-model=\"quotationNew.auto.driver\"></div></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"brand\">Marca</label> <input class=\"form-control\" name=\"brand\" ng-model=\"quotationNew.auto.brand\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"model\">Modelo</label> <input class=\"form-control\" name=\"model\" ng-model=\"quotationNew.auto.model\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"year\">Año</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"quotationNew.auto.year\"><option value=\"\">Selecciona el año</option></select></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"version\">Versión</label> <input class=\"form-control\" name=\"version\" ng-model=\"quotationNew.auto.version\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"serial\">Serie</label> <input class=\"form-control\" name=\"serial\" ng-blur=\"checkNumSerie()\" ng-model=\"quotationNew.auto.serial\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"engine\">Motor</label> <input class=\"form-control\" name=\"engine\" ng-model=\"quotationNew.auto.engine\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"color\">Color</label> <input class=\"form-control\" name=\"color\" ng-model=\"quotationNew.auto.color\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"license_plates\">Matrícula</label> <input class=\"form-control\" name=\"license_plates\" ng-model=\"quotationNew.auto.license_plates\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"use\">Uso</label><select ng-model=\"quotationNew.auto.usage\" class=\"form-control\"><option value=\"\" disabled=\"\">Selecciona una opción</option><option value=\"1\">PARTICULAR</option><option value=\"2\">CARGA</option><option value=\"3\">SERVICIO PÚBLICO</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"quotationNew.auto.usage == 2 || quotationNew.auto.usage == \'2\'\"><label>Tipo de Carga</label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.charge_type\" ng-change=\"changeProc();\" name=\"charge_type\" ng-model=\"quotationNew.auto.charge_type\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"use\">Servicio</label> <input class=\"form-control\" name=\"color\" ng-model=\"quotationNew.auto.service\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Estado de Circulación</label><select class=\"form-control\" data-ng-options=\"estado.state for estado in statesArray track by estado.url\" name=\"state\" ng-model=\"quotationNew.auto.state_circulation\"><option value=\"\">Selecciona un estado</option></select></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Adaptaciones</legend><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\"><label>Monto de adaptación</label> <input class=\"form-control\" type=\"text\" ng-model=\"quotationNew.auto.mont_adjustment\" format-currency=\"\"></div><div class=\"form-group\"><label>Adaptación</label> <textarea class=\"form-control\" ng-model=\"quotationNew.auto.adjustment\"></textarea></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\"><label>Monto de equipamiento</label> <input type=\"text\" class=\"form-control\" ng-model=\"quotationNew.auto.mont_special_team\" format-currency=\"\"></div><div class=\"form-group\"><label>Equipo especial</label> <textarea class=\"form-control\" ng-model=\"quotationNew.auto.special_team\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Beneficiario Preferente</legend><div class=\"col-xs-12 col-md-6 form-group\"><label>Nombre beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"quotationNew.auto.beneficiary_name\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Dirección beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"quotationNew.auto.beneficiary_address\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>RFC beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"quotationNew.auto.beneficiary_rfc\" maxlength=\"13\"></div></div></div></form></div></fieldset>");
$templateCache.put("app/cotizacion/cotizacion.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Cotización</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Cotización</strong></li></ol></div></div><div style=\"margin-right: 20px;margin-left: 20px;\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"quotation == null\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-if=\"!showQuotation\" ng-click=\"createQuotation()\">Agregar Cotización</button></div><div class=\"row flex-center\"><div class=\"col-xs-6 col-sm-1 col-md-1 pull-right\"><div class=\"ibox\"><button ng-if=\"!has_sr_conf\" ng-click=\"filtrosSubramos()\" class=\"btn btn-outline btn-block btn-default dim btn-sm\"><i class=\"fa fa-cog\" aria-hidden=\"true\"></i></button> <button ng-if=\"has_sr_conf\" ng-click=\"filtrosSubramos()\" class=\"btn btn-outline btn-block btn-primary dim btn-sm\"><i class=\"fa fa-cog\" aria-hidden=\"true\"></i></button></div></div></div><div class=\"col-xs-12\" ng-show=\"showQuotation\"><legend class=\"legend-title\" align=\"center\">Nueva cotización</legend><form class=\"row\" name=\"form\"><div class=\"row form-group\"><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"quotationNew.prospecto\" type=\"radio\" value=\"1\"> <b>Prospecto:</b> Nuevo</label><div ng-if=\"quotationNew.prospecto==1\" class=\"row\" align=\"center\"><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"quotationNew.type_person\" type=\"radio\" value=\"1\"> <b>Físico</b></label></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"quotationNew.type_person\" value=\"2\"> <b>Moral</b></label></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"quotationNew.prospecto\" value=\"2\"> <b>Prospecto:</b> Existente</label></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"quotationNew.prospecto == 2\"><label>Contratante <span class=\"color-red\">*</span></label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"quotationNew.contratante\" change=\"matchesContractors(quotationNew.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"quotationNew.prospecto == 1\"><label>Nombre <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"quotationNew.first_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"quotationNew.prospecto == 1 && quotationNew.type_person ==1\"><label>Apellido Paterno <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"quotationNew.last_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"quotationNew.prospecto == 1 && quotationNew.type_person ==1\"><label>Apellido Materno</label> <input class=\"form-control\" type=\"text\" ng-model=\"quotationNew.second_last_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"quotationNew.prospecto == 1\"><label>Email</label> <input class=\"form-control\" type=\"email\" ng-model=\"quotationNew.email\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"quotationNew.prospecto == 1\"><label>Teléfono</label> <input class=\"form-control\" type=\"text\" ng-model=\"quotationNew.phone\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Ramo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"ramo.name for ramo in ramos\" ng-change=\"changeRamo()\" name=\"ramo\" ng-model=\"quotationNew.ramo\"><option value=\"\" disabled=\"\">Selecciona un ramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Subramo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-change=\"updateProviders()\" ng-options=\"subramo.name for subramo in subramos\" name=\"subramo\" ng-model=\"quotationNew.subramo\"><option value=\"\" disabled=\"\">Selecciona un subramo</option></select></div><div class=\"col-xs-12 col-lg-6 form-group\"><label>Aseguradora(s) <span class=\"color-red\">*</span></label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"quotationNew.aseguradora\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in allProviders | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"tipo.descr for tipo in tipos\" name=\"tipo\" ng-model=\"quotationNew.tipo\"><option value=\"\">Selecciona un tipo</option></select></div><div ng-if=\"referenciador\" class=\"col-sm-4 form-group\"><label for=\"vendedor\">Referenciador</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"vendedor\" ng-model=\"quotationNew.referenciador\" ng-change=\"changeReferenciador(quotation.referenciador)\" ng-options=\"vendedor.url as vendedor.first_name + \' \' + vendedor.last_name for vendedor in referenciador\"><option value=\"\">Seleccione un referenciador</option></select></div></div><div class=\"quote-toggle col-sm-4 form-group\"><label class=\"toggle-label\">Tipo de Póliza <span class=\"text-danger\">*</span></label><div class=\"btn-group\" data-toggle=\"buttons\"><label class=\"btn btn-default\" ng-class=\"{\'active btn-secondary\': quotationNew.document_type === 1}\" ng-click=\"quotationNew.document_type = 1\"><i class=\"fa fa-user\"></i> Póliza Individual</label> <label class=\"btn btn-default\" ng-class=\"{\'active btn-warning\': quotationNew.document_type === 3}\" ng-click=\"quotationNew.document_type = 3\"><i class=\"fa fa-users\"></i> Póliza de Grupo</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 form-group\" ng-if=\"quotationNew.ramo && quotationNew.ramo.value == 2 && quotationNew.document_type === 1\"><div ng-include=\"\'app/cotizacion/accidentes.form.html\'\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 form-group\" ng-if=\"quotationNew.subramo && quotationNew.subramo.value == 9 && quotationNew.document_type === 1\"><div ng-include=\"\'app/cotizacion/autos.form.html\'\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 form-group\" ng-if=\"quotationNew.ramo && quotationNew.ramo.value == 3 && quotationNew.subramo && quotationNew.subramo.value != 9 && quotationNew.document_type === 1\"><div ng-include=\"\'app/cotizacion/danios.form.html\'\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 form-group\" ng-if=\"quotationNew.ramo && quotationNew.ramo.value == 1 && quotationNew.document_type === 1\"><div ng-include=\"\'app/cotizacion/vida.form.html\'\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 form-group\" ng-if=\"quotationNew.document_type === 3\"><div class=\"form-group col-sm-6\" ng-if=\"quotationNew.subramo && quotationNew.subramo.value == 9\"><label for=\"autos_cotizdos\">Autos cotizados: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"autos_cotizdos\" ng-model=\"quotationNew.autos_cotizados\" class=\"form-control\"></div><div class=\"form-group col-sm-6\" ng-if=\"quotationNew.ramo && quotationNew.ramo.value == 2 || quotationNew.ramo && quotationNew.ramo.value == 1\"><label for=\"personas_cotizadas\">Personas cotizadas: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"personas_cotizadas\" ng-model=\"quotationNew.personas_cotizadas\" class=\"form-control\"></div><div class=\"form-group col-sm-6\" ng-if=\"quotationNew.ramo && quotationNew.ramo.value == 3 && quotationNew.subramo && quotationNew.subramo.value != 9\"><label for=\"inmuebles_cotizados\">Inmuebles cotizados: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"inmuebles_cotizados\" ng-model=\"quotationNew.inmuebles_cotizados\" class=\"form-control\"></div></div><div class=\"col-xs-12 form-group\"><label>Detalles</label><fieldset><form name=\"form1\"><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-class=\"{ \'has-error\': form1.observations.$invalid && !form1.observations.$pristine }\"><textarea type=\"text\" class=\"form-control\" name=\"observations\" ng-model=\"quotationNew.observations\"></textarea></div></div></form></fieldset></div><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"permiso_administrar_adjuntos\"><div ng-include=\"\'templates/upload.html\'\"></div></div><table class=\"table table-bordered table\"><h3 class=\"text-center\">Archivos que estan actualmente en la base de datos</h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th ng-if=\"permiso_archivos\" width=\"200px\">Acciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_input\" class=\"form-control display-none\" ng-if=\"permiso_administrar_adjuntos\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"saveFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,files)\" ng-if=\"permiso_administrar_adjuntos\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"permiso_administrar_adjuntos\">Renombrar</button> <span class=\"btn btn-success display-none\">Guardar</span></td><td><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-if=\"permiso_administrar_adjuntos\" ng-model=\"file.sensible\"> * Archivo sensible</td></tr></tbody></table></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary\" ng-if=\"quotationNew.url\" ng-click=\"saveDelivery()\">Actualizar Cotización</button> <button class=\"col-xs-12 btn btn-primary\" ng-if=\"!quotationNew.url\" ng-click=\"saveDelivery()\">Crear Cotización</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeQuotation()\">Cancelar</button></div></form></div></div><div class=\"row\" ng-show=\"!showQuotation && !showInfoQuotation\" align=\"center\"><div class=\"col-xs-12 center blue-color\"><h3>Filtros</h3></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-8 form-group\"><label for=\"startDate\">Buscar por:</label><div><input type=\"text\" class=\"form-control\" placeholder=\"Folio, Asegurado, Cliente, Serie\" ng-model=\"filters.cadena\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group\"><label>Estatus</label><select class=\"form-control\" ng-model=\"filters.status\" ng-options=\"status.name for status in statusOptions | orderBy: \'id\' track by status.id\" ng-change=\"getCotizaciones()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"startDate\">Fecha creación desde:</label><div class=\"input-group date datepicker-me\" data-provide=\"datepicker\"><input type=\"text\" id=\"startDate\" name=\"startDate\" class=\"form-control text-align-center width-100\" ng-model=\"filters.since\" ng-change=\"changeSince()\" value=\"{{filters.since | date:\'medium\'}}\" data-date-format=\"mm/dd/yyyy\" readonly=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Fecha creación hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"filters.until\" value=\"{{vm.form.until}}\" ng-change=\"changeUntil()\" data-date-format=\"mm/dd/yyyy\" readonly=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 pull-right\"><button class=\"col-xs-12 btn btn-secondary pull-right m-t\" ng-if=\"!showQuotation\" ng-click=\"getCotizaciones()\"><span class=\"blue-color\">Aplicar</span></button></div><div class=\"col-xs-12 form-group\" ng-if=\"!filtrosAplicados\"><div class=\"alert alert-danger alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <b>Filtros Sin Aplicar</b>.</div></div><div class=\"col-xs-12 form-group\" ng-if=\"filtrosAplicados\"><div class=\"alert alert-success alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <b>Filtros Aplicados</b>.</div></div></div><div class=\"ibox float-e-margins\" ng-show=\"!showQuotation\"><div class=\"ibox-title\"><h5>Cotizaciones</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\" ng-hide=\"showInfoQuotation\"><h4 ng-if=\"vm.quotations && vm.quotations.length ==0\" align=\"center\" class=\"blue-color\">Sin registros</h4><table class=\"table table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th>No. de Folio</th><th>Contratante</th><th>Ramo</th><th>Subramo</th><th>Aseguradora</th><th>Estatus</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"item in vm.quotations track by $index\" ng-click=\"showInformation(item)\"><td>{{ item.id }}</td><td>{{ item.full_name }}</td><td>{{ item.ramo }}</td><td>{{ item.subramo }}</td><td><ul><li ng-repeat=\"aseg in item.aseguradora track by $index\">{{aseg}}</li></ul></td><td><span>{{ item.status }}</span></td><td ng-click=\"$event.stopPropagation()\"><div class=\"d-flex flex-column align-items-start\"><a class=\"btn btn-white btn-sm w-100 mb-2\" ng-click=\"$event.stopPropagation(); loadMail(item)\"><i class=\"fa fa-envelope\"></i></a> <button ng-if=\"item.status == \'En trámite\'\" class=\"btn btn-success btn-xs w-100 mb-2\" ng-click=\"$event.stopPropagation(); changeStatus(item, 2)\">Emitir</button> <button ng-if=\"item.status == \'En trámite\'\" class=\"btn btn-warning btn-xs w-100 mb-2\" ng-click=\"$event.stopPropagation(); changeStatus(item, 3)\">Batear</button> <button class=\"btn btn-danger btn-xs w-100 mb-2\" ng-click=\"$event.stopPropagation(); deleteQuatation(item.url, $index)\">Eliminar</button> <button ng-if=\"item.status == \'Emitida.\' && item.is_complete && (item.poliza_asociada && item.poliza_asociada.length == 0)\" class=\"btn btn-default btn-xs w-100 mb-2\" ng-click=\"$event.stopPropagation(); createPolicy(item)\">Crear póliza</button> <button ng-if=\"item.status == \'Bateada\'\" class=\"btn btn-secondary btn-xs w-100 mb-2\" ng-click=\"$event.stopPropagation(); changeStatus(item, 1)\">Desbatear</button></div><span ng-if=\"item.poliza_asociada\"><ul class=\"poliza-list mt-2\"><li ng-repeat=\"pa in item.poliza_asociada track by $index\" class=\"poliza-item\" ng-click=\"$event.stopPropagation(); goToPolicyInfo(pa)\"><p class=\"poliza-number\" ng-if=\"pa.poliza_number\"><strong>Póliza:</strong> {{pa.poliza_number}}</p><p class=\"poliza-number\" ng-if=\"!pa.poliza_number\"><strong>Interno:</strong> {{pa.internal_number}}</p><p class=\"poliza-date\" ng-if=\"pa.created_at\"><i class=\"fa fa-calendar\"></i> {{pa.created_at | date: \'dd/MM/yyyy\': \'UTC\'}}</p></li></ul></span></td></tr></tbody></table><div ng-if=\"vm.showpag\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 m-t\" ng-show=\"quotations\"><button class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"exprtExcelCotizacion()\" ng-if=\"vm.quotations && vm.quotations.length >0\">Generar reporte</button></div></div><div class=\"row\" ng-if=\"showInfoQuotation\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog(quotation.id)\"><i class=\"fa fa-history\"></i> Log</button> <button class=\"btn btn-light\" ng-click=\"showInformation(null)\" style=\"color: #6c757d; border: 1px solid #dee2e6; background-color: transparent;\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4\"><legend>👤 Información del Prospecto</legend><div class=\"col-xs-12 form-group\"><span class=\"label-cotizacion\">Nombre</span><div><span class=\"value\">{{quotation.full_name}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"label-cotizacion\">Correo</span><div><span ng-if=\"quotation.data.email && !quotation.email\" class=\"value\">{{ quotation.data.email}}</span><span ng-if=\"quotation.email\" class=\"value\">{{ quotation.email}}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"label-cotizacion\">Teléfono</span><div><span ng-if=\"quotation.data.phone && !quotation.phone\" class=\"value\">{{ quotation.data.phone}}</span><span ng-if=\"quotation.phone\" class=\"value\">{{ quotation.phone}}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"label-cotizacion\">Referido por</span><div><span class=\"value\">{{ quotation.referenciador_name }}</span></div></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><legend>🗒 Información de lo cotizado</legend><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"label-cotizacion\">Ramo:</span><div><span class=\"value\">{{ quotation.ramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"label-cotizacion\">Subramo:</span><div><span class=\"value\">{{ quotation.subramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"label-cotizacion\">Aseguradora:</span><br><span class=\"value\">{{quotation.aseguradora_seleccionada}}</span><div ng-repeat=\"aseg in quotation.aseguradora track by $index\" ng-if=\"!quotation.aseguradora_seleccionada\"><span class=\"value\">{{ aseg }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"quotation.observations\"><span class=\"label-cotizacion\">Observaciones:</span><div><span class=\"value\">{{ quotation.observations }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"quotation.ramo == \'Accidentes y Enfermedades\' && quotation.document_type==1\"><span class=\"label-cotizacion\">Titular:</span><div><span class=\"value\">{{ quotation.accidents.first_name }} {{ quotation.accidents.last_name }} {{ quotation.accidents.second_last_name }}</span></div><span class=\"label-cotizacion\">Fecha de nacimiento:</span><div><span class=\"value\">{{ quotation.accidents.birthdate }}</span></div><span class=\"label-cotizacion\">Sexo:</span><div><span class=\"value\">{{ quotation.accidents.sex }}</span></div><span class=\"label-cotizacion\">Antiguedad:</span><div><span class=\"value\">{{ quotation.accidents.antiguedad }}</span></div><span class=\"label-cotizacion\">Dependientes:</span><ul ng-repeat=\"aseg in quotation.accidents.relationshipList track by $index\"><li class=\"value\">{{ aseg.first_name }} {{ aseg.last_name }} {{ aseg.second_last_name }}</li><span class=\"label-cotizacion\">Fecha de nacimiento:</span><div><span class=\"value\">{{ aseg.birthdate }}</span></div><span class=\"label-cotizacion\">Sexo:</span><div><span ng-if=\"aseg.value == \'M\'\">Masculino</span> <span ng-if=\"aseg.value == \'F\'\">Femenino</span></div><span class=\"label-cotizacion\">Antiguedad:</span><div><span class=\"value\">{{ quotation.accidents.antiguedad }}</span></div></ul></div><div class=\"col-xs-12 form-group\" ng-if=\"quotation.ramo == \'Vida\' && quotation.document_type==1\" ng-repeat=\"titular in quotation.life.aseguradosList track by $index\"><span class=\"label-cotizacion\">Titular:</span><div><span class=\"value\">{{ titular.first_name }} {{ titular.last_name }} {{ titular.second_last_name }}</span></div><span class=\"label-cotizacion\">Fecha de nacimiento:</span><div><span class=\"value\">{{ titular.birthdate }}</span></div><span class=\"label-cotizacion\">Sexo:</span><div><span class=\"value\">{{ titular.sex }}</span></div><span class=\"label-cotizacion\">Antiguedad:</span><div><span class=\"value\">{{ titular.antiguedad }}</span></div><span class=\"label-cotizacion\">Fumador:</span><div><span ng-if=\"titular.smoker\" class=\"value\">Si</span> <span ng-if=\"!titular.smoker\" class=\"value\">No</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"quotation.ramo == \'Vida\' && quotation.document_type==1\"><span class=\"label-cotizacion\">Beneficiarios:</span><ul><li ng-repeat=\"benefciario in quotation.life.beneficiariesList track by $index\"><div><span class=\"value\">{{ benefciario.first_name }} {{ benefciario.last_name }} {{ benefciario.second_last_name }}</span></div><span class=\"label-cotizacion\">Fecha de nacimiento:</span><div><span class=\"value\">{{ benefciario.birthdate }}</span></div><span class=\"label-cotizacion\">Sexo:</span><div><span class=\"value\">{{ benefciario.sex }}</span></div><span class=\"label-cotizacion\">Antiguedad:</span><div><span class=\"value\">{{ benefciario.antiguedad }}</span></div></li></ul></div><div class=\"col-xs-12 form-group\" ng-if=\"quotation.subramo == \'Automóviles\' && quotation.document_type==1\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Conductor:</span><div><span class=\"value\">{{ quotation.auto.driver }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Marca:</span><div><span class=\"value\">{{ quotation.auto.brand }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Modelo:</span><div><span class=\"value\">{{ quotation.auto.model }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Año:</span><div><span class=\"value\">{{ quotation.auto.year }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Versión:</span><div><span class=\"value\">{{ quotation.auto.version }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Serie:</span><div><span class=\"value\">{{ quotation.auto.serial }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Motor:</span><div><span class=\"value\">{{ quotation.auto.engine }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Color:</span><div><span class=\"value\">{{ quotation.auto.color }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Matrícula:</span><div><span class=\"value\">{{ quotation.auto.license_plates }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Servcio:</span><div><span class=\"value\">{{ quotation.auto.service }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Estado de circulación:</span><div><span class=\"value\">{{ quotation.auto.state_circulation.state }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Monto de adaptación:</span><div><span class=\"value\">{{ quotation.auto.mont_adjustment }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Adaptación:</span><div><span class=\"value\">{{ quotation.auto.adjustment }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Monto de equipamiento:</span><div><span class=\"value\">{{ quotation.auto.mont_special_team }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Equipo especial:</span><div><span class=\"value\">{{ quotation.auto.special_team }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Uso:</span><div><span ng-if=\"quotation.auto.usage == 1\" class=\"value\">Particular</span> <span ng-if=\"quotation.auto.usage == \'2\'\" class=\"value\">Carga</span> <span ng-if=\"quotation.auto.usage == \'3\'\" class=\"value\">Servicio público</span></div></div></div><div class=\"col-xs-12 form-group\" ng-if=\"quotation.ramo == \'Daños\' && quotation.subramo != \'Automóviles\' && quotation.document_type==1\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Bien asegurado:</span><div><span class=\"value\">{{ quotation.danios.insured_item }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Detalles:</span><div><span class=\"value\">{{ quotation.danios.item_details }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"label-cotizacion\">Dirección:</span><div><span class=\"value\">{{ quotation.danios.item_address }}</span></div></div></div><div class=\"col-xs-12 form-group\" ng-if=\"quotation.document_type==3\"><label class=\"blue-color\">Póliza de Grupo</label><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"quotation.ramo == \'Daños\' && quotation.subramo != \'Automóviles\'\"><span class=\"label-cotizacion\">Inmuebles Cotizados:</span><div><span class=\"value\">{{ quotation.inmuebles_cotizados }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"quotation.subramo == \'Automóviles\'\"><span class=\"label-cotizacion\">Automóviles Cotizados:</span><div><span class=\"value\">{{ quotation.autos_cotizados }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"quotation.ramo == \'Vida\' || quotation.ramo == \'Accidentes y Enfermedades\'\"><span class=\"label-cotizacion\">Personas Cotizadas:</span><div><span class=\"value\">{{ quotation.personas_cotizadas }}</span></div></div></div></div></div><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"permiso_administrar_adjuntos\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 text-right form-group\" ng-if=\"uploader.queue.length >0\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(quotation.id)\">Guardar Archivos</button></div><table class=\"table table-bordered table\"><h3 class=\"text-center\">Archivos que estan actualmente en la base de datos</h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th ng-if=\"permiso_archivos\" width=\"200px\">Acciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_input\" class=\"form-control display-none\" ng-if=\"permiso_administrar_adjuntos\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"saveFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,files)\" ng-if=\"permiso_administrar_adjuntos\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"permiso_administrar_adjuntos\">Renombrar</button> <span class=\"btn btn-success display-none\">Guardar</span></td><td><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> * Archivo sensible</td></tr></tbody></table></div></div></div></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"quotation.cotizacion_primas && quotation.cotizacion_primas.length > 0\" class=\"col-xs-12 col-sm-6 form-group\"><div class=\"col-xs-12 form-group\" style=\"padding: 15px; border-radius: 6px; background-color: #ffffff; border: 1px solid #e5e7eb;\"><legend style=\"font-size: 18px; color: #333;\">📄 Respuesta de aseguradora</legend><div style=\"margin-top: 10px;\"><div ng-repeat=\"aseg in quotation.cotizacion_primas track by $index\" style=\"display: flex; align-items: center; margin-bottom: 10px;\"><input ng-change=\"updatePrimaAseguradora(aseg)\" type=\"checkbox\" ng-model=\"aseg.checked\" style=\"margin-right: 8px;\"> <span style=\"flex: 1; color: #333;\" class=\"value\">{{ aseg.aseguradora }}</span> <input ng-blur=\"updatePrimaAseguradora(aseg)\" class=\"form-control\" type=\"text\" ng-model=\"aseg.prima\" style=\"margin-left: 10px;\"></div></div></div></div><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 col-sm-6 col-md-2 form-group pull-right\" ng-if=\"quotation.status == \'En trámite\' || showEditInformation\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"changeStatus(quotation, 2)\">Emitir</button></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group pull-right\" ng-if=\"quotation.status == \'En trámite\' || showEditInformation\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"changeStatus(quotation, 3)\">Batear</button></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group pull-right\" ng-if=\"quotation.status!=\'Emitida.\'\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"editQuatation(quotation)\">Editar</button></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group pull-right\" ng-if=\"showEditInformation\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelQuatation()\">Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group pull-right\" ng-if=\"!showEditInformation\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"getCotizacionPDF(quotation)\">Generar PDF</button></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group pull-right\" ng-if=\"!showEditInformation\"><button class=\"col-xs-12 btn btn-dark\" ng-click=\"addcomentario(quotation)\">Comentario(s)</button></div></div><br><div class=\"col-md-12\" ng-if=\"addBitacora\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><comments datasource=\"comments_data\" typemodel=\"30\" config=\"comments_config\" idmodel=\"quotation.id\" receiptmodel=\"receiptmodel\" exportable=\"true\"></comments></div><div class=\"col-xs-6 form-group pull-right\" ng-if=\"quotation.task_associated\"><button type=\"button\" class=\"btn btn-white btn-sm btn-secondary\" ng-click=\"openModal(quotation.task_associated_info)\">{{ vm.isCollapsed ? \'Ocultar\' : \'Ver\' }} Tarea Origen</button></div></div></div></div></div></div></div></div></div></div></div></div><script type=\"text/javascript\">\n\n    function renombrarArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"td input\");\n  \n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n  \n      btnTag.addClass(\'display-none\');\n      dummy.removeClass(\'display-none\');\n  \n  \n      inputTag.removeClass(\'display-none\');\n      strongTag.addClass(\'display-none\');\n  \n      inputTag.focus();\n    }\n  \n    function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target);\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n  \n      // btnTag.prop(\'onclick\',null).off(\'click\');\n  \n      btnTag.removeClass(\'display-none\');\n      dummy.addClass(\'display-none\');\n  \n  \n      inputTag.addClass(\'display-none\');\n      strongTag.removeClass(\'display-none\');\n    }\n  </script>");
$templateCache.put("app/cotizacion/danios.form.html","<fieldset><legend align=\"right\">Datos de inmueble</legend><div class=\"ibox float-e-margins\"><form role=\"form\" ng-model=\"order.subforms\"><div class=\"form-group col-xs-12 col-md-6\"><label>Bien asegurado</label> <input class=\"form-control\" ng-model=\"quotationNew.danios.insured_item\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label>Detalles</label> <input class=\"form-control\" ng-model=\"quotationNew.danios.item_details\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-6\"><label>Direccion</label> <input class=\"form-control\" ng-model=\"quotationNew.danios.item_address\" type=\"text\"></div></form></div></fieldset>");
$templateCache.put("app/cotizacion/modal.email.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Compartir por Email</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!vm.show_binnacle\"><div class=\"col-lg-12\"><div class=\"panel-body\"><div><h4>Por favor ingrese el o los correo(s) electrónico(s) a quien se desea enviar un email:</h4><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Correo electrónico<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"email\" name=\"email_assign_mail\" ng-model=\"vmm.email_assign_mail\" required=\"\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"addEmail(vmm.email_assign_mail)\">Agregar</button></div></div><input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{email}}\" ng-show=\"owner_exist\" ng-click=\"addEmail(email)\"> <input class=\"btn btn-white btn-mt\" ng-repeat=\"correo in vmm.correos\" type=\"button\" name=\"\" value=\"{{correo.correo}}\" ng-click=\"addEmail(correo.correo)\"></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 input-group\"><input ng-change=\"load_provider_contacts(load_provider_contact)\" ng-model=\"load_provider_contact\" type=\"checkbox\" required=\"\">Cargar contactos de las aseguradoras</div><table ng-if=\"load_provider_contact\" class=\"table table-bordered\"><thead><th>Aseguradora</th><th>Contactos</th></thead><tr ng-repeat=\"aseguradora in vmm.aseguradoras\"><td>{{aseguradora.aseguradora}}</td><td><ul><li ng-repeat=\"contacto in aseguradora.contactos\">{{contacto.name}} - {{contacto.email}}<input style=\"margin-left: 5px;\" ng-model=\"contacto.checked_email\" type=\"checkbox\"></li></ul></td></tr></table></div></div><table ng-if=\"files && files.length\" class=\"table table-bordered\"><br><h3><span><i>Seleccione los archivos que desea compartir:</i></span></h3><thead><tr><th>Archivo</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong></td><td><div class=\"col-md-4\"><input type=\"checkbox\" ng-model=\"file.shared_email\" ng-change=\"shareFileEmail(file)\"> <label>Compartir</label></div><div class=\"col-md-4\"><a class=\"btn btn-primary pull-right\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a></div></td></tr></tbody></table><div class=\"form-group\"><br><label>Se enviara a:</label><table class=\"table table-bordered\" ng-if=\"emails.length > 0\"><thead><th>Correo electrónico</th><th>Acciones</th></thead><tr ng-repeat=\"email in emails track by $index\"><td>{{email}}</td><td><button class=\"btn btn-danger\" ng-click=\"remove_email($index)\"><i class=\"fa fa-trash\"></i></button></td></tr></table><table class=\"table table-bordered\" ng-if=\"load_provider_contact\"><thead><th>Correo electrónico [Ejecutivos - Aseguradoras]</th></thead><tr ng-repeat=\"aseguradora in vmm.aseguradoras\"><td ng-repeat=\"contacto in aseguradora.contactos\" ng-if=\"contacto.checked_email\">[{{aseguradora.aseguradora}}] -{{contacto.email}}</td></tr></table></div><div class=\"col-xs-12\"><div ng-if=\"permiso_administrar_adjuntos\"><div upload-template=\"\"></div></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"text-align-center\"><button class=\"btn btn-primary\" type=\"button\" name=\"savefiles\" ng-click=\"saveFilesEmail(vmm.quote.id)\">Guardar archivos</button></div></div><div class=\"form-group col-xs-12\"><label class=\"control-label\" for=\"title\">Mensaje</label><div ng-bind-html=\"vmm.head\" name=\"body\"></div><div text-angular=\"\" ng-model=\"vmm.first_comment\" name=\"second_comment\"></div></div><div class=\"col-md-4\"><input type=\"checkbox\" ng-model=\"sendPdf\" ng-change=\"check(sendPdf)\"> <label>Compartir pdf</label></div><div><button class=\"btn btn-primary pull-right ladda-button\" ng-click=\"sendEmail(people_assigned)\">Compartir por Email</button></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div><script>\n      function renombrarArchivoCargado(){\n        var strongTag = $(event.target).parent().parent().find(\"td strong\");\n        var inputTag = $(event.target).parent().parent().find(\"td input\");\n  \n        strongTag.hide();\n        inputTag.show();\n        inputTag.focus();\n      }\n  \n      function blurArchivoCargado(){\n        var strongTag = $(event.target).parent().parent().find(\"td strong\");\n        var inputTag = $(event.target);\n  \n        strongTag.show();\n        inputTag.hide();\n      }\n    </script><style type=\"text/css\">\n    .to_send  {\n      background-color: red;\n    }\n  </style>");
$templateCache.put("app/cotizacion/modal.emitir.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Emitir</h4></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"form-group col-sm-11\"><label for=\"motivo\">Selecciona una aseguradora: <span class=\"color-red\">*</span></label><div class=\"col-xs-12 col-sm-12 col-md-12 form-group\" ng-repeat=\"aseg in vmm.aseguradoras track by $index\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"vmm.aseguradora_seleccionada\" type=\"radio\" value=\"{{aseg}}\"> {{aseg}}</label></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"vmm.close()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success\" ng-disabled=\"vmm.aseguradora_seleccionada == \'\'\" ng-click=\"vmm.guardar()\" type=\"button\">Guardar</button></div>");
$templateCache.put("app/cotizacion/vida.form.html","<toaster-container></toaster-container><div class=\"row\"><div class=\"data-container\"><legend class=\"legend-title\" align=\"center\">Datos de asegurado</legend><div class=\"col-xs-12 form-group\"><button type=\"button\" ng-click=\"llenarAsegurado(quotationNew)\" class=\"btn btn-success pull-right\">Llenar con datos del Prospecto</button></div><div class=\"row\" ng-if=\"quotationNew.life.aseguradosList.length == 0\"><div class=\"col-xs-12\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"quotationNew.life.aseguradosList.length == 1\">Quitar Asegurado</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"quotationNew.aseguradosList.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Asegurados</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addAsegurado()\" type=\"button\">Agregar Asegurado</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addAsegurado()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"life_as in quotationNew.life.aseguradosList track by $index\"><div class=\"col-xs-12\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" ng-disabled=\"quotationNew.life.aseguradosList.length == 1\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"removeAsegurado($index)\">Quitar Asegurado</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"addAsegurado($index)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Asegurado #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addAsegurado()\" type=\"button\">Agregar Asegurado</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addAsegurado()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"names_aseg\">Nombre <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"life_as.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent\">Apellido Paterno <span class=\"color-red\">*</span></label> <input type=\"text\" ng-model=\"life_as.last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent_1\">Apellido Materno</label> <input type=\"text\" name=\"last_name_dependent_1\" ng-model=\"life_as.second_last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"life_as.birthdate\" value=\"{{life_as.birthdate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\" for=\"sex{{$index}}\"><label for=\"sex{{$index}}\">Sexo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"life_as.sex\" placeholder=\"\"><option value=\"\">Selecciona una opcion</option><option value=\"M\">MASCULINO</option><option value=\"F\">FEMENINO</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"ant{{$index}}\">Antigüedad</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"life_as.antiguedad\" value=\"{{life_as.antiguedad}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3form-group\"><label for=\"smoker{{$index}}\">Fumador <span class=\"color-red\">*</span></label><div><input type=\"radio\" ng-model=\"life_as.smoker\" name=\"smoker{{$index}}\" ng-value=\"\'True\'\"> Si<br><input type=\"radio\" ng-model=\"life_as.smoker\" name=\"smoker{{$index}}\" ng-value=\"\'False\'\"> No</div></div></div></div></div><div class=\"row\" ng-if=\"quotationNew.life.beneficiariesList.length == 0\"><div class=\"col-xs-12\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"life.beneficiariesList.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Beneficiarios</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiario()\" type=\"button\">Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiario()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"beneficiary in quotationNew.life.beneficiariesList track by $index\"><div class=\"col-xs-12\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"removeBeneficiario()\">Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"quotationNew.life.destroy($index,beneficiary)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiario()\" type=\"button\">Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiario()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 m-b\"><button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiary.person == 2\" ng-click=\"beneficiary.person = 1\">Fisica</button> <button class=\"btn btn-primary col-xs-6\" ng-if=\"beneficiary.person == 1\" ng-click=\"beneficiary.person = 1\">Fisica</button> <button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiary.person == 1\" ng-click=\"beneficiary.person = 2\">Moral</button> <button class=\"btn btn-primary col-xs-6\" ng-if=\"beneficiary.person == 2\" ng-click=\"beneficiary.person = 2\">Moral</button></div><div ng-if=\"beneficiary.person == 1\"><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"names_dependant\">Nombre <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"names_dependant\" ng-model=\"beneficiary.first_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent\">Apellido Paterno <span class=\"color-red\">*</span></label> <input type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent_1\">Apellido Materno</label> <input type=\"text\" name=\"last_name_dependent_1\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"parentesco\">Parentesco <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"parentesco\" ng-model=\"beneficiary.optional_relationship\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"beneficiary.birthdate\" value=\"{{beneficiary.birthdate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Sexo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"beneficiary.sex\" placeholder=\"\"><option value=\"\">Selecciona una opcion</option><option value=\"M\">MASCULINO</option><option value=\"F\">FEMENINO</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"ants{{$index}}\">Antigüedad</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"beneficiary.antiguedad\" value=\"{{beneficiary.antiguedad}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-md-3 form-group\"><label for=\"ben_percentage\">Porcentaje <span class=\"color-red\">*</span></label> <input type=\"number\" class=\"form-control\" ng-model=\"beneficiary.percentage\" minlength=\"1\" maxlength=\"3\" max=\"100\" min=\"1\" ng-change=\"percentage_life(beneficiary.percentage,$index)\"></div></div><div ng-if=\"beneficiary.person == 2\"><div class=\"col-xs-6 form-group\"><label for=\"nombre{{$index}}\">Razón Social <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiary.j_name\" type=\"text\"></div><div class=\"col-xs-6 form-group\"><label for=\"nombre{{$index}}\">RFC <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiary.rfc\" type=\"text\" maxlength=\"13\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"antm{{$index}}\">Antigüedad</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"beneficiary.antiguedad\" value=\"{{beneficiary.antiguedad}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div></div></div>");
$templateCache.put("app/emails/email_data_modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Correo de prueba</h4></div><div class=\"modal-body\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div><label>Correo electrónico <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"email\" step=\"any\" type=\"email\" placeholder=\"example@dominio.com\" required=\"true\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary ladda-button\" ng-click=\"ok()\">Enviar correo</button></div></div>");
$templateCache.put("app/emails/emails.config.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Correos Automáticos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a>Correos</a></li><li class=\"active\"><strong>Configuración</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Configuración de correos automáticos <span ng-if=\"vm.form.updated_at\" class=\"pull-right\" style=\"font-size: 11px\"><i>Ultima modificación: {{vm.form.updated_at | date: \'medium\'}}</i></span></h5><div ibox-tools=\"\"></div></div><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 float-e-margins m-b\"><div class=\"ibox-title\"><h2 class=\"text-align-center font-emails\">OT/Póliza</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">Solicitud</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.solicitud_pol\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(1)\"></i></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">Registro o Emisión</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.registro_pol\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(2)\"></i></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">Renovación</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.renovacion\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(9)\"></i></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 float-e-margins m-b\"><div class=\"ibox-title\"><h2 class=\"text-align-center font-emails\">Siniestros</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">Solicitud</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.solicitud_siniestro\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(3)\"></i></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">Trámite</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.tramite_siniestro\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(11)\"></i></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">Cancelación</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.cancelacion_siniestro\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(12)\"></i></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">Rechazo</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.rechazo_siniestro\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(13)\"></i></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">En espera</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.espera_siniestro\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(14)\"></i></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">Finalización</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.fin_siniestro\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(4)\"></i></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 float-e-margins m-b\"><div class=\"ibox-title\"><h2 class=\"text-align-center font-emails\">Cobranza</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">Al pagar un recibo</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.cobranza_pago\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(6)\"></i></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">Creación de nota de crédito</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.create_nota\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(7)\"></i></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">Al aplicar nota de crédito</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.apply_nota\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(8)\"></i></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 float-e-margins m-b\"><div class=\"ibox-title\"><h2 class=\"text-align-center font-emails\">Recordatorios</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">De pago</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.recordatorio_cob\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(5,vm.frecuencia)\"></i></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">De renovación</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.recordatorio_ren\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(10,vm.frecuencia)\"></i></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">De cumpleaños</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.recordatorio_cum\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.edithMailBirth(true)\"></i></div></div></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.saveConfig()\">Guardar Configuración</button></div></div></div></div></div></div><br><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"!vm.flagEmail && vm.reminder && (vm.rec || vm.ren)\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Configuraciones <span ng-if=\"vm.form.updated_at\" class=\"pull-right\" style=\"font-size: 11px\"><i>Ultima modificación: {{vm.form.updated_at | date: \'medium\'}}</i></span></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12 btn-mt\"><div class=\"table-responsive hidden-xs hidden-sm\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Id</th><th ng-if=\"vm.ren\">Tipo</th><th>Frecuencia</th><th ng-if=\"vm.ren\">Remitente</th><th><span ng-if=\"vm.rec\">Ramo</span><span ng-if=\"vm.ren\">SubRamo(s)</span></th><th ng-if=\"vm.rec\">Tipo Cobro</th><th><span>Aseguradora(s)</span></th><th>Texto</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"reminder in vm.reminders_payments track by $index\"><td>{{reminder.id}}</td><td ng-if=\"vm.ren\">{{ tipos_ren[reminder.type_policy] }}</td><td><span ng-if=\"vm.ren && reminder.days > 0\" style=\"font-weight: bold;\">{{reminder.days}} días</span> <span ng-if=\"vm.ren && reminder.relative_time > 0\">{{ relative_times[reminder.relative_time] | lowercase }}</span><span ng-if=\"vm.rec && reminder.days > 0\" style=\"font-weight: bold;\">{{reminder.days}} dias</span> <span ng-if=\"reminder.model==5 && reminder.relative_time > 0\">{{ relative_times_rec[reminder.relative_time] | lowercase }}</span> <span ng-if=\"reminder.model==5 && reminder.relative_time > 0\">{{ relative_dates_rec[reminder.relative_date] | lowercase }}</span> <span ng-if=\"reminder.model==10 && reminder.relative_time > 0\">{{relative_dates_ren[reminder.relative_date] | lowercase}}</span></td><td ng-if=\"vm.ren\"><span ng-if=\"reminder.remitente\">{{ reminder.remitente }}</span> <span ng-if=\"!reminder.remitente\">{{ vm.form.correoorg }}</span></td><td><span ng-if=\"vm.rec\">{{ ramos[reminder.ramo_code] }}</span> <span ng-if=\"vm.ren\"><div ng-repeat=\"s in reminder.subramosRen track by s.subramo_code\">{{s.subramo_name}}</div></span></td><td ng-if=\"vm.rec\">{{ cobro[reminder.tipo_cobro ]}}</td><td><span ng-if=\"vm.rec && reminder.aseguradorasRec\"><div ng-repeat=\"a in reminder.aseguradorasRec track by a.id\">{{a.alias}}</div></span> <span ng-if=\"vm.rec && reminder.aseguradorasRec.length ==0\"><div>Todas</div></span> <span ng-if=\"vm.ren\"><div ng-repeat=\"a in reminder.aseguradorasRen track by a.id\">{{a.alias}}</div></span></td><td><div ng-bind-html=\"reminder.text\" name=\"reminder.text\"></div></td><td><a class=\"btn btn-white btn-sm\" ng-click=\"vm.edithReminder(reminder)\" ng-disabled=\"false\" aria-disabled=\"false\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></a> <a ng-if=\"vm.rec\" class=\"btn btn-warning btn-sm ladda-button\" ng-click=\"vm.sendEmailR(reminder, reminder.text, reminder.model, reminder.ramo_code)\" ng-disabled=\"false\" aria-disabled=\"false\"><i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i></a> <a ng-if=\"vm.ren\" class=\"btn btn-warning btn-sm ladda-button\" ng-click=\"vm.sendEmailRPol(reminder, reminder.text, reminder.model,reminder.type_policy,reminder.subramos,reminder.aseguradoras)\" ng-disabled=\"false\" aria-disabled=\"false\"><i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-danger btn-sm\" ng-click=\"vm.deleteReminder(reminder)\" ng-disabled=\"false\" aria-disabled=\"false\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a></td></tr></tbody></table></div><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.addReminder()\">Agregar</button></div></div></div></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"vm.flagEmail\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title col-xs-12\"><h5>Configuración email: {{vm.title}}*</h5></div><div class=\"ibox-content\"><div class=\"form-group col-xs-12\"><label class=\"control-label\" for=\"title\">Texto del correo: <span class=\"color-red\">*</span></label><div class=\"form-group col-xs-12\"><button type=\"button\" class=\"btn btn-default ng-scope\" unselectable=\"on\" tabindex=\"-1\" ng-click=\"getFileTemplate()\" ng-disabled=\"!editor_focusTemplate\"><i class=\"fa fa-upload\"></i></button><div text-angular=\"\" ng-model=\"vm.email.text\" name=\"myEditorCreateTemplate\" ng-focus=\"focusEditorTemplate()\" ng-blur=\"unfocusEditorTemplate()\"></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"vm.saveEmail(vm.email.text)\">Guardar Correo</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"vm.sendEmail_Data(vm.email.subject, vm.email.text, vm.model,vm.email)\">Enviar correo de prueba</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div ng-show=\"!vm.flagEmail && vm.reminder && vm.reminder_edith\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title col-xs-12\"><h5>Configuración email: {{vm.title}}</h5></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12 col-sm-4 form-group\" ng-show=\"vm.rec\"><div class=\"row\"><div class=\"col-xs-12 col-sm-5 form-group\"><label>Días:</label><input type=\"number\" class=\"form-control\" style=\"width: 80px;\" ng-model=\"vm.email.days\" ng-disabled=\"vm.email.vencimiento || vm.email.relative_time==3\" min=\"0\"></div><div class=\"col-xs-12 col-sm-5 form-group\"><label>Frecuencia:</label><select class=\"form-control\" name=\"frecuencia\" ng-model=\"vm.email.relative_time\" required=\"\" ng-change=\"updateVencimiento()\"><option value=\"1\">Antes de</option><option value=\"2\">Después de</option><option value=\"3\">Día 0</option></select></div></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-show=\"!vm.rec\"><div class=\"row\"><div class=\"col-xs-12 col-sm-3 col-md-2 form-group\"><label>Días:</label> <input type=\"number\" class=\"form-control\" style=\"width: 80px;\" ng-model=\"vm.email.days\" ng-disabled=\"vm.email.vencimiento\"></div><div class=\"col-xs-12 col-sm-5 form-group\"><label>Frecuencia:</label><select class=\"form-control\" name=\"frecuencia\" ng-model=\"vm.email.relative_time\" required=\"\" ng-change=\"updateVencimiento()\"><option value=\"1\">Antes de</option><option value=\"2\">Después de</option><option value=\"3\">Al vencer</option></select></div></div></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\" ng-show=\"vm.rec\"><label>Filtrar por:</label><div><input type=\"radio\" ng-model=\"vm.email.relative_date\" name=\"inicio_vigencia\" ng-value=\"1\"> Inicio de vigencia<br><input type=\"radio\" ng-model=\"vm.email.relative_date\" name=\"vencimiento\" ng-value=\"2\"> Vencimiento</div></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-if=\"!vm.rec\"><label>Filtrado por:</label><div><p>Fecha Fin de Vigencia</p></div></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-if=\"!vm.rec\"><label>Tipo</label><select class=\"form-control\" ng-model=\"vm.email.tipo\" ng-change=\"vm.changeTipo(vm.form.tipo)\"><option value=\"\" disabled=\"\">Selecciona el tipo</option><option value=\"0\">Todos los tipos</option><option value=\"1\">Póliza Ind</option><option value=\"2\">Póliza Ind de Colectividad</option><option value=\"3\">Póliza Grupo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"vm.rec\"><label>Ramo</label><select class=\"form-control\" ng-model=\"vm.email.ramo\" ng-change=\"vm.changeRamo(vm.form.ramo)\"><option value=\"\" disabled=\"\">Selecciona el ramo</option><option value=\"0\">Todos los ramos</option><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"!vm.rec\"><label>Subramo(s):</label><select class=\"js-example-basic-multiple form-control\" id=\"mySelect2\" name=\"mySelect2\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.subramo_code\" ng-change=\"selectSubramos(select_sramo)\"></select><div class=\"col-xs-12\" ng-if=\"vm.ren && vm.email.subramos\"><span ng-if=\"vm.ren\"><div ng-repeat=\"s in vm.email.subramosRen track by s.subramo_code\">{{s.subramo_name}}</div></span></div></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\" ng-show=\"vm.rec\"><label>Tipo de cobro</label><select class=\"form-control\" ng-model=\"vm.email.tipo_cobro\" ng-init=\"vm.email.tipo_cobro = 2\"><option value=\"0\">No Domiciliado</option><option value=\"1\">Domiciliado y Otros</option><option value=\"3\">Domiciliado</option><option value=\"4\">No Domiciliado y Agente</option><option value=\"2\">Todos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"vm.rec\"><label>Tipo Recibo</label><select class=\"form-control\" ng-model=\"vm.email.receipt_type\" ng-change=\"vm.changeRamo(vm.form.receipt_type)\"><option selected=\"\" value=\"0\">Todos los recibos</option><option value=\"1\">Recibos Póliza/Endoso</option><option value=\"2\">Recibos Póliza</option><option value=\"3\">Notas de Crédito</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"vm.rec\"><label>Aseguradora(s)*</label><select class=\"js-example-basic-multiple form-control\" id=\"mySelectrc\" name=\"mySelectrc\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select><div class=\"col-xs-12\" ng-if=\"vm.rec && vm.email.aseguradoras\"><span ng-if=\"vm.rec\"><div ng-repeat=\"s in vm.email.aseguradorasRec track by s.id\">{{s.alias}}</div></span></div><label class=\"blue-color\" ng-if=\"vm.email.aseguradorasRec.length == 0 || select_provider.length ==0\">Si el campo Aseguradora(s) esta vacío se entenderá que se han seleccionado todas las Aseguradoras sin excepción</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"!vm.rec\"><label>Aseguradora(s):</label><select class=\"js-example-basic-multiple form-control\" id=\"mySelectm\" name=\"mySelectm\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select><div class=\"col-xs-12\" ng-if=\"vm.ren && vm.email.aseguradoras\"><span ng-if=\"vm.ren\"><div ng-repeat=\"s in vm.email.aseguradorasRen track by s.id\">{{s.alias}}</div></span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.ren\"><label class=\"control-label\" for=\"title\">Remitente: <span class=\"color-red\">*</span></label> <input style=\"min-width: 100%; max-width: 100%;\" class=\"form-control\" ng-model=\"vm.email.remitente\" type=\"text\" required=\"\"></div><div class=\"form-group col-xs-12\"><label class=\"control-label\" for=\"title\">TEXTO SUPERIOR<span class=\"color-red\">*</span></label><div text-angular=\"\" ng-model=\"vm.email.text\"></div></div><div class=\"form-group col-xs-12\"><label class=\"control-label\" for=\"title\">TEXTO INFERIOR<span class=\"color-red\">*</span></label><div text-angular=\"\" ng-model=\"vm.email.text_end\"></div></div><div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"vm.saveEmailR(vm.email, vm.email.text, vm.model)\">Guardar Correo</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"vm.ren\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"vm.sendEmail_Data(vm.email.subject, vm.email.text, \'renovacion\',vm.email)\">Enviar correo de prueba</button></div></div></div></div></div></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"vm.flagEmailCumple\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title col-xs-12\"><h5>Configuración Correo Electrónico de Cumpleaños:</h5></div><div class=\"ibox-content\"><div class=\"col-xs-12 form-group\"><label class=\"control-label\" for=\"title\">Remitente: <span class=\"color-red\">*</span></label> <input style=\"min-width: 100%; max-width: 100%;\" class=\"form-control\" ng-model=\"vm.emailCumple.remitente\" type=\"text\" required=\"\"></div><div class=\"form-group col-xs-12\"><label class=\"control-label\" for=\"title\">Asunto: <span class=\"color-red\">*</span></label> <input style=\"min-width: 100%; max-width: 100%;\" class=\"form-control\" ng-model=\"vm.emailCumple.subject\" type=\"text\" required=\"\"></div><div class=\"form-group col-xs-12\"><label class=\"control-label\" for=\"title\">Contenido: <span class=\"color-red\">*</span></label> <label style=\"min-width: 100%; max-width: 100%;\" class=\"form-control\" disabled=\"\">Estimado(a): (Nombre Cumpleañero)</label> <button type=\"button\" class=\"btn btn-default ng-scope\" unselectable=\"on\" tabindex=\"-1\" ng-click=\"getFile()\" ng-disabled=\"!editor_focus\"><i class=\"fa fa-upload\"></i></button><div text-angular=\"\" name=\"myEditorCreate\" ng-focus=\"focusEditor()\" ng-blur=\"unfocusEditor()\" ng-model=\"vm.emailCumple.text\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.edithMailBirth(false)\">Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"vm.saveEmailBirth(vm.emailCumple)\">Guardar Correo</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"vm.emailCumple\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"vm.sendEmail_Data(vm.emailCumple.subject, vm.emailCumple.text, \'cumple\',vm.emailCumple)\">Enviar correo de prueba</button></div></div></div></div></div></div><script type=\"text/javascript\">\n  // $(\'#mySelect2\').select2().trigger(\'change\');\n  // $(\'#mySelectm\').select2().trigger(\'change\');\n</script>");
$templateCache.put("app/emails/smtp.config.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Configuracion SMTP</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a>Correos</a></li><li class=\"active\"><strong>Configuración SMTP</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Configuración de SMTP</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12 col-sm-12 col-md-6 float-e-margins m-b\"><div class=\"ibox-title\"><h2 class=\"text-align-center font-emails\">SMTP</h2></div><div class=\"ibox-content\"><div class=\"col-xs-12 form-group\"><label class=\"\">Nombre Remitente <span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><input type=\"text\" ng-model=\"vm.form.name\" class=\"ng-valid ng-dirty ng-touched form-control\"></div></div><div class=\"col-xs-12 form-group\"><label>Usuario <span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><span class=\"input-group-addon\">@</span> <input class=\"form-control\" type=\"email\" name=\"email_assign_mail\" ng-model=\"vm.form.username\" required=\"\" disabled=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Contraseña <span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-lock\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"password\" name=\"email_assign_mail\" ng-model=\"vm.form.password\" required=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Servidor de correo saliente (SMTP)<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-server\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"text\" name=\"smtp_server\" ng-model=\"vm.form.host\" required=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Puerto<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><span class=\"input-group-addon\"><b>#</b></span> <input class=\"form-control\" type=\"number\" name=\"port\" ng-model=\"vm.form.port\" required=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>&nbsp;</label><div class=\"col-xs-12 col-sm-6 col-md-3 input-group\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.saveConfig()\">Guardar Configuración</button></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 float-e-margins m-b\"><div class=\"ibox-title\"><h2 class=\"text-align-center font-emails\">SMTP Organizacional</h2></div><div class=\"ibox-content\"><div class=\"col-xs-12 form-group\"><label class=\"\">Nombre Remitente <span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><input type=\"text\" ng-model=\"vm.form_org.name\" class=\"ng-valid ng-dirty ng-touched form-control\"></div></div><div class=\"col-xs-12 form-group\"><label>Usuario <span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><span class=\"input-group-addon\">@</span> <input class=\"form-control\" type=\"text\" name=\"org_username\" ng-model=\"vm.form_org.username\" required=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Contraseña <span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-lock\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"password\" name=\"email_assign_mail\" ng-model=\"vm.form_org.password\" required=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Servidor de correo saliente (SMTP)<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-server\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"text\" name=\"smtp_server\" ng-model=\"vm.form_org.host\" required=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Puerto<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><span class=\"input-group-addon\"><b>#</b></span> <input class=\"form-control\" type=\"number\" name=\"port\" ng-model=\"vm.form_org.port\" required=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Firma</label><div text-angular=\"\" ng-model=\"vm.form_org.signature\"></div></div><div class=\"col-xs-12 form-group\"><label>&nbsp;</label><div class=\"col-xs-12 col-sm-6 col-md-3 input-group\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.saveConfigOrg()\">Guardar Configuración</button></div></div><br><form ng-if=\"banner_edith\"><div class=\"form-group col-xs-12\"><label>Banner Superior :</label> <input class=\"col-xs-12 form-control\" type=\"file\" onchange=\"angular.element(this).scope().addFile(\'header\',this.files)\" ng-model=\"vm.b_super\"></div><div class=\"form-group col-xs-12\"><label>Banner Inferior:</label> <input class=\"col-xs-12 form-control\" type=\"file\" onchange=\"angular.element(this).scope().addFile(\'footer\',this.files)\" ng-model=\"vm.b_infer\"></div></form><button ng-if=\"banner_edith\" class=\"btn btn-primary\" type=\"button\" ng-click=\"saveFilesHF()\" title=\"Guardar Firma\">Guardar</button> <button ng-if=\"banner_edith\" class=\"btn btn-danger\" type=\"button\" ng-click=\"CancelEdithBanner()\" title=\"Guardar Firma\">Cancelar</button> <button ng-if=\"!banner_edith\" class=\"btn btn-default\" type=\"button\" ng-click=\"edithBanner()\" title=\"Editar Banner\">Editar Banner</button></div></div></div></div></div></div><br>");
$templateCache.put("app/emails/whatsapp.config.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Recordatorio Pago vía Whatsapp/SMS</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a>Whatsapp/SMS</a></li><li class=\"active\"><strong>Configuración Whatsapp/SMS</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Configuración de Whatsapp/SMS <span ng-if=\"vm.form.updated_at\" class=\"pull-right\" style=\"font-size: 11px\"><i>Ultima modificación: {{vm.form.updated_at | date: \'medium\'}}</i></span></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12 float-e-margins m-b\"><div class=\"ibox-title\"><h2 class=\"text-align-center font-emails\">Recordatorios Automático Whatsapp/SMS</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color col-xs-6\">De pago Whatsapp/SMS</span><div class=\"col-xs-6\" align=\"center\"><div class=\"col-xs-6\"><input ng-model=\"vm.form.recordatorio_sms\" type=\"checkbox\"></div><div class=\"col-xs-6\"><i class=\"fa fa-pencil fa-lg\" aria-hidden=\"true\" ng-click=\"vm.selectModel(15,vm.frecuencia)\"></i></div></div></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.saveConfig()\">Guardar Configuración</button></div></div><div class=\"row col-xs-12\"><div class=\"col-xs-12 col-sm-8 form-group\"><label><input type=\"checkbox\" ng-model=\"vm.form.activar_contacto_dudas\" ng-change=\"vm.saveConfig()\"> Activar campo de Dudas o Comentarios</label></div><div class=\"col-xs-12 col-sm-8 form-group\" ng-if=\"vm.form.activar_contacto_dudas\"><label>Dudas o Comentarios:</label> <input class=\"form-control\" type=\"text\" ng-model=\"contacto_dudas\"></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.form.activar_contacto_dudas\" style=\"padding-top:25px;\" title=\"Guardar contacto de Dudas o Comentarios\"><button class=\"btn-xs btn-sm btn-primary\" ng-click=\"vm.saveContacto(contacto_dudas)\"><i class=\"btn btn-sm btn-primary fa fa-save\" ng-click=\"saveContacto(contacto_dudas)\" aria-hidden=\"true\"></i></button></div></div></div></div></div></div><br><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"!vm.flagEmail && vm.reminder && vm.recsms\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Configuraciones <span ng-if=\"vm.form.updated_at\" class=\"pull-right\" style=\"font-size: 11px\"><i>Ultima modificación: {{vm.form.updated_at | date: \'medium\'}}</i></span></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12 btn-mt\"><div class=\"table-responsive hidden-xs hidden-sm\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Id</th><th>Tipo Recibo</th><th>Tipo Mensaje</th><th>Frecuencia</th><th>Fecha Seleccionada</th><th><span ng-if=\"vm.recsms\">Ramo</span></th><th ng-if=\"vm.recsms\">Tipo Cobro</th><th><span>Aseguradora(s)</span></th><th>Mensaje</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"reminder in reminders_payments track by $index\"><td>{{reminder.id}}</td><td>{{ tipos_recsms[reminder.receipt_type] }}</td><td>{{ tipos_message[reminder.type_message] }}</td><td><span ng-if=\"vm.recsms\">{{ frecuencies_dict[reminder.frequency] }}</span></td><td><span ng-if=\"vm.recsms\">{{fechas[reminder.tipo_fecha]}}</span></td><td><span ng-if=\"vm.recsms\">{{ ramos[reminder.ramo_code] }}</span></td><td ng-if=\"vm.recsms\">{{ cobro[reminder.tipo_cobro ]}}</td><td><span ng-if=\"vm.recsms && reminder.aseguradorasRecWhatsapp\"><div ng-repeat=\"a in reminder.aseguradorasRecWhatsapp track by a.id\">{{a.alias}}</div></span> <span ng-if=\"vm.recsms && reminder.aseguradorasRecWhatsapp.length ==0\"><div>Todas</div></span></td><td><div ng-bind-html=\"reminder.text\" name=\"reminder.text\"></div></td><td><a class=\"btn btn-white btn-sm\" ng-click=\"vm.edithReminder(reminder)\" ng-disabled=\"false\" aria-disabled=\"false\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"vm.deleteReminder(reminder)\" ng-disabled=\"false\" aria-disabled=\"false\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a> <a ng-if=\"vm.recsms\" class=\"btn btn-warning btn-sm ladda-button\" ng-click=\"vm.sendEmailRWhatsapp(reminder, reminder.text, reminder.model, reminder.frequency, reminder.ramo_code)\" ng-disabled=\"false\" aria-disabled=\"false\"><i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i></a></td></tr></tbody></table></div><div ng-if=\"vm.show_pag_search && vm.search_config.count > 10\" class=\"text-center\"><pagination config=\"vm.search_config\" model=\"vm.search_results\"></pagination></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.addReminder();tipoMensaje(2)\">Agregar</button></div></div></div></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"vm.flagEmail\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title col-xs-12\"><h5>Configuración email: {{vm.title}}</h5></div><div class=\"ibox-content\"><div class=\"form-group col-xs-12\"><label class=\"control-label\" for=\"title\">Texto del correo: <span class=\"color-red\">*</span></label> <textarea style=\"min-width: 100%; max-width: 100%; height: 200px; max-height: 400px; max-height: 600px;\" class=\"form-control\" ng-model=\"vm.email.text\" type=\"text\" required=\"\"></textarea></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"vm.saveEmail(vm.email.text)\">Guardar Correo</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"vm.sendEmail_Data(vm.email.subject, vm.email.text, vm.model)\">Enviar correo de prueba</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div ng-show=\"!vm.flagEmail && vm.reminder && vm.reminder_edith\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title col-xs-12\"><h5>Configuración Mensajería: {{vm.title}}</h5></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12\"><div class=\"row col-xs-12 col-xs-6 col-md-6 form-group\"><div class=\"col-xs-12\" align=\"center\"><label class=\"blue-color\">Tipo de Mensaje</label></div><div class=\"col-xs-12 col-md-6 form-group margin-top-24 text-center\"><input name=\"look_folio_pago\" value=\"1\" ng-change=\"tipoMensaje(vm.email.type_message)\" ng-model=\"vm.email.type_message\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"look_folio_pago\">Whatsapp</span></div><div class=\"col-xs-12 col-md-6 form-group margin-top-24 text-center\"><input name=\"look_folio_pago\" value=\"2\" ng-change=\"tipoMensaje(vm.email.type_message)\" ng-model=\"vm.email.type_message\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"look_folio_pago\">SMS</span></div></div><div class=\"row col-xs-12 col-xs-6 col-md-6 form-group border-left\"><div class=\"col-xs-12\" align=\"center\"><label class=\"blue-color\">Tipo de Recibos</label></div><div class=\"col-xs-12 col-md-3 form-group margin-top-24 text-center\"><input name=\"type_receipt\" value=\"1\" ng-model=\"vm.email.receipt_type\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"type_receipt\">Póliza</span></div><div class=\"col-xs-12 col-md-3 form-group margin-top-24 text-center\"><input name=\"type_receipt\" value=\"2\" ng-model=\"vm.email.receipt_type\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"type_receipt\">Endoso</span></div><div class=\"col-xs-12 col-md-3 form-group margin-top-24 text-center\"><input name=\"type_receipt\" value=\"3\" ng-model=\"vm.email.receipt_type\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"type_receipt\">Nota Crédito</span></div><div class=\"col-xs-12 col-md-3 form-group margin-top-24 text-center\"><input name=\"type_receipt\" value=\"0\" ng-model=\"vm.email.receipt_type\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"type_receipt\">Todos</span></div></div></div><br><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"vm.recsms\"><label>Frecuencia<span class=\"color-red\">*</span></label><div><select class=\"form-control\" name=\"frecuencia\" ng-model=\"vm.email.frequency\" ng-change=\"vm.changeFrecuency()\" required=\"\"><option value=\"\" class=\"\" selected=\"selected\" disabled=\"\">Selecciona una frecuencia</option><option label=\"-30 DIAS ANTES DEL\" value=\"1\">-30 DIAS ANTES DEL</option><option label=\"-15 DIAS ANTES DEL\" value=\"2\">-15 DIAS ANTES DEL</option><option label=\"-5 DIAS ANTES DEL\" value=\"3\">-5 DIAS ANTES DEL</option><option label=\"+5 DIAS POSTERIORES A\" value=\"5\">+5 DIAS POSTERIORES A</option><option label=\"+10 DIAS POSTERIORES A\" value=\"6\">+10 DIAS POSTERIORES A</option><option label=\"+15 DIAS POSTERIORES A\" value=\"7\">+15 DIAS POSTERIORES A</option><option label=\"-10 DIAS ANTES DEL\" value=\"8\">-10 DIAS ANTES DEL</option><option label=\"-20 DIAS ANTES DEL\" value=\"9\">-20 DIAS ANTES DEL</option><option label=\"+20 DIAS POSTERIORES A\" value=\"10\">+20 DIAS POSTERIORES A</option><option label=\"Vencido\" value=\"4\">Vencido</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"vm.recsms\"><label>Filtrar por:</label><div><input type=\"radio\" ng-model=\"vm.email.tipo_fecha\" name=\"inicio_vigencia\" ng-value=\"1\"> Inicio de vigencia<br><input type=\"radio\" ng-model=\"vm.email.tipo_fecha\" name=\"vencimiento\" ng-value=\"2\"> Vencimiento</div></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"vm.recsms\"><label>Ramo</label><select class=\"form-control\" ng-model=\"vm.email.ramo\" ng-change=\"vm.changeRamo(vm.form.ramo)\"><option value=\"\" disabled=\"\">Selecciona el ramo</option><option value=\"0\">Todos los ramos</option><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"vm.recsms\"><label>Tipo de cobro</label><select class=\"form-control\" ng-model=\"vm.email.tipo_cobro\" ng-init=\"vm.email.tipo_cobro = 2\"><option value=\"0\">No Domiciliado</option><option value=\"1\">Domiciliado y Otros</option><option value=\"3\">Domiciliado</option><option value=\"4\">No Domiciliado y Agente</option><option value=\"2\">Todos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"vm.recsms\"><label>Aseguradora(s)*</label><select class=\"js-example-basic-multiple form-control\" id=\"mySelectrc\" name=\"mySelectrc\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select><div class=\"col-xs-12\" ng-if=\"vm.recsms && vm.email.aseguradoras\"><span ng-if=\"vm.recsms\"><div ng-repeat=\"s in vm.email.aseguradorasRecWhatsapp track by s.id\">{{s.alias}}</div></span></div><label class=\"blue-color\" ng-if=\"vm.email.aseguradorasRecWhatsapp.length == 0 || select_provider.length ==0\">Si el campo Aseguradora(s) esta vacío se entenderá que se han seleccionado todas las Aseguradoras sin excepción</label></div><div class=\"form-group col-xs-12 col-sm-6\" ng-if=\"(vm.email.type_message == 0 || vm.email.type_message ==1)\"><label>Plantillas de Whatsapp:</label><select class=\"form-control\" ng-options=\"item.mensaje for item in plantillasWhatsapp\" ng-change=\"changePlantillaWha(plantilla)\" ng-model=\"plantilla\"><option value=\"\" disabled=\"\">Selecciona una plantilla</option></select></div><div class=\"form-group col-xs-12 col-sm-6\" ng-if=\"(vm.email.type_message == 2)\"><label>Plantillas de SMS:</label><select class=\"form-control\" ng-options=\"item.text for item in plantillaSMS\" ng-change=\"changePlantillaSMS(plantilla)\" ng-model=\"plantilla\"><option value=\"\" disabled=\"\">Selecciona una plantilla</option></select></div><div class=\"form-group col-xs-12\"><label>Mensaje:</label> <textarea ng-if=\"vm.email.type_message ==1\" class=\"col-xs-8 form-control textarea-modal\" ng-model=\"vm.email.text\" disabled=\"\"></textarea> <textarea ng-if=\"vm.email.type_message ==2\" class=\"col-xs-8 form-control textarea-modal\" ng-model=\"vm.email.text\"></textarea><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"vm.saveEmailR(vm.email, vm.email.text, vm.model)\">Guardar Configuración</button></div></div></div></div></div></div><br><div class=\"row\"><div class=\"col-xs-12\"></div></div><script type=\"text/javascript\">\n  // $(\'#mySelect2\').select2().trigger(\'change\');\n  // $(\'#mySelectm\').select2().trigger(\'change\');\n</script>");
$templateCache.put("app/endoso/endosos.collectivity.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Endosos colectivos</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 class=\"col-xs-12\">Agregar endosos colectivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-md-6\" ng-if=\"vm.acceso_adm_pol || vmacceso_adm_fia\"><label for=\"brand\">Endosos manual</label><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 radio\"><label><label ng-class=\"{\'receipts-select\': endorsement_type_manual == \'caratula\'}\"><input type=\"radio\" ng-model=\"endorsement_type_manual\" ng-click=\"valueRadioManual(endorsement_type_manual)\" ng-value=\"\'caratula\'\"> Para carátula</label></label></div><div class=\"col-xs-12 col-sm-6 radio\"><label class=\"margin-top-15\"><label ng-class=\"{\'receipts-select\': endorsement_type_manual == \'certificado\'}\"><input type=\"radio\" ng-model=\"endorsement_type_manual\" ng-click=\"valueRadioManual(endorsement_type_manual)\" ng-value=\"\'certificado\'\" title=\"Busque la carátula, de click en Buscar, después seleccione el certificado y, enseguida click en Elegir\"> Para certificado</label></label></div></div><br><label>Carátula:</label><br><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.word\" change=\"vm.getCollet(vm.word)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getType(vm.word)\"><span class=\"fa fa-search\"></span> Buscar</button></div></div><br><br><div ng-if=\"endosoBy == \'certificado\' && existCertificates\" class=\"form-group\" title=\"Click en Elegir para asignar endoso\"><label>Titular/Serie:</label><br><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteDataCertificate\" model=\"vm.word_certificate\" change=\"vm.getCertificate(vm.word_certificate)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getTypeCertificate(vm.word_certificate)\"><span class=\"fa fa-ballot\"></span>Elegir</button></div></div></div></div><div class=\"col-xs-12 col-sm-6 border-left\" style=\"border-left-color: #2E9AFE;\"><div class=\"col-xs-12\"><label for=\"files\">Endosos masivos</label></div><div class=\"col-xs-12 col-sm-6\" align=\"center\"><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': end_type == \'altas\'}\"><input type=\"radio\" ng-model=\"end_type\" ng-click=\"valueRadio(end_type)\" value=\"altas\"> Altas</label></div></div><div class=\"col-xs-12 col-sm-6\" align=\"center\"><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': end_type == \'bajas\'}\"><input type=\"radio\" ng-model=\"end_type\" ng-click=\"valueRadio(end_type)\" value=\"bajas\"> Bajas</label></div></div><div name=\"files\" class=\"row\" ng-if=\"end_type == \'bajas\' || end_type == \'altas\'\"><div class=\"form-group col-xs-12\"><input class=\"btn btn-default col-xs-12\" type=\"file\" fileread=\"\" ng-model=\"excelFile\" name=\"readCsvFile\" id=\"readCsvFile\" ng-change=\"selectExcel(excelFile)\" ng-disabled=\"inputFileDisabled\"></div></div></div><div class=\"col-xs-12 form-group margin-top-15\" ng-if=\"vm.acceso_reg_end\"><h3 class=\"color-blue\" ng-if=\"certs_json.length == 0\"><input type=\"checkbox\" name=\"register\" ng-disabled=\"(!vm.selectedType.name)\" ng-checked=\"checkSelected_caratula(checkRegister)\" ng-model=\"checkRegister\"> Registrar Endoso</h3><h3 class=\"color-blue\" ng-if=\"certs_json.length\"><input type=\"checkbox\" name=\"register\" ng-disabled=\"(certs_json.length == 0)\" ng-checked=\"checkSelected(checkRegister)\" ng-model=\"checkRegister\"> Registrar Endoso*</h3></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.typeForm === \'manualEndorsement\'\"><div class=\"col-xs-12 col-md-3 form-group\"><label for=\"selectType\" ng-init=\"vm.mexicanada ? vm.selectedType = vm.types[3] : vm.selectedType = vm.types[0]\">Tipo de endoso <span class=\"red-color\" ng-init=\"vm.mexicanada ? typeEndosos(vm.selectedType) : false\">*</span></label><select class=\"form-control margin-bottom-10\" ng-model=\"vm.selectedType\" ng-options=\"type as type.name for type in vm.types track by type.id\" ng-change=\"typeEndosos(vm.selectedType)\"></select></div><div class=\"col-xs-12 col-md-3 form-group\"><label for=\"selectType\">Concepto <span class=\"red-color\">*</span></label><select class=\"form-control margin-bottom-10\" ng-model=\"vm.selectedConcept\" ng-options=\"type as type.name for type in vm.manualConcept track by type.id\" ng-change=\"conceptEndoso(vm.selectedConcept)\"><option value=\"\" disabled=\"\">Selecciona un concepto</option></select></div><div class=\"col-xs-12 col-md-3 form-group\" ng-if=\"vm.typeEndoso === \'A\' || vm.typeEndoso === \'B\' || vm.typeEndoso === \'D\'\"><label>Vigencia desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.start_of_validity\" ng-change=\"changeUntil()\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-md-3 form-group\" ng-if=\"vm.typeEndoso === \'A\' || vm.typeEndoso === \'B\' || vm.typeEndoso === \'D\'\"><label>Vigencia hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_of_validity\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"otros\" ng-show=\"vm.typeForm === \'manualEndorsement\'\"><label for=\"\">Agregue el concepto <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"otros\" ng-model=\"vm.form.other_desc\" class=\"form-control\"></div><div ng-if=\"endosoBy == \'caratula\'\"><div ng-if=\"vm.certificates.length > 0 && vm.selectedConcept.id == 27\" class=\"form-group col-xs-12 col-sm-3\"><label>Certificado a Reconocer la Antigüedad<span class=\"red-color\">*</span></label><select class=\"form-control margin-bottom-10\" ng-model=\"vm.certificate_selected\" ng-options=\"certs as certs.certificate_number for certs in vm.certificates track by certs.id\" ng-change=\"certif_selected_ant(vm.certificate_selected)\"></select></div><div class=\"col-xs-12 col-md-3 form-group\" ng-if=\"(vm.typeEndoso === \'A\' || vm.typeEndoso === \'B\' || vm.typeEndoso === \'D\') && vm.selectedConcept.id == 27\"><label>Fecha de Antigüedad:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.antiguedad\" ng-change=\"changeAntig(vm.form.antiguedad)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.conceptSel == 43 && endosoBy == \'caratula\'\"><label>Forma de Pago Actual:</label><div class=\"form-control\" ng-bind=\"(vm.policy.forma_de_pago | payformtype)\" disabled=\"\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.conceptSel == 43 && endosoBy == \'caratula\'\"><label>Seleccione la nueva forma de pago: <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"payment\" ng-model=\"vm.form.payment\" ng-options=\"payment as payment.label for payment in vm.payform track by payment.value\"><option value=\"\" disabled=\"\">Selecciona forma de pago</option></select></div></div><div ng-if=\"(vm.typeEndoso === \'A\' || vm.typeEndoso === \'B\' || vm.typeEndoso === \'D\') && vm.typeForm === \'manualEndorsement\'\"><div ng-if=\"endosoBy == \'caratula\'\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Detalles</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-sm-4\"><h3 align=\"center\">Contratante</h3><hr><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Nombre:</span><div><span>{{vm.contractor.name}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Tipo de persona:</span><div><span>{{vm.contractor.type_person}}</span></div></div><div class=\"form-group col-xs-12\" style=\"word-wrap: break-word\"><span class=\"blue-color\">Correo:</span><div><span>{{vm.contractor.email}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Teléfono:</span><div><span>{{vm.contractor.phone_number}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Dirección:</span><div><span>{{vm.contractor.address}}</span></div></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><h3 align=\"center\">Información</h3><hr><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Identificador:</span><div><span>{{vm.policy.identifier}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Tipo de administración:</span><div><span>{{vm.policy.administration_type}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Vigencia desde:</span><div><span>{{vm.policy.start_of_validity | date: \'dd/MM/yyyy\'}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Vigencia hasta:</span><div><span>{{vm.policy.end_of_validity | date: \'dd/MM/yyyy\'}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Estatus:</span><div><span>{{vm.policy.status}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{vm.policy.aseguradora.alias}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Clave del agente:</span><div><span>{{vm.policy.clave.clave}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Forma de pago:</span><div><span>{{vm.policy.forma_de_pago | payformtype}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Ramo:</span><div><span>{{vm.policy.ramo.ramo_name}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Subramo:</span><div><span>{{vm.policy.subramo.subramo_name}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Frecuencia de pago:</span><div><span>{{vm.policy.f_currency}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Moneda:</span><div><span>{{vm.policy.f_currency}}</span></div></div></div></div></div></div><div class=\"form-group col-xs-12 col-md-3\" ng-if=\"vm.typeEndoso === \'A\' && vm.conceptSel == 31 && endosoBy == \'caratula\'\"><label for=\"selectType\">Certificados existentes <span class=\"red-color\">*</span></label><select class=\"form-control margin-bottom-10\" ng-model=\"vm.selectedCertificado\" ng-options=\"cert as cert.certificate_number for cert in vm.certsCollect track by cert.id\" ng-change=\"certificateSelected(vm.selectedCertificado)\"></select></div><div class=\"col-xs-12\"><div><div ng-if=\"vm.manualForm == 2 && subramoCode == 3\"><div class=\"row address-container\" ng-repeat=\"relationship in subforms.relationshipList track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"options.relationshipList.destroy($index,relationship)\">Quitar Dependiente</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"options.relationshipList.destroy($index,relationship)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Dependiente #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"options.relationshipList.add(subforms.relationshipList)\" type=\"button\">Agregar Dependiente</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"options.relationshipList.add(subforms.relationshipList)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-2 col-lg-1 col-md-1 col-sm-1 form-group\"><label for=\"names_dependant\">Certificado</label> <input id=\"names_dependant{{$index}}\" name=\"names_dependant{{$index}}\" class=\"form-control\" ng-model=\"numCertificado\" type=\"text\" readonly=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"nombre{{$index}}\">Nombre</label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"relationship.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last{{$index}}\">Apellido Paterno</label> <input id=\"last{{$index}}\" name=\"last{{$index}}\" class=\"form-control\" ng-model=\"relationship.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"relationship.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"parentesco{{0}}\">Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"relationship.relationship\" ng-options=\"r.option for r in relation track by r.option\"><option value=\"\" disabled=\"\">Selecciona</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.birthdate\" value=\"{{relationship.birthdate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"gender{{$index}}\">Sexo</label><select class=\"form-control\" ng-options=\"sex as sex.name for sex in sex track by sex.value\" ng-model=\"relationship.sex\"><option value=\"\" disabled=\"\">Selecciona</option></select></div></div></div></div><div ng-if=\"vm.manualForm == 2 && subramoCode== 1\"><div class=\"row address-container\" ng-repeat=\"beneficiary in subforms.beneficiariesList track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"options.beneficiary.destroy($index,beneficiary); delBeneficiary()\">Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"options.beneficiary.destroy($index,beneficiary)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"options.beneficiary.add();addBeneficiary()\" type=\"button\">Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"options.beneficiary.add()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div ng-if=\"beneficiary.person == 1\"><div class=\"col-xs-2 col-lg-1 col-md-1 col-sm-1 form-group\"><label for=\"names_dependant\">Certificado</label> <input id=\"names_dependant{{$index}}\" name=\"names_dependant{{$index}}\" class=\"form-control\" ng-model=\"numCertificado\" type=\"text\" readonly=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"names_dependant\">Nombre</label> <input type=\"text\" name=\"names_dependant\" ng-model=\"beneficiary.first_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent\">Apellido Paterno</label> <input type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"last_name_dependent_1\">Apellido Materno</label> <input type=\"text\" name=\"last_name_dependent_1\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"parentesco\">Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"beneficiary.optional_relationship\" ng-options=\"r.option for r in relation track by r.option\"><option value=\"\" disabled=\"\">Selecciona</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"beneficiary.birthdate\" value=\"{{beneficiary.birthdate}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Sexo</label><select class=\"form-control\" ng-model=\"beneficiary.sex\" placeholder=\"\"><option value=\"\">Selecciona una opcion</option><option value=\"M\">MASCULINO</option><option value=\"F\">FEMENINO</option></select></div><div class=\"col-xs-12 col-md-3 form-group\"><label for=\"ben_percentage\">Porcentaje</label> <input type=\"number\" class=\"form-control\" ng-model=\"beneficiary.percentage\" minlength=\"1\" maxlength=\"3\" max=\"100\" min=\"1\"></div></div><div ng-if=\"beneficiary.person == 2\"><div class=\"col-xs-6 form-group\"><label for=\"nombre{{$index}}\">Razón Social <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiary.j_name\" type=\"text\"></div><div class=\"col-xs-6 form-group\"><label for=\"nombre{{$index}}\">RFC</label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiary.rfc\" type=\"text\" maxlength=\"13\"></div></div></div></div></div></div></div></div><div ng-if=\"endosoBy == \'certificado\'\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Detalles</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-sm-4\"><h3 align=\"center\">Contratante</h3><hr><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Nombre:</span><div><span>{{vm.contractor.name}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Tipo de persona:</span><div><span>{{vm.contractor.type_person}}</span></div></div><div class=\"form-group col-xs-12\" style=\"word-wrap: break-word\"><span class=\"blue-color\">Correo:</span><div><span>{{vm.contractor.email}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Teléfono:</span><div><span>{{vm.contractor.phone_number}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Dirección:</span><div><span>{{vm.contractor.address}}</span></div></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><h3 align=\"center\">Información</h3><hr><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Número Certificado:</span><div><span>{{vm.certificado_for_endoso.certificate_number}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Vigencia desde:</span><div><span>{{vm.certificado_for_endoso.init_date | date: \'dd/MM/yyyy\'}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Vigencia hasta:</span><div><span>{{vm.certificado_for_endoso.end_date | date: \'dd/MM/yyyy\'}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6\"><span class=\"blue-color\">Estatus:</span><div><span>{{status(vm.certificado_for_endoso.status)}}</span></div></div><div class=\"col-xs-12\"><h3 align=\"center\">Información Carátula</h3><hr><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{vm.policy.aseguradora.alias}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Clave del agente:</span><div><span>{{vm.policy.clave.clave}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Ramo:</span><div><span>{{vm.policy.ramo.ramo_name}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Subramo:</span><div><span>{{vm.policy.subramo.subramo_name}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Frecuencia de pago:</span><div><span>{{vm.policy.f_currency}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><span class=\"blue-color\">Moneda:</span><div><span>{{vm.policy.f_currency}}</span></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 form-group\"><label for=\"description\">Descripción del endoso <span class=\"red-color\">*</span></label> <textarea class=\"form-control\" ng-model=\"vm.observations\" name=\"description\"></textarea></div><div class=\"col-sm-12\" ng-if=\"vm.typeEndoso === \'B\'\"><div class=\"row\"><div ng-include=\"\'app/endoso/type/manual.html\'\"></div></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.selectedType.id\"><div class=\"row\"><div upload-template=\"\"></div></div></div></div><div ng-if=\"checkRegister\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Registro del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número del Endoso<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"otros\" ng-model=\"vm.form.number_endorsement\" ng-blur=\"checkNumEndoso(vm.poliza_number_data)\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.selectedType.name === \'A\'\" ng-init=\"numberReceipts()\"><label>Número de Recibos<span class=\"color-red\">*</span></label><select ng-model=\"vm.form.num_receipts\" ng-options=\"item.value as item.name for item in vm.num_receipts_data\" ng-change=\"vm.selectNumReceipts(vm.form.num_receipts)\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.selectedType.name === \'D\'\" ng-init=\"numberReceipts()\"><label>Número de Notas<span class=\"color-red\">*</span></label><select ng-model=\"vm.form.num_notas\" ng-options=\"item.value as item.name for item in vm.num_notes_data\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.form.num_receipts == 0 && checkRegister || vm.form.num_receipts > 0 && checkRegister\"><div><div class=\"col-xs-12 form-group\" ng-if=\"certs_json.length == 0\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Debes Calcular y generar recibos aunque el número de recibos sea igual a cero.</div></div><div ng-if=\"certs_json.length == 0\"><endorsement-receipts tosave=\"vm.form\" form=\"vm.form\" policy=\"vm.policy\"></endorsement-receipts></div><div ng-if=\"certs_json.length > 0\"><endorsement-receipts tosave=\"vm.form\" form=\"vm.form\" policy=\"policy\"></endorsement-receipts></div></div></div><div ng-if=\"vm.selectedType.name === \'D\' && vm.form.num_notas == 0 || vm.selectedType.name === \'D\' && vm.form.num_notas > 0\"><div class=\"col-xs-12 form-group\"><hr><h3>Notas de Crédito</h3></div><form name=\"formStatusD\"><div class=\"row col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Folio:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"folio\" ng-model=\"vm.form.folio\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de Emisión:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input class=\"width-100 text-align-center form-control\" type=\"text\" name=\"startDate\" ng-model=\"vm.form.fecha_emision\" value=\"{{vm.form.fecha_emision}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Prima Neta:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"prima_neta\" ng-model=\"vm.form.p_neta\" required=\"\" ng-change=\"calculatePT()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>IVA:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" type=\"tel\" id=\"iva\" ng-model=\"vm.form.iva\" required=\"\" ng-change=\"editIva(\'iva\');\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Recargo por Pago Fraccionado:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" type=\"tel\" id=\"rpf\" ng-model=\"vm.form.rpf\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Gastos de Expedición:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"prima-neta\" ng-model=\"vm.form.gastos_expedicion\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-success btn-mt\" ng-disabled=\"formStatusD.$invalid\" ng-click=\"calculateNote(vm.form); calculatePT()\" id=\"calcularD\" type=\"submit\">Calcular</button></div></form><div ng-if=\"vm.credit_notes.length\" class=\"row col-xs-12\"><div class=\"col-xs-12\"><table class=\"table table-stripped\"><thead><tr><th>Nota</th><th>Fecha inicio</th><th>Fecha fin</th><th>Prima Neta</th><th>IVA</th><th>RPF</th><th>Sub Total</th><th>Gastos de expedición</th><th>Prima Total</th></tr></thead><tbody ng-repeat=\"notes in vm.credit_notes track by $index\"><tr><td><span ng-if=\"!vm.editNotes\">{{ notes.folio }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.folio\" ng-enter=\"calculateNote(vm.form, notes, $index)\"></td><td><span ng-if=\"!vm.editNotes && !(notes.initDate == null || notes.initDate == \'\' || notes.initDate == undefined || !notes.initDate || notes.initDate == \'Invalid Date\')\">{{ notes.initDate | date: \'dd/MM/yyyy\' }}</span><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"vm.editNotes\"><input type=\"text\" name=\"initDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.initDate\" value=\"Seleccione fecha\" ng-change=\"changeSinceE(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"(notes.initDate == null || notes.initDate == \'\' || notes.initDate == undefined || !notes.initDate || notes.initDate == \'Invalid Date\') && !vm.editNotes\"><input type=\"text\" name=\"initDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.initDate\" value=\"Seleccione fecha\" ng-change=\"changeSinceE(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></td><td><span ng-if=\"!vm.editNotes && !(notes.endDate == null || notes.endDate == \'\' || notes.endDate == undefined || !notes.endDate || notes.endDate == \'Invalid Date\')\">{{ notes.endDate | date: \'dd/MM/yyyy\' }}</span><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"vm.editNotes\"><input type=\"text\" name=\"endDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.endDate\" value=\"{{notes.endDate}}\" ng-change=\"changeUntilE(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"(notes.endDate == null || notes.endDate == \'\' || notes.endDate == undefined || !notes.endDate || notes.endDate == \'Invalid Date\') && !vm.editNotes\"><input type=\"text\" name=\"endDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.endDate\" value=\"{{notes.endDate}}\" ng-change=\"changeUntilE(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></td><td><span ng-if=\"!vm.editNotes\">{{ notes.prima_neta }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.prima_neta\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td><td><span ng-if=\"!vm.editNotes\">{{ notes.iva }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.iva\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td><td><span ng-if=\"!vm.editNotes\">{{ notes.rpf }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.rpf\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td><td><span ng-if=\"!vm.editNotes\">{{ notes.sub_total }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.sub_total\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td><td><span ng-if=\"!vm.editNotes\">{{ notes.gastos_expedicion }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.gastos_expedicion\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td><td><span ng-if=\"!vm.editNotes\">{{ notes.prima_total }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.prima_total\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td></tr></tbody></table><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-click=\"vm.editNotes ? vm.editNotes = false : vm.editNotes = true\"><span ng-if=\"!vm.editNotes\">Editar Notas</span> <span ng-if=\"vm.editNotes\">Guardar</span></button></div></div></div></div></div><div class=\"col-xs-12 form-group btn-mt\" ng-if=\"vm.typeForm === \'manualEndorsement\'\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"!checkRegister && vm.acceso_adm_ot\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"createEndorsement()\"><span class=\"fa fa-save\"></span> Crear Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"checkRegister && vm.acceso_reg_end && vm.acceso_adm_ot\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"createEndorsement()\"><span class=\"fa fa-check-square\"></span> Registrar Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"vm.typeForm === \'manualEndorsement\'\"><button class=\"col-xs-12 btn btn-danger\" ui-sref=\"endorsement.lista\" type=\"button\"><span class=\"fa fa-times-circle\"></span> Cancelar</button></div></div><div ng-show=\"vm.typeForm === \'masivoEndorsement\'\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Certificados</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div upload-template=\"\"></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-10\"><div class=\"col-md-12\"><div id=\"endorsemented_tree\" class=\"treeview\"></div></div></div><div class=\"col-xs-12 col-md-2\"><div class=\"form-group col-md-12 pull-right\"><button type=\"button\" ng-click=\"vm.massive()\" class=\"btn btn-block btn-primary\">Cargar</button></div></div></div></div></div></div></div>");
$templateCache.put("app/endoso/endosos.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Editar Endoso de Fianza</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Editar Endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Datos de la Fianza</legend></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Número de Fianza:</span><div><span>{{ vm.insurance.poliza_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Fiado:</span><div><span>{{ vm.insurance.juridical.j_name }}{{ vm.insurance. natural.full_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Beneficiario(s):</span><div><span ng-repeat=\"beneficiario in vm.insurance.beneficiaries_poliza_many track by $index\">{{ beneficiario.full_name }}{{ beneficiario.j_name }}<br><span><span ng-if=\"vm.insurance.beneficiaries_poliza_many.length == 0\">Sin beneficiarios</span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Compañía:</span><div><span>{{ vm.insurance.aseguradora.alias }}{{ vm.insurance.afianzadora.alias }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.insurance.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ vm.insurance.end_of_validity | date: \'dd/MM/yyyy\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Estatus</span><div><span>{{ status(vm.insurance.status) }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ vm.insurance.ramo.ramo_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.insurance.subramo.subramo_name }}<span></span></span></div></div><div class=\"col-xs-12 form-group\"><hr></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Concepto del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"\">Concepto:<span class=\"color-red\">*</span></label><select class=\"form-control\" disabled=\"\" ng-options=\"concept.value as concept.label for concept in concepts track by concept.value\" ng-model=\"vm.form.concept\" ng-change=\"vm.changeConcept()\"><option value=\"\" disabled=\"\">Selecciona un concepto</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"\">Tipo de endoso:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in vm.types track by type.name\" ng-model=\"vm.form.endorsement_type\" disabled=\"\" ng-change=\"vm.changeTipo()\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.concept == 4\"><label for=\"\">Agregue el concepto: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"otros\" ng-model=\"vm.form.other_desc\" class=\"form-control\"></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del endoso</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia desde: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" disabled=\"\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.init_date\" ng-change=\"changeUntil()\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia hasta: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" ng-disabled=\"!(vm.form.concept == 54 || vm.form.concept.value == 54)\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_date\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.form.concept == 55 || vm.form.concept.value == 55\"><label>Fecha Anuencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.anuency\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del endoso: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"vm.form.observations\" name=\"description\"></textarea></div><div ng-if=\"vm.form.concept == 53 || vm.form.concept.value == 53\"><div class=\"col-md-12 col-sm-12 form-group\"><fieldset><legend align=\"right\">Detalle de Garantía</legend><div class=\"ibox float-e-margins\"><div class=\"form-group col-xs-12 col-md-8\"><label>Descripción <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.change.description\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto a garantizar <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.form.change.guarantee_amount\" type=\"number\" ng-change=\"validateDecimalMontoTotal(vm.form.subforms.contract.guarantee_amount)\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Tarifa aplicable <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.change.rate\" ng-change=\"percentageRange(vm.form.subforms.contract.rate)\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div><div ng-if=\"vm.insurance.ramo.ramo_name == \'Fidelidad\'\"><div class=\"form-group col-xs-12 col-md-4\"><label>Giro de la empresa <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.change.business_activity\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Nombre del empleado <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.change.employee_name\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Actividad que realiza <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.change.activity\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Deducible <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.change.deductible_percentage\" ng-change=\"percentageRange(vm.form.subforms.contract.deductible_percentage)\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div></div><div ng-if=\"vm.insurance.subramo.subramo_name == \'Obra\' || vm.insurance.subramo.subramo_name == \'Proveeduria\'\"><div class=\"form-group col-xs-12 col-md-4\"><label>Número de contrato <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.change.number\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Plazo del documento fuente <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.change.start\" value=\"{{vm.form.subforms.contract.start}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>al <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.change.end\" value=\"{{vm.form.subforms.contract.end}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de firma del contrato <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.change.sign_date\" value=\"{{vm.form.subforms.contract.sign_date}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto del contrato <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.form.change.amount\" type=\"number\" ng-change=\"validateDecimalMontoTotal(vm.form.subforms.contract.amount)\"></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto del contrato con IVA <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.form.change.amount_iva\" type=\"number\" ng-change=\"validateDecimalMontoTotal(vm.form.subforms.contract.amount_iva)\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Porcentaje a garantizar <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.change.guarantee_percentage\" ng-change=\"percentageRange(vm.form.subforms.contract.guarantee_percentage)\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div></div></div></fieldset></div></div><div class=\"col-md-12 col-sm-12 form-group\" id=\"modal_in\" ng-if=\"vm.form.concept == 34 || vm.form.concept.value == 34\"><fieldset><legend align=\"right\">Beneficiarios</legend><div ng-repeat=\"beneficiaries_fianza in vm.form.change track by $index\"><div class=\"row address-container\"><div class=\"col-xs-12 legend-gray\"><br><br><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBene($index, vm.form.subforms.beneficiaries_fianza)\">Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteBene($index, beneficiaries_fianza)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Nuevo Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBene(beneficiaries_fianza)\" type=\"button\">Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBene(beneficiaries_fianza)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 m-b\"><button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 2\" ng-click=\"beneficiaries_fianza.type_person = 1\">Física</button> <button class=\"btn btn-primary col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 1\" ng-click=\"beneficiaries_fianza.type_person = 1\">Física</button> <button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 1\" ng-click=\"beneficiaries_fianza.type_person = 2\">Moral</button> <button class=\"btn btn-prymary col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 2\" ng-click=\"beneficiaries_fianza.type_person = 2\">Moral</button></div><div ng-if=\"beneficiaries_fianza.type_person == 1\"><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"nombre{{$index}}\">Nombre <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"last{{$index}}\">Apellido Paterno <span class=\"color-red\">*</span></label> <input id=\"last{{$index}}\" name=\"last{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.second_last_name\" type=\"text\"></div></div><div ng-if=\"beneficiaries_fianza.type_person == 2\"><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"nombre{{$index}}\">Razón Social <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.j_name\" type=\"text\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">RFC <span class=\"color-red\">*</span></label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.rfc\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Email <span class=\"color-red\">*</span></label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.email\" type=\"email\" placeholder=\"example@example.com\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Teléfono <span class=\"color-red\">*</span></label><phonenumber-directive model=\"beneficiaries_fianza.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"beneficiaries_fianza.phone_number\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div></div></div></div></fieldset></div></div><div class=\"row\"><hr><div><div ng-if=\"vm.form.status == 2 && vm.acceso_reg_end\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Registro del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número del Endoso<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"otros\" ng-model=\"vm.form.number_endorsement\"></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.checkRegister && vm.insurance.type_endorsement != \'B\' && vm.insurance.type_endorsement.id != \'B\'\"><div><receipts-endorsement form=\"vm.to_receipts\" tosave=\"vm.form\" type=\"2\"></receipts-endorsement></div></div><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"vm.acceso_adm_ot\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"save()\">Actualizar Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/endoso/endosos.fianza.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Crear Endoso de Fianza</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Agregar Endoso</h5></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"vm.showFinder\"><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.acceso_adm_fia\"><label>Número de Fianza: <span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.to_search\" change=\"vm.findContractor(vm.to_search)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" ng-click=\"vm.getPolicy()\" class=\"btn btn-success\">Buscar</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Datos de la Fianza</legend></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Número de Fianza:</span><div><span>{{ vm.insurance.poliza_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Fiado:</span><div><span>{{ vm.insurance.contractor.full_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Beneficiario(s):</span><div><span ng-repeat=\"beneficiario in vm.insurance.beneficiaries_poliza_many track by $index\">{{ beneficiario.full_name }}{{ beneficiario.j_name }}<br><span><span ng-if=\"vm.insurance.beneficiaries_poliza_many.length == 0\">Sin beneficiarios</span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Compañía:</span><div><span>{{ vm.insurance.aseguradora.alias }}{{ vm.insurance.afianzadora.alias }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.insurance.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ vm.insurance.end_of_validity | date: \'dd/MM/yyyy\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Estatus</span><div><span>{{ status(vm.insurance.status) }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ vm.insurance.ramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.insurance.subramo }}<span></span></span></div></div><div class=\"col-xs-12 form-group\"><hr></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Concepto del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"\">Concepto:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"conceptSelected\" ng-options=\"concept as concept.label for concept in concepts track by concept.value\" ng-change=\"vm.changeConcept(conceptSelected); saveLocalstorange();\"><option value=\"\" disabled=\"\">Selecciona un concepto</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"\">Tipo de endoso:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in vm.types track by type.name\" ng-model=\"vm.insurance.type_endorsement\" ng-change=\"vm.changeTipo(vm.insurance.type_endorsement); saveLocalstorange();\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.concept == 4 || vm.insurance.concept == 4\"><label for=\"\">Agregue el concepto: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"otros\" ng-model=\"vm.form.other_desc\" ng-change=\"saveLocalstorange()\" class=\"form-control\"></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del endoso</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia desde: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.start_of_validity\" ng-change=\"changeUntil()\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia hasta: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_of_validity\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.insurance.concept.value == 55 || vm.insurance.concept == 55\"><label>Fecha Anuencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.anuency\" ng-change=\"saveLocalstorange()\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del endoso: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"vm.form.observations\" ng-change=\"saveLocalstorange()\" name=\"description\"></textarea></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.insurance.concept.value == 60 || vm.insurance.concept == 60\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Anulación de la Fianza</legend></div><hr><div class=\"col-xs-12 col-sm-12 form-group\"><label class=\"blue-color\">Concepto de Anulación: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"concept_anulacion.value as concept_anulacion.label for concept_anulacion in vm.concept_anulacion\" ng-change=\"conceptAnnSelection(vm.conceptAnnulment)\" name=\"conceptAnn\" ng-model=\"vm.conceptAnnulment\"></select></div><div class=\"col-xs-12 col-sm-12\" ng-if=\"vm.conceptAnnulment\"><label class=\"blue-color\">Razón de Anulación: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" name=\"reason\" ng-model=\"vm.reason_cancel\" ng-change=\"saveLocalstorange()\"></textarea></div></div><div class=\"col-xs-12 col-sm-12 row\" ng-if=\"vm.insurance.concept.value == 61 || vm.insurance.concept == 61\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Cancelación de la Fianza</legend></div><hr><div class=\"col-xs-12 col-sm-6 form-group\"><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><label class=\"blue-color\">Fecha de cancelación: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.fecha_cancelacion\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=\"blue-color\">Monto de Cancelación: <span class=\"color-red\">*</span></label> <input type=\"text\" class=\"form-control\" name=\"reason\" ng-model=\"vm.monto_cancelacion\" ng-change=\"saveLocalstorange()\"></div></div><div ng-if=\"vm.insurance.concept.value == 53 || vm.insurance.concept == 53 || vm.insurance.concept.value == 57 || vm.insurance.concept == 57 || vm.insurance.concept.value == 58 || vm.insurance.concept == 58 || vm.insurance.concept.value == 59|| vm.insurance.concept == 59 || vm.insurance.concept.value == 62 || vm.insurance.concept == 62\"><div class=\"col-md-12 col-sm-12 form-group\"><fieldset><legend align=\"right\">Detalle de Garantía</legend><div class=\"ibox float-e-margins\"><div class=\"form-group col-xs-12 col-md-8\"><label>Descripción <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.contract_poliza.description\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto a garantizar <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.form.contract_poliza.guarantee_amount\" type=\"text\" ng-change=\"validateDecimalMontoTotal(vm.form.contract_poliza.guarantee_amount)\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Tarifa aplicable <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.contract_poliza.rate\" ng-change=\"percentageRange(vm.form.subforms.contract.rate)\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div><div ng-if=\"vm.insurance.ramo == \'Fidelidad\'\"><div class=\"form-group col-xs-12 col-md-4\"><label>Giro de la empresa <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.contract_poliza.business_activity\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Nombre del empleado <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.contract_poliza.employee_name\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Actividad que realiza <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.contract_poliza.activity\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Deducible <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.contract_poliza.deductible_percentage\" ng-change=\"percentageRange(vm.form.subforms.contract.deductible_percentage)\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div></div><div ng-if=\"vm.insurance.subramo == \'Obra\' || vm.insurance.subramo == \'Proveeduria\'\"><div class=\"form-group col-xs-12 col-md-4\"><label>Número de contrato <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.contract_poliza.number\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Plazo del documento fuente <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.contract_poliza.start\" value=\"{{vm.form.subforms.contract.start}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>al <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.contract_poliza.end\" value=\"{{vm.form.subforms.contract.end}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de firma del contrato <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.contract_poliza.sign_date\" value=\"{{vm.form.subforms.contract.sign_date}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto del contrato <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.form.contract_poliza.amount\" type=\"text\" ng-change=\"validateDecimalMontoTotal(vm.form.subforms.contract.amount)\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto del contrato con IVA <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.form.contract_poliza.amount_iva\" type=\"text\" ng-change=\"validateDecimalMontoTotal(vm.form.subforms.contract.amount_iva)\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\" disabled=\"\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Porcentaje a garantizar <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.contract_poliza.guarantee_percentage\" ng-change=\"percentageRange(vm.form.subforms.contract.guarantee_percentage)\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div></div></div></fieldset></div></div><div class=\"col-md-12 col-sm-12 form-group\" id=\"modal_in\" ng-if=\"vm.insurance.concept.value == 34 || vm.insurance.concept == 34\"><fieldset><legend align=\"right\">Beneficiarios</legend><div ng-repeat=\"beneficiaries_fianza in vm.form.beneficiaries_fianza track by $index\"><div class=\"row address-container\"><div class=\"col-xs-12 legend-gray\"><br><br><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteBene($index)\">Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteBene($index, beneficiaries_fianza)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Nuevo Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addBene(beneficiaries_fianza)\" type=\"button\">Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addBene(beneficiaries_fianza)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 m-b\"><button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 2\" ng-click=\"beneficiaries_fianza.type_person = 1\">Física</button> <button class=\"btn btn-primary col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 1\" ng-click=\"beneficiaries_fianza.type_person = 1\">Física</button> <button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 1\" ng-click=\"beneficiaries_fianza.type_person = 2\">Moral</button> <button class=\"btn btn-prymary col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 2\" ng-click=\"beneficiaries_fianza.type_person = 2\">Moral</button></div><div ng-if=\"beneficiaries_fianza.type_person == 1\"><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"nombre{{$index}}\">Nombre <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.first_name\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"last{{$index}}\">Apellido Paterno <span class=\"color-red\">*</span></label> <input id=\"last{{$index}}\" name=\"last{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.last_name\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" ng-change=\"saveLocalstorange()\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.second_last_name\" type=\"text\"></div></div><div ng-if=\"beneficiaries_fianza.type_person == 2\"><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"nombre{{$index}}\">Razón Social <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" ng-change=\"saveLocalstorange()\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.j_name\" type=\"text\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">RFC <span class=\"color-red\">*</span></label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.rfc\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Email</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.email\" ng-change=\"saveLocalstorange()\" type=\"email\" placeholder=\"example@example.com\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Teléfono</label><phonenumber-directive model=\"beneficiaries_fianza.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"beneficiaries_fianza.phone_number\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div></div></div></div></fieldset></div></div><div class=\"row\"><hr><div><div class=\"col-xs-12 form-group\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"row\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.acceso_reg_end\"><h3 class=\"color-blue\"><label><input type=\"checkbox\" name=\"register\" ng-change=\"vm.registry_endorsement()\" ng-model=\"vm.checkRegister\" ng-disabled=\"vm.checkRegister\"> &nbsp;Registrar Endoso</label></h3></div><div ng-if=\"vm.checkRegister && vm.acceso_reg_end\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Registro del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número del Endoso<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"otros\" ng-model=\"vm.form.number_endorsement\" ng-change=\"saveLocalstorange()\"></div></div><div class=\"col-xs-12 form-group\"><div class=\"row\"></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.checkRegister && vm.insurance.type_endorsement != \'B\' && vm.insurance.type_endorsement.id != \'B\'\"><div class=\"col-xs-12 col-sm-6 col-md-6 nopadding form-group\"><label>Bono Afianzadora:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"text\" ng-model=\"vm.form.bono_variable\" ng-change=\"saveLocalstorange()\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de Bono</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.date_bono\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkFechaBono(vm.form.date_bono)\" ng-init=\"vm.checkFechaBono(vm.form.date_bono)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de emisión de la Factura</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.date_emision_factura\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkFechaFactura(vm.form.date_emision_factura)\" ng-init=\"vm.checkFechaFactura(vm.form.date_emision_factura)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectMontEmision\">Mes de Emisión de Factura</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in month.options\" ng-model=\"vm.form.month.month_selected\" ng-init=\"vm.form.month.month_selected = 0\" ng-change=\"changemonth()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"year\">Año Factura</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"vm.form.year_factura\" ng-change=\"changeyaer(vm.form.year_factura)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Folio Factura</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" value=\"{{vm.form.folio_factura}}\" ng-model=\"vm.form.folio_factura\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Maquila</label> <input class=\"form-control\" name=\"maquila\" type=\"text\" value=\"{{vm.form.maquila}}\" ng-model=\"vm.form.maquila\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de Maquila</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.date_maquila\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkFechaMaquila(vm.form.date_maquila)\" ng-init=\"vm.checkFechaFactura(vm.form.date_maquila)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div><receipts-endorsement form=\"vm.to_receipts\" tosave=\"vm.form\" type=\"2\"></receipts-endorsement></div></div><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"vm.acceso_adm_ot\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"vm.save()\">Crear Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ui-sref=\"endorsement.lista\" type=\"button\">Cancelar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/endoso/endosos.fianza.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a ui-sref=\"endorsement.lista\">Endosos</a></li><li class=\"active\"><strong>Endoso {{vm.insurance.internal_number}}</strong></li></ol></div></div><br><div class=\"btn-group pull-right m-b option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_ver_fia\"><a ng-click=\"goToPolicy(\'Información fianza\', \'fianzas.info\', vm.insurance.policy.id)\">Ver Fianza</a></li><li ng-if=\"vm.acceso_adm_ot && vm.insurance.status != 2\"><a ng-click=\"goToEdit(vm.insurance.id)\">Editar Endoso</a></li><li ng-if=\"vm.acceso_elim_end\"><a ng-click=\"anulateEndorsment(vm.insurance)\">Anular Endoso</a></li><li><a ng-click=\"vm.getPDF(vm.insurance.id)\">Ver PDF</a></li><li ng-if=\"vm.acceso_elim_end\"><a ng-click=\"deleteEndorsment(vm.insurance)\">Eliminar Endoso</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length && vm.acceso_form\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, vm.insurance.policy.id, carta.id)\">{{carta.name}}</a></li><li><a ng-click=\"vm.getPDF(vm.insurance.id)\">Resumen PDF</a></li></ul></li></ul></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"vm.insurance.number_endorsement\">Endoso</h5><h5 ng-if=\"!vm.insurance.number_endorsement\">OT</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button> <button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(vm.insurance,10)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4\"><legend class=\"legend-title\" align=\"center\" ng-if=\"vm.insurance.policy.document_type == 7\">Fianza</legend><legend class=\"legend-title\" align=\"center\" ng-if=\"vm.insurance.policy.document_type == 8\">Fianza Colectiva</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\"><b>Contratante</b>:</span><div><span>{{ vm.insurance.policy.contractor.full_name}}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.insurance.policy.poliza_number\"><span class=\"blue-color\">Número de Fianza:</span><div><span>{{ vm.insurance.policy.poliza_number }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.insurance.policy.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ vm.insurance.policy.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ vm.insurance.policy.aseguradora.alias }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Creada por:</span><div><span>{{ vm.insurance.policy.owner }}</span></div></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"vm.showRecordatorios()\">{{vm.insurance.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><legend class=\"legend-title\" align=\"center\">Endoso</legend><div class=\"col-xs-12 col-sm-4 form-group\" style=\"word-wrap: break-word;\" ng-if=\"vm.insurance.status == 2\"><span class=\"blue-color\"><b>Número de endoso</b>:</span><div><span>{{ vm.insurance.number_endorsement }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\" style=\"word-wrap: break-word;\"><span class=\"blue-color\">Tipo:</span><div><span>{{ vm.insurance.endorsement_type }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\" style=\"word-wrap: break-word;\" ng-if=\"!(vm.insurance.status == 2)\"><span class=\"blue-color\">Folio interno:</span><div><span>{{ vm.insurance.internal_number }}</span></div></div><div ng-if=\"vm.insurance.policy.document_type != 3\" class=\"col-xs-12 col-sm-4 form-group\" style=\"word-wrap: break-word;\"><span class=\"blue-color\">Concepto:</span><div><span>{{ concept(vm.insurance.concept) }}</span> <span ng-if=\"vm.insurance.other_desc\">- {{ vm.insurance.other_desc }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.insurance.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ vm.insurance.end_date | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.insurance.policy.subramo.subramo_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Creado por:</span><div>{{ vm.insurance.owner }}</div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" ng-class=\"{\'label-success\': vm.insurance.status == 2, \'label-info\' : vm.insurance.status == 5,\'label-primary\' : vm.insurance.status == 1, \'label-warning\' : vm.insurance.status == 3 || vm.insurance.status == 4}\" style=\"margin-right: 10px\">{{ status(vm.insurance.status) }}</div></div></div><div class=\"form-group col-xs-12 col-sm-4 pull-right m-t\"><button class=\"btn btn-primary\" ng-if=\"vm.insurance.status === 1 || vm.insurance.status === 5\" ng-click=\"changeStatus(vm.insurance.policy)\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i> Cambiar Estatus</button></div><div class=\"row col-xs-12\"><div class=\"col-xs-12 col-sm-4 form-group\"><label class=\"blue-color\">Bono Afianzadora:</label><div><span>{{ vm.insurance.bono_variable | currency }}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeBono()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Fecha de Bono:</span><div><span>{{ vm.insurance.date_bono | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaBono()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><span class=\"blue-color\">Porcentaje Comisión:</span><div>{{ vm.insurance.comision_percent}}% <button class=\"btn btn-white btn-sm\" ng-click=\"changecomission(2)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Pago de Comisión:</span><div><span>{{ vm.insurance.fecha_pago_comision | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaComision()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Maquila:</span><div><span>{{ vm.insurance.maquila | currency}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeMaquila()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha Maquila:</span><div><span>{{ vm.insurance.date_maquila | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaMaquila()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha Emisión Factura:</span><div><span>{{ vm.insurance.date_emision_factura | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaEmisionF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!openMonth\"><span class=\"blue-color\">Mes de Emisión de Factura:</span><div><span>{{ monthEmision(vm.insurance.month_factura)}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeMesF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"openMonth\"><label class=\"blue-color\" for=\"SelectMontEmision\">Mes de Emisión de Factura</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in month.options\" ng-model=\"month.month_selected\" ng-init=\"month.month_selected = vm.insurance.month_factura\" ng-change=\"changemonth()\"></select><button class=\"btn btn-white btn-sm\" ng-click=\"changeMesF1(month.month_selected)\"><i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!openYear\"><span class=\"blue-color\">Año Factura:</span><div><span>{{ vm.insurance.year_factura}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changYearF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"openYear\"><label class=\"blue-color\" for=\"SelectYearEmision\">Año de Factura</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"vm.form.year_factura\" ng-change=\"changeyaer(vm.form.year_factura)\"><option value=\"\"></option></select><button class=\"btn btn-white btn-sm\" ng-click=\"changeYearF1(vm.form.year_factura)\"><i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Folio Factura:</span><div><span>{{ vm.insurance.folio_factura}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFolioF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Entrega:</span><div><span>{{ vm.insurance.fecha_entrega | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaEntrega()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-6 form-group pull-right\" ng-if=\"vm.insurance.task_associated\"><button type=\"button\" class=\"btn btn-white btn-sm btn-secondary\" ng-click=\"openModal(vm.insurance.task_associated_info)\">{{ vm.isCollapsed ? \'Ocultar\' : \'Ver\' }} Tarea Origen</button></div><div class=\"col-xs-12\"><hr></div><div ng-if=\"vm.insurance.number_endorsement && vm.insurance.status == 2 && vm.insurance.endorsement_type != \'B\'\"><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Neta:</span><div>{{ vm.insurance.p_neta | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Derecho:</span><div>{{ vm.insurance.rpf | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Gastos:</span><div>{{ vm.insurance.derecho | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Iva:</span><div>{{ vm.insurance.iva | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Total:</span><div>{{ vm.insurance.p_total | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Comisión:</span><div>{{ vm.insurance.comision | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.permiso_comisiones\"><span class=\"blue-color\">Porcentaje de Comisión:</span><div>{{ vm.insurance.comision_percent }}%</div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Cargo Automático:</span><div><span ng-if=\"vm.insurance.recibos_poliza[0].is_cat\">Si</span> <span ng-if=\"!vm.insurance.recibos_poliza[0].is_cat\">No</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changedomiciliado()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> Cambiar</button></div></div></div></div></div></div></div></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"vm.recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"vm.recordatoriosFlag = false; vm.infoFlag = true\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in vm.insurance.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información del Endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><h4>Descripción del endoso: <button ng-show=\"end_obs_dis\" class=\"btn btn-white btn-sm\" ng-click=\"end_obs_dis = false\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <button ng-show=\"!end_obs_dis\" class=\"btn btn-white btn-sm\" ng-click=\"end_obs_dis = true ; updateEndObs(vm.insurance)\"><i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i></button></h4><textarea ng-disabled=\"end_obs_dis\" type=\"text\" class=\"form-control\" ng-model=\"vm.insurance.observations\"></textarea></div></div><div ng-if=\"vm.insurance.concept == 53 || vm.insurance.concept == 57 || vm.insurance.concept == 58 || vm.insurance.concept == 59 || vm.insurance.concept == 62\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Detalles de Garantía</legend></div><div class=\"col-xs-12 col-sm-6\" ng-if=\"vm.insurance.status != 2\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Fianza Original</legend></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\' || vm.insurance.policy.subramo.subramo_name == \'Colectivas\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\" ng-if=\"vm.insurance.concept != 58\">Monto a Garantizar:</span> <span class=\"blue-color\" ng-if=\"vm.insurance.concept == 58\"><b>Monto a Garantizar:</b></span><div ng-if=\"vm.insurance.concept != 58\">{{ vm.insurance.policy.contract_poliza.guarantee_amount | currency }}</div><div ng-if=\"vm.insurance.concept == 58\"><b>{{ vm.insurance.policy.contract_poliza.guarantee_amount | currency }}</b></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Tarifa:</span><div>{{ vm.insurance.policy.contract_poliza.rate }}%</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Giro de la empresa:</span><div>{{ vm.insurance.policy.contract_poliza.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Colectivas\'\"><span class=\"blue-color\">Número de Empleados:</span><div>{{ vm.insurance.policy.contract_poliza.no_employees }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Nombre del Empleado:</span><div>{{ vm.insurance.policy.contract_poliza.employee_name }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Actividad:</span><div>{{ vm.insurance.policy.contract_poliza.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Deducible:</span><div>{{ vm.insurance.policy.contract_poliza.deductible_percentage }}</div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Detalle Adicional de Garantía:</span><div>{{ vm.insurance.policy.contract_poliza.description }}</div></div></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Obra\' || vm.insurance.policy.subramo.subramo_name == \'Proveeduria\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Descripción:</span><div>{{ vm.insurance.policy.contract_poliza.description }}</div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Número de contrato:</span><div>{{ vm.insurance.policy.contract_poliza.number }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Plazo del documento fuente:</span><div>{{ vm.insurance.policy.contract_poliza.start | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ vm.insurance.change.end | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de firma del contrato:</span><div>{{ vm.insurance.policy.contract_poliza.sign_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\"><b>Monto del contrato:</b></span><div>{{ vm.insurance.policy.contract_poliza.amount | currency}}</div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\"><b>Monto del contrato con IVA:</b></span><div>{{ vm.insurance.policy.contract_poliza.amount_iva | currency}}</div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Porcentaje a garantizar:</span><div>{{ vm.insurance.policy.contract_poliza.guarantee_percentage }} %</div></div></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Fidelidad\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Giro de la empresa:</span><div>{{ vm.insurance.policy.contract_poliza.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Nombre del Empleado:</span><div>{{ vm.insurance.policy.contract_poliza.employee_name }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Actividad:</span><div>{{ vm.insurance.policy.contract_poliza.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Deducible:</span><div>{{ vm.insurance.policy.contract_poliza.deductible_percentage }}</div></div></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name != \'Obra\' && vm.insurance.policy.subramo.subramo_name != \'Proveeduria\' && vm.insurance.policy.subramo.subramo_name != \'Fidelidad\' && vm.insurance.policy.subramo.subramo_name != \'Colectivas\' && vm.insurance.policy.subramo.subramo_name != \'Individual\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Descripción:</span><div>{{ vm.insurance.policy.contract_poliza.description }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\" ng-if=\"vm.insurance.concept != 58\">Monto a Garantizar:</span> <span class=\"blue-color\" ng-if=\"vm.insurance.concept == 58\"><b>Monto a Garantizar:</b></span><div ng-if=\"vm.insurance.concept != 58\">{{ vm.insurance.policy.contract_poliza.guarantee_amount | currency }}</div><div ng-if=\"vm.insurance.concept == 58\"><b>{{ vm.insurance.policy.contract_poliza.guarantee_amount | currency }}</b></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Tarifa:</span><div>{{ vm.insurance.policy.contract_poliza.rate }}%</div></div></div></div><div class=\"col-xs-12 col-sm-6\" ng-if=\"vm.insurance.status == 2\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Fianza Original</legend></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\' || vm.insurance.policy.subramo.subramo_name == \'Colectivas\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\" ng-if=\"vm.insurance.concept != 58\">Monto a Garantizar:</span> <span class=\"blue-color\" ng-if=\"vm.insurance.concept == 58\"><b>Monto a Garantizar:</b></span><div ng-if=\"vm.insurance.concept != 58\">{{ vm.insurance.original.guarantee_amount | currency }}</div><div ng-if=\"vm.insurance.concept == 58\"><b>{{ vm.insurance.original.guarantee_amount | currency }}</b></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Tarifa:</span><div>{{ vm.insurance.original.rate }}%</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Giro de la empresa:</span><div>{{ vm.insurance.original.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Colectivas\'\"><span class=\"blue-color\">Número de Empleados:</span><div>{{ vm.insurance.original.no_employees }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Nombre del Empleado:</span><div>{{ vm.insurance.original.employee_name }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Actividad:</span><div>{{ vm.insurance.original.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Deducible:</span><div>{{ vm.insurance.original.deductible_percentage }}</div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Detalle Adicional de Garantía:</span><div>{{ vm.insurance.original.description }}</div></div></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Obra\' || vm.insurance.policy.subramo.subramo_name == \'Proveeduria\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Descripción:</span><div>{{ vm.insurance.original.description }}</div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Número de contrato:</span><div>{{ vm.insurance.original.number }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Plazo del documento fuente:</span><div>{{ vm.insurance.original.start | date: \'dd/MM/yyyy\' }} - {{ vm.insurance.change.end | date: \'dd/MM/yyyy\' }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de firma del contrato:</span><div>{{ vm.insurance.original.sign_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\"><b>Monto del contrato:</b></span><div>{{ vm.insurance.original.amount | currency}}</div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\"><b>Monto del contrato con IVA:</b></span><div>{{ vm.insurance.original.amount_iva | currency}}</div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Porcentaje a garantizar:</span><div>{{ vm.insurance.original.guarantee_percentage }} %</div></div></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Fidelidad\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Giro de la empresa:</span><div>{{ vm.insurance.original.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Nombre del Empleado:</span><div>{{ vm.insurance.original.employee_name }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Actividad:</span><div>{{ vm.insurance.original.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Deducible:</span><div>{{ vm.insurance.original.deductible_percentage }}</div></div></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name != \'Obra\' && vm.insurance.policy.subramo.subramo_name != \'Proveeduria\' && vm.insurance.policy.subramo.subramo_name != \'Fidelidad\' && vm.insurance.policy.subramo.subramo_name != \'Colectivas\' && vm.insurance.policy.subramo.subramo_name != \'Individual\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Descripción:</span><div>{{ vm.insurance.original.description }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\" ng-if=\"vm.insurance.concept != 58\">Monto a Garantizar:</span> <span class=\"blue-color\" ng-if=\"vm.insurance.concept == 58\"><b>Monto a Garantizar:</b></span><div ng-if=\"vm.insurance.concept != 58\">{{ vm.insurance.original.guarantee_amount | currency }}</div><div ng-if=\"vm.insurance.concept == 58\"><b>{{ vm.insurance.original.guarantee_amount | currency }}</b></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Tarifa:</span><div>{{ vm.insurance.original.rate }}%</div></div></div></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Cambio Endoso</legend></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\' || vm.insurance.policy.subramo.subramo_name == \'Colectivas\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\" ng-if=\"vm.insurance.concept != 58\">Monto a Garantizar:</span> <span class=\"blue-color\" ng-if=\"vm.insurance.concept == 58\"><b>Monto a Garantizar:</b></span><div ng-if=\"vm.insurance.concept != 58\">{{ vm.insurance.change.guarantee_amount | currency }}</div><div ng-if=\"vm.insurance.concept == 58\"><b>{{ vm.insurance.change.guarantee_amount | currency }}</b></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Tarifa:</span><div>{{ vm.insurance.change.rate }}%</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Giro de la empresa:</span><div>{{ vm.insurance.change.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Colectivas\'\"><span class=\"blue-color\">Número de Empleados:</span><div>{{ vm.insurance.change.no_employees }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Nombre del Empleado:</span><div>{{ vm.insurance.change.employee_name }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Actividad:</span><div>{{ vm.insurance.change.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Deducible:</span><div>{{ vm.insurance.change.deductible_percentage }}</div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Detalle Adicional de Garantía:</span><div>{{ vm.insurance.change.description }}</div></div></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Obra\' || vm.insurance.policy.subramo.subramo_name == \'Proveeduria\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Descripción:</span><div>{{ vm.insurance.change.description }}</div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Número de contrato:</span><div>{{ vm.insurance.change.number }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Plazo del documento fuente:</span><div>{{ vm.insurance.change.start | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ vm.insurance.change.end | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de firma del contrato:</span><div>{{ vm.insurance.change.sign_date | date: \'dd/MM/yyyy\' : \'UTC\' }}</div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\"><b>Monto del contrato:</b></span><div>{{ vm.insurance.change.amount | currency}}</div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\"><b>Monto del contrato con IVA:</b></span><div>{{ vm.insurance.change.amount_iva | currency}}</div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Porcentaje a garantizar:</span><div>{{ vm.insurance.change.guarantee_percentage }}%</div></div></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Fidelidad\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Giro de la empresa:</span><div>{{ vm.insurance.change.contract_poliza.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Nombre del Empleado:</span><div>{{ vm.insurance.change.contract_poliza.employee_name }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Actividad:</span><div>{{ vm.insurance.change.contract_poliza.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.policy.subramo.subramo_name == \'Individual\'\"><span class=\"blue-color\">Deducible:</span><div>{{ vm.insurance.change.contract_poliza.deductible_percentage }}</div></div></div><div ng-if=\"vm.insurance.policy.subramo.subramo_name != \'Obra\' && vm.insurance.policy.subramo.subramo_name != \'Proveeduria\' && vm.insurance.policy.subramo.subramo_name != \'Fidelidad\' && vm.insurance.policy.subramo.subramo_name != \'Colectivas\' && vm.insurance.policy.subramo.subramo_name != \'Individual\'\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Descripción:</span><div>{{ vm.insurance.change.description }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\" ng-if=\"vm.insurance.concept != 58\">Monto a Garantizar:</span> <span class=\"blue-color\" ng-if=\"vm.insurance.concept == 58\"><b>Monto a Garantizar:</b></span><div ng-if=\"vm.insurance.concept != 58\">{{ vm.insurance.change.guarantee_amount | currency }}</div><div ng-if=\"vm.insurance.concept == 58\"><b>{{ vm.insurance.change.guarantee_amount | currency }}</b></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Tarifa:</span><div>{{ vm.insurance.change.rate }}%</div></div></div></div></div><div ng-if=\"vm.insurance.concept == 34\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Cambio de Beneficiario</legend></div><div class=\"col-xs-12 col-sm-6\" ng-if=\"vm.insurance.status != 2\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Fianza Original</legend></div><div ng-repeat=\"beneficiary in vm.insurance.policy.beneficiaries_poliza_many\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 2\"><span class=\"blue-color\">Razón Social:</span><div>{{ beneficiary.j_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 1\"><span class=\"blue-color\">Nombre:</span><div>{{ beneficiary.first_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 1\"><span class=\"blue-color\">Apellido Paterno:</span><div>{{ beneficiary.last_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 1\"><span class=\"blue-color\">Apellido Materno:</span><div>{{ beneficiary.second_last_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RFC:</span><div>{{ beneficiary.rfc }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div>{{ beneficiary.email }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Teléfono:</span><div>{{ beneficiary.phone_number }}</div></div><div class=\"col-xs-12\"><hr></div></div></div><div class=\"col-xs-12 col-sm-6\" ng-if=\"vm.insurance.status == 2\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Fianza Original</legend></div><div ng-repeat=\"beneficiary in vm.insurance.original\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 2\"><span class=\"blue-color\">Razón Social:</span><div>{{ beneficiary.j_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 1\"><span class=\"blue-color\">Nombre:</span><div>{{ beneficiary.first_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 1\"><span class=\"blue-color\">Apellido Paterno:</span><div>{{ beneficiary.last_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 1\"><span class=\"blue-color\">Apellido Materno:</span><div>{{ beneficiary.second_last_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RFC:</span><div>{{ beneficiary.rfc }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div>{{ beneficiary.email }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Teléfono:</span><div>{{ beneficiary.phone_number }}</div></div><div class=\"col-xs-12\"><hr></div></div></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Cambio Endoso</legend></div><div ng-repeat=\"beneficiary in vm.insurance.change\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 2\"><span class=\"blue-color\">Razón Social:</span><div>{{ beneficiary.j_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 1\"><span class=\"blue-color\">Nombre:</span><div>{{ beneficiary.first_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 1\"><span class=\"blue-color\">Apellido Paterno:</span><div>{{ beneficiary.last_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.type_person == 1\"><span class=\"blue-color\">Apellido Materno:</span><div>{{ beneficiary.second_last_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RFC:</span><div>{{ beneficiary.rfc }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div>{{ beneficiary.email }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Teléfono:</span><div>{{ beneficiary.phone_number }}</div></div><div class=\"col-xs-12\"><hr></div></div></div></div><div ng-if=\"vm.insurance.concept == 55\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Anuencia</legend></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Cambio Endoso</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Anuencia:</span><div>{{ vm.insurance.change.fecha_anuencia | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div></div></div><div ng-if=\"vm.insurance.concept == 60\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Anulación</legend></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Fianza Original</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"text-center\">Concepto de Anulación</legend><div>{{ concepAn(vm.insurance.original.concept_annulment)}}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"text-center\">Razón de Anulación</legend><div>{{ vm.insurance.original.reason_cancel}}</div></div></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Cambio Endoso</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"text-center\">Concepto de Anulación</legend><div align=\"center\"><span ng-if=\"vm.insurance.change.concept_annulment ==1\">Preanulada</span> <span ng-if=\"vm.insurance.change.concept_annulment ==2\">Por error de captura</span> <span ng-if=\"vm.insurance.change.concept_annulment ==3\">Por reexpedición</span> <span ng-if=\"vm.insurance.change.concept_annulment ==4\">Por falta de pago</span> <span ng-if=\"vm.insurance.change.concept_annulment ==5\">Solo anular</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"text-center\">Razón de Anulación</legend><div align=\"center\">{{ vm.insurance.change.reason_cancel}}</div></div></div></div><div ng-if=\"vm.insurance.concept == 61\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Cancelación</legend></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Fianza Original</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"text-center\">Fecha de Cancelación</legend><div>{{(vm.insurance.original.fecha_cancelacion | date: \'dd/MM/yyyy\' : \'UTC\')}}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"text-center\">Monto de Cancelación</legend><div>{{ vm.insurance.original.monto_cancelacion | currency}}</div></div></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Cambio Endoso</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"text-center\">Fecha de Cancelación</legend><div>{{vm.insurance.change.fecha_cancelacion | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><legend class=\"text-center\">Monto de Cancelación</legend><div align=\"center\">{{ vm.insurance.change.monto_cancelacion | currency}}</div></div></div></div><div ng-if=\"vm.insurance.concept == 54\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Prórroga de Vigencia</legend></div><div class=\"col-xs-12 col-sm-6\" ng-if=\"vm.insurance.status != 2\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Fianza Original</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Inicio:</span><div>{{ vm.insurance.policy.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Fin:</span><div>{{ vm.insurance.policy.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div></div><div class=\"col-xs-12 col-sm-6\" ng-if=\"vm.insurance.status == 2\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Fianza Original</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Inicio:</span><div>{{ vm.insurance.policy.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Fin:</span><div>{{ vm.insurance.original | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Cambio Endoso</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Inicio:</span><div>{{ vm.insurance.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Fin:</span><div>{{ vm.insurance.end_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div></div></div><div ng-if=\"vm.insurance.concept == 24 || vm.insurance.concept == 25\"><div class=\"col-xs-12 form-group\"><legend class=\"text-center\">Certificados</legend></div><div class=\"col-xs-12 form-group\"><div class=\"col-xs-1 form-group\"><select class=\"form-control\" ng-options=\"renewal.value for renewal in optionsViews\" ng-change=\"selectViews(optionViews)\" ng-model=\"optionViews\"></select></div><div><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Certificado</td><td>Correo</td><td>Nombre</td><td>RFC</td><td>Puesto</td><td>Actividad</td><td>Monto a Garantizar</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.certificate_number }}</td><td>{{ item.beneficiaries_poliza[0].email }}</td><td>{{ item.beneficiaries_poliza[0].full_name }}</td><td>{{ item.beneficiaries_poliza[0].rfc }}</td><td>{{ item.beneficiaries_poliza[0].workstation }}</td><td>{{ item.contract_poliza.activity }}</td><td>{{ item.contract_poliza.amount | currency }}</td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de Fianza</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"!vm.show_binnacle_receipt\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}}</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th><th>Gastos</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}}</th><th ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}}</th><th width=\"3%\">Entregado</th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th></tr></thead><tbody><tr ng-click=\"changeStatusModal(receipt, vm.insurance.policy, vm.insurance.policy)\" ng-repeat=\"receipt in vm.policy_receipts track by $index\"><td>{{ receipt.recibo_numero }} / {{vm.policy_receipts.length}}</td><td>{{ receipt.prima_neta | currency }}</td><td>{{ receipt.rpf | currency }}</td><td>{{ receipt.derecho | currency }}</td><td>{{ receipt.iva | currency }}</td><td>{{ receipt.prima_total | currency }}</td><td ng-if=\"vm.permiso_comisiones\">{{ receipt.comision | currency }}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{receipt.vencimiento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8 || receipt.status == 10 || receipt.status == 11}\">{{ statusReceipts(receipt.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(receipt)\"><span ng-if=\"receipt.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!receipt.delivered\"><i class=\"fa fa-times\"></i></span></td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-if=\"!receipt.track_bitacora\" ng-click=\"vm.showBinnacleReceipt(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"receipt.track_bitacora\" ng-click=\"vm.showBinnacleReceipt(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a ng-if=\"receipt.is_cat\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div class=\"col-xs-12\"><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div></div><div class=\"animate\" ng-if=\"vm.show_binnacle_receipt\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"vm.returnToReceipts()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data_receipt\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\" receiptmodel=\"receiptmodel\" exportable=\"true\"></comments></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.endorsement_receipts.length > 0\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"vm.endorsement_receipts[0].receipt_type == 2\">Recibos de Endoso</h5><h5 ng-if=\"vm.endorsement_receipts[0].receipt_type == 3\">Notas de Crédito</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"!vm.show_binnacle_receipt_end\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}}</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th><th>Gastos</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}}</th><th ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}}</th><th width=\"3%\">Entregado</th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th></tr></thead><tbody><tr ng-click=\"changeStatusModal(receipt, vm.insurance.policy, vm.insurance.policy)\" ng-repeat=\"receipt in vm.endorsement_receipts track by $index\" ng-if=\"receipt.status != 0\"><td>{{ receipt.recibo_numero }} / {{vm.endorsement_receipts.length }}</td><td>{{ receipt.prima_neta | currency }}</td><td>{{ receipt.rpf | currency }}</td><td>{{ receipt.derecho | currency }}</td><td>{{ receipt.iva | currency }}</td><td>{{ receipt.prima_total | currency }}</td><td ng-if=\"vm.permiso_comisiones\">{{ receipt.comision | currency }}</td><td>{{ receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\' }}</td><td>{{receipt.vencimiento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8 || receipt.status == 10 || receipt.status == 11}\">{{ statusReceipts(receipt.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(receipt)\"><span ng-if=\"receipt.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!receipt.delivered\"><i class=\"fa fa-times\"></i></span></td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-if=\"vm.acceso_cor && !receipt.track_email\" ng-click=\"addEmailsConfirmPolicy(receipt, vm.insurance.natural, vm.insurance.juridical,vm.insurance.contractor)\" ng-disabled=\"!(receipt.status == 4)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-if=\"vm.acceso_cor && receipt.track_email\" ng-click=\"addEmailsConfirmPolicy(receipt, vm.insurance.natural, vm.insurance.juridical,vm.insurance.contractor)\" ng-disabled=\"receipt.status != 4\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-if=\"!receipt.track_bitacora\" ng-click=\"vm.showBinnacleReceipt_Endoso(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"receipt.track_bitacora\" ng-click=\"vm.showBinnacleReceipt_Endoso(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a ng-if=\"recibo.is_cat\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-click=\"applyEx()\" ng-if=\"receipt.excedente > 0\" style=\"background-color: white;border-color: #f8ac59;color: black;\"><i class=\"fa fa-hand-holding-usd\" aria-hidden=\"true\" title=\"Recibo con excedente sin aplicar\"></i></a> <a class=\"btn btn-sm btn-white\" ng-click=\"editReceipt(receipt)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"3\" model=\"recibo.recibo_numero + \' de la póliza \' + vm.insurance.poliza_number\" associated=\"vm.insurance.id\" receipt=\"recibo.id\"></tasks></td></tr><tr><td><b>Totales<b></b></b></td><td><b>{{ total_prima | currency }}</b></td><td><b>{{ total_rpf | currency }}</b></td><td><b>{{ total_derecho | currency }}</b></td><td><b>{{ total_iva | currency }}</b></td><td><b>{{ total_total | currency }}</b></td><td><b>{{ total_comision| currency }}</b></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><div class=\"col-xs-12\"><div class=\"identificador-dash-email\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se envio un correo.</span><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div></div><div class=\"animate\" ng-if=\"vm.show_binnacle_receipt_end\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"vm.returnToReceipts_End()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data_receipt_endoso\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\" receiptmodel=\"receiptmodel\" exportable=\"true\"></comments></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(vm.insurance)\">Guardar Archivos</button></div></div><div class=\"row col-md-12 col-sm-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in vm.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"renameFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file, vm.files, vm.insurance)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado()\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"10\" idmodel=\"vm.endosoId\" exportable=\"true\"></comments></div></div></div></div></div></div><script type=\"text/javascript\">\n\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target);\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    // btnTag.prop(\'onclick\',null).off(\'click\');\n\n    btnTag.removeClass(\'display-none\');\n    dummy.addClass(\'display-none\');\n\n\n    inputTag.addClass(\'display-none\');\n    strongTag.removeClass(\'display-none\');\n  }\n</script>");
$templateCache.put("app/endoso/endosos.fianza.status.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Cambiar Estatus Endoso Fianza</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><h3>Estatus del endoso:</h3><div class=\"label\" ng-class=\"{\'label-success\': endoso.status == 2, \'label-info\' : endoso.status == 5,\'label-primary\' : endoso.status == 1, \'label-warning\' : endoso.status == 3 || endoso.status == 4}\">{{ status(endoso.status) }}</div></div></div><div class=\"row\" ng-if=\"vmm.endoso_status != 2\"><div class=\"form-group col-xs-12 col-sm-6\"><select class=\"form-control m-b\" ng-model=\"vmm.selectedType\" ng-options=\"s as s.label for s in vmm.status track by s.value\" ng-if=\"s.value != 1 || s.value != 5\"><option disabled=\"\" value=\"\">Selecciona un estatus</option></select></div></div><div class=\"row\" ng-if=\"vmm.selectedType.value == 2\"><div class=\"col-xs-12 form-group\"><div class=\"row\"><div upload-template=\"\"></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label for=\"\">Número de Endoso<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.number_endorsement\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 nopadding form-group\"><label>Bono Afianzadora:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.bono_variable\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Fecha de Bono</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vmm.date_bono\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkFechaBono(vmm.date_bono)\" ng-init=\"vm.checkFechaBono(vmm.date_bono)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de emisión de la Factura</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vmm.date_emision_factura\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkFechaFactura(vmm.date_emision_factura)\" ng-init=\"vmm.checkFechaFactura(vmm.date_emision_factura)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectMontEmision\">Mes de Emisión de Factura</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in vmm.month.options\" ng-model=\"vmm.month.month_selected\" ng-init=\"vmm.month.month_selected = 0\" ng-change=\"changemonth()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"year\">Año Factura</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"vmm.year_factura\" ng-change=\"changeyaer(vmm.year_factura)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Folio Factura</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" value=\"{{vmm.folio_factura}}\" ng-model=\"vmm.folio_factura\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Maquila</label> <input class=\"form-control\" name=\"maquila\" type=\"txt\" value=\"{{vmm.maquila}}\" ng-model=\"vmm.maquila\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de Maquila</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vmm.date_maquila\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vmm.checkFechaMaquila(vmm.date_maquila)\" ng-init=\"vmm.checkFechaFactura(vmm.date_maquila)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vmm.endorsement.endorsement_type == \'A\' || vmm.endorsement.endorsement_type == \'D\'\"><div><receipts-endorsement form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"2\"></receipts-endorsement></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success\" ng-if=\"vmm.selectedType.value != 2\" ng-click=\"rejectEndorsement()\" type=\"button\">Guardar</button> <button class=\"btn btn-success\" ng-if=\"vmm.selectedType.value == 2\" ng-disabled=\"!vmm.number_endorsement\" ng-click=\"checkNumEndoso()\" type=\"button\">Crear</button></div></div>");
$templateCache.put("app/endoso/endosos.fianzaGpo.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Editar</a></li><li class=\"active\"><strong>Endoso {{ endorsement.internal_number }}</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Editar Endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Datos de la Fianza Colectiva</legend></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Número de Fianza:</span><div><span>{{ surety.poliza_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Contacto:</span><div><span>{{ surety.contractor.full_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Afianzadora:</span><div><span>{{ surety.aseguradora.alias }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ surety.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ surety.end_of_validity | date: \'dd/MM/yyyy\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Estatus Fianza:</span><div><div class=\"label\" ng-class=\"{\'label-success\': surety.status == 1, \'label-info\' : surety.status == 10, \'label-primary\' : surety.status == 14, \'label-warning\' : surety.status == 2 || surety.status == 4 || surety.status == 11 || surety.status == 12 || surety.status == 17 || surety.status == 24}\" style=\"margin-right: 10px\">{{ status(surety.status) }}</div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ surety.ramo.ramo_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ surety.subramo.subramo_name }}<span></span></span></div></div><div class=\"col-xs-12 form-group\"><hr></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Concepto del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"\">Concepto:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"concept.value as concept.label for concept in concepts track by concept.label\" ng-model=\"endorsement.concept\" ng-change=\"changeConcept()\" disabled=\"\"><option value=\"\" disabled=\"\">Selecciona un concepto</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.concept.value == 4\"><label for=\"\">Agregue el concepto: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"otros\" ng-model=\"endorsement.other_desc\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"\">Tipo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"endorsement_type\" ng-options=\"massive as massive.label for massive in typesMassive track by massive.label\" ng-change=\"changeType()\" disabled=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Vigencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"startDate\" value=\"{{startDate}}\" ng-change=\"checkDate(startDate)\" disabled=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Al: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"endDate\" value=\"{{endDate}}\" ng-change=\"checkEndDate(endDate)\" disabled=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del Endoso: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"endorsement.observations\" name=\"description\"></textarea></div><div ng-if=\"endorsement.concept.value == 53\"><div class=\"col-xs-12\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Detalles de Garantía</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Monto a Garantizar: <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"number\" ng-model=\"endorsement.change.guarantee_amount\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Tarifa: <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"endorsement.change.rate\" ng-change=\"valuePercentageRate(endorsement.change.rate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Giro de la Empresa: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.change.activity\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>No. de Empleados: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"endorsement.change.no_employees\"></div><div class=\"col-xs-12 form-group\"><label>Detalle Adicional de Garantía para Subramo Fidelidad Colectiva <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" type=\"text\" ng-model=\"endorsement.change.description\"></textarea></div></div><div ng-if=\"endorsement.concept.value == 34\"><div class=\"col-xs-12 form-group\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Beneficiarios</legend><label>Beneficiario existente:</label><div class=\"input-group col-xs-12\"><autocomplete datasource=\"beneficiaries_data\" model=\"benecifiarieSelected\" change=\"matchesBeneficiary(benecifiarieSelected.val)\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addBeneficiaries(benecifiarieSelected.value)\">Agregar</button></span></div><br><div class=\"address-container\" ng-repeat=\"beneficiary in endorsement.change\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiary($index)\" ng-disabled=\"beneficiaries.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiary($index)\" ng-disabled=\"beneficiaries.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiary()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiary()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 m-b\"><button ng-if=\"beneficiary.type_person == 1\" class=\"btn btn-primary col-xs-6\" ng-click=\"typePerson(1, $index)\">Física</button> <button ng-if=\"beneficiary.type_person == 1\" class=\"btn btn-default col-xs-6\" ng-click=\"typePerson(2, $index)\">Moral</button> <button ng-if=\"beneficiary.type_person == 2\" class=\"btn btn-default col-xs-6\" ng-click=\"typePerson(1, $index)\">Física</button> <button ng-if=\"beneficiary.type_person == 2\" class=\"btn btn-primary col-xs-6\" ng-click=\"typePerson(2, $index)\">Moral</button></div><div ng-if=\"beneficiary.type_person == 1\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.first_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.last_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Apellido Materno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.second_last_name\"></div></div><div ng-if=\"beneficiary.type_person == 2\"><div class=\"col-xs-12 form-group\"><label>Razón Social: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.j_name\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>RFC: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.rfc\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Correo Electrónico:</label> <input class=\"form-control\" type=\"email\" ng-model=\"beneficiary.email\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Teléfono:</label><phonenumber-directive model=\"beneficiary.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"beneficiaries_fianza.phone_number\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"validitySurety()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Actualizar Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ui-sref=\"endorsement.details({endosoId: endorsement.id})\" type=\"button\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div></div></div></div></div>");
$templateCache.put("app/endoso/endosos.fianzaGpo.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Crear Endoso Fianza Colectiva</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Agregar Endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.acceso_adm_fia\"><label>Número de Fianza: <span class=\"color-red\">*</span></label><autocomplete datasource=\"autocompleteData\" model=\"vm.poliza_number_data\" change=\"findContractor(vm.poliza_number_data)\"></autocomplete></div></div><div class=\"row\" ng-if=\"surety.aseguradora\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Datos de la Fianza Colectiva</legend></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Número de Fianza:</span><div><span>{{ surety.poliza_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Contacto:</span><div><span>{{ surety.contractor.full_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Afianzadora:</span><div><span>{{ surety.aseguradora.alias }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ surety.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ surety.end_of_validity | date: \'dd/MM/yyyy\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Estatus Fianza:</span><div><div class=\"label\" ng-class=\"{\'label-success\': surety.status == 1, \'label-info\' : surety.status == 10, \'label-primary\' : surety.status == 14, \'label-warning\' : surety.status == 2 || surety.status == 4 || surety.status == 11 || surety.status == 12 || surety.status == 17 || surety.status == 24}\" style=\"margin-right: 10px\">{{ status(surety.status) }}</div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ surety.ramo.ramo_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ surety.subramo.subramo_name }}<span></span></span></div></div><div class=\"col-xs-12 form-group\"><hr></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Concepto del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"\">Concepto:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"concept.value as concept.label for concept in concepts track by concept.label\" ng-model=\"endorsement.concept\" ng-change=\"changeConcept(); saveLocalstorange();\" ng-disabled=\"!surety.aseguradora\"><option value=\"\" disabled=\"\">Selecciona un concepto</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.concept == 4\"><label for=\"\">Agregue el concepto: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"otros\" ng-model=\"endorsement.other_desc\" ng-change=\"saveLocalstorange()\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"\">Tipo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"endorsement_type\" ng-options=\"massive as massive.label for massive in typesMassive track by massive.label\" ng-change=\"changeType(); saveLocalstorange();\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.concept == 60 || endorsement.concept.value == 60\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Anulación de la Fianza</legend></div><hr><div class=\"col-xs-12 col-sm-12 form-group\"><label class=\"blue-color\">Concepto de Anulación: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"concept_anulacion.value as concept_anulacion.label for concept_anulacion in vm.concept_anulacion\" ng-change=\"conceptAnnSelection(vm.conceptAnnulment); saveLocalstorange();\" name=\"conceptAnn\" ng-model=\"vm.conceptAnnulment\"></select></div><div class=\"col-xs-12 col-sm-12\" ng-if=\"vm.conceptAnnulment\"><label class=\"blue-color\">Razón de Anulación: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" name=\"reason\" ng-model=\"vm.reason_cancel\" ng-change=\"saveLocalstorange()\"></textarea></div></div><div class=\"col-xs-12 col-sm-12 row\" ng-if=\"endorsement.concept == 61 || endorsement.concept.value == 61\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Cancelación de la Fianza</legend></div><hr><div class=\"col-xs-12 col-sm-6 form-group\"><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><label class=\"blue-color\">Fecha de cancelación: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.fecha_cancelacion\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=\"blue-color\">Monto de Cancelación: <span class=\"color-red\">*</span></label> <input type=\"text\" class=\"form-control\" name=\"reason\" ng-model=\"vm.monto_cancelacion\" ng-change=\"saveLocalstorange()\"></div></div><div class=\"col-xs-12 form-group\" align=\"center\" ng-if=\"endorsement.concept == 55 || endorsement.concept.value == 55\"><label>Fecha Anuencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"aneunecy\" class=\"width-100 text-align-center form-control\" ng-model=\"anuency\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Vigencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"startDate\" value=\"{{startDate}}\" ng-change=\"checkDate(startDate)\" ng-disabled=\"!surety.aseguradora\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Al: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"endDate\" value=\"{{endDate}}\" ng-change=\"checkEndDate(endDate)\" ng-disabled=\"!surety.aseguradora\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del Endoso: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"endorsement.observations\" ng-change=\"saveLocalstorange()\" name=\"description\" ng-disabled=\"!surety.aseguradora\"></textarea></div><div ng-if=\"endorsement.concept == 53 || endorsement.concept.value == 53 || endorsement.concept == 58 || endorsement.concept.value == 58 || endorsement.concept == 59 || endorsement.concept.value == 59\"><div class=\"col-xs-12\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Detalles de Garantía</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Monto a Garantizar: <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.change.guarantee_amount\" ng-change=\"saveLocalstorange()\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Tarifa: <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-model=\"endorsement.change.rate\" ng-change=\"valuePercentageRate(endorsement.change.rate); saveLocalstorange();\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Giro de la Empresa: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.change.activity\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>No. de Empleados: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.change.no_employees\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 form-group\"><label>Detalle Adicional de Garantía para Subramo Fidelidad Colectiva <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" type=\"text\" ng-model=\"endorsement.change.description\" ng-change=\"saveLocalstorange()\"></textarea></div></div><div ng-if=\"endorsement.concept == 34 || endorsement.concept.value == 34\"><div class=\"col-xs-12 form-group\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Beneficiarios</legend><label>Beneficiario existente:</label><div class=\"input-group col-xs-12\"><autocomplete datasource=\"beneficiaries_data\" id=\"beneficiaries\" model=\"benecifiarieSelected\" change=\"matchesBeneficiary(benecifiarieSelected.val)\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addBeneficiaries(benecifiarieSelected.value)\">Agregar</button></span></div><br><div class=\"address-container\" ng-repeat=\"beneficiary in beneficiaries\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiary($index)\" ng-disabled=\"beneficiaries.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiary($index)\" ng-disabled=\"beneficiaries.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiary()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiary()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 m-b\"><button ng-if=\"beneficiary.type_person == 1\" class=\"btn btn-primary col-xs-6\" ng-click=\"typePerson(1, $index)\">Física</button> <button ng-if=\"beneficiary.type_person == 1\" class=\"btn btn-default col-xs-6\" ng-click=\"typePerson(2, $index)\">Moral</button> <button ng-if=\"beneficiary.type_person == 2\" class=\"btn btn-default col-xs-6\" ng-click=\"typePerson(1, $index)\">Física</button> <button ng-if=\"beneficiary.type_person == 2\" class=\"btn btn-primary col-xs-6\" ng-click=\"typePerson(2, $index)\">Moral</button></div><div ng-if=\"beneficiary.type_person == 1\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.first_name\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.last_name\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Apellido Materno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.second_last_name\" ng-change=\"saveLocalstorange()\"></div></div><div ng-if=\"beneficiary.type_person == 2\"><div class=\"col-xs-12 form-group\"><label>Razón Social: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.j_name\" ng-change=\"saveLocalstorange()\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>RFC: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.rfc\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Correo Electrónico:</label> <input class=\"form-control\" type=\"email\" ng-model=\"beneficiary.email\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Teléfono:</label><phonenumber-directive model=\"beneficiary.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"beneficiaries_fianza.phone_number\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div></div></div></div></div></div><div ng-if=\"endorsement.concept == 24 || endorsement.concept.value == 24 || endorsement.concept == 25 || endorsement.concept.value == 25 || endorsement.concept == 56 || endorsement.concept.value == 56\"><br><div class=\"row\" ng-if=\"!showTableCertificates\"><div class=\"col-xs-12 col-sm-6 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>No. Fianza</th><th>Categoría</th><th>ID</th></tr></thead><tbody><tr ng-repeat=\"item in categories\"><td>{{ surety.poliza_number }}</td><td>{{ item.name }}</td><td>{{ item.id }}</td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"!showTableCertificates\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label class=\"col-xs-12 btn btn-success\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i> Agregar Archivo <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\"></label></div></div><div class=\"row\" ng-if=\"showTableCertificates\"><div class=\"col-xs-1 form-group\"><select class=\"form-control\" ng-options=\"renewal.value for renewal in optionsViews\" ng-change=\"selectViews(optionViews)\" ng-model=\"optionViews\"></select></div><div><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>No. Fianza</td><td>Certificado</td><td>Correo</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>RFC</td><td>Puesto</td><td>Actividad</td><td>Monto a Garantizar</td><td>Observaciones</td><td>Categoría</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.NO_FIANZA }}</td><td>{{ item.CERTIFICADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.RFC }}</td><td>{{ item.PUESTO }}</td><td>{{ item.ACTIVIDAD }}</td><td>{{ item.MONTO_A_GARANTIZAR }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.CATEGORIA }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><br><h3 class=\"blue-color\"><input type=\"checkbox\" ng-change=\"checkSelected(checkRegister)\" ng-model=\"checkRegister\" name=\"register\" checked=\"\" disabled=\"\"> Crear Registro</h3></div><div ng-if=\"checkRegister && vm.acceso_reg_end\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Registro del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Número de Endoso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"otros\" ng-model=\"endorsement.number_endorsement\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 nopadding form-group\"><label>Bono Afianzadora:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.bono_variable\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de Bono</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"endorsement.date_bono\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkFechaBono(endorsement.date_bono)\" ng-init=\"vm.checkFechaBono(endorsement.date_bono)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de emisión de la Factura</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"endorsement.date_emision_factura\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkFechaFactura(endorsement.date_emision_factura)\" ng-init=\"vm.checkFechaFactura(endorsement.date_emision_factura)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectMontEmision\">Mes de Emisión de Factura</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in month.options\" ng-model=\"endorsement.month.month_selected\" ng-init=\"endorsement.month.month_selected = 0\" ng-change=\"changemonth()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"year\">Año Factura</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"endorsement.year_factura\" ng-change=\"changeyaer(endorsement.year_factura)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Folio Factura</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" value=\"{{endorsement.folio_factura}}\" ng-model=\"endorsement.folio_factura\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Maquila</label> <input class=\"form-control\" name=\"maquila\" type=\"text\" value=\"{{endorsement.maquila}}\" ng-model=\"endorsement.maquila\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de Maquila</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"endorsement.date_maquila\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkFechaMaquila(endorsement.date_maquila)\" ng-init=\"vm.checkFechaFactura(endorsement.date_maquila)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.endorsement_type == \'A\' || endorsement.endorsement_type == \'D\'\"><div><receipts-endorsement form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"2\"></receipts-endorsement></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"!checkRegister && vm.acceso_adm_ot\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"validitySurety()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"checkRegister && vm.acceso_adm_ot && vm.acceso_reg_end\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"checkNumEndoso()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Registrar Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ui-sref=\"endorsement.lista\" type=\"button\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div></div></div></div></div>");
$templateCache.put("app/endoso/endosos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Crear Endoso</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Agregar Endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-lg-6 col-sm-4 col-md-4\" align=\"center\" ng-hide=\"!vm.acceso_adm_pol\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': fianza_for_endoso == \'poliza\'}\"><input type=\"radio\" ng-model=\"fianza_for_endoso\" ng-click=\"f_p(fianza_for_endoso)\" value=\"Póliza\"> <b>Póliza</b></label></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-8 col-lg-6 col-sm-6 form-group\" ng-if=\"vm.acceso_adm_pol || vmacceso_adm_fia\"><label ng-if=\"fianza_for_endoso == \'Póliza\' && vm.acceso_adm_pol\">Número de Póliza<span class=\"color-red\">*</span></label> <label ng-if=\"fianza_for_endoso == \'Fianza\' && vm.acceso_adm_fia\">Número de Fianza<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.poliza_number_data\" change=\"findContractor(vm.poliza_number_data)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" ng-click=\"getPolicy(vm.poliza_number_data, true, 1)\" class=\"btn btn-success\">Buscar</button></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"selectType\">Tipo de Endoso:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-disabled=\"vm.selectTypeStatus\" ng-model=\"vm.selectedType\" ng-options=\"type as type.name for type in vm.types track by type.id\" ng-change=\"fillData(vm.selectedType)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-disabled=\"vm.selectedType.id == 1 || vm.selectedType.id == 0\"><label for=\"\">Concepto:<span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"payment\" ng-model=\"vm.description\" ng-options=\"description as description.label for description in vm.descriptions track by description.label\" ng-change=\"showFields(vm.description)\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un concepto</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"otros\"><label for=\"\">Agregue el concepto <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"otros\" ng-model=\"vm.form.other_desc\" class=\"form-control\"></div></div><div class=\"row\"><hr><div><div class=\"col-xs-12 form-group\" ng-if=\"vm.acceso_reg_end\"><h3 class=\"color-blue\"><label><input type=\"checkbox\" name=\"register\" ng-disabled=\"!vm.selectedType.name\" ng-checked=\"checkSelected(checkRegister)\" ng-model=\"checkRegister\"> &nbsp;Registrar Endoso</label></h3></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"(valueConcept == 1 || valueConcept == 11) && fianza_for_endoso == \'Póliza\'\"><label>Forma de Pago Actual:</label><div class=\"form-control\" ng-bind=\"(vm.policy.forma_de_pago | payformtype)\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"(valueConcept == 1 || valueConcept == 11) && fianza_for_endoso == \'Póliza\'\"><label>Seleccione la nueva forma de pago: <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"payment\" ng-model=\"vm.form.payment\" ng-options=\"payment as payment.label for payment in vm.payform track by payment.value\"><option value=\"\" disabled=\"\">Selecciona forma de pago</option></select></div><div ng-if=\"vm.selectedType.id\"><div ng-include=\"\'app/endoso/type/a.html\'\" ng-if=\"vm.selectedType.id === 1\"></div><div ng-include=\"\'app/endoso/type/d.html\'\" ng-if=\"vm.selectedType.id === 3\"></div><div ng-include=\"\'app/endoso/type/b.html\'\" ng-if=\"vm.selectedType.id === 2\"></div><div class=\"col-sm-12\" ng-if=\"vm.showUploader\"></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.selectedType.id\"><div class=\"row\"><div upload-template=\"\"></div></div></div><div ng-if=\"checkRegister && vm.acceso_reg_end\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Registro del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número del Endoso<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"otros\" ng-model=\"vm.form.number_endorsement\" ng-blur=\"checkNumEndoso(vm.poliza_number_data)\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.selectedType.name === \'A\'\"><label>Número de Recibos<span class=\"color-red\">*</span></label><select ng-model=\"vm.form.num_receipts\" ng-options=\"item.value as item.name for item in vm.num_receipts_data\" ng-change=\"vm.selectNumReceipts(vm.form.num_receipts)\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.selectedType.name === \'D\'\"><label>Número de Notas<span class=\"color-red\">*</span></label><select ng-model=\"vm.form.num_notas\" ng-options=\"item.value as item.name for item in vm.num_notes_data\" ng-change=\"vm.form_notes = true\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.form.num_receipts && checkRegister\"><div><endorsement-receipts tosave=\"vm.form\" form=\"vm.form\" policy=\"vm.policy\"></endorsement-receipts></div></div><div ng-if=\"vm.selectedType.name === \'D\' && vm.form_notes\"><div class=\"col-xs-12 form-group\"><hr><h3>Notas de Crédito</h3></div><form name=\"formStatusD\"><div class=\"row col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Folio:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"folio\" ng-model=\"vm.form.folio\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de Emisión:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input class=\"width-100 text-align-center form-control\" type=\"text\" name=\"startDate\" ng-model=\"vm.form.fecha_emision\" value=\"{{vm.form.fecha_emision}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Prima Neta:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"prima_neta\" ng-model=\"vm.form.p_neta\" ng-change=\"calculatePTotal()\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>IVA:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" type=\"tel\" id=\"iva\" ng-model=\"vm.form.iva\" ng-change=\"editIva(\'iva\');\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Recargo por Pago Fraccionado:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" type=\"tel\" id=\"rpf\" ng-model=\"vm.form.rpf\" ng-change=\"calculatePTotal()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Gastos de Expedición:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"prima-neta\" ng-model=\"vm.form.gastos_expedicion\" ng-change=\"calculatePTotal()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" value=\"\" id=\"prima-total\" ng-model=\"vm.form.p_total\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-success btn-mt\" ng-disabled=\"formStatusD.$invalid\" ng-click=\"calculateNote(vm.form); calculatePT()\" id=\"calcularD\" type=\"submit\">Calcular</button></div></form><div ng-if=\"vm.credit_notes.length\" class=\"row col-xs-12\"><div class=\"col-xs-12\"><table class=\"table table-stripped\"><thead><tr><th>Nota</th><th>Fecha inicio</th><th>Fecha fin</th><th>Prima Neta</th><th>IVA</th><th>RPF</th><th>Comisión</th><th>Sub Total</th><th>Gastos de expedición</th><th>Prima Total</th></tr></thead><tbody ng-repeat=\"notes in vm.credit_notes track by $index\"><tr><td><span ng-if=\"!vm.editNotes\">{{ notes.folio }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.folio\" ng-enter=\"calculateNote(vm.form, notes, $index)\"></td><td><span ng-if=\"!vm.editNotes && !(notes.initDate == null || notes.initDate == \'\' || notes.initDate == undefined || !notes.initDate || notes.initDate == \'Invalid Date\')\">{{ notes.initDate | date: \'dd/MM/yyyy\' }}</span><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"vm.editNotes\"><input type=\"text\" name=\"initDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.initDate\" value=\"Seleccione fecha\" ng-change=\"changeSinceE(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"(notes.initDate == null || notes.initDate == \'\' || notes.initDate == undefined || !notes.initDate || notes.initDate == \'Invalid Date\') && !vm.editNotes\"><input type=\"text\" name=\"initDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.initDate\" value=\"Seleccione fecha\" ng-change=\"changeSinceE(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></td><td><span ng-if=\"!vm.editNotes && !(notes.endDate == null || notes.endDate == \'\' || notes.endDate == undefined || !notes.endDate || notes.endDate == \'Invalid Date\')\">{{ notes.endDate | date: \'dd/MM/yyyy\' }}</span><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"vm.editNotes\"><input type=\"text\" name=\"endDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.endDate\" value=\"{{notes.endDate}}\" ng-change=\"changeUntilE(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"(notes.endDate == null || notes.endDate == \'\' || notes.endDate == undefined || !notes.endDate || notes.endDate == \'Invalid Date\') && !vm.editNotes\"><input type=\"text\" name=\"endDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.endDate\" value=\"{{notes.endDate}}\" ng-change=\"changeUntilE(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></td><td><span ng-if=\"!vm.editNotes\">{{ notes.prima_neta }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.prima_neta\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td><td><span ng-if=\"!vm.editNotes\">{{ notes.iva }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.iva\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td><td><span ng-if=\"!vm.editNotes\">{{ notes.rpf }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.rpf\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td><td><span ng-if=\"!vm.editNotes\">{{ notes.comision }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.comision\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td><td><span ng-if=\"!vm.editNotes\">{{ notes.sub_total }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.sub_total\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td><td><span ng-if=\"!vm.editNotes\">{{ notes.gastos_expedicion }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.gastos_expedicion\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td><td><span ng-if=\"!vm.editNotes\">{{ notes.prima_total }}</span> <input ng-if=\"vm.editNotes\" class=\"form-control\" ng-model=\"notes.prima_total\" ng-enter=\"calculateNote(vm.form, notes, $index)\" type=\"number\"></td></tr></tbody></table><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-click=\"vm.editNotes ? vm.editNotes = false : vm.editNotes = true\"><span ng-if=\"!vm.editNotes\">Editar Notas</span> <span ng-if=\"vm.editNotes\">Guardar</span></button></div></div></div></div></div><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"!checkRegister && vm.acceso_adm_ot\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"createEndorsement()\">Crear Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"checkRegister && vm.acceso_adm_ot && vm.acceso_reg_end\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"createEndorsement()\">Registrar Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ui-sref=\"endorsement.lista\" type=\"button\">Cancelar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/endoso/endosos.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a ui-sref=\"endorsement.lista\">Endosos</a></li><li class=\"active\"><strong>Endoso {{vm.insurance.internal_number}}</strong></li></ol></div></div><br><div class=\"btn-group pull-right m-b option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.insurance.policy && vm.acceso_ver_pol && vm.insurance.policy.document_type == 1\"><a ng-click=\"goToPolicy(vm.insurance.policy.id)\">Ver póliza</a></li><li ng-if=\"vm.insurance.policy && vm.acceso_ver_pol && vm.insurance.policy.document_type == 3\"><a ng-click=\"goToPolicy(vm.insurance.policy.id)\">Ver Colectividad</a></li><li ng-if=\"vm.insurance.policy && vm.acceso_ver_fia && vm.insurance.policy.document_type == 7\"><a ng-click=\"goToPolicy(vm.insurance.policy.id)\">Ver Fianza</a></li><li ng-if=\"vm.insurance.policy && vm.acceso_ver_fia && vm.insurance.policy.document_type == 8\"><a ng-click=\"goToPolicy(vm.insurance.policy.id)\">Ver Fianza Colectiva</a></li><li ng-if=\"vm.insurance.policy && vm.acceso_ver_fia\"><a ng-click=\"goToPolicy(vm.insurance.fianza.id)\">Ver fianza</a></li><li ng-if=\"vm.acceso_adm_ot\"><a ui-sref=\"endorsement.edit({endosoId: vm.insurance.id})\">Editar</a></li><li ng-if=\"vm.acceso_elim_end\"><a ng-click=\"deleteEndorsment(vm.insurance)\">Eliminar</a></li><li><a ng-click=\"vm.getPDF(vm.insurance.id)\">Ver PDF</a></li><li><a ng-click=\"sendProvider(vm.insurance)\">Enviar PDF a la compañia</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length && vm.acceso_form\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, vm.insurance.policy.id, carta.id)\">{{carta.name}}</a></li><li><a ng-click=\"vm.getPDF(vm.insurance.id)\">Resumen PDF</a></li></ul></li></ul></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"vm.insurance.number_endorsement\">Información del endoso</h5><h5 ng-if=\"!vm.insurance.number_endorsement\">Información de la OT</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\">Log</i></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4\"><legend class=\"legend-title\" align=\"center\" ng-if=\"vm.insurance.policy.document_type ==1\">Póliza</legend><legend class=\"legend-title\" align=\"center\" ng-if=\"vm.insurance.policy.document_type ==6\">Certificado</legend><legend class=\"legend-title\" align=\"center\" ng-if=\"vm.insurance.fianza\">Fianza</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ vm.insurance.policy.contractor.full_name }}{{ vm.insurance.fianza.contractor.full_name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\" ng-if=\"vm.insurance.policy.document_type !=6\">Número de póliza:</span> <span class=\"blue-color\" ng-if=\"vm.insurance.policy.document_type == 6\">Número de Póliza:</span> <span class=\"blue-color\" ng-if=\"vm.insurance.fianza\">Número de fianza:</span><div><span>{{ vm.insurance.policy.poliza_number }} <span class=\"blue-color\" ng-if=\"vm.insurance.policy.document_type == 6\">Certificado:</span> {{ vm.insurance.policy.certificate_number }} {{ vm.insurance.fianza.fianza_number }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\" ng-if=\"vm.insurance.policy.administration_type\">Tipo de Administración:</span><div><span ng-if=\"vm.insurance.policy.administration_type == 2 || vm.insurance.policy.administration_type == \'Autoadministrada\'\">Autoadministrada</span> <span ng-if=\"vm.insurance.policy.administration_type == 1 || vm.insurance.policy.administration_type == \'Simplificada\'\">Simplificada</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span ng-if=\"vm.insurance.policy\">{{ vm.insurance.policy.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ vm.insurance.policy.end_of_validity | date: \'dd/MM/yyyy\' }}</span> <span ng-if=\"vm.insurance.fianza\">{{ vm.insurance.fianza.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ vm.insurance.fianza.end_of_validity | date: \'dd/MM/yyyy\' }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ vm.insurance.policy.aseguradora.alias }}{{ vm.insurance.fianza.afianzadora.alias}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Creada por:</span><div><span>{{ vm.insurance.policy.owner }}</span> <span>{{ vm.insurance.fianza.owner }}</span></div></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><legend class=\"legend-title\" align=\"center\">Endoso</legend><div class=\"col-xs-12 col-sm-4 form-group\" style=\"word-wrap: break-word;\" ng-if=\"vm.insurance.status == 2\"><span class=\"blue-color\">Número de endoso:</span><div><span>{{ vm.insurance.number_endorsement }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\" style=\"word-wrap: break-word;\"><span class=\"blue-color\">Tipo:</span><div><span>{{ vm.insurance.endorsement_type }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\" style=\"word-wrap: break-word;\" ng-if=\"!(vm.insurance.status == 2)\"><span class=\"blue-color\">Folio interno:</span><div><span>{{ vm.insurance.internal_number }}</span></div></div><div ng-if=\"vm.insurance.policy.document_type != 3\" class=\"col-xs-12 col-sm-4 form-group\" style=\"word-wrap: break-word;\"><span class=\"blue-color\">Concepto:</span><div><span>{{ concept(vm.insurance.concept) }}</span> <span ng-if=\"vm.insurance.other_desc\">- {{ vm.insurance.other_desc }}</span></div></div><div ng-if=\"vm.insurance.policy.document_type == 3\" class=\"col-xs-12 col-sm-4 form-group\" style=\"word-wrap: break-word;\"><span class=\"blue-color\">Concepto:</span><div><span>{{ conceptCollectivity(vm.insurance.concept) }}</span> <span ng-if=\"vm.insurance.other_desc\">- {{ vm.insurance.other_desc }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.insurance.init_date | date: \'dd/MM/yyyy\' }} - {{ vm.insurance.end_date | date: \'dd/MM/yyyy\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.insurance.policy.subramo.subramo_name }}{{ vm.insurance.fianza.subramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\"><b>Creado por:</b></span><div>{{ vm.insurance.owner }}</div></div><div class=\"col-xs-12 col-sm-4 form-group\"><h4><b>Estatus:</b></h4><div class=\"label\" ng-class=\"{\'label-success\': vm.insurance.status == 2, \'label-info\' : vm.insurance.status == 5,\'label-primary\' : vm.insurance.status == 1, \'label-warning\' : vm.insurance.status == 3 || vm.insurance.status == 4}\" style=\"float: left; margin-right: 10px\">{{ status(vm.insurance.status) }}</div></div><div class=\"col-xs-6 form-group pull-right\" align=\"center\" ng-if=\"vm.insurance.seguimiento && vm.acceso_tab && && vm.acceso_tab decrptedtoken.org ==\'pruebas\'\"><span class=\"blue-color\">Tablero OT</span><div><span>{{ vm.insurance.seguimiento }}</span><div class=\"btn-group pull-right m-b\"><button style=\"border: 0px;\" type=\"button\" class=\"btn btn-white btn-sm btn-secondary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bars\" aria-hidden=\"true\"></i></button><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"dropdown-submenu\" ng-if=\"principal.contenedores.length\"><a>Mover a</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"principal.contenedores\"><a class=\"disabled\">Estados</a></li><li ng-if=\"principal.contenedores\" ng-repeat=\"newcontainer in principal.contenedores track by $index\"><a ng-click=\"moveOTState(newcontainer,principal,vm.insurance.seguimiento)\" ng-if=\"newcontainer.tablero != vm.insurance.seguimiento\">{{newcontainer.tablero}}</a></li></ul></li></ul></div></div></div><div class=\"form-group col-xs-12 col-sm-4\" style=\"margin-top: 13px;\"><button class=\"btn btn-primary\" ng-if=\"vm.insurance.status === 1 || vm.insurance.status === 5\" ng-click=\"changeStatus(vm.insurance.policy)\">Cambiar Estatus</button></div><div class=\"form-group col-xs-12 col-sm-4\" style=\"margin-top: 13px;\"><button class=\"btn btn-white\" ng-if=\"vm.insurance.status === 2\" ng-click=\"cancelEndorsement()\">Cancelar Endoso</button></div><div class=\"col-xs-12\"><hr></div><div ng-if=\"vm.insurance.status == 2\"><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.insurance.p_neta\"><span class=\"blue-color\">Prima Neta:</span><div>{{ vm.insurance.p_neta | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.insurance.endorsement_type == \'A\' && vm.insurance.derecho\"><span class=\"blue-color\">Derecho:</span><div>{{ vm.insurance.derecho | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.insurance.iva\"><span class=\"blue-color\">Iva:</span><div>{{ vm.insurance.iva | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.insurance.rpf\"><span class=\"blue-color\">RPF:</span><div>{{ vm.insurance.rpf | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.insurance.comision && vm.permiso_comisiones\"><span class=\"blue-color\">Comisión:</span><div>{{ vm.insurance.comision | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.insurance.p_total\"><span class=\"blue-color\">Prima Total:</span><div>{{ vm.insurance.p_total | currency}}</div></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Detalles</h5></div><div class=\"ibox-content\"><div class=\"col-xs-12 form-group\" style=\"margin-bottom: 40px;\"><h4>Descripción del endoso:</h4><textarea disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.insurance.observations\"></textarea></div><div class=\"col-xs-12 text-center\" ng-if=\"vm.insurance.concept == 27\"><h4 class=\"blue-color\">Fecha de antigüedad:</h4><span><span>{{vm.reconocimiento.rec_antiguedad | date: \'dd/MM/yyyy\' }}</span></span></div><div ng-if=\"aseguradotype\"><div ng-if=\"vm.insurance.policy.automobiles_policy.length && vm.insurance.concept == 4\"><div class=\"col-xs-12 col-sm-6 form-group\"><h4>Datos del Automóvil</h4><span class=\"blue-color\"><b>Tipo de vehiculo:&nbsp;</b></span> <span>{{ policy_type(vm.insurance.automobiles_policy[0].policy_type) }}<span><br><span class=\"blue-color\">Conductor:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].driver }}<span><br><span class=\"blue-color\">Marca:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].brand }}<span><br><span class=\"blue-color\">Modelo:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].model }}<span><br><span class=\"blue-color\">Año:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].year }}<span><br><span class=\"blue-color\">Version:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].version }}<span><br><span class=\"blue-color\">Color:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].color }}<span><br><span class=\"blue-color\">Motor:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].engine }}<span><br><span class=\"blue-color\">Serial:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].serial }}<span><br><span class=\"blue-color\">Matricula:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].license_plates }}<span><br><span class=\"blue-color\">Servicio:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].service }}</span><br><span class=\"blue-color\">Uso:&nbsp;</span> <span>{{ getUsage(vm.insurance.policy.automobiles_policy[0].usage) }}</span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></div><div class=\"col-xs-12 col-sm-6 form-group\"><h4>Adaptación</h4><span class=\"blue-color\">Monto de Adaptación:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].mont_adjustment | currency }}</span><br><span class=\"blue-color\">Adaptaciones:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].adjustment }}</span><br><br><span class=\"blue-color\">Monto de Equipamiento:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].mont_special_team | currency }}</span><br><span class=\"blue-color\">Equipo Especial:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].special_team }}</span><br></div><div class=\"col-xs-12 col-sm-6 form-group\"><h4>Beneficiario Preferente</h4><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].beneficiary_name }}</span><br><span class=\"blue-color\">Dirección:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].beneficiary_address }}</span><br><span class=\"blue-color\">RFC:&nbsp;</span> <span>{{ vm.insurance.policy.automobiles_policy[0].beneficiary_rfc }}</span><br></div></div><div ng-if=\"vm.insurance.policy.automobiles_policy.length && (vm.insurance.concept == 20 || vm.insurance.concept == 8)\"><div class=\"col-xs-12 col-sm-6 form-group\"><h4>Datos del Automóvil</h4><span class=\"blue-color\"><b>Tipo de vehiculo:&nbsp;</b></span> <span>{{ policy_type(vm.subforms.policy_type) }}<span><br><span class=\"blue-color\">Conductor:&nbsp;</span> <span>{{ vm.subforms.driver }}<span><br><span class=\"blue-color\">Marca:&nbsp;</span> <span>{{ vm.subforms.brand }}<span><br><span class=\"blue-color\">Modelo:&nbsp;</span> <span>{{ vm.subforms.model }}<span><br><span class=\"blue-color\">Año:&nbsp;</span> <span>{{ vm.subforms.year }}<span><br><span class=\"blue-color\">Version:&nbsp;</span> <span>{{ vm.subforms.version }}<span><br><span class=\"blue-color\">Color:&nbsp;</span> <span>{{ vm.subforms.color }}<span><br><span class=\"blue-color\">Motor:&nbsp;</span> <span>{{ vm.subforms.engine }}<span><br><span class=\"blue-color\">Serial:&nbsp;</span> <span>{{ vm.subforms.serial }}<span><br><span class=\"blue-color\">Matricula:&nbsp;</span> <span>{{ vm.subforms.license_plates }}<span><br><span class=\"blue-color\">Servicio:&nbsp;</span> <span>{{ vm.subforms.service }}</span><br><span class=\"blue-color\">Uso:&nbsp;</span> <span>{{ getUsage(vm.subforms.usage) }}</span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></div><div class=\"col-xs-12 col-sm-6 form-group\"><h4>Adaptación</h4><span class=\"blue-color\">Monto de Adaptación:&nbsp;</span> <span>{{ vm.subforms.mont_adjustment | currency }}</span><br><span class=\"blue-color\">Adaptaciones:&nbsp;</span> <span>{{ vm.subforms.adjustment }}</span><br><br><span class=\"blue-color\">Monto de Equipamiento:&nbsp;</span> <span>{{ vm.subforms.mont_special_team | currency }}</span><br><span class=\"blue-color\">Equipo Especial:&nbsp;</span> <span>{{ vm.subforms.special_team }}</span><br></div><div class=\"col-xs-12 col-sm-6 form-group\"><h4>Beneficiario Preferente</h4><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{ vm.subforms.beneficiary_name }}</span><br><span class=\"blue-color\">Dirección:&nbsp;</span> <span>{{ vm.subforms.beneficiary_address }}</span><br><span class=\"blue-color\">RFC:&nbsp;</span> <span>{{ vm.subforms.beneficiary_rfc }}</span><br></div></div><div ng-if=\"vm.insurance.policy.accidents_policy.length\"><div ng-init=\"p_info = vm.insurance.policy.accidents_policy[0].personal\"><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"p_info.full_name && vm.insurance.concept == 4\"><h4>Titular</h4><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{p_info.full_name}}</span><br><span class=\"blue-color\">Fecha de nacimiento:&nbsp;</span> <span>{{p_info.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"p_info.sex == \'M\'\">MASCULINO</span> <span ng-if=\"p_info.sex == \'F\'\">FEMENINO</span><br></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.insurance.policy.accidents_policy[0].relationship_accident.length && vm.insurance.concept == 4\"><h4>Dependientes</h4><div ng-repeat=\"relationship in vm.insurance.policy.accidents_policy[0].relationship_accident\"><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{relationship.first_name}} {{relationship.last_name}} {{relationship.second_last_name}}</span><br><span class=\"blue-color\">Fecha de Nacimiento:&nbsp;</span> <span>{{relationship.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"relationship.sex == \'F\'\">FEMENINO</span> <span ng-if=\"relationship.sex == \'M\'\">MASCULINO</span><br><span class=\"blue-color\">Parentesco:&nbsp;</span> <span ng-if=\"relationship.relationship == 1\">TITULAR</span> <span ng-if=\"relationship.relationship == 2\">CONYUGE</span> <span ng-if=\"relationship.relationship == 3\">HIJO</span> <span ng-if=\"relationship.relationship == 4\">OTRO</span><br><br></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.insurance.concept == 20 || vm.insurance.concept == 22 || vm.insurance.concept == 8\" ng-init=\"p_info = vm.subforms.personal\"><h4>Titular</h4><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{p_info.full_name}}</span><br><span class=\"blue-color\">Fecha de nacimiento:&nbsp;</span> <span>{{p_info.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"p_info.sex == \'M\'\">MASCULINO</span> <span ng-if=\"p_info.sex == \'F\'\">FEMENINO</span><br></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.insurance.concept == 20 || vm.insurance.concept == 22 || vm.insurance.concept == 8\"><h4>Dependientes</h4><div ng-repeat=\"relationship in vm.subforms.relationship_accident\"><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{relationship.first_name}} {{relationship.last_name}} {{relationship.second_last_name}}</span><br><span class=\"blue-color\">Fecha de Nacimiento:&nbsp;</span> <span>{{relationship.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"relationship.sex == \'F\'\">FEMENINO</span> <span ng-if=\"relationship.sex == \'M\'\">MASCULINO</span><br><span class=\"blue-color\">Parentesco:&nbsp;</span> <span ng-if=\"relationship.relationship == 1\">TITULAR</span> <span ng-if=\"relationship.relationship == 2\">CONYUGE</span> <span ng-if=\"relationship.relationship == 3\">HIJO</span> <span ng-if=\"relationship.relationship == 4\">OTRO</span><br><br></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.newRelationship.length && vm.insurance.status != 2\"><h4>Nuevos Asegurados</h4><div ng-repeat=\"relationship in vm.newRelationship\"><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{relationship.first_name}} {{relationship.last_name}} {{relationship.second_last_name}}</span><br><span class=\"blue-color\">Fecha de Nacimiento:&nbsp;</span> <span>{{relationship.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"relationship.sex == \'F\'\">FEMENINO</span> <span ng-if=\"relationship.sex == \'M\'\">MASCULINO</span><br><span class=\"blue-color\">Parentesco:&nbsp;</span> <span ng-if=\"relationship.relationship == 1\">TITULAR</span> <span ng-if=\"relationship.relationship == 2\">CONYUGE</span> <span ng-if=\"relationship.relationship == 3\">HIJO</span> <span ng-if=\"relationship.relationship == 4\">OTRO</span><br><br></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.toDelRelationship.length && vm.insurance.status != 2\"><h4>Asegurados a eliminar</h4><div ng-repeat=\"relationship in vm.toDelRelationship\"><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{relationship.first_name}} {{relationship.last_name}} {{relationship.second_last_name}}</span><br><span class=\"blue-color\">Fecha de Nacimiento:&nbsp;</span> <span>{{relationship.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"relationship.sex == \'F\'\">FEMENINO</span> <span ng-if=\"relationship.sex == \'M\'\">MASCULINO</span><br><span class=\"blue-color\">Parentesco:&nbsp;</span> <span ng-if=\"relationship.relationship == 1\">TITULAR</span> <span ng-if=\"relationship.relationship == 2\">CONYUGE</span> <span ng-if=\"relationship.relationship == 3\">HIJO</span> <span ng-if=\"relationship.relationship == 4\">OTRO</span><br><br></div></div></div></div><div ng-if=\"vm.insurance.policy.damages_policy.length && vm.insurance.concept == 4\" ng-init=\"damages = vm.insurance.policy.damages_policy[0]\"><div class=\"col-xs-12\"><span class=\"blue-color\">Bien Asegurado:&nbsp;</span> <span>{{ damages.insured_item }}</span><br><span class=\"blue-color\">Dirección:&nbsp;</span> <span>{{ damages.item_address }}</span><br><span class=\"blue-color\">Detalles:&nbsp;</span> <span>{{ damages.item_details }}</span><br></div></div><div ng-if=\"vm.insurance.policy.damages_policy.length && (vm.insurance.concept == 20 || vm.insurance.concept == 8)\" ng-init=\"damages = vm.subforms\"><div class=\"col-xs-12\"><span class=\"blue-color\">Bien Asegurado:&nbsp;</span> <span>{{ damages.insured_item }}</span><br><span class=\"blue-color\">Dirección:&nbsp;</span> <span>{{ damages.item_address }}</span><br><span class=\"blue-color\">Detalles:&nbsp;</span> <span>{{ damages.item_details }}</span><br></div></div><div ng-if=\"vm.insurance.policy.life_policy.length\"><div class=\"col-xs-12\"><div ng-init=\"life_info = vm.insurance.policy.life_policy[0].personal\"><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.insurance.concept == 4\"><h4>Asegurado</h4><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{ life_info.full_name }}</span><br><span class=\"blue-color\">Fecha de nacimiento:&nbsp;</span> <span>{{ life_info.birthdate | date: \'dd/MM/yyyy\' }}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"life_info.sex == \'M\'\">MASCULINO</span> <span ng-if=\"life_info.sex == \'F\'\">FEMENINO</span><br><span class=\"blue-color\">Fumador:&nbsp;</span> <span ng-if=\"vm.insurance.life_policy[0].smoker\">SI</span> <span ng-if=\"!vm.insurance.life_policy[0].smoker\">NO</span><br></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.insurance.concept == 4\"><h4>Beneficiarios</h4><div ng-repeat=\"relationship in vm.insurance.policy.life_policy[0].beneficiaries_life\"><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{ relationship.j_name }}{{ relationship.first_name }} {{ relationship.last_name }} {{ relationship.second_last_name }}</span><br><span class=\"blue-color\" ng-if=\"relationship.j_name\">RFC:&nbsp;</span> <span ng-if=\"relationship.j_name\">{{ relationship.rfc }}</span><br ng-if=\"relationship.j_name\"><span class=\"blue-color\" ng-if=\"relationship.optional_relationship\">Parentesco:&nbsp;</span> <span>{{ relationship.optional_relationship }}</span><br><span class=\"blue-color\" ng-if=\"!relationship.j_name\">Fecha de Nacimiento:&nbsp;</span> <span ng-if=\"!relationship.j_name\">{{ relationship.birthdate | date: \'dd/MM/yyyy\' }}</span><br><span class=\"blue-color\" ng-if=\"!relationship.j_name\">Sexo:&nbsp;</span> <span ng-if=\"relationship.sex == \'F\' && !relationship.j_name\">FEMENINO</span> <span ng-if=\"relationship.sex == \'M\' && !relationship.j_name\">MASCULINO</span><br><span class=\"blue-color\" ng-if=\"!relationship.j_name\">Porcentaje:&nbsp;</span> <span ng-if=\"!relationship.j_name\">{{ relationship.percentage }}%</span><br><br></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.insurance.concept == 20 || vm.insurance.concept == 22 || vm.insurance.concept == 8\" ng-init=\"p_info = vm.subforms.personal\"><h4>Titular</h4><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{p_info.first_name}} {{p_info.last_name}} {{p_info.second_last_name}}</span><br><span class=\"blue-color\">Fecha de nacimiento:&nbsp;</span> <span>{{p_info.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"p_info.sex == \'M\'\">MASCULINO</span> <span ng-if=\"p_info.sex == \'F\'\">FEMENINO</span><br></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.insurance.concept == 20 || vm.insurance.concept == 22 || vm.insurance.concept == 8\"><h4>Beneficiarios</h4><div ng-repeat=\"relationship in vm.subforms.beneficiaries_life\"><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{relationship.first_name}} {{relationship.last_name}} {{relationship.second_last_name}}</span><br><span class=\"blue-color\">Fecha de Nacimiento:&nbsp;</span> <span>{{relationship.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"relationship.sex == \'F\'\">FEMENINO</span> <span ng-if=\"relationship.sex == \'M\'\">MASCULINO</span><br><span class=\"blue-color\">Parentesco:&nbsp;</span> <span>{{relationship.optional_relationship}}</span><br><br></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.newBeneficiaries.length && vm.insurance.status != 2\"><h4>Nuevos Asegurados</h4><div ng-repeat=\"relationship in vm.newBeneficiaries\"><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{relationship.first_name}} {{relationship.last_name}} {{relationship.second_last_name}}</span><br><span class=\"blue-color\">Fecha de Nacimiento:&nbsp;</span> <span>{{relationship.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"relationship.sex == \'F\'\">FEMENINO</span> <span ng-if=\"relationship.sex == \'M\'\">MASCULINO</span><br><span class=\"blue-color\">Parentesco:&nbsp;</span> <span ng-if=\"relationship.optional_relationship == 1\">TITULAR</span> <span ng-if=\"relationship.optional_relationship == 2\">CONYUGE</span> <span ng-if=\"relationship.optional_relationship == 3\">HIJO</span> <span ng-if=\"relationship.optional_relationship == 4\">OTRO</span><br><br></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.toDelBeneficiarie.length && vm.insurance.status != 2\"><h4>Asegurados a eliminar</h4><div ng-repeat=\"relationship in vm.toDelBeneficiarie\"><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{relationship.first_name}} {{relationship.last_name}} {{relationship.second_last_name}}</span><br><span class=\"blue-color\">Fecha de Nacimiento:&nbsp;</span> <span>{{relationship.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"relationship.sex == \'F\'\">FEMENINO</span> <span ng-if=\"relationship.sex == \'M\'\">MASCULINO</span><br><span class=\"blue-color\">Parentesco:&nbsp;</span> <span ng-if=\"relationship.relationship == 1\">TITULAR</span> <span ng-if=\"relationship.relationship == 2\">CONYUGE</span> <span ng-if=\"relationship.relationship == 3\">HIJO</span> <span ng-if=\"relationship.relationship == 4\">OTRO</span><br><br></div></div></div></div></div></div><div class=\"col-xs-12 hidden-xs hidden-sm\" ng-if=\"vm.coverages && vm.insurance.policy\"><legend class=\"legend-title blue-color\" align=\"center\">Coberturas</legend><table class=\"table table-bordered table-hover\"><thead><tr><th>Cobertura</th><th>Suma Asegurada</th><th>Deducible</th><th ng-if=\"vm.insurance.policy.ramo.ramo_code == 2\">Coaseguro</th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.coverages track by $index\" ng-if=\"coverage.coverage_name && (coverage.sum_insured || coverage.deductible || coverage.coinsurance) && (coverage.sum_insured != 0 || coverage.deductible != 0 || coverage.coinsurance != 0)\"><td>{{ coverage.coverage_name }}</td><td>{{ formatCoverage(coverage.sum_insured) }}</td><td>{{ formatCoverage(coverage.deductible) }}</td><td ng-if=\"vm.insurance.policy.ramo.ramo_code == 2\">{{coverage.coinsurance}}</td></tr></tbody></table></div><div class=\"col-xs-12 text-center\" ng-if=\"cfp\"><h4 class=\"blue-color\">Forma de pago a registrar:</h4><span>{{ payform(vm.insurance.change) }}</span></div><div class=\"col-xs-12 text-center\" ng-if=\"cancelacion\"><h4 class=\"blue-color\">Motivo de cancelación:</h4><span ng-if=\"vm.insurance.concept == 16\">Cancelación por petición</span> <span ng-if=\"vm.insurance.concept == 17\">Cancelación por falta de pago</span></div><div class=\"row\" ng-if=\"vm.insurance.concept == 31\"><div class=\"col-sm-12\"><legend class=\"text-center\" ng-if=\"vm.insurance.policy.subramo.subramo_code == 3\">Dependientes</legend><legend class=\"text-center\" ng-if=\"vm.insurance.policy.subramo.subramo_code == 1\">Beneficiarios</legend><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"certificates && vm.insurance.policy.subramo.subramo_code == 1\"><div class=\"row col-md-12 col-sm-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Certificado</th><th>Beneficiario</th><th>Parentesco</th><th>Sexo</th><th>Fecha Nacimiento</th></tr></thead><tbody><tr ng-repeat=\"info in certificates track by $index\"><td>{{info.certificate_number}}</td><td><span ng-if=\"!info.full_name\">{{info.first_name}} {{info.last_name}} {{info.second_last_name}}</span><span ng-if=\"info.full_name\">{{info.full_name}}</span></td><td><span ng-if=\"info.optional_relationship ==1\">Titular</span> <span ng-if=\"info.optional_relationship ==2\">Conyuge</span> <span ng-if=\"info.optional_relationship ==3\">Hijo</span> <span ng-if=\"info.optional_relationship ==4\">Otro</span></td><td><span ng-if=\"info.sex == \'M\'\">Masculino</span><span ng-if=\"info.sex == \'F\'\">Femenino</span></td><td>{{info.birthdate | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table></div></div></div><div class=\"col-xs-12\" ng-if=\"certificates && vm.insurance.policy.subramo.subramo_code == 3\"><div class=\"row col-md-12 col-sm-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Certificado</th><th>Dependiente</th><th>Parentesco</th><th>Sexo</th><th>Fecha Nacimiento</th></tr></thead><tbody><tr ng-repeat=\"info in certificates track by $index\"><td>{{info.certificate_number}}</td><td><span ng-if=\"!info.full_name\">{{info.first_name}} {{info.last_name}} {{info.second_last_name}}</span><span ng-if=\"info.full_name\">{{info.full_name}}</span></td><td><span ng-if=\"info.relationship ==1\">Titular</span> <span ng-if=\"info.relationship ==2\">Conyuge</span> <span ng-if=\"info.relationship ==3\">Hijo</span> <span ng-if=\"info.relationship ==4\">Otro</span></td><td><span ng-if=\"info.sex == \'M\'\">Masculino</span><span ng-if=\"info.sex == \'F\'\">Femenino</span></td><td>{{info.birthdate | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.insurance.concept == 24 || vm.insurance.concept == 25\"><div class=\"col-sm-12\"><legend class=\"text-center\">Certificados</legend><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"dependientes.length && vm.insurance.policy.subramo.subramo_code == 1\"><ul class=\"list-group col-xs-12\"><li class=\"list-group-item\" ng-repeat=\"item in dependientes track by id\"><b>Beneficiario:</b> <span ng-repeat=\"beneficiary in dependientes track by id\">{{$index + 1}}.- {{beneficiary.first_name + \" \" + beneficiary.last_name}}<span ng-if=\"beneficiary.second_last_name\">{{\" \" + beneficiary.second_last_name}}</span></span><b>Fecha Movimiento:</b>{{vm.insurance.init_date | date: \'dd/MM/yyyy\'}}</li></ul></div><div class=\"col-xs-12\" ng-if=\"dependientes.length && vm.insurance.policy.subramo.subramo_code == 3\"><ul class=\"list-group col-xs-12\"><li class=\"list-group-item\" ng-repeat=\"item in dependientes track by id\"><b>Dependiente:</b> <span ng-repeat=\"beneficiary1 in dependientes track by id\">{{$index + 1}}.- {{beneficiary1.first_name + \" \" + beneficiary1.last_name}}<span ng-if=\"beneficiary1.second_last_name\">{{\" \" + beneficiary1.second_last_name}}</span></span><b>Fecha Movimiento:</b>{{vm.insurance.init_date | date: \'dd/MM/yyyy\'}}</li></ul></div><div class=\"col-xs-12\" ng-if=\"vm.certificates.length && vm.insurance.policy.subramo.subramo_code == 1\"><ul class=\"list-group col-xs-12\"><li class=\"list-group-item\" ng-repeat=\"item in vm.certificates track by $index\"><input class=\"pull-right\" type=\"checkbox\" ng-checked=\"checkSelected(item.id)\" ng-click=\"addCertificate(item.id)\" ng-init=\"info = item.certificate\"> <b>No. certificado:</b> <span ng-if=\"info.certificate_number\">{{info.certificate_number}}</span> <input ng-if=\"!info.certificate_number\" ng-model=\"info.certificate_number_patch\"> <b>Asegurado:</b>{{info.life_policy[0].personal.first_name + \" \" + info.life_policy[0].personal.last_name + \" \" + info.life_policy[0].personal.second_last_name + \" - \"}} <b>Antigüedad:</b>{{info.rec_antiguedad | date: \'dd/MM/yyyy\'}} <b>Dependientes:</b> <span ng-repeat=\"beneficiary in info.life_policy[0].beneficiaries_life\" ng-if=\"!beneficiary.is_active\">{{$index + 1}}.- {{beneficiary.first_name + \" \" + beneficiary.last_name}}</span> <b>Fecha Movimiento:</b>{{vm.insurance.init_date | date: \'dd/MM/yyyy\'}}</li></ul></div><div class=\"col-xs-12\" ng-if=\"vm.certificates.length && vm.insurance.policy.ramo.ramo_code == 3 && vm.insurance.policy.subramo.subramo_code != 9\"><h4>Daños</h4><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in vm.certificates track by $index\"><input class=\"pull-right\" type=\"checkbox\" ng-checked=\"checkSelected(item.id)\" ng-click=\"addCertificate(item.id)\" ng-init=\"info = item.certificate.damages_policy[0]\"> <b>No. certificado:</b> <span ng-if=\"info.certificate_number\">{{info.certificate_number}}</span> <input ng-if=\"!info.certificate_number\" ng-model=\"info.certificate_number_patch\"> <b>Bien asegurado:</b>{{info.insured_item}} <b>Detalles:</b>{{info.item_details}} <b>Fecha Movimiento:</b>{{vm.insurance.init_date | date: \'dd/MM/yyyy\'}}</li></ul></div><div class=\"col-xs-12\" ng-if=\"vm.certificates.length && vm.insurance.policy.subramo.subramo_code == 3\"><ul class=\"list-group col-xs-12\"><li class=\"list-group-item\" ng-repeat=\"item in vm.certificates track by $index\"><input class=\"pull-right\" type=\"checkbox\" ng-checked=\"checkSelected(item.id)\" ng-click=\"addCertificate(item.id)\" ng-init=\"info = item.certificate\"> <b>No. certificado:</b> <span ng-if=\"info.certificate_number\">{{info.certificate_number}}</span> <input ng-if=\"!info.certificate_number\" ng-model=\"info.certificate_number_patch\"> <b>Asegurado:</b>{{info.accidents_policy[0].personal.first_name + \" \" + info.accidents_policy[0].personal.last_name + \" \" + info.accidents_policy[0].personal.second_last_name + \" - \"}} <b>Antigüedad:</b>{{info.rec_antiguedad | date: \'dd/MM/yyyy\'}} <b>Dependientes:</b> <span ng-repeat=\"beneficiary in info.accidents_policy[0].relationship_accident\" ng-if=\"!beneficiary.is_active\">{{$index + 1}}.- {{beneficiary.first_name + \" \" + beneficiary.last_name}}</span> <b>Fecha Movimiento:</b>{{vm.insurance.init_date | date: \'dd/MM/yyyy\'}}</li></ul></div><div class=\"col-xs-12\" ng-if=\"vm.certificates.length && vm.insurance.policy.subramo.subramo_code == 9\"><h4>Automóviles</h4><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in vm.certificates track by $index\"><input class=\"pull-right\" type=\"checkbox\" ng-checked=\"checkSelected(item.id)\" ng-click=\"addCertificate(item.id)\" ng-init=\"info = item.certificate.automobiles_policy[0]\"> <b>No. certificado:</b> <span ng-if=\"item.certificate.certificate_number\">{{item.certificate.certificate_number}}</span> <input ng-if=\"!item.certificate.certificate_number\" ng-model=\"info.certificate_number_patch\"> <b>General:</b> {{info.brand + \" \" + info.model + \" \" + info.version + \" \" + info.year + \" \" + info.color}} <b>Fecha Movimiento:</b>{{vm.insurance.init_date | date: \'dd/MM/yyyy\'}}</li></ul></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"vm.insurance.policy && vm.recibosPor1 == 1\">Recibos de Póliza</h5><h5 ng-if=\"vm.insurance.policy.document_type == 6 && vm.recibosPor1 == 2\">Recibos de Subgrupo</h5><h5 ng-if=\"vm.insurance.fianza\">Recibos de Fianza</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"poliza_multianual\"><label>Año:</label><select class=\"form-control\" ng-model=\"anioPoliza\" data-ng-options=\"anio for anio in aniosPoliza\" ng-change=\"showReceiptsYear(anioPoliza)\"></select><br></div><div class=\"col-xs-12\" ng-if=\"!vm.show_binnacle_receipt && vm.insurance.policy && vm.insurance.policy.administration_type != 2\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}}</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th><th ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}}</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}}</th><th ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}}</th><th width=\"3%\">Entregado</th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th></tr></thead><tbody><tr ng-click=\"changeStatusModal(receipt, vm.insurance.policy, vm.insurance.policy)\" ng-repeat=\"receipt in vm.policy_receipts track by $index\" ng-show=\"receipt.status != 0\"><td>{{ receipt.recibo_numero }} / {{vm.policy_receipts.length}}</td><td>{{ receipt.prima_neta | currency }}</td><td>{{ receipt.derecho | currency }}</td><td>{{ receipt.rpf | currency }}</td><td>{{ receipt.iva | currency }}</td><td ng-if=\"vm.permiso_comisiones\">{{ receipt.comision | currency }}</td><td>{{ receipt.prima_total | currency }}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\'}}</td><td>{{receipt.vencimiento | date: \'dd/MM/yyyy\'}}</td><td><span>{{ statusReceipts(receipt.status) }}</span></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(receipt)\"><span ng-if=\"receipt.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!receipt.delivered\"><i class=\"fa fa-times\"></i></span></td><td><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacleReceipt(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><div ng-if=\"receipt.track_bitacora\" class=\"identificador-dash-binnacle\"></div><a class=\"btn btn-warning btn-sm\" ng-click=\"$event.stopPropagation();applyEx()\" ng-if=\"receipt.excedente > 0\" style=\"background-color: white;border-color: #f8ac59;color: black;\"><i class=\"fa fa-hand-holding-usd\" aria-hidden=\"true\" title=\"Recibo con excedente sin aplicar\"></i></a> <a ng-if=\"receipt.is_cat\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a></td></tr></tbody></table></div><div class=\"col-xs-12\" ng-if=\"!vm.show_binnacle_receipt && vm.insurance.fianza\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}}</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th><th ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}}</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}}</th><th ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}}</th><th width=\"3%\">Entregado</th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th></tr></thead><tbody><tr ng-click=\"changeStatusModal(receipt, vm.insurance.fianza, vm.insurance.fianza)\" ng-repeat=\"receipt in vm.policy_receipts track by $index\"><td>{{ receipt.recibo_numero }} / {{vm.policy_receipts.length}}</td><td>{{ receipt.prima_neta | currency }}</td><td>{{ receipt.derecho | currency }}</td><td>{{ receipt.rpf | currency }}</td><td>{{ receipt.iva | currency }}</td><td ng-if=\"vm.permiso_comisiones\">{{ receipt.comision | currency }}</td><td>{{ receipt.prima_total | currency }}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\'}}</td><td>{{receipt.vencimiento | date: \'dd/MM/yyyy\'}}</td><td><span>{{ statusReceipts(receipt.status) }}</span></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(receipt)\"><span ng-if=\"receipt.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!receipt.delivered\"><i class=\"fa fa-times\"></i></span></td><td><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacleReceipt(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><div ng-if=\"receipt.track_bitacora\" class=\"identificador-dash-binnacle\"></div><a ng-if=\"receipt.is_cat\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div class=\"col-xs-12\"><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle_receipt\"><div class=\"col-md-12\"><div><label>Bitácora de recibos</label> <a class=\"btn btn-info pull-right\" ng-click=\"vm.returnToReceipts()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data_receipt\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.insurance.endorsement_type == \'A\' && !cfp && vm.insurance.status != 5\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de Endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"!vm.show_binnacle_receipt_end\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th>Endoso</th><th ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}}</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th><th ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}}</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}}</th><th ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}}</th><th width=\"3%\">Entregado</th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th></tr></thead><tbody><tr ng-click=\"changeStatusModal(receipt, vm.insurance.policy, vm.insurance.policy)\" ng-repeat=\"receipt in vm.endorsement_receipts track by $index\" ng-if=\"receipt.status != 0\"><td ng-if=\"receipt.endorsement\">{{ receipt.endorsement }}</td><td ng-click=\"$event.stopPropagation();\" ng-if=\"!receipt.endorsement\"><div class=\"form-group\"><select class=\"form-control\" ng-disabled=\"receipt.endorsement\" ng-model=\"vm.endosoSelected[$index]\" ng-options=\"endoso as endoso.number_endorsement for endoso in vm.endoToSelect track by endoso.id\" ng-change=\"selectEndoso(receipt, vm.endosoSelected[$index])\"><option disabled=\"\" value=\"\">Selecciona</option></select></div></td><td>{{ receipt.recibo_numero }} / {{vm.endorsement_receipts.length }}</td><td>{{ receipt.prima_neta | currency }}</td><td>{{ receipt.derecho | currency }}</td><td>{{ receipt.rpf | currency }}</td><td>{{ receipt.iva | currency }}</td><td ng-if=\"vm.permiso_comisiones\">{{ receipt.comision | currency }}</td><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.fecha_inicio | date: \'dd/MM/yyyy\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' }}</td><td>{{receipt.vencimiento | date: \'dd/MM/yyyy\'}}</td><td><span>{{ statusReceipts(receipt.status) }}</span></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(receipt)\"><span ng-if=\"receipt.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!receipt.delivered\"><i class=\"fa fa-times\"></i></span></td><td><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacleReceipt_Endoso(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><div ng-if=\"receipt.track_bitacora\" class=\"identificador-dash-binnacle\"></div><a class=\"btn btn-warning btn-sm\" ng-click=\"$event.stopPropagation();applyEx()\" ng-if=\"receipt.excedente > 0\" style=\"background-color: white;border-color: #f8ac59;color: black;\"><i class=\"fa fa-hand-holding-usd\" aria-hidden=\"true\" title=\"Recibo con excedente sin aplicar\"></i></a> <a ng-if=\"receipt.is_cat\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <button class=\"btn btn-sm btn-primary\" ng-click=\"$event.stopPropagation(); editReceipt(receipt)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-sm btn-danger\" ng-if=\"vm.permiso_delete_cobranza\" ng-click=\"$event.stopPropagation(); deleteReceipt(receipt)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr><tr><td>Totales</td><td></td><td>{{calculatePrima(vm.endorsement_receipts) | currency}}</td><td>{{calculateDerecho(vm.endorsement_receipts) | currency}}</td><td>{{calculateRpf(vm.endorsement_receipts) | currency}}</td><td>{{calculateIva(vm.endorsement_receipts) | currency}}</td><td>{{calculateComision(vm.endorsement_receipts) | currency}}</td><td>{{calculatePrimaTotal(vm.endorsement_receipts) | currency}}</td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><div class=\"col-xs-12\"><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div></div></div></div></div></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle_receipt_end\"><div class=\"col-md-12\"><div><label>Bitácora de Recibos endoso</label> <a class=\"btn btn-info pull-right\" ng-click=\"vm.returnToReceipts_End()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data_receipt_endoso\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div></div><div class=\"row\" ng-if=\"vm.insurance.endorsement_type == \'D\' && vm.insurance.status == 2\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de Nota de Crédito</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"!vm.show_binnacle_notes\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}}</th><th>Folio</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}}</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th>Gastos de Expedición</th><th>Fecha de vencimiento</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[6]}}</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th></tr></thead><tbody><tr ng-click=\"changeStatusModal(receipt, vm.insurance.policy ? vm.insurance.policy : vm.insurance.fianza, vm.insurance.policy ? vm.insurance.policy : vm.insurance.fianza)\" ng-repeat=\"receipt in vm.endorsement_receipts track by $index\" ng-if=\"receipt.receipt_type == 3 || receipt.receipt_type == 2\"><td>{{ receipt.recibo_numero }}/ {{vm.endorsement_receipts.length }}</td><td>{{ receipt.folio }}</td><td>{{ receipt.prima_neta | currency }}</td><td>{{ receipt.rpf | currency }}</td><td>{{ receipt.iva | currency }}</td><td>{{ receipt.derecho | currency }}</td><td>{{ receipt.vencimiento | date: \'dd/MM/yyyy\'}}</td><td ng-if=\"vm.permiso_comisiones\">{{ receipt.comision | currency }}</td><td>{{ receipt.prima_total | currency }}</td><td><span>{{ statusReceipts(receipt.status) }}</span></td><td>{{ receipt.fecha_inicio | date: \'dd/MM/yyyy\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' }}</td><td><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacleNotes(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><div ng-if=\"receipt.track_bitacora\" class=\"identificador-dash-binnacle\"></div><a ng-if=\"receipt.is_cat\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <button class=\"btn btn-sm btn-primary\" ng-click=\"$event.stopPropagation(); editReceipt(receipt)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></td></tr><tr><td>Totales</td><td></td><td>{{calculatePrima(vm.endorsement_receipts) | currency}}</td><td>{{calculateRpf(vm.endorsement_receipts) | currency}}</td><td>{{calculateIva(vm.endorsement_receipts) | currency}}</td><td>{{calculateDerecho(vm.endorsement_receipts) | currency}}</td><td>{{calculateComision(vm.endorsement_receipts) | currency}}</td><td>{{calculatePrimaTotal(vm.endorsement_receipts) | currency}}</td><td></td><td></td><td></td></tr></tbody></table><div class=\"col-xs-12\"><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div></div></div></div></div></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle_notes\"><div class=\"col-md-12\"><div><label>Bitácora de Notas de Crédito</label> <a class=\"btn btn-info pull-right\" ng-click=\"vm.returnToNotes()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data_notes\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/show-files.html\'\"></div><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(vm.insurance)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Archivos</button></div></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in filesCover track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"renameFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file, filesCover)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td></tr></tbody></table></div></div></div></div></div></div><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"10\" idmodel=\"vm.endosoId\"></comments></div></div></div></div></div><div class=\"row\"><script type=\"text/javascript\">\n\n    function renombrarArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n\n      btnTag.addClass(\'display-none\');\n      dummy.removeClass(\'display-none\');\n\n\n      inputTag.removeClass(\'display-none\');\n      strongTag.addClass(\'display-none\');\n\n      inputTag.focus();\n    }\n\n    function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target);\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n\n      // btnTag.prop(\'onclick\',null).off(\'click\');\n\n      btnTag.removeClass(\'display-none\');\n      dummy.addClass(\'display-none\');\n\n\n      inputTag.addClass(\'display-none\');\n      strongTag.removeClass(\'display-none\');\n    }\n  </script></div>");
$templateCache.put("app/endoso/endosos.status.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Cambiar Estatus</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><h3>Estatus del endoso:</h3><div class=\"label\" ng-class=\"{\'label-success\': endoso.status == 2, \'label-info\' : endoso.status == 5,\'label-primary\' : endoso.status == 1, \'label-warning\' : endoso.status == 3 || endoso.status == 4}\">{{ status(endoso.status) }}</div></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><select class=\"form-control m-b\" ng-model=\"vmm.selectedType\" ng-options=\"s as s.label for s in vmm.status track by s.value\" ng-if=\"s.value != 1 || s.value != 5\"><option disabled=\"\" value=\"\">Selecciona un estatus</option></select></div></div><div class=\"row\" ng-if=\"vmm.selectedType.value == 2 && endoso.endorsement_type === \'A\'\"><div class=\"form-group col-xs-12 col-sm-6\"><label for=\"\">Número de Endoso<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.number_endorsement\" ng-blur=\"checkNumEndoso(vmm.policy)\"></div><div class=\"form-group col-xs-12 col-sm-6\" ng-init=\"numberReceipts()\"><label for=\"\">Número de Recibos</label><select ng-model=\"vmm.form.num_receipts\" ng-options=\"item.value as item.name for item in vmm.num_receipts_data\" ng-change=\"vmm.selectNumReceipts(vmm.form.num_receipts)\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"form-group col-xs-12\"><div class=\"row\"><div upload-template=\"\"></div></div></div><div ng-if=\"vmm.form.num_receipts == 0 || vmm.form.num_receipts > 0\"><div><endorsement-receipts tosave=\"vmm.infoReceipt\" form=\"vmm.form\" policy=\"vmm.policy\"></endorsement-receipts></div></div></div><div class=\"row\" ng-if=\"vmm.selectedType.value == 2 && endoso.endorsement_type === \'B\'\"><div class=\"form-group col-xs-12 col-sm-6\" ng-init=\"vmm.createdNote = true\"><label for=\"\">Número de Endoso</label> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.number_endorsement\" ng-blur=\"checkNumEndoso(vmm.policy)\"></div><div class=\"form-group col-xs-12\"><div class=\"row\"><div upload-template=\"\"></div></div></div></div><div class=\"row\" ng-if=\"vmm.selectedType.value == 2 && endoso.endorsement_type === \'D\'\"><div class=\"form-group col-xs-12 col-sm-6\"><label for=\"\">Número de Endoso<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.number_endorsement\" ng-blur=\"checkNumEndoso(vmm.policy)\"></div><div class=\"form-group col-xs-12 col-sm-6\" ng-init=\"numberReceipts()\"><label for=\"\">Número de Notas de Crédito</label><select ng-model=\"vmm.infoNote.num_notas\" ng-options=\"item.value as item.name for item in vmm.num_notes_data\" class=\"form-control\" ng-change=\"vmm.form_notes = true\"><option value=\"\">Selecciona una opción</option></select></div><div ng-if=\"endoso.endorsement_type === \'D\' && vmm.infoNote.num_notas == 0 || endoso.endorsement_type === \'D\' && vmm.infoNote.num_notas > 0\"><div class=\"col-xs-12 form-group\"><hr><h3>Notas de Crédito</h3></div><form name=\"formStatusD\"><div class=\"row col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Folio:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"folio\" ng-model=\"vmm.infoNote.folio\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de Emisión:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input class=\"width-100 text-align-center form-control\" type=\"text\" name=\"startDate\" ng-model=\"vmm.infoNote.fecha_emision\" value=\"{{vmm.infoNote.fecha_emision}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Prima Neta:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"prima_neta\" ng-model=\"vmm.infoNote.p_neta\" ng-change=\"calculatePT(); calculateIVA()\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>IVA:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" type=\"tel\" id=\"iva\" ng-model=\"vmm.infoNote.iva\" ng-change=\"calculatePT()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>RPF:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" type=\"tel\" id=\"rpf\" ng-model=\"vmm.infoNote.rpf\" ng-change=\"calculatePT(); calculateIVA()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Gastos de Expedición:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"prima-neta\" ng-model=\"vmm.infoNote.gastos_expedicion\" ng-change=\"calculatePT()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" value=\"\" id=\"prima-neta\" ng-model=\"vmm.infoNote.p_total\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-success btn-mt\" ng-disabled=\"formStatusD.$invalid\" ng-click=\"calculateNote(vmm.infoNote);\" id=\"calcularD\" type=\"submit\">Calcular</button></div></form><div ng-if=\"vmm.credit_notes.length\" class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-stripped\"><thead><tr><th>Nota</th><th class=\"text-align-center\">Inicio de vigencia</th><th class=\"text-align-center\">Fin de vigencia</th><th class=\"text-align-center\">Fecha de vencimiento</th><th>Prima Neta</th><th>IVA</th><th>RPF</th><th>Comisión</th><th>Sub Total</th><th>Gastos de expedición</th><th>Prima Total</th></tr></thead><tbody ng-repeat=\"notes in vmm.credit_notes\"><tr><td><span ng-if=\"!vmm.editNotes\">{{ notes.folio }}</span> <input ng-if=\"vmm.editNotes\" class=\"form-control\" ng-model=\"notes.folio\"></td><td><span ng-if=\"!vmm.editNotes && !(notes.initDate == null || notes.initDate == \'\' || notes.initDate == undefined || !notes.initDate || notes.initDate == \'Invalid Date\')\">{{ notes.initDate | date: \'dd/MM/yyyy\' }}</span><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"vmm.editNotes\"><input type=\"text\" name=\"initDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.initDate\" value=\"Seleccione fecha\" ng-change=\"changeSince(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"(notes.initDate == null || notes.initDate == \'\' || notes.initDate == undefined || !notes.initDate || notes.initDate == \'Invalid Date\') && !vmm.editNotes\"><input type=\"text\" name=\"initDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.initDate\" value=\"Seleccione fecha\" ng-change=\"changeSince(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></td><td><span ng-if=\"!vmm.editNotes && !(notes.endDate == null || notes.endDate == \'\' || notes.endDate == undefined || !notes.endDate || notes.endDate == \'Invalid Date\')\">{{ notes.endDate | date: \'dd/MM/yyyy\' }}</span><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"vmm.editNotes\"><input type=\"text\" name=\"endDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.endDate\" value=\"{{notes.endDate}}\" ng-change=\"changeUntil(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"(notes.endDate == null || notes.endDate == \'\' || notes.endDate == undefined || !notes.endDate || notes.endDate == \'Invalid Date\') && !vmm.editNotes\"><input type=\"text\" name=\"endDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.endDate\" value=\"{{notes.endDate}}\" ng-change=\"changeUntil(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></td><td><span ng-if=\"!vmm.editNotes && !(notes.vencimiento == null || notes.vencimiento == \'\' || notes.vencimiento == undefined || !notes.vencimiento || notes.vencimiento == \'Invalid Date\')\">{{ notes.vencimiento | date: \'dd/MM/yyyy\' }}</span><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"vmm.editNotes\"><input type=\"text\" name=\"vencimiento\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.vencimiento\" value=\"{{notes.vencimiento}}\" ng-change=\"changeUntil(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"(notes.vencimiento == null || notes.vencimiento == \'\' || notes.vencimiento == undefined || !notes.vencimiento || notes.vencimiento == \'Invalid Date\') && !vmm.editNotes\"><input type=\"text\" name=\"vencimiento\" class=\"width-100 text-align-center form-control\" ng-model=\"notes.vencimiento\" value=\"{{notes.vencimiento}}\" ng-change=\"changeUntil(notes,$index)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></td><td><span ng-if=\"!vmm.editNotes\">{{ notes.prima_neta }}</span><input ng-if=\"vmm.editNotes\" class=\"form-control\" ng-model=\"notes.prima_neta\" ng-enter=\"calculateNote(vmm.infoNote,notes,$index)\"></td><td><span ng-if=\"!vmm.editNotes\">{{ notes.iva }}</span> <input ng-if=\"vmm.editNotes\" class=\"form-control\" ng-model=\"notes.iva\" ng-enter=\"calculateNote(vmm.infoNote,notes,$index)\"></td><td><span ng-if=\"!vmm.editNotes\">{{ notes.rpf }}</span> <input ng-if=\"vmm.editNotes\" class=\"form-control\" ng-model=\"notes.rpf\" ng-enter=\"calculateNote(vmm.infoNote,notes, $index)\"></td><td><span ng-if=\"!vmm.editNotes\">{{ notes.comision }}</span> <input ng-if=\"vmm.editNotes\" class=\"form-control\" ng-model=\"notes.comision\" ng-enter=\"calculateNote(vmm.infoNote,notes, $index)\"></td><td><span ng-if=\"!vmm.editNotes\">{{ notes.sub_total }}</span> <input ng-if=\"vmm.editNotes\" class=\"form-control\" ng-model=\"notes.sub_total\" ng-enter=\"calculateNote(vmm.infoNote,notes,$index)\"></td><td><span ng-if=\"!vmm.editNotes\">{{ notes.gastos_expedicion }}</span> <input ng-if=\"vmm.editNotes\" class=\"form-control\" ng-model=\"notes.gastos_expedicion\" ng-enter=\"calculateNote(vmm.infoNote,notes,$index)\"></td><td><span ng-if=\"!vmm.editNotes\">{{ notes.prima_total }}</span> <input ng-if=\"vmm.editNotes\" class=\"form-control\" ng-model=\"notes.prima_total\" ng-enter=\"calculateNote(vmm.infoNote,notes,$index)\"></td></tr></tbody></table><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-click=\"vmm.editNotes ? vmm.editNotes = false : vmm.editNotes = true\"><span ng-if=\"!vmm.editNotes\">Editar Notas</span> <span ng-if=\"vmm.editNotes\">Guardar</span></button></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success\" ng-if=\"vmm.selectedType.value != 2\" ng-click=\"rejectEndorsement()\" type=\"button\">Guardar</button> <button type=\"button\" class=\"btn btn-success\" ng-if=\"vmm.selectedType.value == 2\" ng-disabled=\"!vmm.number_endorsement || !vmm.createdNote\" ng-click=\"registerEndorsement()\">Crear</button></div></div>");
$templateCache.put("app/endoso/endosos.table.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Listado de endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Endosos</a></li><li class=\"active\"><strong>Listado</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número de póliza</label> <input ng-model=\"vm.form.poliza\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Estatus</label><select class=\"form-control m-b\" ng-model=\"vm.form.status\" data-ng-options=\"status.name for status in vm.status track by status.id\" ng-change=\"vm.changeStatus(vm.form.status)\"><option value=\"\">Selecciona un estatus</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Tipo</label><select class=\"form-control m-b\" ng-model=\"vm.form.type\" data-ng-options=\"type.name for type in vm.types track by type.id\" ng-change=\"vm.changeType(vm.form.type)\"><option value=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.providers\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(vm.form.providers)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.ramos\" ng-change=\"selectRamos(vm.form.ramos)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.subramos\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(vm.form.subramos)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>{{moduleName}}</label><select class=\"form-control\" ng-model=\"vm.form.celula\" data-ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"vm.changecelula(vm.form.celula)\"><option value=\"\">Todo</option></select></div><div class=\"col-xs-12 col-md-4 col-lg-3 form-group\"><label>Línea de Negocio</label><select class=\"form-control\" ng-model=\"vm.form.businesLine\" data-ng-options=\"businesLine.name for businesLine in vm.businesLine track by businesLine.id\" ng-change=\"vm.changeBLine(vm.form.businesLine)\" required=\"\"><option value=\"\">Todas las líneas</option></select></div><div ng-if=\"vm.isdates\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-2 m-t\"><button class=\"btn btn-white\" ng-click=\"vm.isdates = false\">Cerrar</button></div></div><div ng-if=\"!vm.isdates\" class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group m-t\"><button class=\"btn btn-primary\" ng-click=\"vm.isdates = true\">Agregar filtro de fechas</button></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"btn btn-success col-xs-12\" ng-click=\"Consultar(1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y\" id=\"exportable\"><table class=\"table table-bordered table-hover table-width\"><thead><tr><td>Contratante</td><td>Folio</td><td>Tipo de endoso</td><td>Concepto</td><td>Número de endoso</td><td>Vigencia</td><td>Estatus</td><td>Número de póliza</td><td>Aseguradora</td><td>Subramo</td><td>Creado por</td><td>Acciones</td></tr></thead><tbody><tr ng-repeat=\"endoso in vm.endorsements track by $index\" ng-click=\"goTo(endoso.policy.document_type, endoso.id)\" context=\"contextFianzas\" ng-right-click=\"ShowContextMenu(\'Información Endoso\', endoso)\"><td>{{endoso.policy.contractor}}{{endoso.fianza.contractor.full_name}}</td><td>{{endoso.internal_number}}</td><td>{{endoso.endorsement_type}}</td><td ng-if=\"endoso.original\">{{ endoso.original.concept.name }}</td><td ng-if=\"!endoso.original\">{{ concept(endoso.concept,endoso) }}</td><td ng-if=\"endoso.number_endorsement\">{{endoso.number_endorsement}}</td><td ng-if=\"!endoso.number_endorsement\">Sin número asignado</td><td>{{endoso.init_date | date: \'dd/MM/yyyy\'}} - {{endoso.end_date | date: \'dd/MM/yyyy\'}}</td><td>{{ status(endoso.status) }}</td><td>{{endoso.policy.poliza_number}}{{endoso.fianza.fianza_number}}</td><td>{{endoso.policy.aseguradora}}{{endoso.fianza.afianzadora}}</td><td>{{endoso.policy.subramo}}{{endoso.fianza.subramo}}</td><td>{{endoso.owner}}</td><td><tasks click=\"addtask()\" type=\"endoso.number_endorsement ? 9 : 2\" model=\"endoso.number_endorsement ? endoso.number_endorsement + \' de la póliza \' + endoso.policy.poliza_number : endoso.internal_number + \' de la póliza \' + endoso.policy.poliza_number\" associated=\"endoso.id\"></tasks></td></tr></tbody></table><div ng-if=\"vm.show_pag_endosos && vm.endosos_config.count > 10\" class=\"text-center\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div></div></div></div><div class=\"row\" ng-if=\"showButtonExcel\"><div class=\"col-xs-12 form-group\" style=\"margin-bottom: 40px;\"><button class=\"btn btn-primary ladda-button\" ng-click=\"exportData(\'Endosos\')\">Generar Reporte</button></div></div>");
$templateCache.put("app/endosoFull/endoso.full.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Editar Endoso de Fianza</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Editar Endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Información de la Póliza</legend></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{ policy.poliza_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ policy.contractor.full_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ policy.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ policy.end_of_validity | date: \'dd/MM/yyyy\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Frecuencia de pago:</span><div><span>{{ payment(policy.forma_de_pago) }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Estatus:</span><div><div class=\"label\" ng-class=\"{\'label-success\': policy.status == 10, \'label-info\' : policy.status == 14, \'label-primary\' : surety.status == 12}\" style=\"margin-right: 10px\">{{ statusPolicy(policy.status) }}</div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Compañía:</span><div><span>{{ policy.aseguradora.alias }}{{ vm.insurance.afianzadora.alias }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ policy.ramo.ramo_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ policy.subramo.subramo_name }}<span></span></span></div></div><div class=\"col-xs-12 form-group\"><hr></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Información del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Folio:</span><div><span>{{ endorsement.internal_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Tipo:</span><div><span>{{ endorsement.endorsement_type }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"endorsement.policy.document_type != 3\"><span class=\"blue-color\">Concepto:</span><div><span ng-if=\"endorsement.original.concept\">{{ endorsement.original.concept.name }}</span> <span ng-if=\"!endorsement.original.concept\">{{ concept(endorsement.concept) }}</span> <span ng-if=\"endorsement.other_desc\">- {{ endorsement.other_desc }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"endorsement.policy.document_type == 3\"><span class=\"blue-color\">Concepto:</span><div><span>{{ conceptCollectivity(class=\"col-xs-12 col-sm-4 form-group\" .concept) }}</span> <span ng-if=\"endorsement.other_desc\">- {{ endorsement.other_desc }}</span> <span ng-if=\"!endorsement.other_desc && descriptionSelected\">- {{ descriptionSelected.name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" ng-class=\"{\'label-success\': endorsement.status == 2, \'label-info\' : endorsement.status == 5,\'label-primary\' : endorsement.status == 1, \'label-warning\' : endorsement.status == 3 || endorsement.status == 4}\" style=\"margin-right: 10px\">{{ status(endorsement.status) }}</div></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"startDate\" ng-change=\"checkDate(startDate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Al: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endDate\" class=\"width-100 text-align-center form-control\" ng-model=\"endDate\" ng-change=\"checkEndDate(endDate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del endoso: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"endorsement.observations\" name=\"description\" ng-blur=\"save_info_tab()\"></textarea></div></div><div ng-if=\"endorsement.status != 2\"><div class=\"row\" ng-if=\"endorsement.policy.document_type == 1\"><div ng-include=\"\'app/endosoFull/types/individual.html\'\"></div></div><div class=\"row\" ng-if=\"endorsement.policy.document_type == 3 && endorsement.original.concept.value == 38\"><div ng-include=\"\'app/endosoFull/types/colectivo.html\'\"></div></div></div><div ng-if=\"endorsement.status == 2\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Número de Endoso</label> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.number_endorsement\" ng-blur=\"checkLength(endorsement.number_endorsement)\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-if=\"endorsement.status != 2\" ng-click=\"validityEndorsement()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Actualizar Endoso</button> <button class=\"col-xs-12 btn btn-primary ladda-button\" ng-if=\"endorsement.status == 2\" ng-click=\"editEndorsement()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Actualizar Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ui-sref=\"endorsement.info({endosoId: endorsement.id})\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div class=\"row\"><div class=\"col-xs-12\"><br><br><br><br></div></div></div></div></div></div>");
$templateCache.put("app/endosoFull/endoso.full.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Endosos</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"!policy.poliza_number\"><label>Número de Póliza: <span class=\"color-red\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"cadena_a_buscar\" ng-change=\"cadenaBusq(cadena_a_buscar)\"></div><div class=\"col-xs-12 col-sm-2 col-lg-2 form-group\" ng-if=\"!policy.poliza_number\"><button ng-if=\"cadena_a_buscar\" type=\"button\" ng-click=\"findPolicy(cadena_a_buscar)\" class=\"btn-mt25 btn btn-sm btn-primary\">Buscar</button><div ng-if=\"cadena_a_buscar && habuscado && autocompleteData.length==0\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div></div><div class=\"form-group col-xs-12 col-sm-6\" ng-if=\"autocompleteData.length >0\"><label>Póliza:</label><select class=\"select form-control\" ng-model=\"order.policy_number\" ng-options=\"affected as affected.label for affected in autocompleteData\" ng-change=\"findPolicy(vm.order.policy_number)\"><option value=\"\" disabled=\"\">Seleccione una Póliza</option></select></div></div><div ng-if=\"policy.poliza_number\"><div class=\"col-xs-12 col-sm-4 form-group\"><button type=\"button\" ng-click=\"anotherPolicy()\" class=\"btn-mt25 btn btn-sm btn-primary\">Buscar otra póliza</button></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Información de la Póliza</legend></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{ policy.poliza_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ policy.contractor.full_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ policy.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ policy.end_of_validity | date: \'dd/MM/yyyy\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Frecuencia de pago:</span><div><span>{{ payment(policy.forma_de_pago) }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Estatus:</span><div><div class=\"label\" ng-class=\"{\'label-success\': policy.status == 10, \'label-info\' : policy.status == 14, \'label-primary\' : surety.status == 12}\" style=\"margin-right: 10px\">{{ status(policy.status) }}</div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Compañía:</span><div><span>{{ policy.aseguradora.alias }}{{ vm.insurance.afianzadora.alias }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ policy.ramo.ramo_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ policy.subramo.subramo_name }}<span></span></span></div></div><div class=\"col-xs-12 form-group\"><hr></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Información del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Tipo de Endoso:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"typeSelected\" ng-options=\"type as type.name for type in types track by type.id\" ng-change=\"fillData(typeSelected); saveLocalstorange();\" ng-disabled=\"!policy.poliza_number\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-8 form-group\" ng-if=\"typeSelected.id != 0\"><label>Concepto: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"descriptionSelected\" ng-options=\"description as description.name for description in descriptions track by description.value\" ng-change=\"showFields(descriptionSelected); saveLocalstorange();\"><option value=\"\" disabled=\"\">Selecciona un concepto</option></select></div><div class=\"col-xs-12 form-group\" ng-if=\"descriptionSelected.id == 3\"><label>Agregue el concepto: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.other_desc\" ng-change=\"saveLocalstorange()\" ng-blur=\"checkLengthOtherdesc(endorsement.other_desc)\"></div></div><div class=\"row\" ng-if=\"descriptionSelected\"><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"startDate\" ng-change=\"checkDate(startDate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Al: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endDate\" class=\"width-100 text-align-center form-control\" ng-model=\"endDate\" ng-change=\"checkEndDate(endDate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del endoso: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"endorsement.observations\" ng-change=\"saveLocalstorange()\" name=\"description\"></textarea></div></div><div class=\"row\" ng-if=\"typeSelected.id != 0 && descriptionSelected.id != 0\"><div ng-include=\"\'app/endosoFull/types/individual.html\'\"></div></div><div class=\"row\" ng-if=\"descriptionSelected && order.permiso_administrar_adjuntos\"><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div><div class=\"row\" ng-if=\"descriptionSelected\"><div class=\"col-xs-12 form-group\"><hr></div><div class=\"btn-group col-sm-4 col-sm-offset-4\"><button class=\"btn\" ng-click=\"changeRegister(false)\" ng-style=\"btnNoRegister\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i> No Registrar</button> <button class=\"btn\" ng-click=\"changeRegister(true)\" ng-style=\"btnRegister\"><i class=\"fa fa-tasks\" aria-hidden=\"true\"></i> Registrar</button></div><div class=\"col-xs-12 form-group\"><hr></div></div><div class=\"row\" ng-if=\"checkRegister && order.acceso_adm_ot && order.acceso_reg_end\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Registrar Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Número de Endoso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.number_endorsement\" ng-blur=\"checkLength(endorsement.number_endorsement)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"typeSelected.name != \'B\' && descriptionSelected.id !=1 && recibosIndividuales==false\"><label>Número de Recibos: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"total_receipts\" ng-options=\"number as number.name for number in totalReceipts track by number.id\" ng-change=\"changeNumberReceipts(total_receipts)\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Folio de la Aseguradora:</label> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.insurancefolio\"></div><div class=\"col-xs-12 form-group\" ng-if=\"typeSelected.name != \'B\' && descriptionSelected.id!=1 && recibosIndividuales==false\"><receipts-endoso form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-endoso></div><div class=\"col-xs-12 form-group\" ng-if=\"((typeSelected.name == \'D\' || typeSelected.name ==\'A\') && descriptionSelected.id==1 )|| recibosIndividuales\"><receipts-individual form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-individual></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"!checkRegister\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"validityEndorsement()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"checkRegister && order.acceso_reg_end\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"checkNumberEndorsement()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Registrar Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelarCreacion(\'endorsement.lista\')\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div class=\"row\"><div class=\"col-xs-12\"><br><br><br><br></div></div>");
$templateCache.put("app/endosoFull/endoso.full.information.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a ui-sref=\"endorsement.lista\">Endosos</a></li><li class=\"active\"><strong>Endoso {{ endorsement.internal_number }}</strong></li></ol></div></div><br><div class=\"btn-group pull-right m-b option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"endorsement.policy && order.acceso_ver_pol\"><a ng-click=\"goToPolicy(endorsement.policy.id)\">Ver póliza</a></li><li ng-if=\"order.acceso_adm_ot && endorsement.status !=3\"><a ui-sref=\"endorsement.edit({endosoId: endorsement.id})\">Editar</a></li><li ng-if=\"order.acceso_elim_end\"><a ng-click=\"deleteEndorsment()\">Eliminar</a></li><li><a ng-click=\"getPDF(vm.insurance.id)\">Ver PDF</a></li><li><a ng-click=\"order.shareEndorsementOk(endorsement)\">Compartir por Email</a></li><li><a ng-click=\"sendProvider(endorsement)\">Enviar PDF a la compañia</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"cartas.length && order.acceso_form\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, vm.insurance.policy.id, carta.id)\">{{carta.name}}</a></li><li><a ng-click=\"getPDF(vm.insurance.id)\">Resumen PDF</a></li></ul></li></ul></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"endorsement.number_endorsement\">Información del Endoso</h5><h5 ng-if=\"!endorsement.number_endorsement\">Información de la OT</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button> <button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"createRecordatorio(endorsement,10)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\" ng-if=\"endorsement.policy.document_type == 1\">Póliza</legend><legend class=\"legend-title\" align=\"center\" ng-if=\"endorsement.policy.document_type == 6\">Certificado</legend></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ contractor.contractor.full_name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\"><b>Número de Póliza</b>:</span><div><span>{{ endorsement.policy.poliza_number }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.policy.document_type == 6\"><span class=\"blue-color\">Número de Certificado:</span><div><span>{{ endorsement.policy.certificate_number }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.policy.document_type == 3\"><span class=\"blue-color\">Tipo de Administración:</span><div><span ng-if=\"endorsement.policy.administration_type == 1 || endorsement.policy.administration_type == \'Simplificada\'\">Simplificada</span> <span ng-if=\"endorsement.policy.administration_type == 2 || endorsement.policy.administration_type == \'Autoadministrada\'\">Autoadministrada</span> <span ng-if=\"endorsement.policy.administration_type == 3 || endorsement.policy.administration_type == \'Detallada\'\">Detallada</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span ng-if=\"endorsement.policy\">{{ endorsement.policy.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{ endorsement.policy.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ endorsement.policy.aseguradora.alias }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Creada por:</span><div><span>{{ endorsement.policy.owner }}</span></div></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showRecordatorios()\">{{endorsement.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-primary m-r-sm ladda-button-initial-e\" ng-click=\"showEndosos()\"><span ng-if=\"endorsement.otrosendosos\">{{endorsement.otrosendosos.length}}</span></button><span class=\"blue-color\">Lista de Endosos de la Póliza</span></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Endoso</legend></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"endorsement.status == 2\"><span class=\"blue-color\"><b>Número de Endoso</b>:</span><div><span>{{ endorsement.number_endorsement }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"endorsement.status != 2\"><span class=\"blue-color\">Folio interno:</span><div><span>{{ endorsement.internal_number }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Tipo:</span><div><span>{{ endorsement.endorsement_type }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"endorsement.policy.document_type != 3\"><span class=\"blue-color\">Concepto:</span><div><span ng-if=\"endorsement.original.concept.name\">{{ endorsement.original.concept.name }}</span> <span ng-if=\"!endorsement.original.concept.name\">{{ concept(endorsement.concept) }}</span> <span ng-if=\"endorsement.other_desc\">- {{ endorsement.other_desc }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"endorsement.policy.document_type == 3\"><span class=\"blue-color\">Concepto:</span><div><span ng-if=\"endorsement.original.concept.name\">{{ endorsement.original.concept.name }}</span> <span ng-if=\"!endorsement.original.concept.name\">{{ conceptCollectivity(endorsement.concept) }}</span> <span ng-if=\"endorsement.policy.subramo.subramo_code==9 && endorsement.concept ==9\">CAMBIO DE ADAPTACIONES</span> <span ng-if=\"endorsement.policy.subramo.subramo_code!=9 && endorsement.concept ==9\">CAMBIO DE RIESGO ASEGURADO</span> <span ng-if=\"endorsement.other_desc\">- {{ endorsement.other_desc }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ endorsement.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ endorsement.end_date | date: \'dd/MM/yyyy\' : \'UTC\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ endorsement.policy.subramo.subramo_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" ng-class=\"{\'label-success\': endorsement.status == 2, \'label-info\' : endorsement.status == 5,\'label-primary\' : endorsement.status == 1, \'label-warning\' : endorsement.status == 3 || endorsement.status == 4}\" style=\"margin-right: 10px\">{{ status(endorsement.status) }}</div></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"endorsement.insurancefolio\"><span class=\"blue-color\">Folio de Aseguradora:</span><div>{{ endorsement.insurancefolio }}</div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Creado por:</span><div>{{ endorsement.owner }}</div></div><div ng-if=\"endorsement.task_.titulo\" class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Tarea:</span><div>{{ endorsement.task_.titulo }}</div></div><div ng-if=\"endorsement.task_.titulo\" class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Tarea (Responsable):</span><div>{{ endorsement.task_.asignado }}</div><span class=\"blue-color\">Involucrados:</span><div ng-repeat=\"person in endorsement.task_.involucrados\">{{ person }}</div></div><br><div ng-if=\"endorsement.status != 2\"><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\" ng-if=\"endorsement.status !=2 && endorsement.status !=3 && endorsement.status !=4\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"changeStatus(endorsement.policy)\"><i class=\"fa fa-exchange\" aria-hidden=\"true\"></i> Cambiar Estatus</button></div></div><div class=\"col-xs-3 form-group pull-right\" align=\"center\" ng-if=\"endorsement.seguimiento && order.acceso_tab && usuarioorg==\'pruebas\'\"><span class=\"blue-color\">Tablero OT</span><div><span>{{ endorsement.seguimiento }}</span><div class=\"btn-group pull-right m-b\"><button style=\"border: 0px;\" type=\"button\" class=\"btn btn-white btn-sm btn-secondary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bars\" aria-hidden=\"true\"></i></button><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"dropdown-submenu\" ng-if=\"principal.contenedores.length\"><a>Mover a</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"principal.contenedores\"><a class=\"disabled\">Estados</a></li><li ng-if=\"principal.contenedores\" ng-repeat=\"newcontainer in principal.contenedores track by $index\"><a ng-click=\"moveOTState(newcontainer,principal,endorsement.seguimiento,2)\" ng-if=\"newcontainer.tablero != endorsement.seguimiento\">{{newcontainer.tablero}}</a></li></ul></li></ul></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\" ng-if=\"endorsement.task_associated\"><button type=\"button\" class=\"btn btn-white btn-sm btn-secondary\" ng-click=\"openModal(endorsement.task_associated_info)\">{{ order.isCollapsed ? \'Ocultar\' : \'Ver\' }} Tarea Origen</button><div ng-show=\"order.isCollapsed\"><span class=\"blue-color\">Tarea Origen</span><div><span>{{ endorsement.task_associated_info.title }}</span></div></div></div><div ng-if=\"endorsement.status == 2 && (endorsement.endorsement_type == \'A\' || endorsement.endorsement_type == \'D\')\"><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"endorsement.p_neta\"><span class=\"blue-color\">Prima Neta:</span><div>{{ endorsement.p_neta | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-6 form-group\" ng-if=\"endorsement.rpf\"><span class=\"blue-color\">Recargo por Pago Fraccionado:</span><div>{{ endorsement.rpf | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"endorsement.derecho\"><span class=\"blue-color\" ng-if=\"endorsement.endorsement_type == \'A\'\">Derecho:</span> <span class=\"blue-color\" ng-if=\"endorsement.endorsement_type == \'D\'\">Gastos:</span><div>{{ endorsement.derecho | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"endorsement.iva\"><span class=\"blue-color\">Iva:</span><div>{{ endorsement.iva | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"endorsement.p_total\"><span class=\"blue-color\">Prima Total:</span><div>{{ endorsement.p_total | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"endorsement.comision && order.permiso_comisiones\"><span class=\"blue-color\">Comisión:</span><div>{{ endorsement.comision | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"endorsement.descuento\"><span class=\"blue-color\">Descuento:</span><div>{{ endorsement.descuento | currency}}</div></div></div></div></div></div></div></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"showRecordatorios()\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in endorsement.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"endososOtros\"><div class=\"ibox-title\"><h5>Endoso de la Póliza</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"showEndosos()\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Número endoso</th><th>Tipo de Endoso</th><th>Descripción</th><th>Fecha Inicio</th><th>Fecha Fin</th><th>Póliza</th></thead><tr ng-repeat=\"oe in endorsement.otrosendosos track by $index\" ng-click=\"goToInfo(oe, $index)\"><td>{{ oe.number_endorsement }}</td><td>{{ oe.endorsement_type}}</td><td>{{ oe.observations }}</td><td>{{ oe.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ oe.end_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ oe.policy.poliza_number}}</td></tr></table></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Detalles</h5></div><div class=\"ibox-content\"><h4>Descripción del endoso:</h4><textarea disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"endorsement.observations\"></textarea><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Original Póliza</legend></div><div ng-if=\"endorsement.concept == 1\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Frecuencia de pago:</span><div><span>{{ payment(endorsement.original.forma_de_pago) }}</span></div></div></div><div ng-if=\"endorsement.concept == 2 || endorsement.concept == 12\"><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered\"><thead><tr><th>Cobertura</th><th>Suma</th><th>Deducible</th></tr></thead><tbody><tr ng-repeat=\"item in endorsement.original.coverageInPolicy_policy\"><td>{{ item.coverage_name }}</td><td>{{ item.sum_insured }}</td><td>{{ item.deductible }}</td></tr></tbody></table></div></div><div ng-if=\"endorsement.concept == 4\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Fecha Fin:</span><div><span>{{ endorsement.original.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div></div><div ng-if=\"endorsement.concept == 7\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ endorsement.original.contractor.full_name }}</span></div></div></div><div ng-if=\"endorsement.concept == 10\"><div class=\"col-xs-12 form-group\"><h4>Titular:</h4></div><div ng-if=\"endorsement.original.life_policy[0]\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ endorsement.original.life_policy[0].personal.first_name }} {{ endorsement.original.life_policy[0].personal.last_name }} {{ endorsement.original.life_policy[0].personal.second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ endorsement.original.life_policy[0].personal.birthdate | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"endorsement.original.life_policy[0].personal.sex == \'F\'\">Femenino</span> <span ng-if=\"endorsement.original.life_policy[0].personal.sex == \'M\'\">Masculino</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Antigüedad:</span><div><span>{{ endorsement.original.life_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fumador:</span><div><span ng-if=\"endorsement.original.life_policy[0].personal.smoker == true\">Si</span> <span ng-if=\"endorsement.original.life_policy[0].personal.smoker == false\">No</span></div></div></div><div ng-if=\"endorsement.original.accidents_policy[0]\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ endorsement.original.accidents_policy[0].personal.first_name }} {{ endorsement.original.accidents_policy[0].personal.last_name }} {{ endorsement.original.accidents_policy[0].personal.second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ endorsement.original.accidents_policy[0].personal.birthdate | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"endorsement.original.accidents_policy[0].personal.sex == \'F\'\">Femenino</span> <span ng-if=\"endorsement.original.accidents_policy[0].personal.sex == \'M\'\">Masculino</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Antigüedad:</span><div><span>{{ endorsement.original.accidents_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div></div></div><div ng-if=\"endorsement.concept == 6\"><div ng-repeat=\"item in endorsement.original.life_policy[0].beneficiaries_life\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ item.first_name }} {{ item.last_name }} {{ item.second_last_name }} {{ item.j_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ item.birthdate | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"item.optional_relationship\"><span class=\"blue-color\">Parentesco:</span><div><span>{{ item.optional_relationship }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Porcentaje:</span><div><span>{{ item.percentage }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"item.sex\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"item.sex == \'F\'\">Femenino</span> <span ng-if=\"item.sex == \'M\'\">Masculino</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Antigüedad:</span><div><span>{{ item.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 form-group\"><hr></div></div><div ng-repeat=\"item in endorsement.original.accidents_policy[0].relationship_accident\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ item.first_name }} {{ item.last_name }} {{ item.second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ item.birthdate | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Parentesco:</span><div><span ng-if=\"item.relationship == 1\">Titular</span> <span ng-if=\"item.relationship == 2\">Cónyuge</span> <span ng-if=\"item.relationship == 3\">Hijo</span> <span ng-if=\"item.relationship == 4\">Otro</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"item.sex == \'F\'\">Femenino</span> <span ng-if=\"item.sex == \'M\'\">Masculino</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Antigüedad:</span><div><span>{{ item.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 form-group\"><hr></div></div></div><div ng-if=\"endorsement.concept == 9\"><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.change.tabulator\"><span class=\"blue-color\">Tabulador:</span><div><span>{{ endorsement.original.tabulator }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.change.hospital_level\"><span class=\"blue-color\">Nivel Hospitalario:</span><div><span>{{ endorsement.original.hospital_level }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.brand\"><span class=\"blue-color\">Tipo:</span><div><span ng-if=\"endorsement.original.automobiles_policy[0].policy_type == 1\">Automóvil</span> <span ng-if=\"endorsement.original.automobiles_policy[0].policy_type == 2\">Motocicleta</span> <span ng-if=\"endorsement.original.automobiles_policy[0].policy_type == 3\">Tracto</span> <span ng-if=\"endorsement.original.automobiles_policy[0].policy_type == 4\">Autobús</span> <span ng-if=\"endorsement.original.automobiles_policy[0].policy_type == 5\">Pick up</span> <span ng-if=\"endorsement.original.automobiles_policy[0].policy_type == 6\">Camiones hasta 1.5 ton</span> <span ng-if=\"endorsement.original.automobiles_policy[0].policy_type == 7\">Chofer app</span> <span ng-if=\"endorsement.original.automobiles_policy[0].policy_type == 8\">Remolque</span> <span ng-if=\"endorsement.original.automobiles_policy[0].policy_type == 9\">Camiones + 1.5 ton</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.brand\"><span class=\"blue-color\">Marca:</span><div><span>{{ endorsement.original.automobiles_policy[0].brand }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.model\"><span class=\"blue-color\">Modelo:</span><div><span>{{ endorsement.original.automobiles_policy[0].model }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.year\"><span class=\"blue-color\">Año:</span><div><span>{{ endorsement.original.automobiles_policy[0].year }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.version\"><span class=\"blue-color\">Versión:</span><div><span>{{ endorsement.original.automobiles_policy[0].version }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.serial\"><span class=\"blue-color\">Serie:</span><div><span>{{ endorsement.original.automobiles_policy[0].serial }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.engine\"><span class=\"blue-color\">Motor:</span><div><span>{{ endorsement.original.automobiles_policy[0].engine }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.color\"><span class=\"blue-color\">Color:</span><div><span>{{ endorsement.original.automobiles_policy[0].color }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.license_plates\"><span class=\"blue-color\">Matrícula:</span><div><span>{{ endorsement.original.automobiles_policy[0].license_plates }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.usage\"><span class=\"blue-color\">Uso:</span><div><span ng-if=\"endorsement.original.automobiles_policy[0].usage == 1\">PARTICULAR</span> <span ng-if=\"endorsement.original.automobiles_policy[0].usage == 2\">CARGA COMERCIAL</span> <span ng-if=\"endorsement.original.automobiles_policy[0].usage == 3\">SERVICIO PÚBLICO</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.service\"><span class=\"blue-color\">Servicio:</span><div><span>{{ endorsement.original.automobiles_policy[0].service }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.procedencia\"><span class=\"blue-color\">Procedencia:</span><div><span ng-if=\"endorsement.original.automobiles_policy[0].procedencia == 0\">SIN ESPECIFICAR</span> <span ng-if=\"endorsement.original.automobiles_policy[0].procedencia == 1\">RESIDENCIA</span> <span ng-if=\"endorsement.original.automobiles_policy[0].procedencia == 2\">TURISTA</span> <span ng-if=\"endorsement.original.automobiles_policy[0].procedencia == 3\">LEGALIZADO</span> <span ng-if=\"endorsement.original.automobiles_policy[0].procedencia == 4\">FRONTERIZO</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.driver\"><span class=\"blue-color\">Conductor:</span><div><span>{{ endorsement.original.automobiles_policy[0].driver }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.special_team\"><span class=\"blue-color\">Equipamiento:</span><div><span>{{ endorsement.original.automobiles_policy[0].special_team }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.mont_special_team\"><span class=\"blue-color\">Monto Equipamiento:</span><div><span>{{ endorsement.original.automobiles_policy[0].mont_special_team | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.adjustment\"><span class=\"blue-color\">Adaptaciones:</span><div><span>{{ endorsement.original.automobiles_policy[0].adjustment }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.mont_adjustment\"><span class=\"blue-color\">Monto Adaptaciones:</span><div><span>{{ endorsement.original.automobiles_policy[0].mont_adjustment | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.beneficiary_name\"><span class=\"blue-color\">Beneficiaro Preferente:</span><div><span>{{ endorsement.original.automobiles_policy[0].beneficiary_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.beneficiary_rfc\"><span class=\"blue-color\">Beneficiaro RFC:</span><div><span>{{ endorsement.original.automobiles_policy[0].beneficiary_rfc }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.beneficiary_address\"><span class=\"blue-color\">Beneficiaro Dirección:</span><div><span>{{ endorsement.original.automobiles_policy[0].beneficiary_address }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.insured_item\"><span class=\"blue-color\">Bien Asegurado:</span><div><span>{{ endorsement.original.damages_policy[0].insured_item }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.item_details\"><span class=\"blue-color\">Detalles:</span><div><span>{{ endorsement.original.damages_policy[0].item_details }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.item_address\"><span class=\"blue-color\">Dirección:</span><div><span>{{ endorsement.original.damages_policy[0].item_address }}</span></div></div></div><div ng-if=\"endorsement.concept == 13\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Estatus:</span><div><div class=\"label\" ng-class=\"{\'label-success\': endorsement.original.status == 1 || endorsement.original.status == 12, \'label-info\' : endorsement.original.status == 10, \'label-primary\' : endorsement.original.status == 14, \'label-warning\' : endorsement.original.status == 2 || endorsement.original.status == 4 || endorsement.original.status == 11}\" style=\"margin-right: 10px\">{{ statusPolicy(endorsement.original.status) }}</div></div></div></div></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Cambio Endoso</legend></div><div ng-if=\"endorsement.concept == 1\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Frecuencia de pago:</span><div><span>{{ payment(endorsement.change.forma_de_pago) }}</span></div></div></div><div ng-if=\"endorsement.concept == 2 || endorsement.concept == 12\"><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered\"><thead><tr><th>Cobertura</th><th>Suma</th><th>Deducible</th></tr></thead><tbody><tr ng-repeat=\"item in endorsement.change.coverages track by $index\"><td>{{ item.coverage_name }}</td><td><span ng-if=\"item.sumInPolicy\">{{ item.sumInPolicy.value }}</span></td><td><span ng-if=\"item.deductibleInPolicy\">{{ item.deductibleInPolicy.value }}</span></td></tr></tbody></table></div></div><div ng-if=\"endorsement.concept == 4\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Fecha Prorroga:</span><div><span>{{ endorsement.change.end_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div></div><div ng-if=\"endorsement.concept == 7\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ contractor_change.full_name }}{{ contractor_change.j_name }}</span></div></div></div><div ng-if=\"endorsement.concept == 10\"><div class=\"col-xs-12 form-group\"><h4>Titular:</h4></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ endorsement.change.first_name }} {{ endorsement.change.last_name }} {{ endorsement.change.second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ endorsement.change.birthdate | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"endorsement.change.sex == \'F\'\">Femenino</span> <span ng-if=\"endorsement.change.sex == \'M\'\">Masculino</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Antigüedad:</span><div><span>{{ endorsement.change.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.smoker\"><span class=\"blue-color\">Fumador:</span><div><span ng-if=\"endorsement.change.smoker.value == true\">Si</span> <span ng-if=\"endorsement.change.smoker.value == false\">No</span></div></div></div><div ng-if=\"endorsement.concept == 6\"><div ng-repeat=\"item in endorsement.change track by $index\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ item.first_name }} {{ item.last_name }} {{ item.second_last_name }} {{ item.j_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ item.birthdate | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"item.optional_relationship\"><span class=\"blue-color\">Parentesco:</span><div><span>{{ item.optional_relationship }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Porcentaje:</span><div><span>{{ item.percentage }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"item.sex\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"item.sex == \'F\'\">Femenino</span> <span ng-if=\"item.sex == \'M\'\">Masculino</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Antigüedad:</span><div><span>{{ item.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 form-group\"><hr></div></div></div><div ng-if=\"endorsement.concept == 9\"><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.change.tabulator\"><span class=\"blue-color\">Tabulador:</span><div><span>{{ endorsement.change.tabulator }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.change.hospital_level\"><span class=\"blue-color\">Nivel Hospitalario:</span><div><span>{{ endorsement.change.hospital_level }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.policy_type\"><span class=\"blue-color\">Tipo:</span><div><span ng-if=\"endorsement.change.policy_type == 1\">Automóvil</span> <span ng-if=\"endorsement.change.policy_type == 2\">Motocicleta</span> <span ng-if=\"endorsement.change.policy_type == 3\">Tracto</span> <span ng-if=\"endorsement.change.policy_type == 4\">Autobús</span> <span ng-if=\"endorsement.change.policy_type == 5\">Pick up</span> <span ng-if=\"endorsement.change.policy_type == 6\">Camiones hasta 1.5 ton</span> <span ng-if=\"endorsement.change.policy_type == 7\">Chofer app</span> <span ng-if=\"endorsement.change.policy_type == 8\">Remolque</span> <span ng-if=\"endorsement.change.policy_type == 9\">Camiones + 1.5 ton</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.brand\"><span class=\"blue-color\">Marca:</span><div><span>{{ endorsement.change.brand }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.model\"><span class=\"blue-color\">Modelo:</span><div><span>{{ endorsement.change.model }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.year\"><span class=\"blue-color\">Año:</span><div><span>{{ endorsement.change.year }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.version\"><span class=\"blue-color\">Versión:</span><div><span>{{ endorsement.change.version }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.serial\"><span class=\"blue-color\">Serie:</span><div><span>{{ endorsement.change.serial }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.engine\"><span class=\"blue-color\">Motor:</span><div><span>{{ endorsement.change.engine }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.color\"><span class=\"blue-color\">Color:</span><div><span>{{ endorsement.change.color }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.license_plates\"><span class=\"blue-color\">Matrícula:</span><div><span>{{ endorsement.change.license_plates }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.usage\"><span class=\"blue-color\">Uso:</span><div><span ng-if=\"endorsement.change.usage == 1\">PARTICULAR</span> <span ng-if=\"endorsement.change.usage == 2\">CARGA COMERCIAL</span> <span ng-if=\"endorsement.change.usage == 3\">SERVICIO PÚBLICO</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.service\"><span class=\"blue-color\">Servicio:</span><div><span>{{ endorsement.change.service }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.procedencia\"><span class=\"blue-color\">Procedencia:</span><div><span ng-if=\"endorsement.change.procedencia == 0\">SIN ESPECIFICAR</span> <span ng-if=\"endorsement.change.procedencia == 1\">RESIDENCIA</span> <span ng-if=\"endorsement.change.procedencia == 2\">TURISTA</span> <span ng-if=\"endorsement.change.procedencia == 3\">LEGALIZADO</span> <span ng-if=\"endorsement.change.procedencia == 4\">FRONTERIZO</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.driver\"><span class=\"blue-color\">Conductor:</span><div><span>{{ endorsement.change.driver }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.special_team\"><span class=\"blue-color\">Equipamiento:</span><div><span>{{ endorsement.change.special_team }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.mont_special_team\"><span class=\"blue-color\">Monto Equipamiento:</span><div><span>{{ endorsement.change.mont_special_team | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.adjustment\"><span class=\"blue-color\">Adaptaciones:</span><div><span>{{ endorsement.change.adjustment }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.mont_adjustment\"><span class=\"blue-color\">Monto Adaptaciones:</span><div><span>{{ endorsement.change.mont_adjustment | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.beneficiary_name\"><span class=\"blue-color\">Beneficiaro Preferente:</span><div><span>{{ endorsement.change.beneficiary_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.beneficiary_rfc\"><span class=\"blue-color\">Beneficiaro RFC:</span><div><span>{{ endorsement.change.beneficiary_rfc }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.beneficiary_address\"><span class=\"blue-color\">Beneficiaro Dirección:</span><div><span>{{ endorsement.change.beneficiary_address }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.insured_item\"><span class=\"blue-color\">Bien Asegurado:</span><div><span>{{ endorsement.change.insured_item }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.item_details\"><span class=\"blue-color\">Detalles:</span><div><span>{{ endorsement.change.item_details }}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"endorsement.change.item_address\"><span class=\"blue-color\">Dirección:</span><div><span>{{ endorsement.change.item_address }}</span></div></div></div><div ng-if=\"endorsement.concept == 13\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Estatus:</span><div><div class=\"label\" ng-class=\"{\'label-success\': endorsement.change.status == 1 || endorsement.change.status == 12, \'label-info\' : endorsement.change.status == 10, \'label-primary\' : endorsement.change.status == 14, \'label-warning\' : endorsement.change.status == 2 || endorsement.change.status == 4 || endorsement.change.status == 11}\" style=\"margin-right: 10px\">{{ statusPolicy(endorsement.change.status) }}</div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha Cancelación:</span><div><div class=\"label\" style=\"margin-right: 10px\">{{endorsement.change.fecha_cancelacion | date: \'dd/MM/yyyy\' : \'UTC\'}}</div></div></div></div><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.concept == 27\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Certificado</td><td>Categoría</td><td ng-if=\"endorsement.policy.ramo.ramo_code ==2\">Baja del Dependiente</td><td ng-if=\"endorsement.policy.ramo.ramo_code ==1\">Baja del Beneficiario</td></tr></thead><tbody><tr ng-repeat=\"item in endorsement.change track by $index\"><td>{{ item.certificate_number }}</td><td>{{ item.parent }}</td><td>{{ item.first_name }} {{ item.last_name }} {{ item.second_last_name }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.concept == 26\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Certificado</td><td>Categoría</td><td ng-if=\"endorsement.policy.ramo.ramo_code ==2\">Alta del Dependiente</td><td ng-if=\"endorsement.policy.ramo.ramo_code ==1\">Alta del Beneficiario</td></tr></thead><tbody><tr ng-repeat=\"item in endorsement.change track by $index\"><td>{{ item.certificate_number }}</td><td>{{ item.parent }}</td><td>{{ item.first_name }} {{ item.last_name }} {{ item.second_last_name }}</td></tr></tbody></table></div></div></div><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.concept == 24 || endorsement.concept == 35\"><div class=\"panel-body table-over-y\"><div class=\"col-xs-12 col-sm-6 col-md-3 m-t\"><button ng-if=\"endorsement.status != 2\" style=\"margin-bottom: 10px;\" ng-click=\"initChanges(endorsement.change)\" ng-hide=\"editChanges == true\" class=\"btn btn-primary col-xs-12\">Activar edición</button></div><table class=\"table table-bordered table-hover\" ng-if=\"!editChanges && endorsement.policy.subramo.subramo_code == 1 && endorsement.change[0].life_policy.length > 0\"><thead><tr><td>Folio</td><td>Certificado</td><td>Correo</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Tipo Suma Asegurada</td><td>Suma Asegurada</td><td>Sueldo</td><td>Fumador</td><td>Beneficiarios</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td></tr></thead><tbody><tr ng-repeat=\"item in endorsement.change track by $index\"><td>{{ item.folio }}</td><td>{{ item.certificate_number }}</td><td>{{ item.life_policy[0].personal.email }}</td><td>{{ item.life_policy[0].personal.first_name }}</td><td>{{ item.life_policy[0].personal.last_name }}</td><td>{{ item.life_policy[0].personal.second_last_name }}</td><td>{{ item.life_policy[0].personal.birthdate | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ item.life_policy[0].personal.sex }}</td><td>{{ item.life_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ item.life_policy[0].personal.type_sa }}</td><td>{{ item.life_policy[0].personal.sum_assured }}</td><td>{{ item.life_policy[0].personal.salary }}</td><td>{{ item.life_policy[0].smoker }}</td><td><ul ng-repeat=\"relations in item.life_policy[0].beneficiaries_life\"><li>{{ relations.first_name }} {{ relations.last_name }}</li></ul></td><td>{{ item.p_neta }}</td><td>{{ item.rpf }}</td><td>{{ item.derecho }}</td><td>{{ item.iva }}</td><td>{{ item.p_total }}</td><td>{{ item.comision }}</td><td>{{ item.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ item.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ item.observations }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"!editChanges && endorsement.policy.ramo.ramo_code == 2 && endorsement.change[0].accidents_policy.length > 0\"><thead><tr><td>Folio</td><td>Certificado</td><td>Correo</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Dependientes</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td></tr></thead><tbody><tr ng-repeat=\"item in endorsement.change track by $index\"><td>{{ item.folio }}</td><td>{{ item.certificate_number }}</td><td>{{ item.accidents_policy[0].personal.email }}</td><td>{{ item.accidents_policy[0].personal.first_name }}</td><td>{{ item.accidents_policy[0].personal.last_name }}</td><td>{{ item.accidents_policy[0].personal.second_last_name }}</td><td>{{ item.accidents_policy[0].personal.birthdate | date: \'dd/MM/yyyy\' : \'UTC\' }}</td><td>{{ item.accidents_policy[0].personal.sex }}</td><td>{{ item.accidents_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\' }}</td><td><ul ng-repeat=\"relations in item.accidents_policy[0].relationship_accident\"><li>{{ relations.first_name }} {{ relations.last_name }}</li></ul></td><td>{{ item.p_neta }}</td><td>{{ item.rpf }}</td><td>{{ item.derecho }}</td><td>{{ item.iva }}</td><td>{{ item.p_total }}</td><td>{{ item.comision }}</td><td>{{ item.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}</td><td>{{ item.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}</td><td>{{ item.observations }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"!editChanges && endorsement.policy.subramo.subramo_code == 9\"><thead><tr><td>Inciso</td><td>Propietario</td><td>Conductor</td><td>Correo</td><td>No. Empleado</td><td>Marca</td><td>Modelo</td><td>Año</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Uso</td><td>Servicio</td><td>Procedencia</td><td>Valor Asegurado</td><td>Tipo Carga</td><td>Adaptaciones</td><td>Monto Adaptaciones</td><td>Equipamineto</td><td>Monto Equipamineto</td><td>Beneficiario Preferente</td><td>Beneficiario RFC</td><td>Beneficiario Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td></tr></thead><tbody><tr ng-repeat=\"item in endorsement.change track by $index\"><td>{{ item.certificate_number }}</td><td>{{ item.automobiles_policy[0].car_owner }}</td><td>{{ item.automobiles_policy[0].driver }}</td><td>{{ item.automobiles_policy[0].email }}</td><td>{{ item.automobiles_policy[0].no_employee }}</td><td>{{ item.automobiles_policy[0].brand }}</td><td>{{ item.automobiles_policy[0].model }}</td><td>{{ item.automobiles_policy[0].year }}</td><td>{{ item.automobiles_policy[0].version }}</td><td>{{ item.automobiles_policy[0].serial }}</td><td>{{ item.automobiles_policy[0].engine }}</td><td>{{ item.automobiles_policy[0].color }}</td><td>{{ item.automobiles_policy[0].license_plates }}</td><td>{{ item.automobiles_policy[0].usage }}</td><td>{{ item.automobiles_policy[0].service }}</td><td>{{ item.automobiles_policy[0].procedencia }}</td><td>{{ item.automobiles_policy[0].mont_special_team }}</td><td>{{ item.automobiles_policy[0].charge_type }}</td><td>{{ item.automobiles_policy[0].adjustment }}</td><td>{{ item.automobiles_policy[0].mont_adjustment }}</td><td>{{ item.automobiles_policy[0].special_team }}</td><td>{{ item.automobiles_policy[0].mont_special_team }}</td><td>{{ item.automobiles_policy[0].beneficiary_name }}</td><td>{{ item.automobiles_policy[0].beneficiary_rfc }}</td><td>{{ item.automobiles_policy[0].beneficiary_address }}</td><td>{{ item.p_neta }}</td><td>{{ item.rpf }}</td><td>{{ item.derecho }}</td><td>{{ item.iva }}</td><td>{{ item.p_total }}</td><td>{{ item.comision }}</td><td>{{ item.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}</td><td>{{ item.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"!editChanges && endorsement.policy.subramo.subramo_code == 7\"><thead><tr><td>Inciso</td><td>Sucursal</td><td>Correo</td><td>Giro</td><td>Tipo Constructivo</td><td>No. Niveles</td><td>Zona FHM</td><td>Zona TYEV</td><td>Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td></tr></thead><tbody><tr ng-repeat=\"item in endorsement.change track by $index\"><td>{{ item.certificate_number }}</td><td>{{ item.damages_policy[0].sucursal }}</td><td>{{ item.damages_policy[0].email }}</td><td>{{ item.damages_policy[0].giro }}</td><td>{{ item.damages_policy[0].type_construction }}</td><td>{{ item.damages_policy[0].no_levels }}</td><td>{{ item.damages_policy[0].fhm_zone }}</td><td>{{ item.damages_policy[0].tyev_zone }}</td><td>{{ item.damages_policy[0].item_address }}</td><td>{{ item.p_neta }}</td><td>{{ item.rpf }}</td><td>{{ item.derecho }}</td><td>{{ item.iva }}</td><td>{{ item.p_total }}</td><td>{{ item.comision }}</td><td>{{ item.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}</td><td>{{ item.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}</td><td>{{ item.damages_policy[0].item_details }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"!editChanges && endorsement.policy.subramo.subramo_code == 13\"><thead><tr><td>Inciso</td><td>Propietario</td><td>No. Empleado</td><td>Correo</td><td>Uso</td><td>Marca</td><td>Modelo</td><td>Año Construcción</td><td>Año Reconstrucción</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Permiso</td><td>Valor Compra</td><td>Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td></tr></thead><tbody><tr ng-repeat=\"item in endorsement.change track by $index\"><td>{{ item.certificate_number }}</td><td>{{ item.damages_policy[0].dam_owner }}</td><td>{{ item.damages_policy[0].no_employee }}</td><td>{{ item.damages_policy[0].email }}</td><td>{{ item.damages_policy[0].usage }}</td><td>{{ item.damages_policy[0].brand }}</td><td>{{ item.damages_policy[0].model }}</td><td>{{ item.damages_policy[0].construction_year }}</td><td>{{ item.damages_policy[0].reconstruction_year }}</td><td>{{ item.damages_policy[0].version }}</td><td>{{ item.damages_policy[0].serial }}</td><td>{{ item.damages_policy[0].engine }}</td><td>{{ item.damages_policy[0].color }}</td><td>{{ item.damages_policy[0].matricula }}</td><td>{{ item.damages_policy[0].permiso }}</td><td>{{ item.damages_policy[0].purchase_value }}</td><td>{{ item.damages_policy[0].item_address }}</td><td>{{ item.p_neta }}</td><td>{{ item.rpf }}</td><td>{{ item.derecho }}</td><td>{{ item.iva }}</td><td>{{ item.p_total }}</td><td>{{ item.comision }}</td><td>{{ item.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ item.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}</td><td>{{ item.damages_policy[0].item_details }}</td></tr></tbody></table><div ng-if=\"editChanges && endorsement.policy.ramo.ramo_code == 2\" ng-repeat=\"item in endorsement.change track by $index\"><div ng-if=\"item.tipo && item.tipo == 3\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Certificado: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-disabled=\"item.accidents_policy[0].personal.url\" ng-model=\"item.certificate\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Nombre:</span><div><span>{{ item.first_name }} {{ item.last_name }} {{ item.second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Fecha de nacimiento:</span><div><span>{{ item.birthdate | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Parentesco</span><div><span ng-if=\"item.relationship == 2\">Cónyuge</span> <span ng-if=\"item.relationship == 3\">Hijo(a)</span> <span ng-if=\"item.relationship == 4\">Otro</span></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Alta:</label><div class=\"datepicker-me input-group date\"><input ng-disabled=\"item.url\" type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.charge_date\" date-validator=\"\" value=\"{{newCertificate.datos.personal.charge_date}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input ng-disabled=\"item.url\" type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.antiguedad\" date-validator=\"\" value=\"{{datosantiguedad}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input ng-disabled=\"item.url\" ng-change=\"updatePrimaTotal()\" class=\"form-control\" type=\"number\" ng-model=\"item.p_neta\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input ng-disabled=\"item.url\" ng-change=\"updatePrimaTotal()\" class=\"form-control\" type=\"number\" ng-model=\"item.rpf\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input ng-disabled=\"item.url\" ng-change=\"updatePrimaTotal()\" class=\"form-control\" type=\"number\" ng-model=\"item.derecho\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input ng-disabled=\"item.url\" class=\"form-control\" type=\"number\" ng-model=\"item.iva\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input ng-disabled=\"item.url\" class=\"form-control\" type=\"text\" ng-model=\"item.p_total\" ng-change=\"updateTotal()\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input ng-disabled=\"item.url\" class=\"form-control\" type=\"number\" ng-model=\"item.comision\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div></div><div ng-if=\"!item.tipo\"><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"!item.accidents_policy[0].personal.url\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Certificado: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-disabled=\"item.accidents_policy[0].personal.url\" ng-model=\"item.accidents_policy[0].certificate_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Nombre:</span><div><span>{{ item.accidents_policy[0].personal.first_name}} {{item.accidents_policy[0].personal.last_name}} {{item.accidents_policy[0].personal.second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" id=\"birthdatePicker\" data-provide=\"datepicker\" ng-model=\"item.accidents_policy[0].personal.birthdate\" date-validator=\"\" value=\"{{item.accidents_policy[0].personal.birthdate}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><br><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><br><label class=\"pull-right\"><input type=\"checkbox\" name=\"\" ng-model=\"item.contributory\" ng-click=\"datosContributorios(item)\">Incluir Datos Contributorios</label> <span class=\"blue-color\" ng-if=\"item.accidents_policy[0].personal\"><b>Titular</b></span><div><span>&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Alta:</label><div class=\"datepicker-me input-group date\"><input ng-disabled=\"item.accidents_policy[0].personal.url\" type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.accidents_policy[0].personal.charge_date\" date-validator=\"\" value=\"{{newCertificate.datos.personal.charge_date}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Antigüedad:</label><div class=\"datepicker-me input-group date\"><input ng-disabled=\"item.accidents_policy[0].personal.url\" type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.accidents_policy[0].personal.antiguedad\" date-validator=\"\" value=\"{{newCertificate.datos.personal.antiguedad}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><br><div class=\"row col-xs-12\"><div class=\"col-xs-12\" ng-if=\"item.contributory\"><div class=\"col-xs-12\" align=\"center\"><legend><b>RFC</b></legend></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Clave:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"item.accidents_policy[0].personal.url\" ng-model=\"item.accidents_policy[0].personal.rfc_cve\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Homoclave:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"item.accidents_policy[0].personal.url\" ng-model=\"item.accidents_policy[0].personal.rfc_homocve\"></div></div><div class=\"col-xs-12\" align=\"center\"><legend><b>Domicilio</b></legend></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Calle - Número:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"item.accidents_policy[0].personal.url\" ng-model=\"item.accidents_policy[0].personal.dom_callenum\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Colonia:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"item.accidents_policy[0].personal.url\" ng-model=\"item.accidents_policy[0].personal.dom_colonia\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">CP:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"item.accidents_policy[0].personal.url\" ng-model=\"item.accidents_policy[0].personal.dom_cp\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Municipio:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"item.accidents_policy[0].personal.url\" ng-model=\"item.accidents_policy[0].personal.dom_poblacion\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Estado:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"item.accidents_policy[0].personal.url\" ng-model=\"item.accidents_policy[0].personal.dom_estado\"></div></div></div></div><br><br><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input ng-disabled=\"item.accidents_policy[0].personal.url\" ng-change=\"updatePrimaTotal()\" class=\"form-control\" type=\"number\" ng-model=\"item.accidents_policy[0].personal.p_neta\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input ng-disabled=\"item.accidents_policy[0].personal.url\" ng-change=\"updatePrimaTotal()\" class=\"form-control\" type=\"number\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\" ng-model=\"item.accidents_policy[0].personal.rpf\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input ng-disabled=\"item.accidents_policy[0].personal.url\" ng-change=\"updatePrimaTotal()\" class=\"form-control\" type=\"number\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\" ng-model=\"item.accidents_policy[0].personal.derecho\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input ng-disabled=\"item.accidents_policy[0].personal.url\" class=\"form-control\" type=\"number\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\" ng-model=\"item.accidents_policy[0].personal.iva\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input ng-disabled=\"item.accidents_policy[0].personal.url\" class=\"form-control\" type=\"text\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\" ng-model=\"item.accidents_policy[0].personal.p_total\" ng-change=\"updateTotal()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input ng-disabled=\"item.accidents_policy[0].personal.url\" class=\"form-control\" type=\"number\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\" ng-model=\"item.accidents_policy[0].personal.comision\"></div></div></div><div ng-if=\"editChanges\" ng-repeat=\"relations in item.accidents_policy[0].relationship_accident\"><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"!relations.url\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Certificado: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-disabled=\"relations.url\" ng-model=\"relations.certificate\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Nombre:</span><div><span>{{ relations.first_name }} {{ relations.last_name }} {{ relations.second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"relations.birthdate\" date-validator=\"\" value=\"{{relations.birthdate}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Parentesco</span><div><span ng-if=\"relations.relationship == 2\">Cónyuge</span> <span ng-if=\"relations.relationship == 3\">Hijo(a)</span> <span ng-if=\"relations.relationship == 4\">Otro</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Alta:</label><div class=\"datepicker-me input-group date\"><input ng-disabled=\"relations.url\" type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"relations.charge_date\" date-validator=\"\" value=\"{{newCertificate.datos.personal.charge_date}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input ng-disabled=\"relations.url\" type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"relations.antiguedad\" date-validator=\"\" value=\"{{datosantiguedad}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><br><div class=\"row col-xs-12\"><div class=\"col-xs-12\" ng-if=\"item.contributory\"><div class=\"col-xs-12\" align=\"center\"><legend><b>RFC</b></legend></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Clave:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"item.accidents_policy[0].personal.url\" ng-model=\"relations.rfc_cve\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Homoclave:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"relations.url\" ng-model=\"relations.rfc_homocve\"></div></div><div class=\"col-xs-12\" align=\"center\"><legend><b>Domicilio</b></legend></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Calle - Número:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"relations.url\" ng-model=\"relations.dom_callenum\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Colonia:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"relations.url\" ng-model=\"relations.dom_colonia\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">CP:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"relations.url\" ng-model=\"relations.dom_cp\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Municipio:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"relations.url\" ng-model=\"relations.dom_poblacion\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Estado:</label><div ng-if=\"item.contributory\"><input class=\"form-control\" type=\"text\" ng-disabled=\"relations.url\" ng-model=\"relations.dom_estado\"></div></div></div></div><br><br><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input ng-disabled=\"relations.url\" ng-change=\"updatePrimaTotal()\" class=\"form-control\" type=\"number\" ng-model=\"relations.p_neta\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input ng-disabled=\"relations.url\" ng-change=\"updatePrimaTotal()\" class=\"form-control\" type=\"number\" ng-model=\"relations.rpf\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input ng-disabled=\"relations.url\" ng-change=\"updatePrimaTotal()\" class=\"form-control\" type=\"number\" ng-model=\"relations.derecho\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input ng-disabled=\"relations.url\" class=\"form-control\" type=\"number\" ng-model=\"relations.iva\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input ng-disabled=\"relations.url\" class=\"form-control\" type=\"text\" ng-model=\"relations.p_total\" ng-change=\"updateTotal()\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input ng-disabled=\"relations.url\" class=\"form-control\" type=\"number\" ng-model=\"relations.comision\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 form-group\"><hr></div></div></div></div></div></div><div ng-if=\"editChanges && endorsement.policy.ramo.ramo_code == 1\" ng-repeat=\"item in endorsement.change track by $index\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Certificado: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.certificate_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Nombre:</span><div><span>{{item.life_policy[0].personal.first_name}} {{item.life_policy[0].personal.last_name}} {{item.life_policy[0].personal.second_last_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Fecha de nacimiento:</span><div><span>{{ item.life_policy[0].personal.birthdate | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\" ng-if=\"item.life_policy[0].personal\"><b>Titular</b></span><div><span>&nbsp;</span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.life_policy[0].personal.birthdate\" value=\"{{newCertificate.datos.personal.birthdate}}\" date-validator=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.life_policy[0].personal.antiguedad\" date-validator=\"\" value=\"{{datosantiguedad}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" ng-change=\"updatePrimaTotal()\" type=\"number\" ng-model=\"item.life_policy[0].personal.p_neta\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" ng-change=\"updatePrimaTotal()\" type=\"number\" ng-model=\"item.life_policy[0].personal.rpf\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" ng-change=\"updatePrimaTotal()\" type=\"number\" ng-model=\"item.life_policy[0].personal.derecho\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"number\" ng-model=\"item.life_policy[0].personal.iva\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" ng-change=\"updateTotal()\" type=\"text\" ng-model=\"item.life_policy[0].personal.p_total\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"number\" ng-model=\"item.life_policy[0].personal.comision\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div></div></div><div ng-if=\"editChanges && endorsement.policy.subramo.subramo_code == 9\" ng-repeat=\"item in endorsement.change track by $index\"><div class=\"col-xs-12\" align=\"center\" style=\"margin-bottom: 20px;\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Certificado: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.certificate_number\"></div><div class=\"col-xs-12 col-sm-9 form-group m-t\"><span class=\"blue-color\">Descripción:</span><div><span>{{item.automobiles_policy[0].brand}} {{item.automobiles_policy[0].model}} {{item.automobiles_policy[0].version}} {{item.automobiles_policy[0].year}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" ng-change=\"updatePrimaTotal()\" type=\"number\" ng-model=\"item.p_neta\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" ng-change=\"updatePrimaTotal()\" type=\"number\" ng-model=\"item.rpf\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" ng-change=\"updatePrimaTotal()\" type=\"number\" ng-model=\"item.derecho\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" ng-change=\"changePrimaIva(item)\" type=\"number\" ng-model=\"item.iva\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" ng-change=\"updateTotal()\" type=\"text\" ng-model=\"item.p_total\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"number\" ng-model=\"item.comision\" ng-pattern=\"/^\\d+(\\.\\d{1,2})?$/\" step=\"0.01\"></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 m-t pull-right\"><button ng-if=\"endorsement.status != 2\" style=\"margin-bottom: 10px;\" ng-click=\"saveChangesUpdates(endorsement.change)\" ng-hide=\"editChanges == false\" class=\"btn btn-primary col-xs-12\">Guardar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 m-t pull-right\"><button ng-if=\"endorsement.status != 2\" style=\"margin-bottom: 10px;\" ng-click=\"hideButtons()\" ng-hide=\"editChanges == false\" class=\"btn btn-white col-xs-12\">Cancelar</button></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Total:</label> <input class=\"form-control\" type=\"number\" ng-model=\"suma_p_total\" disabled=\"\"></div></div></div><div class=\"col-xs-12 form-group\" ng-if=\"endorsement.concept == 25\"><div ng-if=\"editChanges\" class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Las primas corresponden <b>Primas no devengadas</b></div><div class=\"panel-body table-over-y\"><button ng-if=\"endorsement.status != 2\" style=\"margin-bottom: 10px;\" ng-click=\"initChanges(endorsement.change)\" ng-hide=\"editChanges == true\" class=\"btn btn-primary\">Activar edición</button> <button ng-if=\"endorsement.status != 2\" style=\"margin-bottom: 10px;\" ng-click=\"saveChangesUpdates(endorsement.change)\" ng-hide=\"editChanges == false\" class=\"btn btn-primary\">Guardar</button><div ng-if=\"editChanges && endorsement.policy.ramo.ramo_code == 2\" ng-repeat=\"item in endorsement.change track by $index\"><div ng-if=\"!item.tipo\"><div ng-if=\"editChanges && item.personal\"><div class=\"col-xs-12\" align=\"center\" style=\"margin-bottom: 20px;\"><label>{{item.personal.first_name}} {{item.personal.last_name}} {{item.personal.second_last_name}}</label><br><label>Número de certificado: {{item.personal.certificate_number}}</label><br><label>Titular</label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Baja:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.personal.discharge_date\" date-validator=\"\" value=\"{{newCertificate.datos.personal.discharge_date}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.p_neta_earned\" ng-change=\"changePrimaTutular(item.personal)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.rpf_earned\" ng-change=\"changePrimaTutular(item.personal)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.derecho_earned\" ng-change=\"changePrimaTutular(item.personal)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.iva_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.p_total_earned\" ng-change=\"changePrimaTutular(item.personal)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.comision_earned\" ng-change=\"changePrimaTutular(item.personal)\"></div></div><div ng-repeat=\"itemRelation in item.personal.dependientes track by $index\" ng-if=\"itemRelation.is_active ==true || itemRelation.is_active\"><div class=\"col-xs-12\" align=\"center\" style=\"margin-bottom: 20px;\"><label>{{itemRelation.first_name}} {{itemRelation.last_name}} {{itemRelation.second_last_name}}</label><br><label>Número de certificado: {{itemRelation.certificate}}</label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Baja:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"itemRelation.discharge_date\" date-validator=\"\" value=\"{{newCertificate.datos.personal.discharge_date}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"itemRelation.p_neta_earned\" ng-change=\"changePrimaDependient(itemRelation)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-model=\"itemRelation.rpf_earned\" ng-change=\"changePrimaDependient(itemRelation)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"itemRelation.derecho_earned\" ng-change=\"changePrimaDependient(itemRelation)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"itemRelation.iva_earned\" ng-change=\"changePrimaDependient(itemRelation)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"itemRelation.p_total_earned\" ng-change=\"changePrimaDependient(itemRelation)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"itemRelation.comision_earned\" ng-change=\"changePrimaDependient(itemRelation)\"></div></div></div><div ng-if=\"item.tipo\"><div ng-if=\"editChanges\"><div class=\"col-xs-12\" align=\"center\" style=\"margin-bottom: 20px;\"><label>{{item.first_name}} {{item.last_name}} {{item.second_last_name}}</label><br><label>Número de certificado: {{item.certificate_number}}</label><br><label>Titular</label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Baja:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.discharge_date\" date-validator=\"\" value=\"{{newCertificate.datos.discharge_date}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" ng-change=\"updatePrimaTotal()\" type=\"text\" ng-model=\"item.prima_neta_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" ng-change=\"updatePrimaTotal()\" type=\"text\" ng-model=\"item.rpf_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" ng-change=\"updatePrimaTotal()\" type=\"text\" ng-model=\"item.derecho_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.iva_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.prima_total_earned\" ng-change=\"updateTotal()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.comision_earned\"></div></div></div></div><div ng-if=\"editChanges && endorsement.policy.ramo.ramo_code == 1\" ng-repeat=\"item in endorsement.change track by $index\"><div class=\"col-xs-12\" align=\"center\" style=\"margin-bottom: 20px;\"><label>{{item.personal.first_name}} {{item.personal.last_name}} {{item.personal.second_last_name}}</label><br><label>Número de certificado: {{item.personal.certificate_number}}</label><br><label>Titular</label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Baja:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.personal.discharge_date\" value=\"{{newCertificate.datos.personal.discharge_date}}\" date-validator=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.p_neta_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.rpf_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.derecho_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.iva_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.p_total_earned\" ng-change=\"updateTotal()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.comision_earned\"></div></div><div ng-if=\"editChanges && endorsement.policy.subramo.subramo_code == 9\" ng-repeat=\"item in endorsement.change track by $index\"><div class=\"col-xs-12\" align=\"center\" style=\"margin-bottom: 20px;\"><label>{{item.personal.first_name}} {{item.personal.last_name}} {{item.personal.second_last_name}}</label><br><label>Número de certificado: {{item.personal.certificate_number}}</label><br><label>Titular</label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Baja:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.personal.discharge_date\" date-validator=\"\" value=\"{{newCertificate.datos.personal.discharge_date}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" ng-change=\"updatePrimaTotal()\" type=\"text\" ng-model=\"item.personal.p_neta_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-change=\"updatePrimaTotal()\" ng-model=\"item.personal.rpf_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-change=\"updatePrimaTotal()\" ng-model=\"item.personal.derecho_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-change=\"updatePrimaTotal()\" ng-model=\"item.personal.iva_earned\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.p_total_earned\" ng-change=\"updateTotal()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.personal.comision_earned\"></div></div><table ng-if=\"!editChanges\" class=\"table table-bordered table-hover\"><thead><tr><td>Inciso</td><td>Categoría</td></tr></thead><tbody><tr ng-repeat=\"item in endorsement.change track by $index\"><td><span ng-if=\"item.certificate_number\">{{ item.certificate_number }}</span> <span ng-if=\"!item.certificate_number && item.personal.full_name\">{{ item.personal.full_name }}</span></td><td><span ng-if=\"item.parent\">{{ item.parent }}</span> <span ng-if=\"!item.parent\">{{ item.categoria.category }}</span></td></tr></tbody></table><br><div ng-if=\"!editChanges && endorsement.concept ==25 && endorsement.status==5\" class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 col-sm-6 col-md-6 btn btn-secondary ladda-button\" ng-click=\"exportIncisos(1)\">Descargar Layout Primas No Devengadas</button></div></div><div class=\"row\" ng-if=\"!editChanges && endorsement.concept ==25 && endorsement.status==5\"><div class=\"col-xs-12\"><div class=\"col-sm-6 col-md-3 form-group pull-right\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Cargar Layout Primas No Devengadas<i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando certificados...</span></div></div></div></div><div ng-if=\"showTableCertificates && !flagCertificate\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\" ng-if=\"endorsement.concept == 25 && (endorsement.policy.ramo.ramo_code == 2 || endorsement.policy.ramo.ramo_code == 1)\"><thead><tr><td>ID</td><td>Certificado</td><td>Nombre</td><td>Fecha Baja</td><td>Prima Neta No Devengada</td><td>RPF No Devengada</td><td>Derecho No Devengada</td><td>IVA No Devengada</td><td>Comisión No Devengada</td><td>Prima Total No Devengada</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.ID }}</td><td>{{ item.CERTIFICADO }}</td><td>{{ item.NOMBRE}} {{item.APELLIDO_PATERNO}} {{item.APELLIDO_MATERNO}}</td><td>{{ item.FECHA_BAJA }}</td><td>{{ item.PRIMA_NETA_NO_DEVENGADA}}</td><td>{{ item.RPF_NO_DEVENGADA }}</td><td>{{ item.DERECHO_NO_DEVENGADA }}</td><td>{{ item.IVA_NO_DEVENGADA }}</td><td>{{ item.COMISION_NO_DEVENGADA }}</td><td>{{ item.PRIMA_TOTAL_NO_DEVENGADA }}</td></tr></tbody></table><button ng-if=\"showTableCertificates && endorsement.concept ==25 && endorsement.status==5 && !guardandolay\" style=\"margin-bottom: 10px;\" ng-click=\"saveChangesUpdatesLayout(endorsement.change, excelJsonViews)\" class=\"btn btn-primary pull-right\">Guardar Cambios del Layout</button><div class=\"col-xs-12 text-center\" ng-if=\"guardandolay\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Guardando los cambios...</span></div></div></div></div><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Total:</label> <input class=\"form-control\" type=\"number\" ng-model=\"suma_p_total_baja\" disabled=\"\"></div></div></div></div></div><div class=\"row\" style=\"display: none;\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"endorsement.policy && endorsement.policy.receipts_by == 1\">Recibos de Póliza</h5><h5 ng-if=\"endorsement.policy && endorsement.policy.receipts_by == 2\">Recibos de Subgrupo</h5><h5 ng-if=\"endorsement.policy && endorsement.policy.receipts_by == 3\">Recibos de Certificado</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"poliza_multianual\"><label>Año:</label><select class=\"form-control\" ng-model=\"anioPoliza\" data-ng-options=\"anio for anio in aniosPoliza\" ng-change=\"showReceiptsYear(anioPoliza)\"></select><br></div><div class=\"col-xs-12\" ng-if=\"!show_binnacle_receipt\"><table class=\"table table-bordered table-hover animate\" ng-if=\"!show_binnacle_receipt\"><thead><tr><th>Serie</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>Iva</th><th>Prima Total</th><th ng-if=\"order.permiso_comisiones\">Comisión</th><th width=\"5%\" ng-if=\"order.permiso_comisiones\">Comisión Conciliada</th><th>Vigencia</th><th>Vencimiento</th><th>Estatus</th><th>Entregado</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"recibo in endorsement.policy.recibos_poliza\" ng-if=\"recibo.receipt_type == 1 && recibo.status != 0\" ng-click=\"changeStatusModal(recibo, contractor, endorsement)\"><td>{{recibo.recibo_numero}}</td><td>{{recibo.prima_neta | currency}}</td><td>{{recibo.rpf | currency}}</td><td>{{recibo.derecho | currency}}</td><td>{{recibo.iva | currency}}</td><td>{{recibo.prima_total | currency}}</td><td ng-if=\"order.permiso_comisiones\">{{recibo.comision | currency}}</td><td ng-if=\"order.permiso_comisiones\">{{recibo.comision_conciliada | currency}}</td><td>{{recibo.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{recibo.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{recibo.vencimiento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == 4, \'label-info\' : recibo.status == 5 || recibo.status == 6, \'label-primary\' : recibo.status == 1 || recibo.status == 3, \'label-warning\' : recibo.status == 2 || recibo.status == 8}\">{{ statusReceipt(recibo.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(recibo);\"><span ng-if=\"recibo.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!recibo.delivered\"><i class=\"fa fa-times\"></i></span></td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-if=\"!recibo.track_bitacora\" ng-click=\"showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"recibo.track_bitacora\" ng-click=\"showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-info btn-sm pull-right\" title=\"Crear Recordatorio\" ng-click=\"$event.stopPropagation();createRecordatorio(recibo,4)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a> <a ng-if=\"recibo.is_cat\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a></td></tr><tr><td><b>Totales</b></td><td><b>{{ total_prima | currency }}</b></td><td><b>{{ total_rpf | currency }}</b></td><td><b>{{ total_derecho | currency }}</b></td><td><b>{{ total_iva | currency }}</b></td><td><b>{{ total_total | currency }}</b></td><td><b>{{ total_comision| currency }}</b></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table></div><div class=\"col-xs-12\" ng-if=\"!show_binnacle_receipt\"><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div><div class=\"row animate\" ng-if=\"show_binnacle_receipt\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><a class=\"col-xs-12 btn btn-info pull-right\" ng-click=\"returnToReceipts()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</a></div><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Bitácora de recibos</h3><hr></div><div><div class=\"col-xs-12 form-group\"><comments datasource=\"comments_data_receipt\" typemodel=\"4\" config=\"comments_config\" idmodel=\"receipt_id\" receiptmodel=\"receiptmodel\" exportable=\"true\"></comments></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"endorsement.endorsement_type != \'B\' && (endorsement.status == 2 || endorsement.status == 4)\"><div class=\"col-xs-12\" ng-if=\"endorsement.concept != 1\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de Endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover animate\" ng-if=\"!show_binnacle_receipt_endorsement\"><thead><tr><th>Serie</th><th>Prima Neta</th><th><span ng-if=\"endorsement.policy.document_type == 1 || endorsement.policy.document_type == 3\">RPF</span><span ng-if=\"endorsement.policy.document_type == 7 || endorsement.policy.document_type == 8\">Gastos</span></th><th>Derecho</th><th>Iva</th><th>Prima Total</th><th ng-if=\"order.permiso_comisiones\">Comisión</th><th width=\"5%\" ng-if=\"order.permiso_comisiones\">Comisión Conciliada</th><th>Vigencia</th><th>Vencimiento</th><th>Estatus</th><th>Entregado</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"recibo in endorsement.endorsement_receipt\" ng-if=\"(recibo.receipt_type == 2 || recibo.receipt_type == 3) && recibo.status != 0\" ng-click=\"changeStatusModal(recibo,contractor, endorsement)\"><td>{{recibo.recibo_numero}}</td><td>{{recibo.prima_neta | currency}}</td><td>{{recibo.rpf | currency}}</td><td>{{recibo.derecho | currency}}</td><td>{{recibo.iva | currency}}</td><td>{{recibo.prima_total | currency}}</td><td ng-if=\"order.permiso_comisiones\">{{recibo.comision | currency}}</td><td ng-if=\"order.permiso_comisiones\">{{recibo.comision_conciliada | currency}}</td><td>{{recibo.fecha_inicio | date: \'dd/MM/yyyy\'}} - {{recibo.fecha_fin | date: \'dd/MM/yyyy\'}}</td><td>{{recibo.vencimiento | date: \'dd/MM/yyyy\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == 4, \'label-info\' : recibo.status == 5 || recibo.status == 6, \'label-primary\' : recibo.status == 1 || recibo.status == 3, \'label-warning\' : recibo.status == 2 || recibo.status == 8}\">{{ statusReceipt(recibo.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(recibo);\"><span ng-if=\"recibo.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!recibo.delivered\"><i class=\"fa fa-times\"></i></span></td><td ng-click=\"$event.stopPropagation()\"><span title=\"{{ whatsappWebEnabled ? \'Recordatorio por WhatsApp Web\' : \'Recordatorio por SMS\' }}\" ng-if=\"order.acceso_adm_pol\"><button class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); addPhoneWhatsapp(recibo, contractor.contractor)\" ng-disabled=\"recibo.status != 4\" title=\"{{ whatsappWebEnabled ? \'Recordatorio por WhatsApp Web\' : \'Recordatorio por SMS\' }}\"><img ng-if=\"!whatsappWebEnabled\" style=\"height: 15px;\" class=\"icon-menu\" src=\"../../assets/comment-sms-solid.svg\"> <i ng-if=\"whatsappWebEnabled\" class=\"fa fa-whatsapp\"></i></button></span> <a class=\"btn btn-white btn-sm\" ng-if=\"order.acceso_cor\" ng-click=\"addEmailsConfirmPolicy(recibo, contractor.contractor)\" ng-disabled=\"!(recibo.status == 4)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-if=\"acceso_cor\" ng-click=\"addEmailsConfirmPolicy(recibo, contractor.contractor)\" ng-disabled=\"recibo.status != 4\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-if=\"!recibo.track_bitacora\" ng-click=\"showBinnacleReceiptEndorsement(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"recibo.track_bitacora\" ng-click=\"showBinnacleReceiptEndorsement(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a ng-if=\"recibo.is_cat\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <a ng-if=\"recibo.status == 4 && order.permiso_delete_cobranza\" ng-click=\"deleteReceipts(recibo,$index)\" class=\"btn btn-white btn-sm\" title=\"Eliminar recibo\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-info btn-sm pull-right\" title=\"Crear Recordatorio\" ng-click=\"$event.stopPropagation();createRecordatorio(recibo,4)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-sm btn-white\" ng-click=\"editReceipt(recibo)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"3\" model=\"recibo.recibo_numero + \' de la póliza \' + caratula.poliza_number\" associated=\"caratula.id\" receipt=\"recibo.id\"></tasks></td></tr><tr><td><b>Totales</b></td><td><b>{{ endorsement_total_prima | currency }}</b></td><td><b>{{ endorsement_total_rpf | currency }}</b></td><td><b>{{ endorsement_total_derecho | currency }}</b></td><td><b>{{ endorsement_total_iva | currency }}</b></td><td><b>{{ endorsement_total_total | currency }}</b></td><td><b>{{ endorsement_total_comision| currency }}</b></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><div class=\"col-xs-12\" ng-if=\"!show_binnacle_receipt_endorsement\"><div class=\"identificador-dash-email\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se envio un correo.</span><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div><div class=\"row animate\" ng-if=\"show_binnacle_receipt_endorsement\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><a class=\"col-xs-12 btn btn-info pull-right\" ng-click=\"returnToReceiptsEndorsement()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</a></div><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Bitácora de recibos</h3><hr></div><div><div class=\"col-xs-12 form-group\"><comments datasource=\"comments_data_receipt\" typemodel=\"4\" config=\"comments_config\" idmodel=\"receipt_id\" receiptmodel=\"receiptmodel\" exportable=\"true\"></comments></div></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Archivos</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-if=\"order.permiso_administrar_adjuntos\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(endorsement)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Archivos</button></div></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th ng-if=\"order.permiso_archivos\" width=\"200px\"></th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><input id=\"blur_text\" type=\"text\" ng-model=\"file.nombre\" ng-blur=\"saveFile(file)\" onblur=\"blurArchivoCargado(this)\" class=\"form-control display-none\"> <strong>{{ file.nombre }}</strong></td><td nowrap=\"\"><a class=\"btn btn-success btn-bm0\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary btn-bm0\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file, files)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</a> <span ng-click=\"saveFile(file)\" class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td><td ng-if=\"order.permiso_archivos\"><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> * Archivo sensible</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"comments_data\" config=\"comments_config\" typemodel=\"10\" idmodel=\"endorsement.id\" exportable=\"true\"></comments></div></div></div></div></div></div><script type=\"text/javascript\">\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"[id=\'blur_text\']\");\n\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target);\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    // btnTag.prop(\'onclick\',null).off(\'click\');\n\n    btnTag.removeClass(\'display-none\');\n    dummy.addClass(\'display-none\');\n\n\n    inputTag.addClass(\'display-none\');\n    strongTag.removeClass(\'display-none\');\n  }\n</script><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/endosoFull/endoso.full.status.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Cambiar Estatus</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><h3>Estatus actual:</h3><div class=\"label\" ng-class=\"{\'label-success\': vmm.endorsement.status == 2, \'label-info\' : vmm.endorsement.status == 5,\'label-primary\' : vmm.endorsement.status == 1, \'label-warning\' : vmm.endorsement.status == 3 || vmm.endorsement.status == 4}\">{{ status(vmm.endorsement.status) }}</div></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><label>Estatus:</label><select class=\"form-control m-b\" ng-model=\"vmm.selectedType\" ng-options=\"item as item.label for item in vmm.status track by item.value\" ng-change=\"changePayment()\"><option disabled=\"\" value=\"\">Selecciona un estatus</option></select></div></div><div class=\"row\" ng-if=\"vmm.selectedType.value == 2\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Registrar Endoso</legend></div><div class=\"row text-align-center\" ng-if=\"vmm.policy.administration_type === \'Autoadministrada\' || vmm.policy.administration_type === 2\"><div class=\"col-xs-12\"><div class=\"panel panel-info\" style=\"margin-bottom:12px;\"><div class=\"panel-heading\" style=\"font-weight:600;\">Póliza Autoadministrada</div><div class=\"panel-body\"><p class=\"text-muted\" style=\"margin-bottom:12px;\">Esta póliza es <strong>autoadministrada</strong>, por lo tanto <strong><u>no requiere recibos</u></strong>.</p><div class=\"row\"><div class=\"col-xs-12 col-sm-8\"><div class=\"checkbox\" style=\"margin:0;\"><label><input type=\"checkbox\" ng-model=\"generarRecibosExcepcional\" ng-change=\"vmm.addReceipts(generarRecibosExcepcional)\"> <strong>¿Generar recibos en esta ocasión excepcional?</strong></label><p class=\"help-block pull-right\" ng-if=\"generarRecibosExcepcional\" style=\"margin-top:6px;\">Se generarán recibos <strong>solo por esta vez</strong>.</p></div></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Número de Endoso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.endorsement.number_endorsement\" ng-blur=\"checkLength(vmm.endorsement.number_endorsement)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vmm.endorsement.endorsement_type != \'B\' && vmm.endorsement.concept !=1\"><label>Número de Recibos: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vmm.total_receipts\" ng-options=\"number as number.name for number in vmm.totalReceipts track by number.id\" ng-change=\"changeNumberReceipts(vmm.total_receipts)\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Folio de la Aseguradora:</label> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.endorsement.insurancefolio\"></div><div class=\"col-xs-12 form-group\" ng-if=\"(vmm.endorsement.endorsement_type == \'A\' || vmm.endorsement.endorsement_type == \'D\') && vmm.endorsement.concept!=1\"><div><receipts-endoso form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-endoso></div></div><div class=\"col-xs-12 form-group\" ng-if=\"(vmm.endorsement.endorsement_type == \'A\' || vmm.endorsement.endorsement_type == \'D\') && (vmm.endorsement.concept==1)\"><receipts-individual form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-individual></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cerrar</button> <button class=\"btn btn-success\" ng-if=\"vmm.selectedType.value != 2\" ng-click=\"rejectEndorsement()\" type=\"button\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar</button> <button class=\"btn btn-success\" ng-if=\"vmm.selectedType.value == 2\" ng-click=\"checkNumberEndorsement()\" type=\"button\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Registrar</button></div></div>");
$templateCache.put("app/endosoFull/endoso.gpo.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos Pólizas de Grupo</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Endosos Pólizas de Grupo</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 form-group padding20\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"Manual\" ng-click=\"hideButtonOT()\"><div ng-include=\"\" src=\"\'app/endosoFull/endoso.gpo.manual.html\'\"></div></uib-tab><uib-tab index=\"1\" heading=\"Masivo\" ng-click=\"showButtonPolicy()\"><div ng-include=\"\" src=\"\'app/endosoFull/endoso.gpo.massive.html\'\"></div></uib-tab></uib-tabset></div></div>");
$templateCache.put("app/endosoFull/endoso.gpo.manual.html","<toaster-container></toaster-container><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Endoso Manual</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Número de Póliza: <span class=\"color-red\">*</span></label><autocomplete datasource=\"autocompleteData\" model=\"order.policy_number\" change=\"findPolicy(order.policy_number)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=\"m-t\"><input type=\"checkbox\" name=\"register\" ng-disabled=\"!order.policy_number\" ng-checked=\"checkSelected(checkCertificate)\" ng-model=\"checkCertificate\"> &nbsp;Endoso a un certificado</label></div><div class=\"col-xs-12 col-sm-8 form-group\" ng-if=\"checkCertificate\"><div class=\"col-sm-6 form-group\"><label>Titular/Serie: <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-model=\"word\" placeholder=\"Núm.Certificado, Serie, Titular\"> <span class=\"input-group-btn\" ng-disabled=\"!word\"><button class=\"btn btn-success\" ng-click=\"findCertificate_b(word)\"><i class=\"glyphicon glyphicon-search\"></i></button></span></div><br></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"checkCertificate\"><label>Seleccione (Certificado)<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"order.certificate_number\" ng-options=\"cert.label for cert in autocompleteDataCertificate track by cert.id\" ng-change=\"selectCertB(order.certificate_number)\"></select></div></div></div><div ng-if=\"caratula.poliza_number\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Información de la Póliza</legend></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{ caratula.poliza_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ caratula.contractor.full_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ caratula.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ caratula.end_of_validity | date: \'dd/MM/yyyy\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Frecuencia de pago:</span><div><span>{{ payment(caratula.forma_de_pago) }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Tipo de Administración:</span><div><span>{{caratula.administration_type}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Estatus:</span><div><div class=\"label\" ng-class=\"{\'label-success\': caratula.status == \'Por iniciar\', \'label-info\' : caratula.status == \'Vigente\', \'label-primary\' : caratula.status == \'Renovada\'}\" style=\"margin-right: 10px\">{{ caratula.status }}</div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Compañía:</span><div><span>{{ caratula.aseguradora.alias }}{{ vm.insurance.afianzadora.alias }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ caratula.ramo.ramo_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ caratula.subramo.subramo_name }}<span></span></span></div></div><div class=\"col-xs-12 form-group\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Información del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Tipo de Endoso:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"typeSelected\" ng-options=\"type as type.name for type in types track by type.id\" ng-change=\"fillData(typeSelected); saveLocalstorange()\" ng-disabled=\"!caratula.poliza_number\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-8 form-group\" ng-if=\"typeSelected.id != 0\"><label>Concepto: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"descriptionSelected\" ng-options=\"description as description.name for description in descriptions track by description.value\" ng-change=\"showFields(descriptionSelected);\"><option value=\"\" disabled=\"\">Selecciona un concepto</option></select></div><div class=\"col-xs-12 form-group\" ng-if=\"descriptionSelected.id == 3\"><label>Agregue el concepto: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.other_desc\" ng-change=\"saveLocalstorange()\" ng-blur=\"checkLengthOtherdesc(endorsement.other_desc)\"></div></div><div class=\"row\" ng-if=\"descriptionSelected\"><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"startDate\" ng-change=\"checkDate(startDate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Al: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endDate\" class=\"width-100 text-align-center form-control\" ng-model=\"endDate\" ng-change=\"checkEndDate(endDate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del endoso: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"endorsement.observations\" ng-change=\"saveLocalstorange()\" name=\"description\"></textarea></div></div><div class=\"row\" ng-if=\"typeSelected.id != 0 && descriptionSelected.id != 0\"><div ng-include=\"\'app/endosoFull/types/colectivo.html\'\"></div></div><div class=\"row\" ng-if=\"descriptionSelected && order.permiso_administrar_adjuntos\"><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><hr></div><div class=\"btn-group col-sm-4 col-sm-offset-4\"><button class=\"btn\" ng-click=\"changeRegister(false)\" ng-style=\"btnNoRegister\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i> No Registrar</button> <button class=\"btn\" ng-click=\"changeRegister(true)\" ng-style=\"btnRegister\"><i class=\"fa fa-tasks\" aria-hidden=\"true\"></i> Registrar</button></div><div class=\"col-xs-12 form-group\"><hr></div></div><div class=\"row\" ng-if=\"checkRegister && order.acceso_adm_ot && order.acceso_reg_end\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Registar Endoso</legend></div><div class=\"row text-align-center\" ng-if=\"caratula.administration_type === \'Autoadministrada\' || caratula.administration_type === 2\"><div class=\"col-xs-12\"><div class=\"panel panel-info\" style=\"margin-bottom:12px;\"><div class=\"panel-heading\" style=\"font-weight:600;\">Póliza Autoadministrada</div><div class=\"panel-body\"><p class=\"text-muted\" style=\"margin-bottom:12px;\">Esta póliza es <strong>autoadministrada</strong>, por lo tanto <strong><u>no requiere recibos</u></strong>.</p><div class=\"row\"><div class=\"col-xs-12 col-sm-8\"><div class=\"checkbox\" style=\"margin:0;\"><label><input type=\"checkbox\" ng-model=\"generarRecibosExcepcional\" ng-change=\"order.addReceipts(generarRecibosExcepcional)\"> <strong>¿Generar recibos en esta ocasión excepcional?</strong></label><p class=\"help-block pull-right\" ng-if=\"generarRecibosExcepcional\" style=\"margin-top:6px;\">Se generarán recibos <strong>solo por esta vez</strong>.</p></div></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Número de Endoso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.number_endorsement\" ng-change=\"saveLocalstorange()\" ng-blur=\"checkLength(endorsement.number_endorsement)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"typeSelected.name != \'B\'\"><label>Número de Recibos: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"total_receipts\" ng-options=\"number as number.name for number in totalReceipts track by number.id\" ng-change=\"changeNumberReceipts(total_receipts)\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Folio de la Aseguradora:</label> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.insurancefolio\"></div><div class=\"col-xs-12 form-group\" ng-if=\"typeSelected.name != \'B\'\"><receipts-endoso form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-endoso></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"!checkRegister\"><button class=\"col-xs-12 btn btn-primary ladda-button2\" ng-click=\"createEndorsement()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"checkRegister && order.acceso_reg_end\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"checkNumberEndorsement()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Registrar Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ui-sref=\"endorsement.lista\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div class=\"row\"><div class=\"col-xs-12\"><br><br><br><br></div></div>");
$templateCache.put("app/endosoFull/endoso.gpo.massive.html","<toaster-container></toaster-container><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pull-right option_button m-b\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\" ng-if=\"order.acceso_form\"><li class=\"dropdown-submenu\"><a>Descargar layouts</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Flotillas.xls\">Flotillas</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Gastos_Medicos.xls\">Gastos médicos</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Vida.xls\">Vida</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Incendio.xls\">Incendio</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Eq_Elect_Contratista.xls\">Diversos</a></li><li><a href=\"https://miurabox.s3.amazonaws.com/layouts/Layout_Endoso_Baja.xls\">Baja Certificado *</a></li></ul></li></ul></div></div></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Certificados</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Número de Póliza: <span class=\"color-red\">*</span></label><autocomplete datasource=\"autocompleteData\" model=\"order.policy_number\" change=\"findPolicy(order.policy_number)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Movimiento: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"movement.name for movement in movements\" ng-change=\"changeMovement(movementSelected)\" ng-model=\"movementSelected\" ng-disabled=\"!order.policy_number.value\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div></div><div class=\"row col-xs-12 padding20\"><div ng-if=\"caratula.poliza_number\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Información de la Póliza</legend></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{ caratula.poliza_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ caratula.contractor.full_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ caratula.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ caratula.end_of_validity | date: \'dd/MM/yyyy\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Frecuencia de pago:</span><div><span>{{ payment(caratula.forma_de_pago) }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Tipo de Administración:</span><div><span>{{caratula.administration_type}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Estatus:</span><div><div class=\"label\" ng-class=\"{\'label-success\': caratula.status == 10, \'label-info\' : caratula.status == 14, \'label-primary\' : caratula.status == 12}\" style=\"margin-right: 10px\">{{ status(caratula.status) }}</div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Compañía:</span><div><span>{{ caratula.aseguradora.alias }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ caratula.ramo.ramo_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ caratula.subramo.subramo_name }}<span></span></span></div></div><div class=\"col-xs-12 form-group\"><hr></div></div></div><div class=\"row\" ng-if=\"movementSelected\"><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"startDate\" ng-change=\"checkDate(startDate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Al: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endDate\" class=\"width-100 text-align-center form-control\" ng-model=\"endDate\" ng-change=\"checkEndDate(endDate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del endoso: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"endorsement.observations\" name=\"description\"></textarea></div><div class=\"col-xs-12 form-group\"><hr></div><div class=\"col-xs-12 col-sm-8 form-group\" ng-if=\"subgrupos.length > 0\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Subgrupos</th><th>Categorías</th></tr></thead><tbody><tr ng-repeat=\"item in subgrupos\"><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br><small>Nombre: <span>{{ item.name }}</span></small></td><td><ul><li ng-repeat=\"categorie in item.categorias\"><small>ID para layout:</small><span class=\"font-weight-bold\">{{ categorie.id }}</span><br><small>Nombre: <span>{{ categorie.name }}</span></small></li></ul></td></tr></tbody></table></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"paquetes.length > 0\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Paquetes</th></tr></thead><tbody><tr ng-repeat=\"item in paquetes\"><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br><small>Nombre: <span>{{ item.package_name }}</span></small></td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"!showTableCertificates && movementSelected\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando certificados...</span></div></div></div><div class=\"row\" ng-if=\"showTableCertificates\"><div class=\"col-xs-1 form-group\"><select class=\"form-control\" ng-options=\"renewal.value for renewal in optionsViews\" ng-change=\"selectViews(optionViews)\" ng-model=\"optionViews\"></select></div><div><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\" ng-if=\"movementSelected.value != 2\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\" ng-if=\"movementSelected.id == 24 && caratula.subramo.subramo_code == 1\"><thead><tr><td>Familia</td><td>Folio</td><td>Certificado</td><td>Correo</td><td>Tipo</td><td>Parentesco</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Tipo Suma Asegurada</td><td>Suma Asegurada</td><td>Sueldo</td><td>Fumador</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.FAMILIA }}</td><td>{{ item.FOLIO }}</td><td>{{ item.CERTIFICADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.TIPO }}</td><td>{{ item.PARENTESCO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.FECHA_NACIMIENTO }}</td><td>{{ item.SEXO }}</td><td>{{ item.FECHA_ANTIGUEDAD }}</td><td>{{ item.TIPO_SUMA_ASEGURADA }}</td><td>{{ item.SUMA_ASEGURADA }}</td><td>{{ item.SUELDO }}</td><td>{{ item.FUMADOR }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"movementSelected.id == 24 && caratula.ramo.ramo_code == 2\"><thead><tr><td>Familia</td><td>Folio</td><td>Certificado</td><td>Correo</td><td>Tipo</td><td>Parentesco</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>Fecha Nacimiento</td><td>Sexo</td><td>Fecha Antigüedad</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.FAMILIA }}</td><td>{{ item.FOLIO }}</td><td>{{ item.CERTIFICADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.TIPO }}</td><td>{{ item.PARENTESCO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.FECHA_NACIMIENTO }}</td><td>{{ item.SEXO }}</td><td>{{ item.FECHA_ANTIGUEDAD }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"movementSelected.id == 24 && caratula.subramo.subramo_code == 9\"><thead><tr><td>Inciso</td><td>Propietario</td><td>Conductor</td><td>Correo</td><td>No. Empleado</td><td>Marca</td><td>Modelo</td><td>Año</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Uso</td><td>Servicio</td><td>Procedencia</td><td>Valor Asegurado</td><td>Tipo Carga</td><td>Adaptaciones</td><td>Monto Adaptaciones</td><td>Equipamineto</td><td>Monto Equipamineto</td><td>Beneficiario Preferente</td><td>Beneficiario RFC</td><td>Beneficiario Dirección</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.PROPIETARIO }}</td><td>{{ item.CONDUCTOR }}</td><td>{{ item.CORREO }}</td><td>{{ item.NO_EMPLEADO }}</td><td>{{ item.MARCA }}</td><td>{{ item.MODELO }}</td><td>{{ item.ANO }}</td><td>{{ item.VERSION }}</td><td>{{ item.SERIE }}</td><td>{{ item.MOTOR }}</td><td>{{ item.COLOR }}</td><td>{{ item.MATRICULA }}</td><td>{{ item.USO }}</td><td>{{ item.SERVICIO }}</td><td>{{ item.PROCEDENCIA }}</td><td>{{ item.VALOR_O_SUMA_ASEGURADA }}</td><td>{{ item.TIPO_CARGA }}</td><td>{{ item.ADAPTACIONES }}</td><td>{{ item.MONTO_ADAPTACIONES }}</td><td>{{ item.EQUIPAMIENTO }}</td><td>{{ item.MONTO_EQUIPAMIENTO }}</td><td>{{ item.BENEFICIARIO_PREFERENTE }}</td><td>{{ item.BENEFICIARIO_RFC }}</td><td>{{ item.BENEFICIARIO_DIRECCION }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"movementSelected.id == 24 && caratula.subramo.subramo_code == 7\"><thead><tr><td>Inciso</td><td>Sucursal</td><td>Correo</td><td>Giro</td><td>Tipo Constructivo</td><td>No. Niveles</td><td>Zona FHM</td><td>Zona TYEV</td><td>Calle</td><td>No. Interior</td><td>No. Exterior</td><td>Municipio</td><td>Colonia</td><td>Ciudad</td><td>Estado</td><td>Código Postal</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Observaciones</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.CORREO }}</td><td>{{ item.GIRO }}</td><td>{{ item.TIPO_CONSTRUCTIVO }}</td><td>{{ item.NO_NIVELES }}</td><td>{{ item.ZONA_FHM }}</td><td>{{ item.ZONA_TYEV }}</td><td>{{ item.CALLE }}</td><td>{{ item.NO_INTERIOR }}</td><td>{{ item.NO_EXTERIOR }}</td><td>{{ item.MUNICIPIO }}</td><td>{{ item.COLONIA }}</td><td>{{ item.CIUDAD }}</td><td>{{ item.ESTADO }}</td><td>{{ item.CP }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"movementSelected.id == 24 && caratula.subramo.subramo_code == 13\"><thead><tr><td>Inciso</td><td>Propietario</td><td>No. Empleado</td><td>Correo</td><td>Descripción</td><td>Uso</td><td>Marca</td><td>Modelo</td><td>Año Construcción</td><td>Año Reconstrucción</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Permiso</td><td>Valor Compra</td><td>Calle</td><td>No. Interior</td><td>No. Exterior</td><td>Ciudad</td><td>Estado</td><td>Código Postal</td><td>Prima Neta</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Subgrupo</td><td>Categoría</td><td>Paquete</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.PROPIETARIO }}</td><td>{{ item.NO_EMPLEADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.DESCRIPCION }}</td><td>{{ item.USO }}</td><td>{{ item.MARCA }}</td><td>{{ item.MODELO }}</td><td>{{ item.ANO_CONSTRUCCION }}</td><td>{{ item.ANO_RECONSTRUCCION }}</td><td>{{ item.VERSION }}</td><td>{{ item.SERIE }}</td><td>{{ item.MOTOR }}</td><td>{{ item.COLOR }}</td><td>{{ item.MATRICULA }}</td><td>{{ item.PERMISO }}</td><td>{{ item.VALOR_COMPRA }}</td><td>{{ item.CALLE }}</td><td>{{ item.NO_INTERIOR }}</td><td>{{ item.NO_EXTERIOR }}</td><td>{{ item.CIUDAD }}</td><td>{{ item.ESTADO }}</td><td>{{ item.CP }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.SUBGRUPO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.PAQUETE }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 form-group\" ng-if=\"movementSelected.id == 25\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Certificado</td><td>Categoría</td><td>Tipo</td><td ng_if=\"caratula.ramo.ramo_code == 2\">Baja</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.CATEGORIA }}</td><td><span ng-if=\"item.TIPO ==1\">Certificado</span> <span ng-if=\"item.TIPO ==2\">Dependiente</span> <span ng-if=\"item.TIPO ==3\">Solo Dependiente</span></td><td>{{ item.NOMBRE}} {{ item.AP_PATERNO}} {{ item.AP_MATERNO}}</td></tr></tbody></table></div></div><div class=\"col-xs-12 form-group\" ng-if=\"movementSelected.id == 27\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Certificado</td><td>Categoría</td><td ng_if=\"caratula.ramo.ramo_code == 2\">Baja Dependiente</td><td ng_if=\"caratula.ramo.ramo_code == 1\">Baja Beneficiario</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.NOMBRE}} {{ item.AP_PATERNO}} {{ item.AP_MATERNO}}</td></tr></tbody></table></div></div><div class=\"col-xs-12 form-group\" ng-if=\"movementSelected.id == 26\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Certificado</td><td>Categoría</td><td ng_if=\"caratula.ramo.ramo_code == 2\">Alta Dependiente</td><td ng_if=\"caratula.ramo.ramo_code == 1\">Alta Beneficiario</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.INCISO }}</td><td>{{ item.CATEGORIA }}</td><td>{{ item.NOMBRE}} {{ item.AP_PATERNO}} {{ item.AP_MATERNO}}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"row padding20\" ng-if=\"descriptionSelected && order.permiso_administrar_adjuntos\"><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><hr></div><div class=\"btn-group col-sm-4 col-sm-offset-4\"><button class=\"btn\" ng-click=\"changeRegister(false)\" ng-style=\"btnNoRegister\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i> No Registrar</button> <button class=\"btn\" ng-click=\"changeRegister(true)\" ng-style=\"btnRegister\"><i class=\"fa fa-tasks\" aria-hidden=\"true\"></i> Registrar</button></div><div class=\"col-xs-12 form-group\"><hr></div></div><div class=\"row\" ng-if=\"checkRegister && order.acceso_adm_ot && order.acceso_reg_end\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Registrar Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Número de Endoso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"endorsement.number_endorsement\" ng-blur=\"checkLength(endorsement.number_endorsement)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"typeSelected.name != \'B\'\"><label>Número de Recibos: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"total_receipts\" ng-options=\"number as number.name for number in totalReceipts track by number.id\" ng-change=\"changeNumberReceipts(total_receipts)\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 form-group\" ng-if=\"typeSelected.name != \'B\'\"><receipts-endoso form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-endoso></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"!checkRegister\"><button class=\"col-xs-12 btn btn-primary ladda-button2\" ng-click=\"validityEndorsement()\" ng-disabled=\"disableCreate\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear Endoso*</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"checkRegister && order.acceso_reg_end\"><button class=\"col-xs-12 btn btn-primary ladda-button2\" ng-click=\"validityEndorsement()\" ng-disabled=\"disableCreate\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Registrar Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ui-sref=\"endorsement.lista\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div class=\"row\"><div class=\"col-xs-12\"><br><br><br><br></div></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/endosoFull/endoso.share.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Compartir Endoso</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!vm.show_binnacle\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Compartir por Correo electrónico\" id=\"email\" ng-click=\"getTemplate(true)\"><div class=\"panel-body\"><div><h4>Por favor ingrese el o los correo(s) electrónico(s) a quien se desea enviar un email:</h4><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Correo electrónico<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"email\" name=\"email_assign_mail\" ng-model=\"vmm.email_assign_mail\" required=\"\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"addEmail(vmm.email_assign_mail)\">Agregar</button></div></div><input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{email}}\" ng-show=\"owner_exist\" ng-click=\"addEmail(email)\"> <input class=\"btn btn-white btn-mt\" ng-repeat=\"correo in vmm.correos\" type=\"button\" name=\"\" value=\"{{correo}}\" ng-click=\"addEmail(correo)\"></div></div><table ng-if=\"files && files.length\" class=\"table table-bordered\"><br><h3><span><i>Seleccione los archivos que desea compartir:</i></span></h3><thead><tr><th>Archivo</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong></td><td><div class=\"col-md-4\"><input type=\"checkbox\" ng-model=\"file.shared_email\" ng-change=\"shareFileEmail(file)\"> <label>Compartir</label></div><div class=\"col-md-4\"><a class=\"btn btn-primary pull-right\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a></div></td></tr></tbody></table><div class=\"form-group\"><br><label>Se enviara a:</label><table class=\"table table-bordered\"><thead><th>Correo electrónico</th><th>Acciones</th></thead><tr ng-repeat=\"email in emails track by $index\"><td>{{email}}</td><td><button class=\"btn btn-danger\" ng-click=\"remove_email($index)\"><i class=\"fa fa-trash\"></i></button></td></tr></table></div></div><div class=\"form-group col-xs-12\" ng-if=\"vmm.custom_email\"><div class=\"form-group col-xs-12\"><label>Asunto:</label> <input class=\"col-xs-12 form-control\" type=\"text\" name=\"\" ng-model=\"vmm.subjectEmail\" ng-blur=\"emptySubject(vmm.subjectEmail)\"></div><div text-angular=\"\" ng-model=\"vmm.first_comment\" name=\"first_comment\"></div><br><div ng-bind-html=\"vmm.body\" name=\"body\"></div><div text-angular=\"\" ng-model=\"vmm.second_comment\" name=\"second_comment\"></div><br><div ng-bind-html=\"vmm.footer\" name=\"footer\"></div></div><div><button class=\"btn btn-primary pull-right ladda-button\" ng-disabled=\"!emails.length > 0 || !send\" ng-click=\"sendEmail(people_assigned)\">Compartir por Email</button></div></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div><script>\n    function renombrarArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n      strongTag.hide();\n      inputTag.show();\n      inputTag.focus();\n    }\n\n    function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target);\n\n      strongTag.show();\n      inputTag.hide();\n    }\n  </script><style type=\"text/css\">\n  .to_send = {\n    background-color: red;\n  }\n</style>");
$templateCache.put("app/endosos/endosos.certificateInformation.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"endosos.collectivity\">Endosos colectivos</a></li><li class=\"active\"><strong>Certificado #{{vm.covers.certificate_number}}</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title title-colapsable\"><h5>Información del endoso</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12 form-group\"><h4>Carátula</h4><div class=\"row\"><div class=\"form-group col-sm-3\"><label for=\"\">Identificador</label> <input type=\"text\" ng-model=\"vm.policy.identifier\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-3\"><label for=\"\">Tipo de administracion</label> <input type=\"text\" ng-model=\"vm.policy.administration_type\" class=\"form-control\" disabled=\"\"></div><div class=\"col-sm-3 form-group\"><label>Vigencia desde:</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.policy.start_of_validity\" min-date=\"vm.limit.start\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" disabled=\"\"></div></div><div class=\"col-sm-3 form-group\"><label>Vigencia hasta:</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.policy.end_of_validity\" max-date=\"vm.limit.end\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" disabled=\"\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\"><label for=\"\">Estatus</label><div class=\"form-control\" ng-bind=\"vm.policy.status\" disabled=\"\"></div></div><div class=\"form-group col-sm-3\"><label>Aseguradora</label> <input type=\"text\" ng-model=\"vm.policy.aseguradora.alias\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-3\"><label for=\"\">Clave del agente</label> <input type=\"text\" ng-model=\"vm.policy.clave.clave\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-3\"><label>Forma de pago</label><div class=\"form-control\" ng-bind=\"(vm.policy.forma_de_pago | payformtype)\" disabled=\"\"></div></div></div><div class=\"row\"><div class=\"col-sm-3 form-group\"><label for=\"\">Ramo</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.policy.ramo.ramo_name\" disabled=\"\"></div><div class=\"col-sm-3 form-group\"><label>Subramo</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.policy.subramo.subramo_name\" disabled=\"\"></div><div class=\"form-group col-sm-3\"><label for=\"\">Frecuencia de pago</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.policy.f_currency\" disabled=\"\"></div><div class=\"form-group col-sm-3\"><label for=\"\">Moneda</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.policy.f_currency\" disabled=\"\"></div></div><hr><h4>Datos del contratante</h4><div class=\"row\"><div class=\"form-group col-sm-3\"><label for=\"\">Nombre</label> <input type=\"text\" ng-model=\"vm.policy.natural.full_name\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-3\"><label for=\"\">Tipo de persona</label> <input type=\"text\" ng-model=\"vm.policy.natural.type_person\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-3\"><label for=\"\">Correo</label> <input type=\"email\" ng-model=\"vm.policy.natural.email\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-3\"><label for=\"\">Teléfono</label> <input type=\"tel\" ng-model=\"vm.policy.natural.phone_number\" class=\"form-control\" disabled=\"\"></div></div><div class=\"row\"><div class=\"form-group col-sm-6\"><label for=\"\">Dirección</label> <input type=\"text\" ng-model=\"direccion_contratante\" class=\"form-control\" disabled=\"\"></div></div></div></div></div></div></div></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title title-colapsable\"><h5>Información del certificado</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div ng-if=\"vm.covers.beneficiaries_life\"><h4>Titular</h4><form name=\"formLife\"><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.certificate_number.$invalid && !formLfe.certificate_number.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Número de certificado <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"certificate_number\" ng-model=\"vm.covers.certificate_number\" class=\"form-control\" ng-disabled=\"inputDisabledCert\" required=\"\"></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Paquete</label><select class=\"form-control\" name=\"pack\" data-ng-options=\"item as item.package_name for item in vm.pack\" ng-model=\"vm.covers.pack\" ng-disabled=\"inputDisabled\"></select></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pFirst_Name.$invalid && !formLfe.pFirst_Name.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Nombre <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pFirst_Name\" ng-model=\"vm.covers.personal.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pLast_name.$invalid && !formLfe.pLast_name.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Apellido Paterno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pLast_name\" ng-model=\"vm.covers.personal.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pSecond_last_name.$invalid && !formLfe.pSecond_last_name.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Apellido Materno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSecond_last_name\" ng-model=\"vm.covers.personal.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"col-sm-3 form-group\" ng-class=\"{\'has-error\': formLife.pBirthdate.$invalid && !formLfe.pBirthdate.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Fecha de nacimiento <span class=\"color-red\">*</span></label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" name=\"pBirthdate\" date-time=\"\" ng-model=\"vm.covers.personal.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\" required=\"\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pEmail.$invalid && !formLfe.pEmail.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Correo <span class=\"color-red\">*</span></label> <input type=\"email\" name=\"pEmail\" ng-model=\"vm.covers.personal.email\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pBirthdate.$invalid && !formLfe.pBirthdate.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Sexo <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"pSex\" ng-model=\"vm.covers.personal.sex\" ng-disabled=\"inputDisabled\" required=\"\"><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pSalary.$invalid && !formLfe.pSalary.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Sueldo <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSalary\" ng-model=\"vm.covers.personal.salary\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pSum_assured.$invalid && !formLfe.pSum_assured.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Suma asegurada <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSum_assured\" ng-model=\"vm.covers.personal.sum_assured\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><h4>Beneficiarios</h4><div class=\"row\"><div class=\"form-group col-xs-12 col-md-3\" ng-if=\"newEndoso\"><button type=\"button\" ng-click=\"vm.options.life.beneficiaries.add(vm.covers.life.beneficiaries)\" class=\"btn btn-info btn-block\"><span class=\"fa fa-plus-square-o\"></span> Agregar beneficiario</button></div></div><table class=\"table table-hover\"><tbody><tr ng-repeat=\"beneficiary in vm.covers.beneficiaries_life track by $index\"><td><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Nombre</label> <input type=\"text\" ng-model=\"beneficiary.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Apellido Paterno</label> <input type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Apellido Materno</label> <input type=\"text\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Fecha de nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"beneficiary.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Sexo</label><select class=\"form-control\" ng-model=\"beneficiary.sex\" ng-disabled=\"inputDisabled\"><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Parentesco</label> <input type=\"text\" ng-model=\"beneficiary.optional_relationship\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Porcentaje</label> <input type=\"text\" ng-model=\"beneficiary.percentage\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><button class=\"btn btn-danger btn-mt\" ng-if=\"newEndoso\" ng-click=\"vm.options.life.beneficiaries.destroy($index, beneficiary)\"><span class=\"fa fa-trash-o\"></span> Eliminar</button></div></div></td></tr></tbody></table><div class=\"form-group\"><button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.covers.endorsement_type === \'A\'\" ng-disabled=\"formLife.$invalid\" ng-click=\"saveCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Guardar Certificado</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.covers.endorsement_type === \'B\'\" ng-disabled=\"formLife.$invalid\" ng-click=\"editCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Actializar Certificado</button> <button class=\"btn btn-white pull-right margin-right-10\" ng-if=\"newEndoso\" ng-click=\"closeCertificate()\" ui-sref=\"endosos.collectivity\"><span class=\"fa fa-times-circle\"></span> Cancelar</button></div></form></div><div ng-if=\"vm.covers.insured_item\"><form name=\"formDamage\"><div class=\"row\"><div class=\"form-group col-sm-3\"><label>Bien asegurado</label> <input class=\"form-control\" ng-model=\"vm.covers.insured_item\" type=\"text\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label>Detalles</label> <input class=\"form-control\" ng-model=\"vm.covers.item_details\" type=\"text\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label>Direccion</label> <input class=\"form-control\" ng-model=\"vm.covers.item_address\" type=\"text\" ng-disabled=\"inputDisabled\"></div></div></form></div><div ng-if=\"vm.covers.relationship_accident\"><h4>Asegurado</h4><form name=\"formDiseage\"><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.certificate_number.$invalid && !formDiseage.certificate_number.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Número de certificado <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"certificate_number\" ng-model=\"vm.covers.certificate_number\" class=\"form-control\" ng-disabled=\"inputDisabledCert\" required=\"\"></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Paquete</label><select class=\"form-control\" name=\"pack\" data-ng-options=\"item as item.package_name for item in vm.pack\" ng-model=\"vm.covers.pack\" ng-disabled=\"inputDisabled\"></select></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pFirst_Name.$invalid && !formDiseage.pFirst_Name.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Nombre <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pFirst_Name\" ng-model=\"vm.covers.personal.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pLast_name.$invalid && !formDiseage.pLast_name.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Apellido Paterno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pLast_name\" ng-model=\"vm.covers.personal.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSecond_last_name.$invalid && !formDiseage.pSecond_last_name.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Apellido Materno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSecond_last_name\" ng-model=\"vm.covers.personal.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"col-sm-3 form-group\" ng-class=\"{\'has-error\': formDiseage.pBirthdate.$invalid && !formDiseage.pBirthdate.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Fecha de nacimiento <span class=\"color-red\">*</span></label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" name=\"pBirthdate\" date-time=\"\" ng-model=\"vm.covers.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\" required=\"\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pEmail.$invalid && !formDiseage.pEmail.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Correo <span class=\"color-red\">*</span></label> <input type=\"email\" name=\"pEmail\" ng-model=\"vm.covers.personal.email\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSex.$invalid && !formDiseage.pSex.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Sexo <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"pSex\" ng-model=\"vm.covers.personal.sex\" ng-disabled=\"inputDisabled\" required=\"\"><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSalary.$invalid && !formDiseage.pSalary.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Sueldo <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSalary\" ng-model=\"vm.covers.personal.salary\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSum_assured.$invalid && !formDiseage.pSum_assured.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Suma asegurada <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSum_assured\" ng-model=\"vm.covers.personal.sum_assured\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><hr><h4>Dependientes</h4><div class=\"row\"><div class=\"form-group col-xs-12 col-md-3\" ng-if=\"newEndoso\"><button type=\"button\" ng-click=\"vm.options.disease.relationships.add(vm.covers.disease.relationships)\" class=\"btn btn-info btn-block\"><span class=\"fa fa-plus-square-o\"></span> Agregar dependiente</button></div></div><table class=\"table table-hover\"><tbody><tr ng-repeat=\"beneficiary in vm.covers.relationship_accident track by $index\"><td><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Nombre</label> <input type=\"text\" ng-model=\"beneficiary.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Apellido Paterno</label> <input type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Apellido Materno</label> <input type=\"text\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Fecha de nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"beneficiary.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Sexo</label><select class=\"form-control\" ng-model=\"beneficiary.sex\" ng-disabled=\"inputDisabled\"><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Parentesco</label><select class=\"form-control\" ng-model=\"beneficiary.relationship\" ng-disabled=\"inputDisabled\"><option value=\"1\">Titular</option><option value=\"2\">Cónyuge</option><option value=\"3\">Hijo</option></select></div><div class=\"form-group col-sm-3\"><button class=\"btn btn-danger btn-mt\" ng-if=\"newEndoso\" ng-click=\"vm.options.disease.relationships.destroy($index, beneficiary)\"><span class=\"fa fa-trash-o\"></span> Eliminar</button></div></div></td></tr></tbody></table><div class=\"form-group\"><button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.covers.endorsement_type === \'A\'\" ng-disabled=\"formDiseage.$invalid\" ng-click=\"saveCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Guardar Certificado</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.covers.endorsement_type === \'B\'\" ng-disabled=\"formDiseage.$invalid\" ng-click=\"editCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Actualizar Certificado</button> <button class=\"btn btn-white pull-right margin-right-10\" ng-if=\"newEndoso\" ng-click=\"closeCertificate()\" ui-sref=\"endosos.collectivity\"><span class=\"fa fa-times-circle\"></span> Cancelar</button></div></form></div><div ng-if=\"vm.covers.brand || vm.covers.auto\"><h4>Automóvil</h4><form name=\"formAutomobile\"><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.certificate_number.$invalid && !formAutomobile.certificate_number.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Número de certificado <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"certificate_number\" ng-model=\"vm.covers.certificate_number\" class=\"form-control\" ng-disabled=\"inputDisabledCert\" required=\"\"></div><div class=\"form-group col-sm-3\"><label ng-style=\"fontColor\" for=\"\">Paquete</label><select class=\"form-control\" name=\"pack\" data-ng-options=\"item as item.package_name for item in vm.pack\" ng-model=\"vm.covers.pack\" ng-disabled=\"inputDisabled\"></select></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.brand.$invalid && !formAutomobile.brand.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Marca <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"brand\" ng-model=\"vm.covers.brand\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.model.$invalid && !formAutomobile.model.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Modelo <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"model\" ng-model=\"vm.covers.model\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.year.$invalid && !formAutomobile.year.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Año <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"year\" ng-model=\"vm.covers.year\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.version.$invalid && !formAutomobile.version.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Versión <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"version\" ng-model=\"vm.covers.version\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.color.$invalid && !formAutomobile.color.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Color <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"color\" ng-model=\"vm.covers.color\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.serial.$invalid && !formAutomobile.serial.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Serie <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"serial\" ng-model=\"vm.covers.serial\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.engine.$invalid && !formAutomobile.engine.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Motor <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"engine\" ng-model=\"vm.covers.engine\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.license_plates.$invalid && !formAutomobile.license_plates.$pristine}\"><label ng-style=\"fontColor\" for=\"\">Matricula <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"license_plates\" ng-model=\"vm.covers.license_plates\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><div class=\"form-group\"><button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.covers.endorsement_type === \'A\'\" ng-disabled=\"formAutomobile.$invalid\" ng-click=\"saveCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Guardar Certificado</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.covers.endorsement_type === \'B\'\" ng-disabled=\"formAutomobile.$invalid\" ng-click=\"editCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Actualizar Certificado</button> <button class=\"btn btn-white pull-right margin-right-10\" ng-if=\"newEndoso\" ng-click=\"closeCertificate()\" ui-sref=\"endosos.collectivity\"><span class=\"fa fa-times-circle\"></span> Cancelar</button></div></form></div><div class=\"row\"><div class=\"form-group col-sm-12\"><button class=\"btn btn-primary pull-right\" ng-if=\"vm.covers.endorsement_type === \'B\'\" ng-hide=\"newEndoso\" ng-click=\"showInputDisabled()\"><span class=\"fa fa-pencil-square-o\"></span> Editar</button> <button class=\"btn btn-primary\" ui-sref=\"endosos.collectivity\"><span class=\"fa fa-reply\"></span> Regresar</button></div></div></div></div></div></div></div>");
$templateCache.put("app/endosos/endosos.collectivity.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Endosos colectivos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title title-colapsable\"><h5 class=\"col-md-8\">Agregar endosos colectivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div name=\"brand\"><div class=\"form-group col-md-8\"><label for=\"brand\">Endosos manual</label><autocomplete datasource=\"autocompleteData\" model=\"vm.word\" change=\"vm.getCollet(vm.word)\"></autocomplete></div><div class=\"form-group col-md-4\"><button type=\"button\" class=\"btn btn-block btn-success btn-mt\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getType(vm.word)\"><span class=\"fa fa-search\"></span> Buscar</button></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><div class=\"col-sm-4\"><label for=\"files\">Endosos masivos</label></div></div><div class=\"row\"><div class=\"col-sm-2\"><input type=\"radio\" ng-model=\"end_type\" ng-click=\"valueRadio(end_type)\" value=\"altas\"> <label ng-class=\"{\'receipts-select\': end_type == \'altas\'}\">Altas</label></div><div class=\"col-sm-2\"><input type=\"radio\" ng-model=\"end_type\" ng-click=\"valueRadio(end_type)\" value=\"bajas\"> <label ng-class=\"{\'receipts-select\': end_type == \'bajas\'}\">Bajas</label></div></div><div name=\"files\" class=\"row\"><div class=\"form-group col-xs-12\"><input class=\"btn btn-default col-xs-12\" type=\"file\" fileread=\"\" ng-model=\"excelFile\" name=\"readCsvFile\" id=\"readCsvFile\" ng-change=\"selectExcel(excelFile)\" ng-disabled=\"inputFileDisabled\"></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.typeForm === \'manualEndorsement\'\"><div class=\"form-group col-xs-12 col-md-6\"><label for=\"selectType\">Tipo de endoso*</label><select class=\"form-control margin-bottom-10\" ng-disabled=\"vm.selectTypeStatus\" ng-model=\"vm.selectedType\" ng-options=\"type as type.name for type in vm.types track by type.id\" ng-change=\"typeEndoso(vm.selectedType)\"></select></div><div ng-if=\"vm.typeEndoso === \'A\' || vm.typeEndoso === \'B\' || vm.typeEndoso === \'D\'\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title title-colapsable\"><h5>Informacion</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Identificador:</label><div><span>{{vm.policy.identifier}}</span></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Tipo de administración:</label><div><pan>{{vm.policy.administration_type}}</pan></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Vigencia desde:</label><div><pan>{{vm.policy.start_of_validity | date: \'dd/MM/yyyy\'}}</pan></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Vigencia hasta:</label><div><pan>{{vm.policy.end_of_validity | date: \'dd/MM/yyyy\'}}</pan></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Estatus:</label><div><span>{{vm.policy.status}}</span></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Aseguradora:</label><div><span>{{vm.policy.aseguradora.alias}}</span></div></div></div><div class=\"row\"><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Clave del agente:</label><div><span>{{vm.policy.clave.clave}}</span></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Forma de pago:</label><div><span>{{vm.policy.forma_de_pago | payformtype}}</span></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Ramo:</label><div><span>{{vm.policy.ramo.ramo_name}}</span></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Subramo:</label><div><span>{{vm.policy.subramo.subramo_name}}</span></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Frecuencia de pago:</label><div><span>{{vm.policy.f_currency}}</span></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Moneda:</label><div><span>{{vm.policy.f_currency}}</span></div></div></div><hr><h3>Datos del contratante</h3><div class=\"row\"><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Nombre:</label><div><span>{{vm.contractor.name}}</span></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Tipo de persona:</label><div><span>{{vm.contractor.type_person}}</span></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Correo:</label><div><span>{{vm.contractor.email}}</span></div></div><div class=\"form-group col-sm-2\"><label class=\"blue-color\">Teléfono:</label><div><span>{{vm.contractor.phone_number}}</span></div></div><div class=\"form-group col-sm-4\"><label class=\"blue-color\">Dirección:</label><div><span>{{vm.contractor.address}}</span></div></div></div></div></div></div><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title title-colapsable\"><h5>{{vm.titleTable}}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div ng-include=\"\'app/endosos/type/manual.html\'\"></div></div></div></div></div></div></div><div ng-show=\"vm.typeForm === \'masivoEndorsement\'\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title title-colapsable\"><h5>Certificados</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div upload-template=\"\"></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-10\"><div class=\"col-md-12\"><div id=\"endorsemented_tree\" class=\"treeview\"></div></div></div><div class=\"col-xs-12 col-md-2\"><div class=\"form-group col-md-12 pull-right\"><button type=\"button\" ng-click=\"vm.massive()\" class=\"btn btn-block btn-primary\">Cargar</button></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/endosos/endosos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Crear Endoso</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Agregar Endosos</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-8 col-lg-6 form-group\"><label>Número de Póliza<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.poliza_number_data\" change=\"findContractor(vm.poliza_number_data)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" ng-click=\"vm.options.getPolicy(vm.poliza_number_data, true)\" class=\"btn btn-success\">Buscar</button></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"selectType\">Tipo de Endoso:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-disabled=\"vm.selectTypeStatus\" ng-model=\"vm.selectedType\" ng-options=\"type as type.name for type in vm.types track by type.id\" ng-change=\"vm.options.fillData(vm.selectedType)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-disabled=\"vm.selectedType.id == 1 || vm.selectedType.id == 0\"><label for=\"\">Concepto:<span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"payment\" ng-model=\"vm.form.description\" ng-disabled=\"vm.disabledAll\" ng-options=\"description as description.label for description in vm.defaults.descriptions track by description.label\" ng-change=\"showFields(vm.form.description)\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un concepto</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.description.label == \'OTRO\'\"><label for=\"\">Agregue el concepto <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"otros\" ng-model=\"vm.form.others\" class=\"form-control\"></div></div><div class=\"row\"><hr><div><div class=\"col-xs-12 form-group\"><h3 class=\"color-blue\"><input type=\"checkbox\" name=\"register\" ng-disabled=\"!vm.selectedType.name\" ng-checked=\"checkSelected(checkRegister)\" ng-model=\"checkRegister\"> Registrar Endoso</h3></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"valueConcept == 1 || valueConcept == 11\"><label>Forma de Pago Actual:</label><div class=\"form-control\" ng-bind=\"(vm.policy.forma_de_pago | payformtype)\" disabled=\"disabled\" ng-disabled=\"!(vm.form.description.label == \'OTRO\') || vm.form.description == \'\' || (vm.selectedType.id == 2 )\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"valueConcept == 1 || valueConcept == 11\"><label>Seleccione la nueva forma de pago: <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"payment\" ng-model=\"vm.form.payment\" ng-change=\"vm.options.changePayform(vm.form.payment)\" ng-options=\"payment as payment.label for payment in vm.defaults.payform track by payment.value\"><option value=\"\" disabled=\"\">Selecciona forma de pago</option></select></div><div ng-if=\"vm.selectedType.id\"><div ng-include=\"\'app/endosos/type/a.html\'\" ng-if=\"vm.selectedType.id === 1 && !vm.disabledAll\"></div><div ng-include=\"\'app/endosos/type/d.html\'\" ng-if=\"vm.selectedType.id === 3 && !vm.disabledAll\"></div><div ng-include=\"\'app/endosos/type/b.html\'\" ng-if=\"vm.selectedType.id === 2\"></div><div class=\"col-sm-12\" ng-if=\"vm.showUploader\"></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.selectedType.id\"><div class=\"row\"><div upload-template=\"\"></div></div></div><div ng-if=\"checkRegister\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Registro del Endoso</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número del Endoso<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"otros\" ng-model=\"vm.number_endorsement\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.selectedType.name === \'A\'\"><label>Número de Recibos<span class=\"color-red\">*</span></label><select ng-model=\"vm.form.num_receipts\" ng-options=\"item.value as item.name for item in vm.num_receipts_data\" ng-change=\"vm.selectNumReceipts(vm.form.num_receipts)\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.form.num_receipts && checkRegister\"><div><endorsement-receipts tosave=\"vm.form\" form=\"vm.form\" policy=\"vm.policy\"></endorsement-receipts></div></div><div ng-if=\"vm.selectedType.name === \'D\'\"><div class=\"col-xs-12 form-group\"><hr><h3>Nota de Crédito</h3></div><form name=\"formStatusD\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Folio de la Nota de Crédito:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"folio\" ng-model=\"creditNotes.folio\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Prima Neta:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"prima_neta\" ng-model=\"creditNotes.prima_neta\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>IVA: %</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" type=\"tel\" id=\"iva_percentage\" minlength=\"1\" maxlength=\"2\" ng-model=\"creditNotes.iva_percentage\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Recargo por Pago Fraccionado: %</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" type=\"tel\" id=\"rpf_percentage\" minlength=\"1\" maxlength=\"2\" ng-model=\"creditNotes.rpf_percentage\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Gastos de Expedición: $</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"prima-neta\" ng-model=\"creditNotes.gastos_expedicion\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Forma de Pago:</label><select class=\"form-control\" ng-model=\"creditNotes.payform\" ng-options=\"item.value as item.name for item in dataPayform\"><option value=\"\">Seleccione una opcion</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"SelectCurrency\">Moneda</label><select id=\"SelectCurrency\" class=\"form-control\" ng-options=\"f_currency.value as f_currency.label for f_currency in vm.f_currency.options\" ng-init=\"vm.f_currency.f_currency_selected = 1\" ng-model=\"vm.f_currency.f_currency_selected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de Emisión:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input class=\"width-100 text-align-center form-control\" type=\"text\" name=\"startDate\" ng-model=\"creditNotes.fecha_emision\" value=\"{{vmm.creditNotes.fecha_emision}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-success btn-mt\" ng-disabled=\"formStatusD.$invalid\" ng-click=\"updateFieldD()\" id=\"calcularD\" type=\"submit\">Calcular</button></div></form><div class=\"col-xs-12\"><div class=\"col-xs-12 col-md-6 col-md-offset-3\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Nota de Crédito</div><div class=\"panel-body\"><div class=\"form-horizontal\"><div class=\"form-group btn-mt\"><label class=\"control-label col-sm-4\">IVA:</label><div class=\"col-sm-8\"><input class=\"form-control\" disabled=\"\" ng-model=\"creditNotes.iva\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Prima Neta:</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"creditNotes.prima_neta\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Recargo por Pago Fraccionado:</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"creditNotes.rpf\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Sub Total:</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"creditNotes.sub_total\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Prima Total:</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"creditNotes.prima_total\" format-as-currency=\"\"></div></div></div></div></div></div></div></div></div><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"!checkRegister\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"vm.options.createEndorsement(1)\">Crear Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"checkRegister\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"vm.options.createEndorsement(2)\">Registrar Endoso</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/endosos/endosos.information.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"endosos.endosos\">Endosos</a></li><li class=\"active\"><strong>Información de Endosos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"></div></div></div></div></div>");
$templateCache.put("app/endosos/endosos.pending.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Endosos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Listado de endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-init=\"vm.getEndorsementsEs()\"><div class=\"col-xs-12 input-group btn-mt\"><input type=\"text\" class=\"form-control\" id=\"filter\" placeholder=\"Buscar\" ng-enter=\"vm.search(cadena)\" ng-model=\"cadena\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.activate()\">Mostrar Todo</button></div></div><div class=\"row m-t-lg mt-30\" ng-init=\"vm.change_tab(1,1,1)\"><div class=\"col-lg-12\"><div class=\"tabs-container\" ng-show=\"tableEndosos\" ng-if=\"!vm.show_binnacle\"><uib-tabset><uib-tab heading=\"Pendientes\" id=\"enpendientes\" ng-click=\"responsiv(); vm.change_tab(1,1,1)\"><div class=\"panel-body no-lateral-scroll\"><div class=\"table-responsive\" id=\"exportable\"><div class=\"project-list\"><table class=\"table table-stripped\"><thead><tr><th ng-click=\"vm.changeEndosoP(1, vm.endosop_type_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': vm.endosop_type_asc == 1, \'fa fa-sort-asc\': vm.endosop_type_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoP(2, vm.endosop_conc_asc == 1 ? 2 : 1)\">Concepto <span ng-class=\"{\'fa fa-sort-desc\': vm.endosop_conc_asc == 1, \'fa fa-sort-asc\': vm.endosop_conc_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoP(3, vm.endosop_nend_asc == 1 ? 2 : 1)\">Número de Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.endosop_nend_asc == 1, \'fa fa-sort-asc\': vm.endosop_nend_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoP(4, vm.endosop_form_asc == 1 ? 2 : 1)\">Formulario <span ng-class=\"{\'fa fa-sort-desc\': vm.endosop_form_asc == 1, \'fa fa-sort-asc\': vm.endosop_form_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoP(5, vm.endosop_npol_asc == 1 ? 2 : 1)\">Número de Póliza <span ng-class=\"{\'fa fa-sort-desc\': vm.endosop_npol_asc == 1, \'fa fa-sort-asc\': vm.endosop_npol_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoP(6, vm.endosop_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.endosop_cont_asc == 1, \'fa fa-sort-asc\': vm.endosop_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoP(7, vm.endosop_folio_asc == 1 ? 2 : 1)\">Folio del Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.endosop_folio_asc == 1, \'fa fa-sort-asc\': vm.endosop_folio_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoP(8, vm.endosop_fecha_asc == 1 ? 2 : 1)\">Fecha de Creación <span ng-class=\"{\'fa fa-sort-desc\': vm.endosop_fecha_asc == 1, \'fa fa-sort-asc\': vm.endosop_fecha_asc == 2}\"></span></th><th>Acciones</th></tr></thead><tbody><tr ng-if=\"endorsement.status == 1\" ng-repeat=\"endorsement in vm.endorsements track by $index\" ng-click=\"showInformationEndoso(endorsement)\"><td>{{ endorsement.endorsement_type }}</td><td>{{ endorsement.description }}</td><td>{{ endorsement.number_endorsement }}<p ng-if=\'endorsement.number_endorsement == \"\" || endorsement.number_endorsement == null\'>SIN NÚMERO ASIGNADO</p></td><td><p ng-if=\"endorsement.policy.subramo == 9\">AUTOMÓVILES</p><p ng-if=\"endorsement.policy.subramo == 1\">VIDA</p><p ng-if=\"endorsement.damage\">DAÑOS</p><p ng-if=\"endorsement.policy.subramo == 3\">ACCIDENTES</p></td><td>{{ endorsement.policy.poliza_number }}</td><td>{{ endorsement.policy.natural }} {{ endorsement.policy.juridical }}</td><td>{{ endorsement.folio_endorsement }}<p ng-if=\'endorsement.folio_endorsement == \"\" || endorsement.folio_endorsement == null\'>SIN FOLIO ASIGNADO</p></td><td>{{ endorsement.created_at | date: \'medium\'}}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(endorsement)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_endorsements && !vm.show_binnacle\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div></div></div></div></uib-tab><uib-tab heading=\"En trámite\" id=\"entramite\" ng-click=\"responsiv(); vm.change_tab(1,1,2)\"><div class=\"panel-body\"><div class=\"table-responsive\"><div class=\"project-list\"><table class=\"table table-stripped\"><thead><tr><th ng-click=\"vm.changeEndosoT(1, vm.endosot_type_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': vm.endosot_type_asc == 1, \'fa fa-sort-asc\': vm.endosot_type_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoT(2, vm.endosot_conc_asc == 1 ? 2 : 1)\">Concepto <span ng-class=\"{\'fa fa-sort-desc\': vm.endosot_conc_asc == 1, \'fa fa-sort-asc\': vm.endosot_conc_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoT(3, vm.endosot_nend_asc == 1 ? 2 : 1)\">Número de Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.endosot_nend_asc == 1, \'fa fa-sort-asc\': vm.endosot_nend_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoT(4, vm.endosot_form_asc == 1 ? 2 : 1)\">Formulario <span ng-class=\"{\'fa fa-sort-desc\': vm.endosot_form_asc == 1, \'fa fa-sort-asc\': vm.endosot_form_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoT(5, vm.endosot_npol_asc == 1 ? 2 : 1)\">Número de Póliza <span ng-class=\"{\'fa fa-sort-desc\': vm.endosot_npol_asc == 1, \'fa fa-sort-asc\': vm.endosot_npol_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoT(6, vm.endosot_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.endosot_cont_asc == 1, \'fa fa-sort-asc\': vm.endosot_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoT(7, vm.endosot_folio_asc == 1 ? 2 : 1)\">Folio de Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.endosot_folio_asc == 1, \'fa fa-sort-asc\': vm.endosot_folio_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoT(8, vm.endosot_fecha_asc == 1 ? 2 : 1)\">Fecha de Creación <span ng-class=\"{\'fa fa-sort-desc\': vm.endosot_fecha_asc == 1, \'fa fa-sort-asc\': vm.endosot_fecha_asc == 2}\"></span></th><th>Acciones</th></tr></thead><tbody><tr ng-if=\"endorsement.status == 5\" ng-repeat=\"endorsement in vm.endorsements track by $index\" ng-click=\"showInformationEndoso(endorsement)\"><td>{{ endorsement.endorsement_type }}</td><td>{{ endorsement.description }}</td><td>{{ endorsement.number_endorsement }}<p ng-if=\'endorsement.number_endorsement == \"\" || endorsement.number_endorsement == null\'>SIN NÚMERO ASIGNADO</p></td><td><p ng-if=\"endorsement.policy.subramo == 9\">AUTOMÓVILES</p><p ng-if=\"endorsement.policy.subramo == 1\">VIDA</p><p ng-if=\"endorsement.damage\">DAÑOS</p><p ng-if=\"endorsement.policy.subramo == 3\">ACCIDENTES</p></td><td>{{ endorsement.policy.poliza_number }}</td><td>{{ endorsement.policy.natural }} {{ endorsement.policy.juridical }}</td><td>{{ endorsement.folio_endorsement }}<p ng-if=\'endorsement.folio_endorsement == \"\" || endorsement.number_endorsement == null\'>SIN FOLIO ASIGNADO</p></td><td>{{ endorsement.created_at | date: \'dd/MM/yyyy\'}}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(endorsement)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_endorsements\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div></div></div></div></uib-tab><uib-tab heading=\"Registrados\" id=\"registrados\" ng-click=\"responsiv(); vm.change_tab(1,1,3)\"><div class=\"panel-body\"><div class=\"table-responsive\"><div class=\"project-list\"><table class=\"table table-stripped\"><thead><tr><th ng-click=\"vm.changeEndosoR(1, vm.endosor_type_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': vm.endosor_type_asc == 1, \'fa fa-sort-asc\': vm.endosor_type_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoR(2, vm.endosor_conc_asc == 1 ? 2 : 1)\">Concepto <span ng-class=\"{\'fa fa-sort-desc\': vm.endosor_conc_asc == 1, \'fa fa-sort-asc\': vm.endosor_conc_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoR(3, vm.endosor_nend_asc == 1 ? 2 : 1)\">Número de Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.endosor_nend_asc == 1, \'fa fa-sort-asc\': vm.endosor_nend_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoR(4, vm.endosor_form_asc == 1 ? 2 : 1)\">Formulario <span ng-class=\"{\'fa fa-sort-desc\': vm.endosor_form_asc == 1, \'fa fa-sort-asc\': vm.endosor_form_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoR(5, vm.endosor_npol_asc == 1 ? 2 : 1)\">Número de Póliza <span ng-class=\"{\'fa fa-sort-desc\': vm.endosor_npol_asc == 1, \'fa fa-sort-asc\': vm.endosor_npol_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoR(6, vm.endosor_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.endosor_cont_asc == 1, \'fa fa-sort-asc\': vm.endosor_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoR(7, vm.endosor_folio_asc == 1 ? 2 : 1)\">Folio de Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.endosor_folio_asc == 1, \'fa fa-sort-asc\': vm.endosor_folio_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoR(8, vm.endosor_fecha_asc == 1 ? 2 : 1)\">Fecha de Creación <span ng-class=\"{\'fa fa-sort-desc\': vm.endosor_fecha_asc == 1, \'fa fa-sort-asc\': vm.endosor_fecha_asc == 2}\"></span></th><th>Acciones</th></tr></thead><tbody><tr ng-if=\"endorsement.status == 2\" ng-repeat=\"endorsement in vm.endorsements track by $index\" ng-click=\"showInformationEndoso(endorsement)\"><td>{{ endorsement.endorsement_type }}</td><td>{{ endorsement.description }}</td><td>{{ endorsement.number_endorsement }}<p ng-if=\'endorsement.number_endorsement == \"\" || endorsement.number_endorsement == null\'>SIN NÚMERO ASIGNADO</p></td><td><p ng-if=\"endorsement.policy.subramo == 9\">AUTOMÓVILES</p><p ng-if=\"endorsement.policy.subramo == 1\">VIDA</p><p ng-if=\"endorsement.damage\">DAÑOS</p><p ng-if=\"endorsement.policy.subramo == 3\">ACCIDENTES</p></td><td>{{ endorsement.policy.poliza_number }}</td><td>{{ endorsement.policy.natural }} {{ endorsement.policy.juridical }}</td><td>{{ endorsement.folio_endorsement }}<p ng-if=\'endorsement.folio_endorsement == \"\" || endorsement.number_endorsement == null\'>SIN FOLIO ASIGNADO</p></td><td>{{ endorsement.created_at | date: \'dd/MM/yyyy\' }}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(endorsement)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_endorsements\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div></div></div></div></uib-tab><uib-tab heading=\"Rechazados\" id=\"rechazados\" ng-click=\"responsiv(); vm.change_tab(1,1,4)\"><div class=\"panel-body\"><div class=\"table-responsive\"><div class=\"project-list\"><table class=\"table table-stripped\"><thead><tr><th ng-click=\"vm.changeEndosoRec(1, vm.endosorc_type_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': vm.endosorc_type_asc == 1, \'fa fa-sort-asc\': vm.endosorc_type_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoRec(2, vm.endosorc_conc_asc == 1 ? 2 : 1)\">Concepto <span ng-class=\"{\'fa fa-sort-desc\': vm.endosorc_conc_asc == 1, \'fa fa-sort-asc\': vm.endosorc_conc_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoRec(3, vm.endosorc_nend_asc == 1 ? 2 : 1)\">Número de Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.endosorc_nend_asc == 1, \'fa fa-sort-asc\': vm.endosorc_nend_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoRec(4, vm.endosorc_form_asc == 1 ? 2 : 1)\">Formulario <span ng-class=\"{\'fa fa-sort-desc\': vm.endosorc_form_asc == 1, \'fa fa-sort-asc\': vm.endosorc_form_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoRec(5, vm.endosorc_npol_asc == 1 ? 2 : 1)\">Número de Póliza <span ng-class=\"{\'fa fa-sort-desc\': vm.endosorc_npol_asc == 1, \'fa fa-sort-asc\': vm.endosorc_npol_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoRec(6, vm.endosorc_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.endosorc_cont_asc == 1, \'fa fa-sort-asc\': vm.endosorc_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoRec(7, vm.endosorc_folio_asc == 1 ? 2 : 1)\">Folio del Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.endosorc_folio_asc == 1, \'fa fa-sort-asc\': vm.endosorc_folio_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoRec(8, vm.endosorc_fecha_asc == 1 ? 2 : 1)\">Fecha de Creación <span ng-class=\"{\'fa fa-sort-desc\': vm.endosorc_fecha_asc == 1, \'fa fa-sort-asc\': vm.endosorc_fecha_asc == 2}\"></span></th><th>Acciones</th></tr></thead><tbody><tr ng-if=\"endorsement.status == 3\" ng-repeat=\"endorsement in vm.endorsements track by $index\" ng-click=\"showInformationEndoso(endorsement)\"><td>{{ endorsement.endorsement_type }}</td><td>{{ endorsement.description }}</td><td>{{ endorsement.number_endorsement }}<p ng-if=\'endorsement.number_endorsement == \"\" || endorsement.number_endorsement == null\'>SIN NÚMERO ASIGNADO</p></td><td><p ng-if=\"endorsement.policy.subramo == 9\">AUTOMÓVILES</p><p ng-if=\"endorsement.policy.subramo == 1\">VIDA</p><p ng-if=\"endorsement.damage\">DAÑOS</p><p ng-if=\"endorsement.policy.subramo == 3\">ACCIDENTES</p></td><td>{{ endorsement.policy.poliza_number }}</td><td>{{ endorsement.policy.natural }} {{ endorsement.policy.juridical }}</td><td>{{ endorsement.folio_endorsement }}<p ng-if=\'endorsement.folio_endorsement == \"\" || endorsement.number_endorsement == null\'>SIN FOLIO ASIGNADO</p></td><td>{{ endorsement.created_at | date: \'dd/MM/yyyy\' }}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(endorsement)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_endorsements\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div></div></div></div></uib-tab><uib-tab heading=\"Cancelados\" id=\"endcancelados\" ng-click=\"responsiv(); vm.change_tab(1,1,5)\"><div class=\"panel-body\"><div class=\"table-responsive\"><div class=\"project-list\"><table class=\"table table-stripped\"><thead><tr><th ng-click=\"vm.changeEndosoC(1, vm.endosoc_type_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': vm.endosoc_type_asc == 1, \'fa fa-sort-asc\': vm.endosoc_type_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoC(2, vm.endosoc_conc_asc == 1 ? 2 : 1)\">Concepto <span ng-class=\"{\'fa fa-sort-desc\': vm.endosoc_conc_asc == 1, \'fa fa-sort-asc\': vm.endosoc_conc_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoC(3, vm.endosoc_nend_asc == 1 ? 2 : 1)\">Número de Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.endosoc_nend_asc == 1, \'fa fa-sort-asc\': vm.endosoc_nend_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoC(4, vm.endosoc_form_asc == 1 ? 2 : 1)\">Formulario <span ng-class=\"{\'fa fa-sort-desc\': vm.endosoc_form_asc == 1, \'fa fa-sort-asc\': vm.endosoc_form_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoC(5, vm.endosoc_npol_asc == 1 ? 2 : 1)\">Número de Póliza <span ng-class=\"{\'fa fa-sort-desc\': vm.endosoc_npol_asc == 1, \'fa fa-sort-asc\': vm.endosoc_npol_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoC(6, vm.endosoc_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.endosoc_cont_asc == 1, \'fa fa-sort-asc\': vm.endosoc_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoC(7, vm.endosoc_folio_asc == 1 ? 2 : 1)\">Folio del Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.endosoc_folio_asc == 1, \'fa fa-sort-asc\': vm.endosoc_folio_asc == 2}\"></span></th><th ng-click=\"vm.changeEndosoC(8, vm.endosoc_fecha_asc == 1 ? 2 : 1)\">Fecha de Creación <span ng-class=\"{\'fa fa-sort-desc\': vm.endosoc_fecha_asc == 1, \'fa fa-sort-asc\': vm.endosoc_fecha_asc == 2}\"></span></th><th>Acciones</th></tr></thead><tbody><tr ng-if=\"endorsement.status == 4\" ng-repeat=\"endorsement in vm.endorsements track by $index\" ng-click=\"showInformationEndoso(endorsement)\"><td>{{ endorsement.endorsement_type }}</td><td>{{ endorsement.description }}</td><td>{{ endorsement.number_endorsement }}<p ng-if=\'endorsement.number_endorsement == \"\" || endorsement.number_endorsement == null\'>SIN NÚMERO ASIGNADO</p></td><td><p ng-if=\"endorsement.policy.subramo == 9\">AUTOMÓVILES</p><p ng-if=\"endorsement.policy.subramo == 1\">VIDA</p><p ng-if=\"endorsement.damage\">DAÑOS</p><p ng-if=\"endorsement.policy.subramo == 3\">ACCIDENTES</p></td><td>{{ endorsement.policy.poliza_number }}</td><td>{{ endorsement.policy.natural }} {{ endorsement.policy.juridical }}</td><td>{{ endorsement.folio_endorsement }}<p ng-if=\'endorsement.folio_endorsement == \"\" || endorsement.number_endorsement == null\'>SIN FOLIO ASIGNADO</p></td><td>{{ endorsement.created_at | date: \'dd/MM/yyyy\' }}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(endorsement)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_endorsements\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div></div></div></div></uib-tab></uib-tabset><button ng-click=\"exportData(\'Endosos\')\" class=\"btn btn-primary btn-mt\">Generar Reporte</button></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle\"><div class=\"col-md-12\"><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data\" typemodel=\"10\" config=\"vm.comments_config\" idmodel=\"vm.endorsement_id\" exportable=\"true\"></comments></div><div class=\"col-md-12\"><button class=\"btn btn-primary\" ng-click=\"vm.returnToEndorsement()\"><span class=\"fa fa-arrow-left\"></span> Regresar</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/endosos/endosos.pendingInfoMassive.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"endosos.pending\">Listado de endosos</a></li><li class=\"active\"><strong>{{vm.endorsement.id}}</strong></li></ol></div></div><br><div class=\"btn-group pull-right option_button\"><button type=\"button\" class=\"btn no-mb btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.goToPolicy(forms.id)\">Ver póliza</a></li><li><a ng-click=\"vm.getPDF(vm.endorsement.id, vm.policy.id)\">Ver PDF</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, carta.id)\">{{carta.name}}</a></li></ul></li></ul></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información del endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><h3>Estatus del endoso:</h3><div ng-bind=\"vm.endorsement.status | endorsement\" class=\"label\" ng-class=\"{\'label-success\': vm.endorsement.status == 2, \'label-info\' : vm.endorsement.status == 5,\'label-primary\' : vm.endorsement.status == 1, \'label-warning\' : vm.endorsement.status == 3 || vm.endorsement.status == 4}\" style=\"float: left; margin-right: 10px\"></div></div><div class=\"col-sm-12\"><h4>Tipo de endoso: {{ vm.endorsement.endorsement_type }}</h4></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><button class=\"btn btn-primary\" ng-disabled=\"vm.endorsement.status === 2 || vm.endorsement.status === 3 || vm.endorsement.status === 4\" ng-click=\"changeStatusColectivity()\">Cambiar Estatus</button></div></div><hr><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Póliza</legend><div class=\"col-xs-12 col-md-8 col-lg-6 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ vm.contractor.name }}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{ vm.policy.poliza_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Folio del Endoso:</span><div><span>{{ vm.endorsement.folio_endorsement }}</span> <span ng-if=\"!vm.endorsement.folio_endorsement\">Sin Folio</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Número de Endoso:</span><div><span>{{ vm.endorsement.number_endorsement }}</span> <span ng-if=\"!vm.endorsement.number_endorsement\">Sin Número</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Vigencia de la póliza:</span><div><span>{{ vm.policy.start_of_validity | date: \'dd/MM/yyyy\'}} - {{vm.policy.end_of_validity | date: \'dd/MM/yyyy\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Estatus de la Póliza:</span><div><span>{{ vm.policy.status }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Estatus del Endoso:</span><div><span>{{ vm.endorsement.status | endorsement }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Forma de Pago:</span><div><span>{{ vm.policy.forma_de_pago | payformtype }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ vm.policy.aseguradora.alias }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.policy.subramo.subramo_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\"><b>Creado por:</b></span><div><span>{{ vm.policy.owner }}</span></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\" ng-if=\"vm.subforms && !vm.alta_ben_only\"><div class=\"ibox-title\"><h5>Certificados</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-8\"><h4>Vida</h4><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in vm.subforms track by $index\"><input class=\"pull-right\" type=\"checkbox\" ng-disabled=\"vm.endorsement.status == \'2\' || vm.endorsement.status == \'3\' || vm.endorsement.status == \'4\'\" ng-checked=\"checkSelected(item.id)\" ng-click=\"addCertificate(item.id)\"> <b>No. certificado:</b><div ng-if=\"item.certificate_number\">{{item.certificate_number + \" - \"}}</div><div ng-if=\"!item.certificate_number\">Sin # certificado -</div><b>Titular:</b>{{item.personal.first_name + \" \" + item.personal.last_name + \" \" + item.personal.second_last_name +\" - \"}} <b>Beneficiarios:</b> <span ng-repeat=\"beneficiary in item.beneficiaries_life\">{{beneficiary.first_name + \" \" + beneficiary.last_name}} -</span></li></ul></div><div class=\"col-xs-12 col-md-8\"><h4>Daños</h4><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in vm.subforms track by $index\"><input class=\"pull-right\" type=\"checkbox\" ng-checked=\"checkSelected(item.id)\" ng-click=\"addCertificate(item.id)\"> <b>No. certificado:</b>{{item.certificate_number}} <b>Bien asegurado:</b>{{item.insured_item}} <b>Detalles:</b>{{item.item_details}}</li></ul></div><div class=\"col-xs-12 col-md-8\"><h4>Gastos Médicos</h4><ul class=\"list-group col-xs-12\"><li class=\"list-group-item\" ng-repeat=\"item in vm.subforms track by $index\"><input class=\"pull-right\" type=\"checkbox\" ng-checked=\"checkSelected(item.id)\" ng-click=\"addCertificate(item.id)\"> <b>No. certificado:</b>{{item.certificate_number + \" - \"}} <b>Asegurado:</b>{{item.personal.first_name + \" \" + item.personal.last_name + \" \" + item.personal.second_last_name + \" - \"}} <b>Beneficiarios:</b> <span ng-repeat=\"beneficiary in item.relationship_accident\">{{beneficiary.first_name + \" \" + beneficiary.last_name}} -</span></li></ul></div><div class=\"col-xs-12 col-md-8\"><h4>Automovil</h4><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in vm.subforms track by $index\"><input class=\"pull-right\" type=\"checkbox\" ng-checked=\"checkSelected(item.id)\" ng-click=\"addCertificate(item.id)\"> <b>No. certificado:</b>{{item.certificate_number + \" - \"}} <b>General:</b> {{item.brand + \" \" + item.model + \" \" + item.version + \" \" + item.year + \" \" + item.color}}</li></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.endorsement.description == \'CAMBIO DE FORMA DE PAGO\'\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de Póliza</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Recibo</th><th>Estatus</th><th>Prima Neta</th><th>Recargo por Pago Fraccionado</th><th>Derecho</th><th>IVA</th><th>Sub Total</th><th>Prima Total</th><th>Inicio de Vigencia</th><th>Fin de Vigencia</th></tr></thead><tbody><tr ng-if=\"receipt.receipt_type == 1\" ng-repeat=\"receipt in vm.receipts track by $index\" ng-click=\"vm.changeStatusModal(receipt, vm.contractor)\"><td ng-bind=\"receipt.recibo_numero\"></td><td status-receipt=\"{{receipt.status}}\"></td><td>{{receipt.prima_neta | currency}}</td><td>{{receipt.rpf | currency}}</td><td>{{receipt.derecho | currency}}</td><td>{{receipt.iva | currency}}</td><td>{{receipt.sub_total | currency}}</td><td>{{receipt.prima_total | currency}}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\'}}</td><td>{{receipt.fecha_fin | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.endorsement.description == \'CAMBIO DE FORMA DE PAGO\'\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de Endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Recibo</th><th>Estatus</th><th>Prima Neta</th><th>Recargo por Pago Fraccionado</th><th>Derecho</th><th>IVA</th><th>Sub Total</th><th>Prima Total</th><th>Inicio de Vigencia</th><th>Fin de Vigencia</th></tr></thead><tbody><tr ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"vm.endorsement.status == 2\"><td ng-bind=\"receipt.recibo_numero\"></td><td status-receipt=\"{{receipt.status}}\"></td><td>{{receipt.prima_neta | currency}}</td><td>{{receipt.rpf | currency}}</td><td>{{receipt.derecho | currency}}</td><td>{{receipt.iva | currency}}</td><td>{{receipt.sub_total | currency}}</td><td>{{receipt.prima_total | currency}}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\'}}</td><td>{{receipt.fecha_fin | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.endorsement.status == 2 && vm.endorsement.endorsement_type == \'D\'\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de nota de crédito</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Recibo</th><th>Prima Neta</th><th>Recargo por Pago Fraccionado</th><th>IVA</th><th>Prima Total</th></tr></thead><tbody><tr ng-repeat=\"receipt in vm.notas track by $index\" ng-click=\"vm.NotasModal(receipt, vm.contractor_name,vm.endorsement)\"><td ng-bind=\"receipt.folio\"></td><td>{{receipt.prima_neta | currency}}</td><td>{{receipt.rpf | currency}}</td><td>{{receipt.iva | currency}}</td><td>{{receipt.prima_total | currency}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/show-files.html\'\"></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"10\" idmodel=\"vm.endorsementId\"></comments></div></div></div></div></div></div>");
$templateCache.put("app/endosos/endosos.pendingInformation.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"endosos.pending\">Listado de endosos</a></li><li class=\"active\"><strong>{{vm.endorsement.id}}</strong></li></ol></div></div><br><div class=\"btn-group pull-right option_button\"><button type=\"button\" class=\"btn no-mb btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.goToPolicy(forms)\">Ver póliza</a></li><li><a ng-click=\"vm.goToEdit(forms.id,vm.endorsement)\">Editar</a></li><li><a ng-click=\"vm.getPDF(vm.endorsement.id, vm.policy.id)\">Ver PDF</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length && view_cartas\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, carta.id)\">{{carta.name}}</a></li></ul></li></ul></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información del endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><h3>Estatus del endoso:</h3><div ng-bind=\"vm.endorsement.status | endorsement\" class=\"label\" ng-class=\"{\'label-success\': vm.endorsement.status == 2, \'label-info\' : vm.endorsement.status == 5,\'label-primary\' : vm.endorsement.status == 1, \'label-warning\' : vm.endorsement.status == 3 || vm.endorsement.status == 4}\" style=\"float: left; margin-right: 10px\"></div></div><div class=\"col-sm-12\"><h4>Tipo de endoso: {{vm.endorsement.endorsement_type}}</h4></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><button class=\"btn btn-primary\" ng-disabled=\"vm.endorsement.status === 2 || vm.endorsement.status === 3 || vm.endorsement.status === 4\" ng-click=\"vm.options.changeStatus()\">Cambiar Estatus</button></div></div><hr><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><legend class=\"legend-title\" align=\"center\">Póliza</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Contratante:</span><div><span>{{vm.contractor_name}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{vm.policy.poliza_number}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Folio del Endoso:</span><div><span>{{vm.endorsement.folio_endorsement}}</span> <span ng-if=\"!vm.endorsement.folio_endorsement\">Sin Folio</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Número de Endoso:</span><div><span>{{vm.endorsement.number_endorsement}}</span> <span ng-if=\"!vm.endorsement.number_endorsement\">Sin Número</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Vigencia de la póliza:</span><div><span>{{vm.policy.start_of_validity | date: \'dd/MM/yyyy\'}} - {{vm.policy.end_of_validity | date: \'dd/MM/yyyy\'}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Estatus de la Póliza:</span><div><span>{{vm.policy.status | policystatus}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Estatus del Endoso:</span><div><span>{{vm.endorsement.status | endorsement}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{forma_pago(vm.policy.forma_de_pago)}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{vm.policy_aseguradora}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Subramo:</span><div><span>{{vm.policy.subramo.subramo_name}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Paquete:</span><div><span>{{vm.policy.paquete.package_name}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Creado por:</span><div><span>{{vm.endorsement.owner}}</span></div></div></div><div class=\"col-xs-12 col-md-6\" ng-show=\"vm.subforms.show === 1\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Concepto:</span><div><span>{{vm.endorsement.description}}</span> <span>&nbsp;</span></div></div></div><div class=\"col-xs-12 col-md-6\" ng-show=\"vm.subforms.show === 1\"><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Descripción:</span><div><span>{{vm.endorsement.other_desc}}</span> <span>&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\" ng-if=\"vm.edit_endorsement == false\"><span class=\"blue-color\">Vigencia del endoso:</span><div><span>{{vm.form.start_of_validity | date: \'dd/MM/yyyy\'}} - {{vm.form.end_of_validity | date: \'dd/MM/yyyy\'}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Marca:</span><div><span>{{vm.subforms.brand}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Modelo:</span><div><span>{{vm.subforms.model}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Año:</span><div><span>{{vm.subforms.year}}</span> <span ng-if=\"!vm.subforms.year\">&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Versión:</span><div><span>{{vm.subforms.version}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Serie:</span><div><span>{{vm.subforms.serial}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Motor:</span><div><span>{{vm.subforms.engine}}</span> <span ng-if=\"!vm.subforms.engine\">&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Color:</span><div><span>{{vm.subforms.color}}</span> <span ng-if=\"!vm.subforms.color\">&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Placas:</span><div><span>{{vm.subforms.license_plates}}</span> <span ng-if=\"!vm.subforms.license_plates\">&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Observaciones:</span><div><span>{{vm.endorsement.observations}}</span></div></div></div><div class=\"col-xs-12 col-md-6\" ng-show=\"vm.subforms.show === 2\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Concepto:</span><div><span>{{vm.endorsement.description}}</span> <span>&nbsp;</span></div><div><span>{{vm.endorsement.other_desc}}</span> <span>&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Bien Asegurado:</span><div><span>{{vm.subforms.insured_item}}</span> <span ng-if=\"!vm.subforms.insured_item\">&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Detalles:</span><div><span>{{vm.subforms.item_details}}</span> <span ng-if=\"!vm.subforms.item_details\">&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Dirección:</span><div><span>{{vm.subforms.item_address}}</span> <span ng-if=\"!vm.subforms.item_address\">&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Observaciones:</span><div><span>{{vm.endorsement.policy.observations}}</span></div></div></div><div class=\"col-xs-12 col-sm-6\" ng-show=\"vm.subforms.show === 0\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Concepto:</span><div><span>{{vm.endorsement.description}}</span> <span>&nbsp;</span></div><div><span>{{vm.endorsement.other_desc}}</span> <span>&nbsp;</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Vigencia:</span><div><span>{{vm.form.start_of_validity | date: \'dd/MM/yyyy\'}} - {{vm.form.end_of_validity | date: \'dd/MM/yyyy\'}}</span></div></div><div class=\"col-xs-12\"><h4>Asegurado</h4></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Nombre:</span><div><span>{{vm.subforms.personal.full_name}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{vm.subforms.personal.birthdate | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"!vm.subforms.personal.birthdate\">&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"vm.subforms.personal.sex == \'F\'\">FEMENINO</span> <span ng-if=\"vm.subforms.personal.sex == \'M\'\">MASCULINO</span> <span ng-if=\"!vm.subforms.personal.sex\">&nbsp;</span></div></div><div class=\"form-group col-xs-12\"><h4>Dependientes</h4><div ng-repeat=\"relationship in vm.subforms.relationship_accident\"><span class=\"blue-color\">Nombre:</span> <span>{{relationship.full_name}}</span><br><span class=\"blue-color\">Parentesco:</span> <span ng-if=\"relationship.relationship == 1\">TITULAR</span> <span ng-if=\"relationship.relationship == 2\">CONYUGE</span> <span ng-if=\"relationship.relationship == 3\">HIJO</span> <span ng-if=\"relationship.relationship == 4\">OTRO</span><br><span class=\"blue-color\">Fecha de Nacimiento:</span> <span>{{relationship.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:</span> <span ng-if=\"relationship.sex == \'F\'\">FEMENINO</span> <span ng-if=\"relationship.sex == \'M\'\">MASCULINO</span><br><br></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Observaciones:</span><div><span>{{vm.endorsement.policy.observations}}</span></div></div></div><div class=\"col-xs-12 col-md-6\" ng-show=\"vm.subforms.show === 3\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Concepto:</span><div><span>{{vm.endorsement.description}}</span> <span>&nbsp;</span></div><div><span>{{vm.endorsement.other_desc}}</span> <span>&nbsp;</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Vigencia:</span><div><span>{{vm.form.start_of_validity | date: \'dd/MM/yyyy\'}} - {{vm.form.end_of_validity | date: \'dd/MM/yyyy\'}}</span></div></div><div class=\"col-xs-12\"><h4>Asegurado</h4></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Nombre:</span><div><span>{{vm.subforms.personal.full_name}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{vm.subforms.personal.birthdate | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"!vm.subforms.personal.birthdate\">&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Sexo:</span><div><span ng-if=\"vm.subforms.personal.sex == \'F\'\">FEMENINO</span> <span ng-if=\"vm.subforms.personal.sex == \'M\'\">MASCULINO</span> <span ng-if=\"!vm.subforms.personal.sex\">&nbsp;</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Fumador:</span><div><span ng-if=\"vm.subforms.smoker == true\">SI</span> <span ng-if=\"vm.subforms.smoker == false\">NO</span></div></div><div class=\"form-group col-xs-12\"><h4>Beneficiarios</h4><div ng-repeat=\"relationship in vm.subforms.beneficiaries_life\"><span class=\"blue-color\">Nombre:</span> <span>{{relationship.full_name}}</span><br><span class=\"blue-color\">Parentesco:</span> <span>{{relationship.optional_relationship}}</span><br><span class=\"blue-color\">Fecha de Nacimiento:</span> <span>{{relationship.birthdate | date: \'dd/MM/yyyy\'}}</span><br><span class=\"blue-color\">Sexo:</span> <span ng-if=\"relationship.sex == \'F\'\">FEMENINO</span> <span ng-if=\"relationship.sex == \'M\'\">MASCULINO</span><br><span class=\"blue-color\">Porcentaje:</span> <span>{{relationship.percentage}}%</span><br><br></div></div><div class=\"form-group col-xs-12 col-sm-6 col-lg-4\"><span class=\"blue-color\">Observaciones:</span><div><span>{{vm.endorsement.policy.observations}}</span></div></div></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.edit_endorsement == true\"><label>Vigencia desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.start_of_validity\" ng-change=\"changeUntil()\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.edit_endorsement == true\"><label>Vigencia hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_of_validity\" data-date-format=\"dd/MM/yyyy\" disabled=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 desc-border m-t form-group\"><legend class=\"legend-title blue-color\">Cambio a realizar:</legend><span ng-if=\"vm.endorsement.description == \'OTRO\'\">{{vm.endorsement.other_desc}}</span> <span ng-if=\"!(vm.endorsement.description == \'OTRO\')\">{{vm.endorsement.description}}</span><br>{{vm.endorsement.observations}}</div></div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Coberturas</legend><table class=\"table table-bordered table-hover\"><thead><tr><th>Cobertura</th><th>Suma Asegurada</th><th>Deducible</th><th ng-show=\"vm.subforms.show === 0\">Coaseguro</th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.defaults.coverages\"><td>{{coverage.coverage_name}}</td><td>{{coverage.sum_insured}}</td><td>{{coverage.deductible}}</td><td ng-show=\"vm.subforms.show === 0\">{{coverage.coinsurance}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.endorsement.description == \'CAMBIO DE FORMA DE PAGO\'\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de Póliza</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Recibo</th><th>Prima Neta</th><th>Recargo por Pago Fraccionado</th><th>Derecho</th><th>IVA</th><th>Sub Total</th><th>Prima Total</th><th>Inicio de Vigencia</th><th>Fin de Vigencia</th></tr></thead><tbody><tr ng-click=\"vm.changeStatusModal(receipt, vm.contractor_name,vm.endorsement)\" ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.receipt_type == 1\"><td ng-bind=\"receipt.recibo_numero\"></td><td>{{receipt.prima_neta | currency}}</td><td>{{receipt.rpf | currency}}</td><td>{{receipt.derecho | currency}}</td><td>{{receipt.iva | currency}}</td><td>{{receipt.sub_total | currency}}</td><td>{{receipt.prima_total | currency}}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\'}}</td><td>{{receipt.fecha_fin | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.endorsement.status == 2 && vm.endorsement.endorsement_type == \'A\'\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de Endoso</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Recibo</th><th>Estatus</th><th>Prima Neta</th><th>Recargo por Pago Fraccionado</th><th>Derecho</th><th>IVA</th><th>Sub Total</th><th>Prima Total</th><th>Inicio de Vigencia</th><th>Fin de Vigencia</th></tr></thead><tbody><tr ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.receipt_type == 2\" ng-click=\"vm.changeStatusModal(receipt, vm.contractor_name,vm.endorsement)\"><td ng-bind=\"receipt.recibo_numero\"></td><td status-receipt=\"{{receipt.status}}\"></td><td>{{receipt.prima_neta | currency}}</td><td>{{receipt.rpf | currency}}</td><td>{{receipt.derecho | currency}}</td><td>{{receipt.iva | currency}}</td><td>{{receipt.sub_total | currency}}</td><td>{{receipt.prima_total | currency}}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\'}}</td><td>{{receipt.fecha_fin | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.endorsement.status == 2 && vm.endorsement.endorsement_type == \'D\'\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de nota de crédito</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Recibo</th><th>Prima Neta</th><th>Recargo por Pago Fraccionado</th><th>IVA</th><th>Prima Total</th></tr></thead><tbody><tr ng-repeat=\"receipt in vm.notas track by $index\" ng-click=\"vm.NotasModal(receipt, vm.contractor_name,vm.endorsement)\"><td ng-bind=\"receipt.folio\"></td><td>{{receipt.prima_neta | currency}}</td><td>{{receipt.rpf | currency}}</td><td>{{receipt.iva | currency}}</td><td>{{receipt.prima_total | currency}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/show-files.html\'\"></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"10\" idmodel=\"vm.endorsementId\"></comments></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-2 col-lg-2 pull-right\" ng-if=\"vm.edit_endorsement == true\"><div class=\"form-group col-md-12 pull-right margin-top-17\"><button type=\"button\" ng-click=\"vm.saveEdit(vm.endorsement)\" class=\"btn btn-block btn-info margin-top-17\">Guardar cambios</button></div></div><div class=\"col-xs-12 col-md-2 col-lg-2 pull-right\" ng-if=\"vm.edit_endorsement == true\"><div class=\"form-group col-md-12 pull-right margin-top-17\"><button type=\"button\" ng-click=\"vm.cancelEdit()\" class=\"btn btn-block btn-primary margin-top-17\">Cancelar cambios</button></div></div></div>");
$templateCache.put("app/endosos/endosos.plantillas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Plantillas de Endosos</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createQuotation()\">Agregar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"col-xs-12 btn btn-secondary m-t\" ng-click=\"cambiarCampos()\">Campos en el Correo</button></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"showQuotation\" style=\"margin-left: 25px;padding-right: 75px;\"><legend ng-if=\"!showEditInformation\" class=\"legend-title\" align=\"center\">Nueva Plantilla</legend><legend ng-if=\"showEditInformation\" class=\"legend-title\" align=\"center\">Actualizar Plantilla</legend><form class=\"row\" name=\"form\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre de la Plantilla <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"plantilla.name\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Asunto <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"plantilla.title\"></div><button type=\"button\" class=\"btn btn-default ng-scope pull-right\" unselectable=\"on\" tabindex=\"-1\" ng-click=\"getFile()\" ng-disabled=\"!editor_focus\"><i class=\"fa fa-upload\"></i></button><div class=\"col-xs-12 form-group\"><label>Texto Superior <span class=\"color-red\">*</span></label><div text-angular=\"\" ng-model=\"plantilla.text\" name=\"myEditorCreate\" ng-focus=\"focusEditor()\" ng-blur=\"unfocusEditor()\"></div></div><div class=\"col-xs-12 form-group\"><label>Texto Inferior <span class=\"color-red\">*</span></label><div text-angular=\"\" ng-model=\"plantilla.bottom_text\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button ng-if=\"!showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"saveDelivery(plantilla)\">Crear Plantilla</button> <button ng-if=\"showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"updateDelivery(plantilla)\">Actualizar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeQuotation()\">Cancelar</button></div></form></div></div></div><div class=\"ibox\" ng-if=\"configurar\"><div class=\"ibox-title-c bg-light-gray clearfix\"><h3 class=\"section-title\" style=\"text-align: center;\">Configuración de Visualización en Correo</h3><span class=\"pull-right\" ng-click=\"cambiarCampos()\" style=\"cursor: pointer; color: #888;\" title=\"Cerrar sección\"><i class=\"fa fa-times fa-lg\"></i></span></div><div class=\"ibox-content-c row\"><form class=\"form-inline\"><div class=\"row\"><div class=\"col-sm-3 value-email\"><div class=\"checkbox checkbox-inline-c\"><label><input id=\"fecha_limite_email_cobranza\" type=\"checkbox\" ng-model=\"configuracionGlobal.fecha_limite_email_cobranza\" ng-change=\"changeFechaLimiteEmail(configuracionGlobal.fecha_limite_email_cobranza)\"> Fecha límite de pago</label></div></div><div class=\"col-sm-3 value-email\"><div class=\"checkbox checkbox-inline-c\"><label><input id=\"boton_segumovil\" type=\"checkbox\" ng-model=\"configuracionGlobal.boton_segumovil\" ng-change=\"changeButtonSegumovilEmail(configuracionGlobal.boton_segumovil)\"> Botón Segumóvil</label></div></div><div class=\"col-sm-3 value-email\" ng-repeat=\"campo in [ { id: \'dato_contratante\', label: \'Contratante\', key: \'contratante\' }, { id: \'dato_numero_poliza\', label: \'Número de póliza\', key: \'no_poliza\' }, { id: \'dato_concepto\', label: \'Concepto\', key: \'concepto\' }, { id: \'dato_aseguradora\', label: \'Aseguradora\', key: \'aseguradora\' }, { id: \'dato_subramo\', label: \'Subramo\', key: \'subramo\' }, { id: \'dato_serie\', label: \'Serie\', key: \'serie\' }, { id: \'dato_total\', label: \'Total\', key: \'total\' }, { id: \'copia_user_envio\', label: \'Copiar al remitente en envíos manuales de cobranza\', key: \'copia_user_envio\' } ]\"><div class=\"checkbox checkbox-inline-c\"><label><input type=\"checkbox\" id=\"{{campo.id}}\" ng-model=\"configuracionGlobal[campo.id]\" ng-change=\"cambiarDato(campo.id, configuracionGlobal[campo.id])\"> {{campo.label}}</label></div></div></div></form></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Plantillas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\" ng-hide=\"showInfoQuotation\"><table class=\"table table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th>ID</th><th>Nombre</th><th>Asunto</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"item in vm.quotations track by $index\" ng-click=\"showInformation(item)\"><td>{{ item.id }}</td><td>{{ item.name }}</td><td>{{ item.title }}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-sm btn-white\" ng-click=\"editQuatation(item)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"show_pagination\" class=\"text-center\"><pagination config=\"vm.config_pagination\" model=\"vm.quotations\"></pagination></div></div><div class=\"animate\" ng-if=\"showInfoQuotation\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showInformation(null)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Name:</span><div><span>{{ quotation.name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Asunto:</span><div><span>{{ quotation.title }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Texto Superior:</span><div><span>{{ quotation.text }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Texto Inferior:</span><div><span>{{ quotation.bottom_text }}</span></div></div></div></div></div></div>");
$templateCache.put("app/endosos/endosos.receipts.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Recibo {{vmmm.endorsement.recibo_numero}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"form-group col-md-6\"><label>Prima neta: $</label> <input class=\"form-control\" format-as-currency=\"\" disabled=\"\" ng-model=\"vmmm.endorsement.prima_neta\" step=\"any\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Recargo por Pago Fraccionado: $</label> <input class=\"form-control\" format-as-currency=\"\" disabled=\"\" ng-model=\"vmmm.endorsement.rpf\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Derecho: $</label> <input class=\"form-control\" format-as-currency=\"\" disabled=\"\" ng-model=\"vmmm.endorsement.derecho\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>IVA (%):</label> <input class=\"form-control\" disabled=\"\" ng-model=\"vmmm.endorsement.iva\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Sub Total: $</label> <input class=\"form-control\" format-as-currency=\"\" disabled=\"\" ng-model=\"vmmm.endorsement.sub_total\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Prima Total: $</label> <input class=\"form-control\" format-as-currency=\"\" disabled=\"\" ng-model=\"vmmm.endorsement.prima_total\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Fecha de inicio</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" ng-model=\"vmmm.endorsement.fecha_inicio\" view=\"year\" disabled=\"\"></div></div><div class=\"form-group col-md-6\"><label>Fecha de fin</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" ng-model=\"vmmm.endorsement.fecha_fin\" view=\"year\" disabled=\"\"></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"vmmm.options.cancel()\" type=\"button\">Cerrar</button></div></div>");
$templateCache.put("app/endosos/endosos.status.collectivity.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Cambiar estatus</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"form-group col-sm-6\"><label for=\"selectType\">Tipo de endoso</label><br><label for=\"\">Estatus:</label><div ng-bind=\"vmm.endorsement.status | endorsement\" class=\"label\" ng-class=\"{\'label-success\': vmm.endorsement.status == 2, \'label-info\' : vmm.endorsement.status == 5,\'label-primary\' : vmm.endorsement.status == 1, \'label-warning\' : vmm.endorsement.status == 3 || vmm.endorsement.status == 4}\"></div><select class=\"form-control m-b\" ng-model=\"vmm.selectedType\" ng-options=\"s as s.label for s in vmm.status track by s.value\" ng-change=\"vmm.enableSave()\"><option disabled=\"\" value=\"\">Selecciona un estatus</option></select></div></div><br><div class=\"row\"><div ng-show=\"vmm.folio\" class=\"form-group col-sm-6\"><label for=\"\">Folio de Endoso -----</label> <input class=\"form-control\" ng-model=\"vmm.form.folio\"></div></div><div ng-if=\"vmm.selectedType.value == 2 && vmm.endorsement.endorsement_type === \'A\'\"><div class=\"row\"><div class=\"form-group col-sm-6\"><label for=\"\">No. Endoso</label> <input type=\"text\" ng-model=\"vmm.number_endorsement\" class=\"form-control\"></div></div><div id=\"divConfigDerechoEndoso\" class=\"checkbox\"><label><input id=\"configDerechoEndoso\" type=\"checkbox\" ng-model=\"configDerecho\">Derecho - Cargos sólo al primer recibo.</label></div><div id=\"divConfigRPFEndoso\" class=\"checkbox\"><label><input id=\"configRPFEndoso\" type=\"checkbox\" ng-model=\"configRPF\">RPF - Cargos sólo al primer recibo.</label></div><div id=\"divConfigIVA\" class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vmm.statusIva\" ng-change=\"vmm.changeIva(vmm.statusIva)\">IVA - Generar el endoso con IVA.</label></div><br><div class=\"col-sm-6 form-group\"><label>Prima neta del endoso: $</label> <input value=\"\" class=\"form-control\" id=\"prima-neta\" ng-model=\"vmm.prima_neta\" format-as-currency=\"\"></div><div class=\"col-sm-6 form-group\"><label>RPF del endoso: $</label> <input value=\"\" class=\"form-control\" id=\"rpf\" ng-model=\"vmm.rpf\" format-as-currency=\"\"></div><div class=\"col-sm-6 form-group\"><label>Derecho de endoso: $</label> <input value=\"\" class=\"form-control\" id=\"derecho\" ng-model=\"vmm.derecho\" format-as-currency=\"\"></div><div class=\"col-sm-6 form-group\"><label>Sub-Total del endoso: $</label> <input value=\"\" class=\"form-control\" id=\"sub-total\" ng-model=\"vmm.sub_total\" placeholder=\"\" disabled=\"\" format-as-currency=\"\"></div><div class=\"col-sm-6 form-group\"><label>Prima Total del endoso:$</label> <input value=\"\" class=\"form-control\" id=\"prima-total\" ng-model=\"vmm.prima_total\" placeholder=\"\" disabled=\"\" format-as-currency=\"\"></div><hr><button class=\"ladda-button ladda-button-demo btn btn-success\" ng-click=\"vmm.updateField()\" id=\"calcularB\" type=\"button\">Calcular recibos</button><hr><div class=\"col-sm-6 col-xs-12\" ng-repeat=\"receipt in vmm.endorsement.policy.recibos_poliza track by $index | orderBy: \'-recibo_numero\': true\" ng-if=\"receipt.receipt_type == 2\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Recibo # {{receipt.recibo_numero}}</div><div class=\"panel-body\"><div class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Prima neta: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.prima_neta\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">RPF: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.rpf\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Derecho: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.derecho\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">IVA: $</label><div class=\"col-sm-8\"><input class=\"form-control\" disabled=\"\" ng-model=\"receipt.iva\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Sub Total: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.sub_total\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Prima Total: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.prima_total\" format-as-currenc=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de inicio</label><div class=\"col-sm-8\"><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"receipt.fecha_inicio\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de fin</label><div class=\"col-sm-8\"><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"receipt.fecha_fin\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div></div></div></div></div></div></div><div ng-if=\"vmm.selectedType.value == 2 && vmm.endorsement.endorsement_type === \'D\'\"><div class=\"row\"><div class=\"form-group col-sm-6\"><label for=\"\">No. Endoso</label> <input type=\"text\" ng-model=\"vmm.number_endorsement\" class=\"form-control\"></div></div><div id=\"divConfigIVA\" class=\"checkbox\"><label>Nota de crédito</label></div><br><div class=\"col-sm-6 form-group\"><label>Prima neta del endoso: $</label> <input value=\"\" class=\"form-control\" id=\"prima-neta\" ng-model=\"vmm.prima_neta\" format-as-currency=\"\"></div><div class=\"col-sm-6 form-group\"><label>RPF del endoso: $</label> <input value=\"\" class=\"form-control\" id=\"rpf\" ng-model=\"vmm.rpf\" format-as-currency=\"\"></div><div class=\"col-sm-6 form-group\"><label>Derecho de endoso: $</label> <input value=\"\" class=\"form-control\" id=\"derecho\" ng-model=\"vmm.derecho\" format-as-currency=\"\"></div><div class=\"col-sm-6 form-group\"><label>Sub-Total del endoso: $</label> <input value=\"\" class=\"form-control\" id=\"sub-total\" ng-model=\"vmm.sub_total\" placeholder=\"\" disabled=\"\" format-as-currency=\"\"></div><div class=\"col-sm-6 form-group\"><label>Prima Total del endoso:$</label> <input value=\"\" class=\"form-control\" id=\"prima-total\" ng-model=\"vmm.prima_total\" placeholder=\"\" disabled=\"\" format-as-currency=\"\"></div><hr><button class=\"ladda-button ladda-button-demo btn btn-success\" ng-click=\"vmm.updateField()\" id=\"calcularB\" type=\"button\">Calcular recibos</button><hr><div class=\"col-sm-6 col-xs-12\" ng-repeat=\"receipt in vmm.endorsement.policy.recibos_poliza track by $index | orderBy: \'-recibo_numero\': true\" ng-if=\"receipt.receipt_type == 2\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Recibo # {{receipt.recibo_numero}}</div><div class=\"panel-body\"><div class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Prima neta: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.prima_neta\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">RPF: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.rpf\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Derecho: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.derecho\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">IVA: $</label><div class=\"col-sm-8\"><input class=\"form-control\" disabled=\"\" ng-model=\"receipt.iva\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Sub Total: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.sub_total\" format-as-currency=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Prima Total: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.prima_total\" format-as-currenc=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de inicio</label><div class=\"col-sm-8\"><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"receipt.fecha_inicio\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de fin</label><div class=\"col-sm-8\"><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"receipt.fecha_fin\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-success\" ng-disabled=\"vmm.form.folio.length === 0 && vmm.folio == true\" ng-click=\"vmm.options.save()\" type=\"button\">Crear</button> <button class=\"btn btn-white\" ng-click=\"vmm.options.cancel()\" type=\"button\">Cerrar</button></div></div>");
$templateCache.put("app/endosos/endosos.status.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Cambiar Estatus</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><h3>Estatus del endoso:</h3><div ng-bind=\"vmm.endorsement.status | endorsement\" class=\"label\" ng-class=\"{\'label-success\': vmm.endorsement.status == 2, \'label-info\' : vmm.endorsement.status == 5,\'label-primary\' : vmm.endorsement.status == 1, \'label-warning\' : vmm.endorsement.status == 3 || vmm.endorsement.status == 4}\"></div></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><select class=\"form-control m-b\" ng-model=\"vmm.selectedType\" ng-options=\"s as s.label for s in vmm.status track by s.value\" ng-change=\"vmm.enableSave()\"><option disabled=\"\" value=\"\">Selecciona un estatus</option></select></div></div><div class=\"row\"><div ng-show=\"vmm.endorsement.certif\" class=\"form-group col-sm-6\"><label for=\"\">Número de certificado</label> <input class=\"form-control\" ng-model=\"vmm.form.num_certificate\"></div></div><div class=\"row\" ng-if=\"vmm.selectedType.value == 2 && vmm.endorsement.endorsement_type === \'A\'\"><div class=\"form-group col-xs-12 col-sm-6\"><label for=\"\">Número de Endoso<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.number_endorsement\"></div><div class=\"form-group col-xs-12 col-sm-6\" ng-if=\"!vmm.policy.administration_type\"><label for=\"\">Numéro de Recibos</label><select ng-model=\"vmm.form.num_receipts\" ng-options=\"item.value as item.name for item in vmm.num_receipts_data\" ng-change=\"vmm.selectNumReceipts(vmm.form.num_receipts)\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"form-group col-xs-12\"><div class=\"row\"><div upload-template=\"\"></div></div></div><div ng-if=\"vmm.form.num_receipts\"><div><endorsement-receipts tosave=\"vmm.form\" form=\"vmm.form\" policy=\"vmm.policy\"></endorsement-receipts></div></div></div><div class=\"row\" ng-if=\"vmm.selectedType.value == 2 && vmm.endorsement.endorsement_type === \'B\'\"><div class=\"form-group col-xs-12 col-sm-6\"><label for=\"\">Número de Endoso</label> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.number_endorsement\"></div><div class=\"form-group col-xs-12\"><div class=\"row\"><div upload-template=\"\"></div></div></div></div><div class=\"row\" ng-if=\"vmm.selectedType.value == 2 && vmm.endorsement.endorsement_type === \'D\'\"><div class=\"form-group col-xs-12 col-sm-6\"><label for=\"\">Número de Endoso<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"vmm.number_endorsement\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label for=\"\">Numéro de recibos a generar<span class=\"color-red\">*</span></label> <input type=\"number\" name=\"notes_data\" ng-model=\"vmm.num_notes_data\" class=\"form-control\"></div><div><div class=\"col-xs-12\"><h3 class=\"blue-color\">Notas de Crédito</h3></div><form name=\"formStatusD\"><div class=\"form-group col-xs-12 col-sm-6\"><label>Folio de la Nota de Crédito:</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"folio\" ng-model=\"vmm.creditNotes.folio\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Prima Neta: $</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"prima_neta\" ng-model=\"vmm.creditNotes.prima_neta\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>IVA: %</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" type=\"number\" id=\"iva_percentage\" step=\"any\" ng-model=\"vmm.creditNotes.iva_percentage\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Recargo por Pago Fraccionado: %</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" type=\"tel\" id=\"rpf_percentage\" step=\"any\" ng-model=\"vmm.creditNotes.rpf_percentage\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Gastos de Expedición: $</label><span class=\"color-red\">*</span> <input class=\"form-control\" value=\"\" id=\"prima-neta\" ng-model=\"vmm.creditNotes.gastos_expedicion\"></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Forma de Pago:</label><select class=\"form-control\" ng-model=\"vmm.creditNotes.payform\" ng-options=\"item.value as item.name for item in dataPayform\"><option value=\"\">Seleccione una opcion</option></select></div><div class=\"form-group col-xs-12 col-sm-6\"><label for=\"SelectCurrency\">Moneda</label><select id=\"SelectCurrency\" class=\"form-control\" ng-options=\"f_currency.value as f_currency.label for f_currency in vmm.f_currency.options\" ng-init=\"vmm.f_currency.f_currency_selected = 1\" ng-model=\"vmm.f_currency.f_currency_selected\"></select></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Fecha de emisión:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input class=\"width-100 text-align-center form-control\" type=\"text\" name=\"startDate\" ng-model=\"vmm.creditNotes.fecha_emision\" value=\"{{vmm.creditNotes.fecha_emision}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6\"><button class=\"ladda-button ladda-button-demo btn btn-success btn-mt\" ng-disabled=\"formStatusD.$invalid\" ng-click=\"vmm.updateFieldD()\" id=\"calcularD\" type=\"submit\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i> Calcular</button></div></form><div><table class=\"table table-stripped\" ng-if=\"vmm.credit_notes\"><thead><tr><th>Nota</th><th>Prima Neta</th><th>IVA</th><th>RPF</th><th>Sub Total</th><th>Prima Total</th></tr></thead><tbody ng-repeat=\"notes in vmm.credit_notes\"><tr><td>{{ notes.folio }}</td><td>{{ notes.prima_neta }}</td><td>{{ notes.iva }}</td><td>{{ notes.rpf }}</td><td>{{ notes.sub_total }}</td><td>{{ notes.prima_total }}</td></tr></tbody></table></div><div class=\"form-group col-xs-12\"><div class=\"row\"><div upload-template=\"\"></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"vmm.options.cancel()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success\" ng-if=\"vmm.selectedType.value != 2\" ng-disabled=\"vmm.form.folio.length === 0 && vmm.folio == true\" ng-click=\"vmm.options.save()\" type=\"button\">Crear</button> <button class=\"btn btn-success\" ng-if=\"vmm.selectedType.value == 2\" ng-disabled=\"!vmm.number_endorsement || !vmm.createdNote\" ng-click=\"vmm.options.save()\" type=\"button\">Crear</button></div></div>");
$templateCache.put("app/endosos/endosos.table.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"endosos.endosos\">Endosos</a></li><li class=\"active\"><strong>Pólizas con endosos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"></div></div></div></div></div></div>");
$templateCache.put("app/fianzaGpo/annulment.ChangeModal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Anulación de Fianza</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 form-group\" align=\"center\"><label ng-if=\"ann.suretyInfo.poliza_number\">Fianza Colectiva {{ann.suretyInfo.poliza_number}}</label> <label ng-if=\"!ann.suretyInfo.poliza_number\">Proyecto de Fianza {{ann.suretyInfo.internal_number}}</label></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Inicio Vigencia:</label> <input class=\"form-control\" type=\"text\" name=\"startValidity\" ng-model=\"ann.suretyInfo.startValidity\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Fin Vigencia:</label> <input class=\"form-control\" type=\"text\" name=\"endValidity\" ng-model=\"ann.suretyInfo.endValidity\" disabled=\"\"></div><div class=\"col-xs-12 form-group\"><label>Contratante:</label> <input ng-if=\"ann.suretyInfo.contractor\" class=\"form-control\" type=\"text\" name=\"contractor.full_name\" ng-model=\"ann.suretyInfo.contractor.full_name\" disabled=\"\"></div><div class=\"col-xs-12 form-group\"><label>Concepto de Anulación: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"conceptAnn.value as conceptAnn.label for conceptAnn in ann.conceptAnn\" ng-change=\"conceptAnnSelection(ann.conceptAnnulment)\" name=\"conceptAnn\" ng-model=\"ann.conceptAnnulment\"></select></div><div class=\"col-xs-12\" ng-if=\"ann.conceptAnnulment\"><label>Razón de Anulación: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" name=\"reason\" ng-model=\"ann.suretyInfo.reason_cancel\"></textarea></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"savesuretyAnnulment(ann.suretyInfo)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Cambios</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cerrar</button></div></div>");
$templateCache.put("app/fianzaGpo/fianza.gpo.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Fianzas</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a ui-sref=\"fianzas.list\">Fianzas</a></li><li><a ng-if=\"surety.poliza_number\" ui-sref=\"fianzas.details({polizaId: surety.id})\">Fianza #{{ surety.poliza_number }}</a> <a ng-if=\"!surety.poliza_number\" ui-sref=\"fianzas.details({polizaId: surety.id})\">Proyecto de Fianza</a></li><li class=\"active\"><strong>Editar</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox-title\"><h5 ng-if=\"!surety.poliza_number\">Editar OT</h5><h5 ng-if=\"surety.poliza_number\">Editar Fianza</h5></div><div class=\"ibox-content wizard\"><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Información de Fianza</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Folio Interno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"surety.internal_number\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!showPF\"><label>Número de Fianza: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-blur=\"checkNumPolicy(); save_info_tab();\" ng-model=\"surety.poliza_number\"></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"!showPF\"><label>Fecha de emision</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"emision_date\" class=\"width-100 text-align-center form-control\" ng-model=\"surety.emision_date\" value=\"{{surety.emision_date}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Vigencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"startDate\" value=\"{{startDate}}\" ng-change=\"checkDate(startDate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Al: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"endDate\" value=\"{{endDate}}\" ng-change=\"checkEndDate(endDate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Afianzadora: <span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control\" ng-options=\"aseguradora.alias for aseguradora in providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"getClaves(aseguradoraSelected, 2)\" ng-model=\"aseguradoraSelected\"><option value=\"\">Selecciona un proveedor</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"refreshProvider()\"><i class=\"glyphicon glyphicon-refresh\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Clave de Agente: <span class=\"color-red\">*</span></label> <input ng-if=\"claves.length == 0\" class=\"form-control\" type=\"text\" placeholder=\"Elige una aseguradora aseguradora\" disabled=\"\"> <input ng-if=\"claves.length == 1\" class=\"form-control\" type=\"text\" value=\"{{claves[0].clave + \' - \' + claves[0].name}}\" disabled=\"\"><select ng-if=\"claves.length > 1\" class=\"form-control\" ng-options=\"clave as clave.clave + \' - \' + clave.name for clave in claves | orderBy: \'clave\' track by clave.url\" ng-change=\"changeClave(claveSelected)\" ng-model=\"claveSelected\" ng-disabled=\"!aseguradoraSelected\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"ramo.ramo_name for ramo in ramos track by ramo.url\" ng-change=\"changeRamo(ramoSelected)\" ng-model=\"ramoSelected\" disabled=\"\"><option value=\"\">Selecciona un ramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"subramo.subramo_name for subramo in subramos track by subramo.url\" ng-change=\"changeSubramo(subramoSelected)\" ng-model=\"subramoSelected\" disabled=\"\"><option value=\"\">Selecciona un subramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Tipo Subramo de Fidelidad Colectiva: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"renewal.type_name for renewal in subramosTypes\" ng-change=\"changeSubramoType(subramoTypeSelected)\" ng-model=\"subramoTypeSelected\"><option value=\"\">Selecciona un tipo de subramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Moneda:</label><select class=\"form-control\" ng-options=\"currency.value as currency.label for currency in currencys\" ng-change=\"changeCurrency(currencySelected)\" ng-model=\"currencySelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Renovable <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.renewal.$invalid && !form.renewal.$pristine }\"><select class=\"form-control\" ng-options=\"renewal.value as renewal.label for renewal in order.renewal.options\" ng-change=\"renewalSelection(order.renewal.is_renewable)\" name=\"renewal\" ng-model=\"order.renewal.is_renewable\" required=\"\"></select></div></div><div class=\"col-xs-12\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Información de Contratante</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Fiado: <span class=\"color-red\">*</span></label><div class=\"input-group\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contacto\" change=\"matchesContractors(order.contacto)\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"contratanteCreator()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in addresses track by address.url\" ng-change=\"changeAddress(addressSelected)\" ng-model=\"addressSelected\" ng-disabled=\"!order.contacto\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo Electrónico:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"email\" ng-model=\"order.contacto.value.email\" disabled=\"\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-phone\" aria-hidden=\"true\"></i></span><phonenumber-directive model=\"order.contacto.value.phone_number\" class=\"ng-isolate-scope\" disabledfield=\"true\"><input class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" type=\"tel\" maxlength=\"25\" aria-invalid=\"false\" ng-model=\"inputValue\"></phonenumber-directive></div></div><div class=\"col-xs-12 col-sm-6 form-group hidden-xs hidden-sm\"><label>Referenciadores:</label><div ng-repeat=\"item in referenciadorArray\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteReferenciador(item, $index)\" ng-disabled=\"referenciadorArray.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control\" ng-options=\"referenciador.url as referenciador.first_name + \' \' + referenciador.last_name for referenciador in referenciadores\" ng-model=\"item.referenciador\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\"><input class=\"form-control wb102\" type=\"text\" placeholder=\"% Comisión\" ng-disabled=\"referenciadorArray.length <= 1\" ng-change=\"changeComRef(item.comision_vendedor, $index)\" ng-model=\"item.comision_vendedor\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Bono Afianzadora:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"text\" ng-model=\"surety.bono_variable\" ng-blur=\"save_info_tab()\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de Bono</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"surety.date_bono\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkFechaFactura(surety.date_bono)\" ng-init=\"vm.checkFechaBono(surety.date_bono)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Detalles de Garantía</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Monto a Garantizar: <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"number\" ng-model=\"surety.contract_poliza.guarantee_amount\" ng-blur=\"save_info_tab()\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Tarifa: <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"surety.contract_poliza.rate\" ng-change=\"valuePercentageRate(surety.contract_poliza.rate)\" ng-blur=\"save_info_tab()\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Giro de la Empresa: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"surety.contract_poliza.activity\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>No. de Empleados: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"surety.contract_poliza.no_employees\"></div><div class=\"col-xs-12 form-group\"><label>Detalle Adicional de Garantía para Subramo Fidelidad Colectiva <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" type=\"text\" ng-model=\"surety.contract_poliza.description\"></textarea></div><div class=\"col-xs-12 form-group\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Categorías</legend><div class=\"address-container\" ng-repeat=\"item in categories\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteCategorie($index, item)\" ng-disabled=\"categories.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Categoría</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteCategorie($index, item)\" ng-disabled=\"categories.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Categoría #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addCategorie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Categoría</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addCategorie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.name\" ng-change=\"createIdentifier()\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Porcentaje Deducible: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"item.deductible\" ng-change=\"valuePercentage(item.deductible, $index)\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones:</label> <textarea type=\"text\" class=\"form-control\" ng-model=\"item.observations\"></textarea></div></div></div></div><div class=\"col-xs-12 form-group\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Beneficiarios</legend><label>Beneficiario existente:</label><div class=\"input-group col-xs-12\"><autocomplete datasource=\"beneficiaries_data\" id=\"beneficiaries\" model=\"benecifiarieSelected\" change=\"matchesBeneficiary(benecifiarieSelected.val)\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addBeneficiaries(benecifiarieSelected.value)\">Agregar</button></span></div><br><legend class=\"col-xs-12 legend-title\" align=\"center\">Beneficiarios</legend><div class=\"address-container\" ng-repeat=\"beneficiary in beneficiaries\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiary($index)\" ng-disabled=\"beneficiaries.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiary($index)\" ng-disabled=\"beneficiaries.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiary()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiary()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 m-b\"><button ng-if=\"beneficiary.type_person == 1\" class=\"btn btn-primary col-xs-6\" ng-click=\"typePerson(1, $index)\">Física</button> <button ng-if=\"beneficiary.type_person == 1\" class=\"btn btn-default col-xs-6\" ng-click=\"typePerson(2, $index)\">Moral</button> <button ng-if=\"beneficiary.type_person == 2\" class=\"btn btn-default col-xs-6\" ng-click=\"typePerson(1, $index)\">Física</button> <button ng-if=\"beneficiary.type_person == 2\" class=\"btn btn-primary col-xs-6\" ng-click=\"typePerson(2, $index)\">Moral</button></div><div ng-if=\"beneficiary.type_person == 1\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.first_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.last_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Apellido Materno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.second_last_name\"></div></div><div ng-if=\"beneficiary.type_person == 2\"><div class=\"col-xs-12 form-group\"><label>Razón Social: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.j_name\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>RFC:</label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.rfc\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Correo Electrónico:</label> <input class=\"form-control\" type=\"email\" ng-model=\"beneficiary.email\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Teléfono:</label><phonenumber-directive model=\"beneficiary.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"beneficiaries_fianza.phone_number\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"showPrograma\" ng-change=\"changeProgram(showPrograma)\"> <span>Pertenece a un Programa de Proveedores</span></h3></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"showPrograma\"><label>Nombre del Programa</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contratante\" change=\"matchesShows(order.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"surety.identifier\"></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de emisión de la Factura</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"surety.date_emision_factura\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkFechaFactura(surety.date_emision_factura)\" ng-init=\"vm.checkFechaFactura(surety.date_emision_factura)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectMontEmision\">Mes de Emisión de factura</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in month.options\" ng-model=\"month.month_selected\" ng-change=\"changemonth()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectYearEmision\">Año de Emisión de la factura</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"surety.year_factura\" ng-change=\"changeyaer(surety.year_factura)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Folio Factura</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" value=\"{{surety.folio_factura}}\" ng-model=\"surety.folio_factura\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Maquila</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" value=\"{{surety.maquila}}\" ng-model=\"surety.maquila\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Fecha de Maquila</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"surety.date_maquila\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkFechaMaquila(surety.date_maquila)\" ng-init=\"vm.checkFechaMaquila(surety.date_maquila)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Tipo Cambio (captura)</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" value=\"{{surety.exchange_rate}}\" ng-model=\"surety.exchange_rate\"></div><div class=\"col-xs-12 form-group\" ng-if=\"!showPF\"><receipts-endorsement form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-endorsement></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"validityInsurance()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Edición Colectividad</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancel()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/fianzaGpo/fianza.gpo.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Fianzas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a ui-sref=\"fianzas.list\">Colectividades</a></li><li class=\"active\"><strong ng-if=\"surety.poliza_number && vm.acceso_adm_fia\">Fianza #{{surety.poliza_number}}</strong> <strong ng-if=\"!surety.poliza_number && vm.acceso_adm_ot\">Orden</strong></li></ol></div></div><div class=\"btn-group pull-right m-b option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_adm_fia && (surety.status != 1 && surety.status != 2)\"><a ui-sref=\"fianzas.edit({polizaId: surety.id})\">Editar Fianza</a></li><li ng-if=\"vm.acceso_adm_ot && (surety.status == 1 || surety.status == 2)\"><a ui-sref=\"fianzas.edit({polizaId: surety.id})\">Editar OT</a></li><li ng-if=\"vm.acceso_adm_ot && (surety.status == 1 || surety.status == 2)\"><a ng-click=\"saveAsSurety()\">Convertir a Fianza</a></li><li ng-if=\"vm.acceso_adm_ot\"><a ng-click=\"goEndorsement(\'Endoso\',\'endorsement.collective\', surety.id)\" ng-if=\"surety.status == 14\">Crear endoso</a></li><li ng-if=\"vm.acceso_adm_fia && (surety.poliza_number && surety.status != 1 && surety.status != 2 && surety.status != 12 && surety.is_renewable == 1)\"><a ui-sref=\"fianzas.renewal({polizaId: surety.id})\">Renovar Fianza</a></li><li ng-if=\"vm.acceso_adm_ot && ((!surety.poliza_number && surety.status == 1 && surety.is_renewable == 1) || (!surety.poliza_number && surety.status == 2 && surety.is_renewable == 1))\"><a ui-sref=\"fianzas.renewal({polizaId: surety.id})\">Renovar OT</a></li><li ng-if=\"vm.acceso_canc_fia && ((surety.poliza_number && surety.status == 14) || (surety.poliza_number && surety.status == 24))\"><a ng-click=\"anularFianza(surety)\">Anular Fianza</a></li><li ng-if=\"vm.acceso_canc_ot && ((!surety.poliza_number && surety.status == 1) || (!surety.poliza_number && surety.status == 14) || (!surety.poliza_number && surety.status == 24))\"><a ng-click=\"anularFianza(surety)\">Anular OT</a></li><li ng-if=\"vm.acceso_canc_fia && ((surety.poliza_number && surety.status == 17) || (surety.poliza_number && surety.status == 24))\"><a ng-click=\"rehabilitarFianza(surety)\">Rehabilitar Fianza</a></li><li ng-if=\"vm.acceso_canc_ot && ((!surety.poliza_number && surety.status == 17) || (!surety.poliza_number && surety.status == 24))\"><a ng-click=\"rehabilitarFianza(surety)\">Rehabilitar OT</a></li><li ng-if=\"vm.acceso_canc_fia && ((surety.poliza_number && surety.status == 13) || (surety.poliza_number && surety.status == 14))\"><a ng-click=\"cancelFianza(surety)\">Cancelar Fianza</a></li><li ng-if=\"vm.acceso_canc_ot && ((!surety.poliza_number && surety.status == 13) || (!surety.poliza_number && surety.status == 1))\"><a ng-click=\"cancelFianza(surety)\">Cancelar OT</a></li><li ng-if=\"vm.acceso_elim_fia && (surety.status !=1 && surety.status != 2)\"><a ng-click=\"deleteFianza()\" ng-hide=\"surety.status == 11\">Eliminar Fianza</a></li><li ng-if=\"vm.acceso_elim_ot && (surety.status ==1 || surety.status == 2)\"><a ng-click=\"deleteFianza()\" ng-hide=\"surety.status == 11\">Eliminar OT</a></li><li class=\"dropdown-submenu\" ng-if=\"surety.files.length && vm.permiso_archivos\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!surety.files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"surety.files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"surety.files\" ng-repeat=\"file in surety.files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, carta.id)\">{{carta.name}}</a></li></ul></li></ul></div><br><div class=\"row\"><div class=\"col-xs-12\"><ul class=\"tab-group\"><li ng-class=\"{ \'active-group\': show_surety }\" ng-click=\"show_section(1)\">Carátula Fianza</li><li ng-class=\"{ \'active-group\': show_categorie }\" ng-click=\"show_section(2)\">Categorías</li><li ng-class=\"{ \'active-group\': show_certificate }\" ng-click=\"show_section(3)\">Certificados</li></ul></div></div><div ng-if=\"show_surety\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carátula</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button> <button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(surety,13)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contacto</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\" ng-if=\"surety.natural || (surety.contractor.type_person ==1 || surety.contractor.type_person ==\'Física\')\"><b>Nombre</b>:</span> <span class=\"blue-color\" ng-if=\"surety.juridical || (surety.contractor.type_person ==2 || surety.contractor.type_person ==\'Moral\')\"><b>Razón Social</b>:</span><div><span>{{ surety.contractor.full_name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">RFC:</span><div><span>{{ surety.natural.rfc }}{{ surety.juridical.rfc }}{{ surety.contractor.rfc }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Grupo:</span><div><span>{{ surety.natural.group }}{{ surety.juridical.group }}{{ surety.contractor.group }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div style=\"word-wrap: break-word\"><span>{{ surety.natural.email }}{{ surety.juridical.email }}{{ surety.contractor.email }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ surety.natural.phone_number }}{{ surety.juridical.phone_number }}{{ surety.contractor.phone_number }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Dirección</span><div><span>{{ surety.address.route }} {{ surety.address.street_number }}&nbsp;</span> <span>Int. {{ surety.address.street_number_int }},</span> <span>{{ surety.address.sublocality }},</span><br><span>{{ surety.address.administrative_area_level_2 }},</span> <span>{{ surety.address.administrative_area_level_1 }},</span> <span>CP. {{ surety.address.postal_code }}</span></div></div><div class=\"col-xs-12 form-group\"><button class=\"btn btn-warning\" ng-click=\"showNotes(true)\">Notas de Crédito ({{ notes.length }})</button></div><div class=\"col-xs-12 form-group\"><button class=\"btn btn-primary\" ng-click=\"showEndorsement(true)\">Endosos ({{ endorsements.length }})</button></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"vm.showRecordatorios()\">{{surety.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div><div class=\"col-xs-12 col-md-8 border-left\"><legend class=\"legend-title\" align=\"center\">Carátula</legend><div ng-if=\"surety.poliza_number\" class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\"><b>Número de Fianza</b>:</span><div><span>{{ surety.poliza_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Identificador:</span><div><span>{{ surety.identifier }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ surety.aseguradora.alias }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Clave de Agente:</span><div><span>{{ surety.clave.clave }} <span ng-if=\"surety.clave.name\">- {{ surety.clave.name }}</span></span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ surety.ramo.ramo_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ surety.subramo.subramo_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Tipo Renovable:</span><div><span ng-if=\"surety.is_renewable == 1\">Renovable</span> <span ng-if=\"surety.is_renewable == 2\">No Renovable</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ surety.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ surety.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Tipo de Subramo:</span><div><span>{{ surety.fianza_type.type_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" ng-class=\"{\'label-success\': surety.status == 1, \'label-info\' : surety.status == 10, \'label-primary\' : surety.status == 14, \'label-warning\' : surety.status == 2 || surety.status == 4 || surety.status == 11 || surety.status == 12 || surety.status == 17 || surety.status == 24}\" style=\"margin-right: 10px\">{{ status(surety.status) }}</div></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"surety.emision_date\"><span class=\"blue-color\">Fecha de emisión:</span><div><span>{{ surety.emision_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"surety.status == 17 || surety.status == 24\"><span class=\"blue-color\">Concepto de anulación:</span><div><span ng-if=\"surety.concept_annulment == 1\">Preanulación</span> <span ng-if=\"surety.concept_annulment == 2\">Error de Captura</span> <span ng-if=\"surety.concept_annulment == 3\">Reexpedición</span> <span ng-if=\"surety.concept_annulment == 4\">Falta de Pago</span> <span ng-if=\"surety.concept_annulment == 5\">Otro</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-8 form-group\" ng-if=\"surety.status == 17 || surety.status == 24\"><span class=\"blue-color\">Razón de anulación:</span><div><span>{{ surety.reason_cancel }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"surety.reason_rehabilitate\"><span class=\"blue-color\">Motivo de rehabilitación:</span><div><span>{{ surety.reason_rehabilitate }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"surety.fecha_cancelacion\"><span class=\"blue-color\">Fecha Cancelación:</span><div><span>{{ surety.fecha_cancelacion | date: \'dd/MM/yyyy\': \'UTC\' }}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaCancelacion()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"surety.monto_cancelacion\"><span class=\"blue-color\">Monto Cancelación:</span><div><span>{{ surety.monto_cancelacion | currency }}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeMontoCancelacion()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"surety.f_currency == 1\">Pesos</span> <span ng-if=\"surety.f_currency == 2\">Dolares</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Creado Por:</span><div><span>{{ surety.owner }}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"surety.ref_policy.length > 0\"><span class=\"blue-color\">Referenciador(es):</span><div ng-repeat=\"refs in surety.ref_policy\"><span>{{ refs.referenciador.first_name | uppercase}} {{ refs.referenciador.last_name | uppercase}} <span ng-if=\"refs.comision_vendedor\">|| {{refs.comision_vendedor}}%</span></span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\">Programa de Proveedores:</span><div class=\"input-group\"><span>{{ programa.full_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"surety.status != 1\"><span class=\"blue-color\">Fecha Emisión Factura:</span><div><span>{{surety.date_emision_factura | date: \'dd/MM/yyyy\': \'UTC\' }}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaEmisionF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!openMonth && surety.status != 1\"><span class=\"blue-color\">Mes de Emisión:</span><div><span>{{ monthEmision(surety.month_factura)}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeMesF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!openYear && surety.status != 1\"><span class=\"blue-color\">Año Factura:</span><div><span>{{ surety.year_factura}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changYearF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"openYear\"><label class=\"blue-color\" for=\"SelectYearEmision\">Año de Factura</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"surety.year_factura\" ng-change=\"changeyaer(surety.year_factura)\"><option value=\"\"></option></select><button class=\"btn btn-white btn-sm\" ng-click=\"changeYearF1(surety.year_factura)\"><i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"openMonth\"><label class=\"blue-color\" for=\"SelectMontEmision\">Mes de Emisión</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in month.options\" ng-model=\"month.month_selected\" ng-init=\"month.month_selected = surety.month_factura\" ng-change=\"changemonth()\"></select><button class=\"btn btn-white btn-sm\" ng-click=\"changeMesF1(month.month_selected)\"><i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"surety.status != 1\"><span class=\"blue-color\">Folio Factura:</span><div><span>{{ surety.folio_factura}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFolioF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"surety.status != 1\"><span class=\"blue-color\">Maquila:</span><div><span>{{ surety.maquila | currency}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeMaquila()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"surety.status != 1\"><span class=\"blue-color\">Fecha Maquila:</span><div><span>{{ surety.date_maquila | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaMaquila()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"surety.status != 1\"><span class=\"blue-color\">Tipo de Cambio (Captura):</span><div><span>{{ surety.exchange_rate | currency }}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeTipoC()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12\"><hr></div><div ng-if=\"surety.status != 1 && surety.recibos_poliza.length\"><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Primera:</span><div>{{ surety.p_neta | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Derecho:</span><div>{{ surety.rpf | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Gastos:</span><div>{{ surety.derecho | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Iva:</span><div>{{ surety.iva | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Total:</span><div>{{ surety.p_total | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.permiso_comisiones\"><span class=\"blue-color\">Comisión:</span><div>{{ surety.comision | currency }}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.permiso_comisiones\"><span class=\"blue-color\">Porcentaje de Comisión:</span><div>{{ surety.comision_percent }}%</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Pago de Comisión:</span><div><span>{{ surety.fecha_pago_comision | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaComision()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"surety.poliza_number\"><span class=\"blue-color\">Cargo Automático:</span><div><span ng-if=\"surety.recibos_poliza[0].is_cat\">Si</span> <span ng-if=\"!surety.recibos_poliza[0].is_cat\">No</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changedomiciliado()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> Cambiar</button></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=\"blue-color\">Bono Afianzadora:</label><div><span>{{ surety.bono_variable | currency }}</span><button class=\"btn btn-white btn-sm\" ng-click=\"changeBono()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Bono:</span><div><span>{{ surety.date_bono | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaBono()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-6 form-group pull-right\" ng-if=\"surety.task_associated\"><button type=\"button\" class=\"btn btn-white btn-sm btn-secondary\" ng-click=\"openModal(surety.task_associated_info)\">{{ vm.isCollapsed ? \'Ocultar\' : \'Ver\' }} Tarea Origen</button><div ng-show=\"vm.isCollapsed\"><span class=\"blue-color\">Tarea Origen</span><div><span>{{ surety.task_associated_info.title }}</span></div></div></div></div></div></div></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"show_surety && vm.recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"vm.recordatoriosFlag = false; vm.infoFlag = true\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in surety.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"show_surety && show_notes\"><div class=\"ibox-title\"><h5>Notas de Crédito</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"showNotes(false)\"><span class=\"fa fa-reply\"></span> Regresar</button></div><div class=\"col-xs-12 form-group\"><table class=\"table table-hover table-bordered\"><thead><th>Folio</th><th>No. Póliza/Fianza</th><th>No. Endoso</th><th>Fecha de Inicio</th><th>Prima Total</th><th>Estatus</th></thead><tr ng-repeat=\"nota in notes track by $index\" ng-click=\"changeStatusModal(nota, surety)\"><td>{{ nota.folio }}</td><td>{{ nota.poliza }}</td><td>{{ nota.endorsement }}</td><td>{{ nota.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ nota.prima_total | currency }}</td><td><div class=\"label\" ng-class=\"{\'label-success\': nota.status == 4, \'label-info\' : nota.status == 5 || nota.status == 6, \'label-primary\' : nota.status == 1 || nota.status == 3, \'label-warning\' : nota.status == 2 || nota.status == 8 || nota.status == 10 || nota.status == 11}\">{{ statusReceipt(nota.status) }}</div></td></tr></table></div></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"show_surety && show_endorsement\"><div class=\"ibox-title\"><h5>Endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"showEndorsement(false)\"><span class=\"fa fa-reply\"></span> Regresar</button></div><div><table class=\"table table-hover table-bordered\"><thead><th>Número de endoso</th><th>Tipo</th><th>Concepto</th><th>Vigencia</th><th>Estatus</th></thead><tbody><tr ng-repeat=\"endorsement in endorsements track by $index\" ng-click=\"goEndorsement(\'Información endoso\', \'endorsement.details\', endorsement)\"><td ng-if=\"endorsement.number_endorsement\">{{ endorsement.number_endorsement }}</td><td ng-if=\"!endorsement.number_endorsement\">Sin número asigando</td><td>{{ endorsement.endorsement_type }}</td><td>{{ concept(endorsement.concept) }}</td><td>{{ endorsement.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ endorsement.end_date | date: \'dd/MM/yyyy\': \'UTC\' }}</td><td ng-if=\"endorsement.status == 1\">Pendiente</td><td ng-if=\"endorsement.status == 2\">Registrado</td><td ng-if=\"endorsement.status == 3\">Rechazado</td><td ng-if=\"endorsement.status == 4\">Cancelado</td><td ng-if=\"endorsement.status == 5\">En trámite</td><td ng-if=\"endorsement.status == 6\">Anulado</td></tr></tbody></table></div></div></div><div ng-if=\"show_surety\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Contrato</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Monto a Garantizar:</span><div>{{ surety.contract_poliza.guarantee_amount | currency }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Tarifa:</span><div>{{ surety.contract_poliza.rate }}%</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Giro de la empresa:</span><div>{{ surety.contract_poliza.activity }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Número de Empleados:</span><div>{{ surety.contract_poliza.no_employees }}</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Detalle Adicional de Garantía para Subramo Fidelidad Colectiva:</span><div>{{ surety.contract_poliza.description }}</div></div></div></div></div></div><div ng-if=\"show_surety\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Beneficiarios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div ng-repeat=\"beneficiary in surety.beneficiaries_poliza_many\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.j_name\"><span class=\"blue-color\">Razón Social:</span><div>{{ beneficiary.j_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.first_name\"><span class=\"blue-color\">Nombre:</span><div>{{ beneficiary.first_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.last_name\"><span class=\"blue-color\">Apellido Paterno:</span><div>{{ beneficiary.last_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"beneficiary.second_last_name\"><span class=\"blue-color\">Apellido Materno:</span><div>{{ beneficiary.second_last_name }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RFC:</span><div>{{ beneficiary.rfc }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div>{{ beneficiary.email }}</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Teléfono:</span><div>{{ beneficiary.phone_number }}</div></div><div class=\"col-xs-12\"><hr></div></div></div></div></div></div><div ng-if=\"show_surety && surety.poliza_number\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Recibo Fianza</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle_receipt\"><thead><tr><th>Serie</th><th>Prima Primera</th><th>Derecho</th><th>Gastos</th><th>Iva</th><th>Prima Total</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th>Vigencia</th><th>Vencimiento</th><th>Estatus</th><th>Entregado</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"recibo in surety.recibos_poliza\" ng-if=\"recibo.receipt_type == 1\" ng-show=\"recibo.status != 0\" ng-click=\"changeStatusModal(recibo, surety)\"><td>{{recibo.recibo_numero}}</td><td>{{recibo.prima_neta | currency}}</td><td>{{recibo.rpf | currency}}</td><td>{{recibo.derecho | currency}}</td><td>{{recibo.iva | currency}}</td><td>{{recibo.prima_total | currency}}</td><td ng-if=\"vm.permiso_comisiones\">{{recibo.comision | currency}}</td><td>{{recibo.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}} - {{recibo.fecha_fin | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td>{{recibo.vencimiento | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == 4, \'label-info\' : recibo.status == 5 || recibo.status == 6, \'label-primary\' : recibo.status == 1 || recibo.status == 3, \'label-warning\' : recibo.status == 2 || recibo.status == 8 || recibo.status == 10 || recibo.status == 11}\">{{ statusReceipt(recibo.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(recibo)\"><span ng-if=\"recibo.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!recibo.delivered\"><i class=\"fa fa-times\"></i></span></td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-if=\"vm.permiso_correo && !recibo.track_email\" ng-click=\"addEmailsConfirmPolicy(recibo, surety.natural, surety.juridical, surety.contractor)\" ng-disabled=\"!(recibo.status == 4)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-if=\"vm.permiso_correo && recibo.track_email\" ng-click=\"addEmailsConfirmPolicy(recibo, surety.natural, surety.juridical, surety.contractor)\" ng-disabled=\"recibo.status != 4\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-if=\"!recibo.track_bitacora\" ng-click=\"showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"recibo.track_bitacora\" ng-click=\"showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a ng-if=\"recibo.is_cat\" class=\"btn btn-white btn-sm\" title=\"Este recibo es con cargo a tarjeta (Domiciliado)\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-sm btn-white\" ng-click=\"editReceipt(recibo)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-info btn-sm\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(receipt,4)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"3\" model=\"recibo.recibo_numero + \' de la póliza \' + surety.poliza_number\" associated=\"surety.id\" receipt=\"recibo.id\"></tasks></td></tr><tr><td><b>Totales</b></td><td><b>{{ total_prima | currency }}</b></td><td><b>{{ total_rpf | currency }}</b></td><td><b>{{ total_derecho | currency }}</b></td><td><b>{{ total_iva | currency }}</b></td><td><b>{{ total_total | currency }}</b></td><td><b>{{ total_comision| currency }}</b></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><div class=\"col-xs-12\" ng-if=\"!show_binnacle_receipt\"><div class=\"identificador-dash-email\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se envio un correo.</span><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div><div class=\"row animate\" ng-if=\"show_binnacle_receipt\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><a class=\"col-xs-12 btn btn-info pull-right\" ng-click=\"returnToReceipts()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</a></div><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Bitácora de recibos</h3><hr></div><div><div class=\"col-xs-12 form-group\"><comments datasource=\"comments_data_receipt\" typemodel=\"4\" config=\"comments_config_receipt\" idmodel=\"receipt_id\" exportable=\"true\"></comments></div></div></div></div></div></div></div></div><div ng-if=\"show_surety && receipts_endorsement.length > 0\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Recibos de Endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle_receipt\"><thead><tr><th>No. Endoso</th><th>Serie</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>Iva</th><th>Prima Total</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th>Vigencia</th><th>Vencimiento</th><th>Estatus</th><th>Entregado</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"recibo in receipts_endorsement track by $index\" ng-if=\"recibo.receipt_type == 2\" ng-show=\"recibo.status != 0\" ng-click=\"changeStatusModal(recibo, surety)\"><td>{{recibo.endorsement}}</td><td>{{recibo.recibo_numero}}</td><td>{{recibo.prima_neta | currency}}</td><td>{{recibo.rpf | currency}}</td><td>{{recibo.derecho | currency}}</td><td>{{recibo.iva | currency}}</td><td>{{recibo.prima_total | currency}}</td><td ng-if=\"vm.permiso_comisiones\">{{recibo.comision | currency}}</td><td>{{recibo.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}} - {{recibo.fecha_fin | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td>{{recibo.vencimiento | date: \'dd-MM-yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == 4, \'label-info\' : recibo.status == 5 || recibo.status == 6, \'label-primary\' : recibo.status == 1 || recibo.status == 3, \'label-warning\' : recibo.status == 2 || recibo.status == 8 || recibo.status == 10 || recibo.status == 11}\">{{ statusReceipt(recibo.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); deliveredReceipt(recibo)\"><span ng-if=\"recibo.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!recibo.delivered\"><i class=\"fa fa-times\"></i></span></td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-if=\"vm.permiso_correo && !recibo.track_email\" ng-click=\"addEmailsConfirmPolicy(recibo, surety.natural, surety.juridical, surety.contractor)\" ng-disabled=\"!(recibo.status == 4)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-if=\"vm.permiso_correo && recibo.track_email\" ng-click=\"addEmailsConfirmPolicy(recibo, surety.natural, surety.juridical, surety.contractor)\" ng-disabled=\"recibo.status != 4\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-if=\"!recibo.track_bitacora\" ng-click=\"showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"recibo.track_bitacora\" ng-click=\"showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-info btn-sm\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(receipt,4)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div class=\"col-xs-12\" ng-if=\"!show_binnacle_receipt\"><div class=\"identificador-dash-email\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se envio un correo.</span><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div><div class=\"row animate\" ng-if=\"show_binnacle_receipt\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><a class=\"col-xs-12 btn btn-info pull-right\" ng-click=\"returnToReceipts()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</a></div><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Bitácora de recibos</h3><hr></div><div><div class=\"col-xs-12 form-group\"><comments datasource=\"comments_data_receipt\" typemodel=\"4\" config=\"comments_config_receipt\" idmodel=\"receipt_id\" exportable=\"true\"></comments></div></div></div></div></div></div></div></div><div ng-if=\"show_surety && showHistoric\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Histórico renovaciones y cancelaciones</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div ng-if=\"!vm.show_binnacle_receipt\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th>Número de Póliza</th><th>Vigencia</th><th>Estatus</th><th>Fecha de Renovación</th><th>Renovado Por:</th></tr></thead><tbody><tr ng-repeat=\"policy in policy_history track by $index\" ng-click=\"goToPolicy(policy)\"><td ng-if=\"policy.poliza_number\">{{ policy.poliza_number }}</td><td ng-if=\"!policy.poliza_number\">Sin número asignado</td><td>{{ policy.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ policy.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ status(policy.status) }}</td><td>{{ policy.created_at | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ policy.owner }}</td></tr></tbody></table></div></div></div></div><div ng-if=\"show_surety && vm.permiso_archivos\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(surety)\">Guardar Archivos</button></div></div><div class=\"row col-md-12 col-sm-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in surety.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"renameFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file, surety.files)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado()\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"show_surety\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"comments_data\" config=\"comments_config\" typemodel=\"13\" idmodel=\"surety.id\" exportable=\"true\"></comments></div></div></div></div></div><div ng-if=\"show_categorie\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Categorías</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row jumbotron\" ng-repeat=\"category in categories\" ng-if=\"category.status !=0\"><div class=\"col-xs-12 col-sm-8\"><legend class=\"legend-title\" align=\"center\">Categoría</legend><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\"><b>Nombre</b>:</span><div><span>{{ category.name }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">ID:</span><div><span>{{ category.id }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Deducible:</span><div><span>{{ category.deductible }}%</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><button class=\"btn btn-white\" ng-click=\"deleteCategorie(category)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i> Eliminar Categoría</button></div></div><div class=\"col-xs-12 col-sm-4 border-left\"><legend class=\"legend-title\" align=\"center\">Certificados</legend><div class=\"col-xs-12 col-sm-6 form-group\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"getCertificate(category, 1)\">Activos ({{ category.certificados_activos }})</button></div><div class=\"col-xs-12 col-sm-6 form-group\"><button class=\"btn btn-warning col-xs-12\" ng-click=\"getCertificate(category, 2)\">Inactivos ({{ category.certificados_inactivos }})</button></div></div><div class=\"col-xs-12\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(category)\">Guardar Archivos</button></div></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in category.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"renameFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file, category.files)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td></tr></tbody></table></div></div></div></div></div></div><div ng-if=\"show_certificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Certificados</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"certificate_table\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"getAllCertificate(0,0)\"><i class=\"fa fa-bars\" aria-hidden=\"true\"></i> Todos los Certificados</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"showSectionCertificate(4)\"><i class=\"fa fa-list\" aria-hidden=\"true\"></i> Agregar Certificados Layouts</button></div><div class=\"col-xs-12 form-group\"><label>Buscar</label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-enter=\"search(cadena)\" ng-model=\"cadena\" placeholder=\"Certificado, Nombre\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"search(cadena)\">Buscar</button></div></div></div><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered table-hover\"><thead><th>Certificado</th><th>Estatus</th><th>Nombre</th><th>Puesto</th><th>Actividad</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"item in categorySelected.certificates | orderBy: \'certificate_number\'\" ng-click=\"selectCerficate(item)\" ng-if=\"item.status != 0\"><td>{{ item.certificate_number }}</td><td><div class=\"label\" ng-class=\"{\'label-success\': item.certificado_inciso_activo == true, \'label-warning\' : item.certificado_inciso_activo == false}\" style=\"margin-right: 10px\"><span ng-if=\"item.certificado_inciso_activo\">Activo</span> <span ng-if=\"!item.certificado_inciso_activo\">Inactivo</span></div></td><td>{{ item.beneficiaries_poliza[0].first_name }} {{ item.beneficiaries_poliza[0].last_name }} {{ item.beneficiaries_poliza[0].second_last_name }}</td><td>{{ item.beneficiaries_poliza[0].workstation }}</td><td>{{ item.contract_poliza.activity }}</td><td ng-click=\"$event.stopPropagation()\"><button ng-if=\"vm.acceso_adm_fia\" class=\"btn btn-white\" ng-click=\"editCerficate(item)\" title=\"Editar Certificado\"><span class=\"fa fa-pencil\"></span></button> <button ng-if=\"vm.acceso_adm_fia\" class=\"btn btn-white\" ng-click=\"deleteCertificate(item)\" title=\"Eliminar Certificado\"><span class=\"fa fa-trash\"></span></button></td></tr></tbody></table><div class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"downloadExcel()\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar Certificados</button></div></div><div class=\"row\" ng-if=\"certificate_info\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showSectionCertificate(1)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">No. Certificado:</span><div><span>{{ certificate.certificate_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div><span ng-if=\"certificate.beneficiaries_poliza[0].email\">{{ certificate.beneficiaries_poliza[0].email }}</span> <span ng-if=\"!certificate.beneficiaries_poliza[0].email\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ certificate.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\' }} - {{ certificate.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ certificate.beneficiaries_poliza[0].first_name }} {{ certificate.beneficiaries_poliza[0].last_name }} {{ certificate.beneficiaries_poliza[0].second_last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RFC:</span><div><span ng-if=\"certificate.beneficiaries_poliza[0].rfc\">{{ certificate.beneficiaries_poliza[0].rfc }}</span> <span ng-if=\"!certificate.beneficiaries_poliza[0].rfc\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Puesto:</span><div><span>{{ certificate.beneficiaries_poliza[0].workstation }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Actividad:</span><div><span>{{ certificate.contract_poliza.activity }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Monto a Garantizar:</span><div><span ng-if=\"certificate.contract_poliza.amount\">{{ certificate.contract_poliza.amount | currency}}</span> <span ng-if=\"!certificate.contract_poliza.amount\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-8 form-group\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ certificate.observations }}</span></div></div><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(certificate)\">Guardar Archivos</button></div></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in certificate.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"renameFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file, certificate.files)\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td></tr></tbody></table></div></div></div><div class=\"row\" ng-if=\"certificate_edit\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showSectionCertificate(1)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>No. Certificado:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.certificate_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Correo Electrónico:</label> <input class=\"form-control\" type=\"email\" ng-model=\"newBeneficiary.email\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Nombre:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newBeneficiary.first_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Apellido Paterno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newBeneficiary.last_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Apellido Materno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newBeneficiary.second_last_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>RFC:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newBeneficiary.rfc\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Puesto:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newBeneficiary.workstation\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Actividad:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newContract.activity\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Monto a garantizar:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newContract.amount\"></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group pull-right\"><button class=\"btn btn-success col-xs-12\" ng-click=\"updateCertificate()\">Actualizar Certificado</button></div></div><div ng-if=\"certificate_mass\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showSectionCertificate(1)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Categoría</th><th>ID</th></tr></thead><tbody><tr ng-repeat=\"item in categories\"><td>{{ item.name }}</td><td>{{ item.id }}</td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"!showTableCertificates\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando certificados...</span></div></div></div><div class=\"row\" ng-if=\"showTableCertificates\"><div class=\"col-xs-1 form-group\"><select class=\"form-control\" ng-options=\"renewal.value for renewal in optionsViews\" ng-change=\"selectViews(optionViews)\" ng-model=\"optionViews\"></select></div><div><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Certificado</td><td>Correo</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>RFC</td><td>Puesto</td><td>Actividad</td><td>Monto a Garantizar</td><td>Observaciones</td><td>Categoría</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.CERTIFICADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.RFC }}</td><td>{{ item.PUESTO }}</td><td>{{ item.ACTIVIDAD }}</td><td>{{ item.MONTO_A_GARANTIZAR }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.CATEGORIA }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"saveCertificates()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Certificados</button></div></div></div></div></div></div><script type=\"text/javascript\">\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target);\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.removeClass(\'display-none\');\n    dummy.addClass(\'display-none\');\n\n    inputTag.addClass(\'display-none\');\n    strongTag.removeClass(\'display-none\');\n  }\n\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/fianzaGpo/fianza.gpo.ordenes.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Fianzas</h2><ol class=\"breadcrumb margin-top-15\"><li ng-show=\"!show_contractor\"><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\" ng-show=\"!show_contractor\"><strong>Colectividades</strong></li><li class=\"active\" ng-show=\"show_contractor\" ng-click=\"returnToPolicy()\"><a>Regresar</a></li></ol></div></div><div ng-if=\"show_contractor\" class=\"animate z-index-9000\"><div><ng-include src=\"\'app/contratantes/contratantes.add.html\'\" ng-controller=\"ContratantesCtrl as vm\"></ng-include></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\" ng-if=\"!show_contractor\"><div class=\"row\"><div class=\"col-lg-12\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"Proyecto de Fianza\" ng-click=\"hideButtonOT()\" ng-show=\"order.acceso_adm_ot && order.acceso_proy_fia\"><div id=\"divCOT\" ng-include=\"\'app/fianzaGpo/fianzas.gpo.colectividades.html\'\"></div></uib-tab><uib-tab index=\"1\" heading=\"Fianza Colectiva\" ng-click=\"hideButtonSurety()\" ng-show=\"order.acceso_adm_fia\"><div id=\"divCPoliza\" ng-include=\"\'app/fianzaGpo/fianzas.gpo.colectividades.html\'\"></div></uib-tab></uib-tabset></div></div></div></div></div>");
$templateCache.put("app/fianzaGpo/fianza.gpo.renewal.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Fianzas</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a ui-sref=\"fianzas.list\">Fianzas</a></li><li><a ng-if=\"surety.poliza_number\" ui-sref=\"fianzas.details({polizaId: surety.id})\">Fianza #{{ surety.poliza_number }}</a> <a ng-if=\"!surety.poliza_number\" ui-sref=\"fianzas.details({polizaId: surety.id})\">Proyecto de Fianza</a></li><li class=\"active\"><strong ng-if=\"reexpedir\">Reexpedir</strong> <strong ng-if=\"!reexpedir\">Renovar</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div ng-include=\"\'app/fianzaGpo/fianzas.gpo.colectividades.html\'\"></div><br><br></div></div>");
$templateCache.put("app/fianzaGpo/fianzas.gpo.colectividades.html","<toaster-container></toaster-container><div class=\"row\" ng-if=\"!show_certificates\"><div class=\"col-xs-12\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Información de Fianza</legend></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Folio Interno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"surety.internal_number\" ng-change=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!showPF\"><label>Número de Fianza: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-blur=\"checkNumPolicy()\" ng-model=\"surety.poliza_number\"></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"!showPF\"><label>Fecha de emisión de Fianza</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"emision_date\" class=\"width-100 text-align-center form-control\" ng-model=\"surety.emision_date\" data-date-format=\"mm/dd/yyyy\" ng-change=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Vigencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"startDate\" ng-change=\"checkDate(startDate);\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Al: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"endDate\" ng-change=\"checkEndDate(endDate);\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Afianzadora: <span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control\" ng-options=\"aseguradora.alias for aseguradora in providers | orderBy: \'alias\' track by aseguradora.url\" ng-model=\"aseguradoraSelected\" ng-change=\"getClaves(aseguradoraSelected)\"><option value=\"\">Selecciona un proveedor</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"refreshProvider()\"><i class=\"glyphicon glyphicon-refresh\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Clave de Agente: <span class=\"color-red\">*</span></label> <input ng-if=\"claves.length == 0\" class=\"form-control\" type=\"text\" placeholder=\"Elige una aseguradora aseguradora\" disabled=\"\"> <input ng-if=\"claves.length == 1\" class=\"form-control\" type=\"text\" value=\"{{claves[0].clave + \' - \' + claves[0].name}}\" disabled=\"\"><select ng-if=\"claves.length > 1\" class=\"form-control\" ng-options=\"clave as clave.clave + \' - \' + clave.name for clave in claves | orderBy: \'clave\' track by clave.url\" ng-change=\"changeClave(claveSelected)\" ng-model=\"claveSelected\" ng-disabled=\"!aseguradoraSelected\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"ramo.ramo_name for ramo in ramos track by ramo.url\" ng-change=\"changeRamo(ramoSelected)\" ng-model=\"ramoSelected\" disabled=\"\"><option value=\"\">Selecciona un ramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"subramo.subramo_name for subramo in subramos track by subramo.url\" ng-change=\"changeSubramo(subramoSelected)\" ng-model=\"subramoSelected\" disabled=\"\"><option value=\"\">Selecciona un subramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Tipo Subramo de Fidelidad Colectiva: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"renewal.type_name for renewal in subramosTypes\" ng-change=\"changeSubramoType(subramoTypeSelected)\" ng-model=\"subramoTypeSelected\"><option value=\"\">Selecciona un tipo de subramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Moneda:</label><select class=\"form-control\" ng-options=\"currency.value as currency.label for currency in currencys\" ng-change=\"changeCurrency(currencySelected)\" ng-model=\"currencySelected\"></select></div><div class=\"col-xs-12 col-sm-4 col-md-4 form-group\"><label>Renovable <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.renewal.$invalid && !form.renewal.$pristine }\"><select class=\"form-control\" ng-options=\"renewal.value as renewal.label for renewal in order.renewal.options\" ng-change=\"renewalSelection()\" name=\"renewal\" ng-model=\"order.renewal.selected\" required=\"\"></select></div></div><div class=\"col-xs-12\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Información de Contratante</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Fiado: <span class=\"color-red\">*</span></label><div class=\"input-group\" ng-if=\"order.acceso_adm_cont\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contacto\" change=\"matchesContractors(order.contacto)\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"contratanteCreatorModalEvent()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div><div class=\"form-group\" ng-if=\"!order.acceso_adm_cont\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contacto\" change=\"matchesContractors(order.contacto)\"></autocomplete><span class=\"input-group-btn\" ng-if=\"vm.acceso_adm_cont\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"contratanteCreatorModalEvent(); show_contractor = true\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in addresses track by address.url\" ng-change=\"changeAddress(addressSelected)\" ng-model=\"addressSelected\" ng-disabled=\"!order.contacto\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo Electrónico:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"email\" ng-model=\"order.contacto.value.email\" disabled=\"\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-phone\" aria-hidden=\"true\"></i></span><phonenumber-directive model=\"order.contacto.value.phone_number\" class=\"ng-isolate-scope\" disabledfield=\"true\"><input class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" type=\"tel\" maxlength=\"25\" aria-invalid=\"false\" ng-model=\"inputValue\"></phonenumber-directive></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6 form-group\"><label>Referenciador(es): <span class=\"color-red\" ng-if=\"order.acceso_obligatorio_ref\">*</span></label><div ng-repeat=\"item in referenciadorArray\"><div class=\"row\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"deleteReferenciador($index)\" ng-disabled=\"referenciadorArray.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control\" ng-options=\"referenciador.url as referenciador.first_name + \' \' + referenciador.last_name for referenciador in referenciadores\" ng-model=\"item.referenciador\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\"><input class=\"form-control wb102\" type=\"text\" placeholder=\"% Comisión\" ng-disabled=\"referenciadorArray.length <= 1\" ng-change=\"changeComRef(item.comision_vendedor, $index)\" ng-model=\"item.comision_vendedor\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div></div></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Bono Afianzadora:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"text\" ng-model=\"surety.bono_variable\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de Bono</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"date_bono\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkFechaBono(date_bono);\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Detalles de Garantía</legend></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Monto a Garantizar: <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"text\" ng-model=\"surety.contract_poliza.guarantee_amount\" ng-blur=\"valueGuarante(surety.contract_poliza.guarantee_amount)\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Tarifa: <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-model=\"surety.contract_poliza.rate\" ng-blur=\"valuePercentageRate(surety.contract_poliza.rate);\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Giro de la Empresa: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"surety.contract_poliza.activity\" ng-change=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>No. de Empleados: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"surety.contract_poliza.no_employees\" ng-change=\"\"></div><div class=\"col-xs-12 form-group\"><label>Detalle Adicional de Garantía para Subramo Fidelidad Colectiva <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" type=\"text\" ng-model=\"surety.contract_poliza.description\" ng-change=\"\"></textarea></div><div class=\"col-xs-12 form-group\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Categorías</legend><div class=\"address-container\" ng-repeat=\"item in categories\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteCategorie($index)\" ng-disabled=\"categories.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Categoría</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteCategorie($index)\" ng-disabled=\"categories.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Categoría #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addCategorie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Categoría</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addCategorie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.name\" ng-change=\"createIdentifier();\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Porcentaje Deducible: <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"item.deductible\" ng-change=\"valuePercentage(item.deductible, $index);\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label>Observaciones:</label> <textarea type=\"text\" class=\"form-control\" ng-model=\"item.observations\" ng-change=\"\"></textarea></div></div></div></div><div class=\"col-xs-12 form-group\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Beneficiarios</legend><label>Beneficiario existente:</label><div class=\"input-group col-xs-12\"><autocomplete datasource=\"beneficiaries_data\" id=\"beneficiaries\" model=\"benecifiarieSelected\" change=\"matchesBeneficiary(benecifiarieSelected.val)\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addBeneficiaries(benecifiarieSelected.value)\">Agregar</button></span></div><br><div class=\"address-container\" ng-repeat=\"beneficiary in beneficiaries\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiary($index)\" ng-disabled=\"beneficiaries.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiary($index)\" ng-disabled=\"beneficiaries.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiary()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiary()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 m-b\"><button ng-if=\"beneficiary.type_person == 1\" class=\"btn btn-primary col-xs-6\" ng-click=\"typePerson(1, $index)\">Física</button> <button ng-if=\"beneficiary.type_person == 1\" class=\"btn btn-default col-xs-6\" ng-click=\"typePerson(2, $index)\">Moral</button> <button ng-if=\"beneficiary.type_person == 2\" class=\"btn btn-default col-xs-6\" ng-click=\"typePerson(1, $index)\">Física</button> <button ng-if=\"beneficiary.type_person == 2\" class=\"btn btn-primary col-xs-6\" ng-click=\"typePerson(2, $index)\">Moral</button></div><div ng-if=\"beneficiary.type_person == 1\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.first_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.last_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Apellido Materno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.second_last_name\"></div></div><div ng-if=\"beneficiary.type_person == 2\"><div class=\"col-xs-12 form-group\"><label>Razón Social: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.j_name\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>RFC:</label> <input class=\"form-control\" type=\"text\" ng-model=\"beneficiary.rfc\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Correo Electrónico:</label> <input class=\"form-control\" type=\"email\" ng-model=\"beneficiary.email\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Teléfono:</label><phonenumber-directive model=\"beneficiary.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"beneficiaries_fianza.phone_number\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"showPrograma\"> <span>Pertenece a un Programa de Proveedores</span></h3></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"showPrograma\"><label>Nombre del programa</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contratante\" change=\"matchesShows(order.contratante.val, true)\"></autocomplete></div><div class=\"col-xs-12 form-group\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"row\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"surety.identifier\" ng-change=\"\"></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"!showPF\"><label>Fecha de emisión de la Factura</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" class=\"width-100 text-align-center form-control\" ng-model=\"date_emision_factura\" data-dat=\"mm/dd/yyyy\" ng-change=\"checkFechaFactura(date_emision_factura)\" ng-init=\"vm.checkFechaFactura(date_emision_factura)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!showPF\"><label for=\"SelectMontEmision\">Mes de Emisión Factura</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in month.options\" ng-model=\"month.month_selected\" ng-change=\"order.changemonth(month)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!showPF\"><label for=\"year\">Año Factura</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"year_factura\" ng-change=\"changeyaer(year_factura)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!showPF\"><label for=\"folio-fact\">Folio Factura</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" ng-model=\"folio_factura\" ng-change=\"changeFolio(folio_factura)\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!showPF\"><label for=\"folio-fact\">Maquila</label> <input class=\"form-control\" name=\"maquila\" type=\"number\" ng-model=\"maquila\" ng-change=\"changeMaquila(maquila)\"></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"!showPF\"><label>Fecha de Maquila</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" class=\"width-100 text-align-center form-control\" ng-model=\"date_maquila\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkFechaMaquila(date_maquila)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!showPF\"><label for=\"folio-fact\">Tipo Cambio (Captura)</label> <input class=\"form-control\" name=\"changeType\" type=\"number\" ng-model=\"exchange_rate\" ng-change=\"changeExchange(exchange_rate)\"></div><br><div class=\"col-xs-12 form-group\" ng-if=\"!showPF\"><receipts-endorsement form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-endorsement></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"validityInsurance()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Colectividad</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancel()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div ng-if=\"show_certificates\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Categoría</th><th>ID</th></tr></thead><tbody><tr ng-repeat=\"item in dataCategories\"><td>{{ item.name }}</td><td>{{ item.id }}</td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"!showTableCertificates\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\"></label></div><div class=\"col-sm-6 col-md-3 form-group pull-right\" ng-if=\"!loader\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"goToInformation()\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Información Fianza Colectiva</button></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando certificados...</span></div></div></div><div class=\"row\" ng-if=\"showTableCertificates\"><div class=\"col-xs-1 form-group\"><select class=\"form-control\" ng-options=\"renewal.value for renewal in optionsViews\" ng-change=\"selectViews(optionViews)\" ng-model=\"optionViews\"></select></div><div><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\"><thead><tr><td>Certificado</td><td>Correo</td><td>Nombre</td><td>Apellido Paterno</td><td>Apellido Materno</td><td>RFC</td><td>Puesto</td><td>Actividad</td><td>Monto a Garantizar</td><td>Observaciones</td><td>Categoría</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.CERTIFICADO }}</td><td>{{ item.CORREO }}</td><td>{{ item.NOMBRE }}</td><td>{{ item.APELLIDO_PATERNO }}</td><td>{{ item.APELLIDO_MATERNO }}</td><td>{{ item.RFC }}</td><td>{{ item.PUESTO }}</td><td>{{ item.ACTIVIDAD }}</td><td>{{ item.MONTO_A_GARANTIZAR }}</td><td>{{ item.OBSERVACIONES }}</td><td>{{ item.CATEGORIA }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"saveCertificates()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Certificados</button></div></div></div>");
$templateCache.put("app/fianzaGpo/rehabilitate.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Rehabilitación de Fianza</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-if=\"ann.suretyInfo.poliza_number\"><span class=\"blue-color\">Fianza:</span><div>{{ ann.suretyInfo.poliza_number }}</div></div><div class=\"col-xs-12 form-group\" ng-if=\"!ann.suretyInfo.poliza_number\"><span class=\"blue-color\">Proyecto de Fianza:</span><div>{{ ann.suretyInfo.internal_number }}</div></div><div class=\"col-xs-12\"><label>Motivo de Rehabilitación: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" name=\"reason\" ng-model=\"ann.suretyInfo.reason_rehabilitate\"></textarea></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"saveSuretyRehabilitate()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Rehabilitar</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cerrar</button></div></div>");
$templateCache.put("app/fianzas/anular.fianzas.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Anular fianza</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"form-group col-sm-11\"><label for=\"motivo\">Motivo de anulación: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"motivo\" ng-model=\"motivo\" class=\"form-control\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Cerrar</button> <button class=\"btn btn-primary pull-right ladda-button\" ng-click=\"cancelFianza()\">Anular</button></div></div><script>\n    function renombrarArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n      strongTag.hide();\n      inputTag.show();\n      inputTag.focus();\n    }\n\n    function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target);\n\n      strongTag.show();\n      inputTag.hide();\n    }\n  </script>");
$templateCache.put("app/fianzas/cancel.fianzas.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Cancelar fianza</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group col-xs-12\"><label for=\"datecancel\">Fecha de cancelación: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vmm.surety.fecha_cancelacion\" value=\"{{date_cancel}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12\"><label for=\"motivo\">Monto de cancelación: <span class=\"color-red\">*</span></label> <input type=\"number\" name=\"motivo\" ng-model=\"vmm.surety.monto_cancelacion\" class=\"form-control\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Cerrar</button> <button class=\"btn btn-primary pull-right ladda-button\" ng-click=\"cancelSurety()\">Cancelar</button></div></div><script>\n    function renombrarArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n      strongTag.hide();\n      inputTag.show();\n      inputTag.focus();\n    }\n\n    function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target);\n\n      strongTag.show();\n      inputTag.hide();\n    }\n  </script>");
$templateCache.put("app/fianzas/contratantes.tab.html","<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\"><a href=\"\" ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude=\"\">{{heading}}</a></li>");
$templateCache.put("app/fianzas/contratantes.tabset.html","<div><ul class=\"nav nav-{{tabset.type || \'tabs\'}}\" ng-class=\"{\'nav-stacked\': vertical, \'nav-justified\': justified}\" ng-transclude=\"\"></ul><div class=\"tab-content\"><div class=\"tab-pane\" ng-repeat=\"tab in tabset.tabs\" ng-class=\"{active: tabset.active === tab.index}\" uib-tab-content-transclude=\"tab\"></div></div></div>");
$templateCache.put("app/fianzas/fianza_rehabilitar_modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Rehabilitar de Fianza</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 form-group\" align=\"center\"><label ng-if=\"ann.suretyInfo.poliza_number\">Fianza Colectiva {{ann.suretyInfo.poliza_number}}</label> <label ng-if=\"!ann.suretyInfo.poliza_number\">Proyecto de Fianza {{ann.suretyInfo.internal_number}}</label></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Inicio Vigencia:</label> <input class=\"form-control\" type=\"text\" name=\"startValidity\" ng-model=\"ann.suretyInfo.startValidity\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Fin Vigencia:</label> <input class=\"form-control\" type=\"text\" name=\"endValidity\" ng-model=\"ann.suretyInfo.endValidity\" disabled=\"\"></div><div class=\"col-xs-12 form-group\"><label>Contratante:</label> <input ng-if=\"ann.suretyInfo.contractor\" class=\"form-control\" type=\"text\" name=\"contractor.full_name\" ng-model=\"ann.suretyInfo.contractor.full_name\" disabled=\"\"></div><div class=\"col-xs-12\"><label>Razón de Rehabilitación: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" name=\"reason\" ng-model=\"ann.suretyInfo.reason_rehabilitate\"></textarea></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"savesuretyAnnulment(ann.suretyInfo)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Cambios</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cerrar</button></div></div>");
$templateCache.put("app/fianzas/fianzas.edit.html","<div ng-show=\"vm.show.firstTab == true\"><div ng-if=\"show_contractor\" class=\"animate z-index-9000\"><legend class=\"legend-title\" align=\"center\">Crear Contratante</legend><div><ng-include src=\"\'app/contratantes/contratantes.add.html\'\" ng-controller=\"ContratantesCtrl as vm\"></ng-include></div></div><div ng-if=\"!show_contractor\"><div class=\"col-xs-12 form-group\"><fieldset><legend class=\"legend-title\" align=\"center\">{{titulo_vista}} Fianza</legend><form name=\"form\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.form.identifier\"></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\" ng-hide=\"vm.form.status != 1\"><label for=\"folio-intenero\">Folio Interno</label> <input class=\"form-control\" name=\"folio-intenero\" disabled=\"\" type=\"text\" value=\"{{vm.form.internal_number}}\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.status != 1\"><label>Folio</label> <input class=\"form-control\" name=\"folio\" ng-model=\"vm.form.folio\" type=\"text\" ng-change=\"changeFolio()\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.status != 1\" ng-hide=\"reexpedir == 1 || reexpedir == \'1\'\"><label>Número de Fianza<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.poliza.$invalid && !form.poliza.$pristine }\"><input class=\"form-control\" ng-blur=\"checkNumFianza(vm.form.poliza_number)\" name=\"poliza\" ng-model=\"vm.form.poliza_number\" type=\"text\" ng-trim=\"false\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Vigencia</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"start_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.start_of_validity\" value=\"{{vm.form.start_of_validity}}\" ng-disabled=\"!vm.form.contratante\" ng-change=\"vm.checkDate(\'initial\')\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>al</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_of_validity\" value=\"{{vm.form.end_of_validity}}\" ng-disabled=\"!vm.form.contratante\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.form.status != 1\"><label>Fecha de emisión de Fianza</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.emision_date\" value=\"{{vm.form.emision_date}}\" ng-disabled=\"!vm.form.contratante\" data-date-format=\"dd/mm/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Afianzadora<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.aseguradora.$invalid && !form.aseguradora.$pristine }\"><select class=\"form-control\" ng-options=\"aseguradora as aseguradora.alias for aseguradora in vm.defaults.providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"vm.aseguradoraSelection()\" name=\"aseguradora\" ng-model=\"vm.form.aseguradora\" ng-disabled=\"!vm.form.contratante\"><option value=\"\">Selecciona un proveedor</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Clave de agente<span class=\"color-red\">*</span></label><div ng-if=\"!vm.defaults.claves.length\"><input type=\"text\" placeholder=\"No hay ninguna clave para esta afianzadora\" class=\"form-control\" disabled=\"\"></div><div ng-if=\"vm.defaults.claves.length == 1\" ng-init=\"vm.form.clave = vm.defaults.claves[0]\"><input type=\"text\" name=\"clave_agente\" class=\"form-control\" value=\"{{vm.defaults.claves[0].clave +\' - \'+ vm.defaults.claves[0].name}}\" disabled=\"\"></div><div ng-class=\"{ \'has-error\': form.clave.$invalid && !form.clave.$pristine }\"><select ng-if=\"vm.defaults.claves.length > 1\" class=\"form-control\" data-ng-options=\"clave as clave.clave +\' - \'+ clave.name for clave in vm.defaults.claves | orderBy: \'clave\' track by clave.url\" ng-change=\"vm.options.changeClave(vm.form.clave); changeClave()\" name=\"clave\" ng-model=\"vm.form.clave\" ng-disabled=\"!vm.form.afianzadora\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.ramo.$invalid && !form.ramo.$pristine }\"><select class=\"form-control\" ng-options=\"ramo as ramo.ramo_name for ramo in vm.defaults.ramos | orderBy:\'ramo_name\' track by ramo.url\" ng-change=\"vm.changeRamo();\" name=\"ramo\" ng-model=\"vm.form.ramo\" ng-disabled=\"!vm.form.afianzadora && !vm.form.clave\"><option value=\"\">Selecciona un ramo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramos<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"subramo as subramo.subramo_name for subramo in vm.defaults.subramos | orderBy:\'subramo_name\' track by subramo.url\" ng-change=\"vm.changeSubramo(vm.form.subramo)\" name=\"subramo\" ng-model=\"vm.form.subramo\" ng-disabled=\"!vm.form.ramo\"><option value=\"\">Selecciona un subramo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.defaults.types.length >0\"><label>Tipo de fianza <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.tipo.$invalid && !form.tipo.$pristine }\"><select class=\"form-control\" ng-options=\"type.type_name for type in vm.defaults.types | orderBy:\'type_name\' track by type.url\" ng-change=\"vm.changeTipo(vm.form.tipo)\" name=\"type\" ng-model=\"vm.form.tipo\" ng-disabled=\"!vm.form.subramo\"><option value=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectCurrency\">Moneda</label><select id=\"SelectCurrency\" class=\"form-control\" ng-options=\"currency.value as currency.label for currency in vm.form.currency.options\" ng-init=\"vm.form.currency.currency_selected = 1\" ng-model=\"vm.form.currency.currency_selected\" ng-change=\"changeCurrency()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Renovable <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.renewal.$invalid && !form.renewal.$pristine }\"><select class=\"form-control\" ng-options=\"renewal.value as renewal.label for renewal in vm.form.renewal.options\" ng-change=\"renewalSelection(vm.form.renewal.is_renewable)\" name=\"renewal\" ng-model=\"vm.form.renewal.is_renewable\" required=\"\"></select></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Fiado <span class=\"color-red\">*</span></label><div class=\"input-group\" ng-if=\"vm.acceso_adm_cont\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"matchesContractors(vm.form.contratante.val)\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.contratanteCreatorModalEvent()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div><div class=\"form-group\" ng-if=\"!vm.acceso_adm_cont\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"matchesContractors(vm.form.contratante.val)\"></autocomplete><span class=\"input-group-btn\" ng-if=\"vm.acceso_adm_cont\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.contratanteCreatorModalEvent(); show_contractor = true\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.address.$invalid && !form.address.$pristine }\"><select class=\"form-control\" data-ng-options=\"address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in vm.defaults.address track by address.url\" ng-change=\"vm.options.changeAddress(vm.form.address)\" name=\"address\" ng-model=\"vm.form.address\" ng-disabled=\"!vm.form.contratante\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" disabled=\"\" name=\"correo\" ng-blur=\"validarEmail(vm.form.contratante.email)\" ng-model=\"vm.form.contratante.email\" type=\"email\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono</label><phonenumber-directive disabledfield=\"true\" model=\"vm.form.contratante.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"inputValue\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div><div class=\"row col-xs-12 col-sm-6 col-md-6 nopadding form-group\" ng-if=\"vm.acceso_ver_ref\"><label>Referenciadores</label><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.form.referenciadores\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteReferenciador($index, 1)\" ng-disabled=\"vm.form.referenciadores.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b col-xs-8\" name=\"referenciador_policy\" ng-model=\"item.referenciador\" ng-change=\"changeReferenciador(item)\" ng-options=\"referenciador_policy.url as referenciador_policy.first_name + \' \' + referenciador_policy.last_name for referenciador_policy in usuarios\" ng-disabled=\"!vm.acceso_chng_ref\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\" ng-init=\"vm.form.referenciadores[$index].resp_type = 0\"><input class=\"form-control m-b col-xs-12 wb102\" type=\"text\" name=\"\" placeholder=\"% Comisión\" ng-model=\"item.comision_vendedor\" ng-disabled=\"vm.form.referenciadores.length <= 1\" ng-change=\"changeComRef(item)\" required=\"\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador(1)\" type=\"button\" ng-disabled=\"!vm.acceso_chng_ref\"><i class=\"glyphicon glyphicon-plus\"></i></button><a ng-disabled=\"!item.referenciador\" ng-show=\"item.selectedRef && vm.form.referenciadores.length > 1 && order.poliza.primaTotal\" class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); calculateComision(item, $index)\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i></a></div></div></div></div><div class=\"col-xs-12\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Bono Afianzadora:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"text\" ng-model=\"vm.form.bono_variable\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de Bono</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.date_bono\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkFechaFactura(vm.form.date_bono)\" ng-init=\"vm.checkFechaBono(vm.form.date_bono)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></form></fieldset></div><div class=\"col-md-12 col-sm-12 form-group\"><fieldset><legend>Detalle de Garantía</legend><div class=\"ibox float-e-margins\"><form role=\"form\" ng-model=\"vm.form.subforms\"><div class=\"form-group col-xs-12 col-md-8\"><label>Descripción <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.description\" type=\"text\" ng-change=\"save_info_tab()\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto a garantizar <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.guarantee_amount\" type=\"text\" ng-change=\"validateDecimalMontoTotal(vm.form.subforms.contract.guarantee_amount)\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Tarifa aplicable <span class=\"color-red\">* Cantidad hasta 4 decimales</span></label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.subforms.contract.rate\" ng-change=\"percentageRange(vm.form.subforms.contract.rate)\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div><div ng-if=\"vm.form.ramo.ramo_code == 4 && vm.form.subramo.subramo_code == 15\"><div class=\"form-group col-xs-12 col-md-4\"><label>Giro de la empresa <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.business_activity\" type=\"text\" ng-change=\"save_info_tab() /> </div> <div class=\" form-group=\"\" col-xs-12=\"\" col-md-4\"=\"\"> <label>Nombre del empleado <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.employee_name\" type=\"text\" ng-change=\"save_info_tab() /> </div> <div class=\" form-group=\"\" col-xs-12=\"\" col-md-4\"=\"\"> <label>Actividad que realiza <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.activity\" type=\"text\" ng-change=\"save_info_tab() /> </div> <div class=\" col-xs-12=\"\" col-sm-4=\"\" form-group\"=\"\"> <label>Deducible <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.subforms.contract.deductible_percentage\" ng-change=\"percentageRange(vm.form.subforms.contract.deductible_percentage)\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div></div><div ng-if=\"vm.form.subramo.subramo_code == 20 || vm.form.subramo.subramo_code == 21\"><div class=\"form-group col-xs-12 col-md-4\"><label>Número de contrato <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.number\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Plazo del documento fuente <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.subforms.contract.start\" value=\"{{vm.form.subforms.contract.start}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>al <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.subforms.contract.end\" value=\"{{vm.form.subforms.contract.end}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de firma del contrato <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.subforms.contract.sign_date\" value=\"{{vm.form.subforms.contract.sign_date}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto del contrato <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.amount\" type=\"text\" ng-change=\"validateDecimalMontoTotal(vm.form.subforms.contract.amount)\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto del contrato con IVA <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.amount_iva\" type=\"text\" ng-change=\"validateDecimalMontoTotal(vm.form.subforms.contract.amount_iva)\" disabled=\"\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Porcentaje a garantizar</label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.subforms.contract.guarantee_percentage\" ng-change=\"percentageRange(vm.form.subforms.contract.guarantee_percentage)\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div></div></form></div></fieldset></div><div class=\"col-md-12 col-sm-12 form-group\" id=\"modal_in\"><fieldset><legend align=\"right\">Beneficiarios</legend><label>Beneficiario existente <span class=\"color-red\">*</span></label><div class=\"input-group col-xs-12\"><autocomplete datasource=\"beneficiaries_data\" id=\"beneficiaries\" model=\"vm.form.defaults.benecifiary\" change=\"matchesBeneficiary(vm.form.defaults.benecifiary.val)\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"agregarBeneficiario(vm.form.defaults.benecifiary)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div><div ng-repeat=\"beneficiaries_fianza in vm.form.subforms.beneficiaries_fianza track by $index\"><div class=\"row address-container\"><div class=\"col-xs-12 legend-gray\"><br><br><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteBene($index, vm.form.subforms.beneficiaries_fianza)\">Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteBene($index, beneficiaries_fianza)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Nuevo Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addBene(beneficiaries_fianza)\" type=\"button\">Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addBene(beneficiaries_fianza)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 m-b\"><button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 2\" ng-click=\"beneficiaries_fianza.type_person = 1\">Física</button> <button class=\"btn btn-primary col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 1\" ng-click=\"beneficiaries_fianza.type_person = 1\">Física</button> <button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 1\" ng-click=\"beneficiaries_fianza.type_person = 2\">Moral</button> <button class=\"btn btn-prymary col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 2\" ng-click=\"beneficiaries_fianza.type_person = 2\">Moral</button></div><div ng-if=\"beneficiaries_fianza.type_person == 1\"><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"nombre{{$index}}\">Nombre <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"last{{$index}}\">Apellido Paterno <span class=\"color-red\">*</span></label> <input id=\"last{{$index}}\" name=\"last{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.second_last_name\" type=\"text\"></div></div><div ng-if=\"beneficiaries_fianza.type_person == 2\"><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"nombre{{$index}}\">Razón Social <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.j_name\" type=\"text\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">RFC</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.rfc\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Email</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.email\" type=\"email\" placeholder=\"example@example.com\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Teléfono</label><phonenumber-directive model=\"beneficiaries_fianza.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"beneficiaries_fianza.phone_number\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div></div></div></div></fieldset></div><div class=\"col-xs-12 col-sm-6 form-group\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"showPrograma\" ng-change=\"changeProgram(showPrograma)\"> <span>Pertenece a un Programa de Proveedores</span></h3></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"showPrograma\"><label>Nombre del Programa</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.contratante\" change=\"matchesShows(vm.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 form-group\"><fieldset><legend class=\"legend-title\" align=\"center\">Observaciones</legend><form name=\"form1\"><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-class=\"{ \'has-error\': form1.observations.$invalid && !form1.observations.$pristine }\"><textarea type=\"text\" class=\"form-control\" name=\"observations\" ng-model=\"vm.form.observations\"></textarea></div></div></form></fieldset></div><div class=\"col-xs-12 form-group\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\" ng-if=\"vm.acceso_adm_fia\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(vm.form.id)\">Guardar Archivos</button></div></div><div class=\"row\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos de fianza</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th></th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_input\" class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"saveFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"vm.deleteFile(file,files)\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\">Renombrar</button> <span class=\"btn btn-success display-none\">Guardar</span></td><td><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\">*Archivo sensible</td></tr></tbody></table></div></div><div ng-if=\"titulo_vista != \'Renovación\'\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de emisión de la Factura</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.date_emision_factura\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkFechaFactura(vm.form.date_emision_factura)\" ng-init=\"vm.checkFechaFactura(vm.form.date_emision_factura)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectMontEmision\">Mes de Emisión de la factura</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in vm.form.month.options\" ng-model=\"vm.form.month.month_selected\" ng-init=\"vm.form.month.month_selected = 0\" ng-change=\"changemonth()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectYearEmision\">Año de Emisión de la factura</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"vm.form.year_factura\" ng-change=\"changeyaer(vm.form.year_factura)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Folio Factura</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" value=\"{{vm.form.folio_factura}}\" ng-model=\"vm.form.folio_factura\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Maquila</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" value=\"{{vm.form.maquila}}\" ng-model=\"vm.form.maquila\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Fecha de Maquila</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.date_maquila\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkFechaMaquila(vm.form.date_maquila)\" ng-init=\"vm.checkFechaMaquila(vm.form.date_maquila)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Tipo cambio (captura)</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" value=\"{{vm.form.exchange_rate}}\" ng-model=\"vm.form.exchange_rate\"></div></div><button id=\"createCont\" ng-click=\"vm.contratanteCreatorModalEvent()\" class=\"display-none\"></button><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"vm.acceso_adm_fia\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"save()\"><span class=\"ladda-label\">Guardar</span></button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button ng-click=\"vm.cancel()\" class=\"col-xs-12 btn btn-white\" type=\"button\">Cancelar</button></div></div></div><script type=\"text/javascript\">\n    $(\'#select_user\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n    </script></div>");
$templateCache.put("app/fianzas/fianzas.generic.html","<div ng-show=\"vm.show.firstTab == true\"><div class=\"col-xs-12 form-group\"><fieldset><legend class=\"legend-title\" align=\"center\">Información General</legend><form name=\"form\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador</label> <input class=\"form-control\" type=\"text\" disabled=\"\" ng-model=\"vm.form.identifier\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-hide=\"vm.form.status == 1\"><label for=\"folio-intenero\">Folio Interno</label> <input class=\"form-control\" name=\"folio-interno\" ng-model=\"vm.form.internal_number\" disabled=\"\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-hide=\"vm.show.ot\"><label>Folio</label> <input class=\"form-control\" name=\"folio\" ng-model=\"vm.form.folio\" type=\"text\" ng-change=\"changeFolio(); saveLocalstorange();\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.status != 1\"><label>Número de Fianza<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.poliza.$invalid && !form.poliza.$pristine }\"><input class=\"form-control\" ng-blur=\"checkNumFianza(vm.form.poliza_number)\" name=\"poliza\" ng-model=\"vm.form.poliza_number\" ng-change=\"saveLocalstorange()\" type=\"text\" ng-trim=\"false\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.status != 1\"><label>Folio</label><div ng-class=\"{ \'has-error\': form.poliza.$invalid && !form.poliza.$pristine }\"><input class=\"form-control\" ng-blur=\"checkNumFianza(vm.form.folio)\" name=\"poliza\" ng-model=\"vm.form.folio\" ng-change=\"saveLocalstorange()\" type=\"text\" ng-trim=\"false\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.form.status != 1\"><label>Fecha de emisión de Fianza</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"emision_date\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.emision_date\" ng-disabled=\"!vm.form.contratante\" data-date-format=\"mm/dd/yyyy\" ng-change=\"saveLocalstorange()\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Vigencia</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"start_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.start_of_validity\" ng-disabled=\"!vm.form.contratante\" ng-change=\"vm.checkDate(vm.form.start_of_validity)\" data-date-format=\"mm/dd/yyyy\" ng-init=\"vm.checkDate(vm.form.start_of_validity)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>al</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_of_validity\" ng-disabled=\"!vm.form.contratante\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkEndDate(vm.form.end_of_validity)\" ng-init=\"vm.checkEndDate(vm.form.end_of_validity)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Afianzadora<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.afianzadora.$invalid && !form.afianzadora.$pristine }\"><select class=\"form-control\" ng-options=\"aseguradora as aseguradora.alias for aseguradora in vm.defaults.providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"vm.aseguradoraSelection(); saveLocalstorange();\" name=\"afianzadora\" ng-model=\"vm.form.afianzadora\" ng-disabled=\"!vm.form.contratante\"><option value=\"\">Selecciona un proveedor</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Clave de agente<span class=\"color-red\">*</span></label><div ng-if=\"!vm.defaults.claves.length\"><input type=\"text\" placeholder=\"No hay ninguna clave para esta afianzadora\" class=\"form-control\" disabled=\"\"></div><div ng-if=\"vm.defaults.claves.length == 1\" ng-init=\"vm.form.clave = vm.defaults.claves[0]\"><input type=\"text\" name=\"clave_agente\" class=\"form-control\" value=\"{{vm.defaults.claves[0].clave +\' - \'+ vm.defaults.claves[0].name}}\" disabled=\"\"></div><div ng-class=\"{ \'has-error\': form.clave.$invalid && !form.clave.$pristine }\"><select ng-if=\"vm.defaults.claves.length > 1\" class=\"form-control\" data-ng-options=\"clave as clave.clave +\' - \'+ clave.name for clave in vm.defaults.claves | orderBy: \'clave\' track by clave.url\" ng-change=\"vm.options.changeClave(vm.form.clave); changeClave(); saveLocalstorange();\" name=\"clave\" ng-model=\"vm.form.clave\" ng-disabled=\"!vm.form.afianzadora\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.ramo.$invalid && !form.ramo.$pristine }\"><select class=\"form-control\" ng-options=\"ramo as ramo.ramo_name for ramo in vm.defaults.ramos | orderBy:\'ramo_name\' track by ramo.url\" ng-change=\"vm.changeRamo(); saveLocalstorange();\" name=\"ramo\" ng-model=\"vm.form.ramo\" ng-disabled=\"!vm.form.afianzadora && !vm.form.clave\"><option value=\"\">Selecciona un ramo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramos<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"subramo as subramo.subramo_name for subramo in vm.defaults.subramos | orderBy:\'subramo_name\' track by subramo.url\" ng-change=\"vm.changeSubramo(vm.form.subramo); saveLocalstorange();\" name=\"subramo\" ng-model=\"vm.form.subramo\" ng-disabled=\"!vm.form.ramo\"><option value=\"\">Selecciona un subramo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.defaults.types.length >0\"><label>Tipo de fianza <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.tipo.$invalid && !form.tipo.$pristine }\"><select class=\"form-control\" ng-options=\"type.type_name for type in vm.defaults.types | orderBy:\'type_name\' track by type.url\" ng-change=\"vm.changeTipo(); saveLocalstorange();\" name=\"type\" ng-model=\"vm.form.tipo\" ng-disabled=\"!vm.form.subramo\"><option value=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectCurrency\">Moneda</label><select id=\"SelectCurrency\" class=\"form-control\" ng-options=\"currency.value as currency.label for currency in vm.form.currency.options\" ng-init=\"vm.form.currency.currency_selected = 1\" ng-model=\"vm.form.currency.currency_selected\" ng-change=\"changeCurrency(); saveLocalstorange();\"></select></div><div class=\"col-xs-12 col-sm-4 col-md-4 form-group\"><label>Renovable <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.renewal.$invalid && !form.renewal.$pristine }\"><select class=\"form-control\" ng-options=\"renewal.value as renewal.label for renewal in vm.form.renewal.options\" ng-change=\"renewalSelection(vm.form.renewal.selected); saveLocalstorange();\" name=\"renewal\" ng-model=\"vm.form.renewal.selected\" required=\"\"></select></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Fiado {{contrac.selected}} <span class=\"color-red\">*</span></label><div class=\"input-group\" ng-if=\"vm.acceso_adm_cont\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"matchesContractors(vm.form.contratante.val)\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.contratanteCreatorModalEvent()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div><div class=\"form-group\" ng-if=\"!vm.acceso_adm_cont\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"matchesContractors(vm.form.contratante.val)\"></autocomplete><span class=\"input-group-btn\" ng-if=\"vm.acceso_adm_cont\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.contratanteCreatorModalEvent(); show_contractor = true\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.address.$invalid && !form.address.$pristine }\"><select class=\"form-control\" data-ng-options=\"address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in vm.defaults.address track by address.url\" ng-change=\"vm.options.changeAddress(vm.form.address)\" name=\"address\" ng-model=\"vm.form.address\" ng-disabled=\"!vm.form.contratante\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" disabled=\"\" name=\"correo\" ng-blur=\"validarEmail(vm.form.contratante.email)\" ng-model=\"vm.form.contratante.email\" type=\"email\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono</label><phonenumber-directive disabledfield=\"true\" model=\"vm.form.contratante.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"inputValue\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div><div class=\"row col-xs-12 col-sm-6 col-md-6 nopadding form-group\"><label>Referenciadores <span class=\"color-red\" ng-if=\"vm.acceso_obligatorio_ref\">*</span></label><div class=\"nopadding form-group\" ng-repeat=\"item in vm.form.referenciadores track by $index\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteReferenciador($index, 1)\" ng-disabled=\"vm.form.referenciadores.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b col-xs-8\" name=\"referenciador_policy\" ng-model=\"item.referenciador\" ng-change=\"saveLocalstorange(); changeReferenciador(item)\" ng-options=\"referenciador_policy.url as referenciador_policy.first_name + \' \' + referenciador_policy.last_name for referenciador_policy in vendors\" ng-disabled=\"!vm.acceso_chng_ref\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\" ng-init=\"vm.form.referenciadores[$index].resp_type = 0\"><input class=\"form-control m-b col-xs-12 wb102\" type=\"text\" name=\"\" placeholder=\"% Comisión\" ng-model=\"item.comision_vendedor\" ng-disabled=\"!item.referenciador\" ng-change=\"changeComRef(item)\" required=\"\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador(1)\" type=\"button\" ng-disabled=\"!vm.acceso_chng_ref\"><i class=\"glyphicon glyphicon-plus\"></i></button><a ng-disabled=\"!item.referenciador\" ng-show=\"item.selectedRef && vm.form.referenciadores.length > 1 && order.poliza.primaTotal\" class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); calculateComision(item, $index)\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i></a></div></div></div></div><div class=\"col-xs-12\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 nopadding form-group\"><label>Bono Afianzadora:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" type=\"text\" ng-model=\"vm.form.bono_variable\" ng-change=\"saveLocalstorange()\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 nopadding form-group\"><label>Fecha de Bono</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.date_bono\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkFechaBono(vm.form.date_bono)\" ng-init=\"vm.checkFechaBono(vm.form.date_bono)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></form></fieldset></div><div class=\"col-md-12 col-sm-12 form-group\"><fieldset><legend align=\"right\">Detalle de Garantía</legend><div class=\"ibox float-e-margins\"><form role=\"form\" ng-model=\"vm.form.subforms\"><div class=\"form-group col-xs-12 col-md-8\"><label>Descripción <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.description\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto a garantizar <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span><input class=\"form-control\" ng-model=\"vm.form.subforms.contract.guarantee_amount\" type=\"text\" ng-blur=\"validateDecimalMontoTotal(vm.form.subforms.contract.guarantee_amount); formatearNumero(vm.form.subforms.contract.guarantee_amount,2); saveLocalstorange();\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Tarifa aplicable<span class=\"color-red\">* Cantidad hasta 4 decimales</span></label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.subforms.contract.rate\" ng-change=\"percentageRange(vm.form.subforms.contract.rate); saveLocalstorange();\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div><div ng-if=\"vm.form.ramo.ramo_code == 4 && vm.form.subramo.subramo_code == 15\"><div class=\"form-group col-xs-12 col-md-4\"><label>Giro de la empresa <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.business_activity\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Nombre del empleado <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.employee_name\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Actividad que realiza <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.activity\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Deducible<span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.subforms.contract.deductible_percentage\" ng-change=\"percentageRange(vm.form.subforms.contract.deductible_percentage); saveLocalstorange();\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div></div><div ng-if=\"vm.form.subramo.subramo_code == 20 || vm.form.subramo.subramo_code == 21\"><div class=\"form-group col-xs-12 col-md-4\"><label>Número de contrato <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.number\" ng-change=\"saveLocalstorange()\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Plazo del documento fuente del <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.subforms.contract.start\" data-date-format=\"mm/dd/yyyy\" ng-change=\"saveLocalstorange()\" ng-paste=\"fechas_upd(vm.form.subforms.contract.start,1,$event)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>al <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.subforms.contract.end\" data-date-format=\"mm/dd/yyyy\" ng-change=\"saveLocalstorange()\" ng-paste=\"fechas_upd(vm.form.subforms.contract.end,2,$event)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de firma del contrato <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.subforms.contract.sign_date\" ng-change=\"saveLocalstorange()\" data-date-format=\"mm/dd/yyyy\" ng-paste=\"fechas_upd(vm.form.subforms.contract.sign_date,3,$event)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto del contrato <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.amount\" type=\"text\" ng-blur=\"validateDecimalMontoTotal(vm.form.subforms.contract.amount); formatearNumero(vm.form.subforms.contract.amount,1); saveLocalstorange();\"></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Monto del contrato con IVA <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.form.subforms.contract.amount_iva\" type=\"text\" ng-change=\"validateDecimalMontoTotal(vm.form.subforms.contract.amount_iva); saveLocalstorange();\" disabled=\"\" format-as-currency=\"\"></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Porcentaje a garantizar</label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"vm.form.subforms.contract.guarantee_percentage\" ng-change=\"percentageRange(vm.form.subforms.contract.guarantee_percentage); saveLocalstorange();\" value=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div></div></form></div></fieldset></div><div class=\"col-md-12 col-sm-12 form-group\" id=\"modal_in\"><fieldset><legend align=\"right\">Beneficiarios</legend><label>Beneficiario existente <span class=\"color-red\">*</span></label><div class=\"input-group col-xs-12\"><autocomplete datasource=\"beneficiaries_data\" id=\"beneficiaries\" model=\"vm.form.defaults.benecifiary\" change=\"matchesBeneficiary(vm.form.defaults.benecifiary.val)\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"agregarBeneficiario(vm.form.defaults.benecifiary)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div><div ng-repeat=\"beneficiaries_fianza in vm.form.subforms.beneficiaries_fianza track by $index\"><div class=\"row address-container\"><div class=\"col-xs-12 legend-gray\"><br><br><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" ng-if=\"vm.form.subforms.beneficiaries_fianza.length > 1\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteBene($index, vm.form.subforms.beneficiaries_fianza)\">Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteBene($index, beneficiaries_fianza)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Nuevo Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addBene(beneficiaries_fianza)\" type=\"button\">Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addBene(beneficiaries_fianza)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 m-b\"><button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 2\" ng-click=\"beneficiaries_fianza.type_person = 1\">Física</button> <button class=\"btn btn-primary col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 1\" ng-click=\"beneficiaries_fianza.type_person = 1\">Física</button> <button class=\"btn btn-default col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 1\" ng-click=\"beneficiaries_fianza.type_person = 2\">Moral</button> <button class=\"btn btn-prymary col-xs-6\" ng-if=\"beneficiaries_fianza.type_person == 2\" ng-click=\"beneficiaries_fianza.type_person = 2\">Moral</button></div><div ng-if=\"beneficiaries_fianza.type_person == 1\"><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"nombre{{$index}}\">Nombre <span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"last{{$index}}\">Apellido Paterno</label> <input id=\"last{{$index}}\" name=\"last{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.second_last_name\" type=\"text\"></div></div><div ng-if=\"beneficiaries_fianza.type_person == 2\"><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"nombre{{$index}}\">Razón Social<span class=\"color-red\">*</span></label> <input id=\"nombre{{$index}}\" name=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.j_name\" type=\"text\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">RFC</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.rfc\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Email</label> <input id=\"secondLast{{$index}}\" name=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"beneficiaries_fianza.email\" type=\"email\" placeholder=\"example@example.com\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"secondLast{{$index}}\">Teléfono</label><phonenumber-directive model=\"beneficiaries_fianza.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"beneficiaries_fianza.phone_number\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div></div></div></div></fieldset></div><div class=\"col-xs-12 col-sm-6 form-group\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"showPrograma\" ng-change=\"testCheck(showPrograma)\"> <span>Pertenece a un Programa de Proveedores</span></h3></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"showPrograma\"><label>Nombre del Programa</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.contratante\" change=\"matchesShows(vm.contratante.val); saveLocalstorange()\"></autocomplete></div><div class=\"col-xs-12 form-group\"><fieldset><legend class=\"legend-title\" align=\"center\">Observaciones</legend><form name=\"form1\"><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-class=\"{ \'has-error\': form1.observations.$invalid && !form1.observations.$pristine }\"><textarea type=\"text\" class=\"form-control\" name=\"observations\" ng-model=\"vm.form.observations\" ng-change=\"saveLocalstorange()\"></textarea></div></div></form></fieldset></div><div class=\"col-xs-12 form-group\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"row\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.form.status != 1\"><label>Fecha de emisión de la Factura</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.date_emision_factura\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkFechaFactura(vm.form.date_emision_factura)\" ng-init=\"vm.checkFechaFactura(vm.form.date_emision_factura)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.form.status != 1\"><label for=\"SelectMontEmision\">Mes de Emisión de Factura</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in vm.form.month.options\" ng-model=\"vm.form.month_selected\" ng-change=\"saveLocalstorange()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.form.status != 1\"><label for=\"year\">Año Factura</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"vm.form.year_factura\" ng-change=\"saveLocalstorange()\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.form.status != 1\"><label for=\"folio-fact\">Folio Factura</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" ng-model=\"vm.form.folio_factura\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.form.status != 1\"><label for=\"folio-fact\">Maquila</label> <input class=\"form-control\" name=\"maquila\" type=\"text\" ng-model=\"vm.form.maquila\" ng-change=\"saveLocalstorange()\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.form.status != 1\"><label>Fecha de Maquila</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.date_maquila\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vm.checkFechaMaquila(vm.form.date_maquila)\" ng-init=\"vm.checkFechaFactura(vm.form.date_maquila)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.form.status != 1\"><label for=\"folio-fact\">Tipo Cambio (Captura)</label> <input class=\"form-control\" name=\"changeType\" type=\"number\" ng-model=\"vm.form.exchange_rate\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.form.status != 1\"><label>Fecha de entrega de la Factura</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.fecha_entrega\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkFechaFactura(vm.form.date_emision_factura)\" ng-init=\"vm.checkFechaFactura(vm.form.date_emision_factura)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div ng-if=\"vm.form.status != 1\"><receipts-endorsement form=\"vm.form\" tosave=\"dataToSave\" type=\"1\"></receipts-endorsement></div><script type=\"text/javascript\">\n    $(\'#select_user\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n    $(\'input.CurrencyInput\').on(\'blur\', function() {\n      const value = this.value.replace(/,/g, \'\');\n      this.value = parseFloat(value).toLocaleString(\'en-US\', {\n        style: \'decimal\',\n        maximumFractionDigits: 2,\n        minimumFractionDigits: 2\n      });\n    });\n    </script></div>");
$templateCache.put("app/fianzas/fianzas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Fianzas</h2><ol class=\"breadcrumb margin-top-15\"><li ng-if=\"!show_contractor\"><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\" ng-show=\"!show_contractor\"><strong>Fianzas</strong></li></ol></div></div><div ng-if=\"show_contractor\" class=\"animate z-index-9000\"><div><ng-include src=\"\'app/contratantes/contratantes.add.html\'\" ng-controller=\"ContratantesCtrl as vm\"></ng-include></div></div><br><div class=\"wrapper wrapper-content animated fadeIn ng-scope\" ng-if=\"!show_contractor\"><div class=\"row\"><div class=\"col-lg-12\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><uib-tabset active=\"activeJustified\" justified=\"true\" ng-if=\"vm.acceso_proy_fia\"><uib-tab index=\"0\" heading=\"Proyecto de Fianza\" ng-click=\"vm.form.status = 1;activateTab(\'ot\')\" ng-if=\"vm.acceso_proy_fia\"><div id=\"divCOT\" ng-include=\"\'app/fianzas/fianzas.generic.html\'\" active=\"activeJustified\"></div></uib-tab><uib-tab index=\"1\" heading=\"Fianza\" ng-click=\"vm.form.status = 10;activateTab(\'fianza\')\"><div id=\"divCPoliza\" ng-include=\"\'app/fianzas/fianzas.generic.html\'\"></div></uib-tab></uib-tabset><uib-tabset active=\"activeJustified\" justified=\"true\" ng-if=\"!vm.acceso_proy_fia\"><uib-tab index=\"0\" heading=\"Fianza\" ng-click=\"vm.form.status = 10;activateTab(\'fianza\')\"><div id=\"divCPoliza\" ng-include=\"\'app/fianzas/fianzas.generic.html\'\"></div></uib-tab></uib-tabset></div></div></div></div><div class=\"row\"><div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"vm.acceso_adm_fia\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"save()\" data-style=\"expand-right\"><span class=\"ladda-label\">Guardar</span></button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button ng-click=\"vm.cancel()\" class=\"col-xs-12 btn btn-white\" type=\"button\">Cancelar</button></div></div></div><br><br></div>");
$templateCache.put("app/fianzas/fianzas.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Fianzas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a ui-sref=\"fianzas.list\">Fianzas</a></li><li class=\"active\"><strong ng-if=\"vm.insurance.poliza_number && vm.acceso_adm_fia\">Fianza #{{vm.insurance.poliza_number}}</strong> <strong ng-if=\"!vm.insurance.poliza_number && vm.acceso_adm_ot\">Orden</strong></li></ol></div></div><div class=\"btn-group pull-right m-b option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_ver_cont\"><a ng-click=\"vm.viewContractor(\'Información contratante\',\'contratantes.info\')\">Ver información del fiado</a></li><li ng-if=\"vm.acceso_adm_fia && (vm.insurance.status !=1 && vm.insurance.status != 2) && vm.insurance.poliza_number\"><a ui-sref=\"fianzas.editar({polizaId: vm.insurance.id})\">Editar</a></li><li ng-if=\"vm.acceso_adm_ot && (vm.insurance.status ==1 || vm.insurance.status == 2 || !vm.insurance.poliza_number)\"><a ui-sref=\"fianzas.editar({polizaId: vm.insurance.id})\">Editar OT</a></li><li ng-if=\"vm.acceso_adm_ot && (vm.insurance.status ==1 || vm.insurance.status == 2 || !vm.insurance.poliza_number)\"><a ng-click=\"vm.saveAsInsurance(vm.insurance)\">Convertir a fianza</a></li><li ng-if=\"vm.acceso_elim_fia && (vm.insurance.status !=1 && vm.insurance.status != 2) && vm.insurance.poliza_number\"><a ng-click=\"vm.deleteFianza(vm.insurance.id)\" ng-hide=\"vm.insurance.status == 11\">Eliminar Fianza</a></li><li ng-if=\"vm.acceso_elim_ot && (vm.insurance.status ==1 || vm.insurance.status == 2 || !vm.insurance.poliza_number)\"><a ng-click=\"vm.deleteFianza(vm.insurance.id)\" ng-hide=\"vm.insurance.status == 11\">Eliminar OT</a></li><li ng-if=\"vm.acceso_adm_fia\"><a ng-if=\"vm.insurance.status !=1 && vm.insurance.poliza_number\" ng-hide=\"vm.insurance.status ==11 || vm.insurance.status == 17\" ng-click=\"vm.anularFianza(vm.insurance)\">Anular fianza</a></li><li ng-if=\"vm.acceso_adm_fia\"><a ng-if=\"(vm.insurance.status ==17 || vm.insurance.status == 24) && (vm.insurance.concept_annulment == 4 || vm.insurance.concept_annulment == 5)\" ng-hide=\"vm.insurance.status ==11\" ng-click=\"vm.rehabilitarFianza(vm.insurance)\">Rehabilitar fianza</a></li><li ng-if=\"vm.acceso_adm_fia\"><a ng-if=\"vm.insurance.status !=1 && vm.insurance.poliza_number\" ng-hide=\"vm.insurance.is_renewable ==2 || vm.insurance.renewed_status ==1\" ng-click=\"vm.renovacion(vm.insurance.id)\">Renovar fianza</a></li><li ng-if=\"vm.acceso_adm_fia\"><a ng-if=\"vm.insurance.status !=1 && vm.insurance.poliza_number\" ng-hide=\"vm.insurance.status == 11 || vm.insurance.status == 17 || vm.insurance.status == 24\" ng-click=\"vm.crearEndoso(\'Endoso\', \'endorsement.fianza\', vm.insurance.id)\">Crear endoso</a></li><li><a ng-click=\"vm.cancelPolicy(vm.insurance)\" ng-if=\"vm.acceso_adm_fia && (vm.insurance.status !=1 && vm.insurance.status != 2) && vm.insurance.poliza_number\">Cancelar fianza</a></li><li><a ng-click=\"vm.cancelPolicy(vm.insurance)\" ng-if=\"vm.acceso_adm_fia && (vm.insurance.status ==1 || vm.insurance.status == 2 || !vm.insurance.poliza_number)\">Cancelar OT</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length && vm.permiso_archivos && vm.permiso_administrar_adjuntos\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, carta.id)\">{{carta.name}}</a></li></ul></li></ul></div><br><div class=\"row\" ng-if=\"vm.infoFlag\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"vm.insurance.poliza_number\">Información de la fianza</h5><h5 ng-if=\"!vm.insurance.poliza_number\">Información de la OT</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"vm.getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button> <button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(vm.insurance,13)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"vm.insurance.poliza_number\"><div class=\"col-xs-12 col-sm-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ contratante.full_name }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"addressContratante\"><span class=\"blue-color\">Dirección</span><div><span ng-if=\"addressContratante.route\">{{ addressContratante.route }}</span> <span ng-if=\"addressContratante.street_number && !addressContratante.street_number_int\">{{ addressContratante.street_number }},</span> <span ng-if=\"addressContratante.street_number && addressContratante.street_number_int\">{{ addressContratante.street_number }}</span> <span ng-if=\"addressContratante.street_number_int\">Int.{{ addressContratante.street_number_int }},</span> <span ng-if=\"addressContratante.sublocality\">{{ addressContratante.sublocality }}</span><div><span ng-if=\"addressContratante.administrative_area_level_2\">{{addressContratante.administrative_area_level_2}}</span> <span ng-if=\"addressContratante.administrative_area_level_1\">, {{ addressContratante.administrative_area_level_1 }}</span></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Telefono</span><div><span>{{contratante.phone_number | phonenumber}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo</span><div><span>{{contratante.email}}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.acceso_ver_ot && endososFianza.length > 0\"><button type=\"button\" class=\"btn btn-primary m-r-sm\" ng-click=\"showEndorsements(vm.insurance)\" ng-disabled=\"endososFianza.length == 0\">{{endososFianza.length}}</button><span class=\"blue-color\">Endosos</span></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.acceso_ver_ot && vm.endorsement_receipts_show.length > 0\"><button type=\"button\" class=\"btn btn-primary m-r-sm\" ng-disabled=\"endososFianza.length == 0\">{{vm.endorsement_receipts_show.length}}</button><span class=\"blue-color\">Recibos de endosos / Notas de crédito</span></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"vm.showRecordatorios()\">{{vm.insurance.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><legend class=\"legend-title\" align=\"center\">Fianza</legend><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" style=\"word-wrap: break-word;\"><span class=\"blue-color\">Identificador</span><br><span>{{ vm.insurance.identifier }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Número de fianza</span><div><span>{{ vm.insurance.poliza_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.folio\"><span class=\"blue-color\">Folio</span><div><span>{{ vm.insurance.folio }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Folio Interno</span><div><span>{{ vm.insurance.internal_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Afianzadora - Clave Agente</span><div><span>{{ vm.insurance.aseguradora.alias }} - {{vm.insurance.clave.clave}} <span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Ramo</span><div><span>{{ vm.insurance.ramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Subramos</span><div><span>{{ vm.insurance.subramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.fianza_type\"><span class=\"blue-color\">Tipo de fianza</span><div><span>{{ vm.insurance.fianza_type }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Vigencia</span><div><span>{{ vm.insurance.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ vm.insurance.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de emisión de Fianza</span><div><span>{{ vm.insurance.emision_date | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Estatus</span><div><div class=\"label\" ng-class=\"{\'label-success\': vm.insurance.status == 1, \'label-info\' : vm.insurance.status == 10, \'label-primary\' : vm.insurance.status == 14, \'label-warning\' : vm.insurance.status == 2 || vm.insurance.status == 4 || vm.insurance.status == 11 || vm.insurance.status == 12 || vm.insurance.status == 17 || vm.insurance.status == 24}\" style=\"margin-right: 10px\">{{ status(vm.insurance.status) }}</div></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"vm.insurance.status == 17 || vm.insurance.status == 24\"><span class=\"blue-color\">Concepto de anulación:</span><div><span ng-if=\"vm.insurance.concept_annulment == 1\">Preanulación</span> <span ng-if=\"vm.insurance.concept_annulment == 2\">Error de Captura</span> <span ng-if=\"vm.insurance.concept_annulment == 3\">Reexpedición</span> <span ng-if=\"vm.insurance.concept_annulment == 4\">Falta de Pago</span> <span ng-if=\"vm.insurance.concept_annulment == 5\">Otro</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-8 form-group\" ng-if=\"vm.insurance.status == 17 || vm.insurance.status == 24\"><span class=\"blue-color\">Razón de anulación:</span><div><span>{{ vm.insurance.reason_cancel }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.insurance.reason_rehabilitate\"><span class=\"blue-color\">Motivo de rehabilitación:</span><div><span>{{ vm.insurance.reason_rehabilitate }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.fecha_cancelacion\"><span class=\"blue-color\">Fecha Cancelación:</span><div><span>{{ vm.insurance.fecha_cancelacion | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaCancelacion()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.monto_cancelacion\"><span class=\"blue-color\">Monto Cancelación:</span><div><span>{{ vm.insurance.monto_cancelacion | currency }}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeMontoCancelacion()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.f_currency\"><span class=\"blue-color\">Moneda: &nbsp;</span><div><span ng-if=\"vm.insurance.f_currency == 1\">Pesos</span> <span ng-if=\"vm.insurance.f_currency == 2\">Dolares</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.tarifa_afianzada\"><span class=\"blue-color\">Tarifa afianzada: &nbsp;</span><div><span>{{vm.insurance.tarifa_afianzada }}%</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.project_name\"><span class=\"blue-color\">Nombre del proyecto: &nbsp;</span><div><span>{{vm.insurance.project_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.is_renewable\"><span class=\"blue-color\">Renovable: &nbsp;</span><div><span ng-if=\"vm.insurance.is_renewable == 1\">Renovable</span> <span ng-if=\"vm.insurance.is_renewable == 2\">No Renovable</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.emision_status\"><span class=\"blue-color\">Estatus de emisión: &nbsp;</span><div><span ng-if=\"vm.insurance.emision_status == 1\">Documentos recibidos</span> <span ng-if=\"vm.insurance.emision_status == 2\">Documentos pendientes</span> <span ng-if=\"vm.insurance.emision_status == 3\">Carga de documentos</span> <span ng-if=\"vm.insurance.emision_status == 4\">En autorización</span> <span ng-if=\"vm.insurance.emision_status == 5\">Emitida</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\"><b>Creado por: &nbsp;</b></span><div>{{vm.insurance.owner}}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"vm.acceso_ver_ref\"><span class=\"blue-color\"><b>Referenciador(es): &nbsp;</b></span><div ng-repeat=\"ref in vm.insurance.ref_policy\">{{ref.ref_name}} <span ng-if=\"ref.comision_vendedor\">|| {{ref.comision_vendedor}}%</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><label class=\"blue-color\">Bono Afianzadora:</label><div class=\"input-group\"><span>{{ vm.insurance.bono_variable | currency }}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeBono()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Bono:</span><div><span>{{ vm.insurance.date_bono | date: \'dd/MM/yyyy\' : \'UTC\' }}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaBono()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\">Programa de Proveedores:</span><div class=\"input-group\"><span>{{ programa.full_name }}</span></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-3 form-group\"><span class=\"blue-color\">Prima Primera:</span><div>{{ vm.insurance.p_neta | currency}}</div></div><div class=\"col-xs-12 col-sm-3 form-group\"><span class=\"blue-color\">Derecho:</span><div>{{ vm.insurance.rpf | currency}}</div></div><div class=\"col-xs-12 col-sm-3 form-group\"><span class=\"blue-color\">Gastos de expedición:</span><div>{{ vm.insurance.derecho | currency}}</div></div><div class=\"col-xs-12 col-sm-3 form-group\"><span class=\"blue-color\">Iva:</span><div>{{ vm.insurance.iva | currency}}</div></div><div class=\"col-xs-12 col-sm-3 form-group\"><span class=\"blue-color\">Prima Total:</span><div>{{ vm.insurance.p_total | currency}}</div></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><span class=\"blue-color\">Comisión:</span><div>{{ vm.insurance.comision | currency}} <button class=\"btn btn-white btn-sm\" ng-click=\"changecomission(1)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"vm.insurance.poliza_number && !changeDom\"><span class=\"blue-color\">Cargo Automático:</span><div><span ng-if=\"vm.insurance.conducto_de_pago == 1\" aria-hidden=\"true\"><span>No Domiciliado</span></span> <span ng-if=\"vm.insurance.conducto_de_pago == 2\" aria-hidden=\"true\"><span>Agente</span></span> <span ng-if=\"vm.insurance.conducto_de_pago == 3\" aria-hidden=\"true\"><span>CAC</span></span> <span ng-if=\"vm.insurance.conducto_de_pago == 4\" aria-hidden=\"true\"><span>CAT Domiciliado</span></span> <span ng-if=\"vm.insurance.conducto_de_pago == 5\" aria-hidden=\"true\"><span>Nómina</span></span> <span ng-if=\"vm.insurance.conducto_de_pago == 6\" aria-hidden=\"true\"><span>CUT</span></span> <button class=\"btn btn-white btn-sm\" ng-click=\"changedomiciliado()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> Cambiar</button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"changeDom\"><label for=\"SelectConducto\">Conducto de pago <span class=\"color-red\">*</span></label><select id=\"SelectConducto\" class=\"form-control\" ng-options=\"conducto_de_pago.value as conducto_de_pago.label for conducto_de_pago in conducto_de_pago.options\" ng-model=\"vm.insurance.conducto_de_pago\" ng-change=\"changedomiciliado1(vm.insurance.conducto_de_pago)\"></select></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><span class=\"blue-color\">Porcentaje Comisión:</span><div>{{ vm.insurance.comision_percent}}% <button class=\"btn btn-white btn-sm\" ng-click=\"changecomission(2)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Pago de Comisión:</span><div><span>{{ vm.insurance.fecha_pago_comision | date: \'dd/MM/yyyy\' : \'UTC\' }}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaComision()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Maquila:</span><div><span>{{ vm.insurance.maquila | currency}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeMaquila()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha Maquila:</span><div><span>{{ vm.insurance.date_maquila | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaMaquila()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha Emisión Factura:</span><div><span>{{ vm.insurance.date_emision_factura | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaEmisionF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!openMonth\"><span class=\"blue-color\">Mes de Emisión de Factura:</span><div><span>{{ monthEmision(vm.insurance.month_factura)}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeMesF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"openMonth\"><label class=\"blue-color\" for=\"SelectMontEmision\">Mes de Emisión de Factura</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in month.options\" ng-model=\"month.month_selected\" ng-init=\"month.month_selected = vm.insurance.month_factura\" ng-change=\"changemonth()\"></select><button class=\"btn btn-white btn-sm\" ng-click=\"changeMesF1(month.month_selected)\"><i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"!openYear\"><span class=\"blue-color\">Año Factura:</span><div><span>{{ vm.insurance.year_factura}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changYearF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"openYear\"><label class=\"blue-color\" for=\"SelectYearEmision\">Año de Factura</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"vm.form.year_factura\" ng-change=\"changeyaer(vm.form.year_factura)\"><option value=\"\"></option></select><button class=\"btn btn-white btn-sm\" ng-click=\"changeYearF1(vm.form.year_factura)\"><i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Folio Factura:</span><div><span>{{ vm.insurance.folio_factura}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFolioF()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Tipo de Cambio (Captura):</span><div><span>{{ vm.insurance.exchange_rate | currency }}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeTipoC()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha Entrega:</span><div><span>{{ vm.insurance.fecha_entrega | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaEntrega()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div></div></div><div ng-if=\"!vm.insurance.poliza_number\"><div class=\"col-xs-12 col-sm-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{ contratante.full_name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Dirección:</span><div><span>{{ addressContratante.route }} {{ addressContratante.street_number }}, {{ addressContratante.sublocality }}.</span><div><span>{{ addressContratante.administrative_area_level_1}}, {{addressContratante.administrative_area_level_2}}.</span></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Teléfono:</span><div><span>{{contratante.phone_number | phonenumber}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo:</span><div><span>{{contratante.email}}</span></div></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"vm.showRecordatorios()\">{{vm.insurance.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><legend class=\"legend-title\" align=\"center\">Generales</legend><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" style=\"word-wrap: break-word;\"><span class=\"blue-color\">Identificador</span><br><span>{{ vm.insurance.identifier }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Folio Interno</span><div><span>{{ vm.insurance.internal_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Afianzadora - Clave Agente:</span><div><span>{{ vm.insurance.aseguradora.alias }} - {{vm.insurance.clave.clave}} <span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ vm.insurance.ramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.insurance.subramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Tipo de fianza:</span><div><span>{{ vm.insurance.fianza_type }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha Inicio - Fecha Fin:</span><div><span>{{ vm.insurance.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ vm.insurance.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Estatus:</span><div><div class=\"label\" ng-class=\"{\'label-success\': vm.insurance.status == 1, \'label-info\' : vm.insurance.status == 10, \'label-primary\' : vm.insurance.status == 14, \'label-warning\' : vm.insurance.status == 2 || vm.insurance.status == 4 || vm.insurance.status == 11 || vm.insurance.status == 12 || vm.insurance.status == 17 || vm.insurance.status == 24}\" style=\"margin-right: 10px\">{{ status(vm.insurance.status) }}</div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.tarifa_afianzada\"><span class=\"blue-color\">Tarifa afianzada:</span><div><span>{{vm.insurance.tarifa_afianzada }}%</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.f_currency\"><span class=\"blue-color\">Moneda: &nbsp;</span><div><span ng-if=\"vm.insurance.f_currency == 1\">Pesos</span> <span ng-if=\"vm.insurance.f_currency == 2\">Dolares</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.project_name\"><span class=\"blue-color\">Nombre del proyecto:</span><div><span>{{vm.insurance.project_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.number_inclusion\"><span class=\"blue-color\">Número de inclusión:</span><div><span>{{vm.insurance.number_inclusion }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.is_renewable\"><span class=\"blue-color\">Renovable:</span><div><span ng-if=\"vm.insurance.is_renewable == 1\">Renovable</span> <span ng-if=\"vm.insurance.is_renewable == 2\">No Renovable</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.emision_status\"><span class=\"blue-color\">Estatus de emisión:</span><div><span ng-if=\"vm.insurance.emision_status == 1\">Documentos recibidos</span> <span ng-if=\"vm.insurance.emision_status == 2\">Documentos pendientes</span> <span ng-if=\"vm.insurance.emision_status == 3\">Carga de documentos</span> <span ng-if=\"vm.insurance.emision_status == 4\">En autorización</span> <span ng-if=\"vm.insurance.emision_status == 5\">Emitida</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\"><b>Creado por:</b></span><div>{{vm.insurance.owner}}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\"><b>Referenciador(es): &nbsp;</b></span><div ng-repeat=\"ref in vm.insurance.ref_policy\">{{ref.ref_name}}</div></div><div ng-if=\"vm.insurance.vendor\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\"><b>Referenciador: &nbsp;</b></span><div>{{vm.insurance.vendor.first_name}} {{vm.insurance.vendor.last_name}}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><label class=\"blue-color\">Bono Afianzadora:</label><div><span>{{ vm.insurance.bono_variable | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Bono:</span><div><span>{{ vm.insurance.date_bono | date: \'dd/MM/yyyy\' : \'UTC\' }}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaBono()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\">Programa de Proveedores:</span><div class=\"input-group\"><span>{{ programa.first_name }} {{ programa.last_name }} {{ programa.second_last_name }} {{ programa.j_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Fecha de Pago de Comisión:</span><div><span>{{ vm.insurance.fecha_pago_comision | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeFechaComision()\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-6 form-group pull-right\" ng-if=\"vm.insurance.task_associated\"><button type=\"button\" class=\"btn btn-white btn-sm btn-secondary\" ng-click=\"openModal(vm.insurance.task_associated_info)\">{{ vm.isCollapsed ? \'Ocultar\' : \'Ver\' }} Tarea Origen</button></div></div></div></div></div></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"endososFianza.length > 0\"><div class=\"ibox-title\"><h5>Endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><table class=\"table table-hover table-bordered\"><thead><th>Tipo</th><th>Número de endoso</th><th>Concepto</th><th>Descripción</th><th>Vigencia</th><th>Estatus</th></thead><tbody><tr ng-repeat=\"endorsement in endososFianza track by $index\" ng-click=\"goToEndorsementInfo(endorsement)\"><td>{{ endorsement.endorsement_type }}</td><td ng-if=\"endorsement.number_endorsement\">{{ endorsement.number_endorsement }}</td><td ng-if=\"!endorsement.number_endorsement\">Sin número asigando</td><td>{{ concept(endorsement.concept) }}<span ng-if=\"concept(endorsement.concept) == \'OTRO\'\">:</span> {{endorsement.other_desc}}</td><td>{{ endorsement.observations}}</td><td>{{ endorsement.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ endorsement.end_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td ng-if=\"endorsement.status == 1\">Pendiente</td><td ng-if=\"endorsement.status == 2\">Registrado</td><td ng-if=\"endorsement.status == 3\">Rechazado</td><td ng-if=\"endorsement.status == 5\">En trámite</td><td ng-if=\"endorsement.status == 4\">Cancelado</td><td ng-if=\"endorsement.status == 6\">Anulado</td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Detalle</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-md-6\"><legend class=\"legend-title\" align=\"center\">Contrato</legend><div class=\"col-md-12\"><div><span class=\"blue-color\">Descripción: &nbsp;</span> <span>{{ contrato.description }}</span></div><div><span class=\"blue-color\">Monto a garantizar: &nbsp;</span> <span>{{ contrato.guarantee_amount | currency}}</span></div><div><span class=\"blue-color\">Tarifa aplicable: &nbsp;</span> <span>{{ contrato.rate }}%</span></div></div><div class=\"col-md-12\" ng-if=\"vm.insurance.ramo == \'Fidelidad\' && vm.insurance.subramo == \'Individual\'\"><div><span class=\"blue-color\">Giro de la empresa: &nbsp;</span> <span>{{ contrato.business_activity }}</span></div><div><span class=\"blue-color\">Nombre del empleado: &nbsp;</span> <span>{{ contrato.employee_name }}</span></div><div><span class=\"blue-color\">Actividad que realiza: &nbsp;</span> <span>{{ contrato.activity }}</span></div><div><span class=\"blue-color\">Deducible (%): &nbsp;</span> <span>{{ contrato.deductible_percentage }}</span></div></div><div class=\"col-md-12\" ng-if=\"vm.insurance.subramo == \'Obra\' || vm.insurance.subramo == \'Proveeduria\'\"><div><span class=\"blue-color\">Número de contrato: &nbsp;</span> <span>{{ contrato.number }}</span></div><div><span class=\"blue-color\">Plazo del documento fuente: &nbsp;</span> <span>{{ contrato.start | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ contrato.end | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div><span class=\"blue-color\">Fecha de firma del contrato: &nbsp;</span> <span>{{ contrato.sign_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div><span class=\"blue-color\">Monto del contrato: &nbsp;</span> <span>{{ contrato.amount | currency}}</span></div><div><span class=\"blue-color\">Monto del contrato con IVA: &nbsp;</span> <span>{{ contrato.amount_iva | currency}}</span></div><div><span class=\"blue-color\">Porcentaje a garantizar: &nbsp;</span> <span>%{{ contrato.guarantee_percentage }}</span></div></div></div><div class=\"col-xs-12 col-md-6\"><legend class=\"legend-title\" align=\"center\">Beneficiarios</legend><div ng-repeat=\"item in vm.insurance.beneficiaries_poliza_many\"><div><span class=\"blue-color\">Nombre:</span> <span>{{item.first_name}} {{item.last_name}} {{item.second_last_name}} {{item.j_name}}</span></div><div><span class=\"blue-color\">RFC:</span> <span>{{item.rfc }}</span></div><div><span class=\"blue-color\">Teléfono:</span> <span>{{item.phone_number | phonenumber}}</span></div><div><span class=\"blue-color\">Email:</span> <span>{{item.email}}</span></div><hr ng-if=\"vm.insurance.beneficiaries_poliza_many.length > 1\"></div></div><br></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><h4>Observaciones: <textarea disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.insurance.observations\"></textarea></h4></div></div><div class=\"row\" ng-if=\"vm.acceso_ver_fia || vm.acceso_ver_ot\"><div class=\"col-xs-12\" ng-if=\"vm.fianza_history && vm.fianza_history.length > 0\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Histórico reexpediciones, renovaciones y cancelaciones</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div ng-if=\"!vm.show_binnacle_receipt\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th>Número de Fianza</th><th>Vigencia</th><th>Estatus</th><th>Fecha de Reexpedición</th><th>Reexpedido Por:</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.fianza_history track by $index\" ui-sref=\"fianzas.info({polizaId: insurance.id})\"><td ng-if=\"insurance.poliza_number\">{{insurance.poliza_number}}</td><td ng-if=\"!insurance.poliza_number\">Sin número asignado</td><td>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{status(insurance.status)}}</td><td>{{insurance.created_at | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{insurance.owner}}</td></tr></tbody></table></div></div></div></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"vm.recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"vm.recordatoriosFlag = false; vm.infoFlag = true\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in vm.insurance.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div class=\"row\" ng-if=\"vm.permiso_archivos && vm.permiso_administrar_adjuntos\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 form-group\"><div><div class=\"row\" ng-if=\"vm.acceso_adm_fia && vm.insurance.status != 1 && vm.insurance.status != 2 && vm.permiso_administrar_adjuntos\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 text-right form-group\" ng-if=\"vm.acceso_adm_fia && vm.insurance.status != 1 && vm.insurance.status != 2 && vm.permiso_administrar_adjuntos\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(vm.insurance.id)\">Guardar Archivos</button></div><div class=\"row\" ng-if=\"vm.acceso_adm_ot && (vm.insurance.status == 1 || vm.insurance.status == 2) && vm.permiso_administrar_adjuntos\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 text-right form-group\" ng-if=\"vm.acceso_adm_ot && (vm.insurance.status == 1 || vm.insurance.status == 2) && vm.permiso_administrar_adjuntos\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(vm.insurance.id)\">Guardar Archivos</button></div><table class=\"table table-bordered\"><br><h3><span><i>Archivos de fianza</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th></th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_input\" class=\"form-control display-none\" ng-if=\"vm.permiso_administrar_adjuntos\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"saveFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"vm.deleteFile(file,files)\" ng-if=\"vm.permiso_administrar_adjuntos\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"vm.permiso_administrar_adjuntos\">Renombrar</button> <span class=\"btn btn-success display-none\" ng-if=\"vm.permiso_administrar_adjuntos\">Guardar</span></td><td><input ng-if=\"vm.permiso_administrar_adjuntos\" type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\">*Archivo sensible</td></tr></tbody></table></div></div><div class=\"col-xs-12 form-group\" ng-if=\"filesCancel\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos de cancelación</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th></th></tr></thead><tbody><tr ng-repeat=\"file in filesCancel track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_input\" class=\"form-control display-none\" ng-if=\"vm.permiso_administrar_adjuntos\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"saveFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"vm.deleteFile(file,filesCancel)\" ng-if=\"vm.permiso_administrar_adjuntos\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"vm.permiso_administrar_adjuntos\">Renombrar</button> <span class=\"btn btn-success display-none\">Guardar</span></td><td><input type=\"checkbox\" ng-if=\"vm.permiso_administrar_adjuntos\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\">*Archivo sensible</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"vm.policy_receipts_show.length > 0\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de fianza</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div ng-if=\"!vm.show_binnacle_receipt\"><table class=\"table table-bordered table-hover hidden-xs hidden-sm\"><thead><tr><th ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}}</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th><th ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}}</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}}</th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th></tr></thead><tbody><tr ng-click=\"vm.changeStatusModal(receipt,vm.insurance)\" ng-repeat=\"receipt in vm.insurance.recibos_poliza track by $index\" ng-if=\"receipt.receipt_type == 1 && receipt.status != 0\"><td>{{ receipt.recibo_numero }} / {{vm.policy_receipts_show.length}}</td><td>{{ receipt.prima_neta | currency }}</td><td>{{ receipt.rpf | currency }}</td><td>{{ receipt.derecho | currency }}</td><td>{{ receipt.iva | currency }}</td><td ng-if=\"vm.permiso_comisiones\">{{ receipt.comision | currency }}</td><td>{{ receipt.prima_total | currency }}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8 || receipt.status == 10 || receipt.status == 11}\">{{ vm.checkStatusReceipts(receipt.status) }}</div></td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-if=\"vm.permiso_correo && !receipt.track_email\" ng-click=\"addEmailsConfirmPolicy(receipt, vm.insurance.natural, vm.insurance.juridical, vm.insurance.contractor)\" ng-disabled=\"!(receipt.status == 4)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-if=\"vm.permiso_correo && receipt.track_email\" ng-click=\"addEmailsConfirmPolicy(receipt, vm.insurance.natural, vm.insurance.juridical, vm.insurance.contractor)\" ng-disabled=\"receipt.status != 4\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-if=\"!receipt.track_bitacora\" ng-click=\"vm.showBinnacleReceipt(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"receipt.track_bitacora\" ng-click=\"vm.showBinnacleReceipt(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-sm btn-white\" ng-click=\"editReceipt(receipt)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-info btn-sm\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(receipt,4)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a> <a ng-if=\"receipt.poliza.conducto_de_pago != 1\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"{{conductos[receipt.poliza.conducto_de_pago]}}\"><i ng-if=\"receipt.poliza.conducto_de_pago == 2\" class=\"fa fa-dollar\" aria-hidden=\"true\" title=\"Este recibo es con cargo a tarjeta (Agente)\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == 3\" class=\"fa fa-dollar\" aria-hidden=\"true\" title=\"Este recibo es con cargo a tarjeta (CAC)\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == 4\" class=\"fa fa-credit-card-alt\" aria-hidden=\"true\" title=\"Este recibo es con cargo a tarjeta (CAT/Domiciliado)\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == 5\" class=\"fa fa-money\" aria-hidden=\"true\" title=\"Este recibo es con cargo a tarjeta (Nómina)\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == 6\" class=\"fa fa-credit-card\" aria-hidden=\"true\" title=\"Este recibo es con cargo a tarjeta (CUT)\"></i></a><tasks click=\"addtask()\" type=\"3\" model=\"receipt.recibo_numero + \' de la póliza \' + vm.insurance.poliza_number\" associated=\"vm.insurance.id\" receipt=\"receipt.id\"></tasks></td></tr><tr><td>Totales</td><td>{{calculatePrima(vm.insurance.recibos_poliza) | currency}}</td><td>{{calculateDerecho(vm.insurance.recibos_poliza) | currency}}</td><td>{{calculateRpf(vm.insurance.recibos_poliza) | currency}}</td><td>{{calculateIva(vm.insurance.recibos_poliza) | currency}}</td><td>{{calculateComision(vm.insurance.recibos_poliza) | currency}}</td><td>{{calculatePrimaTotal(vm.insurance.recibos_poliza) | currency}}</td><td></td><td></td><td></td></tr></tbody></table><div class=\"col-xs-12\" ng-if=\"!show_binnacle_receipt\"><div class=\"identificador-dash-email\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se envio un correo.</span><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle_receipt\"><div class=\"col-md-12\"><div><label>Bitácora de recibos</label> <a class=\"btn btn-info pull-right\" ng-click=\"vm.returnToReceipts()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data_receipt\" typemodel=\"4\" config=\"vm.comments_config_receipt\" idmodel=\"vm.receipt_id\" exportable=\"true\"></comments></div></div></div></div></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-click=\"vm.changeStatusModal(receipt)\" ng-repeat=\"receipt in vm.insurance.recibos_poliza track by $index\" ng-if=\"receipt.receipt_type==1\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}:{{ receipt.recibo_numero }} / {{vm.receipts.length}}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ receipt.recibo_numero }} / {{vm.receipts.length}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ receipt.prima_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p>{{ receipt.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ receipt.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ receipt.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\" ng-if=\"vm.permiso_comisiones\"><label>Comisión</label><p>{{ receipt.comision | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ receipt.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p><span>{{ vm.checkStatusReceipts(receipt.status) }}</span></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacleReceipt(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></tr></table><div class=\"animate\" ng-if=\"vm.show_binnacle_receipt\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"vm.returnToReceiptsEnd()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data_receipt\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div></div></div></div><div ng-if=\"vm.insurance\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"comments_data\" config=\"comments_config\" typemodel=\"13\" idmodel=\"vm.insurance.id\" exportable=\"true\"></comments></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.endorsement_receipts_show.length > 0\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de Endosos</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"!vm.show_binnacle_receipt_end\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th ng-model=\"vm.table.headers[0]\">Tipo</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th><th ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}}</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}}</th><th width=\"3%\">Entregado</th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th></tr></thead><tbody><tr ng-click=\"vm.changeStatusModal(receipt, contratante, vm.insurance)\" ng-repeat=\"receipt in vm.endorsement_receipts_show track by $index\" ng-if=\"receipt.receipt_type == 2 || receipt.receipt_type == 3\"><td><span ng-if=\"receipt.receipt_type == 2\">Recibo</span><span ng-if=\"receipt.receipt_type == 3\">Nota de crédito</span></td><td>{{ receipt.prima_neta | currency }}</td><td>{{ receipt.rpf | currency }}</td><td>{{ receipt.derecho | currency }}</td><td>{{ receipt.iva | currency }}</td><td ng-if=\"vm.permiso_comisiones\">{{ receipt.comision | currency }}</td><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8 || receipt.status == 10 || receipt.status == 11}\">{{ vm.checkStatusReceipts(receipt.status) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); vm.deliveredReceipt(receipt)\"><span ng-if=\"receipt.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!receipt.delivered\"><i class=\"fa fa-times\"></i></span></td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-if=\"!receipt.track_bitacora\" ng-click=\"vm.showBinnacleReceiptEndorsement(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"receipt.track_bitacora\" ng-click=\"vm.showBinnacleReceiptEndorsement(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-info btn-sm\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(receipt,4)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a></td></tr></tbody></table></div><div class=\"animate\" ng-if=\"vm.show_binnacle_receipt_end\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"vm.returnToReceiptsEnd()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data_receipt_endoso\" typemodel=\"4\" config=\"vm.comments_config_endoso\" idmodel=\"vm.receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"receipt in vm.endorsement_receipts_show track by $index\" ng-if=\"receipt.receipt_type == 2\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}:{{ receipt.recibo_numero }} / {{vm.receipts.length}}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ng-click=\"vm.changeStatusModal(receipt)\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ receipt.recibo_numero }} / {{vm.receipts.length}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ receipt.prima_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p>{{ receipt.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ receipt.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ receipt.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ receipt.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p><span>{{ vm.checkStatusReceipts(receipt.status) }}</span></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacleReceipt(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></tr></table><div class=\"animate\" ng-if=\"vm.show_binnacle_receipt_end\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"vm.returnToReceiptsEnd()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data_receipt_endoso\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\" receiptmodel=\"receiptmodel\" exportable=\"true\"></comments></div></div></div></div></div></div></div></div></div><script>\n\n  function renombrarArchivoCargado(){\n    console.log(\'renombrarArchivoCargados-Fianzas.info\');\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"[name=\'text_input\']\");\n\n      inputTag.removeClass(\'display-none\');\n      strongTag.addClass(\'display-none\');\n      inputTag.focus();\n   }\n   function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"[name=\'text_input\']\");\n\n      inputTag.addClass(\'display-none\');\n      strongTag.removeClass(\'display-none\');\n    }\n\n\n</script>");
$templateCache.put("app/fianzas/fianzas.list.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Fianzas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Fianzas</strong></li></ol></div></div><div class=\"row wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Número de fianza</label> <input class=\"form-control\" type=\"text\" name=\"poliza\" ng-model=\"vm.form.num_poliza\" ng-change=\"vm.saveLocalstorage()\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fiado</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val);vm.saveLocalstorage()\"></autocomplete></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val);vm.saveLocalstorage()\"></autocomplete></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"subgroups.length >0\"><label>SubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subgroup\" data-ng-options=\"subgroup.group_name for subgroup in subgroups track by subgroup.url\" ng-change=\"vm.changeSubgroup(vm.form.subgroup); vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"subsubgroups.length >0\"><label>SubsubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subsubgroup\" data-ng-options=\"subsubgroup.group_name for subsubgroup in subsubgroups track by subsubgroup.url\" ng-change=\"vm.changeSubsubgroup(vm.form.subsubgroup);vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"campo_agrupacion\"><label>Nivel de Agrupación</label><autocomplete datasource=\"groupinglevels_data\" id=\"groupingleves\" model=\"vm.form.groupinglevel\" change=\"vm.matchesGroupinglevel(vm.form.groupinglevel.val);vm.saveLocalstorage()\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.form.groupinglevel.subgrupos.length >0 && campo_agrupacion\"><label>SubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subgrouping\" data-ng-options=\"subgrouping.description for subgrouping in vm.form.groupinglevel.subgrupos track by subgrouping.url\" ng-change=\"vm.changeSubgrouping(vm.form.subgrouping);vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.form.subgrouping.subsubgrupos.length >0 && campo_agrupacion\"><label>SubsubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subsubgrouping\" data-ng-options=\"subsubgroupin.description for subsubgroupin in vm.form.subgrouping.subsubgrupos track by subsubgroupin.url\" ng-change=\"vm.changeSubsubgrouping(vm.form.subsubgrouping);vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-model=\"vm.form.celula\" data-ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"vm.changecelula(vm.form.celula);vm.saveLocalstorage()\"><option value=\"\">Todo</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Clasificación</label><autocomplete datasource=\"classification_data\" id=\"classification\" model=\"vm.form.classification\" change=\"vm.matchesClassification(vm.form.classification.val);vm.saveLocalstorage()\"></autocomplete></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Afianzadora</label><select class=\"form-control\" ng-model=\"vm.form.provider\" data-ng-options=\"provider.compania for provider in vm.providers | orderBy: \'compania\' track by provider.url\" ng-change=\"vm.changeProvider(vm.form.provider);vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todos los proveedores</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Estatus</label><select class=\"form-control\" ng-model=\"vm.form.status\" data-ng-options=\"status.name for status in vm.status track by status.id\" ng-change=\"vm.changeStatus(vm.form.status); vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todos los status</option></select></div><div class=\"col-xs-12 col-sm-4 form-group check-options\"><br><br><div class=\"col-xs-12 col-sm-6 checkbox-inline nopadding\"><input type=\"radio\" ng-model=\"incio_fin\" ng-click=\"valueRadio(incio_fin); vm.saveLocalstorage()\" value=\"true\"> <span ng-class=\"{\'receipts-select\': incio_fin == \'true\'}\">Inicio de vigencia</span></div><div class=\"col-xs-12 col-sm-6 checkbox-inline nopadding\"><input type=\"radio\" ng-model=\"incio_fin\" ng-click=\"valueRadio(incio_fin); vm.saveLocalstorage()\" value=\"false\"> <span ng-class=\"{\'receipts-select\': incio_fin == \'false\'}\">Fin de vigencia</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since | date : \'medium\'}}\" ng-change=\"vm.options.changeSince();vm.saveLocalstorage()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil();vm.saveLocalstorage()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-12 form-group btn-action\" ng-if=\"vm.acceso_ver_fia\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.search(3, 1,1);vm.searchOT(3, 1,1)\">Consultar</button></div></div></div></div></div></div><ul id=\"contextFianzas\" class=\"dropdown-menu\" role=\"menu\" z-index=\"1000\"></ul><div class=\"row\" ng-if=\"vm.fianzas.length && vm.acceso_ver_fia\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Fianzas</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"results-container\"><div class=\"col-xs-12 panel-body\"><legend class=\"col-xs-12 legend-title visible-xs-block visible-sm-block\" align=\"center\">Resultado de fianzas</legend><div class=\"results-content\" ng-if=\"!vm.show_binnacle_fianza\"><div class=\"row visible-sm-block\" ng-if=\"!vm.fianzas.length\"><div class=\"table-cell col-xs-12 text-center\">No se han encontrado registros</div></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in vm.fianzas track by $index\" context=\"contextFianzas\" ng-right-click=\"ShowContextMenu(\'Información fianza\', insurance)\"><div class=\"ibox-title\"><h5>Fianza: {{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ui-sref=\"fianzas.info({polizaId: insurance.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>Póliza</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Contratante</label><p>{{ insurance.contractor.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Aseguradora</label><p>{{ insurance.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Subramo</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Forma de pago</label><p payment=\"{{insurance.forma_de_pago}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Estatus</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Vigencia</label><p>{{ insurance.start_of_validity | date: \'medium\': \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Antigüedad</label><p ng-if=\"!(insurance.antiguedad > 0)\">0 días</p><p ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Acciones</label><p ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></div></div></div></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in vm.search_results track by $index\" ng-if=\"insurance.document_type == 3\"><div class=\"ibox-title\"><h5>Colectividad: {{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ui-sref=\"colectividades.info({polizaId: insurance.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>Tipo</label><p>Colectividad</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Póliza</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Contratante</label><p>{{ insurance.contractor.full_name}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Aseguradora</label><p>{{ insurance.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Subramo</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Forma de pago</label><p payment=\"{{insurance.forma_de_pago}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Estatus</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Vigencia</label><p>{{ insurance.start_of_validity | date: \'medium\': \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Antigüedad</label><p ng-if=\"!(insurance.antiguedad > 0)\">0 días</p><p ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Acciones</label><p ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></div></div></div></div><table class=\"table table-stripped table-hover hidden-xs hidden-sm\"><thead><tr><th ng-click=\"vm.changeOrder(1, vm.order_poliza_asc == 1 ? 2 : 1)\">Fianza <span ng-class=\"{\'fa fa-sort-desc\': vm.order_poliza_asc == 1, \'fa fa-sort-asc\': vm.order_poliza_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(2, vm.order_contractor_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.order_contractor_asc == 1, \'fa fa-sort-asc\': vm.order_contractor_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(3, vm.order_provider_asc == 1 ? 2 : 1)\">Afianzadora <span ng-class=\"{\'fa fa-sort-desc\': vm.order_provider_asc == 1, \'fa fa-sort-asc\': vm.order_provider_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(4, vm.order_ramo_asc == 1 ? 2 : 1)\">Ramo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_ramo_asc == 1, \'fa fa-sort-asc\': vm.order_ramo_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(5, vm.order_subramo_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_subramo_asc == 1, \'fa fa-sort-asc\': vm.order_subramo_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(6, vm.order_type_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_type_asc == 1, \'fa fa-sort-asc\': vm.order_type_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(7, vm.order_status_asc == 1 ? 2 : 1)\">Estatus <span ng-class=\"{\'fa fa-sort-desc\': vm.order_status_asc == 1, \'fa fa-sort-asc\': vm.order_status_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(8, vm.order_vigencia_asc == 1 ? 2 : 1)\">Vigencia <span ng-class=\"{\'fa fa-sort-desc\': vm.order_vigencia_asc == 1, \'fa fa-sort-asc\': vm.order_vigencia_asc == 2}\"></span></th><th>Antigüedad</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.fianzas track by $index\" ng-click=\"selectSurety(insurance)\" context=\"contextFianzas\" ng-right-click=\"ShowContextMenu(\'Información fianza \', insurance)\"><td>{{ insurance.poliza_number }}</td><td><span>{{ insurance.contractor.full_name}}</span></td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.ramo }}</td><td>{{ insurance.subramo }}</td><td>{{ insurance.fianza_type.type_name }}</td><td>{{status(insurance.status)}}</td><td>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</td><td ng-if=\"!(insurance.antiguedad > 0)\">0 días</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"8\" model=\"insurance.poliza_number\" associated=\"insurance.id\"></tasks></td></tr></tbody></table><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle_fianza\"><div><label>Bitácora de Fianza</label></div><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data_fianza\" typemodel=\"13\" config=\"vm.comments_config_fianza\" idmodel=\"vm.fianza_id\" exportable=\"true\"></comments><div class=\"col-xs-12 col-sm-4 col-md-3\"><div class=\"row\"><a class=\"col-xs-12 btn btn-primary margin-top-10\" ng-click=\"vm.returnToFianza()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.fianzas_ot.length && vm.acceso_ver_ot\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>OTs Fianzas</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"results-container\"><div class=\"col-xs-12 panel-body\"><legend class=\"col-xs-12 legend-title visible-xs-block visible-sm-block\" align=\"center\">Resultado de OT de fianzas</legend><div class=\"results-content\" ng-if=\"!vm.show_binnacle_fianza_ot\"><div class=\"row visible-sm-block\" ng-if=\"!vm.fianzas_ot.length\"><div class=\"table-cell col-xs-12 text-center\">No se han encontrado registros</div></div><table class=\"table table-stripped table-hover hidden-xs hidden-sm\"><thead><tr><th ng-click=\"vm.changeOrderOT(1, vm.order_opoliza_asc == 1 ? 2 : 1)\">Fianza <span ng-class=\"{\'fa fa-sort-desc\': vm.order_opoliza_asc == 1, \'fa fa-sort-asc\': vm.order_opoliza_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(2, vm.order_ocontractor_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.order_ocontractor_asc == 1, \'fa fa-sort-asc\': vm.order_ocontractor_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(3, vm.order_oprovider_asc == 1 ? 2 : 1)\">Afianzadora <span ng-class=\"{\'fa fa-sort-desc\': vm.order_oprovider_asc == 1, \'fa fa-sort-asc\': vm.order_oprovider_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(4, vm.order_oramo_asc == 1 ? 2 : 1)\">Ramo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_oramo_asc == 1, \'fa fa-sort-asc\': vm.order_oramo_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(5, vm.order_osubramo_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_osubramo_asc == 1, \'fa fa-sort-asc\': vm.order_osubramo_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(6, vm.order_otype_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_otype_asc == 1, \'fa fa-sort-asc\': vm.order_otype_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(7, vm.order_ostatus_asc == 1 ? 2 : 1)\">Estatus <span ng-class=\"{\'fa fa-sort-desc\': vm.order_ostatus_asc == 1, \'fa fa-sort-asc\': vm.order_ostatus_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(8, vm.order_ovigencia_asc == 1 ? 2 : 1)\">Vigencia <span ng-class=\"{\'fa fa-sort-desc\': vm.order_ovigencia_asc == 1, \'fa fa-sort-asc\': vm.order_ovigencia_asc == 2}\"></span></th><th>Antigüedad</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.fianzas_ot track by $index\" ng-click=\"selectSurety(insurance)\"><td>{{ insurance.poliza_number }}</td><td><span>{{ insurance.contractor.full_name}}</span></td><td>{{ insurance.afianzadora }}{{ insurance.aseguradora }}</td><td>{{ insurance.ramo }}</td><td>{{ insurance.subramo }}</td><td>{{ insurance.fianza_type }}</td><td>{{status(insurance.status)}}</td><td>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</td><td ng-if=\"!(insurance.antiguedad > 0)\">0 días</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle_ot(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"paginacionOT[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPaginaOT(paginaOT)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"paginaOT in paginacionOT.totalPaginas\" ng-click=\"selecionPaginaOT(paginaOT)\" ng-class=\"{\'active\': paginaOT === paginacionOT.paginaActual}\"><a class=\"page-link\" role=\"button\">{{paginaOT}}</a></li><li class=\"page-item\" ng-click=\"siguientePaginaOT(paginaOT)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle_fianza_ot\"><div><label>Bitácora de OT Fianza</label></div><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data_fianza_ot\" typemodel=\"13\" config=\"vm.comments_config_fianza_ot\" idmodel=\"vm.fianza_id\"></comments><div class=\"col-xs-12 col-sm-4 col-md-3\"><div class=\"row\"><a class=\"col-xs-12 btn btn-primary margin-top-10\" ng-click=\"vm.returnToFianza()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div></div></div></div></div></div></div></div>");
$templateCache.put("app/fianzas/fianzas.reclamaciones.html","<div class=\"row wrapper border-bottom white-bg page-heading\" ng-if=\"url !== \'/index/main\'\"><div class=\"col-lg-9\"><h2>Fianzas</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Fianzas - Reclamaciones</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Reclamación</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6 form-group\"><label>Fianza o Cliente: <span class=\"color-red\">*</span></label><autocomplete datasource=\"bens_data\" id=\"autocomplete\" model=\"vm.selected_affect\" change=\"matchBeneficiares(vm.selected_affect.val)\"></autocomplete></div><div class=\"col-md-2 form-group\"><label></label> <button type=\"button\" id=\"buttonsearch\" ng-click=\"getInfo(vm.selected_affect)\" class=\"btn btn-block btn-success mt4\">Buscar</button></div></div><fieldset><legend align=\"right\">Información de la reclamación</legend><form name=\"infoSiniestroForm\"><div class=\"row\"><div class=\"col-md-3 form-group\" ng-class=\"{ \'has-error\': infoSiniestroForm.numero_de_siniestro.$invalid && !infoSiniestroForm.numero_de_siniestro.$pristine }\"><label>Número de reclamación: <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.number\" name=\"numero_de_siniestro\" required=\"true\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-md-3 form-group\"><label>Fecha presentación: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"vm.form.presentacion\" value=\"{{order.form.startDate}}\" ng-change=\"order.options.checkDate()\" ng-init=\"order.options.checkDate(\'initial\')\"></div></div><div ng-disabled=\"vm.user.permiso.editar\" class=\"col-md-3 form-group\"><label>Tipo de reclamación</label><select class=\"select form-control\" ng-model=\"vm.form.claim_type\" ng-change=\"vm.updateSiniestroStatus(vm.status); saveLocalstorange();\" ng-options=\"status.id as status.label for status in types_options\"><option value=\"\">Seleccione una opción</option></select></div><div ng-disabled=\"vm.user.permiso.editar\" class=\"col-md-3 form-group\"><label>Estatus</label><select class=\"select form-control\" ng-model=\"vm.form.status\" ng-change=\"vm.updateSiniestroStatus(vm.status); saveLocalstorange();\" ng-options=\"status.id as status.label for status in status_options\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"col-md-12 form-group\" ng-class=\"{ \'has-error\': infoSiniestroForm.numero_de_siniestro.$invalid && !infoSiniestroForm.numero_de_siniestro.$pristine }\"><label>Motivo: <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"vm.form.reason\" name=\"numero_de_siniestro\" required=\"true\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12\"><label>Observaciones</label> <textarea class=\"form-control\" ng-model=\"vm.form.observations\" ng-change=\"saveLocalstorange()\"></textarea></div></div></form></fieldset><br><fieldset><legend align=\"right\">Información de la fianza</legend><form name=\"infoGral\"><div class=\"row\"><div class=\"col-md-3 form-group\"><label>Afianzadora:</label> <input disabled=\"\" class=\"form-control\" ng-model=\"fianza.aseguradora.alias\"></div><div class=\"col-md-3 form-group\"><label>Fiado:<span class=\"color-red\">*</span></label> <input ng-if=\"fianza.contractor\" disabled=\"\" ng-model=\"fianza.contractor.full_name\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Número de fianza:</label> <input disabled=\"\" ng-model=\"fianza.poliza_number\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Subramo</label> <input disabled=\"\" class=\"form-control\" ng-model=\"fianza.subramo\"></div><div class=\"col-md-3 form-group\"><label>Tipo:</label> <input disabled=\"\" ng-model=\"fianza.fianza_type\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Monto afianzado:</label> <input disabled=\"\" ng-model=\"fianza.contract_poliza.guarantee_amount\" format-as-currency=\"\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Inicio de Vigencia:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"fianza.start_of_validity\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Fin de Vigencia:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"fianza.end_of_validity\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div></div></form></fieldset><br><br><div upload-template=\"\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"row\"><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-click=\"saveClaim()\">Guardar reclamación</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></div></div>");
$templateCache.put("app/fianzas/otAsFianzaModal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Completar datos de Fianza</h4></div><div class=\"modal-body\"><div class=\"row\"><form class=\"quoteForm\" name=\"otpolicy\" novalidate=\"\"><div class=\"form-group col-xs-6\"><label for=\"\">Folio de Fianza</label> <input class=\"form-control\" ng-model=\"vmm.form.folio\"></div><div class=\"form-group col-xs-6\" ng-hide=\"order.show.ot\"><label>Número de Fianza<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.fianza.$invalid && !form.fianza.$pristine }\"><input class=\"form-control\" ng-blur=\"changeNoPoliza(vmm.form.fianza)\" name=\"fianza\" ng-model=\"vmm.form.fianza\" type=\"text\" ng-trim=\"false\" required=\"\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.status != 1\"><label>Fecha de emisión de Fianza</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vmm.form.emision_date\" value=\"{{vm.form.emision_date}}\" data-date-format=\"dd/mm/yyyy\" ng-change=\"vm.checkDate(\'emision_date\')\" ng-init=\"vm.checkDate(\'emision_date\')\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></form></div><hr><div class=\"row\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de emisión de la Factura</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vmm.form.date_emision_factura\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkFechaFactura(vmm.form.date_emision_factura)\" ng-init=\"vmm.checkFechaFactura(vmm.form.date_emision_factura)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectMontEmision\">Mes de Emisión de Factura</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in vmm.form.month.options\" ng-model=\"vmm.form.month.month_selected\" ng-init=\"vmm.form.month.month_selected = 0\" ng-change=\"changemonth()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"year\">Año Factura</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"vmm.form.year_factura\" ng-change=\"changeyaer(vmm.form.year_factura)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Folio Factura</label> <input class=\"form-control\" name=\"folio-fact\" type=\"text\" value=\"{{vmm.form.folio_factura}}\" ng-model=\"vmm.form.folio_factura\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Maquila</label> <input class=\"form-control\" name=\"maquila\" type=\"number\" value=\"{{vmm.form.maquila}}\" ng-model=\"vmm.form.maquila\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de Maquila</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vmm.form.date_maquila\" data-date-format=\"mm/dd/yyyy\" ng-change=\"vmm.checkFechaMaquila(vmm.form.date_maquila)\" ng-init=\"vmm.checkFechaFactura(vmm.form.date_maquila)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"folio-fact\">Tipo Cambio (Captura)</label> <input class=\"form-control\" name=\"changeType\" type=\"number\" value=\"{{vmm.form.exchange_rate}}\" ng-model=\"vmm.form.exchange_rate\"></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.form.status != 1\"><label>Fecha de entrega de la Factura</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_of_validity\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.fecha_entrega\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkFechaFactura(vm.form.date_emision_factura)\" ng-init=\"vm.checkFechaFactura(vm.form.date_emision_factura)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\" ng-hide=\"order.show.ot\"><receipts-endorsement form=\"vmm.form\" tosave=\"vmm.policyInfo\" type=\"1\"></receipts-endorsement></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"vmm.options.cancel()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success ladda-button\" ng-disabled=\"otpolicy.$invalid\" ng-click=\"vmm.options.save()\" type=\"button\">Crear</button></div>");
$templateCache.put("app/fianzas/pproveedor.edit.html","<div><div ng-if=\"vm.form\"><div class=\"row\" ng-include=\"\'app/fianzas/pproveedor.fisico.edit.html\'\"></div></div><div ng-if=\"vm.juridicalForm\"><div class=\"row\" ng-include=\"\'app/fianzas/pproveedor.moral.edit.html\'\"></div></div></div>");
$templateCache.put("app/fianzas/pproveedor.fisico.edit.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Contratantes</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"fianzas.pprovlist\">Contratantes</a></li><li class=\"active\"><strong>Editar</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div><form class=\"col-xs-12\" method=\"post\" name=\"form\" ng-submit=\"vm.submitNatural(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"data-container\"><div class=\"col-xs-12 col-sm-4 nopadding form-group\" ng-class=\"{ \'has-error\': form.name.$invalid && !form.name.$pristine }\"><label>Nombre<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"vm.form.first_name\" required=\"\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 nopadding form-group\" ng-class=\"{ \'has-error\': form.last_name.$invalid && !form.last_name.$pristine }\"><label>Apellido Paterno<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"last_name\" ng-model=\"vm.form.last_name\" required=\"\"></div><div class=\"col-xs-12 col-sm-4 nopadding form-group\"><label>Apellido Materno</label> <input class=\"form-control\" type=\"text\" name=\"second_last_name\" ng-model=\"vm.form.second_last_name\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\" id=\"data_2\" ng-class=\"{ \'has-error\': form.birthday.$invalid && !form.birthday.$pristine }\"><label>Fecha de Nacimiento<span class=\"color-red\">*</span></label><div class=\"input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" name=\"birthday\" ng-model=\"vm.form.birthday\" value=\"vm.form.birthday\" ng-change=\"selectDate(vm.form.birthday)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\" ng-class=\"{ \'has-error\': form.rfc.$invalid && !form.rfc.$pristine }\"><label>RFC<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"rfc\" uppercase-only=\"\" ng-model=\"vm.form.rfc\" maxlength=\"13\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Género</label><select class=\"form-control\" name=\"sex\" ng-model=\"vm.form.sex\"><option ng-selected=\"vm.form.sex == \'M\'\" value=\"M\">MASCULINO</option><option ng-selected=\"vm.form.sex == \'F\'\" value=\"F\">FEMENINO</option></select></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\"><label for=\"group\">Grupo<span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"group\" ng-model=\"vm.editForm.group\" ng-change=\"changeGroup(vm.editForm.group)\" ng-options=\"group.group_name for group in vm.groups track by group.id\"><option value=\"\" selected=\"\" disabled=\"\">--Sin grupo--</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(1,1,null)\" type=\"button\" ng-if=\"vm.user.permiso.crear\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\" ng-if=\"vm.editForm.group\"><label for=\"subgroup\">Subgrupo</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"subgroup\" ng-model=\"vm.editForm.subgroup\" ng-change=\"changeSubGroup(vm.editForm.subgroup)\" ng-options=\"group.group_name for group in vm.subgroups track by group.url\"><option value=\"\" disabled=\"\">Seleccione un subgrupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(2,1,vm.editForm.group)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group nopadding\" ng-class=\"{ \'has-error\': form.group.$invalid && !form.group.$pristine }\" ng-if=\"vm.editForm.subgroup\"><label for=\"subgroup2\">Subsubgrupo</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"subgroup2\" ng-model=\"vm.editForm.subsubgrupo\" ng-options=\"ssgroup.group_name for ssgroup in vm.sub_subgroups track by ssgroup.url\"><option value=\"\" disabled=\"\">Seleccione un subgrupo</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalGroup(3,1,vm.editForm.subgroup)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Correo Electrónico (principal)</label> <input class=\"form-control\" ng-model=\"vm.form.email\" type=\"email\"></div><div class=\"col-xs-12 col-sm-6 hidden-xs hidden-sm nopadding form-group\"><label>Teléfono (principal)</label><phonenumber-directive placeholder=\"myPrompt\" model=\"vm.form.phone_number\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Correos Electrónicos (secundarios)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.form.email_natural\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.emails.delete($index, 1, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><input class=\"form-control\" ng-model=\"item.correo\" type=\"email\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.emails.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a id=\"dropdown-menu-item-link-1\" ng-click=\"item.email_type = 1; vm.closeDropdown();\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal</a></li><li><a id=\"dropdown-menu-item-link-2\" ng-click=\"item.email_type = 2; vm.closeDropdown();\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"item.email_type = 3; vm.closeDropdown();\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro</a></li><li><a id=\"dropdown-menu-item-link-3\" ng-click=\"item.email_type = 4; vm.closeDropdown();\"><span class=\"fa fa fa fa-building\" aria-hidden=\"true\"></span> CDFI</a></li></ul></div></div></div><div class=\"nopadding form-group\" ng-if=\"vm.form.email_natural.length == 0\"><div class=\"col-xs-12 input-group form-group\"><button class=\"btn btn-success\" ng-click=\"vm.emails.add(1)\" type=\"button\">Agregar correo</button></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.form.email_natural\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.emails.delete($index, 1, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><input class=\"form-control\" ng-model=\"item.correo\" type=\"email\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.email_type == 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"item.email_type = 1\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Personal</a></li><li><a ng-click=\"item.email_type = 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Trabajo</a></li><li><a ng-click=\"item.email_type = 4\"><span class=\"fa fa-file-text\" aria-hidden=\"true\"></span> CFDI</a></li><li><a ng-click=\"item.email_type = 3\"><span class=\"fa fa-at\" aria-hidden=\"true\"></span> Otro</a></li></ul><button class=\"btn btn-success\" ng-click=\"vm.emails.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 hidden-md hidden-lg nopadding form-group\"><label>Teléfono (principal)</label><phonenumber-directive placeholder=\"myPrompt\" model=\"vm.form.phone_number\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Teléfonos (secundarios)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.form.phone_natural\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.phones.delete($index, 1, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><phonenumber-directive placeholder=\"myPrompt\" model=\"item.phone\"></phonenumber-directive><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.phones.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"col-xs-12 form-group\"><div class=\"hasDropdown row\"><button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina <span class=\"caret\"></span></button> <button type=\"button\" class=\"col-xs-12 btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil <span class=\"caret\"></span></button><ul class=\"col-xs-12 dropdown-menu\"><li><a ng-click=\"item.phone_type = 1; vm.closeDropdown();\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa</a></li><li><a ng-click=\"item.phone_type = 2; vm.closeDropdown();\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina</a></li><li><a ng-click=\"item.phone_type = 3; vm.closeDropdown();\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil</a></li></ul></div></div></div><div class=\"nopadding form-group\" ng-if=\"vm.form.phone_natural.length == 0\"><div class=\"col-xs-12 input-group form-group\"><button class=\"btn btn-success\" ng-click=\"vm.phones.add(1)\" type=\"button\">Agregar teléfono</button></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.form.phone_natural\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.phones.delete($index, 1, item)\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><phonenumber-directive placeholder=\"myPrompt\" model=\"item.phone\"></phonenumber-directive><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 0\">Elige el tipo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"item.phone_type == 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"item.phone_type = 1\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> Casa</a></li><li><a ng-click=\"item.phone_type = 2\"><span class=\"fa fa-building\" aria-hidden=\"true\"></span> Oficina</a></li><li><a ng-click=\"item.phone_type = 3\"><span class=\"fa fa-mobile\" aria-hidden=\"true\"></span> Móvil</a></li></ul><button class=\"btn btn-success\" ng-click=\"vm.phones.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div></div><div class=\"address-container\" ng-repeat=\"address in vm.form.userAddresses track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.addresses.delete($index,1)\" ng-disabled=\"address.can_delete\">Quitar dirección</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.addresses.delete($index,1)\" ng-disabled=\"vm.form.userAddresses.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Direccion #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addresses.add(1)\" type=\"button\">Agregar dirección</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addresses.add(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{\'has-error\': form2.city.$invalid && !form2.city.$pristine}\"><label>Tipo de dirección</label><select class=\"form-control\" data-ng-options=\"type.name for type in vm.address_type track by type.name\" name=\"type\" ng-model=\"address.tipo\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{\'has-error\': form.state.$invalid && !form.state.$pristine}\"><label>Estado<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"estado.state for estado in vm.statesArray track by estado.url\" name=\"state\" ng-model=\"address.administrative_area_level_1\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un estado</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 nopadding form-group\" ng-class=\"{\'has-error\': form.city.$invalid && !form.city.$pristine}\"><label>Municipio<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"ciudad.city for ciudad in address.administrative_area_level_1.cities track by ciudad.url\" name=\"city\" ng-model=\"address.administrative_area_level_2\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un municipio</option></select></div><div class=\"col-xs-12 col-md-8 nopadding form-group\"><label>Calle</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.route\" id=\"id_address_route\" name=\"address_route\" data-geo=\"route\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Ext.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number\" id=\"id_address_street_number\" name=\"address_street_number\" data-geo=\"street_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 nopadding form-group\"><label>Num. Int.</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number_int\" id=\"id_address_street_number_int\" name=\"address_street_number_int\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Colonia</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.sublocality\" id=\"id_address_sublocality\" name=\"address_sublocality\" data-geo=\"sublocality\"></div><div class=\"col-xs-12 col-sm-6 nopadding form-group\"><label>Código Postal</label> <input type=\"tel\" name=\"zip\" ng-model=\"address.postal_code\" minlength=\"5\" maxlength=\"5\" class=\"form-control\" ng-keypress=\"filterValue($event)\"></div><div class=\"col-xs-12 nopadding form-group\"><label>Referencias</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.details\" id=\"id_address_details\" name=\"address_details\"></div><input type=\"hidden\" class=\"form-control\" ng-model=\"address.administrative_area_level_1_short\" id=\"id_address_administrative_area_level_1_short\" name=\"address_state_code\" data-geo=\"administrative_area_level_1_short\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country\" id=\"id_address_country\" name=\"address_country\" data-geo=\"country\" value=\"México\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.composed\" id=\"id_address_composed\" name=\"address_composed\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country_code\" id=\"id_address_country_code\" name=\"address_country_code\" data-geo=\"country_short\" value=\"MX\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.locality\" id=\"id_address_locality\" name=\"address_locality\" data-geo=\"locality\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.latitude\" id=\"id_address_latitude\" name=\"address_latitude\" data-geo=\"lat\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.longitude\" id=\"id_address_longitude\" name=\"address_longitude\" data-geo=\"lng\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.formatted\" id=\"id_address_formatted\" name=\"address_formatted\" data-geo=\"formatted_address\"></div></div><br><br><br><div class=\"col-xs-12\" ng-if=\"vm.form.only_sureties\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Seleccione el archivo a cargar, de clic en el ícono <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> uno a la vez después de seleccionar, para añadirlo.</div></div><div class=\"col-xs-12 col-sm-6 form-group m-t\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"vm.form.only_sureties\" ng-change=\"onlyFianzas(1)\" disabled=\"\"> <span>Solo para Fianzas</span></h3></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-lg-12 form-group\" align=\"center\" style=\"padding-top: 30px\"><table class=\"table table-bordered\" align=\"center\"><thead><tr><th>Entregado</th><th>Documento</th><th ng-if=\"vm.form.only_sureties\">Archivo</th></tr></thead><tbody><tr ng-repeat=\"listaD in vm.listDocument track by $index\"><td class=\"col-lg-3\" ng-click=\"$event.stopPropagation()\"><label><input type=\"checkbox\" ng-model=\"listaD.value\"></label></td><td><span class=\"font-weight-bold\">{{listaD.name}}</span></td><td ng-click=\"$event.stopPropagation()\" ng-if=\"vm.form.only_sureties\"><div class=\"col-xs-12 form-group\" id=\"$index\"><label class=\"btn btn-success\" ng-if=\"listaD.file ==false\">Seleccionar Archivo <input nv-file-select=\"\" type=\"file\" name=\"xyz\" uploader=\"uploaderDocument\" class=\"display-none\"></label> <button class=\"btn btn-white\" ng-if=\"listaD.file ==false\" ng-click=\"addFileList($index,vm.listDocument, uploaderDocument.queue,xyz)\" title=\"Click para añadir archivo y subirlo\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i></button> <span class=\"blue-color\">{{listaD.arch.file.name}}</span><i class=\"fa fa-check-circle\" aria-hidden=\"true\" ng-if=\"listaD.file ==true\"></i></div></td></tr></tbody></table></div></div><div class=\"col-xs-12 form-group m-t\"><label>Observaciones</label> <textarea class=\"form-control upperclass\" type=\"text\" ng-model=\"vm.form.description\"></textarea></div><div ng-if=\"vm.vendors.length >0\" class=\"col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.vendedor.$invalid && !form.vendedor.$pristine }\"><label for=\"vendedor\">Referenciador<span class=\"color-red\">*</span></label><div><select class=\"form-control m-b\" name=\"vendedor\" ng-model=\"vm.form.vendedor\" ng-change=\"changeVendedor(vm.form.vendedor)\" ng-options=\"vendedor.name for vendedor in vm.vendors track by vendedor.id\"><option value=\"\">Seleccione un referenciador</option></select></div></div><div ng-if=\"sucursalList.length > 0\" class=\"col-xs-12 col-sm-6 form-group\"><label for=\"sucursal\">Sucursal</label><select class=\"form-control\" name=\"sucursal\" ng-model=\"vm.form.sucursal\" ng-change=\"sucursal(vm.form.sucursal)\" ng-options=\"sucursal as sucursal.sucursal_name for sucursal in sucursalList track by sucursal.id\"><option value=\"\">Seleccione una Sucursal</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"sucursal\">Célula</label><div class=\"input-group\"><select class=\"form-control\" name=\"celula\" ng-model=\"vm.form.celula\" ng-change=\"celula(vm.form.celula)\" ng-options=\"celula.url as celula.celula_name for celula in vm.celulas\"><option value=\"\" disabled=\"\">Seleccione una Célula</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.openModalCelulaContractor()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"sucursal\">Clasificación</label><div class=\"input-group\"><select class=\"form-control\" name=\"clasification\" ng-model=\"vm.form.classification\" ng-change=\"sucursal(vm.form.clasification)\" ng-options=\"clasification.url as clasification.classification_name for clasification in vm.clasifications\"><option value=\"\" disabled=\"\">Seleccione una clasificación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.openModalClasification()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"sucursal\">Agrupación</label><select class=\"form-control\" name=\"agrupacion\" ng-model=\"vm.editForm.grouping_level\" ng-change=\"changeAgrupacion2(vm.editForm.grouping_level)\" ng-options=\"agrupaciones.description for agrupaciones in vm.agrupaciones track by agrupaciones.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.editForm.grouping_level\"><label for=\"sucursal\">Subagrupación</label><div class=\"input-group\"><select class=\"form-control\" name=\"subagrupacion\" ng-model=\"vm.editForm.subagrupaciones\" ng-change=\"changeSubagrupacion2(vm.editForm.subagrupaciones)\" ng-options=\"agrupaciones.description for agrupaciones in sub_asignaciones track by agrupaciones.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalAsignacion(2,vm.editForm.grouping_level)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.editForm.subagrupaciones\"><label for=\"sucursal\">Subsubagrupación</label><div class=\"input-group\"><select class=\"form-control\" name=\"subsubagrupacion\" ng-model=\"vm.editForm.subsubasignaciones\" ng-change=\"changeSubsubagrupacion2(vm.editForm.subsubasignaciones)\" ng-options=\"grupo.description for grupo in sub_subasignaciones track by grupo.id\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"vm.openModalAsignacion(3,vm.editForm.subagrupaciones)\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div ng-if=\"vm.responsables.length >0\" class=\"col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.responsable.$invalid && !form.responsable.$pristine }\"><label for=\"responsable\">Responsable<span class=\"color-red\">*</span></label><div><select class=\"form-control m-b\" name=\"responsable\" ng-model=\"vm.form.responsable\" ng-change=\"changeResponsable(vm.form.responsable)\" ng-options=\"responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables track by responsable.id\"><option value=\"\">Seleccione un responsable</option></select></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.form.resp_contractor\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteResponsable($index, 1)\" ng-disabled=\"vm.form.resp_contractor.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b\" ng-model=\"item.responsable\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in vm.responsables\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 0\">Elige el área <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-if=\"vm.form.resp_contractor[$index].resp_type == 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.form.resp_contractor[$index].resp_type = 1\"><span class=\"fa fa-file\" aria-hidden=\"true\"></span> Emisión</a></li><li><a ng-click=\"vm.form.resp_contractor[$index].resp_type = 4\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> Ejecutivo</a></li><li><a ng-click=\"vm.form.resp_contractor[$index].resp_type = 5\"><span class=\"fa fa-briefcase\" aria-hidden=\"true\"></span> Comercial</a></li><li><a ng-click=\"vm.form.resp_contractor[$index].resp_type = 2\"><span class=\"fa fa-money\" aria-hidden=\"true\"></span> Cobranza</a></li><li><a ng-click=\"vm.form.resp_contractor[$index].resp_type = 3\"><span class=\"fa fa-ambulance\" aria-hidden=\"true\"></span> Siniestros</a></li></ul><button class=\"btn btn-success\" ng-click=\"addResponsable(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Obligado(s) Solidario(s) (Fianzas)</label><div class=\"hidden-md hidden-lg nopadding form-group\" ng-repeat=\"item in vm.form.obligados\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteObligados($index, 1)\" ng-disabled=\"vm.form.obligados.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><div id=\"item[$index]\"><pre>{{item}}</pre><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"item\" change=\"matchesContractors(item.val)\"></autocomplete></div><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addObligados(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in vm.form.obligados\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteObligados($index, 1)\" ng-disabled=\"vm.form.obligados.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><div id=\"item[$index]\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"item\" change=\"matchesContractors(item.val)\"></autocomplete></div><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addObligados(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group m-t\"><h3><input type=\"checkbox\" name=\"\" ng-model=\"vm.form.vip\"> <span>VIP</span></h3></div><div><input type=\"hidden\" name=\"type_person\" ng-model=\"vm.form.type\" value=\"\"></div><div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Información de contacto</legend></div><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.form.contact_natural.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"vm.form.contact_natural.length == 0\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"vm.form.contact_natural.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contactos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact(1)\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"contact in vm.form.contact_natural track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteContacts($index, 1, contact)\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts($index, 1, contact)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contacto #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact(1)\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"contact.name\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" type=\"search\" lowercase=\"\" ng-model=\"contact.email\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Teléfono</label><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone_number\"></phonenumber-directive></div></div></div></div></div></form></div></div><div class=\"row\" ng-if=\"vm.permiso_archivos\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/upload.html\'\" ng-if=\"vm.user.permiso.crear && vm.user.permiso.editar\"></div><div class=\"col-xs-12 col-sm-4 col-md-3 pull-right form-group\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-click=\"vm.uploadImages()\" ng-if=\"vm.user.permiso.crear && vm.user.permiso.editar\">Subir archivos</button></div><div ng-include=\"\'templates/show-files.html\'\"></div></div></div></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"vm.save()\" ng-if=\"vm.user.permiso.editar\">Guardar cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></div>");
$templateCache.put("app/fianzas/pproveedor.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-lg-9\"><h2>Contratantes Programa de Proveedores</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"fianzas.pprovlist\">Contratantes Programa de Proveedores</a></li><li class=\"active\"><strong>Información</strong></li></ol></div></div><div class=\"row wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pull-right option_button m-b\"><div class=\"btn-group\" ng-if=\"vm.form.url\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_adm_cont\"><a ng-click=\"vm.goToContractorEdit(vm.form)\">Editar</a></li><li ng-if=\"vm.acceso_adm_cont\"><a ng-click=\"vm.deleteContractor(vm.form.id, 2, natural)\">Eliminar</a></li><li class=\"dropdown-submenu\" ng-if=\"vm.files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"vm.files\" ng-repeat=\"file in vm.files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li></ul></div><div class=\"btn-group\" ng-if=\"vm.juridicalForm.url\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_adm_cont\"><a ng-click=\"vm.goToContractorEdit(vm.juridicalForm)\">Editar</a></li><li ng-if=\"vm.acceso_adm_cont\"><a ng-click=\"vm.deleteContractor(vm.juridicalForm.id, 1, moral)\">Eliminar</a></li><li class=\"dropdown-submenu\" ng-if=\"vm.files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"vm.files\" ng-repeat=\"file in vm.files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li></ul></div></div></div></div><div class=\"ibox float-e-margins animate\" ng-if=\"vm.form.url && vm.showInfo\"><div class=\"ibox-title\"><h5>Información del contratante</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><legend class=\"legend-title\" align=\"center\">Datos personales</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{vm.form.first_name}} {{vm.form.last_name}} {{vm.form.second_last_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ vm.form.birth_date.replace(\'Z\', \'\') | date: \'dd/MM/yyyy\': \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">RFC:</span><div><span>{{vm.form.rfc}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Género:</span><div><span ng-if=\"vm.form.sex== \'F\'\">FEMENINO</span> <span ng-if=\"vm.form.sex== \'M\'\">MASCULINO</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Grupo:</span><div><span>{{vm.form.group.group_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.group.subgroup_name\"><span class=\"blue-color\">Subgrupo:</span><div><span>{{vm.form.group.subgroup_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.group.subsubgroup_name\"><span class=\"blue-color\">Subsubgrupo:</span><div><span>{{vm.form.group.subsubgroup_name}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div class=\"row\"><div class=\"col-xs-12 col-sm-6\" ng-if=\"vm.form.email\"><span class=\"fa fa-user\" aria-hidden=\"true\"></span> <span>{{vm.form.email}}</span></div><div class=\"col-xs-12\" ng-repeat=\"email in vm.form.email_natural\"><span ng-if=\"email.email_type == 1\" class=\"fa fa-user\" aria-hidden=\"true\"></span> <span ng-if=\"email.email_type == 2\" class=\"fa fa-building\" aria-hidden=\"true\"></span> <span ng-if=\"email.email_type == 3\" class=\"fa fa-at\" aria-hidden=\"true\"></span> <span>{{email.correo}}</span></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Teléfono:</span><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"vm.form.phone_number\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> <span>{{vm.form.phone_number | phonenumber}}</span></div><div class=\"col-xs-12\" ng-repeat=\"phone_number in vm.form.phone_natural\"><span ng-if=\"phone_number.phone_type == 1\" class=\"fa fa-home\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 2\" class=\"fa fa-building\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 3\" class=\"fa fa-mobile\" aria-hidden=\"true\"></span> <span>{{phone_number.phone | phonenumber}}</span></div></div></div><div class=\"col-xs-12 form-group\"><input type=\"checkbox\" name=\"\" ng-change=\"change_vip(vm.form.url, vm.form.vip)\" ng-model=\"vm.form.vip\"> <span class=\"blue-color\">VIP</span></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"infoFisicoc.classification_name\"><span class=\"blue-color\">Clasificación:</span><div><span>{{infoFisicoc.classification_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"infoFisicocel.celula_name\"><span class=\"blue-color\">Célula:</span><div><span>{{infoFisicocel.celula_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.grouping_level.group_name\"><span class=\"blue-color\">Nivel Agrupación:</span><div><span>{{vm.form.grouping_level.group_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.grouping_level.subgroup_name\"><span class=\"blue-color\">Nivel Subagrupación:</span><div><span>{{vm.form.grouping_level.subgroup_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.form.grouping_level.subsubgroup_name\"><span class=\"blue-color\">Nivel Subsubagrupación:</span><div><span>{{vm.form.grouping_level.subsubgroup_name}}</span></div></div><div ng-if=\"vm.form.only_sureties\" class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\"><b>Tipo de contratante:</b></span><div><span><u>Solo para fianzas</u></span><br><span><b>Programa de Proveedores</b></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><span class=\"blue-color\"><b>Sucursal</b>:</span><div><span>{{vm.form.sucursal.sucursal_name}}</span></div></div><br><div ng-if=\"vm.form.vendor\" class=\"col-xs-12 col-sm-6 col-md-3\"><span class=\"blue-color\"><b>Referenciador</b>:</span><div><span>{{vm.form.vendor.first_name}} {{vm.form.vendor.last_name}}</span></div></div><br><div ng-if=\"vm.form.resp_contractor\" class=\"col-xs-12 col-sm-6 col-md-6\"><span class=\"blue-color\"><i class=\"fa fa-star yellow\"></i><b>Responsables</b>:</span><div class=\"col-xs-12\" ng-repeat=\"resp in vm.form.resp_contractor\"><span>{{resp.responsable_name}}</span></div></div><br><div ng-if=\"vm.form.responsable\" class=\"col-xs-12 col-sm-6 col-md-3\"><span class=\"blue-color\"><i class=\"fa fa-star yellow\"></i><b>Responsable</b>:</span><div><span>{{vm.form.responsable.first_name}} {{vm.form.responsable.last_name}}</span></div></div><br><br><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><span class=\"blue-color\"><b>Antigüedad:</b></span><div><span>{{ vm.form.antiguedad }} días</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><span class=\"blue-color\">Obligado(s) Solidario(s):</span><div class=\"row\" ng-repeat=\"sols in solidarios\"><span align=\"center\">{{ sols.full_name }}</span></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"row\" ng-repeat=\"address in vm.form.address_natural\"><legend class=\"legend-title\" align=\"center\">Dirección #{{ $index + 1 }}</legend><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Calle:</span><div><span>{{address.route}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Número Ext.:</span><div><span>{{address.street_number}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div ng-if=\"address.street_number_int\" class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Número Int.:</span><div><span>{{address.street_number_int}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Colonia:</span><div><span>{{address.sublocality}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Municipio:</span><div><span ng-if=\"!address.administrative_area_level_2.state\">{{address.administrative_area_level_2}}</span> <span ng-if=\"address.administrative_area_level_2.city != null\">{{address.administrative_area_level_2.city}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Estado:</span><div><span ng-if=\"!address.administrative_area_level_1.state\">{{address.administrative_area_level_1}}</span> <span ng-if=\"address.administrative_area_level_1.state != null\">{{address.administrative_area_level_1.state}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Código Postal:</span><div><span>{{address.postal_code}}</span> <span class=\"hidden-xs hidden-sm\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Tipo de dirección:</span><div><span>{{address.tipo}}</span></div></div><div ng-if=\"address.details\" class=\"col-xs-12 form-group\"><span class=\"blue-color\">Referencia:</span><div><span>{{address.details}}</span></div></div></div></div></div><div class=\"row\" ng-if=\"vm.form && vm.showInfo\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Documentos</legend><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Identificación Oficial:</span><div><span ng-if=\"vm.form.card_official_identification\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.card_official_identification\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">CURP:</span><div><span ng-if=\"vm.form.CURP\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.CURP\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Comprobante de Inscripción de Firma Electrónica:</span><div><span ng-if=\"vm.form.voucher_efirm\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.voucher_efirm\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Comprobante de Domicilio:</span><div><span ng-if=\"vm.form.voucher_of_address\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.voucher_of_address\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Formato de Identificación de Cliente Firmado:</span><div><span ng-if=\"vm.form.signed_format_ic\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.signed_format_ic\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\" ng-if=\"vm.org_name !=\'ancora\'\"><span class=\"blue-color\">Poder:</span><div><span ng-if=\"vm.form.fiscal_power\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.fiscal_power\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div ng-if=\"vm.form.only_sureties\"><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Carta nombramiento:</span><div><span ng-if=\"vm.form.carta_nombramiento\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.carta_nombramiento\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Currículo:</span><div><span ng-if=\"vm.form.curriculo\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.curriculo\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Contrato multiple de la afianzadora:</span><div><span ng-if=\"vm.form.contrato_multiple_afianzadora\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.contrato_multiple_afianzadora\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Carta buro:</span><div><span ng-if=\"vm.form.carta_buro\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.carta_buro\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Entrevista con la afianzadora:</span><div><span ng-if=\"vm.form.entrevista_afianzadora\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.entrevista_afianzadora\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">RFC:</span><div><span ng-if=\"vm.form.rfc_document\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.rfc_document\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Alta ante hacienda o alta electrónica:</span><div><span ng-if=\"vm.form.alta_hacienda\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.alta_hacienda\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Recibos de nómina:</span><div><span ng-if=\"vm.form.recibos_nomina\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.recibos_nomina\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Declaración anual completa con cadena de los últimos dos años inmediatos anteriores:</span><div><span ng-if=\"vm.form.declaracion_anual\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.declaracion_anual\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Estados financieros anuales del año inmediato anterior:</span><div><span ng-if=\"vm.form.estados_financieros_anuales\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.estados_financieros_anuales\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Estados financieros parciales, los mas recientes, con una antigüedad no mayor a 2 años:</span><div><span ng-if=\"vm.form.estados_financieros_parciales\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.estados_financieros_parciales\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Escritura de inmueble</span><div><span ng-if=\"vm.form.escritura_inmueble\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.escritura_inmueble\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Boleta parcial o avaluó</span><div><span ng-if=\"vm.form.boleta_predial\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.boleta_predial\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div><div class=\"col-xs-12 col-md-6 col-sm-4 form-group\"><span class=\"blue-color\">Certificado de libertad de gravamen</span><div><span ng-if=\"vm.form.certificado_gravamen\"><i class=\"fa fa-check\"></i> Entregado</span> <span ng-if=\"!vm.form.certificado_gravamen\"><i class=\"fa fa-times\"></i> No Entregado</span></div></div></div></div><div class=\"col-xs-12 col-md-6\" ng-if=\"vm.form.contact_natural.length > 0\"><legend class=\"legend-title\" align=\"center\">Contacto</legend><div class=\"col-xs-12 form-group\"><div class=\"row\"><div class=\"col-xs-6\" ng-repeat=\"contact in vm.form.contact_natural track by $index\"><legend class=\"legend-title\" align=\"center\">Contacto #{{ $index + 1 }}</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{contact.name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{contact.email}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Téléfono:</span><div><span>{{contact.phone_number | phonenumber}}</span></div></div></div></div></div></div></div><hr><div class=\"col-xs-12 m-b\" ng-if=\"!vm.notasFlag\"><table><tr><td><div class=\"\"><button type=\"button\" class=\"btn btn-info m-r-sm\" ng-click=\"vm.showNotas()\" ng-disabled=\"vm.notas.length == 0\">{{vm.notas.length}}</button> <a>Notas de crédito</a></div></td></tr></table><br><div class=\"col-xs-12 form-group\" style=\"margin-bottom: 40px;\"><h4>Observaciones:</h4><textarea disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.form.description\"></textarea></div></div><div class=\"ibox float-e-margins animate\" ng-if=\"vm.notasFlag\"><div class=\"ibox-title\"><h5>Notas de crédito</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"col-xs-12 col-sm-4 col-md-3 btn btn-info m-b\" ng-click=\"vm.notasFlag = false\"><span class=\"fa fa-arrow-left\"></span> Regresar</button><table class=\"table\"><thead><th>Folio</th><th>Número de póliza</th><th>Número de endoso</th><th>Fecha de emisión</th><th>Prima total</th><th>Estatus</th></thead><tr ng-repeat=\"nota in vm.notas\" ng-click=\"vm.NotasModal(nota)\"><td>{{nota.folio}}</td><td>{{nota.disease_endorsement.policy.poliza_number}} {{nota.damages_endorsement.policy.poliza_number}} {{nota.auto_endorsement.policy.poliza_number}} {{nota.life_endorsement.policy.poliza_number}}</td><td>{{nota.disease_endorsement.number_endorsement}} {{nota.damages_endorsement.number_endorsement}} {{nota.auto_endorsement.number_endorsement}} {{nota.life_endorsement.number_endorsement}}</td><td>{{nota.fecha_emision | date:\'dd/MM/yyyy\': \'UTC\'}}</td><td>{{nota.prima_total}}</td><td ng-if=\"nota.status == 1\">Pendiente</td><td ng-if=\"nota.status == 2\">Cerrada</td></tr></table></div></div></div></div><div class=\"ibox float-e-margins animate\" ng-if=\"vm.juridicalForm.url && vm.showInfo\"><div class=\"ibox-title\"><h5>Información del contratante</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><legend class=\"legend-title\" align=\"center\">Datos personales</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Nombre:</span><div><span>{{vm.juridicalForm.full_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Grupo:</span><div><span>{{vm.juridicalForm.group.group_name}}</span></div></div><div ng-if=\"vm.juridicalForm.only_sureties\" class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Tipo de contratante:</span><div><span>Solo para fianzas</span><br><span><b>Programa de Proveedores</b></span></div></div></div><div class=\"col-xs-12 form-group\" style=\"margin-bottom: 40px;\"><h4>Observaciones:</h4><textarea disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.juridicalForm.description\"></textarea></div></div></div><div class=\"ibox float-e-margins animate\" ng-if=\"vm.activityLog\"><div class=\"ibox-title\"><h5>Registro de Actividad</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info\" ng-click=\"vm.showInfo = true; vm.activityLog = false\"><span class=\"fa fa-reply\"></span> Regresar</button><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"block-log\"><div ng-repeat=\"item in log_info\"><span><b>{{ item.date | date: \'dd/MM/yyyy hh:mm:ss a\': \'UTC\' }}</b></span> <span>{{ item.msj }}</span></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.permiso_archivos\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/show-files.html\'\"></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12\"><div class=\"row\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"2\" idmodel=\"vm.contratanteId\" exportable=\"true\"></comments></div></div></div></div></div></div></div></div>");
$templateCache.put("app/fianzas/pproveedor.moral.edit.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Contratantes</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"fianzas.pprovlist\">Contratantes</a></li><li class=\"active\"><strong>Editar</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div><form class=\"col-xs-12\" method=\"post\" name=\"form2\" ng-submit=\"vm.submitJuridical(form2.$valid)\" novalidate=\"\" role=\"form\"><div class=\"data-container\"><div class=\"col-xs-12 nopadding form-group\" ng-class=\"{ \'has-error\': form2.j_name.$invalid && !form2.j_name.$pristine }\"><label>Nombre de la empresa <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"j_name\" ng-model=\"vm.juridicalForm.j_name\" required=\"\" type=\"text\"></div></div><div><input type=\"hidden\" name=\"type_person\" ng-model=\"vm.juridicalForm.type\" value=\"\"></div></form></div></div></div><div class=\"row\" ng-if=\"vm.permiso_archivos\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/upload.html\'\" ng-if=\"vm.user.permiso.crear && vm.user.permiso.editar\"></div><div class=\"col-xs-12 col-sm-4 col-md-3 pull-right form-group\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-click=\"vm.uploadImages()\" ng-if=\"vm.user.permiso.crear && vm.user.permiso.editar\">Subir archivos</button></div><div ng-include=\"\'templates/show-files.html\'\"></div></div></div></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"vm.save_moral()\" ng-if=\"vm.user.permiso.editar\">Guardar cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/fianzas/programa.list.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-lg-9\"><h2>Contratantes Programa de Proveedores</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"fianzas.pprovlist\">Programa de Proveedores</a></li><li class=\"active\"><strong>Buscar</strong></li></ol></div></div><br><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content padding-bottom-0\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Nombre</label> <input type=\"text\" class=\"form-control\" placeholder=\"Ingresa un nombre\" ng-model=\"vm.form.contratante\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>RFC</label> <input type=\"text\" class=\"form-control\" placeholder=\"Ingresa un RFC\" ng-model=\"vm.form.rfc\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Condiciones</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_condition\" ng-change=\"selectConditions(select_condition)\"><option value=\"1\">Sin vendedor</option><option value=\"2\">Sin correo electrónico</option><option value=\"3\">Sin teléfono</option></select></div><div class=\"col-xs-12 col-md-8 col-lg-12 form-group btn-action\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-3 pull-right\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.Consultar()\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins border-bottom\"><div class=\"ibox-title\"><h5>Contratantes</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"vm.persons.all.length\"><table class=\"table table-stripped table-hover hidden-xs hidden-sm\" ng-if=\"!vm.show_binnacle\"><thead><tr><th ng-model=\"vm.table.headers[0]\" ng-click=\"vm.Consultar()\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.order_asc, \'fa fa-sort-asc\': !vm.order_asc}\"></span></th><th>Grupo</th><th>SubGrupo</th><th>SubSubGrupo</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th>Creado por</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th></tr></thead><tbody><tr class=\"gradeX\" ng-click=\"vm.goToContractorView(person)\" ng-repeat=\"person in vm.persons.all track by $index\" ng-if=\"vm.persons.all.length\"><td>{{ person.full_name }}</td><td>{{ person.group }}</td><td>{{ person.subgrupo }}</td><td>{{ person.subsubgrupo }}</td><td>{{ person.type_person }}</td><td>{{ person.owner }}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(person)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"7\" model=\"person.full_name\" associated=\"person.id\"></tasks></td></tr><tr ng-if=\"vm.persons\" class=\"gradeX\" ng-click=\"vm.goToContractorView(person)\" ng-repeat=\"person in vm.persons track by $index\"><td>{{ person.full_name }} {{person.j_name}}</td><td>{{ person.group }}</td><td>{{ person.subgrupo }}</td><td>{{ person.subsubgrupo }}</td><td>{{ person.type_person }}</td><td>{{ person.owner }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_naturals && !vm.show_binnacle\" class=\"text-center hidden-xs hidden-sm\"><pagination config=\"vm.naturals_config\" model=\"vm.persons.naturals\"></pagination></div><div ng-if=\"vm.show_pag_juridicals\" class=\"text-center hidden-xs hidden-sm\"><pagination config=\"vm.juridicals_config\" model=\"vm.persons.juridicals\"></pagination></div><div ng-if=\"show_pagination && !vm.show_binnacle\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"person in vm.persons.naturals track by $index\" ng-if=\"vm.persons.naturals.length || type_person == 1\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }} : {{ person.full_name }} {{person.j_name }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ng-click=\"vm.goToContractorView(person)\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ person.full_name }} {{person.j_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ person.type_person }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(person)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></div></div></div></div><div ng-if=\"vm.show_pagination\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-3\" ng-if=\"vm.persons.naturals.length && !vm.show_binnacle\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 btn btn-primary\" ng-click=\"vm.exportDataE(1)\">Generar Reporte</button></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-3\" ng-if=\"vm.persons.all.length && !vm.show_binnacle\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 btn btn-primary\" ng-click=\"vm.exportDataE(0)\">Generar Reporte</button></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-3\" ng-if=\"vm.persons.juridicals.length && !vm.show_binnacle\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 btn btn-primary\" ng-click=\"vm.exportDataE(2)\">Generar Reporte</button></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" typemodel=\"2\" config=\"vm.comments_config\" idmodel=\"vm.person_id\"></comments><div class=\"col-xs-12 col-sm-4 col-md-3\"><div class=\"row\"><a class=\"col-xs-12 btn btn-primary margin-top-10\" ng-click=\"vm.returnToContractors(2)\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div></div></div></div></div></div>");
$templateCache.put("app/fianzas/programa.new.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\" ng-init=\"type(2)\"><div class=\"col-xs-12 col-lg-9\"><h2>Contratantes Programa de Proveedores</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Contratantes</strong></li></ol></div></div><div class=\"row wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div id=\"addContratantes\" class=\"col-xs-12\" ng-init=\"type(2)\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><uib-tabset template-url=\"app/fianzas/contratantes.tabset.html\" active=\"activeJustified\" justified=\"true\" ng-click=\"type(2); vm.form.only_sureties = true;onlyFianzas(2)\"><uib-tab template-url=\"app/fianzas/contratantes.tab.html\" active=\"activeJustified\" index=\"1\" heading=\"Morales\" ng-init=\"type(2);vm.juridicalForm.only_sureties = true;onlyFianzas(2)\"><div class=\"ibox-content\"><toaster-container></toaster-container><div class=\"row\"><div class=\"row data-container\"><div class=\"col-xs-12\"><legend class=\"col-xs-12 legend-title\" align=\"center\">Datos del contratante</legend><div class=\"col-xs-12 nopadding form-group\" ng-class=\"{ \'has-error\': form2.j_name.$invalid && !form2.j_name.$pristine }\"><label>Nombre de la empresa <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"j_name\" ng-model=\"vm.juridicalForm.j_name\" ng-change=\"saveLocalstorange()\" required=\"\" type=\"text\"></div></div><div class=\"row col-xs-12 col-lg-12 nopadding\"><div ng-if=\"vm.permiso_archivos\"><div upload-template=\"\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button id=\"saveButtonMoral\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"vm.submitFormJuridical1()\">Guardar contratante</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button id=\"cancelButtonMoral\" class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></uib-tab></uib-tabset></div></div></div></div></div>");
$templateCache.put("app/fianzas/receipt-modal.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Actualizar Recibo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><h3>Estatus actual:</h3><div ng-bind=\"rec.recibo.status | receipts\" class=\"label\" ng-class=\"{\'label-success\': rec.recibo.status == 1 || rec.recibo.status == 5, \'label-danger\': rec.recibo.status == 2, \'label-warning\' : rec.recibo.status == 3 || rec.recibo.status == 4, \'label-default\': rec.recibo.status == 6 || rec.receipt.status == 7 || rec.recibo.status == 8}\"></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Número de Recibo</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.recibo_numero\" name=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Inicio Vigencia</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"rec.recibo.fecha_inicio\" value=\"{{rec.recibo.fecha_inicio}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fin Vigencia</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"rec.recibo.fecha_fin\" value=\"{{rec.recibo.fecha_fin}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Prima Primera</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.prima_neta\" ng-change=\"validateDecimal(rec.recibo.prima_neta); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Derecho</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.rpf\" ng-change=\"validateDecimal(rec.recibo.rpf); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Gastos</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.derecho\" ng-change=\"validateDecimal(rec.recibo.derecho); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>IVA</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.iva\" ng-change=\"validateDecimal(rec.recibo.iva); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Comisión</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.comision\" ng-change=\"validateDecimal(rec.recibo.comision); changePrimas(rec.recibo);\" name=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Vencimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"rec.recibo.vencimiento\" value=\"{{rec.recibo.vencimiento}}\" data-date-format=\"mm/dd/yyyy\" disabled=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Subtotal</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.sub_total\" name=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Prima Total</label> <input class=\"form-control\" type=\"text\" ng-model=\"rec.recibo.prima_total\" name=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Entregado</label> <input class=\"form-control\" type=\"checkbox\" ng-model=\"rec.recibo.delivered\" name=\"\"></div><div class=\"col-xs-12\" ng-if=\"rec.recibo.receipt_type == 3\"><label>Las cantidades en las notas de crédito tienen que ir con valores negativos.</label></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"saveReceipt(rec.recibo)\">Guardar Cambios</button></div></div>");
$templateCache.put("app/fianzas/reclamaciones.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Reclamaciones</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a ui-sref=\"fianzas.reclist\">Fianzas</a></li><li class=\"active\"><strong>Reclamaciones</strong></li></ol></div></div><br><div class=\"btn-group pull-right m-b option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_ver_fia && vm.insurance.poliza.status != 1 && vm.insurance.poliza.status !=2\"><a ui-sref=\"fianzas.info({polizaId: vm.insurance.poliza.id})\">Ver fianza</a></li><li ng-if=\"vm.acceso_ver_ot && (vm.insurance.poliza.status == 1 || vm.insurance.poliza.status ==2)\"><a ui-sref=\"fianzas.info({polizaId: vm.insurance.poliza.id})\">Ver OT</a></li><li ng-if=\"vm.acceso_adm_ot && (vm.insurance.status != 11 || vm.insurance.status !=8)\"><a ui-sref=\"reclamacion.edit({reclId: vm.insurance.id})\">Editar</a></li><li ng-if=\"vm.acceso_elim_fia\"><a ng-click=\"deleteFianza(vm.insurance)\">Eliminar</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length && view_cartas\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, carta.id)\">{{carta.name}}</a></li><li><a ng-click=\"vm.getPDF(vm.insurance.id)\">Resumen PDF</a></li></ul></li></ul></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"vm.insurance.number_endorsement\">Información de la reclamación</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\">Log</i></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4\"><legend class=\"legend-title\" align=\"center\">Fianza</legend><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Afianzadora:</span><div><span>{{ vm.insurance.poliza.aseguradora }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Fiado</span><div><span>{{ vm.insurance.poliza.contractor.full_name}}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Número de fianza:</span><div><span>{{ vm.insurance.poliza.poliza_number }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.insurance.poliza.subramo }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Tipo:</span><div><span>{{ vm.insurance.poliza.fianza_type.type_name }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Monto afianzado:</span><div><span>{{ vm.insurance.poliza.contract_poliza.guarantee_amount | currency}}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.insurance.poliza.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ vm.insurance.poliza.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Creada por:</span><div><span>{{ vm.insurance.poliza.owner }}</span></div></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><legend class=\"legend-title\" align=\"center\">Reclamación<div class=\"btn-group m-b pull-right\" ng-if=\"vm.acceso_adm_fia\"><button type=\"button\" class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">Cambiar estatus</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"changeStatus(1)\" ng-if=\"vm.insurance.status != 1\">Presentación</a></li><li><a ng-click=\"changeStatus(2)\" ng-if=\"vm.insurance.status != 2\">En integración</a></li><li><a ng-click=\"changeStatus(3)\" ng-if=\"vm.insurance.status != 3\">Reclamo Formal</a></li><li><a ng-click=\"changeStatus(4)\" ng-if=\"vm.insurance.status != 4\">Respuesta afianzadora</a></li><li><a ng-click=\"changeStatus(5)\" ng-if=\"vm.insurance.status != 5\">Respuesta cliente</a></li><li><a ng-click=\"changeStatus(6)\" ng-if=\"vm.insurance.status != 6\">Reconsideración</a></li><li><a ng-click=\"changeStatus(7)\" ng-if=\"vm.insurance.status != 7\">Rechazada</a></li><li><a ng-click=\"changeStatus(8)\" ng-if=\"vm.insurance.status != 8\">Pagada</a></li><li><a ng-click=\"changeStatus(9)\" ng-if=\"vm.insurance.status != 9\">Desistimiento</a></li><li><a ng-click=\"changeStatus(10)\" ng-if=\"vm.insurance.status != 11\">Recuperación</a></li><li><a ng-click=\"changeStatus(11)\" ng-if=\"vm.insurance.status != 11\">Cerrada</a></li></ul></div></legend><div class=\"col-xs-12 col-sm-3 form-group\" style=\"word-wrap: break-word;\"><span class=\"blue-color\">Número de reclamación</span><div><span>{{ vm.insurance.number }}</span></div></div><div class=\"col-xs-12 col-sm-3 form-group\" style=\"word-wrap: break-word;\"><span class=\"blue-color\">Tipo</span><div><span>{{ type(vm.insurance.claim_type) }}</span></div></div><div class=\"col-xs-12 col-sm-12 form-group\" style=\"word-wrap: break-word;\"><span class=\"blue-color\">Motivo:</span><div><span>{{ vm.insurance.reason }}</span> <span ng-if=\"vm.insurance.other_desc\">- {{ vm.insurance.other_desc }}</span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Fecha presentación:</span><div><span>{{ vm.insurance.introduction_date | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.insurance.poliza.subramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-2 form-group\"><h4><b>Estatus:</b></h4><div class=\"label\" ng-class=\"{\'label-success\': vm.insurance.status == 2, \'label-info\' : vm.insurance.status == 5,\'label-primary\' : vm.insurance.status == 1, \'label-warning\' : vm.insurance.status == 3 || vm.insurance.status == 4}\" style=\"float: left; margin-right: 10px\">{{ status(vm.insurance.status) }}</div></div><div class=\"col-xs-12 col-sm-8 col-md-6 form-group\"><span class=\"blue-color\">Observaciones:</span><div>{{ vm.insurance.observations}}</div></div><div class=\"col-xs-12\"><hr></div><div ng-if=\"vm.insurance.status == 2\"><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Neta:</span><div>{{ vm.insurance.p_neta | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.insurance.endorsement_type == \'A\'\"><span class=\"blue-color\">Derecho:</span><div>{{ vm.insurance.derecho | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">RPF:</span><div>{{ vm.insurance.rpf | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Iva:</span><div>{{ vm.insurance.iva | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Comisión:</span><div>{{ vm.insurance.comision | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Total:</span><div>{{ vm.insurance.p_total | currency}}</div></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"col-xs-12 form-group\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(vm.insurance)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Archivos</button></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/show-files.html\'\"></div></div></div></div></div><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"10\" idmodel=\"vm.endosoId\" exportable=\"true\"></comments></div></div></div></div></div><div class=\"row\"><script type=\"text/javascript\">\n\n    function renombrarArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n\n      btnTag.addClass(\'display-none\');\n      dummy.removeClass(\'display-none\');\n\n\n      inputTag.removeClass(\'display-none\');\n      strongTag.addClass(\'display-none\');\n\n      inputTag.focus();\n    }\n\n    function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target);\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n\n      // btnTag.prop(\'onclick\',null).off(\'click\');\n\n      btnTag.removeClass(\'display-none\');\n      dummy.addClass(\'display-none\');\n\n\n      inputTag.addClass(\'display-none\');\n      strongTag.removeClass(\'display-none\');\n    }\n  </script></div>");
$templateCache.put("app/fianzas/reclamaciones.list.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reclamaciones</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"fianzas.list\">Fianzas</a></li><li class=\"active\"><strong>Reclamaciones</strong></li></ol></div></div><div class=\"row wrapper wrapper-content animated fadeIn ng-scope\"><button class=\"btn btn-info m-b\" ui-sref=\"fianzas.reclamaciones\" ng-if=\"vm.acceso_adm_fia\"><i class=\"fa fa-plus\"></i> Nueva reclamación</button><ul id=\"contextFianzas\" class=\"dropdown-menu\" role=\"menu\" z-index=\"1000\"></ul><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Reclamaciones</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"results-container\" ng-if=\"!vm.show_binnacle_claim\"><div class=\"col-xs-12 panel-body\"><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in claims track by $index\"><div class=\"ibox-title\"><h5>Fianza: {{ insurance.fianza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ui-sref=\"fianzas.info({polizaId: insurance.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>Póliza</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Contratante</label><p>{{ insurance.contractor.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Aseguradora</label><p>{{ insurance.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Subramo</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Forma de pago</label><p payment=\"{{insurance.forma_de_pago}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Estatus</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Vigencia</label><p>{{ insurance.start_of_validity | date: \'medium\': \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Antigüedad</label><p ng-if=\"!(insurance.antiguedad > 0)\">0 días</p><p ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Acciones</label><p ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></div></div></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Estatus:</label><select class=\"form-control\" ng-model=\"searchStatus\" data-ng-options=\"status.name for status in statuses\" required=\"\"><option value=\"\" disabled=\"\">Seleccione un estatus</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de presentación inicio:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"init_date\" class=\"width-100 text-align-center form-control\" ng-model=\"init_date\" value=\"{{init_date}}\" ng-change=\"change_init_date(init_date)\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fecha de presentación fin:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"end_date\" ng-change=\"change_end_date(end_date)\" class=\"width-100 text-align-center form-control\" ng-model=\"end_date\" value=\"{{end_date}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><table class=\"table table-bordered table-hover hidden-xs hidden-sm\"><thead><tr><th ng-click=\"vm.changeOrder(1, vm.order_poliza_asc == 1 ? 2 : 1)\">Beneficiario <span ng-class=\"{\'fa fa-sort-desc\': vm.order_poliza_asc == 1, \'fa fa-sort-asc\': vm.order_poliza_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(2, vm.order_contractor_asc == 1 ? 2 : 1)\">Fiado <span ng-class=\"{\'fa fa-sort-desc\': vm.order_contractor_asc == 1, \'fa fa-sort-asc\': vm.order_contractor_asc == 2}\"></span></th><th># Reclamación</th><th ng-click=\"vm.changeOrder(3, vm.order_provider_asc == 1 ? 2 : 1)\">Fianza <span ng-class=\"{\'fa fa-sort-desc\': vm.order_provider_asc == 1, \'fa fa-sort-asc\': vm.order_provider_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(3, vm.order_provider_asc == 1 ? 2 : 1)\">Afianzadora <span ng-class=\"{\'fa fa-sort-desc\': vm.order_provider_asc == 1, \'fa fa-sort-asc\': vm.order_provider_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(5, vm.order_subramo_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_subramo_asc == 1, \'fa fa-sort-asc\': vm.order_subramo_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(6, vm.order_type_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_type_asc == 1, \'fa fa-sort-asc\': vm.order_type_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(7, vm.order_status_asc == 1 ? 2 : 1)\">Estatus <span ng-class=\"{\'fa fa-sort-desc\': vm.order_status_asc == 1, \'fa fa-sort-asc\': vm.order_status_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(8, vm.order_vigencia_asc == 1 ? 2 : 1)\">Reclamación <span ng-class=\"{\'fa fa-sort-desc\': vm.order_vigencia_asc == 1, \'fa fa-sort-asc\': vm.order_vigencia_asc == 2}\"></span></th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"insurance in claims track by $index\" ng-click=\"selectSurety(insurance)\" context=\"contextFianzas\" ng-right-click=\"ShowContextMenu(\'Información Reclamación\', insurance.id)\"><td>{{ insurance.benefited.first_name }} {{ insurance.benefited.last_name }} {{ insurance.benefited.second_last_name }} {{ insurance.benefited.j_name }}</td><td><span>{{ insurance.poliza.contractor.full_name }}</span></td><td>{{ insurance.number }}</td><td><span ng-if=\"insurance.poliza.poliza_number\">{{ insurance.poliza.poliza_number }}</span><span ng-if=\"insurance.poliza.internal_number\">{{ insurance.poliza.internal_number }}</span></td><td>{{ insurance.poliza.aseguradora }}</td><td>{{ insurance.poliza.subramo }}</td><td>{{ insurance.poliza.fianza_type }}</td><td>{{status(insurance.status)}}</td><td>{{type(insurance.claim_type)}}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_search\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><button style=\"margin-left: 10px\" ng-if=\"claims && claims.length > 0\" class=\"btn btn-info m-b pull-right\" ng-click=\"makeReport(searchStatus)\"><i class=\"fa fa-table\"></i> Generar Reporte</button> <button class=\"btn btn-info m-b pull-right\" ng-click=\"getStatus(searchStatus)\"><i class=\"fa fa-arrow-right\"></i> Consultar</button></div></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle_claim\"><div><label>Bitácora de Reclamación Fianza</label></div><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data_claim\" typemodel=\"21\" config=\"vm.comments_config_claim\" idmodel=\"vm.reclamacion_id\"></comments><div class=\"col-xs-12 col-sm-4 col-md-3\"><div class=\"row\"><a class=\"col-xs-12 btn btn-primary margin-top-10\" ng-click=\"vm.returnToFianzaR()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/filtros/filtro.compartir.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Filtro por Usuario</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Filtro por Usuario</a></li><li class=\"active\"><strong>Compartir</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtro por Usuario</h5></div><div class=\"ibox-content\"><div class=\"col-xs-12 form-group\"><div class=\"col-xs-12 col-sm-6\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': selectUser == \'usuario\'}\"><input type=\"radio\" ng-model=\"selectUser\" value=\"usuario\" ng-click=\"valueUser = \'\'; showTable = false;\"> Usuario</label></div></div><div class=\"col-xs-12 col-sm-6\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': selectUser == \'grupo\'}\"><input type=\"radio\" ng-model=\"selectUser\" value=\"grupo\" ng-click=\"valueUser = \'\'; showTable = false;\"> Grupo de Usuarios</label></div></div></div><div class=\"col-xs-12 col-sm-6 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"valueUser\" change=\"findUser(valueUser)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" ng-click=\"userSelect(valueUser)\" class=\"btn btn-success\">Buscar</button></div></div><div ng-if=\"showTable\"><div class=\"col-xs-12 form-group\" ng-if=\"selectUser == \'usuario\'\"><legend class=\"legend-title\" align=\"center\" \"=\"\">Usuario: {{ userSelected.first_name }} {{ userSelected.last_name }}</legend></div><div class=\"col-xs-12 form-group\" ng-if=\"selectUser == \'grupo\'\"><legend class=\"legend-title\" align=\"center\">Grupo de Usuarios: {{ valueUser.value }}</legend><ul class=\"row address_components\" style=\"padding-top: 10px;\"><li class=\"col-xs-12 col-sm-6 col-md-4\" ng-repeat=\"user in groupsList\">{{ user.first_name }} {{ user.last_name }}</li></ul></div><div class=\"row address-container\" ng-repeat=\"shared in shareds track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteShared($index)\" ng-disabled=\"shareds.length <= 1\">Quitar Asignación</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteShared($index)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Asignación #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addShared()\" type=\"button\">Agregar Asignación</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addShared()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Aseguradora</label><select class=\"form-control\" ng-options=\"aseguradora.alias for aseguradora in providers | orderBy: \'alias\' track by aseguradora.url\" ng-model=\"shared.aseguradora\"><option value=\"\">Selecciona un proveedor</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"shared.contratante\" change=\"matchesContractors(shared.contratante)\"></autocomplete></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Fianza</label><autocomplete datasource=\"fianza_data\" id=\"fianzas\" model=\"shared.fianza\" change=\"matchesFianzas(shared.fianza)\"></autocomplete></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"shared.grupo\" change=\"matchesGroup(shared.grupo)\"></autocomplete></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Póliza</label><autocomplete datasource=\"policies_data\" id=\"polizas\" model=\"shared.poliza\" change=\"matchesPolicies(shared.poliza)\"></autocomplete></div></div></div><div class=\"col-xs-12 form-group\"><button class=\"btn btn-primary pull-right\" ng-click=\"saveShared()\">Compartir al usuario</button></div></div></div></div></div></div>");
$templateCache.put("app/filtros/filtro.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Filtro por Usuario</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Filtro por Usuario</a></li><li class=\"active\"><strong>Asignar</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Grupos de Usuarios</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info m-t\" ng-click=\"createGroupUser(true)\">Crear Grupo de Usuarios</button></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-primary m-t\" ng-click=\"asignUsers(true)\">Agregar Usuarios a un Grupo</button></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-success m-t\" ng-click=\"editGroupUsers(true)\">Editar un Grupo de Usuarios</button></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-white m-t\" ng-click=\"eliminarGroupUsers(true)\">Eliminar un Grupo de Usuarios</button></div><div class=\"col-xs-12 address_components\" ng-show=\"showGroupUser\"><legend class=\"legend-title\" align=\"center\">Nuevo Grupo de Usuario</legend><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre del Grupo: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.form.name\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-info\" ng-disabled=\"!vm.form.name\" ng-click=\"saveGroupUser(vm.form, 1)\">Crear Grupo</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"createGroupUser(false)\">Cancelar</button></div></div><div class=\"col-xs-12\" ng-show=\"showListGroupUser\"><legend class=\"legend-title\" align=\"center\">Grupos de Usuario</legend><div><div class=\"col-xs-12 form-group\" align=\"center\"><span class=\"blue-color\">Nombre del Grupo</span><div><span>{{ groupsUsers.name }}<span></span></span></div></div></div></div><div class=\"col-xs-12 address_components\" ng-show=\"addUsersToGroup\"><legend class=\"legend-title\" align=\"center\">Asignación de Usuarios a un Grupo</legend><div class=\"col-xs-12 col-sm-6 form-group\"><label>Grupo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"gu as gu.name for gu in groupsUsersList | orderBy:\'name\' track by gu.url\" ng-change=\"changeGroup();\" name=\"group\" ng-model=\"group.name\"><option value=\"\">Selecciona un grupo</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Usuarios:</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"users.first_name + \' \'+users.last_name for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"></select><span><span class=\"color-red\">*</span> Asigne sólo los usuarios que no estén dentro del grupo</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary\" ng-disabled=\"!group.name\" ng-click=\"saveUserinGroup(group,1)\">Asignar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"createGroupUser(false)\">Cancelar</button></div></div><div class=\"col-xs-12 address_components\" ng-show=\"editGroupUser\"><legend class=\"legend-title\" align=\"center\">Editar Grupo de Usuarios</legend><div class=\"col-xs-12 col-sm-6 form-group\"><label>Grupo:</label><select class=\"form-control\" ng-options=\"gu as gu.name for gu in groupsUsersList | orderBy:\'name\' track by gu.url\" ng-change=\"groupSelect(group.name);\" name=\"group\" ng-model=\"group.name\"><option value=\"\">Selecciona un grupo</option></select></div><div ng-if=\"showChangeNameGroup\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre del Grupo:</label> <input class=\"form-control\" type=\"text\" ng-model=\"groupName.name\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button type=\"button\" ng-click=\"saveEditGroupName(groupName)\" ng-disabled=\"!group.name\" class=\"col-xs-12 btn btn-success\">Guardar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button type=\"button\" ng-click=\"editGroupUsers()\" class=\"col-xs-12 btn btn-white\">Cancelar</button></div></div></div><div class=\"col-xs-12 address_components\" ng-show=\"delUsersToGroup\"><legend class=\"legend-title\" align=\"center\">Eliminar Grupo de Usuarios</legend><div class=\"col-xs-12 col-sm-6 form-group\"><label>Grupo <span class=\"color-red\">*</span></label><div><select class=\"form-control\" ng-options=\"gu as gu.name for gu in groupsUsersList | orderBy:\'name\' track by gu.url\" ng-change=\"getUsers(group);\" name=\"group\" ng-model=\"group.name\"><option value=\"\">Selecciona un grupo</option></select></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"groupsList.length > 0\"><label>Usuarios</label><ul class=\"row\" ng-if=\"groupsList.length > 0\"><li class=\"col-xs-12 col-sm-6\" ng-repeat=\"user in groupsList\">{{ user.first_name }} {{ user.last_name }}</li></ul></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary\" ng-disabled=\"!group.name\" ng-click=\"delGroupAll(group,1)\">Eliminar Grupo</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"eliminarGroupUsers(false)\">Cancelar</button></div></div></div></div></div></div></div>");
$templateCache.put("app/filtros/filtro.lista.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Filtro por Usuario</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Filtro por Usuario</a></li><li class=\"active\"><strong>Lista</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Usuarios</h5></div><div class=\"ibox-content\"><div class=\"col-xs-12\"><ul class=\"list-group\"><div ng-repeat=\"user in users\" ng-if=\"user.usuario__first_name != \'\'\"><div ng-if=\"user.usuario__first_name != null\"><li class=\"list-group-item\" ng-init=\"user[$index] = false\"><legend class=\"legend-title\" ng-click=\"user[$index] ? user[$index] = false : user[$index] = true; getInfoUser(user, $index)\">{{ user.usuario__first_name }} {{ user.usuario__last_name }}</legend><div class=\"row\" ng-if=\"user[$index] && user_index == $index\"><div class=\"panel-body table-over-y\"><legend class=\"legend-title\" align=\"center\">Tabla de Asignación</legend><div class=\"dropdown pull-right\"><button class=\"btn btn-info dropdown-toggle\" type=\"button\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\">Opciones <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" aria-labelledby=\"dropdownMenu1\"><li><a ng-click=\"showDeleteShareUser()\">Quitar Asignaciones</a></li></ul></div><br><br><br><div class=\"alert alert-info\" role=\"alert\"><b>Nota:</b> <span>El usuario podrá ver pólizas, contratantes, etc, aunque no esten asignados directamente, la razón es porque están relacionados con alguna asignación.</span></div><table class=\"table table-bordered table-hover m-t\"><thead><tr><th>Módulo</th><th>Asignación</th></tr></thead><tbody><tr><td>Aseguradoras</td><td><ul ng-repeat=\"asignacion in asignaciones.info.aseguradoras\" ng-if=\"asignacion.aseguradora__count != 0\"><li>{{ asignacion.aseguradora__compania }} <button ng-if=\"showButtonDeleteShareUser\" class=\"btn\" ng-click=\"deleteShare(user, asignacion, 1)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr><tr><td>Contratantes Físicos</td><td><ul ng-repeat=\"asignacion in asignaciones.info.contratante_fisico\" ng-if=\"asignacion.contratante_fisico__count != 0\"><li>{{ asignacion.contratante_fisico__full_name }} <button ng-if=\"showButtonDeleteShareUser\" class=\"btn\" ng-click=\"deleteShare(user, asignacion, 2)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr><tr><td>Contratantes Morales</td><td><ul ng-repeat=\"asignacion in asignaciones.info.contratante_moral\" ng-if=\"asignacion.contratante_moral__count != 0\"><li>{{ asignacion.contratante_moral__j_name }} <button ng-if=\"showButtonDeleteShareUser\" class=\"btn\" ng-click=\"deleteShare(user, asignacion, 3)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr><tr><td>Fianzas</td><td><ul ng-repeat=\"asignacion in asignaciones.info.fianza\" ng-if=\"asignacion.fianza__count != 0\"><li>{{ asignacion.fianza__fianza_number }} <button ng-if=\"showButtonDeleteShareUser\" class=\"btn\" ng-click=\"deleteShare(user, asignacion, 4)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr><tr><td>Grupos</td><td><ul ng-repeat=\"asignacion in asignaciones.info.grupo_de_contratantes\" ng-if=\"asignacion.grupo_de_contratantes__count != 0\"><li>{{ asignacion.grupo_de_contratantes__group_name }} <button ng-if=\"showButtonDeleteShareUser\" class=\"btn\" ng-click=\"deleteShare(user, asignacion, 5)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr><tr><td>Pólizas</td><td><ul ng-repeat=\"asignacion in asignaciones.info.poliza\" ng-if=\"asignacion.poliza__count != 0\"><li>{{ asignacion.poliza__poliza_number }} <button ng-if=\"showButtonDeleteShareUser\" class=\"btn\" ng-click=\"deleteShare(user, asignacion, 6)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr></tbody></table><div class=\"col-xs-12\"><button ng-if=\"showButtonDeleteShareUser\" class=\"btn btn-white pull-right\" ng-click=\"hideDeleteShareUser(false)\" title=\"Cancelar Eliminación de Asignación\">Cancelar</button></div></div></div></li></div></div></ul></div></div></div></div><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Grupos de Usuarios</h5></div><div class=\"ibox-content\"><div class=\"col-xs-12\"><ul class=\"list-group\"><div ng-repeat=\"group in groups\" ng-if=\"group.grupo__name != \'\'\"><div ng-if=\"group.grupo__name != null\"><li class=\"list-group-item\" ng-init=\"group[$index] = false\"><legend class=\"legend-title\" ng-click=\"group[$index] ? group[$index] = false : group[$index] = true; getInfoGroup(group, $index)\">{{ group.grupo__name }}</legend><div class=\"row\" ng-if=\"group[$index] && group_index == $index\"><div class=\"panel-body table-over-y\"><legend class=\"legend-title\" align=\"center\">Tabla de Asignación</legend><div class=\"dropdown pull-right\"><button class=\"btn btn-info dropdown-toggle\" type=\"button\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\">Opciones <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" aria-labelledby=\"dropdownMenu1\"><li><a ng-click=\"showDeleteUser()\">Eliminar Usuarios</a></li><li><a ng-click=\"showDeleteShare()\">Quitar Asignaciones</a></li></ul></div><br><br><table class=\"table table-bordered table-hover m-t\"><thead><tr><th>Usuarios</th></tr></thead><tbody><tr><td><ul class=\"row\"><li class=\"col-xs-12 col-sm-6 col-md-4\" ng-repeat=\"user in groupsList track by user.id\">{{ user.first_name }} {{ user.last_name }}<button ng-if=\"showButtonDeleteUser\" class=\"btn\" ng-click=\"deleteUser(group ,user)\" title=\"Eliminar Usuario del Grupo\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul><button ng-if=\"showButtonDeleteUser\" class=\"btn btn-white m-t\" ng-click=\"hideDeleteUser()\">Cancelar</button></td></tr></tbody></table><div class=\"alert alert-success\" role=\"alert\"><b>Nota:</b> <span>Los usuarios podrán ver pólizas, contratantes, etc, aunque no esten asignados directamente, la razón es porque están relacionados con alguna asignación.</span></div><table class=\"table table-bordered table-hover m-t\"><thead><tr><th>Módulo</th><th>Asignación</th></tr></thead><tbody><tr><td>Aseguradoras</td><td><ul ng-repeat=\"asignacion in asignacionesGroup.info.aseguradoras\" ng-if=\"asignacion.aseguradora__count != 0\"><li>{{ asignacion.aseguradora__compania }} <button ng-if=\"showButtonDeleteShare\" class=\"btn\" ng-click=\"deleteShare(group, asignacion, 1)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr><tr><td>Contratantes Físicos</td><td><ul ng-repeat=\"asignacion in asignacionesGroup.info.contratante_fisico\" ng-if=\"asignacion.contratante_fisico__count != 0\"><li>{{ asignacion.contratante_fisico__full_name }} <button ng-if=\"showButtonDeleteShare\" class=\"btn\" ng-click=\"deleteShare(group, asignacion, 2)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr><tr><td>Contratantes Morales</td><td><ul ng-repeat=\"asignacion in asignacionesGroup.info.contratante_moral\" ng-if=\"asignacion.contratante_moral__count != 0\"><li>{{ asignacion.contratante_moral__j_name }} <button ng-if=\"showButtonDeleteShare\" class=\"btn\" ng-click=\"deleteShare(group, asignacion, 3)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr><tr><td>Fianzas</td><td><ul ng-repeat=\"asignacion in asignacionesGroup.info.fianza\" ng-if=\"asignacion.fianza__count != 0\"><li>{{ asignacion.fianza__fianza_number }} <button ng-if=\"showButtonDeleteShare\" class=\"btn\" ng-click=\"deleteShare(group, asignacion, 4)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr><tr><td>Grupos</td><td><ul ng-repeat=\"asignacion in asignacionesGroup.info.grupo_de_contratantes\" ng-if=\"asignacion.grupo_de_contratantes__count != 0\"><li>{{ asignacion.grupo_de_contratantes__group_name }} <button ng-if=\"showButtonDeleteShare\" class=\"btn\" ng-click=\"deleteShare(group, asignacion, 5)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr><tr><td>Pólizas</td><td><ul ng-repeat=\"asignacion in asignacionesGroup.info.poliza\" ng-if=\"asignacion.poliza__count != 0\"><li>{{ asignacion.poliza__poliza_number }} <button ng-if=\"showButtonDeleteShare\" class=\"btn\" ng-click=\"deleteShare(group, asignacion, 6)\" title=\"Eliminar Asignación\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button></li></ul></td></tr></tbody></table><div class=\"col-xs-12\"><button ng-if=\"showButtonDeleteShare\" class=\"btn btn-white pull-right\" ng-click=\"hideDeleteShare(false)\" title=\"Cancelar Eliminación de Asignación\">Cancelar</button></div></div></div></li></div></div></ul></div></div></div></div></div>");
$templateCache.put("app/flotillas/flotillas.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Colectividades</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Colectividades</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 animate\" ng-show=\"!show_contractor\"><br><div ng-include=\"\" src=\"\'app/flotillas/ordenes.html\'\"></div><div class=\"col-xs-12 col-sm-4 form-group pull-right\"><button class=\"btn btn-primary col-xs-12 m-t\" ng-click=\"validityInsurance()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Cambios</button></div><div class=\"col-xs-12 col-sm-4 form-group pull-right\"><button class=\"btn btn-white col-xs-12 m-t\" ui-sref=\"flotillas.info({polizaId: caratula.id})\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div class=\"col-xs-12 animate z-index-9000\" ng-if=\"show_contractor\"><ng-include src=\"\'app/contratantes/contratantes.add.html\'\" ng-controller=\"ContratantesCtrl as vm\"></ng-include></div></div>");
$templateCache.put("app/flotillas/flotillas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Colectividades</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Colectividades</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"panel-group\"><div class=\"panel panel-default\" ng-init=\"showCar = false\"><div class=\"panel-heading\" ng-click=\"showCar ? showCar = false : showCar = true\"><h4 class=\"panel-title\"><a>Carátula <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showCar\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showCar\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showCar\"><div class=\"col-xs-12 animate z-index-9000\" ng-if=\"show_contractor\"><ng-include src=\"\'app/contratantes/contratantes.add.html\'\" ng-controller=\"ContratantesCtrl as vm\"></ng-include></div><div class=\"col-xs-12 animate\" ng-show=\"!show_contractor\"><br><div ng-include=\"\" src=\"\'app/flotillas/ordenes.html\'\"></div></div><div class=\"col-xs-12 col-sm-4 col-sm-offset-4 form-group\" ng-if=\"!dataCaratula.id\"><button class=\"btn btn-primary col-xs-12 m-t ladda-button\" ng-click=\"validityInsurance()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Crear Carátula</button></div></div></div><div style=\"display:none;\" class=\"panel panel-default\" ng-init=\"showPol = true\"><div class=\"panel-heading\" ng-click=\"showPol ? showPol = false : showPol = true\"><h4 class=\"panel-title\"><a>Pólizas <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showPol\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showPol\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showPol\"><br><div ng-include=\"\" src=\"\'app/flotillas/polizas.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/flotillas/flotillas.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading page-heading--modern\"><div class=\"col-lg-12\"><div class=\"page-heading__top\"><h2 class=\"page-heading__title\">Colectividades <span class=\"page-heading__badge\" ng-if=\"caratula.poliza_number\">#{{caratula.poliza_number}}</span></h2><h2 class=\"page-heading__title\" ng-if=\"!caratula.poliza_number\">OT <span class=\"page-heading__badge\" ng-if=\"caratula.internal_number\">#{{caratula.internal_number}}</span></h2></div><ol class=\"breadcrumb page-heading__breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"polizas.table\">Listado de Pólizas</a></li><li class=\"active\" aria-current=\"page\"><strong>Colectividad</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-success col-xs-12\" data-toggle=\"modal\" data-target=\"#myModal\" ng-if=\"incompleteOT.complete\">Colectividad Completa</button> <button type=\"button\" class=\"btn btn-warning col-xs-12\" data-toggle=\"modal\" data-target=\"#myModal\" ng-if=\"!incompleteOT.complete\">Colectividad Incompleta</button></div><div class=\"modal fade\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Colectividad</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Carátula:</label><ul class=\"col-p0\"><li ng-repeat=\"item in incompleteOT.caratule\"><small>{{ item.text }}</small></li></ul></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Certificados:</label><ul class=\"col-p0\"><li ng-repeat=\"item in incompleteOT.certificates\"><small>{{ item.text }}</small></li></ul></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cerrar</button></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><ul class=\"tab-group\"><li ng-class=\"{ \'active-group\': show_caratula }\" ng-click=\"show_section(1)\">Carátula</li><li ng-class=\"{ \'active-group\': show_certificado }\" ng-click=\"show_section(2)\">Pólizas</li></ul></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pull-right option_button m-b\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"editCollective(caratula)\">Editar Carátula</a></li><li ng-if=\"acceso_adm_rehabilitar && caratula.status == 11\"><a ng-click=\"reActivatePolicy(caratula.id, caratula.poliza_number)\">Rehabilitar Carátula</a></li><li ng-if=\"acceso_adm_rehabilitar && (caratula.status == 15 || caratula.status == \'No Renovada\')\"><a ng-click=\"renovarPolizaRehabilitate(caratula)\">Rehabilitar Póliza/OT para Renovar</a></li><li ng-if=\"caratula.status != \'Cancelada\'; caratula.status != \'En trámite\'; caratula.renewed_status == 0 && caratula.status != 15 || (caratula.is_renewable ==1 && !existeNueva)\"><a ng-click=\"gotoRenewal(caratula)\">Renovar</a></li><li><a ng-click=\"cancelRenovate(caratula)\" ng-if=\"caratula.status != 12 && caratula.status != 15 && caratula.is_renewable == 1 && (acceso_adm_pol && caratula.status !=1 && caratula.status != 2)\">No renovar Colectividad</a></li><li class=\"dropdown-submenu\" ng-if=\"acceso_form\"><a>Descargar layouts</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li><a href=\"https://miurabox-public.s3.amazonaws.com/layouts/Colectividad_Flotilla.xls\">Flotillas</a></li></ul></li><li ng-if=\"acceso_canc_pol\"><a ng-click=\"cancelPolicy(caratula)\">Cancelar Colectividad</a></li><li ng-if=\"acceso_elim_pol\"><a ng-click=\"deletePolicy()\">Eliminar Colectividad</a></li><li class=\"dropdown-submenu\" ng-if=\"acceso_form\"><a>Ver carta</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li ng-if=\"cartas\" ng-repeat=\"carta in cartas track by $index\"><a ng-click=\"viewCarta(caratula.id, carta)\">{{carta.name}}</a></li><li><a ng-click=\"getPDF(caratula.id)\">RESÚMEN EN PDF</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"caratula.status == \'Vigente\' || caratula.status == 14\"><a>Compartir Pólizas de Colectividad a</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li><a ng-click=\"shareCertificatesApp(caratula.id)\">App</a></li><li><a ng-click=\"shareCertificatesEmail(caratula.id)\">Correo Electrónico</a></li><li><a ng-click=\"shareCertificatesAPPEmail(caratula.id)\">App y Correo Electrónico</a></li></ul></li></ul></div></div></div></div><div ng-if=\"show_caratula\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Carátula</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"getLog()\"><i class=\"fa fa-history\"></i> <span>Log</span></button> <button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"createRecordatorio(caratula,1)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\" ng-if=\"contratante.type_person == 1 || contratante.type_person == \'Física\'\"><b>Nombre</b>:</span> <span class=\"blue-color\" ng-if=\"contratante.type_person == 2 || contratante.type_person == \'Moral\'\"><b>Razón Social</b>:</span><div><span>{{ contratante.full_name }}{{ contratante.j_name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">RFC:</span><div><span>{{ contratante.rfc }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Grupo:</span><div><span>{{ contratante.group }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"contratante.subgrupo\"><span class=\"blue-color\">SubGrupo:</span><div><span>{{ contratante.subgrupo }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"contratante.subsubgrupo\"><span class=\"blue-color\">SubsubGrupo:</span><div><span>{{ contratante.subsubgrupo }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"contratante.grouping_level && campo_agrupacion\"><span class=\"blue-color\">Nivel de Agrupación:</span><div><span>{{ contratante.grouping_level }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"contratante.subgrouping && campo_agrupacion\"><span class=\"blue-color\">Sub Agrupación:</span><div><span>{{ contratante.subgrouping }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"contratante.subsubgrouping && campo_agrupacion\"><span class=\"blue-color\">Subsub Agrupación:</span><div><span>{{ contratante.subsubgrouping }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div style=\"word-wrap: break-word\"><span>{{ contratante.email }}</span></div><div style=\"word-wrap: break-word\" ng-repeat=\"correo in contratante.email_contractor\"><span>{{correo.correo}}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ contratante.phone_number }}</span></div></div><div class=\"col-xs-12\" ng-repeat=\"phone_number in contratante.phone_contractor\"><span ng-if=\"phone_number.phone_type == 1\" class=\"fa fa-home\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 2\" class=\"fa fa-building\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 3\" class=\"fa fa-mobile\" aria-hidden=\"true\"></span> <span>{{phone_number.phone | phonenumber}}</span></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Dirección</span><div><span ng-if=\"contratante.direccion.route\">{{ contratante.direccion.route }} {{ $scope.caratula.direccion.street_number }},&nbsp;</span> <span ng-if=\"contratante.direccion.street_number_int\">Int. {{ contratante.direccion.street_number_int }},</span> <span ng-if=\"contratante.direccion.sublocality\">{{ contratante.direccion.sublocality }},</span><br><span ng-if=\"contratante.direccion.administrative_area_level_2\">{{ contratante.direccion.administrative_area_level_2 }},</span> <span ng-if=\"contratante.direccion.administrative_area_level_1\">{{ contratante.direccion.administrative_area_level_1 }},</span> <span ng-if=\"contratante.direccion.postal_code\">CP. {{ contratante.direccion.postal_code }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"contratante.vip\"><span class=\"blue-color\">VIP</span></div></div><div class=\"col-xs-12 col-md-8 border-left\"><legend class=\"legend-title\" align=\"center\">Carátula</legend><div ng-if=\"caratula.poliza_number\" class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\"><b>Número de Carátula</b>:</span><div><span>{{ caratula.poliza_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Identificador:</span><div><span>{{ caratula.identifier }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ caratula.aseguradora.alias }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Clave de Agente:</span><div><span>{{ caratula.clave.clave }} <span ng-if=\"caratula.clave.name\">- {{ caratula.clave.name }}</span></span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ caratula.ramo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ caratula.subramo }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ caratula.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\' }} - {{ caratula.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" ng-class=\"{\'label-success\': caratula.status == 1 || caratula.status == 12, \'label-info\' : caratula.status == 10, \'label-primary\' : caratula.status == 14, \'label-warning\' : caratula.status == 2 || caratula.status == 4 || caratula.status == 11}\" style=\"margin-right: 10px\">{{ statusPolicy(caratula.status) }} <span ng-if=\"caratula.renewed_status == 2\">- En proceso de renovación</span></div></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"caratula.is_renewable\"><span class=\"blue-color\">Tipo:</span><div><span ng-if=\"caratula.type_policy == 1\">Abierta</span> <span ng-if=\"caratula.type_policy == 2\">Cerrada</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.reason_cancel\"><span class=\"blue-color\">Motivo de Cancelación:</span><div><span>{{ caratula.reason_cancel }}<span></span></span></div><span class=\"blue-color\" ng-if=\"caratula.date_cancel\">Fecha de Cancelación:</span><div ng-if=\"caratula.date_cancel\"><span>{{ caratula.date_cancel | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\" ng-if=\"caratula.is_renewable\"><span class=\"blue-color\">Tipo Renovable:</span><div><span ng-if=\"caratula.is_renewable == 1\">Renovable</span> <span ng-if=\"caratula.is_renewable == 2\">No renovable</span></div></div><div class=\"col-xs-12 col-sm-6 col-lg-4 form-group\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"caratula.f_currency == 1\">Pesos</span> <span ng-if=\"caratula.f_currency == 2\">Dólares</span> <span ng-if=\"caratula.f_currency == 3\">UDI</span> <span ng-if=\"caratula.f_currency == 4\">Euros</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"celula && campo_celula\"><span class=\"blue-color\">{{moduleName}}:</span><div><span>{{celula}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.grouping_level && campo_agrupacion\"><span class=\"blue-color\">Agrupación:</span><div><span>{{caratula.grouping_level.description}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.subgrouping_level && campo_agrupacion\"><span class=\"blue-color\">Subagrupación:</span><div><span>{{caratula.subgrouping_level.description}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"caratula.subsubgrouping_level && campo_agrupacion\"><span class=\"blue-color\">Subsubagrupación:</span><div><span>{{caratula.subsubgrouping_level.description}}</span></div></div><div class=\"col-xs-6 col-lg-4 form-group\"><span class=\"blue-color\">Creado Por:</span><div><span>{{ caratula.owner }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_lineanegocio\"><span class=\"blue-color\">Linea de Negocio:</span><div><span ng-if=\"caratula.business_line == 0\">Otro</span> <span ng-if=\"caratula.business_line == 1\">Comercial</span> <span ng-if=\"caratula.business_line == 2\">Personal</span> <span ng-if=\"caratula.business_line != 0 && caratula.business_line != 1 && caratula.business_line != 2\">&nbsp;</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\"><i class=\"fa fa-star yellow\"></i> Responsable:</span><div><span ng-if=\"caratula.responsable\">{{ caratula.responsable.first_name | uppercase}} {{ caratula.responsable.last_name | uppercase}}</span> <span ng-if=\"!caratula.responsable\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Ejecutivo de Cobranza:</span><div><span ng-if=\"caratula.collection_executive\">{{ caratula.collection_executive.first_name | uppercase}} {{ caratula.collection_executive.last_name | uppercase}}</span> <span ng-if=\"!caratula.collection_executive\">&nbsp;</span></div></div><div class=\"col-xs-6 col-lg-4 form-group\" ng-if=\"caratula.vendor && caratula.ref_policy.length == 0 && acceso_ver_ref\"><span class=\"blue-color\">Referenciador:</span><div><span>{{ caratula.vendor.first_name | uppercase}} {{ caratula.vendor.last_name | uppercase}}</span></div></div><div class=\"col-xs-6 col-lg-4 form-group\" ng-if=\"caratula.reason_rehabilitate\"><span class=\"blue-color\">Motivo de rehabilitación:</span><div><span>{{ caratula.reason_rehabilitate }}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"caratula.ref_policy.length > 0 && acceso_ver_ref\"><span class=\"blue-color\">Referenciador(es):</span><div ng-repeat=\"refs in caratula.ref_policy\"><span>{{ refs.ref_name | uppercase}}</span> <a ng-if=\"caratula.ref_policy && caratula.ref_policy.length >0\" class=\"btn btn-sm btn-white\" ng-click=\"cambiarReferenciador(refs,caratula)\" title=\"Cambiar Referenciador\"><i class=\"fa fa-rotate-right\" aria-hidden=\"true\"></i></a></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ caratula.observations }}</span></div></div><div class=\"col-xs-6 form-group pull-right\" ng-if=\"caratula.task_associated\"><button type=\"button\" class=\"btn btn-white btn-sm btn-secondary\" ng-click=\"openModal(caratula.task_associated_info)\">{{ order.isCollapsed ? \'Ocultar\' : \'Ver\' }} Tarea Origen</button><div ng-show=\"order.isCollapsed\"><span class=\"blue-color\">Tarea Origen</span><div><span>{{ caratula.task_associated_info.title }}</span></div></div></div><div class=\"col-xs-12 form-group\" ng-if=\"caratula.status ==15\"><span class=\"blue-color\">Razón de No Renovación:</span><div><span>{{ caratula.reason_ren }}</span></div></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showRecordatorios()\">{{caratula.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div></div></div></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"noshowRecordatorios()\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in caratula.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div ng-if=\"show_caratula && policy_history.length > 0\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Histórico renovaciones y cancelaciones</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th>Número de Póliza</th><th>Vigencia</th><th>Estatus</th><th>Fecha de Renovación</th><th>Renovado Por:</th></tr></thead><tbody><tr ng-repeat=\"policy in policy_history track by $index\" ng-click=\"goToPolicy(policy)\"><td ng-if=\"policy.poliza_number\">{{policy.poliza_number}}</td><td ng-if=\"!policy.poliza_number\">Sin número asignado</td><td>{{ policy.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}} - {{ policy.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{status(policy.status)}}</td><td>{{policy.created_at | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{policy.owner}}</td></tr></tbody></table></div></div></div></div></div><div ng-if=\"show_caratula\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"comments_data\" config=\"comments_config\" typemodel=\"28\" idmodel=\"caratula.id\" exportable=\"true\"></comments></div></div></div></div></div><div ng-if=\"show_certificado && show_tableCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Pólizas</h5></div><div class=\"ibox-content\"><div class=\"row animate\" ng-if=\"infoFlagCertificate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"allCertificates()\"><i class=\"fa fa-bars\" aria-hidden=\"true\"></i> Todas las Pólizas</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"showItemCertificate(4)\" ng-disabled=\"!showOt\"><i class=\"fa fa-list\" aria-hidden=\"true\"></i> Agregar Layout</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"createIndividualCertificate()\" ng-disabled=\"!showOt\"><i class=\"fa fa-ellipsis-h\" aria-hidden=\"true\"></i> Agregar Manual</button></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Buscar</label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-enter=\"search(cadena)\" ng-model=\"cadena\" placeholder=\"Pólizas, Marca, Serial\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"search(cadena)\">Buscar</button></div></div></div><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered table-hover\" ng-if=\"caratula.subramo == \'Automóviles\'\"><thead><th>No. Póliza</th><th>Contratante</th><th>Estatus</th><th>Marca</th><th>Modelo</th><th>Año</th><th>Versión</th><th>Serie</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"item in categorySelected.certificates | orderBy: \'id\' track by $index\" ng-click=\"selectCerficate(item)\"><td>{{ item.poliza_number }}</td><td>{{ item.contractor.full_name }}</td><td><div><div class=\"label\" ng-class=\"{\'label-success\': item.status == 1 || item.status == 12, \'label-info\' : item.status == 10, \'label-primary\' : item.status == 14, \'label-warning\' : item.status == 2 || item.status == 4 || item.status == 11}\" style=\"margin-right: 10px\">{{ statusPolicy(item.status) }} <span ng-if=\"item.is_renewable ==1 && item.renewed_status == 2 && item.status==13 && item.org_name ==\'ancora\'\">-En Proceso de Renovación</span></div></div></td><td>{{ item.automobiles_policy[0].brand }}</td><td>{{ item.automobiles_policy[0].model }}</td><td>{{ item.automobiles_policy[0].year }}</td><td>{{ item.automobiles_policy[0].version }}</td><td>{{ item.automobiles_policy[0].serial }}</td><td ng-click=\"$event.stopPropagation()\"><button ng-if=\"acceso_adm_pol\" class=\"btn btn-white\" ng-click=\"editCerficate(item)\" title=\"Editar Póliza de Colectividad\"><span class=\"fa fa-pencil\"></span></button> <button ng-if=\"acceso_elim_pol\" class=\"btn btn-white\" ng-click=\"deleteCertificate(item)\" title=\"Eliminar Póliza de Colectividad\"><span class=\"fa fa-trash\"></span></button> <button class=\"btn btn-white\" ng-if=\"item.recibos_poliza.length\" ng-click=\"deleteReceiptsCertificate(item)\" title=\"Existen recibos\"><span class=\"fa fa-list-alt\"></span></button> <button class=\"btn btn-white\" ng-click=\"showEndorsementsCertificate(item)\">Endosos({{ item.endosos }})</button> <button class=\"btn btn-white\" ng-click=\"showSinistersCertificate(item)\">Siniestros({{ item.siniestros }})</button> <a ng-if=\"item.conducto_de_pago != 1\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"{{get_conductos(item.conducto_de_pago)}}\"><i ng-if=\"item.conducto_de_pago == 2\" class=\"fa fa-dollar\" aria-hidden=\"true\"></i> <i ng-if=\"item.conducto_de_pago == 3\" class=\"fa fa-dollar\" aria-hidden=\"true\"></i> <i ng-if=\"item.conducto_de_pago == 4\" class=\"fa fa-credit-card-alt\" aria-hidden=\"true\"></i> <i ng-if=\"item.conducto_de_pago == 5\" class=\"fa fa-money\" aria-hidden=\"true\"></i> <i ng-if=\"item.conducto_de_pago == 6\" class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a></td></tr></tbody></table></div><div class=\"col-xs-12 text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination pagination_center justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{ page }}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\" ng-if=\"acceso_rep_pol\"><button class=\"btn btn-primary col-xs-12\" type=\"button\" ng-click=\"downloadExcel(categorySelected, 1)\" ng-if=\"!allExcel\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Generar Reporte</button> <button class=\"btn btn-primary col-xs-12\" type=\"button\" ng-click=\"downloadExcelAll(caratula, 1)\" ng-if=\"allExcel\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Generar Reporte</button></div></div><div class=\"row animate\" ng-if=\"endorsementFlagCertificate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12 form-group\"><table class=\"table table-hover table-bordered\"><thead><th>Tipo</th><th>Número de Endoso</th><th>Concepto</th><th>Descripción</th><th>Vigencia</th><th>Estatus</th><th>Historial</th></thead><tbody><tr ng-repeat=\"endorsement in endorsementsCertificate track by $index\" ng-click=\"gotoEndoso(endorsement)\"><td>{{ endorsement.endorsement_type }}</td><td ng-if=\"endorsement.number_endorsement\">{{ endorsement.number_endorsement }}</td><td ng-if=\"!endorsement.number_endorsement\">Sin número asigando</td><td>{{ concept(endorsement.concept) }} <span ng-if=\"concept(endorsement.concept) == \'OTRO\'\">:</span>{{endorsement.other_desc}}</td><td>{{ endorsement.observations }}</td><td>{{ endorsement.init_date | date: \'dd/MM/yyyy\': \'UTC\' }} - {{ endorsement.end_date | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td ng-if=\"endorsement.status == 1\">Pendiente</td><td ng-if=\"endorsement.status == 2\">Registrado</td><td ng-if=\"endorsement.status == 3\">Rechazado</td><td ng-if=\"endorsement.status == 5\">En trámite</td><td ng-if=\"endorsement.status == 4\">Cancelado</td><td ng-if=\"endorsement.migrated\">Sin historial</td><td ng-if=\"endorsement.status != 2\"></td><td ng-if=\"!endorsement.migrated && endorsement.status == 2\"><button class=\"btn btn-white\" ng-click=\"$event.stopPropagation(); showChange(endorsement)\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i> Ver Cambios</button></td></tr></tbody></table></div></div><div class=\"row animate\" ng-if=\"siniesterFlagCertificate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12 form-group\"><table class=\"table table-hover table-bordered\"><thead><th>Folio</th><th>Número de Siniestro</th><th>Fecha de Creación</th><th>Fecha de Emisión</th><th>Estatus</th><th>Tipo de Pago</th></thead><tbody><tr ng-repeat=\"sinister in sinistersCertificate track by $index\" ng-click=\"infoSinister(sinister)\"><td>{{ sinister.folio_compania }}</td><td>{{ sinister.numero_siniestro }}</td><td>{{ sinister.fecha_siniestro | date: \'dd/MM/yyyy h:mm:ss a\': \'UTC\' }}</td><td>{{ sinister.fecha_ingreso | date: \'dd/MM/yyyy h:mm:ss a\' : \'UTC\'}}</td><td ng-if=\"sinister.status == 1\">Pendiente</td><td ng-if=\"sinister.status == 2\">En trámite</td><td ng-if=\"sinister.status == 3\">Completado</td><td ng-if=\"sinister.status == 4\">Cancelado</td><td ng-if=\"sinister.status == 5\">Rechazado</td><td>{{ tipo_pago(sinister.accidente_sinister[0].tipo_pago)}}</td></tr></tbody></table></div></div></div></div></div><div ng-if=\"show_certificado && show_infoCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Información Póliza</h5></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><div class=\"col-xs-12 btn-group\"><button type=\"button\" class=\"col-xs-12 btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones de la Póliza</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"getLogCertificate(certificate)\"><i class=\"fa fa-history\" aria-hidden=\"true\"></i> Log</a></li><li ng-if=\"acceso_adm_rehabilitar && certificate.status == 11\"><a ng-click=\"reActivatePolicy(certificate.id, certificate.poliza_number)\">Rehabilitar Póliza</a></li><li ng-if=\"acceso_adm_rehabilitar && (certificate.status == 15 || certificate.status == \'No Renovada\')\"><a ng-click=\"renovarPolizaRehabilitate(certificate)\">Rehabilitar Póliza/OT para Renovar</a></li><li ng-if=\"caratula.status == 12 && certificate.is_renewable == 1 && certificate.renewed_status == 0 && !(certificate.status == 15 || certificate.status == \'15\' || certificate.status == \'No Renovada\')\"><a ng-click=\"renovarPoliza(certificate)\"><i class=\"fa fa-rotate-right\" aria-hidden=\"true\"></i> Renovar</a></li><li><a ng-click=\"assignPolicy(certificate.id,certificate)\"><i class=\"fa fa-share-alt\" aria-hidden=\"true\"></i> Compartir</a></li><li ng-if=\"acceso_adm_end\"><a ng-click=\"goToEndorsement(\'Endoso\', \'endorsement.endorsement\',certificate)\" ng-if=\"certificate.status >= 10\"><i class=\"fa fa-th-large\" aria-hidden=\"true\"></i> Crear endoso</a></li><li><a ng-click=\"cancelRenewal(certificate)\" ng-if=\"(certificate.status != 15 && certificate.status != 12)\"><i class=\"fa fa-sticky-note\" aria-hidden=\"true\"></i> No Renovar</a></li><li ng-if=\"acceso_adm_pol && (certificate.status ==10 || certificate.status ==13 || certificate.status ==11 || certificate.status ==15 || certificate.status ==14)\"><a ng-click=\"renovarConPolicy(certificate.id, certificate.poliza_number,certificate)\"><i class=\"fa fa-link\" aria-hidden=\"true\"></i> Renovar con</a></li><li ng-if=\"acceso_canc_pol\"><a ng-click=\"cancelPolicyC(certificate)\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</a></li><li><a ng-if=\"caratula.subramo.subramo_code == 1\" ui-sref=\"siniestros.create_vida({myInsurance: cert_info, contractor: cover_contractor})\"><i class=\"fa fa-folder\" aria-hidden=\"true\"></i> Crear siniestro</a></li><li class=\"dropdown-submenu\"><a ng-if=\"acceso_adm_sin && caratula.ramo.ramo_code == 2\"><i class=\"fa fa-folder\" aria-hidden=\"true\"></i> Crear siniestro</a><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"goToSiniester(\'\', 1)\">Por Titular</a></li><li class=\"dropdown-submenu\"><a>Por Dependiente</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-repeat=\"relationship in cert_info.accidents_policy[0].relationship_accident\"><a ng-click=\"goToSiniester(relationship, 2)\">{{relationship.first_name}} {{relationship.last_name}}</a></li></ul></li></ul></li><li ng-if=\"acceso_adm_sin\"><a ng-if=\"caratula.subramo.subramo_code == 9\" ui-sref=\"siniestros.create_autos({myInsurance: cert_info, contractor: cover_contractor})\"><i class=\"fa fa-folder\" aria-hidden=\"true\"></i> Crear siniestro</a></li></ul></div></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Póliza: {{ certificate.poliza_number }}</legend></div><div class=\"col-xs-12 col-sm-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\" ng-if=\"certificate.contractor.type_person == 1 || certificate.contractor.type_person == \'Física\'\"><b>Nombre</b>:</span> <span class=\"blue-color\" ng-if=\"certificate.contractor.type_person == 2 || certificate.contractor.type_person == \'Moral\'\"><b>Razón Social</b>:</span><div><span>{{ certificate.contractor.full_name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">RFC:</span><div><span>{{ certificate.contractor.rfc }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo Electrónico:</span><div style=\"word-wrap: break-word\"><span>{{ certificate.contractor.email }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ certificate.contractor.phone_number }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Dirección</span><div><span ng-if=\"certificate.contractor\">{{ certificate.address.route }} &nbsp;</span> <span ng-if=\"certificate.contractor\">Int. {{ certificate.address.street_number_int }},</span> <span ng-if=\"certificate.contractor\">{{ certificate.address.sublocality }},</span><br><span ng-if=\"certificate.contratcor\">{{ certificate.address.administrative_area_level_2 }},</span> <span ng-if=\"certificate.contractor\">{{ certificate.address.administrative_area_level_1 }},</span> <span ng-if=\"certificate.contractor\">CP. {{ certificate.address.postal_code }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"certificate.contractor.vip\"><span class=\"blue-color\">VIP</span></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"createRecordatorio(certificate,1)\"><i class=\"fa fa-clock-o\"></i></button><legend class=\"legend-title\" align=\"center\">Información</legend><div ng-if=\"certificate.automobiles_policy.length\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">No. Póliza:</span><div><span>{{ certificate.poliza_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Folio:</span><div><span>{{ certificate.folio }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ certificate.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ certificate.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Estatus:</span><div><div class=\"label\" ng-class=\"{\'label-success\': certificate.status == 1 || certificate.status == 12, \'label-info\' : certificate.status == 10, \'label-primary\' : certificate.status == 14, \'label-warning\' : certificate.status == 2 || certificate.status == 4 || certificate.status == 11}\" style=\"margin-right: 10px\">{{ statusPolicy(certificate.status) }} <span ng-if=\"(certificate.renewed_status == 2 && certificate_history.length > 0) || certificate.renewed_status == 2\">- En proceso de renovación</span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"certificate.reason_cancel\"><span class=\"blue-color\">Motivo de Cancelación:</span><div><span>{{ certificate.reason_cancel }}<span></span></span></div><span class=\"blue-color\" ng-if=\"certificate.date_cancel\">Fecha de Cancelación:</span><div ng-if=\"certificate.date_cancel\"><span>{{ certificate.date_cancel | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span ng-if=\"certificate.forma_de_pago == 1\">Mensual</span> <span ng-if=\"certificate.forma_de_pago == 2\">Bimestral</span> <span ng-if=\"certificate.forma_de_pago == 3\">Trimestral</span> <span ng-if=\"certificate.forma_de_pago == 5\">Contado</span> <span ng-if=\"certificate.forma_de_pago == 6\">Semestral</span> <span ng-if=\"certificate.forma_de_pago == 12\">Anual</span> <span ng-if=\"certificate.forma_de_pago == 7\">Semanal</span> <span ng-if=\"certificate.forma_de_pago == 14\">Catorcenal</span> <span ng-if=\"certificate.forma_de_pago == 15\">Quincenal</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Renovable:</span><div><span ng-if=\"certificate.is_renewable == 1\">Renovable</span> <span ng-if=\"certificate.is_renewable == 2\">No Renovable</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"certificate.f_currency == 1\">Pesos</span> <span ng-if=\"certificate.f_currency == 2\">Dólares</span> <span ng-if=\"certificate.f_currency == 3\">UDI</span> <span ng-if=\"certificate.f_currency == 4\">Euros</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Paquete:</span><div><span>{{ certificate.paquete.package_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_lineanegocio\"><span class=\"blue-color\">Linea de Negocio:</span><div><span ng-if=\"certificate.business_line == 0\">Otro</span> <span ng-if=\"certificate.business_line == 1\">Comercial</span> <span ng-if=\"certificate.business_line == 2\">Personal</span> <span ng-if=\"certificate.business_line != 0 && certificate.business_line != 1 && certificate.business_line != 2\">&nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Conducto de Pago:</span><div><span ng-if=\"certificate.conducto_de_pago == 1\">No domiciliada</span> <span ng-if=\"certificate.conducto_de_pago == 2\">Agente</span> <span ng-if=\"certificate.conducto_de_pago == 3\">CAC</span> <span ng-if=\"certificate.conducto_de_pago == 4\">CAT/Domiciliado</span> <span ng-if=\"certificate.conducto_de_pago == 5\">Nómina</span> <span ng-if=\"certificate.conducto_de_pago == 6\">CUT</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Sucursal:</span><div><span>{{ certificate.sucursal.sucursal_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_celula\"><span class=\"blue-color\">Célula:</span><div><span>{{celula}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Responsable:</span><div><span>{{ certificate.responsable.first_name | uppercase}} {{ certificate.responsable.last_name | uppercase}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Ejecutivo de Cobranza:</span><div><span>{{ certificate.collection_executive.first_name | uppercase}} {{ certificate.collection_executive.last_name | uppercase}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Tipo:</span><div><span ng-if=\"certificate.automobiles_policy[0].policy_type == 1\">Automóvil</span> <span ng-if=\"certificate.automobiles_policy[0].policy_type == 2\">Motocicleta</span> <span ng-if=\"certificate.automobiles_policy[0].policy_type == 3\">Tracto</span> <span ng-if=\"certificate.automobiles_policy[0].policy_type == 4\">Autobús</span> <span ng-if=\"certificate.automobiles_policy[0].policy_type == 5\">Pick up</span> <span ng-if=\"certificate.automobiles_policy[0].policy_type == 6\">Camiones hasta 1.5 ton</span> <span ng-if=\"certificate.automobiles_policy[0].policy_type == 7\">Chofer App</span> <span ng-if=\"certificate.automobiles_policy[0].policy_type == 8\">Remolque</span> <span ng-if=\"certificate.automobiles_policy[0].policy_type == 9\">Camiones + 1.5 ton</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Estado de circulación:</span><div><span>{{ getState(certificate.state_circulation) }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Procedencia:</span><div><span ng-if=\"certificate.automobiles_policy[0].procedencia == 0\">Sin especificar</span> <span ng-if=\"certificate.automobiles_policy[0].procedencia == 1\">Residencia</span> <span ng-if=\"certificate.automobiles_policy[0].procedencia == 2\">Turista</span> <span ng-if=\"certificate.automobiles_policy[0].procedencia == 3\">Legalizado</span> <span ng-if=\"certificate.automobiles_policy[0].procedencia == 4\">Fronterizo</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Conductor:</span><div><span>{{ certificate.automobiles_policy[0].driver }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Marca:</span><div><span>{{ certificate.automobiles_policy[0].brand }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Modelo:</span><div><span>{{ certificate.automobiles_policy[0].model }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Año:</span><div><span>{{ certificate.automobiles_policy[0].year }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Versión:</span><div><span>{{ certificate.automobiles_policy[0].version }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Serie:</span><div><span>{{ certificate.automobiles_policy[0].serial }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Motor:</span><div><span>{{ certificate.automobiles_policy[0].engine }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Color:</span><div><span>{{ certificate.automobiles_policy[0].color }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Matrícula:</span><div><span>{{ certificate.automobiles_policy[0].license_plates }} &nbsp;</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Uso:</span><div><span ng-if=\"certificate.automobiles_policy[0].usage == 1\">Particular</span> <span ng-if=\"certificate.automobiles_policy[0].usage == 2\">Carga Comercial</span> <span ng-if=\"certificate.automobiles_policy[0].usage == 3\">Servicio Público</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Servicio:</span><div><span>{{ certificate.automobiles_policy[0].service }}</span></div></div><div class=\"col-xs-12 form-group\"><h4>Adaptación</h4><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Monto Adaptación:</span><div><span>{{ certificate.automobiles_policy[0].mont_adjustment | currency}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Adaptaciones:</span><div><span>{{ certificate.automobiles_policy[0].adjustment }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Monto Equipamiento:</span><div><span>{{ certificate.automobiles_policy[0].mont_special_team | currency}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Equipamiento:</span><div><span>{{ certificate.automobiles_policy[0].special_team }}</span></div></div></div><div class=\"col-xs-12 form-group\"><h4>Beneficiario Preferente</h4><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Beneficiario:</span><div><span>{{ certificate.automobiles_policy[0].beneficiary_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Beneficiario Dirección:</span><div><span>{{ certificate.automobiles_policy[0].beneficiary_address }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Beneficiario RFC:</span><div><span>{{ certificate.automobiles_policy[0].beneficiary_rfc }}</span></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ certificate.observations }} &nbsp;</span></div></div><div class=\"col-xs-6 col-lg-4 form-group\" ng-if=\"certificate.reason_rehabilitate\"><span class=\"blue-color\">Motivo de rehabilitación:</span><div><span>{{ certificate.reason_rehabilitate }}</span></div></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showRecordatoriosC()\">{{certificate.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Neta:</span><div><span>{{ certificate.p_neta | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Descuento:</span><div><span>{{ certificate.descuento | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">RPF:</span><div><span>{{ certificate.rpf | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Derecho:</span><div><span>{{ certificate.derecho | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">IVA:</span><div><span>{{ certificate.iva | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Prima Total:</span><div><span>{{ certificate.p_total | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"permiso_comisiones\"><span class=\"blue-color\">Comisión:</span><div><span>{{ certificate.comision | currency }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"permiso_comisiones\"><span class=\"blue-color\">% Comisión <span ng-if=\"certificate.comision_derecho_percent!=\'0.00\' || certificate.comision_rpf_percent!=\'0.00\'\">Prima Neta</span>:</span><div>{{ certificate.comision_percent }}%</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"permiso_comisiones && certificate.comision_derecho_percent!=\'0.00\'\"><span class=\"blue-color\">% Comisión Derecho:</span><div>{{ certificate.comision_derecho_percent }}%</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"permiso_comisiones && certificate.comision_rpf_percent!=\'0.00\'\"><span class=\"blue-color\">% Comisión RPF:</span><div>{{ certificate.comision_rpf_percent }}%</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Conducto de Pago:</span><div><span>{{ get_conductos(certificate.conducto_de_pago) }}</span></div></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"recordatoriosFlagC\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"noshowRecordatorios()\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in certificate.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div ng-if=\"caratula.recibos_poliza\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Recibos</legend></div><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered table-hover\" ng-if=\"!show_binnacle_receipt\"><thead><tr><th>Serie</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>Iva</th><th>Prima Total</th><th ng-if=\"permiso_comisiones\">Comisión</th><th width=\"5%\" ng-if=\"permiso_comisiones\">Comisión Conciliada</th><th>Vigencia</th><th>Vencimiento</th><th>Estatus</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"recibo in certificate.recibos_poliza\" ng-if=\"recibo.receipt_type == 1 && recibo.status != \'Desactivado\'\" ng-click=\"changeStatusModal(recibo, certificate.contractor, certificate)\"><td>{{recibo.recibo_numero}}</td><td>{{recibo.prima_neta | currency}}</td><td>{{recibo.rpf | currency}}</td><td>{{recibo.derecho | currency}}</td><td>{{recibo.iva | currency}}</td><td>{{recibo.prima_total | currency}}</td><td ng-if=\"permiso_comisiones\">{{recibo.comision | currency}}</td><td width=\"5%\" ng-if=\"permiso_comisiones\">{{recibo.comision_conciliada | currency}}</td><td>{{recibo.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}} - {{recibo.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{recibo.vencimiento | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': recibo.status == \'Pendiente de pago\', \'label-info\' : recibo.status == \'Conciliado\', \'label-primary\' : recibo.status == \'Pagado\' || recibo.status == \'Prorrogado\', \'label-warning\' : recibo.status == \'Cancelado\' || recibo.status == \'Precancelado\'}\">{{ recibo.status }}</div></td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-sm btn-white\" ng-click=\"editReceipt(recibo,\'\',certificate)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-if=\"acceso_cor && !recibo.track_email\" ng-click=\"addEmailsConfirmPolicy(recibo, contratante)\" ng-disabled=\"!(recibo.status == \'Pendiente de pago\')\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-if=\"acceso_cor && recibo.track_email\" ng-click=\"addEmailsConfirmPolicy(recibo, contratante)\" ng-disabled=\"recibo.status != \'Pendiente de pago\'\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-if=\"!recibo.track_bitacora\" ng-click=\"showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"recibo.track_bitacora\" ng-click=\"showBinnacleReceipt(recibo)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a ng-if=\"(recibo.status == 4 || recibo.status ==\'Pendiente de pago\') && acceso_elim_rec\" ng-click=\"$event.stopPropagation(); deleteReceipts(recibo,$index,certificate)\" class=\"btn btn-white btn-sm\" title=\"Eliminar recibo\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-info btn-sm\" title=\"Crear Recordatorio\" ng-click=\"$event.stopPropagation();createRecordatorio(recibo,4)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-default sm\" style=\"color: red\" ng-click=\"$event.stopPropagation()\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\" ng-if=\"recibo.endosotramite\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\"></i></a> <a ng-if=\"certificate.conducto_de_pago != 1\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"{{get_conductos(certificate.conducto_de_pago)}}\"><i ng-if=\"certificate.conducto_de_pago == 2\" class=\"fa fa-dollar\" aria-hidden=\"true\"></i> <i ng-if=\"certificate.conducto_de_pago == 3\" class=\"fa fa-dollar\" aria-hidden=\"true\"></i> <i ng-if=\"certificate.conducto_de_pago == 4\" class=\"fa fa-credit-card-alt\" aria-hidden=\"true\"></i> <i ng-if=\"certificate.conducto_de_pago == 5\" class=\"fa fa-money\" aria-hidden=\"true\"></i> <i ng-if=\"certificate.conducto_de_pago == 6\" class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a></td></tr><tr><td><b>Totales</b></td><td><b>{{ total_prima_certificate | currency }}</b></td><td><b>{{ total_rpf_certificate | currency }}</b></td><td><b>{{ total_derecho_certificate | currency }}</b></td><td><b>{{ total_iva_certificate | currency }}</b></td><td><b>{{ total_total_certificate | currency }}</b></td><td ng-if=\"permiso_comisiones\"><b>{{ total_comision_certificate | currency }}</b></td><td></td><td></td><td></td></tr></tbody></table><div class=\"col-xs-12\" ng-if=\"!show_binnacle_receipt\"><div class=\"identificador-dash-email\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se envio un correo.</span><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div><div class=\"row animate\" ng-if=\"show_binnacle_receipt\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><a class=\"col-xs-12 btn btn-info pull-right\" ng-click=\"returnToReceipts()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</a></div><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Bitácora de recibos</h3><hr></div><div><div class=\"col-xs-12 form-group\"><comments datasource=\"comments_data_receipt\" typemodel=\"4\" config=\"comments_config\" idmodel=\"receipt_id\" receiptmodel=\"receiptmodel\" exportable=\"true\"></comments></div></div></div></div></div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Histórico</legend><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th>Número de Póliza</th><th>Vigencia</th><th>Estatus</th><th>Fecha de Renovación</th><th>Renovado Por:</th></tr></thead><tbody><tr ng-repeat=\"policy in certificate_history track by $index\" ng-click=\"goToPolicy(policy)\"><td ng-if=\"policy.poliza_number\">{{policy.poliza_number}}</td><td ng-if=\"!policy.poliza_number\">Sin número asignado</td><td>{{ policy.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}} - {{ policy.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{status(policy.status)}}</td><td>{{policy.created_at | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{policy.owner}}</td></tr></tbody></table></div><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Paquete: {{ certificate.paquete.package_name }}</legend><div><table class=\"table table-bordered table-hover\"><thead><th>Cobertura</th><th>Suma Asegurada</th><th>Deducible</th></thead><tbody><tr ng-repeat=\"coverage in certificate.paquete.coverage_package\"><td>{{ coverage.coverage_name }}</td><td>{{ coverage.sums_coverage[0].sum_insured }}</td><td>{{ coverage.deductible_coverage[0].deductible }}</td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12\"><div class=\"col-xs-12 form-group\" ng-if=\"permiso_administrar_adjuntos\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(certificate)\">Guardar Archivos</button></div></div><div class=\"col-xs-12 form-group\" ng-if=\"certificate.files\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th ng-if=\"permiso_archivos && permiso_administrar_adjuntos\" width=\"200px\"></th></tr></thead><tbody><tr ng-repeat=\"file in certificate.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_input\" class=\"form-control display-none\" ng-if=\"permiso_administrar_adjuntos\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"saveFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,certificate.files,certificate)\" ng-if=\"permiso_administrar_adjuntos\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"permiso_administrar_adjuntos\">Renombrar</button> <span class=\"btn btn-success display-none\" ng-if=\"permiso_administrar_adjuntos\">Guardar</span></td><td ng-if=\"permiso_archivos && permiso_administrar_adjuntos\"><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> * Archivo sensible</td></tr></tbody></table></div></div></div></div></div></div></div></div><div ng-if=\"show_certificado && show_editCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5 ng-if=\"isEdit\">Editar Póliza</h5><h5 ng-if=\"!isEdit\">Agregar Póliza</h5></div><div class=\"ibox-content\" ng-if=\"show_contractor==false\"><div class=\"row animate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"return()\"><i class=\"fa fa-reply\"></i> Regresar</button></div><div class=\"col-xs-12\"><hr></div><div ng-if=\"caratula.subramo == \'Automóviles\'\"><form name=\"form\" novalidate=\"\" onkeypress=\"return event.keyCode != 13;\"><div><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-if=\"!loaderPdf\"><label class=\"form-label\">Selecciona un archivo PDF:</label><div class=\"alert alert-info\" role=\"alert\"><strong>Autos:</strong> Chubb, Quálitas, GNP, AXA, HDI, Primero Seguros, ANA, Momento, Afirme, Zurich.<br></div><input accept=\"application/pdf\" class=\"form-control\" type=\"file\" id=\"file-selector\" name=\"file\" onchange=\"angular.element(this).scope().fileNameChanged(this); angular.element(this).scope().showFile(this)\"></div></div><div class=\"row\"></div><div class=\"row\" ng-if=\"!loaderPdf && fileSelected_pf\"><div class=\"col-xs-12 text-right\"><button type=\"button\" class=\"btn btn-primary btn-pdf\" ng-click=\"capturarPoliza(1)\"><i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i> &nbsp;Leer datos para la póliza</button></div></div><hr><div class=\"row\"><div class=\"col-xs-12 form-group container-loader\" ng-if=\"loaderPdf\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div></div></div></form><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Póliza: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.poliza_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Folio:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.folio\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Inicio: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.start_of_validity\" value=\"{{newCertificate.start_of_validity}}\" ng-change=\"checkDate(newCertificate.start_of_validity)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Fin: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.end_of_validity\" value=\"{{newCertificate.end_of_validity}}\" ng-change=\"checkEndDate(newCertificate.end_of_validity)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante: <span class=\"color-red\">*</span></label><div class=\"input-group\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contratante\" change=\"matchesContractors(order.contratante);order.save_info_tab()\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"contratanteCreator();order.save_info_tab()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in addresses track by address.url\" ng-change=\"changeAddress(addressSelected);order.save_info_tab()\" ng-model=\"newCertificate.address\" ng-disabled=\"!order.contratante\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo Electrónico: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"order.contratante.value.email\" ng-disabled=\"!order.contratante\" ng-change=\"order.save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Teléfono:</label><phonenumber-directive model=\"order.contratante.value.phone_number\" class=\"ng-isolate-scope\"><input class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" type=\"tel\" maxlength=\"25\" aria-invalid=\"false\" ng-model=\"inputValue\" ng-change=\"order.save_info_tab()\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Frecuencia de Pago: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"item.label for item in frequencies\" ng-change=\"changePayment(newCertificate.forma_de_pago);order.save_info_tab()\" ng-model=\"newCertificate.forma_de_pago\" ng-disabled=\"isEdit\"><option value=\"\">Seleccione una frecuencia</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Renovable: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"renewal.label for renewal in renewals\" ng-change=\"changeRenewal(newCertificate.is_renewable)\" ng-model=\"newCertificate.is_renewable\" ng-blur=\"order.save_info_tab();order.save_info_tab()\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Moneda: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"currency.value as currency.label for currency in currencys\" ng-change=\"changeCurrency(newCertificate.f_currency)\" ng-model=\"newCertificate.f_currency\"><option value=\"\">Seleccione una moneda</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Paquete: <span class=\"color-red\">*</span><select class=\"form-control\" ng-options=\"pack.package_name for pack in packages\" ng-change=\"changePackage(newCertificate.paquete)\" ng-model=\"newCertificate.paquete\"><option value=\"\" disabled=\"\">Seleccion un paquete</option></select></label></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Conducto de pago <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"conducto_de_pago.value as conducto_de_pago.label for conducto_de_pago in conducto_de_pagos\" ng-model=\"newCertificate.conducto_de_pago\" ng-change=\"changeConducto()\"><option value=\"\">Seleccione un conducto</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sucursal:</label><select class=\"form-control\" ng-options=\"sucursal.sucursal_name for sucursal in sucursales\" ng-change=\"changeType(newCertificate.sucursal)\" ng-model=\"newCertificate.sucursal\"><option value=\"\">Seleccione una sucursal</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.name for type in types\" ng-change=\"changeType(newCertificate.datos.policy_type)\" ng-model=\"newCertificate.datos.policy_type\"><option value=\"\">Seleccione un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Procedencia:</label><select class=\"form-control\" ng-options=\"origin.label for origin in procedencias\" ng-model=\"newCertificate.datos.procedencia\" value=\"{{origin.value}}\"><option value=\"\">Seleccione una procedencia</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Conductor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.driver\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Marca: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.brand\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Modelo: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.model\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Año: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificate.datos.year\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Versión: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.version\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Serie: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.serial\" ng-blur=\"order.save_info_tab();checkNumSerie()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Motor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.engine\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Color:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.color\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Matrícula:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.license_plates\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Uso: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"uso.label for uso in usages\" ng-model=\"newCertificate.datos.usage\" value=\"{{uso.value}}\"><option value=\"\">Seleccione un uso</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Servicio: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.service\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Estado de Circulación</label><select class=\"form-control\" data-ng-options=\"estado.state for estado in statesArray track by estado.state\" name=\"state\" ng-model=\"newCertificate.state_circulation\" required=\"\"><option value=\"\">Selecciona un estado</option></select></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Adaptaciones</legend><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\"><label>Monto de adaptación</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.mont_adjustment\" ng-change=\"save_info_tab()\" format-currency=\"\"></div><div class=\"form-group\"><label>Adaptación</label> <textarea class=\"form-control\" ng-model=\"newCertificate.datos.adjustment\" ng-change=\"save_info_tab()\"></textarea></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\"><label>Monto de equipamiento</label> <input type=\"text\" class=\"form-control\" ng-model=\"newCertificate.datos.mont_special_team\" ng-change=\"save_info_tab()\" format-currency=\"\"></div><div class=\"form-group\"><label>Equipo especial</label> <textarea class=\"form-control\" ng-model=\"newCertificate.datos.special_team\" ng-change=\"save_info_tab()\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Beneficiario Preferente</legend><div class=\"col-xs-12 col-md-6 form-group\"><label>Nombre beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"newCertificate.datos.beneficiary_name\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Dirección beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"newCertificate.datos.beneficiary_address\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>RFC beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"newCertificate.datos.beneficiary_rfc\" maxlength=\"13\"></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Observaciones:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.observations\"></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 form-group\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-colectivo></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"!isEdit\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"validateCertificate()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Póliza</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"isEdit\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"validateCertificate()\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i> Actualizar Póliza</button></div></div></div></div><div class=\"col-xs-12 animate z-index-9000\" ng-if=\"show_contractor\"><ng-include src=\"\'app/contratantes/contratantes.add.html\'\" ng-controller=\"ContratantesCtrl as vm\"></ng-include></div></div><div ng-if=\"show_certificado && show_massCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Agregar Certificados por Layout</h5></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\"></i> Regresar</button></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" ng-if=\"caratula.subramo == \'Vida\'\">Vida</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo == \'Gastos Médicos\'\">Gastos Médicos</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo == \'Automóviles\'\">Automóviles</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo == \'Incendio\'\">Incendio</legend><legend class=\"legend-title\" ng-if=\"caratula.subramo == \'Diversos\'\">Diversos</legend></div><div class=\"col-xs-12 col-sm-6\"><div class=\"col-xs-12 form-group\"><label>Contratante: <span class=\"color-red\">*</span></label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.searchContratante\" change=\"matchesContractors(order.searchContratante)\"></autocomplete></div><div class=\"col-xs-12 form-group\" ng-if=\"order.searchContratante\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Contratante</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ contractorLayout.id }}</span><br><small>Nombre: <span>{{ contractorLayout.name }}</span></small><br><small>ID para Layout Tipo: <span class=\"font-weight-bold\">{{ contractorLayout.type }}</span></small><br><small ng-if=\"contractorLayout.type == 1\">Tipo Contratante: <span>Física</span></small> <small ng-if=\"contractorLayout.type == 2\">Tipo Contratante: <span>Moral</span></small></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\" ng-if=\"order.searchContratante\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Direcciones</th></tr></thead><tbody><tr ng-repeat=\"item in contractorLayout.address\"><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br><small>Nombre: <span>{{ item.administrative_area_level_2 }}, {{ item.administrative_area_level_1 }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><label>Paquete:</label><select class=\"form-control\" data-ng-options=\"package.package_name for package in paquetesLayout | orderBy:\'package_name\' track by package.url\" ng-change=\"changePackageLay(paqueteLay)\" name=\"paquete\" ng-model=\"paqueteLay\"><option value=\"\">Selecciona un paquete</option></select><span ng-if=\"!paquetesLayout.length\">No hay paquetes en este subramo</span></div><div class=\"col-xs-12 form-group\" ng-if=\"paquetesLayout\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Paquete</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ paqueteLay.id }}</span><br><small>Nombre: <span>{{ paqueteLay.package_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><label>Sucursal:</label><select class=\"form-control\" data-ng-options=\"sucursal as sucursal.sucursal_name for sucursal in sucursalesLay\" ng-change=\"changeSucursalLay(sucursalLay)\" name=\"sucursals\" ng-model=\"sucursalLay\"><option value=\"\">Selecciona un sucursal</option></select><span ng-if=\"!sucursalesLay.length\">No hay sucursales</span></div><div class=\"col-xs-12 form-group\" ng-if=\"sucursalLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Sucursal</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ sucursalLay.id }}</span><br><small>Nombre: <span>{{ sucursalLay.sucursal_name }}</span></small></td></tr></tbody></table></div></div></div><div class=\"row\" ng-if=\"!showTableCertificates\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\"></label></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando pólizas...</span></div></div></div><div class=\"row\" ng-if=\"showTableCertificates\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">{{ caratula.subramo.subramo_name }}</legend></div><div class=\"col-xs-1 form-group\"><select class=\"form-control\" ng-options=\"renewal.value for renewal in optionsViews\" ng-change=\"selectViews(optionViews)\" ng-model=\"optionViews\"></select></div><div><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\" ng-if=\"caratula.subramo == \'Automóviles\'\"><thead><tr><td>No Carátula</td><td>Folio</td><td>No. Póliza</td><td>Contratante</td><td>Tipo Contratante</td><td>Dirección</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Frecuencia Pago</td><td>Renovable</td><td>Moneda</td><td>Paquete</td><td>Sucursal</td><td>Tipo</td><td>Procedencia</td><td>Conductor</td><td>Marca</td><td>Modelo</td><td>Año</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Uso</td><td>Servicio</td><td>Adaptaciones</td><td>Monto Adaptaciones</td><td>Equipamiento</td><td>Monto Equipamiento</td><td>Beneficiario</td><td>Beneficiario Dirección</td><td>Beneficiario RFC</td><td>Prima Neta</td><td>Descuento</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>% Comisión</td><td>No. Recibo</td><td>Prima Recibo</td><td>RPF Recibo</td><td>Derecho Recibo</td><td>IVA Recibo</td><td>Total Recibo</td><td>Comisión Recibo</td><td>Inicio Recibo</td><td>Fin Recibo</td><td>Vencimiento Recibo</td><td>Conducto de Pago</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.NO_CARATULA }}</td><td>{{ item.FOLIO }}</td><td>{{ item.NO_POLIZA }}</td><td>{{ item.CONTRATANTE }}</td><td>{{ item.TIPO_CONTRATANTE }}</td><td>{{ item.DIRECCION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.FRECUENCIA_PAGO }}</td><td>{{ item.RENOVABLE }}</td><td>{{ item.MONEDA }}</td><td>{{ item.PAQUETE }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.TIPO }}</td><td>{{ item.PROCEDENCIA }}</td><td>{{ item.CONDUCTOR }}</td><td>{{ item.MARCA }}</td><td>{{ item.MODELO }}</td><td>{{ item.ANIO }}</td><td>{{ item.VERSION }}</td><td>{{ item.SERIE }}</td><td>{{ item.MOTOR }}</td><td>{{ item.COLOR }}</td><td>{{ item.MATRICULA }}</td><td>{{ item.USO }}</td><td>{{ item.SERVICIO }}</td><td>{{ item.ADAPTACIONES }}</td><td>{{ item.MONTO_ADAPTACIONES }}</td><td>{{ item.EQUIPAMIENTO }}</td><td>{{ item.MONTO_EQUIPAMIENTO }}</td><td>{{ item.BENEFICIARIO_PREFERENTE}}</td><td>{{ item.BENEFICIARIO_RFC}}</td><td>{{ item.BENEFICIARIO_DIRECCION}}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.DESCUENTO }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.PORCENTAJE_COMISION }}</td><td>{{ item.NO_RECIBO }}</td><td>{{ item.PRIMA_RECIBO }}</td><td>{{ item.RPF_RECIBO }}</td><td>{{ item.DERECHO_RECIBO }}</td><td>{{ item.IVA_RECIBO }}</td><td>{{ item.TOTAL_RECIBO }}</td><td>{{ item.COMISION_RECIBO }}</td><td>{{ item.INICIO_RECIBO }}</td><td>{{ item.FIN_RECIBO }}</td><td>{{ item.VENCIMIENTO_RECIBO }}</td><td>{{ item.CONDUCTO_DE_PAGO }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveCertificates()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Pólizas</button></div></div></div></div></div><div ng-if=\"show_certificado && show_receiptCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Creación de Recibos en Certificados</h5></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\"></i> Regresar</button></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Total de Certificados:</span><div><span>{{ categorySelected.config.count }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{ statusPayment(caratula.forma_de_pago) }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ caratula.subramo.subramo_name }}</span></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 form-group\" ng-if=\"caratula.recibos_poliza.length == 0\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"2\"></receipts-colectivo></div><div class=\"col-xs-12 form-group\" ng-if=\"caratula.recibos_poliza.length == 0\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Se crearán los recibos a nivel carátula, cuando estos ya existan y se agreguen o se quiten certificados, estos se actualizarán automaticamente.</div></div><div class=\"col-xs-12 form-group\" ng-if=\"caratula.recibos_poliza.length > 0\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Los recibos a nivel carátula ya han sido creados, si necesitas modificarlos por favor edita la carátula.</div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveReceiptsCertificates()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear Recibos</button></div></div></div></div></div><div ng-if=\"show_certificado && show_showReceiptCertificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Recibos en Certificados</h5></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showItemCertificate(1)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Periodo:</label><select class=\"form-control\" ng-options=\"period.label for period in periods track by period.value\" ng-change=\"changePeriod(periodSelected)\" ng-model=\"periodSelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Vigencia del Periodo:</span><div><span>{{ receiptsPeriods[0].fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ receiptsPeriods[0].fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><span class=\"blue-color\">Total Certificados:</span><div><span>{{ receiptsPeriods.length }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Estatus:</label><select class=\"form-control\" ng-options=\"status.label for status in statusReceiptCertificates track by status.value\" ng-change=\"changeStatusReceipt(statusReceiptCertificateSelected)\" ng-model=\"statusReceiptCertificateSelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-9 form-group\"><label>Buscar</label><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-enter=\"searchReceipt(cadena)\" ng-model=\"cadena\" placeholder=\"Certificado, Nombre Titular, Beneficiarios, Dependientes, Marca, Serial\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"searchReceipt(cadena)\">Buscar</button></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t pull-right\" ng-if=\"!desSelected\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"allReciptsSelected(true)\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Seleccionar Todos</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t pull-right\" ng-if=\"desSelected\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"allReciptsSelected(false)\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Deseleccionar Todos</button></div><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Serie</th><th>No. Certificado</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>IVA</th><th>Prima Total</th><th>Comisión</th><th>Vigencia</th><th>Estatus</th><th>Selección</th></tr></thead><tbody><tr ng-repeat=\"receipt in receiptsPeriods track by receipt.id\"><td>{{ receipt.recibo_numero }}</td><td>{{ receipt.poliza }}</td><td>{{ receipt.prima_neta }}</td><td>{{ receipt.rpf }}</td><td>{{ receipt.derecho }}</td><td>{{ receipt.iva }}</td><td>{{ receipt.prima_total }}</td><td>{{ receipt.comision }}</td><td>{{ receipt.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\' }} - {{ receipt.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\' }}</td><td><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8}\">{{ statusReceipt(receipt.status) }}</div></td><td><input type=\"checkbox\" name=\"\" ng-model=\"receipt.selected\" ng-click=\"sumReceipts(receipt)\" ng-disabled=\"receipt.status == 1\"></td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-2 form-group pull-right\"><small>Total Seleccionado</small><br><label>{{ totalReceiptSelected | currency }}</label></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group pull-right\"><small>Total Pendiente</small><br><label>{{ totalReceiptPending | currency }}</label></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group pull-right\"><small>Total Pagado</small><br><label>{{ totalReceiptPay | currency }}</label></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group pull-right\"><small>Total Periodo</small><br><label>{{ totalReceiptPeriod | currency }}</label></div></div><div class=\"row\"><div class=\"col-xs-12 form-group col-sm-6 col-md-3 form-group m-t pull-right\"><button class=\"btn btn-success col-xs-12\" ng-click=\"payReceipts()\"><i class=\"fa fa-dollar\" aria-hidden=\"true\"></i> Pagar Recibos Seleccionados</button></div></div></div></div></div><div ng-if=\"show_renewal_certificate\"><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5 ng-if=\"isRenewal\">Renovación de Póliza de Flotilla</h5></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12 text-align-center\"><div class=\"panel panel-info\"><div class=\"panel-heading\"><strong>Carátula de la colectividad que será asociada a la renovación</strong></div><div class=\"panel-body\"><p><strong>Carátula Número de Póliza:</strong> {{ caratula.nueva.poliza_number }}</p><p><strong>Vigencia:</strong> {{ caratula.nueva.start_of_validity | date:\'dd/MM/yyyy\':\'UTC\' }} {{ caratula.nueva.end_of_validity | date:\'dd/MM/yyyy\':\'UTC\' }}</p></div></div></div><div ng-if=\"caratula.subramo == \'Automóviles\'\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Poliza: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.poliza_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Folio:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.folio\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Inicio: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.start_of_validity\" value=\"{{newCertificate.start_of_validity}}\" ng-change=\"checkDate(newCertificate.start_of_validity)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Fin: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificate.end_of_validity\" value=\"{{newCertificate.end_of_validity}}\" ng-change=\"checkEndDate(newCertificate.end_of_validity)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante: <span class=\"color-red\">*</span></label><div class=\"input-group\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contratante\" change=\"matchesContractors(order.contratante);order.save_info_tab()\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"contratanteCreator();order.save_info_tab()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in addresses track by address.url\" ng-change=\"changeAddress(addressSelected);order.save_info_tab()\" ng-model=\"newCertificate.address\" ng-disabled=\"!order.contratante\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo Electrónico: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"order.contratante.value.email\" ng-disabled=\"!order.contratante\" ng-change=\"order.save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Teléfono:</label><phonenumber-directive model=\"order.contratante.value.phone_number\" class=\"ng-isolate-scope\"><input class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" type=\"tel\" maxlength=\"25\" aria-invalid=\"false\" ng-model=\"inputValue\" ng-change=\"order.save_info_tab()\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Frecuencia de Pago: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"item.label for item in frequencies\" ng-change=\"changePayment(newCertificate.forma_de_pago);order.save_info_tab()\" ng-model=\"newCertificate.forma_de_pago\" ng-disabled=\"isEdit\"><option value=\"\">Seleccione una frecuencia</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Renovable: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"renewal.label for renewal in renewals\" ng-change=\"changeRenewal(newCertificate.is_renewable)\" ng-model=\"newCertificate.is_renewable\" ng-blur=\"order.save_info_tab();order.save_info_tab()\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Moneda: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"currency.value as currency.label for currency in currencys\" ng-change=\"changeCurrency(newCertificate.f_currency)\" ng-model=\"newCertificate.f_currency\"><option value=\"\">Seleccione una moneda</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Paquete: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"pack.package_name for pack in packages\" ng-change=\"changePackage(newCertificate.paquete)\" ng-model=\"newCertificate.paquete\"><option value=\"\" disabled=\"\">Seleccion un paquete</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Conducto de pago <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"conducto_de_pago.value as conducto_de_pago.label for conducto_de_pago in conducto_de_pagos\" ng-model=\"newCertificate.conducto_de_pago\" ng-change=\"changeConducto()\"><option value=\"\">Seleccione un conducto</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sucursal:</label><select class=\"form-control\" ng-options=\"sucursal.sucursal_name for sucursal in sucursales\" ng-change=\"changeType(newCertificate.sucursal)\" ng-model=\"newCertificate.sucursal\"><option value=\"\">Seleccione una sucursal</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.name for type in types\" ng-change=\"changeType(newCertificate.datos.policy_type)\" ng-model=\"newCertificate.datos.policy_type\"><option value=\"\">Seleccione un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Procedencia:</label><select class=\"form-control\" ng-options=\"origin.label for origin in procedencias\" ng-model=\"newCertificate.datos.procedencia\" value=\"{{origin.value}}\"><option value=\"\">Seleccione una procedencia</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Conductor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.driver\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Marca: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.brand\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Modelo: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.model\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Año: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificate.datos.year\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Versión: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.version\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Serie: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.serial\" ng-blur=\"order.save_info_tab();checkNumSerie()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Motor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.engine\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Color:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.color\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Matrícula:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.license_plates\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Uso: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"uso.label for uso in usages\" ng-model=\"newCertificate.datos.usage\" value=\"{{uso.value}}\"><option value=\"\">Seleccione un uso</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Servicio: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.service\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Estado de Circulación</label><select class=\"form-control\" data-ng-options=\"estado.state for estado in statesArray track by estado.state\" name=\"state\" ng-model=\"newCertificate.state_circulation\" required=\"\"><option value=\"\">Selecciona un estado</option></select></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Adaptaciones</legend><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\"><label>Monto de adaptación</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.datos.mont_adjustment\" ng-change=\"save_info_tab()\" format-currency=\"\"></div><div class=\"form-group\"><label>Adaptación</label> <textarea class=\"form-control\" ng-model=\"newCertificate.datos.adjustment\" ng-change=\"save_info_tab()\"></textarea></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\"><label>Monto de equipamiento</label> <input type=\"text\" class=\"form-control\" ng-model=\"newCertificate.datos.mont_special_team\" ng-change=\"save_info_tab()\" format-currency=\"\"></div><div class=\"form-group\"><label>Equipo especial</label> <textarea class=\"form-control\" ng-model=\"newCertificate.datos.special_team\" ng-change=\"save_info_tab()\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Beneficiario Preferente</legend><div class=\"col-xs-12 col-md-6 form-group\"><label>Nombre beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"newCertificate.datos.beneficiary_name\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>Dirección beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"newCertificate.datos.beneficiary_address\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label>RFC beneficiario</label> <input type=\"text\" class=\"form-control\" ng-model=\"newCertificate.datos.beneficiary_rfc\" maxlength=\"13\"></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Observaciones:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificate.observations\"></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 form-group\"><receipts-colectivo form=\"directiveReceipts\" tosave=\"dataToSave\" type=\"1\"></receipts-colectivo></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-6 pull-right form-group\" ng-if=\"isRenewal\"><button class=\"col-xs-12 btn btn-secondary\" ng-click=\"returnInfo()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i>Cancelar Renovación</button></div><div class=\"col-xs-12 col-sm-6 col-md-6 text-align-center form-group\" ng-if=\"isRenewal\"><button class=\"col-xs-12 btn btn-success ladda-button-ren\" ng-click=\"validatePolizaFlotilla()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Renovar Póliza</button></div></div></div></div></div><script type=\"text/javascript\">\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"[name=\'text_input\']\");\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n    inputTag.focus();\n  }\n  function blurArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"[name=\'text_input\']\");\n\n    inputTag.addClass(\'display-none\');\n    strongTag.removeClass(\'display-none\');\n  }\n\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/flotillas/flotillas.renewal.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Colectividades</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"flotillas.info({polizaId: caratula.id})\">Colectividad #{{copy_caratula.poliza_number}}</a></li><li class=\"active\"><strong>Renovación</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"panel-group\"><div class=\"panel panel-default\" ng-init=\"showCar = false\"><div class=\"panel-heading\" ng-click=\"showCar ? showCar = false : showCar = true\"><h4 class=\"panel-title\"><a>Carátula <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showCar\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showCar\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showCar\"><div class=\"col-xs-12 animate z-index-9000\" ng-if=\"show_contractor\"><ng-include src=\"\'app/contratantes/contratantes.add.html\'\" ng-controller=\"ContratantesCtrl as vm\"></ng-include></div><div class=\"col-xs-12 animate\" ng-show=\"!show_contractor\"><br><div ng-include=\"\" src=\"\'app/flotillas/ordenes.html\'\"></div></div><div class=\"col-xs-12 col-sm-4 col-sm-offset-4 form-group\"><button class=\"btn btn-primary col-xs-12 m-t ladda-buttoncrear\" ng-click=\"validityInsurance()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Crear Carátula</button></div></div></div><div style=\"display:none\" class=\"panel panel-default\" ng-init=\"showPol = true\"><div class=\"panel-heading\" ng-click=\"showPol ? showPol = false : showPol = true\"><h4 class=\"panel-title\"><a>Pólizas <span class=\"pull-right\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\" ng-if=\"showPol\"></i> <i class=\"fa fa-chevron-down\" aria-hidden=\"true\" ng-if=\"!showPol\"></i></span></a></h4></div><div class=\"panel-body\" ng-hide=\"showPol\"><br><div ng-include=\"\" src=\"\'app/flotillas/polizas.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/flotillas/ordenes.html","<toaster-container></toaster-container><div class=\"pull-right option_button m-b\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\" ng-if=\"order.acceso_form\"><li class=\"dropdown-submenu\"><a>Descargar layouts</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li><a href=\"https://miurabox.s3.amazonaws.com/layouts/Colectividad_Flotilla.xls\">Flotillas</a></li></ul></li></ul></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"showOt\"><label>Número de Carátula: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-blur=\"checkNumPolicy()\" ng-model=\"caratula.poliza_number\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"caratula.identifier\" ng-blur=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Vigencia: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"startDate\" value=\"{{startDate}}\" ng-change=\"checkDate(startDate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Al: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"endDate\" value=\"{{endDate}}\" ng-change=\"checkEndDate(endDate)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante: <span class=\"color-red\">*</span></label><div class=\"input-group\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contratante\" change=\"matchesContractors(order.contratante)\" ng-blur=\"save_info_tab()\"></autocomplete><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"contratanteCreator()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in addresses track by address.url\" ng-change=\"changeAddress(addressSelected)\" ng-model=\"addressSelected\" ng-disabled=\"!order.contratante\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo Electrónico:</label> <input class=\"form-control\" type=\"email\" ng-model=\"order.contratante.value.email\" ng-disabled=\"!order.contratante\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono:</label><phonenumber-directive model=\"order.contratante.value.phone_number\" class=\"ng-isolate-scope\"><input class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" type=\"tel\" maxlength=\"25\" aria-invalid=\"false\" ng-model=\"inputValue\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Aseguradora: <span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control\" ng-options=\"aseguradora.alias for aseguradora in providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"getClaves(aseguradoraSelected); save_info_tab();\" ng-model=\"aseguradoraSelected\"><option value=\"\">Selecciona un proveedor</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"refreshProvider()\"><i class=\"glyphicon glyphicon-refresh\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Clave de Agente: <span class=\"color-red\">*</span></label> <input ng-if=\"claves.length == 0\" class=\"form-control\" type=\"text\" placeholder=\"Elige una aseguradora aseguradora\" disabled=\"\"> <input ng-if=\"claves.length == 1\" class=\"form-control\" type=\"text\" value=\"{{claves[0].clave + \' - \' + claves[0].name}}\" disabled=\"\"><select ng-if=\"claves.length > 1\" class=\"form-control\" ng-options=\"clave as clave.clave + \' - \' + clave.name for clave in claves | orderBy: \'clave\' track by clave.url\" ng-change=\"changeClave(claveSelected); save_info_tab();\" ng-model=\"claveSelected\" ng-disabled=\"!aseguradoraSelected\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"ramo.ramo_name for ramo in ramos track by ramo.url\" ng-change=\"changeRamo(ramoSelected); save_info_tab();\" ng-model=\"ramoSelected\" ng-disabled=\"!aseguradoraSelected\"><option value=\"\">Selecciona un ramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"subramo.subramo_name for subramo in subramos track by subramo.url\" ng-change=\"changeSubramo(subramoSelected); save_info_tab();\" ng-model=\"subramoSelected\" ng-disabled=\"!ramoSelected\"><option value=\"\">Selecciona un subramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Tipo de Carátula: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.label for type in types\" ng-change=\"changeType(typeSelected); save_info_tab();\" ng-model=\"typeSelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Moneda:</label><select class=\"form-control\" ng-options=\"currency.value as currency.label for currency in currencys\" ng-change=\"changeCurrency(currencySelected); save_info_tab();\" ng-model=\"currencySelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-options=\"bline.name for bline in businessline | orderBy:\'id\' track by bline.id\" ng-change=\"changeBline(lineaSelected); save_info_tab();\" name=\"business\" ng-model=\"lineaSelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Responsable:</label><select class=\"form-control\" ng-options=\"responsable.id as responsable.first_name + \' \' + responsable.last_name for responsable in users\" ng-change=\"changeResponsable(responsableSelected); save_info_tab();\" ng-model=\"responsableSelected\"><option value=\"\">Seleccione un responsable</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Renovable: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"renewal.label for renewal in renewals\" ng-change=\"changeRenewal(renewalSelected); save_info_tab();\" ng-model=\"renewalSelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}:</label><select class=\"form-control\" ng-options=\"celula.celula_name for celula in celulas | orderBy:\'id\' track by celula.id\" ng-change=\"changeCelula(celulaSelected); save_info_tab();\" ng-model=\"celulaSelected\"><option value=\"\" disabled=\"\">Seleccione una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Agrupación</label><select class=\"form-control\" ng-options=\"item.description for item in agrupaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeAgrupacion(grouping_levelSelected)\" ng-model=\"grouping_levelSelected\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Subagrupación</label><select class=\"form-control\" ng-options=\"item.description for item in sub_asignaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeSubagrupacion(subgroupingSelected)\" ng-model=\"subgroupingSelected\" ng-disabled=\"!grouping_levelSelected\"><option value=\"\" disabled=\"\">Seleccione una subagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Subsubagrupación</label><select class=\"form-control\" ng-options=\"item.description for item in sub_subasignaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeSubsubagrupacion(subsubgroupingSelected)\" ng-model=\"subsubgroupingSelected\" ng-disabled=\"!subgroupingSelected\"><option value=\"\" disabled=\"\">Seleccione una subsubagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-class=\"{ \'has-error\': form.ejecutivo_cobranza.$invalid && !form.ejecutivo_cobranza.$pristine }\"><label for=\"ejecutivo_cobranza\">Ejecutivo de cobranza</label><div><select class=\"form-control\" ng-model=\"ejecutivoCobranzaSelected\" ng-change=\"changeEjecutivoCobranza(ejecutivoCobranzaSelected); save_info_tab();\" ng-options=\"ejecutivo_cobranza.id as ejecutivo_cobranza.first_name + \' \' + ejecutivo_cobranza.last_name for ejecutivo_cobranza in users\"><option value=\"\">Seleccione un Ejecutivo</option></select></div></div><div class=\"col-xs-12 col-sm-6 form-group hidden-xs hidden-sm\" ng-if=\"order.acceso_ver_ref\"><label>Referenciadores <span ng-if=\"!order.acc_referenciador_obligatorio\" class=\"color-red\">*</span>:</label><div ng-repeat=\"item in referenciadorArray\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteReferenciador($index,item)\" ng-disabled=\"referenciadorArray.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control\" ng-options=\"referenciador.url as referenciador.first_name + \' \' + referenciador.last_name for referenciador in referenciadores\" ng-model=\"item.referenciador\" ng-change=\"save_info_tab()\"><option value=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\"><input class=\"form-control wb102\" type=\"text\" placeholder=\"% Comisión\" ng-disabled=\"referenciadorArray.length <= 1\" ng-change=\"changeComRef(item.comision_vendedor, $index,item)\" ng-model=\"item.comision_vendedor\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div></div>");
$templateCache.put("app/flotillas/polizas.html","<toaster-container></toaster-container><div class=\"row\"><br><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Pólizas</legend></div><div class=\"col-xs-12 form-group\" ng-if=\"dataCaratula.id\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> - El layout para cargar pólizas a esta colectividad es <strong>Colectividades_Flotillas.xls</strong><br>- El layout lo puedes descargar desde el botón de opciones que se encuentra en esta misma página en la parte superior derecha.<br>- Busca los ID que te ayudarán a llenar el layout.</div></div><div class=\"col-xs-12\" ng-if=\"dataCaratula.id\"><legend class=\"legend-title\">{{ dataCaratula.subramo.subramo_name }}</legend></div><div class=\"col-xs-12 col-sm-6\"><div class=\"col-xs-12 form-group\"><label>Contratante: <span class=\"color-red\">*</span></label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.searchContratante\" change=\"matchesContractors(order.searchContratante)\"></autocomplete></div><div class=\"col-xs-12 form-group\" ng-if=\"order.searchContratante\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Contratante</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ contractorLayout.id }}</span><br><small>Nombre: <span>{{ contractorLayout.name }}</span></small><br><small>Tipo Contratante: <span class=\"font-weight-bold\">{{ contractorLayout.type }}</span></small></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\" ng-if=\"order.searchContratante\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Direcciones</th></tr></thead><tbody><tr ng-repeat=\"item in contractorLayout.address\"><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br><small>Nombre: <span>{{ item.administrative_area_level_2 }}, {{ item.administrative_area_level_1 }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><label>Paquete: <span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"package.package_name for package in paquetesLayout | orderBy:\'package_name\' track by package.url\" ng-change=\"changePackageLay(paqueteLay)\" name=\"paquete\" ng-model=\"paqueteLay\" ng-disabled=\"!subramoSelected\"><option value=\"\">Selecciona un paquete</option></select><span ng-if=\"!paquetesLayout.length && subramoSelected\">No hay paquetes en este subramo</span></div><div class=\"col-xs-12 form-group\" ng-if=\"paqueteLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Paquete</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ paqueteLay.id }}</span><br><small>Nombre: <span>{{ paqueteLay.package_name }}</span></small></td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 border-left\"><div class=\"col-xs-12 form-group\"><label>Sucursal: <span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"sucursal as sucursal.sucursal_name for sucursal in sucursalesLay\" ng-change=\"changeSucursalLay(sucursal)\" name=\"sucursals\" ng-model=\"sucursalLay\"><option value=\"\">Selecciona un sucursal</option></select><span ng-if=\"!sucursalesLay.length\">No hay sucursales</span></div><div class=\"col-xs-12 form-group\" ng-if=\"sucursalLay\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Sucursal</th></tr></thead><tbody><tr><td><small>ID para layout:</small><span class=\"font-weight-bold\">{{ sucursalLay.id }}</span><br><small>Nombre: <span>{{ sucursalLay.sucursal_name }}</span></small></td></tr></tbody></table></div></div></div><div class=\"row\" ng-if=\"!showTableCertificates\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"!loader\"><label class=\"col-xs-12 btn btn-success\">Agregar Archivo <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input class=\"display-none\" type=\"file\" fileread=\"\" name=\"readCsvFile\" id=\"readCsvFile\" ng-model=\"excelFile\" ng-change=\"validateExcel(excelFile)\" onclick=\"limpiar()\"></label></div><div class=\"col-sm-6 col-md-3 form-group pull-right\" ng-if=\"!loader\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"goToPolicy()\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Información de la colectividad</button></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cog fa-spin fa-5x\"></i><div><span>Cargando pólizas...</span></div></div><div class=\"col-xs-12 form-group\"><br><br><br></div></div><div class=\"row\" ng-if=\"showTableCertificates\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">{{ layout.subramo_name }}</legend></div><div class=\"col-xs-1 form-group\"><select class=\"form-control\" ng-options=\"renewal.value for renewal in optionsViews\" ng-change=\"selectViews(optionViews)\" ng-model=\"optionViews\"></select></div><div><label>Del {{ valueInitial }} al {{ valueFinal }} de {{ excelJson.length }}</label> <button class=\"btn btn-white\" ng-click=\"addViews(-1)\" ng-disabled=\"valueInitial == 1\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white\" ng-click=\"addViews(+1)\" ng-disabled=\"valueFinal == excelJson.length\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-12 form-group\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover\" ng-if=\"layout.subramo.subramo_name == \'Automóviles\'\"><thead><tr><td>No Carátula</td><td>Folio</td><td>No. Póliza</td><td>Contratante</td><td>Tipo Contratante</td><td>Dirección</td><td>Vigencia Inicio</td><td>Vigencia Fin</td><td>Frecuencia Pago</td><td>Renovable</td><td>Moneda</td><td>Paquete</td><td>Sucursal</td><td>Tipo</td><td>Procedencia</td><td>Conductor</td><td>Marca</td><td>Modelo</td><td>Año</td><td>Versión</td><td>Serie</td><td>Motor</td><td>Color</td><td>Matrícula</td><td>Uso</td><td>Servicio</td><td>Prima Neta</td><td>Descuento</td><td>RPF</td><td>Derecho</td><td>Iva</td><td>Prima Total</td><td>Comisión</td><td>%Comisión</td><td>No. Recibo</td><td>Prima Recibo</td><td>RPF Recibo</td><td>Derecho Recibo</td><td>IVA Recibo</td><td>Total Recibo</td><td>Comisión Recibo</td><td>Inicio Recibo</td><td>Fin Recibo</td><td>Vencimiento Recibo</td><td>Conducto de Pago</td></tr></thead><tbody><tr ng-repeat=\"item in excelJsonViews\"><td>{{ item.NO_CARATULA }}</td><td>{{ item.FOLIO }}</td><td>{{ item.NO_POLIZA }}</td><td>{{ item.CONTRATANTE }}</td><td>{{ item.TIPO_CONTRATANTE }}</td><td>{{ item.DIRECCION }}</td><td>{{ item.VIGENCIA_INICIO }}</td><td>{{ item.VIGENCIA_FIN }}</td><td>{{ item.FRECUENCIA_PAGO }}</td><td>{{ item.RENOVABLE }}</td><td>{{ item.MONEDA }}</td><td>{{ item.PAQUETE }}</td><td>{{ item.SUCURSAL }}</td><td>{{ item.TIPO }}</td><td>{{ item.PROCEDENCIA }}</td><td>{{ item.CONDUCTOR }}</td><td>{{ item.MARCA }}</td><td>{{ item.MODELO }}</td><td>{{ item.ANIO }}</td><td>{{ item.VERSION }}</td><td>{{ item.SERIE }}</td><td>{{ item.MOTOR }}</td><td>{{ item.COLOR }}</td><td>{{ item.MATRICULA }}</td><td>{{ item.USO }}</td><td>{{ item.SERVICIO }}</td><td>{{ item.PRIMA_NETA }}</td><td>{{ item.DESCUENTO }}</td><td>{{ item.RPF }}</td><td>{{ item.DERECHO }}</td><td>{{ item.IVA }}</td><td>{{ item.PRIMA_TOTAL }}</td><td>{{ item.COMISION }}</td><td>{{ item.PORCENTAJE_COMISION }}</td><td>{{ item.NO_RECIBO }}</td><td>{{ item.PRIMA_RECIBO }}</td><td>{{ item.RPF_RECIBO }}</td><td>{{ item.DERECHO_RECIBO }}</td><td>{{ item.IVA_RECIBO }}</td><td>{{ item.TOTAL_RECIBO }}</td><td>{{ item.COMISION_RECIBO }}</td><td>{{ item.INICIO_RECIBO }}</td><td>{{ item.FIN_RECIBO }}</td><td>{{ item.VENCIMIENTO_RECIBO }}</td><td>{{ item.CONDUCTO_DE_PAGO }}</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"cancelCertificates()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success ladda-button\" ng-click=\"saveCertificates()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Pólizas</button></div></div><script type=\"text/javascript\">\n  function limpiar(){\n    document.getElementById(\'readCsvFile\').value =\'\';\n  }\n</script>");
$templateCache.put("app/flotillas/renovarcon.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Renovar Póliza {{polizaarenovar.poliza_number}}</h4></div><div class=\"modal-body col-xs-12\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"form-group col-xs-12 not-scroll\"><label>Número de Póliza: <span class=\"color-red\">*</span></label><autocomplete datasource=\"autocompleteData\" model=\"vmm.policy_number\" change=\"findPolicy(vmm.policy_number)\"></autocomplete></div></div><div ng-if=\"vmm.policy_number.url\"><h4><label>Póliza a vincular: {{vmm.policy_number.value}}</label></h4></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"close()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success ladda-button\" ng-disabled=\"!vmm.policy_number.url\" ng-click=\"reActivatePolicy(vmm.policy_number)\" type=\"button\">Renovar Póliza</button></div></div>");
$templateCache.put("app/grupos/grupos.deleteContact.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Eliminar</h4></div><div class=\"modal-body\"><p></p><h1>¿Está seguro que desea eliminar este contacto?</h1><br\\>El contacto se eliminará aunque no guarde los cambios<p></p></br\\></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">No</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Sí</button></div></div>");
$templateCache.put("app/grupos/grupos.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Grupos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"grupos.grupos\">Grupos</a></li><li class=\"active\"><strong>Editar</strong></li></ol></div></div><br><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Información</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"vm.form.group_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Responsable</label><select class=\"form-control\" name=\"responsable\" ng-model=\"vm.form.responsable\" ng-change=\"changeResponsable(vm.form.responsable)\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in users track by responsable.url\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" name=\"description\" ng-model=\"vm.form.description\" type=\"text\"></textarea></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-success col-xs-12\" ng-click=\"openModalGroup(2)\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Agregar Subgrupo</button></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Contactos</legend><table class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th class=\"footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Nombre</th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\">Teléfono</th><th data-hide=\"phone\" class=\"footable-sortable\">Correo electrónico</th><th data-hide=\"phone\" class=\"footable-sortable\">Departamento</th><th data-hide=\"phone\" class=\"footable-sortable\">Opción</th></tr></thead><tbody><tr ng-repeat=\"contact in vm.form.contact_group track by $index\" foo-repeat-done=\"\"><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.name\" style=\"text-transform: capitalize\"></td><td><phonenumber-directive model=\"contact.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"inputValue\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></td><td><input class=\"form-control\" type=\"email\" ng-model=\"contact.email\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.departament\"></td><td><button type=\"button\" class=\"btn btn-w-m btn-danger\" name=\"button\" ng-click=\"vm.deleteContacts(contact.url, $index)\">Eliminar</button></td></tr></tbody></table></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"btn btn-success col-xs-12\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button></div><div class=\"col-xs-12\"><div ng-include=\"\'templates/upload.html\'\" ng-if=\"vm.user.permiso.crear && vm.user.permiso.editar\"></div><div ng-include=\"\'templates/show-files.html\'\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"btn btn-primary col-xs-12\" ng-disabled=\"form.$invalid\" type=\"submit\" ng-click=\"vm.save()\" ng-if=\"vm.user.permiso.editar\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"btn btn-white col-xs-12\" type=\"button\" ng-click=\"vm.cancel()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 form-group\"><br><br><br></div></div></div></div>");
$templateCache.put("app/grupos/grupos.form.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Agregar Grupo</h4></div><div class=\"modal-body\"><div class=\"row\" ng-if=\"level == 1\"><div class=\"col-xs-12 form-group\"><label>Nuevo Grupo <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"groupForm.group_name\" type=\"text\"></div><div class=\"col-xs-12 form-group\"><label>Responsable <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"responsable\" ng-model=\"groupForm.responsable\" ng-change=\"changeResponsable(groupForm.responsable)\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in users track by responsable.url\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" name=\"description\" ng-model=\"groupForm.description\" type=\"text\"></textarea></div><div class=\"col-xs-12\"><div class=\"address-container\" ng-repeat=\"item in subgroups\"><label>Subgrupo #{{$index + 1}}</label><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteSubgroup($index)\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button></span> <input class=\"form-control\" type=\"text\" ng-model=\"item.group_name\" placeholder=\"Nombre\"> <span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addSubgroups()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></span></div></div></div></div><div class=\"row\" ng-if=\"level == 2\"><div class=\"col-xs-12 form-group\"><label>Nuevo Subgrupo <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"subgroupForm.group_name\" type=\"text\"></div><div class=\"col-xs-12\"><div class=\"address-container\" ng-repeat=\"item in sub_subgroups\"><label>Subsubgrupo #{{$index + 1}}</label><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteSubsubgroup($index)\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button></span> <input class=\"form-control\" type=\"text\" ng-model=\"item.group_name\" placeholder=\"Nombre\"> <span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addSubsubgroups()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></span></div></div></div></div><div class=\"row\" ng-if=\"level == 3\"><div class=\"col-xs-12 form-group\"><label>Nuevo Subsubgrupo <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"subsubgroupForm.group_name\" type=\"text\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button> <button ng-if=\"level == 1\" type=\"button\" class=\"btn btn-primary ladda-button\" ng-click=\"ok()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear</button> <button ng-if=\"level == 2\" type=\"button\" class=\"btn btn-primary ladda-button\" ng-click=\"oksub()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear</button> <button ng-if=\"level == 3\" type=\"button\" class=\"btn btn-primary ladda-button\" ng-click=\"oksubsub()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear</button></div></div>");
$templateCache.put("app/grupos/grupos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Grupos</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Grupos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\" ng-if=\"vm.acceso_adm_cont\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title\" ng-if=\"vm.acceso_adm_cont\"><h5>Agregar nuevo grupo</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><form method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\"><label>Nombre del Grupo<span class=\"color-red\">*</span></label><autocomplete datasource=\"vm.groups_results\" id=\"autocompleteGroups\" model=\"vm.form.group_name\" change=\"vm.searchGroups(vm.form.group_name);vm.saveLocalstorage()\"></autocomplete></div><div class=\"form-group\"><label>Responsable<span class=\"color-red\">*</span></label><select class=\"form-control m-b\" name=\"responsable\" ng-model=\"vm.form.responsable\" ng-change=\"changeResponsable(vm.form.responsable); vm.saveLocalstorage()\" ng-options=\"responsable.url as responsable.first_name + \' \' + responsable.last_name for responsable in users track by responsable.url\"><option value=\"\" disabled=\"\">Seleccione un responsable</option></select></div><div class=\"form-group\"><label>Observaciones</label> <textarea class=\"form-control\" name=\"description\" ng-model=\"vm.form.description\" type=\"text\" ng-change=\"vm.saveLocalstorage()\"></textarea></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success\" ng-if=\"subgroups.length == 0\" ng-click=\"addSubgroups();vm.saveLocalstorage()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Agregar Subgrupos</button></div><div class=\"address-container\" ng-repeat=\"item in subgroups\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteSubgroup($index);vm.saveLocalstorage()\" <i=\"\" aria-hidden=\"true\">Quitar Subgrupo</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteSubgroup($index);vm.saveLocalstorage()\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Subgrupo #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addSubgroups();vm.saveLocalstorage()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Subgrupo</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addSubgroups();vm.saveLocalstorage()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.group_name\" ng-change=\"vm.saveLocalstorage()\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre del Subsubgrupo:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.sub_subgroup[0].group_name\" ng-change=\"vm.saveLocalstorage()\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-12\"><legend class=\"legend-title\" align=\"center\">Contactos</legend><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover table table-stripped\" data-page-size=\"25\"><thead><tr><th class=\"footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Nombre</th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\">Teléfono</th><th data-hide=\"phone\" class=\"footable-sortable\">Correo electrónico</th><th data-hide=\"phone\" class=\"footable-sortable\">Departamento</th><th data-hide=\"phone\" class=\"footable-sortable\">Opción</th></tr></thead><tbody><tr ng-repeat=\"contact in vm.form.contact_group track by $index\" foo-repeat-done=\"\"><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.name\" ng-change=\"vm.saveLocalstorage()\" style=\"text-transform: capitalize\"></td><td><phonenumber-directive model=\"contact.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"inputValue\" ng-change=\"vm.saveLocalstorage()\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></td><td><input class=\"form-control\" ng-model=\"contact.email\" ng-change=\"vm.saveLocalstorage()\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.departament\" ng-change=\"vm.saveLocalstorage()\"></td><td><button type=\"button\" class=\"btn btn-w-m btn-danger\" name=\"button\" ng-click=\"vm.deleteContacts($index); vm.saveLocalstorage()\" ng-if=\"vm.user.permiso.crear\">Eliminar</button></td></tr></tbody></table></div><div class=\"col-sm-12\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addContact();vm.saveLocalstorage()\" type=\"button\">Agregar contacto</button></div></div></div><div class=\"hr-line-dashed\"></div><div upload-template=\"\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"btn btn-primary col-xs-12\" ng-disabled=\"form.$invalid\" type=\"submit\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Crear Grupo</button></div></div></form></div></div></div></div><div class=\"row\" ng-if=\"vm.acceso_ver_cont\"><div class=\"col-xs-12 form-group\"><label>Nombre del Grupo</label><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" id=\"filter\" placeholder=\"Buscar\" ng-enter=\"vm.search(cadena)\" ng-model=\"cadena\" ng-change=\"vm.saveLocalstorage()\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"vm.activate()\">Mostrar todos</button></div></div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.groups.length\"><table class=\"table table-bordered table-hover table-stripped\" data-filter=\"#filter\" data-page-size=\"25\" ng-if=\"!vm.show_binnacle\"><thead><tr><th class=\"footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Grupo <span class=\"footable-sort-indicator\"></span></th><th class=\"footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Responsable <span class=\"footable-sort-indicator\"></span></th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\">Descripción <span class=\"footable-sort-indicator\"></span></th><th data-hide=\"phone\" class=\"footable-sortable\">Acciones</th></tr></thead><tbody><tr ui-sref=\"grupos.info({grupoId: group.id})\" ng-repeat=\"group in vm.groups track by $index\"><td>{{ group.group_name }}</td><td ng-if=\"group.responsable\">{{ group.responsable.first_name }} {{ group.responsable.last_name }}</td><td ng-if=\"!group.responsable\">Sin responsable asignado</td><td>{{ group.description }}</td><td ng-click=\"$event.stopPropagation()\"><a ng-click=\"vm.editGroup(group)\" ui-sref=\"grupos.edit({grupoId: group.id})\" type=\"button\" class=\"btn btn-info\" ng-if=\"vm.user.permiso.editar\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(group)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"show_pagination && !vm.show_binnacle\" class=\"text-center\"><pagination config=\"vm.config_pagination\" model=\"vm.groups\"></pagination></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.groups.length && vm.buttonReport == false && !vm.show_binnacle\"><button ng-click=\"exportData(\'Grupos\')\" class=\"col-xs-12 btn btn-primary\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Generar Reporte</button></div></div></div>");
$templateCache.put("app/grupos/grupos.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Grupos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"grupos.grupos\">Grupos</a></li><li class=\"active\"><strong>Información</strong></li></ol></div></div><br><div class=\"ibox float-e-margins animate\"><div class=\"ibox-title\"><h5>Grupo</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre del grupo:</label> <input disabled=\"\" ng-model=\"vm.group.group_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.group.responsable\"><label>Responsable:</label> <input disabled=\"\" value=\"{{vm.group.responsable.first_name}} {{vm.group.responsable.last_name}}\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"!vm.group.responsable\"><label>Responsable:</label> <input disabled=\"\" value=\"Sin grupo asignado\" class=\"form-control\"></div><div ng-if=\"vm.group.description\" class=\"col-xs-12 col-sm-6 form-group\"><label>Descripción:</label> <input disabled=\"\" ng-model=\"vm.group.description\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><button ng-if=\"vm.acceso_del_group\" class=\"btn btn-white col-xs-12\" type=\"button\" name=\"button\" ng-click=\"deleteGroup(vm.group.url)\"><i class=\"fa fa-trash\"></i> Eliminar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\"><button ng-if=\"vm.acceso_adm_cont\" class=\"btn btn-info col-xs-12\" type=\"button\" ui-sref=\"grupos.edit({grupoId: vm.group.id})\" name=\"button\"><i class=\"fa fa-pencil\"></i> Editar</button></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Contratantes</legend><table class=\"table table-striped table-bordered table-hover dataTables-example table\" data-filter=\"#filter\" data-page-size=\"25\" ng-if=\"vm.groupsJuridical || vm.groupsNatural\"><thead><tr><th class=\"visible sortable first-column\" data-breakpoints=\"xs\">Nombre <span class=\"sort-indicator\"></span></th><th class=\"visible sortable\" data-hide=\"phone\">Tipo <span class=\"sort-indicator\"></span></th><th class=\"visible sortable\" data-hide=\"phone\">RFC <span class=\"sort-indicator\"></span></th><th data-hide=\"phone\" class=\"sortable\">Correo <span class=\"sort-indicator\"></span></th><th data-hide=\"phone\" class=\"sortable\">Teléfono <span class=\"sort-indicator\"></span></th></tr></thead><tbody><tr ng-repeat=\"info in vm.groupsJuridical track by $index\" foo-repeat-done=\"\" ng-if=\"info.is_active == true\"><td><a ui-sref=\"contratantes.edit({type: vm.checkType(info.type_person), contratanteId: info.id})\">{{ info.full_name }} {{ info.j_name }}</a></td><td><span ng-if=\"info.type_person ==1\">Física</span><span ng-if=\"info.type_person ==2\">Moral</span></td><td>{{info.rfc}}</td><td>{{info.email}}</td><td>{{info.phone_number | phonenumber}}</td></tr><tr ng-repeat=\"info in vm.groupsNatural track by $index\" ng-if=\"info.is_active == true\" foo-repeat-done=\"\"><td><a ui-sref=\"contratantes.edit({type: vm.checkType(info.type_person), contratanteId: info.id})\">{{ info.full_name }} {{ info.j_name }}</a></td><td><span ng-if=\"info.type_person ==1\">Física</span><span ng-if=\"info.type_person ==2\">Moral</span></td><td>{{info.rfc}}</td><td>{{info.email}}</td><td>{{info.phone_number | phonenumber}}</td></tr></tbody><tfoot class=\"hide-if-no-paging\"><tr><td colspan=\"6\" align=\"center\"><ul class=\"pagination\"></ul></td></tr></tfoot></table><div ng-if=\"show_pagination\" class=\"text-center\"><pagination config=\"vm.config_pagination\" model=\"vm.groupsNatural\"></pagination></div></div><div class=\"col-xs-12 form-group\" ng-if=\"!edit_subgroup\"><legend class=\"legend-title\" align=\"center\">Subgrupos y subsubgrupos</legend><table class=\"table table-striped table-bordered table-hover dataTables-example table\" data-filter=\"#filter\" data-page-size=\"25\" ng-if=\"vm.groupsJuridical || vm.groupsNatural\"><thead><tr><th class=\"visible sortable first-column\" data-breakpoints=\"xs\">Nombre Subgrupo <span class=\"sort-indicator\"></span></th><th class=\"visible sortable\" data-hide=\"phone\">Subsubgrupos <span class=\"sort-indicator\"></span></th><th class=\"visible sortable\" data-hide=\"phone\">Opciones <span class=\"sort-indicator\"></span></th></tr></thead><tbody><tr ng-repeat=\"info in vm.group.subgrupos track by $index\" foo-repeat-done=\"\"><td><span>{{info.group_name}}</span></td><td><ul><li ng-repeat=\"item in info.subsubgrupos\"><span>{{item.group_name}}</span></li></ul></td><td><button class=\"btn btn-white btn-sm\" ng-click=\"editSubroup(info)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-white btn-sm\" ng-click=\"deleteGroup(info.url)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></tbody></table></div><div ng-if=\"edit_subgroup\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"returnSub()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12 form-group\"><hr></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"sub_group.group_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group m-t\" ng-if=\"sub_group.subsubgrupos.length == 0\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"addSubsubgroups();\">Agregar Subsubgrupos</button></div><div class=\"col-xs-12 form-group\"><hr></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-repeat=\"item in sub_group.subsubgrupos\"><label>Subgrupos</label><div class=\"input-group\"><span class=\"input-group-btn\" ng-if=\"item.url\"><button class=\"btn btn-white\" ng-click=\"deleteSubsubgroup(item, $index)\" type=\"button\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></span> <span class=\"input-group-btn\" ng-if=\"!item.url\"><button class=\"btn btn-white\" ng-click=\"deleteSubsubgroup(item, $index)\" type=\"button\"><i class=\"fa fa-minus\" aria-hidden=\"true\"></i></button></span> <input class=\"form-control\" type=\"text\" ng-model=\"item.group_name\"> <span class=\"input-group-btn\" ng-if=\"item.url\"><button class=\"btn btn-success\" ng-click=\"addSubsubgroups()\" type=\"button\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span> <span class=\"input-group-btn\" ng-if=\"!item.url\"><button class=\"btn btn-success\" ng-click=\"addSubsubgroups()\" type=\"button\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span></div></div><div class=\"col-xs-12 form-group\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"upgrade()\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"btn btn-white col-xs-12\" ng-click=\"returnSub()\"><i class=\"fa fa-close\" aria-hidden=\"true\"></i> Cancelar</button></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información de contacto</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><table class=\"table table-striped table-bordered table-hover table table-stripped\" data-page-size=\"25\"><thead><tr><th class=\"visible sortable first-column\" data-breakpoints=\"xs\">Nombre <span class=\"sort-indicator\"></span></th><th class=\"visible sortable\" data-hide=\"phone\">Teléfono <span class=\"sort-indicator\"></span></th><th data-hide=\"phone\" class=\"sortable\">Email <span class=\"sort-indicator\"></span></th><th data-hide=\"phone\" class=\"sortable\">Departamento <span class=\"sort-indicator\"></span></th></tr></thead><tbody><tr ng-repeat=\"contact in vm.contact_group track by $index\" foo-repeat-done=\"\"><td>{{contact.name}}</td><td>{{contact.phone_number}}</td><td>{{contact.email}}</td><td>{{contact.departament}}</td></tr></tbody><tfoot class=\"hide-if-no-paging\"><tr><td colspan=\"6\" align=\"center\"><ul class=\"pagination\"></ul></td></tr></tfoot></table></div></div><div class=\"ibox float-e-margins\" ng-if=\"vm.permiso_archivos\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title light-gray-background\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-md-12\"><div class=\"col-md-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"8\" idmodel=\"vm.groupId\" exportable=\"true\"></comments></div></div></div>");
$templateCache.put("app/help/help.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Ayuda de SAAM</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Ayuda</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-8 col-xs-offset-2 form-group container-box\"><ul class=\"list-group\" style=\"margin: 0;\"><li class=\"list-group-item\" ng-repeat=\"item in manuals track by $index\" ng-init=\"isSeller[$index] = false; main_index = $index\" style=\"padding-bottom: 0;\"><p class=\"legend-title\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], users[$index])\" style=\"font-size: 16px;\">{{ item.title }} <span class=\"pull-right\" style=\"font-size: 12px;\"><i class=\"fa fa-chevron-down\"></i></span></p><div class=\"row address_components\" ng-if=\"isSeller[$index]\" style=\"padding: 20px 0 10px;\"><div class=\"col-xs-12\" style=\"padding: 0;\"><div ng-repeat=\"section in item.sections track by $index\" class=\"col-md-12\"><a class=\"col-md-6\" href=\"{{section.url}}\" target=\"_blank\"><p class=\"blue-color\" style=\"display: block; text-align: center; font-size: 14px;\">{{ section.subtitle }}</p></a><div class=\"col-md-6\" align=\"center\" ng-if=\"section.url\"><a class=\"btn btn-primary btn-xs\" href=\"{{section.url}}\" target=\"_blank\">Obtener Manual</a></div></div></div></div></li></ul></div></div>");
$templateCache.put("app/help/help.policy.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>{{ gc.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"help.manual\">Ayuda</a></li><li class=\"active\"><strong>Ayuda Póliza</strong></li></ol></div></div><br><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>¿Cómo hacer una póliza?</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-8 col-xs-offset-2 form-group\"><legend class=\"legend-title blue-color\" align=\"center\">Objetivo</legend><p align=\"center\">Conocer la forma de crear pólizas individuales así como Ots, recibos y adjuntar archivos.</p><div style=\"text-align: center; margin: 40px 0;\"><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/lTiExQ3qY5Y\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen=\"\"></iframe></div><div><legend class=\"legend-title blue-color\" align=\"center\">Paso 1 - Llena la información.</legend><p>Campos marcados con asterisco.</p><p>Al no llenar los campos requeridos el sistema arrojará un error o la información quedará incompleta y algunas funciones estarán deshabilitadas.</p></div><div><legend class=\"legend-title blue-color\" align=\"center\">Paso 2 - Genera los recibos.</legend><p>Primas de la póliza.</p><p>Es necesario que conozcas los costos para poder generar correctamente los recibos que posteriormente usaremos en otras funciones.</p></div><div><legend class=\"legend-title blue-color\" align=\"center\">Paso 3 - Sube adjuntos.</legend><p>Un archivo.</p><p>Para mayor detalle y una referencia documental en tu póliza.</p></div></div><div class=\"col-xs-8 col-xs-offset-2 form-group legend-gray\" style=\"margin-top: 80px; padding-bottom: 20px;\"><legend class=\"legend-title\">¿Te ayudó esta información?</legend><button class=\"btn btn-white\" ng-click=\"showResult(true)\">Sí</button> <button class=\"btn btn-white\" ng-click=\"showResult(false)\">No</button><div ng-if=\"showAnswerAfirmative\" style=\"margin: 30px;\"><p>Gracias por tus sugerencias.</p></div><div class=\"col-sm-12 form-group m-t\" ng-if=\"showAnswerNegative\"><label>Lamentamos esa respuesta</label><p>¿Tienes alguna sugerencia?</p><textarea class=\"form-control\" type=\"text\" ng-model=\"vm.form.description\"></textarea> <button class=\"btn btn-success pull-right m-t\" ng-click=\"\">Enviar</button></div></div></div></div></div>");
$templateCache.put("app/ibis/ibis.directorio.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-lg-9\"><h2>Directorio</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>IBIS</a></li><li class=\"active\"><strong>Directorio</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 margin-bottom-10\"><div class=\"ibox-title\"><h5>Directorios</h5></div><div class=\"ibox-content\"><div class=\"col-xs-12 form-group\" ng-if=\"!loader\"><a class=\"btn btn-info pull-right\" href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Directorio.xls\">Descargar Layout</a></div><div class=\"col-xs-12 form-group\" ng-if=\"!loader\"><label>Seleccione el archivo con los contactos para el directorio.</label> <span>En caso de no tenerlo, por favor hacer click en el botón de Descargar Layout</span></div><div class=\"col-xs-12 form-group\" ng-if=\"!loader\"><input class=\"btn btn-success\" type=\"file\" fileread=\"\" ng-model=\"excelFile\" name=\"readCsvFile\" id=\"readCsvFile\" ng-change=\"selectExcelDirectorio(excelFile)\"></div><div class=\"col-xs-12 form-group\"><label>Contenido del archivo</label></div><div class=\"col-xs-12 form-group\" ng-if=\"!id_tree\"><div id=\"tree_ids\" class=\"treeview\"></div></div><div class=\"col-xs-12 form-group\"><div id=\"tree\" class=\"treeview\"></div></div><div class=\"col-xs-12\" ng-if=\"saveFlag\"><button class=\"btn btn-primary\" ng-click=\"save(1)\"><i class=\"fa fa-save\"></i> Guardar</button></div></div></div></div>");
$templateCache.put("app/ibis/ibis.formatos.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-lg-9\"><h2>Formatos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>IBIS</a></li><li class=\"active\"><strong>Formatos</strong></li></ol></div></div><div class=\"ibox-content\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles()\">Guardar Archivos</button></div></div>");
$templateCache.put("app/ibis/ibis.formatos.whatsapp-siniestros.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Plantillas para Compartir Siniestros por WhatsApp Web</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"ibis.formatos\">IBIS</a></li><li class=\"active\"><strong>Plantillas para Compartir Siniestros por WhatsApp Web</strong></li></ol></div></div><br><div class=\"row\" style=\"padding:20px\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createQuotation()\">Agregar Plantilla</button></div><div class=\"col-xs-12\" ng-show=\"showPlantilla\"><legend ng-if=\"!showEditInformation\" class=\"legend-title\" align=\"center\">Nueva Plantilla</legend><legend ng-if=\"showEditInformation\" class=\"legend-title\" align=\"center\">Actualizar Plantilla</legend><form class=\"row\" name=\"form\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"plantilla.title\" name=\"plantillaTitle\" required=\"\"></div><div class=\"col-xs-12 form-group\"><label>Mensaje<span class=\"color-red\">*</span></label> <textarea type=\"text\" class=\"form-control\" name=\"mensaje\" ng-model=\"plantilla.text\" required=\"\"></textarea></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button ng-if=\"!showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid || savingPlantilla\" ng-click=\"saveDelivery(plantilla)\">Crear Plantilla</button> <button ng-if=\"showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid || savingPlantilla\" ng-click=\"updateDelivery(plantilla)\">Actualizar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeQuotation()\">Cancelar</button></div></form></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Plantillas para Compartir Siniestros por WhatsApp Web</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\" ng-hide=\"showInfoPlantilla\"><table class=\"table table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th>ID</th><th>Identificador</th><th>Mensaje</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"pl in vm.templatesList track by $index\" ng-click=\"showInformation(pl)\"><td>{{ pl.id }}</td><td>{{ pl.title }}</td><td>{{ pl.text }}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-sm btn-white\" ng-click=\"editQuatation(pl)\" title=\"Editar plantilla\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-sm btn-danger m-l-xs\" ng-click=\"borrarPlantilla(pl)\" title=\"Eliminar plantilla\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"showTemplates\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div>");
$templateCache.put("app/ibis/ibis.principal.html","");
$templateCache.put("app/ibis/ibis.red.html","");
$templateCache.put("app/inicio/inicio.html","<toaster-container></toaster-container><br><div class=\"row\" style=\"background-image: url(\'../../assets/images/inicio/back.png\'); background-size: contain;\"><div class=\"col-xs-12 col-sm-6 form-group\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><img ng-src=\"{{vm.logo}}\" alt=\"\" style=\"display: block; margin: 20px auto;max-width: 300px; max-height:200px;\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><div class=\"box-main-inicio\" id=\"createOTS\" ui-sref=\"index.main\"><div class=\"box-inicio\"><p class=\"icon-inicio\"><i class=\"fa fa-pie-chart\"></i></p></div><div class=\"box-inicio-footer\"><p class=\"text-inicio-footer\">DASHBOARD</p></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><div class=\"box-main-inicio\" id=\"createOTS\" ng-click=\"otCreatorModalEvent(1)\"><div class=\"box-inicio\"><p class=\"icon-inicio\"><i class=\"fa fa-paperclip\"></i></p></div><div class=\"box-inicio-footer\"><p class=\"text-inicio-footer\">CREAR OT/PÓLIZA</p></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><div class=\"box-main-inicio\" id=\"createOTS\" ui-sref=\"reportes.polizas\"><div class=\"box-inicio\"><p class=\"icon-inicio\"><i class=\"fa fa-folder-open\"></i></p></div><div class=\"box-inicio-footer\"><p class=\"text-inicio-footer\">REPORTE PÓLIZAS</p></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><div class=\"box-main-inicio\" id=\"createOTS\" ui-sref=\"help.manual\"><div class=\"box-inicio\"><p class=\"icon-inicio\"><i class=\"fa fa-question-circle\"></i></p></div><div class=\"box-inicio-footer\"><p class=\"text-inicio-footer\">AYUDA</p></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><div id=\"carousel-example-generic\" class=\"carousel slide\" data-interval=\"3000\"><ol class=\"carousel-indicators\"><li ng-repeat=\"item in carousel track by $index\" ng-class=\"{\'active\': $index === currentIndex}\" ng-click=\"goToSlide($index)\"></li></ol><div class=\"carousel-inner\" role=\"listbox\"><div class=\"item\" ng-repeat=\"item in carousel track by $index\" ng-class=\"{\'active\': $index === currentIndex}\"><div ng-if=\"item.visible == true || item.visible == \'true\'\"><img class=\"d-block w-100 carousel-image\" style=\"width: 100%;\" ng-src=\"{{item.imagen}}\" alt=\"{{$index + 1}}\"><div class=\"form-group carousel-caption col-6 col-md-6\" ng-if=\"item.description\"><div class=\"justify-content-center align-items-center rounded\"><div class=\"col-4 justify-content-center align-items-center\"><p>{{item.description | uppercase}}</p></div></div></div></div></div></div><a class=\"left carousel-control\" href=\"\" role=\"button\" ng-click=\"prevSlide()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a> <a class=\"right carousel-control\" href=\"\" role=\"button\" ng-click=\"nextSlide()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a></div></div></div>");
$templateCache.put("app/kbi/kbi.html","<toaster-container></toaster-container><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"row wrapper border-bottom white-bg page-heading\" ng-if=\"vm.orgName!=\'gpi\'\"><div class=\"col-xs-12 col-md-9\"><h2>KBI</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>KBI</a></li><li class=\"active\"><strong>KBI</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\" ng-if=\"vm.orgName!=\'gpi\'\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"exportDataExcel()\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Generar Reporte</button><br></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Año:</label><select class=\"form-control\" name=\"payment\" ng-model=\"year_kbi\" ng-options=\"year as year for year in charts_kbi.anios\" ng-change=\"vm.getFilter(1, year_kbi, startDate_production, endDate_production)\"><option value=\"\" disabled=\"\">Selecciona un año</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Moneda:</label><select class=\"form-control\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-3 form-group\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"show_tab_kbi(1)\">Financiero</button></div><div class=\"col-xs-12 col-sm-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"show_tab_kbi(2)\">Producción</button></div><div class=\"col-xs-12 col-sm-3 form-group\"><button class=\"btn btn-success col-xs-12\" ng-click=\"show_tab_kbi(3)\">Cotizaciones</button></div><div class=\"col-xs-12 col-sm-3 form-group\"><button class=\"btn btn-warning col-xs-12\" ng-click=\"show_tab_kbi(4)\">Gastos</button></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\"><span ng-if=\"show_financiero\">Financiero</span> <span ng-if=\"show_produccion\">Producción</span> <span ng-if=\"show_cotizacion\">Cotizaciones</span> <span ng-if=\"show_gastos\">Gastos</span> / {{ year_kbi }} / <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span></legend></div></div><div ng-if=\"show_financiero\"><div class=\"loader-kbi\" ng-if=\"showLoaderKbi\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><div class=\"row container-chart\" style=\"padding: 20px 0 10px\"><div class=\"col-xs-9\"><label>Recibos Pagados, Liquidados o Conciliados <span title=\"Total Prima neta de recibos Pagados, Liquidados o Conciliados con fecha de inicio de recibo del año seleccionado (Tipo Moneda)\"><i class=\"fa fa-question-circle\"></i></span></label><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataFinancial.data\" chart-labels=\"charts_kbi.chartDataFinancial.labels\" chart-colours=\"charts_kbi.chartDataFinancial.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataFinancial.series\" height=\"54\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataFinancialDolar.data\" chart-labels=\"charts_kbi.chartDataFinancialDolar.labels\" chart-colours=\"charts_kbi.chartDataFinancialDolar.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataFinancialDolar.series\" height=\"54\"></canvas></div></div><div class=\"col-xs-3\" style=\"padding: 40px 0 0\"><span>Primas por cobrar</span> <span title=\"Totales de Prima Total de recibos por cobrar que inicien vigencia en el año seleccionado(Endosos, Pólizas, Fianzas, SubGrupo, Pendiente de Pago, Prorrogadas, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.prima_cobrar | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.prima_cobrarDolar | currency }}</label><br><span>Comisión por recibir</span> <span title=\"Total Comisión de recibos pendientes por recibir con fecha de inicio de recibo del año seleccionado (Tipo Moneda, Pendiente Pago, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.prima_recibir | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.prima_recibirDolar | currency }}</label></div><div class=\"col-xs-12\"><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-9\"><label>Recibos Pagados, Liquidados o Conciliados <span title=\"Total Prima neta de recibos Pagados, Liquidados o Conciliados con fecha de inicio de recibo del año seleccionado (Tipo Moneda)\"><i class=\"fa fa-question-circle\"></i></span></label><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataFinancial_anterior.data\" chart-labels=\"charts_kbi.chartDataFinancial_anterior.labels\" chart-colours=\"charts_kbi.chartDataFinancial_anterior.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataFinancial_anterior.series\" height=\"54\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataFinancialDolar_anterior.data\" chart-labels=\"charts_kbi.chartDataFinancialDolar_anterior.labels\" chart-colours=\"charts_kbi.chartDataFinancialDolar_anterior.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataFinancialDolar_anterior.series\" height=\"54\"></canvas></div></div><div class=\"col-xs-3\" style=\"padding: 40px 0 0\"><span>Primas por cobrar</span> <span title=\"Totales de Prima Total de recibos por cobrar que inicien vigencia en el año seleccionado(Endosos, Pólizas, Fianzas, SubGrupo, Pendiente de Pago, Prorrogadas, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_prima_cobrar | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_prima_cobrarDolar | currency }}</label><br><span>Comisión por recibir</span> <span title=\"Total Comisión de recibos pendientes por recibir con fecha de inicio de recibo del año seleccionado (Tipo Moneda, Pendiente Pago, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_prima_recibir | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_prima_recibirDolar | currency }}</label></div></div><div class=\"row container-chart\" style=\"padding: 20px;\"><div class=\"col-xs-12\"><label>Subramos <span title=\"Totales de Prima Netas emitida por Subramo de pólizas con inicio de vigencia del año seleccionado (Tipo Moneda, SubRamo)\"><i class=\"fa fa-question-circle\"></i></span></label></div><div class=\"col-xs-3\"><label>Mes:</label><select class=\"form-control\" name=\"payment\" ng-model=\"month_old\" ng-options=\"item.id as item.month for item in months_kbi\" ng-change=\"dataMonth(month_old, year_old, month_new, year_new)\"><option value=\"\" disabled=\"\" selected=\"\">Todo el año</option></select></div><div class=\"col-xs-3\"><label>Año:</label><select class=\"form-control\" name=\"payment\" ng-model=\"year_old\" ng-options=\"year.id as year.year for year in anios_kbi\" ng-change=\"dataMonth(month_old, year_old, month_new, year_new)\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-3\"><label>Mes Comparación:</label><select class=\"form-control\" name=\"payment\" ng-model=\"month_old\" ng-options=\"item.id as item.month for item in months_kbi\" ng-change=\"dataMonth(month_old, year_old, month_new, year_new)\" ng-disabled=\"true\"><option value=\"\" disabled=\"\" selected=\"\">Todo el año</option></select></div><div class=\"col-xs-3\"><label>Año Comparación:</label><select class=\"form-control\" name=\"payment\" ng-model=\"year_new\" ng-options=\"year.id as year.year for year in anios_kbi\" ng-change=\"dataMonth(month_old, year_old, month_new, year_new)\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-3\"><button class=\"btn btn-success col-xs-12 m-t\" ng-click=\"monthComparative()\">Comparar</button></div><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.polarDataFinancial.data\" chart-labels=\"charts_kbi.polarDataFinancial.labels\" chart-colours=\"charts_kbi.polarDataFinancial.colours\" height=\"120\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.polarDataFinancialDolar.data\" chart-labels=\"charts_kbi.polarDataFinancialDolar.labels\" chart-colours=\"charts_kbi.polarDataFinancial.colours\" height=\"120\"></canvas></div></div><div class=\"row container-chart\"><div class=\"col-xs-4\" style=\"background-color: #884EA0; color: #ffffff;\"><span>Comisión neta del año</span> <span title=\"Total de Comisiones de recibos Liquidado, Conciliado, Pagado con fecha de inicio de recibo del año seleccionado (Tipo de Moneda, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.comision | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.comisionDolar | currency }}</label></div><div class=\"col-xs-4\" style=\"background-color: #5DADE2; color: #ffffff;\"><span>Notas de crédito sobre prima total</span> <span title=\"Totales de Prima Total de notas de crédito con fecha de inicio de recibo del año seleccionado (Excluye recibos con estatus cerrados, cancelados)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.notas_credito | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.notas_creditoDolar | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"!charts_kbi.notas_credito\">{{ 0 | currency }}</label></div><div class=\"col-xs-4\" style=\"background-color: #F1C40F; color: #ffffff;\"><span>Recibos pagados sobre prima neta</span> <span title=\"Totales de Prima Neta de recibos pagados, liquidado, conciliado con fecha de inicio de recibo del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.recibos_pagados | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.recibos_pagadosDolar | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"!charts_kbi.recibos_pagados\">{{ 0 | currency }}</label></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-4\" style=\"background-color: #D4D4D4; color: #ffffff;\"><span>Comisión neta del año</span> <span title=\"Total de Comisiones de recibos Liquidado, Conciliado, Pagado con fecha de inicio de recibo del año seleccionado (Tipo de Moneda, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_comision | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_comisionDolar | currency }}</label></div><div class=\"col-xs-4\" style=\"background-color: #D4D4D4; color: #ffffff;\"><span>Notas de crédito sobre prima total</span> <span title=\"Totales de Prima Total de notas de crédito con fecha de inicio de recibo del año seleccionado (Excluye recibos con estatus cerrados, cancelados)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_notas_credito | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_notas_creditoDolar | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"!charts_kbi.notas_credito\">{{ 0 | currency }}</label></div><div class=\"col-xs-4\" style=\"background-color: #D4D4D4; color: #ffffff;\"><span>Recibos pagados sobre prima neta</span> <span title=\"Totales de Prima Neta de recibos pagados, liquidado, conciliado con fecha de inicio de recibo del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_recibos_pagados | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_recibos_pagadosDolar | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"!charts_kbi.recibos_pagados\">{{ 0 | currency }}</label></div></div></div><div ng-if=\"show_produccion\"><div class=\"loader-kbi\" ng-if=\"showLoaderKbi\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><div class=\"row container-chart\"><br><div class=\"col-xs-6\"><label>Meta a Registrar</label> <input type=\"number\" class=\"form-control\" ng-model=\"newGoal.value\" ng-change=\"validateDecimal(newGoal.value)\"></div><div class=\"col-xs-3 form-group\" style=\"margin-top: 23px;\"><select class=\"form-control\" ng-model=\"newGoal.model\"><option ng-repeat=\"option in newGoal.options\" value=\"{{option.id}}\">{{ option.name }}</option></select></div><div class=\"col-xs-3 form-group\" style=\"margin-top: 23px;\"><button class=\"col-xs-12 btn btn-primary\" ng-if=\"!showBtnKbi\" ng-click=\"saveGoal()\" ng-disabled=\"!newGoal.value\">Guardar</button> <button class=\"col-xs-12 btn btn-primary\" ng-if=\"showBtnKbi\" ng-click=\"editGoal()\" ng-disabled=\"!newGoal.value\">Editar</button></div><br><div class=\"col-xs-4\"><label>Meta: {{ charts_kbi.goal.value | currency }} {{ charts_kbi.goal.currency }}</label></div><div class=\"col-xs-4\"><label>Actual: {{ charts_kbi.goal.progress | currency }} {{ charts_kbi.goal.currency }}</label></div><div class=\"col-xs-4\"><label>Faltan: {{ charts_kbi.goal.remain | currency }} {{ charts_kbi.goal.currency }}</label><div class=\"col-xs-4 pull-right\"><span title=\"Monto Faltante para cumplir Meta del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-12\"><div class=\"progress\" style=\"height: 32px;\"><div class=\"progress-bar bar-goal animate\" role=\"progressbar\" ng-style=\"progressGoal\" aria-valuemin=\"0\" aria-valuemax=\"100\"><label>{{ charts_kbi.goal.percentajeGoal }}%</label></div></div></div></div><div class=\"row container-chart\"><div class=\"col-xs-6\"><span>Total de Primas de Pólizas canceladas de póliza</span> <span title=\"Total de primas netas de pólizas Canceladas, PreCanceladas\"><i class=\"fa fa-question-circle\"></i></span> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label class=\"lbl-tableros\" ng-if=\"show_currency_mxn\">{{ charts_kbi.primas_canceladas | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"show_currency_usd\">{{ charts_kbi.primas_canceladasDolar | currency }}</label></div><div class=\"col-xs-6\"><span>Comisión perdida por notas de crédito</span> <span title=\"Total de Comisión de recibos de Notas de crédito (Cancelados, PreCanceladas del año seleccionado)\"><i class=\"fa fa-question-circle\"></i></span> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.comision_perdida | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.comision_perdidaDolar | currency }}</label></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-6\" style=\"background-color: #D4D4D4; color: #ffffff;\"><span>Total de Primas de Pólizas canceladas de póliza</span> <span title=\"Total de primas netas de pólizas Canceladas, PreCanceladas\"><i class=\"fa fa-question-circle\"></i></span> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label class=\"lbl-tableros\" ng-if=\"show_currency_mxn\">{{ charts_kbi.anterior_primas_canceladas | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"show_currency_usd\">{{ charts_kbi.anterior_primas_canceladasDolar | currency }}</label></div><div class=\"col-xs-6\" style=\"background-color: #D4D4D4; color: #ffffff;\"><span>Comisión perdida por notas de crédito</span> <span title=\"Total de Comisión de recibos de Notas de crédito (Cancelados, PreCanceladas del año seleccionado)\"><i class=\"fa fa-question-circle\"></i></span> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_comision_perdida | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_comision_perdidaDolar | currency }}</label></div></div><div class=\"row container-chart\"><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #5DADE2;\"><i class=\"fa fa-user\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Contratantes</span><br><label class=\"lbl-tableros\">{{ charts_kbi.contratantes }}</label> <span title=\"Totales de contratantes datos de alta en SAAM del año seleccionado(Físicas, Morales)\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #27AE60;\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Pólizas/Fianzas</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.polizas }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.polizasDolar }}</label> <span title=\"Total de pólizas y fianzas registradas en SAAM del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #F1C40F;\"><i class=\"fa fa-file\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>OT proceso</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.ot }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.otDolar }}</label> <span title=\"Total de OT proceso del año seleccionado Endosos (Pendiente, Tramite), OT de Poliza (Pendientes, Trámite)\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #E67E22;\"><i class=\"fa fa-folder\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Endosos</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.endosos }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.endososDolar }}</label> <span title=\"Total de Endosos del año seleccionado (Todos los estatus)\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #BDC3C7;\"><i class=\"fa fa-bookmark\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Renovaciones</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.renovaciones }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.renovacionesDolar }}</label> <span title=\"Total de Renovaciones del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #9B59B6;\"><i class=\"fa fa-certificate\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Siniestros</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.siniestros }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.siniestrosDolar }}</label> <span title=\"Total de Siniestros registrados del año seleccionado (fecha de ingreso de siniestros y/o actualización)\"><i class=\"fa fa-question-circle\"></i></span></div></div></div><div class=\"row container-chart\" style=\"padding: 10px;\"><div class=\"col-xs-6\"><label>Comisiones <span title=\"Total de Comisiones de recibos Liquidado, Conciliado, Pagado con fecha de inicio de recibo del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></label> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataProduction.data\" chart-labels=\"charts_kbi.barDataProduction.labels\" chart-colours=\"charts_kbi.barDataProduction.colours\" height=\"110\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataProductionDolar.data\" chart-labels=\"charts_kbi.barDataProductionDolar.labels\" chart-colours=\"charts_kbi.barDataProductionDolar.colours\" height=\"110\"></canvas></div></div><div class=\"col-xs-6 border-left\"><label>Fecha:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" style=\"display: inline-block; margin-bottom: 6px;\"><input type=\"text\" name=\"startDate\" class=\"text-align-center form-control\" ng-model=\"startDate_production\" value=\"{{startDate_production}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\" style=\"display: none;\"><i class=\"fa fa-calendar\"></i></span></div><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" style=\"display: inline-block; margin-bottom: 6px;\"><input type=\"text\" name=\"endingDate\" class=\"text-align-center form-control\" ng-model=\"endDate_production\" value=\"{{endDate_production}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\" style=\"display: none;\"><i class=\"fa fa-calendar\"></i></span></div><button class=\"btn btn-primary\" style=\"margin: -40px 0 0 0;\" ng-click=\"vm.getFilter(1, year_kbi, startDate_production, endDate_production)\" ng-disabled=\"showLoaderKbi\">Aplicar</button><div class=\"loader-kbi\" ng-if=\"showLoaderKbi\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span><ul class=\"tab-kbi-prodution\"><li ng-class=\"{ \'active-kbi\': show_ejectivo }\" ng-click=\"show_tab_production(1)\">Ejecutivos</li><li ng-class=\"{ \'active-kbi\': show_aseguradora }\" ng-click=\"show_tab_production(2)\">Aseguradoras</li><li ng-class=\"{ \'active-kbi\': show_subramo }\" ng-click=\"show_tab_production(3)\">Subramos</li></ul><div ng-if=\"show_ejectivo\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Ejecutivo</th><th>Acciones</th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"user in charts_kbi.ejecutivos\" ng-if=\"show_currency_mxn\"><td>{{ user.user__first_name }} {{ user.user__last_name }}</td><td>{{ user.user__count }}</td></tr><tr class=\"row-list\" ng-repeat=\"user in charts_kbi.ejecutivosDolar\" ng-if=\"show_currency_usd\"><td>{{ user.user__first_name }} {{ user.user__last_name }}</td><td>{{ user.user__count }}</td></tr></tbody></table></div></div><div ng-if=\"show_aseguradora\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Aseguradora</th><th>Emitida <span title=\"Total de Prima Neta de pólizas por aseguradora del rango fecha seleccionado\"><i class=\"fa fa-question-circle\"></i></span></th><th>Pagada <span title=\"Totales de Prima Neta de recibos pagados por aseguradora de la fecha seleccionada (Pagado, liquidado o conciliado)\"><i class=\"fa fa-question-circle\"></i></span></th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.aseguradoras\" ng-if=\"item.aseguradora__alias && show_currency_mxn\"><td>{{ item.aseguradora__alias }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.aseguradorasDolar\" ng-if=\"item.aseguradora__alias && show_currency_usd\"><td>{{ item.aseguradora__alias }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr></tbody></table></div></div><div ng-if=\"show_subramo\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Subramo</th><th>Emitida <span title=\"Totales de Prima Neta emitida de pólizas por SubRamo de fecha seleccionada (Aseguradora)\"><i class=\"fa fa-question-circle\"></i></span></th><th>Pagada <span title=\"Totales de Prima Neta de recibos pagados por SubRamo de fecha seleccionada (pagado, Liquidado, Conciliado, Subramo)\"><i class=\"fa fa-question-circle\"></i></span></th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.subramos\" ng-if=\"item.subramo__subramo_name && show_currency_mxn\"><td>{{ item.subramo__subramo_name }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.subramosDolar\" ng-if=\"item.subramo__subramo_name && show_currency_usd\"><td>{{ item.subramo__subramo_name }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr></tbody></table></div></div></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-6\"><label>Comisiones <span title=\"Total de Comisiones de recibos Liquidado, Conciliado, Pagado con fecha de inicio de recibo del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></label> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataProduction_anterior.data\" chart-labels=\"charts_kbi.barDataProduction_anterior.labels\" chart-colours=\"charts_kbi.barDataProduction_anterior.colours\" height=\"110\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataProductionDolar_anterior.data\" chart-labels=\"charts_kbi.barDataProductionDolar_anterior.labels\" chart-colours=\"charts_kbi.barDataProductionDolar_anterior.colours\" height=\"110\"></canvas></div></div><div class=\"col-xs-6 border-left\"><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span><ul class=\"tab-kbi-prodution\"><li ng-class=\"{ \'active-kbi\': show_ejectivo }\" ng-click=\"show_tab_production(1)\">Ejecutivos</li><li ng-class=\"{ \'active-kbi\': show_aseguradora }\" ng-click=\"show_tab_production(2)\">Aseguradoras</li><li ng-class=\"{ \'active-kbi\': show_subramo }\" ng-click=\"show_tab_production(3)\">Subramos</li></ul><div ng-if=\"show_ejectivo\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Ejecutivo*</th><th>Acciones</th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"user in charts_kbi.anterior_ejecutivos track by $index\" ng-if=\"show_currency_mxn\"><td>{{ user.user__first_name }} {{ user.user__last_name }}</td><td>{{ user.user__count }}</td></tr><tr class=\"row-list\" ng-repeat=\"user in charts_kbi.anterior_ejecutivosDolar track by $index\" ng-if=\"show_currency_usd\"><td>{{ user.user__first_name }} {{ user.user__last_name }}</td><td>{{ user.user__count }}</td></tr></tbody></table></div></div><div ng-if=\"show_aseguradora\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Aseguradora</th><th>Emitida <span title=\"Total de Prima Neta de pólizas por aseguradora del rango fecha seleccionado\"><i class=\"fa fa-question-circle\"></i></span></th><th>Pagada <span title=\"Totales de Prima Neta de recibos pagados por aseguradora de la fecha seleccionada (Pagado, liquidado o conciliado)\"><i class=\"fa fa-question-circle\"></i></span></th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.anterior_aseguradoras track by $index\" ng-if=\"item.aseguradora__alias && show_currency_mxn\"><td>{{ item.aseguradora__alias }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.anterior_aseguradorasDolar track by $index\" ng-if=\"item.aseguradora__alias && show_currency_usd\"><td>{{ item.aseguradora__alias }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr></tbody></table></div></div><div ng-if=\"show_subramo\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Subramo</th><th>Emitida <span title=\"Totales de Prima Neta emitida de pólizas por SubRamo de fecha seleccionada (Aseguradora)\"><i class=\"fa fa-question-circle\"></i></span></th><th>Pagada <span title=\"Totales de Prima Neta de recibos pagados por SubRamo de fecha seleccionada (pagado, Liquidado, Conciliado, Subramo)\"><i class=\"fa fa-question-circle\"></i></span></th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.anterior_subramos track by $index\" ng-if=\"item.subramo__subramo_name && show_currency_mxn\"><td>{{ item.subramo__subramo_name }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.anterior_subramosDolar track by $index\" ng-if=\"item.subramo__subramo_name && show_currency_usd\"><td>{{ item.subramo__subramo_name }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr></tbody></table></div></div></div></div></div><div ng-if=\"show_cotizacion\"><div class=\"row container-chart\" style=\"padding: 10px;\"><div class=\"col-xs-9\"><label>Cotizaciones</label> <span title=\"Total de cotizaciones realizadas en el año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><div ng-if=\"show_for == \'1\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotization.data\" chart-labels=\"charts_kbi.barDataCotization.labels\" chart-colours=\"charts_kbi.barDataCotization.colours\" height=\"80\"></canvas></div><div ng-if=\"show_for == \'2\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotizationRamo.data\" chart-labels=\"charts_kbi.barDataCotizationRamo.labels\" chart-colours=\"charts_kbi.barDataCotizationRamo.colours\" height=\"80\"></canvas></div><div ng-if=\"show_for == \'3\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotizacionSubramo.data\" chart-labels=\"charts_kbi.barDataCotizacionSubramo.labels\" chart-colours=\"charts_kbi.barDataCotizacionSubramo.colours\" height=\"80\"></canvas></div></div><div class=\"col-xs-3\"><label>Ver por:</label><br><select class=\"form-control\" name=\"payment\" ng-model=\"show_for\" ng-options=\"item.id as item.name for item in options\" ng-change=\"verpor(show_for)\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select><br><span>No. de cotizaciones</span><br><label class=\"lbl-tableros\">{{ charts_kbi.cotizaciones }}</label></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-9\"><label>Cotizaciones</label> <span title=\"Total de cotizaciones realizadas en el año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><div ng-if=\"show_for == \'1\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotization_anterior.data\" chart-labels=\"charts_kbi.barDataCotization_anterior.labels\" chart-colours=\"charts_kbi.barDataCotization_anterior.colours\" height=\"80\"></canvas></div><div ng-if=\"show_for == \'2\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotizationRamo_anterior.data\" chart-labels=\"charts_kbi.barDataCotizationRamo_anterior.labels\" chart-colours=\"charts_kbi.barDataCotizationRamo_anterior.colours\" height=\"80\"></canvas></div><div ng-if=\"show_for == \'3\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotizacionSubramo_anterior.data\" chart-labels=\"charts_kbi.barDataCotizacionSubramo_anterior.labels\" chart-colours=\"charts_kbi.barDataCotizacionSubramo_anterior.colours\" height=\"80\"></canvas></div></div><div class=\"col-xs-3\"><span>No. de cotizaciones</span><br><label class=\"lbl-tableros\">{{ charts_kbi.anterior_cotizaciones }}</label></div></div><div class=\"row container-chart\"><div class=\"col-xs-3\" style=\"padding: 10px;\"><label>Bateo: {{ charts_kbi.bateo}}%</label> <span title=\"Porcentaje Total de cotizaciones bateadas en el año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><div class=\"box-scroll-cotization\"><ul class=\"list-cotization\" ng-repeat=\"item in charts_kbi.monthsBateo\"><li>{{ item.month }} <span class=\"pull-right\">{{ item.value }}</span></li></ul></div></div><div class=\"col-xs-9\" style=\"padding: 10px;\"><label>Cotización y Emisión</label><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataCotization.data\" chart-labels=\"charts_kbi.chartDataCotization.labels\" chart-colours=\"charts_kbi.chartDataCotization.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataCotization.series\" height=\"70\"></canvas></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-3\" style=\"padding: 10px;\"><label>Bateo: {{ charts_kbi.anterior_bateo}}%</label> <span title=\"Porcentaje Total de cotizaciones bateadas en el año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><div class=\"box-scroll-cotization\"><ul class=\"list-cotization\" ng-repeat=\"item in charts_kbi.monthsBateo_anterior\"><li>{{ item.month }} <span class=\"pull-right\">{{ item.value }}</span></li></ul></div></div><div class=\"col-xs-9\" style=\"padding: 10px;\"><label>Cotización y Emisión</label><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataCotization_anterior.data\" chart-labels=\"charts_kbi.chartDataCotization_anterior.labels\" chart-colours=\"charts_kbi.chartDataCotization_anterior.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataCotization_anterior.series\" height=\"70\"></canvas></div></div></div><div ng-if=\"show_gastos\"><div class=\"row container-chart\"><div class=\"col-xs-8\"><div class=\"concept-scroll\"><div class=\"col-xs-6\"><label>Mes</label><select class=\"form-control\" name=\"payment\" ng-model=\"vm.month_kbi\" ng-options=\"month as month.month for month in months_kbi track by month.id\" ng-change=\"selectMonth(vm.month_kbi)\"><option value=\"\" disabled=\"\">Selecciona un mes</option></select></div><div class=\"col-xs-3\" style=\"margin-top: 23px;\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"saveGastos()\">Guardar</button></div><div class=\"col-xs-3\" style=\"margin-top: 23px;\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"addConcept()\">Agregar concepto</button></div><div class=\"col-xs-12\"></div><div ng-repeat=\"concept in concepts track by $index\"><div class=\"col-xs-6\"><label>Concepto</label> <input class=\"form-control\" type=\"text\" ng-model=\"concept.concept\" name=\"\"></div><div class=\"col-xs-3\"><label>Gasto</label> <input class=\"form-control\" type=\"number\" ng-model=\"concept.cantidad\" ng-change=\"validateGasto(concept.cantidad)\" name=\"\"></div><div class=\"col-xs-3\" style=\"margin-top: 23px;\" ng-if=\"concept.value > 9\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"removeConcept($index)\">Quitar concepto</button></div></div></div></div><div class=\"col-xs-4\" ng-if=\"charts_kbi.barDataGastos.concepts.length > 0\"><div class=\"box-scroll\"><br><table class=\"list-production\"><thead><tr><th>Mes</th><th>Concepto</th><th>Cantidad</th><th></th></tr></thead><tbody><tr ng-repeat=\"item_conc in charts_kbi.barDataGastos.concepts | orderBy: \'month\' track by $index\"><td><span>{{monthName(item_conc.month)}}</span></td><td><span>{{item_conc.concept}}</span></td><td><span>{{item_conc.cantidad | currency}}</span></td><td><span ng-click=\"deleteConcept(item_conc, $index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></span></td></tr></tbody></table></div></div></div><div class=\"row container-chart\"><div class=\"col-xs-8\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataGastos.data\" chart-labels=\"charts_kbi.barDataGastos.labels\" chart-colours=\"charts_kbi.barDataGastos.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.barDataGastos.series\" height=\"100\"></canvas></div><div class=\"col-xs-4\"><label>Tipo de cambio:</label> <input class=\"form-control\" type=\"text\" ng-model=\"tipo_cambio\"> <button class=\"btn btn-primary btn-sm\" ng-click=\"saveTipoCambio(tipo_cambio)\"><i class=\"fa fa-save\" aria-hidden=\"true\" ng-disabled=\"showLoaderKbi\"></i></button><div class=\"loader-kbi\" ng-if=\"showLoaderKbi\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><div class=\"box-scroll\"><br><table class=\"list-production\"><thead><tr><th>Utilidad<span title=\"Total de comision en el año seleccionado: {{total_utilidad | currency }}\"><i class=\"fa fa-question-circle\"></i></span></th><th>Comisiones MXN/USD</th></tr></thead><tbody><tr ng-repeat=\"item_uti in charts_kbi.monthsUtilidad track by $index\"><td><span>{{item_uti.month}}</span></td><td><span>{{item_uti.value | currency}}</span></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-8\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataGastos_anterior.data\" chart-labels=\"charts_kbi.barDataGastos_anterior.labels\" chart-colours=\"charts_kbi.barDataGastos_anterior.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.barDataGastos_anterior.series\" height=\"100\"></canvas></div><div class=\"col-xs-4\"><br><div class=\"box-scroll\"><br><table class=\"list-production\"><thead><tr><th>Utilidad<span title=\"Total de comision en el año seleccionado: {{total_utilidad_ant | currency }}\"><i class=\"fa fa-question-circle\"></i></span></th><th>Comisiones MXN/USD</th></tr></thead><tbody><tr ng-repeat=\"item_uti in charts_kbi.monthsUtilidad_anterior track by $index\"><td><span>{{item_uti.month}}</span></td><td><span>{{item_uti.value | currency}}</span></td></tr></tbody></table></div></div></div></div></div><script type=\"text/javascript\" ng-if=\"vm.orgName!=\'gpi\'\">\n  setTimeout(function(){ if(document.getElementById(\"box-kbi\")){document.getElementById(\"box-kbi\").style.width = \"0px\"; }}, 10);\n  var clic = 1;\n  function divLogin(){\n    if(clic==1){\n      angular.element(document.getElementById(\'box-kbi\')).scope().getFilter(0);\n      document.getElementById(\"box-kbi\").style.width = \"1100px\";\n      clic = clic + 1;\n    } else{\n      document.getElementById(\"box-kbi\").style.width = \"0px\";      \n      clic = 1;\n    }   \n  }\n</script><toaster-container></toaster-container><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"row wrapper border-bottom white-bg page-heading\" ng-if=\"vm.orgName==\'gpi\'\"><div class=\"col-xs-12 col-md-9\"><h2>KBI</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>KBI</a></li><li class=\"active\"><strong>KBI</strong></li></ol></div></div><div ng-if=\"vm.orgName==\'gpi\'\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> La <b>información</b> ha sido actualizada con <b>datos</b> correspondientes al <b>cierre</b> de <b>ayer</b>.</div><div class=\"wrapper wrapper-content animated fadeIn ng-scope kbis\"><iframe title=\"gpi-final\" width=\"1200\" height=\"700\" src=\"https://app.powerbi.com/view?r=eyJrIjoiOGNlOWZlMDItZDhmZC00YmFjLWJmMzYtMWYwNGI4NGNhZTc3IiwidCI6ImM4NTZjZDM4LWMyNDItNGJkOC1hNDAyLTI2NGQ3ZTNjMWNhMyJ9\" frameborder=\"0\" allowfullscreen=\"true\"></iframe></div></div><script type=\"text/javascript\" ng-if=\"vm.orgName==\'gpi\'\"> \n  setTimeout(function(){ if(document.getElementById(\"box-kbi\")){document.getElementById(\"box-kbi\").style.width = \"0px\"; }}, 10);\n  var clic = 1;\n  function divLogin(){\n    if(clic==1){\n      angular.element(document.getElementById(\'box-kbi\')).scope().getFilter(0);\n      document.getElementById(\"box-kbi\").style.width = \"1100px\";\n      clic = clic + 1;\n    } else{\n      document.getElementById(\"box-kbi\").style.width = \"0px\";      \n      clic = 1;\n    }   \n  }\n</script>");
$templateCache.put("app/kbi/kbi.modal.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Reporte por</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"row\"><div class=\"row\"><div class=\"col-xs-12 form-group text-center\"><label for=\"selectType\" align=\"center\">Elija una opción:</label><br><hr></div><div class=\"col-xs-12 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"financiero\" ng-change=\"checkReport(financiero)\">Financiero</label></div><div class=\"col-xs-12 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"produccion\" ng-change=\"checkReport(produccion)\">Producción</label></div><div class=\"col-xs-12 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"cotizaciones\" ng-change=\"checkReport(cotizaciones)\">Cotizaciones</label></div><div class=\"col-xs-12 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"gastos\" ng-change=\"checkReport(gastos)\">Gastos</label></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-primary ladda-button\" ng-click=\"downloadReport(optionSent)\">Generar reporte</button></div></div>");
$templateCache.put("app/kbi/kbi_.html","<toaster-container></toaster-container><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>KBI</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>KBI</a></li><li class=\"active\"><strong>KBI</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"exportDataExcel()\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Generar Reporte</button><br></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Año:</label><select class=\"form-control\" name=\"payment\" ng-model=\"year_kbi\" ng-options=\"year as year for year in charts_kbi.anios\" ng-change=\"vm.getFilter(1, year_kbi, startDate_production, endDate_production)\"><option value=\"\" disabled=\"\">Selecciona un año</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Moneda:</label><select class=\"form-control\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-3 form-group\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"show_tab_kbi(1)\">Financiero</button></div><div class=\"col-xs-12 col-sm-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"show_tab_kbi(2)\">Producción</button></div><div class=\"col-xs-12 col-sm-3 form-group\"><button class=\"btn btn-success col-xs-12\" ng-click=\"show_tab_kbi(3)\">Cotizaciones</button></div><div class=\"col-xs-12 col-sm-3 form-group\"><button class=\"btn btn-warning col-xs-12\" ng-click=\"show_tab_kbi(4)\">Gastos</button></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\"><span ng-if=\"show_financiero\">Financiero</span> <span ng-if=\"show_produccion\">Producción</span> <span ng-if=\"show_cotizacion\">Cotizaciones</span> <span ng-if=\"show_gastos\">Gastos</span> / {{ year_kbi }} / <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span></legend></div></div><div ng-if=\"show_financiero\"><div class=\"loader-kbi\" ng-if=\"showLoaderKbi\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><div class=\"row container-chart\" style=\"padding: 20px 0 10px\"><div class=\"col-xs-9\"><label>Recibos Pagados, Liquidados o Conciliados <span title=\"Total Prima neta de recibos Pagados, Liquidados o Conciliados con fecha de inicio de recibo del año seleccionado (Tipo Moneda)\"><i class=\"fa fa-question-circle\"></i></span></label><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataFinancial.data\" chart-labels=\"charts_kbi.chartDataFinancial.labels\" chart-colours=\"charts_kbi.chartDataFinancial.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataFinancial.series\" height=\"54\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataFinancialDolar.data\" chart-labels=\"charts_kbi.chartDataFinancialDolar.labels\" chart-colours=\"charts_kbi.chartDataFinancialDolar.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataFinancialDolar.series\" height=\"54\"></canvas></div></div><div class=\"col-xs-3\" style=\"padding: 40px 0 0\"><span>Primas por cobrar</span> <span title=\"Totales de Prima Total de recibos por cobrar que inicien vigencia en el año seleccionado(Endosos, Pólizas, Fianzas, SubGrupo, Pendiente de Pago, Prorrogadas, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.prima_cobrar | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.prima_cobrarDolar | currency }}</label><br><span>Comisión por recibir</span> <span title=\"Total Comisión de recibos pendientes por recibir con fecha de inicio de recibo del año seleccionado (Tipo Moneda, Pendiente Pago, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.prima_recibir | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.prima_recibirDolar | currency }}</label></div><div class=\"col-xs-12\"><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-9\"><label>Recibos Pagados, Liquidados o Conciliados <span title=\"Total Prima neta de recibos Pagados, Liquidados o Conciliados con fecha de inicio de recibo del año seleccionado (Tipo Moneda)\"><i class=\"fa fa-question-circle\"></i></span></label><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataFinancial_anterior.data\" chart-labels=\"charts_kbi.chartDataFinancial_anterior.labels\" chart-colours=\"charts_kbi.chartDataFinancial_anterior.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataFinancial_anterior.series\" height=\"54\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataFinancialDolar_anterior.data\" chart-labels=\"charts_kbi.chartDataFinancialDolar_anterior.labels\" chart-colours=\"charts_kbi.chartDataFinancialDolar_anterior.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataFinancialDolar_anterior.series\" height=\"54\"></canvas></div></div><div class=\"col-xs-3\" style=\"padding: 40px 0 0\"><span>Primas por cobrar</span> <span title=\"Totales de Prima Total de recibos por cobrar que inicien vigencia en el año seleccionado(Endosos, Pólizas, Fianzas, SubGrupo, Pendiente de Pago, Prorrogadas, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_prima_cobrar | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_prima_cobrarDolar | currency }}</label><br><span>Comisión por recibir</span> <span title=\"Total Comisión de recibos pendientes por recibir con fecha de inicio de recibo del año seleccionado (Tipo Moneda, Pendiente Pago, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_prima_recibir | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_prima_recibirDolar | currency }}</label></div></div><div class=\"row container-chart\" style=\"padding: 20px;\"><div class=\"col-xs-12\"><label>Subramos <span title=\"Totales de Prima Netas emitida por Subramo de pólizas con inicio de vigencia del año seleccionado (Tipo Moneda, SubRamo)\"><i class=\"fa fa-question-circle\"></i></span></label></div><div class=\"col-xs-3\"><label>Mes:</label><select class=\"form-control\" name=\"payment\" ng-model=\"month_old\" ng-options=\"item.id as item.month for item in months_kbi\" ng-change=\"dataMonth(month_old, year_old, month_new, year_new)\"><option value=\"\" disabled=\"\" selected=\"\">Todo el año</option></select></div><div class=\"col-xs-3\"><label>Año:</label><select class=\"form-control\" name=\"payment\" ng-model=\"year_old\" ng-options=\"year.id as year.year for year in anios_kbi\" ng-change=\"dataMonth(month_old, year_old, month_new, year_new)\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-3\"><label>Mes Comparación:</label><select class=\"form-control\" name=\"payment\" ng-model=\"month_old\" ng-options=\"item.id as item.month for item in months_kbi\" ng-change=\"dataMonth(month_old, year_old, month_new, year_new)\" ng-disabled=\"true\"><option value=\"\" disabled=\"\" selected=\"\">Todo el año</option></select></div><div class=\"col-xs-3\"><label>Año Comparación:</label><select class=\"form-control\" name=\"payment\" ng-model=\"year_new\" ng-options=\"year.id as year.year for year in anios_kbi\" ng-change=\"dataMonth(month_old, year_old, month_new, year_new)\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-3\"><button class=\"btn btn-success col-xs-12 m-t\" ng-click=\"monthComparative()\">Comparar</button></div><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.polarDataFinancial.data\" chart-labels=\"charts_kbi.polarDataFinancial.labels\" chart-colours=\"charts_kbi.polarDataFinancial.colours\" height=\"120\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.polarDataFinancialDolar.data\" chart-labels=\"charts_kbi.polarDataFinancialDolar.labels\" chart-colours=\"charts_kbi.polarDataFinancial.colours\" height=\"120\"></canvas></div></div><div class=\"row container-chart\"><div class=\"col-xs-4\" style=\"background-color: #884EA0; color: #ffffff;\"><span>Comisión neta del año</span> <span title=\"Total de Comisiones de recibos Liquidado, Conciliado, Pagado con fecha de inicio de recibo del año seleccionado (Tipo de Moneda, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.comision | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.comisionDolar | currency }}</label></div><div class=\"col-xs-4\" style=\"background-color: #5DADE2; color: #ffffff;\"><span>Notas de crédito sobre prima total</span> <span title=\"Totales de Prima Total de notas de crédito con fecha de inicio de recibo del año seleccionado (Excluye recibos con estatus cerrados, cancelados)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.notas_credito | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.notas_creditoDolar | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"!charts_kbi.notas_credito\">{{ 0 | currency }}</label></div><div class=\"col-xs-4\" style=\"background-color: #F1C40F; color: #ffffff;\"><span>Recibos pagados sobre prima neta</span> <span title=\"Totales de Prima Neta de recibos pagados, liquidado, conciliado con fecha de inicio de recibo del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.recibos_pagados | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.recibos_pagadosDolar | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"!charts_kbi.recibos_pagados\">{{ 0 | currency }}</label></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-4\" style=\"background-color: #D4D4D4; color: #ffffff;\"><span>Comisión neta del año</span> <span title=\"Total de Comisiones de recibos Liquidado, Conciliado, Pagado con fecha de inicio de recibo del año seleccionado (Tipo de Moneda, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_comision | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_comisionDolar | currency }}</label></div><div class=\"col-xs-4\" style=\"background-color: #D4D4D4; color: #ffffff;\"><span>Notas de crédito sobre prima total</span> <span title=\"Totales de Prima Total de notas de crédito con fecha de inicio de recibo del año seleccionado (Excluye recibos con estatus cerrados, cancelados)\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_notas_credito | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_notas_creditoDolar | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"!charts_kbi.notas_credito\">{{ 0 | currency }}</label></div><div class=\"col-xs-4\" style=\"background-color: #D4D4D4; color: #ffffff;\"><span>Recibos pagados sobre prima neta</span> <span title=\"Totales de Prima Neta de recibos pagados, liquidado, conciliado con fecha de inicio de recibo del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><br><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_recibos_pagados | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_recibos_pagadosDolar | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"!charts_kbi.recibos_pagados\">{{ 0 | currency }}</label></div></div></div><div ng-if=\"show_produccion\"><div class=\"loader-kbi\" ng-if=\"showLoaderKbi\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><div class=\"row container-chart\"><br><div class=\"col-xs-6\"><label>Meta a Registrar</label> <input type=\"number\" class=\"form-control\" ng-model=\"newGoal.value\" ng-change=\"validateDecimal(newGoal.value)\"></div><div class=\"col-xs-3 form-group\" style=\"margin-top: 23px;\"><select class=\"form-control\" ng-model=\"newGoal.model\"><option ng-repeat=\"option in newGoal.options\" value=\"{{option.id}}\">{{ option.name }}</option></select></div><div class=\"col-xs-3 form-group\" style=\"margin-top: 23px;\"><button class=\"col-xs-12 btn btn-primary\" ng-if=\"!showBtnKbi\" ng-click=\"saveGoal()\" ng-disabled=\"!newGoal.value\">Guardar</button> <button class=\"col-xs-12 btn btn-primary\" ng-if=\"showBtnKbi\" ng-click=\"editGoal()\" ng-disabled=\"!newGoal.value\">Editar</button></div><br><div class=\"col-xs-4\"><label>Meta: {{ charts_kbi.goal.value | currency }} {{ charts_kbi.goal.currency }}</label></div><div class=\"col-xs-4\"><label>Actual: {{ charts_kbi.goal.progress | currency }} {{ charts_kbi.goal.currency }}</label></div><div class=\"col-xs-4\"><label>Faltan: {{ charts_kbi.goal.remain | currency }} {{ charts_kbi.goal.currency }}</label><div class=\"col-xs-4 pull-right\"><span title=\"Monto Faltante para cumplir Meta del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-12\"><div class=\"progress\" style=\"height: 32px;\"><div class=\"progress-bar bar-goal animate\" role=\"progressbar\" ng-style=\"progressGoal\" aria-valuemin=\"0\" aria-valuemax=\"100\"><label>{{ charts_kbi.goal.percentajeGoal }}%</label></div></div></div></div><div class=\"row container-chart\"><div class=\"col-xs-6\"><span>Total de Primas de Pólizas canceladas de póliza</span> <span title=\"Total de primas netas de pólizas Canceladas, PreCanceladas\"><i class=\"fa fa-question-circle\"></i></span> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label class=\"lbl-tableros\" ng-if=\"show_currency_mxn\">{{ charts_kbi.primas_canceladas | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"show_currency_usd\">{{ charts_kbi.primas_canceladasDolar | currency }}</label></div><div class=\"col-xs-6\"><span>Comisión perdida por notas de crédito</span> <span title=\"Total de Comisión de recibos de Notas de crédito (Cancelados, PreCanceladas del año seleccionado)\"><i class=\"fa fa-question-circle\"></i></span> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.comision_perdida | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.comision_perdidaDolar | currency }}</label></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-6\" style=\"background-color: #D4D4D4; color: #ffffff;\"><span>Total de Primas de Pólizas canceladas de póliza</span> <span title=\"Total de primas netas de pólizas Canceladas, PreCanceladas\"><i class=\"fa fa-question-circle\"></i></span> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label class=\"lbl-tableros\" ng-if=\"show_currency_mxn\">{{ charts_kbi.anterior_primas_canceladas | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"show_currency_usd\">{{ charts_kbi.anterior_primas_canceladasDolar | currency }}</label></div><div class=\"col-xs-6\" style=\"background-color: #D4D4D4; color: #ffffff;\"><span>Comisión perdida por notas de crédito</span> <span title=\"Total de Comisión de recibos de Notas de crédito (Cancelados, PreCanceladas del año seleccionado)\"><i class=\"fa fa-question-circle\"></i></span> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span> <label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.anterior_comision_perdida | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.anterior_comision_perdidaDolar | currency }}</label></div></div><div class=\"row container-chart\"><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #5DADE2;\"><i class=\"fa fa-user\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Contratantes</span><br><label class=\"lbl-tableros\">{{ charts_kbi.contratantes }}</label> <span title=\"Totales de contratantes datos de alta en SAAM del año seleccionado(Físicas, Morales)\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #27AE60;\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Pólizas/Fianzas</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.polizas }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.polizasDolar }}</label> <span title=\"Total de pólizas y fianzas registradas en SAAM del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #F1C40F;\"><i class=\"fa fa-file\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>OT proceso</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.ot }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.otDolar }}</label> <span title=\"Total de OT proceso del año seleccionado Endosos (Pendiente, Tramite), OT de Poliza (Pendientes, Trámite)\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #E67E22;\"><i class=\"fa fa-folder\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Endosos</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.endosos }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.endososDolar }}</label> <span title=\"Total de Endosos del año seleccionado (Todos los estatus)\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #BDC3C7;\"><i class=\"fa fa-bookmark\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Renovaciones</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.renovaciones }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.renovacionesDolar }}</label> <span title=\"Total de Renovaciones del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #9B59B6;\"><i class=\"fa fa-certificate\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Siniestros</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.siniestros }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.siniestrosDolar }}</label> <span title=\"Total de Siniestros registrados del año seleccionado (fecha de ingreso de siniestros y/o actualización)\"><i class=\"fa fa-question-circle\"></i></span></div></div></div><div class=\"row container-chart\" style=\"padding: 10px;\"><div class=\"col-xs-6\"><label>Comisiones <span title=\"Total de Comisiones de recibos Liquidado, Conciliado, Pagado con fecha de inicio de recibo del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></label> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataProduction.data\" chart-labels=\"charts_kbi.barDataProduction.labels\" chart-colours=\"charts_kbi.barDataProduction.colours\" height=\"110\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataProductionDolar.data\" chart-labels=\"charts_kbi.barDataProductionDolar.labels\" chart-colours=\"charts_kbi.barDataProductionDolar.colours\" height=\"110\"></canvas></div></div><div class=\"col-xs-6 border-left\"><label>Fecha:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" style=\"display: inline-block; margin-bottom: 6px;\"><input type=\"text\" name=\"startDate\" class=\"text-align-center form-control\" ng-model=\"startDate_production\" value=\"{{startDate_production}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\" style=\"display: none;\"><i class=\"fa fa-calendar\"></i></span></div><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" style=\"display: inline-block; margin-bottom: 6px;\"><input type=\"text\" name=\"endingDate\" class=\"text-align-center form-control\" ng-model=\"endDate_production\" value=\"{{endDate_production}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\" style=\"display: none;\"><i class=\"fa fa-calendar\"></i></span></div><button class=\"btn btn-primary\" style=\"margin: -40px 0 0 0;\" ng-click=\"vm.getFilter(1, year_kbi, startDate_production, endDate_production)\" ng-disabled=\"showLoaderKbi\">Aplicar</button><div class=\"loader-kbi\" ng-if=\"showLoaderKbi\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span><ul class=\"tab-kbi-prodution\"><li ng-class=\"{ \'active-kbi\': show_ejectivo }\" ng-click=\"show_tab_production(1)\">Ejecutivos</li><li ng-class=\"{ \'active-kbi\': show_aseguradora }\" ng-click=\"show_tab_production(2)\">Aseguradoras</li><li ng-class=\"{ \'active-kbi\': show_subramo }\" ng-click=\"show_tab_production(3)\">Subramos</li></ul><div ng-if=\"show_ejectivo\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Ejecutivo</th><th>Acciones</th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"user in charts_kbi.ejecutivos\" ng-if=\"show_currency_mxn\"><td>{{ user.user__first_name }} {{ user.user__last_name }}</td><td>{{ user.user__count }}</td></tr><tr class=\"row-list\" ng-repeat=\"user in charts_kbi.ejecutivosDolar\" ng-if=\"show_currency_usd\"><td>{{ user.user__first_name }} {{ user.user__last_name }}</td><td>{{ user.user__count }}</td></tr></tbody></table></div></div><div ng-if=\"show_aseguradora\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Aseguradora</th><th>Emitida <span title=\"Total de Prima Neta de pólizas por aseguradora del rango fecha seleccionado\"><i class=\"fa fa-question-circle\"></i></span></th><th>Pagada <span title=\"Totales de Prima Neta de recibos pagados por aseguradora de la fecha seleccionada (Pagado, liquidado o conciliado)\"><i class=\"fa fa-question-circle\"></i></span></th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.aseguradoras\" ng-if=\"item.aseguradora__alias && show_currency_mxn\"><td>{{ item.aseguradora__alias }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.aseguradorasDolar\" ng-if=\"item.aseguradora__alias && show_currency_usd\"><td>{{ item.aseguradora__alias }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr></tbody></table></div></div><div ng-if=\"show_subramo\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Subramo</th><th>Emitida <span title=\"Totales de Prima Neta emitida de pólizas por SubRamo de fecha seleccionada (Aseguradora)\"><i class=\"fa fa-question-circle\"></i></span></th><th>Pagada <span title=\"Totales de Prima Neta de recibos pagados por SubRamo de fecha seleccionada (pagado, Liquidado, Conciliado, Subramo)\"><i class=\"fa fa-question-circle\"></i></span></th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.subramos\" ng-if=\"item.subramo__subramo_name && show_currency_mxn\"><td>{{ item.subramo__subramo_name }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.subramosDolar\" ng-if=\"item.subramo__subramo_name && show_currency_usd\"><td>{{ item.subramo__subramo_name }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr></tbody></table></div></div></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-6\"><label>Comisiones <span title=\"Total de Comisiones de recibos Liquidado, Conciliado, Pagado con fecha de inicio de recibo del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></label> <span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataProduction_anterior.data\" chart-labels=\"charts_kbi.barDataProduction_anterior.labels\" chart-colours=\"charts_kbi.barDataProduction_anterior.colours\" height=\"110\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataProductionDolar_anterior.data\" chart-labels=\"charts_kbi.barDataProductionDolar_anterior.labels\" chart-colours=\"charts_kbi.barDataProductionDolar_anterior.colours\" height=\"110\"></canvas></div></div><div class=\"col-xs-6 border-left\"><span ng-if=\"currency_kbi == 1\">MXN</span> <span ng-if=\"currency_kbi == 2\">USD</span><ul class=\"tab-kbi-prodution\"><li ng-class=\"{ \'active-kbi\': show_ejectivo }\" ng-click=\"show_tab_production(1)\">Ejecutivos</li><li ng-class=\"{ \'active-kbi\': show_aseguradora }\" ng-click=\"show_tab_production(2)\">Aseguradoras</li><li ng-class=\"{ \'active-kbi\': show_subramo }\" ng-click=\"show_tab_production(3)\">Subramos</li></ul><div ng-if=\"show_ejectivo\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Ejecutivo*</th><th>Acciones</th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"user in charts_kbi.anterior_ejecutivos track by $index\" ng-if=\"show_currency_mxn\"><td>{{ user.user__first_name }} {{ user.user__last_name }}</td><td>{{ user.user__count }}</td></tr><tr class=\"row-list\" ng-repeat=\"user in charts_kbi.anterior_ejecutivosDolar track by $index\" ng-if=\"show_currency_usd\"><td>{{ user.user__first_name }} {{ user.user__last_name }}</td><td>{{ user.user__count }}</td></tr></tbody></table></div></div><div ng-if=\"show_aseguradora\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Aseguradora</th><th>Emitida <span title=\"Total de Prima Neta de pólizas por aseguradora del rango fecha seleccionado\"><i class=\"fa fa-question-circle\"></i></span></th><th>Pagada <span title=\"Totales de Prima Neta de recibos pagados por aseguradora de la fecha seleccionada (Pagado, liquidado o conciliado)\"><i class=\"fa fa-question-circle\"></i></span></th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.anterior_aseguradoras track by $index\" ng-if=\"item.aseguradora__alias && show_currency_mxn\"><td>{{ item.aseguradora__alias }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.anterior_aseguradorasDolar track by $index\" ng-if=\"item.aseguradora__alias && show_currency_usd\"><td>{{ item.aseguradora__alias }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr></tbody></table></div></div><div ng-if=\"show_subramo\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Subramo</th><th>Emitida <span title=\"Totales de Prima Neta emitida de pólizas por SubRamo de fecha seleccionada (Aseguradora)\"><i class=\"fa fa-question-circle\"></i></span></th><th>Pagada <span title=\"Totales de Prima Neta de recibos pagados por SubRamo de fecha seleccionada (pagado, Liquidado, Conciliado, Subramo)\"><i class=\"fa fa-question-circle\"></i></span></th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.anterior_subramos track by $index\" ng-if=\"item.subramo__subramo_name && show_currency_mxn\"><td>{{ item.subramo__subramo_name }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.anterior_subramosDolar track by $index\" ng-if=\"item.subramo__subramo_name && show_currency_usd\"><td>{{ item.subramo__subramo_name }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr></tbody></table></div></div></div></div></div><div ng-if=\"show_cotizacion\"><div class=\"row container-chart\" style=\"padding: 10px;\"><div class=\"col-xs-9\"><label>Cotizaciones</label> <span title=\"Total de cotizaciones realizadas en el año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><div ng-if=\"show_for == \'1\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotization.data\" chart-labels=\"charts_kbi.barDataCotization.labels\" chart-colours=\"charts_kbi.barDataCotization.colours\" height=\"80\"></canvas></div><div ng-if=\"show_for == \'2\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotizationRamo.data\" chart-labels=\"charts_kbi.barDataCotizationRamo.labels\" chart-colours=\"charts_kbi.barDataCotizationRamo.colours\" height=\"80\"></canvas></div><div ng-if=\"show_for == \'3\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotizacionSubramo.data\" chart-labels=\"charts_kbi.barDataCotizacionSubramo.labels\" chart-colours=\"charts_kbi.barDataCotizacionSubramo.colours\" height=\"80\"></canvas></div></div><div class=\"col-xs-3\"><label>Ver por:</label><br><select class=\"form-control\" name=\"payment\" ng-model=\"show_for\" ng-options=\"item.id as item.name for item in options\" ng-change=\"verpor(show_for)\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select><br><span>No. de cotizaciones</span><br><label class=\"lbl-tableros\">{{ charts_kbi.cotizaciones }}</label></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-9\"><label>Cotizaciones</label> <span title=\"Total de cotizaciones realizadas en el año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><div ng-if=\"show_for == \'1\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotization_anterior.data\" chart-labels=\"charts_kbi.barDataCotization_anterior.labels\" chart-colours=\"charts_kbi.barDataCotization_anterior.colours\" height=\"80\"></canvas></div><div ng-if=\"show_for == \'2\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotizationRamo_anterior.data\" chart-labels=\"charts_kbi.barDataCotizationRamo_anterior.labels\" chart-colours=\"charts_kbi.barDataCotizationRamo_anterior.colours\" height=\"80\"></canvas></div><div ng-if=\"show_for == \'3\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotizacionSubramo_anterior.data\" chart-labels=\"charts_kbi.barDataCotizacionSubramo_anterior.labels\" chart-colours=\"charts_kbi.barDataCotizacionSubramo_anterior.colours\" height=\"80\"></canvas></div></div><div class=\"col-xs-3\"><span>No. de cotizaciones</span><br><label class=\"lbl-tableros\">{{ charts_kbi.anterior_cotizaciones }}</label></div></div><div class=\"row container-chart\"><div class=\"col-xs-3\" style=\"padding: 10px;\"><label>Bateo: {{ charts_kbi.bateo}}%</label> <span title=\"Porcentaje Total de cotizaciones bateadas en el año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><div class=\"box-scroll-cotization\"><ul class=\"list-cotization\" ng-repeat=\"item in charts_kbi.monthsBateo\"><li>{{ item.month }} <span class=\"pull-right\">{{ item.value }}</span></li></ul></div></div><div class=\"col-xs-9\" style=\"padding: 10px;\"><label>Cotización y Emisión</label><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataCotization.data\" chart-labels=\"charts_kbi.chartDataCotization.labels\" chart-colours=\"charts_kbi.chartDataCotization.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataCotization.series\" height=\"70\"></canvas></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-3\" style=\"padding: 10px;\"><label>Bateo: {{ charts_kbi.anterior_bateo}}%</label> <span title=\"Porcentaje Total de cotizaciones bateadas en el año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><div class=\"box-scroll-cotization\"><ul class=\"list-cotization\" ng-repeat=\"item in charts_kbi.monthsBateo_anterior\"><li>{{ item.month }} <span class=\"pull-right\">{{ item.value }}</span></li></ul></div></div><div class=\"col-xs-9\" style=\"padding: 10px;\"><label>Cotización y Emisión</label><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataCotization_anterior.data\" chart-labels=\"charts_kbi.chartDataCotization_anterior.labels\" chart-colours=\"charts_kbi.chartDataCotization_anterior.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataCotization_anterior.series\" height=\"70\"></canvas></div></div></div><div ng-if=\"show_gastos\"><div class=\"row container-chart\"><div class=\"col-xs-8\"><div class=\"concept-scroll\"><div class=\"col-xs-6\"><label>Mes</label><select class=\"form-control\" name=\"payment\" ng-model=\"vm.month_kbi\" ng-options=\"month as month.month for month in months_kbi track by month.id\" ng-change=\"selectMonth(vm.month_kbi)\"><option value=\"\" disabled=\"\">Selecciona un mes</option></select></div><div class=\"col-xs-3\" style=\"margin-top: 23px;\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"saveGastos()\">Guardar</button></div><div class=\"col-xs-3\" style=\"margin-top: 23px;\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"addConcept()\">Agregar concepto</button></div><div class=\"col-xs-12\"></div><div ng-repeat=\"concept in concepts track by $index\"><div class=\"col-xs-6\"><label>Concepto</label> <input class=\"form-control\" type=\"text\" ng-model=\"concept.concept\" name=\"\"></div><div class=\"col-xs-3\"><label>Gasto</label> <input class=\"form-control\" type=\"number\" ng-model=\"concept.cantidad\" ng-change=\"validateGasto(concept.cantidad)\" name=\"\"></div><div class=\"col-xs-3\" style=\"margin-top: 23px;\" ng-if=\"concept.value > 9\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"removeConcept($index)\">Quitar concepto</button></div></div></div></div><div class=\"col-xs-4\" ng-if=\"charts_kbi.barDataGastos.concepts.length > 0\"><div class=\"box-scroll\"><br><table class=\"list-production\"><thead><tr><th>Mes</th><th>Concepto</th><th>Cantidad</th><th></th></tr></thead><tbody><tr ng-repeat=\"item_conc in charts_kbi.barDataGastos.concepts | orderBy: \'month\' track by $index\"><td><span>{{monthName(item_conc.month)}}</span></td><td><span>{{item_conc.concept}}</span></td><td><span>{{item_conc.cantidad | currency}}</span></td><td><span ng-click=\"deleteConcept(item_conc, $index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></span></td></tr></tbody></table></div></div></div><div class=\"row container-chart\"><div class=\"col-xs-8\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataGastos.data\" chart-labels=\"charts_kbi.barDataGastos.labels\" chart-colours=\"charts_kbi.barDataGastos.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.barDataGastos.series\" height=\"100\"></canvas></div><div class=\"col-xs-4\"><label>Tipo de cambio:</label> <input class=\"form-control\" type=\"text\" ng-model=\"tipo_cambio\"> <button class=\"btn btn-primary btn-sm\" ng-click=\"saveTipoCambio(tipo_cambio)\"><i class=\"fa fa-save\" aria-hidden=\"true\" ng-disabled=\"showLoaderKbi\"></i></button><div class=\"loader-kbi\" ng-if=\"showLoaderKbi\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><div class=\"box-scroll\"><br><table class=\"list-production\"><thead><tr><th>Utilidad<span title=\"Total de comision en el año seleccionado: {{total_utilidad | currency }}\"><i class=\"fa fa-question-circle\"></i></span></th><th>Comisiones MXN/USD</th></tr></thead><tbody><tr ng-repeat=\"item_uti in charts_kbi.monthsUtilidad track by $index\"><td><span>{{item_uti.month}}</span></td><td><span>{{item_uti.value | currency}}</span></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><br><label>Comparativa del año inmediato anterior {{ year_kbi_preview }}</label></div><div class=\"col-xs-8\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataGastos_anterior.data\" chart-labels=\"charts_kbi.barDataGastos_anterior.labels\" chart-colours=\"charts_kbi.barDataGastos_anterior.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.barDataGastos_anterior.series\" height=\"100\"></canvas></div><div class=\"col-xs-4\"><br><div class=\"box-scroll\"><br><table class=\"list-production\"><thead><tr><th>Utilidad<span title=\"Total de comision en el año seleccionado: {{total_utilidad_ant | currency }}\"><i class=\"fa fa-question-circle\"></i></span></th><th>Comisiones MXN/USD</th></tr></thead><tbody><tr ng-repeat=\"item_uti in charts_kbi.monthsUtilidad_anterior track by $index\"><td><span>{{item_uti.month}}</span></td><td><span>{{item_uti.value | currency}}</span></td></tr></tbody></table></div></div></div></div></div><script type=\"text/javascript\">\n  setTimeout(function(){ if(document.getElementById(\"box-kbi\")){document.getElementById(\"box-kbi\").style.width = \"0px\"; }}, 10);\n  var clic = 1;\n  function divLogin(){\n    if(clic==1){\n      angular.element(document.getElementById(\'box-kbi\')).scope().getFilter(0);\n      document.getElementById(\"box-kbi\").style.width = \"1100px\";\n      clic = clic + 1;\n    } else{\n      document.getElementById(\"box-kbi\").style.width = \"0px\";      \n      clic = 1;\n    }   \n  }\n</script>");
$templateCache.put("app/lectura_documentos/lectura_documentos.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Lectura de documentos</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Lectura de documentos</strong></li></ol></div></div><br><div><div class=\"row\" ng-if=\"!archivos_cargados\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Selecciona tu póliza</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\"><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"col-xs-12 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"form.nombre\"></div><div class=\"col-xs-12 form-group\"><label>Tipo de póliza</label><select class=\"form-control\" ng-model=\"form.tipo_poliza\" data-ng-options=\"item.name for item in tipo_poliza | orderBy: \'name\' track by item.id\"></select></div><div class=\"col-xs-12 form-group\"><label>Aseguradora</label><select class=\"form-control\" ng-model=\"form.aseguradora\" data-ng-options=\"item.alias for item in aseguradoras | orderBy: \'name\' track by item.id\" ng-change=\"changeAseguradora()\"></select></div><div class=\"col-xs-12 form-group\"><label>Ramo</label><select class=\"form-control\" ng-model=\"form.ramo\" data-ng-options=\"item.ramo_name disable when item.disabled for item in ramos | orderBy: \'name\' track by item.ramo_code\" ng-change=\"changeRamo()\"></select></div><div class=\"col-xs-12 form-group\"><label>Subramo</label><select class=\"form-control\" ng-model=\"form.subramo\" data-ng-options=\"item.subramo_name disable when item.disabled for item in form.ramo.subramo_ramo | orderBy: \'name\' track by item.subramo_code\"></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"col-xs-12 form-group m-t\"><label class=\"col-xs-12 btn btn-success\">Examinar o arrastrar <i class=\"fa fa-upload\" aria-hidden=\"true\"></i> <input nv-file-select=\"\" type=\"file\" name=\"file\" uploader=\"uploader\" class=\"display-none\"></label></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"col-xs-12 form-group\"><img src=\"https://miurabox-public.s3.amazonaws.com/estaticos-publicos/Captura+de+Pantalla+2022-06-06+a+la(s)+16.23.45.png\"></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"cargarNuevaPoliza()\">Entrenar póliza</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 pull-right\"><button class=\"col-xs-12 btn btn-white ladda-button\" ng-click=\"atras()\">Atrás</button></div></div></div></div></div></div><div class=\"row\" ng-if=\"archivos_cargados\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Selecciona tu póliza</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"form.nombre\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group\"><label>Tipo de póliza</label><select class=\"form-control\" ng-model=\"form.tipo_poliza\" data-ng-options=\"item.name for item in tipo_poliza | orderBy: \'name\' track by item.id\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group\"><label>Aseguradora</label><select class=\"form-control\" ng-model=\"form.aseguradora\" data-ng-options=\"item.alias for item in aseguradoras | orderBy: \'name\' track by item.id\" ng-change=\"changeAseguradora()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group\"><label>Ramo</label><select class=\"form-control\" ng-model=\"form.ramo\" data-ng-options=\"item.ramo_name disable when item.disabled for item in ramos | orderBy: \'name\' track by item.ramo_code\" ng-change=\"changeRamo()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group\"><label>Subramo</label><select class=\"form-control\" ng-model=\"form.subramo\" data-ng-options=\"item.subramo_name disable when item.disabled for item in form.ramo.subramo_ramo | orderBy: \'name\' track by item.subramo_code\"></select></div></div><div class=\"row\" style=\"margin-bottom: 20px;\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group\"><label>Selecciona la etiqueta que deseas crear</label><select class=\"form-control\" ng-model=\"item_active\" data-ng-options=\"item.name disable when !item.active for item in items | orderBy: \'name\' track by item.id\" ng-change=\"itemChanged(item_active.name)\"></select></div></div><div class=\"row\"><div class=\"panel-body table-over-y animate\" ng-repeat=\"archivo in archivos track by $index\"><hr><img ng-areas=\"fields900\" ng-areas-allow=\"{\'edit\':true, \'move\':true, \'resize\':true, \'select\':true, \'remove\':true, \'nudge\':true }\" ng-areas-on-add=\"onAddArea\" reset=\"reset()\" ng-areas-on-remove=\"onRemoveArea\" ng-areas-on-change=\"onChangeAreas900\" ng-areas-extend-data=\"{pageNumber: {{$index + 1}}, tag: \'width900\'}\" ng-src=\"{{archivo.arch}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 m-t\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 m-t\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"atras()\">Atrás</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 m-t\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"guardar()\">Entrenar póliza</button></div></div></div></div></div></div></div><style type=\"text/css\">\n	.class_blue{\n		background-color: #1c84c6;\n		border: 2px solid #1c84c6;\n		color: white;\n	}\n</style>");
$templateCache.put("app/lectura_documentos/lectura_documentos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Lectura de documentos</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Lectura de documentos</strong></li></ol></div></div><div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Plantillas entrenadas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary ladda-button2\" ng-click=\"eliminar()\">Eliminar</button></div></div><div class=\"row\"><div class=\"panel-body table-over-y animate\"><table class=\"table table-hover table-bordered\"><thead><tr><th></th><th>Nombre</th><th>Aseguradora</th><th>Fecha de Entrenamiento</th><th>Ramo</th></tr></thead><tbody><tr ng-repeat=\"lectura in vm.lecturas track by $index\" ng-click=\"open(lectura)\"><td ng-click=\"$event.stopPropagation()\"><input ng-model=\"lectura.selected\" type=\"checkbox\"></td><td>{{lectura.nombre}}</td><td>{{lectura.aseguradora}}</td><td>{{lectura.created_at | date: \'dd/MM/yyyy\'}}</td><td>{{lectura.ramo}}</td></tr></tbody></table><div class=\"col-xs-12 col-sm-3 pull-right m-t\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"edit()\">Entrenar póliza</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/login/login.auth.html","<toaster-container></toaster-container><div class=\"middle-box text-center loginscreen animated zoomIn\"><div><style>\n    .svg {\n      display: inline-block;\n      height: 200px;\n      width: 200px;\n      line-height: 200px;\n      text-align: center;\n      background-color: #FFF;\n      border-radius: 50%;\n    }\n\n    #svg {\n      display: inline-block;\n      vertical-align: middle;\n      fill: #0057B8;\n    }\n\n    #svg path:nth-child(1) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 0.1s;\n      animation-delay: 0.1s;\n    }\n\n    #svg path:nth-child(1):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(2) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 0.2s;\n      animation-delay: 0.2s;\n    }\n\n    #svg path:nth-child(2):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(3) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 0.3s;\n      animation-delay: 0.3s;\n    }\n\n    #svg path:nth-child(3):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(4) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 0.4s;\n      animation-delay: 0.4s;\n    }\n\n    #svg path:nth-child(4):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(5) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 0.5s;\n      animation-delay: 0.5s;\n    }\n\n    #svg path:nth-child(5):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(6) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 0.6s;\n      animation-delay: 0.6s;\n    }\n\n    #svg path:nth-child(6):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(7) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 0.7s;\n      animation-delay: 0.7s;\n    }\n\n    #svg path:nth-child(7):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(8) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 0.8s;\n      animation-delay: 0.8s;\n    }\n\n    #svg path:nth-child(8):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(9) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 0.9s;\n      animation-delay: 0.9s;\n    }\n\n    #svg path:nth-child(9):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(10) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 1s;\n      animation-delay: 1s;\n    }\n\n    #svg path:nth-child(10):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(11) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 1.1s;\n      animation-delay: 1.1s;\n    }\n\n    #svg path:nth-child(11):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(12) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 1.2s;\n      animation-delay: 1.2s;\n    }\n\n    #svg path:nth-child(12):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(13) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 1.3s;\n      animation-delay: 1.3s;\n    }\n\n    #svg path:nth-child(13):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(14) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 1.4s;\n      animation-delay: 1.4s;\n    }\n\n    #svg path:nth-child(14):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(15) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 1.5s;\n      animation-delay: 1.5s;\n    }\n\n    #svg path:nth-child(15):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(16) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 1.6s;\n      animation-delay: 1.6s;\n    }\n\n    #svg path:nth-child(16):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(17) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 1.7s;\n      animation-delay: 1.7s;\n    }\n\n    #svg path:nth-child(17):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    #svg path:nth-child(18) {\n      -webkit-animation: pweek 1.8s linear infinite;\n      animation: pweek 1.8s linear infinite;\n      -webkit-animation-delay: 1.8s;\n      animation-delay: 1.8s;\n    }\n\n    #svg path:nth-child(18):hover {\n      -webkit-animation-play-state: paused;\n      animation-play-state: paused;\n    }\n\n    @-webkit-keyframes pweek {\n      0% {\n        fill: #0057B8;\n      }\n      20% {\n        fill: #F11E4A;\n      }\n      40% {\n        fill: #F8A527;\n      }\n      60% {\n        fill: #266D7F;\n      }\n      80% {\n        fill: #82A;\n      }\n      100% {\n        fill: #0057B8;\n      }\n    }\n\n    @keyframes pweek {\n      0% {\n        fill: #0057B8;\n      }\n      20% {\n        fill: #F11E4A;\n      }\n      40% {\n        fill: #F8A527;\n      }\n      60% {\n        fill: #266D7F;\n      }\n      80% {\n        fill: #82A;\n      }\n      100% {\n        fill: #0057B8;\n      }\n    }\n  </style><div class=\"login-img\" ng-show=\"vm.be_logo == true\"><img alt=\"image\" class=\"img-circle\" ng-src=\"{{vm.logo}}\" style=\"max-width: 300px; max-height:200px;\"></div><div class=\"login-img\" ng-show=\"vm.be_logo == false\"><div class=\"svg\"><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"svg\" x=\"0px\" y=\"0px\" width=\"150px\" height=\"150px\" viewbox=\"0 0 213.235 241.176\" enable-background=\"new 0 0 213.235 241.176\" xml:space=\"preserve\" fill=\"#0057B8\"><path d=\"M108.581,64.968V14.124l44.007,25.422L108.581,64.968\"></path><path fill-opacity=\"0.9\" d=\"M153.591,92.101V41.258L109.582,66.68L153.591,92.101\"></path><path d=\"M155.586,92.062V41.221l44.009,25.42L155.586,92.062\"></path><path fill-opacity=\"0.7\" d=\"M200.299,119.14V68.297l-44.004,25.421L200.299,119.14\"></path><path fill-opacity=\"0.85\" d=\"M155.586,146.255V95.412l44.009,25.422L155.586,146.255\"></path><path fill-opacity=\"0.7\" d=\"M200.299,173.35v-50.844l-44.004,25.422L200.299,173.35\"></path><path fill-opacity=\"0.6\" d=\"M155.586,200.482v-50.84l44.009,25.417L155.586,200.482\"></path><path fill-opacity=\"0.5\" d=\"M153.591,200.521v-50.84l-44.009,25.418L153.591,200.521\"></path><path fill-opacity=\"0.6\" d=\"M108.581,227.696v-50.844l44.007,25.421L108.581,227.696\"></path><path fill-opacity=\"0.5\" d=\"M106.62,227.696v-50.844l-44.005,25.421L106.62,227.696\"></path><path fill-opacity=\"0.7\" d=\"M61.562,200.553V149.71l44.007,25.423L61.562,200.553\"></path><path fill-opacity=\"0.7\" d=\"M59.709,200.56v-50.843l-44.008,25.422L59.709,200.56\"></path><path fill-opacity=\"0.7\" d=\"M14.699,173.467v-50.843l44.01,25.42L14.699,173.467\"></path><path fill-opacity=\"0.5\" d=\"M59.709,146.235V95.392l-44.008,25.42L59.709,146.235\"></path><path fill-opacity=\"0.7\" d=\"M14.699,119.141V68.297l44.01,25.421L14.699,119.141\"></path><path fill-opacity=\"0.6\" d=\"M59.709,92.101V41.258L15.701,66.68L59.709,92.101\"></path><path fill-opacity=\"0.85\" d=\"M61.562,92.092V41.249l44.007,25.419L61.562,92.092\"></path><path fill-opacity=\"0.9\" d=\"M106.62,64.968V14.124L62.614,39.546L106.62,64.968\"></path></svg></div></div><div ng-show=\"error\" class=\"alert alert-danger\">{{error}}</div><form name=\"form\" ng-submit=\"vm.login()\" class=\"m-t login-form\" role=\"form\"><div class=\"form-group\"><input type=\"text\" name=\"username\" id=\"username\" class=\"form-control login-control\" ng-model=\"vm.user.username\" placeholder=\"Usuario\" required=\"\" autocomplete=\"username\" lowercase=\"\"> <span ng-show=\"form.username.$dirty && form.username.$error.required\" class=\"help-block\">Usuario requerido</span></div><div class=\"form-group\"><input type=\"password\" name=\"password\" id=\"password\" class=\"form-control login-control\" ng-model=\"vm.user.password\" placeholder=\"Contraseña\" autocomplete=\"current-password\" required=\"\"> <span ng-show=\"form.password.$dirty && form.password.$error.required\" class=\"help-block\">Contraseña requerida</span></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">Iniciar sesión</button></form></div><div class=\"row\"><div class=\"col-xs-12 text-center browser-info\"><p class=\"browser-text\">Navegadores recomendados</p><ul class=\"browsers\"><li class=\"browser\"><a href=\"https://www.mozilla.org/es-MX/firefox/new/\" data-toggle=\"tooltip\" title=\"De click para descargar Firefox\"><i class=\"fa fa-firefox fa-fw fa-3x\" aria-hidden=\"true\"></i></a></li><li class=\"browser\"><a href=\"https://www.google.com.mx/chrome/browser/desktop/\" data-toggle=\"tooltip\" title=\"De click para descargar Chrome\"><i class=\"fa fa-chrome fa-fw fa-3x\" aria-hidden=\"true\"></i></a></li><li class=\"browser\"><a href=\"#\" data-toggle=\"tooltip\" title=\"De click para descargar Safari\"><i class=\"fa fa-safari fa-fw fa-3x\" aria-hidden=\"true\"></i></a></li></ul></div></div><footer class=\"login-footer col-sm-12\"><div class=\"row\"><div class=\"col-sm-12 contact-info\"><div class=\"logos\"><img src=\"/assets/images/logos/saam.svg\" class=\"img-responsive logo-saam\" alt=\"SAAM\"></div><div class=\"contact-text text-center\"><p><b>Versión</b> 1.21.84</p></div><div class=\"contact-text text-center\"><p>Todos los derechos reservados ®</p><img src=\"assets/images/logos/logo.svg\" class=\"img-responsive logo-miurabox col-xs-6\" alt=\"Miurabox\"></div></div></div></footer></div><script> \n  $(\'[type=password]\').keypress(function(e) {\n  var $password = $(this),\n    tooltipVisible = $(\'.tooltip\').is(\':visible\'),\n    s = String.fromCharCode(e.which); \n    if ( s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey ) {\n  if (!tooltipVisible)\n    $password.tooltip(\'show\');\n  } else {\n  if (tooltipVisible)\n    $password.tooltip(\'hide\');\n  }\n  $password.blur(function(e) {\n  $password.tooltip(\'hide\');\n  });\n  });\n</script>");
$templateCache.put("app/login/login.html","<div ui-view=\"\"></div>");
$templateCache.put("app/main/changeStatusModal.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Estatus</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h4>Estatus actual:<p status-receipt=\"{{receipt.status}}\"></p></h4></div><div class=\"ibox-content\"><div class=\"form-group\"><select class=\"form-control m-b\" ng-model=\"status\" ng-options=\"status as status.label for status in statusReceipt track by status.value\" required=\"\"><option value=\"\" selected=\"\" disabled=\"\">Selecciona un estado</option></select></div><div class=\"form-group\"><label>Observaciones</label><textarea class=\"form-control\" name=\"poliza\" ng-model=\"description\" type=\"text\"></textarea></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"changeReceiptStatus()\" ng-disabled=\"!status\">Guardar</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div></div>");
$templateCache.put("app/main/editReceiptsPago.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Pagar Recibos</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\" ng-init=\"poliza = false; recibos = true; bitacora = false\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': recibos }\"><a ng-click=\"recibos = true; bitacora = false; poliza = false\">Recibos</a></li><li ng-class=\"{ \'active\': poliza }\"><a ng-click=\"poliza = true; bitacora = false; recibos = false\" ng-show=\"myPolicy.document_type == 1 || myPolicy.document_type == 3\">Información de Póliza</a> <a ng-click=\"poliza = true; bitacora = false; recibos = false\" ng-show=\"myPolicy.document_type == 7 || myPolicy.document_type == 8\">Información de Fianza</a></li><li ng-class=\"{ \'active\': bitacora }\"><a ng-click=\"poliza = false; recibos = false; bitacora = true\">Bitácora</a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': recibos}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"receipt.poliza.document_type == 1 && main.acceso_ver_pol\"><a ng-click=\"main.goToPolicy(myPolicy)\">Ver Póliza</a></li><li ng-if=\"receipt.poliza.document_type == 3 && main.acceso_ver_pol || receipt.poliza.document_type == 4 && main.acceso_ver_pol\"><a ng-click=\"main.goToPolicy(myPolicy)\">Ver Pólizas de Grupo</a></li><li ng-if=\"receipt.poliza.document_type == 11 && main.acceso_ver_pol || receipt.poliza.document_type == 12 && main.acceso_ver_pol\"><a ng-click=\"main.goToPolicy(myPolicy)\">Ver Colectividad</a></li><li ng-if=\"(receipt.poliza.document_type == 7 || receipt.poliza.document_type == 8) && (main.acceso_ver_fia || main.acceso_ver_pol)\"><a ng-click=\"main.goToPolicy(myPolicy)\">Ver Fianza</a></li><li><a ng-click=\"main.getPDF(myPolicy.id)\">Ver PDF</a></li><li ng-if=\"receipt.poliza.document_type == 1 && main.acceso_adm_pol\"><a ng-click=\"main.openRenovateModal(myPolicy, 2)\">Renovar Póliza</a></li><li><a ng-click=\"createRecordatorio(receipt, 4)\">Crear Recordatorio</a></li><li class=\"dropdown-submenu\" ng-if=\"receipt.poliza.document_type == 3 && main.acceso_adm_pol || receipt.poliza.document_type == 4 && main.acceso_adm_pol\"><a>Renovar como:</a><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"main.openRenovateModal(myPolicy, \'\')\">Póliza de Grupo</a></li><li><a ng-click=\"main.openRenovateModal(myPolicy, 1)\">OT</a></li></ul></li><li ng-if=\"receipt.poliza.document_type == 1 && main.acceso_adm_pol\"><a ng-click=\"main.goToEdit(myPolicy)\">Editar Póliza</a></li><li ng-if=\"receipt.poliza.document_type == 3 && main.acceso_adm_pol || receipt.poliza.document_type == 4 && main.acceso_adm_pol\"><a ng-click=\"main.goToEdit(myPolicy)\">Editar Póliza de Grupo</a></li><li ng-if=\"receipt.poliza.document_type == 1 && main.acceso_del_pol\"><a ng-click=\"main.deletePolicy(myPolicy)\">Eliminar Póliza</a></li><li ng-if=\"receipt.poliza.document_type == 3 && main.acceso_del_pol || receipt.poliza.document_type == 4 && main.acceso_del_pol\"><a ng-click=\"main.deletePolicy(myPolicy)\">Eliminar Póliza de Grupo</a></li><li class=\"dropdown-submenu\" ng-if=\"main.cartas.length\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"main.cartas\" ng-repeat=\"carta in main.cartas track by $index\"><a ng-click=\"main.viewCarta(myPolicy.id, carta.id, receipt.id)\">{{carta.name}}</a></li></ul></li></ul></div><div class=\"row\"><br><div class=\"col-xs-12\"><div class=\"loading active\" ng-if=\"!main.loaded\"><div class=\"sk-spinner sk-spinner-rotating-plane margin-top-45p\"></div></div><div class=\"table-responsive\"><div class=\"project-list\"><div class=\"col-xs-12\" ng-init=\"receipt = main.pago_recibo_actual[0]\"><br><button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"main.createRecordatorio(receipt,4)\"><i class=\"fa fa-clock-o\"></i></button><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Tipo de Recibo:</span><p ng-if=\"receipt.receipt_type == 1\">Recibo de póliza</p><p ng-if=\"receipt.receipt_type == 2\">Recibo de endoso</p><p ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Serie:</span><p>{{receipt.recibo_numero}}</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.receipt_type == 2\"><span class=\"color-blue\">Número de endoso:</span><p>{{receipt.endorsement.number_endorsement}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\" ng-if=\"receipt.poliza.document_type == 1\">Número de Póliza:</span> <span class=\"color-blue\" ng-if=\"receipt.poliza.document_type == 3\">Número de Póliza de Grupo:</span> <span class=\"color-blue\" ng-if=\"receipt.poliza.document_type == 4\">Número de Póliza de Grupo:</span> <span class=\"color-blue\" ng-if=\"receipt.poliza.document_type == 7\">Número de Fianza:</span> <span class=\"color-blue\" ng-if=\"receipt.poliza.document_type == 8\">Número de Fianza Colectiva:</span><p>{{receipt.poliza.poliza_number}}{{receipt.fianza.fianza_number}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\">Fecha de Vencimiento:</span><p>{{receipt.vencimiento | date: \'dd/MM/yyyy\' : \'UTC\' }}</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.pay_date\"><span class=\"color-blue\">Fecha de Pago:</span><p>{{receipt.pay_date | date: \'dd/MM/yyyy\'}}</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.liquidacion_date\"><span class=\"color-blue\">Fecha de Liquidación:</span><p>{{receipt.liquidacion_date | date: \'dd/MM/yyyy\'}}</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.pay_form\"><span class=\"color-blue\">Forma de Pago:</span><p ng-if=\"receipt.pay_form == 1\">CHEQUE</p><p ng-if=\"receipt.pay_form == 2\">EFECTIVO</p><p ng-if=\"receipt.pay_form == 3\">TRANSFERENCIA</p><p ng-if=\"receipt.pay_form == 4\">DEPOSITO BANCARIO</p><p ng-if=\"receipt.pay_form == 5\">TARJETA DE CRÉDITO</p><p ng-if=\"receipt.pay_form == 7\">NOTA DE CRÉDITO</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.curr_rate\"><span class=\"color-blue\">Tipo de Cambio:</span><p ng-if=\"receipt.curr_rate == 1\">PESO</p><p ng-if=\"receipt.curr_rate == 2\">DOLAR</p><p ng-if=\"receipt.curr_rate == 3\">YEN</p><p ng-if=\"receipt.curr_rate == 4\">LIBRA ESTERLINA</p><p ng-if=\"receipt.curr_rate == 5\">EURO</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.pay_doc\"><span class=\"color-blue\">Documento de Pago:</span><p>{{receipt.pay_doc}}</p></div><div class=\"col-xs-12 col-md-3\" ng-if=\"receipt.bank\"><span class=\"color-blue\">Banco:</span><p>{{banco.label}}</p></div><div class=\"col-xs-12 col-md-3\"><span class=\"color-blue\"><strong>Creado por:</strong></span><p>{{myPolicy.owner}}</p></div><div class=\"col-xs-8 col-md-3 form-group\"><span class=\"color-blue\">Promesa de pago:</span><p ng-if=\"!main.edith_promesa_pago\">{{receipt.promesa_pago | date: \'dd/MM/yyyy\'}} <a class=\"color-blue\" ng-click=\"main.edith_promesa_pago=true\">Editar</a></p><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" ng-if=\"main.edith_promesa_pago\"><input type=\"text\" name=\"promesa_pago\" class=\"width-100 text-align-center form-control\" ng-model=\"main.new_promesa_pago\" value=\"{{receipt.promesa_pago}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-4 col-md-1 form-group\" ng-if=\"main.edith_promesa_pago\"><button class=\"form-control btn btn-primary\" type=\"button\" ng-click=\"main.update_promesa_pago(receipt)\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i></button> <button class=\"form-control btn btn-danger\" type=\"button\" ng-click=\"main.edith_promesa_pago=false;\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Periodo</th><th>Estatus</th><th>Prima total</th><th>Acciones</th></thead><tbody><tr ng-repeat=\"receipt in main.pago_recibo_actual track by receipt.id\" ng-show=\"receipt.isActive\"><td>{{ contratante.full_name }}{{ contratante.j_name }}</td><td><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date:\'dd-MM-yyyy\':\'UTC\' }}</span><br><span>Vence: {{ receipt.fecha_fin | date:\'dd-MM-yyyy\':\'UTC\' }}</span></td><td><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 1, \'label-info\': receipt.status == 2, \'label-primary\': receipt.status == 3, \'label-warning\': receipt.status >= 4 }\"></div></td><td>{{ receipt.prima_total | currency }}</td><td><a ng-if=\"user.permiso.editar\" class=\"btn btn-white btn-sm\" ng-click=\"dismis(receipt,soloInfo)\"><i class=\"fa fa-pencil\"></i> Aplicar</a></td></tr></tbody></table></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\': poliza}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"receipt.poliza.document_type == 1\"><a ng-click=\"main.goToPolicy(myPolicy)\">Ver Póliza</a></li><li ng-if=\"receipt.poliza.document_type == 3 || receipt.poliza.document_type == 4\"><a ng-click=\"main.goToPolicy(myPolicy)\">Ver Póliza de Grupo</a></li><li ng-if=\"receipt.poliza.document_type == 7\"><a ng-click=\"main.goToPolicy(myPolicy)\">Fianza</a></li><li ng-if=\"receipt.poliza.document_type == 8\"><a ng-click=\"main.goToPolicy(myPolicy)\">Fianza Colectiva</a></li><li><a ng-click=\"main.getPDF(myPolicy.id)\">Ver PDF</a></li><li ng-if=\"receipt.poliza.document_type == 1\"><a ng-click=\"main.openRenovateModal(myPolicy)\">Renovar Póliza</a></li><li class=\"dropdown-submenu\" ng-if=\"receipt.poliza.document_type == 3 || receipt.poliza.document_type == 4\"><a>Renovar como:</a><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"main.openRenovateModal(myPolicy, \'\')\">Póliza de Grupo</a></li><li><a ng-click=\"main.openRenovateModal(myPolicy, 1)\">OT</a></li></ul></li><li ng-if=\"receipt.poliza.document_type == 1\"><a ng-click=\"main.goToEdit(myPolicy)\">Editar Póliza</a></li><li ng-if=\"receipt.poliza.document_type == 3 || receipt.poliza.document_type == 4\"><a ng-click=\"main.goToEdit(myPolicy)\">Editar Póliza de Grupo</a></li><li ng-if=\"receipt.poliza.document_type == 1\"><a ng-click=\"main.deletePolicy(myPolicy)\">Eliminar Póliza</a></li><li ng-if=\"receipt.poliza.document_type == 3 || receipt.poliza.document_type == 4\"><a ng-click=\"main.deletePolicy(myPolicy)\">Eliminar Póliza de Grupo</a></li><li class=\"dropdown-submenu\" ng-if=\"main.cartas.length\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"main.cartas\" ng-repeat=\"carta in main.cartas track by $index\"><a ng-click=\"main.viewCarta(myPolicy.id, carta.id)\">{{carta.name}}</a></li></ul></li></ul></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Nombre:</span><div><span>{{contratante.full_name}} {{contratante.j_name}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Dirección:</span><div><span>{{addressContratante.route}} {{addressContratante.street_number}}, {{addressContratante.sublocality}}.</span><div><span>{{ addressContratante.administrative_area_level_1}}, {{addressContratante.administrative_area_level_2}}.</span></div></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ contratante.phone_number | phonenumber }}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{ contratante.email }}</span></div></div></div><div class=\"form-group col-xs-12\" ng-if=\"!chngDesc\"><span class=\"blue-color\">Observaciones:</span> <button class=\"btn btn-white btn-sm\" ng-click=\"changeDescriptionC(true)\"><i class=\"fa fa-edit\" aria-hidden=\"true\"></i></button><div><span>{{ contratante.description }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"chngDesc\"><label>Observaciones</label> <textarea class=\"form-control\" ng-model=\"contratante.description\" type=\"text\"></textarea><div class=\"col-xs-6\"><button class=\"btn btn-primary btn-sm\" ng-click=\"saveDescript(contratante)\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-warning btn-sm\" ng-click=\"changeDescriptionC(false)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></div></div><div class=\"col-xs-12 col-md-8 border-left\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"form-group col-sm-6\"><span class=\"blue-color\" ng-if=\"myPolicy.document_type ==1\">Número de Póliza:</span> <span class=\"blue-color\" ng-if=\"myPolicy.document_type ==3\">Número de Póliza de Grupo:</span> <span class=\"blue-color\" ng-if=\"myPolicy.document_type ==7\">Número de Fianza:</span> <span class=\"blue-color\" ng-if=\"myPolicy.document_type ==8\">Número de Fianza Colectiva:</span><div><span>{{myPolicy.poliza_number}}{{myPolicy.fianza_number}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Aseguradora - Cve Agente:</span><div><span>{{myPolicy.aseguradora.alias}} - {{myPolicy.clave.clave}} {{myPolicy.afianzadora}} - {{myPolicy.clave.clave}} <span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Ramo:</span><div><span>{{myPolicy.ramo}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Subramo:</span><div><span>{{myPolicy.subramo}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Paquete:</span><div><span>{{myPolicy.paquete}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Vigencia:</span><div><span>{{myPolicy.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{myPolicy.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{forma_pago(myPolicy.forma_de_pago)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Estatus:</span><div><span>{{status(myPolicy.status)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"myPolicy.f_currency == 1\">PESOS</span> <span ng-if=\"myPolicy.f_currency == 2\">DOLARES</span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\"><strong>Creado por:</strong></span><div><span>{{myPolicy.owner}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Observaciones:</span><div><span>{{myPolicy.observations}}</span></div></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\': bitacora}\"><div class=\"row\"><br><div class=\"col-xs-12\"><comments datasource=\"main.comments_data_receipt\" typemodel=\"4\" config=\"comments_config\" idmodel=\"recibo.id\" receiptmodel=\"receiptmodel\"></comments></div></div></div></div></form></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel(true)\" type=\"button\">Cerrar</button></div></div><script type=\"text/javascript\">\n  // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n  // $(document).ready(function(){\n  //   $(\'#modal_edit\').modal(\'hide\');\n  //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n  //       $(\'body\').removeClass(\'modal-open\'); \n  //       $(\'.modal-backdrop\').remove(); \n  //     };\n  //   });\n// });\n</script>");
$templateCache.put("app/main/main.html","<toaster-container></toaster-container><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"main.acceso_adm_pol || main.acceso_adm_ot\"><div class=\"ibox\"><button id=\"createOTS\" ng-click=\"main.otCreatorModalEvent(1)\" class=\"btn btn-outline btn-block btn-primary dim\">Crear OT/Póliza</button></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"main.acceso_ver_cob && main.acceso_pag_cob\"><div class=\"ibox\"><button ng-click=\"main.goToCotization()\" class=\"btn btn-block btn-outline btn-primary dim\">Prospectos</button></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"main.acceso_adm_ot\"><div class=\"ibox\"><button ng-click=\"main.crearEndoso()\" class=\"btn btn-block btn-outline btn-primary dim\">Crear endoso</button></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"main.acceso_adm_sin\"><div><button type=\"button\" class=\"btn btn-block btn-outline btn-primary dim dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">Capturar Siniestro</button><ul class=\"dropdown-menu dropdown-menu-right\" ng-model=\"crearSiniestroSeleccionado\" style=\"width: 276px; margin-top: -18px;\"><li ng-click=\"gotoCapturarSiniestro(\'siniestros.accidentes\')\"><a>Accidentes y Enfermedades</a></li><li ng-click=\"gotoCapturarSiniestro(\'siniestros.vida\')\"><a>Vida</a></li><li ng-click=\"gotoCapturarSiniestro(\'siniestros.autos\')\"><a>Automóviles</a></li><li ng-click=\"gotoCapturarSiniestro(\'siniestros.danios\')\"><a>Daños</a></li></ul></div></div></div><div class=\"row flex-center\"><div class=\"col-xs-12 col-sm-3\" ng-if=\"main.permiso_g_ot\"><div class=\"ibox-content col-xs-12\"><h3 class=\"text-center\"><i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i> OTs <a ng-click=\"configGraph(1)\"><i class=\"fa fa-wrench pull-right\" aria-hidden=\"true\"></i></a></h3><br><div class=\"row\"><graphic gtype=\"ot\" lc=\"last_color\"></graphic></div><br><button class=\"btn btn-success center-block\" ng-click=\"main.show_binnacle = false; main.showTotalOt(1,1)\" ng-model=\"main.btn_all\">Ver todos</button></div></div><div ui-view=\"cobranza\" ng-if=\"main.permiso_g_cob\"></div><div ui-view=\"renovaciones\"></div></div><br><div ng-show=\"main.policyTable\" class=\"row flex-container\" id=\"myTable\" ng-if=\"main.permiso_g_ot\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>OTs <span ng-if=\"main.titleID==1\" style=\"color: #17A45D;\">{{main.title}}</span> <span ng-if=\"main.titleID==2\" style=\"color: #F5CD21;\">{{main.title}}</span> <span ng-if=\"main.titleID==3\" style=\"color: #EA9021;\">{{main.title}}</span> <span ng-if=\"main.titleID==4\" style=\"color: #EA5121;\">{{main.title}}</span></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"input-group m-b\" style=\"z-index: 0;\"><input ng-enter=\"main.searchOTs(main.cadena,main.titleID)\" class=\"form-control search-custom\" style=\"height: 34px; margin-top: 13px;\" placeholder=\"Buscar en OTs {{main.title}} (Contratante, subramo, ramo, aseguradora, no. póliza)\" ng-model=\"main.cadena\" name=\"top-search\" id=\"top-search\"> <span class=\"input-group-btn\"><button ng-click=\"main.searchOTs(main.cadena,main.titleID)\" class=\"btn btn-success\" style=\"margin-top: 13px;\" type=\"button\">Buscar</button></span></div><div class=\"table-responsive\" ng-if=\"!main.show_binnacle && !main.show_binnacle_endoso\"><table class=\"table table-bordered table-hover\" id=\"polizas\"><thead><tr><div ng-if=\"main.btn_all == false\"><th ng-if=\"main.btn_all == false\">Tipo</th><th ng-if=\"main.btn_all == false\">Folio Interno</th><th ng-if=\"main.btn_all == false\">Contratante</th><th ng-if=\"main.btn_all == false\">No. Póliza</th><th ng-if=\"main.btn_all == false\">Subramo</th><th ng-if=\"main.btn_all == false\">Aseguradora</th><th ng-if=\"main.btn_all == false\">Estatus</th><th ng-if=\"main.btn_all == false\">Fecha Creación</th><th ng-if=\"main.btn_all == false\">Antigüedad</th><th ng-if=\"main.btn_all == false\">Acciones</th></div><div ng-if=\"main.btn_all == true\"><th ng-if=\"main.btn_all == true\">Tipo</th><th ng-if=\"main.btn_all == true\">Folio Interno</th><th ng-if=\"main.btn_all == true\">Contratante</th><th ng-if=\"main.btn_all == true\">No. Póliza</th><th ng-if=\"main.btn_all == true\">Subramo</th><th ng-if=\"main.btn_all == true\">Aseguradora</th><th ng-if=\"main.btn_all == true\">Estatus</th><th ng-if=\"main.btn_all == true\">Fecha Creación</th><th ng-if=\"main.btn_all == true\">Antigüedad</th><th ng-if=\"main.btn_all == true\">Acciones</th></div></tr></thead><tbody><tr ng-click=\"main.goToPolicy(insurance)\" ng-repeat=\"insurance in main.insurances | orderBy: \'created_at\' track by $index\"><td><span ng-if=\"insurance.document_type == 1\">Individual {{insurance.historic}}</span> <span ng-if=\"insurance.document_type == 3\">Póliza de Grupo {{insurance.historic}}</span></td><div ng-if=\"insurance.folio == \'0\'\">Sin número de OT.</div><div ng-if=\"insurance.folio != \'0\'\">{{ insurance.folio }}</div><td>{{ insurance.internal_number }}</td><td>{{ insurance.contractor.full_name }}</td><td>Sin asignar</td><td>{{ insurance.subramo }}</td><td>{{ insurance.aseguradora }}</td><td>En trámite</td><td>{{ insurance.created_at | date:\"dd/MM/yyyy - HH:mm\" : \'UTC\' }}</td><td ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</td><td ng-if=\"!(insurance.antiguedad > 0)\">0 días</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); main.showBinnacle(insurance,\'poliza\')\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"1\" model=\"insurance.internal_number\" associated=\"insurance.id\"></tasks></td></tr><tr ng-click=\"goToEndorsement(\'Información endosos\', \'endorsement.info\', insurance)\" ng-repeat=\"insurance in main.endo track by $index\"><td><span>Endoso</span></td><td><span>{{insurance.internal_number}} Tipo: {{insurance.endorsement_type}}</span></td><td><span ng-if=\"insurance.policy.contractor\">{{ insurance.policy.contractor }}</span> <span ng-if=\"insurance.policy.contratante_sub && !insurance.policy.contractor\">{{insurance.policy.contratante_sub}}</span></td><td>{{ insurance.policy.poliza_number }}</td><td>{{insurance.policy.subramo}}</td><td>{{ insurance.policy.aseguradora }}</td><td ng-if=\"insurance.status == 1\">Pendiente</td><td ng-if=\"insurance.status == 5\">En trámite</td><td>{{ insurance.created_at | date:\"dd/MM/yyyy - HH:mm\" : \'UTC\' }}</td><td ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</td><td ng-if=\"!(insurance.antiguedad > 0)\">0 días</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); main.showBinnacle_endoso(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"2\" model=\"insurance.internal_number\" associated=\"insurance.id\"></tasks></td></tr></tbody></table><button ng-if=\"main.btn_all && (main.endo.length || main.insurances.length) && (main.acceso_rep_end || main.acceso_rep_pol)\" ng-model=\"vm.buttonReportE\" class=\"col-xs-3 btn btn-primary pull-right ladda-button4\" ng-click=\"main.exportDataGral(2)\">Generar reporte</button> <button ng-if=\"!main.btn_all && (main.endo.length || main.insurances.length) && (main.acceso_rep_end || main.acceso_rep_pol)\" ng-model=\"vm.buttonReportE\" class=\"col-xs-3 btn btn-primary pull-right ladda-button4\" ng-click=\"main.exportDataGral(2)\">Generar reporte</button></div><div class=\"col-xs-12\" ng-if=\"main.show_binnacle_endoso\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora Endoso</h5><a class=\"btn btn-info pull-right\" ng-click=\"main.returnToEndoso()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"main.comments_data_endoso\" config=\"main.comments_config\" typemodel=\"10\" idmodel=\"main.endosoId\"></comments></div></div></div></div></div><div class=\"row animate\" ng-if=\"main.show_binnacle\"><div class=\"col-xs-12\"><div class=\"col-xs-12 margin-top-24\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><button class=\"col-xs-12 btn btn-info pull-right\" ng-click=\"main.returnToReceipts(1)\"><span class=\"fa fa-reply\"></span> Regresar</button></div><div class=\"col-xs-12\"><comments datasource=\"main.comments_data\" typemodel=\"1\" config=\"main.comments_config\" idmodel=\"main.policy_id\"></comments></div></div></div><div class=\"row animate\" ng-if=\"main.show_binnacle_receipt\"><div class=\"col-xs-12\"><label>Bitácora de Recibos</label><div class=\"col-xs-12 margin-top-24\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"main.returnToReceipts(2)\"><span class=\"fa fa-reply\"></span> Regresar</button></div><div class=\"col-xs-12\"><comments datasource=\"main.comments_data_receipt\" typemodel=\"4\" config=\"main.comments_config_receipt\" idmodel=\"main.receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div></div></div></div></div></div><div ng-show=\"main.coverageTable || main.coverageModal\" class=\"row flex-container\" id=\"myTable\" ng-if=\"main.permiso_g_cob\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Cobranza <span ng-if=\"main.titleID==1\" style=\"color: #17A45D;\">{{main.title}}</span> <span ng-if=\"main.titleID==2\" style=\"color: #F5CD21;\">{{main.title}}</span> <span ng-if=\"main.titleID==3\" style=\"color: #EA9021;\">{{main.title}}</span> <span ng-if=\"main.titleID==4\" style=\"color: #EA5121;\">{{main.title}}</span></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"m-b col-xs-12\"><div class=\"col-xs-2\"><input type=\"text\" ng-model=\"main.serie\" class=\"form-control\" placeholder=\"Serie\" ng-enter=\"main.searchReceipts(main.serie,main.cadena,main.titleID)\"></div><div class=\"col-xs-10\"><div class=\"input-group\" style=\"z-index: 0;\"><input ng-enter=\"main.searchReceipts(main.serie,main.cadena,main.titleID)\" class=\"form-control search-custom\" style=\"height: 34px; margin-top: 0px;\" placeholder=\"Buscar en cobranza {{main.title}} (Contratante, subramo, ramo, aseguradora, no. póliza)\" ng-model=\"main.cadena\" name=\"top-search\" id=\"top-search\"> <span class=\"input-group-btn\"><button ng-click=\"main.searchReceipts(main.serie,main.cadena,main.titleID)\" class=\"btn btn-success\" style=\"margin-top: 0px;\" type=\"button\">Buscar</button></span></div></div></div><div class=\"table-responsive col-xs-12\" ng-if=\"!main.show_binnacle_receipt\" id=\"tableDash\"><table class=\"table table-striped table-bordered table-hover\" id=\"cobranza\"><thead><tr><th width=\"1%\"></th><div ng-if=\"main.show_cobranza == false\"><th ng-if=\"main.show_cobranza == false\" width=\"5%\" ng-click=\"main.changeReceipt(1, main.receipt_num_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': main.receipt_num_asc == 1, \'fa fa-sort-asc\': main.receipt_num_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == false\" width=\"5%\" ng-click=\"main.changeReceipt(1, main.receipt_num_asc == 1 ? 2 : 1)\">Serie <span ng-class=\"{\'fa fa-sort-desc\': main.receipt_num_asc == 1, \'fa fa-sort-asc\': main.receipt_num_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == false\" width=\"15%\" ng-click=\"main.changeReceipt(2, main.receipt_cont_asc == 1 ? 2 : 1)\">Contratante<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_cont_asc == 1, \'fa fa-sort-asc\': main.receipt_cont_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == false\" width=\"10%\" ng-click=\"main.changeReceipt(3, main.receipt_nump_asc == 1 ? 2 : 1)\">Número de póliza<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_nump_asc == 1, \'fa fa-sort-asc\': main.receipt_nump_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == false\" width=\"10%\" ng-click=\"main.changeReceipt(4, main.receipt_vig_asc == 1 ? 2 : 1)\">Inicio de Vigencia<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_vig_asc == 1, \'fa fa-sort-asc\': main.receipt_vig_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == false\" width=\"10%\" ng-click=\"main.changeReceipt(5, main.receipt_subr_asc == 1 ? 2 : 1)\">Subramo<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_subr_asc == 1, \'fa fa-sort-asc\': main.receipt_subr_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == false\" width=\"10%\" ng-click=\"main.changeReceipt(6, main.receipt_aseg_asc == 1 ? 2 : 1)\">Aseguradora<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_aseg_asc == 1, \'fa fa-sort-asc\': main.receipt_aseg_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == false\" width=\"5%\" ng-click=\"main.changeReceipt(7, main.receipt_venc_asc == 1 ? 2 : 1)\">Fecha de vencimiento<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_venc_asc == 1, \'fa fa-sort-asc\': main.receipt_venc_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == false\" width=\"10%\" ng-click=\"main.changeReceipt(8, main.receipt_pneta == 1 ? 2 : 1)\">Prima total<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_pneta == 1, \'fa fa-sort-asc\': main.receipt_pneta == 2}\"></span></th></div><div ng-if=\"main.show_cobranza == true\"><th ng-if=\"main.show_cobranza == true\" width=\"5%\" ng-click=\"main.changeReceiptAll(1, main.receipt_num_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': main.receipt_num_asc == 1, \'fa fa-sort-asc\': main.receipt_num_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == true\" width=\"5%\" ng-click=\"main.changeReceiptAll(1, main.receipt_num_asc == 1 ? 2 : 1)\">Serie <span ng-class=\"{\'fa fa-sort-desc\': main.receipt_num_asc == 1, \'fa fa-sort-asc\': main.receipt_num_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == true\" width=\"15%\" ng-click=\"main.changeReceiptAll(2, main.receipt_cont_asc == 1 ? 2 : 1)\">Contratante<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_cont_asc == 1, \'fa fa-sort-asc\': main.receipt_cont_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == true\" width=\"10%\" ng-click=\"main.changeReceiptAll(3, main.receipt_nump_asc == 1 ? 2 : 1)\">Número de póliza<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_nump_asc == 1, \'fa fa-sort-asc\': main.receipt_nump_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == true\" width=\"10%\" ng-click=\"main.changeReceiptAll(4, main.receipt_vig_asc == 1 ? 2 : 1)\">Inicio de Vigencia<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_vig_asc == 1, \'fa fa-sort-asc\': main.receipt_vig_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == true\" width=\"10%\" ng-click=\"main.changeReceiptAll(5, main.receipt_subr_asc == 1 ? 2 : 1)\">Subramo<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_subr_asc == 1, \'fa fa-sort-asc\': main.receipt_subr_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == true\" width=\"10%\" ng-click=\"main.changeReceiptAll(6, main.receipt_aseg_asc == 1 ? 2 : 1)\">Aseguradora<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_aseg_asc == 1, \'fa fa-sort-asc\': main.receipt_aseg_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == true\" width=\"5%\" ng-click=\"main.changeReceiptAll(7, main.receipt_venc_asc == 1 ? 2 : 1)\">Fecha de vencimiento<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_venc_asc == 1, \'fa fa-sort-asc\': main.receipt_venc_asc == 2}\"></span></th><th ng-if=\"main.show_cobranza == true\" width=\"10%\" ng-click=\"main.changeReceiptAll(8, main.receipt_pneta == 1 ? 2 : 1)\">Prima total<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_pneta == 1, \'fa fa-sort-asc\': main.receipt_pneta == 2}\"></span></th></div><th width=\"10%\">Identificador</th><th width=\"10%\">Sucursal</th><th ng-if=\"ver_referenciador\" width=\"10%\">Vendedor</th><th width=\"10%\">Antigüedad</th><th width=\"10%\" ng-click=\"main.changeReceiptAll(13, main.receipt_promesa_pago == 1 ? 2 : 1)\">Promesa de pago<span ng-class=\"{\'fa fa-sort-desc\': main.receipt_promesa_pago == 1, \'fa fa-sort-asc\': main.receipt_promesa_pago == 2}\"></span></th><th width=\"10%\">Acciones</th></tr></thead><tbody><tr ng-repeat=\"receipt in main.receipts track by $index\" ng-click=\"main.editRecibo(receipt)\" ng-init=\"sel_rec\"><td ng-click=\"$event.stopPropagation()\"><label><input type=\"checkbox\" ng-model=\"receipt.toPay\" ng-click=\"massiveReceipts(receipt,receipt.toPay)\" class=\"checkbox\"></label></td><td>{{rectype(receipt)}}</td><td align=\"center\">{{ receipt.recibo_numero }}</td><td><span ng-if=\"receipt.poliza && receipt.poliza.document_type != 4\">{{ receipt.poliza.contractor}}</span> <span ng-if=\"receipt.poliza.document_type == 4\">{{receipt.poliza.parent.contractor.full_name}} <span class=\"color-blue\">({{receipt.poliza.contractor}})</span></span></td><td ng-if=\"receipt.poliza.document_type != 12\">{{ receipt.poliza.poliza_number }}{{ receipt.poliza.parent.poliza_number }}{{ receipt.fianza.fianza_number }}{{ receipt.fianza.parent.fianza_number }}</td><td ng-if=\"receipt.poliza.document_type == 12\">{{ receipt.poliza.poliza_number }}</td><td>{{ receipt.fecha_inicio | date:\"dd/MM/yyyy\" : \'UTC\' }}</td><td ng-if=\"receipt.poliza.document_type != 4\">{{ receipt.poliza.subramo }}{{ receipt.fianza.subramo }} <span ng-if=\"receipt.poliza.automobiles_policy.length\">/ {{receipt.poliza.automobiles_policy[0].model}}</span></td><td ng-if=\"receipt.poliza.document_type == 4\">{{ receipt.poliza.parent.subramo.subramo_name }}</td><td ng-if=\"receipt.poliza.document_type != 4\">{{ receipt.poliza.aseguradora }}{{ receipt.fianza.afianzadora }}</td><td ng-if=\"receipt.poliza.document_type == 4\">{{ receipt.poliza.parent.aseguradora.alias }}{{ receipt.fianza.parent.afianzadora.alias }}</td><td>{{ receipt.vencimiento| date:\"dd/MM/yyyy\" : \'UTC\'}}</td><td>{{receipt.prima_total | currency}} <span ng-if=\"receipt.status==9 || receipt.status ==\'Pago parcial\'\" class=\"color-blue\">{{ statusRecibo(receipt.status) }}</span></td><td><span ng-if=\"receipt.poliza\">{{receipt.poliza.identifier}}</span> <span ng-if=\"!receipt.fianza && !receipt.poliza\">No aplica</span></td><td>{{receipt.poliza.sucursal.sucursal_name}}</td><td ng-if=\"receipt.poliza.document_type != 4 && ver_referenciador\"><span ng-if=\"receipt.poliza.vendor && !receipt.poliza.ref_policy\">{{receipt.poliza.vendor.first_name}} {{receipt.poliza.vendor.last_name}}</span> <span ng-if=\"receipt.fianza.vendor\">{{receipt.fianza.vendor.first_name}} {{receipt.fianza.vendor.last_name}}</span> <span ng-if=\"receipt.poliza.ref_policy && !receipt.poliza.vendor\">{{receipt.poliza.ref_policy[0].referenciador.first_name}} {{receipt.poliza.ref_policy[0].referenciador.last_name}}</span> <span ng-if=\"receipt.poliza.vendor && receipt.poliza.ref_policy\">{{receipt.poliza.vendor.first_name}} {{receipt.poliza.vendor.last_name}}</span></td><td ng-if=\"receipt.poliza.document_type == 4 && ver_referenciador\">{{receipt.poliza.parent.vendor.first_name}} {{receipt.poliza.parent.vendor.last_name}} <span ng-if=\"receipt.poliza.parent.ref_policy\"><span ng-repeat=\"rpol in receipt.poliza.parent.ref_policy\">{{rpol.referenciador.first_name}} {{rpol.referenciador.last_name}},</span></span></td><td>{{receipt.antiguedad}} días</td><td>{{ receipt.promesa_pago | date:\"dd/MM/yyyy\" : \'UTC\' }}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-click=\"main.showPhone(receipt)\" ng-disabled=\"!receipt.contratante.phone\"><i class=\"fa fa-phone\"></i></a><div ng-if=\"receipt.track_phone\" class=\"identificador-dash-phone\"></div><a class=\"btn btn-white btn-sm\" ng-if=\"main.acceso_cor && main.acceso_adm_pol\" ng-click=\"addEmailsConfirm(receipt, receipt.poliza.parent,receipt)\"><i class=\"fa fa-envelope\"></i></a><div ng-if=\"receipt.track_mensajeria\" class=\"identificador-dash-whatsapp\"></div><a class=\"btn btn-white btn-sm\" ng-if=\"main.acceso_adm_pol\" ng-click=\"addPhoneWhatsapp(receipt, receipt.poliza.parent,receipt)\" title=\"{{ main.whatsappWebEnabled ? \'Recordatorio por WhatsApp Web\' : \'Recordatorio por SMS\' }}\"><img ng-if=\"!main.whatsappWebEnabled\" style=\"height: 15px;\" class=\"icon-menu\" src=\"../../assets/comment-sms-solid.svg\"> <i ng-if=\"main.whatsappWebEnabled\" class=\"fa fa-whatsapp\"></i></a><div ng-if=\"receipt.track_email\" class=\"identificador-dash-email\"></div><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); main.showBinnacle(receipt, \'recibo\')\"><i class=\"fa fa-comments\" aria-hidden=\"true\"></i></a><div ng-if=\"receipt.track_bitacora\" class=\"identificador-dash-binnacle\"></div><a ng-if=\"receipt.poliza.conducto_de_pago != \'No domiciliada\'\" ng-click=\"$event.stopPropagation(); sel_rec = receipt\" class=\"btn btn-white btn-sm\" title=\"{{receipt.poliza.conducto_de_pago}}\"><i ng-if=\"receipt.poliza.conducto_de_pago == \'Agente\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CAC\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CAT/Domiciliado\'\" class=\"fa fa-credit-card-alt\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'Nómina\'\" class=\"fa fa-money\" aria-hidden=\"true\"></i> <i ng-if=\"receipt.poliza.conducto_de_pago == \'CUT\'\" class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-default sm\" style=\"color: red\" ng-click=\"$event.stopPropagation()\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\" ng-if=\"receipt.endosotramite\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\"></i></a><tasks click=\"addtask()\" type=\"3\" model=\"receipt.recibo_numero + \' de la póliza \' + receipt.poliza.poliza_number\" associated=\"receipt.poliza.id\"></tasks></td></tr></tbody></table><div class=\"col-xs-12\"><div class=\"identificador-dash-phone\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se hizo una llamada.</span><div class=\"identificador-dash-email\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se envio un correo.</span><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div><div ng-if=\"main.show_paginationReceipts || (show_receipts_pagination && main.config_receipts.count > 10)\"><pagination config=\"main.config_receipts\" model=\"main.receipts\"></pagination></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><button ng-if=\"main.show_cobranza == false && main.acceso_rep_cob\" ng-model=\"vm.buttonReport\" class=\"col-xs-12 btn btn-primary ladda-button3\" ng-click=\"main.exportDataReceipts(2)\">Generar Reporte</button> <button ng-if=\"main.show_cobranza == true && main.acceso_rep_cob\" ng-model=\"vm.buttonReport\" class=\"col-xs-12 btn btn-primary ladda-button3\" ng-click=\"main.exportDataReceiptsAll(2)\">Generar Reporte</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"main.acceso_pag_cob\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"main.pagarRecibos(main.receipts,1)\" ng-disabled=\"main.recibos_a_pagar.length == 0\">Pagar recibos seleccionados</button></div></div><div class=\"row animate\" ng-if=\"main.show_binnacle_receipt\"><div class=\"col-xs-12\"><label>Bitácora de Recibos</label><div class=\"col-xs-12 margin-top-24\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"main.returnToReceipts(2,main.receipts,main.title,main.titleID)\"><span class=\"fa fa-reply\"></span> Regresar</button></div><div class=\"col-xs-12\"><comments datasource=\"main.comments_data_receipt\" typemodel=\"4\" config=\"main.comments_config_receipt\" idmodel=\"main.receipt_id\" receiptmodel=\"main.receipt_url\"></comments></div></div></div></div></div></div></div><div ng-show=\"main.notas\" class=\"row flex-container\" id=\"myTable\" ng-if=\"main.permiso_g_cob\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Notas de crédito</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"m-b\"><input type=\"text\" ng-model=\"main.cadena\" class=\"form-control\" placeholder=\"Buscar en notas de crédito (Contratante, folio, no. póliza)\" ng-enter=\"main.searchNotas(main.cadena)\"></div><div class=\"table-responsive\" ng-if=\"!main.show_binnacle_receipt\"><table class=\"table table-striped table-bordered table-hover\" id=\"notas\"><thead><tr><th ng-if=\"main.show_nota == false\" width=\"5%\" ng-click=\"main.changeNCr(1, main.nota_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': main.nota_cont_asc == 1, \'fa fa-sort-asc\': main.nota_cont_asc == 2}\"></span></th><th ng-if=\"main.show_nota == false\" width=\"5%\">Aseguradora</th><th ng-if=\"main.show_nota == false\" width=\"5%\" ng-click=\"main.changeNCr(2, main.nota_folio_asc == 1 ? 2 : 1)\">Folio de la Nota <span ng-class=\"{\'fa fa-sort-desc\': main.nota_folio_asc == 1, \'fa fa-sort-asc\': main.nota_folio_asc == 2}\"></span></th><th ng-if=\"main.show_nota == false\" width=\"5%\" ng-click=\"main.changeNCr(3, main.nota_numend_asc == 1 ? 2 : 1)\">Número de Endoso <span ng-class=\"{\'fa fa-sort-desc\': main.nota_numend_asc == 1, \'fa fa-sort-asc\': main.nota_numend_asc == 2}\"></span></th><th ng-if=\"main.show_nota == false\" width=\"5%\" ng-click=\"main.changeNCr(4, main.nota_numpol_asc == 1 ? 2 : 1)\">Número de Póliza <span ng-class=\"{\'fa fa-sort-desc\': main.nota_numpol_asc == 1, \'fa fa-sort-asc\': main.nota_numpol_asc == 2}\"></span></th><th ng-if=\"main.show_nota == false\" width=\"5%\" ng-click=\"main.changeNCr(5, main.nota_fecha_asc == 1 ? 2 : 1)\">Fecha de Emisión <span ng-class=\"{\'fa fa-sort-desc\': main.nota_fecha_asc == 1, \'fa fa-sort-asc\': main.nota_fecha_asc == 2}\"></span></th><th ng-if=\"main.show_nota == false\" width=\"5%\" ng-click=\"main.changeNCr(6, main.nota_ptotal_asc == 1 ? 2 : 1)\">Prima Total <span ng-class=\"{\'fa fa-sort-desc\': main.nota_ptotal_asc == 1, \'fa fa-sort-asc\': main.nota_ptotal_asc == 2}\"></span></th><th width=\"5%\">Vigencia</th><th width=\"5%\">Estatus</th><th width=\"5%\">Antiguedad</th><th width=\"5%\">Acciones</th></tr></thead><tbody><tr ng-repeat=\"receipt in main.notascredito track by $index\" ng-click=\"main.NotasModal(receipt)\"><td>{{ receipt.endorsement.policy.contractor}}</td><td>{{ receipt.policy.aseguradora }}</td><td>{{ receipt.folio }}</td><td>{{receipt.endorsement.number_endorsement}}</td><td>{{receipt.endorsement.policy.poliza_number}}</td><td>{{ receipt.fecha_emision | date:\"dd/MM/yyyy\" : \'UTC\' }}</td><td>{{ receipt.prima_total }} <span ng-if=\"receipt.status==9 || receipt.status ==\'Pago parcial\'\" class=\"color-blue\">{{ statusRecibo(receipt.status) }}</span></td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\' }}</td><td>{{ checkStatusNotes(receipt.status) }}</td><td>{{receipt.antiguedad}} días</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); main.showBinnacle(receipt, \'recibo\')\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"3\" model=\"receipt.recibo_numero + \' de la póliza \' + receipt.poliza.poliza_number\" associated=\"receipt.poliza.id\"></tasks></td></tr></tbody></table><div ng-if=\"main.show_paginationNote || (show_note_pagination && main.config_notes.count > 10)\"><pagination config=\"main.config_notes\" model=\"main.notascredito\"></pagination></div><button ng-if=\"main.acceso_rep_cob\" ng-model=\"vm.buttonReport\" class=\"col-xs-3 btn btn-primary ladda-button3\" ng-click=\"main.exportDataReceipts(5)\">Generar Reporte</button></div><div class=\"row animate\" ng-if=\"main.show_binnacle_receipt\"><div class=\"col-xs-12\"><label>Bitácora de Recibos</label><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3\"><a class=\"col-xs-12 btn btn-info\" ng-click=\"main.returnToReceipts(2)\"><span class=\"fa fa-reply\"></span> Regresar</a></div><div class=\"col-xs-12 margin-top-24\"></div><div class=\"col-xs-12\"><comments datasource=\"main.comments_data_receipt\" typemodel=\"4\" config=\"main.comments_config_receipt\" idmodel=\"main.receipt_id\" receiptmodel=\"receiptmodel\"></comments></div></div></div></div></div></div></div><div ng-show=\"main.renewalTable\" class=\"row flex-container\" id=\"myTable\" ng-if=\"main.permiso_g_ren\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Renovaciones <span ng-if=\"main.titleID==1\" style=\"color: #17A45D;\">{{main.title}}</span> <span ng-if=\"main.titleID==2\" style=\"color: #F5CD21;\">{{main.title}}</span> <span ng-if=\"main.titleID==3\" style=\"color: #EA9021;\">{{main.title}}</span> <span ng-if=\"main.titleID==4\" style=\"color: #EA5121;\">{{main.title}}</span></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"input-group m-b\" style=\"z-index: 0;\"><input ng-model=\"main.cadena\" placeholder=\"Buscar en renovaciones {{main.title}} (Contratante, subramo, ramo, aseguradora, no. póliza)\" ng-enter=\"main.searchRenewals(main.cadena,main.titleID)\" class=\"form-control search-custom\" style=\"height: 34px; margin-top: 13px;\" name=\"top-search\" id=\"top-search\"> <span class=\"input-group-btn\"><button ng-click=\"main.searchRenewals(main.cadena,main.titleID)\" class=\"btn btn-success\" style=\"margin-top: 13px;\" type=\"button\">Buscar</button></span></div><div class=\"table-responsive animate\" ng-if=\"!main.show_binnacle_renewal\" id=\"tableDash\"><table class=\"table table-striped table-bordered table-hover\" id=\"renovacion\"><thead><tr><th ng-if=\"main.show_renewal == false\" ng-click=\"main.changeRen(1, main.ren_nump_asc == 1 ? 2 : 1)\">Número de Póliza <span ng-class=\"{\'fa fa-sort-desc\': main.ren_nump_asc == 1, \'fa fa-sort-asc\': main.ren_nump_asc == 2}\"></span></th><th ng-if=\"main.show_renewal == false\" ng-click=\"main.changeRen(2, main.ren_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': main.ren_cont_asc == 1, \'fa fa-sort-asc\': main.ren_cont_asc == 2}\"></span></th><th ng-if=\"main.show_renewal == false\" ng-click=\"main.changeRen(3, main.ren_subr_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': main.ren_subr_asc == 1, \'fa fa-sort-asc\': main.ren_subr_asc == 2}\"></span></th><th ng-if=\"main.show_renewal == false\" ng-click=\"main.changeRen(4, main.ren_aseg_asc == 1 ? 2 : 1)\">Aseguradora <span ng-class=\"{\'fa fa-sort-desc\': main.ren_aseg_asc == 1, \'fa fa-sort-asc\': main.ren_aseg_asc == 2}\"></span></th><th ng-if=\"main.show_renewal == false\">Estatus</th><th ng-if=\"main.show_renewal == false\" ng-click=\"main.changeRen(5, main.ren_vig_asc == 1 ? 2 : 1)\">Fin de Vigencia <span ng-class=\"{\'fa fa-sort-desc\': main.ren_vig_asc == 1, \'fa fa-sort-asc\': main.ren_vig_asc == 2}\"></span></th><th ng-if=\"main.show_renewal == true\" ng-click=\"main.changeRenAll(1, main.ren_nump_asc == 1 ? 2 : 1)\">Número de Póliza <span ng-class=\"{\'fa fa-sort-desc\': main.ren_nump_asc == 1, \'fa fa-sort-asc\': main.ren_nump_asc == 2}\"></span></th><th ng-if=\"main.show_renewal == true\" ng-click=\"main.changeRenAll(2, main.ren_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': main.ren_cont_asc == 1, \'fa fa-sort-asc\': main.ren_cont_asc == 2}\"></span></th><th ng-if=\"main.show_renewal == true\" ng-click=\"main.changeRenAll(3, main.ren_subr_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': main.ren_subr_asc == 1, \'fa fa-sort-asc\': main.ren_subr_asc == 2}\"></span></th><th ng-if=\"main.show_renewal == true\" ng-click=\"main.changeRenAll(4, main.ren_aseg_asc == 1 ? 2 : 1)\">Aseguradora <span ng-class=\"{\'fa fa-sort-desc\': main.ren_aseg_asc == 1, \'fa fa-sort-asc\': main.ren_aseg_asc == 2}\"></span></th><th ng-if=\"main.show_renewal == true\">Estatus</th><th ng-if=\"main.show_renewal == true\" ng-click=\"main.changeRenAll(5, main.ren_vig_asc == 1 ? 2 : 1)\">Fin de Vigencia <span ng-class=\"{\'fa fa-sort-desc\': main.ren_vig_asc == 1, \'fa fa-sort-asc\': main.ren_vig_asc == 2}\"></span></th><th>Antigüedad</th><th>Acciones</th></tr></thead><tbody><tr ng-click=\"main.renewPolicy(policy)\" ng-repeat=\"policy in main.policies track by $index\"><td>{{policy.poliza_number}}</td><td>{{policy.contractor.full_name }}</td><td>{{policy.subramo }}</td><td>{{policy.aseguradora }}</td><td>{{ status(policy.status) }} <span ng-if=\"orgName ==\'ancora\' && policy.is_renewable==1 && policy.status ==13 || policy.status ==\'Vencida\'\">- En Proceso de Renovación</span><span ng-if=\"policy.renewed_status == 2 && orgName !=\'ancora\'\">- <strong>En proceso de renovación</strong></span></td><td>{{policy.end_of_validity | date:\"dd/MM/yyyy\" : \'UTC\'}}</td><td>{{policy.antiguedad }} días</td><td><a class=\"btn btn-white btn-sm\" ng-if=\"!policy.track_bitacora\" ng-click=\"$event.stopPropagation(); main.showBinnacle(policy, \'renovacion\')\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-warning btn-sm\" ng-if=\"policy.track_bitacora\" ng-click=\"$event.stopPropagation(); main.showBinnacle(policy, \'renovacion\')\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"5\" model=\"policy.poliza_number\" associated=\"policy.id\"></tasks></td></tr></tbody></table><div class=\"col-xs-12\" ng-if=\"!show_binnacle_receipt\"><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div><div ng-if=\"main.show_paginationRenewals || ( show_renovaciones_pagination && main.config_renovaciones.count > 10)\"><pagination config=\"main.config_renovaciones\" model=\"main.policies\"></pagination></div></div><div ng-if=\"!main.show_binnacle_renewal\"><button ng-if=\"main.show_renewal == false && main.acceso_rep_ren\" ng-model=\"vm.buttonReport\" class=\"col-xs-3 btn btn-primary ladda-button2\" ng-click=\"main.exportDataRenewal(3,main.cadena)\">Generar Reporte</button> <button ng-if=\"main.show_renewal == true && main.acceso_rep_ren\" ng-model=\"vm.buttonReport\" class=\"col-xs-3 btn btn-primary ladda-button2\" ng-click=\"main.exportDataRenewalAll(3,main.cadena)\">Generar Reporte</button></div><div class=\"row animate\" ng-if=\"main.show_binnacle_renewal\"><div class=\"col-xs-12\"><div class=\"col-xs-12 margin-top-24\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"main.returnToReceipts(3)\"><span class=\"fa fa-reply\"></span> Regresar</button></div><div class=\"col-xs-12\"><comments datasource=\"main.comments_data_renewal\" typemodel=\"6\" config=\"main.comments_config_renewal\" idmodel=\"main.renewal_id\"></comments></div></div></div></div></div></div></div><div ng-show=\"main.sinisterTable\" class=\"row flex-container\" id=\"myTable\" ng-if=\"main.permiso_g_sin\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Siniestros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"input-group m-b\" style=\"z-index: 0;\"><input placeholder=\"Buscar en siniestros {{main.title}} (Contratante, subramo, ramo, aseguradora, no. póliza)\" ng-model=\"main.cadena\" ng-enter=\"main.searchSinisters(main.cadena,main.titleID)\" class=\"form-control search-custom\" style=\"height: 34px; margin-top: 13px;\" name=\"top-search\" id=\"top-search\"> <span class=\"input-group-btn\"><button ng-click=\"main.searchSinisters(main.cadena,main.titleID)\" class=\"btn btn-success\" style=\"margin-top: 13px;\" type=\"button\">Buscar</button></span></div><div class=\"table-responsive\" id=\"tableDash\"><table class=\"table table-striped table-bordered table-hover\" id=\"siniestro\"><thead><tr><th ng-if=\"main.show_sinister == false\" ng-click=\"main.changeSin(1, main.sin_afec_asc == 1 ? 2 : 1)\">Afectado <span ng-class=\"{\'fa fa-sort-desc\': main.sin_afec_asc == 1, \'fa fa-sort-asc\': main.sin_afec_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == false\" ng-click=\"main.changeSin(2, main.sin_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': main.sin_cont_asc == 1, \'fa fa-sort-asc\': main.sin_cont_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == false\" ng-click=\"main.changeSin(3, main.sin_aseg_asc == 1 ? 2 : 1)\">Aseguradora <span ng-class=\"{\'fa fa-sort-desc\': main.sin_aseg_asc == 1, \'fa fa-sort-asc\': main.sin_aseg_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == false\" ng-click=\"main.changeSin(4, main.sin_nump_asc == 1 ? 2 : 1)\">Número de Póliza <span ng-class=\"{\'fa fa-sort-desc\': main.sin_nump_asc == 1, \'fa fa-sort-asc\': main.sin_nump_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == false\" ng-click=\"main.changeSin(5, main.sin_nums_asc == 1 ? 2 : 1)\">Número de Siniestro <span ng-class=\"{\'fa fa-sort-desc\': main.sin_nums_asc == 1, \'fa fa-sort-asc\': main.sin_nums_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == false\" ng-click=\"main.changeSin(6, main.sin_subr_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': main.sin_subr_asc == 1, \'fa fa-sort-asc\': main.sin_subr_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == false\" ng-click=\"main.changeSin(7, main.sin_fecha_asc == 1 ? 2 : 1)\">Fecha Captura<span ng-class=\"{\'fa fa-sort-desc\': main.sin_fecha_asc == 1, \'fa fa-sort-asc\': main.sin_fecha_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == false\" ng-click=\"main.changeSin(12, main.sin_ingreso_asc == 1 ? 2 : 1)\">Fecha Ingreso<span ng-class=\"{\'fa fa-sort-desc\': main.sin_ingreso_asc == 1, \'fa fa-sort-asc\': main.sin_ingreso_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == false\" ng-click=\"main.changeSin(13, main.sin_compromiso_asc == 1 ? 2 : 1)\">Fecha Compromiso<span ng-class=\"{\'fa fa-sort-desc\': main.sin_compromiso_asc == 1, \'fa fa-sort-asc\': main.sin_compromiso_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == false\">Reclamado</th><th ng-if=\"main.show_sinister == false\">Tipo pago</th><th ng-if=\"main.show_sinister == false\">Padecimiento</th><th ng-if=\"main.show_sinister == false\" ng-click=\"main.changeSin(9, main.sin_status_asc == 1 ? 2 : 1)\">Estatus <span ng-class=\"{\'fa fa-sort-desc\': main.sin_status_asc == 1, \'fa fa-sort-asc\': main.sin_status_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == false\">Antiguedad</th><th ng-if=\"main.show_sinister == true\" ng-click=\"main.changeSinAll(1, main.sin_afec_asc == 1 ? 2 : 1)\">Afectado <span ng-class=\"{\'fa fa-sort-desc\': main.sin_afec_asc == 1, \'fa fa-sort-asc\': main.sin_afec_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == true\" ng-click=\"main.changeSinAll(2, main.sin_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': main.sin_cont_asc == 1, \'fa fa-sort-asc\': main.sin_cont_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == true\" ng-click=\"main.changeSinAll(3, main.sin_aseg_asc == 1 ? 2 : 1)\">Aseguradora <span ng-class=\"{\'fa fa-sort-desc\': main.sin_aseg_asc == 1, \'fa fa-sort-asc\': main.sin_aseg_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == true\" ng-click=\"main.changeSinAll(4, main.sin_nump_asc == 1 ? 2 : 1)\">Número de Póliza <span ng-class=\"{\'fa fa-sort-desc\': main.sin_nump_asc == 1, \'fa fa-sort-asc\': main.sin_nump_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == true\" ng-click=\"main.changeSinAll(5, main.sin_nums_asc == 1 ? 2 : 1)\">Número de Siniestro <span ng-class=\"{\'fa fa-sort-desc\': main.sin_nums_asc == 1, \'fa fa-sort-asc\': main.sin_nums_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == true\" ng-click=\"main.changeSinAll(6, main.sin_subr_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': main.sin_subr_asc == 1, \'fa fa-sort-asc\': main.sin_subr_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == true\" ng-click=\"main.changeSinAll(7, main.sin_fecha_asc == 1 ? 2 : 1)\">Fecha Captura <span ng-class=\"{\'fa fa-sort-desc\': main.sin_fecha_asc == 1, \'fa fa-sort-asc\': main.sin_fecha_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == true\" ng-click=\"main.changeSin(12, main.sin_ingreso_asc == 1 ? 2 : 1)\">Fecha Ingreso<span ng-class=\"{\'fa fa-sort-desc\': main.sin_ingreso_asc == 1, \'fa fa-sort-asc\': main.sin_ingreso_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == true\" ng-click=\"main.changeSin(13, main.sin_compromiso_asc == 1 ? 2 : 1)\">Fecha Compromiso<span ng-class=\"{\'fa fa-sort-desc\': main.sin_compromiso_asc == 1, \'fa fa-sort-asc\': main.sin_compromiso_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == true\">Reclamado</th><th ng-if=\"main.show_sinister == true\">Tipo pago</th><th ng-if=\"main.show_sinister == true\">Padecimiento</th><th ng-if=\"main.show_sinister == true\" ng-click=\"main.changeSinAll(8, main.sin_status_asc == 1 ? 2 : 1)\">Estatus <span ng-class=\"{\'fa fa-sort-desc\': main.sin_status_asc == 1, \'fa fa-sort-asc\': main.sin_status_asc == 2}\"></span></th><th ng-if=\"main.show_sinister == true\">Antiguedad</th><th>Acciones <span ng-class=\"{\'fa fa-sort-desc\': main.sin_ant_asc == 1, \'fa fa-sort-asc\': main.sin_ant_asc == 2}\"></span></th></tr></thead><tbody><tr ng-repeat=\"siniestro in main.sinisters track by $index\" ng-click=\"main.siniesterInfo(siniestro)\"><td><span ng-if=\"siniestro.poliza.accidents_policy.length\"><span ng-if=\"siniestro.accidente_sinister[0].dependiente\">{{ siniestro.accidente_sinister[0].dependiente.first_name }} {{ siniestro.accidente_sinister[0].dependiente.last_name }} {{ siniestro.accidente_sinister[0].dependiente.second_last__name }}</span> <span ng-if=\"siniestro.accidente_sinister[0].titular\">{{ siniestro.accidente_sinister[0].titular.first_name }} {{ siniestro.accidente_sinister[0].titular.last_name }} {{ siniestro.accidente_sinister[0].titular.second_last__name }}</span> <span ng-if=\"!siniestro.accidente_sinister[0].titular && !siniestro.accidente_sinister[0].dependiente\">{{ siniestro.accidente_sinister[0].affected_full_name }}</span></span> <span ng-if=\"siniestro.vida_siniester.length\"><span ng-if=\"siniestro.vida_siniester[0].nombre_afectado\">{{ siniestro.vida_siniester[0].nombre_afectado }}</span> <span ng-if=\"siniestro.accidente_sinister[0].titular\">{{ siniestro.accidente_sinister[0].titular.first_name }} {{ siniestro.accidente_sinister[0].titular.last_name }} {{ siniestro.accidente_sinister[0].titular.second_last__name }}</span> <span ng-if=\"!siniestro.accidente_sinister && siniestro.accidente_sinister.affected_full_name\">{{ siniestro.accidente_sinister.affected_full_name }}</span></span> <span ng-if=\"siniestro.poliza.automobiles_policy.length\">{{siniestro.poliza.automobiles_policy[0].serial}} - {{siniestro.poliza.automobiles_policy[0].version}} - {{siniestro.poliza.automobiles_policy[0].year}}</span> <span ng-if=\"siniestro.poliza.damages_policy.length\">{{siniestro.poliza.damages_policy[0].insured_item}}</span> <span ng-if=\"siniestro.danios_sinister[0].bien_asegurado && !siniestro.poliza.damages_policy.length\">{{siniestro.danios_sinister[0].bien_asegurado}}</span> <span ng-if=\"!siniestro.danios_sinister[0].bien_asegurado && !siniestro.poliza.damages_policy.length\">{{ siniestro.aux_affected }}</span> <span ng-if=\"siniestro.poliza.life_policy.length && !siniestro.vida_siniester[0].nombre_afectado\"><span ng-if=\"siniestro.poliza.life_policy[0].personal.full_name\">{{ siniestro.poliza.life_policy[0].personal.full_name }}</span> <span ng-if=\"!siniestro.poliza.life_policy[0].personal.full_name\">{{ siniestro.poliza.life_policy[0].personal.first_name }} {{ siniestro.poliza.life_policy[0].personal.last_name }}</span></span></td><td><span ng-if=\"siniestro.poliza.contractor\">{{siniestro.poliza.contractor}}</span> <span ng-if=\"!siniestro.poliza.contractor\">{{siniestro.poliza.parent.parent.parent.contractor.full_name}}</span></td><td ng-if=\"!siniestro.poliza.aseguradora\">{{siniestro.poliza.parent.parent.parent.aseguradora.alias}}</td><td ng-if=\"siniestro.poliza.aseguradora\">{{siniestro.poliza.aseguradora}}</td><td>{{siniestro.poliza.poliza_number}}</td><td>{{siniestro.numero_siniestro}}</td><td>{{siniestro.poliza.subramo}}</td><td><span ng-if=\"siniestro.fecha_ingreso\">{{siniestro.fecha_ingreso | date:\"dd/MM/yyyy\" : \'UTC\' }}</span></td><td><span ng-if=\"siniestro.fecha\">{{siniestro.fecha | date:\"dd/MM/yyyy\" : \'UTC\' }}</span></td><td><span ng-if=\"siniestro.fecha_compromiso\">{{siniestro.fecha_compromiso | date:\"dd/MM/yyyy\" : \'UTC\' }}</span></td><td>{{siniestro.accidente_sinister[0].total_reclamado | currency : symbol : fractionSize}}</td><td>{{tipoPagoSinister(siniestro.accidente_sinister[0].tipo_pago)}}</td><td ng-if=\"siniestro.accidente_sinister.length\">{{siniestro.accidente_sinister[0].ailment}}</td><td ng-if=\"!siniestro.accidente_sinister.length\">No aplica</td><td>{{ statusSinister(siniestro.status) }}</td><td>{{ siniestro.antiguedad }} días</td><td><tasks click=\"addtask()\" type=\"6\" model=\"siniestro.numero_siniestro + \' de la póliza \' + siniestro.poliza.poliza_number\" associated=\"siniestro.id\"></tasks><button class=\"btn btn-white btn-sm\" ng-if=\"main.whatsappWebEnabled\" ng-click=\"$event.stopPropagation(); main.sendWhatsAppWeb(siniestro)\"><i class=\"fa fa-whatsapp\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div ng-if=\"main.show_sinisters_pagination && main.config_sinisters.count > 10\"><pagination config=\"main.config_sinisters\" model=\"main.sinisters\"></pagination></div><button ng-if=\"main.show_sinister == false && main.search == false && main.acceso_rep_sin\" ng-model=\"vm.buttonReport\" class=\"col-xs-3 btn btn-primary ladda-button\" ng-click=\"main.exportDataSinister(4)\">Generar Reporte</button> <button ng-if=\"main.show_sinister == true && main.search == false && main.acceso_rep_sin\" ng-model=\"vm.buttonReport\" class=\"col-xs-3 btn btn-primary ladda-button\" ng-click=\"main.exportDataSinAll(4)\">Generar Reporte</button> <button ng-if=\"main.search == true && main.acceso_rep_sin\" ng-model=\"vm.buttonReport\" class=\"col-xs-3 btn btn-primary\" ng-click=\"main.excel_search(main.cadena,main.titleID)\">Generar Reporte</button></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"main.acceso_ver_cob && main.acceso_pag_cob\"><div class=\"ibox\"><button id=\"verTareas\" ng-click=\"createTask(\'Tareas\', \'task.task\')\" class=\"btn btn-outline btn-block btn-primary dim\">Crear Tarea</button></div></div><div class=\"row flex-center\"><div class=\"col-xs-6 col-sm-1 col-md-1 pull-right\"><div class=\"ibox\"><button ng-if=\"!has_sr_conf\" ng-click=\"filtrosSubramos()\" class=\"btn btn-outline btn-block btn-default dim btn-sm\"><i class=\"fa fa-cog\" aria-hidden=\"true\"></i></button> <button ng-if=\"has_sr_conf\" ng-click=\"filtrosSubramos()\" class=\"btn btn-outline btn-block btn-primary dim btn-sm\"><i class=\"fa fa-cog\" aria-hidden=\"true\"></i></button></div></div></div><div class=\"row flex-center\" ng-if=\"hide_task\"><div class=\"col-xs-12 form-group\"></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12 form-group\"><h3 class=\"text-center\"><i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i> Tareas <a ng-click=\"hideTask(false)\"><i class=\"fa fa-eye pull-right\" aria-hidden=\"true\"></i></a></h3></div></div></div></div><div class=\"container-fluid\"><div class=\"row d-flex justify-content-between\" ng-init=\"showTask()\" ng-if=\"!hide_task\"><div class=\"col-md-6\"><div class=\"ibox-content\"><h3 class=\"text-center\"><i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i> Tareas <a ng-click=\"configGraph(5)\"><i class=\"fa fa-wrench pull-right\" aria-hidden=\"true\"></i></a></h3><a ng-click=\"hideTask(true)\"><i class=\"fa fa-close pull-right\" aria-hidden=\"true\"></i></a><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" ng-click=\"showTableTasks(1)\" title=\"{{chartsTasks.green.title}}\"><h3 style=\"color: #17A45D;\">{{ chartsTasks.green.status }}</h3><p class=\"small\">{{ chartsTasks.green.label }}</p><div class=\"progress progress-mini\"><div style=\"width: {{ chartsTasks.green.percent }}%;background: #17A45D;\" class=\"progress-bar\"></div></div><p class=\"no-margins small pull-right\">ALTA: {{ chartsTasks.green.Alta }} | MEDIA: {{ chartsTasks.green.Media }} | BAJA: {{ chartsTasks.green.Baja }}</p></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" ng-click=\"showTableTasks(2)\" title=\"{{chartsTasks.yellow.title}}\"><h3 style=\"color: #F5CD21;\">{{ chartsTasks.yellow.status }}</h3><p class=\"small\">{{ chartsTasks.yellow.label }}</p><div class=\"progress progress-mini\"><div style=\"width: {{ chartsTasks.yellow.percent }}%;background: #F5CD21;\" class=\"progress-bar\"></div></div><p class=\"no-margins small pull-right\">ALTA: {{ chartsTasks.yellow.Alta }} | MEDIA: {{ chartsTasks.yellow.Media }} | BAJA: {{ chartsTasks.yellow.Baja }}</p></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" ng-click=\"showTableTasks(3)\" title=\"{{chartsTasks.orange.title}}\"><h3 style=\"color: #EA9021;\">{{ chartsTasks.orange.status }}</h3><p class=\"small\">{{ chartsTasks.orange.label }}</p><div class=\"progress progress-mini\"><div style=\"width: {{ chartsTasks.orange.percent }}%;background: #EA9021;\" class=\"progress-bar\"></div></div><p class=\"no-margins small pull-right\">ALTA: {{ chartsTasks.orange.Alta }} | MEDIA: {{ chartsTasks.orange.Media }} | BAJA: {{ chartsTasks.orange.Baja }}</p></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" ng-click=\"showTableTasks(4)\" title=\"{{chartsTasks.red.title}}\"><h3 style=\"color: #EA5121;\">{{ chartsTasks.red.status }}</h3><p class=\"small\">{{ chartsTasks.red.label }}</p><div class=\"progress progress-mini\"><div style=\"width: {{ chartsTasks.red.percent }}%;background: #EA5121;\" class=\"progress-bar\"></div></div><p class=\"no-margins small pull-right\">ALTA: {{ chartsTasks.red.Alta }} | MEDIA: {{ chartsTasks.red.Media }} | BAJA: {{ chartsTasks.red.Baja }}</p></div></div><div class=\"col-xs-12 form-group\"><button class=\"btn btn-success\" ng-click=\"showTableTasks(0)\" ng-model=\"main.btn_all\">Ver todos</button></div></div></div><div class=\"col-md-6\" ng-if=\"main.acceso_ver_cotizaciones\"><div class=\"ibox-content\" ng-init=\"showQuotations()\"><h3 class=\"text-center\"><i class=\"fa fa-th-large\" aria-hidden=\"true\"></i> Cotizaciones <a ng-click=\"configGraph(6)\"><i class=\"fa fa-wrench pull-right\" aria-hidden=\"true\"></i></a></h3><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" ng-click=\"showTableQuotations(1,1)\" title=\"{{chartsQuotations.green.title}}\"><h3 style=\"color: #17A45D;\">{{ chartsQuotations.green.status }}</h3><p class=\"small\">{{ chartsQuotations.green.label }}</p><div class=\"progress progress-mini\"><div style=\"width: {{ chartsQuotations.green.percent }}%;background: #17A45D;\" class=\"progress-bar\"></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" ng-click=\"showTableQuotations(2,1)\" title=\"{{chartsQuotations.yellow.title}}\"><h3 style=\"color: #F5CD21;\">{{ chartsQuotations.yellow.status }}</h3><p class=\"small\">{{ chartsQuotations.yellow.label }}</p><div class=\"progress progress-mini\"><div style=\"width: {{ chartsQuotations.yellow.percent }}%;background: #F5CD21;\" class=\"progress-bar\"></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" ng-click=\"showTableQuotations(3,1)\" title=\"{{chartsQuotations.orange.title}}\"><h3 style=\"color: #EA9021;\">{{ chartsQuotations.orange.status }}</h3><p class=\"small\">{{ chartsQuotations.orange.label }}</p><div class=\"progress progress-mini\"><div style=\"width: {{ chartsQuotations.orange.percent }}%;background: #EA9021;\" class=\"progress-bar\"></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" ng-click=\"showTableQuotations(4,1)\" title=\"{{chartsQuotations.red.title}}\"><h3 style=\"color: #EA5121;\">{{ chartsQuotations.red.status }}</h3><p class=\"small\">{{ chartsQuotations.red.label }}</p><div class=\"progress progress-mini\"><div style=\"width: {{ chartsQuotations.red.percent }}%;background: #EA5121;\" class=\"progress-bar\"></div></div></div></div><div class=\"col-xs-12 form-group\"><button class=\"btn btn-success\" ng-click=\"showTableQuotations(0)\" ng-model=\"main.btn_all\">Ver todos</button></div></div></div></div></div><div class=\"row col-xs-12\"></div><div class=\"col-lg-12\" ng-if=\"main.showTable\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Tareas <span ng-if=\"main.titleID==1\" style=\"color: #17A45D;\">{{typeGraphyc}}</span> <span ng-if=\"main.titleID==2\" style=\"color: #F5CD21;\">{{typeGraphyc}}</span> <span ng-if=\"main.titleID==3\" style=\"color: #EA9021;\">{{typeGraphyc}}</span> <span ng-if=\"main.titleID==4\" style=\"color: #EA5121;\">{{typeGraphyc}}</span></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"table-responsive animate\" id=\"tableDash\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Estatus</th><th>Folio</th><th>Título</th><th>Fecha</th><th>Prioridad</th><th>Antigüedad</th><th>Creador</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"ticket in tickets track by $index\" ng-click=\"goToTask(ticket,\'Tareas\')\"><td><span ng-if=\"!ticket.closed\">Abierta</span> <span ng-if=\"ticket.closed\">Cerrada</span></td><td>{{ ticket.identifier }}</td><td>{{ ticket.title }}</td><td>{{ ticket.date | date: \'dd/MM/yyyy\' : \'UTC\' }}</td><td><div class=\"label priority\" ng-class=\"{\'label-success\': ticket.closed, \'label-danger\' : ticket.priority == 1 && !ticket.closed, \'label-warning\' : ticket.priority == 2 && !ticket.closed, \'label-info\' : ticket.priority == 3 && !ticket.closed }\"><span ng-if=\"ticket.priority == 1 && !ticket.closed\">Alta</span> <span ng-if=\"ticket.priority == 2 && !ticket.closed\">Media</span> <span ng-if=\"ticket.priority == 3 && !ticket.closed\">Baja</span> <span ng-if=\"ticket.priority == 1 && ticket.closed\">Hecho/Alta</span> <span ng-if=\"ticket.priority == 2 && ticket.closed\">Hecho/Media</span> <span ng-if=\"ticket.priority == 3 && ticket.closed\">Hecho/Baja</span></div></td><td>{{ ticket.antiguedad }} días</td><td>{{ ticket.owner.first_name }} {{ ticket.owner.last_name }}</td><td><a class=\"btn btn-white btn-sm\" href=\"\" ng-click=\"$event.stopPropagation(); getLog(ticket)\" title=\"Log de tarea\"><i class=\"fa fa-history\"></i></a></td></tr></tbody></table><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"tickets.length > 0\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"exportDataGralTask(main.titleID)\">Generar Reporte</button></div></div></div></div></div><div class=\"col-lg-12\" ng-if=\"main.showTableQ\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Cotizaciones <span ng-if=\"main.titleID==1\" style=\"color: #17A45D;\">{{typeGraphyc}}</span> <span ng-if=\"main.titleID==2\" style=\"color: #F5CD21;\">{{typeGraphyc}}</span> <span ng-if=\"main.titleID==3\" style=\"color: #EA9021;\">{{typeGraphyc}}</span> <span ng-if=\"main.titleID==4\" style=\"color: #EA5121;\">{{typeGraphyc}}</span></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"table-responsive animate\" id=\"tableDash\"><table class=\"table table-bordered table-hover\"><thead><tr><th>No. de Folio</th><th>Contratante</th><th>Ramo</th><th>Subramo</th><th>Aseguradora</th><th>Estatus</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"item in quotations track by $index\" ng-click=\"showInformationQ(item)\"><td>{{ item.id }}</td><td>{{ item.full_name }}</td><td>{{ item.ramo }}</td><td>{{ item.subramo }}</td><td><ul><li ng-repeat=\"aseg in item.aseguradora track by $index\">{{aseg}}</li></ul></td><td>{{ item.status }}</td><td><a class=\"btn btn-white btn-sm\" href=\"\" ng-click=\"$event.stopPropagation(); getLog(item)\" title=\"Log de Cotización\"><i class=\"fa fa-history\"></i></a></td></tr></tbody></table><div ng-if=\"showpag\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"quotations.length > 0\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"exportDataGralQuotations()\">Generar Reporte</button></div></div></div></div></div><div class=\"container-kbi hidden-xs hidden-sm\" ng-if=\"main.permiso_kbi\" style=\"z-index: 30000;display: none;\"><div id=\"box-kbi\"><uib-tabset><uib-tab heading=\"Financiero\" id=\"financiero\" ng-click=\"show_tab_kbi(1)\" style=\"width: 25%;\"></uib-tab><uib-tab heading=\"Producción\" id=\"produccion\" ng-click=\"show_tab_kbi(2)\" style=\"width: 25%;\"></uib-tab><uib-tab heading=\"Cotizaciones\" id=\"Cotizaciones\" ng-click=\"show_tab_kbi(3)\" style=\"width: 25%;\"></uib-tab><uib-tab heading=\"Gastos\" id=\"Gastos\" ng-click=\"show_tab_kbi(4)\" style=\"width: 25%;\"></uib-tab></uib-tabset><div ng-if=\"show_financiero\"><div class=\"loader-kbi\" ng-if=\"showLoaderKbi\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><div class=\"row container-chart\"><div class=\"col-xs-9\"><label>Recibos Pagados, Liquidados o Conciliados <span title=\"Total Prima neta de recibos Pagados, Liquidados o Conciliados con fecha de inicio de recibo del año seleccionado (Tipo Moneda)\"><i class=\"fa fa-question-circle\"></i></span></label><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataFinancial.data\" chart-labels=\"charts_kbi.chartDataFinancial.labels\" chart-colours=\"charts_kbi.chartDataFinancial.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataFinancial.series\" height=\"54\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataFinancialDolar.data\" chart-labels=\"charts_kbi.chartDataFinancialDolar.labels\" chart-colours=\"charts_kbi.chartDataFinancialDolar.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataFinancialDolar.series\" height=\"54\"></canvas></div></div><div class=\"col-xs-3\"><label>Año:</label><select class=\"form-kbi\" name=\"payment\" ng-model=\"year_kbi\" ng-options=\"year as year for year in charts_kbi.anios\" ng-change=\"getFilter(1, year_kbi, startDate_production, endDate_production)\"><option value=\"\" disabled=\"\">Selecciona un año</option></select></div><div class=\"col-xs-3\"><label>Primas con moneda:</label><select class=\"form-kbi-filtro\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select></div><div class=\"col-xs-3\"><span>Primas por cobrar</span> <span title=\"Totales de Prima Total de recibos por cobrar que inicien vigencia en el año seleccionado(Endosos, Pólizas, Fianzas, SubGrupo, Pendiente de Pago, Prorrogadas, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><select class=\"form-kbi-filtro\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.prima_cobrar | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.prima_cobrarDolar | currency }}</label> <span>Comisión por recibir</span> <span title=\"Total Comisión de recibos pendientes por recibir con fecha de inicio de recibo del año seleccionado (Tipo Moneda, Pendiente Pago, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><select class=\"form-kbi-filtro\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.prima_recibir | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.prima_recibirDolar | currency }}</label></div></div><div class=\"row container-chart\" style=\"padding: 10px;\"><div class=\"col-xs-12\"><label>Subramos <span title=\"Totales de Prima Netas emitida por Subramo de pólizas con inicio de vigencia del año seleccionado (Tipo Moneda, SubRamo)\"><i class=\"fa fa-question-circle\"></i></span></label><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.polarDataFinancial.data\" chart-labels=\"charts_kbi.polarDataFinancial.labels\" height=\"60\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.polarDataFinancialDolar.data\" chart-labels=\"charts_kbi.polarDataFinancialDolar.labels\" height=\"60\"></canvas></div></div></div><div class=\"row container-chart\"><div class=\"col-xs-4\" style=\"background-color: #884EA0; color: #ffffff;\"><span>Comisión neta del año</span> <span title=\"Total de Comisiones de recibos Liquidado, Conciliado, Pagado con fecha de inicio de recibo del año seleccionado (Tipo de Moneda, excluye NC)\"><i class=\"fa fa-question-circle\"></i></span><br><select class=\"form-kbi-filtro\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\" style=\"color: #000000;\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.comision | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.comisionDolar | currency }}</label></div><div class=\"col-xs-4\" style=\"background-color: #5DADE2; color: #ffffff;\"><span>Notas de crédito sobre prima total</span> <span title=\"Totales de Prima Total de notas de crédito con fecha de inicio de recibo del año seleccionado (Excluye recibos con estatus cerrados, cancelados)\"><i class=\"fa fa-question-circle\"></i></span><br><select class=\"form-kbi-filtro\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\" style=\"color: #000000;\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.notas_credito | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.notas_creditoDolar | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"!charts_kbi.notas_credito\">{{ 0 | currency }}</label></div><div class=\"col-xs-4\" style=\"background-color: #F1C40F; color: #ffffff;\"><span>Recibos pagados sobre prima neta</span> <span title=\"Totales de Prima Neta de recibos pagados, liquidado, conciliado con fecha de inicio de recibo del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><br><select class=\"form-kbi-filtro\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\" style=\"color: #000000;\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.recibos_pagados | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.recibos_pagadosDolar | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"!charts_kbi.recibos_pagados\">{{ 0 | currency }}</label></div></div></div><div ng-if=\"show_produccion\"><div class=\"loader-kbi\" ng-if=\"showLoaderKbi\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><div class=\"row container-chart\"><br><div class=\"col-xs-6\"><label>Meta a Registrar</label> <input type=\"number\" class=\"form-kbi\" ng-model=\"newGoal.value\" ng-change=\"validateDecimal(newGoal.value)\"></div><div class=\"col-xs-3 form-group\" style=\"margin-top: 23px;\"><select class=\"form-kbi\" ng-model=\"newGoal.model\"><option ng-repeat=\"option in newGoal.options\" value=\"{{option.id}}\">{{ option.name }}</option></select></div><div class=\"col-xs-3 form-group\" style=\"margin-top: 23px;\"><button class=\"col-xs-12 btn btn-primary btn-xs\" ng-if=\"!showBtnKbi\" ng-click=\"saveGoal()\" ng-disabled=\"!newGoal.value\">Guardar</button> <button class=\"col-xs-12 btn btn-primary btn-xs\" ng-if=\"showBtnKbi\" ng-click=\"editGoal()\" ng-disabled=\"!newGoal.value\">Editar</button></div><br><div class=\"col-xs-4\"><label>Meta: {{ charts_kbi.goal.value | currency }} {{ charts_kbi.goal.currency }}</label></div><div class=\"col-xs-4\"><label>Actual: {{ charts_kbi.goal.progress | currency }} {{ charts_kbi.goal.currency }}</label></div><div class=\"col-xs-4\"><label>Faltan: {{ charts_kbi.goal.remain | currency }} {{ charts_kbi.goal.currency }}</label><div class=\"col-xs-4 pull-right\"><span title=\"Monto Faltante para cumplir Meta del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-12\"><div class=\"progress\" style=\"height: 32px;\"><div class=\"progress-bar bar-goal animate\" role=\"progressbar\" ng-style=\"progressGoal\" aria-valuemin=\"0\" aria-valuemax=\"100\"><label>{{ charts_kbi.goal.percentajeGoal }}%</label></div></div></div></div><div class=\"row container-chart\"><div class=\"col-xs-6\"><span>Total de Primas de Pólizas canceladas de póliza</span> <span title=\"Total de primas netas de pólizas Canceladas, PreCanceladas\"><i class=\"fa fa-question-circle\"></i></span><select class=\"form-kbi-filtro\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\" style=\"color: #000000;\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select><label class=\"lbl-tableros\" ng-if=\"show_currency_mxn\">{{ charts_kbi.primas_canceladas | currency }}</label> <label class=\"lbl-tableros\" ng-if=\"show_currency_usd\">{{ charts_kbi.primas_canceladasDolar | currency }}</label></div><div class=\"col-xs-6\"><span>Comisión perdida por notas de crédito</span> <span title=\"Total de Comisión de recibos de Notas de crédito (Cancelados, PreCanceladas del año seleccionado)\"><i class=\"fa fa-question-circle\"></i></span><select class=\"form-kbi-filtro\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\" style=\"color: #000000;\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.comision_perdida | currency }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.comision_perdidaDolar | currency }}</label></div></div><div class=\"row container-chart\"><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #5DADE2;\"><i class=\"fa fa-user\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Contratantes</span><br><label class=\"lbl-tableros\">{{ charts_kbi.contratantes }}</label> <span title=\"Totales de contratantes datos de alta en SAAM del año seleccionado(Físicas, Morales)\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #27AE60;\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Pólizas/Fianzas</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.polizas }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.polizasDolar }}</label> <span title=\"Total de pólizas y fianzas registradas en SAAM del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #F1C40F;\"><i class=\"fa fa-file\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>OT proceso</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.ot }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.otDolar }}</label> <span title=\"Total de OT proceso del año seleccionado Endosos (Pendiente, Tramite), OT de Poliza (Pendientes, Trámite)\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #E67E22;\"><i class=\"fa fa-folder\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Endosos</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.endosos }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.endososDolar }}</label> <span title=\"Total de Endosos del año seleccionado (Todos los estatus)\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #BDC3C7;\"><i class=\"fa fa-bookmark\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Renovaciones</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.renovaciones }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.renovacionesDolar }}</label> <span title=\"Total de Renovaciones del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></div></div><div class=\"col-xs-2\"><div class=\"col-xs-3 box-tableros\" style=\"background-color: #9B59B6;\"><i class=\"fa fa-certificate\" aria-hidden=\"true\"></i></div><div class=\"col-xs-9\"><span>Siniestros</span><br><label ng-if=\"show_currency_mxn\" class=\"lbl-tableros\">{{ charts_kbi.siniestros }}</label> <label ng-if=\"show_currency_usd\" class=\"lbl-tableros\">{{ charts_kbi.siniestrosDolar }}</label> <span title=\"Total de Siniestros registrados del año seleccionado (fecha de ingreso de siniestros y/o actualización)\"><i class=\"fa fa-question-circle\"></i></span></div></div></div><div class=\"row container-chart\" style=\"padding: 10px;\"><div class=\"col-xs-6\"><label>Comisiones <span title=\"Total de Comisiones de recibos Liquidado, Conciliado, Pagado con fecha de inicio de recibo del año seleccionado\"><i class=\"fa fa-question-circle\"></i></span></label><select class=\"form-kbi-filtro\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\" style=\"color: #000000;\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select><select class=\"form-kbi-filtro pull-right\" name=\"payment\" ng-model=\"year_kbi\" ng-options=\"year as year for year in charts_kbi.anios\" ng-change=\"getFilter(1, year_kbi, startDate_production, endDate_production)\"><option value=\"\" disabled=\"\">Selecciona un año</option></select><label class=\"pull-right\">Año:</label><div ng-if=\"show_currency_mxn\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataProduction.data\" chart-labels=\"charts_kbi.barDataProduction.labels\" chart-colours=\"charts_kbi.barDataProduction.colours\" height=\"110\"></canvas></div><div ng-if=\"show_currency_usd\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataProductionDolar.data\" chart-labels=\"charts_kbi.barDataProductionDolar.labels\" chart-colours=\"charts_kbi.barDataProductionDolar.colours\" height=\"110\"></canvas></div></div><div class=\"col-xs-6 border-left\"><label>Fecha:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" style=\"display: inline-block; margin-bottom: 6px;\"><input type=\"text\" name=\"startDate\" class=\"text-align-center form-kbi-filtr\" ng-model=\"startDate_production\" value=\"{{startDate_production}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\" style=\"display: none;\"><i class=\"fa fa-calendar\"></i></span></div><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\" style=\"display: inline-block; margin-bottom: 6px;\"><input type=\"text\" name=\"endingDate\" class=\"text-align-center form-kbi-filtr\" ng-model=\"endDate_production\" value=\"{{endDate_production}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\" style=\"display: none;\"><i class=\"fa fa-calendar\"></i></span></div><button class=\"btn btn-primary btn-xs\" ng-click=\"getFilter(1, year_kbi, startDate_production, endDate_production)\">Consultar</button><select class=\"form-kbi-filtro\" ng-model=\"currency_kbi\" ng-change=\"changeCurrencyKbi(currency_kbi)\" style=\"color: #000000;\"><option ng-repeat=\"option in currencies\" value=\"{{option.id}}\">{{ option.name }}</option></select><ul class=\"tab-kbi-prodution\"><li ng-class=\"{ \'active-kbi\': show_ejectivo }\" ng-click=\"show_tab_production(1)\">Ejecutivos</li><li ng-class=\"{ \'active-kbi\': show_aseguradora }\" ng-click=\"show_tab_production(2)\">Aseguradoras</li><li ng-class=\"{ \'active-kbi\': show_subramo }\" ng-click=\"show_tab_production(3)\">Subramos</li></ul><div ng-if=\"show_ejectivo\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Ejecutivo</th><th>Acciones</th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"user in charts_kbi.ejecutivos\" ng-if=\"show_currency_mxn\"><td>{{ user.user__first_name }} {{ user.user__last_name }}</td><td>{{ user.user__count }}</td></tr><tr class=\"row-list\" ng-repeat=\"user in charts_kbi.ejecutivosDolar\" ng-if=\"show_currency_usd\"><td>{{ user.user__first_name }} {{ user.user__last_name }}</td><td>{{ user.user__count }}</td></tr></tbody></table></div></div><div ng-if=\"show_aseguradora\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Aseguradora</th><th>Emitida <span title=\"Total de Prima Neta de pólizas por aseguradora del rango fecha seleccionado\"><i class=\"fa fa-question-circle\"></i></span></th><th>Pagada <span title=\"Totales de Prima Neta de recibos pagados por aseguradora de la fecha seleccionada (Pagado, liquidado o conciliado)\"><i class=\"fa fa-question-circle\"></i></span></th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.aseguradoras\" ng-if=\"item.aseguradora__alias && show_currency_mxn\"><td>{{ item.aseguradora__alias }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.aseguradorasDolar\" ng-if=\"item.aseguradora__alias && show_currency_usd\"><td>{{ item.aseguradora__alias }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr></tbody></table></div></div><div ng-if=\"show_subramo\"><div class=\"col-xs-12 box-scroll\"><table class=\"list-production\"><thead><tr><th>Subramo</th><th>Emitida <span title=\"Totales de Prima Neta emitida de pólizas por SubRamo de fecha seleccionada (Aseguradora)\"><i class=\"fa fa-question-circle\"></i></span></th><th>Pagada <span title=\"Totales de Prima Neta de recibos pagados por SubRamo de fecha seleccionada (pagado, Liquidado, Conciliado, Subramo)\"><i class=\"fa fa-question-circle\"></i></span></th></tr></thead><tbody><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.subramos\" ng-if=\"item.subramo__subramo_name && show_currency_mxn\"><td>{{ item.subramo__subramo_name }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr><tr class=\"row-list\" ng-repeat=\"item in charts_kbi.subramosDolar\" ng-if=\"item.subramo__subramo_name && show_currency_usd\"><td>{{ item.subramo__subramo_name }}</td><td>{{ item.p_neta__sum | currency }}</td><td ng-if=\"item.pagado\">{{ item.pagado | currency }}</td><td ng-if=\"!item.pagado\">{{ 0 | currency }}</td></tr></tbody></table></div></div></div></div></div><div ng-if=\"show_cotizacion\"><div class=\"row container-chart\" style=\"padding: 10px;\"><div class=\"col-xs-9\"><label>Cotizaciones</label> <span title=\"Total de cotizaciones realizadas en el año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><div ng-if=\"show_for == \'1\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotization.data\" chart-labels=\"charts_kbi.barDataCotization.labels\" chart-colours=\"charts_kbi.barDataCotization.colours\" height=\"80\"></canvas></div><div ng-if=\"show_for == \'2\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotizationRamo.data\" chart-labels=\"charts_kbi.barDataCotizationRamo.labels\" chart-colours=\"charts_kbi.barDataCotizationRamo.colours\" height=\"80\"></canvas></div><div ng-if=\"show_for == \'3\'\"><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataCotizacionSubramo.data\" chart-labels=\"charts_kbi.barDataCotizacionSubramo.labels\" chart-colours=\"charts_kbi.barDataCotizacionSubramo.colours\" height=\"80\"></canvas></div></div><div class=\"col-xs-3\"><label>Ver por:</label><br><select class=\"form-kbi-filtro\" name=\"payment\" ng-model=\"show_for\" ng-options=\"item.id as item.name for item in options\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select><br><span>No. de cotizaciones</span><br><label class=\"lbl-tableros\">{{ charts_kbi.cotizaciones }}</label></div></div><div class=\"row container-chart\"><div class=\"col-xs-3\" style=\"padding: 10px;\"><label>Bateo: {{ charts_kbi.bateo}}%</label> <span title=\"Porcentaje Total de cotizaciones bateadas en el año seleccionado\"><i class=\"fa fa-question-circle\"></i></span><div class=\"box-scroll-cotization\"><ul class=\"list-cotization\" ng-repeat=\"item in charts_kbi.monthsBateo\"><li>{{ item.month }} <span class=\"pull-right\">{{ item.value }}</span></li></ul></div></div><div class=\"col-xs-9\" style=\"padding: 10px;\"><label>Cotización y Emisión</label><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"charts_kbi.chartDataCotization.data\" chart-labels=\"charts_kbi.chartDataCotization.labels\" chart-colours=\"charts_kbi.chartDataCotization.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.chartDataCotization.series\" height=\"70\"></canvas></div></div></div><div ng-if=\"show_gastos\"><div class=\"row container-chart\"><div class=\"col-xs-8\"><div class=\"concept-scroll\"><div class=\"col-xs-3\"><label>Mes</label><select class=\"form-kbi\" name=\"payment\" ng-model=\"main.month_kbi\" ng-options=\"month as month.month for month in months_kbi track by month.id\" ng-change=\"selectMonth(main.month_kbi)\"><option value=\"\" disabled=\"\">Selecciona un mes</option></select></div><div class=\"col-xs-3\" style=\"margin-top: 23px;\"><button class=\"col-xs-12 btn btn-primary btn-xs\" ng-click=\"saveGastos()\">Guardar</button></div><div class=\"col-xs-3\" style=\"margin-top: 23px;\"><button class=\"col-xs-12 btn btn-success btn-xs\" ng-click=\"addConcept()\">Agregar concepto</button></div><div class=\"col-xs-12\"></div><div ng-repeat=\"concept in concepts track by $index\"><div class=\"col-xs-6\"><label>Concepto</label> <input class=\"form-kbi\" type=\"text\" ng-model=\"concept.concept\" name=\"\"></div><div class=\"col-xs-3\"><label>Gasto</label> <input class=\"form-kbi\" type=\"number\" ng-model=\"concept.cantidad\" ng-change=\"validateGasto(concept.cantidad)\" name=\"\"></div><div class=\"col-xs-3\" style=\"margin-top: 23px;\" ng-if=\"concept.value > 9\"><button class=\"col-xs-12 btn btn-danger btn-xs\" ng-click=\"removeConcept($index)\">Quitar concepto</button></div></div></div></div><div class=\"col-xs-4\" ng-if=\"charts_kbi.barDataGastos.concepts.length > 0\"><div class=\"box-scroll\"><br><table class=\"list-production\"><thead><tr><th>Mes</th><th>Concepto</th><th>Cantidad</th><th></th></tr></thead><tbody><tr ng-repeat=\"item_conc in charts_kbi.barDataGastos.concepts | orderBy: \'month\' track by $index\"><td><span>{{monthName(item_conc.month)}}</span></td><td><span>{{item_conc.concept}}</span></td><td><span>{{item_conc.cantidad | currency}}</span></td><td><span ng-click=\"deleteConcept(item_conc, $index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></span></td></tr></tbody></table></div></div></div><div class=\"row container-chart\"><div class=\"col-xs-8\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"charts_kbi.barDataGastos.data\" chart-labels=\"charts_kbi.barDataGastos.labels\" chart-colours=\"charts_kbi.barDataGastos.colours\" chart-legend=\"true\" chart-series=\"charts_kbi.barDataGastos.series\" height=\"100\"></canvas></div><div class=\"col-xs-4\"><br><div class=\"box-scroll\"><br><table class=\"list-production\"><thead><tr><th>Utilidad<span title=\"Total de comision en el año seleccionado: {{total_utilidad | currency }}\"><i class=\"fa fa-question-circle\"></i></span></th><th>MXN</th><th>USD</th></tr></thead><tbody><tr ng-repeat=\"item_uti in charts_kbi.monthsUtilidad track by $index\"><td><span>{{item_uti.month}}</span></td><td><span>{{item_uti.value | currency}}</span></td><td><span>{{item_uti.value_dolar | currency}}</span></td></tr></tbody></table></div></div></div></div><div class=\"tab-kbi\" onclick=\"divLogin()\">Administrador KBI</div></div></div></div><script type=\"text/javascript\">\r\n  setTimeout(function(){ if(document.getElementById(\"box-kbi\")){document.getElementById(\"box-kbi\").style.width = \"0px\"; }}, 10);\r\n  var clic = 1;\r\n  function divLogin(){\r\n    if(clic==1){\r\n      angular.element(document.getElementById(\'box-kbi\')).scope().getFilter(0);\r\n      document.getElementById(\"box-kbi\").style.width = \"1100px\";\r\n      clic = clic + 1;\r\n    } else{\r\n      document.getElementById(\"box-kbi\").style.width = \"0px\";      \r\n      clic = 1;\r\n    }   \r\n  }\r\n</script>");
$templateCache.put("app/medicoscelulas/configuracion.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Configuración de Médicos - Células - Contratantes</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Configuración</strong></li></ol></div></div><br><div class=\"row center-content\" id=\"modal_in\" ng-show=\"agregar_configuracion || showEditMedico\"><div class=\"col-xs-12 form-group\"><div class=\"alert alert-success alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <span>Las <b>Células</b> se configuran sobre las <b>Pólizas</b>.</span></div></div><div class=\"col-xs-12 col-sm-2 form-group\" ng-if=\"!existeDefault\"><div><label>Médico Default</label></div><input type=\"checkbox\" ng-model=\"medicoscelula.default\" ng-click=\"valDefault(medicoscelula.default)\"></div><div class=\"col-xs-12 col-sm-2 form-group\" ng-if=\"existeDefault && showEditMedico && medicoscelula.default\"><div><label>Médico Default</label></div></div><div class=\"col-xs-12 col-sm-5 form-group\"><label>Médico <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"medicoscelula.medico\"></div><div class=\"col-xs-12 col-sm-5 form-group\"><label>Teléfono <span class=\"color-red\">*</span></label><phonenumber-directive placeholder=\"myPrompt\" model=\"medicoscelula.medico_telefono\"></phonenumber-directive></div><div ng-if=\"obteniendoFiltros\" class=\"col-xs-12 form-group\" style=\"text-align: center;\"><img src=\"../../assets/images/loaders/loader_6.gif\"><div class=\"alert alert-secondary alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a></div></div><div class=\"col-xs-12 col-sm-6 col-lg-6 form-group\" ng-show=\"medicoscelula.default ==false\"><label>Célula(s)</label><select class=\"js-example-basic-multiple form-control\" multiple=\"multiple\" ng-model=\"select_celula\" data-ng-options=\"cel.description ? cel.description : cel.id for cel in celulas | orderBy: \'description\' track by cel.url\" ng-change=\"selectCelulas(select_celula)\"></select><div ng-if=\"namesCelula\" ng-repeat=\"c in namesCelula\">{{c}}</div></div><div class=\"col-xs-12 col-sm-6 col-lg-6 form-group\" ng-show=\"medicoscelula.default ==false\"><label>Contratante(s)</label><select class=\"js-example-basic-multiple form-control\" multiple=\"multiple\" ng-model=\"select_contractor\" data-ng-options=\"cn.full_name ? cn.full_name : cn.id for cn in contractors | orderBy: \'full_name\' track by cn.url\" ng-change=\"selectContractors(select_contractor)\"></select><div ng-if=\"namesContractor\" ng-repeat=\"cl in namesContractor\">{{cl}}</div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button ng-if=\"agregar_configuracion\" class=\"btn btn-primary col-xs-12 ladda-button\" ng-click=\"save()\">Validar y Guardar</button> <button ng-if=\"showEditMedico\" class=\"btn btn-primary col-xs-12 ladda-button\" ng-click=\"update()\">Validar y Actualizar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"btn btn-white col-xs-12\" ng-click=\"cancelConfig(false)\"><i class=\"fa fa-cancel\" aria-hidden=\"true\"></i> Cancelar</button></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-show=\"!agregar_configuracion && !showEditMedico\"><button class=\"btn btn-success col-xs-12\" ng-click=\"vm.addConfguration()\"><i class=\"fa fa-cancel\" aria-hidden=\"true\"></i> Agregar Configuración</button></div><div class=\"row\" ng-show=\"!agregar_configuracion && !showEditMedico\"><div ng-if=\"configuraciones.length ==0\" class=\"col-xs-12 form-group\" style=\"text-align: center;\"><div class=\"alert alert-secondary alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <b>No se han configurado Médicos (Sin registros)</b></div></div><div class=\"row center-content\"><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th></th><th>Fecha de creación</th><th>Médico</th><th>Teléfono</th><th>Célula(s)</th><th>Cliente(s)</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"item in configuraciones track by $index\"><td>{{ item.id }}</td><td>{{ item.created_at | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ item.medico }}</td><td>{{ item.medico_telefono }}</td><td><div ng-if=\"item.celulas\" ng-repeat=\"c in item.celulas\">{{c.description}}</div></td><td><div ng-if=\"item.clientes\" ng-repeat=\"cl in item.clientes\">{{cl.full_name}}</div></td><td><button class=\"btn btn-danger\" ng-click=\"delete(item,$index,configuraciones)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-secondary\" ng-click=\"edit(item)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div ng-if=\"show_pagination\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div><script type=\"text/javascript\">\n  $(\'#select_contractor\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n  $(\'#select_celula\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n  $(\".js-example-tokenizer\").select2({\n      tags: true,\n      tokenSeparators: [\',\', \' \']\n  })\n</script>");
$templateCache.put("app/mensajeria/create.delivery.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Crear mensajería</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"col-xs-12\"><div class=\"row\"><legend class=\"legend-title\">Asignar Tarea</legend></div><form class=\"quoteForm mc-content\" name=\"quoteForm\" novalidate=\"\"><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\"><label>Mensajero <span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"new_task.delivery_selected\" ng-options=\"delivery_mans.first_name + \' \' + delivery_mans.last_name for delivery_mans in delivery_mans track by delivery_mans.url\"><option value=\"\" disabled=\"\">Seleccione un mensajero</option></select></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Acción <span class=\"red-color\">*</span></label> <input type=\"text\" name=\"action\" class=\"form-control\" ng-model=\"new_task.action\" required=\"\"></div><div class=\"form-group col-xs-12\"><legend class=\"legend-title\" align=\"center\">Dirección desde<span class=\"color-red\">*</span></legend><div class=\"col-xs-12 col-sm-4 col-md-3\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"end_type\" ng-click=\"contratante_opt = true; manual_opt = false;\" value=\"altas\" required=\"\"> Contratante</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-3\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"end_type\" ng-click=\"eraseInput()\" value=\"1\" required=\"\"> Manual</label></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contacto</label> <input class=\"form-control\" type=\"text\" ng-model=\"new_task.contact\"></div><br><br><div class=\"col-xs-12 col-sm-4 col-md-6\" ng-if=\"contratante_opt\"><label>Dirección del contratante <span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in address_options\" ng-change=\"\" name=\"address\" ng-model=\"new_task.address\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 col-sm-4 col-md-6\" ng-if=\"!vm.address.length && manual_opt\"><label>Dirección manual <span class=\"red-color\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"new_task.address\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Fecha <span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_task.fecha\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Hora</label> <input type=\"text\" name=\"time\" class=\"form-control\" ng-model=\"new_task.time\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" name=\"observations\" ng-model=\"new_task.observations\">\n                    </textarea></div><div class=\"col-xs-12 m-t\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"quoteForm.$invalid\" ng-click=\"saveTask()\">Asignar Tarea</button></div></div></form></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div></div>");
$templateCache.put("app/mensajeria/mensajeria.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Mensajería</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Mensajería</strong></li></ol></div></div><div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createDelivery()\">Agregar Mensajero</button></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-success m-t\" ng-click=\"getDelivery()\">Asignar Tarea</button></div><div class=\"col-xs-12\" ng-if=\"delivery\"><legend class=\"legend-title\" align=\"center\">Nuevo Mensajero</legend><form class=\"row\" name=\"form\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre<span class=\"red-color\">*</span></label> <input type=\"text\" name=\"first_name\" class=\"form-control\" ng-model=\"delivery_man.first_name\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Apellido Paterno<span class=\"red-color\">*</span></label> <input type=\"text\" name=\"last_name\" class=\"form-control\" ng-model=\"delivery_man.last_name\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Apellido Materno</label> <input type=\"text\" name=\"second_last_name\" class=\"form-control\" ng-model=\"delivery_man.second_last_name\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Email<span class=\"red-color\">*</span></label> <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"delivery_man.email\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"saveDelivery()\">Crear Mensajero</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeDelivery()\">Cancelar</button></div></form></div><div class=\"col-xs-12\" ng-if=\"task\"><legend class=\"legend-title\" align=\"center\">Asignar Tarea</legend><form class=\"row\" name=\"formTask\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Mensajero <span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"new_task.delivery_selected\" ng-options=\"delivery_mans.first_name + \' \' + delivery_mans.last_name for delivery_mans in delivery_mans track by delivery_mans.url\"><option value=\"\" disabled=\"\">Seleccione un mensajero</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Acción <span class=\"red-color\">*</span></label> <input type=\"text\" name=\"action\" class=\"form-control\" ng-model=\"new_task.action\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección desde <span class=\"red-color\">*</span></label><br><div class=\"col-xs-12 col-sm-6\"><input type=\"radio\" ng-model=\"end_type\" ng-click=\"contratante_opt = true; manual_opt = false;\" value=\"1\" required=\"\"> Contratante</div><div class=\"col-xs-12 col-sm-6\"><span><input type=\"radio\" ng-model=\"end_type\" ng-click=\"manual_opt = true; contratante_opt = false;\" value=\"2\" required=\"\"> Manual</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"contratante_opt\"><label>Contratante <span class=\"red-color\">*</span></label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"contratante_opt\"><label>Dirección de contratante<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in vm.address\" ng-change=\"\" name=\"address\" ng-model=\"new_task.address\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"form-group col-xs-12 col-sm-6\" ng-if=\"!vm.address.length && manual_opt\"><label>Receptor<span class=\"red-color\">*</span></label> <input type=\"text\" name=\"first_name\" class=\"form-control\" ng-model=\"new_task.receptor\" required=\"\"> <label>Dirección manual<span class=\"red-color\">*</span></label> <input type=\"text\" name=\"first_name\" class=\"form-control\" ng-model=\"new_task.address\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contacto</label> <input class=\"form-control\" type=\"text\" ng-model=\"new_task.contact\"></div><br><br><div class=\"form-group col-xs-12 col-sm-6\"><label>Fecha <span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_task.fecha\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Hora <span class=\"red-color\">*</span></label> <input type=\"text\" name=\"time\" class=\"form-control\" ng-model=\"new_task.time\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea class=\"form-control\" name=\"observations\" ng-model=\"new_task.observations\">\n          </textarea></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary\" ng-disabled=\"!new_task.time || !new_task.fecha || (!new_task.address) || !new_task.action || !new_task.delivery_selected\" ng-click=\"saveTask()\" title=\"Seleccione el Tipo de Dirección\">Asignar Tarea</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeDelivery()\">Cancelar</button></div></div></form></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Consultar tareas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Mensajero</label><select class=\"form-control\" ng-model=\"filters.mensajero\" ng-options=\"delivery_mans.first_name + \' \' + delivery_mans.last_name for delivery_mans in delivery_mans track by delivery_mans.url\"><option value=\"\" disabled=\"\">Seleccione un mensajero</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Estatus:</label><select class=\"form-control\" ng-model=\"filters.estatus\" ng-options=\"frec.name for frec in status track by frec.id\"><option value=\"\" disabled=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Obtener por:</label><select class=\"form-control\" ng-model=\"frec_selected\" ng-options=\"frec.name for frec in frecs track by frec.id\" ng-change=\"enableDates()\"><option value=\"\" disabled=\"\">Seleccione una opción</option></select></div><div ng-if=\"dates\"><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Desde</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"filters.since\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Hasta</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"filters.until\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"col-xs-12 m-t\"><button class=\"btn btn-success pull-right\" ng-disabled=\"form.$invalid\" ng-click=\"getTasks()\">Consultar</button></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Tareas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y\" id=\"exportable\"><table class=\"table table-stripped table-hover hidden-xs hidden-sm\"><thead><tr><th>Registrado por</th><th>Mensajero</th><th>Acción</th><th>Receptor</th><th>Dirección</th><th>Tipo de dirección</th><th>Fecha</th><th>Hora</th><th ng-if=\"filters.estatus.id == 2\">Cerrada por</th><th>Contacto</th><th>Observaciones</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"task in tasks track by $index\"><td>{{ task.owner}}</td><td>{{ task.delivery.first_name }} {{ task.delivery.last_name }}</td><td>{{ task.action }}</td><td>{{ task.receptor }}</td><td>{{ task.address }}</td><td ng-if=\"task.type_address != null\">{{ task.type_address }}</td><td ng-if=\"task.type_address == null\">Sin tipo de dirección</td><td>{{ task.date | date: \'dd/MM/yyyy\'}}</td><td ng-if=\"task.time\">{{ task.time }}</td><td ng-if=\"!task.time\">Sin hora asignada</td><td ng-if=\"task.status == 2\">{{task.close_by}} - {{task.close_day | date: \'dd/MM/yyyy\'}}</td><td>{{task.contact}}</td><td>{{task.observations}}</td><td><div class=\"btn-group m-b\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"task.status == 1\"><a ng-click=\"editTask(task)\">Editar</a></li><li><a ng-click=\"reSchedule(task)\">Reprogramar</a></li><li><a ng-click=\"reAssign(task)\">Reasignar</a></li><li><a ng-click=\"closeTask(task)\">Cerrar</a></li></ul></div></td></tr></tbody></table><div ng-if=\"show_pag_search\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPagesP()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPagesP | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPageP(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPagesP()\" ng-if=\"totalPagesP.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPageP()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div><div class=\"col-xs-12 m-t\" ng-if=\"tasks\"><button class=\"btn btn-success pull-right\" ng-disabled=\"form.$invalid\" ng-click=\"getDeliveryPDF()\">Imprimir Itinerario</button> <button class=\"btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"GetTasksExcel()\"><i class=\"fa fa-download\"></i> Exportar a excel</button></div></div></div></div></div>");
$templateCache.put("app/mensajeria/reprogramar.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\" ng-if=\"type_function == 1\">Reprogramar Tarea</h4><h4 class=\"modal-title\" ng-if=\"type_function == 2\">Reasignar Tarea</h4><h4 class=\"modal-title\" ng-if=\"type_function == 3\">Cerrar Tarea</h4><h4 class=\"modal-title\" ng-if=\"type_function == 4\">Editar Tarea</h4></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\" ng-if=\"type_function == 1\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Mensajero:</span><div><span>{{ task.delivery.first_name }} {{ task.delivery.last_name }}<span></span></span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Acción:</span><div><span>{{ task.action }}<span></span></span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Tipo de dirección:</span><div><span ng-if=\"task.type_address != null\">{{ task.type_address }}<span><span ng-if=\"task.type_address == null\">Sin tipo de dirección<span></span></span></span></span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Dirección:</span><div><span>{{ task.address }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha actual:</span><div><span>{{ task.date | date: \'dd/MM/yyyy\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Hora actual:</span><div><span ng-if=\"task.time\">{{ task.time }}<span><span ng-if=\"!task.time\">Sin hora asignada<span></span></span></span></span></div></div><div class=\"col-xs-12\"><br><div class=\"form-group col-xs-12 col-sm-6\"><label>Fecha <span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_info.fecha\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Hora <span class=\"red-color\">*</span></label> <input type=\"text\" name=\"time\" class=\"form-control\" ng-model=\"new_info.time\" required=\"\"></div></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"type_function == 2\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"form-group col-xs-12\"><label>Mensajero</label><select class=\"form-control\" ng-model=\"new_info.mensajero\" ng-options=\"delivery_mans.first_name + \' \' + delivery_mans.last_name for delivery_mans in delivery_mans track by delivery_mans.url\"><option value=\"\" disabled=\"\">Seleccione un mensajero</option></select></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"type_function == 3\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group col-xs-12 col-sm-6\"><label>Fecha de cierre <span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_info.fecha\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Cerrado por <span class=\"red-color\">*</span></label> <input type=\"text\" name=\"time\" class=\"form-control\" ng-model=\"new_info.close_by\" required=\"\"></div></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"type_function == 4\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Mensajero actual:</span><div><span>{{ task.delivery.first_name }} {{ task.delivery.last_name }}<span></span></span></div></div><div class=\"form-group col-xs-12\"><label>Mensajero <span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"new_info.mensajero\" ng-options=\"delivery_mans.first_name + \' \' + delivery_mans.last_name for delivery_mans in delivery_mans track by delivery_mans.url\"><option value=\"\" disabled=\"\">Seleccione un mensajero</option></select></div><div class=\"col-xs-12 form-group\"><label>Acción:</label><div><input class=\"form-control\" type=\"text\" name=\"task.action\" ng-model=\"task.action\"></div></div><div class=\"col-xs-12 form-group\"><label>Tipo de dirección:</label><div><input class=\"form-control\" ng-model=\"task.type_address\" type=\"text\" name=\"task.type_address\"></div></div><div class=\"col-xs-12 form-group\"><label>Dirección:</label><div><input class=\"form-control\" ng-model=\"task.address\" type=\"text\" name=\"task.address\"></div></div><div class=\"col-xs-12 form-group\"><label>Contacto:</label><div><input class=\"form-control\" ng-model=\"task.contact\" type=\"text\" name=\"task.contact\"></div></div><div class=\"col-xs-12 form-group\"><label>Observaciones:</label><div><input class=\"form-control\" ng-model=\"task.observations\" type=\"text\" name=\"task.observations\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Fecha actual:</span><div><span>{{ task.date | date: \'dd/MM/yyyy\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Hora actual:</span><div><span ng-if=\"task.time\">{{ task.time }}<span><span ng-if=\"!task.time\">Sin hora asignada<span></span></span></span></span></div></div><div class=\"col-xs-12\"><br><div class=\"form-group col-xs-12 col-sm-6\"><label>Fecha <span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_info.fecha\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Hora <span class=\"red-color\">*</span></label> <input type=\"text\" name=\"time\" class=\"form-control\" ng-model=\"new_info.time\" required=\"\"></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"close()\" type=\"button\">Cancelar</button> <button class=\"btn btn-success ladda-button\" ng-click=\"reprogramar(optionCancel, vm.insurance.reason)\" type=\"button\" ng-if=\"type_function == 1\">Reprogramar</button> <button class=\"btn btn-success ladda-button\" ng-click=\"reasignar(optionCancel, vm.insurance.reason)\" type=\"button\" ng-if=\"type_function == 2\">Reasignar</button> <button class=\"btn btn-success ladda-button\" ng-click=\"editartarea(optionCancel, task)\" type=\"button\" ng-if=\"type_function == 4\">Editar</button> <button class=\"btn btn-success ladda-button\" ng-click=\"cerrar(optionCancel, vm.insurance.reason)\" type=\"button\" ng-if=\"type_function == 3\">Cerrar tarea</button></div>");
$templateCache.put("app/minor/minor.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Simple example of second view</h1><small>Configure in app.js as index.minor state.</small></div></div></div></div>");
$templateCache.put("app/modals/filtro_subramos_cotizaciones.html","<div class=\"inmodal\" id=\"modal_in\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Filtro de Cotizaciones por Subramos</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><ul ng-repeat=\"item in ramos\"><li><span>{{ item.subramo_name }}</span></li></ul><label>Subramos</label><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"col-xs-12\"><select id=\"select_ramo\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"ramos\" data-ng-options=\"subramo.subramo_name for subramo in subramos_toselected | orderBy: \'subramo_code\' track by subramo.subramo_code\"></select></div></div></div></div><div class=\"modal-footer\"><div class=\"pull-right\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cancelar</button> <button class=\"btn btn-primary ladda-button\" ng-disabled=\"form.$invalid\" ng-click=\"saveConfig()\" type=\"button\">Guardar</button></div></div></div><script type=\"text/javascript\">\n    $(\'#select_ramo\').select2({\n          dropdownParent: $(\'#modal_in\')\n    });\n    $(\".js-example-tokenizer\").select2({\n      tags: true,\n      tokenSeparators: [\',\', \' \']\n  })\n  </script>");
$templateCache.put("app/modals/filtros_subramos_dash.html","<div class=\"inmodal\" id=\"modal_in\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Filtro de Dashboard por:</h4><h3 class=\"modal-title\">Subramo (s) | Tipo de Póliza</h3></div><div class=\"modal-body\"><div class=\"row\"><hr><div class=\"col-xs-6 form-group\"><ul ng-repeat=\"item in ramos\"><li><span><i class=\"fa fa-tag text-primary me-2\"></i> {{ item.subramo_name }}</span></li></ul><label><i class=\"fa fa-sitemap me-2 text-primary\"></i> Subramos:</label><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"col-xs-12\"><select id=\"select_ramo\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"ramos\" data-ng-options=\"subramo.subramo_name for subramo in subramos_toselected | orderBy: \'subramo_code\' track by subramo.subramo_code\"></select></div><hr></div><div class=\"col-xs-6 form-group\"><label><i class=\"fa fa-file-text me-2 text-primary\"></i> Tipo de Póliza:</label><div ng-repeat=\"tipo in tipopoliza_toselect\"><label><input type=\"checkbox\" ng-model=\"tipo.selected\" ng-change=\"toggleTipo(tipo)\"> <label class=\"form-check-label\" for=\"tipo_{{tipo.code}}\">{{ tipo.name }}</label></label></div><hr></div></div></div><div class=\"modal-footer\"><div class=\"pull-right\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cancelar</button> <button class=\"btn btn-primary ladda-button\" ng-disabled=\"form.$invalid\" ng-click=\"saveConfig()\" type=\"button\">Guardar</button></div></div></div><script type=\"text/javascript\">\n    $(\'#select_ramo\').select2({\n          dropdownParent: $(\'#modal_in\')\n    });\n    $(\".js-example-tokenizer\").select2({\n      tags: true,\n      tokenSeparators: [\',\', \' \']\n  })\n  </script>");
$templateCache.put("app/modals/filtros_subramos_tablero.html","<div class=\"inmodal\" id=\"modal_in\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Filtro de Tablero por Subramos</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><ul ng-repeat=\"item in ramos\"><li><span>{{ item.subramo_name }}</span></li></ul><label>Subramos</label><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"col-xs-12\"><select id=\"select_ramo\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"ramos\" data-ng-options=\"subramo.subramo_name for subramo in subramos_toselected | orderBy: \'subramo_code\' track by subramo.subramo_code\"></select></div></div><div class=\"col-xs-12 form-group\"><ul ng-repeat=\"item in aseguradoras\"><li><span>{{ item.alias }}</span></li></ul><label>Aseguradoras</label><div class=\"col-xs-12\"><select id=\"select_aseguradora\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"aseguradoras\" data-ng-options=\"asegs.alias for asegs in providers_toselected | orderBy: \'alias\' track by asegs.alias\" ng-change=\"selectProv(select_aseguradora)\"></select></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-4 col-md-4 form-group\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"type_ots\" type=\"radio\" value=\"1\"> <b>OT Póliza</b></label></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"type_ots\" value=\"2\"> <b>OT Endoso</b></label></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"type_ots\" value=\"0\"> <b>OT Póliza/Endoso</b></label></div></div></div></div></div><div class=\"modal-footer\"><div class=\"pull-right\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cancelar</button> <button class=\"btn btn-primary ladda-button\" ng-disabled=\"form.$invalid\" ng-click=\"saveConfig(select_aseguradora)\" type=\"button\">Guardar</button></div></div></div><script type=\"text/javascript\">\n    $(\'#select_ramo\').select2({\n          dropdownParent: $(\'#modal_in\')\n    });\n    $(\'#select_aseguradora\').select2({\n          dropdownParent: $(\'#modal_in\')\n    });\n    $(\".js-example-tokenizer\").select2({\n      tags: true,\n      tokenSeparators: [\',\', \' \']\n  })\n  </script>");
$templateCache.put("app/modals/modal.contratante.create.html","<div id=\"modalContratate\" class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Crear Contratante</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"Fisica\" ng-click=\"showButtonFisica()\"><div id=\"divFisica\" ng-include=\"\'app/contratantes/contratantes.natural.html\'\"></div></uib-tab><uib-tab index=\"1\" heading=\"Moral\" ng-click=\"showButtonMoral()\"><div id=\"divMoral\" ng-include=\"\'app/contratantes/contratantes.juridical.html\'\"></div></uib-tab></uib-tabset></div></div></div></div></div><div class=\"modal-footer\"><div class=\"form-group\"><div class=\"col-sm-12\"><button ng-if=\"fisicas\" id=\"saveButtonFisicaModal\" class=\"btn btn-success pull-right margin-right-10\" onclick=\"saveContrFisica()\">Guardar cambios</button> <button ng-if=\"morales\" id=\"saveButtonMoralModal\" class=\"btn btn-success pull-right margin-right-10\" onclick=\"saveContrMoral()\">Guardar cambios</button> <button id=\"closeModalContr\" class=\"display-none\" ng-click=\"vm.control.closeModal()\" type=\"button\"></button> <button class=\"btn btn-default pull-right margin-right-10\" onclick=\"closeContr()\" type=\"button\">Cerrar</button></div></div></div></div>");
$templateCache.put("app/modals/modal.coverage.create.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">{{title}}{{coverage_name}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizzard\"><form role=\"form\"><div class=\"row\"><div class=\"form-group col-sm-8\"><label for=\"name\">Cobertura<span class=\"color-red\">*</span></label> <input class=\"form-control\" id=\"name\" ng-model=\"form.coverage_name\" type=\"text\" required=\"\"></div></div><div class=\"row\"><div class=\"form-group\"><label for=\"\" \"suma\"=\"\" class=\"col-sm-12\">Agregar suma asegurada</label><div id=\"suma\"><div class=\"col-sm-8\"><input class=\"form-control\" ng-keyup=\"$event.keyCode == 13 && addSum(form.suma_name)\" ng-model=\"form.suma_name\" type=\"text\"></div><div class=\"col-sm-4\"><p class=\"color-red\">Debe dar click en el botón para guardar la Suma Asegurada</p><button type=\"button\" class=\"btn btn-info btn-block\" ng-click=\"addSum(form.suma_name)\">Agregar suma</button></div></div><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th>Default</th><th class=\"width-70p\">Suma Aseg.</th><th class=\"width-30p\">Acción</th></tr></thead><tbody><tr ng-repeat=\"sum in form.coverage_sums track by $index\"><td><input type=\"radio\" ng-click=\"default_sum(sum)\" ng-model=\"sum.default\" ng-value=\"true\"></td><td>{{(sum.sum_insured) }}</td><td><button type=\"button\" class=\"btn btn-warning btn-block\" ng-click=\"removeSum($index)\">Eliminar</button></td></tr></tbody></table></div></div></div></div><div class=\"row\"><div class=\"form-group\"><label for=\"deducible\" class=\"col-sm-12\">Agregar deducible</label><div id=\"deducible\"><div class=\"col-sm-8\"><input class=\"form-control\" ng-keyup=\"$event.keyCode == 13 && addDeductible(form.deducible_name)\" ng-model=\"form.deducible_name\" type=\"text\"></div><div class=\"col-sm-4\"><p class=\"color-red\">Debe dar click en el botón para guardar el Deducible</p><button type=\"button\" class=\"btn btn-info btn-block\" ng-click=\"addDeductible(form.deducible_name)\">Agregar deducible</button></div></div><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th>Default</th><th class=\"width-70p\">Deducible</th><th class=\"width-30p\">Acción</th></tr></thead><tbody><tr ng-repeat=\"deductible in form.coverage_deductibles track by $index\"><td><input type=\"radio\" ng-click=\"default_deductible(deductible)\" ng-model=\"deductible.default\" ng-value=\"true\"></td><td>{{(deductible.deductible)}}</td><td><button type=\"button\" class=\"btn btn-warning btn-block\" ng-click=\"removeDeductible($index)\">Eliminar</button></td></tr></tbody></table></div></div></div></div></form></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-info\" ng-click=\"submit()\" type=\"button\">Guardar</button> <button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div>");
$templateCache.put("app/modals/modal.editOT.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Editar OT</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div ng-include=\"\'app/ordenes/ordenes.generic.html\'\"></div></div></div></div></div></div><div class=\"modal-footer\"><button ng-if=\"!order.show.isPolicy\" ng-click=\"order.save.openPdf()\" class=\"btn btn-warning\" type=\"button\">Abrir PDF</button> <button ng-if=\"!order.show.isPolicy\" ng-click=\"order.save.downloadPdf()\" class=\"btn btn-warning\" type=\"button\">Descargar PDF</button> <button ng-click=\"order.save.saveChangesInOt()\" class=\"btn btn-success\" type=\"button\">Guardar como OT</button> <button ng-click=\"order.save.saveInsurance(\'poliza\')\" class=\"btn btn-info\" type=\"button\">Guardar como póliza</button> <button ng-click=\"order.save.cancel()\" class=\"btn btn-white\" type=\"button\">Cancelar</button></div></div>");
$templateCache.put("app/modals/modal.endosos.html","<div class=\"inmodal\" ng-controller=\"EndososCtrl as vm\"><div class=\"modal-header modal_title\"><h4 class=\"modal-title\">Agregar Endoso</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><form role=\"form\" name=\"endosoForm\" ng-submit=\"submitEnd()\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><label for=\"brand\">No. Póliza</label><div name=\"brand\"><div class=\"form-group col-md-8 nopadding\"><autocomplete datasource=\"vm.defaults.insurancesIds\" model=\"vm.poliza_number_data\" change=\"policyEndorsments(vm.poliza_number_data)\"></autocomplete></div><div class=\"form-group col-md-4 nopadding\"><button type=\"button\" ng-click=\"vm.options.getPolicy(vm.poliza_number_data)\" class=\"btn btn-block btn-success\">Buscar póliza</button></div></div></div><div class=\"form-group col-xs-12 col-md-6\"><label for=\"selectType\">Tipo de endoso</label><select class=\"form-control m-b\" ng-disabled=\"vm.selectTypeStatus\" ng-model=\"vm.selectedType\" ng-options=\"type as type.name for type in vm.types track by type.id\" ng-change=\"vm.options.fillData(vm.selectedType)\"></select></div></div><div class=\"row\"><div class=\"form-group col-sm-3\"><label for=\"\">Contratante Actual</label> <input type=\"text\" ng-model=\"vm.contractors.contractor\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-3\"><label for=\"\">Contratante Nuevo</label> <input type=\"text\" ng-model=\"contractorNew\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label>Contratantes {{contrac.selected}}</label><ui-select theme=\"bootstrap\" ng-model=\"vm.contractors.contractorNew\" ng-disabled=\"vm.disabled.contractor\" style=\"min-width: 300px;\"><ui-select-match placeholder=\"Seleccione su contratante\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"contrac in vm.defaults.contractors | propsFilter: {name: $select.search, groupName: $select.search}\"><div ng-bind-html=\"contrac.name | highlight: $select.search\"></div><small>Tipo: {{contrac.type_person}}, Grupo: <span ng-bind-html=\"\'\'+contrac.groupName | highlight: $select.search\"></span></small></ui-select-choices></ui-select></div></div><div class=\"row\"><div class=\"form-group col-sm-3\"><label for=\"\">RFC</label> <input type=\"text\" ng-model=\"vm.contractors.rfc\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-sm-6\"><label for=\"\">Dirección*</label><select class=\"form-control\" ng-options=\"address for address in direccion_contratante track by address.url\" ng-disabled=\"vm.disabled.contractor\" ng-model=\"direccion_endoso\" ng-show=\"!flagB1\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select><select class=\"form-control\" data-ng-options=\"address.route + \' \'+ address.street_number + \' Int. \'+ address.street_number_int + \' \'+ address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in direccion_contratante track by address.url\" ng-change=\"order.options.changeAddress(direccion_endoso)\" ng-model=\"direccion_endoso\" ng-show=\"flagB1\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"row\"><div class=\"form-group col-sm-3 ml-16\"><label for=\"\">Concepto</label> <input type=\"text\" ng-model=\"vm.contractors.description\" class=\"form-control\" ng-disabled=\"vm.disabled.contractor\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-6\"><label for=\"\">Forma de pago</label><div class=\"form-control\" ng-bind=\"(vm.form.payment.value | payformtype)\" disabled=\"disabled\"></div></div><div class=\"form-group col-sm-6\"><label>Formas de pago</label><select class=\"form-control m-b\" name=\"payment\" ng-model=\"vm.form.payment\" ng-change=\"vm.options.changePayform(\'{{vm.form.payment}}\')\" ng-options=\"payment as payment.label for payment in vm.defaults.payform track by payment.value\" ng-disabled=\"vm.disabled.payform\"><option value=\"\" disabled=\"\">Selecciona forma de pago</option></select></div></div><div class=\"row\"><div class=\"form-group col-sm-3\"><label for=\"\">Paquete actual</label> <span class=\"form-control\" type=\"text\" disabled=\"\">{{vm.form.paquete.package_name}}</span></div><div class=\"form-group col-sm-3\"><label for=\"\">Ramo</label> <span class=\"form-control\" type=\"text\" disabled=\"\">{{vm.policy.ramo.ramo_name}}</span></div><div class=\"form-group col-sm-6\"><label for=\"\">Paquetes</label><select class=\"form-control m-b\" ng-model=\"vm.selectPackage\" ng-options=\"p as p.package_name for p in vm.packages track by p.id\" ng-change=\"vm.options.changePackage(vm.selectPackage, \'{{vm.selectPackage}}\')\" ng-disabled=\"vm.disabled.package\"><option value=\"\" disabled=\"\">Seleccione otro paquete.</option></select></div></div><div class=\"row\" ng-if=\"vm.selectedType\"><h3 class=\"ml-16\">Formularios</h3><div ng-include=\"\'app/endosos/type/a.html\'\" ng-if=\"vm.selectedType.id === 1 || vm.selectedType.id === 3\"></div><div ng-include=\"\'app/endosos/type/b.html\'\" ng-if=\"vm.selectedType.id === 2\"></div><div class=\"col-sm-12\" ng-if=\"vm.showUploader\"></div></div></form></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-success\" ng-click=\"vm.options.createEndorsement()\" type=\"button\">Crear</button> <button class=\"btn btn-white\" ng-click=\"vm.cancel()\" type=\"button\">Cerrar</button></div></div>");
$templateCache.put("app/modals/modal.endosos.packages.html","<div class=\"inmodal\"><div class=\"modal-header modal_title\"><h4 class=\"modal-title\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"row\"><div class=\"form-group col-sm-12\"><h3>Si cambia de paquete sus coberturas seran eliminadas, ¿esta seguro?</h3></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-success\" ng-click=\"vmm.options.save()\" type=\"button\">Aceptar</button> <button class=\"btn btn-white\" ng-click=\"vmm.options.cancel()\" type=\"button\">Cancelar</button></div></div>");
$templateCache.put("app/modals/modal.modify-policy.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Modificar OT</h4></div><div class=\"modal-body\"><div class=\"row table-responsive\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><table datatable=\"ng\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>No. Póliza</th><th>Contratante</th><th>Aseguradora</th><th>Paquete</th><th>Subramo</th><th>Forma de pago</th><th>Estatus</th></tr></thead><tbody><tr ng-click=\"editPolicy(insurance)\" ng-repeat=\"insurance in insurances track by $index\" ng-if=\"insurance.document_type == 1\"><td><div ng-if=\"insurance.poliza_number == \'0\'\">Orden</div><div ng-if=\"insurance.poliza_number != \'0\'\">{{ insurance.poliza_number }}</div></td><td>{{ insurance.natural }} {{ insurance.juridical }}</td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.paquete }}</td><td>{{ insurance.subramo }}</td><td payment=\"{{insurance.forma_de_pago}}\"></td><td status=\"{{insurance.status}}\"></td></tr></tbody></table></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div>");
$templateCache.put("app/modals/modal.ot-creator.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Crear OT/Póliza</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"OT\" ng-click=\"order.hideButtonOT()\"><div id=\"divCOT\" ng-include=\"\'app/ordenes/ordenes.generic.html\'\"></div></uib-tab><uib-tab index=\"1\" heading=\"Póliza\" ng-click=\"order.showButtonPoliza()\"><div id=\"divCPoliza\" ng-include=\"\'app/ordenes/ordenes.generic.html\'\"></div></uib-tab></uib-tabset></div></div></div></div></div><div class=\"modal-footer\" ng-if=\"activeJustified == 0\"><div class=\"form-group\"><div class=\"col-sm-12 text-center\"><button id=\"closeOT\" class=\"btn btn-default\" ng-click=\"order.save.closeModal()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success\" ng-click=\"order.save.saveInsurance(\'ot\')\" ng-disabled=\"order.form.contratante.length === 0\" ng-show=\"order.show.ot\" type=\"button\">Crear OT</button><button class=\"btn btn-success\" ng-click=\"order.save.saveInsurance(\'poliza\')\" ng-disabled=\"order.options.showPoliceCreator()\" ng-show=\"!order.show.ot\" type=\"button\">Crear póliza</button></div></div></div><div class=\"modal-footer\" ng-if=\"activeJustified == 1\"><div class=\"form-group\"><div class=\"col-xs-12 text-center\"><button ng-click=\"order.save.closeModal()\" class=\"btn btn-white\" type=\"button\">Cancelar</button> <button ng-click=\"order.save.saveInsurance(\'poliza\')\" class=\"btn btn-success\" type=\"button\">Guardar póliza</button></div></div></div></div>");
$templateCache.put("app/modals/modal.overview.html","<div class=\"inmodal\"><div class=\"modal-header gray-background-modal\"><h4 class=\"modal-title\">Resumen</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\" ng-init=\"poliza = true; coberturas = false; bitacora = false\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': poliza }\"><a ng-click=\"poliza = true; bitacora = false; coberturas = false\">Información de Póliza</a></li><li ng-class=\"{ \'active\': coberturas }\"><a ng-click=\"coberturas = true; bitacora = false; poliza = false\">Coberturas</a></li><li ng-class=\"{ \'active\': bitacora }\"><a ng-click=\"poliza = false; coberturas = false; bitacora = true\">Bitácora</a></li></ul><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{ \'active\': poliza }\"><div class=\"col-md-12\"><div class=\"col-md-5\"><h2 class=\"text-align-center\">Contratante</h2><hr><div class=\"form-group\"><span class=\"blue-color\">Nombre</span><div><span>{{contratante.full_name}} {{contratante.j_name}}</span></div></div><div class=\"form-group\"><span class=\"blue-color\">Dirección</span><div><span>{{ addressContratante.route }} {{ addressContratante.street_number }}, {{ addressContratante.sublocality }}.</span><div><span>{{ addressContratante.administrative_area_level_1}}, {{addressContratante.administrative_area_level_2}}.</span></div></div></div><div class=\"form-group\"><span class=\"blue-color\">Telefono</span><div><span>{{contratante.phone_number}}</span></div></div><div class=\"form-group\"><span class=\"blue-color\">Correo</span><div><span>{{contratante.email}}</span></div></div></div><div class=\"col-md-7 border-left\"><h2 class=\"text-align-center\">Generales</h2><hr><div class=\"col-sm-6 form-group\"><span class=\"blue-color\">Aseguradora - Cve Agente</span><div><span>{{ vm.myInsurance.aseguradora }} - {{vm.myInsurance.clave.clave}} <span></span></span></div></div><div class=\"col-sm-6 form-group\"><span class=\"blue-color\">Número de poliza &nbsp;</span><div><span>{{ vm.myInsurance.poliza_number }}<span></span></span></div></div><div class=\"col-sm-6 form-group\"><span class=\"blue-color\">Ramo &nbsp;</span><div><span>{{ vm.myInsurance.ramo }}<span></span></span></div></div><div class=\"col-sm-6 form-group\"><span class=\"blue-color\">Subramos &nbsp;</span><div><span>{{ vm.myInsurance.subramo }}<span></span></span></div></div><div class=\"col-sm-6 form-group\"><span class=\"blue-color\">Paquetes &nbsp;</span><div><span>{{ vm.myInsurance.paquete }}<span></span></span></div></div><div class=\"col-sm-6 form-group\"><span class=\"blue-color\">Fecha Inicio - Fecha Fin</span><div><span>{{ vm.myInsurance.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ vm.myInsurance.end_of_validity | date: \'dd/MM/yyyy\'}}<span></span></span></div></div><div class=\"col-sm-6 form-group\"><span class=\"blue-color\">Frecuencia de pago &nbsp;</span><div><span>{{ forma_pago(vm.myInsurance.forma_de_pago) }}<span></span></span></div></div><div class=\"col-sm-6 form-group\"><span class=\"blue-color\">Estatus &nbsp;</span><div><span>{{status(vm.myInsurance.status)}}<span></span></span></div></div><div class=\"col-sm-6 form-group\"><span class=\"blue-color\">Moneda</span><div><span ng-if=\"vm.myInsurance.f_currency == 1\">PESOS</span> <span ng-if=\"vm.myInsurance.f_currency == 2\">DOLARES</span></div></div><div class=\"col-sm-6 form-group\"><span class=\"blue-color\"><strong>Creado por:</strong></span><div><span>{{vm.myInsurance.owner}}</span></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{ \'active\': coberturas }\"><div><div><table class=\"table\"><thead><tr><th>Coberturas</th><th>Suma Asegurada</th><th>Deducible</th></tr></thead><tbody><tr ng-repeat=\"item in coberturas\"><td>{{ item.coverage_name }}</td><td>{{ item.sum_insured }}</td><td>{{ item.deductible }}</td></tr></tbody></table></div></div></div><div class=\"tab-pane\" ng-class=\"{ \'active\': bitacora }\"><comments datasource=\"vm.comments_data\" typemodel=\"1\" config=\"vm.comments_config\" idmodel=\"vm.policy_id\"></comments></div></div></div></form></div></div></div><div class=\"modal-footer gray-background-modal\"><button ng-click=\"vm.actions.edit()\" ng-if=\"vm.user.permiso.editar\" class=\"btn btn-success\" type=\"button\">Editar</button> <button ng-if=\"vm.isPoliza && user.permiso.crear\" ng-click=\"vm.actions.renew()\" class=\"btn btn-info\" type=\"button\">Renovar</button> <button ng-if=\"!vm.isPoliza\" ng-click=\"vm.actions.openPdf()\" class=\"btn btn-warning\" type=\"button\">Abrir PDF</button> <button ng-if=\"!vm.isPoliza\" ng-click=\"vm.actions.downloadPdf()\" class=\"btn btn-warning\" type=\"button\">Descargar PDF</button><button ng-click=\"vm.actions.close()\" class=\"btn btn-default\" type=\"button\">Cancelar</button></div></div>");
$templateCache.put("app/modals/modal.ramos.edit.html","<div class=\"inmodal\"><div class=\"modal-header modal_title\"><h4 class=\"modal-title\">Editar Ramo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizzard\"><form role=\"form\"><div class=\"row\"><div class=\"col-sm-12\"><h3>Información del Ramo</h3></div></div><div class=\"row\"><div class=\"form-group col-sm-6\"><label for=\"ramo_code\">Código del ramo</label> <input class=\"form-control\" type=\"number\" ng-model=\"ramo_form.ramo_code\"></div><div class=\"form-group col-sm-6\"><label for=\"ramo_name\">Nombre del ramo</label> <input class=\"form-control\" type=\"text\" ng-model=\"ramo_form.ramo_name\"></div></div><div class=\"check-element animate-show\" ng-show=\"ramo_form.validRamo()\"><div class=\"row\"><div class=\"col-sm-12\"><h3>Subramos</h3></div></div><div class=\"row\"><div class=\"form-group col-sm-6\"><label for=\"subramo_code\">Código del subramo</label> <input id=\"subramo_code\" type=\"number\" class=\"form-control\" ng-model=\"ramo_form.subramo_code\"></div><div class=\"form-group col-sm-6\"><label for=\"subramo_name\">Nombre del subramo</label> <input id=\"subramo_name\" type=\"text\" class=\"form-control\" ng-model=\"ramo_form.subramo_name\"></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><button type=\"button\" class=\"btn btn-info btn-block\" ng-click=\"ramo_form.addSubramo(ramo_form.subramo_code,ramo_form.subramo_name)\" ng-if=\"vm.user.permiso.editar\">Agregar</button></div></div><div class=\"check-element animate-show\" ng-show=\"ramo_form.hasSubramos()\"><div class=\"row\"><div class=\"form-group col-sm-12\"><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th>Subramo ID</th><th>Subramo Nombre</th><th class=\"width-30p\">Acción</th></tr></thead><tbody><tr ng-repeat=\"subramo in ramo_form.subramos track by $index\"><td>{{subramo.subramo_code}}</td><td>{{subramo.subramo_name}}</td><td><button type=\"button\" class=\"btn btn-danger\" ng-click=\"ramo_form.deleteSubramo(subramo)\" ng-if=\"vm.user.permiso.eliminar\">Eliminar</button></td></tr></tbody></table></div></div></div></div></div></form></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"ramo_form.submit()\" ng-disabled=\"!ramo_form.validForm()\" class=\"btn btn-success\" ng-if=\"vm.user.permiso.editar\">Guardar</button> <button type=\"button\" ng-click=\"ramo_form.cancel()\" class=\"btn\">Cancelar</button></div></div></div>");
$templateCache.put("app/modals/modal.receipts.html","<div class=\"inmodal\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Recibos pendientes</strong></li></ol></div></div><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Pagar recibos</h4></div><div class=\"modal-body\"><div ng-include=\"\'app/cobranzas/recibospendientes.tabla.html\'\" class=\"animate\" ng-if=\"!vm.show_binnacle\"></div><div class=\"row animate\" ng-if=\"vm.show_binnacle\"><div class=\"col-md-12\"><div><a class=\"btn btn-info pull-right\" ng-click=\"vm.returnToReceipts()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\"></comments></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"vm.close()\" type=\"button\">Salir</button></div></div>");
$templateCache.put("app/modals/modal.reportar-siniestros.html","<div class=\"inmodal\"><div class=\"modal-header modal_title nav-header\"><h4 class=\"modal-title\">Reportar Siniestros</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div ng-include=\"\'app/siniestros/siniestros.accidentes.html\'\"></div></div></div></div></div></div><div class=\"modal-footer\"><button ng-click=\"vm.saveSiniester()\" class=\"btn btn-info\" type=\"button\">Guardar</button> <button ng-click=\"vm.closeModal()\" class=\"btn btn-white\" type=\"button\">Cancelar</button></div></div>");
$templateCache.put("app/modals/modal.siniestros.html","<toaster-container></toaster-container><div class=\"inmodal\"><div class=\"modal-header modal_title\"><h4 class=\"modal-title\">Alta Siniestro</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form class=\"wizard-big\" role=\"form\" name=\"regSinForm\" ng-submit=\"processReg()\"><div class=\"row\"><div class=\"form-group col-sm-12\"><label>Fecha: <span ng-bind=\"date | date:\'MM/dd/yyyy\'\"></span></label></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label>Póliza:</label> <input value=\"125\" readonly=\"\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label>Inciso:</label> <input value=\"insiso\" readonly=\"\"></div></div></div><tr><div class=\"row\"><div class=\"col-sm-6\"><div ng-repeat=\"(key, val) in clientData\"><div ng-if=\"$index < 3\"><label for=\"{{key}}\">{{key}}:</label> <input type=\"text\" name=\"{{key}}\" id=\"{{key}}\" value=\"{{val}}\" readonly=\"\"></div></div></div><div class=\"col-sm-6\"><div ng-repeat=\"(key, val) in clientData\"><div ng-if=\"$index > 3\"><label for=\"{{key}}\">{{key}}:</label> <input type=\"text\" name=\"{{key}}\" id=\"{{key}}\" value=\"{{val}}\" readonly=\"\"></div></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><label>Número de reporte:</label> <input class=\"form-control\"></div><div class=\"col-sm-6\"><label>Fecha Siniestro:</label> <input class=\"form-control\" type=\"date\" max=\"vm.dateLimit.getDate()\"></div></div><div class=\"row\"><div class=\"col-sm-6\"><label>Fecha Rep:</label> <input class=\"form-control\" type=\"date\" max=\"vm.dateLimit.getDate()\"></div><div class=\"col-sm-6\"><label>Folio:</label> <input class=\"form-control\"></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label for=\"in-desc\">Descripción del Bien Afectado</label> <textarea class=\"form-control resize-none\" id=\"in-desc\" name=\"in-desc\" ng-keyup=\"textAExpand($event)\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label for=\"in-ubic\">Ubicación del bien afectado</label> <input class=\"form-control\" id=\"in-ubic\" name=\"in-ubic\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label for=\"in-event\">¿Qué fue lo que ocurrió?</label> <textarea class=\"form-control resize-none\" id=\"in-event\" name=\"in-event\" ng-keyup=\"textAExpand($event)\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"in-obs\">Observaciones</label> <textarea class=\"form-control resize-none\" id=\"in-obs\" name=\"in-obs\" ng-keyup=\"textAExpand($event)\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"in-obs\">Ajustador</label> <textarea class=\"form-control resize-none\" id=\"in-obs\" name=\"in-obs\" ng-keyup=\"textAExpand($event)\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label>Estima:</label> <input class=\"form-control\" value=\"\"></div><div class=\"form-group\"><label>Reclamo:</label> <input class=\"form-control\" value=\"\"></div><div class=\"form-group\"><label>Procede:</label> <input class=\"form-control\" value=\"\"></div><div class=\"form-group\"><label>Deducible:</label> <input class=\"form-control\" value=\"\"></div><div class=\"form-group\"><label>Participa:</label> <input class=\"form-control\" value=\"\"></div></div><div class=\"col-sm-6\"><label for=\"optionsSel\">PDie</label><ui-select ng-model=\"selectedItem\"><ui-select-match><span ng-bind=\"$select.selected.name\"></span></ui-select-match><ui-select-choices repeat=\"item in (options | filter: $select.search) track by item.id\"><span ng-bind=\"item.name\"></span></ui-select-choices></ui-select></div></div></tr></div></form></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">No</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Sí</button></div></div>");
$templateCache.put("app/modals/module_name.html","<div class=\"inmodal\" id=\"modal_in\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Cambio de Nombre a Módulo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><label for=\"\">Nombre:</label> <input type=\"text\" ng-model=\"moduleName\" class=\"form-control\"></div></div></div><div class=\"modal-footer\"><div class=\"pull-right\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cancelar</button> <button class=\"btn btn-primary ladda-button\" ng-disabled=\"form.$invalid\" ng-click=\"saveConfig(moduleName)\" type=\"button\">Guardar</button></div></div></div>");
$templateCache.put("app/modals/selectAddress.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal_title\"><h4 class=\"modal-title\">Selecciona la direccion</h4></div><div class=\"modal-body\"><div class=\"loading active\" ng-if=\"svm.loading\"><div class=\"sk-spinner sk-spinner-rotating-plane margin-top-45p\"></div></div><select class=\"form-control\" ng-model=\"item\" ng-options=\"item as item.label for item in svm.direcciones track by item.index\"><option value=\"\" selected=\"\" disabled=\"\">--Seleccione una direccion--</option></select></div><div class=\"modal-footer\"><button class=\"btn btn-danger pull-left\" ng-click=\"svm.actions.open()\" type=\"button\">Abrir PDF</button> <button class=\"btn btn-info\" ng-click=\"svm.actions.download()\" type=\"button\">Descargar PDF</button> <button class=\"btn btn-white\" ng-click=\"svm.actions.cancel()\" type=\"button\">Cerrar</button></div></div>");
$templateCache.put("app/multicotizador/multicotizador.emision.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Multicotizador</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Multicotizador</a></li><li class=\"active\"><strong>Emisión</strong></li></ol></div></div><div class=\"row\"><div class=\"container-fluid margin-top-15\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Crear emisión</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"quote-container\"><form class=\"quoteForm\" name=\"quoteFormIssue\" novalidate=\"\"><div class=\"line-dashed\"><div class=\"row\"><legend class=\"legend-title\" align=\"center\">Datos del Automóvil</legend><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label class=\"control-label\" for=\"type\">No. de Serie <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"serial\" ng-model=\"client.serial\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label class=\"control-label\" for=\"type\">No. de Motor <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"motor\" ng-model=\"client.motor\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label class=\"control-label\" for=\"type\">No. de Placas <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"placas\" ng-model=\"client.placas\" required=\"\"></div></div></div><div class=\"line-dashed\"><legend class=\"legend-title\" align=\"center\">Datos del Contratante</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label ng-if=\"postData.person_type ==1 || postData.person_type ==\'1\'\">Nombre(s)</label> <label ng-if=\"postData.person_type ==2 || postData.person_type ==\'2\'\">Razón Social</label> <input class=\"form-control\" name=\"name\" ng-model=\"postData.first_name\" placeholder=\"Ingrese el(los) nombre(s)\" required=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"postData.person_type ==1 || postData.person_type ==\'1\'\"><label>Apellido Paterno</label> <input class=\"form-control\" name=\"last_name\" ng-model=\"postData.last_name\" placeholder=\"Ingrese el apellido paterno\" required=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"postData.person_type ==1 || postData.person_type ==\'1\'\"><label>Apellido Materno</label> <input class=\"form-control\" name=\"second_last_name\" ng-model=\"postData.second_last_name\" placeholder=\"Ingrese el apellido materno\" required=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RFC <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"rfc\" ng-model=\"postData.rfc\" placeholder=\"Ingrese un RFC\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo <span class=\"red-color\">*</span></label> <input class=\"form-control\" type=\"email\" name=\"email\" ng-model=\"postData.email\" ng-change=\"validarEmail(postData.email)\" placeholder=\"Ingrese un correo electrónico\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label class=\"control-label\" for=\"zip\">Teléfono <span class=\"red-color\">*</span></label><phonenumber-directive placeholder=\"myPrompt\" model=\"postData.phone\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Calle <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"street\" ng-model=\"postData.address_street\" placeholder=\"Ingrese una calle\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Exterior <span class=\"red-color\">*</span></label> <input class=\"form-control\" type=\"tel\" name=\"no_ext\" ng-model=\"postData.address_number\" placeholder=\"Ingrese un número exterior\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Interior</label> <input class=\"form-control\" type=\"tel\" name=\"no_int\" ng-model=\"postData.address_int_number\" placeholder=\"Ingrese un número interior\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button type=\"submit\" class=\"btn btn-info pull-right btn-ml col-xs-12 ladda-button\" ng-click=\"saveData(1)\" ng-disabled=\"quoteFormIssue.$invalid\">Guardar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"btn btn-white pull-right btn-ml col-xs-12\" ng-click=\"return()\">Cancelar</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/multicotizador/multicotizador.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Multicotizador</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Multicotizador</strong></li></ol></div></div><div class=\"row\" ng-if=\"!quote.visible && !emisionVisible && !resultadoPoliza\"><div class=\"container-fluid margin-top-15\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\" ng-click=\"create_cot ? create_cot = false : create_cot = true\"><h5>Cotización</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"create_cot\"><div class=\"quote-container\"><form class=\"quoteForm\" name=\"quoteForm\" novalidate=\"\"><div class=\"line-dashed\"><div class=\"row\"><legend class=\"legend-title\" align=\"center\">Automóvil</legend><div class=\"form-group col-xs-12 col-sm-6 col-md-3\" ng-class=\"{\'has-error\': quoteForm.type.$invalid && quoteForm.brand.$touched}\"><label class=\"control-label\" for=\"brand\">Marca <span class=\"red-color\">*</span></label><select name=\"brand\" class=\"select2-item form-control\" ng-options=\"cb.descripcion for cb in car.brands\" ng-model=\"car.brand\" ng-change=\"getCarModels()\" required=\"\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\" ng-class=\"{\'has-error\': quoteForm.type.$invalid && quoteForm.model.$touched}\"><label class=\"control-label\" for=\"model\">Modelo <span class=\"red-color\">*</span></label><select name=\"model\" class=\"select2-item form-control\" ng-options=\"cm.descripcion for cm in car.models\" ng-model=\"car.model\" required=\"\" ng-disabled=\"!car.brand\" ng-change=\"getCarYear()\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\" ng-class=\"{\'has-error\': quoteForm.type.$invalid && quoteForm.year.$touched}\"><label class=\"control-label\" for=\"year\">Año <span class=\"red-color\">*</span></label><select name=\"year\" class=\"select2-item form-control\" ng-options=\"cy for cy in car.years | reverse\" ng-model=\"car.year\" ng-change=\"getVersions()\" required=\"\" ng-disabled=\"!car.model\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\" ng-class=\"{\'has-error\': quoteForm.type.$invalid && quoteForm.version.$touched}\"><label class=\"control-label\" for=\"version\">Version <span class=\"red-color\">*</span></label><select name=\"version\" class=\"select2-item form-control\" ng-options=\"cy.descripcion for cy in car.versions | reverse\" ng-model=\"car.version\" required=\"\" ng-disabled=\"!car.year\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\" ng-class=\"{ \'has-error\' : quoteForm.zip.$touched && quoteForm.zip.$invalid }\"><label class=\"control-label\" for=\"zip\">Código Postal <span class=\"red-color\">*</span></label> <input type=\"tel\" name=\"zip\" ng-model=\"client.zip\" minlength=\"5\" maxlength=\"5\" class=\"form-control\" placeholder=\"Ingrese el código postal\" ng-disabled=\"checkZipe\" ng-change=\"getTownsFromZip($event)\" ng-keypress=\"filterValue($event)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-class=\"{ \'has-error\' : quoteForm.suburb.$touched && quoteForm.suburb.$invalid }\"><label class=\"control-label\" for=\"suburb\">Colonia <span class=\"red-color\">*</span></label><select name=\"suburb\" class=\"select2-item form-control\" ng-options=\"cs for cs in client.suburbs\" ng-model=\"client.suburb\" ng-disabled=\"!client.zip\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select><div class=\"field-message\" ng-messages=\"quoteForm.suburb.$error\" ng-if=\"quoteForm.suburb.$touched && quoteForm.suburb.$invalid\" ng-cloak=\"\"><div class=\"help-block\" ng-message=\"required\">Favor de elegir una colonia</div></div></div></div></div><div class=\"line-dashed\"><div class=\"row\"><legend class=\"legend-title\" align=\"center\">Cliente</legend><div ng-if=\"car.person_type == 1\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-class=\"{ \'has-error\' : quoteFormIssue.name.$touched && quoteFormIssue.name.$invalid }\"><label>Nombre(s) <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"name\" ng-model=\"client.name\" placeholder=\"Ingrese el(los) nombre(s)\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-class=\"{ \'has-error\' : quoteFormIssue.last_name.$touched && quoteFormIssue.last_name.$invalid }\"><label>Apellido Paterno <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"last_name\" ng-model=\"client.last_name\" placeholder=\"Ingrese el apellido paterno\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-class=\"{ \'has-error\' : quoteFormIssue.second_last_name.$touched && quoteFormIssue.second_last_name.$invalid }\"><label>Apellido Materno <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"second_last_name\" ng-model=\"client.second_last_name\" placeholder=\"Ingrese el apellido materno\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"car.person_type == 1\" ng-class=\"{ \'has-error\' : quoteForm.gender.$touched && quoteForm.gender.$invalid }\"><label class=\"control-label\" for=\"gender\">Género <span class=\"red-color\">*</span></label><select name=\"gender\" class=\"select2-item form-control\" ng-options=\"cg.name for cg in client.genders\" ng-model=\"client.gender\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"car.person_type == 1\"><label>Fecha de nacimiento <span class=\"red-color\">*</span></label><div class=\"input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" name=\"birthday\" ng-model=\"client.birthdate\" value=\"client.birthdate\" ng-change=\"getAge()\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-class=\"{ \'has-error\' : quoteForm.rfc.$touched && (!rfcValido || quoteForm.rfc.$invalid) }\"><label>RFC <span class=\"red-color\">*</span></label> <input class=\"form-control col-md-12\" name=\"rfc\" ng-model=\"client.rfc\" placeholder=\"Ingrese RFC de la empresa\" required=\"\" ng-blur=\"validarRFC()\" ng-change=\"validarRFC()\"><div ng-show=\"quoteForm.rfc.$touched && quoteForm.rfc.$error.required\"><span class=\"error-message\">El RFC es requerido.</span></div><div ng-show=\"quoteForm.rfc.$touched && !rfcValido\"><span class=\"error-message\">El RFC no es válido.</span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-class=\"{ \'has-error\' : quoteForm.email.$touched && quoteForm.email.$invalid }\"><label>Correo <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"email\" ng-model=\"client.email\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-class=\"{ \'has-error\' : quoteForm.phone.$touched && quoteForm.phone.$invalid }\"><label>Teléfono <span class=\"red-color\">*</span></label><phonenumber-directive placeholder=\"myPrompt\" model=\"client.phone\" required=\"\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label for=\"packageSelect\">Paquete <span class=\"red-color\">*</span></label><select id=\"packageSelect\" name=\"paquete\" ng-init=\"client.paquete=\'01\'\" class=\"form-control\" ng-model=\"client.paquete\" ng-options=\"package.value as package.name for package in paquetes\"><option value=\"\">Selecciona un paquete</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Frecuencia <span class=\"red-color\">*</span></label><select class=\"form-control\" name=\"frecuencia\" ng-init=\"client.frecuencia=\'C\'\" ng-options=\"q_freq.value as q_freq.name for q_freq in quote.frecuencys\" ng-model=\"client.frecuencia\"><option disabled=\"\" value=\"\">Selecciona una opción</option></select></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button type=\"submit\" class=\"btn btn-success col-xs-12 m-t\" ng-click=\"createQuote()\" ng-disabled=\"quoteForm.$invalid\">Solicitar</button></div></div></form></div></div></div></div></div><div ng-if=\"message_error\" class=\"text-center\"><span>{{message_error}}</span></div><div class=\"row text-center\" ng-if=\"loader\"><p style=\"font-weight: bold; color: #43bae0;\">ESPERE, POR FAVOR</p><img src=\"../../assets/images/loaders/loader_5.gif\"></div><div class=\"row animate\" ng-if=\"quote.visible && !emisionVisible && !resultadoPoliza && !loader\"><div class=\"quote-container container-fluid margin-top-15\"><div class=\"ibox float-e-margins\" ng-init=\"res_cot = true\"><div class=\"ibox-title\" ng-click=\"res_cot ? res_cot = false : res_cot = true\"><h5>Resultado de cotización</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><br></div><div class=\"row\"><div class=\"line-dashed\"><div class=\"row\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"col-xs-12 col-sm-3 form-group\"><span class=\"blue-color\">Marca:</span><div><span>{{ quoteLista.marca }}</span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><span class=\"blue-color\">Modelo:</span><div><span>{{ quoteLista.submarca }}</span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><span class=\"blue-color\">Año:</span><div><span>{{quoteLista.modelo }}</span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><span class=\"blue-color\">Version:</span><div><span>{{ quoteLista.descripcion}}</span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><span class=\"blue-color\">Paquete:</span><div><select id=\"packageSelect\" name=\"paquete\" ng-init=\"client.paquete=\'01\'\" class=\"form-control\" ng-model=\"client.paquete\" ng-options=\"package.value as package.name for package in paquetes\"><option value=\"\">Selecciona un paquete</option></select></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><span class=\"blue-color\">Frecuencia:</span><div><select class=\"form-control\" ng-options=\"q_freq.value as q_freq.name for q_freq in quote.frecuencys\" ng-model=\"postData.quoteFrecuency\" ng-change=\"recotizar()\"><option disabled=\"\" value=\"\">Selecciona una opción</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12 m-t\" ng-click=\"verPDF(1)\">Ver pdf</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-danger col-xs-12 m-t\" ng-click=\"cotizarOtro()\">Cotizar otro auto</button></div></div></div></div></div><div class=\"row\"><legend class=\"legend-title\" align=\"center\">Elige la mejor opción</legend><div class=\"col-md-4\" ng-repeat=\"item in quotes\" ng-if=\"(!item.error && item.aseguradora != \'tumomento\') || ( item.aseguradora == \'tumomento\' && item.prima )\"><div class=\"bg-card\"><div class=\"row rowmtc\"><div class=\"col-md-12 box-blue\"><p ng-if=\"item.aseguradora == \'ana\'\" class=\"text-auto\">{{item.DESC}} ({{item.CVEVEH}})</p><p ng-if=\"item.aseguradora == \'chubb\'\" class=\"text-auto\">{{item.descr_chubb}} ({{item.CVEVEH}})</p><p ng-if=\"item.aseguradora == \'gnp\'\" class=\"text-auto\">{{item.descr_gnp}} ({{item.CVEVEH}})</p><p ng-if=\"item.aseguradora == \'hdi\'\" class=\"text-auto\">{{item.descr_hdi}} ({{item.CVEVEH}})</p><p ng-if=\"item.aseguradora == \'ps\'\" class=\"text-auto\">{{item.descr_ps}} ({{item.raw_response.request_json.clave_auto}})</p><p ng-if=\"item.aseguradora == \'qualitas\'\" class=\"text-auto\">{{quoteLista.descripcion}} ({{item.raw_response.Movimientos.Movimiento.DatosVehiculo.ClaveAmis}})</p><p ng-if=\"item.aseguradora == \'tumomento\'\" class=\"text-auto\">{{ item.request_xml.vehicle.version ? item.request_xml.vehicle.version : quoteLista.descripcion }}</p></div><div class=\"col-md-12\"><h3 ng-if=\"item.aseguradora != \'ps\'\"><strong>No. Cotización:</strong>{{item.numero_cotizacion}}</h3></div><div class=\"col-sm-4\"><div class=\"col-12\"><img ng-if=\"item.aseguradora == \'ana\'\" class=\"logo-mini\" src=\"../../assets/images/providers/Logo_ANA.png\" alt=\"Ana\"> <img ng-if=\"item.aseguradora == \'chubb\'\" class=\"logo-mini\" src=\"../../assets/images/providers/Logo_CHUBB.png\" alt=\"Chubb\"> <img ng-if=\"item.aseguradora == \'gnp\'\" class=\"logo-mini\" src=\"../../assets/images/providers/Logo_GNP.png\" alt=\"GNP\"> <img ng-if=\"item.aseguradora == \'hdi\'\" class=\"logo-mini\" src=\"../../assets/images/providers/Logo_HDI.png\" alt=\"HDI\"> <img ng-if=\"item.aseguradora == \'ps\'\" class=\"logo-mini\" src=\"../../assets/images/providers/Logo_Primero.png\" alt=\"PS\"> <img ng-if=\"item.aseguradora == \'qualitas\'\" class=\"logo-mini\" src=\"../../assets/images/providers/Logo_Qualitas.png\" alt=\"Qualitas\"> <img ng-if=\"item.aseguradora == \'tumomento\'\" class=\"logo-mini\" src=\"../../assets/images/providers/Logo_MOMENTO.png\" alt=\"TuMomento\"></div></div><div class=\"col-sm-4 text-end\"><label>Cantidad de pagos :</label><p class=\"pagos\" ng-switch=\"quoteLista.forma_de_pago\"><span ng-switch-when=\"C\" class=\"subprice-bold\">1</span> <span ng-switch-when=\"S\" class=\"subprice-bold\">2</span> <span ng-switch-when=\"T\" class=\"subprice-bold\">4</span> <span ng-switch-when=\"M\" class=\"subprice-bold\">12</span> <span ng-switch-default=\"\" class=\"subprice-bold\">1</span></p><div ng-if=\"quoteLista.forma_de_pago != \'C\'\"><label>Primer pago:</label> <span class=\"subprice-bold\" ng-switch=\"item.aseguradora\"><span ng-switch-when=\"ana\">{{(item.recibos && item.recibos[0] ? item.recibos[1][\'@primatotal\'] : 0) | currency}}</span> <span ng-switch-when=\"chubb\">{{(item.recibos && item.recibos.RECIBO && item.recibos.RECIBO[0] ? item.recibos.RECIBO[0].PTOTAL : 0) | currency}}</span> <span ng-switch-when=\"gnp\">{{(item.recibos && item.recibos.PRIMER_RECIBO ? item.recibos.PRIMER_RECIBO : 0) | currency}}</span> <span ng-switch-when=\"hdi\">{{(item.recibos && item.recibos.PrimeraExhibicion ? item.recibos.PrimeraExhibicion : 0) | currency}}</span> <span ng-switch-when=\"qualitas\">{{item.recibos[0] ? item.recibos[0].PrimaTotal : 0 | currency}}</span> <span ng-switch-when=\"ps\">{{item.recibos.primer_recibo | currency}}</span> <span ng-switch-when=\"tumomento\">{{item.prima | currency}}</span> <span ng-switch-default=\"\">0</span><br><span ng-if=\"quoteLista.forma_de_pago == \'S\'\" class=\"subprice\">Siguiente pago:</span> <span ng-if=\"quoteLista.forma_de_pago == \'T\'\" class=\"subprice\">Siguientes 3 pagos:</span> <span ng-if=\"quoteLista.forma_de_pago == \'M\'\" class=\"subprice\">Siguientes 11 pagos:</span> <span ng-if=\"item.aseguradora == \'ana\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos[1] ? item.recibos[1][\'@primatotal\'] : 0 | currency}}</span></span> <span ng-if=\"item.aseguradora == \'chubb\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos && item.recibos.RECIBO[1] ? item.recibos.RECIBO[1].PTOTAL : 0 | currency}}</span></span> <span ng-if=\"item.aseguradora == \'gnp\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos.RECIBO_SUBSECUENTE | currency}}</span></span> <span ng-if=\"item.aseguradora == \'hdi\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos.RecibosSubsecuentes | currency}}</span></span> <span ng-if=\"item.aseguradora == \'ps\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos.recibo_subsecuente | currency}}</span></span> <span ng-if=\"item.aseguradora == \'qualitas\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos[1] ? item.recibos[1].PrimaTotal : 0 | currency}}</span></span> <span ng-if=\"item.aseguradora == \'tumomento\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.prima | currency}}</span></span></span></div></div><div class=\"col-sm-4 text-end\"><label>Total:</label><p ng-if=\"item.aseguradora == \'ana\'\" class=\"price\">{{item.primas.PTOTAL | currency}}</p><p ng-if=\"item.aseguradora == \'chubb\'\" class=\"price\">{{item.primas.PTOTAL | currency}}</p><p ng-if=\"item.aseguradora == \'gnp\'\" class=\"price\">{{item.primas.TOTAL_PAGAR | currency}}</p><p ng-if=\"item.aseguradora == \'hdi\'\" class=\"price\">{{item.primas.PrimaTotal | currency}}</p><p ng-if=\"item.aseguradora == \'ps\'\" class=\"price\">{{item.primas.prima_total | currency}}</p><p ng-if=\"item.aseguradora == \'qualitas\'\" class=\"price\">{{item.primas.PrimaTotal | currency}}</p><p ng-if=\"item.aseguradora == \'tumomento\' && quoteLista.forma_de_pago == \'C\'\" class=\"price\">{{item.prima | currency}}</p><p ng-if=\"item.aseguradora == \'tumomento\' && quoteLista.forma_de_pago == \'M\'\" class=\"price\">{{(item.prima * 12) | currency}}</p></div><div class=\"col-md-12\"></div><div class=\"col-md-4\" style=\"padding-bottom: 10px;\"><button ng-if=\"item.aseguradora != \'qualitas\'\" class=\"btn btn-secondary w-100\" data-bs-toggle=\"modal\" data-bs-target=\"#exampleModal2\" ng-click=\"wrongCar(item)\">Este no es mi auto</button></div><div class=\"col-md-4\" style=\"padding-bottom: 10px;\"><button class=\"btn btn-primary w-100\" data-bs-toggle=\"modal\" data-bs-target=\"#exampleModal\" ng-click=\"showCoverages(item)\">Ver coberturas</button></div><div class=\"col-md-4\" style=\"padding-bottom: 10px;\"><button class=\"btn btn-secondary w-100\" ng-click=\"seleccionarCotizacion(item)\">Continuar</button></div></div></div></div></div></div></div></div></div><div class=\"row animate\" ng-if=\"emisionVisible\"><div class=\"container-fluid margin-top-15\"><div class=\"col-12\"><div class=\"ibox-content\"><form name=\"formPoliza\" ng-submit=\"emitirPoliza(formPoliza)\"><div class=\"row\"><div class=\"col-12 col-sm-8\"><h3 class=\"title\">Información del vehículo</h3></div><div class=\"col-12 col-sm-4\"><div class=\"col-12\"><img ng-if=\"selected_quote.aseguradora == \'ana\'\" class=\"logo\" src=\"../../../assets/images/providers/Logo_Ana.png\" alt=\"\"> <img ng-if=\"selected_quote.aseguradora == \'chubb\'\" class=\"logo\" src=\"../../../assets/images/providers/Logo_Chubb.png\" alt=\"\"> <img ng-if=\"selected_quote.aseguradora == \'gnp\'\" class=\"logo\" src=\"../../../assets/images/providers/Logo_GNP.png\" alt=\"\"> <img ng-if=\"selected_quote.aseguradora == \'hdi\'\" class=\"logo\" src=\"../../../assets/images/providers/Logo_HDI.png\" alt=\"\"> <img ng-if=\"selected_quote.aseguradora == \'ps\'\" class=\"logo\" src=\"../../../assets/images/providers/Logo_Primero.png\" alt=\"\"> <img ng-if=\"selected_quote.aseguradora == \'qualitas\'\" class=\"logo\" src=\"../../../assets/images/providers/Logo_Qualitas.png\" alt=\"\"> <img ng-if=\"selected_quote.aseguradora == \'tumomento\'\" class=\"logo\" src=\"../../../assets/images/providers/Logo_MOMENTO.png\" alt=\"\"></div></div></div><div class=\"row\"><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : serieError }\" ng-if=\"selected_quote.aseguradora != \'chubb\' || registroChubb\"><label>Numero de serie:</label> <input class=\"form-control\" type=\"text\" ng-model=\"formPoliza.serie\" required=\"\"> <small ng-if=\"serieError\" class=\"text-danger\">Serie es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : engineError }\" ng-if=\"(selected_quote.aseguradora != \'chubb\' || registroChubb) && selected_quote.aseguradora != \'ps\'\"><label>Numero de motor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"formPoliza.motor\" required=\"\"> <small ng-if=\"engineError\" class=\"text-danger\">Motor es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : platesError }\" ng-if=\"selected_quote.aseguradora != \'chubb\' || registroChubb\"><label>Número de placas:</label> <input class=\"form-control\" type=\"text\" ng-model=\"formPoliza.placas\" required=\"\"> <small ng-if=\"platesError\" class=\"text-danger\">Placas es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : nameError }\" ng-if=\"!registroChubb\"><label>Nombre:</label> <input class=\"form-control\" ng-value=\"quoteLista.nombre\" type=\"text\" ng-model=\"formPoliza.nombre\" ng-readonly=\"true\"> <small ng-if=\"nameError\" class=\"text-danger\">Nombre es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : lastError }\" ng-if=\"!registroChubb\"><label>Apellido paterno:</label> <input class=\"form-control\" ng-value=\"quoteLista.apellido_paterno\" type=\"text\" ng-model=\"formPoliza.paterno\" ng-readonly=\"true\"> <small ng-if=\"lastError\" class=\"text-danger\">Apellido paterno es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : secondError }\" ng-if=\"!registroChubb\"><label>Apellido materno:</label> <input class=\"form-control\" ng-value=\"quoteLista.apellido_materno\" type=\"text\" ng-model=\"formPoliza.materno\" ng-readonly=\"true\"> <small ng-if=\"secondError\" class=\"text-danger\">Apellido materno es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : platesError }\" ng-if=\"selected_quote.aseguradora == \'gnp\' || selected_quote.aseguradora == \'ps\'\"><label>Género:</label> <input ng-if=\"quoteLista.sexo === \'F\'\" class=\"form-control\" type=\"text\" placeholder=\"Femenino\" readonly=\"\"> <input ng-if=\"quoteLista.sexo === \'M\'\" class=\"form-control\" type=\"text\" placeholder=\"Masculino\" readonly=\"\"> <small ng-if=\"platesError\" class=\"text-danger\">Placas es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : rfcError }\" ng-if=\"!registroChubb\"><label>Fecha de nacimiento:</label> <input class=\"form-control\" ng-value=\"quoteLista.fecha_nacimiento\" type=\"text\" ng-model=\"formPoliza.fecha_nacimiento\" readonly=\"\"> <small ng-if=\"rfcError\" class=\"text-danger\">Fecha de nacimiento es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : rfcError }\" ng-if=\"!registroChubb\"><label>RFC:</label> <input class=\"form-control\" ng-value=\"quoteLista.rfc\" type=\"text\" ng-model=\"formPoliza.rfc_emisor\" required=\"\"> <small ng-if=\"rfcError\" class=\"text-danger\">RFC es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : curpError }\" ng-if=\"selected_quote.aseguradora == \'ana\'\"><label>CURP:</label> <input class=\"form-control\" type=\"text\" ng-model=\"formPoliza.curp\" required=\"\"> <small ng-if=\"curpError\" class=\"text-danger\">CURP es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : addressError }\" ng-if=\"selected_quote.aseguradora != \'ps\' && !registroChubb\"><label>Calle:</label> <input class=\"form-control\" type=\"text\" ng-model=\"formPoliza.calle\" required=\"\"> <small ng-if=\"addressError\" class=\"text-danger\">Dirección es un campo requerido.</small></div><div class=\"col-12 col-sm-2 form-group\" ng-class=\"{ \'has-error\' : addressError }\" ng-if=\"selected_quote.aseguradora != \'ps\' && !registroChubb\"><label>Número exterior:</label> <input class=\"form-control\" type=\"text\" ng-model=\"formPoliza.numeroexterior\" required=\"\"> <small ng-if=\"addressError\" class=\"text-danger\">Dirección es un campo requerido.</small></div><div class=\"col-12 col-sm-2 form-group\" ng-if=\"selected_quote.aseguradora != \'ps\' && !registroChubb\"><label>Número interior:</label> <input class=\"form-control\" type=\"text\" ng-model=\"formPoliza.numerointerior\"></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : neighborhoodError }\" ng-if=\"selected_quote.aseguradora != \'chubb\' && selected_quote.aseguradora != \'gnp\' && selected_quote.aseguradora != \'ps\' && selected_quote.aseguradora != \'tumomento\' && selected_quote.aseguradora != \'qualitas\'\"><label>Colonia:</label><select class=\"form-control\" ng-model=\"formPoliza.colonia\" required=\"\"><option ng-repeat=\"item in neighborhoods\" value=\"{{item.nombre}}\">{{item.nombre}}</option></select><small ng-if=\"neighborhoodError\" class=\"text-danger\">Colonia es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : neighborhoodError }\" ng-if=\"selected_quote.aseguradora == \'gnp\' || selected_quote.aseguradora == \'ps\' || selected_quote.aseguradora == \'tumomento\'\"><label>Colonia:</label><select class=\"form-control\" ng-model=\"formPoliza.colonia\" required=\"\"><option ng-repeat=\"item in neighborhoods\" value=\"{{item.clave}}\">{{item.nombre}}</option></select><small ng-if=\"neighborhoodError\" class=\"text-danger\">Colonia es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : addressError }\" ng-if=\"selected_quote.aseguradora == \'ps\'\"><label>Calle y numero:</label> <input class=\"form-control\" type=\"text\" ng-model=\"formPoliza.calle_numero\" required=\"\"> <small ng-if=\"addressError\" class=\"text-danger\">Dirección es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : neighborhoodError }\" ng-if=\"selected_quote.aseguradora == \'gnp\'\"><label>Razón social:</label> <input class=\"form-control\" type=\"text\" ng-model=\"formPoliza.razon_social\"> <small ng-if=\"neighborhoodError\" class=\"text-danger\">Razon social es un campo requerido.</small></div><div class=\"col-12 col-sm-4 form-group\" ng-class=\"{ \'has-error\' : neighborhoodError }\" ng-if=\"selected_quote.aseguradora != \'ana\' && selected_quote.aseguradora != \'chubb\' && selected_quote.aseguradora != \'qualitas\' && selected_quote.aseguradora != \'ps\' && selected_quote.aseguradora != \'tumomento\'\"><label>Regimen fiscal (Persona física):</label><select class=\"form-control\" ng-model=\"formPoliza.regimenFiscal\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona un régimen fiscal</option><option ng-repeat=\"item in regimenFiscales\" value=\"{{item.id}}\">{{item.name}}</option></select><small ng-show=\"formPoliza.regimenFiscal.$touched && formPoliza.regimenFiscal == \'\'\" class=\"text-danger\">Este campo es obligatorio.</small></div></div><button type=\"submit\" class=\"btn btn-success col-xs-3 m-t\" ng-if=\"(selected_quote.aseguradora != \'chubb\' || registroChubb)\">Emitir</button> <button type=\"button\" class=\"btn btn-success col-xs-3 m-t\" ng-if=\"selected_quote.aseguradora == \'chubb\' && registroChubb == false\" ng-click=\"registrarChubb(formPoliza)\">Continuar</button> <button type=\"button\" class=\"btn btn-secondary col-xs-3 m-t\" ng-click=\"regresarCotizaciones()\">Regresar</button></form></div></div></div></div><div class=\"row\" ng-if=\"resultadoPoliza && !loader\"><div class=\"container-fluid d-flex justify-content-center align-items-center\" style=\"height: 100vh;\"><div class=\"col-12 col-sm-12 col-md-12\"><div class=\"box-white text-center\"><p class=\"title-green\">¡FELICIDADES!</p><p class=\"subtitle\">Tu póliza de</p><img ng-if=\"selected_quote.aseguradora == \'ana\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_ANA.png\" alt=\"Ana\"> <img ng-if=\"selected_quote.aseguradora == \'chubb\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_CHUBB.png\" alt=\"Chubb\" style=\"max-width: 30%;\"> <img ng-if=\"selected_quote.aseguradora == \'gnp\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_GNP.png\" alt=\"GNP\"> <img ng-if=\"selected_quote.aseguradora == \'hdi\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_HDI.png\" alt=\"HDI\"> <img ng-if=\"selected_quote.aseguradora == \'ps\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_Primero.png\" alt=\"PS\"> <img ng-if=\"selected_quote.aseguradora == \'qualitas\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_Qualitas.png\" alt=\"Qualitas\"> <img ng-if=\"selected_quote.aseguradora == \'tumomento\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_MOMENTO.png\" alt=\"TuMomento\"><p class=\"subtitle\">fue emitida correctamente</p></div><div class=\"box-black text-center mt-4\"><p class=\"title-blue\">NÚMERO DE PÓLIZA</p><p class=\"subtitle-blue\">{{ policy }}</p><div class=\"row justify-content-center\"><div class=\"col-12 col-sm-3 mb-2\"></div><div class=\"col-12 col-sm-2 mb-2\"><button ng-if=\"selected_quote.aseguradora === \'ana\'\" class=\"btn btn-info col-xs-12 m-t\" ng-click=\"downloadPdfAna(2)\">DESCARGAR</button> <button ng-if=\"selected_quote.aseguradora === \'chubb\'\" class=\"btn btn-info col-xs-12 m-t\" ng-click=\"downloadPdfChubb()\">DESCARGAR</button> <button ng-if=\"selected_quote.aseguradora === \'gnp\'\" class=\"btn btn-info col-xs-12 m-t\" ng-click=\"downloadPdfGnp()\">DESCARGAR</button> <button ng-if=\"selected_quote.aseguradora === \'hdi\'\" class=\"btn btn-info col-xs-12 m-t\" ng-click=\"downloadPdfHdi()\">DESCARGAR</button> <button ng-if=\"selected_quote.aseguradora === \'ps\'\" class=\"btn btn-info col-xs-12 m-t\" ng-click=\"downloadPdfPs(quoteCreated.poliza_pdf)\">DESCARGAR</button> <button ng-if=\"selected_quote.aseguradora === \'tumomento\'\" class=\"btn btn-info col-xs-12 m-t\" ng-click=\"downloadPdfMomento()\">DESCARGAR</button> <button ng-if=\"selected_quote.aseguradora === \'qualitas\'\" class=\"btn btn-info col-xs-12 m-t\" ng-click=\"downloadPdfQualitas(2)\">DESCARGAR</button></div><div class=\"col-12 col-sm-2\"><button type=\"button\" class=\"btn btn-success col-xs-12 m-t\" ng-click=\"obtenerPoliza(\'registrar\',selected_quote.aseguradora,cotizacion_id_emitido)\">REGISTRAR PÓLIZA</button></div><div class=\"col-12 col-sm-2\"><button class=\"btn btn-danger col-xs-12 m-t\" ng-click=\"cotizarOtro()\">COTIZAR OTRO AUTO</button></div><div class=\"col-12 col-sm-12\"></div></div></div></div></div></div><style>\n              /* Estilo para el contenedor de la descripción del auto */\n        .box-blue {\n            background-color: #0191a9; /* Fondo azul */\n            color: white; /* Color del texto */\n            padding: 10px; /* Espaciado interno */\n            border-radius: 8px 8px 0 0; /* Bordes redondeados */\n        }\n\n        /* Estilo para el texto de la descripción */\n        .box-blue .text-auto {\n            font-weight: bold; /* Negritas */\n            margin: 0; /* Quitar margen para evitar amontonamiento */\n        }\n\n        /* Espaciado para otros elementos en el contenedor */\n        .bg-card {\n            padding: 15px; /* Espaciado interno en el contenedor */\n            margin-bottom: 15px; /* Espaciado inferior entre tarjetas */\n           \n        }\n\n        /* Asegurarse que las imágenes y textos estén bien alineados */\n         .rowmtc {\n            display: flex; /* Alinear elementos en fila */\n            flex-wrap: wrap; /* Permitir que se envuelvan */\n            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Sombra en la parte inferior de la tarjeta */\n            border-radius: 8px;\n        } \n\n        /* Estilo para precios */\n        .price {\n            font-weight: bold; /* Negritas */\n            font-size:20px; /* Tamaño de fuente más grande */\n        }\n        .pagos {\n          font-size: 17px;\n        }       \n        .subprice{\n          font-weight: bold;\n        }\n        .subtitle{\n          font-size: 13px;\n        }\n        .logo-mini{\n         height: 90px;\n         width: auto;\n        }\n        .botones{\n          padding-bottom: 10px;\n          padding-top: 10px;\n          padding-left: 10px;\n          padding-right: 10px;\n        }\n     \n        .logo {\n            max-width: 100%; /* Asegura que la imagen no se desborde */\n            height: auto; /* Asegura que la imagen no se desborde */\n           \n        }\n        .text-end {\n            text-align: right; /* Alineación a la derecha */\n        }\n        .title-blue{\n          color: #0474c4;\n          font-weight: bold;\n          font-size: 15px;\n        }\n        .title-green{\n          color: #0191a9;\n          font-weight: bold;\n          font-size: 18px;\n        }\n        .has-error input {\n          border-color: red;\n        }\n        .error-message {\n          color: red;\n        }\n\n     </style>");
$templateCache.put("app/multicotizador/multicotizador.tab.html","<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"list-group-item\"><a href=\"\" ng-click=\"select($event)\" uib-tab-heading-transclude=\"\">{{heading}}</a></li>");
$templateCache.put("app/multicotizador/multicotizador.tabset.html","<div class=\"tab-wrapper\"><div class=\"fh-breadcrumb\"><div class=\"fh-column\"><div class=\"full-height-scroll\"><ul class=\"list-group elements-list\" ng-transclude=\"\"></ul></div></div><div class=\"full-height\"><div class=\"full-height-scroll white-bg border-left\"><div class=\"element-detail-box\"><div class=\"tab-content\"><div id=\"tab-{{$index}}\" class=\"tab-pane\" ng-repeat=\"tab in tabset.tabs\" ng-class=\"{active: tabset.active === tab.index}\" uib-tab-content-transclude=\"tab\"></div></div></div></div></div></div></div>");
$templateCache.put("app/notificaciones/notificaciones.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Notificaciones</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Notificaciones</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 form-group\"><div class=\"alert alert-success alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> Las <b>Notificaciones</b> se configuran sobre el <b>Nivel de Agrupación</b> del <b>Contratante</b>.</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Título de la notificación <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"notificaction.title\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Sitio Promoción</label> <input class=\"form-control\" type=\"text\" ng-model=\"notificaction.site\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label class=\"col-xs-12 btn btn-success m-t\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i> Agregar Imagen <input multiple=\"\" nv-file-select=\"\" class=\"display-none\" id=\"file_url\" type=\"file\" name=\"xyz\" uploader=\"uploader\" accept=\"image/*\"></label></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Texto <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"notificaction.description\" name=\"description\"></textarea></div><div class=\"col-xs-12 form-group\"><table class=\"table table-stripped hidden-xs hidden-sm\"><thead><tr><th ng-model=\"archivos.headers[0]\">{{archivos.headers[0]}}</th><th ng-model=\"archivos.headers[1]\">{{archivos.headers[1]}}</th><th ng-model=\"archivos.headers[2]\">{{archivos.headers[2]}}</th><th ng-model=\"archivos.headers[3]\">{{archivos.headers[3]}}</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue track by $index\"><td><input ng-model=\"item.file.name\" ng-blur=\"uploader.onRename(item)\" onblur=\"blurArchivoCargado(this)\" class=\"form-control display-none\"> <strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }}MB</td><td ng-show=\"uploader.isHTML5\"><div class=\"progress margin-bottom-0\"><div class=\"progress-bar\" ng-style=\"{ \'width\': item.progress + \'%\' }\" role=\"progressbar\"></div></div></td><td nowrap=\"\"><button class=\"btn btn-danger btn-xs\" ng-click=\"item.remove()\" type=\"button\">Remover</button> <button class=\"btn btn-info btn-xs\" onclick=\"renombrarArchivoCargado()\" type=\"button\">Renombrar</button> <span class=\"btn btn-success btn-xs display-none\">Guardar</span></td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Filtros</legend></div><div class=\"col-xs-12 form-group\"><div class=\"alert alert-danger alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Importante:</strong> Los <b>Contratante(s), Aseguradora(s), Ramo(s)</b> se cargan al elegir un <b>Nivel de Agrupación.</b></div></div><div ng-if=\"obteniendoFiltros\" class=\"col-xs-12 form-group\" style=\"text-align: center;\"><img src=\"../../assets/images/loaders/loader_6.gif\"><div class=\"alert alert-secondary alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> Se estan consultando los <b>Contratante(s), Aseguradora(s), Ramo(s)</b></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nivel de Agrupación</label><select class=\"form-control\" ng-disabled=\"obteniendoFiltros\" ng-options=\"item.id as item.description for item in agrupaciones track by item.id\" ng-model=\"notificaction.poliza_groupinglevel\" ng-change=\"fillData(notificaction.poliza_groupinglevel)\"></select><br><div class=\"alert alert-info alert-dismissible\" ng-if=\"!notificaction.poliza_groupinglevel\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Si no selecciona un <b>Nivel de Agrupación</b> se enviará a todos los niveles.</div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Contratante(s)</label><select class=\"js-example-basic-multiple form-control\" multiple=\"multiple\" ng-model=\"select_contractor\" data-ng-options=\"contractor.full_name ? contractor.full_name : contractor.id for contractor in contractors | orderBy: \'full_name\' track by contractor.url\" ng-change=\"selectContra(select_contractor)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" multiple=\"multiple\" ng-model=\"select_ramo\" data-ng-options=\"ramo.ramo_name ? ramo.ramo_name : ramo.id for ramo in ramos | orderBy: \'ramo_name\' track by ramo.id\" ng-change=\"selectRamo(select_ramo)\"></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"showProgram\"><label>Fecha Programada</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"notificaction.startsAt\" value=\"{{notificaction.startsAt}}\" ng-change=\"checkDate()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"showProgram\"><div uib-timepicker=\"\" ng-model=\"notificaction.startsHr\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"true\" ng-change=\"checkDate()\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button class=\"btn btn-success col-xs-12 ladda-button\" ng-click=\"save()\"><i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i> Enviar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><button ng-if=\"showProgram\" class=\"btn btn-white col-xs-12\" ng-click=\"program(false)\"><i class=\"fa fa-cancel\" aria-hidden=\"true\"></i> Cancelar</button></div></div><script type=\"text/javascript\">\n  function mostrarImagen(input) {\n    if (input.files && input.files[0]) {\n      var reader = new FileReader();\n      reader.onload = function (e) {\n        $(\'#img_destino\').attr(\'src\', e.target.result);\n      }\n      reader.readAsDataURL(input.files[0]);\n    }\n  }\n   \n  $(\"#file_url\").change(function(){\n    mostrarImagen(this);\n  });\n\n  function renombrarArchivoCargado(){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.addClass(\'display-none\');\n    dummy.removeClass(\'display-none\');\n\n    inputTag.removeClass(\'display-none\');\n    strongTag.addClass(\'display-none\');\n\n    inputTag.focus();\n  }\n\n  function blurArchivoCargado(index){\n    var strongTag = $(event.target).parent().parent().find(\"td strong\");\n    var inputTag = $(event.target).parent().parent().find(\"td input\");\n    var btnTag = $(event.target).parent().parent().find(\"button\");\n    var dummy = $(event.target).parent().parent().find(\"td span\");\n\n    btnTag.removeClass(\'display-none\');\n    dummy.addClass(\'display-none\');\n\n    inputTag.addClass(\'display-none\');\n    strongTag.removeClass(\'display-none\');\n  }\n</script>");
$templateCache.put("app/notificaciones/notificaciones.listado.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Notificaciones</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"index.main\">Notificaciones</a></li><li class=\"active\"><strong>Listado</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>id</th><th>Título</th><th>Sitio web</th><th>Fecha de creación</th><th>Fecha de envío</th><th>Tipo</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"item in notifications\"><td>{{ item.id }}</td><td>{{ item.title }}</td><td>{{ item.site }}</td><td>{{ item.created_at | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ item.startsAt | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td><span ng-if=\"item.type_notification == 1\">Notificación</span> <span ng-if=\"item.type_notification == 2\">Promoción</span></td><td><button class=\"btn btn-white\" ng-click=\"delete(item)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/operacion/reporte.operacion.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reportes de Operación Semanal</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Reporte Operación Semanal</strong></li></ol></div></div><br><div class=\"row\" ng-if=\"showAll == true\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Índices</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Recibos\" id=\"recibos\" ng-click=\"vm.Generar(1)\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-4 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(1,1)\">Pagados</span> # {{vm.resultados.count_pagado}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(1,2)\">Vencidos</span> # {{vm.resultados.count_vencido}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Número de recibo</th><th>Referencia</th><th>Prima Neta</th><th>Derecho</th><th>RPF</th><th>IVA</th><th>Prima Total</th><th>Comisión</th><th>Estatus</th><th>Vigencia</th><th>Tipo</th><th>Fecha de Modificación</th><th>Creado por</th></thead><tbody><tr ng-repeat=\"receipt in vm.resultados.results_pagados track by $index\"><td>{{receipt.poliza.natural }}{{receipt.fianza.natural}}{{receipt.poliza.juridical}} {{receipt.fianza.juridical}} {{receipt.endorsement.fianza.juridical.j_name}}{{receipt.endorsement.fianza.natural.full_name}}{{receipt.endorsement.poliza.juridical.j_name}}{{receipt.endorsement.poliza.natural.full_name}}</td><td>{{receipt.recibo_numero}}</td><td>{{receipt.poliza.poliza_number}}{{receipt.fianza.fianza_number}}{{receipt.endorsement.number_endorsement}}{{receipt.bono.factura_number}}</td><td>{{receipt.prima_neta | currency}}</td><td>{{receipt.derecho | currency}}</td><td>{{receipt.rpf | currency}}</td><td>{{receipt.iva | currency}}</td><td>{{receipt.prima_total | currency}}</td><td>{{receipt.comision | currency}}</td><td>{{status_rec(receipt.status)}}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\'}}</td><td><span ng-if=\"receipt.poliza && receipt.receipt_type ==1\">Póliza</span><span ng-if=\"receipt.endorsement && receipt.receipt_type ==1\">Endoso</span><span ng-if=\"receipt.fianza && receipt.receipt_type ==1\">Fianza</span><span ng-if=\"receipt.receipt_type == 2\">Endoso</span> <span ng-if=\"receipt.bono\">Bono</span><span ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</span></td><td>{{receipt.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{receipt.owner}}</td></tr><tr ng-repeat=\"receipt in vm.resultados.results_vencidos track by $index\"><td>{{receipt.poliza.natural }}{{receipt.fianza.natural}}{{receipt.poliza.juridical}} {{receipt.fianza.juridical}} {{receipt.endorsement.fianza.juridical.j_name}}{{receipt.endorsement.fianza.natural.full_name}}{{receipt.endorsement.poliza.juridical.j_name}}{{receipt.endorsement.poliza.natural.full_name}}</td><td>{{receipt.recibo_numero}}</td><td>{{receipt.poliza.poliza_number}}{{receipt.fianza.fianza_number}}{{receipt.endorsement.number_endorsement}}{{receipt.bono.factura_number}}</td><td>{{receipt.prima_neta | currency}}</td><td>{{receipt.derecho | currency}}</td><td>{{receipt.rpf | currency}}</td><td>{{receipt.iva | currency}}</td><td>{{receipt.prima_total | currency}}</td><td>{{receipt.comision | currency}}</td><td>{{status_rec(receipt.status)}}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\'}}</td><td><span ng-if=\"receipt.poliza && receipt.receipt_type ==1\">Póliza</span><span ng-if=\"receipt.endorsement && receipt.receipt_type ==1\">Endoso</span><span ng-if=\"receipt.fianza && receipt.receipt_type ==1\">Fianza</span><span ng-if=\"receipt.receipt_type == 2\">Endoso</span> <span ng-if=\"receipt.bono\">Bono</span><span ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</span></td><td>{{receipt.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{receipt.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab><uib-tab heading=\"Pólizas\" id=\"polizas\" ng-click=\"vm.responsiv();vm.Generar(2)\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-7 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(2,1)\">Creadas</span> # {{vm.resultados.count_creada}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(2,2)\">Canceladas</span> # {{vm.resultados.count_cancelada}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(2,3)\">Renovadas</span> # {{vm.resultados.count_renovada}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(2,4)\">No Renovadas</span> # {{vm.resultados.count_norenovada}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Número de Póliza</th><th>Ramo</th><th>Subramo</th><th>Aseguradora</th><th>Identificador</th><th>Forma de Pago</th><th>Estatus</th><th>Vigencia</th><th>Fecha de Modificación</th><th>Creado por</th></thead><tbody><tr ng-repeat=\"poliza in vm.resultados.results_creadas track by $index\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.poliza_number}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.identifier}}</td><td>{{forma_pago(poliza.forma_de_pago)}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr><tr ng-repeat=\"poliza in vm.resultados.results_canceladas track by $index\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.poliza_number}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.identifier}}</td><td>{{forma_pago(poliza.forma_de_pago)}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr><tr ng-repeat=\"poliza in vm.resultados.results_renovadas track by $index\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.poliza_number}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.identifier}}</td><td>{{forma_pago(poliza.forma_de_pago)}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr><tr ng-repeat=\"poliza in vm.resultados.results_norenovadas track by $index\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.poliza_number}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.identifier}}</td><td>{{forma_pago(poliza.forma_de_pago)}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab><uib-tab heading=\"Fianzas\" id=\"fianzas\" ng-click=\"vm.responsiv();vm.Generar(3)\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-6 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(3,1)\">Creadas</span> # {{vm.resultados.count_creada}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(3,2)\">Canceladas</span> # {{vm.resultados.count_cancelada}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(3,3)\">Anuladas</span> # {{vm.resultados.count_anulada}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Número de Fianza</th><th>Ramo</th><th>Subramo</th><th>Afianzadora</th><th>Identificador</th><th>Forma de Pago</th><th>Estatus</th><th>Vigencia</th><th>Fecha de Modificación</th><th>Creado por</th></thead><tbody><tr ng-repeat=\"fianza in vm.resultados.results_creadas track by $index\"><td>{{fianza.natural.full_name}}{{fianza.juridical.j_name}}</td><td>{{fianza.fianza_number}}</td><td>{{fianza.ramo}}</td><td>{{fianza.subramo}}</td><td>{{fianza.afianzadora}}</td><td>{{fianza.identifier}}</td><td>{{forma_pago(fianza.forma_de_pago)}}</td><td>{{status_fianza(fianza.status)}}</td><td>{{fianza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{fianza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{fianza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{fianza.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab><uib-tab heading=\"Endosos\" id=\"endosos\" ng-click=\"vm.responsiv();vm.Generar(4)\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-6 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(4,1)\">Creados</span> # {{vm.resultados.count_creado}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Póliza/Fianza</th><th>Ramo</th><th>Subramo</th><th>Número Endoso</th><th>Tipo</th><th>Estatus</th><th>Vigencia</th><th>Fecha de Modificación</th><th>Creado por</th></thead><tbody><tr ng-repeat=\"endoso in vm.resultados.results_creadas track by $index\"><td>{{endoso.policy.natural}}{{endoso.fianza.natural}}{{endoso.policy.juridical}}{{endoso.fianza.juridical}}</td><td>{{endoso.policy.poliza_number}}{{endoso.fianza.fianza_number}}</td><td>{{endoso.policy.ramo}}{{endoso.fianza.ramo}}</td><td>{{endoso.policy.subramo}}{{endoso.fianza.subramo}}</td><td>{{endoso.number_endorsement}}</td><td>{{endoso.endorsement_type}}</td><td>{{status_endoso(endoso.status)}}</td><td>{{endoso.init_date | date: \'dd/MM/yyyy\'}} - {{endoso.end_date | date: \'dd/MM/yyyy\'}}</td><td>{{endoso.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{endoso.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab><uib-tab heading=\"Siniestros\" id=\"siniestros\" ng-click=\"vm.responsiv();vm.Generar(5)\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-6 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(5,1)\">Creados</span> # {{vm.resultados.count_creado}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(5,2)\">Completados</span> # {{vm.resultados.count_completado}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Número de Póliza</th><th>Aseguradora</th><th>Ramo</th><th>Subramo</th><th>Fecha de Ingreso</th><th>Estatus</th><th>Vigencia de la Póliza</th><th>Fecha de Modificación</th><th>Creado por</th></thead><tbody><tr ng-repeat=\"siniestro in vm.resultados.results_creado track by $index\"><td>{{siniestro.poliza.natural}}{{siniestro.poliza.juridical}}</td><td>{{siniestro.poliza.poliza_number}}</td><td>{{siniestro.poliza.aseguradora}}</td><td>{{siniestro.poliza.ramo}}</td><td>{{siniestro.poliza.subramo}}</td><td>{{siniestro.fecha_ingreso | date:\'dd/MM/yyyy\'}}</td><td>{{status_sin(siniestro.status)}}</td><td>{{siniestro.poliza.start_of_validity | date:\'dd/MM/yyyy\'}} - {{siniestro.poliza.end_of_validity | date:\'dd/MM/yyyy\'}}</td><td>{{siniestro.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{siniestro.owner}}</td></tr><tr ng-repeat=\"siniestro in vm.resultados.results_completado track by $index\"><td>{{siniestro.poliza.natural}}{{siniestro.poliza.juridical}}</td><td>{{siniestro.poliza.poliza_number}}</td><td>{{siniestro.poliza.aseguradora}}</td><td>{{siniestro.poliza.ramo}}</td><td>{{siniestro.poliza.subramo}}</td><td>{{siniestro.fecha_ingreso | date:\'dd/MM/yyyy\'}}</td><td>{{status_sin(siniestro.status)}}</td><td>{{siniestro.poliza.start_of_validity | date:\'dd/MM/yyyy\'}} - {{siniestro.poliza.end_of_validity | date:\'dd/MM/yyyy\'}}</td><td>{{siniestro.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{siniestro.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab><uib-tab heading=\"Órdenes de Trabajo\" id=\"ots\" ng-click=\"vm.responsiv();vm.Generar(6)\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-6 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(6,1)\">Pendientes</span> # {{vm.resultados.count_pendiente}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(6,2)\">Canceladas</span> # {{vm.resultados.count_cancelada}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Folio Interno</th><th>Aseguradora</th><th>Ramo</th><th>Subramo</th><th>Identificador</th><th>Estatus</th><th>Vigencia</th><th>Fecha modificación</th><th>Creada por</th></thead><tbody><tr ng-repeat=\"poliza in vm.resultados.results_pendiente track by $index\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.internal_number}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.identifier}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr><tr ng-repeat=\"poliza in vm.resultados.results_cancelada track by $index\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.internal_number}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.identifier}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab></uib-tabset></div></div></div><div ng-if=\"vm.resultados\"><div ng-if=\"showButtonExcel == true\"><div class=\"col-xs-8 col-sm-6 col-md-3 form-group margin-top-24 pull-right\"><button ng-click=\"exportData(1)\" class=\"col-xs-8 btn btn-primary ladda-button\"><i class=\"fa fa-download\"></i> Exportar registros</button></div></div></div></div></div></div></div><br><div class=\"row\" ng-if=\"showAll == false\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Índices</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row animate\"><div class=\"col-xs-12\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Recibos\" id=\"recibos\" ng-click=\"vm.Generar(1);specificShow(1,1);\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-4 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(1,1);vm.Generar(1)\">Pagados</span> # {{vm.resultados.count_pagado}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(1,2);vm.Generar(1)\">Vencidos</span> # {{vm.resultados.count_vencido}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Número de recibo</th><th>Referencia</th><th>Prima Neta</th><th>Derecho</th><th>RPF</th><th>IVA</th><th>Prima Total</th><th>Comisión</th><th>Estatus</th><th>Vigencia</th><th>Tipo</th><th>Fecha de Modificación</th><th>Creado por</th></thead><tbody><tr ng-repeat=\"receipt in vm.resultados.results_pagados track by $index\" ng-if=\"showSpecific1_a\"><td>{{receipt.poliza.natural }}{{receipt.fianza.natural}}{{receipt.poliza.juridical}} {{receipt.fianza.juridical}} {{receipt.endorsement.fianza.juridical.j_name}}{{receipt.endorsement.fianza.natural.full_name}}{{receipt.endorsement.poliza.juridical.j_name}}{{receipt.endorsement.poliza.natural.full_name}}</td><td>{{receipt.recibo_numero}}</td><td>{{receipt.poliza.poliza_number}}{{receipt.fianza.fianza_number}}{{receipt.endorsement.number_endorsement}}{{receipt.bono.factura_number}}</td><td>{{receipt.prima_neta | currency}}</td><td>{{receipt.derecho | currency}}</td><td>{{receipt.rpf | currency}}</td><td>{{receipt.iva | currency}}</td><td>{{receipt.prima_total | currency}}</td><td>{{receipt.comision | currency}}</td><td>{{status_rec(receipt.status)}}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\'}}</td><td><span ng-if=\"receipt.poliza && receipt.receipt_type ==1\">Póliza</span><span ng-if=\"receipt.endorsement && receipt.receipt_type ==1\">Endoso</span><span ng-if=\"receipt.fianza && receipt.receipt_type ==1\">Fianza</span><span ng-if=\"receipt.receipt_type == 2\">Endoso</span> <span ng-if=\"receipt.bono\">Bono</span><span ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</span></td><td>{{receipt.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{receipt.owner}}</td></tr><tr ng-repeat=\"receipt in vm.resultados.results_vencidos track by $index\" ng-if=\"showSpecific1_b\"><td>{{receipt.poliza.natural }}{{receipt.fianza.natural}}{{receipt.poliza.juridical}} {{receipt.fianza.juridical}} {{receipt.endorsement.fianza.juridical.j_name}}{{receipt.endorsement.fianza.natural.full_name}}{{receipt.endorsement.poliza.juridical.j_name}}{{receipt.endorsement.poliza.natural.full_name}}</td><td>{{receipt.recibo_numero}}</td><td>{{receipt.poliza.poliza_number}}{{receipt.fianza.fianza_number}}{{receipt.endorsement.number_endorsement}}{{receipt.bono.factura_number}}</td><td>{{receipt.prima_neta | currency}}</td><td>{{receipt.derecho | currency}}</td><td>{{receipt.rpf | currency}}</td><td>{{receipt.iva | currency}}</td><td>{{receipt.prima_total | currency}}</td><td>{{receipt.comision | currency}}</td><td>{{status_rec(receipt.status)}}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\'}}</td><td><span ng-if=\"receipt.poliza && receipt.receipt_type ==1\">Póliza</span><span ng-if=\"receipt.endorsement && receipt.receipt_type ==1\">Endoso</span><span ng-if=\"receipt.fianza && receipt.receipt_type ==1\">Fianza</span><span ng-if=\"receipt.receipt_type == 2\">Endoso</span> <span ng-if=\"receipt.bono\">Bono</span><span ng-if=\"receipt.receipt_type == 3\">Nota de Crédito</span></td><td>{{receipt.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{receipt.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab><uib-tab heading=\"Pólizas\" id=\"polizas\" ng-click=\"vm.Generar(2);specificShow(2,1);\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-7 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(2,1);vm.Generar(2)\">Creadas</span> # {{vm.resultados.count_creada}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(2,2);vm.Generar(2)\">Canceladas</span> # {{vm.resultados.count_cancelada}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(2,3);vm.Generar(2)\">Renovadas</span> # {{vm.resultados.count_renovada}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(2,4); vm.Generar(2)\">No Renovadas</span> # {{vm.resultados.count_norenovada}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Número de Póliza</th><th>Ramo</th><th>Subramo</th><th>Aseguradora</th><th>Identificador</th><th>Forma de Pago</th><th>Estatus</th><th>Vigencia</th><th>Fecha de Modificación</th><th>Creado por</th></thead><tbody><tr ng-repeat=\"poliza in vm.resultados.results_creadas track by $index\" ng-if=\"showSpecific2_a\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.poliza_number}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.identifier}}</td><td>{{forma_pago(poliza.forma_de_pago)}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr><tr ng-repeat=\"poliza in vm.resultados.results_canceladas track by $index\" ng-if=\"showSpecific2_b\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.poliza_number}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.identifier}}</td><td>{{forma_pago(poliza.forma_de_pago)}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr><tr ng-repeat=\"poliza in vm.resultados.results_renovadas track by $index\" ng-if=\"showSpecific2_c\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.poliza_number}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.identifier}}</td><td>{{forma_pago(poliza.forma_de_pago)}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr><tr ng-repeat=\"poliza in vm.resultados.results_norenovadas track by $index\" ng-if=\"showSpecific2_d\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.poliza_number}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.identifier}}</td><td>{{forma_pago(poliza.forma_de_pago)}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab><uib-tab heading=\"Fianzas\" id=\"fianzas\" ng-click=\"vm.Generar(3);specificShow(3,1);\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-6 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(3,1); vm.Generar(3)\">Creadas</span> # {{vm.resultados.count_creada}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(3,2); vm.Generar(3)\">Canceladas</span> # {{vm.resultados.count_cancelada}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(3,3);vm.Generar(3)\">Anuladas</span> # {{vm.resultados.count_anulada}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Número de Fianza</th><th>Ramo</th><th>Subramo</th><th>Afianzadora</th><th>Identificador</th><th>Forma de Pago</th><th>Estatus</th><th>Vigencia</th><th>Fecha de Modificación</th><th>Creado por</th></thead><tbody><tr ng-repeat=\"fianza in vm.resultados.results_creadas track by $index\" ng-if=\"showSpecific3_a\"><td>{{fianza.natural}}{{fianza.juridical}}</td><td>{{fianza.fianza_number}}</td><td>{{fianza.ramo}}</td><td>{{fianza.subramo}}</td><td>{{fianza.afianzadora}}</td><td>{{fianza.identifier}}</td><td>{{forma_pago(fianza.forma_de_pago)}}</td><td>{{status_fianza(fianza.status)}}</td><td>{{fianza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{fianza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{fianza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{fianza.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab><uib-tab heading=\"Endosos\" id=\"endosos\" ng-click=\"vm.Generar(4);specificShow(4,1);\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-6 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(4,1);vm.Generar(4)\">Creados</span> # {{vm.resultados.count_creado}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Póliza/Fianza</th><th>Ramo</th><th>Subramo</th><th>Número Endoso</th><th>Tipo</th><th>Estatus</th><th>Vigencia</th><th>Fecha de Modificación</th><th>Creado por</th></thead><tbody><tr ng-repeat=\"endoso in vm.resultados.results_creadas track by $index\" ng-if=\"showSpecific4_a\"><td>{{endoso.policy.natural}}{{endoso.fianza.natural}}{{endoso.policy.juridical}}{{endoso.fianza.juridical}}</td><td>{{endoso.policy.poliza_number}}{{endoso.fianza.fianza_number}}</td><td>{{endoso.policy.ramo}}{{endoso.fianza.ramo}}</td><td>{{endoso.policy.subramo}}{{endoso.fianza.subramo}}</td><td>{{endoso.number_endorsement}}</td><td>{{endoso.endorsement_type}}</td><td>{{status_endoso(endoso.status)}}</td><td>{{endoso.init_date | date: \'dd/MM/yyyy\'}} - {{endoso.end_date | date: \'dd/MM/yyyy\'}}</td><td>{{endoso.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{endoso.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab><uib-tab heading=\"Siniestros\" id=\"siniestros\" ng-click=\"vm.Generar(5);specificShow(5,1);\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-6 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(5,1);vm.Generar(5)\">Creados</span> # {{vm.resultados.count_creado}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(5,2);vm.Generar(5)\">Completados</span> # {{vm.resultados.count_completado}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Número de Póliza</th><th>Aseguradora</th><th>Ramo</th><th>Subramo</th><th>Fecha de Ingreso</th><th>Estatus</th><th>Vigencia de la Póliza</th><th>Fecha de Modificación</th><th>Creado por</th></thead><tbody><tr ng-repeat=\"siniestro in vm.resultados.results_creado track by $index\" ng-if=\"showSpecific5_a\"><td>{{siniestro.poliza.natural}}{{siniestro.poliza.juridical}}</td><td>{{siniestro.poliza.poliza_number}}</td><td>{{siniestro.poliza.aseguradora}}</td><td>{{siniestro.poliza.ramo}}</td><td>{{siniestro.poliza.subramo}}</td><td>{{siniestro.fecha_ingreso | date:\'dd/MM/yyyy\'}}</td><td>{{status_sin(siniestro.status)}}</td><td>{{siniestro.poliza.start_of_validity | date:\'dd/MM/yyyy\'}} - {{siniestro.poliza.end_of_validity | date:\'dd/MM/yyyy\'}}</td><td>{{siniestro.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{siniestro.owner}}</td></tr><tr ng-repeat=\"siniestro in vm.resultados.results_completado track by $index\" ng-if=\"showSpecific5_b\"><td>{{siniestro.poliza.natural}}{{siniestro.poliza.juridical}}</td><td>{{siniestro.poliza.poliza_number}}</td><td>{{siniestro.poliza.aseguradora}}</td><td>{{siniestro.poliza.ramo}}</td><td>{{siniestro.poliza.subramo}}</td><td>{{siniestro.fecha_ingreso | date:\'dd/MM/yyyy\'}}</td><td>{{status_sin(siniestro.status)}}</td><td>{{siniestro.poliza.start_of_validity | date:\'dd/MM/yyyy\'}} - {{siniestro.poliza.end_of_validity | date:\'dd/MM/yyyy\'}}</td><td>{{siniestro.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{siniestro.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab><uib-tab heading=\"Órdenes de Trabajo\" id=\"ots\" ng-click=\"vm.Generar(6);specificShow(6,1);\"><div class=\"panel-body\"><div class=\"project-list\"><div class=\"col-xs-6 form-group pull-right\"><span class=\"col-xs-6\">Total de Registros</span><div class=\"col-xs-6\" align=\"center\"><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(6,1);vm.Generar(6)\">Pendientes</span> # {{vm.resultados.count_pendiente}}</div><div><span class=\"blue-color col-xs-6\" ng-click=\"specificShow(6,2);vm.Generar(6)\">Canceladas</span> # {{vm.resultados.count_cancelada}}</div></div></div><table class=\"table table-bordered table-hover\"><thead><th>Contratante</th><th>Folio Interno</th><th>Aseguradora</th><th>Ramo</th><th>Subramo</th><th>Identificador</th><th>Estatus</th><th>Vigencia</th><th>Fecha modificación</th><th>Creada por</th></thead><tbody><tr ng-repeat=\"poliza in vm.resultados.results_pendiente track by $index\" ng-if=\"showSpecific6_a\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.internal_number}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.identifier}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr><tr ng-repeat=\"poliza in vm.resultados.results_cancelada track by $index\" ng-if=\"showSpecific6_b\"><td>{{poliza.natural}}{{poliza.juridical}}</td><td>{{poliza.internal_number}}</td><td>{{poliza.aseguradora}}</td><td>{{poliza.ramo}}</td><td>{{poliza.subramo}}</td><td>{{poliza.identifier}}</td><td>{{status(poliza.status)}}</td><td>{{poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.updated_at | date: \'dd/MM/yyyy\'}}</td><td>{{poliza.owner}}</td></tr></tbody></table><br><br></div></div></uib-tab></uib-tabset></div></div></div><div ng-if=\"vm.resultados\"><div ng-if=\"showButtonExcel == true\"><div class=\"col-xs-8 col-sm-6 col-md-3 form-group margin-top-24 pull-right\"><button ng-click=\"exportData(1)\" class=\"col-xs-8 btn btn-primary ladda-button\"><i class=\"fa fa-download\"></i> Exportar registros</button></div></div></div></div></div></div></div>");
$templateCache.put("app/ordenes/calculateComision.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Calcular comisión por Referenciador</h4></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard col-xs-12\"><div class=\"row\"><div class=\"form-group col-xs-12\" align=\"center\"><label for=\"motivo\" align=\"center\">Referenciador</label> <input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"name\" disabled=\"\" align=\"center\"></div><div class=\"form-group col-xs-12 col-sm-3\"><label for=\"go\" align=\"center\">Gastos de Operación %</label> <input class=\"form-control\" type=\"text\" name=\"valueGo\" ng-model=\"valueGo\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-3\"><label for=\"selectType\">Prima Total</label> <input class=\"form-control\" type=\"text\" name=\"valueMonto\" ng-model=\"valueMonto\" ng-change=\"changeMonto(valueGo ,valueMonto, valueComision, valueComInicial)\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-3\"><label for=\"motivo\">Comisión <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"valueComInicial\" ng-model=\"valueComInicial\" ng-change=\"changeCom(valueGo ,valueMonto, valueComision,valueComInicial)\" ng-disabled=\"!valueMonto\"></div><div class=\"form-group col-xs-12 col-sm-3\"><label for=\"motivo\">Comisión al referenciador</label> <input class=\"form-control\" type=\"text\" name=\"valueComision\" ng-model=\"valueComision\" ng-change=\"numberFormatDolar(valueComision)\" disabled=\"\"></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancelCalculate()\" type=\"button\">Cerrar</button> <button class=\"btn btn-secondary ladda-button\" ng-disabled=\"!valueMonto || !valueComInicial\" ng-click=\"comCalculatePeso(valueMonto,valueComInicial)\" type=\"button\">Calcular comisión</button> <button class=\"btn btn-success ladda-button\" ng-disabled=\"!valueComision\" ng-click=\"cTotal(valueMonto,valueComInicial,valueComision)\" type=\"button\">Asignar</button></div>");
$templateCache.put("app/ordenes/ordenes.generic.html","<div ng-show=\"order.show.firstTab == true\"><div class=\"col-xs-12 form-group\"><fieldset><legend ng-if=\"order.show.ot\" class=\"legend-title\" align=\"center\">Información General de la OT</legend><legend ng-if=\"!order.show.ot\" class=\"legend-title\" align=\"center\">Información General de la Póliza</legend><form name=\"form\" novalidate=\"\" onkeypress=\"return event.keyCode != 13;\"><div><div class=\"row\" ng-hide=\"order.show.ot\"><div class=\"col-xs-12 form-group\" ng-if=\"!loaderPdf\"><label class=\"form-label\">Selecciona un archivo PDF:</label><div class=\"alert alert-info\" role=\"alert\"><strong>Autos:</strong> Chubb, Quálitas, GNP, AXA, HDI, Primero Seguros, ANA, Momento, Afirme, Zurich.<br><strong>Gastos Médicos (Beta):</strong> GNP, Mapfre, Plan Seguro, BX+, MetLife, Axa.<br><strong>Vida (Beta):</strong> Atlas, Mapfre, Seguros Monterrey, GNP.<br></div><input accept=\"application/pdf\" class=\"form-control\" type=\"file\" id=\"file-selector\" name=\"file\" onchange=\"angular.element(this).scope().fileNameChanged(this); angular.element(this).scope().showFile(this)\"></div></div><div class=\"row\" ng-hide=\"order.show.ot\"></div><div class=\"row pull-right\" ng-hide=\"order.show.ot\"><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"!loaderPdf\"><button class=\"btn btn-success\" ng-click=\"capturarPoliza(1)\">Leer Datos para la Póliza</button></div></div><div class=\"row\"><div class=\"col-xs-12 form-group container-loader\" ng-if=\"loaderPdf\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"folio-intenero\">Folio Interno</label> <input class=\"form-control\" name=\"folio-intenero\" ng-model=\"order.form.internal_number\" disabled=\"\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador</label> <input class=\"form-control\" type=\"text\" ng-model=\"order.form.identifier\" ng-change=\"changeIdentifier(order.form.identifier)\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-hide=\"order.show.ot\"><label>Folio</label> <input class=\"form-control\" name=\"folio\" ng-model=\"order.form.folio\" type=\"text\" ng-change=\"changeFolio()\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-hide=\"order.show.ot\"><label>Número de Póliza <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.poliza.$invalid && !form.poliza.$pristine }\"><input class=\"form-control\" ng-blur=\"checkNumPolicy()\" name=\"poliza\" ng-model=\"order.form.poliza\" type=\"text\" ng-trim=\"false\" ng-change=\"changeNoPoliza()\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante {{contrac.selected}} <span class=\"color-red\">*</span></label><div class=\"form-group\" ng-if=\"!order.acceso_adm_cont\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.form.contratante\" change=\"matchesContractors(order.form.contratante.val)\"></autocomplete><span class=\"input-group-btn\" ng-if=\"order.acceso_adm_cont\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"order.contratanteCreatorModalEvent(); show_contractor = true\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div><div class=\"input-group\" ng-if=\"order.acceso_adm_cont\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.form.contratante\" change=\"matchesContractors(order.form.contratante.val)\"></autocomplete><span class=\"input-group-btn\" ng-if=\"order.acceso_adm_cont\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"order.contratanteCreatorModalEvent(); show_contractor = true\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.address.$invalid && !form.address.$pristine }\"><select class=\"form-control\" data-ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in order.defaults.address track by address.url\" ng-change=\"order.options.changeAddress(order.form.address)\" name=\"address\" ng-model=\"order.form.address\" ng-disabled=\"!order.form.contratante\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo electrónico <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"correo\" ng-blur=\"validarEmail(order.form.contratante.email)\" ng-model=\"order.form.contratante.email\" type=\"email\" ng-disabled=\"!order.form.contratante || emailStatus\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono <span class=\"color-red\">*</span></label><phonenumber-directive model=\"order.form.contratante.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"inputValue\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Vigencia <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"order.form.startDate\" ng-disabled=\"!order.form.contratante\" ng-change=\"order.options.checkDate()\" ng-paste=\"order.options.checkDate(\'\',$event)\" data-date-format=\"mm/dd/yyyy\" ng-init=\"order.options.checkDate(\'initial\')\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>al <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"order.form.endingDate\" ng-disabled=\"!order.form.contratante\" data-date-format=\"mm/dd/yyyy\" ng-change=\"checkEndDate();checkDateValues(order.form.endingDate)\" ng-paste=\"checkEndDate($event);checkDateValues(order.form.endingDate,$event)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 form-group\"><label>Renovable <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.renewal.$invalid && !form.renewal.$pristine }\"><select class=\"form-control\" ng-options=\"renewal.value as renewal.label for renewal in order.renewal.options\" ng-change=\"renewalSelection()\" name=\"renewal\" ng-model=\"order.renewal.selected\" ng-disabled=\"!order.form.contratante\" required=\"\"></select></div></div><div class=\"col-sm-4 form-group\" ng-class=\"{ \'has-error\': form.aseguradora.$invalid && !form.aseguradora.$pristine }\"><label>Aseguradora <span class=\"color-red\">*</span></label><div class=\"input-group\"><select class=\"form-control\" ng-options=\"aseguradora.alias for aseguradora in order.defaults.providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"aseguradoraSelection()\" name=\"aseguradora\" ng-model=\"order.form.aseguradora\" ng-disabled=\"!order.form.contratante\" required=\"\"><option value=\"\">Selecciona un proveedor</option></select><span class=\"input-group-btn\" ng-disabled=\"!order.form.subramo\"><button class=\"btn btn-success\" ng-click=\"order.refreshProvider()\"><i class=\"glyphicon glyphicon-refresh\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Clave de agente <span class=\"color-red\">*</span></label><div ng-if=\"!order.defaults.claves.length\"><input type=\"text\" placeholder=\"No hay ninguna clave para esta aseguradora\" class=\"form-control\" disabled=\"\"></div><div ng-if=\"order.defaults.claves.length == 1\" ng-init=\"order.form.clave = order.defaults.claves[0]\"><input type=\"text\" name=\"clave_agente\" placeholder=\"Elige una aseguradora aseguradora\" class=\"form-control\" value=\"{{order.defaults.claves[0].clave +\' - \'+ order.defaults.claves[0].name}}\" disabled=\"\"></div><div ng-class=\"{ \'has-error\': form.clave.$invalid && !form.clave.$pristine }\"><select ng-if=\"order.defaults.claves.length > 1\" class=\"form-control\" data-ng-options=\"clave as clave.clave +\' - \'+ clave.name for clave in order.defaults.claves | orderBy: \'clave\' track by clave.url\" ng-change=\"order.options.changeClave(order.form.clave);changeClave()\" name=\"clave\" ng-model=\"order.form.clave\" ng-disabled=\"!order.form.aseguradora\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.ramo.$invalid && !form.ramo.$pristine }\"><select class=\"form-control\" ng-options=\"ramo.ramo_name for ramo in order.defaults.ramos | orderBy:\'ramo_name\' track by ramo.url\" ng-change=\"changeRamo();identifier(\'ramo\')\" name=\"ramo\" ng-model=\"order.form.ramo\" ng-disabled=\"!order.form.aseguradora && !order.form.clave\" required=\"\"><option value=\"\">Selecciona un ramo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramos <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"subramo.subramo_name for subramo in order.defaults.subramos | orderBy:\'subramo_name\' track by subramo.url\" ng-change=\"changeSubramo();identifier(\'paquete\')\" name=\"subramo\" ng-model=\"order.form.subramo\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\">Selecciona un subramo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 9\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.auto.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 3\"><label>Nivel Hospitalario:</label> <input type=\"text\" class=\"form-control\" ng-model=\"order.form.hospital_level\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 3\"><label>Tabulador:</label> <input type=\"text\" class=\"form-control\" ng-model=\"order.form.tabulator\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 1\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_life | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.life.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 2\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_ap | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.disease.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 3 || order.defaults.formInfo.code == 4\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_gm | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.disease.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 9\"><label>Procedencia</label><select class=\"form-control\" ng-options=\"proc.name for proc in order.procedimiento | orderBy:\'name\' track by proc.id\" ng-change=\"changeProc()\" ng-model=\"order.subforms.auto.procedencia\" ng-disabled=\"!order.form.ramo\"><option value=\"\" disabled=\"\">Selecciona una procedencia</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 7\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_incendio | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.damage.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 6\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_myt | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.damage.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 8\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_ayc | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.damage.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 10\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_credito | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.damage.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 11\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_vivienda | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.damage.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 13\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_diversos | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.damage.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 12\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_garantia | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.damage.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 5\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_rc | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.damage.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 14\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_tyorc | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.damage.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 31\"><label>Tipo <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control\" ng-options=\"type.name for type in order.types_lf | orderBy:\'type_name\' track by type.id\" name=\"type\" ng-model=\"order.subforms.damage.policy_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectCurrency\">Moneda <span class=\"color-red\">*</span></label><select id=\"SelectCurrency\" class=\"form-control\" ng-options=\"f_currency.value as f_currency.label for f_currency in order.f_currency.options\" ng-model=\"order.f_currency.f_currency_selected\" ng-change=\"changeCurrency()\"></select></div><div ng-if=\"users\" class=\"col-sm-4 form-group\" ng-class=\"{ \'has-error\': form.responsable.$invalid && !form.responsable.$pristine }\"><label for=\"responsable\">Responsable</label><div><select class=\"form-control\" name=\"responsable\" ng-model=\"order.form.responsable\" ng-change=\"changeResponsable(order.form.vendor)\" ng-options=\"responsable.id as responsable.first_name + \' \' + responsable.last_name for responsable in users\"><option value=\"\">Seleccione un responsable</option></select></div></div><div ng-if=\"ejecutivo_cobranza\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-class=\"{ \'has-error\': form.ejecutivo_cobranza.$invalid && !form.ejecutivo_cobranza.$pristine }\"><label for=\"ejecutivo_cobranza\">Ejecutivo de cobranza</label><div><select class=\"form-control\" name=\"ejecutivo_cobranza\" ng-model=\"order.form.ejecutivo_cobranza\" ng-options=\"ejecutivo_cobranza.id as ejecutivo_cobranza.first_name + \' \' + ejecutivo_cobranza.last_name for ejecutivo_cobranza in users\"><option value=\"\">Seleccione un Ejecutivo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Paquetes <span class=\"color-red\">*</span></label><div class=\"input-group\" ng-class=\"{ \'has-error\': form.paquete.$invalid && !form.paquete.$pristine }\" style=\"position: relative;\"><select class=\"form-control\" data-ng-options=\"package.package_name for package in order.defaults.packages | orderBy:\'package_name\' track by package.url\" ng-change=\"changePackage(order.form.paquete);identifier(\'paquete\')\" name=\"paquete\" ng-model=\"order.form.paquete\" ng-disabled=\"!order.form.subramo\" required=\"\"><option value=\"\">Selecciona un paquete</option></select><span class=\"input-group-addon\" ng-if=\"cargandoPaquetes\" style=\"background: transparent; border: none; cursor: default;\"><i class=\"fa fa-spinner fa-spin fa-lg\"></i></span> <span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"addNewPackage()\" ng-disabled=\"!order.form.subramo\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div><span ng-if=\"!order.defaults.packages.length && order.form.subramo\">No hay paquetes en este subramo</span></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-options=\"businessline.name for businessline in order.businessline | orderBy:\'id\' track by businessline.id\" name=\"business\" ng-model=\"order.form.business_line\"><option value=\"\" disabled=\"\">Seleccione una línea</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-options=\"celula.celula_name for celula in celulas | orderBy:\'id\' track by celula.id\" ng-model=\"order.form.celula\"><option value=\"\" disabled=\"\">Seleccione {{moduleName}}</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Agrupación</label><select class=\"form-control\" ng-options=\"item.description for item in agrupaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeAgrupacion(order.form.grouping_level)\" ng-model=\"order.form.grouping_level\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Subagrupación</label><select class=\"form-control\" ng-options=\"item.description for item in sub_asignaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeSubagrupacion(order.form.subgrouping)\" ng-model=\"order.form.subgrouping\" ng-disabled=\"!order.form.grouping_level\"><option value=\"\" disabled=\"\">Seleccione una subagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Subsubagrupación</label><select class=\"form-control\" ng-options=\"item.description for item in sub_subasignaciones | orderBy:\'id\' track by item.id\" ng-model=\"order.form.subsubgrouping\" ng-disabled=\"!order.form.subgrouping\"><option value=\"\" disabled=\"\">Seleccione una subsubagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectConducto\">Conducto de pago <span class=\"color-red\">*</span></label><select id=\"SelectConducto\" class=\"form-control\" ng-options=\"conducto_de_pago.value as conducto_de_pago.label for conducto_de_pago in order.conducto_de_pago.options\" ng-model=\"order.conducto_de_pago.conducto_de_pago_selected\" ng-change=\"changeConducto()\"></select></div><div class=\"col-xs-12 form-group legend-gray\" ng-if=\"show_new_sub\" style=\"padding: 20px;\"><legend class=\"legend-title\" align=\"center\">Referenciadores</legend><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in referenciador track by $index\" ng-init=\"isSeller[$index] = false; main_index = $index\" style=\"padding: 20px;\"><legend class=\"legend-title hidden-xs hidden-sm\" ng-if=\"item.user_info.is_vendedor\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], referenciador[$index])\">{{ item.first_name}} {{ item.last_name }} <span class=\"color-blue pull-right\">Vendedor</span></legend><legend class=\"legend-title hidden-xs hidden-sm\" ng-if=\"!item.user_info.is_vendedor\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], referenciador[$index])\">{{ item.first_name}} {{ item.last_name }} <span class=\"color-blue pull-right\">Usuario</span></legend><h2 class=\"legend-title visible-xs-block visible-sm-block\" ng-if=\"item.user_info.is_vendedor\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], referenciador[$index])\">{{ item.first_name}} {{ item.last_name }}<div><h4 class=\"color-blue\">Vendedor</h4></div></h2><h2 class=\"legend-title visible-xs-block visible-sm-block\" ng-if=\"!item.user_info.is_vendedor\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], referenciador[$index])\">{{ item.first_name}} {{ item.last_name }}<div><h4 class=\"color-blue\">Usuario</h4></div></h2><div class=\"row\" ng-if=\"isSeller[$index]\"><form name=\"form\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de Ingreso:<span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"referenciador[$index].hired_date\" data-date-format=\"mm/dd/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Banco:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"referenciador[$index].bank\" ng-options=\"bank.alias for bank in banks | orderBy: \'alias\' track by bank.url\" required=\"\"><option value=\"\" disabled=\"\">Seleccione un banco</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número de Referencia:<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"referenciador[$index].reference_number\" ng-disabled=\"referenciador[$index].pay_way.key == 4\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Forma de Pago:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"referenciador[$index].pay_way\" ng-options=\"pay_way.val for pay_way in pay_ways | orderBy: \'id\' track by pay_way.key\" required=\"\"><option value=\"\" disabled=\"\">Seleccione una forma de pago</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Gastos de Operación:<span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\"></i></span> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"referenciador[$index].gastos_operacion\" required=\"\"></div></div><div class=\"col-xs-12 col-md-8 col-lg-6 form-group\"><label>Dirección:<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"referenciador[$index].address\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Correo electrónico:<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" name=\"\" ng-model=\"referenciador[$index].email\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Teléfono:<span class=\"color-red\">*</span></label><div class=\"input-group form-group\"><phonenumber-directive placeholder=\"myPrompt\" model=\"referenciador[$index].phone\"></phonenumber-directive><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"addPhone($index)\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span></div><div class=\"input-group form-group\" ng-repeat=\"item in referenciador[main_index].phones track by $index\" ng-init=\"child_index = $index\"><phonenumber-directive placeholder=\"myPrompt\" model=\"referenciador[main_index].phones[child_index]\"></phonenumber-directive><span class=\"input-group-btn\"><button class=\"btn btn-danger btn-add-contractor\" ng-click=\"deletePhone(main_index, child_index, referenciador[main_index].phones[child_index])\"><i class=\"fa fa-minus\" aria-hidden=\"true\"></i></button></span></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 legend-gray\" ng-if=\"item.subramos.length == 0\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"item.subramos.length == 0\">Quitar Subramo</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"item.subramos.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Subramos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addSubramo(main_index)\" type=\"button\">Agregar Subramo</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addSubramo(main_index)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"col-xs-12 address-container\" ng-repeat=\"sub_ramo in item.subramos track by $index\" ng-init=\"main_subramos_index = $index; assignAgain()\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteSubramo(main_index, main_subramos_index, item)\">Quitar Subramo</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts($index, 1)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Subramo #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addSubramo(main_index)\" type=\"button\">Agregar Subramo</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addSubramo(main_index)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora</label><select class=\"form-control\" ng-model=\"sub_ramo.provider\" ng-options=\"provider.compania for provider in aseguradoras | orderBy: \'compania\' track by provider.url\" ng-change=\"changeProvider(sub_ramo, sub_ramo.provider)\"><option value=\"\">Todas</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo</label><select class=\"form-control\" ng-model=\"sub_ramo.ramo\" ng-options=\"ramo.ramo_name for ramo in sub_ramo.ramos | orderBy: \'ramo_name\' track by ramo.id\" ng-change=\"changeRamoVendedor(sub_ramo)\"><option value=\"\">Todos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo</label><select class=\"form-control\" ng-model=\"sub_ramo.subramo\" ng-options=\"subramo.subramo_name for subramo in sub_ramo.sub_ramos | orderBy: \'subramo_name\' track by subramo.id\"><option value=\"\">Todos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Porcentaje de Comisión %</label> <input class=\"form-control\" type=\"text\" name=\"\" minlength=\"1\" maxlength=\"10\" ng-model=\"sub_ramo.comision_percentage\"></div></div></div><div class=\"col-xs-12 form-group\"><button class=\"btn btn-success btn-mt pull-right\" ng-if=\"item.user_info.info_vendedor.length == 0\" ng-disabled=\"\" ng-click=\"saveSeller(main_index)\">Guardar como Vendedor</button> <button class=\"btn btn-success btn-mt pull-right\" ng-if=\"item.user_info.info_vendedor.length > 0\" ng-disabled=\"\" ng-click=\"isSeller[$index] = false; saveSeller(main_index)\">Guardar Cambios</button></div></form></div></li></ul><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group btn-mt pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"cancelNewSubramo()\">Cancelar</button></div></div><div ng-if=\"show_new_pack\"><form name=\"packForm\" novalidate=\"\"><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{\'has-error\': packForm.package_name.$touched && packForm.package_name.$invalid}\"><label>Nombre del Paquete: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"package_name\" ng-model=\"newPackageCoverage.package_name\" required=\"\" ng-trim=\"true\"> <small class=\"help-block\" ng-show=\"packForm.package_name.$touched && packForm.package_name.$error.required\">El nombre del paquete es obligatorio.</small></div><div class=\"col-xs-12 form-group\"><label>Observaciones:</label> <textarea type=\"text\" class=\"form-control\" ng-model=\"newPackageCoverage.description\"></textarea></div><div class=\"address-container\" ng-repeat=\"item in newPackageCoverage.coverage_package track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" ng-click=\"deleteNewPackageCoverage($index)\" ng-disabled=\"newPackageCoverage.coverage_package.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Cobertura</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" ng-click=\"deleteNewPackageCoverage($index)\" ng-disabled=\"newPackageCoverage.coverage_package.length <= 1\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Cobertura #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addNewPackageCoverage()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Cobertura</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addNewPackageCoverage()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{\'has-error\': packForm[\'coverage_name_\' + $index].$touched && packForm[\'coverage_name_\' + $index].$invalid}\"><label>Nombre de la Cobertura: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.coverage_name\" ng-attr-name=\"coverage_name_{{$index}}\" required=\"\" ng-trim=\"true\"> <small class=\"help-block\" ng-show=\"packForm[\'coverage_name_\' + $index].$touched && packForm[\'coverage_name_\' + $index].$error.required\">El nombre de la cobertura es obligatorio.</small></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Suma Asegurada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.sums_coverage\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Deducible:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.deductible\"></div></div></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\"><button class=\"btn btn-secondary\" type=\"button\" ng-click=\"cancelNewPackage()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Cancelar</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right m-t\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"saveNewPackage()\" ng-disabled=\"paqueteGuardado || packForm.$invalid || !newPackageCoverage.package_name || !newPackageCoverage.coverage_package.length\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Paquete</button></div></form></div><div ng-if=\"sucursalList\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"sucursal\">Sucursal</label><select class=\"form-control\" name=\"sucursal\" ng-model=\"order.form.sucursal\" ng-options=\"sucursal.id as sucursal.sucursal_name for sucursal in sucursalList\"><option value=\"\">Seleccione una sucursal</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-6 nopadding form-group\"><label>Referenciadores <span ng-if=\"!order.acc_referenciador_obligatorio\" class=\"color-red\">*</span></label><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in referenciadores\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteReferenciador($index, 1)\" ng-disabled=\"referenciadores.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b col-xs-12\" name=\"referenciador_policy\" ng-model=\"item.referenciador\" ng-change=\"changeReferenciador(item)\" ng-options=\"referenciador_policy.url as referenciador_policy.first_name + \' \' + referenciador_policy.last_name for referenciador_policy in referenciador\" ng-disabled=\"!order.acceso_chng_ref\"><option value=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\" ng-init=\"referenciadores[$index].resp_type = 0\"><input class=\"form-control m-b col-xs-12 wb102\" type=\"text\" name=\"\" placeholder=\"% Comisión\" ng-model=\"item.comision_vendedor\" ng-disabled=\"referenciadores.length <= 1\" ng-change=\"changeComRef(item)\" required=\"\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador(1)\" type=\"button\" ng-disabled=\"!order.acceso_chng_ref\"><i class=\"glyphicon glyphicon-plus\"></i></button> <a ng-disabled=\"!item.referenciador\" ng-show=\"item.selectedRef && referenciadores.length > 1 && order.poliza.primaTotal\" class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); calculateComision(item, $index)\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i></a></div></div></div><div class=\"alert alert-danger\" ng-show=\"comisionError\">{{ comisionError }}</div></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Frecuencia de Pago <span class=\"color-red\">*</span></legend><div class=\"row form-group\"><div class=\"col-xs-12 col-sm-4 col-md-2\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.form.payment\" type=\"radio\" value=\"1\"> MENSUAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment\" value=\"2\"> BIMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment\" value=\"3\"> TRIMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.form.payment\" type=\"radio\" value=\"4\"> CUATRIMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment\" value=\"6\"> SEMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment\" value=\"12\"> ANUAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.form.payment\" type=\"radio\" value=\"5\"> CONTADO</label></div></div></div></div></div></form></fieldset></div><div class=\"col-md-12 col-sm-12 form-group\"><div ng-if=\"order.show.showForms\" ng-include=\"\'templates/forms.html\'\"></div></div><div class=\"col-xs-12 form-group\" ng-if=\"order.form.paquete\"><div ng-include=\"\'app/coberturas/coberturas.table.html\'\"></div><div ng-if=\"addNewCoverages\"><div class=\"col-xs-12 col-sm-3 form-group\"><label>Nombre de Cobertura<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"coverageName\"></div><br><div class=\"col-xs-12 col-sm-3\"><button class=\"col-xs-12 btn btn-white pull-right margin-top-5\" ng-click=\"finishNewCoverages()\">Cancelar</button></div><div class=\"col-xs-12 col-sm-3\"><button class=\"col-xs-12 btn btn-info pull-right margin-top-5\" ng-click=\"finishNewCoverages()\" ng-disabled=\"!coverages.length\">Finalizar</button></div><div class=\"col-xs-12 col-sm-3\"><button class=\"col-xs-12 btn btn-success pull-right margin-top-5\" ng-click=\"saveNewCoverage(coverageName,priority,order.form.paquete)\">Agregar</button></div></div></div><div class=\"col-xs-12 form-group\"><fieldset><legend class=\"legend-title\" align=\"center\">Observaciones</legend><form name=\"form1\"><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-class=\"{ \'has-error\': form1.observations.$invalid && !form1.observations.$pristine }\"><textarea type=\"text\" class=\"form-control\" name=\"observations\" ng-model=\"dataToSave.observations\"></textarea></div></div></form></fieldset></div><div class=\"col-xs-12 form-group\" ng-if=\"order.permiso_administrar_adjuntos\"><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"row\"><div ng-include=\"\'templates/show-files.html\'\"></div></div></div><button id=\"createCont\" ng-click=\"order.contratanteCreatorModalEvent()\" class=\"display-none\"></button><div class=\"col-xs-12 form-group\" ng-hide=\"order.show.ot\"><div class=\"alert alert-warning\" ng-if=\"imgPrimasSrc\" style=\"margin-top: 15px;\"><h4 style=\"margin-top:0;\"><i class=\"fa fa-exclamation-triangle\"></i> Verificación obligatoria de primas</h4><p style=\"margin-bottom:0;\">A continuación se muestra la captura de las primas obtenidas del PDF de la aseguradora y las primas leídas automáticamente por SAAM.<br><strong>Revise cuidadosamente que los montos coincidan exactamente.</strong><br><strong>Se recomienda ampliar la imagen (zoom) para asegurar la correcta validación de los montos.</strong></p><button type=\"button\" class=\"btn btn-danger pull-right\" ng-if=\"imgPrimasSrc\" ng-click=\"order.ui = order.ui || {}; order.ui.showImgPrimas = !order.ui.showImgPrimas\"><i class=\"fa\" ng-class=\"{ \'fa-chevron-down\': !(order.ui && order.ui.showImgPrimas), \'fa-chevron-up\': (order.ui && order.ui.showImgPrimas) }\"></i> {{ (order.ui && order.ui.showImgPrimas) ? \'Ocultar captura de primas\' : \'Ver captura de primas\' }} <i class=\"fa fa-search-plus\" ng-class=\"{\'fa-search-plus\': (order.ui && order.ui.showImgPrimas),\'fa-search\': !(order.ui && order.ui.showImgPrimas)}\" aria-hidden=\"true\" style=\"margin-right:6px;\"></i></button></div><style>\n			.img-wrap {\n				overflow: auto;\n				max-height: 70vh;      /* para que no se salga de la pantalla */\n				border-radius: 4px;\n			}\n\n			.img-zoom {\n				display: block;\n				width: 100%;\n				height: auto;\n				max-width: none;       /* clave: permitir crecer */\n				transition: transform .2s ease;\n				transform-origin: top left;   /* clave: no se “pierde” al centro */\n				cursor: zoom-in;\n			}\n\n			.img-zoom.is-zoomed {\n				transform: scale(2.8);\n				cursor: zoom-out;\n			}\n		</style><div class=\"collapse\" ng-class=\"{ in: (order.ui && order.ui.showImgPrimas) }\" ng-if=\"imgPrimasSrc\" style=\"margin-top: 10px;\"><div class=\"well well-sm\" style=\"margin-bottom:0; overflow:auto;\"><img ng-src=\"{{imgPrimasSrc}}\" class=\"img-responsive img-thumbnail img-zoom\" ng-class=\"{\'is-zoomed\': order.ui.zoomPrimas}\" ng-click=\"order.ui.zoomPrimas = !order.ui.zoomPrimas\" style=\"width:50%; max-width:50%; height:260px; object-fit:contain; object-position:center; margin:0 auto; display:block;\"></div></div><receipts-individual form=\"order.form\" tosave=\"dataToSave\" type=\"1\"></receipts-individual></div></div><script type=\"text/javascript\">\n	$(\'#select_srefer\').select2({\n        dropdownParent: $(\'#select_refer\')\n    });\n	const fileSelector = document.getElementById(\'file-selector\');\n	fileSelector.addEventListener(\'change\', (event) => {\n	const fileList = event.target.files;\n	console.log(\'file-----***\',fileList);\n	});\n</script><script src=\"https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js\"></script>");
$templateCache.put("app/ordenes/ordenes.generic.old.html","<div ng-show=\"order.show.firstTab == true\"><div class=\"col-xs-12 form-group\"><fieldset><legend class=\"legend-title\" align=\"center\">Información general</legend><div class=\"row\"><div class=\"col-xs-12 text-right\" ng-if=\"!esEdicion\"><button type=\"button\" ng-click=\"lecturaPDF()\" class=\"btn btn-link btn-sm\" style=\"font-style: italic;\">Extraer y actualizar con PDF <small>(opcional)</small></button></div><div ng-if=\"es_renovacion\" class=\"panel panel-default\"><div class=\"panel-body\"><p class=\"small text-align-center\">Formatos aceptados: PDF</p><div class=\"well well-sm\" style=\"font-size: 12px; background-color: #f9f9f9;\"><strong>Autos:</strong> Chubb, Quálitas, GNP, AXA, HDI, Primero Seguros, ANA, Momento, Afirme, Zurich.<br><strong>Gastos Médicos (Beta):</strong> GNP y Mapfre.</div><div class=\"form-horizontal\" ng-if=\"!loaderPdf\"><div class=\"form-group\"><div class=\"col-xs-8\"><input type=\"file\" accept=\"application/pdf\" class=\"form-control input-sm\" id=\"file-selector\" name=\"file\" ng-model=\"fileselected\" onchange=\"angular.element(this).scope().fileNameChanged(this); angular.element(this).scope().showFile(this);\"></div><div class=\"col-xs-2 text-right\" ng-click=\"capturarPoliza(1)\"><button class=\"btn btn-info btn-sm\" ng-click=\"capturarPoliza(1)\"><i class=\"glyphicon glyphicon-search\"></i> Capturar datos</button></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group container-loader\" ng-if=\"loaderPdf\"><img src=\"../../assets/images/loader/black_loader.gif\"></div></div></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-hide=\"order.show.ot\"><label for=\"folio-intenero\">Folio Interno</label> <input class=\"form-control\" name=\"folio-intenero\" disabled=\"\" type=\"text\" value=\"{{order.form.internal_number}}\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Identificador</label> <input class=\"form-control\" type=\"text\" ng-model=\"order.form.identifier\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-hide=\"order.show.ot\"><label>Folio</label> <input class=\"form-control\" name=\"folio\" ng-model=\"order.form.folio\" type=\"text\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-hide=\"order.show.ot\"><label>Número de Póliza <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"poliza\" ng-model=\"order.form.poliza\" type=\"text\" ng-trim=\"false\" required=\"\" ng-blur=\"changeNoPoliza(order.form.poliza)\" ng-change=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante {{contrac.selected}} <span class=\"color-red\">*</span></label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.form.contratante\" change=\"matchesContractors(order.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección <span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \'+ address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in order.defaults.address track by address.url\" ng-change=\"order.options.changeAddress(order.form.address)\" ng-model=\"order.form.address\" ng-disabled=\"!order.form.contratante\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo electrónico <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"correo\" ng-model=\"order.form.contratante.email\" type=\"email\" ng-disabled=\"!order.form.contratante || emailStatus\" ng-blur=\"checkEmail(order.form.contratante.email)\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono <span class=\"color-red\">*</span></label><phonenumber-directive model=\"order.form.contratante.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"inputValue\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Vigencia <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"order.form.startDate\" value=\"{{order.form.startDate}}\" ng-disabled=\"!order.form.contratante\" ng-change=\"order.options.checkDate()\" ng-init=\"order.options.checkDate(\'initial\')\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>al <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"order.form.endingDate\" value=\"{{order.form.endingDate}}\" ng-change=\"checkEndDate();checkDateValues(order.form.endingDate)\" ng-disabled=\"!order.form.contratante\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Renovable <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.renewal.$invalid && !form.renewal.$pristine }\"><select class=\"form-control\" ng-options=\"renewal.value as renewal.label for renewal in order.renewal.options\" ng-change=\"save_info_tab()\" name=\"renewal\" ng-model=\"order.renewal.is_renewable\" ng-disabled=\"!order.form.contratante\" required=\"\"></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Aseguradora <span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"aseguradora.alias for aseguradora in order.defaults.providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"order.options.changeProvider(order.form.aseguradora)\" ng-model=\"order.form.aseguradora\" ng-disabled=\"!order.form.contratante\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un proveedor</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Clave de agente <span class=\"color-red\">*</span></label><div ng-if=\"!order.defaults.claves.length\"><input type=\"text\" placeholder=\"No hay ninguna clave para esta aseguradora\" class=\"form-control\" disabled=\"\"></div><div class=\"\" ng-if=\"order.defaults.claves.length == 1\" ng-init=\"order.form.clave = order.defaults.claves[0]\"><input type=\"text\" name=\"clave_agente\" placeholder=\"Elige una aseguradora aseguradora\" class=\"form-control\" value=\"{{order.defaults.claves[0].clave +\'-\'+ order.defaults.claves[0].name}}\" disabled=\"\"></div><select ng-if=\"order.defaults.claves.length > 1\" class=\"form-control\" data-ng-options=\"clave as clave.clave +\' - \'+ clave.name for clave in order.defaults.claves | orderBy: \'clave\' track by clave.url\" ng-change=\"order.options.changeClave(order.form.clave)\" ng-model=\"order.form.clave\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo <span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"ramo.ramo_name for ramo in order.defaults.ramos track by ramo.url\" ng-change=\"order.options.changeRamo(order.form.ramo); identifier(\'ramo\')\" ng-model=\"order.form.ramo\" ng-disabled=\"!order.form.aseguradora\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un ramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramo <span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"subramo.subramo_name for subramo in order.defaults.subramos track by subramo.url\" ng-change=\"order.options.changeSubramo(order.form.subramo)\" ng-model=\"order.form.subramo\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un subramo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 1\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_life\" ng-change=\"changeType();\" ng-model=\"order.subforms.life.aseguradosList[0].policy_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 2\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_ap\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.disease.policy_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 3 || order.defaults.formInfo.code == 4\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_gm\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.disease.policy_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 9\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.auto.policy_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 3\"><label>Nivel Hospitalario:</label> <input type=\"text\" class=\"form-control\" ng-model=\"order.form.hospital_level\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 3\"><label>Tabulador:</label> <input type=\"text\" class=\"form-control\" ng-model=\"order.form.tabulator\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 9\"><label>Procedencia</label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.procedencia\" ng-change=\"save_info_tab();\" name=\"procedencia\" ng-model=\"order.subforms.auto.procedencia\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 7\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_incendio\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.damage.damage_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 6\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_myt\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.damage.damage_type\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 8\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_ayc\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.damage.damage_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 10\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_credito\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.damage.damage_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 11\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_vivienda\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.damage.damage_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 13\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_diversos\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.damage.damage_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 12\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_garantia\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.damage.damage_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 5\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_rc\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.damage.damage_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 14\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_tyorc\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.damage.damage_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"order.defaults.formInfo.code == 31\"><label>Tipo <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.id as type.name for type in order.types_lf\" ng-change=\"changeType();\" name=\"type\" ng-model=\"order.subforms.damage.damage_type\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un tipo</option></select></div><div ng-if=\"order.responsables.length > 0\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"responsable\">Responsable</label><select class=\"form-control\" name=\"responsable\" ng-model=\"order.form.responsable\" ng-change=\"save_info_tab(order.form.responsable)\" ng-options=\"responsable as responsable.first_name + \' \' + responsable.last_name for responsable in order.responsables track by responsable.id\"><option value=\"\">Seleccione un responsable</option></select></div><div ng-if=\"order.ejecutivos.length > 0\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"collection_executive\">Ejecutivo de Cobranza</label><select class=\"form-control\" name=\"collection_executive\" ng-model=\"order.form.collection_executive\" ng-change=\"save_info_tab(order.form.collection_executive)\" ng-options=\"collection_executive as collection_executive.first_name + \' \' + collection_executive.last_name for collection_executive in order.ejecutivos track by collection_executive.id\"><option value=\"\">Seleccione un Ejecutivo</option></select></div><div ng-if=\"!order.defaults.comisiones.length\"><span>{{ not_comision }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Paquetes <span class=\"color-red\">*</span></label><div ng-if=\"!createPackRen\"><select class=\"form-control\" data-ng-options=\"package.package_name for package in order.defaults.packages track by package.url\" ng-change=\"order.options.changePackage(order.form.paquete); identifier(\'paquete\')\" ng-model=\"order.form.paquete\" ng-disabled=\"!order.form.subramo\" required=\"\"><option value=\"\">Selecciona un paquete</option></select></div><div class=\"input-group\" ng-if=\"createPackRen\"><select class=\"form-control\" data-ng-options=\"package.package_name for package in order.defaults.packages track by package.url\" ng-change=\"order.options.changePackage(order.form.paquete); identifier(\'paquete\')\" ng-model=\"order.form.paquete\" ng-disabled=\"!order.form.subramo\" required=\"\"><option value=\"\">Selecciona un paquete</option></select><span class=\"input-group-btn\" ng-click=\"addNewPackage()\" ng-disabled=\"!order.form.subramo\"><button class=\"btn btn-success\" ng-click=\"addNewPackage()\" ng-disabled=\"!order.form.subramo\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio <span class=\"color-red\">*</span></label><select id=\"businessline\" class=\"form-control\" ng-options=\"businessline.id as businessline.name for businessline in order.businessline\" ng-model=\"order.form.business_line\" ng-change=\"changeBusinessLine(order.form.business_line)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-options=\"celula.celula_name for celula in celulas | orderBy:\'id\' track by celula.id\" ng-change=\"changeCelula()\" ng-model=\"order.form.celula\"><option value=\"\" disabled=\"\">Seleccione</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Agrupación</label><select class=\"form-control\" ng-options=\"item.description for item in agrupaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeAgrupacion(order.form.grouping_level)\" ng-model=\"order.form.grouping_level\"><option value=\"\" disabled=\"\">Seleccione una agrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Subagrupación</label><select class=\"form-control\" ng-options=\"item.description for item in sub_asignaciones | orderBy:\'id\' track by item.id\" ng-change=\"changeSubagrupacion(order.form.subgrouping)\" ng-model=\"order.form.subgrouping\" ng-disabled=\"!order.form.grouping_level\"><option value=\"\" disabled=\"\">Seleccione una subagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_agrupacion\"><label>Subsubagrupación</label><select class=\"form-control\" ng-options=\"item.description for item in sub_subasignaciones | orderBy:\'id\' track by item.id\" ng-model=\"order.form.subsubgrouping\" ng-disabled=\"!order.form.subgrouping\"><option value=\"\" disabled=\"\">Seleccione una subsubagrupación</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Moneda <span class=\"color-red\">*</span></label><select id=\"SelectCurrency\" class=\"form-control\" ng-options=\"f_currency.value as f_currency.label for f_currency in order.f_currency.options\" ng-model=\"order.f_currency.f_currency_selected\" ng-change=\"changeCurrency()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"SelectConducto\">Conducto de pago <span class=\"color-red\">*</span></label><select id=\"SelectConducto\" class=\"form-control\" ng-options=\"conducto_de_pago.value as conducto_de_pago.label for conducto_de_pago in order.conducto_de_pago.options\" ng-model=\"order.conducto_de_pago.conducto_de_pago_selected\" ng-change=\"changeConducto()\"></select></div><div ng-if=\"sucursalList.length > 0\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"sucursal\">Sucursal</label><select class=\"form-control\" name=\"sucursal\" ng-model=\"order.form.sucursal\" ng-change=\"sucursal(order.form.sucursal)\" ng-options=\"sucursal as sucursal.sucursal_name for sucursal in sucursalList track by sucursal.id\"><option value=\"\">Seleccione una Sucursal</option></select></div><div class=\"col-md-12 col-sm-12 animate legend-gray\" ng-if=\"show_new_pack\"><form><legend class=\"legend-title\" align=\"center\">Agregar Paquete</legend><div class=\"col-xs-12\" ng-if=\"create_pack\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6\"><label>Nombre<span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"package.package_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6\"><label>Observaciones<span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"package.description\"></textarea></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group btn-mt pull-right\"><button class=\"col-xs-12 btn btn-success\" ng-disabled=\"!package.package_name\" ng-click=\"savePackage(package)\">Siguiente</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group btn-mt pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"cancelNewPackage()\">Cancelar</button></div></div></div><div class=\"col-xs-12\" ng-if=\"add_coverages\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><label>Nombre de Cobertura<span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"coverageName\" type=\"text\"></div><div class=\"col-xs-12 col-md-3\"><label>Suma asegurada</label> <input class=\"form-control\" ng-model=\"sum_insured\" type=\"text\"></div><div class=\"col-xs-12 col-md-3\"><label>Deducible</label> <input class=\"form-control\" ng-model=\"deductible\" type=\"text\"></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success\" ng-click=\"saveCoverage(coverageName, sum_insured, deductible); coverageName = \'\'\">Agregar</button> <button class=\"btn btn-info\" ng-click=\"finishCoverages()\" ng-disabled=\"!coverages.length\">Finalizar</button></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><label class=\"text-center\">COBERTURAS DEL PAQUETE {{ package.package_name }}</label><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"coverage in coverages\">{{ coverage.coverage_name }}</li></ul></div></div></div><hr class=\"col-xs-12\"></form></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"frec_disabled\"><label>Frecuencia de pago <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control\" ng-if=\"frec_disabled\" ng-model=\"order.form.payment.label\" type=\"text\" disabled=\"\"> <span class=\"input-group-btn\" ng-if=\"(order.form.status == 1 || order.form.status == 2) || numRecs == totalRecs\"><button class=\"btn btn-info\" ng-if=\"is_edition\" ng-click=\"changeFrequency()\">Cambiar frecuencia</button></span></div></div><div class=\"col-xs-12 form-group\"><div class=\"row form-group\" ng-if=\"!frec_disabled\"><legend class=\"legend-title\" align=\"center\">Frecuencia de Pago <span class=\"color-red\">*</span></legend><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.form.payment.value\" type=\"radio\" value=\"1\"> MENSUAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment.value\" value=\"2\"> BIMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment.value\" value=\"3\"> TRIMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.form.payment.value\" type=\"radio\" value=\"4\"> CUATRIMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment.value\" value=\"6\"> SEMESTRAL</label></div></div><div class=\"col-xs-12 col-sm-4 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input type=\"radio\" ng-model=\"order.form.payment.value\" value=\"12\"> ANUAL</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.form.payment.value\" type=\"radio\" value=\"5\"> CONTADO</label></div></div></div></div><div class=\"col-xs-12 col-sm-7 col-md-5 nopadding form-group\" ng-if=\"order.acceso_ver_ref\"><label>Referenciadores</label><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in referenciadores\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteReferenciador($index, item)\" ng-disabled=\"referenciadores.length <= 1 || item.vendor\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b col-xs-12\" name=\"referenciador_policy\" ng-model=\"item.referenciador\" ng-change=\"changeReferenciador(item)\" ng-options=\"referenciador_policy.url as referenciador_policy.first_name + \' \' + referenciador_policy.last_name for referenciador_policy in referenciador\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\" ng-init=\"referenciadores[$index].resp_type = 0\"><input class=\"form-control m-b col-xs-12 wb102\" type=\"text\" name=\"\" placeholder=\"% Comisión\" ng-model=\"item.comision_vendedor\" ng-disabled=\"referenciadores.length <= 1\" ng-change=\"changeComRef(item)\" required=\"\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button> <a ng-disabled=\"!item.referenciador\" ng-show=\"item.selectedRef && referenciadores.length > 1 && order.poliza.primaTotal\" class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); calculateComision(item, $index)\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i></a></div></div></div></div></div></fieldset></div><div class=\"col-md-12 col-sm-12 form-group\"><div ng-if=\"order.show.showForms\" ng-include=\"\'templates/forms.html\'\"></div></div><div class=\"col-xs-12 form-group\" ng-if=\"order.form.paquete\"><div ng-include=\"\'app/coberturas/coberturas.table.html\'\"></div><div ng-if=\"addNewCoverages\"><div class=\"col-xs-12 col-sm-3 form-group\"><label>Nombre de Cobertura<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"coverageName\"></div><br><div class=\"col-xs-12 col-sm-3\"><button class=\"col-xs-12 btn btn-white pull-right margin-top-5\" ng-click=\"finishNewCoverages()\">Cancelar</button></div><div class=\"col-xs-12 col-sm-3\"><button class=\"col-xs-12 btn btn-info pull-right margin-top-5\" ng-click=\"finishNewCoverages()\" ng-disabled=\"!coverages.length\">Finalizar</button></div><div class=\"col-xs-12 col-sm-3\"><button class=\"col-xs-12 btn btn-success pull-right margin-top-5\" ng-click=\"saveNewCoverage(coverageName,priority,order.form.paquete)\">Agregar</button></div></div></div><div class=\"col-md-12 col-sm-6 form-group\"><fieldset><legend class=\"legend-title\" align=\"center\">Observaciones</legend><div class=\"row\"><div class=\"col-xs-12 form-group\"><textarea type=\"text\" class=\"form-control\" ng-model=\"order.form.observations\"></textarea></div></div></fieldset></div><div class=\"col-md-12 col-sm-12 form-group\"><div class=\"row\" ng-if=\"order.permiso_administrar_adjuntos\"><div ng-if=\"order.acceso_adm_pol\" ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"row\"><div class=\"row col-md-12 col-sm-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_\" class=\"form-control display-none\" ng-if=\"order.permiso_administrar_adjuntos\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"renameFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file,files,order.form)\" ng-if=\"order.permiso_administrar_adjuntos\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"order.permiso_administrar_adjuntos\">Renombrar</button> <span class=\"btn btn-success display-none\" ng-if=\"order.permiso_administrar_adjuntos\">Guardar</span></td></tr></tbody></table></div></div></div></div><button id=\"createCont\" ng-click=\"order.contratanteCreatorModalEvent()\" class=\"display-none\"></button><div class=\"col-md-12 col-sm-12 form-group\" ng-hide=\"order.show.ot\"><div ng-if=\"show_receipts\"><div class=\"alert alert-warning\" ng-if=\"imgPrimasSrcR\" style=\"margin-top: 15px;\"><h4 style=\"margin-top:0;\"><i class=\"fa fa-exclamation-triangle\"></i> Verificación obligatoria de primas</h4><p style=\"margin-bottom:0;\">A continuación se muestra la captura de las primas obtenidas del PDF de la aseguradora y las primas leídas automáticamente por SAAM.<br><strong>Revise cuidadosamente que los montos coincidan exactamente.</strong><br><strong>Se recomienda ampliar la imagen (zoom) para asegurar la correcta validación de los montos.</strong></p><button type=\"button\" class=\"btn btn-danger pull-right\" ng-if=\"imgPrimasSrcR\" ng-click=\"order.ui = order.ui || {}; order.ui.showImgPrimas = !order.ui.showImgPrimas\"><i class=\"fa\" ng-class=\"{ \'fa-chevron-down\': !(order.ui && order.ui.showImgPrimas), \'fa-chevron-up\': (order.ui && order.ui.showImgPrimas) }\"></i> {{ (order.ui && order.ui.showImgPrimas) ? \'Ocultar captura de primas\' : \'Ver captura de primas\' }} <i class=\"fa fa-search-plus\" ng-class=\"{\'fa-search-plus\': (order.ui && order.ui.showImgPrimas),\'fa-search\': !(order.ui && order.ui.showImgPrimas)}\" aria-hidden=\"true\" style=\"margin-right:6px;\"></i></button></div><style>\n            .img-wrap{\n                overflow:auto;\n                max-height:70vh;\n                border-radius:4px;\n            }\n\n            .img-zoom{\n                display:block;\n                width:100%;\n                height:auto;\n                max-width:none;\n                transition:transform .2s ease;\n                transform-origin: 0% 0%;  /* se sobreescribe en runtime */\n                cursor:zoom-in;\n            }\n\n            .img-zoom.is-zoomed{\n                transform:scale(2.8);\n                cursor:zoom-out;\n            }\n        </style><div class=\"collapse\" ng-class=\"{ in: (order.ui && order.ui.showImgPrimas) }\" ng-if=\"imgPrimasSrcR\" style=\"margin-top: 10px;\"><div class=\"well well-sm\" style=\"margin-bottom:0; overflow:auto;\"><img ng-src=\"{{imgPrimasSrcR}}\" class=\"img-responsive img-thumbnail img-zoom\" ng-class=\"{\'is-zoomed\': order.ui.zoomPrimas}\" ng-click=\"order.ui.zoomPrimas = !order.ui.zoomPrimas\" style=\"width:50%; max-width:50%; height:260px; object-fit:contain; object-position:center; margin:0 auto; display:block;\"></div></div><receipts-individual form=\"order.form\" tosave=\"order\" type=\"1\"></receipts-individual></div></div></div><script>\n  function renombrarArchivoCargado(){\n    console.log(\'renombrarArchivoCargados-Ordenes.info\');\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"[name=\'text_\']\");\n\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n\n      btnTag.addClass(\'display-none\');\n      dummy.removeClass(\'display-none\');\n\n      inputTag.removeClass(\'display-none\');\n      strongTag.addClass(\'display-none\');\n      inputTag.focus();\n   }\n   function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"[name=\'text_\']\");\n\n      var btnTag = $(event.target).parent().parent().find(\"button\");\n      var dummy = $(event.target).parent().parent().find(\"td span\");\n\n      btnTag.removeClass(\'display-none\');\n      dummy.addClass(\'display-none\');\n\n      inputTag.addClass(\'display-none\');\n      strongTag.removeClass(\'display-none\');\n    }\n</script>");
$templateCache.put("app/ordenes/ordenes.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Pólizas</h2><ol class=\"breadcrumb margin-top-15\"><li ng-if=\"!show_contractor\"><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\" ng-show=\"!show_contractor\"><strong>Pólizas</strong></li><li class=\"active\" ng-show=\"show_contractor\" ng-click=\"returnToPolicy()\"><a>Regresar</a></li></ol></div></div><div ng-if=\"show_contractor\" class=\"animate z-index-9000\"><div><ng-include src=\"\'app/contratantes/contratantes.add.html\'\" ng-controller=\"ContratantesCtrl as vm\"></ng-include></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\" ng-if=\"!show_contractor\"><div class=\"row\"><div class=\"col-lg-12\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"OT\" ng-click=\"order.hideButtonOT()\" ng-show=\"order.acceso_adm_ot\"><div id=\"divCOT\" ng-include=\"\'app/ordenes/ordenes.generic.html\'\"></div></uib-tab><uib-tab index=\"1\" heading=\"Póliza\" ng-click=\"order.showButtonPoliza()\" ng-show=\"order.acceso_adm_pol\"><div id=\"divCPoliza\" ng-include=\"\'app/ordenes/ordenes.generic.html\'\"></div></uib-tab></uib-tabset></div></div></div></div><div class=\"row\"><div ng-if=\"activeJustified == 0\"><div class=\"form-group\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"order.acceso_adm_ot\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"validatePolicy(\'ot\')\" data-style=\"expand-right\"><span class=\"ladda-label\">Crear OT</span></button> <button class=\"col-xs-12 btn btn-primary\" ng-if=\"order.acceso_adm_pol\" ng-click=\"order.save.saveInsurance(\'poliza\')\" ng-disabled=\"order.options.showPoliceCreator()\" ng-show=\"!order.show.ot\" type=\"button\">Crear Póliza</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button id=\"closeOT\" class=\"col-xs-12 btn btn-danger\" ng-click=\"order.save.closeModal()\" type=\"button\">Cancelar</button></div></div></div></div><div ng-if=\"activeJustified == 1 && order.acceso_adm_pol\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 form-group container-loader\" ng-if=\"enproceso\"></div></div><div ng-class=\"{ \'alert alert-success alertpdf\': serieAGuardar && serieDetectada === serieAGuardar, \'alert alert-danger alertpdf\': serieAGuardar && serieDetectada !== serieAGuardar, \'alert alert-warning alertpdf\': !serieAGuardar }\" style=\"padding: 12px 15px;\" ng-if=\"order.form.subramo && order.form.subramo.subramo_code==9 && mostrarAdvertenciaSerie\"><span><h3>CAPTURA DE LA SERIE EN EL PDF</h3></span> <img ng-if=\"imgSerieSrc\" ng-src=\"{{imgSerieSrc}}\" style=\"max-width:100%;\"><div ng-if=\"order.subforms.auto.serial\" style=\"display:flex; gap:12px; align-items:flex-start; padding:14px 16px; border:1px solid #cfe2ff; background:#f8fbff; border-radius:12px; margin:12px 0;\"><div style=\"width:34px; height:34px; border-radius:10px; background:#1976d2; color:#fff; display:flex; align-items:center; justify-content:center; font-weight:900;\">VIN</div><div style=\"flex:1;\"><div style=\"font-size:12px; font-weight:700; color:#1e3a8a;\"><h3>SERIE DETECTADA POR SAAM</h3>A guardar<div style=\"font-size:22px; font-weight:800; margin-top:4px; word-break:break-all; display:flex; align-items:center; gap:8px;\" ng-class=\"{ \'vin-ok\': !hasInvalidVinLettersTest(order.subforms.auto.serial), \'vin-warning\': hasInvalidVinLettersTest(order.subforms.auto.serial) }\">{{ order.subforms.auto.serial || \'—\' }}<span ng-if=\"hasInvalidVinLettersTest(order.subforms.auto.serial)\" style=\"font-size:11px; font-weight:800; padding:4px 8px; border-radius:999px; background:#fff1f2; color:#991b1b; border:1px solid #fecdd3; white-space:nowrap;\" title=\"El VIN contiene letras no permitidas (O, I, Q)\"><i class=\"fa fa-exclamation-triangle\" style=\"margin-right:4px;\"></i> Serie inválida</span></div></div></div></div><p style=\"margin: 0 0 5px 0; font-size: 14px; color: #333;\" ng-if=\"serieDetectada && order.form.subramo.subramo_code==9\"><strong>⚠ Serie detectada en el documento:</strong> <span style=\"font-weight: bold; color: #000;\">{{serieDetectada}}</span></p><small style=\"display: block; margin-top: 6px; line-height: 1.5; font-size: 13px; color: #444;\"><span>Por favor <strong>revise cuidadosamente</strong> que la <strong>SERIE</strong> detectada coincida exactamente con la que aparece en su documento original.</span><br><br></small></div><div class=\"col-xs-12\" ng-if=\"enproceso==false\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"validatePolicy(\'poliza\')\" ng-if=\"order.acceso_adm_pol\" ng-disabled=\"enproceso\">Crear Póliza</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"order.save.closeModal()\" type=\"button\">Cancelar</button></div></div></div></div></div></div><script src=\"https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js\"></script>");
$templateCache.put("app/ordenes/recibos.generic.html","<fieldset><h3 class=\"legend-title policy-calculate-title\" align=\"center\"><i class=\"fa fa-calculator margin-left-10\"></i> PRIMAS DE PÓLIZAS</h3><div class=\"ibox float-e-margins\"><form name=\"receiptsForm\"><div class=\"row\"><div class=\"col-md-3 col-sm-12 form-group\"><label class=\"control-label\">Prima neta<span class=\"color-red\">*</span></label><input-currency model=\"order.poliza.primaNeta\"></input-currency></div><div class=\"col-md-3 col-sm-12 form-group\"><label class=\"control-label\" for=\"rpf\">Recargo por Pago Fraccionado</label><input-currency model=\"order.poliza.rpf\"></input-currency></div><div class=\"col-md-3 col-sm-12 form-group\"><label for=\"derecho\">Derecho de Póliza<span class=\"color-red\">*</span></label><input-currency model=\"order.poliza.derecho\"></input-currency></div><div class=\"col-md-3 col-sm-12 form-group\"><label for=\"sub-total\">Sub-Total</label><input-currency model=\"order.poliza.subTotal\"></input-currency></div><div class=\"col-md-3 col-sm-12 form-group\"><label for=\"prima-total\">IVA de póliza</label><input-currency model=\"order.poliza.iva\"></input-currency></div><div class=\"col-md-3 col-sm-12 form-group\"><label for=\"prima-total\">Prima Total</label><input-currency model=\"order.poliza.primaTotal\"></input-currency></div><div class=\"row col-md-12\"><div class=\"col-md-3 col-sm-12 form-group\"><label class=\"control-label margin-bottom-0\" for=\"\">Derecho</label><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.configDerecho\" type=\"checkbox\"> Cargos sólo al primer recibo</label></div></div><div class=\"col-md-3 col-sm-12 form-group\"><label class=\"control-label margin-bottom-0\" for=\"\">RPF</label><div class=\"checkbox margin-top-5\"><label><input ng-model=\"order.configRPF\" type=\"checkbox\"> Cargos sólo al primer recibo</label></div></div><div class=\"col-md-3 col-sm-12 form-group\"><label class=\"control-label margin-bottom-0\" for=\"\">IVA</label><div class=\"checkbox margin-top-5\"><label><input type=\"checkbox\" ng-init=\"order.poliza.ivaStatus = true\" ng-model=\"order.poliza.ivaStatus\" ng-click=\"changeIva(order.poliza.ivaStatus)\" ng-change=\"calculate(order.poliza)\"> Aplica IVA</label></div></div><div class=\"row\"><div class=\"pull-right\"><button class=\"btn btn-success btn-shadow\" ng-show=\"order.poliza.primaNeta && order.poliza.derecho\" ng-click=\"calculate(order.poliza); order.receiptOptions.calculate()\" ng-disabled=\"!order.poliza.primaNeta || !order.poliza.derecho\"><i class=\"fa fa-calculator btn-shadow\" aria-hidden=\"true\"></i> Calcular y generar recibos</button></div></div></div></div></form><div class=\"row\"><div ng-if=\"order.defaults.showReceipts\"><div ng-if=\"order.receipts.length\"><table class=\"table footable table-stripped\"><thead><tr><th class=\"footable-visible footable-sortable footable-first-column text-align-center\" data-breakpoints=\"xs\">Recibo</th><th class=\"footable-sortable text-align-center\" data-hide=\"phone\">Fecha Inicio</th><th class=\"footable-sortable text-align-center\" data-hide=\"phone\">Fecha Fin</th><th class=\"footable-visible footable-sortable text-align-center\" data-hide=\"phone\">Prima Neta</th><th class=\"footable-visible footable-sortable text-align-center\" data-hide=\"phone\">RPF</th><th class=\"footable-sortable text-align-center\" data-hide=\"phone\">Derecho</th><th class=\"footable-sortable text-align-center\" data-hide=\"phone\" ng-show=\"order.poliza.ivaStatus\">IVA</th><th class=\"footable-sortable footable-last-column footable-visible text-align-center\" data-breakpoints=\"xs\">Prima Total</th><th>Comisión</th></tr></thead><tbody><tr ng-repeat=\"receipt in order.receipts track by $index\"><td class=\"text-align-center\" ng-if=\"!showInput\">{{receipt.recibo_numero ? receipt.recibo_numero : $index + 1}}</td><td class=\"text-align-center\" ng-if=\"showInput\"><input class=\"form-control\" step=\"any\" value=\"{{receipt.recibo_numero ? receipt.recibo_numero : $index + 1}}\" type=\"text\"></td><td class=\"text-align-center\" ng-if=\"!showInput\">{{receipt.startDate | date: \'dd-MM-yyyy\'}}</td><td ng-if=\"showInput\"><div class=\"datepicker-me\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"receipt.startDate\" value=\"{{receipt.startDate}}\" ng-disabled=\"showInput == true\"></div></td><td class=\"text-align-center\" ng-if=\"!showInput\">{{receipt.endingDate | date: \'dd-MM-yyyy\'}}</td><td ng-if=\"showInput\"><div class=\"datepicker-me\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"receipt.endingDate\" value=\"{{receipt.endingDate}}\" ng-disabled=\"showInput == true\"></div></td><td class=\"text-align-center\" ng-if=\"!showInput\">{{receipt.prima | currency}}</td><td ng-if=\"showInput\"><input-currency model=\"receipt.prima\"></input-currency></td><td class=\"text-align-center\" ng-if=\"!showInput\">{{receipt.rpf | currency}}</td><td ng-if=\"showInput\"><input-currency model=\"receipt.rpf\"></input-currency></td><td class=\"text-align-center\" ng-if=\"!showInput\">{{receipt.derecho | currency}}</td><td ng-if=\"showInput\"><input-currency model=\"receipt.derecho\"></input-currency></td><td class=\"text-align-center\" ng-if=\"order.poliza.iva;!showInput\" ng-show=\"order.poliza.ivaStatus\">{{receipt.iva | currency}}</td><td ng-if=\"order.poliza.iva; showInput\" ng-show=\"order.poliza.ivaStatus\"><input-currency model=\"order.poliza.iva\"></input-currency></td><td class=\"text-align-center\" ng-if=\"!showInput\">{{receipt.total | currency}}</td><td ng-if=\"showInput\"><input-currency model=\"receipt.total\"></input-currency></td><td><span ng-if=\"receipt.comision && !showInput\">{{receipt.comision | currency}}</span><input-currency ng-if=\"showInput\" model=\"receipt.comision\"></input-currency></td></tr></tbody></table><div class=\"pull-right\"><button ng-if=\"order.receipts.length; !showInput\" type=\"button\" class=\"btn btn-primary btn-shadow\" ng-click=\"editTable()\"><i class=\"fa fa-pencil-square-o btn-shadow\" aria-hidden=\"true\"></i> Editar Recibo</button> <button ng-if=\"order.receipts.length; showInput\" type=\"button\" class=\"btn btn-success btn-shadow\" ng-click=\"editTable()\"><i class=\"fa fa-floppy-o btn-shadow\" aria-hidden=\"true\"></i> Guardar cambios</button></div></div></div></div><script type=\"text/javascript\">\n			function currency(){\n				$(\'#money\').prop(\"format-as-currency\");\n			}\n		</script></div></fieldset>");
$templateCache.put("app/paquetes/paquetes.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Coberturas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"paquetes.paquetes\">Paquetes</a></li><li class=\"active\"><strong>Paquete {{vm.package.package_name}}</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Proveedor: {{vm.provider.compania}}- Paquete: {{vm.package.package_name}}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div><label class=\"control-label\">Nombre del paquete</label> <input class=\"form-control\" ng-model=\"vm.package.package_name\" type=\"text\"></div><br><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example\" datatable=\"ng\"><thead><tr><th>Nombre</th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.package.coverage_package | orderBy: \'priority\' track by coverage.url\"><td ng-click=\"vm.editCoverageModal(coverage)\"><a>{{ coverage.coverage_name }}</a></td></tr></tbody></table></div></div></div></div></div><div ng-show=\"false\" class=\"row\"><div class=\"col-lg-4\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Agregar coberturas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"panel-body\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><form class=\"form-horizontal\" method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Cobertura*</label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"name\" ng-model=\"vm.form.coverage_name\" required=\"\" type=\"text\"></div></div><div class=\"form-group\"><div class=\"col-sm-6 col-sm-offset-2\"><button class=\"btn btn-primary\" ng-disabled=\"form.$invalid\" type=\"submit\">Guardar</button></div></div></form></div></div></div></div></div></div><div class=\"col-lg-4\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Agregar sumas aseguradas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"panel-body\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><form class=\"form-horizontal\" method=\"post\" name=\"form2\" ng-submit=\"vm.submitSum(form2.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form2.sum_insured.$invalid && !form2.sum_insured.$pristine }\"><label class=\"col-sm-2 control-label\">Suma asegurada*</label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"sum_insured\" ng-model=\"vm.form2.sum_insured\" required=\"\" type=\"text\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Cobertura*</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-model=\"vm.form2.coverage_sum\" data-ng-options=\"coverage.coverage_name for coverage in vm.package.coverage_package track by coverage.url\" required=\"\"><option value=\"\">Selecciona una cobertura</option></select></div></div><div class=\"form-group\"><div class=\"col-sm-6 col-sm-offset-2\"><button class=\"btn btn-primary\" ng-disabled=\"form2.$invalid\" type=\"submit\">Guardar</button></div></div></form></div></div></div></div></div></div><div class=\"col-lg-4\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Agregar deducibles</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"panel-body\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><form class=\"form-horizontal\" method=\"post\" name=\"form3\" ng-submit=\"vm.submitDeductible(form3.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form3.deductible.$invalid && !form3.deductible.$pristine }\"><label class=\"col-sm-2 control-label\">Deducible*</label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"deductible\" ng-model=\"vm.form3.deductible\" required=\"\" type=\"text\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Cobertura*</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-model=\"vm.form3.coverage_deductible\" data-ng-options=\"coverage.coverage_name for coverage in vm.package.coverage_package track by coverage.url\" required=\"\"><option value=\"\">Selecciona una cobertura</option></select></div></div><div class=\"form-group\"><div class=\"col-sm-6 col-sm-offset-2\"><button class=\"btn btn-primary\" ng-disabled=\"form3.$invalid\" type=\"submit\">Guardar</button></div></div></form></div></div></div></div></div></div></div><div class=\"row\"><div class=\"form-group col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-click=\"vm.savePack(vm.package)\">Actualizar paquete</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"col-xs-12 btn btn-white\" ui-sref=\"paquetes.paquetes\" type=\"button\">Cancelar</button></div></div></div></div>");
$templateCache.put("app/paquetes/paquetes.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Paquetes</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Paquetes</strong></li></ol></div></div><div class=\"row\"><button class=\"col-md-3 col-xs-6 btn btn-info ml-75 button1\" ng-if=\"vm.user.permiso.crear\" name=\"button\" type=\"button\" ng-click=\"vm.toggle(1)\">Crear Paquete</button> <button class=\"col-md-3 col-xs-6 btn btn-info ml-75 button2\" ng-if=\"vm.user.permiso.crear\" name=\"button\" ng-click=\"vm.hideForm1()\" type=\"button\">Crear Cobertura</button> <button class=\"col-md-3 col-xs-6 btn btn-info ml-75 button2\" ng-if=\"vm.user.permiso.editar\" name=\"button\" ng-click=\"vm.hideForm2()\" type=\"button\">Personalizar Paquete</button></div><div class=\"row\" ng-show=\"vm.showForm == 1\"><div class=\"col-lg-12 margin-bottom-10\"><div class=\"ibox-title\"><h5>Creación de paquetes</h5></div><div class=\"ibox-content\"><form method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Nombre del paquete<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.packageName.$invalid && !form.packageName.$pristine }\"><input class=\"form-control\" name=\"packageName\" ng-model=\"vm.form.package_name\" required=\"\" type=\"text\"></div></div></div><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Proveedor<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.provider.$invalid && !form.provider.$pristine }\"><select class=\"form-control m-b\" name=\"provider\" ng-model=\"vm.form.provider\" data-ng-options=\"provider.compania for provider in vm.providers | orderBy: \'compania\' track by provider.url\" ng-change=\"vm.changeProvider(vm.form.provider)\" required=\"\"><option value=\"\">Selecciona un proveedor</option></select></div></div></div><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Ramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.ramo.$invalid && !form.ramo.$pristine }\"><select class=\"form-control m-b\" name=\"ramo\" ng-model=\"vm.form.ramo\" data-ng-options=\"ramo.ramo_name for ramo in vm.ramos track by ramo.url\" ng-change=\"vm.changeRamo(vm.form.ramo)\" required=\"\"><option value=\"\">Selecciona un ramo</option></select></div></div></div><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Subramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.subramo.$invalid && !form.subramo.$pristine }\"><select class=\"form-control m-b\" name=\"subramo\" ng-model=\"vm.form.subramo\" data-ng-options=\"subramo.subramo_name for subramo in vm.subramos track by subramo.url\" required=\"\"><option value=\"\">Selecciona un subramo</option></select></div></div></div><div class=\"form-group\"><label class=\"col-md-6 control-label\">Observaciones</label><div class=\"col-sm-12\"><textarea class=\"form-control\" name=\"description\" ng-model=\"vm.form.description\" type=\"text\"></textarea></div></div><div class=\"row\"><div class=\"form-group col-xs-12\"><button class=\"btn btn-white pull-right mt5\" ng-click=\"vm.hideForm()\" type=\"button\">Cancelar</button> <button class=\"btn btn-success pull-right margin-right-10 mt5\" ng-disabled=\"!vm.form.package_name\" type=\"submit\">Crear paquete</button></div></div></form></div></div></div><div class=\"row\" ng-show=\"vm.showForm2\"><div class=\"col-lg-12 margin-bottom-10\"><div class=\"ibox-title\"><h5>Personalización de paquetes</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><form name=\"personalizar_package\"><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Proveedor<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': personalizar_package.package_provider.$invalid && !personalizar_package.package_provider.$pristine}\"><select class=\"form-control m-b\" ng-options=\"prov as prov.compania for prov in vm.providers\" name=\"package_provider\" ng-model=\"vm.form.package_provider\" ng-change=\"vm.changePackageProvider(vm.form.package_provider)\" required=\"\"><option value=\"\">Selecciona un proveedor</option></select></div></div></div><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Ramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': personalizar_package.ramo.$invalid && !personalizar_package.ramo.$pristine }\"><select class=\"form-control m-b\" ng-options=\"ramo.ramo_name for ramo in vm.package_ramos track by ramo.url\" name=\"ramo\" ng-model=\"vm.form.package_ramo\" ng-change=\"vm.changePackageRamo(vm.form.package_ramo)\" required=\"\"><option value=\"\">Selecciona un ramo</option></select></div></div></div><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Subramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': personalizar_package.subramo.$invalid && !personalizar_package.subramo.$pristine }\"><select class=\"form-control m-b\" ng-options=\"subramo.subramo_name for subramo in vm.package_subramos track by subramo.url\" name=\"subramo\" ng-model=\"vm.form.package_subramo\" ng-change=\"vm.changePackageSubramo(vm.form.package_subramo)\" required=\"\"><option value=\"\">Selecciona un subramo</option></select></div></div></div><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Paquete<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': personalizar_package.package_paquete.$invalid && !personalizar_package.package_paquete.$pristine }\"><select class=\"form-control m-b\" ng-options=\"paquete.package_name for paquete in vm.package_paquetes track by paquete.url\" name=\"package_paquete\" ng-model=\"vm.form.package_paquete\" ng-change=\"vm.changePackagePackage(vm.form.package_paquete)\" required=\"\"><option value=\"\">Selecciona un paquete</option></select></div></div></div></form><div class=\"form-group animate\" id=\"cobertura\" ng-if=\"vm.test == true && vm.ordenar == false && vm.cobDe == true\"><table id=\"cobertura-table\" class=\"footable\" data-filter=\"#filter\" data-page-size=\"25\" ng-if=\"vm.form.package_paquete && vm.package_covs.length\"><thead><tr class=\"col-md-6\"><th class=\"text-align-center footable-visible footable-sortable footable-first-column margin-bottom-10\" data-breakpoints=\"xs\">Cobertura</th><th class=\"footable-visible footable-sortable margin-bottom-10\" data-hide=\"phone\"></th></tr></thead><tbody><tr class=\"col-md-6\" ng-repeat=\"coverage in vm.package_covs track by coverage.url\"><td class=\"col-xs-7\"><p ng-bind=\"coverage.coverage_name\"></p></td><div class=\"col-md-12\"><div class=\"col-sm-6\"><td><div class=\"col-md-12\"><button ng-if=\"coverage.default\" class=\"btn btn-info margin-bottom-10\" name=\"button\" ng-click=\"vm.makeDefaultCoverage(coverage)\" type=\"button\">Desactivar</button> <button ng-if=\"!coverage.default\" class=\"btn btn-primary margin-bottom-10\" name=\"button\" ng-click=\"vm.makeDefaultCoverage(coverage)\" type=\"button\">Activar</button> <button ng-disabled=\"coverage.default\" class=\"btn btn-danger margin-bottom-10\" name=\"button\" type=\"button\" ng-click=\"vm.deleteCoverage(coverage,$index)\">Eliminar</button> <button class=\"btn btn-warning margin-bottom-10\" name=\"button\" type=\"button\" ng-click=\"vm.editCoverage(coverage,$index)\">Editar</button></div></td></div></div></tr></tbody></table></div><div class=\"row\"><div class=\"form-group animate panel-body\" id=\"cobertura\" ng-if=\"vm.test == true && vm.ordenar == true && vm.cobDe == false\"><table class=\"table footable table-hover table-bordered\" data-filter=\"#filter\" data-page-size=\"15\" ng-if=\"vm.form.package_paquete && vm.package_covs.length\"><thead><th class=\"footable-visible footable-sortable footable-first-column col-xs-12 col-sm-3 text-align-center width-20p\" data-breakpoints=\"xs\">Cobertura</th></thead><tbody><tr ng-repeat=\"coverage in vm.package_covs track by coverage.url\" foo-repeat-done=\"\"><td>{{ coverage.coverage_name }}</td></tr></tbody></table><div class=\"col-xs-12 col-sm-12\"><button type=\"button\" class=\"btn btn-w-m btn-primary pull-right\" name=\"button\" ng-click=\"vm.saveCovOrden(vm.package_covs)\">Guardar orden</button></div></div></div></div><div class=\"animate\" id=\"editcobertura\" ng-if=\"vm.test == false\"><div ng-include=\"\'app/modals/modal.coverage.create.html\'\"></div><button class=\"btn btn-primary margin-bottom-10\" name=\"button\" type=\"button\" ng-click=\"vm.coberturaTest()\">Ver coberturas</button></div><div class=\"form-group\"><button class=\"btn btn-white pull-right margin-right-10 margin-bottom-10 mt-3\" ng-if=\"vm.test == true && vm.ordenar == false && vm.cobDe == true\" ng-click=\"vm.hideForm2()\" type=\"button\">Cancelar</button> <button ng-if=\"vm.test == true && vm.ordenar == true && vm.cobDe == false\" class=\"btn btn-white pull-right margin-right-10 margin-bottom-10 mt-3 black-color\" ng-click=\"vm.hideForm2(2)\" type=\"button\">Cancelar</button><button class=\"btn btn-info pull-right margin-right-10 mb5 margin-bottom-10 mt-3\" name=\"button\" ng-if=\"vm.form.package_paquete && vm.package_covs.length == 0\" ng-click=\"vm.toggle(4)\">Crear Cobertura</button></div></div></div></div><div class=\"row\" ng-if=\"vm.showForm1\"><div class=\"col-lg-12 margin-bottom-10\"><div class=\"ibox-title\"><h5>Creación de cobertura</h5></div><div class=\"ibox-content\"><div class=\"row\"><form method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Nombre de la cobertura<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.coverage.$invalid && !form.coverage.$pristine }\"><input class=\"form-control\" name=\"coverage\" ng-model=\"vm.form.coverage_name\" required=\"\" type=\"text\"></div></div></div><div class=\"form-group\"><div class=\"col-md-2\"><label class=\"control-label\">Suma asegurada</label><div><input class=\"form-control\" name=\"coverage\" ng-model=\"vm.form.sum_insured\" type=\"text\"></div></div></div><div class=\"form-group\"><div class=\"col-md-2\"><label class=\"control-label\">Deducible</label><div><input class=\"form-control\" name=\"coverage\" ng-model=\"vm.form.deductible\" type=\"text\"></div></div></div><div class=\"form-group\" ng-if=\"inputCoverage\"><div class=\"col-md-2\"><label class=\"control-label\">Coaseguro</label><div><input class=\"form-control\" name=\"coverage\" ng-model=\"vm.form.coinsurance\" type=\"text\"></div></div></div><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Proveedor<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.coverage_provider.$invalid && !form.coverage_provider.$pristine }\"><select class=\"form-control m-b\" ng-options=\"prov as prov.compania for prov in vm.providers\" name=\"coverage_provider\" ng-model=\"vm.form.coverage_provider\" ng-change=\"vm.changeCoverageProvider(vm.form.coverage_provider)\" required=\"\"><option value=\"\">Selecciona un proveedor</option></select></div></div></div><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Ramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.coverage_ramo.$invalid && !form.coverage_ramo.$pristine }\"><select class=\"form-control m-b\" ng-options=\"ramo.ramo_name for ramo in vm.coverage_ramos track by ramo.url\" name=\"coverage_ramo\" ng-model=\"vm.form.coverage_ramo\" ng-change=\"vm.changeCoverageRamo(vm.form.coverage_ramo)\" required=\"\"><option value=\"\">Selecciona un ramo</option></select></div></div></div><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Subramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.coverage_subramo.$invalid && !form.coverage_subramo.$pristine }\"><select class=\"form-control m-b\" ng-options=\"subramo.subramo_name for subramo in vm.coverage_subramos track by subramo.url\" name=\"coverage_subramo\" ng-model=\"vm.form.coverage_subramo\" ng-change=\"vm.changeCoverageSubramo(vm.form.coverage_subramo)\" required=\"\"><option value=\"\">Selecciona un subramo</option></select></div></div></div><div class=\"form-group\"><div class=\"col-md-6\"><label class=\"control-label\">Paquete<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.coverage_paquete.$invalid && !form.coverage_paquete.$pristine }\"><select class=\"form-control m-b\" ng-options=\"paquete.package_name for paquete in vm.coverage_paquetes track by paquete.url\" name=\"coverage_paquete\" ng-model=\"vm.form.coverage_paquete\" required=\"\"><option value=\"\">Selecciona un paquete</option></select></div></div></div><div class=\"form-group\"><div class=\"col-md-6\"><button class=\"btn btn-white pull-right margin-right-10 margin-top-15\" ng-click=\"vm.hideForm1()\" type=\"button\">Cancelar</button> <button class=\"btn btn-primary pull-right margin-right-10 margin-top-15\" ng-disabled=\"form.$invalid\" type=\"button\" ng-click=\"vm.createCoverage()\">Asignar cobertura</button></div></div></form></div></div></div></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12 form-group\"><label>Paquete</label><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" id=\"filter\" placeholder=\"Buscar\" ng-enter=\"vm.search(cadena)\" ng-model=\"cadena\"><div class=\"input-group-btn\"><button class=\"btn btn-success margin-left-17\" ng-click=\"vm.activate()\">Mostrar todo</button></div></div></div><div class=\"col-lg-12\"><div class=\"row\" ng-if=\"vm.totalPackages.length\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información de paquetes</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><table class=\"table table-stripped hidden-xs hidden-sm\" ng-if=\"!vm.show_binnacle\"><thead><tr><th ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}}</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th><th ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}}</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th></tr></thead><tbody><tr ng-repeat=\"pack in vm.totalPackages | orderBy: \'-id\' track by $index\"><td>{{pack.package_name}}</td><td>{{pack.provider}}</td><td>{{pack.ramo}}</td><td>{{pack.subramo}}</td><td><div class=\"col-xs-12 col-sm-6\"><button type=\"button\" class=\"btn btn-w-m btn-warning\" ng-if=\"vm.user.permiso.editar\" name=\"button\" ng-click=\"vm.goToPackageEditor(pack)\">Editar</button></div><div class=\"col-xs-12 col-sm-6\"><button type=\"button\" class=\"btn btn-w-m btn-danger\" ng-if=\"vm.user.permiso.eliminar\" ng-click=\"vm.deletePackagesw(pack,$index)\">Eliminar</button></div></td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(pack)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pagination_pack && !vm.show_binnacle\" class=\"text-center hidden-xs hidden-sm\"><pagination config=\"vm.config_pagination\" model=\"vm.totalPackages\"></pagination></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"pack in vm.totalPackages track by $index\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}:{{pack.package_name}}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{pack.package_name}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{pack.provider}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p>{{pack.ramo}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{pack.subramo}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p><button type=\"button\" class=\"btn btn-w-m btn-warning\" ng-if=\"vm.user.permiso.editar\" name=\"button\" ng-click=\"vm.goToPackageEditor(pack)\">Editar</button> <button type=\"button\" class=\"btn btn-w-m btn-danger\" ng-if=\"vm.user.permiso.eliminar\" ng-click=\"vm.deletePackagesw(pack)\">Eliminar</button></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(pack)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></tr></table></div></div><div ng-if=\"vm.show_pagination_pack && !vm.show_binnacle\" class=\"text-center visible-xs-block visible-sm-block\"><pagination config=\"vm.config_pagination\" model=\"vm.totalPackages\"></pagination></div><br><div ng-if=\"vm.totalPackages.length && vm.buttonReport == false && !vm.show_binnacle\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 btn btn-primary btn-ef btn-ef-3 btn-ef-3c mb-10 ladda-button\" ng-click=\"exportData()\">Generar reporte</button></div><div ng-if=\"vm.buttonReport == true && !vm.show_binnacle\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 btn btn-primary btn-ef btn-ef-3 btn-ef-3c mb-10 ladda-button\" ng-click=\"exportDataSeeker(1)\">Generar reporte</button></div><div class=\"animate\" ng-if=\"vm.show_binnacle\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"returnToPackage()\"><span class=\"fa fa-reply\"></span> Regresar</button></div><div class=\"col-xs-12\"><div class=\"row margin-bottom-10\"><div class=\"col-xs-12 text-right\"></div></div><comments datasource=\"vm.comments_data\" typemodel=\"9\" config=\"vm.comments_config\" idmodel=\"vm.package_id\" exportable=\"true\"></comments></div></div></div></div></div></div></div></div>");
$templateCache.put("app/paquetes/paquetes_old.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Paquetes</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Paquetes</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title\"><h5>Agregar nuevos paquetes</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><form class=\"form-horizontal\" method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Nombre del paquete*</label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"packageName\" ng-model=\"vm.form.package_name\" required=\"\" type=\"text\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Proveedor*</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-model=\"vm.form.provider\" data-ng-options=\"provider.compania for provider in vm.providers track by provider.url\" ng-change=\"vm.changeProvider(vm.form.provider)\" required=\"\"><option value=\"\">Selecciona un proveedor</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Ramo*</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-model=\"vm.form.ramo\" data-ng-options=\"ramo.ramo_name for ramo in vm.ramos track by ramo.url\" ng-change=\"vm.changeRamo(vm.form.ramo)\" required=\"\"><option value=\"\">Selecciona un ramo</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Subramos*</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-model=\"vm.form.subramo\" data-ng-options=\"subramo.subramo_name for subramo in vm.subramos track by subramo.url\" required=\"\"><option value=\"\">Selecciona un subramo</option></select></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observaciones</label><div class=\"col-sm-10\"><textarea class=\"form-control\" name=\"description\" ng-model=\"vm.form.description\" type=\"text\"></textarea></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"form-group col-sm-12\"><button class=\"btn btn-white pull-right\" type=\"button\">Cancelar</button> <button class=\"btn btn-success pull-right margin-right-10\" ng-disabled=\"!vm.form.package_name\" type=\"submit\">Crear paquete</button></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title\"><h5>Agregar nueva cobertura</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><form class=\"form-horizontal\" method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form.name.$invalid && !form.name.$pristine }\"><label class=\"col-sm-2 control-label\">Nombre de la cobertura*</label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"coverage\" ng-model=\"vm.form.coverage_name\" required=\"\" type=\"text\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Proveedor</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"prov as prov.compania for prov in vm.providers\" ng-model=\"vm.form.coverage_provider\" ng-change=\"vm.changeCoverageProvider(vm.form.coverage_provider)\"><option value=\"\">Selecciona un proveedor</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Ramo</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"ramo.ramo_name for ramo in vm.coverage_ramos track by ramo.url\" ng-model=\"vm.form.coverage_ramo\" ng-change=\"vm.changeCoverageRamo(vm.form.coverage_ramo)\"><option value=\"\">Selecciona un ramo</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Subramo</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"subramo.subramo_name for subramo in vm.coverage_subramos track by subramo.url\" ng-model=\"vm.form.coverage_subramo\" ng-change=\"vm.changeCoverageSubramo(vm.form.coverage_subramo)\"><option value=\"\">Selecciona un subramo</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Paquete</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"paquete.package_name for paquete in vm.coverage_paquetes track by paquete.url\" ng-model=\"vm.form.coverage_paquete\"><option value=\"\">Selecciona un paquete</option></select></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button class=\"btn btn-primary\" ng-disabled=\"form.$invalid\" type=\"button\" ng-click=\"vm.createCoverage()\">Crear cobertura</button></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title\"><h5>Personalizar paquetes</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Proveedor</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"prov as prov.compania for prov in vm.providers\" ng-model=\"vm.form.package_provider\" ng-change=\"vm.changePackageProvider(vm.form.package_provider)\"><option value=\"\">Selecciona un proveedor</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Ramo</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"ramo.ramo_name for ramo in vm.package_ramos track by ramo.url\" ng-model=\"vm.form.package_ramo\" ng-change=\"vm.changePackageRamo(vm.form.package_ramo)\"><option value=\"\">Selecciona un ramo</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Subramo</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"subramo.subramo_name for subramo in vm.package_subramos track by subramo.url\" ng-model=\"vm.form.package_subramo\" ng-change=\"vm.changePackageSubramo(vm.form.package_subramo)\"><option value=\"\">Selecciona un subramo</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Paquete</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"paquete.package_name for paquete in vm.package_paquetes track by paquete.url\" ng-model=\"vm.form.package_paquete\" ng-change=\"vm.changePackagePackage(vm.form.package_paquete)\"><option value=\"\">Selecciona un paquete</option></select></div></div><div class=\"form-group\"><table class=\"table footable table-stripped\" data-filter=\"#filter\" data-page-size=\"25\" ng-if=\"vm.form.package_paquete\"><thead><tr class=\"col-xs-12\"><th class=\"text-align-center footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Cobertura</th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\"></th></tr></thead><tbody><tr class=\"col-xs-12 col-md-6\" ng-repeat=\"coverage in vm.package_covs\"><td class=\"col-xs-11\"><p class=\"col-xs-12\" ng-bind=\"coverage.coverage_name\"></p></td><td class=\"col-xs-6\"><button ng-if=\"coverage.default\" class=\"col-xs-12 btn btn-info pull-right\" name=\"button\" ng-click=\"vm.makeDefaultCoverage(coverage)\" type=\"button\">Desactivar</button> <button ng-if=\"!coverage.default\" class=\"col-xs-12 btn btn-warning pull-right\" name=\"button\" ng-click=\"vm.makeDefaultCoverage(coverage)\" type=\"button\">Activar</button></td></tr></tbody><tfoot class=\"hide-if-no-paging\"><tr><td colspan=\"6\" align=\"center\"><ul class=\"pagination\"></ul></td></tr></tfoot></table></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información de paquetes</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table footable table-stripped\" data-filter=\"#filter\" data-page-size=\"25\"><thead><tr><th class=\"footable-visible footable-sortable footable-first-column\">Paquetes <span class=\"footable-sort-indicator\"></span></th><th class=\"footable-sortable\" data-hide=\"phone\">Aseguradora <span class=\"footable-sort-indicator\"></span></th><th data-hide=\"phone\" class=\"footable-sortable\" style=\"display: none;\">Ramos <span class=\"footable-sort-indicator\"></span></th><th data-hide=\"phone\" class=\"footable-sortable\" style=\"display: none;\">Subramos <span class=\"footable-sort-indicator\"></span></th></tr></thead><tbody><tr ng-repeat=\"pack in vm.totalPackages track by $index\" ng-click=\"vm.goToPackageEditor(pack)\" foo-repeat-done=\"\"><td>{{pack.package_name}}</td><td>{{pack.provider}}</td><td>{{pack.ramo}}</td><td>{{pack.subramo}}</td></tr></tbody><tfoot class=\"hide-if-no-paging\"><tr><td colspan=\"6\" align=\"center\"><ul class=\"pagination\"></ul></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/polizas/add.emails.reminder_reminder.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Enviar a correo electrónico</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"row\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title\" align=\"center\">Recordatorio de renovación por correo electrónico</legend><div class=\"form-group col-xs-12\"><label for=\"selectType\">Elija una opción:</label><br><select class=\"form-control m-b\" ng-model=\"optionSent\" ng-options=\"item as item.label for item in optionsSent track by item.value\" ng-change=\"showAddEmails(optionSent)\"><option disabled=\"\" value=\"\">Selecciona una opción</option></select></div><legend class=\"legend-title legend-flex\" align=\"center\" ng-if=\"showAddEmail\"><button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"form.emails_reminder.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Correos electrónicos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addEmails(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addEmails(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div></div><div class=\"row\" ng-if=\"form.emails_reminder.length != 0\"><div class=\"row email-container\" ng-repeat=\"contact in form.emails_reminder track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\" ng-if=\"showAddEmail\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteEmails($index, 1)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteEmails($index, 1)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Correo electrónico #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addEmails(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addEmails(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 col-sm-12 form-group\" align=\"center\"><label>Correo electrónico</label> <input class=\"form-control\" type=\"search\" lowercase=\"\" ng-model=\"contact.email\"></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"sendReminder(form.emails_reminder,10)\">Enviar recordatorio</button></div></div><script type=\"text/javascript\">\n  // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n  // $(document).ready(function(){\n  //   $(\'#modal_email\').modal(\'hide\');\n  //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n  //       $(\'body\').removeClass(\'modal-open\'); \n  //       $(\'.modal-backdrop\').remove(); \n  //     };\n  //   });\n// });\n</script>");
$templateCache.put("app/polizas/add.receiptsModal.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Agregar Recibo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><h3>Estatus actual:</h3><div ng-bind=\"rec.status | receipts\" class=\"label\" ng-class=\"{\'label-success\': rec.status == 1 || rec.status == 5, \'label-danger\': rec.status == 2, \'label-warning\' : rec.status == 3 || rec.status == 4, \'label-default\': rec.status == 6 || rec.receipt.status == 7 || rec.status == 8}\"></div></div><div class=\"form-group col-xs-12\"><hr></div><div class=\"form-group col-xs-12 col-md-4\"><label ng-if=\"rec.tipo != 3\">Serie:</label> <label ng-if=\"rec.tipo == 3\">Folio:</label><input class=\"form-control\" ng-model=\"rec.recibo_numero\" type=\"text\"></div><div ng-if=\"rec.tipo != 3\" class=\"form-group col-xs-12 col-md-4\"><label ng-if=\"rec.tipo != 3\">Serie recibo manual ({{rec.recibo_numero}}/ ?):</label> <input class=\"form-control col-md-2\" ng-model=\"rec.serie_manual\" type=\"number\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Fecha de inicio</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-change=\"change_date(rec.fecha_inicio)\" ng-model=\"rec.fecha_inicio\" ng-value=\"{{rec.init}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Fecha de fin</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"rec.fecha_fin\" ng-value=\"{{rec.end}}\" data-date-format=\"dd/mm/yyyy\" ng-change=\"validateDates_1(rec.fecha_fin)\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Prima neta:</label> <input class=\"form-control\" step=\"0.01\" ng-value=\"0.00\" ng-model=\"rec.prima_neta\" type=\"text\" ng-change=\"validateDecimal(rec.prima_neta);changePrimas(rec)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label ng-if=\"recibo.receipt_type !=2\">RPF:</label> <label ng-if=\"recibo.receipt_type ==2\">Gastos de expedición:</label><input class=\"form-control\" ng-model=\"rec.rpf\" type=\"text\" ng-change=\"validateDecimal(rec.rpf);changePrimas(rec)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Derecho:</label> <input class=\"form-control\" ng-model=\"rec.derecho\" type=\"text\" ng-change=\"validateDecimal(rec.derecho);changePrimas(rec)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Subtotal:</label> <input class=\"form-control\" ng-model=\"rec.sub_total\" type=\"text\" ng-change=\"validateDecimal(rec.sub_total)\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Iva:</label> <input class=\"form-control\" ng-model=\"rec.iva\" type=\"text\" ng-change=\"changePrimas(rec)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Comisión:</label> <input class=\"form-control\" ng-model=\"rec.comision\" type=\"text\" ng-change=\"validateDecimal(rec.comision)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Prima Total:</label> <input class=\"form-control\" ng-model=\"rec.prima_total\" type=\"text\" ng-change=\"validateDecimal(rec.prima_total)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Vencimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"rec.vencimiento\" ng-value=\"{{rec.venc}}\" data-date-format=\"dd/mm/yyyy\" ng-change=\"validateDates_venc(rec.vencimiento)\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"saveRecibo(rec)\">Guardar Cambios</button></div></div>");
$templateCache.put("app/polizas/edit.receiptsModal.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Actualizar Recibo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><h3>Estatus actual:</h3><div ng-bind=\"rec.recibo.status | receipts\" class=\"label\" ng-class=\"{\'label-success\': rec.recibo.status == 1 || rec.recibo.status == 5, \'label-danger\': rec.recibo.status == 2, \'label-warning\' : rec.recibo.status == 3 || rec.recibo.status == 4, \'label-default\': rec.recibo.status == 6 || rec.receipt.status == 7 || rec.recibo.status == 8}\"></div></div><div class=\"form-group col-xs-12\"><hr></div><div class=\"form-group col-xs-12 col-md-4\"><label>Serie:</label> <input class=\"form-control\" ng-model=\"rec.recibo.recibo_numero\" type=\"text\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Fecha de inicio</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"rec.recibo.fecha_inicio\" ng-value=\"{{rec.recibo.init}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Fecha de fin</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"rec.recibo.fecha_fin\" ng-value=\"{{rec.recibo.end}}\" data-date-format=\"dd/mm/yyyy\" ng-change=\"validateDates_1(rec.recibo.fecha_fin)\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-md-4\"><label>Prima neta:</label> <input class=\"form-control\" step=\"0.01\" ng-value=\"0.00\" ng-model=\"rec.recibo.prima_neta\" type=\"text\" ng-change=\"validateDecimal(rec.recibo.prima_neta);changePrimas(rec.recibo)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label ng-if=\"recibo.receipt_type !=2\">RPF:</label> <label ng-if=\"recibo.receipt_type ==2\">Gastos de expedición:</label><input class=\"form-control\" ng-model=\"rec.recibo.rpf\" type=\"text\" ng-change=\"validateDecimal(rec.recibo.rpf);changePrimas(rec.recibo)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Derecho:</label> <input class=\"form-control\" ng-model=\"rec.recibo.derecho\" type=\"text\" ng-change=\"validateDecimal(rec.recibo.derecho);changePrimas(rec.recibo)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Subtotal:</label> <input class=\"form-control\" ng-model=\"rec.recibo.sub_total\" type=\"text\" ng-change=\"validateDecimal(rec.recibo.sub_total)\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Iva:</label> <input class=\"form-control\" ng-model=\"rec.recibo.iva\" type=\"text\" ng-change=\"changePrimas(rec.recibo)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Comisión:</label> <input class=\"form-control\" ng-model=\"rec.recibo.comision\" type=\"text\" ng-change=\"validateDecimal(rec.recibo.comision)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Prima Total:</label> <input class=\"form-control\" ng-model=\"rec.recibo.prima_total\" type=\"text\" ng-change=\"validateDecimal(rec.recibo.prima_total)\"></div><div class=\"form-group col-xs-12 col-md-4\"><label>Vencimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"rec.recibo.vencimiento\" ng-value=\"{{rec.recibo.venc}}\" data-date-format=\"dd/mm/yyyy\" ng-change=\"validateDates_venc(rec.recibo.vencimiento)\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"saveEdicionRecibo(rec.recibo)\">Guardar Cambios</button></div></div>");
$templateCache.put("app/polizas/poliza.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Cancelar Póliza</h4></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"form-group col-sm-12\"><label for=\"selectType\">Elija una opción:</label><br><select class=\"form-control m-b\" ng-model=\"optionCancel\" ng-options=\"item as item.label for item in optionsCancel track by item.value\"><option disabled=\"\" value=\"\">Selecciona una opción</option></select></div><div class=\"form-group col-sm-12\"><label for=\"motivo\">Motivo de cancelación: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"motivo\" ng-model=\"vm.insurance.reason_cancel\" class=\"form-control\"></div><div class=\"form-group col-sm-12\" ng-if=\"(optionCancel.value == 3 || optionCancel.value == \'3\') || (optionCancel.value == 4 || optionCancel.value == \'4\')\"><label for=\"datecancel\">Fecha de cancelación: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"date_cancel\" value=\"{{date_cancel}}\" ng-disabled=\"!date_cancel\" data-date-format=\"mm/dd/yyyy\" ng-init=\"date_cancel\" ng-change=\"checkCancelDate(date_cancel)\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 checkbox\" align=\"center\" ng-if=\"(optionCancel.value == 3 || optionCancel.value == \'3\') || (optionCancel.value == 4 || optionCancel.value == \'4\')\"><label><input type=\"checkbox\" ng-model=\"addnotasToCancel\" ng-change=\"addnotasToCancelF(addnotasToCancel)\">DESEA CANCELAR NOTAS DE CREDITO PENDIENTE DE PAGO</label></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"close()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success ladda-button\" ng-disabled=\"!vm.insurance.reason_cancel\" ng-click=\"cancelPolicy(optionCancel, vm.insurance.reason_cancel,date_cancel, addnotasToCancel)\" type=\"button\">Cancelar Póliza</button></div>");
$templateCache.put("app/polizas/polizas.assign.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Compartir {{tipopoliza}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!vm.show_binnacle\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Compartir a la App\" id=\"app\" ng-if=\"soloEmail\"><div class=\"panel-body\"><div><h4>Por favor ingrese el correo electrónico a quien se desea asignar:</h4><div class=\"form-group\"><label>Correo electrónico<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"email_assign\" ng-model=\"email_assign\" type=\"email\" required=\"\"> <input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{email}}\" ng-show=\"owner_exist\" ng-click=\"showEmailInInput(email)\"><div ng-repeat=\"em in emailscontractor track by $index\"><input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{em.correo}}\" ng-show=\"owner_exist\" ng-click=\"showEmailInInput(em.correo,0)\"></div><div ng-show=\"owner_exist\"><input type=\"checkbox\" name=\"is_owner\" ng-model=\"vmm.is_owner\"> <label>Es el usuario principal?</label><br></div></div><div class=\"form-group\"><br><label>Compartido con:</label><table class=\"table table-bordered\"><thead><th width=\"80%\">Correo electrónico</th><th width=\"20%\">Acciones</th></thead><tr ng-repeat=\"people in people_assigned\"><td>{{people.email}}{{people.user}}<span ng-if=\"people.is_owner\" class=\"label ng-binding label-success\">Asegurado</span></td><td><span class=\"label ng-binding label-danger\" style=\"cursor: pointer;\" ng-click=\"deleteEmail(people)\">Eliminar</span></td></tr></table></div><table class=\"table table-bordered\" ng-if=\"permiso_administrar_adjuntos\"><br><h3><span><i>Archivos a compartir</i></span></h3><thead><tr><th>Archivo</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td ng-if=\"file.origin==\'P\'\"><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"vmFiles.rename(file)\"></td><td ng-if=\"file.origin==\'P\'\"><div class=\"col-md-4\"><input type=\"checkbox\" ng-model=\"file.shared\" ng-change=\"shareFile(file)\"> <label>Compartir</label></div><div class=\"col-md-4\"><a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a></div></td></tr></tbody></table><div><button class=\"btn btn-primary pull-right ladda-button\" ng-click=\"assignPolicy(email_assign)\">Compartir a la App</button></div></div></div></uib-tab><uib-tab heading=\"Compartir por Email\" id=\"email\" ng-click=\"getTemplate(true)\"><div class=\"panel-body\"><div><h4>Por favor ingrese el o los correo(s) electrónico(s) a quien se desea enviar un email:</h4><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Correo electrónico<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"email\" name=\"email_assign_mail\" ng-model=\"vmm.email_assign_mail\" required=\"\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"addEmail(vmm.email_assign_mail)\">Agregar</button></div></div><input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{email}}\" ng-show=\"owner_exist\" ng-click=\"addEmail(email)\"> <input class=\"btn btn-white btn-mt\" ng-repeat=\"correo in vmm.correos\" type=\"button\" name=\"\" value=\"{{correo.correo}}\" ng-click=\"addEmail(correo.correo)\"></div></div><div class=\"col-xs-12 form-group\" ng-if=\"contratanteInfo.description\"><span class=\"blue-color\">Observaciones del contratante:</span><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"contratanteInfo.description\"><span>{{ contratanteInfo.description }}</span></div></div></div><table ng-if=\"files && files.length && permiso_administrar_adjuntos\" class=\"table table-bordered\"><br><h3><span><i>Seleccione los archivos que desea compartir:</i></span></h3><thead><tr><th>Archivo</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong><br><span ng-if=\"parseMb(file.size) >= maxShareMb\" class=\"color-red\">Archivo demasiado grande para ser compartido</span></td><td><div class=\"col-md-4\"><input type=\"checkbox\" ng-model=\"file.shared_email\" ng-change=\"shareFileEmail(file)\" ng-disabled=\"parseMb(file.size) >= maxShareMb\"> <label>Compartir</label></div><div class=\"col-md-4\"><a class=\"btn btn-primary pull-right\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a></div></td></tr></tbody></table><div class=\"form-group\"><br><label>Se enviara a:</label><table class=\"table table-bordered\"><thead><th>Correo electrónico</th><th>Acciones</th></thead><tr ng-repeat=\"email in emails track by $index\"><td>{{email}}</td><td><button class=\"btn btn-danger\" ng-click=\"remove_email($index)\"><i class=\"fa fa-trash\"></i></button></td></tr></table></div></div><div class=\"form-group col-xs-12\"><label>Plantillas de Póliza:</label><select class=\"form-control\" ng-options=\"item.name for item in plantillas\" ng-change=\"changePlantilla(plantilla)\" ng-model=\"plantilla\"><option value=\"\">Selecciona una plantilla</option></select></div><div class=\"form-group col-xs-12\"><br></div><div class=\"form-group col-xs-12\" ng-if=\"vmm.custom_email\"><div class=\"form-group col-xs-12\"><label>Asunto:</label> <input class=\"col-xs-12 form-control\" type=\"text\" name=\"\" ng-model=\"vmm.subjectEmail\" ng-blur=\"emptySubject(vmm.subjectEmail)\"></div><div text-angular=\"\" ng-model=\"vmm.first_comment\" name=\"first_comment\"></div><br><div ng-bind-html=\"vmm.body\" name=\"body\"></div><div text-angular=\"\" ng-model=\"vmm.second_comment\" name=\"second_comment\"></div><br><div ng-bind-html=\"vmm.footer\" name=\"footer\"></div></div><div><button class=\"btn btn-primary pull-right ladda-button\" ng-disabled=\"!emails.length > 0 || !send\" ng-click=\"sendEmail(people_assigned)\">Compartir por Email</button></div></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div><script>\n    function renombrarArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n      strongTag.hide();\n      inputTag.show();\n      inputTag.focus();\n    }\n\n    function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target);\n\n      strongTag.show();\n      inputTag.hide();\n    }\n  </script><style type=\"text/css\">\n  .to_send = {\n    background-color: red;\n  }\n</style>");
$templateCache.put("app/polizas/polizas.assign_certificate.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Asignar Certificado</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!vm.show_binnacle\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Compartir a la App\" id=\"app\" ng-click=\"\"><div class=\"panel-body\"><div><h4>Por favor ingrese el correo electrónico a quien se desea asignar:</h4><div class=\"form-group\"><label>Correo electrónico<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"email_assign\" ng-model=\"email_assign\" type=\"email\" required=\"\"> <input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{email}}\" ng-show=\"owner_exist\" ng-click=\"showEmailInInput(email)\"><div ng-repeat=\"em in emailscontractor track by $index\"><input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{em.correo}}\" ng-show=\"owner_exist\" ng-click=\"showEmailInInput(em.correo,0)\"></div><div ng-show=\"owner_exist\"><input type=\"checkbox\" name=\"is_owner\" ng-model=\"vmm.is_owner\"> <label>Es el usuario principal?</label><br></div></div><div class=\"form-group\"><br><label>Compartido con:</label><table class=\"table table-bordered\"><thead><th width=\"80%\">Correo electrónico</th><th width=\"20%\">Acciones</th></thead><tr ng-repeat=\"people in people_assigned\"><td>{{people.email}}{{people.user}} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span ng-if=\"people.is_owner\" class=\"label ng-binding label-success\">Asegurado</span></td><td><span class=\"label ng-binding label-danger\" style=\"cursor: pointer;\" ng-click=\"deleteEmail(people)\">Eliminar</span></td></tr></table></div><table class=\"table table-bordered\"><br><h3><span><i>Archivos a compartir</i></span></h3><thead><tr><th>Archivo</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td ng-if=\"file.origin==\'P\'\"><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"vmFiles.rename(file)\"></td><td ng-if=\"file.origin==\'P\'\"><div class=\"col-md-4\"><input type=\"checkbox\" ng-model=\"file.shared\" ng-change=\"shareFile(file)\"> <label>Compartir</label></div><div class=\"col-md-4\"><a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a></div></td></tr></tbody></table><div><button class=\"btn btn-primary pull-right ladda-button\" ng-click=\"assignPolicy(email_assign)\">Compartir a la App</button></div></div></div></uib-tab><uib-tab heading=\"Compartir por Email\" id=\"email\" ng-click=\"getTemplate(true)\"><div class=\"panel-body\"><div><h4>Por favor ingrese el o los correo(s) electrónico(s) a quien se desea enviar un email:</h4><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Correo electrónico<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" type=\"email\" name=\"email_assign_mail\" ng-model=\"vmm.email_assign_mail\" required=\"\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"addEmail(vmm.email_assign_mail)\">Agregar</button></div></div><input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{email}}\" ng-show=\"owner_exist\" ng-click=\"addEmail(email)\"> <input class=\"btn btn-white btn-mt\" ng-repeat=\"correo in vmm.correos\" type=\"button\" name=\"\" value=\"{{correo.correo}}\" ng-click=\"addEmail(correo.correo)\"></div></div><table ng-if=\"files && files.length\" class=\"table table-bordered\"><br><h3><span><i>Seleccione los archivos que desea compartir:</i></span></h3><thead><tr><th>Archivo</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong></td><td><div class=\"col-md-4\"><input type=\"checkbox\" ng-model=\"file.shared_email\" ng-change=\"shareFileEmail(file)\"> <label>Compartir</label></div><div class=\"col-md-4\"><a class=\"btn btn-primary pull-right\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a></div></td></tr></tbody></table><div class=\"form-group\"><br><label>Se enviara a:</label><table class=\"table table-bordered\"><thead><th>Correo electrónico</th><th>Acciones</th></thead><tr ng-repeat=\"email in emails track by $index\"><td>{{email}}</td><td><button class=\"btn btn-danger\" ng-click=\"remove_email($index)\"><i class=\"fa fa-trash\"></i></button></td></tr></table></div></div><div class=\"form-group col-xs-12\"><br></div><div class=\"form-group col-xs-12\"><label>Plantillas de Certificado:</label><select class=\"form-control\" ng-options=\"item.name for item in plantillas\" ng-change=\"changePlantilla(plantilla)\" ng-model=\"plantilla\"><option value=\"\">Selecciona una plantilla</option></select></div><div class=\"form-group col-xs-12\" ng-if=\"vmm.custom_email\"><div class=\"form-group col-xs-12\"><label>Asunto:</label> <input class=\"col-xs-12 form-control\" type=\"text\" name=\"\" ng-model=\"vmm.subjectEmail\" ng-blur=\"emptySubject(vmm.subjectEmail)\"></div><div text-angular=\"\" ng-model=\"vmm.first_comment\" name=\"first_comment\"></div><br><div ng-bind-html=\"vmm.body\" name=\"body\"></div><div text-angular=\"\" ng-model=\"vmm.second_comment\" name=\"second_comment\"></div><br><div ng-bind-html=\"vmm.footer\" name=\"footer\"></div></div><div><button class=\"btn btn-primary pull-right ladda-button\" ng-disabled=\"!emails.length > 0 || !send\" ng-click=\"sendEmail(people_assigned)\">Compartir por Email</button></div></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div><script>\n      function renombrarArchivoCargado(){\n        var strongTag = $(event.target).parent().parent().find(\"td strong\");\n        var inputTag = $(event.target).parent().parent().find(\"td input\");\n  \n        strongTag.hide();\n        inputTag.show();\n        inputTag.focus();\n      }\n  \n      function blurArchivoCargado(){\n        var strongTag = $(event.target).parent().parent().find(\"td strong\");\n        var inputTag = $(event.target);\n  \n        strongTag.show();\n        inputTag.hide();\n      }\n    </script><style type=\"text/css\">\n    .to_send = {\n      background-color: red;\n    }\n  </style>");
$templateCache.put("app/polizas/polizas.cancel.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Eliminar</h4></div><div class=\"modal-body\" ng-if=\"is_policy\"><p></p><h1>¿Está seguro que desea cancelar esta póliza?</h1><br\\>Todos los recibos que no se hayan pagado quedaran cancelados<p></p></br\\></div><div class=\"modal-body\" ng-if=\"!is_policy\"><p></p><h1>¿Está seguro que desea cancelar esta OT?</h1><p></p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">No</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Sí</button></div></div>");
$templateCache.put("app/polizas/polizas.certificateMasivoEmail.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">{{titulo}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!vm.show_binnacle\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Compartir por Email\" id=\"email\" ng-click=\"getTemplate(true)\"><div class=\"panel-body\"><div class=\"form-group col-xs-12\"><br></div><hr><div class=\"form-group col-xs-12\"><label>Plantillas de Certificado:</label><select class=\"form-control\" ng-options=\"item.name for item in plantillas\" ng-change=\"changePlantilla(plantilla)\" ng-model=\"plantilla\"><option value=\"\">Selecciona una plantilla</option></select></div><hr><div class=\"form-group col-xs-12\" ng-if=\"vmm.custom_email\"><div class=\"form-group col-xs-12\"><label>Asunto:</label> <input class=\"col-xs-12 form-control\" type=\"text\" name=\"\" ng-model=\"vmm.subjectEmail\" ng-blur=\"emptySubject(vmm.subjectEmail)\"></div><div text-angular=\"\" ng-model=\"vmm.first_comment\" name=\"first_comment\"></div><br><div ng-bind-html=\"vmm.body\" name=\"body\"></div><div text-angular=\"\" ng-model=\"vmm.second_comment\" name=\"second_comment\"></div><br><div ng-bind-html=\"vmm.footer\" name=\"footer\"></div></div><div><button class=\"btn btn-primary pull-right ladda-button\" ng-if=\"sendOnlyEmail\" ng-click=\"sendEmailMasivo()\">Compartir por Email</button> <button class=\"btn btn-primary pull-right ladda-button\" ng-if=\"!sendOnlyEmail\" ng-click=\"sendEmailMasivoApp()\">Compartir por App/Email</button></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div><script>\n      function renombrarArchivoCargado(){\n        var strongTag = $(event.target).parent().parent().find(\"td strong\");\n        var inputTag = $(event.target).parent().parent().find(\"td input\");\n  \n        strongTag.hide();\n        inputTag.show();\n        inputTag.focus();\n      }\n  \n      function blurArchivoCargado(){\n        var strongTag = $(event.target).parent().parent().find(\"td strong\");\n        var inputTag = $(event.target);\n  \n        strongTag.show();\n        inputTag.hide();\n      }\n    </script><style type=\"text/css\">\n    .to_send = {\n      background-color: red;\n    }\n  </style>");
$templateCache.put("app/polizas/polizas.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2 ng-if=\"order.show.isPolicy && order.acceso_adm_pol\">Pólizas</h2><h2 ng-if=\"!order.show.isPolicy && order.acceso_adm_ot\">OT</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"polizas.table\">Pólizas</a></li><li><a ui-sref=\"polizas.info({polizaId: order.insuranceObject.id})\"><span ng-if=\"order.show.isPolicy && order.acceso_adm_pol\">Póliza #{{order.insuranceObject.poliza_number}}</span> <span ng-if=\"!order.show.isPolicy && order.acceso_adm_ot\">Orden</span></a></li><li class=\"active\"><strong ng-if=\"order.show.isPolicy && order.acceso_adm_pol\">Editar póliza #{{order.insuranceObject.poliza_number}}</strong> <strong ng-if=\"!order.show.isPolicy && order.acceso_adm_ot\">Editar OT</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"order.show.isPolicy && order.acceso_adm_pol\">Editar póliza</h5><h5 ng-if=\"!order.show.isPolicy && order.acceso_adm_ot\">Editar OT</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div ng-include=\"\'app/ordenes/ordenes.generic.old.html\'\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"order.show.isPolicy && order.acceso_adm_pol\"><button type=\"button\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"validatePolicy(\'poliza\')\" data-style=\"expand-right\">Guardar cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"!order.show.isPolicy && order.acceso_adm_ot\"><button type=\"button\" class=\"col-xs-12 btn btn-success ladda-button-ot\" ng-click=\"validatePolicy(\'ot\')\" data-style=\"expand-right\">Guardar cambios OT</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button type=\"button\" class=\"col-xs-12 btn btn-danger margin-right-10\" ng-click=\"order.save.cancel()\">Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/polizas/polizas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Polizas</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Pólizas</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Agregar nueva póliza</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.error\">{{vm.error}}</div><form class=\"form-horizontal\" method=\"post\" name=\"form\" ng-submit=\"vm.submit(form.$valid)\" novalidate=\"\" role=\"form\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Contratantes</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" name=\"contratante\" ng-model=\"vm.form.contratante\"><option ng-repeat=\"contratante in vm.contratantes track by contratante.url\" value=\"{{contratante.url}}\">{{contratante.full_name}} {{contratante.j_name}} -- {{contratante.type_person}}</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Folio de OT</label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"folio\" ng-model=\"vm.form.folio\" type=\"text\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Número de Póliza</label><div class=\"col-sm-10\"><input class=\"form-control\" name=\"poliza\" ng-model=\"vm.form.poliza\" type=\"text\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Aseguradora<span class=\"color-red\">*</span></label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-model=\"vm.form.aseguradora\" data-ng-options=\"provider.compania for provider in vm.providers track by provider.url\" ng-change=\"vm.changeProvider(vm.form.aseguradora)\" required=\"\"><option value=\"\">Selecciona un proveedor</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Ramo<span class=\"color-red\">*</span></label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-model=\"vm.form.ramo\" data-ng-options=\"ramo.ramo_name for ramo in vm.ramos track by ramo.url\" ng-change=\"vm.changeRamo(vm.form.ramo)\" required=\"\"><option value=\"\">Selecciona un ramo</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Subramos<span class=\"color-red\">*</span></label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-model=\"vm.form.subramo\" data-ng-options=\"subramo.subramo_name for subramo in vm.subramos track by subramo.url\" ng-change=\"vm.changeSubramo(vm.form.subramo)\" required=\"\"><option value=\"\">Selecciona un subramo</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Paquetes<span class=\"color-red\">*</span></label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-model=\"vm.form.paquete\" data-ng-options=\"package.package_name for package in vm.packages track by package.url\" ng-change=\"vm.changePackage(vm.form.paquete)\" required=\"\"><option value=\"\">Selecciona un paquete</option></select></div></div><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-10 col-md-offset-2\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Coberturas</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table footable table-stripped\" data-filter=\"#filter\" data-page-size=\"25\"><thead><tr><th class=\"footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Cobertura</th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\">Suma asegurada</th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\">Deducible</th><th data-hide=\"phone\" class=\"footable-sortable\" style=\"display: none;\">Prima</th><th data-hide=\"phone\" class=\"footable-sortable\" style=\"display: none;\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.coverages track by $index\" foo-repeat-done=\"\"><td><p ng-bind=\"coverage.coverage_name\"></p></td><td><select class=\"form-control m-b\" ng-model=\"coverage.sumInPolicy\" data-ng-options=\"sum.sum_insured for sum in coverage.sums_coverage track by sum.url\"><option value=\"\">0</option></select></td><td><select class=\"form-control m-b\" ng-model=\"coverage.deductibleInPolicy\" data-ng-options=\"deductible.deductible for deductible in coverage.deductible_coverage track by deductible.url\"><option value=\"\">0</option></select></td><th><input class=\"form-control\" ng-model=\"coverage.primaInPolicy\"></th><th><button type=\"button\" class=\"btn btn-w-m btn-danger\" name=\"button\" ng-click=\"vm.deleteCoverage(coverage, $index)\">Eliminar</button></th></tr></tbody><tfoot class=\"hide-if-no-paging\"><tr><td colspan=\"6\" align=\"center\"><ul class=\"pagination\"></ul></td></tr></tfoot></table></div></div></div></div></div></div><div class=\"form-group\" id=\"data_2\"><label class=\"col-sm-2 control-label\">Fecha de Inicio</label><div class=\"col-sm-10\"><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" name=\"startDate\" ng-model=\"vm.form.startDate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div></div><div class=\"form-group\" id=\"data_2\"><label class=\"col-sm-2 control-label\">Fecha de Fin</label><div class=\"col-sm-10\"><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" name=\"endingDate\" ng-model=\"vm.form.endingDate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div></div><div class=\"form-group\" ng-hide=\"vm.show.ot\"><label class=\"col-sm-2 control-label\">Forma de pago</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" name=\"payment\" ng-model=\"vm.form.payment\"><option ng-repeat=\"payment in vm.payments\" value=\"{{payment.code}}\">{{payment.name}}</option></select></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-8 col-sm-offset-2\"><button class=\"btn btn-primary\" ng-disabled=\"form.$invalid\" ng-show=\"vm.show.ot\" ng-click=\"vm.hideOT()\">Crear OT</button> <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"form.$invalid\" ng-hide=\"vm.show.ot\" ng-click=\"vm.saveOT()\">Guardar OT</button> <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"form.$invalid\" ng-hide=\"vm.show.ot\" ng-click=\"vm.openModal()\">Crear recibo</button> <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"form.$invalid\" ng-show=\"!vm.show.ot\" ng-click=\"vm.saveInsurance()\">Crear póliza</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/polizas/polizas.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading page-heading--modern\"><div class=\"col-lg-12\"><div class=\"page-heading__top\"><h2 class=\"page-heading__title\" ng-if=\"vm.show.isPolicy && !vm.insurance.folio_endorsement\">Pólizas <span class=\"page-heading__badge\" ng-if=\"vm.insurance.poliza_number\">#{{vm.insurance.poliza_number}}</span></h2><h2 class=\"page-heading__title\" ng-if=\"!vm.show.isPolicy && !vm.insurance.folio_endorsement\">OT</h2><h2 class=\"page-heading__title\" ng-if=\"vm.insurance.folio_endorsement\">Endosos</h2></div><ol class=\"breadcrumb page-heading__breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"polizas.table\">Listado de Pólizas</a></li><li class=\"active\" aria-current=\"page\"><strong ng-if=\"vm.show.isPolicy && !vm.insurance.folio_endorsement\">Póliza</strong> <strong ng-if=\"!vm.show.isPolicy && !vm.insurance.folio_endorsement\">Orden</strong> <strong ng-if=\"vm.insurance.folio_endorsement\">Endoso</strong></li></ol></div></div><br><div class=\"btn-group pull-right m-b option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_ver_cont\"><a ng-click=\"vm.viewContractor(\'Información contratante\',\'contratantes.info\')\">Ver información del cliente</a></li><li><a ng-click=\"vm.saveAsInsurance(vm.insurance)\" ng-if=\"vm.insurance.status < 10 && vm.insurance.status != 4 && vm.acceso_adm_pol\">Convertir a póliza</a></li><li ng-if=\"vm.acceso_adm_ot && vm.acceso_adm_pol\"><a ui-sref=\"polizas.editar({polizaId: vm.polizaId})\">Editar</a></li><li><a ng-click=\"vm.openRenovateModal(\'Renovación\', \'renovaciones.polizas\')\" ng-if=\"vm.insurance.status != 12 && vm.insurance.status != 15 && vm.insurance.is_renewable == 1 && (vm.acceso_adm_pol && (vm.insurance.status != 1 && vm.insurance.status !=2))\">Renovar</a></li><li><a ng-click=\"vm.cancelRenovate(vm.insurance)\" ng-if=\"vm.insurance.status != 12 && vm.insurance.status != 15 && vm.insurance.is_renewable == 1 && (vm.acceso_adm_pol && vm.insurance.status !=1 && vm.insurance.status != 2)\">No renovar</a></li><li ng-if=\"vm.acceso_adm_ot\"><a ng-click=\"ShowContextMenu(\'Endoso\',\'endorsement.endorsement\')\" ng-if=\"vm.insurance.status >= 10\">Crear endoso</a></li><li ng-if=\"vm.acceso_adm_sin && vm.insurance.subramo == \'Vida\'\" ng-click=\"createSiniestro(contractorModal)\"><a>Crear siniestro</a></li><li class=\"dropdown-submenu\"><a ng-if=\"vm.acceso_adm_sin && vm.insurance.ramo == \'Accidentes y Enfermedades\'\">Crear siniestro</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li><a ng-click=\"goToSiniester(\'\', 1,\'Siniestros\', \'siniestros.accidentes\')\">Por Titular</a></li><li class=\"dropdown-submenu\"><a>Por Dependiente</a><ul class=\"dropdown-menu\" style=\"float: static; top: 0; left: -160px;\"><li ng-repeat=\"relationship in vm.insurance.accidents_policy[0].relationship_accident\"><a ng-click=\"goToSiniester(relationship, 2,\'Siniestros\', \'siniestros.accidentes\')\">{{relationship.first_name}} {{relationship.last_name}}</a></li></ul></li></ul></li><li ng-if=\"vm.acceso_adm_rehabilitar && (vm.insurance.status == 2 || vm.insurance.status == 11)\"><a ng-click=\"vm.reActivatePolicy(vm.insurance.id, vm.insurance.poliza_number)\">Rehabilitar Póliza/OT</a></li><li ng-if=\"vm.acceso_adm_rehabilitar && (vm.insurance.status == 15)\"><a ng-click=\"renovarPolizaRehabilitate(vm.insurance.id, vm.insurance.poliza_number)\">Rehabilitar Póliza/OT para Renovar</a></li><li ng-if=\"vm.acceso_adm_sin && vm.insurance.subramo == \'Automóviles\'\" ng-click=\"createSiniester(\'Siniestros\',\'siniestros.create_autos\')\"><a>Crear siniestro</a></li><li ng-if=\"vm.acceso_adm_sin\"><a ng-if=\"vm.insurance.subramo != \'Automóviles\' && vm.insurance.ramo == \'Daños\'\" ng-click=\"createSiniestroDanios(contractorModal)\">Crear siniestro</a></li><li ng-if=\"vm.acceso_cor && vm.acceso_adm_pol\"><a ng-click=\"vm.assignPolicy(vm.insurance.id)\" ng-if=\"vm.insurance.status > 9 && assign_policy\">Compartir</a></li><li><a ng-click=\"vm.getPDF(vm.insurance.id)\">Ver PDF</a></li><li><a ng-click=\"vm.sendProvider(vm.insurance)\" ng-hide=\"vm.insurance.status == 11\" ng-if=\"(vm.insurance.status<9 && vm.insurance.status != 4)\">Enviar PDF a la compañia</a></li><li ng-if=\"vm.acceso_adm_ot && (vm.insurance.status ==1 || vm.insurance.status == 2)\"><a ng-click=\"vm.reactivePolicy()\" ng-hide=\"vm.insurance.status != 4\" ng-if=\"vm.insurance.status == 4\">Reactivar Póliza/OT</a></li><li ng-if=\"vm.acceso_adm_pol && (vm.insurance.status !=1 && vm.insurance.status != 2)\"><a ng-click=\"vm.reactivePolicy(vm.insurance.id)\" ng-hide=\"vm.insurance.status != 4\" ng-if=\"vm.insurance.status == 4\">Reactivar Póliza/OT</a></li><li ng-if=\"vm.acceso_mns && vm.acceso_adm_pol\"><a ng-click=\"vm.delivery(vm.insurance)\">Programar mensajería</a></li><li ng-if=\"vm.acceso_mns && vm.acceso_adm_pol\"><a ng-click=\"getAllCertificates(vm.insurance)\">Todos los certificados</a></li><li><a ng-click=\"vm.cancelPolicy(vm.insurance.id)\" ng-if=\"(vm.insurance.status > 9 || vm.insurance.status == 4) && vm.insurance.status != 11 && vm.acceso_canc_pol\">Cancelar póliza</a></li><li><a ng-click=\"vm.cancelPolicy()\" ng-hide=\"vm.insurance.status == 11\" ng-if=\"vm.acceso_canc_ot && (vm.insurance.status<9 && vm.insurance.status != 4) && vm.acceso_canc_pol\">Cancelar OT</a></li><li ng-if=\"vm.acceso_elim_pol && (vm.insurance.status > 9 || vm.insurance.status == 4)\"><a ng-click=\"vm.deletePolicy(vm.insurance.id)\">Eliminar</a></li><li ng-if=\"vm.acceso_elim_ot && (vm.insurance.status == 1 || vm.insurance.status == 2)\"><a ng-click=\"vm.deletePolicy(vm.insurance.id)\">Eliminar</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, carta)\">{{carta.name}}</a></li></ul></li></ul></div><div class=\"row\" ng-if=\"vm.infoFlag\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 ng-if=\"vm.show.isPolicy || vm.insurance.folio_endorsement\">Información de la póliza</h5><h5 ng-if=\"!vm.show.isPolicy && !vm.insurance.folio_endorsement\">Información de la OT</h5><button class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"vm.getLog()\"><i class=\"fa fa-history\">Log</i></button> <button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"vm.createRecordatorio(vm.insurance,1)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"col-xs-12 form-group\"><span class=\"blue-color\"><b>Nombre</b>:</span><div><span>{{ contratante.full_name }} {{ contratante.j_name }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">RFC:</span><div><span>{{ contratante.rfc }}</span></div></div><div class=\"col-xs-12 col-md-6 form-group\"><span class=\"blue-color\">Grupo:</span><div>{{ contratante.group }}</div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"contratante.subgrupo\"><span class=\"blue-color\">SubGrupo:</span><div>{{ contratante.subgrupo }}</div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"contratante.subsubgrupo\"><span class=\"blue-color\">SubsubGrupo:</span><div>{{ contratante.subsubgrupo }}</div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"contratante.grouping_level && campo_agrupacion\"><span class=\"blue-color\">Nivel de Agrupación:</span><div>{{ contratante.grouping_level }}</div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"contratante.subgrouping && campo_agrupacion\"><span class=\"blue-color\">SubAgrupación:</span><div>{{ contratante.subgrouping }}</div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"contratante.subsubgrouping && campo_agrupacion\"><span class=\"blue-color\">Subsub Agrupación:</span><div>{{ contratante.subsubgrouping }}</div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"contratante.celula && campo_celula\"><span class=\"blue-color\">{{moduleName}}:</span><div>{{ contratante.celula }}</div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"contratante.classification\"><span class=\"blue-color\">Clasificación:</span><div>{{ contratante.classification }}</div></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.insurance.address\"><span class=\"blue-color\">Dirección:</span><div><span ng-if=\"vm.insurance.address.route\">{{ vm.insurance.address.route }}</span> <span ng-if=\"vm.insurance.address.street_number && !vm.insurance.address.street_number_int\">{{ vm.insurance.address.street_number }},</span> <span ng-if=\"vm.insurance.address.street_number && vm.insurance.address.street_number_int\">{{ vm.insurance.address.street_number }}</span> <span ng-if=\"vm.insurance.address.street_number_int\">Int.{{ vm.insurance.address.street_number_int }},</span> <span ng-if=\"vm.insurance.address.sublocality\">{{ vm.insurance.address.sublocality }}</span><div><span ng-if=\"vm.insurance.address.administrative_area_level_2\">{{ vm.insurance.address.administrative_area_level_2 }}</span> <span ng-if=\"vm.insurance.address.administrative_area_level_1\">, {{ vm.insurance.address.administrative_area_level_1 }}</span> <span ng-if=\"vm.insurance.address.postal_code\">C.P.: {{ vm.insurance.address.postal_code }}</span> <span ng-if=\"!vm.insurance.address.postal_code\">, C.P.: N/A</span></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Teléfono:</span><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"contratante.phone_number\"><span class=\"fa fa-home\" aria-hidden=\"true\"></span> <span>{{contratante.phone_number | phonenumber}}</span></div><div class=\"col-xs-12\" ng-repeat=\"phone_number in contratante.phone_contractor\"><span ng-if=\"phone_number.phone_type == 1\" class=\"fa fa-home\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 2\" class=\"fa fa-building\" aria-hidden=\"true\"></span> <span ng-if=\"phone_number.phone_type == 3\" class=\"fa fa-mobile\" aria-hidden=\"true\"></span> <span>{{phone_number.phone | phonenumber}}</span></div><div class=\"col-xs-12\" ng-if=\"contratante.phone_mensajeria\"><br><span class=\"blue-color\">WhatsApp/SMS</span><br><span class=\"fa fa-whatsapp\" aria-hidden=\"true\"></span> <span>{{contratante.phone_mensajeria}}</span></div></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Correo electrónico:</span><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"contratante.email\"><span class=\"fa fa-envelope\" aria-hidden=\"true\"></span> <span ng-if=\"email\">{{ email }}</span> <span class=\"red-color\" ng-if=\"!email\">{{ no_email }}</span></div><div class=\"col-xs-12\" ng-repeat=\"correo in contratante.email_contractor\"><span class=\"fa fa-envelope\" aria-hidden=\"true\"></span> <span>{{correo.correo}}</span></div></div></div><div class=\"col-xs-12 form-group\" ng-if=\"contratante.contact_contractor.length\"><span class=\"blue-color\">Contactos</span><div ng-repeat=\"contact in contratante.contact_contractor\"><span>{{ contact.name }}</span><br><span>{{ contact.email }}</span><br><span>{{ contact.phone_number }}</span></div></div><div class=\"col-xs-12 form-group\" ng-if=\"contratante.vip\"><span class=\"blue-color\">VIP</span></div><div class=\"col-xs-12 form-group\" ng-if=\"contratante.description\"><span class=\"blue-color\">Observaciones:</span><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"contratante.description\"><span>{{ contratante.description }}</span></div></div></div><br><div class=\"col-xs-12 col-lg-10 col-md-10 form-group\" ng-if=\"vm.insurance.status == 13 && !vm.insurance.renewed && vm.acceso_cor\"><br><button class=\"btn btn-white btn-sm\" ng-click=\"addEmailsConfirm(insurance, 10)\"><i class=\"fa fa-envelope\"></i> Enviar recordatorio de renovación</button></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.acceso_adm_sin\"><button type=\"button\" class=\"btn btn-info m-r-sm\" ng-click=\"vm.showSinisters(vm.insurance)\" ng-disabled=\"vm.conteos.siniestros == 0 || !view_siniestros\">{{vm.conteos.siniestros}}</button><span class=\"blue-color\">Siniestros</span></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.acceso_ver_ot\"><button type=\"button\" class=\"btn btn-primary m-r-sm\" ng-click=\"vm.showEndorsements(vm.insurance)\" ng-disabled=\"vm.conteos.endosos == 0\">{{vm.conteos.endosos}}</button><span class=\"blue-color\">Endosos</span></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.acceso_ver_cob\"><button type=\"button\" class=\"btn btn-warning m-r-sm\" ng-click=\"vm.showNotas()\">{{vm.notas.length}}</button><span class=\"blue-color\">Notas de Crédito</span></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"vm.showRecordatorios()\">{{vm.insurance.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div><div class=\"col-xs-12 col-sm-8 border-left\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.poliza_number\"><span class=\"blue-color\"><b>Número de Póliza</b>:</span><div><span>{{ vm.insurance.poliza_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.internal_number\"><span class=\"blue-color\">Folio Interno:</span><div><span>{{ vm.insurance.internal_number }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.folio\"><span class=\"blue-color\">Folio:</span><div><span>{{ vm.insurance.folio }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" style=\"word-wrap: break-word;\"><span class=\"blue-color\">Identificador:</span><div><span>{{ vm.insurance.identifier }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Aseguradora - Clave Agente:</span><div><span>{{ vm.insurance.aseguradora.alias }} - <span ng-if=\"vm.insurance.clave.name\">{{vm.insurance.clave.name}}</span> {{vm.insurance.clave.clave}} <span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Ramo:</span><div><span>{{ vm.insurance.ramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.insurance.subramo }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.hospital_level && vm.insurance.subramo == \'Gastos Médicos\'\"><span class=\"blue-color\">Nivel Hospitalario:</span><div><span>{{ vm.insurance.hospital_level }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.tabulator && vm.insurance.subramo == \'Gastos Médicos\'\"><span class=\"blue-color\">Tabulador:</span><div><span>{{ vm.insurance.tabulator }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.insurance.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ vm.insurance.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{ forma_pago(vm.insurance.forma_de_pago)}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" ng-class=\"{\'label-success\': vm.insurance.status == 1 || vm.insurance.status == 12, \'label-info\' : vm.insurance.status == 10,\'label-primary\' : vm.insurance.status == 14, \'label-warning\' : vm.insurance.status == 2 || vm.insurance.status == 4 || vm.insurance.status == 11}\" style=\"margin-right: 10px\">{{ status(vm.insurance.status) }} <span ng-if=\"vm.insurance.renewed_status == 2 && vm.policy_history.length > 0 && orgName !=\'ancora\'\">- En proceso de renovación</span><span ng-if=\"orgName ==\'ancora\' && vm.insurance.renewed_status ==2 && vm.insurance.is_renewable==1\">- En Proceso de Renovación</span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.reason_ren\"><span class=\"blue-color\">Motivo de no Renovación:</span><div><span>{{ vm.insurance.reason_ren }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.reason_cancel && (vm.insurance.status == 4 || vm.insurance.status == 11)\"><span class=\"blue-color\">Motivo de Cancelación:</span><div><span>{{ vm.insurance.reason_cancel }}<span></span></span></div><span class=\"blue-color\">Fecha de Cancelación:</span><div><span>{{ vm.insurance.date_cancel | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Tipo Renovable:</span><div><span ng-if=\"vm.insurance.is_renewable == 1\">Renovable</span> <span ng-if=\"vm.insurance.is_renewable == 2\">No Renovable</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"vm.insurance.f_currency == 1\">PESOS</span> <span ng-if=\"vm.insurance.f_currency == 2\">DÓLARES</span> <span ng-if=\"vm.insurance.f_currency == 3\">UDI</span> <span ng-if=\"vm.insurance.f_currency == 4\">EURO</span> <span ng-if=\"vm.insurance.f_currency == 5\">DOLAR CANADIENSE</span> <span ng-if=\"vm.insurance.f_currency == 6\">LIBRA ESTERLINA</span> <span ng-if=\"vm.insurance.f_currency == 7\">YEN</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">Paquete:</span><div><span>{{ vm.insurance.paquete }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_lineanegocio\"><span class=\"blue-color\">Línea de Negocio:</span><div><span>{{businessLine}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"campo_celula\"><span class=\"blue-color\">{{moduleName}}:</span><div><span>{{celula}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.grouping_level && campo_agrupacion\"><span class=\"blue-color\">Agrupación:</span><div><span>{{vm.insurance.grouping_level.description}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.subgrouping_level && campo_agrupacion\"><span class=\"blue-color\">Subagrupación:</span><div><span>{{vm.insurance.subgrouping_level.description}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"vm.insurance.subsubgrouping_level && campo_agrupacion\"><span class=\"blue-color\">Subsubagrupación:</span><div><span>{{vm.insurance.subsubgrouping_level.description}}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\">Creado por:</span><div>{{ vm.insurance.owner }}</div></div><div class=\"col-xs-6 col-lg-4 form-group\" ng-if=\"vm.insurance.reason_rehabilitate\"><span class=\"blue-color\">Motivo de rehabilitación:</span><div><span>{{ vm.insurance.reason_rehabilitate }}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"vm.insurance.responsable\"><span class=\"blue-color\"><i class=\"fa fa-star yellow\"></i> Responsable:</span><div>{{ vm.insurance.responsable.first_name | uppercase}} {{ vm.insurance.responsable.last_name | uppercase}}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"vm.insurance.cotizacion_asociada\"><span class=\"blue-color\">Cotización:</span><div>{{ vm.insurance.cotizacion_asociada }}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\"><span class=\"blue-color\">Sucursal:</span><div>{{ vm.insurance.sucursal.sucursal_name }}</div></div><div ng-if=\"vm.acceso_ver_ref\"><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"vm.insurance.vendor && vm.insurance.ref_policy.length == 0\"><span class=\"blue-color\">Referenciador:</span><div>{{ vm.insurance.vendor.first_name | uppercase}} {{ vm.insurance.vendor.last_name | uppercase}}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"vm.insurance.ref_policy.length >0\"><span class=\"blue-color\">Referenciador (es):</span><div ng-repeat=\"refs in vm.insurance.ref_policy\"><span>{{refs.data.first_name | uppercase}} {{ refs.data.last_name | uppercase}} // {{ refs.comision_vendedor }} %</span> <a ng-if=\"vm.insurance.ref_policy && vm.insurance.ref_policy.length >0\" class=\"btn btn-sm btn-white\" ng-click=\"cambiarReferenciador(refs,vm.insurance)\" title=\"Cambiar Referenciador\"><i class=\"fa fa-rotate-right\" aria-hidden=\"true\"></i></a></div></div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"vm.insurance.collection_executive\"><span class=\"blue-color\"><i class=\"fa fa-calculator yellow\"></i> Ejecutivo de Cobranza:</span><div>{{ vm.insurance.collection_executive.first_name | uppercase}} {{ vm.insurance.collection_executive.last_name | uppercase}}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"vm.insurance.contratante_subgroup || vm.insurance.group\"><span class=\"blue-color\"><i class=\"fa fa-group yellow\"></i> Grupo:</span><div>{{ vm.insurance.group }}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"vm.insurance.contratante_subgroup || vm.insurance.subgroup\"><span class=\"blue-color\"><i class=\"fa fa-group yellow\"></i> SubGrupo:</span><div>{{ vm.insurance.subgrupo }}</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"vm.insurance.contratante_subgroup || vm.insurance.subsubgroup\"><span class=\"blue-color\"><i class=\"fa fa-group yellow\"></i> SubsubGrupo:</span><div>{{ vm.insurance.subsubgrupo }}</div></div><div class=\"col-xs-6 form-group pull-right\" align=\"center\" ng-if=\"vm.insurance.seguimiento && vm.acceso_tab && decrptedtoken.org ==\'pruebas\'\"><span class=\"blue-color\">Tablero OT</span><div><span>{{ vm.insurance.seguimiento }}</span><div class=\"btn-group pull-right m-b\"><button style=\"border: 0px;\" type=\"button\" class=\"btn btn-white btn-sm btn-secondary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bars\" aria-hidden=\"true\"></i></button><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"dropdown-submenu\" ng-if=\"principal.contenedores.length\"><a>Mover a</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"principal.contenedores\"><a class=\"disabled\">Estados</a></li><li ng-if=\"principal.contenedores\" ng-repeat=\"newcontainer in principal.contenedores track by $index\"><a ng-click=\"vm.moveOTState(newcontainer,principal,vm.insurance.seguimiento)\" ng-if=\"newcontainer.tablero != vm.insurance.seguimiento\">{{newcontainer.tablero}}</a></li></ul></li></ul></div></div></div><div class=\"col-xs-6 form-group pull-right\" ng-if=\"vm.insurance.task_associated\"><button type=\"button\" class=\"btn btn-white btn-sm btn-secondary\" ng-click=\"openModal(vm.insurance.task_associated_info)\">{{ vm.isCollapsed ? \'Ocultar\' : \'Ver\' }} Tarea Origen</button><div ng-show=\"vm.isCollapsed\"><span class=\"blue-color\">Tarea Origen</span><div><span>{{ vm.insurance.task_associated_info.title }}</span></div></div></div><div class=\"col-xs-12\"><hr></div><div ng-if=\"vm.insurance.status != 1\"><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Neta:</span><div>{{ prima_neta() | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Descuento: &nbsp;</span><div>{{ descuento() | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-6 form-group\"><span class=\"blue-color\">Recargo por Pago Fraccionado:</span><div>{{ recargo() | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Derecho:</span><div>{{ derecho() | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Iva:</span><div>{{ iva() | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\"><span class=\"blue-color\">Prima Total:</span><div>{{ prima_total() | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.permiso_comisiones\"><span class=\"blue-color\">Comisión Total:</span><div>{{ vm.insurance.comision | currency}}</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.permiso_comisiones\"><span class=\"blue-color\">% Comisión <span ng-if=\"vm.insurance.comision_derecho_percent!=\'0.00\' || vm.insurance.comision_rpf_percent!=\'0.00\'\">Prima Neta</span>:</span><div>{{ vm.insurance.comision_percent }}%</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.permiso_comisiones && vm.insurance.comision_derecho_percent!=\'0.00\'\"><span class=\"blue-color\">% Comisión Derecho:</span><div>{{ vm.insurance.comision_derecho_percent }}%</div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group\" ng-if=\"vm.permiso_comisiones && vm.insurance.comision_rpf_percent!=\'0.00\'\"><span class=\"blue-color\">% Comisión RPF:</span><div>{{ vm.insurance.comision_rpf_percent }}%</div></div><div class=\"col-xs-12 col-md-6 col-md-4 form-group\" ng-if=\"vm.insurance.recibos_poliza\"><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i><span class=\"blue-color\"><i class=\"fa fa-card\"></i> Conducto de Pago:</span><div><span>{{ vm.insurance.conducto_de_pago }}</span> <a ui-sref=\"polizas.editar({polizaId: vm.polizaId})\"><button type=\"button\" ng-if=\"vm.acceso_adm_ot && vm.acceso_adm_pol\" class=\"btn btn-white btn-sm\"><i class=\"fa fa-edit\" aria-hidden=\"true\"></i></button></a></div></div></div></div></div></div></div></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"vm.sinistersFlag\"><div class=\"ibox-title\"><h5>Siniestros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><a class=\"btn btn-info m-b\" ng-click=\"vm.returnToInfo()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a><table class=\"table table-hover table-bordered\"><thead><th>Folio</th><th>Número de Siniestro</th><th>Fecha de Creación</th><th>Fecha de Emisión</th><th>Estatus</th><th>Tipo de pago</th></thead><tbody><tr ng-repeat=\"sinister in vm.sinisters track by $index\" ng-click=\"infoSinister(\'Información Siniestro\', sinister,vm.insurance)\"><td>{{ sinister.folio_compania }}</td><td>{{ sinister.numero_siniestro }}</td><td>{{ sinister.fecha_siniestro | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ sinister.fecha_ingreso | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td ng-if=\"sinister.status == 1\">Pendiente</td><td ng-if=\"sinister.status == 2\">En trámite</td><td ng-if=\"sinister.status == 3\">Completado</td><td ng-if=\"sinister.status == 4\">Cancelado</td><td ng-if=\"sinister.status == 5\">Rechazado</td><td>{{ tipo_pago(sinister.accidente_sinister[0].tipo_pago)}}</td></tr></tbody></table></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"vm.endoFlag\"><div class=\"ibox-title\"><h5>Endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><a class=\"btn btn-info m-b\" ng-click=\"vm.returnToInfo()\"><span class=\"fa fa-reply\"></span> Regresar</a><table class=\"table table-hover table-bordered\"><thead><th>Tipo</th><th>Número de endoso</th><th>Concepto</th><th>Descripción</th><th>Vigencia</th><th>Estatus</th><th>Historial</th></thead><tbody><tr ng-repeat=\"endorsement in vm.endorsements track by $index\" ng-click=\"goToEndorsement(\'Información Endoso\', \'endorsement.info\', endorsement)\"><td>{{ endorsement.endorsement_type }}</td><td ng-if=\"endorsement.number_endorsement\">{{ endorsement.number_endorsement }}</td><td ng-if=\"!endorsement.number_endorsement\">Sin número asigando</td><td>{{ concept(endorsement.concept) }}<span ng-if=\"concept(endorsement.concept) == \'OTRO\'\">: {{endorsement.other_desc}}</span></td><td>{{ endorsement.observations}}</td><td>{{ endorsement.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ endorsement.end_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td ng-if=\"endorsement.status == 1\">Pendiente</td><td ng-if=\"endorsement.status == 2\">Registrado</td><td ng-if=\"endorsement.status == 3\">Rechazado</td><td ng-if=\"endorsement.status == 5\">En trámite</td><td ng-if=\"endorsement.status == 4\">Cancelado</td><td ng-if=\"endorsement.migrated\">Sin historial</td><td ng-if=\"endorsement.status != 2\"></td><td ng-if=\"!endorsement.migrated && endorsement.status == 2\"><button class=\"btn btn-default\" style=\"color: grey\" ng-click=\"$event.stopPropagation(); vm.showChange(endorsement)\"><i class=\"fa fa-retweet\">Ver cambios</i></button></td></tr></tbody></table></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"vm.notasFlag\"><div class=\"ibox-title\"><h5>Notas de crédito</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"vm.notasFlag = false; vm.infoFlag = true\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Folio</th><th>Número de Póliza/Fianza</th><th>Número de Endoso</th><th>Fecha de Inicio</th><th>Prima Total</th><th>Estatus</th></thead><tr ng-repeat=\"nota in vm.notas track by $index\" ng-click=\"vm.changeStatusModal(nota, nota.poliza ? nota.poliza: nota.fianza, nota.poliza ? nota.poliza : nota.fianza)\"><td>{{ nota.folio }}</td><td>{{ nota.poliza.poliza_number }}{{nota.fianza.fianza_number}}</td><td ng-if=\"nota.endorsement\">{{ nota.endorsement.number_endorsement }}</td><td ng-if=\"!nota.endorsement\">Nota de crédito libre</td><td>{{ nota.fecha_inicio | date: \'dd/MM/yyyy h:mm:ss a\' : \'UTC\'}}</td><td>{{ nota.prima_total | currency }}</td><td><span>{{ nota.status }}</span></td></tr></table><button class=\"btn btn-primary pull-right\" ng-click=\"vm.createNotes(vm.insurance)\">Crear nota de crédito</button></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"vm.recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"vm.recordatoriosFlag = false; vm.infoFlag = true\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in vm.insurance.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Detalles</h5></div><div class=\"ibox-content\"><div ng-if=\"vm.insurance.automobiles_policy.length\"><div class=\"col-xs-12 col-sm-6 form-group\"><h4>Datos del Automóvil</h4><span class=\"blue-color\"><b>Tipo de vehículo:&nbsp;</b></span> <span>{{ policy_type(vm.insurance.automobiles_policy[0].policy_type) }}<span><br><span class=\"blue-color\">Procedencia:&nbsp;</span> <span>{{ type_procedencia(vm.insurance.automobiles_policy[0].procedencia) }}<span><br><span class=\"blue-color\">Estado de circulación:&nbsp;</span> <span>{{ vm.insurance.state_circulation }}<span><br><span class=\"blue-color\">Conductor:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].driver }}<span><br><span class=\"blue-color\">Marca:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].brand }}<span><br><span class=\"blue-color\">Modelo:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].model }}<span><br><span class=\"blue-color\">Año:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].year }}<span><br><span class=\"blue-color\">Versión:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].version }}<span><br><span class=\"blue-color\">Color:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].color }}<span><br><span class=\"blue-color\">Motor:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].engine }}<span><br><span class=\"blue-color\">Número de serie:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].serial }}<span><br><span class=\"blue-color\">Matrícula:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].license_plates }}<span><br><span class=\"blue-color\">Servicio:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].service }}</span><br><span class=\"blue-color\">Uso:&nbsp;</span> <span>{{ getUsage(vm.insurance.automobiles_policy[0].usage) }}</span><br><span class=\"blue-color\" ng-if=\"vm.insurance.automobiles_policy[0].usage == 2\">Tipo de Carga:&nbsp;</span> <span ng-if=\"vm.insurance.automobiles_policy[0].usage == 2\">{{ getCarga(vm.insurance.automobiles_policy[0].charge_type) }}</span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></div><div class=\"col-xs-12 col-sm-6 form-group\"><h4>Adaptación</h4><span class=\"blue-color\">Monto de Adaptación:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].mont_adjustment | currency }}</span><br><span class=\"blue-color\">Adaptaciones:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].adjustment }}</span><br><br><span class=\"blue-color\">Monto de Equipamiento:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].mont_special_team | currency }}</span><br><span class=\"blue-color\">Equipo Especial:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].special_team }}</span><br></div><div class=\"col-xs-12 col-sm-6 form-group\"><h4>Beneficiario Preferente</h4><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].beneficiary_name }}</span><br><span class=\"blue-color\">Dirección:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].beneficiary_address }}</span><br><span class=\"blue-color\">RFC:&nbsp;</span> <span>{{ vm.insurance.automobiles_policy[0].beneficiary_rfc }}</span><br></div></div><div ng-if=\"vm.insurance.accidents_policy.length\"><div ng-init=\"p_info = vm.insurance.accidents_policy[0].personal\"><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"p_info.full_name\"><h4>Titular</h4><span class=\"blue-color\"><b>Tipo:&nbsp;</b></span> <span>{{ policy_type_fire(p_info.policy_type)}}<span><br><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{p_info.first_name}} {{p_info.last_name}} {{p_info.second_last_name}}</span><br><span class=\"blue-color\">Fecha de nacimiento:&nbsp;</span> <span>{{p_info.birthdate | date: \'dd/MM/yyyy\' : \'UTC\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"p_info.sex == \'M\'\">MASCULINO</span> <span ng-if=\"p_info.sex == \'F\'\">FEMENINO</span><br><span class=\"blue-color\">Fecha de Antigüedad:&nbsp;</span> <span>{{p_info.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span><br></span></span></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.accidents_policy[0].relationship_accident.length\"><h4>Dependientes</h4><div ng-repeat=\"relationship in vm.insurance.accidents_policy[0].relationship_accident\"><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{relationship.first_name}} {{relationship.last_name}} {{relationship.second_last_name}}</span><br><span class=\"blue-color\">Fecha de Nacimiento:&nbsp;</span> <span>{{relationship.birthdate | date: \'dd/MM/yyyy\' : \'UTC\'}}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"relationship.sex == \'F\'\">FEMENINO</span> <span ng-if=\"relationship.sex == \'M\'\">MASCULINO</span><br><span class=\"blue-color\">Parentesco:&nbsp;</span> <span ng-if=\"relationship.relationship == 1\">TITULAR</span> <span ng-if=\"relationship.relationship == 2\">CONYUGE</span> <span ng-if=\"relationship.relationship == 3\">HIJO</span> <span ng-if=\"relationship.relationship == 4\">OTRO</span><br><span class=\"blue-color\">Fecha de Antigüedad:&nbsp;</span> <span>{{relationship.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span><br><br></div></div></div></div><div ng-if=\"vm.insurance.damages_policy.length\" ng-init=\"damages = vm.insurance.damages_policy[0]\"><div class=\"col-xs-12\"><span class=\"blue-color\" ng-if=\"vm.insurance.damages_policy\"><b>Tipo:&nbsp;</b></span> <span>{{ policy_type_fire_ok(damages.damage_type)}}<span><br><span class=\"blue-color\">Bien Asegurado:&nbsp;</span> <span>{{ damages.insured_item }}</span><br><span class=\"blue-color\">Dirección:&nbsp;</span> <span>{{ damages.item_address }}</span><br><span class=\"blue-color\">Detalles:&nbsp;</span> <span>{{ damages.item_details }}</span><br></span></span></div></div><div><div class=\"col-xs-12\"><div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.personal_life_policy.length > 0\"><h4>Asegurado (s)</h4><div ng-repeat=\"pers_life in vm.insurance.personal_life_policy\"><span class=\"blue-color\"><b>Tipo:&nbsp;</b></span> <span>{{ policy_type_fire(pers_life.policy_type)}}<span><br><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{ pers_life.j_name }}{{ pers_life.first_name }} {{ pers_life.last_name }} {{ pers_life.second_last_name }}</span><br><span class=\"blue-color\" ng-if=\"!pers_life.j_name\">Fecha de Nacimiento:&nbsp;</span> <span>{{ pers_life.birthdate | date: \'dd/MM/yyyy\' : \'UTC\'}}</span><br><span class=\"blue-color\" ng-if=\"!pers_life.j_name\">Sexo:&nbsp;</span> <span ng-if=\"pers_life.sex == \'F\'\">FEMENINO</span> <span ng-if=\"pers_life.sex == \'M\'\">MASCULINO</span><br><span class=\"blue-color\">Fumador:&nbsp;</span> <span ng-if=\"pers_life.smoker == true\">SI</span> <span ng-if=\"pers_life.smoker == false\">NO</span><br><span class=\"blue-color\" ng-if=\"!pers_life.j_name\">Fecha de Antigüedad:&nbsp;</span> <span>{{ pers_life.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span><br><hr></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.personal_life_policy.length == 0 && vm.insurance.life_policy[0]\"><span class=\"blue-color\"><b>Tipo:&nbsp;</b></span> <span>{{ policy_type_fire(vm.insurance.life_policy[0].personal.policy_type)}}<span><br><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{ vm.insurance.life_policy[0].personal.full_name }}</span><br><span class=\"blue-color\">Fecha de nacimiento:&nbsp;</span> <span>{{ vm.insurance.life_policy[0].personal.birthdate | date: \'dd/MM/yyyy\' : \'UTC\' }}</span><br><span class=\"blue-color\">Sexo:&nbsp;</span> <span ng-if=\"vm.insurance.life_policy[0].personal.sex == \'M\'\">MASCULINO</span> <span ng-if=\"vm.insurance.life_policy[0].personal.sex == \'F\'\">FEMENINO</span><br><span class=\"blue-color\">Fumador:&nbsp;</span> <span ng-if=\"vm.insurance.life_policy[0].personal.smoker == true\">SI</span> <span ng-if=\"vm.insurance.life_policy[0].personal.smoker == false\">NO</span><br><span class=\"blue-color\">Fecha de Antigüedad:&nbsp;</span> <span>{{ vm.insurance.life_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\' }}</span><br></span></span></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.insurance.personal_life_policy.length == 0 && vm.insurance.life_policy[0].personal.length > 0\"><h4>Asegurado (s)</h4><div ng-repeat=\"pers_life in vm.insurance.life_policy[0].personal\"><span class=\"blue-color\"><b>Tipo:&nbsp;</b></span> <span>{{ policy_type_fire(pers_life.policy_type)}}<span><br><span class=\"blue-color\">Nombre:&nbsp;</span> <span>{{ pers_life.j_name }}{{ pers_life.first_name }} {{ pers_life.last_name }} {{ pers_life.second_last_name }}</span><br><span class=\"blue-color\" ng-if=\"!pers_life.j_name\">Fecha de Nacimiento:&nbsp;</span> <span>{{ pers_life.birthdate | date: \'dd/MM/yyyy\' : \'UTC\'}}</span><br><span class=\"blue-color\" ng-if=\"!pers_life.j_name\">Sexo:&nbsp;</span> <span ng-if=\"pers_life.sex == \'F\'\">FEMENINO</span> <span ng-if=\"pers_life.sex == \'M\'\">MASCULINO</span><br><span class=\"blue-color\">Fumador:&nbsp;</span> <span ng-if=\"vm.insurance.life_policy[0].smoker == true\">SI</span> <span ng-if=\"vm.insurance.life_policy[0].smoker == false\">NO</span><br><span class=\"blue-color\" ng-if=\"!pers_life.j_name\">Fecha de Antigüedad:&nbsp;</span> <span>{{ pers_life.antiguedad | date: \'dd/MM/yyyy\' : \'UTC\'}}</span><br><hr></span></span></div></div><div class=\"col-xs-12 col-sm-6 form-group beneficiaries-section\" ng-if=\"vm.insurance.life_policy[0].beneficiaries_life && vm.insurance.life_policy[0].beneficiaries_life.length\"><h4 class=\"section-title text-uppercase text-muted m-b-10\">Beneficiarios</h4><div class=\"benef-card card m-b-10\" ng-repeat=\"b in vm.insurance.life_policy[0].beneficiaries_life track by $index\" ng-if=\"b.j_name || b.first_name || b.last_name || b.second_last_name\"><div class=\"benef-card__header card-header d-flex align-items-center justify-content-between\"><div class=\"benef-card__title\"><span class=\"benef-name h5\"><span ng-if=\"b.first_name\">{{ b.first_name }} {{ b.last_name }} {{ b.second_last_name }}</span> <span ng-if=\"!b.first_name\">{{ b.j_name }}</span></span></div><span class=\"benef-badge badge badge-pill badge-primary\" ng-if=\"b.percentage\">Porcentaje: {{ (b.percentage || \'\') + (b.percentage ? \'%\' : \'\') }}</span></div><div class=\"benef-card__body card-body\"><dl class=\"benef-meta row\"><div class=\"col-xs-12 col-sm-6\"><dt class=\"benef-label\">Parentesco</dt><dd class=\"benef-value\" ng-bind=\"b.optional_relationship || \'—\'\"></dd><dt class=\"benef-label\" ng-if=\"b.first_name && b.birthdate\">Nacimiento</dt><dd class=\"benef-value\" ng-if=\"b.first_name && b.birthdate\" ng-bind=\"b.birthdate | date:\'dd/MM/yyyy\'\"></dd><dt class=\"benef-label\" ng-if=\"b.sex\">Sexo</dt><dd class=\"benef-value\" ng-if=\"b.sex == \'F\'\">FEMENINO</dd><dd class=\"benef-value\" ng-if=\"b.sex == \'M\'\">MASCULINO</dd></div><div class=\"col-xs-12 col-sm-6\"><dt class=\"benef-label\" ng-if=\"!b.first_name && b.rfc\">RFC</dt><dd class=\"benef-value\" ng-if=\"!b.first_name && b.rfc\" ng-bind=\"b.rfc\"></dd><dt class=\"benef-label\" ng-if=\"b.antiguedad\">Antigüedad</dt><dd class=\"benef-value\" ng-if=\"b.antiguedad\" ng-bind=\"b.antiguedad | date:\'dd/MM/yyyy\':\'UTC\'\"></dd></div></dl></div></div></div></div></div></div><div class=\"col-xs-12 hidden-xs hidden-sm\"><legend class=\"legend-title\" align=\"center\">Coberturas</legend><table class=\"table table-bordered table-hover\"><thead><tr><th ng-model=\"vm.tablec.headers[0]\">{{ vm.tablec.headers[0] }}</th><th ng-model=\"vm.tablec.headers[1]\">{{ vm.tablec.headers[1] }}</th><th ng-model=\"vm.tablec.headers[2]\">{{ vm.tablec.headers[2] }}</th><th ng-if=\"vm.insurance.accidents_policy.length\" ng-model=\"vm.tablec.headers[3]\">{{ vm.tablec.headers[3] }}</th><th ng-if=\"vm.insurance.accidents_policy.length\">Tope Coaseguro</th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.insurance.coverageInPolicy_policy | orderBy: \'priority\' track by coverage.url\" ng-if=\"coverage.package; coverage.coverage_name && (coverage.sum_insured || coverage.deductible || coverage.coinsurance)\"><td>{{ coverage.coverage_name }}</td><td>{{ formatCoverage(coverage.sum_insured) }}</td><td>{{ formatCoverage(coverage.deductible) }}</td><td ng-if=\"vm.insurance.accidents_policy.length\">{{coverage.coinsurance}}</td><td ng-if=\"vm.insurance.accidents_policy.length\">{{coverage.topecoinsurance}}</td></tr></tbody></table></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"coverage in vm.insurance.coverageInPolicy_policy\" ng-if=\"coverage.package; coverage.sum_insured\"><div class=\"ibox-title\"><h5>{{ vm.tablec.headers[0] }}:{{ coverage.coverage_name }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tablec.headers[0] }}</label><p>{{ coverage.coverage_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tablec.headers[1] }}</label><p>{{ formatCoverage(coverage.sum_insured) }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tablec.headers[2] }}</label><p>{{ formatCoverage(coverage.deductible) }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tablec.headers[3] }}</label><p>{{coverage.coinsurance }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Tope coaseguro</label><p>{{coverage.topecoinsurance }}</p></div></tr></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.receipts.length > 0\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title receipt-title\"><h5>Recibos de Póliza</h5><button class=\"btn btn-success\" ng-click=\"renewReceipts()\" ng-if=\"poliza_multianual\">Renovar recibos</button></div><div class=\"ibox-content\"><div class=\"row animate\" ng-if=\"calculate_receipts\"><div ng-if=\"vm.permiso_comisiones\"><span>Comisi&oacute;n</span><div><input type=\"text\" name=\"\" class=\"form-control\" ng-model=\"vm.insurance.comision_percent\"></div></div><calculate-receipts poliza=\"poliza_renew_rec\" form=\"vm.insurance\" tosave=\"dataToSave\" type=\"1\"></calculate-receipts><button class=\"btn btn-success\" ng-click=\"saveNewReceipts()\">Guardar</button></div><div class=\"row animate\" ng-if=\"!calculate_receipts\"><div class=\"col-xs-12\" ng-if=\"!vm.show_binnacle_receipt\"><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"poliza_multianual && vm.insurance.forma_de_pago !=5\"><label>Año:</label><select class=\"form-control\" ng-model=\"anioPoliza\" data-ng-options=\"anio for anio in aniosPoliza\" ng-change=\"showReceiptsYear(anioPoliza)\"></select><br></div><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}}</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th><th ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}}</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th width=\"5%\" ng-if=\"vm.permiso_comisiones\">Comisión Conciliada</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}}</th><th ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}}</th><th width=\"3%\">Entregado</th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th></tr></thead><tbody><tr ng-click=\"vm.changeStatusModal(receipt, contratante,vm.insurance)\" ng-repeat=\"receipt in vm.policy_receipts_show track by $index | orderBy: \'fecha_inicio\'\" ng-if=\"receipt.receipt_type == 1 && receipt.status != 0\"><td ng-if=\"!receipt.serie_manual\">{{ receipt.recibo_numero }} / {{vm.policy_receipts_show.length - vm.receipts_manual}}</td><td ng-if=\"receipt.serie_manual\">{{ receipt.recibo_numero }} / {{receipt.serie_manual}}</td><td>{{ receipt.prima_neta | currency }}</td><td>{{ receipt.derecho | currency }}</td><td>{{ receipt.rpf | currency }}</td><td>{{ receipt.iva | currency }}</td><td>{{ receipt.prima_total | currency }}</td><td ng-if=\"vm.permiso_comisiones\">{{ receipt.comision | currency }}</td><td width=\"5%\" ng-if=\"vm.permiso_comisiones\"><span>{{receipt.comision_conciliada | currency }}</span></td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{receipt.vencimiento | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8}\">{{ vm.checkStatusReceipts(receipt) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); vm.deliveredReceipt(receipt)\"><span ng-if=\"receipt.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!receipt.delivered\"><i class=\"fa fa-times\"></i></span></td><td><span title=\"{{ vm.whatsappWebEnabled ? \'Recordatorio por WhatsApp Web\' : \'Recordatorio por SMS\' }}\" ng-if=\"vm.acceso_adm_pol\"><button class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); addPhoneWhatsapp(receipt, contratante)\" ng-disabled=\"!(receipt.status == 4)\" title=\"{{ vm.whatsappWebEnabled ? \'Recordatorio por WhatsApp Web\' : \'Recordatorio por SMS\' }}\"><img ng-if=\"!vm.whatsappWebEnabled\" style=\"height: 15px;\" class=\"icon-menu\" src=\"../../assets/comment-sms-solid.svg\"> <i ng-if=\"vm.whatsappWebEnabled\" class=\"fa fa-whatsapp\"></i></button></span> <button ng-if=\"vm.acceso_cor && vm.acceso_adm_pol\" class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); addEmailsConfirmPolicy(receipt, contratante)\" ng-disabled=\"!(receipt.status == 4)\"><i class=\"fa fa-envelope\"></i></button><div ng-if=\"receipt.track_email\" class=\"identificador-dash-email\"></div><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacleReceipt(receipt)\"><i class=\"fa fa-comments\" aria-hidden=\"true\"></i></a><div ng-if=\"receipt.track_bitacora\" class=\"identificador-dash-binnacle\"></div><a class=\"btn btn-warning btn-sm\" ng-click=\"$event.stopPropagation();applyEx()\" ng-if=\"receipt.excedente > 0\" style=\"background-color: white;border-color: #f8ac59;color: black;\"><i class=\"fa fa-hand-holding-usd\" aria-hidden=\"true\" title=\"Recibo con excedente sin aplicar\"></i></a> <a ng-if=\"vm.insurance.conducto_de_pago != \'No domiciliada\'\" ng-click=\"$event.stopPropagation()\" class=\"btn btn-white btn-sm\" title=\"{{vm.insurance.conducto_de_pago}}\"><i ng-if=\"vm.insurance.conducto_de_pago == \'Agente\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"vm.insurance.conducto_de_pago == \'CAC\'\" class=\"fa fa-user\" aria-hidden=\"true\"></i> <i ng-if=\"vm.insurance.conducto_de_pago == \'CAT/Domiciliado\'\" class=\"fa fa-credit-card-alt\" aria-hidden=\"true\"></i> <i ng-if=\"vm.insurance.conducto_de_pago == \'Nómina\'\" class=\"fa fa-money\" aria-hidden=\"true\"></i> <i ng-if=\"vm.insurance.conducto_de_pago == \'CUT\'\" class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></a> <a ng-if=\"(receipt.status == 4 || vm.acceso_pl_cob == false) && vm.acceso_adm_pol\" ng-click=\"$event.stopPropagation(); vm.editRecibos($index,receipt.id,receipt)\" class=\"btn btn-white btn-sm\" title=\"Editar recibo\"><i class=\"fa fa-edit\" aria-hidden=\"true\"></i></a><a ng-if=\"receipt.status == 4 && vm.acceso_del_cob && vm.acceso_adm_pol\" ng-click=\"$event.stopPropagation(); deleteReceipts(receipt,$index)\" class=\"btn btn-white btn-sm\" title=\"Eliminar recibo\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-default sm\" style=\"color: red\" ng-click=\"$event.stopPropagation()\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\" ng-if=\"receipt.endosotramite\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\"></i></a><tasks click=\"addtask()\" type=\"3\" model=\"receipt.recibo_numero + \' de la póliza \' + vm.insurance.poliza_number\" associated=\"vm.insurance.id\" receipt=\"receipt.id\"></tasks></td></tr><tr ng-if=\"vm.insurance.poliza_number\"><td><b>Totales</b></td><td><b>{{data_sums.p_neta | currency}}</b></td><td><b>{{data_sums.derecho | currency}}</b></td><td><b>{{data_sums.rpf | currency}}</b></td><td><b>{{data_sums.iva | currency}}</b></td><td><b>{{data_sums.p_total | currency}}</b></td><td ng-if=\"permiso_comisiones\"><b>{{data_sums.comision | currency}}</b></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><div class=\"col-xs-12\"><div class=\"identificador-dash-email\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Se envio un correo.</span><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span> <button class=\"btn btn-primary pull-right\" ng-if=\"vm.acceso_adm_pol\" ng-click=\"vm.createReceipts(vm.insurance)\">Crear Recibos</button></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle_receipt\"><div class=\"col-md-12\"><div><label>Bitácora de recibos</label> <a class=\"btn btn-info pull-right\" ng-click=\"vm.returnToReceipts()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data_receipt\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\" receiptmodel=\"receiptmodel\" exportable=\"true\"></comments></div></div></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"receipt in vm.policy_receipts_show track by $index\" ng-if=\"receipt.receipt_type == 1\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}:{{ receipt.recibo_numero }} / {{vm.policy_receipts_show.length}}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ng-click=\"vm.changeStatusModal(receipt)\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ receipt.recibo_numero }} / {{vm.policy_receipts_show.length}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ receipt.prima_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p>{{ receipt.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ receipt.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ receipt.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ receipt.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8}\">{{ statusReceipts(receipt.status) }}</div></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacleReceipt(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p><button ng-if=\"vm.acceso_cor && vm.acceso_adm_pol\" class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); addEmailsConfirmPolicy(receipt, contratante)\" ng-disabled=\"!(receipt.status == 4)\"><i class=\"fa fa-envelope\"></i></button></div></tr></table></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"vm.endorsement_receipts_show.length > 0\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos de Endosos</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"!vm.show_binnacle_receiptE\"><div class=\"row col-sm-6\"><select class=\"form-control\" ng-model=\"vm.form.endoso\" data-ng-options=\"endoso for endoso in vm.endosos_options track by endoso\" ng-change=\"vm.changeEndorsement(vm.form.endoso)\"><option value=\"\">Todos los endosos</option></select><br></div><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}}</th><th ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}}</th><th ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}}</th><th ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}}</th><th ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}}</th><th ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}}</th><th ng-if=\"vm.permiso_comisiones\">Comisión</th><th width=\"5%\" ng-if=\"vm.permiso_comisiones\">Comisión Conciliada</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th><th ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}}</th><th width=\"3%\">Entregado</th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th></tr></thead><tbody><tr ng-click=\"vm.changeStatusModal(receipt, contratante, vm.insurance)\" ng-repeat=\"receipt in vm.endorsement_receipts_show track by $index\" ng-if=\"(receipt.receipt_type == 2 || receipt.receipt_type == 3) && receipt.stataus != 0\"><td>{{ receipt.recibo_numero }} / {{vm.endorsement_receipts_show.length }}</td><td>{{ receipt.prima_neta | currency }}</td><td>{{ receipt.derecho | currency }}</td><td>{{ receipt.rpf | currency }}</td><td>{{ receipt.iva | currency }}</td><td>{{ receipt.prima_total | currency }}</td><td ng-if=\"vm.permiso_comisiones\">{{ receipt.comision | currency }}</td><td ng-if=\"vm.permiso_comisiones\">{{ receipt.comision_conciliada | currency }}</td><td>{{ receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td><div class=\"label\" ng-class=\"{\'label-success\': receipt.status == 4, \'label-info\' : receipt.status == 5 || receipt.status == 6, \'label-primary\' : receipt.status == 1 || receipt.status == 3, \'label-warning\' : receipt.status == 2 || receipt.status == 8}\">{{ vm.checkStatusReceipts(receipt) }}</div></td><td align=\"center\" ng-click=\"$event.stopPropagation(); vm.deliveredReceipt(receipt)\"><span ng-if=\"receipt.delivered\"><i class=\"fa fa-check\"></i></span><span ng-if=\"!receipt.delivered\"><i class=\"fa fa-times\"></i></span></td><td><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacleReceiptE(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"$event.stopPropagation(); addEmailsConfirmPolicy(receipt, contratante)\" ng-if=\"receipt.status == 4\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></a><div ng-if=\"receipt.track_bitacora\" class=\"identificador-dash-binnacle\"></div><a class=\"btn btn-warning btn-sm\" ng-click=\"$event.stopPropagation();applyEx()\" ng-if=\"receipt.excedente > 0\" style=\"background-color: white;border-color: #f8ac59;color: black;\"><i class=\"fa fa-plus\" aria-hidden=\"true\" title=\"Recibo con excedente sin aplicar\"></i></a><tasks click=\"addtask()\" type=\"3\" model=\"receipt.recibo_numero + \' del endoso de la póliza \' + vm.insurance.poliza_number\" associated=\"vm.insurance.id\"></tasks></td></tr></tbody></table><div class=\"col-xs-12\"><div class=\"identificador-dash-binnacle\" style=\"width: 30px;\"></div><span class=\"margin-right-34\">Hay comentarios en la bitácora.</span></div></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle_receiptE\"><div class=\"col-md-12\"><div><label>Bitácora de recibos de Endosos</label> <a class=\"btn btn-info pull-right\" ng-click=\"vm.returnToReceiptsE()\"><span class=\"fa fa-arrow-left\"></span> Regresar</a></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data_receipt\" typemodel=\"4\" config=\"vm.comments_config\" idmodel=\"vm.receipt_id\" receiptmodel=\"receiptmodel\" exportable=\"true\"></comments></div></div></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"receipt in vm.endorsement_receipts_show track by $index\" ng-if=\"receipt.receipt_type == 2\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}:{{ receipt.recibo_numero }} / {{vm.endorsement_receipts_show.length }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ng-click=\"vm.changeStatusModal(receipt)\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ receipt.recibo_numero }} / {{vm.endorsement_receipts_show.length }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ receipt.prima_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p>{{ receipt.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ receipt.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ receipt.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ receipt.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{receipt.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p><span>{{ statusReceipts(receipt.status) }}</span></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacleReceipt(receipt)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></tr></table></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"vm.showHistoric\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Histórico renovaciones y cancelaciones</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div ng-if=\"!vm.show_binnacle_receipt\"><table class=\"table table-bordered table-hover table hidden-xs hidden-sm\"><thead><tr><th>Número de Póliza</th><th>Vigencia</th><th>Estatus</th><th>Fecha de Renovación</th><th>Renovado Por:</th></tr></thead><tbody><tr ng-repeat=\"policy in vm.policy_history track by $index\" ng-click=\"goToPolicy(policy)\"><td ng-if=\"policy.poliza_number\">{{policy.poliza_number}}</td><td ng-if=\"!policy.poliza_number\">Sin número asignado</td><td>{{ policy.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ policy.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{status(policy.status)}}</td><td>{{policy.created_at | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{policy.owner}}</td></tr></tbody></table></div></div></div></div></div><br><div class=\"col-xs-12 form-group\" style=\"margin-bottom: 40px;\"><h4>Observaciones:</h4><textarea disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.observations\"></textarea></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"vm.permiso_administrar_adjuntos\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"col-xs-12 text-right form-group\" ng-if=\"vm.permiso_administrar_adjuntos\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(vm.insurance.id)\">Guardar Archivos</button></div><table class=\"table table-bordered table\"><h3 class=\"text-center\">Archivos que estan actualmente en la base de datos</h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th ng-if=\"vm.permiso_archivos && vm.permiso_administrar_adjuntos\" width=\"200px\"></th></tr></thead><tbody><tr ng-repeat=\"file in vm.files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input name=\"text_input\" class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"saveFile(file)\" ng-if=\"vm.permiso_administrar_adjuntos\"></td><td><a class=\"btn btn-success\" target=\"_blank\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <button class=\"btn btn-danger btn-bm0\" ng-click=\"vm.deleteFile(file,vm.files)\" ng-if=\"vm.permiso_administrar_adjuntos\">Borrar</button> <button class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"vm.permiso_administrar_adjuntos\">Renombrar</button> <span class=\"btn btn-success display-none\">Guardar</span></td><td ng-if=\"vm.permiso_archivos && vm.permiso_administrar_adjuntos\"><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> * Archivo sensible</td></tr></tbody></table></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"1\" idmodel=\"vm.polizaId\" exportable=\"true\"></comments></div></div></div></div></div><script type=\"text/javascript\">\n    function renombrarArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"[name=\'text_input\']\");\n\n      inputTag.removeClass(\'display-none\');\n      strongTag.addClass(\'display-none\');\n      inputTag.focus();\n   }\n   function blurArchivoCargado(){\n      var strongTag = $(event.target).parent().parent().find(\"td strong\");\n      var inputTag = $(event.target).parent().parent().find(\"[name=\'text_input\']\");\n\n      inputTag.addClass(\'display-none\');\n      strongTag.removeClass(\'display-none\');\n    }\n  </script></div>");
$templateCache.put("app/polizas/polizas.plantillas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Pólizas</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Plantillas de Pólizas</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-6\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createQuotation()\">Agregar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"col-xs-12 btn btn-secondary m-t\" ng-click=\"cambiarCampos()\">Campos en el Correo</button></div><div class=\"ibox\" ng-if=\"configurar\"><div class=\"ibox-title-c bg-light-gray clearfix\"><h3 class=\"section-title\" style=\"text-align: center;\">Configuración de Visualización en Correo</h3><span class=\"pull-right\" ng-click=\"cambiarCampos()\" style=\"cursor: pointer; color: #888;\" title=\"Cerrar sección\"><i class=\"fa fa-times fa-lg\"></i></span></div><div class=\"ibox-content-c row\"><form class=\"form-inline\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><div class=\"col-sm-3 value-email\" ng-repeat=\"campo in [ { id: \'fecha_limite_email\', label: \'Agregar Fecha límite de Pago al compartir una Póliza\', key: \'fecha_limite_email\' }, { id: \'dato_pvigencia\', label: \'Vigencia\', key: \'vigencia\' }, { id: \'dato_paseguradora\', label: \'Compañía\', key: \'compania\' }, { id: \'dato_psubramo\', label: \'Subramo\', key: \'subramo\' }, { id: \'dato_pmoneda\', label: \'Moneda\', key: \'moneda\' }, { id: \'dato_pfrecuenciapago\', label: \'Frecuencia de Pago\', key: \'frecuenciapago\' }, { id: \'dato_pasegurado\', label: \'Asegurado\', key: \'asegurado\' }, { id: \'dato_ptotal\', label: \'Prima Total de la Póliza\', key: \'total\' }, { id: \'dato_ptotalrecibo\', label: \'Prima Total del 1er Recibo\', key: \'totalrecibo\' } ]\"><div class=\"checkbox checkbox-inline-c\"><label><input type=\"checkbox\" id=\"{{campo.id}}\" ng-model=\"configuracionGlobal[campo.id]\" ng-change=\"cambiarDato(campo.id, configuracionGlobal[campo.id])\"> {{campo.label}}</label></div></div></div></div></form></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"showQuotation\" style=\"margin-left: 25px;padding-right: 75px;\"><legend ng-if=\"!showEditInformation\" class=\"legend-title\" align=\"center\">Nueva Plantilla</legend><legend ng-if=\"showEditInformation\" class=\"legend-title\" align=\"center\">Actualizar Plantilla</legend><form class=\"row\" name=\"form\"><div class=\"col-xs-12 col-sm-5 form-group\"><label>Nombre de la Plantilla <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"plantilla.name\" name=\"plantillaName\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Ramo(s) <span class=\"color-red\">*</span></label><select id=\"ramoSelect\" class=\"js-example-basic-multiple col-xs-12 form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"plantilla.ramo_code\" data-ng-options=\"codes.descr ? codes.descr : codes.code for codes in allRamos | orderBy: \'descr\' track by codes.code\" ng-change=\"selectProv(select_code)\" required=\"\" ng-required=\"true\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-2 form-group\"><label for=\"defaultsubject\"><input id=\"plantilla.subject_default\" type=\"checkbox\" ng-model=\"plantilla.subject_default\"> Asunto Default</label></div><div class=\"col-xs-12 col-sm-5 form-group\"><label ng-if=\"plantilla.subject_default==false\">Asunto <span class=\"color-red\">*</span></label> <input ng-if=\"plantilla.subject_default==false\" class=\"form-control\" type=\"text\" ng-model=\"plantilla.title\" name=\"plantillaSubject\" required=\"\"></div><button type=\"button\" class=\"btn btn-default ng-scope pull-right\" unselectable=\"on\" tabindex=\"-1\" ng-click=\"getFile()\" ng-disabled=\"!editor_focus\"><i class=\"fa fa-upload\"></i></button><div class=\"col-xs-12 form-group\"><label>Texto Superior <span class=\"color-red\">*</span></label><div text-angular=\"\" ng-model=\"plantilla.text\" name=\"plantillaText\" ng-focus=\"focusEditor()\" ng-blur=\"unfocusEditor()\" required=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Texto Inferior <span class=\"color-red\">*</span></label><div text-angular=\"\" name=\"plantillaBottom\" ng-focus=\"focusEditor()\" ng-blur=\"unfocusEditor()\" ng-model=\"plantilla.bottom_text\" required=\"\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button ng-if=\"!showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid || savingPlantilla\" ng-click=\"saveDelivery(plantilla)\">Crear Plantilla</button> <button ng-if=\"showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid || savingPlantilla\" ng-click=\"updateDelivery(plantilla)\">Actualizar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeTemplate()\">Cancelar</button></div></form></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Plantillas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\" ng-if=\"!showInfoQuotation\"><table class=\"table table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th>ID</th><th>Nombre</th><th>Asunto</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"item in vm.quotations track by $index\" ng-click=\"showInformation(item)\"><td>{{ item.id }}</td><td>{{ item.name }}</td><td>{{ item.title }}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-sm btn-white\" ng-click=\"editQuatation(item)\" title=\"Editar plantilla\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-sm btn-danger m-l-xs\" ng-click=\"borrarPlantilla(item)\" title=\"Eliminar plantilla\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"show_pagination\" class=\"text-center\"><pagination config=\"vm.config_pagination\" model=\"vm.quotations\"></pagination></div></div><div class=\"animate\" ng-if=\"showInfoQuotation\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showInformation(null)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Name:</span><div><span>{{ quotation.name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Asunto:</span><div><span>{{ quotation.title }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Texto Superior:</span><div text-angular=\"\" ng-model=\"quotation.text\" name=\"quotation.text\" ta-disabled=\"isReadOnly\"></div><br></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Texto Inferior:</span><div text-angular=\"\" ng-model=\"quotation.bottom_text\" name=\"quotation.bottom_text\" ta-disabled=\"isReadOnly\"></div></div></div></div></div></div>");
$templateCache.put("app/polizas/polizas.receiptsModal.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibo {{vmmm.recibo_numero}}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><br><div class=\"form-group col-md-6\"><label>Prima neta: $</label> <input class=\"form-control\" disabled=\"\" ng-model=\"vmmm.prima_neta\" format-as-currency=\"\" step=\"any\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>RPF: $</label> <input class=\"form-control\" disabled=\"\" ng-model=\"vmmm.rpf\" format-as-currency=\"\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Derecho: $</label> <input class=\"form-control\" disabled=\"\" ng-model=\"vmmm.derecho\" format-as-currency=\"\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>IVA(%):</label> <input class=\"form-control\" disabled=\"\" ng-model=\"vmmm.iva\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Sub Total: $</label> <input class=\"form-control\" disabled=\"\" ng-model=\"vmmm.sub_total\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Prima Total: $</label> <input class=\"form-control\" disabled=\"\" ng-model=\"vmmm.prima_total\" type=\"text\"></div><div class=\"form-group col-md-\"><label>Fecha de inicio</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" ng-model=\"vmmm.fecha_inicio\" view=\"year\" disabled=\"\"></div></div><div class=\"form-group col-md-\"><label>Fecha de fin</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" ng-model=\"vmmm.fecha_fin\" view=\"year\" disabled=\"\"></div></div></div></div></div></div></div>");
$templateCache.put("app/polizas/polizas.rehabilitar.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Rehabilitar Póliza</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"form-group col-sm-11\"><label for=\"motivo\">Motivo de rehabilitación: <span class=\"color-red\">*</span></label> <textarea type=\"text\" name=\"motivo\" ng-model=\"motivo_rehabilitacion\" class=\"form-control\"></textarea></div></div><div ng-if=\"mostrar_alerta\"><h3>*Al rehabilitar una póliza de grupo se activaran todos sus certificados</h3></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"close()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success ladda-button\" ng-disabled=\"!motivo_rehabilitacion\" ng-click=\"reActivatePolicy()\" type=\"button\">Rehabilitar Póliza</button></div></div>");
$templateCache.put("app/polizas/polizas.table.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading page-heading--modern\"><div class=\"col-xs-12 col-md-9\"><div class=\"col-lg-12\"><h2 class=\"page-heading__title\">Pólizas</h2><ol class=\"breadcrumb page-heading__breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><a ui-sref=\"polizas.table\">Listado de Pólizas</a></li></ol></div></div></div><br><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Número de póliza</label> <input class=\"form-control\" type=\"text\" name=\"poliza\" ng-model=\"vm.form.num_poliza\" ng-change=\"vm.saveLocalstorage()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val); vm.saveLocalstorage()\"></autocomplete></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val);vm.saveLocalstorage()\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"subgroups.length >0\"><label>SubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subgroup\" data-ng-options=\"subgroup.group_name for subgroup in subgroups track by subgroup.url\" ng-change=\"vm.changeSubgroup(vm.form.subgroup);vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"subsubgroups.length >0\"><label>SubsubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subsubgroup\" data-ng-options=\"subsubgroup.group_name for subsubgroup in subsubgroups track by subsubgroup.url\" ng-change=\"vm.changeSubsubgroup(vm.form.subsubgroup);vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-model=\"vm.form.businessLine\" data-ng-options=\"businesLine.name for businesLine in vm.businesLine track by businesLine.id\" ng-change=\"vm.changeBLine(vm.form.businessLine); vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todas las líneas</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"campo_agrupacion\"><label>Nivel de Agrupación</label><autocomplete datasource=\"groupinglevels_data\" id=\"groupingleves\" model=\"vm.form.groupinglevel\" change=\"vm.matchesGroupinglevel(vm.form.groupinglevel.val);vm.saveLocalstorage()\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.form.groupinglevel.subgrupos.length >0 && campo_agrupacion\"><label>SubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subgrouping\" data-ng-options=\"subgrouping.description for subgrouping in vm.form.groupinglevel.subgrupos track by subgrouping.url\" ng-change=\"vm.changeSubgrouping(vm.form.subgrouping); vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.form.subgrouping.subsubgrupos.length >0 && campo_agrupacion\"><label>SubsubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subsubgrouping\" data-ng-options=\"subsubgrouping.description for subsubgrouping in vm.form.subgrouping.subsubgrupos track by subsubgrouping.url\" ng-change=\"vm.changeSubsubgrouping(vm.form.subsubgrouping); vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-model=\"vm.form.celula\" data-ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"vm.changecelula(vm.form.celula); vm.saveLocalstorage()\"><option value=\"\">Todo</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Clasificación</label><autocomplete datasource=\"classification_data\" id=\"classification\" model=\"vm.form.classification\" change=\"vm.matchesClassification(vm.form.classification.val); vm.saveLocalstorage()\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Estatus</label><select class=\"form-control\" ng-model=\"vm.form.status\" data-ng-options=\"status.name for status in vm.status track by status.id\" ng-change=\"vm.changeStatus(vm.form.status); vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todos los status</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Forma de pago</label><select class=\"form-control\" ng-model=\"vm.form.payment\" data-ng-options=\"payment.name for payment in vm.payment track by payment.id\" ng-change=\"vm.changePayment(vm.form.payment); vm.saveLocalstorage()\" required=\"\"><option value=\"\">Todas las formas de pago</option></select></div><br><br><br><br><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.providers\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(vm.form.providers); vm.saveLocalstorage()\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.ramos\" ng-change=\"selectRamos(vm.form.ramos); vm.saveLocalstorage()\" data-ng-options=\"ramos_toselected.ramo_name for ramos_toselected in vm.ramos_toselected track by ramos_toselected.ramo_code\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.subramos\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.subramo_code\" ng-change=\"selectSubramos(vm.form.subramos); vm.saveLocalstorage()\"></select></div></div><div class=\"row col-xs-12 col-sm-6 col-md-6 form-group\"><label>Carátula:</label><br><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.word\" change=\"vm.getCaratulas(vm.word)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getCarSelected(vm.word);\"><span class=\"fa fa-ok\"></span> Seleccionar</button></div></div></div><br><br><div class=\"row\"><div ng-if=\"!fechasFilter\" class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-20\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.addFilter(1); vm.saveLocalstorage()\">Agregar filtro de fechas</button></div><div ng-if=\"fechasFilter\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since | date : \'medium\'}}\" ng-change=\"vm.options.changeSince(); vm.saveLocalstorage()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil(); vm.saveLocalstorage()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group check-options\"><br><div class=\"checkbox-inline nopadding\"><input type=\"radio\" ng-model=\"incio_fin\" ng-click=\"valueRadio(incio_fin); vm.saveLocalstorage()\" value=\"true\"> <span ng-class=\"{\'receipts-select\': incio_fin == \'true\'}\">Inicio de vigencia</span></div><div class=\"checkbox-inline nopadding pull-right\"><input type=\"radio\" ng-model=\"incio_fin\" ng-click=\"valueRadio(incio_fin); vm.saveLocalstorage()\" value=\"false\"> <span ng-class=\"{\'receipts-select\': incio_fin == \'false\'}\">Fin de vigencia</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 margin-top-20\"><button class=\"btn btn-sm btn-warning\" ng-click=\"vm.addFilter(2)\">x</button></div></div><div class=\"col-xs-12 col-sm-6 col-md-12 form-group btn-action\" ng-if=\"vm.canConsultar()\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.search(3, 1,1); vm.searchOT(3, 1,1,1)\">Consultar</button></div></div></div></div></div></div><div class=\"row\" ng-if=\"busqueda && vm.acceso_ver_pol\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Pólizas</h5><div ibox-tools=\"\"></div></div><ul id=\"contextPolizas\" class=\"dropdown-menu\" role=\"menu\" z-index=\"1000\"></ul><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!vm.show_binnacle\"><div class=\"results-container\"><div class=\"col-xs-12 panel-body\"><legend class=\"col-xs-12 legend-title visible-xs-block visible-sm-block\" align=\"center\">Resultado de pólizas</legend><div class=\"results-content\"></div></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in vm.search_results track by $index\" ng-if=\"insurance.document_type == 1\"><div class=\"ibox-title\"><h5>Póliza: {{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ui-sref=\"polizas.info({polizaId: insurance.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>Tipo</label><p>Póliza</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Póliza</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Contratante</label><p>{{ insurance.natural.first_name }} {{insurance.natural.last_name}} <span ng-if=\"insurance.natural.second_last_name\">{{insurance.natural.second_last_name}}</span> {{ insurance.juridical.j_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Aseguradora</label><p>{{ insurance.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Subramo</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Forma de pago</label><p payment=\"{{insurance.forma_de_pago}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Estatus</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Vigencia</label><p>{{ insurance.start_of_validity | date: \'medium\': \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Antigüedad</label><p ng-if=\"!(insurance.antiguedad > 0)\">0 días</p><p ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Acciones</label><p ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></div></div></div></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in vm.search_results track by $index\" ng-if=\"insurance.document_type == 3\"><div class=\"ibox-title\"><h5>Colectividad: {{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ui-sref=\"colectividades.info({polizaId: insurance.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>Tipo</label><p>Colectividad</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Póliza</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Contratante</label><p>{{ insurance.natural.first_name }} {{insurance.natural.last_name}} <span ng-if=\"insurance.natural.second_last_name\">{{insurance.natural.second_last_name}}</span> {{ insurance.juridical.j_name }} {{ insurance.contractor.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Aseguradora</label><p>{{ insurance.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Subramo</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Forma de pago</label><p payment=\"{{insurance.forma_de_pago}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Estatus</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Vigencia</label><p>{{ insurance.start_of_validity | date: \'medium\': \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Antigüedad</label><p ng-if=\"!(insurance.antiguedad > 0)\">0 días</p><p ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Acciones</label><p ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></div></div></div></div><table class=\"table table-stripped table-hover hidden-xs hidden-sm\"><thead><tr><th ng-click=\"vm.changeOrder(1, vm.order_type_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_type_asc == 1, \'fa fa-sort-asc\': vm.order_type_asc == 2}\"></span></th><th width=\"5%\">Identificador</th><th ng-click=\"vm.changeOrder(2, vm.order_poliza_asc == 1 ? 2 : 1)\" width=\"5%\">Póliza <span ng-class=\"{\'fa fa-sort-desc\': vm.order_poliza_asc == 1, \'fa fa-sort-asc\': vm.order_poliza_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(3, vm.order_contractor_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.order_contractor_asc == 1, \'fa fa-sort-asc\': vm.order_contractor_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(4, vm.order_provider_asc == 1 ? 2 : 1)\">Aseguradora <span ng-class=\"{\'fa fa-sort-desc\': vm.order_provider_asc == 1, \'fa fa-sort-asc\': vm.order_provider_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(5, vm.order_subramo_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_subramo_asc == 1, \'fa fa-sort-asc\': vm.order_subramo_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(6, vm.order_pay_asc == 1 ? 2 : 1)\">Forma de pago <span ng-class=\"{\'fa fa-sort-desc\': vm.order_pay_asc == 1, \'fa fa-sort-asc\': vm.order_pay_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(7, vm.order_status_asc == 1 ? 2 : 1)\">Estatus <span ng-class=\"{\'fa fa-sort-desc\': vm.order_status_asc == 1, \'fa fa-sort-asc\': vm.order_status_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(8, vm.order_vigencia_asc == 1 ? 2 : 1)\">Vigencia <span ng-class=\"{\'fa fa-sort-desc\': vm.order_vigencia_asc == 1, \'fa fa-sort-asc\': vm.order_vigencia_asc == 2}\"></span></th><th ng-click=\"vm.changeOrder(9, vm.order_anti_asc == 1 ? 2 : 1)\">Antigüedad <span ng-class=\"{\'fa fa-sort-desc\': vm.order_anti_asc == 1, \'fa fa-sort-asc\': vm.order_anti_asc == 2}\"></span></th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.search_results track by $index\" ng-click=\"vm.goToInfo(insurance)\" context=\"contextPolizas\" ng-right-click=\"ShowContextMenu(\'Información pólizas \'+ insurance.poliza_number ,insurance.document_type, insurance)\"><td ng-if=\"insurance.document_type == 1\">Póliza {{insurance.historic}}</td><td ng-if=\"insurance.document_type == 3\">Poliza de Grupo {{insurance.historic}}</td><td ng-if=\"insurance.document_type == 11\">Colectividad {{insurance.historic}}</td><td ng-if=\"insurance.document_type == 12\">Póliza de Colectividad {{insurance.historic}}</td><td>{{ insurance.identifier }}</td><td>{{ insurance.poliza_number }}</td><td><span>{{ insurance.natural.first_name }} {{insurance.natural.last_name}} <span ng-if=\"insurance.natural.second_last_name\">{{insurance.natural.second_last_name}}</span>{{insurance.juridical.j_name}}{{insurance.contractor.full_name}}</span></td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.subramo }}</td><td>{{payment(insurance.forma_de_pago)}}</td><td>{{status(insurance.status)}} <span ng-if=\"!insurance.existe_ot_renovacion && insurance.org_name ==\'ancora\' && insurance.renewed_status ==2 && insurance.is_renewable==1\">- En Proceso de Renovación</span></td><td>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</td><td ng-if=\"!(insurance.antiguedad > 0)\">0 días</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" title=\"Creado por: {{insurance.owner}}\"><i class=\"fa fa-info\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"4\" model=\"insurance.poliza_number\" associated=\"insurance.id\"></tasks></td></tr></tbody></table><div ng-if=\"vm.show_pag_search\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.show_binnacle && vm.acceso_rep_pol && vm.search_results.length >0\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.buttonReport == true; vm.search_results.length\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataFilter(1)\">Generar Reporte</button></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><div class=\"row\"><a class=\"col-xs-12 btn btn-info\" ng-click=\"vm.returnToReceipts()\"><span class=\"fa fa-reply\"></span> Regresar</a></div></div><comments datasource=\"vm.comments_data\" typemodel=\"1\" config=\"vm.comments_config\" idmodel=\"vm.policy_id\" exportable=\"true\"></comments></div></div></div></div><div class=\"row ot-results-container\" ng-if=\"busqueda && vm.acceso_ver_ot\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Órdenes de Trabajo</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!vm.show_binnacle_ot\"><div class=\"results-container\"><div class=\"col-xs-12 panel-body\"><legend class=\"col-xs-12 legend-title visible-xs-block visible-sm-block\" align=\"center\">Resultado de OT</legend><div class=\"results-content\"><div class=\"row visible-sm-block\" ng-if=\"!vm.ot_results.length\"><div class=\"table-cell col-xs-12 text-center\">No se han encontrado registros</div></div><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in vm.ot_results track by $index\"><div class=\"ibox-title\"><h5>OT: {{ insurance.internal_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ng-click=\"vm.goToInfo(insurance)\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>Orden de trabajo</label><p>{{ insurance.internal_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Contratante</label><p>{{ insurance.natural.first_name }} {{insurance.natural.last_name}} <span ng-if=\"insurance.natural.second_last_name\">{{insurance.natural.second_last_name}}</span> {{ insurance.juridical.j_name }}{{insurance.contractor.full_name}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Aseguradora</label><p>{{ insurance.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Paquete</label><p>{{ insurance.paquete }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Subramo</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Forma de pago</label><p payment=\"{{insurance.forma_de_pago}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Estatus</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Vigencia</label><p>{{ insurance.start_of_validity | date: \'dd-MM-yyyy\': \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Antigüedad</label><p ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</p><p ng-if=\"!(insurance.antiguedad > 0)\">0 días</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Acciones</label><p ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></div></div></div></div><table class=\"table table-stripped table-hover hidden-xs hidden-sm\"><thead><tr><th ng-click=\"vm.changeOrderOT(1, vm.order_ot_asc == 1 ? 2 : 1)\">Orden de trabajo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_ot_asc == 1, \'fa fa-sort-asc\': vm.order_ot_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(2, vm.order_conot_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.order_conot_asc == 1, \'fa fa-sort-asc\': vm.order_conot_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(3, vm.order_aseg_asc == 1 ? 2 : 1)\">Aseguradora <span ng-class=\"{\'fa fa-sort-desc\': vm.order_aseg_asc == 1, \'fa fa-sort-asc\': vm.order_aseg_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(4, vm.order_package_asc == 1 ? 2 : 1)\">Paquete <span ng-class=\"{\'fa fa-sort-desc\': vm.order_package_asc == 1, \'fa fa-sort-asc\': vm.order_package_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(5, vm.order_subot_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': vm.order_subot_asc == 1, \'fa fa-sort-asc\': vm.order_subot_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(6, vm.order_payot_asc == 1 ? 2 : 1)\">Forma de pago <span ng-class=\"{\'fa fa-sort-desc\': vm.order_payot_asc == 1, \'fa fa-sort-asc\': vm.order_payot_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(7, vm.order_statot_asc == 1 ? 2 : 1)\">Estatus <span ng-class=\"{\'fa fa-sort-desc\': vm.order_statot_asc == 1, \'fa fa-sort-asc\': vm.order_statot_asc == 2}\"></span></th><th ng-click=\"vm.changeOrderOT(8, vm.order_valot_asc == 1 ? 2 : 1)\">Vigencia <span ng-class=\"{\'fa fa-sort-desc\': vm.order_valot_asc == 1, \'fa fa-sort-asc\': vm.order_valot_asc == 2}\"></span></th><th>Antigüedad</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.ot_results track by $index\" ng-click=\"vm.goToInfo(insurance)\" context=\"contextPolizas\" ng-right-click=\"ShowContextMenu(\'Información pólizas\',\'polizas.info\', insurance.id)\"><td>{{ insurance.internal_number }}</td><td ng-if=\"from_activate\">{{ insurance.natural.first_name }} {{insurance.natural.last_name}} <span ng-if=\"insurance.natural.second_last_name\">{{insurance.natural.second_last_name}}</span>{{ insurance.juridical.j_name }}{{insurance.contractor.full_name}}</td><td ng-if=\"!from_activate\">{{ insurance.natural.first_name }} {{insurance.natural.last_name}} <span ng-if=\"insurance.natural.second_last_name\">{{insurance.natural.second_last_name}}</span>{{ insurance.juridical.j_name }}{{insurance.contractor.full_name}}</td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.paquete }}</td><td>{{ insurance.subramo }}</td><td payment=\"{{insurance.forma_de_pago}}\"></td><td status=\"{{insurance.status}}\"></td><td>{{ insurance.start_of_validity | date: \'dd-MM-yyyy\': \'UTC\'}}</td><td ng-if=\"insurance.antiguedad > 0\">{{ insurance.antiguedad }} días</td><td ng-if=\"!(insurance.antiguedad > 0)\">0 días</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"1\" model=\"insurance.internal_number\" associated=\"insurance.id\"></tasks></td></tr></tbody></table><div ng-if=\"vm.show_pag_search_ot\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacionOT && paginacionOT[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPaginaOT(paginaOT)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"paginaOT in paginacionOT.totalPaginas\" ng-click=\"selecionPaginaOT(paginaOT)\" ng-class=\"{\'active\': paginaOT === paginacionOT.paginaActual}\"><a class=\"page-link\" role=\"button\">{{paginaOT}}</a></li><li class=\"page-item\" ng-click=\"siguientePaginaOT(paginaOT)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.show_results\"><div class=\"results-container visible-xs-block visible-sm-block\"><div class=\"results-links\"><div class=\"col-xs-12\"><a class=\"col-xs-12 btn btn-default\" ng-click=\"vm.showOTPendientes(); getPolicies(6);\">En trámite</a></div><div class=\"col-xs-12\"><a class=\"col-xs-12 btn btn-default\" ng-click=\"vm.showOTCanceladas(); getPolicies(7);\">OT Canceladas</a></div></div><div class=\"results-content\"><div class=\"col-xs-12 panel-body\" ng-show=\"vm.oPendientes\"><legend class=\"col-xs-12 legend-title visible-xs-block visible-sm-block\" align=\"center\">En trámite</legend><div class=\"results-content\"><div class=\"ibox float-e-margins border-bottom\" ng-repeat=\"ot in vm.ot track by $index\" ng-if=\"ot.status == 1\"><div class=\"ibox-title\"><h5>OT: #{{ ot.internal_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ui-sref=\"polizas.info({polizaId: ot.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>Orden de trabajo</label><p>{{ ot.internal_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Contratante</label><p>{{ ot.natural }} {{ ot.juridical }} {{ot.contractor}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Aseguradora</label><p>{{ ot.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Paquete</label><p>{{ ot.paquete }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Subramo</label><p>{{ ot.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Antigüedad</label><p ng-if=\"ot.antiguedad > 0\">{{ ot.antiguedad }} días</p><p ng-if=\"!(ot.antiguedad > 0)\">0 días</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Acciones</label><p ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(ot)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"1\" model=\"insurance.internal_number\" associated=\"ot.id\"></tasks></p></div></div></div></div></div></div></div><div class=\"col-xs-12 panel-body\" ng-show=\"vm.oCanceladas\"><legend class=\"col-xs-12 legend-title visible-xs-block visible-sm-block\" align=\"center\">Pólizas Canceladas</legend><div class=\"results-content\"><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"ot in vm.ot track by $index\" ng-if=\"ot.status == 2\"><div class=\"ibox-title\"><h5>OT: #{{ ot.internal_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\" ui-sref=\"polizas.info({polizaId: ot.id})\"><div class=\"table-flex\"><div class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>Orden de trabajo</label><p>{{ ot.internal_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Contratante</label><p>{{ ot.natural }} {{ ot.juridical }} {{ot.contractor}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Aseguradora</label><p>{{ ot.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Paquete</label><p>{{ ot.paquete }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Subramo</label><p>{{ ot.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Antigüedad</label><p ng-if=\"ot.antiguedad > 0\">{{ ot.antiguedad }} días</p><p ng-if=\"!(ot.antiguedad > 0)\">0 días</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Acciones</label><p ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(ot)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></p></div></div></div></div></div></div></div></div></div><div class=\"results-container hidden-xs hidden-sm\"><div class=\"tabs\" ng-if=\"!vm.show_results\"><uib-tabset><uib-tab heading=\"Pendientes\" id=\"otpendientes\" ng-click=\"getPolicies(6)\"><div class=\"panel-body\"><div class=\"table-container\"><table class=\"table table-striped table-hover\"><thead><tr><th>Orden de trabajo</th><th>Contratante</th><th>Aseguradora</th><th>Paquete</th><th>Subramo</th><th>Antigüedad</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"ot in vm.ot track by $index\" ui-sref=\"polizas.info({polizaId: ot.id})\" ng-if=\"ot.status == 1\"><td>{{ ot.internal_number }}</td><td>{{ ot.natural }} {{ ot.juridical }}{{ ot.contractor }}</td><td>{{ ot.aseguradora }}</td><td>{{ ot.paquete }}</td><td>{{ ot.subramo }}</td><td ng-if=\"ot.antiguedad > 0\">{{ ot.antiguedad }} días</td><td ng-if=\"!(ot.antiguedad > 0)\">0 días</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(ot)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"1\" model=\"insurance.internal_number\" associated=\"ot.id\"></tasks></td></tr></tbody></table><div ng-if=\"vm.show_pag_ot\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block_ot\" ng-click=\"previousBlockPagesOT()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages_ot | slice:start:end\" ng-class=\"{\'active\': page === actual_page_ot}\" ng-click=\"selectPageOT(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPagesOT()\" ng-if=\"totalPages_ot.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPageOT()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></uib-tab><uib-tab heading=\"Canceladas\" id=\"otcanceladas\" ng-click=\"getPolicies(7)\" ng-if=\"!vm.show_results\"><div class=\"panel-body\"><div class=\"table-container\"><table class=\"table table-striped table-hover\"><thead><tr><th>Orden de trabajo</th><th>Contratante</th><th>Aseguradora</th><th>Paquete</th><th>Subramo</th><th>Antigüedad</th></tr></thead><tbody><tr ng-repeat=\"ot in vm.ot track by $index\" ui-sref=\"polizas.info({polizaId: ot.id})\" ng-if=\"ot.status == 2\"><td>{{ ot.internal_number }}</td><td>{{ ot.natural }} {{ ot.juridical }}{{ ot.contractor }}</td><td>{{ ot.aseguradora }}</td><td>{{ ot.paquete }}</td><td>{{ ot.subramo }}</td><td ng-if=\"ot.antiguedad > 0\">{{ ot.antiguedad }} días</td><td ng-if=\"!(ot.antiguedad > 0)\">0 días</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(ot)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"1\" model=\"insurance.internal_number\" associated=\"ot.id\"></tasks></td></tr></tbody></table><div ng-if=\"vm.show_pag_ot && vm.ot_config.count > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block_ot\" ng-click=\"previousBlockPagesOT()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages_ot | slice:start:end\" ng-class=\"{\'active\': page === actual_page_ot}\" ng-click=\"selectPageOT(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPagesOT()\" ng-if=\"totalPages_ot.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPageOT()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></uib-tab></uib-tabset></div></div></div><div class=\"row\" ng-if=\"!vm.show_binnacle_ot && vm.acceso_rep_pol && vm.ot_results.length > 0\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3\"><button ng-model=\"vm.buttonReport\" class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataFilter(2)\">Generar Reporte OT</button></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle_ot\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><div class=\"row\"><a class=\"col-xs-12 btn btn-info\" ng-click=\"vm.returnToReceipts(2)\"><span class=\"fa fa-reply\"></span> Regresar</a></div></div><comments datasource=\"vm.comments_data\" typemodel=\"1\" config=\"vm.comments_config\" idmodel=\"vm.policy_id_ot\"></comments></div></div></div></div></div><script type=\"text/javascript\">  \n  $(window).load(function() { $(\"#state\").select2(); });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script></div>");
$templateCache.put("app/polizas/recalculoModal.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Recalcular Recibos</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Frecuencia de Pago:</label><select class=\"form-control\" ng-model=\"datareceipt.payment\" ng-options=\"payment.name for payment in payments\" ng-change=\"changePayment(datareceipt.payment)\"><option value=\"\">Selecciona una frecuencia</option></select></div><div class=\"col-xs-12 form-group\"><receipts-individual form=\"order.form\" tosave=\"order\" type=\"1\"></receipts-individual></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"saveNewReceipts()\">Guardar Cambios</button></div></div>");
$templateCache.put("app/polizas/recibos.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Prima de la Póliza</h4></div><div class=\"modal-body\"><div class=\"col-sm-6 form-group\"><label>Prima neta: $</label> <input type=\"number\" value=\"\" class=\"form-control m-b\" format-as-currency=\"\" id=\"prima-neta\" ng-model=\"poliza.primaNeta\" placeholder=\"\"></div><div class=\"col-sm-6 form-group\"><label>RPF: $</label> <input type=\"number\" value=\"\" class=\"form-control m-b\" format-as-currency=\"\" id=\"rpf\" ng-model=\"poliza.rpf\" placeholder=\"\"></div><div class=\"col-sm-6 form-group\"><label>Derecho de Póliza: $</label> <input type=\"number\" value=\"\" class=\"form-control m-b\" format-as-currency=\"\" id=\"derecho\" ng-model=\"poliza.derecho\" placeholder=\"\"></div><div class=\"col-sm-6 form-group\"><label>IVA:</label> <input type=\"text\" value=\"\" class=\"form-control\" id=\"iva\" ng-model=\"poliza.iva\" placeholder=\"\"></div><div class=\"col-sm-6 form-group\"><label>Sub-Total: $</label> <input type=\"number\" value=\"\" class=\"form-control\" id=\"sub-total\" ng-model=\"poliza.subTotal\" placeholder=\"\" disabled=\"\"></div><div class=\"col-sm-6 form-group\"><label>Prima Total:$</label> <input type=\"number\" value=\"\" class=\"form-control\" id=\"prima-total\" ng-model=\"poliza.primaTotal\" placeholder=\"\" disabled=\"\"></div><button type=\"button\" id=\"calculate\" name=\"button\" class=\"btn btn-primary\" ng-click=\"calculate()\">Calcular y generar recibos</button><div id=\"personalizado\"><div id=\"divConfigDerecho\" class=\"checkbox\"><label><input id=\"configDerecho\" type=\"checkbox\" ng-model=\"configDerecho\">Derecho - Cargos sólo al primer recibo</label></div><div id=\"divConfigRPF\" class=\"checkbox\"><label><input id=\"configRPF\" type=\"checkbox\" ng-model=\"configRPF\">RPF - Cargos sólo al primer recibo</label></div></div><div ng-if=\"showReceipts\" class=\"form-horizontal\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-6 h4\">Cantidad de recibos: {{amountReceipts}}</label></div></div><div ng-if=\"showReceipts\"><h5><strong>Recibo inicial</strong></h5><form method=\"post\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-repeat=\"receipt in receipts track by $index\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Recibo # {{$index + 1}}</div><div class=\"panel-body\"><div class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Prima neta: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.prima\" step=\"any\" type=\"text\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">RPF: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.rpf\" type=\"text\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Derecho: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.derecho\" type=\"text\"></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">IVA(%):</label><div class=\"col-sm-8\"><input class=\"form-control\" disabled=\"\" ng-model=\"receipt.iva\" type=\"number\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Sub Total: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.subTotal\" type=\"number\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Prima Total: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.total\" type=\"number\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de inicio</label><div class=\"col-sm-8\"><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"receipt.startDate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de fin</label><div class=\"col-sm-8\"><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"receipt.endingDate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div></div></div></div></div></div></div></div></form></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Guardar</button></div></div>");
$templateCache.put("app/polizas/referenciadores.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Cambiar Referenciador: {{referenciador_a_cambiar.first_name}} {{referenciador_a_cambiar.last_name}}, Póliza {{poliza_especifica.poliza_number}}</h4></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"form-group col-sm-6\"><label for=\"selectType\">Nuevo Referenciador:</label><select class=\"form-control m-b\" ng-model=\"refSelected\" ng-options=\"item as item.name for item in referenciadores track by item.id\"><option disabled=\"\" value=\"\">Selecciona una opción</option></select></div><div class=\"form-group col-sm-6\"><label for=\"selectType\">Comisión:</label> <input class=\"form-control m-b col-xs-12 wb102\" type=\"number\" ng-min=\"0\" placeholder=\"% Comisión\" ng-model=\"comision_vendedor\" ng-blur=\"validateComision()\" ng-disabled=\"!refSelected\"></div></div><div class=\"alert alert-danger\" ng-show=\"comisionError2\">{{ comisionError2 }}</div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success ladda-button\" ng-disabled=\"!refSelected\" ng-click=\"cambiar(refSelected,comision_vendedor)\" type=\"button\">Cambiar Referenciador</button></div>");
$templateCache.put("app/polizas/subramos.accidentes.gastos.html","<div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Formularios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"form-group\"><label class=\"control-label\">Nombre</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\"><label class=\"control-label\">Apellido</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\"><label class=\"control-label\">Parentesco</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\"><label class=\"control-label\">Titular: sólo puede haber uno</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\"><label class=\"control-label\">Cónyuge: sólo puede haber uno</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\"><label class=\"control-label\">Hijo (a): puede haber varios</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\" id=\"data_2\"><label class=\"control-label\">Fecha de Nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" ng-model=\"vm.form.birthday\" view=\"year\"></div></div><div class=\"form-group\"><label class=\"control-label\">Sexo</label><select class=\"form-control m-b\" name=\"\"><option value=\"M\">MASCULINO</option><option value=\"F\">FEMENINO</option></select></div><div class=\"form-group\"><label class=\"control-label\">Placas</label> <input class=\"form-control\" type=\"text\"></div></div></div></div>");
$templateCache.put("app/polizas/subramos.danos.autos.html","<div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Formularios {{example}}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\">{{packages.forms_subramo.length}}<div class=\"form-group\" ng-repeat=\"form in forms\"><label class=\"control-label\">{{form.label}}</label> <input class=\"form-control\" type=\"text\" value=\"{{form.answer}}\"></div></div></div></div>");
$templateCache.put("app/polizas/subramos.danos.danos.html","<div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Formularios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"form-group\"><label class=\"control-label\">Bien asegurado</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\"><label class=\"control-label\">Domicilio de bien aesgurado</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\"><label class=\"control-label\">Detalles del bien</label> <input class=\"form-control\" type=\"text\"></div></div></div></div>");
$templateCache.put("app/polizas/subramos.vida.vida.html","<div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Formularios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"form-group\"><label class=\"control-label\">Nombre</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\"><label class=\"control-label\">Apellido</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\" id=\"data_2\"><label class=\"control-label\">Fecha de Nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" ng-model=\"vm.form.birthday\" view=\"year\"></div></div><div class=\"form-group\"><label class=\"control-label\">Sexo</label><select class=\"form-control m-b\" name=\"\"><option value=\"M\">MASCULINO</option><option value=\"F\">FEMENINO</option></select></div><div class=\"form-group\"><label class=\"control-label\">Fumador</label><select class=\"form-control m-b\" name=\"\"><option value=\"S\">Si</option><option value=\"N\">No</option></select></div><div class=\"form-group\"><label class=\"control-label\">Beneficiarios(s) (nombre completo, separado por nombre y apellidos)</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\"><label class=\"control-label\">Parentesco</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\"><label class=\"control-label\">Fecha de nacimiento</label> <input class=\"form-control\" type=\"text\"></div><div class=\"form-group\"><label class=\"control-label\">Porcentaje</label> <input class=\"form-control\" type=\"text\"></div></div></div></div>");
$templateCache.put("app/recordatorios/certificado.modal.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Información Certificado</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\" ng-init=\"poliza = false; recibos = true; bitacora = false\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': true }\"><a>Información de Certificado</a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': true}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"goToPolicy(poliza)\">Ver Certificado</a></li></ul></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Nombre:</span><div><span>{{poliza.parentContractor}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Dirección:</span><div><span>{{poliza.contractor.address.route}} {{poliza.contractor.address.street_number}}, {{poliza.contractor.address.sublocality}}.</span><div><span>{{ poliza.contractor.address.administrative_area_level_1}}, {{poliza.contractor.address.administrative_area_level_2}}.</span></div></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ poliza.contractor.phone_number | phonenumber }}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{ poliza.contractor.email }}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.contractor.description\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ poliza.contractor.description }}</span></div></div></div><div class=\"col-xs-12 col-md-8 border-left\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"form-group col-sm-6\"><span class=\"blue-color\">{{recordatorio.instancia.identificador}}</span><br><span class=\"blue-color\">{{recordatorio.instancia.poliza_parent}}</span><div></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Aseguradora - Cve Agente:</span><div><span>{{recordatorio.instancia.aseguradora_parent}} - {{recordatorio.instancia.clave_parent}} <span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Ramo:</span><div><span>{{poliza.ramo.ramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Subramo:</span><div><span>{{poliza.subramo.subramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Paquete:</span><div><span>{{poliza.paquete.package_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Vigencia:</span><div><span>{{poliza.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{forma_pago(poliza.forma_de_pago)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Estatus:</span><div><span>{{status(poliza.status)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"poliza.f_currency == 1\">PESOS</span> <span ng-if=\"poliza.f_currency == 2\">DOLARES</span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\"><strong>Creado por:</strong></span><div><span>{{poliza.owner.first_name}} {{poliza.owner.last_name}}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.observations\"><span class=\"blue-color\">Observaciones:</span><div><span>{{poliza.observations}}</span></div></div></div></div></div></div></div></form></div></div><div class=\"row\"><legend class=\"legend-title\" align=\"center\">Recordatorio</legend><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Resumen:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.nombre}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Descripción:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.descr }}</span></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\'); \n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/recordatorios/contratante.modal.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Información Contratante</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\" ng-init=\"poliza = false; recibos = true; bitacora = false\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': true }\"><a>Información de Contratante</a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': true}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"goToContractor(poliza)\">Ver Contratante</a></li></ul></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Nombre:</span><div><span>{{contratante.full_name}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Dirección:</span><div><span>{{contratante.address_contractor[0].route}} {{contratante.address_contractor[0].street_number}}, {{contratante.address_contractor[0].sublocality}}.</span><div><span>{{ contratante.address_contractor[0].administrative_area_level_1}}, {{contratante.address_contractor[0].administrative_area_level_2}}.</span></div></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ contratante.phone_number | phonenumber }}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{ contratante.email }}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.contratante.description\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ contratante.description }}</span></div></div></div></div></div></div></div></form></div></div><div class=\"row\"><legend class=\"legend-title\" align=\"center\">Recordatorio</legend><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Resumen:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.nombre}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Descripción:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.descr }}</span></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\'); \n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/recordatorios/endosos.modal.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Información Endoso</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\" ng-init=\"poliza = false; recibos = true; bitacora = false\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': true }\"><a>Información de Recibo</a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': true}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"goToEndoso(recordatorio)\">Ver Endoso</a></li></ul></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Nombre:</span><div><span>{{poliza.parentContractor}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Dirección:</span><div><span>{{poliza.contractor.address.route}} {{poliza.contractor.address.street_number}}, {{poliza.contractor.address.sublocality}}.</span><div><span>{{ poliza.contractor.address.administrative_area_level_1}}, {{poliza.contractor.address.administrative_area_level_2}}.</span></div></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ poliza.contractor.phone_number | phonenumber }}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{ poliza.contractor.email }}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.contractor.description\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ poliza.contractor.description }}</span></div></div></div><div class=\"col-xs-12 col-md-4 border-left\"><legend class=\"legend-title\" align=\"center\">Información Póliza</legend><div class=\"form-group col-sm-6\"><span class=\"blue-color\" ng-if=\"poliza.document_type ==1 || poliza.document_type ==12\">Número de Póliza:</span> <span class=\"blue-color\" ng-if=\"poliza.document_type ==3\">Número de Póliza de Grupo:</span><div><span>{{poliza.poliza_number}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Aseguradora - Cve Agente:</span><div><span>{{poliza.aseguradora.alias}} - {{poliza.clave.clave}} <span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Ramo:</span><div><span>{{poliza.ramo.ramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Subramo:</span><div><span>{{poliza.subramo.subramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Paquete:</span><div><span>{{poliza.paquete.package_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Vigencia:</span><div><span>{{poliza.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{forma_pago(poliza.forma_de_pago)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Estatus:</span><div><span>{{status(poliza.status)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"poliza.f_currency == 1\">PESOS</span> <span ng-if=\"poliza.f_currency == 2\">DOLARES</span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\"><strong>Creado por:</strong></span><div><span>{{poliza.owner.first_name}} {{poliza.owner.last_name}}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.observations\"><span class=\"blue-color\">Observaciones:</span><div><span>{{poliza.observations}}</span></div></div></div><div class=\"col-xs-12 col-md-4 border-left\"><legend class=\"legend-title\" align=\"center\">Información Endoso</legend><div class=\"col-xs-12 col-sm-12 form-group\" ng-if=\"endorsement.status == 2\"><span class=\"blue-color\"><b>Número de Endoso</b>:</span><div><span>{{ endorsement.number_endorsement }}</span></div></div><div class=\"col-xs-12 col-sm-12 form-group\" ng-if=\"endorsement.status != 2\"><span class=\"blue-color\">Folio interno:</span><div><span>{{ endorsement.internal_number }}</span></div></div><div class=\"col-xs-12 col-sm-12 form-group\"><span class=\"blue-color\">Tipo:</span><div><span>{{ endorsement.endorsement_type }}</span></div></div><div class=\"col-xs-12 col-sm-12 form-group\" ng-if=\"endorsement.policy.document_type == 3\"><span class=\"blue-color\">Concepto:</span><div><span ng-if=\"endorsement.original.concept.name\">{{ endorsement.original.concept.name }}</span> <span ng-if=\"!endorsement.original.concept.name\">{{ conceptCollectivity(endorsement.concept) }}</span> <span ng-if=\"endorsement.other_desc\">- {{ endorsement.other_desc }}</span></div></div><div class=\"col-xs-12 col-sm-12 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ endorsement.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ endorsement.end_date | date: \'dd/MM/yyyy\' : \'UTC\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-12 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ endorsement.policy.subramo.subramo_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-12 form-group\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" ng-class=\"{\'label-success\': endorsement.status == 2, \'label-info\' : endorsement.status == 5,\'label-primary\' : endorsement.status == 1, \'label-warning\' : endorsement.status == 3 || endorsement.status == 4}\" style=\"margin-right: 10px\">{{ statusEndoso(endorsement.status) }}</div></div></div></div></div></div></div></div></form></div></div><div class=\"row\"><legend class=\"legend-title\" align=\"center\">Recordatorio</legend><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Resumen:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.nombre}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Descripción:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.descr }}</span></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\'); \n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/recordatorios/fianzas.modal.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Información Fianza</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\" ng-init=\"poliza = false; recibos = true; bitacora = false\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': true }\"><a>Información de Fianza</a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': true}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"goToPolicy(poliza)\">Ver Fianza</a></li></ul></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Nombre:</span><div><span>{{poliza.parentContractor}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Dirección:</span><div><span>{{poliza.contractor.address.route}} {{poliza.contractor.address.street_number}}, {{poliza.contractor.address.sublocality}}.</span><div><span>{{ poliza.contractor.address.administrative_area_level_1}}, {{poliza.contractor.address.administrative_area_level_2}}.</span></div></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ poliza.contractor.phone_number | phonenumber }}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{ poliza.contractor.email }}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.contractor.description\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ poliza.contractor.description }}</span></div></div></div><div class=\"col-xs-12 col-md-8 border-left\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"form-group col-sm-6\"><span class=\"blue-color\" ng-if=\"poliza.document_type ==7\">Número de Fianza:</span> <span class=\"blue-color\" ng-if=\"poliza.document_type ==3\">Número de Fianza de Grupo:</span><div><span>{{poliza.poliza_number}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Aseguradora - Cve Agente:</span><div><span>{{poliza.aseguradora.alias}} - {{poliza.clave.clave}} <span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Ramo:</span><div><span>{{poliza.ramo.ramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Subramo:</span><div><span>{{poliza.subramo.subramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Paquete:</span><div><span>{{poliza.paquete.package_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Vigencia:</span><div><span>{{poliza.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{forma_pago(poliza.forma_de_pago)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Estatus:</span><div><span>{{status(poliza.status)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"poliza.f_currency == 1\">PESOS</span> <span ng-if=\"poliza.f_currency == 2\">DOLARES</span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\"><strong>Creado por:</strong></span><div><span>{{poliza.owner.first_name}} {{poliza.owner.last_name}}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.observations\"><span class=\"blue-color\">Observaciones:</span><div><span>{{poliza.observations}}</span></div></div></div></div></div></div></div></form></div></div><div class=\"row\"><legend class=\"legend-title\" align=\"center\">Recordatorio</legend><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Resumen:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.nombre}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Descripción:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.descr }}</span></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\'); \n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/recordatorios/libres.modal.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Información Recordatorio</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': true}\"><div class=\"btn-group pull-right btn-mt option_button\" ng-if=\"recordatorio.record_model == 2\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"goToContratante(recordatorio)\">Ver Contratante</a></li></ul></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Resumen:</span><div><span>{{recordatorio.instancia.resumen}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Descripción:</span><div><span>{{recordatorio.recordatorio.descr}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Tipo:</span><div><span>{{recordatorio.instancia.tipo}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Fecha programada:</span><div><span>{{recordatorio.recordatorio.fecha_programada | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Hora programada:</span><div><span>{{recordatorio.recordatorio.fecha_programada | date: \'HH:mm\'}}</span></div></div></div></div></div></div></div></form></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\'); \n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/recordatorios/polizas.modal.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Información Póliza</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\" ng-init=\"poliza = false; recibos = true; bitacora = false\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': true }\"><a>Información de Póliza</a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': true}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"goToPolicy(poliza)\">Ver Póliza</a></li></ul></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Nombre:</span><div><span>{{poliza.parentContractor}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Dirección:</span><div><span>{{poliza.contractor.address.route}} {{poliza.contractor.address.street_number}}, {{poliza.contractor.address.sublocality}}.</span><div><span>{{ poliza.contractor.address.administrative_area_level_1}}, {{poliza.contractor.address.administrative_area_level_2}}.</span></div></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ poliza.contractor.phone_number | phonenumber }}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{ poliza.contractor.email }}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.contractor.description\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ poliza.contractor.description }}</span></div></div></div><div class=\"col-xs-12 col-md-8 border-left\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"form-group col-sm-6\"><span class=\"blue-color\" ng-if=\"poliza.document_type ==1 || poliza.document_type ==12\">Número de Póliza:</span> <span class=\"blue-color\" ng-if=\"poliza.document_type ==3\">Número de Póliza de Grupo:</span><div><span>{{poliza.poliza_number}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Aseguradora - Cve Agente:</span><div><span>{{poliza.aseguradora.alias}} - {{poliza.clave.clave}} <span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Ramo:</span><div><span>{{poliza.ramo.ramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Subramo:</span><div><span>{{poliza.subramo.subramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Paquete:</span><div><span>{{poliza.paquete.package_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Vigencia:</span><div><span>{{poliza.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{forma_pago(poliza.forma_de_pago)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Estatus:</span><div><span>{{status(poliza.status)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"poliza.f_currency == 1\">PESOS</span> <span ng-if=\"poliza.f_currency == 2\">DOLARES</span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\"><strong>Creado por:</strong></span><div><span>{{poliza.owner.first_name}} {{poliza.owner.last_name}}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.observations\"><span class=\"blue-color\">Observaciones:</span><div><span>{{poliza.observations}}</span></div></div></div></div></div></div></div></form></div></div><div class=\"row\"><legend class=\"legend-title\" align=\"center\">Recordatorio</legend><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Resumen:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.nombre}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Descripción:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.descr }}</span></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\'); \n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/recordatorios/recibos.modal.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Información Recibo</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\" ng-init=\"poliza = false; recibos = true; bitacora = false\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': true }\"><a>Información de Recibo</a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': true}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-if=\"recordatorio.instancia.receipt_type == 1\" ng-click=\"goToReceipt(recordatorio, poliza)\">Ver Póliza</a> <a ng-if=\"recordatorio.instancia.receipt_type == 2\" ng-click=\"goToReceipt(recordatorio, poliza)\">Ver Endoso</a></li></ul></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Nombre:</span><div><span>{{poliza.parentContractor}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Dirección:</span><div><span>{{poliza.contractor.address.route}} {{poliza.contractor.address.street_number}}, {{poliza.contractor.address.sublocality}}.</span><div><span>{{ poliza.contractor.address.administrative_area_level_1}}, {{poliza.contractor.address.administrative_area_level_2}}.</span></div></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ poliza.contractor.phone_number | phonenumber }}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{ poliza.contractor.email }}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.contractor.description\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ poliza.contractor.description }}</span></div></div></div><div class=\"col-xs-12 col-md-4 border-left\"><legend class=\"legend-title\" align=\"center\">Información Póliza</legend><div class=\"form-group col-sm-6\"><span class=\"blue-color\" ng-if=\"poliza.document_type ==1 || poliza.document_type ==12\">Número de Póliza:</span> <span class=\"blue-color\" ng-if=\"poliza.document_type ==3\">Número de Póliza de Grupo:</span><div><span>{{poliza.poliza_number}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Aseguradora - Cve Agente:</span><div><span>{{poliza.aseguradora.alias}} - {{poliza.clave.clave}} <span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Ramo:</span><div><span>{{poliza.ramo.ramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Subramo:</span><div><span>{{poliza.subramo.subramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Paquete:</span><div><span>{{poliza.paquete.package_name}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Vigencia:</span><div><span>{{poliza.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{forma_pago(poliza.forma_de_pago)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Estatus:</span><div><span>{{status(poliza.status)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"poliza.f_currency == 1\">PESOS</span> <span ng-if=\"poliza.f_currency == 2\">DOLARES</span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\"><strong>Creado por:</strong></span><div><span>{{poliza.owner.first_name}} {{poliza.owner.last_name}}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.observations\"><span class=\"blue-color\">Observaciones:</span><div><span>{{poliza.observations}}</span></div></div></div><div class=\"col-xs-12 col-md-4 border-left\"><legend class=\"legend-title\" align=\"center\">Información Recibo</legend><div class=\"form-group col-sm-12\"><span class=\"blue-color\">Serie del recibo:</span><div><span>{{recordatorio.instancia.recibo_numero}}<span></span></span></div></div><div class=\"form-group col-sm-12\"><span class=\"blue-color\">Vigencia del recibo:</span><div><span>{{recordatorio.instancia.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}} -{{recordatorio.instancia.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}} <span></span></span></div></div><div class=\"form-group col-sm-12\"><span class=\"blue-color\">Prima Total:</span><div><span>{{recordatorio.instancia.p_total | currency}}<span></span></span></div></div></div><div class=\"col-xs-12 col-md-4 border-left\" ng-if=\"recordatorio.instancia.receipt_type == 2\"><legend class=\"legend-title\" align=\"center\">Información Endoso</legend><div class=\"col-xs-12 col-sm-12 form-group\" ng-if=\"endorsement.status == 2\"><span class=\"blue-color\"><b>Número de Endoso</b>:</span><div><span>{{ endorsement.number_endorsement }}</span></div></div><div class=\"col-xs-12 col-sm-12 form-group\" ng-if=\"endorsement.status != 2\"><span class=\"blue-color\">Folio interno:</span><div><span>{{ endorsement.internal_number }}</span></div></div><div class=\"col-xs-12 col-sm-12 form-group\"><span class=\"blue-color\">Tipo:</span><div><span>{{ endorsement.endorsement_type }}</span></div></div><div class=\"col-xs-12 col-sm-12 form-group\" ng-if=\"endorsement.policy.document_type == 3\"><span class=\"blue-color\">Concepto:</span><div><span ng-if=\"endorsement.original.concept.name\">{{ endorsement.original.concept.name }}</span> <span ng-if=\"!endorsement.original.concept.name\">{{ conceptCollectivity(endorsement.concept) }}</span> <span ng-if=\"endorsement.other_desc\">- {{ endorsement.other_desc }}</span></div></div><div class=\"col-xs-12 col-sm-12 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ endorsement.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ endorsement.end_date | date: \'dd/MM/yyyy\' : \'UTC\' }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-12 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ endorsement.policy.subramo.subramo_name }}<span></span></span></div></div><div class=\"col-xs-12 col-sm-12 form-group\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" ng-class=\"{\'label-success\': endorsement.status == 2, \'label-info\' : endorsement.status == 5,\'label-primary\' : endorsement.status == 1, \'label-warning\' : endorsement.status == 3 || endorsement.status == 4}\" style=\"margin-right: 10px\">{{ statusEndoso(endorsement.status) }}</div></div></div></div></div></div></div></div></form></div></div><div class=\"row\"><legend class=\"legend-title\" align=\"center\">Recordatorio</legend><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Resumen:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.nombre}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Descripción:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.descr }}</span></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\')\n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/recordatorios/siniestros.modal.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Información Siniestro</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\" ng-init=\"poliza = false; recibos = true; bitacora = false\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': true }\"><a>Información de Recibo</a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': true}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"goToSiniestro(siniestro)\">Ver Siniestro</a></li></ul></div><div class=\"row\"><div class=\"col-xs-12 btn-mt\"><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Nombre:</span><div><span>{{poliza.parentContractor}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Dirección:</span><div><span>{{poliza.contractor.address.route}} {{poliza.contractor.address.street_number}}, {{poliza.contractor.address.sublocality}}.</span><div><span>{{ poliza.contractor.address.administrative_area_level_1}}, {{poliza.contractor.address.administrative_area_level_2}}.</span></div></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Teléfono:</span><div><span>{{ poliza.contractor.phone_number | phonenumber }}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{ poliza.contractor.email }}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.contractor.description\"><span class=\"blue-color\">Observaciones:</span><div><span>{{ poliza.contractor.description }}</span></div></div></div><div class=\"col-xs-12 col-md-4 border-left\"><legend class=\"legend-title\" align=\"center\">Información Póliza</legend><div class=\"form-group col-sm-12\"><span class=\"blue-color\" ng-if=\"poliza.document_type ==1 || poliza.document_type ==12\">Número de Póliza:</span> <span class=\"blue-color\" ng-if=\"poliza.document_type ==3\">Número de Póliza de Grupo:</span><div><span>{{poliza.poliza_number}}<span></span></span></div></div><div class=\"form-group col-sm-12\"><span class=\"blue-color\">Aseguradora - Cve Agente:</span><div><span>{{poliza.aseguradora.alias}} - {{poliza.clave.clave}} <span></span></span></div></div><div class=\"form-group col-sm-12\"><span class=\"blue-color\">Ramo:</span><div><span>{{poliza.ramo.ramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-12\"><span class=\"blue-color\">Subramo:</span><div><span>{{poliza.subramo.subramo_name}}<span></span></span></div></div><div class=\"form-group col-sm-12\"><span class=\"blue-color\">Paquete:</span><div><span>{{poliza.paquete.package_name}}<span></span></span></div></div><div class=\"form-group col-sm-12\"><span class=\"blue-color\">Vigencia:</span><div><span>{{poliza.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }}<span></span></span></div></div><div class=\"form-group col-sm-12\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{forma_pago(poliza.forma_de_pago)}}<span></span></span></div></div><div class=\"form-group col-sm-12\"><span class=\"blue-color\">Estatus:</span><div><span>{{status(poliza.status)}}<span></span></span></div></div><div class=\"form-group col-sm-12\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"poliza.f_currency == 1\">PESOS</span> <span ng-if=\"poliza.f_currency == 2\">DOLARES</span></div></div><div class=\"form-group col-sm-12\"><span class=\"blue-color\"><strong>Creado por:</strong></span><div><span>{{poliza.owner.first_name}} {{poliza.owner.last_name}}</span></div></div><div class=\"form-group col-xs-12\" ng-if=\"poliza.observations\"><span class=\"blue-color\">Observaciones:</span><div><span>{{poliza.observations}}</span></div></div></div><div class=\"col-xs-12 col-md-4 border-left\"><legend class=\"legend-title\" align=\"center\">Información Siniestro</legend><div class=\"form-group col-xs-12 col-sm-12 col-md-12\" role=\"group\" aria-label=\"...\"><label>Tipo de siniestro:</label><br><div class=\"label\" ng-class=\"{ \'label-primary\': siniestro.accidente.initial == true, \'label-info\': siniestro.accidente.initial == false}\"><span ng-if=\"siniestro.accidente.initial\">Inicial</span> <span ng-if=\"!siniestro.accidente.initial\">Complemento</span></div></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\" ng-if=\"siniestro.accidente.initial == false\"><label>Numero de Complemento:</label><br><span>{{ siniestro.accidente.numero_consecutivo_complemento }}</span></div><br><br><br><br><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><span class=\"blue-color\">Número de Siniestro:</span><br><span>{{ siniestro.siniestro.numero_siniestro }}</span></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><span class=\"blue-color\">Fecha de Ingreso:</span><br><span>{{siniestro.siniestro.fecha| date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><span class=\"blue-color\">Fecha de captura:</span><br><span>{{siniestro.siniestro.fecha_ingreso| date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><span class=\"blue-color\">Fecha en que ocurrió:</span><br><span>{{siniestro.siniestro.fecha_siniestro| date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><span class=\"blue-color\">Fecha de terminación:</span><br><span>{{siniestro.siniestro.fecha_terminacion | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><span class=\"blue-color\">Tipo de Siniestro:</span><br><span>{{tipo_title[siniestro.accidente.razon_siniestro]}}</span></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><span class=\"blue-color\">Estatus:</span><br><span>En trámite</span></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><span class=\"blue-color\">Padecimiento:</span><br><span>{{siniestro.accidente.ailment}}</span></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><span class=\"blue-color\">Tipo de Pago:</span><br><span>{{pago_title[siniestro.accidente.tipo_pago]}}</span></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><span class=\"blue-color\">Creado por:</span><br><span>{{siniestro.siniestro.owner}}</span></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\" ng-if=\"siniestro.siniestro.state.state\"><span class=\"blue-color\">Estado y Ciudad:</span><br><span>{{siniestro.siniestro.state.state}},{{ciudad_name}}</span></div></div></div></div></div></div></form></div></div><div class=\"row\"><legend class=\"legend-title\" align=\"center\">Recordatorio</legend><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Resumen:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.nombre}}</span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\"><span class=\"blue-color\"><strong>Descripción:</strong></span><div><span align=\"center\">{{ recordatorio.recordatorio.descr }}</span></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\'); \n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/recordatorios/tareas.modal.html","<div class=\"inmodal\" id=\"modal_edit\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Información Tarea</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': true }\"><a>Información de Tarea</a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': true}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"gotoTarea(tarea)\">Ver Tarea</a></li></ul></div><div class=\"row\"><div class=\"col-xs-12 col-md-8 border-left\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Título:</span><div><span>{{tarea.title}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Descripción:</span><div><span>{{tarea.descrip}} <span></span></span></div></div></div></div></div></div></form></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Resumen:</span><div><span>{{ recordatorio.recordatorio.nombre}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Descripción:</span><div><span>{{ recordatorio.recordatorio.descr }}</span></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\'); \n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/renovaciones/renovaciones.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Renovaciones</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Renovaciones</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div><div class=\"col-sm-3\"><label>Contratante</label><div class=\"form-group\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div></div></div><div><div class=\"col-sm-3\"><label>Grupo</label><div class=\"form-group\"><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"subgroups.length >0\"><label>SubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subgroup\" data-ng-options=\"subgroup.group_name for subgroup in subgroups track by subgroup.url\" ng-change=\"vm.changeSubgroup(vm.form.subgroup)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"subsubgroups.length >0\"><label>SubsubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subsubgroup\" data-ng-options=\"subsubgroup.group_name for subsubgroup in subsubgroups track by subsubgroup.url\" ng-change=\"vm.changeSubsubgroup(vm.form.subsubgroup)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Clasificación</label><autocomplete datasource=\"classification_data\" id=\"classification\" model=\"vm.form.classification\" change=\"vm.matchesClassification(vm.form.classification.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-model=\"vm.form.celula\" data-ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"vm.changecelula(vm.form.celula)\"><option value=\"\">Todo</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-model=\"vm.form.businesLine\" data-ng-options=\"businesLine.name for businesLine in vm.businesLine track by businesLine.id\" ng-change=\"vm.changeBLine(vm.form.businesLine)\" required=\"\"><option value=\"\">Todas las líneas</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"campo_agrupacion\"><label>Nivel de Agrupación</label><autocomplete datasource=\"groupinglevels_data\" id=\"groupingleves\" model=\"vm.form.groupinglevel\" change=\"vm.matchesGroupinglevel(vm.form.groupinglevel.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.form.groupinglevel.subgrupos.length >0 && campo_agrupacion\"><label>SubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subgrouping\" data-ng-options=\"subgrouping.description for subgrouping in vm.form.groupinglevel.subgrupos track by subgrouping.url\" ng-change=\"vm.changeSubgrouping(vm.form.subgrouping)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.form.subgrouping.subsubgrupos.length >0 && campo_agrupacion\"><label>SubsubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subsubgrouping\" data-ng-options=\"subsubgroupin.description for subsubgroupin in vm.form.subgrouping.subsubgrupos track by subsubgroupin.url\" ng-change=\"vm.changeSubsubgrouping(vm.form.subsubgrouping)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.providers\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(vm.form.providers)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.ramos\" ng-change=\"selectRamos(vm.form.ramos)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.subramos\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(vm.form.subramos)\"></select></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group\"><label>Tipo de póliza:</label><select class=\"form-control\" ng-model=\"vm.form.tipo_poliza\" ng-options=\"option.name for option in vm.option_tp track by option.id\"><option value=\"\">Selecciona una opción</option></select></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group\"><label>Forma de pago</label><select class=\"form-control m-b\" ng-model=\"vm.form.payment\" data-ng-options=\"payment.name for payment in vm.payment track by payment.id\" ng-change=\"vm.changePayment(vm.form.payment)\" required=\"\"><option value=\"\">Todas las formas de pago</option></select></div></div><div class=\"form-group\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.renovadas\" ng-options=\"option.name for option in vm.option track by option.id\"><option value=\"\">Selecciona una opción</option></select></div></div><div class=\"row col-xs-12 col-sm-6 col-md-6 col-lg-5 form-group\"><label>Carátula:</label><br><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.word\" change=\"vm.getCaratulas(vm.word)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getCarSelected(vm.word)\"><span class=\"fa fa-ok\"></span> Seleccionar</button></div></div></div><br><br></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.options.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3\" ng-if=\"vm.acceso_ver_pol || vm.acceso_ver_ot\"><button class=\"btn btn-success m-t col-xs-12\" ng-click=\"vm.Generar(1,1)\">Consultar</button></div></div></div></div></div></div><ul id=\"contextRenovaciones\" class=\"dropdown-menu\" role=\"menu\" z-index=\"1000\"></ul><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Renovaciones</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div ng-if=\"!results && !vm.show_binnacle && (vm.acceso_ver_pol || vm.acceso_ver_ot)\" class=\"row\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Pólizas Vencidas\" id=\"vencidas\" ng-click=\"vm.getRenovaciones(1,1,1)\"><div class=\"panel-body\"><table class=\"table table-striped table-hover table-bordered\"><thead><tr><th ng-click=\"vm.changeRenewalT(1, vm.ren_nump_asc == 1 ? 2 : 1)\">Número de póliza <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_nump_asc == 1, \'fa fa-sort-asc\': vm.ren_nump_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(2, vm.ren_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_cont_asc == 1, \'fa fa-sort-asc\': vm.ren_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(3, vm.ren_type_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_type_asc == 1, \'fa fa-sort-asc\': vm.ren_type_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(4, vm.ren_aseg_asc == 1 ? 2 : 1)\">Aseguradora <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_aseg_asc == 1, \'fa fa-sort-asc\': vm.ren_aseg_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(5, vm.ren_pack_asc == 1 ? 2 : 1)\">Paquete <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_pack_asc == 1, \'fa fa-sort-asc\': vm.ren_pack_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(6, vm.ren_subr_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_subr_asc == 1, \'fa fa-sort-asc\': vm.ren_subr_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(7, vm.ren_fini_asc == 1 ? 2 : 1)\">Fecha de Inicio <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_fini_asc == 1, \'fa fa-sort-asc\': vm.ren_fini_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(8, vm.ren_ffin_asc == 1 ? 2 : 1)\">Fecha de Fin <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_ffin_asc == 1, \'fa fa-sort-asc\': vm.ren_ffin_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(9, vm.ren_pago_asc == 1 ? 2 : 1)\">Forma de Pago <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_pago_asc == 1, \'fa fa-sort-asc\': vm.ren_pago_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(10, vm.ren_est_asc == 1 ? 2 : 1)\">Estatus <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_est_asc == 1, \'fa fa-sort-asc\': vm.ren_est_asc == 2}\"></span></th><th>Antigüedad</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.insurances track by $index\" ng-click=\"vm.openRenovateModal(insurance)\" ng-if=\"insurance.status == 13\" context=\"contextRenovaciones\" ng-right-click=\"ShowContextMenu(insurance)\"><td><div ng-if=\"insurance.poliza_number == 0\">OT</div><span ng-if=\"insurance.poliza_number != 0\">{{ insurance.poliza_number }}</span></td><td>{{ insurance.contractor.full_name }}</td><td>{{ insurance.contractor.type_person }}</td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.paquete }}</td><td>{{ insurance.subramo }}</td><td>{{ insurance.start_of_validity | date: \'dd-MM-yyyy\': \'UTC\'}}</td><td>{{ insurance.end_of_validity | date: \'dd-MM-yyyy\': \'UTC\'}}</td><td payment=\"{{insurance.forma_de_pago}}\"></td><td status=\"{{insurance.status}}\"><span ng-if=\"!insurance.existe_ot_renovacion && orgName ==\'ancora\' && insurance.renewed_status ==2 && insurance.is_renewable==1\">- En Proceso de Renovación</span></td><td>{{ insurance.antiguedad }} días</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"paginacionVenc[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPaginaVenc(paginaVenc)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-click=\"siguientePaginaVenc(paginaVenc)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></uib-tab><uib-tab heading=\"Pólizas Vigentes\" id=\"vigentes\" ng-click=\"vm.getRenovaciones(2,1,1)\"><div class=\"panel-body\"><table class=\"table table-striped table-hover hidden-xs hidden-sm\"><thead><tr><th ng-click=\"vm.changeRenewalT(1, vm.ren_nump_asc == 1 ? 2 : 1)\">Número de póliza <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_nump_asc == 1, \'fa fa-sort-asc\': vm.ren_nump_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(2, vm.ren_cont_asc == 1 ? 2 : 1)\">Contratante <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_cont_asc == 1, \'fa fa-sort-asc\': vm.ren_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(3, vm.ren_type_asc == 1 ? 2 : 1)\">Tipo <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_type_asc == 1, \'fa fa-sort-asc\': vm.ren_type_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(4, vm.ren_aseg_asc == 1 ? 2 : 1)\">Aseguradora <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_aseg_asc == 1, \'fa fa-sort-asc\': vm.ren_aseg_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(5, vm.ren_pack_asc == 1 ? 2 : 1)\">Paquete <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_pack_asc == 1, \'fa fa-sort-asc\': vm.ren_pack_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(6, vm.ren_subr_asc == 1 ? 2 : 1)\">Subramo <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_subr_asc == 1, \'fa fa-sort-asc\': vm.ren_subr_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(7, vm.ren_fini_asc == 1 ? 2 : 1)\">Fecha de inicio <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_fini_asc == 1, \'fa fa-sort-asc\': vm.ren_fini_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(8, vm.ren_ffin_asc == 1 ? 2 : 1)\">Fecha de fin <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_ffin_asc == 1, \'fa fa-sort-asc\': vm.ren_ffin_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(9, vm.ren_pago_asc == 1 ? 2 : 1)\">Forma de pago <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_pago_asc == 1, \'fa fa-sort-asc\': vm.ren_pago_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewalT(10, vm.ren_est_asc == 1 ? 2 : 1)\">Estatus <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_est_asc == 1, \'fa fa-sort-asc\': vm.ren_est_asc == 2}\"></span></th><th>Antigüedad</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.insurances track by $index\" ng-click=\"vm.openRenovateModal(insurance)\" ng-if=\"insurance.status == 14\" context=\"contextRenovaciones\" ng-right-click=\"ShowContextMenu(insurance)\"><td><div ng-if=\"insurance.poliza_number == 0\">OT</div><span ng-if=\"insurance.poliza_number != 0\">{{ insurance.poliza_number }}</span></td><td>{{ insurance.contractor.full_name }}</td><td>{{ insurance.contractor.type_person }}</td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.paquete }}</td><td>{{ insurance.subramo }}</td><td>{{ insurance.start_of_validity | date: \'dd-MM-yyyy\': \'UTC\'}}</td><td>{{ insurance.end_of_validity | date: \'dd-MM-yyyy\': \'UTC\'}}</td><td payment=\"{{insurance.forma_de_pago}}\"></td><td status=\"{{insurance.status}}\"></td><td>{{ insurance.antiguedad }} días</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(insurance)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"paginacionVig[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPaginaVig(paginaVig)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-click=\"siguientePaginaVig(paginaVig)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in vm.insurances track by $index\" ng-if=\"insurance.status == 14\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}: {{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-click=\"vm.openRenovateModal(insurance)\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.contractor.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p>{{ insurance.contractor.type_person}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ insurance.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ insurance.paquete }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ insurance.start_of_validity | date: \'dd-MM-yyyy\' : \'UTC\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ insurance.end_of_validity | date: \'dd-MM-yyyy\': \'UTC\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{ insurance.forma_de_pago }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.status }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[10] }}</label><p>{{ insurance.antiguedad }}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_policy\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></uib-tab></uib-tabset></div></div><div ng-if=\"results && !vm.show_binnacle\" class=\"row animate\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Resultados\" id=\"vencidas\"><div class=\"panel-body\"><table class=\"table table-striped table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th ng-click=\"vm.changeRenewal(1, vm.ren_nump_asc == 1 ? 2 : 1)\" ng-model=\"vm.tableRes.headers[0]\">{{vm.tableRes.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_nump_asc == 1, \'fa fa-sort-asc\': vm.ren_nump_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewal(2, vm.ren_cont_asc == 1 ? 2 : 1)\" ng-model=\"vm.tableRes.headers[1]\">{{vm.tableRes.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_cont_asc == 1, \'fa fa-sort-asc\': vm.ren_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewal(3, vm.ren_type_asc == 1 ? 2 : 1)\" ng-model=\"vm.tableRes.headers[2]\">{{vm.tableRes.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_type_asc == 1, \'fa fa-sort-asc\': vm.ren_type_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewal(4, vm.ren_aseg_asc == 1 ? 2 : 1)\" ng-model=\"vm.tableRes.headers[3]\">{{vm.tableRes.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_aseg_asc == 1, \'fa fa-sort-asc\': vm.ren_aseg_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewal(5, vm.ren_pack_asc == 1 ? 2 : 1)\" ng-model=\"vm.tableRes.headers[4]\">{{vm.tableRes.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_pack_asc == 1, \'fa fa-sort-asc\': vm.ren_pack_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewal(6, vm.ren_subr_asc == 1 ? 2 : 1)\" ng-model=\"vm.tableRes.headers[5]\">{{vm.tableRes.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_subr_asc == 1, \'fa fa-sort-asc\': vm.ren_subr_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewal(7, vm.ren_fini_asc == 1 ? 2 : 1)\" ng-model=\"vm.tableRes.headers[6]\">{{vm.tableRes.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_fini_asc == 1, \'fa fa-sort-asc\': vm.ren_fini_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewal(8, vm.ren_ffin_asc == 1 ? 2 : 1)\" ng-model=\"vm.tableRes.headers[7]\">{{vm.tableRes.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_ffin_asc == 1, \'fa fa-sort-asc\': vm.ren_ffin_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewal(9, vm.ren_pago_asc == 1 ? 2 : 1)\" ng-model=\"vm.tableRes.headers[8]\">{{vm.tableRes.headers[8]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_pago_asc == 1, \'fa fa-sort-asc\': vm.ren_pago_asc == 2}\"></span></th><th ng-click=\"vm.changeRenewal(10, vm.ren_est_asc == 1 ? 2 : 1)\" ng-model=\"vm.tableRes.headers[9]\">{{vm.tableRes.headers[9]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.ren_est_asc == 1, \'fa fa-sort-asc\': vm.ren_est_asc == 2}\"></span></th><th ng-model=\"vm.tableRes.headers[10]\">{{vm.tableRes.headers[10]}}</th><th ng-model=\"vm.tableRes.headers[11]\">{{vm.tableRes.headers[11]}}</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.insurances track by $index\" ng-click=\"vm.openRenovateModal(insurance)\" context=\"contextRenovaciones\" ng-right-click=\"ShowContextMenu(insurance)\"><td><div ng-if=\"insurance.poliza_number == 0\">OT</div><span ng-if=\"insurance.poliza_number != 0\">{{ insurance.poliza_number }}</span></td><td>{{ insurance.contractor.full_name }}</td><td>{{ insurance.contractor.type_person}}</td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.paquete }}</td><td>{{ insurance.subramo }}</td><td>{{ insurance.start_of_validity | date: \'dd-MM-yyyy\': \'UTC\'}}</td><td>{{ insurance.end_of_validity | date: \'dd-MM-yyyy\': \'UTC\'}}</td><td payment=\"{{insurance.forma_de_pago}}\"></td><td><span status=\"{{insurance.status}}\"></span><span ng-if=\"orgName ==\'ancora\' && insurance.renewed_status ==2 && insurance.is_renewable==1\">- En Proceso de Renovación</span></td><td>{{ insurance.antiguedad }} días</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(siniestro)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in vm.insurances track by $index\" ng-if=\"insurance.status == 14\"><div class=\"ibox-title\"><h5>{{ vm.tableRes.headers[0] }}: {{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-click=\"vm.openRenovateModal(insurance)\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tableRes.headers[0] }}</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tableRes.headers[1] }}</label><p>{{ insurance.contractor.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tableRes.headers[2] }}</label><p>{{ insurance.contractor.type_person}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tableRes.headers[3] }}</label><p>{{ insurance.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tableRes.headers[4] }}</label><p>{{ insurance.paquete }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tableRes.headers[5] }}</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tableRes.headers[6] }}</label><p>{{ insurance.start_of_validity | date: \'dd-MM-yyyy\': \'UTC\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tableRes.headers[7] }}</label><p>{{ insurance.end_of_validity | date: \'dd-MM-yyyy\': \'UTC\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tableRes.headers[8] }}</label><p>{{ insurance.forma_de_pago }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tableRes.headers[9] }}</label><p>{{ insurance.status }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.tableRes.headers[10] }}</label><p>{{ insurance.antiguedad }}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_renew\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></uib-tab></uib-tabset></div><br><div><button ng-click=\"exportData(1)\" class=\"btn btn-primary ladda-button\">Generar Reporte</button></div></div><div class=\"row animate\" ng-if=\"vm.show_binnacle\"><div class=\"col-md-12\"><div><a ng-click=\"vm.returnToReceipts()\">Regresar</a></div><div class=\"col-md-12 margin-top-24\"></div><div class=\"col-md-12\"><comments datasource=\"vm.comments_data\" typemodel=\"6\" config=\"vm.comments_config\" idmodel=\"vm.renewal_id\" exportable=\"true\"></comments></div></div></div></div></div></div></div></div>");
$templateCache.put("app/renovaciones/renovaciones.modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Renovaciones</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><form method=\"post\" name=\"form\" role=\"form\"><div class=\"tabs-container\" ng-init=\"poliza = true; recibos = false; bitacora = false\"><ul class=\"nav nav-tabs\"><li ng-class=\"{ \'active\': poliza }\"><a ng-click=\"poliza = true; bitacora = false; recibos = false\">Información de Póliza</a></li><li ng-class=\"{ \'active\': recibos }\"><a ng-click=\"recibos = true; bitacora = false; poliza = false\">Recibos</a></li><li ng-class=\"{ \'active\': bitacora }\"><a ng-click=\"poliza = false; recibos = false; bitacora = true\">Bitácora</a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\': poliza}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn no-mb btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"forms.document_type == 1\"><a ng-click=\"goToPolicy(forms)\">Ver Póliza</a></li><li ng-if=\"forms.document_type == 3 || forms.document_type == 4\"><a ng-click=\"goToPolicy(forms)\">Ver Póliza (Carátula)</a></li><li><a ng-click=\"getPDF(forms.id)\">Ver PDF</a></li><li ng-if=\"forms.document_type == 1\"><a ng-click=\"openRenovateModal(forms, 2)\">Renovar Póliza</a></li><li ng-if=\"forms.document_type == 3 || forms.document_type == 4\"><a ng-click=\"openRenovateModal(forms, \'\')\">Renovar Póliza (Carátula)</a></li><li ng-if=\"forms.document_type == 1\"><a ng-click=\"goToEdit(forms)\">Editar Póliza</a></li><li ng-if=\"forms.document_type == 3 || forms.document_type == 4\"><a ng-click=\"goToEdit(forms)\">Editar Póliza (Carátula)</a></li><li ng-if=\"forms.document_type == 1\"><a ng-click=\"deletePolicy(forms)\">Eliminar Póliza</a></li><li ng-if=\"forms.document_type == 3 || forms.document_type == 4\"><a ng-click=\"deletePolicy(forms)\">Eliminar Póliza (Carátula)</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"cartas.length && view_cartas\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"cartas\" ng-repeat=\"carta in cartas track by $index\"><a ng-click=\"viewCarta(forms.id, carta.id)\">{{carta.name}}</a></li></ul></li></ul></div><div class=\"row\"><div class=\"col-xs-12\"><br><div class=\"col-xs-12 col-md-4\"><legend class=\"legend-title\" align=\"center\">Contratante</legend><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Nombre:</span><div><span>{{contratante.full_name}} {{contratante.j_name}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Dirección:</span><div><span>{{addressContratante.route}} {{addressContratante.street_number}}, {{addressContratante.sublocality}}.</span><div><span>{{ addressContratante.administrative_area_level_1}}, {{addressContratante.administrative_area_level_2}}.</span></div></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Teléfono:</span><div><span>{{contratante.phone_number | phonenumber}}</span></div></div><div class=\"form-group col-xs-12\"><span class=\"blue-color\">Correo Electrónico:</span><div><span>{{contratante.email}}</span></div></div></div><div class=\"col-xs-12 col-md-8 border-left\"><legend class=\"legend-title\" align=\"center\">Información</legend><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{forms.poliza_number}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Aseguradora - Cve Agente:</span><div><span>{{forms.aseguradora}} - {{forms.clave.clave}} <span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Ramo:</span><div><span>{{forms.ramo}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Subramo:</span><div><span>{{forms.subramo}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Paquete:</span><div><span>{{forms.paquete}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Vigencia:</span><div><span>{{forms.start_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}} - {{forms.end_of_validity | date: \'dd/MM/yyyy\': \'UTC\'}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Frecuencia de Pago:</span><div><span>{{forma_pago(forms.forma_de_pago)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Estatus:</span><div><span>{{status(forms.status)}}<span></span></span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\">Moneda:</span><div><span ng-if=\"forms.f_currency == 1\">PESOS</span> <span ng-if=\"forms.f_currency == 2\">DOLARES</span></div></div><div class=\"form-group col-sm-6\"><span class=\"blue-color\"><strong>Creado por:</strong></span><div><span>{{forms.owner}}</span></div></div><div class=\"col-xs-12\"><hr></div><div class=\"form-group col-xs-12 col-sm-4\"><span class=\"blue-color\">Prima Neta:</span><div><span>{{forms.p_neta | currency}}</span></div></div><div class=\"form-group col-xs-12 col-sm-4\"><span class=\"blue-color\">Derecho:</span><div>{{forms.derecho | currency}}</div></div><div class=\"form-group col-xs-12 col-sm-4\"><span class=\"blue-color\">Recargo por Pago Fraccionado:</span><div>{{forms.rpf | currency}}</div></div><div class=\"form-group col-xs-12 col-sm-4\"><span class=\"blue-color\">Descuento:</span><div><span>{{forms.descuento | currency}}</span></div></div><div class=\"form-group col-xs-12 col-sm-4\"><span class=\"blue-color\">Prima Total:</span><div><span>{{forms.p_total | currency}}</span></div></div><div class=\"form-group col-xs-12 col-sm-4\"><span class=\"blue-color\">Comisión:</span><div><span>{{forms.comision | currency}}</span></div></div><div class=\"form-group col-xs-12 col-sm-4\"><span class=\"blue-color\">Iva:</span><div><span>{{forms.iva | currency}}</span></div></div></div><div class=\"col-xs-12\" ng-if=\"forms.document_type != 3\"><legend class=\"legend-title\" align=\"center\">Coberturas</legend><table class=\"table table-bordered table-hover\"><thead><tr><th>Cobertura</th><th>Suma Asegurada</th><th>Deducible</th><th ng-show=\"forms.subramo == \'Gastos Médicos\'\">Coaseguro</th></tr></thead><tbody><tr ng-repeat=\"coverage in forms.coverageInPolicy_policy | orderBy: \'priority\' track by coverage.url\"><td>{{formatCoverage(coverage.coverage_name)}}</td><td>{{formatCoverage(coverage.sum_insured)}}</td><td>{{formatCoverage(coverage.deductible)}}</td><td ng-show=\"forms.subramo == \'Gastos Médicos\'\">{{coverage.coinsurance}}%</td></tr></tbody></table></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\': recibos}\"><div class=\"btn-group pull-right btn-mt option_button\"><button type=\"button\" class=\"btn no-mb btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"forms.document_type == 1\"><a ng-click=\"goToPolicy(forms)\">Ver Póliza</a></li><li ng-if=\"forms.document_type == 3 || forms.document_type == 4\"><a ng-click=\"goToPolicy(forms)\">Ver Colectividad</a></li><li ng-if=\"forms.document_type == 1\"><a ng-click=\"openRenovateModal(forms, 2)\">Renovar Póliza</a></li><li class=\"dropdown-submenu\" ng-if=\"forms.document_type == 3 || forms.document_type == 4\"><a>Renovar como:</a><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"openRenovateModal(forms, \'\')\">Colectividad</a></li><li><a ng-click=\"openRenovateModal(forms, 1)\">OT</a></li></ul></li><li ng-if=\"forms.document_type == 1\"><a ng-click=\"goToEdit(forms)\">Editar Póliza</a></li><li ng-if=\"forms.document_type == 3 || forms.document_type == 4\"><a ng-click=\"goToEdit(forms)\">Editar Colectividad</a></li><li ng-if=\"forms.document_type == 1\"><a ng-click=\"deletePolicy(forms)\">Eliminar Póliza</a></li><li ng-if=\"forms.document_type == 3 || forms.document_type == 4\"><a ng-click=\"deletePolicy(forms)\">Eliminar Colectividad</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"cartas.length\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"cartas\" ng-repeat=\"carta in cartas track by $index\"><a ng-click=\"viewCarta(forms.id, carta.id)\">{{carta.name}}</a></li></ul></li></ul></div><div class=\"row\" ng-if=\"forms.recibos_poliza.length\"><br><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Recibo</th><th>Contratante</th><th>Estatus</th><th>Prima Total</th><th>Fecha Inicio</th><th>Fecha Fin</th></tr></thead><tbody><tr ng-repeat=\"receipt in forms.recibos_poliza track by $index\" ng-click=\"dismis(forms, receipt)\"><td ng-bind=\"receipt.recibo_numero\"></td><td>{{contratante.full_name}}{{contratante.j_name}}</td><td>{{receipt.status}}</td><td>{{receipt.prima_total | currency}}</td><td>{{receipt.fecha_inicio | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{receipt.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"!forms.recibos_poliza.length\"><br><div class=\"col-xs-12 text-center\">Multiples recibos Para consultar dirigase a menu de opciones rapidas > Ver colectividad</div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\': bitacora}\"><div class=\"row\"><br><div class=\"col-xs-12\"><comments datasource=\"comments_data\" typemodel=\"6\" config=\"comments_config\" idmodel=\"renewal_id\" exportable=\"true\"></comments></div></div></div></div></form></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancelRenovate(forms)\">No renovar</button> <button ng-if=\"user.permiso.crear\" class=\"btn btn-success ladda-button\" type=\"button\" ng-click=\"renewal(forms)\" data-style=\"expand-right\"><span class=\"ladda-label\">Renovar</span></button> <button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div>");
$templateCache.put("app/renovaciones/renovaciones.modalNew.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Renovaciones</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"renovaciones.renovaciones\">Renovaciones</a></li><li><a ui-sref=\"polizas.info({polizaId: order.insuranceObject.id})\">Póliza #{{order.insuranceObject.poliza_number}}</a></li><li class=\"active\"><strong>Renovación póliza # {{poliza_data.poliza_number}}</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\" id=\"addContratantes\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><ng-include src=\"\'app/ordenes/ordenes.generic.old.html\'\"></ng-include></div></div></div></div><div class=\"row\"><div ng-class=\"{ \'alert alert-success alertpdf\': serieAGuardar && serieDetectada === serieAGuardar, \'alert alert-danger alertpdf\': serieAGuardar && serieDetectada !== serieAGuardar, \'alert alert-warning alertpdf\': !serieAGuardar }\" style=\"padding: 12px 15px;\" ng-if=\"order.form.subramo && order.form.subramo.subramo_code==9\"><span><h3>CAPTURA DE LA SERIE EN EL PDF</h3></span> <img ng-if=\"imgSerieSrcR\" ng-src=\"{{imgSerieSrcR}}\" style=\"max-width:100%;\"><div ng-if=\"order.subforms.auto.serial\" style=\"display:flex; gap:12px; align-items:flex-start; padding:14px 16px; border:1px solid #cfe2ff; background:#f8fbff; border-radius:12px; margin:12px 0;\"><div style=\"width:34px; height:34px; border-radius:10px; background:#1976d2; color:#fff; display:flex; align-items:center; justify-content:center; font-weight:900;\">VIN</div><div style=\"flex:1;\"><div style=\"font-size:12px; font-weight:700; color:#1e3a8a;\"><h3>SERIE DETECTADA POR SAAM</h3>A guardar<div style=\"font-size:22px; font-weight:800; margin-top:4px; word-break:break-all; display:flex; align-items:center; gap:8px;\" ng-class=\"{ \'vin-ok\': !hasInvalidVinLettersTest(order.subforms.auto.serial), \'vin-warning\': hasInvalidVinLettersTest(order.subforms.auto.serial) }\">{{ order.subforms.auto.serial || \'—\' }}<span ng-if=\"hasInvalidVinLettersTest(order.subforms.auto.serial)\" style=\"font-size:11px; font-weight:800; padding:4px 8px; border-radius:999px; background:#fff1f2; color:#991b1b; border:1px solid #fecdd3; white-space:nowrap;\" title=\"El VIN contiene letras no permitidas (O, I, Q)\"><i class=\"fa fa-exclamation-triangle\" style=\"margin-right:4px;\"></i> Serie inválida</span></div></div></div></div><div ng-if=\"order.subforms.auto.serial\" style=\"display:flex; gap:12px; align-items:flex-start; padding:14px 16px; border:1px solid #cfe2ff; background:#f8fbff; border-radius:12px; margin:12px 0;\"><div style=\"width:34px; height:34px; border-radius:10px; background:#1976d2; color:#fff; display:flex; align-items:center; justify-content:center; font-weight:900;\" ng-if=\"serialBase && order.subforms.auto.serial && !sameVIN(serialBase, order.subforms.auto.serial)\">VIN</div><div style=\"flex:1;\" ng-if=\"serialBase && order.subforms.auto.serial && !sameVIN(serialBase, order.subforms.auto.serial)\"><div style=\"display:flex; align-items:center; justify-content:space-between; gap:10px;\"><div style=\"font-size:12px; font-weight:800; color:#1e3a8a;\">Comparación de serie (VIN)</div><div style=\"font-size:12px; font-weight:800; padding:6px 10px; border-radius:999px;\" ng-class=\"sameVIN(serialBase, order.subforms.auto.serial) ? \'badge-ok\' : \'badge-neutral\'\"><span ng-if=\"sameVIN(serialBase, order.subforms.auto.serial)\">Coincide</span> <span ng-if=\"!sameVIN(serialBase, order.subforms.auto.serial)\">Cambio detectado</span></div></div><div style=\"display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-top:10px;\"><div style=\"padding:10px 12px; border:1px solid #e5e7eb; background:#fff; border-radius:10px;\"><div style=\"font-size:12px; font-weight:800; color:#6b7280; margin-bottom:6px;\">SERIE DE LA PÓLIZA ANTERIOR</div><div style=\"font-size:14px; font-weight:900; word-break:break-all; color:#111827;\">{{ serialBase || \'—\' }}</div></div><div style=\"padding:10px 12px; border-radius:10px; background:#fff;\" ng-class=\"hasInvalidVinLettersTestX(order.subforms.auto.serial) ? \'badge-warn\' : \'badge-ok\'\"><div style=\"display:flex; align-items:center; justify-content:space-between; gap:10px; margin-bottom:6px;\"><div style=\"font-size:12px; font-weight:800;\">SERIE DETECTADA EN ESTA RENOVACION (ACTUAL)</div><div ng-if=\"hasInvalidVinLettersTestX(order.subforms.auto.serial)\" style=\"font-size:11px; font-weight:900;\"><i class=\"fa fa-exclamation-triangle\" style=\"margin-right:6px;\"></i> Contiene O / I / Q</div></div><div style=\"font-size:14px; font-weight:900; word-break:break-all;\" ng-class=\"hasInvalidVinLettersTestX(order.subforms.auto.serial) ? \'vin-warning\' : \'vin-ok\'\">{{ order.subforms.auto.serial || \'—\' }}</div></div></div><div ng-if=\"serialBase && !sameVIN(serialBase, order.subforms.auto.serial)\" style=\"margin-top:10px; font-size:12px; color:#6b7280;\">*Verifica que el cambio sea correcto antes de guardar.</div></div></div><small style=\"display: block; margin-top: 6px; line-height: 1.5; font-size: 13px; color: #444;\"><span>Por favor <strong>revise cuidadosamente</strong> que la <strong>SERIE</strong> detectada coincida exactamente con la que aparece en su documento original.</span></small></div><div class=\"col-xs-12 m-b\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"order.acceso_adm_pol\"><button class=\"col-xs-12 btn btn-primary ladda-butto\" ng-click=\"validatePolicy(\'poliza\', 2)\" ng-disable=\"!order.user.permiso.crear\" type=\"button\">No es renovación</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"order.acceso_adm_pol\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"validatePolicy(\'poliza\', 1)\" ng-disable=\"!order.user.permiso.crear\" type=\"button\" data-style=\"expand-right\"><span class=\"ladda-label\">Renovar</span></button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"order.acceso_adm_ot\"><button class=\"col-xs-12 btn btn-success ladda-buttonOT\" ng-disabled=\"!order.user.permiso.crear || order.form.poliza\" ng-click=\"order.save.saveChangesInOt()\" type=\"button\">Guardar como OT</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"order.save.cancel()\" type=\"button\">Cancelar</button></div></div></div>");
$templateCache.put("app/reportes/reporte.adjuntos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reporte Adjuntos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Adjuntos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12form-group\"><div class=\"col-xs-12 col-ms-2 col-sm-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.polizas\" ng-change=\"vm.addTypeAdjuntos(1); vm.saveLocalstorange()\">Pólizas</label></div><div class=\"col-xs-12 col-ms-2 col-sm-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.endosos\" ng-change=\"vm.addTypeAdjuntos(2); vm.saveLocalstorange()\">Endosos</label></div><div class=\"col-xs-12 col-ms-2 col-sm-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.siniestros\" ng-change=\"vm.addPolizas(3); vm.saveLocalstorange()\">Siniestros</label></div><div class=\"col-xs-12 col-ms-2 col-sm-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.fianzas\" ng-change=\"vm.addPolizas(4); vm.saveLocalstorange()\">Fianzas</label></div><div class=\"col-xs-12 col-ms-2 col-sm-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.contratantes\" ng-change=\"vm.addPolizas(5); vm.saveLocalstorange()\">Contratantes</label></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"contractorSelected || vm.form.contratantes\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.group\" change=\"vm.matchesGroup(vm.group.val); vm.saveLocalstorange()\"></autocomplete></div><div align=\"center\" class=\"row\" ng-if=\"vm.form.polizas || vm.form.endosos || vm.form.siniestros || vm.form.fianzas\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><br><div class=\"row\" ng-if=\"vm.form.polizas || vm.form.endosos || vm.form.siniestros || vm.form.fianzas || vm.form.contratantes\"><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right ladda-button\" ng-click=\"getAdjuntos(1,1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos por Tipo</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"adjuntos\"><div class=\"panel-body table-over-y\" ng-if=\"adjuntos.contractor\"><legend class=\"legend-title blue-color\" align=\"center\">Contratante</legend><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Tipo</th><th>Referente</th><th>ID</th><th>Nombre</th><th>Fecha creación</th></tr></thead><tbody><tr ng-repeat=\"adj in adjuntos.contractor track by $index\"><td>Contratantes</td><td>{{adj.owner_ref}}</td><td>{{adj.owner_id}}</td><td>{{adj.name}}</td><td>{{adj.created_at | date:\"dd/MM/yyyy - HH:mm:ss\" }}</td></tr></tbody></table></div><div class=\"panel-body table-over-y\" ng-if=\"adjuntos.polizas\"><legend class=\"legend-title blue-color\" align=\"center\">Póliza</legend><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Tipo</th><th>Referente</th><th>ID</th><th>Vigencia</th><th>Nombre</th><th>Fecha creación</th></tr></thead><tbody><tr ng-repeat=\"adj in adjuntos.polizas track by $index\"><td>Pólizas</td><td>{{adj.owner_ref}}</td><td>{{adj.owner_id}}</td><td>{{adj.inicio | date:\"dd/MM/yyyy\"}} - {{adj.fin | date:\"dd/MM/yyyy\"}}</td><td>{{adj.nombre}}</td><td>{{adj.created_at | date:\"dd/MM/yyyy - HH:mm:ss\" }}</td></tr></tbody></table></div><div class=\"panel-body table-over-y\" ng-if=\"adjuntos.fianzas\"><legend class=\"legend-title blue-color\" align=\"center\">Fianza</legend><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Tipo</th><th>Referente - ID</th><th>ID</th><th>Vigencia</th><th>Nombre</th><th>Fecha creación</th></tr></thead><tbody><tr ng-repeat=\"adj in adjuntos.fianzas track by $index\"><td>Fianzas</td><td>{{adj.owner_ref}}</td><td>{{adj.owner_id}}</td><td>{{adj.inicio | date:\"dd/MM/yyyy\"}} - {{adj.fin | date:\"dd/MM/yyyy\"}}</td><td>{{adj.nombre}}</td><td>{{adj.created_at | date:\"dd/MM/yyyy - HH:mm:ss\" }}</td></tr></tbody></table></div><div class=\"panel-body table-over-y\" ng-if=\"adjuntos.endosos\"><legend class=\"legend-title blue-color\" align=\"center\">Endoso</legend><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Tipo</th><th>Referente</th><th>ID</th><th>Vigencia</th><th>Nombre</th><th>Fecha creación</th></tr></thead><tbody><tr ng-repeat=\"adj in adjuntos.endosos track by $index\"><td>Endoso</td><td>{{adj.owner_ref}}</td><td>{{adj.owner_id}}</td><td>{{adj.inicio | date:\"dd/MM/yyyy\"}} - {{adj.fin | date:\"dd/MM/yyyy\"}}</td><td>{{adj.nombre}}</td><td>{{adj.created_at | date:\"dd/MM/yyyy - HH:mm:ss\" }}</td></tr></tbody></table></div><div class=\"panel-body table-over-y\" ng-if=\"adjuntos.siniestros\"><legend class=\"legend-title blue-color\" align=\"center\">Siniestro</legend><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Tipo</th><th>Referente</th><th>ID</th><th>Fecha Siniestro</th><th>Fecha Ingreso</th><th>Nombre</th><th>Fecha creación</th></tr></thead><tbody><tr ng-repeat=\"adj in adjuntos.siniestros track by $index\"><td>Siniestro</td><td>{{adj.owner_ref}}</td><td>{{adj.owner_id}}</td><td>{{adj.fsiniestro | date:\"dd/MM/yyyy\"}}</td><td>{{adj.fingreso | date:\"dd/MM/yyyy\"}}</td><td>{{adj.nombre}}</td><td>{{adj.created_at | date:\"dd/MM/yyyy - HH:mm:ss\" }}</td></tr></tbody></table></div><button ng-if=\"adjuntos.contractor.length > 0 || adjuntos.polizas.length > 0 || adjuntos.fianzas.length > 0 || adjuntos.endosos.length > 0 || adjuntos.siniestros.length > 0\" ng-click=\"export(1)\" class=\"btn btn-primary pull-right ladda-button_excel\"><i class=\"fa fa-download\"></i> Reporte en excel</button></div></div></div><script type=\"text/javascript\">  \n  $(window).load(function() { $(\"#state\").select2(); });\n</script>");
$templateCache.put("app/reportes/reporte.asegurados.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reporte Asegurados</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Asegurados</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Estatus</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_status\" data-ng-options=\"status.name for status in vm.estatus | orderBy: \'name\' track by status.value\" ng-change=\"selectStatus(select_status)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider); vm.saveLocalstorange()\"><option value=\"\"></option></select></div><br><hr></div><div align=\"center\" class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div><div class=\"col-xs-6 form-group\"><legend class=\"legend-title\" align=\"center\">Subramo/Ramo</legend><div class=\"col-xs-12 col-sm-3\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': subramoSelected == \'1\'}\"><input type=\"radio\" ng-model=\"subramoSelected\" ng-click=\"selectSubramo(subramoSelected)\" value=\"1\"> Vida</label></div></div><div class=\"col-xs-12 col-sm-3\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': subramoSelected == \'9\'}\"><input type=\"radio\" ng-model=\"subramoSelected\" ng-click=\"selectSubramo(subramoSelected)\" value=\"9\"> Autos</label></div></div><div class=\"col-xs-12 col-sm-3\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': subramoSelected == \'0\'}\"><input type=\"radio\" ng-model=\"subramoSelected\" ng-click=\"selectSubramo(subramoSelected)\" value=\"0\"> Daños</label></div></div><div class=\"col-xs-12 col-sm-3\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': subramoSelected == \'2\'}\"><input type=\"radio\" ng-model=\"subramoSelected\" ng-click=\"selectSubramo(subramoSelected)\" value=\"2\"> Accidentes y Enfermedades</label></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right\" ng-click=\"getAsegurados(1,1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Asegurados</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width\" ng-if=\"asegurados && subramoSelected ==\'0\'\"><thead><tr><th>Póliza</th><th>Contratante</th><th>Ramo</th><th>Subramo</th><th>Tipo</th><th>Inicio Vigencia</th><th>Fin de Vigencia</th><th>Estatus</th><th>Bien Asegurado</th><th>Detalles</th><th>Dirección</th><th>Estado</th><th>Prima Neta</th><th>Prima Total</th><th>Paquete</th><th>Forma de Pago</th></tr></thead><tbody><tr ng-repeat=\"aseg in asegurados track by $index\"><td>{{aseg.poliza_number}}</td><td>{{aseg.contractor.full_name}}</td><td>{{aseg.ramo}}</td><td>{{aseg.subramo}}</td><td>{{aseg.damages_policy[0].damage_type}}</td><td>{{aseg.start_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{aseg.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{status(aseg.status)}}</td><td>{{aseg.damages_policy[0].insured_item}}</td><td>{{aseg.damages_policy[0].item_details}}</td><td>{{aseg.damages_policy[0].item_address}}</td><td>{{aseg.address.administrative_area_level_1}}</td><td>{{aseg.p_neta}}</td><td>{{aseg.p_total}}</td><td>{{aseg.paquete}}</td><td>{{payment(aseg.forma_de_pago)}}</td></tr></tbody></table><table class=\"table table-bordered table-hover table-width\" ng-if=\"asegurados && subramoSelected ==\'2\'\"><thead><tr><th>Póliza</th><th>Contratante</th><th>Ramo</th><th>Subramo</th><th>Inicio Vigencia</th><th>Fin de Vigencia</th><th>Estatus</th><th>Tipo Asegurado</th><th>Dependientes</th><th>Nombre</th><th>Fecha Antigüedad</th><th>Fecha Nacimiento</th><th>Parentesco</th><th>Estado</th><th>Prima Neta</th><th>Prima Total</th><th>Paquete</th><th>Edad</th><th>Forma de Pago</th></tr></thead><tbody><tr ng-repeat=\"aseg in asegurados track by $index\"><td>{{aseg.poliza_number}}</td><td>{{aseg.contractor.full_name}}</td><td>{{aseg.ramo}}</td><td>{{aseg.subramo}}</td><td>{{aseg.start_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{aseg.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{status(aseg.status)}}</td><td>Titular</td><td><div ng-if=\"aseg.accidents_policy[0].relationship_accident\"><span ng-repeat=\"deps in aseg.accidents_policy[0].relationship_accident\"><br><span class=\"blue-color\">Nombre:</span> {{deps.first_name}} {{deps.last_name}}<br><span class=\"blue-color\">Parentesco:</span>{{deps.relationship_name}}<br><span class=\"blue-color\">Fecha Nacimiento:</span>{{deps.birthdate | date: \'dd/MM/yyyy\'}}<br><span class=\"blue-color\">Edad:</span>{{deps.age}}</span></div></td><td>{{aseg.accidents_policy[0].personal.first_name}} {{aseg.accidents_policy[0].personal.last_name}}</td><td>{{aseg.accidents_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\'}}</td><td>{{aseg.accidents_policy[0].personal.birthdate | date: \'dd/MM/yyyy\'}}</td><td>Titular</td><td>{{aseg.address.administrative_area_level_1}}</td><td>{{aseg.p_neta}}</td><td>{{aseg.p_total}}</td><td>{{aseg.paquete}}</td><td>{{aseg.accidents_policy[0].personal.age}}</td><td>{{payment(aseg.forma_de_pago)}}</td></tr></tbody></table><table class=\"table table-bordered table-hover table-width\" ng-if=\"asegurados && subramoSelected ==\'1\'\"><thead><tr><th>Póliza</th><th>Contratante</th><th>Ramo</th><th>Subramo</th><th>Tipo</th><th>Inicio Vigencia</th><th>Fin de Vigencia</th><th>Estatus</th><th>Tipo Asegurado</th><th>Beneficiarios</th><th>Nombre</th><th>Fecha Antigüedad</th><th>Fecha Nacimiento</th><th>Parentesco</th><th>Fumador</th><th>Porcentaje</th><th>Estado</th><th>Prima Neta</th><th>Prima Total</th><th>Paquete</th><th>Edad</th><th>Forma de Pago</th></tr></thead><tbody><tr ng-repeat=\"aseg in asegurados track by $index\"><td>{{aseg.poliza_number}}</td><td>{{aseg.contractor.full_name}}</td><td>{{aseg.ramo}}</td><td>{{aseg.subramo}}</td><td><span ng-if=\"aseg.life_policy[0].personal.policy_type ==47\">Ahorro</span> <span ng-if=\"aseg.life_policy[0].personal.policy_type ==48\">Vitalicia</span> <span ng-if=\"aseg.life_policy[0].personal.policy_type ==49\">Temporal/Protección</span></td><td>{{aseg.start_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{aseg.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{status(aseg.status)}}</td><td>Titular</td><td><div ng-if=\"aseg.life_policy[0].beneficiaries_life\"><span ng-repeat=\"deps in aseg.life_policy[0].beneficiaries_life\"><br><span class=\"blue-color\">Nombre:</span> {{deps.first_name}} {{deps.last_name}}<br><span class=\"blue-color\">Parentesco:</span>{{deps.optional_relationship}}<br><span class=\"blue-color\">Porcentaje:</span>{{deps.percentage}}<br><span class=\"blue-color\">Género:</span>{{deps.sex}}<br><span class=\"blue-color\">Fecha Nacimiento:</span>{{deps.birthdate | date: \'dd/MM/yyyy\'}}<br><span class=\"blue-color\">Edad:</span>{{deps.age}}</span></div></td><td>{{aseg.life_policy[0].personal.first_name}} {{aseg.life_policy[0].personal.last_name}}</td><td>{{aseg.life_policy[0].personal.antiguedad | date: \'dd/MM/yyyy\'}}</td><td>{{aseg.life_policy[0].personal.birthdate | date: \'dd/MM/yyyy\'}}</td><td>Titular</td><td><span ng-if=\"aseg.life_policy[0].personal.smoker\">Si</span> <span ng-if=\"!aseg.life_policy[0].personal.smoker\">No</span></td><td></td><td>{{aseg.address.administrative_area_level_1}}</td><td>{{aseg.p_neta}}</td><td>{{aseg.p_total}}</td><td>{{aseg.paquete}}</td><td>{{aseg.life_policy[0].personal.age}}</td><td>{{payment(aseg.forma_de_pago)}}</td></tr></tbody></table><table class=\"table table-bordered table-hover table-width\" ng-if=\"asegurados && subramoSelected ==\'9\'\"><thead><tr><th>Póliza</th><th>Contratante</th><th>Ramo</th><th>Subramo</th><th>Tipo</th><th>Inicio Vigencia</th><th>Fin de Vigencia</th><th>Estatus</th><th>Conductor</th><th>Marca</th><th>Modelo</th><th>Año</th><th>Versión</th><th>Serie</th><th>Motor</th><th>Color</th><th>Matrícula</th><th>Uso</th><th>Servicio</th><th>Estado Circulación</th><th>Adaptación</th><th>Monto Adaptación</th><th>Equipo especial</th><th>Monto Equipo especial</th><th>Nombre Beneficiario</th><th>Dirección Beneficiario</th><th>RFC Beneficiario</th><th>Estado</th><th>Prima Neta</th><th>Prima Total</th><th>Paquete</th><th>Forma de Pago</th></tr></thead><tbody><tr ng-repeat=\"aseg in asegurados track by $index\"><td>{{aseg.poliza_number}}</td><td>{{aseg.contractor.full_name}}</td><td>{{aseg.ramo}}</td><td>{{aseg.subramo}}</td><td>{{aseg.automobiles_policy[0].policy_typename}}</td><td>{{aseg.start_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{aseg.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{status(aseg.status)}}</td><td>{{aseg.automobiles_policy[0].driver}}</td><td>{{aseg.automobiles_policy[0].brand}}</td><td>{{aseg.automobiles_policy[0].model}}</td><td>{{aseg.automobiles_policy[0].year}}</td><td>{{aseg.automobiles_policy[0].version}}</td><td>{{aseg.automobiles_policy[0].serial}}</td><td>{{aseg.automobiles_policy[0].engine}}</td><td>{{aseg.automobiles_policy[0].color}}</td><td>{{aseg.automobiles_policy[0].license_plates}}</td><td><span ng-if=\"aseg.automobiles_policy[0].usage ==1\">Particular</span> <span ng-if=\"aseg.automobiles_policy[0].usage ==2\">Carga</span> <span ng-if=\"aseg.automobiles_policy[0].usage ==3\">Servicio Particular</span></td><td>{{aseg.automobiles_policy[0].service}}</td><td>{{aseg.state_circulation}}</td><td>{{aseg.automobiles_policy[0].adjustment}}</td><td>{{aseg.automobiles_policy[0].mont_adjustment}}</td><td>{{aseg.automobiles_policy[0].special_team}}</td><td>{{aseg.automobiles_policy[0].mont_special_team}}</td><td>{{aseg.automobiles_policy[0].beneficiary_name}}</td><td>{{aseg.automobiles_policy[0].beneficiary_address}}</td><td>{{aseg.automobiles_policy[0].beneficiary_rfc}}</td><td>{{aseg.address.administrative_area_level_1}}</td><td>{{aseg.p_neta}}</td><td>{{aseg.p_total}}</td><td>{{aseg.paquete}}</td><td>{{payment(aseg.forma_de_pago)}}</td></tr></tbody></table><div ng-if=\"vm.show_pag_asegurados && asegurados.length > 0\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div><button ng-if=\"asegurados.length > 0\" ng-click=\"export(1)\" class=\"btn btn-primary pull-right ladda-button_excel\"><i class=\"fa fa-download\"></i> Reporte en excel</button></div></div></div><script type=\"text/javascript\">  \n  $(window).load(function() { $(\"#state\").select2(); });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script>");
$templateCache.put("app/reportes/reporte.auditoria.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12\"><h2>Reportes Auditoria</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Auditoria</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Identificador</label> <input class=\"form-control\" type=\"text\" name=\"identificador\" ng-model=\"vm.form.identifier\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider); vm.saveLocalstorange()\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo); vm.saveLocalstorange()\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.subramo_code\" ng-change=\"selectSubramos(select_sramo); vm.saveLocalstorange()\"></select></div><div align=\"center\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input ng-disabled=\"vm.buscar_por_folio\" type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince(); vm.saveLocalstorange()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" ng-disabled=\"vm.buscar_por_folio\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil(); vm.saveLocalstorange()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Filtrar por</legend><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': ot_rep == \'1\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"1\"> Pólizas, Recibos, Endosos</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': ot_rep == \'2\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"2\"> Pólizas y Recibos</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': ot_rep == \'3\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"3\"> Pólizas y Endosos (Sin recibos)</label></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"vm.acceso_ver_cob\"><button class=\"btn btn-success pull-right ladda-buttonC\" ng-click=\"vm.Generar(1,1)\">Consultar</button></div></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result || grupos_result.length == 0\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><td>TIPO DE DATO</td><td>NUMERO DE POLIZA</td><td>CONTRATANTE</td><td>CORREO</td><td>TELEFONO</td><td>ASEGURADORA</td><td>CLAVE</td><td>RAMO</td><td>SUBRAMO</td><td>TIPO</td><td>BIEN ASEGURADO</td><td>ESTATUS</td><td>INICIO VIGENCIA (POL/END)</td><td>FIN VIGENCIA (POL/END)</td><td>FORMA DE PAGO</td><td>REFERENCIADOR</td><td>MONEDA</td><td>CONDUCTO DE PAGO</td><td>PRIMA NETA</td><td>DESCUENTO</td><td>RPF</td><td>DERECHO</td><td>IVA</td><td>PRIMA TOTAL</td><td>COMISION $</td><td>COMISION %</td><td>ID POLIZA</td><td>POLIZA ANTERIOR</td><td>POLIZA SIGUIENTE</td><td>BALANCE PRIMA NETA</td><td>BALANCE PRIMA TOTAL</td><td>TOTAL PAGADO</td><td>TOTAL PENDIENTE</td><td>TOTAL CANCELADO</td><td>RECIBOS VENCIDO</td><td>BALANCE COMISION POLIZAvsRECIBOS</td></tr></thead><tbody><tr ng-repeat=\"registro in auditoria track by $index\" ng-click=\"vm.goToInfo(insurance)\"><td>Póliza</td><td>{{registro.poliza_number}}</td><td>{{registro.contractor.full_name}}</td><td>{{registro.contractor.email}}</td><td>{{registro.contractor.phone_number}}</td><td>{{registro.aseguradora}}</td><td>{{registro.clave.name}} - {{registro.clave.clave}}</td><td>{{registro.ramo}}</td><td>{{registro.subramo}}</td><td><span ng-if=\"registro.document_type == \'Póliza\'\">Póliza</span> <span ng-if=\"registro.document_type == \'OT\'\">OT</span> <span ng-if=\"registro.document_type == \'Colectividad\'\">Póliza de Grupo</span> <span ng-if=\"registro.document_type == \'Carátula\'\">Colectividad</span> <span ng-if=\"registro.document_type == \'Póliza de Carátula\'\">Póliza de Colectividad</span> <span ng-if=\"registro.document_type == \' \'\"></span> <span ng-if=\"registro.document_type == 1\">Póliza</span> <span ng-if=\"registro.document_type == 1 && (registro.status == 1 || registro.status==2)\">OT</span> <span ng-if=\"registro.document_type == 3\">Póliza de Grupo</span> <span ng-if=\"registro.document_type == 11\">Colectividad</span> <span ng-if=\"registro.document_type == 12\">Póliza de Colectividad</span></td><td>{{ registro.accidents_policy[0].personal.full_name }} {{ registro.life_policy[0].personal.full_name }} {{ registro.automobiles_policy[0].serial }}</td><td><span ng-if=\"registro.status != \' \'\"><p>{{ status(registro.status) }}</p></span></td><td>{{ registro.start_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{ registro.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{ registro.forma_de_pago }}</td><td><div ng-if=\"registro.ref_policy\"><span ng-repeat=\"ref in registro.ref_policy\">{{ref.referenciador.first_name}} {{ref.referenciador.last_name}}</span></div><div ng-if=\"registro.vendor && !registro.ref_policy\">{{registro.vendor.first_name}} {{registro.vendor.last_name}}</div></td><td>{{ registro.f_currency }}</td><td>{{ registro.conducto_de_pago }}</td><td>{{ registro.p_neta | currency}}</td><td>{{ registro.descuento | currency}}</td><td>{{ registro.rpf | currency}}</td><td>{{ registro.derecho | currency}}</td><td>{{ registro.iva | currency}}</td><td>{{ registro.p_total | currency}}</td><td>{{ registro.comision | currency}}</td><td>{{ registro.comision_percent}}</td><td>{{ registro.id}}</td><td>{{ registro.poliza_anterior}}</td><td>{{ registro.poliza_siguiente}}</td><td>{{ registro.auditoria.pnetasuma | currency}}</td><td>{{ registro.auditoria.ptotalsuma | currency}}</td><td>{{ registro.auditoria.total_pagado | currency}}</td><td>{{ registro.auditoria.total_pendiente | currency}}</td><td>{{ registro.auditoria.total_cancelado | currency}}</td><td>{{ registro.auditoria.vencidos}}</td><td>{{ registro.auditoria.balance_comision | currency}}</td></tr></tbody></table><div ng-if=\"vm.show_pag_auditoria\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div><div class=\"row\" ng-if=\"vm.acceso_rep_pol\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button2\" ng-click=\"exportDataExcel(1,false)\">Generar Reporte</button></div></div>");
$templateCache.put("app/reportes/reporte.certificados.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reportes Certificados</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Certificados</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Número de Póliza</label> <input class=\"form-control\" type=\"text\" name=\"poliza\" ng-model=\"vm.form.num_poliza\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Observaciones</label> <input class=\"form-control\" type=\"text\" name=\"observaciones\" ng-model=\"vm.form.observaciones\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Filtrar fecha por:</label><select class=\"form-control\" ng-change=\"vm.changeDateFilter()\" ng-model=\"vm.form.date_filter_by\" ng-options=\"status.name for status in vm.filter_type track by status.id\"></select></div><div ng-if=\"vm.form.date_filter_by.id != 2\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div ng-if=\"vm.form.date_filter_by.id != 2\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.select_provider\" data-ng-options=\"providers.compania ? providers.compania : providers.id for providers in vm.providers | orderBy: \'compania\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.select_ramo\" data-ng-options=\"ramos_toselected.ramo_name for ramos_toselected in vm.ramos_toselected track by ramos_toselected.ramo_code\" ng-change=\"selectSubramos(select_ramo)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.subramo_code\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"campo_celula\"><label>Célula</label><select class=\"form-control\" ng-model=\"vm.form.celula\" data-ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"vm.changecelula(vm.form.celula)\"><option value=\"\">Todas las Células</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Referenciador</label><select class=\"form-control\" ng-model=\"vm.form.vendedor\" data-ng-options=\"vendedor.name for vendedor in vm.vendedores | orderBy: \'name\' track by vendedor.id\" ng-change=\"vm.changeReferenciador(vm.form.vendedor)\"><option value=\"\">Todos los referenciadores</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.form.select_user\" data-ng-options=\"users.username for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Número de Certificado</label> <input class=\"form-control\" type=\"text\" name=\"poliza\" ng-model=\"vm.form.num_certificado\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Estatus del certificado</label><select class=\"form-control\" ng-model=\"vm.form.status_cert\" ng-options=\"status.name for status in vm.status track by status.id\" ng-change=\"vm.changeStatus(vm.form.status)\"><option value=\"\">Todos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Estatus de renovación</label><select class=\"form-control\" ng-model=\"vm.form.status_ren_cert\" ng-options=\"status.name for status in vm.status_ren track by status.id\" ng-change=\"vm.changeStatusRen(vm.form.status_ren_cert)\"><option value=\"\">Todas</option></select></div></div><div class=\"row\" align=\"center\"><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" align=\"center\"><legend class=\"blue-color\" align=\"center\">Pólizas Contributorias</legend><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 form-group\"><input type=\"radio\" ng-model=\"vm.form.contributory\" name=\"si\" ng-value=\"1\" ng-click=\"vm.Generar()\"><b>Solo Contributorias</b></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 form-group\"><input type=\"radio\" ng-model=\"vm.form.contributory\" name=\"todos\" ng-value=\"0\" ng-click=\"vm.Generar()\"><b>Todos</b></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right ladda-buttonC\" ng-click=\"vm.Generar()\">Consultar</button></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Certificados</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th ng-repeat=\"item in vm.table.headers\">{{item}}</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.insurances track by $index\" ng-click=\"vm.goToInfo(insurance)\" on-finish-render=\"ngRepeatFinished\"><td>{{insurance.poliza_number}}</td><td>{{ insurance.contratante }}</td><td>{{insurance.certificate_number}}</td><td ng-if=\"insurance.certificado_inciso_activo\">Activo</td><td ng-if=\"!insurance.certificado_inciso_activo\">Inactivo</td><td>{{insurance.ramo}}</td><td>{{insurance.subramo}}</td><td>{{insurance.aseguradora}}</td><td>{{insurance.paquete}}</td><td>{{insurance.tipo}}</td><td>{{insurance.nombre_asegurado}}</td><td>{{insurance.sexo}}</td><td>{{insurance.email}}</td><td>{{insurance.marca}}</td><td>{{insurance.modelo}}</td><td>{{insurance.anio}}</td><td>{{insurance.version}}</td><td>{{insurance.serie}}</td><td>{{insurance.motor}}</td><td>{{insurance.conductor}}</td><td>{{insurance.vigencia}}</td><td>{{insurance.fecha_antiguedad}}</td><td>{{insurance.rpf | currency}}</td><td>{{insurance.iva | currency}}</td><td>{{insurance.derecho | currency}}</td><td>{{insurance.p_neta | currency}}</td><td>{{insurance.p_total | currency}}</td></tr></tbody></table></div><div class=\"col-xs-12 form-group\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav><div ng-if=\"vm.insurances.length > 0\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Enviar reporte por correo <small><i><u>(Si no se introduce un email se enviará al email del usuario que genera el reporte)</u></i></small></label> <input class=\"form-control\" type=\"text\" name=\"poliza\" ng-model=\"vm.form.email\"> <button ng-click=\"vm.exportDataExcel()\" class=\"btn btn-primary pull-right ladda-button_excel\"><i class=\"fa fa-download\"></i>Generar Reporte en Excel</button></div></div></div></div></div>");
$templateCache.put("app/reportes/reporte.cobranza.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12\"><h2>Reportes Cobranzas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Cobranza</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtro Básico</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row report-highlight text-align-center\"><div class=\"col-sm-6 col-md-4 col-lg-4 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport();\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-sm-6 col-md-4 col-lg-4 form-group\"><label>Desde</label><div class=\"input-group date\" data-provide=\"datepicker\"><input type=\"text\" class=\"form-control text-center\" ng-model=\"vm.form.since\" ng-change=\"vm.options.changeSince();\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-4 form-group\"><label>Hasta</label><div class=\"input-group date\" data-provide=\"datepicker\"><input type=\"text\" class=\"form-control text-center\" ng-model=\"vm.form.until\" ng-change=\"vm.changeUntil();\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><legend class=\"legend\" align=\"center\">Estatus</legend><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\" style=\"margin-top: 0;\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_pagados\" ng-change=\"vm.enableConciliacion(1);\">Pagados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_no_pagados\" ng-change=\"vm.enableConciliacion(1);\">No pagados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_prorrogados\" ng-change=\"vm.enableConciliacion(1);\">Prorrogados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_liquidados\" ng-change=\"vm.enableConciliacion(1);\">Liquidados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_conciliados\" ng-change=\"vm.enableConciliacion(2);\">Conciliados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_precancelados\" ng-change=\"vm.enableConciliacion(1);\">Precancelados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_cancelados\" ng-change=\"vm.enableConciliacion(1);\">Cancelados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_cerrados\" ng-change=\"vm.enableConciliacion(1);\">Cerrados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_pago_parcial\" ng-change=\"vm.enableConciliacion(1);\">Pago parcial</label></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Más Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-show=\"!vm.buscar_por_folio\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val);\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" ng-disabled=\"vm.buscar_por_folio\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val);\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"subgroups.length >0\"><label>SubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subgroup\" data-ng-options=\"subgroup.group_name for subgroup in subgroups track by subgroup.url\" ng-change=\"vm.changeSubgroup(vm.form.subgroup)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"subsubgroups.length >0\"><label>SubsubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subsubgroup\" data-ng-options=\"subsubgroup.group_name for subsubgroup in subsubgroups track by subsubgroup.url\" ng-change=\"vm.changeSubsubgroup(vm.form.subsubgroup)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Clasificación</label><autocomplete datasource=\"classification_data\" id=\"classification\" model=\"vm.form.classification\" change=\"vm.matchesClassification(vm.form.classification.val);\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-model=\"vm.form.businesLine\" data-ng-options=\"businesLine.name for businesLine in vm.businesLine track by businesLine.id\" ng-change=\"vm.changeBLine(vm.form.businesLine);\" required=\"\"><option value=\"\">Todas las líneas</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_agrupacion\"><label>Nivel de Agrupación</label><autocomplete datasource=\"groupinglevels_data\" id=\"groupingleves\" model=\"vm.form.groupinglevel\" change=\"vm.matchesGroupinglevel(vm.form.groupinglevel.val);\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.form.groupinglevel.subgrupos.length > 0 && campo_agrupacion\"><label>SubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subgrouping\" data-ng-options=\"subgrouping.description for subgrouping in vm.form.groupinglevel.subgrupos track by subgrouping.url\" ng-change=\"vm.changeSubgrouping(vm.form.subgrouping)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.form.subgrouping.subsubgrupos.length >0 && campo_agrupacion\"><label>SubsubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subsubgrouping\" data-ng-options=\"subsubgroupin.description for subsubgroupin in vm.form.subgrouping.subsubgrupos track by subsubgroupin.url\" ng-change=\"vm.changeSubsubgrouping(vm.form.subsubgrouping)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-model=\"vm.form.celula\" data-ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"vm.changecelula(vm.form.celula);\"><option value=\"\">Todo</option></select></div></div><div class=\"row\" ng-show=\"!vm.buscar_por_folio\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" multiple=\"\" ng-model=\"select_provider\" ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy:\'alias\' track by providers.url\" ng-change=\"selectProv(select_provider);\"></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo);\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option><option value=\"6\">Administrativas</option><option value=\"7\">Crédito</option><option value=\"8\">Fideicomiso</option><option value=\"4\">Fidelidad</option><option value=\"5\">Judicial</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.subramo_code\" ng-change=\"selectSubramos(select_sramo);\"></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"!vm.buscar_por_folio\"><label>Creado por</label><select class=\"form-control\" ng-model=\"vm.form.user\" data-ng-options=\"user.first_name +\' \'+user.last_name for user in vm.users | orderBy: \'first_name\' track by user.id\" ng-change=\"selectUser(vm.form.user);\"><option value=\"\">Todos los usuarios</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Pagado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user_pay\" data-ng-options=\"users_p.username for users_p in vm.users | orderBy: \'username\' track by users_p.url\" ng-change=\"selectUserPay(select_user_pay);\"><option value=\"\"></option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Clave de Agente</label> <input class=\"form-control\" type=\"text\" name=\"agente\" ng-model=\"vm.form.cve_agente\" ng-change=\"\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.permiso_ver_referenciador\"><label>Referenciador</label><select class=\"form-control\" ng-model=\"vm.form.vendedor\" data-ng-options=\"vendedor.name for vendedor in vm.vendedores | orderBy: \'name\' track by vendedor.id\" ng-change=\"vm.changeReferenciador(vm.form.vendedor);\"><option value=\"\">Todos los referenciadores</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label title=\"Filtro aplicado sobre la póliza\">Sucursal</label><select class=\"form-control\" ng-model=\"vm.form.sucursal\" ng-options=\"sucursal.sucursal_name for sucursal in sucursales.data track by sucursal.id\" ng-change=\"\"><option value=\"\">Seleccione</option></select><span ng-if=\"vm.form.sucursal\" class=\"color-red\">Filtro aplicado sobre póliza(s)</span></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Entregado:</label><select class=\"form-control\" ng-model=\"vm.form.recibos_delivered\" ng-options=\"entregado.name for entregado in vm.entregados track by entregado.id\" ng-change=\"vm.enableConciliacion(1)\"><option value=\"\">Seleccione</option></select></div></div><div class=\"row\" ng-if=\"!vm.buscar_por_folio\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Agrupar por:</label><select class=\"form-control\" ng-disabled=\"vm.buscar_por_folio\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"vm.changeGroupBy();\"><option value=\"\">Seleccione</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group\"><label>Identificador de Póliza</label> <input ng-disabled=\"vm.buscar_por_folio\" class=\"form-control\" type=\"text\" name=\"identificador\" ng-model=\"vm.form.identifier\" ng-change=\"\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Valor dólar</label> <input ng-disabled=\"vm.buscar_por_folio\" class=\"form-control\" type=\"text\" name=\"valueDolar\" ng-model=\"vm.form.valueDolar\" ng-change=\"numberFormatDolar(vm.form.valueDolar);\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Valor UDI</label> <input ng-disabled=\"vm.buscar_por_folio\" class=\"form-control\" type=\"text\" name=\"valueUdi\" ng-model=\"vm.form.valueUdi\" ng-change=\"numberFormatUdi(vm.form.valueUdi);\"></div></div><div class=\"row\" ng-if=\"!vm.buscar_por_folio\"><div class=\"col-sm-6 col-md-4 col-lg-4 form-group\" ng-if=\"!vm.buscar_por_folio\"><label>Carátula:</label><br><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.word\" change=\"vm.getCaratulas(vm.word)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getCarSelected(vm.word);\"><span class=\"fa fa-ok\"></span> Seleccionar</button></div></div></div></div><div class=\"row\"></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-3 checkbox\" ng-if=\"!vm.buscar_por_folio\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_delivered\" ng-change=\"vm.enableConciliacion(1)\">No entregados</label></div><div class=\"col-xs-12 col-sm-4 col-md-3 checkbox\" ng-if=\"!vm.buscar_por_folio\"><div class=\"col-xs-12 checkbox\" align=\"center\"><label><input ng-disabled=\"vm.buscar_por_folio\" type=\"checkbox\" ng-model=\"vm.form.add_precancelados\" ng-change=\"vm.addPrecancel(1);\">Excluir recibos pre-cancelados</label></div></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><input name=\"look_folio\" ng-model=\"vm.buscar_por_folio\" ng-change=\"vm.apagarBusquedaPorFolio(vm.buscar_por_folio);\" type=\"checkbox\" class=\"ng-valid ng-dirty ng-touched\"> <span for=\"look_folio\">Buscar por número de folio de pago/liquidación</span></div><div ng-if=\"vm.buscar_por_folio\" class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><input name=\"look_folio_pago\" value=\"1\" ng-model=\"vm.form.tipo_folio_buscar\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"look_folio_pago\" ng-chnage=\"\">Folio de pago</span></div><div ng-if=\"vm.buscar_por_folio\" class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><input name=\"look_folio_liq\" value=\"2\" ng-model=\"vm.form.tipo_folio_buscar\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"look_folio_liq\" ng-chnage=\"\">Folio de liquidación</span></div><div ng-if=\"vm.buscar_por_folio\" class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Buscar Folio:</label> <input placeholder=\"Folio\" type=\"text\" ng-if=\"vm.buscar_por_folio\" class=\"form-control\" ng-model=\"vm.form.folio_a_buscar\" ng-change=\"\"></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Número de póliza</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.policySearch\" placeholder=\"Escribe al menos 3 caracteres\" uib-typeahead=\"p as p.label for p in vm.searchPolicies($viewValue)\" typeahead-min-length=\"3\" typeahead-wait-ms=\"350\" typeahead-loading=\"vm.loadingPolicies\" typeahead-on-select=\"vm.onPolicySelected($item)\"><div ng-if=\"vm.loadingPolicies\" class=\"text-muted\" style=\"margin-top:6px;\">Buscando...</div><div ng-if=\"vm.filters.policy_id\" style=\"margin-top:6px;\"><span class=\"label label-info\">{{vm.filters.policy_label}}</span> <button type=\"button\" class=\"btn btn-xs btn-default\" ng-click=\"vm.clearPolicy()\">Quitar</button></div></div></div><div class=\"row\" ng-if=\"!vm.buscar_por_folio\"><hr><div><div class=\"col-xs-6 form-group\"><legend class=\"legend-title filter-section legend\" align=\"center\">Conducto de Pago</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"cp_todos\" ng-change=\"selectReceiptsOption(0, cp_todos);\">Todos</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"cp_domiciliado\" ng-change=\"selectReceiptsOption(4, cp_domiciliado);\">CAT/Domiciliado</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"cp_no_domiciliado\" ng-change=\"selectReceiptsOption(1, cp_no_domiciliado);\">No Domiciliado</label></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"cp_agente\" ng-change=\"selectReceiptsOption(2, cp_agente);\">Agente</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"cp_cac\" ng-change=\"selectReceiptsOption(3, cp_cac);\">CAC</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"cp_nomina\" ng-change=\"selectReceiptsOption(5, cp_nomina);\">Nómina</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\" align=\"center\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"cp_cut\" ng-change=\"selectReceiptsOption(6, cp_cut);\">CUT</label></div></div></div></div></div><div class=\"col-xs-6 form-group border-left\"><legend class=\"legend-title filter-section legend\" align=\"center\">Tipo</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'fianza\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza);\" value=\"fianza\"> Fianza</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'poliza\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza);\" value=\"poliza\"> Póliza Individual</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'colectiva\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza);\" value=\"colectiva\"> Póliza de Grupo</label></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'caratula\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza);\" value=\"caratula\"> Colectividad</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'bono\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza);\" value=\"bono\"> Bonos</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'ambas_pf\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza);\" value=\"ambas_pf\"> Fianzas / Pólizas / Bonos</label></div></div></div></div><div class=\"col-xs-12 form-group border-left\"><legend class=\"legend-title filter-section legend\" align=\"center\">Opciones</legend><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': recibo_nota == \'recibo\'}\"><input type=\"radio\" ng-model=\"recibo_nota\" ng-click=\"selectReciboOption(recibo_nota);\" value=\"recibo\"> Recibos</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': recibo_nota == \'nota\'}\"><input type=\"radio\" ng-model=\"recibo_nota\" ng-click=\"selectReciboOption(recibo_nota)\" value=\"nota\"> Notas de Crédito</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': recibo_nota == \'ambos\'}\"><input type=\"radio\" ng-model=\"recibo_nota\" ng-click=\"selectReciboOption(recibo_nota);\" value=\"ambos\"> Recibos / Notas de Crédito</label></div></div></div></div></div></div><div class=\"row text-align-center\"><div class=\"col-xs-12\" ng-if=\"vm.acceso_ver_cob\"><button class=\"btn btn-success ladda-buttonC\" ng-click=\"vm.Generar(24,1)\">Consultar</button></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\" style=\"position: relative; overflow: hidden;\"><h5>Recibos</h5><div class=\"contentvideo\"><span>Personaliza tus reportes: selecciona solo los campos que necesitas</span> <a href=\"https://youtu.be/KFd50p5ZVuk\" target=\"_blank\" class=\"vervideo\">▶ Ver video</a></div><div ibox-tools=\"\" class=\"iboxtools\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result || grupos_result.length == 0\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr ng-if=\"filteredKeys.length>0\"><th ng-repeat=\"header in filteredKeys\">{{ header }}</th></tr></thead><tbody><tr ng-show=\"insurance\" ng-repeat=\"insurance in vm.insurances track by $index\" ng-click=\"vm.goToInfo(insurance)\"><td ng-repeat=\"header in filteredKeys\"><span ng-if=\"header === \'No.Póliza/Fianza\'\">{{ insurance.poliza.poliza_number }} <span ng-if=\"insurance.poliza.document_type == 4\">{{ insurance.poliza.parent.poliza_number }}</span></span> <span ng-if=\"header ===\'Tipo Recibo\'\">{{ typeReceipt(insurance.receipt_type,insurance)}}</span> <span ng-if=\"header ===\'No.Endoso\'\"><span ng-if=\"insurance.endorsement && insurance.receipt_type == 2\">{{insurance.endorsement.number_endorsement}}</span> <span ng-if=\"insurance.endorsement && insurance.receipt_type == 3\">{{insurance.endorsement.number_endorsement}}</span> <span ng-if=\"insurance.receipt_type == 1\">&nbsp;</span></span> <span ng-if=\"header ===\'Endoso Descripción\'\"><span ng-if=\"insurance.endorsement && insurance.receipt_type == 2\">{{insurance.endorsement.observations}}</span> <span ng-if=\"insurance.endorsement && insurance.receipt_type == 3\">{{insurance.endorsement.observations}}</span> <span ng-if=\"insurance.receipt_type == 1\">&nbsp;</span></span> <span ng-if=\"header ===\'Estatus Póliza/Endoso\'\"><span ng-if=\"insurance.poliza\">{{ status(insurance.poliza.status) }}</span></span> <span ng-if=\"header ===\'Grupo\'\"><span ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor.group }}</span> <span ng-if=\"insurance.poliza.parent.contractor\">{{ insurance.poliza.parent.contractor.group }}</span></span> <span ng-if=\"header ===\'Contratante\'\"><span ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor.full_name }}</span> <span ng-if=\"insurance.poliza.parent.contractor\">{{ insurance.poliza.parent.contractor.full_name }}</span></span> <span ng-if=\"header ===\'Correo electrónico\'\"><span ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor.email }}</span> <span ng-if=\"insurance.poliza.parent.contractor\">{{ insurance.poliza.parent.contractor.email }}</span></span> <span ng-if=\"header ===\'Teléfono\'\"><span ng-if=\"(insurance.poliza.contractor)\">{{ insurance.poliza.contractor.phone_number }}</span> <span ng-if=\"(insurance.poliza.parent.contractor)\">{{ insurance.poliza.parent.contractor.phone_number }}</span></span> <span ng-if=\"header ===\'Alías Aseguradora/Afianzadora\'\">{{ insurance.poliza.parent.aseguradora }}{{ insurance.poliza.aseguradora }}{{insurance.bono.aseguradora}}</span> <span ng-if=\"header ===\'Ramo\'\">{{ insurance.poliza.parent.ramo }}{{ insurance.poliza.ramo }}</span> <span ng-if=\"header ===\'Subramo\'\">{{ insurance.poliza.parent.subramo }}{{ insurance.poliza.subramo }}</span> <span ng-if=\"header ===\'Identificador\'\"><span ng-if=\"insurance.poliza\">{{insurance.poliza.identifier}}</span></span> <span ng-if=\"header ===\'Riesgo/Asegurado\'\"><span>{{ insurance.poliza.accidents_policy[0].personal.full_name }}{{ insurance.poliza.automobiles_policy[0].serial }}{{ insurance.poliza.life_policy[0].personal.full_name }}</span></span> <span ng-if=\"header ===\'Forma de Pago\'\"><span ng-if=\"insurance.poliza\">{{insurance.poliza.forma_de_pago}}</span> <span ng-if=\"insurance.fianza\">Anual</span></span> <span ng-if=\"header ===\'Moneda\'\"><span ng-if=\"insurance.poliza.f_currency ==1\">Pesos</span> <span ng-if=\"insurance.poliza.f_currency ==2\">Dólares</span> <span ng-if=\"!(insurance.poliza) && insurance.bono\">{{insurance.bono.tipo_cambio}}</span></span> <span ng-if=\"header ===\'Serie No.Recibo\'\">{{ insurance.recibo_numero }}</span> <span ng-if=\"header ===\'Fecha Inicio recibo\'\">{{ insurance.fecha_inicio | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Fecha Fin recibo\'\">{{ insurance.fecha_fin | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Vencimiento\'\">{{ insurance.vencimiento | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Antigüedad\'\">{{insurance.antiguedad}}</span> <span ng-if=\"header ===\'Promesa Pago\'\">{{ insurance.promesa_pago | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Prima Neta\'\">{{ insurance.prima_neta | currency }}</span> <span ng-if=\"header ===\'RPF\'\">{{ insurance.rpf | currency }}</span> <span ng-if=\"header ===\'Derecho\'\">{{ insurance.derecho | currency }}</span> <span ng-if=\"header ===\'IVA\'\">{{ insurance.iva | currency }}</span> <span ng-if=\"header ===\'Prima Total\'\">{{ insurance.prima_total | currency }}</span> <span ng-if=\"header ===\'Comisión\'\"><span ng-if=\"vm.permiso_comisiones\">{{ insurance.comision | currency }}</span></span> <span ng-if=\"header ===\'Estatus recibo\'\">{{ insurance.status }}</span> <span ng-if=\"header ===\'Conducto de Pago\'\"><span ng-if=\"insurance.is_cat == true\">Si</span> <span ng-if=\"insurance.is_cat == false\">No</span></span> <span ng-if=\"header ===\'Metodo de Pago\'\"><span ng-if=\"insurance.pay_form && insurance.pay_form==0\">No especificado</span> <span ng-if=\"insurance.pay_form && insurance.pay_form==1\">Cheque</span> <span ng-if=\"insurance.pay_form && insurance.pay_form==2\">Efectivo</span> <span ng-if=\"insurance.pay_form && insurance.pay_form==3\">Transferencia</span> <span ng-if=\"insurance.pay_form && insurance.pay_form==4\">Deposito Bancario</span> <span ng-if=\"insurance.pay_form && insurance.pay_form==5\">Tarjeta de Credito</span> <span ng-if=\"insurance.pay_form && insurance.pay_form==6\">Tarjeta de Debito</span> <span ng-if=\"insurance.pay_form && insurance.pay_form==7\">Estado de Cuenta</span> <span ng-if=\"insurance.pay_form && insurance.pay_form==8\">Compañia</span></span> <span ng-if=\"header ===\'Documento de Pago\'\"><span ng-if=\"insurance.pay_doc\">{{insurance.pay_doc}}</span></span> <span ng-if=\"header ===\'Fecha Pago\'\">{{ insurance.pay_date | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Fecha Liquidación\'\">{{ insurance.liquidacion_date | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Folio de Pago\'\">{{ insurance.folio_pago}}</span> <span ng-if=\"header ===\'Folio de Liquidación\'\">{{ insurance.liquidacion_folio}}</span> <span ng-if=\"header ===\'Fecha de conciliación\'\">{{ insurance.conciliacion_date | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Comisión conciliada\'\"><span ng-if=\"vm.permiso_comisiones\">{{ insurance.comision_conciliada | currency }}</span></span> <span ng-if=\"header ===\'Fecha Inicio Póliza/Fianza\'\"><span ng-if=\"insurance.poliza\">{{ insurance.poliza.start_of_validity | date: \'dd/MM/yyyy\' }}</span> <span ng-if=\"(!insurance.poliza) && insurance.bono\">{{ insurance.bono.start_validity | date: \'dd/MM/yyyy\' }}</span></span> <span ng-if=\"header ===\'Fecha Fin Póliza/Fianza\'\"><span ng-if=\"(!insurance.poliza) && insurance.bono\">{{ insurance.bono.end_validity | date: \'dd/MM/yyyy\' }}</span> <span ng-if=\"insurance.poliza\">{{ insurance.poliza.end_of_validity | date: \'dd/MM/yyyy\' }}</span></span> <span ng-if=\"header ===\'Clave de Agente\'\"><span ng-if=\"insurance.poliza.clave.clave\"><span ng-if=\"insurance.poliza.clave.name\">{{ insurance.poliza.clave.clave }} - {{ insurance.poliza.clave.name }}</span> <span ng-if=\"!insurance.poliza.clave.name\"><p class=\"hidden-text\"></p></span></span></span> <span ng-if=\"header ===\'Clave de Agente\'\"><span ng-if=\"insurance.bono.clave.name\">{{ insurance.bono.clave.clave }} - {{ insurance.bono.clave.name }}</span> <span ng-if=\"!insurance.bono.clave.name\"><p class=\"hidden-text\"></p></span></span> <span ng-if=\"header ===\'Referenciador\'\"><span ng-if=\"vm.permiso_ver_referenciador\"><span ng-if=\"insurance.poliza.ref_policy.length > 0\"><div ng-repeat=\"ref in insurance.poliza.ref_policy\">{{ref.referenciador.first_name}} {{ref.referenciador.last_name}}</div></span> <span ng-if=\"insurance.poliza.ref_policy.length == 0\">{{insurance.poliza.vendor.first_name}} {{insurance.poliza.vendor.last_name}}</span> <span ng-if=\"insurance.fianza\">{{insurance.fianza.vendor.first_name}} {{insurance.fianza.vendor.last_name}}</span></span></span> <span ng-if=\"header ===\'Sucursal\'\">{{insurance.poliza.sucursal.sucursal_name}}</span> <span ng-if=\"header ===\'Responsable\'\">{{insurance.poliza.responsable.first_name}} {{insurance.poliza.responsable.last_name}}</span> <span ng-if=\"header ===\'Creado por\'\">{{insurance.owner}}</span> <span ng-if=\"header ===\'Fecha Creación\'\">{{insurance.created_at | date: \'dd/MM/yyyy\' }}</span> <span ng-if=\"header ===\'Importe Pesos\'\">{{insurance.importe | currency}}</span> <span ng-if=\"header ===\'Ej. Cobranza\'\">{{insurance.poliza.collection_executive.first_name}} {{insurance.poliza.collection_executive.last_name}}</span> <span ng-if=\"header ===\'Pagado por\'\">{{insurance.user_pay}}</span> <span ng-if=\"header ===\'Bitacora\'\">{{insurance.bitacora}}</span> <span ng-if=\"header ===\'Subgrupo\'\"><span ng-if=\"(insurance.poliza.contractor.subgrupo) || insurance.fianza\">{{ insurance.poliza.contractor.subgrupo }}</span></span> <span ng-if=\"header ===\'Subsubgrupo\'\"><span ng-if=\"(insurance.poliza.contractor.subsubgrupo) || insurance.fianza\">{{ insurance.poliza.contractor.subsubgrupo }}</span></span> <span ng-if=\"header ===\'Agrupación\'\"><span ng-if=\"(insurance.poliza.contractor.grouping_level) || insurance.fianza\">{{ insurance.poliza.contractor.grouping_level}}</span></span> <span ng-if=\"header ===\'Subagrupación\'\"><span ng-if=\"(insurance.poliza.contractor.subgrouping) || insurance.fianza\">{{ insurance.poliza.contractor.subgrouping }}</span></span> <span ng-if=\"header ===\'Subsubagrupación\'\"><span ng-if=\"(insurance.poliza.contractor.subsubgrouping) || insurance.fianza\">{{ insurance.poliza.contractor.subsubgrouping }}</span></span> <span ng-if=\"header ===\'Clasificación\'\"><span ng-if=\"(insurance.poliza.contractor.classification) || insurance.fianza\">{{ insurance.poliza.contractor.classification }}</span></span> <span ng-if=\"header ===\'Línea de Negocio\'\"><span ng-if=\"insurance.poliza.document_type ==11\"><span ng-if=\"insurance.poliza.business_line ==1\">Comercial</span><span ng-if=\"insurance.poliza.business_line ==2\">Personal</span><span ng-if=\"insurance.poliza.business_line ==0\">Otro</span></span></span> <span ng-if=\"header ===\'Número de Carátula\'\"><span ng-if=\"insurance.poliza.document_type ==12\">{{insurance.poliza.parent.poliza_number }}</span></span> <span ng-if=\"header ===\'Carátula Contratante\'\"><span ng-if=\"insurance.poliza.document_type ==12\">{{insurance.poliza.parent.contractor.full_name }}</span></span> <span ng-if=\"header ===\'Célula\'\"><span ng-if=\"insurance.poliza.document_type ==12\">{{insurance.poliza.parent.celula.celula_name }}</span><span ng-if=\"insurance.poliza.document_type !=12\">{{insurance.poliza.celula.celula_name }}</span></span> <span ng-if=\"header ===\'Año(Automovil)\'\"></span> <span ng-if=\"header ===\'Serie(Automovil)\'\"></span> <span ng-if=\"header ===\'Contacto(nombre)\'\"></span> <span ng-if=\"header ===\'Contacto(telefono)\'\"></span> <span ng-if=\"header ===\'Contacto(email)\'\"></span> <span ng-if=\"header ===\'Tipo Póliza\'\"></span> <span ng-if=\"header ===\'Tipo de Cambio\'\">{{insurance.rate_exchange }}</span> <span ng-if=\"header ===\'Póliza del Recibo con Endoso(s) en Trámite\'\"><span ng-if=\"insurance.endosotramite\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\" title=\"LA PÓLIZA DEL RECIBO TIENE OT ENDOSO(S) EN TRÁMITE\"></i> Si</span> <span ng-if=\"!insurance.endosotramite\">No</span></span></td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in insurances track by $index\" ng-if=\"insurance.recibo_numero != \' \'\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[15] }}: {{ insurance.recibo_numero }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.receipt_type }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{insurance.poliza.status}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{ insurance.poliza.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.poliza.ramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[10] }}</label><p>{{ insurance.poliza.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[12] }}</label><p ng-if=\"insurance.poliza\">{{ insurance.poliza.accidents_policy[0].personal.full_name }}{{ insurance.poliza.automobiles_policy[0].serial }}{{ insurance.poliza.life_policy[0].personal.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[13] }}</label><p>{{ insurance.poliza.forma_de_pago }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[15] }}</label><p>{{ insurance.recibo_numero }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[16] }}</label><p>{{ insurance.fecha_inicio | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[17] }}</label><p>{{ insurance.fecha_fin | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[18] }}</label><p>{{ insurance.vencimiento | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[20] }}</label><p>{{ insurance.prima_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[21] }}</label><p>{{ insurance.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[22] }}</label><p>{{ insurance.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[23] }}</label><p>{{ insurance.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[24] }}</label><p>{{ insurance.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[25] }}</label><p>{{ insurance.comision | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[26] }}</label><p>{{ insurance.status}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[35] }}</label><p>{{ insurance.poliza.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ insurance.poliza.end_of_validity | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[37] }}</label><p>{{ insurance.poliza.clave.clave }} - {{ insurance.poliza.clave.name }}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && (vm.form.group_by.id != 1) && vm.form.group_by.id != 2 && vm.form.group_by.id != 3 && vm.form.group_by.id != 4 && vm.form.group_by.id != 5 && vm.form.group_by.id != 7\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td ng-if=\"vm.form.group_by.id == 6\">Responsable</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 1\"><td>{{ insurance.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 2\"><td>{{ insurance.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 3\"><td>{{ insurance.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__subramo__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"5\" align=\"center\"><b>Contratantes Fisicos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.poliza__natural__group__group_name\"><td>{{ insurance.poliza__natural__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__natural__group__group_name__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"5\" align=\"center\"><b>Contratantes Morales</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.poliza__juridical__group__group_name\"><td>{{ insurance.poliza__juridical__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__juridical__group__group_name__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 5\"><td colspan=\"5\" align=\"center\"><b>Pólizas</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.poliza__vendor__first_name\"><td>{{ insurance.poliza__vendor__first_name }} {{ insurance.poliza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__vendor__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 5\"><td colspan=\"5\" align=\"center\"><b>Fianzas</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.fianza__vendor__first_name\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 6\"><td>{{ insurance.poliza__aseguradora__alias }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 1\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_pol track by $index\" ng-if=\"insurance.poliza__aseguradora__compania && insurance.poliza__aseguradora__count\"><td>{{ insurance.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fia track by $index\" ng-if=\"!insurance.poliza__aseguradora__compania && insurance.fianza__afianzadora__count\"><td>{{ insurance.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__afianzadora__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_pol track by $index\" ng-if=\"insurance.poliza__aseguradora__compania && insurance.poliza__aseguradora__count\"><td>{{ insurance.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fia track by $index\" ng-if=\"!insurance.poliza__aseguradora__compania && insurance.fianza__afianzadora__count\"><td>{{ insurance.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__afianzadora__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.udi_pol track by $index\" ng-if=\"insurance.poliza__aseguradora__compania && insurance.poliza__aseguradora__count\"><td>{{ insurance.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.udi_fia track by $index\" ng-if=\"!insurance.poliza__aseguradora__compania && insurance.fianza__afianzadora__count\"><td>{{ insurance.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__afianzadora__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 2\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_pol track by $index\" ng-if=\"insurance.poliza__ramo__ramo_name && insurance.poliza__ramo__count\"><td>{{ insurance.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fia track by $index\" ng-if=\"!insurance.poliza__ramo__ramo_name && insurance.fianza__ramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__ramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_pol track by $index\" ng-if=\"insurance.poliza__ramo__ramo_name && insurance.poliza__ramo__count\"><td>{{ insurance.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fia track by $index\" ng-if=\"!insurance.poliza__ramo__ramo_name && insurance.fianza__ramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><t ng-if=\"vm.permiso_comisiones\" d=\"\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}<td>{{ insurance.fianza__ramo__count }}</td></t></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.udi_pol track by $index\" ng-if=\"insurance.poliza__ramo__ramo_name && insurance.poliza__ramo__count\"><td>{{ insurance.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.udi_fia track by $index\" ng-if=\"!insurance.poliza__ramo__ramo_name && insurance.fianza__ramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><t ng-if=\"vm.permiso_comisiones\" d=\"\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}<td>{{ insurance.fianza__ramo__count }}</td></t></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 3\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_pol track by $index\" ng-if=\"insurance.poliza__subramo__subramo_name && insurance.poliza__subramo__count\"><td>{{ insurance.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__subramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fia track by $index\" ng-if=\"!insurance.poliza__subramo__subramo_name && insurance.fianza__subramo__count\"><td>{{ insurance.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__subramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_pol track by $index\" ng-if=\"insurance.poliza__subramo__subramo_name && insurance.poliza__subramo__count\"><td>{{ insurance.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__subramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fia track by $index\" ng-if=\"!insurance.poliza__subramo__subramo_name && insurance.fianza__subramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__subramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.udi_pol track by $index\" ng-if=\"insurance.poliza__subramo__subramo_name && insurance.poliza__subramo__count\"><td>{{ insurance.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__subramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.udi_fia track by $index\" ng-if=\"!insurance.poliza__subramo__subramo_name && insurance.fianza__subramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__subramo__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 4\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.naturals_pesos || grupos_result.naturals_dolares\"><b>Contratantes Físicos</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_pesos track by $index\" ng-if=\"insurance.poliza__contractor__group__group_name && insurance.poliza__contractor__group__group_name__count\"><td>{{ insurance.poliza__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__contractor__group__group_name__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_dolares track by $index\" ng-if=\"insurance.poliza__contractor__group__group_name && insurance.poliza__contractor__group__group_name__count\"><td>{{ insurance.poliza__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__contractor__group__group_name__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_udi track by $index\" ng-if=\"insurance.poliza__contractor__group__group_name && insurance.poliza__contractor__group__group_name__count\"><td>{{ insurance.poliza__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__contractor__group__group_name__count }}</td></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.juridicals_pesos || grupos_result.juridicals_dolares\"><b>Contratantes Morales</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_pesos track by $index\" ng-if=\"insurance.poliza__contractor__group__group_name && insurance.poliza__contractor__group__group_name__count\"><td>{{ insurance.poliza__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__contractor__group__group_name__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_dolares track by $index\" ng-if=\"insurance.poliza__contractor__group__group_name && insurance.poliza__contractor__group__group_name__count\"><td>{{ insurance.poliza__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__contractor__group__group_name__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_udi track by $index\" ng-if=\"insurance.poliza__contractor__group__group_name && insurance.poliza__contractor__group__group_name__count\"><td>{{ insurance.poliza__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__contractor__group__group_name__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 5\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr ng-if=\"grupos_result.polizas_pesos || grupos_result.polizas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Pólizas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_pesos_refs track by $index\" ng-if=\"insurance.poliza__ref_policy__referenciador__first_name && insurance.poliza__ref_policy__referenciador__id__count\"><td>{{ insurance.poliza__ref_policy__referenciador__first_name }} {{ insurance.poliza__ref_policy__referenciador__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__ref_policy__referenciador__id__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_dolares_refs track by $index\" ng-if=\"insurance.poliza__ref_policy__referenciador__first_name && insurance.poliza__ref_policy__referenciador__id__count\"><td>{{ insurance.poliza__ref_policy__referenciador__first_name }} {{ insurance.poliza__ref_policy__referenciador__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__ref_policy__referenciador__id__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_udi_refs track by $index\" ng-if=\"insurance.poliza__ref_policy__referenciador__first_name && insurance.poliza__ref_policy__referenciador__id__count\"><td>{{ insurance.poliza__ref_policy__referenciador__first_name }} {{ insurance.poliza__ref_policy__referenciador__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__ref_policy__referenciador__id__count }}</td></tr><tr ng-if=\"grupos_result.fianzas_pesos || grupos_result.fianzas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Fianzas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_pesos track by $index\" ng-if=\"insurance.fianza__vendor__first_name && insurance.fianza__vendor__count\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_dolares track by $index\" ng-if=\"insurance.fianza__vendor__first_name && insurance.fianza__vendor__count\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_udi track by $index\" ng-if=\"insurance.fianza__vendor__first_name && insurance.fianza__vendor__count\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 7\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 7\">Usuario</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr ng-if=\"grupos_result.polizas_pesos || grupos_result.polizas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Pólizas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_pesos track by $index\" ng-if=\"insurance.poliza__owner__first_name && insurance.poliza__owner__count\"><td>{{ insurance.poliza__owner__first_name }} {{ insurance.poliza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_dolares track by $index\" ng-if=\"insurance.poliza__owner__first_name && insurance.poliza__owner__count\"><td>{{ insurance.poliza__owner__first_name }} {{ insurance.poliza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_udi track by $index\" ng-if=\"insurance.poliza__owner__first_name && insurance.poliza__owner__count\"><td>{{ insurance.poliza__owner__first_name }} {{ insurance.poliza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__owner__count }}</td></tr><tr ng-if=\"grupos_result.fianzas_pesos || grupos_result.fianzas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Fianzas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_pesos track by $index\" ng-if=\"insurance.fianza__owner__first_name && insurance.fianza__owner__count\"><td>{{ insurance.fianza__owner__first_name }} {{ insurance.fianza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_dolares track by $index\" ng-if=\"insurance.fianza__owner__first_name && insurance.fianza__owner__count\"><td>{{ insurance.fianza__owner__first_name }} {{ insurance.fianza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_udi track by $index\" ng-if=\"insurance.fianza__owner__first_name && insurance.fianza__owner__count\"><td>{{ insurance.fianza__owner__first_name }} {{ insurance.fianza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__owner__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div></div><div ng-if=\"showSums\"><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Pesos</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_pesos | currency}}\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Dólares</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_dolares\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">UDI</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_udi\" disabled=\"\"></div></div></div><div class=\"row\" ng-if=\"showButtonExcel && vm.acceso_rep_cob\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(1,addSiniestrosBitacora)\">Generar Reporte</button></div><div class=\"col-xs-12 col-sm-6 form-group\"><input type=\"checkbox\" ng-model=\"addSiniestrosBitacora\" ng-click=\"addSiniestros(addSiniestrosBitacora)\" class=\"checkbox\" ng-value=\"addSiniestrosBitacora\">Informar siniestros de Pérdida Total</div></div><style>\n  /* === Limpieza visual para secciones === */\n  .filter-section {\n    border: 1px solid #e7eaec;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    padding: 15px 15px 5px 15px;\n    background-color: #fcfcfc;\n  }\n  .filter-section legend {\n    font-size: 14px;\n    font-weight: 600;\n    color: #000000;\n    border-bottom: 1px solid #fafdff;\n    margin-bottom: 15px;\n    padding-bottom: 5px;\n  }\n  .report-highlight {\n    background-color: #eef4f7;\n    border-radius: 6px;\n    padding: 15px;\n    margin-top: 20px;\n    border: 1px solid #dbe3e6;\n  }\n\n  .btn-consultar {\n    margin-top: 20px;\n  }\n</style>");
$templateCache.put("app/reportes/reporte.cobranza_liq.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12\"><h2>Reportes Cobranza Liquidaciones</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Cobranza - Liquidaciones</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option><option value=\"6\">Administrativas</option><option value=\"7\">Crédito</option><option value=\"8\">Fideicomiso</option><option value=\"4\">Fidelidad</option><option value=\"5\">Judicial</option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.subramo_code\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Referenciador</label><select class=\"form-control\" ng-model=\"vm.form.vendedor\" data-ng-options=\"vendedor.name for vendedor in vm.vendedores | orderBy: \'name\' track by vendedor.id\" ng-change=\"vm.changeReferenciador(vm.form.vendedor)\"><option value=\"\">Todos los referenciadores</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Clave de Agente</label> <input class=\"form-control\" type=\"text\" name=\"agente\" ng-model=\"vm.form.cve_agente\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"users.username for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Pagado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user_pay\" data-ng-options=\"users_p.username for users_p in vm.users | orderBy: \'username\' track by users_p.url\" ng-change=\"selectUserPay(select_user_pay)\"><option value=\"\"></option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Identificador de Póliza</label> <input class=\"form-control\" type=\"text\" name=\"identificador\" ng-model=\"vm.form.identifier\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Agrupar por:</label><select class=\"form-control\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\">Seleccione</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport()\"><option value=\"\">Selecciona una opción</option></select></div><br><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><div class=\"col-xs-12 checkbox\" align=\"center\" style=\"margin-top: 0;\"><label><input type=\"checkbox\" ng-model=\"vm.form.add_precancelados\" ng-change=\"vm.addPrecancel(1)\">Excluir recibos pre-cancelados</label></div></div></div><div align=\"center\" ng-if=\"vigency || created_at\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div align=\"center\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Valor dólar</label> <input class=\"form-control\" type=\"text\" name=\"valueDolar\" ng-model=\"vm.form.valueDolar\" ng-change=\"numberFormatDolar(vm.form.valueDolar)\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Valor UDI</label> <input class=\"form-control\" type=\"text\" name=\"valueUdi\" ng-model=\"vm.form.valueUdi\" ng-change=\"numberFormatUdi(vm.form.valueUdi)\"></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Estatus</legend><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_liquidados\" ng-change=\"vm.enableConciliacion(1)\" disabled=\"disabled\" checked=\"checked\">Liquidados</label></div></div><hr><div><div class=\"col-xs-6 form-group\"><legend class=\"legend-title\" align=\"center\">Domiciliados</legend><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': receipts_option == \'domiciliados\'}\"><input type=\"radio\" ng-model=\"receipts_option\" ng-click=\"selectReceiptsOption(receipts_option)\" value=\"domiciliados\"> Domiciliados</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': receipts_option == \'no_domiciliados\'}\"><input type=\"radio\" ng-model=\"receipts_option\" ng-click=\"selectReceiptsOption(receipts_option)\" value=\"no_domiciliados\"> No domiciliados</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': receipts_option == \'todos\'}\"><input type=\"radio\" ng-model=\"receipts_option\" ng-click=\"selectReceiptsOption(receipts_option)\" value=\"todos\"> Todos</label></div></div></div></div><div class=\"col-xs-6 form-group border-left\"><legend class=\"legend-title\" align=\"center\">Tipo</legend><div class=\"col-xs-12 col-sm-2\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'fianza\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza)\" value=\"fianza\"> Fianza</label></div></div><div class=\"col-xs-12 col-sm-2\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'poliza\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza)\" value=\"poliza\"> Póliza Individual</label></div></div><div class=\"col-xs-12 col-sm-2\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'colectiva\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza)\" value=\"colectiva\"> Póliza Colectiva</label></div></div><div class=\"col-xs-12 col-sm-2\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'bono\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza)\" value=\"bono\"> Bonos</label></div></div><div class=\"col-xs-12 col-sm-3\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'ambas_pf\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza)\" value=\"ambas_pf\"> Fianzas / Pólizas / Bonos</label></div></div></div><div class=\"col-xs-12 form-group border-left\"><legend class=\"legend-title\" align=\"center\">Opciones</legend><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': recibo_nota == \'recibo\'}\"><input type=\"radio\" ng-model=\"recibo_nota\" ng-click=\"selectReciboOption(recibo_nota)\" value=\"recibo\"> Recibos</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': recibo_nota == \'nota\'}\"><input type=\"radio\" ng-model=\"recibo_nota\" ng-click=\"selectReciboOption(recibo_nota)\" value=\"nota\"> Notas de Crédito</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': recibo_nota == \'ambos\'}\"><input type=\"radio\" ng-model=\"recibo_nota\" ng-click=\"selectReciboOption(recibo_nota)\" value=\"ambos\"> Recibos / Notas de Crédito</label></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"vm.acceso_ver_cob\"><button class=\"btn btn-success pull-right ladda-buttonC\" ng-click=\"vm.Generar(24,1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result || grupos_result.length == 0\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(16, vm.receipts_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(16, $event)\" ng-mouseout=\"finalColumn(16, $event)\" ng-model=\"vm.table.headers[13]\">{{vm.table.headers[13]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_cont_asc == 1, \'fa fa-sort-asc\': vm.receipts_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(17, vm.receipts_contemail_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(17, $event)\" ng-mouseout=\"finalColumn(17, $event)\">Email <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_contemail_asc == 1, \'fa fa-sort-asc\': vm.receipts_contemail_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(18, vm.receipts_contphone_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(18, $event)\" ng-mouseout=\"finalColumn(18, $event)\">Teléfono <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_contphone_asc == 1, \'fa fa-sort-asc\': vm.receipts_contphone_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(28, vm.receipts_contgrupo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(28, $event)\" ng-mouseout=\"finalColumn(28, $event)\">Grupo <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_contgrupo_asc == 1, \'fa fa-sort-asc\': vm.receipts_contgrupo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(25, vm.receipts_ado_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(25, $event)\" ng-mouseout=\"finalColumn(25, $event)\">Asegurado <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ado_asc == 1, \'fa fa-sort-asc\': vm.receipts_ado_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(27, vm.receipts_moneda_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(27, $event)\" ng-mouseout=\"finalColumn(27, $event)\">Moneda <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_moneda_asc == 1, \'fa fa-sort-asc\': vm.receipts_moneda_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(14, vm.receipts_nump_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(14, $event)\" ng-mouseout=\"finalColumn(14, $event)\" ng-model=\"vm.table.headers[11]\">{{vm.table.headers[11]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_nump_asc == 1, \'fa fa-sort-asc\': vm.receipts_nump_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(19, vm.receipts_aseg_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(19, $event)\" ng-mouseout=\"finalColumn(19, $event)\" ng-model=\"vm.table.headers[14]\">{{vm.table.headers[14]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_aseg_asc == 1, \'fa fa-sort-asc\': vm.receipts_aseg_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(1, vm.receipts_rec_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(1, $event)\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_rec_asc == 1, \'fa fa-sort-asc\': vm.receipts_rec_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(3, vm.receipts_pneta_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(3, $event)\" ng-mouseout=\"finalColumn(3, $event)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_pneta_asc == 1, \'fa fa-sort-asc\': vm.receipts_pneta_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(6, vm.receipts_iva_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(6, $event)\" ng-mouseout=\"finalColumn(6, $event)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_iva_asc == 1, \'fa fa-sort-asc\': vm.receipts_iva_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(4, vm.receipts_rpf_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(4, $event)\" ng-mouseout=\"finalColumn(4, $event)\" ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_rpf_asc == 1, \'fa fa-sort-asc\': vm.receipts_rpf_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(5, vm.receipts_der_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(5, $event)\" ng-mouseout=\"finalColumn(5, $event)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_der_asc == 1, \'fa fa-sort-asc\': vm.receipts_der_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(7, vm.receipts_ptotal_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(7, $event)\" ng-mouseout=\"finalColumn(7, $event)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ptotal_asc == 1, \'fa fa-sort-asc\': vm.receipts_ptotal_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(2, vm.receipts_status_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(2, $event)\" ng-mouseout=\"finalColumn(2, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_status_asc == 1, \'fa fa-sort-asc\': vm.receipts_status_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(30, vm.receipts_paydate_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(30, $event)\" ng-mouseout=\"finalColumn(30, $event)\" ng-model=\"vm.table.headers[21]\">{{vm.table.headers[21]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_paydate_asc == 1, \'fa fa-sort-asc\': vm.receipts_paydate_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(31, vm.receipts_payliq_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(31, $event)\" ng-mouseout=\"finalColumn(31, $event)\" ng-model=\"vm.table.headers[22]\">{{vm.table.headers[22]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_payliq_asc == 1, \'fa fa-sort-asc\': vm.receipts_payliq_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(34, vm.receipts_folioliq_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(31, $event)\" ng-mouseout=\"finalColumn(31, $event)\" ng-model=\"vm.table.headers[23]\">{{vm.table.headers[23]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_folioliq_asc == 1, \'fa fa-sort-asc\': vm.receipts_folioliq_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(9, vm.receipts_fini_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(9, $event)\" ng-mouseout=\"finalColumn(9, $event)\" ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_fini_asc == 1, \'fa fa-sort-asc\': vm.receipts_fini_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(10, vm.receipts_ffin_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(10, $event)\" ng-mouseout=\"finalColumn(10, $event)\" ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ffin_asc == 1, \'fa fa-sort-asc\': vm.receipts_ffin_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(10, vm.receipts_com_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(10, $event)\" ng-mouseout=\"finalColumn(10, $event)\" ng-model=\"vm.table.headers[9]\" ng-if=\"vm.permiso_comisiones\">{{vm.table.headers[9]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_com_asc == 1, \'fa fa-sort-asc\': vm.receipts_com_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(32, vm.receipts_com_c_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(32, $event)\" ng-mouseout=\"finalColumn(32, $event)\" ng-model=\"vm.table.headers[9]\" ng-if=\"vm.permiso_comisiones\">Comisión conciliada <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_com_c_asc == 1, \'fa fa-sort-asc\': vm.receipts_com_c_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(33, vm.receipts_fconc_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(33, $event)\" ng-mouseout=\"finalColumn(33, $event)\" ng-model=\"vm.table.headers[10]\">Fecha de conciliación <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_fconc_asc == 1, \'fa fa-sort-asc\': vm.receipts_fconc_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(11, vm.receipts_fvenc_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(11, $event)\" ng-mouseout=\"finalColumn(11, $event)\" ng-model=\"vm.table.headers[10]\">{{vm.table.headers[10]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_fvenc_asc == 1, \'fa fa-sort-asc\': vm.receipts_fvenc_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(13, vm.receipts_tip_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(13, $event)\" ng-mouseout=\"finalColumn(13, $event)\" ng-model=\"vm.table.headers[12]\">{{vm.table.headers[12]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_tip_asc == 1, \'fa fa-sort-asc\': vm.receipts_tip_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(0, vm.receipts_ramo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(0, $event)\" ng-mouseout=\"finalColumn(0, $event)\" ng-model=\"vm.table.headers[15]\">{{vm.table.headers[15]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ramo_asc == 1, \'fa fa-sort-asc\': vm.receipts_ramo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(20, vm.receipts_subr_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(20, $event)\" ng-mouseout=\"finalColumn(20, $event)\" ng-model=\"vm.table.headers[16]\">{{vm.table.headers[16]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_subr_asc == 1, \'fa fa-sort-asc\': vm.receipts_subr_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(21, vm.receipts_fpago_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(21, $event)\" ng-mouseout=\"finalColumn(21, $event)\" ng-model=\"vm.table.headers[17]\">{{vm.table.headers[17]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_fpago_asc == 1, \'fa fa-sort-asc\': vm.receipts_fpago_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(22, vm.receipts_status1_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(22, $event)\" ng-mouseout=\"finalColumn(22, $event)\" ng-model=\"vm.table.headers[18]\">{{vm.table.headers[18]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_status1_asc == 1, \'fa fa-sort-asc\': vm.receipts_status1_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(23, vm.receipts_vig_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(23, $event)\" ng-mouseout=\"finalColumn(23, $event)\" ng-model=\"vm.table.headers[19]\">{{vm.table.headers[19]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_vig_asc == 1, \'fa fa-sort-asc\': vm.receipts_vig_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(12, vm.receipts_domic_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(12, $event)\" ng-mouseout=\"finalColumn(12, $event)\">Domiciliado <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_domic_asc == 1, \'fa fa-sort-asc\': vm.receipts_domic_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(15, vm.receipts_nend_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(15, $event)\" ng-mouseout=\"finalColumn(15, $event)\">No. Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_nend_asc == 1, \'fa fa-sort-asc\': vm.receipts_nend_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(26, vm.receipts_ref_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(26, $event)\" ng-mouseout=\"finalColumn(26, $event)\">Referenciador <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ref_asc == 1, \'fa fa-sort-asc\': vm.receipts_ref_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(29, vm.receipts_resp_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(29, $event)\" ng-mouseout=\"finalColumn(29, $event)\">Responsable <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_resp_asc == 1, \'fa fa-sort-asc\': vm.receipts_resp_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(24, vm.receipts_clave_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(24, $event)\" ng-mouseout=\"finalColumn(24, $event)\" ng-model=\"vm.table.headers[20]\">{{vm.table.headers[20]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_clave_asc == 1, \'fa fa-sort-asc\': vm.receipts_clave_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(25, vm.receipts_ant_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(25, $event)\" ng-mouseout=\"finalColumn(25, $event)\" ng-model=\"vm.table.headers[20]\">Antigüedad <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_clave_asc == 1, \'fa fa-sort-asc\': vm.receipts_clave_asc == 2}\"></span></th></tr></thead><tbody><tr ng-show=\"insurances\" ng-repeat=\"insurance in insurances track by $index\" ng-click=\"vm.goToInfo(insurance)\"><td><span ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor.full_name }}</span><span ng-if=\"insurance.poliza.parent.contractor\">{{ insurance.poliza.parent.contractor.full_name }}</span></td><td><span ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor.email }}</span><span ng-if=\"insurance.poliza.parent.contractor\">{{ insurance.poliza.parent.contractor.email }}</span></td><td><span ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor.emailphone_number }}</span><span ng-if=\"insurance.poliza.parent.contractor\">{{ insurance.poliza.parent.contractor.phone_number }}</span></td><td><span ng-if=\"(insurance.poliza.contractor)\">{{ insurance.poliza.contractor.group }}</span><span ng-if=\"(insurance.poliza.parent.contractor)\">{{ insurance.poliza.parent.contractor.group }}</span></td><td ng-if=\"insurance.poliza\">{{ insurance.poliza.accidents_policy[0].personal.full_name }}{{ insurance.poliza.automobiles_policy[0].serial }}{{ insurance.poliza.life_policy[0].personal.full_name }}</td><td ng-if=\"!insurance.poliza\">No aplica</td><td><span ng-if=\"insurance.poliza.f_currency ==1\">Pesos</span> <span ng-if=\"insurance.fianza\">Pesos</span> <span ng-if=\"insurance.poliza.f_currency ==2\">Dólares</span><span ng-if=\"!(insurance.fianza || insurance.poliza) && insurance.bono\">{{insurance.bono.tipo_cambio}}</span></td><td>{{ insurance.poliza.poliza_number }}{{ insurance.fianza.fianza_number }}</td><td>{{ insurance.poliza.aseguradora }}{{insurance.bono.aseguradora}}{{ insurance.fianza.afianzadora }}</td><td>{{ insurance.recibo_numero }}</td><td align=\"right\">{{ insurance.prima_neta | currency }}</td><td align=\"right\">{{ insurance.iva | currency }}</td><td align=\"right\">{{ insurance.rpf | currency }}</td><td align=\"right\">{{ insurance.derecho | currency }}</td><td align=\"right\">{{ insurance.prima_total | currency }}</td><td>{{ insurance.status }}</td><td>{{ insurance.pay_date | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.liquidacion_date | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.liquidacion_folio}}</td><td>{{ insurance.fecha_inicio | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.fecha_fin | date: \'dd/MM/yyyy\'}}</td><td ng-if=\"vm.permiso_comisiones\" align=\"right\">{{ insurance.comision | currency }}</td><td ng-if=\"vm.permiso_comisiones\" align=\"right\">{{ insurance.comision_conciliada | currency }}</td><td>{{ insurance.conciliacion_date | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.vencimiento | date: \'dd/MM/yyyy\'}}</td><td ng-if=\"!insurance.fianza\">{{ typeReceipt(insurance.receipt_type)}}</td><td ng-if=\"insurance.fianza\">Fianza</td><td>{{ insurance.poliza.ramo }}{{ insurance.fianza.ramo }}</td><td>{{ insurance.poliza.subramo }}{{ insurance.fianza.subramo }}</td><td ng-if=\"insurance.poliza\">{{insurance.poliza.forma_de_pago}}</td><td ng-if=\"!insurance.poliza\">Contado</td><td ng-if=\"insurance.poliza\">{{ status(insurance.poliza.status) }}</td><td ng-if=\"insurance.poliza\">{{ insurance.poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td ng-if=\"(!insurance.poliza) && insurance.bono\">{{ insurance.bono.start_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.bono.end_validity | date: \'dd/MM/yyyy\'}}</td><td><span ng-if=\"insurance.is_cat == true\">Si</span><span ng-if=\"insurance.is_cat == false\">No</span></td><td><span ng-if=\"insurance.endorsement\">{{insurance.endorsement.number_endorsement}}</span><span ng-if=\"!insurance.endorsement\">No aplica</span></td><td>{{insurance.owner}}</td><td>{{insurance.poliza.responsable.first_name}} {{insurance.poliza.responsable.last_name}}</td><td ng-if=\"insurance.poliza.clave.clave\"><span ng-if=\"insurance.poliza.clave.name\">{{ insurance.poliza.clave.clave }} - {{ insurance.poliza.clave.name }}</span> <span ng-if=\"!insurance.poliza.clave.name\"><p class=\"hidden-text\"></p></span></td><td ng-if=\"insurance.fianza.clave.clave\"><span ng-if=\"insurance.fianza.clave.name\">{{ insurance.fianza.clave.clave }} - {{ insurance.fianza.clave.name }}</span> <span ng-if=\"!insurance.fianza.clave.name\"><p class=\"hidden-text\"></p></span></td><td ng-if=\"insurance.bono.clave.clave\"><span ng-if=\"insurance.bono.clave.name\">{{ insurance.bono.clave.clave }} - {{ insurance.bono.clave.name }}</span> <span ng-if=\"!insurance.bono.clave.name\"><p class=\"hidden-text\"></p></span></td><td>{{insurance.antiguedad}} días</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in insurances track by $index\" ng-if=\"insurance.recibo_numero != \' \'\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}: {{ insurance.recibo_numero }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.recibo_numero }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Asegurado</label><p ng-if=\"insurance.poliza\">{{ insurance.poliza.accidents_policy[0].personal.full_name }}{{ insurance.poliza.automobiles_policy[0].serial }}{{ insurance.poliza.life_policy[0].personal.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.status}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p>{{ insurance.prima_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ insurance.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ insurance.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ insurance.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ insurance.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ insurance.fecha_inicio | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{ insurance.fecha_fin | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.comision | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[10] }}</label><p>{{ insurance.vencimiento | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[11] }}</label><p>{{ insurance.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[12] }}</label><p>{{ insurance.receipt_type }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[13] }}</label><p ng-if=\"insurance.poliza.natural\">{{ insurance.poliza.natural }}</p><p ng-if=\"!insurance.poliza.natural\">{{ insurance.poliza.juridical }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[14] }}</label><p>{{ insurance.poliza.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[15] }}</label><p>{{ insurance.poliza.ramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[16] }}</label><p>{{ insurance.poliza.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[17] }}</label><p>{{ insurance.poliza.forma_de_pago }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[18] }}</label><p>{{insurance.poliza.status}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[19] }}</label><p>{{ insurance.poliza.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ insurance.poliza.end_of_validity | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[20] }}</label><p>{{ insurance.poliza.clave.clave }} - {{ insurance.poliza.clave.name }}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && (vm.form.group_by.id != 1) && vm.form.group_by.id != 2 && vm.form.group_by.id != 3 && vm.form.group_by.id != 4 && vm.form.group_by.id != 5 && vm.form.group_by.id != 7\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td ng-if=\"vm.form.group_by.id == 6\">Responsable</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 1\"><td>{{ insurance.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 2\"><td>{{ insurance.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 3\"><td>{{ insurance.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__subramo__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"5\" align=\"center\"><b>Contratantes Fisicos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.poliza__natural__group__group_name\"><td>{{ insurance.poliza__natural__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__natural__group__group_name__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"5\" align=\"center\"><b>Contratantes Morales</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.poliza__juridical__group__group_name\"><td>{{ insurance.poliza__juridical__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__juridical__group__group_name__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 5\"><td colspan=\"5\" align=\"center\"><b>Pólizas</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.poliza__vendor__first_name\"><td>{{ insurance.poliza__vendor__first_name }} {{ insurance.poliza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__vendor__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 5\"><td colspan=\"5\" align=\"center\"><b>Fianzas</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.fianza__vendor__first_name\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 6\"><td>{{ insurance.poliza__aseguradora__alias }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 1\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_pol track by $index\" ng-if=\"insurance.poliza__aseguradora__compania && insurance.poliza__aseguradora__count\"><td>{{ insurance.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fia track by $index\" ng-if=\"!insurance.poliza__aseguradora__compania && insurance.fianza__afianzadora__count\"><td>{{ insurance.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__afianzadora__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dolares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_pol track by $index\" ng-if=\"insurance.poliza__aseguradora__compania && insurance.poliza__aseguradora__count\"><td>{{ insurance.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fia track by $index\" ng-if=\"!insurance.poliza__aseguradora__compania && insurance.fianza__afianzadora__count\"><td>{{ insurance.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__afianzadora__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 2\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_pol track by $index\" ng-if=\"insurance.poliza__ramo__ramo_name && insurance.poliza__ramo__count\"><td>{{ insurance.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fia track by $index\" ng-if=\"!insurance.poliza__ramo__ramo_name && insurance.fianza__ramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__ramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_pol track by $index\" ng-if=\"insurance.poliza__ramo__ramo_name && insurance.poliza__ramo__count\"><td>{{ insurance.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fia track by $index\" ng-if=\"!insurance.poliza__ramo__ramo_name && insurance.fianza__ramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><t ng-if=\"vm.permiso_comisiones\" d=\"\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}<td>{{ insurance.fianza__ramo__count }}</td></t></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 3\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_pol track by $index\" ng-if=\"insurance.poliza__subramo__subramo_name && insurance.poliza__subramo__count\"><td>{{ insurance.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__subramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fia track by $index\" ng-if=\"!insurance.poliza__subramo__subramo_name && insurance.fianza__subramo__count\"><td>{{ insurance.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__subramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_pol track by $index\" ng-if=\"insurance.poliza__subramo__subramo_name && insurance.poliza__subramo__count\"><td>{{ insurance.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__subramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fia track by $index\" ng-if=\"!insurance.poliza__subramo__subramo_name && insurance.fianza__subramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__subramo__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 4\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.naturals_pesos || grupos_result.naturals_dolares\"><b>Contratantes Físicos</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_pesos track by $index\" ng-if=\"insurance.poliza__natural__group__group_name && insurance.poliza__natural__group__group_name__count\"><td>{{ insurance.poliza__natural__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__natural__group__group_name__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_dolares track by $index\" ng-if=\"insurance.poliza__natural__group__group_name && insurance.poliza__natural__group__group_name__count\"><td>{{ insurance.poliza__natural__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__natural__group__group_name__count }}</td></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.juridicals_pesos || grupos_result.juridicals_dolares\"><b>Contratantes Morales</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_pesos track by $index\" ng-if=\"insurance.poliza__juridical__group__group_name && insurance.poliza__juridical__group__group_name__count\"><td>{{ insurance.poliza__juridical__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__juridical__group__group_name__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_dolares track by $index\" ng-if=\"insurance.poliza__juridical__group__group_name && insurance.poliza__juridical__group__group_name__count\"><td>{{ insurance.poliza__juridical__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__juridical__group__group_name__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 5\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr ng-if=\"grupos_result.polizas_pesos || grupos_result.polizas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Pólizas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_pesos track by $index\" ng-if=\"insurance.poliza__vendor__first_name && insurance.poliza__vendor__count\"><td>{{ insurance.poliza__vendor__first_name }} {{ insurance.poliza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__vendor__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_dolares track by $index\" ng-if=\"insurance.poliza__vendor__first_name && insurance.poliza__vendor__count\"><td>{{ insurance.poliza__vendor__first_name }} {{ insurance.poliza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__vendor__count }}</td></tr><tr ng-if=\"grupos_result.fianzas_pesos || grupos_result.fianzas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Fianzas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_pesos track by $index\" ng-if=\"insurance.fianza__vendor__first_name && insurance.fianza__vendor__count\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_dolares track by $index\" ng-if=\"insurance.fianza__vendor__first_name && insurance.fianza__vendor__count\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 7\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 7\">Usuario</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr ng-if=\"grupos_result.polizas_pesos || grupos_result.polizas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Pólizas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_pesos track by $index\" ng-if=\"insurance.poliza__owner__first_name && insurance.poliza__owner__count\"><td>{{ insurance.poliza__owner__first_name }} {{ insurance.poliza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_dolares track by $index\" ng-if=\"insurance.poliza__owner__first_name && insurance.poliza__owner__count\"><td>{{ insurance.poliza__owner__first_name }} {{ insurance.poliza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__owner__count }}</td></tr><tr ng-if=\"grupos_result.fianzas_pesos || grupos_result.fianzas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Fianzas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_pesos track by $index\" ng-if=\"insurance.fianza__owner__first_name && insurance.fianza__owner__count\"><td>{{ insurance.fianza__owner__first_name }} {{ insurance.fianza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_dolares track by $index\" ng-if=\"insurance.fianza__owner__first_name && insurance.fianza__owner__count\"><td>{{ insurance.fianza__owner__first_name }} {{ insurance.fianza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__owner__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div></div><div ng-if=\"showSums\"><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Pesos</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_pesos | currency}}\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Dólares</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_dolares\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">UDI</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_udi\" disabled=\"\"></div></div></div><div class=\"row\" ng-if=\"showButtonExcel && vm.acceso_rep_cob\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(1)\">Generar Reporte</button></div></div><script>\n  // $(window).load(function() {\n  //     $(\'.js-example-basic-multiple\').select2();\n  // });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script><script type=\"text/javascript\">  \n  $(window).load(function() { $(\"#state\").select2(); });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script>");
$templateCache.put("app/reportes/reporte.cobranzafianzas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12\"><h2>Reportes Cobranzas Fianzas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Cobranza Fianzas</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número de Fianza</label> <input class=\"form-control\" type=\"text\" name=\"poliza_number\" ng-model=\"vm.form.poliza_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fiado</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Identificador</label> <input ng-disabled=\"vm.buscar_por_folio\" class=\"form-control\" type=\"text\" name=\"identificador\" ng-model=\"vm.form.identifier\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Referenciador</label><select class=\"form-control\" ng-model=\"vm.form.vendedor\" data-ng-options=\"vendedor.name for vendedor in vm.vendedores | orderBy: \'name\' track by vendedor.id\" ng-change=\"vm.changeReferenciador(vm.form.vendedor)\"><option value=\"\">Todos los referenciadores</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fiado Programa de Proveedores</label><autocomplete datasource=\"contractors_datapp\" id=\"contractors\" model=\"vm.form.programap\" change=\"vm.matchesPrograma(vm.form.programap.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-disabled=\"vm.buscar_por_folio\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport()\"><option value=\"\">Selecciona una opción</option></select></div><div align=\"center\" ng-if=\"vigency || created_at\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input ng-disabled=\"vm.buscar_por_folio\" type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" ng-disabled=\"vm.buscar_por_folio\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"decrptedtoken.org ==\'ancora\'\"><label for=\"SelectMontEmision\">Mes de Emisión de Producción</label><select id=\"SelectMontEmision\" class=\"form-control\" ng-options=\"month.value as month.label for month in month.options\" ng-model=\"vm.form.month.month_selected\" ng-init=\"vm.form.month.month_selected = 0\" ng-change=\"changemonth()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"decrptedtoken.org ==\'ancora\'\"><label for=\"year\">Año emisión Producción</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"vm.form.year_factura\" ng-change=\"changeyaer(vm.form.year_factura)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Afianzadora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"6\">Administrativas</option><option value=\"7\">Crédito</option><option value=\"8\">Fideicomiso</option><option value=\"4\">Fidelidad</option><option value=\"5\">Judicial</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.subramo_code\" ng-change=\"selectSubramos(select_sramo)\"></select></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Estatus</legend><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\" style=\"margin-top: 0;\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_pagados\" ng-change=\"vm.enableConciliacion(1)\">Pagados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_no_pagados\" ng-change=\"vm.enableConciliacion(1)\">No pagados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_liquidados\" ng-change=\"vm.enableConciliacion(1)\">Liquidados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_conciliados\" ng-change=\"vm.enableConciliacion(2)\">Conciliados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_precancelados\" ng-change=\"vm.enableConciliacion(1)\">Precancelados</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_delivered\" ng-change=\"vm.enableConciliacion(1)\">No entregados</label></div></div><hr></div><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"vm.acceso_ver_cob\"><button class=\"btn btn-success pull-right ladda-buttonC\" ng-click=\"vm.Generar(24,1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result || grupos_result.length == 0\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>No. Fianza</th><th>Tipo Recibo</th><th>No. Endoso</th><th>Estatus Fianza</th><th>Fiado</th><th>Grupo</th><th>Correo Electrónico</th><th>Teléfono</th><th>Afianzadora</th><th>Ramo</th><th>SubRamo</th><th>Identificador</th><th>Frecuencia Pago</th><th>Moneda</th><th>Serie Recibo</th><th>Fecha Inicio Recibo</th><th>Fecha Fin Recibo</th><th>Vencimiento</th><th>Antigüedad</th><th>Promesa Pago</th><th>Prima Neta</th><th>Gastos Expedición</th><th>Derecho</th><th>IVA</th><th>Prima Total</th><th>Comisión</th><th>Comisión Conciliada</th><th>Estatus Recibo</th><th>Método de Pago</th><th>Fecha de Pago</th><th>Fecha de Pago de Comisión</th><th>Fecha de Liquidación</th><th>Folio de Liquidación</th><th>Fecha de Conciliación</th><th>Fecha Inicio Fianza</th><th>Fecha Fin Fianza</th><th>Clave Agente</th><th>Referenciador</th><th>Responsable</th><th>Creado Por</th><th>Fecha Creación</th><th>Tipo Cambio (Pago)</th><th>Importe Pesos</th><th>Ej. Cobranza</th><th>Pagado por</th><th>Bono Afianzadora</th><th>Fecha Bono</th><th>Fecha emisión factura</th><th>Mes emisión producción</th><th>Año emisión producción</th><th>Folio factura</th><th>Maquila</th><th>Fecha Maquila</th><th>Tipo Cambio (CAPTURA)</th></tr></thead><tbody><tr ng-show=\"insurance\" ng-repeat=\"insurance in insurances track by $index\" ng-click=\"vm.goToInfo(insurance)\" on-finish-render=\"ngRepeatFinished\"><td>{{ insurance.poliza.poliza_number }}</td><td>{{ typeReceipt(insurance.receipt_type)}}</td><td><span ng-if=\"insurance.endorsement\">{{insurance.endorsement.number_endorsement}}</span><span ng-if=\"!insurance.endorsement\">&nbsp;</span></td><td>{{ status(insurance.poliza.status) }}</td><td>{{ insurance.poliza.contractor.full_name }}</td><td>{{ insurance.poliza.contractor.group }}</td><td>{{ insurance.poliza.contractor.email }}</td><td>{{ insurance.poliza.contractor.phone_number }}</td><td>{{ insurance.poliza.aseguradora }}</td><td>{{ insurance.poliza.ramo }}</td><td>{{ insurance.poliza.subramo }}</td><td>{{ insurance.poliza.identifier}}</td><td>{{ insurance.poliza.forma_de_pago}}</td><td><span ng-if=\"insurance.poliza.f_currency ==1\">Pesos</span> <span ng-if=\"insurance.poliza.f_currency ==2\">Dólares</span></td><td>{{ insurance.recibo_numero }}</td><td>{{ insurance.fecha_inicio | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.fecha_fin | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.vencimiento | date: \'dd/MM/yyyy\'}}</td><td>{{insurance.antiguedad}} &nbsp;</td><td>{{ insurance.promesa_pago | date: \'dd/MM/yyyy\'}}</td><td align=\"right\">{{ insurance.prima_neta | currency }}</td><td align=\"right\">{{ insurance.rpf | currency }}</td><td align=\"right\">{{ insurance.derecho | currency }}</td><td align=\"right\">{{ insurance.iva | currency }}</td><td align=\"right\">{{ insurance.prima_total | currency }}</td><td ng-if=\"vm.permiso_comisiones\" align=\"right\">{{ insurance.comision | currency }}</td><td ng-if=\"vm.permiso_comisiones\" align=\"right\">{{ insurance.comision_conciliada | currency }}</td><td>{{ insurance.status }}</td><td><span ng-if=\"insurance.pay_doc\">{{insurance.pay_doc}}</span></td><td>{{ insurance.pay_date | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.poliza.fecha_pago_comision | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.liquidacion_date | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.liquidacion_folio}}</td><td>{{ insurance.conciliacion_date | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.poliza.start_of_validity | date: \'dd/MM/yyyy\' }}</td><td>{{ insurance.poliza.end_of_validity | date: \'dd/MM/yyyy\' }}</td><td><span ng-if=\"insurance.poliza.clave.name\">{{ insurance.poliza.clave.clave }} - {{ insurance.poliza.clave.name }}</span></td><td><span ng-if=\"insurance.poliza.ref_policy.length > 0\"><div ng-repeat=\"ref in insurance.poliza.ref_policy\">{{ref.referenciador.first_name}} {{ref.referenciador.last_name}}</div></span></td><td>{{insurance.poliza.responsable.first_name}} {{insurance.poliza.responsable.last_name}}</td><td>{{insurance.owner}}</td><td>{{insurance.created_at | date: \'dd/MM/yyyy\' }}</td><td>{{insurance.rate_exchange}}</td><td>{{insurance.importe | currency}}</td><td>{{insurance.poliza.collection_executive.first_name}} {{insurance.poliza.collection_executive.last_name}}</td><td>{{insurance.user_pay}}</td><td><span ng-if=\"insurance.receipt_type ==1\">{{insurance.poliza.bono_variable}}</span><span ng-if=\"insurance.receipt_type ==2 || insurance.receipt_type ==3\">{{insurance.endorsement.bono_variable}}</span></td><td><span ng-if=\"insurance.receipt_type ==1\">{{insurance.poliza.date_bono | date:\'dd/MM/yyyy\'}}</span><span ng-if=\"insurance.receipt_type ==2 || insurance.receipt_type ==3\">{{insurance.endorsement.date_bono | date:\'dd/MM/yyyy\'}}</span></td><td>{{insurance.poliza.date_emision_factura | date: \'dd/MM/yyyy\' }}</td><td><span ng-if=\"insurance.receipt_type ==1\">{{monthEmision(insurance.poliza.month_factura)}}</span><span ng-if=\"insurance.receipt_type ==2 || insurance.receipt_type==3\">{{monthEmision(insurance.endorsement.month_factura)}}</span></td><td><span ng-if=\"insurance.receipt_type ==1\">{{(insurance.poliza.year_factura)}}</span><span ng-if=\"insurance.receipt_type ==2 || insurance.receipt_type==3\">{{(insurance.endorsement.year_factura)}}</span></td><td>{{insurance.poliza.folio_factura}}</td><td>{{insurance.poliza.maquila | currency}}</td><td>{{insurance.poliza.date_maquila | date: \'dd/MM/yyyy\'}}</td><td>{{insurance.poliza.exchange_rate | currency}}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in insurances track by $index\" ng-if=\"insurance.recibo_numero != \' \'\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[15] }}: {{ insurance.recibo_numero }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.receipt_type }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{insurance.poliza.status}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{ insurance.poliza.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.poliza.ramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[10] }}</label><p>{{ insurance.poliza.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[12] }}</label><p ng-if=\"insurance.poliza\">{{ insurance.poliza.accidents_policy[0].personal.full_name }}{{ insurance.poliza.automobiles_policy[0].serial }}{{ insurance.poliza.life_policy[0].personal.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[13] }}</label><p>{{ insurance.poliza.forma_de_pago }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[15] }}</label><p>{{ insurance.recibo_numero }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[16] }}</label><p>{{ insurance.fecha_inicio | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[17] }}</label><p>{{ insurance.fecha_fin | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[18] }}</label><p>{{ insurance.vencimiento | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[20] }}</label><p>{{ insurance.prima_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[21] }}</label><p>{{ insurance.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[22] }}</label><p>{{ insurance.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[23] }}</label><p>{{ insurance.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[24] }}</label><p>{{ insurance.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[25] }}</label><p>{{ insurance.comision | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[26] }}</label><p>{{ insurance.status}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[35] }}</label><p>{{ insurance.poliza.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ insurance.poliza.end_of_validity | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[37] }}</label><p>{{ insurance.poliza.clave.clave }} - {{ insurance.poliza.clave.name }}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div><div ng-if=\"showSums\"><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Pesos</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_pesos | currency}}\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Dólares</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_dolares\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">UDI</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_udi\" disabled=\"\"></div></div></div><div class=\"row\" ng-if=\"showButtonExcel && vm.acceso_rep_cob\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(1)\">Generar Reporte</button></div></div>");
$templateCache.put("app/reportes/reporte.cobranzapendiente.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12\"><h2>Reportes Cobranza</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Cobranza Pendiente</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option><option value=\"6\">Administrativas</option><option value=\"7\">Crédito</option><option value=\"8\">Fideicomiso</option><option value=\"4\">Fidelidad</option><option value=\"5\">Judicial</option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.subramo_code\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Referenciador</label><select class=\"form-control\" ng-model=\"vm.form.vendedor\" data-ng-options=\"vendedor.name for vendedor in vm.vendedores | orderBy: \'name\' track by vendedor.id\" ng-change=\"vm.changeReferenciador(vm.form.vendedor)\"><option value=\"\">Todos los referenciadores</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Clave de Agente</label> <input class=\"form-control\" type=\"text\" name=\"agente\" ng-model=\"vm.form.cve_agente\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"users.username for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Pagado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user_pay\" data-ng-options=\"users_p.username for users_p in vm.users | orderBy: \'username\' track by users_p.url\" ng-change=\"selectUserPay(select_user_pay)\"><option value=\"\"></option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Identificador de Póliza</label> <input class=\"form-control\" type=\"text\" name=\"identificador\" ng-model=\"vm.form.identifier\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Agrupar por:</label><select class=\"form-control\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\">Seleccione</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport()\"><option value=\"\">Selecciona una opción</option></select></div><br><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><div class=\"col-xs-12 checkbox\" align=\"center\" style=\"margin-top: 0;\"><label><input type=\"checkbox\" ng-model=\"vm.form.add_precancelados\" ng-change=\"vm.addPrecancel(1)\">Excluir recibos pre-cancelados</label></div></div></div><div align=\"center\" ng-if=\"vigency || created_at\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div align=\"center\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Valor dólar</label> <input class=\"form-control\" type=\"text\" name=\"valueDolar\" ng-model=\"vm.form.valueDolar\" ng-change=\"numberFormatDolar(vm.form.valueDolar)\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Valor UDI</label> <input class=\"form-control\" type=\"text\" name=\"valueUdi\" ng-model=\"vm.form.valueUdi\" ng-change=\"numberFormatUdi(vm.form.valueUdi)\"></div></div><div class=\"row\"><div class=\"col-xs-6 form-group\"><legend class=\"legend-title\" align=\"center\">Estatus</legend><div class=\"col-xs-12 col-sm-6 col-md-5 checkbox\" align=\"center\"><label><input type=\"checkbox\" ng-model=\"vm.form.recibos_no_pagados\" ng-change=\"vm.enableConciliacion(1)\" checked=\"checked\" disabled=\"\">No pagados</label></div></div><hr><div><div class=\"col-xs-6 form-group\"><legend class=\"legend-title\" align=\"center\">Domiciliados</legend><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': receipts_option == \'domiciliados\'}\"><input type=\"radio\" ng-model=\"receipts_option\" ng-click=\"selectReceiptsOption(receipts_option)\" value=\"domiciliados\"> Domiciliados</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': receipts_option == \'no_domiciliados\'}\"><input type=\"radio\" ng-model=\"receipts_option\" ng-click=\"selectReceiptsOption(receipts_option)\" value=\"no_domiciliados\"> No domiciliados</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': receipts_option == \'todos\'}\"><input type=\"radio\" ng-model=\"receipts_option\" ng-click=\"selectReceiptsOption(receipts_option)\" value=\"todos\"> Todos</label></div></div></div></div><div class=\"col-xs-6 form-group border-left\"><legend class=\"legend-title\" align=\"center\">Tipo</legend><div class=\"col-xs-12 col-sm-2\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'fianza\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza)\" value=\"fianza\"> Fianza</label></div></div><div class=\"col-xs-12 col-sm-2\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'poliza\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza)\" value=\"poliza\"> Póliza Individual</label></div></div><div class=\"col-xs-12 col-sm-2\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'colectiva\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza)\" value=\"colectiva\"> Póliza Colectiva</label></div></div><div class=\"col-xs-12 col-sm-2\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'bono\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza)\" value=\"bono\"> Bonos</label></div></div><div class=\"col-xs-12 col-sm-3\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': fianza_poliza == \'ambas_pf\'}\"><input type=\"radio\" ng-model=\"fianza_poliza\" ng-click=\"selectFianzaOption(fianza_poliza)\" value=\"ambas_pf\"> Fianzas / Pólizas / Bonos</label></div></div></div><div class=\"col-xs-12 form-group border-left\"><legend class=\"legend-title\" align=\"center\">Opciones</legend><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': recibo_nota == \'recibo\'}\"><input type=\"radio\" ng-model=\"recibo_nota\" ng-click=\"selectReciboOption(recibo_nota)\" value=\"recibo\"> Recibos</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': recibo_nota == \'nota\'}\"><input type=\"radio\" ng-model=\"recibo_nota\" ng-click=\"selectReciboOption(recibo_nota)\" value=\"nota\"> Notas de Crédito</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': recibo_nota == \'ambos\'}\"><input type=\"radio\" ng-model=\"recibo_nota\" ng-click=\"selectReciboOption(recibo_nota)\" value=\"ambos\"> Recibos / Notas de Crédito</label></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"vm.acceso_ver_cob\"><button class=\"btn btn-success pull-right ladda-buttonC\" ng-click=\"vm.Generar(24,1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result || grupos_result.length == 0\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(16, vm.receipts_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(16, $event)\" ng-mouseout=\"finalColumn(16, $event)\" ng-model=\"vm.table.headers[13]\">{{vm.table.headers[13]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_cont_asc == 1, \'fa fa-sort-asc\': vm.receipts_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(17, vm.receipts_contemail_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(17, $event)\" ng-mouseout=\"finalColumn(17, $event)\">Email <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_contemail_asc == 1, \'fa fa-sort-asc\': vm.receipts_contemail_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(18, vm.receipts_contphone_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(18, $event)\" ng-mouseout=\"finalColumn(18, $event)\">Teléfono <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_contphone_asc == 1, \'fa fa-sort-asc\': vm.receipts_contphone_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(28, vm.receipts_contgrupo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(28, $event)\" ng-mouseout=\"finalColumn(28, $event)\">Grupo <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_contgrupo_asc == 1, \'fa fa-sort-asc\': vm.receipts_contgrupo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(25, vm.receipts_ado_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(25, $event)\" ng-mouseout=\"finalColumn(25, $event)\">Asegurado <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ado_asc == 1, \'fa fa-sort-asc\': vm.receipts_ado_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(27, vm.receipts_moneda_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(27, $event)\" ng-mouseout=\"finalColumn(27, $event)\">Moneda <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_moneda_asc == 1, \'fa fa-sort-asc\': vm.receipts_moneda_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(14, vm.receipts_nump_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(14, $event)\" ng-mouseout=\"finalColumn(14, $event)\" ng-model=\"vm.table.headers[11]\">{{vm.table.headers[11]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_nump_asc == 1, \'fa fa-sort-asc\': vm.receipts_nump_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(19, vm.receipts_aseg_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(19, $event)\" ng-mouseout=\"finalColumn(19, $event)\" ng-model=\"vm.table.headers[14]\">{{vm.table.headers[14]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_aseg_asc == 1, \'fa fa-sort-asc\': vm.receipts_aseg_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(1, vm.receipts_rec_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(1, $event)\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_rec_asc == 1, \'fa fa-sort-asc\': vm.receipts_rec_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(3, vm.receipts_pneta_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(3, $event)\" ng-mouseout=\"finalColumn(3, $event)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_pneta_asc == 1, \'fa fa-sort-asc\': vm.receipts_pneta_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(6, vm.receipts_iva_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(6, $event)\" ng-mouseout=\"finalColumn(6, $event)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_iva_asc == 1, \'fa fa-sort-asc\': vm.receipts_iva_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(4, vm.receipts_rpf_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(4, $event)\" ng-mouseout=\"finalColumn(4, $event)\" ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_rpf_asc == 1, \'fa fa-sort-asc\': vm.receipts_rpf_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(5, vm.receipts_der_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(5, $event)\" ng-mouseout=\"finalColumn(5, $event)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_der_asc == 1, \'fa fa-sort-asc\': vm.receipts_der_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(7, vm.receipts_ptotal_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(7, $event)\" ng-mouseout=\"finalColumn(7, $event)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ptotal_asc == 1, \'fa fa-sort-asc\': vm.receipts_ptotal_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(2, vm.receipts_status_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(2, $event)\" ng-mouseout=\"finalColumn(2, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_status_asc == 1, \'fa fa-sort-asc\': vm.receipts_status_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(30, vm.receipts_paydate_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(30, $event)\" ng-mouseout=\"finalColumn(30, $event)\" ng-model=\"vm.table.headers[21]\">{{vm.table.headers[21]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_paydate_asc == 1, \'fa fa-sort-asc\': vm.receipts_paydate_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(31, vm.receipts_payliq_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(31, $event)\" ng-mouseout=\"finalColumn(31, $event)\" ng-model=\"vm.table.headers[22]\">{{vm.table.headers[22]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_payliq_asc == 1, \'fa fa-sort-asc\': vm.receipts_payliq_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(34, vm.receipts_folioliq_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(31, $event)\" ng-mouseout=\"finalColumn(31, $event)\" ng-model=\"vm.table.headers[23]\">{{vm.table.headers[23]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_folioliq_asc == 1, \'fa fa-sort-asc\': vm.receipts_folioliq_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(9, vm.receipts_fini_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(9, $event)\" ng-mouseout=\"finalColumn(9, $event)\" ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_fini_asc == 1, \'fa fa-sort-asc\': vm.receipts_fini_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(10, vm.receipts_ffin_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(10, $event)\" ng-mouseout=\"finalColumn(10, $event)\" ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ffin_asc == 1, \'fa fa-sort-asc\': vm.receipts_ffin_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(10, vm.receipts_com_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(10, $event)\" ng-mouseout=\"finalColumn(10, $event)\" ng-model=\"vm.table.headers[9]\" ng-if=\"vm.permiso_comisiones\">{{vm.table.headers[9]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_com_asc == 1, \'fa fa-sort-asc\': vm.receipts_com_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(32, vm.receipts_com_c_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(32, $event)\" ng-mouseout=\"finalColumn(32, $event)\" ng-model=\"vm.table.headers[9]\" ng-if=\"vm.permiso_comisiones\">Comisión conciliada <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_com_c_asc == 1, \'fa fa-sort-asc\': vm.receipts_com_c_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(33, vm.receipts_fconc_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(33, $event)\" ng-mouseout=\"finalColumn(33, $event)\" ng-model=\"vm.table.headers[10]\">Fecha de conciliación <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_fconc_asc == 1, \'fa fa-sort-asc\': vm.receipts_fconc_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(11, vm.receipts_fvenc_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(11, $event)\" ng-mouseout=\"finalColumn(11, $event)\" ng-model=\"vm.table.headers[10]\">{{vm.table.headers[10]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_fvenc_asc == 1, \'fa fa-sort-asc\': vm.receipts_fvenc_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(13, vm.receipts_tip_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(13, $event)\" ng-mouseout=\"finalColumn(13, $event)\" ng-model=\"vm.table.headers[12]\">{{vm.table.headers[12]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_tip_asc == 1, \'fa fa-sort-asc\': vm.receipts_tip_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(0, vm.receipts_ramo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(0, $event)\" ng-mouseout=\"finalColumn(0, $event)\" ng-model=\"vm.table.headers[15]\">{{vm.table.headers[15]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ramo_asc == 1, \'fa fa-sort-asc\': vm.receipts_ramo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(20, vm.receipts_subr_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(20, $event)\" ng-mouseout=\"finalColumn(20, $event)\" ng-model=\"vm.table.headers[16]\">{{vm.table.headers[16]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_subr_asc == 1, \'fa fa-sort-asc\': vm.receipts_subr_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(21, vm.receipts_fpago_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(21, $event)\" ng-mouseout=\"finalColumn(21, $event)\" ng-model=\"vm.table.headers[17]\">{{vm.table.headers[17]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_fpago_asc == 1, \'fa fa-sort-asc\': vm.receipts_fpago_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(22, vm.receipts_status1_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(22, $event)\" ng-mouseout=\"finalColumn(22, $event)\" ng-model=\"vm.table.headers[18]\">{{vm.table.headers[18]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_status1_asc == 1, \'fa fa-sort-asc\': vm.receipts_status1_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(23, vm.receipts_vig_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(23, $event)\" ng-mouseout=\"finalColumn(23, $event)\" ng-model=\"vm.table.headers[19]\">{{vm.table.headers[19]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_vig_asc == 1, \'fa fa-sort-asc\': vm.receipts_vig_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(12, vm.receipts_domic_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(12, $event)\" ng-mouseout=\"finalColumn(12, $event)\">Domiciliado <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_domic_asc == 1, \'fa fa-sort-asc\': vm.receipts_domic_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(15, vm.receipts_nend_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(15, $event)\" ng-mouseout=\"finalColumn(15, $event)\">No. Endoso <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_nend_asc == 1, \'fa fa-sort-asc\': vm.receipts_nend_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(26, vm.receipts_ref_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(26, $event)\" ng-mouseout=\"finalColumn(26, $event)\">Referenciador <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ref_asc == 1, \'fa fa-sort-asc\': vm.receipts_ref_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(29, vm.receipts_resp_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(29, $event)\" ng-mouseout=\"finalColumn(29, $event)\">Responsable <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_resp_asc == 1, \'fa fa-sort-asc\': vm.receipts_resp_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(24, vm.receipts_clave_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(24, $event)\" ng-mouseout=\"finalColumn(24, $event)\" ng-model=\"vm.table.headers[20]\">{{vm.table.headers[20]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_clave_asc == 1, \'fa fa-sort-asc\': vm.receipts_clave_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeReceipts(25, vm.receipts_ant_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(25, $event)\" ng-mouseout=\"finalColumn(25, $event)\" ng-model=\"vm.table.headers[20]\">Antigüedad <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_clave_asc == 1, \'fa fa-sort-asc\': vm.receipts_clave_asc == 2}\"></span></th></tr></thead><tbody><tr ng-show=\"insurance\" ng-repeat=\"insurance in insurances track by $index\" ng-click=\"vm.goToInfo(insurance)\"><td><span ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor.group }}</span><span ng-if=\"insurance.poliza.parent.contractor\">{{ insurance.poliza.parent.contractor.group }}</span></td><td><span ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor.full_name }}</span><span ng-if=\"insurance.poliza.parent.contractor\">{{ insurance.poliza.parent.contractor.full_name }}</span></td><td><span ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor.email }}</span><span ng-if=\"insurance.poliza.parent.contractor\">{{ insurance.poliza.parent.contractor.email }}</span></td><td><span ng-if=\"(insurance.poliza.contractor)\">{{ insurance.poliza.contractor.phone_number }}</span><span ng-if=\"(insurance.poliza.parent.contractor)\">{{ insurance.poliza.parent.contractor.phone_number }}</span></td><td ng-if=\"insurance.poliza\">{{ insurance.poliza.accidents_policy[0].personal.full_name }}{{ insurance.poliza.automobiles_policy[0].serial }}{{ insurance.poliza.life_policy[0].personal.full_name }}</td><td ng-if=\"!insurance.poliza\">No aplica</td><td><span ng-if=\"insurance.poliza.f_currency ==1\">Pesos</span> <span ng-if=\"insurance.fianza\">Pesos</span> <span ng-if=\"insurance.poliza.f_currency ==2\">Dólares</span><span ng-if=\"!(insurance.fianza || insurance.poliza) && insurance.bono\">{{insurance.bono.tipo_cambio}}</span></td><td>{{ insurance.poliza.poliza_number }}{{ insurance.fianza.fianza_number }}</td><td>{{ insurance.poliza.aseguradora }}{{insurance.bono.aseguradora}}{{ insurance.fianza.afianzadora }}</td><td>{{ insurance.recibo_numero }}</td><td align=\"right\">{{ insurance.prima_neta | currency }}</td><td align=\"right\">{{ insurance.iva | currency }}</td><td align=\"right\">{{ insurance.rpf | currency }}</td><td align=\"right\">{{ insurance.derecho | currency }}</td><td align=\"right\">{{ insurance.prima_total | currency }}</td><td>{{ insurance.status }}</td><td>{{ insurance.pay_date | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.liquidacion_date | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.liquidacion_folio}}</td><td>{{ insurance.fecha_inicio | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.fecha_fin | date: \'dd/MM/yyyy\'}}</td><td ng-if=\"vm.permiso_comisiones\" align=\"right\">{{ insurance.comision | currency }}</td><td ng-if=\"vm.permiso_comisiones\" align=\"right\">{{ insurance.comision_conciliada | currency }}</td><td>{{ insurance.conciliacion_date | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.vencimiento | date: \'dd/MM/yyyy\'}}</td><td ng-if=\"!insurance.fianza\">{{ typeReceipt(insurance.receipt_type)}}</td><td ng-if=\"insurance.fianza\">Fianza</td><td>{{ insurance.poliza.ramo }}{{ insurance.fianza.ramo }}</td><td>{{ insurance.poliza.subramo }}{{ insurance.fianza.subramo }}</td><td ng-if=\"insurance.poliza\">{{insurance.poliza.forma_de_pago}}</td><td ng-if=\"!insurance.poliza\">Contado</td><td ng-if=\"!insurance.fianza\">{{ status(insurance.poliza.status) }}</td><td ng-if=\"insurance.fianza\">{{ status(insurance.fianza.status) }}</td><td ng-if=\"insurance.poliza\">{{ insurance.poliza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.poliza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td ng-if=\"!insurance.poliza && insurance.fianza\">{{ insurance.fianza.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.fianza.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td ng-if=\"(!insurance.poliza && !insurance.fianza) && insurance.bono\">{{ insurance.bono.start_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.bono.end_validity | date: \'dd/MM/yyyy\'}}</td><td><span ng-if=\"insurance.is_cat == true\">Si</span><span ng-if=\"insurance.is_cat == false\">No</span></td><td><span ng-if=\"insurance.endorsement\">{{insurance.endorsement.number_endorsement}}</span><span ng-if=\"!insurance.endorsement\">No aplica</span></td><td>{{insurance.owner}}</td><td>{{insurance.poliza.responsable.first_name}} {{insurance.poliza.responsable.last_name}}</td><td ng-if=\"insurance.poliza.clave.clave\"><span ng-if=\"insurance.poliza.clave.name\">{{ insurance.poliza.clave.clave }} - {{ insurance.poliza.clave.name }}</span> <span ng-if=\"!insurance.poliza.clave.name\"><p class=\"hidden-text\"></p></span></td><td ng-if=\"insurance.fianza.clave.clave\"><span ng-if=\"insurance.fianza.clave.name\">{{ insurance.fianza.clave.clave }} - {{ insurance.fianza.clave.name }}</span> <span ng-if=\"!insurance.fianza.clave.name\"><p class=\"hidden-text\"></p></span></td><td ng-if=\"insurance.bono.clave.clave\"><span ng-if=\"insurance.bono.clave.name\">{{ insurance.bono.clave.clave }} - {{ insurance.bono.clave.name }}</span> <span ng-if=\"!insurance.bono.clave.name\"><p class=\"hidden-text\"></p></span></td><td>{{insurance.antiguedad}} días</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in insurances track by $index\" ng-if=\"insurance.recibo_numero != \' \'\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}: {{ insurance.recibo_numero }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.recibo_numero }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>Asegurado</label><p ng-if=\"insurance.poliza\">{{ insurance.poliza.accidents_policy[0].personal.full_name }}{{ insurance.poliza.automobiles_policy[0].serial }}{{ insurance.poliza.life_policy[0].personal.full_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.status}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p>{{ insurance.prima_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ insurance.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ insurance.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ insurance.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ insurance.prima_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ insurance.fecha_inicio | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{ insurance.fecha_fin | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.comision | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[10] }}</label><p>{{ insurance.vencimiento | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[11] }}</label><p>{{ insurance.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[12] }}</label><p>{{ insurance.receipt_type }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[13] }}</label><p ng-if=\"insurance.poliza.natural\">{{ insurance.poliza.natural }}</p><p ng-if=\"!insurance.poliza.natural\">{{ insurance.poliza.juridical }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[14] }}</label><p>{{ insurance.poliza.aseguradora }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[15] }}</label><p>{{ insurance.poliza.ramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[16] }}</label><p>{{ insurance.poliza.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[17] }}</label><p>{{ insurance.poliza.forma_de_pago }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[18] }}</label><p>{{insurance.poliza.status}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[19] }}</label><p>{{ insurance.poliza.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ insurance.poliza.end_of_validity | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[20] }}</label><p>{{ insurance.poliza.clave.clave }} - {{ insurance.poliza.clave.name }}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && (vm.form.group_by.id != 1) && vm.form.group_by.id != 2 && vm.form.group_by.id != 3 && vm.form.group_by.id != 4 && vm.form.group_by.id != 5 && vm.form.group_by.id != 7\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td ng-if=\"vm.form.group_by.id == 6\">Responsable</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 1\"><td>{{ insurance.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 2\"><td>{{ insurance.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 3\"><td>{{ insurance.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__subramo__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"5\" align=\"center\"><b>Contratantes Fisicos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.poliza__natural__group__group_name\"><td>{{ insurance.poliza__natural__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__natural__group__group_name__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"5\" align=\"center\"><b>Contratantes Morales</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.poliza__juridical__group__group_name\"><td>{{ insurance.poliza__juridical__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__juridical__group__group_name__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 5\"><td colspan=\"5\" align=\"center\"><b>Pólizas</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.poliza__vendor__first_name\"><td>{{ insurance.poliza__vendor__first_name }} {{ insurance.poliza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__vendor__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 5\"><td colspan=\"5\" align=\"center\"><b>Fianzas</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.fianza__vendor__first_name\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 6\"><td>{{ insurance.poliza__aseguradora__alias }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 1\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_pol track by $index\" ng-if=\"insurance.poliza__aseguradora__compania && insurance.poliza__aseguradora__count\"><td>{{ insurance.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fia track by $index\" ng-if=\"!insurance.poliza__aseguradora__compania && insurance.fianza__afianzadora__count\"><td>{{ insurance.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__afianzadora__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dolares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_pol track by $index\" ng-if=\"insurance.poliza__aseguradora__compania && insurance.poliza__aseguradora__count\"><td>{{ insurance.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__aseguradora__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fia track by $index\" ng-if=\"!insurance.poliza__aseguradora__compania && insurance.fianza__afianzadora__count\"><td>{{ insurance.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__afianzadora__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 2\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_pol track by $index\" ng-if=\"insurance.poliza__ramo__ramo_name && insurance.poliza__ramo__count\"><td>{{ insurance.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fia track by $index\" ng-if=\"!insurance.poliza__ramo__ramo_name && insurance.fianza__ramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__ramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_pol track by $index\" ng-if=\"insurance.poliza__ramo__ramo_name && insurance.poliza__ramo__count\"><td>{{ insurance.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fia track by $index\" ng-if=\"!insurance.poliza__ramo__ramo_name && insurance.fianza__ramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><t ng-if=\"vm.permiso_comisiones\" d=\"\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}<td>{{ insurance.fianza__ramo__count }}</td></t></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 3\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_pol track by $index\" ng-if=\"insurance.poliza__subramo__subramo_name && insurance.poliza__subramo__count\"><td>{{ insurance.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__subramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fia track by $index\" ng-if=\"!insurance.poliza__subramo__subramo_name && insurance.fianza__subramo__count\"><td>{{ insurance.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__subramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_pol track by $index\" ng-if=\"insurance.poliza__subramo__subramo_name && insurance.poliza__subramo__count\"><td>{{ insurance.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__subramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fia track by $index\" ng-if=\"!insurance.poliza__subramo__subramo_name && insurance.fianza__subramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__subramo__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 4\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.naturals_pesos || grupos_result.naturals_dolares\"><b>Contratantes Físicos</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_pesos track by $index\" ng-if=\"insurance.poliza__natural__group__group_name && insurance.poliza__natural__group__group_name__count\"><td>{{ insurance.poliza__natural__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__natural__group__group_name__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_dolares track by $index\" ng-if=\"insurance.poliza__natural__group__group_name && insurance.poliza__natural__group__group_name__count\"><td>{{ insurance.poliza__natural__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__natural__group__group_name__count }}</td></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.juridicals_pesos || grupos_result.juridicals_dolares\"><b>Contratantes Morales</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_pesos track by $index\" ng-if=\"insurance.poliza__juridical__group__group_name && insurance.poliza__juridical__group__group_name__count\"><td>{{ insurance.poliza__juridical__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__juridical__group__group_name__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_dolares track by $index\" ng-if=\"insurance.poliza__juridical__group__group_name && insurance.poliza__juridical__group__group_name__count\"><td>{{ insurance.poliza__juridical__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__juridical__group__group_name__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 5\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr ng-if=\"grupos_result.polizas_pesos || grupos_result.polizas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Pólizas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_pesos track by $index\" ng-if=\"insurance.poliza__vendor__first_name && insurance.poliza__vendor__count\"><td>{{ insurance.poliza__vendor__first_name }} {{ insurance.poliza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__vendor__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_dolares track by $index\" ng-if=\"insurance.poliza__vendor__first_name && insurance.poliza__vendor__count\"><td>{{ insurance.poliza__vendor__first_name }} {{ insurance.poliza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__vendor__count }}</td></tr><tr ng-if=\"grupos_result.fianzas_pesos || grupos_result.fianzas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Fianzas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_pesos track by $index\" ng-if=\"insurance.fianza__vendor__first_name && insurance.fianza__vendor__count\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_dolares track by $index\" ng-if=\"insurance.fianza__vendor__first_name && insurance.fianza__vendor__count\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 7\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 7\">Usuario</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr ng-if=\"grupos_result.polizas_pesos || grupos_result.polizas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Pólizas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_pesos track by $index\" ng-if=\"insurance.poliza__owner__first_name && insurance.poliza__owner__count\"><td>{{ insurance.poliza__owner__first_name }} {{ insurance.poliza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.polizas_dolares track by $index\" ng-if=\"insurance.poliza__owner__first_name && insurance.poliza__owner__count\"><td>{{ insurance.poliza__owner__first_name }} {{ insurance.poliza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.poliza__owner__count }}</td></tr><tr ng-if=\"grupos_result.fianzas_pesos || grupos_result.fianzas_dolares\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Fianzas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_pesos track by $index\" ng-if=\"insurance.fianza__owner__first_name && insurance.fianza__owner__count\"><td>{{ insurance.fianza__owner__first_name }} {{ insurance.fianza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.fianzas_dolares track by $index\" ng-if=\"insurance.fianza__owner__first_name && insurance.fianza__owner__count\"><td>{{ insurance.fianza__owner__first_name }} {{ insurance.fianza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision_conciliada__sum) }}</td><td>{{ insurance.fianza__owner__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div></div><div ng-if=\"showSums\"><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Pesos</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_pesos | currency}}\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Dólares</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_dolares\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">UDI</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_udi\" disabled=\"\"></div></div></div><div class=\"row\" ng-if=\"showButtonExcel && vm.acceso_rep_cob\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(1)\">Generar Reporte</button></div></div><<<<<<< Updated upstream<script>\n  // $(window).load(function() {\n  //     $(\'.js-example-basic-multiple\').select2();\n  // });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script><script type=\"text/javascript\">  \n  $(window).load(function() { $(\"#state\").select2(); });\n</script>======= >>>>>>> Stashed changes");
$templateCache.put("app/reportes/reporte.cobranzas_subsec.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Reporte recibos subsecuentes</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Recibos subsecuentes</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!vm.buscar_por_folio\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Número de póliza</label> <input type=\"text\" name=\"poliza_number\" ng-model=\"vm.form.poliza_number\" class=\"form-control\"></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Aseguradora(s)</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Ramo(s)</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Subramo(s)</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Forma de pago</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"form-control\" ng-model=\"vm.form.payment\" data-ng-options=\"payment.name for payment in vm.payment track by payment.id\" ng-change=\"vm.changePayment(vm.form.payment)\" required=\"\"><option value=\"\">Todas las formas de pago</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Pagado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user_pay\" data-ng-options=\"users_p.username for users_p in vm.users | orderBy: \'username\' track by users_p.url\" ng-change=\"selectUserPay(select_user_pay)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input ng-disabled=\"vm.buscar_por_folio\" type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input ng-disabled=\"vm.buscar_por_folio\" type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Referenciador</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"form-control\" ng-model=\"vm.form.vendedor\" data-ng-options=\"vendedor.name for vendedor in vm.vendedores | orderBy: \'name\' track by vendedor.id\" ng-change=\"vm.changeReferenciador(vm.form.vendedor)\"><option value=\"\">Todos los referenciadores</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo de Recibo</label><select ng-model=\"vm.form.tipo_recibo\" ng-options=\"item.id as item.name for item in vm.tipo_recibo\" class=\"form-control\" disabled=\"\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Estatus de Recibo</label><select ng-model=\"vm.form.status_recibos\" ng-options=\"item.id as item.name for item in vm.status_recibos\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Ejecutivo de cobranza</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"form-control\" ng-model=\"vm.form.ejecutivo\" data-ng-options=\"ejecutivos.name for ejecutivos in vm.ejecutivos | orderBy: \'name\' track by ejecutivos.id\" ng-change=\"vm.changeEjecutivo(vm.form.ejecutivo)\"><option value=\"\">Todos los Ejecutivos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Entregado</label><select ng-disabled=\"vm.buscar_por_folio\" class=\"form-control\" ng-model=\"vm.form.deliver\" data-ng-options=\"deliver.name for deliver in deliverReceipt | orderBy: \'id\' track by deliver.id\" ng-change=\"vm.changeDeleiver(vm.form.deliver)\"></select></div><div ng-if=\"vm.buscar_por_folio\" class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24 text-center\"><input name=\"look_folio_pago\" value=\"1\" ng-model=\"vm.tipo_folio_buscar\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"look_folio_pago\">Folio de pago</span></div><div ng-if=\"vm.buscar_por_folio\" class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24 text-center\"><input name=\"look_folio_liq\" value=\"2\" ng-model=\"vm.tipo_folio_buscar\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"look_folio_liq\">Folio de liquidación</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24\"><input placeholder=\"Folio\" type=\"text\" ng-if=\"vm.buscar_por_folio\" class=\"form-control\" ng-model=\"vm.folio_a_buscar\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"vm.buscar_por_folio\"><label>Creado por</label><select class=\"form-control\" ng-model=\"vm.form.user\" data-ng-options=\"user.first_name +\' \'+user.last_name for user in vm.users | orderBy: \'first_name\' track by user.id\" ng-change=\"selectUser(vm.form.user)\"><option value=\"\">Todos los usuarios</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24 pull-right\" ng-if=\"vm.acceso_ver_cob\"><button class=\"col-xs-12 btn btn-success ladda-button2\" ng-click=\"vm.Generar(1,1,1,1)\">Consultar</button></div></div></div></div></div></div><div ng-if=\"vm.acceso_ver_cob\" class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row animate\" ng-if=\"!vm.show_binnacle\"><div class=\"col-xs-12\"><div class=\"tabs-container\" ng-if=\"vm.acceso_ver_cob\"><uib-tabset><div class=\"panel-body\"><div class=\"project-list\"><table class=\"table table-bordered table-hover table-hover hidden-xs hidden-sm\"><thead><th></th><th ng-click=\"vm.changeReceipts(1, vm.receipts_tipo_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_tipo_asc == 1, \'fa fa-sort-asc\': vm.receipts_tipo_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(2, vm.receipts_cont_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_cont_asc == 1, \'fa fa-sort-asc\': vm.receipts_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(3, vm.receipts_nump_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_nump_asc == 1, \'fa fa-sort-asc\': vm.receipts_nump_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(4, vm.receipts_periodo_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_periodo_asc == 1, \'fa fa-sort-asc\': vm.receipts_periodo_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(5, vm.receipts_aseg_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_aseg_asc == 1, \'fa fa-sort-asc\': vm.receipts_aseg_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(6, vm.receipts_estatus_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_estatus_asc == 1, \'fa fa-sort-asc\': vm.receipts_estatus_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(7, vm.receipts_ptotal_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_ptotal_asc == 1, \'fa fa-sort-asc\': vm.receipts_ptotal_asc == 2}\"></span></th><th ng-click=\"vm.changeReceipts(8, vm.receipts_operador_asc == 1 ? 2 : 1)\" ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.receipts_operador_asc == 1, \'fa fa-sort-asc\': vm.receipts_operador_asc == 2}\"></span></th><th>Fecha de Pago</th><th ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}}</th></thead><tbody><tr ng-repeat=\"receipt in vm.receipts track by $index\" ng-if=\"receipt.isCopy == false\"><td ng-click=\"$event.stopPropagation()\"><label><input type=\"checkbox\" ng-model=\"value_check\" ng-click=\"massiveReceipts(receipt,value_check)\" class=\"checkbox\"></label></td><td ng-if=\"receipt.receipt_type == 1\">Póliza</td><td ng-if=\"receipt.receipt_type == 2\">Endoso</td><td ng-if=\"receipt.receipt_type == 3\">Nota Crédito/Endoso</td><td ng-if=\"receipt.receipt_type == 4\">Recibo de Bono</td><td class=\"project-title\"><p class=\"font-weight-bold\" ng-if=\"receipt.poliza.contractor\">{{ receipt.poliza.contractor.full_name }}</p><br><small ng-if=\"receipt.poliza.contractor.type_person == \'Física\'\">Persona Física</small> <small ng-if=\"receipt.poliza.contractor.type_person == \'Moral\'\">Persona Moral</small> <small ng-if=\"(!receipt.poliza.contractor) && receipt.bono\">Bono</small></td><td class=\"project-title\"><a ng-if=\"receipt.poliza && vm.acceso_ver_pol\" ui-sref=\"polizas.info({polizaId: receipt.poliza.id})\">Póliza: {{ receipt.poliza.poliza_number }}</a> <span ng-if=\"receipt.poliza && !vm.acceso_ver_pol\">Póliza: {{ receipt.poliza.poliza_number }}</span><br><small ng-if=\"receipt.poliza\">Serie:</small><br><small ng-if=\"receipt.poliza\">{{receipt.recibo_numero}} / {{receipt.poliza.recibos_poliza.length}}</small> <small ng-if=\"receipt.bono\">Serie: {{receipt.recibo_bono}}</small></td><td class=\"project-title\"><span class=\"font-weight-bold\">Desde: {{ receipt.fecha_inicio | date: \'dd-MM-yyyy\' : \'UTC\'}}</span><br><span>Vence: {{ receipt.fecha_fin | date: \'dd-MM-yyyy\'}}</span></td><td class=\"project-title\"><span class=\"font-weight-bold\">Aseguradora: {{ receipt.poliza.aseguradora }} {{receipt.bono.aseguradora}}</span><br><small ng-if=\"receipt.poliza || receipt.fianza\">Subramo: {{ receipt.poliza.subramo }}</small></td><td class=\"project-status\"><div status-receipt-clean=\"receipt.status\" class=\"label\" ng-class=\"{ \'label-success\': receipt.status == 4, \'label-info\': receipt.status == 5 || receipt.status == 6, \'label-primary\': receipt.status == 1 || receipt.status == 3, \'label-warning\': receipt.status == 2 || receipt.status == 8 }\"></div></td></tr></tbody></table></div><td>{{ receipt.prima_total | currency }}</td><td>{{ receipt.poliza.owner }} {{receipt.bono.owner}}</td><td>{{ receipt.pay_date | date: \'dd-MM-yyyy\'}}<br></td><td ng-if=\"receipt.antiguedad > 0\">{{ receipt.antiguedad}} días</td><td ng-if=\"!(receipt.antiguedad > 0)\">0 días</td><div ng-if=\"vm.show_paginacion_recibos\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></uib-tabset></div></div></div></div><div ng-if=\"vm.receipts.length\"><div ng-if=\"vm.show_button1 == true && !vm.show_binnacle\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group margin-top-24 pull-right\" ng-if=\"vm.acceso_rep_cob\"><button ng-click=\"exportData(1)\" class=\"col-xs-12 btn btn-primary\">Generar Reporte</button></div></div></div></div></div></div><script type=\"text/javascript\">  \n  $(window).load(function() { $(\"#state\").select2(); });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script>");
$templateCache.put("app/reportes/reporte.cotizaciones.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reportes Cotizaciones</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Cotizaciones</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Emitida por</label><select class=\"form-control\" ng-model=\"vm.emitida_por\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"vm.changeSubgroup(vm.form.subgroup)\" required=\"\"><option value=\"\">Todas las aseguradoras</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Cotizada en</label><select class=\"js-example-basic-multiple col-xs-12 form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.cotizada_en\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"vm.subramos\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de ingreso inicial</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.fecha_ingreso_inicial\" value=\"{{vm.fecha_ingreso_inicial}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de ingreso final</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.fecha_ingreso_final\" value=\"{{vm.fecha_ingreso_final}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo</label><select class=\"form-control\" ng-model=\"vm.tipo\" data-ng-options=\"tipo.id as tipo.name for tipo in tipos track by tipo.id\"></select></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right ladda-buttonC\" ng-click=\"vm.Generar()\">Consultar</button></div></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Cotizaciones</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>No. Folio</th><th>Contratante</th><th>Ramo</th><th>Subramo</th><th>Aseguradoras Cotizadas</th><th>Estatus</th><th>Asegurado</th></tr></thead><tbody><tr ng-show=\"cotizacion\" ng-repeat=\"cotizacion in cotizaciones track by $index\"><td>{{cotizacion.id}}</td><td>{{cotizacion.contractor}}</td><td>{{cotizacion.ramo}}</td><td>{{cotizacion.subramo}}</td><td>{{cotizacion.aseguradoras}}</td><td>{{cotizacion.status}}</td><td>{{cotizacion.asegurado}}</td></tr></tbody></table><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div></div></div><div class=\"row\" ng-if=\"cotizaciones && cotizaciones.length!=0\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel()\">Descargar Reporte</button></div></div>");
$templateCache.put("app/reportes/reporte.cumple.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reporte Cumpleaños</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Cumpleaños en la Semana</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\" ng-init=\"getPersons(1,1)\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input ng-disabled=\"vm.buscar_por_folio\" type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"since\" value=\"{{since}}\" ng-change=\"vm.saveLocalstorange()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" ng-disabled=\"vm.buscar_por_folio\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"until\" value=\"{{until}}\" ng-change=\"vm.saveLocalstorange()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right ladda-button\" ng-click=\"getPersons(1,1)\">Consultar</button></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Personas</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"persons\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Tipo</th><th>Persona</th><th>Fecha de Cumpleaños</th><th>Fecha creación</th><th>Póliza</th></tr></thead><tbody><tr ng-repeat=\"per1 in persons.contractors track by $index\"><td>Contratante</td><td><span ng-if=\"per1[0]\">{{per1[0]}}</span></td><td>{{per1[4] | date:\"dd/MM/yyyy\" : \'UTC\'}}</td><td>{{per1[5]| date:\"dd/MM/yyyy - HH:mm:ss\" : \'UTC\' }}</td><td>{{per1[7]}}</td></tr><tr ng-repeat=\"per3 in persons.titulares track by $index\"><td>Titulares</td><td><span ng-if=\"per3[0]\">{{per3[0]}}</span> <span ng-if=\"!per3[0]\">{{per3[1]}} {{per3[2]}} <span ng-if=\"per3[3]\">{{per3[3]}}</span></span></td><td>{{per3[4] | date:\"dd/MM/yyyy\" : \'UTC\'}}</td><td>{{per3[5]| date:\"dd/MM/yyyy - HH:mm:ss\" : \'UTC\' }}</td><td>{{per3[7]}}</td></tr><tr ng-repeat=\"per in persons.beneficiaries track by $index\"><td>Beneficiario</td><td><span ng-if=\"per[0]\">{{per[0]}}</span> <span ng-if=\"!per[0]\">{{per[1]}} {{per[2]}} <span ng-if=\"per[3]\">{{per[3]}}</span></span></td><td>{{per[4] | date:\"dd/MM/yyyy\" : \'UTC\'}}</td><td>{{per[5]| date:\"dd/MM/yyyy - HH:mm:ss\" : \'UTC\' }}</td><td>{{per[7]}}</td></tr><tr ng-repeat=\"per2 in persons.relationship track by $index\"><td>Dependientes</td><td><span ng-if=\"per2[0]\">{{per2[0]}}</span> <span ng-if=\"!per2[0]\">{{per2[1]}} {{per2[2]}} <span ng-if=\"per2[3]\">{{per2[3]}}</span></span></td><td>{{per2[4] | date:\"dd/MM/yyyy\" : \'UTC\'}}</td><td>{{per2[5]| date:\"dd/MM/yyyy - HH:mm:ss\" : \'UTC\' }}</td><td>{{per2[7]}}</td></tr></tbody></table></div><button ng-if=\"persons\" ng-click=\"export(1)\" class=\"btn btn-secondary pull-right ladda-button_excel\"><i class=\"fa fa-download\"></i> Reporte en excel</button></div></div></div>");
$templateCache.put("app/reportes/reporte.edoclientes.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reporte Edo. de Clientes</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Edo. de Clientes</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option><option value=\"6\">Administrativas</option><option value=\"7\">Crédito</option><option value=\"8\">Fideicomiso</option><option value=\"4\">Fidelidad</option><option value=\"5\">Judicial</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.subramo_code\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"users.username for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Estatus</label><select class=\"form-control\" ng-model=\"vm.form.status\" ng-options=\"status.name for status in vm.status | orderBy: \'name\' track by status.id\" ng-change=\"vm.changestatus(vm.form.status)\"><option value=\"\" disabled=\"\">Seleccione estatus de póliza</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Agrupar por:</label><select class=\"form-control\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\">Seleccione</option></select></div><div align=\"center\" class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><br><div class=\"col-xs-12 form-group\" align=\"center\"><legend class=\"legend-title\" align=\"center\">Tipo de Recibos</legend><div class=\"col-xs-12 col-sm-6 col-md-3 radio\" align=\"center\" style=\"margin-top: 0;\"><label><input name=\"recibo_endoso\" type=\"radio\" ng-model=\"recibo_endoso\" ng-click=\"selectReceiptsOption(recibo_endoso)\" value=\"1\" class=\"ng-valid ng-dirty ng-touched\">Endoso</label></div><div class=\"col-xs-12 col-sm-6 col-md-2 radio\" align=\"center\"><label><input name=\"recibo_endoso\" type=\"radio\" ng-model=\"recibo_endoso\" ng-click=\"selectReceiptsOption(recibo_endoso)\" value=\"2\" class=\"ng-valid ng-dirty ng-touched\">Póliza</label></div><div class=\"col-xs-12 col-sm-6 col-md-3 radio\" align=\"center\"><label><input name=\"recibo_endoso\" type=\"radio\" ng-model=\"recibo_endoso\" value=\"3\" ng-click=\"selectReceiptsOption(recibo_endoso)\" class=\"ng-valid ng-dirty ng-touched\">Notas de Crédito</label></div><div class=\"col-xs-12 col-sm-6 col-md-3 radio\" align=\"center\"><label><input name=\"recibo_endoso\" type=\"radio\" ng-model=\"recibo_endoso\" ng-click=\"selectReceiptsOption(recibo_endoso)\" value=\"0\" class=\"ng-valid ng-dirty ng-touched\">Todos</label></div></div><br></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right ladda-button\" ng-click=\"getEdosClientes(1,1)\">Consultar</button><div class=\"col-xs-12\"></div></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Estado de Clientes</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"(!grupos_result || grupos_result.length == 0)\" style=\"display: none;\"><div class=\"row\" ng-if=\"edoclientes\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Contratante</th><th>Póliza</th><th>Ramo</th><th>Subramo</th><th>Inicio Vigencia</th><th>Fin Vigencia</th><th>Aseguradora</th><th>Forma de Pago</th><th>Prima Neta</th><th>Prima Total</th><th>Ejecutivo de Cobranza</th><th>Estatus</th></tr></thead><tbody><tr ng-repeat=\"edo in edoclientes track by $index\"><td>{{edo.contractor.full_name}}</td><td>{{edo.poliza_number}}</td><td>{{edo.ramo}}</td><td>{{edo.subramo}}</td><td>{{edo.start_of_validity | date:\"dd/MM/yyyy\" }}</td><td>{{edo.end_of_validity | date:\"dd/MM/yyyy\" }}</td><td>{{edo.aseguradora}}</td><td>{{payForm(edo.forma_de_pago)}}</td><td>{{edo.p_neta | currency}}</td><td>{{edo.p_total | currency}}</td><td>{{edo.collection_executive.first_name}} {{edo.collection_executive.last_name}}</td><td>{{status(edo.status)}}</td></tr><tr ng-repeat=\"edo_1 in edoclientes_1 track by $index\"><td>{{edo_1.contractor.full_name}}</td><td>{{edo_1.poliza_number}}</td><td>{{edo_1.ramo}}</td><td>{{edo_1.subramo}}</td><td>{{edo_1.start_of_validity | date:\"dd/MM/yyyy\" }}</td><td>{{edo_1.end_of_validity | date:\"dd/MM/yyyy\" }}</td><td>{{edo_1.aseguradora}}</td><td>{{payForm(edo_1.forma_de_pago)}}</td><td>{{edo_1.p_neta | currency}}</td><td>{{edo_1.p_total | currency}}</td><td>{{edo_1.collection_executive.first_name}} {{edo_1.collection_executive.last_name}}</td><td>{{status(edo_1.status)}}</td></tr></tbody></table></div><button ng-if=\"edoclientes.length > 0\" ng-click=\"export(1)\" class=\"btn btn-primary pull-right ladda-button_excel\"><i class=\"fa fa-download\"></i> Reporte en excel</button></div></div><div class=\"row\"><div class=\"ibox-content\" ng-if=\"(!grupos_result || grupos_result.length == 0) && edoclientes.length > 0\"><div class=\"row\" ng-if=\"edoclientes\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Contratante</th><th>Póliza</th><th>Ramo</th><th>Subramo</th><th>Inicio Vigencia</th><th>Fin Vigencia</th><th>Aseguradora</th><th>Forma de Pago</th><th>Prima Neta General</th><th>Prima Total General</th><th>Prima Neta Liquidado</th><th>Prima Total Liquidado</th><th>Ejecutivo de Cobranza</th><th>Estatus Póliza</th><th>Estatus Recibos</th></tr></thead><tbody><tr ng-repeat=\"edo_rec in edoclientes track by $index\"><td>{{edo_rec.poliza__contractor__full_name}}</td><td>{{edo_rec.poliza__poliza_number}}</td><td>{{edo_rec.poliza__ramo__ramo_name}}</td><td>{{edo_rec.poliza__subramo__subramo_name}}</td><td>{{edo_rec.poliza__start_of_validity | date:\"dd/MM/yyyy\" }}</td><td>{{edo_rec.poliza__end_of_validity | date:\"dd/MM/yyyy\" }}</td><td>{{edo_rec.poliza__aseguradora__compania}}</td><td>{{payForm(edo_rec.poliza__forma_de_pago)}}</td><td>{{edo_rec.poliza__p_neta | currency}}</td><td>{{edo_rec.poliza__p_total | currency}}</td><td>{{edo_rec.prima_neta__sum | currency}}</td><td>{{edo_rec.prima_total__sum | currency}}</td><td>{{edo_rec.poliza__collection_executive__first_name}} {{edo_rec.poliza__collection_executive__last_name}}</td><td>{{status(edo_rec.poliza__status)}}</td><td><span class=\"badge\">{{receiptsStatus(edo_rec.status)}}</span></td></tr><tr ng-repeat=\"edo_rec_1 in edoclientes_1 track by $index\"><td>{{edo_rec_1.poliza__contractor__full_name}}</td><td>{{edo_rec_1.poliza__poliza_number}}</td><td>{{edo_rec_1.poliza__ramo__ramo_name}}</td><td>{{edo_rec_1.poliza__subramo__subramo_name}}</td><td>{{edo_rec_1.poliza__start_of_validity | date:\"dd/MM/yyyy\" }}</td><td>{{edo_rec_1.poliza__end_of_validity | date:\"dd/MM/yyyy\" }}</td><td>{{edo_rec_1.poliza__aseguradora__compania}}</td><td>{{payForm(edo_rec_1.poliza__forma_de_pago)}}</td><td>{{edo_rec_1.poliza__p_neta | currency}}</td><td>{{edo_rec_1.poliza__p_total | currency}}</td><td>{{0 | currency}}</td><td>{{0 | currency}}</td><td>{{edo_rec_1.poliza__collection_executive__first_name}} {{edo_rec_1.poliza__collection_executive__last_name}}</td><td>{{status(edo_rec_1.poliza__status)}}</td><td><span class=\"badge\">{{receiptsStatus(edo_rec_1.status)}}</span></td></tr></tbody></table></div><button ng-if=\"edoclientes.length > 0\" ng-click=\"export(1)\" class=\"btn btn-primary pull-right ladda-button_excel\"><i class=\"fa fa-download\"></i> Reporte en excel</button></div></div><div class=\"ibox-content\" ng-if=\"grupos_result.length > 0 && vm.form.group_by.id == 1\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td>Contratante</td><td>Prima Neta General</td><td>Prima Total General</td><td>Prima Neta Liquidada</td><td>Prima Total Liquidada</td><td>Registros</td><tbody><tr ng-repeat=\"edo_cont in grupos_result track by $index\" ng-if=\"(edo_cont.poliza__contractor__full_name) && (edo_cont.poliza__id__count)\"><td>{{ edo_cont.poliza__contractor__full_name }}</td><td>{{ edo_cont.poliza__p_neta__sum | currency}}</td><td>{{ edo_cont.poliza__p_total__sum | currency }}</td><td>{{ edo_cont.prima_neta__sum | currency}}</td><td>{{ edo_cont.prima_total__sum | currency }}</td><td>{{ edo_cont.poliza__id__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result.length > 0 && vm.form.group_by.id == 2\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td>Aseguradora</td><td>Prima Neta General</td><td>Prima Total General</td><td>Prima Neta Liquidada</td><td>Prima Total Liquidada</td><td>Registros</td><tbody><tr ng-repeat=\"edo_cont in grupos_result track by $index\" ng-if=\"edo_cont.poliza__aseguradora__compania && edo_cont.poliza__id__count\"><td>{{ edo_cont.poliza__aseguradora__compania }}</td><td>{{ edo_cont.poliza__p_neta__sum | currency}}</td><td>{{ edo_cont.poliza__p_total__sum | currency }}</td><td>{{ edo_cont.prima_neta__sum | currency}}</td><td>{{ edo_cont.prima_total__sum | currency }}</td><td>{{ edo_cont.poliza__id__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result.length > 0 && vm.form.group_by.id == 3\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td>Ramo</td><td>Prima Neta General</td><td>Prima Total General</td><td>Prima Neta Liquidada</td><td>Prima Total Liquidada</td><td>Registros</td><tbody><tr ng-repeat=\"edo_cont in grupos_result track by $index\" ng-if=\"edo_cont.poliza__ramo__ramo_name && edo_cont.poliza__id__count\"><td>{{ edo_cont.poliza__ramo__ramo_name }}</td><td>{{ edo_cont.poliza__p_neta__sum | currency}}</td><td>{{ edo_cont.poliza__p_total__sum | currency }}</td><td>{{ edo_cont.prima_neta__sum | currency}}</td><td>{{ edo_cont.prima_total__sum | currency }}</td><td>{{ edo_cont.poliza__id__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result.length > 0 && vm.form.group_by.id == 4\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td>Subramo</td><td>Prima Neta General</td><td>Prima Total General</td><td>Prima Neta Liquidada</td><td>Prima Total Liquidada</td><td>Registros</td><tbody><tr ng-repeat=\"edo_cont in grupos_result track by $index\" ng-if=\"edo_cont.poliza__subramo__subramo_name && edo_cont.poliza__id__count\"><td>{{ edo_cont.poliza__subramo__subramo_name }}</td><td>{{ edo_cont.poliza__p_neta__sum | currency}}</td><td>{{ edo_cont.poliza__p_total__sum | currency }}</td><td>{{ edo_cont.prima_neta__sum | currency}}</td><td>{{ edo_cont.prima_total__sum | currency }}</td><td>{{ edo_cont.poliza__id__count }}</td></tr></tbody></table><br></div></div></div><button ng-if=\"grupos_result.length > 0\" ng-click=\"export(2)\" class=\"btn btn-primary pull-right ladda-button_excel\"><i class=\"fa fa-download\"></i> Reporte en excel *</button></div></div>");
$templateCache.put("app/reportes/reporte.endosos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reportes Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Endosos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtro Básico</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row text-align-center report-highlight\"><div class=\"col-sm-6 col-md-6 col-lg-6 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-sm-6 col-md-6 col-lg-6 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Más Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Mostrar endosos de:</label><select class=\"form-control\" ng-model=\"vm.form.report_by\" ng-change=\"changeReportBy()\" ng-options=\"tipo as tipo.name for tipo in vm.tipo_report track by tipo.id\"></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label ng-if=\"vm.form.report_by !=2\">Número de póliza</label><label ng-if=\"vm.form.report_by ==2\">Número de fianza</label> <input ng-model=\"vm.form.poliza\" class=\"form-control\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-model=\"vm.form.celula\" data-ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"vm.changecelula(vm.form.celula)\"><option value=\"\">Todo</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label ng-if=\"vm.form.report_by !=2\">Aseguradora(s)</label> <label ng-if=\"vm.form.report_by ==2\">Afianzadora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\" ng-if=\"vm.form.report_by !=2\">Vida</option><option value=\"2\" ng-if=\"vm.form.report_by !=2\">Accidentes y Enfermedades</option><option value=\"3\" ng-if=\"vm.form.report_by !=2\">Daños</option><option value=\"8\" ng-if=\"vm.form.report_by ==2\">Fideicomiso</option><option value=\"4\" ng-if=\"vm.form.report_by ==2\">Fidelidad</option><option value=\"6\" ng-if=\"vm.form.report_by ==2\">Administrativas</option><option value=\"5\" ng-if=\"vm.form.report_by ==2\">Judicial</option><option value=\"7\" ng-if=\"vm.form.report_by ==2\">Crédito</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"users.username for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Estatus</label><select class=\"form-control m-b\" ng-model=\"vm.form.status\" data-ng-options=\"status.name for status in vm.status track by status.id\" ng-change=\"vm.changeStatus(vm.form.status)\"><option value=\"\">Selecciona un estatus</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Tipo</label><select class=\"form-control m-b\" ng-model=\"vm.form.type\" data-ng-options=\"type.name for type in vm.type track by type.id\" ng-change=\"vm.changeType(vm.form.type)\"><option value=\"\">Selecciona un tipo</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-model=\"vm.form.businesLine\" data-ng-options=\"businesLine.name for businesLine in vm.businesLine track by businesLine.id\" ng-change=\"vm.changeBLine(vm.form.businesLine)\" required=\"\"><option value=\"\">Todas las líneas</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Agrupar por:</label><select class=\"form-control\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\">Seleccione</option></select></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Valor dólar</label> <input class=\"form-control\" type=\"text\" name=\"valueDolar\" ng-model=\"vm.form.valueDolar\" ng-change=\"numberFormatDolar(vm.form.valueDolar)\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Valor UDI</label> <input class=\"form-control\" type=\"text\" name=\"valueUdi\" ng-model=\"vm.form.valueUdi\" ng-change=\"numberFormatUdi(vm.form.valueUdi)\"></div></div></div></div><div class=\"col-xs-12 text-align-center form-group\"><button class=\"btn btn-success ladda-buttonC\" ng-click=\"vm.Generar(1,1)\">Consultar</button></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result || grupos_result.length == 0\"><div class=\"row\"><div class=\"panel-body table-over-y\" id=\"exportable\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeEndoso(1, vm.endoso_num_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(1, $event)\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.endoso_num_asc == 1, \'fa fa-sort-asc\': vm.endoso_num_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeEndoso(2, vm.endoso_folio_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(2, $event)\" ng-mouseout=\"finalColumn(2, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.endoso_folio_asc == 1, \'fa fa-sort-asc\': vm.endoso_folio_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeEndoso(3, vm.endoso_status_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(3, $event)\" ng-mouseout=\"finalColumn(3, $event)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.endoso_status_asc == 1, \'fa fa-sort-asc\': vm.endoso_status_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeEndoso(4, vm.endoso_fecha_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(4, $event)\" ng-mouseout=\"finalColumn(4, $event)\" ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.endoso_fecha_asc == 1, \'fa fa-sort-asc\': vm.endoso_fecha_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeEndoso(5, vm.endoso_tipo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(5, $event)\" ng-mouseout=\"finalColumn(5, $event)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.endoso_tipo_asc == 1, \'fa fa-sort-asc\': vm.endoso_tipo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeEndoso(6, vm.endoso_nump_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(6, $event)\" ng-mouseout=\"finalColumn(6, $event)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.endoso_nump_asc == 1, \'fa fa-sort-asc\': vm.endoso_nump_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeEndoso(7, vm.endoso_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(7, $event)\" ng-mouseout=\"finalColumn(7, $event)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.endoso_cont_asc == 1, \'fa fa-sort-asc\': vm.endoso_cont_asc == 2}\"></span></th><th>Grupo</th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeEndoso(8, vm.endoso_aseg_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(8, $event)\" ng-mouseout=\"finalColumn(8, $event)\" ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.endoso_aseg_asc == 1, \'fa fa-sort-asc\': vm.endoso_aseg_asc == 2}\"></span></th><th>Sucursal</th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeEndoso(9, vm.endoso_subramo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(9, $event)\" ng-mouseout=\"finalColumn(9, $event)\" ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.endoso_subramo_asc == 1, \'fa fa-sort-asc\': vm.endoso_subramo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeEndoso(10, vm.endoso_desc_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(10, $event)\" ng-mouseout=\"finalColumn(10, $event)\" ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.endoso_desc_asc == 1, \'fa fa-sort-asc\': vm.endoso_desc_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeEndoso(11, vm.endoso_owner_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(11, $event)\" ng-mouseout=\"finalColumn(11, $event)\" ng-model=\"vm.table.headers[10]\">{{vm.table.headers[10]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.endoso_owner_asc == 1, \'fa fa-sort-asc\': vm.endoso_owner_asc == 2}\"></span></th><th>Identificador Póliza/Fianza</th><th>Inicio Póliza</th><th>Fin Póliza</th><th>Prima Neta</th><th>RPF</th><th>Derecho</th><th>IVA</th><th>Prima Total</th><th>Subgrupo</th><th>Subsubgrupo</th><th>Agrupación</th><th>Subagrupación</th><th>Subsubagrupación</th><th>Clasificación</th><th>Línea de Negocio</th><th>Célula</th><th>Folio Aseguradora</th><th>Fecha de Creación</th></tr></thead><tbody><tr ng-repeat=\"insurance in insurances track by $index\" ng-click=\"goToInfo(insurance.id)\" on-finish-render=\"ngRepeatFinished\"><td ng-if=\"insurance.number_endorsement\">{{ insurance.number_endorsement }}</td><td ng-if=\"!insurance.number_endorsement\">Sin número asignado</td><td>{{ insurance.internal_number }}</td><td ng-if=\"insurance.status == 1\">Pendiente</td><td ng-if=\"insurance.status == 2\">Registrado</td><td ng-if=\"insurance.status == 3\">Rechazado</td><td ng-if=\"insurance.status == 4\">Cancelado</td><td ng-if=\"insurance.status == 5\">En trámite</td><td ng-if=\"insurance.status == 0\">Desactivado</td><td ng-if=\"!insurance.status\">Sin especificar</td><td>{{ insurance.init_date | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.endorsement_type }}</td><td>{{ insurance.policy.poliza_number }}</td><td>{{ insurance.policy.contractor.full_name }}</td><td>{{ insurance.policy.contractor.group }}</td><td>{{ insurance.policy.aseguradora.alias }}</td><td>{{ insurance.policy.sucursal.sucursal_name }}</td><td><p ng-if=\"insurance.policy.subramo == 9\">Automóviles</p><p ng-if=\"insurance.policy.subramo == 1\">Vida</p><p ng-if=\"insurance.damage\">Daños</p><p ng-if=\"insurance.policy.subramo == 3\">Accidentes</p><p ng-if=\"insurance.policy.document_type == 3 || insurance.policy.document_type == 1\">{{ insurance.policy.subramo.subramo_name }}</p></td><td>{{ insurance.observations }}</td><td>{{ insurance.owner }}</td><td><span ng-if=\"insurance.policy\">{{insurance.policy.identifier}}</span></td><td>{{ insurance.policy.start_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.policy.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.p_neta | currency}}</td><td>{{ insurance.rpf | currency}}</td><td>{{ insurance.derecho | currency}}</td><td>{{ insurance.iva | currency}}</td><td>{{ insurance.p_total | currency}}</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>{{ insurance.insurancefolio}}</td><td>{{ insurance.created_at | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table><div ng-if=\"show_pag_endorsments\" class=\"text-center\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0)\"><div class=\"row\" style=\"display: none;\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td ng-if=\"vm.form.group_by.id == 6\">Estatus</td><td>Prima Neta</td><td>Prima Total</td><td>Comisión</td><td>Registros</td><tbody><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 1\"><td>{{ insurance.policy__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.policy__aseguradora__id__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 2\"><td>{{ insurance.policy__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.policy__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 3\"><td>{{ insurance.policy__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.policy__subramo__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Fisicos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.policy__contractor__group__group_name\"><td>{{ insurance.policy__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.policy__contractor__group__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Morales</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.policy__contractor__group__group_name\"><td>{{ insurance.policy__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.policy__contractor__group__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.policy__vendor__count\"><td>{{ insurance.policy__vendor__first_name }} {{ insurance.policy__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.policy__vendor__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 6\"><td>{{ status(insurance.status) }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.status__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div><br></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 1\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_poliza track by $index\" ng-if=\"insurance.policy__aseguradora__compania && insurance.policy__aseguradora__id__count\"><td>{{ insurance.policy__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.policy__aseguradora__id__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fianza track by $index\" ng-if=\"!insurance.policy__aseguradora__compania && insurance.fianza__afianzadora__id__count\"><td>{{ insurance.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.fianza__afianzadora__id__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dolares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_poliza track by $index\" ng-if=\"insurance.policy__aseguradora__compania && insurance.policy__aseguradora__id__count\"><td>{{ insurance.policy__aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.policy__aseguradora__id__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fianza track by $index\" ng-if=\"!insurance.policy__aseguradora__compania && insurance.fianza__afianzadora__id__count\"><td>{{ insurance.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.fianza__afianzadora__id__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 2\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_poliza track by $index\" ng-if=\"insurance.policy__ramo__ramo_name && insurance.policy__ramo__count\"><td>{{ insurance.policy__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.policy__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fianza track by $index\" ng-if=\"!insurance.policy__ramo__ramo_name && insurance.fianza__ramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.fianza__ramo__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dolares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_poliza track by $index\" ng-if=\"insurance.policy__ramo__ramo_name && insurance.policy__ramo__count\"><td>{{ insurance.policy__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.policy__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fianza track by $index\" ng-if=\"!insurance.policy__ramo__ramo_name && insurance.fianza__ramo__count\"><td>{{ insurance.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.fianza__ramo__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 3\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_poliza track by $index\" ng-if=\"insurance.policy__subramo__subramo_name && insurance.policy__subramo__count\"><td>{{ insurance.policy__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.policy__subramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fianza track by $index\" ng-if=\"!insurance.policy__subramo__subramo_name && insurance.fianza__subramo__count\"><td>{{ insurance.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.fianza__subramo__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dolares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_poliza track by $index\" ng-if=\"insurance.policy__subramo__subramo_name && insurance.policy__subramo__count\"><td>{{ insurance.policy__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.policy__subramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fianza track by $index\" ng-if=\"!insurance.policy__subramo__subramo_name && insurance.fianza__subramo__count\"><td>{{ insurance.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.fianza__subramo__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 4\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.naturals_pol_pesos || grupos_result.naturals_pol_dolares || grupos_result.naturals_fia_dolares || grupos_result.naturals_fia_pesos\"><b>Contratantes Físicos</b></td></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Pólizas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_pol_pesos track by $index\" ng-if=\"insurance.policy__contractor__group__group_name && insurance.policy__contractor__group__count\"><td>{{ insurance.policy__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.policy__contractor__group__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_pol_dolares track by $index\" ng-if=\"insurance.policy__contractor__group__group_name && insurance.policy__contractor__group__count\"><td>{{ insurance.policy__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.policy__contractor__group__count }}</td></tr><tr><td colspan=\"5\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.juridicals_pol_pesos || grupos_result.juridicals_pol_dolares\"><b>Contratantes Morales</b></td></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Pólizas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_pol_pesos track by $index\" ng-if=\"insurance.policy__contractor__group__group_name && insurance.policy__contractor__group__count\"><td>{{ insurance.policy__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.policy__contractor__group__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_pol_dolares track by $index\" ng-if=\"insurance.policy__contractor__group__group_name && insurance.policy__contractor__group__count\"><td>{{ insurance.policy__contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.policy__contractor__group__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 5\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 5\">Referenciador</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr ng-if=\"grupos_result.pesos_poliza || grupos_result.dolares_poliza\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Pólizas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_poliza track by $index\" ng-if=\"insurance.policy__vendor__first_name && insurance.policy__vendor__count\"><td>{{ insurance.policy__vendor__first_name }} {{ insurance.poliza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.policy__comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.policy__recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.policy__vendor__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_poliza track by $index\" ng-if=\"insurance.policy__vendor__first_name && insurance.policy__vendor__count\"><td>{{ insurance.policy__vendor__first_name }} {{ insurance.policy__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.policy__comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.policy__recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.policy__vendor__count }}</td></tr><tr ng-if=\"grupos_result.pesos_fianza || grupos_result.dolares_fianza\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Fianzas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fianza track by $index\" ng-if=\"insurance.fianza__vendor__first_name && insurance.fianza__vendor__count\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.fianza__comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.fianza__recibos_fianza__comision_conciliada__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fianza track by $index\" ng-if=\"insurance.fianza__vendor__first_name && insurance.fianza__vendor__count\"><td>{{ insurance.fianza__vendor__first_name }} {{ insurance.fianza__vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.fianza__comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.fianza__recibos_fianza__comision_conciliada__sum) }}</td><td>{{ insurance.fianza__vendor__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 6\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 6\">Estatus</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr ng-if=\"grupos_result.pesos_poliza || grupos_result.dolares_poliza\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Pólizas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_poliza track by $index\" ng-if=\"insurance.status && insurance.status__count\"><td>{{ status(insurance.status )}}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.status__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_poliza track by $index\" ng-if=\"insurance.status && insurance.status__count\"><td>{{ status(insurance.status) }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.status__count }}</td></tr><tr ng-if=\"grupos_result.pesos_fianza || grupos_result.dolares_fianza\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Fianzas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fianza track by $index\" ng-if=\"insurance.status && insurance.status__count\"><td>{{ status(insurance.status) }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.status__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fianza track by $index\" ng-if=\"insurance.status && insurance.status__count\"><td>{{ status(insurance.status) }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.endorsement_receipt__comision_conciliada__sum) }}</td><td>{{ insurance.status__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 7\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 7\">Usuario</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr ng-if=\"grupos_result.pesos_poliza || grupos_result.dolares_poliza\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Pólizas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_poliza track by $index\" ng-if=\"insurance.policy__owner__first_name && insurance.policy__owner__count\"><td>{{ insurance.policy__owner__first_name }} {{ insurance.poliza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.policy__comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.policy__recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.policy__owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_poliza track by $index\" ng-if=\"insurance.policy__owner__first_name && insurance.policy__owner__count\"><td>{{ insurance.policy__owner__first_name }} {{ insurance.policy__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.policy__comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.policy__recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.policy__owner__count }}</td></tr><tr ng-if=\"grupos_result.pesos_fianza || grupos_result.dolares_fianza\"></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F;\"><b>Fianzas</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos_fianza track by $index\" ng-if=\"insurance.fianza__owner__first_name && insurance.fianza__owner__count\"><td>{{ insurance.fianza__owner__first_name }} {{ insurance.fianza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.fianza__comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.fianza__recibos_fianza__comision_conciliada__sum) }}</td><td>{{ insurance.fianza__owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares_fianza track by $index\" ng-if=\"insurance.fianza__owner__first_name && insurance.fianza__owner__count\"><td>{{ insurance.fianza__owner__first_name }} {{ insurance.fianza__owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.fianza__comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.fianza__recibos_fianza__comision_conciliada__sum) }}</td><td>{{ insurance.fianza__owner__count }}</td></tr></tbody></table><br></div></div></div></div></div><div ng-if=\"showSums\"><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Pesos</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_pesos | currency}}\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Dólares</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_dolares\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">UDI</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_udi\" disabled=\"\"></div></div></div><div class=\"row\" ng-if=\"showButtonExcel && vm.acceso_rep_end\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(1)\">Generar Reporte</button></div></div><style>\n  /* ======== BLOQUE DE FILTROS PROFESIONAL (TONO CLARO) ======== */\n  .filter-card {\n    background-color: #f9fafb; /* tono gris claro */\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    padding: 20px 25px 10px 25px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n    transition: all 0.2s ease-in-out;\n  }\n\n  .filter-card:hover {\n    box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n  }\n\n  .filter-card legend,\n  .filter-card h5 {\n    font-weight: 600;\n    color: #2f4050;\n    font-size: 16px;\n    border-bottom: 1px solid #e5e5e5;\n    padding-bottom: 8px;\n    margin-bottom: 15px;\n  }\n\n  .filter-card label {\n    font-weight: 500;\n    color: #495057;\n    font-size: 13px;\n  }\n\n  .filter-card .form-control,\n  .filter-card select,\n  .filter-card input {\n    border-radius: 4px;\n    border: 1px solid #d1d5db;\n    box-shadow: none;\n    font-size: 13px;\n  }\n\n  .filter-card .form-control:focus {\n    border-color: #1ab394;\n    box-shadow: 0 0 3px rgba(26,179,148,0.4);\n  }\n\n  .filter-card .checkbox label {\n    font-weight: 400;\n    font-size: 13px;\n    color: #333;\n  }\n\n  .filter-card .btn-consultar {\n    background-color: #1ab394;\n    border-color: #18a689;\n    color: white;\n    font-weight: 600;\n    transition: 0.2s;\n  }\n\n  .filter-card .btn-consultar:hover {\n    background-color: #18a689;\n    border-color: #169d81;\n  }\n\n  .datepicker-me .input-group-addon {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-left: 0;\n  }\n\n  .report-highlight {\n    background-color: #eef4f7;\n    border-radius: 6px;\n    padding: 15px;\n    margin-top: 20px;\n    border: 1px solid #dbe3e6;\n  }\n\n  .report-highlight label {\n    color: #2f4050;\n  }\n</style>");
$templateCache.put("app/reportes/reporte.fianzas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reportes Fianzas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Fianzas</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtro Básico</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row report-highlight\"><div class=\"col-sm-6 col-md-3 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport()\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" class=\"form-control text-center\" ng-model=\"vm.form.since\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" class=\"form-control text-center\" ng-model=\"vm.form.until\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Más Filtros</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6 col-md-3 form-group\"><label>Número de Fianza</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.form.num_fianza\"></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Identificador</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.form.identifier\"></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Fiado</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Clasificación</label><autocomplete datasource=\"classification_data\" id=\"classification\" model=\"vm.form.classification\" change=\"vm.matchesClassification(vm.form.classification.val)\"></autocomplete></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-model=\"vm.form.celula\" ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"vm.changecelula(vm.form.celula)\"><option value=\"\">Todo</option></select></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Fiado Programa de Proveedores</label><select class=\"js-example-basic-multiple form-control\" multiple=\"\" ng-model=\"programap\" ng-options=\"pp.label ? pp.label : pp.value.id for pp in contractors_datapp | orderBy:\'label\' track by pp.value.id\" ng-change=\"selectedPP(programap)\"></select></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Afianzadora(s)</label><select class=\"js-example-basic-multiple form-control\" multiple=\"\" ng-model=\"select_provider\" ng-options=\"providers.compania ? providers.compania : providers.id for providers in vm.providers | orderBy:\'compania\' track by providers.url\" ng-change=\"selectProv(select_provider)\"></select></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" multiple=\"\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"159\">Administrativas</option><option value=\"160\">Crédito</option><option value=\"161\">Fideicomiso</option><option value=\"157\">Fidelidad</option><option value=\"158\">Judicial</option></select></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" multiple=\"\" ng-model=\"select_sramo\" ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" multiple=\"\" ng-model=\"select_user\" ng-options=\"users.username for users in vm.users | orderBy:\'username\' track by users.url\" ng-change=\"selectUser(select_user)\"></select></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Clave de Agente</label> <input class=\"form-control\" type=\"text\" ng-model=\"vm.form.cve_agente\"></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Estatus</label><select class=\"form-control\" ng-model=\"vm.form.status\" ng-options=\"status.name for status in vm.status track by status.id\" ng-change=\"vm.changeStatus(vm.form.status)\"><option value=\"\">Selecciona un estatus</option></select></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-3 form-group\"><label>Agrupar por:</label><select class=\"form-control\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\">Seleccione</option></select></div><div class=\"col-sm-6 col-md-3 form-group\"><label>Beneficiario:</label><autocomplete datasource=\"autocompleteData\" model=\"vm.form.beneficiario\" change=\"findBeneficiario(vm.form.beneficiario)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"decrptedtoken.org ==\'ancora\'\"><label>Mes de Emisión Producción</label><select class=\"form-control\" ng-options=\"month.value as month.label for month in month.options\" ng-model=\"vm.form.month.month_selected\" ng-init=\"vm.form.month.month_selected = 0\" ng-change=\"changemonth()\"></select></div><div class=\"col-sm-6 col-md-3 form-group\" ng-if=\"decrptedtoken.org ==\'ancora\'\"><label>Año de Emisión Producción</label><select class=\"form-control\" ng-options=\"year for year in years track by year\" ng-model=\"vm.form.year_factura\" ng-change=\"changeyaer(vm.form.year_factura)\"></select></div></div><div class=\"row\"><div class=\"col-xs-12 form-group text-center\"><div class=\"radio-inline\" ng-if=\"vm.acceso_ver_ot\"><label><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"true\"> Incluir OTs</label></div><div class=\"radio-inline\"><label><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"false\"> No incluir OTs</label></div></div></div></div></div><div class=\"col-xs-12 col-lg-6 col-sm-6 col-md-6 text-align-center form-group\"><button class=\"btn btn-success pull-right ladda-buttonC\" ng-click=\"vm.Generar(1,1,1);vm.EndososLista(1,1,1)\">Consultar</button></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Fianzas</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result || grupos_result.length == 0\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(1, $event)\" ng-mouseout=\"finalColumn(1, $event)\">FIADO <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(2, vm.policy_nump_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(2, $event)\" ng-mouseout=\"finalColumn(2, $event)\">NO. FIANZA <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_nump_asc == 1, \'fa fa-sort-asc\': vm.policy_nump_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(3, vm.policy_aseg_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(3, $event)\" ng-mouseout=\"finalColumn(3, $event)\">AFIANZADORA <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_aseg_asc == 1, \'fa fa-sort-asc\': vm.policy_aseg_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(4, vm.policy_ramo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(4, $event)\" ng-mouseout=\"finalColumn(4, $event)\">RAMO <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ramo_asc == 1, \'fa fa-sort-asc\': vm.policy_ramo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(5, vm.policy_subramo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(5, $event)\" ng-mouseout=\"finalColumn(5, $event)\">SUBRAMO <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_subramo_asc == 1, \'fa fa-sort-asc\': vm.policy_subramo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(20, vm.policy_esemision_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(20, $event)\" ng-mouseout=\"finalColumn(20, $event)\">ESTATUS EMISIÓN <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_esemision_asc == 1, \'fa fa-sort-asc\': vm.policy_esemision_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(6, vm.policy_pneta_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(6, $event)\" ng-mouseout=\"finalColumn(6, $event)\">PRIMA NETA <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_pneta_asc == 1, \'fa fa-sort-asc\': vm.policy_pneta_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(7, vm.policy_rpf_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(7, $event)\" ng-mouseout=\"finalColumn(7, $event)\">GASTOS EXPEDICIÓN <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_rpf_asc == 1, \'fa fa-sort-asc\': vm.policy_rpf_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(8, vm.policy_der_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(8, $event)\" ng-mouseout=\"finalColumn(8, $event)\">DERECHO <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_der_asc == 1, \'fa fa-sort-asc\': vm.policy_der_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(9, vm.policy_iva_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(9, $event)\" ng-mouseout=\"finalColumn(9, $event)\">IVA <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_iva_asc == 1, \'fa fa-sort-asc\': vm.policy_iva_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(10, vm.policy_ptotal_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(10, $event)\" ng-mouseout=\"finalColumn(10, $event)\">PRIMA TOTAL <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ptotal_asc == 1, \'fa fa-sort-asc\': vm.policy_ptotal_asc == 2}\"></span></th><th ng-if=\"vm.permiso_comisiones\" drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(11, vm.policy_comision_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(11, $event)\" ng-mouseout=\"finalColumn(11, $event)\">COMISIÓN <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_comision_asc == 1, \'fa fa-sort-asc\': vm.policy_comision_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(12, vm.policy_estatus_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(12, $event)\" ng-mouseout=\"finalColumn(12, $event)\">ESTATUS <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_estatus_asc == 1, \'fa fa-sort-asc\': vm.policy_estatus_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(13, vm.policy_created_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(13, $event)\" ng-mouseout=\"finalColumn(13, $event)\">FECHA CREACIÓN <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_created_asc == 1, \'fa fa-sort-asc\': vm.policy_created_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(14, vm.policy_tipo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(14, $event)\" ng-mouseout=\"finalColumn(14, $event)\">TIPO FIANZA <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_tipo_asc == 1, \'fa fa-sort-asc\': vm.policy_tipo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(15, vm.policy_vig_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(15, $event)\" ng-mouseout=\"finalColumn(15, $event)\">Vigencia <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_vig_asc == 1, \'fa fa-sort-asc\': vm.policy_vig_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(16, vm.policy_folio_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(16, $event)\" ng-mouseout=\"finalColumn(16, $event)\">FOLIO <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_folio_asc == 1, \'fa fa-sort-asc\': vm.policy_folio_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(17, vm.policy_tarifa_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(17, $event)\" ng-mouseout=\"finalColumn(17, $event)\">% TARIFA AFIANZADA <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_tarifa_asc == 1, \'fa fa-sort-asc\': vm.policy_tarifa_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(18, vm.policy_owner_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(20, $event)\" ng-mouseout=\"finalColumn(20, $event)\">CREADOR POR <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_owner_asc == 1, \'fa fa-sort-asc\': vm.policy_owner_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(19, vm.policy_clave_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(19, $event)\" ng-mouseout=\"finalColumn(19, $event)\">CLAVE AFIANZADORA <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_clave_asc == 1, \'fa fa-sort-asc\': vm.policy_clave_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(21, vm.policy_peinicio_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(21, $event)\" ng-mouseout=\"finalColumn(21, $event)\">PLAZO DEL DOCUMENTO FUENTE <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_peinicio_asc == 1, \'fa fa-sort-asc\': vm.policy_peinicio_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(24, vm.policy_value_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(24, $event)\" ng-mouseout=\"finalColumn(24, $event)\">MONTO TOTAL <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_value_asc == 1, \'fa fa-sort-asc\': vm.policy_value_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(26, vm.policy_perc_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(26, $event)\" ng-mouseout=\"finalColumn(26, $event)\">% GARANTÍA <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_perc_asc == 1, \'fa fa-sort-asc\': vm.policy_perc_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(27, vm.policy_num_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(27, $event)\" ng-mouseout=\"finalColumn(27, $event)\">NÚM CONTRATO <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_num_asc == 1, \'fa fa-sort-asc\': vm.policy_num_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(28, vm.policy_proyecto_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(28, $event)\" ng-mouseout=\"finalColumn(28, $event)\">PROYECTO <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_proyecto_asc == 1, \'fa fa-sort-asc\': vm.policy_proyecto_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(30, vm.policy_monto_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(30, $event)\" ng-mouseout=\"finalColumn(30, $event)\">MONTO AFIANZADO <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_monto_asc == 1, \'fa fa-sort-asc\': vm.policy_monto_asc == 2}\"></span></th><th>Clasificación</th><th>Célula</th><th>Monto del contrato con IVA</th><th>NOMBRE BENEFICIARIO</th><th>RFC BENEFICIARIO</th><th>Bono Afianzadora</th><th>Fecha Bono</th><th>PROGRAMA DE PROVEEDORES</th><th>(NOMBRE) PROGRAMA DE PROVEEDORES</th><th>MONEDA</th><th>FECHA DE EMISION</th><th>MONTO DE CANCELACION</th><th>FECHA DE CANCELACION</th><th>FECHA DE PAGO COMISIÓN</th><th>MAQUILA</th><th>FECHA MAQUILA</th><th>TIPO CAMBIO (CAPTURA)</th><th>FECHA EMISIÓN FACTURA</th><th>MES EMISIÓN PRODUCCIÓN</th><th>AÑO EMISIÓN PRODUCCIÓN</th><th>FOLIO FACTURA</th><th>ENDOSOS TOTALES</th></tr></thead><tbody><tr ng-repeat=\"insurance in insurances track by $index\" ng-click=\"vm.goToInfo(insurance)\" on-finish-render=\"ngRepeatFinished\"><td>{{ insurance.contractor.full_name}}</td><td>{{ insurance.poliza_number }}</td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.ramo }}</td><td>{{ insurance.subramo }}</td><td>{{ statusEmision(insurance.emision_status) }}</td><td align=\"right\">{{ insurance.p_neta | currency }}</td><td align=\"right\">{{ insurance.rpf | currency }}</td><td align=\"right\">{{ insurance.derecho | currency }}</td><td align=\"right\">{{ insurance.iva | currency }}</td><td align=\"right\">{{ insurance.p_total | currency }}</td><td ng-if=\"vm.permiso_comisiones\" align=\"right\">{{ insurance.comision | currency }}</td><td>{{ status(insurance.status) }}</td><td>{{ insurance.created_at | date: \'dd/MM/yyyy\'}}</td><td>{{insurance.fianza_type}}</td><td><span ng-if=\"insurance.start_of_validity != \' \'\">{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</span></td><td>{{ insurance.folio }}</td><td>{{ insurance.tarifa_afianzada }}</td><td>{{ insurance.owner }}</td><td>{{ insurance.clave.clave }} - {{insurance.clave.name}}</td><td>{{ insurance.contract_poliza.start | date: \'dd/MM/yyyy\'}} - {{ insurance.contract_poliza.end | date: \'dd/MM/yyyy\'}}</td><td align=\"right\">{{ insurance.contract_poliza.amount | currency }}</td><td align=\"right\">{{ insurance.contract_poliza.guarantee_percentage}}</td><td align=\"right\">{{ insurance.contract_poliza.number }}</td><td align=\"right\">{{ insurance.project_name }}</td><td align=\"right\">{{ insurance.monto_afianzado | currency }}</td><td></td><td></td><td></td><td></td><td></td><td align=\"right\">{{ insurance.bono_variable | currency }}</td><td>{{ insurance.date_bono | date: \'dd/MM/yyyy\'}}</td><td></td><td></td><td></td><td></td><td>{{ insurance.monto_cancelacion | currency}}</td><td>{{ insurance.fecha_cancelacion | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.fecha_pago_comision | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.maquila | currency}}</td><td>{{ insurance.date_maquila | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.exchange_rate | currency}}</td><td>{{ insurance.date_emision_factura | date: \'dd/MM/yyyy\'}}</td><td>{{ monthEmision(insurance.month_factura)}}</td><td>{{ insurance.year_factura}}</td><td>{{ insurance.folio_factura}}</td><td>{{ insurance.totalendosos}}</td></tr></tbody></table><div ng-if=\"vm.show_pag_policy\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in insurances track by $index\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}: {{ insurance.fianza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\" ng-repeat=\"insurance in insurances track by $index\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.fianza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.document_type }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p ng-if=\"insurance.contractor\">{{ insurance.contractor }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ insurance.afianzadora}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ insurance.ramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[10] }}</label><p>{{ insurance.folio}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[11] }}</label><p>{{ insurance.f_currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[12] }}</label><p>{{ insurance.p_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[13] }}</label><p>{{ insurance.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[14] }}</label><p>{{ insurance.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[15] }}</label><p>{{ insurance.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[16] }}</label><p>{{ insurance.p_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[17] }}</label><p>{{ insurance.comision | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[18] }}</label><p>{{ insurance.observations }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[19] }}</label><p>{{ insurance.owner }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[20] }}</label><p>{{insurance.clave.clave}} - {{insurance.clave.name}}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_policy\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0)\"><div class=\"row\" style=\"display: none;\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Afianzadora</td><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td ng-if=\"vm.form.group_by.id == 6\">Fecha de Creación</td><td ng-if=\"vm.form.group_by.id == 6\">Número de póliza</td><td>Prima Neta</td><td>Prima Total</td><td>Comisión</td><td>Registros</td><tbody><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 1\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.afianzadora__id__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 2\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 3\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Fisicos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.contractor__group__group_name\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Morales</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.contractor__group__group_name\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.vendor__count\"><td>{{ insurance.vendor__first_name }} {{ insurance.vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.vendor__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 7 && insurance.owner__count\"><td>{{ insurance.owner__first_name }} {{ insurance.owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.owner__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 6\"><td>{{ insurance.created_at | date: \'medium\'}}</td><td>{{ insurance.fianza_number}}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.created_at__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 1\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Afianzadora</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.afianzadora__compania && insurance.afianzadora__id__count\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.afianzadora__id__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.afianzadora__compania && insurance.afianzadora__id__count\"><td>{{ insurance.afianzadora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.afianzadora__id__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 2\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.ramo__ramo_name && insurance.ramo__count\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.ramo__ramo_name && insurance.ramo__count\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 3\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.subramo__subramo_name && insurance.subramo__count\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.subramo__subramo_name && insurance.subramo__count\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 4\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.naturals_pesos || grupos_result.naturals_dolares\"><b>Contratantes Físicos</b></td></tr><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_pesos track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_dolares track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td>${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr><td colspan=\"5\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.juridicals_pesos || grupos_result.juridicals_dolares\"><b>Contratantes Morales</b></td></tr><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_pesos track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_dolares track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 5\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 5\">Referenciador</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.vendor__first_name && insurance.vendor__count\"><td>{{ insurance.vendor__first_name }} {{ insurance.vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.vendor__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.vendor__first_name && insurance.vendor__count\"><td>{{ insurance.vendor__first_name }} {{ insurance.vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.vendor__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 7\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 7\">Usuario</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.owner__first_name && insurance.owner__count\"><td>{{ insurance.owner__first_name }} {{ insurance.owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.owner__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.owner__first_name && insurance.owner__count\"><td>{{ insurance.owner__first_name }} {{ insurance.owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.owner__count }}</td></tr></tbody></table><br></div></div></div></div><div class=\"ibox-title\" ng-if=\"vm.form.dates_sel.id ==4\"><h5>Endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"vm.form.dates_sel.id ==4\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Folio Interno</th><th>No.Endoso</th><th>No.Fianza</th><th>Vigencia Inicio</th><th>Vigencia Fin</th><th>Estatus</th><th>Prima Neta</th><th>Prima Total</th><th>Creación</th></tr></thead><tbody><tr ng-repeat=\"listend in endosos track by $index\" ng-click=\"vm.irAlEndoso(listend)\" on-finish-render=\"ngRepeatFinished\"><td>{{ listend.internal_number}}</td><td>{{ listend.number_endorsement }}</td><td>{{ listend.policy.poliza_number }}</td><td>{{ listend.init_date | date: \'dd/MM/yyyy\'}}</td><td>{{ listend.end_date | date: \'dd/MM/yyyy\'}}</td><td>{{ statusEndoso(listend.status) }}</td><td align=\"right\">{{ listend.p_neta | currency }}</td><td align=\"right\">{{ listend.p_total | currency }}</td><td>{{ listend.created_at | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table><div ng-if=\"vm.show_pag_endosos\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPagesE()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPagesE | slice:start:end\" ng-class=\"{\'active\': page === actual_pageE}\" ng-click=\"selectPageE(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPagesE()\" ng-if=\"totalPagesE.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPageE()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div></div><div class=\"row\" ng-if=\"showSums\"><div class=\"col-xs-12 col-sm-9 pull-right\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Total Prima Neta:</label> <input class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.p_neta_total\" format-currency=\"\" disabled=\"\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Total Prima Total:</label> <input class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.p_total_total\" format-currency=\"\" disabled=\"\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total\" format-currency=\"\" disabled=\"\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total\" format-currency=\"\" disabled=\"\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Fianzas Vigentes:</label> <input class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.monto_fianzas_vigentes\" format-currency=\"\" disabled=\"\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Fianzas Canceladas:</label> <input class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.monto_fianzas_canceladas\" format-currency=\"\" disabled=\"\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Diferencia Vigentes/Canceladas:</label> <input class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.total_fv_fc\" format-currency=\"\" disabled=\"\"></div></div></div><div class=\"row\" ng-if=\"showButtonExcel\"><br><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(1)\">Generar Reporte</button></div><div class=\"col-xs-12 col-sm-6 form-group\"><input type=\"checkbox\" ng-model=\"addBitacoraEndoso\" ng-click=\"addBitEndoso(addBitacoraEndoso)\" class=\"checkbox\" ng-value=\"addBitacoraEndoso\">Incluir Bitácora/Historial de Endosos</div></div><style>\n  /* ======== BLOQUE DE FILTROS PROFESIONAL (TONO CLARO) ======== */\n  .filter-card {\n    background-color: #f9fafb; /* tono gris claro */\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    padding: 20px 25px 10px 25px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n    transition: all 0.2s ease-in-out;\n  }\n\n  .filter-card:hover {\n    box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n  }\n\n  .filter-card legend,\n  .filter-card h5 {\n    font-weight: 600;\n    color: #2f4050;\n    font-size: 16px;\n    border-bottom: 1px solid #e5e5e5;\n    padding-bottom: 8px;\n    margin-bottom: 15px;\n  }\n\n  .filter-card label {\n    font-weight: 500;\n    color: #495057;\n    font-size: 13px;\n  }\n\n  .filter-card .form-control,\n  .filter-card select,\n  .filter-card input {\n    border-radius: 4px;\n    border: 1px solid #d1d5db;\n    box-shadow: none;\n    font-size: 13px;\n  }\n\n  .filter-card .form-control:focus {\n    border-color: #1ab394;\n    box-shadow: 0 0 3px rgba(26,179,148,0.4);\n  }\n\n  .filter-card .checkbox label {\n    font-weight: 400;\n    font-size: 13px;\n    color: #333;\n  }\n\n  .filter-card .btn-consultar {\n    background-color: #1ab394;\n    border-color: #18a689;\n    color: white;\n    font-weight: 600;\n    transition: 0.2s;\n  }\n\n  .filter-card .btn-consultar:hover {\n    background-color: #18a689;\n    border-color: #169d81;\n  }\n\n  .datepicker-me .input-group-addon {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-left: 0;\n  }\n\n  .report-highlight {\n    background-color: #eef4f7;\n    border-radius: 6px;\n    padding: 15px;\n    margin-top: 20px;\n    border: 1px solid #dbe3e6;\n  }\n\n  .report-highlight label {\n    color: #2f4050;\n  }\n</style>");
$templateCache.put("app/reportes/reporte.fianzasben.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reportes Fianzas Beneficiarios</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Fianzas -Beneficiarios</strong></li></ol></div></div><br><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Fianzas Beneficiarios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Nombre</th><th>RFC</th><th>Teléfono</th><th>Correo Electrónico</th></tr></thead><tbody><tr ng-repeat=\"insurance in insurances track by $index\" on-finish-render=\"ngRepeatFinished\"><td><span ng-if=\"insurance.first_name\">{{ insurance.first_name}} {{ insurance.last_name}} {{ insurance.second_last_name}}</span> <span ng-if=\"insurance.j_name\">{{ insurance.j_name}}</span></td><td>{{ insurance.rfc }}</td><td>{{ insurance.phone_number }}</td><td>{{ insurance.email }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_policy\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div></div></div></div><div class=\"row\" ng-if=\"showButtonExcel\"><br><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(1)\">Generar Reporte</button></div></div>");
$templateCache.put("app/reportes/reporte.log.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reporte Log</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Log</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtro Básico</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row report-highlight\"><div class=\"col-sm-6 col-md-6 col-lg-6 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-sm-6 col-md-6 col-lg-6 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Más Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6 col-md-4 col-lg-4 form-group\"><label>Usuario:</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"users.first_name + \' \' + users.last_name for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div><div class=\"col-sm-6 col-md-4 col-lg-4 form-group\"><label>Modelo:</label><select class=\"form-control\" ng-model=\"vm.form.model\" ng-options=\"model.model for model in vm.models | orderBy: \'model\' track by model.id\" ng-change=\"vm.changeModel(vm.form.model)\"><option value=\"\" disabled=\"\">Selecciona un modelo</option></select></div><div class=\"col-sm-6 col-md-4 col-lg-4 form-group\"><label>Agrupar por:</label><select class=\"form-control\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\">Seleccione</option></select></div></div></div></div><div class=\"col-xs-12 text-align-center\"><button class=\"btn btn-success ladda-button\" ng-click=\"getLogs(1,1)\">Consultar</button></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Transacciones</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"(!grupos_result || grupos_result.length == 0)\"><div class=\"row\" ng-if=\"logs\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Usuario</th><th>Acción</th><th>Modelo</th><th>Fecha creación</th></tr></thead><tbody><tr ng-repeat=\"log in logs track by $index\"><td>{{log.user}}</td><td>{{log.identifier}}</td><td>{{log.model}}</td><td>{{log.created_at | date:\"dd/MM/yyyy - HH:mm:ss\" }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_log && logs.length > 0\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div><button ng-if=\"logs.length > 0\" ng-click=\"export(1)\" class=\"btn btn-primary pull-right ladda-button_excel\"><i class=\"fa fa-download\"></i> Reporte en excel</button></div></div><div class=\"ibox-content\" ng-if=\"grupos_result.length > 0 && vm.form.group_by.id == 1\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td>Usuarios</td><td>Registros</td><tbody><tr ng-repeat=\"lgb in grupos_result track by $index\" ng-if=\"lgb.user__first_name && lgb.user__id__count\"><td>{{ lgb.user__first_name }} {{ lgb.user__last_name }}</td><td>{{ lgb.user__id__count }}</td></tr></tbody></table><br></div></div><button ng-if=\"grupos_result.length > 0\" ng-click=\"export(2)\" class=\"btn btn-primary pull-right ladda-button_excel\"><i class=\"fa fa-download\"></i> Reporte en excel *</button></div></div><script type=\"text/javascript\">  \n  $(window).load(function() { $(\"#state\").select2(); });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script><style>\n  .report-highlight {\n    background-color: #eef4f7;\n    border-radius: 6px;\n    padding: 15px;\n    margin-top: 20px;\n    border: 1px solid #dbe3e6;\n  }\n</style>");
$templateCache.put("app/reportes/reporte.otsendosos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reportes OTs y Endosos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>OTs / Endosos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-2 form-group\"><label>Identificador</label> <input class=\"form-control\" type=\"text\" name=\"identificador\" ng-model=\"vm.form.identifier\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"users.username for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Clave de Agente</label> <input class=\"form-control\" type=\"text\" name=\"agente\" ng-model=\"vm.form.cve_agente\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport()\"><option value=\"\">Selecciona una opción</option></select></div><div align=\"center\" ng-if=\"vigency || created_at\" class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><br></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Opciones</legend><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': ot_rep == \'1\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"1\"> Solo OTs</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': ot_rep == \'2\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"2\"> Solo Endosos</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': ot_rep == \'3\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"3\"> OTs / Endosos</label></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right ladda-buttonC\" ng-click=\"vm.Generar(1,1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>OTs / Endosos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"insurances.length > 0\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Tipo</th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(3, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(3, $event)\" ng-mouseout=\"finalColumn(3, $event)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(24, vm.policy_contgroup_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(24, $event)\" ng-mouseout=\"finalColumn(24, $event)\" ng-model=\"vm.table.headers[2]\">Grupo <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_contgroup_asc == 1, \'fa fa-sort-asc\': vm.policy_contgroup_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_nump_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(1, $event)\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_nump_asc == 1, \'fa fa-sort-asc\': vm.policy_nump_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(4, vm.policy_aseg_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(4, $event)\" ng-mouseout=\"finalColumn(4, $event)\" ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_aseg_asc == 1, \'fa fa-sort-asc\': vm.policy_aseg_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(5, vm.policy_ramo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(5, $event)\" ng-mouseout=\"finalColumn(5, $event)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ramo_asc == 1, \'fa fa-sort-asc\': vm.policy_ramo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(6, vm.policy_subramo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(6, $event)\" ng-mouseout=\"finalColumn(6, $event)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_subramo_asc == 1, \'fa fa-sort-asc\': vm.policy_subramo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(7, vm.policy_pack_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(7, $event)\" ng-mouseout=\"finalColumn(7, $event)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_pack_asc == 1, \'fa fa-sort-asc\': vm.policy_pack_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(13, vm.policy_pneta_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(13, $event)\" ng-mouseout=\"finalColumn(13, $event)\" ng-model=\"vm.table.headers[12]\">{{vm.table.headers[12]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_pneta_asc == 1, \'fa fa-sort-asc\': vm.policy_pneta_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(14, vm.policy_rpf_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(14, $event)\" ng-mouseout=\"finalColumn(14, $event)\" ng-model=\"vm.table.headers[13]\">{{vm.table.headers[13]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_rpf_asc == 1, \'fa fa-sort-asc\': vm.policy_rpf_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(15, vm.policy_der_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(15, $event)\" ng-mouseout=\"finalColumn(15, $event)\" ng-model=\"vm.table.headers[14]\">{{vm.table.headers[14]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_der_asc == 1, \'fa fa-sort-asc\': vm.policy_der_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(16, vm.policy_iva_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(16, $event)\" ng-mouseout=\"finalColumn(16, $event)\" ng-model=\"vm.table.headers[15]\">{{vm.table.headers[15]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_iva_asc == 1, \'fa fa-sort-asc\': vm.policy_iva_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(17, vm.policy_ptotal_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(17, $event)\" ng-mouseout=\"finalColumn(17, $event)\" ng-model=\"vm.table.headers[16]\">{{vm.table.headers[16]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ptotal_asc == 1, \'fa fa-sort-asc\': vm.policy_ptotal_asc == 2}\"></span></th><th ng-if=\"vm.permiso_comisiones\" drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(18, vm.policy_com_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(18, $event)\" ng-mouseout=\"finalColumn(18, $event)\" ng-model=\"vm.table.headers[17]\">{{vm.table.headers[17]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_com_asc == 1, \'fa fa-sort-asc\': vm.policy_com_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(8, vm.policy_fpago_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(8, $event)\" ng-mouseout=\"finalColumn(8, $event)\" ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_fpago_asc == 1, \'fa fa-sort-asc\': vm.policy_fpago_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(22, vm.policy_ase_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(22, $event)\" ng-mouseout=\"finalColumn(22, $event)\" ng-model=\"vm.table.headers[21]\">{{vm.table.headers[21]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(9, vm.policy_status_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(9, $event)\" ng-mouseout=\"finalColumn(9, $event)\" ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_status_asc == 1, \'fa fa-sort-asc\': vm.policy_status_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(10, vm.policy_vig_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(10, $event)\" ng-mouseout=\"finalColumn(10, $event)\" ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_vig_asc == 1, \'fa fa-sort-asc\': vm.policy_vig_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(11, vm.policy_folio_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(11, $event)\" ng-mouseout=\"finalColumn(11, $event)\" ng-model=\"vm.table.headers[10]\">{{vm.table.headers[10]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_folio_asc == 1, \'fa fa-sort-asc\': vm.policy_folio_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(12, vm.policy_moneda_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(12, $event)\" ng-mouseout=\"finalColumn(12, $event)\" ng-model=\"vm.table.headers[11]\">{{vm.table.headers[11]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_moneda_asc == 1, \'fa fa-sort-asc\': vm.policy_moneda_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(23, vm.policy_created_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(23, $event)\" ng-mouseout=\"finalColumn(23, $event)\" ng-model=\"vm.table.headers[22]\">{{vm.table.headers[22]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_created_asc == 1, \'fa fa-sort-asc\': vm.policy_created_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(19, vm.policy_obs_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(19, $event)\" ng-mouseout=\"finalColumn(19, $event)\" ng-model=\"vm.table.headers[18]\">{{vm.table.headers[18]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_obs_asc == 1, \'fa fa-sort-asc\': vm.policy_obs_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(20, vm.policy_owner_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(20, $event)\" ng-mouseout=\"finalColumn(20, $event)\" ng-model=\"vm.table.headers[19]\">{{vm.table.headers[19]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_owner_asc == 1, \'fa fa-sort-asc\': vm.policy_owner_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(21, vm.policy_clave_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(21, $event)\" ng-mouseout=\"finalColumn(21, $event)\" ng-model=\"vm.table.headers[20]\">{{vm.table.headers[20]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_clave_asc == 1, \'fa fa-sort-asc\': vm.policy_clave_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-model=\"vm.table.headers[23]\">{{vm.table.headers[23]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" ng-mouseout=\"finalColumn(25, $event)\" ng-model=\"vm.table.headers[24]\">{{vm.table.headers[24]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" ng-mouseout=\"finalColumn(26, $event)\" ng-model=\"vm.table.headers[25]\">{{vm.table.headers[25]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" ng-mouseout=\"finalColumn(27, $event)\" ng-model=\"vm.table.headers[26]\">{{vm.table.headers[26]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" ng-mouseout=\"finalColumn(28, $event)\" ng-model=\"vm.table.headers[27]\">{{vm.table.headers[27]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" ng-mouseout=\"finalColumn(28, $event)\" ng-model=\"vm.table.headers[28]\">{{vm.table.headers[28]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_dir_asc == 1, \'fa fa-sort-asc\': vm.policy_dir_asc == 2}\"></span></th></tr></thead><tbody><tr ng-repeat=\"insurance in insurances track by $index\" ng-click=\"vm.goToInfo(insurance)\"><td><span ng-if=\"insurance.document_type == 1 && (insurance.status != 1 && insurances.status != 2)\">Póliza</span> <span ng-if=\"insurance.document_type == 1 && (insurance.status == 1 || insurances.status == 2)\">OT</span> <span ng-if=\"insurance.document_type == 3\">Colectividad</span></td><td>{{ insurance.contractor.full_name }}</td><td>{{ insurance.contractor.group }}</td><td>{{ insurance.poliza_number }}</td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.ramo }}</td><td>{{ insurance.subramo }}</td><td>{{ insurance.paquete }}</td><td align=\"right\">{{ insurance.p_neta | currency }}</td><td align=\"right\">{{ insurance.rpf | currency }}</td><td align=\"right\">{{ insurance.derecho | currency }}</td><td align=\"right\">{{ insurance.iva | currency }}</td><td align=\"right\">{{ insurance.p_total | currency }}</td><td ng-if=\"vm.permiso_comisiones\" align=\"right\">{{ insurance.comision | currency }}</td><td>{{ fpago(insurance.forma_de_pago )}}</td><td>{{ insurance.accidents_policy[0].personal.full_name }} {{ insurance.life_policy[0].personal.full_name }} {{ insurance.automobiles_policy[0].serial }}</td><td><span ng-if=\"insurance.status != \' \'\" status=\"{{insurance.status}}\"></span> <span ng-if=\"insurance.status == \' \'\"></span></td><td><span ng-if=\"insurance.start_of_validity != \'\'\">{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"insurance.start_of_validity != \'\'\"></span></td><td>{{ insurance.folio }}</td><td>{{ fmoneda(insurance.f_currency) }}</td><td>{{ insurance.created_at | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.observations }}</td><td>{{ insurance.owner }}</td><td>{{ insurance.clave.clave }} - {{ insurance.clave.name }}</td><td>{{ insurance.automobiles_policy[0].brand }} - {{ insurance.automobiles_policy[0].model }} - {{ insurance.automobiles_policy[0].year }}</td><td>{{insurance.automobiles_policy[0].version}}</td><td>{{insurance.automobiles_policy[0].license_plates}}</td><td>{{insurance.automobiles_policy[0].engine}}</td><td>{{insurance.automobiles_policy[0].adjustment}}</td><td>{{insurance.address.administrative_area_level_2}}, {{insurance.address.administrative_area_level_1}}. <span ng-if=\"insurance.address.postal_code\">C.P.: {{insurance.address.postal_code}}</span></td></tr></tbody></table><div ng-if=\"vm.show_pag_policy\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in insurances track by $index\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}: {{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\" ng-repeat=\"insurance in insurances track by $index\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.document_type }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p ng-if=\"insurance.natural\">{{ insurance.natural }}</p><p ng-if=\"!insurance.natural\">{{ insurance.juridical }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ insurance.aseguradora}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ insurance.ramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ insurance.paquete }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ insurance.forma_de_pago }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[10] }}</label><p>{{ insurance.folio}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[11] }}</label><p>{{ insurance.f_currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[12] }}</label><p>{{ insurance.p_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[13] }}</label><p>{{ insurance.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[14] }}</label><p>{{ insurance.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[15] }}</label><p>{{ insurance.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[16] }}</label><p>{{ insurance.p_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[17] }}</label><p>{{ insurance.comision | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[18] }}</label><p>{{ insurance.observations }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[19] }}</label><p>{{ insurance.owner }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[20] }}</label><p>{{insurance.clave}}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_policy\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div></div></div><br><br><div class=\"ibox-title\" ng-if=\"endosos.length > 0\"><h5>Endosos</h5><br></div><div class=\"row\" ng-if=\"endosos.length > 0\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Tipo</th><th>Folio Interno</th><th>Contratante</th><th>Número Póliza</th><th>Ramo</th><th>Aseguradora</th><th>Estatus</th><th>Creación</th><th>Antigüedad</th><th>Acciones</th></tr></thead><tbody><tr ng-click=\"goToEndorsement(endoso)\" ng-repeat=\"endoso in endosos track by $index\"><td><span>Endoso</span></td><td><span>{{endoso.internal_number}} Tipo: {{endoso.endorsement_type}}</span></td><td>{{ endoso.policy.contractor }}</td><td>{{ endoso.policy.poliza_number }} {{ endoso.fianza.fianza_number }}</td><td>{{endoso.policy.subramo}} {{endoso.fianza.subramo}}</td><td>{{ endoso.policy.aseguradora }} {{ endoso.fianza.afianzadora }}</td><td ng-if=\"endoso.status == 1\">Pendiente</td><td ng-if=\"endoso.status == 5\">En trámite</td><td>{{ endoso.created_at | date:\"dd/MM/yyyy - HH:mm\" }}</td><td ng-if=\"endoso.antiguedad > 0\">{{ endoso.antiguedad }} días</td><td ng-if=\"!(endoso.antiguedad > 0)\">0 días</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); main.showBinnacle_endoso(endoso)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a><tasks click=\"addtask()\" type=\"2\" model=\"endoso.internal_number\" associated=\"endoso.id\"></tasks></td></tr></tbody></table><br></div></div><button ng-click=\"exportDataExcel(1)\" class=\"btn btn-primary ladda-button\">Generar Reporte</button></div></div>");
$templateCache.put("app/reportes/reporte.polizas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reportes Pólizas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Pólizas</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtro Básico</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content report-highlight\"><div class=\"row text-align-center\"><div class=\"row\"><div class=\"col-sm-6 col-md-4 col-lg-4 form-group\"><label align=\"center\">Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport()\"><option value=\"\">Selecciona una opción</option></select><span class=\"color-red\" ng-if=\"vm.form.dates_sel.id == 1\">**Este reporte no incluye pólizas migradas o renovadas masivamente por Miurabox</span><div class=\"help-block\" ng-if=\"vm.form.dates_sel.id == 3\" style=\"margin-top:6px;\"><strong>Con cobertura:</strong> pólizas con vigencia activa al día de hoy (excepto canceladas).</div></div><div class=\"col-sm-6 col-md-8 col-lg-8 form-group\" ng-if=\"vm.form.dates_sel.id==3\" style=\"display:flex; align-items:center; justify-content:flex-end; min-height:74px;\"><label class=\"checkbox-inline\" style=\"font-weight:600; margin:0;\"><input type=\"checkbox\" ng-model=\"vm.form.include_por_iniciar\" ng-change=\"changeReport(vm.form.include_por_iniciar)\"> Incluir pólizas “por iniciar”</label> <span style=\"margin-left:5px; color:#555;\">(Es decir, pólizas cuya vigencia comenzará en una fecha futura)</span></div></div><div align=\"center\" ng-if=\"vigency || created_at\"><div class=\"col-sm-6 col-md-4 col-lg-4 form-group form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-4 form-group form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Más Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6 col-md-3 col-lg-6 form-group\"><label>No.Póliza</label> <input class=\"form-control\" type=\"text\" name=\"poliza\" ng-model=\"vm.form.num_poliza\"></div><div class=\"col-sm-6 col-md-3 col-lg-6 form-group\"><label>Identificador</label> <input class=\"form-control\" type=\"text\" name=\"identificador\" ng-model=\"vm.form.identifier\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"subgroups.length >0\"><label>SubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subgroup\" data-ng-options=\"subgroup.group_name for subgroup in subgroups track by subgroup.url\" ng-change=\"vm.changeSubgroup(vm.form.subgroup)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"subsubgroups.length >0\"><label>SubsubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subsubgroup\" data-ng-options=\"subsubgroup.group_name for subsubgroup in subsubgroups track by subsubgroup.url\" ng-change=\"vm.changeSubsubgroup(vm.form.subsubgroup)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-model=\"vm.form.businesLine\" data-ng-options=\"businesLine.name for businesLine in vm.businesLine track by businesLine.id\" ng-change=\"vm.changeBLine(vm.form.businesLine)\" required=\"\"><option value=\"\">Todas las líneas</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-model=\"vm.form.celula\" data-ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"vm.changecelula(vm.form.celula)\"><option value=\"\">Todo</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_agrupacion\"><label>Nivel de Agrupación</label><autocomplete datasource=\"groupinglevels_data\" id=\"groupingleves\" model=\"vm.form.groupinglevel\" change=\"vm.matchesGroupinglevel(vm.form.groupinglevel.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.form.groupinglevel.subgrupos.length >0 && campo_agrupacion\"><label>SubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subgrouping\" data-ng-options=\"subgrouping.description for subgrouping in vm.form.groupinglevel.subgrupos track by subgrouping.url\" ng-change=\"vm.changeSubgrouping(vm.form.subgrouping)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.form.subgrouping.subsubgrupos.length >0 && campo_agrupacion\"><label>SubsubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subsubgrouping\" data-ng-options=\"subsubgroupin.description for subsubgroupin in vm.form.subgrouping.subsubgrupos track by subsubgroupin.url\" ng-change=\"vm.changeSubsubgrouping(vm.form.subsubgrouping)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Clasificación</label><autocomplete datasource=\"classification_data\" id=\"classification\" model=\"vm.form.classification\" change=\"vm.matchesClassification(vm.form.classification.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Estatus</label><select id=\"estadoMultiple\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"\" ng-model=\"select_status\" ng-options=\"status_x.id as status_x.name for status_x in vm.status | orderBy:\'id\'\" ng-change=\"selectEstatus(select_status)\" ng-disabled=\"estadosDisabled\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"users.username for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Clave de Agente</label><autocomplete datasource=\"claves_data\" id=\"claves\" model=\"vm.form.cve_agente\" change=\"vm.matchesClaves(vm.form.cve_agente.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Agrupar por:</label><select class=\"form-control\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Forma de Pago</label><select class=\"form-control\" ng-model=\"vm.form.payment\" ng-options=\"payment.name for payment in vm.payment track by payment.id\" ng-change=\"vm.changePayment(vm.form.payment)\"><option value=\"\">Seleccione una forma de pago</option></select></div><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3 form-group\"><label title=\"Filtro aplicado sobre la póliza\">Sucursal</label><select class=\"form-control\" ng-model=\"vm.form.sucursal\" ng-options=\"sucursal.sucursal_name for sucursal in sucursales.data track by sucursal.id\"><option value=\"\">Seleccione una sucursal</option></select><span ng-if=\"vm.form.sucursal\" class=\"color-red\">Filtro aplicado sobre póliza(s)</span></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Referenciador</label><select class=\"form-control\" ng-model=\"vm.form.vendedor\" data-ng-options=\"vendedor.name for vendedor in vm.vendedores | orderBy: \'name\' track by vendedor.id\" ng-change=\"vm.changeReferenciador(vm.form.vendedor)\"><option value=\"\">Todos los referenciadores</option></select></div><div align=\"center\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Valor dólar</label> <input class=\"form-control\" type=\"text\" name=\"valueDolar\" ng-model=\"vm.form.valueDolar\" ng-change=\"numberFormatDolar(vm.form.valueDolar)\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Valor UDI</label> <input class=\"form-control\" type=\"text\" name=\"valueUdi\" ng-model=\"vm.form.valueUdi\" ng-change=\"numberFormatUdi(vm.form.valueUdi)\"></div></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Origen Póliza:</label><select class=\"form-control\" ng-model=\"vm.form.origin\" ng-options=\"origin.name for origin in origins track by origin.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\">Seleccione un origen</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-5 form-group\"><label>Carátula:</label><br><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.word\" change=\"vm.getCaratulas(vm.word)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getCarSelected(vm.word)\"><span class=\"fa fa-ok\"></span> Seleccionar</button></div></div></div><br></div><div class=\"row\"><div class=\"col-xs-6 form-group\"><legend class=\"legend-title filter-section legend\" align=\"center\">Opciones</legend><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': ot_rep == \'1\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"1\"> Solo OTs</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': ot_rep == \'2\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"2\"> Incluir OTs</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': ot_rep == \'3\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"3\"> No incluir OTs</label></div></div></div><div class=\"col-xs-6 form-group form-group border-left\"><legend class=\"legend-title filter-section legend\" align=\"center\">Tipo</legend><div class=\"col-xs-6 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': renewals == \'1\'}\"><input type=\"radio\" ng-model=\"renewals\" ng-click=\"valueRadioRen(renewals)\" ng-value=\"1\"> Renovadas</label></div></div><div class=\"col-xs-6 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': renewals == \'2\'}\"><input type=\"radio\" ng-model=\"renewals\" ng-click=\"valueRadioRen(renewals)\" ng-value=\"2\"> No renovadas</label></div></div><div class=\"col-xs-6 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': renewals == \'0\'}\"><input type=\"radio\" ng-model=\"renewals\" ng-click=\"valueRadioRen(renewals)\" ng-value=\"0\"> Todas</label></div></div></div></div></div><div class=\"row text-align-center\"><div class=\"col-xs-12\"><button class=\"btn btn-success ladda-buttonC\" ng-click=\"vm.Generar(1,1)\">Consultar</button></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Pólizas</h5><div class=\"contentvideo\"><span>Personaliza tus reportes: selecciona solo los campos que necesitas</span> <a href=\"https://youtu.be/KFd50p5ZVuk\" target=\"_blank\" class=\"vervideo\">▶ Ver video</a></div><div ibox-tools=\"\" class=\"iboxtools\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result || grupos_result.length == 0\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr ng-if=\"filteredKeys.length>0\"><th ng-repeat=\"header in filteredKeys\" ng-click=\"vm.changePolicy(header)\">{{ header }} <span ng-if=\"vm.sortOrders[header] === 1\">▲</span> <span ng-if=\"vm.sortOrders[header] === 2\">▼</span></th></tr></thead><tbody><tr ng-repeat=\"insurance in insurances track by $index\" ng-click=\"vm.goToInfo(insurance)\" on-finish-render=\"ngRepeatFinished\"><td ng-repeat=\"header in filteredKeys\"><span ng-if=\"header ===\'Identificador\'\">{{ insurance.identifier }}</span> <span ng-if=\"header ===\'Contratante\'\"><span ng-if=\"insurance.contractor\">{{ insurance.contractor.full_name }}</span></span> <span ng-if=\"header ===\'Grupo\'\">{{ insurance.contractor.group }}</span> <span ng-if=\"header ===\'No.Póliza\'\">{{ insurance.poliza_number }}</span> <span ng-if=\"header ===\'Proveedor\'\">{{ insurance.aseguradora }}</span> <span ng-if=\"header ===\'Ramo\'\">{{ insurance.ramo }}</span> <span ng-if=\"header ===\'Subramo\'\">{{ insurance.subramo }}</span> <span ng-if=\"header ===\'Paquete\'\">{{ insurance.paquete }}</span> <span ng-if=\"header ===\'Prima Neta\'\">{{ insurance.p_neta | currency }}</span> <span ng-if=\"header ===\'Descuento\'\">{{ insurance.descuento | currency }}</span> <span ng-if=\"header ===\'RPF\'\">{{ insurance.rpf | currency }}</span> <span ng-if=\"header ===\'Derecho\'\">{{ insurance.derecho | currency }}</span> <span ng-if=\"header ===\'IVA\'\">{{ insurance.iva | currency }}</span> <span ng-if=\"header ===\'Prima Total\'\">{{ insurance.p_total | currency }}</span> <span ng-if=\"header ===\'Comisión\'\"><span ng-if=\"vm.permiso_comisiones\">{{ insurance.comision | currency }}</span></span> <span ng-if=\"header ===\'Comisión Porcentaje\'\"><span ng-if=\"vm.permiso_comisiones\" align=\"right\">{{ insurance.comision_percent}}</span></span> <span ng-if=\"header ===\'Forma de Pago\'\">{{ insurance.forma_de_pago }}</span> <span ng-if=\"header ===\'Asegurado/Serial\'\">{{ insurance.accidents_policy[0].personal.full_name }} {{ insurance.life_policy[0].personal.full_name }} {{ insurance.automobiles_policy[0].serial }}</span> <span ng-if=\"header ===\'Tipo\'\"><span ng-if=\"insurance.document_type == \'Póliza\'\">Póliza</span> <span ng-if=\"insurance.document_type == \'OT\'\">OT</span> <span ng-if=\"insurance.document_type == \'Colectividad\'\">Póliza de Grupo</span> <span ng-if=\"insurance.document_type == \'Carátula\'\">Colectividad</span> <span ng-if=\"insurance.document_type == \'Póliza de Carátula\'\">Póliza de Colectividad</span> <span ng-if=\"insurance.document_type == \' \'\"></span> <span ng-if=\"insurance.document_type == 1\">Póliza</span> <span ng-if=\"insurance.document_type == 1 && (insurance.status == 1 || insurance.status==2)\">OT</span> <span ng-if=\"insurance.document_type == 3\">Póliza de Grupo</span> <span ng-if=\"insurance.document_type == 11\">Colectividad</span> <span ng-if=\"insurance.document_type == 12\">Póliza de Colectividad</span></span> <span ng-if=\"header ===\'Estatus\'\"><span ng-if=\"insurance.status != \' \'\"><p>{{ status(insurance.status) }}</p></span></span> <span ng-if=\"header ===\'Inicio Póliza\'\">{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Fin Póliza\'\">{{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Referenciador\'\"><span ng-if=\"vm.permiso_ver_referenciador\"><div ng-if=\"insurance.ref_policy\"><span ng-repeat=\"ref in insurance.ref_policy\">{{ref.referenciador.first_name}} {{ref.referenciador.last_name}}</span></div><div ng-if=\"insurance.vendor && !insurance.ref_policy\">{{insurance.vendor.first_name}} {{insurance.vendor.last_name}}</div></span></span> <span ng-if=\"header ===\'Folio\'\">{{ insurance.folio }}</span> <span ng-if=\"header ===\'Moneda\'\">{{ insurance.f_currency }}</span> <span ng-if=\"header ===\'Fecha creación\'\">{{ insurance.created_at | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Observaciones\'\">{{ insurance.observations }}</span> <span ng-if=\"header ===\'Creado por\'\">{{ insurance.owner }}</span> <span ng-if=\"header ===\'Clave\'\"><span ng-if=\"insurance.clave.name\">{{ insurance.clave.clave }} - {{ insurance.clave.name }}</span></span> <span ng-if=\"header ===\'Asegurado/Serial\'\"><span>{{ insurance.accidents_policy[0].personal.full_name }}{{ insurance.automobiles_policy[0].serial }}{{ insurance.life_policy[0].personal.full_name }}</span></span> <span ng-if=\"header ===\'Marca\'\"><span ng-if=\"insurance.automobiles_policy\">{{ insurance.automobiles_policy[0].brand }}</span></span> <span ng-if=\"header ===\'Versión\'\">{{ insurance.automobiles_policy[0].version }}</span> <span ng-if=\"header ===\'Placas\'\">{{ insurance.automobiles_policy[0].license_plates }}</span> <span ng-if=\"header ===\'Motor\'\">{{ insurance.automobiles_policy[0].engine }}</span> <span ng-if=\"header ===\'Adaptaciones\'\">{{ insurance.automobiles_policy[0].adjustment }}</span> <span ng-if=\"header ===\'Dirección\'\"><span ng-if=\"insurance.address.administrative_area_level_2\">{{ insurance.address.administrative_area_level_2 }}, {{ insurance.address.administrative_area_level_1 }}. <span ng-if=\"insurance.address.postal_code\">C.P. {{ insurance.address.postal_code }}</span></span></span> <span ng-if=\"header ===\'Ejecutivo Cobranza\'\">{{ insurance.collection_executive.first_name }} {{ insurance.collection_executive.last_name }}</span> <span ng-if=\"header ===\'Responsable\'\">{{ insurance.responsable.first_name }} {{ insurance.responsable.last_name }}</span> <span ng-if=\"header ===\'Sucursal\'\">{{ insurance.sucursal.sucursal_name }}</span> <span ng-if=\"header ===\'Renovable\'\"><span ng-if=\"insurance.is_renewable == 0\">No renovable</span> <span ng-if=\"insurance.is_renewable == 1\">Renovable</span></span> <span ng-if=\"header ===\'OT/Póliza asociada\'\">{{ insurance.asociada }}</span> <span ng-if=\"header ===\'Origen Póliza\'\">{{ insurance.origin }}</span> <span ng-if=\"header ===\'Agrupación\'\"></span> <span ng-if=\"header ===\'Subagrupación\'\"></span> <span ng-if=\"header ===\'Subsubagrupación\'\"></span> <span ng-if=\"header ===\'Clasificación\'\"></span> <span ng-if=\"header ===\'Línea de Negocio\'\"></span> <span ng-if=\"header ===\'Célula\'\"></span> <span ng-if=\"header ===\'Contacto(nombre)\'\"></span> <span ng-if=\"header ===\'Contacto(telefono)\'\"></span> <span ng-if=\"header ===\'Contacto(email)\'\"></span> <span ng-if=\"header ===\'Carátula\'\"></span> <span ng-if=\"header ===\'Póliza Siguiente\'\"></span> <span ng-if=\"header ===\'Fecha Cancelación\'\"></span> <span ng-if=\"header ===\'Adjuntos\'\"></span> <span ng-if=\"header ===\'Colectividad/PG completa\'\"></span> <span ng-if=\"header ===\'Estado Circulación\'\"></span> <span ng-if=\"header ===\'Tipo Administración\'\"></span> <span ng-if=\"header ===\'Póliza Anterior\'\"></span> <span ng-if=\"header ===\'Serie\'\"></span> <span ng-if=\"header ===\'No.Interno\'\">{{insurance.internal_number}}</span> <span ng-if=\"header ===\'Serie\'\">{{insurance.automobiles_policy[0].serial}}</span> <span ng-if=\"header ===\'Conducto de Pago\'\">{{}}</span> <span ng-if=\"header ===\'Bitacora\'\">{{}}</span></td></tr></tbody></table><div ng-if=\"vm.show_pag_policy\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in insurances track by $index\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}: {{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table id=\"example2\" class=\"table-flex\"><tr class=\"table-row\" ng-repeat=\"insurance in insurances track by $index\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.document_type }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p ng-if=\"insurance.contractor\">{{ insurance.contractor }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ insurance.aseguradora}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ insurance.ramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ insurance.paquete }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ insurance.forma_de_pago }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[10] }}</label><p>{{ insurance.folio}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[11] }}</label><p>{{ insurance.f_currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[12] }}</label><p>{{ insurance.p_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[13] }}</label><p>{{ insurance.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[14] }}</label><p>{{ insurance.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[15] }}</label><p>{{ insurance.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[16] }}</label><p>{{ insurance.p_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[17] }}</label><p>{{ insurance.comision | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[18] }}</label><p>{{ insurance.observations }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[19] }}</label><p>{{ insurance.owner }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[20] }}</label><p>{{insurance.clave}}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_policy\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div></div><div class=\"col-xs-12 form-group\" ng-if=\"insurances && insurances.length!=0\"><button ng-click=\"exportDataExcel(1)\" class=\"btn btn-primary ladda-button\">Generar Reporte</button></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0)\"><div class=\"row\" style=\"display: none;\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td ng-if=\"vm.form.group_by.id == 6\">Estatus</td><td ng-if=\"vm.form.group_by.id == 7\">Usuario</td><td ng-if=\"vm.form.group_by.id == 8\">Contratante</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 1\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.aseguradora__id__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 2\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 3\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Fisicos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.contractor__group__group_name\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Morales</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.contractor__group__group_name\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.vendor__count\"><td>{{ insurance.vendor__first_name }} {{ insurance.vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.vendor__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 6\"><td>{{ status(insurance.status) }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.status__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 8\"><td colspan=\"4\" align=\"center\"><b>Contratantes Fisicos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals track by $index\" ng-if=\"vm.form.group_by.id == 8 && insurance.contractor__full_name\"><td>{{ insurance.contractor__full_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 8\"><td colspan=\"4\" align=\"center\"><b>Contratantes Morales</b></td><td colspan=\"4\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_pesos track by $index\" ng-if=\"vm.form.group_by.id == 8 && insurance.contractor__full_name\"><td>{{ insurance.contractor__full_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 8\"><td colspan=\"4\" align=\"center\"><b>Contratantes Morales</b></td><td colspan=\"4\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_dolares track by $index\" ng-if=\"vm.form.group_by.id == 8 && insurance.contractor__full_name\"><td>{{ insurance.contractor__full_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div><br></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 1\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.aseguradora__compania && insurance.aseguradora__id__count\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.aseguradora__id__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.aseguradora__compania && insurance.aseguradora__id__count\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.aseguradora__id__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.udi track by $index\" ng-if=\"insurance.aseguradora__compania && insurance.aseguradora__id__count\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.aseguradora__id__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 2\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.ramo__ramo_name && insurance.ramo__count\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.ramo__ramo_name && insurance.ramo__count\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.udi track by $index\" ng-if=\"insurance.ramo__ramo_name && insurance.ramo__count\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 3\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.subramo__subramo_name && insurance.subramo__count\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.subramo__subramo_name && insurance.subramo__count\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.udi track by $index\" ng-if=\"insurance.subramo__subramo_name && insurance.subramo__count\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 4\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.naturals_pesos || grupos_result.naturals_dolares\"><b>Contratantes Físicos</b></td></tr><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_pesos track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_dolares track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_udi track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr><td colspan=\"5\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.juridicals_pesos || grupos_result.juridicals_dolares\"><b>Contratantes Morales</b></td></tr><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_pesos track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_dolares track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_udi track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 5\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 5\">Referenciador</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.ref_policy__referenciador__first_name && insurance.ref_policy__referenciador__count\"><td>{{ insurance.ref_policy__referenciador__first_name }} {{ insurance.ref_policy__referenciador__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.vendor__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.ref_policy__referenciador__first_name && insurance.ref_policy__referenciador__count\"><td>{{ insurance.ref_policy__referenciador__first_name }} {{ insurance.ref_policy__referenciador__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.vendor__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.udi track by $index\" ng-if=\"insurance.ref_policy__referenciador__first_name && insurance.ref_policy__referenciador__count\"><td>{{ insurance.ref_policy__referenciador__first_name }} {{ insurance.ref_policy__referenciador__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.vendor__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 6\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 6\">Estatus</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.status && insurance.status__count\"><td>{{ status(insurance.status) }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.status__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.status && insurance.status__count\"><td>{{ status(insurance.status) }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.status__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.udi track by $index\" ng-if=\"insurance.status && insurance.status__count\"><td>{{ status(insurance.status) }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.status__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 7\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 7\">Usuario</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.owner__first_name && insurance.owner__count\"><td>{{ insurance.owner__first_name }} {{ insurance.owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.owner__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.owner__first_name && insurance.owner__count\"><td>{{ insurance.owner__first_name }} {{ insurance.owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.owner__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.udi track by $index\" ng-if=\"insurance.owner__first_name && insurance.owner__count\"><td>{{ insurance.owner__first_name }} {{ insurance.owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.owner__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 8\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 8\">Contratante</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr><td colspan=\"5\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.naturals_pesos || grupos_result.naturals_dolares\"><b>Contratantes Físicos</b></td></tr><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_pesos track by $index\" ng-if=\"insurance.contractor__full_name && insurance.contractor__count\"><td>{{ insurance.contractor__full_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_dolares track by $index\" ng-if=\"insurance.contractor__full_name && insurance.contractor__count\"><td>{{ insurance.contractor__full_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_udi track by $index\" ng-if=\"insurance.contractor__full_name && insurance.contractor__count\"><td>{{ insurance.contractor__full_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__count }}</td></tr><tr><td colspan=\"5\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.juridicals_pesos || grupos_result.juridicals_dolares\"><b>Contratantes Morales</b></td></tr><tr><td colspan=\"5\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_pesos track by $index\" ng-if=\"insurance.contractor__full_name && insurance.contractor__count\"><td>{{ insurance.contractor__full_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_dolares track by $index\" ng-if=\"insurance.contractor__full_name && insurance.contractor__count\"><td>{{ insurance.contractor__full_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__count }}</td></tr><tr><td colspan=\"5\" align=\"center\"><b>UDI</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_udi track by $index\" ng-if=\"insurance.contractor__full_name && insurance.contractor__count\"><td>{{ insurance.contractor__full_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__count }}</td></tr></tbody></table><br></div></div></div></div></div><div ng-if=\"showSums\"><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Pesos</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_pesos | currency}}\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Dólares</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_dolares\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">UDI</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_udi\" disabled=\"\"></div></div></div><div class=\"row\" ng-if=\"showButtonExcel && vm.acceso_rep_pol && grupos_result && !(grupos_result.length == 0)\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(2)\">Descargar Reporte</button></div></div><style>\n  /* === Limpieza visual para secciones === */\n  .filter-section {\n    border: 1px solid #e7eaec;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    padding: 15px 15px 5px 15px;\n    background-color: #fcfcfc;\n  }\n  .filter-section legend {\n    font-size: 14px;\n    font-weight: 600;\n    color: #000000;\n    border-bottom: 1px solid #fafdff;\n    margin-bottom: 15px;\n    padding-bottom: 5px;\n  }\n  .report-highlight {\n    background-color: #eef4f7;\n    border-radius: 6px;\n    padding: 15px;\n    margin-top: 20px;\n    border: 1px solid #dbe3e6;\n  }\n\n  .btn-consultar {\n    margin-top: 20px;\n  }\n</style></div>");
$templateCache.put("app/reportes/reporte.polizasGastosMedicos.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reportes Pólizas Titulares y Cónyuges</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Pólizas Titulares y Cónyuges</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport()\"><option value=\"\">Selecciona una opción</option></select><span class=\"color-red\" ng-if=\"vm.form.dates_sel.id == 1\">**Este reporte no incluye pólizas migradas o renovadas masivamente por Miurabox</span></div><div align=\"center\" ng-if=\"vigency || created_at\" class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><br></div><div class=\"row\"><div class=\"col-xs-6 form-group\"><legend class=\"legend-title\" align=\"center\">Opciones</legend><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': ot_rep == \'1\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"1\"> Solo OTs</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': ot_rep == \'2\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"2\"> Incluir OTs</label></div></div><div class=\"col-xs-12 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': ot_rep == \'3\'}\"><input type=\"radio\" ng-model=\"ot_rep\" ng-click=\"valueRadioRep(ot_rep)\" ng-value=\"3\"> No incluir OTs</label></div></div></div><div class=\"col-xs-6 form-group form-group border-left\"><legend class=\"legend-title\" align=\"center\">Tipo</legend><div class=\"col-xs-6 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': renewals == \'1\'}\"><input type=\"radio\" ng-model=\"renewals\" ng-click=\"valueRadioRen(renewals)\" ng-value=\"1\"> Renovadas</label></div></div><div class=\"col-xs-6 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': renewals == \'2\'}\"><input type=\"radio\" ng-model=\"renewals\" ng-click=\"valueRadioRen(renewals)\" ng-value=\"2\"> No renovadas</label></div></div><div class=\"col-xs-6 col-sm-4\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': renewals == \'0\'}\"><input type=\"radio\" ng-model=\"renewals\" ng-click=\"valueRadioRen(renewals)\" ng-value=\"0\"> Todas</label></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right ladda-buttonC\" ng-click=\"vm.Generar(1,1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Pólizas</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result || grupos_result.length == 0\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Identificador</th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[8]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th></tr></thead><tbody><tr ng-repeat=\"insurance in insurances track by $index\" ng-click=\"vm.goToInfo(insurance)\" on-finish-render=\"ngRepeatFinished\"><td>{{ insurance.identifier }}</td><td>{{ insurance.poliza_number }}</td><td>{{ insurance.contractor.full_name }}</td><td><span ng-if=\"insurance.start_of_validity != \' \'\">{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</span></td><td>{{insurance.p_neta}}</td><td><span ng-if=\"insurance.address.route\">{{insurance.address.route}},</span> <span ng-if=\"insurance.address.street_number\">{{insurance.address.street_number}},</span> <span ng-if=\"insurance.address.street_number_int\">Int. {{insurance.address.street_number_int}}</span> <span ng-if=\"insurance.address.sublocality\">{{insurance.address.sublocality}},</span> {{insurance.address.administrative_area_level_2}}, {{insurance.address.administrative_area_level_1}} <span ng-if=\"insurance.address.postal_code\">C.P.: {{insurance.address.postal_code}}</span></td><td>{{ insurance.accidents_policy[0].personal.full_name }} {{ insurance.life_policy[0].personal.full_name }} {{ insurance.automobiles_policy[0].serial }}</td><td>{{ insurance.accidents_policy[0].personal.birthdate | date: \'dd/MM/yyyy\'}} {{ insurance.life_policy[0].personal.birthdate | date: \'dd/MM/yyyy\'}}</td><td><div ng-repeat=\"relation in insurance.accidents_policy[0].relationship_accident\"><p ng-if=\"relation.relationship == 2\">{{ relation.full_name }}</p></div></td><td><div ng-repeat=\"relation in insurance.accidents_policy[0].relationship_accident\"><p ng-if=\"relation.relationship == 2\">{{ relation.birthdate | date: \'dd/MM/yyyy\'}}</p></div></td></tr></tbody></table><div ng-if=\"vm.show_pag_policy\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br></div><button ng-click=\"exportDataExcel(1)\" class=\"btn btn-primary ladda-button\">Generar Reporte</button></div></div></div><div ng-if=\"showSums\"><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Pesos</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_pesos | currency}}\" disabled=\"\"></div><br></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Dólares</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_dolares\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">UDI</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_udi\" disabled=\"\"></div></div></div><div class=\"row\" ng-if=\"showButtonExcel && vm.acceso_rep_pol && grupos_result && !(grupos_result.length == 0)\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(2)\">Descargar Reporte</button></div></div>");
$templateCache.put("app/reportes/reporte.polizascontributorias.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reportes Pólizas Contributorias</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Pólizas Contributorias</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.dates_sel\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport()\"><option value=\"\">Selecciona una opción</option></select><span class=\"color-red\" ng-if=\"vm.form.dates_sel.id == 1\">**Este reporte no incluye pólizas migradas o renovadas masivamente por Miurabox</span></div><div align=\"center\" ng-if=\"vigency || created_at\" class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><br></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right ladda-buttonC\" ng-click=\"vm.Generar(1,1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Pólizas</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Identificador</th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(3, vm.policy_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(3, $event)\" ng-mouseout=\"finalColumn(3, $event)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_cont_asc == 1, \'fa fa-sort-asc\': vm.policy_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(24, vm.policy_contgroup_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(24, $event)\" ng-mouseout=\"finalColumn(24, $event)\" ng-model=\"vm.table.headers[2]\">Grupo <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_contgroup_asc == 1, \'fa fa-sort-asc\': vm.policy_contgroup_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(1, vm.policy_nump_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(1, $event)\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_nump_asc == 1, \'fa fa-sort-asc\': vm.policy_nump_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(4, vm.policy_aseg_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(4, $event)\" ng-mouseout=\"finalColumn(4, $event)\" ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_aseg_asc == 1, \'fa fa-sort-asc\': vm.policy_aseg_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(5, vm.policy_ramo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(5, $event)\" ng-mouseout=\"finalColumn(5, $event)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ramo_asc == 1, \'fa fa-sort-asc\': vm.policy_ramo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(6, vm.policy_subramo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(6, $event)\" ng-mouseout=\"finalColumn(6, $event)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_subramo_asc == 1, \'fa fa-sort-asc\': vm.policy_subramo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(7, vm.policy_pack_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(7, $event)\" ng-mouseout=\"finalColumn(7, $event)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_pack_asc == 1, \'fa fa-sort-asc\': vm.policy_pack_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(13, vm.policy_pneta_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(13, $event)\" ng-mouseout=\"finalColumn(13, $event)\" ng-model=\"vm.table.headers[12]\">{{vm.table.headers[12]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_pneta_asc == 1, \'fa fa-sort-asc\': vm.policy_pneta_asc == 2}\"></span></th><th>Descuento</th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(14, vm.policy_rpf_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(14, $event)\" ng-mouseout=\"finalColumn(14, $event)\" ng-model=\"vm.table.headers[13]\">{{vm.table.headers[13]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_rpf_asc == 1, \'fa fa-sort-asc\': vm.policy_rpf_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(15, vm.policy_der_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(15, $event)\" ng-mouseout=\"finalColumn(15, $event)\" ng-model=\"vm.table.headers[14]\">{{vm.table.headers[14]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_der_asc == 1, \'fa fa-sort-asc\': vm.policy_der_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(16, vm.policy_iva_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(16, $event)\" ng-mouseout=\"finalColumn(16, $event)\" ng-model=\"vm.table.headers[15]\">{{vm.table.headers[15]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_iva_asc == 1, \'fa fa-sort-asc\': vm.policy_iva_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(17, vm.policy_ptotal_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(17, $event)\" ng-mouseout=\"finalColumn(17, $event)\" ng-model=\"vm.table.headers[16]\">{{vm.table.headers[16]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ptotal_asc == 1, \'fa fa-sort-asc\': vm.policy_ptotal_asc == 2}\"></span></th><th ng-if=\"vm.permiso_comisiones\" drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(18, vm.policy_com_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(18, $event)\" ng-mouseout=\"finalColumn(18, $event)\" ng-model=\"vm.table.headers[17]\">{{vm.table.headers[17]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_com_asc == 1, \'fa fa-sort-asc\': vm.policy_com_asc == 2}\"></span></th><th ng-if=\"vm.permiso_comisiones\">Comisión Porcentaje</th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(8, vm.policy_fpago_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(8, $event)\" ng-mouseout=\"finalColumn(8, $event)\" ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_fpago_asc == 1, \'fa fa-sort-asc\': vm.policy_fpago_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(22, vm.policy_ase_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(22, $event)\" ng-mouseout=\"finalColumn(22, $event)\" ng-model=\"vm.table.headers[21]\">{{vm.table.headers[21]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(2, vm.policy_tipo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(2, $event)\" ng-mouseout=\"finalColumn(2, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_tipo_asc == 1, \'fa fa-sort-asc\': vm.policy_tipo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(9, vm.policy_status_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(9, $event)\" ng-mouseout=\"finalColumn(9, $event)\" ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_status_asc == 1, \'fa fa-sort-asc\': vm.policy_status_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(10, vm.policy_vig_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(10, $event)\" ng-mouseout=\"finalColumn(10, $event)\" ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_vig_asc == 1, \'fa fa-sort-asc\': vm.policy_vig_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(10, vm.policy_vig2_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(10, $event)\" ng-mouseout=\"finalColumn(10, $event)\" ng-model=\"vm.table.headers[9]\">{{vm.table.headers[29]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_vig2_asc == 1, \'fa fa-sort-asc\': vm.policy_vig2_asc == 2}\"></span></th><th>Referenciador</th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(11, vm.policy_folio_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(11, $event)\" ng-mouseout=\"finalColumn(11, $event)\" ng-model=\"vm.table.headers[10]\">{{vm.table.headers[10]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_folio_asc == 1, \'fa fa-sort-asc\': vm.policy_folio_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(12, vm.policy_moneda_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(12, $event)\" ng-mouseout=\"finalColumn(12, $event)\" ng-model=\"vm.table.headers[11]\">{{vm.table.headers[11]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_moneda_asc == 1, \'fa fa-sort-asc\': vm.policy_moneda_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(23, vm.policy_created_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(23, $event)\" ng-mouseout=\"finalColumn(23, $event)\" ng-model=\"vm.table.headers[22]\">{{vm.table.headers[22]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_created_asc == 1, \'fa fa-sort-asc\': vm.policy_created_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(19, vm.policy_obs_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(19, $event)\" ng-mouseout=\"finalColumn(19, $event)\" ng-model=\"vm.table.headers[18]\">{{vm.table.headers[18]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_obs_asc == 1, \'fa fa-sort-asc\': vm.policy_obs_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(20, vm.policy_owner_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(20, $event)\" ng-mouseout=\"finalColumn(20, $event)\" ng-model=\"vm.table.headers[19]\">{{vm.table.headers[19]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_owner_asc == 1, \'fa fa-sort-asc\': vm.policy_owner_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changePolicy(21, vm.policy_clave_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(21, $event)\" ng-mouseout=\"finalColumn(21, $event)\" ng-model=\"vm.table.headers[20]\">{{vm.table.headers[20]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_clave_asc == 1, \'fa fa-sort-asc\': vm.policy_clave_asc == 2}\"><th drag-me=\"\" drop-me=\"\" ng-model=\"vm.table.headers[23]\">{{vm.table.headers[23]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" ng-mouseout=\"finalColumn(25, $event)\" ng-model=\"vm.table.headers[24]\">{{vm.table.headers[24]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" ng-mouseout=\"finalColumn(26, $event)\" ng-model=\"vm.table.headers[25]\">{{vm.table.headers[25]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" ng-mouseout=\"finalColumn(27, $event)\" ng-model=\"vm.table.headers[26]\">{{vm.table.headers[26]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" ng-mouseout=\"finalColumn(28, $event)\" ng-model=\"vm.table.headers[27]\">{{vm.table.headers[27]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_ase_asc == 1, \'fa fa-sort-asc\': vm.policy_case_asc == 2}\"></span></th><th drag-me=\"\" ng-mouseout=\"finalColumn(28, $event)\" ng-model=\"vm.table.headers[28]\">{{vm.table.headers[28]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.policy_dir_asc == 1, \'fa fa-sort-asc\': vm.policy_dir_asc == 2}\"></span></th><th>Ejecutivo Cobranza</th><th>Responsable</th><th>Sucursal</th><th>Renovable</th><th>OT/Póliza asociada</th><th>Origen Póliza</th><th>Agrupación</th><th>Subagrupación</th><th>Subsubagrupación</th><th>Clasificación</th><th>Línea de Negocio</th><th>Célula</th><th>Contacto(nombre)</th><th>Contacto(telefono)</th><th>Contacto(email)</th><th>Carátula</th><th>Póliza Anterior</th><th>Póliza Siguiente</th><th>Fecha Cancelación</th><th>Adjuntos</th><th>Colectividad/PG completa</th><th>Estado Circulación</th><th>Tipo Administración</th><th>Tipo</th><th>No.Interno</th><th>Serie</th><th>Conducto de Pago</th><th>Bitacora</th><th>RFC Clave</th><th>RFC HomoClave</th><th>Domicilio Calle-Núm</th><th>Domicilio Colonia</th><th>Domicilio C.P.</th><th>Domicilio Población/Municipio</th><th>Domicilio Estado</th></span></th></tr></thead><tbody><tr ng-repeat=\"insurance in insurances track by $index\" ng-click=\"vm.goToInfo(insurance)\" on-finish-render=\"ngRepeatFinished\"><td>{{ insurance.identifier }}</td><td><span ng-if=\"insurance.contractor\">{{ insurance.contractor.full_name }}</span></td><td>{{ insurance.contractor.group }}</td><td>{{ insurance.poliza_number }}</td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.ramo }}</td><td>{{ insurance.subramo }}</td><td>{{ insurance.paquete }}</td><td align=\"right\">{{ insurance.p_neta | currency }}</td><td align=\"right\">{{ insurance.descuento | currency }}</td><td align=\"right\">{{ insurance.rpf | currency }}</td><td align=\"right\">{{ insurance.derecho | currency }}</td><td align=\"right\">{{ insurance.iva | currency }}</td><td align=\"right\">{{ insurance.p_total | currency }}</td><td ng-if=\"vm.permiso_comisiones\" align=\"right\">{{ insurance.comision | currency }}</td><td ng-if=\"vm.permiso_comisiones\" align=\"right\">{{ insurance.comision_percent}}</td><td>{{ insurance.forma_de_pago }}</td><td>{{ insurance.accidents_policy[0].personal.full_name }} {{ insurance.life_policy[0].personal.full_name }} {{ insurance.automobiles_policy[0].serial }}</td><td><span ng-if=\"insurance.document_type == \'Póliza\'\">Póliza</span> <span ng-if=\"insurance.document_type == \'OT\'\">OT</span> <span ng-if=\"insurance.document_type == \'Colectividad\'\">Póliza de Grupo</span> <span ng-if=\"insurance.document_type == \'Carátula\'\">Colectividad</span> <span ng-if=\"insurance.document_type == \'Póliza de Carátula\'\">Póliza de Colectividad</span> <span ng-if=\"insurance.document_type == \' \'\"></span> <span ng-if=\"insurance.document_type == 1\">Póliza</span> <span ng-if=\"insurance.document_type == 1 && (insurance.status == 1 || insurance.status==2)\">OT</span> <span ng-if=\"insurance.document_type == 3\">Póliza de Grupo</span> <span ng-if=\"insurance.document_type == 11\">Colectividad</span> <span ng-if=\"insurance.document_type == 12\">Póliza de Colectividad</span></td><td><span ng-if=\"insurance.status != \' \'\"><p>{{ status(insurance.status) }}</p></span></td><td>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td><div ng-if=\"insurance.ref_policy\"><span ng-repeat=\"ref in insurance.ref_policy\">{{ref.referenciador.first_name}} {{ref.referenciador.last_name}}</span></div><div ng-if=\"insurance.vendor && !insurance.ref_policy\">{{insurance.vendor.first_name}} {{insurance.vendor.last_name}}</div></td><td>{{ insurance.folio }}</td><td>{{ insurance.f_currency }}</td><td>{{ insurance.created_at | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.observations }}</td><td>{{ insurance.owner }}</td><td ng-if=\"insurance.clave.name\">{{ insurance.clave.clave }} - {{ insurance.clave.name }}</td><td ng-if=\"!insurance.clave.name\">&nbsp;</td><td ng-if=\"insurance.automobiles_policy[0].brand\">{{ insurance.automobiles_policy[0].brand }} - {{ insurance.automobiles_policy[0].model }} - {{ insurance.automobiles_policy[0].year }}</td><td ng-if=\"!insurance.automobiles_policy[0].brand\">&nbsp;</td><td>{{ insurance.automobiles_policy[0].version }}</td><td>{{ insurance.automobiles_policy[0].license_plates }}</td><td>{{ insurance.automobiles_policy[0].engine }}</td><td>{{ insurance.automobiles_policy[0].adjustment }}</td><td ng-if=\"insurance.address.administrative_area_level_2\">{{ insurance.address.administrative_area_level_2 }}, {{ insurance.address.administrative_area_level_1 }}. <span ng-if=\"insurance.address.postal_code\">C.P. {{ insurance.address.postal_code }}</span></td><td ng-if=\"!insurance.address.administrative_area_level_2\">&nbsp;</td><td>{{ insurance.collection_executive.first_name }} {{ insurance.collection_executive.last_name }}</td><td>{{ insurance.responsable.first_name }} {{ insurance.responsable.last_name }}</td><td>{{ insurance.sucursal.sucursal_name }}</td><td><span ng-if=\"insurance.is_renewable == 0\">No renovable</span> <span ng-if=\"insurance.is_renewable == 1\">Renovable</span></td><td>{{ insurance.asociada }}</td><td>{{ insurance.origin }}</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>{{insurance.internal_number}}</td><td>{{insurance.automobiles_policy[0].serial}}</td><td>{{}}</td><td>{{}}</td><td>{{insurance.rfc_cve}}</td><td>{{insurance.rfc_homocve}}</td><td>{{insurance.dom_callenum}}</td><td>{{insurance.dom_colonia}}</td><td>{{insurance.dom_cp}}</td><td>{{insurance.dom_poblacion}}</td><td>{{insurance.dom_estado}}</td></tr></tbody></table><div ng-if=\"vm.show_pag_policy\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in insurances track by $index\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}: {{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table id=\"example2\" class=\"table-flex\"><tr class=\"table-row\" ng-repeat=\"insurance in insurances track by $index\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.document_type }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p ng-if=\"insurance.contractor\">{{ insurance.contractor }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ insurance.aseguradora}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ insurance.ramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ insurance.paquete }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ insurance.forma_de_pago }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p status=\"{{insurance.status}}\"></p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[10] }}</label><p>{{ insurance.folio}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[11] }}</label><p>{{ insurance.f_currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[12] }}</label><p>{{ insurance.p_neta | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[13] }}</label><p>{{ insurance.rpf | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[14] }}</label><p>{{ insurance.derecho | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[15] }}</label><p>{{ insurance.iva | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[16] }}</label><p>{{ insurance.p_total | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[17] }}</label><p>{{ insurance.comision | currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[18] }}</label><p>{{ insurance.observations }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[19] }}</label><p>{{ insurance.owner }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[20] }}</label><p>{{insurance.clave}}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_policy\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div></div><div class=\"col-xs-12 form-group\"><button ng-click=\"exportDataExcel(1)\" class=\"btn btn-primary ladda-button\">Generar Reporte</button></div></div></div></div><div ng-if=\"showSums\"><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Pesos</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_pesos | currency}}\" format-currency=\"\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_pesos | currency}}\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">Dólares</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_dolares | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_dolares | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_dolares\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_dolares\" disabled=\"\"></div></div><div class=\"col-xs-12 pull-right\"><div class=\"col-xs-12 col-sm-3 form-group m-t\"><h4 class=\"pull-right\">UDI</h4></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Neta:</label> <input ng-if=\"sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_neta_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Total Prima Total:</label> <input ng-if=\"sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.p_total_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total_udi | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input ng-if=\"sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total_udi | currency}}\" disabled=\"\"> <input ng-if=\"!sumas.comision_total_udi\" class=\"form-control\" type=\"\" name=\"\" ng-model=\"sumas.comision_total_udi\" disabled=\"\"></div></div></div>");
$templateCache.put("app/reportes/reporte.renovaciones.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12\"><h2>Reportes Renovaciones</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Renovaciones</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtro Básico</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row text-align-center report-highlight\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.renovadas\" ng-options=\"option.name for option in vm.option track by option.id\" ng-change=\"\"><option value=\"\" disabled=\"\">Selecciona una opción</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Más filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"subgroups.length >0\"><label>SubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subgroup\" data-ng-options=\"subgroup.group_name for subgroup in subgroups track by subgroup.url\" ng-change=\"vm.changeSubgroup(vm.form.subgroup)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"subsubgroups.length >0\"><label>SubsubGrupo</label><select class=\"form-control\" ng-model=\"vm.form.subsubgroup\" data-ng-options=\"subsubgroup.group_name for subsubgroup in subsubgroups track by subsubgroup.url\" ng-change=\"vm.changeSubsubgroup(vm.form.subsubgroup)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Clasificación</label><autocomplete datasource=\"classification_data\" id=\"classification\" model=\"vm.form.classification\" change=\"vm.matchesClassification(vm.form.classification.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_agrupacion\"><label>Nivel de Agrupación</label><autocomplete datasource=\"groupinglevels_data\" id=\"groupingleves\" model=\"vm.form.groupinglevel\" change=\"vm.matchesGroupinglevel(vm.form.groupinglevel.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.form.groupinglevel.subgrupos.length >0 && campo_agrupacion\"><label>SubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subgrouping\" data-ng-options=\"subgrouping.description for subgrouping in vm.form.groupinglevel.subgrupos track by subgrouping.url\" ng-change=\"vm.changeSubgrouping(vm.form.subgrouping)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"vm.form.subgrouping.subsubgrupos.length >0 && campo_agrupacion\"><label>SubsubAgrupación</label><select class=\"form-control\" ng-model=\"vm.form.subsubgrouping\" data-ng-options=\"subsubgroupin.description for subsubgroupin in vm.form.subgrouping.subsubgrupos track by subsubgroupin.url\" ng-change=\"vm.changeSubsubgrouping(vm.form.subsubgrouping)\" required=\"\"><option value=\"\">Todos los subgrupos</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-model=\"vm.form.celula\" data-ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"vm.changecelula(vm.form.celula)\"><option value=\"\">Todo</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-model=\"vm.form.businesLine\" data-ng-options=\"businesLine.name for businesLine in vm.businesLine track by businesLine.id\" ng-change=\"vm.changeBLine(vm.form.businesLine)\" required=\"\"><option value=\"\">Todas las líneas</option></select></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"users.username for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Estatus</label><select class=\"form-control\" ng-model=\"vm.form.status\" ng-options=\"status.name for status in vm.status track by status.id\" ng-change=\"vm.changeStatus(vm.form.status)\"><option value=\"\">Selecciona un estatus</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Frecuencia de Pago</label><select class=\"form-control\" ng-model=\"vm.form.payment\" ng-options=\"payment.name for payment in vm.payment track by payment.id\" ng-change=\"vm.changePayment(vm.form.payment)\"><option value=\"\">Selecciona una frecuencia de pago</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label title=\"Filtro aplicado sobre la póliza\">Sucursal</label><select class=\"form-control\" ng-model=\"vm.form.sucursal\" ng-options=\"sucursal.sucursal_name for sucursal in sucursales track by sucursal.id\" ng-change=\"\"><option value=\"\">Seleccione</option></select><span ng-if=\"vm.form.sucursal\" class=\"color-red\">Filtro aplicado sobre póliza(s)</span></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Agrupar por:</label><select class=\"form-control\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\" disabled=\"\">Seleccione</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Clave de Agente</label> <input class=\"form-control\" type=\"text\" name=\"agente\" ng-model=\"vm.form.cve_agente\" ng-change=\"\"></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Buscar por:</label><select class=\"form-control\" ng-model=\"vm.form.validity\" ng-options=\"option.name for option in vm.validity track by option.id\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-5 form-group\"><label>Carátula:</label><br><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.word\" change=\"vm.getCaratulas(vm.word)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getCarSelected(vm.word)\"><span class=\"fa fa-ok\"></span> Seleccionar</button></div></div></div></div></div></div><div class=\"col-xs-12 text-align-center\"><button class=\"btn btn-success ladda-buttonC\" ng-click=\"vm.Generar(1,1)\">Consultar</button></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Renovaciones <span ng-if=\"vm.form.renovadas && vm.form.renovadas.id==2\">Pendientes</span></h5><div class=\"contentvideo\"><span>Personaliza tus reportes: selecciona solo los campos que necesitas</span> <a href=\"https://youtu.be/KFd50p5ZVuk\" target=\"_blank\" class=\"vervideo\">▶ Ver video</a></div><div ibox-tools=\"\" class=\"iboxtools\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result && !(grupos_result.length == 0)\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr ng-if=\"filteredKeys.length>0\"><th ng-repeat=\"header in filteredKeys\" ng-click=\"vm.changeRenewal(header)\">{{ header }} <span ng-if=\"vm.sortOrders[header] === 1\">▲</span> <span ng-if=\"vm.sortOrders[header] === 2\">▼</span></th></tr></thead><tbody><tr ng-repeat=\"insurance in insurances | orderBy: \'aseguradora\' track by $index\" ng-click=\"vm.goToInfo(insurance)\" on-finish-render=\"ngRepeatFinished\"><td ng-repeat=\"header in filteredKeys\"><span ng-if=\"header ===\'No.Póliza\'\">{{ insurance.poliza_number }}</span> <span ng-if=\"header ===\'Contratante\'\"><span ng-if=\"insurance.contractor\">{{ insurance.contractor.full_name }}</span></span> <span ng-if=\"header ===\'Grupo\'\">{{ insurance.contractor.group }}</span> <span ng-if=\"header ===\'Proveedor\'\">{{ insurance.aseguradora }}</span> <span ng-if=\"header ===\'Ramo\'\">{{ insurance.ramo }}</span> <span ng-if=\"header ===\'Subramo\'\">{{ insurance.subramo }}</span> <span ng-if=\"header ===\'Paquete\'\">{{ insurance.paquete }}</span> <span ng-if=\"header ===\'Prima Neta\'\">{{ insurance.p_neta | currency }}</span> <span ng-if=\"header ===\'RPF\'\">{{ insurance.rpf | currency }}</span> <span ng-if=\"header ===\'Derecho\'\">{{ insurance.derecho | currency }}</span> <span ng-if=\"header ===\'IVA\'\">{{ insurance.iva | currency }}</span> <span ng-if=\"header ===\'Prima Total\'\">{{ insurance.p_total | currency }}</span> <span ng-if=\"header ===\'Comisión\'\"><span ng-if=\"vm.permiso_comisiones\">{{ insurance.comision | currency }}</span></span> <span ng-if=\"header ===\'Forma de Pago\'\">{{ insurance.forma_de_pago }}</span> <span ng-if=\"header ===\'Tipo\'\">{{ insurance.document_type }}</span> <span ng-if=\"header ===\'Estatus Póliza\'\">{{ insurance.status }}</span> <span ng-if=\"header ===\'Estatus de la Renovación\'\"><span ng-if=\"insurance.renewed_status == 2\"><strong>En proceso de renovación</strong></span> <span ng-if=\"insurance.renewed_status == 1\"><strong>Renovada</strong></span> <span ng-if=\"insurance.renewed_status == 0\"><strong>No Renovada</strong></span></span> <span ng-if=\"header ===\'Inicio Póliza\'\">{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Fin Póliza\'\">{{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Fecha de Creación\'\">{{ insurance.created_at | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Folio\'\">{{ insurance.folio }}</span> <span ng-if=\"header ===\'Moneda\'\">{{insurance.f_currency}}</span> <span ng-if=\"header ===\'Conducto de Pago\'\">{{insurance.conducto_de_pago}}</span> <span ng-if=\"header ===\'Observaciones\'\">{{ insurance.observations }}</span> <span ng-if=\"header ===\'Clave\'\"><span ng-if=\"insurance.clave.name\">{{ insurance.clave.clave }} - {{ insurance.clave.name }}</span> <span ng-if=\"!insurance.clave.name\"><p class=\"hidden-text\"></p></span></span> <span ng-if=\"header ===\'Póliza Siguiente\'\">{{insurance.historic}}</span> <span ng-if=\"header ===\'Responsable\'\">{{insurance.responsable.first_name }} {{insurance.responsable.last_name}}</span> <span ng-if=\"header ===\'Identificador\'\">{{insurance.identifier}}</span> <span ng-if=\"header ===\'Email\'\">{{ insurance.contractor.email }}</span> <span ng-if=\"header ===\'Teléfono\'\">{{ insurance.contractor.phone_number }}</span> <span ng-if=\"header ===\'Asegurado\'\"><span ng-if=\"insurance.accidents_policy\">{{ insurance.accidents_policy[0].personal.full_name }}</span> <span ng-if=\"insurance.automobiles_policy\">{{ insurance.automobiles_policy[0].serial }}</span> <span ng-if=\"insurance.life_policy\">{{ insurance.life_policy[0].personal.full_name }}</span> <span ng-if=\"insurance.damages_policy\">{{ insurance.damages_policy[0].insured_ }}</span></span> <span ng-if=\"header ===\'Referenciador\'\"><span ng-if=\"vm.permiso_ver_referenciador\"><div ng-if=\"insurance.ref_policy\"><span ng-repeat=\"ref in insurance.ref_policy\">{{ref.referenciador.first_name}} {{ref.referenciador.last_name}}</span></div></span></span> <span ng-if=\"header ===\'Creado por\'\"></span> <span ng-if=\"header ===\'Fecha renovación\'\"></span> <span ng-if=\"header ===\'Póliza Anterior\'\"></span> <span ng-if=\"header ===\'C.P.\'\"></span> <span ng-if=\"header ===\'Agrupación\'\"></span> <span ng-if=\"header ===\'Subagrupación\'\"></span> <span ng-if=\"header ===\'Subsubagrupación\'\"></span> <span ng-if=\"header ===\'Clasificación\'\"></span> <span ng-if=\"header ===\'Línea de Negocio\'\"></span> <span ng-if=\"header ===\'Célula\'\"></span> <span ng-if=\"header ===\'Contacto(nombre)\'\"></span> <span ng-if=\"header ===\'Contacto(telefono)\'\"></span> <span ng-if=\"header ===\'Contacto(email)\'\"></span> <span ng-if=\"header ===\'Sucursal\'\">{{insurance.sucursal}}</span> <span ng-if=\"header ===\'N.Carátula\'\"></span> <span ng-if=\"header ===\'CaratulaContratante\'\"></span> <span ng-if=\"header ===\'Serie(Automovil)\'\">{{ insurance.automobiles_policy[0].serial }}</span></td></tr></tbody></table><div ng-if=\"vm.show_pag_renewal\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in insurances track by $index\" ng-if=\"insurance.poliza_number != \' \'\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}: {{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.document_type }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p ng-if=\"insurance.contractor\">{{ insurance.contractor }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ insurance.aseguradora}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ insurance.ramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ insurance.paquete }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ insurance.forma_de_pago }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{insurance.status}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[10] }}</label><p>{{ insurance.created_at | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[11] }}</label><p>{{ insurance.folio}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[12] }}</label><p>{{ insurance.f_currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[13] }}</label><p>{{ insurance.p_neta}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[14] }}</label><p>{{ insurance.rpf}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[15] }}</label><p>{{ insurance.derecho}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[16] }}</label><p>{{ insurance.iva}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[17] }}</label><p>{{ insurance.p_total}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[18] }}</label><p>{{ insurance.comision}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[19] }}</label><p>{{ insurance.observations}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[20] }}</label><p>{{ insurance.clave.clave }} - {{ insurance.clave.name }}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_renewal\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div><div class=\"row\" ng-if=\"vm.form.renovadas && vm.form.renovadas.id==2\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Pólizas en proceso de renovación (ya cuentan con una OT siguiente)</h5><div ibox-tools=\"\" class=\"iboxtools\"></div></div><div class=\"ibox-content\" ng-if=\"insurances_en_proceso && insurances_en_proceso.length != 0\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr ng-if=\"filteredKeys.length>0\"><th ng-repeat=\"header in filteredKeys\" ng-click=\"vm.changePolicy(header)\">{{ header }}</th></tr></thead><tbody><tr ng-repeat=\"insurance in insurances_en_proceso | orderBy: \'aseguradora\' track by $index\" ng-click=\"vm.goToInfo(insurance)\" on-finish-render=\"ngRepeatFinished\"><td ng-repeat=\"header in filteredKeys\"><span ng-if=\"header ===\'No.Póliza\'\">{{ insurance.poliza_number }}</span> <span ng-if=\"header ===\'Contratante\'\"><span ng-if=\"insurance.contractor\">{{ insurance.contractor.full_name }}</span></span> <span ng-if=\"header ===\'Grupo\'\">{{ insurance.contractor.group }}</span> <span ng-if=\"header ===\'Proveedor\'\">{{ insurance.aseguradora }}</span> <span ng-if=\"header ===\'Ramo\'\">{{ insurance.ramo }}</span> <span ng-if=\"header ===\'Subramo\'\">{{ insurance.subramo }}</span> <span ng-if=\"header ===\'Paquete\'\">{{ insurance.paquete }}</span> <span ng-if=\"header ===\'Prima Neta\'\">{{ insurance.p_neta | currency }}</span> <span ng-if=\"header ===\'RPF\'\">{{ insurance.rpf | currency }}</span> <span ng-if=\"header ===\'Derecho\'\">{{ insurance.derecho | currency }}</span> <span ng-if=\"header ===\'IVA\'\">{{ insurance.iva | currency }}</span> <span ng-if=\"header ===\'Prima Total\'\">{{ insurance.p_total | currency }}</span> <span ng-if=\"header ===\'Comisión\'\"><span ng-if=\"vm.permiso_comisiones\">{{ insurance.comision | currency }}</span></span> <span ng-if=\"header ===\'Forma de Pago\'\">{{ insurance.forma_de_pago }}</span> <span ng-if=\"header ===\'Tipo\'\">{{ insurance.document_type }}</span> <span ng-if=\"header ===\'Estatus Póliza\'\">{{ insurance.status }}</span> <span ng-if=\"header ===\'Estatus de la Renovación\'\"><span ng-if=\"insurance.renewed_status == 2\"><strong>En proceso de renovación</strong></span> <span ng-if=\"insurance.renewed_status == 1\"><strong>Renovada</strong></span> <span ng-if=\"insurance.renewed_status == 0\"><strong>No Renovada</strong></span></span> <span ng-if=\"header ===\'Inicio Póliza\'\">{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Fin Póliza\'\">{{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Fecha de Creación\'\">{{ insurance.created_at | date: \'dd/MM/yyyy\'}}</span> <span ng-if=\"header ===\'Folio\'\">{{ insurance.folio }}</span> <span ng-if=\"header ===\'Moneda\'\">{{insurance.f_currency}}</span> <span ng-if=\"header ===\'Conducto de Pago\'\">{{insurance.conducto_de_pago}}</span> <span ng-if=\"header ===\'Observaciones\'\">{{ insurance.observations }}</span> <span ng-if=\"header ===\'Clave\'\"><span ng-if=\"insurance.clave.name\">{{ insurance.clave.clave }} - {{ insurance.clave.name }}</span> <span ng-if=\"!insurance.clave.name\"><p class=\"hidden-text\"></p></span></span> <span ng-if=\"header ===\'Póliza Siguiente\'\">{{insurance.historic}}</span> <span ng-if=\"header ===\'Responsable\'\">{{insurance.responsable.first_name }} {{insurance.responsable.last_name}}</span> <span ng-if=\"header ===\'Identificador\'\">{{insurance.identifier}}</span> <span ng-if=\"header ===\'Email\'\">{{ insurance.contractor.email }}</span> <span ng-if=\"header ===\'Teléfono\'\">{{ insurance.contractor.phone_number }}</span> <span ng-if=\"header ===\'Asegurado\'\"><span ng-if=\"insurance.accidents_policy\">{{ insurance.accidents_policy[0].personal.full_name }}</span> <span ng-if=\"insurance.automobiles_policy\">{{ insurance.automobiles_policy[0].serial }}</span> <span ng-if=\"insurance.life_policy\">{{ insurance.life_policy[0].personal.full_name }}</span> <span ng-if=\"insurance.damages_policy\">{{ insurance.damages_policy[0].insured_ }}</span></span> <span ng-if=\"header ===\'Referenciador\'\"><span ng-if=\"vm.permiso_ver_referenciador\"><div ng-if=\"insurance.ref_policy\"><span ng-repeat=\"ref in insurance.ref_policy\">{{ref.referenciador.first_name}} {{ref.referenciador.last_name}}</span></div></span></span> <span ng-if=\"header ===\'Creado por\'\"></span> <span ng-if=\"header ===\'Fecha renovación\'\"></span> <span ng-if=\"header ===\'Póliza Anterior\'\"></span> <span ng-if=\"header ===\'C.P.\'\"></span> <span ng-if=\"header ===\'Agrupación\'\"></span> <span ng-if=\"header ===\'Subagrupación\'\"></span> <span ng-if=\"header ===\'Subsubagrupación\'\"></span> <span ng-if=\"header ===\'Clasificación\'\"></span> <span ng-if=\"header ===\'Línea de Negocio\'\"></span> <span ng-if=\"header ===\'Célula\'\"></span> <span ng-if=\"header ===\'Contacto(nombre)\'\"></span> <span ng-if=\"header ===\'Contacto(telefono)\'\"></span> <span ng-if=\"header ===\'Contacto(email)\'\"></span> <span ng-if=\"header ===\'Sucursal\'\">{{insurance.sucursal}}</span> <span ng-if=\"header ===\'N.Carátula\'\"></span> <span ng-if=\"header ===\'CaratulaContratante\'\"></span> <span ng-if=\"header ===\'Serie(Automovil)\'\">{{ insurance.automobiles_policy[0].serial }}</span></td></tr></tbody></table><div ng-if=\"vm.show_pag_policy_en_proceso\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion2[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina2(pagina2)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina2 in paginacion2.totalPaginas2\" ng-click=\"selecionPagina2(pagina2)\" ng-class=\"{\'active\': pagina === paginacion2.paginaActual2}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina2(pagina2)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><br></div></div></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0)\"><div class=\"row\"><div class=\"panel-body table-over-y\" style=\"display: none\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td ng-if=\"vm.form.group_by.id == 6\">Fecha de Creación</td><td ng-if=\"vm.form.group_by.id == 6\">Número de póliza/fianza</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 1\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.aseguradora__id__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 2\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 3\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Fisicos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.contractor__group__group_name\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Morales</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.contractor__group__group_name\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.vendor__count\"><td>{{ insurance.vendor__first_name }} {{ insurance.vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.vendor__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 6\"><td>{{ insurance.created_at | date: \'medium\'}}</td><td>{{ insurance.poliza_number}}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.created_at__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div><br></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 1\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora/Afianzadora</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.aseguradora__compania && insurance.aseguradora__id__count\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.aseguradora__id__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.aseguradora__compania && insurance.aseguradora__id__count\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.aseguradora__id__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 2\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.ramo__ramo_name && insurance.ramo__count\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.ramo__ramo_name && insurance.ramo__count\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 3\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.subramo__subramo_name && insurance.subramo__count\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.subramo__subramo_name && insurance.subramo__count\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 4\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.naturals_pesos || grupos_result.naturals_dolares\"><b>Contratantes Físicos</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_pesos track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_dolares track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.juridicals_pesos || grupos_result.juridicals_dolares\"><b>Contratantes Morales</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_pesos track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_dolares track by $index\" ng-if=\"insurance.contractor__group__group_name && insurance.contractor__group__count\"><td>{{ insurance.contractor__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.contractor__group__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 5\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 5\">Referenciador</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.ref_policy__referenciador__first_name && insurance.ref_policy__referenciador__count\"><td>{{ insurance.ref_policy__referenciador__first_name }} {{ insurance.ref_policy__referenciador__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.ref_policy__referenciador__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.ref_policy__referenciador__first_name && insurance.ref_policy__referenciador__count\"><td>{{ insurance.ref_policy__referenciador__first_name }} {{ insurance.ref_policy__referenciador__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.ref_policy__referenciador__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 7\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 7\">Usuario</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.owner__first_name && insurance.owner__count\"><td>{{ insurance.owner__first_name }} {{ insurance.owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.owner__first_name && insurance.owner__count\"><td>{{ insurance.owner__first_name }} {{ insurance.owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.owner__count }}</td></tr></tbody></table><br></div></div></div></div></div><div class=\"row\" ng-if=\"showSums\"><div class=\"col-xs-12 col-sm-9 pull-right\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Total Prima Neta:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Total Prima Total:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total | currency}}\" disabled=\"\"></div></div></div><div class=\"row\" ng-if=\"showButtonExcel && vm.acceso_rep_ren && (insurances && insurances.length!=0)\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(1)\">Generar Reporte</button></div><div class=\"col-xs-12 col-sm-6 form-group\"><input type=\"checkbox\" ng-model=\"addSiniestrosBitacora\" ng-click=\"addSiniestros(addSiniestrosBitacora)\" class=\"checkbox\" ng-value=\"addSiniestrosBitacora\">Informar siniestros de Pérdida Total</div></div><style>\n  /* ======== BLOQUE DE FILTROS PROFESIONAL (TONO CLARO) ======== */\n  .filter-card {\n    background-color: #f9fafb; /* tono gris claro */\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    padding: 20px 25px 10px 25px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n    transition: all 0.2s ease-in-out;\n  }\n\n  .filter-card:hover {\n    box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n  }\n\n  .filter-card legend,\n  .filter-card h5 {\n    font-weight: 600;\n    color: #2f4050;\n    font-size: 16px;\n    border-bottom: 1px solid #e5e5e5;\n    padding-bottom: 8px;\n    margin-bottom: 15px;\n  }\n\n  .filter-card label {\n    font-weight: 500;\n    color: #495057;\n    font-size: 13px;\n  }\n\n  .filter-card .form-control,\n  .filter-card select,\n  .filter-card input {\n    border-radius: 4px;\n    border: 1px solid #d1d5db;\n    box-shadow: none;\n    font-size: 13px;\n  }\n\n  .filter-card .form-control:focus {\n    border-color: #1ab394;\n    box-shadow: 0 0 3px rgba(26,179,148,0.4);\n  }\n\n  .filter-card .checkbox label {\n    font-weight: 400;\n    font-size: 13px;\n    color: #333;\n  }\n\n  .filter-card .btn-consultar {\n    background-color: #1ab394;\n    border-color: #18a689;\n    color: white;\n    font-weight: 600;\n    transition: 0.2s;\n  }\n\n  .filter-card .btn-consultar:hover {\n    background-color: #18a689;\n    border-color: #169d81;\n  }\n\n  .datepicker-me .input-group-addon {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-left: 0;\n  }\n\n  .report-highlight {\n    background-color: #eef4f7;\n    border-radius: 6px;\n    padding: 15px;\n    margin-top: 20px;\n    border: 1px solid #dbe3e6;\n  }\n\n  .report-highlight label {\n    color: #2f4050;\n  }\n</style>");
$templateCache.put("app/reportes/reporte.renovacionespendientes.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12\"><h2>Reportes Renovaciones</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Renovaciones Pendientes</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Estatus</label><select class=\"form-control\" ng-model=\"vm.form.status\" ng-options=\"status.name for status in vm.status track by status.id\" ng-change=\"vm.changeStatus(vm.form.status)\"><option value=\"\">Selecciona un estatus</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Frecuencia de Pago</label><select class=\"form-control\" ng-model=\"vm.form.payment\" ng-options=\"payment.name for payment in vm.payment track by payment.id\" ng-change=\"vm.changePayment(vm.form.payment)\"><option value=\"\">Selecciona una frecuencia de pago</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Clave de Agente</label> <input class=\"form-control\" type=\"text\" name=\"agente\" ng-model=\"vm.form.cve_agente\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Agrupar por:</label><select class=\"form-control\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\" disabled=\"\">Seleccione</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"users.username for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Buscar por:</label><select class=\"form-control\" ng-model=\"vm.form.validity\" ng-options=\"option.name for option in vm.validity track by option.id\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Reporte por: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.renovadas\" ng-options=\"option.name for option in vm.option track by option.id\" disabled=\"\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right ladda-buttonC\" ng-click=\"vm.Generar(1,1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Renovaciones</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result && !(grupos_result.length == 0)\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(3, vm.renewal_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(3, $event)\" ng-mouseout=\"finalColumn(3, $event)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_cont_asc == 1, \'fa fa-sort-asc\': vm.renewal_cont_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(1, vm.renewal_nump_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(1, $event)\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_nump_asc == 1, \'fa fa-sort-asc\': vm.renewal_nump_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(4, vm.renewal_aseg_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(4, $event)\" ng-mouseout=\"finalColumn(4, $event)\" ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_aseg_asc == 1, \'fa fa-sort-asc\': vm.renewal_aseg_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(5, vm.renewal_ramo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(5, $event)\" ng-mouseout=\"finalColumn(5, $event)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_ramo_asc == 1, \'fa fa-sort-asc\': vm.renewal_ramo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(6, vm.renewal_subr_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(6, $event)\" ng-mouseout=\"finalColumn(6, $event)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_subr_asc == 1, \'fa fa-sort-asc\': vm.renewal_subr_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(7, vm.renewal_pack_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(7, $event)\" ng-mouseout=\"finalColumn(7, $event)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_pack_asc == 1, \'fa fa-sort-asc\': vm.renewal_pack_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(14, vm.renewal_pneta_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(14, $event)\" ng-mouseout=\"finalColumn(14, $event)\" ng-model=\"vm.table.headers[13]\">{{vm.table.headers[13]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_pneta_asc == 1, \'fa fa-sort-asc\': vm.renewal_pneta_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(15, vm.renewal_rpf_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(15, $event)\" ng-mouseout=\"finalColumn(15, $event)\" ng-model=\"vm.table.headers[14]\">{{vm.table.headers[14]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_rpf_asc == 1, \'fa fa-sort-asc\': vm.renewal_rpf_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(16, vm.renewal_der_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(16, $event)\" ng-mouseout=\"finalColumn(16, $event)\" ng-model=\"vm.table.headers[15]\">{{vm.table.headers[15]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_der_asc == 1, \'fa fa-sort-asc\': vm.renewal_der_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(17, vm.renewal_iva_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(17, $event)\" ng-mouseout=\"finalColumn(17, $event)\" ng-model=\"vm.table.headers[16]\">{{vm.table.headers[16]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_iva_asc == 1, \'fa fa-sort-asc\': vm.renewal_iva_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(18, vm.renewal_ptotal_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(18, $event)\" ng-mouseout=\"finalColumn(18, $event)\" ng-model=\"vm.table.headers[17]\">{{vm.table.headers[17]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_ptotal_asc == 1, \'fa fa-sort-asc\': vm.renewal_ptota_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(19, vm.renewal_com_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(19, $event)\" ng-mouseout=\"finalColumn(19, $event)\" ng-model=\"vm.table.headers[18]\" ng-if=\"vm.permiso_comisiones\">{{vm.table.headers[18]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_com_asc == 1, \'fa fa-sort-asc\': vm.renewal_com_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(8, vm.renewal_frecpago_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(8, $event)\" ng-mouseout=\"finalColumn(8, $event)\" ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_frecpago_asc == 1, \'fa fa-sort-asc\': vm.renewal_frecpago_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(2, vm.renewal_tipo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(2, $event)\" ng-mouseout=\"finalColumn(2, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_tipo_asc == 1, \'fa fa-sort-asc\': vm.renewal_tipo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(9, vm.renewal_status_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(9, $event)\" ng-mouseout=\"finalColumn(9, $event)\" ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_status_asc == 1, \'fa fa-sort-asc\': vm.renewal_status_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(23, vm.renewal_status_ren_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(23, $event)\" ng-mouseout=\"finalColumn(23, $event)\" ng-model=\"vm.table.headers[8]\">Estatus de la Renovación <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_status_ren_asc == 1, \'fa fa-sort-asc\': vm.renewal_status_ren_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(10, vm.renewal_vig_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(10, $event)\" ng-mouseout=\"finalColumn(10, $event)\" ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_vig_asc == 1, \'fa fa-sort-asc\': vm.renewal_vig_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(22, vm.renewal_fin_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(22, $event)\" ng-mouseout=\"finalColumn(22, $event)\" ng-model=\"vm.table.headers[21]\">{{vm.table.headers[21]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_fin_asc == 1, \'fa fa-sort-asc\': vm.renewal_fin_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(11, vm.renewal_creac_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(11, $event)\" ng-mouseout=\"finalColumn(11, $event)\" ng-model=\"vm.table.headers[10]\">{{vm.table.headers[10]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_creac_asc == 1, \'fa fa-sort-asc\': vm.renewal_creac_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(12, vm.renewal_folio_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(12, $event)\" ng-mouseout=\"finalColumn(12, $event)\" ng-model=\"vm.table.headers[11]\">{{vm.table.headers[11]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_folio_asc == 1, \'fa fa-sort-asc\': vm.renewal_folio_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(20, vm.renewal_obser_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(20, $event)\" ng-mouseout=\"finalColumn(20, $event)\" ng-model=\"vm.table.headers[19]\">{{vm.table.headers[19]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_obser_asc == 1, \'fa fa-sort-asc\': vm.renewal_obser_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeRenewal(21, vm.renewal_clave_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(21, $event)\" ng-mouseout=\"finalColumn(21, $event)\" ng-model=\"vm.table.headers[20]\">{{vm.table.headers[20]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.renewal_clave_asc == 1, \'fa fa-sort-asc\': vm.renewal_clave_asc == 2}\"></span></th><th>#OT Renovación</th></tr></thead><tbody><tr ng-repeat=\"insurance in insurances | orderBy: \'aseguradora\' track by $index\" ng-click=\"vm.goToInfo(insurance)\"><td><p>{{ insurance.contractor.full_name }}</p></td><td>{{ insurance.poliza_number }} - {{ insurance.internal_number }}</td><td>{{ insurance.aseguradora }}</td><td>{{ insurance.ramo }}</td><td>{{ insurance.subramo }}</td><td>{{ insurance.paquete }}</td><td align=\"right\">{{ insurance.p_neta | currency }}</td><td align=\"right\">{{ insurance.rpf | currency }}</td><td align=\"right\">{{ insurance.derecho | currency }}</td><td align=\"right\">{{ insurance.iva | currency }}</td><td align=\"right\">{{ insurance.p_total | currency }}</td><td align=\"right\" ng-if=\"vm.permiso_comisiones\">{{ insurance.comision | currency }}</td><td>{{ insurance.forma_de_pago }}</td><td>{{ insurance.document_type }}</td><td>{{ insurance.status }}</td><td><span ng-if=\"insurance.renewed_status == 2\"><strong>En proceso de renovación</strong></span> <span ng-if=\"insurance.renewed_status == 1\"><strong>Renovada</strong></span> <span ng-if=\"insurance.renewed_status == 0\"><strong>No Renovada</strong></span></td><td>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.end_of_validity | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.created_at | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.folio }}</td><td ng-if=\"insurance.f_currency == 1\">PESOS</td><td ng-if=\"insurance.f_currency == 2\">DOLARES</td><td>{{ insurance.observations }}</td><td ng-if=\"insurance.clave.clave\"><span ng-if=\"insurance.clave.name\">{{ insurance.clave.clave }} - {{ insurance.clave.name }}</span> <span ng-if=\"!insurance.clave.name\"><p class=\"hidden-text\"></p></span></td><td>{{insurance.historic}}</td></tr></tbody></table><div ng-if=\"vm.show_pag_renewal\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in insurances track by $index\" ng-if=\"insurance.poliza_number != \' \'\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}: {{ insurance.poliza_number }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.document_type }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p ng-if=\"insurance.natural\">{{ insurance.natural.first_name }}{{ insurance.natural.last_name }} <span ng-if=\"insurance.natural.second_last_name\">{{ insurance.natural.second_last_name }}</span></p><p ng-if=\"!insurance.natural\">{{ insurance.juridical.j_name }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ insurance.aseguradora}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ insurance.ramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p>{{ insurance.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ insurance.paquete }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ insurance.forma_de_pago }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{insurance.status}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.start_of_validity | date: \'dd/MM/yyyy\' }} - {{ insurance.end_of_validity | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[10] }}</label><p>{{ insurance.created_at | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[11] }}</label><p>{{ insurance.folio}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[12] }}</label><p>{{ insurance.f_currency }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[13] }}</label><p>{{ insurance.p_neta}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[14] }}</label><p>{{ insurance.rpf}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[15] }}</label><p>{{ insurance.derecho}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[16] }}</label><p>{{ insurance.iva}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[17] }}</label><p>{{ insurance.p_total}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[18] }}</label><p>{{ insurance.comision}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[19] }}</label><p>{{ insurance.observations}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[20] }}</label><p>{{ insurance.clave.clave }} - {{ insurance.clave.name }}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_renewal\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0)\"><div class=\"row\"><div class=\"panel-body table-over-y\" style=\"display: none\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td ng-if=\"vm.form.group_by.id == 6\">Fecha de Creación</td><td ng-if=\"vm.form.group_by.id == 6\">Número de póliza</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td>Registros</td><tbody><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 1\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.aseguradora__id__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 2\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 3\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Fisicos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.natural__group__group_name\"><td>{{ insurance.natural__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.natural__group__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Morales</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.juridical__group__group_name\"><td>{{ insurance.juridical__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.juridical__group__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.vendor__count\"><td>{{ insurance.vendor__first_name }} {{ insurance.vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.vendor__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 6\"><td>{{ insurance.created_at | date: \'medium\'}}</td><td>{{ insurance.poliza_number}}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td>{{ insurance.created_at__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div><br></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 1\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.aseguradora__compania && insurance.aseguradora__id__count\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.aseguradora__id__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.aseguradora__compania && insurance.aseguradora__id__count\"><td>{{ insurance.aseguradora__compania }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.aseguradora__id__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 2\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.ramo__ramo_name && insurance.ramo__count\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.ramo__ramo_name && insurance.ramo__count\"><td>{{ insurance.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.ramo__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 3\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.subramo__subramo_name && insurance.subramo__count\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.subramo__subramo_name && insurance.subramo__count\"><td>{{ insurance.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.subramo__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 4\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.naturals_pesos || grupos_result.naturals_dolares\"><b>Contratantes Físicos</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_pesos track by $index\" ng-if=\"insurance.natural__group__group_name && insurance.natural__group__count\"><td>{{ insurance.natural__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.natural__group__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals_dolares track by $index\" ng-if=\"insurance.natural__group__group_name && insurance.natural__group__count\"><td>{{ insurance.natural__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.natural__group__count }}</td></tr><tr><td colspan=\"7\" align=\"center\" style=\"color: #0F907F\" ng-if=\"grupos_result.juridicals_pesos || grupos_result.juridicals_dolares\"><b>Contratantes Morales</b></td></tr><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_pesos track by $index\" ng-if=\"insurance.juridical__group__group_name && insurance.juridical__group__count\"><td>{{ insurance.juridical__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.juridical__group__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals_dolares track by $index\" ng-if=\"insurance.juridical__group__group_name && insurance.juridical__group__count\"><td>{{ insurance.juridical__group__group_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.juridical__group__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 5\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 5\">Referenciador</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.vendor__first_name && insurance.vendor__count\"><td>{{ insurance.vendor__first_name }} {{ insurance.vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.vendor__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.vendor__first_name && insurance.vendor__count\"><td>{{ insurance.vendor__first_name }} {{ insurance.vendor__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.vendor__count }}</td></tr></tbody></table><br></div></div></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0) && vm.form.group_by.id == 7\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 7\">Usuario</td><td>Prima Neta</td><td>Prima Total</td><td ng-if=\"vm.permiso_comisiones\">Comisión</td><td ng-if=\"vm.permiso_comisiones\">Comisión conciliada</td><td>Registros</td><tbody><tr><td colspan=\"7\" align=\"center\"><b>Pesos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.pesos track by $index\" ng-if=\"insurance.owner__first_name && insurance.owner__count\"><td>{{ insurance.owner__first_name }} {{ insurance.owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.owner__count }}</td></tr><tr><td colspan=\"7\" align=\"center\"><b>Dólares</b></td></tr><tr ng-repeat=\"insurance in grupos_result.dolares track by $index\" ng-if=\"insurance.owner__first_name && insurance.owner__count\"><td>{{ insurance.owner__first_name }} {{ insurance.owner__last_name }}</td><td>${{ vm.formatearNumero(insurance.p_neta__sum) }}</td><td>${{ vm.formatearNumero(insurance.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.comision__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(insurance.recibos_poliza__comision_conciliada__sum) }}</td><td>{{ insurance.owner__count }}</td></tr></tbody></table><br></div></div></div></div></div><div class=\"row\" ng-if=\"showSums\"><div class=\"col-xs-12 col-sm-9 pull-right\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Total Prima Neta:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_neta_total | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Total Prima Total:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.p_total_total | currency}}\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.permiso_comisiones\"><label>Total Comisión:</label> <input class=\"form-control\" type=\"\" name=\"\" value=\"{{sumas.comision_total | currency}}\" disabled=\"\"></div></div></div><div class=\"row\" ng-if=\"showButtonExcel && vm.acceso_rep_ren\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(1)\">Generar Reporte</button></div></div><script type=\"text/javascript\">  \n  $(window).load(function() { $(\"#state\").select2(); });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script>");
$templateCache.put("app/reportes/reporte.siniestros.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reportes Siniestros</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Siniestros</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtro Básico</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row text-align-center report-highlight\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Reporte de: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.report\" ng-options=\"option.name for option in vm.option_policy track by option.id\" ng-change=\"changeReport()\"><option value=\"\">Selecciona una opción</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Más Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Número de Póliza:</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.num_poliza\"></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Estatus</label><select class=\"form-control\" ng-model=\"vm.form.status\" ng-options=\"status.name for status in vm.status track by status.id\" ng-change=\"vm.changeStatus(vm.form.status)\"><option value=\"\">Todos los estatus</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_celula\"><label>{{moduleName}}</label><select class=\"form-control\" ng-model=\"vm.form.celula\" data-ng-options=\"celula.celula_name for celula in celulas track by celula.url\" ng-change=\"vm.changecelula(vm.form.celula)\"><option value=\"\">Todo</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-model=\"vm.form.businesLine\" data-ng-options=\"businesLine.name for businesLine in vm.businesLine track by businesLine.id\" ng-change=\"vm.changeBLine(vm.form.businesLine)\" required=\"\"><option value=\"\">Todas las líneas</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider)\"><option value=\"\"></option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Subramo (s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.id\" ng-change=\"selectSubramos(select_sramo)\"></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"users.username for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Agrupar por:</label><select class=\"form-control\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\">Seleccione</option></select></div><div class=\"col-sm-6 col-md-3 col-lg-3 form-group\"><label>Carátula:</label><br><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.word\" change=\"vm.getCaratulas(vm.word)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getCarSelected(vm.word)\"><span class=\"fa fa-ok\"></span> Seleccionar</button></div></div></div></div></div></div><div class=\"col-xs-12 text-align-center\"><button class=\"btn btn-success ladda-buttonC\" ng-click=\"vm.Generar(1,1)\">Consultar</button></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Siniestros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" ng-if=\"!grupos_result || grupos_result.length == 0\"><div class=\"rows\"><div class=\"panel-body table-over-y\"><table id=\"example\" class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(1, vm.sinister_num_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(1, $event)\" ng-mouseout=\"finalColumn(1, $event)\" ng-model=\"vm.table.headers[0]\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_num_asc == 1, \'fa fa-sort-asc\': vm.sinister_num_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(11, vm.sinister_fint_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(11, $event)\" ng-mouseout=\"finalColumn(11, $event)\" ng-model=\"vm.table.headers[10]\">{{vm.table.headers[10]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_fint_asc == 1, \'fa fa-sort-asc\': vm.sinister_fint_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(12, vm.sinister_affect_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(12, $event)\" ng-mouseout=\"finalColumn(12, $event)\" ng-model=\"vm.table.headers[11]\">{{vm.table.headers[11]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_affect_asc == 1, \'fa fa-sort-asc\': vm.sinister_affect_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(13, vm.sinister_affect_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(13, $event)\" ng-mouseout=\"finalColumn(13, $event)\" ng-model=\"vm.table.headers[11]\">Versión <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_affect_asc == 1, \'fa fa-sort-asc\': vm.sinister_affect_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(14, vm.sinister_affect_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(14, $event)\" ng-mouseout=\"finalColumn(14, $event)\" ng-model=\"vm.table.headers[11]\">Marca <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_affect_asc == 1, \'fa fa-sort-asc\': vm.sinister_affect_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(15, vm.sinister_affect_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(15, $event)\" ng-mouseout=\"finalColumn(15, $event)\" ng-model=\"vm.table.headers[11]\">Modelo <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_affect_asc == 1, \'fa fa-sort-asc\': vm.sinister_affect_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(2, vm.sinister_status_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(2, $event)\" ng-mouseout=\"finalColumn(2, $event)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_status_asc == 1, \'fa fa-sort-asc\': vm.sinister_status_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(3, vm.sinister_fini_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(3, $event)\" ng-mouseout=\"finalColumn(3, $event)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_fini_asc == 1, \'fa fa-sort-asc\': vm.sinister_fini_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(4, vm.sinister_fing_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(4, $event)\" ng-mouseout=\"finalColumn(4, $event)\" ng-model=\"vm.table.headers[3]\">{{vm.table.headers[3]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_fing_asc == 1, \'fa fa-sort-asc\': vm.sinister_fing_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(5, vm.sinister_npol_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(5, $event)\" ng-mouseout=\"finalColumn(5, $event)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_npol_asc == 1, \'fa fa-sort-asc\': vm.sinister_npol_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(6, vm.sinister_cont_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(6, $event)\" ng-mouseout=\"finalColumn(6, $event)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_cont_asc == 1, \'fa fa-sort-asc\': vm.sinister_cont_asc == 2}\"></span></th><th>Grupo</th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(7, vm.sinister_aseg_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(7, $event)\" ng-mouseout=\"finalColumn(7, $event)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_aseg_asc == 1, \'fa fa-sort-asc\': vm.sinister_aseg_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(8, vm.sinister_ramo_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(8, $event)\" ng-mouseout=\"finalColumn(8, $event)\" ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_ramo_asc == 1, \'fa fa-sort-asc\': vm.sinister_ramo_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(9, vm.sinister_subr_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(9, $event)\" ng-mouseout=\"finalColumn(9, $event)\" ng-model=\"vm.table.headers[8]\">{{vm.table.headers[8]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_subr_asc == 1, \'fa fa-sort-asc\': vm.sinister_subr_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(12, vm.sinister_reclamado_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(12, $event)\" ng-mouseout=\"finalColumn(12, $event)\" ng-model=\"vm.table.headers[12]\">{{vm.table.headers[12]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_reclamado_asc == 1, \'fa fa-sort-asc\': vm.sinister_reclamado_asc == 2}\"></span></th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(17, vm.sinister_proc_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(17, $event)\" ng-mouseout=\"finalColumn(17, $event)\" ng-model=\"vm.table.headers[17]\">Procedente <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_proc_asc == 1, \'fa fa-sort-asc\': vm.sinister_proc_asc == 2}\"></span></th><th>Deducible</th><th>Coaseguro</th><th>Total Final</th><th drag-me=\"\" drop-me=\"\" ng-click=\"vm.changeSinister(10, vm.sinister_obs_asc == 1 ? 2 : 1)\" ng-mouseenter=\"currentColumn(10, $event)\" ng-mouseout=\"finalColumn(10, $event)\" ng-model=\"vm.table.headers[9]\">{{vm.table.headers[9]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sinister_obs_asc == 1, \'fa fa-sort-asc\': vm.sinister_obs_asc == 2}\"></span></th><th>Tipo de trámite</th><th>Fecha creación</th><th ng-if=\"vm.permiso_ver_referenciador\">Referenciador</th><th>Bitácora</th><th>Número de Serie</th><th>Subgrupo</th><th>Subsubgrupo</th><th>Agrupación</th><th>Subagrupación</th><th>Subsubagrupación</th><th>Clasificación</th><th>Línea de Negocio</th><th>Célula</th><th>Fecha Terminación</th><th>Fecha Bitácora</th><th>Creado Por</th><th>Folio de la Aseguradora</th></tr></thead><tbody><tr ng-repeat=\"insurance in insurances track by $index\" style=\"height: 36px;\" ng-click=\"vm.goToInfo(insurance)\" on-finish-render=\"ngRepeatFinished\"><td ng-if=\"insurance.numero_siniestro\">{{ insurance.numero_siniestro }}</td><td ng-if=\"!insurance.numero_siniestro\">Sin número asignado</td><td>{{ insurance.folio_interno }}</td><td><span ng-if=\"!insurance.aux_affected && insurance.poliza.document_type !=3\">{{ insurance.poliza.accidents_policy[0].personal.first_name }} {{insurance.poliza.accidents_policy[0].personal.last_name}} {{insurance.poliza.accidents_policy[0].personal.second_last_name}}{{ insurance.poliza.life_policy[0].personal.full_name }}{{insurance.poliza.damages_policy[0].insured_item}}</span> <span ng-if=\"insurance.poliza.automobiles_policy.length >0\">Serie: {{ insurance.poliza.automobiles_policy[0].serial}}</span> <span ng-if=\"insurance.aux_affected\">{{insurance.aux_affected}}</span></td><td><span ng-if=\"insurance.poliza.automobiles_policy.length>0\">{{ insurance.poliza.automobiles_policy[0].version}}</span></td><td><span ng-if=\"insurance.poliza.automobiles_policy.length >0\">{{ insurance.poliza.automobiles_policy[0].brand}}</span></td><td><span ng-if=\"insurance.poliza.automobiles_policy.length >0\">{{ insurance.poliza.automobiles_policy[0].model}}</span></td><td>{{ insurance.status }}</td><td>{{ insurance.fecha_siniestro | date: \'dd/MM/yyyy\' }}</td><td>{{ insurance.fecha_ingreso | date: \'dd/MM/yyyy\'}}</td><td>{{ insurance.poliza.poliza_number }}</td><td>{{ insurance.poliza.contractor.full_name }}</td><td>{{ insurance.poliza.contractor.group }}</td><td>{{ insurance.poliza.aseguradora }}</td><td>{{ insurance.ramo }}</td><td>{{ insurance.poliza.subramo }}</td><td>{{insurance.reclamado | currency : symbol : fractionSize}}</td><td>{{insurance.procedente | currency : symbol : fractionSize}}</td><td>{{insurance.deducible | currency : symbol : fractionSize}}</td><td>{{insurance.coaseguro | currency : symbol : fractionSize}}</td><td>{{insurance.total_final | currency : symbol : fractionSize}}</td><td>{{ insurance.observations }}</td><td><span ng-if=\"insurance.poliza.subramo == \'Gastos Médicos\'\"><span ng-if=\"insurance.accidente_sinister\"><span ng-if=\"insurance.accidente_sinister[0].tipo_pago == 1\">Reembolso</span> <span ng-if=\"insurance.accidente_sinister[0].tipo_pago == 2\">Programación</span> <span ng-if=\"insurance.accidente_sinister[0].tipo_pago == 3\">Pago directo</span> <span ng-if=\"insurance.accidente_sinister[0].tipo_pago == 4\">Aclaración</span></span></span></td><td>{{insurance.created_at | date: \'dd/MM/yyyy\'}}</td><td ng-if=\"vm.permiso_ver_referenciador\"><span ng-if=\"insurance.poliza.ref_policy.length > 0\"><div ng-repeat=\"ref in insurance.poliza.ref_policy\">{{ref.referenciador.first_name}} {{ref.referenciador.last_name}}</div></span> <span ng-if=\"insurance.poliza.ref_policy.length == 0\">{{insurance.poliza.vendor.first_name}} {{insurance.poliza.vendor.last_name}}</span></td><td><span ng-if=\"insurance.last_comment\"><b>Comentario:</b> {{insurance.last_comment.content}}<br><b>Hora:</b> {{insurance.last_comment.created_at | date:\'dd/MM/yyyy - HH:mm:ss\'}}</span></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>{{insurance.owner}}</td><td>{{insurance.folio_compania}}</td></tr></tbody></table><div ng-if=\"vm.show_pag_sinisters\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div><br><div class=\"ibox float-e-margins border-bottom visible-xs-block visible-sm-block\" ng-repeat=\"insurance in insurances track by $index\" ng-if=\"insurance.numero_siniestro != \' \'\"><div class=\"ibox-title\"><h5>{{ vm.table.headers[0] }}: {{ insurance.numero_siniestro }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: none\"><table class=\"table-flex\"><tr class=\"table-row\"><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[0] }}</label><p>{{ insurance.numero_siniestro }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[1] }}</label><p>{{ insurance.status }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[2] }}</label><p>{{ insurance.fecha_siniestro | date: \'dd/MM/yyyy\' }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[3] }}</label><p>{{ insurance.fecha_ingreso | date: \'dd/MM/yyyy\'}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[4] }}</label><p>{{ insurance.poliza.poliza_number }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[5] }}</label><p ng-if=\"insurance.poliza.contractor\">{{ insurance.poliza.contractor }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[6] }}</label><p>{{ insurance.poliza.aseguradora}}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[7] }}</label><p>{{ insurance.ramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[8] }}</label><p>{{ insurance.poliza.subramo }}</p></div><div class=\"table-cell col-xs-12 col-sm-6\"><label>{{ vm.table.headers[9] }}</label><p>{{ insurance.reason }}</p></div></tr></table></div></div><div ng-if=\"vm.show_pag_sinisters\" class=\"text-center visible-xs-block visible-sm-block\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div><br></div><div class=\"ibox-content\" ng-if=\"grupos_result && !(grupos_result.length == 0)\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead></thead><td ng-if=\"vm.form.group_by.id == 1\">Aseguradora</td><td ng-if=\"vm.form.group_by.id == 2\">Ramo</td><td ng-if=\"vm.form.group_by.id == 3\">Subramo</td><td ng-if=\"vm.form.group_by.id == 4\">Grupo</td><td ng-if=\"vm.form.group_by.id == 5\">Vendedor</td><td ng-if=\"vm.form.group_by.id == 6\">Estatus</td><td ng-if=\"vm.form.group_by.id == 7\">Usuario</td><td>Registros</td><tbody><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 1\"><td>{{ insurance.poliza__aseguradora__compania }}</td><td>{{ insurance.poliza__aseguradora__id__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 2\"><td>{{ insurance.poliza__ramo__ramo_name }}</td><td>{{ insurance.poliza__ramo__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 3\"><td>{{ insurance.poliza__subramo__subramo_name }}</td><td>{{ insurance.poliza__subramo__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Fisicos</b></td></tr><tr ng-repeat=\"insurance in grupos_result.naturals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.poliza__contractor__group__group_name\"><td>{{ insurance.poliza__contractor__group__group_name }}</td><td>{{ insurance.poliza__contractor__group__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 4\"><td colspan=\"4\" align=\"center\"><b>Contratantes Morales</b></td></tr><tr ng-repeat=\"insurance in grupos_result.juridicals track by $index\" ng-if=\"vm.form.group_by.id == 4 && insurance.poliza__contractor__group__group_name\"><td>{{ insurance.poliza__contractor__group__group_name }}</td><td>{{ insurance.poliza__contractor__group__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 5 && insurance.poliza__vendor__count\"><td>{{ insurance.poliza__vendor__first_name }} {{ insurance.poliza__vendor__last_name }}</td><td>{{ insurance.poliza__vendor__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 7 && insurance.owner__count\"><td>{{ insurance.owner__first_name }} {{ insurance.owner__last_name }}</td><td>{{ insurance.owner__count }}</td></tr><tr ng-repeat=\"insurance in grupos_result track by $index\" ng-if=\"vm.form.group_by.id == 6\"><td>{{ status(insurance.status) }}</td><td>{{ insurance.status__count }}</td></tr></tbody></table><div ng-if=\"vm.show_pag_cobranza\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div><br></div></div></div></div><div class=\"row\" ng-if=\"showButtonExcel && vm.acceso_rep_sin\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-click=\"exportDataExcel(1)\">Generar Reporte</button></div></div><style>\n  /* === Limpieza visual para secciones === */\n  .filter-section {\n    border: 1px solid #e7eaec;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    padding: 15px 15px 5px 15px;\n    background-color: #fcfcfc;\n  }\n  .filter-section legend {\n    font-size: 14px;\n    font-weight: 600;\n    color: #000000;\n    border-bottom: 1px solid #fafdff;\n    margin-bottom: 15px;\n    padding-bottom: 5px;\n  }\n  .report-highlight {\n    background-color: #eef4f7;\n    border-radius: 6px;\n    padding: 15px;\n    margin-top: 20px;\n    border: 1px solid #dbe3e6;\n  }\n\n  .btn-consultar {\n    margin-top: 20px;\n  }\n</style>");
$templateCache.put("app/reportes/reporte.task.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reporte Tareas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Tareas</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group\"><label>Creado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_created_by\" data-ng-options=\"(users.first_name + \' \' + users.last_name) for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectCreatedBy(select_created_by)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group\"><label>Cerrado por</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_close_by\" data-ng-options=\"(users.first_name + \' \' + users.last_name) for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectCloseBy(select_close_by)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group\"><label>Involucrados</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_involved\" data-ng-options=\"(users.first_name + \' \' + users.last_name) for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectInvolved(select_involved)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Reporte por</label><select class=\"form-control\" ng-model=\"vm.form.report_by\" ng-options=\"report_by.name for report_by in vm.report_by track by report_by.id\" ng-change=\"vm.changeGroupBy()\"><option value=\"\">Seleccione</option></select></div><div align=\"center\" class=\"row\" ng-if=\"vm.form.report_by\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><br><div><div class=\"col-xs-6 form-group\"><legend class=\"legend-title\" align=\"center\">Prioridad</legend><div class=\"col-xs-12 col-sm-3\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox\"><label ng-class=\"{\'receipts-select\': priority_task == \'1\'}\"><input type=\"radio\" ng-model=\"priority_task\" ng-click=\"selectPriority(priority_task)\" value=\"1\"> Alta</label></div></div><div class=\"col-xs-12 col-sm-3\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': priority_task == \'2\'}\"><input type=\"radio\" ng-model=\"priority_task\" ng-click=\"selectPriority(priority_task)\" value=\"2\"> Media</label></div></div><div class=\"col-xs-12 col-sm-3\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': priority_task == \'3\'}\"><input type=\"radio\" ng-model=\"priority_task\" ng-click=\"selectPriority(priority_task)\" value=\"3\"> Baja</label></div></div><div class=\"col-xs-12 col-sm-3\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label ng-class=\"{\'receipts-select\': priority_task == \'0\'}\"><input type=\"radio\" ng-model=\"priority_task\" ng-click=\"selectPriority(priority_task)\" value=\"0\"> Todos</label></div></div></div></div><div class=\"col-xs-6 form-group\"><legend class=\"legend-title\" align=\"center\">Estatus</legend><div class=\"col-xs-12 col-sm-3\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label><input type=\"checkbox\" ng-model=\"vm.form.archived\" ng-change=\"estatusTask(0)\">Archivada</label></div></div><div class=\"col-xs-12 col-sm-3 checkbox\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label><input type=\"checkbox\" ng-model=\"vm.form.closed\" ng-change=\"estatusTask(0)\">Completada</label></div></div><div class=\"col-xs-12 col-sm-3 checkbox\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label><input type=\"checkbox\" ng-model=\"vm.form.opened\" ng-change=\"estatusTask(0)\">Abierta</label></div></div><div class=\"col-xs-12 col-sm-3 checkbox\" align=\"center\"><label>&nbsp;</label><div class=\"checkbox margin-top-5\"><label><input type=\"checkbox\" ng-model=\"vm.form.todos\" ng-change=\"estatusTask(1)\">Todos</label></div></div></div><hr></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right\" ng-click=\"getTasks(1,1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Tareas</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"tasks\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width\"><thead><tr><th>Estatus</th><th>Identificador</th><th>Título</th><th>Fecha</th><th>Prioridad</th><th>Concepto</th><th>Descripción</th><th>Asignada a</th><th>Creado por</th><th>Antigüedad</th><th>Involucrados</th><th>Cerrado por</th></tr></thead><tbody><tr ng-repeat=\"task in tasks track by $index\"><td><span ng-if=\"task.closed\">Completada</span><span ng-if=\"!task.closed\">Vigente</span> <span ng-if=\"task.archived\">Archivada</span></td><td>{{task.identifier}}</td><td>{{task.title}}</td><td>{{task.date | date:\"dd/MM/yyyy\"}}</td><td>{{ prior(task.priority) }}</td><td>{{ concept(task.concept) }}</td><td>{{task.descrip }}</td><td>{{task.assigned.first_name }} {{task.assigned.last_name}}</td><td>{{task.owner.first_name }} {{task.owner.last_name}}</td><td>{{task.antiguedad }}</td><td><div ng-repeat=\"inv in task.involved_task track by $index\" ng-if=\"task.involved_task\"><span><span class=\"color-blue\">#{{$index +1}}:</span>{{inv.person.first_name}} {{inv.person.last_name}}</span></div></td><td>{{task.closedBy.first_name }} {{task.closedBy.last_name}}</td></tr></tbody></table><div ng-if=\"vm.show_pag_task && tasks.length > 0\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div><button ng-if=\"tasks.length > 0\" ng-click=\"export(1)\" class=\"btn btn-primary pull-right ladda-button_excel\"><i class=\"fa fa-download\"></i> Reporte en excel</button></div></div></div><script type=\"text/javascript\">  \n  $(window).load(function() { $(\"#state\").select2(); });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script>");
$templateCache.put("app/reportes/reporte.ventacruzada.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reporte Venta Cruzada</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Venta Cruzada</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Referenciador</label><select class=\"form-control\" ng-model=\"vm.form.vendedor\" data-ng-options=\"vendedor.name for vendedor in vm.vendedores | orderBy: \'name\' track by vendedor.id\" ng-change=\"filterChanged()\"><option value=\"\">Todos los referenciadores</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Grupo</label><autocomplete datasource=\"groups_data\" id=\"groups\" model=\"vm.form.group\" change=\"vm.matchesGroup(vm.form.group.val);filterChanged()\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_provider\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in vm.providers | orderBy: \'alias\' track by providers.url\" ng-change=\"selectProv(select_provider);filterChanged()\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo\" ng-change=\"selectRamos(select_ramo); filterChanged()\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected track by subramos_toselected.subramo_code\" ng-change=\"selectSubramos(select_sramo);filterChanged()\"></select></div></div><div class=\"row\"><h3 style=\"margin-left: 15px; margin-top: 20px; margin-bottom: 15px;\" class=\"form-group\">PERO NO CUENTA CON POLIZAS VIGENTES DE:</h3><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_ramo_not\" ng-change=\"selectRamosNot(select_ramo_not)\"><option value=\"1\">Vida</option><option value=\"2\">Accidentes y Enfermedades</option><option value=\"3\">Daños</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo(s)</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_sramo_not\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in vm.subramos_toselected_not track by subramos_toselected.subramo_code\" ng-change=\"selectSubramosToNot(select_sramo_not)\"></select></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right ladda-button\" ng-click=\"getClientes()\">Consultar</button><div class=\"col-xs-12\"></div></div></div><div class=\"row mt-3\"><div class=\"col-md-6\"><div class=\"checkbox i-checks\"><label><input type=\"checkbox\" ng-model=\"vm.form.only_active\" ng-change=\"filterChanged()\"> <i></i> Considerar Contratantes sin pólizas vigentes</label></div></div><div class=\"col-md-6\"><div class=\"checkbox i-checks\"><label><input type=\"checkbox\" ng-model=\"vm.form.notifyInactiveBranches\"> <i></i> Notificar ramos y subramos donde tuvo pólizas inactivas</label></div></div></div></div></div></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Clientes</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\" style=\"display: block;\"><div class=\"row\"><div class=\"panel-body table-over-y\"><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Nombre</th><th>Correo</th><th>Correo 2</th><th>Correo 3</th><th>Teléfono</th><th>Teléfono 2</th><th>Teléfono 3</th><th>RFC</th><th>Fecha de establecimiento</th><th>Grupo</th><th>Ramo: Vida</th><th>Ramo: Accidentes y Enfermedades</th><th>Ramo: Daños</th></tr></thead><tbody><tr ng-repeat=\"contractor in edoclientes track by $index\"><td>{{contractor.full_name}}</td><td>{{contractor.email}}</td><td ng-if=\"contractor.email_contractor && contractor.email_contractor.length>0\">{{contractor.email_contractor[0].correo}}</td><td ng-if=\"contractor.email_contractor && contractor.email_contractor.length == 0\"></td><td ng-if=\"contractor.email_contractor && contractor.email_contractor.length>1\">{{contractor.email_contractor[1].correo}}</td><td ng-if=\"contractor.email_contractor && contractor.email_contractor.length < 2\"></td><td>{{contractor.phone_number}}</td><td ng-if=\"contractor.phone_contractor && contractor.phone_contractor.length>0\">{{contractor.phone_contractor[0].phone}}</td><td ng-if=\"contractor.phone_contractor && contractor.phone_contractor.length == 0\"></td><td ng-if=\"contractor.phone_contractor && contractor.phone_contractor.length>1\">{{contractor.phone_contractor[1].phone}}</td><td ng-if=\"contractor.phone_contractor && contractor.phone_contractor.length < 2\"></td><td>{{contractor.rfc}}</td><td>{{contractor.birth_date}}</td><td>{{contractor.group}}</td><td ng-if=\"contractor.has_vida\">Activo</td><td ng-if=\"!contractor.has_vida\"></td><td ng-if=\"contractor.has_gmm\">Activo</td><td ng-if=\"!contractor.has_gmm\"></td><td ng-if=\"contractor.has_danios\">Activo</td><td ng-if=\"!contractor.has_danios\"></td></tr></tbody></table><div ng-if=\"vm.ver_pagiando\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"></li></ul></nav></div></div><div class=\"row text-center mt-3 mb-3\"><div class=\"col-md-12\"><button ng-if=\"edoclientes.length > 0\" ng-click=\"export()\" class=\"btn btn-primary btn-lg ladda-button_excel\">Exportar Reporte en Excel</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/reportes/reportexcel.option.html","<div class=\"inmodal\" id=\"modal_email\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Reporte por</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"row\"><div class=\"row\"><div class=\"col-xs-12 form-group text-center\"><label for=\"selectType\" align=\"center\">Elija una opción:</label><br><hr><input name=\"optionSent\" ng-value=\"1\" ng-model=\"optionSent\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\" ng-change=\"selectReport(optionSent)\"><span for=\"optionSent\">Totales de la Agrupación</span><br></div><div class=\"col-xs-12 form-group text-center\"><input name=\"optionSent\" ng-value=\"2\" ng-model=\"optionSent\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\" ng-change=\"selectReport(optionSent)\"><span for=\"optionSent\">Desglose de la consulta</span><br></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-primary ladda-button\" ng-click=\"downloadReport(optionSent)\">Generar reporte</button></div></div>");
$templateCache.put("app/repositorio/repositorio.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Repositorio de Pago</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Repositorio de Pago</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Repositorios de Pago</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><table class=\"table table-hover table-bordered\"><thead><tr><th>Nombre del archivo</th><th>Total de movimientos</th><th>Movimientos subidos</th><th>Movimientos no subidos</th><th>Fecha de movimiento</th><th>Usuario</th><th>Acción</th></tr></thead><tbody><tr ng-repeat=\"layout in layouts\"><td><b>{{ layout.nombre_archivo }}</b><br><small>{{ layout.fuente }}</small></td><td>{{ layout.registros_del_archivo }}</td><td>{{ layout.movimientos_cargados }}</td><td>{{ layout.movimientos_no_cargados }}</td><td>{{ layout.created_at | date: \'medium\' }}</td><td>{{ layout.owner }}</td><td><a class=\"btn btn-white\" href=\"{{layout.arch}}\" target=\"_blank\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_rp\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPagesP()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPagesP | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPageP(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPagesP()\" ng-if=\"totalPagesP.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPageP()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div></div></div>");
$templateCache.put("app/siniestros/email_siniestro.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Enviar Correo Electrónico</h4><span ng-if=\"poliza && poliza.poliza_number\"><b>Póliza:</b> {{poliza.poliza_number}}</span> <span ng-if=\"siniestro && siniestro.numero_siniestro\"><b>Siniestro:</b> {{siniestro.numero_siniestro}}</span></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Enviar Correo Electrónico\" id=\"email\"><div class=\"panel-body\"><div><h4>Por favor ingrese el o los correo(s) electrónico(s) a quien se desea enviar un correo electrónico:</h4><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Correo electrónico<span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><p><input class=\"form-control\" type=\"email\" name=\"email_assign_mail\" ng-model=\"vmm.email_assign_mail\" required=\"\"><div class=\"input-group-btn\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"addEmail(vmm.email_assign_mail)\">Agregar</button></div></p></div><input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{emailcontractor}}\" ng-show=\"emailcontractor\" ng-click=\"addEmail(emailcontractor)\"> <input class=\"btn btn-white btn-mt\" type=\"button\" name=\"\" value=\"{{emailAsegurado}}\" ng-show=\"emailAsegurado\" ng-click=\"addEmail(emailAsegurado)\"></div></div><div class=\"form-group\"><br><label>Se enviara a:</label><table class=\"table table-bordered\"><thead><th>Correo electrónico</th><th>Acciones</th></thead><tr ng-repeat=\"email in emails track by $index\"><td>{{email}}</td><td><button class=\"btn btn-danger\" ng-click=\"remove_email($index)\"><i class=\"fa fa-trash\"></i></button></td></tr></table></div></div><div class=\"form-group col-xs-12\" ng-if=\"plantillas\"><label>Plantilla(s):</label><select class=\"form-control\" ng-options=\"item.name for item in plantillas\" ng-change=\"changePlantilla(plantilla)\" ng-model=\"plantilla\"><option value=\"\">Selecciona una plantilla</option></select></div><div class=\"form-group col-xs-12\"><div class=\"form-group col-xs-12\"><label>Asunto:</label> <input class=\"col-xs-12 form-control\" type=\"text\" name=\"subjectEmail\" ng-model=\"subjectEmail\" ng-blur=\"emptySubject(subjectEmail)\"></div><div text-angular=\"\" ng-model=\"first_comment\" name=\"first_comment\"></div><br><div ng-bind-html=\"body\" name=\"body\"></div><div text-angular=\"\" ng-model=\"second_comment\" name=\"second_comment\"></div><br></div><table ng-if=\"files && files.length\" class=\"table table-bordered\"><br><h3><span class=\"text-align-center\"><b>Seleccione los archivos que desea compartir:</b></span></h3><thead><tr><th>Archivo</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in files track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong></td><td><div class=\"col-md-4\" ng-init=\"file.shared_email = false\"><input type=\"checkbox\" ng-model=\"file.shared_email\" ng-change=\"shareFileEmail(file,file.shared_email)\"> <label>Compartir</label></div><div class=\"col-md-4\"><a class=\"btn btn-primary pull-right\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a></div></td></tr></tbody></table><div><button class=\"btn btn-primary pull-right ladda-button\" ng-disabled=\"!emails.length > 0\" ng-click=\"sendEmailSiniestro(first_comment,second_comment)\">Compartir por Email</button></div></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button></div><script>\n    function renombrarArchivoCargado(){\n        var strongTag = $(event.target).parent().parent().find(\"td strong\");\n        var inputTag = $(event.target).parent().parent().find(\"td input\");\n\n        strongTag.hide();\n        inputTag.show();\n        inputTag.focus();\n    }\n\n    function blurArchivoCargado(){\n        var strongTag = $(event.target).parent().parent().find(\"td strong\");\n        var inputTag = $(event.target);\n\n        strongTag.show();\n        inputTag.hide();\n    }\n</script><style type=\"text/css\">\n  .to_send = {\n    background-color: red;\n  }\n</style>");
$templateCache.put("app/siniestros/facturas.observation.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Observaciones</h4></div><div class=\"modal-body\"><label>Observaciones:</label> <textarea class=\"form-control\" ng-model=\"observation_aux\" step=\"any\" type=\"text\"></textarea></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Guardar</button></div></div>");
$templateCache.put("app/siniestros/modal.finiquito.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Hoja de finiquito</h4></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"form-group col-sm-11\"><label for=\"motivo\">Número de cheque: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"motivo\" ng-model=\"data.cheque\" class=\"form-control\"></div><div class=\"form-group col-sm-11\"><label for=\"motivo\">Observaciones o carta: <span class=\"color-red\">*</span></label> <textarea ng-model=\"data.observaciones\" class=\"form-control\"></textarea></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"close()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success ladda-button\" ng-click=\"visualizar(data)\" type=\"button\">Ver finiquito</button></div>");
$templateCache.put("app/siniestros/new_siniestros.table.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Siniestros</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Siniestros</strong></li></ol></div></div><div><br><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Número de Póliza:</label> <input type=\"text\" class=\"form-control\" ng-model=\"filters.numero_poliza\" ng-blur=\"clearInput(filters.numero_poliza,filters.certificado)\"> <label ng-if=\"filters.numero_poliza.length >= 3\"><input type=\"checkbox\" name=\"valueCheck\" ng-model=\"isAddCert\" ng-change=\"isColectividadOK(isAddCert)\">Certificado</label></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"isColectividad\"><label>Número de Certificado</label> <input class=\"form-control\" type=\"text\" name=\"poliza\" ng-model=\"filters.certificado\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Número de Siniestro:</label> <input type=\"text\" class=\"form-control\" ng-model=\"filters.numero_siniestro\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Folio Compañia:</label> <input type=\"text\" class=\"form-control\" ng-model=\"filters.folio_compania\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Ramo</label><select class=\"form-control\" ng-model=\"filters.ramo\" ng-options=\"ramo.name for ramo in vm.ramo track by ramo.id\" ng-change=\"getSiniestros()\"><option value=\"\">Seleccione un ramo</option></select></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-if=\"filters.ramo.id == 2\"><label>Afectado:</label> <input type=\"text\" class=\"form-control\" ng-model=\"filters.affected_full_name\"></div><div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Estatus</label><select class=\"form-control\" ng-model=\"filters.estatus\" ng-options=\"estatus.name for estatus in vm.status track by estatus.id\" ng-change=\"getSiniestros()\"><option value=\"\">Seleccione un estatus</option></select></div></div><div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Filtro de Fechas</label><select class=\"form-control\" ng-model=\"filters.fechas\" ng-options=\"fechas.name for fechas in vm.fechas track by fechas.id\"><option value=\"\">Seleccione un tipo de Fecha</option></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"campo_lineanegocio\"><label>Línea de Negocio</label><select class=\"form-control\" ng-model=\"vm.form.businesLine\" data-ng-options=\"businesLine.name for businesLine in vm.businesLine track by businesLine.id\" ng-change=\"vm.changeBLine(vm.form.businesLine)\" required=\"\"><option value=\"\">Todas las líneas</option></select></div><div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Tipo</label><select class=\"form-control\" ng-model=\"filters.tipo\" ng-options=\"tipo.name for tipo in vm.tipos track by tipo.id\" ng-change=\"getSiniestros()\"><option value=\"\">Seleccione un tipo</option></select></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-if=\"filters.fechas\"><label>Desde</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"filters.since\" value=\"\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-if=\"filters.fechas\"><label>Hasta</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"filters.until\" value=\"\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Carátula:</label><br><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteData\" model=\"vm.word\" change=\"vm.getCaratulas(vm.word)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getCarSelected(vm.word)\"><span class=\"fa fa-ok\"></span> Seleccionar</button></div></div></div><br><br><div class=\"col-xs-12 m-t\"><button class=\"btn btn-success pull-right\" ng-click=\"getSiniestros()\" ng-if=\"vm.acceso_adm_sin\">Consultar</button></div></div><ul id=\"contextSiniestros\" class=\"dropdown-menu\" role=\"menu\" z-index=\"1000\"></ul><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Siniestros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"results-container\"><div class=\"panel-body table-over-y\" id=\"exportable\"><table class=\"table table-stripped table-hover hidden-xs hidden-sm\"><thead><tr><th>No. Siniestro</th><th>Folio Interno</th><th ng-if=\"filters.ramo.id == 2\">Afectado</th><th ng-if=\"filters.ramo.id == 2\">Titular</th><th>Estatus</th><th ng-if=\"filters.ramo.id == 2\">Tipo</th><th>Fecha ocurrio</th><th>Fecha Ingreso</th><th>No. Poliza</th><th>No. Certificado</th><th>Contratante</th><th>Aseguradora</th><th>Subramo</th><th ng-if=\"filters.ramo.id == 2\">Padecimiento</th><th ng-if=\"filters.ramo.id == 2\">Total Reclamado</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"siniestro in siniestros track by $index\" ng-click=\"vm.goToSinister(siniestro.tipo_siniestro_general, siniestro.id)\" context=\"contextSiniestros\" ng-right-click=\"ShowContextMenu(\'Información siniestros\', siniestro.id, siniestro.tipo_siniestro_general)\"><td>{{ siniestro.numero_siniestro }}</td><td>{{ siniestro.folio_interno }}</td><td ng-if=\"filters.ramo.id == 2\">{{ siniestro.accidente_sinister[0].affected_full_name}}</td><td ng-if=\"filters.ramo.id == 2\">{{ siniestro.poliza.accidents_policy[0].personal.first_name }} {{ siniestro.poliza.accidents_policy[0].personal.last_name}} {{ siniestro.poliza.accidents_policy[0].personal.second_last_name}}</td><td>{{ siniestro.status }}</td><td ng-if=\"filters.ramo.id == 2\"><div ng-if=\"siniestro.accidente_sinister[0].initial == true\" class=\"label\" ng-class=\"{ \'label-primary\': siniestro.accidente_sinister[0].initial == true, \'label-info\': siniestro.accidente_sinister[0].initial == false }\"><span>Inicial</span></div><div ng-if=\"siniestro.accidente_sinister[0].initial == false\" class=\"label\" ng-class=\"{ \'label-primary\': siniestro.accidente_sinister[0].initial == true, \'label-info\': siniestro.accidente_sinister[0].initial == false }\"><span>Complemento</span></div></td><td>{{ siniestro.fecha_siniestro | date: \'dd/MM/yyyy\': \'UTC\' }}</td><td>{{ siniestro.fecha_ingreso | date: \'dd/MM/yyyy\': \'UTC\' }}</td><td>{{ siniestro.poliza.poliza_number}}</td><td ng-if=\"siniestro.poliza.certificate_number\">{{ siniestro.poliza.certificate_number}}</td><td ng-if=\"!siniestro.poliza.certificate_number\"></td><td>{{ siniestro.contratante_name}}</td><td>{{ siniestro.aseguradora_name}}</td><td>{{ siniestro.poliza.subramo}}</td><td ng-if=\"filters.ramo.id == 2\">{{ siniestro.accidente_sinister[0].ailment}}</td><td ng-if=\"filters.ramo.id == 2\">{{ siniestro.accidente_sinister[0].total_reclamado}}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(siniestro);\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a> <button class=\"btn btn-white btn-sm\" ng-if=\"vm.whatsappWebEnabled\" ng-click=\"$event.stopPropagation(); vm.sendWhatsAppWeb(siniestro, siniestro.poliza)\"><i class=\"fa fa-whatsapp\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div ng-if=\"show_pag_search\" class=\"text-center hidden-xs hidden-sm\"><div ng-if=\"paginacion[\'count\'] > 10\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-click=\"anteriorPagina(pagina)\"><a class=\"page-link\" aria-label=\"Previous\" role=\"button\"><span aria-hidden=\"true\">&laquo;</span></a></li><li class=\"page-item\" ng-repeat=\"pagina in paginacion.totalPaginas\" ng-click=\"selecionPagina(pagina)\" ng-class=\"{\'active\': pagina === paginacion.paginaActual}\"><a class=\"page-link\" role=\"button\">{{pagina}}</a></li><li class=\"page-item\" ng-click=\"siguientePagina(pagina)\"><a class=\"page-link\" aria-label=\"Next\" role=\"button\"><span aria-hidden=\"true\"><span aria-hidden=\"true\">&raquo;</span></span></a></li></ul></nav></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3\"><button class=\"btn btn-primary\" ng-if=\"siniestros.length\" ng-click=\"vm.exportarExcel()\"><i class=\"fa fa-download\"></i> Exportar a excel</button></div></div></div></div><div class=\"row\" ng-if=\"vm.show_binnacle\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"5\" idmodel=\"vm.siniester_id\" exportable=\"true\"></comments></div></div></div></div></div>");
$templateCache.put("app/siniestros/new_siniestros_accidentes.edit.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Siniestros</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"siniestros.lista\">Siniestros</a></li><li class=\"active\"><a>Accidentes y Enfermedades</a></li><li class=\"active\"><a ui-sref=\"siniestros.edit\"><strong>Siniestro #{{vm.infoSiniestro.siniestro.numero_siniestro}}</strong></a></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Edición de Siniestro</h5><button class=\"btn btn-default\" style=\"margin-top: -7px; color: grey\" ng-click=\"vm.getLog()\"><i class=\"fa fa-history\">Log</i></button></div><div class=\"ibox-content\"><form name=\"infoSiniestro\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Afectado:</label><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" disabled=\"\" ng-model=\"vm.infoSiniestro.accidente.affected_full_name\" ng-if=\"vm.infoSiniestro.poliza.document_type != 3\"><br><div class=\"col-xs-12 input-group\" ng-if=\"vm.infoSiniestro.poliza.document_type == 3\"><autocomplete datasource=\"autocompleteDataCertificate\" model=\"vm.word_certificate\" change=\"vm.getCertificate(vm.word_certificate)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getTypeCertificate(vm.word_certificate)\"><span class=\"fa fa-ballot\"></span>Elegir</button></div></div></div></div><div class=\"pull-right col-xs-12 col-sm-3 form-group\"><h3>Estatus del siniestro:</h3><div class=\"label\" ng-class=\"{ \'label-primary\': vm.infoSiniestro.siniestro.status == 1, \'label-primary\': vm.infoSiniestro.siniestro.status == 2, \'label-success\': vm.infoSiniestro.siniestro.status == 3, \'label-danger\': vm.infoSiniestro.siniestro.status == 4, \'label-warning\': vm.infoSiniestro.siniestro.status == 5, \'label-info\': vm.infoSiniestro.siniestro.status == 6}\"><span>{{status_siniestro}}</span></div></div></div><fieldset><legend align=\"left\">Información del Afectado</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ vm.infoSiniestro.contratante_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Parentesco:</span><div><span>{{ vm.infoSiniestro.relationship }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.afectado_birthdate\"><span class=\"blue-color\">Fecha de nacimiento:</span><div><span>{{ vm.infoSiniestro.afectado_birthdate }}</span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group\"><span class=\"blue-color\">Direccion:</span><div><span>{{ vm.infoSiniestro.contratante_address }}</span></div></div></div></fieldset><fieldset><legend align=\"right\">Información General</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{ vm.infoSiniestro.poliza.poliza_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.infoSiniestro.subramo.subramo_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.infoSiniestro.poliza.start_of_validity }} - {{ vm.infoSiniestro.poliza.end_of_validity }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.poliza.paquete\"><span class=\"blue-color\">Plan / Paquete:</span><div><span>{{ vm.infoSiniestro.paquete.package_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ vm.infoSiniestro.aseguradora.aseguradora_name }}</span></div></div></div></fieldset><fieldset><legend align=\"right\">Información del Siniestro</legend><div class=\"row\"><div class=\"form-group col-xs-6 col-sm-6 col-md-6\" role=\"group\" aria-label=\"...\"><label>Tipo de siniestro:</label><br><div class=\"label\" ng-class=\"{ \'label-primary\': vm.infoSiniestro.accidente.initial == true, \'label-info\': vm.infoSiniestro.accidente.initial == false}\"><span>{{inicial_complemento}}</span></div></div><div class=\"form-group col-xs-6 col-sm-6 col-md-6\" ng-if=\"vm.infoSiniestro.accidente.initial == false\"><label>Numero de Complemento:</label><br><span>{{ vm.infoSiniestro.accidente.numero_consecutivo_complemento }}</span></div><br><br><br><br><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Número de Siniestro</label> <input type=\"text\" name=\"numero_siniestro\" ng-value=\"numero_siniestro\" class=\"form-control\" ng-model=\"vm.infoSiniestro.siniestro.numero_siniestro\" ng-blur=\"save_info_tab()\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-2\"><label>Fecha de ingreso</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"vm.infoSiniestro.siniestro.fecha\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-2\"><label>Fecha de captura</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"vm.infoSiniestro.siniestro.fecha_ingreso\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-2\"><label>Fecha en que ocurrió</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"vm.infoSiniestro.siniestro.fecha_siniestro\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Tipo de Siniestro</label><select class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.razon_siniestro\" ng-options=\"tipo.id as tipo.name for tipo in vm.tipo\" ng-blur=\"save_info_tab()\" required=\"\"><option value=\"\" disabled=\"\">Seleccione un tipo</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Estatus</label><select class=\"select form-control\" ng-model=\"vm.infoSiniestro.siniestro.status\" ng-options=\"status.id as status.name for status in vm.status\" ng-disabled=\"vm.siniestro_completado\" ng-blur=\"save_info_tab()\"><option value=\"\" disabled=\"\">Seleccione un estatus</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Padecimiento</label><autocomplete id=\"padecimiento\" datasource=\"enfermedades\" name=\"disease\" model=\"vm.selected_disease\" change=\"vm.buscaPadecimientos(vm.selected_disease)\" required=\"true\"></autocomplete></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Tipo de Pago</label><select class=\"select form-control\" ng-model=\"vm.infoSiniestro.accidente.tipo_pago\" ng-options=\"tipo_pago.id as tipo_pago.name for tipo_pago in vm.tipo_pago\" ng-blur=\"save_info_tab()\"><option value=\"\" disabled=\"\">Seleccione un tipo de pago</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Fecha de terminación:<span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"vm.infoSiniestro.siniestro.fecha_terminacion\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6\"><label>Estado</label><select class=\"form-control\" ng-model=\"vm.infoSiniestro.siniestro.state\" ng-options=\"estado as estado.state for estado in vm.statesArray\" ng-change=\"vm.ciudades_estados();\" ng-blur=\"save_info_tab()\"><option value=\"\" disabled=\"\">Seleccione un estado</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6\"><label>Ciudad</label><select class=\"form-control\" ng-model=\"vm.infoSiniestro.siniestro.city\" ng-options=\"ciudad.url as ciudad.city for ciudad in vm.citiesArray\" ng-blur=\"save_info_tab()\"><option value=\"\" disabled=\"\">Seleccione una ciudad</option></select></div><div class=\"col-xs-12 col-sm-12 form-group\" ng-if=\"vm.infoSiniestro.siniestro.status == 4\"><label>Razón de cancelación: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"vm.infoSiniestro.siniestro.reason\" ng-required=\"vm.infoSiniestro.siniestro.status == 3\"></textarea></div><div class=\"col-xs-12 col-sm-12 form-group\"><label>Observaciones: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"vm.infoSiniestro.siniestro.observations\" ng-required=\"vm.infoSiniestro.siniestro.status == 4\" ng-blur=\"save_info_tab()\"></textarea></div><div ng-if=\"vm.infoSiniestro.siniestro.status == 2 || vm.infoSiniestro.siniestro.status == 3\" class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Folio Compañia:</label> <input type=\"text\" name=\"FolioCompañia\" class=\"form-control\" ng-model=\"vm.infoSiniestro.siniestro.folio_compania\"></div><div ng-if=\"vm.infoSiniestro.siniestro.status == 2 || vm.infoSiniestro.siniestro.status == 3\" class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Fecha Compromiso</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"vm.infoSiniestro.siniestro.fecha_compromiso\" data-date-format=\"dd/mm/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></fieldset><fieldset><legend align=\"right\">Facturación</legend><div class=\"tabs-container\"><uib-tabset active=\"active\"><uib-tab heading=\"Facturas\"><div class=\"panel-body\" id=\"exportable\"><table class=\"table table-hover\"><thead><tr><th width=\"10%\">Serie</th><th width=\"10%\">No. Factura</th><th>Concepto</th><th>Proveedor</th><th>Fecha de factura</th><th width=\"10%\">Importe</th><th width=\"10%\">IVA</th><th width=\"10%\">Total</th><th ng-if=\"vm.infoSiniestro.siniestro.status==3 && vm.infoSiniestro.accidente.tipo_pago==1\" width=\"10%\">Procedente</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"factura in vm.facturas track by $index\"><td ng-init=\"factura.serie = $index+1\"><input class=\"form-control\" type=\"text\" ng-model=\"factura.serie\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.f_number\"></td><td><select ng-model=\"factura.concepto\" ng-options=\"item.value as item.name for item in vm.facturas_conceptos\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.proovedor\"></td><td class=\"position-date\"><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"factura.f_date\" data-date-format=\"dd/mm/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></td><td><input class=\"form-control\" ng-model=\"factura.import\" ng-change=\"calculateIva($index, factura.import)\" type=\"number\" ng-blur=\"vm.siniestro_completado==false\"></td><td><input class=\"form-control\" ng-model=\"factura.iva\" ng-change=\"calculateTotal($index, factura.iva)\" type=\"number\" ng-blur=\"vm.siniestro_completado==false\"></td><td><input class=\"form-control\" ng-model=\"factura.total\" type=\"number\" disabled=\"\"></td><td ng-if=\"vm.infoSiniestro.siniestro.status==3 && vm.infoSiniestro.accidente.tipo_pago==1\"><input class=\"form-control\" ng-model=\"factura.procedente\" ng-change=\"validateProcedente($index, factura.procedente)\" type=\"number\" ng-blur=\"vm.siniestro_completado==false\"></td><td><button ng-disabled=\"vm.infoSiniestro.siniestro.status == 5 || vm.infoSiniestro.siniestro.status == 3 || vm.infoSiniestro.siniestro.status == 4\" type=\"button\" class=\"btn btn-sm btn-danger\" name=\"button\" ng-click=\"vm.deleteFactura(factura.url,$index)\"><span class=\"fa fa-trash-o fa-lg\"></span></button></td><td><button type=\"button\" class=\"btn btn-white btn-sm\" name=\"button\" ng-if=\"factura.url\" ng-click=\"vm.viewObservation(factura.url,vm.infoSiniestro.siniestro.status)\"><i class=\"fa fa-commenting-o\" aria-hidden=\"true\"></i></button></td></tr><tr ng-repeat=\"factura in vm.facturas track by $index\" ng-show=\"false\"><td>{{factura.serie}}</td><td>{{factura.f_number}}</td><td>{{factura.concepto}}</td><td>{{factura.proovedor}}</td><td class=\"position-date\">{{factura.f_date}}</td><td>{{factura.import}}</td><td>{{factura.iva}}</td><td>{{factura.total}}</td><td ng-if=\"vm.infoSiniestro.siniestro.status==3 && vm.infoSiniestro.accidente.tipo_pago==1\">{{factura.procedente}}</td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td ng-if=\"vm.facturas.length\"><input class=\"form-control\" name=\"\" disabled=\"\" ng-model=\"vm.totalImporte\" type=\"number\"></td><td ng-if=\"vm.facturas.length\"><input class=\"form-control\" name=\"\" disabled=\"\" ng-model=\"vm.totalIva\" type=\"number\"></td><td ng-if=\"vm.facturas.length\"><input class=\"form-control\" name=\"\" disabled=\"\" ng-model=\"vm.totalTotal\" type=\"number\"></td><td ng-if=\"vm.facturas.length && vm.infoSiniestro.siniestro.status==3 && vm.infoSiniestro.accidente.tipo_pago==1\"><input class=\"form-control\" type=\"number\" name=\"\" disabled=\"\" ng-model=\"vm.totalProcedente\"></td><td></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-12 form-group\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addFactura()\" type=\"button\">Agregar factura</button> <button class=\"btn btn-primary\" ng-click=\"vm.downloadFacturas()\" type=\"button\">Descargar facturas</button></div></div></div></uib-tab></uib-tabset></div><br><br><div class=\"row\"><div ng-if=\"vm.infoSiniestro.siniestro.status==3 && vm.infoSiniestro.accidente.tipo_pago!=1 || vm.siniestro_completado\" class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Total Procedente: <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"vm.infoSiniestro.accidente.total_procedente\" ng-change=\"validateTotal(vm.infoSiniestro.accidente.total_procedente)\" class=\"form-control\" ng-disabled=\"vm.siniestro_completado\" type=\"text\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-if=\"vm.infoSiniestro.siniestro.status==3\"><label>Coaseguro: <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"vm.infoSiniestro.accidente.total_coaseguro\" ng-change=\"validateCoaseguro(vm.infoSiniestro.accidente.total_coaseguro)\" class=\"form-control\" ng-disabled=\"vm.siniestro_completado\" type=\"text\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-if=\"vm.infoSiniestro.siniestro.status==3\"><label>Deducible: <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"vm.infoSiniestro.accidente.total_deducible\" ng-change=\"validateDeducible(vm.infoSiniestro.accidente.total_deducible)\" class=\"form-control\" ng-disabled=\"vm.siniestro_completado\" type=\"text\" required=\"\"></div></div><div class=\"form-group col-xs-6 col-sm-6 col-md-4\" ng-if=\"vm.siniestro_completado\"><label>Total Reclamado:</label> <input format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_reclamado\" class=\"form-control\" ng-disabled=\"vm.siniestro_completado\" type=\"text\" required=\"\"></div><div class=\"form-group col-xs-6 col-sm-6 col-md-4\" ng-if=\"vm.siniestro_completado\"><label>Total Final:</label> <input format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_final\" class=\"form-control\" ng-disabled=\"vm.siniestro_completado\" type=\"text\" required=\"\"></div></div></fieldset><fieldset ng-if=\"(vm.infoSiniestro.siniestro.status == 1 || vm.infoSiniestro.siniestro.status == 2 || vm.infoSiniestro.siniestro.status == 3) && (vm.infoSiniestro.accidente.tipo_pago == 2 || vm.infoSiniestro.accidente.tipo_pago == 3)\"><legend align=\"right\">Complementar Siniestro</legend><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6 col-md-8\"><label>Hospital:</label><autocomplete id=\"hospital\" datasource=\"vm.hospitals\" name=\"disease\" model=\"vm.hospital\" change=\"vm.updateHospital(vm.hospital)\"></autocomplete></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Fecha de cirugia</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"vm.infoSiniestro.accidente.fecha_cirugia\" data-date-format=\"dd/mm/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Monto Autorizado (Hospital):</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"vm.infoSiniestro.accidente.monto_hospital\" ng-change=\"validateAutorizado(vm.infoSiniestro.accidente.monto_hospital)\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Deducible (Hospital):</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"vm.infoSiniestro.accidente.ded_hospital\" ng-change=\"validateDedHospital(vm.infoSiniestro.accidente.ded_hospital)\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Coaseguro (Hospital):</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"vm.infoSiniestro.accidente.coas_hospital\" ng-change=\"validateCoasHospital(vm.infoSiniestro.accidente.coas_hospital)\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Monto Autorizado Honorarios Médicos:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"vm.infoSiniestro.accidente.monto_honorarios\" ng-change=\"validateHonorarios(vm.infoSiniestro.accidente.monto_honorarios)\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Cirujano:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.cirujano\" ng-change=\"validateCirujano(vm.infoSiniestro.accidente.cirujano)\" type=\"number\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Anestesiólogo:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.anestesiologo\" ng-change=\"validateAnestesiologo(vm.infoSiniestro.accidente.anestesiologo)\" type=\"number\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Ayudante:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.ayudante\" ng-change=\"validateAyudante(vm.infoSiniestro.accidente.ayudante)\" type=\"number\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Otros:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.otros\" ng-change=\"validateOtros(vm.infoSiniestro.accidente.otros)\" type=\"number\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Coaseguro:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.coas_honorarios\" ng-change=\"validateCoasHonorarios(vm.infoSiniestro.accidente.coas_honorarios)\" type=\"number\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Deducible:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.ded_honorarios\" ng-change=\"validateDeduHonorarios(vm.infoSiniestro.accidente.ded_honorarios)\" type=\"number\"></div></div></div></fieldset><br><fieldset><legend align=\"right\">Información de Contacto</legend><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><div class=\"row\" ng-if=\"vm.infoSiniestro.accidente.contact_accidente.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"vm.infoSiniestro.accidente.contact_accidente.length\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"vm.infoSiniestro.accidente.contact_accidente.length\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contactos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"contact in vm.infoSiniestro.accidente.contact_accidente track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteContacts($index,contact)\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts($index,contact)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contacto #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"contact.name\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" type=\"search\" lowercase=\"\" ng-model=\"contact.email\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Teléfono</label><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone_number\"></phonenumber-directive></div></div></div></div></div></fieldset><div class=\"hr-line-dashed\"></div><div upload-template=\"\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><br><br><br><br><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-disabled=\"infoSiniestro.$invalid\" ng-click=\"vm.updateSiniestro()\">Guardar siniestro</button></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-sm-12\"><div class=\"col-md-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"5\" idmodel=\"vm.siniestro_id\"></comments></div></div></div></div></div>");
$templateCache.put("app/siniestros/new_siniestros_accidentes.html","<div class=\"row wrapper border-bottom white-bg page-heading\" ng-if=\"url !== \'/index/main\'\"><div class=\"col-lg-9\"><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Siniestros - Accidentes y enfermedades</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Accidentes y enfermedades - Crear siniestro</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><form name=\"infoSiniestro\"><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-if=\"!vm.myInsurance.url && !vm.carga_siniestro\"><label>Número de Póliza: <span class=\"red-color\">*</span></label> <span>(Solo el número de póliza)</span><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"cadena_a_buscar\"><div class=\"form-group input-group-btn\"><button type=\"button\" ng-click=\"vm.updateStatus(cadena_a_buscar)\" class=\"btn btn-block btn-success\" title=\"Los campos con con * son obligatorios\">Buscar</button></div></div><br></div><div ng-if=\"vm.affected_poliza.length>0\" class=\"col-xs-12 form-group\"><select class=\"select form-control\" ng-model=\"vm.form.poliza\" ng-options=\"affected as affected.label for affected in vm.affected_poliza\" ng-change=\"vm.BuscarPolizas(vm.form.poliza); vm.saveLocalstorange()\"><option value=\"\" disabled=\"\">Seleccione una Póliza</option></select></div><div class=\"form-group col-xs-12 col-sm-4 col-md-12\" ng-if=\"!nocertificado && vm.show_caratula == false && vm.show_poliza == true && !vm.carga_siniestro && !vm.myInsurance.url\"><label>Afectado:</label><select class=\"select form-control\" ng-model=\"vm.selected_affect\" ng-options=\"affected as affected.label for affected in vm.affected\" ng-change=\"vm.LlenarDatos(vm.selected_affect); vm.saveLocalstorange()\"><option value=\"\" disabled=\"\">Seleccione un afectado</option></select></div><div class=\"form-group col-xs-12 col-sm-4 col-md-6\" ng-if=\"vm.carga_siniestro || vm.myInsurance.url\"><label>Número de Poliza:</label><br><p ng-if=\"vm.form.poliza.val && vm.affect_data.policy_number\" size=\"5\">{{vm.form.poliza.val}}</p><p ng-if=\"vm.form.poliza.val && !vm.affect_data.policy_number\" size=\"5\">{{vm.form.poliza.val}}</p><p ng-if=\"vm.affect_data.policy_number && !vm.form.poliza.val\" size=\"5\">{{vm.affect_data.policy_number}}</p></div><div class=\"form-group col-xs-12 col-sm-4 col-md-6\" ng-if=\"vm.carga_siniestro || vm.myInsurance.url\"><label>Afectado:</label><br><p size=\"5\" ng-if=\"vm.selected_affect\">{{vm.selected_affect.value.full_name}}</p><p size=\"5\" ng-if=\"vm.tmp_siniestro.siniestro.aux_affected\">{{vm.tmp_siniestro.siniestro.aux_affected}}</p></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.show_caratula == true && vm.show_poliza == false && !vm.myInsurance.url\"><label>Certificado/Inciso: <span class=\"red-color\">*</span></label><div class=\"col-xs-12 input-group\"><autocomplete datasource=\"autocompleteDataCertificate\" model=\"vm.word_certificate\" change=\"vm.getCertificate(vm.word_certificate)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"chooseCertificate(vm.word_certificate)\"><span class=\"fa fa-ballot\"></span>Elegir</button></div></div></div><div class=\"form-group col-xs-12\" ng-if=\"affectedCaratula == true && vm.show_poliza == false && !vm.carga_siniestro && !vm.myInsurance.url\"><label>Afectado:</label><select class=\"select form-control\" ng-model=\"vm.selected_affect\" ng-options=\"affected as affected.label for affected in vm.affected_certificate\" ng-change=\"vm.LlenarDatos(vm.selected_affect)\"><option value=\"\" disabled=\"\">Seleccione un afectado</option></select></div></div><fieldset><legend align=\"right\">Información del Afectado</legend><div class=\"row\"><div ng-if=\"vm.show_caratula == true && vm.show_poliza == false\" class=\"form-group col-xs-12 col-sm-6 col-md-6\"><label>Parentesco:</label><select class=\"select form-control\" ng-model=\"new_siniestro.relationship_aux_affected\" ng-options=\"parentesco.id as parentesco.name for parentesco in vm.parentesco\"><option value=\"\" disabled=\"\">Seleccione un parentesco</option></select></div><div class=\"form-group col-xs-12 col-sm-4 col-md-4\"><label>Contratante:</label> <input disabled=\"\" ng-model=\"vm.affect_data.contratante.name\" class=\"form-control\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-4 col-md-4\"><label>Parentesco:</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.affect_data.title\"></div><div class=\"form-group col-xs-12 col-sm-4 col-md-4\"><label>Fecha de Nacimiento:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-4 col-md-12\"><label>Domicilio:</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.affect_data.contractor_addres\" required=\"\"></div></div></fieldset><br><fieldset><legend align=\"right\">Información General</legend><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-4 col-md-3\"><label>Número de Póliza:</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.affect_data.policy_number\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-4 col-md-3\"><label>Subramo:</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.siniester_data.subramo.subramo_name\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-4 col-md-3\"><label>Inicio de Vigencia:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.policy_vigencia_init\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-4 col-md-3\"><label>Fin de Vigencia:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.policy_vigencia\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-4 col-md-3\"><label>Estatus de Pago:</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.affect_data.policy_status.label\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-4 col-md-6\"><label>Aseguradora:</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.affect_data.aseguradora.compania\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-4 col-md-3\"><label>Plan / Paquete:</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.affect_data.paquete.package_name\"></div></div></fieldset><br><fieldset><legend align=\"right\">Información del Siniestro</legend><div class=\"row\"><div class=\"btn-group form-group col-xs-12 col-sm-12 col-md-12\" role=\"group\" aria-label=\"...\"><button id=\"btn-inicial\" type=\"button\" ng-click=\"vm.checkRadio(\'Inicial\')\" class=\"btn btn-default btn-iniComp\">Inicial</button> <button id=\"btn-complemento\" type=\"button\" ng-click=\"vm.checkRadio(\'Complemento\')\" class=\"btn btn-default\">Complemento</button><br><br><br></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\" ng-if=\"vm.isInicial==true\"><label>Número de Siniestro:</label> <input type=\"text\" name=\"numero_siniestro\" ng-value=\"numero_siniestro\" class=\"form-control\" ng-model=\"new_siniestro.numero_siniestro\" ng-change=\"vm.saveLocalstorange()\" ng-required=\"new_siniestro.status==3\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\" ng-if=\"vm.isInicial==false\"><label>Número de Siniestro: <span class=\"red-color\">*</span></label><select class=\"select form-control\" ng-model=\"vm.siniester_data.siniester_number\" ng-options=\"affected as affected.label for affected in vm.siniester_data.siniestros_by_number\" ng-change=\"vm.BuscarIniciales(vm.siniester_data.siniester_number)\" required=\"!vm.isInicial\"><option value=\"\" disabled=\"\">Siniestro Inicial</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Fecha de Ingreso:<span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_siniestro.fecha\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Fecha de captura:<span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_siniestro.fechaIngreso\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Fecha en que ocurrió:<span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_siniestro.fechaSiniestro\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Tipo de Siniestro:<span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"new_accidente.razon_siniestro\" ng-options=\"tipo.id as tipo.name for tipo in vm.tipo\" ng-change=\"vm.saveLocalstorange()\" required=\"\"><option value=\"\" disabled=\"\">Seleccione un tipo</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Estatus:<span class=\"red-color\">*</span><select class=\"select form-control\" ng-model=\"new_siniestro.status\" ng-options=\"status.id as status.name for status in vm.status\" ng-change=\"vm.saveLocalstorangeStatus(new_siniestro.status)\" required=\"\"><option value=\"\" disabled=\"\">Seleccione un estatus</option></select></label></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\" ng-class=\"{ \'has-error\': infoSiniestroForm.disease.$invalid && !infoSiniestroForm.disease.$pristine }\"><label>Padecimiento:<span class=\"color-red\">*</span></label><autocomplete id=\"padecimiento\" datasource=\"enfermedades\" name=\"disease\" model=\"vm.selected_disease\" change=\"vm.buscaPadecimientos(vm.selected_disease)\" required=\"true\"></autocomplete></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Tipo de Pago:<span class=\"red-color\">*</span></label><select class=\"select form-control\" ng-model=\"new_accidente.tipo_pago\" ng-options=\"tipo_pago.id as tipo_pago.name for tipo_pago in vm.tipo_pago\" ng-change=\"vm.saveLocalstorange()\" required=\"\"><option value=\"\" disabled=\"\">Seleccione un tipo de pago</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Fecha de terminación:<span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_siniestro.fechaTerminacion\" value=\"{{filterDate.startDate}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><label>Agregar Ciudad y Estado:</label><br><input type=\"checkbox\" ng-model=\"vm.show_state_city\" ng-change=\"vm.saveLocalstorange()\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6\" ng-if=\"vm.show_state_city\"><label>Estado:</label><select class=\"form-control\" ng-model=\"new_siniestro.state\" ng-options=\"estado as estado.state for estado in vm.statesArray\" ng-change=\"vm.ciudades_estados(); vm.saveLocalstorange()\"><option value=\"\" disabled=\"\">Seleccione un estado</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6\" ng-if=\"vm.show_state_city\"><label>Ciudad:</label><select class=\"form-control\" ng-model=\"new_siniestro.city\" ng-options=\"ciudad.url as ciudad.city for ciudad in vm.citiesArray\" ng-change=\"vm.saveLocalstorange()\"><option value=\"\" disabled=\"\">Seleccione una ciudad</option></select></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Folio Compañia:</label> <input type=\"text\" name=\"FolioCompañia\" class=\"form-control\" ng-model=\"new_siniestro.folio_compania\" ng-change=\"vm.saveLocalstorange()\"></div><div ng-show=\"new_siniestro.status==2\" class=\"form-group col-xs-12 col-sm-6 col-md-3\"><label>Fecha Compromiso:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_siniestro.fecha_compromiso\" data-date-format=\"dd/mm/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div ng-show=\"new_siniestro.status==4\" class=\"form-group col-xs-12 col-sm-12 col-md-12\"><label>Motivo de Cancelación:</label> <input type=\"text\" name=\"reason\" class=\"form-control\" ng-model=\"new_siniestro.reason\" ng-change=\"vm.saveLocalstorange()\"></div><div class=\"form-group col-xs-12 col-sm-12 col-md-12\"><label>Observaciones:</label> <textarea type=\"text\" name=\"Observaciones\" class=\"form-control\" ng-model=\"new_siniestro.observations\" ng-change=\"vm.saveLocalstorange()\"></textarea></div></div></fieldset><br><fieldset><legend align=\"right\">Facturas</legend><div class=\"tabs-container\"><uib-tabset active=\"active\"><uib-tab heading=\"Facturas\"><div class=\"panel-body\" id=\"exportable\"><div class=\"row margin-bottom-10\"><div class=\"col-md-12 text-right\"><a class=\"btn btn-success\" href=\"https://miurabox-public.s3.us-east-1.amazonaws.com/layouts/plantilla_siniestros.xlsx\" download=\"plantilla_siniestros.xlsx\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar plantilla</a> <label class=\"btn btn-info btn-sm\" for=\"facturasExcelInput\" style=\"cursor:pointer; margin-bottom:0\">Importar desde Excel</label> <input type=\"file\" id=\"facturasExcelInput\" accept=\".xlsx,.xls\" style=\"display:none\" onchange=\"angular.element(this).scope().vm.handleFacturasExcelFile(this)\"></div></div><div class=\"alert alert-danger\" ng-if=\"unknownConceptsAlert.length\"><strong>Conceptos no detectados:</strong> {{ unknownConceptsAlert.join(\', \') }}</div><table class=\"table table-hover\"><thead><tr><th width=\"10%\">Serie</th><th width=\"10%\">No. Factura</th><th>Concepto</th><th>Proveedor</th><th>Fecha de factura</th><th width=\"10%\">Importe</th><th width=\"10%\">IVA</th><th width=\"10%\">Total</th><th width=\"10%\" ng-if=\"new_siniestro.status==3 && new_accidente.tipo_pago==1\">Procedente</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"factura in vm.facturas track by $index\"><td ng-init=\"factura.serie = $index+1\"><input class=\"form-control\" type=\"text\" ng-model=\"factura.serie\" ng-change=\"vm.saveLocalstorange()\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.f_number\" ng-change=\"vm.saveLocalstorange()\"></td><td><select ng-model=\"factura.concepto\" ng-options=\"item.value as item.name for item in vm.facturas_conceptos\" class=\"form-control\" ng-change=\"vm.saveLocalstorange()\"><option value=\"\">Selecciona una opción</option></select></td><td><input class=\"form-control\" type=\"text\" maxlength=\"450\" ng-model=\"factura.proovedor\" ng-change=\"vm.saveLocalstorange()\"></td><td class=\"position-date\"><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"factura.f_date\" data-date-format=\"dd/mm/yyyy\" ng-change=\"vm.saveLocalstorange()\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></td><td><input class=\"form-control\" ng-model=\"factura.import\" ng-change=\"calculateIva($index, factura.import);vm.saveLocalstorange()\" type=\"number\"></td><td><input class=\"form-control\" ng-model=\"factura.iva\" ng-change=\"calculateTotal($index, factura.iva);vm.saveLocalstorange()\" type=\"number\"></td><td><input class=\"form-control\" ng-model=\"factura.total\" type=\"number\" disabled=\"\" ng-change=\"vm.saveLocalstorange()\"></td><td ng-if=\"new_siniestro.status==3 && new_accidente.tipo_pago==1\"><input class=\"form-control\" ng-model=\"factura.procedente\" type=\"number\" required=\"\" ng-change=\"vm.saveLocalstorange();validateProcedente($index, factura.procedente)\"></td><td><button type=\"button\" class=\"btn btn-sm btn-danger\" name=\"button\" ng-click=\"vm.deleteFactura(factura.url,$index);vm.saveLocalstorange()\"><span class=\"fa fa-trash-o fa-lg\"></span></button></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-12 form-group\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addFactura();vm.saveLocalstorange()\" type=\"button\">Agregar factura</button> <button class=\"btn btn-primary\" ng-click=\"vm.downloadFacturas();vm.saveLocalstorange()\" ng-if=\"existenFacturas\" type=\"button\">Descargar facturas</button> <button class=\"btn btn-warning pull-left\" ng-click=\"vm.clearFacturas();vm.saveLocalstorange()\" type=\"button\">Vaciar facturas</button></div></div></div></uib-tab></uib-tabset></div><br><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-if=\"new_siniestro.status==3 && new_accidente.tipo_pago!=1\"><label>Total Procedente: <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.total_procedente\" ng-change=\"validateTotal(new_accidente.total_procedente)\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-if=\"new_siniestro.status==3\"><label>Coaseguro: <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.total_coaseguro\" ng-change=\"validateCoaseguro(new_accidente.total_coaseguro)\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-if=\"new_siniestro.status==3\"><label>Deducible: <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.total_deducible\" ng-change=\"validateDeducible(new_accidente.total_deducible)\" class=\"form-control\" type=\"number\" required=\"\"></div></div></div></fieldset><br><fieldset ng-if=\"(new_siniestro.status == 1 || new_siniestro.status == 2 || new_siniestro.status == 3) && (new_accidente.tipo_pago == 2 || new_accidente.tipo_pago == 3)\"><legend align=\"right\">Complementar Siniestro</legend><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6 col-md-8\"><label>Hospital:</label><autocomplete id=\"hospital\" datasource=\"vm.hospitals\" name=\"disease\" model=\"vm.hospital\" change=\"vm.updateHospital(vm.hospital); vm.saveLocalstorange()\" required=\"true\"></autocomplete></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Fecha de cirugia:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"new_accidente.fecha_cirugia\" ng-change=\"vm.saveLocalstorange()\" data-date-format=\"dd/mm/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Monto Autorizado (Hospital):</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.monto_hospital\" ng-change=\"validateAutorizado(new_accidente.monto_hospital); vm.saveLocalstorange()\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Deducible (Hospital):</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.ded_hospital\" ng-change=\"validateDedHospital(new_accidente.ded_hospital); vm.saveLocalstorange()\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Coaseguro (Hospital):</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.coas_hospital\" ng-change=\"validateCoasHospital(new_accidente.coas_hospital); vm.saveLocalstorange()\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Monto Autorizado Honorarios Médicos:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.monto_honorarios\" ng-change=\"validateHonorarios(new_accidente.monto_honorarios); vm.saveLocalstorange()\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Cirujano:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.cirujano\" ng-change=\"validateCirujano(new_accidente.cirujano); vm.saveLocalstorange()\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Anestesiólogo:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.anestesiologo\" ng-change=\"validateAnestesiologo(new_accidente.anestesiologo); vm.saveLocalstorange()\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Ayudante:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.ayudante\" ng-change=\"validateAyudante(new_accidente.ayudante); vm.saveLocalstorange()\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Otros:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.otros\" ng-change=\"validateOtros(new_accidente.otros); vm.saveLocalstorange()\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Coaseguro:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.coas_honorarios\" ng-change=\"validateCoasHonorarios(new_accidente.coas_honorarios); vm.saveLocalstorange()\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Deducible:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"new_accidente.ded_honorarios\" ng-change=\"validateDedHonorarios(new_accidente.ded_honorarios); vm.saveLocalstorange()\" class=\"form-control\" type=\"number\" required=\"\"></div></div></div></fieldset><br><fieldset><legend align=\"right\">Información del Contacto</legend><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"vm.contactos.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"vm.contactos.length == 0\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"vm.contactos.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contactos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"contact in vm.contactos track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"vm.deleteContacts($index)\">Quitar contacto</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts($index)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Contacto #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"vm.addContact()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-4 form-group\"><label>Nombre</label> <input class=\"form-control\" type=\"text\" ng-model=\"contact.name\" ng-click=\"vm.saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" type=\"search\" lowercase=\"\" ng-model=\"contact.email\" ng-click=\"vm.saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Teléfono</label><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone_number\"></phonenumber-directive></div></div></div></div></div></fieldset><br><br><div class=\"hr-line-dashed\"></div><div upload-template=\"\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\" ng-if=\"url !== \'/index/main\'\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><br><br><br><br><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"saveSiniestro()\" title=\"Los campos con con * son obligatorios\">Guardar siniestro</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/siniestros/new_siniestros_accidentes.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Siniestros</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"siniestros.lista\">Siniestros</a></li><li class=\"active\"><a>Accidentes y Enfermedades</a></li><li class=\"active\"><a ui-sref=\"siniestros.info\"><strong>Siniestro #{{vm.infoSiniestro.siniestro.numero_siniestro}}</strong></a></li></ol></div></div><br><div class=\"btn-group pull-right option_button\"><button ng-if=\"vm.acceso_adm_sin\" type=\"button\" class=\"btn no-mb btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_ver_pol\"><a ng-click=\"vm.goToPolicy(forms.id)\">Ver póliza</a></li><li><a ng-click=\"vm.goToSinister(vm.infoSiniestro.siniestro.tipo_siniestro_general,vm.infoSiniestro.siniestro.id)\">Editar</a></li><li><a ng-click=\"vm.deleteSiniestro(vm.infoSiniestro.siniestro.url)\">Eliminar</a></li><li><a ng-click=\"vm.getPDF(vm.infoSiniestro.siniestro.id, vm.infoSiniestro.poliza.id)\">Ver PDF</a></li><li ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><a ng-click=\"vm.getPDFiniquito(vm.infoSiniestro.siniestro.id, vm.infoSiniestro.poliza.id)\">Hoja de finiquito</a></li><li class=\"dropdown-submenu\" ng-if=\"vm.files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"!vm.files\"><a>No hay archivos adjuntos</a></li><li ng-if=\"vm.files\"><a>Archivos adjuntos</a></li><li ng-if=\"vm.files\" ng-repeat=\"file in vm.files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length && vm.acceso_form\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, carta.id)\">{{carta.name}}</a></li></ul></li><li ng-if=\"vm.infoSiniestro.accidente.initial==true\"><a ng-click=\"vm.crear_complemento(vm.infoSiniestro, \'Siniestros\', \'siniestros.accidentes\')\">Crear complemento</a></li><li ng-if=\"vm.whatsappWebEnabled\"><a ng-click=\"vm.sendWhatsAppWeb(vm.infoSiniestro.siniestro, vm.infoSiniestro.poliza)\">Enviar WhatsApp Web</a></li><li><a ng-click=\"vm.sendEmail(vm.infoSiniestro.siniestro, vm.infoSiniestro.poliza)\">Enviar correo electrónico</a></li></ul></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información del siniestro</h5><button class=\"btn btn-default\" style=\"margin-top: -7px; color: grey\" ng-click=\"vm.getLog()\"><i class=\"fa fa-history\">Log</i></button> <button class=\"btn btn-default\" style=\"margin-top: -7px; color: green; margin-left:10px\" ng-if=\"vm.whatsappWebEnabled\" ng-click=\"vm.sendWhatsAppWeb(vm.infoSiniestro.siniestro, vm.infoSiniestro.poliza)\"><i class=\"fa fa-whatsapp\"></i></button> <button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"createRecordatorio(vm.infoSiniestro.siniestro,5)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"ibox-content\"><form name=\"infoSiniestro\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Afectado:</label><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" disabled=\"\" ng-model=\"vm.infoSiniestro.accidente.affected_full_name\"></div></div><div class=\"pull-right col-xs-12 col-sm-3 form-group\"><h3>Estatus del siniestro:</h3><div class=\"label\" ng-class=\"{ \'label-primary\': vm.infoSiniestro.siniestro.status == 1, \'label-primary\': vm.infoSiniestro.siniestro.status == 2, \'label-success\': vm.infoSiniestro.siniestro.status == 3, \'label-danger\': vm.infoSiniestro.siniestro.status == 4, \'label-warning\': vm.infoSiniestro.siniestro.status == 5, \'label-info\': vm.infoSiniestro.siniestro.status == 7, \'label-info\': vm.infoSiniestro.siniestro.status == 8, \'label-info\': vm.infoSiniestro.siniestro.status == 6,}\"><span>{{status_siniestro}}</span></div></div></div><fieldset><legend align=\"left\">Información del Afectado</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ vm.infoSiniestro.contratante_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Parentesco:</span><div><span>{{ vm.infoSiniestro.relationship }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.afectado_birthdate\"><span class=\"blue-color\">Fecha de nacimiento:</span><div><span>{{ vm.infoSiniestro.afectado_birthdate | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group\"><span class=\"blue-color\">Direccion:</span><div><span>{{ vm.infoSiniestro.contratante_address }}</span></div></div></div></fieldset><fieldset><legend align=\"left\">Información General</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{ vm.infoSiniestro.poliza.poliza_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.infoSiniestro.subramo.subramo_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.infoSiniestro.poliza.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{ vm.infoSiniestro.poliza.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.poliza.paquete\"><span class=\"blue-color\">Plan / Paquete:</span><div><span>{{ vm.infoSiniestro.paquete.package_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span ng-if=\"vm.infoSiniestro.aseguradora.aseguradora_name\">{{ vm.infoSiniestro.aseguradora.aseguradora_name }}</span> <span ng-if=\"!vm.infoSiniestro.aseguradora.aseguradora_name && vm.infoSiniestro.poliza.parent.parent.parent.aseguradora.alias\">{{ vm.infoSiniestro.poliza.parent.parent.parent.aseguradora.alias }}</span></div></div></div></fieldset><fieldset><legend align=\"left\">Información del Siniestro</legend><div class=\"row\"><div class=\"form-group col-xs-6 col-sm-6 col-md-6\" role=\"group\" aria-label=\"...\"><label>Tipo de siniestro:</label><br><div class=\"label\" ng-class=\"{ \'label-primary\': vm.infoSiniestro.accidente.initial == true, \'label-info\': vm.infoSiniestro.accidente.initial == false}\"><span>{{inicial_complemento}}</span></div></div><div class=\"form-group col-xs-6 col-sm-6 col-md-6\" ng-if=\"vm.infoSiniestro.accidente.initial == false\"><label>Numero de Complemento:</label><br><span>{{ vm.infoSiniestro.accidente.numero_consecutivo_complemento }}</span></div><br><br><br><br><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><span class=\"blue-color\">Número de Siniestro:</span><br><span>{{ vm.infoSiniestro.siniestro.numero_siniestro }}</span></div><div class=\"form-group col-xs-12 col-sm-6 col-md-2\"><span class=\"blue-color\">Fecha de Ingreso:</span><br><span>{{vm.infoSiniestro.siniestro.fecha| date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div class=\"form-group col-xs-12 col-sm-6 col-md-2\"><span class=\"blue-color\">Fecha de captura:</span><br><span>{{vm.infoSiniestro.siniestro.fecha_ingreso| date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div class=\"form-group col-xs-12 col-sm-6 col-md-2\"><span class=\"blue-color\">Fecha en que ocurrió:</span><br><span>{{vm.infoSiniestro.siniestro.fecha_siniestro| date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div class=\"form-group col-xs-12 col-sm-6 col-md-2\"><span class=\"blue-color\">Fecha de terminación:</span><br><span>{{vm.infoSiniestro.siniestro.fecha_terminacion | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><span class=\"blue-color\">Tipo de Siniestro:</span><br><span>{{vm.tipo_title[vm.infoSiniestro.accidente.razon_siniestro]}}</span></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><span class=\"blue-color\">Estatus:</span><br><span>{{status_siniestro}}</span></div><div class=\"form-group col-xs-12 col-sm-6 col-md-6\"><span class=\"blue-color\">Padecimiento:</span><br><span>{{vm.infoSiniestro.accidente.ailment}}</span></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><span class=\"blue-color\">Tipo de Pago:</span><br><span>{{vm.pago_title[vm.infoSiniestro.accidente.tipo_pago]}}</span></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><span class=\"blue-color\">Creado por:</span><br><span>{{vm.infoSiniestro.siniestro.owner}}</span></div><div class=\"form-group col-xs-12 col-sm-4 col-md-4\" ng-if=\"vm.infoSiniestro.siniestro.state.state\"><span class=\"blue-color\">Estado y Ciudad:</span><br><span>{{vm.infoSiniestro.siniestro.state.state}},{{vm.ciudad_name}}</span></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showRecordatorios()\">{{vm.infoSiniestro.siniestro.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div><br><br><div class=\"row\"><div class=\"col-xs-12 col-sm-12 form-group\" ng-if=\"vm.infoSiniestro.siniestro.status == 4\"><span class=\"blue-color\">Razón de cancelación:</span><br><textarea class=\"form-control\" ng-model=\"vm.infoSiniestro.siniestro.reason\" disabled=\"\"></textarea></div><div class=\"col-xs-12 col-sm-12 form-group\"><span class=\"blue-color\">Observaciónes:</span><br><textarea class=\"form-control\" ng-model=\"vm.infoSiniestro.siniestro.observations\" disabled=\"\"></textarea></div><div ng-if=\"vm.infoSiniestro.siniestro.status == 2 || vm.infoSiniestro.siniestro.status == 3\" class=\"form-group col-xs-12 col-sm-4 col-md-4\"><span class=\"blue-color\">Folio Compañia:</span><br><span>{{vm.infoSiniestro.siniestro.folio_compania}}</span></div><div ng-if=\"vm.infoSiniestro.siniestro.status == 2 || vm.infoSiniestro.siniestro.status == 3\" class=\"form-group col-xs-12 col-sm-4 col-md-4\"><span class=\"blue-color\">Fecha Compromiso:</span><br><span>{{vm.infoSiniestro.siniestro.fecha_compromiso| date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div></fieldset><div class=\"ibox float-e-margins animate m-t\" ng-if=\"recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"showRecordatorios()\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in vm.infoSiniestro.siniestro.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><fieldset><legend align=\"left\">Facturación</legend><div class=\"tabs-container\"><uib-tabset active=\"active\"><uib-tab heading=\"Facturas\"><div class=\"panel-body\" id=\"exportable\"><table class=\"table table-hover\"><thead><tr><th width=\"10%\">Serie</th><th width=\"10%\">No. Factura</th><th>Concepto</th><th>Proveedor</th><th>Fecha de factura</th><th width=\"10%\">Importe</th><th width=\"10%\">IVA</th><th width=\"10%\">Total</th><th ng-if=\"vm.infoSiniestro.siniestro.status==3 && vm.infoSiniestro.accidente.tipo_pago==1\" width=\"10%\">Procedente</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"factura in vm.facturas track by $index\"><td ng-init=\"factura.serie = $index+1\"><input class=\"form-control\" type=\"text\" ng-model=\"factura.serie\" disabled=\"\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.f_number\" disabled=\"\"></td><td><select ng-model=\"factura.concepto\" ng-options=\"item.value as item.name for item in vm.facturas_conceptos\" class=\"form-control\" disabled=\"\"><option value=\"\">Selecciona una opción</option></select></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.proovedor\" disabled=\"\"></td><td class=\"position-date\"><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"factura.f_date\" data-date-format=\"dd/mm/yyyy\" disabled=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></td><td><input class=\"form-control\" format-as-currency=\"\" ng-model=\"factura.import\" ng-change=\"calculateIva($index, factura.import)\" ng-blur=\"vm.siniestro_completado==false && calculateTotales()\" disabled=\"\"></td><td><input class=\"form-control\" format-as-currency=\"\" ng-model=\"factura.iva\" ng-change=\"calculateTotal($index, factura.iva)\" ng-blur=\"vm.siniestro_completado==false && calculateTotales()\" disabled=\"\"></td><td><input format-as-currency=\"\" class=\"form-control\" type=\"text\" ng-model=\"factura.total\" disabled=\"\"></td><td ng-if=\"vm.infoSiniestro.siniestro.status==3 && vm.infoSiniestro.accidente.tipo_pago==1\"><input class=\"form-control\" format-as-currency=\"\" ng-model=\"factura.procedente\" ng-blur=\"vm.siniestro_completado==false && calculateTotales()\" disabled=\"\"></td><td><button type=\"button\" class=\"btn btn-white btn-sm\" name=\"button\" ng-if=\"factura.url\" ng-click=\"vm.viewObservation(factura.url,vm.infoSiniestro.siniestro.status)\"><i class=\"fa fa-commenting-o\" aria-hidden=\"true\"></i></button></td></tr><tr ng-repeat=\"factura in vm.facturas track by $index\" ng-show=\"false\"><td>{{factura.serie}}</td><td>{{factura.f_number}}</td><td>{{factura.concepto}}</td><td>{{factura.proovedor}}</td><td class=\"position-date\">{{factura.f_date}}</td><td>{{factura.import}}</td><td>{{factura.iva}}</td><td>{{factura.total}}</td><td ng-if=\"vm.infoSiniestro.siniestro.status==3 && vm.infoSiniestro.accidente.tipo_pago==1\">{{factura.procedente}}</td><td></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-12 form-group\"><button class=\"btn btn-primary\" ng-click=\"vm.downloadFacturas()\" type=\"button\">Descargar facturas</button></div></div></div></uib-tab></uib-tabset></div><br><br><div class=\"row\"><div ng-if=\"vm.infoSiniestro.siniestro.status==3 && vm.infoSiniestro.accidente.tipo_pago!=1 || vm.siniestro_completado\" class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Total Procedente:</label> <input format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_procedente\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-if=\"vm.infoSiniestro.siniestro.status==3\"><label>Coaseguro:</label> <input format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_coaseguro\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-if=\"vm.infoSiniestro.siniestro.status==3\"><label>Deducible:</label> <input format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_deducible\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-xs-6 col-sm-6 col-md-4\" ng-if=\"vm.siniestro_completado\"><label>Total Reclamado:</label> <input format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_reclamado\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-xs-6 col-sm-6 col-md-4\" ng-if=\"vm.siniestro_completado\"><label>Total Final:</label> <input format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_final\" class=\"form-control\" disabled=\"\"></div></div></fieldset><fieldset ng-if=\"(vm.infoSiniestro.siniestro.status == 1 || vm.infoSiniestro.siniestro.status == 2 || vm.infoSiniestro.siniestro.status == 3) && (vm.infoSiniestro.accidente.tipo_pago == 2 || vm.infoSiniestro.accidente.tipo_pago == 3)\"><legend align=\"left\">Complementar Siniestro</legend><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6 col-md-8\"><label>Hospital:</label> <input type=\"text\" name=\"hospital\" ng-value=\"hospital\" class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.hospital\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Fecha de cirugia</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"vm.infoSiniestro.accidente.fecha_cirugia\" data-date-format=\"dd/mm/yyyy\" disabled=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Monto Autorizado (Hospital):</label> <input format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.monto_hospital\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Deducible (Hospital):</label> <input format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.ded_hospital\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Coaseguro (Hospital):</label> <input format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.coas_hospital\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Monto Autorizado Honorarios Médicos:</label> <input format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.monto_honorarios\" class=\"form-control\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Cirujano:</label> <input format-as-currency=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.cirujano\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Anestesiólogo:</label> <input format-as-currency=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.anestesiologo\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Ayudante:</label> <input format-as-currency=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.ayudante\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Otros:</label> <input format-as-currency=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.otros\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Coaseguro:</label> <input format-as-currency=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.coas_honorarios\" disabled=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\"><label>Deducible:</label> <input format-as-currency=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.ded_honorarios\" disabled=\"\"></div></div></fieldset><br><fieldset ng-if=\"vm.infoSiniestro.accidente.contact_accidente.length\"><legend class=\"legend-title\" align=\"left\">Información de Contacto</legend><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th class=\"text-align-center width-20p\">Nombre</th><th class=\"text-align-center width-20p\">Correo electrónico</th><th class=\"text-align-center width-20p\">Teléfono</th></tr></thead><tbody><tr ng-repeat=\"contact in vm.infoSiniestro.accidente.contact_accidente track by $index\"><td class=\"text-align-center width-20p\">{{contact.name}}</td><td class=\"text-align-center width-20p\">{{contact.email}}</td><td class=\"text-align-center width-20p\">{{contact.phone_number}}</td></tr></tbody></table></div></div></div></fieldset><fieldset ng-if=\"vm.siniestro_inicial\"><legend class=\"legend-title\" align=\"left\">Siniestro Inicial</legend><div class=\"row\"><div class=\"results-container\"><div class=\"panel-body table-over-y\" id=\"exportable\"><table class=\"table table-stripped table-hover hidden-xs hidden-sm\"><thead><tr><th>No. Siniestro</th><th>Padecimiento</th><th>Fecha de Siniestro</th></tr></thead><tbody><tr ng-repeat=\"siniestro in vm.siniestro_inicial track by $index\" ng-click=\"vm.goToSinisterInfo(2, siniestro.siniestro.id)\"><td>{{ siniestro.siniestro.numero_siniestro }}</td><td>{{ siniestro.ailment }}</td><td>{{ siniestro.siniestro.fecha_siniestro | date: \'dd/MM/yyyy\' : \'UTC\'}}</td></tr></tbody></table></div></div></div></fieldset><fieldset ng-if=\"vm.siniestro_complementos.length\"><legend class=\"legend-title\" align=\"left\">Siniestros Complementarios</legend><div class=\"row\"><div class=\"results-container\"><div class=\"panel-body table-over-y\" id=\"exportable\"><table class=\"table table-stripped table-hover hidden-xs hidden-sm\"><thead><tr><th>No. Siniestro</th><th>Padecimiento</th><th>Fecha de Siniestro</th></tr></thead><tbody><tr ng-repeat=\"siniestro in vm.siniestro_complementos track by $index\" ng-click=\"vm.goToSinisterInfo(2, siniestro.siniestro.id)\"><td>{{ siniestro.siniestro.numero_siniestro }}</td><td>{{ siniestro.ailment }}</td><td>{{ siniestro.siniestro.fecha_siniestro | date: \'dd/MM/yyyy\' : \'UTC\'}}</td></tr></tbody></table></div></div></div></fieldset><br><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" ng-include=\"\'templates/show-files.html\'\"></div><div class=\"col-xs-12 form-group\" ng-if=\"vm.permiso_administrar_adjuntos\"><div ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(vm.infoSiniestro)\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Archivos</button></div></div><div class=\"col-xs-12 form-group\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th><th ng-if=\"vm.permiso_archivos && vm.permiso_administrar_adjuntos\" width=\"200px\"></th></tr></thead><tbody><tr ng-repeat=\"file in filesCover track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"renameFile(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <a class=\"btn btn-danger btn-bm0\" ng-click=\"deleteFile(file, filesCover)\" ng-if=\"vm.permiso_administrar_adjuntos\">Borrar</a> <a class=\"btn btn-info btn-bm0\" onclick=\"renombrarArchivoCargado(), saveInput = true\" ng-if=\"vm.permiso_administrar_adjuntos\">Renombrar</a> <span class=\"btn btn-success btn-bm0 display-none\">Guardar</span></td><td ng-if=\"vm.permiso_archivos && vm.permiso_administrar_adjuntos\"><input type=\"checkbox\" ng-change=\"saveFile(file)\" ng-model=\"file.sensible\"> * Archivo sensible</td></tr></tbody></table></div></div></div></div></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-sm-12\"><div class=\"col-md-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"5\" idmodel=\"vm.siniestro_id\" exportable=\"true\"></comments></div></div></div></div></div>");
$templateCache.put("app/siniestros/siniestro.auto.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Siniestros</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"siniestros.lista\">Siniestros</a></li><li><span>Automóviles</span></li><li class=\"active\"><a ui-sref=\"siniestros.info\"><strong>Siniestro #{{vm.siniester_data.siniester_number}}</strong></a></li></ol></div></div><div class=\"btn-group pull-right option_button\"><button type=\"button\" class=\"btn no-mb btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_ver_pol\"><a ng-click=\"vm.goToPolicy(\'Información póliza\', \'polizas.info\', vm.selectedPoliza.data.id)\">Ver póliza</a></li><li><a ng-click=\"vm.getPDF(vm.infoSiniestro.id, vm.selectedPoliza.data.id)\">Ver PDF</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length > 0 && vm.acceso_form\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, carta.id)\">{{carta.name}}</a></li></ul></li><li><a ng-click=\"vm.crear_complemento(vm.infoSiniestro)\">Crear complemento</a></li><li class=\"dropdown-submenu\"><a>Cambiar Estatus</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-repeat=\"status in vm.statuses\" ng-model=\"status.id\" ng-click=\"changeLabel(status)\"><a>{{status.label}}</a></li></ul></li><li><a ng-click=\"vm.deleteSiniestro(vm.infoSiniestro.url)\">Eliminar</a></li><li ng-if=\"vm.selectedPoliza.data.document_type == 3\"><a ng-click=\"changeAfectado(vm.infoSiniestro)\">Editar</a></li><li><a ng-click=\"vm.sendEmail(vm.infoSiniestro, vm.selectedPoliza.data)\">Enviar correo electrónico</a></li><li ng-if=\"vm.whatsappWebEnabled\"><a ng-click=\"vm.sendWhatsAppWeb(vm.infoSiniestro, vm.selectedPoliza.data)\">Enviar WhatsApp Web</a></li></ul></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Automóviles - Información del siniestro</h5><button class=\"btn btn-default\" style=\"margin-top: -7px; color: grey\" ng-click=\"vm.getLog()\"><i class=\"fa fa-history\">Log</i></button> <button class=\"btn btn-default\" style=\"margin-top: -7px; color: green; margin-left: 10px;\" ng-if=\"vm.whatsappWebEnabled\" ng-click=\"vm.sendWhatsAppWeb(vm.infoSiniestro, vm.selectedPoliza.data)\"><i class=\"fa fa-whatsapp\"></i></button> <button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"createRecordatorio(vm.infoSiniestro,5)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-9 form-group\" ng-if=\"!newAfectado\"><label>Afectado</label><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" disabled=\"\" ng-model=\"vm.selected_affect\"></div></div><div class=\"pull-right col-xs-12 col-md-3 form-group\"><h3>Estatus del siniestro:</h3><div class=\"label\" ng-class=\"{\'label-success\': vm.infoSiniestro.status == 1, \'label-primary\': vm.infoSiniestro.status == 2, \'label-info\': vm.infoSiniestro.status == 3, \'label-warning\': vm.infoSiniestro.status == 4, \'label-danger\': vm.infoSiniestro.status == 5}\"><span>{{statusSinister}}</span></div></div></div><div class=\"row\" ng-if=\"newAfectado\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Afectado:</label><div class=\"col-xs-12 input-group\"><br><div class=\"col-xs-12 input-group\" ng-if=\"vm.selectedPoliza.data.document_type == 3\"><autocomplete datasource=\"autocompleteDataCertificate\" model=\"vm.word_certificate\" change=\"vm.getCertificate(vm.word_certificate)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getTypeCertificate(vm.word_certificate)\"><span class=\"fa fa-ballot\"></span>Elegir</button></div></div></div></div></div><legend align=\"center\">Información del siniestro</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de emisión</label><div class=\"input-group date\"><input class=\"form-control\" date-time=\"\" ng-model=\"vm.infoSiniestro.fecha_ingreso\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número de siniestro</label> <input class=\"form-control\" ng-model=\"vm.siniester_data.siniester_number\" name=\"numero_de_siniestro\" ng-blur=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha en que ocurrió</label><div class=\"input-group date\"><input class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.siniester_date\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Tipo de siniestro</label><select name=\"siniestroType\" ng-model=\"vm.siniester_type\" id=\"siniestroType\" class=\"select form-control\" ng-options=\"siniester_tipo.id as siniester_tipo.label for siniester_tipo in vm.siniestros_type\" ng-blur=\"save_info_tab()\"></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.siniester_type == 1 || vm.siniester_type == 5 || vm.siniester_type == 6\"><label ng-if=\"vm.siniester_type == 1\">¿Contra qué?:</label> <label ng-if=\"vm.siniester_type == 5\">¿Qué se llevaron?:</label> <label ng-if=\"vm.siniester_type == 6\">¿Cúal?:</label> <input class=\"form-control\" ng-model=\"vm.siniester_data.tercero\" name=\"terceros\" ng-blur=\"save_info_tab()\"></div><div class=\"col-xs-12 form-group\"><label>¿Cómo ocurrió?</label> <input type=\"textarea\" class=\"form-control\" ng-model=\"vm.siniester_data.explicacion\" name=\"explicacion\" ng-blur=\"save_info_tab()\"></div><div class=\"col-xs-12 form-group\"><label>Conductor</label> <input type=\"textarea\" class=\"form-control\" ng-model=\"vm.siniester_data.conductor\" name=\"conductor\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.status.id == 3\"><label>Indemnización</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.siniester_data.indemnizacion\" format-as-currency=\"\" step=\"any\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.status.id == 3\"><label>Deducible</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.siniester_data.deducible\" format-as-currency=\"\" step=\"any\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.status.id == 3\"><label>Coaseguro</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.siniester_data.coaseguro\" format-as-currency=\"\" step=\"any\" type=\"text\"></div><div class=\"col-xs-12 form-group\"><div ng-if=\"vm.infoSiniestro.reason\" class=\"form-group\"><label>Razón de cancelación/rechazo</label> <input class=\"form-control\" ng-model=\"vm.infoSiniestro.reason\" name=\"reason\"></div></div></div><div class=\"row\"><legend align=\"center\">Información General</legend><div class=\"col-xs-12 form-group\"><h3 class=\"blue-color\" style=\"display: inline-block;\">Estatus de Pago:</h3><h3 style=\"display: inline-block;\"><span>{{ vm.affect_data.policy_status.label }}</span></h3></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Fecha de Captura:</span><div><span>{{ vm.infoSiniestro.created_at | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ vm.affect_data.contratante.name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{ vm.affect_data.policy_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.affect_data.policy_vigencia_init | date: \'dd/MM/yyyy\': \'UTC\' }} - {{ vm.affect_data.policy_vigencia | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.siniester_data.subramo.subramo_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ vm.affect_data.aseguradora.compania }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Plan/Paquete</span><div><span>{{ vm.affect_data.paquete.package_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Dirección:</span><div><span>{{ vm.affect_data.contractor_addres }}</span></div></div><div class=\"col-md-3 form-group\"><span class=\"blue-color\">Creado por:</span><div><span>{{ vm.infoSiniestro.owner }}</span></div></div><div class=\"col-md-3 form-group\" ng-if=\"vm.infoSiniestro.status == 2\"><label>Folio:</label> <input ng-model=\"vm.siniester_data.companyFolio\" class=\"form-control\"></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showRecordatorios()\">{{vm.infoSiniestro.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"showRecordatorios()\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in vm.infoSiniestro.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div class=\"row\"><legend align=\"center\">Información de Contacto</legend><div class=\"col-xs-12\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Nombre</th><th>Teléfono</th><th>Correo electrónico</th><th>Referencia</th><th></th></tr></thead><tbody><tr ng-repeat=\"contact in vm.contacts track by $index\"><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.first_name\" ng-disabled=\"contact.org_name == null\"></td><td><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone\" disabledfield=\"contact.org_name == null\"></phonenumber-directive></td><td><input class=\"form-control\" type=\"email\" ng-model=\"contact.email\" ng-disabled=\"contact.org_name == null\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.references\" ng-disabled=\"contact.org_name == null\"></td><td><i class=\"fa fa-check\" ng-if=\"contact.id\"></i></td></tr></tbody></table></div><div class=\"col-sm-12\"><button class=\"btn btn-default pull-right\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button></div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-click=\"vm.saveContact(vm.contacts)\" type=\"button\">Guardar contactos</button></div></div><br><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Observaciones:</label> <textarea disabled=\"\" class=\"form-control\" ng-model=\"vm.siniester_data.observations\"></textarea></div></div><div class=\"hr-line-dashed\"></div><div upload-template=\"\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div class=\"row\" ng-if=\"url !== \'/index/main\'\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\" ng-if=\"url !== \'/index/main\'\"></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"5\" idmodel=\"vm.siniestro_id\" exportable=\"true\"></comments></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"!checkRegister\"><button type=\"button\" ng-if=\"!newAfectado\" ng-disabled=\"!vm.user.permiso.editar\" ng-click=\"vm.saveEditInformation()\" class=\"col-xs-12 btn btn-primary pull-right\">Guardar cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"newAfectado\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-click=\"saveEditInformation2(vm.infoSiniestro )\">Guardar cambios*</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-white pull-right\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div>");
$templateCache.put("app/siniestros/siniestro.danio.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Siniestros</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"siniestros.lista\">Siniestros</a></li><li class=\"active\"><a>Daños</a></li><li class=\"active\"><a ui-sref=\"siniestros.info\"><strong>Siniestro #{{vm.infoSiniestro.siniestro.numero_siniestro}}</strong></a></li></ol></div></div><br><div class=\"btn-group pull-right option_button\"><button type=\"button\" class=\"btn no-mb btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_ver_pol\"><a ng-click=\"vm.goToPolicy(\'Información póliza\', \'polizas.info\', forms.id)\">Ver póliza</a></li><li><a ng-click=\"vm.deleteSiniestro(vm.infoSiniestro.siniestro.url)\">Eliminar</a></li><li><a ng-click=\"vm.getPDF(vm.infoSiniestro.siniestro.id, vm.infoSiniestro.poliza.id)\">Ver PDF</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length && vm.acceso_form\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, carta.id)\">{{carta.name}}</a></li></ul></li><li class=\"dropdown-submenu\"><a>Cambiar Estatus</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-repeat=\"status in vm.statuses\" ng-model=\"status.id\" ng-click=\"changeLabel(status)\"><a>{{status.label}}</a></li></ul></li><li><a ng-click=\"vm.sendEmail(vm.infoSiniestro.siniestro, vm.infoSiniestro.poliza)\">Enviar correo electrónico</a></li><li ng-if=\"vm.whatsappWebEnabled\"><a ng-click=\"vm.sendWhatsAppWeb(vm.infoSiniestro.siniestro, vm.infoSiniestro.poliza)\">Enviar WhatsApp Web</a></li></ul></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información del siniestro</h5><button class=\"btn btn-default\" style=\"margin-top: -7px; color: grey\" ng-click=\"vm.getLog()\"><i class=\"fa fa-history\">Log</i></button> <button class=\"btn btn-default\" style=\"margin-top: -7px; color: green\" ng-if=\"vm.whatsappWebEnabled\" ng-click=\"vm.sendWhatsAppWeb(vm.infoSiniestro.siniestro, vm.infoSiniestro.poliza)\"><i class=\"fa fa-whatsapp\"></i></button> <button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"createRecordatorio(vm.infoSiniestro.siniestro,5)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Bien Asegurado</label><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" disabled=\"\" ng-model=\"vm.selected_affect\"></div></div><div class=\"pull-right col-xs-12 col-sm-3 form-group\"><h3>Estatus del siniestro:</h3><div class=\"label\" ng-class=\"{\'label-success\': vm.infoSiniestro.siniestro.status == 1, \'label-primary\': vm.infoSiniestro.siniestro.status == 2, \'label-info\': vm.infoSiniestro.siniestro.status == 3, \'label-warning\': vm.infoSiniestro.siniestro.status == 4, \'label-secondary\': vm.infoSiniestro.siniestro.status == 6, \'label-danger\': vm.infoSiniestro.siniestro.status == 5}\"><span>{{statusSinister}}</span></div></div><div ng-if=\"actualizando\" class=\"pull-right col-xs-12 col-sm-3 form-group\"><div class=\"form-group container-loader\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div></div></div><div class=\"row col-xs-12\"><div class=\"modal-body\" ng-if=\"vm.infoSiniestro.siniestro.status == 4 || vm.infoSiniestro.siniestro.status == 5\"><label>Razón de cancelación / rechazo:</label> <textarea class=\"form-control\" disabled=\"\" ng-model=\"vm.infoSiniestro.siniestro.reason\"></textarea></div></div><div class=\"row\"><br><legend align=\"center\">Información del Siniestro</legend><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de Emisión</label><div class=\"input-group date\"><input class=\"form-control\" date-time=\"\" ng-model=\"vm.infoSiniestro.siniestro.fecha_ingreso\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número de Siniestro</label> <input class=\"form-control\" ng-model=\"vm.siniester_data.siniester_number\" name=\"numero_de_siniestro\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.siniestro.status == 2\"><label>Fecha compromiso</label><div class=\"input-group date\"><input class=\"form-control\" date-time=\"\" ng-model=\"vm.infoSiniestro.siniestro.fecha_compromiso\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha en que ocurrió</label><div class=\"input-group date\"><input class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.siniester_date\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"row\" ng-if=\"vm.status.id == 2|| vm.status.id == 3\"><div class=\"col-md-3 form-group\"></div><div class=\"col-md-3 form-group\"><label>Folio del Siniestro</label> <input class=\"form-control\" disabled=\"\" ng-model=\"vm.folio_siniestro\" required=\"\"></div><div class=\"col-md-3 form-group\"><label>Fecha compromiso</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" disabled=\"\" date-time=\"\" ng-model=\"vm.fecha_compromiso\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" required=\"\"></div></div><div class=\"col-md-3 form-group\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Cobertura afectada</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.danios_sin.cobertura_afectada\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Causa reclamación</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.danios_sin.causa_reclamacion\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.danios_sin.currency\"><label>Moneda</label> <input disabled=\"\" class=\"form-control\" value=\"Pesos\" ng-if=\"vm.infoSiniestro.danios_sin.currency == 1\"> <input disabled=\"\" class=\"form-control\" value=\"Dólares\" ng-if=\"vm.infoSiniestro.danios_sin.currency == 2\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.danios_sin.tipo_cambio\"><label>Tipo cambio</label> <input disabled=\"\" class=\"form-control\" value=\"Pesos\" ng-if=\"vm.infoSiniestro.danios_sin.tipo_cambio == 1\"> <input disabled=\"\" class=\"form-control\" value=\"Dólares\" ng-if=\"vm.infoSiniestro.danios_sin.tipo_cambio == 2\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Estimación pérdida</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.danios_sin.estimacion_perdida\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><label>Indeminización</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.danios_sin.indemnizacion\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><label>Deducible</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.danios_sin.total_deducible\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><label>Coaseguro</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.danios_sin.total_coaseguro\"></div><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-12 form-group\"><label>Descripción</label> <textarea ng-disabled=\"vm.infoSiniestro.siniestro.status == 4 || vm.infoSiniestro.siniestro.status == 5 || vm.infoSiniestro.siniestro.status == 3\" class=\"form-control\" ng-model=\"vm.siniester_data.observations\">\n            </textarea></div></div><div class=\"row\"><br><legend align=\"center\">Información general</legend><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Fecha de Captura:</span><div><span>{{ vm.infoSiniestro.siniestro.created_at | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ vm.affect_data.contratante.name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ vm.affect_data.contratante.birthdate | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{ vm.affect_data.policy_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.siniester_data.subramo.subramo_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.affect_data.policy_vigencia_init | date: \'dd/MM/yyyy\' : \'UTC\' }} - {{ vm.affect_data.policy_vigencia | date: \'dd/MM/yyyy\' : \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ vm.affect_data.aseguradora.compania }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Plan/Paquete:</span><div><span>{{ vm.affect_data.paquete.package_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Domicilio:</span><div><span>{{ vm.affect_data.contractor_addres.address }}</span></div></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showRecordatorios()\">{{vm.infoSiniestro.siniestro.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"showRecordatorios()\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in vm.infoSiniestro.siniestro.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div class=\"row\" id=\"pre_completado\"><legend align=\"center\">Facturación</legend><div class=\"alert alert-info no-margin font-12\"><strong>Columnas:</strong> Serie, No. Factura, Concepto, Proveedor, Fecha de factura (dd/mm/aaaa), Importe, IVA y Total.</div><div class=\"col-xs-12\" id=\"exportable\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Serie</th><th>No. Factura</th><th>Proveedor</th><th>Fecha de factura</th><th>Importe</th><th>IVA</th><th>Total</th><th>Procedente</th><th ng-show=\"false\">Observaciones</th><th colspan=\"2\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"factura in vm.facturas track by $index\"><td><input class=\"form-control\" type=\"text\" ng-init=\"factura.serie ? factura.serie : factura.serie = $index + 1\" ng-model=\"factura.serie\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.f_number\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.proovedor\"></td><td><input class=\"form-control\" date-time=\"\" ng-model=\"factura.f_date\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></td><td><input class=\"form-control\" type=\"number\" step=\"0.01\" ng-model=\"factura.import\" ng-change=\"calculateIva($index, factura.import)\"></td><td><input class=\"form-control\" type=\"number\" step=\"0.01\" ng-model=\"factura.iva\" ng-change=\"calculateTotal($index, factura.iva)\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.total\" disabled=\"\"></td><td><input class=\"form-control\" type=\"number\" step=\"0.01\" ng-if=\"vm.status.id ==\'3\'\" ng-model=\"factura.procedente\"></td><td><button type=\"button\" ng-disabled=\"vm.infoSiniestro.siniestro.status == 4 || vm.infoSiniestro.siniestro.status == 5 || vm.infoSiniestro.siniestro.status == 3\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.deleteFactura(factura.url,$index)\" ng-if=\"vm.user.permiso.editar\"><span class=\"fa fa-trash-o\"></span></button></td><td><button type=\"button\" class=\"btn btn-white btn-sm\" name=\"button\" ng-if=\"factura.url\" ng-click=\"vm.viewObservation(factura.url,vm.infoSiniestro.siniestro.status)\"><i class=\"fa fa-commenting-o\" aria-hidden=\"true\"></i></button></td></tr><tr ng-repeat=\"factura in vm.facturas track by $index\" ng-show=\"false\"><td>{{factura.serie}}</td><td>{{factura.f_number}}</td><td>{{factura.proovedor}}</td><td class=\"position-date\">{{factura.f_date}}</td><td>{{factura.import}}</td><td>{{factura.iva}}</td><td>{{factura.total}}</td><td>{{factura.procedente}}</td><td>{{factura.observaciones}}</td></tr></tbody></table><div class=\"col-xs-12 form-group\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addFactura()\" type=\"button\">Agregar factura</button> <button class=\"btn btn-primary\" ng-click=\"vm.downloadFacturas()\">Descargar facturas</button></div></div><div><div class=\"col-xs-12 col-sm-4\" ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><label>Cantidad reclamada:</label> <input disabled=\"\" format-as-currency=\"\" ng-model=\"vm.infoSiniestro.danios_sin.total_reclamado\" class=\"form-control\"></div></div><div class=\"row\" ng-if=\"vm.infoSiniestro.accidente.contact_phone || vm.infoSiniestro.accidente.contact_email || vm.infoSiniestro.accidente.contact_first_name\"><legend align=\"center\">Información de Contacto</legend><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Nombre</th><th>Teléfono</th><th>Correo electrónico</th><th>Referencia</th></tr></thead><tbody><tr><td><input disabled=\"\" class=\"form-control\" type=\"text\" ng-model=\"vm.infoSiniestro.accidente.contact_first_name\"></td><td><phonenumber-directive disabledfield=\"vm.infoSiniestro.accidente\" placeholder=\"myPrompt\" model=\"vm.infoSiniestro.accidente.contact_phone\"></phonenumber-directive></td><td><input disabled=\"\" class=\"form-control\" type=\"email\" ng-model=\"vm.infoSiniestro.accidente.contact_email\"></td><td><input disabled=\"\" class=\"form-control\" type=\"text\" ng-model=\"vm.infoSiniestro.accidente.contact_references\"></td></tr></tbody></table></div></div><div class=\"hr-line-dashed\"></div><div upload-template=\"\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div class=\"col-xs-12 text-right form-group\"><button class=\"btn btn-primary\" ng-click=\"saveFiles(vm.infoSiniestro)\" ng-if=\"vm.permiso_administrar_adjuntos\"><i class=\"fa fa-save\" aria-hidden=\"true\"></i> Guardar Archivos</button></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\"></div></div><div class=\"row\"><legend align=\"center\">Información de Contacto</legend><div class=\"col-xs-12\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Nombre</th><th>Teléfono</th><th>Correo electrónico</th><th>Referencia</th><th></th></tr></thead><tbody><tr ng-repeat=\"contact in vm.contacts track by $index\"><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.first_name\" ng-disabled=\"contact.org_name == null\"></td><td><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone\" disabledfield=\"contact.org_name == null\"></phonenumber-directive></td><td><input class=\"form-control\" type=\"email\" ng-model=\"contact.email\" ng-disabled=\"contact.org_name == null\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.references\" ng-disabled=\"contact.org_name == null\"></td><td><i class=\"fa fa-check\" ng-if=\"contact.id\"></i></td></tr></tbody></table></div><div class=\"col-sm-12\"><button class=\"btn btn-default pull-right\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button></div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-click=\"vm.saveContact(vm.contacts)\" type=\"button\">Guardar contactos</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"5\" idmodel=\"vm.siniestro_id\" exportable=\"true\"></comments></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"vm.status.id == \'3\'\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"vm.saveEditInformation()\" type=\"button\">Completar Siniestro</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"!checkRegister && !(vm.status.id == \'3\')\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-disabled=\"!vm.user.permiso.editar; vm.infoSiniestro.siniestro.status == 3\" ng-click=\"vm.saveEditInformation()\">Guardar cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div>");
$templateCache.put("app/siniestros/siniestro.info.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Siniestros</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"siniestros.lista\">Siniestros</a></li><li class=\"active\"><a>Accidentes y Enfermedades</a></li><li class=\"active\"><a ui-sref=\"siniestros.info\"><strong>Siniestro #{{vm.infoSiniestro.siniestro.numero_siniestro}}</strong></a></li></ol></div></div><br><div class=\"btn-group pull-right option_button\"><button type=\"button\" class=\"btn no-mb btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li><a ng-click=\"vm.goToPolicy(forms.id)\">Ver póliza</a></li><li><a ng-click=\"vm.deleteSiniestro(vm.infoSiniestro.siniestro.url)\">Eliminar</a></li><li><a ng-click=\"vm.getPDF(vm.infoSiniestro.siniestro.id, vm.infoSiniestro.poliza.id)\">Ver PDF</a></li><li ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><a ng-click=\"vm.getPDFiniquito(vm.infoSiniestro.siniestro.id, vm.infoSiniestro.poliza.id)\">Hoja de finiquito</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length && view_cartas\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, carta.id)\">{{carta.name}}</a></li></ul></li><li><a ng-click=\"vm.crear_complemento(vm.infoSiniestro)\">Crear complemento</a></li><li class=\"dropdown-submenu\"><a>Cambiar Estatus</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-repeat=\"status in vm.statuses\" ng-model=\"status.id\" ng-click=\"changeLabel(status)\"><a>{{status.label}}</a></li></ul></li></ul></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información del siniestro</h5><button class=\"btn btn-default\" style=\"margin-top: -7px; color: grey\" ng-click=\"vm.getLog()\"><i class=\"fa fa-history\">Log</i></button></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Afectado</label><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" disabled=\"\" ng-model=\"vm.selected_affect\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"vm.infoSiniestro.siniestro.aux_affected\"><label>Parentesco</label><div class=\"col-xs-12 input-group\"><input ng-if=\"vm.infoSiniestro.siniestro.relationship_aux_affected == 1\" type=\"text\" class=\"form-control\" disabled=\"\" value=\"Titular\"> <input ng-if=\"vm.infoSiniestro.siniestro.relationship_aux_affected == 2\" type=\"text\" class=\"form-control\" disabled=\"\" value=\"Cónyuge\"> <input ng-if=\"vm.infoSiniestro.siniestro.relationship_aux_affected == 3\" type=\"text\" class=\"form-control\" disabled=\"\" value=\"Hijo\"> <input ng-if=\"vm.infoSiniestro.siniestro.relationship_aux_affected == 4\" type=\"text\" class=\"form-control\" disabled=\"\" value=\"Otro\"></div></div><div class=\"pull-right col-xs-12 col-sm-3 form-group\"><h3>Estatus del siniestro:</h3><div class=\"label\" ng-class=\"{\'label-success\': vm.infoSiniestro.siniestro.status == 1, \'label-primary\': vm.infoSiniestro.siniestro.status == 2, \'label-info\': vm.infoSiniestro.siniestro.status == 3, \'label-warning\': vm.infoSiniestro.siniestro.status == 4, \'label-danger\': vm.infoSiniestro.siniestro.status == 5}\"><span>{{statusSinister}}</span></div></div></div><div class=\"row col-xs-12\"><div class=\"modal-body\" ng-if=\"vm.infoSiniestro.siniestro.status == 4 || vm.infoSiniestro.siniestro.status == 5\"><label>Razón de cancelación / rechazo:</label> <textarea class=\"form-control\" disabled=\"\" ng-model=\"vm.infoSiniestro.siniestro.reason\"></textarea></div></div><div class=\"row\"><br><legend align=\"center\">Información del Siniestro</legend><div class=\"col-xs-12 col-lg-3 btn-group form-group\" role=\"group\" aria-label=\"...\"><button id=\"btn-inicial\" type=\"button\" ng-click=\"vm.checkRadio(\'Inicial\')\" class=\"btn btn-default\">Inicial</button> <button id=\"btn-complemento\" type=\"button\" ng-click=\"vm.checkRadio(\'Complemento\')\" class=\"btn btn-default\">Complemento</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de Emisión</label><div class=\"input-group date\"><input class=\"form-control\" date-time=\"\" ng-model=\"vm.infoSiniestro.siniestro.fecha_ingreso\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número de Siniestro</label> <input class=\"form-control\" ng-model=\"vm.siniester_data.siniester_number\" name=\"numero_de_siniestro\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><label>Número de Complemento</label><div class=\"input-group date\"><input disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.siniester_data.complemento\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha en que ocurrió</label><div class=\"input-group date\"><input class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.siniester_date\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\" ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><label ng-if=\"!vm.isInicial\">Número de Complemento</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.siniester_data.complemento\" ng-if=\"!vm.isInicial\"></div><div class=\"row\" ng-if=\"vm.status.id == 2|| vm.status.id == 3\"><div class=\"col-md-3 form-group\"></div><div class=\"col-md-3 form-group\"><label>Folio del Siniestro</label> <input class=\"form-control\" disabled=\"\" ng-model=\"vm.siniester_data.companyFolio\" required=\"\"></div><div class=\"col-md-3 form-group\"><label>Fecha promesa</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" disabled=\"\" date-time=\"\" ng-model=\"vm.fecha_promesa\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" required=\"\"></div></div><div class=\"col-md-3 form-group\"></div></div><div class=\"col-xs-12 col-lg-offset-3 col-lg-9 form-group\"><label>Padecimiento</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.accidente.ailment\"></div><div class=\"col-xs-12 col-lg-offset-3 col-lg-9 form-group\"><label>Observaciones</label> <textarea ng-disabled=\"vm.infoSiniestro.siniestro.status == 4 || vm.infoSiniestro.siniestro.status == 5 || vm.infoSiniestro.siniestro.status == 3\" class=\"form-control\" ng-model=\"vm.siniester_data.observations\">\n            </textarea></div><div class=\"col-xs-12 col-sm-6 col-lg-offset-3 col-lg-3 form-group\"><label>Tipo de Sinestro</label><select name=\"siniestroType\" id=\"siniestroType\" class=\"select form-control\"><option value=\"0\" disabled=\"\">Seleccionar una opción</option><option value=\"1\">Accidente</option><option value=\"2\">Enfermedad</option><option value=\"3\">Parto</option></select></div><div class=\"col-xs-12 col-sm-6 col-lg-3 form-group\"><label>Forma de Pago</label><select name=\"payWay\" id=\"payWay\" class=\"select form-control\"><option value=\"0\" disabled=\"\">Seleccionar una opción</option><option value=\"1\">Reembolso</option><option value=\"2\">Programación</option><option value=\"3\">Pago Directo</option><option value=\"4\">Aclaración</option></select></div></div><div class=\"row\"><br><legend align=\"center\">Información general</legend><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Fecha de Emisión:</span><div><span>{{ vm.infoSiniestro.siniestro.fecha_ingreso | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Fecha de Captura:</span><div><span>{{ vm.infoSiniestro.siniestro.created_at | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ vm.affect_data.contratante.name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Fecha de Nacimiento:</span><div><span>{{ vm.affect_data.birthdate | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Número de Póliza:</span><div><span>{{ vm.affect_data.policy_number }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.siniester_data.subramo.subramo_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.affect_data.policy_vigencia_init | date: \'dd/MM/yyyy\': \'UTC\' }} - {{ vm.affect_data.policy_vigencia | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ vm.affect_data.aseguradora.compania }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Plan/Paquete:</span><div><span>{{ vm.affect_data.paquete.package_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Domicilio:</span><div><span>{{ vm.affect_data.contractor_addres.address }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Parentesco:</span><div><span>{{ vm.affect_data.title }}</span></div></div></div><div class=\"row\" id=\"pre_completado\"><legend align=\"center\">Facturación</legend><div class=\"col-xs-12\" id=\"exportable\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Serie</th><th>No. Factura</th><th>Concepto</th><th>Proveedor</th><th>Fecha de factura</th><th>Importe</th><th>IVA</th><th>Total</th><th>Procedente</th><th ng-show=\"false\">Observaciones</th><th colspan=\"2\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"factura in vm.facturas track by $index\"><td><input class=\"form-control\" type=\"text\" ng-init=\"factura.serie ? factura.serie : factura.serie = $index + 1\" ng-model=\"factura.serie\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.f_number\"></td><td><select ng-model=\"facturas.concepto\" ng-options=\"item.value as item.name for item in vm.facturas_conceptos\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.proovedor\"></td><td><input class=\"form-control\" date-time=\"\" ng-model=\"factura.f_date\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></td><td><input class=\"form-control\" type=\"number\" step=\"0.01\" ng-model=\"factura.import\" ng-change=\"calculateIva($index, factura.import)\"></td><td><input class=\"form-control\" type=\"number\" step=\"0.01\" ng-model=\"factura.iva\" ng-change=\"calculateTotal($index, factura.iva)\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.total\" disabled=\"\"></td><td><input class=\"form-control\" type=\"number\" step=\"0.01\" ng-if=\"vm.status.id ==\'3\'\" ng-model=\"factura.procedente\"></td><td><button type=\"button\" ng-disabled=\"vm.infoSiniestro.siniestro.status == 4 || vm.infoSiniestro.siniestro.status == 5 || vm.infoSiniestro.siniestro.status == 3\" class=\"btn btn-danger\" name=\"button\" ng-click=\"vm.deleteFactura(factura.url,$index)\" ng-if=\"vm.user.permiso.editar\"><span class=\"fa fa-trash-o\"></span></button></td><td><button type=\"button\" class=\"btn btn-white btn-sm\" name=\"button\" ng-if=\"factura.url\" ng-click=\"vm.viewObservation(factura.url,vm.infoSiniestro.siniestro.status)\"><i class=\"fa fa-commenting-o\" aria-hidden=\"true\"></i></button></td></tr><tr ng-repeat=\"factura in vm.facturas track by $index\" ng-show=\"false\"><td>{{factura.serie}}</td><td>{{factura.f_number}}</td><td>{{factura.proovedor}}</td><td class=\"position-date\">{{factura.f_date}}</td><td>{{factura.import}}</td><td>{{factura.iva}}</td><td>{{factura.total}}</td><td>{{factura.procedente}}</td><td>{{factura.observaciones}}</td></tr></tbody></table><div class=\"col-xs-12 form-group\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addFactura()\" type=\"button\">Agregar factura</button> <button class=\"btn btn-primary\" ng-click=\"vm.downloadFacturas()\">Descargar facturas</button></div></div><div><div class=\"col-xs-12 col-sm-4\" ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><label>Cantidad reclamada:</label> <input disabled=\"\" format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_reclamado\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4\" ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><label>Cantidad procedente:</label> <input disabled=\"\" format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_procedente\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4\" ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><label>Coaseguro:</label> <input disabled=\"\" format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_coaseguro\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4\" ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><label>Deducible:</label> <input disabled=\"\" format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_deducible\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4\" ng-if=\"vm.infoSiniestro.siniestro.status == 3\"><label>Total pagado:</label> <input disabled=\"\" format-as-currency=\"\" ng-model=\"vm.infoSiniestro.accidente.total_final\" class=\"form-control\"></div></div><div class=\"row\" ng-if=\"vm.infoSiniestro.accidente.contact_phone || vm.infoSiniestro.accidente.contact_email || vm.infoSiniestro.accidente.contact_first_name\"><legend align=\"center\">Información de Contacto</legend><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Nombre</th><th>Teléfono</th><th>Correo electrónico</th><th>Referencia</th></tr></thead><tbody><tr><td><input disabled=\"\" class=\"form-control\" type=\"text\" ng-model=\"vm.infoSiniestro.accidente.contact_first_name\"></td><td><phonenumber-directive disabledfield=\"vm.infoSiniestro.accidente\" placeholder=\"myPrompt\" model=\"vm.infoSiniestro.accidente.contact_phone\"></phonenumber-directive></td><td><input disabled=\"\" class=\"form-control\" type=\"email\" ng-model=\"vm.infoSiniestro.accidente.contact_email\"></td><td><input disabled=\"\" class=\"form-control\" type=\"text\" ng-model=\"vm.infoSiniestro.accidente.contact_references\"></td></tr></tbody></table></div></div><div class=\"hr-line-dashed\"></div><div upload-template=\"\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\"></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"5\" idmodel=\"vm.siniestro_id\" exportable=\"true\"></comments></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"vm.status.id == \'3\'\"><button class=\"col-xs-12 btn btn-primary\" ng-click=\"vm.saveEditInformation()\" type=\"button\">Completar Siniestro</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"!checkRegister && !(vm.status.id == \'3\')\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-disabled=\"!vm.user.permiso.editar; vm.infoSiniestro.siniestro.status == 3\" ng-click=\"vm.saveEditInformation()\">Guardar cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div>");
$templateCache.put("app/siniestros/siniestro.vida.info.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Siniestros</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a ui-sref=\"siniestros.lista\">Siniestros</a></li><li><span>Vida</span></li><li class=\"active\"><a ui-sref=\"siniestros.info\"><strong>Siniestro #{{vm.siniester_data.siniester_number}}</strong></a></li></ol></div></div><div class=\"btn-group pull-right option_button\"><button type=\"button\" class=\"btn no-mb btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"fa fa-bolt\"></span> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.acceso_ver_pol\"><a ng-click=\"vm.goToPolicy(\'Información pólizas\', \'polizas.info\', forms.id)\">Ver póliza</a></li><li><a ng-click=\"vm.getPDF(vm.infoSiniestro.id, vm.selectedPoliza.data.id)\">Ver PDF</a></li><li class=\"dropdown-submenu\" ng-if=\"files.length\"><a>Ver adjuntos</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"!files\"><a class=\"disabled\">No hay archivos adjuntos</a></li><li class=\"disabled\" ng-if=\"files\"><a class=\"disabled\">Archivos adjuntos</a></li><li ng-if=\"files\" ng-repeat=\"file in files track by $index\"><a href=\"{{file.arch}}\" target=\"_blank\">{{file.nombre}}</a></li></ul></li><li class=\"dropdown-submenu\" ng-if=\"vm.cartas.length && vm.acceso_form\"><a>Ver carta</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-if=\"vm.cartas\" ng-repeat=\"carta in vm.cartas track by $index\"><a ng-click=\"vm.viewCarta(vm.insurance.id, carta.id)\">{{carta.name}}</a></li></ul></li><li><a ng-click=\"vm.crear_complemento(vm.infoSiniestro)\">Crear complemento</a></li><li class=\"dropdown-submenu\"><a>Cambiar Estatus</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-repeat=\"status in vm.statuses\" ng-model=\"status.id\" ng-click=\"changeLabel(status)\"><a>{{status.label}}</a></li></ul></li><li ng-if=\"vm.infoSiniestro.poliza.document_type ==3\"><a ng-click=\"changeAfectado(vm.infoSiniestro.poliza)\">Editar</a></li><li ng-if=\"vm.whatsappWebEnabled\"><a ng-click=\"vm.sendWhatsAppWeb(vm.infoSiniestro, vm.selectedPoliza.data)\">Enviar WhatsApp Web</a></li><li><a ng-click=\"vm.sendEmail(vm.infoSiniestro, vm.selectedPoliza.data)\">Enviar correo electrónico</a></li></ul></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Vida - Información del siniestro</h5><button class=\"btn btn-default\" style=\"margin-top: -7px; color: grey\" ng-click=\"vm.getLog()\"><i class=\"fa fa-history\">Log</i></button> <button class=\"btn btn-default\" style=\"margin-top: -7px; color: green; margin-left: 10px;\" ng-if=\"vm.whatsappWebEnabled\" ng-click=\"vm.sendWhatsAppWeb(vm.infoSiniestro, vm.selectedPoliza.data)\"><i class=\"fa fa-whatsapp\"></i></button> <button class=\"btn btn-default pull-right btn-tab10\" style=\"margin-top: -7px; color: grey\" title=\"Crear Recordatorio\" ng-click=\"createRecordatorio(vm.infoSiniestro,5)\"><i class=\"fa fa-clock-o\"></i></button></div><div class=\"ibox-content\"><div class=\"row\" ng-if=\"!newAfectado\"><div class=\"col-xs-12 col-sm-6\"><label>Afectado</label> <input disabled=\"\" class=\"form-control\" type=\"text\" ng-model=\"vm.selected_affect\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\"><h3>Estatus del siniestro:</h3><div class=\"label\" ng-class=\"{\'label-success\': vm.infoSiniestro.status == 1, \'label-primary\': vm.infoSiniestro.status == 2, \'label-info\': vm.infoSiniestro.status == 3, \'label-warning\': vm.infoSiniestro.status == 4, \'label-danger\': vm.infoSiniestro.status == 5}\"><span>{{statusSinister}}</span></div></div></div><div class=\"row\" ng-if=\"newAfectado\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Afectado:</label><div class=\"col-xs-12 input-group\"><br><div class=\"col-xs-12 input-group\" ng-if=\"vm.infoSiniestro.poliza.document_type == 3\"><autocomplete datasource=\"autocompleteDataCertificate\" model=\"vm.word_certificate\" change=\"vm.getCertificate(vm.word_certificate)\"></autocomplete><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-block btn-success\" ng-disabled=\"btnSearchDisabled\" ng-click=\"vm.getTypeCertificate(vm.word_certificate)\"><span class=\"fa fa-ballot\"></span>Elegir</button></div></div></div></div></div><legend align=\"center\">Información del siniestro</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de emisión</label><div class=\"input-group date\"><input class=\"form-control\" date-time=\"\" ng-model=\"vm.infoSiniestro.fecha_ingreso\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Número de siniestro</label> <input class=\"form-control\" ng-model=\"vm.siniester_data.siniester_number\" name=\"numero_de_siniestro\" ng-blur=\"save_info_tab()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha en que ocurrió</label><div class=\"input-group date\"><input class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.siniester_date\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo de sinestro</label><select name=\"siniestroType\" ng-model=\"vm.siniester_type\" id=\"siniestroType\" class=\"select form-control\" ng-options=\"siniester_tipo.id as siniester_tipo.label for siniester_tipo in vm.siniestros_type\" ng-blur=\"save_info_tab()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Forma de pago</label><select name=\"payWay\" id=\"payWay\" ng-model=\"vm.siniester_pay_form\" class=\"select form-control\" ng-options=\"siniester_tipo.id as siniester_tipo.label for siniester_tipo in vm.siniestros_pay_form\" ng-blur=\"save_info_tab()\"></select></div><div ng-if=\"vm.infoSiniestro.folio_compania\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Folio del siniestro</label> <input class=\"form-control\" ng-model=\"vm.infoSiniestro.folio_compania\" name=\"folio_compañia\"></div><div ng-if=\"vm.infoSiniestro.promise_date && vm.infoSiniestro.status != 1\" class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha promesa</label><div class=\"input-group date\"><input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.infoSiniestro.promise_date\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"row\"><div ng-if=\"vm.infoSiniestro.reason\" class=\"col-md-12 form-group\"><label>Razón de cancelación/rechazo</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.infoSiniestro.reason\" name=\"reason\"></div></div><br><div class=\"ibox float-e-margins animate m-t\" ng-if=\"recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"showRecordatorios()\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in vm.infoSiniestro.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><br><fieldset><legend align=\"center\">Información general</legend><div class=\"row\"><div class=\"col-xs-12 form-group\"><h3 class=\"blue-color\" style=\"display: inline-block;\">Estatus de Pago:</h3><h3 style=\"display: inline-block;\"><span>{{ vm.affect_data.policy_status.label }}</span></h3></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Fecha de captura:</span><div><span>{{ vm.infoSiniestro.created_at | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Contratante:</span><div><span>{{ vm.affect_data.contratante.name}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Fecha de nacimiento:</span><div><span>{{ vm.affect_data.birthdate | date: \'dd/MM/yyyy\': \'UTC\' }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Parentesco:</span><div><span>{{ vm.affect_data.title}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Número de póliza:</span><div><span>{{ vm.affect_data.policy_number}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Subramo:</span><div><span>{{ vm.siniester_data.subramo.subramo_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Domicilio:</span><div><span>{{ vm.affect_data.contractor_addres}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Vigencia:</span><div><span>{{ vm.affect_data.policy_vigencia_init | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{ vm.affect_data.policy_vigencia | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Aseguradora:</span><div><span>{{ vm.affect_data.aseguradora.compania }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Paquete:</span><div><span>{{vm.affect_data.paquete.package_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><span class=\"blue-color\">Creado por:</span><div><span>{{vm.affect_data.owner.first_name}} {{vm.affect_data.owner.last_name}}</span></div></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"showRecordatorios()\">{{vm.infoSiniestro.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div></div></fieldset><br><fieldset><legend class=\"legend-title\" align=\"center\">Beneficiarios</legend><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th class=\"text-align-left width-20p\">Nombre</th><th class=\"text-align-left width-20p\">Parentesco</th><th class=\"text-align-left width-20p\">Fecha de nacimiento</th><th class=\"text-align-left width-20p\">Procentaje</th><th ng-if=\"vm.infoSiniestro.status == 3\" class=\"text-align-left width-20p\">Impuesto</th><th ng-if=\"vm.infoSiniestro.status == 3\" class=\"text-align-left width-20p\">Procedente</th></tr></thead><tbody><tr ng-repeat=\"benficiarie in vm.beneficiaries\"><td class=\"text-align-left width-20p\">{{benficiarie.first_name}} {{benficiarie.last_name}} {{benficiarie.second_last_name}}</td><td class=\"text-align-left width-20p\">{{benficiarie.optional_relationship}}</td><td class=\"text-align-left width-20p\">{{benficiarie.birthdate | date:\"MM/dd/yyyy\": \'UTC\'}}</td><td class=\"text-align-left width-20p\">{{benficiarie.percentage}}%</td><td ng-if=\"vm.infoSiniestro.status == 3\" class=\"text-align-left width-20p\">${{benficiarie.isr}}</td><td ng-if=\"vm.infoSiniestro.status == 3\" class=\"text-align-left width-20p\">${{benficiarie.procedente}}</td></tr></tbody></table></div></div></div></fieldset><br><fieldset><legend class=\"legend-title\" align=\"center\">Coberturas</legend><div class=\"table-responsive\"><table class=\"table table-hover table-bordered\"><thead><tr><th class=\"text-align-center width-20p\">Cobertura</th><th class=\"text-align-center width-20p\">Suma Asegurada</th><th class=\"text-align-center width-20p\">Deducible</th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.selectedPoliza.data.coverageInPolicy_policy\"><td class=\"text-align-center width-20p\">{{coverage.coverage_name }}</td><td class=\"text-align-center width-20p\">{{coverage.sum_insured }}</td><td class=\"text-align-center width-20p\">{{coverage.deductible }}</td></tr></tbody></table></div></fieldset><br><fieldset ng-if=\"vm.afectados.nombre\"><legend align=\"center\">Dependiente Afectado</legend><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Nombre</th><th>Parentesco</th></tr></thead><tbody><tr><td><input class=\"form-control\" type=\"text\" ng-model=\"vm.afectados.nombre\" disabled=\"\"></td><td><select disabled=\"\" ng-model=\"vm.afectados.parentesco\" ng-options=\"item.id as item.label for item in vm.relationship\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></td></tr></tbody></table></fieldset><fieldset><legend align=\"center\">Información de Contacto</legend><div class=\"col-xs-12\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Nombre</th><th>Teléfono</th><th>Correo electrónico</th><th>Referencia</th></tr></thead><tbody><tr ng-repeat=\"contact in vm.contacts track by $index\"><td><input ng-disabled=\"contact.id\" class=\"form-control\" type=\"text\" ng-model=\"contact.first_name\"></td><td><phonenumber-directive disabledfield=\"contact.id\" placeholder=\"myPrompt\" model=\"contact.phone\"></phonenumber-directive></td><td><input ng-disabled=\"contact.id\" class=\"form-control\" type=\"email\" ng-model=\"contact.email\"></td><td><input ng-disabled=\"contact.id\" class=\"form-control\" type=\"text\" ng-model=\"contact.references\"></td></tr></tbody></table></div></fieldset><br><fieldset><div class=\"row\"><div class=\"col-md-12 form-group\"><label>Observaciones:</label> <textarea class=\"form-control\" ng-model=\"vm.siniester_data.observations\"></textarea></div></div></fieldset><br><div class=\"hr-line-dashed\"></div><div upload-template=\"\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\" ng-if=\"url !== \'/index/main\'\"></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-sm-12\"><div class=\"col-md-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"5\" idmodel=\"vm.siniestro_id\" exportable=\"true\"></comments></div></div></div></div></div><div class=\"row\" ng-if=\"url !== \'/index/main\'\"><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"!checkRegister && !newAfectado\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-disabled=\"!vm.user.permiso.editar; vm.infoSiniestro.status == 3\" ng-click=\"vm.saveEditInformation()\">Guardar cambios</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"newAfectado\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-click=\"saveEditInformation2(vm.infoSiniestro )\">Guardar cambios*</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div>");
$templateCache.put("app/siniestros/siniestro_base.html","<div class=\"row col-sm-2\"><label>Fecha de captura</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.dateNow\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" disabled=\"\"></div></div><div class=\"input-group date col-sm-2\"><label>Fecha promesa</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.dateNow\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\"></div></div><div class=\"col-sm-2\"><label>Folio Interno</label> <input class=\"form-control\"></div><div class=\"col-sm-2\"><label>Folio de Compañia</label> <input class=\"form-control\"></div><div class=\"col-sm-4\"><label>Estatus</label><select class=\"select form-control\" ng-model=\"vm.status.id\" ng-change=\"vm.updateSiniestroStatus(vm.status)\" ng-options=\"status.id as status.label for status in vm.statuses\"></select></div><div class=\"row col-sm-4\"><label>Afectado:</label><auto-complete selected-result=\"vm.poliza_number_data\" source=\"vm.insurances_number\"></auto-complete></div><div class=\"col-sm-3\"><label>Parentesco:</label> <input class=\"form-control\"></div><label>Fecha de nacimiento</label><div class=\"input-group date col-sm-3\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.dateNow\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\"></div><div class=\"col-sm-3\"><label>Contratante:</label> <input class=\"form-control\"></div><div class=\"col-sm-3\"><label>Numero de póliza:</label> <input class=\"form-control\"></div><div class=\"col-sm-3\"><label>Estatus de pago:</label> <input class=\"form-control\"></div><div class=\"col-sm-3\"><label>Domicilio:</label> <input class=\"form-control\"></div><div class=\"col-sm-3\"><label>Vigencia:</label> <input class=\"form-control\"></div><div class=\"col-sm-3\"><label>Aseguradora:</label> <input class=\"form-control\"></div><div class=\"col-sm-3\"><label>Plan / Paquete:</label> <input class=\"form-control\"></div><div class=\"col-sm-3\"><label>Contratante:</label> <input class=\"form-control\"></div><div class=\"row col-sm-12\"><label class=\"radio-inline\"><input type=\"radio\" id=\"isInitial\" name=\"isInitial\" value=\"Inicial\" checked=\"\" ng-click=\"vm.checkRadio()\"> Inicial</label> <label class=\"radio-inline\"><input type=\"radio\" id=\"isInitial\" name=\"isInitial\" value=\"Complemento\" ng-click=\"vm.checkRadio()\">Complemento</label></div><br><div class=\"col-sm-3\"><label>Numero de siniestro:</label> <input ng-if=\"vm.isInicial\" class=\"form-control\" ng-hide=\"!vm.isInicial\"><auto-complete ng-if=\"!vm.isInicial\" ng-hide=\"vm.isInicial\" selected-result=\"vm.poliza_number_data\" source=\"vm.insurances_number\"></auto-complete></div><div class=\"col-sm-3\"><label>Padecimiento:</label> <input class=\"form-control\"></div><label>Fecha en que ocurrió</label><div class=\"input-group date col-sm-3\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.dateNow\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\"></div><div class=\"row col-lg-10\"><label class=\"radio-inline\"><input type=\"radio\" id=\"siniestroType\" name=\"siniestroType\" value=\"Accidente\">Accidente</label> <label class=\"radio-inline\"><input type=\"radio\" id=\"siniestroType\" name=\"siniestroType\" value=\"Enfermedad\">Enfermedad</label> <label class=\"radio-inline\"><input type=\"radio\" id=\"siniestroType\" name=\"siniestroType\" value=\"Parto\">Parto</label></div><div class=\"row col-sm-12\"><label class=\"radio-inline\"><input type=\"radio\" id=\"payWay\" name=\"payWay\" value=\"reembolso\">Reembolso</label> <label class=\"radio-inline\"><input type=\"radio\" id=\"payWay\" name=\"payWay\" value=\"programacion\">Programación</label> <label class=\"radio-inline\"><input type=\"radio\" id=\"payWay\" name=\"payWay\" value=\"pagoDirecto\">Pago Directo</label></div><div class=\"ibox-content\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Facturas\"><div class=\"panel-body\"><div class=\"table-responsive\"><table datatable=\"ng\" class=\"table table-striped table-bordered table-hover\"><thead><tr><th>No. Factura</th><th>Proveedor</th><th>Fecha de factura</th><th>Importe</th><th>IVA</th><th>Total</th><th>Procedente</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.policy track by $index\"><td>No. Factura</td><td>Proveedor</td><td>Fecha de factura</td><td>Importe</td><td>IVA</td><td>Total</td><td>Procedente</td></tr></tbody></table></div></div></uib-tab></uib-tabset></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div upload-template=\"\"></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"form-group\"><button class=\"btn btn-success pull-right margin-right-10\" ng-click=\"vm.uploadFiles()\" id=\"uploadButton\" type=\"button\" ng-if=\"uploader.queue.length >= 1\">Subir archivos</button></div></div><div class=\"hr-line-dashed\"></div><div ng-include=\"\'templates/show-filesRecepits.html\'\"></div></div></div></div></div>");
$templateCache.put("app/siniestros/siniestro_cancel_modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Cancelar - Rechazar Siniestro</h4></div><div class=\"modal-body\"><label>Razón <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"cancelRazon\" required=\"true\"></textarea></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Guardar</button></div></div>");
$templateCache.put("app/siniestros/siniestro_completado_autos_modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Completar Siniestro</h4></div><div class=\"modal-body\"><div class=\"ibox float-e-margins\"><div class=\"row\"><div class=\"col-xs-12\"><label>Indemnización</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"imndemnizacion\" ng-change=\"validateImndemnizacion(imndemnizacion)\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"col-xs-12\"><label>Deducible</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"deducible\" ng-change=\"validateDeducible(deducible)\" class=\"form-control\" type=\"number\" required=\"\"></div></div><div class=\"col-xs-12\"><label>Coaseguro</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i></span> <input ng-model=\"coaseguro\" ng-change=\"validateCoaseguro(coaseguro)\" class=\"form-control\" type=\"number\" required=\"\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(imndemnizacion,deducible,coaseguro)\">Guardar</button></div></div>");
$templateCache.put("app/siniestros/siniestro_completado_modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Completar Siniestro</h4></div><div class=\"modal-body\"><label>Cantidad Reclamada:</label> <input class=\"form-control\" ng-model=\"final_reclamado\" format-as-currency=\"\" disabled=\"\" step=\"any\" type=\"text\"><br><label>Cantidad Procedente:</label> <input class=\"form-control\" ng-model=\"final_procedente\" format-as-currency=\"\" step=\"any\" type=\"text\"><br><label>Deducible <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"final_deducible\" step=\"any\" type=\"text\" required=\"true\"><br><label>Coaseguro <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"final_coaseguro\" step=\"any\" type=\"text\" required=\"true\"><br><label>Número de Complemento <span class=\"color-red\">*</span></label> <input class=\"form-control\" ng-model=\"final_complemento\" step=\"any\" type=\"text\" required=\"true\"><br></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancelar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"ok()\">Guardar</button></div></div>");
$templateCache.put("app/siniestros/siniestro_completado_modal_prog.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Completar Siniestro</h4></div><div class=\"modal-body\"><div><div class=\"col-md-6\"><h5 class=\"color-blue\">Hospital</h5><input class=\"form-control\" ng-model=\"hospital\" type=\"text\"></div><div class=\"col-md-6\"><h5 class=\"color-blue\">Fecha de cirugia</h5><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"fecha_cirugia\" value=\"{{fecha_cirugia}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div><div class=\"col-md-12\"><h5 class=\"color-blue\">Monto Autorizado (Hospital) <span class=\"color-red\">*</span></h5><input class=\"form-control\" ng-model=\"monto_hospital\" format-currency=\"\" type=\"text\"></div><div class=\"col-md-6\"><h5 class=\"color-blue\">Deducible <span class=\"color-red\">*</span></h5><input class=\"form-control\" ng-model=\"ded_hospital\" format-currency=\"\" type=\"text\"></div><div class=\"col-md-6\"><h5 class=\"color-blue\">Coaseguro <span class=\"color-red\">*</span></h5><input class=\"form-control\" ng-model=\"coas_hospital\" step=\"any\" type=\"text\"></div></div><div><div class=\"col-md-12 margin-top-24\"><h5 class=\"color-blue\">Monto Autorizado Honorarios Médicos:</h5><input class=\"form-control\" ng-model=\"monto_honorarios\" format-currency=\"\" type=\"text\"></div><div class=\"col-md-6\"><h5 class=\"color-blue\">Cirujano:</h5><input class=\"form-control\" ng-model=\"cirujano\" format-currency=\"\" type=\"text\"></div><br><div class=\"col-md-6\"><h5 class=\"color-blue\">Anestesiólogo:</h5><input class=\"form-control\" ng-model=\"anestesiologo\" format-currency=\"\" type=\"text\"></div><br><div class=\"col-md-6\"><h5 class=\"color-blue\">Ayudante:</h5><input class=\"form-control\" ng-model=\"ayudante\" format-currency=\"\" type=\"text\"></div><br><div class=\"col-md-6\"><h5 class=\"color-blue\">Otros:</h5><input class=\"form-control\" ng-model=\"otros\" format-currency=\"\" type=\"text\"></div><br><div class=\"col-md-6\"><h5 class=\"color-blue\">Deducible:</h5><input class=\"form-control\" ng-model=\"ded_honorarios\" format-currency=\"\" type=\"text\"></div><br><div class=\"col-md-6\"><h5 class=\"color-blue\">Coaseguro:</h5><input class=\"form-control\" ng-model=\"coas_honorarios\" step=\"any\" type=\"text\"></div><br><div class=\"col-md-6\"><h5 class=\"color-blue\">Número de complemento <span class=\"color-red\">*</span></h5><input class=\"form-control\" ng-model=\"complemento\" step=\"any\" type=\"text\" required=\"true\"></div><br><br></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white margin-top-24\" ng-click=\"cancel()\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary margin-top-24\" ng-click=\"ok()\">Guardar</button></div></div>");
$templateCache.put("app/siniestros/siniestro_completado_vida.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Completar Siniestro</h4></div><div class=\"modal-body\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th class=\"text-align-left width-20p\">Nombre</th><th class=\"text-align-left width-20p\">Parentesco</th><th class=\"text-align-left width-10p\">Porcentaje</th><th class=\"text-align-left width-5p\">Reclamado</th><th class=\"text-align-left width-10p\">Impuesto</th><th class=\"text-align-left width-10p\">Procedente</th></tr></thead><tbody><tr ng-repeat=\"benficiarie in beneficiaries track by $index\"><td class=\"text-align-left width-20p\">{{benficiarie.first_name}} {{benficiarie.last_name}} {{benficiarie.second_last_name}}</td><td class=\"text-align-center width-5p\">{{benficiarie.optional_relationship}}</td><td class=\"text-align-center width-5p\">{{benficiarie.percentage}}%</td><td tyclass=\"text-align-center width-10p\">${{benficiarie.percentage*(coverage.sum_insured/100)}}</td><td tyclass=\"text-align-center width-10p\"><input class=\"form-control\" type=\"number\" ng-model=\"benficiarie.isr\" ng-change=\"validateImpuesto($index, benficiarie.isr)\"></td><td tyclass=\"text-align-center width-10p\"><input class=\"form-control\" type=\"number\" ng-model=\"benficiarie.procedente\" ng-change=\"validateProcedente($index, benficiarie.isr)\"></td></tr></tbody></table></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Guardar</button></div></div>");
$templateCache.put("app/siniestros/siniestro_en_tramite_modal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Siniestro en Trámite</h4></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Folio del Siniestro</label> <input class=\"form-control\" ng-model=\"aux_folio\" step=\"any\" type=\"text\"></div><div class=\"col-xs-12 form-group\"><label ng-if=\"fc_visible == false\">Fecha Promesa</label> <label ng-if=\"fc_visible == true\">Fecha Compromiso</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"aux_fecha_promesa\" format=\"MM/dd/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" required=\"true\" id=\"date\" placeholder=\"MM/dd/yyy\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Guardar</button></div>");
$templateCache.put("app/siniestros/siniestros.accidentes.html","<div class=\"row wrapper border-bottom white-bg page-heading\" ng-if=\"url !== \'/index/main\'\"><div class=\"col-lg-9\"><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Siniestros - Accidentes y enfermedades</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Accidentes y enfermedades - Crear siniestro</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6 form-group\"><label>Afectado: <span class=\"color-red\">*</span></label><autocomplete datasource=\"vm.affected\" id=\"autocomplete\" model=\"vm.selected_affect\" change=\"vm.updateStatus(vm.selected_affect.val)\"></autocomplete></div><div class=\"col-md-2 form-group\"><label></label> <button type=\"button\" ng-click=\"vm.LookFor()\" class=\"btn btn-block btn-success mt4\">Buscar</button></div></div><fieldset><legend align=\"right\">Información general</legend><form name=\"infoGral\"><div class=\"row\"><div ng-if=\"vm.show_caratula_afectado\" class=\"col-md-6 form-group\"><label>Afectado (Siniestro a carátula) <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"siniester_number\" ng-model=\"vm.siniester_data.aux_affected\" required=\"true\"></div><div class=\"col-xs-12 col-sm-4 col-md-6 form-group\" ng-if=\"vm.show_caratula_afectado\"><label for=\"parentesco{{0}}\">Parentesco <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-init=\"vm.siniester_data.aux_affected_parent = 1\" ng-options=\"type.value as type.label for type in vm.relationship\" ng-change=\"renewalSelection()\" name=\"renewal\" ng-model=\"vm.siniester_data.aux_affected_parent\" required=\"\"><option value=\"\" disabled=\"\">Selecciona</option></select></div></div><div class=\"row\"><div class=\"col-md-3 form-group\"><label>Fecha de emisión</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.dateNow_emision\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" value=\"vm.fecha_ingreso\"></div></div><div class=\"col-md-3 form-group\"><label>Fecha de captura</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.dateNow\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div ng-disabled=\"vm.user.permiso.editar\" class=\"col-md-3 form-group\"><label>Estatus</label><select class=\"select form-control\" ng-model=\"vm.status.id\" ng-change=\"vm.updateSiniestroStatus(vm.status)\" ng-options=\"status.id as status.label for status in vm.statuses\"></select></div><div class=\"col-md-3 form-group\"><label>Parentesco:</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.affect_data.title\"></div><div class=\"col-md-3 form-group\"><label>Fecha de nacimiento:</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Contratante:<span class=\"color-red\">*</span></label> <input disabled=\"\" ng-model=\"vm.affect_data.contratante.name\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Número de póliza:</label> <input disabled=\"\" ng-model=\"vm.affect_data.policy_number\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Subramo</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.siniester_data.subramo.subramo_name\"></div><div class=\"col-md-3 form-group\"><label>Estatus de pago:</label> <input disabled=\"\" ng-model=\"vm.affect_data.policy_status.label\" class=\"form-control\"></div><div class=\"col-md-6 form-group\"><label>Domicilio:</label> <input disabled=\"\" ng-model=\"vm.affect_data.contractor_addres\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Inicio de Vigencia:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.policy_vigencia_init\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Fin de Vigencia:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.policy_vigencia\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-5 form-group\" ng-class=\"{ \'has-error\': infoGral.aseguradora.$invalid && !infoGral.aseguradora.$pristine }\"><label>Aseguradora:<span class=\"color-red\">*</span></label> <input disabled=\"\" name=\"aseguradora\" ng-model=\"vm.affect_data.aseguradora.compania\" class=\"form-control\"></div><div class=\"col-md-4 form-group\"><label>Plan / Paquete:</label> <input disabled=\"\" ng-model=\"vm.affect_data.paquete.package_name\" class=\"form-control\"></div></div></form></fieldset><br><fieldset><legend align=\"right\">Información del Siniestro</legend><form name=\"infoSiniestroForm\"><div class=\"row\"><div class=\"btn-group col-md-3 form-group\" role=\"group\" aria-label=\"...\"><button id=\"btn-inicial\" type=\"button\" ng-click=\"vm.checkRadio(\'Inicial\')\" class=\"btn btn-default btn-iniComp\">Inicial</button> <button id=\"btn-complemento\" type=\"button\" ng-click=\"vm.checkRadio(\'Complemento\')\" class=\"btn btn-default\">Complemento</button></div><div class=\"col-md-3 form-group\" ng-class=\"{ \'has-error\': infoSiniestroForm.numero_de_siniestro.$invalid && !infoSiniestroForm.numero_de_siniestro.$pristine }\"><label>Número de siniestro:<span class=\"color-red\">*</span></label> <input ng-if=\"vm.isInicial || vm.carga_siniestro\" class=\"form-control\" ng-model=\"vm.siniester_data.siniester_number.label\" name=\"numero_de_siniestro\" required=\"true\" ng-cahnge=\"numberSelected(vm.siniester_data)\"><div class=\"input-group\" ng-if=\"!vm.isInicial && !vm.carga_siniestro\"><autocomplete datasource=\"siniestros_data\" id=\"siniestros\" model=\"vm.siniester_data.siniester_number\" change=\"BuscarIniciales(vm.siniester_data.siniester_number)\"></autocomplete></div></div><div class=\"col-md-3 form-group\"><label>Fecha en que ocurrió</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.siniester_date\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div></div><div class=\"row\"><div class=\"col-md-1 form-group\"></div><div class=\"col-md-2 form-group\"></div><div class=\"col-md-9 form-group\" ng-class=\"{ \'has-error\': infoSiniestroForm.disease.$invalid && !infoSiniestroForm.disease.$pristine }\"><label>Padecimiento:<span class=\"color-red\">*</span></label><autocomplete id=\"padecimiento\" datasource=\"enfermedades\" name=\"disease\" model=\"vm.selected_disease\" change=\"vm.buscaPadecimientos(vm.selected_disease)\" required=\"true\"></autocomplete></div></div><div class=\"row\"><div class=\"col-md-1 form-group\"></div><div class=\"col-md-2 form-group\"></div><div class=\"col-md-9 form-group\"><label>Observaciones:</label> <textarea class=\"form-control\" name=\"observations\" ng-model=\"vm.siniester_data.observations\">\n                                    </textarea></div></div><div class=\"row\"><div class=\"col-md-1 form-group\"></div><div class=\"col-md-2 form-group\"></div><div class=\"col-md-4 form-group\" ng-class=\"{ \'has-error\': infoSiniestroForm.siniestroType.$invalid && !infoSiniestroForm.siniestroType.$pristine }\"><label>Tipo de sinestro <span class=\"color-red\">*</span></label><select name=\"siniestroType\" id=\"siniestroType\" class=\"select form-control\" required=\"true\"><option value=\"0\">Seleccionar una opción</option><option value=\"1\">Accidente</option><option value=\"2\">Enfermedad</option><option value=\"3\">Parto</option></select></div><div class=\"col-md-4 form-group\"><label>Forma de pago <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': infoSiniestroForm.payWay.$invalid && !infoSiniestroForm.payWay.$pristine }\"><select name=\"payWay\" id=\"payWay\" class=\"select form-control\" required=\"true\"><option value=\"0\">Seleccione una opción</option><option value=\"1\">Reembolso</option><option value=\"2\">Programación</option><option value=\"3\">Pago Directo</option><option value=\"4\">Aclaración</option></select></div></div></div></form></fieldset><br><fieldset><legend align=\"right\">Facturas a reembolsar</legend><div class=\"tabs-container\"><uib-tabset active=\"active\"><uib-tab heading=\"Facturas\"><div class=\"panel-body\" id=\"exportable\"><table class=\"table table-hover\"><thead><tr><th width=\"10%\">Serie</th><th width=\"10%\">No. Factura</th><th>Concepto</th><th>Proveedor</th><th>Fecha de factura</th><th width=\"10%\">Importe</th><th width=\"10%\">IVA</th><th width=\"10%\">Total</th><th width=\"10%\">Procedente</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"factura in vm.facturas track by $index\"><td ng-init=\"factura.serie = $index+1\"><input class=\"form-control\" type=\"text\" ng-model=\"factura.serie\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.f_number\"></td><td><select ng-model=\"factura.concepto\" ng-options=\"item.value as item.name for item in vm.facturas_conceptos\" class=\"form-control\"><option value=\"\">Selecciona una opción</option></select></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.proovedor\"></td><td class=\"position-date\"><input class=\"form-control\" date-time=\"\" ng-model=\"factura.f_date\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></td><td><input class=\"form-control\" type=\"number\" step=\"0.01\" ng-model=\"factura.import\" ng-change=\"calculateIva($index, factura.import)\" ng-blur=\"calculateTotales()\"></td><td><input class=\"form-control\" type=\"number\" step=\"0.01\" ng-model=\"factura.iva\" ng-change=\"calculateTotal($index, factura.iva)\" ng-blur=\"calculateTotales()\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.total\" disabled=\"\"></td><td><input class=\"form-control\" type=\"text\" ng-if=\"vm.status.id ==\'3\'\" ng-model=\"factura.procedente\"></td><td><button type=\"button\" class=\"btn btn-sm btn-danger\" name=\"button\" ng-click=\"vm.deleteFactura(factura.url,$index)\"><span class=\"fa fa-trash-o fa-lg\"></span></button></td></tr><tr ng-repeat=\"factura in vm.facturas track by $index\" ng-show=\"false\"><td>{{factura.serie}}</td><td>{{factura.f_number}}</td><td>{{factura.concepto}}</td><td>{{factura.proovedor}}</td><td class=\"position-date\">{{factura.f_date}}</td><td>{{factura.import}}</td><td>{{factura.iva}}</td><td>{{factura.total}}</td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td ng-if=\"vm.facturas.length\"><input class=\"form-control\" type=\"number\" step=\"0.01\" name=\"\" disabled=\"\" ng-model=\"vm.totalImporte\"></td><td ng-if=\"vm.facturas.length\"><input class=\"form-control\" type=\"number\" step=\"0.01\" name=\"\" disabled=\"\" ng-model=\"vm.totalIva\"></td><td></td><td></td><td></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-12 form-group\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addFactura()\" type=\"button\">Agregar factura</button> <button class=\"btn btn-primary\" ng-click=\"vm.downloadFacturas()\">Descargar facturas</button></div></div></div></uib-tab></uib-tabset></div></fieldset><br><br><br><fieldset><legend align=\"right\">Información de Contacto</legend><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover table footable table-stripped\" data-page-size=\"25\"><thead><tr><th class=\"footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Nombre</th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\">Teléfono <span class=\"color-red\">*</span></th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\" \"=\"\">Correo electrónico</th><th data-hide=\"phone\" class=\"footable-sortable\">Referencia</th><th data-hide=\"phone\" class=\"footable-sortable\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"contact in vm.contacts track by $index\" foo-repeat-done=\"\"><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.first_name\"></td><td><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone\" required=\"\"></phonenumber-directive></td><td><input class=\"form-control\" type=\"email\" ng-model=\"contact.email\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.references\"></td><td><button type=\"button\" class=\"btn btn-w-m btn-danger\" name=\"button\" ng-click=\"vm.deleteContacts(contact.url,$index)\">Eliminar</button></td></tr></tbody></table></div><div class=\"col-sm-12\" ng-if=\"count_contact == true\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button></div></fieldset><div class=\"hr-line-dashed\"></div><div upload-template=\"\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\" ng-if=\"url !== \'/index/main\'\"></div><div class=\"row\"><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary\" type=\"button\" ng-disabled=\"!vm.user.permiso.crear\" ng-click=\"vm.saveSiniester()\">Guardar siniestro</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/siniestros/siniestros.autos.html","<div class=\"row wrapper border-bottom white-bg page-heading\" ng-if=\"url !== \'/index/main\'\"><div class=\"col-lg-9\"><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Siniestros - Automóviles</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Automóviles - Crear siniestro</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6 form-group\" ng-if=\"!myInsurance.url && !ok_afectted.label\"><label>Afectado: <span class=\"color-red\">*</span> (Póliza, Contratante o Serie)</label><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"cadena_a_buscar\" ng-change=\"vm.cadenaBusq(cadena_a_buscar)\"></div><div class=\"col-md-2 form-group\"><label></label></div></div><div class=\"col-md-6 form-group\" ng-if=\"ok_afectted.label\" align=\"center\"><label class=\"blue-color\" for=\"\">Afectado:</label><p align=\"center\">{{ok_afectted.label}}</p></div><div class=\"col-md-2 form-group\" ng-if=\"!myInsurance.url && !ok_afectted.label\"><label></label> <button type=\"button\" ng-click=\"vm.updateStatus(cadena_a_buscar)\" class=\"btn btn-block btn-success mt5\" title=\"Debe completar los datos que contengan *\">Buscar</button></div></div><div ng-if=\"cadena_a_buscar && habuscado && vm.affected.length==0\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><div ng-if=\"vm.affected.length>0\" class=\"col-xs-12 form-group\"><select class=\"select form-control\" ng-model=\"vm.selected_affect\" ng-options=\"affected as affected.label ? affected.label : affected.val for affected in vm.affected\" ng-change=\"vm.LookFor(vm.selected_affect); vm.saveLocalstorange()\"><option value=\"\" disabled=\"\">Seleccione un afectado</option></select></div><div ng-if=\"vm.show_caratula_afectado\" class=\"col-md-6 form-group\"><label>Afectado (Siniestro a carátula) <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"siniester_number\" ng-model=\"vm.siniester_data.aux_affected\" ng-change=\"vm.saveLocalstorange()\" required=\"true\"></div><div class=\"row\"><form name=\"autoSiniestroForm\"><div class=\"col-md-3 form-group\"><label>Fecha de emisión <span class=\"color-red\">*</span></label><div class=\"input-group date\" ng-class=\"{ \'has-error\': vidaSiniestroForm.date_ingreso.$invalid && !vidaSiniestroForm.date_ingreso.$pristine }\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.fecha_ingreso\" name=\"date_ingreso\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-blur=\"vm.saveLocalstorange()\" required=\"\"></div></div><div class=\"col-md-3 form-group\"><label>Número de siniestro</label><div ng-class=\"{ \'has-error\': autoSiniestroForm.siniester_number.$invalid && !autoSiniestroForm.siniester_number.$pristine }\"><input class=\"form-control\" name=\"siniester_number\" ng-model=\"vm.siniester_data.siniester_number\" ng-change=\"vm.saveLocalstorange()\"></div></div><div class=\"col-md-3 form-group\"><label>Fecha en que ocurrió <span class=\"color-red\">*</span></label><div class=\"input-group date\" ng-class=\"{ \'has-error\': autoSiniestroForm.siniester_date.$invalid && !autoSiniestroForm.siniester_date.$pristine }\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.siniester_date\" ng-blur=\"vm.saveLocalstorange()\" name=\"siniester_date\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" required=\"\"></div></div><div class=\"col-md-3 form-group\" ng-class=\"{ \'has-error\': autoSiniestroForm.siniestroType.$invalid && !autoSiniestroForm.siniestroType.$pristine }\"><label>Tipo de siniestro <span class=\"color-red\">*</span></label><select name=\"siniestroType\" ng-model=\"vm.siniester_type\" id=\"siniestroType\" class=\"select form-control\" ng-change=\"vm.saveLocalstorange()\" ng-options=\"siniester_tipo.id as siniester_tipo.label for siniester_tipo in vm.siniestros_type\" required=\"\"></select></div><div ng-if=\"vm.siniester_type == 1 || vm.siniester_type == 5 || vm.siniester_type == 6\" class=\"col-md-3 form-group\" ng-class=\"{ \'has-error\': autoSiniestroForm.siniester_data.$invalid && !autoSiniestroForm.siniester_data.$pristine }\"><label ng-if=\"vm.siniester_type == 1\">¿Contra qué? <span class=\"color-red\">*</span></label> <label ng-if=\"vm.siniester_type == 5\">¿Qué se llevaron? <span class=\"color-red\">*</span></label> <label ng-if=\"vm.siniester_type == 6\">¿Cúal? <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"siniester_data\" ng-model=\"vm.siniester_data.tercero\" required=\"\"></div><div class=\"col-md-12 form-group\" ng-class=\"{ \'has-error\': autoSiniestroForm.explicacion.$invalid && !autoSiniestroForm.explicacion.$pristine }\"><label>¿Cómo ocurrió? <span class=\"color-red\">*</span></label> <input type=\"textarea\" class=\"form-control\" name=\"explicacion\" ng-model=\"vm.siniester_data.explicacion\" ng-change=\"vm.saveLocalstorange()\" required=\"\"></div></form></div><br><fieldset><legend align=\"right\">Información general</legend><div class=\"row\"><div class=\"col-md-3 form-group\"><label>Fecha de captura</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.dateNow\" ng-change=\"vm.saveLocalstorange()\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" disabled=\"\"></div></div><div class=\"col-md-3 form-group\"><label>Estatus del siniestro</label><select class=\"select form-control\" ng-model=\"vm.status.id\" ng-change=\"vm.saveLocalstorange()\" ng-options=\"status.id as status.label for status in vm.statuses\"></select></div><div class=\"col-md-3 form-group\"><label>Contratante:</label> <input disabled=\"\" ng-model=\"vm.affect_data.contratante.name\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Número de póliza:</label> <input disabled=\"\" ng-model=\"vm.affect_data.policy_number\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Subramo</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.siniester_data.subramo.subramo_name\"></div><div class=\"col-md-3 form-group\"><label>Estatus de pago:</label> <input disabled=\"\" ng-model=\"vm.affect_data.policy_status.label\" class=\"form-control\"></div><div class=\"col-md-6 form-group\"><label>Domicilio:</label> <input disabled=\"\" ng-model=\"vm.affect_data.contractor_addres\" class=\"form-control\"></div><div class=\"col-md-3 form-group\" ng-if=\"vm.status.id == 2\"><label>Folio:</label> <input ng-model=\"vm.folio_compania\" ng-change=\"vm.saveLocalstorange()\" class=\"form-control\"></div><div class=\"col-md-3 form-group\" ng-if=\"vm.status.id == 2\"><label>Fecha compromiso:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.promise_date\" ng-blur=\"vm.saveLocalstorange()\" format=\"dd/MM/yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Inicio de Vigencia:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.policy_vigencia_init\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Fin de Vigencia:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.policy_vigencia\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Aseguradora:</label> <input disabled=\"\" ng-model=\"vm.affect_data.aseguradora.compania\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Plan / Paquete:</label> <input disabled=\"\" ng-model=\"vm.affect_data.paquete.package_name\" class=\"form-control\"></div><div class=\"col-md-12 form-group\"><label>Nombre del Conductor</label> <input type=\"textarea\" class=\"form-control\" name=\"conductor\" ng-model=\"vm.siniester_data.conductor\" ng-change=\"vm.saveLocalstorange()\"></div></div></fieldset><br><fieldset><legend align=\"right\">Información de contacto</legend><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover table table-stripped\" data-page-size=\"25\"><thead><tr><th class=\"\" data-breakpoints=\"xs\">Nombre <span class=\"color-red\">*</span></th><th class=\"\" data-hide=\"phone\">Teléfono</th><th class=\"\" data-hide=\"phone\">Correo electrónico</th><th data-hide=\"phone\" class=\"\">Referencia</th><th data-hide=\"phone\" class=\"\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"contact in vm.contacts track by $index\"><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.first_name\" required=\"\"></td><td><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone\"></phonenumber-directive></td><td><input class=\"form-control\" type=\"email\" ng-model=\"contact.email\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.references\"></td><td><button type=\"button\" class=\"btn btn-w-m btn-danger\" name=\"button\" ng-click=\"vm.deleteContacts(contact.url,$index)\">Eliminar</button></td></tr></tbody></table></div><div class=\"col-sm-12\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button></div></fieldset><fieldset><div class=\"row\"><div class=\"col-md-12 form-group\"><label>Observaciones:</label> <textarea class=\"form-control\" ng-model=\"vm.siniester_data.observations\" ng-change=\"vm.saveLocalstorange()\">\n                                </textarea></div></div><div class=\"row\"></div></fieldset><br><div class=\"hr-line-dashed\"></div><div upload-template=\"\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\" ng-if=\"url !== \'/index/main\'\"></div><div class=\"row\" ng-if=\"url !== \'/index/main\'\"><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"vm.saveSiniester()\" title=\"Los campos con con * son obligatorios\">Guardar siniestro</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/siniestros/siniestros.damage.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Siniestros - Daños</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Daños - Lista de siniestros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Pendientes\"><div class=\"panel-body\"><div class=\"table-responsive\"><table datatable=\"ng\" class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Subramo</th><th>Numero de siniestro</th><th>Tipo de siniestro</th><th>Afectado</th><th>Contratante</th><th>Aseguradora</th><th>Procedente</th></tr></thead><tbody><tr ng-repeat=\"insurance in vm.policy track by $index\" ui-sref=\"polizas.info({polizaId: insurance.id})\" ng-if=\"insurance.status != 11\"></tr></tbody></table></div></div></uib-tab></uib-tabset></div></div></div></div></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Daños - Crear siniestro</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><select class=\"select form-control m-b\" ng-model=\"subramo_select.id\" ng-change=\"vm.updateStatus(subramo_select)\" ng-options=\"element.id as element.subramo for element in vm.sub_ramos | filter:element.ramo = \'Daños\'\"></select></div></div></div></div></div></div>");
$templateCache.put("app/siniestros/siniestros.danios.html","<div class=\"row wrapper border-bottom white-bg page-heading\" ng-if=\"url !== \'/index/main\'\"><div class=\"col-lg-9\"><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Siniestros - Daños</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Daños - Crear siniestro</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6 form-group\" ng-if=\"danios_affected==false\"><label>Número de Póliza o Contratante: <span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"cadena_a_buscar\" ng-change=\"vm.cadenaBusq(cadena_a_buscar)\"></div></div><div class=\"col-md-2 form-group\" ng-if=\"danios_affected==false\"><label></label> <button type=\"button\" ng-click=\"vm.updateStatus(cadena_a_buscar)\" class=\"btn btn-block btn-success mt5\" title=\"Debe completar los datos que contengan *\">Buscar</button></div><div class=\"col-md-2 form-group\"><label></label></div><div ng-if=\"cadena_a_buscar && habuscado && vm.affected.length==0\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div><div ng-if=\"vm.affected.length>0 && danios_affected==false\" class=\"col-xs-12 form-group\"><select class=\"select form-control\" ng-model=\"vm.selected_affect\" ng-options=\"affected as affected.label ? affected.label : affected.val for affected in vm.affected\" ng-change=\"vm.LookFor(vm.selected_affect); vm.saveLocalstorange()\"><option value=\"\" disabled=\"\">Seleccione un afectado</option></select></div><div ng-if=\"vm.show_affected\" class=\"col-md-6 form-group\"><label>Bien asegurado <span class=\"color-red\">*</span></label> <input ng-class=\"{ \'has-error\': danioSiniestroForm.bien_asegurado.$invalid && !danioSiniestroForm.bien_asegurado.$pristine }\" class=\"form-control\" name=\"siniester_number\" ng-model=\"vm.siniester_data.aux_affected\" ng-change=\"saveLocalstorange()\" required=\"true\"></div><br><br></div><br><div class=\"row\"><form name=\"danioSiniestroForm\"><div class=\"col-md-3 form-group\"><label>Fecha de emisión <span class=\"color-red\">*</span></label><div class=\"input-group date\" ng-class=\"{ \'has-error\': danioSiniestroForm.date_ingreso.$invalid && !danioSiniestroForm.date_ingreso.$pristine }\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.fecha_ingreso\" name=\"date_ingreso\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" required=\"\"></div></div><div class=\"col-md-3 form-group\"><label>Número de siniestro</label><div ng-class=\"{ \'has-error\': danioSiniestroForm.siniester_number.$invalid && !danioSiniestroForm.siniester_number.$pristine }\"><input class=\"form-control\" name=\"siniester_number\" ng-model=\"vm.siniester_data.siniester_number\"></div></div><div class=\"col-md-3 form-group\"><label>Estimación pérdida <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': danioSiniestroForm.estimacion.$invalid && !danioSiniestroForm.estimacion.$pristine }\"><input class=\"form-control\" name=\"estimacion\" ng-model=\"vm.siniester_data.estimacion_perdida\" ng-change=\"saveLocalstorange()\" required=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Causa reclamación <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': danioSiniestroForm.causa.$invalid && !danioSiniestroForm.causa.$pristine }\"><input class=\"form-control\" name=\"causa\" ng-model=\"vm.siniester_data.causa_reclamacion\" ng-change=\"saveLocalstorange()\" required=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Moneda</label><select class=\"form-control\" ng-change=\"change_pesos(); saveLocalstorange();\" ng-model=\"vm.siniester_data.currency\"><option value=\"\">Selecciona una opción</option><option value=\"1\">Pesos</option><option value=\"2\">Dólares</option></select></div><div class=\"col-md-3 form-group\"><label>Tipo de cambio</label><select class=\"form-control\" ng-change=\"change_pesos(); saveLocalstorange();\" ng-model=\"vm.siniester_data.tipo_de_cambio\"><option value=\"1\">Pesos</option><option value=\"2\">Dólares</option></select></div><div class=\"col-md-3 form-group\" ng-if=\"vm.coverages.length == 0\"><label>Cobertura afectada <span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': danioSiniestroForm.cobertura.$invalid && !danioSiniestroForm.cobertura.$pristine }\"><input class=\"form-control\" name=\"cobertura\" ng-model=\"vm.cobertura_afectada\" ng-change=\"saveLocalstorange()\"></div></div><div class=\"col-md-3 form-group\" ng-if=\"vm.coverages.length > 0\"><label>Cobertura afectada<span class=\"color-red\">*</span></label><select name=\"cov_affected\" ng-model=\"vm.cobertura_afectada\" id=\"cov_affected\" class=\"select form-control\" ng-change=\"saveLocalstorange()\" ng-options=\"cov_affected.coverage_name as cov_affected.coverage_name for cov_affected in vm.coverages\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una cobertura</option></select></div><div class=\"col-md-3 form-group\"><label>Fecha Siniestro <span class=\"color-red\">*</span></label><div class=\"input-group date\" ng-class=\"{ \'has-error\': danioSiniestroForm.siniester_date.$invalid && !danioSiniestroForm.siniester_date.$pristine }\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.siniester_date\" ng-blur=\"saveLocalstorange()\" name=\"siniester_date\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" required=\"\"></div></div></form></div><br><fieldset><legend align=\"right\">Información general</legend><div class=\"row\"><div class=\"col-md-3 form-group\"><label>Fecha de captura</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.dateNow\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" disabled=\"\"></div></div><div class=\"col-md-3 form-group\"><label>Estatus del siniestro</label><select class=\"select form-control\" ng-model=\"vm.status.id\" ng-change=\"vm.updateSiniestroStatus(vm.status)\" ng-options=\"status.id as status.label for status in vm.statuses\"></select></div><div class=\"col-md-3 form-group\"><label>Contratante:</label> <input disabled=\"\" ng-model=\"vm.affect_data.contratante.name\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Número de póliza:</label> <input disabled=\"\" ng-model=\"vm.affect_data.policy_number\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Subramo</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.siniester_data.subramo.subramo_name\"></div><div class=\"col-md-3 form-group\"><label>Estatus de pago:</label> <input disabled=\"\" ng-model=\"vm.affect_data.policy_status.label\" class=\"form-control\"></div><div class=\"col-md-5 form-group\"><label>Domicilio:</label> <input disabled=\"\" ng-model=\"vm.affect_data.contractor_addres\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Inicio de Vigencia:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.policy_vigencia_init\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Fin de Vigencia:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.policy_vigencia\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Aseguradora:</label> <input disabled=\"\" ng-model=\"vm.affect_data.aseguradora.compania\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Plan / Paquete:</label> <input disabled=\"\" ng-model=\"vm.affect_data.paquete.package_name\" class=\"form-control\"></div></div></fieldset><br><fieldset><legend align=\"right\">Información de contacto</legend><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover table footable table-stripped\" data-page-size=\"25\"><thead><tr><th class=\"footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Nombre <span class=\"color-red\">*</span></th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\">Teléfono</th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\" \"=\"\">Correo electrónico</th><th data-hide=\"phone\" class=\"footable-sortable\">Referencia</th><th data-hide=\"phone\" class=\"footable-sortable\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"contact in vm.contacts track by $index\" foo-repeat-done=\"\"><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.first_name\" required=\"\"></td><td><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone\"></phonenumber-directive></td><td><input class=\"form-control\" type=\"email\" ng-model=\"contact.email\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.references\"></td><td><button type=\"button\" class=\"btn btn-w-m btn-danger\" name=\"button\" ng-click=\"vm.deleteContacts(contact.url,$index)\">Eliminar</button></td></tr></tbody></table></div><div class=\"col-sm-12\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addContact()\" type=\"button\">Agregar contacto</button></div></fieldset><br><fieldset><legend align=\"right\">Facturas a reembolsar</legend><div class=\"tabs-container\"><uib-tabset active=\"active\"><uib-tab heading=\"Facturas\"><div class=\"panel-body\" id=\"exportable\"><table class=\"table table-hover\"><thead><tr><th width=\"10%\">Serie</th><th width=\"10%\">No. Factura</th><th>Proveedor</th><th>Fecha de factura</th><th width=\"10%\">Importe</th><th width=\"10%\">IVA</th><th width=\"10%\">Total</th><th width=\"10%\">Procedente</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"factura in vm.facturas track by $index\"><td ng-init=\"factura.serie = $index+1\"><input class=\"form-control\" type=\"text\" ng-model=\"factura.serie\" ng-change=\"saveLocalstorange()\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.f_number\" ng-change=\"saveLocalstorange()\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.proovedor\" ng-change=\"saveLocalstorange()\"></td><td class=\"position-date\"><input class=\"form-control\" date-time=\"\" ng-model=\"factura.f_date\" ng-change=\"saveLocalstorange()\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></td><td><input class=\"form-control\" format-as-currency=\"\" step=\"0.01\" ng-model=\"factura.import\" ng-change=\"calculateIva($index, factura.import);saveLocalstorange()\" ng-blur=\"calculateTotales()\"></td><td><input class=\"form-control\" format-as-currency=\"\" step=\"0.01\" ng-model=\"factura.iva\" ng-change=\"calculateTotal($index, factura.iva);saveLocalstorange()\" ng-blur=\"calculateTotales()\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"factura.total\" ng-change=\"saveLocalstorange()\" disabled=\"\"></td><td><input class=\"form-control\" type=\"text\" ng-if=\"vm.status.id ==\'3\'\" ng-model=\"factura.procedente\" ng-change=\"saveLocalstorange()\"></td><td><button type=\"button\" class=\"btn btn-sm btn-danger\" name=\"button\" ng-click=\"vm.deleteFactura(factura.url,$index)\"><span class=\"fa fa-trash-o fa-lg\"></span></button></td></tr><tr ng-repeat=\"factura in vm.facturas track by $index\" ng-show=\"false\"><td>{{factura.serie}}</td><td>{{factura.f_number}}</td><td>{{factura.proovedor}}</td><td class=\"position-date\">{{factura.f_date}}</td><td>{{factura.import}}</td><td>{{factura.iva}}</td><td>{{factura.total}}</td><td>{{factura.procedente}}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td ng-if=\"vm.facturas.length\"><input class=\"form-control\" type=\"number\" step=\"0.01\" name=\"\" disabled=\"\" ng-model=\"vm.totalImporte\"></td><td ng-if=\"vm.facturas.length\"><input class=\"form-control\" type=\"number\" step=\"0.01\" name=\"\" disabled=\"\" ng-model=\"vm.totalIva\"></td><td ng-if=\"vm.facturas.length\"><input class=\"form-control\" type=\"number\" step=\"0.01\" name=\"\" disabled=\"\" ng-model=\"vm.totalTotal\"></td><td></td><td></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-12 form-group\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addFactura();saveLocalstorange()\" type=\"button\">Agregar factura</button> <button class=\"btn btn-primary\" ng-click=\"vm.downloadFacturas();saveLocalstorange()\" ng-if=\"existenFacturas\">Descargar facturas</button></div></div></div></uib-tab></uib-tabset></div></fieldset><br><fieldset><div class=\"row\"><div class=\"col-md-12 form-group\"><label>Descripción:</label> <textarea class=\"form-control\" ng-model=\"vm.siniester_data.observations\" ng-change=\"saveLocalstorange()\">\n                                </textarea></div></div><div class=\"row\"></div></fieldset><br><div class=\"hr-line-dashed\"></div><div upload-template=\"\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\" ng-if=\"url !== \'/index/main\'\"></div><div class=\"row\" ng-if=\"url !== \'/index/main\'\"><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" title=\"Los campos con con * son obligatorios\" ng-click=\"vm.saveSiniester()\">Guardar siniestro</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/siniestros/siniestros.deleteFactura.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Eliminar</h4></div><div class=\"modal-body\"><p></p><h1>¿Está seguro que desea eliminar este contacto?</h1><br\\>El contacto se eliminará aunque no guarde los cambios<p></p></br\\></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">No</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Sí</button></div></div>");
$templateCache.put("app/siniestros/siniestros.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ vm.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Siniestros</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Siniestros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div ng-repeat=\"ramo in vm.ramos\"><div class=\"clearfix\" ng-if=\"$index % 3 == 0\"></div><div class=\"col-sm-4\"><div class=\"ibox-content btn btn-block btn-outline btn-success\"><h2 class=\"text-center\" id=\"{{ramo.ramo_code}}\" ng-click=\"vm.showSubRamos($event)\">{{ramo.ramo_name}}</h2></div></div></div></div><hr><div class=\"row\"><div ng-repeat=\"ramo in vm.ramos\"><div ng-repeat=\"subramo in ramo.subramo_ramo\"><div class=\"clearfix\" ng-if=\"($index + $parent.$index) % 3 == 0\"></div><div class=\"col-sm-4\" ng-click=\"vm.regSinModal()\" id=\"{{subramo.subramo_code}}\"><div class=\"ibox-content btn btn-block btn-outline btn-info\"><h2 class=\"text-center\">{{subramo.subramo_name}}</h2></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/siniestros/siniestros.plantillas.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Siniestros</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Plantillas de Siniestros</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-4 pull-right\"><button class=\"col-xs-12 btn btn-info btn-sm pull-right m-t\" ng-click=\"createQuotation()\">Agregar Plantilla <i class=\"fa fa-plus-square-o\"></i></button></div><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"></div><div class=\"row\"><div class=\"col-xs-12\" ng-show=\"showQuotation\" style=\"margin-left: 25px;padding-right: 75px;\"><legend ng-if=\"!showEditInformation\" class=\"legend-title\" align=\"center\">Nueva Plantilla</legend><legend ng-if=\"showEditInformation\" class=\"legend-title\" align=\"center\">Actualizar Plantilla</legend><form class=\"row\" name=\"form\"><div class=\"col-xs-12 col-sm-5 form-group\"><label>Nombre de la Plantilla <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"plantilla.name\" name=\"plantillaName\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Ramo(s) <span class=\"color-red\">*</span></label><select id=\"ramoSelect\" class=\"js-example-basic-multiple col-xs-12 form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"plantilla.ramo_code\" data-ng-options=\"codes.descr ? codes.descr : codes.code for codes in allRamos | orderBy: \'descr\' track by codes.code\" ng-change=\"selectProv(select_code)\" required=\"\" ng-required=\"true\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-2 form-group\"><label for=\"defaultsubject\"><input id=\"plantilla.subject_default\" type=\"checkbox\" ng-model=\"plantilla.subject_default\"> Asunto Default</label></div><div class=\"col-xs-12 col-sm-5 form-group\"><label ng-if=\"plantilla.subject_default==false\">Asunto <span class=\"color-red\">*</span></label> <input ng-if=\"plantilla.subject_default==false\" class=\"form-control\" type=\"text\" ng-model=\"plantilla.title\" name=\"plantillaSubject\" required=\"\"></div><button type=\"button\" class=\"btn btn-default ng-scope pull-right\" unselectable=\"on\" tabindex=\"-1\" ng-click=\"getFile()\" ng-disabled=\"!editor_focus\"><i class=\"fa fa-upload\"></i></button><div class=\"col-xs-12 form-group\"><label>Texto Superior <span class=\"color-red\">*</span></label><div text-angular=\"\" ng-model=\"plantilla.text\" name=\"plantillaText\" ng-focus=\"focusEditor()\" ng-blur=\"unfocusEditor()\" required=\"\"></div></div><div class=\"col-xs-12 form-group\"><label>Texto Inferior <span class=\"color-red\">*</span></label><div text-angular=\"\" name=\"plantillaBottom\" ng-focus=\"focusEditor()\" ng-blur=\"unfocusEditor()\" ng-model=\"plantilla.bottom_text\" required=\"\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button ng-if=\"!showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid || savingPlantilla\" ng-click=\"saveDelivery(plantilla)\">Crear Plantilla</button> <button ng-if=\"showEditInformation\" class=\"col-xs-12 btn btn-primary\" ng-disabled=\"form.$invalid || savingPlantilla\" ng-click=\"updateDelivery(plantilla)\">Actualizar Plantilla</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeTemplate()\">Cancelar</button></div></form></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Plantillas</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\" ng-if=\"!showInfoQuotation\"><table class=\"table table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th>ID</th><th>Nombre</th><th>Ramo(s)</th><th>Asunto</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"item in vm.quotations track by $index\" ng-click=\"showInformation(item)\"><td>{{ item.id }}</td><td>{{ item.name }}</td><td><ul ng-repeat=\"it in item.ramo_code track by $index\"><li><span ng-if=\"it==9\">Daños/Automóviles</span> <span ng-if=\"it==3\">Daños</span> <span ng-if=\"it==2\">Accidentes y enfermedades</span> <span ng-if=\"it==1\">Vida</span></li></ul></td><td>{{ item.title }}</td><td ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-sm btn-white\" ng-click=\"editQuatation(item)\" title=\"Editar plantilla\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-sm btn-danger m-l-xs\" ng-click=\"borrarPlantilla(item)\" title=\"Eliminar plantilla\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"show_pagination\" class=\"text-center\"><pagination config=\"vm.config_pagination\" model=\"vm.quotations\"></pagination></div></div><div class=\"animate\" ng-if=\"showInfoQuotation\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-info\" ng-click=\"showInformation(null)\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Name:</span><div><span>{{ quotation.name}}</span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><span class=\"blue-color\">Asunto:</span><div><span>{{ quotation.title }}</span></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Texto Superior:</span><div text-angular=\"\" ng-model=\"quotation.text\" name=\"quotation.text\" ta-disabled=\"isReadOnly\"></div><br></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Texto Inferior:</span><div text-angular=\"\" ng-model=\"quotation.bottom_text\" name=\"quotation.bottom_text\" ta-disabled=\"isReadOnly\"></div></div></div></div></div></div>");
$templateCache.put("app/siniestros/siniestros.table.html","<div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row animate\"><div class=\"col-xs-12\"><button class=\"pull-right btn btn-info m-b\" ng-click=\"vm.addSiniestro(vm.ramos.ramo_selected)\" ng-if=\"vm.acceso_adm_sin\"><i class=\"fa fa-plus\"></i> Nuevo siniestro</button><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.ramos.ramo_selected == 2\"><label>Afectado</label><input class=\"form-control col-sm-3 col-xs-2\" type=\"text\" name=\"afectado\" ng-model=\"vm.form.afectado\"><i class=\"fa fa-times-circle pull-right\" ng-if=\"vm.form.afectado\" ng-click=\"vm.clearInput(vm.form.afectado)\" style=\"position: absolute; top: 30px; right: 20px; font-size: 20px; z-index: 2000;\"></i></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Número de póliza</label> <input class=\"form-control\" type=\"text\" name=\"poliza\" ng-model=\"vm.form.num_poliza\"><i class=\"fa fa-times-circle pull-right\" ng-if=\"vm.form.num_poliza\" ng-click=\"vm.clearInput(vm.form.num_poliza)\" style=\"position: absolute; top: 30px; right: 20px; font-size: 20px; z-index: 2000;\"></i></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Número de siniestro</label> <input class=\"form-control\" type=\"text\" name=\"nsin\" ng-model=\"vm.form.num_sinister\"><i class=\"fa fa-times-circle pull-right\" ng-if=\"vm.form.num_sinister\" ng-click=\"vm.clearInput(vm.form.num_sinister)\" style=\"position: absolute; top: 30px; right: 20px; font-size: 20px; z-index: 2000;\"></i></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.ramos.ramo_selected == 4\"><label>Contratante</label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"vm.form.contratante\" change=\"vm.matchesContractors(vm.form.contratante.val)\"></autocomplete></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"!vm.ramosProvider.length\"><label>Ramo</label><select id=\"SelectRamo\" class=\"form-control col-sm-5\" ng-options=\"ramo.id as ramo.label for ramo in vm.ramos.options\" ng-model=\"vm.ramos.ramo_selected\" ng-change=\"vm.changeRamo(\'initial\')\"></select></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.ramosProvider.length\"><label>Ramo</label><select id=\"SelectRamo\" class=\"form-control col-sm-5\" ng-options=\"ramo.id as ramo.ramo_name for ramo in vm.ramosProvider\" ng-model=\"vm.ramos.ramo_selected\" ng-change=\"vm.changeRamo()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-12 form-group btn-action\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"vm.getSinisters(1,1,vm.ramos.ramo_selected, vm.actual_tab)\">Consultar</button></div></div></div></div><div class=\"row\"><div ng-if=\"!fechasFilter\" class=\"col-xs-12 col-sm-6 col-md-4 col-lg-5 form-group\"><button class=\"btn btn-success\" ng-click=\"vm.addFilter(1)\">Agregar filtro de fechas</button></div><div ng-if=\"fechasFilter\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group\"><label>Desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since | date : \'medium\'}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-2\"><button class=\"btn btn-sm btn-warning\" ng-click=\"vm.addFilter(2)\">x</button></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Siniestros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><uib-tabset ng-if=\"vm.ramos.ramo_selected == 2\"><uib-tab heading=\"Pendientes\" id=\"pendiente\" ng-click=\"vm.getSinisters(1,1,2,1); vm.actual_tab = 1\"><uib-tab-heading>Pendientes ({{vm.conteos.siniestros_pendientes}})</uib-tab-heading></uib-tab><uib-tab heading=\"En Trámite\" id=\"tramite\" ng-click=\"vm.getSinisters(1,1,2,2); vm.actual_tab = 2\"><uib-tab-heading>En trámite ({{vm.conteos.siniestros_tramite}})</uib-tab-heading></uib-tab><uib-tab heading=\"Cancelado\" id=\"cancelado\" ng-click=\"vm.getSinisters(1,1,2,3); vm.actual_tab = 3\"><uib-tab-heading>Cancelado ({{vm.conteos.siniestros_cancelado}})</uib-tab-heading></uib-tab><uib-tab heading=\"Rechazado\" id=\"rechazado\" ng-click=\"vm.getSinisters(1,1,2,4); vm.actual_tab = 4\"><uib-tab-heading>Rechazado ({{vm.conteos.siniestros_rechazado}})</uib-tab-heading></uib-tab><uib-tab heading=\"Completado\" id=\"completado\" ng-click=\"vm.getSinisters(1,1,2,5); vm.actual_tab = 5\"><uib-tab-heading>Completado ({{vm.conteos.siniestros_completado}})</uib-tab-heading></uib-tab><uib-tab heading=\"En espera\" id=\"enespera\" ng-click=\"vm.getSinisters(1,1,2,6); vm.actual_tab = 6\"><uib-tab-heading>En espera ({{vm.conteos.siniestros_enespera}})</uib-tab-heading></uib-tab></uib-tabset><uib-tabset ng-if=\"vm.ramos.ramo_selected == 3\"><uib-tab heading=\"Pendientes\" id=\"pendiente\" ng-click=\"vm.getSinisters(1,1,3,1); vm.actual_tab = 1\"><uib-tab-heading>Pendientes ({{vm.conteos.siniestros_pendientes}})</uib-tab-heading></uib-tab><uib-tab heading=\"En Trámite\" id=\"tramite\" ng-click=\"vm.getSinisters(1,1,3,2); vm.actual_tab = 2\"><uib-tab-heading>En trámite ({{vm.conteos.siniestros_tramite}})</uib-tab-heading></uib-tab><uib-tab heading=\"Cancelado\" id=\"cancelado\" ng-click=\"vm.getSinisters(1,1,3,3); vm.actual_tab = 3\"><uib-tab-heading>Cancelado ({{vm.conteos.siniestros_cancelado}})</uib-tab-heading></uib-tab><uib-tab heading=\"Rechazado\" id=\"rechazado\" ng-click=\"vm.getSinisters(1,1,3,4); vm.actual_tab = 4\"><uib-tab-heading>Rechazado ({{vm.conteos.siniestros_rechazado}})</uib-tab-heading></uib-tab><uib-tab heading=\"Completado\" id=\"completado\" ng-click=\"vm.getSinisters(1,1,3,5); vm.actual_tab = 5\"><uib-tab-heading>Completado ({{vm.conteos.siniestros_completado}})</uib-tab-heading></uib-tab><uib-tab heading=\"En espera\" id=\"enespera\" ng-click=\"vm.getSinisters(1,1,3,6); vm.actual_tab = 6\"><uib-tab-heading>En espera ({{vm.conteos.siniestros_enespera}})</uib-tab-heading></uib-tab></uib-tabset><uib-tabset ng-if=\"vm.ramos.ramo_selected == 4\"><uib-tab heading=\"Pendientes\" id=\"pendiente\" ng-click=\"vm.getSinisters(1,1,4,1); vm.actual_tab = 1\"><uib-tab-heading>Pendientes ({{vm.conteos.siniestros_pendientes}})</uib-tab-heading></uib-tab><uib-tab heading=\"En Trámite\" id=\"tramite\" ng-click=\"vm.getSinisters(1,1,4,2); vm.actual_tab = 2\"><uib-tab-heading>En trámite ({{vm.conteos.siniestros_tramite}})</uib-tab-heading></uib-tab><uib-tab heading=\"Cancelado\" id=\"cancelado\" ng-click=\"vm.getSinisters(1,1,4,3); vm.actual_tab = 3\"><uib-tab-heading>Cancelado ({{vm.conteos.siniestros_cancelado}})</uib-tab-heading></uib-tab><uib-tab heading=\"Rechazado\" id=\"rechazado\" ng-click=\"vm.getSinisters(1,1,4,4); vm.actual_tab = 4\"><uib-tab-heading>Rechazado ({{vm.conteos.siniestros_rechazado}})</uib-tab-heading></uib-tab><uib-tab heading=\"Completado\" id=\"completado\" ng-click=\"vm.getSinisters(1,1,4,5); vm.actual_tab = 5\"><uib-tab-heading>Completado ({{vm.conteos.siniestros_completado}})</uib-tab-heading></uib-tab><uib-tab heading=\"En espera\" id=\"enespera\" ng-click=\"vm.getSinisters(1,1,4,6); vm.actual_tab = 6\"><uib-tab-heading>En espera ({{vm.conteos.siniestros_enespera}})</uib-tab-heading></uib-tab></uib-tabset><uib-tabset ng-if=\"vm.ramos.ramo_selected == 1\"><uib-tab heading=\"Pendientes\" id=\"pendiente\" ng-click=\"vm.getSinisters(1,1,1,1); vm.actual_tab = 1\"><uib-tab-heading>Pendientes ({{vm.conteos.siniestros_pendientes}})</uib-tab-heading></uib-tab><uib-tab heading=\"En Trámite\" id=\"tramite\" ng-click=\"vm.getSinisters(1,1,1,2); vm.actual_tab = 2\"><uib-tab-heading>En trámite ({{vm.conteos.siniestros_tramite}})</uib-tab-heading></uib-tab><uib-tab heading=\"Cancelado\" id=\"cancelado\" ng-click=\"vm.getSinisters(1,1,1,3); vm.actual_tab = 3\"><uib-tab-heading>Cancelado ({{vm.conteos.siniestros_cancelado}})</uib-tab-heading></uib-tab><uib-tab heading=\"Rechazado\" id=\"rechazado\" ng-click=\"vm.getSinisters(1,1,1,4); vm.actual_tab = 4\"><uib-tab-heading>Rechazado ({{vm.conteos.siniestros_rechazado}})</uib-tab-heading></uib-tab><uib-tab heading=\"Completado\" id=\"completado\" ng-click=\"vm.getSinisters(1,1,1,5); vm.actual_tab = 5\"><uib-tab-heading>Completado ({{vm.conteos.siniestros_completado}})</uib-tab-heading></uib-tab><uib-tab heading=\"En espera\" id=\"enespera\" ng-click=\"vm.getSinisters(1,1,1,6); vm.actual_tab = 6\"><uib-tab-heading>En espera ({{vm.conteos.siniestros_enespera}})</uib-tab-heading></uib-tab></uib-tabset><table class=\"table table-striped table-bordered table-hover hidden-xs hidden-sm\"><thead><tr><th ng-click=\"vm.changeSiniesterA(1, vm.sin_afect_asc == 1 ? 2 : 1,vm.ramos.ramo_selected,vm.actual_tab)\" ng-model=\"vm.table.headers[0]\" ng-if=\"vm.ramos.ramo_selected == 2\">{{vm.table.headers[0]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sin_afect_asc == 1, \'fa fa-sort-asc\': vm.sin_afect_asc == 2}\"></span></th><th ng-if=\"vm.ramos.ramo_selected == 2\">Parentesco</th><th ng-click=\"vm.changeSiniesterA(2, vm.sin_cont_asc == 1 ? 2 : 1,vm.ramos.ramo_selected,vm.actual_tab)\" ng-model=\"vm.table.headers[1]\">{{vm.table.headers[1]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sin_cont_asc == 1, \'fa fa-sort-asc\': vm.sin_cont_asc == 2}\"></span></th><th ng-click=\"vm.changeSiniesterA(3, vm.sin_aseg_asc == 1 ? 2 : 1,vm.ramos.ramo_selected,vm.actual_tab)\" ng-model=\"vm.table.headers[2]\">{{vm.table.headers[2]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sin_aseg_asc == 1, \'fa fa-sort-asc\': vm.sin_aseg_asc == 2}\"></span></th><th ng-click=\"vm.changeSiniesterA(4, vm.sin_fingreso_asc == 1 ? 2 : 1,vm.ramos.ramo_selected,vm.actual_tab)\" ng-model=\"vm.table.headers[3]\">Fecha de ingreso <span ng-class=\"{\'fa fa-sort-desc\': vm.sin_fingreso_asc == 1, \'fa fa-sort-asc\': vm.sin_fingreso_asc == 2}\"></span></th><th ng-click=\"vm.changeSiniesterA(5, vm.sin_nsin_asc == 1 ? 2 : 1,vm.ramos.ramo_selected,vm.actual_tab)\" ng-model=\"vm.table.headers[3]\">No. Siniestro <span ng-class=\"{\'fa fa-sort-desc\': vm.sin_nsin_asc == 1, \'fa fa-sort-asc\': vm.sin_nsin_asc == 2}\"></span></th><th ng-click=\"vm.changeSiniesterA(6, vm.sin_npol_asc == 1 ? 2 : 1,vm.ramos.ramo_selected,vm.actual_tab)\" ng-model=\"vm.table.headers[3]\">No. Póliza <span ng-class=\"{\'fa fa-sort-desc\': vm.sin_npol_asc == 1, \'fa fa-sort-asc\': vm.sin_npol_asc == 2}\"></span></th><th ng-if=\"vm.ramos.ramo_selected == 2\" ng-click=\"vm.changeSiniesterA(7, vm.sin_pad_asc == 1 ? 2 : 1,vm.ramos.ramo_selected,vm.actual_tab)\" ng-model=\"vm.table.headers[4]\">{{vm.table.headers[4]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sin_pad_asc == 1, \'fa fa-sort-asc\': vm.sin_pad_asc == 2}\"></span></th><th ng-if=\"vm.ramos.ramo_selected == 2\" ng-click=\"vm.changeSiniesterA(8, vm.sin_recl_asc == 1 ? 2 : 1,vm.ramos.ramo_selected,vm.actual_tab)\" ng-model=\"vm.table.headers[5]\">{{vm.table.headers[5]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sin_recl_asc == 1, \'fa fa-sort-asc\': vm.sin_recl_asc == 2}\"></span></th><th ng-if=\"vm.ramos.ramo_selected == 2\" ng-click=\"vm.changeSiniesterA(10, vm.sin_proc_asc == 1 ? 2 : 1,vm.ramos.ramo_selected,vm.actual_tab)\" ng-model=\"vm.table.headers[5]\">Procedente <span ng-class=\"{\'fa fa-sort-desc\': vm.sin_proc_asc == 1, \'fa fa-sort-asc\': vm.sin_proc_asc == 2}\"></span></th><th ng-click=\"vm.changeSiniesterA(9, vm.sin_subr_asc == 1 ? 2 : 1,vm.ramos.ramo_selected,vm.actual_tab)\" ng-model=\"vm.table.headers[6]\">{{vm.table.headers[6]}} <span ng-class=\"{\'fa fa-sort-desc\': vm.sin_subr_asc == 1, \'fa fa-sort-asc\': vm.sin_subr_asc == 2}\"></span></th><th ng-model=\"vm.table.headers[7]\">{{vm.table.headers[7]}}</th></tr></thead><tbody><tr ng-repeat=\"siniestro in vm.siniestros track by $index\" ng-click=\"vm.goToSinister(vm.ramos.ramo_selected, siniestro.id)\"><td ng-if=\"siniestro.accidente_sinister[0].dependiente && vm.ramos.ramo_selected == 2\">{{siniestro.accidente_sinister[0].dependiente.full_name}} <span ng-if=\"!siniestro.accidente_sinister[0].dependiente.full_name\">{{siniestro.accidente_sinister[0].dependiente.first_name}} {{siniestro.accidente_sinister[0].dependiente.last_name}} {{siniestro.accidente_sinister[0].dependiente.second_last_name}}</span><br></td><td ng-if=\"siniestro.accidente_sinister[0].titular && vm.ramos.ramo_selected == 2 && siniestro.accidente_sinister[0].titular.full_name\">{{siniestro.accidente_sinister[0].titular.full_name}}</td><td ng-if=\"siniestro.accidente_sinister[0].titular && vm.ramos.ramo_selected == 2 && !siniestro.accidente_sinister[0].titular.full_name\">{{siniestro.accidente_sinister[0].titular.first_name}} {{siniestro.accidente_sinister[0].titular.last_name}} {{siniestro.accidente_sinister[0].titular.second_last_name}}</td><td ng-if=\"!siniestro.accidente_sinister[0].dependiente && vm.ramos.ramo_selected == 2 && !siniestro.accidente_sinister[0].titular\">{{siniestro.aux_affected}}</td><td ng-if=\"vm.ramos.ramo_selected == 2\" \"=\"\"><div ng-if=\"!siniestro.aux_affected\"><span ng-if=\"siniestro.accidente_sinister[0].relationship == 1\">Titular</span> <span ng-if=\"siniestro.accidente_sinister[0].relationship == 2\">Cónyuge</span> <span ng-if=\"siniestro.accidente_sinister[0].relationship == 3\">Hijo</span> <span ng-if=\"siniestro.accidente_sinister[0].relationship == 4\">Otro</span></div><div ng-if=\"siniestro.aux_affected\"><span ng-if=\"siniestro.relationship_aux_affected == 1\">Titular</span> <span ng-if=\"siniestro.relationship_aux_affected == 2\">Cónyuge</span> <span ng-if=\"siniestro.relationship_aux_affected == 3\">Hijo</span> <span ng-if=\"siniestro.relationship_aux_affected == 4\">Otro</span></div></td><td ng-if=\"siniestro.poliza.contractor\">{{siniestro.poliza.contractor}}</td><td ng-if=\"siniestro.poliza.parent.parent.contractor\">{{siniestro.poliza.parent.parent.contractor.full_name}}</td><td ng-if=\"siniestro.poliza.parent.parent.parent.contractor && !siniestro.poliza.parent.parent.contractor\">{{siniestro.poliza.parent.parent.parent.contractor.full_name}}</td><td ng-if=\"siniestro.poliza.aseguradora\">{{siniestro.poliza.aseguradora}}</td><td ng-if=\"!siniestro.poliza.aseguradora\">{{siniestro.cover_aseguradora}}</td><td>{{siniestro.fecha_ingreso | date: \'dd/MM/yyyy - HH:MM\': \'UTC\'}}</td><td>{{siniestro.numero_siniestro }}</td><td>{{siniestro.poliza.poliza_number }}</td><td ng-if=\"vm.ramos.ramo_selected == 2\">{{siniestro.accidente_sinister[0].ailment}}</td><td ng-if=\"vm.ramos.ramo_selected == 2\">{{siniestro.accidente_sinister[0].total_reclamado | currency : symbol : fractionSize}}</td><td ng-if=\"vm.ramos.ramo_selected == 2\">{{siniestro.accidente_sinister[0].total_procedente | currency : symbol : fractionSize}}</td><td>{{siniestro.poliza.subramo}}</td><td ng-click=\"$event.stopPropagation();\"><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); vm.showBinnacle(siniestro)\"><i class=\"fa fa-comment\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"vm.show_pag_policy\" class=\"text-center\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li></ul></nav></div><div class=\"row\" ng-if=\"vm.show_binnacle\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"5\" idmodel=\"vm.siniester_id\" exportable=\"true\"></comments></div></div></div></div></div><div class=\"row\" ng-if=\"vm.acceso_rep_sin\"><div class=\"col-xs-12\"><button class=\"btn btn-primary pull-right ladda-button\" ng-if=\"vm.siniestros.length\" ng-click=\"vm.exportToExcel(1,1,vm.ramos.ramo_selected, vm.actual_tab)\"><i class=\"fa fa-download\"></i> Exportar a excel</button></div></div></div></div></div></div></div>");
$templateCache.put("app/siniestros/siniestros.vida.html","<div class=\"row wrapper border-bottom white-bg page-heading\" ng-if=\"url !== \'/index/main\'\"><div class=\"col-lg-9\"><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Siniestros - Vida</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Vida - Crear siniestro</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6 form-group\" ng-if=\"!vm.selected_affect || !vm.selected_affect.val\"><label>Afectado: <span class=\"color-red\">*</span></label><div class=\"col-xs-12 input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"cadena_a_buscar\" ng-change=\"vm.cadenaBusq(cadena_a_buscar)\"></div></div><div class=\"col-md-2 form-group\" ng-if=\"!vm.selected_affect || !vm.selected_affect.val\"><label></label> <button type=\"button\" ng-click=\"vm.updateStatus(cadena_a_buscar)\" class=\"btn btn-block btn-success mt5\">Buscar</button></div><div ng-if=\"vm.affected.length>0\" class=\"col-xs-12 form-group\"><select class=\"select form-control\" ng-model=\"vm.selected_affect\" ng-options=\"affected as affected.label for affected in vm.affected\" ng-change=\"vm.LookFor(vm.selected_affect); vm.saveLocalstorange()\"><option value=\"\" disabled=\"\">Seleccione una Póliza</option></select></div><div ng-if=\"vm.selected_affect && vm.selected_affect.val\" align=\"center\"><label class=\"color-blue\" for=\"\">Afectado:</label> <label>{{vm.selected_affect.val}}</label></div><div ng-if=\"cadena_a_buscar && habuscado && vm.affected.length==0\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div></div><div class=\"row\"><form name=\"vidaSiniestroForm\"><div class=\"row\"><div ng-if=\"vm.show_caratula_afectado\" class=\"col-md-6 form-group\"><label>Afectado (Siniestro a carátula) <span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"siniester_number\" ng-model=\"vm.siniester_data.aux_affected\" ng-change=\"saveLocalstorange()\" required=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Fecha de emisión<span class=\"color-red\">*</span></label><div class=\"input-group date\" ng-class=\"{ \'has-error\': vidaSiniestroForm.date_ingreso.$invalid && !vidaSiniestroForm.date_ingreso.$pristine }\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" name=\"date_ingreso\" date-time=\"\" ng-model=\"vm.affect_data.fecha_ingreso\" ng-blur=\"saveLocalstorange()\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" required=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Número de siniestro</label> <input ng-class=\"{ \'has-error\': vidaSiniestroForm.numero_de_siniestro.$invalid && !vidaSiniestroForm.numero_de_siniestro.$pristine }\" class=\"form-control\" ng-model=\"vm.siniester_data.siniester_number.label\" ng-change=\"saveLocalstorange()\" name=\"numero_de_siniestro\"></div><div class=\"col-md-3 form-group\"><label>Fecha en que ocurrió <span class=\"color-red\">*</span></label><div class=\"input-group date\" ng-class=\"{ \'has-error\': vidaSiniestroForm.date.$invalid && !vidaSiniestroForm.date.$pristine }\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" name=\"date\" date-time=\"\" ng-model=\"vm.affect_data.siniester_date\" ng-blur=\"saveLocalstorange()\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" required=\"true\"></div></div><div class=\"col-md-3 form-group\" ng-class=\"{ \'has-error\': vidaSiniestroForm.siniestroType.$invalid && !vidaSiniestroForm.siniestroType.$pristine }\"><label>Tipo de sinestro <span class=\"color-red\">*</span></label><select name=\"siniestroType\" ng-model=\"vm.siniester_type\" id=\"siniestroType\" ng-init=\"vm.siniester_type = vm.siniester_type || 0\" class=\"select form-control\" ng-change=\"saveLocalstorange()\" ng-options=\"siniester_tipo.id as siniester_tipo.label for siniester_tipo in vm.siniestros_type\" required=\"\"></select></div><div class=\"col-md-3 form-group\" ng-class=\"{ \'has-error\': vidaSiniestroForm.payWay.$invalid && !vidaSiniestroForm.payWay.$pristine }\"><label>Forma de pago <span class=\"color-red\">*</span></label><select name=\"payWay\" id=\"payWay\" ng-model=\"vm.siniester_pay_form\" ng-init=\"vm.siniester_pay_form = vm.siniester_pay_form || 0\" class=\"select form-control\" ng-change=\"saveLocalstorange()\" ng-options=\"siniester_tipo.id as siniester_tipo.label for siniester_tipo in vm.siniestros_pay_form\" required=\"\"></select></div></form></div><br><fieldset><legend align=\"right\">Información general</legend><div class=\"row\"><div class=\"col-md-3 form-group\"><label>Fecha de captura</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"vm.dateNow\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" disabled=\"\"></div></div><div class=\"col-md-3 form-group\"><label>Estatus del siniestro</label><select class=\"select form-control\" ng-init=\"vm.status.id = vm.status.id || 1\" ng-model=\"vm.status.id\" ng-change=\"vm.updateSiniestroStatus(vm.status); saveLocalstorange();\" ng-options=\"status.id as status.label for status in vm.statuses\"></select></div><div class=\"col-md-3 form-group\"><label>Parentesco:</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.affect_data.title\"></div><div class=\"col-md-3 form-group\"><label>Fecha de nacimiento:</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Contratante:</label> <input disabled=\"\" ng-model=\"vm.affect_data.contratante.name\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Número de póliza:</label> <input disabled=\"\" ng-model=\"vm.affect_data.policy_number\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Subramo</label> <input disabled=\"\" class=\"form-control\" ng-model=\"vm.siniester_data.subramo.subramo_name\"></div><div class=\"col-md-3 form-group\"><label>Estatus de pago:</label> <input disabled=\"\" ng-model=\"vm.affect_data.policy_status.label\" class=\"form-control\"></div><div class=\"col-md-5 form-group\"><label>Domicilio:</label> <input disabled=\"\" ng-model=\"vm.affect_data.contractor_addres\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Inicio de Vigencia:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.policy_vigencia_init\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Fin de Vigencia:</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input disabled=\"\" class=\"form-control\" date-time=\"\" ng-model=\"vm.affect_data.policy_vigencia\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\"></div></div><div class=\"col-md-3 form-group\"><label>Aseguradora:</label> <input disabled=\"\" ng-model=\"vm.affect_data.aseguradora.compania\" class=\"form-control\"></div><div class=\"col-md-3 form-group\"><label>Plan / Paquete:</label> <input disabled=\"\" ng-model=\"vm.affect_data.paquete.package_name\" class=\"form-control\"></div></div></fieldset><br><fieldset><legend align=\"right\">Dependiente Afectado</legend><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover table footable table-stripped\" data-page-size=\"25\"><thead><tr><th class=\"footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Nombre</th><th class=\"footable-sortable\">Parentesco</th><th class=\"footable-sortable\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"afectado in vm.afectados track by $index\" foo-repeat-done=\"\"><td><input class=\"form-control\" type=\"text\" ng-model=\"afectado.nombre\" ng-change=\"saveLocalstorange()\"></td><td><select ng-model=\"afectado.parentesco\" ng-options=\"item.id as item.label for item in vm.relationship\" class=\"form-control\" ng-change=\"saveLocalstorange()\"><option value=\"\">Selecciona una opción</option></select></td><td><button type=\"button\" class=\"btn btn-w-m btn-danger\" name=\"button\" ng-click=\"vm.deleteAfectado(afectado.url,$index); saveLocalstorange()\">Eliminar</button></td></tr></tbody></table></div><div class=\"col-sm-12\" ng-if=\"count_afectado == true\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addAfectado();saveLocalstorange()\" type=\"button\">Agregar Afectado</button></div></fieldset><br><fieldset><legend class=\"legend-title\" align=\"right\">Beneficiarios</legend><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table footable table-stripped\" data-filter=\"#filter\" data-page-size=\"25\"><thead><tr><th class=\"text-align-left width-20p footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Nombre <span class=\"footable-sort-indicator\"></span></th><th class=\"text-align-left width-20p footable-visible footable-sortable footable-first-column\" data-hide=\"phone\">Parentesco <span class=\"footable-sort-indicator\"></span></th><th class=\"text-align-left width-20p footable-sortable\" data-hide=\"phone\">Fecha de nacimiento <span class=\"footable-sort-indicator\"></span></th><th class=\"text-align-left width-20p footable-sortable\" data-hide=\"phone\">Porcentaje <span class=\"footable-sort-indicator\"></span></th></tr></thead><tbody><tr ng-repeat=\"benficiarie in vm.beneficiaries\" foo-repeat-done=\"\"><td class=\"text-align-left width-20p\">{{benficiarie.first_name }} {{benficiarie.last_name }} {{benficiarie.second_last_name }}</td><td class=\"text-align-left width-20p\" ng-if=\"benficiarie.optional_relationship == 1\">Titular</td><td class=\"text-align-left width-20p\" ng-if=\"benficiarie.optional_relationship == 2\">Cónyuge</td><td class=\"text-align-left width-20p\" ng-if=\"benficiarie.optional_relationship == 3\">Hijo</td><td class=\"text-align-left width-20p\" ng-if=\"benficiarie.optional_relationship == 4\">Otro</td><td class=\"text-align-left width-20p\" ng-if=\"benficiarie.optional_relationship != 1 || benficiarie.optional_relationship != 2 || benficiarie.optional_relationship != 3 || benficiarie.optional_relationship != 4\">{{benficiarie.optional_relationship}}</td><td class=\"text-align-left width-20p\">{{benficiarie.birthdate | date:\"MM/dd/yyyy\": \'UTC\'}}</td><td class=\"text-align-left width-20p\"><div class=\"input-group\"><input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"benficiarie.percentage\"> <span class=\"input-group-btn\"><button class=\"btn btn-white\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></button></span></div></td></tr></tbody></table></div></div></div></fieldset><br><fieldset><legend class=\"legend-title\" align=\"right\">Coberturas</legend><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table footable table-stripped\" data-filter=\"#filter\" data-page-size=\"25\"><thead><tr><th class=\"text-align-center width-20p footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Cobertura <span class=\"footable-sort-indicator\"></span></th><th class=\"text-align-center width-20p footable-visible footable-sortable footable-first-column\" data-hide=\"phone\">S. Asegurada <span class=\"footable-sort-indicator\"></span></th><th class=\"text-align-center width-20p footable-sortable\" data-hide=\"phone\">Deducible <span class=\"footable-sort-indicator\"></span></th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.selectedPoliza.data.coverageInPolicy_policy\" foo-repeat-done=\"\"><td class=\"text-align-center width-20p\">{{coverage.coverage_name}}</td><td class=\"text-align-center width-20p\">{{coverage.sum_insured}}</td><td class=\"text-align-center width-20p\">{{coverage.deductible}}</td></tr></tbody></table></div></div></div><fieldset><legend align=\"right\">Información de contacto</legend><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover table footable table-stripped\" data-page-size=\"25\"><thead><tr><th class=\"footable-visible footable-sortable footable-first-column\" data-breakpoints=\"xs\">Nombre <span class=\"color-red\">*</span></th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\">Teléfono</th><th class=\"footable-visible footable-sortable\" data-hide=\"phone\">Correo electrónico</th><th data-hide=\"phone\" class=\"footable-sortable\">Referencia</th><th data-hide=\"phone\" class=\"footable-sortable\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"contact in vm.contacts track by $index\" foo-repeat-done=\"\"><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.first_name\" required=\"\" ng-change=\"saveLocalstorange()\"></td><td><phonenumber-directive placeholder=\"myPrompt\" model=\"contact.phone\" change=\"saveLocalstorange()\"></phonenumber-directive></td><td><input class=\"form-control\" type=\"email\" ng-model=\"contact.email\" ng-change=\"saveLocalstorange()\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"contact.references\" ng-change=\"saveLocalstorange()\"></td><td><button type=\"button\" class=\"btn btn-w-m btn-danger\" name=\"button\" ng-click=\"vm.deleteContacts(contact.url,$index); saveLocalstorange\">Eliminar</button></td></tr></tbody></table></div><div class=\"col-sm-12\"><button class=\"btn btn-success pull-right\" ng-click=\"vm.addContact(); saveLocalstorange()\" type=\"button\">Agregar contacto</button></div></fieldset></fieldset><br><fieldset><div class=\"row\"><div class=\"col-md-12 form-group\"><label>Observaciones:</label> <textarea class=\"form-control\" ng-model=\"vm.siniester_data.observations\">\n                                </textarea></div></div><div class=\"row\"></div></fieldset><br><div class=\"hr-line-dashed\"></div><div upload-template=\"\" ng-if=\"vm.permiso_administrar_adjuntos\"></div><div ng-include=\"\'templates/show-files.html\'\"></div><div class=\"hr-line-dashed\" ng-if=\"url !== \'/index/main\'\"></div><div class=\"row\" ng-if=\"url !== \'/index/main\'\"><div class=\"col-xs-12 form-group btn-mt\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-primary ladda-button\" type=\"button\" ng-click=\"vm.saveSiniester()\" title=\"Los campos con con * son obligatorios\">Guardar siniestro</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"vm.cancel()\" type=\"button\">Cancelar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/siniestros/whatsapp_siniestro.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Enviar WhatsApp Web</h4><span ng-if=\"poliza && poliza.poliza_number\"><b>Póliza:</b> {{poliza.poliza_number}}</span> <span ng-if=\"siniestro && siniestro.numero_siniestro\"><b>Siniestro:</b> {{siniestro.numero_siniestro}}</span></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\"><label>Teléfono (WhatsApp Web)<span class=\"color-red\">*</span></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"phone\" maxlength=\"15\"></div><div class=\"form-group\"><label>Plantilla de WhatsApp Web:</label><select class=\"form-control\" ng-model=\"selectedTemplate\" ng-options=\"tpl as tpl.title for tpl in templatesList track by tpl.id\" ng-change=\"applyTemplate(selectedTemplate)\"><option value=\"\">Selecciona una plantilla</option></select></div><div class=\"form-group\"><label>Mensaje adicional:</label> <textarea class=\"form-control\" rows=\"5\" ng-model=\"message\" placeholder=\"Escribe aquí el mensaje que deseas enviar\"></textarea></div><div class=\"form-group alert alert-warning\" style=\"margin-top:10px;\" ng-init=\"whatsAppWarningExpanded = true\"><div class=\"clearfix\"><strong>⚠️ Uso de WhatsApp Web:</strong> <button type=\"button\" class=\"btn btn-link btn-xs pull-right\" ng-click=\"whatsAppWarningExpanded = !whatsAppWarningExpanded\">{{ whatsAppWarningExpanded ? \'Ocultar detalles\' : \'Mostrar detalles\' }}</button></div><ul class=\"list-unstyled\" style=\"margin-top:0.3rem;\" ng-show=\"whatsAppWarningExpanded\"><li>• Envía en tandas pequeñas y deja pausas entre envíos.</li><li>• Contacta preferentemente a clientes con consentimiento o interacción previa.</li><li>• Personaliza el mensaje y evita textos idénticos masivos.</li><li>• Si el cliente no quiere más mensajes, respeta la baja de inmediato.</li></ul><p class=\"text-muted\" style=\"margin-bottom:0;\" ng-show=\"whatsAppWarningExpanded\">Las restricciones y bloqueos son reglas de WhatsApp. Usa esta función con responsabilidad.</p><p class=\"text-muted\" style=\"margin-bottom:0;\" ng-if=\"!whatsAppWarningExpanded\">Hay algunas restricciones que deberías saber antes de enviar mensajes por WhatsApp Web.</p></div><div class=\"form-group\" ng-if=\"siniestroDetails.length\"><label>Detalles del siniestro</label><div class=\"well\" style=\"background-color:#fcfcfc; padding:15px;\"><div ng-repeat=\"detail in siniestroDetails track by $index\" class=\"detail-line\">{{ detail }}</div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cerrar</button> <button type=\"button\" class=\"btn btn-success ladda-button\" ng-click=\"sendWhatsApp()\" ng-disabled=\"sendLoading || previewLoading\"><i class=\"fa fa-whatsapp\"></i> Enviar WhatsApp</button></div></div>");
$templateCache.put("app/sucursales/sucursal.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Sucursales</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Sucursales</strong></li></ol></div></div><div><div class=\"row\" ng-if=\"!showSucursal\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><button class=\"col-xs-12 btn btn-info pull-right m-t\" ng-click=\"createSucursal()\">Agregar Sucursal</button></div></div><div ng-if=\"showSucursal\"><legend ng-if=\"!edit\" class=\"legend-title\" align=\"center\">Nueva Sucursal</legend><legend ng-if=\"edit\" class=\"legend-title\" align=\"center\">Actualizar Sucursal</legend><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre de la Sucursal <span class=\"color-red\">*</span></label> <input class=\"form-control\" value=\"\" id=\"sucursal_name\" ng-model=\"sucursal.sucursal_name\" ng-change=\"saveLocalstorange()\" required=\"\"></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Calle</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.route\" ng-change=\"saveLocalstorange()\" id=\"id_address_route\" name=\"address_route\" data-geo=\"route\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Número Exterior</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number\" ng-change=\"saveLocalstorange()\" id=\"id_address_street_number\" name=\"address_street_number\" data-geo=\"street_number\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Número Interior</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.street_number_int\" ng-change=\"saveLocalstorange()\" id=\"id_address_street_number_int\" name=\"address_street_number_int\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Colonia</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.sublocality\" ng-change=\"saveLocalstorange()\" id=\"id_address_sublocality\" name=\"address_sublocality\" data-geo=\"sublocality\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.state.$invalid && !form.state.$pristine }\"><label>Estado<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"estado.state for estado in statesArray track by estado.url\" name=\"state\" ng-model=\"address.administrative_area_level_1\" ng-change=\"saveLocalstorange()\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un estado</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.city.$invalid && !form.city.$pristine }\"><label>Municipio<span class=\"color-red\">*</span></label><select class=\"form-control\" data-ng-options=\"ciudad.city for ciudad in address.administrative_area_level_1.cities track by ciudad.url\" name=\"city\" ng-model=\"address.administrative_area_level_2\" ng-change=\"saveLocalstorange()\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un municipio</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Código Postal</label> <input type=\"tel\" name=\"zip\" ng-model=\"address.postal_code\" ng-change=\"saveLocalstorange()\" minlength=\"5\" maxlength=\"5\" class=\"form-control\" ng-keypress=\"filterValue($event)\"></div><div class=\"col-xs-12 form-group\"><label>Referencias</label> <input type=\"text\" class=\"form-control\" ng-model=\"address.details\" ng-change=\"saveLocalstorange()\" id=\"id_address_details\" name=\"address_details\"></div><input type=\"hidden\" class=\"form-control\" ng-model=\"address.administrative_area_level_1_short\" id=\"id_address_administrative_area_level_1_short\" name=\"address_state_code\" data-geo=\"administrative_area_level_1_short\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country\" id=\"id_address_country\" name=\"address_country\" data-geo=\"country\" value=\"México\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.composed\" id=\"id_address_composed\" name=\"address_composed\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.country_code\" id=\"id_address_country_code\" name=\"address_country_code\" data-geo=\"country_short\" value=\"MX\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.locality\" id=\"id_address_locality\" name=\"address_locality\" data-geo=\"locality\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.latitude\" id=\"id_address_latitude\" name=\"address_latitude\" data-geo=\"lat\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.longitude\" id=\"id_address_longitude\" name=\"address_longitude\" data-geo=\"lng\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"address.formatted\" id=\"id_address_formatted\" name=\"address_formatted\" data-geo=\"formatted_address\"></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Detalles</label> <textarea type=\"text\" class=\"form-control\" name=\"details\" ng-model=\"sucursal.details\" ng-change=\"saveLocalstorange()\"></textarea></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button ng-if=\"!edit\" class=\"col-xs-12 btn btn-primary\" ng-click=\"saveSucursal(sucursal)\">Crear</button> <button ng-if=\"edit\" class=\"col-xs-12 btn btn-primary\" ng-click=\"updateSucursal(sucursal)\">Actualizar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeSucursal()\">Cancelar</button></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"!showSucursal\"><div class=\"ibox-title\"><h5>Sucursales</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y animate\"><table class=\"table table-hover table-bordered hidden-xs hidden-sm\"><thead><tr><th>Sucursal</th><th>Dirección</th><th>Detalles</th><th>Creada por</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"item in sucursalList track by $index\"><td>{{ item.sucursal_name }}</td><td><div ng-if=\"item.address_sucursal[0]\"><span>{{ item.address_sucursal[0].route }} {{ item.address_sucursal[0].street_number }} int. {{ item.address_sucursal[0].street_number_int }} {{ item.address_sucursal[0].sublocality }}, {{ item.address_sucursal[0].postal_code }}, {{ item.address_sucursal[0].administrative_area_level_2 }}, {{ item.address_sucursal[0].administrative_area_level_1 }}</span></div><div ng-if=\"!item.address_sucursal[0]\">No existe</div></td><td>{{ item.details }}</td><td>{{ item.owner }}</td><td><a class=\"btn btn-sm btn-white\" ng-click=\"editSucursal(item, $index)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/tablero/tablero.config.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Tablero</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><a ui-sref=\"polizas.table\">Tablero OT</a></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"container-fluid text-right\"><div class=\"col-xs-12 form-group\" ng-if=\"cargando\"><div class=\"col-xs-12 form-group container-loader\"><img src=\"../../assets/images/loader/black_loader.gif\"></div></div><div class=\"row\"><div class=\"col-xs-6 col-sm-3 form-group\" ng-if=\"!cargando\"><button ng-click=\"filtrosSubramos()\" class=\"btn btn-outline btn-default dim btn-block btn-sm\"><i class=\"fa fa-cog\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-6 col-sm-3 form-group\" ng-if=\"!cargando\"><button class=\"btn btn-primary ladda-button2\" ng-click=\"addContainer(principal)\">Añadir estado <i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></div><button ng-if=\"!cargando\" class=\"btn btn-default pull-right\" style=\"margin-top: -7px; color: grey\" ng-click=\"vm.getLog()\"><i class=\"fa fa-history\">Log</i></button></div></div><div class=\"col-xs-12\" ng-if=\"newcontainer || editcontainer_b\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Nombre del contenedor: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"container.tablero\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Color: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"color.value as color.name for color in colorArray1\" ng-change=\"vm.saveColor(colorSelected)\" ng-model=\"colorSelected\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group d-flex gap-2\"><button class=\"btn btn-success col-xs-6 m-t ladda-button2\" ng-click=\"newcontainer ? saveContainer(principal, container) : saveEditContainer(principal, container)\">{{ newcontainer ? \'Guardar estado\' : \'Guardar cambios\' }}</button> <button class=\"btn btn-warning col-xs-6 m-t ladda-button2\" ng-click=\"cancelNewEdit(newcontainer,editcontainer_b)\">Cancelar</button></div></div></div><div class=\"row\"><div class=\"col-xs-12 text-center\" ng-if=\"cargando\"><div class=\"alert alert-warning alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Obteniendo datos a partir de la configuración establecida.</div></div><div class=\"alert alert-info alert-dismissible\" ng-if=\"mensajeTablero\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Sin configuraciones existentes (Tablero vacío)</div><div class=\"col-xs-12 table-tablero\"><table class=\"table\"><thead><tr><th ng-repeat=\"container in (filtrado ? resultsFilter : principal.contenedores) track by $index\"><div class=\"col-xs-12 box-title\" style=\"background-color: {{container.color}}\"><a class=\"btn btn-white btn-sm pull-right\" ng-click=\"vm.editContainer(container, $index)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm pull-right\" ng-if=\"(!container.details_polizas || container.details_polizas.length === 0) && (!container.details_endoso || container.details_endoso.length === 0)\" ng-click=\"vm.deleteContainer(container,principal, $index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></a> <label class=\"label-tablero\">{{container.tablero}}</label> <span class=\"label-number\">OT Póliza(s): {{container.details_polizas.length}} // OT Endoso(s): {{container.details_endoso.length}}</span></div><div class=\"caption\"><div ng-repeat=\"dp in container.details_polizas track by $index\" class=\"col-xs-12 box-content\"><button type=\"button\" class=\"btn btn-secondary btn-sm dropdown-toggle pull-right\" data-toggle=\"dropdown\"><i class=\"fa fa-pencil\"></i></button> <b>OT PÓLIZA: {{dp.internal_number}} - {{dp.contractor}}</b><h6>{{dp.start_of_validity | date: \'dd/MM/yyyy\'}} - {{dp.end_of_validity | date: \'dd/MM/yyyy\'}}</h6><h6><b>{{dp.ramo}}</b></h6><h6><b>{{dp.subramo}}</b></h6><h6 class=\"pull-right\"><b>Hace {{dp.antiguedad}}d.</b></h6><ul class=\"dropdown-menu dropdown-menu-right\"><li><a class=\"btn btn-white btn-sm\" ng-click=\"gotToInfo(dp, container, $index, 1)\"><i class=\"fa fa-info\"></i> Ir</a></li><li class=\"dropdown-submenu\" ng-if=\"principal.contenedores.length\"><a>Mover a</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-repeat=\"newcontainer in principal.contenedores track by $index\" ng-if=\"newcontainer.tablero != container.tablero\"><a ng-click=\"vm.moveOTState(dp, container, newcontainer, principal, 1)\">{{newcontainer.tablero}}</a></li></ul></li><li><a ng-click=\"vm.getPDF(dp.id)\">Ver PDF</a></li></ul></div><div ng-repeat=\"de in container.details_endoso track by $index\" class=\"col-xs-12 box-content\"><button type=\"button\" class=\"btn btn-secondary btn-sm dropdown-toggle pull-right\" data-toggle=\"dropdown\"><i class=\"fa fa-pencil\"></i></button> <b>OT ENDOSO: {{de.internal_number}} - {{de.policy.contractor}}</b><h6>{{de.init_date | date: \'dd/MM/yyyy\'}} - {{de.end_date | date: \'dd/MM/yyyy\'}}</h6><h6><b>{{de.policy.ramo}}</b></h6><h6><b>{{de.policy.subramo}}</b></h6><h6 class=\"pull-right\"><b>Hace {{de.antiguedad}}d.</b></h6><ul class=\"dropdown-menu dropdown-menu-right\"><li><a class=\"btn btn-white btn-sm\" ng-click=\"gotToInfo(de, container, $index, 2)\"><i class=\"fa fa-info\"></i> Ir</a></li><li class=\"dropdown-submenu\" ng-if=\"principal.contenedores.length\"><a>Mover a</a><ul class=\"dropdown-menu dropdown-menu-right\"><li ng-repeat=\"newcontainer in principal.contenedores track by $index\" ng-if=\"newcontainer.tablero != container.tablero\"><a ng-click=\"vm.moveOTState(de, container, newcontainer, principal, 2)\">{{newcontainer.tablero}}</a></li></ul></li><li><a ng-click=\"getPDFE(de)\">Ver PDF</a></li></ul></div></div></th></tr></thead></table></div></div></div></div></div></div></div>");
$templateCache.put("app/tablero/tablero_original.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Tablero</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><a ui-sref=\"polizas.table\">Tablero OT</a></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"container-fluid text-right\"><div class=\"col-xs-12 form-group\"><span ng-if=\"cargando\"><div class=\"sk-spinner sk-spinner-rotating-plane margin-top-45p\"></div></span></div><div class=\"row\"><div class=\"col-xs-6 col-sm-3 form-group\"><button ng-click=\"filtrosSubramos()\" class=\"btn btn-outline btn-default dim btn-block btn-sm\"><i class=\"fa fa-cog\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-6 col-sm-3 form-group\"><button class=\"btn btn-primary ladda-button2\" ng-click=\"addContainer(principal)\">Añadir estado <i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></div></div></div><div class=\"col-xs-12\"><div class=\"row\" ng-if=\"newcontainer || editcontainer\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Nombre del contenedor: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"container.tablero\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Color: <span class=\"color-red\">*</span></label><div><select class=\"form-control\" ng-options=\"color.value as color.name for color in colorArray1\" ng-change=\"vm.saveColor(colorSelected)\" ng-model=\"colorSelected\"></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"newcontainer && !editcontainer\"><button class=\"btn btn-success col-xs-12 m-t ladda-button2\" ng-click=\"saveContainer(principal,container)\" ng-if=\"!filtrado\">Guardar estado</button> <button class=\"btn btn-success col-xs-12 m-t ladda-button2\" ng-click=\"saveContainerFilter(principal,container)\" ng-if=\"filtrado\">Guardar estado</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group pull-right\" ng-if=\"editcontainer\"><button class=\"btn btn-success col-xs-12 m-t ladda-button2\" ng-click=\"saveEditContainer(principal,container)\" ng-if=\"!filtrado\">Guardar cambios</button> <button class=\"btn btn-success col-xs-12 m-t ladda-button2\" ng-click=\"saveEditContainerFilter(principal,container)\" ng-if=\"filtrado\">Guardar cambios</button></div><div class=\"row\" ng-if=\"container.tablero\"><div class=\"col-xs-12 col-sm-4 col-sm-offset-4 form-group\"><div class=\"box-title\" style=\"background-color: {{container.color}}\"><a class=\"btn btn-white btn-sm pull-right\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a><label class=\"label-tablero\">{{container.tablero}}</label></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 table-tablero\"><table class=\"table\" ng-if=\"!filtrado\"><thead><tr><th ng-repeat=\"container in principal.contenedores track by $index\"><div class=\"col-xs-12 box-title\" style=\"background-color: {{container.color}}\"><a class=\"btn btn-white btn-sm pull-right\" ng-click=\"vm.editContainer(container,$index)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a><label class=\"label-tablero\">{{container.tablero}}</label> <span class=\"label-number\">OT Póliza(s): {{container.details_polizas.length}} // OT Endoso(s): {{container.details_endoso.length}}</span></div><div class=\"caption\"><div ng-repeat=\"dp in container.details_polizas track by $index\"><div class=\"col-xs-12 box-content\"><button type=\"button\" class=\"btn btn-secondary btn-sm dropdown-toggle pull-right\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <b>OT PÓLIZA: {{dp.internal_number}} - {{dp.contractor}}</b><h6>{{dp.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{dp.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</h6><h6><b>{{dp.ramo}}</b></h6><h6><b>{{dp.subramo}}</b></h6><h6 class=\"pull-right\"><b>Hace {{dp.antiguedad}}d.</b></h6><ul class=\"dropdown-menu dropdown-menu-right\"><li><a class=\"btn btn-white btn-sm\" ng-click=\"gotToInfo(dp,container,$index,1)\"><i class=\"fa fa-info\" aria-hidden=\"true\"></i> Ir</a></li><li class=\"dropdown-submenu\" ng-if=\"principal.contenedores.length\"><a>Mover a</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"principal.contenedores\"><a class=\"disabled\">Estados</a></li><li ng-if=\"principal.contenedores\" ng-repeat=\"newcontainer in principal.contenedores track by $index\"><a ng-click=\"vm.moveOTState(dp,container,newcontainer,principal,1)\" ng-if=\"newcontainer.tablero != container.tablero\">{{newcontainer.tablero}}</a></li></ul></li><li><a ng-click=\"vm.getPDF(dp.id)\" class=\"\">Ver PDF</a></li></ul></div></div><div ng-repeat=\"de in container.details_endoso track by $index\"><div class=\"col-xs-12 box-content\"><button type=\"button\" class=\"btn btn-secondary btn-sm dropdown-toggle pull-right\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <b>OT ENDOSO: {{de.internal_number}} - {{de.policy.contractor}}</b><h6>{{de.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{de.end_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</h6><h6><b>{{de.policy.ramo}}</b></h6><h6><b>{{de.policy.subramo}}</b></h6><h6 class=\"pull-right\"><b>Hace {{de.antiguedad}}d.</b></h6><ul class=\"dropdown-menu dropdown-menu-right\"><li><a class=\"btn btn-white btn-sm\" ng-click=\"gotToInfo(de,container,$index,2)\"><i class=\"fa fa-info\" aria-hidden=\"true\"></i> Ir</a></li><li class=\"dropdown-submenu\" ng-if=\"principal.contenedores.length\"><a>Mover a</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"principal.contenedores\"><a class=\"disabled\">Estados</a></li><li ng-if=\"principal.contenedores\" ng-repeat=\"newcontainer in principal.contenedores track by $index\"><a ng-click=\"vm.moveOTState(de,container,newcontainer,principal,2)\" ng-if=\"newcontainer.tablero != container.tablero\">{{newcontainer.tablero}}</a></li></ul></li><li><a ng-click=\"getPDFE(de)\" class=\"\">Ver PDF</a></li></ul></div></div></div></th></tr></thead></table><table class=\"table\" ng-if=\"filtrado\"><thead><tr><th ng-repeat=\"filter_cn in resultsFilter track by $index\" ng-if=\"resultsFilter.length>0 && filter_cn.tablero\"><div class=\"col-xs-12 box-title\" style=\"background-color: {{filter_cn.color}}\"><a class=\"btn btn-white btn-sm pull-right\" ng-click=\"vm.editContainer(filter_cn,$index)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a><label class=\"label-tablero\">{{filter_cn.tablero}}</label> <span class=\"label-number\">OT Póliza(s): {{filter_cn.details_polizas.length}} // OT Endoso(s): {{filter_cn.details_endoso.length}}</span></div><div class=\"caption\"><div ng-repeat=\"dpf in filter_cn.details_polizas track by $index\"><div class=\"col-xs-12 box-content\"><button type=\"button\" class=\"btn btn-secondary btn-sm dropdown-toggle pull-right\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <b>OT PÓLIZA: {{dpf.internal_number}} - {{dpf.contractor}}</b><h6>{{dpf.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{dpf.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}</h6><h6><b>{{dpf.ramo}}</b></h6><h6><b>{{dpf.subramo}}</b></h6><h6 class=\"pull-right\"><b>Hace {{dpf.antiguedad}}d.</b></h6><ul class=\"dropdown-menu dropdown-menu-right\"><li><a class=\"btn btn-white btn-sm\" ng-click=\"gotToInfo(dpf,filter_cn,$index,1)\"><i class=\"fa fa-info\" aria-hidden=\"true\"></i> Ir</a></li><li class=\"dropdown-submenu\" ng-if=\"principal.contenedores.length\"><a>Mover a</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"principal.contenedores\"><a class=\"disabled\">Estados</a></li><li ng-if=\"principal.contenedores\" ng-repeat=\"newcontainer in principal.contenedores track by $index\"><a ng-click=\"vm.moveOTStateFilter(dpf,filter_cn,newcontainer,principal,1)\" ng-if=\"newcontainer.tablero != filter_cn.tablero\">{{newcontainer.tablero}}</a></li></ul></li><li><a ng-click=\"vm.getPDF(dpf.id)\" class=\"\">Ver PDF</a></li></ul></div></div><div ng-repeat=\"def in filter_cn.details_endoso track by $index\"><div class=\"col-xs-12 box-content\"><button type=\"button\" class=\"btn btn-secondary btn-sm dropdown-toggle pull-right\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <b>OT ENDOSO: {{def.internal_number}} - {{def.policy.contractor}}</b><h6>{{def.init_date | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{def.end_date | date: \'dd/MM/yyyy\' : \'UTC\'}}</h6><h6><b>{{def.policy.ramo}}</b></h6><h6><b>{{def.policy.subramo}}</b></h6><h6 class=\"pull-right\"><b>Hace {{def.antiguedad}}d.</b></h6><ul class=\"dropdown-menu dropdown-menu-right\"><li><a class=\"btn btn-white btn-sm\" ng-click=\"gotToInfo(def,filter_cn,$index,2)\"><i class=\"fa fa-info\" aria-hidden=\"true\"></i> Ir</a></li><li class=\"dropdown-submenu\" ng-if=\"principal.contenedores.length\"><a>Mover a</a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=\"disabled\" ng-if=\"principal.contenedores\"><a class=\"disabled\">Estados</a></li><li ng-if=\"principal.contenedores\" ng-repeat=\"newcontainer in principal.contenedores track by $index\"><a ng-click=\"vm.moveOTStateFilter(def,filter_cn,newcontainer,principal,2)\" ng-if=\"newcontainer.tablero != filter_cn.tablero\">{{newcontainer.tablero}}</a></li></ul></li><li><a ng-click=\"getPDFE(def)\" class=\"\">Ver PDF</a></li></ul></div></div></div></th></tr></thead></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tasks/task.admin.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-6\"><h2>Tareas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>AdminTareas</strong></li></ol></div></div><br><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Administrador de tareas</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group\"><label>Usuario</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_created_by\" data-ng-options=\"(users.first_name + \' \' + users.last_name) for users in vm.users | orderBy: \'username\' track by users.url\" ng-change=\"selectCreatedBy(select_created_by)\"><option value=\"\"></option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-rigth\"><button class=\"btn btn-success col-xs-12\" ng-click=\"save()\">Guardar</button></div></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend align=\"center\">Usuarios</legend></div><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered\"><thead><tr><th>Nombre</th></tr></thead><tbody><tr ng-repeat=\"user in vm.users_selected\"><td>{{ user.first_name }} {{ user.last_name }}</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/tasks/task.createot.modal.html","<div class=\"inmodal\" id=\"modal_in\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">{{title}} Completa Ligar a OT</h4></div><div class=\"modal-body\"><div class=\"col-xs-4 form-group\" ng-if=\"vm.form.model != 7\"><button class=\"btn btn-primary\" ng-click=\"goToRegis()\">Regresar</button></div><div class=\"col-xs-4 form-group\" ng-if=\"vm.form.model != 7\"><p>{{track_task_id}}</p></div><div class=\"col-xs-4 form-group\" ng-if=\"vm.form.model != 7\"><p>{{track_task_entity_number}}</p></div><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Título <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"title\" ng-model=\"vm.form.title\" disabled=\"\"></div><div class=\"col-xs-6 form-group\"><label>Asignar a: <span class=\"red-color\">*</span></label><select class=\"form-control\" disabled=\"\" ng-model=\"vm.form.assigned\" data-ng-options=\"vendedor.first_name + \' \' + vendedor.last_name for vendedor in users | orderBy: \'first_name\' track by vendedor.url\" ng-change=\"vm.changeAssigned(vm.form.assigned)\"><option value=\"\">Seleccione</option></select></div><div class=\"col-xs-6 form-group\"><label>Fecha compromiso<span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input disabled=\"\" type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"vm.form.compromiso\" value=\"{{vm.form.compromiso}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-6 form-group\"><label>Involucrados</label><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"col-xs-12\"><select disabled=\"\" id=\"select_user\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"user.first_name + \' \' + user.last_name for user in users | orderBy: \'first_name\' track by user.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div></div><div class=\"col-xs-6 form-group\"><label>Concepto <span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.concept\" disabled=\"\" data-ng-options=\"concept.name for concept in concepts | orderBy: \'name\' track by concept.id\" ng-change=\"vm.changeConcept(vm.form.concept)\"><option value=\"\">Seleccione</option></select></div><div class=\"col-xs-12 form-group\"><label>Descripción <span class=\"red-color\">*</span></label> <textarea disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.form.descrip\"></textarea></div><div class=\"col-xs-12 form-group\" ng-if=\"ticket1.concept ==2\"><label>Tipo de OT <span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.tipo_ot\" data-ng-options=\"tipo_ot.name for tipo_ot in selectedOTOptions | orderBy: \'name\' track by tipo_ot.id\" ng-change=\"vm.changeOTSelected(vm.form.tipo_ot)\"><option value=\"\">Seleccione</option></select></div><div class=\"text-align-center col-xs-12 form-group\" ng-if=\"ticket1.concept ==1\"><label class=\"color-blue\">Formulario de Cotización</label></div><div class=\"text-align-center col-xs-12 form-group\" ng-if=\"ticket1.concept ==3\"><label class=\"color-blue\">Formulario de Endoso (A)</label> <label>Tipo de Póliza <span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.tipo_ot_p\" data-ng-options=\"tipo_ot_p.name for tipo_ot_p in selectedEndosoOptions | orderBy: \'name\' track by tipo_ot_p.id\" ng-change=\"vm.changeOTSelected(vm.form.tipo_ot_p)\"><option value=\"\">Seleccione</option></select></div><div class=\"text-align-center col-xs-12 form-group\" ng-if=\"ticket1.concept ==10\"><label class=\"color-blue\">Formulario de Endoso (B)</label> <label>Tipo de Póliza <span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.tipo_ot_p\" data-ng-options=\"tipo_ot_p.name for tipo_ot_p in selectedEndosoOptions | orderBy: \'name\' track by tipo_ot_p.id\" ng-change=\"vm.changeOTSelected(vm.form.tipo_ot_p)\"><option value=\"\">Seleccione</option></select></div><div class=\"text-align-center col-xs-12 form-group\" ng-if=\"ticket1.concept ==11\"><label class=\"color-blue\">Formulario de Endoso (D)</label> <label>Tipo de Póliza <span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.tipo_ot_p\" data-ng-options=\"tipo_ot_p.name for tipo_ot_p in selectedEndosoOptions | orderBy: \'name\' track by tipo_ot_p.id\" ng-change=\"vm.changeOTSelected(vm.form.tipo_ot_p)\"><option value=\"\">Seleccione</option></select></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-if=\"vm.form.id\" ng-click=\"goToCapture(vm.form)\">Ir a capturar OT</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Cerrar</button></div><script type=\"text/javascript\">\n	$(\'#select_user\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n  $(\'#select_email_system\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n  $(\'#select_email_manual\').select2({\n        dropdownParent: $(\'#modal_in\'),\n    });\n  $(\".js-example-tokenizer\").select2({\n      tags: true,\n      tokenSeparators: [\',\', \' \']\n  })\n\n  $(\'#select_email_manual\').select2({\n       tags: true,\n       multiple: true,\n       tokenSeparators: [\",\", \" \"],       \n       placeholder: {\n          // id: -1,\n          text: \"example@some,\",\n       }\n  });\n</script><script type=\"text/javascript\">  \n  // $(window).load(function() { $(\"#state\").select2(); });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script></div>");
$templateCache.put("app/tasks/task.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-6\"><h2>Tareas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Tareas</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-success col-xs-12\" ng-click=\"addTaskOK()\">Agregar tarea</button></div><div ng-show=\"show_task\" class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Nueva Tarea</legend><form class=\"row\" name=\"form\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Titulo<span class=\"red-color\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.title\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{\'has-error\': form.assigned.$touched && form.assigned.$invalid}\"><label>Asignar a <span class=\"red-color\">*</span></label><select name=\"assigned\" class=\"form-control\" ng-model=\"vm.form.assigned_url\" ng-options=\"u.url as (u.first_name + \' \' + u.last_name) for u in users track by u.url\" ng-required=\"true\"><option value=\"\">Seleccione un usuario</option></select><div class=\"help-block\" ng-if=\"form.assigned.$touched && form.assigned.$error.required\">Requerido</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Involucrados</label><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"col-xs-12\"><select id=\"select_user\" style=\"width: 100%;\" class=\"js-example-basic-multiple2 form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"user.first_name + \' \' + user.last_name for user in users track by user.url\" ng-change=\"selectUser(select_user)\"></select></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Fecha de compromiso<span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"vm.form.compromiso\" value=\"{{vm.form.compromiso}}\" ng-change=\"vm.saveLocalstorange()\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Prioridad<span class=\"red-color\">*</span></label><select class=\"form-control\" name=\"priority\" ng-model=\"vm.form.priority_int\" ng-options=\"priority.id as priority.name for priority in priorities | orderBy:\'name\'\" ng-change=\"vm.changePriority(vm.form.priority_int)\" required=\"\"><option value=\"\">Seleccione una prioridad</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Concepto<span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.concept\" ng-options=\"concept.id as concept.name for concept in concepts | orderBy:\'name\'\" ng-change=\"vm.changeConcept(vm.form.concept)\" required=\"\"><option value=\"\">Seleccione un concepto</option></select></div><div class=\"col-xs-12 form-group\"><label>Descripción<span class=\"red-color\">*</span></label> <textarea type=\"text\" class=\"form-control\" ng-model=\"vm.form.descrip\" required=\"\" ng-change=\"vm.saveLocalstorange()\"></textarea></div><div class=\"col-xs-12\"><div><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"ibox-content\" ng-show=\"vm.form.id\"><div class=\"row\" ng-include=\"\'templates/show-files.html\'\"></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-primary ladda-button\" ng-disabled=\"form.$invalid\" ng-click=\"saveTask(vm.form)\">Crear Tarea</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right m-t\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"show_task = false\">Cancelar</button></div></form><div class=\"col-xs-12\"><hr></div></div></div><div class=\"row\"><div class=\"col-xs-6 form-group\" ng-enter=\"getTickets(7, chain)\"><label>Buscar:</label><div class=\"col-xs-12 input-group\"><input class=\"form-control\" placeholder=\"Buscar en todas las tareas (Enter para buscar)\" ng-model=\"chain\" type=\"text\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"getTickets(7, chain)\">Buscar</button></div></div></div><div class=\"col-xs-6 form-group\" ng-enter=\"getTickets(7, chain)\"><label>Buscar por usuario:</label><div class=\"col-xs-12 input-group\"><div class=\"col-xs-12\"><select id=\"select_user\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"selected_user\" data-ng-options=\"user.first_name + \' \' + user.last_name for user in users | orderBy: \'first_name\' track by user.url\"><option value=\"\"></option></select></div><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"getTickets(7, chain)\">Buscar</button></div></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Prioridad:</label><select class=\"form-control\" ng-model=\"vm.form.priority\" data-ng-options=\"priority.name for priority in priorities | orderBy: \'name\' track by priority.id\" ng-change=\"getTickets(vm.form.priority.id)\" required=\"\"><option value=\"\">Seleccione una prioridad</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Estatus:</label><select class=\"form-control\" ng-model=\"vm.form.status\" data-ng-options=\"priority.name for priority in statusTask | orderBy: \'name\' track by priority.id\" ng-change=\"getTickets(vm.form.priority.id)\" required=\"\"><option value=\"\">Seleccione un estatus</option></select></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Ver:</label><select class=\"form-control\" ng-model=\"vm.form.ver\" data-ng-options=\"priority.name for priority in seeTask | orderBy: \'name\' track by priority.id\" ng-change=\"getTickets(vm.form.priority.id)\" required=\"\"><option value=\"\">Seleccione un estatus</option></select></div><div class=\"col-xs-12 form-group\"></div><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\" ng-show=\"!show_comment\"><thead><tr><th>Estatus</th><th>Folio</th><th>Título</th><th>Fecha promesa <span class=\"pull-right\"><input type=\"checkbox\" name=\"\" ng-model=\"fechahoy\" ng-click=\"getTickets(7, chain,1,1,fechahoy)\">Solo de hoy</span></th><th>Prioridad</th><th>Concepto</th><th>Antigüedad</th><th>Dias de creación al cierre</th><th>Usuario que reasignó</th><th>Fecha de reasignación</th><th>Usuario asignado</th><th>Creador</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"ticket in tickets track by $index\" ng-click=\"openModal(ticket)\" ng-class=\"{\'alert-warning\' : ticket.up_date < 3 }\"><td><span ng-if=\"!ticket.closed\">Abierta</span> <span ng-if=\"ticket.closed\">Cerrada</span></td><td>{{ ticket.identifier }}</td><td>{{ ticket.title }}</td><td>{{ ticket.date | date: \'dd/MM/yyyy\': \'UTC\' }}</td><td><div class=\"label priority\" ng-class=\"{\'label-success\': ticket.closed, \'label-danger\' : ticket.priority == 1 && !ticket.closed, \'label-warning\' : ticket.priority == 2 && !ticket.closed, \'label-info\' : ticket.priority == 3 && !ticket.closed }\"><span ng-if=\"ticket.priority == 1 && !ticket.closed\">Alta</span> <span ng-if=\"ticket.priority == 2 && !ticket.closed\">Media</span> <span ng-if=\"ticket.priority == 3 && !ticket.closed\">Baja</span> <span ng-if=\"ticket.priority == 1 && ticket.closed\">Hecho/Alta</span> <span ng-if=\"ticket.priority == 2 && ticket.closed\">Hecho/Media</span> <span ng-if=\"ticket.priority == 3 && ticket.closed\">Hecho/Baja</span></div></td><td>{{conceptTicket(ticket.concept)}}</td><td>{{ ticket.antiguedad }} días</td><td>{{ ticket.contador_dias_cierre }}</td><td>{{ ticket.reassignBy }}</td><td>{{ ticket.reassign_date | date: \'dd/MM/yyyy\': \'UTC\' }}</td><td><img ng-src=\"{{ ticket.image }}\" class=\"w-i\">{{ticket.assigned.first_name}} {{ticket.assigned.last_name}}</td><td>{{ ticket.owner.first_name }} {{ ticket.owner.last_name }}</td><td><a ng-if=\"!ticket.closed\" class=\"btn btn-white btn-sm\" href=\"\" ng-click=\"$event.stopPropagation(); Complete(ticket, $index)\" title=\"Cerrar tarea\"><i class=\"fa fa-times-circle\"></i></a> <a ng-if=\"ticket.closed\" class=\"btn btn-white btn-sm\" href=\"\" ng-click=\"$event.stopPropagation(); Complete(ticket, $index)\" title=\"Abrir tarea\"><i class=\"fa fa-folder-open\"></i></a> <a class=\"btn btn-white btn-sm\" href=\"\" ng-if=\"!ticket.archived\" ng-click=\"$event.stopPropagation(); archiveTask(ticket)\" title=\"Archivar tarea\"><i class=\"fa fa-archive\"></i></a> <a class=\"btn btn-white btn-sm\" href=\"\" ng-click=\"$event.stopPropagation(); getLog(ticket)\" title=\"Log de tarea\"><i class=\"fa fa-history\"></i></a> <a class=\"btn btn-info btn-sm\" title=\"Crear Recordatorio\" ng-click=\"$event.stopPropagation();vm.createRecordatorio(ticket,22)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" href=\"\" ng-if=\"ticket.closed && !ticket.ot_id_reference && (ticket.concept==1 || ticket.concept==2 || ticket.concept==11 || ticket.concept==3 || ticket.concept==10)\" ng-click=\"$event.stopPropagation();createOT(ticket)\"><i class=\"fa fa-external-link\" aria-hidden=\"true\" title=\"Crear OT\"></i></a> <a class=\"btn btn-danger btn-sm\" href=\"\" ng-if=\"ticket.closed && ticket.ot_id_reference && (ticket.concept==1 || ticket.concept==2 || ticket.concept==11 || ticket.concept==3 || ticket.concept==10)\" ng-click=\"$event.stopPropagation();irOT(ticket)\"><i class=\"fa fa-eye\" aria-hidden=\"true\" title=\"Información OT\"></i></a></td></tr></tbody></table><div ng-if=\"show_comment && !radio.closed\"><div class=\"row\"><div class=\"col-xs-12\" align=\"center\"><legend class=\"legend-title\" align=\"center\">Cerrar tarea</legend></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"closeComment()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div></div><div class=\"col-xs-12 bab\"><br><label>Título: {{ radio.title }}</label><div class=\"col-xs-12\"><span><i class=\"fa fa-edit\" style=\"padding: 13px;\"></i> Agregue un comentario de cierre</span><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"22\" idmodel=\"vm.polizaId\" exportable=\"true\"></comments></div></div></div></div><div ng-if=\"show_comment && radio.closed\"><div class=\"row\"><div class=\"col-xs-12\" align=\"center\"><legend class=\"legend-title\" align=\"center\">Esta tarea ya esta cerrada.</legend></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12\" ng-click=\"closeComment()\"><i class=\"fa fa-reply\" aria-hidden=\"true\"></i> Regresar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-warning col-xs-12\" ng-click=\"openTask(radio)\"><i class=\"fa fa-folder-open-o\" aria-hidden=\"true\"></i> Abrir Tarea</button></div></div></div><div ng-if=\"show_pag_task\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"col-xs-12 col-sm-6 col-md-3 m-t pull-right\" ng-if=\"tickets.length > 0\"><button class=\"btn btn-primary col-xs-12\" ng-click=\"exportToExcel(tickets,fechahoy)\">Exportar a excel</button></div></div></div>");
$templateCache.put("app/tasks/task.modal.html","<div class=\"inmodal\" id=\"modal_in\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">{{title}}</h4></div><div class=\"modal-body\"><div class=\"col-xs-4 form-group\" ng-if=\"vm.form.model == 7 && !desdeOT\"><button class=\"btn btn-primary\" ng-click=\"goToRegis()\">Ver {{ origin_task }}</button></div><div class=\"col-xs-4 form-group\" ng-if=\"vm.form.model != 7 && !desdeOT\"><button class=\"btn btn-primary\" ng-click=\"goToRegis()\">Ver {{ origin_task }}</button></div><div class=\"col-xs-4 form-group\" ng-if=\"vm.form.model != 7 && !desdeOT\" \"=\"\"><p>{{track_task_id}}</p></div><div class=\"col-xs-4 form-group\" ng-if=\"vm.form.model != 7 && !desdeOT\" \"=\"\"><p>{{track_task_entity_number}}</p></div><a class=\"btn btn-info btn-sm pull-right\" title=\"Crear Recordatorio\" ng-click=\"$event.stopPropagation();createRecordatorio(vm.form,22)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></a><div class=\"row\"><div class=\"col-xs-12 form-group\"><label>Titulo <span class=\"red-color\">*</span></label> <input class=\"form-control\" name=\"title\" ng-model=\"vm.form.title\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{\'has-error\': form.assigned.$touched && form.assigned.$invalid}\"><label>Asignar a <span class=\"red-color\">*</span></label><select name=\"assigned\" class=\"form-control\" ng-model=\"vm.form.assigned\" ng-options=\"v as (v.first_name + \' \' + v.last_name) for v in users | orderBy:\'first_name\' track by v.url\" ng-change=\"vm.changeAssigned(vm.form.assigned)\" ng-required=\"true\"><option value=\"\">Seleccione un usuario</option></select><div class=\"help-block\" ng-if=\"form.assigned.$touched && form.assigned.$error.required\">Requerido</div></div><div class=\"col-xs-6 form-group\"><label>Fecha compromiso<span class=\"red-color\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"vm.form.compromiso\" value=\"{{vm.form.compromiso}}\" data-date-format=\"dd/mm/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-6 form-group\"><label>Involucrados</label><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"col-xs-12\"><select id=\"select_user\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_user\" data-ng-options=\"user.first_name + \' \' + user.last_name for user in users | orderBy: \'first_name\' track by user.url\" ng-change=\"selectUser(select_user)\"><option value=\"\"></option></select></div></div><div class=\"col-xs-6 form-group\"><label>Prioridad <span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.priority\" data-ng-options=\"priority.name for priority in priorities | orderBy: \'name\' track by priority.id\" ng-change=\"vm.changePriority(vm.form.priority)\"><option value=\"\">Seleccione</option></select></div><div class=\"col-xs-6 form-group\"><label>Concepto <span class=\"red-color\">*</span></label><select class=\"form-control\" ng-model=\"vm.form.concept\" data-ng-options=\"concept.name for concept in concepts | orderBy: \'name\' track by concept.id\" ng-change=\"vm.changeConcept(vm.form.concept)\"><option value=\"\">Seleccione</option></select></div><div class=\"col-xs-12 form-group\"><label>Descripción <span class=\"red-color\">*</span></label> <textarea type=\"text\" class=\"form-control\" ng-model=\"vm.form.descrip\"></textarea></div></div><div class=\"col-xs-12 form-group\"><button type=\"button\" class=\"btn btn-secondary m-r-sm\" ng-click=\"vm.showRecordatorios()\">{{vm.form.recordatorios.length}}</button><span class=\"blue-color\">Recordatorios</span></div><div class=\"ibox float-e-margins animate m-t\" ng-if=\"vm.recordatoriosFlag\"><div class=\"ibox-title\"><h5>Recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-info m-b\" ng-click=\"vm.recordatoriosFlag = false; vm.infoFlag = true\"><span class=\"fa fa-reply\"></span> Regresar</button><table class=\"table table-hover table-bordered\"><thead><th>Recordatorio ID</th><th>Resumen</th><th>Descripción</th><th>Fecha programada</th><th>Hora programada</th><th>Vista</th></thead><tr ng-repeat=\"reco in ticket1.recordatorios track by $index\" ng-click=\"goToRecordatorio(reco, $index)\"><td>{{ reco.recordatorio.id }}</td><td>{{ reco.recordatorio.nombre}}</td><td>{{ reco.recordatorio.descr }}</td><td>{{ reco.recordatorio.fecha_programada | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td>{{ reco.recordatorio.hora_programada | date: \'h:mm:ss a\' : \'UTC\'}}</td><td ng-class=\"{\'label-info\' : reco.seen }\" ng-if=\"reco.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !reco.seen }\" ng-if=\"!reco.seen\">No visto</td></tr></table></div></div><div class=\"row\"><div ng-include=\"\'templates/upload.html\'\"></div></div><div class=\"ibox-content\" ng-if=\"vm.form.id\"><div class=\"row\" ng-include=\"\'templates/show-files.html\'\"></div></div><br><div class=\"row\" ng-if=\"vm.form.title\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Bitácora</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><comments datasource=\"vm.comments_data\" config=\"vm.comments_config\" typemodel=\"22\" idmodel=\"vm.polizaId\"></comments></div></div></div></div></div></div><button class=\"btn btn-primary\" ng-show=\"vm.form.id && !historic_email\" ng-click=\"send_historic_email()\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> Envíar histórico por email</button><div class=\"row\"><div class=\"col-xs-12 col-lg-12 form-group text-center\" ng-show=\"historic_email\"><input name=\"email_x\" ng-value=\"1\" ng-model=\"email_x\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"email_x\">Manual</span><br><div class=\"col-xs-12 col-lg-12 form-group\" ng-show=\"email_x == \'1\' && historic_email\"><div class=\"col-xs-12 col-lg-12\"><select id=\"select_email_manual\" data-placeholder=\"example@something.com,\" class=\"form-control col-xs-12 col-lg-12\" style=\"width: 100%;\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_email_manual\" ng-change=\"selectManualEmails(select_email_manual)\"><option></option></select></div></div><br><hr><input name=\"email_x\" ng-value=\"2\" ng-model=\"email_x\" type=\"radio\" class=\"ng-valid ng-dirty ng-touched\"><span for=\"email_x\">Sistema</span><br><div class=\"col-xs-8 form-group\" ng-show=\"emails_users.length > 0 && historic_email && email_x == \'2\'\"><div class=\"col-xs-12 form-group\"><label>Correos de Usuarios del Sistema</label><br><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"col-xs-12\"><select id=\"select_email_system\" style=\"width: 100%;\" class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_email\" data-ng-options=\"email for email in emails_users | orderBy: email\" ng-change=\"changeEmailSendH(select_email)\"><option value=\"\"></option></select></div></div></div></div><br><div class=\"col-xs-4\"><button class=\"btn btn-primary ladda-button\" ng-if=\"vm.form.id && historic_email\" ng-click=\"send_historic(vm.form)\" ng-disabled=\"(!vm.emails_selected_manual && email_x == 1) || (email_x == 2 && vm.emails_selected.length == 0)\"><i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i> Envíar</button></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-if=\"vm.form.id\" ng-click=\"updateTask(vm.form)\">Actualizar</button> <button class=\"btn btn-primary\" ng-if=\"!vm.form.id\" ng-click=\"saveTask(vm.form)\">Guardar</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Cerrar</button></div><script type=\"text/javascript\">\n	$(\'#select_user\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n  $(\'#select_email_system\').select2({\n        dropdownParent: $(\'#modal_in\')\n    });\n  $(\'#select_email_manual\').select2({\n        dropdownParent: $(\'#modal_in\'),\n    });\n  $(\".js-example-tokenizer\").select2({\n      tags: true,\n      tokenSeparators: [\',\', \' \']\n  })\n\n  $(\'#select_email_manual\').select2({\n       tags: true,\n       multiple: true,\n       tokenSeparators: [\",\", \" \"],       \n       placeholder: {\n          // id: -1,\n          text: \"example@some,\",\n       }\n  });\n</script><script type=\"text/javascript\">  \n  // $(window).load(function() { $(\"#state\").select2(); });\n  // angular.element(document).ready(function(){\n  //   $(\'.js-example-basic-multiple\').select2();\n  // });\n</script></div>");
$templateCache.put("app/testing/testing.html","<div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Modificar Estatus</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><button class=\"btn btn-defaul\" ng-click=\"vm.cli()\">:D</button><p>Canvas:</p><canvas id=\"imgCanvas\" width=\"240\" height=\"297\" style=\"border:1px solid #d3d3d3;\">Your browser does not support the HTML5 canvas tag.</canvas><div class=\"row\"><div ng-include=\"\'templates/template.formulario.vida.html\'\"></div></div><div class=\"row\"><div ng-include=\"\'templates/template.formulario.accidentes.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/colectividades/templates/categories.html","<toaster-container></toaster-container><div class=\"ibox float-e-margins\"><div class=\"ibox-content animate-if\"><div class=\"row\"><form name=\"categories_form\"><div class=\"col-xs-12\" align=\"center\"><h2 class=\"legend-title\">Por favor indique si desea agregar categorias</h2></div><div class=\"col-xs-6\"><div ng-if=\"!categoria_result || not_category || show_cat_again\"><button class=\"btn btn-danger pull-right ladda-button\" ng-click=\"NotCategories()\"><i class=\"glyphicon glyphicon-remove\"></i> Sin Categoría</button></div></div><div class=\"col-xs-6\"><div ng-if=\"!order.subgroup.length && subgrupoResult.name !== \'Default\'\"><button class=\"btn btn-success\" ng-click=\"existCategoria(1)\"><i class=\"glyphicon glyphicon-plus\"></i> Agregar Categoría</button></div></div><div class=\"col-xs-12\" ng-if=\"exist_category\"><legend class=\"legend-title\" align=\"center\">Datos de la categoría</legend><div><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{ \'has-error\': categories_form.category.subgroup.$invalid && !categories_form.category.subgroup.$pristine }\"><label>Subgrupo<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"category.subgroup\" ng-options=\"item as item.name for item in sub_group\" ng-change=\"selectSubgroup(category.subgroup)\" required=\"\"><option value=\"\" disabled=\"\">Selecciona un subgrupo</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{ \'has-error\': categories_form.category.$invalid && !categories_form.category.$pristine }\"><label>Nombre<span class=\"color-red\">*</span></label> <input type=\"text\" class=\"form-control\" name=\"category\" ng-model=\"category.name\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{ \'has-error\': categories_form.description.$invalid && !categories_form.description.$pristine }\"><label>Descripción<span class=\"color-red\">*</span></label> <textarea type=\"text\" class=\"form-control\" name=\"description\" ng-model=\"category.observations\" required=\"\"></textarea></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"!autos\" ng-class=\"{ \'has-error\': categories_form.category_h.$invalid && !categories_form.category_h.$pristine }\"><label>Nivel Hospitalario<span class=\"color-red\">*</span></label> <input type=\"text\" class=\"form-control\" name=\"category_h\" ng-model=\"category.hospital_level\" required=\"\"></div></div></div><div class=\"col-xs-12\" ng-if=\"exist_category\"><button class=\"btn btn-danger pull-right ladda-button\" ng-click=\"existCategoria(2)\">Cancelar</button> <button class=\"btn btn-success pull-right ladda-button m-r\" ng-click=\"saveCategory(\'add\')\" ng-disabled=\"categories_form.$invalid\">Guardar Categoría</button></div></form><div class=\"col-xs-12 col-sm-6\" ng-if=\"exist_category\"><legend class=\"legend-title\" ng-if=\"subgrupoResult.name !== \'Default\'\">Subgrupos y Categorias creados</legend><legend class=\"legend-title\" ng-if=\"subgrupoResult.name == \'Default\' && categoria_result.name !== \'Default\'\">Categorías</legend><label class=\"text-center\" ng-if=\"subgrupoResult.name == \'Default\' && categoria_result.name !== \'Default\'\">Categorías</label><div ng-repeat=\"item in tree_subs\"><ul class=\"todo-list m-t small-list\"><li ng-init=\"show_cat[$index] = true\" ng-click=\"show_cat[$index] ? show_cat[$index] = false : show_cat[$index] = true; selectSubgroup(item.data);\" ng-class=\"{\'package-selected\': item.data.id == subgrupoResult.id}\" class=\"subgroup-item\"><span class=\"m-l-xs\">{{item.text}}</span></li><ul ng-if=\"show_cat[$index]\" class=\"todo-list m-t small-list\"><li class=\"category-item\" ng-repeat=\"cat in item.nodes\"><i class=\"fa fa-long-arrow-right\" aria-hidden=\"true\"></i> &nbsp;{{cat.text}}</li></ul></ul></div></div></div></div></div>");
$templateCache.put("app/colectividades/templates/certificados.html","<toaster-container></toaster-container><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"!loader\"><label>Archivo Excel</label> <input type=\"file\" fileread=\"\" ng-model=\"excelFile\" name=\"readCsvFile\" id=\"readCsvFile\" ng-change=\"selectExcel(excelFile)\"></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"!id_tree\"><div class=\"form-group\"><label>Contenido del archivo</label><div id=\"tree\" class=\"treeview\"></div></div></div><div class=\"col-xs-12 col-md-6 form-group\"><div id=\"tree_ids\" class=\"treeview\"></div></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"config_saved.length\"><table class=\"table table-bordered table-hover\"><thead><th>Número de Paquete</th><th>Nombre</th></thead><tbody><tr ng-repeat=\"item in config_saved\"><td>{{item.id}}</td><td>{{item.package_name}}</td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12\" ng-if=\"!loader\"><button class=\"btn btn-success pull-right\" ng-click=\"saveCertificados()\">Finalizar</button></div><div class=\"col-xs-12 text-center\" ng-if=\"loader\"><i class=\"fa fa-cogs fa-spin fa-5x\"></i><div><span>Espere unos minutos</span></div></div></div></div></div></div>");
$templateCache.put("app/colectividades/templates/crear-ot.html","<div class=\"row wrapper wrapper-content animated fadeIn ng-scope no-padding\" ng-if=\"!show_contractor\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"OT\" ng-click=\"order.hideButtonOT()\" ng-if=\"order.acceso_adm_ot\"><div ng-include=\"\" src=\"\'app/colectividades/templates/ordenes.html\'\"></div></uib-tab><uib-tab index=\"1\" heading=\"Póliza\" ng-click=\"order.showButtonPoliza()\" ng-if=\"order.acceso_adm_pol\"><div ng-include=\"\" src=\"\'app/colectividades/templates/ordenes.html\'\"></div></uib-tab></uib-tabset></div></div></div></div><div ng-if=\"show_contractor\" class=\"animate z-index-9000\"><div><ng-include src=\"\'app/contratantes/contratantes.add.html\'\" ng-controller=\"ContratantesCtrl as vm\"></ng-include></div></div>");
$templateCache.put("app/colectividades/templates/ordenes.html","<toaster-container></toaster-container><div class=\"pull-right option_button m-b\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-bolt\" aria-hidden=\"true\"></i> Opciones</button><ul class=\"dropdown-menu dropdown-menu-right\" ng-if=\"order.acceso_form\"><li class=\"dropdown-submenu\"><a>Descargar layouts</a><ul class=\"dropdown-menu dropdown-menu-right\"><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Col_Flotillas.xls\">Flotillas</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Col_GM.xls\">Gastos médicos</a></li><li><a href=\"https://s3.amazonaws.com/miurabox/layouts/Layout_Col_Vida.xls\">Vida</a></li></ul></li></ul></div></div><div class=\"ibox-content\" ng-show=\"showContent\"><form onkeypress=\"if(event.keyCode == 13) event.returnValue = false;\"><div class=\"row\"><form name=\"caratula_form\"><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{ \'has-error\': caratula_form.identifier.$invalid && !caratula_form.identifier.$pristine }\"><label for=\"identifier\">Identificador<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"identifier\" type=\"text\" ng-model=\"order.form.identifier\" ng-change=\"changeIdentifier(order.form.identifier)\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"folio-intenero\">Folio Interno</label> <input class=\"form-control\" name=\"folio-intenero\" disabled=\"\" type=\"text\" value=\"{{order.form.internal_number}}\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"!order.show.ot\"><label for=\"folio\">Folio</label> <input class=\"form-control\" name=\"folio\" type=\"text\" ng-model=\"order.form.folio\"></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"!order.show.ot\" ng-class=\"{ \'has-error\': caratula_form.poliza.$invalid && !caratula_form.poliza.$pristine }\"><label for=\"poliza\">Número de Póliza<span class=\"color-red\">*</span></label> <input class=\"form-control\" name=\"poliza\" ng-model=\"order.form.poliza\" ng-blur=\"checkNumPolicy()\" type=\"text\" ng-trim=\"false\" required=\"\"></div><div class=\"col-xs-12 col-md-6 form-group\"><label class=\"control-label\">Contratante {{contrac.selected}}<span class=\"color-red\">*</span></label> {{order.form.contratante.val}}<div class=\"form-group\" ng-if=\"!order.acceso_adm_cont\" ng-class=\"{ \'has-error\': caratula_form.contratante.$invalid && !caratula_form.contratante.$pristine }\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" name=\"contratante\" model=\"order.form.contratante\" change=\"matchesContractors(order.form.contratante.val)\"></autocomplete><span class=\"input-group-btn\" ng-if=\"order.acceso_adm_cont\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"contratanteCreatorModalEvent(); show_contractor = true\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div><div class=\"input-group\" ng-if=\"order.acceso_adm_cont\" ng-class=\"{ \'has-error\': caratula_form.contratante.$invalid && !caratula_form.contratante.$pristine }\"><autocomplete datasource=\"contractors_data\" id=\"contractors\" name=\"contratante\" model=\"order.form.contratante\" change=\"matchesContractors(order.form.contratante.val)\"></autocomplete><span class=\"input-group-btn\" ng-if=\"order.acceso_adm_cont\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"contratanteCreatorModalEvent(); show_contractor = true\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.address.$invalid && !caratula_form.address.$pristine }\"><select class=\"form-control\" data-ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in order.defaults.address track by address.url\" ng-change=\"order.options.changeAddress(order.form.address)\" name=\"address\" ng-model=\"order.form.address\" ng-disabled=\"!order.form.contratante\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo electrónico</label> <input class=\"form-control\" name=\"correo\" ng-model=\"order.form.contratante.email\" type=\"email\" ng-disabled=\"!order.form.contratante || emailStatus\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono</label><phonenumber-directive model=\"order.form.contratante.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"inputValue\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Vigencia</label><div class=\"datepicker-me input-group date\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"order.form.startDate\" value=\"{{order.form.startDate}}\" ng-disabled=\"!order.form.contratante\" ng-change=\"checkDate()\" ng-init=\"checkDate(\'initial\')\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>al</label><div class=\"datepicker-me input-group date\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" id=\"endingDate\" data-provide=\"datepicker\" ng-model=\"order.form.endingDate\" value=\"{{order.form.endingDate}}\" ng-change=\"changeUntil_1()\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label>Aseguradora<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.aseguradora.$invalid && !caratula_form.aseguradora.$pristine }\"><select class=\"form-control\" data-ng-options=\"aseguradora.alias for aseguradora in order.defaults.providers | orderBy: \'alias\' track by aseguradora.url\" ng-change=\"aseguradoraSelection()\" name=\"aseguradora\" ng-model=\"order.form.aseguradora\" ng-disabled=\"!order.form.contratante\" required=\"\"><option value=\"\">Selecciona un proveedor</option></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Clave de agente<span class=\"color-red\">*</span></label><div ng-if=\"!order.defaults.claves.length\" ng-class=\"{ \'has-error\': caratula_form.clave.$invalid && !caratula_form.clave.$pristine }\"><input type=\"text\" name=\"clave\" placeholder=\"No hay ninguna clave para esta aseguradora\" class=\"form-control\" disabled=\"\"></div><div class=\"\" ng-if=\"order.defaults.claves.length == 1\" ng-init=\"order.form.clave = order.defaults.claves[0]\" ng-class=\"{ \'has-error\': caratula_form.clave_agente.$invalid && !caratula_form.clave_agente.$pristine }\"><input type=\"text\" name=\"clave_agente\" placeholder=\"Elige una aseguradora aseguradora\" class=\"form-control\" value=\"{{order.defaults.claves[0].clave +\' - \'+ order.defaults.claves[0].name}}\" disabled=\"\"></div><div ng-class=\"{ \'has-error\': caratula_form.clave1.$invalid && !caratula_form.clave1.$pristine }\"><select ng-if=\"order.defaults.claves.length > 1\" class=\"form-control\" data-ng-options=\"clave as clave.clave +\' - \'+clave.name for clave in order.defaults.claves | orderBy: \'clave\' track by clave.url\" ng-change=\"changeClave(order.form.clave)\" name=\"clave1\" ng-model=\"order.form.clave\" ng-disabled=\"!order.form.aseguradora\" required=\"\"><option value=\"\" disabled=\"\">Selecciona una clave de agente</option></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Ramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.ramo.$invalid && !caratula_form.ramo.$pristine }\"><select class=\"form-control\" data-ng-options=\"ramo.ramo_name for ramo in order.defaults.ramos track by ramo.url\" ng-change=\"changeRamo()\" name=\"ramo\" ng-model=\"order.form.ramo\" ng-disabled=\"!order.form.aseguradora\" required=\"\"><option value=\"\">Selecciona un ramo</option></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Subramo<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.subramo.$invalid && !caratula_form.subramo.$pristine }\"><select class=\"form-control\" data-ng-options=\"subramo.subramo_name for subramo in order.defaults.subramos track by subramo.url\" ng-change=\"changeSubramo()\" name=\"subramo\" ng-model=\"order.form.subramo\" ng-disabled=\"!order.form.ramo\" required=\"\"><option value=\"\">Selecciona un subramo</option></select></div></div><div class=\"col-xs-2 form-group\" ng-if=\"order.form.comision.comission && order.form.ceder_comision\"><label>Comisión (%)</label> <input class=\"form-control\" name=\"comision\" ng-model=\"order.form.comision_percent\" type=\"text\"></div><div class=\"col-xs-2 form-group\" ng-if=\"order.form.comision.udi && order.form.ceder_comision\"><label>Udi (%)</label> <input class=\"form-control\" name=\"udi\" ng-model=\"order.form.udi\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 col-md-4 form-group\"><label>Renovable<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.renewal.$invalid && !form.renewal.$pristine }\"><select class=\"form-control\" ng-init=\"order.renewal.selected = 1\" ng-options=\"renewal.value as renewal.label for renewal in order.renewal.options\" ng-change=\"renewalSelection()\" name=\"renewal\" ng-model=\"order.renewal.selected\" ng-disabled=\"!order.form.contratante\" required=\"\"></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Tipo de administración<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.adminType.$invalid && !caratula_form.adminType.$pristine }\"><select class=\"form-control\" ng-change=\"changeAdminType()\" name=\"adminType\" ng-model=\"order.adminType\" required=\"\"><option value=\"\">Selecciona un tipo de administración</option><option value=\"Autoadministrada\">Autoadministrada</option><option value=\"Simple\">Simplificada</option><option value=\"Detallada\">Detallada</option></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Frecuencia de pago<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': caratula_form.payment.$invalid && !caratula_form.payment.$pristine }\"><select class=\"form-control\" name=\"payment\" ng-model=\"order.form.payment\" ng-disabled=\"frec_disabled\" ng-change=\"isReceiptAvailable(); identifier(order.form.ramo)\" ng-options=\"payform.value as payform.label for payform in order.defaults.payform track by payform.value\" required=\"\"><option value=\"\">Selecciona forma de pago</option></select></div></div><div class=\"col-xs-12 col-sm-4 form-group\"><label for=\"SelectCurrency\">Moneda</label><select id=\"SelectCurrency\" class=\"form-control\" ng-options=\"f_currency.value as f_currency.label for f_currency in order.f_currency.options\" ng-init=\"order.f_currency.f_currency_selected = 1\" ng-model=\"order.f_currency.f_currency_selected\" ng-change=\"changeFCurrency()\"></select></div><div ng-if=\"users\" class=\"col-sm-4 form-group\" ng-class=\"{ \'has-error\': form.responsable.$invalid && !form.responsable.$pristine }\"><label for=\"responsable\">Responsable</label><div><select class=\"form-control m-b\" name=\"responsable\" ng-model=\"order.form.responsable\" ng-change=\"changeResponsable(order.form.vendor)\" ng-options=\"responsable.id as responsable.first_name + \' \' + responsable.last_name for responsable in users\"><option value=\"\">Seleccione un responsable</option></select></div></div><div ng-if=\"ejecutivos\" class=\"col-sm-4 form-group\"><label for=\"ej\">Ejecutivo de Cobranza</label><div><select class=\"form-control m-b\" name=\"collection_executive\" ng-model=\"order.form.collection_executive\" ng-change=\"collection_executive(order.form.vendor)\" ng-options=\"collection_executive.id as collection_executive.first_name + \' \' + collection_executive.last_name for collection_executive in ejecutivos\"><option value=\"\">Seleccione un ejecutivo</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-init=\"order.form.domiciliado = false\"><label style=\"margin-bottom: 10px;\">Domiciliado</label><br><div class=\"col-xs-12 col-sm-6\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"order.form.domiciliado\" ng-value=\"true\" id=\"_1\" ng-click=\"changeDomiciliado()\"> Si</label></div></div><div class=\"col-xs-12 col-sm-6\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"order.form.domiciliado\" ng-value=\"false\" id=\"_2\" ng-click=\"changeDomiciliado()\"> No</label></div></div></div><div class=\"col-xs-12 form-group\" ng-if=\"show_new_sub\"><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in users track by $index\" ng-init=\"isSeller[$index] = false; main_index = $index\" style=\"padding: 20px;\"><legend class=\"legend-title hidden-xs hidden-sm\" ng-if=\"item.user_info.is_vendedor\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], users[$index])\">{{ item.first_name}} {{ item.last_name }} <span class=\"color-blue pull-right\">Vendedor</span></legend><legend class=\"legend-title hidden-xs hidden-sm\" ng-if=\"!item.user_info.is_vendedor\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], users[$index])\">{{ item.first_name}} {{ item.last_name }} <span class=\"color-blue pull-right\">Usuario</span></legend><h2 class=\"legend-title visible-xs-block visible-sm-block\" ng-if=\"item.user_info.is_vendedor\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], users[$index])\">{{ item.first_name}} {{ item.last_name }}<div><h4 class=\"color-blue\">Vendedor</h4></div></h2><h2 class=\"legend-title visible-xs-block visible-sm-block\" ng-if=\"!item.user_info.is_vendedor\" ng-click=\"isSeller[$index] ? isSeller[$index] = false : isSeller[$index] = true ;checkSelected(isSeller[$index], users[$index])\">{{ item.first_name}} {{ item.last_name }}<div><h4 class=\"color-blue\">Usuario</h4></div></h2><div class=\"row\" ng-if=\"isSeller[$index]\"><form name=\"form\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Fecha de Ingreso:<span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"\" class=\"form-control width-100 text-align-center\" ng-model=\"users[$index].hired_date\" value=\"{{filterDate.startDate}}\" data-date-format=\"mm/dd/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Banco:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"users[$index].bank\" ng-options=\"bank.alias for bank in banks | orderBy: \'alias\' track by bank.url\" required=\"\"><option value=\"\" disabled=\"\">Seleccione un banco</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Número de Referencia:<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"users[$index].reference_number\" ng-disabled=\"users[$index].pay_way.key == 4\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Forma de Pago:<span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"users[$index].pay_way\" ng-options=\"pay_way.val for pay_way in pay_ways | orderBy: \'id\' track by pay_way.key\" required=\"\"><option value=\"\" disabled=\"\">Seleccione una forma de pago</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Gastos de Operación:<span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-usd\"></i></span> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"users[$index].gastos_operacion\" required=\"\"></div></div><div class=\"col-xs-12 col-md-8 col-lg-6 form-group\"><label>Dirección:<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" name=\"\" ng-model=\"users[$index].address\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Correo electrónico:<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" name=\"\" ng-model=\"users[$index].email\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Teléfono:<span class=\"color-red\">*</span></label><div class=\"input-group form-group\"><phonenumber-directive placeholder=\"myPrompt\" model=\"users[$index].phone\"></phonenumber-directive><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"addPhone($index)\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span></div><div class=\"input-group form-group\" ng-repeat=\"item in users[main_index].phones track by $index\" ng-init=\"child_index = $index\"><phonenumber-directive placeholder=\"myPrompt\" model=\"users[main_index].phones[child_index]\"></phonenumber-directive><span class=\"input-group-btn\"><button class=\"btn btn-danger btn-add-contractor\" ng-click=\"deletePhone(main_index, child_index, users[main_index].phones[child_index])\"><i class=\"fa fa-minus\" aria-hidden=\"true\"></i></button></span></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 legend-gray\" ng-if=\"item.subramos.length == 0\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-disabled=\"item.subramos.length == 0\">Quitar Subramo</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-disabled=\"item.subramos.length == 0\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Subramos</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addSubramo(main_index)\" type=\"button\">Agregar Subramo</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addSubramo(main_index)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"col-xs-12 address-container\" ng-repeat=\"sub_ramo in item.subramos track by $index\" ng-init=\"main_subramos_index = $index; assignAgain()\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteSubramo(main_index, main_subramos_index, item)\">Quitar Subramo</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"vm.deleteContacts($index, 1)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Subramo #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addSubramo(main_index)\" type=\"button\">Agregar Subramo</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addSubramo(main_index)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Aseguradora</label><select class=\"form-control\" ng-model=\"sub_ramo.provider\" ng-options=\"provider.compania for provider in aseguradoras | orderBy: \'compania\' track by provider.url\" ng-change=\"changeProvider(sub_ramo, sub_ramo.provider)\"><option value=\"\">Todas</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Ramo</label><select class=\"form-control\" ng-model=\"sub_ramo.ramo\" ng-options=\"ramo.ramo_name for ramo in sub_ramo.ramos | orderBy: \'ramo_name\' track by ramo.id\" ng-change=\"changeRamoVendedor(sub_ramo)\"><option value=\"\">Todos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Subramo</label><select class=\"form-control\" ng-model=\"sub_ramo.subramo\" ng-options=\"subramo.subramo_name for subramo in sub_ramo.sub_ramos | orderBy: \'subramo_name\' track by subramo.id\"><option value=\"\">Todos</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Porcentage de Comisión %</label> <input class=\"form-control\" type=\"text\" name=\"\" minlength=\"1\" maxlength=\"10\" ng-model=\"sub_ramo.comision_percentage\"></div></div></div><div class=\"col-xs-12 form-group\"><button class=\"btn btn-success btn-mt pull-right\" ng-if=\"item.user_info.info_vendedor.length == 0\" ng-disabled=\"\" ng-click=\"saveSeller(main_index)\">Guardar como Vendedor</button> <button class=\"btn btn-success btn-mt pull-right\" ng-if=\"item.user_info.info_vendedor.length > 0\" ng-disabled=\"\" ng-click=\"isSeller[$index] = false; saveSeller(main_index)\">Guardar Cambios</button></div></form></div></li></ul><button class=\"btn btn-danger pull-right\" style=\"margin-top: 24px\" ng-click=\"cancelNewSubramo()\">Finalizar</button><hr class=\"col-xs-12\"></div><div ng-if=\"sucursalList\" class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><label for=\"sucursal\">Sucursal</label><select class=\"form-control m-b\" name=\"sucursal\" ng-model=\"order.form.sucursal\" ng-change=\"sucursal(order.form.sucursal)\" ng-options=\"sucursal.id as sucursal.sucursal_name for sucursal in sucursalList\"><option value=\"\">Seleccione una sucursal</option></select></div><br><br><div class=\"col-xs-12 col-sm-6 col-md-6 nopadding form-group\"><label>Referenciadores</label><div class=\"hidden-xs hidden-sm nopadding form-group\" ng-repeat=\"item in referenciadores\"><div class=\"col-xs-12 input-group form-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-danger\" name=\"button\" ng-click=\"deleteReferenciador($index, 1)\" ng-disabled=\"referenciadores.length <= 1\"><i class=\"glyphicon glyphicon-minus\"></i></button></div><select class=\"form-control m-b col-xs-12\" name=\"referenciador_policy\" ng-model=\"item.referenciador\" ng-change=\"changeReferenciador(item)\" ng-options=\"referenciador_policy.url as referenciador_policy.first_name + \' \' + referenciador_policy.last_name for referenciador_policy in referenciador\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione el referenciador</option></select><div class=\"input-group-btn wb102\" ng-init=\"referenciadores[$index].resp_type = 0\"><input class=\"form-control m-b col-xs-12 wb102\" type=\"text\" name=\"\" placeholder=\"% Comisión\" ng-model=\"item.comision_vendedor\" ng-disabled=\"referenciadores.length <= 1\" ng-change=\"changeComRef(item)\" required=\"\"> <button class=\"btn btn-success\" ng-click=\"addReferenciador(1)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button> <a ng-disabled=\"!item.referenciador\" ng-show=\"item.selectedRef && referenciadores.length > 1 && order.poliza.primaTotal\" class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); calculateComision(item, $index)\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i></a></div></div></div></div><div class=\"col-xs-12 form-group\"><label>Observaciones</label> <textarea type=\"text\" class=\"form-control\" ng-model=\"order.form.observations\" ng-change=\"changeObservations()\"></textarea></div><div class=\"col-xs-12 form-group\" ng-if=\"order.permiso_archivos\"><div ng-if=\"!filesCaratula\" ng-include=\"\'templates/upload.html\'\"></div><div class=\"col-xs-12 form-group\" ng-if=\"filesCaratula == true\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><br><h3><span><i>Archivos que estan actualmente en la base de datos</i></span></h3><thead><tr><th>Nombre</th><th width=\"400px\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"file in filesC track by $index\"><td><strong ng-bind=\"file.nombre\" disabled=\"\"></strong> <input class=\"form-control display-none\" ng-model=\"file.nombre\" onblur=\"blurArchivoCargado()\" ng-blur=\"vmFiles.rename(file)\"></td><td><a class=\"btn btn-success\" download=\"\" href=\"{{file.arch}}\">Descargar</a> <a class=\"btn btn-primary\" href=\"{{file.arch}}\" target=\"_blank\">Ver</a> <span class=\"btn btn-success display-none\">Guardar</span></td></tr></tbody></table></div></div></div><div class=\"col-xs-12 form-group\" ng-init=\"selectReceiptsOption(\'on_cover\')\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Selecciona correctamente donde quieres que se creen los recibos.</div></div><div class=\"col-xs-12 col-sm-6 form-group\"><div class=\"radio\"><label class=\"pull-right\" ng-class=\"{\'receipts-select\': receipts_option == \'on_cover\'}\"><input type=\"radio\" ng-model=\"receipts_option\" value=\"on_cover\" ng-change=\"selectReceiptsOption(receipts_option)\"> Crear recibos por póliza</label></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><div class=\"radio\"><label ng-class=\"{\'receipts-select\': receipts_option == \'on_subgroup\'}\"><input type=\"radio\" ng-model=\"receipts_option\" value=\"on_subgroup\" ng-change=\"selectReceiptsOption(receipts_option)\"> Crear recibos por subgrupo (Diferentes Razones Sociales para Facturación)</label></div></div><div class=\"col-xs-12\" ng-if=\"receits_on_cover && !order.show.ot\"><calculate-receipts poliza=\"order.poliza\" form=\"order.form\" tosave=\"dataToSave\" type=\"1\"></calculate-receipts></div></form></div></form></div><button id=\"createCont\" ng-click=\"contratanteCreatorModalEvent()\" class=\"display-none\"></button>");
$templateCache.put("app/colectividades/templates/paquetes.html","<toaster-container></toaster-container><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><form name=\"newPackageForm\"><div class=\"col-xs-12 col-sm-6 form-group\"><label for=\"group\">Paquete</label><div class=\"input-group\"><select class=\"form-control m-b\" name=\"package\" ng-model=\"package\" ng-options=\"item as item.package_name for item in order.defaults.packages\" ng-change=\"selectPackage(package)\"><option value=\"\" disabled=\"\">Selecciona un paquete</option></select><span class=\"input-group-btn\"><button class=\"btn btn-success btn-add-contractor\" ng-click=\"addPackage()\"><i class=\"glyphicon glyphicon-plus\"></i></button></span></div></div><div class=\"row col-xs-12 col-sm-6\" ng-if=\"newPackage\"><div class=\"col-xs-12 form-group\"><label>Nombre<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"package.package_name\"></div><div class=\"col-xs-12 form-group\"><label>Observaciones<span class=\"color-red\">*</span></label> <textarea class=\"form-control\" type=\"text\" ng-model=\"package.description\"></textarea></div><div class=\"col-xs-12 col-sm-6 form-group\"><button class=\"col-xs-12 btn btn-danger pull-right\" ng-click=\"cancelNewPackage()\">Cancelar</button></div><div class=\"col-xs-12 col-sm-6 form-group\"><button class=\"col-xs-12 btn btn-success pull-right\" ng-disabled=\"!package.description\" ng-click=\"savePackage(package);\">Siguiente</button></div></div><div class=\"col-xs-12\" ng-if=\"addCoverages\"><div class=\"col-xs-12 col-sm-6\"><div class=\"col-xs-8 form-group\"><label>Nombre de Cobertura<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"coverageName\"></div><div class=\"col-xs-12 col-sm-6\"><button class=\"col-xs-12 btn btn-info pull-right\" ng-click=\"finishCoverages()\" ng-disabled=\"!coverages.length\">Finalizar</button></div><div class=\"col-xs-12 col-sm-6\"><button class=\"col-xs-12 btn btn-success pull-right\" ng-click=\"saveCoverage(coverageName,priority)\">Agregar</button></div></div><div class=\"col-xs-12 col-sm-6\"><legend class=\"legend-title\" align=\"center\">Coberturas del Paquete {{ package.package_name }}</legend><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"coverage in coverages\">{{ coverage.coverage_name }}</li></ul></div></div><div class=\"col-xs-12\" ng-if=\"package && !newPackage\"><legend class=\"legend-title\" align=\"center\">Personalizar</legend><div class=\"col-xs-12 col-sm-6\" ng-show=\"showNewCoverage\"><div class=\"col-xs-12 form-group\"><label>Nombre de la Cobertura</label> <input class=\"form-control\" ng-model=\"newCoverage[$index]\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><button class=\"col-xs-12 btn btn-danger\" ng-click=\"showNewCoverage = false; newCoverage[$index] = \'\'\">Cancelar</button></div><div class=\"col-xs-12 col-sm-6 form-group\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"saveCoverage(newCoverage[$index],priority, \'config\', package, data); showNewCoverage = false; newCoverage[$index] = \'\'\">Agregar</button></div></div><div class=\"col-xs-12\"><div ng-show=\"!showNewCoverage\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre del paquete personalizado<span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"config_coverages.package_name\"></div><div class=\"col-xs-12 col-sm-3 form-group btn-mt\"><span class=\"dropdown\" uib-dropdown=\"\" is-open=\"isopen\" auto-close=\"outsideClick\"><a href=\"javascript:void(0);\" class=\"dropdown-toggle btn btn-success\" uib-dropdown-toggle=\"\">Mostrar Coberturas</a><ul style=\"margin-top: 10px;\" uib-dropdown-menu=\"\" class=\"dropdown-menu scrollable-menu\" role=\"menu\"><li ng-click=\"addAll(); isopen = false\" ng-if=\"config_coverages.source.length\"><label class=\"menu-item align-center\">Seleccionar Todos</label></li><li ng-click=\"showNewCoverage = true; isopen = false\"><label class=\"menu-item align-center\">Nueva cobertura</label></li><li ng-repeat=\"item in config_coverages.source track by item.url\"><label class=\"menu-item\"><input type=\"checkbox\" ng-model=\"item.selected\" ng-click=\"addCoverageToArray(item)\">&nbsp;{{item.coverage_name}}</label></li></ul></span></div></div></div><legend class=\"legend-title\" align=\"center\">Coberturas</legend><div ng-init=\"showConfig[$index] = true\"><div class=\"col-xs-12\" ng-if=\"showConfig[$index]\"><table class=\"table\"><thead><th>Cobertura</th><th>Suma Asegurada<span class=\"color-red\">*</span></th><th>Deducible<span class=\"color-red\">*</span></th><th ng-if=\"order.form.subramo.subramo_name == \'Gastos Médicos\'\">Coaseguro</th><th ng-if=\"order.form.subramo.subramo_name == \'Gastos Médicos\'\">Tope Coaseguro</th><th></th></thead><tbody><tr ng-repeat=\"coverage in config_coverages.coveragesConfig track by coverage.url\"><td>{{coverage.coverage_name}}</td><td><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.sums_coverage\" ng-click=\"coverage.sumInPolicy.value = item.sum_insured\"><a>{{demo(item.sum_insured) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.sumInPolicy.value\" ng-keyup=\"show_button_save_sum = true\" format-currency=\"\"></div></td><td><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.deductible_coverage\" ng-click=\"coverage.deductibleInPolicy.value = item.deductible\"><a>{{demo(item.deductible) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.deductibleInPolicy.value\" ng-keyup=\"show_button_save_ded = true\" format-currency=\"\"></div></td><td ng-if=\"order.form.subramo.subramo_name == \'Gastos Médicos\'\"><div class=\"form-group\"><input type=\"text\" class=\"col-xs-12 form-control\" ng-model=\"coverage.coinsuranceInPolicy.value\" ng-if=\"order.form.subramo.subramo_name == \'Gastos Médicos\'\"></div></td><td ng-if=\"order.form.subramo.subramo_name == \'Gastos Médicos\'\"><div class=\"form-group\"><input type=\"text\" class=\"col-xs-12 form-control\" ng-model=\"coverage.topeCoinsuranceInPolicy.value\" ng-if=\"order.form.subramo.subramo_name == \'Gastos Médicos\'\"></div></td><td><button class=\"btn btn-danger pull-right\" name=\"button\" ng-click=\"deleteCoverage(coverage, data)\" type=\"button\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><button class=\"btn btn-success pull-right\" ng-disabled=\"!config_coverages.package_name\" ng-click=\"saveConfiguration(config_coverages)\">Guardar paquete personalizado</button></div></div></form><div class=\"col-xs-12 btn-mt\" ng-if=\"config_saved.length\" ng-repeat=\"data in config_saved\"><div class=\"panel panel-info\"><div class=\"panel-heading\"><label>ID: {{ data.id }}</label></div></div><h3 class=\"text-center\">{{data.package_name}}</h3><table class=\"table table-bordered table-hover\"><thead><th>Cobertura</th><th>Suma Asegurada</th><th>Deducible</th><th ng-if=\"order.form.subramo.subramo_name == \'Gastos Médicos\'\">Coaseguro</th><th ng-if=\"order.form.subramo.subramo_name == \'Gastos Médicos\'\">Tope Coaseguro</th></thead><tbody><tr ng-repeat=\"item in data.coveragesConfig track by item.url\"><td>{{item.coverage_name}}</td><td>{{item.sums_coverage[0].sum_insured}}</td><td>{{item.deductible_coverage[0].deductible}}</td><td ng-if=\"order.form.subramo.subramo_name == \'Gastos Médicos\'\">{{item.coinsurance_coverage[0].coinsurance}}</td><td ng-if=\"order.form.subramo.subramo_name == \'Gastos Médicos\'\">{{item.topecoinsurance_coverage[0].topecoinsurance}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/colectividades/templates/subgroups.html","<toaster-container></toaster-container><div class=\"ibox float-e-margins\"><div class=\"ibox-content animate-if\"><div class=\"row\" ng-init=\"receits_on_cover = true\"><form name=\"subgrupo_form\"><div class=\"col-xs-12 form-group\" ng-if=\"mostrarAlertaSubgrupo\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Si quieres agregar recibos en los subgrupos creados, por favor agregalos desde la informacion de la colectividad en el apartado de Subgrupos y Categorías.</div></div><div class=\"col-xs-12\" ng-if=\"receits_on_cover\" align=\"center\"><h2 class=\"legend-title\">Por favor indique si desea agregar subgrupos</h2></div><div class=\"col-xs-6\" ng-if=\"receits_on_cover\"><div ng-if=\"!order.subgroup.length && subgrupoResult.name !== \'Default\'\"><button class=\"btn btn-danger pull-right\" ng-click=\"NotSubgroups()\"><i class=\"glyphicon glyphicon-remove\"></i> Sin Subgrupo</button></div></div><div class=\"col-xs-6\" ng-if=\"receits_on_cover\"><div ng-if=\"!order.subgroup.length && subgrupoResult.name !== \'Default\'\"><button class=\"btn btn-success\" ng-click=\"existSubgroup(1)\"><i class=\"glyphicon glyphicon-plus\"></i> Agregar Subgrupo</button></div></div><div class=\"col-xs-12\" ng-if=\"exist_subgroup\"><legend class=\"legend-title\" align=\"center\">Datos del subgrupo</legend><div class=\"col-xs-12 col-sm-6 form-group\" ng-class=\"{ \'has-error\': subgrupo_form.subgroup.$invalid && !subgrupo_form.subgroup.$pristine }\"><label>Nombre<span class=\"color-red\">*</span></label> <input type=\"text\" class=\"form-control\" name=\"subgroup\" ng-model=\"subgroup.name\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Observaciones</label> <textarea type=\"text\" class=\"form-control\" ng-model=\"subgroup.observations\"></textarea></div></div><div class=\"col-xs-12\" ng-if=\"(!receits_on_cover && exist_subgroup) || (caratula.receipts_by == 2 && exist_subgroup && receipts_option == \'on_subgroup\') || (renovacionCaratula.receipts_by == 2 && receipts_option == \'on_subgroup\' && exist_subgroup)\"><legend class=\"legend-title\" align=\"center\">Datos del contratante</legend><div ng-if=\"show_contractor_list\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante {{contrac.selected}}<span class=\"color-red\">*</span></label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"subgroup.contratante\" change=\"matchesContractors(subgroup.contratante, 2)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección</label><select class=\"form-control\" data-ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \'+ address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in subgroup.contratante.address_all track by address.url\" ng-change=\"order.options.changeAddress(order.form.address)\" ng-model=\"subgroup.contratante.address\" ng-disabled=\"!subgroup.contratante\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Correo</label> <input class=\"form-control\" name=\"correo\" ng-model=\"subgroup.contratante.email\" type=\"email\" ng-disabled=\"!subgroup.contratante || emailStatus\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Teléfono</label><phonenumber-directive model=\"subgroup.contratante.phone_number\" class=\"ng-isolate-scope\"><input ng-model=\"inputValue\" type=\"tel\" class=\"phonenumber form-control ng-pristine ng-valid ng-valid-maxlength ng-touched\" maxlength=\"25\" placeholder=\"\" title=\"Phonenumber (Format: (999) 9999-9999)\" aria-invalid=\"false\" style=\"\"></phonenumber-directive></div><div ng-if=\"order.vendors.length > 0\" class=\"col-sm-6 form-group\" ng-class=\"{ \'has-error\': form.vendedor.$invalid && !form.vendedor.$pristine }\"><label for=\"vendedor\">Referenciador<span class=\"color-red\">*</span></label><div class=\"\"><select class=\"form-control m-b\" name=\"vendedor\" ng-model=\"subgroup.vendor\" ng-change=\"changeVendedor(order.form.vendor)\" ng-options=\"vendedor.id as vendedor.name for vendedor in order.vendors track by vendedor.id\"><option value=\"\" disabled=\"\">Seleccione un referenciador</option></select></div></div></div></div><div class=\"col-xs-12 btn-mt\" ng-if=\"(!receits_on_cover && exist_subgroup) || (caratula.receipts_by == 2 && exist_subgroup && receipts_option == \'on_subgroup\') || (renovacionCaratula.receipts_by == 2 && receipts_option == \'on_subgroup\' && exist_subgroup)\" ng-hide=\"order.show.ot && !verReceipts\"><calculate-receipts poliza=\"order.poliza\" form=\"order.form\" tosave=\"dataToSave\" type=\"1\"></calculate-receipts></div><div class=\"col-xs-12 form-group\" ng-if=\"exist_subgroup\"><button class=\"btn btn-danger pull-right\" ng-click=\"existSubgroup(2)\">Cancelar</button><button class=\"btn btn-success pull-right m-r\" ng-click=\"saveSubgroup(\'add\', dataToSave)\">Guardar Subgrupo</button></div></form><div class=\"col-xs-12 col-sm-6\" ng-if=\"exist_subgroup\"><legend class=\"legend-title\" ng-if=\"subgrupoResult.name !== \'Default\'\">Subgrupos Creados</legend><div ng-repeat=\"item in tree_subs\"><ul class=\"todo-list m-t small-list\"><li ng-init=\"show_cat[$index] = true\" ng-click=\"show_cat[$index] ? show_cat[$index] = false : show_cat[$index] = true; selectSubgroup(item.data);\" ng-class=\"{\'package-selected\': item.data.id == subgrupoResult.id}\" class=\"subgroup-item\"><span class=\"m-l-xs\">{{item.text}}</span></li></ul></div></div></div></div></div>");
$templateCache.put("app/components/common/address-panel.html","<label>Dirección</label><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Dirección</th><th>Opción</th></tr></thead><tbody><tr ng-repeat=\"address in vm.addresses track by $index\"><td><input class=\"form-control\" type=\"text\" ng-model=\"address.address\"></td><td><button type=\"button\" class=\"btn btn-w-m btn-danger\" name=\"button\" ng-click=\"vm.deleteAddress($index)\">Eliminar</button></td></tr></tbody></table></div><div class=\"col-sm-12\"><button class=\"btn btn-white pull-right\" ng-click=\"vm.addAddress()\" type=\"button\">Agregar dirección</button></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\" (contextmenu)=\"onRightClick()\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"white-bg {{$state.current.name}} page-wrapper--no-tabs\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div class=\"row\"><div id=\"tabs-views\" data-ui-view=\"\"></div></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools dropdown cursor-pointer\" ng-click=\"showhide()\" dropdown=\"\"><a ng-click=\"showhide()\"></a><a class=\"collapse-link\"><i class=\"fa fa-chevron-up\"></i></a></div>");
$templateCache.put("app/components/common/mc-content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"white-bg {{$state.current.name}} page-wrapper--no-tabs\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div class=\"row\"><div id=\"tabs-views\" data-ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><link href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css\" rel=\"stylesheet\"><script src=\"https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/js/select2.min.js\"></script><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header nav-header-Miurabox\"><div class=\"dropdown profile-element\" dropdown=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold color-white\">{{main.orgname}}</strong></span></span> <img alt=\"image\" class=\"img-circle dimension-50\" ng-src=\"{{main.logo_mini}}\"> <a class=\"dropdown-toggle\" dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{main.full_name}}</strong></span> <span class=\"text-muted text-xs block\">{{main.role}}</span></span></a></div><div class=\"logo-element\"><img alt=\"image\" ng-if=\"!main.logo_mini\" class=\"img-circle dimension-50\" ng-src=\"../../assets/images/logos/miuraiconwhite.png\"> <img alt=\"image\" ng-if=\"main.logo_mini\" class=\"img-circle dimension-50\" ng-src=\"{{main.logo_mini}}\"></div></li><ul id=\"context1\" class=\"dropdown-menu\" role=\"menu\" z-index=\"1000\"></ul><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Inicio\',\'inicio.inicio\')\" ng-if=\"main.permiso_g_ot || main.permiso_g_cob || main.permiso_g_ren ||main.permiso_g_sin || main.acceso_adm_pol || main.acceso_adm_sin || main.acceso_ver_cob\"><a ng-click=\"main.activateAux(); main.closeMenu(); open_in_same_tab(\'Inicio\',\'inicio.inicio\')\"><i class=\"fa fa-pause\"></i> <span class=\"nav-label\">Inicio</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Dashboard\',\'index.main\')\" ng-if=\"main.permiso_g_ot || main.permiso_g_cob || main.permiso_g_ren ||main.permiso_g_sin || main.acceso_adm_pol || main.acceso_adm_sin || main.acceso_ver_cob\"><a ng-click=\"main.activateAux(); main.closeMenu(); open_in_same_tab(\'Dashboard\',\'index.main\')\"><i class=\"fa fa-pie-chart\"></i> <span class=\"nav-label\">Dashboard</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_cont || main.acceso_adm_cont\"><a><i class=\"fa fa-users\"></i> <span class=\"nav-label\">Clientes</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-second-level collapse\" ng-if=\"main.acceso_ver_cont || main.acceso_adm_cont\"><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_cont || main.acceso_ver_cont\"><a class=\"nav-second-level-custom\"><i class=\"fa fa-user\"></i> <span class=\"nav-label\">Contratantes</span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_cont\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Nuevo contratante\',\'contratantes.create\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Nuevo contratante\',\'contratantes.create\')\">Nuevo</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_cont\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Lista contratantes\',\'contratantes.list\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Lista contratantes\',\'contratantes.list\')\">Listado</a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_cont || main.acceso_adm_cont\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Grupos\',\'grupos.grupos\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Grupos\',\'grupos.grupos\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-users\"></i> <span class=\"nav-label\">Grupos</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-if=\"main.acceso_clasificacion\" ng-right-click=\"ShowContextMenu(\'Clasificación\',\'clasificacion.clasificacion\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Clasificación\',\'clasificacion.clasificacion\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-table\"></i> <span class=\"nav-label\">Clasificación</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-if=\"main.acceso_clasificacion\" ng-right-click=\"ShowContextMenu(\'Células\',\'celulacontractor.celulacontractor\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Células\',\'celulacontractor.celulacontractor\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-building\"></i> <span class=\"nav-label\">{{moduleName}}</span></a></li><li ui-sref-active=\"active\" id=\"navigate\" name=\"navigate\" context=\"context1\" ng-if=\"main.acceso_clasificacion\" ng-right-click=\"ShowContextMenu(\'Agrupaciones\',\'grupinglevel.grupinglevel\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Agrupaciones\',\'grupinglevel.grupinglevel\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-shopping-bag\"></i> <span class=\"nav-label\">Agrupaciones</span></a></li></ul></li><li ui-sref-active=\"active\"><a><i class=\"fa fa-wrench\"></i> <span class=\"nav-label\">Operación</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_pol || main.acceso_ver_pol || main.acceso_adm_ot || main.acceso_ver_ot\"><a class=\"nav-second-level-custom\"><i class=\"fa fa-paperclip\"></i> <span class=\"nav-label\">Póliza</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_pol || main.acceso_ver_ot\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Listado pólizas\',\'polizas.table\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Listado pólizas\',\'polizas.table\')\">Listado</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_pol || main.acceso_adm_ot\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'OT / Pólizas\',\'polizas.create\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'OT / Pólizas\',\'polizas.create\')\">OT / Pólizas</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_pol || main.acceso_adm_ot\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Pólizas de Grupo\',\'colectividades.main\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Pólizas de Grupo\',\'colectividades.main\')\">Pólizas de Grupo</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_pol || main.acceso_adm_ot\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Colectividad/Flotilla\',\'flotillas.flotillas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Colectividad/Flotilla\',\'flotillas.flotillas\')\">Colectividad/Flotilla</a></li><li ui-sref-active=\"active\" ng-if=\"(main.acceso_adm_pol || main.acceso_adm_ot) && main.permiso_administrar_adjuntos\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Archivos de Certificados\',\'colectividades.masivos\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Archivos de Certificados\',\'colectividades.masivos\')\">Carga masiva de adjuntos</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_pol\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Compartir a la App\',\'compartir.create\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Compartir a la App\',\'compartir.create\')\">Compartir a la App</a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_fia || main.acceso_ver_fia\"><a class=\"nav-second-level-custom\"><i class=\"fa fa-usd\"></i> <span class=\"nav-label\">Fianza</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_fia\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Fianzas\',\'fianzas.list\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Fianzas\',\'fianzas.list\')\" class=\"nav-third-level-custom\">Listado</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_fia || main.acceso_adm_ot\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'PF/Fianza\',\'fianzas.fianzas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'PF/Fianza\',\'fianzas.fianzas\')\" ng-if=\"main.permisos.crear\">PF/Fianza</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_fia || main.acceso_adm_ot\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'PF/Colectivo Fidelidad\',\'fianzas.colectividades\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'PF/Colectivo Fidelidad\',\'fianzas.colectividades\')\" ng-if=\"main.permisos.crear\">PF/Colectivo Fidelidad</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_fia\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Reclamaciones\',\'fianzas.reclist\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Reclamaciones\',\'fianzas.reclist\')\" ng-if=\"main.permisos.crear\">Reclamaciones</a></li><li ui-sref-active=\"active\"><a class=\"nav-second-level-custom\"><span class=\"nav-label\" style=\"font-size: 11px\">Programa de Proveedores</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Listado Proveedores\',\'fianzas.pprovlist\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Listado Proveedores\',\'fianzas.pprovlist\')\"><span style=\"font-size: 11px\">Listado</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Crear Proveedores\',\'fianzas.pprovnew\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Crear Proveedores\',\'fianzas.pprovnew\')\"><span style=\"font-size: 11px\">Nuevo</span></a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_rep_fia\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Beneficiarios\',\'reportes.fianzas_ben\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Beneficiarios\',\'reportes.fianzas_ben\')\">Beneficiarios</a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_pol || main.acceso_ver_pol || main.acceso_adm_ot || main.acceso_ver_ot\"><a class=\"nav-second-level-custom\"><i class=\"fa fa-inbox\"></i> <span class=\"nav-label\">Endosos</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_ot\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Listado Endoso\',\'endorsement.lista\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Listado Endoso\',\'endorsement.lista\')\">Listado</a></li><li ng-if=\"main.permisos.crear\" ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Póliza Individual\',\'endorsement.endorsement\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Póliza Individual\',\'endorsement.endorsement\')\">Póliza Individual</a></li><li ng-if=\"main.permisos.crear\" ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Póliza de Grupos\',\'endorsement.collectivity\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Póliza de Grupos\',\'endorsement.collectivity\')\">Póliza de Grupos</a></li><li ng-if=\"main.permisos.crear\" ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Fianza Individual\',\'endorsement.fianza\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Fianza Individual\',\'endorsement.fianza\')\">Fianza Individual</a></li><li ng-if=\"main.permisos.crear\" ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Fianza Colectiva\',\'endorsement.collective\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Fianza Colectiva\',\'endorsement.collective\')\">Fianza Colectiva</a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_pol\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Renovaciones\',\'renovaciones.renovaciones\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Renovaciones\',\'renovaciones.renovaciones\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-refresh\"></i> <span class=\"nav-label\">Renovaciones</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_cob\"><a class=\"nav-second-level-custom\"><i class=\"fa fa-usd\"></i> <span class=\"nav-label\">Cobranza</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Listado cobranza\',\'cobranzas.cobranzas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Listado cobranza\',\'cobranzas.cobranzas\')\" class=\"nav-third-level-custom\">Listado</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Folio Pago/Liquidación\',\'cobranzas.folios\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Folio Pago/Liquidación\',\'cobranzas.folios\')\">Folio Pago/Liquidación</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Bonos\',\'cobranzas.bonos\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Bonos\',\'cobranzas.bonos\')\" class=\"nav-third-level-custom\">Bonos</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Masivo Liquidación-Pago\',\'cobranzas.cobranzasmasivo\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Masivo Liquidación-Pago\',\'cobranzas.cobranzasmasivo\')\" class=\"nav-third-level-custom\">Masivo Liquidación-Pago</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Repositorio Pago\',\'cobranzas.repositorio\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Repositorio Pago\',\'cobranzas.repositorio\')\" class=\"nav-third-level-custom\">Repositorio de Pago</a></li></ul></li><li ui-sref-active=\"active\" id=\"navigate\" name=\"navigate\" ng-if=\"main.acceso_adm_pack\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Aseguradoras\',\'aseguradoras.aseguradoras\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Aseguradoras\',\'aseguradoras.aseguradoras\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-life-ring\"></i> <span class=\"nav-label\">Aseguradoras</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_pol\"><a class=\"nav-second-level-custom\"><i class=\"fa fa-upload\"></i> <span class=\"nav-label\">Carga Masiva</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Masivo No Renovación ID\',\'carga.norenovacion\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Masivo No Renovación ID\',\'carga.norenovacion\');\" class=\"nav-third-level-custom\">No Renovación de pólizas (ID)</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Masivo Cancelación\',\'carga.cancelacion\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Masivo Cancelación\',\'carga.cancelacion\');\" class=\"nav-third-level-custom\">Cancelación de pólizas</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Masivo Contratantes\',\'carga.contractor\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Masivo Contratantes\',\'carga.contractor\');\" class=\"nav-third-level-custom\">Contratantes</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Masivo Póliza Individual\',\'carga.poliza\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Masivo Póliza Individual\',\'carga.poliza\');\" class=\"nav-third-level-custom\">Póliza Individual</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Masivo Póliza Grupo\',\'carga.pgrupo\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Masivo Póliza Grupo\',\'carga.pgrupo\');\" class=\"nav-third-level-custom\">Póliza de Grupo</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Masivo Certificados\',\'carga.certificado\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Masivo Certificados\',\'carga.certificado\');\" class=\"nav-third-level-custom\">Certificados de PG</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Masivo Flotilla\',\'carga.flotilla\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Masivo Flotillas\',\'carga.flotilla\')\" class=\"nav-third-level-custom\">Colectividad/Flotilla</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Catálogos\',\'carga.catalogo\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Catálogos\',\'carga.catalogo\')\" class=\"nav-third-level-custom\">Catálogos</a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_pack\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Paquetes\',\'paquetes.paquetes\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Paquetes\',\'paquetes.paquetes\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-gift\"></i> <span class=\"nav-label\">Paquetes</span></a></li></ul></li><li ui-sref-active=\"active\" context=\"context1\" ng-if=\"main.acceso_tab_ots\" ng-right-click=\"ShowContextMenu(\'Tablero OTs\',\'tablero.init\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Tablero OTs\',\'tablero.init\')\"><i class=\"fa fa-qrcode\"></i> <span class=\"nav-label\">Tablero OT</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-if=\"main.acceso_ver_cotizaciones\" ng-right-click=\"ShowContextMenu(\'Cotizaciones\',\'cotizacion.cotizacion\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Cotizaciones\',\'cotizacion.cotizacion\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-th-large\"></i> <span class=\"nav-label\">Cotizaciones</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_sin\"><a><i class=\"fa fa-ambulance\"></i> <span class=\"nav-label\">Siniestros</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_sin\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Listado siniestros\',\'siniestros.lista\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Listado siniestros\',\'siniestros.lista\')\">Listado</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_sin\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Accidentes y enfermedades\',\'siniestros.accidentes\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Accidentes y enfermedades\',\'siniestros.accidentes\')\">Accidentes y enfermedades</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_sin\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Vida\',\'siniestros.vida\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Vida\',\'siniestros.vida\')\">Vida</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_sin\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Automóviles\',\'siniestros.autos\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Automóviles\',\'siniestros.autos\')\">Automóviles</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_sin\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Daños\',\'siniestros.danios\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Daños\',\'siniestros.danios\')\">Daños</a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_cob || main.acceso_conc_cob\" ng-show=\"main.permiso_comisiones\"><a><i class=\"fa fa-money\"></i> <span class=\"nav-label\">Comisiones</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_cob\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Conciliar\',\'comisiones.comisiones\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Conciliar\',\'comisiones.comisiones\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-copy\"></i> <span class=\"nav-label\">Conciliar</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_cob\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Consultar\',\'comisiones.consulta\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Consultar\',\'comisiones.consulta\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-search\"></i> <span class=\"nav-label\">Consultar</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_ver_cob\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Conciliar ID\',\'comisiones.conciliarid\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Conciliar ID\',\'comisiones.conciliarid\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-bars\"></i> <span class=\"nav-label\">Conciliar Masivo por ID</span></a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_rep_cob || main.acceso_rep_ren || main.acceso_rep_sin || main.acceso_rep_fia || main.acceso_rep_end || main.acceso_rep_pol\"><a><i class=\"fa fa-folder-open-o\"></i> <span class=\"nav-label\">Reportes</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\" ng-if=\"main.acceso_rep_pol\"></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_rep_cob\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Reporte Cobranza\',\'reportes.cobranza\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Cobranza\',\'reportes.cobranza\')\">Cobranza</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_rep_ren\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Reporte Renovaciones\',\'reportes.renovaciones\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Renovaciones\',\'reportes.renovaciones\')\">Renovaciones</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_rep_end\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Reporte Endosos\',\'reportes.endosos\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Endosos\',\'reportes.endosos\')\">Endosos</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_rep_pol\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Reporte Pólizas\',\'reportes.polizas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Pólizas\',\'reportes.polizas\')\">Pólizas</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_rep_sin\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Reporte Siniestros\',\'reportes.siniestros\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Siniestros\',\'reportes.siniestros\')\">Siniestros</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_rep_fia\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Reporte fianzas\',\'reportes.fianzas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Fianzas\',\'reportes.fianzas\')\">Fianzas</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-if=\"main.acceso_rep_log\" ng-right-click=\"ShowContextMenu(\'Reporte Log\',\'reportes.log\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Log\',\'reportes.log\')\">Log</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Tareas\',\'reportes.task\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Tareas\',\'reportes.task\')\">Tareas</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Certificados\',\'reportes.certificates\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Certificados\',\'reportes.certificates\')\">Certificados</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Cumpleañeros\',\'reportes.cumple\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Cumpleañeros\',\'reportes.cumple\')\">Cumpleañeros</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-if=\"main.acceso_rep_cob\" ng-right-click=\"ShowContextMenu(\' Reportes fianzas\',\'reportes.cobranzafianzas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Reportes fianzas\',\'reportes.cobranzafianzas\')\">Cobranza Fianzas</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\' Reportes Asegurados\',\'reportes.asegurados\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Reportes Asegurados\',\'reportes.asegurados\')\">Asegurados</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_rep_esp\"><a class=\"nav-second-level-custom\"><span class=\"nav-label\">Reportes Especiales</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Estado clientes\',\'reportes.cotizaciones\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Reportes Cotizaciones\',\'reportes.cotizaciones\')\">Reporte de Cotizaciones</a></li></ul><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Estado clientes\',\'reportes.edoclientes\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Estado clientes\',\'reportes.edoclientes\')\">Estado clientes</a></li></ul><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Liquidaciones\',\'reportes.cobranza_liq\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Liquidaciones\',\'reportes.cobranza_liq\')\">Liquidaciones</a></li></ul><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Recibos subsecuentes\',\'reportes.cobranza_subsec\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Recibos subsecuentes\',\'reportes.cobranza_subsec\')\">Recibos subsecuentes</a></li></ul><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Recibos Pendientes\',\'reportes.cobranzapendiente\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Recibos Pendientes\',\'reportes.cobranzapendiente\')\">Recibos Pendientes</a></li></ul><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Renovaciones Pendientes\',\'reportes.renovacionespendientes\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Renovaciones Pendientes\',\'reportes.renovacionespendientes\')\">Renovaciones Pendientes</a></li></ul><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Órdenes y Endosos\',\'reportes.otsendosos\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Órdenes y Endosos\',\'reportes.otsendosos\')\">Órdenes y Endosos</a></li></ul><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Titulares y Cónyuges\',\'reportes.polizasTitularesConyuges\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Titulares y Cónyuges\',\'reportes.polizasTitularesConyuges\')\">Titulares y Cónyuges</a></li></ul><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Reporte Adjuntos\',\'reportes.adjuntos\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Reporte Adjuntos\',\'reportes.adjuntos\')\">Reporte Adjuntos</a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_rep_est\"><a class=\"nav-second-level-custom\"><span class=\"nav-label\">Reportes Estadísticos</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Conservación/Producción\',\'reportes.conservacion\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Conservación/Producción\',\'reportes.conservacion\')\">Conservación/Producción</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Venta cruazada\', \'reportes.ventacruzada\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Venta cruazada\', \'reportes.ventacruzada\')\">Venta cruzada</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Reporte Auditoria\',\'reportes.auditoria\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Auditoria\',\'reportes.auditoria\')\">Auditoria</a></li></ul></li></ul></li><li ui-sref-active=\"active\"><a ng-click=\"main.closeMenu()\"><i class=\"fa fa-clock-o\"></i> <span class=\"nav-label\">Mis recordatorios</span><span class=\"label label-warning\" ng-if=\"recordatorioscount > 0\">{{recordatorioscount}}</span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Recordatorios automáticos\',\'recordatorios.table\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Recordatorios\',\'recordatorios.table\')\">Todos</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Recordatorios automáticos\',\'recordatorios.automaticos\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Recordatorios automáticos\',\'recordatorios.automaticos\')\">Automáticos</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Recordatorios libres\',\'recordatorios.libres\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Recordatorios libres\',\'recordatorios.libres\')\">Libres</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Recordatorios de registros\',\'recordatorios.desde_registros\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Recordatorios de registros\',\'recordatorios.desde_registros\')\">Desde registro</a></li></ul></li><li ui-sref-active=\"active\" context=\"context1\" ng-if=\"main.permiso_kbi\" ng-right-click=\"ShowContextMenu(\'KBI\',\'kbi.principal\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'KBI\',\'kbi.principal\')\"><i class=\"fa fa-key\"></i> <span class=\"nav-label\">KBI</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_form\"><a><i class=\"fa fa-book\"></i> <span class=\"nav-label\">Formatos</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\"><a class=\"nav-second-level-custom\"><i class=\"fa fa-file\"></i> <span class=\"nav-label\">Adjuntos Internos</span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Carpetas\',\'adjuntosinternos.list\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Carpetas\',\'adjuntosinternos.list\')\">Carpetas</a></li></ul></li><li ui-sref-active=\"active\"><a class=\"nav-second-level-custom\"><i class=\"fa fa-envelope\"></i> <span class=\"nav-label\">Cartas</span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Listado cartas\',\'bibliotecas.list\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Listado cartas\',\'bibliotecas.list\')\">Lista</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Nueva carta\',\'bibliotecas.bibliotecas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Nueva carta\',\'bibliotecas.bibliotecas\')\">Nueva</a></li></ul></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Layouts\',\'bibliotecas.layouts\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Layouts\',\'bibliotecas.layouts\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-file-excel-o\"></i> <span class=\"nav-label\">Layouts</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Editables\',\'bibliotecas.editables\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Editables\',\'bibliotecas.editables\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-file-word-o\"></i> <span class=\"nav-label\">Editables</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Plantillas Cobranza\',\'cobranzas.plantillas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Plantillas Cobranza\',\'cobranzas.plantillas\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-indent\"></i> <span class=\"nav-label\">Plantillas de correo (Cobranza)</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Plantillas Pólizas\',\'polizas.plantillas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Plantillas Pólizas\',\'polizas.plantillas\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-code\"></i> <span class=\"nav-label\">Plantillas de correo (Pólizas)</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Plantillas Certificados\',\'colectividades.plantillas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Plantillas Certificados\',\'colectividades.plantillas\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-code\"></i> <span class=\"nav-label\">Plantillas de correo (Certificados)</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Plantillas Siniestros\',\'siniestros.plantillas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Plantillas Siniestros\',\'siniestros.plantillas\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-ambulance\"></i> <span class=\"nav-label\">Plantillas de correo (Siniestros)</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Plantillas Endosos\',\'endosos.plantillas\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Plantillas Endosos\',\'endosos.plantillas\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-file-alt\"></i> <span class=\"nav-label\">Plantillas de correo (Endosos)</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Plantillas Whatsapp Web\',\'cobranzas.plantillaswhatsapp\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Plantillas Whatsapp Web\',\'cobranzas.plantillaswhatsapp\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-whatsapp\"></i> <span class=\"nav-label\">Plantillas Whatsapp Web (Cobranza)</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Plantillas para Compartir Siniestros por WhatsApp Web\',\'ibis.formatosPlantillasWhatsappSiniestros\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Plantillas para Compartir Siniestros por WhatsApp Web\',\'ibis.formatosPlantillasWhatsappSiniestros\')\" class=\"nav-third-level-custom\"><i class=\"fa fa-medkit\"></i> <span class=\"nav-label\">Plantillas WhatsApp Web (Siniestros)</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Plantillas SMS Cobranza\',\'cobranzas.plantillassms\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Plantillas SMS Cobranza\',\'cobranzas.plantillassms\')\" class=\"nav-second-level-custom\"><img style=\"height: 15px;\" class=\"icon-menu\" src=\"../../assets/comment-sms-solid.svg\"> <span class=\"nav-label\">Plantillas SMS (Cobranza)</span></a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_camp\"><a ng-click=\"main.closeMenu()\"><i class=\"fa fa-flag-checkered\"></i> <span class=\"nav-label\">Campañas</span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Lista de campañas\',\'campaign.list\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Lista de campañas\',\'campaign.list\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-list-ul\"></i> <span class=\"nav-label\">Lista</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Nueva campaña\',\'campaign.create\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Nueva campaña\',\'campaign.create\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-newspaper-o\"></i> <span class=\"nav-label\">Nueva</span></a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_mns\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Mensajeria\',\'mensajeria.principal\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Mensajeria\',\'mensajeria.principal\')\"><i class=\"fa fa-paper-plane\"></i> <span class=\"nav-label\">Mensajeria</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.mc_permission_user && (main.orgname == \'GPI\' || main.orgname == \'PRUEBAS\' )\"><a ng-click=\"main.closeMenu()\"><i class=\"fa fa-cab\"></i> <span class=\"nav-label\">Multicotizador</span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\" ng-if=\"main.acceso_mns\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Cotizador\',\'multicotizador.multicotizador\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Cotizador\',\'multicotizador.multicotizador\')\">Cotizador</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_mns\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Administrador\',\'multicotizador.administrador\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Administrador\',\'multicotizador.administrador\')\">Administrador</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_mns\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Configurador\',\'multicotizador.configurador\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Configurador\',\'multicotizador.configurador\')\">Configurador</a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_ref || main.acceso_pag_ref\" ng-show=\"main.ver_referenciador\"><a><i class=\"fa fa-male\" aria-hidden=\"true\"></i> <span class=\"nav-label\">Referenciador</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\" ng-if=\"main.acceso_pag_ref\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Pagar\',\'agentes.agentes\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Pagar\',\'agentes.agentes\')\">Pagar</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_ref\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Administrar\',\'agentes.administration\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Administrar\',\'agentes.administration\')\">Administrar</a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_pag_ref && main.acceso_edo_cuenta\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'EstadosCuenta\',\'agentes.estadoscuenta\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'EstadosCuenta\',\'agentes.estadoscuenta\')\">Estados de Cuenta</a></li></ul></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Tareas\',\'task.task\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Tareas\',\'task.task\')\"><i class=\"fa fa-list-ul\"></i> <span class=\"nav-label\">Tareas</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_not\"><a ng-click=\"main.closeMenu()\"><i class=\"fa fa-bell\"></i> <span class=\"nav-label\">Notificaciones</span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Nueva notificación\',\'notificaciones.main\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Nueva Notificación\',\'notificaciones.main\')\">Nueva</a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Lista de notificaciones\',\'notificaciones.listado\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Lista de notificaciones\',\'notificaciones.listado\')\">Listado</a></li></ul></li><li ui-sref-active=\"active\" context=\"context1\" ng-if=\"main.acceso_configuracion\"><a><i class=\"fa fa-cogs\"></i> <span class=\"nav-label\">Configuración</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-second-level nav-second-level1 collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Configuración\',\'config.configCampos\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Configuración\',\'config.configCampos\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-filter\"></i> <span class=\"nav-label\">Filtros</span></a></li><li ui-sref-active=\"active\"><a ng-click=\"main.closeMenu()\" ui-sref=\"cedula.cedula\" class=\"nav-second-level-custom\"><i class=\"fa fa-file-text-o\"></i> <span class=\"nav-label\">Cédula</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_cor\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Correos Automáticos\',\'emails.config\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Correos Automáticos\',\'emails.config\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-envelope-o\"></i> <span class=\"nav-label\">Correos Automáticos</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'whatsapp\',\'emails.whatsapp\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Recordatorio Pago vía Whatsapp/SMS\',\'emails.whatsapp\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-whatsapp\" aria-hidden=\"true\"></i> <span class=\"nav-label\">Whatsapp/SMS</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_age\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Agenda\',\'agenda.agenda\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Agenda\',\'agenda.agenda\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-calendar\"></i> <span class=\"nav-label\">Agenda</span></a></li><li ui-sref-active=\"active\" context=\"context1\"><a class=\"nav-second-level-custom\"><i class=\"fa fa-info\"></i> <span class=\"nav-label\">Portal clientes</span> <span class=\"fa plus-minus\"></span></a><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Formatos\',\'ibis.formatos\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Formatos\',\'ibis.formatos\')\" class=\"nav-third-level-custom\"><span class=\"nav-label\">Formatos</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Plantillas para Compartir Siniestros por WhatsApp Web\',\'ibis.formatosPlantillasWhatsappSiniestros\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Plantillas para Compartir Siniestros por WhatsApp Web\',\'ibis.formatosPlantillasWhatsappSiniestros\')\" class=\"nav-third-level-custom\"><span class=\"nav-label\">Plantillas WhatsApp Web (Siniestros)</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Directorio\',\'ibis.directorio\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Directorio\',\'ibis.directorio\')\" class=\"nav-third-level-custom\"><span class=\"nav-label\">Directorio</span></a></li></ul></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Sucursales\',\'sucursal.config\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Sucursales\',\'sucursal.config\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-houzz\"></i> <span class=\"nav-label\">Sucursales</span></a></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'SMTP\',\'emails.smtp\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'SMTP\',\'emails.smtp\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i> <span class=\"nav-label\">SMTP</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.acceso_adm_tas\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'AdminTareas\',\'task.admin\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'AdminTareas\',\'task.admin\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i> <span class=\"nav-label\">AdminTareas</span></a></li><li ng-if=\"main.userLogin.name ==\'superuser_ancora\' || main.userLogin.name ==\'superuser_ancora2\' || main.userLogin.name ==\'odolores\' || main.userLogin.name ==\'dsalgado\'\" ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'medicosCelulas\',\'medicoscelulas.configuracion\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Médicos\',\'medicoscelulas.configuracion\')\" class=\"nav-second-level-custom\"><i class=\"fa fa-hospital-o\" aria-hidden=\"true\"></i> <span class=\"nav-label\">Médicos-Células</span></a></li></ul></li><li ui-sref-active=\"active\" context=\"context1\" ng-right-click=\"ShowContextMenu(\'Ayuda\',\'help.manual\')\"><a ng-click=\"main.closeMenu(); open_in_same_tab(\'Ayuda\',\'help.manual\')\"><i class=\"fa fa-question-circle\"></i> <span class=\"nav-label\">Ayuda</span></a></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom nav-header nav-header-Miurabox\"><nav class=\"margin-bottom-0\" role=\"navigation\"><div class=\"col-xs-12 navbar-header\"><div ng-if=\"licencia\"><div style=\"padding: 12px 24px; background-color: #ff0000; color: #ffffff; font-size: 24px font-weight: 700; text-align: center; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;\"><span>Su licencia de uso esta VENCIDA. Su licencia en breve sera desactivada. Contactar a finanzas@miurabox.com</span></div></div><div class=\"row row-flex\"><div class=\"col-xs-2 col-sm-1 hamburger-icon\"><div class=\"row\"><span minimaliza-sidebar=\"\"></span></div></div><div class=\"col-xs-8 col-sm-10 search-bar\"><div class=\"row\"><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" ng-enter=\"main.submit(\'Buscador\', \'buscador.buscador\', main.cadena)\"><div class=\"col-xs-12 form-group\"><div class=\"row\"><div class=\"input-group\" style=\"z-index: 0\"><span><input class=\"form-control mi-input search-custom\" style=\"background-color: rgba(180,180,180,0.8); height: 34px; margin-top: 13px;\" placeholder=\"Póliza, asegurado, contratante, ramo, subramo, RFC, teléfono...\" ng-model=\"main.cadena\" name=\"top-search\" id=\"top-search\" type=\"search\"> <i class=\"fa fa-times-circle color-white pull-right\" ng-if=\"main.cadena\" ng-click=\"main.clearInput(main.cadena)\" style=\"position: absolute; top: 20px; right: 80px; font-size: 20px; z-index: 3000\"></i></span> <span class=\"input-group-btn\"><button ng-click=\"main.submit(\'Buscador\', \'buscador.buscador\', main.cadena)\" class=\"btn-sm btn-default\" style=\"margin-top: 13px;\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div></form></div></div><div id=\"small-assistant\" style=\"display: none;\"><a ng-if=\"!assistantStart\" class=\"open-small-assistant\" ng-click=\"openAssistant()\"><i class=\"fa fa-ils\"></i></a> <a ng-if=\"assistantStart\" class=\"open-small-assistant\" ng-click=\"closeAssistant()\"><i class=\"fa fa-times\"></i></a></div><div id=\"box-assistant\" class=\"small-assistant-box fadeInRight animated active\" ng-if=\"assistantStart\" style=\"z-index: 1000;\"><div class=\"header-assistant\" draggable=\"true\" ng-click=\"minimizerAssistant()\"><label class=\"title-assistant\">ASISTENTE <span class=\"notification-assistant\" ng-if=\"minimizer && num_noti != 0\">{{ num_noti }}</span></label></div><div class=\"content-assistant\"><div class=\"scrollingContainer\" ng-repeat=\"msg in main.chat_assistant\"><div class=\"container-left\" ng-if=\"msg.owner == \'ia\'\"><div class=\"status-assistant\" ng-if=\"msg.actual == true\"><span ng-if=\"msg.message != \'Escribiendo...\'\"><i class=\"fa fa-ils\"></i></span> <span ng-if=\"msg.message == \'Escribiendo...\'\"><i class=\"fa fa-ellipsis-h\"></i></span></div><div class=\"status-assistant-false\" ng-if=\"msg.actual != true\"></div><div class=\"cloud-left\" ng-if=\"msg.owner == \'ia\'\"><div style=\"word-wrap: break-word;overflow-x: auto\"><span ng-bind-html=\"msg.message.text\"></span></div><div ng-repeat=\"btn in msg.message.buttons\"><a class=\"btn-chat\" ng-click=\"sendAssistantMessage(1, btn.payload)\">{{ btn.title }}</a></div><img class=\"img-chat\" ng-src=\"{{msg.message.image}}\"></div></div><div class=\"cloud-right\" ng-if=\"msg.owner == \'user\'\">{{ msg.message }}</div></div></div><div class=\"footer-assistant\"><textarea class=\"text-question\" ng-model=\"main.message_assistant\"></textarea> <button class=\"btn-assistant\" type=\"button\" ng-click=\"sendAssistantMessage(2, main.message_assistant)\">enviar</button></div></div><div class=\"col-xs-2 col-sm-1 settings-icon\"><div class=\"row\"><ul class=\"nav navbar-top-links\"><li><div class=\"dropdown\"><button class=\"dropdown-toggle btn btn-outline btn-default btn-menu count-info\" type=\"button\" id=\"configDropdown\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\" ng-click=\"main.getNotifications(); seeNot(main.seeNotification);\" title=\"Notificaciones\"><i class=\"fa fa-globe color-white\" aria-hidden=\"true\"></i> <span class=\"label label-warning\" ng-if=\"notificationscount > 0\">{{notificationscount}}</span> <span class=\"label label-danger\" ng-if=\"notificationscount > 0 && main.color == 1\">{{notificationscount}}</span></button></div><div class=\"dropdown\" ng-if=\"main.seeNotification\"><ul ng-disabled=\"true\" class=\"dropdown-menu pull-right press\" aria-labelledby=\"configDropdown\" id=\"config2\"><li ng-repeat=\"notification in main.notifications.results track by $index\" ng-click=\"goToTask(notification)\"><a ng-class=\"{notseen : notification.seen == false}\" style=\"cursor: auto;\"><i class=\"fa fa-users\" ng-if=\"notification.involucrado\"></i> <i class=\"fa fa-user\" ng-if=\"!notification.involucrado\"></i> <span>{{notification.title }}</span><div ng-if=\"notification.model == 26\"><span><b><a href=\"{{notification.description}}\" target=\"_blank\" style=\"font-size: 10px; color:black\"><u>Descargar el reporte</u></a></b>{{notification.created_at | date:\'dd/MM/yy h:mm:ss a\'}}</span></div><div ng-if=\"notification.model == 15\"><span style=\"font-size: 10px\"><b>{{notification.description}}</b>- {{notification.created_at | date:\'dd/MM/yy h:mm:ss a\'}}</span></div><div ng-if=\"notification.model != 26 && notification.model !=15\"><span style=\"font-size: 10px\"><b>{{notification.description}}</b>- {{notification.created_at | date:\'dd/MM/yy h:mm:ss a\'}}</span></div></a><hr role=\"separator\" class=\"divider\"></li><li ng-if=\"main.notifications.results.length > 0 && main.notifications.next\" ng-click=\"main.loadMoreNotifications(); $event.stopPropagation();\"><a style=\"cursor: auto;\"><i class=\"fa fa-get-pocket\"></i> <span>Cargar anteriores</span></a></li><li ng-if=\"main.notifications.results.length == 0\"><a style=\"cursor: auto;\"><i class=\"fa fa-info-circle\"></i> <span><b>&nbsp; No hay notificaciones para mostrar</b></span></a></li></ul></div></li></ul></div></div><div class=\"col-xs-2 col-sm-1 settings-icon\"><div class=\"row\"><ul class=\"nav navbar-top-links\"><li><div class=\"dropdown\"><button class=\"dropdown-toggle btn btn-outline btn-default btn-menu count-info\" type=\"button\" id=\"configDropdown\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\" ng-click=\"main.changeViewed(1)\" title=\"Cumpleañeros\"><i class=\"fa fa-birthday-cake color-white\" aria-hidden=\"true\"></i> <span class=\"label label-warning\" ng-if=\"!main.viewed && main.persons_length\">{{ main.persons_length }}</span></button><ul class=\"dropdown-menu pull-right\" aria-labelledby=\"configDropdown\"><li ng-repeat=\"person in main.contractors track by $index\"><a><i class=\"fa fa-birthday-cake\"></i> <span ng-if=\"person[0]\">{{ person[0] }}</span> <span ng-if=\"!person[0]\">{{ person[1] }} {{ person[2] }} <span ng-if=\"person[3]\">{{ person[3] }}</span></span><div><span style=\"font-size: 10px\"><b>Contratante</b></span></div></a><hr role=\"separator\" class=\"divider\"></li><li ng-repeat=\"person in main.titulares track by $index\"><a><i class=\"fa fa-birthday-cake\"></i> <span ng-if=\"person[0]\">{{ person[0] }}</span> <span ng-if=\"!person[0]\">{{ person[1] }} {{ person[2] }} <span ng-if=\"person[3]\">{{ person[3] }}</span></span><div><span style=\"font-size: 10px\"><b>Titular</b></span></div></a><hr role=\"separator\" class=\"divider\"></li><li ng-repeat=\"person in main.beneficiaries track by $index\"><a><i class=\"fa fa-birthday-cake\"></i> <span ng-if=\"person[0]\">{{ person[0] }}</span> <span ng-if=\"!person[0]\">{{ person[1] }} {{ person[2] }} <span ng-if=\"person[3]\">{{ person[3] }}</span></span><div><span style=\"font-size: 10px\"><b>Beneficiario</b></span></div></a><hr role=\"separator\" class=\"divider\"></li><li ng-repeat=\"person in main.relationship track by $index\"><a><i class=\"fa fa-birthday-cake\"></i> <span ng-if=\"person[0]\">{{ person[0] }}</span> <span ng-if=\"!person[0]\">{{ person[1] }} {{ person[2] }} <span ng-if=\"person[3]\">{{ person[3] }}</span></span><div><span style=\"font-size: 10px\"><b>Dependiente</b></span></div></a><hr role=\"separator\" class=\"divider\"></li></ul></div></li></ul></div></div><div class=\"col-xs-2 col-sm-1 settings-icon\"><div class=\"row\"><ul class=\"nav navbar-top-links\"><li><div class=\"dropdown\"><button class=\"dropdown-toggle btn btn-outline btn-default btn-menu count-info\" type=\"button\" id=\"configDropdown\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\" ng-click=\"main.changeViewed(2)\" title=\"Historial de cambios\"><i class=\"fa fa-eye color-white\" aria-hidden=\"true\"></i> <span class=\"label label-warning\" ng-if=\"!main.viewed_changes && main.changes.length\">{{ main.changes.length }}</span></button><ul class=\"dropdown-menu pull-right\" aria-labelledby=\"configDropdown\"><li ng-repeat=\"change in main.changes track by $index\"><a style=\"cursor: auto;\"><i class=\"fa fa-upload\" ng-if=\"change.type == 1\"></i> <i class=\"fa fa-times\" ng-if=\"change.type == 2\"></i> <span>{{change.desc }}</span></a><hr role=\"separator\" class=\"divider\"></li></ul></div></li></ul></div></div><div class=\"col-xs-2 col-sm-1 settings-icon\"><div class=\"row\"><ul class=\"nav navbar-top-links\"><li><div class=\"dropdown\"><button class=\"dropdown-toggle btn btn-outline btn-default btn-menu\" type=\"button\" id=\"configDropdown\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\" title=\"Configuración\"><i class=\"fa fa-cog color-white\" aria-hidden=\"true\"></i></button><ul class=\"dropdown-menu pull-right\" aria-labelledby=\"configDropdown\"><li><a ng-click=\"main.logout()\"><i class=\"fa fa-sign-out\"></i> &nbsp;Cerrar sesión</a></li><li role=\"separator\" class=\"divider\"></li><li><a ng-click=\"main.block()\"><i class=\"fa fa-lock\" aria-hidden=\"true\"></i> &nbsp; Bloquear</a></li></ul></div></li></ul></div></div></div></div></nav></div><style type=\"text/css\">\n    .notseen{\n        background: #f5f5f5;\n        mouse-ove\n    }\n</style><script>\n\n  $(document).ready(function(){ \n      \n\n      var $content, $modal, $apnData, $modalCon; \n\n      $content = $(\".min\");   \n      $(\"#top-search-other\").click(function(e){\n        console.log(\'openmxmssssm\')\n        $(\"#modal-1\").modal();\n        $(\"modal-1\").modal({backdrop: \'static\', keyboard: false}); \n      });\n\n      //To fire modal\n      $(\".mdlFire\").click(function(e){\n\n          e.preventDefault();\n\n          var $id = $(this).attr(\"data-target\"); \n\n          $($id).modal({backdrop: false, keyboard: false}); \n          $(\'#modal-1\').on(\'hide.bs.modal\', function (e) {\n            e.preventDefault();\n            e.stopPropagation();\n            return false;\n          });\n\n        }); \n \n      $(\"#modal-1\").click(function(){\n          $(\"#modal-1\").modal({backdrop: \"static\"});\n      });\n      $(\".modalMinimize\").on(\"click\", function(){\n\n                  $modalCon = $(this).closest(\".mymodal\").attr(\"id\");  \n\n                  $apnData = $(this).closest(\".mymodal\");\n\n                  $modal = \"#\" + $modalCon;\n                  $(\".modal-backdrop\").addClass(\"display-none\");   \n\n                  $($modal).toggleClass(\"min\");  \n\n                    if ( $($modal).hasClass(\"min\") ){ \n\n                        $(\".minmaxCon\").append($apnData);  \n\n                        $(this).find(\"i\").toggleClass( \'fa-minus\').toggleClass( \'fa-clone\');\n\n                      } \n                      else { \n\n                              $(\".container\").append($apnData); \n\n                              $(this).find(\"i\").toggleClass( \'fa-clone\').toggleClass( \'fa-minus\');\n\n                            };\n\n                  });\n        // $(\'#modal-1\').modal({backdrop: \'static\', keyboard: false})\n        // $(\'.inmodal\').modal({backdrop: \'static\', keyboard: false})\n        // $(\"button[data-dismiss=\'modal\']\").click(function(){ \n        $(\"button[data-dismiss=\'inmodal\']\").click(function(){   \n                $(\".modal-header\").click(function(){\n                  // $(\".modal-body\").slideToggle();\n                  // $(\".inmodal\").slideToggle();\n                  $(\".inmodal\").hide();\n                });  \n\n                $(this).closest(\".mymodal\").removeClass(\"min\");\n\n                $(\".container\").removeClass($apnData);   \n\n                $(this).next(\'.modalMinimize\').find(\"i\").removeClass(\'fa fa-clone\').addClass( \'fa fa-minus\');\n\n              }); \n\n  });\n\n</script><style type=\"text/css\">\n    .container{max-width:1170px; margin:auto;}\nimg{ max-width:100%;}\n.inbox_people {\n  background: #f8f8f8 none repeat scroll 0 0;\n  float: left;\n  overflow: hidden;\n  width: 100%; border-right:1px solid #c4c4c4;\n}\n.inbox_msg {\n  border: 1px solid #c4c4c4;\n  clear: both;\n  overflow: hidden;\n}\n.top_spac{ margin: 20px 0 0;}\n\n\n.recent_heading {float: left; width:40%;}\n.srch_bar {\n  display: inline-block;\n  text-align: right;\n  width: 60%; padding:\n}\n.headind_srch{ padding:10px 29px 10px 20px; overflow:hidden; border-bottom:1px solid #c4c4c4;}\n\n.recent_heading h4 {\n  color: #05728f;\n  font-size: 21px;\n  margin: auto;\n}\n.srch_bar input{ border:1px solid #cdcdcd; border-width:0 0 1px 0; width:80%; padding:2px 0 4px 6px; background:none;}\n.srch_bar .input-group-addon button {\n  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;\n  border: medium none;\n  padding: 0;\n  color: #707070;\n  font-size: 18px;\n}\n.srch_bar .input-group-addon { margin: 0 0 0 -27px;}\n\n.chat_ib h5{ font-size:15px; color:#464646; margin:0 0 8px 0;}\n.chat_ib h5 span{ font-size:13px; float:right;}\n.chat_ib p{ font-size:14px; color:#989898; margin:auto}\n.chat_img {\n  float: left;\n  width: 11%;\n}\n.chat_ib {\n  float: left;\n  padding: 0 0 0 15px;\n  width: 88%;\n}\n\n.chat_people{ overflow:hidden; clear:both;}\n.chat_list {\n  border-bottom: 1px solid #c4c4c4;\n  margin: 0;\n  padding: 18px 16px 10px;\n}\n.inbox_chat { height: 550px; overflow-y: scroll;}\n\n.active_chat{ background:#ebebeb;}\n\n.incoming_msg_img {\n  display: inline-block;\n  width: 6%;\n}\n.received_msg {\n  display: inline-block;\n  padding: 0 0 0 10px;\n  vertical-align: top;\n  width: 92%;\n }\n .received_withd_msg p {\n  background: #ebebeb none repeat scroll 0 0;\n  border-radius: 3px;\n  color: #646464;\n  font-size: 14px;\n  margin: 0;\n  padding: 5px 10px 5px 12px;\n  width: 100%;\n}\n.time_date {\n  color: #747474;\n  display: block;\n  font-size: 12px;\n  margin: 8px 0 0;\n}\n.received_withd_msg { width: 57%;}\n.mesgs {\n  float: left;\n  padding: 30px 15px 0 25px;\n  width: 60%;\n}\n\n .sent_msg p {\n  background: #05728f none repeat scroll 0 0;\n  border-radius: 3px;\n  font-size: 14px;\n  margin: 0; color:#fff;\n  padding: 5px 10px 5px 12px;\n  width:100%;\n}\n.outgoing_msg{ overflow:hidden; margin:26px 0 26px;}\n.sent_msg {\n  float: right;\n  width: 46%;\n}\n.input_msg_write input {\n  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;\n  border: medium none;\n  color: #4c4c4c;\n  font-size: 15px;\n  min-height: 48px;\n  width: 100%;\n}\n\n.type_msg {border-top: 1px solid #c4c4c4;position: relative;}\n.msg_send_btn {\n  background: #05728f none repeat scroll 0 0;\n  border: medium none;\n  border-radius: 50%;\n  color: #fff;\n  cursor: pointer;\n  font-size: 17px;\n  height: 33px;\n  position: absolute;\n  right: 0;\n  top: 11px;\n  width: 33px;\n}\n.messaging { padding: 0 0 50px 0;}\n.msg_history {\n  height: 516px;\n  overflow-y: auto;\n}\n\n.slimScrollDiv{\n    height: 180px;\n    overflow-y: auto;\n}\n</style>");
$templateCache.put("app/directivas/calculateReceipts/calculate.receipts.template.html","<fieldset><legend class=\"legend-title\" align=\"center\">Primas de Pólizas</legend><div class=\"ibox float-e-margins\"><form name=\"receiptsForm\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><label class=\"control-label\">Prima Neta <span class=\"color-red\">*</span></label> <input ng-model=\"poliza.primaNeta\" id=\"number\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\" ng-blur=\"calculateComision()\" ng-change=\"calculateInputs(\'primaNeta\',1)\" class=\"col-md-2 form-control\"></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><label class=\"control-label\">% Descuento</label> <input ng-model=\"poliza.descuento\" type=\"text\" ng-blur=\"calculateComision()\" ng-change=\"calculateInputs(\'descuento\',2)\" min=\"0\" maxlength=\"5\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><label class=\"control-label\" for=\"rpf\" ng-if=\"type == 1\">Recargo por Pago Fraccionado</label> <label class=\"control-label\" for=\"rpf\" ng-if=\"type == 2\">Gastos de expedición</label><input ng-model=\"poliza.rpf\" id=\"rpf\" ng-value=\"0.00\" class=\"form-control\" ng-change=\"calculateInputs(\'rpf\',3)\"></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><label for=\"derecho\" ng-if=\"type == 1\">Derecho de Póliza</label> <label for=\"derecho\" ng-if=\"type == 2\">Derechos</label> <input ng-model=\"poliza.derecho\" id=\"derecho\" ng-value=\"0.00\" class=\"form-control\" ng-change=\"calculateInputs(\'derecho\',4)\"></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><label for=\"sub-total\">Sub-Total</label> <input ng-model=\"poliza.subTotal\" id=\"subTotal\" class=\"form-control\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><label for=\"prima-total\">IVA de póliza</label> <input ng-model=\"poliza.iva\" class=\"form-control\" ng-value=\"0.00\" ng-change=\"editIva(\'iva\'); checkValue([$index], $event, \'iva\', 1)\"></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><label for=\"prima-total\">Prima Total</label> <input ng-model=\"poliza.primaTotal\" class=\"form-control\" ng-value=\"0.00\" ng-change=\"editPTotal(); checkValue([$index], $event, \'primaTotal\', 1)\"></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\" ng-if=\"type == 2 && permiso_comisiones\"><label for=\"prima-total\">Comision póliza</label> <input ng-model=\"poliza.comision_insurance\" class=\"form-control\" disabled=\"\"></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\" ng-if=\"type == 1\"><label class=\"control-label margin-bottom-0\" for=\"\">Derecho</label><div class=\"checkbox margin-top-10 margin-left-10\"><label><input ng-model=\"poliza.configDerecho\" type=\"checkbox\" ng-disabled=\"edit == false\"> Cargos sólo al primer recibo</label></div></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\" ng-if=\"type == 1\"><label class=\"control-label margin-bottom-0\" for=\"\">Recargo por Pago Fraccionado</label><div class=\"checkbox margin-top-10 margin-left-10\"><label><input ng-model=\"poliza.configRPF\" type=\"checkbox\" ng-disabled=\"edit == false\"> Cargos sólo al primer recibo</label></div></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><label class=\"control-label margin-bottom-0\" for=\"\">&nbsp;</label><div class=\"checkbox margin-top-10 margin-left-10\"><label><input ng-model=\"poliza.aplicarDescuento\" ng-change=\"activarDescuento(poliza.aplicarDescuento)\" type=\"checkbox\"> Calcular con descuento</label></div></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\" ng-if=\"type == 1\"><label class=\"control-label margin-bottom-0\" for=\"\">&nbsp;</label><div class=\"checkbox margin-top-10 margin-left-10\"><label><input ng-model=\"poliza.fy\" ng-change=\"firstYear(poliza.fy)\" type=\"checkbox\"> Sólo el primer año</label></div><input ng-if=\"poliza.pp\" type=\"text\" class=\"form-control\" ng-model=\"poliza.pp_percent_comision\" name=\"pp_percent_comision\"></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\" ng-if=\"type == 2\"><label class=\"control-label margin-bottom-0\" for=\"\">&nbsp;</label><div class=\"checkbox margin-top-10 margin-left-10\"><label><input ng-model=\"poliza.pp\" ng-change=\"activarPP(poliza.pp)\" type=\"checkbox\"> PP</label></div><input ng-if=\"poliza.pp\" type=\"text\" class=\"form-control\" ng-model=\"poliza.pp_percent_comision\" name=\"pp_percent_comision\"></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form- m-t\"><div ng-if=\"!noRecalculateReceipts\"><button class=\"col-xs-12 btn btn-success btn-shadow\" ng-if=\"!recibo_liquidado_conciliado\" ng-click=\"calculate(poliza)\" ng-disabled=\"!poliza.primaNeta || !active_calculate\">Calcular y generar recibos</button></div></div></div></div></form><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"receipts.length > 0\"><h3 class=\"legend-title\" align=\"center\">Recibos Generados</h3><hr></div></div><div class=\"row\" ng-repeat=\"receipt in receipts track by $index\" ng-if=\"receipt.status !=0 || receipt.status == \'Desactivado\'\"><div class=\"form-group col-xs-2\"><label>Recibo</label><br><span ng-if=\"receipt.status && receipt.status !== 3 && receipt.status !== 4 && showInput || !showInput\">{{receipt.recibo_numero ? receipt.recibo_numero : $index + 1}}</span> <input ng-if=\"showInput && receipt.status == 3 || showInput && receipt.status == 4 || showInput && !receipt.status\" class=\"form-control\" step=\"any\" ng-model=\"receipt.recibo_numero\" value=\"{{receipt.recibo_numero ? receipt.recibo_numero : $index + 1}}\" type=\"text\"></div><div class=\"form-group col-xs-2\"><label>Inicio Vigencia</label><br><span ng-if=\"receipt.status && receipt.status !== 3 && receipt.status !== 4 && showInput || !showInput\">{{receipt.startDate | date: \'dd-MM-yyyy\' : \'UTC\' }}</span><div class=\"datepicker-me\" ng-if=\"showInput && receipt.status == 3 || showInput && receipt.status == 4 || showInput && !receipt.status\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"receipt.startDate\" value=\"{{receipt.startDate}}\"></div></div><div class=\"form-group col-xs-2\"><label>Fin Vigencia</label><br><span ng-if=\"receipt.status && receipt.status !== 3 && receipt.status !== 4 && showInput || !showInput\">{{receipt.endingDate | date: \'dd-MM-yyyy\' : \'UTC\' }}</span><div class=\"datepicker-me\" ng-if=\"showInput && receipt.status == 3 || showInput && receipt.status == 4 || showInput && !receipt.status\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"receipt.endingDate\" value=\"{{receipt.endingDate}}\"></div></div><div class=\"form-group col-xs-2\"><label>Prima Neta</label><br><span ng-if=\"receipt.status && receipt.status !== 3 && receipt.status !== 4 && showInput || !showInput\">{{receipt.prima | currency}}</span> <input ng-if=\"showInput && receipt.status == 3 || showInput && receipt.status == 4 || showInput && !receipt.status\" ng-model=\"receipt.prima\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 1)\" ng-change=\"recalc_receipt(receipt, $index)\"></div><div class=\"form-group col-xs-2\"><label>RPF</label><br><span ng-if=\"receipt.status && receipt.status !== 3 && receipt.status !== 4 && showInput || !showInput\">{{receipt.rpf | currency}}</span> <input ng-if=\"showInput && receipt.status == 3 || showInput && receipt.status == 4 || showInput && !receipt.status\" ng-model=\"receipt.rpf\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 2)\" ng-change=\"recalc_receipt(receipt, $index)\"></div><div class=\"form-group col-xs-2\"><label>Derecho</label><br><span ng-if=\"receipt.status && receipt.status !== 3 && receipt.status !== 4 && showInput || !showInput\">{{receipt.derecho | currency}}</span> <input ng-if=\"showInput && receipt.status == 3 || showInput && receipt.status == 4 || showInput && !receipt.status\" ng-model=\"receipt.derecho\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 3)\" ng-change=\"recalc_receipt(receipt, $index)\"></div><div class=\"form-group col-xs-2\"><label>IVA</label><br><span ng-if=\"receipt.status && receipt.status !== 3 && receipt.status !== 4 && showInput || !showInput\">{{ receipt.iva | currency}}</span> <input ng-if=\"poliza.iva; showInput && receipt.status == 3 || showInput && receipt.status == 4 || showInput && !receipt.status\" ng-model=\"receipt.iva\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 4)\"></div><div class=\"form-group col-xs-2\"><label>Prima Total</label><br><span ng-if=\"receipt.status && receipt.status !== 3 && receipt.status !== 4 && showInput || !showInput\">{{receipt.total | currency}}</span> <input ng-if=\"showInput && receipt.status == 3 || showInput && receipt.status == 4 || showInput && !receipt.status\" ng-model=\"receipt.total\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 5)\"></div><div class=\"form-group col-xs-2\" ng-if=\"permiso_comisiones\"><label>Comisión</label><br><span ng-if=\"receipt.status && receipt.status !== 3 && receipt.status !== 4 && showInput || !showInput\">{{receipt.comision | currency}}</span> <input ng-if=\"showInput && receipt.status == 3 || showInput && receipt.status == 4 || showInput && !receipt.status\" ng-model=\"receipt.comision\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 6)\" ng-change=\"recalc_receipt(receipt, $index)\"></div><div class=\"form-group col-xs-2\"><label>Vencimiento</label><br><span ng-if=\"receipt.status && receipt.status !== 3 && receipt.status !== 4 && showInput || !showInput\">{{receipt.vencimiento | date: \'dd-MM-yyyy\' : \'UTC\' }}</span><div class=\"datepicker-me\" ng-if=\"showInput && receipt.status == 3 || showInput && receipt.status == 4 || showInput && !receipt.status\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"receipt.vencimiento\" ng-change=\"checkVenDate(receipt)\"></div></div><div class=\"form-group col-xs-2\"><label>Entregado</label><br><input type=\"checkbox\" ng-model=\"receipt.delivered\"></div><div class=\"form-group col-xs-2\" ng-if=\"showInput && canDeleteReceipts\"><label>Eliminar</label><br><button class=\"btn btn-danger\" ng-click=\"delete_receipt($event, receipt, $index,poliza)\"><i class=\"fa fa-trash\"></i></button></div><div class=\"form-group col-xs-12\"><legend class=\"legend-title\" align=\"center\" <=\"\" legend=\"\"></legend></div></div><div class=\"row\" ng-if=\"receipts.length > 0\"><div ng-if=\"!noRecalculateReceipts\"><div class=\"col-xs-12\"><button ng-if=\"receipts.length; !showInput\" type=\"button\" class=\"btn btn-primary btn-shadow pull-right\" ng-click=\"editTable()\"><i class=\"fa fa-pencil-square-o btn-shadow\" aria-hidden=\"true\"></i> Editar Recibo</button> <button ng-if=\"receipts.length; showInput\" type=\"button\" class=\"btn btn-success btn-shadow pull-right\" ng-click=\"editTable(\'save\')\"><i class=\"fa fa-floppy-o btn-shadow\" aria-hidden=\"true\"></i> Guardar cambios</button></div></div></div></div></fieldset>");
$templateCache.put("app/directivas/calculateReceipts/endorsement.receipts.template.html","<div><div class=\"form-group col-xs-12\"><legend class=\"legend-title\" align=\"center\">Recibos del endoso</legend></div><div><div class=\"form-group col-xs-12 col-md-3 col-sm-6\"><h5>Prima Neta: <span class=\"color-red\">*</span></h5><input value=\"\" class=\"form-control\" id=\"prima-neta\" ng-model=\"endoso.primaNeta\" ng-change=\"calculateInputs(endoso,1)\"></div><div class=\"form-group col-xs-12 col-md-3 col-sm-6\"><h5>RPF:</h5><input value=\"\" class=\"form-control\" id=\"rpf\" ng-model=\"endoso.rpf\" ng-change=\"calculateInputs(endoso,3)\"></div><div class=\"form-group col-xs-12 col-md-3 col-sm-6\"><h5>Derecho: <span class=\"color-red\">*</span></h5><input value=\"\" type=\"text\" class=\"form-control\" id=\"derecho\" ng-model=\"endoso.derecho\" ng-change=\"calculateInputs(endoso,4)\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><h5>Sub-Total:</h5><input value=\"\" class=\"form-control\" id=\"sub-total\" ng-model=\"endoso.subTotal\" placeholder=\"\" disabled=\"\" format-as-currency=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><h5>IVA:</h5><input value=\"\" class=\"form-control\" id=\"sub-total\" ng-model=\"endoso.iva\" ng-change=\"editIva(\'iva\');\" placeholder=\"\" format-as-currency=\"\"></div><div class=\"form-group col-xs-12 col-sm-6 col-md-3\"><h5>Prima Total:</h5><input value=\"\" class=\"form-control\" id=\"prima-total\" ng-model=\"endoso.primaTotal\" placeholder=\"\" ng-change=\"editPTotal()\"></div><hr><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><h5>Derecho</h5><div class=\"checkbox margin-top-10 margin-left-10\"><label><input id=\"configDerechoEndoso\" ng-model=\"endoso.configDerecho\" type=\"checkbox\"> Cargos sólo al primer recibo</label></div></div><div class=\"col-xs-12 col-sm-4 col-lg-3 form-group\"><h5>Recargo por Pago Fraccionado</h5><div class=\"checkbox margin-top-10 margin-left-10\"><label><input id=\"configRPFEndoso\" type=\"checkbox\" ng-model=\"endoso.configRPF\"> Cargos sólo al primer recibo</label></div></div><div class=\"col-xs-12 form-group\"><div ng-if=\"!noRecalculateReceipts\"><button class=\"col-xs-12 col-sm-4 col-lg-3 btn btn-success pull-right\" ng-disabled=\"!endoso.primaNeta || !endoso.derecho\" ng-click=\"calculate(endoso)\" id=\"calcularB\" type=\"button\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i> Calcular y generar recibos</button></div></div></div><div><div ng-repeat=\"receipt in receipts track by $index\"><div class=\"form-group col-xs-2\"><label>Recibo</label><br><span ng-if=\"!showInput\">{{receipt.recibo_numero ? receipt.recibo_numero : $index + 1}}</span> <input ng-if=\"showInput\" class=\"form-control\" step=\"any\" ng-model=\"receipt.recibo_numero\" value=\"{{receipt.recibo_numero ? receipt.recibo_numero : $index + 1}}\" type=\"text\"></div><div class=\"form-group col-xs-2\"><label>Inicio Vigencia</label><br><span ng-if=\"!showInput\">{{receipt.startDate | date: \'dd-MM-yyyy\' : \'UTC\' }}</span><div class=\"datepicker-me\" ng-if=\"showInput\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"receipt.startDate\" value=\"{{receipt.startDate}}\"></div></div><div class=\"form-group col-xs-2\"><label>Fin Vigencia</label><br><span ng-if=\"!showInput\">{{receipt.endingDate | date: \'dd-MM-yyyy\' : \'UTC\' }}</span><div class=\"datepicker-me\" ng-if=\"showInput\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"receipt.endingDate\" value=\"{{receipt.endingDate}}\"></div></div><div class=\"form-group col-xs-2\"><label>Prima Neta</label><br><span ng-if=\"!showInput\">{{receipt.prima | currency}}</span> <input ng-model=\"receipt.prima\" ng-if=\"showInput\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 1)\" ng-change=\"recalc_receipt(receipt, $index)\"></div><div class=\"form-group col-xs-2\"><label>RPF</label><br><span ng-if=\"!showInput\">{{receipt.rpf | currency}}</span> <input ng-model=\"receipt.rpf\" ng-if=\"showInput\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 2)\" ng-change=\"recalc_receipt(receipt, $index)\"></div><div class=\"form-group col-xs-2\"><label>Derecho</label><br><span ng-if=\"!showInput\">{{receipt.derecho | currency}}</span> <input ng-model=\"receipt.derecho\" ng-if=\"showInput\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 3)\" ng-change=\"recalc_receipt(receipt, $index)\"></div><div class=\"form-group col-xs-2\"><label>IVA</label><br><span ng-if=\"poliza.iva;!showInput\">{{ receipt.iva | currency}}</span> <input ng-if=\"poliza.iva; showInput\" ng-model=\"receipt.iva\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 4)\"></div><div class=\"form-group col-xs-2\"><label>Prima Total</label><br><span ng-if=\"!showInput\">{{receipt.total | currency}}</span> <input ng-model=\"receipt.total\" ng-if=\"showInput\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 5)\"></div><div class=\"form-group col-xs-2\" ng-show=\"permiso_comisiones\"><label>Comisión</label><br><span ng-if=\"!showInput\">{{receipt.comision | currency}}</span> <input ng-model=\"receipt.comision\" ng-if=\"showInput\" class=\"form-control\" ng-keypress=\"validateFloatKeyPress($event, receipt, $index, 6)\" ng-change=\"recalc_receipt(receipt, $index)\"></div><div class=\"form-group col-xs-2\"><label>Vencimiento</label><br><span ng-if=\"!showInput\">{{receipt.vencimiento | date: \'dd-MM-yyyy\' : \'UTC\' }}</span><div class=\"datepicker-me\" ng-if=\"showInput\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"receipt.vencimiento\" ng-change=\"checkVenDate(receipt)\"></div></div><div class=\"form-group col-xs-2\"><label>Entregado</label><br><input type=\"checkbox\" ng-model=\"receipt.delivered\"></div><div class=\"form-group col-xs-12\"><legend class=\"legend-title\" align=\"center\" <=\"\" legend=\"\"></legend></div></div><div ng-if=\"receipts.length > 0\"><div ng-if=\"!noRecalculateReceipts\"><div class=\"col-xs-12\"><button ng-if=\"receipts.length; !showInput\" type=\"button\" class=\"btn btn-primary btn-shadow pull-right\" ng-click=\"editTable()\"><i class=\"fa fa-pencil-square-o btn-shadow\" aria-hidden=\"true\"></i> Editar Recibo</button> <button ng-if=\"receipts.length; showInput\" type=\"button\" class=\"btn btn-success btn-shadow pull-right\" ng-click=\"editTable(\'save\')\"><i class=\"fa fa-floppy-o btn-shadow\" aria-hidden=\"true\"></i> Guardar cambios</button></div></div></div></div></div>");
$templateCache.put("app/directivas/calculateReceipts/receiptsColectivo.html","<div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\" ng-if=\"type == 1\">Primas</legend><legend class=\"legend-title\" align=\"center\" ng-if=\"type == 2\">Suma de Primas</legend></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Configuración: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"comision_seleccion\" ng-options=\"item as (\'Nombre: \' + item.nombre + \', Comisión Prima: \' + item.comission + \'%, Fecha Efectividad: \'+ item.efective_date) for item in form.comisiones\" ng-change=\"asignarValores(comision_seleccion)\" ng-focus=\"verComisiones()\" ng-disabled=\"type == 2\"><option value=\"\" disabled=\"\">Seleccione una Configuración:</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"type == 3\"><label>Porcentaje de Siniestralidad: <span class=\"color-red\">*</span></label><div class=\"input-group\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"datareceipt.accident_rate\" ng-change=\"validarPorcentaje()\" ng-disabled=\"!comision_seleccion\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span></div></div></div><div class=\"row\" ng-if=\"type == 3\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-repeat=\"escalon in arreglo_escalones\"><label>Escalon {{ $index + 1 }}: <span class=\"color-red\">*</span></label><div class=\"input-group\"><span class=\"input-group-btn\"><button class=\"btn btn-warning\" ng-click=\"quitarEscalon($index)\" ng-disabled=\"arreglo_escalones.length == 1\"><i class=\"fa fa-minus\" aria-hidden=\"true\"></i></button></span> <input class=\"form-control m-b\" type=\"number\" ng-model=\"escalon.porcentaje\" ng-blur=\"sumarPorcentajes()\"> <span class=\"input-group-addon\"><i class=\"fa fa-percent\" aria-hidden=\"true\"></i></span> <span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-click=\"agregarEscalon()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></span></div></div><div class=\"col-xs-12 form-group\"><label>Total porcentaje de escalones: {{ suma_porcentaje }}%</label></div><div class=\"col-xs-12 form-group\" ng-if=\"comision_seleccion && editar\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Al selecionar los valores de comisión, se recalculan de nuevo las primas con los vaores predeterminados.</div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.primaNeta\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\"> <span>&nbsp;</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"type != 2\"><label>Descuento:</label><div class=\"col-xs-12\"><select class=\"col-xs-2 form-control\" ng-model=\"tipo_descuento\" ng-options=\"valor.name for valor in option_descuento\" ng-change=\"calcularTotales(tipo_descuento)\" ng-disabled=\"!comision_seleccion\" style=\"width: 30%;\"></select><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.descuento\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 70%;\"></div><div class=\"ml-16\"><span ng-if=\"tipo_descuento.value == 2 && datareceipt.descuento\">{{ descuentoPesos | currency }}</span> <span ng-if=\"tipo_descuento.value == 1 && datareceipt.descuento\">{{ descuentoPorcentaje }}%</span> <span title=\"Para aplicar el descuento tienes que seleccionar la casilla de Calcular con descuento.\"><i class=\"fa fa-question-circle\"></i></span><br></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Recargo Pago Fraccionado:</label><div class=\"col-xs-12\"><select class=\"col-xs-2 form-control\" ng-model=\"tipo_rpf\" ng-options=\"valor.name for valor in option_rpf\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 30%;\"></select><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.rpf\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 70%;\"></div><div class=\"ml-16\"><span ng-if=\"tipo_rpf.value == 2 && datareceipt.rpf\">{{ rpfPesos | currency }}</span> <span ng-if=\"tipo_rpf.value == 1 && datareceipt.rpf\">{{ rpfPorcentaje }}%</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho de póliza:</label><div class=\"col-xs-12\"><select ng-disabled=\"true\" class=\"col-xs-2 form-control\" ng-model=\"tipo_rpf\" ng-options=\"valor.name for valor in option_rpf\" ng-change=\"calcularTotales()\" style=\"width: 30%;\"></select><input style=\"width: 70%;\" class=\"form-control\" type=\"number\" ng-model=\"datareceipt.derecho\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" step=\".01\" ng-value=\"0.00\"></div><span>&nbsp;</span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sub Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"datareceipt.subTotal\" ng-change=\"calcularTotales()\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\" disabled=\"\"> <span>&nbsp;</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label><div class=\"col-xs-12\"><select class=\"col-xs-2 form-control\" ng-model=\"tipo_iva\" ng-options=\"valor.name for valor in option_iva\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 30%;\"></select><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.iva\" ng-change=\"calcularTotales(\'\',datareceipt.iva)\" ng-disabled=\"!comision_seleccion\" style=\"width: 70%;\"></div><div class=\"ml-16\"><span ng-if=\"tipo_iva.value == 2 && datareceipt.iva\">{{ ivaPesos | currency }}</span> <span ng-if=\"tipo_iva.value == 1 && datareceipt.iva\">{{ ivaPorcentaje }}%</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"datareceipt.primaTotal\" ng-disabled=\"!comision_seleccion\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"> <span>&nbsp;</span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Recargo por Pago Fraccionado:</label><div class=\"checkbox margin-left-10\"><label><input type=\"checkbox\" ng-model=\"datareceipt.aplicarRpf\"> Aplicar solo en el primer recibo</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho de póliza:</label><div class=\"checkbox margin-left-10\"><label><input type=\"checkbox\" ng-model=\"datareceipt.aplicarDerecho\"> Aplicar solo en el primer recibo</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"type != 2\"><label>&nbsp;</label><div class=\"checkbox margin-left-10\"><label><input type=\"checkbox\" ng-model=\"datareceipt.aplicarDescuento\" ng-change=\"calcularTotales()\"> Calcular con descuento</label></div></div></div><div class=\"row\"></div><div class=\"row\" ng-if=\"comision_seleccion\"><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Las comisiones son referencia para el cálculo de los recibos, los cambios que se hagan en ellas sólo se incluirán en esta póliza.</div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Prima Neta:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.prima_comision\" limit-to-decimals=\"\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_prima_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Recargo Pago Fraccionado:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.rpf_comision\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_rpf_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Derecho:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.derecho_comision\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_derecho_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Total:</label><div class=\"input-group\"><span class=\"input-group-addon\">$</span> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.comision\" ng-change=\"calcularComision()\"></div><span>{{ comisionPorcentaje }}%</span></div></div><div class=\"row\" ng-if=\"type != 3\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"calcularPrimerRecibo()\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i> Generar Primer Recibo</button></div></div><div class=\"row\" ng-if=\"type == 3\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-success m-t\" ng-click=\"calcularRecibosPrimaMinima()\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i> Calcular y Generar Recibos</button></div></div><div class=\"row\" ng-if=\"mostrarPrimerRecibo\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Primer recibo</legend></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Serie:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].recibo_numero\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Neta: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].prima_neta\" ng-change=\"calcularTotalPrimerRecibo()\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].rpf\" ng-change=\"calcularTotalPrimerRecibo()\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].derecho\" ng-change=\"calcularTotalPrimerRecibo()\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].iva\" ng-change=\"calcularTotalPrimerRecibo()\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].prima_total\"></div></div><div class=\"row\" ng-if=\"mostrarPrimerRecibo\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-success m-t\" ng-click=\"calcularSiguientesRecibos()\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i> Calcular y Generar Recibos</button></div></div><div class=\"row\" ng-if=\"mostrarTodosRecibo\"><legend class=\"legend-title\" align=\"center\">Recibos Generados</legend></div><div class=\"row\" ng-if=\"mostrarTodosRecibo && editar\"><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Los recibos no se pueden modificar desde la edición de la póliza, solo se podrán hacer desde la información de la póliza.</div></div></div><div class=\"row\" ng-repeat=\"receipt in datareceipt.receipts | orderBy : \'id\'\" ng-if=\"mostrarTodosRecibo && receipt.receipt_type == 1\"><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Serie</label><br><span ng-if=\"!editar_recibos\">{{ receipt.recibo_numero }} / {{ recibos_totales }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.recibo_numero\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Inicio Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.fecha_inicio }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.fecha_inicio\" ng-change=\"validarFechaInicio(receipt, $index)\" value=\"{{receipt.fecha_inicio}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Fin Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.fecha_fin }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.fecha_fin\" ng-change=\"validarFechaFin(receipt, $index)\" value=\"{{receipt.fecha_fin}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Neta</label><br><span ng-if=\"!editar_recibos\">{{ receipt.prima_neta | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_neta\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>RPF</label><br><span ng-if=\"!editar_recibos\">{{ receipt.rpf | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.rpf\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Derecho</label><br><span ng-if=\"!editar_recibos\">{{ receipt.derecho | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.derecho\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Iva</label><br><span ng-if=\"!editar_recibos\">{{ receipt.iva | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.iva\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Total</label><br><span ng-if=\"!editar_recibos\">{{ receipt.prima_total | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_total\" ng-change=\"recalcularTotal($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"permiso_comisiones || form.is_edit == false\"><label>Comisión</label><br><span ng-if=\"!editar_recibos\">{{ receipt.comision | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.comision\" ng-change=\"recalcularComision($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Vencimiento</label><br><span ng-if=\"!editar_recibos\">{{ receipt.vencimiento }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.vencimiento\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Entregado</label><br><input type=\"checkbox\" ng-model=\"receipt.delivered\"></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\"></legend></div></div><div class=\"row\" ng-repeat=\"receipt in datareceipt.receipts | orderBy : \'id\'\" ng-if=\"mostrarTodosRecibo && receipt.receipt_type == 3\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Nota de Crédito</legend></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Serie</label><br><span ng-if=\"!editar_recibos\">{{ receipt.recibo_numero }} / 1</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.recibo_numero\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Inicio Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.fecha_inicio }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.fecha_inicio\" ng-change=\"validarFechaInicio(receipt, $index)\" value=\"{{receipt.fecha_inicio}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Fin Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.fecha_fin }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.fecha_fin\" ng-change=\"validarFechaFin(receipt, $index)\" value=\"{{receipt.fecha_fin}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Neta</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.prima_neta | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_neta\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>RPF</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.rpf | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.rpf\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Derecho</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.derecho | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.derecho\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Iva</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.iva | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.iva\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Total</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.prima_total | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_total\" ng-change=\"recalcularTotal($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"permiso_comisiones || form.is_edit == false\"><label>Comisión</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.comision | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.comision\" ng-change=\"recalcularComision($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Vencimiento</label><br><span ng-if=\"!editar_recibos\">{{ receipt.vencimiento }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.vencimiento\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Entregado</label><br><input type=\"checkbox\" ng-model=\"receipt.delivered\"></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\"></legend></div></div><div class=\"row\" ng-if=\"mostrarTodosRecibo && recalcular\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\"><button class=\"col-xs-12 btn btn-primary\" ng-if=\"!editar_recibos\" ng-click=\"editarRecibos()\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> Editar Recibos</button> <button class=\"col-xs-12 btn btn-primary\" ng-if=\"editar_recibos\" ng-click=\"guardarRecibos()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Recibos</button></div></div></div>");
$templateCache.put("app/directivas/calculateReceipts/receiptsEndorsement.html","<div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Primas</legend></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Valores de Comisión: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"comision_seleccion\" ng-options=\"item as (\'Nombre: \' + item.nombre + \', Fecha Efectividad: \'+ item.efective_date) for item in form.comisiones\" ng-change=\"asignarValores(comision_seleccion)\" ng-focus=\"verComisiones()\"><option value=\"\" disabled=\"\">Selecciona una comisión</option></select></div><div class=\"col-xs-12 form-group\" ng-if=\"comision_seleccion && editar\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Al selecionar los valores de comisión, se recalculan de nuevo las primas con los vaores predeterminados.</div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label ng-if=\"type == 2\">Prima Neta: <span class=\"color-red\">*</span></label> <label ng-if=\"type == 1\">Prima Primera: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.primaNeta\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\"> <span>&nbsp;</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label><div class=\"col-xs-12\"><select class=\"col-xs-2 form-control\" ng-model=\"tipo_rpf\" ng-options=\"valor.name for valor in option_rpf\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 30%;\"></select><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.rpf\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 70%;\"></div><div class=\"ml-16\"><span ng-if=\"tipo_rpf.value == 2 && datareceipt.rpf\">{{ rpfPesos | currency }}</span> <span ng-if=\"tipo_rpf.value == 1 && datareceipt.rpf\">{{ rpfPorcentaje }}%</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Gastos:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.derecho\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\"> <span>&nbsp;</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sub Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"datareceipt.subTotal\" ng-change=\"calcularTotales()\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\" disabled=\"\"> <span>&nbsp;</span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label><div class=\"col-xs-12\"><select class=\"col-xs-2 form-control\" ng-model=\"tipo_iva\" ng-options=\"valor.name for valor in option_iva\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 30%;\"></select><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.iva\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 70%;\"></div><div class=\"ml-16\"><span ng-if=\"tipo_iva.value == 2 && datareceipt.iva\">{{ ivaPesos | currency }}</span> <span ng-if=\"tipo_iva.value == 1 && datareceipt.iva\">{{ ivaPorcentaje }}%</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"datareceipt.primaTotal\" ng-disabled=\"!comision_seleccion\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"> <span>&nbsp;</span></div></div><div class=\"row\" ng-if=\"type == 2\"></div><div class=\"row\" ng-if=\"comision_seleccion\"><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <span ng-if=\"type == 1\"><strong>Información:</strong> Las comisiones son referencia para el cálculo de los recibos, los cambios que se hagan en ellas sólo se incluirán en esta fianza.</span> <span ng-if=\"type == 2\"><strong>Información:</strong> Las comisiones son referencia para el cálculo de los recibos, los cambios que se hagan en ellas sólo se incluirán en este endoso.</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label ng-if=\"type == 1\">Comisión Prima Neta:</label> <label ng-if=\"type == 2\">Comisión Prima Primera:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.prima_comision\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_prima_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"type == 2\"><label>Comisión Recargo Pago Fraccionado:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.rpf_comision\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_rpf_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"type == 2\"><label>Comisión Derecho:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.derecho_comision\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_derecho_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Total:</label><div class=\"input-group\"><span class=\"input-group-addon\">$</span> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.comision\" ng-change=\"calcularComision()\"></div><span>{{ comisionPorcentaje }}%</span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"calcularPrimerRecibo()\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i> Generar Primer Recibo</button></div></div><div class=\"row\" ng-if=\"mostrarPrimerRecibo\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Primer recibo</legend></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Serie:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].recibo_numero\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label ng-if=\"type == 2\">Prima Neta: <span class=\"color-red\">*</span></label> <label ng-if=\"type == 1\">Prima Primera: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].prima_neta\" ng-change=\"calcularTotalPrimerRecibo()\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].rpf\" ng-change=\"calcularTotalPrimerRecibo()\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Gastos:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].derecho\" ng-change=\"calcularTotalPrimerRecibo()\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].iva\" ng-change=\"calcularTotalPrimerRecibo()\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].prima_total\" ng-style=\"noteColor\"></div></div><div class=\"row\" ng-if=\"mostrarPrimerRecibo\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-success m-t\" ng-click=\"calcularSiguientesRecibos()\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i> <span ng-if=\"type == 2\">Calcular y Generar Recibos</span> <span ng-if=\"type == 1\">Calcular y Generar Recibo</span></button></div></div><div class=\"row\" ng-if=\"mostrarTodosRecibo\"><legend class=\"legend-title\" ng-if=\"type == 2\" align=\"center\">Recibos Generados</legend><legend class=\"legend-title\" ng-if=\"type == 1\" align=\"center\">Recibo Generado</legend></div><div class=\"row\" ng-if=\"mostrarTodosRecibo && editar\"><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Los recibos no se pueden modificar desde la edición de la póliza, solo se podrán hacer desde la información de la póliza.</div></div></div><div class=\"row\" ng-repeat=\"receipt in datareceipt.receipts track by $index\" ng-if=\"mostrarTodosRecibo\"><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Serie</label><br><span ng-if=\"!editar_recibos\">{{ receipt.recibo_numero }} / {{ numeroRecibos }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.recibo_numero\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Inicio Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.startDate }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.startDate\" ng-change=\"validarFechaInicio(receipt, $index)\" value=\"{{receipt.startDate}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Fin Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.endingDate }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.endingDate\" ng-change=\"validarFechaFin(receipt, $index)\" value=\"{{receipt.endingDate}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label ng-if=\"type == 2\">Prima Neta</label> <label ng-if=\"type == 1\">Prima Primera</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.prima_neta | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_neta\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Derecho</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.rpf | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.rpf\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Gastos</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.derecho | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.derecho\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Iva</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.iva | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.iva\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Total</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.prima_total | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_total\" ng-change=\"recalcularTotal($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"permiso_comisiones\"><label>Comisión</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.comision | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.comision\" ng-change=\"recalcularComision($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Vencimiento</label><br><span ng-if=\"!editar_recibos\">{{ receipt.vencimiento }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.vencimiento\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Entregado</label><br><input type=\"checkbox\" ng-model=\"receipt.delivered\"></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\"></legend></div></div><div class=\"row\" ng-if=\"mostrarTodosRecibo && recalcular\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\"><button class=\"col-xs-12 btn btn-primary\" ng-if=\"!editar_recibos\" ng-click=\"editarRecibos()\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> <span ng-if=\"type == 2\">Editar Recibos</span> <span ng-if=\"type == 1\">Editar Recibo</span></button> <button class=\"col-xs-12 btn btn-primary\" ng-if=\"editar_recibos\" ng-click=\"guardarRecibos()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> <span ng-if=\"type == 2\">Guardar Recibos</span> <span ng-if=\"type == 1\">Guardar Recibo</span></button></div></div></div>");
$templateCache.put("app/directivas/calculateReceipts/receiptsEndoso.html","<div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Primas</legend></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Configuración: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"comision_seleccion\" ng-options=\"item as (\'Comisión Prima: \' + item.comission + \'%, Fecha Efectividad: \'+ item.efective_date) for item in form.comisiones\" ng-change=\"asignarValores(comision_seleccion)\" ng-focus=\"verComisiones()\" ng-disabled=\"type == 2\"><option value=\"\" disabled=\"\">Seleccione una Configuración:</option></select></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.primaNeta\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\"> <span>&nbsp;</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"form.endorsement_type == \'A\'\"><label>Descuento:</label><div class=\"col-xs-12\"><select class=\"col-xs-2 form-control\" ng-model=\"tipo_descuento\" ng-options=\"valor.name for valor in option_descuento\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 30%;\"></select><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.descuento\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 70%;\"></div><div class=\"ml-16\"><span ng-if=\"tipo_descuento.value == 2 && datareceipt.descuento\">{{ descuentoPesos | currency }}</span> <span ng-if=\"tipo_descuento.value == 1 && datareceipt.descuento\">{{ descuentoPorcentaje }}%</span> <span title=\"Para aplicar el descuento tienes que seleccionar la casilla de Calcular con descuento.\"><i class=\"fa fa-question-circle\"></i></span><br></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Recargo Pago Fraccionado:</label><div class=\"col-xs-12\"><select class=\"col-xs-2 form-control\" ng-model=\"tipo_rpf\" ng-options=\"valor.name for valor in option_rpf\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 30%;\"></select><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.rpf\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 70%;\"></div><div class=\"ml-16\"><span ng-if=\"tipo_rpf.value == 2 && datareceipt.rpf\">{{ rpfPesos | currency }}</span> <span ng-if=\"tipo_rpf.value == 1 && datareceipt.rpf\">{{ rpfPorcentaje }}%</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label ng-if=\"form.endorsement_type == \'A\'\">Derecho de póliza:</label> <label ng-if=\"form.endorsement_type == \'D\'\">Gastos de Expedición:</label> <input class=\"form-control\" type=\"text\" ng-model=\"datareceipt.derecho\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"> <span>&nbsp;</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sub Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"datareceipt.subTotal\" ng-change=\"calcularTotales()\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\" disabled=\"\"> <span>&nbsp;</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label><div class=\"col-xs-12\"><select class=\"col-xs-2 form-control\" ng-model=\"tipo_iva\" ng-options=\"valor.name for valor in option_iva\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 30%;\"></select><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.iva\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 70%;\"></div><div class=\"ml-16\"><span ng-if=\"tipo_iva.value == 2 && datareceipt.iva\">{{ ivaPesos | currency }}</span> <span ng-if=\"tipo_iva.value == 1 && datareceipt.iva\">{{ ivaPorcentaje }}%</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"datareceipt.primaTotal\" ng-change=\"changePrimaTotal(datareceipt.primaTotal)\" ng-disabled=\"!comision_seleccion\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"> <span>&nbsp;</span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Recargo por Pago Fraccionado:</label><div class=\"checkbox margin-left-10\"><label><input type=\"checkbox\" ng-model=\"datareceipt.aplicarRpf\"> Aplicar solo en el primer recibo</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label ng-if=\"form.endorsement_type == \'A\'\">Derecho de póliza:</label> <label ng-if=\"form.endorsement_type == \'D\'\">Gastos de Expedición:</label><div class=\"checkbox margin-left-10\"><label><input type=\"checkbox\" ng-model=\"datareceipt.aplicarDerecho\"> Aplicar solo en el primer recibo</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"type != 2\"><label>&nbsp;</label><div class=\"checkbox margin-left-10\"><label><input type=\"checkbox\" ng-model=\"datareceipt.aplicarDescuento\" ng-change=\"calcularTotales()\"> Calcular con descuento</label></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"form.policy_days_duration > 367 && type == 1\"><div class=\"checkbox margin-left-10\"><label><input type=\"checkbox\" ng-model=\"datareceipt.fy\"> Generar sólo el primer año</label></div></div></div><div class=\"row\" ng-if=\"comision_seleccion\"><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Las comisiones son referencia para el cálculo de los recibos, los cambios que se hagan en ellas sólo se incluirán en esta póliza.</div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Prima Neta:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.prima_comision\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_prima_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Recargo Pago Fraccionado:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.rpf_comision\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_rpf_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label ng-if=\"form.endorsement_type == \'A\'\">Comisión Derecho:</label> <label ng-if=\"form.endorsement_type == \'D\'\">Comisión Gastos:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.derecho_comision\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_derecho_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Total:</label><div class=\"input-group\"><span class=\"input-group-addon\">$</span> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.comision\" ng-change=\"calcularComision()\"></div><span>{{ comisionPorcentaje }}%</span></div></div><div class=\"row\" ng-if=\"form.num_receipts != 0\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"calcularPrimerRecibo()\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i> Generar Primer Recibo</button></div></div><div class=\"row\" ng-if=\"mostrarPrimerRecibo\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Primer recibo</legend></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Serie:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].recibo_numero\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Neta: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].prima_neta\" ng-change=\"calcularTotalPrimerRecibo()\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].rpf\" ng-change=\"calcularTotalPrimerRecibo()\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label ng-if=\"form.endorsement_type == \'A\'\">Derecho de póliza:</label> <label ng-if=\"form.endorsement_type == \'D\'\">Gastos de Expedición:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].derecho\" ng-change=\"calcularTotalPrimerRecibo()\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].iva\" ng-change=\"calcularTotalPrimerRecibo()\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].prima_total\" ng-change=\"calcularNetaPrimerRecibo()\" ng-style=\"noteColor\"></div></div><div class=\"row\" ng-if=\"mostrarPrimerRecibo\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-success m-t\" ng-click=\"calcularSiguientesRecibos()\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i> Calcular y Generar Recibos</button></div></div><div class=\"row\" ng-if=\"mostrarTodosRecibo && datareceipt.type_endorsement == \'A\'\"><legend class=\"legend-title\" align=\"center\">Recibos Generados</legend></div><div class=\"row\" ng-if=\"mostrarTodosRecibo && datareceipt.type_endorsement == \'D\'\"><legend class=\"legend-title\" align=\"center\">Nota de Crédito</legend></div><div class=\"row\" ng-if=\"mostrarTodosRecibo && editar\"><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Los recibos no se pueden modificar desde la edición de la póliza, solo se podrán hacer desde la información de la póliza.</div></div></div><div class=\"row\" ng-repeat=\"receipt in datareceipt.receipts | orderBy : \'id\'\" ng-if=\"mostrarTodosRecibo && (receipt.receipt_type == 1 || receipt.receipt_type == 2)\"><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Serie</label><br><span ng-if=\"!editar_recibos\">{{ receipt.recibo_numero }} / {{ recibos_totales }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.recibo_numero\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Inicio Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.fecha_inicio }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.fecha_inicio\" ng-change=\"validarFechaInicio(receipt, $index)\" value=\"{{receipt.fecha_inicio}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Fin Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.fecha_fin }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.fecha_fin\" ng-change=\"validarFechaFin(receipt, $index)\" value=\"{{receipt.fecha_fin}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Neta</label><br><span ng-if=\"!editar_recibos\">{{ receipt.prima_neta | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_neta\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>RPF</label><br><span ng-if=\"!editar_recibos\">{{ receipt.rpf | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.rpf\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label ng-if=\"form.endorsement_type == \'A\'\">Derecho de póliza:</label> <label ng-if=\"form.endorsement_type == \'D\'\">Gastos de Expedición:</label><br><span ng-if=\"!editar_recibos\">{{ receipt.derecho | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.derecho\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Iva</label><br><span ng-if=\"!editar_recibos\">{{ receipt.iva | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.iva\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Total</label><br><span ng-if=\"!editar_recibos\">{{ receipt.prima_total | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_total\" ng-change=\"recalcularTotal($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"permiso_comisiones\"><label>Comisión</label><br><span ng-if=\"!editar_recibos\">{{ receipt.comision | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.comision\" ng-change=\"recalcularComision($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Vencimiento</label><br><span ng-if=\"!editar_recibos\">{{ receipt.vencimiento }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.vencimiento\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Entregado</label><br><input type=\"checkbox\" ng-model=\"receipt.delivered\"></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\"></legend></div></div><div class=\"row\" ng-repeat=\"receipt in datareceipt.receipts | orderBy : \'id\'\" ng-if=\"mostrarTodosRecibo && receipt.receipt_type == 3\"><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Serie</label><br><span ng-if=\"!editar_recibos\">{{ receipt.recibo_numero }} / 1</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.recibo_numero\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Inicio Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.fecha_inicio }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.fecha_inicio\" ng-change=\"validarFechaInicio(receipt, $index)\" value=\"{{receipt.fecha_inicio}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Fin Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.fecha_fin }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.fecha_fin\" ng-change=\"validarFechaFin(receipt, $index)\" value=\"{{receipt.fecha_fin}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Neta</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.prima_neta | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_neta\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>RPF</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.rpf | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.rpf\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label ng-if=\"form.endorsement_type == \'A\'\">Derecho de póliza:</label> <label ng-if=\"form.endorsement_type == \'D\'\">Gastos de Expedición:</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.derecho | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.derecho\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Iva</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.iva | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.iva\" ng-change=\"recalcularRecibo($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Total</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.prima_total | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_total\" ng-change=\"recalcularTotal($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"permiso_comisiones\"><label>Comisión</label><br><span ng-if=\"!editar_recibos\" ng-style=\"noteColor\">{{ receipt.comision | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.comision\" ng-change=\"recalcularComision($index)\" ng-style=\"noteColor\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Vencimiento</label><br><span ng-if=\"!editar_recibos\">{{ receipt.vencimiento }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.vencimiento\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Entregado</label><br><input type=\"checkbox\" ng-model=\"receipt.delivered\"></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\"></legend></div></div><div class=\"row\" ng-if=\"mostrarTodosRecibo && recalcular\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\"><button class=\"col-xs-12 btn btn-primary\" ng-if=\"!editar_recibos\" ng-click=\"editarRecibos()\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> Editar Recibos</button> <button class=\"col-xs-12 btn btn-primary\" ng-if=\"editar_recibos\" ng-click=\"guardarRecibos()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Recibos</button></div></div></div>");
$templateCache.put("app/directivas/calculateReceipts/receiptsIndividual.html","<div><div class=\"row\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Primas</legend></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Configuración: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"comision_seleccion\" ng-options=\"item as (\'Nombre Comisión: \' + item.nombre + \', Comisión Prima: \' + item.comission + \'%, Fecha Efectividad: \'+ item.efective_date) for item in form.comisiones\" ng-change=\"asignarValores(comision_seleccion)\" ng-focus=\"verComisiones()\"><option value=\"\" disabled=\"\">Seleccione una Configuración:</option></select></div><div class=\"col-xs-12 form-group\" ng-if=\"comision_seleccion && editar\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Al selecionar los valores de comisión, se recalculan de nuevo las primas con los vaores predeterminados.</div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.primaNeta\" ng-change=\"calcularTotales();validarPrimaNeta()\" ng-disabled=\"!comision_seleccion\"> <span>&nbsp;</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Descuento:</label><div class=\"col-xs-12\"><select class=\"col-xs-2 form-control\" ng-model=\"tipo_descuento\" ng-options=\"valor.name for valor in option_descuento\" ng-change=\"calcularTotales(tipo_descuento)\" ng-disabled=\"!comision_seleccion\" style=\"width: 30%;\"></select><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.descuento\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 70%;\"></div><div class=\"ml-16\"><span ng-if=\"tipo_descuento.value == 2 && datareceipt.descuento\">{{ descuentoPesos | currency }}</span> <span ng-if=\"tipo_descuento.value == 1 && datareceipt.descuento\">{{ descuentoPorcentaje }}%</span> <span title=\"Para aplicar el descuento tienes que seleccionar la casilla de Calcular con descuento.\"><i class=\"fa fa-question-circle\"></i></span><br></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Recargo por Pago Fraccionado:</label><div class=\"col-xs-12\"><select class=\"col-xs-2 form-control\" ng-model=\"tipo_rpf\" ng-options=\"valor.name for valor in option_rpf\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 30%;\"></select><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.rpf\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 70%;\"></div><div class=\"ml-16\"><span ng-if=\"tipo_rpf.value == 2 && datareceipt.rpf\">{{ rpfPesos | currency }}</span> <span ng-if=\"tipo_rpf.value == 1 && datareceipt.rpf\">{{ rpfPorcentaje }}%</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho de póliza:</label><div class=\"input-group\"><span class=\"input-group-addon\">$</span> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.derecho\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sub Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"datareceipt.subTotal\" ng-change=\"calcularTotales()\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\" disabled=\"\"> <span>&nbsp;</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label><div class=\"col-xs-12\"><select class=\"col-xs-2 form-control\" ng-model=\"tipo_iva\" ng-options=\"valor.name for valor in option_iva\" ng-change=\"calcularTotales()\" ng-disabled=\"!comision_seleccion\" style=\"width: 30%;\"></select><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.iva\" ng-change=\"calcularTotales(\'\',datareceipt.iva)\" ng-disabled=\"!comision_seleccion\" style=\"width: 70%;\"></div><div class=\"ml-16\"><span ng-if=\"tipo_iva.value == 2 && datareceipt.iva\">{{ ivaPesos | currency }}</span> <span ng-if=\"tipo_iva.value == 1 && datareceipt.iva\">{{ ivaPorcentaje }}%</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"datareceipt.primaTotal\" ng-disabled=\"!comision_seleccion\" format-as-currency=\"\" step=\"0.01\" ng-value=\"0.00\"> <span>&nbsp;</span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Recargo por Pago Fraccionado:</label><div class=\"checkbox margin-left-10\"><label><input type=\"checkbox\" ng-model=\"datareceipt.aplicarRpf\"> Aplicar solo en el primer recibo</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho de póliza:</label><div class=\"checkbox margin-left-10\"><label><input type=\"checkbox\" ng-model=\"datareceipt.aplicarDerecho\"> Aplicar solo en el primer recibo</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>&nbsp;</label><div class=\"checkbox margin-left-10\"><label><input type=\"checkbox\" ng-model=\"datareceipt.aplicarDescuento\" ng-change=\"calcularTotales()\"> Calcular con descuento</label></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" ng-if=\"form.policy_days_duration > 367\"><div class=\"checkbox margin-left-10\"><label><input type=\"checkbox\" ng-model=\"datareceipt.fy\"> Generar sólo el primer año</label></div></div></div><div class=\"row\" ng-if=\"comision_seleccion\"><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Las comisiones son referencia para el cálculo de los recibos, los cambios que se hagan en ellas sólo se incluirán en esta póliza.</div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Prima Neta:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.prima_comision\" limit-to-decimals=\"\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_prima_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Recargo Pago Fraccionado:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.rpf_comision\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_rpf_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Derecho:</label><div class=\"input-group\"><input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.derecho_comision\" ng-change=\"calcularTotales()\"> <span class=\"input-group-addon\">%</span></div><span>{{ valor_derecho_comision | currency }}</span></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión Total:</label><div class=\"input-group\"><span class=\"input-group-addon\">$</span> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.comision\" ng-change=\"calcularComision()\"></div><span>{{ comisionPorcentaje }}%</span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"calcularPrimerRecibo()\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i> Generar Primer Recibo</button></div></div><div class=\"row\" ng-if=\"mostrarPrimerRecibo\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Primer recibo</legend></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Serie:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].recibo_numero\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Neta: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].prima_neta\" ng-change=\"calcularTotalPrimerRecibo()\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].rpf\" ng-change=\"calcularTotalPrimerRecibo()\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].derecho\" ng-change=\"calcularTotalPrimerRecibo()\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].iva\" ng-change=\"calcularTotalPrimerRecibo()\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"number\" ng-model=\"datareceipt.receipts[0].prima_total\" ng-change=\"calcularNetaPrimerRecibo()\"></div></div><div class=\"row\" ng-if=\"mostrarPrimerRecibo\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-success m-t\" ng-click=\"calcularSiguientesRecibos()\"><i class=\"fa fa-calculator\" aria-hidden=\"true\"></i> Calcular y Generar Recibos</button></div></div><div class=\"row\" ng-if=\"mostrarTodosRecibo\"><legend class=\"legend-title\" align=\"center\">Recibos Generados</legend></div><div class=\"row\" ng-if=\"mostrarTodosRecibo && editar\"><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Los recibos no se pueden modificar desde la edición de la póliza, solo se podrán hacer desde la información de la póliza.</div></div></div><div class=\"row\" ng-repeat=\"receipt in datareceipt.receipts | orderBy : \'id\'\" ng-if=\"mostrarTodosRecibo\"><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Serie</label><br><span ng-if=\"!editar_recibos\">{{ receipt.recibo_numero }} / {{ numeroRecibos }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.recibo_numero\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Inicio Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.fecha_inicio }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.fecha_inicio\" ng-change=\"validarFechaInicio(receipt, $index)\" value=\"{{receipt.fecha_inicio}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Fin Vigencia</label><br><span ng-if=\"!editar_recibos\">{{ receipt.fecha_fin }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.fecha_fin\" ng-change=\"validarFechaFin(receipt, $index)\" value=\"{{receipt.fecha_fin}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Neta</label><br><span ng-if=\"!editar_recibos\">{{ receipt.prima_neta | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_neta\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>RPF</label><br><span ng-if=\"!editar_recibos\">{{ receipt.rpf | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.rpf\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Derecho</label><br><span ng-if=\"!editar_recibos\">{{ receipt.derecho | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.derecho\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Iva</label><br><span ng-if=\"!editar_recibos\">{{ receipt.iva | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.iva\" ng-change=\"recalcularRecibo($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Prima Total</label><br><span ng-if=\"!editar_recibos\">{{ receipt.prima_total | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.prima_total\" ng-change=\"recalcularTotal($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\" ng-show=\"permiso_comisiones || form.is_edit == false\"><label>Comisión</label><br><span ng-if=\"!editar_recibos\">{{ receipt.comision | currency }}</span> <input ng-if=\"editar_recibos\" class=\"form-control\" type=\"number\" ng-model=\"receipt.comision\" ng-change=\"recalcularComision($index)\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Vencimiento</label><br><span ng-if=\"!editar_recibos\">{{ receipt.vencimiento }}</span> <input ng-if=\"editar_recibos\" data-provide=\"datepicker\" class=\"form-control width-100 text-align-center\" type=\"text\" ng-model=\"receipt.vencimiento\"></div><div class=\"col-xs-12 col-sm-6 col-md-2 form-group\"><label>Entregado</label><br><input type=\"checkbox\" ng-model=\"receipt.delivered\"></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\"></legend></div></div><div class=\"row\" ng-if=\"mostrarTodosRecibo && recalcular\"><div class=\"col-xs-12 col-sm-6 col-md-3 pull-right form-group\"><button class=\"col-xs-12 btn btn-primary\" ng-if=\"!editar_recibos\" ng-click=\"editarRecibos()\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> Editar Recibos</button> <button class=\"col-xs-12 btn btn-primary\" ng-if=\"editar_recibos\" ng-click=\"guardarRecibos()\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Guardar Recibos</button></div></div></div>");
$templateCache.put("app/directivas/comments/comments-mc.template.html","<div class=\"binacle-content\" id=\"binaclecontent\"><div ng-if=\"config.count > 10 && config.next\" class=\"text-center\"><a ng-click=\"showMore()\">Ver más</a></div><div class=\"social-feed-box\" ng-repeat=\"item in datasource | orderBy: \'created_at\'\" ng-if=\"!item.is_child\" ng-init=\"scrollDown();\"><div class=\"social-avatar\"><a href=\"\" class=\"pull-left\"><span>{{ item.user }} &nbsp; &nbsp; &nbsp;</span></a><div class=\"media-body\"><a>{{item.user_info}}</a> <small class=\"text-muted\">{{ item.created_at | date: \'shortTime\' }} - {{ item.created_at | date: \'dd/MM/yyyy\' }}</small></div></div><div class=\"social-body\"><p>{{item.content}}</p></div><div class=\"social-footer\"><div class=\"social-comment\" ng-repeat=\"child in item.comment_child\"><a href=\"\" class=\"pull-left\"><span>{{ child.user }}</span></a><br><div class=\"media-body\"><a>{{child.user_info}}</a> {{child.content}}<br><small class=\"text-muted\">{{ item.created_at | date: \'shortTime\' }} - {{ child.created_at | date: \'dd/MM/yyyy\' }}</small></div></div><div class=\"social-comment\"><a href=\"\" class=\"pull-left\"></a><div class=\"media-body\" ng-init=\"child.response = false\"><span class=\"label label-success pull-right\" ng-click=\"child.response = true\" ng-if=\"child.response == false\">Responder</span> <textarea ng-if=\"child.response == true\" class=\"form-control\" ng-model=\"child.content\" placeholder=\"Escriba un comentario...\"></textarea> <input type=\"checkbox\" name=\"\">Convertir a tarea? <button ng-if=\"child.response == true\" class=\"btn btn-success pull-right margin-top-10\" ng-click=\"saveChild(child, item);\" ng-disabled=\"!child.content\">Responder</button></div></div></div></div></div><div><div class=\"col-xs-12 form-group\"><div class=\"row\"><textarea class=\"form-control\" ng-model=\"simple_comment\" placeholder=\"Escriba un comentario...\"></textarea></div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group pull-right\"><div class=\"row\"><input type=\"checkbox\" name=\"\">Convertir a tarea? <a class=\"col-xs-12 btn btn-success pull-right margin-top-10\" ng-click=\"saveComment()\">Enviar comentario</a></div></div></div>");
$templateCache.put("app/directivas/comments/comments.template.html","<link href=\"bower_components/angular-bootstrap-calendar/dist/css/angular-bootstrap-calendar.min.css\" rel=\"stylesheet\"><script src=\"bower_components/angular-bootstrap-calendar/dist/js/angular-bootstrap-calendar-tpls.min.js\"></script><div class=\"binacle-content\" id=\"binaclecontent\"><div ng-if=\"config.count > 10 && config.next\" class=\"text-center\"><a ng-click=\"showMore()\">Ver más</a></div><div class=\"text-right\" ng-if=\"showExportButton\"><button class=\"btn btn-success btn-xs\" ng-disabled=\"commentsExportLoading || !datasource.length\" ng-click=\"exportComments()\" style=\"margin-bottom: 10px;\"><i class=\"fa fa-file-excel-o\"></i> Exportar bitácora</button></div><div class=\"social-feed-box\" ng-repeat=\"item in datasource | orderBy: \'created_at\' track by $index\" ng-if=\"!item.is_child\" ng-init=\"scrollDown(); getPicture(item);index = $index\"><div class=\"social-avatar\"><a href=\"\" class=\"pull-left\"><img alt=\"image\" ng-src=\"{{ item.image }}\" style=\"border-radius: 50%;\"> <span class=\"blue-color\"><b>{{ item.user_info }}</b></span></a><div class=\"media-body\"><div class=\"input-group date pull-right\" id=\"datetimepicker5\"><span ng-if=\"!item.isReminder\" title=\"Hacer recordatorio\" ng-click=\"makeReminder(item)\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\" style=\"font-size: 20px\"></i></span> <span ng-if=\"item.isReminder\"><p class=\"input-group\" style=\"max-width: 250px\"><input type=\"text\" class=\"form-control\" readonly=\"\" uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=\"item.event.startsAt\" is-open=\"item.event.startOpen\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"toggle($event, \'startOpen\', item.event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div uib-timepicker=\"\" ng-model=\"item.event.startsAt\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"true\"></div><div class=\"col-md-6\"><button class=\"col-xs-12 btn btn-white\" ng-click=\"closeReminder(item)\">Cancelar</button></div><div class=\"col-md-6\"><button class=\"col-xs-12 btn btn-success\" ng-click=\"saveReminder(item, $index)\">Guardar Recordatorio</button></div></span></div></div></div><div class=\"social-body\"><hr><div><p>{{ item.content }}</p></div><div><small class=\"text-muted tree-parent-item\">{{ item.created_at | date: \'dd/MM/yyyy h:mm a\' }}</small><br ng-if=\"item.has_reminder\"><small ng-if=\"item.has_reminder\" class=\"text-muted tree-parent-item\"><b>Recordatorio</b>: {{ item.reminder_date | date: \'dd/MM/yyyy h:mm a\' }}</small></div></div><div class=\"social-footer\"><div class=\"social-comment\" ng-repeat=\"child in item.comment_child track by $index\" ng-init=\"getPicture(child);index2 = $index\"><a href=\"\" class=\"pull-left\"><img alt=\"image\" ng-src=\"{{ child.image }}\" style=\"border-radius: 50%;\"><span class=\"blue-color\"><b>{{child.user_info}}</b></span></a><div class=\"media-body\"><br><hr><div><p>{{ child.content }}</p></div><div><small class=\"text-muted\">{{ child.created_at | date: \'dd/MM/yyyy h:mm a\' }}</small></div></div></div><div class=\"social-comment\"><button class=\"button button-default pull-left col-xs-3\" ng-if=\"item.has_email\" ng-click=\"show_mail(item.id);\"><i class=\"fa fa-envelope\"></i></button><br><div class=\"media-body\" ng-init=\"child.response = false\"><span class=\"label label-success pull-right\" ng-click=\"child.response = true;child.content=\'\'\" ng-if=\"child.response == false\">Responder comentario</span> <textarea ng-show=\"child.response == true\" id=\"commentInputChild\" class=\"form-control\" ng-model=\"child.content\" ng-keyup=\"checkForMentionChild($event,child)\" placeholder=\"Escriba una respuesta...\"></textarea><ul ng-show=\"showUserListChild\" class=\"user-list-child\"><li ng-repeat=\"user in child.filteredUsersC\" ng-click=\"addMentionChild(user,child)\">{{ user.name }}</li></ul><button ng-if=\"child.response == true\" class=\"btn btn-success pull-right margin-top-10\" ng-click=\"saveChild(child, item);\" ng-disabled=\"!child.content\">Responder</button><br><hr><div ng-if=\"item.comment_tasks && item.comment_tasks.length > 0 && item.comment_tasks[0].id\" class=\"col-xs-12 form-group\"><h3>Este comentario contiene una tarea:</h3><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Título:</span><div><span>{{ item.comment_tasks[0].title }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span class=\"blue-color\">Asignado:</span><div><span>{{ item.comment_tasks[0].assigned.first_name }} {{ item.comment_tasks[0].assigned.last_name }}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><span ng-if=\"item.comment_tasks[0].involved_task && item.comment_tasks[0].involved_task.length > 0\" class=\"blue-color\">Involucrados:</span><div ng-if=\"item.comment_tasks[0].involved_task && item.comment_tasks[0].involved_task.length > 0\"><ul><li ng-repeat=\"involved in item.comment_tasks[0].involved_task\">{{ involved.person.first_name }} {{involved.person.last_name}}</li></ul></div></div><div class=\"col-xs-12 form-group\"><span class=\"blue-color\">Descripción:</span><div><span>{{ item.comment_tasks[0].descrip }}</span></div></div><div><button class=\"btn btn-primary btn-sm\" ng-click=\"editTask(item, $index)\">Editar</button></div></div></div></div></div></div></div><div><div class=\"col-xs-12 form-group\"><div class=\"row\"><textarea class=\"form-control\" id=\"commentInput\" ng-model=\"simple_comment\" ng-keyup=\"checkForMention($event)\" placeholder=\"Escriba un comentario...\"></textarea><ul ng-show=\"showUserList\" class=\"user-list\"><li ng-repeat=\"user in filteredUsers\" ng-click=\"addMention(user)\">{{ user.name }}</li></ul></div></div><div class=\"col-xs-12 col-sm-4 col-md-3 form-group pull-right\"><div class=\"row\"><span class=\"ng-click-active\" title=\"Realice una tarea desde este comentario.\" ng-if=\"show_main == true\"><input ng-click=\"change_converter(converter_task,1)\" ng-model=\"converter_task\" type=\"checkbox\"> ¿Convertir a tarea?<br><label ng-if=\"converter_task\" for=\"select_resp\">Asignar a:</label><select id=\"select_resp\" class=\"form-control\" ng-change=\"changeSelect(user_assigned)\" ng-if=\"converter_task\" ng-model=\"user_assigned\"><option ng-repeat=\"user in users track by $index\" value=\"{{user.id}}\">{{user.first_name}} {{user.last_name}}</option></select></span><a class=\"col-xs-12 btn btn-success pull-right margin-top-10 ladda-button\" ng-disabled=\"!simple_comment || yaguardado\" ng-click=\"saveComment($event)\">Enviar comentario</a></div></div></div>");
$templateCache.put("app/directivas/comments/comments.template.old.html","<div><div><div><div><div ng-if=\"type == \'contactos\'\" class=\"col-xs-12 comment-container\"><div class=\"box box-widget\"><div class=\"box-header with-border\"><div class=\"user-block\"><img src=\"images/contact-icon-green.png\"><div class=\"username\">{{data.name}}</div><div class=\"description\">{{data.contactDate | date: \'medium\'}}</div></div></div><div class=\"box-body\"><p ng-if=\"!isHidden($index)\" class=\"col-xs-10\">{{data.comments}}</p><p ng-if=\"isHidden($index)\" class=\"col-xs-12\">{{data.comments}}</p><button ng-click=\"asignParent(data.id, data.id); hideThis($index)\" ng-hide=\"isHidden($index)\" class=\"btn btn-asegura pull-right\">Responder</button></div><div class=\"box-footer box-comments\"><div ng-repeat=\"item in comentarios | orderBy : \'created\': true\" ng-if=\"item.comment_id == data.id &amp;&amp; item.parent\" class=\"box-comment\"><img src=\"images/contact-icon-blue.png\"><div class=\"comment-text\"><span class=\"username\">{{ item.username }}<span style=\"color:gray;\" class=\"text-muted pull-right\">{{ item.created | date: \'medium\' }}</span></span><div ng-repeat=\"child in comentarios\" ng-if=\"child.id == item.parent\"></div><div>{{item.content}}</div></div></div></div><div ng-show=\"commentElement == data.id\" class=\"box-footer\"><form><div class=\"col-xs-10\"><input type=\"text\" ng-model=\"textResponse\" placeholder=\"Escribe una respuesta....\" required=\"required\" class=\"form-control comment-control\"></div><div class=\"col-xs-2\"><span class=\"inut-group-btn\"><button ng-click=\"addResponse(textResponse)\" ng-disabled=\"childComment.$invalid\" class=\"btn btn-asegura\">Enviar</button></span></div></form></div></div></div><div ng-repeat=\"response in comentarios\" ng-if=\"response.parent == null\" class=\"col-xs-12 comment-container\"><div class=\"col-xs-12\"><div class=\"box box-widget\"><div class=\"box-header with-border\"><div class=\"user-block\"><img src=\"images/contact-icon-green.png\"><div class=\"username\">{{response.username}}</div><div class=\"description\">{{ response.created | date: \'medium\' }}</div></div></div><div class=\"box-body\"><p ng-if=\"!isHidden($index)\" class=\"col-xs-10\">{{response.content}}</p><p ng-if=\"isHidden($index)\" class=\"col-xs-12\">{{response.content}}</p><button ng-click=\"asignParent(response.id, response.id); hideThis($index)\" ng-hide=\"isHidden($index)\" class=\"btn btn-asegura pull-right\">Responder</button></div><div ng-if=\"response.content\" class=\"box-footer box-comments\"><div ng-repeat=\"item in comentarios | orderBy : \'created\': true\" ng-if=\"item.comment_id == response.id\" class=\"box-comment response-item\"><img src=\"images/contact-icon-blue.png\"><div ng-if=\"item.parent\" class=\"comment-text\"><span class=\"username\">{{ item.username }}</span><span style=\"color:gray;\" class=\"text-muted pull-right\">{{ item.created | date: \'medium\' }}</span><div ng-repeat=\"child in comentarios\" ng-if=\"child.id == item.parent\">{{item.content}}</div></div></div></div><div ng-show=\"commentElement == response.id\" class=\"box-footer\"><form name=\"childComment\"><div class=\"col-xs-10\"><input type=\"text\" ng-model=\"newTextResponse\" placeholder=\"Escribe una respuesta....\" required=\"required\" class=\"form-control comment-control\"></div><div class=\"col-xs-2\"><span class=\"inut-group-btn\"><button ng-click=\"addResponse(newTextResponse)\" ng-disabled=\"childComment.$invalid\" class=\"btn btn-asegura\">Enviar</button></span></div></form></div></div></div></div></div><div class=\"col-xs-12 comment-container\"><hr><form name=\"requestComment\" class=\"form-group\"><div class=\"col-xs-10\"><input type=\"text\" placeholder=\"Nuevo comentario...\" ng-model=\"newComment\" required=\"required\" class=\"form-control comment-control\"></div><div class=\"col-xs-2\"><button ng-click=\"addResponse(newComment, \'comment\')\" ng-disabled=\"requestComment.$invalid\" class=\"btn btn-asegura pull-right\">Enviar</button></div></form></div></div></div></div>");
$templateCache.put("app/directivas/graphic/graphic.html","<ul class=\"stat-list col-xs-12\"><li class=\"col-xs-12\" ng-click=\"getItems(\'green\',\'0\',\'0\')\" ng-if=\"data.green.percent > 0\"><div class=\"row\"><div class=\"col-xs-12 no-padding\" title=\"{{data.green.title}}\"><h3 style=\"color: #17A45D;\" class=\"no-margins\">{{data.green.status}}</h3><p class=\"small\">{{data.green.label}}</p></div></div><div class=\"row\"><div class=\"progress progress-mini\"><div style=\"width: {{data.green.percent}}%; background: #17A45D;\" class=\"progress-bar\" \"=\"\"></div></div><div ng-if=\"data.green.prima_total\"><p class=\"no-margins small pull-right\" title=\"Total prima total\">MXN {{ data.green.prima_total }} | USD {{ data.green.prima_total_dolares }}</p><br><p class=\"no-margins small pull-right\" title=\"Total notas de crédito\">MXN {{ data.green.prima_total_nota }} | USD {{ data.green.prima_total_nota_dolares }}</p></div></div></li><li class=\"col-xs-12\" ng-click=\"getItems(\'yellow\',\'0\',\'0\')\" ng-if=\"data.yellow.percent > 0\"><div class=\"row\"><div class=\"col-xs-9 no-padding\" title=\"{{data.yellow.title}}\"><h3 style=\"color: #F5CD21;\" class=\"no-margins\">{{data.yellow.status}}</h3><p class=\"small\">{{data.yellow.label}}</p></div></div><div class=\"row\"><div class=\"progress progress-mini\"><div style=\"width: {{data.yellow.percent}}%;background: #F5CD21;\" class=\"progress-bar\"></div></div><div ng-if=\"data.yellow.prima_total\"><p class=\"no-margins small pull-right\" title=\"Total prima total\">MXN {{ data.yellow.prima_total }} | USD {{ data.yellow.prima_total_dolares }}</p><br><p class=\"no-margins small pull-right\" title=\"Total notas de crédito\">MXN {{ data.yellow.prima_total_nota }} | USD {{ data.yellow.prima_total_nota_dolares }}</p></div></div></li><li class=\"col-xs-12\" ng-click=\"getItems(\'orange\',\'0\',\'0\')\" ng-if=\"data.orange.percent > 0\"><div class=\"row\"><div class=\"col-xs-10 no-padding\" title=\"{{data.orange.title}}\"><h3 style=\"color: #EA9021;\" class=\"no-margins\">{{data.orange.status}}</h3><p class=\"small\">{{data.orange.label}}</p></div></div><div class=\"row\"><div class=\"progress progress-mini\"><div style=\"width: {{data.orange.percent}}%;background: #EA9021;\" class=\"progress-bar\"></div></div><div ng-if=\"data.orange.prima_total\"><p class=\"no-margins small pull-right\" title=\"Total prima total\">MXN {{ data.orange.prima_total }} | USD {{ data.orange.prima_total_dolares }}</p><br><p class=\"no-margins small pull-right\" title=\"Total notas de crédito\">MXN {{ data.orange.prima_total_nota }} | USD {{ data.orange.prima_total_nota_dolares }}</p></div></div></li><li class=\"col-xs-12\" ng-click=\"getItems(\'red\',\'0\',\'0\')\" ng-if=\"data.red.percent > 0\"><div class=\"row\"><div class=\"col-xs-10 no-padding\" title=\"{{data.red.title}}\"><h3 style=\"color: #EA5121;\" class=\"no-margins\">{{data.red.status}}</h3><p class=\"no-margins\">{{data.red.label}}</p></div></div><div class=\"row\"><div class=\"progress progress-mini\"><div style=\"width: {{data.red.percent}}%; background: #EA5121;\" class=\"progress-bar\"></div></div><div ng-if=\"data.red.prima_total\"><p class=\"no-margins small pull-right\" title=\"Total prima total\">MXN {{ data.red.prima_total }} | USD {{ data.red.prima_total_dolares }}</p><br><p class=\"no-margins small pull-right\" title=\"Total notas de crédito\">MXN {{ data.red.prima_total_nota }} | USD {{ data.red.prima_total_nota_dolares }}</p></div></div></li></ul>");
$templateCache.put("app/directivas/pagination/pagination.html","<nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li class=\"page-item\" ng-show=\"!not_prev\"><a class=\"page-link\" ng-click=\"previousPage()\" aria-label=\"Previous\"><span aria-hidden=\"true\">&laquo;</span> <span class=\"sr-only\">Previous</span></a></li><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"!not_next && totalPages > 4\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-if=\"!not_next && config.next\"><a class=\"page-link\" ng-click=\"nextPage()\" aria-label=\"Next\"><span aria-hidden=\"true\">&raquo;</span> <span class=\"sr-only\">Next</span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav>");
$templateCache.put("app/directivas/tabs/tabset.html","<div role=\"tabpanel\"><ul class=\"nav nav-tabs\" role=\"tablist\"><li role=\"presentation\" ng-class=\"{\'active\':tab.active, \'disabled\':tab.disabled}\" ng-repeat=\"tab in tabset.tabs track by $index\"><a href=\"\" role=\"tab\" ng-click=\"tabset.select(tab)\">{{tab.heading}} <span ng-if=\"tabset.tabs.length > 1\" style=\"margin-left: 20px; padding: 12px 12px\" ng-mousedown=\"$event.stopPropagation();\" ng-click=\"tabset.delete_tab($index)\">x</span></a></li><li role=\"presentation\" ng-click=\"tabset.add_tab()\" ng-class=\"{\'active\':tab.active, \'disabled\':tab.disabled}\"><a href=\"\" role=\"\">+</a></li></ul><ng-transclude></ng-transclude></div>");
$templateCache.put("app/endoso/type/a.html","<div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del endoso</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.start_of_validity\" ng-change=\"changeUntil()\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_of_validity\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del endoso</label> <textarea class=\"form-control\" ng-model=\"vm.form.observations\" name=\"description\"></textarea></div><div ng-show=\"vm.subforms.show === 1\" ng-if=\"valueConcept == 20 && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Automóvil</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"brand\">Marca</label> <input class=\"form-control\" ng-model=\"vm.subforms.brand\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"model\">Modelo</label> <input class=\"form-control\" ng-model=\"vm.subforms.model\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"year\">Año</label><select class=\"form-control\" ng-model=\"vm.subforms.year\" ng-options=\"year as year for year in vm.defaults.years track by year\"><option value=\"\">{{vm.subforms.year}}</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"version\">Versión</label> <input class=\"form-control\" ng-model=\"vm.subforms.version\" type=\"text\"></div></div><div ng-show=\"vm.subforms.show === 2\" ng-if=\"valueConcept == 20 && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Bien asegurado</label> <input class=\"form-control\" ng-model=\"vm.subforms.insured_item\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Detalles</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_details\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Direccion</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_address\" type=\"text\"></div></div><div ng-show=\"vm.subforms.show === 3\" ng-if=\"(valueConcept == 4 || valueConcept == 20) && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Asegurados</legend></div><div class=\"col-xs-12\" ng-if=\"(vm.subforms.beneficiaries_life.length || vm.subforms.personal) && valueConcept == 4\"><table class=\"table table-stripped table-bordered\"><thead></thead><td>Tipo</td><td>Nombre</td><td>Parentesco</td><td>Fecha de nacimiento</td><td>Sexo</td><tbody><tr><td>Titular</td><td>{{ vm.subforms.personal.first_name }} {{ vm.subforms.personal.last_name }} {{ vm.subforms.personal.second_last_name }}</td><td>Titular</td><td>{{ vm.subforms.personal.birthdate | date: \'dd/MM/yyyy\'}}</td><td>{{ vm.subforms.personal.sex }}</td></tr><tr ng-repeat=\"relationship in vm.subforms.beneficiaries_life track by $index\"><td>Dependiente</td><td>{{relationship.first_name}} {{relationship.last_name}} {{relationship.second_last_name}}</td><td>{{ relationship.optional_relationship }}</td><td>{{ relationship.birthdate | date: \'dd/MM/yyyy\'}}</td><td>{{ relationship.sex }}</td></tr></tbody></table></div><div class=\"col-xs-12\" ng-if=\"valueConcept == 4\"><div ng-if=\"vm.subforms.beneficiaries_life.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"vm.newBeneficiarie.length == 1\"><i class=\"fa fa-minus\"></i></button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"vm.newBeneficiarie.length == 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Agregar dependientes</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiarie()\" type=\"button\"><i class=\"fa fa-plus\"></i></button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiarie()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"relationship in vm.newBeneficiarie track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"vm.newBeneficiarie.length == 1\"><i class=\"fa fa-minus\"></i></button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"vm.newBeneficiarie.length == 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Agregar beneficiarios</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiarie()\" type=\"button\"><i class=\"fa fa-plus\"></i></button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiarie()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"nombre{{$index}}\">Nombre</label> <input id=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"relationship.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"last{{$index}}\">Apellido Paterno</label> <input id=\"last{{$index}}\" class=\"form-control\" ng-model=\"relationship.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"relationship.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"parentesco{{$index}}\">Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"relationship.optional_relationship\" ng-options=\"item.value as item.name for item in vm.typesRelation\"><option value=\"\" disabled=\"\">Selecciona un parentesco</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha de Nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.birthdate\" ng-change=\"changebirthdate(relationship.birthdate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Sexo</label><select class=\"form-control\" ng-options=\"sex.value as sex.label for sex in vm.sex track by sex.value\" ng-model=\"relationship.sex\"><option value=\"\" disabled=\"\">Selecciona un sexo</option></select></div></div></div></div><div ng-if=\"valueConcept == 20 && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12 col-sm-3 form-group\"><label>Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Fecha de nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.subforms.personal.birthdate\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'M\'\">MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'F\'\">FEMENINO</span></div></div><div class=\"col-xs-12\"><div class=\"row address-container\" ng-repeat=\"relationship in vm.subforms.beneficiaries_life track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><span>Dependiente #{{$index + 1}}</span></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"nombre{{$index}}\">Nombre</label> <input id=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"relationship.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"last{{$index}}\">Apellido Paterno</label> <input id=\"last{{$index}}\" class=\"form-control\" ng-model=\"relationship.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"relationship.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"parentesco{{$index}}\">Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"relationship.relationship\" ng-options=\"item.value as item.name for item in vm.typesRelation\"><option value=\"\" disabled=\"\">Selecciona un parentesco</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha de Nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.birthdate\" ng-change=\"changebirthdate(relationship.birthdate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Sexo</label><select class=\"form-control\" ng-options=\"sex.value as sex.label for sex in vm.sex track by sex.value\" ng-model=\"relationship.sex\"><option value=\"\" disabled=\"\">Selecciona un sexo</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"ben_percentage\">Porcentaje</label> <input type=\"number\" class=\"form-control\" ng-model=\"relationship.percentage\"></div></div></div></div></div></div><div ng-show=\"vm.subforms.show === 0\" ng-if=\"(valueConcept == 4 || valueConcept == 20) && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Asegurados</legend></div><div class=\"col-xs-12\" ng-if=\"(vm.subforms.relationship_accident.length || vm.subforms.personal) && valueConcept == 4\"><table class=\"table table-stripped table-bordered\"><thead></thead><td>Tipo</td><td>Nombre</td><td>Parentesco</td><td>Fecha de nacimiento</td><td>Sexo</td><tbody><tr><td>Titular</td><td>{{ vm.subforms.personal.first_name }} {{ vm.subforms.personal.last_name }} {{ vm.subforms.personal.second_last_name }}</td><td>Titular</td><td>{{ vm.subforms.personal.birthdate | date: \'dd/MM/yyyy\'}}</td><td>{{ vm.subforms.personal.sex }}</td></tr><tr ng-repeat=\"relationship in vm.subforms.relationship_accident track by $index\"><td>Dependiente</td><td>{{relationship.first_name}} {{relationship.last_name}} {{relationship.second_last_name}}</td><td>{{ relationship.relationship }}</td><td>{{ relationship.birthdate | date: \'dd/MM/yyyy\'}}</td><td>{{ relationship.sex }}</td></tr></tbody></table></div><div class=\"col-xs-12\" ng-if=\"valueConcept == 4 && fianza_for_endoso == \'Póliza\'\"><div ng-if=\"vm.subforms.relationship_accident.length == 0\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteRelationship($index)\" ng-disabled=\"vm.newRelationship.length == 1\"><i class=\"fa fa-minus\"></i></button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteRelationship($index)\" ng-disabled=\"vm.newRelationship.length == 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Dependientes</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addRelationship()\" type=\"button\">Agregar Dependiente</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addRelationship()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div></div><div class=\"row address-container\" ng-repeat=\"relationship in vm.newRelationship track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteRelationship($index)\" ng-disabled=\"vm.newRelationship.length == 1\"><i class=\"fa fa-minus\"></i></button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteRelationship($index)\" ng-disabled=\"vm.newRelationship.length == 1\"><i class=\"glyphicon glyphicon-minus\"></i></button> <span>Agregar dependientes</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addRelationship()\" type=\"button\"><i class=\"fa fa-plus\"></i></button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addRelationship()\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"nombre{{$index}}\">Nombre</label> <input id=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"relationship.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"last{{$index}}\">Apellido Paterno</label> <input id=\"last{{$index}}\" class=\"form-control\" ng-model=\"relationship.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"relationship.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"parentesco{{$index}}\">Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"relationship.relationship\" ng-options=\"item.value as item.name for item in vm.typesRelation\"><option value=\"\" disabled=\"\">Selecciona un parentesco</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha de Nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.birthdate\" ng-change=\"changebirthdate(relationship.birthdate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Sexo</label><select class=\"form-control\" ng-options=\"sex.value as sex.label for sex in vm.sex track by sex.value\" ng-model=\"relationship.sex\"><option value=\"\" disabled=\"\">Selecciona un sexo</option></select></div></div></div></div><div ng-if=\"valueConcept == 20 && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12 col-sm-3 form-group\"><label>Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Fecha de nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.subforms.personal.birthdate\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'M\'\">MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'F\'\">FEMENINO</span></div></div><div class=\"col-xs-12\"><div class=\"row address-container\" ng-repeat=\"relationship in vm.subforms.relationship_accident track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><span>Dependiente #{{$index + 1}}</span></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"nombre{{$index}}\">Nombre</label> <input id=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"relationship.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"last{{$index}}\">Apellido Paterno</label> <input id=\"last{{$index}}\" class=\"form-control\" ng-model=\"relationship.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"relationship.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"parentesco{{$index}}\">Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"relationship.relationship\" ng-options=\"item.value as item.name for item in vm.typesRelation\"><option value=\"\" disabled=\"\">Selecciona un parentesco</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha de Nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.birthdate\" ng-change=\"changebirthdate(relationship.birthdate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Sexo</label><select class=\"form-control\" ng-options=\"sex.value as sex.label for sex in vm.sex track by sex.value\" ng-model=\"relationship.sex\"><option value=\"\" disabled=\"\">Selecciona un sexo</option></select></div></div></div></div></div></div><div class=\"col-md-12 col-sm-12 form-group\" ng-if=\"(valueConcept == 2 || valueConcept == 3 || valueConcept == 5 || valueConcept == 19) && fianza_for_endoso == \'Póliza\'\"><legend class=\"legend-title\" align=\"center\">Coberturas</legend><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-stripped table-hover\" data-filter=\"#filter\" data-page-size=\"25\"><thead><tr><th class=\"text-align-center width-20p\" data-breakpoints=\"xs\">Cobertura</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">S. Asegurada</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">Deducible</th><th ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\">Coaseguro</th><th class=\"display-none\">Prima</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.coverages\"><td class=\"text-align-center\"><p ng-bind=\"coverage.coverage_name\"></p></td><td class=\"text-align-center\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.sums_coverage\" ng-init=\"!coverage.sumInPolicy.value && item.default ? coverage.sumInPolicy.value = item.sum_insured : def = item.default\" ng-click=\"coverage.sumInPolicy.value = item.sum_insured; show_button_save_sum = false\"><a>{{formatQ(item.sum_insured) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.sum_insured\" ng-keyup=\"show_button_save_sum = true\" format-currency=\"currency\" ng-disabled=\"valueConcept == 3\"><div class=\"input-group-btn\" ng-show=\"show_button_save_sum\"><button class=\"btn btn-success\" ng-click=\"saveSum(coverage.sumInPolicy.value, coverage);show_button_save_sum = result_\">+</button></div></div></td><td class=\"text-align-center\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.deductible_coverage\" ng-init=\"item.default ? coverage.deductibleInPolicy.value = item.deductible : def = item.default\" ng-click=\"coverage.deductibleInPolicy.value = item.deductible; show_button_save_ded = false\"><a>{{formatQ(item.deductible) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.deductible\" ng-keyup=\"show_button_save_ded = true\" format-currency=\"currency\" ng-disabled=\"valueConcept == 2\"><div class=\"input-group-btn\" ng-show=\"show_button_save_ded\"><button class=\"btn btn-success\" ng-click=\"saveDed(coverage.deductibleInPolicy.value, coverage);show_button_save_ded = result_ded\">+</button></div></div></td><td class=\"text-align-center\" ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\"><input class=\"form-control m-b\" type=\"text\" ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\" ng-model=\"coverage.coinsurance\" value=\"\" ng-disabled=\"valueConcept == 2\"></td><td class=\"display-none\"><input class=\"form-control m-b\" format-as-currency=\"\" ng-model=\"coverage.primaInPolicy.value\"></td><td class=\"text-align-center\"><button class=\"btn btn-danger btn-danger\" name=\"button\" ng-click=\"deleteCoverage(coverage, $index)\" type=\"button\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div class=\"form-group\"><label>Agregar coberturas</label><select class=\"form-control m-b\" ng-options=\"cvg.coverage_name for cvg in vm.coverageList | orderBy: \'coverage_name\' track by cvg.id\" ng-change=\"addCoverage(vm.coverageInPackage)\" ng-model=\"vm.coverageInPackage\"><option value=\"\" disabled=\"\">Agrega una cobertura</option></select></div></div></div></div></div>");
$templateCache.put("app/endoso/type/b.html","<div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del endoso</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.start_of_validity\" value=\"{{vm.form.start_of_validity}}\" ng-change=\"changeUntil()\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_of_validity\" value=\"{{vm.form.end_of_validity}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-sm-12 form-group\"><label for=\"description\">Descripción del endoso</label> <textarea class=\"form-control\" ng-model=\"vm.form.observations\" name=\"description\"></textarea></div><div ng-show=\"vm.subforms.show === 1\" ng-if=\"(valueConcept == 8 || valueConcept == 10) && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Automóvil</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"brand\">Marca</label> <input class=\"form-control\" ng-model=\"vm.subforms.brand\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"model\">Modelo</label> <input class=\"form-control\" ng-model=\"vm.subforms.model\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"year\">Año</label><select class=\"form-control\" ng-model=\"vm.subforms.year\" ng-options=\"year as year for year in vm.defaults.years track by year\" disabled=\"\"><option value=\"\">{{vm.subforms.year}}</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"version\">Versión</label> <input class=\"form-control\" ng-model=\"vm.subforms.version\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"serial\">Serie</label> <input class=\"form-control\" ng-model=\"vm.subforms.serial\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"engine\">Motor</label> <input class=\"form-control\" ng-model=\"vm.subforms.engine\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"color\">Color</label> <input class=\"form-control\" ng-model=\"vm.subforms.color\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"license_plates\">Placas</label> <input class=\"form-control\" ng-model=\"vm.subforms.license_plates\" type=\"text\"></div></div><div ng-show=\"vm.subforms.show === 2\" ng-if=\"(valueConcept == 8 || valueConcept == 10) && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos</legend></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Bien asegurado</label> <input class=\"form-control\" ng-model=\"vm.subforms.insured_item\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Detalles</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_details\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Direccion</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_address\" type=\"text\"></div></div><div ng-show=\"vm.subforms.show === 3\" ng-if=\"valueConcept == 8 || valueConcept == 10\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Asegurado</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Fecha de nacimiento</label><div class=\"input-group date\"><input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"vm.subforms.personal.birthdate\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"gender\">Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"genero\" ng-value=\"\'M\'\"> MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"genero\" ng-value=\"\'F\'\"> FEMENINO</span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"smoker\">Fumador</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.smoker\" name=\"smoker\" ng-value=\"true\"> SI</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.smoker\" name=\"smoker\" ng-value=\"false\"> NO</span></div></div><div class=\"col-xs-12\"><div class=\"row\" ng-repeat=\"beneficiary in vm.subforms.beneficiaries_life track by $index\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Beneficiario #{{$index + 1}}</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Nombre</label> <input type=\"text\" ng-model=\"beneficiary.first_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Apellido Paterno</label> <input type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Apellido Materno</label> <input type=\"text\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Parentesco</label> <input type=\"text\" ng-model=\"beneficiary.optional_relationship\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento</label><div class=\"input-group date\"><input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"beneficiary.birthdate\"> <span id=\"nacimiento{{$index}}\" class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Sexo</label><select class=\"form-control\" ng-model=\"beneficiary.sex\" placeholder=\"\"><option value=\"M\">MASCULINO</option><option value=\"F\">FEMENINO</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"ben_percentage\">Porcentaje</label> <input type=\"number\" class=\"form-control\" ng-model=\"beneficiary.percentage\"></div></div></div></div><div ng-show=\"vm.subforms.show === 0\" ng-if=\"valueConcept == 8 && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Asegurado</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"name\">Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"middle_name\">Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"last_name\">Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento\">Fecha de nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.subforms.personal.birthdate\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"gender\">Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'M\'\"> MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'F\'\"> FEMENINO</span></div></div><div class=\"col-xs-12\"><div class=\"row\" ng-repeat=\"relationship in vm.subforms.relationship_accident track by $index\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Dependiente #{{$index + 1}}</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Nombre</label> <input type=\"text\" ng-model=\"relationship.first_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Apellido Paterno</label> <input type=\"text\" ng-model=\"relationship.last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Apellido Materno</label> <input type=\"text\" ng-model=\"relationship.second_last_name\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"relationship.relationship\" ng-options=\"item.value as item.name for item in vm.typesRelation\"><option value=\"\" disabled=\"\">Selecciona un parentesco</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento</label><div class=\"input-group date\"><input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"relationship.birthdate\"> <span id=\"nacimiento{{$index}}\" class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Sexo</label><select class=\"form-control\" ng-options=\"sex.value as sex.label for sex in vm.sex track by sex.value\" ng-model=\"relationship.sex\"><option value=\"\" disabled=\"\">Selecciona un sexo</option></select></div></div></div></div>");
$templateCache.put("app/endoso/type/d.html","<div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del endoso</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.start_of_validity\" ng-change=\"changeUntil()\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_of_validity\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del endoso</label> <textarea class=\"form-control\" ng-model=\"vm.form.observations\" name=\"description\"></textarea></div><div ng-show=\"vm.subforms.show === 1\" ng-if=\"(valueConcept == 15 || valueConcept == 22) && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Automóvil</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"brand\">Marca</label> <input class=\"form-control\" ng-model=\"vm.subforms.brand\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"model\">Modelo</label> <input class=\"form-control\" ng-model=\"vm.subforms.model\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"year\">Año</label><select class=\"form-control\" ng-model=\"vm.subforms.year\" ng-options=\"year as year for year in vm.defaults.years track by year\"><option value=\"\">{{vm.subforms.year}}</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"version\">Versión</label> <input class=\"form-control\" ng-model=\"vm.subforms.version\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"serial\">Serie</label> <input class=\"form-control\" ng-model=\"vm.subforms.serial\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"engine\">Motor</label> <input class=\"form-control\" ng-model=\"vm.subforms.engine\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"color\">Color</label> <input class=\"form-control\" ng-model=\"vm.subforms.color\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"license_plates\">Placas</label> <input class=\"form-control\" ng-model=\"vm.subforms.license_plates\" type=\"text\"></div></div><div ng-show=\"vm.subforms.show === 2\" ng-if=\"(valueConcept == 15 || valueConcept == 22) && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Bien asegurado</label> <input class=\"form-control\" ng-model=\"vm.subforms.insured_item\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Detalles</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_details\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Direccion</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_address\" type=\"text\"></div></div><div ng-show=\"vm.subforms.show === 3\" ng-if=\"(valueConcept == 15 || valueConcept == 22) && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Asegurado</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"name\">Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"middle_name\">Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"last_name\">Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento\">Fecha de nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"vm.subforms.personal.birthdate\"></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"gender\">Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'M\'\"> MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'F\'\"> FEMENINO</span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"smoker\">Fumador</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.smoker\" name=\"smoker\" ng-value=\"true\"> SI</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.smoker\" name=\"smoker\" ng-value=\"false\"> NO</span></div></div></div><div ng-show=\"vm.subforms.show === 0\" ng-if=\"valueConcept == 15 || valueConcept == 22\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Asegurados</legend></div><div class=\"col-xs-12\" ng-if=\"(vm.subforms.relationship_accident.length || vm.subforms.personal) && valueConcept == 15 && fianza_for_endoso == \'Póliza\'\"><table class=\"table table-stripped table-bordered\"><thead></thead><td>Tipo</td><td>Nombre</td><td>Parentesco</td><td>Fecha de nacimiento</td><td>Sexo</td><td>Eliminar</td><tbody><tr><td>Titular</td><td>{{ vm.subforms.personal.first_name }} {{ vm.subforms.personal.last_name }} {{ vm.subforms.personal.second_last_name }}</td><td>Titular</td><td>{{ vm.subforms.personal.birthdate | date: \'dd/MM/yyyy\'}}</td><td>{{ vm.subforms.personal.sex }}</td></tr><tr ng-repeat=\"relationship in vm.subforms.relationship_accident track by $index\"><td>Dependiente</td><td>{{relationship.first_name}} {{relationship.last_name}} {{relationship.second_last_name}}</td><td>{{ relationship.relationship }}</td><td>{{ relationship.birthdate | date: \'dd/MM/yyyy\'}}</td><td>{{ relationship.sex }}</td><td><button class=\"btn btn-danger btn-danger\" name=\"button\" ng-click=\"deleteRelationship($index, relationship)\" type=\"button\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table></div><div ng-if=\"valueConcept == 22 && fianza_for_endoso == \'Póliza\'\"><div class=\"col-xs-12 col-sm-3 form-group\"><label>Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Fecha de nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.subforms.personal.birthdate\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'M\'\">MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'F\'\">FEMENINO</span></div></div><div class=\"col-xs-12\"><div class=\"row address-container\" ng-repeat=\"relationship in vm.subforms.relationship_accident track by $index\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><span>Dependiente #{{$index + 1}}</span></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"nombre{{$index}}\">Nombre</label> <input id=\"nombre{{$index}}\" class=\"form-control\" ng-model=\"relationship.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"last{{$index}}\">Apellido Paterno</label> <input id=\"last{{$index}}\" class=\"form-control\" ng-model=\"relationship.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"secondLast{{$index}}\">Apellido Materno</label> <input id=\"secondLast{{$index}}\" class=\"form-control\" ng-model=\"relationship.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"parentesco{{$index}}\">Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"relationship.relationship\" ng-options=\"item.value as item.name for item in vm.typesRelation\"><option value=\"\" disabled=\"\">Selecciona un parentesco</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha de Nacimiento</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"relationship.birthdate\" ng-change=\"changebirthdate(relationship.birthdate)\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Sexo</label><select class=\"form-control\" ng-options=\"sex.value as sex.label for sex in vm.sex track by sex.value\" ng-model=\"relationship.sex\"><option value=\"\" disabled=\"\">Selecciona un sexo</option></select></div></div></div></div></div></div><div class=\"col-md-12 col-sm-12 form-group\" ng-if=\"(valueConcept == 12 || valueConcept == 13 || valueConcept == 14 || valueConcept == 21) && fianza_for_endoso == \'Póliza\'\"><legend class=\"legend-title\" align=\"center\">Coberturas</legend><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-stripped table-hover\" data-filter=\"#filter\" data-page-size=\"25\"><thead><tr><th class=\"text-align-center width-20p\" data-breakpoints=\"xs\">Cobertura</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">S. Asegurada</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">Deducible</th><th ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\">Coaseguro</th><th class=\"display-none\">Prima</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.coverages\"><td class=\"text-align-center\"><p ng-bind=\"coverage.coverage_name\"></p></td><td class=\"text-align-center\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.sums_coverage\" ng-init=\"!coverage.sumInPolicy.value && item.default ? coverage.sumInPolicy.value = item.sum_insured : def = item.default\" ng-click=\"coverage.sumInPolicy.value = item.sum_insured; show_button_save_sum = false\"><a>{{formatQ(item.sum_insured) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.sum_insured\" ng-keyup=\"show_button_save_sum = true\" format-currency=\"currency\" ng-disabled=\"valueConcept == 13 || valueConcept == 14\"><div class=\"input-group-btn\" ng-show=\"show_button_save_sum\"><button class=\"btn btn-success\" ng-click=\"saveSum(coverage.sumInPolicy.value, coverage);show_button_save_sum = result_\">+</button></div></div></td><td class=\"text-align-center\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.deductible_coverage\" ng-init=\"item.default ? coverage.deductibleInPolicy.value = item.deductible : def = item.default\" ng-click=\"coverage.deductibleInPolicy.value = item.deductible; show_button_save_ded = false\"><a>{{formatQ(item.deductible) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.deductible\" ng-keyup=\"show_button_save_ded = true\" format-currency=\"currency\" ng-disabled=\"valueConcept == 12 || valueConcept == 13\"><div class=\"input-group-btn\" ng-show=\"show_button_save_ded\"><button class=\"btn btn-success\" ng-click=\"saveDed(coverage.deductibleInPolicy.value, coverage);show_button_save_ded = result_ded\">+</button></div></div></td><td class=\"text-align-center\" ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\"><input class=\"form-control m-b\" type=\"text\" ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\" ng-model=\"coverage.coinsurance\" value=\"\" ng-disabled=\"valueConcept == 12 || valueConcept == 13\"></td><td class=\"display-none\"><input class=\"form-control m-b\" format-as-currency=\"\" ng-model=\"coverage.primaInPolicy.value\"></td><td class=\"text-align-center\"><button class=\"btn btn-danger btn-danger\" name=\"button\" ng-click=\"deleteCoverage(coverage, $index)\" type=\"button\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div class=\"form-group\"><label>Agregar coberturas</label><select class=\"form-control m-b\" ng-options=\"cvg.coverage_name for cvg in vm.coverageList | orderBy: \'coverage_name\' track by cvg.id\" ng-change=\"addCoverage(vm.coverageInPackage)\" ng-model=\"vm.coverageInPackage\"><option value=\"\" disabled=\"\">Agrega una cobertura</option></select></div></div></div></div></div>");
$templateCache.put("app/endoso/type/manual.html","<div class=\"wrapper\" ng-if=\"false\"><div class=\"row\"><div class=\"col-xs-12 col-md-12\"><div name=\"brand\"><div class=\"form-group col-md-6\"><label for=\"brand\">Encontrar certificado</label><input type=\"search\" class=\"form-control\" name=\"\" ng-model=\"certificateNumber\"></div><div class=\"form-group col-md-4\"><button type=\"button\" class=\"btn btn-block btn-success btn-mt\" ng-click=\"search(certificateNumber)\"><span class=\"fa fa-search\"></span> Buscar certificado</button></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group col-xs-12\"><button class=\"btn btn-primary btn-mt pull-right\" ng-if=\"vm.typeEndoso === \'A\'\" ng-disabled=\"btnAddDisabled\" ng-click=\"addCertificate()\"><span class=\"fa fa-plus-square-o\"></span> Agregar certificado</button></div><div class=\"form-group col-xs-12\"><button class=\"btn btn-danger btn-mt pull-right\" ng-if=\"vm.typeEndoso === \'D\'\" ng-click=\"deletePoliza()\"><span class=\"fa fa-trash-o\"></span> Eliminar Póliza</button></div></div></div></div><br><div></div><div class=\"wrapper wrapper-content animate fadeIn ng-scope\" ng-if=\"show_form_life\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Información del certificado</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div ng-if=\"vm.policy.ramo.ramo_code == 1\"><div class=\"form-group\"><button class=\"btn btn-primary\" ng-click=\"closeCertificate()\" type=\"submit\"><span class=\"fa fa-reply\"></span> Regresar</button></div><form name=\"formLife\"><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.certificate_number.$invalid && !formLife.certificate_number.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Antiguedad reconocida desde: <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"certificate_number\" ng-model=\"vm.covers.start_of_validity\" class=\"form-control\" ng-disabled=\"inputDisabledCert\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.certificate_number.$invalid && !formLife.certificate_number.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Número de certificado <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"certificate_number\" ng-model=\"vm.covers.certificate_number\" class=\"form-control\" ng-disabled=\"inputDisabledCert\" required=\"\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Subgrupo <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"group\" data-ng-options=\"item as item.name for item in subgroups\" ng-model=\"vm.configuration.group\" ng-disabled=\"inputDisabled\" ng-change=\"selectGroup(vm.configuration.group)\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Categoria</label><select class=\"form-control\" name=\"categoty\" data-ng-options=\"item as item.name for item in group_selected.categories\" ng-model=\"vm.configuration.category\" ng-disabled=\"comboboxDisabled\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Paquete <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"pack\" data-ng-options=\"item as item.package_name for item in vm.pack\" ng-model=\"vm.configuration.pack\" ng-disabled=\"inputDisabled\" required=\"\"><option value=\"\">Seleccione una opción</option></select></div></div><h4>Titular</h4><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pFirst_Name.$invalid && !formLife.pFirst_Name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Nombre <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pFirst_Name\" ng-model=\"vm.covers.life_policy[0].personal.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pLast_name.$invalid && !formLife.pLast_name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Apellido Paterno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pLast_name\" ng-model=\"vm.covers.life_policy[0].personal.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pSecond_last_name.$invalid && !formLife.pSecond_last_name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Apellido Materno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSecond_last_name\" ng-model=\"vm.covers.life_policy[0].personal.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"col-sm-3 form-group\" ng-class=\"{\'has-error\': formLife.pBirthdate.$invalid && !formLife.pBirthdate.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Fecha de nacimiento <span class=\"color-red\">*</span></label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" name=\"pBirthdate\" date-time=\"\" ng-model=\"vm.covers.life_policy[0].personal.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\" required=\"\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pEmail.$invalid && !formLife.pEmail.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Correo <span class=\"color-red\">*</span></label> <input type=\"email\" name=\"pEmail\" ng-model=\"vm.covers.life_policy[0].personal.email\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pBirthdate.$invalid && !formLife.pBirthdate.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Sexo <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"pSex\" ng-model=\"vm.covers.life_policy[0].personal.sex\" ng-disabled=\"inputDisabled\" required=\"\"><option value=\"\">Selecciona un sexo</option><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pSalary.$invalid && !formLife.pSalary.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Sueldo <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSalary\" ng-model=\"vm.covers.life_policy[0].personal.salary\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pSum_assured.$invalid && !formLife.pSum_assured.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Suma asegurada <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSum_assured\" ng-model=\"vm.covers.life_policy[0].personal.sum_assured\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><h4>Beneficiarios</h4><div class=\"row\"><div class=\"form-group col-xs-12 col-md-3\" ng-if=\"newEndoso\"><button type=\"button\" class=\"btn btn-info btn-block\" ng-click=\"vm.options.life.beneficiaries.add(vm.covers.life.beneficiaries)\"><span class=\"fa fa-plus-square-o\"></span> Agregar beneficiario</button></div></div><table class=\"table table-hover\"><tbody><tr ng-repeat=\"beneficiary in vm.covers.life_policy[0].beneficiaries_life track by $index\"><td><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Nombre</label> <input type=\"text\" ng-model=\"beneficiary.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Apellido Paterno</label> <input type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Apellido Materno</label> <input type=\"text\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Fecha de nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"beneficiary.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Sexo</label><select class=\"form-control\" ng-model=\"beneficiary.sex\" ng-disabled=\"inputDisabled\"><option value=\"\">Selecciona un sexo</option><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Parentesco</label> <input type=\"text\" ng-model=\"beneficiary.optional_relationship\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Porcentaje</label> <input type=\"text\" ng-model=\"beneficiary.percentage\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><button class=\"btn btn-danger btn-mt\" ng-if=\"newEndoso\" ng-click=\"vm.options.life.beneficiaries.destroy($index, beneficiary)\"><span class=\"fa fa-trash-o\"></span> Eliminar</button></div></div></td></tr></tbody></table><div class=\"form-group\"><button class=\"btn btn-primary pull-right\" ng-if=\"vm.selectedType.name === \'B\'\" ng-hide=\"newEndoso\" ng-click=\"showInputDisabled()\"><span class=\"fa fa-pencil-square-o\"></span> Editar</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'A\'\" ng-disabled=\"formLife.$invalid\" ng-click=\"saveCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Guardar Certificado</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'B\'\" ng-disabled=\"formLife.$invalid\" ng-click=\"editCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Actualizar Certificado</button> <button class=\"btn btn-white pull-right margin-right-10\" ng-if=\"newEndoso\" ng-click=\"closeCertificate()\" ui-sref=\"endosos.collectivity\"><span class=\"fa fa-times-circle\"></span> Cancelar</button></div></form></div><div ng-if=\"vm.policy.ramo.ramo_code == 2\"><div class=\"form-group\"><button class=\"btn btn-primary\" ng-click=\"closeCertificate()\" type=\"submit\"><span class=\"fa fa-reply\"></span> Regresar</button></div><form name=\"formDiseage\"><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.certificate_number.$invalid && !formDiseage.certificate_number.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Antiguedad reconocida desde: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.cobers.start_of_validity\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.certificate_number.$invalid && !formDiseage.certificate_number.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Número de certificado <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"certificate_number\" ng-model=\"vm.covers.certificate_number\" class=\"form-control\" ng-disabled=\"inputDisabledCert\" required=\"\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Subgrupo</label><select class=\"form-control\" name=\"group\" data-ng-options=\"item as item.name for item in subgroups\" ng-model=\"vm.configuration.group\" ng-disabled=\"inputDisabled\" ng-change=\"selectGroup(vm.configuration.group)\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Categoria</label><select class=\"form-control\" name=\"categoty\" data-ng-options=\"item as item.name for item in group_selected.categories\" ng-model=\"vm.configuration.category\" ng-disabled=\"comboboxDisabled\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Paquete</label><select class=\"form-control\" name=\"pack\" data-ng-options=\"item as item.package_name for item in vm.pack\" ng-model=\"vm.configuration.pack\" ng-disabled=\"inputDisabled\"><option value=\"\">Seleccione una opción</option></select></div></div><h4>Asegurado</h4><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pFirst_Name.$invalid && !formDiseage.pFirst_Name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Nombre <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pFirst_Name\" ng-model=\"vm.covers.personal.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pLast_name.$invalid && !formDiseage.pLast_name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Apellido Paterno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pLast_name\" ng-model=\"vm.covers.personal.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSecond_last_name.$invalid && !formDiseage.pSecond_last_name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Apellido Materno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSecond_last_name\" ng-model=\"vm.covers.personal.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"col-sm-3 form-group\" ng-class=\"{\'has-error\': formDiseage.pBirthdate.$invalid && !formDiseage.pBirthdate.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Fecha de nacimiento <span class=\"color-red\">*</span></label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" name=\"pBirthdate\" date-time=\"\" ng-model=\"vm.covers.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\" required=\"\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pEmail.$invalid && !formDiseage.pEmail.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Correo <span class=\"color-red\">*</span></label> <input type=\"email\" name=\"pEmail\" ng-model=\"vm.covers.personal.email\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSex.$invalid && !formDiseage.pSex.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Sexo <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"pSex\" ng-model=\"vm.covers.personal.sex\" ng-disabled=\"inputDisabled\" required=\"\"><option value=\"\">Selecciona un sexo</option><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSalary.$invalid && !formDiseage.pSalary.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Sueldo <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSalary\" ng-model=\"vm.covers.personal.salary\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSum_assured.$invalid && !formDiseage.pSum_assured.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Suma asegurada <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSum_assured\" ng-model=\"vm.covers.personal.sum_assured\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><hr><h4>Dependientes</h4><div class=\"row\"><div class=\"form-group col-xs-12 col-md-3\" ng-if=\"newEndoso\"><button type=\"button\" ng-click=\"vm.options.disease.relationships.add(vm.covers.disease.relationships)\" class=\"btn btn-info btn-block\"><span class=\"fa fa-plus-square-o\"></span> Agregar dependiente</button></div></div><table class=\"table table-hover\"><tbody><tr ng-repeat=\"beneficiary in vm.covers.relationship_accident track by $index\"><td><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Nombre</label> <input type=\"text\" ng-model=\"beneficiary.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Apellido Paterno</label> <input type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Apellido Materno</label> <input type=\"text\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Fecha de nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"beneficiary.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Sexo</label><select class=\"form-control\" ng-model=\"beneficiary.sex\" ng-disabled=\"inputDisabled\"><option value=\"\">Selecciona un sexo</option><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Parentesco</label><select class=\"form-control\" ng-model=\"beneficiary.relationship\" ng-disabled=\"inputDisabled\"><option value=\"\">Selecciona un parentesco</option><option value=\"1\">Titular</option><option value=\"2\">Cónyuge</option><option value=\"3\">Hijo</option></select></div><div class=\"form-group col-sm-3\"><button class=\"btn btn-danger btn-mt\" ng-if=\"newEndoso\" ng-click=\"vm.options.disease.relationships.destroy($index, beneficiary)\"><span class=\"fa fa-trash-o\"></span> Eliminar</button></div></div></td></tr></tbody></table><div class=\"form-group\"><button class=\"btn btn-primary pull-right\" ng-if=\"vm.selectedType.name === \'B\'\" ng-hide=\"newEndoso\" ng-click=\"showInputDisabled()\"><span class=\"fa fa-pencil-square-o\"></span> Editar</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'A\'\" ng-disabled=\"formDiseage.$invalid\" ng-click=\"saveCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Guardar Certificado</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'B\'\" ng-disabled=\"formDiseage.$invalid\" ng-click=\"editCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Actualizar Certificado</button> <button class=\"btn btn-white pull-right margin-right-10\" ng-if=\"newEndoso\" ng-click=\"closeCertificate()\" ui-sref=\"endosos.collectivity\"><span class=\"fa fa-times-circle\"></span> Cancelar</button></div></form></div><div ng-if=\"vm.policy.ramo.ramo_code == 3\"><div class=\"form-group\"><button class=\"btn btn-primary\" ng-click=\"closeCertificate()\" type=\"submit\"><span class=\"fa fa-reply\"></span> Regresar</button></div><form name=\"formAutomobile\"><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.certificate_number.$invalid && !formAutomobile.certificate_number.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Número de certificado <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"certificate_number\" ng-model=\"vm.covers.certificate_number\" class=\"form-control\" ng-disabled=\"inputDisabledCert\" required=\"\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Subgrupo</label><select class=\"form-control\" name=\"group\" data-ng-options=\"item as item.name for item in subgroups\" ng-model=\"vm.configuration.group\" ng-disabled=\"inputDisabled\" ng-change=\"selectGroup(vm.configuration.group)\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Categoria</label><select class=\"form-control\" name=\"categoty\" data-ng-options=\"item as item.name for item in group_selected.categories\" ng-model=\"vm.configuration.category\" ng-disabled=\"comboboxDisabled\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Paquete</label><select class=\"form-control\" name=\"pack\" data-ng-options=\"item as item.package_name for item in vm.pack\" ng-model=\"vm.configuration.pack\" ng-disabled=\"inputDisabled\"><option value=\"\">Seleccione una opción</option></select></div></div><h4>Automóvil</h4><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.brand.$invalid && !formAutomobile.brand.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Marca <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"brand\" ng-model=\"vm.covers.automobiles_policy[0].brand\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.model.$invalid && !formAutomobile.model.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Modelo <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"model\" ng-model=\"vm.covers.automobiles_policy[0].model\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.year.$invalid && !formAutomobile.year.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Año <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"year\" ng-model=\"vm.covers.automobiles_policy[0].year\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.version.$invalid && !formAutomobile.version.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Versión <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"version\" ng-model=\"vm.covers.automobiles_policy[0].version\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.color.$invalid && !formAutomobile.color.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Color <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"color\" ng-model=\"vm.covers.automobiles_policy[0].color\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.serial.$invalid && !formAutomobile.serial.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Serie <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"serial\" ng-model=\"vm.covers.automobiles_policy[0].serial\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.engine.$invalid && !formAutomobile.engine.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Motor <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"engine\" ng-model=\"vm.covers.automobiles_policy[0].engine\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.license_plates.$invalid && !formAutomobile.license_plates.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Matrícula <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"license_plates\" ng-model=\"vm.covers.automobiles_policy[0].license_plates\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><div class=\"form-group\"><button class=\"btn btn-primary pull-right\" ng-if=\"vm.selectedType.name === \'B\'\" ng-hide=\"newEndoso\" ng-click=\"showInputDisabled()\"><span class=\"fa fa-pencil-square-o\"></span> Editar</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'A\'\" ng-disabled=\"formAutomobile.$invalid\" ng-click=\"saveCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Guardar Certificado</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'B\'\" ng-disabled=\"formAutomobile.$invalid\" ng-click=\"editCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Actualizar Certificado</button> <button class=\"btn btn-white pull-right margin-right-10\" ng-if=\"newEndoso\" ng-click=\"closeCertificate()\" ui-sref=\"endosos.collectivity\"><span class=\"fa fa-times-circle\"></span> Cancelar</button></div></form></div></div></div></div></div></div>");
$templateCache.put("app/endosoFull/types/colectivo.html","<div class=\"col-xs-12 form-group padding20\"><legend class=\"legend-title\" align=\"center\">{{ descriptionSelected.name }}</legend></div><div ng-if=\"descriptionSelected.value == 1 || descriptionSelected.id == 6 || descriptionSelected.id ==1 || descriptionSelected.value ==6\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Forma de pago actual:</label> <input class=\"form-control\" type=\"text\" ng-model=\"oldPay\" ng-change=\"saveLocalstorange()\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Forma de pago nueva: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"paySelected\" ng-options=\"pay as pay.name for pay in payments track by pay.id\" ng-change=\"order.changePayment(paySelected)\"><option value=\"\" disabled=\"\">Selecciona una forma de pago</option></select></div><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Los recibos actuales de la póliza que esten como pendientes de pago, se eliminarán de la póliza para crear nuevos.</div></div></div><div ng-if=\"descriptionSelected.id == 24 || descriptionSelected.id == 35\" class=\"padding20\"><div><div class=\"col-xs-12 form-group\" ng-if=\"certificates_selected_alta.length > 0\"><table class=\"table table-bordered table-hover\" ng-if=\"caratula.ramo.ramo_code == 2\"><thead><tr><th>Categoría</th><th>Titular</th><th>Dependientes</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in certificates_selected_alta\"><td>{{ item.parent.category }}</td><td><span class=\"font-weight-bold\">{{ item.certificate_number }} - {{ item.personal.first_name }} {{ item.personal.last_name }} {{ item.personal.second_last_name }}</span><br><small>Prima Total: <span>{{ item.personal.p_total }}</span></small></td><td><ul><li ng-repeat=\"dependient in item.relationship_accident\"><span class=\"font-weight-bold\">{{ dependient.certificate }} - {{ dependient.first_name }} {{ dependient.last_name }} {{ dependient.second_last_name }}</span><br><small>Prima Total: <span>{{ dependient.p_total }}</span></small></li></ul></td><td><button type=\"button\" class=\"btn btn-white\" ng-click=\"deleteDependient($index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.ramo.ramo_code == 1\"><thead><tr><th>Categoría</th><th>Titular</th><th>Beneficiarios</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in certificates_selected_alta\"><td>{{ item.parent.category }}</td><td><span class=\"font-weight-bold\">{{ item.certificate_number }} - {{ item.personal.first_name }} {{ item.personal.last_name }} {{ item.personal.second_last_name }}</span><br><small>Prima Total: <span>{{ item.p_total }}</span></small></td><td><ul><li ng-repeat=\"dependient in item.beneficiaries_life\"><span class=\"font-weight-bold\">{{ dependient.certificate }} - {{ dependient.first_name }} {{ dependient.last_name }} {{ dependient.second_last_name }}</span></li></ul></td><td><button type=\"button\" class=\"btn btn-white\" ng-click=\"deleteDependient($index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.subramo.subramo_code == 9 || caratula.subramo.subramo_code == 13\"><thead><tr><th>Categoría</th><th>Marca</th><th>Modelo</th><th>Serie</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in certificates_selected_alta\"><td>{{ item.parent.category }}</td><td>{{ item.auto.brand }}</td><td>{{ item.auto.model }}</td><td>{{ item.auto.serial }}</td><td><button type=\"button\" class=\"btn btn-white\" ng-click=\"deleteDependient($index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.subramo.subramo_code == 7\"><thead><tr><th>Categoría</th><th>Sucursal</th><th>Giro</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in certificates_selected_alta\"><td>{{ item.parent.category }}</td><td>{{ item.auto.sucursal }}</td><td>{{ item.auto.giro }}</td><td><button type=\"button\" class=\"btn btn-white\" ng-click=\"deleteDependient($index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Total:</label> <input class=\"form-control\" type=\"number\" ng-model=\"suma_p_total\" disabled=\"\"></div></div><div class=\"col-xs-12 form-group padding20\" ng-if=\"caratula.ramo.ramo_code == 1 || caratula.ramo.ramo_code == 2\"><label class=\"m-t\"><input ng-if=\"(caratula.ramo.ramo_code == 2 && descriptionSelected.value != 40 && descriptionSelected.id != 35) || (caratula.ramo.ramo_code == 1 && descriptionSelected.value != 40 && descriptionSelected.id != 35)\" type=\"checkbox\" name=\"titular\" ng-click=\"showBeneficiaries(checkBeneficiaries)\" ng-model=\"checkBeneficiaries\" id=\"checkB\"> &nbsp;<span ng-if=\"caratula.ramo.ramo_code == 1\">Alta solo a beneficiarios</span> &nbsp;<span ng-if=\"caratula.ramo.ramo_code == 2 && descriptionSelected.value != 40 && descriptionSelected.id != 35\">Alta solo a dependiente(s) a titular existente</span></label></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Categoría: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"category as (\'Subgrupo: \' + category.subgroup + \' | Categoría: \'+ category.category) for category in categoriesJson\" ng-model=\"newCertificates.parent\" value=\"{{category.id}}\"><option value=\"\" disabled=\"\">Selecciona una categoría</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"!checkBeneficiaries\"><label>Paquetes: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"pack.package_name for pack in paquetes\" ng-model=\"newCertificates.paquete\" value=\"{{pack.id}}\"><option value=\"\" disabled=\"\">Selecciona un paquete</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"checkBeneficiaries\"><label ng-if=\"caratula.ramo.ramo_code ==2 || caratula.ramo.ramo_code ==1\">Número del Certificado/Nombre Titular: <span class=\"color-red\">*</span></label> <label ng-if=\"caratula.ramo.ramo_code ==3 && caratula.subramo.subramo_code ==9\">Serie o Número de Certificado:<span class=\"color-red\">*</span></label> <label ng-if=\"caratula.ramo.ramo_code ==3 && caratula.subramo.subramo_code !=9\">Número de Certificado:<span class=\"color-red\">*</span></label><autocomplete datasource=\"autocompleteDataCertificate\" model=\"order.titular\" change=\"getCertificates(order.titular)\"></autocomplete></div><div ng-if=\"caratula.ramo.ramo_code == 1\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Certificado:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.certificate_number\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Folio:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.folio\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificates.rec_antiguedad\" value=\"{{newCertificates.rec_antiguedad}}\" date-validator=\"\" ng-disabled=\"checkBeneficiaries\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo Electrónico: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"newCertificates.personal.email\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Inicio: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificates.start_of_validity\" date-validator=\"\" value=\"{{newCertificates.start_of_validity}}\" ng-disabled=\"checkBeneficiaries\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Fin: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificates.end_of_validity\" date-validator=\"\" value=\"{{newCertificates.end_of_validity}}\" ng-disabled=\"checkBeneficiaries\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12\"><label>Titular</label><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.first_name\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.last_name\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.second_last_name\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificates.personal.birthdate\" date-validator=\"\" value=\"{{newCertificates.personal.birthdate}}\" ng-disabled=\"checkBeneficiaries\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"sexo.label for sexo in sexs\" ng-model=\"newCertificates.personal.sex\" value=\"{{sexo.value}}\" ng-disabled=\"checkBeneficiaries\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo Suma Asegurada: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.label for type in typesInsureds\" ng-model=\"newCertificates.personal.type_sa\" value=\"{{type.value}}\" ng-disabled=\"checkBeneficiaries\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Suma Asegurada: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.sum_assured\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sueldo: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.salary\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fumador: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"smoke.label for smoke in smokers\" ng-model=\"newCertificates.smoker\" value=\"{{smoke.value}}\" ng-disabled=\"checkBeneficiaries\"></select></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"newCertificates.beneficiaries_life.length == 0\"><button class=\"btn btn-success col-xs-12\" ng-click=\"addBeneficiarie()\">Agregar Beneficiario</button></div><div class=\"address-container\" ng-repeat=\"item in newCertificates.beneficiaries_life\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"item.url\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"item.url\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiarie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiarie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.first_name\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.last_name\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.second_last_name\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.birthdate\" date-validator=\"\" value=\"{{item.birthdate}}\" ng-disabled=\"checkBeneficiaries && item.url\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Parentesco:</label><select class=\"form-control\" ng-options=\"relation.label for relation in relationships\" ng-model=\"item.optional_relationship\" value=\"{{relation.value}}\" ng-disabled=\"checkBeneficiaries && item.url\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo:</label><select class=\"form-control\" ng-options=\"sexbeneficiarie.label for sexbeneficiarie in sexs\" ng-model=\"item.sex\" value=\"{{sexbeneficiarie.value}}\" ng-disabled=\"checkBeneficiaries && item.url\"></select></div></div></div><div class=\"col-xs-12 form-group m-t\"><label for=\"description\">Observaciones del asegurado: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"newCertificates.observations\" ng-change=\"saveLocalstorange()\" name=\"description\" style=\"height: 36px\"></textarea></div></div><div ng-if=\"caratula.ramo.ramo_code == 2\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Certificado:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.certificate_number\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Folio:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.folio\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificates.rec_antiguedad\" value=\"{{datosantiguedad}}\" date-validator=\"\" ng-disabled=\"checkBeneficiaries\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo Electrónico: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"newCertificates.personal.email\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Inicio: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificates.start_of_validity\" date-validator=\"\" value=\"{{newCertificates.start_of_validity}}\" ng-disabled=\"checkBeneficiaries\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Fin: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificates.end_of_validity\" date-validator=\"\" value=\"{{newCertificates.end_of_validity}}\" ng-disabled=\"checkBeneficiaries\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12\" align=\"center\"><label class=\"pull-right blue-color\"><input type=\"checkbox\" name=\"\" ng-model=\"newCertificates.contributory\" ng-click=\"datosContributorios(newCertificates)\" ng-change=\"vm.saveLocalstorage(newCertificates)\"><b>Incluir Datos Contributorios</b></label> <label blue-color=\"\"><b>Titular</b></label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.first_name\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.last_name\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.second_last_name\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificates.personal.birthdate\" date-validator=\"\" ng-disabled=\"checkBeneficiaries\" placeholder=\"DD/MM/YYYY\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"sexo.label for sexo in sexs\" ng-model=\"newCertificates.personal.sex\" value=\"{{sexo.value}}\" ng-disabled=\"checkBeneficiaries\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Alta: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificates.personal.charge_date\" date-validator=\"\" value=\"{{newCertificates.personal.charge_date}}\" ng-disabled=\"checkBeneficiaries\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"row col-xs-12\"><div class=\"col-xs-12\" ng-if=\"newCertificates.contributory\"><div class=\"col-xs-12\" align=\"center\"><legend><b>RFC</b></legend></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Clave:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.rfc_cve\" ng-disabled=\"checkBeneficiaries\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Homoclave:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.rfc_homocve\" ng-disabled=\"checkBeneficiaries\"></div></div><div class=\"col-xs-12\" align=\"center\"><legend><b>Domicilio</b></legend></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Calle - Número:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.dom_callenum\" ng-disabled=\"checkBeneficiaries\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Colonia:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.dom_colonia\" ng-disabled=\"checkBeneficiaries\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">CP:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.dom_cp\" ng-disabled=\"checkBeneficiaries\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Municipio:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.dom_poblacion\" ng-disabled=\"checkBeneficiaries\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Estado:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.dom_estado\" ng-disabled=\"checkBeneficiaries\"></div></div></div></div><br><div class=\"col-xs-12\" align=\"center\"><label>Primas del Titular</label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.p_neta\" ng-change=\"changePrima(newCertificates.personal)\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.rpf\" ng-change=\"changePrima(newCertificates.personal)\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.derecho\" ng-change=\"changePrima(newCertificates.personal)\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.iva\" ng-change=\"changePrimaIva(newCertificates.personal)\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.p_total\" ng-change=\"changePrima(newCertificates.personal)\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.personal.comision\" ng-change=\"changePrima(newCertificates.personal)\" ng-disabled=\"checkBeneficiaries\"></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"newCertificates.relationship_accident.length == 0\"><button class=\"btn btn-success col-xs-12\" ng-click=\"addBeneficiarie()\">Agregar Dependiente</button></div><div class=\"address-container\" ng-repeat=\"item in newCertificates.relationship_accident\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"item.url\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Dependiente</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"item.url\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Dependiente #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiarie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Dependiente</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiarie()\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Certificado:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.certificate\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.first_name\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.last_name\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.second_last_name\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.birthdate\" date-validator=\"\" value=\"{{item.birthdate}}\" ng-disabled=\"checkBeneficiaries && item.url\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Parentesco:</label><select class=\"form-control\" ng-options=\"relation.label for relation in relationships\" ng-model=\"item.relationship\" value=\"{{relation.value}}\" ng-disabled=\"checkBeneficiaries && item.url\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo:</label><select class=\"form-control\" ng-options=\"sexbeneficiarie.label for sexbeneficiarie in sexs\" ng-model=\"item.sex\" value=\"{{sexbeneficiarie.value}}\" ng-disabled=\"checkBeneficiaries && item.url\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Alta:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.charge_date\" date-validator=\"\" value=\"{{item.charge_date}}\" ng-disabled=\"checkBeneficiaries && item.url\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"row col-xs-12\"><div class=\"col-xs-12\" ng-if=\"newCertificates.contributory\"><div class=\"col-xs-12\" align=\"center\"><legend><b>RFC</b></legend></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Clave:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.rfc_cve\" ng-disabled=\"checkBeneficiaries && item.url\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">RFC Homoclave:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.rfc_homocve\" ng-disabled=\"checkBeneficiaries && item.url\"></div></div><div class=\"col-xs-12\" align=\"center\"><legend><b>Domicilio</b></legend></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Calle - Número:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.dom_callenum\" ng-disabled=\"checkBeneficiaries && item.url\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Colonia:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.dom_colonia\" ng-disabled=\"checkBeneficiaries && item.url\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">CP:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.dom_cp\" ng-disabled=\"checkBeneficiaries && item.url\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Municipio:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.dom_poblacion\" ng-disabled=\"checkBeneficiaries && item.url\"></div></div><div class=\"col-xs-12 col-sm-4 col-ms-4 form-group\"><label class=\"blue-color\">Estado:</label><div ng-if=\"newCertificates.contributory\"><input class=\"form-control\" type=\"text\" ng-model=\"item.dom_estado\" ng-disabled=\"checkBeneficiaries && item.url\"></div></div></div></div><br><div class=\"col-xs-12\" align=\"center\"><label>Primas del Dependiente #{{$index + 1}}</label><br></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.p_neta\" ng-change=\"changePrima(item, $index)\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RPF:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.rpf\" ng-change=\"changePrima(item, $index)\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.derecho\" ng-change=\"changePrima(item, $index)\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>IVA:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.iva\" ng-change=\"changePrimaIva(item, $index)\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.p_total\" ng-change=\"changePrima(item, $index)\" ng-disabled=\"checkBeneficiaries && item.url\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.comision\" ng-change=\"changePrima(item, $index)\" ng-disabled=\"checkBeneficiaries && item.url\"></div></div></div><div class=\"col-xs-12 form-group m-t\"><label for=\"description\">Observaciones de la familia: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"newCertificates.observations\" ng-change=\"saveLocalstorange()\" name=\"description\" style=\"height: 36px\"></textarea></div></div><div ng-if=\"caratula.subramo.subramo_code == 9\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Inciso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.certificate_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Propietario:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.car_owner\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Conductor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.driver\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo Electrónico: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"newCertificates.auto.email\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Inicio: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificates.start_of_validity\" date-validator=\"\" value=\"{{newCertificates.start_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Fin: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"newCertificates.end_of_validity\" date-validator=\"\" value=\"{{newCertificates.end_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Empleado:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.no_employee\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Marca: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.brand\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Modelo: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.model\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Año: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.auto.year\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Versión: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.version\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Serie: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.serial\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Motor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.engine\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Color:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.color\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Matrícula:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.license_plates\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Uso: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"uso.label for uso in usages\" ng-model=\"newCertificates.auto.usage\" value=\"{{uso.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Servicio: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.service\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Procedencia: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"origin.label for origin in procedencias\" ng-model=\"newCertificates.auto.procedencia\" value=\"{{origin.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Valor/Suma Asegurada:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.auto.sum_insured\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo Carga:</label><select class=\"form-control\" ng-options=\"type.label for type in typesCharges\" ng-model=\"newCertificates.auto.charge_type\" value=\"{{type.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Adaptaciones:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.adjustment\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Monto Adaptaciones:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.mont_adjustment\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Equipamiento:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.special_team\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Monto Equipamiento:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.mont_special_team\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Beneficiario Preferente:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.preferential_benefiaciary\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Beneficiario RFC:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.beneficiary_rfc\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Beneficiario Dirección:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.beneficiary_address\"></div><div class=\"col-xs-12 form-group m-t\"><label for=\"description\">Observaciones del auto: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"newCertificates.observations\" ng-change=\"saveLocalstorange()\" name=\"description\" style=\"height: 36px\"></textarea></div></div><div ng-if=\"caratula.subramo.subramo_code == 7 || caratula.subramo.subramo_code == 13\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Inciso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.certificate_number\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Correo Electrónico: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"email\" ng-model=\"newCertificates.email\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Inicio: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" date-validator=\"\" ng-model=\"newCertificates.start_of_validity\" value=\"{{newCertificates.start_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Vigencia Fin: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" date-validator=\"\" ng-model=\"newCertificates.end_of_validity\" value=\"{{newCertificates.end_of_validity}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div ng-if=\"caratula.subramo.subramo_name == \'Incendio\'\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sucursal: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.sucursal\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Giro: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.giro\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo Constructivo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.label for type in typesConstruction\" ng-model=\"newCertificates.auto.type_construction\" value=\"{{type.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Niveles: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.auto.no_levels\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Zona FHM: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.fhm_zone\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Zona TYEV: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.tyev_zone\"></div></div><div ng-if=\"caratula.subramo.subramo_name == \'Diversos\'\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Propietario:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.dam_owner\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>No. Empleado:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.no_employee\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Description: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.item_details\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Uso: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"uso.label for uso in usages\" ng-model=\"newCertificates.auto.usage\" value=\"{{uso.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Marca: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.brand\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Modelo: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.model\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Año Contrucción: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.auto.construction_year\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Año Recontrucción: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.auto.reconstruction_year\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Versión: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.version\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Serie: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.serial\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Motor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.engine\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Color:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.color\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Matrícula:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.matricula\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Permiso: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.permiso\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Valor Comercial:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.auto.purchase_value\"></div></div><div class=\"col-xs-12 form-group\"><label>Dirección: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.auto.item_address\"></div><div class=\"col-xs-12 form-group m-t\"><label for=\"description\">Observaciones: <span class=\"color-red\">*</span></label> <textarea class=\"form-control\" ng-model=\"newCertificates.observations\" ng-change=\"saveLocalstorange()\" name=\"description\" style=\"height: 36px\"></textarea></div></div><div class=\"col-xs-12\"><hr></div><div ng-if=\"caratula.ramo.ramo_code != 2\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.p_neta\" ng-change=\"changePrima(newCertificates)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Rpf:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.rpf\" ng-change=\"changePrima(newCertificates)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.derecho\" ng-change=\"changePrima(newCertificates)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Iva:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.iva\" ng-change=\"changePrimaIva(newCertificates)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.p_total\" ng-change=\"changePrima(newCertificates)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comsión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.comision\" ng-change=\"changePrima(newCertificates)\"></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12 ladda-button2\" ng-click=\"validityEndorsement(checkBeneficiaries)\" oncl=\"\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Agregar Certificado</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-white col-xs-12\" ng-click=\"cancelDependient()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Cancelar</button></div></div></div><div ng-if=\"descriptionSelected.id == 25\"><div ng-if=\"newCertificates\"><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">Certificados</legend></div><div class=\"col-xs-12 form-group\" ng-if=\"certificates_selected.length > 0\"><table class=\"table table-bordered table-hover\" ng-if=\"caratula.ramo.ramo_code == 2\"><thead><tr><th>Categoría</th><th>Titular</th><th>Dependientes</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in certificates_selected\"><td>{{ item.categoria.category }}</td><td><span class=\"font-weight-bold\">{{ item.certificate_number }} - {{ item.personal.first_name }} {{ item.personal.last_name }} {{ item.personal.second_last_name }}</span><br><small>Prima Total: <span>{{ item.personal.p_total_earned }}</span></small></td><td><ul><li ng-repeat=\"dependient in item.personal.dependientes\"><span class=\"font-weight-bold\">{{ dependient.certificate }} - {{ dependient.first_name }} {{ dependient.last_name }} {{ dependient.second_last_name }}</span><br><small>Prima Total: <span>{{ dependient.p_total_earned }}</span></small></li></ul></td><td><button type=\"button\" class=\"btn btn-white\" ng-click=\"deleteDependient($index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.ramo.ramo_code == 1 || caratula.ramo.ramo_code == \'1\'\"><thead><tr><th>Categoría</th><th>Titular</th><th>Dependientes</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in certificates_selected\"><td>{{ item.categoria.category }}</td><td>{{ item.personal.certificate }} - {{ item.personal.first_name }} {{ item.personal.last_name }} {{ item.personal.second_last_name }}</td><td><ul><li ng-repeat=\"dependient in item.personal.dependientes\"><span>{{ dependient.certificate }} - {{ dependient.first_name }} {{ dependient.last_name }} {{ dependient.second_last_name }}</span></li></ul></td><td><button type=\"button\" class=\"btn btn-white\" ng-click=\"deleteDependient($index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratula.subramo.subramo_code == 9 || caratula.subramo.subramo_code == 7 || caratula.subramo.subramo_code == 13\"><thead><tr><th>Categoría</th><th>Marca</th><th>Modelo</th><th>Serie</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in certificates_selected\"><td>{{ item.categoria.category }}</td><td>{{ item.personal.brand }}</td><td>{{ item.personal.model }}</td><td>{{ item.personal.serial }}</td><td><button type=\"button\" class=\"btn btn-white\" ng-click=\"deleteDependient($index)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Total:</label> <input class=\"form-control\" type=\"number\" ng-model=\"suma_p_total_baja\" disabled=\"\"></div></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Categoría: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"category as (\'Subgrupo: \' + category.subgroup + \' | Categoría: \'+ category.category) for category in categoriesJson\" ng-model=\"newCertificates.parent\" value=\"{{category.id}}\"><option value=\"\" disabled=\"\">Selecciona una categoría</option></select></div><div class=\"col-xs-12 col-sm-6 form-group\"><label ng-if=\"caratula.ramo.ramo_code ==2 || caratula.ramo.ramo_code ==1\">Número del Certificado/Nombre Titular: <span class=\"color-red\">*</span></label> <label ng-if=\"caratula.ramo.ramo_code ==3 && caratula.subramo.subramo_code ==9\">Serie o Número de Certificado:<span class=\"color-red\">*</span></label> <label ng-if=\"caratula.ramo.ramo_code ==3 && caratula.subramo.subramo_code !=9\">Número de Certificado:<span class=\"color-red\">*</span></label><autocomplete datasource=\"autocompleteDataCertificate\" model=\"order.titular\" change=\"getCertificates(order.titular)\"></autocomplete></div><div ng-if=\"order.titular.value && caratula.ramo.ramo_code == 2\"><div class=\"col-xs-12 form-grou\"><br><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Selecciona el check de <b>Baja a dependientes</b> si quieres dar de baja uno o mas dependientes. Recuerda seleccionar los dependientes que quieras dar de baja.</div></div><div class=\"col-xs-12 form-group\"><label class=\"m-t\"><input type=\"checkbox\" name=\"titular\" ng-click=\"showDependients(checkDependients)\" ng-model=\"checkDependients\"> &nbsp;Baja a titular y dependientes</label></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\"><label>{{ newCertificates.personal.certificate }} - {{ newCertificates.personal.first_name }} {{ newCertificates.personal.last_name }} {{ newCertificates.personal.second_last_name }}</label></legend></div><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Primas No Devengadas del Titular</h3></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Baja: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"newCertificates.personal.discharge_date\" date-validator=\"\" data-date-format=\"dd/MM/yyyy\" ng-disabled=\"!checkDependients\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.p_neta_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\" ng-disabled=\"!checkDependients\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Rpf:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.rpf_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\" ng-disabled=\"!checkDependients\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.derecho_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\" ng-disabled=\"!checkDependients\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Iva:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.iva_earned\" ng-change=\"changePrimaTutularIva(newCertificates.personal)\" ng-disabled=\"!checkDependients\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.p_total_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\" ng-disabled=\"!checkDependients\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.comision_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\" ng-disabled=\"!checkDependients\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Porcentaje de Comisión:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.comision_percent_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\" ng-disabled=\"!checkDependients\"></div><div class=\"address-container\" ng-repeat=\"item in newCertificates.dependientes\" ng-if=\"item.is_active\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><label class=\"m-t\"><input type=\"checkbox\" name=\"item.dependient\" ng-checked=\"checkcert(item, item.selected)\" ng-model=\"item.selected\" ng-disabled=\"checkDependients\"> <span class=\"hidden-xs\">{{ item.certificate }} - {{ item.first_name }} {{ item.last_name }} {{ item.second_last_name }}</span></label></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Primas No Devengadas del Dependiente</h3></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Baja: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"item.discharge_date\" date-validator=\"\" data-date-format=\"dd/MM/yyyy\" ng-disabled=\"!item.selected\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"number\" ng-model=\"item.p_neta_earned\" ng-change=\"changePrimaDependient(item, $index)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Rpf:</label> <input class=\"form-control\" type=\"number\" ng-model=\"item.rpf_earned\" ng-change=\"changePrimaDependient(item, $index)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"number\" ng-model=\"item.derecho_earned\" ng-change=\"changePrimaDependient(item, $index)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Iva:</label> <input class=\"form-control\" type=\"number\" ng-model=\"item.iva_earned\" ng-change=\"changePrimaDependient(item, $index)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"number\" ng-model=\"item.p_total_earned\" ng-change=\"changePrimaDependient(item, $index)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"number\" ng-model=\"item.comision_earned\" ng-change=\"changePrimaDependient(item, $index)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Porcentaje de Comisión:</label> <input class=\"form-control\" type=\"number\" ng-model=\"item.comision_percent_earned\" ng-change=\"changePrimaDependient(item, $index)\" ng-disabled=\"!item.selected\"></div></div></div></div><div ng-if=\"order.titular.value && (caratula.ramo.ramo_code == \'1\' || caratula.ramo.ramo_code == 1)\"><div class=\"col-xs-12 form-group\"><br><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Selecciona el check de <b>Baja a dependientes</b> si quieres dar de baja uno o mas dependientes. Recuerda seleccionar los dependientes que quieras dar de baja.</div></div><div class=\"col-xs-12 form-group\"><legend class=\"legend-title\"><label>{{ newCertificates.personal.certificate }} - {{ newCertificates.personal.first_name }} {{ newCertificates.personal.last_name }} {{ newCertificates.personal.second_last_name }}</label></legend></div><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Primas No Devengadas del Titular</h3></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Baja: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"newCertificates.personal.discharge_date\" date-validator=\"\" data-date-format=\"dd/MM/yyyy\" ng-disabled=\"!checkDependients\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.p_neta_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Rpf:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.rpf_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.derecho_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Iva:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.iva_earned\" ng-change=\"changePrimaTutularIva(newCertificates.personal)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.p_total_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.comision_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Porcentaje de Comisión:</label> <input class=\"form-control\" type=\"number\" ng-model=\"newCertificates.personal.comision_percent_earned\" ng-change=\"changePrimaTutular(newCertificates.personal)\"></div><div class=\"address-container\" ng-repeat=\"item in newCertificates.dependientes\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\">{{ item.certificate }} - {{ item.first_name }} {{ item.last_name }} {{ item.second_last_name }}</legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Primas No Devengadas del Beneficiario</h3></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Baja: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"item.discharge_date\" date-validator=\"\" data-date-format=\"dd/MM/yyyy\" ng-disabled=\"!item.selected\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.p_neta_earned\" ng-change=\"changePrimaDependient(item)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Rpf:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.rpf_earned\" ng-change=\"changePrimaDependient(item)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.derecho_earned\" ng-change=\"changePrimaDependient(item)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Iva:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.iva_earned\" ng-change=\"changePrimaDependient(item)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.p_total_earned\" ng-change=\"changePrimaDependient(item)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.comision_earned\" ng-change=\"changePrimaDependient(item)\" ng-disabled=\"!item.selected\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Porcentaje de Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.comision_percent_earned\" ng-change=\"changePrimaDependient(item)\" ng-disabled=\"!item.selected\"></div></div></div></div><div ng-if=\"order.titular.value && (caratula.subramo.subramo_code == 9 || caratula.subramo.subramo_code == 7 || caratula.subramo.subramo_code == 13)\"><div class=\"col-xs-12 form-group\"><h3 align=\"center\">Primas No Devengadas</h3></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Baja: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"newCertificates.discharge_date\" date-validator=\"\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Neta:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.p_neta_earned\" ng-blur=\"changePrimaDependient(newCertificates)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Rpf:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.rpf_earned\" ng-blur=\"changePrimaDependient(newCertificates)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Derecho:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.derecho_earned\" ng-blur=\"changePrimaDependient(newCertificates)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Iva:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.iva_earned\" ng-blur=\"changePrimaDependient(newCertificates)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Prima Total:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.p_total_earned\" ng-blur=\"changePrimaDependient(newCertificates)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.comision_earned\" ng-blur=\"changePrimaDependient(newCertificates)\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Porcentaje de Comisión:</label> <input class=\"form-control\" type=\"text\" ng-model=\"newCertificates.comision_percent_earned\" ng-blur=\"changePrimaDependient(newCertificates)\"></div></div><div ng-if=\"order.titular.value\"><div class=\"col-xs-12 form-grou\"><br><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Debes agregar el certificado con el botón de abajo para guardarlo y poder agregar el siguiente certificado.</div></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"addcertificate()\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Agregar Certificado</button></div><div class=\"col-xs-12 col-sm-3 form-group pull-right\"><button class=\"btn btn-white col-xs-12\" ng-click=\"cancelDependient()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Cancelar</button></div></div></div></div>");
$templateCache.put("app/endosoFull/types/individual.html","<div class=\"col-xs-12 form-group\"><legend class=\"legend-title\" align=\"center\">{{ descriptionSelected.name }}</legend></div><div ng-if=\"descriptionSelected.value == 1 || descriptionSelected.value == 6\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Forma de pago actual:</label> <input class=\"form-control\" type=\"text\" ng-model=\"oldPay\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Forma de pago nueva: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-model=\"paySelected\" ng-options=\"pay as pay.name for pay in payments track by pay.id\" ng-change=\"changePayment(paySelected)\"><option value=\"\" disabled=\"\">Selecciona una forma de pago</option></select></div><div class=\"col-xs-12 form-group\"><div class=\"alert alert-info alert-dismissible\"><a class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a> <strong>Información:</strong> Los recibos actuales de la póliza que esten como pendientes de pago, se eliminarán de la póliza para crear nuevos.</div></div></div><div ng-if=\"descriptionSelected.value == 2 || descriptionSelected.value == 7\"><button class=\"btn btn-success pull-right\" ng-click=\"add_new_coverage = !add_new_coverage; trigger_add_coverage(add_new_coverage)\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Nueva Cobertura</button><div class=\"col-xs-12\" ng-if=\"add_new_coverage\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nombre de la Cobertura: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"new_coverage.coverage_name\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Suma Asegurada:</label> <input class=\"form-control\" type=\"text\" ng-model=\"new_coverage.sums_coverage\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Deducible:</label> <input class=\"form-control\" type=\"text\" ng-model=\"new_coverage.deductible\" ng-change=\"saveLocalstorange()\"></div><button class=\"btn btn-success pull-right\" ng-click=\"addNewPackageCoverage(new_coverage)\" type=\"button\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Guardar Cobertura</button></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Paquete:</label><select class=\"form-control\" ng-options=\"pack.package_name for pack in packages\" ng-change=\"changePackage(packageSelected)\" ng-model=\"packageSelected\"><option value=\"\" disabled=\"\">Selecciona un paquete</option></select></div><div class=\"col-xs-12 form-group\"><div ng-include=\"\'app/coberturas/coberturas.table.html\'\"></div></div></div><div ng-if=\"descriptionSelected.value == 4 || descriptionSelected.value == 5\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Contratante: <span class=\"color-red\">*</span></label><autocomplete datasource=\"contractors_data\" id=\"contractors\" model=\"order.contratante\" change=\"matchesContractors(order.contratante)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"address.tipo + \' - \' + address.route + \' \' + address.street_number + \' Int. \'+ address.street_number_int + \' \' + address.sublocality + \' \' + address.administrative_area_level_2 + \', \' + address.administrative_area_level_1 for address in addresses track by address.url\" ng-change=\"changeAddress(addressSelected)\" ng-model=\"addressSelected\" ng-disabled=\"!order.contratante\"><option value=\"\" disabled=\"\">Selecciona una dirección</option></select></div></div><div ng-if=\"descriptionSelected.value == 9 || descriptionSelected.value == 11 || descriptionSelected.value == 13\"><div class=\"col-xs-12\"><label>Titular</label><hr></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.first_name\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.last_name\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.second_last_name\" ng-change=\"saveLocalstorange()\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"change_endorsement.birthdate\" ng-change=\"validateBirthdate(change_endorsement.birthdate)\" value=\"{{change_endorsement.birthdate}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"sexo.label for sexo in sexs track by sexo.value\" ng-model=\"change_endorsement.sex\" value=\"{{sexo.value}}\" ng-change=\"saveLocalstorange()\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"change_endorsement.antiguedad\" ng-change=\"validateBirthdate(change_endorsement.antiguedad)\" value=\"{{change_endorsement.antiguedad}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fumador: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"smoke.label for smoke in smokers\" ng-model=\"change_endorsement.smoker\" value=\"{{smoke.value}}\"></select></div></div><div ng-if=\"descriptionSelected.value == 10 || descriptionSelected.value == 12 || descriptionSelected.value == 14\"><div class=\"address-container\" ng-repeat=\"item in change_endorsement\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"change_endorsement.length == 1 || (item.id && typeSelected.name != \'D\')\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Beneficiario</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"change_endorsement.length == 1 || (item.id && typeSelected.name != \'D\')\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Beneficiario #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiarie()\" type=\"button\" ng-disabled=\"item.id && typeSelected.name != \'A\'\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Beneficiario</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiarie()\" type=\"button\" ng-disabled=\"item.id && typeSelected.name != \'A\'\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i>></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 m-b\"><button ng-if=\"item.type_person == 1\" class=\"btn btn-primary col-xs-6\" ng-click=\"typePerson(1, $index)\" ng-disabled=\"item.id && typeSelected.name != \'B\'\">Física</button> <button ng-if=\"item.type_person == 1\" class=\"btn btn-default col-xs-6\" ng-click=\"typePerson(2, $index)\" ng-disabled=\"item.id && typeSelected.name != \'B\'\">Moral</button> <button ng-if=\"item.type_person == 2\" class=\"btn btn-default col-xs-6\" ng-click=\"typePerson(1, $index)\" ng-disabled=\"item.id && typeSelected.name != \'B\'\">Física</button> <button ng-if=\"item.type_person == 2\" class=\"btn btn-primary col-xs-6\" ng-click=\"typePerson(2, $index)\" ng-disabled=\"item.id && typeSelected.name != \'B\'\">Moral</button></div><div ng-if=\"item.type_person == 1\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.first_name\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.last_name\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.second_last_name\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.birthdate\" ng-change=\"validateBirthdate(item.birthdate)\" value=\"{{item.birthdate}}\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Parentesco: <span class=\"color-red\">*</span></label><input class=\"form-control\" type=\"text\" ng-model=\"item.optional_relationship\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"sexbeneficiarie.label for sexbeneficiarie in sexs track by sexbeneficiarie.value\" ng-model=\"item.sex\" value=\"{{sexbeneficiarie.value}}\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Antigüedad:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.antiguedad\" ng-change=\"validateBirthdate(item.antiguedad)\" value=\"{{item.antiguedad}}\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Porcentaje: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.percentage\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></div></div><div ng-if=\"item.type_person == 2\"><div class=\"col-xs-12 col-xs-6 form-group\"><label>Razón Social: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.j_name\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>RFC: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.rfc\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.antiguedad\" ng-change=\"validateBirthdate(item.antiguedad)\" value=\"{{item.antiguedad}}\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div></div><div ng-if=\"descriptionSelected.value == 16 || descriptionSelected.value == 20 || descriptionSelected.value == 24\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Tabulador:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.tabulator\"></div></div><div ng-if=\"descriptionSelected.value == 15 || descriptionSelected.value == 19 || descriptionSelected.value == 23\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Nivel Hospitalario:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.hospital_level\"></div></div><div ng-if=\"descriptionSelected.value == 13 || descriptionSelected.value == 13 || descriptionSelected.value == 8\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Fecha de Cancelación: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"change_endorsement.fecha_cancelacion\" ng-change=\"validateCancelacion(change_endorsement.fecha_cancelacion)\" value=\"{{change_endorsement.fecha_cancelacion}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div ng-if=\"descriptionSelected.value == 17 || descriptionSelected.value == 21 || descriptionSelected.value == 25\"><div class=\"col-xs-12\"><label>Titular</label></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.first_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.last_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.second_last_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"change_endorsement.birthdate\" ng-change=\"validateBirthdate(change_endorsement.birthdate)\" value=\"{{change_endorsement.birthdate}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"sexo.label for sexo in sexs track by sexo.value\" ng-model=\"change_endorsement.sex\" value=\"{{sexo.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Antigüedad:</label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"change_endorsement.antiguedad\" ng-change=\"validateBirthdate(change_endorsement.antiguedad)\" value=\"{{change_endorsement.antiguedad}}\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div ng-if=\"descriptionSelected.value == 18 || descriptionSelected.value == 22 || descriptionSelected.value == 26\"><div class=\"col-xs-12 form-group\"><button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiarie()\" type=\"button\" ng-if=\"change_endorsement.length == 0\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Dependiente</button><div class=\"address-container\" ng-repeat=\"item in change_endorsement\"><div class=\"col-xs-12 legend-gray\"><legend class=\"legend-title legend-flex\" align=\"center\"><button type=\"button\" class=\"btn btn-danger pull-left hidden-xs\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"change_endorsement.length == 0 || (item.id && typeSelected.name != \'D\')\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i> Quitar Dependiente</button> <button type=\"button\" class=\"btn btn-danger pull-left visible-xs-inline-block\" name=\"button\" ng-click=\"deleteBeneficiarie($index)\" ng-disabled=\"change_endorsement.length == 0 || (item.id && typeSelected.name != \'D\')\"><i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i></button> <span class=\"hidden-xs\">Dependiente #{{$index + 1}}</span> <button class=\"btn btn-success pull-right hidden-xs\" ng-click=\"addBeneficiarie()\" type=\"button\" ng-disabled=\"item.id && typeSelected.name != \'A\'\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i> Agregar Dependiente</button> <button class=\"btn btn-success pull-right visible-xs-inline-block\" ng-click=\"addBeneficiarie()\" type=\"button\" ng-disabled=\"item.id && typeSelected.name != \'A\'\"><i class=\"fa fa-plus-circle\" aria-hidden=\"true\"></i></button></legend></div><div class=\"col-xs-12 address_components\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Nombre: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.first_name\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Paterno: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"item.last_name\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Apellido Materno:</label> <input class=\"form-control\" type=\"text\" ng-model=\"item.second_last_name\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Nacimiento: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.birthdate\" ng-change=\"validateBirthdate(item.birthdate)\" value=\"{{item.birthdate}}\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Parentesco: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"relation.label for relation in relationships track by relation.value\" ng-model=\"item.relationship\" value=\"{{relation.value}}\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Sexo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"sexbeneficiarie.label for sexbeneficiarie in sexs track by sexbeneficiarie.value\" ng-model=\"item.sex\" value=\"{{sexbeneficiarie.value}}\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Fecha de Antigüedad: <span class=\"color-red\">*</span></label><div class=\"datepicker-me input-group date\"><input type=\"text\" class=\"width-100 text-align-center form-control\" data-provide=\"datepicker\" ng-model=\"item.antiguedad\" ng-change=\"validateBirthdate(item.antiguedad)\" value=\"{{item.antiguedad}}\" ng-disabled=\"item.id && typeSelected.name != \'B\'\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div></div><div ng-if=\"descriptionSelected.value == 27 || descriptionSelected.value == 32\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Tipo: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"type.name for type in types_auto\" ng-model=\"change_endorsement.policy_type\" value=\"{{type.id}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Marca: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.brand\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Modelo: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.model\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Año: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"number\" ng-model=\"change_endorsement.year\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Versión: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.version\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Serie: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.serial\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Motor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.engine\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Color:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.color\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Matrícula:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.license_plates\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Uso: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"uso.label for uso in usages\" ng-model=\"change_endorsement.usage\" value=\"{{uso.value}}\"></select></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Servicio: <span class=\"color-red\">*</span></label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.service\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Procedencia: <span class=\"color-red\">*</span></label><select class=\"form-control\" ng-options=\"origin.label for origin in procedencias\" ng-model=\"change_endorsement.procedencia\" value=\"{{origin.value}}\"></select></div></div><div ng-if=\"descriptionSelected.value == 28 || descriptionSelected.value == 33\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Conductor:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.driver\"></div></div><div ng-if=\"descriptionSelected.value == 30 || descriptionSelected.value == 35\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Adaptaciones:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.adjustment\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Monto Adaptaciones:</label> <input class=\"form-control\" type=\"number\" ng-model=\"change_endorsement.mont_adjustment\"></div></div><div ng-if=\"descriptionSelected.value == 29 || descriptionSelected.value == 34\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Equipamiento:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.special_team\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Monto Equipamiento:</label> <input class=\"form-control\" type=\"number\" ng-model=\"change_endorsement.mont_special_team\"></div></div><div ng-if=\"descriptionSelected.value == 31\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Beneficiario Preferente:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.beneficiary_name\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Beneficiario RFC:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.beneficiary_rfc\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Beneficiario Dirección:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.beneficiary_address\"></div></div><div ng-if=\"descriptionSelected.value == 36\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Bien Asegurado:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.insured_item\"></div><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><label>Detalles:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.item_details\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Dirección:</label> <input class=\"form-control\" type=\"text\" ng-model=\"change_endorsement.item_address\"></div></div>");
$templateCache.put("app/endosos/type/a.html","<div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del endoso</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.start_of_validity\" ng-change=\"changeUntil()\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_of_validity\" data-date-format=\"dd/MM/yyyy\" disabled=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del endoso</label> <textarea class=\"form-control\" ng-model=\"vm.form.observations\" name=\"description\"></textarea></div><div ng-show=\"vm.subforms.show === 1\" ng-if=\"valueConcept == 4 || valueConcept == 7\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Automóvil</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"brand\">Marca</label> <input class=\"form-control\" ng-model=\"vm.subforms.brand\" type=\"text\" ng-disabled=\"((vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO\') || (vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR PETICIÓN\'))\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"model\">Modelo</label> <input class=\"form-control\" ng-model=\"vm.subforms.model\" type=\"text\" ng-disabled=\"((vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO\') || (vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR PETICIÓN\'))\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"year\">Año</label><select class=\"form-control\" ng-model=\"vm.subforms.year\" ng-options=\"year as year for year in vm.defaults.years track by year\" ng-disabled=\"((vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO\') || (vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR PETICIÓN\'))\"><option value=\"\">{{vm.subforms.year}}</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"version\">Versión</label> <input class=\"form-control\" ng-model=\"vm.subforms.version\" type=\"text\" ng-disabled=\"((vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO\') || (vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR PETICIÓN\'))\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"serial\">Serie</label> <input class=\"form-control\" ng-model=\"vm.subforms.serial\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"engine\">Motor</label> <input class=\"form-control\" ng-model=\"vm.subforms.engine\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"color\">Color</label> <input class=\"form-control\" ng-model=\"vm.subforms.color\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"license_plates\">Placas</label> <input class=\"form-control\" ng-model=\"vm.subforms.license_plates\" type=\"text\" disabled=\"\"></div></div><div ng-show=\"vm.subforms.show === 2\" ng-if=\"valueConcept == 4 || valueConcept == 7\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Bien asegurado</label> <input class=\"form-control\" ng-model=\"vm.subforms.insured_item\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Detalles</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_details\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Direccion</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_address\" type=\"text\" disabled=\"\"></div></div><div ng-show=\"vm.subforms.show === 3\" ng-if=\"valueConcept == 4 || valueConcept == 7\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Asegurado</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"name\">Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"middle_name\">Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"last_name\">Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento\">Fecha de nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"vm.subforms.personal.birthdate\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"gender\">Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'M\'\"> MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'F\'\"> FEMENINO</span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"smoker\">Fumador</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.smoker\" name=\"smoker\" ng-value=\"true\" disabled=\"\"> SI</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.smoker\" name=\"smoker\" ng-value=\"false\" disabled=\"\"> NO</span></div></div></div><div ng-show=\"vm.subforms.show === 0\" ng-if=\"valueConcept == 4 || valueConcept == 7\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Asegurado</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Fecha de nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"vm.subforms.personal.birthdate\" ng-disabled=\"((vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO\') || (vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR PETICIÓN\')) && (vm.form.description == \'OTRO\')\"></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'M\'\">MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'F\'\">FEMENINO</span></div></div></div><div class=\"col-md-12 col-sm-12 form-group\" ng-if=\"valueConcept == 2 || valueConcept == 3 || valueConcept == 5 || valueConcept == 7\"><legend class=\"legend-title\" align=\"center\">Coberturas</legend><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-stripped table-hover\" data-filter=\"#filter\" data-page-size=\"25\"><thead><tr><th class=\"text-align-center width-20p\" data-breakpoints=\"xs\">Cobertura</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">S. Asegurada</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">Deducible</th><th ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\">Coaseguro</th><th class=\"display-none\">Prima</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.defaults.coverages\"><td class=\"text-align-center\"><p ng-bind=\"coverage.coverage_name\"></p></td><td class=\"text-align-center\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.sums_coverage\" ng-init=\"!coverage.sumInPolicy.value && item.default ? coverage.sumInPolicy.value = item.sum_insured : def = item.default\" ng-click=\"coverage.sumInPolicy.value = item.sum_insured; show_button_save_sum = false\"><a>{{demo(item.sum_insured) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.sumInPolicy.value\" ng-keyup=\"show_button_save_sum = true\" format-currency=\"currency\" ng-disabled=\"valueConcept == 3\"><div class=\"input-group-btn\" ng-show=\"show_button_save_sum\"><button class=\"btn btn-success\" ng-click=\"saveSum(coverage.sumInPolicy.value, coverage);show_button_save_sum = result_\">+</button></div></div></td><td class=\"text-align-center\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.deductible_coverage\" ng-init=\"item.default ? coverage.deductibleInPolicy.value = item.deductible : def = item.default\" ng-click=\"coverage.deductibleInPolicy.value = item.deductible; show_button_save_ded = false\"><a>{{demo(item.deductible) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.deductibleInPolicy.value\" ng-keyup=\"show_button_save_ded = true\" format-currency=\"currency\" ng-disabled=\"valueConcept == 2\"><div class=\"input-group-btn\" ng-show=\"show_button_save_ded\"><button class=\"btn btn-success\" ng-click=\"saveDed(coverage.deductibleInPolicy.value, coverage);show_button_save_ded = result_ded\">+</button></div></div></td><td class=\"text-align-center\" ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\"><input class=\"form-control m-b\" type=\"text\" ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\" ng-model=\"coverage.coinsurance\" value=\"\" ng-disabled=\"valueConcept == 2\"></td><td class=\"display-none\"><input class=\"form-control m-b\" format-as-currency=\"\" ng-model=\"coverage.primaInPolicy.value\"></td><td class=\"text-align-center\"><button class=\"btn btn-danger btn-danger\" name=\"button\" ng-click=\"vm.options.deleteCoverage(coverage, $index)\" type=\"button\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div class=\"form-group\"><label>Agregar coberturas</label><select class=\"form-control m-b\" ng-options=\"cvg.coverage_name for cvg in vm.defaults.coverageList | orderBy: \'coverage_name\' track by cvg.id\" ng-change=\"vm.options.addCoverage(vm.defaults.coverageInPackage)\" ng-model=\"vm.defaults.coverageInPackage\"><option value=\"\" disabled=\"\">Agrega una cobertura</option></select></div></div></div></div></div>");
$templateCache.put("app/endosos/type/b.html","<div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del endoso</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.start_of_validity\" value=\"{{vm.form.start_of_validity}}\" ng-change=\"changeUntil()\" data-date-format=\"mm/dd/yyyy\"></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_of_validity\" value=\"{{vm.form.end_of_validity}}\" data-date-format=\"mm/dd/yyyy\" disabled=\"\"></div></div><div class=\"col-sm-12 form-group\"><label for=\"description\">Descripción del endoso</label> <textarea class=\"form-control\" ng-model=\"vm.form.observations\" name=\"description\"></textarea></div><div ng-show=\"vm.subforms.show === 1\" ng-if=\"valueConcept == 8 || valueConcept == 10\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Automóvil</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"brand\">Marca</label> <input class=\"form-control\" ng-model=\"vm.subforms.brand\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"model\">Modelo</label> <input class=\"form-control\" ng-model=\"vm.subforms.model\" type=\"text\" disabled=\"\" ng-disabled=\"vm.form.description.label == \'\' || !(vm.form.description.label == \'MODIFICACIÓN DE DATOS DE ASEGURADO\' || !(vm.form.description.label == \'CORRECCIÓN DATOS DE ASEGURADO\'))\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"year\">Año</label><select class=\"form-control\" ng-model=\"vm.subforms.year\" ng-options=\"year as year for year in vm.defaults.years track by year\" disabled=\"\"><option value=\"\">{{vm.subforms.year}}</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"version\">Versión</label> <input class=\"form-control\" ng-model=\"vm.subforms.version\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"serial\">Serie</label> <input class=\"form-control\" ng-model=\"vm.subforms.serial\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"engine\">Motor</label> <input class=\"form-control\" ng-model=\"vm.subforms.engine\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"color\">Color</label> <input class=\"form-control\" ng-model=\"vm.subforms.color\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"license_plates\">Placas</label> <input class=\"form-control\" ng-model=\"vm.subforms.license_plates\" type=\"text\"></div></div><div ng-show=\"vm.subforms.show === 2\" ng-if=\"valueConcept == 8 || valueConcept == 10\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos</legend></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Bien asegurado</label> <input class=\"form-control\" ng-model=\"vm.subforms.insured_item\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Detalles</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_details\" type=\"text\"></div><div class=\"col-xs-12 col-sm-4 form-group\"><label>Direccion</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_address\" type=\"text\"></div></div><div ng-show=\"vm.subforms.show === 3\" ng-if=\"valueConcept == 8 || valueConcept == 10\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Asegurado</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\" ng-disabled=\"!(vm.form.description.label == \'CORRECCIÓN DATOS DE ASEGURADO\' || vm.form.description.label == \'MODIFICACIÓN DE DATOS DE ASEGURADO\' || vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'CORRECCIÓN DATOS DE ASEGURADO\' || vm.form.description.label == \'MODIFICACIÓN DE DATOS DE ASEGURADO\' || vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'CORRECCIÓN DATOS DE ASEGURADO\' || vm.form.description.label == \'MODIFICACIÓN DE DATOS DE ASEGURADO\' || vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Fecha de nacimiento</label><div class=\"input-group date\"><input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"vm.subforms.personal.birthdate\" ng-disabled=\"!(vm.form.description.label == \'CORRECCIÓN DATOS DE ASEGURADO\' || vm.form.description.label == \'MODIFICACIÓN DE DATOS DE ASEGURADO\' || vm.form.description.label == \'OTRO\')\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"gender\">Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'M\'\"> MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'F\'\"> FEMENINO</span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"smoker\">Fumador</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.smoker\" name=\"smoker\" ng-value=\"true\" disabled=\"\"> SI</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.smoker\" name=\"smoker\" ng-value=\"false\" disabled=\"\"> NO</span></div></div><div class=\"col-xs-12\"><div class=\"row\" ng-repeat=\"beneficiary in vm.subforms.beneficiaries_life track by $index\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Beneficiario #{{$index + 1}}</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Nombre</label> <input disabled=\"\" type=\"text\" ng-model=\"beneficiary.first_name\" class=\"form-control\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Apellido Paterno</label> <input disabled=\"\" type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Apellido Materno</label> <input disabled=\"\" type=\"text\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Parentesco</label> <input disabled=\"\" type=\"text\" ng-model=\"beneficiary.optional_relationship\" class=\"form-control\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento</label><div class=\"input-group date\"><input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"beneficiary.birthdate\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"> <span id=\"nacimiento{{$index}}\" class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Sexo</label><select class=\"form-control\" ng-model=\"beneficiary.sex\" placeholder=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"><option value=\"M\">MASCULINO</option><option value=\"F\">FEMENINO</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"ben_percentage\">Porcentaje</label> <input disabled=\"\" type=\"number\" class=\"form-control\" ng-model=\"beneficiary.percentage\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div></div></div></div><div ng-show=\"vm.subforms.show === 0\" ng-if=\"valueConcept == 8 || valueConcept == 10\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Asegurado</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"name\">Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"middle_name\">Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"last_name\">Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento\">Fecha de nacimiento</label><div class=\"input-group date\"><input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"vm.subforms.personal.birthdate\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"gender\">Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'M\'\"> MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'F\'\"> FEMENINO</span></div></div><div class=\"col-xs-12\"><div class=\"row\" ng-repeat=\"relationship in vm.subforms.relationshipList track by $index\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Dependiente #{{$index + 1}}</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Nombre</label> <input type=\"text\" ng-model=\"relationship.first_name\" class=\"form-control\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Apellido Paterno</label> <input type=\"text\" ng-model=\"relationship.last_name\" class=\"form-control\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"\">Apellido Materno</label> <input type=\"text\" ng-model=\"relationship.second_last_name\" class=\"form-control\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Parentesco</label><select id=\"parentesco{{$index}}\" class=\"form-control m-b\" ng-model=\"relationship.relationship\" ng-change=\"vm.options.disease.relationships.selectType(relationship.relationship,\'{{relationship.relationship}}\')\" ng-options=\"r.option for r in vm.options.disease.types track by r.option\"><option value=\"\" disabled=\"\">Selecciona un parentesco</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento{{$index}}\">Fecha Nacimiento</label><div class=\"input-group date\"><input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"relationship.birthdate\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"> <span id=\"nacimiento{{$index}}\" class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 form-group\"><label>Sexo</label><select class=\"form-control\" ng-options=\"sex as sex.label for sex in vm.defaults.sex track by sex.value\" ng-model=\"relationship.sex\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"><option value=\"\" disabled=\"\">Selecciona un sexo</option></select></div></div></div></div><div class=\"col-md-12 col-sm-12 form-group\" ng-if=\"valueConcept == 10\"><legend class=\"legend-title\" align=\"center\">Coberturas</legend><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-stripped table-hover\" data-filter=\"#filter\" data-page-size=\"25\"><thead><tr><th class=\"text-align-center width-20p\" data-breakpoints=\"xs\">Cobertura</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">S. Asegurada</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">Deducible</th><th ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\">Coaseguro</th><th class=\"display-none\">Prima</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.defaults.coverages\"><td class=\"text-align-center\"><p ng-bind=\"coverage.coverage_name\"></p></td><td class=\"text-align-center\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.sums_coverage\" ng-init=\"!coverage.sumInPolicy.value && item.default ? coverage.sumInPolicy.value = item.sum_insured : def = item.default\" ng-click=\"coverage.sumInPolicy.value = item.sum_insured; show_button_save_sum = false\"><a>{{demo(item.sum_insured) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.sumInPolicy.value\" ng-keyup=\"show_button_save_sum = true\" format-currency=\"currency\" disabled=\"\"><div class=\"input-group-btn\" ng-show=\"show_button_save_sum\"><button class=\"btn btn-success\" ng-click=\"saveSum(coverage.sumInPolicy.value, coverage);show_button_save_sum = result_\">+</button></div></div></td><td class=\"text-align-center\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.deductible_coverage\" ng-init=\"item.default ? coverage.deductibleInPolicy.value = item.deductible : def = item.default\" ng-click=\"coverage.deductibleInPolicy.value = item.deductible; show_button_save_ded = false\"><a>{{demo(item.deductible) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.deductibleInPolicy.value\" ng-keyup=\"show_button_save_ded = true\" format-currency=\"currency\" disabled=\"\"><div class=\"input-group-btn\" ng-show=\"show_button_save_ded\"><button class=\"btn btn-success\" ng-click=\"saveDed(coverage.deductibleInPolicy.value, coverage);show_button_save_ded = result_ded\">+</button></div></div></td><td class=\"text-align-center\" ng-if=\"coverage.coinsurance || vm.policy.subramo.subramo_name == \'Gastos Médicos\'\"><input class=\"form-control m-b\" type=\"text\" ng-if=\"coverage.coinsurance\" ng-model=\"coverage.coinsurance\" value=\"\" disabled=\"\"></td><td class=\"display-none\"><input class=\"form-control m-b\" format-as-currency=\"\" ng-model=\"coverage.primaInPolicy.value\" disabled=\"\"></td><td class=\"text-align-center\"><button class=\"btn btn-danger btn-danger\" name=\"button\" ng-click=\"vm.options.deleteCoverage(coverage, $index)\" type=\"button\" disabled=\"\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div class=\"form-group\"><label>Agregar coberturas</label><select class=\"form-control m-b\" ng-options=\"cvg.coverage_name for cvg in vm.defaults.coverageList | orderBy: \'coverage_name\' track by cvg.id\" ng-change=\"vm.options.addCoverage(vm.defaults.coverageInPackage)\" ng-model=\"vm.defaults.coverageInPackage\" disabled=\"\"><option value=\"\" disabled=\"\">Agrega una cobertura</option></select></div></div></div></div></div>");
$templateCache.put("app/endosos/type/d.html","<div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del endoso</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia desde:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.start_of_validity\" ng-change=\"changeUntil()\" data-date-format=\"dd/MM/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Vigencia hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.end_of_validity\" data-date-format=\"dd/MM/yyyy\" disabled=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 form-group\"><label for=\"description\">Descripción del endoso</label> <textarea class=\"form-control\" ng-model=\"vm.form.observations\" name=\"description\"></textarea></div><div ng-show=\"vm.subforms.show === 1\" ng-if=\"valueConcept == 15 || valueConcept == 18\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Automóvil</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"brand\">Marca</label> <input class=\"form-control\" ng-model=\"vm.subforms.brand\" type=\"text\" ng-disabled=\"((vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO\') || (vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR PETICIÓN\'))\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"model\">Modelo</label> <input class=\"form-control\" ng-model=\"vm.subforms.model\" type=\"text\" ng-disabled=\"((vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO\') || (vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR PETICIÓN\'))\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"year\">Año</label><select class=\"form-control\" ng-model=\"vm.subforms.year\" ng-options=\"year as year for year in vm.defaults.years track by year\" ng-disabled=\"((vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO\') || (vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR PETICIÓN\'))\"><option value=\"\">{{vm.subforms.year}}</option></select></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"version\">Versión</label> <input class=\"form-control\" ng-model=\"vm.subforms.version\" type=\"text\" ng-disabled=\"((vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO\') || (vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR PETICIÓN\'))\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"serial\">Serie</label> <input class=\"form-control\" ng-model=\"vm.subforms.serial\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"engine\">Motor</label> <input class=\"form-control\" ng-model=\"vm.subforms.engine\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"color\">Color</label> <input class=\"form-control\" ng-model=\"vm.subforms.color\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"license_plates\">Placas</label> <input class=\"form-control\" ng-model=\"vm.subforms.license_plates\" type=\"text\" disabled=\"\"></div></div><div ng-show=\"vm.subforms.show === 2\" ng-if=\"valueConcept == 15 || valueConcept == 18\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Bien asegurado</label> <input class=\"form-control\" ng-model=\"vm.subforms.insured_item\" type=\"text\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Detalles</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_details\" type=\"text\" disabled=\"\"></div><div class=\"col-xs-12 col-sm-6 form-group\"><label>Direccion</label> <input class=\"form-control\" ng-model=\"vm.subforms.item_address\" type=\"text\" disabled=\"\"></div></div><div ng-show=\"vm.subforms.show === 3\" ng-if=\"valueConcept == 15 || valueConcept == 18\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Asegurado</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"name\">Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"middle_name\">Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"last_name\">Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"nacimiento\">Fecha de nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"vm.subforms.personal.birthdate\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"gender\">Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'M\'\"> MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'F\'\"> FEMENINO</span></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label for=\"smoker\">Fumador</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.smoker\" name=\"smoker\" ng-value=\"true\" disabled=\"\"> SI</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.smoker\" name=\"smoker\" ng-value=\"false\" disabled=\"\"> NO</span></div></div></div><div ng-show=\"vm.subforms.show === 0\" ng-if=\"valueConcept == 15 || valueConcept == 18\"><div class=\"col-xs-12\"><legend class=\"legend-title\" align=\"center\">Datos del Asegurado</legend></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Nombre</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.first_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Primer Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.last_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Segundo Apellido</label> <input class=\"form-control\" ng-model=\"vm.subforms.personal.second_last_name\" type=\"text\" disabled=\"\" ng-disabled=\"!(vm.form.description.label == \'OTRO\')\"></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Fecha de nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd/MM/yyyy\" min-view=\"date\" name=\"startDate\" view=\"year\" ng-model=\"vm.subforms.personal.birthdate\" ng-disabled=\"((vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR FALTA DE PAGO\') || (vm.form.description.label == \'CANCELACIÓN DE PÓLIZA POR PETICIÓN\')) && (vm.form.description == \'OTRO\')\"></div></div><div class=\"col-xs-12 col-sm-3 form-group\"><label>Sexo</label><div><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'M\'\">MASCULINO</span><br><span><input type=\"radio\" ng-model=\"vm.subforms.personal.sex\" name=\"gender\" ng-value=\"\'F\'\">FEMENINO</span></div></div></div><div class=\"col-md-12 col-sm-12 form-group\" ng-if=\"valueConcept == 12 || valueConcept == 13 || valueConcept == 14 || valueConcept == 18\"><legend class=\"legend-title\" align=\"center\">Coberturas</legend><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-stripped table-hover\" data-filter=\"#filter\" data-page-size=\"25\"><thead><tr><th class=\"text-align-center width-20p\" data-breakpoints=\"xs\">Cobertura</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">S. Asegurada</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">Deducible</th><th ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\">Coaseguro</th><th class=\"display-none\">Prima</th><th class=\"text-align-center width-20p\" data-hide=\"phone\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"coverage in vm.defaults.coverages\"><td class=\"text-align-center\"><p ng-bind=\"coverage.coverage_name\"></p></td><td class=\"text-align-center\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.sums_coverage\" ng-init=\"!coverage.sumInPolicy.value && item.default ? coverage.sumInPolicy.value = item.sum_insured : def = item.default\" ng-click=\"coverage.sumInPolicy.value = item.sum_insured; show_button_save_sum = false\"><a>{{demo(item.sum_insured) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.sumInPolicy.value\" ng-keyup=\"show_button_save_sum = true\" format-currency=\"currency\" ng-disabled=\"valueConcept == 13 || valueConcept == 14\"><div class=\"input-group-btn\" ng-show=\"show_button_save_sum\"><button class=\"btn btn-success\" ng-click=\"saveSum(coverage.sumInPolicy.value, coverage);show_button_save_sum = result_\">+</button></div></div></td><td class=\"text-align-center\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-th-list\" aria-hidden=\"true\"></i> &nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in coverage.deductible_coverage\" ng-init=\"item.default ? coverage.deductibleInPolicy.value = item.deductible : def = item.default\" ng-click=\"coverage.deductibleInPolicy.value = item.deductible; show_button_save_ded = false\"><a>{{demo(item.deductible) }}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"coverage.deductibleInPolicy.value\" ng-keyup=\"show_button_save_ded = true\" format-currency=\"currency\" ng-disabled=\"valueConcept == 12 || valueConcept == 13\"><div class=\"input-group-btn\" ng-show=\"show_button_save_ded\"><button class=\"btn btn-success\" ng-click=\"saveDed(coverage.deductibleInPolicy.value, coverage);show_button_save_ded = result_ded\">+</button></div></div></td><td class=\"text-align-center\" ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\"><input class=\"form-control m-b\" type=\"text\" ng-if=\"vm.policy.subramo.subramo_name == \'Gastos Médicos\'\" ng-model=\"coverage.coinsurance\" value=\"\" ng-disabled=\"valueConcept == 12 || valueConcept == 13\"></td><td class=\"display-none\"><input class=\"form-control m-b\" format-as-currency=\"\" ng-model=\"coverage.primaInPolicy.value\"></td><td class=\"text-align-center\"><button class=\"btn btn-danger btn-danger\" name=\"button\" ng-click=\"vm.options.deleteCoverage(coverage, $index)\" type=\"button\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div class=\"form-group\"><label>Agregar coberturas</label><select class=\"form-control m-b\" ng-options=\"cvg.coverage_name for cvg in vm.defaults.coverageList | orderBy: \'coverage_name\' track by cvg.id\" ng-change=\"vm.options.addCoverage(vm.defaults.coverageInPackage)\" ng-model=\"vm.defaults.coverageInPackage\"><option value=\"\" disabled=\"\">Agrega una cobertura</option></select></div></div></div></div></div>");
$templateCache.put("app/endosos/type/manual.html","<div class=\"wrapper\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div name=\"brand\"><div class=\"form-group col-md-8\"><label for=\"brand\">Encontrar certificado</label><input type=\"search\" class=\"form-control\" name=\"\" ng-model=\"certificateNumber\"></div><div class=\"form-group col-md-4\"><button type=\"button\" class=\"btn btn-block btn-success btn-mt\" ng-click=\"search(certificateNumber)\"><span class=\"fa fa-search\"></span> Buscar certificado</button></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group col-xs-12\"><button class=\"btn btn-primary btn-mt pull-right\" ng-if=\"vm.typeEndoso === \'A\'\" ng-disabled=\"btnAddDisabled\" ng-click=\"addCertificate()\"><span class=\"fa fa-plus-square-o\"></span> Agregar certificado</button></div><div class=\"form-group col-xs-12\"><button class=\"btn btn-danger btn-mt pull-right\" ng-if=\"vm.typeEndoso === \'D\'\" ng-click=\"deletePoliza()\"><span class=\"fa fa-trash-o\"></span> Eliminar Póliza</button></div></div></div></div><br><div><div class=\"wrapper wrapper-content animate fadeIn ng-scope\" ng-if=\"showCertificate\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title title-colapsable\"><h5>Certificados</h5></div><div class=\"ibox-content wizard\"><table ng-if=\"vm.infoCertificate.life_policy.length > 0\" class=\"table table-hover\"><thead><tr><th>Certificado</th><th>Titular</th><th>Beneficiario</th><th ng-if=\"vm.selectedType.name === \'A\'\">Estatus</th><th ng-if=\"vm.selectedType.name === \'D\'\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"item in vm.certificates track by $index\" ng-click=\"viewCertificate(item)\"><td>{{ item.certificate_number }}</td><td>{{ item.personal.full_name }}</td><td><span ng-repeat=\"beneficiary in item.beneficiaries_life\">{{beneficiary.full_name + \" - \" + beneficiary.percentage + \"%\"}}<br></span></td><td ng-if=\"vm.selectedType.name === \'A\'\"><span class=\"label\" ng-class=\"{\'label-success\': item.status == \'REGISTRADO\', \'label-info\' : item.status == \'PENDIENTE\'}\">{{item.status}}</span></td><td ng-if=\"vm.selectedType.name === \'D\'\" ng-click=\"$event.stopPropagation()\"><input type=\"checkbox\" ng-checked=\"checkDelete(item.id)\" ng-click=\"checkCertificate(item.id)\"></td></tr></tbody></table><table ng-if=\"vm.infoCertificate.accidents_policy.length > 0\" class=\"table table-hover\"><thead><tr><th>Identificador</th><th>Nombre</th><th>Beneficiario</th><th ng-if=\"vm.selectedType.name === \'A\'\">Estatus</th><th ng-if=\"vm.selectedType.name === \'D\'\">Opciones</th></tr></thead><tbody><tr ng-repeat=\"item in vm.certificates track by $index\" ng-click=\"viewCertificate(item)\"><td>{{ item.certificate_number }}</td><td>{{ item.accidents_policy.personal.full_name }}</td><td><span ng-repeat=\"beneficiary in item.relationship_accident\">{{beneficiary.full_name}}<br></span></td><td ng-if=\"vm.selectedType.name === \'A\'\"><span class=\"label\" ng-class=\"{\'label-success\': item.status == \'REGISTRADO\', \'label-info\' : item.status == \'PENDIENTE\'}\">{{item.status}}</span></td><td ng-if=\"vm.selectedType.name === \'D\'\" ng-click=\"$event.stopPropagation()\"><input type=\"checkbox\" ng-checked=\"checkDelete(item.id)\" ng-click=\"checkCertificate(item.id)\"></td></tr></tbody></table><table ng-if=\"vm.infoCertificate.automobiles_policy.length > 0\" class=\"table table-hover\"><thead><tr><th>Identificador</th><th>Información del auto</th><th ng-if=\"vm.selectedType.name === \'A\'\">Estatus</th><th ng-if=\"vm.selectedType.name === \'D\'\">Eliminar certificados</th></tr></thead><tbody><tr ng-repeat=\"item in vm.certificates track by $index\" ng-click=\"viewCertificate(item)\"><td>{{ item.certificate_number }}</td><td><span class=\"blue-color\">Generales:</span>{{ item.brand + \" \" + item.model + \" \" + item.year + \" \" + item.version + \" \" + item.color }}<br><span class=\"blue-color\">Serie:</span>{{ item.serial }}<br><span class=\"blue-color\">Motor:</span>{{ item.engine }}<br><span class=\"blue-color\">Matrícula:</span>{{ item.license_plates }}<br></td><td ng-if=\"vm.selectedType.name === \'A\'\"><span class=\"label\" ng-class=\"{\'label-success\': item.status == \'REGISTRADO\', \'label-info\' : item.status == \'PENDIENTE\'}\">{{item.status}}</span></td><td ng-if=\"vm.selectedType.name === \'D\'\" ng-click=\"$event.stopPropagation()\"><input type=\"checkbox\" ng-checked=\"checkDelete(item.id)\" ng-click=\"checkCertificate(item.id)\"></td></tr></tbody></table><div><label ng-if=\"noData\">No se han encontrado resultados</label></div></div></div></div></div></div></div><div class=\"wrapper wrapper-content animate fadeIn ng-scope\" ng-if=\"show_form_life\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title title-colapsable\"><h5>Información del certificado</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div ng-if=\"vm.policy.ramo.ramo_code == 1\"><div class=\"form-group\"><button class=\"btn btn-primary\" ng-click=\"closeCertificate()\" type=\"submit\"><span class=\"fa fa-reply\"></span> Regresar</button></div><form name=\"formLife\"><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.certificate_number.$invalid && !formLife.certificate_number.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Número de certificado <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"certificate_number\" ng-model=\"vm.covers.certificate_number\" class=\"form-control\" ng-disabled=\"inputDisabledCert\" required=\"\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Subgrupo <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"group\" data-ng-options=\"item as item.name for item in subgroups\" ng-model=\"vm.configuration.group\" ng-disabled=\"inputDisabled\" ng-change=\"selectGroup(vm.configuration.group)\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Categoria</label><select class=\"form-control\" name=\"categoty\" data-ng-options=\"item as item.name for item in group_selected.categories\" ng-model=\"vm.configuration.category\" ng-disabled=\"comboboxDisabled\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Paquete <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"pack\" data-ng-options=\"item as item.package_name for item in vm.pack\" ng-model=\"vm.configuration.pack\" ng-disabled=\"inputDisabled\" required=\"\"><option value=\"\">Seleccione una opción</option></select></div></div><h4>Titular</h4><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pFirst_Name.$invalid && !formLife.pFirst_Name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Nombre <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pFirst_Name\" ng-model=\"vm.covers.personal.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pLast_name.$invalid && !formLife.pLast_name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Apellido Paterno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pLast_name\" ng-model=\"vm.covers.personal.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pSecond_last_name.$invalid && !formLife.pSecond_last_name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Apellido Materno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSecond_last_name\" ng-model=\"vm.covers.personal.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"col-sm-3 form-group\" ng-class=\"{\'has-error\': formLife.pBirthdate.$invalid && !formLife.pBirthdate.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Fecha de nacimiento <span class=\"color-red\">*</span></label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" name=\"pBirthdate\" date-time=\"\" ng-model=\"vm.covers.personal.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\" required=\"\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pEmail.$invalid && !formLife.pEmail.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Correo <span class=\"color-red\">*</span></label> <input type=\"email\" name=\"pEmail\" ng-model=\"vm.covers.personal.email\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pBirthdate.$invalid && !formLife.pBirthdate.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Sexo <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"pSex\" ng-model=\"vm.covers.personal.sex\" ng-disabled=\"inputDisabled\" required=\"\"><option value=\"\">Selecciona un sexo</option><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pSalary.$invalid && !formLife.pSalary.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Sueldo <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSalary\" ng-model=\"vm.covers.personal.salary\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formLife.pSum_assured.$invalid && !formLife.pSum_assured.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Suma asegurada <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSum_assured\" ng-model=\"vm.covers.personal.sum_assured\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><h4>Beneficiarios</h4><div class=\"row\"><div class=\"form-group col-xs-12 col-md-3\" ng-if=\"newEndoso\"><button type=\"button\" class=\"btn btn-info btn-block\" ng-click=\"vm.options.life.beneficiaries.add(vm.covers.life.beneficiaries)\"><span class=\"fa fa-plus-square-o\"></span> Agregar beneficiario</button></div></div><table class=\"table table-hover\"><tbody><tr ng-repeat=\"beneficiary in vm.covers.beneficiaries_life track by $index\"><td><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Nombre</label> <input type=\"text\" ng-model=\"beneficiary.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Apellido Paterno</label> <input type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Apellido Materno</label> <input type=\"text\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Fecha de nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"beneficiary.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Sexo</label><select class=\"form-control\" ng-model=\"beneficiary.sex\" ng-disabled=\"inputDisabled\"><option value=\"\">Selecciona un sexo</option><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Parentesco</label> <input type=\"text\" ng-model=\"beneficiary.optional_relationship\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Porcentaje</label> <input type=\"text\" ng-model=\"beneficiary.percentage\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><button class=\"btn btn-danger btn-mt\" ng-if=\"newEndoso\" ng-click=\"vm.options.life.beneficiaries.destroy($index, beneficiary)\"><span class=\"fa fa-trash-o\"></span> Eliminar</button></div></div></td></tr></tbody></table><div class=\"form-group\"><button class=\"btn btn-primary pull-right\" ng-if=\"vm.selectedType.name === \'B\'\" ng-hide=\"newEndoso\" ng-click=\"showInputDisabled()\"><span class=\"fa fa-pencil-square-o\"></span> Editar</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'A\'\" ng-disabled=\"formLife.$invalid\" ng-click=\"saveCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Guardar Certificado</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'B\'\" ng-disabled=\"formLife.$invalid\" ng-click=\"editCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Actializar Certificado</button> <button class=\"btn btn-white pull-right margin-right-10\" ng-if=\"newEndoso\" ng-click=\"closeCertificate()\" ui-sref=\"endosos.collectivity\"><span class=\"fa fa-times-circle\"></span> Cancelar</button></div></form></div><div ng-if=\"vm.policy.ramo.ramo_code == 2\"><div class=\"form-group\"><button class=\"btn btn-primary\" ng-click=\"closeCertificate()\" type=\"submit\"><span class=\"fa fa-reply\"></span> Regresar</button></div><form name=\"formDiseage\"><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.certificate_number.$invalid && !formDiseage.certificate_number.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Número de certificado <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"certificate_number\" ng-model=\"vm.covers.certificate_number\" class=\"form-control\" ng-disabled=\"inputDisabledCert\" required=\"\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Subgrupo</label><select class=\"form-control\" name=\"group\" data-ng-options=\"item as item.name for item in subgroups\" ng-model=\"vm.configuration.group\" ng-disabled=\"inputDisabled\" ng-change=\"selectGroup(vm.configuration.group)\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Categoria</label><select class=\"form-control\" name=\"categoty\" data-ng-options=\"item as item.name for item in group_selected.categories\" ng-model=\"vm.configuration.category\" ng-disabled=\"comboboxDisabled\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Paquete</label><select class=\"form-control\" name=\"pack\" data-ng-options=\"item as item.package_name for item in vm.pack\" ng-model=\"vm.configuration.pack\" ng-disabled=\"inputDisabled\"><option value=\"\">Seleccione una opción</option></select></div></div><h4>Asegurado</h4><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pFirst_Name.$invalid && !formDiseage.pFirst_Name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Nombre <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pFirst_Name\" ng-model=\"vm.covers.personal.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pLast_name.$invalid && !formDiseage.pLast_name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Apellido Paterno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pLast_name\" ng-model=\"vm.covers.personal.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSecond_last_name.$invalid && !formDiseage.pSecond_last_name.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Apellido Materno <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSecond_last_name\" ng-model=\"vm.covers.personal.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"col-sm-3 form-group\" ng-class=\"{\'has-error\': formDiseage.pBirthdate.$invalid && !formDiseage.pBirthdate.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Fecha de nacimiento <span class=\"color-red\">*</span></label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" name=\"pBirthdate\" date-time=\"\" ng-model=\"vm.covers.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\" required=\"\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pEmail.$invalid && !formDiseage.pEmail.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Correo <span class=\"color-red\">*</span></label> <input type=\"email\" name=\"pEmail\" ng-model=\"vm.covers.personal.email\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSex.$invalid && !formDiseage.pSex.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Sexo <span class=\"color-red\">*</span></label><select class=\"form-control\" name=\"pSex\" ng-model=\"vm.covers.personal.sex\" ng-disabled=\"inputDisabled\" required=\"\"><option value=\"\">Selecciona un sexo</option><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSalary.$invalid && !formDiseage.pSalary.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Sueldo <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSalary\" ng-model=\"vm.covers.personal.salary\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formDiseage.pSum_assured.$invalid && !formDiseage.pSum_assured.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Suma asegurada <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"pSum_assured\" ng-model=\"vm.covers.personal.sum_assured\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><hr><h4>Dependientes</h4><div class=\"row\"><div class=\"form-group col-xs-12 col-md-3\" ng-if=\"newEndoso\"><button type=\"button\" ng-click=\"vm.options.disease.relationships.add(vm.covers.disease.relationships)\" class=\"btn btn-info btn-block\"><span class=\"fa fa-plus-square-o\"></span> Agregar dependiente</button></div></div><table class=\"table table-hover\"><tbody><tr ng-repeat=\"beneficiary in vm.covers.relationship_accident track by $index\"><td><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Nombre</label> <input type=\"text\" ng-model=\"beneficiary.first_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Apellido Paterno</label> <input type=\"text\" ng-model=\"beneficiary.last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Apellido Materno</label> <input type=\"text\" ng-model=\"beneficiary.second_last_name\" class=\"form-control\" ng-disabled=\"inputDisabled\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Fecha de nacimiento</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input class=\"form-control\" date-time=\"\" ng-model=\"beneficiary.birthdate\" format=\"dd-MM-yyyy\" view=\"year\" min-view=\"date\" auto-close=\"true\" ng-disabled=\"inputDisabled\"></div></div></div><div class=\"row\"><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Sexo</label><select class=\"form-control\" ng-model=\"beneficiary.sex\" ng-disabled=\"inputDisabled\"><option value=\"\">Selecciona un sexo</option><option value=\"F\">FEMENINO</option><option value=\"M\">MASCULINO</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Parentesco</label><select class=\"form-control\" ng-model=\"beneficiary.relationship\" ng-disabled=\"inputDisabled\"><option value=\"\">Selecciona un parentesco</option><option value=\"1\">Titular</option><option value=\"2\">Cónyuge</option><option value=\"3\">Hijo</option></select></div><div class=\"form-group col-sm-3\"><button class=\"btn btn-danger btn-mt\" ng-if=\"newEndoso\" ng-click=\"vm.options.disease.relationships.destroy($index, beneficiary)\"><span class=\"fa fa-trash-o\"></span> Eliminar</button></div></div></td></tr></tbody></table><div class=\"form-group\"><button class=\"btn btn-primary pull-right\" ng-if=\"vm.selectedType.name === \'B\'\" ng-hide=\"newEndoso\" ng-click=\"showInputDisabled()\"><span class=\"fa fa-pencil-square-o\"></span> Editar</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'A\'\" ng-disabled=\"formDiseage.$invalid\" ng-click=\"saveCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Guardar Certificado</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'B\'\" ng-disabled=\"formDiseage.$invalid\" ng-click=\"editCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Actualizar Certificado</button> <button class=\"btn btn-white pull-right margin-right-10\" ng-if=\"newEndoso\" ng-click=\"closeCertificate()\" ui-sref=\"endosos.collectivity\"><span class=\"fa fa-times-circle\"></span> Cancelar</button></div></form></div><div ng-if=\"vm.policy.ramo.ramo_code == 3\"><div class=\"form-group\"><button class=\"btn btn-primary\" ng-click=\"closeCertificate()\" type=\"submit\"><span class=\"fa fa-reply\"></span> Regresar</button></div><form name=\"formAutomobile\"><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.certificate_number.$invalid && !formAutomobile.certificate_number.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Número de certificado <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"certificate_number\" ng-model=\"vm.covers.certificate_number\" class=\"form-control\" ng-disabled=\"inputDisabledCert\" required=\"\"></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Subgrupo</label><select class=\"form-control\" name=\"group\" data-ng-options=\"item as item.name for item in subgroups\" ng-model=\"vm.configuration.group\" ng-disabled=\"inputDisabled\" ng-change=\"selectGroup(vm.configuration.group)\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Categoria</label><select class=\"form-control\" name=\"categoty\" data-ng-options=\"item as item.name for item in group_selected.categories\" ng-model=\"vm.configuration.category\" ng-disabled=\"comboboxDisabled\"><option value=\"\">Seleccione una opción</option></select></div><div class=\"form-group col-sm-3\"><label ng-class=\"fontColor\" for=\"\">Paquete</label><select class=\"form-control\" name=\"pack\" data-ng-options=\"item as item.package_name for item in vm.pack\" ng-model=\"vm.configuration.pack\" ng-disabled=\"inputDisabled\"><option value=\"\">Seleccione una opción</option></select></div></div><h4>Automóvil</h4><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.brand.$invalid && !formAutomobile.brand.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Marca <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"brand\" ng-model=\"vm.covers.brand\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.model.$invalid && !formAutomobile.model.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Modelo <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"model\" ng-model=\"vm.covers.model\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.year.$invalid && !formAutomobile.year.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Año <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"year\" ng-model=\"vm.covers.year\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.version.$invalid && !formAutomobile.version.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Versión <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"version\" ng-model=\"vm.covers.version\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.color.$invalid && !formAutomobile.color.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Color <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"color\" ng-model=\"vm.covers.color\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.serial.$invalid && !formAutomobile.serial.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Serie <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"serial\" ng-model=\"vm.covers.serial\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.engine.$invalid && !formAutomobile.engine.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Motor <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"engine\" ng-model=\"vm.covers.engine\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div><div class=\"form-group col-sm-3\" ng-class=\"{\'has-error\': formAutomobile.license_plates.$invalid && !formAutomobile.license_plates.$pristine}\"><label ng-class=\"fontColor\" for=\"\">Matrícula <span class=\"color-red\">*</span></label> <input type=\"text\" name=\"license_plates\" ng-model=\"vm.covers.license_plates\" class=\"form-control\" ng-disabled=\"inputDisabled\" required=\"\"></div></div><div class=\"form-group\"><button class=\"btn btn-primary pull-right\" ng-if=\"vm.selectedType.name === \'B\'\" ng-hide=\"newEndoso\" ng-click=\"showInputDisabled()\"><span class=\"fa fa-pencil-square-o\"></span> Editar</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'A\'\" ng-disabled=\"formAutomobile.$invalid\" ng-click=\"saveCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Guardar Certificado</button> <button class=\"btn btn-success pull-right\" ng-if=\"newEndoso && vm.selectedType.name === \'B\'\" ng-disabled=\"formAutomobile.$invalid\" ng-click=\"editCertificate(vm.covers)\" type=\"submit\"><span class=\"fa fa-save\"></span> Actualizar Certificado</button> <button class=\"btn btn-white pull-right margin-right-10\" ng-if=\"newEndoso\" ng-click=\"closeCertificate()\" ui-sref=\"endosos.collectivity\"><span class=\"fa fa-times-circle\"></span> Cancelar</button></div></form></div></div></div></div></div></div><div class=\"form-group col-xs-12\"><button class=\"btn btn-success btn-mt pull-right\" ng-if=\"vm.selectedType.name === \'A\'\" ng-click=\"saveEndosoA()\"><span class=\"fa fa-floppy-o\"></span> Guardar</button> <button class=\"btn btn-success btn-mt pull-right\" ng-if=\"vm.selectedType.name === \'B\'\" ng-click=\"saveEndosoB()\"><span class=\"fa fa-floppy-o\"></span> Guardar</button> <button class=\"btn btn-success btn-mt pull-right\" ng-if=\"vm.selectedType.name === \'D\'\" ng-click=\"saveEndosoD()\"><span class=\"fa fa-floppy-o\"></span> Guardar</button></div>");
$templateCache.put("app/multicotizador/admin/admin.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Multicotizador</h2><ol class=\"breadcrumb margin-top-15\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Administrador</strong></li></ol></div></div><br><div ng-if=\"loader_data\" class=\"text-center\"><img src=\"../../assets/images/loaders/loader_6.gif\"></div><div class=\"row animate\" ng-if=\"show_quote_selected\"><div class=\"container-fluid margin-top-15\"><div class=\"col-12 col-sm-3 mb-3 d-flex align-items-center\"><label>Marca:</label><p class=\"text\">{{show_quote_selected.marca}}</p></div><div class=\"col-12 col-sm-3 mb-3 d-flex align-items-center\"><label>Modelo:</label><p class=\"text\">{{show_quote_selected.submarca}}</p></div><div class=\"col-12 col-sm-3 mb-3 d-flex align-items-center\"><label>Paquete:</label><p class=\"text\"><span ng-if=\"show_quote_selected.paquete == 1\">AMPLIA</span> <span ng-if=\"show_quote_selected.paquete == 2\">PLUS</span> <span ng-if=\"show_quote_selected.paquete == 3\">LIMITADA</span></p></div><div class=\"col-12 col-sm-3 mb-3 d-flex align-items-center\"><label>Frecuencia de pago:</label><p class=\"text\"><span ng-if=\"show_quote_selected.forma_de_pago == \'C\'\">CONTADO</span> <span ng-if=\"show_quote_selected.forma_de_pago == \'S\'\">SEMESTRAL</span> <span ng-if=\"show_quote_selected.forma_de_pago == \'T\'\">TRIMESTRAL</span> <span ng-if=\"show_quote_selected.forma_de_pago == \'M\'\">MENSUAL</span></p></div><div class=\"col-12 col-sm-3 mb-3 d-flex align-items-center\"><label>Año:</label><p class=\"text\">{{show_quote_selected.modelo}}</p></div><div class=\"col-12 col-sm-3 mb-3 d-flex align-items-center\"><label>Versión:</label><p class=\"text\">{{show_quote_selected.descripcion}}</p></div><div class=\"col-12 col-sm-3 mb-3 d-flex align-items-center\"><label>Cliente:</label><p class=\"text\" ng-if=\"show_quote_selected.qualitas\">{{show_quote_selected.qualitas.cliente.nombre}}</p></div><div class=\"col-12 col-sm-3 mb-3\"><label>Correo/Teléfono:</label><p class=\"text\"><span ng-if=\"show_quote_selected.qualitas\">{{show_quote_selected.qualitas.cliente.correo}}</span><br><span ng-if=\"show_quote_selected.qualitas\">{{show_quote_selected.qualitas.cliente.telefono}}</span></p></div><div class=\"col-12 col-sm-3 mb-3 d-flex align-items-center\"><label for=\"status\">Estatus:</label><select class=\"form-control\" ng-options=\"item.name for item in status\" ng-model=\"selectedStatus\" ng-change=\"changeStatus(selectedStatus)\"><option disabled=\"\" value=\"\">Selecciona una opción</option></select></div><div class=\"col-12 col-sm-12 mb-12\"></div><div class=\"col-12 col-sm-4 mb-4\" ng-repeat=\"item in quotes\" ng-if=\"!item.error\"><div class=\"bg-card\"><div class=\"row rowmtc\"><div class=\"col-md-12 box-blue\"><p ng-if=\"item.aseguradora == \'ana\'\" class=\"text-auto\">{{item.DESC}} ({{item.CVEVEH}})</p><p ng-if=\"item.aseguradora == \'chubb\'\" class=\"text-auto\">{{item.descr_chubb}} ({{item.CVEVEH}})</p><p ng-if=\"item.aseguradora == \'gnp\'\" class=\"text-auto\">{{item.descr_gnp}} ({{item.CVEVEH}})</p><p ng-if=\"item.aseguradora == \'hdi\'\" class=\"text-auto\">{{item.descr_hdi}} ({{item.CVEVEH}})</p><p ng-if=\"item.aseguradora == \'ps\'\" class=\"text-auto\">{{item.descr_ps}} ({{item.raw_response.request_json.clave_auto}})</p><p ng-if=\"item.aseguradora == \'qualitas\'\" class=\"text-auto\">{{quoteLista.descripcion}} ({{item.raw_response.Movimientos.Movimiento.DatosVehiculo.ClaveAmis}})</p><p ng-if=\"item.aseguradora == \'tumomento\'\" class=\"text-auto\">{{ item.request_xml.vehicle.version ? item.request_xml.vehicle.version : quoteLista.descripcion }}</p></div><div class=\"col-md-12\"><h3 ng-if=\"item.aseguradora != \'ps\'\"><strong>No. Cotización:</strong>{{item.numero_cotizacion}}</h3></div><div class=\"col-sm-4\"><div class=\"col-12\"><img ng-if=\"item.aseguradora == \'ana\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_ANA.png\" alt=\"Ana\"> <img ng-if=\"item.aseguradora == \'chubb\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_CHUBB.png\" alt=\"Chubb\"> <img ng-if=\"item.aseguradora == \'gnp\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_GNP.png\" alt=\"GNP\"> <img ng-if=\"item.aseguradora == \'hdi\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_HDI.png\" alt=\"HDI\"> <img ng-if=\"item.aseguradora == \'ps\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_Primero.png\" alt=\"PS\"> <img ng-if=\"item.aseguradora == \'qualitas\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_Qualitas.png\" alt=\"Qualitas\"> <img ng-if=\"item.aseguradora == \'tumomento\'\" class=\"logo\" src=\"../../assets/images/providers/Logo_MOMENTO.png\" alt=\"TuMomento\"></div></div><div class=\"col-sm-4 text-end\"><label>Cantidad de pagos :</label><p class=\"pagos\" ng-switch=\"quoteLista.forma_de_pago\"><span ng-switch-when=\"C\" class=\"subprice-bold\">1</span> <span ng-switch-when=\"S\" class=\"subprice-bold\">2</span> <span ng-switch-when=\"T\" class=\"subprice-bold\">4</span> <span ng-switch-when=\"M\" class=\"subprice-bold\">12</span> <span ng-switch-default=\"\" class=\"subprice-bold\">1</span></p><div ng-if=\"quoteLista.forma_de_pago != \'C\'\"><label>Primer pago:</label> <span class=\"subprice-bold\" ng-switch=\"item.aseguradora\"><span ng-switch-when=\"ana\">{{(item.recibos && item.recibos[0] ? item.recibos[1][\'@primatotal\'] : 0) | currency}}</span> <span ng-switch-when=\"chubb\">{{(item.recibos && item.recibos.RECIBO && item.recibos.RECIBO[0] ? item.recibos.RECIBO[0].PTOTAL : 0) | currency}}</span> <span ng-switch-when=\"gnp\">{{(item.recibos && item.recibos.PRIMER_RECIBO ? item.recibos.PRIMER_RECIBO : 0) | currency}}</span> <span ng-switch-when=\"hdi\">{{(item.recibos && item.recibos.PrimeraExhibicion ? item.recibos.PrimeraExhibicion : 0) | currency}}</span> <span ng-switch-when=\"qualitas\">{{item.recibos[0] ? item.recibos[0].PrimaTotal : 0 | currency}}</span> <span ng-switch-when=\"ps\">{{item.recibos.primer_recibo | currency}}</span> <span ng-switch-when=\"tumomento\">{{item.prima | currency}}</span> <span ng-switch-default=\"\">0</span><br><span ng-if=\"quoteLista.forma_de_pago == \'S\'\" class=\"subprice\">Siguiente pago:</span> <span ng-if=\"quoteLista.forma_de_pago == \'T\'\" class=\"subprice\">Siguientes 3 pagos:</span> <span ng-if=\"quoteLista.forma_de_pago == \'M\'\" class=\"subprice\">Siguientes 11 pagos:</span> <span ng-if=\"item.aseguradora == \'ana\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos[1] ? item.recibos[1][\'@primatotal\'] : 0 | currency}}</span></span> <span ng-if=\"item.aseguradora == \'chubb\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos && item.recibos.RECIBO[1] ? item.recibos.RECIBO[1].PTOTAL : 0 | currency}}</span></span> <span ng-if=\"item.aseguradora == \'gnp\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos.RECIBO_SUBSECUENTE | currency}}</span></span> <span ng-if=\"item.aseguradora == \'hdi\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos.RecibosSubsecuentes | currency}}</span></span> <span ng-if=\"item.aseguradora == \'ps\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos.recibo_subsecuente | currency}}</span></span> <span ng-if=\"item.aseguradora == \'qualitas\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.recibos[1] ? item.recibos[1].PrimaTotal : 0 | currency}}</span></span> <span ng-if=\"item.aseguradora == \'tumomento\'\" class=\"subprice\"><span class=\"subprice-bold\">{{item.prima | currency}}</span></span></span></div></div><div class=\"col-sm-4 text-end\"><label>Total:</label><p ng-if=\"item.aseguradora == \'ana\'\" class=\"price\">{{item.primas.PTOTAL | currency}}</p><p ng-if=\"item.aseguradora == \'chubb\'\" class=\"price\">{{item.primas.PTOTAL | currency}}</p><p ng-if=\"item.aseguradora == \'gnp\'\" class=\"price\">{{item.primas.TOTAL_PAGAR | currency}}</p><p ng-if=\"item.aseguradora == \'hdi\'\" class=\"price\">{{item.primas.PrimaTotal | currency}}</p><p ng-if=\"item.aseguradora == \'ps\'\" class=\"price\">{{item.primas.prima_total | currency}}</p><p ng-if=\"item.aseguradora == \'qualitas\'\" class=\"price\">{{item.primas.PrimaTotal | currency}}</p><p ng-if=\"item.aseguradora == \'tumomento\' && quoteLista.forma_de_pago == \'C\'\" class=\"price\">{{item.prima | currency}}</p><p ng-if=\"item.aseguradora == \'tumomento\' && quoteLista.forma_de_pago == \'M\'\" class=\"price\">{{(item.prima * 12) | currency}}</p></div><div class=\"col-12 col-sm-4\"><button class=\"btn btn-primary m-t\" data-bs-toggle=\"modal\" style=\"width: 100%;\" data-bs-target=\"#exampleModal\" ng-click=\"showCoverages(item)\">Ver coberturas</button></div><div class=\"col-12 col-sm-4\" ng-if=\"item.impresion\"><button class=\"btn btn-secondary m-t\" ng-click=\"downloadPdf(item)\">Descargar póliza</button></div><div class=\"col-12 col-sm-4\" ng-if=\"item.impresion && selectedStatus.value == 2\"><button class=\"btn btn-success m-t\" ng-click=\"obtenerPoliza(\'registrar\',item.aseguradora,show_quote_selected.cotizacion_id )\">Registrar poliza</button></div><div class=\"col-12 col-sm-4\" style=\"margin-top: 20px;\" ng-if=\"item.impresion && selectedStatus.value == 4\"><span class=\"badge badge-success w-100 py-3 fs-6\"><i class=\"fa fa-info-circle\"></i>Póliza registrada</span></div></div></div></div><div class=\"col-12 col-sm-12\" style=\"margin-bottom: 30px;\"><button class=\"btn btn-danger col-xs-3\" ng-click=\"regresar()\">Regresar</button></div></div></div><div class=\"row animate\" ng-if=\"!show_quote_selected && quotes_data\"><div class=\"container-fluid margin-top-15\"><div class=\"col-xs-12 form-group\"><span>{{pageStart}} al {{pageEnd}} de {{total}}</span> <button class=\"btn btn-info\" ng-disabled=\"offset === 0\" ng-click=\"changePage(-100)\">Anterior</button> <button class=\"btn btn-info\" ng-disabled=\"pageEnd >= total\" ng-click=\"changePage(100)\">Siguiente</button></div><div class=\"col-xs-12 form-group\"><table class=\"table table-bordered table-hover\"><thead><tr><th>ID</th><th>Auto</th><th>Cliente</th><th>Fecha</th><th>Estatus</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"item in quotes_data\"><td>{{ item.id }}</td><td>{{item.marca}} {{item.descripcion}} {{item.modelo}}</td><td><span ng-if=\"item.qualitas.cliente\">{{item.qualitas.cliente.nombre}}</span></td><td>{{item.created_at | date: \'dd/MM/yyyy\'}}</td><td><span ng-if=\"item.status == \'0\' || item.status == null\">Pendiente</span> <span ng-if=\"item.status == \'1\'\">Abierta</span> <span ng-if=\"item.status == \'2\'\">Cerrada</span> <span ng-if=\"item.status == \'3\'\">Cancelada</span> <span ng-if=\"item.status == \'4\'\">Registrada</span></td><td><button class=\"btn btn-success\" ng-click=\"quoter(item)\">Ver</button></td></tr></tbody></table><div ng-if=\"loader_data\" class=\"text-center\"><img src=\"../../assets/images/loaders/loader_6.gif\" alt=\"Loading...\"></div></div></div></div><style>\n  /* Estilo para el contenedor de la descripción del auto */\n.box-blue {\nbackground-color: #0191a9; /* Fondo azul */\ncolor: white; /* Color del texto */\npadding: 10px; /* Espaciado interno */\nborder-radius: 8px 8px 0 0; /* Bordes redondeados */\n}\n\n/* Estilo para el texto de la descripción */\n.box-blue .text-auto {\nfont-weight: bold; /* Negritas */\nmargin: 0; /* Quitar margen para evitar amontonamiento */\n}\n\n/* Espaciado para otros elementos en el contenedor */\n.bg-card {\npadding: 15px; /* Espaciado interno en el contenedor */\nmargin-bottom: 15px; /* Espaciado inferior entre tarjetas */\n\n}\n\n/* Asegurarse que las imágenes y textos estén bien alineados */\n.rowmtc {\ndisplay: flex; /* Alinear elementos en fila */\nflex-wrap: wrap; /* Permitir que se envuelvan */\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Sombra en la parte inferior de la tarjeta */\nborder-radius: 8px;\n} \n\n/* Estilo para precios */\n.price {\nfont-weight: bold; /* Negritas */\nfont-size:20px; /* Tamaño de fuente más grande */\n}\n.pagos {\nfont-size: 17px;\n}       \n.subprice{\nfont-weight: bold;\n}\n.subtitle{\nfont-size: 13px;\n}\n/* Alinear precios a la derecha */\n/* .col-12.col-sm-6 {\ntext-align: right; /* Alinear a la derecha \n} */\n\n/* Estilos para los logos */\n.logo {\nmax-width: 100%; /* Asegura que la imagen no se desborde */\nheight: auto; /* Asegura que la imagen no se desborde */\n\n}\n.text-end {\ntext-align: right; /* Alineación a la derecha */\n}\n.title-blue{\ncolor: #0474c4;\nfont-weight: bold;\nfont-size: 15px;\n}\n.title-green{\ncolor: #0191a9;\nfont-weight: bold;\nfont-size: 18px;\n}\n</style>");
$templateCache.put("app/multicotizador/configurador/configurador.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ vm.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Configurador</strong></li></ol></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Configurador</h5></div><div class=\"ibox-content\"><uib-tabset><uib-tab heading=\"Aseguradoras\"><br><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th>Empresa</th></tr></thead><tbody><tr><td><select class=\"form-control\" ng-model=\"selectedEmpresa\" ng-options=\"e.id as e.nombre for e in empresas\" ng-change=\"changeEmpresa(selectedEmpresa)\"></select></td></tr><tr><th>Aseguradoras</th></tr><tr ng-repeat=\"aseguradora in aseguradoras\"><td><div class=\"form-check\"><input type=\"checkbox\" class=\"form-check-input\" id=\"aseguradora{{aseguradora.id}}\" ng-model=\"aseguradorasSeleccionadas[aseguradora.id]\"> <label class=\"form-check-label\" for=\"aseguradora{{aseguradora.id}}\">{{ aseguradora.nombre }}</label></div></td></tr></tbody></table></div><div class=\"text-end mt-3\"><button class=\"btn mr-0 btn-success\" ng-click=\"guardarSeleccion(selectedEmpresa)\" type=\"button\"><i class=\"fa fa-save me-2\"></i> Guardar</button></div></uib-tab><uib-tab heading=\"Coberturas\"><br><div class=\"row\"><div class=\"card card-body\"><div class=\"col-12 ms-3\"><div class=\"col-12 col-sm-4 mt-3\"><label class=\"mb-3\">Aseguradora</label><select class=\"form-control\" ng-model=\"aseguradora\" ng-change=\"changeAseguradora(aseguradora)\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione una aseguradora</option><option ng-repeat=\"aseguradora in aseguradoras\" ng-value=\"aseguradora.nombre\">{{aseguradora.nombre}}</option></select></div><div class=\"col-12 col-sm-4 mt-4\"><label class=\"mb-3\">Empresa</label><select class=\"form-control\" ng-model=\"owner\" ng-change=\"changeNegocio(owner)\"><option ng-repeat=\"empresa in empresas | filter:{ nombre: \'!undefined\' }\" value=\"{{empresa.nombre}}\">{{empresa.nombre}}</option></select></div><div class=\"col-12 col-sm-4 mt-4\" ng-if=\"aseguradora !== \'hdi\'\"><label class=\"mb-3\">Paquete</label><select class=\"form-control\" ng-model=\"paquete\" ng-change=\"changePaquete(paquete)\"><option value=\"\" selected=\"\">Seleccione un paquete</option><option ng-repeat=\"paquet in paquetesUnicos\" value=\"{{paquet}}\">{{paquet}}</option></select></div><div ng-if=\"aseguradora === \'hdi\'\" class=\"col-12 col-sm-4 mt-4\"><label class=\"mb-3\">Paquete</label><select class=\"form-control\" ng-model=\"option\" ng-change=\"onTipoChange(option)\"><option value=\"\" selected=\"\">Seleccione un paquete</option><option ng-repeat=\"option in tipoOpciones\" value=\"{{option}}\">{{option}}</option></select></div><div class=\"col-12 col-sm-6 mt-4\" style=\"margin-top: 10px;\"></div></div><div class=\"col-12 col-sm-12 mt-4 table-responsive\" ng-if=\"paquete\"><table class=\"table table-sm align-middle\"><thead ng-if=\"aseguradora === \'tumomento\'\"><tr><th>Selección</th><th>Nombre de la Cobertura</th><th>Suma Asegurada</th><th>Deducible</th><th>Opción Deducible Pérdida Total</th></tr></thead><thead ng-if=\"aseguradora === \'ps\' || aseguradora === \'qualitas\' || aseguradora === \'chubb\' || aseguradora ===\'gnp\' || aseguradora ===\'ana\' || aseguradora ===\'hdi\'\"><tr><th>ID</th><th>Selección</th><th>Nombre</th><th>Suma Asegurada</th><th>Deducible</th></tr></thead><tbody ng-if=\"aseguradora === \'tumomento\'\"><tr><td><input type=\"checkbox\" ng-model=\"selectedCoberturas[\'gastos_medicos_ocupantes\']\"></td><td>Gastos médicos ocupantes</td><td><select class=\"form-control\" ng-model=\"selectedCoberturas[\'gastos_medicos_ocupantes_id\']\" ng-disabled=\"!selectedCoberturas[\'gastos_medicos_ocupantes_id\']\"><option value=\"1\" ng-selected=\"selectedCoberturas[\'gastos_medicos_ocupantes_id\'] === 1\">$300,000</option><option value=\"2\" ng-selected=\"selectedCoberturas[\'gastos_medicos_ocupantes_id\'] === 2\">$350,000</option><option value=\"3\" ng-selected=\"selectedCoberturas[\'gastos_medicos_ocupantes_id\'] === 3\">$400,000</option><option value=\"4\" ng-selected=\"selectedCoberturas[\'gastos_medicos_ocupantes_id\'] === 4\">$500,000</option></select></td><td>-</td><td>-</td></tr><tr><td><input type=\"checkbox\" ng-model=\"selectedCoberturas[\'responsabilidad_civil_personas\']\"></td><td>Responsabilidad Civil Personas</td><td><select class=\"form-control\" ng-model=\"selectedCoberturas[\'responsabilidad_civil_personas_id\']\"><option value=\"5\" ng-selected=\"selectedCoberturas[\'responsabilidad_civil_personas_id\'] === 5\">$1,000,000</option><option value=\"6\" ng-selected=\"selectedCoberturas[\'responsabilidad_civil_personas_id\'] === 6\">$1,500,000</option><option value=\"7\" ng-selected=\"selectedCoberturas[\'responsabilidad_civil_personas_id\'] === 7\">$2,000,000</option></select></td></tr><tr><td><input type=\"checkbox\" ng-model=\"selectedCoberturas[\'responsabilidad_civil_muerte\']\"></td><td>Responsabilidad Civil Muerte</td><td><select class=\"form-control\" ng-model=\"selectedCoberturas[\'responsabilidad_civil_muerte_id\']\"><option value=\"8\" ng-selected=\"selectedCoberturas[\'responsabilidad_civil_muerte_id\'] === 8\">$500,000</option><option value=\"9\" ng-selected=\"selectedCoberturas[\'responsabilidad_civil_muerte_id\'] === 9\">$1,000,000</option><option value=\"10\" ng-selected=\"selectedCoberturas[\'responsabilidad_civil_muerte_id\'] === 10\">$1,500,000</option></select></td><td>-</td><td>-</td></tr><tr><td><input type=\"checkbox\" ng-model=\"selectedCoberturas[\'responsabilidad_civil_bienes\']\"></td><td>Responsabilidad Civil Bienes</td><td><select class=\"form-control\" ng-model=\"selectedCoberturas[\'responsabilidad_civil_bienes_id\']\"><option value=\"11\" ng-selected=\"selectedCoberturas[\'responsabilidad_civil_bienes_id\'] === 11\">$1,000,000</option><option value=\"12\" ng-selected=\"selectedCoberturas[\'responsabilidad_civil_bienes_id\'] === 12\">$1,500,000</option><option value=\"13\" ng-selected=\"selectedCoberturas[\'responsabilidad_civil_bienes_id\'] === 13\">$2,000,000</option></select></td><td>-</td><td>-</td></tr><tr><td><input type=\"checkbox\" ng-model=\"selectedCoberturas[\'danos_materiales\']\"></td><td>Daños Materiales</td><td>-</td><td><select class=\"form-control\" ng-model=\"selectedCoberturas[\'danos_materiales_deductible\']\" ng-change=\"updateDanosMaterialesId()\"><option value=\"3\" ng-selected=\"selectedCoberturas[\'danos_materiales_deductible\'] === 3\">3%</option><option value=\"5\" ng-selected=\"selectedCoberturas[\'danos_materiales_deductible\'] === 5\">5%</option><option value=\"7\" ng-selected=\"selectedCoberturas[\'danos_materiales_deductible\'] === 7\">7%</option></select></td><td><select class=\"form-control\" ng-model=\"selectedCoberturas[\'danos_materiales_opcion\']\" ng-change=\"updateDanosMaterialesId()\"><option value=\"true\">Sí</option><option value=\"false\">No</option></select></td></tr><tr><td><input type=\"checkbox\" ng-model=\"selectedCoberturas[\'robo_total\']\"></td><td>Robo total</td><td>-</td><td><select class=\"form-control\" ng-model=\"selectedCoberturas[\'robo_total_id\']\"><option value=\"23\" ng-selected=\"selectedCoberturas[\'robo_total_id\'] === 23\">0%</option><option value=\"24\" ng-selected=\"selectedCoberturas[\'robo_total_id\'] === 24\">5%</option><option value=\"25\" ng-selected=\"selectedCoberturas[\'robo_total_id\'] === 25\">10%</option><option value=\"26\" ng-selected=\"selectedCoberturas[\'robo_total_id\'] === 26\">15%</option></select></td><td>-</td></tr><tr><td><input type=\"checkbox\" ng-model=\"selectedCoberturas[\'robo_parcial\']\"></td><td>Robo parcial</td><td>-</td><td><select class=\"form-control\" ng-model=\"selectedCoberturas[\'robo_parcial_id\']\"><option value=\"27\" ng-selected=\"selectedCoberturas[\'robo_parcial_id\'] === 27\">0%</option><option value=\"28\" ng-selected=\"selectedCoberturas[\'robo_parcial_id\'] === 28\">5%</option><option value=\"29\" ng-selected=\"selectedCoberturas[\'robo_parcial_id\'] === 29\">10%</option></select></td><td>-</td></tr><tr><td><input type=\"checkbox\" ng-model=\"selectedCoberturas[\'conductor\']\"></td><td>Accidentes al conductor</td><td><select class=\"form-control\" ng-model=\"selectedCoberturas[\'conductor_id\']\"><option value=\"30\" ng-selected=\"selectedCoberturas[\'conductor_id\'] === 30\">$50,000</option><option value=\"31\" ng-selected=\"selectedCoberturas[\'conductor_id\'] === 31\">$100,000</option><option value=\"32\" ng-selected=\"selectedCoberturas[\'conductor_id\'] === 32\">$150,000</option></select></td><td>-</td><td>-</td></tr><tr><td><input type=\"checkbox\" ng-model=\"selectedCoberturas[\'asistencia_legal\']\" ng-change=\"onCheckboxChange(\'asistencia_legal\', 33)\"></td><td>Asistencia legal</td><td>-</td><td>-</td><td>-</td></tr><tr><td><input type=\"checkbox\" ng-model=\"selectedCoberturas[\'asistencia_vial\']\" ng-change=\"onCheckboxChange(\'asistencia_vial\', 34)\"></td><td>Asistencia vial</td><td>-</td><td>-</td><td>-</td></tr><tr><td><input type=\"checkbox\" ng-model=\"selectedCoberturas[\'lazy_fee\']\" ng-change=\"onCheckboxChange(\'lazy_fee\', 35)\"></td><td>Emisión ágil</td><td>-</td><td>-</td><td>-</td></tr></tbody><tbody ng-if=\"aseguradora !== \'gnp\' && aseguradora !== \'ps\'\"><tr ng-repeat=\"(key, value) in coberturasActuales\"><td ng-if=\"paquete\">{{ key }}</td><td ng-if=\"paquete\"><input type=\"checkbox\" ng-checked=\"selectedCoberturas[key] > 0\" ng-model=\"selectedCoberturas[key]\" ng-change=\"onCheckboxChangeQualitas(key, selectedCoberturas[key])\"></td><td ng-if=\"paquete\">{{ value }}</td><td ng-if=\"paquete\"><input type=\"text\" class=\"form-control\" ng-disabled=\"!selectedCoberturas[key]\" ng-value=\"formatVisualSumaAsegurada(selectedCoberturas[key + \'_sumaAsegurada\'])\" ng-model=\"selectedCoberturas[key + \'_sumaAsegurada\']\"></td><td ng-if=\"paquete\"><input type=\"text\" class=\"form-control\" ng-disabled=\"!selectedCoberturas[key]\" ng-model=\"selectedCoberturas[key + \'_deducible\']\" ng-change=\"onDeducibleChange(selectedCoberturas[key + \'_deducible\'], key)\"></td></tr><tr><td colspan=\"5\"><button type=\"button\" class=\"btn btn-primary\" ng-if=\"paquete != \'\'\" ng-click=\"guardarCobertura()\">Guardar</button></td></tr></tbody><tbody ng-if=\"aseguradora === \'ps\'\"><tr ng-repeat=\"(key, value) in coberturasActuales\"><td ng-if=\"paquete\">{{ key }}</td><td ng-if=\"paquete\"><input type=\"checkbox\" ng-model=\"selectedCoberturas[key]\" ng-checked=\"!!selectedCoberturas[key]\" ng-change=\"onCheckboxChangeQualitas(key, selectedCoberturas[key])\"></td><td ng-if=\"paquete\">{{ value }}</td><td ng-if=\"paquete\"><input type=\"text\" class=\"form-control\" ng-disabled=\"!selectedCoberturas[key]\" ng-value=\"formatVisualSumaAsegurada(selectedCoberturas[key + \'_sumaAsegurada\'])\" ng-input=\"onSumaAseguradaInput($event, key)\"></td><td ng-if=\"paquete\"><input type=\"text\" class=\"form-control\" ng-disabled=\"!selectedCoberturas[key]\" ng-model=\"selectedCoberturas[key + \'_deducible\']\" ng-change=\"onDeducibleChange(selectedCoberturas[key + \'_deducible\'], key)\"></td></tr><tr><td colspan=\"5\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"guardarCobertura()\" ng-if=\"paquete != \'\'\">Guardar</button></td></tr></tbody><tbody ng-if=\"aseguradora === \'gnp\'\"><tr ng-repeat=\"(key, cobertura) in COBERTURAS_GNP\"><td ng-if=\"paquete\">{{ cobertura.id }}</td><td ng-if=\"paquete\"><input type=\"checkbox\" ng-checked=\"!!isCoberturaSeleccionada(key)\" ng-change=\"onCheckboxChangeGNP(key, cobertura, selectedCoberturas[key])\" ng-model=\"selectedCoberturas[key]\"></td><td ng-if=\"paquete\">{{ cobertura.nombre }}</td><td ng-if=\"paquete\"><select class=\"form-control form-select\" ng-model=\"sumaAsegurada[key]\" ng-change=\"onSumaAseguradaChangeGNP(sumaAsegurada[key], key)\" ng-disabled=\"!isCoberturaSeleccionada(key)\" ng-options=\"suma as (suma | currency) for suma in cobertura.suma_asegurada\"></select></td><td ng-if=\"paquete\"><select class=\"form-control\" ng-model=\"deducibleGNP[key]\" ng-change=\"onDeducibleChangeGNP(deducibleGNP[key], key)\" ng-disabled=\"!isCoberturaSeleccionada(key)\"><option ng-repeat=\"deducible in cobertura.opcionesDeducible\" value=\"{{ deducible }}\" ng-selected=\"deducible === deducibleGNP[key]\">{{ deducible }}</option></select></td></tr><tr><td colspan=\"5\" ng-if=\"aseguradora === \'gnp\' && paquete\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"guardarCobertura()\" ng-if=\"paquete != \'\'\">Guardar</button></td></tr></tbody></table></div></div></div></uib-tab><uib-tab heading=\"Descuentos\"><br><div class=\"row\"><div class=\"card card-body\"><div class=\"col-12 col-sm-6 mt-3\"><label class=\"mb-3\">Aseguradora</label><select ng-model=\"aseguradoradesc\" class=\"form-control\" ng-change=\"changeAseguradoraDescuento(aseguradoradesc)\"><option ng-repeat=\"aseguradora in aseguradoras\" value=\"{{aseguradora.nombre}}\">{{aseguradora.nombre}}</option></select></div><div class=\"col-12 col-sm-6 mt-4\"><label class=\"mb-3\">Empresa</label><select ng-model=\"owner\" class=\"form-control\" ng-value=\"owner\" ng-change=\"changeEmpresaDescuento(owner)\"><option ng-repeat=\"empresa in empresas\" value=\"{{empresa.nombre}}\">{{empresa.nombre}}</option></select></div><div class=\"col-12 col-sm-6 mt-4\" style=\"padding-top: 10px;\"><button class=\"col-12 col-md-3 btn btn-info text-white mt-3\" ng-click=\"modalDescuento()\"><i class=\"fa fa-plus-square me-2\"></i> Nuevo Descuento</button></div><div class=\"col-12 col-sm-12 table-responsive\"><table class=\"col-12 table table-sm align-middle\"><thead><tr><th>Descuento (%)</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"descuento in descuentos track by $index\" ng-click=\"modalDescuento(descuento)\"><td>{{descuento.descuento}}</td><td><button class=\"btn\" ng-click=\"$event.stopPropagation(); deleteCobertura(descuento, $index)\">Borrar</button></td></tr></tbody></table></div></div></div></uib-tab><uib-tab heading=\"Credenciales\"><br><div class=\"row\"><div class=\"card card-body\"><div class=\"col-12 col-sm-6 mt-3\"><label class=\"mb-3\">Aseguradora</label><select ng-model=\"aseguradoraCred\" class=\"form-control\" ng-change=\"changeAseguradoraCredencial(aseguradoraCred)\"><option ng-repeat=\"aseguradora in aseguradoras\" value=\"{{aseguradora.nombre}}\">{{aseguradora.nombre}}</option></select></div><div class=\"col-12 col-sm-6 mt-4\"><label class=\"mb-3\">Empresa</label><select ng-model=\"owner\" class=\"form-control\" ng-change=\"changeEmpresaCredencial(owner)\"><option ng-repeat=\"empresa in empresas\" value=\"{{empresa.nombre}}\">{{empresa.nombre}}</option></select></div><div class=\"col-12 col-sm-6 mt-4\" style=\"padding-top: 10px;\"><button class=\"col-12 col-md-3 btn btn-info text-white mt-3\" ng-click=\"modalCredencial()\"><i class=\"fa fa-plus-square me-2\"></i> Nueva Credencial</button></div><div class=\"col-12 col-sm-12 table-responsive\"><table class=\"col-12 table table-sm align-middle\"><thead><tr><th>Credenciales</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"credencial in credenciales track by $index\" ng-click=\"modalCredencial(credencial)\"><td>{{credencial.data}}</td><td><button class=\"btn\" ng-click=\"$event.stopPropagation(); deleteCredencial(credencial, $index)\">Borrar</button></td></tr></tbody></table></div></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/multicotizador/modals/credencial_form.html","<div class=\"col-xs-12 col-sm-12 col-md-12 modal-content\" style=\"padding-bottom: 10px;\"><div class=\"modal-header\"><div class=\"col-md-12\"><h4>Nuevo descuento</h4></div></div><div class=\"col-md-12\"><div class=\"col-sm-12\"><label class=\"col-sm-4 col-form-label\">Data</label><div class=\"col-sm-8\"><textarea ng-model=\"credencial_seleccionado.data\" rows=\"10\" type=\"text\" class=\"form-control\"></textarea></div></div><div class=\"col-sm-12\"><label class=\"col-sm-4 col-form-label\">Ambiente</label><div class=\"col-sm-8\"><input ng-model=\"credencial_seleccionado.env\" type=\"text\" class=\"form-control\"></div></div><div class=\"col-sm-12\"><label class=\"col-sm-4 col-form-label\">Activo</label><div class=\"col-sm-8\"><input type=\"checkbox\" ng-model=\"credencial_seleccionado.is_active\" checked=\"\"></div></div></div><div class=\"col-xs-12 text-center\"><button ng-click=\"cancel()\" class=\"btn btn-danger\">Cerrar</button> <button ng-click=\"guardarCredencial(credencial)\" class=\"btn btn-success\">Guardar</button></div></div>");
$templateCache.put("app/multicotizador/modals/descuento_form.html","<div class=\"col-xs-12 col-sm-12 col-md-12 modal-content\" style=\"padding-bottom: 10px;\"><div class=\"modal-header\"><div class=\"col-md-12\"><h4>Nuevo descuento</h4></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label>Descuento</label> <input type=\"number\" class=\"form-control\" name=\"descuento\" ng-model=\"descuento\" placeholder=\"Descuento (%)\" value=\"descuento\" required=\"\"></div></div><div class=\"col-xs-12 text-center\"><button ng-click=\"cancel()\" class=\"btn btn-danger\">Cerrar</button> <button ng-click=\"guardarDescuento(descuento)\" class=\"btn btn-success\">Guardar</button></div></div>");
$templateCache.put("app/multicotizador/modals/multicotizador_coberturas.html","<div class=\"col-xs-12 col-sm-12 col-md-12 modal-content\"><div class=\"modal-header\"><h3 class=\"modal-title\" id=\"exampleModalLabel\">Coberturas</h3></div><div class=\"modal-body\"><table class=\"table table-bordered table-striped\"><thead><tr><th>Coberturas</th><th>Suma asegurada</th><th>Deducible</th></tr></thead><tbody><tr ng-repeat=\"item in coverages.coberturas\"><td ng-if=\"coverages.aseguradora === \'ana\' && item.id !== \'08\' && item.id !== \'24\'\">{{item.desc}}</td><td ng-if=\"coverages.aseguradora === \'chubb\' && item.SEL === \'1\'\">{{item.DESC}}</td><td ng-if=\"coverages.aseguradora === \'gnp\'\">{{item.NOMBRE}}</td><td ng-if=\"coverages.aseguradora === \'hdi\'\">{{item.Descripcion}}</td><td ng-if=\"coverages.aseguradora === \'ps\'\"><span ng-if=\"item.id === \'DM\'\">Daños Materiales</span> <span ng-if=\"item.id === \'RED\'\">Reducible</span> <span ng-if=\"item.id === \'RT\'\">Robo Total</span> <span ng-if=\"item.id === \'RCTBP\'\">Responsabilidad Civil Por Daños A Terceros Bienes Y</span> <span ng-if=\"item.id === \'DJUR\'\">Defensa Jurídica</span> <span ng-if=\"item.id === \'NPD\'\">No Pago De Deducible Por Pérdida Total Por Daños</span> <span ng-if=\"item.id === \'GV\'\">Gestoría Vial</span> <span ng-if=\"item.id === \'RCUSA\'\">Responsabilidad Civil En El Extranjero (EE.UU.)</span> <span ng-if=\"item.id === \'EXCRCP\'\">Responsabilidad Civil en Exceso por Muerte</span> <span ng-if=\"item.id === \'AS\'\">Auto Sustituto</span> <span ng-if=\"item.id === \'GMO\'\">Gastos Médicos Ocupantes</span> <span ng-if=\"item.id === \'ASVI\'\">Asistencia Vial</span> <span ng-if=\"item.id === \'AAC\'\">Accidentes Automovilísticos al Conductor</span></td><td ng-if=\"coverages.aseguradora === \'qualitas\' && item.Cobertura !== \'\'\">{{item.Cobertura}}</td><td ng-if=\"coverages.aseguradora === \'qualitas\' && item.Cobertura == \'\'\"><span ng-if=\"item.NoCobertura === \'47\'\">RC Complementaria Personas</span> <span ng-if=\"item.NoCobertura === \'34\'\">RC en el Extranjero</span></td><td ng-if=\"coverages.aseguradora === \'tumomento\' && item.selected\"><span ng-if=\"item.peril === \'occupant_medical_expenses\'\">Gastos Médicos Ocupantes</span> <span ng-if=\"item.peril === \'personal_civil_liability\'\">Responsabilidad Civil Personal</span> <span ng-if=\"item.peril === \'personal_civil_liability_death\'\">Responsabilidad Civil Personal Fallecimiento</span> <span ng-if=\"item.peril === \'property_civil_liability\'\">Responsabilidad Civil Propiedad</span> <span ng-if=\"item.peril === \'material_damage\'\">Daños Materiales</span> <span ng-if=\"item.peril === \'total_theft\'\">Robo Total</span> <span ng-if=\"item.peril === \'driver_death\'\">Accidentes al Conductor</span> <span ng-if=\"item.peril === \'legal_expenses\'\">Asistencia Legal</span> <span ng-if=\"item.peril === \'roadside_assistance\'\">Asistencia Vial y en Viajes</span></td><td ng-if=\"coverages.aseguradora === \'ana\' && item.id !== \'08\' && item.id !== \'24\'\" class=\"text-table\">{{item.sa || \'VALOR COMERCIAL\'}}</td><td ng-if=\"coverages.aseguradora === \'chubb\' && item.SEL === \'1\'\" class=\"text-table\">{{item.SADESC}}</td><td ng-if=\"coverages.aseguradora === \'gnp\'\" class=\"text-table\">{{item.SUMA_ASEGURADA}}</td><td ng-if=\"coverages.aseguradora === \'hdi\'\" class=\"text-table\"><span ng-if=\"item.SumaAsegurada === \'0.0\'\"><span ng-if=\"item.Descripcion === \'Daños Materiales\' || item.Descripcion === \'Robo Total\'\">Valor Comercial</span> <span ng-if=\"item.Descripcion !== \'Daños Materiales\' && item.Descripcion !== \'Robo Total\'\">Amparada</span></span> <span ng-if=\"item.SumaAsegurada !== \'0.0\'\">{{item.SumaAsegurada | currency}}</span></td><td ng-if=\"coverages.aseguradora === \'ps\'\" class=\"text-table\">{{item.dsc_sa}}</td><td ng-if=\"coverages.aseguradora === \'qualitas\'\" class=\"text-table\">{{item.SumaAsegurada | currency}}</td><td ng-if=\"coverages.aseguradora === \'tumomento\' && item.selected\" class=\"text-table\">{{item.insuredSum | currency}}</td><td ng-if=\"coverages.aseguradora === \'ana\' && item.id !== \'08\' && item.id !== \'24\'\" class=\"text-table\">{{item.ded}}</td><td ng-if=\"coverages.aseguradora === \'chubb\' && item.SEL === \'1\'\" class=\"text-table\">{{item.DEDESC}}</td><td ng-if=\"coverages.aseguradora === \'gnp\'\" class=\"text-table\">{{item.DEDUCIBLE}}</td><td ng-if=\"coverages.aseguradora === \'hdi\'\" class=\"text-table\">{{item.Deducible}}%</td><td ng-if=\"coverages.aseguradora === \'ps\'\" class=\"text-table\">{{item.dsc_ded}}</td><td ng-if=\"coverages.aseguradora === \'qualitas\'\" class=\"text-table\">{{item.Deducible | number}}%</td><td ng-if=\"coverages.aseguradora === \'tumomento\' && item.selected\" class=\"text-table\">{{item.deductible}}%</td></tr></tbody></table></div><div class=\"modal-footer\"><div class=\"col-xs-12 text-center\"><button ng-click=\"cancel()\" class=\"btn btn-danger\">Cerrar</button></div></div></div>");
$templateCache.put("app/multicotizador/modals/wrong-car.template.html","<div class=\"col-xs-12 col-sm-12 col-md-12 modal-content\"><div class=\"modal-header\"><div class=\"col-xs-12\"><h4>Modelos</h4></div></div><div name=\"modalData\" class=\"panel-body cob-body\"><div class=\"col-md-12\"><div class=\"container steps-container col-md-12\"><div class=\"modal-body\"><div ng-if=\"loaderModal\"><img class=\"image-load2\" src=\"../../../assets/ZKZg.gif\" alt=\"\"></div><form name=\"new_car\"><div class=\"row\" ng-if=\"provider == \'ana\'\"><div class=\"form-group col-md-6\"><label class=\"text\">Tipo:</label><select ng-model=\"new_car.type\" ng-options=\"cy.descripcion for cy in car.types\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Año</label><select ng-model=\"new_car.year\" ng-options=\"cy.descripcion for cy in car.years | reverse\" class=\"form-control form-control-custom\" ng-change=\"getCarBrands(\'ana\',\'marcas\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Marca</label><select ng-model=\"new_car.brand\" ng-options=\"cb.descripcion for cb in car.brands\" class=\"form-control form-control-custom\" ng-change=\"getCarModels(\'ana\',\'submarcas\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Modelo</label><select ng-model=\"new_car.model\" ng-options=\"cm.descripcion for cm in car.models\" ng-change=\"getVersions(\'ana\',\'vehiculos\')\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Version</label><select ng-model=\"new_car.version\" ng-options=\"cy.descripcion for cy in car.versions | reverse\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div></div><div class=\"row\" ng-if=\"provider == \'gnp\'\"><div class=\"form-group col-md-6\"><label>Marca:</label><select class=\"form-control\" ng-options=\"cy.descripcion for cy in car.brands\" ng-model=\"new_car.brand\" formcontrolname=\"form-control form-control-custom\" ng-change=\"getCarModels(\'gnp\',\'submarcas\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Submarca:</label><select ng-model=\"new_car.model\" ng-options=\"cm.descripcion for cm in car.models\" ng-change=\"getCarYear(\'gnp\',\'modelos\')\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Modelo:</label><select ng-model=\"new_car.year\" ng-options=\"cy for cy in car.years | reverse\" class=\"form-control form-control-custom\" ng-change=\"getVersions(\'gnp\',\'vehiculos\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Version:</label><select ng-model=\"new_car.version\" ng-options=\"cy.descripcion for cy in car.versions | reverse\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div></div><div class=\"row\" ng-if=\"provider == \'ps\'\"><div class=\"form-group col-md-6\"><label>Marca:</label><select class=\"form-control\" ng-options=\"cy.descripcion for cy in car.brands\" ng-model=\"new_car.brand\" formcontrolname=\"form-control form-control-custom\" ng-change=\"getCarModels(\'ps\',\'submarcas\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Submarca:</label><select ng-model=\"new_car.model\" ng-options=\"cm.descripcion for cm in car.models\" ng-change=\"getVersions(\'ps\',\'vehiculos\')\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Version:</label><select ng-model=\"new_car.version\" ng-options=\"cy.descripcion for cy in car.versions | reverse\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div></div><div class=\"row\" ng-if=\"provider == \'hdi\'\"><div class=\"form-group col-md-6\"><label class=\"text\">Tipo:</label><select ng-model=\"new_car.type\" ng-options=\"cy.descripcion for cy in car.types\" class=\"form-control form-control-custom\" ng-change=\"getCarBrands(\'hdi\',\'marcas\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Marca</label><select ng-model=\"new_car.brand\" ng-options=\"cb.descripcion for cb in car.brands\" class=\"form-control form-control-custom\" ng-change=\"getCarModels(\'hdi\',\'submarcas\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Modelo</label><select ng-model=\"new_car.model\" ng-options=\"cm.descripcion for cm in car.models\" ng-change=\"getCarYear(\'hdi\',\'modelos\')\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Año</label> <input class=\"form-control\" type=\"text\" ng-model=\"new_car.year\" ng-value=\"infoForm.modelo\" readonly=\"\"></div><div class=\"form-group col-md-6\"><label class=\"text\">Version</label><select ng-model=\"new_car.version\" ng-options=\"cy.descripcion for cy in car.versions | reverse\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div></div><div class=\"row\" ng-if=\"provider == \'tumomento\'\"><div class=\"form-group col-md-6\"><label class=\"text\">Tipo:</label><select ng-model=\"new_car.type\" ng-options=\"cy.descripcion for cy in car.types\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Marca:</label><select ng-model=\"new_car.brand\" ng-options=\"cb.descripcion for cb in car.brands\" class=\"form-control form-control-custom\" ng-change=\"getCarModels(\'tumomento\',\'submarcas\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Submarca:</label><select ng-model=\"new_car.model\" ng-options=\"cm.descripcion for cm in car.models\" ng-change=\"getCarYear(\'tumomento\',\'modelos\')\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Modelo:</label><select ng-model=\"new_car.year\" ng-options=\"cy.descripcion for cy in car.years | reverse\" class=\"form-control form-control-custom\" ng-change=\"getVersions(\'tumomento\',\'versiones\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Version</label><select ng-model=\"new_car.version\" ng-options=\"cy.descripcion for cy in car.versions | reverse\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div></div><div class=\"row\" ng-if=\"provider == \'chubb\'\"><div class=\"form-group col-md-6\"><label class=\"text\">Marca:</label><select ng-model=\"new_car.brand\" ng-options=\"cb.descripcion for cb in car.brands\" class=\"form-control form-control-custom\" ng-change=\"getCarModels(\'chubb\',\'submarcas\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Submarca:</label><select ng-model=\"new_car.model\" ng-options=\"cm.descripcion for cm in car.models\" ng-change=\"getCarYear(\'chubb\',\'modelos\')\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Año:</label><select ng-model=\"new_car.year\" ng-options=\"cy.descripcion for cy in car.years | reverse\" class=\"form-control form-control-custom\" ng-change=\"getCarTypes(\'chubb\',\'tipos\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Modelo:</label><select ng-model=\"new_car.model2\" ng-options=\"cy.descripcion for cy in car.types | reverse\" class=\"form-control form-control-custom\" ng-change=\"getVersions(\'chubb\',\'descr\')\"><option value=\"\">-- Selecciona una opción --</option></select></div><div class=\"form-group col-md-6\"><label class=\"text\">Version</label><select ng-model=\"new_car.version\" ng-options=\"cy.descripcion for cy in car.versions | reverse\" class=\"form-control form-control-custom\"><option value=\"\">-- Selecciona una opción --</option></select></div></div></form></div></div></div><div class=\"modal-footer\"><div class=\"col-xs-12 text-center\"><button ng-click=\"cancel()\" class=\"btn btn-danger\">Cerrar</button> <button ng-click=\"sendData()\" class=\"btn btn-success\">Aceptar</button></div></div></div></div>");
$templateCache.put("app/polizas/modals/otAsPolicyModal.html","<div class=\"inmodal\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Convertir a Póliza</h4></div><div class=\"modal-body\"><div class=\"row\"><form class=\"quoteForm\" name=\"otpolicy\" novalidate=\"\"><div class=\"form-group col-xs-6\"><label for=\"\">Folio de Póliza</label> <input class=\"form-control\" ng-model=\"vmm.form.folio\"></div><div class=\"form-group col-xs-6\" ng-hide=\"order.show.ot\"><label>Número de Póliza<span class=\"color-red\">*</span></label><div ng-class=\"{ \'has-error\': form.poliza.$invalid && !form.poliza.$pristine }\"><input class=\"form-control\" ng-blur=\"changeNoPoliza(vmm.form.poliza)\" name=\"poliza\" ng-model=\"vmm.form.poliza\" type=\"text\" ng-trim=\"false\" required=\"\"></div></div><hr><div class=\"row\"><div class=\"col-xs-12 form-group\" ng-hide=\"order.show.ot\"><receipts-individual form=\"vmm.form\" tosave=\"dataToSave\" type=\"1\"></receipts-individual></div></div></form></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"vmm.options.cancel()\" type=\"button\">Cerrar</button> <button class=\"btn btn-success ladda-button\" ng-disabled=\"otpolicy.$invalid\" ng-click=\"vmm.save()\" type=\"button\">Crear</button></div></div>");
$templateCache.put("app/polizas/modals/renewal.policy.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Renovación - Crear OT</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><form name=\"signupForm\" ng-submit=\"processForm()\"><div class=\"\" ng-show=\"showOne == true\"><form class=\"\"><div class=\"form-group col-sm-6\"><label>Contratantes</label><input class=\"form-control\" value=\"{{renewal.natural}}{{renewal.juridical}}\" type=\"text\" disabled=\"disabled\"></div><div class=\"form-group col-sm-6\"><label>Número de Póliza</label> <input class=\"form-control\" name=\"poliza\" ng-model=\"renewal.poliza_number\" type=\"text\"></div><div class=\"form-group col-sm-6\"><label>Aseguradora<span class=\"color-red\">*</span></label><select ng-model=\"renewal.aseguradora\" class=\"form-control\" ng-options=\"a.compania for a in combos.providers track by a.id\" ng-change=\"changeProvider(renewal.aseguradora)\" required=\"\"></select></div><div class=\"form-group col-sm-6\"><label>Ramo<span class=\"color-red\">*</span></label><select ng-model=\"renewal.ramo\" class=\"form-control\" ng-options=\"r.ramo_name for r in combos.ramos track by r.id\" ng-change=\"changeRamo(renewal.ramo)\" required=\"\"></select></div><div class=\"form-group col-sm-6\"><label>Subramos<span class=\"color-red\">*</span></label><select ng-model=\"renewal.subramo\" class=\"form-control\" ng-options=\"s.subramo_name for s in combos.subramos track by s.id\" ng-change=\"changeSubramo(renewal.subramo)\" required=\"\"></select></div><div class=\"form-group col-sm-12\"><div ng-if=\"showForms\" ng-include=\"\'templates/forms.html\'\"></div></div><div class=\"form-group col-sm-6\"><label>Paquetes<span class=\"color-red\">*</span></label><select ng-model=\"renewal.paquete\" class=\"form-control\" ng-options=\"p.package_name for p in combos.packages track by p.id\" ng-change=\"changePackage(renewal.paquete)\" required=\"\"></select></div><div class=\"form-group col-sm-6\"><label>Fecha de Inicio</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" name=\"startDate\" ng-model=\"renewal.start_of_validity\" view=\"year\"></div></div><div class=\"form-group col-sm-6\"><label>Fecha de Fin</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" name=\"endingDate\" ng-model=\"renewal.end_of_validity\" view=\"year\"></div></div><div class=\"form-group col-sm-6\"><label>Forma de pago<span class=\"color-red\">*</span></label><select ng-model=\"renewal.payment\" class=\"form-control\" ng-options=\"p.label for p in combos.payform track by p.value\" required=\"\"></select></div><div class=\"hr-line-dashed\"></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-success pull-right margin-right-10\" ng-click=\"hideOT()\" ng-disabled=\"renewal.contratante.length === 0\" ng-show=\"show.ot\" type=\"button\">Crear OT</button> <button class=\"btn btn-success pull-right margin-right-10\" type=\"button\" ng-disabled=\"renewal.$invalid\" ng-hide=\"show.ot\" ng-click=\"saveChangesInOt()\">Guardar OT</button> <button class=\"btn btn-success pull-right margin-right-10\" ng-click=\"saveInsurance()\" ng-disabled=\"showPoliceCreator()\" ng-show=\"!show.ot\" type=\"button\">Crear póliza</button></div></div></form></div><div class=\"\" ng-show=\"showOne == false\"><div class=\"modal-body\"><form class=\"form-group\"><div class=\"form-group\"><label class=\"control-label\">Prima neta: $</label> <input class=\"form-control\" id=\"prima-neta\" ng-model=\"poliza.primaNeta\" min=\"0.00\" step=\"any\" max=\"9999999999\" type=\"number\" value=\"\" format-as-currency=\"\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"rpf\">RPF: $</label> <input class=\"form-control\" id=\"rpf\" ng-model=\"poliza.rpf\" min=\"0.00\" step=\"any\" max=\"9999999999\" type=\"number\" value=\"\" format-as-currency=\"\"></div><div class=\"form-group\"><label for=\"derecho\">Derecho de Póliza: $</label> <input class=\"form-control\" id=\"derecho\" ng-model=\"poliza.derecho\" min=\"0.00\" step=\"any\" max=\"9999999999\" type=\"number\" value=\"\" format-as-currency=\"\"></div><div class=\"form-group\"><label for=\"iva\">IVA:</label> <input class=\"form-control\" id=\"iva\" ng-model=\"poliza.iva\" min=\"0.00\" step=\"any\" max=\"9999999999\" type=\"text\" value=\"\"></div><div class=\"form-group\"><label for=\"sub-total\">Sub-Total: $</label> <input class=\"form-control\" id=\"sub-total\" ng-model=\"poliza.subTotal\" min=\"0.00\" step=\"any\" max=\"9999999999\" type=\"number\" value=\"\" disabled=\"\"></div><div class=\"form-group\"><label for=\"prima-total\">Prima Total: $</label> <input class=\"form-control\" id=\"prima-total\" ng-model=\"poliza.primaTotal\" min=\"0.00\" step=\"any\" max=\"9999999999\" type=\"number\" value=\"\" disabled=\"\"></div></form><button class=\"btn btn-success\" id=\"calculate\" name=\"button\" ng-click=\"calculate()\" type=\"button\">Calcular y generar recibos</button><div id=\"personalizado\"><div class=\"checkbox\" id=\"divConfigDerecho\"><label><input id=\"configDerecho\" ng-model=\"configDerecho\" type=\"checkbox\">Derecho - Cargos sólo al primer recibo</label></div><div class=\"checkbox\" id=\"divConfigRPF\"><label><input id=\"configRPF\" ng-model=\"configRPF\" type=\"checkbox\">RPF - Cargos sólo al primer recibo</label></div></div><div class=\"form-horizontal\" ng-if=\"showReceipts\"><div class=\"form-group\"><label class=\"col-sm-6 h4\" for=\"\">Cantidad de recibos: {{amountReceipts}}</label></div></div><div ng-if=\"showReceipts\"><h5><strong>Recibo inicial</strong></h5><form method=\"post\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-repeat=\"receipt in receipts track by $index\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Recibo # {{$index + 1}}</div><div class=\"panel-body\"><div class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Prima neta: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.prima\" step=\"any\" type=\"number\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">RPF: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.rpf\" type=\"number\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Derecho: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.derecho\" type=\"number\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">IVA(%):</label><div class=\"col-sm-8\"><input class=\"form-control\" disabled=\"\" ng-model=\"receipt.iva\" type=\"number\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Sub Total: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.subTotal\" type=\"number\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Prima Total: $</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"receipt.total\" type=\"number\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de inicio</label><div class=\"col-sm-8\"><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" ng-model=\"receipt.startDate\" view=\"year\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de fin</label><div class=\"col-sm-8\"><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" ng-model=\"receipt.endingDate\" view=\"year\"></div></div></div></div></div></div></div></div></form></div></div></div></form></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div>");
$templateCache.put("app/polizas/receipts/receipts.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Pólizas</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"breadcrumb\"><a ui-sref=\"polizas.table\">Pólizas</a></li><li class=\"breadcrumb\"><a ui-sref=\"polizas.info({polizaId: vm.poliza_id})\">Póliza # {{vm.poliza_number}}</a></li><li class=\"active\"><strong>Recibos</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Recibo</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"form-group\"><button class=\"btn btn-w-m btn-primary pull-right\" name=\"button\" ng-click=\"vm.editReceipt()\" type=\"button\" ng-show=\"vm.canEditReceipt\" ng-if=\"vm.user.permiso.editar\">Editar</button> <button class=\"btn btn-w-m btn-success pull-right margin-right-10\" name=\"button\" ng-click=\"vm.applyEditReceipt()\" type=\"button\" ng-show=\"!vm.canEditReceipt\" ng-if=\"vm.user.permiso.editar\">Guardar</button> <button class=\"btn btn-w-m btn-white pull-right margin-right-10\" name=\"button\" ng-click=\"vm.cancelEditReceipt()\" type=\"button\" ng-show=\"!vm.canEditReceipt\">Cancelar</button></div><br><div class=\"form-group col-md-6\"><label>Fecha de inicio</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" ng-model=\"vm.receipt.fecha_inicio\" view=\"year\" ng-disabled=\"vm.canEditReceipt\"></div></div><div class=\"form-group col-md-6\"><label>Fecha de fin</label><div class=\"input-group date\"><span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input auto-close=\"true\" class=\"form-control\" date-time=\"\" format=\"dd-MM-yyyy\" min-view=\"date\" ng-model=\"vm.receipt.fecha_fin\" view=\"year\" ng-disabled=\"vm.canEditReceipt\"></div></div><div class=\"form-group col-md-6\"><label>Prima neta:</label> <input class=\"form-control\" format-as-currency=\"\" ng-disabled=\"vm.canEditReceipt\" ng-model=\"vm.receipt.prima_neta\" step=\"any\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Recargo por Pago Fraccionado:</label> <input class=\"form-control\" format-as-currency=\"\" ng-disabled=\"vm.canEditReceipt\" ng-model=\"vm.receipt.rpf\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Derecho:</label> <input class=\"form-control\" format-as-currency=\"\" ng-disabled=\"vm.canEditReceipt\" ng-model=\"vm.receipt.derecho\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>IVA(%):</label> <input class=\"form-control\" ng-disabled=\"vm.canEditReceipt\" ng-model=\"vm.receipt.iva\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Sub Total:</label> <input class=\"form-control\" format-as-currency=\"\" ng-disabled=\"vm.canEditReceipt\" ng-model=\"vm.receipt.sub_total\" type=\"text\"></div><div class=\"form-group col-md-6\"><label>Prima Total:</label> <input class=\"form-control\" format-as-currency=\"\" ng-disabled=\"vm.canEditReceipt\" ng-model=\"vm.receipt.prima_total\" type=\"text\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Modificar Estatus</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"form-group\"><button class=\"btn btn-w-m btn-info pull-right\" name=\"button\" ng-click=\"vm.editReceiptStatus(vm.receipt)\" type=\"button\" ng-if=\"vm.user.permiso.editar\">Aplicar</button></div><br><div class=\"form-group\"><label>Estatus Actual:</label> {{vm.receipt.status | receipts}}</div><div class=\"form-group\"><label>Estatus</label><select class=\"form-control\" ng-model=\"vm.status\" ng-options=\"s.label for s in vm.statusReceipt\" ng-change=\"vm.changeReceiptStatus()\" ng-disabled=\"vm.canEditReceiptStatus\"></select></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Archivos</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div upload-template=\"\"></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"form-group\"><button class=\"btn btn-success pull-right margin-right-10\" ng-click=\"vm.uploadFiles()\" id=\"uploadButton\" type=\"button\" ng-if=\"uploader.queue.length >= 1\">Subir archivos</button></div></div><div class=\"hr-line-dashed\"></div><div ng-include=\"\'templates/show-filesRecepits.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/recordatorios/automaticos/automaticos.component.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-6\"><h2>Recordatorios Automáticos</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Recordatorios Automáticos</strong></li></ol></div></div><br><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Administrador de recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12 pull-right\" ng-click=\"crear_recordatorio()\">+ Agregar recordatorio</button></div><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\" ng-if=\"!show_comment\"><thead><tr><th>Resumen</th><th>Descripción</th><th>Aseguradoras</th><th>Subramos</th><th>Regla</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"recordatorio in vm.recordatorios track by $index\" ng-click=\"showReminder(recordatorio)\"><td>{{ recordatorio.nombre}}</td><td>{{ recordatorio.descr}}</td><td><ul><li ng-repeat=\"aseg in recordatorio.aseguradoras_recordatorio\">{{aseg.aseguradora}}</li></ul></td><td><ul><li ng-repeat=\"subramo in recordatorio.subramos_recordatorio\">{{subramo.subramo_descr}}</li></ul></td><td>{{recordatorio.tipo_instancia_descr}} : <span class=\"color-blue\">{{recordatorio.dias_configuracion}}</span></td><td><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); deleteReminder(recordatorio, $index)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); editReminder(recordatorio, $index)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"show_pag_recatm\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div></div>");
$templateCache.put("app/recordatorios/automaticos/automaticos.detail.component.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-6\"><h2>{{action}} Recordatorio Automático</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>{{action}} Recordatorio Automático</strong></li></ol></div></div><br><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{action}} Recordatorio</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group\"><label>Resumen</label> <input class=\"form-control\" type=\"text\" name=\"nombre\" id=\"\" ng-model=\"form.nombre\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-3 form-group\"><label>Aseguradoras</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"form.providers\" data-ng-options=\"providers.alias ? providers.alias : providers.id for providers in providers | orderBy: \'alias\' track by providers.url\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-3 form-group\"><label>Subramos</label><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"form.subramos\" data-ng-options=\"subramos_toselected.subramo_name for subramos_toselected in subramos_toselected track by subramos_toselected.subramo_code\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group\"><label>Descripción de recordatorio</label> <textarea class=\"form-control\" ng-model=\"form.descr\" id=\"\" rows=\"3\"></textarea></div></div><hr><h3>Reglas</h3><hr><table class=\"table table-bordered table-hover\"><thead><th>Nombre</th><th>Cuántos días antes o después (- antes / + después)</th></thead><tbody><tr><td><select name=\"\" id=\"\" class=\"form-control\" ng-model=\"form.tipo_instancia\" ng-options=\"opcion.descr for opcion in opciones_tipo_instancia\"></select></td><td ng-click=\"$event.stopPropagation();\"><input type=\"number\" name=\"\" ng-model=\"form.dias_configuracion\" minlength=\"1\" maxlength=\"3\" max=\"90\" min=\"-90\" class=\"form-control\" required=\"\"></td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"save()\">Guardar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-danger col-xs-12\" ng-click=\"cancel()\">Cancelar</button></div></div></div>");
$templateCache.put("app/recordatorios/automaticos/automaticos.show.component.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-6\"><h2>{{action}} Recordatorio Automático</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Información Recordatorio Automático</strong></li></ol></div></div><br><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{action}} Recordatorio</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-3 form-group\"><span class=\"blue-color\">Resumen:</span><div>{{ form.nombre }}</div></div><div class=\"col-xs-12 col-md-2 form-group\"><span class=\"blue-color\">Aseguradoras:</span><div><ul><li ng-repeat=\"aseg in form.providers\">{{aseg.alias}}</li></ul></div></div><div class=\"col-xs-12 col-md-2 form-group\"><span class=\"blue-color\">Subramos:</span><div><ul><li ng-repeat=\"aseg in form.subramos\">{{aseg.subramo_name}}</li></ul></div></div><div class=\"col-xs-12 col-md-5 form-group\"><span class=\"blue-color\">Regla:</span><div><ul><li>{{form.tipo_instancia_descr}} : <span class=\"color-blue\">{{form.dias_configuracion}}</span></li></ul></div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12 form-group container-loader\" ng-if=\"loader\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div></div><table class=\"table table-bordered table-hover\" ng-if=\"!show_comment\"><thead><tr><th>Ubicación / Tipo</th><th>Resumen</th><th>Recordatorio</th><th>Póliza</th><th>Aseguradora</th><th>Subramo</th><th>Estatus</th></tr></thead><tbody><tr ng-repeat=\"recordatorio in vm.recordatorios track by $index\" ng-click=\"showReminder(recordatorio,$index)\"><td>{{ recordatorio.instancia.ubicacion}} / {{ recordatorio.instancia.tipo}}</td><td>{{ recordatorio.instancia.resumen}}</td><td>{{ recordatorio.instancia.recordatorio}}</td><td>{{ recordatorio.instancia.identificador}}</td><td>{{ recordatorio.instancia.aseguradora}}</td><td>{{ recordatorio.instancia.subramo}}</td><td ng-class=\"{\'label-info\' : recordatorio.seen }\" ng-if=\"recordatorio.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !recordatorio.seen }\" ng-if=\"!recordatorio.seen\">No visto</td></tr></tbody></table><div ng-if=\"show_pag_task\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"vm.cargarRegistros()\">Recargar registros</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-danger col-xs-12\" ng-click=\"cancel()\">Cancelar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/recordatorios/desde-registro/desde_registro.component.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-6\"><h2>Recordatorios desde Registros</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Recordatorios desde Registros</strong></li></ol></div></div><br><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Administrador de recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12 pull-right\" ng-click=\"crear_recordatorio()\">+ Agregar recordatorio</button></div><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\" ng-if=\"!show_comment\"><thead><tr><th>Resumen</th><th>Descripción</th><th>Fecha</th><th>Hora</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"recordatorio in vm.recordatorios track by $index\" ng-click=\"showReminder(recordatorio)\"><td>{{ recordatorio.nombre}}</td><td>{{ recordatorio.descr}}</td><td>{{ recordatorio.fecha_programada | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{ recordatorio.hora_programada | date: \'HH:mm\'}}</td><td><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); deleteReminder(recordatorio, $index)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); editReminder(recordatorio, $index)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"show_pag_recfree\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div></div>");
$templateCache.put("app/recordatorios/desde-registro/desde_registro.detail.component.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom \'white\'-bg page-heading\"><div class=\"col-xs-6\"><h2>{{action}} Recordatorio desde Registros</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>{{action}} Recordatorio desde Registros</strong></li></ol></div></div><br><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{action}} Recordatorio desde Registros</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group\"><label>Resumen</label> <input class=\"form-control\" type=\"text\" name=\"nombre\" id=\"\" ng-model=\"form.nombre\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-3 form-group\"><label>Fecha</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"form.fecha_programada\" value=\"{{form.fecha_programada}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-3 form-group\"><label>Hora</label><div uib-timepicker=\"\" ng-model=\"form.hora_programada\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"true\" ng-change=\"timeDate(form.hora_programada)\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group\" ng-if=\"action == \'Información\'\"><label>Registro asignado:</label> <span>{{form.registro.instancia.identificador}}</span><br></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\" ng-hide=\"action != \'Nuevo\'\"><label>Póliza Individual:</label><autocomplete datasource=\"policies_data\" id=\"policies\" model=\"searchPolicy\" change=\"matchesPolicies(searchPolicy)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"policyLay.poliza_number\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Póliza Individual</th></tr></thead><tbody><tr><td ng-style=\"{\'background-color\': policyLay && policyLay.selected ? \'#0991A9\' : \'white\' }\" ng-click=\"selectPolicy()\"><small>Vigencia Inicio: <span>{{ policyLay.start }}</span></small><br><small>Vigencia Fin: <span>{{ policyLay.end }}</span></small><br><small>Número de Póliza: <span>{{ policyLay.poliza_number }}</span></small></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"policyLay.recibos && policyLay.recibos.length > 0\"><thead><tr><th>Recibos Póliza</th></tr></thead><tbody><tr ng-repeat=\"item in policyLay.recibos track by $index\" ng-click=\"selectRecibo($index)\"><td ng-style=\"{\'background-color\': item.selected ? \'#0991A9\' : \'white\' }\"><small>Número de serie: <span>{{ item.recibo_numero }}</span></small> - <small>Vigencia:</small><span class=\"font-weight-bold\">{{ item.fecha_inicio| date: \'dd/MM/yyyy\': \'UTC\' }} - {{ item.fecha_fin | date: \'dd/MM/yyyy\': \'UTC\'}}</span><br></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"policyLay.endosos && policyLay.endosos.length > 0\"><thead><tr><th>Endosos Póliza</th></tr></thead><tbody><tr ng-repeat=\"item in policyLay.endosos track by $index\" ng-click=\"selectEndoso($index)\"><td ng-style=\"{\'background-color\': item.selected ? \'#0991A9\' : \'white\' }\"><small>Número de endoso: <span>{{ item.number_endorsement }}</span></small> -Número interno: <span>{{ item.internal_number }}</span> - <small>Vigencia:</small><span class=\"font-weight-bold\">{{ item.init_date | date: \'dd/MM/yyyy\': \'UTC\'}} - {{ item.end_date | date: \'dd/MM/yyyy\': \'UTC\' }}</span><br></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"policyLay.siniestros && policyLay.siniestros.length > 0\"><thead><tr><th>Siniestros Póliza</th></tr></thead><tbody><tr ng-repeat=\"item in policyLay.siniestros track by $index\" ng-click=\"selectSiniestro($index)\"><td ng-style=\"{\'background-color\': item.selected ? \'#0991A9\' : \'white\' }\"><small ng-if=\"item.numero_siniestro\">Número de siniestro: <span>{{ item.numero_siniestro }}</span></small> - <small ng-if=\"item.folio_interno\">Número interno: <span>{{ item.folio_interno }}</span></small> - <small>Fecha siniestro:</small><span class=\"font-weight-bold\">{{ item.fecha_siniestro | date: \'dd/MM/yyyy\': \'UTC\'}}</span> <small>Fecha ingreso:</small><span class=\"font-weight-bold\">{{ item.fecha_ingreso | date: \'dd/MM/yyyy\': \'UTC\'}}</span><br></td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-6 form-group\"><label>Póliza de Grupo:</label><autocomplete datasource=\"caratules_data\" id=\"caratules\" model=\"searchCaratule\" change=\"matchesCaratules(searchCaratule)\"></autocomplete></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=\"searchCaratule\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Póliza de Grupo</th></tr></thead><tbody><tr ng-click=\"selectCaratula()\"><td ng-style=\"{\'background-color\': caratuleLay && caratuleLay.selected ? \'#0991A9\' : \'white\' }\"><small>ID para layout:</small><span class=\"font-weight-bold\">{{ caratuleLay.id }}</span><br><small>Vigencia Inicio: <span>{{ caratuleLay.start }}</span></small><br><small>Vigencia Fin: <span>{{ caratuleLay.end }}</span></small><br><small>Número de Carátula: <span>{{ caratuleLay.poliza_number }}</span></small><br><small>Recibos por: <span ng-if=\"caratuleLay.receipts_by == 1\">Carátula</span> <span ng-if=\"caratuleLay.receipts_by == 2\">Subgrupo</span> <span ng-if=\"caratuleLay.receipts_by == 3\">Certificado</span></small></td></tr></tbody></table><table class=\"table table-bordered table-hover\" ng-if=\"caratuleLay.receipts_by == 1\"><thead><tr><th>Recibos Carátula</th></tr></thead><tbody><tr ng-repeat=\"item in caratuleLay.recibos track by $index\" ng-if=\"item.receipt_type == 1\" ng-click=\"selectReciboCaratula($index)\"><td ng-style=\"{\'background-color\': item.selected ? \'#0991A9\' : \'white\' }\"><small>Número de serie: <span>{{ item.recibo_numero }}</span></small> - <small>ID para layout:</small><span class=\"font-weight-bold\">{{ item.id }}</span><br></td></tr></tbody></table></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group\"><label>Descripción de recordatorio</label> <textarea class=\"form-control\" ng-model=\"form.descr\" id=\"\" rows=\"5\"></textarea></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"save()\">Guardar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-danger col-xs-12\" ng-click=\"cancel()\">Cancelar</button></div></div></div>");
$templateCache.put("app/recordatorios/desde-registro/desde_registro.show.component.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-6\"><h2>{{action}} Recordatorio Desde Registro</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Información Recordatorio Desde Registro</strong></li></ol></div></div><br><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{action}} Recordatorio</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-3 form-group\"><span class=\"blue-color\">Resumen:</span><div>{{ form.nombre }}</div></div><div class=\"col-xs-12 col-md-3 form-group\"><span class=\"blue-color\">Descripción:</span><div>{{ form.descr }}</div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12 form-group container-loader\" ng-if=\"loader\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div></div><table class=\"table table-bordered table-hover\" ng-if=\"!show_comment\"><thead><tr><th>Ubicación / Tipo</th><th>Resumen</th><th>Recordatorio</th><th>Tipo de registro</th><th>Identificador</th><th>Fecha programada</th><th>Hora programada</th><th>Estatus</th></tr></thead><tbody><tr ng-repeat=\"recordatorio in vm.recordatorios track by $index\" ng-click=\"showReminder(recordatorio,$index)\"><td>{{ recordatorio.instancia.ubicacion}}</td><td>{{ recordatorio.instancia.resumen}}</td><td>{{ recordatorio.instancia.recordatorio}}</td><td>{{ recordatorio.instancia.modelo}}</td><td>{{ recordatorio.instancia.identificador}}</td><td>{{ recordatorio.recordatorio.fecha_programada | date: \'dd/MM/yyyy\': \'UTC\' }}</td><td>{{ recordatorio.recordatorio.fecha_programada | date: \'HH:mm\' }}</td><td ng-class=\"{\'label-info\' : recordatorio.seen }\" ng-if=\"recordatorio.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !recordatorio.seen }\" ng-if=\"!recordatorio.seen\">No visto</td></tr></tbody></table><div ng-if=\"show_pag_task\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"vm.cargarRegistros()\">Recargar registros</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-danger col-xs-12\" ng-click=\"cancel()\">Cancelar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/recordatorios/desde-registro/desderegistro.modal.html","<div class=\"inmodal\" id=\"modal_edit\" style=\"z-index: 1000;\"><div class=\"modal-header modal-header modal_title nav-header\"><h4 class=\"modal-title\">Recordatorio desde Registro</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"wizard\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Nuevo Recordatorio</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\"><span class=\"blue-color\">{{tipo}}:</span><div ng-if=\"tipoRegistro ==1 || tipoRegistro ==13\"><span>{{poliza.poliza_number}}<span><span ng-if=\"poliza.internal_number\">{{poliza.internal_number}}<span></span></span></span></span></div><div ng-if=\"tipoRegistro ==22\"><span>{{poliza.identifier}}<span><br><span ng-if=\"poliza.title\">{{poliza.title}}<span></span></span></span></span></div><div ng-if=\"tipoRegistro ==25\"><span ng-if=\"poliza.certificate_number\">{{poliza.certificate_number}}<span><br><br><span>Número Póliza: {{poliza.poliza_number}}<span><br></span></span></span></span></div><div ng-if=\"tipoRegistro ==4\"><span>{{poliza.recibo_numero}}<span><br><span ng-if=\"parent.poliza_number\" class=\"blue-color\">Póliza:</span> <span ng-if=\"parent.poliza_number\">{{parent.poliza_number}}<span></span></span></span></span></div><div ng-if=\"tipoRegistro ==2\"><span>{{poliza.full_name}}<span></span></span></div><div ng-if=\"tipoRegistro ==5\"><span>{{poliza.numero_siniestro}}<span></span></span></div><div ng-if=\"tipoRegistro == 10\"><span>{{poliza.internal_number}}<span><br><span class=\"blue-color\">Número:</span> <span>{{poliza.number_endorsement}}<span></span></span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"tipoRegistro ==1 || tipoRegistro ==13 || tipoRegistro ==25\"><span class=\"blue-color\">Vigencia:</span><div><span>{{poliza.start_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{poliza.end_of_validity | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"tipoRegistro ==1 || tipoRegistro ==13\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" ng-class=\"{\'label-success\': poliza.status == 1 || poliza.status == 12, \'label-info\' : poliza.status == 10,\'label-primary\' : poliza.status == 14, \'label-warning\' : poliza.status == 2 || poliza.status == 4 || poliza.status == 11}\" style=\"margin-right: 10px\">{{ status(poliza.status) }}</div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"tipoRegistro ==4\"><span class=\"blue-color\">Fecha Inicio - Fecha Fin:</span><div><span>{{poliza.fecha_inicio | date: \'dd/MM/yyyy\' : \'UTC\'}} - {{poliza.fecha_fin | date: \'dd/MM/yyyy\' : \'UTC\'}}<span></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"tipoRegistro ==4\"><span class=\"blue-color\"><b>Estatus</b>:</span><div><div class=\"label\" style=\"margin-right: 10px\">{{ checkStatusReceipts(poliza.status) }}</div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"tipoRegistro ==2\"><span class=\"blue-color\"><b>Grupo</b>:</span><div><span>{{poliza.group.group_name}}</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 form-group\" ng-if=\"tipoRegistro ==2\"><span class=\"blue-color\"><b>RFC</b>:</span><div><span>{{poliza.rfc}}</span></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group\"><label>Resumen</label> <input class=\"form-control\" name=\"poliza\" ng-model=\"form.nombre_rec\" type=\"text\" ng-trim=\"false\" required=\"\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-3 form-group\"><label>Fecha</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"form.fecha_programada\" value=\"{{form.fecha_programada}}\" data-date-format=\"mm/dd/yyyy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-3 form-group\"><label>Hora</label><div uib-timepicker=\"\" ng-model=\"form.hora_programada\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"true\" ng-change=\"timeDate(form.hora_programada)\" required=\"\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group\"><label>Descripción de recordatorio</label> <textarea class=\"form-control\" ng-model=\"form.descr\" id=\"\" rows=\"5\" required=\"\"></textarea></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"save()\">Guardar</button></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-white\" ng-click=\"cancel()\" type=\"button\">Cerrar</button></div></div><script type=\"text/javascript\">\n    // $(\'#modal_email\').modal({backdrop: \'static\', keyboard: false})\n    // $(document).ready(function(){\n    //   $(\'#modal_edit\').modal(\'hide\');\n    //     if ($(\'.modal-backdrop\').is(\':visible\')) {\n    //       $(\'body\').removeClass(\'modal-open\'); \n    //       $(\'.modal-backdrop\').remove(); \n    //     };\n    //   });\n  // });\n  </script>");
$templateCache.put("app/recordatorios/libres/libres.component.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-6\"><h2>Recordatorios Libres</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Recordatorios Libres</strong></li></ol></div></div><br><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Administrador de recordatorios</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\"><button class=\"btn btn-info col-xs-12 pull-right\" ng-click=\"crear_recordatorio()\">+ Agregar recordatorio</button></div><div class=\"col-xs-12\"><table class=\"table table-bordered table-hover\" ng-if=\"!show_comment\"><thead><tr><th>Resumen</th><th>Descripción</th><th>Fecha</th><th>Hora</th><th>Opciones</th></tr></thead><tbody><tr ng-repeat=\"recordatorio in vm.recordatorios track by $index\" ng-click=\"showReminder(recordatorio)\"><td>{{ recordatorio.nombre}}</td><td>{{ recordatorio.descr}}</td><td>{{ recordatorio.fecha_programada | date: \'dd/MM/yyyy\': \'UTC\'}}</td><td>{{ recordatorio.hora_programada | date: \'HH:mm\'}}</td><td><a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); deleteReminder(recordatorio, $index)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></a> <a class=\"btn btn-white btn-sm\" ng-click=\"$event.stopPropagation(); editReminder(recordatorio, $index)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></a></td></tr></tbody></table><div ng-if=\"show_pag_recfree\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div></div>");
$templateCache.put("app/recordatorios/libres/libres.detail.component.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-6\"><h2>{{action}} Recordatorio Libre</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>{{action}} Recordatorio Libre</strong></li></ol></div></div><br><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{action}} Recordatorio</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group\"><label>Resumen</label> <input class=\"form-control\" type=\"text\" name=\"nombre\" id=\"\" ng-model=\"form.nombre\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-3 form-group\"><label>Fecha</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"form.fecha_programada\" value=\"{{form.fecha_programada}}\" data-date-format=\"mm/dd/yyyy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-3 form-group\"><label>Hora</label><div uib-timepicker=\"\" ng-model=\"form.hora_programada\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"true\" ng-change=\"timeDate(form.hora_programada)\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group\"><label>Descripción de recordatorio</label> <textarea class=\"form-control\" ng-model=\"form.descr\" id=\"\" rows=\"5\"></textarea></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"save()\">Guardar</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-danger col-xs-12\" ng-click=\"cancel()\">Cancelar</button></div></div></div>");
$templateCache.put("app/recordatorios/libres/libres.show.component.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-6\"><h2>{{action}} Recordatorio Libre</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Información Recordatorio Libre</strong></li></ol></div></div><br><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{action}} Recordatorio</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-3 form-group\"><span class=\"blue-color\">Resumen:</span><div>{{ form.nombre }}</div></div><div class=\"col-xs-12 col-md-3 form-group\"><span class=\"blue-color\">Descripción:</span><div>{{ form.descr }}</div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12 form-group container-loader\" ng-if=\"loader\"><img src=\"../../assets/images/loader/blue_loader.gif\"></div></div><table class=\"table table-bordered table-hover\" ng-if=\"!show_comment\"><thead><tr><th>Ubicación / Tipo</th><th>Resumen</th><th>Recordatorio</th><th>Fecha programada</th><th>Hora programada</th><th>Estatus</th></tr></thead><tbody><tr ng-click=\"showReminder(recordatorio,$index)\"><td>Libre</td><td>{{ form.nombre}}</td><td>{{ form.descr}}</td><td>{{ form.fecha_programada | date: \'dd/MM/yyyy\': \'UTC\' }}</td><td>{{ form.hora_programada | date: \'HH:mm\' }}</td><td ng-class=\"{\'label-info\' : form.seen }\" ng-if=\"form.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !form.seen }\" ng-if=\"!form.seen\">No visto</td></tr></tbody></table><div ng-if=\"show_pag_task\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-info col-xs-12\" ng-click=\"vm.cargarRegistros()\">Recargar registros</button></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 form-group pull-right\"><button class=\"btn btn-danger col-xs-12\" ng-click=\"cancel()\">Cancelar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/recordatorios/table/recordatorios.table.component.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{ vm.pageTitle }}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li class=\"active\"><strong>Mis Recordatorios</strong></li></ol></div></div><br><div class=\"row col-xs-12\"><div class=\"col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"row\"><div class=\"col-xs-12\"><ul class=\"tab-group\"><li ng-class=\"{ \'active-group\': showMisrecordatorios }\" ng-click=\"show_section(1);vm.cargarRegistros(\'hoy\')\">MIS RECORDATORIOS (HOY)</li><li ng-class=\"{ \'active-group\': showMisrecordatoriosNo }\" ng-click=\"show_section(2);vm.cargarRegistros(\'pasados\')\">RECORDATORIOS PASADOS NO VISTOS</li><li ng-class=\"{ \'active-group\': showMisrecordatoriosSi }\" ng-click=\"show_section(3);vm.cargarRegistros(\'pasadosvistos\',1)\">RECORDATORIOS PASADOS VISTOS</li></ul></div></div><div class=\"ibox-content col-xs-12\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group pull-right\" ng-if=\"showMisrecordatoriosNo\"><button class=\"btn btn-success col-xs-12\" ng-click=\"showReminderAll()\">Seleccionar todos vistos</button></div><table class=\"table table-bordered table-hover\"><thead><tr><th>Ubicación / Tipo</th><th>Resumen</th><th>Recordatorio</th><th>Tipo de registro</th><th>Identificador</th><th>Fecha programada</th><th>Hora programada</th><th>Estatus</th></tr></thead><tbody><tr ng-repeat=\"recordatorio in vm.recordatorios track by $index\" ng-click=\"showReminder(recordatorio,$index)\"><td>{{ recordatorio.recordatorio.tipo_descr}}</td><td>{{ recordatorio.instancia.resumen}}</td><td>{{ recordatorio.instancia.recordatorio}}</td><td ng-if=\"recordatorio.recordatorio.tipo_descr != \'Libre\'\"><span ng-if=\"recordatorio.recordatorio.tipo !=1\">{{ recordatorio.record_model_descr}}</span><span ng-if=\"recordatorio.recordatorio.tipo ==1\">Automático</span></td><td ng-if=\"recordatorio.recordatorio.tipo_descr == \'Libre\'\">Libre</td><td>{{ recordatorio.instancia.identificador}}</td><td>{{ recordatorio.recordatorio.fecha_programada | date: \'dd/MM/yyyy\': \'UTC\' }}</td><td>{{ recordatorio.recordatorio.fecha_programada | date: \'HH:mm\' }}</td><td ng-class=\"{\'label-info\' : recordatorio.seen }\" ng-if=\"recordatorio.seen\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> Visto</td><td ng-class=\"{\'label-success\' : !recordatorio.seen }\" ng-if=\"!recordatorio.seen\">No visto</td></tr></tbody></table><div ng-if=\"show_pag_misrecsi && showMisrecordatoriosSi\" class=\"text-center hidden-xs hidden-sm\"><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-center\"><li ng-if=\"show_prev_block\" ng-click=\"previousBlockPages()\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\" ng-repeat=\"page in totalPages | slice:start:end\" ng-class=\"{\'active\': page === actual_page}\" ng-click=\"selectPage(page)\"><a class=\"page-link\">{{page}}</a></li><li ng-click=\"nextBlockPages()\" ng-if=\"totalPages.length > 5\"><a class=\"page-link\"><span><i class=\"glyphicon glyphicon-option-horizontal\"></i></span></a></li><li class=\"page-item\"><a class=\"page-link\" ng-click=\"lastPage()\" aria-label=\"Last\"><span aria-hidden=\"true\"><i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i></span> <span class=\"sr-only\">Last</span></a></li></ul></nav></div></div></div></div></div>");
$templateCache.put("app/reportes/estadistica/reporte.conservacion.html","<toaster-container></toaster-container><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12 col-md-9\"><h2>Reporte Estadístico</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"inicio.inicio\">Inicio</a></li><li><a>Reporte</a></li><li class=\"active\"><strong>Conservación</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros Primer Periodo</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row col-xs-12 col-sm-6 col-md-6 form-group\"><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Estatus</label> <span class=\"red-color\" ng-if=\"vm.form.recibos && period_select == 3\" title=\"Los estatus a considerar son: Pagado, Liquidado, Conciliado\">?</span><select class=\"js-example-basic-multiple form-control\" name=\"states[]\" multiple=\"multiple\" ng-model=\"select_status\" data-ng-options=\"status.name for status in vm.estatus | orderBy: \'name\' track by status.id\" ng-change=\"selectStatus(select_status)\"><option value=\"\"></option></select></div><div class=\"col-xs-12 col-sm-6 col-md-6 form-group\"><label>Presentar por:</label><select class=\"form-control\" ng-model=\"vm.form.group_by\" ng-options=\"group_by.name for group_by in vm.group_by track by group_by.id\" ng-change=\"changeGroupBy(vm.form.group_by)\"></select></div></div><div align=\"center\" class=\"row col-xs-12 col-sm-6 col-md-6 form-group\"><div class=\"col-xs-12 form-group\" align=\"center\"><label>Por:</label></div><div class=\"col-xs-12 col-sm-3 form-group\" align=\"center\"><label ng-class=\"{\'periodo-select\': selectData == \'1\'}\"><input type=\"radio\" ng-model=\"vm.form.selectTipo\" ng-click=\"selectPor(1)\" value=\"1\">Pólizas</label></div><div class=\"col-xs-12 col-sm-3 form-group\" align=\"center\"><label><input type=\"radio\" ng-model=\"vm.form.selectTipo\" ng-click=\"selectPor(2)\" value=\"2\">Recibos</label></div><div class=\"col-xs-12 col-sm-3 form-group\" align=\"center\"><label><input type=\"radio\" ng-model=\"vm.form.selectTipo\" ng-click=\"selectPor(3)\" value=\"3\">Fianzas</label></div><div class=\"col-xs-12 col-sm-3 form-group\" align=\"center\"><label><input type=\"radio\" ng-model=\"vm.form.selectTipo\" ng-click=\"selectPor(4)\" value=\"4\">Endosos</label></div></div><div align=\"center\" class=\"row col-xs-12 col-sm-6 col-md-6\"><div class=\"col-xs-12 form-group\" align=\"center\"><label>Periodo:</label></div><div class=\"col-xs-12 col-sm-4 form-group\" align=\"center\"><label ng-class=\"{\'periodo-select\': period_select == \'1\'}\"><input type=\"radio\" ng-model=\"period_select\" ng-click=\"selctPeriodo(period_select)\" value=\"1\">Vigencia</label></div><div class=\"col-xs-12 col-sm-4 form-group\" align=\"center\"><label><input type=\"radio\" ng-model=\"period_select\" ng-click=\"selctPeriodo(period_select)\" value=\"2\">Emisión</label> <span class=\"red-color\" ng-if=\"period_select == 2\" title=\"Se considerará la Fecha Creación\">?</span></div><div class=\"col-xs-12 col-sm-4 form-group\" align=\"center\"><label><input type=\"radio\" ng-model=\"period_select\" ng-click=\"selctPeriodo(period_select)\" value=\"3\">Pago</label></div><div class=\"col-xs-12 col-sm-6 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepickerer-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since\" value=\"{{vm.form.since}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until\" value=\"{{vm.form.until}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-primary pull-right ladda-button\" ng-click=\"getStadistics(1,1)\">Consultar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\" align=\"center\"><h5>Resultados Primer Periodo</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"panel-body table-over-y\"><div class=\"col-xs-12 text-center\" style=\"margin-bottom: 20px;\"><div class=\"panel panel-default headTables\"><h4 class=\"blue-color textHead\">Parámetros</h4><h5 class=\"textSecHead\"><span class=\"textSecHead2\" ng-repeat=\"est in parEst track by $index\">{{est}}</span> {{parPor}} {{by}} {{parPer}}<br><small style=\"color: #555;\">{{vm.form.since | date: \'dd/MM/yyyy\'}} al {{vm.form.until | date: \'dd/MM/yyyy\'}}</small></h5></div></div><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Presentación</th><th>Total Prima Neta</th><th>Total Prima total</th><th ng-if=\"vm.permiso_comisiones\">Total Comisión</th><th>Moneda</th><th>Registros</th></tr></thead><tbody><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 1 && rst.clave__clave && vm.form.polizas\"><td>{{ rst.clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 2 && rst.aseguradora__compania && vm.form.polizas\"><td>{{ rst.aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.aseguradora__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 3 && rst.contractor__full_name && vm.form.polizas\"><td>{{ rst.contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 4 && rst.ramo__ramo_name && vm.form.polizas\"><td>{{ rst.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td>{{ rst.ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 5 && rst.subramo__subramo_name && vm.form.polizas\"><td>{{ rst.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKPD track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKPU track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKPE track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>{{Euro}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas\"><td colspan=\"6\" align=\"center\"><b>Sucursal por Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.sucursal__id__count && vm.form.polizas\"><td>{{rst.sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas && (presentarPor.resultsOKPN || presentarPor.resultsOKPJ)\"><td colspan=\"6\" align=\"center\"><b>Sucursal por Contratantes</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKPN track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.contractor__sucursal__id__count && vm.form.polizas\"><td>{{rst.contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.poliza__clave__clave) && vm.form.recibos\"><td>{{ rst.poliza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.poliza__aseguradora__compania) && vm.form.recibos\"><td>{{ rst.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__aseguradora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos && (presentarPor.resultsOKR || presentarPor.resultsOKRJ)\"><td colspan=\"6\" align=\"center\"><b>Recibos por Contratante Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.poliza__contractor__full_name) && vm.form.recibos\"><td>{{ rst.poliza__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.fianza__clave__clave) && vm.form.recibos\"><td>{{ rst.fianza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.fianza__afianzadora__compania) && vm.form.recibos\"><td>{{ rst.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__afianzadora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos && (presentarPor.resultsOKRF || presentarPor.resultsOKRJF)\"><td colspan=\"6\" align=\"center\"><b>Recibos por Contratante Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.fianza__contractor__full_name) && vm.form.recibos\"><td>{{ rst.fianza__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.poliza__ramo__ramo_name) && vm.form.recibos\"><td>{{ rst.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.fianza__ramo__ramo_name) && vm.form.recibos\"><td>{{ rst.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.poliza__subramo__subramo_name) && vm.form.recibos\"><td>{{ rst.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.fianza__subramo__subramo_name) && vm.form.recibos\"><td>{{ rst.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__subramo__subramo_code__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos && presentarPor.resultsOKR\"><td colspan=\"6\" align=\"center\"><b>Recibos por Moneda Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRD track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRU track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRE track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos && presentarPor.resultsOKRF\"><td colspan=\"6\" align=\"center\"><b>Recibos por Moneda Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRDF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRUF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKREF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.poliza__sucursal__id__count) && vm.form.recibos\"><td>{{poliza__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos && presentarPor.resultsOKRN\"><td colspan=\"6\" align=\"center\"><b>Recibos por Sucursal Póliza - Contratante</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRJ track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.poliza__contractor__sucursal__id__count) && vm.form.recibos\"><td>{{poliza__contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos && presentarPor.resultsOKRN\"><td colspan=\"6\" align=\"center\"><b>Recibos por Sucursal Fianza - Contratante</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRJF track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.fianza__contractor__sucursal__id__count) && vm.form.recibos\"><td>{{fianza__contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 1 && rst.clave__clave && vm.form.fianzas\"><td>{{ rst.clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 2 && rst.afianzadora__compania && vm.form.fianzas\"><td>{{ rst.afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.afianzadora__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 3 && rst.contractor__full_name && vm.form.fianzas\"><td>{{ rst.contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 4 && rst.ramo__ramo_name && vm.form.fianzas\"><td>{{ rst.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 5 && rst.subramo__subramo_name && vm.form.fianzas\"><td>{{ rst.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKFD track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKFU track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKFE track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.contractor__sucursal__id__count && vm.form.fianzas\"><td>{{contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.policy__clave__clave) && vm.form.addEndosos\"><td>{{ rst.policy__clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.policy__aseguradora__compania) && vm.form.addEndosos\"><td>{{ rst.policy__aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__aseguradora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos && (presentarPor.resultsOKE || presentarPor.resultsOKEJ)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Contratante Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.policy__contractor__full_name) && vm.form.addEndosos\"><td>{{ rst.policy__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEF track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.fianza__clave__clave) && vm.form.addEndosos\"><td>{{ rst.fianza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.fianza__afianzadora__compania) && vm.form.addEndosos\"><td>{{ rst.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__afianzadora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos && (presentarPor.resultsOKEF || presentarPor.resultsOKEJF)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Contratante Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.policy__ramo__ramo_name) && vm.form.addEndosos\"><td>{{ rst.policy__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEF track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.fianza__ramo__ramo_name) && vm.form.addEndosos\"><td>{{ rst.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.policy__subramo__subramo_name) && vm.form.addEndosos\"><td>{{ rst.policy__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEF track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.fianza__subramo__subramo_name) && vm.form.addEndosos\"><td>{{ rst.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__subramo__subramo_code__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos && (presentarPor.resultsOKE || presentarPor.resultsOKED || presentarPor.resultsOKEU || presentarPor.resultsOKEE)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Moneda Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKED track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKU track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEE track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos && (presentarPor.resultsOKEF || presentarPor.resultsOKEFD || presentarPor.resultsOKFU || presentarPor.resultsOKEEF)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Moneda Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEFD track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKFU track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEEF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr></tbody></table></div></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-secondary pull-right\" ng-click=\"makeComparation(2)\" style=\"margin: 5px 10px;\">Comparar</button></div></div></div><div class=\"wrapper wrapper-content animated fadeIn ng-scope\" ng-if=\"procComparar\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Filtros Segundo Periodo</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div align=\"center\" class=\"row col-xs-12 col-sm-6 col-md-6\"><div class=\"col-xs-12 form-group\" align=\"center\"><label>Periodo:</label></div><div class=\"col-xs-12 col-sm-6 form-group\" align=\"center\"><label>Desde:</label><div class=\"datepickerer-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"startDate2\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.since2\" value=\"{{vm.form.since2}}\" ng-change=\"vm.options.changeSince()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"col-xs-12 col-sm-6 form-group\" align=\"center\"><label>Hasta:</label><div class=\"datepicker-me input-group date\" data-provide=\"datepicker\"><input type=\"text\" name=\"endingDate2\" class=\"width-100 text-align-center form-control\" ng-model=\"vm.form.until2\" value=\"{{vm.form.until2}}\" ng-change=\"vm.changeUntil()\" data-date-format=\"mm/dd/yyyy HH:mm:ss\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-primary pull-right ladda-button2\" ng-click=\"getStadistics2(1,1)\">Procesar</button></div></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"procComparar\"><div class=\"ibox-title\" align=\"center\"><h5>Resultados Segundo Periodo</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\" style=\"display: none;\"><div class=\"panel-body table-over-y\"><div class=\"col-xs-12 text-center\" style=\"margin-bottom: 20px;\"><div class=\"panel panel-default headTables\"><h4 class=\"blue-color textHead\">Parámetros Segundo Periodo</h4><h5 class=\"textSecHead\"><span class=\"textSecHead2\" ng-repeat=\"est in parEst track by $index\">{{est}}</span> {{parPor}} {{by}} {{parPer}}<br><small style=\"color: #555;\">{{vm.form.since2 | date: \'dd/MM/yyyy\'}} al {{vm.form.until2 | date: \'dd/MM/yyyy\'}}</small></h5></div></div><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Presentación</th><th>Total Prima Neta</th><th>Total Prima total</th><th>Total Comisión</th><th>Moneda</th><th>Registros</th></tr></thead><tbody><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && rst.clave__clave && vm.form.polizas\"><td>{{ rst.clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && rst.aseguradora__compania && vm.form.polizas\"><td>{{ rst.aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.aseguradora__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && rst.contractor__full_name && vm.form.polizas\"><td>{{ rst.contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && rst.ramo__ramo_name && vm.form.polizas\"><td>{{ rst.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && rst.subramo__subramo_name && vm.form.polizas\"><td>{{ rst.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKPD_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKPU_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKPE track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>{{Euro}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas\"><td colspan=\"6\" align=\"center\"><b>Sucursal por Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.sucursal__id__count && vm.form.polizas\"><td>{{rst.sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas && (presentarPor2.resultsOKPN_ || presentarPor2.resultsOKPJ_)\"><td colspan=\"6\" align=\"center\"><b>Sucursal por Contratantes</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKPN_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.contractor__sucursal__id__count && vm.form.polizas\"><td>{{rst.contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.poliza__clave__clave) && vm.form.recibos\"><td>{{ rst.poliza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.poliza__aseguradora__compania) && vm.form.recibos\"><td>{{ rst.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__aseguradora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos && (presentarPor2.resultsOKR_ || presentarPor2.resultsOKRJ_)\"><td colspan=\"6\" align=\"center\"><b>Recibos por Contratante Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.poliza__contractor__full_name) && vm.form.recibos\"><td>{{ rst.poliza__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.fianza__clave__clave) && vm.form.recibos\"><td>{{ rst.fianza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.fianza__afianzadora__compania) && vm.form.recibos\"><td>{{ rst.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__afianzadora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos && (presentarPor2.resultsOKRF_ || presentarPor2.resultsOKRJF_)\"><td colspan=\"6\" align=\"center\"><b>Recibos por Contratante Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.fianza__contractor__full_name) && vm.form.recibos\"><td>{{ rst.fianza__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.poliza__ramo__ramo_name) && vm.form.recibos\"><td>{{ rst.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.fianza__ramo__ramo_name) && vm.form.recibos\"><td>{{ rst.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.poliza__subramo__subramo_name) && vm.form.recibos\"><td>{{ rst.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.fianza__subramo__subramo_name) && vm.form.recibos\"><td>{{ rst.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__subramo__subramo_code__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos && presentarPor2.resultsOKR_\"><td colspan=\"6\" align=\"center\"><b>Recibos por Moneda Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRD_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRU_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRE_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos && presentarPor2.resultsOKRF_\"><td colspan=\"6\" align=\"center\"><b>Recibos por Moneda Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRDF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRUF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKREF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.poliza__sucursal__id__count) && vm.form.recibos\"><td>{{poliza__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos && presentarPor2.resultsOKRN_\"><td colspan=\"6\" align=\"center\"><b>Recibos por Sucursal Póliza - Contratante</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRJ_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.poliza__contractor__sucursal__id__count) && vm.form.recibos\"><td>{{poliza__contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos && presentarPor2.resultsOKRN_\"><td colspan=\"6\" align=\"center\"><b>Recibos por Sucursal Fianza - Contratante</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRJF_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.fianza__contractor__sucursal__id__count) && vm.form.recibos\"><td>{{fianza__contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && rst.clave__clave && vm.form.fianzas\"><td>{{ rst.clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && rst.afianzadora__compania && vm.form.fianzas\"><td>{{ rst.afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.afianzadora__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && rst.contractor__full_name && vm.form.fianzas\"><td>{{ rst.contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && rst.ramo__ramo_name && vm.form.fianzas\"><td>{{ rst.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && rst.subramo__subramo_name && vm.form.fianzas\"><td>{{ rst.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKFD_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKFU_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKFE_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.contractor__sucursal__id__count && vm.form.fianzas\"><td>{{contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.policy__clave__clave) && vm.form.addEndosos\"><td>{{ rst.policy__clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.policy__aseguradora__compania) && vm.form.addEndosos\"><td>{{ rst.policy__aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__aseguradora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos && (presentarPor2.resultsOKE_ || presentarPor2.resultsOKEJ_)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Contratante Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.policy__contractor__full_name) && vm.form.addEndosos\"><td>{{ rst.policy__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEF_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.fianza__clave__clave) && vm.form.addEndosos\"><td>{{ rst.fianza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.fianza__afianzadora__compania) && vm.form.addEndosos\"><td>{{ rst.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__afianzadora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos && (presentarPor2.resultsOKEF_ || presentarPor2.resultsOKEJF_)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Contratante Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEF_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.fianza__contractor__full_name) && vm.form.addEndosos\"><td>{{ rst.fianza__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.policy__ramo__ramo_name) && vm.form.addEndosos\"><td>{{ rst.policy__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEF_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.fianza__ramo__ramo_name) && vm.form.addEndosos\"><td>{{ rst.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.policy__subramo__subramo_name) && vm.form.addEndosos\"><td>{{ rst.policy__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEF_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.fianza__subramo__subramo_name) && vm.form.addEndosos\"><td>{{ rst.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__subramo__subramo_code__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos && (presentarPor2.resultsOKE_ || presentarPor2.resultsOKED_ || presentarPor2.resultsOKEU_ || presentarPor2.resultsOKEE_)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Moneda Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKED_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKU_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEE_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos && (presentarPor2.resultsOKEF_ || presentarPor2.resultsOKEFD_ || presentarPor2.resultsOKFU_ || presentarPor2.resultsOKEEF_)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Moneda Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEFD_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKFU_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEEF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group\"><div class=\"col-xs-6 col-sm-6 col-lg-6 col-md-6\" align=\"center\"><div class=\"col-xs-12 text-center\" style=\"margin-bottom: 20px;\"><div class=\"panel panel-default headTables\"><h4 class=\"blue-color textHead\">Parámetros Primer Periodo</h4><h5 class=\"textSecHead\"><span class=\"textSecHead2\" ng-repeat=\"est in parEst track by $index\">{{est}}</span> {{parPor}} {{by}} {{parPer}}<br><small style=\"color: #555;\">{{vm.form.since | date: \'dd/MM/yyyy\'}} al {{vm.form.until | date: \'dd/MM/yyyy\'}}</small></h5></div></div><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Presentación</th><th>Total Prima Neta</th><th>Total Prima total</th><th>Total Comisión</th><th>Moneda</th><th>Registros</th></tr></thead><tbody><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 1 && rst.clave__clave && vm.form.polizas\"><td>{{ rst.clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 2 && rst.aseguradora__compania && vm.form.polizas\"><td>{{ rst.aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.aseguradora__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 3 && rst.contractor__full_name && vm.form.polizas\"><td>{{ rst.contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 4 && rst.ramo__ramo_name && vm.form.polizas\"><td>{{ rst.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 5 && rst.subramo__subramo_name && vm.form.polizas\"><td>{{ rst.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKPD track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKPU track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKPE track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>{{Euro}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas\"><td colspan=\"6\" align=\"center\"><b>Sucursal por Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKP track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.sucursal__id__count && vm.form.polizas\"><td>{{rst.sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas && (presentarPor.resultsOKPN || presentarPor.resultsOKPJ)\"><td colspan=\"6\" align=\"center\"><b>Sucursal por Contratantes</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKPN track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.contractor__sucursal__id__count && vm.form.polizas\"><td>{{rst.contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.poliza__clave__clave) && vm.form.recibos\"><td>{{ rst.poliza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.poliza__aseguradora__compania) && vm.form.recibos\"><td>{{ rst.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__aseguradora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos && (presentarPor.resultsOKR || presentarPor.resultsOKRJ)\"><td colspan=\"6\" align=\"center\"><b>Recibos por Contratante Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.poliza__contractor__full_name) && vm.form.recibos\"><td>{{ rst.poliza__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.fianza__clave__clave) && vm.form.recibos\"><td>{{ rst.fianza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.fianza__afianzadora__compania) && vm.form.recibos\"><td>{{ rst.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__afianzadora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos && (presentarPor.resultsOKRF || presentarPor.resultsOKRJF)\"><td colspan=\"6\" align=\"center\"><b>Recibos por Contratante Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.fianza__contractor__full_name) && vm.form.recibos\"><td>{{ rst.fianza__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.poliza__ramo__ramo_name) && vm.form.recibos\"><td>{{ rst.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.fianza__ramo__ramo_name) && vm.form.recibos\"><td>{{ rst.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.poliza__subramo__subramo_name) && vm.form.recibos\"><td>{{ rst.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.fianza__subramo__subramo_name) && vm.form.recibos\"><td>{{ rst.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__subramo__subramo_code__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos && presentarPor.resultsOKR\"><td colspan=\"6\" align=\"center\"><b>Recibos por Moneda Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRD track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRU track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRE track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos && presentarPor.resultsOKRF\"><td colspan=\"6\" align=\"center\"><b>Recibos por Moneda Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRDF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRUF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKREF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKR track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.poliza__sucursal__id__count) && vm.form.recibos\"><td>{{poliza__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos && presentarPor.resultsOKRN\"><td colspan=\"6\" align=\"center\"><b>Recibos por Sucursal Póliza - Contratante</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRJ track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.poliza__contractor__sucursal__id__count) && vm.form.recibos\"><td>{{poliza__contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos && presentarPor.resultsOKRN\"><td colspan=\"6\" align=\"center\"><b>Recibos por Sucursal Fianza - Contratante</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKRJF track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.fianza__contractor__sucursal__id__count) && vm.form.recibos\"><td>{{fianza__contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 1 && rst.clave__clave && vm.form.fianzas\"><td>{{ rst.clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 2 && rst.afianzadora__compania && vm.form.fianzas\"><td>{{ rst.afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.afianzadora__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 3 && rst.contractor__full_name && vm.form.fianzas\"><td>{{ rst.contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 4 && rst.ramo__ramo_name && vm.form.fianzas\"><td>{{ rst.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 5 && rst.subramo__subramo_name && vm.form.fianzas\"><td>{{ rst.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKFD track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKFU track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKFE track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKF track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.contractor__sucursal__id__count && vm.form.fianzas\"><td>{{contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.policy__clave__clave) && vm.form.addEndosos\"><td>{{ rst.policy__clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.policy__aseguradora__compania) && vm.form.addEndosos\"><td>{{ rst.policy__aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__aseguradora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos && (presentarPor.resultsOKE || presentarPor.resultsOKEJ)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Contratante Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.policy__contractor__full_name) && vm.form.addEndosos\"><td>{{ rst.policy__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEF track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.fianza__clave__clave) && vm.form.addEndosos\"><td>{{ rst.fianza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.fianza__afianzadora__compania) && vm.form.addEndosos\"><td>{{ rst.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__afianzadora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos && (presentarPor.resultsOKEF || presentarPor.resultsOKEJF)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Contratante Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEF track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.fianza__contractor__full_name) && vm.form.addEndosos\"><td>{{ rst.fianza__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.policy__ramo__ramo_name) && vm.form.addEndosos\"><td>{{ rst.policy__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEF track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.fianza__ramo__ramo_name) && vm.form.addEndosos\"><td>{{ rst.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.policy__subramo__subramo_name) && vm.form.addEndosos\"><td>{{ rst.policy__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEF track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.fianza__subramo__subramo_name) && vm.form.addEndosos\"><td>{{ rst.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__subramo__subramo_code__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos && (presentarPor.resultsOKE || presentarPor.resultsOKED || presentarPor.resultsOKEU || presentarPor.resultsOKEE)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Moneda Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKE track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKED track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKU track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEE track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos && (presentarPor.resultsOKEF || presentarPor.resultsOKEFD || presentarPor.resultsOKFU || presentarPor.resultsOKEEF)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Moneda Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEFD track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKFU track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor.resultsOKEEF track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr></tbody></table></div><div class=\"col-xs-6 col-sm-6 col-lg-6 col-md-6\" align=\"center\"><div class=\"col-xs-12 text-center\" style=\"margin-bottom: 20px;\"><div class=\"panel panel-default headTables\"><h4 class=\"blue-color textHead\">Parámetros Segundo Periodo</h4><h5 class=\"textSecHead\"><span class=\"textSecHead2\" ng-repeat=\"est in parEst track by $index\">{{est}}</span> {{parPor}} {{by}} {{parPer}}<br><small style=\"color: #555;\">{{vm.form.since2 | date: \'dd/MM/yyyy\'}} al {{vm.form.until2 | date: \'dd/MM/yyyy\'}}</small></h5></div></div><table class=\"table table-bordered table-hover table-width hidden-xs hidden-sm\"><thead><tr><th>Presentación</th><th>Total Prima Neta</th><th>Total Prima total</th><th>Total Comisión</th><th>Moneda</th><th>Registros</th></tr></thead><tbody><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Pólizas {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && rst.clave__clave && vm.form.polizas\"><td>{{ rst.clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && rst.aseguradora__compania && vm.form.polizas\"><td>{{ rst.aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.aseguradora__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && rst.contractor__full_name && vm.form.polizas\"><td>{{ rst.contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && rst.ramo__ramo_name && vm.form.polizas\"><td>{{ rst.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && rst.subramo__subramo_name && vm.form.polizas\"><td>{{ rst.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKPD_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKPU_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKPE track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.polizas\"><td>{{Euro}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas\"><td colspan=\"6\" align=\"center\"><b>Sucursal por Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKP_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.sucursal__id__count && vm.form.polizas\"><td>{{rst.sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.polizas && (presentarPor2.resultsOKPN_ || presentarPor2.resultsOKPJ_)\"><td colspan=\"6\" align=\"center\"><b>Sucursal por Contratantes</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKPN_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.contractor__sucursal__id__count && vm.form.polizas\"><td>{{rst.contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Recibos {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.poliza__clave__clave) && vm.form.recibos\"><td>{{ rst.poliza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.poliza__aseguradora__compania) && vm.form.recibos\"><td>{{ rst.poliza__aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__aseguradora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos && (presentarPor2.resultsOKR_ || presentarPor2.resultsOKRJ_)\"><td colspan=\"6\" align=\"center\"><b>Recibos por Contratante Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.poliza__contractor__full_name) && vm.form.recibos\"><td>{{ rst.poliza__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.fianza__clave__clave) && vm.form.recibos\"><td>{{ rst.fianza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.fianza__afianzadora__compania) && vm.form.recibos\"><td>{{ rst.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__afianzadora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.recibos && (presentarPor2.resultsOKRF_ || presentarPor2.resultsOKRJF_)\"><td colspan=\"6\" align=\"center\"><b>Recibos por Contratante Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.fianza__contractor__full_name) && vm.form.recibos\"><td>{{ rst.fianza__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.poliza__ramo__ramo_name) && vm.form.recibos\"><td>{{ rst.poliza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.fianza__ramo__ramo_name) && vm.form.recibos\"><td>{{ rst.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.poliza__subramo__subramo_name) && vm.form.recibos\"><td>{{ rst.poliza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.fianza__subramo__subramo_name) && vm.form.recibos\"><td>{{ rst.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__subramo__subramo_code__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos && presentarPor2.resultsOKR_\"><td colspan=\"6\" align=\"center\"><b>Recibos por Moneda Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRD_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRU_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRE_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.poliza__f_currency__count) && vm.form.recibos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.recibos && presentarPor2.resultsOKRF_\"><td colspan=\"6\" align=\"center\"><b>Recibos por Moneda Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRDF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRUF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKREF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.recibos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKR_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.poliza__sucursal__id__count) && vm.form.recibos\"><td>{{poliza__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos && presentarPor2.resultsOKRN_\"><td colspan=\"6\" align=\"center\"><b>Recibos por Sucursal Póliza - Contratante</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRJ_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.poliza__contractor__sucursal__id__count) && vm.form.recibos\"><td>{{poliza__contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.poliza__contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.recibos && presentarPor2.resultsOKRN_\"><td colspan=\"6\" align=\"center\"><b>Recibos por Sucursal Fianza - Contratante</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKRJF_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && (rst.fianza__contractor__sucursal__id__count) && vm.form.recibos\"><td>{{fianza__contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.prima_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.prima_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.fianzas\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Fianzas {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && rst.clave__clave && vm.form.fianzas\"><td>{{ rst.clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && rst.afianzadora__compania && vm.form.fianzas\"><td>{{ rst.afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.afianzadora__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && rst.contractor__full_name && vm.form.fianzas\"><td>{{ rst.contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && rst.ramo__ramo_name && vm.form.fianzas\"><td>{{ rst.ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && rst.subramo__subramo_name && vm.form.fianzas\"><td>{{ rst.subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKFD_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKFU_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKFE_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && rst.f_currency__count && vm.form.fianzas\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKF_ track by $index\" ng-if=\"vm.form.group_by.id == 7 && rst.contractor__sucursal__id__count && vm.form.fianzas\"><td>{{contractor__sucursal__sucursal_name}}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.contractor__sucursal__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 1 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 2 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 4 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 5 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-if=\"vm.form.group_by.id == 7 && vm.form.addEndosos\"><td colspan=\"6\" align=\"center\" bgcolor=\"#AFE0EB\"><b>Endosos {{by}}</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.policy__clave__clave) && vm.form.addEndosos\"><td>{{ rst.policy__clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.policy__aseguradora__compania) && vm.form.addEndosos\"><td>{{ rst.policy__aseguradora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__aseguradora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos && (presentarPor2.resultsOKE_ || presentarPor2.resultsOKEJ_)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Contratante Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.policy__contractor__full_name) && vm.form.addEndosos\"><td>{{ rst.policy__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEF_ track by $index\" ng-if=\"vm.form.group_by.id == 1 && (rst.fianza__clave__clave) && vm.form.addEndosos\"><td>{{ rst.fianza__clave__clave }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__clave__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 2 && (rst.fianza__afianzadora__compania) && vm.form.addEndosos\"><td>{{ rst.fianza__afianzadora__compania }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__afianzadora__id__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 3 && vm.form.addEndosos && (presentarPor2.resultsOKEF_ || presentarPor2.resultsOKEJF_)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Contratante Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEF_ track by $index\" ng-if=\"vm.form.group_by.id == 3 && (rst.fianza__contractor__full_name) && vm.form.addEndosos\"><td>{{ rst.fianza__contractor__full_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__contractor__id__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.policy__ramo__ramo_name) && vm.form.addEndosos\"><td>{{ rst.policy__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEF_ track by $index\" ng-if=\"vm.form.group_by.id == 4 && (rst.fianza__ramo__ramo_name) && vm.form.addEndosos\"><td>{{ rst.fianza__ramo__ramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__ramo__ramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.policy__subramo__subramo_name) && vm.form.addEndosos\"><td>{{ rst.policy__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__subramo__subramo_code__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEF_ track by $index\" ng-if=\"vm.form.group_by.id == 5 && (rst.fianza__subramo__subramo_name) && vm.form.addEndosos\"><td>{{ rst.fianza__subramo__subramo_name }}</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__subramo__subramo_code__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos && (presentarPor2.resultsOKE_ || presentarPor2.resultsOKED_ || presentarPor2.resultsOKEU_ || presentarPor2.resultsOKEE_)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Moneda Pólizas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKE_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKED_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKU_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEE_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.policy__f_currency__count) && vm.form.addEndosos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.policy__f_currency__count }}</td></tr><tr ng-if=\"vm.form.group_by.id == 6 && vm.form.addEndosos && (presentarPor2.resultsOKEF_ || presentarPor2.resultsOKEFD_ || presentarPor2.resultsOKFU_ || presentarPor2.resultsOKEEF_)\"><td colspan=\"6\" align=\"center\"><b>Endosos por Moneda Fianzas</b></td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Pesos</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEFD_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Dólares</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKFU_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>UDI</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr><tr ng-repeat=\"rst in presentarPor2.resultsOKEEF_ track by $index\" ng-if=\"vm.form.group_by.id == 6 && (rst.fianza__f_currency__count) && vm.form.addEndosos\"><td>Euro</td><td>${{ vm.formatearNumero(rst.p_neta__sum) }}</td><td>${{ vm.formatearNumero(rst.p_total__sum) }}</td><td ng-if=\"vm.permiso_comisiones\">${{ vm.formatearNumero(rst.comision__sum) }}</td><td><span ng-if=\"rst.f_currency==1\">Pesos</span> <span ng-if=\"rst.f_currency==2\">Dólar</span> <span ng-if=\"rst.f_currency==3\">UDI</span> <span ng-if=\"rst.f_currency==4\">Euro</span></td><td>{{ rst.fianza__f_currency__count }}</td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"presentarPor && presentarPor2\"><button class=\"btn btn-info pull-right ladda-button3\" ng-click=\"makeComparationFinal(2)\" style=\"margin: 60px 10px;\">Gráfica</button></div><div class=\"ibox float-e-margins\" ng-if=\"makeComparationFin\"><div class=\"row container-chart\"><div class=\"col-xs-12\" align=\"center\"><div class=\"panel panel-default headTables\"><h4 class=\"blue-color textHead\">Parámetros Primer Periodo</h4><h5 class=\"textSecHead\"><span class=\"textSecHead2\" ng-repeat=\"est in parEst track by $index\">{{est}}</span> {{parPor}} {{by}} {{parPer}}<br><small style=\"color: #555;\">{{vm.form.since | date: \'dd/MM/yyyy\'}} al {{vm.form.until | date: \'dd/MM/yyyy\'}}</small></h5></div></div></div><div class=\"row col-xs-12\"><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"labels\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>{{by}}:</b></span><div align=\"center\" ng-repeat=\"dt in labels track by $index\"><span class=\"border-bottom\">{{dt}}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"data\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total P.N. %:</b></span><div align=\"center\" ng-repeat=\"dtN in data track by $index\"><span class=\"border-bottom border-right border-left\">{{dtN}} %</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"dataT\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total P.T. %:</b></span><div align=\"center\" ng-repeat=\"dtT in dataT track by $index\"><span class=\"border-bottom border-right border-left\">{{dtT}} %</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"dataC\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total Comisión %:</b></span><div align=\"center\" ng-repeat=\"dtC in dataC track by $index\"><span class=\"border-bottom border-right border-left\">{{dtC}} %</span></div></div></div><br><hr><div class=\"col-xs-4\"><label ng-if=\"vm.form.polizas\"><b>Pólizas {{by}} (Prima Neta % )</b></label> <label ng-if=\"vm.form.recibos\"><b>Recibos {{by}} (Prima Neta % )</b></label> <label ng-if=\"vm.form.fianzas\"><b>Fianzas {{by}} (Prima Neta % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos {{by}} (Prima Neta % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"data\" chart-labels=\"labels\" chart-options=\"options\" chart-legend=\"data\" chart-colours=\"colours\" legend=\"true\" ng-if=\"data.length > 0\"></canvas></div><div class=\"col-xs-4\"><label ng-if=\"vm.form.polizas\"><b>Pólizas {{by}} (Prima Total % )</b></label> <label ng-if=\"vm.form.recibos\"><b>Recibos {{by}} (Prima Total % )</b></label> <label ng-if=\"vm.form.fianzas\"><b>Fianzas {{by}} (Prima Total % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos {{by}} (Prima Total % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"dataT\" chart-labels=\"labels\" chart-options=\"options\" chart-legend=\"dataT\" chart-colours=\"colours\" ng-if=\"dataT.length > 0\"></canvas></div><div class=\"col-xs-4\"><label ng-if=\"vm.form.polizas\"><b>Pólizas {{by}} (Comisión % )</b></label> <label ng-if=\"vm.form.recibos\"><b>Recibos {{by}} (Comisión % )</b></label> <label ng-if=\"vm.form.fianzas\"><b>Fianzas {{by}} (Comisión % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos {{by}} (Comisión % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"dataC\" chart-labels=\"labels\" chart-options=\"options\" chart-legend=\"dataC\" chart-colours=\"colours\" ng-if=\"dataC.length > 0\"></canvas></div><br><br><br><hr><div class=\"row col-xs-12\" ng-if=\"((vm.form.recibos && vm.form.group_by.id == 3) || (vm.form.addEndosos && vm.form.group_by.id == 3))\"><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"labelsF\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>{{by}} de Fianza:</b></span><div align=\"center\" ng-repeat=\"dtF in labelsF track by $index\"><span class=\"border-bottom border-right border-left\">{{dtF}}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"dataF\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total P.N. %:</b></span><div align=\"center\" ng-repeat=\"dtNF in dataF track by $index\"><span class=\"border-bottom border-right border-left\">{{dtNF}} %</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"dataTF\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total P.T. %:</b></span><div align=\"center\" ng-repeat=\"dtTF in dataTF track by $index\"><span class=\"border-bottom border-right border-left\">{{dtTF}} %</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"dataCF\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total Comisión %:</b></span><div align=\"center\" ng-repeat=\"dtCF in dataCF track by $index\"><span class=\"border-bottom border-right border-left\">{{dtCF}} %</span></div></div></div><div ng-if=\"((vm.form.recibos && vm.form.group_by.id == 3) || (vm.form.addEndosos && vm.form.group_by.id == 3))\"><div class=\"col-xs-4\"><label ng-if=\"vm.form.recibos\"><b>Recibos Contratante Fianza (Prima Neta % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos Contratante Fianza (Prima Neta % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"dataF\" chart-labels=\"labelsF\" chart-options=\"options\" chart-legend=\"dataF\" chart-colours=\"colours\"></canvas></div><div class=\"col-xs-4\"><label ng-if=\"vm.form.recibos\"><b>Recibos Contratante Fianza (Prima Total % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos Contratante Fianza (Prima Total % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"dataTF\" chart-labels=\"labelsF\" chart-options=\"options\" chart-legend=\"dataTF\" chart-colours=\"colours\"></canvas></div><div class=\"col-xs-4\"><label ng-if=\"vm.form.recibos\"><b>Recibos Contratante Fianza (Comisión % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos Contratante Fianza (Comisión % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"dataCF\" chart-labels=\"labelsF\" chart-options=\"options\" chart-legend=\"dataCF\" chart-colours=\"colours\"></canvas></div></div></div></div><div class=\"ibox float-e-margins\" ng-if=\"makeComparationFin\"><div class=\"row container-chart\"><div class=\"col-xs-12\" align=\"center\"><div class=\"panel panel-default headTables\"><h4 class=\"blue-color textHead\">Parámetros Segundo Periodo</h4><h5 class=\"textSecHead\"><span class=\"textSecHead2\" ng-repeat=\"est in parEst track by $index\">{{est}}</span> {{parPor}} {{by}} {{parPer}}<br><small style=\"color: #555;\">{{vm.form.since2 | date: \'dd/MM/yyyy\'}} al {{vm.form.until2 | date: \'dd/MM/yyyy\'}}</small></h5></div></div></div><div class=\"row col-xs-12\"><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"labels2\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>{{by}}:</b></span><div align=\"center\" ng-repeat=\"dt in labels2 track by $index\"><span class=\"border-bottom border-right border-left\">{{dt}}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"data2\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total P.N. %:</b></span><div align=\"center\" ng-repeat=\"dtN in data2 track by $index\"><span class=\"border-bottom border-right border-left\">{{dtN}} %</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"dataT2\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total P.T. %:</b></span><div align=\"center\" ng-repeat=\"dtT in dataT2 track by $index\"><span class=\"border-bottom border-right border-left\">{{dtT}} %</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"dataC2\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total Comisión %:</b></span><div align=\"center\" ng-repeat=\"dtC in dataC2 track by $index\"><span class=\"border-bottom border-right border-left\">{{dtC}} %</span></div></div></div><div class=\"col-xs-4\"><label ng-if=\"vm.form.polizas\"><b>Pólizas {{by}} (Prima Neta % )</b></label> <label ng-if=\"vm.form.recibos\"><b>Recibos {{by}} (Prima Neta % )</b></label> <label ng-if=\"vm.form.fianzas\"><b>Fianzas {{by}} (Prima Neta % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos {{by}} (Prima Neta % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"data2\" chart-labels=\"labels2\" chart-options=\"options\" chart-legend=\"data2\" chart-colours=\"colours\"></canvas></div><div class=\"col-xs-4\"><label ng-if=\"vm.form.polizas\"><b>Pólizas {{by}} (Prima Total % )</b></label> <label ng-if=\"vm.form.recibos\"><b>Recibos {{by}} (Prima Total % )</b></label> <label ng-if=\"vm.form.fianzas\"><b>Fianzas {{by}} (Prima Total % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos {{by}} (Prima Total % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"dataT2\" chart-labels=\"labels2\" chart-options=\"options\" chart-legend=\"dataT2\" chart-colours=\"colours\"></canvas></div><div class=\"col-xs-4\"><label ng-if=\"vm.form.polizas\"><b>Pólizas {{by}} (Comisión % )</b></label> <label ng-if=\"vm.form.recibos\"><b>Recibos {{by}} (Comisión % )</b></label> <label ng-if=\"vm.form.fianzas\"><b>Fianzas {{by}} (Comisión % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos {{by}} (Comisión % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"dataC2\" chart-labels=\"labels2\" chart-options=\"options\" chart-legend=\"dataC2\" chart-colours=\"colours\"></canvas></div><br><br><br><hr><div class=\"row col-xs-12\" ng-if=\"((vm.form.recibos && vm.form.group_by.id == 3) || (vm.form.addEndosos && vm.form.group_by.id == 3))\"><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"labels2F\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>{{by}} de Fianza:</b></span><div align=\"center\" ng-repeat=\"dtF2 in labels2F track by $index\"><span class=\"border-bottom border-right border-left\">{{dtF2}}</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"data2F\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total P.N. %:</b></span><div align=\"center\" ng-repeat=\"dtNF2 in data2F track by $index\"><span class=\"border-bottom border-right border-left\">{{dtNF2}} %</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"dataT2F\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total P.T. %:</b></span><div align=\"center\" ng-repeat=\"dtTF2 in dataT2F track by $index\"><span class=\"border-bottom border-right border-left\">{{dtTF2}} %</span></div></div><div class=\"col-xs-12 col-md-6 col-md-3 col-sm-3 form-group\" align=\"center\" ng-if=\"dataC2F\"><span class=\"blue-color border-bottom border-right border-left\" align=\"center\"><b>Total Comisión %:</b></span><div align=\"center\" ng-repeat=\"dtCF2 in dataC2F track by $index\"><span class=\"border-bottom border-right border-left\">{{dtCF2}} %</span></div></div></div><div ng-if=\"((vm.form.recibos && vm.form.group_by.id == 3) || (vm.form.addEndosos && vm.form.group_by.id == 3))\"><div class=\"col-xs-4\"><label ng-if=\"vm.form.recibos\"><b>Recibos por Contratante Fianza (Prima Neta % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos por Contratante Fianza (Prima Neta % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"data2F\" chart-labels=\"labels2F\" chart-options=\"options\" chart-legend=\"data2F\" chart-colours=\"colours\"></canvas></div><div class=\"col-xs-4\"><label ng-if=\"vm.form.recibos\"><b>Recibos por Contratante Fianza (Prima Total % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos por Contratante Fianza (Prima Total % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"dataT2F\" chart-labels=\"labels2F\" chart-options=\"options\" chart-legend=\"dataT2F\" chart-colours=\"colours\"></canvas></div><div class=\"col-xs-4\"><label ng-if=\"vm.form.recibos\"><b>Recibos por Contratante Fianza (Comisión % )</b></label> <label ng-if=\"vm.form.addEndosos\"><b>Endosos por Contratante Fianza (Comisión % )</b></label><br><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"dataC2F\" chart-labels=\"labels2F\" chart-options=\"options\" chart-legend=\"dataC2F\" chart-colours=\"colours\"></canvas></div></div></div><div class=\"row\" ng-if=\"presentarPor || presentarPor2\"><div class=\"col-xs-12 col-sm-6 col-md-3 form-group\" style=\"margin-bottom: 40px;\"><button class=\"col-xs-12 btn btn-primary ladda-buttonE\" ng-click=\"getExcelData(1)\">Generar Reporte</button></div></div><script type=\"text/javascript\">  \n  $(window).load(function() { $(\"#state\").select2(); });\n</script>");}]);